
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire7add"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire7add"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("eumjn", function(module, exports) {
$parcel$export(module.exports, "Fragment", () => $a8c52ca0fff03671$export$ffb0004e005737fa, (v) => $a8c52ca0fff03671$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "jsx", () => $a8c52ca0fff03671$export$34b9dba7ce09269b, (v) => $a8c52ca0fff03671$export$34b9dba7ce09269b = v);
$parcel$export(module.exports, "jsxs", () => $a8c52ca0fff03671$export$25062201e9e25d76, (v) => $a8c52ca0fff03671$export$25062201e9e25d76 = v);
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $a8c52ca0fff03671$export$ffb0004e005737fa;
var $a8c52ca0fff03671$export$34b9dba7ce09269b;
var $a8c52ca0fff03671$export$25062201e9e25d76;
'use strict';

var $5FkrB = parcelRequire("5FkrB");
var $a8c52ca0fff03671$var$k = Symbol.for("react.element"), $a8c52ca0fff03671$var$l = Symbol.for("react.fragment"), $a8c52ca0fff03671$var$m = Object.prototype.hasOwnProperty, $a8c52ca0fff03671$var$n = $5FkrB.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $a8c52ca0fff03671$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $a8c52ca0fff03671$var$q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)$a8c52ca0fff03671$var$m.call(a, b) && !$a8c52ca0fff03671$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $a8c52ca0fff03671$var$k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: $a8c52ca0fff03671$var$n.current
    };
}
$a8c52ca0fff03671$export$ffb0004e005737fa = $a8c52ca0fff03671$var$l;
$a8c52ca0fff03671$export$34b9dba7ce09269b = $a8c52ca0fff03671$var$q;
$a8c52ca0fff03671$export$25062201e9e25d76 = $a8c52ca0fff03671$var$q;

});
parcelRegister("5FkrB", function(module, exports) {
'use strict';

module.exports = (parcelRequire("abbvA"));

});
parcelRegister("abbvA", function(module, exports) {
$parcel$export(module.exports, "Children", () => $7693dbd047ade921$export$dca3b0875bd9a954, (v) => $7693dbd047ade921$export$dca3b0875bd9a954 = v);
$parcel$export(module.exports, "Component", () => $7693dbd047ade921$export$16fa2f45be04daa8, (v) => $7693dbd047ade921$export$16fa2f45be04daa8 = v);
$parcel$export(module.exports, "Fragment", () => $7693dbd047ade921$export$ffb0004e005737fa, (v) => $7693dbd047ade921$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Profiler", () => $7693dbd047ade921$export$e2c29f18771995cb, (v) => $7693dbd047ade921$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "PureComponent", () => $7693dbd047ade921$export$221d75b3f55bb0bd, (v) => $7693dbd047ade921$export$221d75b3f55bb0bd = v);
$parcel$export(module.exports, "StrictMode", () => $7693dbd047ade921$export$5f8d39834fd61797, (v) => $7693dbd047ade921$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $7693dbd047ade921$export$74bf444e3cd11ea5, (v) => $7693dbd047ade921$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $7693dbd047ade921$export$ae55be85d98224ed, (v) => $7693dbd047ade921$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "cloneElement", () => $7693dbd047ade921$export$e530037191fcd5d7, (v) => $7693dbd047ade921$export$e530037191fcd5d7 = v);
$parcel$export(module.exports, "createContext", () => $7693dbd047ade921$export$fd42f52fd3ae1109, (v) => $7693dbd047ade921$export$fd42f52fd3ae1109 = v);
$parcel$export(module.exports, "createElement", () => $7693dbd047ade921$export$c8a8987d4410bf2d, (v) => $7693dbd047ade921$export$c8a8987d4410bf2d = v);
$parcel$export(module.exports, "createFactory", () => $7693dbd047ade921$export$d38cd72104c1f0e9, (v) => $7693dbd047ade921$export$d38cd72104c1f0e9 = v);
$parcel$export(module.exports, "createRef", () => $7693dbd047ade921$export$7d1e3a5e95ceca43, (v) => $7693dbd047ade921$export$7d1e3a5e95ceca43 = v);
$parcel$export(module.exports, "forwardRef", () => $7693dbd047ade921$export$257a8862b851cb5b, (v) => $7693dbd047ade921$export$257a8862b851cb5b = v);
$parcel$export(module.exports, "isValidElement", () => $7693dbd047ade921$export$a8257692ac88316c, (v) => $7693dbd047ade921$export$a8257692ac88316c = v);
$parcel$export(module.exports, "lazy", () => $7693dbd047ade921$export$488013bae63b21da, (v) => $7693dbd047ade921$export$488013bae63b21da = v);
$parcel$export(module.exports, "memo", () => $7693dbd047ade921$export$7c73462e0d25e514, (v) => $7693dbd047ade921$export$7c73462e0d25e514 = v);
$parcel$export(module.exports, "startTransition", () => $7693dbd047ade921$export$7568632d0d33d16d, (v) => $7693dbd047ade921$export$7568632d0d33d16d = v);
$parcel$export(module.exports, "unstable_act", () => $7693dbd047ade921$export$88948ce120ea2619, (v) => $7693dbd047ade921$export$88948ce120ea2619 = v);
$parcel$export(module.exports, "useCallback", () => $7693dbd047ade921$export$35808ee640e87ca7, (v) => $7693dbd047ade921$export$35808ee640e87ca7 = v);
$parcel$export(module.exports, "useContext", () => $7693dbd047ade921$export$fae74005e78b1a27, (v) => $7693dbd047ade921$export$fae74005e78b1a27 = v);
$parcel$export(module.exports, "useDebugValue", () => $7693dbd047ade921$export$dc8fbce3eb94dc1e, (v) => $7693dbd047ade921$export$dc8fbce3eb94dc1e = v);
$parcel$export(module.exports, "useDeferredValue", () => $7693dbd047ade921$export$6a7bc4e911dc01cf, (v) => $7693dbd047ade921$export$6a7bc4e911dc01cf = v);
$parcel$export(module.exports, "useEffect", () => $7693dbd047ade921$export$6d9c69b0de29b591, (v) => $7693dbd047ade921$export$6d9c69b0de29b591 = v);
$parcel$export(module.exports, "useId", () => $7693dbd047ade921$export$f680877a34711e37, (v) => $7693dbd047ade921$export$f680877a34711e37 = v);
$parcel$export(module.exports, "useImperativeHandle", () => $7693dbd047ade921$export$d5a552a76deda3c2, (v) => $7693dbd047ade921$export$d5a552a76deda3c2 = v);
$parcel$export(module.exports, "useInsertionEffect", () => $7693dbd047ade921$export$aaabe4eda9ed9969, (v) => $7693dbd047ade921$export$aaabe4eda9ed9969 = v);
$parcel$export(module.exports, "useLayoutEffect", () => $7693dbd047ade921$export$e5c5a5f917a5871c, (v) => $7693dbd047ade921$export$e5c5a5f917a5871c = v);
$parcel$export(module.exports, "useMemo", () => $7693dbd047ade921$export$1538c33de8887b59, (v) => $7693dbd047ade921$export$1538c33de8887b59 = v);
$parcel$export(module.exports, "useReducer", () => $7693dbd047ade921$export$13e3392192263954, (v) => $7693dbd047ade921$export$13e3392192263954 = v);
$parcel$export(module.exports, "useRef", () => $7693dbd047ade921$export$b8f5890fc79d6aca, (v) => $7693dbd047ade921$export$b8f5890fc79d6aca = v);
$parcel$export(module.exports, "useState", () => $7693dbd047ade921$export$60241385465d0a34, (v) => $7693dbd047ade921$export$60241385465d0a34 = v);
$parcel$export(module.exports, "useSyncExternalStore", () => $7693dbd047ade921$export$306c0aa65ff9ec16, (v) => $7693dbd047ade921$export$306c0aa65ff9ec16 = v);
$parcel$export(module.exports, "useTransition", () => $7693dbd047ade921$export$7b286972b8d8ccbf, (v) => $7693dbd047ade921$export$7b286972b8d8ccbf = v);
$parcel$export(module.exports, "version", () => $7693dbd047ade921$export$83d89fbfd8236492, (v) => $7693dbd047ade921$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $7693dbd047ade921$export$dca3b0875bd9a954;
var $7693dbd047ade921$export$16fa2f45be04daa8;
var $7693dbd047ade921$export$ffb0004e005737fa;
var $7693dbd047ade921$export$e2c29f18771995cb;
var $7693dbd047ade921$export$221d75b3f55bb0bd;
var $7693dbd047ade921$export$5f8d39834fd61797;
var $7693dbd047ade921$export$74bf444e3cd11ea5;
var $7693dbd047ade921$export$ae55be85d98224ed;
var $7693dbd047ade921$export$e530037191fcd5d7;
var $7693dbd047ade921$export$fd42f52fd3ae1109;
var $7693dbd047ade921$export$c8a8987d4410bf2d;
var $7693dbd047ade921$export$d38cd72104c1f0e9;
var $7693dbd047ade921$export$7d1e3a5e95ceca43;
var $7693dbd047ade921$export$257a8862b851cb5b;
var $7693dbd047ade921$export$a8257692ac88316c;
var $7693dbd047ade921$export$488013bae63b21da;
var $7693dbd047ade921$export$7c73462e0d25e514;
var $7693dbd047ade921$export$7568632d0d33d16d;
var $7693dbd047ade921$export$88948ce120ea2619;
var $7693dbd047ade921$export$35808ee640e87ca7;
var $7693dbd047ade921$export$fae74005e78b1a27;
var $7693dbd047ade921$export$dc8fbce3eb94dc1e;
var $7693dbd047ade921$export$6a7bc4e911dc01cf;
var $7693dbd047ade921$export$6d9c69b0de29b591;
var $7693dbd047ade921$export$f680877a34711e37;
var $7693dbd047ade921$export$d5a552a76deda3c2;
var $7693dbd047ade921$export$aaabe4eda9ed9969;
var $7693dbd047ade921$export$e5c5a5f917a5871c;
var $7693dbd047ade921$export$1538c33de8887b59;
var $7693dbd047ade921$export$13e3392192263954;
var $7693dbd047ade921$export$b8f5890fc79d6aca;
var $7693dbd047ade921$export$60241385465d0a34;
var $7693dbd047ade921$export$306c0aa65ff9ec16;
var $7693dbd047ade921$export$7b286972b8d8ccbf;
var $7693dbd047ade921$export$83d89fbfd8236492;
'use strict';
var $7693dbd047ade921$var$l = Symbol.for("react.element"), $7693dbd047ade921$var$n = Symbol.for("react.portal"), $7693dbd047ade921$var$p = Symbol.for("react.fragment"), $7693dbd047ade921$var$q = Symbol.for("react.strict_mode"), $7693dbd047ade921$var$r = Symbol.for("react.profiler"), $7693dbd047ade921$var$t = Symbol.for("react.provider"), $7693dbd047ade921$var$u = Symbol.for("react.context"), $7693dbd047ade921$var$v = Symbol.for("react.forward_ref"), $7693dbd047ade921$var$w = Symbol.for("react.suspense"), $7693dbd047ade921$var$x = Symbol.for("react.memo"), $7693dbd047ade921$var$y = Symbol.for("react.lazy"), $7693dbd047ade921$var$z = Symbol.iterator;
function $7693dbd047ade921$var$A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $7693dbd047ade921$var$z && a[$7693dbd047ade921$var$z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $7693dbd047ade921$var$B = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $7693dbd047ade921$var$C = Object.assign, $7693dbd047ade921$var$D = {};
function $7693dbd047ade921$var$E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $7693dbd047ade921$var$D;
    this.updater = e || $7693dbd047ade921$var$B;
}
$7693dbd047ade921$var$E.prototype.isReactComponent = {};
$7693dbd047ade921$var$E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$7693dbd047ade921$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $7693dbd047ade921$var$F() {}
$7693dbd047ade921$var$F.prototype = $7693dbd047ade921$var$E.prototype;
function $7693dbd047ade921$var$G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $7693dbd047ade921$var$D;
    this.updater = e || $7693dbd047ade921$var$B;
}
var $7693dbd047ade921$var$H = $7693dbd047ade921$var$G.prototype = new $7693dbd047ade921$var$F;
$7693dbd047ade921$var$H.constructor = $7693dbd047ade921$var$G;
$7693dbd047ade921$var$C($7693dbd047ade921$var$H, $7693dbd047ade921$var$E.prototype);
$7693dbd047ade921$var$H.isPureReactComponent = !0;
var $7693dbd047ade921$var$I = Array.isArray, $7693dbd047ade921$var$J = Object.prototype.hasOwnProperty, $7693dbd047ade921$var$K = {
    current: null
}, $7693dbd047ade921$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $7693dbd047ade921$var$M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$7693dbd047ade921$var$J.call(b, d) && !$7693dbd047ade921$var$L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: $7693dbd047ade921$var$l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: $7693dbd047ade921$var$K.current
    };
}
function $7693dbd047ade921$var$N(a, b) {
    return {
        $$typeof: $7693dbd047ade921$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $7693dbd047ade921$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $7693dbd047ade921$var$l;
}
function $7693dbd047ade921$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $7693dbd047ade921$var$P = /\/+/g;
function $7693dbd047ade921$var$Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $7693dbd047ade921$var$escape("" + a.key) : b.toString(36);
}
function $7693dbd047ade921$var$R(a, b, e, d, c) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $7693dbd047ade921$var$l:
                case $7693dbd047ade921$var$n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + $7693dbd047ade921$var$Q(h, 0) : d, $7693dbd047ade921$var$I(c) ? (e = "", null != a && (e = a.replace($7693dbd047ade921$var$P, "$&/") + "/"), $7693dbd047ade921$var$R(c, b, e, "", function(a) {
        return a;
    })) : null != c && ($7693dbd047ade921$var$O(c) && (c = $7693dbd047ade921$var$N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace($7693dbd047ade921$var$P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if ($7693dbd047ade921$var$I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + $7693dbd047ade921$var$Q(k, g);
        h += $7693dbd047ade921$var$R(k, b, e, f, c);
    }
    else if (f = $7693dbd047ade921$var$A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + $7693dbd047ade921$var$Q(k, g++), h += $7693dbd047ade921$var$R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function $7693dbd047ade921$var$S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    $7693dbd047ade921$var$R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function $7693dbd047ade921$var$T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var $7693dbd047ade921$var$U = {
    current: null
}, $7693dbd047ade921$var$V = {
    transition: null
}, $7693dbd047ade921$var$W = {
    ReactCurrentDispatcher: $7693dbd047ade921$var$U,
    ReactCurrentBatchConfig: $7693dbd047ade921$var$V,
    ReactCurrentOwner: $7693dbd047ade921$var$K
};
$7693dbd047ade921$export$dca3b0875bd9a954 = {
    map: $7693dbd047ade921$var$S,
    forEach: function(a, b, e) {
        $7693dbd047ade921$var$S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function(a) {
        var b = 0;
        $7693dbd047ade921$var$S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $7693dbd047ade921$var$S(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$7693dbd047ade921$var$O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$7693dbd047ade921$export$16fa2f45be04daa8 = $7693dbd047ade921$var$E;
$7693dbd047ade921$export$ffb0004e005737fa = $7693dbd047ade921$var$p;
$7693dbd047ade921$export$e2c29f18771995cb = $7693dbd047ade921$var$r;
$7693dbd047ade921$export$221d75b3f55bb0bd = $7693dbd047ade921$var$G;
$7693dbd047ade921$export$5f8d39834fd61797 = $7693dbd047ade921$var$q;
$7693dbd047ade921$export$74bf444e3cd11ea5 = $7693dbd047ade921$var$w;
$7693dbd047ade921$export$ae55be85d98224ed = $7693dbd047ade921$var$W;
$7693dbd047ade921$export$e530037191fcd5d7 = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $7693dbd047ade921$var$C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $7693dbd047ade921$var$K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$7693dbd047ade921$var$J.call(b, f) && !$7693dbd047ade921$var$L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: $7693dbd047ade921$var$l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
$7693dbd047ade921$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $7693dbd047ade921$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $7693dbd047ade921$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$7693dbd047ade921$export$c8a8987d4410bf2d = $7693dbd047ade921$var$M;
$7693dbd047ade921$export$d38cd72104c1f0e9 = function(a) {
    var b = $7693dbd047ade921$var$M.bind(null, a);
    b.type = a;
    return b;
};
$7693dbd047ade921$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$7693dbd047ade921$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $7693dbd047ade921$var$v,
        render: a
    };
};
$7693dbd047ade921$export$a8257692ac88316c = $7693dbd047ade921$var$O;
$7693dbd047ade921$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $7693dbd047ade921$var$y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $7693dbd047ade921$var$T
    };
};
$7693dbd047ade921$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $7693dbd047ade921$var$x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$7693dbd047ade921$export$7568632d0d33d16d = function(a) {
    var b = $7693dbd047ade921$var$V.transition;
    $7693dbd047ade921$var$V.transition = {};
    try {
        a();
    } finally{
        $7693dbd047ade921$var$V.transition = b;
    }
};
$7693dbd047ade921$export$88948ce120ea2619 = function() {
    throw Error("act(...) is not supported in production builds of React.");
};
$7693dbd047ade921$export$35808ee640e87ca7 = function(a, b) {
    return $7693dbd047ade921$var$U.current.useCallback(a, b);
};
$7693dbd047ade921$export$fae74005e78b1a27 = function(a) {
    return $7693dbd047ade921$var$U.current.useContext(a);
};
$7693dbd047ade921$export$dc8fbce3eb94dc1e = function() {};
$7693dbd047ade921$export$6a7bc4e911dc01cf = function(a) {
    return $7693dbd047ade921$var$U.current.useDeferredValue(a);
};
$7693dbd047ade921$export$6d9c69b0de29b591 = function(a, b) {
    return $7693dbd047ade921$var$U.current.useEffect(a, b);
};
$7693dbd047ade921$export$f680877a34711e37 = function() {
    return $7693dbd047ade921$var$U.current.useId();
};
$7693dbd047ade921$export$d5a552a76deda3c2 = function(a, b, e) {
    return $7693dbd047ade921$var$U.current.useImperativeHandle(a, b, e);
};
$7693dbd047ade921$export$aaabe4eda9ed9969 = function(a, b) {
    return $7693dbd047ade921$var$U.current.useInsertionEffect(a, b);
};
$7693dbd047ade921$export$e5c5a5f917a5871c = function(a, b) {
    return $7693dbd047ade921$var$U.current.useLayoutEffect(a, b);
};
$7693dbd047ade921$export$1538c33de8887b59 = function(a, b) {
    return $7693dbd047ade921$var$U.current.useMemo(a, b);
};
$7693dbd047ade921$export$13e3392192263954 = function(a, b, e) {
    return $7693dbd047ade921$var$U.current.useReducer(a, b, e);
};
$7693dbd047ade921$export$b8f5890fc79d6aca = function(a) {
    return $7693dbd047ade921$var$U.current.useRef(a);
};
$7693dbd047ade921$export$60241385465d0a34 = function(a) {
    return $7693dbd047ade921$var$U.current.useState(a);
};
$7693dbd047ade921$export$306c0aa65ff9ec16 = function(a, b, e) {
    return $7693dbd047ade921$var$U.current.useSyncExternalStore(a, b, e);
};
$7693dbd047ade921$export$7b286972b8d8ccbf = function() {
    return $7693dbd047ade921$var$U.current.useTransition();
};
$7693dbd047ade921$export$83d89fbfd8236492 = "18.2.0";

});



parcelRegister("aLeHs", function(module, exports) {
'use strict';
function $7d59b24134129acf$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($7d59b24134129acf$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$7d59b24134129acf$var$checkDCE();

module.exports = (parcelRequire("hLm8s"));

});
parcelRegister("hLm8s", function(module, exports) {
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $cee7ff159d524e18$export$ae55be85d98224ed, (v) => $cee7ff159d524e18$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "createPortal", () => $cee7ff159d524e18$export$d39a5bbd09211389, (v) => $cee7ff159d524e18$export$d39a5bbd09211389 = v);
$parcel$export(module.exports, "createRoot", () => $cee7ff159d524e18$export$882461b6382ed46c, (v) => $cee7ff159d524e18$export$882461b6382ed46c = v);
$parcel$export(module.exports, "findDOMNode", () => $cee7ff159d524e18$export$466bfc07425424d5, (v) => $cee7ff159d524e18$export$466bfc07425424d5 = v);
$parcel$export(module.exports, "flushSync", () => $cee7ff159d524e18$export$cd75ccfd720a3cd4, (v) => $cee7ff159d524e18$export$cd75ccfd720a3cd4 = v);
$parcel$export(module.exports, "hydrate", () => $cee7ff159d524e18$export$fa8d919ba61d84db, (v) => $cee7ff159d524e18$export$fa8d919ba61d84db = v);
$parcel$export(module.exports, "hydrateRoot", () => $cee7ff159d524e18$export$757ceba2d55c277e, (v) => $cee7ff159d524e18$export$757ceba2d55c277e = v);
$parcel$export(module.exports, "render", () => $cee7ff159d524e18$export$b3890eb0ae9dca99, (v) => $cee7ff159d524e18$export$b3890eb0ae9dca99 = v);
$parcel$export(module.exports, "unmountComponentAtNode", () => $cee7ff159d524e18$export$502457920280e6be, (v) => $cee7ff159d524e18$export$502457920280e6be = v);
$parcel$export(module.exports, "unstable_batchedUpdates", () => $cee7ff159d524e18$export$c78a37762a8d58e1, (v) => $cee7ff159d524e18$export$c78a37762a8d58e1 = v);
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", () => $cee7ff159d524e18$export$dc54d992c10e8a18, (v) => $cee7ff159d524e18$export$dc54d992c10e8a18 = v);
$parcel$export(module.exports, "version", () => $cee7ff159d524e18$export$83d89fbfd8236492, (v) => $cee7ff159d524e18$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $cee7ff159d524e18$export$ae55be85d98224ed;
var $cee7ff159d524e18$export$d39a5bbd09211389;
var $cee7ff159d524e18$export$882461b6382ed46c;
var $cee7ff159d524e18$export$466bfc07425424d5;
var $cee7ff159d524e18$export$cd75ccfd720a3cd4;
var $cee7ff159d524e18$export$fa8d919ba61d84db;
var $cee7ff159d524e18$export$757ceba2d55c277e;
var $cee7ff159d524e18$export$b3890eb0ae9dca99;
var $cee7ff159d524e18$export$502457920280e6be;
var $cee7ff159d524e18$export$c78a37762a8d58e1;
var $cee7ff159d524e18$export$dc54d992c10e8a18;
var $cee7ff159d524e18$export$83d89fbfd8236492;
'use strict';

var $5FkrB = parcelRequire("5FkrB");

var $3hvsM = parcelRequire("3hvsM");
function $cee7ff159d524e18$var$p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $cee7ff159d524e18$var$da = new Set, $cee7ff159d524e18$var$ea = {};
function $cee7ff159d524e18$var$fa(a, b) {
    $cee7ff159d524e18$var$ha(a, b);
    $cee7ff159d524e18$var$ha(a + "Capture", b);
}
function $cee7ff159d524e18$var$ha(a, b) {
    $cee7ff159d524e18$var$ea[a] = b;
    for(a = 0; a < b.length; a++)$cee7ff159d524e18$var$da.add(b[a]);
}
var $cee7ff159d524e18$var$ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $cee7ff159d524e18$var$ja = Object.prototype.hasOwnProperty, $cee7ff159d524e18$var$ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $cee7ff159d524e18$var$la = {}, $cee7ff159d524e18$var$ma = {};
function $cee7ff159d524e18$var$oa(a) {
    if ($cee7ff159d524e18$var$ja.call($cee7ff159d524e18$var$ma, a)) return !0;
    if ($cee7ff159d524e18$var$ja.call($cee7ff159d524e18$var$la, a)) return !1;
    if ($cee7ff159d524e18$var$ka.test(a)) return $cee7ff159d524e18$var$ma[a] = !0;
    $cee7ff159d524e18$var$la[a] = !0;
    return !1;
}
function $cee7ff159d524e18$var$pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $cee7ff159d524e18$var$qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $cee7ff159d524e18$var$pa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $cee7ff159d524e18$var$v(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $cee7ff159d524e18$var$z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $cee7ff159d524e18$var$z[a] = new $cee7ff159d524e18$var$v(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $cee7ff159d524e18$var$z[b] = new $cee7ff159d524e18$var$v(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $cee7ff159d524e18$var$z[a] = new $cee7ff159d524e18$var$v(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $cee7ff159d524e18$var$z[a] = new $cee7ff159d524e18$var$v(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $cee7ff159d524e18$var$z[a] = new $cee7ff159d524e18$var$v(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $cee7ff159d524e18$var$z[a] = new $cee7ff159d524e18$var$v(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $cee7ff159d524e18$var$z[a] = new $cee7ff159d524e18$var$v(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $cee7ff159d524e18$var$z[a] = new $cee7ff159d524e18$var$v(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $cee7ff159d524e18$var$z[a] = new $cee7ff159d524e18$var$v(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $cee7ff159d524e18$var$ra = /[\-:]([a-z])/g;
function $cee7ff159d524e18$var$sa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($cee7ff159d524e18$var$ra, $cee7ff159d524e18$var$sa);
    $cee7ff159d524e18$var$z[b] = new $cee7ff159d524e18$var$v(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($cee7ff159d524e18$var$ra, $cee7ff159d524e18$var$sa);
    $cee7ff159d524e18$var$z[b] = new $cee7ff159d524e18$var$v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($cee7ff159d524e18$var$ra, $cee7ff159d524e18$var$sa);
    $cee7ff159d524e18$var$z[b] = new $cee7ff159d524e18$var$v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $cee7ff159d524e18$var$z[a] = new $cee7ff159d524e18$var$v(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$cee7ff159d524e18$var$z.xlinkHref = new $cee7ff159d524e18$var$v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $cee7ff159d524e18$var$z[a] = new $cee7ff159d524e18$var$v(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $cee7ff159d524e18$var$ta(a, b, c, d) {
    var e = $cee7ff159d524e18$var$z.hasOwnProperty(b) ? $cee7ff159d524e18$var$z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) $cee7ff159d524e18$var$qa(b, c, e, d) && (c = null), d || null === e ? $cee7ff159d524e18$var$oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var $cee7ff159d524e18$var$ua = $5FkrB.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $cee7ff159d524e18$var$va = Symbol.for("react.element"), $cee7ff159d524e18$var$wa = Symbol.for("react.portal"), $cee7ff159d524e18$var$ya = Symbol.for("react.fragment"), $cee7ff159d524e18$var$za = Symbol.for("react.strict_mode"), $cee7ff159d524e18$var$Aa = Symbol.for("react.profiler"), $cee7ff159d524e18$var$Ba = Symbol.for("react.provider"), $cee7ff159d524e18$var$Ca = Symbol.for("react.context"), $cee7ff159d524e18$var$Da = Symbol.for("react.forward_ref"), $cee7ff159d524e18$var$Ea = Symbol.for("react.suspense"), $cee7ff159d524e18$var$Fa = Symbol.for("react.suspense_list"), $cee7ff159d524e18$var$Ga = Symbol.for("react.memo"), $cee7ff159d524e18$var$Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $cee7ff159d524e18$var$Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var $cee7ff159d524e18$var$Ja = Symbol.iterator;
function $cee7ff159d524e18$var$Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $cee7ff159d524e18$var$Ja && a[$cee7ff159d524e18$var$Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $cee7ff159d524e18$var$A = Object.assign, $cee7ff159d524e18$var$La;
function $cee7ff159d524e18$var$Ma(a) {
    if (void 0 === $cee7ff159d524e18$var$La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $cee7ff159d524e18$var$La = b && b[1] || "";
    }
    return "\n" + $cee7ff159d524e18$var$La + a;
}
var $cee7ff159d524e18$var$Na = !1;
function $cee7ff159d524e18$var$Oa(a, b) {
    if (!a || $cee7ff159d524e18$var$Na) return "";
    $cee7ff159d524e18$var$Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $cee7ff159d524e18$var$Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $cee7ff159d524e18$var$Ma(a) : "";
}
function $cee7ff159d524e18$var$Pa(a) {
    switch(a.tag){
        case 5:
            return $cee7ff159d524e18$var$Ma(a.type);
        case 16:
            return $cee7ff159d524e18$var$Ma("Lazy");
        case 13:
            return $cee7ff159d524e18$var$Ma("Suspense");
        case 19:
            return $cee7ff159d524e18$var$Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $cee7ff159d524e18$var$Oa(a.type, !1), a;
        case 11:
            return a = $cee7ff159d524e18$var$Oa(a.type.render, !1), a;
        case 1:
            return a = $cee7ff159d524e18$var$Oa(a.type, !0), a;
        default:
            return "";
    }
}
function $cee7ff159d524e18$var$Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $cee7ff159d524e18$var$ya:
            return "Fragment";
        case $cee7ff159d524e18$var$wa:
            return "Portal";
        case $cee7ff159d524e18$var$Aa:
            return "Profiler";
        case $cee7ff159d524e18$var$za:
            return "StrictMode";
        case $cee7ff159d524e18$var$Ea:
            return "Suspense";
        case $cee7ff159d524e18$var$Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $cee7ff159d524e18$var$Ca:
            return (a.displayName || "Context") + ".Consumer";
        case $cee7ff159d524e18$var$Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case $cee7ff159d524e18$var$Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $cee7ff159d524e18$var$Ga:
            return b = a.displayName || null, null !== b ? b : $cee7ff159d524e18$var$Qa(a.type) || "Memo";
        case $cee7ff159d524e18$var$Ha:
            b = a._payload;
            a = a._init;
            try {
                return $cee7ff159d524e18$var$Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function $cee7ff159d524e18$var$Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return $cee7ff159d524e18$var$Qa(b);
        case 8:
            return b === $cee7ff159d524e18$var$za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function $cee7ff159d524e18$var$Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function $cee7ff159d524e18$var$Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $cee7ff159d524e18$var$Ua(a) {
    var b = $cee7ff159d524e18$var$Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $cee7ff159d524e18$var$Va(a) {
    a._valueTracker || (a._valueTracker = $cee7ff159d524e18$var$Ua(a));
}
function $cee7ff159d524e18$var$Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $cee7ff159d524e18$var$Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $cee7ff159d524e18$var$Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $cee7ff159d524e18$var$Ya(a, b) {
    var c = b.checked;
    return $cee7ff159d524e18$var$A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $cee7ff159d524e18$var$Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $cee7ff159d524e18$var$Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $cee7ff159d524e18$var$ab(a, b) {
    b = b.checked;
    null != b && $cee7ff159d524e18$var$ta(a, "checked", b, !1);
}
function $cee7ff159d524e18$var$bb(a, b) {
    $cee7ff159d524e18$var$ab(a, b);
    var c = $cee7ff159d524e18$var$Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $cee7ff159d524e18$var$cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $cee7ff159d524e18$var$cb(a, b.type, $cee7ff159d524e18$var$Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $cee7ff159d524e18$var$db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $cee7ff159d524e18$var$cb(a, b, c) {
    if ("number" !== b || $cee7ff159d524e18$var$Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var $cee7ff159d524e18$var$eb = Array.isArray;
function $cee7ff159d524e18$var$fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $cee7ff159d524e18$var$Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $cee7ff159d524e18$var$gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($cee7ff159d524e18$var$p(91));
    return $cee7ff159d524e18$var$A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $cee7ff159d524e18$var$hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($cee7ff159d524e18$var$p(92));
            if ($cee7ff159d524e18$var$eb(c)) {
                if (1 < c.length) throw Error($cee7ff159d524e18$var$p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $cee7ff159d524e18$var$Sa(c)
    };
}
function $cee7ff159d524e18$var$ib(a, b) {
    var c = $cee7ff159d524e18$var$Sa(b.value), d = $cee7ff159d524e18$var$Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $cee7ff159d524e18$var$jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function $cee7ff159d524e18$var$kb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $cee7ff159d524e18$var$lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $cee7ff159d524e18$var$kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $cee7ff159d524e18$var$mb, $cee7ff159d524e18$var$nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        $cee7ff159d524e18$var$mb = $cee7ff159d524e18$var$mb || document.createElement("div");
        $cee7ff159d524e18$var$mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $cee7ff159d524e18$var$mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $cee7ff159d524e18$var$ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $cee7ff159d524e18$var$pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $cee7ff159d524e18$var$qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($cee7ff159d524e18$var$pb).forEach(function(a) {
    $cee7ff159d524e18$var$qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $cee7ff159d524e18$var$pb[b] = $cee7ff159d524e18$var$pb[a];
    });
});
function $cee7ff159d524e18$var$rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $cee7ff159d524e18$var$pb.hasOwnProperty(a) && $cee7ff159d524e18$var$pb[a] ? ("" + b).trim() : b + "px";
}
function $cee7ff159d524e18$var$sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $cee7ff159d524e18$var$rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $cee7ff159d524e18$var$tb = $cee7ff159d524e18$var$A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $cee7ff159d524e18$var$ub(a, b) {
    if (b) {
        if ($cee7ff159d524e18$var$tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($cee7ff159d524e18$var$p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($cee7ff159d524e18$var$p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error($cee7ff159d524e18$var$p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error($cee7ff159d524e18$var$p(62));
    }
}
function $cee7ff159d524e18$var$vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $cee7ff159d524e18$var$wb = null;
function $cee7ff159d524e18$var$xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $cee7ff159d524e18$var$yb = null, $cee7ff159d524e18$var$zb = null, $cee7ff159d524e18$var$Ab = null;
function $cee7ff159d524e18$var$Bb(a) {
    if (a = $cee7ff159d524e18$var$Cb(a)) {
        if ("function" !== typeof $cee7ff159d524e18$var$yb) throw Error($cee7ff159d524e18$var$p(280));
        var b = a.stateNode;
        b && (b = $cee7ff159d524e18$var$Db(b), $cee7ff159d524e18$var$yb(a.stateNode, a.type, b));
    }
}
function $cee7ff159d524e18$var$Eb(a) {
    $cee7ff159d524e18$var$zb ? $cee7ff159d524e18$var$Ab ? $cee7ff159d524e18$var$Ab.push(a) : $cee7ff159d524e18$var$Ab = [
        a
    ] : $cee7ff159d524e18$var$zb = a;
}
function $cee7ff159d524e18$var$Fb() {
    if ($cee7ff159d524e18$var$zb) {
        var a = $cee7ff159d524e18$var$zb, b = $cee7ff159d524e18$var$Ab;
        $cee7ff159d524e18$var$Ab = $cee7ff159d524e18$var$zb = null;
        $cee7ff159d524e18$var$Bb(a);
        if (b) for(a = 0; a < b.length; a++)$cee7ff159d524e18$var$Bb(b[a]);
    }
}
function $cee7ff159d524e18$var$Gb(a, b) {
    return a(b);
}
function $cee7ff159d524e18$var$Hb() {}
var $cee7ff159d524e18$var$Ib = !1;
function $cee7ff159d524e18$var$Jb(a, b, c) {
    if ($cee7ff159d524e18$var$Ib) return a(b, c);
    $cee7ff159d524e18$var$Ib = !0;
    try {
        return $cee7ff159d524e18$var$Gb(a, b, c);
    } finally{
        if ($cee7ff159d524e18$var$Ib = !1, null !== $cee7ff159d524e18$var$zb || null !== $cee7ff159d524e18$var$Ab) $cee7ff159d524e18$var$Hb(), $cee7ff159d524e18$var$Fb();
    }
}
function $cee7ff159d524e18$var$Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $cee7ff159d524e18$var$Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($cee7ff159d524e18$var$p(231, b, typeof c));
    return c;
}
var $cee7ff159d524e18$var$Lb = !1;
if ($cee7ff159d524e18$var$ia) try {
    var $cee7ff159d524e18$var$Mb = {};
    Object.defineProperty($cee7ff159d524e18$var$Mb, "passive", {
        get: function() {
            $cee7ff159d524e18$var$Lb = !0;
        }
    });
    window.addEventListener("test", $cee7ff159d524e18$var$Mb, $cee7ff159d524e18$var$Mb);
    window.removeEventListener("test", $cee7ff159d524e18$var$Mb, $cee7ff159d524e18$var$Mb);
} catch (a) {
    $cee7ff159d524e18$var$Lb = !1;
}
function $cee7ff159d524e18$var$Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var $cee7ff159d524e18$var$Ob = !1, $cee7ff159d524e18$var$Pb = null, $cee7ff159d524e18$var$Qb = !1, $cee7ff159d524e18$var$Rb = null, $cee7ff159d524e18$var$Sb = {
    onError: function(a) {
        $cee7ff159d524e18$var$Ob = !0;
        $cee7ff159d524e18$var$Pb = a;
    }
};
function $cee7ff159d524e18$var$Tb(a, b, c, d, e, f, g, h, k) {
    $cee7ff159d524e18$var$Ob = !1;
    $cee7ff159d524e18$var$Pb = null;
    $cee7ff159d524e18$var$Nb.apply($cee7ff159d524e18$var$Sb, arguments);
}
function $cee7ff159d524e18$var$Ub(a, b, c, d, e, f, g, h, k) {
    $cee7ff159d524e18$var$Tb.apply(this, arguments);
    if ($cee7ff159d524e18$var$Ob) {
        if ($cee7ff159d524e18$var$Ob) {
            var l = $cee7ff159d524e18$var$Pb;
            $cee7ff159d524e18$var$Ob = !1;
            $cee7ff159d524e18$var$Pb = null;
        } else throw Error($cee7ff159d524e18$var$p(198));
        $cee7ff159d524e18$var$Qb || ($cee7ff159d524e18$var$Qb = !0, $cee7ff159d524e18$var$Rb = l);
    }
}
function $cee7ff159d524e18$var$Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $cee7ff159d524e18$var$Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $cee7ff159d524e18$var$Xb(a) {
    if ($cee7ff159d524e18$var$Vb(a) !== a) throw Error($cee7ff159d524e18$var$p(188));
}
function $cee7ff159d524e18$var$Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = $cee7ff159d524e18$var$Vb(a);
        if (null === b) throw Error($cee7ff159d524e18$var$p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $cee7ff159d524e18$var$Xb(e), a;
                if (f === d) return $cee7ff159d524e18$var$Xb(e), b;
                f = f.sibling;
            }
            throw Error($cee7ff159d524e18$var$p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($cee7ff159d524e18$var$p(189));
            }
        }
        if (c.alternate !== d) throw Error($cee7ff159d524e18$var$p(190));
    }
    if (3 !== c.tag) throw Error($cee7ff159d524e18$var$p(188));
    return c.stateNode.current === c ? a : b;
}
function $cee7ff159d524e18$var$Zb(a) {
    a = $cee7ff159d524e18$var$Yb(a);
    return null !== a ? $cee7ff159d524e18$var$$b(a) : null;
}
function $cee7ff159d524e18$var$$b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $cee7ff159d524e18$var$$b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var $cee7ff159d524e18$var$ac = $3hvsM.unstable_scheduleCallback, $cee7ff159d524e18$var$bc = $3hvsM.unstable_cancelCallback, $cee7ff159d524e18$var$cc = $3hvsM.unstable_shouldYield, $cee7ff159d524e18$var$dc = $3hvsM.unstable_requestPaint, $cee7ff159d524e18$var$B = $3hvsM.unstable_now, $cee7ff159d524e18$var$ec = $3hvsM.unstable_getCurrentPriorityLevel, $cee7ff159d524e18$var$fc = $3hvsM.unstable_ImmediatePriority, $cee7ff159d524e18$var$gc = $3hvsM.unstable_UserBlockingPriority, $cee7ff159d524e18$var$hc = $3hvsM.unstable_NormalPriority, $cee7ff159d524e18$var$ic = $3hvsM.unstable_LowPriority, $cee7ff159d524e18$var$jc = $3hvsM.unstable_IdlePriority, $cee7ff159d524e18$var$kc = null, $cee7ff159d524e18$var$lc = null;
function $cee7ff159d524e18$var$mc(a) {
    if ($cee7ff159d524e18$var$lc && "function" === typeof $cee7ff159d524e18$var$lc.onCommitFiberRoot) try {
        $cee7ff159d524e18$var$lc.onCommitFiberRoot($cee7ff159d524e18$var$kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var $cee7ff159d524e18$var$oc = Math.clz32 ? Math.clz32 : $cee7ff159d524e18$var$nc, $cee7ff159d524e18$var$pc = Math.log, $cee7ff159d524e18$var$qc = Math.LN2;
function $cee7ff159d524e18$var$nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($cee7ff159d524e18$var$pc(a) / $cee7ff159d524e18$var$qc | 0) | 0;
}
var $cee7ff159d524e18$var$rc = 64, $cee7ff159d524e18$var$sc = 4194304;
function $cee7ff159d524e18$var$tc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function $cee7ff159d524e18$var$uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = $cee7ff159d524e18$var$tc(h) : (f &= g, 0 !== f && (d = $cee7ff159d524e18$var$tc(f)));
    } else g = c & ~e, 0 !== g ? d = $cee7ff159d524e18$var$tc(g) : 0 !== f && (d = $cee7ff159d524e18$var$tc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $cee7ff159d524e18$var$oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $cee7ff159d524e18$var$vc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $cee7ff159d524e18$var$wc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - $cee7ff159d524e18$var$oc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = $cee7ff159d524e18$var$vc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function $cee7ff159d524e18$var$xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $cee7ff159d524e18$var$yc() {
    var a = $cee7ff159d524e18$var$rc;
    $cee7ff159d524e18$var$rc <<= 1;
    0 === ($cee7ff159d524e18$var$rc & 4194240) && ($cee7ff159d524e18$var$rc = 64);
    return a;
}
function $cee7ff159d524e18$var$zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $cee7ff159d524e18$var$Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - $cee7ff159d524e18$var$oc(b);
    a[b] = c;
}
function $cee7ff159d524e18$var$Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - $cee7ff159d524e18$var$oc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function $cee7ff159d524e18$var$Cc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - $cee7ff159d524e18$var$oc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var $cee7ff159d524e18$var$C = 0;
function $cee7ff159d524e18$var$Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var $cee7ff159d524e18$var$Ec, $cee7ff159d524e18$var$Fc, $cee7ff159d524e18$var$Gc, $cee7ff159d524e18$var$Hc, $cee7ff159d524e18$var$Ic, $cee7ff159d524e18$var$Jc = !1, $cee7ff159d524e18$var$Kc = [], $cee7ff159d524e18$var$Lc = null, $cee7ff159d524e18$var$Mc = null, $cee7ff159d524e18$var$Nc = null, $cee7ff159d524e18$var$Oc = new Map, $cee7ff159d524e18$var$Pc = new Map, $cee7ff159d524e18$var$Qc = [], $cee7ff159d524e18$var$Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $cee7ff159d524e18$var$Sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $cee7ff159d524e18$var$Lc = null;
            break;
        case "dragenter":
        case "dragleave":
            $cee7ff159d524e18$var$Mc = null;
            break;
        case "mouseover":
        case "mouseout":
            $cee7ff159d524e18$var$Nc = null;
            break;
        case "pointerover":
        case "pointerout":
            $cee7ff159d524e18$var$Oc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $cee7ff159d524e18$var$Pc.delete(b.pointerId);
    }
}
function $cee7ff159d524e18$var$Tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = $cee7ff159d524e18$var$Cb(b), null !== b && $cee7ff159d524e18$var$Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $cee7ff159d524e18$var$Uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $cee7ff159d524e18$var$Lc = $cee7ff159d524e18$var$Tc($cee7ff159d524e18$var$Lc, a, b, c, d, e), !0;
        case "dragenter":
            return $cee7ff159d524e18$var$Mc = $cee7ff159d524e18$var$Tc($cee7ff159d524e18$var$Mc, a, b, c, d, e), !0;
        case "mouseover":
            return $cee7ff159d524e18$var$Nc = $cee7ff159d524e18$var$Tc($cee7ff159d524e18$var$Nc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $cee7ff159d524e18$var$Oc.set(f, $cee7ff159d524e18$var$Tc($cee7ff159d524e18$var$Oc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $cee7ff159d524e18$var$Pc.set(f, $cee7ff159d524e18$var$Tc($cee7ff159d524e18$var$Pc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $cee7ff159d524e18$var$Vc(a) {
    var b = $cee7ff159d524e18$var$Wc(a.target);
    if (null !== b) {
        var c = $cee7ff159d524e18$var$Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $cee7ff159d524e18$var$Wb(c), null !== b) {
                    a.blockedOn = b;
                    $cee7ff159d524e18$var$Ic(a.priority, function() {
                        $cee7ff159d524e18$var$Gc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $cee7ff159d524e18$var$Xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $cee7ff159d524e18$var$Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            $cee7ff159d524e18$var$wb = d;
            c.target.dispatchEvent(d);
            $cee7ff159d524e18$var$wb = null;
        } else return b = $cee7ff159d524e18$var$Cb(c), null !== b && $cee7ff159d524e18$var$Fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $cee7ff159d524e18$var$Zc(a, b, c) {
    $cee7ff159d524e18$var$Xc(a) && c.delete(b);
}
function $cee7ff159d524e18$var$$c() {
    $cee7ff159d524e18$var$Jc = !1;
    null !== $cee7ff159d524e18$var$Lc && $cee7ff159d524e18$var$Xc($cee7ff159d524e18$var$Lc) && ($cee7ff159d524e18$var$Lc = null);
    null !== $cee7ff159d524e18$var$Mc && $cee7ff159d524e18$var$Xc($cee7ff159d524e18$var$Mc) && ($cee7ff159d524e18$var$Mc = null);
    null !== $cee7ff159d524e18$var$Nc && $cee7ff159d524e18$var$Xc($cee7ff159d524e18$var$Nc) && ($cee7ff159d524e18$var$Nc = null);
    $cee7ff159d524e18$var$Oc.forEach($cee7ff159d524e18$var$Zc);
    $cee7ff159d524e18$var$Pc.forEach($cee7ff159d524e18$var$Zc);
}
function $cee7ff159d524e18$var$ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $cee7ff159d524e18$var$Jc || ($cee7ff159d524e18$var$Jc = !0, $3hvsM.unstable_scheduleCallback($3hvsM.unstable_NormalPriority, $cee7ff159d524e18$var$$c)));
}
function $cee7ff159d524e18$var$bd(a) {
    function b(b) {
        return $cee7ff159d524e18$var$ad(b, a);
    }
    if (0 < $cee7ff159d524e18$var$Kc.length) {
        $cee7ff159d524e18$var$ad($cee7ff159d524e18$var$Kc[0], a);
        for(var c = 1; c < $cee7ff159d524e18$var$Kc.length; c++){
            var d = $cee7ff159d524e18$var$Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $cee7ff159d524e18$var$Lc && $cee7ff159d524e18$var$ad($cee7ff159d524e18$var$Lc, a);
    null !== $cee7ff159d524e18$var$Mc && $cee7ff159d524e18$var$ad($cee7ff159d524e18$var$Mc, a);
    null !== $cee7ff159d524e18$var$Nc && $cee7ff159d524e18$var$ad($cee7ff159d524e18$var$Nc, a);
    $cee7ff159d524e18$var$Oc.forEach(b);
    $cee7ff159d524e18$var$Pc.forEach(b);
    for(c = 0; c < $cee7ff159d524e18$var$Qc.length; c++)d = $cee7ff159d524e18$var$Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $cee7ff159d524e18$var$Qc.length && (c = $cee7ff159d524e18$var$Qc[0], null === c.blockedOn);)$cee7ff159d524e18$var$Vc(c), null === c.blockedOn && $cee7ff159d524e18$var$Qc.shift();
}
var $cee7ff159d524e18$var$cd = $cee7ff159d524e18$var$ua.ReactCurrentBatchConfig, $cee7ff159d524e18$var$dd = !0;
function $cee7ff159d524e18$var$ed(a, b, c, d) {
    var e = $cee7ff159d524e18$var$C, f = $cee7ff159d524e18$var$cd.transition;
    $cee7ff159d524e18$var$cd.transition = null;
    try {
        $cee7ff159d524e18$var$C = 1, $cee7ff159d524e18$var$fd(a, b, c, d);
    } finally{
        $cee7ff159d524e18$var$C = e, $cee7ff159d524e18$var$cd.transition = f;
    }
}
function $cee7ff159d524e18$var$gd(a, b, c, d) {
    var e = $cee7ff159d524e18$var$C, f = $cee7ff159d524e18$var$cd.transition;
    $cee7ff159d524e18$var$cd.transition = null;
    try {
        $cee7ff159d524e18$var$C = 4, $cee7ff159d524e18$var$fd(a, b, c, d);
    } finally{
        $cee7ff159d524e18$var$C = e, $cee7ff159d524e18$var$cd.transition = f;
    }
}
function $cee7ff159d524e18$var$fd(a, b, c, d) {
    if ($cee7ff159d524e18$var$dd) {
        var e = $cee7ff159d524e18$var$Yc(a, b, c, d);
        if (null === e) $cee7ff159d524e18$var$hd(a, b, d, $cee7ff159d524e18$var$id, c), $cee7ff159d524e18$var$Sc(a, d);
        else if ($cee7ff159d524e18$var$Uc(e, a, b, c, d)) d.stopPropagation();
        else if ($cee7ff159d524e18$var$Sc(a, d), b & 4 && -1 < $cee7ff159d524e18$var$Rc.indexOf(a)) {
            for(; null !== e;){
                var f = $cee7ff159d524e18$var$Cb(e);
                null !== f && $cee7ff159d524e18$var$Ec(f);
                f = $cee7ff159d524e18$var$Yc(a, b, c, d);
                null === f && $cee7ff159d524e18$var$hd(a, b, d, $cee7ff159d524e18$var$id, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else $cee7ff159d524e18$var$hd(a, b, d, null, c);
    }
}
var $cee7ff159d524e18$var$id = null;
function $cee7ff159d524e18$var$Yc(a, b, c, d) {
    $cee7ff159d524e18$var$id = null;
    a = $cee7ff159d524e18$var$xb(d);
    a = $cee7ff159d524e18$var$Wc(a);
    if (null !== a) {
        if (b = $cee7ff159d524e18$var$Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = $cee7ff159d524e18$var$Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    $cee7ff159d524e18$var$id = a;
    return null;
}
function $cee7ff159d524e18$var$jd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch($cee7ff159d524e18$var$ec()){
                case $cee7ff159d524e18$var$fc:
                    return 1;
                case $cee7ff159d524e18$var$gc:
                    return 4;
                case $cee7ff159d524e18$var$hc:
                case $cee7ff159d524e18$var$ic:
                    return 16;
                case $cee7ff159d524e18$var$jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var $cee7ff159d524e18$var$kd = null, $cee7ff159d524e18$var$ld = null, $cee7ff159d524e18$var$md = null;
function $cee7ff159d524e18$var$nd() {
    if ($cee7ff159d524e18$var$md) return $cee7ff159d524e18$var$md;
    var a, b = $cee7ff159d524e18$var$ld, c = b.length, d, e = "value" in $cee7ff159d524e18$var$kd ? $cee7ff159d524e18$var$kd.value : $cee7ff159d524e18$var$kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $cee7ff159d524e18$var$md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $cee7ff159d524e18$var$od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $cee7ff159d524e18$var$pd() {
    return !0;
}
function $cee7ff159d524e18$var$qd() {
    return !1;
}
function $cee7ff159d524e18$var$rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $cee7ff159d524e18$var$pd : $cee7ff159d524e18$var$qd;
        this.isPropagationStopped = $cee7ff159d524e18$var$qd;
        return this;
    }
    $cee7ff159d524e18$var$A(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = $cee7ff159d524e18$var$pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = $cee7ff159d524e18$var$pd);
        },
        persist: function() {},
        isPersistent: $cee7ff159d524e18$var$pd
    });
    return b;
}
var $cee7ff159d524e18$var$sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $cee7ff159d524e18$var$td = $cee7ff159d524e18$var$rd($cee7ff159d524e18$var$sd), $cee7ff159d524e18$var$ud = $cee7ff159d524e18$var$A({}, $cee7ff159d524e18$var$sd, {
    view: 0,
    detail: 0
}), $cee7ff159d524e18$var$vd = $cee7ff159d524e18$var$rd($cee7ff159d524e18$var$ud), $cee7ff159d524e18$var$wd, $cee7ff159d524e18$var$xd, $cee7ff159d524e18$var$yd, $cee7ff159d524e18$var$Ad = $cee7ff159d524e18$var$A({}, $cee7ff159d524e18$var$ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $cee7ff159d524e18$var$zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== $cee7ff159d524e18$var$yd && ($cee7ff159d524e18$var$yd && "mousemove" === a.type ? ($cee7ff159d524e18$var$wd = a.screenX - $cee7ff159d524e18$var$yd.screenX, $cee7ff159d524e18$var$xd = a.screenY - $cee7ff159d524e18$var$yd.screenY) : $cee7ff159d524e18$var$xd = $cee7ff159d524e18$var$wd = 0, $cee7ff159d524e18$var$yd = a);
        return $cee7ff159d524e18$var$wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : $cee7ff159d524e18$var$xd;
    }
}), $cee7ff159d524e18$var$Bd = $cee7ff159d524e18$var$rd($cee7ff159d524e18$var$Ad), $cee7ff159d524e18$var$Cd = $cee7ff159d524e18$var$A({}, $cee7ff159d524e18$var$Ad, {
    dataTransfer: 0
}), $cee7ff159d524e18$var$Dd = $cee7ff159d524e18$var$rd($cee7ff159d524e18$var$Cd), $cee7ff159d524e18$var$Ed = $cee7ff159d524e18$var$A({}, $cee7ff159d524e18$var$ud, {
    relatedTarget: 0
}), $cee7ff159d524e18$var$Fd = $cee7ff159d524e18$var$rd($cee7ff159d524e18$var$Ed), $cee7ff159d524e18$var$Gd = $cee7ff159d524e18$var$A({}, $cee7ff159d524e18$var$sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $cee7ff159d524e18$var$Hd = $cee7ff159d524e18$var$rd($cee7ff159d524e18$var$Gd), $cee7ff159d524e18$var$Id = $cee7ff159d524e18$var$A({}, $cee7ff159d524e18$var$sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $cee7ff159d524e18$var$Jd = $cee7ff159d524e18$var$rd($cee7ff159d524e18$var$Id), $cee7ff159d524e18$var$Kd = $cee7ff159d524e18$var$A({}, $cee7ff159d524e18$var$sd, {
    data: 0
}), $cee7ff159d524e18$var$Ld = $cee7ff159d524e18$var$rd($cee7ff159d524e18$var$Kd), $cee7ff159d524e18$var$Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $cee7ff159d524e18$var$Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $cee7ff159d524e18$var$Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $cee7ff159d524e18$var$Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $cee7ff159d524e18$var$Od[a]) ? !!b[a] : !1;
}
function $cee7ff159d524e18$var$zd() {
    return $cee7ff159d524e18$var$Pd;
}
var $cee7ff159d524e18$var$Qd = $cee7ff159d524e18$var$A({}, $cee7ff159d524e18$var$ud, {
    key: function(a) {
        if (a.key) {
            var b = $cee7ff159d524e18$var$Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $cee7ff159d524e18$var$od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $cee7ff159d524e18$var$Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $cee7ff159d524e18$var$zd,
    charCode: function(a) {
        return "keypress" === a.type ? $cee7ff159d524e18$var$od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? $cee7ff159d524e18$var$od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $cee7ff159d524e18$var$Rd = $cee7ff159d524e18$var$rd($cee7ff159d524e18$var$Qd), $cee7ff159d524e18$var$Sd = $cee7ff159d524e18$var$A({}, $cee7ff159d524e18$var$Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $cee7ff159d524e18$var$Td = $cee7ff159d524e18$var$rd($cee7ff159d524e18$var$Sd), $cee7ff159d524e18$var$Ud = $cee7ff159d524e18$var$A({}, $cee7ff159d524e18$var$ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $cee7ff159d524e18$var$zd
}), $cee7ff159d524e18$var$Vd = $cee7ff159d524e18$var$rd($cee7ff159d524e18$var$Ud), $cee7ff159d524e18$var$Wd = $cee7ff159d524e18$var$A({}, $cee7ff159d524e18$var$sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $cee7ff159d524e18$var$Xd = $cee7ff159d524e18$var$rd($cee7ff159d524e18$var$Wd), $cee7ff159d524e18$var$Yd = $cee7ff159d524e18$var$A({}, $cee7ff159d524e18$var$Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $cee7ff159d524e18$var$Zd = $cee7ff159d524e18$var$rd($cee7ff159d524e18$var$Yd), $cee7ff159d524e18$var$$d = [
    9,
    13,
    27,
    32
], $cee7ff159d524e18$var$ae = $cee7ff159d524e18$var$ia && "CompositionEvent" in window, $cee7ff159d524e18$var$be = null;
$cee7ff159d524e18$var$ia && "documentMode" in document && ($cee7ff159d524e18$var$be = document.documentMode);
var $cee7ff159d524e18$var$ce = $cee7ff159d524e18$var$ia && "TextEvent" in window && !$cee7ff159d524e18$var$be, $cee7ff159d524e18$var$de = $cee7ff159d524e18$var$ia && (!$cee7ff159d524e18$var$ae || $cee7ff159d524e18$var$be && 8 < $cee7ff159d524e18$var$be && 11 >= $cee7ff159d524e18$var$be), $cee7ff159d524e18$var$ee = String.fromCharCode(32), $cee7ff159d524e18$var$fe = !1;
function $cee7ff159d524e18$var$ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $cee7ff159d524e18$var$$d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $cee7ff159d524e18$var$he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var $cee7ff159d524e18$var$ie = !1;
function $cee7ff159d524e18$var$je(a, b) {
    switch(a){
        case "compositionend":
            return $cee7ff159d524e18$var$he(b);
        case "keypress":
            if (32 !== b.which) return null;
            $cee7ff159d524e18$var$fe = !0;
            return $cee7ff159d524e18$var$ee;
        case "textInput":
            return a = b.data, a === $cee7ff159d524e18$var$ee && $cee7ff159d524e18$var$fe ? null : a;
        default:
            return null;
    }
}
function $cee7ff159d524e18$var$ke(a, b) {
    if ($cee7ff159d524e18$var$ie) return "compositionend" === a || !$cee7ff159d524e18$var$ae && $cee7ff159d524e18$var$ge(a, b) ? (a = $cee7ff159d524e18$var$nd(), $cee7ff159d524e18$var$md = $cee7ff159d524e18$var$ld = $cee7ff159d524e18$var$kd = null, $cee7ff159d524e18$var$ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $cee7ff159d524e18$var$de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $cee7ff159d524e18$var$le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $cee7ff159d524e18$var$me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$cee7ff159d524e18$var$le[a.type] : "textarea" === b ? !0 : !1;
}
function $cee7ff159d524e18$var$ne(a, b, c, d) {
    $cee7ff159d524e18$var$Eb(d);
    b = $cee7ff159d524e18$var$oe(b, "onChange");
    0 < b.length && (c = new $cee7ff159d524e18$var$td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $cee7ff159d524e18$var$pe = null, $cee7ff159d524e18$var$qe = null;
function $cee7ff159d524e18$var$re(a) {
    $cee7ff159d524e18$var$se(a, 0);
}
function $cee7ff159d524e18$var$te(a) {
    var b = $cee7ff159d524e18$var$ue(a);
    if ($cee7ff159d524e18$var$Wa(b)) return a;
}
function $cee7ff159d524e18$var$ve(a, b) {
    if ("change" === a) return b;
}
var $cee7ff159d524e18$var$we = !1;
if ($cee7ff159d524e18$var$ia) {
    var $cee7ff159d524e18$var$xe;
    if ($cee7ff159d524e18$var$ia) {
        var $cee7ff159d524e18$var$ye = "oninput" in document;
        if (!$cee7ff159d524e18$var$ye) {
            var $cee7ff159d524e18$var$ze = document.createElement("div");
            $cee7ff159d524e18$var$ze.setAttribute("oninput", "return;");
            $cee7ff159d524e18$var$ye = "function" === typeof $cee7ff159d524e18$var$ze.oninput;
        }
        $cee7ff159d524e18$var$xe = $cee7ff159d524e18$var$ye;
    } else $cee7ff159d524e18$var$xe = !1;
    $cee7ff159d524e18$var$we = $cee7ff159d524e18$var$xe && (!document.documentMode || 9 < document.documentMode);
}
function $cee7ff159d524e18$var$Ae() {
    $cee7ff159d524e18$var$pe && ($cee7ff159d524e18$var$pe.detachEvent("onpropertychange", $cee7ff159d524e18$var$Be), $cee7ff159d524e18$var$qe = $cee7ff159d524e18$var$pe = null);
}
function $cee7ff159d524e18$var$Be(a) {
    if ("value" === a.propertyName && $cee7ff159d524e18$var$te($cee7ff159d524e18$var$qe)) {
        var b = [];
        $cee7ff159d524e18$var$ne(b, $cee7ff159d524e18$var$qe, a, $cee7ff159d524e18$var$xb(a));
        $cee7ff159d524e18$var$Jb($cee7ff159d524e18$var$re, b);
    }
}
function $cee7ff159d524e18$var$Ce(a, b, c) {
    "focusin" === a ? ($cee7ff159d524e18$var$Ae(), $cee7ff159d524e18$var$pe = b, $cee7ff159d524e18$var$qe = c, $cee7ff159d524e18$var$pe.attachEvent("onpropertychange", $cee7ff159d524e18$var$Be)) : "focusout" === a && $cee7ff159d524e18$var$Ae();
}
function $cee7ff159d524e18$var$De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $cee7ff159d524e18$var$te($cee7ff159d524e18$var$qe);
}
function $cee7ff159d524e18$var$Ee(a, b) {
    if ("click" === a) return $cee7ff159d524e18$var$te(b);
}
function $cee7ff159d524e18$var$Fe(a, b) {
    if ("input" === a || "change" === a) return $cee7ff159d524e18$var$te(b);
}
function $cee7ff159d524e18$var$Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $cee7ff159d524e18$var$He = "function" === typeof Object.is ? Object.is : $cee7ff159d524e18$var$Ge;
function $cee7ff159d524e18$var$Ie(a, b) {
    if ($cee7ff159d524e18$var$He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!$cee7ff159d524e18$var$ja.call(b, e) || !$cee7ff159d524e18$var$He(a[e], b[e])) return !1;
    }
    return !0;
}
function $cee7ff159d524e18$var$Je(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $cee7ff159d524e18$var$Ke(a, b) {
    var c = $cee7ff159d524e18$var$Je(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $cee7ff159d524e18$var$Je(c);
    }
}
function $cee7ff159d524e18$var$Le(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $cee7ff159d524e18$var$Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $cee7ff159d524e18$var$Me() {
    for(var a = window, b = $cee7ff159d524e18$var$Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $cee7ff159d524e18$var$Xa(a.document);
    }
    return b;
}
function $cee7ff159d524e18$var$Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function $cee7ff159d524e18$var$Oe(a) {
    var b = $cee7ff159d524e18$var$Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && $cee7ff159d524e18$var$Le(c.ownerDocument.documentElement, c)) {
        if (null !== d && $cee7ff159d524e18$var$Ne(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = $cee7ff159d524e18$var$Ke(c, f);
                var g = $cee7ff159d524e18$var$Ke(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var $cee7ff159d524e18$var$Pe = $cee7ff159d524e18$var$ia && "documentMode" in document && 11 >= document.documentMode, $cee7ff159d524e18$var$Qe = null, $cee7ff159d524e18$var$Re = null, $cee7ff159d524e18$var$Se = null, $cee7ff159d524e18$var$Te = !1;
function $cee7ff159d524e18$var$Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $cee7ff159d524e18$var$Te || null == $cee7ff159d524e18$var$Qe || $cee7ff159d524e18$var$Qe !== $cee7ff159d524e18$var$Xa(d) || (d = $cee7ff159d524e18$var$Qe, "selectionStart" in d && $cee7ff159d524e18$var$Ne(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $cee7ff159d524e18$var$Se && $cee7ff159d524e18$var$Ie($cee7ff159d524e18$var$Se, d) || ($cee7ff159d524e18$var$Se = d, d = $cee7ff159d524e18$var$oe($cee7ff159d524e18$var$Re, "onSelect"), 0 < d.length && (b = new $cee7ff159d524e18$var$td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $cee7ff159d524e18$var$Qe)));
}
function $cee7ff159d524e18$var$Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $cee7ff159d524e18$var$We = {
    animationend: $cee7ff159d524e18$var$Ve("Animation", "AnimationEnd"),
    animationiteration: $cee7ff159d524e18$var$Ve("Animation", "AnimationIteration"),
    animationstart: $cee7ff159d524e18$var$Ve("Animation", "AnimationStart"),
    transitionend: $cee7ff159d524e18$var$Ve("Transition", "TransitionEnd")
}, $cee7ff159d524e18$var$Xe = {}, $cee7ff159d524e18$var$Ye = {};
$cee7ff159d524e18$var$ia && ($cee7ff159d524e18$var$Ye = document.createElement("div").style, "AnimationEvent" in window || (delete $cee7ff159d524e18$var$We.animationend.animation, delete $cee7ff159d524e18$var$We.animationiteration.animation, delete $cee7ff159d524e18$var$We.animationstart.animation), "TransitionEvent" in window || delete $cee7ff159d524e18$var$We.transitionend.transition);
function $cee7ff159d524e18$var$Ze(a) {
    if ($cee7ff159d524e18$var$Xe[a]) return $cee7ff159d524e18$var$Xe[a];
    if (!$cee7ff159d524e18$var$We[a]) return a;
    var b = $cee7ff159d524e18$var$We[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $cee7ff159d524e18$var$Ye) return $cee7ff159d524e18$var$Xe[a] = b[c];
    return a;
}
var $cee7ff159d524e18$var$$e = $cee7ff159d524e18$var$Ze("animationend"), $cee7ff159d524e18$var$af = $cee7ff159d524e18$var$Ze("animationiteration"), $cee7ff159d524e18$var$bf = $cee7ff159d524e18$var$Ze("animationstart"), $cee7ff159d524e18$var$cf = $cee7ff159d524e18$var$Ze("transitionend"), $cee7ff159d524e18$var$df = new Map, $cee7ff159d524e18$var$ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function $cee7ff159d524e18$var$ff(a, b) {
    $cee7ff159d524e18$var$df.set(a, b);
    $cee7ff159d524e18$var$fa(b, [
        a
    ]);
}
for(var $cee7ff159d524e18$var$gf = 0; $cee7ff159d524e18$var$gf < $cee7ff159d524e18$var$ef.length; $cee7ff159d524e18$var$gf++){
    var $cee7ff159d524e18$var$hf = $cee7ff159d524e18$var$ef[$cee7ff159d524e18$var$gf], $cee7ff159d524e18$var$jf = $cee7ff159d524e18$var$hf.toLowerCase(), $cee7ff159d524e18$var$kf = $cee7ff159d524e18$var$hf[0].toUpperCase() + $cee7ff159d524e18$var$hf.slice(1);
    $cee7ff159d524e18$var$ff($cee7ff159d524e18$var$jf, "on" + $cee7ff159d524e18$var$kf);
}
$cee7ff159d524e18$var$ff($cee7ff159d524e18$var$$e, "onAnimationEnd");
$cee7ff159d524e18$var$ff($cee7ff159d524e18$var$af, "onAnimationIteration");
$cee7ff159d524e18$var$ff($cee7ff159d524e18$var$bf, "onAnimationStart");
$cee7ff159d524e18$var$ff("dblclick", "onDoubleClick");
$cee7ff159d524e18$var$ff("focusin", "onFocus");
$cee7ff159d524e18$var$ff("focusout", "onBlur");
$cee7ff159d524e18$var$ff($cee7ff159d524e18$var$cf, "onTransitionEnd");
$cee7ff159d524e18$var$ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$cee7ff159d524e18$var$ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$cee7ff159d524e18$var$ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$cee7ff159d524e18$var$ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$cee7ff159d524e18$var$fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$cee7ff159d524e18$var$fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$cee7ff159d524e18$var$fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$cee7ff159d524e18$var$fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$cee7ff159d524e18$var$fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$cee7ff159d524e18$var$fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $cee7ff159d524e18$var$lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $cee7ff159d524e18$var$mf = new Set("cancel close invalid load scroll toggle".split(" ").concat($cee7ff159d524e18$var$lf));
function $cee7ff159d524e18$var$nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $cee7ff159d524e18$var$Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function $cee7ff159d524e18$var$se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $cee7ff159d524e18$var$nf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $cee7ff159d524e18$var$nf(e, h, l);
                f = k;
            }
        }
    }
    if ($cee7ff159d524e18$var$Qb) throw a = $cee7ff159d524e18$var$Rb, $cee7ff159d524e18$var$Qb = !1, $cee7ff159d524e18$var$Rb = null, a;
}
function $cee7ff159d524e18$var$D(a, b) {
    var c = b[$cee7ff159d524e18$var$of];
    void 0 === c && (c = b[$cee7ff159d524e18$var$of] = new Set);
    var d = a + "__bubble";
    c.has(d) || ($cee7ff159d524e18$var$pf(b, a, 2, !1), c.add(d));
}
function $cee7ff159d524e18$var$qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    $cee7ff159d524e18$var$pf(c, a, d, b);
}
var $cee7ff159d524e18$var$rf = "_reactListening" + Math.random().toString(36).slice(2);
function $cee7ff159d524e18$var$sf(a) {
    if (!a[$cee7ff159d524e18$var$rf]) {
        a[$cee7ff159d524e18$var$rf] = !0;
        $cee7ff159d524e18$var$da.forEach(function(b) {
            "selectionchange" !== b && ($cee7ff159d524e18$var$mf.has(b) || $cee7ff159d524e18$var$qf(b, !1, a), $cee7ff159d524e18$var$qf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[$cee7ff159d524e18$var$rf] || (b[$cee7ff159d524e18$var$rf] = !0, $cee7ff159d524e18$var$qf("selectionchange", !1, b));
    }
}
function $cee7ff159d524e18$var$pf(a, b, c, d) {
    switch($cee7ff159d524e18$var$jd(b)){
        case 1:
            var e = $cee7ff159d524e18$var$ed;
            break;
        case 4:
            e = $cee7ff159d524e18$var$gd;
            break;
        default:
            e = $cee7ff159d524e18$var$fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$cee7ff159d524e18$var$Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $cee7ff159d524e18$var$hd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = $cee7ff159d524e18$var$Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    $cee7ff159d524e18$var$Jb(function() {
        var d = f, e = $cee7ff159d524e18$var$xb(c), g = [];
        a: {
            var h = $cee7ff159d524e18$var$df.get(a);
            if (void 0 !== h) {
                var k = $cee7ff159d524e18$var$td, n = a;
                switch(a){
                    case "keypress":
                        if (0 === $cee7ff159d524e18$var$od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = $cee7ff159d524e18$var$Rd;
                        break;
                    case "focusin":
                        n = "focus";
                        k = $cee7ff159d524e18$var$Fd;
                        break;
                    case "focusout":
                        n = "blur";
                        k = $cee7ff159d524e18$var$Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = $cee7ff159d524e18$var$Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = $cee7ff159d524e18$var$Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = $cee7ff159d524e18$var$Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = $cee7ff159d524e18$var$Vd;
                        break;
                    case $cee7ff159d524e18$var$$e:
                    case $cee7ff159d524e18$var$af:
                    case $cee7ff159d524e18$var$bf:
                        k = $cee7ff159d524e18$var$Hd;
                        break;
                    case $cee7ff159d524e18$var$cf:
                        k = $cee7ff159d524e18$var$Xd;
                        break;
                    case "scroll":
                        k = $cee7ff159d524e18$var$vd;
                        break;
                    case "wheel":
                        k = $cee7ff159d524e18$var$Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = $cee7ff159d524e18$var$Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = $cee7ff159d524e18$var$Td;
                }
                var t = 0 !== (b & 4), J = !t && "scroll" === a, x = t ? null !== h ? h + "Capture" : null : h;
                t = [];
                for(var w = d, u; null !== w;){
                    u = w;
                    var F = u.stateNode;
                    5 === u.tag && null !== F && (u = F, null !== x && (F = $cee7ff159d524e18$var$Kb(w, x), null != F && t.push($cee7ff159d524e18$var$tf(w, F, u))));
                    if (J) break;
                    w = w.return;
                }
                0 < t.length && (h = new k(h, n, null, c, e), g.push({
                    event: h,
                    listeners: t
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== $cee7ff159d524e18$var$wb && (n = c.relatedTarget || c.fromElement) && ($cee7ff159d524e18$var$Wc(n) || n[$cee7ff159d524e18$var$uf])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = d, n = n ? $cee7ff159d524e18$var$Wc(n) : null, null !== n && (J = $cee7ff159d524e18$var$Vb(n), n !== J || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = d;
                    if (k !== n) {
                        t = $cee7ff159d524e18$var$Bd;
                        F = "onMouseLeave";
                        x = "onMouseEnter";
                        w = "mouse";
                        if ("pointerout" === a || "pointerover" === a) t = $cee7ff159d524e18$var$Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                        J = null == k ? h : $cee7ff159d524e18$var$ue(k);
                        u = null == n ? h : $cee7ff159d524e18$var$ue(n);
                        h = new t(F, w + "leave", k, c, e);
                        h.target = J;
                        h.relatedTarget = u;
                        F = null;
                        $cee7ff159d524e18$var$Wc(e) === d && (t = new t(x, w + "enter", n, c, e), t.target = u, t.relatedTarget = J, F = t);
                        J = F;
                        if (k && n) b: {
                            t = k;
                            x = n;
                            w = 0;
                            for(u = t; u; u = $cee7ff159d524e18$var$vf(u))w++;
                            u = 0;
                            for(F = x; F; F = $cee7ff159d524e18$var$vf(F))u++;
                            for(; 0 < w - u;)t = $cee7ff159d524e18$var$vf(t), w--;
                            for(; 0 < u - w;)x = $cee7ff159d524e18$var$vf(x), u--;
                            for(; w--;){
                                if (t === x || null !== x && t === x.alternate) break b;
                                t = $cee7ff159d524e18$var$vf(t);
                                x = $cee7ff159d524e18$var$vf(x);
                            }
                            t = null;
                        }
                        else t = null;
                        null !== k && $cee7ff159d524e18$var$wf(g, h, k, t, !1);
                        null !== n && null !== J && $cee7ff159d524e18$var$wf(g, J, n, t, !0);
                    }
                }
            }
            a: {
                h = d ? $cee7ff159d524e18$var$ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var na = $cee7ff159d524e18$var$ve;
                else if ($cee7ff159d524e18$var$me(h)) {
                    if ($cee7ff159d524e18$var$we) na = $cee7ff159d524e18$var$Fe;
                    else {
                        na = $cee7ff159d524e18$var$De;
                        var xa = $cee7ff159d524e18$var$Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (na = $cee7ff159d524e18$var$Ee);
                if (na && (na = na(a, d))) {
                    $cee7ff159d524e18$var$ne(g, na, c, e);
                    break a;
                }
                xa && xa(a, h, d);
                "focusout" === a && (xa = h._wrapperState) && xa.controlled && "number" === h.type && $cee7ff159d524e18$var$cb(h, "number", h.value);
            }
            xa = d ? $cee7ff159d524e18$var$ue(d) : window;
            switch(a){
                case "focusin":
                    if ($cee7ff159d524e18$var$me(xa) || "true" === xa.contentEditable) $cee7ff159d524e18$var$Qe = xa, $cee7ff159d524e18$var$Re = d, $cee7ff159d524e18$var$Se = null;
                    break;
                case "focusout":
                    $cee7ff159d524e18$var$Se = $cee7ff159d524e18$var$Re = $cee7ff159d524e18$var$Qe = null;
                    break;
                case "mousedown":
                    $cee7ff159d524e18$var$Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $cee7ff159d524e18$var$Te = !1;
                    $cee7ff159d524e18$var$Ue(g, c, e);
                    break;
                case "selectionchange":
                    if ($cee7ff159d524e18$var$Pe) break;
                case "keydown":
                case "keyup":
                    $cee7ff159d524e18$var$Ue(g, c, e);
            }
            var $a;
            if ($cee7ff159d524e18$var$ae) b: {
                switch(a){
                    case "compositionstart":
                        var ba = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ba = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ba = "onCompositionUpdate";
                        break b;
                }
                ba = void 0;
            }
            else $cee7ff159d524e18$var$ie ? $cee7ff159d524e18$var$ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
            ba && ($cee7ff159d524e18$var$de && "ko" !== c.locale && ($cee7ff159d524e18$var$ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && $cee7ff159d524e18$var$ie && ($a = $cee7ff159d524e18$var$nd()) : ($cee7ff159d524e18$var$kd = e, $cee7ff159d524e18$var$ld = "value" in $cee7ff159d524e18$var$kd ? $cee7ff159d524e18$var$kd.value : $cee7ff159d524e18$var$kd.textContent, $cee7ff159d524e18$var$ie = !0)), xa = $cee7ff159d524e18$var$oe(d, ba), 0 < xa.length && (ba = new $cee7ff159d524e18$var$Ld(ba, a, null, c, e), g.push({
                event: ba,
                listeners: xa
            }), $a ? ba.data = $a : ($a = $cee7ff159d524e18$var$he(c), null !== $a && (ba.data = $a))));
            if ($a = $cee7ff159d524e18$var$ce ? $cee7ff159d524e18$var$je(a, c) : $cee7ff159d524e18$var$ke(a, c)) d = $cee7ff159d524e18$var$oe(d, "onBeforeInput"), 0 < d.length && (e = new $cee7ff159d524e18$var$Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = $a);
        }
        $cee7ff159d524e18$var$se(g, b);
    });
}
function $cee7ff159d524e18$var$tf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $cee7ff159d524e18$var$oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = $cee7ff159d524e18$var$Kb(a, c), null != f && d.unshift($cee7ff159d524e18$var$tf(a, f, e)), f = $cee7ff159d524e18$var$Kb(a, b), null != f && d.push($cee7ff159d524e18$var$tf(a, f, e)));
        a = a.return;
    }
    return d;
}
function $cee7ff159d524e18$var$vf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $cee7ff159d524e18$var$wf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = $cee7ff159d524e18$var$Kb(c, f), null != k && g.unshift($cee7ff159d524e18$var$tf(c, k, h))) : e || (k = $cee7ff159d524e18$var$Kb(c, f), null != k && g.push($cee7ff159d524e18$var$tf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var $cee7ff159d524e18$var$xf = /\r\n?/g, $cee7ff159d524e18$var$yf = /\u0000|\uFFFD/g;
function $cee7ff159d524e18$var$zf(a) {
    return ("string" === typeof a ? a : "" + a).replace($cee7ff159d524e18$var$xf, "\n").replace($cee7ff159d524e18$var$yf, "");
}
function $cee7ff159d524e18$var$Af(a, b, c) {
    b = $cee7ff159d524e18$var$zf(b);
    if ($cee7ff159d524e18$var$zf(a) !== b && c) throw Error($cee7ff159d524e18$var$p(425));
}
function $cee7ff159d524e18$var$Bf() {}
var $cee7ff159d524e18$var$Cf = null, $cee7ff159d524e18$var$Df = null;
function $cee7ff159d524e18$var$Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $cee7ff159d524e18$var$Ff = "function" === typeof setTimeout ? setTimeout : void 0, $cee7ff159d524e18$var$Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, $cee7ff159d524e18$var$Hf = "function" === typeof Promise ? Promise : void 0, $cee7ff159d524e18$var$Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $cee7ff159d524e18$var$Hf ? function(a) {
    return $cee7ff159d524e18$var$Hf.resolve(null).then(a).catch($cee7ff159d524e18$var$If);
} : $cee7ff159d524e18$var$Ff;
function $cee7ff159d524e18$var$If(a) {
    setTimeout(function() {
        throw a;
    });
}
function $cee7ff159d524e18$var$Kf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    $cee7ff159d524e18$var$bd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    $cee7ff159d524e18$var$bd(b);
}
function $cee7ff159d524e18$var$Lf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function $cee7ff159d524e18$var$Mf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $cee7ff159d524e18$var$Nf = Math.random().toString(36).slice(2), $cee7ff159d524e18$var$Of = "__reactFiber$" + $cee7ff159d524e18$var$Nf, $cee7ff159d524e18$var$Pf = "__reactProps$" + $cee7ff159d524e18$var$Nf, $cee7ff159d524e18$var$uf = "__reactContainer$" + $cee7ff159d524e18$var$Nf, $cee7ff159d524e18$var$of = "__reactEvents$" + $cee7ff159d524e18$var$Nf, $cee7ff159d524e18$var$Qf = "__reactListeners$" + $cee7ff159d524e18$var$Nf, $cee7ff159d524e18$var$Rf = "__reactHandles$" + $cee7ff159d524e18$var$Nf;
function $cee7ff159d524e18$var$Wc(a) {
    var b = a[$cee7ff159d524e18$var$Of];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$cee7ff159d524e18$var$uf] || c[$cee7ff159d524e18$var$Of]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $cee7ff159d524e18$var$Mf(a); null !== a;){
                if (c = a[$cee7ff159d524e18$var$Of]) return c;
                a = $cee7ff159d524e18$var$Mf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $cee7ff159d524e18$var$Cb(a) {
    a = a[$cee7ff159d524e18$var$Of] || a[$cee7ff159d524e18$var$uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $cee7ff159d524e18$var$ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($cee7ff159d524e18$var$p(33));
}
function $cee7ff159d524e18$var$Db(a) {
    return a[$cee7ff159d524e18$var$Pf] || null;
}
var $cee7ff159d524e18$var$Sf = [], $cee7ff159d524e18$var$Tf = -1;
function $cee7ff159d524e18$var$Uf(a) {
    return {
        current: a
    };
}
function $cee7ff159d524e18$var$E(a) {
    0 > $cee7ff159d524e18$var$Tf || (a.current = $cee7ff159d524e18$var$Sf[$cee7ff159d524e18$var$Tf], $cee7ff159d524e18$var$Sf[$cee7ff159d524e18$var$Tf] = null, $cee7ff159d524e18$var$Tf--);
}
function $cee7ff159d524e18$var$G(a, b) {
    $cee7ff159d524e18$var$Tf++;
    $cee7ff159d524e18$var$Sf[$cee7ff159d524e18$var$Tf] = a.current;
    a.current = b;
}
var $cee7ff159d524e18$var$Vf = {}, $cee7ff159d524e18$var$H = $cee7ff159d524e18$var$Uf($cee7ff159d524e18$var$Vf), $cee7ff159d524e18$var$Wf = $cee7ff159d524e18$var$Uf(!1), $cee7ff159d524e18$var$Xf = $cee7ff159d524e18$var$Vf;
function $cee7ff159d524e18$var$Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $cee7ff159d524e18$var$Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $cee7ff159d524e18$var$Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $cee7ff159d524e18$var$$f() {
    $cee7ff159d524e18$var$E($cee7ff159d524e18$var$Wf);
    $cee7ff159d524e18$var$E($cee7ff159d524e18$var$H);
}
function $cee7ff159d524e18$var$ag(a, b, c) {
    if ($cee7ff159d524e18$var$H.current !== $cee7ff159d524e18$var$Vf) throw Error($cee7ff159d524e18$var$p(168));
    $cee7ff159d524e18$var$G($cee7ff159d524e18$var$H, b);
    $cee7ff159d524e18$var$G($cee7ff159d524e18$var$Wf, c);
}
function $cee7ff159d524e18$var$bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error($cee7ff159d524e18$var$p(108, $cee7ff159d524e18$var$Ra(a) || "Unknown", e));
    return $cee7ff159d524e18$var$A({}, c, d);
}
function $cee7ff159d524e18$var$cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $cee7ff159d524e18$var$Vf;
    $cee7ff159d524e18$var$Xf = $cee7ff159d524e18$var$H.current;
    $cee7ff159d524e18$var$G($cee7ff159d524e18$var$H, a);
    $cee7ff159d524e18$var$G($cee7ff159d524e18$var$Wf, $cee7ff159d524e18$var$Wf.current);
    return !0;
}
function $cee7ff159d524e18$var$dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($cee7ff159d524e18$var$p(169));
    c ? (a = $cee7ff159d524e18$var$bg(a, b, $cee7ff159d524e18$var$Xf), d.__reactInternalMemoizedMergedChildContext = a, $cee7ff159d524e18$var$E($cee7ff159d524e18$var$Wf), $cee7ff159d524e18$var$E($cee7ff159d524e18$var$H), $cee7ff159d524e18$var$G($cee7ff159d524e18$var$H, a)) : $cee7ff159d524e18$var$E($cee7ff159d524e18$var$Wf);
    $cee7ff159d524e18$var$G($cee7ff159d524e18$var$Wf, c);
}
var $cee7ff159d524e18$var$eg = null, $cee7ff159d524e18$var$fg = !1, $cee7ff159d524e18$var$gg = !1;
function $cee7ff159d524e18$var$hg(a) {
    null === $cee7ff159d524e18$var$eg ? $cee7ff159d524e18$var$eg = [
        a
    ] : $cee7ff159d524e18$var$eg.push(a);
}
function $cee7ff159d524e18$var$ig(a) {
    $cee7ff159d524e18$var$fg = !0;
    $cee7ff159d524e18$var$hg(a);
}
function $cee7ff159d524e18$var$jg() {
    if (!$cee7ff159d524e18$var$gg && null !== $cee7ff159d524e18$var$eg) {
        $cee7ff159d524e18$var$gg = !0;
        var a = 0, b = $cee7ff159d524e18$var$C;
        try {
            var c = $cee7ff159d524e18$var$eg;
            for($cee7ff159d524e18$var$C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            $cee7ff159d524e18$var$eg = null;
            $cee7ff159d524e18$var$fg = !1;
        } catch (e) {
            throw null !== $cee7ff159d524e18$var$eg && ($cee7ff159d524e18$var$eg = $cee7ff159d524e18$var$eg.slice(a + 1)), $cee7ff159d524e18$var$ac($cee7ff159d524e18$var$fc, $cee7ff159d524e18$var$jg), e;
        } finally{
            $cee7ff159d524e18$var$C = b, $cee7ff159d524e18$var$gg = !1;
        }
    }
    return null;
}
var $cee7ff159d524e18$var$kg = [], $cee7ff159d524e18$var$lg = 0, $cee7ff159d524e18$var$mg = null, $cee7ff159d524e18$var$ng = 0, $cee7ff159d524e18$var$og = [], $cee7ff159d524e18$var$pg = 0, $cee7ff159d524e18$var$qg = null, $cee7ff159d524e18$var$rg = 1, $cee7ff159d524e18$var$sg = "";
function $cee7ff159d524e18$var$tg(a, b) {
    $cee7ff159d524e18$var$kg[$cee7ff159d524e18$var$lg++] = $cee7ff159d524e18$var$ng;
    $cee7ff159d524e18$var$kg[$cee7ff159d524e18$var$lg++] = $cee7ff159d524e18$var$mg;
    $cee7ff159d524e18$var$mg = a;
    $cee7ff159d524e18$var$ng = b;
}
function $cee7ff159d524e18$var$ug(a, b, c) {
    $cee7ff159d524e18$var$og[$cee7ff159d524e18$var$pg++] = $cee7ff159d524e18$var$rg;
    $cee7ff159d524e18$var$og[$cee7ff159d524e18$var$pg++] = $cee7ff159d524e18$var$sg;
    $cee7ff159d524e18$var$og[$cee7ff159d524e18$var$pg++] = $cee7ff159d524e18$var$qg;
    $cee7ff159d524e18$var$qg = a;
    var d = $cee7ff159d524e18$var$rg;
    a = $cee7ff159d524e18$var$sg;
    var e = 32 - $cee7ff159d524e18$var$oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - $cee7ff159d524e18$var$oc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        $cee7ff159d524e18$var$rg = 1 << 32 - $cee7ff159d524e18$var$oc(b) + e | c << e | d;
        $cee7ff159d524e18$var$sg = f + a;
    } else $cee7ff159d524e18$var$rg = 1 << f | c << e | d, $cee7ff159d524e18$var$sg = a;
}
function $cee7ff159d524e18$var$vg(a) {
    null !== a.return && ($cee7ff159d524e18$var$tg(a, 1), $cee7ff159d524e18$var$ug(a, 1, 0));
}
function $cee7ff159d524e18$var$wg(a) {
    for(; a === $cee7ff159d524e18$var$mg;)$cee7ff159d524e18$var$mg = $cee7ff159d524e18$var$kg[--$cee7ff159d524e18$var$lg], $cee7ff159d524e18$var$kg[$cee7ff159d524e18$var$lg] = null, $cee7ff159d524e18$var$ng = $cee7ff159d524e18$var$kg[--$cee7ff159d524e18$var$lg], $cee7ff159d524e18$var$kg[$cee7ff159d524e18$var$lg] = null;
    for(; a === $cee7ff159d524e18$var$qg;)$cee7ff159d524e18$var$qg = $cee7ff159d524e18$var$og[--$cee7ff159d524e18$var$pg], $cee7ff159d524e18$var$og[$cee7ff159d524e18$var$pg] = null, $cee7ff159d524e18$var$sg = $cee7ff159d524e18$var$og[--$cee7ff159d524e18$var$pg], $cee7ff159d524e18$var$og[$cee7ff159d524e18$var$pg] = null, $cee7ff159d524e18$var$rg = $cee7ff159d524e18$var$og[--$cee7ff159d524e18$var$pg], $cee7ff159d524e18$var$og[$cee7ff159d524e18$var$pg] = null;
}
var $cee7ff159d524e18$var$xg = null, $cee7ff159d524e18$var$yg = null, $cee7ff159d524e18$var$I = !1, $cee7ff159d524e18$var$zg = null;
function $cee7ff159d524e18$var$Ag(a, b) {
    var c = $cee7ff159d524e18$var$Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function $cee7ff159d524e18$var$Cg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, $cee7ff159d524e18$var$xg = a, $cee7ff159d524e18$var$yg = $cee7ff159d524e18$var$Lf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, $cee7ff159d524e18$var$xg = a, $cee7ff159d524e18$var$yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== $cee7ff159d524e18$var$qg ? {
                id: $cee7ff159d524e18$var$rg,
                overflow: $cee7ff159d524e18$var$sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = $cee7ff159d524e18$var$Bg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, $cee7ff159d524e18$var$xg = a, $cee7ff159d524e18$var$yg = null, !0) : !1;
        default:
            return !1;
    }
}
function $cee7ff159d524e18$var$Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function $cee7ff159d524e18$var$Eg(a) {
    if ($cee7ff159d524e18$var$I) {
        var b = $cee7ff159d524e18$var$yg;
        if (b) {
            var c = b;
            if (!$cee7ff159d524e18$var$Cg(a, b)) {
                if ($cee7ff159d524e18$var$Dg(a)) throw Error($cee7ff159d524e18$var$p(418));
                b = $cee7ff159d524e18$var$Lf(c.nextSibling);
                var d = $cee7ff159d524e18$var$xg;
                b && $cee7ff159d524e18$var$Cg(a, b) ? $cee7ff159d524e18$var$Ag(d, c) : (a.flags = a.flags & -4097 | 2, $cee7ff159d524e18$var$I = !1, $cee7ff159d524e18$var$xg = a);
            }
        } else {
            if ($cee7ff159d524e18$var$Dg(a)) throw Error($cee7ff159d524e18$var$p(418));
            a.flags = a.flags & -4097 | 2;
            $cee7ff159d524e18$var$I = !1;
            $cee7ff159d524e18$var$xg = a;
        }
    }
}
function $cee7ff159d524e18$var$Fg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    $cee7ff159d524e18$var$xg = a;
}
function $cee7ff159d524e18$var$Gg(a) {
    if (a !== $cee7ff159d524e18$var$xg) return !1;
    if (!$cee7ff159d524e18$var$I) return $cee7ff159d524e18$var$Fg(a), $cee7ff159d524e18$var$I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !$cee7ff159d524e18$var$Ef(a.type, a.memoizedProps));
    if (b && (b = $cee7ff159d524e18$var$yg)) {
        if ($cee7ff159d524e18$var$Dg(a)) throw $cee7ff159d524e18$var$Hg(), Error($cee7ff159d524e18$var$p(418));
        for(; b;)$cee7ff159d524e18$var$Ag(a, b), b = $cee7ff159d524e18$var$Lf(b.nextSibling);
    }
    $cee7ff159d524e18$var$Fg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($cee7ff159d524e18$var$p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $cee7ff159d524e18$var$yg = $cee7ff159d524e18$var$Lf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $cee7ff159d524e18$var$yg = null;
        }
    } else $cee7ff159d524e18$var$yg = $cee7ff159d524e18$var$xg ? $cee7ff159d524e18$var$Lf(a.stateNode.nextSibling) : null;
    return !0;
}
function $cee7ff159d524e18$var$Hg() {
    for(var a = $cee7ff159d524e18$var$yg; a;)a = $cee7ff159d524e18$var$Lf(a.nextSibling);
}
function $cee7ff159d524e18$var$Ig() {
    $cee7ff159d524e18$var$yg = $cee7ff159d524e18$var$xg = null;
    $cee7ff159d524e18$var$I = !1;
}
function $cee7ff159d524e18$var$Jg(a) {
    null === $cee7ff159d524e18$var$zg ? $cee7ff159d524e18$var$zg = [
        a
    ] : $cee7ff159d524e18$var$zg.push(a);
}
var $cee7ff159d524e18$var$Kg = $cee7ff159d524e18$var$ua.ReactCurrentBatchConfig;
function $cee7ff159d524e18$var$Lg(a, b) {
    if (a && a.defaultProps) {
        b = $cee7ff159d524e18$var$A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
var $cee7ff159d524e18$var$Mg = $cee7ff159d524e18$var$Uf(null), $cee7ff159d524e18$var$Ng = null, $cee7ff159d524e18$var$Og = null, $cee7ff159d524e18$var$Pg = null;
function $cee7ff159d524e18$var$Qg() {
    $cee7ff159d524e18$var$Pg = $cee7ff159d524e18$var$Og = $cee7ff159d524e18$var$Ng = null;
}
function $cee7ff159d524e18$var$Rg(a) {
    var b = $cee7ff159d524e18$var$Mg.current;
    $cee7ff159d524e18$var$E($cee7ff159d524e18$var$Mg);
    a._currentValue = b;
}
function $cee7ff159d524e18$var$Sg(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function $cee7ff159d524e18$var$Tg(a, b) {
    $cee7ff159d524e18$var$Ng = a;
    $cee7ff159d524e18$var$Pg = $cee7ff159d524e18$var$Og = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($cee7ff159d524e18$var$Ug = !0), a.firstContext = null);
}
function $cee7ff159d524e18$var$Vg(a) {
    var b = a._currentValue;
    if ($cee7ff159d524e18$var$Pg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === $cee7ff159d524e18$var$Og) {
            if (null === $cee7ff159d524e18$var$Ng) throw Error($cee7ff159d524e18$var$p(308));
            $cee7ff159d524e18$var$Og = a;
            $cee7ff159d524e18$var$Ng.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else $cee7ff159d524e18$var$Og = $cee7ff159d524e18$var$Og.next = a;
    }
    return b;
}
var $cee7ff159d524e18$var$Wg = null;
function $cee7ff159d524e18$var$Xg(a) {
    null === $cee7ff159d524e18$var$Wg ? $cee7ff159d524e18$var$Wg = [
        a
    ] : $cee7ff159d524e18$var$Wg.push(a);
}
function $cee7ff159d524e18$var$Yg(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, $cee7ff159d524e18$var$Xg(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return $cee7ff159d524e18$var$Zg(a, d);
}
function $cee7ff159d524e18$var$Zg(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var $cee7ff159d524e18$var$$g = !1;
function $cee7ff159d524e18$var$ah(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function $cee7ff159d524e18$var$bh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function $cee7ff159d524e18$var$ch(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $cee7ff159d524e18$var$dh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== ($cee7ff159d524e18$var$K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return $cee7ff159d524e18$var$Zg(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, $cee7ff159d524e18$var$Xg(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return $cee7ff159d524e18$var$Zg(a, c);
}
function $cee7ff159d524e18$var$eh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $cee7ff159d524e18$var$Cc(a, c);
    }
}
function $cee7ff159d524e18$var$fh(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $cee7ff159d524e18$var$gh(a, b, c, d) {
    var e = a.updateQueue;
    $cee7ff159d524e18$var$$g = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var r = h.lane, y = h.eventTime;
            if ((d & r) === r) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, t = h;
                    r = b;
                    y = c;
                    switch(t.tag){
                        case 1:
                            n = t.payload;
                            if ("function" === typeof n) {
                                q = n.call(y, q, r);
                                break a;
                            }
                            q = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = t.payload;
                            r = "function" === typeof n ? n.call(y, q, r) : n;
                            if (null === r || void 0 === r) break a;
                            q = $cee7ff159d524e18$var$A({}, q, r);
                            break a;
                        case 2:
                            $cee7ff159d524e18$var$$g = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = q) : m = m.next = y, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        $cee7ff159d524e18$var$hh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function $cee7ff159d524e18$var$ih(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error($cee7ff159d524e18$var$p(191, e));
            e.call(d);
        }
    }
}
var $cee7ff159d524e18$var$jh = (new $5FkrB.Component).refs;
function $cee7ff159d524e18$var$kh(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $cee7ff159d524e18$var$A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $cee7ff159d524e18$var$nh = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? $cee7ff159d524e18$var$Vb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = $cee7ff159d524e18$var$L(), e = $cee7ff159d524e18$var$lh(a), f = $cee7ff159d524e18$var$ch(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $cee7ff159d524e18$var$dh(a, f, e);
        null !== b && ($cee7ff159d524e18$var$mh(b, a, e, d), $cee7ff159d524e18$var$eh(b, a, e));
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = $cee7ff159d524e18$var$L(), e = $cee7ff159d524e18$var$lh(a), f = $cee7ff159d524e18$var$ch(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $cee7ff159d524e18$var$dh(a, f, e);
        null !== b && ($cee7ff159d524e18$var$mh(b, a, e, d), $cee7ff159d524e18$var$eh(b, a, e));
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = $cee7ff159d524e18$var$L(), d = $cee7ff159d524e18$var$lh(a), e = $cee7ff159d524e18$var$ch(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = $cee7ff159d524e18$var$dh(a, e, d);
        null !== b && ($cee7ff159d524e18$var$mh(b, a, d, c), $cee7ff159d524e18$var$eh(b, a, d));
    }
};
function $cee7ff159d524e18$var$oh(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$cee7ff159d524e18$var$Ie(c, d) || !$cee7ff159d524e18$var$Ie(e, f) : !0;
}
function $cee7ff159d524e18$var$ph(a, b, c) {
    var d = !1, e = $cee7ff159d524e18$var$Vf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = $cee7ff159d524e18$var$Vg(f) : (e = $cee7ff159d524e18$var$Zf(b) ? $cee7ff159d524e18$var$Xf : $cee7ff159d524e18$var$H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $cee7ff159d524e18$var$Yf(a, e) : $cee7ff159d524e18$var$Vf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $cee7ff159d524e18$var$nh;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $cee7ff159d524e18$var$qh(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $cee7ff159d524e18$var$nh.enqueueReplaceState(b, b.state, null);
}
function $cee7ff159d524e18$var$rh(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = $cee7ff159d524e18$var$jh;
    $cee7ff159d524e18$var$ah(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = $cee7ff159d524e18$var$Vg(f) : (f = $cee7ff159d524e18$var$Zf(b) ? $cee7ff159d524e18$var$Xf : $cee7ff159d524e18$var$H.current, e.context = $cee7ff159d524e18$var$Yf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($cee7ff159d524e18$var$kh(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $cee7ff159d524e18$var$nh.enqueueReplaceState(e, e.state, null), $cee7ff159d524e18$var$gh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function $cee7ff159d524e18$var$sh(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($cee7ff159d524e18$var$p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($cee7ff159d524e18$var$p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function(a) {
                var b = e.refs;
                b === $cee7ff159d524e18$var$jh && (b = e.refs = {});
                null === a ? delete b[f] : b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error($cee7ff159d524e18$var$p(284));
        if (!c._owner) throw Error($cee7ff159d524e18$var$p(290, a));
    }
    return a;
}
function $cee7ff159d524e18$var$th(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error($cee7ff159d524e18$var$p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function $cee7ff159d524e18$var$uh(a) {
    var b = a._init;
    return b(a._payload);
}
function $cee7ff159d524e18$var$vh(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = $cee7ff159d524e18$var$wh(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $cee7ff159d524e18$var$xh(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === $cee7ff159d524e18$var$ya) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === $cee7ff159d524e18$var$Ha && $cee7ff159d524e18$var$uh(f) === b.type)) return d = e(b, c.props), d.ref = $cee7ff159d524e18$var$sh(a, b, c), d.return = a, d;
        d = $cee7ff159d524e18$var$yh(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $cee7ff159d524e18$var$sh(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $cee7ff159d524e18$var$zh(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $cee7ff159d524e18$var$Ah(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = $cee7ff159d524e18$var$xh("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case $cee7ff159d524e18$var$va:
                    return c = $cee7ff159d524e18$var$yh(b.type, b.key, b.props, null, a.mode, c), c.ref = $cee7ff159d524e18$var$sh(a, null, b), c.return = a, c;
                case $cee7ff159d524e18$var$wa:
                    return b = $cee7ff159d524e18$var$zh(b, a.mode, c), b.return = a, b;
                case $cee7ff159d524e18$var$Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if ($cee7ff159d524e18$var$eb(b) || $cee7ff159d524e18$var$Ka(b)) return b = $cee7ff159d524e18$var$Ah(b, a.mode, c, null), b.return = a, b;
            $cee7ff159d524e18$var$th(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $cee7ff159d524e18$var$va:
                    return c.key === e ? k(a, b, c, d) : null;
                case $cee7ff159d524e18$var$wa:
                    return c.key === e ? l(a, b, c, d) : null;
                case $cee7ff159d524e18$var$Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if ($cee7ff159d524e18$var$eb(c) || $cee7ff159d524e18$var$Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            $cee7ff159d524e18$var$th(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case $cee7ff159d524e18$var$va:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case $cee7ff159d524e18$var$wa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case $cee7ff159d524e18$var$Ha:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if ($cee7ff159d524e18$var$eb(d) || $cee7ff159d524e18$var$Ka(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            $cee7ff159d524e18$var$th(b, d);
        }
        return null;
    }
    function n(e, g, h, k) {
        for(var l = null, m = null, u = g, w = g = 0, x = null; null !== u && w < h.length; w++){
            u.index > w ? (x = u, u = null) : x = u.sibling;
            var n = r(e, u, h[w], k);
            if (null === n) {
                null === u && (u = x);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? l = n : m.sibling = n;
            m = n;
            u = x;
        }
        if (w === h.length) return c(e, u), $cee7ff159d524e18$var$I && $cee7ff159d524e18$var$tg(e, w), l;
        if (null === u) {
            for(; w < h.length; w++)u = q(e, h[w], k), null !== u && (g = f(u, g, w), null === m ? l = u : m.sibling = u, m = u);
            $cee7ff159d524e18$var$I && $cee7ff159d524e18$var$tg(e, w);
            return l;
        }
        for(u = d(e, u); w < h.length; w++)x = y(u, e, w, h[w], k), null !== x && (a && null !== x.alternate && u.delete(null === x.key ? w : x.key), g = f(x, g, w), null === m ? l = x : m.sibling = x, m = x);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        $cee7ff159d524e18$var$I && $cee7ff159d524e18$var$tg(e, w);
        return l;
    }
    function t(e, g, h, k) {
        var l = $cee7ff159d524e18$var$Ka(h);
        if ("function" !== typeof l) throw Error($cee7ff159d524e18$var$p(150));
        h = l.call(h);
        if (null == h) throw Error($cee7ff159d524e18$var$p(151));
        for(var u = l = null, m = g, w = g = 0, x = null, n = h.next(); null !== m && !n.done; w++, n = h.next()){
            m.index > w ? (x = m, m = null) : x = m.sibling;
            var t = r(e, m, n.value, k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? l = t : u.sibling = t;
            u = t;
            m = x;
        }
        if (n.done) return c(e, m), $cee7ff159d524e18$var$I && $cee7ff159d524e18$var$tg(e, w), l;
        if (null === m) {
            for(; !n.done; w++, n = h.next())n = q(e, n.value, k), null !== n && (g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
            $cee7ff159d524e18$var$I && $cee7ff159d524e18$var$tg(e, w);
            return l;
        }
        for(m = d(e, m); !n.done; w++, n = h.next())n = y(m, e, w, n.value, k), null !== n && (a && null !== n.alternate && m.delete(null === n.key ? w : n.key), g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        $cee7ff159d524e18$var$I && $cee7ff159d524e18$var$tg(e, w);
        return l;
    }
    function J(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === $cee7ff159d524e18$var$ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case $cee7ff159d524e18$var$va:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === $cee7ff159d524e18$var$ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === $cee7ff159d524e18$var$Ha && $cee7ff159d524e18$var$uh(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = $cee7ff159d524e18$var$sh(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === $cee7ff159d524e18$var$ya ? (d = $cee7ff159d524e18$var$Ah(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $cee7ff159d524e18$var$yh(f.type, f.key, f.props, null, a.mode, h), h.ref = $cee7ff159d524e18$var$sh(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case $cee7ff159d524e18$var$wa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = $cee7ff159d524e18$var$zh(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case $cee7ff159d524e18$var$Ha:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if ($cee7ff159d524e18$var$eb(f)) return n(a, d, f, h);
            if ($cee7ff159d524e18$var$Ka(f)) return t(a, d, f, h);
            $cee7ff159d524e18$var$th(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = $cee7ff159d524e18$var$xh(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var $cee7ff159d524e18$var$Bh = $cee7ff159d524e18$var$vh(!0), $cee7ff159d524e18$var$Ch = $cee7ff159d524e18$var$vh(!1), $cee7ff159d524e18$var$Dh = {}, $cee7ff159d524e18$var$Eh = $cee7ff159d524e18$var$Uf($cee7ff159d524e18$var$Dh), $cee7ff159d524e18$var$Fh = $cee7ff159d524e18$var$Uf($cee7ff159d524e18$var$Dh), $cee7ff159d524e18$var$Gh = $cee7ff159d524e18$var$Uf($cee7ff159d524e18$var$Dh);
function $cee7ff159d524e18$var$Hh(a) {
    if (a === $cee7ff159d524e18$var$Dh) throw Error($cee7ff159d524e18$var$p(174));
    return a;
}
function $cee7ff159d524e18$var$Ih(a, b) {
    $cee7ff159d524e18$var$G($cee7ff159d524e18$var$Gh, b);
    $cee7ff159d524e18$var$G($cee7ff159d524e18$var$Fh, a);
    $cee7ff159d524e18$var$G($cee7ff159d524e18$var$Eh, $cee7ff159d524e18$var$Dh);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $cee7ff159d524e18$var$lb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $cee7ff159d524e18$var$lb(b, a);
    }
    $cee7ff159d524e18$var$E($cee7ff159d524e18$var$Eh);
    $cee7ff159d524e18$var$G($cee7ff159d524e18$var$Eh, b);
}
function $cee7ff159d524e18$var$Jh() {
    $cee7ff159d524e18$var$E($cee7ff159d524e18$var$Eh);
    $cee7ff159d524e18$var$E($cee7ff159d524e18$var$Fh);
    $cee7ff159d524e18$var$E($cee7ff159d524e18$var$Gh);
}
function $cee7ff159d524e18$var$Kh(a) {
    $cee7ff159d524e18$var$Hh($cee7ff159d524e18$var$Gh.current);
    var b = $cee7ff159d524e18$var$Hh($cee7ff159d524e18$var$Eh.current);
    var c = $cee7ff159d524e18$var$lb(b, a.type);
    b !== c && ($cee7ff159d524e18$var$G($cee7ff159d524e18$var$Fh, a), $cee7ff159d524e18$var$G($cee7ff159d524e18$var$Eh, c));
}
function $cee7ff159d524e18$var$Lh(a) {
    $cee7ff159d524e18$var$Fh.current === a && ($cee7ff159d524e18$var$E($cee7ff159d524e18$var$Eh), $cee7ff159d524e18$var$E($cee7ff159d524e18$var$Fh));
}
var $cee7ff159d524e18$var$M = $cee7ff159d524e18$var$Uf(0);
function $cee7ff159d524e18$var$Mh(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var $cee7ff159d524e18$var$Nh = [];
function $cee7ff159d524e18$var$Oh() {
    for(var a = 0; a < $cee7ff159d524e18$var$Nh.length; a++)$cee7ff159d524e18$var$Nh[a]._workInProgressVersionPrimary = null;
    $cee7ff159d524e18$var$Nh.length = 0;
}
var $cee7ff159d524e18$var$Ph = $cee7ff159d524e18$var$ua.ReactCurrentDispatcher, $cee7ff159d524e18$var$Qh = $cee7ff159d524e18$var$ua.ReactCurrentBatchConfig, $cee7ff159d524e18$var$Rh = 0, $cee7ff159d524e18$var$N = null, $cee7ff159d524e18$var$O = null, $cee7ff159d524e18$var$P = null, $cee7ff159d524e18$var$Sh = !1, $cee7ff159d524e18$var$Th = !1, $cee7ff159d524e18$var$Uh = 0, $cee7ff159d524e18$var$Vh = 0;
function $cee7ff159d524e18$var$Q() {
    throw Error($cee7ff159d524e18$var$p(321));
}
function $cee7ff159d524e18$var$Wh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$cee7ff159d524e18$var$He(a[c], b[c])) return !1;
    return !0;
}
function $cee7ff159d524e18$var$Xh(a, b, c, d, e, f) {
    $cee7ff159d524e18$var$Rh = f;
    $cee7ff159d524e18$var$N = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $cee7ff159d524e18$var$Ph.current = null === a || null === a.memoizedState ? $cee7ff159d524e18$var$Yh : $cee7ff159d524e18$var$Zh;
    a = c(d, e);
    if ($cee7ff159d524e18$var$Th) {
        f = 0;
        do {
            $cee7ff159d524e18$var$Th = !1;
            $cee7ff159d524e18$var$Uh = 0;
            if (25 <= f) throw Error($cee7ff159d524e18$var$p(301));
            f += 1;
            $cee7ff159d524e18$var$P = $cee7ff159d524e18$var$O = null;
            b.updateQueue = null;
            $cee7ff159d524e18$var$Ph.current = $cee7ff159d524e18$var$$h;
            a = c(d, e);
        }while ($cee7ff159d524e18$var$Th);
    }
    $cee7ff159d524e18$var$Ph.current = $cee7ff159d524e18$var$ai;
    b = null !== $cee7ff159d524e18$var$O && null !== $cee7ff159d524e18$var$O.next;
    $cee7ff159d524e18$var$Rh = 0;
    $cee7ff159d524e18$var$P = $cee7ff159d524e18$var$O = $cee7ff159d524e18$var$N = null;
    $cee7ff159d524e18$var$Sh = !1;
    if (b) throw Error($cee7ff159d524e18$var$p(300));
    return a;
}
function $cee7ff159d524e18$var$bi() {
    var a = 0 !== $cee7ff159d524e18$var$Uh;
    $cee7ff159d524e18$var$Uh = 0;
    return a;
}
function $cee7ff159d524e18$var$ci() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $cee7ff159d524e18$var$P ? $cee7ff159d524e18$var$N.memoizedState = $cee7ff159d524e18$var$P = a : $cee7ff159d524e18$var$P = $cee7ff159d524e18$var$P.next = a;
    return $cee7ff159d524e18$var$P;
}
function $cee7ff159d524e18$var$di() {
    if (null === $cee7ff159d524e18$var$O) {
        var a = $cee7ff159d524e18$var$N.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $cee7ff159d524e18$var$O.next;
    var b = null === $cee7ff159d524e18$var$P ? $cee7ff159d524e18$var$N.memoizedState : $cee7ff159d524e18$var$P.next;
    if (null !== b) $cee7ff159d524e18$var$P = b, $cee7ff159d524e18$var$O = a;
    else {
        if (null === a) throw Error($cee7ff159d524e18$var$p(310));
        $cee7ff159d524e18$var$O = a;
        a = {
            memoizedState: $cee7ff159d524e18$var$O.memoizedState,
            baseState: $cee7ff159d524e18$var$O.baseState,
            baseQueue: $cee7ff159d524e18$var$O.baseQueue,
            queue: $cee7ff159d524e18$var$O.queue,
            next: null
        };
        null === $cee7ff159d524e18$var$P ? $cee7ff159d524e18$var$N.memoizedState = $cee7ff159d524e18$var$P = a : $cee7ff159d524e18$var$P = $cee7ff159d524e18$var$P.next = a;
    }
    return $cee7ff159d524e18$var$P;
}
function $cee7ff159d524e18$var$ei(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $cee7ff159d524e18$var$fi(a) {
    var b = $cee7ff159d524e18$var$di(), c = b.queue;
    if (null === c) throw Error($cee7ff159d524e18$var$p(311));
    c.lastRenderedReducer = a;
    var d = $cee7ff159d524e18$var$O, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if (($cee7ff159d524e18$var$Rh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                $cee7ff159d524e18$var$N.lanes |= m;
                $cee7ff159d524e18$var$hh |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        $cee7ff159d524e18$var$He(d, b.memoizedState) || ($cee7ff159d524e18$var$Ug = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, $cee7ff159d524e18$var$N.lanes |= f, $cee7ff159d524e18$var$hh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $cee7ff159d524e18$var$gi(a) {
    var b = $cee7ff159d524e18$var$di(), c = b.queue;
    if (null === c) throw Error($cee7ff159d524e18$var$p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $cee7ff159d524e18$var$He(f, b.memoizedState) || ($cee7ff159d524e18$var$Ug = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $cee7ff159d524e18$var$hi() {}
function $cee7ff159d524e18$var$ii(a, b) {
    var c = $cee7ff159d524e18$var$N, d = $cee7ff159d524e18$var$di(), e = b(), f = !$cee7ff159d524e18$var$He(d.memoizedState, e);
    f && (d.memoizedState = e, $cee7ff159d524e18$var$Ug = !0);
    d = d.queue;
    $cee7ff159d524e18$var$ji($cee7ff159d524e18$var$ki.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== $cee7ff159d524e18$var$P && $cee7ff159d524e18$var$P.memoizedState.tag & 1) {
        c.flags |= 2048;
        $cee7ff159d524e18$var$li(9, $cee7ff159d524e18$var$mi.bind(null, c, d, e, b), void 0, null);
        if (null === $cee7ff159d524e18$var$R) throw Error($cee7ff159d524e18$var$p(349));
        0 !== ($cee7ff159d524e18$var$Rh & 30) || $cee7ff159d524e18$var$ni(c, b, e);
    }
    return e;
}
function $cee7ff159d524e18$var$ni(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = $cee7ff159d524e18$var$N.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $cee7ff159d524e18$var$N.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function $cee7ff159d524e18$var$mi(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    $cee7ff159d524e18$var$oi(b) && $cee7ff159d524e18$var$pi(a);
}
function $cee7ff159d524e18$var$ki(a, b, c) {
    return c(function() {
        $cee7ff159d524e18$var$oi(b) && $cee7ff159d524e18$var$pi(a);
    });
}
function $cee7ff159d524e18$var$oi(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !$cee7ff159d524e18$var$He(a, c);
    } catch (d) {
        return !0;
    }
}
function $cee7ff159d524e18$var$pi(a) {
    var b = $cee7ff159d524e18$var$Zg(a, 1);
    null !== b && $cee7ff159d524e18$var$mh(b, a, 1, -1);
}
function $cee7ff159d524e18$var$qi(a) {
    var b = $cee7ff159d524e18$var$ci();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $cee7ff159d524e18$var$ei,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = $cee7ff159d524e18$var$ri.bind(null, $cee7ff159d524e18$var$N, a);
    return [
        b.memoizedState,
        a
    ];
}
function $cee7ff159d524e18$var$li(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $cee7ff159d524e18$var$N.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $cee7ff159d524e18$var$N.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $cee7ff159d524e18$var$si() {
    return $cee7ff159d524e18$var$di().memoizedState;
}
function $cee7ff159d524e18$var$ti(a, b, c, d) {
    var e = $cee7ff159d524e18$var$ci();
    $cee7ff159d524e18$var$N.flags |= a;
    e.memoizedState = $cee7ff159d524e18$var$li(1 | b, c, void 0, void 0 === d ? null : d);
}
function $cee7ff159d524e18$var$ui(a, b, c, d) {
    var e = $cee7ff159d524e18$var$di();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $cee7ff159d524e18$var$O) {
        var g = $cee7ff159d524e18$var$O.memoizedState;
        f = g.destroy;
        if (null !== d && $cee7ff159d524e18$var$Wh(d, g.deps)) {
            e.memoizedState = $cee7ff159d524e18$var$li(b, c, f, d);
            return;
        }
    }
    $cee7ff159d524e18$var$N.flags |= a;
    e.memoizedState = $cee7ff159d524e18$var$li(1 | b, c, f, d);
}
function $cee7ff159d524e18$var$vi(a, b) {
    return $cee7ff159d524e18$var$ti(8390656, 8, a, b);
}
function $cee7ff159d524e18$var$ji(a, b) {
    return $cee7ff159d524e18$var$ui(2048, 8, a, b);
}
function $cee7ff159d524e18$var$wi(a, b) {
    return $cee7ff159d524e18$var$ui(4, 2, a, b);
}
function $cee7ff159d524e18$var$xi(a, b) {
    return $cee7ff159d524e18$var$ui(4, 4, a, b);
}
function $cee7ff159d524e18$var$yi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $cee7ff159d524e18$var$zi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $cee7ff159d524e18$var$ui(4, 4, $cee7ff159d524e18$var$yi.bind(null, b, a), c);
}
function $cee7ff159d524e18$var$Ai() {}
function $cee7ff159d524e18$var$Bi(a, b) {
    var c = $cee7ff159d524e18$var$di();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $cee7ff159d524e18$var$Wh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $cee7ff159d524e18$var$Ci(a, b) {
    var c = $cee7ff159d524e18$var$di();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $cee7ff159d524e18$var$Wh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $cee7ff159d524e18$var$Di(a, b, c) {
    if (0 === ($cee7ff159d524e18$var$Rh & 21)) return a.baseState && (a.baseState = !1, $cee7ff159d524e18$var$Ug = !0), a.memoizedState = c;
    $cee7ff159d524e18$var$He(c, b) || (c = $cee7ff159d524e18$var$yc(), $cee7ff159d524e18$var$N.lanes |= c, $cee7ff159d524e18$var$hh |= c, a.baseState = !0);
    return b;
}
function $cee7ff159d524e18$var$Ei(a, b) {
    var c = $cee7ff159d524e18$var$C;
    $cee7ff159d524e18$var$C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = $cee7ff159d524e18$var$Qh.transition;
    $cee7ff159d524e18$var$Qh.transition = {};
    try {
        a(!1), b();
    } finally{
        $cee7ff159d524e18$var$C = c, $cee7ff159d524e18$var$Qh.transition = d;
    }
}
function $cee7ff159d524e18$var$Fi() {
    return $cee7ff159d524e18$var$di().memoizedState;
}
function $cee7ff159d524e18$var$Gi(a, b, c) {
    var d = $cee7ff159d524e18$var$lh(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($cee7ff159d524e18$var$Hi(a)) $cee7ff159d524e18$var$Ii(b, c);
    else if (c = $cee7ff159d524e18$var$Yg(a, b, c, d), null !== c) {
        var e = $cee7ff159d524e18$var$L();
        $cee7ff159d524e18$var$mh(c, a, d, e);
        $cee7ff159d524e18$var$Ji(c, b, d);
    }
}
function $cee7ff159d524e18$var$ri(a, b, c) {
    var d = $cee7ff159d524e18$var$lh(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($cee7ff159d524e18$var$Hi(a)) $cee7ff159d524e18$var$Ii(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if ($cee7ff159d524e18$var$He(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, $cee7ff159d524e18$var$Xg(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = $cee7ff159d524e18$var$Yg(a, b, e, d);
        null !== c && (e = $cee7ff159d524e18$var$L(), $cee7ff159d524e18$var$mh(c, a, d, e), $cee7ff159d524e18$var$Ji(c, b, d));
    }
}
function $cee7ff159d524e18$var$Hi(a) {
    var b = a.alternate;
    return a === $cee7ff159d524e18$var$N || null !== b && b === $cee7ff159d524e18$var$N;
}
function $cee7ff159d524e18$var$Ii(a, b) {
    $cee7ff159d524e18$var$Th = $cee7ff159d524e18$var$Sh = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function $cee7ff159d524e18$var$Ji(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $cee7ff159d524e18$var$Cc(a, c);
    }
}
var $cee7ff159d524e18$var$ai = {
    readContext: $cee7ff159d524e18$var$Vg,
    useCallback: $cee7ff159d524e18$var$Q,
    useContext: $cee7ff159d524e18$var$Q,
    useEffect: $cee7ff159d524e18$var$Q,
    useImperativeHandle: $cee7ff159d524e18$var$Q,
    useInsertionEffect: $cee7ff159d524e18$var$Q,
    useLayoutEffect: $cee7ff159d524e18$var$Q,
    useMemo: $cee7ff159d524e18$var$Q,
    useReducer: $cee7ff159d524e18$var$Q,
    useRef: $cee7ff159d524e18$var$Q,
    useState: $cee7ff159d524e18$var$Q,
    useDebugValue: $cee7ff159d524e18$var$Q,
    useDeferredValue: $cee7ff159d524e18$var$Q,
    useTransition: $cee7ff159d524e18$var$Q,
    useMutableSource: $cee7ff159d524e18$var$Q,
    useSyncExternalStore: $cee7ff159d524e18$var$Q,
    useId: $cee7ff159d524e18$var$Q,
    unstable_isNewReconciler: !1
}, $cee7ff159d524e18$var$Yh = {
    readContext: $cee7ff159d524e18$var$Vg,
    useCallback: function(a, b) {
        $cee7ff159d524e18$var$ci().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $cee7ff159d524e18$var$Vg,
    useEffect: $cee7ff159d524e18$var$vi,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $cee7ff159d524e18$var$ti(4194308, 4, $cee7ff159d524e18$var$yi.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return $cee7ff159d524e18$var$ti(4194308, 4, a, b);
    },
    useInsertionEffect: function(a, b) {
        return $cee7ff159d524e18$var$ti(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = $cee7ff159d524e18$var$ci();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = $cee7ff159d524e18$var$ci();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = $cee7ff159d524e18$var$Gi.bind(null, $cee7ff159d524e18$var$N, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = $cee7ff159d524e18$var$ci();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: $cee7ff159d524e18$var$qi,
    useDebugValue: $cee7ff159d524e18$var$Ai,
    useDeferredValue: function(a) {
        return $cee7ff159d524e18$var$ci().memoizedState = a;
    },
    useTransition: function() {
        var a = $cee7ff159d524e18$var$qi(!1), b = a[0];
        a = $cee7ff159d524e18$var$Ei.bind(null, a[1]);
        $cee7ff159d524e18$var$ci().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function() {},
    useSyncExternalStore: function(a, b, c) {
        var d = $cee7ff159d524e18$var$N, e = $cee7ff159d524e18$var$ci();
        if ($cee7ff159d524e18$var$I) {
            if (void 0 === c) throw Error($cee7ff159d524e18$var$p(407));
            c = c();
        } else {
            c = b();
            if (null === $cee7ff159d524e18$var$R) throw Error($cee7ff159d524e18$var$p(349));
            0 !== ($cee7ff159d524e18$var$Rh & 30) || $cee7ff159d524e18$var$ni(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        $cee7ff159d524e18$var$vi($cee7ff159d524e18$var$ki.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        $cee7ff159d524e18$var$li(9, $cee7ff159d524e18$var$mi.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function() {
        var a = $cee7ff159d524e18$var$ci(), b = $cee7ff159d524e18$var$R.identifierPrefix;
        if ($cee7ff159d524e18$var$I) {
            var c = $cee7ff159d524e18$var$sg;
            var d = $cee7ff159d524e18$var$rg;
            c = (d & ~(1 << 32 - $cee7ff159d524e18$var$oc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = $cee7ff159d524e18$var$Uh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = $cee7ff159d524e18$var$Vh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, $cee7ff159d524e18$var$Zh = {
    readContext: $cee7ff159d524e18$var$Vg,
    useCallback: $cee7ff159d524e18$var$Bi,
    useContext: $cee7ff159d524e18$var$Vg,
    useEffect: $cee7ff159d524e18$var$ji,
    useImperativeHandle: $cee7ff159d524e18$var$zi,
    useInsertionEffect: $cee7ff159d524e18$var$wi,
    useLayoutEffect: $cee7ff159d524e18$var$xi,
    useMemo: $cee7ff159d524e18$var$Ci,
    useReducer: $cee7ff159d524e18$var$fi,
    useRef: $cee7ff159d524e18$var$si,
    useState: function() {
        return $cee7ff159d524e18$var$fi($cee7ff159d524e18$var$ei);
    },
    useDebugValue: $cee7ff159d524e18$var$Ai,
    useDeferredValue: function(a) {
        var b = $cee7ff159d524e18$var$di();
        return $cee7ff159d524e18$var$Di(b, $cee7ff159d524e18$var$O.memoizedState, a);
    },
    useTransition: function() {
        var a = $cee7ff159d524e18$var$fi($cee7ff159d524e18$var$ei)[0], b = $cee7ff159d524e18$var$di().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $cee7ff159d524e18$var$hi,
    useSyncExternalStore: $cee7ff159d524e18$var$ii,
    useId: $cee7ff159d524e18$var$Fi,
    unstable_isNewReconciler: !1
}, $cee7ff159d524e18$var$$h = {
    readContext: $cee7ff159d524e18$var$Vg,
    useCallback: $cee7ff159d524e18$var$Bi,
    useContext: $cee7ff159d524e18$var$Vg,
    useEffect: $cee7ff159d524e18$var$ji,
    useImperativeHandle: $cee7ff159d524e18$var$zi,
    useInsertionEffect: $cee7ff159d524e18$var$wi,
    useLayoutEffect: $cee7ff159d524e18$var$xi,
    useMemo: $cee7ff159d524e18$var$Ci,
    useReducer: $cee7ff159d524e18$var$gi,
    useRef: $cee7ff159d524e18$var$si,
    useState: function() {
        return $cee7ff159d524e18$var$gi($cee7ff159d524e18$var$ei);
    },
    useDebugValue: $cee7ff159d524e18$var$Ai,
    useDeferredValue: function(a) {
        var b = $cee7ff159d524e18$var$di();
        return null === $cee7ff159d524e18$var$O ? b.memoizedState = a : $cee7ff159d524e18$var$Di(b, $cee7ff159d524e18$var$O.memoizedState, a);
    },
    useTransition: function() {
        var a = $cee7ff159d524e18$var$gi($cee7ff159d524e18$var$ei)[0], b = $cee7ff159d524e18$var$di().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $cee7ff159d524e18$var$hi,
    useSyncExternalStore: $cee7ff159d524e18$var$ii,
    useId: $cee7ff159d524e18$var$Fi,
    unstable_isNewReconciler: !1
};
function $cee7ff159d524e18$var$Ki(a, b) {
    try {
        var c = "", d = b;
        do c += $cee7ff159d524e18$var$Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function $cee7ff159d524e18$var$Li(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function $cee7ff159d524e18$var$Mi(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var $cee7ff159d524e18$var$Ni = "function" === typeof WeakMap ? WeakMap : Map;
function $cee7ff159d524e18$var$Oi(a, b, c) {
    c = $cee7ff159d524e18$var$ch(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $cee7ff159d524e18$var$Pi || ($cee7ff159d524e18$var$Pi = !0, $cee7ff159d524e18$var$Qi = d);
        $cee7ff159d524e18$var$Mi(a, b);
    };
    return c;
}
function $cee7ff159d524e18$var$Ri(a, b, c) {
    c = $cee7ff159d524e18$var$ch(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            $cee7ff159d524e18$var$Mi(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        $cee7ff159d524e18$var$Mi(a, b);
        "function" !== typeof d && (null === $cee7ff159d524e18$var$Si ? $cee7ff159d524e18$var$Si = new Set([
            this
        ]) : $cee7ff159d524e18$var$Si.add(this));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
function $cee7ff159d524e18$var$Ti(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new $cee7ff159d524e18$var$Ni;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = $cee7ff159d524e18$var$Ui.bind(null, a, b, c), b.then(a, a));
}
function $cee7ff159d524e18$var$Vi(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function $cee7ff159d524e18$var$Wi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = $cee7ff159d524e18$var$ch(-1, 1), b.tag = 2, $cee7ff159d524e18$var$dh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var $cee7ff159d524e18$var$Xi = $cee7ff159d524e18$var$ua.ReactCurrentOwner, $cee7ff159d524e18$var$Ug = !1;
function $cee7ff159d524e18$var$Yi(a, b, c, d) {
    b.child = null === a ? $cee7ff159d524e18$var$Ch(b, null, c, d) : $cee7ff159d524e18$var$Bh(b, a.child, c, d);
}
function $cee7ff159d524e18$var$Zi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $cee7ff159d524e18$var$Tg(b, e);
    d = $cee7ff159d524e18$var$Xh(a, b, c, d, f, e);
    c = $cee7ff159d524e18$var$bi();
    if (null !== a && !$cee7ff159d524e18$var$Ug) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $cee7ff159d524e18$var$$i(a, b, e);
    $cee7ff159d524e18$var$I && c && $cee7ff159d524e18$var$vg(b);
    b.flags |= 1;
    $cee7ff159d524e18$var$Yi(a, b, d, e);
    return b.child;
}
function $cee7ff159d524e18$var$aj(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !$cee7ff159d524e18$var$bj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, $cee7ff159d524e18$var$cj(a, b, f, d, e);
        a = $cee7ff159d524e18$var$yh(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : $cee7ff159d524e18$var$Ie;
        if (c(g, d) && a.ref === b.ref) return $cee7ff159d524e18$var$$i(a, b, e);
    }
    b.flags |= 1;
    a = $cee7ff159d524e18$var$wh(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $cee7ff159d524e18$var$cj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if ($cee7ff159d524e18$var$Ie(f, d) && a.ref === b.ref) {
            if ($cee7ff159d524e18$var$Ug = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && ($cee7ff159d524e18$var$Ug = !0);
            else return b.lanes = a.lanes, $cee7ff159d524e18$var$$i(a, b, e);
        }
    }
    return $cee7ff159d524e18$var$dj(a, b, c, d, e);
}
function $cee7ff159d524e18$var$ej(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, $cee7ff159d524e18$var$G($cee7ff159d524e18$var$fj, $cee7ff159d524e18$var$gj), $cee7ff159d524e18$var$gj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, $cee7ff159d524e18$var$G($cee7ff159d524e18$var$fj, $cee7ff159d524e18$var$gj), $cee7ff159d524e18$var$gj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            $cee7ff159d524e18$var$G($cee7ff159d524e18$var$fj, $cee7ff159d524e18$var$gj);
            $cee7ff159d524e18$var$gj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, $cee7ff159d524e18$var$G($cee7ff159d524e18$var$fj, $cee7ff159d524e18$var$gj), $cee7ff159d524e18$var$gj |= d;
    $cee7ff159d524e18$var$Yi(a, b, e, c);
    return b.child;
}
function $cee7ff159d524e18$var$hj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function $cee7ff159d524e18$var$dj(a, b, c, d, e) {
    var f = $cee7ff159d524e18$var$Zf(c) ? $cee7ff159d524e18$var$Xf : $cee7ff159d524e18$var$H.current;
    f = $cee7ff159d524e18$var$Yf(b, f);
    $cee7ff159d524e18$var$Tg(b, e);
    c = $cee7ff159d524e18$var$Xh(a, b, c, d, f, e);
    d = $cee7ff159d524e18$var$bi();
    if (null !== a && !$cee7ff159d524e18$var$Ug) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $cee7ff159d524e18$var$$i(a, b, e);
    $cee7ff159d524e18$var$I && d && $cee7ff159d524e18$var$vg(b);
    b.flags |= 1;
    $cee7ff159d524e18$var$Yi(a, b, c, e);
    return b.child;
}
function $cee7ff159d524e18$var$ij(a, b, c, d, e) {
    if ($cee7ff159d524e18$var$Zf(c)) {
        var f = !0;
        $cee7ff159d524e18$var$cg(b);
    } else f = !1;
    $cee7ff159d524e18$var$Tg(b, e);
    if (null === b.stateNode) $cee7ff159d524e18$var$jj(a, b), $cee7ff159d524e18$var$ph(b, c, d), $cee7ff159d524e18$var$rh(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = $cee7ff159d524e18$var$Vg(l) : (l = $cee7ff159d524e18$var$Zf(c) ? $cee7ff159d524e18$var$Xf : $cee7ff159d524e18$var$H.current, l = $cee7ff159d524e18$var$Yf(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $cee7ff159d524e18$var$qh(b, g, d, l);
        $cee7ff159d524e18$var$$g = !1;
        var r = b.memoizedState;
        g.state = r;
        $cee7ff159d524e18$var$gh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || $cee7ff159d524e18$var$Wf.current || $cee7ff159d524e18$var$$g ? ("function" === typeof m && ($cee7ff159d524e18$var$kh(b, c, m, d), k = b.memoizedState), (h = $cee7ff159d524e18$var$$g || $cee7ff159d524e18$var$oh(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        $cee7ff159d524e18$var$bh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : $cee7ff159d524e18$var$Lg(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = $cee7ff159d524e18$var$Vg(k) : (k = $cee7ff159d524e18$var$Zf(c) ? $cee7ff159d524e18$var$Xf : $cee7ff159d524e18$var$H.current, k = $cee7ff159d524e18$var$Yf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && $cee7ff159d524e18$var$qh(b, g, d, k);
        $cee7ff159d524e18$var$$g = !1;
        r = b.memoizedState;
        g.state = r;
        $cee7ff159d524e18$var$gh(b, d, g, e);
        var n = b.memoizedState;
        h !== q || r !== n || $cee7ff159d524e18$var$Wf.current || $cee7ff159d524e18$var$$g ? ("function" === typeof y && ($cee7ff159d524e18$var$kh(b, c, y, d), n = b.memoizedState), (l = $cee7ff159d524e18$var$$g || $cee7ff159d524e18$var$oh(b, c, l, d, r, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return $cee7ff159d524e18$var$kj(a, b, c, d, f, e);
}
function $cee7ff159d524e18$var$kj(a, b, c, d, e, f) {
    $cee7ff159d524e18$var$hj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && $cee7ff159d524e18$var$dg(b, c, !1), $cee7ff159d524e18$var$$i(a, b, f);
    d = b.stateNode;
    $cee7ff159d524e18$var$Xi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = $cee7ff159d524e18$var$Bh(b, a.child, null, f), b.child = $cee7ff159d524e18$var$Bh(b, null, h, f)) : $cee7ff159d524e18$var$Yi(a, b, h, f);
    b.memoizedState = d.state;
    e && $cee7ff159d524e18$var$dg(b, c, !0);
    return b.child;
}
function $cee7ff159d524e18$var$lj(a) {
    var b = a.stateNode;
    b.pendingContext ? $cee7ff159d524e18$var$ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $cee7ff159d524e18$var$ag(a, b.context, !1);
    $cee7ff159d524e18$var$Ih(a, b.containerInfo);
}
function $cee7ff159d524e18$var$mj(a, b, c, d, e) {
    $cee7ff159d524e18$var$Ig();
    $cee7ff159d524e18$var$Jg(e);
    b.flags |= 256;
    $cee7ff159d524e18$var$Yi(a, b, c, d);
    return b.child;
}
var $cee7ff159d524e18$var$nj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $cee7ff159d524e18$var$oj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function $cee7ff159d524e18$var$pj(a, b, c) {
    var d = b.pendingProps, e = $cee7ff159d524e18$var$M.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    $cee7ff159d524e18$var$G($cee7ff159d524e18$var$M, e & 1);
    if (null === a) {
        $cee7ff159d524e18$var$Eg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = $cee7ff159d524e18$var$qj(g, d, 0, null), a = $cee7ff159d524e18$var$Ah(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = $cee7ff159d524e18$var$oj(c), b.memoizedState = $cee7ff159d524e18$var$nj, a) : $cee7ff159d524e18$var$rj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return $cee7ff159d524e18$var$sj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = $cee7ff159d524e18$var$wh(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = $cee7ff159d524e18$var$wh(h, f) : (f = $cee7ff159d524e18$var$Ah(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? $cee7ff159d524e18$var$oj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = $cee7ff159d524e18$var$nj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = $cee7ff159d524e18$var$wh(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function $cee7ff159d524e18$var$rj(a, b) {
    b = $cee7ff159d524e18$var$qj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function $cee7ff159d524e18$var$tj(a, b, c, d) {
    null !== d && $cee7ff159d524e18$var$Jg(d);
    $cee7ff159d524e18$var$Bh(b, a.child, null, c);
    a = $cee7ff159d524e18$var$rj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function $cee7ff159d524e18$var$sj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = $cee7ff159d524e18$var$Li(Error($cee7ff159d524e18$var$p(422))), $cee7ff159d524e18$var$tj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = $cee7ff159d524e18$var$qj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = $cee7ff159d524e18$var$Ah(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && $cee7ff159d524e18$var$Bh(b, a.child, null, g);
        b.child.memoizedState = $cee7ff159d524e18$var$oj(g);
        b.memoizedState = $cee7ff159d524e18$var$nj;
        return f;
    }
    if (0 === (b.mode & 1)) return $cee7ff159d524e18$var$tj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error($cee7ff159d524e18$var$p(419));
        d = $cee7ff159d524e18$var$Li(f, d, void 0);
        return $cee7ff159d524e18$var$tj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if ($cee7ff159d524e18$var$Ug || h) {
        d = $cee7ff159d524e18$var$R;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, $cee7ff159d524e18$var$Zg(a, e), $cee7ff159d524e18$var$mh(d, a, e, -1));
        }
        $cee7ff159d524e18$var$uj();
        d = $cee7ff159d524e18$var$Li(Error($cee7ff159d524e18$var$p(421)));
        return $cee7ff159d524e18$var$tj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = $cee7ff159d524e18$var$vj.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    $cee7ff159d524e18$var$yg = $cee7ff159d524e18$var$Lf(e.nextSibling);
    $cee7ff159d524e18$var$xg = b;
    $cee7ff159d524e18$var$I = !0;
    $cee7ff159d524e18$var$zg = null;
    null !== a && ($cee7ff159d524e18$var$og[$cee7ff159d524e18$var$pg++] = $cee7ff159d524e18$var$rg, $cee7ff159d524e18$var$og[$cee7ff159d524e18$var$pg++] = $cee7ff159d524e18$var$sg, $cee7ff159d524e18$var$og[$cee7ff159d524e18$var$pg++] = $cee7ff159d524e18$var$qg, $cee7ff159d524e18$var$rg = a.id, $cee7ff159d524e18$var$sg = a.overflow, $cee7ff159d524e18$var$qg = b);
    b = $cee7ff159d524e18$var$rj(b, d.children);
    b.flags |= 4096;
    return b;
}
function $cee7ff159d524e18$var$wj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    $cee7ff159d524e18$var$Sg(a.return, b, c);
}
function $cee7ff159d524e18$var$xj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function $cee7ff159d524e18$var$yj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $cee7ff159d524e18$var$Yi(a, b, d.children, c);
    d = $cee7ff159d524e18$var$M.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $cee7ff159d524e18$var$wj(a, c, b);
            else if (19 === a.tag) $cee7ff159d524e18$var$wj(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $cee7ff159d524e18$var$G($cee7ff159d524e18$var$M, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $cee7ff159d524e18$var$Mh(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $cee7ff159d524e18$var$xj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $cee7ff159d524e18$var$Mh(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $cee7ff159d524e18$var$xj(b, !0, c, null, f);
            break;
        case "together":
            $cee7ff159d524e18$var$xj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $cee7ff159d524e18$var$jj(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function $cee7ff159d524e18$var$$i(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $cee7ff159d524e18$var$hh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error($cee7ff159d524e18$var$p(153));
    if (null !== b.child) {
        a = b.child;
        c = $cee7ff159d524e18$var$wh(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $cee7ff159d524e18$var$wh(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function $cee7ff159d524e18$var$zj(a, b, c) {
    switch(b.tag){
        case 3:
            $cee7ff159d524e18$var$lj(b);
            $cee7ff159d524e18$var$Ig();
            break;
        case 5:
            $cee7ff159d524e18$var$Kh(b);
            break;
        case 1:
            $cee7ff159d524e18$var$Zf(b.type) && $cee7ff159d524e18$var$cg(b);
            break;
        case 4:
            $cee7ff159d524e18$var$Ih(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            $cee7ff159d524e18$var$G($cee7ff159d524e18$var$Mg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return $cee7ff159d524e18$var$G($cee7ff159d524e18$var$M, $cee7ff159d524e18$var$M.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return $cee7ff159d524e18$var$pj(a, b, c);
                $cee7ff159d524e18$var$G($cee7ff159d524e18$var$M, $cee7ff159d524e18$var$M.current & 1);
                a = $cee7ff159d524e18$var$$i(a, b, c);
                return null !== a ? a.sibling : null;
            }
            $cee7ff159d524e18$var$G($cee7ff159d524e18$var$M, $cee7ff159d524e18$var$M.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return $cee7ff159d524e18$var$yj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            $cee7ff159d524e18$var$G($cee7ff159d524e18$var$M, $cee7ff159d524e18$var$M.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, $cee7ff159d524e18$var$ej(a, b, c);
    }
    return $cee7ff159d524e18$var$$i(a, b, c);
}
var $cee7ff159d524e18$var$Aj, $cee7ff159d524e18$var$Bj, $cee7ff159d524e18$var$Cj, $cee7ff159d524e18$var$Dj;
$cee7ff159d524e18$var$Aj = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$cee7ff159d524e18$var$Bj = function() {};
$cee7ff159d524e18$var$Cj = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        $cee7ff159d524e18$var$Hh($cee7ff159d524e18$var$Eh.current);
        var f = null;
        switch(c){
            case "input":
                e = $cee7ff159d524e18$var$Ya(a, e);
                d = $cee7ff159d524e18$var$Ya(a, d);
                f = [];
                break;
            case "select":
                e = $cee7ff159d524e18$var$A({}, e, {
                    value: void 0
                });
                d = $cee7ff159d524e18$var$A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $cee7ff159d524e18$var$gb(a, e);
                d = $cee7ff159d524e18$var$gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $cee7ff159d524e18$var$Bf);
        }
        $cee7ff159d524e18$var$ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($cee7ff159d524e18$var$ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && ($cee7ff159d524e18$var$ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && $cee7ff159d524e18$var$D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
$cee7ff159d524e18$var$Dj = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function $cee7ff159d524e18$var$Ej(a, b) {
    if (!$cee7ff159d524e18$var$I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $cee7ff159d524e18$var$S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function $cee7ff159d524e18$var$Fj(a, b, c) {
    var d = b.pendingProps;
    $cee7ff159d524e18$var$wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $cee7ff159d524e18$var$S(b), null;
        case 1:
            return $cee7ff159d524e18$var$Zf(b.type) && $cee7ff159d524e18$var$$f(), $cee7ff159d524e18$var$S(b), null;
        case 3:
            d = b.stateNode;
            $cee7ff159d524e18$var$Jh();
            $cee7ff159d524e18$var$E($cee7ff159d524e18$var$Wf);
            $cee7ff159d524e18$var$E($cee7ff159d524e18$var$H);
            $cee7ff159d524e18$var$Oh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) $cee7ff159d524e18$var$Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== $cee7ff159d524e18$var$zg && ($cee7ff159d524e18$var$Gj($cee7ff159d524e18$var$zg), $cee7ff159d524e18$var$zg = null));
            $cee7ff159d524e18$var$Bj(a, b);
            $cee7ff159d524e18$var$S(b);
            return null;
        case 5:
            $cee7ff159d524e18$var$Lh(b);
            var e = $cee7ff159d524e18$var$Hh($cee7ff159d524e18$var$Gh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) $cee7ff159d524e18$var$Cj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($cee7ff159d524e18$var$p(166));
                    $cee7ff159d524e18$var$S(b);
                    return null;
                }
                a = $cee7ff159d524e18$var$Hh($cee7ff159d524e18$var$Eh.current);
                if ($cee7ff159d524e18$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[$cee7ff159d524e18$var$Of] = b;
                    d[$cee7ff159d524e18$var$Pf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            $cee7ff159d524e18$var$D("cancel", d);
                            $cee7ff159d524e18$var$D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $cee7ff159d524e18$var$D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < $cee7ff159d524e18$var$lf.length; e++)$cee7ff159d524e18$var$D($cee7ff159d524e18$var$lf[e], d);
                            break;
                        case "source":
                            $cee7ff159d524e18$var$D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $cee7ff159d524e18$var$D("error", d);
                            $cee7ff159d524e18$var$D("load", d);
                            break;
                        case "details":
                            $cee7ff159d524e18$var$D("toggle", d);
                            break;
                        case "input":
                            $cee7ff159d524e18$var$Za(d, f);
                            $cee7ff159d524e18$var$D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            $cee7ff159d524e18$var$D("invalid", d);
                            break;
                        case "textarea":
                            $cee7ff159d524e18$var$hb(d, f), $cee7ff159d524e18$var$D("invalid", d);
                    }
                    $cee7ff159d524e18$var$ub(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && $cee7ff159d524e18$var$Af(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && $cee7ff159d524e18$var$Af(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : $cee7ff159d524e18$var$ea.hasOwnProperty(g) && null != h && "onScroll" === g && $cee7ff159d524e18$var$D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            $cee7ff159d524e18$var$Va(d);
                            $cee7ff159d524e18$var$db(d, f, !0);
                            break;
                        case "textarea":
                            $cee7ff159d524e18$var$Va(d);
                            $cee7ff159d524e18$var$jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = $cee7ff159d524e18$var$Bf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = $cee7ff159d524e18$var$kb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script>\x3c/script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[$cee7ff159d524e18$var$Of] = b;
                    a[$cee7ff159d524e18$var$Pf] = d;
                    $cee7ff159d524e18$var$Aj(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = $cee7ff159d524e18$var$vb(c, d);
                        switch(c){
                            case "dialog":
                                $cee7ff159d524e18$var$D("cancel", a);
                                $cee7ff159d524e18$var$D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                $cee7ff159d524e18$var$D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < $cee7ff159d524e18$var$lf.length; e++)$cee7ff159d524e18$var$D($cee7ff159d524e18$var$lf[e], a);
                                e = d;
                                break;
                            case "source":
                                $cee7ff159d524e18$var$D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                $cee7ff159d524e18$var$D("error", a);
                                $cee7ff159d524e18$var$D("load", a);
                                e = d;
                                break;
                            case "details":
                                $cee7ff159d524e18$var$D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                $cee7ff159d524e18$var$Za(a, d);
                                e = $cee7ff159d524e18$var$Ya(a, d);
                                $cee7ff159d524e18$var$D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = $cee7ff159d524e18$var$A({}, d, {
                                    value: void 0
                                });
                                $cee7ff159d524e18$var$D("invalid", a);
                                break;
                            case "textarea":
                                $cee7ff159d524e18$var$hb(a, d);
                                e = $cee7ff159d524e18$var$gb(a, d);
                                $cee7ff159d524e18$var$D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        $cee7ff159d524e18$var$ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? $cee7ff159d524e18$var$sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && $cee7ff159d524e18$var$nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && $cee7ff159d524e18$var$ob(a, k) : "number" === typeof k && $cee7ff159d524e18$var$ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($cee7ff159d524e18$var$ea.hasOwnProperty(f) ? null != k && "onScroll" === f && $cee7ff159d524e18$var$D("scroll", a) : null != k && $cee7ff159d524e18$var$ta(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                $cee7ff159d524e18$var$Va(a);
                                $cee7ff159d524e18$var$db(a, d, !1);
                                break;
                            case "textarea":
                                $cee7ff159d524e18$var$Va(a);
                                $cee7ff159d524e18$var$jb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + $cee7ff159d524e18$var$Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? $cee7ff159d524e18$var$fb(a, !!d.multiple, f, !1) : null != d.defaultValue && $cee7ff159d524e18$var$fb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = $cee7ff159d524e18$var$Bf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            $cee7ff159d524e18$var$S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) $cee7ff159d524e18$var$Dj(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($cee7ff159d524e18$var$p(166));
                c = $cee7ff159d524e18$var$Hh($cee7ff159d524e18$var$Gh.current);
                $cee7ff159d524e18$var$Hh($cee7ff159d524e18$var$Eh.current);
                if ($cee7ff159d524e18$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[$cee7ff159d524e18$var$Of] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = $cee7ff159d524e18$var$xg, null !== a) switch(a.tag){
                            case 3:
                                $cee7ff159d524e18$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && $cee7ff159d524e18$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[$cee7ff159d524e18$var$Of] = b, b.stateNode = d;
            }
            $cee7ff159d524e18$var$S(b);
            return null;
        case 13:
            $cee7ff159d524e18$var$E($cee7ff159d524e18$var$M);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if ($cee7ff159d524e18$var$I && null !== $cee7ff159d524e18$var$yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) $cee7ff159d524e18$var$Hg(), $cee7ff159d524e18$var$Ig(), b.flags |= 98560, f = !1;
                else if (f = $cee7ff159d524e18$var$Gg(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error($cee7ff159d524e18$var$p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error($cee7ff159d524e18$var$p(317));
                        f[$cee7ff159d524e18$var$Of] = b;
                    } else $cee7ff159d524e18$var$Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    $cee7ff159d524e18$var$S(b);
                    f = !1;
                } else null !== $cee7ff159d524e18$var$zg && ($cee7ff159d524e18$var$Gj($cee7ff159d524e18$var$zg), $cee7ff159d524e18$var$zg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== ($cee7ff159d524e18$var$M.current & 1) ? 0 === $cee7ff159d524e18$var$T && ($cee7ff159d524e18$var$T = 3) : $cee7ff159d524e18$var$uj()));
            null !== b.updateQueue && (b.flags |= 4);
            $cee7ff159d524e18$var$S(b);
            return null;
        case 4:
            return $cee7ff159d524e18$var$Jh(), $cee7ff159d524e18$var$Bj(a, b), null === a && $cee7ff159d524e18$var$sf(b.stateNode.containerInfo), $cee7ff159d524e18$var$S(b), null;
        case 10:
            return $cee7ff159d524e18$var$Rg(b.type._context), $cee7ff159d524e18$var$S(b), null;
        case 17:
            return $cee7ff159d524e18$var$Zf(b.type) && $cee7ff159d524e18$var$$f(), $cee7ff159d524e18$var$S(b), null;
        case 19:
            $cee7ff159d524e18$var$E($cee7ff159d524e18$var$M);
            f = b.memoizedState;
            if (null === f) return $cee7ff159d524e18$var$S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) $cee7ff159d524e18$var$Ej(f, !1);
                else {
                    if (0 !== $cee7ff159d524e18$var$T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = $cee7ff159d524e18$var$Mh(a);
                        if (null !== g) {
                            b.flags |= 128;
                            $cee7ff159d524e18$var$Ej(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            $cee7ff159d524e18$var$G($cee7ff159d524e18$var$M, $cee7ff159d524e18$var$M.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && $cee7ff159d524e18$var$B() > $cee7ff159d524e18$var$Hj && (b.flags |= 128, d = !0, $cee7ff159d524e18$var$Ej(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = $cee7ff159d524e18$var$Mh(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), $cee7ff159d524e18$var$Ej(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !$cee7ff159d524e18$var$I) return $cee7ff159d524e18$var$S(b), null;
                    } else 2 * $cee7ff159d524e18$var$B() - f.renderingStartTime > $cee7ff159d524e18$var$Hj && 1073741824 !== c && (b.flags |= 128, d = !0, $cee7ff159d524e18$var$Ej(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = $cee7ff159d524e18$var$B(), b.sibling = null, c = $cee7ff159d524e18$var$M.current, $cee7ff159d524e18$var$G($cee7ff159d524e18$var$M, d ? c & 1 | 2 : c & 1), b;
            $cee7ff159d524e18$var$S(b);
            return null;
        case 22:
        case 23:
            return $cee7ff159d524e18$var$Ij(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== ($cee7ff159d524e18$var$gj & 1073741824) && ($cee7ff159d524e18$var$S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : $cee7ff159d524e18$var$S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error($cee7ff159d524e18$var$p(156, b.tag));
}
function $cee7ff159d524e18$var$Jj(a, b) {
    $cee7ff159d524e18$var$wg(b);
    switch(b.tag){
        case 1:
            return $cee7ff159d524e18$var$Zf(b.type) && $cee7ff159d524e18$var$$f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return $cee7ff159d524e18$var$Jh(), $cee7ff159d524e18$var$E($cee7ff159d524e18$var$Wf), $cee7ff159d524e18$var$E($cee7ff159d524e18$var$H), $cee7ff159d524e18$var$Oh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return $cee7ff159d524e18$var$Lh(b), null;
        case 13:
            $cee7ff159d524e18$var$E($cee7ff159d524e18$var$M);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error($cee7ff159d524e18$var$p(340));
                $cee7ff159d524e18$var$Ig();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return $cee7ff159d524e18$var$E($cee7ff159d524e18$var$M), null;
        case 4:
            return $cee7ff159d524e18$var$Jh(), null;
        case 10:
            return $cee7ff159d524e18$var$Rg(b.type._context), null;
        case 22:
        case 23:
            return $cee7ff159d524e18$var$Ij(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var $cee7ff159d524e18$var$Kj = !1, $cee7ff159d524e18$var$U = !1, $cee7ff159d524e18$var$Lj = "function" === typeof WeakSet ? WeakSet : Set, $cee7ff159d524e18$var$V = null;
function $cee7ff159d524e18$var$Mj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            $cee7ff159d524e18$var$W(a, b, d);
        }
        else c.current = null;
    }
}
function $cee7ff159d524e18$var$Nj(a, b, c) {
    try {
        c();
    } catch (d) {
        $cee7ff159d524e18$var$W(a, b, d);
    }
}
var $cee7ff159d524e18$var$Oj = !1;
function $cee7ff159d524e18$var$Pj(a, b) {
    $cee7ff159d524e18$var$Cf = $cee7ff159d524e18$var$dd;
    a = $cee7ff159d524e18$var$Me();
    if ($cee7ff159d524e18$var$Ne(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (F) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, q = a, r = null;
                b: for(;;){
                    for(var y;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (y = q.firstChild)) break;
                        r = q;
                        q = y;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++m === d && (k = g);
                        if (null !== (y = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    $cee7ff159d524e18$var$Df = {
        focusedElem: a,
        selectionRange: c
    };
    $cee7ff159d524e18$var$dd = !1;
    for($cee7ff159d524e18$var$V = b; null !== $cee7ff159d524e18$var$V;)if (b = $cee7ff159d524e18$var$V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, $cee7ff159d524e18$var$V = a;
    else for(; null !== $cee7ff159d524e18$var$V;){
        b = $cee7ff159d524e18$var$V;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var t = n.memoizedProps, J = n.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : $cee7ff159d524e18$var$Lg(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                    }
                    break;
                case 3:
                    var u = b.stateNode.containerInfo;
                    1 === u.nodeType ? u.textContent = "" : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error($cee7ff159d524e18$var$p(163));
            }
        } catch (F) {
            $cee7ff159d524e18$var$W(b, b.return, F);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            $cee7ff159d524e18$var$V = a;
            break;
        }
        $cee7ff159d524e18$var$V = b.return;
    }
    n = $cee7ff159d524e18$var$Oj;
    $cee7ff159d524e18$var$Oj = !1;
    return n;
}
function $cee7ff159d524e18$var$Qj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && $cee7ff159d524e18$var$Nj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function $cee7ff159d524e18$var$Rj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function $cee7ff159d524e18$var$Sj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function $cee7ff159d524e18$var$Tj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, $cee7ff159d524e18$var$Tj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[$cee7ff159d524e18$var$Of], delete b[$cee7ff159d524e18$var$Pf], delete b[$cee7ff159d524e18$var$of], delete b[$cee7ff159d524e18$var$Qf], delete b[$cee7ff159d524e18$var$Rf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function $cee7ff159d524e18$var$Uj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $cee7ff159d524e18$var$Vj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || $cee7ff159d524e18$var$Uj(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function $cee7ff159d524e18$var$Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $cee7ff159d524e18$var$Bf));
    else if (4 !== d && (a = a.child, null !== a)) for($cee7ff159d524e18$var$Wj(a, b, c), a = a.sibling; null !== a;)$cee7ff159d524e18$var$Wj(a, b, c), a = a.sibling;
}
function $cee7ff159d524e18$var$Xj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($cee7ff159d524e18$var$Xj(a, b, c), a = a.sibling; null !== a;)$cee7ff159d524e18$var$Xj(a, b, c), a = a.sibling;
}
var $cee7ff159d524e18$var$X = null, $cee7ff159d524e18$var$Yj = !1;
function $cee7ff159d524e18$var$Zj(a, b, c) {
    for(c = c.child; null !== c;)$cee7ff159d524e18$var$ak(a, b, c), c = c.sibling;
}
function $cee7ff159d524e18$var$ak(a, b, c) {
    if ($cee7ff159d524e18$var$lc && "function" === typeof $cee7ff159d524e18$var$lc.onCommitFiberUnmount) try {
        $cee7ff159d524e18$var$lc.onCommitFiberUnmount($cee7ff159d524e18$var$kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            $cee7ff159d524e18$var$U || $cee7ff159d524e18$var$Mj(c, b);
        case 6:
            var d = $cee7ff159d524e18$var$X, e = $cee7ff159d524e18$var$Yj;
            $cee7ff159d524e18$var$X = null;
            $cee7ff159d524e18$var$Zj(a, b, c);
            $cee7ff159d524e18$var$X = d;
            $cee7ff159d524e18$var$Yj = e;
            null !== $cee7ff159d524e18$var$X && ($cee7ff159d524e18$var$Yj ? (a = $cee7ff159d524e18$var$X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : $cee7ff159d524e18$var$X.removeChild(c.stateNode));
            break;
        case 18:
            null !== $cee7ff159d524e18$var$X && ($cee7ff159d524e18$var$Yj ? (a = $cee7ff159d524e18$var$X, c = c.stateNode, 8 === a.nodeType ? $cee7ff159d524e18$var$Kf(a.parentNode, c) : 1 === a.nodeType && $cee7ff159d524e18$var$Kf(a, c), $cee7ff159d524e18$var$bd(a)) : $cee7ff159d524e18$var$Kf($cee7ff159d524e18$var$X, c.stateNode));
            break;
        case 4:
            d = $cee7ff159d524e18$var$X;
            e = $cee7ff159d524e18$var$Yj;
            $cee7ff159d524e18$var$X = c.stateNode.containerInfo;
            $cee7ff159d524e18$var$Yj = !0;
            $cee7ff159d524e18$var$Zj(a, b, c);
            $cee7ff159d524e18$var$X = d;
            $cee7ff159d524e18$var$Yj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!$cee7ff159d524e18$var$U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? $cee7ff159d524e18$var$Nj(c, b, g) : 0 !== (f & 4) && $cee7ff159d524e18$var$Nj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            $cee7ff159d524e18$var$Zj(a, b, c);
            break;
        case 1:
            if (!$cee7ff159d524e18$var$U && ($cee7ff159d524e18$var$Mj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                $cee7ff159d524e18$var$W(c, b, h);
            }
            $cee7ff159d524e18$var$Zj(a, b, c);
            break;
        case 21:
            $cee7ff159d524e18$var$Zj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? ($cee7ff159d524e18$var$U = (d = $cee7ff159d524e18$var$U) || null !== c.memoizedState, $cee7ff159d524e18$var$Zj(a, b, c), $cee7ff159d524e18$var$U = d) : $cee7ff159d524e18$var$Zj(a, b, c);
            break;
        default:
            $cee7ff159d524e18$var$Zj(a, b, c);
    }
}
function $cee7ff159d524e18$var$bk(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $cee7ff159d524e18$var$Lj);
        b.forEach(function(b) {
            var d = $cee7ff159d524e18$var$ck.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function $cee7ff159d524e18$var$dk(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        $cee7ff159d524e18$var$X = h.stateNode;
                        $cee7ff159d524e18$var$Yj = !1;
                        break a;
                    case 3:
                        $cee7ff159d524e18$var$X = h.stateNode.containerInfo;
                        $cee7ff159d524e18$var$Yj = !0;
                        break a;
                    case 4:
                        $cee7ff159d524e18$var$X = h.stateNode.containerInfo;
                        $cee7ff159d524e18$var$Yj = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === $cee7ff159d524e18$var$X) throw Error($cee7ff159d524e18$var$p(160));
            $cee7ff159d524e18$var$ak(f, g, e);
            $cee7ff159d524e18$var$X = null;
            $cee7ff159d524e18$var$Yj = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            $cee7ff159d524e18$var$W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)$cee7ff159d524e18$var$ek(b, a), b = b.sibling;
}
function $cee7ff159d524e18$var$ek(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $cee7ff159d524e18$var$dk(b, a);
            $cee7ff159d524e18$var$fk(a);
            if (d & 4) {
                try {
                    $cee7ff159d524e18$var$Qj(3, a, a.return), $cee7ff159d524e18$var$Rj(3, a);
                } catch (t) {
                    $cee7ff159d524e18$var$W(a, a.return, t);
                }
                try {
                    $cee7ff159d524e18$var$Qj(5, a, a.return);
                } catch (t) {
                    $cee7ff159d524e18$var$W(a, a.return, t);
                }
            }
            break;
        case 1:
            $cee7ff159d524e18$var$dk(b, a);
            $cee7ff159d524e18$var$fk(a);
            d & 512 && null !== c && $cee7ff159d524e18$var$Mj(c, c.return);
            break;
        case 5:
            $cee7ff159d524e18$var$dk(b, a);
            $cee7ff159d524e18$var$fk(a);
            d & 512 && null !== c && $cee7ff159d524e18$var$Mj(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    $cee7ff159d524e18$var$ob(e, "");
                } catch (t) {
                    $cee7ff159d524e18$var$W(a, a.return, t);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && $cee7ff159d524e18$var$ab(e, f);
                    $cee7ff159d524e18$var$vb(h, g);
                    var l = $cee7ff159d524e18$var$vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var m = k[g], q = k[g + 1];
                        "style" === m ? $cee7ff159d524e18$var$sb(e, q) : "dangerouslySetInnerHTML" === m ? $cee7ff159d524e18$var$nb(e, q) : "children" === m ? $cee7ff159d524e18$var$ob(e, q) : $cee7ff159d524e18$var$ta(e, m, q, l);
                    }
                    switch(h){
                        case "input":
                            $cee7ff159d524e18$var$bb(e, f);
                            break;
                        case "textarea":
                            $cee7ff159d524e18$var$ib(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? $cee7ff159d524e18$var$fb(e, !!f.multiple, y, !1) : r !== !!f.multiple && (null != f.defaultValue ? $cee7ff159d524e18$var$fb(e, !!f.multiple, f.defaultValue, !0) : $cee7ff159d524e18$var$fb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[$cee7ff159d524e18$var$Pf] = f;
                } catch (t) {
                    $cee7ff159d524e18$var$W(a, a.return, t);
                }
            }
            break;
        case 6:
            $cee7ff159d524e18$var$dk(b, a);
            $cee7ff159d524e18$var$fk(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error($cee7ff159d524e18$var$p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (t) {
                    $cee7ff159d524e18$var$W(a, a.return, t);
                }
            }
            break;
        case 3:
            $cee7ff159d524e18$var$dk(b, a);
            $cee7ff159d524e18$var$fk(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                $cee7ff159d524e18$var$bd(b.containerInfo);
            } catch (t) {
                $cee7ff159d524e18$var$W(a, a.return, t);
            }
            break;
        case 4:
            $cee7ff159d524e18$var$dk(b, a);
            $cee7ff159d524e18$var$fk(a);
            break;
        case 13:
            $cee7ff159d524e18$var$dk(b, a);
            $cee7ff159d524e18$var$fk(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || ($cee7ff159d524e18$var$gk = $cee7ff159d524e18$var$B()));
            d & 4 && $cee7ff159d524e18$var$bk(a);
            break;
        case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? ($cee7ff159d524e18$var$U = (l = $cee7ff159d524e18$var$U) || m, $cee7ff159d524e18$var$dk(b, a), $cee7ff159d524e18$var$U = l) : $cee7ff159d524e18$var$dk(b, a);
            $cee7ff159d524e18$var$fk(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1)) for($cee7ff159d524e18$var$V = a, m = a.child; null !== m;){
                    for(q = $cee7ff159d524e18$var$V = m; null !== $cee7ff159d524e18$var$V;){
                        r = $cee7ff159d524e18$var$V;
                        y = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                $cee7ff159d524e18$var$Qj(4, r, r.return);
                                break;
                            case 1:
                                $cee7ff159d524e18$var$Mj(r, r.return);
                                var n = r.stateNode;
                                if ("function" === typeof n.componentWillUnmount) {
                                    d = r;
                                    c = r.return;
                                    try {
                                        b = d, n.props = b.memoizedProps, n.state = b.memoizedState, n.componentWillUnmount();
                                    } catch (t) {
                                        $cee7ff159d524e18$var$W(d, c, t);
                                    }
                                }
                                break;
                            case 5:
                                $cee7ff159d524e18$var$Mj(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    $cee7ff159d524e18$var$hk(q);
                                    continue;
                                }
                        }
                        null !== y ? (y.return = r, $cee7ff159d524e18$var$V = y) : $cee7ff159d524e18$var$hk(q);
                    }
                    m = m.sibling;
                }
                a: for(m = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === m) {
                            m = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = $cee7ff159d524e18$var$rb("display", g));
                            } catch (t) {
                                $cee7ff159d524e18$var$W(a, a.return, t);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === m) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (t) {
                            $cee7ff159d524e18$var$W(a, a.return, t);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        m === q && (m = null);
                        q = q.return;
                    }
                    m === q && (m = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            $cee7ff159d524e18$var$dk(b, a);
            $cee7ff159d524e18$var$fk(a);
            d & 4 && $cee7ff159d524e18$var$bk(a);
            break;
        case 21:
            break;
        default:
            $cee7ff159d524e18$var$dk(b, a), $cee7ff159d524e18$var$fk(a);
    }
}
function $cee7ff159d524e18$var$fk(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if ($cee7ff159d524e18$var$Uj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error($cee7ff159d524e18$var$p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && ($cee7ff159d524e18$var$ob(e, ""), d.flags &= -33);
                    var f = $cee7ff159d524e18$var$Vj(a);
                    $cee7ff159d524e18$var$Xj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = $cee7ff159d524e18$var$Vj(a);
                    $cee7ff159d524e18$var$Wj(a, h, g);
                    break;
                default:
                    throw Error($cee7ff159d524e18$var$p(161));
            }
        } catch (k) {
            $cee7ff159d524e18$var$W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function $cee7ff159d524e18$var$ik(a, b, c) {
    $cee7ff159d524e18$var$V = a;
    $cee7ff159d524e18$var$jk(a, b, c);
}
function $cee7ff159d524e18$var$jk(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== $cee7ff159d524e18$var$V;){
        var e = $cee7ff159d524e18$var$V, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || $cee7ff159d524e18$var$Kj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || $cee7ff159d524e18$var$U;
                h = $cee7ff159d524e18$var$Kj;
                var l = $cee7ff159d524e18$var$U;
                $cee7ff159d524e18$var$Kj = g;
                if (($cee7ff159d524e18$var$U = k) && !l) for($cee7ff159d524e18$var$V = e; null !== $cee7ff159d524e18$var$V;)g = $cee7ff159d524e18$var$V, k = g.child, 22 === g.tag && null !== g.memoizedState ? $cee7ff159d524e18$var$kk(e) : null !== k ? (k.return = g, $cee7ff159d524e18$var$V = k) : $cee7ff159d524e18$var$kk(e);
                for(; null !== f;)$cee7ff159d524e18$var$V = f, $cee7ff159d524e18$var$jk(f, b, c), f = f.sibling;
                $cee7ff159d524e18$var$V = e;
                $cee7ff159d524e18$var$Kj = h;
                $cee7ff159d524e18$var$U = l;
            }
            $cee7ff159d524e18$var$lk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, $cee7ff159d524e18$var$V = f) : $cee7ff159d524e18$var$lk(a, b, c);
    }
}
function $cee7ff159d524e18$var$lk(a) {
    for(; null !== $cee7ff159d524e18$var$V;){
        var b = $cee7ff159d524e18$var$V;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        $cee7ff159d524e18$var$U || $cee7ff159d524e18$var$Rj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !$cee7ff159d524e18$var$U) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : $cee7ff159d524e18$var$Lg(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && $cee7ff159d524e18$var$ih(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            $cee7ff159d524e18$var$ih(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var q = m.dehydrated;
                                    null !== q && $cee7ff159d524e18$var$bd(q);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error($cee7ff159d524e18$var$p(163));
                }
                $cee7ff159d524e18$var$U || b.flags & 512 && $cee7ff159d524e18$var$Sj(b);
            } catch (r) {
                $cee7ff159d524e18$var$W(b, b.return, r);
            }
        }
        if (b === a) {
            $cee7ff159d524e18$var$V = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $cee7ff159d524e18$var$V = c;
            break;
        }
        $cee7ff159d524e18$var$V = b.return;
    }
}
function $cee7ff159d524e18$var$hk(a) {
    for(; null !== $cee7ff159d524e18$var$V;){
        var b = $cee7ff159d524e18$var$V;
        if (b === a) {
            $cee7ff159d524e18$var$V = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $cee7ff159d524e18$var$V = c;
            break;
        }
        $cee7ff159d524e18$var$V = b.return;
    }
}
function $cee7ff159d524e18$var$kk(a) {
    for(; null !== $cee7ff159d524e18$var$V;){
        var b = $cee7ff159d524e18$var$V;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b.return;
                    try {
                        $cee7ff159d524e18$var$Rj(4, b);
                    } catch (k) {
                        $cee7ff159d524e18$var$W(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b.return;
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            $cee7ff159d524e18$var$W(b, e, k);
                        }
                    }
                    var f = b.return;
                    try {
                        $cee7ff159d524e18$var$Sj(b);
                    } catch (k) {
                        $cee7ff159d524e18$var$W(b, f, k);
                    }
                    break;
                case 5:
                    var g = b.return;
                    try {
                        $cee7ff159d524e18$var$Sj(b);
                    } catch (k) {
                        $cee7ff159d524e18$var$W(b, g, k);
                    }
            }
        } catch (k) {
            $cee7ff159d524e18$var$W(b, b.return, k);
        }
        if (b === a) {
            $cee7ff159d524e18$var$V = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h.return = b.return;
            $cee7ff159d524e18$var$V = h;
            break;
        }
        $cee7ff159d524e18$var$V = b.return;
    }
}
var $cee7ff159d524e18$var$mk = Math.ceil, $cee7ff159d524e18$var$nk = $cee7ff159d524e18$var$ua.ReactCurrentDispatcher, $cee7ff159d524e18$var$ok = $cee7ff159d524e18$var$ua.ReactCurrentOwner, $cee7ff159d524e18$var$pk = $cee7ff159d524e18$var$ua.ReactCurrentBatchConfig, $cee7ff159d524e18$var$K = 0, $cee7ff159d524e18$var$R = null, $cee7ff159d524e18$var$Y = null, $cee7ff159d524e18$var$Z = 0, $cee7ff159d524e18$var$gj = 0, $cee7ff159d524e18$var$fj = $cee7ff159d524e18$var$Uf(0), $cee7ff159d524e18$var$T = 0, $cee7ff159d524e18$var$qk = null, $cee7ff159d524e18$var$hh = 0, $cee7ff159d524e18$var$rk = 0, $cee7ff159d524e18$var$sk = 0, $cee7ff159d524e18$var$tk = null, $cee7ff159d524e18$var$uk = null, $cee7ff159d524e18$var$gk = 0, $cee7ff159d524e18$var$Hj = Infinity, $cee7ff159d524e18$var$vk = null, $cee7ff159d524e18$var$Pi = !1, $cee7ff159d524e18$var$Qi = null, $cee7ff159d524e18$var$Si = null, $cee7ff159d524e18$var$wk = !1, $cee7ff159d524e18$var$xk = null, $cee7ff159d524e18$var$yk = 0, $cee7ff159d524e18$var$zk = 0, $cee7ff159d524e18$var$Ak = null, $cee7ff159d524e18$var$Bk = -1, $cee7ff159d524e18$var$Ck = 0;
function $cee7ff159d524e18$var$L() {
    return 0 !== ($cee7ff159d524e18$var$K & 6) ? $cee7ff159d524e18$var$B() : -1 !== $cee7ff159d524e18$var$Bk ? $cee7ff159d524e18$var$Bk : $cee7ff159d524e18$var$Bk = $cee7ff159d524e18$var$B();
}
function $cee7ff159d524e18$var$lh(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== ($cee7ff159d524e18$var$K & 2) && 0 !== $cee7ff159d524e18$var$Z) return $cee7ff159d524e18$var$Z & -$cee7ff159d524e18$var$Z;
    if (null !== $cee7ff159d524e18$var$Kg.transition) return 0 === $cee7ff159d524e18$var$Ck && ($cee7ff159d524e18$var$Ck = $cee7ff159d524e18$var$yc()), $cee7ff159d524e18$var$Ck;
    a = $cee7ff159d524e18$var$C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : $cee7ff159d524e18$var$jd(a.type);
    return a;
}
function $cee7ff159d524e18$var$mh(a, b, c, d) {
    if (50 < $cee7ff159d524e18$var$zk) throw $cee7ff159d524e18$var$zk = 0, $cee7ff159d524e18$var$Ak = null, Error($cee7ff159d524e18$var$p(185));
    $cee7ff159d524e18$var$Ac(a, c, d);
    if (0 === ($cee7ff159d524e18$var$K & 2) || a !== $cee7ff159d524e18$var$R) a === $cee7ff159d524e18$var$R && (0 === ($cee7ff159d524e18$var$K & 2) && ($cee7ff159d524e18$var$rk |= c), 4 === $cee7ff159d524e18$var$T && $cee7ff159d524e18$var$Dk(a, $cee7ff159d524e18$var$Z)), $cee7ff159d524e18$var$Ek(a, d), 1 === c && 0 === $cee7ff159d524e18$var$K && 0 === (b.mode & 1) && ($cee7ff159d524e18$var$Hj = $cee7ff159d524e18$var$B() + 500, $cee7ff159d524e18$var$fg && $cee7ff159d524e18$var$jg());
}
function $cee7ff159d524e18$var$Ek(a, b) {
    var c = a.callbackNode;
    $cee7ff159d524e18$var$wc(a, b);
    var d = $cee7ff159d524e18$var$uc(a, a === $cee7ff159d524e18$var$R ? $cee7ff159d524e18$var$Z : 0);
    if (0 === d) null !== c && $cee7ff159d524e18$var$bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && $cee7ff159d524e18$var$bc(c);
        if (1 === b) 0 === a.tag ? $cee7ff159d524e18$var$ig($cee7ff159d524e18$var$Fk.bind(null, a)) : $cee7ff159d524e18$var$hg($cee7ff159d524e18$var$Fk.bind(null, a)), $cee7ff159d524e18$var$Jf(function() {
            0 === ($cee7ff159d524e18$var$K & 6) && $cee7ff159d524e18$var$jg();
        }), c = null;
        else {
            switch($cee7ff159d524e18$var$Dc(d)){
                case 1:
                    c = $cee7ff159d524e18$var$fc;
                    break;
                case 4:
                    c = $cee7ff159d524e18$var$gc;
                    break;
                case 16:
                    c = $cee7ff159d524e18$var$hc;
                    break;
                case 536870912:
                    c = $cee7ff159d524e18$var$jc;
                    break;
                default:
                    c = $cee7ff159d524e18$var$hc;
            }
            c = $cee7ff159d524e18$var$Gk(c, $cee7ff159d524e18$var$Hk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $cee7ff159d524e18$var$Hk(a, b) {
    $cee7ff159d524e18$var$Bk = -1;
    $cee7ff159d524e18$var$Ck = 0;
    if (0 !== ($cee7ff159d524e18$var$K & 6)) throw Error($cee7ff159d524e18$var$p(327));
    var c = a.callbackNode;
    if ($cee7ff159d524e18$var$Ik() && a.callbackNode !== c) return null;
    var d = $cee7ff159d524e18$var$uc(a, a === $cee7ff159d524e18$var$R ? $cee7ff159d524e18$var$Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = $cee7ff159d524e18$var$Jk(a, d);
    else {
        b = d;
        var e = $cee7ff159d524e18$var$K;
        $cee7ff159d524e18$var$K |= 2;
        var f = $cee7ff159d524e18$var$Kk();
        if ($cee7ff159d524e18$var$R !== a || $cee7ff159d524e18$var$Z !== b) $cee7ff159d524e18$var$vk = null, $cee7ff159d524e18$var$Hj = $cee7ff159d524e18$var$B() + 500, $cee7ff159d524e18$var$Lk(a, b);
        for(;;)try {
            $cee7ff159d524e18$var$Mk();
            break;
        } catch (h) {
            $cee7ff159d524e18$var$Nk(a, h);
        }
        $cee7ff159d524e18$var$Qg();
        $cee7ff159d524e18$var$nk.current = f;
        $cee7ff159d524e18$var$K = e;
        null !== $cee7ff159d524e18$var$Y ? b = 0 : ($cee7ff159d524e18$var$R = null, $cee7ff159d524e18$var$Z = 0, b = $cee7ff159d524e18$var$T);
    }
    if (0 !== b) {
        2 === b && (e = $cee7ff159d524e18$var$xc(a), 0 !== e && (d = e, b = $cee7ff159d524e18$var$Ok(a, e)));
        if (1 === b) throw c = $cee7ff159d524e18$var$qk, $cee7ff159d524e18$var$Lk(a, 0), $cee7ff159d524e18$var$Dk(a, d), $cee7ff159d524e18$var$Ek(a, $cee7ff159d524e18$var$B()), c;
        if (6 === b) $cee7ff159d524e18$var$Dk(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !$cee7ff159d524e18$var$Pk(e) && (b = $cee7ff159d524e18$var$Jk(a, d), 2 === b && (f = $cee7ff159d524e18$var$xc(a), 0 !== f && (d = f, b = $cee7ff159d524e18$var$Ok(a, f))), 1 === b)) throw c = $cee7ff159d524e18$var$qk, $cee7ff159d524e18$var$Lk(a, 0), $cee7ff159d524e18$var$Dk(a, d), $cee7ff159d524e18$var$Ek(a, $cee7ff159d524e18$var$B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error($cee7ff159d524e18$var$p(345));
                case 2:
                    $cee7ff159d524e18$var$Qk(a, $cee7ff159d524e18$var$uk, $cee7ff159d524e18$var$vk);
                    break;
                case 3:
                    $cee7ff159d524e18$var$Dk(a, d);
                    if ((d & 130023424) === d && (b = $cee7ff159d524e18$var$gk + 500 - $cee7ff159d524e18$var$B(), 10 < b)) {
                        if (0 !== $cee7ff159d524e18$var$uc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            $cee7ff159d524e18$var$L();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = $cee7ff159d524e18$var$Ff($cee7ff159d524e18$var$Qk.bind(null, a, $cee7ff159d524e18$var$uk, $cee7ff159d524e18$var$vk), b);
                        break;
                    }
                    $cee7ff159d524e18$var$Qk(a, $cee7ff159d524e18$var$uk, $cee7ff159d524e18$var$vk);
                    break;
                case 4:
                    $cee7ff159d524e18$var$Dk(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - $cee7ff159d524e18$var$oc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = $cee7ff159d524e18$var$B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * $cee7ff159d524e18$var$mk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = $cee7ff159d524e18$var$Ff($cee7ff159d524e18$var$Qk.bind(null, a, $cee7ff159d524e18$var$uk, $cee7ff159d524e18$var$vk), d);
                        break;
                    }
                    $cee7ff159d524e18$var$Qk(a, $cee7ff159d524e18$var$uk, $cee7ff159d524e18$var$vk);
                    break;
                case 5:
                    $cee7ff159d524e18$var$Qk(a, $cee7ff159d524e18$var$uk, $cee7ff159d524e18$var$vk);
                    break;
                default:
                    throw Error($cee7ff159d524e18$var$p(329));
            }
        }
    }
    $cee7ff159d524e18$var$Ek(a, $cee7ff159d524e18$var$B());
    return a.callbackNode === c ? $cee7ff159d524e18$var$Hk.bind(null, a) : null;
}
function $cee7ff159d524e18$var$Ok(a, b) {
    var c = $cee7ff159d524e18$var$tk;
    a.current.memoizedState.isDehydrated && ($cee7ff159d524e18$var$Lk(a, b).flags |= 256);
    a = $cee7ff159d524e18$var$Jk(a, b);
    2 !== a && (b = $cee7ff159d524e18$var$uk, $cee7ff159d524e18$var$uk = c, null !== b && $cee7ff159d524e18$var$Gj(b));
    return a;
}
function $cee7ff159d524e18$var$Gj(a) {
    null === $cee7ff159d524e18$var$uk ? $cee7ff159d524e18$var$uk = a : $cee7ff159d524e18$var$uk.push.apply($cee7ff159d524e18$var$uk, a);
}
function $cee7ff159d524e18$var$Pk(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!$cee7ff159d524e18$var$He(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function $cee7ff159d524e18$var$Dk(a, b) {
    b &= ~$cee7ff159d524e18$var$sk;
    b &= ~$cee7ff159d524e18$var$rk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $cee7ff159d524e18$var$oc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $cee7ff159d524e18$var$Fk(a) {
    if (0 !== ($cee7ff159d524e18$var$K & 6)) throw Error($cee7ff159d524e18$var$p(327));
    $cee7ff159d524e18$var$Ik();
    var b = $cee7ff159d524e18$var$uc(a, 0);
    if (0 === (b & 1)) return $cee7ff159d524e18$var$Ek(a, $cee7ff159d524e18$var$B()), null;
    var c = $cee7ff159d524e18$var$Jk(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = $cee7ff159d524e18$var$xc(a);
        0 !== d && (b = d, c = $cee7ff159d524e18$var$Ok(a, d));
    }
    if (1 === c) throw c = $cee7ff159d524e18$var$qk, $cee7ff159d524e18$var$Lk(a, 0), $cee7ff159d524e18$var$Dk(a, b), $cee7ff159d524e18$var$Ek(a, $cee7ff159d524e18$var$B()), c;
    if (6 === c) throw Error($cee7ff159d524e18$var$p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $cee7ff159d524e18$var$Qk(a, $cee7ff159d524e18$var$uk, $cee7ff159d524e18$var$vk);
    $cee7ff159d524e18$var$Ek(a, $cee7ff159d524e18$var$B());
    return null;
}
function $cee7ff159d524e18$var$Rk(a, b) {
    var c = $cee7ff159d524e18$var$K;
    $cee7ff159d524e18$var$K |= 1;
    try {
        return a(b);
    } finally{
        $cee7ff159d524e18$var$K = c, 0 === $cee7ff159d524e18$var$K && ($cee7ff159d524e18$var$Hj = $cee7ff159d524e18$var$B() + 500, $cee7ff159d524e18$var$fg && $cee7ff159d524e18$var$jg());
    }
}
function $cee7ff159d524e18$var$Sk(a) {
    null !== $cee7ff159d524e18$var$xk && 0 === $cee7ff159d524e18$var$xk.tag && 0 === ($cee7ff159d524e18$var$K & 6) && $cee7ff159d524e18$var$Ik();
    var b = $cee7ff159d524e18$var$K;
    $cee7ff159d524e18$var$K |= 1;
    var c = $cee7ff159d524e18$var$pk.transition, d = $cee7ff159d524e18$var$C;
    try {
        if ($cee7ff159d524e18$var$pk.transition = null, $cee7ff159d524e18$var$C = 1, a) return a();
    } finally{
        $cee7ff159d524e18$var$C = d, $cee7ff159d524e18$var$pk.transition = c, $cee7ff159d524e18$var$K = b, 0 === ($cee7ff159d524e18$var$K & 6) && $cee7ff159d524e18$var$jg();
    }
}
function $cee7ff159d524e18$var$Ij() {
    $cee7ff159d524e18$var$gj = $cee7ff159d524e18$var$fj.current;
    $cee7ff159d524e18$var$E($cee7ff159d524e18$var$fj);
}
function $cee7ff159d524e18$var$Lk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $cee7ff159d524e18$var$Gf(c));
    if (null !== $cee7ff159d524e18$var$Y) for(c = $cee7ff159d524e18$var$Y.return; null !== c;){
        var d = c;
        $cee7ff159d524e18$var$wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $cee7ff159d524e18$var$$f();
                break;
            case 3:
                $cee7ff159d524e18$var$Jh();
                $cee7ff159d524e18$var$E($cee7ff159d524e18$var$Wf);
                $cee7ff159d524e18$var$E($cee7ff159d524e18$var$H);
                $cee7ff159d524e18$var$Oh();
                break;
            case 5:
                $cee7ff159d524e18$var$Lh(d);
                break;
            case 4:
                $cee7ff159d524e18$var$Jh();
                break;
            case 13:
                $cee7ff159d524e18$var$E($cee7ff159d524e18$var$M);
                break;
            case 19:
                $cee7ff159d524e18$var$E($cee7ff159d524e18$var$M);
                break;
            case 10:
                $cee7ff159d524e18$var$Rg(d.type._context);
                break;
            case 22:
            case 23:
                $cee7ff159d524e18$var$Ij();
        }
        c = c.return;
    }
    $cee7ff159d524e18$var$R = a;
    $cee7ff159d524e18$var$Y = a = $cee7ff159d524e18$var$wh(a.current, null);
    $cee7ff159d524e18$var$Z = $cee7ff159d524e18$var$gj = b;
    $cee7ff159d524e18$var$T = 0;
    $cee7ff159d524e18$var$qk = null;
    $cee7ff159d524e18$var$sk = $cee7ff159d524e18$var$rk = $cee7ff159d524e18$var$hh = 0;
    $cee7ff159d524e18$var$uk = $cee7ff159d524e18$var$tk = null;
    if (null !== $cee7ff159d524e18$var$Wg) {
        for(b = 0; b < $cee7ff159d524e18$var$Wg.length; b++)if (c = $cee7ff159d524e18$var$Wg[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        $cee7ff159d524e18$var$Wg = null;
    }
    return a;
}
function $cee7ff159d524e18$var$Nk(a, b) {
    do {
        var c = $cee7ff159d524e18$var$Y;
        try {
            $cee7ff159d524e18$var$Qg();
            $cee7ff159d524e18$var$Ph.current = $cee7ff159d524e18$var$ai;
            if ($cee7ff159d524e18$var$Sh) {
                for(var d = $cee7ff159d524e18$var$N.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                $cee7ff159d524e18$var$Sh = !1;
            }
            $cee7ff159d524e18$var$Rh = 0;
            $cee7ff159d524e18$var$P = $cee7ff159d524e18$var$O = $cee7ff159d524e18$var$N = null;
            $cee7ff159d524e18$var$Th = !1;
            $cee7ff159d524e18$var$Uh = 0;
            $cee7ff159d524e18$var$ok.current = null;
            if (null === c || null === c.return) {
                $cee7ff159d524e18$var$T = 1;
                $cee7ff159d524e18$var$qk = b;
                $cee7ff159d524e18$var$Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = $cee7ff159d524e18$var$Z;
                h.flags |= 32768;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k, m = h, q = m.tag;
                    if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = m.alternate;
                        r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = $cee7ff159d524e18$var$Vi(g);
                    if (null !== y) {
                        y.flags &= -257;
                        $cee7ff159d524e18$var$Wi(y, g, h, f, b);
                        y.mode & 1 && $cee7ff159d524e18$var$Ti(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var t = new Set;
                            t.add(k);
                            b.updateQueue = t;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            $cee7ff159d524e18$var$Ti(f, l, b);
                            $cee7ff159d524e18$var$uj();
                            break a;
                        }
                        k = Error($cee7ff159d524e18$var$p(426));
                    }
                } else if ($cee7ff159d524e18$var$I && h.mode & 1) {
                    var J = $cee7ff159d524e18$var$Vi(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        $cee7ff159d524e18$var$Wi(J, g, h, f, b);
                        $cee7ff159d524e18$var$Jg($cee7ff159d524e18$var$Ki(k, h));
                        break a;
                    }
                }
                f = k = $cee7ff159d524e18$var$Ki(k, h);
                4 !== $cee7ff159d524e18$var$T && ($cee7ff159d524e18$var$T = 2);
                null === $cee7ff159d524e18$var$tk ? $cee7ff159d524e18$var$tk = [
                    f
                ] : $cee7ff159d524e18$var$tk.push(f);
                f = g;
                do {
                    switch(f.tag){
                        case 3:
                            f.flags |= 65536;
                            b &= -b;
                            f.lanes |= b;
                            var x = $cee7ff159d524e18$var$Oi(f, k, b);
                            $cee7ff159d524e18$var$fh(f, x);
                            break a;
                        case 1:
                            h = k;
                            var w = f.type, u = f.stateNode;
                            if (0 === (f.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === $cee7ff159d524e18$var$Si || !$cee7ff159d524e18$var$Si.has(u)))) {
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var F = $cee7ff159d524e18$var$Ri(f, h, b);
                                $cee7ff159d524e18$var$fh(f, F);
                                break a;
                            }
                    }
                    f = f.return;
                }while (null !== f);
            }
            $cee7ff159d524e18$var$Tk(c);
        } catch (na) {
            b = na;
            $cee7ff159d524e18$var$Y === c && null !== c && ($cee7ff159d524e18$var$Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function $cee7ff159d524e18$var$Kk() {
    var a = $cee7ff159d524e18$var$nk.current;
    $cee7ff159d524e18$var$nk.current = $cee7ff159d524e18$var$ai;
    return null === a ? $cee7ff159d524e18$var$ai : a;
}
function $cee7ff159d524e18$var$uj() {
    if (0 === $cee7ff159d524e18$var$T || 3 === $cee7ff159d524e18$var$T || 2 === $cee7ff159d524e18$var$T) $cee7ff159d524e18$var$T = 4;
    null === $cee7ff159d524e18$var$R || 0 === ($cee7ff159d524e18$var$hh & 268435455) && 0 === ($cee7ff159d524e18$var$rk & 268435455) || $cee7ff159d524e18$var$Dk($cee7ff159d524e18$var$R, $cee7ff159d524e18$var$Z);
}
function $cee7ff159d524e18$var$Jk(a, b) {
    var c = $cee7ff159d524e18$var$K;
    $cee7ff159d524e18$var$K |= 2;
    var d = $cee7ff159d524e18$var$Kk();
    if ($cee7ff159d524e18$var$R !== a || $cee7ff159d524e18$var$Z !== b) $cee7ff159d524e18$var$vk = null, $cee7ff159d524e18$var$Lk(a, b);
    for(;;)try {
        $cee7ff159d524e18$var$Uk();
        break;
    } catch (e) {
        $cee7ff159d524e18$var$Nk(a, e);
    }
    $cee7ff159d524e18$var$Qg();
    $cee7ff159d524e18$var$K = c;
    $cee7ff159d524e18$var$nk.current = d;
    if (null !== $cee7ff159d524e18$var$Y) throw Error($cee7ff159d524e18$var$p(261));
    $cee7ff159d524e18$var$R = null;
    $cee7ff159d524e18$var$Z = 0;
    return $cee7ff159d524e18$var$T;
}
function $cee7ff159d524e18$var$Uk() {
    for(; null !== $cee7ff159d524e18$var$Y;)$cee7ff159d524e18$var$Vk($cee7ff159d524e18$var$Y);
}
function $cee7ff159d524e18$var$Mk() {
    for(; null !== $cee7ff159d524e18$var$Y && !$cee7ff159d524e18$var$cc();)$cee7ff159d524e18$var$Vk($cee7ff159d524e18$var$Y);
}
function $cee7ff159d524e18$var$Vk(a) {
    var b = $cee7ff159d524e18$var$Wk(a.alternate, a, $cee7ff159d524e18$var$gj);
    a.memoizedProps = a.pendingProps;
    null === b ? $cee7ff159d524e18$var$Tk(a) : $cee7ff159d524e18$var$Y = b;
    $cee7ff159d524e18$var$ok.current = null;
}
function $cee7ff159d524e18$var$Tk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (c = $cee7ff159d524e18$var$Fj(c, b, $cee7ff159d524e18$var$gj), null !== c) {
                $cee7ff159d524e18$var$Y = c;
                return;
            }
        } else {
            c = $cee7ff159d524e18$var$Jj(c, b);
            if (null !== c) {
                c.flags &= 32767;
                $cee7ff159d524e18$var$Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                $cee7ff159d524e18$var$T = 6;
                $cee7ff159d524e18$var$Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            $cee7ff159d524e18$var$Y = b;
            return;
        }
        $cee7ff159d524e18$var$Y = b = a;
    }while (null !== b);
    0 === $cee7ff159d524e18$var$T && ($cee7ff159d524e18$var$T = 5);
}
function $cee7ff159d524e18$var$Qk(a, b, c) {
    var d = $cee7ff159d524e18$var$C, e = $cee7ff159d524e18$var$pk.transition;
    try {
        $cee7ff159d524e18$var$pk.transition = null, $cee7ff159d524e18$var$C = 1, $cee7ff159d524e18$var$Xk(a, b, c, d);
    } finally{
        $cee7ff159d524e18$var$pk.transition = e, $cee7ff159d524e18$var$C = d;
    }
    return null;
}
function $cee7ff159d524e18$var$Xk(a, b, c, d) {
    do $cee7ff159d524e18$var$Ik();
    while (null !== $cee7ff159d524e18$var$xk);
    if (0 !== ($cee7ff159d524e18$var$K & 6)) throw Error($cee7ff159d524e18$var$p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error($cee7ff159d524e18$var$p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    $cee7ff159d524e18$var$Bc(a, f);
    a === $cee7ff159d524e18$var$R && ($cee7ff159d524e18$var$Y = $cee7ff159d524e18$var$R = null, $cee7ff159d524e18$var$Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || $cee7ff159d524e18$var$wk || ($cee7ff159d524e18$var$wk = !0, $cee7ff159d524e18$var$Gk($cee7ff159d524e18$var$hc, function() {
        $cee7ff159d524e18$var$Ik();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = $cee7ff159d524e18$var$pk.transition;
        $cee7ff159d524e18$var$pk.transition = null;
        var g = $cee7ff159d524e18$var$C;
        $cee7ff159d524e18$var$C = 1;
        var h = $cee7ff159d524e18$var$K;
        $cee7ff159d524e18$var$K |= 4;
        $cee7ff159d524e18$var$ok.current = null;
        $cee7ff159d524e18$var$Pj(a, c);
        $cee7ff159d524e18$var$ek(c, a);
        $cee7ff159d524e18$var$Oe($cee7ff159d524e18$var$Df);
        $cee7ff159d524e18$var$dd = !!$cee7ff159d524e18$var$Cf;
        $cee7ff159d524e18$var$Df = $cee7ff159d524e18$var$Cf = null;
        a.current = c;
        $cee7ff159d524e18$var$ik(c, a, e);
        $cee7ff159d524e18$var$dc();
        $cee7ff159d524e18$var$K = h;
        $cee7ff159d524e18$var$C = g;
        $cee7ff159d524e18$var$pk.transition = f;
    } else a.current = c;
    $cee7ff159d524e18$var$wk && ($cee7ff159d524e18$var$wk = !1, $cee7ff159d524e18$var$xk = a, $cee7ff159d524e18$var$yk = e);
    f = a.pendingLanes;
    0 === f && ($cee7ff159d524e18$var$Si = null);
    $cee7ff159d524e18$var$mc(c.stateNode, d);
    $cee7ff159d524e18$var$Ek(a, $cee7ff159d524e18$var$B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if ($cee7ff159d524e18$var$Pi) throw $cee7ff159d524e18$var$Pi = !1, a = $cee7ff159d524e18$var$Qi, $cee7ff159d524e18$var$Qi = null, a;
    0 !== ($cee7ff159d524e18$var$yk & 1) && 0 !== a.tag && $cee7ff159d524e18$var$Ik();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === $cee7ff159d524e18$var$Ak ? $cee7ff159d524e18$var$zk++ : ($cee7ff159d524e18$var$zk = 0, $cee7ff159d524e18$var$Ak = a) : $cee7ff159d524e18$var$zk = 0;
    $cee7ff159d524e18$var$jg();
    return null;
}
function $cee7ff159d524e18$var$Ik() {
    if (null !== $cee7ff159d524e18$var$xk) {
        var a = $cee7ff159d524e18$var$Dc($cee7ff159d524e18$var$yk), b = $cee7ff159d524e18$var$pk.transition, c = $cee7ff159d524e18$var$C;
        try {
            $cee7ff159d524e18$var$pk.transition = null;
            $cee7ff159d524e18$var$C = 16 > a ? 16 : a;
            if (null === $cee7ff159d524e18$var$xk) var d = !1;
            else {
                a = $cee7ff159d524e18$var$xk;
                $cee7ff159d524e18$var$xk = null;
                $cee7ff159d524e18$var$yk = 0;
                if (0 !== ($cee7ff159d524e18$var$K & 6)) throw Error($cee7ff159d524e18$var$p(331));
                var e = $cee7ff159d524e18$var$K;
                $cee7ff159d524e18$var$K |= 4;
                for($cee7ff159d524e18$var$V = a.current; null !== $cee7ff159d524e18$var$V;){
                    var f = $cee7ff159d524e18$var$V, g = f.child;
                    if (0 !== ($cee7ff159d524e18$var$V.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for($cee7ff159d524e18$var$V = l; null !== $cee7ff159d524e18$var$V;){
                                    var m = $cee7ff159d524e18$var$V;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            $cee7ff159d524e18$var$Qj(8, m, f);
                                    }
                                    var q = m.child;
                                    if (null !== q) q.return = m, $cee7ff159d524e18$var$V = q;
                                    else for(; null !== $cee7ff159d524e18$var$V;){
                                        m = $cee7ff159d524e18$var$V;
                                        var r = m.sibling, y = m.return;
                                        $cee7ff159d524e18$var$Tj(m);
                                        if (m === l) {
                                            $cee7ff159d524e18$var$V = null;
                                            break;
                                        }
                                        if (null !== r) {
                                            r.return = y;
                                            $cee7ff159d524e18$var$V = r;
                                            break;
                                        }
                                        $cee7ff159d524e18$var$V = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var t = n.child;
                                if (null !== t) {
                                    n.child = null;
                                    do {
                                        var J = t.sibling;
                                        t.sibling = null;
                                        t = J;
                                    }while (null !== t);
                                }
                            }
                            $cee7ff159d524e18$var$V = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, $cee7ff159d524e18$var$V = g;
                    else b: for(; null !== $cee7ff159d524e18$var$V;){
                        f = $cee7ff159d524e18$var$V;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                $cee7ff159d524e18$var$Qj(9, f, f.return);
                        }
                        var x = f.sibling;
                        if (null !== x) {
                            x.return = f.return;
                            $cee7ff159d524e18$var$V = x;
                            break b;
                        }
                        $cee7ff159d524e18$var$V = f.return;
                    }
                }
                var w = a.current;
                for($cee7ff159d524e18$var$V = w; null !== $cee7ff159d524e18$var$V;){
                    g = $cee7ff159d524e18$var$V;
                    var u = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, $cee7ff159d524e18$var$V = u;
                    else b: for(g = w; null !== $cee7ff159d524e18$var$V;){
                        h = $cee7ff159d524e18$var$V;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    $cee7ff159d524e18$var$Rj(9, h);
                            }
                        } catch (na) {
                            $cee7ff159d524e18$var$W(h, h.return, na);
                        }
                        if (h === g) {
                            $cee7ff159d524e18$var$V = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F.return = h.return;
                            $cee7ff159d524e18$var$V = F;
                            break b;
                        }
                        $cee7ff159d524e18$var$V = h.return;
                    }
                }
                $cee7ff159d524e18$var$K = e;
                $cee7ff159d524e18$var$jg();
                if ($cee7ff159d524e18$var$lc && "function" === typeof $cee7ff159d524e18$var$lc.onPostCommitFiberRoot) try {
                    $cee7ff159d524e18$var$lc.onPostCommitFiberRoot($cee7ff159d524e18$var$kc, a);
                } catch (na) {}
                d = !0;
            }
            return d;
        } finally{
            $cee7ff159d524e18$var$C = c, $cee7ff159d524e18$var$pk.transition = b;
        }
    }
    return !1;
}
function $cee7ff159d524e18$var$Yk(a, b, c) {
    b = $cee7ff159d524e18$var$Ki(c, b);
    b = $cee7ff159d524e18$var$Oi(a, b, 1);
    a = $cee7ff159d524e18$var$dh(a, b, 1);
    b = $cee7ff159d524e18$var$L();
    null !== a && ($cee7ff159d524e18$var$Ac(a, 1, b), $cee7ff159d524e18$var$Ek(a, b));
}
function $cee7ff159d524e18$var$W(a, b, c) {
    if (3 === a.tag) $cee7ff159d524e18$var$Yk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            $cee7ff159d524e18$var$Yk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $cee7ff159d524e18$var$Si || !$cee7ff159d524e18$var$Si.has(d))) {
                a = $cee7ff159d524e18$var$Ki(c, a);
                a = $cee7ff159d524e18$var$Ri(b, a, 1);
                b = $cee7ff159d524e18$var$dh(b, a, 1);
                a = $cee7ff159d524e18$var$L();
                null !== b && ($cee7ff159d524e18$var$Ac(b, 1, a), $cee7ff159d524e18$var$Ek(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function $cee7ff159d524e18$var$Ui(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = $cee7ff159d524e18$var$L();
    a.pingedLanes |= a.suspendedLanes & c;
    $cee7ff159d524e18$var$R === a && ($cee7ff159d524e18$var$Z & c) === c && (4 === $cee7ff159d524e18$var$T || 3 === $cee7ff159d524e18$var$T && ($cee7ff159d524e18$var$Z & 130023424) === $cee7ff159d524e18$var$Z && 500 > $cee7ff159d524e18$var$B() - $cee7ff159d524e18$var$gk ? $cee7ff159d524e18$var$Lk(a, 0) : $cee7ff159d524e18$var$sk |= c);
    $cee7ff159d524e18$var$Ek(a, b);
}
function $cee7ff159d524e18$var$Zk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = $cee7ff159d524e18$var$sc, $cee7ff159d524e18$var$sc <<= 1, 0 === ($cee7ff159d524e18$var$sc & 130023424) && ($cee7ff159d524e18$var$sc = 4194304)));
    var c = $cee7ff159d524e18$var$L();
    a = $cee7ff159d524e18$var$Zg(a, b);
    null !== a && ($cee7ff159d524e18$var$Ac(a, b, c), $cee7ff159d524e18$var$Ek(a, c));
}
function $cee7ff159d524e18$var$vj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    $cee7ff159d524e18$var$Zk(a, c);
}
function $cee7ff159d524e18$var$ck(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error($cee7ff159d524e18$var$p(314));
    }
    null !== d && d.delete(b);
    $cee7ff159d524e18$var$Zk(a, c);
}
var $cee7ff159d524e18$var$Wk;
$cee7ff159d524e18$var$Wk = function(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $cee7ff159d524e18$var$Wf.current) $cee7ff159d524e18$var$Ug = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return $cee7ff159d524e18$var$Ug = !1, $cee7ff159d524e18$var$zj(a, b, c);
            $cee7ff159d524e18$var$Ug = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else $cee7ff159d524e18$var$Ug = !1, $cee7ff159d524e18$var$I && 0 !== (b.flags & 1048576) && $cee7ff159d524e18$var$ug(b, $cee7ff159d524e18$var$ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            $cee7ff159d524e18$var$jj(a, b);
            a = b.pendingProps;
            var e = $cee7ff159d524e18$var$Yf(b, $cee7ff159d524e18$var$H.current);
            $cee7ff159d524e18$var$Tg(b, c);
            e = $cee7ff159d524e18$var$Xh(null, b, d, a, e, c);
            var f = $cee7ff159d524e18$var$bi();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, $cee7ff159d524e18$var$Zf(d) ? (f = !0, $cee7ff159d524e18$var$cg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, $cee7ff159d524e18$var$ah(b), e.updater = $cee7ff159d524e18$var$nh, b.stateNode = e, e._reactInternals = b, $cee7ff159d524e18$var$rh(b, d, a, c), b = $cee7ff159d524e18$var$kj(null, b, d, !0, f, c)) : (b.tag = 0, $cee7ff159d524e18$var$I && f && $cee7ff159d524e18$var$vg(b), $cee7ff159d524e18$var$Yi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                $cee7ff159d524e18$var$jj(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $cee7ff159d524e18$var$$k(d);
                a = $cee7ff159d524e18$var$Lg(d, a);
                switch(e){
                    case 0:
                        b = $cee7ff159d524e18$var$dj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = $cee7ff159d524e18$var$ij(null, b, d, a, c);
                        break a;
                    case 11:
                        b = $cee7ff159d524e18$var$Zi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $cee7ff159d524e18$var$aj(null, b, d, $cee7ff159d524e18$var$Lg(d.type, a), c);
                        break a;
                }
                throw Error($cee7ff159d524e18$var$p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $cee7ff159d524e18$var$Lg(d, e), $cee7ff159d524e18$var$dj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $cee7ff159d524e18$var$Lg(d, e), $cee7ff159d524e18$var$ij(a, b, d, e, c);
        case 3:
            a: {
                $cee7ff159d524e18$var$lj(b);
                if (null === a) throw Error($cee7ff159d524e18$var$p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                $cee7ff159d524e18$var$bh(a, b);
                $cee7ff159d524e18$var$gh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = $cee7ff159d524e18$var$Ki(Error($cee7ff159d524e18$var$p(423)), b);
                        b = $cee7ff159d524e18$var$mj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = $cee7ff159d524e18$var$Ki(Error($cee7ff159d524e18$var$p(424)), b);
                        b = $cee7ff159d524e18$var$mj(a, b, d, c, e);
                        break a;
                    } else for($cee7ff159d524e18$var$yg = $cee7ff159d524e18$var$Lf(b.stateNode.containerInfo.firstChild), $cee7ff159d524e18$var$xg = b, $cee7ff159d524e18$var$I = !0, $cee7ff159d524e18$var$zg = null, c = $cee7ff159d524e18$var$Ch(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    $cee7ff159d524e18$var$Ig();
                    if (d === e) {
                        b = $cee7ff159d524e18$var$$i(a, b, c);
                        break a;
                    }
                    $cee7ff159d524e18$var$Yi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return $cee7ff159d524e18$var$Kh(b), null === a && $cee7ff159d524e18$var$Eg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $cee7ff159d524e18$var$Ef(d, e) ? g = null : null !== f && $cee7ff159d524e18$var$Ef(d, f) && (b.flags |= 32), $cee7ff159d524e18$var$hj(a, b), $cee7ff159d524e18$var$Yi(a, b, g, c), b.child;
        case 6:
            return null === a && $cee7ff159d524e18$var$Eg(b), null;
        case 13:
            return $cee7ff159d524e18$var$pj(a, b, c);
        case 4:
            return $cee7ff159d524e18$var$Ih(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $cee7ff159d524e18$var$Bh(b, null, d, c) : $cee7ff159d524e18$var$Yi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $cee7ff159d524e18$var$Lg(d, e), $cee7ff159d524e18$var$Zi(a, b, d, e, c);
        case 7:
            return $cee7ff159d524e18$var$Yi(a, b, b.pendingProps, c), b.child;
        case 8:
            return $cee7ff159d524e18$var$Yi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return $cee7ff159d524e18$var$Yi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                $cee7ff159d524e18$var$G($cee7ff159d524e18$var$Mg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if ($cee7ff159d524e18$var$He(f.value, g)) {
                        if (f.children === e.children && !$cee7ff159d524e18$var$Wf.current) {
                            b = $cee7ff159d524e18$var$$i(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = $cee7ff159d524e18$var$ch(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    $cee7ff159d524e18$var$Sg(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error($cee7ff159d524e18$var$p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            $cee7ff159d524e18$var$Sg(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                $cee7ff159d524e18$var$Yi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, $cee7ff159d524e18$var$Tg(b, c), e = $cee7ff159d524e18$var$Vg(e), d = d(e), b.flags |= 1, $cee7ff159d524e18$var$Yi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = $cee7ff159d524e18$var$Lg(d, b.pendingProps), e = $cee7ff159d524e18$var$Lg(d.type, e), $cee7ff159d524e18$var$aj(a, b, d, e, c);
        case 15:
            return $cee7ff159d524e18$var$cj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $cee7ff159d524e18$var$Lg(d, e), $cee7ff159d524e18$var$jj(a, b), b.tag = 1, $cee7ff159d524e18$var$Zf(d) ? (a = !0, $cee7ff159d524e18$var$cg(b)) : a = !1, $cee7ff159d524e18$var$Tg(b, c), $cee7ff159d524e18$var$ph(b, d, e), $cee7ff159d524e18$var$rh(b, d, e, c), $cee7ff159d524e18$var$kj(null, b, d, !0, a, c);
        case 19:
            return $cee7ff159d524e18$var$yj(a, b, c);
        case 22:
            return $cee7ff159d524e18$var$ej(a, b, c);
    }
    throw Error($cee7ff159d524e18$var$p(156, b.tag));
};
function $cee7ff159d524e18$var$Gk(a, b) {
    return $cee7ff159d524e18$var$ac(a, b);
}
function $cee7ff159d524e18$var$al(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $cee7ff159d524e18$var$Bg(a, b, c, d) {
    return new $cee7ff159d524e18$var$al(a, b, c, d);
}
function $cee7ff159d524e18$var$bj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $cee7ff159d524e18$var$$k(a) {
    if ("function" === typeof a) return $cee7ff159d524e18$var$bj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $cee7ff159d524e18$var$Da) return 11;
        if (a === $cee7ff159d524e18$var$Ga) return 14;
    }
    return 2;
}
function $cee7ff159d524e18$var$wh(a, b) {
    var c = a.alternate;
    null === c ? (c = $cee7ff159d524e18$var$Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function $cee7ff159d524e18$var$yh(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $cee7ff159d524e18$var$bj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $cee7ff159d524e18$var$ya:
            return $cee7ff159d524e18$var$Ah(c.children, e, f, b);
        case $cee7ff159d524e18$var$za:
            g = 8;
            e |= 8;
            break;
        case $cee7ff159d524e18$var$Aa:
            return a = $cee7ff159d524e18$var$Bg(12, c, b, e | 2), a.elementType = $cee7ff159d524e18$var$Aa, a.lanes = f, a;
        case $cee7ff159d524e18$var$Ea:
            return a = $cee7ff159d524e18$var$Bg(13, c, b, e), a.elementType = $cee7ff159d524e18$var$Ea, a.lanes = f, a;
        case $cee7ff159d524e18$var$Fa:
            return a = $cee7ff159d524e18$var$Bg(19, c, b, e), a.elementType = $cee7ff159d524e18$var$Fa, a.lanes = f, a;
        case $cee7ff159d524e18$var$Ia:
            return $cee7ff159d524e18$var$qj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case $cee7ff159d524e18$var$Ba:
                    g = 10;
                    break a;
                case $cee7ff159d524e18$var$Ca:
                    g = 9;
                    break a;
                case $cee7ff159d524e18$var$Da:
                    g = 11;
                    break a;
                case $cee7ff159d524e18$var$Ga:
                    g = 14;
                    break a;
                case $cee7ff159d524e18$var$Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error($cee7ff159d524e18$var$p(130, null == a ? a : typeof a, ""));
    }
    b = $cee7ff159d524e18$var$Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $cee7ff159d524e18$var$Ah(a, b, c, d) {
    a = $cee7ff159d524e18$var$Bg(7, a, d, b);
    a.lanes = c;
    return a;
}
function $cee7ff159d524e18$var$qj(a, b, c, d) {
    a = $cee7ff159d524e18$var$Bg(22, a, d, b);
    a.elementType = $cee7ff159d524e18$var$Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function $cee7ff159d524e18$var$xh(a, b, c) {
    a = $cee7ff159d524e18$var$Bg(6, a, null, b);
    a.lanes = c;
    return a;
}
function $cee7ff159d524e18$var$zh(a, b, c) {
    b = $cee7ff159d524e18$var$Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $cee7ff159d524e18$var$bl(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = $cee7ff159d524e18$var$zc(0);
    this.expirationTimes = $cee7ff159d524e18$var$zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $cee7ff159d524e18$var$zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function $cee7ff159d524e18$var$cl(a, b, c, d, e, f, g, h, k) {
    a = new $cee7ff159d524e18$var$bl(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = $cee7ff159d524e18$var$Bg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    $cee7ff159d524e18$var$ah(f);
    return a;
}
function $cee7ff159d524e18$var$dl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $cee7ff159d524e18$var$wa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $cee7ff159d524e18$var$el(a) {
    if (!a) return $cee7ff159d524e18$var$Vf;
    a = a._reactInternals;
    a: {
        if ($cee7ff159d524e18$var$Vb(a) !== a || 1 !== a.tag) throw Error($cee7ff159d524e18$var$p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if ($cee7ff159d524e18$var$Zf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error($cee7ff159d524e18$var$p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if ($cee7ff159d524e18$var$Zf(c)) return $cee7ff159d524e18$var$bg(a, c, b);
    }
    return b;
}
function $cee7ff159d524e18$var$fl(a, b, c, d, e, f, g, h, k) {
    a = $cee7ff159d524e18$var$cl(c, d, !0, a, e, f, g, h, k);
    a.context = $cee7ff159d524e18$var$el(null);
    c = a.current;
    d = $cee7ff159d524e18$var$L();
    e = $cee7ff159d524e18$var$lh(c);
    f = $cee7ff159d524e18$var$ch(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    $cee7ff159d524e18$var$dh(c, f, e);
    a.current.lanes = e;
    $cee7ff159d524e18$var$Ac(a, e, d);
    $cee7ff159d524e18$var$Ek(a, d);
    return a;
}
function $cee7ff159d524e18$var$gl(a, b, c, d) {
    var e = b.current, f = $cee7ff159d524e18$var$L(), g = $cee7ff159d524e18$var$lh(e);
    c = $cee7ff159d524e18$var$el(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $cee7ff159d524e18$var$ch(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = $cee7ff159d524e18$var$dh(e, b, g);
    null !== a && ($cee7ff159d524e18$var$mh(a, e, g, f), $cee7ff159d524e18$var$eh(a, e, g));
    return g;
}
function $cee7ff159d524e18$var$hl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $cee7ff159d524e18$var$il(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $cee7ff159d524e18$var$jl(a, b) {
    $cee7ff159d524e18$var$il(a, b);
    (a = a.alternate) && $cee7ff159d524e18$var$il(a, b);
}
function $cee7ff159d524e18$var$kl() {
    return null;
}
var $cee7ff159d524e18$var$ll = "function" === typeof reportError ? reportError : function(a) {
    console.error(a);
};
function $cee7ff159d524e18$var$ml(a) {
    this._internalRoot = a;
}
$cee7ff159d524e18$var$nl.prototype.render = $cee7ff159d524e18$var$ml.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error($cee7ff159d524e18$var$p(409));
    $cee7ff159d524e18$var$gl(a, b, null, null);
};
$cee7ff159d524e18$var$nl.prototype.unmount = $cee7ff159d524e18$var$ml.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        $cee7ff159d524e18$var$Sk(function() {
            $cee7ff159d524e18$var$gl(null, a, null, null);
        });
        b[$cee7ff159d524e18$var$uf] = null;
    }
};
function $cee7ff159d524e18$var$nl(a) {
    this._internalRoot = a;
}
$cee7ff159d524e18$var$nl.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = $cee7ff159d524e18$var$Hc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < $cee7ff159d524e18$var$Qc.length && 0 !== b && b < $cee7ff159d524e18$var$Qc[c].priority; c++);
        $cee7ff159d524e18$var$Qc.splice(c, 0, a);
        0 === c && $cee7ff159d524e18$var$Vc(a);
    }
};
function $cee7ff159d524e18$var$ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function $cee7ff159d524e18$var$pl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $cee7ff159d524e18$var$ql() {}
function $cee7ff159d524e18$var$rl(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function() {
                var a = $cee7ff159d524e18$var$hl(g);
                f.call(a);
            };
        }
        var g = $cee7ff159d524e18$var$fl(b, d, a, 0, null, !1, !1, "", $cee7ff159d524e18$var$ql);
        a._reactRootContainer = g;
        a[$cee7ff159d524e18$var$uf] = g.current;
        $cee7ff159d524e18$var$sf(8 === a.nodeType ? a.parentNode : a);
        $cee7ff159d524e18$var$Sk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function() {
            var a = $cee7ff159d524e18$var$hl(k);
            h.call(a);
        };
    }
    var k = $cee7ff159d524e18$var$cl(a, 0, !1, null, null, !1, !1, "", $cee7ff159d524e18$var$ql);
    a._reactRootContainer = k;
    a[$cee7ff159d524e18$var$uf] = k.current;
    $cee7ff159d524e18$var$sf(8 === a.nodeType ? a.parentNode : a);
    $cee7ff159d524e18$var$Sk(function() {
        $cee7ff159d524e18$var$gl(b, k, c, d);
    });
    return k;
}
function $cee7ff159d524e18$var$sl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = $cee7ff159d524e18$var$hl(g);
                h.call(a);
            };
        }
        $cee7ff159d524e18$var$gl(b, g, a, e);
    } else g = $cee7ff159d524e18$var$rl(c, b, a, e, d);
    return $cee7ff159d524e18$var$hl(g);
}
$cee7ff159d524e18$var$Ec = function(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = $cee7ff159d524e18$var$tc(b.pendingLanes);
                0 !== c && ($cee7ff159d524e18$var$Cc(b, c | 1), $cee7ff159d524e18$var$Ek(b, $cee7ff159d524e18$var$B()), 0 === ($cee7ff159d524e18$var$K & 6) && ($cee7ff159d524e18$var$Hj = $cee7ff159d524e18$var$B() + 500, $cee7ff159d524e18$var$jg()));
            }
            break;
        case 13:
            $cee7ff159d524e18$var$Sk(function() {
                var b = $cee7ff159d524e18$var$Zg(a, 1);
                if (null !== b) {
                    var c = $cee7ff159d524e18$var$L();
                    $cee7ff159d524e18$var$mh(b, a, 1, c);
                }
            }), $cee7ff159d524e18$var$jl(a, 1);
    }
};
$cee7ff159d524e18$var$Fc = function(a) {
    if (13 === a.tag) {
        var b = $cee7ff159d524e18$var$Zg(a, 134217728);
        if (null !== b) {
            var c = $cee7ff159d524e18$var$L();
            $cee7ff159d524e18$var$mh(b, a, 134217728, c);
        }
        $cee7ff159d524e18$var$jl(a, 134217728);
    }
};
$cee7ff159d524e18$var$Gc = function(a) {
    if (13 === a.tag) {
        var b = $cee7ff159d524e18$var$lh(a), c = $cee7ff159d524e18$var$Zg(a, b);
        if (null !== c) {
            var d = $cee7ff159d524e18$var$L();
            $cee7ff159d524e18$var$mh(c, a, b, d);
        }
        $cee7ff159d524e18$var$jl(a, b);
    }
};
$cee7ff159d524e18$var$Hc = function() {
    return $cee7ff159d524e18$var$C;
};
$cee7ff159d524e18$var$Ic = function(a, b) {
    var c = $cee7ff159d524e18$var$C;
    try {
        return $cee7ff159d524e18$var$C = a, b();
    } finally{
        $cee7ff159d524e18$var$C = c;
    }
};
$cee7ff159d524e18$var$yb = function(a, b, c) {
    switch(b){
        case "input":
            $cee7ff159d524e18$var$bb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $cee7ff159d524e18$var$Db(d);
                        if (!e) throw Error($cee7ff159d524e18$var$p(90));
                        $cee7ff159d524e18$var$Wa(d);
                        $cee7ff159d524e18$var$bb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $cee7ff159d524e18$var$ib(a, c);
            break;
        case "select":
            b = c.value, null != b && $cee7ff159d524e18$var$fb(a, !!c.multiple, b, !1);
    }
};
$cee7ff159d524e18$var$Gb = $cee7ff159d524e18$var$Rk;
$cee7ff159d524e18$var$Hb = $cee7ff159d524e18$var$Sk;
var $cee7ff159d524e18$var$tl = {
    usingClientEntryPoint: !1,
    Events: [
        $cee7ff159d524e18$var$Cb,
        $cee7ff159d524e18$var$ue,
        $cee7ff159d524e18$var$Db,
        $cee7ff159d524e18$var$Eb,
        $cee7ff159d524e18$var$Fb,
        $cee7ff159d524e18$var$Rk
    ]
}, $cee7ff159d524e18$var$ul = {
    findFiberByHostInstance: $cee7ff159d524e18$var$Wc,
    bundleType: 0,
    version: "18.2.0",
    rendererPackageName: "react-dom"
};
var $cee7ff159d524e18$var$vl = {
    bundleType: $cee7ff159d524e18$var$ul.bundleType,
    version: $cee7ff159d524e18$var$ul.version,
    rendererPackageName: $cee7ff159d524e18$var$ul.rendererPackageName,
    rendererConfig: $cee7ff159d524e18$var$ul.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $cee7ff159d524e18$var$ua.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = $cee7ff159d524e18$var$Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $cee7ff159d524e18$var$ul.findFiberByHostInstance || $cee7ff159d524e18$var$kl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.2.0-next-9e3b772b8-20220608"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $cee7ff159d524e18$var$wl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$cee7ff159d524e18$var$wl.isDisabled && $cee7ff159d524e18$var$wl.supportsFiber) try {
        $cee7ff159d524e18$var$kc = $cee7ff159d524e18$var$wl.inject($cee7ff159d524e18$var$vl), $cee7ff159d524e18$var$lc = $cee7ff159d524e18$var$wl;
    } catch (a) {}
}
$cee7ff159d524e18$export$ae55be85d98224ed = $cee7ff159d524e18$var$tl;
$cee7ff159d524e18$export$d39a5bbd09211389 = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$cee7ff159d524e18$var$ol(b)) throw Error($cee7ff159d524e18$var$p(200));
    return $cee7ff159d524e18$var$dl(a, b, null, c);
};
$cee7ff159d524e18$export$882461b6382ed46c = function(a, b) {
    if (!$cee7ff159d524e18$var$ol(a)) throw Error($cee7ff159d524e18$var$p(299));
    var c = !1, d = "", e = $cee7ff159d524e18$var$ll;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = $cee7ff159d524e18$var$cl(a, 1, !1, null, null, c, !1, d, e);
    a[$cee7ff159d524e18$var$uf] = b.current;
    $cee7ff159d524e18$var$sf(8 === a.nodeType ? a.parentNode : a);
    return new $cee7ff159d524e18$var$ml(b);
};
$cee7ff159d524e18$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($cee7ff159d524e18$var$p(188));
        a = Object.keys(a).join(",");
        throw Error($cee7ff159d524e18$var$p(268, a));
    }
    a = $cee7ff159d524e18$var$Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$cee7ff159d524e18$export$cd75ccfd720a3cd4 = function(a) {
    return $cee7ff159d524e18$var$Sk(a);
};
$cee7ff159d524e18$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$cee7ff159d524e18$var$pl(b)) throw Error($cee7ff159d524e18$var$p(200));
    return $cee7ff159d524e18$var$sl(null, a, b, !0, c);
};
$cee7ff159d524e18$export$757ceba2d55c277e = function(a, b, c) {
    if (!$cee7ff159d524e18$var$ol(a)) throw Error($cee7ff159d524e18$var$p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = $cee7ff159d524e18$var$ll;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = $cee7ff159d524e18$var$fl(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[$cee7ff159d524e18$var$uf] = b.current;
    $cee7ff159d524e18$var$sf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new $cee7ff159d524e18$var$nl(b);
};
$cee7ff159d524e18$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$cee7ff159d524e18$var$pl(b)) throw Error($cee7ff159d524e18$var$p(200));
    return $cee7ff159d524e18$var$sl(null, a, b, !1, c);
};
$cee7ff159d524e18$export$502457920280e6be = function(a) {
    if (!$cee7ff159d524e18$var$pl(a)) throw Error($cee7ff159d524e18$var$p(40));
    return a._reactRootContainer ? ($cee7ff159d524e18$var$Sk(function() {
        $cee7ff159d524e18$var$sl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$cee7ff159d524e18$var$uf] = null;
        });
    }), !0) : !1;
};
$cee7ff159d524e18$export$c78a37762a8d58e1 = $cee7ff159d524e18$var$Rk;
$cee7ff159d524e18$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$cee7ff159d524e18$var$pl(c)) throw Error($cee7ff159d524e18$var$p(200));
    if (null == a || void 0 === a._reactInternals) throw Error($cee7ff159d524e18$var$p(38));
    return $cee7ff159d524e18$var$sl(a, b, c, !1, d);
};
$cee7ff159d524e18$export$83d89fbfd8236492 = "18.2.0-next-9e3b772b8-20220608";

});
parcelRegister("3hvsM", function(module, exports) {
'use strict';

module.exports = (parcelRequire("4bJqP"));

});
parcelRegister("4bJqP", function(module, exports) {
$parcel$export(module.exports, "unstable_now", () => $30cb6e4b156fa063$export$c4744153514ff05d, (v) => $30cb6e4b156fa063$export$c4744153514ff05d = v);
$parcel$export(module.exports, "unstable_IdlePriority", () => $30cb6e4b156fa063$export$3e506c1ccc9cc1a7, (v) => $30cb6e4b156fa063$export$3e506c1ccc9cc1a7 = v);
$parcel$export(module.exports, "unstable_ImmediatePriority", () => $30cb6e4b156fa063$export$e26fe2ed2fa76875, (v) => $30cb6e4b156fa063$export$e26fe2ed2fa76875 = v);
$parcel$export(module.exports, "unstable_LowPriority", () => $30cb6e4b156fa063$export$502329bbf4b505b1, (v) => $30cb6e4b156fa063$export$502329bbf4b505b1 = v);
$parcel$export(module.exports, "unstable_NormalPriority", () => $30cb6e4b156fa063$export$6e3807111c4874c4, (v) => $30cb6e4b156fa063$export$6e3807111c4874c4 = v);
$parcel$export(module.exports, "unstable_Profiling", () => $30cb6e4b156fa063$export$c27134553091fb3a, (v) => $30cb6e4b156fa063$export$c27134553091fb3a = v);
$parcel$export(module.exports, "unstable_UserBlockingPriority", () => $30cb6e4b156fa063$export$33ee1acdc04fd2a2, (v) => $30cb6e4b156fa063$export$33ee1acdc04fd2a2 = v);
$parcel$export(module.exports, "unstable_cancelCallback", () => $30cb6e4b156fa063$export$b00a404bbd5edef2, (v) => $30cb6e4b156fa063$export$b00a404bbd5edef2 = v);
$parcel$export(module.exports, "unstable_continueExecution", () => $30cb6e4b156fa063$export$8352ce38b91d0c62, (v) => $30cb6e4b156fa063$export$8352ce38b91d0c62 = v);
$parcel$export(module.exports, "unstable_forceFrameRate", () => $30cb6e4b156fa063$export$d66a1c1c77bd778b, (v) => $30cb6e4b156fa063$export$d66a1c1c77bd778b = v);
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", () => $30cb6e4b156fa063$export$d3dfb8e4810cb555, (v) => $30cb6e4b156fa063$export$d3dfb8e4810cb555 = v);
$parcel$export(module.exports, "unstable_getFirstCallbackNode", () => $30cb6e4b156fa063$export$839f9183b0465a69, (v) => $30cb6e4b156fa063$export$839f9183b0465a69 = v);
$parcel$export(module.exports, "unstable_next", () => $30cb6e4b156fa063$export$72fdf0e06517287b, (v) => $30cb6e4b156fa063$export$72fdf0e06517287b = v);
$parcel$export(module.exports, "unstable_pauseExecution", () => $30cb6e4b156fa063$export$4b844e58a3e414b4, (v) => $30cb6e4b156fa063$export$4b844e58a3e414b4 = v);
$parcel$export(module.exports, "unstable_requestPaint", () => $30cb6e4b156fa063$export$816d2913ae6b83b1, (v) => $30cb6e4b156fa063$export$816d2913ae6b83b1 = v);
$parcel$export(module.exports, "unstable_runWithPriority", () => $30cb6e4b156fa063$export$61bcfe829111a1d0, (v) => $30cb6e4b156fa063$export$61bcfe829111a1d0 = v);
$parcel$export(module.exports, "unstable_scheduleCallback", () => $30cb6e4b156fa063$export$7ee8c9beb337bc3f, (v) => $30cb6e4b156fa063$export$7ee8c9beb337bc3f = v);
$parcel$export(module.exports, "unstable_shouldYield", () => $30cb6e4b156fa063$export$b5836b71941fa3ed, (v) => $30cb6e4b156fa063$export$b5836b71941fa3ed = v);
$parcel$export(module.exports, "unstable_wrapCallback", () => $30cb6e4b156fa063$export$cf845f2c119da08a, (v) => $30cb6e4b156fa063$export$cf845f2c119da08a = v);
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $30cb6e4b156fa063$export$c4744153514ff05d;
var $30cb6e4b156fa063$export$3e506c1ccc9cc1a7;
var $30cb6e4b156fa063$export$e26fe2ed2fa76875;
var $30cb6e4b156fa063$export$502329bbf4b505b1;
var $30cb6e4b156fa063$export$6e3807111c4874c4;
var $30cb6e4b156fa063$export$c27134553091fb3a;
var $30cb6e4b156fa063$export$33ee1acdc04fd2a2;
var $30cb6e4b156fa063$export$b00a404bbd5edef2;
var $30cb6e4b156fa063$export$8352ce38b91d0c62;
var $30cb6e4b156fa063$export$d66a1c1c77bd778b;
var $30cb6e4b156fa063$export$d3dfb8e4810cb555;
var $30cb6e4b156fa063$export$839f9183b0465a69;
var $30cb6e4b156fa063$export$72fdf0e06517287b;
var $30cb6e4b156fa063$export$4b844e58a3e414b4;
var $30cb6e4b156fa063$export$816d2913ae6b83b1;
var $30cb6e4b156fa063$export$61bcfe829111a1d0;
var $30cb6e4b156fa063$export$7ee8c9beb337bc3f;
var $30cb6e4b156fa063$export$b5836b71941fa3ed;
var $30cb6e4b156fa063$export$cf845f2c119da08a;
'use strict';
function $30cb6e4b156fa063$var$f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < $30cb6e4b156fa063$var$g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $30cb6e4b156fa063$var$h(a) {
    return 0 === a.length ? null : a[0];
}
function $30cb6e4b156fa063$var$k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > $30cb6e4b156fa063$var$g(C, c)) n < e && 0 > $30cb6e4b156fa063$var$g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > $30cb6e4b156fa063$var$g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function $30cb6e4b156fa063$var$g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $30cb6e4b156fa063$var$l = performance;
    $30cb6e4b156fa063$export$c4744153514ff05d = function() {
        return $30cb6e4b156fa063$var$l.now();
    };
} else {
    var $30cb6e4b156fa063$var$p = Date, $30cb6e4b156fa063$var$q = $30cb6e4b156fa063$var$p.now();
    $30cb6e4b156fa063$export$c4744153514ff05d = function() {
        return $30cb6e4b156fa063$var$p.now() - $30cb6e4b156fa063$var$q;
    };
}
var $30cb6e4b156fa063$var$r = [], $30cb6e4b156fa063$var$t = [], $30cb6e4b156fa063$var$u = 1, $30cb6e4b156fa063$var$v = null, $30cb6e4b156fa063$var$y = 3, $30cb6e4b156fa063$var$z = !1, $30cb6e4b156fa063$var$A = !1, $30cb6e4b156fa063$var$B = !1, $30cb6e4b156fa063$var$D = "function" === typeof setTimeout ? setTimeout : null, $30cb6e4b156fa063$var$E = "function" === typeof clearTimeout ? clearTimeout : null, $30cb6e4b156fa063$var$F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function $30cb6e4b156fa063$var$G(a) {
    for(var b = $30cb6e4b156fa063$var$h($30cb6e4b156fa063$var$t); null !== b;){
        if (null === b.callback) $30cb6e4b156fa063$var$k($30cb6e4b156fa063$var$t);
        else if (b.startTime <= a) $30cb6e4b156fa063$var$k($30cb6e4b156fa063$var$t), b.sortIndex = b.expirationTime, $30cb6e4b156fa063$var$f($30cb6e4b156fa063$var$r, b);
        else break;
        b = $30cb6e4b156fa063$var$h($30cb6e4b156fa063$var$t);
    }
}
function $30cb6e4b156fa063$var$H(a) {
    $30cb6e4b156fa063$var$B = !1;
    $30cb6e4b156fa063$var$G(a);
    if (!$30cb6e4b156fa063$var$A) {
        if (null !== $30cb6e4b156fa063$var$h($30cb6e4b156fa063$var$r)) $30cb6e4b156fa063$var$A = !0, $30cb6e4b156fa063$var$I($30cb6e4b156fa063$var$J);
        else {
            var b = $30cb6e4b156fa063$var$h($30cb6e4b156fa063$var$t);
            null !== b && $30cb6e4b156fa063$var$K($30cb6e4b156fa063$var$H, b.startTime - a);
        }
    }
}
function $30cb6e4b156fa063$var$J(a, b) {
    $30cb6e4b156fa063$var$A = !1;
    $30cb6e4b156fa063$var$B && ($30cb6e4b156fa063$var$B = !1, $30cb6e4b156fa063$var$E($30cb6e4b156fa063$var$L), $30cb6e4b156fa063$var$L = -1);
    $30cb6e4b156fa063$var$z = !0;
    var c = $30cb6e4b156fa063$var$y;
    try {
        $30cb6e4b156fa063$var$G(b);
        for($30cb6e4b156fa063$var$v = $30cb6e4b156fa063$var$h($30cb6e4b156fa063$var$r); null !== $30cb6e4b156fa063$var$v && (!($30cb6e4b156fa063$var$v.expirationTime > b) || a && !$30cb6e4b156fa063$var$M());){
            var d = $30cb6e4b156fa063$var$v.callback;
            if ("function" === typeof d) {
                $30cb6e4b156fa063$var$v.callback = null;
                $30cb6e4b156fa063$var$y = $30cb6e4b156fa063$var$v.priorityLevel;
                var e = d($30cb6e4b156fa063$var$v.expirationTime <= b);
                b = $30cb6e4b156fa063$export$c4744153514ff05d();
                "function" === typeof e ? $30cb6e4b156fa063$var$v.callback = e : $30cb6e4b156fa063$var$v === $30cb6e4b156fa063$var$h($30cb6e4b156fa063$var$r) && $30cb6e4b156fa063$var$k($30cb6e4b156fa063$var$r);
                $30cb6e4b156fa063$var$G(b);
            } else $30cb6e4b156fa063$var$k($30cb6e4b156fa063$var$r);
            $30cb6e4b156fa063$var$v = $30cb6e4b156fa063$var$h($30cb6e4b156fa063$var$r);
        }
        if (null !== $30cb6e4b156fa063$var$v) var w = !0;
        else {
            var m = $30cb6e4b156fa063$var$h($30cb6e4b156fa063$var$t);
            null !== m && $30cb6e4b156fa063$var$K($30cb6e4b156fa063$var$H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        $30cb6e4b156fa063$var$v = null, $30cb6e4b156fa063$var$y = c, $30cb6e4b156fa063$var$z = !1;
    }
}
var $30cb6e4b156fa063$var$N = !1, $30cb6e4b156fa063$var$O = null, $30cb6e4b156fa063$var$L = -1, $30cb6e4b156fa063$var$P = 5, $30cb6e4b156fa063$var$Q = -1;
function $30cb6e4b156fa063$var$M() {
    return $30cb6e4b156fa063$export$c4744153514ff05d() - $30cb6e4b156fa063$var$Q < $30cb6e4b156fa063$var$P ? !1 : !0;
}
function $30cb6e4b156fa063$var$R() {
    if (null !== $30cb6e4b156fa063$var$O) {
        var a = $30cb6e4b156fa063$export$c4744153514ff05d();
        $30cb6e4b156fa063$var$Q = a;
        var b = !0;
        try {
            b = $30cb6e4b156fa063$var$O(!0, a);
        } finally{
            b ? $30cb6e4b156fa063$var$S() : ($30cb6e4b156fa063$var$N = !1, $30cb6e4b156fa063$var$O = null);
        }
    } else $30cb6e4b156fa063$var$N = !1;
}
var $30cb6e4b156fa063$var$S;
if ("function" === typeof $30cb6e4b156fa063$var$F) $30cb6e4b156fa063$var$S = function() {
    $30cb6e4b156fa063$var$F($30cb6e4b156fa063$var$R);
};
else if ("undefined" !== typeof MessageChannel) {
    var $30cb6e4b156fa063$var$T = new MessageChannel, $30cb6e4b156fa063$var$U = $30cb6e4b156fa063$var$T.port2;
    $30cb6e4b156fa063$var$T.port1.onmessage = $30cb6e4b156fa063$var$R;
    $30cb6e4b156fa063$var$S = function() {
        $30cb6e4b156fa063$var$U.postMessage(null);
    };
} else $30cb6e4b156fa063$var$S = function() {
    $30cb6e4b156fa063$var$D($30cb6e4b156fa063$var$R, 0);
};
function $30cb6e4b156fa063$var$I(a) {
    $30cb6e4b156fa063$var$O = a;
    $30cb6e4b156fa063$var$N || ($30cb6e4b156fa063$var$N = !0, $30cb6e4b156fa063$var$S());
}
function $30cb6e4b156fa063$var$K(a, b) {
    $30cb6e4b156fa063$var$L = $30cb6e4b156fa063$var$D(function() {
        a($30cb6e4b156fa063$export$c4744153514ff05d());
    }, b);
}
$30cb6e4b156fa063$export$3e506c1ccc9cc1a7 = 5;
$30cb6e4b156fa063$export$e26fe2ed2fa76875 = 1;
$30cb6e4b156fa063$export$502329bbf4b505b1 = 4;
$30cb6e4b156fa063$export$6e3807111c4874c4 = 3;
$30cb6e4b156fa063$export$c27134553091fb3a = null;
$30cb6e4b156fa063$export$33ee1acdc04fd2a2 = 2;
$30cb6e4b156fa063$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$30cb6e4b156fa063$export$8352ce38b91d0c62 = function() {
    $30cb6e4b156fa063$var$A || $30cb6e4b156fa063$var$z || ($30cb6e4b156fa063$var$A = !0, $30cb6e4b156fa063$var$I($30cb6e4b156fa063$var$J));
};
$30cb6e4b156fa063$export$d66a1c1c77bd778b = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $30cb6e4b156fa063$var$P = 0 < a ? Math.floor(1E3 / a) : 5;
};
$30cb6e4b156fa063$export$d3dfb8e4810cb555 = function() {
    return $30cb6e4b156fa063$var$y;
};
$30cb6e4b156fa063$export$839f9183b0465a69 = function() {
    return $30cb6e4b156fa063$var$h($30cb6e4b156fa063$var$r);
};
$30cb6e4b156fa063$export$72fdf0e06517287b = function(a) {
    switch($30cb6e4b156fa063$var$y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $30cb6e4b156fa063$var$y;
    }
    var c = $30cb6e4b156fa063$var$y;
    $30cb6e4b156fa063$var$y = b;
    try {
        return a();
    } finally{
        $30cb6e4b156fa063$var$y = c;
    }
};
$30cb6e4b156fa063$export$4b844e58a3e414b4 = function() {};
$30cb6e4b156fa063$export$816d2913ae6b83b1 = function() {};
$30cb6e4b156fa063$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $30cb6e4b156fa063$var$y;
    $30cb6e4b156fa063$var$y = a;
    try {
        return b();
    } finally{
        $30cb6e4b156fa063$var$y = c;
    }
};
$30cb6e4b156fa063$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $30cb6e4b156fa063$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $30cb6e4b156fa063$var$u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $30cb6e4b156fa063$var$f($30cb6e4b156fa063$var$t, a), null === $30cb6e4b156fa063$var$h($30cb6e4b156fa063$var$r) && a === $30cb6e4b156fa063$var$h($30cb6e4b156fa063$var$t) && ($30cb6e4b156fa063$var$B ? ($30cb6e4b156fa063$var$E($30cb6e4b156fa063$var$L), $30cb6e4b156fa063$var$L = -1) : $30cb6e4b156fa063$var$B = !0, $30cb6e4b156fa063$var$K($30cb6e4b156fa063$var$H, c - d))) : (a.sortIndex = e, $30cb6e4b156fa063$var$f($30cb6e4b156fa063$var$r, a), $30cb6e4b156fa063$var$A || $30cb6e4b156fa063$var$z || ($30cb6e4b156fa063$var$A = !0, $30cb6e4b156fa063$var$I($30cb6e4b156fa063$var$J)));
    return a;
};
$30cb6e4b156fa063$export$b5836b71941fa3ed = $30cb6e4b156fa063$var$M;
$30cb6e4b156fa063$export$cf845f2c119da08a = function(a) {
    var b = $30cb6e4b156fa063$var$y;
    return function() {
        var c = $30cb6e4b156fa063$var$y;
        $30cb6e4b156fa063$var$y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $30cb6e4b156fa063$var$y = c;
        }
    };
};

});




parcelRegister("N6ReQ", function(module, exports) {
$parcel$export(module.exports, "themeIds", () => $0939e582e4241e27$export$7d43e72a58e3283f);
$parcel$export(module.exports, "themeIdsWithOverrides", () => $0939e582e4241e27$export$92ba366331403db2);
$parcel$export(module.exports, "themeStateDefaults", () => $0939e582e4241e27$export$9aedcfa7336a207);
$parcel$export(module.exports, "default", () => $0939e582e4241e27$export$2e2bcd8739ae039);

var $9Zzpd = parcelRequire("9Zzpd");
var $0939e582e4241e27$export$83993de8eb66733 = [
    'light',
    'dark',
    'auto'
];
/**
 * Contrast preferences: The system contrast preference
 */ var $0939e582e4241e27$var$themeContrastModes = [
    'more',
    'no-preference',
    'auto'
];
var $0939e582e4241e27$export$7d43e72a58e3283f = [
    'light-increased-contrast',
    'light',
    'light-future',
    'dark',
    'dark-future',
    'dark-increased-contrast',
    'spacing',
    'shape',
    'typography',
    'motion'
];
/**
 * Theme override ids: the equivalent of themeIds for theme overrides.
 * Theme overrides are temporary and there may not be any defined at times.
 */ var $0939e582e4241e27$var$themeOverrideIds = [];
var $0939e582e4241e27$export$92ba366331403db2 = [].concat($0939e582e4241e27$export$7d43e72a58e3283f, $0939e582e4241e27$var$themeOverrideIds);
/**
 * Theme to use a base. This will create the theme as
 * an extension with all token values marked as optional
 * to allow tokens to be overridden as required.
 */ /**
 * Palettes: The set of base tokens a given theme may be populated with.
 * For example: legacy light & dark themes use the "legacyPalette" containing colors from our
 * previous color set.
 */ /**
 * ThemeConfig: the source of truth for all theme meta-data.
 * This object should be used whenever interfacing with themes.
 */ var $0939e582e4241e27$var$themeConfig = {
    'atlassian-light': {
        id: 'light',
        displayName: 'Light Theme',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'light'
        }
    },
    'atlassian-light-future': {
        id: 'light-future',
        displayName: 'Future Light Theme',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'light'
        },
        override: 'light'
    },
    'atlassian-light-increased-contrast': {
        id: 'light-increased-contrast',
        displayName: 'Light Theme (increased contrast)',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'light'
        },
        extends: 'light',
        increasesContrastFor: 'light'
    },
    'atlassian-dark': {
        id: 'dark',
        displayName: 'Dark Theme',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'dark'
        }
    },
    'atlassian-dark-future': {
        id: 'dark-future',
        displayName: 'Future Dark Theme',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'dark'
        },
        override: 'light'
    },
    'atlassian-dark-increased-contrast': {
        id: 'dark-increased-contrast',
        displayName: 'Dark Theme (increased contrast)',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'dark'
        },
        extends: 'dark',
        increasesContrastFor: 'dark'
    },
    'atlassian-spacing': {
        id: 'spacing',
        displayName: 'Atlassian Spacing',
        palette: 'spacingScale',
        attributes: {
            type: 'spacing'
        }
    },
    'atlassian-typography': {
        id: 'typography',
        displayName: 'Atlassian Typography',
        palette: 'typographyPalette',
        attributes: {
            type: 'typography'
        }
    },
    'atlassian-shape': {
        id: 'shape',
        displayName: 'Shape',
        palette: 'shapePalette',
        attributes: {
            type: 'shape'
        }
    },
    'atlassian-motion': {
        id: 'motion',
        displayName: 'Motion',
        palette: 'motionPalette',
        attributes: {
            type: 'motion'
        }
    }
};
/**
 * ThemeOptionsSchema: additional configuration options used to customize Atlassian's themes
 */ /**
 * ThemeState: the standard representation of an app's current theme and preferences
 */ /**
 * Can't evaluate typography feature flags at the module level,
 * it will always resolve to false when server side rendered or when flags are loaded async.
 */ function $0939e582e4241e27$var$getShapeDefault() {
    if ((0, $9Zzpd.fg)('platform-dst-shape-theme-default')) return 'shape';
    return undefined;
}
function $0939e582e4241e27$var$getMotionDefault() {
    if ((0, $9Zzpd.fg)('platform-dst-motion-theme-default')) return 'motion';
    return undefined;
}
var $0939e582e4241e27$export$9aedcfa7336a207 = {
    colorMode: 'auto',
    contrastMode: 'auto',
    dark: 'dark',
    light: 'light',
    shape: $0939e582e4241e27$var$getShapeDefault,
    spacing: 'spacing',
    typography: 'typography',
    motion: $0939e582e4241e27$var$getMotionDefault,
    UNSAFE_themeOptions: undefined
};
var /**
 * Represents theme state once mounted to the page
 * (the page doesn't have an "auto" color mode, it's either light or dark)
 */ $0939e582e4241e27$export$2e2bcd8739ae039 = $0939e582e4241e27$var$themeConfig;

});
parcelRegister("9Zzpd", function(module, exports) {
$parcel$export(module.exports, "fg", () => $74654669a87807aa$export$b40ec24ac8275656);

var $lLIS3 = parcelRequire("lLIS3");
function $74654669a87807aa$export$ba05d765b8392e5e(flagResolver) {
    (0, $lLIS3.setBooleanResolver)(flagResolver);
}
function $74654669a87807aa$export$470e5c2be1411c89(name) {
    return (0, $lLIS3.resolveBooleanFlag)(name);
}
function $74654669a87807aa$export$b40ec24ac8275656(name) {
    return (0, $lLIS3.resolveBooleanFlag)(name);
}

});
parcelRegister("lLIS3", function(module, exports) {
$parcel$export(module.exports, "setBooleanResolver", () => $fd90cb3103826b9d$export$f2b591175b3e424c);
$parcel$export(module.exports, "resolveBooleanFlag", () => $fd90cb3103826b9d$export$6333b6aff9fc6275);

var $34h0K = parcelRequire("34h0K");

var $kjcRI = parcelRequire("kjcRI");

var $3ZMUU = parcelRequire("3ZMUU");
var $fd90cb3103826b9d$var$pkgName = '@atlaskit/platform-feature-flags';
var $fd90cb3103826b9d$export$7e41b1b2bdee3f98 = '__PLATFORM_FEATURE_FLAGS__';
var $fd90cb3103826b9d$var$hasProcessEnv = typeof $3ZMUU !== 'undefined' && typeof $3ZMUU.env !== 'undefined';
// FF global overrides can be configured by test runners or Storybook
var $fd90cb3103826b9d$var$ENV_ENABLE_PLATFORM_FF = $fd90cb3103826b9d$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
// STORYBOOK_ENABLE_PLATFORM_FF is included as storybook only allows env vars prefixed with STORYBOOK
// https://github.com/storybookjs/storybook/issues/12270
var $fd90cb3103826b9d$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF = $fd90cb3103826b9d$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
var $fd90cb3103826b9d$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE = $fd90cb3103826b9d$var$ENV_ENABLE_PLATFORM_FF || $fd90cb3103826b9d$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF;
var $fd90cb3103826b9d$var$DEFAULT_PFF_GLOBAL = {
    booleanResolver: undefined
};
var $fd90cb3103826b9d$var$globalVar = typeof window !== 'undefined' ? window : globalThis;
$fd90cb3103826b9d$var$globalVar[$fd90cb3103826b9d$export$7e41b1b2bdee3f98] = $fd90cb3103826b9d$var$globalVar[$fd90cb3103826b9d$export$7e41b1b2bdee3f98] || $fd90cb3103826b9d$var$DEFAULT_PFF_GLOBAL;
function $fd90cb3103826b9d$export$f2b591175b3e424c(resolver) {
    $fd90cb3103826b9d$var$globalVar[$fd90cb3103826b9d$export$7e41b1b2bdee3f98].booleanResolver = resolver;
}
function $fd90cb3103826b9d$export$6333b6aff9fc6275(flagKey) {
    if ($fd90cb3103826b9d$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE) {
        (0, $kjcRI.debug)('[%s]: The feature flags were enabled while running tests. The flag "%s" will be always enabled.', $fd90cb3103826b9d$var$pkgName, flagKey);
        return true;
    }
    try {
        var _globalVar$PFF_GLOBAL, _globalVar$PFF_GLOBAL2, _globalVar$PFF_GLOBAL3;
        // booleanResolver will be empty for products like Trello, Elevate, Recruit etc.
        // Currently only Confluence, Jira and Bitbucket has set it.
        if (((_globalVar$PFF_GLOBAL = $fd90cb3103826b9d$var$globalVar[$fd90cb3103826b9d$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL === void 0 ? void 0 : _globalVar$PFF_GLOBAL.booleanResolver) === undefined || ((_globalVar$PFF_GLOBAL2 = $fd90cb3103826b9d$var$globalVar[$fd90cb3103826b9d$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL2 === void 0 ? void 0 : _globalVar$PFF_GLOBAL2.booleanResolver) === null) // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
        return (0, $34h0K.default).checkGate(flagKey);
        var result = (_globalVar$PFF_GLOBAL3 = $fd90cb3103826b9d$var$globalVar[$fd90cb3103826b9d$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL3 === void 0 ? void 0 : _globalVar$PFF_GLOBAL3.booleanResolver(flagKey);
        if (typeof result !== 'boolean') {
            // eslint-disable-next-line no-console
            console.warn("".concat(flagKey, " resolved to a non-boolean value, returning false for safety"));
            return false;
        }
        return result;
    } catch (e) {
        return false;
    }
}

});
parcelRegister("34h0K", function(module, exports) {
$parcel$export(module.exports, "default", () => $23bef0dafa61fe97$export$2e2bcd8739ae039);

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $25nEq = parcelRequire("25nEq");

var $3BZ2Q = parcelRequire("3BZ2Q");

var $6WhoI = parcelRequire("6WhoI");



var $23bef0dafa61fe97$var$_FeatureGates;
/**
 * Access the FeatureGates object via the default export.
 * ```ts
 * import FeatureGates from '@atlaskit/feature-gate-js-client';
 * ```
 */ var $23bef0dafa61fe97$var$FeatureGates = /*#__PURE__*/ function() {
    function FeatureGates() {
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, FeatureGates);
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(FeatureGates, null, [
        {
            key: "isGateExists",
            value: function isGateExists(gateName) {
                return this.client.isGateExist(gateName);
            }
        },
        {
            key: "isExperimentExists",
            value: function isExperimentExists(experimentName) {
                return this.client.isExperimentExist(experimentName);
            }
        }
    ]);
}();
$23bef0dafa61fe97$var$_FeatureGates = $23bef0dafa61fe97$var$FeatureGates;
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($23bef0dafa61fe97$var$FeatureGates, "client", new (0, $3BZ2Q.Client)());
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($23bef0dafa61fe97$var$FeatureGates, "hasCheckGateErrorOccurred", false);
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($23bef0dafa61fe97$var$FeatureGates, "hasGetExperimentValueErrorOccurred", false);
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($23bef0dafa61fe97$var$FeatureGates, "checkGate", function(gateName, options) {
    try {
        // Check if the CRITERION override mechanism is available
        if (typeof window !== 'undefined' && window.__CRITERION__ && typeof window.__CRITERION__.getFeatureFlagOverride === 'function') {
            // Attempt to retrieve an override value for the feature gate
            var overrideValue = window.__CRITERION__.getFeatureFlagOverride(gateName);
            // If an override value is found, return it immediately
            if (overrideValue !== undefined) return overrideValue;
        }
    } catch (error) {
        // Log the first occurrence of the error
        if (!$23bef0dafa61fe97$var$_FeatureGates.hasCheckGateErrorOccurred) {
            // eslint-disable-next-line no-console
            console.warn({
                msg: 'An error has occurred checking the feature gate from criterion override. Only the first occurrence of this error is logged.',
                gateName: gateName,
                error: error
            });
            $23bef0dafa61fe97$var$_FeatureGates.hasCheckGateErrorOccurred = true;
        }
    }
    // Proceed with the main logic if no override is found
    return $23bef0dafa61fe97$var$_FeatureGates.client.checkGate(gateName, options);
});
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($23bef0dafa61fe97$var$FeatureGates, "getExperimentValue", function(experimentName, parameterName, defaultValue, options) {
    try {
        // Check if the CRITERION override mechanism is available
        if (typeof window !== 'undefined' && window.__CRITERION__ && typeof window.__CRITERION__.getExperimentValueOverride === 'function') {
            var overrideValue = window.__CRITERION__.getExperimentValueOverride(experimentName, parameterName);
            if (overrideValue !== undefined && overrideValue !== null) return overrideValue;
        }
    } catch (error) {
        // Log the first occurrence of the error
        if (!$23bef0dafa61fe97$var$_FeatureGates.hasGetExperimentValueErrorOccurred) {
            // eslint-disable-next-line no-console
            console.warn({
                msg: 'An error has occurred getting the experiment value from criterion override. Only the first occurrence of this error is logged.',
                experimentName: experimentName,
                defaultValue: defaultValue,
                options: options,
                error: error
            });
            $23bef0dafa61fe97$var$_FeatureGates.hasGetExperimentValueErrorOccurred = true;
        }
        return defaultValue;
    }
    // Proceed with the main logic if no override is found
    return $23bef0dafa61fe97$var$_FeatureGates.client.getExperimentValue(experimentName, parameterName, defaultValue, options);
});
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($23bef0dafa61fe97$var$FeatureGates, "initializeCalled", $23bef0dafa61fe97$var$_FeatureGates.client.initializeCalled.bind($23bef0dafa61fe97$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($23bef0dafa61fe97$var$FeatureGates, "initializeCompleted", $23bef0dafa61fe97$var$_FeatureGates.client.initializeCompleted.bind($23bef0dafa61fe97$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($23bef0dafa61fe97$var$FeatureGates, "waitUntilInitializeCompleted", $23bef0dafa61fe97$var$_FeatureGates.client.waitUntilInitializeCompleted.bind($23bef0dafa61fe97$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($23bef0dafa61fe97$var$FeatureGates, "initialize", $23bef0dafa61fe97$var$_FeatureGates.client.initialize.bind($23bef0dafa61fe97$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($23bef0dafa61fe97$var$FeatureGates, "initializeWithProvider", $23bef0dafa61fe97$var$_FeatureGates.client.initializeWithProvider.bind($23bef0dafa61fe97$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($23bef0dafa61fe97$var$FeatureGates, "initializeFromValues", $23bef0dafa61fe97$var$_FeatureGates.client.initializeFromValues.bind($23bef0dafa61fe97$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($23bef0dafa61fe97$var$FeatureGates, "manuallyLogGateExposure", $23bef0dafa61fe97$var$_FeatureGates.client.manuallyLogGateExposure.bind($23bef0dafa61fe97$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($23bef0dafa61fe97$var$FeatureGates, "getExperiment", $23bef0dafa61fe97$var$_FeatureGates.client.getExperiment.bind($23bef0dafa61fe97$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($23bef0dafa61fe97$var$FeatureGates, "manuallyLogExperimentExposure", $23bef0dafa61fe97$var$_FeatureGates.client.manuallyLogExperimentExposure.bind($23bef0dafa61fe97$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($23bef0dafa61fe97$var$FeatureGates, "manuallyLogLayerExposure", $23bef0dafa61fe97$var$_FeatureGates.client.manuallyLogLayerExposure.bind($23bef0dafa61fe97$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($23bef0dafa61fe97$var$FeatureGates, "shutdownStatsig", $23bef0dafa61fe97$var$_FeatureGates.client.shutdownStatsig.bind($23bef0dafa61fe97$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($23bef0dafa61fe97$var$FeatureGates, "overrideGate", $23bef0dafa61fe97$var$_FeatureGates.client.overrideGate.bind($23bef0dafa61fe97$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($23bef0dafa61fe97$var$FeatureGates, "clearGateOverride", $23bef0dafa61fe97$var$_FeatureGates.client.clearGateOverride.bind($23bef0dafa61fe97$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($23bef0dafa61fe97$var$FeatureGates, "overrideConfig", $23bef0dafa61fe97$var$_FeatureGates.client.overrideConfig.bind($23bef0dafa61fe97$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($23bef0dafa61fe97$var$FeatureGates, "clearConfigOverride", $23bef0dafa61fe97$var$_FeatureGates.client.clearConfigOverride.bind($23bef0dafa61fe97$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($23bef0dafa61fe97$var$FeatureGates, "setOverrides", $23bef0dafa61fe97$var$_FeatureGates.client.setOverrides.bind($23bef0dafa61fe97$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($23bef0dafa61fe97$var$FeatureGates, "getOverrides", $23bef0dafa61fe97$var$_FeatureGates.client.getOverrides.bind($23bef0dafa61fe97$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($23bef0dafa61fe97$var$FeatureGates, "clearAllOverrides", $23bef0dafa61fe97$var$_FeatureGates.client.clearAllOverrides.bind($23bef0dafa61fe97$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($23bef0dafa61fe97$var$FeatureGates, "isCurrentUser", $23bef0dafa61fe97$var$_FeatureGates.client.isCurrentUser.bind($23bef0dafa61fe97$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($23bef0dafa61fe97$var$FeatureGates, "onGateUpdated", $23bef0dafa61fe97$var$_FeatureGates.client.onGateUpdated.bind($23bef0dafa61fe97$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($23bef0dafa61fe97$var$FeatureGates, "onExperimentValueUpdated", $23bef0dafa61fe97$var$_FeatureGates.client.onExperimentValueUpdated.bind($23bef0dafa61fe97$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($23bef0dafa61fe97$var$FeatureGates, "onAnyUpdated", $23bef0dafa61fe97$var$_FeatureGates.client.onAnyUpdated.bind($23bef0dafa61fe97$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($23bef0dafa61fe97$var$FeatureGates, "updateUser", $23bef0dafa61fe97$var$_FeatureGates.client.updateUser.bind($23bef0dafa61fe97$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($23bef0dafa61fe97$var$FeatureGates, "updateUserWithProvider", $23bef0dafa61fe97$var$_FeatureGates.client.updateUserWithProvider.bind($23bef0dafa61fe97$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($23bef0dafa61fe97$var$FeatureGates, "updateUserWithValues", $23bef0dafa61fe97$var$_FeatureGates.client.updateUserWithValues.bind($23bef0dafa61fe97$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($23bef0dafa61fe97$var$FeatureGates, "getPackageVersion", $23bef0dafa61fe97$var$_FeatureGates.client.getPackageVersion.bind($23bef0dafa61fe97$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($23bef0dafa61fe97$var$FeatureGates, "getLayer", $23bef0dafa61fe97$var$_FeatureGates.client.getLayer.bind($23bef0dafa61fe97$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($23bef0dafa61fe97$var$FeatureGates, "getLayerValue", $23bef0dafa61fe97$var$_FeatureGates.client.getLayerValue.bind($23bef0dafa61fe97$var$_FeatureGates.client));
var $23bef0dafa61fe97$var$boundFGJS = $23bef0dafa61fe97$var$FeatureGates;
// This makes it possible to get a reference to the FeatureGates client at runtime.
// This is important for overriding values in Cypress tests, as there needs to be a
// way to get the exact instance for a window in order to mock some of its methods.
if (typeof window !== 'undefined') {
    if (window.__FEATUREGATES_JS__ === undefined) window.__FEATUREGATES_JS__ = $23bef0dafa61fe97$var$FeatureGates;
    else {
        var $23bef0dafa61fe97$var$_boundFGJS, $23bef0dafa61fe97$var$_boundFGJS$getPackage;
        $23bef0dafa61fe97$var$boundFGJS = window.__FEATUREGATES_JS__;
        var $23bef0dafa61fe97$var$boundVersion = (($23bef0dafa61fe97$var$_boundFGJS = $23bef0dafa61fe97$var$boundFGJS) === null || $23bef0dafa61fe97$var$_boundFGJS === void 0 || ($23bef0dafa61fe97$var$_boundFGJS$getPackage = $23bef0dafa61fe97$var$_boundFGJS.getPackageVersion) === null || $23bef0dafa61fe97$var$_boundFGJS$getPackage === void 0 ? void 0 : $23bef0dafa61fe97$var$_boundFGJS$getPackage.call($23bef0dafa61fe97$var$_boundFGJS)) || '4.10.0 or earlier';
        if ($23bef0dafa61fe97$var$boundVersion !== (0, $6WhoI.CLIENT_VERSION)) {
            var $23bef0dafa61fe97$var$message = "Multiple versions of FeatureGateClients found on the current page.\n      The currently bound version is ".concat($23bef0dafa61fe97$var$boundVersion, " when module version ").concat((0, $6WhoI.CLIENT_VERSION), " was loading.");
            // eslint-disable-next-line no-console
            console.warn($23bef0dafa61fe97$var$message);
        }
    }
}
var /**
 * @property {FeatureGates} FeatureGate default export
 */ $23bef0dafa61fe97$export$2e2bcd8739ae039 = $23bef0dafa61fe97$var$boundFGJS;

});
parcelRegister("9P61R", function(module, exports) {
function $726d8db65a256fd4$var$_classCallCheck(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
module.exports = $726d8db65a256fd4$var$_classCallCheck, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("arMYe", function(module, exports) {

var $l5tDI = parcelRequire("l5tDI");
function $79b2697ff32e0117$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, $l5tDI(o.key), o);
    }
}
function $79b2697ff32e0117$var$_createClass(e, r, t) {
    return r && $79b2697ff32e0117$var$_defineProperties(e.prototype, r), t && $79b2697ff32e0117$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}
module.exports = $79b2697ff32e0117$var$_createClass, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("l5tDI", function(module, exports) {

var $ekGgq = parcelRequire("ekGgq");
var $f5a10e61d0aa9357$var$_typeof = $ekGgq.default;

var $hmjpV = parcelRequire("hmjpV");
function $f5a10e61d0aa9357$var$toPropertyKey(t) {
    var i = $hmjpV(t, "string");
    return "symbol" == $f5a10e61d0aa9357$var$_typeof(i) ? i : i + "";
}
module.exports = $f5a10e61d0aa9357$var$toPropertyKey, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("ekGgq", function(module, exports) {
function $a6f3b7a9d572ec57$var$_typeof(o) {
    "@babel/helpers - typeof";
    return module.exports = $a6f3b7a9d572ec57$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $a6f3b7a9d572ec57$var$_typeof(o);
}
module.exports = $a6f3b7a9d572ec57$var$_typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("hmjpV", function(module, exports) {

var $ekGgq = parcelRequire("ekGgq");
var $ca338d9498474816$var$_typeof = $ekGgq.default;
function $ca338d9498474816$var$toPrimitive(t, r) {
    if ("object" != $ca338d9498474816$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $ca338d9498474816$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
module.exports = $ca338d9498474816$var$toPrimitive, module.exports.__esModule = true, module.exports["default"] = module.exports;

});



parcelRegister("25nEq", function(module, exports) {

var $l5tDI = parcelRequire("l5tDI");
function $184e64fa7279c0f0$var$_defineProperty(e, r, t) {
    return (r = $l5tDI(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
module.exports = $184e64fa7279c0f0$var$_defineProperty, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("3BZ2Q", function(module, exports) {
$parcel$export(module.exports, "Client", () => $2a142e07fdcca311$export$1f2bb630327ac4b6);

var $1Vcia = parcelRequire("1Vcia");

var $iYJcE = parcelRequire("iYJcE");

var $fL8KA = parcelRequire("fL8KA");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $25nEq = parcelRequire("25nEq");

var $6HG4S = parcelRequire("6HG4S");

var $iFR7a = parcelRequire("iFR7a");

var $kJAvC = parcelRequire("kJAvC");

var $bA77O = parcelRequire("bA77O");

var $gFo6M = parcelRequire("gFo6M");

var $icCTV = parcelRequire("icCTV");

var $f9px2 = parcelRequire("f9px2");

var $5MYIV = parcelRequire("5MYIV");

var $80LFe = parcelRequire("80LFe");

var $cXGvu = parcelRequire("cXGvu");

var $jGAYn = parcelRequire("jGAYn");

var $6WhoI = parcelRequire("6WhoI");
var $2a142e07fdcca311$var$_excluded = [
    "sdkKey",
    "environment",
    "updateUserCompletionCallback",
    "perimeter"
];
function $2a142e07fdcca311$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $2a142e07fdcca311$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $2a142e07fdcca311$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $2a142e07fdcca311$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $2a142e07fdcca311$var$DEFAULT_CLIENT_KEY = 'client-default-key';
// default event logging api is Atlassian proxy rather than Statsig's domain, to avoid ad blockers
var $2a142e07fdcca311$var$DEFAULT_EVENT_LOGGING_API = 'https://xp.atlassian.com/v1/rgstr';
var $2a142e07fdcca311$export$1f2bb630327ac4b6 = /*#__PURE__*/ function() {
    function Client() {
        var _this = this;
        var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, _ref$localStorageKey = _ref.localStorageKey, localStorageKey = _ref$localStorageKey === void 0 ? (0, $80LFe.LOCAL_STORAGE_KEY) : _ref$localStorageKey, overrideAdapter = _ref.overrideAdapter;
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, Client);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "initPromise", null);
        /** True if an initialize method was called and completed successfully. */ (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "initCompleted", false);
        /**
     * True if an initialize method was called and completed, meaning the client is now usable.
     * However if there was an error during initialization it may have initialized with default
     * values. Use {@link initCompleted} to check for this.
     */ (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "initWithDefaults", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "hasCheckGateErrorOccurred", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "hasGetExperimentErrorOccurred", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "hasGetExperimentValueErrorOccurred", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "hasGetLayerErrorOccurred", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "hasGetLayerValueErrorOccurred", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "subscriptions", new (0, $kJAvC.default)());
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "dataAdapter", new (0, $5MYIV.NoFetchDataAdapter)());
        /**
     * Call this if modifying the values being served by the Statsig library since it has its own
     * memoization cache which will not be updated if the values are changed outside of the library.
     */ (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "statsigValuesUpdated", function() {
            if (_this.user) // Trigger a reset of the memoize cache
            _this.statsigClient.updateUserSync(_this.user, {
                disableBackgroundCacheRefresh: true
            });
            _this.subscriptions.anyUpdated();
        });
        this.overrideAdapter = overrideAdapter || new (0, $80LFe.PersistentOverrideAdapter)(localStorageKey);
    }
    /**
   * @description
   * This method initializes the client using a network call to fetch the bootstrap values.
   * If the client is inialized with an `analyticsWebClient`, it will send an operational event
   * to GASv3 with the following attributes:
   * - targetApp: the target app of the client
   * - clientVersion: the version of the client
   * - success: whether the initialization was successful
   * - startTime: the time when the initialization started
   * - totalTime: the total time it took to initialize the client
   * - apiKey: the api key used to initialize the client
   * @param clientOptions {ClientOptions}
   * @param identifiers {Identifiers}
   * @param customAttributes {CustomAttributes}
   * @returns {Promise<void>}
   */ return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(Client, [
        {
            key: "initialize",
            value: function() {
                var _initialize = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee(clientOptions, identifiers, customAttributes) {
                    var _this2 = this;
                    var clientOptionsWithDefaults, startTime;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee$(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                clientOptionsWithDefaults = (0, $jGAYn.getOptionsWithDefaults)(clientOptions);
                                if (!this.initPromise) {
                                    _context.next = 4;
                                    break;
                                }
                                if (!(0, $jGAYn.shallowEquals)(clientOptionsWithDefaults, this.initOptions)) // eslint-disable-next-line no-console
                                console.warn('Feature Gates client already initialized with different options. New options were not applied.');
                                return _context.abrupt("return", this.initPromise);
                            case 4:
                                startTime = performance.now();
                                this.initOptions = clientOptionsWithDefaults;
                                this.initPromise = this.init(clientOptionsWithDefaults, identifiers, customAttributes).then(function() {
                                    _this2.initCompleted = true;
                                    _this2.initWithDefaults = true;
                                }).finally(function() {
                                    var endTime = performance.now();
                                    var totalTime = endTime - startTime;
                                    _this2.fireClientEvent(startTime, totalTime, 'initialize', _this2.initCompleted, clientOptionsWithDefaults.apiKey);
                                });
                                return _context.abrupt("return", this.initPromise);
                            case 8:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee, this);
                }));
                function initialize(_x, _x2, _x3) {
                    return _initialize.apply(this, arguments);
                }
                return initialize;
            }()
        },
        {
            key: "initializeWithProvider",
            value: function() {
                var _initializeWithProvider = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee2(clientOptions, provider, identifiers, customAttributes) {
                    var _this3 = this;
                    var clientOptionsWithDefaults, startTime;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee2$(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                clientOptionsWithDefaults = (0, $jGAYn.getOptionsWithDefaults)(clientOptions);
                                if (!this.initPromise) {
                                    _context2.next = 4;
                                    break;
                                }
                                if (!(0, $jGAYn.shallowEquals)(clientOptionsWithDefaults, this.initOptions)) // eslint-disable-next-line no-console
                                console.warn('Feature Gates client already initialized with different options. New options were not applied.');
                                return _context2.abrupt("return", this.initPromise);
                            case 4:
                                startTime = performance.now();
                                this.initOptions = clientOptionsWithDefaults;
                                this.provider = provider;
                                this.provider.setClientVersion((0, $6WhoI.CLIENT_VERSION));
                                if (this.provider.setApplyUpdateCallback) this.provider.setApplyUpdateCallback(this.applyUpdateCallback.bind(this));
                                this.initPromise = this.initWithProvider(clientOptionsWithDefaults, provider, identifiers, customAttributes).then(function() {
                                    _this3.initCompleted = true;
                                    _this3.initWithDefaults = true;
                                }).finally(function() {
                                    var endTime = performance.now();
                                    var totalTime = endTime - startTime;
                                    _this3.fireClientEvent(startTime, totalTime, 'initializeWithProvider', _this3.initCompleted, provider.getApiKey ? provider.getApiKey() : undefined);
                                });
                                return _context2.abrupt("return", this.initPromise);
                            case 11:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2, this);
                }));
                function initializeWithProvider(_x4, _x5, _x6, _x7) {
                    return _initializeWithProvider.apply(this, arguments);
                }
                return initializeWithProvider;
            }()
        },
        {
            key: "applyUpdateCallback",
            value: function applyUpdateCallback(experimentsResult) {
                try {
                    if (this.initCompleted || this.initWithDefaults) {
                        this.assertInitialized(this.statsigClient);
                        this.dataAdapter.setBootstrapData(experimentsResult.experimentValues);
                        this.dataAdapter.setData(JSON.stringify(experimentsResult.experimentValues));
                        this.statsigValuesUpdated();
                    }
                } catch (error) {
                    // eslint-disable-next-line no-console
                    console.warn('Error when attempting to apply update', error);
                }
            }
        },
        {
            key: "fireClientEvent",
            value: function fireClientEvent(startTime, totalTime, action, success) {
                var _analyticsWebClient, _this4 = this;
                var apiKey = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
                (_analyticsWebClient = this.initOptions.analyticsWebClient) === null || _analyticsWebClient === void 0 || _analyticsWebClient.then(function(analyticsWebClient) {
                    var attributes = $2a142e07fdcca311$var$_objectSpread({
                        targetApp: _this4.initOptions.targetApp,
                        clientVersion: (0, $6WhoI.CLIENT_VERSION),
                        success: success,
                        startTime: startTime,
                        totalTime: totalTime
                    }, apiKey && {
                        apiKey: apiKey
                    });
                    analyticsWebClient.sendOperationalEvent({
                        action: action,
                        actionSubject: 'featureGatesClient',
                        attributes: attributes,
                        tags: [
                            'measurement'
                        ],
                        source: '@atlaskit/feature-gate-js-client'
                    });
                }).catch(function(err) {
                    if (_this4.initOptions.environment !== (0, $cXGvu.FeatureGateEnvironment).Production) // eslint-disable-next-line no-console
                    console.error('Analytics web client promise did not resolve', err);
                });
            }
        },
        {
            key: "initializeFromValues",
            value: function() {
                var _initializeFromValues = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee3(clientOptions, identifiers, customAttributes) {
                    var _this5 = this;
                    var initializeValues, clientOptionsWithDefaults, startTime, _args3 = arguments;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee3$(_context3) {
                        while(true)switch(_context3.prev = _context3.next){
                            case 0:
                                initializeValues = _args3.length > 3 && _args3[3] !== undefined ? _args3[3] : {};
                                clientOptionsWithDefaults = (0, $jGAYn.getOptionsWithDefaults)(clientOptions);
                                if (!this.initPromise) {
                                    _context3.next = 5;
                                    break;
                                }
                                if (!(0, $jGAYn.shallowEquals)(clientOptionsWithDefaults, this.initOptions)) // eslint-disable-next-line no-console
                                console.warn('Feature Gates client already initialized with different options. New options were not applied.');
                                return _context3.abrupt("return", this.initPromise);
                            case 5:
                                // This makes sure the new Statsig client behaves like the old when bootstrap data is
                                // passed, and `has_updates` isn't specified (which happens a lot in product integration tests).
                                if (!Object.prototype.hasOwnProperty.call(initializeValues, 'has_updates')) initializeValues['has_updates'] = true;
                                startTime = performance.now();
                                this.initOptions = clientOptionsWithDefaults;
                                this.initPromise = this.initFromValues(clientOptionsWithDefaults, identifiers, customAttributes, initializeValues).then(function() {
                                    _this5.initCompleted = true;
                                    _this5.initWithDefaults = true;
                                }).finally(function() {
                                    var endTime = performance.now();
                                    var totalTime = endTime - startTime;
                                    _this5.fireClientEvent(startTime, totalTime, 'initializeFromValues', _this5.initCompleted);
                                });
                                return _context3.abrupt("return", this.initPromise);
                            case 10:
                            case "end":
                                return _context3.stop();
                        }
                    }, _callee3, this);
                }));
                function initializeFromValues(_x8, _x9, _x0) {
                    return _initializeFromValues.apply(this, arguments);
                }
                return initializeFromValues;
            }()
        },
        {
            key: "assertInitialized",
            value: function assertInitialized(statsigClient) {
                if (!statsigClient) throw new Error('Client must be initialized before using this method');
            }
        },
        {
            key: "updateUser",
            value: function() {
                var _updateUser = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee4(fetchOptions, identifiers, customAttributes) {
                    var fetchOptionsWithDefaults, initializeValuesProducer;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee4$(_context4) {
                        while(true)switch(_context4.prev = _context4.next){
                            case 0:
                                this.assertInitialized(this.statsigClient);
                                fetchOptionsWithDefaults = (0, $jGAYn.getOptionsWithDefaults)(fetchOptions);
                                initializeValuesProducer = function initializeValuesProducer() {
                                    return (0, $f9px2.default).fetchExperimentValues(fetchOptionsWithDefaults, identifiers, customAttributes).then(function(_ref2) {
                                        var experimentValues = _ref2.experimentValues, customAttributes = _ref2.customAttributes;
                                        return {
                                            experimentValues: experimentValues,
                                            customAttributesFromFetch: customAttributes
                                        };
                                    });
                                };
                                _context4.next = 5;
                                return this.updateUserUsingInitializeValuesProducer(initializeValuesProducer, identifiers, customAttributes);
                            case 5:
                            case "end":
                                return _context4.stop();
                        }
                    }, _callee4, this);
                }));
                function updateUser(_x1, _x10, _x11) {
                    return _updateUser.apply(this, arguments);
                }
                return updateUser;
            }()
        },
        {
            key: "updateUserWithProvider",
            value: function() {
                var _updateUserWithProvider = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee5(identifiers, customAttributes) {
                    var _this6 = this;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee5$(_context5) {
                        while(true)switch(_context5.prev = _context5.next){
                            case 0:
                                this.assertInitialized(this.statsigClient);
                                if (this.provider) {
                                    _context5.next = 3;
                                    break;
                                }
                                throw new Error('Cannot update user using provider as the client was not initialised with a provider');
                            case 3:
                                _context5.next = 5;
                                return this.provider.setProfile(this.initOptions, identifiers, customAttributes);
                            case 5:
                                _context5.next = 7;
                                return this.updateUserUsingInitializeValuesProducer(function() {
                                    return _this6.provider.getExperimentValues();
                                }, identifiers, customAttributes);
                            case 7:
                            case "end":
                                return _context5.stop();
                        }
                    }, _callee5, this);
                }));
                function updateUserWithProvider(_x12, _x13) {
                    return _updateUserWithProvider.apply(this, arguments);
                }
                return updateUserWithProvider;
            }()
        },
        {
            key: "updateUserWithValues",
            value: function() {
                var _updateUserWithValues = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee6(identifiers, customAttributes) {
                    var initializeValues, initializeValuesProducer, _args6 = arguments;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee6$(_context6) {
                        while(true)switch(_context6.prev = _context6.next){
                            case 0:
                                initializeValues = _args6.length > 2 && _args6[2] !== undefined ? _args6[2] : {};
                                this.assertInitialized(this.statsigClient);
                                initializeValuesProducer = function initializeValuesProducer() {
                                    return Promise.resolve({
                                        experimentValues: initializeValues,
                                        customAttributesFromFetch: customAttributes
                                    });
                                };
                                _context6.next = 5;
                                return this.updateUserUsingInitializeValuesProducer(initializeValuesProducer, identifiers, customAttributes);
                            case 5:
                            case "end":
                                return _context6.stop();
                        }
                    }, _callee6, this);
                }));
                function updateUserWithValues(_x14, _x15) {
                    return _updateUserWithValues.apply(this, arguments);
                }
                return updateUserWithValues;
            }()
        },
        {
            key: "initializeCalled",
            value: function initializeCalled() {
                return this.initPromise != null;
            }
        },
        {
            key: "initializeCompleted",
            value: function initializeCompleted() {
                return this.initCompleted;
            }
        },
        {
            key: "waitUntilInitializeCompleted",
            value: function() {
                var _waitUntilInitializeCompleted = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee7() {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee7$(_context7) {
                        while(true)switch(_context7.prev = _context7.next){
                            case 0:
                                if (this.initPromise) {
                                    _context7.next = 2;
                                    break;
                                }
                                throw new Error('The client must be initialized before you can wait until initialized.');
                            case 2:
                                if (!this.initCompleted) {
                                    _context7.next = 4;
                                    break;
                                }
                                return _context7.abrupt("return");
                            case 4:
                                _context7.next = 6;
                                return this.initPromise;
                            case 6:
                            case "end":
                                return _context7.stop();
                        }
                    }, _callee7, this);
                }));
                function waitUntilInitializeCompleted() {
                    return _waitUntilInitializeCompleted.apply(this, arguments);
                }
                return waitUntilInitializeCompleted;
            }()
        },
        {
            key: "checkGate",
            value: function checkGate(gateName) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                try {
                    this.assertInitialized(this.statsigClient);
                    var _options$fireGateExpo = options.fireGateExposure, fireGateExposure = _options$fireGateExpo === void 0 ? true : _options$fireGateExpo;
                    return this.statsigClient.checkGate(gateName, {
                        disableExposureLog: !fireGateExposure
                    });
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!this.hasCheckGateErrorOccurred) {
                        // eslint-disable-next-line no-console
                        console.warn({
                            msg: 'An error has occurred checking the feature gate. Only the first occurrence of this error is logged.',
                            gateName: gateName,
                            error: error
                        });
                        this.hasCheckGateErrorOccurred = true;
                    }
                    return false;
                }
            }
        },
        {
            key: "isGateExist",
            value: function isGateExist(gateName) {
                try {
                    this.assertInitialized(this.statsigClient);
                    var gate = this.statsigClient.getFeatureGate(gateName, {
                        disableExposureLog: true
                    });
                    return !gate.details.reason.includes('Unrecognized');
                } catch (error) {
                    // eslint-disable-next-line no-console
                    console.error("Error occurred when trying to check FeatureGate: ".concat(error));
                    // in case of error report true to avoid false positives.
                    return true;
                }
            }
        },
        {
            key: "isExperimentExist",
            value: function isExperimentExist(experimentName) {
                try {
                    this.assertInitialized(this.statsigClient);
                    var config = this.statsigClient.getExperiment(experimentName, {
                        disableExposureLog: true
                    });
                    return !config.details.reason.includes('Unrecognized');
                } catch (error) {
                    // eslint-disable-next-line no-console
                    console.error("Error occurred when trying to check Experiment: ".concat(error));
                    // in case of error report true to avoid false positives.
                    return true;
                }
            }
        },
        {
            key: "manuallyLogGateExposure",
            value: function manuallyLogGateExposure(gateName) {
                this.assertInitialized(this.statsigClient);
                // This is the approach recommended in the docs
                // https://docs.statsig.com/client/javascript-sdk/#manual-exposures-
                this.statsigClient.checkGate(gateName);
            }
        },
        {
            key: "getExperiment",
            value: function getExperiment(experimentName) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                try {
                    this.assertInitialized(this.statsigClient);
                    var _options$fireExperime = options.fireExperimentExposure, fireExperimentExposure = _options$fireExperime === void 0 ? true : _options$fireExperime;
                    return (0, $bA77O.DynamicConfig).fromExperiment(this.statsigClient.getExperiment(experimentName, {
                        disableExposureLog: !fireExperimentExposure
                    }));
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!this.hasGetExperimentErrorOccurred) {
                        // eslint-disable-next-line no-console
                        console.warn({
                            msg: 'An error has occurred getting the experiment. Only the first occurrence of this error is logged.',
                            experimentName: experimentName,
                            error: error
                        });
                        this.hasGetExperimentErrorOccurred = true;
                    }
                    // Return a default value
                    return new (0, $bA77O.DynamicConfig)(experimentName, {}, '', {
                        time: Date.now(),
                        reason: (0, $icCTV.EvaluationReason).Error
                    });
                }
            }
        },
        {
            key: "getExperimentValue",
            value: function getExperimentValue(experimentName, parameterName, defaultValue) {
                var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var experiment = this.getExperiment(experimentName, options);
                try {
                    var typeGuard = options.typeGuard;
                    return experiment.get(parameterName, defaultValue, typeGuard);
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!this.hasGetExperimentValueErrorOccurred) {
                        // eslint-disable-next-line no-console
                        console.warn({
                            msg: 'An error has occurred getting the experiment value. Only the first occurrence of this error is logged.',
                            experimentName: experimentName,
                            defaultValue: defaultValue,
                            options: options,
                            error: error
                        });
                        this.hasGetExperimentValueErrorOccurred = true;
                    }
                    return defaultValue;
                }
            }
        },
        {
            key: "manuallyLogExperimentExposure",
            value: function manuallyLogExperimentExposure(experimentName) {
                this.assertInitialized(this.statsigClient);
                // This is the approach recommended in the docs
                // https://docs.statsig.com/client/javascript-sdk/#manual-exposures-
                this.statsigClient.getExperiment(experimentName);
            }
        },
        {
            key: "manuallyLogLayerExposure",
            value: function manuallyLogLayerExposure(layerName, parameterName) {
                var _this$statsigClient$g;
                this.assertInitialized(this.statsigClient);
                // This is the approach recommended in the docs
                // https://docs.statsig.com/client/javascript-sdk/#manual-exposures-
                (_this$statsigClient$g = this.statsigClient.getLayer(layerName)) === null || _this$statsigClient$g === void 0 || _this$statsigClient$g.get(parameterName);
            }
        },
        {
            key: "shutdownStatsig",
            value: function shutdownStatsig() {
                this.assertInitialized(this.statsigClient);
                this.statsigClient.shutdown();
            }
        },
        {
            key: "overrideGate",
            value: function overrideGate(gateName, value) {
                this.overrideAdapter.overrideGate(gateName, value);
                // Trigger a reset of the memoized gate value
                if (this.user) {
                    var _this$statsigClient;
                    (_this$statsigClient = this.statsigClient) === null || _this$statsigClient === void 0 || _this$statsigClient.updateUserSync(this.user, {
                        disableBackgroundCacheRefresh: true
                    });
                }
                this.statsigValuesUpdated();
            }
        },
        {
            key: "clearGateOverride",
            value: function clearGateOverride(gateName) {
                this.overrideAdapter.removeGateOverride(gateName);
                this.statsigValuesUpdated();
            }
        },
        {
            key: "overrideConfig",
            value: function overrideConfig(experimentName, values) {
                this.overrideAdapter.overrideDynamicConfig(experimentName, values);
                this.statsigValuesUpdated();
            }
        },
        {
            key: "clearConfigOverride",
            value: function clearConfigOverride(experimentName) {
                this.overrideAdapter.removeDynamicConfigOverride(experimentName);
                this.statsigValuesUpdated();
            }
        },
        {
            key: "setOverrides",
            value: function setOverrides(overrides) {
                this.overrideAdapter.setOverrides(overrides);
                this.statsigValuesUpdated();
            }
        },
        {
            key: "getOverrides",
            value: function getOverrides() {
                return this.overrideAdapter.getOverrides();
            }
        },
        {
            key: "clearAllOverrides",
            value: function clearAllOverrides() {
                this.overrideAdapter.removeAllOverrides();
                this.statsigValuesUpdated();
            }
        },
        {
            key: "isCurrentUser",
            value: function isCurrentUser(identifiers, customAttributes) {
                return (0, $jGAYn.shallowEquals)(this.currentIdentifiers, identifiers) && (0, $jGAYn.shallowEquals)(this.currentAttributes, customAttributes);
            }
        },
        {
            key: "onGateUpdated",
            value: function onGateUpdated(gateName, callback) {
                var _this7 = this;
                var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var wrapCallback = function wrapCallback(value) {
                    var _options$fireGateExpo2 = options.fireGateExposure, fireGateExposure = _options$fireGateExpo2 === void 0 ? true : _options$fireGateExpo2;
                    if (fireGateExposure) _this7.manuallyLogGateExposure(gateName);
                    try {
                        callback(value);
                    } catch (error) {
                        // eslint-disable-next-line no-console
                        console.warn("Error calling callback for gate ".concat(gateName, " with value ").concat(value), error);
                    }
                };
                return this.subscriptions.onGateUpdated(gateName, wrapCallback, this.checkGate.bind(this), options);
            }
        },
        {
            key: "onExperimentValueUpdated",
            value: function onExperimentValueUpdated(experimentName, parameterName, defaultValue, callback) {
                var _this8 = this;
                var options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
                var wrapCallback = function wrapCallback(value) {
                    var _options$fireExperime2 = options.fireExperimentExposure, fireExperimentExposure = _options$fireExperime2 === void 0 ? true : _options$fireExperime2;
                    if (fireExperimentExposure) _this8.manuallyLogExperimentExposure(experimentName);
                    try {
                        callback(value);
                    } catch (error) {
                        // eslint-disable-next-line no-console
                        console.warn("Error calling callback for experiment ".concat(experimentName, " with value ").concat(value), error);
                    }
                };
                return this.subscriptions.onExperimentValueUpdated(experimentName, parameterName, defaultValue, wrapCallback, this.getExperimentValue.bind(this), options);
            }
        },
        {
            key: "onAnyUpdated",
            value: function onAnyUpdated(callback) {
                return this.subscriptions.onAnyUpdated(callback);
            }
        },
        {
            key: "init",
            value: function() {
                var _init = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee8(clientOptions, identifiers, customAttributes) {
                    var fromValuesClientOptions, experimentValues, customAttributesFromResult, clientSdkKeyPromise, experimentValuesPromise, _yield$Promise$all, _yield$Promise$all2, experimentValuesResult;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee8$(_context8) {
                        while(true)switch(_context8.prev = _context8.next){
                            case 0:
                                fromValuesClientOptions = $2a142e07fdcca311$var$_objectSpread({}, clientOptions);
                                _context8.prev = 1;
                                // If client sdk key fetch fails, an error would be thrown and handled instead of waiting for
                                // the experiment values request to be settled, and it will fall back to use default values.
                                clientSdkKeyPromise = (0, $f9px2.default).fetchClientSdk(clientOptions).then(function(value) {
                                    return fromValuesClientOptions.sdkKey = value.clientSdkKey;
                                });
                                experimentValuesPromise = (0, $f9px2.default).fetchExperimentValues(clientOptions, identifiers, customAttributes); // Only wait for the experiment values request to finish and try to initialise the client
                                // with experiment values if both requests are successful. Else an error would be thrown and
                                // handled by the catch
                                _context8.next = 6;
                                return Promise.all([
                                    clientSdkKeyPromise,
                                    experimentValuesPromise
                                ]);
                            case 6:
                                _yield$Promise$all = _context8.sent;
                                _yield$Promise$all2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_yield$Promise$all, 2);
                                experimentValuesResult = _yield$Promise$all2[1];
                                experimentValues = experimentValuesResult.experimentValues;
                                customAttributesFromResult = experimentValuesResult.customAttributes;
                                _context8.next = 20;
                                break;
                            case 13:
                                _context8.prev = 13;
                                _context8.t0 = _context8["catch"](1);
                                if (_context8.t0 instanceof Error) // eslint-disable-next-line no-console
                                console.error("Error occurred when trying to fetch the Feature Gates client values, error: ".concat(_context8.t0 === null || _context8.t0 === void 0 ? void 0 : _context8.t0.message));
                                // eslint-disable-next-line no-console
                                console.warn("Initialising Statsig client without values");
                                _context8.next = 19;
                                return this.initFromValues(fromValuesClientOptions, identifiers, customAttributes);
                            case 19:
                                throw _context8.t0;
                            case 20:
                                return _context8.abrupt("return", this.initFromValues(fromValuesClientOptions, identifiers, customAttributesFromResult, experimentValues));
                            case 21:
                            case "end":
                                return _context8.stop();
                        }
                    }, _callee8, this, [
                        [
                            1,
                            13
                        ]
                    ]);
                }));
                function init(_x16, _x17, _x18) {
                    return _init.apply(this, arguments);
                }
                return init;
            }()
        },
        {
            key: "initWithProvider",
            value: function() {
                var _initWithProvider = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee9(baseClientOptions, provider, identifiers, customAttributes) {
                    var fromValuesClientOptions, experimentValues, customAttributesFromResult, clientSdkKeyPromise, experimentValuesPromise, _yield$Promise$all3, _yield$Promise$all4, experimentValuesResult;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee9$(_context9) {
                        while(true)switch(_context9.prev = _context9.next){
                            case 0:
                                fromValuesClientOptions = $2a142e07fdcca311$var$_objectSpread($2a142e07fdcca311$var$_objectSpread({}, baseClientOptions), {}, {
                                    disableCurrentPageLogging: true
                                });
                                _context9.prev = 1;
                                _context9.next = 4;
                                return provider.setProfile(baseClientOptions, identifiers, customAttributes);
                            case 4:
                                // If client sdk key fetch fails, an error would be thrown and handled instead of waiting for
                                // the experiment values request to be settled, and it will fall back to use default values.
                                clientSdkKeyPromise = provider.getClientSdkKey().then(function(value) {
                                    return fromValuesClientOptions.sdkKey = value;
                                });
                                experimentValuesPromise = provider.getExperimentValues(); // Only wait for the experiment values request to finish and try to initialise the client
                                // with experiment values if both requests are successful. Else an error would be thrown and
                                // handled by the catch
                                _context9.next = 8;
                                return Promise.all([
                                    clientSdkKeyPromise,
                                    experimentValuesPromise
                                ]);
                            case 8:
                                _yield$Promise$all3 = _context9.sent;
                                _yield$Promise$all4 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_yield$Promise$all3, 2);
                                experimentValuesResult = _yield$Promise$all4[1];
                                experimentValues = experimentValuesResult.experimentValues;
                                customAttributesFromResult = experimentValuesResult.customAttributesFromFetch;
                                _context9.next = 22;
                                break;
                            case 15:
                                _context9.prev = 15;
                                _context9.t0 = _context9["catch"](1);
                                if (_context9.t0 instanceof Error) // eslint-disable-next-line no-console
                                console.error("Error occurred when trying to fetch the Feature Gates client values, error: ".concat(_context9.t0 === null || _context9.t0 === void 0 ? void 0 : _context9.t0.message));
                                // eslint-disable-next-line no-console
                                console.warn("Initialising Statsig client without values");
                                _context9.next = 21;
                                return this.initFromValues(fromValuesClientOptions, identifiers, customAttributes);
                            case 21:
                                throw _context9.t0;
                            case 22:
                                return _context9.abrupt("return", this.initFromValues(fromValuesClientOptions, identifiers, customAttributesFromResult, experimentValues));
                            case 23:
                            case "end":
                                return _context9.stop();
                        }
                    }, _callee9, this, [
                        [
                            1,
                            15
                        ]
                    ]);
                }));
                function initWithProvider(_x19, _x20, _x21, _x22) {
                    return _initWithProvider.apply(this, arguments);
                }
                return initWithProvider;
            }()
        },
        {
            key: "initFromValues",
            value: function() {
                var _initFromValues = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee0(clientOptions, identifiers, customAttributes) {
                    var _newClientOptions$net;
                    var initializeValues, newClientOptions, sdkKey, environment, _updateUserCompletionCallback, _perimeter, restClientOptions, statsigOptions, _args0 = arguments;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee0$(_context0) {
                        while(true)switch(_context0.prev = _context0.next){
                            case 0:
                                initializeValues = _args0.length > 3 && _args0[3] !== undefined ? _args0[3] : {};
                                this.overrideAdapter.initFromStoredOverrides();
                                this.currentIdentifiers = identifiers;
                                this.currentAttributes = customAttributes;
                                newClientOptions = (0, $jGAYn.migrateInitializationOptions)(clientOptions);
                                if (!newClientOptions.sdkKey) newClientOptions.sdkKey = $2a142e07fdcca311$var$DEFAULT_CLIENT_KEY;
                                if (!((_newClientOptions$net = newClientOptions.networkConfig) !== null && _newClientOptions$net !== void 0 && _newClientOptions$net.logEventUrl)) newClientOptions.networkConfig = $2a142e07fdcca311$var$_objectSpread($2a142e07fdcca311$var$_objectSpread({}, newClientOptions.networkConfig), {}, {
                                    logEventUrl: $2a142e07fdcca311$var$DEFAULT_EVENT_LOGGING_API
                                });
                                if (newClientOptions.perimeter === (0, $cXGvu.PerimeterType).FEDRAMP_MODERATE) // disable all logging in FedRAMP to prevent egress of sensitive data
                                newClientOptions.disableLogging = true;
                                sdkKey = newClientOptions.sdkKey, environment = newClientOptions.environment, _updateUserCompletionCallback = newClientOptions.updateUserCompletionCallback, _perimeter = newClientOptions.perimeter, restClientOptions = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(newClientOptions, $2a142e07fdcca311$var$_excluded);
                                this.user = (0, $jGAYn.toStatsigUser)(identifiers, customAttributes);
                                statsigOptions = $2a142e07fdcca311$var$_objectSpread($2a142e07fdcca311$var$_objectSpread({}, restClientOptions), {}, {
                                    environment: {
                                        tier: environment
                                    },
                                    includeCurrentPageUrlWithEvents: false,
                                    dataAdapter: this.dataAdapter,
                                    overrideAdapter: this.overrideAdapter,
                                    logEventCompressionMode: (0, $iFR7a.LogEventCompressionMode).Forced
                                }); // Statsig validates the provided stableId against their own cookie, so we either need
                                // to update the cookie to match, or disable the validation completely.
                                if (identifiers.stableId) (0, $iFR7a.StableID).setOverride(identifiers.stableId, sdkKey);
                                else statsigOptions.disableStableID = true;
                                _context0.prev = 12;
                                this.statsigClient = new (0, $iFR7a.StatsigClient)(sdkKey, this.user, statsigOptions);
                                this.dataAdapter.setBootstrapData(initializeValues);
                                _context0.next = 17;
                                return this.statsigClient.initializeAsync();
                            case 17:
                                _context0.next = 29;
                                break;
                            case 19:
                                _context0.prev = 19;
                                _context0.t0 = _context0["catch"](12);
                                if (_context0.t0 instanceof Error) // eslint-disable-next-line no-console
                                console.error("Error occurred when trying to initialise the Statsig client, error: ".concat(_context0.t0 === null || _context0.t0 === void 0 ? void 0 : _context0.t0.message));
                                // eslint-disable-next-line no-console
                                console.warn("Initialising Statsig client with default sdk key and without values");
                                this.statsigClient = new (0, $iFR7a.StatsigClient)($2a142e07fdcca311$var$DEFAULT_CLIENT_KEY, this.user, statsigOptions);
                                this.dataAdapter.setBootstrapData();
                                _context0.next = 27;
                                return this.statsigClient.initializeAsync();
                            case 27:
                                this.initWithDefaults = true;
                                throw _context0.t0;
                            case 29:
                            case "end":
                                return _context0.stop();
                        }
                    }, _callee0, this, [
                        [
                            12,
                            19
                        ]
                    ]);
                }));
                function initFromValues(_x23, _x24, _x25) {
                    return _initFromValues.apply(this, arguments);
                }
                return initFromValues;
            }()
        },
        {
            key: "updateUserUsingInitializeValuesProducer",
            value: function() {
                var _updateUserUsingInitializeValuesProducer = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee10(getInitializeValues, identifiers, customAttributes) {
                    var _this9 = this;
                    var originalInitPromise, initializeValuesPromise, updateUserPromise;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee10$(_context10) {
                        while(true)switch(_context10.prev = _context10.next){
                            case 0:
                                this.assertInitialized(this.statsigClient);
                                if (this.initPromise) {
                                    _context10.next = 3;
                                    break;
                                }
                                throw new Error('The client must be initialized before you can update the user.');
                            case 3:
                                if (!this.isCurrentUser(identifiers, customAttributes)) {
                                    _context10.next = 5;
                                    break;
                                }
                                return _context10.abrupt("return", this.initPromise);
                            case 5:
                                // Wait for the current initialize/update to finish
                                originalInitPromise = this.initPromise;
                                _context10.prev = 6;
                                _context10.next = 9;
                                return this.initPromise;
                            case 9:
                                _context10.next = 13;
                                break;
                            case 11:
                                _context10.prev = 11;
                                _context10.t0 = _context10["catch"](6);
                            case 13:
                                initializeValuesPromise = getInitializeValues();
                                updateUserPromise = this.updateStatsigClientUser(initializeValuesPromise, identifiers, customAttributes); // We replace the init promise here since we are essentially re-initializing the client at this
                                // point. Any subsequent calls to await client.initialize() or client.updateUser()
                                // will now also await this user update.
                                this.initPromise = updateUserPromise.catch(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee1() {
                                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee1$(_context1) {
                                        while(true)switch(_context1.prev = _context1.next){
                                            case 0:
                                                // If the update failed then it changed nothing, so revert back to the original promise.
                                                _this9.initPromise = originalInitPromise;
                                                // Set the user profile again to revert back to the current user
                                                if (!_this9.provider) {
                                                    _context1.next = 4;
                                                    break;
                                                }
                                                _context1.next = 4;
                                                return _this9.provider.setProfile(_this9.initOptions, _this9.currentIdentifiers, _this9.currentAttributes);
                                            case 4:
                                            case "end":
                                                return _context1.stop();
                                        }
                                    }, _callee1);
                                })));
                                return _context10.abrupt("return", updateUserPromise);
                            case 17:
                            case "end":
                                return _context10.stop();
                        }
                    }, _callee10, this, [
                        [
                            6,
                            11
                        ]
                    ]);
                }));
                function updateUserUsingInitializeValuesProducer(_x26, _x27, _x28) {
                    return _updateUserUsingInitializeValuesProducer.apply(this, arguments);
                }
                return updateUserUsingInitializeValuesProducer;
            }()
        },
        {
            key: "updateStatsigClientUser",
            value: function() {
                var _updateStatsigClientUser = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee11(initializeValuesPromise, identifiers, customAttributes) {
                    var _this$initOptions, _this$initOptions$upd;
                    var initializeValues, user, _updateUserCompletion, _ref4, errMsg, success, errorMessage;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee11$(_context11) {
                        while(true)switch(_context11.prev = _context11.next){
                            case 0:
                                this.assertInitialized(this.statsigClient);
                                _context11.prev = 1;
                                _context11.next = 4;
                                return initializeValuesPromise;
                            case 4:
                                initializeValues = _context11.sent;
                                user = (0, $jGAYn.toStatsigUser)(identifiers, initializeValues.customAttributesFromFetch);
                                _context11.next = 13;
                                break;
                            case 8:
                                _context11.prev = 8;
                                _context11.t0 = _context11["catch"](1);
                                // Make sure the updateUserCompletionCallback is called for any errors in our custom code.
                                // This is not necessary for the updateUserWithValues call, because the Statsig client will
                                // already invoke the callback itself.
                                errMsg = _context11.t0 instanceof Error ? _context11.t0.message : JSON.stringify(_context11.t0);
                                (_updateUserCompletion = (_ref4 = this.initOptions).updateUserCompletionCallback) === null || _updateUserCompletion === void 0 || _updateUserCompletion.call(_ref4, false, errMsg);
                                throw _context11.t0;
                            case 13:
                                success = true;
                                errorMessage = null;
                                _context11.prev = 15;
                                this.dataAdapter.setBootstrapData(initializeValues.experimentValues);
                                this.user = user;
                                if (!this.user) {
                                    _context11.next = 21;
                                    break;
                                }
                                _context11.next = 21;
                                return this.statsigClient.updateUserAsync(this.user);
                            case 21:
                                _context11.next = 27;
                                break;
                            case 23:
                                _context11.prev = 23;
                                _context11.t1 = _context11["catch"](15);
                                success = false;
                                errorMessage = String(_context11.t1);
                            case 27:
                                (_this$initOptions = this.initOptions) === null || _this$initOptions === void 0 || (_this$initOptions$upd = _this$initOptions.updateUserCompletionCallback) === null || _this$initOptions$upd === void 0 || _this$initOptions$upd.call(_this$initOptions, success, errorMessage);
                                if (!success) {
                                    _context11.next = 34;
                                    break;
                                }
                                this.currentIdentifiers = identifiers;
                                this.currentAttributes = customAttributes;
                                this.subscriptions.anyUpdated();
                                _context11.next = 35;
                                break;
                            case 34:
                                throw new Error('Failed to update user. An unexpected error occured.');
                            case 35:
                            case "end":
                                return _context11.stop();
                        }
                    }, _callee11, this, [
                        [
                            1,
                            8
                        ],
                        [
                            15,
                            23
                        ]
                    ]);
                }));
                function updateStatsigClientUser(_x29, _x30, _x31) {
                    return _updateStatsigClientUser.apply(this, arguments);
                }
                return updateStatsigClientUser;
            }()
        },
        {
            key: "getPackageVersion",
            value: /**
     * @returns string version of the current package in semver style.
     */ function getPackageVersion() {
                return 0, $6WhoI.CLIENT_VERSION;
            }
        },
        {
            key: "getLayer",
            value: function getLayer(/** The name of the layer */ layerName) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                try {
                    this.assertInitialized(this.statsigClient);
                    var _options$fireLayerExp = options.fireLayerExposure, fireLayerExposure = _options$fireLayerExp === void 0 ? true : _options$fireLayerExp;
                    return (0, $gFo6M.Layer).fromLayer(this.statsigClient.getLayer(layerName, {
                        disableExposureLog: !fireLayerExposure
                    }));
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!this.hasGetLayerErrorOccurred) {
                        // eslint-disable-next-line no-console
                        console.warn({
                            msg: 'An error has occurred getting the layer. Only the first occurrence of this error is logged.',
                            layerName: layerName,
                            error: error
                        });
                        this.hasGetLayerErrorOccurred = true;
                    }
                    // Return a default value
                    return (0, $gFo6M.Layer).fromLayer((0, $iFR7a._makeLayer)(layerName, {
                        reason: 'Error'
                    }, null));
                }
            }
        },
        {
            key: "getLayerValue",
            value: function getLayerValue(layerName, parameterName, defaultValue) {
                var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var layer = this.getLayer(layerName, options);
                try {
                    var typeGuard = options.typeGuard;
                    return layer.get(parameterName, defaultValue, typeGuard);
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!this.hasGetLayerValueErrorOccurred) {
                        // eslint-disable-next-line no-console
                        console.warn({
                            msg: 'An error has occurred getting the layer value. Only the first occurrence of this error is logged.',
                            layerName: layerName,
                            defaultValue: defaultValue,
                            options: options,
                            error: error
                        });
                        this.hasGetLayerValueErrorOccurred = true;
                    }
                    return defaultValue;
                }
            }
        }
    ]);
}();

});
parcelRegister("1Vcia", function(module, exports) {

var $19a0g = parcelRequire("19a0g");
function $1664a63d282a7249$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $19a0g(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
module.exports = $1664a63d282a7249$var$_objectWithoutProperties, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("19a0g", function(module, exports) {
function $0d5e64210d12b637$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
module.exports = $0d5e64210d12b637$var$_objectWithoutPropertiesLoose, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("iYJcE", function(module, exports) {

var $4rHdx = parcelRequire("4rHdx");

var $1YVwW = parcelRequire("1YVwW");

var $ccaOk = parcelRequire("ccaOk");

var $lzFPZ = parcelRequire("lzFPZ");
function $dd10e4fe59ebf2c1$var$_slicedToArray(r, e) {
    return $4rHdx(r) || $1YVwW(r, e) || $ccaOk(r, e) || $lzFPZ();
}
module.exports = $dd10e4fe59ebf2c1$var$_slicedToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("4rHdx", function(module, exports) {
function $33cb35214efb072a$var$_arrayWithHoles(r) {
    if (Array.isArray(r)) return r;
}
module.exports = $33cb35214efb072a$var$_arrayWithHoles, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("1YVwW", function(module, exports) {
function $1718055c8ee40965$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
module.exports = $1718055c8ee40965$var$_iterableToArrayLimit, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("ccaOk", function(module, exports) {

var $7Edli = parcelRequire("7Edli");
function $8e0efdd2cb2ea886$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $7Edli(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $7Edli(r, a) : void 0;
    }
}
module.exports = $8e0efdd2cb2ea886$var$_unsupportedIterableToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("7Edli", function(module, exports) {
function $59169e612a7ccfc3$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
module.exports = $59169e612a7ccfc3$var$_arrayLikeToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("lzFPZ", function(module, exports) {
function $fb4d51eeedba6c65$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
module.exports = $fb4d51eeedba6c65$var$_nonIterableRest, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("fL8KA", function(module, exports) {
function $b7920873e945f960$var$asyncGeneratorStep(n, t, e, r, o, a, c) {
    try {
        var i = n[a](c), u = i.value;
    } catch (n) {
        return void e(n);
    }
    i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function $b7920873e945f960$var$_asyncToGenerator(n) {
    return function() {
        var t = this, e = arguments;
        return new Promise(function(r, o) {
            var a = n.apply(t, e);
            function _next(n) {
                $b7920873e945f960$var$asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
            }
            function _throw(n) {
                $b7920873e945f960$var$asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
            }
            _next(void 0);
        });
    };
}
module.exports = $b7920873e945f960$var$_asyncToGenerator, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("6HG4S", function(module, exports) {
// TODO(Babel 8): Remove this file.

var $4e1765f344e6d069$var$runtime = (parcelRequire("3F8qK"))();
module.exports = $4e1765f344e6d069$var$runtime;
// Copied from https://github.com/facebook/regenerator/blob/main/packages/runtime/runtime.js#L736=
try {
    regeneratorRuntime = $4e1765f344e6d069$var$runtime;
} catch (accidentalStrictMode) {
    if (typeof globalThis === "object") globalThis.regeneratorRuntime = $4e1765f344e6d069$var$runtime;
    else Function("r", "regeneratorRuntime = r")($4e1765f344e6d069$var$runtime);
}

});
parcelRegister("3F8qK", function(module, exports) {

var $ekGgq = parcelRequire("ekGgq");
var $2aabbd8f05fd3ff7$var$_typeof = $ekGgq.default;
function $2aabbd8f05fd3ff7$var$_regeneratorRuntime() {
    "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ 
    module.exports = $2aabbd8f05fd3ff7$var$_regeneratorRuntime = function _regeneratorRuntime() {
        return e;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports;
    var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function(t, e, r) {
        t[e] = r.value;
    }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag";
    function define(t, e, r) {
        return Object.defineProperty(t, e, {
            value: r,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }), t[e];
    }
    try {
        define({}, "");
    } catch (t) {
        define = function define(t, e, r) {
            return t[e] = r;
        };
    }
    function wrap(t, e, r, n) {
        var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []);
        return o(a, "_invoke", {
            value: makeInvokeMethod(t, r, c)
        }), a;
    }
    function tryCatch(t, e, r) {
        try {
            return {
                type: "normal",
                arg: t.call(e, r)
            };
        } catch (t) {
            return {
                type: "throw",
                arg: t
            };
        }
    }
    e.wrap = wrap;
    var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {};
    function Generator() {}
    function GeneratorFunction() {}
    function GeneratorFunctionPrototype() {}
    var p = {};
    define(p, a, function() {
        return this;
    });
    var d = Object.getPrototypeOf, v = d && d(d(values([])));
    v && v !== r && n.call(v, a) && (p = v);
    var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p);
    function defineIteratorMethods(t) {
        [
            "next",
            "throw",
            "return"
        ].forEach(function(e) {
            define(t, e, function(t) {
                return this._invoke(e, t);
            });
        });
    }
    function AsyncIterator(t, e) {
        function invoke(r, o, i, a) {
            var c = tryCatch(t[r], t, o);
            if ("throw" !== c.type) {
                var u = c.arg, h = u.value;
                return h && "object" == $2aabbd8f05fd3ff7$var$_typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function(t) {
                    invoke("next", t, i, a);
                }, function(t) {
                    invoke("throw", t, i, a);
                }) : e.resolve(h).then(function(t) {
                    u.value = t, i(u);
                }, function(t) {
                    return invoke("throw", t, i, a);
                });
            }
            a(c.arg);
        }
        var r;
        o(this, "_invoke", {
            value: function value(t, n) {
                function callInvokeWithMethodAndArg() {
                    return new e(function(e, r) {
                        invoke(t, n, e, r);
                    });
                }
                return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
            }
        });
    }
    function makeInvokeMethod(e, r, n) {
        var o = h;
        return function(i, a) {
            if (o === f) throw Error("Generator is already running");
            if (o === s) {
                if ("throw" === i) throw a;
                return {
                    value: t,
                    done: !0
                };
            }
            for(n.method = i, n.arg = a;;){
                var c = n.delegate;
                if (c) {
                    var u = maybeInvokeDelegate(c, n);
                    if (u) {
                        if (u === y) continue;
                        return u;
                    }
                }
                if ("next" === n.method) n.sent = n._sent = n.arg;
                else if ("throw" === n.method) {
                    if (o === h) throw o = s, n.arg;
                    n.dispatchException(n.arg);
                } else "return" === n.method && n.abrupt("return", n.arg);
                o = f;
                var p = tryCatch(e, r, n);
                if ("normal" === p.type) {
                    if (o = n.done ? s : l, p.arg === y) continue;
                    return {
                        value: p.arg,
                        done: n.done
                    };
                }
                "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg);
            }
        };
    }
    function maybeInvokeDelegate(e, r) {
        var n = r.method, o = e.iterator[n];
        if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y;
        var i = tryCatch(o, e.iterator, r.arg);
        if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y;
        var a = i.arg;
        return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y);
    }
    function pushTryEntry(t) {
        var e = {
            tryLoc: t[0]
        };
        1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e);
    }
    function resetTryEntry(t) {
        var e = t.completion || {};
        e.type = "normal", delete e.arg, t.completion = e;
    }
    function Context(t) {
        this.tryEntries = [
            {
                tryLoc: "root"
            }
        ], t.forEach(pushTryEntry, this), this.reset(!0);
    }
    function values(e) {
        if (e || "" === e) {
            var r = e[a];
            if (r) return r.call(e);
            if ("function" == typeof e.next) return e;
            if (!isNaN(e.length)) {
                var o = -1, i = function next() {
                    for(; ++o < e.length;)if (n.call(e, o)) return next.value = e[o], next.done = !1, next;
                    return next.value = t, next.done = !0, next;
                };
                return i.next = i;
            }
        }
        throw new TypeError($2aabbd8f05fd3ff7$var$_typeof(e) + " is not iterable");
    }
    return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", {
        value: GeneratorFunctionPrototype,
        configurable: !0
    }), o(GeneratorFunctionPrototype, "constructor", {
        value: GeneratorFunction,
        configurable: !0
    }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function(t) {
        var e = "function" == typeof t && t.constructor;
        return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name));
    }, e.mark = function(t) {
        return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t;
    }, e.awrap = function(t) {
        return {
            __await: t
        };
    }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function() {
        return this;
    }), e.AsyncIterator = AsyncIterator, e.async = function(t, r, n, o, i) {
        void 0 === i && (i = Promise);
        var a = new AsyncIterator(wrap(t, r, n, o), i);
        return e.isGeneratorFunction(r) ? a : a.next().then(function(t) {
            return t.done ? t.value : a.next();
        });
    }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function() {
        return this;
    }), define(g, "toString", function() {
        return "[object Generator]";
    }), e.keys = function(t) {
        var e = Object(t), r = [];
        for(var n in e)r.push(n);
        return r.reverse(), function next() {
            for(; r.length;){
                var t = r.pop();
                if (t in e) return next.value = t, next.done = !1, next;
            }
            return next.done = !0, next;
        };
    }, e.values = values, Context.prototype = {
        constructor: Context,
        reset: function reset(e) {
            if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for(var r in this)"t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t);
        },
        stop: function stop() {
            this.done = !0;
            var t = this.tryEntries[0].completion;
            if ("throw" === t.type) throw t.arg;
            return this.rval;
        },
        dispatchException: function dispatchException(e) {
            if (this.done) throw e;
            var r = this;
            function handle(n, o) {
                return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o;
            }
            for(var o = this.tryEntries.length - 1; o >= 0; --o){
                var i = this.tryEntries[o], a = i.completion;
                if ("root" === i.tryLoc) return handle("end");
                if (i.tryLoc <= this.prev) {
                    var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc");
                    if (c && u) {
                        if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
                        if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
                    } else if (c) {
                        if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
                    } else {
                        if (!u) throw Error("try statement without catch or finally");
                        if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
                    }
                }
            }
        },
        abrupt: function abrupt(t, e) {
            for(var r = this.tryEntries.length - 1; r >= 0; --r){
                var o = this.tryEntries[r];
                if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
                    var i = o;
                    break;
                }
            }
            i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
            var a = i ? i.completion : {};
            return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a);
        },
        complete: function complete(t, e) {
            if ("throw" === t.type) throw t.arg;
            return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y;
        },
        finish: function finish(t) {
            for(var e = this.tryEntries.length - 1; e >= 0; --e){
                var r = this.tryEntries[e];
                if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y;
            }
        },
        "catch": function _catch(t) {
            for(var e = this.tryEntries.length - 1; e >= 0; --e){
                var r = this.tryEntries[e];
                if (r.tryLoc === t) {
                    var n = r.completion;
                    if ("throw" === n.type) {
                        var o = n.arg;
                        resetTryEntry(r);
                    }
                    return o;
                }
            }
            throw Error("illegal catch attempt");
        },
        delegateYield: function delegateYield(e, r, n) {
            return this.delegate = {
                iterator: values(e),
                resultName: r,
                nextLoc: n
            }, "next" === this.method && (this.arg = t), y;
        }
    }, e;
}
module.exports = $2aabbd8f05fd3ff7$var$_regeneratorRuntime, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("iFR7a", function(module, exports) {
"use strict";
var $d98541c52a8d8f29$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $d98541c52a8d8f29$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $d98541c52a8d8f29$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.StatsigClient = void 0;


var $i1p2j = parcelRequire("i1p2j");
module.exports.StatsigClient = $i1p2j.default;

$d98541c52a8d8f29$var$__exportStar((parcelRequire("dtn6l")), module.exports);
const $d98541c52a8d8f29$var$__STATSIG__ = Object.assign((0, (parcelRequire("dtn6l"))._getStatsigGlobal)(), {
    StatsigClient: $i1p2j.default
});
module.exports.default = $d98541c52a8d8f29$var$__STATSIG__;

});
parcelRegister("dtn6l", function(module, exports) {
"use strict";
var $9cefe737490148f0$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $9cefe737490148f0$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $9cefe737490148f0$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Storage = module.exports.Log = module.exports.EventLogger = module.exports.Diagnostics = void 0;



Object.defineProperty(module.exports, "Diagnostics", {
    enumerable: true,
    get: function() {
        return (parcelRequire("cNxHP")).Diagnostics;
    }
});

var $lT0oC = parcelRequire("lT0oC");
Object.defineProperty(module.exports, "EventLogger", {
    enumerable: true,
    get: function() {
        return $lT0oC.EventLogger;
    }
});

Object.defineProperty(module.exports, "Log", {
    enumerable: true,
    get: function() {
        return (parcelRequire("fvY6A")).Log;
    }
});


Object.defineProperty(module.exports, "Storage", {
    enumerable: true,
    get: function() {
        return (parcelRequire("cUOGL")).Storage;
    }
});

$9cefe737490148f0$var$__exportStar((parcelRequire("6zYf6")), module.exports);

$9cefe737490148f0$var$__exportStar((parcelRequire("6ZtBQ")), module.exports);

$9cefe737490148f0$var$__exportStar((parcelRequire("IwlSQ")), module.exports);

$9cefe737490148f0$var$__exportStar((parcelRequire("hPIlK")), module.exports);

$9cefe737490148f0$var$__exportStar((parcelRequire("cNxHP")), module.exports);

$9cefe737490148f0$var$__exportStar((parcelRequire("audqG")), module.exports);

$9cefe737490148f0$var$__exportStar((parcelRequire("a7dQ0")), module.exports);

$9cefe737490148f0$var$__exportStar((parcelRequire("7A9u9")), module.exports);

$9cefe737490148f0$var$__exportStar((parcelRequire("cpYjX")), module.exports);

$9cefe737490148f0$var$__exportStar((parcelRequire("lUUuL")), module.exports);

$9cefe737490148f0$var$__exportStar((parcelRequire("drWJh")), module.exports);

$9cefe737490148f0$var$__exportStar((parcelRequire("fvY6A")), module.exports);

$9cefe737490148f0$var$__exportStar((parcelRequire("g4vOj")), module.exports);

$9cefe737490148f0$var$__exportStar((parcelRequire("4JLTD")), module.exports);

$9cefe737490148f0$var$__exportStar((parcelRequire("4neZ1")), module.exports);

$9cefe737490148f0$var$__exportStar((parcelRequire("am110")), module.exports);

$9cefe737490148f0$var$__exportStar((parcelRequire("J5dlM")), module.exports);

$9cefe737490148f0$var$__exportStar((parcelRequire("jjgcN")), module.exports);

$9cefe737490148f0$var$__exportStar((parcelRequire("6OyqX")), module.exports);

$9cefe737490148f0$var$__exportStar((parcelRequire("6cbWs")), module.exports);

$9cefe737490148f0$var$__exportStar((parcelRequire("kS7H6")), module.exports);

$9cefe737490148f0$var$__exportStar((parcelRequire("lbAhi")), module.exports);

$9cefe737490148f0$var$__exportStar((parcelRequire("uj5Sb")), module.exports);

$9cefe737490148f0$var$__exportStar((parcelRequire("dbFUm")), module.exports);

$9cefe737490148f0$var$__exportStar((parcelRequire("4kZUp")), module.exports);

$9cefe737490148f0$var$__exportStar((parcelRequire("bfSbh")), module.exports);

$9cefe737490148f0$var$__exportStar((parcelRequire("9tDUz")), module.exports);

$9cefe737490148f0$var$__exportStar((parcelRequire("fFtli")), module.exports);

$9cefe737490148f0$var$__exportStar((parcelRequire("eEYg8")), module.exports);

$9cefe737490148f0$var$__exportStar((parcelRequire("boH9C")), module.exports);

$9cefe737490148f0$var$__exportStar((parcelRequire("3G1qf")), module.exports);

$9cefe737490148f0$var$__exportStar((parcelRequire("8Nbnq")), module.exports);

$9cefe737490148f0$var$__exportStar((parcelRequire("cUOGL")), module.exports);

$9cefe737490148f0$var$__exportStar((parcelRequire("1I57i")), module.exports);

$9cefe737490148f0$var$__exportStar((parcelRequire("fOOnv")), module.exports);

$9cefe737490148f0$var$__exportStar((parcelRequire("12s6q")), module.exports);

$9cefe737490148f0$var$__exportStar((parcelRequire("5G12m")), module.exports);

$9cefe737490148f0$var$__exportStar((parcelRequire("71rjN")), module.exports);

$9cefe737490148f0$var$__exportStar((parcelRequire("bhG9g")), module.exports);

$9cefe737490148f0$var$__exportStar((parcelRequire("cd98p")), module.exports);
Object.assign((0, (parcelRequire("6zYf6"))._getStatsigGlobal)(), {
    Log: (parcelRequire("fvY6A")).Log,
    SDK_VERSION: (parcelRequire("9tDUz")).SDK_VERSION
});

});
parcelRegister("6zYf6", function(module, exports) {
"use strict";
/* eslint-disable @typescript-eslint/no-unsafe-assignment */ var $4ca4bde10f45d2ff$var$_a, $4ca4bde10f45d2ff$var$_b, $4ca4bde10f45d2ff$var$_c;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._getInstance = module.exports._getStatsigGlobalFlag = module.exports._getStatsigGlobal = void 0;

var $fvY6A = parcelRequire("fvY6A");
const $4ca4bde10f45d2ff$var$_getStatsigGlobal = ()=>{
    // Avoid ReferenceError, which is happening with Cloudflare pages
    try {
        return typeof __STATSIG__ !== 'undefined' ? __STATSIG__ : $4ca4bde10f45d2ff$var$statsigGlobal;
    } catch (e) {
        return $4ca4bde10f45d2ff$var$statsigGlobal;
    }
};
module.exports._getStatsigGlobal = $4ca4bde10f45d2ff$var$_getStatsigGlobal;
const $4ca4bde10f45d2ff$var$_getStatsigGlobalFlag = (flag)=>{
    return (0, module.exports._getStatsigGlobal)()[flag];
};
module.exports._getStatsigGlobalFlag = $4ca4bde10f45d2ff$var$_getStatsigGlobalFlag;
const $4ca4bde10f45d2ff$var$_getInstance = (sdkKey)=>{
    const gbl = (0, module.exports._getStatsigGlobal)();
    if (!sdkKey) {
        if (gbl.instances && Object.keys(gbl.instances).length > 1) $fvY6A.Log.warn('Call made to Statsig global instance without an SDK key but there is more than one client instance. If you are using mulitple clients, please specify the SDK key.');
        return gbl.firstInstance;
    }
    return gbl.instances && gbl.instances[sdkKey];
};
module.exports._getInstance = $4ca4bde10f45d2ff$var$_getInstance;
const $4ca4bde10f45d2ff$var$GLOBAL_KEY = '__STATSIG__';
const $4ca4bde10f45d2ff$var$_window = typeof window !== 'undefined' ? window : {};
const $4ca4bde10f45d2ff$var$_global = typeof $parcel$global !== 'undefined' ? $parcel$global : {};
const $4ca4bde10f45d2ff$var$_globalThis = typeof globalThis !== 'undefined' ? globalThis : {};
const $4ca4bde10f45d2ff$var$statsigGlobal = ($4ca4bde10f45d2ff$var$_c = ($4ca4bde10f45d2ff$var$_b = ($4ca4bde10f45d2ff$var$_a = $4ca4bde10f45d2ff$var$_window[$4ca4bde10f45d2ff$var$GLOBAL_KEY]) !== null && $4ca4bde10f45d2ff$var$_a !== void 0 ? $4ca4bde10f45d2ff$var$_a : $4ca4bde10f45d2ff$var$_global[$4ca4bde10f45d2ff$var$GLOBAL_KEY]) !== null && $4ca4bde10f45d2ff$var$_b !== void 0 ? $4ca4bde10f45d2ff$var$_b : $4ca4bde10f45d2ff$var$_globalThis[$4ca4bde10f45d2ff$var$GLOBAL_KEY]) !== null && $4ca4bde10f45d2ff$var$_c !== void 0 ? $4ca4bde10f45d2ff$var$_c : {
    instance: module.exports._getInstance
};
$4ca4bde10f45d2ff$var$_window[$4ca4bde10f45d2ff$var$GLOBAL_KEY] = $4ca4bde10f45d2ff$var$statsigGlobal;
$4ca4bde10f45d2ff$var$_global[$4ca4bde10f45d2ff$var$GLOBAL_KEY] = $4ca4bde10f45d2ff$var$statsigGlobal;
$4ca4bde10f45d2ff$var$_globalThis[$4ca4bde10f45d2ff$var$GLOBAL_KEY] = $4ca4bde10f45d2ff$var$statsigGlobal;

});
parcelRegister("fvY6A", function(module, exports) {
"use strict";
/* eslint-disable no-console */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Log = module.exports.LogLevel = void 0;
// intentionally spaced for formatting
const $b4b85fe3d12d0071$var$DEBUG = ' DEBUG ';
const $b4b85fe3d12d0071$var$_INFO = '  INFO ';
const $b4b85fe3d12d0071$var$_WARN = '  WARN ';
const $b4b85fe3d12d0071$var$ERROR = ' ERROR ';
function $b4b85fe3d12d0071$var$addTag(args) {
    args.unshift('[Statsig]');
    return args; // ['[Statsig]', ...args];
}
module.exports.LogLevel = {
    None: 0,
    Error: 1,
    Warn: 2,
    Info: 3,
    Debug: 4
};
class $b4b85fe3d12d0071$var$Log {
    static info(...args) {
        if ($b4b85fe3d12d0071$var$Log.level >= module.exports.LogLevel.Info) console.info($b4b85fe3d12d0071$var$_INFO, ...$b4b85fe3d12d0071$var$addTag(args));
    }
    static debug(...args) {
        if ($b4b85fe3d12d0071$var$Log.level >= module.exports.LogLevel.Debug) console.debug($b4b85fe3d12d0071$var$DEBUG, ...$b4b85fe3d12d0071$var$addTag(args));
    }
    static warn(...args) {
        if ($b4b85fe3d12d0071$var$Log.level >= module.exports.LogLevel.Warn) console.warn($b4b85fe3d12d0071$var$_WARN, ...$b4b85fe3d12d0071$var$addTag(args));
    }
    static error(...args) {
        if ($b4b85fe3d12d0071$var$Log.level >= module.exports.LogLevel.Error) console.error($b4b85fe3d12d0071$var$ERROR, ...$b4b85fe3d12d0071$var$addTag(args));
    }
}
module.exports.Log = $b4b85fe3d12d0071$var$Log;
$b4b85fe3d12d0071$var$Log.level = module.exports.LogLevel.Warn;

});


parcelRegister("cNxHP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Diagnostics = void 0;
const $951434f10e36012f$var$MARKER_MAP = new Map();
const $951434f10e36012f$var$ACT_START = 'start';
const $951434f10e36012f$var$ACT_END = 'end';
const $951434f10e36012f$var$DIAGNOSTICS_EVENT = 'statsig::diagnostics';
module.exports.Diagnostics = {
    _getMarkers: (sdkKey)=>{
        return $951434f10e36012f$var$MARKER_MAP.get(sdkKey);
    },
    _markInitOverallStart: (sdkKey)=>{
        $951434f10e36012f$var$_addMarker(sdkKey, $951434f10e36012f$var$_createMarker({}, $951434f10e36012f$var$ACT_START, 'overall'));
    },
    _markInitOverallEnd: (sdkKey, success, evaluationDetails)=>{
        $951434f10e36012f$var$_addMarker(sdkKey, $951434f10e36012f$var$_createMarker({
            success: success,
            error: success ? undefined : {
                name: 'InitializeError',
                message: 'Failed to initialize'
            },
            evaluationDetails: evaluationDetails
        }, $951434f10e36012f$var$ACT_END, 'overall'));
    },
    _markInitNetworkReqStart: (sdkKey, data)=>{
        $951434f10e36012f$var$_addMarker(sdkKey, $951434f10e36012f$var$_createMarker(data, $951434f10e36012f$var$ACT_START, 'initialize', 'network_request'));
    },
    _markInitNetworkReqEnd: (sdkKey, data)=>{
        $951434f10e36012f$var$_addMarker(sdkKey, $951434f10e36012f$var$_createMarker(data, $951434f10e36012f$var$ACT_END, 'initialize', 'network_request'));
    },
    _markInitProcessStart: (sdkKey)=>{
        $951434f10e36012f$var$_addMarker(sdkKey, $951434f10e36012f$var$_createMarker({}, $951434f10e36012f$var$ACT_START, 'initialize', 'process'));
    },
    _markInitProcessEnd: (sdkKey, data)=>{
        $951434f10e36012f$var$_addMarker(sdkKey, $951434f10e36012f$var$_createMarker(data, $951434f10e36012f$var$ACT_END, 'initialize', 'process'));
    },
    _clearMarkers: (sdkKey)=>{
        $951434f10e36012f$var$MARKER_MAP.delete(sdkKey);
    },
    _formatError (e) {
        if (!(e && typeof e === 'object')) return;
        return {
            code: $951434f10e36012f$var$_safeGetField(e, 'code'),
            name: $951434f10e36012f$var$_safeGetField(e, 'name'),
            message: $951434f10e36012f$var$_safeGetField(e, 'message')
        };
    },
    _getDiagnosticsData (res, attempt, body, e) {
        var _a;
        return {
            success: (res === null || res === void 0 ? void 0 : res.ok) === true,
            statusCode: res === null || res === void 0 ? void 0 : res.status,
            sdkRegion: (_a = res === null || res === void 0 ? void 0 : res.headers) === null || _a === void 0 ? void 0 : _a.get('x-statsig-region'),
            isDelta: body.includes('"is_delta":true') === true ? true : undefined,
            attempt: attempt,
            error: module.exports.Diagnostics._formatError(e)
        };
    },
    _enqueueDiagnosticsEvent (user, logger, sdk, options) {
        const markers = module.exports.Diagnostics._getMarkers(sdk);
        if (markers == null || markers.length <= 0) return -1;
        const overallInitDuration = markers[markers.length - 1].timestamp - markers[0].timestamp;
        module.exports.Diagnostics._clearMarkers(sdk);
        const event = $951434f10e36012f$var$_makeDiagnosticsEvent(user, {
            context: 'initialize',
            markers: markers.slice(),
            statsigOptions: options
        });
        logger.enqueue(event);
        return overallInitDuration;
    }
};
function $951434f10e36012f$var$_createMarker(data, action, key, step) {
    return Object.assign({
        key: key,
        action: action,
        step: step,
        timestamp: Date.now()
    }, data);
}
function $951434f10e36012f$var$_makeDiagnosticsEvent(user, data) {
    const latencyEvent = {
        eventName: $951434f10e36012f$var$DIAGNOSTICS_EVENT,
        user: user,
        value: null,
        metadata: data,
        time: Date.now()
    };
    return latencyEvent;
}
function $951434f10e36012f$var$_addMarker(sdkKey, marker) {
    var _a;
    const markers = (_a = $951434f10e36012f$var$MARKER_MAP.get(sdkKey)) !== null && _a !== void 0 ? _a : [];
    markers.push(marker);
    $951434f10e36012f$var$MARKER_MAP.set(sdkKey, markers);
}
function $951434f10e36012f$var$_safeGetField(data, field) {
    if (field in data) return data[field];
    return undefined;
}

});

parcelRegister("lT0oC", function(module, exports) {
"use strict";
var $feef0aade80dd3d6$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.EventLogger = void 0;

var $6ZtBQ = parcelRequire("6ZtBQ");

var $lUUuL = parcelRequire("lUUuL");

var $fvY6A = parcelRequire("fvY6A");

var $4JLTD = parcelRequire("4JLTD");

var $jjgcN = parcelRequire("jjgcN");

var $bfSbh = parcelRequire("bfSbh");

var $fFtli = parcelRequire("fFtli");

var $cUOGL = parcelRequire("cUOGL");

var $12s6q = parcelRequire("12s6q");

var $71rjN = parcelRequire("71rjN");
const $feef0aade80dd3d6$var$DEFAULT_QUEUE_SIZE = 100;
const $feef0aade80dd3d6$var$DEFAULT_FLUSH_INTERVAL_MS = 10000;
const $feef0aade80dd3d6$var$MAX_DEDUPER_KEYS = 1000;
const $feef0aade80dd3d6$var$DEDUPER_WINDOW_DURATION_MS = 600000;
const $feef0aade80dd3d6$var$MAX_FAILED_LOGS = 500;
const $feef0aade80dd3d6$var$QUICK_FLUSH_WINDOW_MS = 200;
const $feef0aade80dd3d6$var$EVENT_LOGGER_MAP = {};
class $feef0aade80dd3d6$var$EventLogger {
    static _safeFlushAndForget(sdkKey) {
        var _a;
        (_a = $feef0aade80dd3d6$var$EVENT_LOGGER_MAP[sdkKey]) === null || _a === void 0 || _a.flush().catch(()=>{
        // noop
        });
    }
    static _safeRetryFailedLogs(sdkKey) {
        var _a;
        (_a = $feef0aade80dd3d6$var$EVENT_LOGGER_MAP[sdkKey]) === null || _a === void 0 || _a._retryFailedLogs();
    }
    constructor(_sdkKey, _emitter, _network, _options){
        var _a, _b;
        this._sdkKey = _sdkKey;
        this._emitter = _emitter;
        this._network = _network;
        this._options = _options;
        this._queue = [];
        this._lastExposureTimeMap = {};
        this._nonExposedChecks = {};
        this._hasRunQuickFlush = false;
        this._creationTime = Date.now();
        this._loggingEnabled = (_a = _options === null || _options === void 0 ? void 0 : _options.loggingEnabled) !== null && _a !== void 0 ? _a : (_options === null || _options === void 0 ? void 0 : _options.disableLogging) === true ? $fFtli.LoggingEnabledOption.disabled : $fFtli.LoggingEnabledOption.browserOnly;
        if ((_options === null || _options === void 0 ? void 0 : _options.loggingEnabled) && _options.disableLogging !== undefined) $fvY6A.Log.warn('Detected both loggingEnabled and disableLogging options. loggingEnabled takes precedence - please remove disableLogging.');
        this._maxQueueSize = (_b = _options === null || _options === void 0 ? void 0 : _options.loggingBufferMaxSize) !== null && _b !== void 0 ? _b : $feef0aade80dd3d6$var$DEFAULT_QUEUE_SIZE;
        const config = _options === null || _options === void 0 ? void 0 : _options.networkConfig;
        this._logEventUrlConfig = new $12s6q.UrlConfiguration($4JLTD.Endpoint._rgstr, config === null || config === void 0 ? void 0 : config.logEventUrl, config === null || config === void 0 ? void 0 : config.api, config === null || config === void 0 ? void 0 : config.logEventFallbackUrls);
    }
    setLogEventCompressionMode(mode) {
        this._network.setLogEventCompressionMode(mode);
    }
    setLoggingEnabled(loggingEnabled) {
        if (this._loggingEnabled === 'disabled' && loggingEnabled !== 'disabled') {
            // load any pre consented events into memory
            const storageKey = this._getStorageKey();
            const events = (0, $cUOGL._getObjectFromStorage)(storageKey);
            if (events) this._queue.push(...events);
            $cUOGL.Storage.removeItem(storageKey);
        }
        this._loggingEnabled = loggingEnabled;
    }
    enqueue(event) {
        if (!this._shouldLogEvent(event)) return;
        this._normalizeAndAppendEvent(event);
        this._quickFlushIfNeeded();
        if (this._queue.length > this._maxQueueSize) $feef0aade80dd3d6$var$EventLogger._safeFlushAndForget(this._sdkKey);
    }
    incrementNonExposureCount(name) {
        var _a;
        const current = (_a = this._nonExposedChecks[name]) !== null && _a !== void 0 ? _a : 0;
        this._nonExposedChecks[name] = current + 1;
    }
    reset() {
        // attempt to flush any remaining events
        this.flush().catch(()=>{
        // noop
        });
        this._lastExposureTimeMap = {};
    }
    start() {
        var _a;
        const isServerEnv = (0, $jjgcN._isServerEnv)();
        if (isServerEnv && ((_a = this._options) === null || _a === void 0 ? void 0 : _a.loggingEnabled) !== 'always') return;
        $feef0aade80dd3d6$var$EVENT_LOGGER_MAP[this._sdkKey] = this;
        if (!isServerEnv) (0, $71rjN._subscribeToVisiblityChanged)((visibility)=>{
            if (visibility === 'background') $feef0aade80dd3d6$var$EventLogger._safeFlushAndForget(this._sdkKey);
            else if (visibility === 'foreground') $feef0aade80dd3d6$var$EventLogger._safeRetryFailedLogs(this._sdkKey);
        });
        this._retryFailedLogs();
        this._startBackgroundFlushInterval();
    }
    stop() {
        return $feef0aade80dd3d6$var$__awaiter(this, void 0, void 0, function*() {
            if (this._flushIntervalId) {
                clearInterval(this._flushIntervalId);
                this._flushIntervalId = null;
            }
            delete $feef0aade80dd3d6$var$EVENT_LOGGER_MAP[this._sdkKey];
            yield this.flush();
        });
    }
    flush() {
        return $feef0aade80dd3d6$var$__awaiter(this, void 0, void 0, function*() {
            this._appendAndResetNonExposedChecks();
            if (this._queue.length === 0) return;
            const events = this._queue;
            this._queue = [];
            yield this._sendEvents(events);
        });
    }
    /**
     * We 'Quick Flush' following the very first event enqueued
     * within the quick flush window
     */ _quickFlushIfNeeded() {
        if (this._hasRunQuickFlush) return;
        this._hasRunQuickFlush = true;
        if (Date.now() - this._creationTime > $feef0aade80dd3d6$var$QUICK_FLUSH_WINDOW_MS) return;
        setTimeout(()=>$feef0aade80dd3d6$var$EventLogger._safeFlushAndForget(this._sdkKey), $feef0aade80dd3d6$var$QUICK_FLUSH_WINDOW_MS);
    }
    _shouldLogEvent(event) {
        var _a;
        if (((_a = this._options) === null || _a === void 0 ? void 0 : _a.loggingEnabled) !== 'always' && (0, $jjgcN._isServerEnv)()) return false;
        if (!(0, $bfSbh._isExposureEvent)(event)) return true;
        const user = event.user ? event.user : {
            statsigEnvironment: undefined
        };
        const userKey = (0, $6ZtBQ._getUserStorageKey)(this._sdkKey, user);
        const metadata = event.metadata ? event.metadata : {};
        const key = [
            event.eventName,
            userKey,
            metadata['gate'],
            metadata['config'],
            metadata['ruleID'],
            metadata['allocatedExperiment'],
            metadata['parameterName'],
            String(metadata['isExplicitParameter']),
            metadata['reason']
        ].join('|');
        const previous = this._lastExposureTimeMap[key];
        const now = Date.now();
        if (previous && now - previous < $feef0aade80dd3d6$var$DEDUPER_WINDOW_DURATION_MS) return false;
        if (Object.keys(this._lastExposureTimeMap).length > $feef0aade80dd3d6$var$MAX_DEDUPER_KEYS) this._lastExposureTimeMap = {};
        this._lastExposureTimeMap[key] = now;
        return true;
    }
    _sendEvents(events) {
        return $feef0aade80dd3d6$var$__awaiter(this, void 0, void 0, function*() {
            var _a, _b;
            if (this._loggingEnabled === 'disabled') {
                this._saveFailedLogsToStorage(events);
                return false;
            }
            try {
                const isClosing = (0, $71rjN._isUnloading)();
                const shouldUseBeacon = isClosing && this._network.isBeaconSupported() && ((_b = (_a = this._options) === null || _a === void 0 ? void 0 : _a.networkConfig) === null || _b === void 0 ? void 0 : _b.networkOverrideFunc) == null;
                this._emitter({
                    name: 'pre_logs_flushed',
                    events: events
                });
                const response = shouldUseBeacon ? this._sendEventsViaBeacon(events) : yield this._sendEventsViaPost(events);
                if (response.success) {
                    this._emitter({
                        name: 'logs_flushed',
                        events: events
                    });
                    return true;
                } else {
                    $fvY6A.Log.warn('Failed to flush events.');
                    this._saveFailedLogsToStorage(events);
                    return false;
                }
            } catch (_c) {
                $fvY6A.Log.warn('Failed to flush events.');
                return false;
            }
        });
    }
    _sendEventsViaPost(events) {
        return $feef0aade80dd3d6$var$__awaiter(this, void 0, void 0, function*() {
            var _a;
            const result = yield this._network.post(this._getRequestData(events));
            const code = (_a = result === null || result === void 0 ? void 0 : result.code) !== null && _a !== void 0 ? _a : -1;
            return {
                success: code >= 200 && code < 300
            };
        });
    }
    _sendEventsViaBeacon(events) {
        return {
            success: this._network.beacon(this._getRequestData(events))
        };
    }
    _getRequestData(events) {
        return {
            sdkKey: this._sdkKey,
            data: {
                events: events
            },
            urlConfig: this._logEventUrlConfig,
            retries: 3,
            isCompressable: true,
            params: {
                [$4JLTD.NetworkParam.EventCount]: String(events.length)
            },
            credentials: 'same-origin'
        };
    }
    _saveFailedLogsToStorage(events) {
        while(events.length > $feef0aade80dd3d6$var$MAX_FAILED_LOGS)events.shift();
        const storageKey = this._getStorageKey();
        try {
            const savedEvents = this._getFailedLogsFromStorage(storageKey);
            (0, $cUOGL._setObjectInStorage)(storageKey, [
                ...savedEvents,
                ...events
            ]);
        } catch (_a) {
            $fvY6A.Log.warn('Unable to save failed logs to storage');
        }
    }
    _getFailedLogsFromStorage(storageKey) {
        let savedEvents = [];
        try {
            const retrieved = (0, $cUOGL._getObjectFromStorage)(storageKey);
            if (Array.isArray(retrieved)) savedEvents = retrieved;
            return savedEvents;
        } catch (_a) {
            return [];
        }
    }
    _retryFailedLogs() {
        const storageKey = this._getStorageKey();
        (()=>$feef0aade80dd3d6$var$__awaiter(this, void 0, void 0, function*() {
                if (!$cUOGL.Storage.isReady()) yield $cUOGL.Storage.isReadyResolver();
                const events = (0, $cUOGL._getObjectFromStorage)(storageKey);
                if (!events) return;
                $cUOGL.Storage.removeItem(storageKey);
                yield this._sendEvents(events);
            }))().catch(()=>{
            $fvY6A.Log.warn('Failed to flush stored logs');
        });
    }
    _getStorageKey() {
        return `statsig.failed_logs.${(0, $lUUuL._DJB2)(this._sdkKey)}`;
    }
    _normalizeAndAppendEvent(event) {
        if (event.user) {
            event.user = Object.assign({}, event.user);
            delete event.user.privateAttributes;
        }
        const extras = {};
        const currentPage = this._getCurrentPageUrl();
        if (currentPage) extras.statsigMetadata = {
            currentPage: currentPage
        };
        const final = Object.assign(Object.assign({}, event), extras);
        $fvY6A.Log.debug('Enqueued Event:', final);
        this._queue.push(final);
    }
    _appendAndResetNonExposedChecks() {
        if (Object.keys(this._nonExposedChecks).length === 0) return;
        this._normalizeAndAppendEvent({
            eventName: 'statsig::non_exposed_checks',
            user: null,
            time: Date.now(),
            metadata: {
                checks: Object.assign({}, this._nonExposedChecks)
            }
        });
        this._nonExposedChecks = {};
    }
    _getCurrentPageUrl() {
        var _a;
        if (((_a = this._options) === null || _a === void 0 ? void 0 : _a.includeCurrentPageUrlWithEvents) === false) return;
        return (0, $jjgcN._getCurrentPageUrlSafe)();
    }
    _startBackgroundFlushInterval() {
        var _a, _b;
        const flushInterval = (_b = (_a = this._options) === null || _a === void 0 ? void 0 : _a.loggingIntervalMs) !== null && _b !== void 0 ? _b : $feef0aade80dd3d6$var$DEFAULT_FLUSH_INTERVAL_MS;
        const intervalId = setInterval(()=>{
            const logger = $feef0aade80dd3d6$var$EVENT_LOGGER_MAP[this._sdkKey];
            if (!logger || logger._flushIntervalId !== intervalId) clearInterval(intervalId);
            else $feef0aade80dd3d6$var$EventLogger._safeFlushAndForget(this._sdkKey);
        }, flushInterval);
        this._flushIntervalId = intervalId;
    }
}
module.exports.EventLogger = $feef0aade80dd3d6$var$EventLogger;

});
parcelRegister("6ZtBQ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._getStorageKey = module.exports._getUserStorageKey = void 0;

var $lUUuL = parcelRequire("lUUuL");
function $516f68604f39036a$var$_getUserStorageKey(sdkKey, user, customKeyGenerator) {
    var _a;
    if (customKeyGenerator) return customKeyGenerator(sdkKey, user);
    const cids = user && user.customIDs ? user.customIDs : {};
    const parts = [
        `uid:${(_a = user === null || user === void 0 ? void 0 : user.userID) !== null && _a !== void 0 ? _a : ''}`,
        `cids:${Object.keys(cids).sort((leftKey, rightKey)=>leftKey.localeCompare(rightKey)).map((key)=>`${key}-${cids[key]}`).join(',')}`,
        `k:${sdkKey}`
    ];
    return (0, $lUUuL._DJB2)(parts.join('|'));
}
module.exports._getUserStorageKey = $516f68604f39036a$var$_getUserStorageKey;
function $516f68604f39036a$var$_getStorageKey(sdkKey, user, customKeyGenerator) {
    if (user) return $516f68604f39036a$var$_getUserStorageKey(sdkKey, user, customKeyGenerator);
    return (0, $lUUuL._DJB2)(`k:${sdkKey}`);
}
module.exports._getStorageKey = $516f68604f39036a$var$_getStorageKey;

});
parcelRegister("lUUuL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._getSortedObject = module.exports._DJB2Object = module.exports._DJB2 = void 0;

var $fOOnv = parcelRequire("fOOnv");
const $ff4aa6ade9a90e99$var$_DJB2 = (value)=>{
    let hash = 0;
    for(let i = 0; i < value.length; i++){
        const character = value.charCodeAt(i);
        hash = (hash << 5) - hash + character;
        hash = hash & hash; // Convert to 32bit integer
    }
    return String(hash >>> 0);
};
module.exports._DJB2 = $ff4aa6ade9a90e99$var$_DJB2;
const $ff4aa6ade9a90e99$var$_DJB2Object = (value, maxLevels)=>{
    return (0, module.exports._DJB2)(JSON.stringify((0, module.exports._getSortedObject)(value, maxLevels)));
};
module.exports._DJB2Object = $ff4aa6ade9a90e99$var$_DJB2Object;
const $ff4aa6ade9a90e99$var$_getSortedObject = (object, maxDepth)=>{
    if (object == null) return null;
    const keys = Object.keys(object).sort();
    const sortedObject = {};
    keys.forEach((key)=>{
        const value = object[key];
        if (maxDepth === 0 || (0, $fOOnv._typeOf)(value) !== 'object') {
            sortedObject[key] = value;
            return;
        }
        sortedObject[key] = (0, module.exports._getSortedObject)(value, maxDepth != null ? maxDepth - 1 : maxDepth);
    });
    return sortedObject;
};
module.exports._getSortedObject = $ff4aa6ade9a90e99$var$_getSortedObject;

});
parcelRegister("fOOnv", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._isTypeMatch = module.exports._typeOf = void 0;
function $b8429a94efe702e2$var$_typeOf(input) {
    return Array.isArray(input) ? 'array' : typeof input;
}
module.exports._typeOf = $b8429a94efe702e2$var$_typeOf;
function $b8429a94efe702e2$var$_isTypeMatch(a, b) {
    const typeOf = (x)=>Array.isArray(x) ? 'array' : x === null ? 'null' : typeof x;
    return typeOf(a) === typeOf(b);
}
module.exports._isTypeMatch = $b8429a94efe702e2$var$_isTypeMatch;

});



parcelRegister("4JLTD", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.NetworkParam = module.exports.NetworkDefault = module.exports.Endpoint = void 0;
module.exports.Endpoint = {
    _initialize: 'initialize',
    _rgstr: 'rgstr',
    _download_config_specs: 'download_config_specs'
};
module.exports.NetworkDefault = {
    [module.exports.Endpoint._rgstr]: 'https://prodregistryv2.org/v1',
    [module.exports.Endpoint._initialize]: 'https://featureassets.org/v1',
    [module.exports.Endpoint._download_config_specs]: 'https://api.statsigcdn.com/v1'
};
module.exports.NetworkParam = {
    EventCount: 'ec',
    SdkKey: 'k',
    SdkType: 'st',
    SdkVersion: 'sv',
    Time: 't',
    SessionID: 'sid',
    StatsigEncoded: 'se',
    IsGzipped: 'gz'
};

});

parcelRegister("jjgcN", function(module, exports) {

var $3ZMUU = parcelRequire("3ZMUU");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._getUnloadEvent = module.exports._getCurrentPageUrlSafe = module.exports._addDocumentEventListenerSafe = module.exports._addWindowEventListenerSafe = module.exports._isServerEnv = module.exports._getDocumentSafe = module.exports._getWindowSafe = void 0;
const $e0ec5cbb0c18f89e$var$_getWindowSafe = ()=>{
    return typeof window !== 'undefined' ? window : null;
};
module.exports._getWindowSafe = $e0ec5cbb0c18f89e$var$_getWindowSafe;
const $e0ec5cbb0c18f89e$var$_getDocumentSafe = ()=>{
    var _a;
    const win = (0, module.exports._getWindowSafe)();
    return (_a = win === null || win === void 0 ? void 0 : win.document) !== null && _a !== void 0 ? _a : null;
};
module.exports._getDocumentSafe = $e0ec5cbb0c18f89e$var$_getDocumentSafe;
const $e0ec5cbb0c18f89e$var$_isServerEnv = ()=>{
    if ((0, module.exports._getDocumentSafe)() !== null) return false;
    const isNode = typeof $3ZMUU !== 'undefined' && $3ZMUU.versions != null && $3ZMUU.versions.node != null;
    const isVercel = typeof EdgeRuntime === 'string';
    return isVercel || isNode;
};
module.exports._isServerEnv = $e0ec5cbb0c18f89e$var$_isServerEnv;
const $e0ec5cbb0c18f89e$var$_addWindowEventListenerSafe = (key, listener)=>{
    const win = (0, module.exports._getWindowSafe)();
    if (typeof (win === null || win === void 0 ? void 0 : win.addEventListener) === 'function') win.addEventListener(key, listener);
};
module.exports._addWindowEventListenerSafe = $e0ec5cbb0c18f89e$var$_addWindowEventListenerSafe;
const $e0ec5cbb0c18f89e$var$_addDocumentEventListenerSafe = (key, listener)=>{
    const doc = (0, module.exports._getDocumentSafe)();
    if (typeof (doc === null || doc === void 0 ? void 0 : doc.addEventListener) === 'function') doc.addEventListener(key, listener);
};
module.exports._addDocumentEventListenerSafe = $e0ec5cbb0c18f89e$var$_addDocumentEventListenerSafe;
const $e0ec5cbb0c18f89e$var$_getCurrentPageUrlSafe = ()=>{
    var _a;
    try {
        return (_a = (0, module.exports._getWindowSafe)()) === null || _a === void 0 ? void 0 : _a.location.href.split(/[?#]/)[0];
    } catch (_b) {
        return;
    }
};
module.exports._getCurrentPageUrlSafe = $e0ec5cbb0c18f89e$var$_getCurrentPageUrlSafe;
const $e0ec5cbb0c18f89e$var$_getUnloadEvent = ()=>{
    const win = (0, module.exports._getWindowSafe)();
    if (!win) return 'beforeunload';
    const eventType = 'onpagehide' in win ? 'pagehide' : 'beforeunload';
    return eventType;
};
module.exports._getUnloadEvent = $e0ec5cbb0c18f89e$var$_getUnloadEvent;

});
parcelRegister("3ZMUU", function(module, exports) {
// shim for using process in browser
var $2e8d0374c7e0ead2$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $2e8d0374c7e0ead2$var$cachedSetTimeout;
var $2e8d0374c7e0ead2$var$cachedClearTimeout;
function $2e8d0374c7e0ead2$var$defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function $2e8d0374c7e0ead2$var$defaultClearTimeout() {
    throw new Error('clearTimeout has not been defined');
}
(function() {
    try {
        if (typeof setTimeout === 'function') $2e8d0374c7e0ead2$var$cachedSetTimeout = setTimeout;
        else $2e8d0374c7e0ead2$var$cachedSetTimeout = $2e8d0374c7e0ead2$var$defaultSetTimout;
    } catch (e) {
        $2e8d0374c7e0ead2$var$cachedSetTimeout = $2e8d0374c7e0ead2$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') $2e8d0374c7e0ead2$var$cachedClearTimeout = clearTimeout;
        else $2e8d0374c7e0ead2$var$cachedClearTimeout = $2e8d0374c7e0ead2$var$defaultClearTimeout;
    } catch (e) {
        $2e8d0374c7e0ead2$var$cachedClearTimeout = $2e8d0374c7e0ead2$var$defaultClearTimeout;
    }
})();
function $2e8d0374c7e0ead2$var$runTimeout(fun) {
    if ($2e8d0374c7e0ead2$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($2e8d0374c7e0ead2$var$cachedSetTimeout === $2e8d0374c7e0ead2$var$defaultSetTimout || !$2e8d0374c7e0ead2$var$cachedSetTimeout) && setTimeout) {
        $2e8d0374c7e0ead2$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $2e8d0374c7e0ead2$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $2e8d0374c7e0ead2$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $2e8d0374c7e0ead2$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $2e8d0374c7e0ead2$var$runClearTimeout(marker) {
    if ($2e8d0374c7e0ead2$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($2e8d0374c7e0ead2$var$cachedClearTimeout === $2e8d0374c7e0ead2$var$defaultClearTimeout || !$2e8d0374c7e0ead2$var$cachedClearTimeout) && clearTimeout) {
        $2e8d0374c7e0ead2$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $2e8d0374c7e0ead2$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $2e8d0374c7e0ead2$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $2e8d0374c7e0ead2$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $2e8d0374c7e0ead2$var$queue = [];
var $2e8d0374c7e0ead2$var$draining = false;
var $2e8d0374c7e0ead2$var$currentQueue;
var $2e8d0374c7e0ead2$var$queueIndex = -1;
function $2e8d0374c7e0ead2$var$cleanUpNextTick() {
    if (!$2e8d0374c7e0ead2$var$draining || !$2e8d0374c7e0ead2$var$currentQueue) return;
    $2e8d0374c7e0ead2$var$draining = false;
    if ($2e8d0374c7e0ead2$var$currentQueue.length) $2e8d0374c7e0ead2$var$queue = $2e8d0374c7e0ead2$var$currentQueue.concat($2e8d0374c7e0ead2$var$queue);
    else $2e8d0374c7e0ead2$var$queueIndex = -1;
    if ($2e8d0374c7e0ead2$var$queue.length) $2e8d0374c7e0ead2$var$drainQueue();
}
function $2e8d0374c7e0ead2$var$drainQueue() {
    if ($2e8d0374c7e0ead2$var$draining) return;
    var timeout = $2e8d0374c7e0ead2$var$runTimeout($2e8d0374c7e0ead2$var$cleanUpNextTick);
    $2e8d0374c7e0ead2$var$draining = true;
    var len = $2e8d0374c7e0ead2$var$queue.length;
    while(len){
        $2e8d0374c7e0ead2$var$currentQueue = $2e8d0374c7e0ead2$var$queue;
        $2e8d0374c7e0ead2$var$queue = [];
        while(++$2e8d0374c7e0ead2$var$queueIndex < len)if ($2e8d0374c7e0ead2$var$currentQueue) $2e8d0374c7e0ead2$var$currentQueue[$2e8d0374c7e0ead2$var$queueIndex].run();
        $2e8d0374c7e0ead2$var$queueIndex = -1;
        len = $2e8d0374c7e0ead2$var$queue.length;
    }
    $2e8d0374c7e0ead2$var$currentQueue = null;
    $2e8d0374c7e0ead2$var$draining = false;
    $2e8d0374c7e0ead2$var$runClearTimeout(timeout);
}
$2e8d0374c7e0ead2$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $2e8d0374c7e0ead2$var$queue.push(new $2e8d0374c7e0ead2$var$Item(fun, args));
    if ($2e8d0374c7e0ead2$var$queue.length === 1 && !$2e8d0374c7e0ead2$var$draining) $2e8d0374c7e0ead2$var$runTimeout($2e8d0374c7e0ead2$var$drainQueue);
};
// v8 likes predictible objects
function $2e8d0374c7e0ead2$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$2e8d0374c7e0ead2$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$2e8d0374c7e0ead2$var$process.title = 'browser';
$2e8d0374c7e0ead2$var$process.browser = true;
$2e8d0374c7e0ead2$var$process.env = {};
$2e8d0374c7e0ead2$var$process.argv = [];
$2e8d0374c7e0ead2$var$process.version = ''; // empty string to avoid regexp issues
$2e8d0374c7e0ead2$var$process.versions = {};
function $2e8d0374c7e0ead2$var$noop() {}
$2e8d0374c7e0ead2$var$process.on = $2e8d0374c7e0ead2$var$noop;
$2e8d0374c7e0ead2$var$process.addListener = $2e8d0374c7e0ead2$var$noop;
$2e8d0374c7e0ead2$var$process.once = $2e8d0374c7e0ead2$var$noop;
$2e8d0374c7e0ead2$var$process.off = $2e8d0374c7e0ead2$var$noop;
$2e8d0374c7e0ead2$var$process.removeListener = $2e8d0374c7e0ead2$var$noop;
$2e8d0374c7e0ead2$var$process.removeAllListeners = $2e8d0374c7e0ead2$var$noop;
$2e8d0374c7e0ead2$var$process.emit = $2e8d0374c7e0ead2$var$noop;
$2e8d0374c7e0ead2$var$process.prependListener = $2e8d0374c7e0ead2$var$noop;
$2e8d0374c7e0ead2$var$process.prependOnceListener = $2e8d0374c7e0ead2$var$noop;
$2e8d0374c7e0ead2$var$process.listeners = function(name) {
    return [];
};
$2e8d0374c7e0ead2$var$process.binding = function(name) {
    throw new Error('process.binding is not supported');
};
$2e8d0374c7e0ead2$var$process.cwd = function() {
    return '/';
};
$2e8d0374c7e0ead2$var$process.chdir = function(dir) {
    throw new Error('process.chdir is not supported');
};
$2e8d0374c7e0ead2$var$process.umask = function() {
    return 0;
};

});


parcelRegister("bfSbh", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._createLayerParameterExposure = module.exports._createConfigExposure = module.exports._mapExposures = module.exports._createGateExposure = module.exports._isExposureEvent = void 0;
const $831b1fa1d6ab26dc$var$CONFIG_EXPOSURE_NAME = 'statsig::config_exposure';
const $831b1fa1d6ab26dc$var$GATE_EXPOSURE_NAME = 'statsig::gate_exposure';
const $831b1fa1d6ab26dc$var$LAYER_EXPOSURE_NAME = 'statsig::layer_exposure';
const $831b1fa1d6ab26dc$var$_createExposure = (eventName, user, details, metadata, secondaryExposures)=>{
    if (details.bootstrapMetadata) metadata['bootstrapMetadata'] = details.bootstrapMetadata;
    return {
        eventName: eventName,
        user: user,
        value: null,
        metadata: $831b1fa1d6ab26dc$var$_addEvaluationDetailsToMetadata(details, metadata),
        secondaryExposures: secondaryExposures,
        time: Date.now()
    };
};
const $831b1fa1d6ab26dc$var$_isExposureEvent = ({ eventName: eventName })=>{
    return eventName === $831b1fa1d6ab26dc$var$GATE_EXPOSURE_NAME || eventName === $831b1fa1d6ab26dc$var$CONFIG_EXPOSURE_NAME || eventName === $831b1fa1d6ab26dc$var$LAYER_EXPOSURE_NAME;
};
module.exports._isExposureEvent = $831b1fa1d6ab26dc$var$_isExposureEvent;
const $831b1fa1d6ab26dc$var$_createGateExposure = (user, gate, exposureMapping)=>{
    var _a, _b, _c;
    const metadata = {
        gate: gate.name,
        gateValue: String(gate.value),
        ruleID: gate.ruleID
    };
    if (((_a = gate.__evaluation) === null || _a === void 0 ? void 0 : _a.version) != null) metadata['configVersion'] = gate.__evaluation.version;
    return $831b1fa1d6ab26dc$var$_createExposure($831b1fa1d6ab26dc$var$GATE_EXPOSURE_NAME, user, gate.details, metadata, $831b1fa1d6ab26dc$var$_mapExposures((_c = (_b = gate.__evaluation) === null || _b === void 0 ? void 0 : _b.secondary_exposures) !== null && _c !== void 0 ? _c : [], exposureMapping));
};
module.exports._createGateExposure = $831b1fa1d6ab26dc$var$_createGateExposure;
function $831b1fa1d6ab26dc$var$_mapExposures(exposures, exposureMapping) {
    return exposures.map((exposure)=>{
        if (typeof exposure === 'string') return (exposureMapping !== null && exposureMapping !== void 0 ? exposureMapping : {})[exposure];
        return exposure;
    }).filter((exposure)=>exposure != null);
}
module.exports._mapExposures = $831b1fa1d6ab26dc$var$_mapExposures;
const $831b1fa1d6ab26dc$var$_createConfigExposure = (user, config, exposureMapping)=>{
    var _a, _b, _c, _d;
    const metadata = {
        config: config.name,
        ruleID: config.ruleID
    };
    if (((_a = config.__evaluation) === null || _a === void 0 ? void 0 : _a.version) != null) metadata['configVersion'] = config.__evaluation.version;
    if (((_b = config.__evaluation) === null || _b === void 0 ? void 0 : _b.passed) != null) metadata['rulePassed'] = String(config.__evaluation.passed);
    return $831b1fa1d6ab26dc$var$_createExposure($831b1fa1d6ab26dc$var$CONFIG_EXPOSURE_NAME, user, config.details, metadata, $831b1fa1d6ab26dc$var$_mapExposures((_d = (_c = config.__evaluation) === null || _c === void 0 ? void 0 : _c.secondary_exposures) !== null && _d !== void 0 ? _d : [], exposureMapping));
};
module.exports._createConfigExposure = $831b1fa1d6ab26dc$var$_createConfigExposure;
const $831b1fa1d6ab26dc$var$_createLayerParameterExposure = (user, layer, parameterName, exposureMapping)=>{
    var _a, _b, _c, _d, _e, _f, _g;
    const evaluation = layer.__evaluation;
    const isExplicit = ((_a = evaluation === null || evaluation === void 0 ? void 0 : evaluation.explicit_parameters) === null || _a === void 0 ? void 0 : _a.includes(parameterName)) === true;
    let allocatedExperiment = '';
    let secondaryExposures = (_b = evaluation === null || evaluation === void 0 ? void 0 : evaluation.undelegated_secondary_exposures) !== null && _b !== void 0 ? _b : [];
    if (isExplicit) {
        allocatedExperiment = (_c = evaluation.allocated_experiment_name) !== null && _c !== void 0 ? _c : '';
        secondaryExposures = (_d = evaluation.secondary_exposures) !== null && _d !== void 0 ? _d : [];
    }
    const parameterRuleIDs = (_e = layer.__evaluation) === null || _e === void 0 ? void 0 : _e.parameter_rule_ids;
    const metadata = {
        config: layer.name,
        parameterName: parameterName,
        ruleID: (_f = parameterRuleIDs === null || parameterRuleIDs === void 0 ? void 0 : parameterRuleIDs[parameterName]) !== null && _f !== void 0 ? _f : layer.ruleID,
        allocatedExperiment: allocatedExperiment,
        isExplicitParameter: String(isExplicit)
    };
    if (((_g = layer.__evaluation) === null || _g === void 0 ? void 0 : _g.version) != null) metadata['configVersion'] = layer.__evaluation.version;
    return $831b1fa1d6ab26dc$var$_createExposure($831b1fa1d6ab26dc$var$LAYER_EXPOSURE_NAME, user, layer.details, metadata, $831b1fa1d6ab26dc$var$_mapExposures(secondaryExposures, exposureMapping));
};
module.exports._createLayerParameterExposure = $831b1fa1d6ab26dc$var$_createLayerParameterExposure;
const $831b1fa1d6ab26dc$var$_addEvaluationDetailsToMetadata = (details, metadata)=>{
    metadata['reason'] = details.reason;
    if (details.lcut) metadata['lcut'] = String(details.lcut);
    if (details.receivedAt) metadata['receivedAt'] = String(details.receivedAt);
    return metadata;
};

});

parcelRegister("fFtli", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LoggingEnabledOption = module.exports.LogEventCompressionMode = void 0;
module.exports.LogEventCompressionMode = {
    /** Do not compress request bodies */ Disabled: 'd',
    /** Compress request bodies unless a network proxy is configured */ Enabled: 'e',
    /** Always compress request bodies, even when a proxy is configured */ Forced: 'f'
};
module.exports.LoggingEnabledOption = {
    disabled: 'disabled',
    browserOnly: 'browser-only',
    always: 'always'
};

});

parcelRegister("cUOGL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._setObjectInStorage = module.exports._getObjectFromStorage = module.exports.Storage = void 0;

var $fvY6A = parcelRequire("fvY6A");

var $jjgcN = parcelRequire("jjgcN");
const $967208b68a686b58$var$inMemoryStore = {};
const $967208b68a686b58$var$_inMemoryProvider = {
    isReady: ()=>true,
    isReadyResolver: ()=>null,
    getProviderName: ()=>'InMemory',
    getItem: (key)=>$967208b68a686b58$var$inMemoryStore[key] ? $967208b68a686b58$var$inMemoryStore[key] : null,
    setItem: (key, value)=>{
        $967208b68a686b58$var$inMemoryStore[key] = value;
    },
    removeItem: (key)=>{
        delete $967208b68a686b58$var$inMemoryStore[key];
    },
    getAllKeys: ()=>Object.keys($967208b68a686b58$var$inMemoryStore)
};
let $967208b68a686b58$var$_localStorageProvider = null;
try {
    const win = (0, $jjgcN._getWindowSafe)();
    if (win && win.localStorage && typeof win.localStorage.getItem === 'function') $967208b68a686b58$var$_localStorageProvider = {
        isReady: ()=>true,
        isReadyResolver: ()=>null,
        getProviderName: ()=>'LocalStorage',
        getItem: (key)=>win.localStorage.getItem(key),
        setItem: (key, value)=>win.localStorage.setItem(key, value),
        removeItem: (key)=>win.localStorage.removeItem(key),
        getAllKeys: ()=>Object.keys(win.localStorage)
    };
} catch (error) {
    $fvY6A.Log.warn('Failed to setup localStorageProvider.');
}
let $967208b68a686b58$var$_main = $967208b68a686b58$var$_localStorageProvider !== null && $967208b68a686b58$var$_localStorageProvider !== void 0 ? $967208b68a686b58$var$_localStorageProvider : $967208b68a686b58$var$_inMemoryProvider;
let $967208b68a686b58$var$_current = $967208b68a686b58$var$_main;
function $967208b68a686b58$var$_inMemoryBreaker(action) {
    try {
        return action();
    } catch (error) {
        if (error instanceof Error && error.name === 'SecurityError') {
            module.exports.Storage._setProvider($967208b68a686b58$var$_inMemoryProvider);
            return null;
        }
        throw error;
    }
}
module.exports.Storage = {
    isReady: ()=>$967208b68a686b58$var$_current.isReady(),
    isReadyResolver: ()=>$967208b68a686b58$var$_current.isReadyResolver(),
    getProviderName: ()=>$967208b68a686b58$var$_current.getProviderName(),
    getItem: (key)=>$967208b68a686b58$var$_inMemoryBreaker(()=>$967208b68a686b58$var$_current.getItem(key)),
    setItem: (key, value)=>$967208b68a686b58$var$_inMemoryBreaker(()=>$967208b68a686b58$var$_current.setItem(key, value)),
    removeItem: (key)=>$967208b68a686b58$var$_current.removeItem(key),
    getAllKeys: ()=>$967208b68a686b58$var$_current.getAllKeys(),
    // StorageProviderManagment
    _setProvider: (newProvider)=>{
        $967208b68a686b58$var$_main = newProvider;
        $967208b68a686b58$var$_current = newProvider;
    },
    _setDisabled: (isDisabled)=>{
        if (isDisabled) $967208b68a686b58$var$_current = $967208b68a686b58$var$_inMemoryProvider;
        else $967208b68a686b58$var$_current = $967208b68a686b58$var$_main;
    }
};
function $967208b68a686b58$var$_getObjectFromStorage(key) {
    const value = module.exports.Storage.getItem(key);
    try {
        return JSON.parse(value !== null && value !== void 0 ? value : 'null');
    } catch (e) {
        $fvY6A.Log.error(`Failed to parse value for key "${key}"`);
        return null;
    }
}
module.exports._getObjectFromStorage = $967208b68a686b58$var$_getObjectFromStorage;
function $967208b68a686b58$var$_setObjectInStorage(key, obj) {
    module.exports.Storage.setItem(key, JSON.stringify(obj));
}
module.exports._setObjectInStorage = $967208b68a686b58$var$_setObjectInStorage;

});

parcelRegister("12s6q", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.UrlConfiguration = void 0;

var $lUUuL = parcelRequire("lUUuL");

var $4JLTD = parcelRequire("4JLTD");
const $0c1bc6f7052054af$var$ENDPOINT_DNS_KEY_MAP = {
    [$4JLTD.Endpoint._initialize]: 'i',
    [$4JLTD.Endpoint._rgstr]: 'e',
    [$4JLTD.Endpoint._download_config_specs]: 'd'
};
class $0c1bc6f7052054af$var$UrlConfiguration {
    constructor(endpoint, customUrl, customApi, fallbackUrls){
        this.customUrl = null;
        this.fallbackUrls = null;
        this.endpoint = endpoint;
        this.endpointDnsKey = $0c1bc6f7052054af$var$ENDPOINT_DNS_KEY_MAP[endpoint];
        if (customUrl) this.customUrl = customUrl;
        if (!customUrl && customApi) this.customUrl = customApi.endsWith('/') ? `${customApi}${endpoint}` : `${customApi}/${endpoint}`;
        if (fallbackUrls) this.fallbackUrls = fallbackUrls;
        const defaultApi = $4JLTD.NetworkDefault[endpoint];
        this.defaultUrl = `${defaultApi}/${endpoint}`;
    }
    getUrl() {
        var _a;
        return (_a = this.customUrl) !== null && _a !== void 0 ? _a : this.defaultUrl;
    }
    getChecksum() {
        var _a;
        const fallbacks = ((_a = this.fallbackUrls) !== null && _a !== void 0 ? _a : []).sort().join(',');
        return (0, $lUUuL._DJB2)(this.customUrl + fallbacks);
    }
}
module.exports.UrlConfiguration = $0c1bc6f7052054af$var$UrlConfiguration;

});

parcelRegister("71rjN", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._notifyVisibilityChanged = module.exports._subscribeToVisiblityChanged = module.exports._isUnloading = module.exports._isCurrentlyVisible = void 0;

var $jjgcN = parcelRequire("jjgcN");
const $51cdd13d47b1548c$var$FOREGROUND = 'foreground';
const $51cdd13d47b1548c$var$BACKGROUND = 'background';
const $51cdd13d47b1548c$var$LISTENERS = [];
let $51cdd13d47b1548c$var$current = $51cdd13d47b1548c$var$FOREGROUND;
let $51cdd13d47b1548c$var$isUnloading = false;
const $51cdd13d47b1548c$var$_isCurrentlyVisible = ()=>{
    return $51cdd13d47b1548c$var$current === $51cdd13d47b1548c$var$FOREGROUND;
};
module.exports._isCurrentlyVisible = $51cdd13d47b1548c$var$_isCurrentlyVisible;
const $51cdd13d47b1548c$var$_isUnloading = ()=>$51cdd13d47b1548c$var$isUnloading;
module.exports._isUnloading = $51cdd13d47b1548c$var$_isUnloading;
const $51cdd13d47b1548c$var$_subscribeToVisiblityChanged = (listener)=>{
    $51cdd13d47b1548c$var$LISTENERS.unshift(listener);
};
module.exports._subscribeToVisiblityChanged = $51cdd13d47b1548c$var$_subscribeToVisiblityChanged;
const $51cdd13d47b1548c$var$_notifyVisibilityChanged = (visibility)=>{
    if (visibility === $51cdd13d47b1548c$var$current) return;
    $51cdd13d47b1548c$var$current = visibility;
    $51cdd13d47b1548c$var$LISTENERS.forEach((l)=>l(visibility));
};
module.exports._notifyVisibilityChanged = $51cdd13d47b1548c$var$_notifyVisibilityChanged;
(0, $jjgcN._addWindowEventListenerSafe)('focus', ()=>{
    $51cdd13d47b1548c$var$isUnloading = false;
    (0, module.exports._notifyVisibilityChanged)($51cdd13d47b1548c$var$FOREGROUND);
});
(0, $jjgcN._addWindowEventListenerSafe)('blur', ()=>(0, module.exports._notifyVisibilityChanged)($51cdd13d47b1548c$var$BACKGROUND));
(0, $jjgcN._addDocumentEventListenerSafe)('visibilitychange', ()=>{
    (0, module.exports._notifyVisibilityChanged)(document.visibilityState === 'visible' ? $51cdd13d47b1548c$var$FOREGROUND : $51cdd13d47b1548c$var$BACKGROUND);
});
(0, $jjgcN._addWindowEventListenerSafe)((0, $jjgcN._getUnloadEvent)(), ()=>{
    $51cdd13d47b1548c$var$isUnloading = true;
    (0, module.exports._notifyVisibilityChanged)($51cdd13d47b1548c$var$BACKGROUND);
});

});


parcelRegister("9tDUz", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.StatsigMetadataProvider = module.exports.SDK_VERSION = void 0;
module.exports.SDK_VERSION = '3.30.2';
let $6e65c810593ccaf7$var$metadata = {
    sdkVersion: module.exports.SDK_VERSION,
    sdkType: 'js-mono'
};
module.exports.StatsigMetadataProvider = {
    get: ()=>$6e65c810593ccaf7$var$metadata,
    add: (additions)=>{
        $6e65c810593ccaf7$var$metadata = Object.assign(Object.assign({}, $6e65c810593ccaf7$var$metadata), additions);
    }
};

});

parcelRegister("IwlSQ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("hPIlK", function(module, exports) {
"use strict";
var $cfb99a0123e1f5cd$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._makeDataAdapterResult = module.exports.DataAdapterCore = void 0;

var $fvY6A = parcelRequire("fvY6A");

var $lbAhi = parcelRequire("lbAhi");

var $8Nbnq = parcelRequire("8Nbnq");

var $cUOGL = parcelRequire("cUOGL");

var $1I57i = parcelRequire("1I57i");
const $cfb99a0123e1f5cd$var$CACHE_LIMIT = 10;
const $cfb99a0123e1f5cd$var$MAX_CACHE_WRITE_ATTEMPTS = 8;
class $cfb99a0123e1f5cd$var$DataAdapterCore {
    constructor(_adapterName, _cacheSuffix){
        this._adapterName = _adapterName;
        this._cacheSuffix = _cacheSuffix;
        this._options = null;
        this._sdkKey = null;
        this._cacheLimit = $cfb99a0123e1f5cd$var$CACHE_LIMIT;
        this._lastModifiedStoreKey = `statsig.last_modified_time.${_cacheSuffix}`;
        this._inMemoryCache = new $cfb99a0123e1f5cd$var$InMemoryCache();
    }
    attach(sdkKey, options, _network) {
        this._sdkKey = sdkKey;
        this._options = options;
    }
    getDataSync(user) {
        const normalized = user && (0, $8Nbnq._normalizeUser)(user, this._options);
        const cacheKey = this._getCacheKey(normalized);
        const inMem = this._inMemoryCache.get(cacheKey, normalized);
        if (inMem && this._getIsCacheValueValid(inMem)) return inMem;
        const cache = this._loadFromCache(cacheKey);
        if (cache && this._getIsCacheValueValid(cache)) {
            this._inMemoryCache.add(cacheKey, cache, this._cacheLimit);
            return this._inMemoryCache.get(cacheKey, normalized);
        }
        return null;
    }
    setData(data, user) {
        const normalized = user && (0, $8Nbnq._normalizeUser)(user, this._options);
        const cacheKey = this._getCacheKey(normalized);
        this._inMemoryCache.add(cacheKey, $cfb99a0123e1f5cd$var$_makeDataAdapterResult('Bootstrap', data, null, normalized), this._cacheLimit);
    }
    _getIsCacheValueValid(current) {
        return current.stableID == null || current.stableID === $lbAhi.StableID.get(this._getSdkKey());
    }
    _getDataAsyncImpl(current, user, options) {
        return $cfb99a0123e1f5cd$var$__awaiter(this, void 0, void 0, function*() {
            if (!$cUOGL.Storage.isReady()) yield $cUOGL.Storage.isReadyResolver();
            const cache = current !== null && current !== void 0 ? current : this.getDataSync(user);
            const ops = [
                this._fetchAndPrepFromNetwork(cache, user, options)
            ];
            if (options === null || options === void 0 ? void 0 : options.timeoutMs) ops.push(new Promise((r)=>setTimeout(r, options.timeoutMs)).then(()=>{
                $fvY6A.Log.debug('Fetching latest value timed out');
                return null;
            }));
            return yield Promise.race(ops);
        });
    }
    _prefetchDataImpl(user, options) {
        return $cfb99a0123e1f5cd$var$__awaiter(this, void 0, void 0, function*() {
            const normalized = user && (0, $8Nbnq._normalizeUser)(user, this._options);
            const cacheKey = this._getCacheKey(normalized);
            const result = yield this._getDataAsyncImpl(null, normalized, options);
            if (result) this._inMemoryCache.add(cacheKey, Object.assign(Object.assign({}, result), {
                source: 'Prefetch'
            }), this._cacheLimit);
        });
    }
    _fetchAndPrepFromNetwork(cachedResult, user, options) {
        return $cfb99a0123e1f5cd$var$__awaiter(this, void 0, void 0, function*() {
            var _a;
            const cachedData = (_a = cachedResult === null || cachedResult === void 0 ? void 0 : cachedResult.data) !== null && _a !== void 0 ? _a : null;
            const isCacheValidFor204 = cachedResult != null && this._isCachedResultValidFor204(cachedResult, user);
            const latest = yield this._fetchFromNetwork(cachedData, user, options, isCacheValidFor204);
            if (!latest) {
                $fvY6A.Log.debug('No response returned for latest value');
                return null;
            }
            const response = (0, $1I57i._typedJsonParse)(latest, 'has_updates', 'Response');
            const sdkKey = this._getSdkKey();
            const stableID = $lbAhi.StableID.get(sdkKey);
            let result = null;
            if ((response === null || response === void 0 ? void 0 : response.has_updates) === true) result = $cfb99a0123e1f5cd$var$_makeDataAdapterResult('Network', latest, stableID, user);
            else if (cachedData && (response === null || response === void 0 ? void 0 : response.has_updates) === false) result = $cfb99a0123e1f5cd$var$_makeDataAdapterResult('NetworkNotModified', cachedData, stableID, user);
            else return null;
            const cacheKey = this._getCacheKey(user);
            this._inMemoryCache.add(cacheKey, result, this._cacheLimit);
            this._writeToCache(cacheKey, result);
            return result;
        });
    }
    _getSdkKey() {
        if (this._sdkKey != null) return this._sdkKey;
        $fvY6A.Log.error(`${this._adapterName} is not attached to a Client`);
        return '';
    }
    _loadFromCache(cacheKey) {
        var _a;
        const cache = (_a = $cUOGL.Storage.getItem) === null || _a === void 0 ? void 0 : _a.call($cUOGL.Storage, cacheKey);
        if (cache == null) return null;
        const result = (0, $1I57i._typedJsonParse)(cache, 'source', 'Cached Result');
        return result ? Object.assign(Object.assign({}, result), {
            source: 'Cache'
        }) : null;
    }
    _writeToCache(cacheKey, result) {
        const resultString = JSON.stringify(result);
        for(let i = 0; i < $cfb99a0123e1f5cd$var$MAX_CACHE_WRITE_ATTEMPTS; i++)try {
            $cUOGL.Storage.setItem(cacheKey, resultString);
            break;
        } catch (error) {
            if (!(error instanceof Error) || !(error.toString().includes('QuotaExceededError') || error.toString().includes('QUOTA_EXCEEDED_ERR')) || this._cacheLimit <= 1) throw error;
            this._cacheLimit = Math.ceil(this._cacheLimit / 2);
            this._runLocalStorageCacheEviction(cacheKey, this._cacheLimit - 1);
        }
        this._runLocalStorageCacheEviction(cacheKey);
    }
    _runLocalStorageCacheEviction(cacheKey, cacheLimit = this._cacheLimit) {
        var _a;
        const lastModifiedTimeMap = (_a = (0, $cUOGL._getObjectFromStorage)(this._lastModifiedStoreKey)) !== null && _a !== void 0 ? _a : {};
        lastModifiedTimeMap[cacheKey] = Date.now();
        const evictableKeys = $cfb99a0123e1f5cd$var$_getEvictableKeys(lastModifiedTimeMap, cacheLimit);
        for (const evictable of evictableKeys){
            delete lastModifiedTimeMap[evictable];
            $cUOGL.Storage.removeItem(evictable);
        }
        (0, $cUOGL._setObjectInStorage)(this._lastModifiedStoreKey, lastModifiedTimeMap);
    }
}
module.exports.DataAdapterCore = $cfb99a0123e1f5cd$var$DataAdapterCore;
function $cfb99a0123e1f5cd$var$_makeDataAdapterResult(source, data, stableID, user) {
    return {
        source: source,
        data: data,
        receivedAt: Date.now(),
        stableID: stableID,
        fullUserHash: (0, $8Nbnq._getFullUserHash)(user)
    };
}
module.exports._makeDataAdapterResult = $cfb99a0123e1f5cd$var$_makeDataAdapterResult;
class $cfb99a0123e1f5cd$var$InMemoryCache {
    constructor(){
        this._data = {};
    }
    get(cacheKey, user) {
        var _a;
        const result = this._data[cacheKey];
        const cached = result === null || result === void 0 ? void 0 : result.stableID;
        const provided = (_a = user === null || user === void 0 ? void 0 : user.customIDs) === null || _a === void 0 ? void 0 : _a.stableID;
        if (provided && cached && provided !== cached) {
            $fvY6A.Log.warn("'StatsigUser.customIDs.stableID' mismatch");
            return null;
        }
        return result;
    }
    add(cacheKey, value, cacheLimit) {
        const evictableKeys = $cfb99a0123e1f5cd$var$_getEvictableKeys(this._data, cacheLimit - 1);
        for (const evictable of evictableKeys)delete this._data[evictable];
        this._data[cacheKey] = value;
    }
    merge(values) {
        this._data = Object.assign(Object.assign({}, this._data), values);
    }
}
function $cfb99a0123e1f5cd$var$_getEvictableKeys(data, limit) {
    const keys = Object.keys(data);
    if (keys.length <= limit) return [];
    if (limit === 0) return keys;
    return keys.sort((keyA, keyB)=>{
        const valueA = data[keyA];
        const valueB = data[keyB];
        if (typeof valueA === 'object' && typeof valueB === 'object') return valueA.receivedAt - valueB.receivedAt;
        return valueA - valueB;
    }).slice(0, keys.length - limit);
}

});
parcelRegister("lbAhi", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getCookieName = module.exports.StableID = void 0;

var $6ZtBQ = parcelRequire("6ZtBQ");

var $fvY6A = parcelRequire("fvY6A");

var $jjgcN = parcelRequire("jjgcN");

var $cUOGL = parcelRequire("cUOGL");

var $5G12m = parcelRequire("5G12m");
const $f6c6c4187dbee940$var$PROMISE_MAP = {};
const $f6c6c4187dbee940$var$COOKIE_ENABLED_MAP = {};
const $f6c6c4187dbee940$var$DISABLED_MAP = {};
module.exports.StableID = {
    cookiesEnabled: false,
    randomID: Math.random().toString(36),
    get: (sdkKey)=>{
        if ($f6c6c4187dbee940$var$DISABLED_MAP[sdkKey]) return null;
        if ($f6c6c4187dbee940$var$PROMISE_MAP[sdkKey] != null) return $f6c6c4187dbee940$var$PROMISE_MAP[sdkKey];
        let stableID = null;
        stableID = $f6c6c4187dbee940$var$_loadFromCookie(sdkKey);
        if (stableID != null) {
            $f6c6c4187dbee940$var$PROMISE_MAP[sdkKey] = stableID;
            $f6c6c4187dbee940$var$_persistToStorage(stableID, sdkKey);
            return stableID;
        }
        stableID = $f6c6c4187dbee940$var$_loadFromStorage(sdkKey);
        if (stableID == null) stableID = (0, $5G12m.getUUID)();
        $f6c6c4187dbee940$var$_persistToStorage(stableID, sdkKey);
        $f6c6c4187dbee940$var$_persistToCookie(stableID, sdkKey);
        $f6c6c4187dbee940$var$PROMISE_MAP[sdkKey] = stableID;
        return stableID;
    },
    setOverride: (override, sdkKey)=>{
        $f6c6c4187dbee940$var$PROMISE_MAP[sdkKey] = override;
        $f6c6c4187dbee940$var$_persistToStorage(override, sdkKey);
        $f6c6c4187dbee940$var$_persistToCookie(override, sdkKey);
    },
    _setCookiesEnabled: (sdkKey, cookiesEnabled)=>{
        $f6c6c4187dbee940$var$COOKIE_ENABLED_MAP[sdkKey] = cookiesEnabled;
    },
    _setDisabled: (sdkKey, disabled)=>{
        $f6c6c4187dbee940$var$DISABLED_MAP[sdkKey] = disabled;
    }
};
function $f6c6c4187dbee940$var$_getStableIDStorageKey(sdkKey) {
    return `statsig.stable_id.${(0, $6ZtBQ._getStorageKey)(sdkKey)}`;
}
function $f6c6c4187dbee940$var$_persistToStorage(stableID, sdkKey) {
    const storageKey = $f6c6c4187dbee940$var$_getStableIDStorageKey(sdkKey);
    try {
        (0, $cUOGL._setObjectInStorage)(storageKey, stableID);
    } catch (e) {
        $fvY6A.Log.warn('Failed to save StableID to storage');
    }
}
function $f6c6c4187dbee940$var$_loadFromStorage(sdkKey) {
    const storageKey = $f6c6c4187dbee940$var$_getStableIDStorageKey(sdkKey);
    return (0, $cUOGL._getObjectFromStorage)(storageKey);
}
function $f6c6c4187dbee940$var$_loadFromCookie(sdkKey) {
    if (!$f6c6c4187dbee940$var$COOKIE_ENABLED_MAP[sdkKey] || (0, $jjgcN._getDocumentSafe)() == null) return null;
    const cookies = document.cookie.split(';');
    for (const cookie of cookies){
        const [key, value] = cookie.trim().split('=');
        if (key === $f6c6c4187dbee940$var$getCookieName(sdkKey)) return decodeURIComponent(value);
    }
    return null;
}
function $f6c6c4187dbee940$var$_persistToCookie(stableID, sdkKey) {
    if (!$f6c6c4187dbee940$var$COOKIE_ENABLED_MAP[sdkKey] || (0, $jjgcN._getDocumentSafe)() == null) return;
    const expiryDate = new Date();
    expiryDate.setFullYear(expiryDate.getFullYear() + 1);
    document.cookie = `${$f6c6c4187dbee940$var$getCookieName(sdkKey)}=${encodeURIComponent(stableID)}; expires=${expiryDate.toUTCString()}; path=/`;
}
function $f6c6c4187dbee940$var$getCookieName(sdkKey) {
    return `statsig.stable_id.${(0, $6ZtBQ._getStorageKey)(sdkKey)}`;
}
module.exports.getCookieName = $f6c6c4187dbee940$var$getCookieName;

});
parcelRegister("5G12m", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getUUID = void 0;
function $4221adf57cf05a89$var$getUUID() {
    if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') return crypto.randomUUID();
    let d = new Date().getTime();
    let d2 = typeof performance !== 'undefined' && performance.now && performance.now() * 1000 || 0;
    const y = '89ab'[Math.floor(Math.random() * 4)];
    return `xxxxxxxx-xxxx-4xxx-${y}xxx-xxxxxxxxxxxx`.replace(/[xy]/g, (c)=>{
        let r = Math.random() * 16;
        if (d > 0) {
            r = (d + r) % 16 | 0;
            d = Math.floor(d / 16);
        } else {
            r = (d2 + r) % 16 | 0;
            d2 = Math.floor(d2 / 16);
        }
        return (c === 'x' ? r : r & 0x7 | 0x8).toString(16);
    });
}
module.exports.getUUID = $4221adf57cf05a89$var$getUUID;

});


parcelRegister("8Nbnq", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._getFullUserHash = module.exports._normalizeUser = void 0;

var $lUUuL = parcelRequire("lUUuL");

var $fvY6A = parcelRequire("fvY6A");
function $666bb98ace10d484$var$_normalizeUser(original, options, fallbackEnvironment) {
    try {
        const copy = JSON.parse(JSON.stringify(original));
        if (options != null && options.environment != null) copy.statsigEnvironment = options.environment;
        else if (fallbackEnvironment != null) copy.statsigEnvironment = {
            tier: fallbackEnvironment
        };
        return copy;
    } catch (error) {
        $fvY6A.Log.error('Failed to JSON.stringify user');
        return {
            statsigEnvironment: undefined
        };
    }
}
module.exports._normalizeUser = $666bb98ace10d484$var$_normalizeUser;
function $666bb98ace10d484$var$_getFullUserHash(user) {
    return user ? (0, $lUUuL._DJB2Object)(user) : null;
}
module.exports._getFullUserHash = $666bb98ace10d484$var$_getFullUserHash;

});

parcelRegister("1I57i", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._typedJsonParse = void 0;

var $fvY6A = parcelRequire("fvY6A");
/**
 *
 * @param {string} data The values to parse into T
 * @param {string} guard A field that must exists on the parsed object for the parse to be valid
 * @param {string} error An error to print via Log.error() when parsing fails
 * @returns {T | null} The parse object T or null if it failed
 */ function $13edde94128756b8$var$_typedJsonParse(data, guard, typeName) {
    try {
        const result = JSON.parse(data);
        if (result && typeof result === 'object' && guard in result) return result;
    } catch (_a) {
    // noop
    }
    $fvY6A.Log.error(`Failed to parse ${typeName}`);
    return null;
}
module.exports._typedJsonParse = $13edde94128756b8$var$_typedJsonParse;

});


parcelRegister("audqG", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("a7dQ0", function(module, exports) {
"use strict";
var $75d54abd189c1104$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ErrorBoundary = module.exports.EXCEPTION_ENDPOINT = void 0;

var $fvY6A = parcelRequire("fvY6A");

var $6OyqX = parcelRequire("6OyqX");

var $9tDUz = parcelRequire("9tDUz");
module.exports.EXCEPTION_ENDPOINT = 'https://statsigapi.net/v1/sdk_exception';
const $75d54abd189c1104$var$UNKNOWN_ERROR = '[Statsig] UnknownError';
class $75d54abd189c1104$var$ErrorBoundary {
    constructor(_sdkKey, _options, _emitter, _lastSeenError){
        this._sdkKey = _sdkKey;
        this._options = _options;
        this._emitter = _emitter;
        this._lastSeenError = _lastSeenError;
        this._seen = new Set();
    }
    wrap(instance, namePrefix) {
        try {
            const obj = instance;
            $75d54abd189c1104$var$_getAllInstanceMethodNames(obj).forEach((name)=>{
                const original = obj[name];
                if ('$EB' in original) return;
                obj[name] = (...args)=>{
                    return this._capture(namePrefix ? `${namePrefix}:${name}` : name, ()=>original.apply(instance, args));
                };
                obj[name].$EB = true;
            });
        } catch (err) {
            this._onError('eb:wrap', err);
        }
    }
    logError(tag, error) {
        this._onError(tag, error);
    }
    getLastSeenErrorAndReset() {
        const tempError = this._lastSeenError;
        this._lastSeenError = undefined;
        return tempError !== null && tempError !== void 0 ? tempError : null;
    }
    attachErrorIfNoneExists(error) {
        if (this._lastSeenError) return;
        this._lastSeenError = $75d54abd189c1104$var$_resolveError(error);
    }
    _capture(tag, task) {
        try {
            const res = task();
            if (res && res instanceof Promise) return res.catch((err)=>this._onError(tag, err));
            return res;
        } catch (error) {
            this._onError(tag, error);
            return null;
        }
    }
    _onError(tag, error) {
        try {
            $fvY6A.Log.warn(`Caught error in ${tag}`, {
                error: error
            });
            const impl = ()=>$75d54abd189c1104$var$__awaiter(this, void 0, void 0, function*() {
                    var _a, _b, _c, _d, _e, _f, _g;
                    const unwrapped = error ? error : Error($75d54abd189c1104$var$UNKNOWN_ERROR);
                    const isError = unwrapped instanceof Error;
                    const name = isError ? unwrapped.name : 'No Name';
                    const resolvedError = $75d54abd189c1104$var$_resolveError(unwrapped);
                    this._lastSeenError = resolvedError;
                    if (this._seen.has(name)) return;
                    this._seen.add(name);
                    if ((_b = (_a = this._options) === null || _a === void 0 ? void 0 : _a.networkConfig) === null || _b === void 0 ? void 0 : _b.preventAllNetworkTraffic) {
                        (_c = this._emitter) === null || _c === void 0 || _c.call(this, {
                            name: 'error',
                            error: error,
                            tag: tag
                        });
                        return;
                    }
                    const sdkType = $6OyqX.SDKType._get(this._sdkKey);
                    const statsigMetadata = $9tDUz.StatsigMetadataProvider.get();
                    const info = isError ? unwrapped.stack : $75d54abd189c1104$var$_getDescription(unwrapped);
                    const body = Object.assign({
                        tag: tag,
                        exception: name,
                        info: info,
                        statsigOptions: $75d54abd189c1104$var$_getStatsigOptionLoggingCopy(this._options)
                    }, Object.assign(Object.assign({}, statsigMetadata), {
                        sdkType: sdkType
                    }));
                    const func = (_f = (_e = (_d = this._options) === null || _d === void 0 ? void 0 : _d.networkConfig) === null || _e === void 0 ? void 0 : _e.networkOverrideFunc) !== null && _f !== void 0 ? _f : fetch;
                    yield func(module.exports.EXCEPTION_ENDPOINT, {
                        method: 'POST',
                        headers: {
                            'STATSIG-API-KEY': this._sdkKey,
                            'STATSIG-SDK-TYPE': String(sdkType),
                            'STATSIG-SDK-VERSION': String(statsigMetadata.sdkVersion),
                            'Content-Type': 'application/json'
                        },
                        body: JSON.stringify(body)
                    });
                    (_g = this._emitter) === null || _g === void 0 || _g.call(this, {
                        name: 'error',
                        error: error,
                        tag: tag
                    });
                });
            impl().then(()=>{
            /* noop */ }).catch(()=>{
            /* noop */ });
        } catch (_error) {
        /* noop */ }
    }
}
module.exports.ErrorBoundary = $75d54abd189c1104$var$ErrorBoundary;
function $75d54abd189c1104$var$_resolveError(error) {
    if (error instanceof Error) return error;
    else if (typeof error === 'string') return new Error(error);
    else return new Error('An unknown error occurred.');
}
function $75d54abd189c1104$var$_getDescription(obj) {
    try {
        return JSON.stringify(obj);
    } catch (_a) {
        return $75d54abd189c1104$var$UNKNOWN_ERROR;
    }
}
function $75d54abd189c1104$var$_getAllInstanceMethodNames(instance) {
    const names = new Set();
    let proto = Object.getPrototypeOf(instance);
    while(proto && proto !== Object.prototype){
        Object.getOwnPropertyNames(proto).filter((prop)=>typeof (proto === null || proto === void 0 ? void 0 : proto[prop]) === 'function').forEach((name)=>names.add(name));
        proto = Object.getPrototypeOf(proto);
    }
    return Array.from(names);
}
function $75d54abd189c1104$var$_getStatsigOptionLoggingCopy(options) {
    if (!options) return {};
    const loggingCopy = {};
    Object.keys(options).forEach((key)=>{
        const option = key;
        const value = options[option];
        const valueType = typeof value;
        switch(valueType){
            case 'number':
            case 'bigint':
            case 'boolean':
                loggingCopy[String(option)] = value;
                break;
            case 'string':
                if (value.length < 50) loggingCopy[String(option)] = value;
                else loggingCopy[String(option)] = 'set';
                break;
            case 'object':
                if (option === 'environment') loggingCopy['environment'] = value;
                else if (option === 'networkConfig') loggingCopy['networkConfig'] = value;
                else loggingCopy[String(option)] = value != null ? 'set' : 'unset';
                break;
            default:
        }
    });
    return loggingCopy;
}

});
parcelRegister("6OyqX", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SDKType = void 0;
const $4f621f727d71eed4$var$SDK_CLIENT = {};
let $4f621f727d71eed4$var$suffix;
module.exports.SDKType = {
    _get: (sdkKey)=>{
        var _a;
        return ((_a = $4f621f727d71eed4$var$SDK_CLIENT[sdkKey]) !== null && _a !== void 0 ? _a : 'js-mono') + ($4f621f727d71eed4$var$suffix !== null && $4f621f727d71eed4$var$suffix !== void 0 ? $4f621f727d71eed4$var$suffix : '');
    },
    _setClientType (sdkKey, client) {
        $4f621f727d71eed4$var$SDK_CLIENT[sdkKey] = client;
    },
    _setBindingType (binding) {
        if (!$4f621f727d71eed4$var$suffix || $4f621f727d71eed4$var$suffix === '-react') $4f621f727d71eed4$var$suffix = '-' + binding;
    }
};

});


parcelRegister("7A9u9", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("cpYjX", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("drWJh", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("g4vOj", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.createMemoKey = module.exports.MemoPrefix = void 0;
module.exports.MemoPrefix = {
    _gate: 'g',
    _dynamicConfig: 'c',
    _experiment: 'e',
    _configList: 'cl',
    _layer: 'l',
    _paramStore: 'p'
};
const $bb35b1f34b6c714c$var$EXIST_KEYS = new Set([]);
const $bb35b1f34b6c714c$var$DO_NOT_MEMO_KEYS = new Set([
    // Add keys that if exist, should not be memoized
    'userPersistedValues'
]);
function $bb35b1f34b6c714c$var$createMemoKey(prefix, name, options) {
    let cacheKey = `${prefix}|${name}`;
    if (!options) return cacheKey;
    for (const key of Object.keys(options)){
        if ($bb35b1f34b6c714c$var$DO_NOT_MEMO_KEYS.has(key)) return undefined;
        if ($bb35b1f34b6c714c$var$EXIST_KEYS.has(key)) cacheKey += `|${key}=true`;
        else cacheKey += `|${key}=${options[key]}`;
    }
    return cacheKey;
}
module.exports.createMemoKey = $bb35b1f34b6c714c$var$createMemoKey;

});

parcelRegister("4neZ1", function(module, exports) {
"use strict";
var $32f4eec2dcf9f3a5$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.NetworkCore = void 0;

var $6zYf6 = parcelRequire("6zYf6");

var $6zYf6 = parcelRequire("6zYf6");

var $cNxHP = parcelRequire("cNxHP");

var $fvY6A = parcelRequire("fvY6A");

var $4JLTD = parcelRequire("4JLTD");

var $9zIz8 = parcelRequire("9zIz8");

var $cd98p = parcelRequire("cd98p");

var $6OyqX = parcelRequire("6OyqX");

var $jjgcN = parcelRequire("jjgcN");

var $6cbWs = parcelRequire("6cbWs");

var $lbAhi = parcelRequire("lbAhi");

var $dbFUm = parcelRequire("dbFUm");

var $9tDUz = parcelRequire("9tDUz");

var $fFtli = parcelRequire("fFtli");

var $71rjN = parcelRequire("71rjN");
const $32f4eec2dcf9f3a5$var$DEFAULT_TIMEOUT_MS = 10000;
const $32f4eec2dcf9f3a5$var$BACKOFF_BASE_MS = 500;
const $32f4eec2dcf9f3a5$var$BACKOFF_MAX_MS = 30000;
const $32f4eec2dcf9f3a5$var$RATE_LIMIT_WINDOW_MS = 1000;
const $32f4eec2dcf9f3a5$var$RATE_LIMIT_MAX_REQ_COUNT = 50;
const $32f4eec2dcf9f3a5$var$LEAK_RATE = $32f4eec2dcf9f3a5$var$RATE_LIMIT_MAX_REQ_COUNT / $32f4eec2dcf9f3a5$var$RATE_LIMIT_WINDOW_MS;
const $32f4eec2dcf9f3a5$var$RETRYABLE_CODES = new Set([
    408,
    500,
    502,
    503,
    504,
    522,
    524,
    599
]);
class $32f4eec2dcf9f3a5$var$NetworkCore {
    constructor(options, _emitter){
        this._emitter = _emitter;
        this._errorBoundary = null;
        this._timeout = $32f4eec2dcf9f3a5$var$DEFAULT_TIMEOUT_MS;
        this._netConfig = {};
        this._options = {};
        this._leakyBucket = {};
        this._lastUsedInitUrl = null;
        if (options) this._options = options;
        if (this._options.networkConfig) this._netConfig = this._options.networkConfig;
        if (this._netConfig.networkTimeoutMs) this._timeout = this._netConfig.networkTimeoutMs;
        this._fallbackResolver = new $9zIz8.NetworkFallbackResolver(this._options);
        this.setLogEventCompressionMode(this._getLogEventCompressionMode(options));
    }
    setLogEventCompressionMode(mode) {
        this._options.logEventCompressionMode = mode;
    }
    setErrorBoundary(errorBoundary) {
        this._errorBoundary = errorBoundary;
        this._errorBoundary.wrap(this);
        this._errorBoundary.wrap(this._fallbackResolver);
        this._fallbackResolver.setErrorBoundary(errorBoundary);
    }
    isBeaconSupported() {
        return typeof navigator !== 'undefined' && typeof navigator.sendBeacon === 'function';
    }
    getLastUsedInitUrlAndReset() {
        const tempUrl = this._lastUsedInitUrl;
        this._lastUsedInitUrl = null;
        return tempUrl;
    }
    beacon(args) {
        if (!$32f4eec2dcf9f3a5$var$_ensureValidSdkKey(args)) return false;
        const argsInternal = this._getInternalRequestArgs('POST', args);
        const url = this._getPopulatedURL(argsInternal);
        const nav = navigator;
        return nav.sendBeacon.bind(nav)(url, argsInternal.body);
    }
    post(args) {
        return $32f4eec2dcf9f3a5$var$__awaiter(this, void 0, void 0, function*() {
            const argsInternal = this._getInternalRequestArgs('POST', args);
            this._tryEncodeBody(argsInternal);
            yield this._tryToCompressBody(argsInternal);
            return this._sendRequest(argsInternal);
        });
    }
    get(args) {
        const argsInternal = this._getInternalRequestArgs('GET', args);
        return this._sendRequest(argsInternal);
    }
    _sendRequest(args) {
        return $32f4eec2dcf9f3a5$var$__awaiter(this, void 0, void 0, function*() {
            var _a, _b, _c, _d;
            if (!$32f4eec2dcf9f3a5$var$_ensureValidSdkKey(args)) return null;
            if (this._netConfig.preventAllNetworkTraffic) return null;
            const { method: method, body: body, retries: retries, attempt: attempt } = args;
            const endpoint = args.urlConfig.endpoint;
            if (this._isRateLimited(endpoint)) {
                $fvY6A.Log.warn(`Request to ${endpoint} was blocked because you are making requests too frequently.`);
                return null;
            }
            const currentAttempt = attempt !== null && attempt !== void 0 ? attempt : 1;
            let reqTimedOut = false;
            const populatedUrl = this._getPopulatedURL(args);
            let response = null;
            const keepalive = (0, $71rjN._isUnloading)();
            try {
                const config = {
                    method: method,
                    body: body,
                    headers: Object.assign({}, args.headers),
                    priority: args.priority,
                    keepalive: keepalive
                };
                $32f4eec2dcf9f3a5$var$_tryMarkInitStart(args, currentAttempt);
                const bucket = this._leakyBucket[endpoint];
                if (bucket) {
                    bucket.lastRequestTime = Date.now();
                    this._leakyBucket[endpoint] = bucket;
                }
                const func = (_a = this._netConfig.networkOverrideFunc) !== null && _a !== void 0 ? _a : fetch;
                let timeoutId;
                response = yield Promise.race([
                    func(populatedUrl, config).finally(()=>clearTimeout(timeoutId)),
                    new Promise((_, reject)=>{
                        timeoutId = setTimeout(()=>{
                            reqTimedOut = true;
                            reject(new Error(`Timeout of ${this._timeout}ms expired.`));
                        }, this._timeout);
                    })
                ]);
                if (!response.ok) {
                    const text = yield response.text().catch(()=>'No Text');
                    const err = new Error(`NetworkError: ${populatedUrl} ${text}`);
                    err.name = 'NetworkError';
                    throw err;
                }
                const text = yield response.text();
                $32f4eec2dcf9f3a5$var$_tryMarkInitEnd(args, response, currentAttempt, text);
                this._fallbackResolver.tryBumpExpiryTime(args.sdkKey, args.urlConfig);
                return {
                    body: text,
                    code: response.status
                };
            } catch (error) {
                const errorMessage = $32f4eec2dcf9f3a5$var$_getErrorMessage(error);
                const timedOut = $32f4eec2dcf9f3a5$var$_didTimeout(errorMessage !== null && errorMessage !== void 0 ? errorMessage : '', reqTimedOut);
                $32f4eec2dcf9f3a5$var$_tryMarkInitEnd(args, response, currentAttempt, '', error);
                const fallbackUpdated = yield this._fallbackResolver.tryFetchUpdatedFallbackInfo(args.sdkKey, args.urlConfig, errorMessage, timedOut);
                if (fallbackUpdated) args.fallbackUrl = this._fallbackResolver.getActiveFallbackUrl(args.sdkKey, args.urlConfig);
                if (!retries || currentAttempt > retries || !$32f4eec2dcf9f3a5$var$RETRYABLE_CODES.has((_b = response === null || response === void 0 ? void 0 : response.status) !== null && _b !== void 0 ? _b : 500)) {
                    (_c = this._emitter) === null || _c === void 0 || _c.call(this, {
                        name: 'error',
                        error: error,
                        tag: $dbFUm.ErrorTag.NetworkError,
                        requestArgs: args
                    });
                    const formattedErrorMsg = `A networking error occurred during ${method} request to ${populatedUrl}.`;
                    $fvY6A.Log.error(formattedErrorMsg, errorMessage, error);
                    (_d = this._errorBoundary) === null || _d === void 0 || _d.attachErrorIfNoneExists(formattedErrorMsg);
                    return null;
                }
                yield $32f4eec2dcf9f3a5$var$_exponentialBackoff(currentAttempt);
                return this._sendRequest(Object.assign(Object.assign({}, args), {
                    retries: retries,
                    attempt: currentAttempt + 1
                }));
            }
        });
    }
    _getLogEventCompressionMode(options) {
        // Handle backward compatibility for deprecated disableCompression flag
        let compressionMode = options === null || options === void 0 ? void 0 : options.logEventCompressionMode;
        if (!compressionMode && (options === null || options === void 0 ? void 0 : options.disableCompression) === true) compressionMode = $fFtli.LogEventCompressionMode.Disabled;
        // Default to enabled if unset
        if (!compressionMode) compressionMode = $fFtli.LogEventCompressionMode.Enabled;
        return compressionMode;
    }
    _isRateLimited(endpoint) {
        var _a;
        const now = Date.now();
        const bucket = (_a = this._leakyBucket[endpoint]) !== null && _a !== void 0 ? _a : {
            count: 0,
            lastRequestTime: now
        };
        const elapsed = now - bucket.lastRequestTime;
        const leakedRequests = Math.floor(elapsed * $32f4eec2dcf9f3a5$var$LEAK_RATE);
        bucket.count = Math.max(0, bucket.count - leakedRequests);
        if (bucket.count >= $32f4eec2dcf9f3a5$var$RATE_LIMIT_MAX_REQ_COUNT) return true;
        bucket.count += 1;
        bucket.lastRequestTime = now;
        this._leakyBucket[endpoint] = bucket;
        return false;
    }
    _getPopulatedURL(args) {
        var _a;
        const url = (_a = args.fallbackUrl) !== null && _a !== void 0 ? _a : args.urlConfig.getUrl();
        if (args.urlConfig.endpoint === $4JLTD.Endpoint._initialize || args.urlConfig.endpoint === $4JLTD.Endpoint._download_config_specs) this._lastUsedInitUrl = url;
        const params = Object.assign({
            [$4JLTD.NetworkParam.SdkKey]: args.sdkKey,
            [$4JLTD.NetworkParam.SdkType]: $6OyqX.SDKType._get(args.sdkKey),
            [$4JLTD.NetworkParam.SdkVersion]: $9tDUz.SDK_VERSION,
            [$4JLTD.NetworkParam.Time]: String(Date.now()),
            [$4JLTD.NetworkParam.SessionID]: $6cbWs.SessionID.get(args.sdkKey)
        }, args.params);
        const query = Object.keys(params).map((key)=>{
            return `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`;
        }).join('&');
        return `${url}${query ? `?${query}` : ''}`;
    }
    _tryEncodeBody(args) {
        var _a;
        const win = (0, $jjgcN._getWindowSafe)();
        const body = args.body;
        if (!args.isStatsigEncodable || this._options.disableStatsigEncoding || typeof body !== 'string' || (0, $6zYf6._getStatsigGlobalFlag)('no-encode') != null || !(win === null || win === void 0 ? void 0 : win.btoa)) return;
        try {
            args.body = win.btoa(body).split('').reverse().join('');
            args.params = Object.assign(Object.assign({}, (_a = args.params) !== null && _a !== void 0 ? _a : {}), {
                [$4JLTD.NetworkParam.StatsigEncoded]: '1'
            });
        } catch (e) {
            $fvY6A.Log.warn(`Request encoding failed for ${args.urlConfig.getUrl()}`, e);
        }
    }
    _tryToCompressBody(args) {
        return $32f4eec2dcf9f3a5$var$__awaiter(this, void 0, void 0, function*() {
            var _a;
            const body = args.body;
            if (typeof body !== 'string' || !$32f4eec2dcf9f3a5$var$_allowCompression(args, this._options)) return;
            try {
                const bytes = new TextEncoder().encode(body);
                const stream = new CompressionStream('gzip');
                const writer = stream.writable.getWriter();
                writer.write(bytes).catch($fvY6A.Log.error);
                writer.close().catch($fvY6A.Log.error);
                const reader = stream.readable.getReader();
                const chunks = [];
                let result;
                // eslint-disable-next-line no-await-in-loop
                while(!(result = yield reader.read()).done)chunks.push(result.value);
                const totalLength = chunks.reduce((acc, chunk)=>acc + chunk.length, 0);
                const combined = new Uint8Array(totalLength);
                let offset = 0;
                for (const chunk of chunks){
                    combined.set(chunk, offset);
                    offset += chunk.length;
                }
                args.body = combined;
                args.params = Object.assign(Object.assign({}, (_a = args.params) !== null && _a !== void 0 ? _a : {}), {
                    [$4JLTD.NetworkParam.IsGzipped]: '1'
                });
            } catch (e) {
                $fvY6A.Log.warn(`Request compression failed for ${args.urlConfig.getUrl()}`, e);
            }
        });
    }
    _getInternalRequestArgs(method, args) {
        const fallbackUrl = this._fallbackResolver.getActiveFallbackUrl(args.sdkKey, args.urlConfig);
        const result = Object.assign(Object.assign({}, args), {
            method: method,
            fallbackUrl: fallbackUrl
        });
        if ('data' in args) $32f4eec2dcf9f3a5$var$_populateRequestBody(result, args.data);
        return result;
    }
}
module.exports.NetworkCore = $32f4eec2dcf9f3a5$var$NetworkCore;
const $32f4eec2dcf9f3a5$var$_ensureValidSdkKey = (args)=>{
    if (!args.sdkKey) {
        $fvY6A.Log.warn('Unable to make request without an SDK key');
        return false;
    }
    return true;
};
const $32f4eec2dcf9f3a5$var$_populateRequestBody = (args, data)=>{
    const { sdkKey: sdkKey, fallbackUrl: fallbackUrl } = args;
    const stableID = $lbAhi.StableID.get(sdkKey);
    const sessionID = $6cbWs.SessionID.get(sdkKey);
    const sdkType = $6OyqX.SDKType._get(sdkKey);
    args.body = JSON.stringify(Object.assign(Object.assign({}, data), {
        statsigMetadata: Object.assign(Object.assign({}, $9tDUz.StatsigMetadataProvider.get()), {
            stableID: stableID,
            sessionID: sessionID,
            sdkType: sdkType,
            fallbackUrl: fallbackUrl
        })
    }));
};
function $32f4eec2dcf9f3a5$var$_allowCompression(args, options) {
    if (!args.isCompressable) return false;
    // Never compress if 'no-compress' is set globally or required APIs are unavailable
    if ((0, $6zYf6._getStatsigGlobalFlag)('no-compress') != null || typeof CompressionStream === 'undefined' || typeof TextEncoder === 'undefined') return false;
    const isProxy = args.urlConfig.customUrl != null || args.urlConfig.fallbackUrls != null;
    const flagEnabled = $cd98p.SDKFlags.get(args.sdkKey, 'enable_log_event_compression') === true;
    switch(options.logEventCompressionMode){
        case $fFtli.LogEventCompressionMode.Disabled:
            return false;
        case $fFtli.LogEventCompressionMode.Enabled:
            // Only compress through proxy if flag is explicitly on
            if (isProxy && !flagEnabled) return false;
            return true;
        case $fFtli.LogEventCompressionMode.Forced:
            return true;
        default:
            return false;
    }
}
function $32f4eec2dcf9f3a5$var$_getErrorMessage(error) {
    if (typeof error === 'string') return error;
    if (error instanceof Error) return `${error.name}: ${error.message}`;
    return 'Unknown Error';
}
function $32f4eec2dcf9f3a5$var$_didTimeout(errorMsg, abortedByTimeout) {
    const timeout = errorMsg.includes('Timeout'); // probably not needed but just in case
    return timeout || abortedByTimeout;
}
function $32f4eec2dcf9f3a5$var$_tryMarkInitStart(args, attempt) {
    if (args.urlConfig.endpoint !== $4JLTD.Endpoint._initialize) return;
    $cNxHP.Diagnostics._markInitNetworkReqStart(args.sdkKey, {
        attempt: attempt
    });
}
function $32f4eec2dcf9f3a5$var$_tryMarkInitEnd(args, response, attempt, body, err) {
    if (args.urlConfig.endpoint !== $4JLTD.Endpoint._initialize) return;
    $cNxHP.Diagnostics._markInitNetworkReqEnd(args.sdkKey, $cNxHP.Diagnostics._getDiagnosticsData(response, attempt, body, err));
}
function $32f4eec2dcf9f3a5$var$_exponentialBackoff(attempt) {
    return $32f4eec2dcf9f3a5$var$__awaiter(this, void 0, void 0, function*() {
        // 1*1*1000 1s
        // 2*2*1000 4s
        // 3*3*1000 9s
        // 4*4*1000 16s
        // 5*5*1000 25s
        yield new Promise((r)=>setTimeout(r, Math.min($32f4eec2dcf9f3a5$var$BACKOFF_BASE_MS * (attempt * attempt), $32f4eec2dcf9f3a5$var$BACKOFF_MAX_MS)));
    });
}

});
parcelRegister("9zIz8", function(module, exports) {
"use strict";
var $6f89f3be547c87c2$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._isDomainFailure = module.exports.NetworkFallbackResolver = void 0;

var $9NOma = parcelRequire("9NOma");

var $lUUuL = parcelRequire("lUUuL");

var $fvY6A = parcelRequire("fvY6A");

var $cUOGL = parcelRequire("cUOGL");
const $6f89f3be547c87c2$var$DEFAULT_TTL_MS = 604800000; // 7 days
const $6f89f3be547c87c2$var$COOLDOWN_TIME_MS = 14400000; // 4 hours
class $6f89f3be547c87c2$var$NetworkFallbackResolver {
    constructor(options){
        var _a;
        this._fallbackInfo = null;
        this._errorBoundary = null;
        this._dnsQueryCooldowns = {};
        this._networkOverrideFunc = (_a = options.networkConfig) === null || _a === void 0 ? void 0 : _a.networkOverrideFunc;
    }
    setErrorBoundary(errorBoundary) {
        this._errorBoundary = errorBoundary;
    }
    tryBumpExpiryTime(sdkKey, urlConfig) {
        var _a;
        const info = (_a = this._fallbackInfo) === null || _a === void 0 ? void 0 : _a[urlConfig.endpoint];
        if (!info) return;
        info.expiryTime = Date.now() + $6f89f3be547c87c2$var$DEFAULT_TTL_MS;
        $6f89f3be547c87c2$var$_tryWriteFallbackInfoToCache(sdkKey, Object.assign(Object.assign({}, this._fallbackInfo), {
            [urlConfig.endpoint]: info
        }));
    }
    getActiveFallbackUrl(sdkKey, urlConfig) {
        var _a, _b;
        if (urlConfig.customUrl != null && urlConfig.fallbackUrls != null) return null;
        let info = this._fallbackInfo;
        if (info == null) {
            info = (_a = $6f89f3be547c87c2$var$_readFallbackInfoFromCache(sdkKey)) !== null && _a !== void 0 ? _a : {};
            this._fallbackInfo = info;
        }
        const entry = info[urlConfig.endpoint];
        if (!entry || Date.now() > ((_b = entry.expiryTime) !== null && _b !== void 0 ? _b : 0) || urlConfig.getChecksum() !== entry.urlConfigChecksum) {
            delete info[urlConfig.endpoint];
            this._fallbackInfo = info;
            $6f89f3be547c87c2$var$_tryWriteFallbackInfoToCache(sdkKey, this._fallbackInfo);
            return null;
        }
        if (entry.url) return entry.url;
        return null;
    }
    tryFetchUpdatedFallbackInfo(sdkKey, urlConfig, errorMessage, timedOut) {
        return $6f89f3be547c87c2$var$__awaiter(this, void 0, void 0, function*() {
            var _a, _b;
            try {
                if (!$6f89f3be547c87c2$var$_isDomainFailure(errorMessage, timedOut)) return false;
                const canUseNetworkFallbacks = urlConfig.customUrl == null && urlConfig.fallbackUrls == null;
                const urls = canUseNetworkFallbacks ? yield this._tryFetchFallbackUrlsFromNetwork(urlConfig) : urlConfig.fallbackUrls;
                const newUrl = this._pickNewFallbackUrl((_a = this._fallbackInfo) === null || _a === void 0 ? void 0 : _a[urlConfig.endpoint], urls);
                if (!newUrl) return false;
                this._updateFallbackInfoWithNewUrl(sdkKey, urlConfig, newUrl);
                return true;
            } catch (error) {
                (_b = this._errorBoundary) === null || _b === void 0 || _b.logError('tryFetchUpdatedFallbackInfo', error);
                return false;
            }
        });
    }
    _updateFallbackInfoWithNewUrl(sdkKey, urlConfig, newUrl) {
        var _a, _b, _c;
        const newFallbackInfo = {
            urlConfigChecksum: urlConfig.getChecksum(),
            url: newUrl,
            expiryTime: Date.now() + $6f89f3be547c87c2$var$DEFAULT_TTL_MS,
            previous: []
        };
        const endpoint = urlConfig.endpoint;
        const previousInfo = (_a = this._fallbackInfo) === null || _a === void 0 ? void 0 : _a[endpoint];
        if (previousInfo) newFallbackInfo.previous.push(...previousInfo.previous);
        if (newFallbackInfo.previous.length > 10) newFallbackInfo.previous = [];
        const previousUrl = (_c = (_b = this._fallbackInfo) === null || _b === void 0 ? void 0 : _b[endpoint]) === null || _c === void 0 ? void 0 : _c.url;
        if (previousUrl != null) newFallbackInfo.previous.push(previousUrl);
        this._fallbackInfo = Object.assign(Object.assign({}, this._fallbackInfo), {
            [endpoint]: newFallbackInfo
        });
        $6f89f3be547c87c2$var$_tryWriteFallbackInfoToCache(sdkKey, this._fallbackInfo);
    }
    _tryFetchFallbackUrlsFromNetwork(urlConfig) {
        return $6f89f3be547c87c2$var$__awaiter(this, void 0, void 0, function*() {
            var _a;
            const cooldown = this._dnsQueryCooldowns[urlConfig.endpoint];
            if (cooldown && Date.now() < cooldown) return null;
            this._dnsQueryCooldowns[urlConfig.endpoint] = Date.now() + $6f89f3be547c87c2$var$COOLDOWN_TIME_MS;
            const result = [];
            const records = yield (0, $9NOma._fetchTxtRecords)((_a = this._networkOverrideFunc) !== null && _a !== void 0 ? _a : fetch);
            const path = $6f89f3be547c87c2$var$_extractPathFromUrl(urlConfig.defaultUrl);
            for (const record of records){
                if (!record.startsWith(urlConfig.endpointDnsKey + '=')) continue;
                const parts = record.split('=');
                if (parts.length > 1) {
                    let baseUrl = parts[1];
                    if (baseUrl.endsWith('/')) baseUrl = baseUrl.slice(0, -1);
                    result.push(`https://${baseUrl}${path}`);
                }
            }
            return result;
        });
    }
    _pickNewFallbackUrl(currentFallbackInfo, urls) {
        var _a;
        if (urls == null) return null;
        const previouslyUsed = new Set((_a = currentFallbackInfo === null || currentFallbackInfo === void 0 ? void 0 : currentFallbackInfo.previous) !== null && _a !== void 0 ? _a : []);
        const currentFallbackUrl = currentFallbackInfo === null || currentFallbackInfo === void 0 ? void 0 : currentFallbackInfo.url;
        let found = null;
        for (const loopUrl of urls){
            const url = loopUrl.endsWith('/') ? loopUrl.slice(0, -1) : loopUrl;
            if (!previouslyUsed.has(loopUrl) && url !== currentFallbackUrl) {
                found = url;
                break;
            }
        }
        return found;
    }
}
module.exports.NetworkFallbackResolver = $6f89f3be547c87c2$var$NetworkFallbackResolver;
function $6f89f3be547c87c2$var$_isDomainFailure(errorMsg, timedOut) {
    var _a;
    const lowerErrorMsg = (_a = errorMsg === null || errorMsg === void 0 ? void 0 : errorMsg.toLowerCase()) !== null && _a !== void 0 ? _a : '';
    return timedOut || lowerErrorMsg.includes('uncaught exception') || lowerErrorMsg.includes('failed to fetch') || lowerErrorMsg.includes('networkerror when attempting to fetch resource');
}
module.exports._isDomainFailure = $6f89f3be547c87c2$var$_isDomainFailure;
function $6f89f3be547c87c2$var$_getFallbackInfoStorageKey(sdkKey) {
    return `statsig.network_fallback.${(0, $lUUuL._DJB2)(sdkKey)}`;
}
function $6f89f3be547c87c2$var$_tryWriteFallbackInfoToCache(sdkKey, info) {
    const hashKey = $6f89f3be547c87c2$var$_getFallbackInfoStorageKey(sdkKey);
    if (!info || Object.keys(info).length === 0) {
        $cUOGL.Storage.removeItem(hashKey);
        return;
    }
    $cUOGL.Storage.setItem(hashKey, JSON.stringify(info));
}
function $6f89f3be547c87c2$var$_readFallbackInfoFromCache(sdkKey) {
    const hashKey = $6f89f3be547c87c2$var$_getFallbackInfoStorageKey(sdkKey);
    const data = $cUOGL.Storage.getItem(hashKey);
    if (!data) return null;
    try {
        return JSON.parse(data);
    } catch (_a) {
        $fvY6A.Log.error('Failed to parse FallbackInfo');
        return null;
    }
}
function $6f89f3be547c87c2$var$_extractPathFromUrl(urlString) {
    try {
        const url = new URL(urlString);
        return url.pathname;
    } catch (error) {
        return null;
    }
}

});
parcelRegister("9NOma", function(module, exports) {
"use strict";
var $722fc069dd1cc14d$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._fetchTxtRecords = void 0;
// See example: https://github.com/statsig-io/private-js-client-monorepo/pull/340
const $722fc069dd1cc14d$var$FEATURE_ASSETS_DNS_QUERY = new Uint8Array([
    0x00,
    0x00,
    0x01,
    0x00,
    0x00,
    0x01,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x0d,
    0x66,
    0x65,
    0x61,
    0x74,
    0x75,
    0x72,
    0x65,
    0x61,
    0x73,
    0x73,
    0x65,
    0x74,
    0x73,
    0x03,
    0x6f,
    0x72,
    0x67,
    0x00,
    0x00,
    0x10,
    0x00,
    0x01
]);
const $722fc069dd1cc14d$var$DNS_QUERY_ENDPOINT = 'https://cloudflare-dns.com/dns-query';
const $722fc069dd1cc14d$var$DOMAIN_CHARS = [
    'i',
    'e',
    'd'
];
const $722fc069dd1cc14d$var$MAX_START_LOOKUP = 200;
function $722fc069dd1cc14d$var$_fetchTxtRecords(networkFunc) {
    return $722fc069dd1cc14d$var$__awaiter(this, void 0, void 0, function*() {
        const response = yield networkFunc($722fc069dd1cc14d$var$DNS_QUERY_ENDPOINT, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/dns-message',
                Accept: 'application/dns-message'
            },
            body: $722fc069dd1cc14d$var$FEATURE_ASSETS_DNS_QUERY
        });
        if (!response.ok) {
            const err = new Error('Failed to fetch TXT records from DNS');
            err.name = 'DnsTxtFetchError';
            throw err;
        }
        const data = yield response.arrayBuffer();
        const bytes = new Uint8Array(data);
        return $722fc069dd1cc14d$var$_parseDnsResponse(bytes);
    });
}
module.exports._fetchTxtRecords = $722fc069dd1cc14d$var$_fetchTxtRecords;
function $722fc069dd1cc14d$var$_parseDnsResponse(input) {
    // loop until we find the first valid domain char. One of [i=, e=, d=]
    const start = input.findIndex((byte, index)=>index < $722fc069dd1cc14d$var$MAX_START_LOOKUP && String.fromCharCode(byte) === '=' && $722fc069dd1cc14d$var$DOMAIN_CHARS.includes(String.fromCharCode(input[index - 1])));
    if (start === -1) {
        const err = new Error('Failed to parse TXT records from DNS');
        err.name = 'DnsTxtParseError';
        throw err;
    }
    // decode the remaining bytes as a string
    let result = '';
    for(let i = start - 1; i < input.length; i++)result += String.fromCharCode(input[i]);
    return result.split(',');
}

});


parcelRegister("cd98p", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SDKFlags = void 0;
const $8e3dc8e27d017159$var$FLAGMAP = {};
module.exports.SDKFlags = {
    setFlags: (sdkKey, flags)=>{
        $8e3dc8e27d017159$var$FLAGMAP[sdkKey] = flags;
    },
    get: (sdkKey, flagKey)=>{
        var _a, _b;
        return (_b = (_a = $8e3dc8e27d017159$var$FLAGMAP[sdkKey]) === null || _a === void 0 ? void 0 : _a[flagKey]) !== null && _b !== void 0 ? _b : false;
    }
};

});

parcelRegister("6cbWs", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.StatsigSession = module.exports.SessionID = void 0;

var $6zYf6 = parcelRequire("6zYf6");

var $6ZtBQ = parcelRequire("6ZtBQ");

var $fvY6A = parcelRequire("fvY6A");

var $cUOGL = parcelRequire("cUOGL");

var $5G12m = parcelRequire("5G12m");
const $482d2078a26fb880$var$MAX_SESSION_IDLE_TIME = 1800000; // 30 minutes
const $482d2078a26fb880$var$MAX_SESSION_AGE = 14400000; // 4 hours
const $482d2078a26fb880$var$PROMISE_MAP = {};
module.exports.SessionID = {
    get: (sdkKey)=>{
        return module.exports.StatsigSession.get(sdkKey).data.sessionID;
    }
};
module.exports.StatsigSession = {
    get: (sdkKey)=>{
        if ($482d2078a26fb880$var$PROMISE_MAP[sdkKey] == null) $482d2078a26fb880$var$PROMISE_MAP[sdkKey] = $482d2078a26fb880$var$_loadSession(sdkKey);
        const session = $482d2078a26fb880$var$PROMISE_MAP[sdkKey];
        return $482d2078a26fb880$var$_bumpSession(session);
    },
    overrideInitialSessionID: (override, sdkKey)=>{
        $482d2078a26fb880$var$PROMISE_MAP[sdkKey] = $482d2078a26fb880$var$_overrideSessionId(override, sdkKey);
    }
};
function $482d2078a26fb880$var$_loadSession(sdkKey) {
    let data = $482d2078a26fb880$var$_loadFromStorage(sdkKey);
    const now = Date.now();
    if (!data) data = {
        sessionID: (0, $5G12m.getUUID)(),
        startTime: now,
        lastUpdate: now
    };
    return {
        data: data,
        sdkKey: sdkKey
    };
}
function $482d2078a26fb880$var$_overrideSessionId(override, sdkKey) {
    const now = Date.now();
    return {
        data: {
            sessionID: override,
            startTime: now,
            lastUpdate: now
        },
        sdkKey: sdkKey
    };
}
function $482d2078a26fb880$var$_bumpSession(session) {
    const now = Date.now();
    const data = session.data;
    const sdkKey = session.sdkKey;
    if ($482d2078a26fb880$var$_isIdle(data) || $482d2078a26fb880$var$_hasRunTooLong(data)) {
        data.sessionID = (0, $5G12m.getUUID)();
        data.startTime = now;
        const client = __STATSIG__ === null || __STATSIG__ === void 0 ? void 0 : __STATSIG__.instance(sdkKey);
        if (client) client.$emt({
            name: 'session_expired'
        });
    }
    data.lastUpdate = now;
    $482d2078a26fb880$var$_persistToStorage(data, session.sdkKey);
    clearTimeout(session.idleTimeoutID);
    clearTimeout(session.ageTimeoutID);
    const lifetime = now - data.startTime;
    session.idleTimeoutID = $482d2078a26fb880$var$_createSessionTimeout(sdkKey, $482d2078a26fb880$var$MAX_SESSION_IDLE_TIME);
    session.ageTimeoutID = $482d2078a26fb880$var$_createSessionTimeout(sdkKey, $482d2078a26fb880$var$MAX_SESSION_AGE - lifetime);
    return session;
}
function $482d2078a26fb880$var$_createSessionTimeout(sdkKey, duration) {
    return setTimeout(()=>{
        var _a;
        const client = (_a = (0, $6zYf6._getStatsigGlobal)()) === null || _a === void 0 ? void 0 : _a.instance(sdkKey);
        if (client) client.$emt({
            name: 'session_expired'
        });
    }, duration);
}
function $482d2078a26fb880$var$_isIdle({ lastUpdate: lastUpdate }) {
    return Date.now() - lastUpdate > $482d2078a26fb880$var$MAX_SESSION_IDLE_TIME;
}
function $482d2078a26fb880$var$_hasRunTooLong({ startTime: startTime }) {
    return Date.now() - startTime > $482d2078a26fb880$var$MAX_SESSION_AGE;
}
function $482d2078a26fb880$var$_getSessionIDStorageKey(sdkKey) {
    return `statsig.session_id.${(0, $6ZtBQ._getStorageKey)(sdkKey)}`;
}
function $482d2078a26fb880$var$_persistToStorage(session, sdkKey) {
    const storageKey = $482d2078a26fb880$var$_getSessionIDStorageKey(sdkKey);
    try {
        (0, $cUOGL._setObjectInStorage)(storageKey, session);
    } catch (e) {
        $fvY6A.Log.warn('Failed to save SessionID');
    }
}
function $482d2078a26fb880$var$_loadFromStorage(sdkKey) {
    const storageKey = $482d2078a26fb880$var$_getSessionIDStorageKey(sdkKey);
    return (0, $cUOGL._getObjectFromStorage)(storageKey);
}

});

parcelRegister("dbFUm", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ErrorTag = void 0;
module.exports.ErrorTag = {
    NetworkError: 'NetworkError'
};

});


parcelRegister("am110", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("J5dlM", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("kS7H6", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._fastApproxSizeOf = void 0;
const $f31ed1b25fdb1fa1$var$CURLY_AND_SQUARE_BRACKET_SIZE = 2; // [] for array, {} for object
const $f31ed1b25fdb1fa1$var$APPROX_ADDITIONAL_SIZE = 1; // additional size for comma and stuff
const $f31ed1b25fdb1fa1$var$_fastApproxSizeOf = (obj, max)=>{
    let size = 0;
    const keys = Object.keys(obj);
    for(let i = 0; i < keys.length; i++){
        const key = keys[i];
        const value = obj[key];
        size += key.length;
        if (typeof value === 'object' && value !== null) size += (0, module.exports._fastApproxSizeOf)(value, max) + $f31ed1b25fdb1fa1$var$CURLY_AND_SQUARE_BRACKET_SIZE;
        else size += String(value).length + $f31ed1b25fdb1fa1$var$APPROX_ADDITIONAL_SIZE;
        if (size >= max) // exit early if we've exceeded the max
        return size;
    }
    return size;
};
module.exports._fastApproxSizeOf = $f31ed1b25fdb1fa1$var$_fastApproxSizeOf;

});

parcelRegister("uj5Sb", function(module, exports) {
"use strict";
var $05b19d12b0b40110$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.StatsigClientBase = void 0;

var $6zYf6 = parcelRequire("6zYf6");

var $6zYf6 = parcelRequire("6zYf6");

var $a7dQ0 = parcelRequire("a7dQ0");

var $lT0oC = parcelRequire("lT0oC");

var $fvY6A = parcelRequire("fvY6A");

var $g4vOj = parcelRequire("g4vOj");

var $jjgcN = parcelRequire("jjgcN");

var $6cbWs = parcelRequire("6cbWs");

var $lbAhi = parcelRequire("lbAhi");

var $fFtli = parcelRequire("fFtli");

var $cUOGL = parcelRequire("cUOGL");
const $05b19d12b0b40110$var$MAX_MEMO_CACHE_SIZE = 3000;
class $05b19d12b0b40110$var$StatsigClientBase {
    constructor(sdkKey, adapter, network, options){
        var _a, _b, _c, _d;
        this.loadingStatus = 'Uninitialized';
        this._initializePromise = null;
        this._listeners = {};
        const emitter = this.$emt.bind(this);
        (options === null || options === void 0 ? void 0 : options.logLevel) != null && ($fvY6A.Log.level = options.logLevel);
        (options === null || options === void 0 ? void 0 : options.disableStorage) && $cUOGL.Storage._setDisabled(true);
        (options === null || options === void 0 ? void 0 : options.initialSessionID) && $6cbWs.StatsigSession.overrideInitialSessionID(options.initialSessionID, sdkKey);
        (options === null || options === void 0 ? void 0 : options.storageProvider) && $cUOGL.Storage._setProvider(options.storageProvider);
        (options === null || options === void 0 ? void 0 : options.enableCookies) && $lbAhi.StableID._setCookiesEnabled(sdkKey, options.enableCookies);
        (options === null || options === void 0 ? void 0 : options.disableStableID) && $lbAhi.StableID._setDisabled(sdkKey, true);
        this._sdkKey = sdkKey;
        this._options = options !== null && options !== void 0 ? options : {};
        this._memoCache = {};
        this.overrideAdapter = (_a = options === null || options === void 0 ? void 0 : options.overrideAdapter) !== null && _a !== void 0 ? _a : null;
        this._logger = new $lT0oC.EventLogger(sdkKey, emitter, network, options);
        this._errorBoundary = new $a7dQ0.ErrorBoundary(sdkKey, options, emitter);
        this._errorBoundary.wrap(this);
        this._errorBoundary.wrap(adapter);
        this._errorBoundary.wrap(this._logger);
        network.setErrorBoundary(this._errorBoundary);
        this.dataAdapter = adapter;
        this.dataAdapter.attach(sdkKey, options, network);
        this.storageProvider = $cUOGL.Storage;
        (_d = (_c = (_b = this.overrideAdapter) === null || _b === void 0 ? void 0 : _b.loadFromStorage) === null || _c === void 0 ? void 0 : _c.call(_b)) === null || _d === void 0 || _d.catch((e)=>this._errorBoundary.logError('OA::loadFromStorage', e));
        this._primeReadyRipcord();
        $05b19d12b0b40110$var$_assignGlobalInstance(sdkKey, this);
    }
    /**
     * Updates runtime configuration options for the SDK, allowing toggling of certain behaviors such as logging and storage to comply with user preferences or regulations such as GDPR.
     *
     * @param {StatsigRuntimeMutableOptions} options - The configuration options that dictate the runtime behavior of the SDK.
     */ updateRuntimeOptions(options) {
        if (options.loggingEnabled) {
            this._options.loggingEnabled = options.loggingEnabled;
            this._logger.setLoggingEnabled(options.loggingEnabled);
        } else if (options.disableLogging != null) {
            this._options.disableLogging = options.disableLogging;
            this._logger.setLoggingEnabled(options.disableLogging ? 'disabled' : 'browser-only');
        }
        if (options.disableStorage != null) {
            this._options.disableStorage = options.disableStorage;
            $cUOGL.Storage._setDisabled(options.disableStorage);
        }
        if (options.enableCookies != null) {
            this._options.enableCookies = options.enableCookies;
            $lbAhi.StableID._setCookiesEnabled(this._sdkKey, options.enableCookies);
        }
        if (options.logEventCompressionMode) this._logger.setLogEventCompressionMode(options.logEventCompressionMode);
        else if (options.disableCompression) this._logger.setLogEventCompressionMode($fFtli.LogEventCompressionMode.Disabled);
    }
    /**
     * Flushes any currently queued events.
     */ flush() {
        return this._logger.flush();
    }
    /**
     * Gracefully shuts down the SDK, ensuring that all pending events are send before the SDK stops.
     * This function emits a 'pre_shutdown' event and then waits for the logger to complete its shutdown process.
     *
     * @returns {Promise<void>} A promise that resolves when all shutdown procedures, including logging shutdown, have been completed.
     */ shutdown() {
        return $05b19d12b0b40110$var$__awaiter(this, void 0, void 0, function*() {
            this.$emt({
                name: 'pre_shutdown'
            });
            this._setStatus('Uninitialized', null);
            this._initializePromise = null;
            yield this._logger.stop();
        });
    }
    /**
     * Subscribes a callback function to a specific {@link StatsigClientEvent} or all StatsigClientEvents if the wildcard '*' is used.
     * Once subscribed, the listener callback will be invoked whenever the specified event is emitted.
     *
     * @param {StatsigClientEventName} event - The name of the event to subscribe to, or '*' to subscribe to all events.
     * @param {StatsigClientEventCallback<T>} listener - The callback function to execute when the event occurs. The function receives event-specific data as its parameter.
     * @see {@link off} for unsubscribing from events.
     */ on(event, listener) {
        if (!this._listeners[event]) this._listeners[event] = [];
        this._listeners[event].push(listener);
    }
    /**
     * Unsubscribes a previously registered callback function from a specific {@link StatsigClientEvent} or all StatsigClientEvents if the wildcard '*' is used.
     *
     * @param {StatsigClientEventName} event - The name of the event from which to unsubscribe, or '*' to unsubscribe from all events.
     * @param {StatsigClientEventCallback<T>} listener - The callback function to remove from the event's notification list.
     * @see {@link on} for subscribing to events.
     */ off(event, listener) {
        if (this._listeners[event]) {
            const index = this._listeners[event].indexOf(listener);
            if (index !== -1) this._listeners[event].splice(index, 1);
        }
    }
    $on(event, listener) {
        listener.__isInternal = true;
        this.on(event, listener);
    }
    $emt(event) {
        var _a;
        const barrier = (listener)=>{
            try {
                listener(event);
            } catch (error) {
                if (listener.__isInternal === true) {
                    this._errorBoundary.logError(`__emit:${event.name}`, error);
                    return;
                }
                $fvY6A.Log.error(`An error occurred in a StatsigClientEvent listener. This is not an issue with Statsig.`, event);
            }
        };
        if (this._listeners[event.name]) this._listeners[event.name].forEach((l)=>barrier(l));
        (_a = this._listeners['*']) === null || _a === void 0 || _a.forEach(barrier);
    }
    _setStatus(newStatus, values) {
        this.loadingStatus = newStatus;
        this._memoCache = {};
        this.$emt({
            name: 'values_updated',
            status: newStatus,
            values: values
        });
    }
    _enqueueExposure(name, exposure, options) {
        if ((options === null || options === void 0 ? void 0 : options.disableExposureLog) === true) {
            this._logger.incrementNonExposureCount(name);
            return;
        }
        this._logger.enqueue(exposure);
    }
    _memoize(prefix, fn) {
        return (name, options)=>{
            if (this._options.disableEvaluationMemoization) return fn(name, options);
            const memoKey = (0, $g4vOj.createMemoKey)(prefix, name, options);
            if (!memoKey) return fn(name, options);
            if (!(memoKey in this._memoCache)) {
                if (Object.keys(this._memoCache).length >= $05b19d12b0b40110$var$MAX_MEMO_CACHE_SIZE) this._memoCache = {};
                this._memoCache[memoKey] = fn(name, options);
            }
            return this._memoCache[memoKey];
        };
    }
}
module.exports.StatsigClientBase = $05b19d12b0b40110$var$StatsigClientBase;
function $05b19d12b0b40110$var$_assignGlobalInstance(sdkKey, client) {
    var _a;
    if ((0, $jjgcN._isServerEnv)()) return;
    const statsigGlobal = (0, $6zYf6._getStatsigGlobal)();
    const instances = (_a = statsigGlobal.instances) !== null && _a !== void 0 ? _a : {};
    const inst = client;
    if (instances[sdkKey] != null) $fvY6A.Log.warn('Creating multiple Statsig clients with the same SDK key can lead to unexpected behavior. Multi-instance support requires different SDK keys.');
    instances[sdkKey] = inst;
    if (!statsigGlobal.firstInstance) statsigGlobal.firstInstance = inst;
    statsigGlobal.instances = instances;
    __STATSIG__ = statsigGlobal;
}

});

parcelRegister("4kZUp", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DataAdapterCachePrefix = void 0;
module.exports.DataAdapterCachePrefix = 'statsig.cached';

});

parcelRegister("eEYg8", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("boH9C", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._makeTypedGet = module.exports._mergeOverride = module.exports._makeLayer = module.exports._makeExperiment = module.exports._makeDynamicConfig = module.exports._makeFeatureGate = void 0;

var $fvY6A = parcelRequire("fvY6A");

var $fOOnv = parcelRequire("fOOnv");
function $84c36919a00c4c78$var$_makeEvaluation(name, details, evaluation, value) {
    var _a;
    return {
        name: name,
        details: details,
        ruleID: (_a = evaluation === null || evaluation === void 0 ? void 0 : evaluation.rule_id) !== null && _a !== void 0 ? _a : '',
        __evaluation: evaluation,
        value: value
    };
}
function $84c36919a00c4c78$var$_makeFeatureGate(name, details, evaluation) {
    var _a;
    return Object.assign(Object.assign({}, $84c36919a00c4c78$var$_makeEvaluation(name, details, evaluation, (evaluation === null || evaluation === void 0 ? void 0 : evaluation.value) === true)), {
        idType: (_a = evaluation === null || evaluation === void 0 ? void 0 : evaluation.id_type) !== null && _a !== void 0 ? _a : null
    });
}
module.exports._makeFeatureGate = $84c36919a00c4c78$var$_makeFeatureGate;
function $84c36919a00c4c78$var$_makeDynamicConfig(name, details, evaluation) {
    var _a, _b;
    const value = (_a = evaluation === null || evaluation === void 0 ? void 0 : evaluation.value) !== null && _a !== void 0 ? _a : {};
    return Object.assign(Object.assign({}, $84c36919a00c4c78$var$_makeEvaluation(name, details, evaluation, value)), {
        idType: (_b = evaluation === null || evaluation === void 0 ? void 0 : evaluation.id_type) !== null && _b !== void 0 ? _b : null,
        get: $84c36919a00c4c78$var$_makeTypedGet(name, evaluation === null || evaluation === void 0 ? void 0 : evaluation.value)
    });
}
module.exports._makeDynamicConfig = $84c36919a00c4c78$var$_makeDynamicConfig;
function $84c36919a00c4c78$var$_makeExperiment(name, details, evaluation) {
    var _a;
    const result = $84c36919a00c4c78$var$_makeDynamicConfig(name, details, evaluation);
    return Object.assign(Object.assign({}, result), {
        groupName: (_a = evaluation === null || evaluation === void 0 ? void 0 : evaluation.group_name) !== null && _a !== void 0 ? _a : null
    });
}
module.exports._makeExperiment = $84c36919a00c4c78$var$_makeExperiment;
function $84c36919a00c4c78$var$_makeLayer(name, details, evaluation, exposeFunc) {
    var _a, _b;
    return Object.assign(Object.assign({}, $84c36919a00c4c78$var$_makeEvaluation(name, details, evaluation, undefined)), {
        get: $84c36919a00c4c78$var$_makeTypedGet(name, evaluation === null || evaluation === void 0 ? void 0 : evaluation.value, exposeFunc),
        groupName: (_a = evaluation === null || evaluation === void 0 ? void 0 : evaluation.group_name) !== null && _a !== void 0 ? _a : null,
        __value: (_b = evaluation === null || evaluation === void 0 ? void 0 : evaluation.value) !== null && _b !== void 0 ? _b : {}
    });
}
module.exports._makeLayer = $84c36919a00c4c78$var$_makeLayer;
function $84c36919a00c4c78$var$_mergeOverride(original, overridden, value, exposeFunc) {
    return Object.assign(Object.assign(Object.assign({}, original), overridden), {
        get: $84c36919a00c4c78$var$_makeTypedGet(original.name, value, exposeFunc)
    });
}
module.exports._mergeOverride = $84c36919a00c4c78$var$_mergeOverride;
function $84c36919a00c4c78$var$_makeTypedGet(name, value, exposeFunc) {
    return (param, fallback)=>{
        var _a;
        const found = (_a = value === null || value === void 0 ? void 0 : value[param]) !== null && _a !== void 0 ? _a : null;
        if (found == null) return fallback !== null && fallback !== void 0 ? fallback : null;
        if (fallback != null && !(0, $fOOnv._isTypeMatch)(found, fallback)) {
            $fvY6A.Log.warn(`Parameter type mismatch. '${name}.${param}' was found to be type '${typeof found}' but fallback/return type is '${typeof fallback}'. See https://docs.statsig.com/client/javascript-sdk/#typed-getters`);
            return fallback !== null && fallback !== void 0 ? fallback : null;
        }
        exposeFunc === null || exposeFunc === void 0 || exposeFunc(param);
        return found;
    };
}
module.exports._makeTypedGet = $84c36919a00c4c78$var$_makeTypedGet;

});

parcelRegister("3G1qf", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("bhG9g", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.UPDATE_DETAIL_ERROR_MESSAGES = module.exports.createUpdateDetails = void 0;
const $8371fa073e270eba$var$createUpdateDetails = (success, source, initDuration, error, sourceUrl, warnings)=>{
    return {
        duration: initDuration,
        source: source,
        success: success,
        error: error,
        sourceUrl: sourceUrl,
        warnings: warnings
    };
};
module.exports.createUpdateDetails = $8371fa073e270eba$var$createUpdateDetails;
module.exports.UPDATE_DETAIL_ERROR_MESSAGES = {
    NO_NETWORK_DATA: 'No data was returned from the network. This may be due to a network timeout if a timeout value was specified in the options or ad blocker error.'
};

});


parcelRegister("i1p2j", function(module, exports) {
"use strict";
var $d1ebbdb02ace9f76$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $dtn6l = parcelRequire("dtn6l");

var $i8QCG = parcelRequire("i8QCG");

var $e4Scn = parcelRequire("e4Scn");

var $9JsrP = parcelRequire("9JsrP");

var $j6Ssa = parcelRequire("j6Ssa");
class $d1ebbdb02ace9f76$var$StatsigClient extends $dtn6l.StatsigClientBase {
    /**
     * Retrieves an instance of the StatsigClient based on the provided SDK key.
     *  If no SDK key is provided, the method returns the most recently created instance of the StatsigClient.
     *  The method ensures that each unique SDK key corresponds to a single instance of StatsigClient, effectively implementing a singleton pattern for each key.
     *  If no instance exists for the given SDK key, a new StatsigClient instance will be created and returned.
     *
     * @param {string} [sdkKey] - Optional. The SDK key used to identify a specific instance of the StatsigClient. If omitted, the method returns the last created instance.
     * @returns {StatsigClient} Returns the StatsigClient instance associated with the given SDK key, creating a new one if needed.
     */ static instance(sdkKey) {
        const instance = (0, $dtn6l._getStatsigGlobal)().instance(sdkKey);
        if (instance instanceof $d1ebbdb02ace9f76$var$StatsigClient) return instance;
        $dtn6l.Log.warn((0, $dtn6l._isServerEnv)() ? 'StatsigClient.instance is not supported in server environments' : 'Unable to find StatsigClient instance');
        return new $d1ebbdb02ace9f76$var$StatsigClient(sdkKey !== null && sdkKey !== void 0 ? sdkKey : '', {});
    }
    /**
     * StatsigClient constructor
     *
     * @param {string} sdkKey A Statsig client SDK key. eg "client-xyz123..."
     * @param {StatsigUser} user StatsigUser object containing various attributes related to a user.
     * @param {StatsigOptions | null} options StatsigOptions, used to customize the behavior of the SDK.
     */ constructor(sdkKey, user, options = null){
        var _a, _b;
        $dtn6l.SDKType._setClientType(sdkKey, 'javascript-client');
        const network = new $e4Scn.default(options, (e)=>{
            this.$emt(e);
        });
        super(sdkKey, (_a = options === null || options === void 0 ? void 0 : options.dataAdapter) !== null && _a !== void 0 ? _a : new $j6Ssa.StatsigEvaluationsDataAdapter(), network, options);
        this._possibleFirstTouchMetadata = {};
        /**
         * Retrieves the value of a feature gate for the current user, represented as a {@link FeatureGate} object.
         *
         * @param {string} name - The name of the feature gate to retrieve.
         * @param {FeatureGateEvaluationOptions} [options] - Optional. Additional options to customize the method call.
         * @returns {FeatureGate} - The {@link FeatureGate} object representing the gate's current evaluation results for the user.
         */ this.getFeatureGate = this._memoize($dtn6l.MemoPrefix._gate, this._getFeatureGateImpl.bind(this));
        /**
         * Retrieves the value of a dynamic config for the current user.
         *
         * @param {string} name The name of the dynamic config to get.
         * @param {DynamicConfigEvaluationOptions} [options] - Optional. Additional options to customize the method call.
         * @returns {DynamicConfig} - The {@link DynamicConfig} object representing the dynamic configs's current evaluation results for the user.
         */ this.getDynamicConfig = this._memoize($dtn6l.MemoPrefix._dynamicConfig, this._getDynamicConfigImpl.bind(this));
        /**
         * Retrieves the value of a experiment for the current user.
         *
         * @param {string} name The name of the experiment to get.
         * @param {ExperimentEvaluationOptions} [options] - Optional. Additional options to customize the method call.
         * @returns {Experiment} - The {@link Experiment} object representing the experiments's current evaluation results for the user.
         */ this.getExperiment = this._memoize($dtn6l.MemoPrefix._experiment, this._getExperimentImpl.bind(this));
        /**
         * Retrieves the list of all Dynamic Configs and Experiments for the current user.
         *
         * @returns {string[]} The list of all Dynamic Config and Experiment names for the current user. Note - these will be hashed unless you've disabled hashing.
         * This is intended to be used for debugging.
         */ this.getConfigList = this._memoize($dtn6l.MemoPrefix._configList, this._getConfigListImpl.bind(this));
        /**
         * Retrieves the value of a layer for the current user.
         *
         * @param {string} name The name of the layer to get.
         * @param {LayerEvaluationOptions} [options] - Optional. Additional options to customize the method call.
         * @returns {Layer} - The {@link Layer} object representing the layers's current evaluation results for the user.
         */ this.getLayer = this._memoize($dtn6l.MemoPrefix._layer, this._getLayerImpl.bind(this));
        /**
         * Retrieves the value of a parameter store for the current user.
         *
         * @param {string} name The name of the parameter store to get.
         * @param {ParameterStoreEvaluationOptions} [options] - Optional. Additional options to customize the method call.
         * @returns {ParameterStore} - The {@link ParameterStore} object representing the parameter store's current mappings for the user.
         */ this.getParameterStore = this._memoize($dtn6l.MemoPrefix._paramStore, this._getParameterStoreImpl.bind(this));
        this._store = new $i8QCG.default(sdkKey);
        this._network = network;
        this._user = this._configureUser(user, options);
        this._sdkInstanceID = (0, $dtn6l.getUUID)();
        const plugins = (_b = options === null || options === void 0 ? void 0 : options.plugins) !== null && _b !== void 0 ? _b : [];
        for (const plugin of plugins)plugin.bind(this);
    }
    /**
     * Initializes the StatsigClient using cached values. This method sets up the client synchronously by utilizing previously cached values.
     * After initialization, cache values are updated in the background for future use, either in subsequent sessions or when `updateUser` is called.
     * This is useful for quickly starting with the last-known-good configurations while refreshing data to keep settings up-to-date.
     *
     * @see {@link initializeAsync} for the asynchronous version of this method.
     */ initializeSync(options) {
        var _a;
        if (this.loadingStatus !== 'Uninitialized') return (0, $dtn6l.createUpdateDetails)(true, this._store.getSource(), -1, null, null, [
            'MultipleInitializations',
            ...(_a = this._store.getWarnings()) !== null && _a !== void 0 ? _a : []
        ]);
        this._logger.start();
        return this.updateUserSync(this._user, options);
    }
    /**
     * Initializes the StatsigClient asynchronously by first using cached values and then updating to the latest values from the network.
     * Once the network values are fetched, they replace the existing cached values. If this method's promise is not awaited,
     * there might be a transition from cached to network values during the session, which can affect consistency.
     * This method is useful when it's acceptable to begin with potentially stale data and switch to the latest configuration as it becomes available.
     *
     * @param {AsyncUpdateOptions} [options] - Optional. Additional options to customize the method call.
     * @returns {Promise<void>} A promise that resolves once the client is fully initialized with the latest values from the network or a timeout (if set) is hit.
     * @see {@link initializeSync} for the synchronous version of this method.
     */ initializeAsync(options) {
        return $d1ebbdb02ace9f76$var$__awaiter(this, void 0, void 0, function*() {
            if (this._initializePromise) return this._initializePromise;
            this._initializePromise = this._initializeAsyncImpl(options);
            return this._initializePromise;
        });
    }
    /**
     * Synchronously updates the user in the Statsig client and switches the internal state to use cached values for the newly specified user.
     * After the initial switch to cached values, this method updates these values in the background, preparing them for future sessions or subsequent calls to updateUser.
     * This method ensures the client is quickly ready with available data.
     *
     * @param {StatsigUser} user - The new StatsigUser for which the client should update its internal state.
     * @see {@link updateUserAsync} for the asynchronous version of this method.
     */ updateUserSync(user, options) {
        const startTime = performance.now();
        try {
            return this._updateUserSyncImpl(user, options, startTime);
        } catch (e) {
            const err = e instanceof Error ? e : new Error(String(e));
            return this._createErrorUpdateDetails(err, startTime);
        }
    }
    _updateUserSyncImpl(user, options, startTime) {
        var _a;
        const warnings = [
            ...(_a = this._store.getWarnings()) !== null && _a !== void 0 ? _a : []
        ];
        this._resetForUser(user);
        const result = this.dataAdapter.getDataSync(this._user);
        if (result == null) warnings.push('NoCachedValues');
        this._store.setValues(result, this._user);
        this._finalizeUpdate(result);
        const disable = options === null || options === void 0 ? void 0 : options.disableBackgroundCacheRefresh;
        if (disable === true || disable == null && (result === null || result === void 0 ? void 0 : result.source) === 'Bootstrap') return (0, $dtn6l.createUpdateDetails)(true, this._store.getSource(), performance.now() - startTime, this._errorBoundary.getLastSeenErrorAndReset(), this._network.getLastUsedInitUrlAndReset(), warnings);
        this._runPostUpdate(result !== null && result !== void 0 ? result : null, this._user);
        return (0, $dtn6l.createUpdateDetails)(true, this._store.getSource(), performance.now() - startTime, this._errorBoundary.getLastSeenErrorAndReset(), this._network.getLastUsedInitUrlAndReset(), warnings);
    }
    /**
     * Asynchronously updates the user in the Statsig client by initially using cached values and then fetching the latest values from the network.
     * When the latest values are fetched, they replace the cached values. If the promise returned by this method is not awaited,
     * the client's state may shift from cached to updated network values during the session, potentially affecting consistency.
     * This method is best used in scenarios where up-to-date configuration is critical and initial delays are acceptable.
     *
     * @param {StatsigUser} user - The new StatsigUser for which the client should update its internal state.
     * @param {AsyncUpdateOptions} [options] - Optional. Additional options to customize the method call.
     * @returns {Promise<void>} A promise that resolves once the client is fully updated with the latest values from the network or a timeout (if set) is hit.
     * @see {@link updateUserSync} for the synchronous version of this method.
     */ updateUserAsync(user, options) {
        return $d1ebbdb02ace9f76$var$__awaiter(this, void 0, void 0, function*() {
            const startTime = performance.now();
            try {
                return yield this._updateUserAsyncImpl(user, options);
            } catch (e) {
                const err = e instanceof Error ? e : new Error(String(e));
                return this._createErrorUpdateDetails(err, startTime);
            }
        });
    }
    _updateUserAsyncImpl(user, options) {
        return $d1ebbdb02ace9f76$var$__awaiter(this, void 0, void 0, function*() {
            this._resetForUser(user);
            const initiator = this._user;
            $dtn6l.Diagnostics._markInitOverallStart(this._sdkKey);
            let result = this.dataAdapter.getDataSync(initiator);
            this._store.setValues(result, this._user);
            this._setStatus('Loading', result);
            result = yield this.dataAdapter.getDataAsync(result, initiator, options);
            // ensure the user hasn't changed while we were waiting
            if (initiator !== this._user) return (0, $dtn6l.createUpdateDetails)(false, this._store.getSource(), -1, new Error('User changed during update'), this._network.getLastUsedInitUrlAndReset());
            let isUsingNetworkValues = false;
            if (result != null) {
                $dtn6l.Diagnostics._markInitProcessStart(this._sdkKey);
                isUsingNetworkValues = this._store.setValues(result, this._user);
                $dtn6l.Diagnostics._markInitProcessEnd(this._sdkKey, {
                    success: isUsingNetworkValues
                });
            }
            this._finalizeUpdate(result);
            if (!isUsingNetworkValues) {
                this._errorBoundary.attachErrorIfNoneExists($dtn6l.UPDATE_DETAIL_ERROR_MESSAGES.NO_NETWORK_DATA);
                this.$emt({
                    name: 'initialization_failure'
                });
            }
            $dtn6l.Diagnostics._markInitOverallEnd(this._sdkKey, isUsingNetworkValues, this._store.getCurrentSourceDetails());
            const initDuration = $dtn6l.Diagnostics._enqueueDiagnosticsEvent(this._user, this._logger, this._sdkKey, this._options);
            return (0, $dtn6l.createUpdateDetails)(isUsingNetworkValues, this._store.getSource(), initDuration, this._errorBoundary.getLastSeenErrorAndReset(), this._network.getLastUsedInitUrlAndReset(), this._store.getWarnings());
        });
    }
    /**
     * Retrieves a synchronous context containing data currently being used by the SDK. Represented as a {@link PrecomputedEvaluationsContext} object.
     *
     * @returns {PrecomputedEvaluationsContext} The current synchronous context for the this StatsigClient instance.
     */ getContext() {
        let user = {};
        try {
            user = JSON.parse(JSON.stringify(this._user));
        } catch (_a) {
            $dtn6l.Log.error('Failed to parse user');
        }
        return {
            sdkKey: this._sdkKey,
            options: this._options,
            values: this._store.getValues(),
            user: user,
            errorBoundary: this._errorBoundary,
            session: $dtn6l.StatsigSession.get(this._sdkKey),
            stableID: $dtn6l.StableID.get(this._sdkKey),
            sdkInstanceID: this._sdkInstanceID
        };
    }
    /**
     * Retrieves the value of a feature gate for the current user, represented as a simple boolean.
     *
     * @param {string} name - The name of the feature gate to retrieve.
     * @param {FeatureGateEvaluationOptions} [options] - Optional. Additional options to customize the method call.
     * @returns {boolean} - The boolean value representing the gate's current evaluation results for the user.
     */ checkGate(name, options) {
        return this.getFeatureGate(name, options).value;
    }
    /**
     * Logs an event to the internal logging system. This function allows logging by either passing a fully formed event object or by specifying the event name with optional value and metadata.
     *
     * @param {StatsigEvent|string} eventOrName - The event object conforming to the StatsigEvent interface, or the name of the event as a string.
     * @param {string|number} value - Optional. The value associated with the event, which can be a string or a number. This parameter is ignored if the first parameter is a StatsigEvent object.
     * @param {Record<string, string>} metadata - Optional. A key-value record containing metadata about the event. This is also ignored if the first parameter is an event object.
     */ logEvent(eventOrName, value, metadata) {
        const event = typeof eventOrName === 'string' ? {
            eventName: eventOrName,
            value: value,
            metadata: metadata
        } : eventOrName;
        this.$emt({
            name: 'log_event_called',
            event: event
        });
        this._logger.enqueue(Object.assign(Object.assign({}, event), {
            user: this._user,
            time: Date.now()
        }));
    }
    /**
     * Updates the user with analytics only metadata. This will override any existing analytics only metadata.
     *
     * @param {Record<string, string | number | boolean>} metadata - The metadata to add to the user.
     */ updateUserWithAnalyticsOnlyMetadata(metadata) {
        this._user = this._configureUser(Object.assign(Object.assign({}, this._user), {
            analyticsOnlyMetadata: metadata
        }), this._options);
    }
    _primeReadyRipcord() {
        this.$on('error', ()=>{
            this.loadingStatus === 'Loading' && this._finalizeUpdate(null);
        });
    }
    _initializeAsyncImpl(options) {
        return $d1ebbdb02ace9f76$var$__awaiter(this, void 0, void 0, function*() {
            if (!$dtn6l.Storage.isReady()) yield $dtn6l.Storage.isReadyResolver();
            this._logger.start();
            return this.updateUserAsync(this._user, options);
        });
    }
    _createErrorUpdateDetails(error, startTime) {
        var _a;
        return (0, $dtn6l.createUpdateDetails)(false, this._store.getSource(), performance.now() - startTime, error, null, [
            ...(_a = this._store.getWarnings()) !== null && _a !== void 0 ? _a : []
        ]);
    }
    _finalizeUpdate(values) {
        this._store.finalize();
        this._setStatus('Ready', values);
    }
    _runPostUpdate(current, user) {
        this.dataAdapter.getDataAsync(current, user, {
            priority: 'low'
        }).catch((err)=>{
            $dtn6l.Log.error('An error occurred after update.', err);
        });
    }
    _resetForUser(user) {
        this._logger.reset();
        this._store.reset();
        this._user = this._configureUser(user, this._options);
    }
    _configureUser(originalUser, options) {
        var _a, _b, _c;
        const user = (0, $dtn6l._normalizeUser)(originalUser, options);
        const stableIdOverride = (_a = user.customIDs) === null || _a === void 0 ? void 0 : _a.stableID;
        if (stableIdOverride) {
            const readyPromise = (_c = (_b = this.storageProvider).isReadyResolver) === null || _c === void 0 ? void 0 : _c.call(_b);
            if (readyPromise) readyPromise.then(()=>$dtn6l.StableID.setOverride(stableIdOverride, this._sdkKey), ()=>$dtn6l.StableID.setOverride(stableIdOverride, this._sdkKey));
            else $dtn6l.StableID.setOverride(stableIdOverride, this._sdkKey);
        }
        // Only attach first touch metadata if it's not empty
        if (Object.keys(this._possibleFirstTouchMetadata).length > 0) user.analyticsOnlyMetadata = Object.assign(Object.assign({}, user.analyticsOnlyMetadata), this._possibleFirstTouchMetadata);
        return user;
    }
    _getFeatureGateImpl(name, options) {
        var _a, _b;
        const { result: evaluation, details: details } = this._store.getGate(name);
        const gate = (0, $dtn6l._makeFeatureGate)(name, details, evaluation);
        const overridden = (_b = (_a = this.overrideAdapter) === null || _a === void 0 ? void 0 : _a.getGateOverride) === null || _b === void 0 ? void 0 : _b.call(_a, gate, this._user, options);
        const result = overridden !== null && overridden !== void 0 ? overridden : gate;
        this._enqueueExposure(name, (0, $dtn6l._createGateExposure)(this._user, result, this._store.getExposureMapping()), options);
        this.$emt({
            name: 'gate_evaluation',
            gate: result
        });
        return result;
    }
    _getDynamicConfigImpl(name, options) {
        var _a, _b;
        const { result: evaluation, details: details } = this._store.getConfig(name);
        const config = (0, $dtn6l._makeDynamicConfig)(name, details, evaluation);
        const overridden = (_b = (_a = this.overrideAdapter) === null || _a === void 0 ? void 0 : _a.getDynamicConfigOverride) === null || _b === void 0 ? void 0 : _b.call(_a, config, this._user, options);
        const result = overridden !== null && overridden !== void 0 ? overridden : config;
        this._enqueueExposure(name, (0, $dtn6l._createConfigExposure)(this._user, result, this._store.getExposureMapping()), options);
        this.$emt({
            name: 'dynamic_config_evaluation',
            dynamicConfig: result
        });
        return result;
    }
    _getExperimentImpl(name, options) {
        var _a, _b, _c, _d;
        const { result: evaluation, details: details } = this._store.getConfig(name);
        const experiment = (0, $dtn6l._makeExperiment)(name, details, evaluation);
        if (experiment.__evaluation != null) experiment.__evaluation.secondary_exposures = (0, $dtn6l._mapExposures)((_b = (_a = experiment.__evaluation) === null || _a === void 0 ? void 0 : _a.secondary_exposures) !== null && _b !== void 0 ? _b : [], this._store.getExposureMapping());
        const overridden = (_d = (_c = this.overrideAdapter) === null || _c === void 0 ? void 0 : _c.getExperimentOverride) === null || _d === void 0 ? void 0 : _d.call(_c, experiment, this._user, options);
        const result = overridden !== null && overridden !== void 0 ? overridden : experiment;
        this._enqueueExposure(name, (0, $dtn6l._createConfigExposure)(this._user, result, this._store.getExposureMapping()), options);
        this.$emt({
            name: 'experiment_evaluation',
            experiment: result
        });
        return result;
    }
    _getConfigListImpl() {
        return this._store.getConfigList();
    }
    _getLayerImpl(name, options) {
        var _a, _b, _c;
        const { result: evaluation, details: details } = this._store.getLayer(name);
        const layer = (0, $dtn6l._makeLayer)(name, details, evaluation);
        const overridden = (_b = (_a = this.overrideAdapter) === null || _a === void 0 ? void 0 : _a.getLayerOverride) === null || _b === void 0 ? void 0 : _b.call(_a, layer, this._user, options);
        if (options === null || options === void 0 ? void 0 : options.disableExposureLog) this._logger.incrementNonExposureCount(name);
        const result = (0, $dtn6l._mergeOverride)(layer, overridden, (_c = overridden === null || overridden === void 0 ? void 0 : overridden.__value) !== null && _c !== void 0 ? _c : layer.__value, (param)=>{
            if (options === null || options === void 0 ? void 0 : options.disableExposureLog) return;
            this._enqueueExposure(name, (0, $dtn6l._createLayerParameterExposure)(this._user, result, param, this._store.getExposureMapping()), options);
        });
        this.$emt({
            name: 'layer_evaluation',
            layer: result
        });
        return result;
    }
    _getParameterStoreImpl(name, options) {
        var _a, _b;
        const { result: configuration, details: details } = this._store.getParamStore(name);
        this._logger.incrementNonExposureCount(name);
        const paramStore = {
            name: name,
            details: details,
            __configuration: configuration,
            get: (0, $9JsrP._makeParamStoreGetter)(this, configuration, options)
        };
        const overridden = (_b = (_a = this.overrideAdapter) === null || _a === void 0 ? void 0 : _a.getParamStoreOverride) === null || _b === void 0 ? void 0 : _b.call(_a, paramStore, options);
        if (overridden != null) {
            paramStore.__configuration = overridden.config;
            paramStore.details = overridden.details;
            paramStore.get = (0, $9JsrP._makeParamStoreGetter)(this, overridden.config, options);
        }
        return paramStore;
    }
}
module.exports.default = $d1ebbdb02ace9f76$var$StatsigClient;

});
parcelRegister("i8QCG", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $dtn6l = parcelRequire("dtn6l");

var $7btVL = parcelRequire("7btVL");

var $3UfIi = parcelRequire("3UfIi");
class $d351cb260e1921f6$var$EvaluationStore {
    constructor(_sdkKey){
        this._sdkKey = _sdkKey;
        this._rawValues = null;
        this._values = null;
        this._source = 'Uninitialized';
        this._lcut = 0;
        this._receivedAt = 0;
        this._bootstrapMetadata = null;
        this._warnings = new Set();
    }
    reset() {
        this._values = null;
        this._rawValues = null;
        this._source = 'Loading';
        this._lcut = 0;
        this._receivedAt = 0;
        this._bootstrapMetadata = null;
        this._warnings.clear();
    }
    finalize() {
        if (this._values) return;
        this._source = 'NoValues';
    }
    getValues() {
        return this._rawValues ? (0, $dtn6l._typedJsonParse)(this._rawValues, 'has_updates', 'EvaluationStoreValues') : null;
    }
    setValues(result, user) {
        var _a, _b;
        if (!result) return false;
        const values = (0, $dtn6l._typedJsonParse)(result.data, 'has_updates', 'EvaluationResponse');
        if (values == null) return false;
        this._source = result.source;
        if ((values === null || values === void 0 ? void 0 : values.has_updates) !== true) return true;
        const updatedLcut = (_a = values.time) !== null && _a !== void 0 ? _a : 0;
        if (updatedLcut < this._lcut) return true;
        this._rawValues = result.data;
        this._lcut = values.time;
        this._receivedAt = result.receivedAt;
        if (values.response_format === 'init-v2') this._values = new $3UfIi.V2InitializeContainer(values);
        else this._values = new $7btVL.V1InitializeContainer(values);
        this._bootstrapMetadata = this._extractBootstrapMetadata(result.source, values);
        if (result.source && values.user) this._setWarningState(user, values);
        $dtn6l.SDKFlags.setFlags(this._sdkKey, (_b = values.sdk_flags) !== null && _b !== void 0 ? _b : {});
        return true;
    }
    getWarnings() {
        if (this._warnings.size === 0) return undefined;
        return Array.from(this._warnings);
    }
    getGate(name) {
        const res = this._values ? this._values.getGate(name) : null;
        return this._getDetailedStoreResult(res);
    }
    getConfig(name) {
        const res = this._values ? this._values.getConfig(name) : null;
        return this._getDetailedStoreResult(res);
    }
    getConfigList() {
        if (!this._values) return [];
        return this._values.getConfigList();
    }
    getLayer(name) {
        const res = this._values ? this._values.getLayer(name) : null;
        return this._getDetailedStoreResult(res);
    }
    getParamStore(name) {
        const res = this._values ? this._values.getParamStore(name) : null;
        return this._getDetailedStoreResult(res);
    }
    getSource() {
        return this._source;
    }
    getExposureMapping() {
        var _a;
        return (_a = this._values) === null || _a === void 0 ? void 0 : _a.getExposureMapping();
    }
    _extractBootstrapMetadata(source, values) {
        if (source !== 'Bootstrap') return null;
        const bootstrapMetadata = {};
        if (values.user) bootstrapMetadata.user = values.user;
        if (values.sdkInfo) bootstrapMetadata.generatorSDKInfo = values.sdkInfo;
        bootstrapMetadata.lcut = values.time;
        return bootstrapMetadata;
    }
    _getDetailedStoreResult(result) {
        return {
            result: result,
            details: this._getDetails(result == null)
        };
    }
    _setWarningState(user, values) {
        var _a, _b;
        const stableID = $dtn6l.StableID.get(this._sdkKey);
        if (((_a = user.customIDs) === null || _a === void 0 ? void 0 : _a.stableID) !== stableID && // don't throw if they're both undefined
        (((_b = user.customIDs) === null || _b === void 0 ? void 0 : _b.stableID) || stableID)) {
            this._warnings.add('StableIDMismatch');
            return;
        }
        if ('user' in values) {
            const bootstrapUser = values['user'];
            const userForComparison = Object.assign(Object.assign({}, user), {
                analyticsOnlyMetadata: undefined,
                privateAttributes: undefined
            });
            if ((0, $dtn6l._getFullUserHash)(userForComparison) !== (0, $dtn6l._getFullUserHash)(bootstrapUser)) this._warnings.add('PartialUserMatch');
        }
    }
    getCurrentSourceDetails() {
        if (this._source === 'Uninitialized' || this._source === 'NoValues') return {
            reason: this._source
        };
        const sourceDetails = {
            reason: this._source,
            lcut: this._lcut,
            receivedAt: this._receivedAt
        };
        if (this._warnings.size > 0) sourceDetails.warnings = Array.from(this._warnings);
        return sourceDetails;
    }
    _getDetails(isUnrecognized) {
        var _a, _b;
        const sourceDetails = this.getCurrentSourceDetails();
        let reason = sourceDetails.reason;
        const warnings = (_a = sourceDetails.warnings) !== null && _a !== void 0 ? _a : [];
        if (this._source === 'Bootstrap' && warnings.length > 0) reason = reason + warnings[0];
        if (reason !== 'Uninitialized' && reason !== 'NoValues') {
            const subreason = isUnrecognized ? 'Unrecognized' : 'Recognized';
            reason = `${reason}:${subreason}`;
        }
        const bootstrapMetadata = this._source === 'Bootstrap' ? (_b = this._bootstrapMetadata) !== null && _b !== void 0 ? _b : undefined : undefined;
        if (bootstrapMetadata) sourceDetails.bootstrapMetadata = bootstrapMetadata;
        return Object.assign(Object.assign({}, sourceDetails), {
            reason: reason
        });
    }
}
module.exports.default = $d351cb260e1921f6$var$EvaluationStore;

});
parcelRegister("7btVL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.V1InitializeContainer = void 0;

var $dtn6l = parcelRequire("dtn6l");
class $53b0c713f248c7f9$var$V1InitializeContainer {
    constructor(_values){
        this._values = _values;
    }
    getGate(name) {
        return this._getResultFromLookup(this._values.feature_gates, name);
    }
    getConfig(name) {
        return this._getResultFromLookup(this._values.dynamic_configs, name);
    }
    getLayer(name) {
        return this._getResultFromLookup(this._values.layer_configs, name);
    }
    getParamStore(name) {
        return this._getResultFromLookup(this._values.param_stores, name);
    }
    getConfigList() {
        return Object.keys(this._values.dynamic_configs);
    }
    getExposureMapping() {
        return this._values.exposures;
    }
    _getResultFromLookup(lookup, name) {
        var _a, _b;
        if (!lookup) return null;
        return (_b = (_a = lookup[name]) !== null && _a !== void 0 ? _a : lookup[(0, $dtn6l._DJB2)(name)]) !== null && _b !== void 0 ? _b : null;
    }
}
module.exports.V1InitializeContainer = $53b0c713f248c7f9$var$V1InitializeContainer;

});

parcelRegister("3UfIi", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.V2InitializeContainer = void 0;

var $dtn6l = parcelRequire("dtn6l");
class $2d82ca689190c304$var$V2InitializeContainer {
    constructor(_values){
        this._values = _values;
    }
    getGate(name) {
        var _a, _b, _c;
        const evalV2 = this._getResultFromLookup(this._values.feature_gates, name);
        if (!evalV2) return null;
        return {
            name: name,
            value: evalV2.v === true,
            rule_id: (_a = evalV2.r) !== null && _a !== void 0 ? _a : 'default',
            secondary_exposures: (_b = evalV2.s) !== null && _b !== void 0 ? _b : [],
            id_type: (_c = evalV2.i) !== null && _c !== void 0 ? _c : ''
        };
    }
    getConfig(name) {
        var _a, _b, _c, _d;
        const evalV2 = this._getResultFromLookup(this._values.dynamic_configs, name);
        if (!evalV2) return null;
        return {
            name: name,
            value: (_a = this._values.values[evalV2.v]) !== null && _a !== void 0 ? _a : {},
            rule_id: evalV2.r,
            secondary_exposures: (_b = evalV2.s) !== null && _b !== void 0 ? _b : [],
            id_type: (_c = evalV2.i) !== null && _c !== void 0 ? _c : '',
            is_user_in_experiment: evalV2.ue === true ? true : false,
            passed: evalV2.p === true,
            group_name: (_d = evalV2.gn) !== null && _d !== void 0 ? _d : undefined,
            is_experiment_active: evalV2.ea === true ? true : false,
            group: evalV2.r,
            is_device_based: evalV2.i === 'stableID'
        };
    }
    getLayer(name) {
        var _a, _b, _c, _d, _e, _f;
        const evalV2 = this._getResultFromLookup(this._values.layer_configs, name);
        if (!evalV2) return null;
        return {
            name: name,
            value: (_a = this._values.values[evalV2.v]) !== null && _a !== void 0 ? _a : {},
            rule_id: evalV2.r,
            secondary_exposures: (_b = evalV2.s) !== null && _b !== void 0 ? _b : [],
            is_user_in_experiment: evalV2.ue === true ? true : false,
            group_name: (_c = evalV2.gn) !== null && _c !== void 0 ? _c : undefined,
            is_experiment_active: evalV2.ea === true ? true : false,
            group: evalV2.r,
            is_device_based: evalV2.i === 'stableID',
            allocated_experiment_name: (_d = evalV2.ae) !== null && _d !== void 0 ? _d : '',
            explicit_parameters: (_e = evalV2.ep) !== null && _e !== void 0 ? _e : [],
            undelegated_secondary_exposures: (_f = evalV2.us) !== null && _f !== void 0 ? _f : [],
            parameter_rule_ids: evalV2.pr
        };
    }
    getParamStore(name) {
        return this._getResultFromLookup(this._values.param_stores, name);
    }
    getConfigList() {
        return Object.keys(this._values.dynamic_configs);
    }
    getExposureMapping() {
        return this._values.exposures;
    }
    _getResultFromLookup(lookup, name) {
        var _a, _b;
        if (!lookup) return null;
        return (_b = (_a = lookup[name]) !== null && _a !== void 0 ? _a : lookup[(0, $dtn6l._DJB2)(name)]) !== null && _b !== void 0 ? _b : null;
    }
}
module.exports.V2InitializeContainer = $2d82ca689190c304$var$V2InitializeContainer;

});


parcelRegister("e4Scn", function(module, exports) {
"use strict";
var $a3fb7b1b9752a99a$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $dtn6l = parcelRequire("dtn6l");

var $7TiGk = parcelRequire("7TiGk");
class $a3fb7b1b9752a99a$var$StatsigNetwork extends $dtn6l.NetworkCore {
    constructor(options, emitter){
        super(options, emitter);
        const config = options === null || options === void 0 ? void 0 : options.networkConfig;
        this._option = options;
        this._initializeUrlConfig = new $dtn6l.UrlConfiguration($dtn6l.Endpoint._initialize, config === null || config === void 0 ? void 0 : config.initializeUrl, config === null || config === void 0 ? void 0 : config.api, config === null || config === void 0 ? void 0 : config.initializeFallbackUrls);
    }
    fetchEvaluations(sdkKey, current, priority, user, isCacheValidFor204) {
        return $a3fb7b1b9752a99a$var$__awaiter(this, void 0, void 0, function*() {
            var _a, _b, _c, _d, _e, _f;
            const cache = current ? (0, $dtn6l._typedJsonParse)(current, 'has_updates', 'InitializeResponse') : null;
            let data = {
                user: user,
                hash: (_c = (_b = (_a = this._option) === null || _a === void 0 ? void 0 : _a.networkConfig) === null || _b === void 0 ? void 0 : _b.initializeHashAlgorithm) !== null && _c !== void 0 ? _c : 'djb2',
                deltasResponseRequested: false,
                full_checksum: null
            };
            if (cache === null || cache === void 0 ? void 0 : cache.has_updates) {
                const hasHashChanged = (cache === null || cache === void 0 ? void 0 : cache.hash_used) !== ((_f = (_e = (_d = this._option) === null || _d === void 0 ? void 0 : _d.networkConfig) === null || _e === void 0 ? void 0 : _e.initializeHashAlgorithm) !== null && _f !== void 0 ? _f : 'djb2');
                data = Object.assign(Object.assign({}, data), {
                    sinceTime: isCacheValidFor204 && !hasHashChanged ? cache.time : 0,
                    previousDerivedFields: 'derived_fields' in cache && isCacheValidFor204 ? cache.derived_fields : {},
                    deltasResponseRequested: true,
                    full_checksum: cache.full_checksum,
                    partialUserMatchSinceTime: !hasHashChanged ? cache.time : 0
                });
            }
            return this._fetchEvaluations(sdkKey, cache, data, priority);
        });
    }
    _fetchEvaluations(sdkKey, cache, data, priority) {
        return $a3fb7b1b9752a99a$var$__awaiter(this, void 0, void 0, function*() {
            var _a, _b;
            const response = yield this.post({
                sdkKey: sdkKey,
                urlConfig: this._initializeUrlConfig,
                data: data,
                retries: 2,
                isStatsigEncodable: true,
                priority: priority
            });
            if ((response === null || response === void 0 ? void 0 : response.code) === 204) return '{"has_updates": false}';
            if ((response === null || response === void 0 ? void 0 : response.code) !== 200) return (_a = response === null || response === void 0 ? void 0 : response.body) !== null && _a !== void 0 ? _a : null;
            if ((cache === null || cache === void 0 ? void 0 : cache.has_updates) !== true || ((_b = response.body) === null || _b === void 0 ? void 0 : _b.includes('"is_delta":true')) !== true || data.deltasResponseRequested !== true) return response.body;
            const result = (0, $7TiGk._resolveDeltasResponse)(cache, response.body);
            if (typeof result === 'string') return result;
            // retry without deltas
            return this._fetchEvaluations(sdkKey, cache, Object.assign(Object.assign(Object.assign({}, data), result), {
                deltasResponseRequested: false
            }), priority);
        });
    }
}
module.exports.default = $a3fb7b1b9752a99a$var$StatsigNetwork;

});
parcelRegister("7TiGk", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._resolveDeltasResponse = void 0;

var $dtn6l = parcelRequire("dtn6l");
const $5bec293bd088a842$var$MAX_DELTAS_SORT_DEPTH = 2;
function $5bec293bd088a842$var$_resolveDeltasResponse(cache, deltasString) {
    const deltas = (0, $dtn6l._typedJsonParse)(deltasString, 'checksum', 'DeltasEvaluationResponse');
    if (!deltas) return {
        hadBadDeltaChecksum: true
    };
    const merged = $5bec293bd088a842$var$_mergeDeltasIntoCache(cache, deltas);
    const resolved = $5bec293bd088a842$var$_handleDeletedEntries(merged);
    const actualChecksum = (0, $dtn6l._DJB2Object)({
        feature_gates: resolved.feature_gates,
        dynamic_configs: resolved.dynamic_configs,
        layer_configs: resolved.layer_configs
    }, $5bec293bd088a842$var$MAX_DELTAS_SORT_DEPTH);
    const isMatch = actualChecksum === deltas.checksumV2;
    if (!isMatch) return {
        hadBadDeltaChecksum: true,
        badChecksum: actualChecksum,
        badMergedConfigs: resolved,
        badFullResponse: deltas.deltas_full_response
    };
    return JSON.stringify(resolved);
}
module.exports._resolveDeltasResponse = $5bec293bd088a842$var$_resolveDeltasResponse;
function $5bec293bd088a842$var$_mergeDeltasIntoCache(cache, deltas) {
    return Object.assign(Object.assign(Object.assign({}, cache), deltas), {
        feature_gates: Object.assign(Object.assign({}, cache.feature_gates), deltas.feature_gates),
        layer_configs: Object.assign(Object.assign({}, cache.layer_configs), deltas.layer_configs),
        dynamic_configs: Object.assign(Object.assign({}, cache.dynamic_configs), deltas.dynamic_configs)
    });
}
function $5bec293bd088a842$var$_handleDeletedEntries(deltas) {
    const result = deltas;
    $5bec293bd088a842$var$_deleteEntriesInRecord(deltas.deleted_gates, result.feature_gates);
    delete result.deleted_gates;
    $5bec293bd088a842$var$_deleteEntriesInRecord(deltas.deleted_configs, result.dynamic_configs);
    delete result.deleted_configs;
    $5bec293bd088a842$var$_deleteEntriesInRecord(deltas.deleted_layers, result.layer_configs);
    delete result.deleted_layers;
    return result;
}
function $5bec293bd088a842$var$_deleteEntriesInRecord(keys, values) {
    keys === null || keys === void 0 || keys.forEach((key)=>{
        delete values[key];
    });
}

});


parcelRegister("9JsrP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._makeParamStoreGetter = void 0;

var $dtn6l = parcelRequire("dtn6l");
const $715e622b11c913c1$var$NO_EXPOSURE_OPT = {
    disableExposureLog: true
};
function $715e622b11c913c1$var$_shouldLogExposure(options) {
    return options == null || options.disableExposureLog === false;
}
function $715e622b11c913c1$var$_shouldReturnFallback(value, fallback) {
    return fallback != null && !(0, $dtn6l._isTypeMatch)(value, fallback);
}
function $715e622b11c913c1$var$_getMappedStaticValue(param, _options) {
    return param.value;
}
function $715e622b11c913c1$var$_getMappedGateValue(client, param, options) {
    const gate = client.getFeatureGate(param.gate_name, $715e622b11c913c1$var$_shouldLogExposure(options) ? undefined : $715e622b11c913c1$var$NO_EXPOSURE_OPT);
    if (gate.value) return param.pass_value;
    return param.fail_value;
}
function $715e622b11c913c1$var$_getMappedDynamicConfigValue(client, param, fallback, options) {
    const config = client.getDynamicConfig(param.config_name, $715e622b11c913c1$var$_shouldLogExposure(options) ? undefined : $715e622b11c913c1$var$NO_EXPOSURE_OPT);
    const value = config.get(param.param_name);
    if ($715e622b11c913c1$var$_shouldReturnFallback(value, fallback)) return fallback;
    return value;
}
function $715e622b11c913c1$var$_getMappedExperimentValue(client, param, fallback, options) {
    const experiment = client.getExperiment(param.experiment_name, $715e622b11c913c1$var$_shouldLogExposure(options) ? undefined : $715e622b11c913c1$var$NO_EXPOSURE_OPT);
    const value = experiment.get(param.param_name);
    if ($715e622b11c913c1$var$_shouldReturnFallback(value, fallback)) return fallback;
    return value;
}
function $715e622b11c913c1$var$_getMappedLayerValue(client, param, fallback, options) {
    const layer = client.getLayer(param.layer_name, $715e622b11c913c1$var$_shouldLogExposure(options) ? undefined : $715e622b11c913c1$var$NO_EXPOSURE_OPT);
    const value = layer.get(param.param_name);
    if ($715e622b11c913c1$var$_shouldReturnFallback(value, fallback)) return fallback;
    return value;
}
function $715e622b11c913c1$var$_makeParamStoreGetter(client, config, options) {
    return (paramName, fallback)=>{
        if (config == null) return fallback;
        const param = config[paramName];
        if (param == null || fallback != null && (0, $dtn6l._typeOf)(fallback) !== param.param_type) return fallback;
        switch(param.ref_type){
            case 'static':
                return $715e622b11c913c1$var$_getMappedStaticValue(param, options);
            case 'gate':
                return $715e622b11c913c1$var$_getMappedGateValue(client, param, options);
            case 'dynamic_config':
                return $715e622b11c913c1$var$_getMappedDynamicConfigValue(client, param, fallback, options);
            case 'experiment':
                return $715e622b11c913c1$var$_getMappedExperimentValue(client, param, fallback, options);
            case 'layer':
                return $715e622b11c913c1$var$_getMappedLayerValue(client, param, fallback, options);
            default:
                return fallback;
        }
    };
}
module.exports._makeParamStoreGetter = $715e622b11c913c1$var$_makeParamStoreGetter;

});

parcelRegister("j6Ssa", function(module, exports) {
"use strict";
var $de98d1245d1fdec6$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.StatsigEvaluationsDataAdapter = void 0;

var $dtn6l = parcelRequire("dtn6l");

var $e4Scn = parcelRequire("e4Scn");
class $de98d1245d1fdec6$var$StatsigEvaluationsDataAdapter extends $dtn6l.DataAdapterCore {
    constructor(){
        super('EvaluationsDataAdapter', 'evaluations');
        this._network = null;
        this._options = null;
    }
    attach(sdkKey, options, network) {
        super.attach(sdkKey, options, network);
        if (network !== null && network instanceof $e4Scn.default) this._network = network;
        else this._network = new $e4Scn.default(options !== null && options !== void 0 ? options : {});
    }
    getDataAsync(current, user, options) {
        return this._getDataAsyncImpl(current, (0, $dtn6l._normalizeUser)(user, this._options), options);
    }
    prefetchData(user, options) {
        return this._prefetchDataImpl(user, options);
    }
    setData(data) {
        const values = (0, $dtn6l._typedJsonParse)(data, 'has_updates', 'data');
        if (values && 'user' in values) super.setData(data, values.user);
        else $dtn6l.Log.error('StatsigUser not found. You may be using an older server SDK version. Please upgrade your SDK or use setDataLegacy.');
    }
    setDataLegacy(data, user) {
        super.setData(data, user);
    }
    _fetchFromNetwork(current, user, options, isCacheValidFor204) {
        return $de98d1245d1fdec6$var$__awaiter(this, void 0, void 0, function*() {
            var _a;
            const result = yield (_a = this._network) === null || _a === void 0 ? void 0 : _a.fetchEvaluations(this._getSdkKey(), current, options === null || options === void 0 ? void 0 : options.priority, user, isCacheValidFor204);
            return result !== null && result !== void 0 ? result : null;
        });
    }
    _getCacheKey(user) {
        var _a;
        const key = (0, $dtn6l._getStorageKey)(this._getSdkKey(), user, (_a = this._options) === null || _a === void 0 ? void 0 : _a.customUserCacheKeyFunc);
        return `${$dtn6l.DataAdapterCachePrefix}.${this._cacheSuffix}.${key}`;
    }
    _isCachedResultValidFor204(result, user) {
        return result.fullUserHash != null && result.fullUserHash === (0, $dtn6l._getFullUserHash)(user);
    }
}
module.exports.StatsigEvaluationsDataAdapter = $de98d1245d1fdec6$var$StatsigEvaluationsDataAdapter;

});



parcelRegister("kJAvC", function(module, exports) {
$parcel$export(module.exports, "default", () => $f18454857a439bdd$export$2e2bcd8739ae039);

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $25nEq = parcelRequire("25nEq");

var $hLfKH = parcelRequire("hLfKH");
function $f18454857a439bdd$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $f18454857a439bdd$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $f18454857a439bdd$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $f18454857a439bdd$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $f18454857a439bdd$export$a66cbd9b2289cd78 = '@all-features';
var $f18454857a439bdd$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function Subscriptions() {
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, Subscriptions);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "eventToValue", new Map());
        this.emitter = new (0, (/*@__PURE__*/$parcel$interopDefault($hLfKH)))();
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(Subscriptions, [
        {
            key: "onGateUpdated",
            value: function onGateUpdated(gateName, callback, checkGate, options) {
                var _this = this;
                var value = checkGate(gateName, $f18454857a439bdd$var$_objectSpread($f18454857a439bdd$var$_objectSpread({}, options), {}, {
                    fireGateExposure: false
                }));
                if (this.eventToValue.get(callback) === undefined) this.eventToValue.set(callback, value);
                var wrapCallback = function wrapCallback() {
                    var value = checkGate(gateName, $f18454857a439bdd$var$_objectSpread($f18454857a439bdd$var$_objectSpread({}, options), {}, {
                        fireGateExposure: false
                    }));
                    var existingValue = _this.eventToValue.get(callback);
                    if (existingValue !== value) {
                        _this.eventToValue.set(callback, value);
                        callback(value);
                    }
                };
                this.emitter.on(gateName, wrapCallback);
                return function() {
                    _this.emitter.off(gateName, wrapCallback);
                };
            }
        },
        {
            key: "onExperimentValueUpdated",
            value: function onExperimentValueUpdated(experimentName, parameterName, defaultValue, callback, getExperimentValue, options) {
                var _this2 = this;
                var experimentEventName = "".concat(experimentName, ".").concat(parameterName);
                var value = getExperimentValue(experimentName, parameterName, defaultValue, $f18454857a439bdd$var$_objectSpread($f18454857a439bdd$var$_objectSpread({}, options), {}, {
                    fireExperimentExposure: false
                }));
                if (this.eventToValue.get(callback) === undefined) this.eventToValue.set(callback, value);
                var wrapCallback = function wrapCallback() {
                    var value = getExperimentValue(experimentName, parameterName, defaultValue, $f18454857a439bdd$var$_objectSpread($f18454857a439bdd$var$_objectSpread({}, options), {}, {
                        fireExperimentExposure: false
                    }));
                    var existingValue = _this2.eventToValue.get(callback);
                    if (existingValue !== value) {
                        _this2.eventToValue.set(callback, value);
                        callback(value);
                    }
                };
                this.emitter.on(experimentEventName, wrapCallback);
                return function() {
                    _this2.emitter.off(experimentEventName, wrapCallback);
                };
            }
        },
        {
            key: "onAnyUpdated",
            value: function onAnyUpdated(callback) {
                var _this3 = this;
                this.emitter.on($f18454857a439bdd$export$a66cbd9b2289cd78, callback);
                return function() {
                    _this3.emitter.off($f18454857a439bdd$export$a66cbd9b2289cd78, callback);
                };
            }
        },
        {
            key: "anyUpdated",
            value: function anyUpdated() {
                var _this4 = this;
                this.emitter.emit($f18454857a439bdd$export$a66cbd9b2289cd78);
                this.emitter.eventNames().filter(function(name) {
                    return name !== $f18454857a439bdd$export$a66cbd9b2289cd78;
                }).forEach(function(event) {
                    _this4.emitter.emit(event);
                });
            }
        }
    ]);
}();

});
parcelRegister("hLfKH", function(module, exports) {
'use strict';
var $cee30b8789895425$var$has = Object.prototype.hasOwnProperty, $cee30b8789895425$var$prefix = '~';
/**
 * Constructor to create a storage for our `EE` objects.
 * An `Events` instance is a plain object whose properties are event names.
 *
 * @constructor
 * @private
 */ function $cee30b8789895425$var$Events() {}
//
// We try to not inherit from `Object.prototype`. In some engines creating an
// instance in this way is faster than calling `Object.create(null)` directly.
// If `Object.create(null)` is not supported we prefix the event names with a
// character to make sure that the built-in object properties are not
// overridden or used as an attack vector.
//
if (Object.create) {
    $cee30b8789895425$var$Events.prototype = Object.create(null);
    //
    // This hack is needed because the `__proto__` property is still inherited in
    // some old browsers like Android 4, iPhone 5.1, Opera 11 and Safari 5.
    //
    if (!new $cee30b8789895425$var$Events().__proto__) $cee30b8789895425$var$prefix = false;
}
/**
 * Representation of a single event listener.
 *
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} [once=false] Specify if the listener is a one-time listener.
 * @constructor
 * @private
 */ function $cee30b8789895425$var$EE(fn, context, once) {
    this.fn = fn;
    this.context = context;
    this.once = once || false;
}
/**
 * Add a listener for a given event.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} once Specify if the listener is a one-time listener.
 * @returns {EventEmitter}
 * @private
 */ function $cee30b8789895425$var$addListener(emitter, event, fn, context, once) {
    if (typeof fn !== 'function') throw new TypeError('The listener must be a function');
    var listener = new $cee30b8789895425$var$EE(fn, context || emitter, once), evt = $cee30b8789895425$var$prefix ? $cee30b8789895425$var$prefix + event : event;
    if (!emitter._events[evt]) emitter._events[evt] = listener, emitter._eventsCount++;
    else if (!emitter._events[evt].fn) emitter._events[evt].push(listener);
    else emitter._events[evt] = [
        emitter._events[evt],
        listener
    ];
    return emitter;
}
/**
 * Clear event by name.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} evt The Event name.
 * @private
 */ function $cee30b8789895425$var$clearEvent(emitter, evt) {
    if (--emitter._eventsCount === 0) emitter._events = new $cee30b8789895425$var$Events();
    else delete emitter._events[evt];
}
/**
 * Minimal `EventEmitter` interface that is molded against the Node.js
 * `EventEmitter` interface.
 *
 * @constructor
 * @public
 */ function $cee30b8789895425$var$EventEmitter() {
    this._events = new $cee30b8789895425$var$Events();
    this._eventsCount = 0;
}
/**
 * Return an array listing the events for which the emitter has registered
 * listeners.
 *
 * @returns {Array}
 * @public
 */ $cee30b8789895425$var$EventEmitter.prototype.eventNames = function eventNames() {
    var names = [], events, name;
    if (this._eventsCount === 0) return names;
    for(name in events = this._events)if ($cee30b8789895425$var$has.call(events, name)) names.push($cee30b8789895425$var$prefix ? name.slice(1) : name);
    if (Object.getOwnPropertySymbols) return names.concat(Object.getOwnPropertySymbols(events));
    return names;
};
/**
 * Return the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Array} The registered listeners.
 * @public
 */ $cee30b8789895425$var$EventEmitter.prototype.listeners = function listeners(event) {
    var evt = $cee30b8789895425$var$prefix ? $cee30b8789895425$var$prefix + event : event, handlers = this._events[evt];
    if (!handlers) return [];
    if (handlers.fn) return [
        handlers.fn
    ];
    for(var i = 0, l = handlers.length, ee = new Array(l); i < l; i++)ee[i] = handlers[i].fn;
    return ee;
};
/**
 * Return the number of listeners listening to a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Number} The number of listeners.
 * @public
 */ $cee30b8789895425$var$EventEmitter.prototype.listenerCount = function listenerCount(event) {
    var evt = $cee30b8789895425$var$prefix ? $cee30b8789895425$var$prefix + event : event, listeners = this._events[evt];
    if (!listeners) return 0;
    if (listeners.fn) return 1;
    return listeners.length;
};
/**
 * Calls each of the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Boolean} `true` if the event had listeners, else `false`.
 * @public
 */ $cee30b8789895425$var$EventEmitter.prototype.emit = function emit(event, a1, a2, a3, a4, a5) {
    var evt = $cee30b8789895425$var$prefix ? $cee30b8789895425$var$prefix + event : event;
    if (!this._events[evt]) return false;
    var listeners = this._events[evt], len = arguments.length, args, i;
    if (listeners.fn) {
        if (listeners.once) this.removeListener(event, listeners.fn, undefined, true);
        switch(len){
            case 1:
                return listeners.fn.call(listeners.context), true;
            case 2:
                return listeners.fn.call(listeners.context, a1), true;
            case 3:
                return listeners.fn.call(listeners.context, a1, a2), true;
            case 4:
                return listeners.fn.call(listeners.context, a1, a2, a3), true;
            case 5:
                return listeners.fn.call(listeners.context, a1, a2, a3, a4), true;
            case 6:
                return listeners.fn.call(listeners.context, a1, a2, a3, a4, a5), true;
        }
        for(i = 1, args = new Array(len - 1); i < len; i++)args[i - 1] = arguments[i];
        listeners.fn.apply(listeners.context, args);
    } else {
        var length = listeners.length, j;
        for(i = 0; i < length; i++){
            if (listeners[i].once) this.removeListener(event, listeners[i].fn, undefined, true);
            switch(len){
                case 1:
                    listeners[i].fn.call(listeners[i].context);
                    break;
                case 2:
                    listeners[i].fn.call(listeners[i].context, a1);
                    break;
                case 3:
                    listeners[i].fn.call(listeners[i].context, a1, a2);
                    break;
                case 4:
                    listeners[i].fn.call(listeners[i].context, a1, a2, a3);
                    break;
                default:
                    if (!args) for(j = 1, args = new Array(len - 1); j < len; j++)args[j - 1] = arguments[j];
                    listeners[i].fn.apply(listeners[i].context, args);
            }
        }
    }
    return true;
};
/**
 * Add a listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */ $cee30b8789895425$var$EventEmitter.prototype.on = function on(event, fn, context) {
    return $cee30b8789895425$var$addListener(this, event, fn, context, false);
};
/**
 * Add a one-time listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */ $cee30b8789895425$var$EventEmitter.prototype.once = function once(event, fn, context) {
    return $cee30b8789895425$var$addListener(this, event, fn, context, true);
};
/**
 * Remove the listeners of a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn Only remove the listeners that match this function.
 * @param {*} context Only remove the listeners that have this context.
 * @param {Boolean} once Only remove one-time listeners.
 * @returns {EventEmitter} `this`.
 * @public
 */ $cee30b8789895425$var$EventEmitter.prototype.removeListener = function removeListener(event, fn, context, once) {
    var evt = $cee30b8789895425$var$prefix ? $cee30b8789895425$var$prefix + event : event;
    if (!this._events[evt]) return this;
    if (!fn) {
        $cee30b8789895425$var$clearEvent(this, evt);
        return this;
    }
    var listeners = this._events[evt];
    if (listeners.fn) {
        if (listeners.fn === fn && (!once || listeners.once) && (!context || listeners.context === context)) $cee30b8789895425$var$clearEvent(this, evt);
    } else {
        for(var i = 0, events = [], length = listeners.length; i < length; i++)if (listeners[i].fn !== fn || once && !listeners[i].once || context && listeners[i].context !== context) events.push(listeners[i]);
        //
        // Reset the array, or remove it completely if we have no more listeners.
        //
        if (events.length) this._events[evt] = events.length === 1 ? events[0] : events;
        else $cee30b8789895425$var$clearEvent(this, evt);
    }
    return this;
};
/**
 * Remove all listeners, or those of the specified event.
 *
 * @param {(String|Symbol)} [event] The event name.
 * @returns {EventEmitter} `this`.
 * @public
 */ $cee30b8789895425$var$EventEmitter.prototype.removeAllListeners = function removeAllListeners(event) {
    var evt;
    if (event) {
        evt = $cee30b8789895425$var$prefix ? $cee30b8789895425$var$prefix + event : event;
        if (this._events[evt]) $cee30b8789895425$var$clearEvent(this, evt);
    } else {
        this._events = new $cee30b8789895425$var$Events();
        this._eventsCount = 0;
    }
    return this;
};
//
// Alias methods names because people roll like that.
//
$cee30b8789895425$var$EventEmitter.prototype.off = $cee30b8789895425$var$EventEmitter.prototype.removeListener;
$cee30b8789895425$var$EventEmitter.prototype.addListener = $cee30b8789895425$var$EventEmitter.prototype.on;
//
// Expose the prefix.
//
$cee30b8789895425$var$EventEmitter.prefixed = $cee30b8789895425$var$prefix;
//
// Allow `EventEmitter` to be imported as module namespace.
//
$cee30b8789895425$var$EventEmitter.EventEmitter = $cee30b8789895425$var$EventEmitter;
module.exports = $cee30b8789895425$var$EventEmitter;

});


parcelRegister("bA77O", function(module, exports) {
$parcel$export(module.exports, "DynamicConfig", () => $86e895649208ddeb$export$6dc24881a3d96325);

var $ekGgq = parcelRequire("ekGgq");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $jGAYn = parcelRequire("jGAYn");
var $86e895649208ddeb$export$6dc24881a3d96325 = /*#__PURE__*/ function() {
    function DynamicConfig(configName, configValue, ruleID, evaluationDetails) {
        var secondaryExposures = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : [];
        var allocatedExperimentName = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : '';
        var onDefaultValueFallback = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : null;
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, DynamicConfig);
        this.value = configValue;
        this._name = configName;
        this._ruleID = ruleID;
        this._secondaryExposures = secondaryExposures;
        this._allocatedExperimentName = allocatedExperimentName;
        this._evaluationDetails = evaluationDetails;
        this._onDefaultValueFallback = onDefaultValueFallback;
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(DynamicConfig, [
        {
            key: "get",
            value: function get(key, defaultValue, typeGuard) {
                var _this$_onDefaultValue2;
                var val = this.getValue(key, defaultValue);
                if (val == null) return defaultValue;
                var expectedType = Array.isArray(defaultValue) ? 'array' : (0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(defaultValue);
                var actualType = Array.isArray(val) ? 'array' : (0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(val);
                if (typeGuard) {
                    var _this$_onDefaultValue;
                    if (typeGuard(val)) {
                        this.fireExposure(key);
                        return val;
                    }
                    (_this$_onDefaultValue = this._onDefaultValueFallback) === null || _this$_onDefaultValue === void 0 || _this$_onDefaultValue.call(this, this, key, expectedType, actualType);
                    return defaultValue;
                }
                if (defaultValue == null || expectedType === actualType) {
                    this.fireExposure(key);
                    return val;
                }
                (_this$_onDefaultValue2 = this._onDefaultValueFallback) === null || _this$_onDefaultValue2 === void 0 || _this$_onDefaultValue2.call(this, this, key, expectedType, actualType);
                return defaultValue;
            }
        },
        {
            key: "getValue",
            value: function getValue(key, defaultValue) {
                if (key == null) return this.value;
                if (defaultValue == null) defaultValue = null;
                if (this.value[key] == null) return defaultValue;
                this.fireExposure(key);
                return this.value[key];
            }
        },
        {
            key: "fireExposure",
            value: function fireExposure(key) {
                // Call the wrapped experiment's get method to fire exposure
                if (this.experiment) this.experiment.get(key);
            }
        }
    ], [
        {
            key: "fromExperiment",
            value: function fromExperiment(experiment) {
                var _experiment$__evaluat, _experiment$__evaluat2, _experiment$groupName;
                var config = new DynamicConfig(experiment.name, experiment.value, experiment.ruleID, (0, $jGAYn.migrateEvaluationDetails)(experiment.details), (0, $jGAYn.migrateSecondaryExposures)((_experiment$__evaluat = (_experiment$__evaluat2 = experiment.__evaluation) === null || _experiment$__evaluat2 === void 0 ? void 0 : _experiment$__evaluat2.secondary_exposures) !== null && _experiment$__evaluat !== void 0 ? _experiment$__evaluat : []), (_experiment$groupName = experiment.groupName) !== null && _experiment$groupName !== void 0 ? _experiment$groupName : undefined);
                config.experiment = experiment;
                return config;
            }
        }
    ]);
}();

});
parcelRegister("jGAYn", function(module, exports) {
$parcel$export(module.exports, "getOptionsWithDefaults", () => $e54e9e9d69b6dd52$export$d119b37e5f788b43);
$parcel$export(module.exports, "shallowEquals", () => $e54e9e9d69b6dd52$export$fa1c2bbf4100b8bc);
$parcel$export(module.exports, "toStatsigUser", () => $e54e9e9d69b6dd52$export$3dad1db244472f32);
$parcel$export(module.exports, "migrateInitializationOptions", () => $e54e9e9d69b6dd52$export$202946b690d26d22);
$parcel$export(module.exports, "migrateEvaluationDetails", () => $e54e9e9d69b6dd52$export$18ad168d3dbac899);
$parcel$export(module.exports, "migrateSecondaryExposures", () => $e54e9e9d69b6dd52$export$55fd683752d01e67);

var $1Vcia = parcelRequire("1Vcia");

var $iYJcE = parcelRequire("iYJcE");

var $25nEq = parcelRequire("25nEq");

var $ygbGG = parcelRequire("ygbGG");

var $icCTV = parcelRequire("icCTV");

var $cXGvu = parcelRequire("cXGvu");
var $e54e9e9d69b6dd52$var$_excluded = [
    "api",
    "disableCurrentPageLogging",
    "loggingIntervalMillis",
    "loggingBufferMaxSize",
    "localMode",
    "eventLoggingApi",
    "eventLoggingApiForRetries",
    "disableLocalStorage",
    "ignoreWindowUndefined",
    "disableAllLogging",
    "initTimeoutMs",
    "disableNetworkKeepalive",
    "overrideStableID",
    "disableErrorLogging",
    "disableAutoMetricsLogging"
];
function $e54e9e9d69b6dd52$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $e54e9e9d69b6dd52$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $e54e9e9d69b6dd52$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $e54e9e9d69b6dd52$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $e54e9e9d69b6dd52$export$d119b37e5f788b43 = function getOptionsWithDefaults(options) {
    return $e54e9e9d69b6dd52$var$_objectSpread({
        /**
     * If more federal PerimeterTypes are added in the future, this should be updated so
     * that isFedRamp() === true always returns the strictest perimeter.
     */ perimeter: (0, $ygbGG.isFedRamp)() ? (0, $cXGvu.PerimeterType).FEDRAMP_MODERATE : (0, $cXGvu.PerimeterType).COMMERCIAL
    }, options);
};
var $e54e9e9d69b6dd52$export$fa1c2bbf4100b8bc = function shallowEquals(objectA, objectB) {
    if (!objectA && !objectB) return true;
    if (!objectA || !objectB) return false;
    var aEntries = Object.entries(objectA);
    var bEntries = Object.entries(objectB);
    if (aEntries.length !== bEntries.length) return false;
    var ascendingKeyOrder = function ascendingKeyOrder(_ref, _ref2) {
        var _ref3 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_ref, 1), key1 = _ref3[0];
        var _ref4 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_ref2, 1), key2 = _ref4[0];
        return key1.localeCompare(key2);
    };
    aEntries.sort(ascendingKeyOrder);
    bEntries.sort(ascendingKeyOrder);
    for(var i = 0; i < aEntries.length; i++){
        var _aEntries$i = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(aEntries[i], 2), aValue = _aEntries$i[1];
        var _bEntries$i = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(bEntries[i], 2), bValue = _bEntries$i[1];
        if (aValue !== bValue) return false;
    }
    return true;
};
var $e54e9e9d69b6dd52$export$3dad1db244472f32 = function toStatsigUser(identifiers, customAttributes) {
    var user = {
        customIDs: identifiers,
        custom: customAttributes
    };
    if (identifiers.atlassianAccountId) user.userID = identifiers.atlassianAccountId;
    return user;
};
var $e54e9e9d69b6dd52$export$202946b690d26d22 = function migrateInitializationOptions(options) {
    var api = options.api, disableCurrentPageLogging = options.disableCurrentPageLogging, loggingIntervalMillis = options.loggingIntervalMillis, loggingBufferMaxSize = options.loggingBufferMaxSize, localMode = options.localMode, eventLoggingApi = options.eventLoggingApi, eventLoggingApiForRetries = options.eventLoggingApiForRetries, disableLocalStorage = options.disableLocalStorage, ignoreWindowUndefined = options.ignoreWindowUndefined, disableAllLogging = options.disableAllLogging, _initTimeoutMs = options.initTimeoutMs, _disableNetworkKeepalive = options.disableNetworkKeepalive, _overrideStableID = options.overrideStableID, _disableErrorLogging = options.disableErrorLogging, _disableAutoMetricsLogging = options.disableAutoMetricsLogging, rest = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(options, $e54e9e9d69b6dd52$var$_excluded);
    return $e54e9e9d69b6dd52$var$_objectSpread($e54e9e9d69b6dd52$var$_objectSpread({}, rest), {}, {
        networkConfig: {
            api: api,
            logEventUrl: eventLoggingApi ? eventLoggingApi + 'rgstr' : undefined,
            logEventFallbackUrls: eventLoggingApiForRetries ? [
                eventLoggingApiForRetries
            ] : undefined,
            preventAllNetworkTraffic: localMode || !ignoreWindowUndefined && typeof window === 'undefined'
        },
        includeCurrentPageUrlWithEvents: !disableCurrentPageLogging,
        loggingIntervalMs: loggingIntervalMillis,
        loggingBufferMaxSize: loggingBufferMaxSize,
        disableStorage: disableLocalStorage === undefined ? localMode : disableLocalStorage,
        disableLogging: disableAllLogging === undefined ? localMode : disableAllLogging
    });
};
var $e54e9e9d69b6dd52$var$evaluationReasonMappings = Object.entries((0, $icCTV.EvaluationReason)).map(function(_ref5) {
    var _ref6 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_ref5, 2), key = _ref6[0], value = _ref6[1];
    return [
        key.toLowerCase(),
        value
    ];
});
var $e54e9e9d69b6dd52$export$18ad168d3dbac899 = function migrateEvaluationDetails(details) {
    var _evaluationReasonMapp, _evaluationReasonMapp2, _details$receivedAt;
    var reasonLower = details.reason.toLowerCase();
    return {
        reason: (_evaluationReasonMapp = (_evaluationReasonMapp2 = $e54e9e9d69b6dd52$var$evaluationReasonMappings.find(function(_ref7) {
            var _ref8 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_ref7, 1), key = _ref8[0];
            return reasonLower.includes(key);
        })) === null || _evaluationReasonMapp2 === void 0 ? void 0 : _evaluationReasonMapp2[1]) !== null && _evaluationReasonMapp !== void 0 ? _evaluationReasonMapp : (0, $icCTV.EvaluationReason).Unknown,
        time: (_details$receivedAt = details.receivedAt) !== null && _details$receivedAt !== void 0 ? _details$receivedAt : Date.now()
    };
};
var $e54e9e9d69b6dd52$export$55fd683752d01e67 = function migrateSecondaryExposures(secondaryExposures) {
    return secondaryExposures.map(function(exposure) {
        if (typeof exposure === 'string') // This should ideally have gateValue and ruleID fields too, but it's not possible for us
        // to determine the correct values for these.
        return {
            gate: exposure
        };
        return exposure;
    });
};

});
parcelRegister("ygbGG", function(module, exports) {
$parcel$export(module.exports, "isFedRamp", () => $066fbb979700de6b$export$64d6499adf9b2e51);

var $cThmQ = parcelRequire("cThmQ");
function $066fbb979700de6b$export$64d6499adf9b2e51() {
    var _global$location;
    var global = globalThis;
    // MICROS_PERIMETER is already used by few products, so we need to keep it for backward compatibility
    var env = global.MICROS_PERIMETER || global.UNSAFE_ATL_CONTEXT_BOUNDARY;
    if (env) return env === (0, $cThmQ.FEDRAMP_MODERATE);
    var matches = (_global$location = global.location) === null || _global$location === void 0 || (_global$location = _global$location.hostname) === null || _global$location === void 0 ? void 0 : _global$location.match(/atlassian-us-gov-mod\.(com|net)|atlassian-us-gov\.(com|net)|atlassian-fex\.(com|net)|atlassian-stg-fedm\.(com|net)/);
    return matches ? matches.length > 0 : false;
}

});
parcelRegister("cThmQ", function(module, exports) {
$parcel$export(module.exports, "FEDRAMP_MODERATE", () => $962817e776c3bc68$export$ce553301d55c2fd8);
$parcel$export(module.exports, "COMMERCIAL", () => $962817e776c3bc68$export$f005e2e9f707cb5f);
$parcel$export(module.exports, "FEDRAMP_FEDEX", () => $962817e776c3bc68$export$bd6b5a7802d76127);
$parcel$export(module.exports, "STAGING", () => $962817e776c3bc68$export$a739cd5aac835909);
$parcel$export(module.exports, "PRODUCTION", () => $962817e776c3bc68$export$42dd0cdd351a4a9);
$parcel$export(module.exports, "DEV", () => $962817e776c3bc68$export$404582bc18fe4d9e);
var $962817e776c3bc68$export$ce553301d55c2fd8 = 'fedramp-moderate';
var $962817e776c3bc68$export$f005e2e9f707cb5f = 'commercial';
var $962817e776c3bc68$export$bd6b5a7802d76127 = 'fedramp-fedex';
var $962817e776c3bc68$export$a739cd5aac835909 = 'stg';
var $962817e776c3bc68$export$42dd0cdd351a4a9 = 'prod';
var $962817e776c3bc68$export$404582bc18fe4d9e = 'dev';

});


parcelRegister("icCTV", function(module, exports) {
$parcel$export(module.exports, "EvaluationReason", () => $d40785e450291118$export$c62558b199e46828);
// Reference: https://github.com/statsig-io/js-lite/blob/main/src/StatsigStore.ts
var $d40785e450291118$export$c62558b199e46828 = /*#__PURE__*/ function(EvaluationReason) {
    // Order is important since the logic for migrating from a new client reason to an old one
    // returns the first which is a substring of the new client reason
    EvaluationReason["Error"] = "Error";
    EvaluationReason["LocalOverride"] = "LocalOverride";
    EvaluationReason["Unrecognized"] = "Unrecognized";
    EvaluationReason["Uninitialized"] = "Uninitialized";
    EvaluationReason["NetworkNotModified"] = "NetworkNotModified";
    EvaluationReason["Network"] = "Network";
    EvaluationReason["InvalidBootstrap"] = "InvalidBootstrap";
    EvaluationReason["Bootstrap"] = "Bootstrap";
    EvaluationReason["Cache"] = "Cache";
    // For when we could not migrate the reason from the new client
    EvaluationReason["Unknown"] = "Unknown";
    return EvaluationReason;
}({}); // Reference: https://github.com/statsig-io/js-lite/blob/main/src/StatsigSDKOptions.ts

});

parcelRegister("cXGvu", function(module, exports) {
$parcel$export(module.exports, "FeatureGateEnvironment", () => $96fbf7b5c7e04efa$export$479e7351a733299);
$parcel$export(module.exports, "PerimeterType", () => $96fbf7b5c7e04efa$export$c42b7bbc5e7ba555);
/**
 * The identifiers for the user. Options are restricted to the set that is currently supported.
 */ /**
 * Base client options. Does not include any options specific to providers
 * @interface BaseClientOptions
 * @property {FeatureGateEnvironment} environment - The environment for the client.
 * @property {string} targetApp - The target app for the client.
 * @property {AnalyticsWebClient} analyticsWebClient - The analytics web client.
 * @property {PerimeterType} perimeter - The perimeter for the client.
 */ /**
 * The options for the client.
 * @interface ClientOptions
 * @extends {BaseClientOptions}
 * @property {string} apiKey - The API key for the client.
 * @property {fetchTimeoutMs} fetchTimeoutMs - The timeout for the fetch request in milliseconds. Defaults to 5000.
 * @property {boolean} useGatewayURL - Whether to use the gateway URL. Defaults to false.
 */ /**
 * The custom attributes for the user.
 */ var $96fbf7b5c7e04efa$export$479e7351a733299 = /*#__PURE__*/ function(FeatureGateEnvironment) {
    FeatureGateEnvironment["Development"] = "development";
    FeatureGateEnvironment["Staging"] = "staging";
    FeatureGateEnvironment["Production"] = "production";
    return FeatureGateEnvironment;
}({});
var $96fbf7b5c7e04efa$export$c42b7bbc5e7ba555 = /*#__PURE__*/ function(PerimeterType) {
    PerimeterType["COMMERCIAL"] = "commercial";
    PerimeterType["FEDRAMP_MODERATE"] = "fedramp-moderate";
    return PerimeterType;
}({});
var $96fbf7b5c7e04efa$export$42f4885608027d0c = 'non_boolean'; // Type magic to get the JSDoc comments from the Client class methods to appear on the static
 // methods in FeatureGates where the property name and function type are identical

});



parcelRegister("gFo6M", function(module, exports) {
$parcel$export(module.exports, "Layer", () => $c2232d11a9592b0d$export$936d0764594b6eb3);

var $ekGgq = parcelRequire("ekGgq");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $jGAYn = parcelRequire("jGAYn");
var $c2232d11a9592b0d$export$936d0764594b6eb3 = /*#__PURE__*/ function() {
    function Layer(name, layerValue, ruleID, evaluationDetails) {
        var logParameterFunction = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
        var secondaryExposures = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : [];
        var undelegatedSecondaryExposures = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : [];
        var allocatedExperimentName = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : '';
        var explicitParameters = arguments.length > 8 && arguments[8] !== undefined ? arguments[8] : [];
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, Layer);
        this._logParameterFunction = logParameterFunction;
        this._name = name;
        this._value = JSON.parse(JSON.stringify(layerValue !== null && layerValue !== void 0 ? layerValue : {}));
        this._ruleID = ruleID !== null && ruleID !== void 0 ? ruleID : '';
        this._evaluationDetails = evaluationDetails;
        this._secondaryExposures = secondaryExposures;
        this._undelegatedSecondaryExposures = undelegatedSecondaryExposures;
        this._allocatedExperimentName = allocatedExperimentName;
        this._explicitParameters = explicitParameters;
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(Layer, [
        {
            key: "get",
            value: function get(key, defaultValue, typeGuard) {
                var _this = this;
                var val = this._value[key];
                if (val == null) return defaultValue;
                var logAndReturn = function logAndReturn() {
                    _this._logLayerParameterExposure(key);
                    return val;
                };
                if (typeGuard) return typeGuard(val) ? logAndReturn() : defaultValue;
                if (defaultValue == null) return logAndReturn();
                if ((0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(val) === (0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(defaultValue) && Array.isArray(defaultValue) === Array.isArray(val)) return logAndReturn();
                return defaultValue;
            }
        },
        {
            key: "getValue",
            value: function getValue(key, defaultValue) {
                // eslint-disable-next-line eqeqeq
                if (defaultValue == undefined) defaultValue = null;
                var val = this._value[key];
                if (val != null) this._logLayerParameterExposure(key);
                return val !== null && val !== void 0 ? val : defaultValue;
            }
        },
        {
            key: "_logLayerParameterExposure",
            value: function _logLayerParameterExposure(parameterName) {
                var _this$_logParameterFu;
                (_this$_logParameterFu = this._logParameterFunction) === null || _this$_logParameterFu === void 0 || _this$_logParameterFu.call(this, this, parameterName);
            }
        }
    ], [
        {
            key: "fromLayer",
            value: function fromLayer(layer) {
                var _layer$__evaluation$s, _layer$__evaluation, _layer$__evaluation$u, _layer$__evaluation2, _layer$__evaluation3, _layer$__evaluation4;
                var value = new Layer(layer.name, layer.__value, layer.ruleID, (0, $jGAYn.migrateEvaluationDetails)(layer.details), function(_layer, parameterName) {
                    return layer.get(parameterName);
                }, (0, $jGAYn.migrateSecondaryExposures)((_layer$__evaluation$s = (_layer$__evaluation = layer.__evaluation) === null || _layer$__evaluation === void 0 ? void 0 : _layer$__evaluation.secondary_exposures) !== null && _layer$__evaluation$s !== void 0 ? _layer$__evaluation$s : []), (0, $jGAYn.migrateSecondaryExposures)((_layer$__evaluation$u = (_layer$__evaluation2 = layer.__evaluation) === null || _layer$__evaluation2 === void 0 ? void 0 : _layer$__evaluation2.undelegated_secondary_exposures) !== null && _layer$__evaluation$u !== void 0 ? _layer$__evaluation$u : []), (_layer$__evaluation3 = layer.__evaluation) === null || _layer$__evaluation3 === void 0 ? void 0 : _layer$__evaluation3.allocated_experiment_name, (_layer$__evaluation4 = layer.__evaluation) === null || _layer$__evaluation4 === void 0 ? void 0 : _layer$__evaluation4.explicit_parameters);
                return value;
            }
        }
    ]);
}();

});

parcelRegister("f9px2", function(module, exports) {
$parcel$export(module.exports, "default", () => $b07b8065f46b75ac$export$2e2bcd8739ae039);

var $25nEq = parcelRequire("25nEq");

var $fL8KA = parcelRequire("fL8KA");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $6HG4S = parcelRequire("6HG4S");

var $cXGvu = parcelRequire("cXGvu");

var $6WhoI = parcelRequire("6WhoI");

var $5otRh = parcelRequire("5otRh");
function $b07b8065f46b75ac$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $b07b8065f46b75ac$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $b07b8065f46b75ac$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $b07b8065f46b75ac$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $b07b8065f46b75ac$var$DEFAULT_REQUEST_TIMEOUT_MS = 5000;
var $b07b8065f46b75ac$export$250a58ecde616daa = 'https://api.atlassian.com/flags';
var $b07b8065f46b75ac$export$942ba04389b0d5a2 = 'https://api.stg.atlassian.com/flags';
var $b07b8065f46b75ac$export$f058dbf75c3bc647 = 'https://api.dev.atlassian.com/flags';
var $b07b8065f46b75ac$export$1a401a0da8da3565 = 'https://api.stg.atlassian-us-gov-mod.com/flags';
var $b07b8065f46b75ac$export$18c93900db9358a4 = 'https://api.atlassian-us-gov-mod.com/flags';
var $b07b8065f46b75ac$export$4e8a0415edbfa1f7 = 'https://atlassian-statsig-proxy-archetype.atl-paas.%s.atl-ic.net';
var $b07b8065f46b75ac$export$cb3cd156f70d7e94 = 'oasis-stg.com/flags';
var $b07b8065f46b75ac$export$921fbc6cdfd4eee0 = 'atlassian-isolated.net/flags';
var $b07b8065f46b75ac$export$450bd8fb2a6d7ace = '/gateway/api/flags';
var $b07b8065f46b75ac$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function Fetcher() {
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, Fetcher);
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(Fetcher, null, [
        {
            key: "fetchClientSdk",
            value: function() {
                var _fetchClientSdk = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee(fetcherOptions) {
                    var targetApp, url;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee$(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                targetApp = fetcherOptions.targetApp;
                                url = "/api/v2/frontend/clientSdkKey/".concat(targetApp);
                                _context.prev = 2;
                                _context.next = 5;
                                return this.fetchRequest(url, 'GET', fetcherOptions);
                            case 5:
                                return _context.abrupt("return", _context.sent);
                            case 8:
                                _context.prev = 8;
                                _context.t0 = _context["catch"](2);
                                if (!(_context.t0 instanceof Error)) {
                                    _context.next = 12;
                                    break;
                                }
                                throw _context.t0;
                            case 12:
                                throw Error('Failed to retrieve client sdk key');
                            case 13:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee, this, [
                        [
                            2,
                            8
                        ]
                    ]);
                }));
                function fetchClientSdk(_x) {
                    return _fetchClientSdk.apply(this, arguments);
                }
                return fetchClientSdk;
            }()
        },
        {
            key: "fetchExperimentValues",
            value: function() {
                var _fetchExperimentValues = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee2(fetcherOptions, identifiers, customAttributes) {
                    var requestBody;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee2$(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                requestBody = {
                                    identifiers: identifiers,
                                    customAttributes: customAttributes,
                                    targetApp: fetcherOptions.targetApp
                                };
                                _context2.prev = 1;
                                _context2.next = 4;
                                return this.fetchRequest('/api/v2/frontend/experimentValues', 'POST', fetcherOptions, requestBody);
                            case 4:
                                return _context2.abrupt("return", _context2.sent);
                            case 7:
                                _context2.prev = 7;
                                _context2.t0 = _context2["catch"](1);
                                if (!(_context2.t0 instanceof Error)) {
                                    _context2.next = 11;
                                    break;
                                }
                                throw _context2.t0;
                            case 11:
                                throw Error('Failed to retrieve experiment values');
                            case 12:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2, this, [
                        [
                            1,
                            7
                        ]
                    ]);
                }));
                function fetchExperimentValues(_x2, _x3, _x4) {
                    return _fetchExperimentValues.apply(this, arguments);
                }
                return fetchExperimentValues;
            }()
        },
        {
            key: "handleResponseError",
            value: function() {
                var _handleResponseError = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee3(response) {
                    var body;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee3$(_context3) {
                        while(true)switch(_context3.prev = _context3.next){
                            case 0:
                                if (response.ok) {
                                    _context3.next = 5;
                                    break;
                                }
                                _context3.next = 3;
                                return response.text();
                            case 3:
                                body = _context3.sent;
                                throw new (0, $5otRh.ResponseError)("Non 2xx response status received, status: ".concat(response.status, ", body: ").concat(JSON.stringify(body)));
                            case 5:
                                if (!(response.status === 204)) {
                                    _context3.next = 7;
                                    break;
                                }
                                throw new (0, $5otRh.ResponseError)('Unexpected 204 response');
                            case 7:
                            case "end":
                                return _context3.stop();
                        }
                    }, _callee3);
                }));
                function handleResponseError(_x5) {
                    return _handleResponseError.apply(this, arguments);
                }
                return handleResponseError;
            }()
        },
        {
            key: "extractResponseBody",
            value: function() {
                var _extractResponseBody = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee4(response) {
                    var value;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee4$(_context4) {
                        while(true)switch(_context4.prev = _context4.next){
                            case 0:
                                _context4.next = 2;
                                return response.text();
                            case 2:
                                value = _context4.sent;
                                return _context4.abrupt("return", JSON.parse(value));
                            case 4:
                            case "end":
                                return _context4.stop();
                        }
                    }, _callee4);
                }));
                function extractResponseBody(_x6) {
                    return _extractResponseBody.apply(this, arguments);
                }
                return extractResponseBody;
            }()
        },
        {
            key: "getBaseUrl",
            value: function getBaseUrl(serviceEnv) {
                var useGatewayUrl = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
                var perimeter = arguments.length > 2 ? arguments[2] : undefined;
                var isolationContextId = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
                if (useGatewayUrl) return $b07b8065f46b75ac$export$450bd8fb2a6d7ace;
                if (perimeter === (0, $cXGvu.PerimeterType).FEDRAMP_MODERATE) switch(serviceEnv){
                    case (0, $cXGvu.FeatureGateEnvironment).Production:
                        return $b07b8065f46b75ac$export$18c93900db9358a4;
                    case (0, $cXGvu.FeatureGateEnvironment).Staging:
                        return $b07b8065f46b75ac$export$1a401a0da8da3565;
                    default:
                        throw new Error("Invalid environment \"".concat(serviceEnv, "\" for \"").concat(perimeter, "\" perimeter"));
                }
                else if (perimeter === (0, $cXGvu.PerimeterType).COMMERCIAL) switch(serviceEnv){
                    case (0, $cXGvu.FeatureGateEnvironment).Development:
                        return $b07b8065f46b75ac$export$f058dbf75c3bc647;
                    case (0, $cXGvu.FeatureGateEnvironment).Staging:
                        var apiUrl = this.getApiUrl(isolationContextId);
                        if (apiUrl !== null) return apiUrl;
                        return $b07b8065f46b75ac$export$942ba04389b0d5a2;
                    default:
                        var prodApiUrl = this.getApiUrl(isolationContextId);
                        if (prodApiUrl !== null) return prodApiUrl;
                        return $b07b8065f46b75ac$export$250a58ecde616daa;
                }
                else throw new Error("Invalid perimeter \"".concat(perimeter, "\""));
            }
        },
        {
            key: "fetchRequest",
            value: function() {
                var _fetchRequest = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee5(path, method, fetcherOptions, body) {
                    var baseUrl, fetchTimeout, abortSignal, abortController, response;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee5$(_context5) {
                        while(true)switch(_context5.prev = _context5.next){
                            case 0:
                                baseUrl = Fetcher.getBaseUrl(fetcherOptions.environment, fetcherOptions.useGatewayURL, fetcherOptions.perimeter, fetcherOptions.isolationContextId);
                                fetchTimeout = fetcherOptions.fetchTimeoutMs || $b07b8065f46b75ac$var$DEFAULT_REQUEST_TIMEOUT_MS;
                                if (AbortSignal.timeout) abortSignal = AbortSignal.timeout(fetchTimeout);
                                else if (AbortController) {
                                    abortController = new AbortController();
                                    abortSignal = abortController.signal;
                                    setTimeout(function() {
                                        return abortController.abort();
                                    }, fetchTimeout);
                                }
                                _context5.next = 5;
                                return fetch("".concat(baseUrl).concat(path), $b07b8065f46b75ac$var$_objectSpread({
                                    method: method,
                                    headers: {
                                        'Content-Type': 'application/json',
                                        'X-Client-Name': 'feature-gate-js-client',
                                        'X-Client-Version': (0, $6WhoI.CLIENT_VERSION),
                                        'X-API-KEY': fetcherOptions.apiKey
                                    },
                                    signal: abortSignal
                                }, body && {
                                    body: JSON.stringify(body)
                                }));
                            case 5:
                                response = _context5.sent;
                                _context5.next = 8;
                                return this.handleResponseError(response);
                            case 8:
                                _context5.next = 10;
                                return this.extractResponseBody(response);
                            case 10:
                                return _context5.abrupt("return", _context5.sent);
                            case 11:
                            case "end":
                                return _context5.stop();
                        }
                    }, _callee5, this);
                }));
                function fetchRequest(_x7, _x8, _x9, _x0) {
                    return _fetchRequest.apply(this, arguments);
                }
                return fetchRequest;
            }()
        },
        {
            key: "getApiUrl",
            value: function getApiUrl(isolationContextId) {
                var window1 = this.getWindowLocation();
                if (window1 === undefined) {
                    //this is needed when this SDK is used for SSR or plugin use cases where secret keys not available to use backend SDKs
                    if (!isolationContextId) return null;
                    return $b07b8065f46b75ac$export$4e8a0415edbfa1f7.replace('%s', isolationContextId);
                }
                var protocol = window1.protocol, hostname = window1.hostname;
                // Match last subdomain fragment before oasis-stg.com
                var oasisMatch = hostname.match(/([^.]+)\.oasis-stg\.com$/);
                if (oasisMatch) return "".concat(protocol, "//api.").concat(oasisMatch[1], ".").concat($b07b8065f46b75ac$export$cb3cd156f70d7e94);
                // Match last subdomain fragment before atlassian-isolated.net
                var isolatedMatch = hostname.match(/([^.]+)\.atlassian-isolated\.net$/);
                if (isolatedMatch) return "".concat(protocol, "//api.").concat(isolatedMatch[1], ".").concat($b07b8065f46b75ac$export$921fbc6cdfd4eee0);
                return null;
            }
        },
        {
            key: "getWindowLocation",
            value: function getWindowLocation() {
                if (typeof window !== 'undefined' && window.location) return window.location;
                return undefined;
            }
        }
    ]);
}();

});
parcelRegister("6WhoI", function(module, exports) {
$parcel$export(module.exports, "CLIENT_VERSION", () => $50d5a7aca1523610$export$a59f8d67326bd1cb);
/// <reference types="node" />
var $50d5a7aca1523610$export$a59f8d67326bd1cb = "0.0.0-development";

});

parcelRegister("5otRh", function(module, exports) {
$parcel$export(module.exports, "ResponseError", () => $3ed65ae992f0316e$export$286baf652d0b1206);

var $arMYe = parcelRequire("arMYe");

var $9P61R = parcelRequire("9P61R");

var $kIXpt = parcelRequire("kIXpt");

var $cYPzS = parcelRequire("cYPzS");

var $eyuDe = parcelRequire("eyuDe");

var $c7s0H = parcelRequire("c7s0H");
function $3ed65ae992f0316e$var$_callSuper(t, o, e) {
    return o = (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(o), (0, (/*@__PURE__*/$parcel$interopDefault($kIXpt)))(t, $3ed65ae992f0316e$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(t).constructor) : o.apply(t, e));
}
function $3ed65ae992f0316e$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($3ed65ae992f0316e$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $3ed65ae992f0316e$export$286baf652d0b1206 = /*#__PURE__*/ function(_Error) {
    function ResponseError(message) {
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, ResponseError);
        return $3ed65ae992f0316e$var$_callSuper(this, ResponseError, [
            message
        ]);
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($eyuDe)))(ResponseError, _Error);
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(ResponseError);
}(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($c7s0H)))(Error));

});
parcelRegister("kIXpt", function(module, exports) {

var $ekGgq = parcelRequire("ekGgq");
var $f1660048948b9f64$var$_typeof = $ekGgq.default;

var $ilz08 = parcelRequire("ilz08");
function $f1660048948b9f64$var$_possibleConstructorReturn(t, e) {
    if (e && ("object" == $f1660048948b9f64$var$_typeof(e) || "function" == typeof e)) return e;
    if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
    return $ilz08(t);
}
module.exports = $f1660048948b9f64$var$_possibleConstructorReturn, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("ilz08", function(module, exports) {
function $d5b556b08c8aee39$var$_assertThisInitialized(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}
module.exports = $d5b556b08c8aee39$var$_assertThisInitialized, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("cYPzS", function(module, exports) {
function $973318e0cb84a68c$var$_getPrototypeOf(t) {
    return module.exports = $973318e0cb84a68c$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
        return t.__proto__ || Object.getPrototypeOf(t);
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $973318e0cb84a68c$var$_getPrototypeOf(t);
}
module.exports = $973318e0cb84a68c$var$_getPrototypeOf, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("eyuDe", function(module, exports) {

var $aMsoM = parcelRequire("aMsoM");
function $a98c007cb7076ed5$var$_inherits(t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
    t.prototype = Object.create(e && e.prototype, {
        constructor: {
            value: t,
            writable: !0,
            configurable: !0
        }
    }), Object.defineProperty(t, "prototype", {
        writable: !1
    }), e && $aMsoM(t, e);
}
module.exports = $a98c007cb7076ed5$var$_inherits, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("aMsoM", function(module, exports) {
function $7d946a7286a692c7$var$_setPrototypeOf(t, e) {
    return module.exports = $7d946a7286a692c7$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $7d946a7286a692c7$var$_setPrototypeOf(t, e);
}
module.exports = $7d946a7286a692c7$var$_setPrototypeOf, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("c7s0H", function(module, exports) {

var $cYPzS = parcelRequire("cYPzS");

var $aMsoM = parcelRequire("aMsoM");

var $eBlTh = parcelRequire("eBlTh");

var $lyIwl = parcelRequire("lyIwl");
function $8d2bddb8428cdada$var$_wrapNativeSuper(t) {
    var r = "function" == typeof Map ? new Map() : void 0;
    return module.exports = $8d2bddb8428cdada$var$_wrapNativeSuper = function _wrapNativeSuper(t) {
        if (null === t || !$eBlTh(t)) return t;
        if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function");
        if (void 0 !== r) {
            if (r.has(t)) return r.get(t);
            r.set(t, Wrapper);
        }
        function Wrapper() {
            return $lyIwl(t, arguments, $cYPzS(this).constructor);
        }
        return Wrapper.prototype = Object.create(t.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: !1,
                writable: !0,
                configurable: !0
            }
        }), $aMsoM(Wrapper, t);
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $8d2bddb8428cdada$var$_wrapNativeSuper(t);
}
module.exports = $8d2bddb8428cdada$var$_wrapNativeSuper, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("eBlTh", function(module, exports) {
function $aa15806f3ef01ea8$var$_isNativeFunction(t) {
    try {
        return -1 !== Function.toString.call(t).indexOf("[native code]");
    } catch (n) {
        return "function" == typeof t;
    }
}
module.exports = $aa15806f3ef01ea8$var$_isNativeFunction, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("lyIwl", function(module, exports) {

var $agUgE = parcelRequire("agUgE");

var $aMsoM = parcelRequire("aMsoM");
function $fb1f4ecffe144cb9$var$_construct(t, e, r) {
    if ($agUgE()) return Reflect.construct.apply(null, arguments);
    var o = [
        null
    ];
    o.push.apply(o, e);
    var p = new (t.bind.apply(t, o))();
    return r && $aMsoM(p, r.prototype), p;
}
module.exports = $fb1f4ecffe144cb9$var$_construct, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("agUgE", function(module, exports) {
function $77a70b912f3fa5ba$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return (module.exports = $77a70b912f3fa5ba$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports)();
}
module.exports = $77a70b912f3fa5ba$var$_isNativeReflectConstruct, module.exports.__esModule = true, module.exports["default"] = module.exports;

});





parcelRegister("5MYIV", function(module, exports) {
$parcel$export(module.exports, "NoFetchDataAdapter", () => $437089ddf0a30c62$export$55fffef3474104af);

var $fL8KA = parcelRequire("fL8KA");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $kIXpt = parcelRequire("kIXpt");

var $cYPzS = parcelRequire("cYPzS");

var $lwlXp = parcelRequire("lwlXp");

var $eyuDe = parcelRequire("eyuDe");

var $25nEq = parcelRequire("25nEq");

var $6HG4S = parcelRequire("6HG4S");

var $iFR7a = parcelRequire("iFR7a");
function $437089ddf0a30c62$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $437089ddf0a30c62$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $437089ddf0a30c62$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $437089ddf0a30c62$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $437089ddf0a30c62$var$_callSuper(t, o, e) {
    return o = (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(o), (0, (/*@__PURE__*/$parcel$interopDefault($kIXpt)))(t, $437089ddf0a30c62$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(t).constructor) : o.apply(t, e));
}
function $437089ddf0a30c62$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($437089ddf0a30c62$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $437089ddf0a30c62$var$_superPropGet(t, o, e, r) {
    var p = (0, (/*@__PURE__*/$parcel$interopDefault($lwlXp)))((0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(1 & r ? t.prototype : t), o, e);
    return 2 & r && "function" == typeof p ? function(t) {
        return p.apply(e, t);
    } : p;
}
var $437089ddf0a30c62$export$55fffef3474104af = /*#__PURE__*/ function(_DataAdapterCore) {
    function NoFetchDataAdapter() {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, NoFetchDataAdapter);
        _this = $437089ddf0a30c62$var$_callSuper(this, NoFetchDataAdapter, [
            'NoFetchDataAdapter',
            'nofetch'
        ]);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "bootstrapResult", null);
        return _this;
    }
    /**
   * Make sure to call this **before** calling `initializeAsync` or `updateUserAsync` but
   * after the Statsig client has been created!
   */ (0, (/*@__PURE__*/$parcel$interopDefault($eyuDe)))(NoFetchDataAdapter, _DataAdapterCore);
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(NoFetchDataAdapter, [
        {
            key: "setBootstrapData",
            value: function setBootstrapData(data) {
                this.bootstrapResult = data ? {
                    source: 'Bootstrap',
                    data: JSON.stringify(data),
                    receivedAt: Date.now(),
                    stableID: (0, $iFR7a.StableID).get(this._getSdkKey()),
                    fullUserHash: null
                } : null;
            }
        },
        {
            key: "prefetchData",
            value: function() {
                var _prefetchData = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee(_user, _options) {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee$(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee);
                }));
                function prefetchData(_x, _x2) {
                    return _prefetchData.apply(this, arguments);
                }
                return prefetchData;
            }()
        },
        {
            key: "getDataAsync",
            value: function() {
                var _getDataAsync = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee2(_current, user, _options) {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee2$(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                return _context2.abrupt("return", this.bootstrapResult && $437089ddf0a30c62$var$_objectSpread($437089ddf0a30c62$var$_objectSpread({}, this.bootstrapResult), {}, {
                                    fullUserHash: (0, $iFR7a._getFullUserHash)(user)
                                }));
                            case 1:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2, this);
                }));
                function getDataAsync(_x3, _x4, _x5) {
                    return _getDataAsync.apply(this, arguments);
                }
                return getDataAsync;
            }()
        },
        {
            key: "getDataSync",
            value: function getDataSync(user) {
                return this.bootstrapResult && $437089ddf0a30c62$var$_objectSpread($437089ddf0a30c62$var$_objectSpread({}, this.bootstrapResult), {}, {
                    fullUserHash: (0, $iFR7a._getFullUserHash)(user)
                });
            }
        },
        {
            key: "_fetchFromNetwork",
            value: function() {
                var _fetchFromNetwork2 = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee3(_current, _user, _options) {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee3$(_context3) {
                        while(true)switch(_context3.prev = _context3.next){
                            case 0:
                                return _context3.abrupt("return", null);
                            case 1:
                            case "end":
                                return _context3.stop();
                        }
                    }, _callee3);
                }));
                function _fetchFromNetwork(_x6, _x7, _x8) {
                    return _fetchFromNetwork2.apply(this, arguments);
                }
                return _fetchFromNetwork;
            }()
        },
        {
            key: "_getCacheKey",
            value: function _getCacheKey(user) {
                // Same logic as default data adapter
                // https://github.com/statsig-io/js-client-monorepo/blob/main/packages/js-client/src/StatsigEvaluationsDataAdapter.ts
                var key = (0, $iFR7a._getStorageKey)(this._getSdkKey(), user);
                return "".concat((0, $iFR7a.DataAdapterCachePrefix), ".").concat(this._cacheSuffix, ".").concat(key);
            }
        },
        {
            key: "_isCachedResultValidFor204",
            value: function _isCachedResultValidFor204(_result, _user) {
                return false;
            }
        },
        {
            key: "setDataLegacy",
            value: function setDataLegacy(data, user) {
                $437089ddf0a30c62$var$_superPropGet(NoFetchDataAdapter, "setData", this, 3)([
                    data,
                    user
                ]);
            }
        },
        {
            key: "toJSON",
            value: function toJSON() {
                var result = $437089ddf0a30c62$var$_objectSpread({}, this);
                delete result._options;
                delete result._inMemoryCache;
                delete result.bootstrapResult;
                return result;
            }
        }
    ]);
}((0, $iFR7a.DataAdapterCore));

});
parcelRegister("lwlXp", function(module, exports) {

var $6HP01 = parcelRequire("6HP01");
function $faad9e602d30b37d$var$_get() {
    return module.exports = $faad9e602d30b37d$var$_get = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function(e, t, r) {
        var p = $6HP01(e, t);
        if (p) {
            var n = Object.getOwnPropertyDescriptor(p, t);
            return n.get ? n.get.call(arguments.length < 3 ? e : r) : n.value;
        }
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $faad9e602d30b37d$var$_get.apply(null, arguments);
}
module.exports = $faad9e602d30b37d$var$_get, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("6HP01", function(module, exports) {

var $cYPzS = parcelRequire("cYPzS");
function $4e1e51a03226bd6a$var$_superPropBase(t, o) {
    for(; !({}).hasOwnProperty.call(t, o) && null !== (t = $cYPzS(t)););
    return t;
}
module.exports = $4e1e51a03226bd6a$var$_superPropBase, module.exports.__esModule = true, module.exports["default"] = module.exports;

});



parcelRegister("80LFe", function(module, exports) {
$parcel$export(module.exports, "LOCAL_STORAGE_KEY", () => $5d534bea4a687e8a$export$d8474cff104280f3);
$parcel$export(module.exports, "PersistentOverrideAdapter", () => $5d534bea4a687e8a$export$bcb28fbac1def494);

var $25nEq = parcelRequire("25nEq");

var $iYJcE = parcelRequire("iYJcE");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $dtn6l = parcelRequire("dtn6l");
function $5d534bea4a687e8a$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $5d534bea4a687e8a$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $5d534bea4a687e8a$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $5d534bea4a687e8a$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $5d534bea4a687e8a$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $5d534bea4a687e8a$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $5d534bea4a687e8a$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $5d534bea4a687e8a$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $5d534bea4a687e8a$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $5d534bea4a687e8a$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
var $5d534bea4a687e8a$var$LOCAL_OVERRIDE_REASON = 'LocalOverride:Recognized';
var $5d534bea4a687e8a$export$d8474cff104280f3 = 'STATSIG_OVERRIDES';
var $5d534bea4a687e8a$var$LEGACY_LOCAL_STORAGE_KEY = 'STATSIG_JS_LITE_LOCAL_OVERRIDES';
var $5d534bea4a687e8a$var$makeEmptyStore = function makeEmptyStore() {
    return {
        gates: {},
        configs: {},
        layers: {}
    };
};
var $5d534bea4a687e8a$var$djb2MapKey = function djb2MapKey(hash, kind) {
    return kind + ':' + hash;
};
var $5d534bea4a687e8a$export$bcb28fbac1def494 = /*#__PURE__*/ function() {
    function PersistentOverrideAdapter(localStorageKey) {
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, PersistentOverrideAdapter);
        this._overrides = $5d534bea4a687e8a$var$makeEmptyStore();
        this._djb2Map = new Map();
        this._localStorageKey = localStorageKey;
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(PersistentOverrideAdapter, [
        {
            key: "parseStoredOverrides",
            value: function parseStoredOverrides(localStorageKey) {
                try {
                    var json = window.localStorage.getItem(localStorageKey);
                    if (!json) return $5d534bea4a687e8a$var$makeEmptyStore();
                    return JSON.parse(json);
                } catch (_unused) {
                    return $5d534bea4a687e8a$var$makeEmptyStore();
                }
            }
        },
        {
            key: "mergeOverrides",
            value: function mergeOverrides() {
                var merged = $5d534bea4a687e8a$var$makeEmptyStore();
                for(var _len = arguments.length, allOverrides = new Array(_len), _key = 0; _key < _len; _key++)allOverrides[_key] = arguments[_key];
                for(var _i = 0, _allOverrides = allOverrides; _i < _allOverrides.length; _i++){
                    var overrides = _allOverrides[_i];
                    for(var _i2 = 0, _Object$entries = Object.entries((_overrides$gates = overrides.gates) !== null && _overrides$gates !== void 0 ? _overrides$gates : {}); _i2 < _Object$entries.length; _i2++){
                        var _overrides$gates;
                        var _Object$entries$_i = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_Object$entries[_i2], 2), name = _Object$entries$_i[0], value = _Object$entries$_i[1];
                        merged.gates[name] = value;
                    }
                    for(var _i3 = 0, _Object$entries2 = Object.entries((_overrides$configs = overrides.configs) !== null && _overrides$configs !== void 0 ? _overrides$configs : {}); _i3 < _Object$entries2.length; _i3++){
                        var _overrides$configs;
                        var _Object$entries2$_i = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_Object$entries2[_i3], 2), _name = _Object$entries2$_i[0], _value = _Object$entries2$_i[1];
                        merged.configs[_name] = _value;
                    }
                    for(var _i4 = 0, _Object$entries3 = Object.entries((_overrides$layers = overrides.layers) !== null && _overrides$layers !== void 0 ? _overrides$layers : {}); _i4 < _Object$entries3.length; _i4++){
                        var _overrides$layers;
                        var _Object$entries3$_i = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_Object$entries3[_i4], 2), _name2 = _Object$entries3$_i[0], _value2 = _Object$entries3$_i[1];
                        merged.layers[_name2] = _value2;
                    }
                }
                return merged;
            }
        },
        {
            key: "initFromStoredOverrides",
            value: function initFromStoredOverrides() {
                var storedOverrides = this.mergeOverrides(this._overrides, this.parseStoredOverrides($5d534bea4a687e8a$var$LEGACY_LOCAL_STORAGE_KEY), this.parseStoredOverrides(this._localStorageKey));
                // Clear data from legacy local storage key now we've read from it.
                // This prevents things being stuck in there that are always read but never written to.
                try {
                    window.localStorage.removeItem($5d534bea4a687e8a$var$LEGACY_LOCAL_STORAGE_KEY);
                } catch (_unused2) {
                // ignored - window is not defined in non-browser environments, and we don't save things there
                // (things like SSR, etc)
                }
                // In version 4.24.0 we introduced hashes in this override adapter, but had a bug which would cause
                // multiple hashes to continue being created. This code here removes these hashes since we've moved
                // to using a more reliable and easier to maintain map in `_djb2Map`.
                for(var _i5 = 0, _Object$values = Object.values(storedOverrides); _i5 < _Object$values.length; _i5++){
                    var container = _Object$values[_i5];
                    var allKeys = new Set(Object.keys(container));
                    var _iterator = $5d534bea4a687e8a$var$_createForOfIteratorHelper(allKeys), _step;
                    try {
                        for(_iterator.s(); !(_step = _iterator.n()).done;){
                            var name = _step.value;
                            var hash = (0, $dtn6l._DJB2)(name);
                            if (allKeys.has(hash)) delete container[hash];
                        }
                    } catch (err) {
                        _iterator.e(err);
                    } finally{
                        _iterator.f();
                    }
                }
                this.applyOverrides(storedOverrides);
            }
        },
        {
            key: "saveOverrides",
            value: function saveOverrides() {
                try {
                    window.localStorage.setItem(this._localStorageKey, JSON.stringify(this._overrides));
                } catch (_unused3) {
                // ignored - window is not defined in non-browser environments, and we don't save things there
                // (things like SSR, etc)
                }
            }
        },
        {
            key: "getOverrides",
            value: function getOverrides() {
                return this.mergeOverrides(this._overrides);
            }
        },
        {
            key: "applyOverrides",
            value: function applyOverrides(overrides) {
                var newOverrides = $5d534bea4a687e8a$var$_objectSpread($5d534bea4a687e8a$var$_objectSpread({}, $5d534bea4a687e8a$var$makeEmptyStore()), overrides);
                this._djb2Map.clear();
                for(var _i6 = 0, _Object$entries4 = Object.entries(newOverrides); _i6 < _Object$entries4.length; _i6++){
                    var _Object$entries4$_i = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_Object$entries4[_i6], 2), containerName = _Object$entries4$_i[0], container = _Object$entries4$_i[1];
                    for(var _i7 = 0, _Object$entries5 = Object.entries(container); _i7 < _Object$entries5.length; _i7++){
                        var _Object$entries5$_i = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_Object$entries5[_i7], 2), name = _Object$entries5$_i[0], value = _Object$entries5$_i[1];
                        this._djb2Map.set($5d534bea4a687e8a$var$djb2MapKey((0, $dtn6l._DJB2)(name), containerName), value);
                    }
                }
                this._overrides = newOverrides;
            }
        },
        {
            key: "setOverrides",
            value: function setOverrides(overrides) {
                this.applyOverrides(overrides);
                this.saveOverrides();
            }
        },
        {
            key: "overrideGate",
            value: function overrideGate(name, value) {
                this._overrides.gates[name] = value;
                this._djb2Map.set($5d534bea4a687e8a$var$djb2MapKey((0, $dtn6l._DJB2)(name), 'gates'), value);
                this.saveOverrides();
            }
        },
        {
            key: "removeGateOverride",
            value: function removeGateOverride(name) {
                delete this._overrides.gates[name];
                this._djb2Map.delete($5d534bea4a687e8a$var$djb2MapKey((0, $dtn6l._DJB2)(name), 'gates'));
                this.saveOverrides();
            }
        },
        {
            key: "getGateOverride",
            value: function getGateOverride(current, _user) {
                var _this$_overrides$gate;
                var overridden = (_this$_overrides$gate = this._overrides.gates[current.name]) !== null && _this$_overrides$gate !== void 0 ? _this$_overrides$gate : this._djb2Map.get($5d534bea4a687e8a$var$djb2MapKey(current.name, 'gates'));
                if (overridden == null) return null;
                return $5d534bea4a687e8a$var$_objectSpread($5d534bea4a687e8a$var$_objectSpread({}, current), {}, {
                    value: overridden,
                    details: $5d534bea4a687e8a$var$_objectSpread($5d534bea4a687e8a$var$_objectSpread({}, current.details), {}, {
                        reason: $5d534bea4a687e8a$var$LOCAL_OVERRIDE_REASON
                    })
                });
            }
        },
        {
            key: "overrideDynamicConfig",
            value: function overrideDynamicConfig(name, value) {
                this._overrides.configs[name] = value;
                this._djb2Map.set($5d534bea4a687e8a$var$djb2MapKey((0, $dtn6l._DJB2)(name), 'configs'), value);
                this.saveOverrides();
            }
        },
        {
            key: "removeDynamicConfigOverride",
            value: function removeDynamicConfigOverride(name) {
                delete this._overrides.configs[name];
                this._djb2Map.delete($5d534bea4a687e8a$var$djb2MapKey((0, $dtn6l._DJB2)(name), 'configs'));
                this.saveOverrides();
            }
        },
        {
            key: "getDynamicConfigOverride",
            value: function getDynamicConfigOverride(current, _user) {
                return this._getConfigOverride(current, this._overrides.configs);
            }
        },
        {
            key: "overrideExperiment",
            value: function overrideExperiment(name, value) {
                this._overrides.configs[name] = value;
                this._djb2Map.set($5d534bea4a687e8a$var$djb2MapKey((0, $dtn6l._DJB2)(name), 'configs'), value);
                this.saveOverrides();
            }
        },
        {
            key: "removeExperimentOverride",
            value: function removeExperimentOverride(name) {
                delete this._overrides.configs[name];
                this._djb2Map.delete($5d534bea4a687e8a$var$djb2MapKey((0, $dtn6l._DJB2)(name), 'configs'));
                this.saveOverrides();
            }
        },
        {
            key: "getExperimentOverride",
            value: function getExperimentOverride(current, _user) {
                return this._getConfigOverride(current, this._overrides.configs);
            }
        },
        {
            key: "overrideLayer",
            value: function overrideLayer(name, value) {
                this._overrides.layers[name] = value;
                this._djb2Map.set($5d534bea4a687e8a$var$djb2MapKey((0, $dtn6l._DJB2)(name), 'layers'), value);
                this.saveOverrides();
            }
        },
        {
            key: "removeLayerOverride",
            value: function removeLayerOverride(name) {
                delete this._overrides.layers[name];
                this._djb2Map.delete($5d534bea4a687e8a$var$djb2MapKey((0, $dtn6l._DJB2)(name), 'layers'));
                this.saveOverrides();
            }
        },
        {
            key: "removeAllOverrides",
            value: function removeAllOverrides() {
                this._overrides = $5d534bea4a687e8a$var$makeEmptyStore();
                try {
                    window.localStorage.removeItem(this._localStorageKey);
                } catch (_unused4) {
                // ignored - window is not defined in non-browser environments, and we don't save things there
                // (things like SSR, etc)
                }
            }
        },
        {
            key: "getLayerOverride",
            value: function getLayerOverride(current, _user) {
                var _this$_overrides$laye;
                var overridden = (_this$_overrides$laye = this._overrides.layers[current.name]) !== null && _this$_overrides$laye !== void 0 ? _this$_overrides$laye : this._djb2Map.get($5d534bea4a687e8a$var$djb2MapKey(current.name, 'layers'));
                if (overridden == null) return null;
                return $5d534bea4a687e8a$var$_objectSpread($5d534bea4a687e8a$var$_objectSpread({}, current), {}, {
                    __value: overridden,
                    get: (0, $dtn6l._makeTypedGet)(current.name, overridden),
                    details: $5d534bea4a687e8a$var$_objectSpread($5d534bea4a687e8a$var$_objectSpread({}, current.details), {}, {
                        reason: $5d534bea4a687e8a$var$LOCAL_OVERRIDE_REASON
                    })
                });
            }
        },
        {
            key: "_getConfigOverride",
            value: function _getConfigOverride(current, lookup) {
                var _lookup$current$name;
                var overridden = (_lookup$current$name = lookup[current.name]) !== null && _lookup$current$name !== void 0 ? _lookup$current$name : this._djb2Map.get($5d534bea4a687e8a$var$djb2MapKey(current.name, 'configs'));
                if (overridden == null) return null;
                return $5d534bea4a687e8a$var$_objectSpread($5d534bea4a687e8a$var$_objectSpread({}, current), {}, {
                    value: overridden,
                    get: (0, $dtn6l._makeTypedGet)(current.name, overridden),
                    details: $5d534bea4a687e8a$var$_objectSpread($5d534bea4a687e8a$var$_objectSpread({}, current.details), {}, {
                        reason: $5d534bea4a687e8a$var$LOCAL_OVERRIDE_REASON
                    })
                });
            }
        }
    ]);
}();

});



parcelRegister("kjcRI", function(module, exports) {
$parcel$export(module.exports, "debug", () => $ec8f8fc8c8703c3d$export$1c9f709888824e05);
var $ec8f8fc8c8703c3d$var$_process, $ec8f8fc8c8703c3d$var$_process2;
// We can't rely on NODE_ENV === 'test' if its value is already configured by the consumer to some other value, so better to use JEST_WORKER_ID
// https://jestjs.io/docs/environment-variables#jest_worker_id
var $ec8f8fc8c8703c3d$var$TESTS_MODE = (globalThis === null || globalThis === void 0 || ($ec8f8fc8c8703c3d$var$_process = globalThis.process) === null || $ec8f8fc8c8703c3d$var$_process === void 0 || ($ec8f8fc8c8703c3d$var$_process = $ec8f8fc8c8703c3d$var$_process.env) === null || $ec8f8fc8c8703c3d$var$_process === void 0 ? void 0 : $ec8f8fc8c8703c3d$var$_process.JEST_WORKER_ID) !== undefined;
var $ec8f8fc8c8703c3d$var$DEBUG_MODE = !$ec8f8fc8c8703c3d$var$TESTS_MODE && (globalThis === null || globalThis === void 0 || ($ec8f8fc8c8703c3d$var$_process2 = globalThis.process) === null || $ec8f8fc8c8703c3d$var$_process2 === void 0 || ($ec8f8fc8c8703c3d$var$_process2 = $ec8f8fc8c8703c3d$var$_process2.env) === null || $ec8f8fc8c8703c3d$var$_process2 === void 0 ? void 0 : $ec8f8fc8c8703c3d$var$_process2.NODE_ENV) !== 'production';
var $ec8f8fc8c8703c3d$export$1c9f709888824e05 = function debug() {
    var _console;
    if (!$ec8f8fc8c8703c3d$var$DEBUG_MODE) return;
    // eslint-disable-next-line no-console
    (_console = console).debug.apply(_console, arguments);
};

});




parcelRegister("9AP5g", function(module, exports) {
$parcel$export(module.exports, "THEME_DATA_ATTRIBUTE", () => $6fbf1a0fc3bf0ef0$export$4ef52930e33717cd);
$parcel$export(module.exports, "COLOR_MODE_ATTRIBUTE", () => $6fbf1a0fc3bf0ef0$export$a00eac3f8684bcd0);
$parcel$export(module.exports, "CONTRAST_MODE_ATTRIBUTE", () => $6fbf1a0fc3bf0ef0$export$2112803007239c61);
$parcel$export(module.exports, "CUSTOM_THEME_ATTRIBUTE", () => $6fbf1a0fc3bf0ef0$export$352e418ed5b6193a);
$parcel$export(module.exports, "TOKEN_NOT_FOUND_CSS_VAR", () => $6fbf1a0fc3bf0ef0$export$dddac1532e822863);
$parcel$export(module.exports, "CURRENT_SURFACE_CSS_VAR", () => $6fbf1a0fc3bf0ef0$export$9d7b58831ae93caa);
var $6fbf1a0fc3bf0ef0$export$4ef52930e33717cd = 'data-theme';
var $6fbf1a0fc3bf0ef0$export$cb374d25ded7f6ab = 'data-subtree-theme';
var $6fbf1a0fc3bf0ef0$export$a00eac3f8684bcd0 = 'data-color-mode';
var $6fbf1a0fc3bf0ef0$export$2112803007239c61 = 'data-contrast-mode';
var $6fbf1a0fc3bf0ef0$export$352e418ed5b6193a = 'data-custom-theme';
var $6fbf1a0fc3bf0ef0$export$6f0c6fb8c80fcc92 = 'ds';
var $6fbf1a0fc3bf0ef0$export$4d0c7bbf80185957 = [
    'opacity',
    'font',
    'space',
    'border',
    'radius'
];
var $6fbf1a0fc3bf0ef0$export$dddac1532e822863 = "--".concat($6fbf1a0fc3bf0ef0$export$6f0c6fb8c80fcc92, "-token-not-found");
var $6fbf1a0fc3bf0ef0$export$9d7b58831ae93caa = "--".concat($6fbf1a0fc3bf0ef0$export$6f0c6fb8c80fcc92, "-elevation-surface-current");

});

parcelRegister("a4ocu", function(module, exports) {
$parcel$export(module.exports, "isValidBrandHex", () => $754d0cd5a8bc7a9d$export$53031ac1ecb71f44);
$parcel$export(module.exports, "rgbToHex", () => $754d0cd5a8bc7a9d$export$34d09c4a771c46ef);
$parcel$export(module.exports, "hexToRgbA", () => $754d0cd5a8bc7a9d$export$b36dbdb4f463f05c);
$parcel$export(module.exports, "hexToRgb", () => $754d0cd5a8bc7a9d$export$5a544e13ad4e1fa5);
$parcel$export(module.exports, "hexToHSL", () => $754d0cd5a8bc7a9d$export$47ea145a83f50dc0);
$parcel$export(module.exports, "HSLToRGB", () => $754d0cd5a8bc7a9d$export$1ff93e992dd58bec);
$parcel$export(module.exports, "relativeLuminanceW3C", () => $754d0cd5a8bc7a9d$export$e770b01b744f3745);
$parcel$export(module.exports, "getContrastRatio", () => $754d0cd5a8bc7a9d$export$d061e26956a60b0a);
$parcel$export(module.exports, "deltaE", () => $754d0cd5a8bc7a9d$export$e8ddad763b4bebf9);
// valid hex color with 6 digits
var $754d0cd5a8bc7a9d$export$53031ac1ecb71f44 = function isValidBrandHex(hex) {
    return /^#[0-9A-F]{6}$/i.test(hex);
};
// valid hex color with 4, 6 or 8 digits
var $754d0cd5a8bc7a9d$var$isValidHex = function isValidHex(hex) {
    return /^#([A-Fa-f0-9]{3,4}){1,2}$/.test(hex);
};
function $754d0cd5a8bc7a9d$export$34d09c4a771c46ef(r, g, b) {
    return '#' + (16777216 + (r << 16) + (g << 8) + b).toString(16).slice(1);
}
function $754d0cd5a8bc7a9d$export$1212645cf40ebf71(hex) {
    if (hex.length === 9) {
        var int = parseInt(hex.slice(7, 9), 16) / 255;
        return Number(parseFloat(int.toString()).toFixed(2));
    }
    return 1;
}
function $754d0cd5a8bc7a9d$export$b36dbdb4f463f05c(hex) {
    if (!$754d0cd5a8bc7a9d$var$isValidHex(hex)) throw new Error('Invalid HEX');
    var c;
    c = hex.substring(1).split('');
    if (c.length === 3) c = [
        c[0],
        c[0],
        c[1],
        c[1],
        c[2],
        c[2]
    ];
    c = '0x' + c.join('');
    return [
        c >> 16 & 255,
        c >> 8 & 255,
        c & 255,
        $754d0cd5a8bc7a9d$export$1212645cf40ebf71(hex)
    ];
}
function $754d0cd5a8bc7a9d$export$5a544e13ad4e1fa5(hex) {
    if (!$754d0cd5a8bc7a9d$var$isValidHex(hex)) throw new Error('Invalid HEX');
    var c;
    c = hex.substring(1).split('');
    if (c.length === 3) c = [
        c[0],
        c[0],
        c[1],
        c[1],
        c[2],
        c[2]
    ];
    c = '0x' + c.join('');
    return [
        c >> 16 & 255,
        c >> 8 & 255,
        c & 255
    ];
}
function $754d0cd5a8bc7a9d$export$47ea145a83f50dc0(hex) {
    if (!$754d0cd5a8bc7a9d$var$isValidHex(hex)) throw new Error('Invalid HEX');
    var r = 0, g = 0, b = 0;
    if (hex.length === 4) {
        r = '0x' + hex[1] + hex[1];
        g = '0x' + hex[2] + hex[2];
        b = '0x' + hex[3] + hex[3];
    } else if (hex.length === 7) {
        r = '0x' + hex[1] + hex[2];
        g = '0x' + hex[3] + hex[4];
        b = '0x' + hex[5] + hex[6];
    }
    // Then to HSL
    r /= 255;
    g /= 255;
    b /= 255;
    var cmin = Math.min(r, g, b), cmax = Math.max(r, g, b), delta = cmax - cmin, h = 0, s = 0, l = 0;
    if (delta === 0) h = 0;
    else if (cmax === r) h = (g - b) / delta % 6;
    else if (cmax === g) h = (b - r) / delta + 2;
    else h = (r - g) / delta + 4;
    h = Math.round(h * 60);
    if (h < 0) h += 360;
    l = (cmax + cmin) / 2;
    s = delta === 0 ? 0 : delta / (1 - Math.abs(2 * l - 1));
    s = +(s * 100).toFixed(1);
    l = +(l * 100).toFixed(1);
    return [
        h,
        s,
        l
    ];
}
function $754d0cd5a8bc7a9d$export$1ff93e992dd58bec(h, s, l) {
    s /= 100;
    l /= 100;
    var k = function k(n) {
        return (n + h / 30) % 12;
    };
    var a = s * Math.min(l, 1 - l);
    var f = function f(n) {
        return l - a * Math.max(-1, Math.min(k(n) - 3, Math.min(9 - k(n), 1)));
    };
    return [
        255 * f(0),
        255 * f(8),
        255 * f(4)
    ];
}
function $754d0cd5a8bc7a9d$export$e770b01b744f3745(r, g, b) {
    var RsRGB = r / 255;
    var GsRGB = g / 255;
    var BsRGB = b / 255;
    var R = RsRGB <= 0.03928 ? RsRGB / 12.92 : Math.pow((RsRGB + 0.055) / 1.055, 2.4);
    var G = GsRGB <= 0.03928 ? GsRGB / 12.92 : Math.pow((GsRGB + 0.055) / 1.055, 2.4);
    var B = BsRGB <= 0.03928 ? BsRGB / 12.92 : Math.pow((BsRGB + 0.055) / 1.055, 2.4);
    // For the sRGB colorspace, the relative luminance of a color is defined as:
    var L = 0.2126 * R + 0.7152 * G + 0.0722 * B;
    return L;
}
function $754d0cd5a8bc7a9d$export$d061e26956a60b0a(foreground, background) {
    if (!$754d0cd5a8bc7a9d$var$isValidHex(foreground) || !$754d0cd5a8bc7a9d$var$isValidHex(background)) throw new Error('Invalid HEX');
    var foregroundRgb = $754d0cd5a8bc7a9d$export$5a544e13ad4e1fa5(foreground);
    var backgroundRgb = $754d0cd5a8bc7a9d$export$5a544e13ad4e1fa5(background);
    var foregroundLuminance = $754d0cd5a8bc7a9d$export$e770b01b744f3745(foregroundRgb[0], foregroundRgb[1], foregroundRgb[2]);
    var backgroundLuminance = $754d0cd5a8bc7a9d$export$e770b01b744f3745(backgroundRgb[0], backgroundRgb[1], backgroundRgb[2]);
    // calculate the color contrast ratio
    var brightest = Math.max(foregroundLuminance, backgroundLuminance);
    var darkest = Math.min(foregroundLuminance, backgroundLuminance);
    return (brightest + 0.05) / (darkest + 0.05);
}
function $754d0cd5a8bc7a9d$export$e8ddad763b4bebf9(rgbA, rgbB) {
    var labA = $754d0cd5a8bc7a9d$var$rgbToLab(rgbA);
    var labB = $754d0cd5a8bc7a9d$var$rgbToLab(rgbB);
    var deltaL = labA[0] - labB[0];
    var deltaA = labA[1] - labB[1];
    var deltaB = labA[2] - labB[2];
    var c1 = Math.sqrt(labA[1] * labA[1] + labA[2] * labA[2]);
    var c2 = Math.sqrt(labB[1] * labB[1] + labB[2] * labB[2]);
    var deltaC = c1 - c2;
    var deltaH = deltaA * deltaA + deltaB * deltaB - deltaC * deltaC;
    deltaH = deltaH < 0 ? 0 : Math.sqrt(deltaH);
    var sc = 1.0 + 0.045 * c1;
    var sh = 1.0 + 0.015 * c1;
    var deltaLKlsl = deltaL / 1.0;
    var deltaCkcsc = deltaC / sc;
    var deltaHkhsh = deltaH / sh;
    var i = deltaLKlsl * deltaLKlsl + deltaCkcsc * deltaCkcsc + deltaHkhsh * deltaHkhsh;
    return i < 0 ? 0 : Math.sqrt(i);
}
function $754d0cd5a8bc7a9d$var$rgbToLab(rgb) {
    var r = rgb[0] / 255, g = rgb[1] / 255, b = rgb[2] / 255, x, y, z;
    r = r > 0.04045 ? Math.pow((r + 0.055) / 1.055, 2.4) : r / 12.92;
    g = g > 0.04045 ? Math.pow((g + 0.055) / 1.055, 2.4) : g / 12.92;
    b = b > 0.04045 ? Math.pow((b + 0.055) / 1.055, 2.4) : b / 12.92;
    x = (r * 0.4124 + g * 0.3576 + b * 0.1805) / 0.95047;
    y = (r * 0.2126 + g * 0.7152 + b * 0.0722) / 1.0;
    z = (r * 0.0193 + g * 0.1192 + b * 0.9505) / 1.08883;
    x = x > 0.008856 ? Math.pow(x, 1 / 3) : 7.787 * x + 16 / 116;
    y = y > 0.008856 ? Math.pow(y, 1 / 3) : 7.787 * y + 16 / 116;
    z = z > 0.008856 ? Math.pow(z, 1 / 3) : 7.787 * z + 16 / 116;
    return [
        116 * y - 16,
        500 * (x - y),
        200 * (y - z)
    ];
}

});

parcelRegister("3ENxc", function(module, exports) {
$parcel$export(module.exports, "hash", () => $2a9b880a994ef4e4$export$d6af199866bfb566);
var $2a9b880a994ef4e4$export$d6af199866bfb566 = function hash(str) {
    var hash = 0;
    for(var i = 0; i < str.length; i++){
        var char = str.charCodeAt(i);
        hash = (hash << 5) - hash + char;
        hash &= hash; // Convert to 32bit integer
    }
    return new Uint32Array([
        hash
    ])[0].toString(36);
};

});

parcelRegister("7QpUe", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.bindAll = module.exports.bind = void 0;

var $g2LBo = parcelRequire("g2LBo");
Object.defineProperty(module.exports, "bind", {
    enumerable: true,
    get: function() {
        return $g2LBo.bind;
    }
});

var $lcukj = parcelRequire("lcukj");
Object.defineProperty(module.exports, "bindAll", {
    enumerable: true,
    get: function() {
        return $lcukj.bindAll;
    }
});

});
parcelRegister("g2LBo", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.bind = void 0;
function $bae1c2098f2dd253$var$bind(target, _a) {
    var type = _a.type, listener = _a.listener, options = _a.options;
    target.addEventListener(type, listener, options);
    return function unbind() {
        target.removeEventListener(type, listener, options);
    };
}
module.exports.bind = $bae1c2098f2dd253$var$bind;

});

parcelRegister("lcukj", function(module, exports) {
"use strict";
var $f6f23e2d6cc820f3$var$__assign = module.exports && module.exports.__assign || function() {
    $f6f23e2d6cc820f3$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $f6f23e2d6cc820f3$var$__assign.apply(this, arguments);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.bindAll = void 0;

var $g2LBo = parcelRequire("g2LBo");
function $f6f23e2d6cc820f3$var$toOptions(value) {
    if (typeof value === 'undefined') return undefined;
    if (typeof value === 'boolean') return {
        capture: value
    };
    return value;
}
function $f6f23e2d6cc820f3$var$getBinding(original, sharedOptions) {
    if (sharedOptions == null) return original;
    var binding = $f6f23e2d6cc820f3$var$__assign($f6f23e2d6cc820f3$var$__assign({}, original), {
        options: $f6f23e2d6cc820f3$var$__assign($f6f23e2d6cc820f3$var$__assign({}, $f6f23e2d6cc820f3$var$toOptions(sharedOptions)), $f6f23e2d6cc820f3$var$toOptions(original.options))
    });
    return binding;
}
function $f6f23e2d6cc820f3$var$bindAll(target, bindings, sharedOptions) {
    var unbinds = bindings.map(function(original) {
        var binding = $f6f23e2d6cc820f3$var$getBinding(original, sharedOptions);
        return (0, $g2LBo.bind)(target, binding);
    });
    return function unbindAll() {
        unbinds.forEach(function(unbind) {
            return unbind();
        });
    };
}
module.exports.bindAll = $f6f23e2d6cc820f3$var$bindAll;

});


parcelRegister("bDSDt", function(module, exports) {

var $iKwew = parcelRequire("iKwew");
module.exports = $iKwew("8dpxt").then(()=>parcelRequire('dBLpv'));

});
parcelRegister("iKwew", function(module, exports) {
"use strict";

function $da6586bd2e851bf4$var$load(id) {
    // eslint-disable-next-line no-undef
    return import((parcelRequire("F8oyc")).resolve(id));
}
module.exports = $da6586bd2e851bf4$var$load;

});
parcelRegister("F8oyc", function(module, exports) {
$parcel$export(module.exports, "register", () => $07ba578472346502$export$6503ec6e8aabbaf, (v) => $07ba578472346502$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $07ba578472346502$export$f7ad0328861e2f03, (v) => $07ba578472346502$export$f7ad0328861e2f03 = v);
var $07ba578472346502$export$6503ec6e8aabbaf;
var $07ba578472346502$export$f7ad0328861e2f03;
"use strict";
var $07ba578472346502$var$mapping = new Map();
function $07ba578472346502$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$07ba578472346502$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $07ba578472346502$var$resolve(id) {
    var resolved = $07ba578472346502$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$07ba578472346502$export$6503ec6e8aabbaf = $07ba578472346502$var$register;
$07ba578472346502$export$f7ad0328861e2f03 = $07ba578472346502$var$resolve;

});



parcelRegister("8SV4m", function(module, exports) {

var $iKwew = parcelRequire("iKwew");
module.exports = $iKwew("6mk2N").then(()=>parcelRequire('d9oU7'));

});

parcelRegister("10OzB", function(module, exports) {

var $iKwew = parcelRequire("iKwew");
module.exports = $iKwew("i8ZQs").then(()=>parcelRequire('19VjI'));

});

parcelRegister("8Ul61", function(module, exports) {

var $iKwew = parcelRequire("iKwew");
module.exports = $iKwew("fXI52").then(()=>parcelRequire('aYEHp'));

});

parcelRegister("fUMDb", function(module, exports) {

var $iKwew = parcelRequire("iKwew");
module.exports = $iKwew("hwaZz").then(()=>parcelRequire('c5rYc'));

});

parcelRegister("5r8Y4", function(module, exports) {

var $iKwew = parcelRequire("iKwew");
module.exports = $iKwew("8g0D1").then(()=>parcelRequire('7cU8a'));

});

parcelRegister("9aLgs", function(module, exports) {

var $iKwew = parcelRequire("iKwew");
module.exports = $iKwew("8JRRA").then(()=>parcelRequire('d7lZx'));

});

parcelRegister("b3HFs", function(module, exports) {

var $iKwew = parcelRequire("iKwew");
module.exports = $iKwew("19czx").then(()=>parcelRequire('jyhWx'));

});

parcelRegister("2BLfh", function(module, exports) {

var $iKwew = parcelRequire("iKwew");
module.exports = $iKwew("lKdH4").then(()=>parcelRequire('dkaXG'));

});

parcelRegister("j7Ivm", function(module, exports) {

var $iKwew = parcelRequire("iKwew");
module.exports = $iKwew("iUl3e").then(()=>parcelRequire('JvPYp'));

});

parcelRegister("fC8ib", function(module, exports) {

var $80rv2 = parcelRequire("80rv2");

var $2XfV2 = parcelRequire("2XfV2");

var $ccaOk = parcelRequire("ccaOk");

var $eo9uW = parcelRequire("eo9uW");
function $b5e0d6462918fd61$var$_toConsumableArray(r) {
    return $80rv2(r) || $2XfV2(r) || $ccaOk(r) || $eo9uW();
}
module.exports = $b5e0d6462918fd61$var$_toConsumableArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("80rv2", function(module, exports) {

var $7Edli = parcelRequire("7Edli");
function $5d43a7b0c15e0a9e$var$_arrayWithoutHoles(r) {
    if (Array.isArray(r)) return $7Edli(r);
}
module.exports = $5d43a7b0c15e0a9e$var$_arrayWithoutHoles, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("2XfV2", function(module, exports) {
function $226d70a7652df90f$var$_iterableToArray(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}
module.exports = $226d70a7652df90f$var$_iterableToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("eo9uW", function(module, exports) {
function $a79aacb7570835cb$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
module.exports = $a79aacb7570835cb$var$_nonIterableSpread, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("6OciX", function(module, exports) {

var $iKwew = parcelRequire("iKwew");
module.exports = $iKwew("adg9C").then(()=>parcelRequire('jLYkO'));

});

parcelRegister("2DGGf", function(module, exports) {
$parcel$export(module.exports, "createIntl", () => $1ec054bf15c60dc8$export$7e4cbedfdd7b4c0d);
$parcel$export(module.exports, "default", () => $1ec054bf15c60dc8$export$2e2bcd8739ae039);
/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */ 
var $l2Z7B = parcelRequire("l2Z7B");

var $5FkrB = parcelRequire("5FkrB");

var $3IjMA = parcelRequire("3IjMA");

var $ktNo6 = parcelRequire("ktNo6");

var $htSVt = parcelRequire("htSVt");
var $ftB2S = parcelRequire("ftB2S");
var $2k5ES = parcelRequire("2k5ES");

var $b1zcR = parcelRequire("b1zcR");
function $1ec054bf15c60dc8$var$processIntlConfig(config) {
    return {
        locale: config.locale,
        timeZone: config.timeZone,
        fallbackOnEmptyString: config.fallbackOnEmptyString,
        formats: config.formats,
        textComponent: config.textComponent,
        messages: config.messages,
        defaultLocale: config.defaultLocale,
        defaultFormats: config.defaultFormats,
        onError: config.onError,
        onWarn: config.onWarn,
        wrapRichTextChunksInFragment: config.wrapRichTextChunksInFragment,
        defaultRichTextElements: config.defaultRichTextElements
    };
}
function $1ec054bf15c60dc8$var$assignUniqueKeysToFormatXMLElementFnArgument(values) {
    if (!values) return values;
    return Object.keys(values).reduce(function(acc, k) {
        var v = values[k];
        acc[k] = (0, $b1zcR.isFormatXMLElementFn)(v) ? (0, $ktNo6.assignUniqueKeysToParts)(v) : v;
        return acc;
    }, {});
}
var $1ec054bf15c60dc8$var$formatMessage = function(config, formatters, descriptor, rawValues) {
    var rest = [];
    for(var _i = 4; _i < arguments.length; _i++)rest[_i - 4] = arguments[_i];
    var values = $1ec054bf15c60dc8$var$assignUniqueKeysToFormatXMLElementFnArgument(rawValues);
    var chunks = (0, $2k5ES.formatMessage).apply(void 0, (0, $l2Z7B.__spreadArray)([
        config,
        formatters,
        descriptor,
        values
    ], rest, false));
    if (Array.isArray(chunks)) return $5FkrB.Children.toArray(chunks);
    return chunks;
};
var $1ec054bf15c60dc8$export$7e4cbedfdd7b4c0d = function(_a, cache) {
    var rawDefaultRichTextElements = _a.defaultRichTextElements, config = (0, $l2Z7B.__rest)(_a, [
        "defaultRichTextElements"
    ]);
    var defaultRichTextElements = $1ec054bf15c60dc8$var$assignUniqueKeysToFormatXMLElementFnArgument(rawDefaultRichTextElements);
    var coreIntl = (0, $htSVt.createIntl)((0, $l2Z7B.__assign)((0, $l2Z7B.__assign)((0, $l2Z7B.__assign)({}, (0, $ktNo6.DEFAULT_INTL_CONFIG)), config), {
        defaultRichTextElements: defaultRichTextElements
    }), cache);
    return (0, $l2Z7B.__assign)((0, $l2Z7B.__assign)({}, coreIntl), {
        formatMessage: $1ec054bf15c60dc8$var$formatMessage.bind(null, {
            locale: coreIntl.locale,
            timeZone: coreIntl.timeZone,
            fallbackOnEmptyString: coreIntl.fallbackOnEmptyString,
            formats: coreIntl.formats,
            defaultLocale: coreIntl.defaultLocale,
            defaultFormats: coreIntl.defaultFormats,
            messages: coreIntl.messages,
            onError: coreIntl.onError,
            defaultRichTextElements: defaultRichTextElements
        }, coreIntl.formatters)
    });
};
var $1ec054bf15c60dc8$var$IntlProvider = /** @class */ function(_super) {
    (0, $l2Z7B.__extends)(IntlProvider, _super);
    function IntlProvider() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.cache = (0, $ftB2S.createIntlCache)();
        _this.state = {
            cache: _this.cache,
            intl: $1ec054bf15c60dc8$export$7e4cbedfdd7b4c0d($1ec054bf15c60dc8$var$processIntlConfig(_this.props), _this.cache),
            prevConfig: $1ec054bf15c60dc8$var$processIntlConfig(_this.props)
        };
        return _this;
    }
    IntlProvider.getDerivedStateFromProps = function(props, _a) {
        var prevConfig = _a.prevConfig, cache = _a.cache;
        var config = $1ec054bf15c60dc8$var$processIntlConfig(props);
        if (!(0, $ktNo6.shallowEqual)(prevConfig, config)) return {
            intl: $1ec054bf15c60dc8$export$7e4cbedfdd7b4c0d(config, cache),
            prevConfig: config
        };
        return null;
    };
    IntlProvider.prototype.render = function() {
        (0, $ktNo6.invariantIntlContext)(this.state.intl);
        return $5FkrB.createElement((0, $3IjMA.Provider), {
            value: this.state.intl
        }, this.props.children);
    };
    IntlProvider.displayName = 'IntlProvider';
    IntlProvider.defaultProps = (0, $ktNo6.DEFAULT_INTL_CONFIG);
    return IntlProvider;
}($5FkrB.PureComponent);
var $1ec054bf15c60dc8$export$2e2bcd8739ae039 = $1ec054bf15c60dc8$var$IntlProvider;

});
parcelRegister("l2Z7B", function(module, exports) {
$parcel$export(module.exports, "__extends", () => $f529325f6b7626f5$export$a8ba968b8961cb8a);
$parcel$export(module.exports, "__assign", () => $f529325f6b7626f5$export$18ce0697a983be9b);
$parcel$export(module.exports, "__rest", () => $f529325f6b7626f5$export$3c9a16f847548506);
$parcel$export(module.exports, "__exportStar", () => $f529325f6b7626f5$export$f33643c0debef087);
$parcel$export(module.exports, "__spreadArrays", () => $f529325f6b7626f5$export$6388937ca91ccae8);
$parcel$export(module.exports, "__spreadArray", () => $f529325f6b7626f5$export$1216008129fb82ed);
$parcel$export(module.exports, "__importDefault", () => $f529325f6b7626f5$export$da59b14a69baef04);
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol, Iterator */ var $f529325f6b7626f5$var$extendStatics = function(d, b) {
    $f529325f6b7626f5$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $f529325f6b7626f5$var$extendStatics(d, b);
};
function $f529325f6b7626f5$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $f529325f6b7626f5$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $f529325f6b7626f5$export$18ce0697a983be9b = function() {
    $f529325f6b7626f5$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $f529325f6b7626f5$export$18ce0697a983be9b.apply(this, arguments);
};
function $f529325f6b7626f5$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $f529325f6b7626f5$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $f529325f6b7626f5$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $f529325f6b7626f5$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $f529325f6b7626f5$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $f529325f6b7626f5$export$6a2a36740a146cb8(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function $f529325f6b7626f5$export$d1a06452d3489bc7(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $f529325f6b7626f5$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $f529325f6b7626f5$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $f529325f6b7626f5$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $f529325f6b7626f5$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $f529325f6b7626f5$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $f529325f6b7626f5$export$45d3717a4c69092e(o, m, p);
}
function $f529325f6b7626f5$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $f529325f6b7626f5$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $f529325f6b7626f5$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($f529325f6b7626f5$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $f529325f6b7626f5$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $f529325f6b7626f5$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $f529325f6b7626f5$export$10c90e4f7922046c(v) {
    return this instanceof $f529325f6b7626f5$export$10c90e4f7922046c ? (this.v = v, this) : new $f529325f6b7626f5$export$10c90e4f7922046c(v);
}
function $f529325f6b7626f5$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = Object.create((typeof AsyncIterator === "function" ? AsyncIterator : Object).prototype), verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function awaitReturn(f) {
        return function(v) {
            return Promise.resolve(v).then(f, reject);
        };
    }
    function verb(n, f) {
        if (g[n]) {
            i[n] = function(v) {
                return new Promise(function(a, b) {
                    q.push([
                        n,
                        v,
                        a,
                        b
                    ]) > 1 || resume(n, v);
                });
            };
            if (f) i[n] = f(i[n]);
        }
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $f529325f6b7626f5$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $f529325f6b7626f5$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $f529325f6b7626f5$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $f529325f6b7626f5$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $f529325f6b7626f5$export$19a8beecd37a4c45 === "function" ? $f529325f6b7626f5$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $f529325f6b7626f5$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $f529325f6b7626f5$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
var $f529325f6b7626f5$var$ownKeys = function(o) {
    $f529325f6b7626f5$var$ownKeys = Object.getOwnPropertyNames || function(o) {
        var ar = [];
        for(var k in o)if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
        return ar;
    };
    return $f529325f6b7626f5$var$ownKeys(o);
};
function $f529325f6b7626f5$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k = $f529325f6b7626f5$var$ownKeys(mod), i = 0; i < k.length; i++)if (k[i] !== "default") $f529325f6b7626f5$export$45d3717a4c69092e(result, mod, k[i]);
    }
    $f529325f6b7626f5$var$__setModuleDefault(result, mod);
    return result;
}
function $f529325f6b7626f5$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $f529325f6b7626f5$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $f529325f6b7626f5$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $f529325f6b7626f5$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $f529325f6b7626f5$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose, inner;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
            if (async) inner = dispose;
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        if (inner) dispose = function() {
            try {
                inner.call(this);
            } catch (e) {
                return Promise.reject(e);
            }
        };
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $f529325f6b7626f5$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $f529325f6b7626f5$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $f529325f6b7626f5$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    var r, s = 0;
    function next() {
        while(r = env.stack.pop())try {
            if (!r.async && s === 1) return s = 0, env.stack.push(r), Promise.resolve().then(next);
            if (r.dispose) {
                var result = r.dispose.call(r.value);
                if (r.async) return s |= 2, Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } else s |= 1;
        } catch (e) {
            fail(e);
        }
        if (s === 1) return env.hasError ? Promise.reject(env.error) : Promise.resolve();
        if (env.hasError) throw env.error;
    }
    return next();
}
function $f529325f6b7626f5$export$889dfb5d17574b0b(path, preserveJsx) {
    if (typeof path === "string" && /^\.\.?\//.test(path)) return path.replace(/\.(tsx)$|((?:\.d)?)((?:\.[^./]+?)?)\.([cm]?)ts$/i, function(m, tsx, d, ext, cm) {
        return tsx ? preserveJsx ? ".jsx" : ".js" : d && (!ext || !cm) ? m : d + ext + "." + cm.toLowerCase() + "js";
    });
    return path;
}
var $f529325f6b7626f5$export$2e2bcd8739ae039 = {
    __extends: $f529325f6b7626f5$export$a8ba968b8961cb8a,
    __assign: $f529325f6b7626f5$export$18ce0697a983be9b,
    __rest: $f529325f6b7626f5$export$3c9a16f847548506,
    __decorate: $f529325f6b7626f5$export$29e00dfd3077644b,
    __param: $f529325f6b7626f5$export$d5ad3fd78186038f,
    __esDecorate: $f529325f6b7626f5$export$3a84e1ae4e97e9b0,
    __runInitializers: $f529325f6b7626f5$export$d831c04e792af3d,
    __propKey: $f529325f6b7626f5$export$6a2a36740a146cb8,
    __setFunctionName: $f529325f6b7626f5$export$d1a06452d3489bc7,
    __metadata: $f529325f6b7626f5$export$f1db080c865becb9,
    __awaiter: $f529325f6b7626f5$export$1050f835b63b671e,
    __generator: $f529325f6b7626f5$export$67ebef60e6f28a6,
    __createBinding: $f529325f6b7626f5$export$45d3717a4c69092e,
    __exportStar: $f529325f6b7626f5$export$f33643c0debef087,
    __values: $f529325f6b7626f5$export$19a8beecd37a4c45,
    __read: $f529325f6b7626f5$export$8d051b38c9118094,
    __spread: $f529325f6b7626f5$export$afc72e2116322959,
    __spreadArrays: $f529325f6b7626f5$export$6388937ca91ccae8,
    __spreadArray: $f529325f6b7626f5$export$1216008129fb82ed,
    __await: $f529325f6b7626f5$export$10c90e4f7922046c,
    __asyncGenerator: $f529325f6b7626f5$export$e427f37a30a4de9b,
    __asyncDelegator: $f529325f6b7626f5$export$bbd80228419bb833,
    __asyncValues: $f529325f6b7626f5$export$e3b29a3d6162315f,
    __makeTemplateObject: $f529325f6b7626f5$export$4fb47efe1390b86f,
    __importStar: $f529325f6b7626f5$export$c21735bcef00d192,
    __importDefault: $f529325f6b7626f5$export$da59b14a69baef04,
    __classPrivateFieldGet: $f529325f6b7626f5$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $f529325f6b7626f5$export$d40a35129aaff81f,
    __classPrivateFieldIn: $f529325f6b7626f5$export$81fdc39f203e4e04,
    __addDisposableResource: $f529325f6b7626f5$export$88ac25d8e944e405,
    __disposeResources: $f529325f6b7626f5$export$8f076105dc360e92,
    __rewriteRelativeImportExtension: $f529325f6b7626f5$export$889dfb5d17574b0b
};

});

parcelRegister("3IjMA", function(module, exports) {
$parcel$export(module.exports, "Provider", () => $2b44d392c4a4ed5c$export$2881499e37b75b9a);
$parcel$export(module.exports, "Context", () => $2b44d392c4a4ed5c$export$841858b892ce1f4c);
$parcel$export(module.exports, "default", () => $2b44d392c4a4ed5c$export$2e2bcd8739ae039);

var $l2Z7B = parcelRequire("l2Z7B");

var $5FkrB = parcelRequire("5FkrB");

var $knBeW = parcelRequire("knBeW");

var $ktNo6 = parcelRequire("ktNo6");
function $2b44d392c4a4ed5c$var$getDisplayName(Component) {
    return Component.displayName || Component.name || 'Component';
}
// TODO: We should provide initial value here
var $2b44d392c4a4ed5c$var$IntlContext = $5FkrB.createContext(null);
var $2b44d392c4a4ed5c$var$IntlConsumer = $2b44d392c4a4ed5c$var$IntlContext.Consumer, $2b44d392c4a4ed5c$var$IntlProvider = $2b44d392c4a4ed5c$var$IntlContext.Provider;
var $2b44d392c4a4ed5c$export$2881499e37b75b9a = $2b44d392c4a4ed5c$var$IntlProvider;
var $2b44d392c4a4ed5c$export$841858b892ce1f4c = $2b44d392c4a4ed5c$var$IntlContext;
function $2b44d392c4a4ed5c$export$2e2bcd8739ae039(WrappedComponent, options) {
    var _a = options || {}, _b = _a.intlPropName, intlPropName = _b === void 0 ? 'intl' : _b, _c = _a.forwardRef, forwardRef = _c === void 0 ? false : _c, _d = _a.enforceContext, enforceContext = _d === void 0 ? true : _d;
    var WithIntl = function(props) {
        return $5FkrB.createElement($2b44d392c4a4ed5c$var$IntlConsumer, null, function(intl) {
            var _a;
            if (enforceContext) (0, $ktNo6.invariantIntlContext)(intl);
            var intlProp = (_a = {}, _a[intlPropName] = intl, _a);
            return $5FkrB.createElement(WrappedComponent, (0, $l2Z7B.__assign)({}, props, intlProp, {
                ref: forwardRef ? props.forwardedRef : null
            }));
        });
    };
    WithIntl.displayName = "injectIntl(".concat($2b44d392c4a4ed5c$var$getDisplayName(WrappedComponent), ")");
    WithIntl.WrappedComponent = WrappedComponent;
    if (forwardRef) return (0, (/*@__PURE__*/$parcel$interopDefault($knBeW)))($5FkrB.forwardRef(function(props, ref) {
        return $5FkrB.createElement(WithIntl, (0, $l2Z7B.__assign)({}, props, {
            forwardedRef: ref
        }));
    }), WrappedComponent);
    return (0, (/*@__PURE__*/$parcel$interopDefault($knBeW)))(WithIntl, WrappedComponent);
}

});
parcelRegister("knBeW", function(module, exports) {
'use strict';

var $lwfCu = parcelRequire("lwfCu");
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */ var $ed62d7b2a7b04291$var$REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $ed62d7b2a7b04291$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $ed62d7b2a7b04291$var$FORWARD_REF_STATICS = {
    '$$typeof': true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var $ed62d7b2a7b04291$var$MEMO_STATICS = {
    '$$typeof': true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var $ed62d7b2a7b04291$var$TYPE_STATICS = {};
$ed62d7b2a7b04291$var$TYPE_STATICS[$lwfCu.ForwardRef] = $ed62d7b2a7b04291$var$FORWARD_REF_STATICS;
$ed62d7b2a7b04291$var$TYPE_STATICS[$lwfCu.Memo] = $ed62d7b2a7b04291$var$MEMO_STATICS;
function $ed62d7b2a7b04291$var$getStatics(component) {
    // React v16.11 and below
    if ($lwfCu.isMemo(component)) return $ed62d7b2a7b04291$var$MEMO_STATICS;
     // React v16.12 and above
    return $ed62d7b2a7b04291$var$TYPE_STATICS[component['$$typeof']] || $ed62d7b2a7b04291$var$REACT_STATICS;
}
var $ed62d7b2a7b04291$var$defineProperty = Object.defineProperty;
var $ed62d7b2a7b04291$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $ed62d7b2a7b04291$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $ed62d7b2a7b04291$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $ed62d7b2a7b04291$var$getPrototypeOf = Object.getPrototypeOf;
var $ed62d7b2a7b04291$var$objectPrototype = Object.prototype;
function $ed62d7b2a7b04291$var$hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') {
        // don't hoist over string (html) components
        if ($ed62d7b2a7b04291$var$objectPrototype) {
            var inheritedComponent = $ed62d7b2a7b04291$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $ed62d7b2a7b04291$var$objectPrototype) $ed62d7b2a7b04291$var$hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
        }
        var keys = $ed62d7b2a7b04291$var$getOwnPropertyNames(sourceComponent);
        if ($ed62d7b2a7b04291$var$getOwnPropertySymbols) keys = keys.concat($ed62d7b2a7b04291$var$getOwnPropertySymbols(sourceComponent));
        var targetStatics = $ed62d7b2a7b04291$var$getStatics(targetComponent);
        var sourceStatics = $ed62d7b2a7b04291$var$getStatics(sourceComponent);
        for(var i = 0; i < keys.length; ++i){
            var key = keys[i];
            if (!$ed62d7b2a7b04291$var$KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = $ed62d7b2a7b04291$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    $ed62d7b2a7b04291$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
module.exports = $ed62d7b2a7b04291$var$hoistNonReactStatics;

});
parcelRegister("lwfCu", function(module, exports) {
'use strict';

module.exports = (parcelRequire("3gsre"));

});
parcelRegister("3gsre", function(module, exports) {
$parcel$export(module.exports, "AsyncMode", () => $2608ecfb9154a3b7$export$2b8d127b894957b9, (v) => $2608ecfb9154a3b7$export$2b8d127b894957b9 = v);
$parcel$export(module.exports, "ConcurrentMode", () => $2608ecfb9154a3b7$export$cea3a54a6425200c, (v) => $2608ecfb9154a3b7$export$cea3a54a6425200c = v);
$parcel$export(module.exports, "ContextConsumer", () => $2608ecfb9154a3b7$export$a7c73072b1a182ae, (v) => $2608ecfb9154a3b7$export$a7c73072b1a182ae = v);
$parcel$export(module.exports, "ContextProvider", () => $2608ecfb9154a3b7$export$9f27bc3417b4524d, (v) => $2608ecfb9154a3b7$export$9f27bc3417b4524d = v);
$parcel$export(module.exports, "Element", () => $2608ecfb9154a3b7$export$db77ccec0bb4ccac, (v) => $2608ecfb9154a3b7$export$db77ccec0bb4ccac = v);
$parcel$export(module.exports, "ForwardRef", () => $2608ecfb9154a3b7$export$8392c0c9d3dcbd35, (v) => $2608ecfb9154a3b7$export$8392c0c9d3dcbd35 = v);
$parcel$export(module.exports, "Fragment", () => $2608ecfb9154a3b7$export$ffb0004e005737fa, (v) => $2608ecfb9154a3b7$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Lazy", () => $2608ecfb9154a3b7$export$b624eff549462981, (v) => $2608ecfb9154a3b7$export$b624eff549462981 = v);
$parcel$export(module.exports, "Memo", () => $2608ecfb9154a3b7$export$7897aa7841a5380c, (v) => $2608ecfb9154a3b7$export$7897aa7841a5380c = v);
$parcel$export(module.exports, "Portal", () => $2608ecfb9154a3b7$export$602eac185826482c, (v) => $2608ecfb9154a3b7$export$602eac185826482c = v);
$parcel$export(module.exports, "Profiler", () => $2608ecfb9154a3b7$export$e2c29f18771995cb, (v) => $2608ecfb9154a3b7$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "StrictMode", () => $2608ecfb9154a3b7$export$5f8d39834fd61797, (v) => $2608ecfb9154a3b7$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $2608ecfb9154a3b7$export$74bf444e3cd11ea5, (v) => $2608ecfb9154a3b7$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "isAsyncMode", () => $2608ecfb9154a3b7$export$92387174baf9b227, (v) => $2608ecfb9154a3b7$export$92387174baf9b227 = v);
$parcel$export(module.exports, "isConcurrentMode", () => $2608ecfb9154a3b7$export$ec112efeb987d9c6, (v) => $2608ecfb9154a3b7$export$ec112efeb987d9c6 = v);
$parcel$export(module.exports, "isContextConsumer", () => $2608ecfb9154a3b7$export$b706b080d889d2c9, (v) => $2608ecfb9154a3b7$export$b706b080d889d2c9 = v);
$parcel$export(module.exports, "isContextProvider", () => $2608ecfb9154a3b7$export$5be5a87408f70ddc, (v) => $2608ecfb9154a3b7$export$5be5a87408f70ddc = v);
$parcel$export(module.exports, "isElement", () => $2608ecfb9154a3b7$export$45a5e7f76e0caa8d, (v) => $2608ecfb9154a3b7$export$45a5e7f76e0caa8d = v);
$parcel$export(module.exports, "isForwardRef", () => $2608ecfb9154a3b7$export$455c2e768291efa6, (v) => $2608ecfb9154a3b7$export$455c2e768291efa6 = v);
$parcel$export(module.exports, "isFragment", () => $2608ecfb9154a3b7$export$9522e17588c12572, (v) => $2608ecfb9154a3b7$export$9522e17588c12572 = v);
$parcel$export(module.exports, "isLazy", () => $2608ecfb9154a3b7$export$2110ac352bb060b9, (v) => $2608ecfb9154a3b7$export$2110ac352bb060b9 = v);
$parcel$export(module.exports, "isMemo", () => $2608ecfb9154a3b7$export$56885ab8b9c456ab, (v) => $2608ecfb9154a3b7$export$56885ab8b9c456ab = v);
$parcel$export(module.exports, "isPortal", () => $2608ecfb9154a3b7$export$d927fcb6adf8f9de, (v) => $2608ecfb9154a3b7$export$d927fcb6adf8f9de = v);
$parcel$export(module.exports, "isProfiler", () => $2608ecfb9154a3b7$export$b82d16f27459e05a, (v) => $2608ecfb9154a3b7$export$b82d16f27459e05a = v);
$parcel$export(module.exports, "isStrictMode", () => $2608ecfb9154a3b7$export$522c17b4f5e123e8, (v) => $2608ecfb9154a3b7$export$522c17b4f5e123e8 = v);
$parcel$export(module.exports, "isSuspense", () => $2608ecfb9154a3b7$export$1aabd8a0274ecfd6, (v) => $2608ecfb9154a3b7$export$1aabd8a0274ecfd6 = v);
$parcel$export(module.exports, "isValidElementType", () => $2608ecfb9154a3b7$export$9b621391a187a31a, (v) => $2608ecfb9154a3b7$export$9b621391a187a31a = v);
$parcel$export(module.exports, "typeOf", () => $2608ecfb9154a3b7$export$f5bbd400c2f4426f, (v) => $2608ecfb9154a3b7$export$f5bbd400c2f4426f = v);
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $2608ecfb9154a3b7$export$2b8d127b894957b9;
var $2608ecfb9154a3b7$export$cea3a54a6425200c;
var $2608ecfb9154a3b7$export$a7c73072b1a182ae;
var $2608ecfb9154a3b7$export$9f27bc3417b4524d;
var $2608ecfb9154a3b7$export$db77ccec0bb4ccac;
var $2608ecfb9154a3b7$export$8392c0c9d3dcbd35;
var $2608ecfb9154a3b7$export$ffb0004e005737fa;
var $2608ecfb9154a3b7$export$b624eff549462981;
var $2608ecfb9154a3b7$export$7897aa7841a5380c;
var $2608ecfb9154a3b7$export$602eac185826482c;
var $2608ecfb9154a3b7$export$e2c29f18771995cb;
var $2608ecfb9154a3b7$export$5f8d39834fd61797;
var $2608ecfb9154a3b7$export$74bf444e3cd11ea5;
var $2608ecfb9154a3b7$export$92387174baf9b227;
var $2608ecfb9154a3b7$export$ec112efeb987d9c6;
var $2608ecfb9154a3b7$export$b706b080d889d2c9;
var $2608ecfb9154a3b7$export$5be5a87408f70ddc;
var $2608ecfb9154a3b7$export$45a5e7f76e0caa8d;
var $2608ecfb9154a3b7$export$455c2e768291efa6;
var $2608ecfb9154a3b7$export$9522e17588c12572;
var $2608ecfb9154a3b7$export$2110ac352bb060b9;
var $2608ecfb9154a3b7$export$56885ab8b9c456ab;
var $2608ecfb9154a3b7$export$d927fcb6adf8f9de;
var $2608ecfb9154a3b7$export$b82d16f27459e05a;
var $2608ecfb9154a3b7$export$522c17b4f5e123e8;
var $2608ecfb9154a3b7$export$1aabd8a0274ecfd6;
var $2608ecfb9154a3b7$export$9b621391a187a31a;
var $2608ecfb9154a3b7$export$f5bbd400c2f4426f;
'use strict';
var $2608ecfb9154a3b7$var$b = "function" === typeof Symbol && Symbol.for, $2608ecfb9154a3b7$var$c = $2608ecfb9154a3b7$var$b ? Symbol.for("react.element") : 60103, $2608ecfb9154a3b7$var$d = $2608ecfb9154a3b7$var$b ? Symbol.for("react.portal") : 60106, $2608ecfb9154a3b7$var$e = $2608ecfb9154a3b7$var$b ? Symbol.for("react.fragment") : 60107, $2608ecfb9154a3b7$var$f = $2608ecfb9154a3b7$var$b ? Symbol.for("react.strict_mode") : 60108, $2608ecfb9154a3b7$var$g = $2608ecfb9154a3b7$var$b ? Symbol.for("react.profiler") : 60114, $2608ecfb9154a3b7$var$h = $2608ecfb9154a3b7$var$b ? Symbol.for("react.provider") : 60109, $2608ecfb9154a3b7$var$k = $2608ecfb9154a3b7$var$b ? Symbol.for("react.context") : 60110, $2608ecfb9154a3b7$var$l = $2608ecfb9154a3b7$var$b ? Symbol.for("react.async_mode") : 60111, $2608ecfb9154a3b7$var$m = $2608ecfb9154a3b7$var$b ? Symbol.for("react.concurrent_mode") : 60111, $2608ecfb9154a3b7$var$n = $2608ecfb9154a3b7$var$b ? Symbol.for("react.forward_ref") : 60112, $2608ecfb9154a3b7$var$p = $2608ecfb9154a3b7$var$b ? Symbol.for("react.suspense") : 60113, $2608ecfb9154a3b7$var$q = $2608ecfb9154a3b7$var$b ? Symbol.for("react.suspense_list") : 60120, $2608ecfb9154a3b7$var$r = $2608ecfb9154a3b7$var$b ? Symbol.for("react.memo") : 60115, $2608ecfb9154a3b7$var$t = $2608ecfb9154a3b7$var$b ? Symbol.for("react.lazy") : 60116, $2608ecfb9154a3b7$var$v = $2608ecfb9154a3b7$var$b ? Symbol.for("react.block") : 60121, $2608ecfb9154a3b7$var$w = $2608ecfb9154a3b7$var$b ? Symbol.for("react.fundamental") : 60117, $2608ecfb9154a3b7$var$x = $2608ecfb9154a3b7$var$b ? Symbol.for("react.responder") : 60118, $2608ecfb9154a3b7$var$y = $2608ecfb9154a3b7$var$b ? Symbol.for("react.scope") : 60119;
function $2608ecfb9154a3b7$var$z(a) {
    if ("object" === typeof a && null !== a) {
        var u = a.$$typeof;
        switch(u){
            case $2608ecfb9154a3b7$var$c:
                switch(a = a.type, a){
                    case $2608ecfb9154a3b7$var$l:
                    case $2608ecfb9154a3b7$var$m:
                    case $2608ecfb9154a3b7$var$e:
                    case $2608ecfb9154a3b7$var$g:
                    case $2608ecfb9154a3b7$var$f:
                    case $2608ecfb9154a3b7$var$p:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $2608ecfb9154a3b7$var$k:
                            case $2608ecfb9154a3b7$var$n:
                            case $2608ecfb9154a3b7$var$t:
                            case $2608ecfb9154a3b7$var$r:
                            case $2608ecfb9154a3b7$var$h:
                                return a;
                            default:
                                return u;
                        }
                }
            case $2608ecfb9154a3b7$var$d:
                return u;
        }
    }
}
function $2608ecfb9154a3b7$var$A(a) {
    return $2608ecfb9154a3b7$var$z(a) === $2608ecfb9154a3b7$var$m;
}
$2608ecfb9154a3b7$export$2b8d127b894957b9 = $2608ecfb9154a3b7$var$l;
$2608ecfb9154a3b7$export$cea3a54a6425200c = $2608ecfb9154a3b7$var$m;
$2608ecfb9154a3b7$export$a7c73072b1a182ae = $2608ecfb9154a3b7$var$k;
$2608ecfb9154a3b7$export$9f27bc3417b4524d = $2608ecfb9154a3b7$var$h;
$2608ecfb9154a3b7$export$db77ccec0bb4ccac = $2608ecfb9154a3b7$var$c;
$2608ecfb9154a3b7$export$8392c0c9d3dcbd35 = $2608ecfb9154a3b7$var$n;
$2608ecfb9154a3b7$export$ffb0004e005737fa = $2608ecfb9154a3b7$var$e;
$2608ecfb9154a3b7$export$b624eff549462981 = $2608ecfb9154a3b7$var$t;
$2608ecfb9154a3b7$export$7897aa7841a5380c = $2608ecfb9154a3b7$var$r;
$2608ecfb9154a3b7$export$602eac185826482c = $2608ecfb9154a3b7$var$d;
$2608ecfb9154a3b7$export$e2c29f18771995cb = $2608ecfb9154a3b7$var$g;
$2608ecfb9154a3b7$export$5f8d39834fd61797 = $2608ecfb9154a3b7$var$f;
$2608ecfb9154a3b7$export$74bf444e3cd11ea5 = $2608ecfb9154a3b7$var$p;
$2608ecfb9154a3b7$export$92387174baf9b227 = function(a) {
    return $2608ecfb9154a3b7$var$A(a) || $2608ecfb9154a3b7$var$z(a) === $2608ecfb9154a3b7$var$l;
};
$2608ecfb9154a3b7$export$ec112efeb987d9c6 = $2608ecfb9154a3b7$var$A;
$2608ecfb9154a3b7$export$b706b080d889d2c9 = function(a) {
    return $2608ecfb9154a3b7$var$z(a) === $2608ecfb9154a3b7$var$k;
};
$2608ecfb9154a3b7$export$5be5a87408f70ddc = function(a) {
    return $2608ecfb9154a3b7$var$z(a) === $2608ecfb9154a3b7$var$h;
};
$2608ecfb9154a3b7$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $2608ecfb9154a3b7$var$c;
};
$2608ecfb9154a3b7$export$455c2e768291efa6 = function(a) {
    return $2608ecfb9154a3b7$var$z(a) === $2608ecfb9154a3b7$var$n;
};
$2608ecfb9154a3b7$export$9522e17588c12572 = function(a) {
    return $2608ecfb9154a3b7$var$z(a) === $2608ecfb9154a3b7$var$e;
};
$2608ecfb9154a3b7$export$2110ac352bb060b9 = function(a) {
    return $2608ecfb9154a3b7$var$z(a) === $2608ecfb9154a3b7$var$t;
};
$2608ecfb9154a3b7$export$56885ab8b9c456ab = function(a) {
    return $2608ecfb9154a3b7$var$z(a) === $2608ecfb9154a3b7$var$r;
};
$2608ecfb9154a3b7$export$d927fcb6adf8f9de = function(a) {
    return $2608ecfb9154a3b7$var$z(a) === $2608ecfb9154a3b7$var$d;
};
$2608ecfb9154a3b7$export$b82d16f27459e05a = function(a) {
    return $2608ecfb9154a3b7$var$z(a) === $2608ecfb9154a3b7$var$g;
};
$2608ecfb9154a3b7$export$522c17b4f5e123e8 = function(a) {
    return $2608ecfb9154a3b7$var$z(a) === $2608ecfb9154a3b7$var$f;
};
$2608ecfb9154a3b7$export$1aabd8a0274ecfd6 = function(a) {
    return $2608ecfb9154a3b7$var$z(a) === $2608ecfb9154a3b7$var$p;
};
$2608ecfb9154a3b7$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $2608ecfb9154a3b7$var$e || a === $2608ecfb9154a3b7$var$m || a === $2608ecfb9154a3b7$var$g || a === $2608ecfb9154a3b7$var$f || a === $2608ecfb9154a3b7$var$p || a === $2608ecfb9154a3b7$var$q || "object" === typeof a && null !== a && (a.$$typeof === $2608ecfb9154a3b7$var$t || a.$$typeof === $2608ecfb9154a3b7$var$r || a.$$typeof === $2608ecfb9154a3b7$var$h || a.$$typeof === $2608ecfb9154a3b7$var$k || a.$$typeof === $2608ecfb9154a3b7$var$n || a.$$typeof === $2608ecfb9154a3b7$var$w || a.$$typeof === $2608ecfb9154a3b7$var$x || a.$$typeof === $2608ecfb9154a3b7$var$y || a.$$typeof === $2608ecfb9154a3b7$var$v);
};
$2608ecfb9154a3b7$export$f5bbd400c2f4426f = $2608ecfb9154a3b7$var$z;

});



parcelRegister("ktNo6", function(module, exports) {
$parcel$export(module.exports, "invariantIntlContext", () => $ee8cd37431c4074b$export$45c4bbf6e55bba1f);
$parcel$export(module.exports, "DEFAULT_INTL_CONFIG", () => $ee8cd37431c4074b$export$b52f8d6fc0d47415);
$parcel$export(module.exports, "assignUniqueKeysToParts", () => $ee8cd37431c4074b$export$cfec03d26465fa63);
$parcel$export(module.exports, "shallowEqual", () => $ee8cd37431c4074b$export$d36bdfa510afb180);

var $l2Z7B = parcelRequire("l2Z7B");

var $5FkrB = parcelRequire("5FkrB");

var $kVTHJ = parcelRequire("kVTHJ");

var $ftB2S = parcelRequire("ftB2S");
function $ee8cd37431c4074b$export$45c4bbf6e55bba1f(intl) {
    (0, $kVTHJ.invariant)(intl, "[React Intl] Could not find required `intl` object. <IntlProvider> needs to exist in the component ancestry.");
}
var $ee8cd37431c4074b$export$b52f8d6fc0d47415 = (0, $l2Z7B.__assign)((0, $l2Z7B.__assign)({}, (0, $ftB2S.DEFAULT_INTL_CONFIG)), {
    textComponent: $5FkrB.Fragment
});
function $ee8cd37431c4074b$export$cfec03d26465fa63(formatXMLElementFn) {
    return function(parts) {
        // eslint-disable-next-line prefer-rest-params
        return formatXMLElementFn($5FkrB.Children.toArray(parts));
    };
}
function $ee8cd37431c4074b$export$d36bdfa510afb180(objA, objB) {
    if (objA === objB) return true;
    if (!objA || !objB) return false;
    var aKeys = Object.keys(objA);
    var bKeys = Object.keys(objB);
    var len = aKeys.length;
    if (bKeys.length !== len) return false;
    for(var i = 0; i < len; i++){
        var key = aKeys[i];
        if (objA[key] !== objB[key] || !Object.prototype.hasOwnProperty.call(objB, key)) return false;
    }
    return true;
}

});
parcelRegister("kVTHJ", function(module, exports) {
$parcel$export(module.exports, "invariant", () => $f3d457438d3fe9d5$export$f5708dca728d7177);
/**
 * Cannot do Math.log(x) / Math.log(10) bc if IEEE floating point issue
 * @param x number
 */ function $f3d457438d3fe9d5$export$f535bb00660c42db(x) {
    // Cannot count string length via Number.toString because it may use scientific notation
    // for very small or very large numbers.
    return Math.floor(Math.log(x) * Math.LOG10E);
}
function $f3d457438d3fe9d5$export$76d90c956114f2c2(s, times) {
    if (typeof s.repeat === 'function') return s.repeat(times);
    var arr = new Array(times);
    for(var i = 0; i < arr.length; i++)arr[i] = s;
    return arr.join('');
}
function $f3d457438d3fe9d5$export$489176b9ebc725cc(map, pl, field, value) {
    if (!map.get(pl)) map.set(pl, Object.create(null));
    var slots = map.get(pl);
    slots[field] = value;
}
function $f3d457438d3fe9d5$export$d21499e79b5c28e2(map, pl, props) {
    for(var _i = 0, _a = Object.keys(props); _i < _a.length; _i++){
        var k = _a[_i];
        $f3d457438d3fe9d5$export$489176b9ebc725cc(map, pl, k, props[k]);
    }
}
function $f3d457438d3fe9d5$export$3fae2929ed23c202(map, pl, field) {
    return $f3d457438d3fe9d5$export$ca4e2274c058dd9f(map, pl, field)[field];
}
function $f3d457438d3fe9d5$export$ca4e2274c058dd9f(map, pl) {
    var fields = [];
    for(var _i = 2; _i < arguments.length; _i++)fields[_i - 2] = arguments[_i];
    var slots = map.get(pl);
    if (!slots) throw new TypeError("".concat(pl, " InternalSlot has not been initialized"));
    return fields.reduce(function(all, f) {
        all[f] = slots[f];
        return all;
    }, Object.create(null));
}
function $f3d457438d3fe9d5$export$25c75e09b890f24e(patternPart) {
    return patternPart.type === 'literal';
}
function $f3d457438d3fe9d5$export$fdab3c20aae16ddf(target, name, _a) {
    var value = _a.value;
    Object.defineProperty(target, name, {
        configurable: true,
        enumerable: false,
        writable: true,
        value: value
    });
}
var $f3d457438d3fe9d5$export$9049a02e759202e4 = /-u(?:-[0-9a-z]{2,8})+/gi;
function $f3d457438d3fe9d5$export$f5708dca728d7177(condition, message, Err) {
    if (Err === void 0) Err = Error;
    if (!condition) throw new Err(message);
}

});

parcelRegister("ftB2S", function(module, exports) {
$parcel$export(module.exports, "filterProps", () => $b4464ce91a872efb$export$d697c39a2985a4c);
$parcel$export(module.exports, "DEFAULT_INTL_CONFIG", () => $b4464ce91a872efb$export$b52f8d6fc0d47415);
$parcel$export(module.exports, "createIntlCache", () => $b4464ce91a872efb$export$51c4f4e973f2dc00);
$parcel$export(module.exports, "createFormatters", () => $b4464ce91a872efb$export$c3f4cd5551df13fd);
$parcel$export(module.exports, "getNamedFormat", () => $b4464ce91a872efb$export$4ee1db8ce44a209b);

var $l2Z7B = parcelRequire("l2Z7B");

var $9exF4 = parcelRequire("9exF4");

var $pW1k6 = parcelRequire("pW1k6");

var $lxO85 = parcelRequire("lxO85");
function $b4464ce91a872efb$export$d697c39a2985a4c(props, allowlist, defaults) {
    if (defaults === void 0) defaults = {};
    return allowlist.reduce(function(filtered, name) {
        if (name in props) filtered[name] = props[name];
        else if (name in defaults) filtered[name] = defaults[name];
        return filtered;
    }, {});
}
var $b4464ce91a872efb$var$defaultErrorHandler = function(error) {};
var $b4464ce91a872efb$var$defaultWarnHandler = function(warning) {};
var $b4464ce91a872efb$export$b52f8d6fc0d47415 = {
    formats: {},
    messages: {},
    timeZone: undefined,
    defaultLocale: 'en',
    defaultFormats: {},
    fallbackOnEmptyString: true,
    onError: $b4464ce91a872efb$var$defaultErrorHandler,
    onWarn: $b4464ce91a872efb$var$defaultWarnHandler
};
function $b4464ce91a872efb$export$51c4f4e973f2dc00() {
    return {
        dateTime: {},
        number: {},
        message: {},
        relativeTime: {},
        pluralRules: {},
        list: {},
        displayNames: {}
    };
}
function $b4464ce91a872efb$var$createFastMemoizeCache(store) {
    return {
        create: function() {
            return {
                get: function(key) {
                    return store[key];
                },
                set: function(key, value) {
                    store[key] = value;
                }
            };
        }
    };
}
function $b4464ce91a872efb$export$c3f4cd5551df13fd(cache) {
    if (cache === void 0) cache = $b4464ce91a872efb$export$51c4f4e973f2dc00();
    var RelativeTimeFormat = Intl.RelativeTimeFormat;
    var ListFormat = Intl.ListFormat;
    var DisplayNames = Intl.DisplayNames;
    var getDateTimeFormat = (0, $pW1k6.default)(function() {
        var _a;
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        return new ((_a = Intl.DateTimeFormat).bind.apply(_a, (0, $l2Z7B.__spreadArray)([
            void 0
        ], args, false)))();
    }, {
        cache: $b4464ce91a872efb$var$createFastMemoizeCache(cache.dateTime),
        strategy: (0, $pW1k6.strategies).variadic
    });
    var getNumberFormat = (0, $pW1k6.default)(function() {
        var _a;
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        return new ((_a = Intl.NumberFormat).bind.apply(_a, (0, $l2Z7B.__spreadArray)([
            void 0
        ], args, false)))();
    }, {
        cache: $b4464ce91a872efb$var$createFastMemoizeCache(cache.number),
        strategy: (0, $pW1k6.strategies).variadic
    });
    var getPluralRules = (0, $pW1k6.default)(function() {
        var _a;
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        return new ((_a = Intl.PluralRules).bind.apply(_a, (0, $l2Z7B.__spreadArray)([
            void 0
        ], args, false)))();
    }, {
        cache: $b4464ce91a872efb$var$createFastMemoizeCache(cache.pluralRules),
        strategy: (0, $pW1k6.strategies).variadic
    });
    return {
        getDateTimeFormat: getDateTimeFormat,
        getNumberFormat: getNumberFormat,
        getMessageFormat: (0, $pW1k6.default)(function(message, locales, overrideFormats, opts) {
            return new (0, $9exF4.IntlMessageFormat)(message, locales, overrideFormats, (0, $l2Z7B.__assign)({
                formatters: {
                    getNumberFormat: getNumberFormat,
                    getDateTimeFormat: getDateTimeFormat,
                    getPluralRules: getPluralRules
                }
            }, opts || {}));
        }, {
            cache: $b4464ce91a872efb$var$createFastMemoizeCache(cache.message),
            strategy: (0, $pW1k6.strategies).variadic
        }),
        getRelativeTimeFormat: (0, $pW1k6.default)(function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new (RelativeTimeFormat.bind.apply(RelativeTimeFormat, (0, $l2Z7B.__spreadArray)([
                void 0
            ], args, false)))();
        }, {
            cache: $b4464ce91a872efb$var$createFastMemoizeCache(cache.relativeTime),
            strategy: (0, $pW1k6.strategies).variadic
        }),
        getPluralRules: getPluralRules,
        getListFormat: (0, $pW1k6.default)(function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new (ListFormat.bind.apply(ListFormat, (0, $l2Z7B.__spreadArray)([
                void 0
            ], args, false)))();
        }, {
            cache: $b4464ce91a872efb$var$createFastMemoizeCache(cache.list),
            strategy: (0, $pW1k6.strategies).variadic
        }),
        getDisplayNames: (0, $pW1k6.default)(function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new (DisplayNames.bind.apply(DisplayNames, (0, $l2Z7B.__spreadArray)([
                void 0
            ], args, false)))();
        }, {
            cache: $b4464ce91a872efb$var$createFastMemoizeCache(cache.displayNames),
            strategy: (0, $pW1k6.strategies).variadic
        })
    };
}
function $b4464ce91a872efb$export$4ee1db8ce44a209b(formats, type, name, onError) {
    var formatType = formats && formats[type];
    var format;
    if (formatType) format = formatType[name];
    if (format) return format;
    onError(new (0, $lxO85.UnsupportedFormatterError)("No ".concat(type, " format named: ").concat(name)));
}

});
parcelRegister("9exF4", function(module, exports) {
$parcel$export(module.exports, "IntlMessageFormat", () => $6b8f88550973e494$export$d342343268debc40);
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/ 
var $l2Z7B = parcelRequire("l2Z7B");

var $6dpFj = parcelRequire("6dpFj");

var $pW1k6 = parcelRequire("pW1k6");

var $b1zcR = parcelRequire("b1zcR");
// -- MessageFormat --------------------------------------------------------
function $6b8f88550973e494$var$mergeConfig(c1, c2) {
    if (!c2) return c1;
    return (0, $l2Z7B.__assign)((0, $l2Z7B.__assign)((0, $l2Z7B.__assign)({}, c1 || {}), c2 || {}), Object.keys(c1).reduce(function(all, k) {
        all[k] = (0, $l2Z7B.__assign)((0, $l2Z7B.__assign)({}, c1[k]), c2[k] || {});
        return all;
    }, {}));
}
function $6b8f88550973e494$var$mergeConfigs(defaultConfig, configs) {
    if (!configs) return defaultConfig;
    return Object.keys(defaultConfig).reduce(function(all, k) {
        all[k] = $6b8f88550973e494$var$mergeConfig(defaultConfig[k], configs[k]);
        return all;
    }, (0, $l2Z7B.__assign)({}, defaultConfig));
}
function $6b8f88550973e494$var$createFastMemoizeCache(store) {
    return {
        create: function() {
            return {
                get: function(key) {
                    return store[key];
                },
                set: function(key, value) {
                    store[key] = value;
                }
            };
        }
    };
}
function $6b8f88550973e494$var$createDefaultFormatters(cache) {
    if (cache === void 0) cache = {
        number: {},
        dateTime: {},
        pluralRules: {}
    };
    return {
        getNumberFormat: (0, $pW1k6.default)(function() {
            var _a;
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new ((_a = Intl.NumberFormat).bind.apply(_a, (0, $l2Z7B.__spreadArray)([
                void 0
            ], args, false)))();
        }, {
            cache: $6b8f88550973e494$var$createFastMemoizeCache(cache.number),
            strategy: (0, $pW1k6.strategies).variadic
        }),
        getDateTimeFormat: (0, $pW1k6.default)(function() {
            var _a;
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new ((_a = Intl.DateTimeFormat).bind.apply(_a, (0, $l2Z7B.__spreadArray)([
                void 0
            ], args, false)))();
        }, {
            cache: $6b8f88550973e494$var$createFastMemoizeCache(cache.dateTime),
            strategy: (0, $pW1k6.strategies).variadic
        }),
        getPluralRules: (0, $pW1k6.default)(function() {
            var _a;
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new ((_a = Intl.PluralRules).bind.apply(_a, (0, $l2Z7B.__spreadArray)([
                void 0
            ], args, false)))();
        }, {
            cache: $6b8f88550973e494$var$createFastMemoizeCache(cache.pluralRules),
            strategy: (0, $pW1k6.strategies).variadic
        })
    };
}
var $6b8f88550973e494$export$d342343268debc40 = /** @class */ function() {
    function IntlMessageFormat(message, locales, overrideFormats, opts) {
        var _this = this;
        if (locales === void 0) locales = IntlMessageFormat.defaultLocale;
        this.formatterCache = {
            number: {},
            dateTime: {},
            pluralRules: {}
        };
        this.format = function(values) {
            var parts = _this.formatToParts(values);
            // Hot path for straight simple msg translations
            if (parts.length === 1) return parts[0].value;
            var result = parts.reduce(function(all, part) {
                if (!all.length || part.type !== (0, $b1zcR.PART_TYPE).literal || typeof all[all.length - 1] !== 'string') all.push(part.value);
                else all[all.length - 1] += part.value;
                return all;
            }, []);
            if (result.length <= 1) return result[0] || '';
            return result;
        };
        this.formatToParts = function(values) {
            return (0, $b1zcR.formatToParts)(_this.ast, _this.locales, _this.formatters, _this.formats, values, undefined, _this.message);
        };
        this.resolvedOptions = function() {
            return {
                locale: _this.resolvedLocale.toString()
            };
        };
        this.getAst = function() {
            return _this.ast;
        };
        // Defined first because it's used to build the format pattern.
        this.locales = locales;
        this.resolvedLocale = IntlMessageFormat.resolveLocale(locales);
        if (typeof message === 'string') {
            this.message = message;
            if (!IntlMessageFormat.__parse) throw new TypeError('IntlMessageFormat.__parse must be set to process `message` of type `string`');
            // Parse string messages into an AST.
            this.ast = IntlMessageFormat.__parse(message, {
                ignoreTag: opts === null || opts === void 0 ? void 0 : opts.ignoreTag,
                locale: this.resolvedLocale
            });
        } else this.ast = message;
        if (!Array.isArray(this.ast)) throw new TypeError('A message must be provided as a String or AST.');
        // Creates a new object with the specified `formats` merged with the default
        // formats.
        this.formats = $6b8f88550973e494$var$mergeConfigs(IntlMessageFormat.formats, overrideFormats);
        this.formatters = opts && opts.formatters || $6b8f88550973e494$var$createDefaultFormatters(this.formatterCache);
    }
    Object.defineProperty(IntlMessageFormat, "defaultLocale", {
        get: function() {
            if (!IntlMessageFormat.memoizedDefaultLocale) IntlMessageFormat.memoizedDefaultLocale = new Intl.NumberFormat().resolvedOptions().locale;
            return IntlMessageFormat.memoizedDefaultLocale;
        },
        enumerable: false,
        configurable: true
    });
    IntlMessageFormat.memoizedDefaultLocale = null;
    IntlMessageFormat.resolveLocale = function(locales) {
        var supportedLocales = Intl.NumberFormat.supportedLocalesOf(locales);
        if (supportedLocales.length > 0) return new Intl.Locale(supportedLocales[0]);
        return new Intl.Locale(typeof locales === 'string' ? locales : locales[0]);
    };
    IntlMessageFormat.__parse = (0, $6dpFj.parse);
    // Default format options used as the prototype of the `formats` provided to the
    // constructor. These are used when constructing the internal Intl.NumberFormat
    // and Intl.DateTimeFormat instances.
    IntlMessageFormat.formats = {
        number: {
            integer: {
                maximumFractionDigits: 0
            },
            currency: {
                style: 'currency'
            },
            percent: {
                style: 'percent'
            }
        },
        date: {
            short: {
                month: 'numeric',
                day: 'numeric',
                year: '2-digit'
            },
            medium: {
                month: 'short',
                day: 'numeric',
                year: 'numeric'
            },
            long: {
                month: 'long',
                day: 'numeric',
                year: 'numeric'
            },
            full: {
                weekday: 'long',
                month: 'long',
                day: 'numeric',
                year: 'numeric'
            }
        },
        time: {
            short: {
                hour: 'numeric',
                minute: 'numeric'
            },
            medium: {
                hour: 'numeric',
                minute: 'numeric',
                second: 'numeric'
            },
            long: {
                hour: 'numeric',
                minute: 'numeric',
                second: 'numeric',
                timeZoneName: 'short'
            },
            full: {
                hour: 'numeric',
                minute: 'numeric',
                second: 'numeric',
                timeZoneName: 'short'
            }
        }
    };
    return IntlMessageFormat;
}();

});
parcelRegister("6dpFj", function(module, exports) {
$parcel$export(module.exports, "isArgumentElement", () => (parcelRequire("4VghZ")).isArgumentElement);
$parcel$export(module.exports, "isDateElement", () => (parcelRequire("4VghZ")).isDateElement);
$parcel$export(module.exports, "isDateTimeSkeleton", () => (parcelRequire("4VghZ")).isDateTimeSkeleton);
$parcel$export(module.exports, "isLiteralElement", () => (parcelRequire("4VghZ")).isLiteralElement);
$parcel$export(module.exports, "isNumberElement", () => (parcelRequire("4VghZ")).isNumberElement);
$parcel$export(module.exports, "isNumberSkeleton", () => (parcelRequire("4VghZ")).isNumberSkeleton);
$parcel$export(module.exports, "isPluralElement", () => (parcelRequire("4VghZ")).isPluralElement);
$parcel$export(module.exports, "isPoundElement", () => (parcelRequire("4VghZ")).isPoundElement);
$parcel$export(module.exports, "isSelectElement", () => (parcelRequire("4VghZ")).isSelectElement);
$parcel$export(module.exports, "isTagElement", () => (parcelRequire("4VghZ")).isTagElement);
$parcel$export(module.exports, "isTimeElement", () => (parcelRequire("4VghZ")).isTimeElement);
$parcel$export(module.exports, "TYPE", () => (parcelRequire("4VghZ")).TYPE);
$parcel$export(module.exports, "parse", () => $4867dd96a90c056b$export$98e6a39c04603d36);

var $l2Z7B = parcelRequire("l2Z7B");

var $1qhWu = parcelRequire("1qhWu");

var $5DR7r = parcelRequire("5DR7r");

var $4VghZ = parcelRequire("4VghZ");
function $4867dd96a90c056b$var$pruneLocation(els) {
    els.forEach(function(el) {
        delete el.location;
        if ((0, $4VghZ.isSelectElement)(el) || (0, $4VghZ.isPluralElement)(el)) for(var k in el.options){
            delete el.options[k].location;
            $4867dd96a90c056b$var$pruneLocation(el.options[k].value);
        }
        else if ((0, $4VghZ.isNumberElement)(el) && (0, $4VghZ.isNumberSkeleton)(el.style)) delete el.style.location;
        else if (((0, $4VghZ.isDateElement)(el) || (0, $4VghZ.isTimeElement)(el)) && (0, $4VghZ.isDateTimeSkeleton)(el.style)) delete el.style.location;
        else if ((0, $4VghZ.isTagElement)(el)) $4867dd96a90c056b$var$pruneLocation(el.children);
    });
}
function $4867dd96a90c056b$export$98e6a39c04603d36(message, opts) {
    if (opts === void 0) opts = {};
    opts = (0, $l2Z7B.__assign)({
        shouldParseSkeletons: true,
        requiresOtherClause: true
    }, opts);
    var result = new (0, $5DR7r.Parser)(message, opts).parse();
    if (result.err) {
        var error = SyntaxError((0, $1qhWu.ErrorKind)[result.err.kind]);
        // @ts-expect-error Assign to error object
        error.location = result.err.location;
        // @ts-expect-error Assign to error object
        error.originalMessage = result.err.message;
        throw error;
    }
    if (!(opts === null || opts === void 0 ? void 0 : opts.captureLocation)) $4867dd96a90c056b$var$pruneLocation(result.val);
    return result.val;
}

});
parcelRegister("1qhWu", function(module, exports) {
$parcel$export(module.exports, "ErrorKind", () => $109623254d5d054c$export$896afd8541959ee5);
var $109623254d5d054c$export$896afd8541959ee5;
(function(ErrorKind) {
    /** Argument is unclosed (e.g. `{0`) */ ErrorKind[ErrorKind["EXPECT_ARGUMENT_CLOSING_BRACE"] = 1] = "EXPECT_ARGUMENT_CLOSING_BRACE";
    /** Argument is empty (e.g. `{}`). */ ErrorKind[ErrorKind["EMPTY_ARGUMENT"] = 2] = "EMPTY_ARGUMENT";
    /** Argument is malformed (e.g. `{foo!}``) */ ErrorKind[ErrorKind["MALFORMED_ARGUMENT"] = 3] = "MALFORMED_ARGUMENT";
    /** Expect an argument type (e.g. `{foo,}`) */ ErrorKind[ErrorKind["EXPECT_ARGUMENT_TYPE"] = 4] = "EXPECT_ARGUMENT_TYPE";
    /** Unsupported argument type (e.g. `{foo,foo}`) */ ErrorKind[ErrorKind["INVALID_ARGUMENT_TYPE"] = 5] = "INVALID_ARGUMENT_TYPE";
    /** Expect an argument style (e.g. `{foo, number, }`) */ ErrorKind[ErrorKind["EXPECT_ARGUMENT_STYLE"] = 6] = "EXPECT_ARGUMENT_STYLE";
    /** The number skeleton is invalid. */ ErrorKind[ErrorKind["INVALID_NUMBER_SKELETON"] = 7] = "INVALID_NUMBER_SKELETON";
    /** The date time skeleton is invalid. */ ErrorKind[ErrorKind["INVALID_DATE_TIME_SKELETON"] = 8] = "INVALID_DATE_TIME_SKELETON";
    /** Exepct a number skeleton following the `::` (e.g. `{foo, number, ::}`) */ ErrorKind[ErrorKind["EXPECT_NUMBER_SKELETON"] = 9] = "EXPECT_NUMBER_SKELETON";
    /** Exepct a date time skeleton following the `::` (e.g. `{foo, date, ::}`) */ ErrorKind[ErrorKind["EXPECT_DATE_TIME_SKELETON"] = 10] = "EXPECT_DATE_TIME_SKELETON";
    /** Unmatched apostrophes in the argument style (e.g. `{foo, number, 'test`) */ ErrorKind[ErrorKind["UNCLOSED_QUOTE_IN_ARGUMENT_STYLE"] = 11] = "UNCLOSED_QUOTE_IN_ARGUMENT_STYLE";
    /** Missing select argument options (e.g. `{foo, select}`) */ ErrorKind[ErrorKind["EXPECT_SELECT_ARGUMENT_OPTIONS"] = 12] = "EXPECT_SELECT_ARGUMENT_OPTIONS";
    /** Expecting an offset value in `plural` or `selectordinal` argument (e.g `{foo, plural, offset}`) */ ErrorKind[ErrorKind["EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE"] = 13] = "EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE";
    /** Offset value in `plural` or `selectordinal` is invalid (e.g. `{foo, plural, offset: x}`) */ ErrorKind[ErrorKind["INVALID_PLURAL_ARGUMENT_OFFSET_VALUE"] = 14] = "INVALID_PLURAL_ARGUMENT_OFFSET_VALUE";
    /** Expecting a selector in `select` argument (e.g `{foo, select}`) */ ErrorKind[ErrorKind["EXPECT_SELECT_ARGUMENT_SELECTOR"] = 15] = "EXPECT_SELECT_ARGUMENT_SELECTOR";
    /** Expecting a selector in `plural` or `selectordinal` argument (e.g `{foo, plural}`) */ ErrorKind[ErrorKind["EXPECT_PLURAL_ARGUMENT_SELECTOR"] = 16] = "EXPECT_PLURAL_ARGUMENT_SELECTOR";
    /** Expecting a message fragment after the `select` selector (e.g. `{foo, select, apple}`) */ ErrorKind[ErrorKind["EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT"] = 17] = "EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT";
    /**
     * Expecting a message fragment after the `plural` or `selectordinal` selector
     * (e.g. `{foo, plural, one}`)
     */ ErrorKind[ErrorKind["EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT"] = 18] = "EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT";
    /** Selector in `plural` or `selectordinal` is malformed (e.g. `{foo, plural, =x {#}}`) */ ErrorKind[ErrorKind["INVALID_PLURAL_ARGUMENT_SELECTOR"] = 19] = "INVALID_PLURAL_ARGUMENT_SELECTOR";
    /**
     * Duplicate selectors in `plural` or `selectordinal` argument.
     * (e.g. {foo, plural, one {#} one {#}})
     */ ErrorKind[ErrorKind["DUPLICATE_PLURAL_ARGUMENT_SELECTOR"] = 20] = "DUPLICATE_PLURAL_ARGUMENT_SELECTOR";
    /** Duplicate selectors in `select` argument.
     * (e.g. {foo, select, apple {apple} apple {apple}})
     */ ErrorKind[ErrorKind["DUPLICATE_SELECT_ARGUMENT_SELECTOR"] = 21] = "DUPLICATE_SELECT_ARGUMENT_SELECTOR";
    /** Plural or select argument option must have `other` clause. */ ErrorKind[ErrorKind["MISSING_OTHER_CLAUSE"] = 22] = "MISSING_OTHER_CLAUSE";
    /** The tag is malformed. (e.g. `<bold!>foo</bold!>) */ ErrorKind[ErrorKind["INVALID_TAG"] = 23] = "INVALID_TAG";
    /** The tag name is invalid. (e.g. `<123>foo</123>`) */ ErrorKind[ErrorKind["INVALID_TAG_NAME"] = 25] = "INVALID_TAG_NAME";
    /** The closing tag does not match the opening tag. (e.g. `<bold>foo</italic>`) */ ErrorKind[ErrorKind["UNMATCHED_CLOSING_TAG"] = 26] = "UNMATCHED_CLOSING_TAG";
    /** The opening tag has unmatched closing tag. (e.g. `<bold>foo`) */ ErrorKind[ErrorKind["UNCLOSED_TAG"] = 27] = "UNCLOSED_TAG";
})($109623254d5d054c$export$896afd8541959ee5 || ($109623254d5d054c$export$896afd8541959ee5 = {}));

});

parcelRegister("5DR7r", function(module, exports) {
$parcel$export(module.exports, "Parser", () => $41b9cca01985965f$export$7acfa6ed01010e37);

var $l2Z7B = parcelRequire("l2Z7B");

var $1qhWu = parcelRequire("1qhWu");

var $4VghZ = parcelRequire("4VghZ");

var $1tlBf = parcelRequire("1tlBf");
parcelRequire("3Uiry");
var $aYwqB = parcelRequire("aYwqB");
var $4f4OJ = parcelRequire("4f4OJ");

var $h8PxH = parcelRequire("h8PxH");
var $41b9cca01985965f$var$_a;
var $41b9cca01985965f$var$SPACE_SEPARATOR_START_REGEX = new RegExp("^".concat((0, $1tlBf.SPACE_SEPARATOR_REGEX).source, "*"));
var $41b9cca01985965f$var$SPACE_SEPARATOR_END_REGEX = new RegExp("".concat((0, $1tlBf.SPACE_SEPARATOR_REGEX).source, "*$"));
function $41b9cca01985965f$var$createLocation(start, end) {
    return {
        start: start,
        end: end
    };
}
// #region Ponyfills
// Consolidate these variables up top for easier toggling during debugging
var $41b9cca01985965f$var$hasNativeStartsWith = !!String.prototype.startsWith;
var $41b9cca01985965f$var$hasNativeFromCodePoint = !!String.fromCodePoint;
var $41b9cca01985965f$var$hasNativeFromEntries = !!Object.fromEntries;
var $41b9cca01985965f$var$hasNativeCodePointAt = !!String.prototype.codePointAt;
var $41b9cca01985965f$var$hasTrimStart = !!String.prototype.trimStart;
var $41b9cca01985965f$var$hasTrimEnd = !!String.prototype.trimEnd;
var $41b9cca01985965f$var$hasNativeIsSafeInteger = !!Number.isSafeInteger;
var $41b9cca01985965f$var$isSafeInteger = $41b9cca01985965f$var$hasNativeIsSafeInteger ? Number.isSafeInteger : function(n) {
    return typeof n === 'number' && isFinite(n) && Math.floor(n) === n && Math.abs(n) <= 0x1fffffffffffff;
};
// IE11 does not support y and u.
var $41b9cca01985965f$var$REGEX_SUPPORTS_U_AND_Y = true;
try {
    var $41b9cca01985965f$var$re = $41b9cca01985965f$var$RE('([^\\p{White_Space}\\p{Pattern_Syntax}]*)', 'yu');
    /**
     * legacy Edge or Xbox One browser
     * Unicode flag support: supported
     * Pattern_Syntax support: not supported
     * See https://github.com/formatjs/formatjs/issues/2822
     */ $41b9cca01985965f$var$REGEX_SUPPORTS_U_AND_Y = (($41b9cca01985965f$var$_a = $41b9cca01985965f$var$re.exec('a')) === null || $41b9cca01985965f$var$_a === void 0 ? void 0 : $41b9cca01985965f$var$_a[0]) === 'a';
} catch (_) {
    $41b9cca01985965f$var$REGEX_SUPPORTS_U_AND_Y = false;
}
var $41b9cca01985965f$var$startsWith = $41b9cca01985965f$var$hasNativeStartsWith ? function startsWith(s, search, position) {
    return s.startsWith(search, position);
} : function startsWith(s, search, position) {
    return s.slice(position, position + search.length) === search;
};
var $41b9cca01985965f$var$fromCodePoint = $41b9cca01985965f$var$hasNativeFromCodePoint ? String.fromCodePoint : function fromCodePoint() {
    var codePoints = [];
    for(var _i = 0; _i < arguments.length; _i++)codePoints[_i] = arguments[_i];
    var elements = '';
    var length = codePoints.length;
    var i = 0;
    var code;
    while(length > i){
        code = codePoints[i++];
        if (code > 0x10ffff) throw RangeError(code + ' is not a valid code point');
        elements += code < 0x10000 ? String.fromCharCode(code) : String.fromCharCode(((code -= 0x10000) >> 10) + 0xd800, code % 0x400 + 0xdc00);
    }
    return elements;
};
var $41b9cca01985965f$var$fromEntries = // native
$41b9cca01985965f$var$hasNativeFromEntries ? Object.fromEntries : function fromEntries(entries) {
    var obj = {};
    for(var _i = 0, entries_1 = entries; _i < entries_1.length; _i++){
        var _a = entries_1[_i], k = _a[0], v = _a[1];
        obj[k] = v;
    }
    return obj;
};
var $41b9cca01985965f$var$codePointAt = $41b9cca01985965f$var$hasNativeCodePointAt ? function codePointAt(s, index) {
    return s.codePointAt(index);
} : function codePointAt(s, index) {
    var size = s.length;
    if (index < 0 || index >= size) return undefined;
    var first = s.charCodeAt(index);
    var second;
    return first < 0xd800 || first > 0xdbff || index + 1 === size || (second = s.charCodeAt(index + 1)) < 0xdc00 || second > 0xdfff ? first : (first - 0xd800 << 10) + (second - 0xdc00) + 0x10000;
};
var $41b9cca01985965f$var$trimStart = $41b9cca01985965f$var$hasTrimStart ? function trimStart(s) {
    return s.trimStart();
} : function trimStart(s) {
    return s.replace($41b9cca01985965f$var$SPACE_SEPARATOR_START_REGEX, '');
};
var $41b9cca01985965f$var$trimEnd = $41b9cca01985965f$var$hasTrimEnd ? function trimEnd(s) {
    return s.trimEnd();
} : function trimEnd(s) {
    return s.replace($41b9cca01985965f$var$SPACE_SEPARATOR_END_REGEX, '');
};
// Prevent minifier to translate new RegExp to literal form that might cause syntax error on IE11.
function $41b9cca01985965f$var$RE(s, flag) {
    return new RegExp(s, flag);
}
// #endregion
var $41b9cca01985965f$var$matchIdentifierAtIndex;
if ($41b9cca01985965f$var$REGEX_SUPPORTS_U_AND_Y) {
    // Native
    var $41b9cca01985965f$var$IDENTIFIER_PREFIX_RE_1 = $41b9cca01985965f$var$RE('([^\\p{White_Space}\\p{Pattern_Syntax}]*)', 'yu');
    $41b9cca01985965f$var$matchIdentifierAtIndex = function matchIdentifierAtIndex(s, index) {
        var _a;
        $41b9cca01985965f$var$IDENTIFIER_PREFIX_RE_1.lastIndex = index;
        var match = $41b9cca01985965f$var$IDENTIFIER_PREFIX_RE_1.exec(s);
        return (_a = match[1]) !== null && _a !== void 0 ? _a : '';
    };
} else // IE11
$41b9cca01985965f$var$matchIdentifierAtIndex = function matchIdentifierAtIndex(s, index) {
    var match = [];
    while(true){
        var c = $41b9cca01985965f$var$codePointAt(s, index);
        if (c === undefined || $41b9cca01985965f$var$_isWhiteSpace(c) || $41b9cca01985965f$var$_isPatternSyntax(c)) break;
        match.push(c);
        index += c >= 0x10000 ? 2 : 1;
    }
    return $41b9cca01985965f$var$fromCodePoint.apply(void 0, match);
};
var $41b9cca01985965f$export$7acfa6ed01010e37 = /** @class */ function() {
    function Parser(message, options) {
        if (options === void 0) options = {};
        this.message = message;
        this.position = {
            offset: 0,
            line: 1,
            column: 1
        };
        this.ignoreTag = !!options.ignoreTag;
        this.locale = options.locale;
        this.requiresOtherClause = !!options.requiresOtherClause;
        this.shouldParseSkeletons = !!options.shouldParseSkeletons;
    }
    Parser.prototype.parse = function() {
        if (this.offset() !== 0) throw Error('parser can only be used once');
        return this.parseMessage(0, '', false);
    };
    Parser.prototype.parseMessage = function(nestingLevel, parentArgType, expectingCloseTag) {
        var elements = [];
        while(!this.isEOF()){
            var char = this.char();
            if (char === 123 /* `{` */ ) {
                var result = this.parseArgument(nestingLevel, expectingCloseTag);
                if (result.err) return result;
                elements.push(result.val);
            } else if (char === 125 /* `}` */  && nestingLevel > 0) break;
            else if (char === 35 /* `#` */  && (parentArgType === 'plural' || parentArgType === 'selectordinal')) {
                var position = this.clonePosition();
                this.bump();
                elements.push({
                    type: (0, $4VghZ.TYPE).pound,
                    location: $41b9cca01985965f$var$createLocation(position, this.clonePosition())
                });
            } else if (char === 60 /* `<` */  && !this.ignoreTag && this.peek() === 47 // char code for '/'
            ) {
                if (expectingCloseTag) break;
                else return this.error((0, $1qhWu.ErrorKind).UNMATCHED_CLOSING_TAG, $41b9cca01985965f$var$createLocation(this.clonePosition(), this.clonePosition()));
            } else if (char === 60 /* `<` */  && !this.ignoreTag && $41b9cca01985965f$var$_isAlpha(this.peek() || 0)) {
                var result = this.parseTag(nestingLevel, parentArgType);
                if (result.err) return result;
                elements.push(result.val);
            } else {
                var result = this.parseLiteral(nestingLevel, parentArgType);
                if (result.err) return result;
                elements.push(result.val);
            }
        }
        return {
            val: elements,
            err: null
        };
    };
    /**
     * A tag name must start with an ASCII lower/upper case letter. The grammar is based on the
     * [custom element name][] except that a dash is NOT always mandatory and uppercase letters
     * are accepted:
     *
     * ```
     * tag ::= "<" tagName (whitespace)* "/>" | "<" tagName (whitespace)* ">" message "</" tagName (whitespace)* ">"
     * tagName ::= [a-z] (PENChar)*
     * PENChar ::=
     *     "-" | "." | [0-9] | "_" | [a-z] | [A-Z] | #xB7 | [#xC0-#xD6] | [#xD8-#xF6] | [#xF8-#x37D] |
     *     [#x37F-#x1FFF] | [#x200C-#x200D] | [#x203F-#x2040] | [#x2070-#x218F] | [#x2C00-#x2FEF] |
     *     [#x3001-#xD7FF] | [#xF900-#xFDCF] | [#xFDF0-#xFFFD] | [#x10000-#xEFFFF]
     * ```
     *
     * [custom element name]: https://html.spec.whatwg.org/multipage/custom-elements.html#valid-custom-element-name
     * NOTE: We're a bit more lax here since HTML technically does not allow uppercase HTML element but we do
     * since other tag-based engines like React allow it
     */ Parser.prototype.parseTag = function(nestingLevel, parentArgType) {
        var startPosition = this.clonePosition();
        this.bump(); // `<`
        var tagName = this.parseTagName();
        this.bumpSpace();
        if (this.bumpIf('/>')) // Self closing tag
        return {
            val: {
                type: (0, $4VghZ.TYPE).literal,
                value: "<".concat(tagName, "/>"),
                location: $41b9cca01985965f$var$createLocation(startPosition, this.clonePosition())
            },
            err: null
        };
        else if (this.bumpIf('>')) {
            var childrenResult = this.parseMessage(nestingLevel + 1, parentArgType, true);
            if (childrenResult.err) return childrenResult;
            var children = childrenResult.val;
            // Expecting a close tag
            var endTagStartPosition = this.clonePosition();
            if (this.bumpIf('</')) {
                if (this.isEOF() || !$41b9cca01985965f$var$_isAlpha(this.char())) return this.error((0, $1qhWu.ErrorKind).INVALID_TAG, $41b9cca01985965f$var$createLocation(endTagStartPosition, this.clonePosition()));
                var closingTagNameStartPosition = this.clonePosition();
                var closingTagName = this.parseTagName();
                if (tagName !== closingTagName) return this.error((0, $1qhWu.ErrorKind).UNMATCHED_CLOSING_TAG, $41b9cca01985965f$var$createLocation(closingTagNameStartPosition, this.clonePosition()));
                this.bumpSpace();
                if (!this.bumpIf('>')) return this.error((0, $1qhWu.ErrorKind).INVALID_TAG, $41b9cca01985965f$var$createLocation(endTagStartPosition, this.clonePosition()));
                return {
                    val: {
                        type: (0, $4VghZ.TYPE).tag,
                        value: tagName,
                        children: children,
                        location: $41b9cca01985965f$var$createLocation(startPosition, this.clonePosition())
                    },
                    err: null
                };
            } else return this.error((0, $1qhWu.ErrorKind).UNCLOSED_TAG, $41b9cca01985965f$var$createLocation(startPosition, this.clonePosition()));
        } else return this.error((0, $1qhWu.ErrorKind).INVALID_TAG, $41b9cca01985965f$var$createLocation(startPosition, this.clonePosition()));
    };
    /**
     * This method assumes that the caller has peeked ahead for the first tag character.
     */ Parser.prototype.parseTagName = function() {
        var startOffset = this.offset();
        this.bump(); // the first tag name character
        while(!this.isEOF() && $41b9cca01985965f$var$_isPotentialElementNameChar(this.char()))this.bump();
        return this.message.slice(startOffset, this.offset());
    };
    Parser.prototype.parseLiteral = function(nestingLevel, parentArgType) {
        var start = this.clonePosition();
        var value = '';
        while(true){
            var parseQuoteResult = this.tryParseQuote(parentArgType);
            if (parseQuoteResult) {
                value += parseQuoteResult;
                continue;
            }
            var parseUnquotedResult = this.tryParseUnquoted(nestingLevel, parentArgType);
            if (parseUnquotedResult) {
                value += parseUnquotedResult;
                continue;
            }
            var parseLeftAngleResult = this.tryParseLeftAngleBracket();
            if (parseLeftAngleResult) {
                value += parseLeftAngleResult;
                continue;
            }
            break;
        }
        var location = $41b9cca01985965f$var$createLocation(start, this.clonePosition());
        return {
            val: {
                type: (0, $4VghZ.TYPE).literal,
                value: value,
                location: location
            },
            err: null
        };
    };
    Parser.prototype.tryParseLeftAngleBracket = function() {
        if (!this.isEOF() && this.char() === 60 /* `<` */  && (this.ignoreTag || // If at the opening tag or closing tag position, bail.
        !$41b9cca01985965f$var$_isAlphaOrSlash(this.peek() || 0))) {
            this.bump(); // `<`
            return '<';
        }
        return null;
    };
    /**
     * Starting with ICU 4.8, an ASCII apostrophe only starts quoted text if it immediately precedes
     * a character that requires quoting (that is, "only where needed"), and works the same in
     * nested messages as on the top level of the pattern. The new behavior is otherwise compatible.
     */ Parser.prototype.tryParseQuote = function(parentArgType) {
        if (this.isEOF() || this.char() !== 39 /* `'` */ ) return null;
        // Parse escaped char following the apostrophe, or early return if there is no escaped char.
        // Check if is valid escaped character
        switch(this.peek()){
            case 39 /* `'` */ :
                // double quote, should return as a single quote.
                this.bump();
                this.bump();
                return "'";
            // '{', '<', '>', '}'
            case 123:
            case 60:
            case 62:
            case 125:
                break;
            case 35:
                if (parentArgType === 'plural' || parentArgType === 'selectordinal') break;
                return null;
            default:
                return null;
        }
        this.bump(); // apostrophe
        var codePoints = [
            this.char()
        ]; // escaped char
        this.bump();
        // read chars until the optional closing apostrophe is found
        while(!this.isEOF()){
            var ch = this.char();
            if (ch === 39 /* `'` */ ) {
                if (this.peek() === 39 /* `'` */ ) {
                    codePoints.push(39);
                    // Bump one more time because we need to skip 2 characters.
                    this.bump();
                } else {
                    // Optional closing apostrophe.
                    this.bump();
                    break;
                }
            } else codePoints.push(ch);
            this.bump();
        }
        return $41b9cca01985965f$var$fromCodePoint.apply(void 0, codePoints);
    };
    Parser.prototype.tryParseUnquoted = function(nestingLevel, parentArgType) {
        if (this.isEOF()) return null;
        var ch = this.char();
        if (ch === 60 /* `<` */  || ch === 123 /* `{` */  || ch === 35 /* `#` */  && (parentArgType === 'plural' || parentArgType === 'selectordinal') || ch === 125 /* `}` */  && nestingLevel > 0) return null;
        else {
            this.bump();
            return $41b9cca01985965f$var$fromCodePoint(ch);
        }
    };
    Parser.prototype.parseArgument = function(nestingLevel, expectingCloseTag) {
        var openingBracePosition = this.clonePosition();
        this.bump(); // `{`
        this.bumpSpace();
        if (this.isEOF()) return this.error((0, $1qhWu.ErrorKind).EXPECT_ARGUMENT_CLOSING_BRACE, $41b9cca01985965f$var$createLocation(openingBracePosition, this.clonePosition()));
        if (this.char() === 125 /* `}` */ ) {
            this.bump();
            return this.error((0, $1qhWu.ErrorKind).EMPTY_ARGUMENT, $41b9cca01985965f$var$createLocation(openingBracePosition, this.clonePosition()));
        }
        // argument name
        var value = this.parseIdentifierIfPossible().value;
        if (!value) return this.error((0, $1qhWu.ErrorKind).MALFORMED_ARGUMENT, $41b9cca01985965f$var$createLocation(openingBracePosition, this.clonePosition()));
        this.bumpSpace();
        if (this.isEOF()) return this.error((0, $1qhWu.ErrorKind).EXPECT_ARGUMENT_CLOSING_BRACE, $41b9cca01985965f$var$createLocation(openingBracePosition, this.clonePosition()));
        switch(this.char()){
            // Simple argument: `{name}`
            case 125 /* `}` */ :
                this.bump(); // `}`
                return {
                    val: {
                        type: (0, $4VghZ.TYPE).argument,
                        // value does not include the opening and closing braces.
                        value: value,
                        location: $41b9cca01985965f$var$createLocation(openingBracePosition, this.clonePosition())
                    },
                    err: null
                };
            // Argument with options: `{name, format, ...}`
            case 44 /* `,` */ :
                this.bump(); // `,`
                this.bumpSpace();
                if (this.isEOF()) return this.error((0, $1qhWu.ErrorKind).EXPECT_ARGUMENT_CLOSING_BRACE, $41b9cca01985965f$var$createLocation(openingBracePosition, this.clonePosition()));
                return this.parseArgumentOptions(nestingLevel, expectingCloseTag, value, openingBracePosition);
            default:
                return this.error((0, $1qhWu.ErrorKind).MALFORMED_ARGUMENT, $41b9cca01985965f$var$createLocation(openingBracePosition, this.clonePosition()));
        }
    };
    /**
     * Advance the parser until the end of the identifier, if it is currently on
     * an identifier character. Return an empty string otherwise.
     */ Parser.prototype.parseIdentifierIfPossible = function() {
        var startingPosition = this.clonePosition();
        var startOffset = this.offset();
        var value = $41b9cca01985965f$var$matchIdentifierAtIndex(this.message, startOffset);
        var endOffset = startOffset + value.length;
        this.bumpTo(endOffset);
        var endPosition = this.clonePosition();
        var location = $41b9cca01985965f$var$createLocation(startingPosition, endPosition);
        return {
            value: value,
            location: location
        };
    };
    Parser.prototype.parseArgumentOptions = function(nestingLevel, expectingCloseTag, value, openingBracePosition) {
        var _a;
        // Parse this range:
        // {name, type, style}
        //        ^---^
        var typeStartPosition = this.clonePosition();
        var argType = this.parseIdentifierIfPossible().value;
        var typeEndPosition = this.clonePosition();
        switch(argType){
            case '':
                // Expecting a style string number, date, time, plural, selectordinal, or select.
                return this.error((0, $1qhWu.ErrorKind).EXPECT_ARGUMENT_TYPE, $41b9cca01985965f$var$createLocation(typeStartPosition, typeEndPosition));
            case 'number':
            case 'date':
            case 'time':
                // Parse this range:
                // {name, number, style}
                //              ^-------^
                this.bumpSpace();
                var styleAndLocation = null;
                if (this.bumpIf(',')) {
                    this.bumpSpace();
                    var styleStartPosition = this.clonePosition();
                    var result = this.parseSimpleArgStyleIfPossible();
                    if (result.err) return result;
                    var style = $41b9cca01985965f$var$trimEnd(result.val);
                    if (style.length === 0) return this.error((0, $1qhWu.ErrorKind).EXPECT_ARGUMENT_STYLE, $41b9cca01985965f$var$createLocation(this.clonePosition(), this.clonePosition()));
                    var styleLocation = $41b9cca01985965f$var$createLocation(styleStartPosition, this.clonePosition());
                    styleAndLocation = {
                        style: style,
                        styleLocation: styleLocation
                    };
                }
                var argCloseResult = this.tryParseArgumentClose(openingBracePosition);
                if (argCloseResult.err) return argCloseResult;
                var location_1 = $41b9cca01985965f$var$createLocation(openingBracePosition, this.clonePosition());
                // Extract style or skeleton
                if (styleAndLocation && $41b9cca01985965f$var$startsWith(styleAndLocation === null || styleAndLocation === void 0 ? void 0 : styleAndLocation.style, '::', 0)) {
                    // Skeleton starts with `::`.
                    var skeleton = $41b9cca01985965f$var$trimStart(styleAndLocation.style.slice(2));
                    if (argType === 'number') {
                        var result = this.parseNumberSkeletonFromString(skeleton, styleAndLocation.styleLocation);
                        if (result.err) return result;
                        return {
                            val: {
                                type: (0, $4VghZ.TYPE).number,
                                value: value,
                                location: location_1,
                                style: result.val
                            },
                            err: null
                        };
                    } else {
                        if (skeleton.length === 0) return this.error((0, $1qhWu.ErrorKind).EXPECT_DATE_TIME_SKELETON, location_1);
                        var dateTimePattern = skeleton;
                        // Get "best match" pattern only if locale is passed, if not, let it
                        // pass as-is where `parseDateTimeSkeleton()` will throw an error
                        // for unsupported patterns.
                        if (this.locale) dateTimePattern = (0, $h8PxH.getBestPattern)(skeleton, this.locale);
                        var style = {
                            type: (0, $4VghZ.SKELETON_TYPE).dateTime,
                            pattern: dateTimePattern,
                            location: styleAndLocation.styleLocation,
                            parsedOptions: this.shouldParseSkeletons ? (0, $aYwqB.parseDateTimeSkeleton)(dateTimePattern) : {}
                        };
                        var type = argType === 'date' ? (0, $4VghZ.TYPE).date : (0, $4VghZ.TYPE).time;
                        return {
                            val: {
                                type: type,
                                value: value,
                                location: location_1,
                                style: style
                            },
                            err: null
                        };
                    }
                }
                // Regular style or no style.
                return {
                    val: {
                        type: argType === 'number' ? (0, $4VghZ.TYPE).number : argType === 'date' ? (0, $4VghZ.TYPE).date : (0, $4VghZ.TYPE).time,
                        value: value,
                        location: location_1,
                        style: (_a = styleAndLocation === null || styleAndLocation === void 0 ? void 0 : styleAndLocation.style) !== null && _a !== void 0 ? _a : null
                    },
                    err: null
                };
            case 'plural':
            case 'selectordinal':
            case 'select':
                // Parse this range:
                // {name, plural, options}
                //              ^---------^
                var typeEndPosition_1 = this.clonePosition();
                this.bumpSpace();
                if (!this.bumpIf(',')) return this.error((0, $1qhWu.ErrorKind).EXPECT_SELECT_ARGUMENT_OPTIONS, $41b9cca01985965f$var$createLocation(typeEndPosition_1, (0, $l2Z7B.__assign)({}, typeEndPosition_1)));
                this.bumpSpace();
                // Parse offset:
                // {name, plural, offset:1, options}
                //                ^-----^
                //
                // or the first option:
                //
                // {name, plural, one {...} other {...}}
                //                ^--^
                var identifierAndLocation = this.parseIdentifierIfPossible();
                var pluralOffset = 0;
                if (argType !== 'select' && identifierAndLocation.value === 'offset') {
                    if (!this.bumpIf(':')) return this.error((0, $1qhWu.ErrorKind).EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE, $41b9cca01985965f$var$createLocation(this.clonePosition(), this.clonePosition()));
                    this.bumpSpace();
                    var result = this.tryParseDecimalInteger((0, $1qhWu.ErrorKind).EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE, (0, $1qhWu.ErrorKind).INVALID_PLURAL_ARGUMENT_OFFSET_VALUE);
                    if (result.err) return result;
                    // Parse another identifier for option parsing
                    this.bumpSpace();
                    identifierAndLocation = this.parseIdentifierIfPossible();
                    pluralOffset = result.val;
                }
                var optionsResult = this.tryParsePluralOrSelectOptions(nestingLevel, argType, expectingCloseTag, identifierAndLocation);
                if (optionsResult.err) return optionsResult;
                var argCloseResult = this.tryParseArgumentClose(openingBracePosition);
                if (argCloseResult.err) return argCloseResult;
                var location_2 = $41b9cca01985965f$var$createLocation(openingBracePosition, this.clonePosition());
                if (argType === 'select') return {
                    val: {
                        type: (0, $4VghZ.TYPE).select,
                        value: value,
                        options: $41b9cca01985965f$var$fromEntries(optionsResult.val),
                        location: location_2
                    },
                    err: null
                };
                else return {
                    val: {
                        type: (0, $4VghZ.TYPE).plural,
                        value: value,
                        options: $41b9cca01985965f$var$fromEntries(optionsResult.val),
                        offset: pluralOffset,
                        pluralType: argType === 'plural' ? 'cardinal' : 'ordinal',
                        location: location_2
                    },
                    err: null
                };
            default:
                return this.error((0, $1qhWu.ErrorKind).INVALID_ARGUMENT_TYPE, $41b9cca01985965f$var$createLocation(typeStartPosition, typeEndPosition));
        }
    };
    Parser.prototype.tryParseArgumentClose = function(openingBracePosition) {
        // Parse: {value, number, ::currency/GBP }
        //
        if (this.isEOF() || this.char() !== 125 /* `}` */ ) return this.error((0, $1qhWu.ErrorKind).EXPECT_ARGUMENT_CLOSING_BRACE, $41b9cca01985965f$var$createLocation(openingBracePosition, this.clonePosition()));
        this.bump(); // `}`
        return {
            val: true,
            err: null
        };
    };
    /**
     * See: https://github.com/unicode-org/icu/blob/af7ed1f6d2298013dc303628438ec4abe1f16479/icu4c/source/common/messagepattern.cpp#L659
     */ Parser.prototype.parseSimpleArgStyleIfPossible = function() {
        var nestedBraces = 0;
        var startPosition = this.clonePosition();
        while(!this.isEOF()){
            var ch = this.char();
            switch(ch){
                case 39 /* `'` */ :
                    // Treat apostrophe as quoting but include it in the style part.
                    // Find the end of the quoted literal text.
                    this.bump();
                    var apostrophePosition = this.clonePosition();
                    if (!this.bumpUntil("'")) return this.error((0, $1qhWu.ErrorKind).UNCLOSED_QUOTE_IN_ARGUMENT_STYLE, $41b9cca01985965f$var$createLocation(apostrophePosition, this.clonePosition()));
                    this.bump();
                    break;
                case 123 /* `{` */ :
                    nestedBraces += 1;
                    this.bump();
                    break;
                case 125 /* `}` */ :
                    if (nestedBraces > 0) nestedBraces -= 1;
                    else return {
                        val: this.message.slice(startPosition.offset, this.offset()),
                        err: null
                    };
                    break;
                default:
                    this.bump();
                    break;
            }
        }
        return {
            val: this.message.slice(startPosition.offset, this.offset()),
            err: null
        };
    };
    Parser.prototype.parseNumberSkeletonFromString = function(skeleton, location) {
        var tokens = [];
        try {
            tokens = (0, $4f4OJ.parseNumberSkeletonFromString)(skeleton);
        } catch (e) {
            return this.error((0, $1qhWu.ErrorKind).INVALID_NUMBER_SKELETON, location);
        }
        return {
            val: {
                type: (0, $4VghZ.SKELETON_TYPE).number,
                tokens: tokens,
                location: location,
                parsedOptions: this.shouldParseSkeletons ? (0, $4f4OJ.parseNumberSkeleton)(tokens) : {}
            },
            err: null
        };
    };
    /**
     * @param nesting_level The current nesting level of messages.
     *     This can be positive when parsing message fragment in select or plural argument options.
     * @param parent_arg_type The parent argument's type.
     * @param parsed_first_identifier If provided, this is the first identifier-like selector of
     *     the argument. It is a by-product of a previous parsing attempt.
     * @param expecting_close_tag If true, this message is directly or indirectly nested inside
     *     between a pair of opening and closing tags. The nested message will not parse beyond
     *     the closing tag boundary.
     */ Parser.prototype.tryParsePluralOrSelectOptions = function(nestingLevel, parentArgType, expectCloseTag, parsedFirstIdentifier) {
        var _a;
        var hasOtherClause = false;
        var options = [];
        var parsedSelectors = new Set();
        var selector = parsedFirstIdentifier.value, selectorLocation = parsedFirstIdentifier.location;
        // Parse:
        // one {one apple}
        // ^--^
        while(true){
            if (selector.length === 0) {
                var startPosition = this.clonePosition();
                if (parentArgType !== 'select' && this.bumpIf('=')) {
                    // Try parse `={number}` selector
                    var result = this.tryParseDecimalInteger((0, $1qhWu.ErrorKind).EXPECT_PLURAL_ARGUMENT_SELECTOR, (0, $1qhWu.ErrorKind).INVALID_PLURAL_ARGUMENT_SELECTOR);
                    if (result.err) return result;
                    selectorLocation = $41b9cca01985965f$var$createLocation(startPosition, this.clonePosition());
                    selector = this.message.slice(startPosition.offset, this.offset());
                } else break;
            }
            // Duplicate selector clauses
            if (parsedSelectors.has(selector)) return this.error(parentArgType === 'select' ? (0, $1qhWu.ErrorKind).DUPLICATE_SELECT_ARGUMENT_SELECTOR : (0, $1qhWu.ErrorKind).DUPLICATE_PLURAL_ARGUMENT_SELECTOR, selectorLocation);
            if (selector === 'other') hasOtherClause = true;
            // Parse:
            // one {one apple}
            //     ^----------^
            this.bumpSpace();
            var openingBracePosition = this.clonePosition();
            if (!this.bumpIf('{')) return this.error(parentArgType === 'select' ? (0, $1qhWu.ErrorKind).EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT : (0, $1qhWu.ErrorKind).EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT, $41b9cca01985965f$var$createLocation(this.clonePosition(), this.clonePosition()));
            var fragmentResult = this.parseMessage(nestingLevel + 1, parentArgType, expectCloseTag);
            if (fragmentResult.err) return fragmentResult;
            var argCloseResult = this.tryParseArgumentClose(openingBracePosition);
            if (argCloseResult.err) return argCloseResult;
            options.push([
                selector,
                {
                    value: fragmentResult.val,
                    location: $41b9cca01985965f$var$createLocation(openingBracePosition, this.clonePosition())
                }
            ]);
            // Keep track of the existing selectors
            parsedSelectors.add(selector);
            // Prep next selector clause.
            this.bumpSpace();
            _a = this.parseIdentifierIfPossible(), selector = _a.value, selectorLocation = _a.location;
        }
        if (options.length === 0) return this.error(parentArgType === 'select' ? (0, $1qhWu.ErrorKind).EXPECT_SELECT_ARGUMENT_SELECTOR : (0, $1qhWu.ErrorKind).EXPECT_PLURAL_ARGUMENT_SELECTOR, $41b9cca01985965f$var$createLocation(this.clonePosition(), this.clonePosition()));
        if (this.requiresOtherClause && !hasOtherClause) return this.error((0, $1qhWu.ErrorKind).MISSING_OTHER_CLAUSE, $41b9cca01985965f$var$createLocation(this.clonePosition(), this.clonePosition()));
        return {
            val: options,
            err: null
        };
    };
    Parser.prototype.tryParseDecimalInteger = function(expectNumberError, invalidNumberError) {
        var sign = 1;
        var startingPosition = this.clonePosition();
        if (this.bumpIf('+')) ;
        else if (this.bumpIf('-')) sign = -1;
        var hasDigits = false;
        var decimal = 0;
        while(!this.isEOF()){
            var ch = this.char();
            if (ch >= 48 /* `0` */  && ch <= 57 /* `9` */ ) {
                hasDigits = true;
                decimal = decimal * 10 + (ch - 48);
                this.bump();
            } else break;
        }
        var location = $41b9cca01985965f$var$createLocation(startingPosition, this.clonePosition());
        if (!hasDigits) return this.error(expectNumberError, location);
        decimal *= sign;
        if (!$41b9cca01985965f$var$isSafeInteger(decimal)) return this.error(invalidNumberError, location);
        return {
            val: decimal,
            err: null
        };
    };
    Parser.prototype.offset = function() {
        return this.position.offset;
    };
    Parser.prototype.isEOF = function() {
        return this.offset() === this.message.length;
    };
    Parser.prototype.clonePosition = function() {
        // This is much faster than `Object.assign` or spread.
        return {
            offset: this.position.offset,
            line: this.position.line,
            column: this.position.column
        };
    };
    /**
     * Return the code point at the current position of the parser.
     * Throws if the index is out of bound.
     */ Parser.prototype.char = function() {
        var offset = this.position.offset;
        if (offset >= this.message.length) throw Error('out of bound');
        var code = $41b9cca01985965f$var$codePointAt(this.message, offset);
        if (code === undefined) throw Error("Offset ".concat(offset, " is at invalid UTF-16 code unit boundary"));
        return code;
    };
    Parser.prototype.error = function(kind, location) {
        return {
            val: null,
            err: {
                kind: kind,
                message: this.message,
                location: location
            }
        };
    };
    /** Bump the parser to the next UTF-16 code unit. */ Parser.prototype.bump = function() {
        if (this.isEOF()) return;
        var code = this.char();
        if (code === 10 /* '\n' */ ) {
            this.position.line += 1;
            this.position.column = 1;
            this.position.offset += 1;
        } else {
            this.position.column += 1;
            // 0 ~ 0x10000 -> unicode BMP, otherwise skip the surrogate pair.
            this.position.offset += code < 0x10000 ? 1 : 2;
        }
    };
    /**
     * If the substring starting at the current position of the parser has
     * the given prefix, then bump the parser to the character immediately
     * following the prefix and return true. Otherwise, don't bump the parser
     * and return false.
     */ Parser.prototype.bumpIf = function(prefix) {
        if ($41b9cca01985965f$var$startsWith(this.message, prefix, this.offset())) {
            for(var i = 0; i < prefix.length; i++)this.bump();
            return true;
        }
        return false;
    };
    /**
     * Bump the parser until the pattern character is found and return `true`.
     * Otherwise bump to the end of the file and return `false`.
     */ Parser.prototype.bumpUntil = function(pattern) {
        var currentOffset = this.offset();
        var index = this.message.indexOf(pattern, currentOffset);
        if (index >= 0) {
            this.bumpTo(index);
            return true;
        } else {
            this.bumpTo(this.message.length);
            return false;
        }
    };
    /**
     * Bump the parser to the target offset.
     * If target offset is beyond the end of the input, bump the parser to the end of the input.
     */ Parser.prototype.bumpTo = function(targetOffset) {
        if (this.offset() > targetOffset) throw Error("targetOffset ".concat(targetOffset, " must be greater than or equal to the current offset ").concat(this.offset()));
        targetOffset = Math.min(targetOffset, this.message.length);
        while(true){
            var offset = this.offset();
            if (offset === targetOffset) break;
            if (offset > targetOffset) throw Error("targetOffset ".concat(targetOffset, " is at invalid UTF-16 code unit boundary"));
            this.bump();
            if (this.isEOF()) break;
        }
    };
    /** advance the parser through all whitespace to the next non-whitespace code unit. */ Parser.prototype.bumpSpace = function() {
        while(!this.isEOF() && $41b9cca01985965f$var$_isWhiteSpace(this.char()))this.bump();
    };
    /**
     * Peek at the *next* Unicode codepoint in the input without advancing the parser.
     * If the input has been exhausted, then this returns null.
     */ Parser.prototype.peek = function() {
        if (this.isEOF()) return null;
        var code = this.char();
        var offset = this.offset();
        var nextCode = this.message.charCodeAt(offset + (code >= 0x10000 ? 2 : 1));
        return nextCode !== null && nextCode !== void 0 ? nextCode : null;
    };
    return Parser;
}();
/**
 * This check if codepoint is alphabet (lower & uppercase)
 * @param codepoint
 * @returns
 */ function $41b9cca01985965f$var$_isAlpha(codepoint) {
    return codepoint >= 97 && codepoint <= 122 || codepoint >= 65 && codepoint <= 90;
}
function $41b9cca01985965f$var$_isAlphaOrSlash(codepoint) {
    return $41b9cca01985965f$var$_isAlpha(codepoint) || codepoint === 47; /* '/' */ 
}
/** See `parseTag` function docs. */ function $41b9cca01985965f$var$_isPotentialElementNameChar(c) {
    return c === 45 /* '-' */  || c === 46 /* '.' */  || c >= 48 && c <= 57 || c === 95 /* '_' */  || c >= 97 && c <= 122 || c >= 65 && c <= 90 || c == 0xb7 || c >= 0xc0 && c <= 0xd6 || c >= 0xd8 && c <= 0xf6 || c >= 0xf8 && c <= 0x37d || c >= 0x37f && c <= 0x1fff || c >= 0x200c && c <= 0x200d || c >= 0x203f && c <= 0x2040 || c >= 0x2070 && c <= 0x218f || c >= 0x2c00 && c <= 0x2fef || c >= 0x3001 && c <= 0xd7ff || c >= 0xf900 && c <= 0xfdcf || c >= 0xfdf0 && c <= 0xfffd || c >= 0x10000 && c <= 0xeffff;
}
/**
 * Code point equivalent of regex `\p{White_Space}`.
 * From: https://www.unicode.org/Public/UCD/latest/ucd/PropList.txt
 */ function $41b9cca01985965f$var$_isWhiteSpace(c) {
    return c >= 0x0009 && c <= 0x000d || c === 0x0020 || c === 0x0085 || c >= 0x200e && c <= 0x200f || c === 0x2028 || c === 0x2029;
}
/**
 * Code point equivalent of regex `\p{Pattern_Syntax}`.
 * See https://www.unicode.org/Public/UCD/latest/ucd/PropList.txt
 */ function $41b9cca01985965f$var$_isPatternSyntax(c) {
    return c >= 0x0021 && c <= 0x0023 || c === 0x0024 || c >= 0x0025 && c <= 0x0027 || c === 0x0028 || c === 0x0029 || c === 0x002a || c === 0x002b || c === 0x002c || c === 0x002d || c >= 0x002e && c <= 0x002f || c >= 0x003a && c <= 0x003b || c >= 0x003c && c <= 0x003e || c >= 0x003f && c <= 0x0040 || c === 0x005b || c === 0x005c || c === 0x005d || c === 0x005e || c === 0x0060 || c === 0x007b || c === 0x007c || c === 0x007d || c === 0x007e || c === 0x00a1 || c >= 0x00a2 && c <= 0x00a5 || c === 0x00a6 || c === 0x00a7 || c === 0x00a9 || c === 0x00ab || c === 0x00ac || c === 0x00ae || c === 0x00b0 || c === 0x00b1 || c === 0x00b6 || c === 0x00bb || c === 0x00bf || c === 0x00d7 || c === 0x00f7 || c >= 0x2010 && c <= 0x2015 || c >= 0x2016 && c <= 0x2017 || c === 0x2018 || c === 0x2019 || c === 0x201a || c >= 0x201b && c <= 0x201c || c === 0x201d || c === 0x201e || c === 0x201f || c >= 0x2020 && c <= 0x2027 || c >= 0x2030 && c <= 0x2038 || c === 0x2039 || c === 0x203a || c >= 0x203b && c <= 0x203e || c >= 0x2041 && c <= 0x2043 || c === 0x2044 || c === 0x2045 || c === 0x2046 || c >= 0x2047 && c <= 0x2051 || c === 0x2052 || c === 0x2053 || c >= 0x2055 && c <= 0x205e || c >= 0x2190 && c <= 0x2194 || c >= 0x2195 && c <= 0x2199 || c >= 0x219a && c <= 0x219b || c >= 0x219c && c <= 0x219f || c === 0x21a0 || c >= 0x21a1 && c <= 0x21a2 || c === 0x21a3 || c >= 0x21a4 && c <= 0x21a5 || c === 0x21a6 || c >= 0x21a7 && c <= 0x21ad || c === 0x21ae || c >= 0x21af && c <= 0x21cd || c >= 0x21ce && c <= 0x21cf || c >= 0x21d0 && c <= 0x21d1 || c === 0x21d2 || c === 0x21d3 || c === 0x21d4 || c >= 0x21d5 && c <= 0x21f3 || c >= 0x21f4 && c <= 0x22ff || c >= 0x2300 && c <= 0x2307 || c === 0x2308 || c === 0x2309 || c === 0x230a || c === 0x230b || c >= 0x230c && c <= 0x231f || c >= 0x2320 && c <= 0x2321 || c >= 0x2322 && c <= 0x2328 || c === 0x2329 || c === 0x232a || c >= 0x232b && c <= 0x237b || c === 0x237c || c >= 0x237d && c <= 0x239a || c >= 0x239b && c <= 0x23b3 || c >= 0x23b4 && c <= 0x23db || c >= 0x23dc && c <= 0x23e1 || c >= 0x23e2 && c <= 0x2426 || c >= 0x2427 && c <= 0x243f || c >= 0x2440 && c <= 0x244a || c >= 0x244b && c <= 0x245f || c >= 0x2500 && c <= 0x25b6 || c === 0x25b7 || c >= 0x25b8 && c <= 0x25c0 || c === 0x25c1 || c >= 0x25c2 && c <= 0x25f7 || c >= 0x25f8 && c <= 0x25ff || c >= 0x2600 && c <= 0x266e || c === 0x266f || c >= 0x2670 && c <= 0x2767 || c === 0x2768 || c === 0x2769 || c === 0x276a || c === 0x276b || c === 0x276c || c === 0x276d || c === 0x276e || c === 0x276f || c === 0x2770 || c === 0x2771 || c === 0x2772 || c === 0x2773 || c === 0x2774 || c === 0x2775 || c >= 0x2794 && c <= 0x27bf || c >= 0x27c0 && c <= 0x27c4 || c === 0x27c5 || c === 0x27c6 || c >= 0x27c7 && c <= 0x27e5 || c === 0x27e6 || c === 0x27e7 || c === 0x27e8 || c === 0x27e9 || c === 0x27ea || c === 0x27eb || c === 0x27ec || c === 0x27ed || c === 0x27ee || c === 0x27ef || c >= 0x27f0 && c <= 0x27ff || c >= 0x2800 && c <= 0x28ff || c >= 0x2900 && c <= 0x2982 || c === 0x2983 || c === 0x2984 || c === 0x2985 || c === 0x2986 || c === 0x2987 || c === 0x2988 || c === 0x2989 || c === 0x298a || c === 0x298b || c === 0x298c || c === 0x298d || c === 0x298e || c === 0x298f || c === 0x2990 || c === 0x2991 || c === 0x2992 || c === 0x2993 || c === 0x2994 || c === 0x2995 || c === 0x2996 || c === 0x2997 || c === 0x2998 || c >= 0x2999 && c <= 0x29d7 || c === 0x29d8 || c === 0x29d9 || c === 0x29da || c === 0x29db || c >= 0x29dc && c <= 0x29fb || c === 0x29fc || c === 0x29fd || c >= 0x29fe && c <= 0x2aff || c >= 0x2b00 && c <= 0x2b2f || c >= 0x2b30 && c <= 0x2b44 || c >= 0x2b45 && c <= 0x2b46 || c >= 0x2b47 && c <= 0x2b4c || c >= 0x2b4d && c <= 0x2b73 || c >= 0x2b74 && c <= 0x2b75 || c >= 0x2b76 && c <= 0x2b95 || c === 0x2b96 || c >= 0x2b97 && c <= 0x2bff || c >= 0x2e00 && c <= 0x2e01 || c === 0x2e02 || c === 0x2e03 || c === 0x2e04 || c === 0x2e05 || c >= 0x2e06 && c <= 0x2e08 || c === 0x2e09 || c === 0x2e0a || c === 0x2e0b || c === 0x2e0c || c === 0x2e0d || c >= 0x2e0e && c <= 0x2e16 || c === 0x2e17 || c >= 0x2e18 && c <= 0x2e19 || c === 0x2e1a || c === 0x2e1b || c === 0x2e1c || c === 0x2e1d || c >= 0x2e1e && c <= 0x2e1f || c === 0x2e20 || c === 0x2e21 || c === 0x2e22 || c === 0x2e23 || c === 0x2e24 || c === 0x2e25 || c === 0x2e26 || c === 0x2e27 || c === 0x2e28 || c === 0x2e29 || c >= 0x2e2a && c <= 0x2e2e || c === 0x2e2f || c >= 0x2e30 && c <= 0x2e39 || c >= 0x2e3a && c <= 0x2e3b || c >= 0x2e3c && c <= 0x2e3f || c === 0x2e40 || c === 0x2e41 || c === 0x2e42 || c >= 0x2e43 && c <= 0x2e4f || c >= 0x2e50 && c <= 0x2e51 || c === 0x2e52 || c >= 0x2e53 && c <= 0x2e7f || c >= 0x3001 && c <= 0x3003 || c === 0x3008 || c === 0x3009 || c === 0x300a || c === 0x300b || c === 0x300c || c === 0x300d || c === 0x300e || c === 0x300f || c === 0x3010 || c === 0x3011 || c >= 0x3012 && c <= 0x3013 || c === 0x3014 || c === 0x3015 || c === 0x3016 || c === 0x3017 || c === 0x3018 || c === 0x3019 || c === 0x301a || c === 0x301b || c === 0x301c || c === 0x301d || c >= 0x301e && c <= 0x301f || c === 0x3020 || c === 0x3030 || c === 0xfd3e || c === 0xfd3f || c >= 0xfe45 && c <= 0xfe46;
}

});
parcelRegister("4VghZ", function(module, exports) {
$parcel$export(module.exports, "TYPE", () => $39591ef6f138e77f$export$b87f371cbc396fcf);
$parcel$export(module.exports, "SKELETON_TYPE", () => $39591ef6f138e77f$export$906452485466fa53);
$parcel$export(module.exports, "isLiteralElement", () => $39591ef6f138e77f$export$cfa10c5697238752);
$parcel$export(module.exports, "isArgumentElement", () => $39591ef6f138e77f$export$4f55724281bdfaf9);
$parcel$export(module.exports, "isNumberElement", () => $39591ef6f138e77f$export$e11187b219e191e1);
$parcel$export(module.exports, "isDateElement", () => $39591ef6f138e77f$export$32d811605da75f40);
$parcel$export(module.exports, "isTimeElement", () => $39591ef6f138e77f$export$34ec46f596b1702f);
$parcel$export(module.exports, "isSelectElement", () => $39591ef6f138e77f$export$dcfe1c11d168b5a1);
$parcel$export(module.exports, "isPluralElement", () => $39591ef6f138e77f$export$6c796d116f0a4fbc);
$parcel$export(module.exports, "isPoundElement", () => $39591ef6f138e77f$export$c0ece297bdd0c082);
$parcel$export(module.exports, "isTagElement", () => $39591ef6f138e77f$export$5c83de34745812b);
$parcel$export(module.exports, "isNumberSkeleton", () => $39591ef6f138e77f$export$3f9a19cd4152eda3);
$parcel$export(module.exports, "isDateTimeSkeleton", () => $39591ef6f138e77f$export$7680c41f1a55f4cf);
var $39591ef6f138e77f$export$b87f371cbc396fcf;
(function(TYPE) {
    /**
     * Raw text
     */ TYPE[TYPE["literal"] = 0] = "literal";
    /**
     * Variable w/o any format, e.g `var` in `this is a {var}`
     */ TYPE[TYPE["argument"] = 1] = "argument";
    /**
     * Variable w/ number format
     */ TYPE[TYPE["number"] = 2] = "number";
    /**
     * Variable w/ date format
     */ TYPE[TYPE["date"] = 3] = "date";
    /**
     * Variable w/ time format
     */ TYPE[TYPE["time"] = 4] = "time";
    /**
     * Variable w/ select format
     */ TYPE[TYPE["select"] = 5] = "select";
    /**
     * Variable w/ plural format
     */ TYPE[TYPE["plural"] = 6] = "plural";
    /**
     * Only possible within plural argument.
     * This is the `#` symbol that will be substituted with the count.
     */ TYPE[TYPE["pound"] = 7] = "pound";
    /**
     * XML-like tag
     */ TYPE[TYPE["tag"] = 8] = "tag";
})($39591ef6f138e77f$export$b87f371cbc396fcf || ($39591ef6f138e77f$export$b87f371cbc396fcf = {}));
var $39591ef6f138e77f$export$906452485466fa53;
(function(SKELETON_TYPE) {
    SKELETON_TYPE[SKELETON_TYPE["number"] = 0] = "number";
    SKELETON_TYPE[SKELETON_TYPE["dateTime"] = 1] = "dateTime";
})($39591ef6f138e77f$export$906452485466fa53 || ($39591ef6f138e77f$export$906452485466fa53 = {}));
function $39591ef6f138e77f$export$cfa10c5697238752(el) {
    return el.type === $39591ef6f138e77f$export$b87f371cbc396fcf.literal;
}
function $39591ef6f138e77f$export$4f55724281bdfaf9(el) {
    return el.type === $39591ef6f138e77f$export$b87f371cbc396fcf.argument;
}
function $39591ef6f138e77f$export$e11187b219e191e1(el) {
    return el.type === $39591ef6f138e77f$export$b87f371cbc396fcf.number;
}
function $39591ef6f138e77f$export$32d811605da75f40(el) {
    return el.type === $39591ef6f138e77f$export$b87f371cbc396fcf.date;
}
function $39591ef6f138e77f$export$34ec46f596b1702f(el) {
    return el.type === $39591ef6f138e77f$export$b87f371cbc396fcf.time;
}
function $39591ef6f138e77f$export$dcfe1c11d168b5a1(el) {
    return el.type === $39591ef6f138e77f$export$b87f371cbc396fcf.select;
}
function $39591ef6f138e77f$export$6c796d116f0a4fbc(el) {
    return el.type === $39591ef6f138e77f$export$b87f371cbc396fcf.plural;
}
function $39591ef6f138e77f$export$c0ece297bdd0c082(el) {
    return el.type === $39591ef6f138e77f$export$b87f371cbc396fcf.pound;
}
function $39591ef6f138e77f$export$5c83de34745812b(el) {
    return el.type === $39591ef6f138e77f$export$b87f371cbc396fcf.tag;
}
function $39591ef6f138e77f$export$3f9a19cd4152eda3(el) {
    return !!(el && typeof el === 'object' && el.type === $39591ef6f138e77f$export$906452485466fa53.number);
}
function $39591ef6f138e77f$export$7680c41f1a55f4cf(el) {
    return !!(el && typeof el === 'object' && el.type === $39591ef6f138e77f$export$906452485466fa53.dateTime);
}
function $39591ef6f138e77f$export$f0ac572c1121c662(value) {
    return {
        type: $39591ef6f138e77f$export$b87f371cbc396fcf.literal,
        value: value
    };
}
function $39591ef6f138e77f$export$425e864b0ba114f1(value, style) {
    return {
        type: $39591ef6f138e77f$export$b87f371cbc396fcf.number,
        value: value,
        style: style
    };
}

});

parcelRegister("1tlBf", function(module, exports) {
$parcel$export(module.exports, "SPACE_SEPARATOR_REGEX", () => $1129411e0a357551$export$523451f94304dd6c);
// @generated from regex-gen.ts
var $1129411e0a357551$export$523451f94304dd6c = /[ \xA0\u1680\u2000-\u200A\u202F\u205F\u3000]/;
var $1129411e0a357551$export$2b8db14d8bcaece7 = /[\t-\r \x85\u200E\u200F\u2028\u2029]/;

});

parcelRegister("3Uiry", function(module, exports) {
$parcel$export(module.exports, "parseDateTimeSkeleton", () => (parcelRequire("aYwqB")).parseDateTimeSkeleton);
$parcel$export(module.exports, "parseNumberSkeleton", () => (parcelRequire("4f4OJ")).parseNumberSkeleton);
$parcel$export(module.exports, "parseNumberSkeletonFromString", () => (parcelRequire("4f4OJ")).parseNumberSkeletonFromString);
parcelRequire("aYwqB");
parcelRequire("4f4OJ");

});
parcelRegister("aYwqB", function(module, exports) {
$parcel$export(module.exports, "parseDateTimeSkeleton", () => $7fd8a98a97bb80b4$export$f7b99fb377fe69fa);
/**
 * https://unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 * Credit: https://github.com/caridy/intl-datetimeformat-pattern/blob/master/index.js
 * with some tweaks
 */ var $7fd8a98a97bb80b4$var$DATE_TIME_REGEX = /(?:[Eec]{1,6}|G{1,5}|[Qq]{1,5}|(?:[yYur]+|U{1,5})|[ML]{1,5}|d{1,2}|D{1,3}|F{1}|[abB]{1,5}|[hkHK]{1,2}|w{1,2}|W{1}|m{1,2}|s{1,2}|[zZOvVxX]{1,4})(?=([^']*'[^']*')*[^']*$)/g;
function $7fd8a98a97bb80b4$export$f7b99fb377fe69fa(skeleton) {
    var result = {};
    skeleton.replace($7fd8a98a97bb80b4$var$DATE_TIME_REGEX, function(match) {
        var len = match.length;
        switch(match[0]){
            // Era
            case 'G':
                result.era = len === 4 ? 'long' : len === 5 ? 'narrow' : 'short';
                break;
            // Year
            case 'y':
                result.year = len === 2 ? '2-digit' : 'numeric';
                break;
            case 'Y':
            case 'u':
            case 'U':
            case 'r':
                throw new RangeError('`Y/u/U/r` (year) patterns are not supported, use `y` instead');
            // Quarter
            case 'q':
            case 'Q':
                throw new RangeError('`q/Q` (quarter) patterns are not supported');
            // Month
            case 'M':
            case 'L':
                result.month = [
                    'numeric',
                    '2-digit',
                    'short',
                    'long',
                    'narrow'
                ][len - 1];
                break;
            // Week
            case 'w':
            case 'W':
                throw new RangeError('`w/W` (week) patterns are not supported');
            case 'd':
                result.day = [
                    'numeric',
                    '2-digit'
                ][len - 1];
                break;
            case 'D':
            case 'F':
            case 'g':
                throw new RangeError('`D/F/g` (day) patterns are not supported, use `d` instead');
            // Weekday
            case 'E':
                result.weekday = len === 4 ? 'short' : len === 5 ? 'narrow' : 'short';
                break;
            case 'e':
                if (len < 4) throw new RangeError('`e..eee` (weekday) patterns are not supported');
                result.weekday = [
                    'short',
                    'long',
                    'narrow',
                    'short'
                ][len - 4];
                break;
            case 'c':
                if (len < 4) throw new RangeError('`c..ccc` (weekday) patterns are not supported');
                result.weekday = [
                    'short',
                    'long',
                    'narrow',
                    'short'
                ][len - 4];
                break;
            // Period
            case 'a':
                result.hour12 = true;
                break;
            case 'b':
            case 'B':
                throw new RangeError('`b/B` (period) patterns are not supported, use `a` instead');
            // Hour
            case 'h':
                result.hourCycle = 'h12';
                result.hour = [
                    'numeric',
                    '2-digit'
                ][len - 1];
                break;
            case 'H':
                result.hourCycle = 'h23';
                result.hour = [
                    'numeric',
                    '2-digit'
                ][len - 1];
                break;
            case 'K':
                result.hourCycle = 'h11';
                result.hour = [
                    'numeric',
                    '2-digit'
                ][len - 1];
                break;
            case 'k':
                result.hourCycle = 'h24';
                result.hour = [
                    'numeric',
                    '2-digit'
                ][len - 1];
                break;
            case 'j':
            case 'J':
            case 'C':
                throw new RangeError('`j/J/C` (hour) patterns are not supported, use `h/H/K/k` instead');
            // Minute
            case 'm':
                result.minute = [
                    'numeric',
                    '2-digit'
                ][len - 1];
                break;
            // Second
            case 's':
                result.second = [
                    'numeric',
                    '2-digit'
                ][len - 1];
                break;
            case 'S':
            case 'A':
                throw new RangeError('`S/A` (second) patterns are not supported, use `s` instead');
            // Zone
            case 'z':
                result.timeZoneName = len < 4 ? 'short' : 'long';
                break;
            case 'Z':
            case 'O':
            case 'v':
            case 'V':
            case 'X':
            case 'x':
                throw new RangeError('`Z/O/v/V/X/x` (timeZone) patterns are not supported, use `z` instead');
        }
        return '';
    });
    return result;
}

});

parcelRegister("4f4OJ", function(module, exports) {
$parcel$export(module.exports, "parseNumberSkeletonFromString", () => $316c4cc380cc14ac$export$71cee2f16fba2480);
$parcel$export(module.exports, "parseNumberSkeleton", () => $316c4cc380cc14ac$export$47c6f8480bda3e11);

var $l2Z7B = parcelRequire("l2Z7B");

var $cULFT = parcelRequire("cULFT");
function $316c4cc380cc14ac$export$71cee2f16fba2480(skeleton) {
    if (skeleton.length === 0) throw new Error('Number skeleton cannot be empty');
    // Parse the skeleton
    var stringTokens = skeleton.split((0, $cULFT.WHITE_SPACE_REGEX)).filter(function(x) {
        return x.length > 0;
    });
    var tokens = [];
    for(var _i = 0, stringTokens_1 = stringTokens; _i < stringTokens_1.length; _i++){
        var stringToken = stringTokens_1[_i];
        var stemAndOptions = stringToken.split('/');
        if (stemAndOptions.length === 0) throw new Error('Invalid number skeleton');
        var stem = stemAndOptions[0], options = stemAndOptions.slice(1);
        for(var _a = 0, options_1 = options; _a < options_1.length; _a++){
            var option = options_1[_a];
            if (option.length === 0) throw new Error('Invalid number skeleton');
        }
        tokens.push({
            stem: stem,
            options: options
        });
    }
    return tokens;
}
function $316c4cc380cc14ac$var$icuUnitToEcma(unit) {
    return unit.replace(/^(.*?)-/, '');
}
var $316c4cc380cc14ac$var$FRACTION_PRECISION_REGEX = /^\.(?:(0+)(\*)?|(#+)|(0+)(#+))$/g;
var $316c4cc380cc14ac$var$SIGNIFICANT_PRECISION_REGEX = /^(@+)?(\+|#+)?[rs]?$/g;
var $316c4cc380cc14ac$var$INTEGER_WIDTH_REGEX = /(\*)(0+)|(#+)(0+)|(0+)/g;
var $316c4cc380cc14ac$var$CONCISE_INTEGER_WIDTH_REGEX = /^(0+)$/;
function $316c4cc380cc14ac$var$parseSignificantPrecision(str) {
    var result = {};
    if (str[str.length - 1] === 'r') result.roundingPriority = 'morePrecision';
    else if (str[str.length - 1] === 's') result.roundingPriority = 'lessPrecision';
    str.replace($316c4cc380cc14ac$var$SIGNIFICANT_PRECISION_REGEX, function(_, g1, g2) {
        // @@@ case
        if (typeof g2 !== 'string') {
            result.minimumSignificantDigits = g1.length;
            result.maximumSignificantDigits = g1.length;
        } else if (g2 === '+') result.minimumSignificantDigits = g1.length;
        else if (g1[0] === '#') result.maximumSignificantDigits = g1.length;
        else {
            result.minimumSignificantDigits = g1.length;
            result.maximumSignificantDigits = g1.length + (typeof g2 === 'string' ? g2.length : 0);
        }
        return '';
    });
    return result;
}
function $316c4cc380cc14ac$var$parseSign(str) {
    switch(str){
        case 'sign-auto':
            return {
                signDisplay: 'auto'
            };
        case 'sign-accounting':
        case '()':
            return {
                currencySign: 'accounting'
            };
        case 'sign-always':
        case '+!':
            return {
                signDisplay: 'always'
            };
        case 'sign-accounting-always':
        case '()!':
            return {
                signDisplay: 'always',
                currencySign: 'accounting'
            };
        case 'sign-except-zero':
        case '+?':
            return {
                signDisplay: 'exceptZero'
            };
        case 'sign-accounting-except-zero':
        case '()?':
            return {
                signDisplay: 'exceptZero',
                currencySign: 'accounting'
            };
        case 'sign-never':
        case '+_':
            return {
                signDisplay: 'never'
            };
    }
}
function $316c4cc380cc14ac$var$parseConciseScientificAndEngineeringStem(stem) {
    // Engineering
    var result;
    if (stem[0] === 'E' && stem[1] === 'E') {
        result = {
            notation: 'engineering'
        };
        stem = stem.slice(2);
    } else if (stem[0] === 'E') {
        result = {
            notation: 'scientific'
        };
        stem = stem.slice(1);
    }
    if (result) {
        var signDisplay = stem.slice(0, 2);
        if (signDisplay === '+!') {
            result.signDisplay = 'always';
            stem = stem.slice(2);
        } else if (signDisplay === '+?') {
            result.signDisplay = 'exceptZero';
            stem = stem.slice(2);
        }
        if (!$316c4cc380cc14ac$var$CONCISE_INTEGER_WIDTH_REGEX.test(stem)) throw new Error('Malformed concise eng/scientific notation');
        result.minimumIntegerDigits = stem.length;
    }
    return result;
}
function $316c4cc380cc14ac$var$parseNotationOptions(opt) {
    var result = {};
    var signOpts = $316c4cc380cc14ac$var$parseSign(opt);
    if (signOpts) return signOpts;
    return result;
}
function $316c4cc380cc14ac$export$47c6f8480bda3e11(tokens) {
    var result = {};
    for(var _i = 0, tokens_1 = tokens; _i < tokens_1.length; _i++){
        var token = tokens_1[_i];
        switch(token.stem){
            case 'percent':
            case '%':
                result.style = 'percent';
                continue;
            case '%x100':
                result.style = 'percent';
                result.scale = 100;
                continue;
            case 'currency':
                result.style = 'currency';
                result.currency = token.options[0];
                continue;
            case 'group-off':
            case ',_':
                result.useGrouping = false;
                continue;
            case 'precision-integer':
            case '.':
                result.maximumFractionDigits = 0;
                continue;
            case 'measure-unit':
            case 'unit':
                result.style = 'unit';
                result.unit = $316c4cc380cc14ac$var$icuUnitToEcma(token.options[0]);
                continue;
            case 'compact-short':
            case 'K':
                result.notation = 'compact';
                result.compactDisplay = 'short';
                continue;
            case 'compact-long':
            case 'KK':
                result.notation = 'compact';
                result.compactDisplay = 'long';
                continue;
            case 'scientific':
                result = (0, $l2Z7B.__assign)((0, $l2Z7B.__assign)((0, $l2Z7B.__assign)({}, result), {
                    notation: 'scientific'
                }), token.options.reduce(function(all, opt) {
                    return (0, $l2Z7B.__assign)((0, $l2Z7B.__assign)({}, all), $316c4cc380cc14ac$var$parseNotationOptions(opt));
                }, {}));
                continue;
            case 'engineering':
                result = (0, $l2Z7B.__assign)((0, $l2Z7B.__assign)((0, $l2Z7B.__assign)({}, result), {
                    notation: 'engineering'
                }), token.options.reduce(function(all, opt) {
                    return (0, $l2Z7B.__assign)((0, $l2Z7B.__assign)({}, all), $316c4cc380cc14ac$var$parseNotationOptions(opt));
                }, {}));
                continue;
            case 'notation-simple':
                result.notation = 'standard';
                continue;
            // https://github.com/unicode-org/icu/blob/master/icu4c/source/i18n/unicode/unumberformatter.h
            case 'unit-width-narrow':
                result.currencyDisplay = 'narrowSymbol';
                result.unitDisplay = 'narrow';
                continue;
            case 'unit-width-short':
                result.currencyDisplay = 'code';
                result.unitDisplay = 'short';
                continue;
            case 'unit-width-full-name':
                result.currencyDisplay = 'name';
                result.unitDisplay = 'long';
                continue;
            case 'unit-width-iso-code':
                result.currencyDisplay = 'symbol';
                continue;
            case 'scale':
                result.scale = parseFloat(token.options[0]);
                continue;
            // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#integer-width
            case 'integer-width':
                if (token.options.length > 1) throw new RangeError('integer-width stems only accept a single optional option');
                token.options[0].replace($316c4cc380cc14ac$var$INTEGER_WIDTH_REGEX, function(_, g1, g2, g3, g4, g5) {
                    if (g1) result.minimumIntegerDigits = g2.length;
                    else if (g3 && g4) throw new Error('We currently do not support maximum integer digits');
                    else if (g5) throw new Error('We currently do not support exact integer digits');
                    return '';
                });
                continue;
        }
        // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#integer-width
        if ($316c4cc380cc14ac$var$CONCISE_INTEGER_WIDTH_REGEX.test(token.stem)) {
            result.minimumIntegerDigits = token.stem.length;
            continue;
        }
        if ($316c4cc380cc14ac$var$FRACTION_PRECISION_REGEX.test(token.stem)) {
            // Precision
            // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#fraction-precision
            // precision-integer case
            if (token.options.length > 1) throw new RangeError('Fraction-precision stems only accept a single optional option');
            token.stem.replace($316c4cc380cc14ac$var$FRACTION_PRECISION_REGEX, function(_, g1, g2, g3, g4, g5) {
                // .000* case (before ICU67 it was .000+)
                if (g2 === '*') result.minimumFractionDigits = g1.length;
                else if (g3 && g3[0] === '#') result.maximumFractionDigits = g3.length;
                else if (g4 && g5) {
                    result.minimumFractionDigits = g4.length;
                    result.maximumFractionDigits = g4.length + g5.length;
                } else {
                    result.minimumFractionDigits = g1.length;
                    result.maximumFractionDigits = g1.length;
                }
                return '';
            });
            var opt = token.options[0];
            // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#trailing-zero-display
            if (opt === 'w') result = (0, $l2Z7B.__assign)((0, $l2Z7B.__assign)({}, result), {
                trailingZeroDisplay: 'stripIfInteger'
            });
            else if (opt) result = (0, $l2Z7B.__assign)((0, $l2Z7B.__assign)({}, result), $316c4cc380cc14ac$var$parseSignificantPrecision(opt));
            continue;
        }
        // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#significant-digits-precision
        if ($316c4cc380cc14ac$var$SIGNIFICANT_PRECISION_REGEX.test(token.stem)) {
            result = (0, $l2Z7B.__assign)((0, $l2Z7B.__assign)({}, result), $316c4cc380cc14ac$var$parseSignificantPrecision(token.stem));
            continue;
        }
        var signOpts = $316c4cc380cc14ac$var$parseSign(token.stem);
        if (signOpts) result = (0, $l2Z7B.__assign)((0, $l2Z7B.__assign)({}, result), signOpts);
        var conciseScientificAndEngineeringOpts = $316c4cc380cc14ac$var$parseConciseScientificAndEngineeringStem(token.stem);
        if (conciseScientificAndEngineeringOpts) result = (0, $l2Z7B.__assign)((0, $l2Z7B.__assign)({}, result), conciseScientificAndEngineeringOpts);
    }
    return result;
}

});
parcelRegister("cULFT", function(module, exports) {
$parcel$export(module.exports, "WHITE_SPACE_REGEX", () => $966fb236f7c5dc5f$export$2b8db14d8bcaece7);
// @generated from regex-gen.ts
var $966fb236f7c5dc5f$export$2b8db14d8bcaece7 = /[\t-\r \x85\u200E\u200F\u2028\u2029]/i;

});



parcelRegister("h8PxH", function(module, exports) {
$parcel$export(module.exports, "getBestPattern", () => $c7ab2a52b535161a$export$29c5368be8904d27);

var $bRAhB = parcelRequire("bRAhB");
function $c7ab2a52b535161a$export$29c5368be8904d27(skeleton, locale) {
    var skeletonCopy = '';
    for(var patternPos = 0; patternPos < skeleton.length; patternPos++){
        var patternChar = skeleton.charAt(patternPos);
        if (patternChar === 'j') {
            var extraLength = 0;
            while(patternPos + 1 < skeleton.length && skeleton.charAt(patternPos + 1) === patternChar){
                extraLength++;
                patternPos++;
            }
            var hourLen = 1 + (extraLength & 1);
            var dayPeriodLen = extraLength < 2 ? 1 : 3 + (extraLength >> 1);
            var dayPeriodChar = 'a';
            var hourChar = $c7ab2a52b535161a$var$getDefaultHourSymbolFromLocale(locale);
            if (hourChar == 'H' || hourChar == 'k') dayPeriodLen = 0;
            while(dayPeriodLen-- > 0)skeletonCopy += dayPeriodChar;
            while(hourLen-- > 0)skeletonCopy = hourChar + skeletonCopy;
        } else if (patternChar === 'J') skeletonCopy += 'H';
        else skeletonCopy += patternChar;
    }
    return skeletonCopy;
}
/**
 * Maps the [hour cycle type](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/Locale/hourCycle)
 * of the given `locale` to the corresponding time pattern.
 * @param locale
 */ function $c7ab2a52b535161a$var$getDefaultHourSymbolFromLocale(locale) {
    var hourCycle = locale.hourCycle;
    if (hourCycle === undefined && // @ts-ignore hourCycle(s) is not identified yet
    locale.hourCycles && // @ts-ignore
    locale.hourCycles.length) // @ts-ignore
    hourCycle = locale.hourCycles[0];
    if (hourCycle) switch(hourCycle){
        case 'h24':
            return 'k';
        case 'h23':
            return 'H';
        case 'h12':
            return 'h';
        case 'h11':
            return 'K';
        default:
            throw new Error('Invalid hourCycle');
    }
    // TODO: Once hourCycle is fully supported remove the following with data generation
    var languageTag = locale.language;
    var regionTag;
    if (languageTag !== 'root') regionTag = locale.maximize().region;
    var hourCycles = (0, $bRAhB.timeData)[regionTag || ''] || (0, $bRAhB.timeData)[languageTag || ''] || (0, $bRAhB.timeData)["".concat(languageTag, "-001")] || (0, $bRAhB.timeData)['001'];
    return hourCycles[0];
}

});
parcelRegister("bRAhB", function(module, exports) {
$parcel$export(module.exports, "timeData", () => $8a30c9f50c999ce6$export$a8c9209db4084317);
// @generated from time-data-gen.ts
// prettier-ignore  
var $8a30c9f50c999ce6$export$a8c9209db4084317 = {
    "AX": [
        "H"
    ],
    "BQ": [
        "H"
    ],
    "CP": [
        "H"
    ],
    "CZ": [
        "H"
    ],
    "DK": [
        "H"
    ],
    "FI": [
        "H"
    ],
    "ID": [
        "H"
    ],
    "IS": [
        "H"
    ],
    "ML": [
        "H"
    ],
    "NE": [
        "H"
    ],
    "RU": [
        "H"
    ],
    "SE": [
        "H"
    ],
    "SJ": [
        "H"
    ],
    "SK": [
        "H"
    ],
    "AS": [
        "h",
        "H"
    ],
    "BT": [
        "h",
        "H"
    ],
    "DJ": [
        "h",
        "H"
    ],
    "ER": [
        "h",
        "H"
    ],
    "GH": [
        "h",
        "H"
    ],
    "IN": [
        "h",
        "H"
    ],
    "LS": [
        "h",
        "H"
    ],
    "PG": [
        "h",
        "H"
    ],
    "PW": [
        "h",
        "H"
    ],
    "SO": [
        "h",
        "H"
    ],
    "TO": [
        "h",
        "H"
    ],
    "VU": [
        "h",
        "H"
    ],
    "WS": [
        "h",
        "H"
    ],
    "001": [
        "H",
        "h"
    ],
    "AL": [
        "h",
        "H",
        "hB"
    ],
    "TD": [
        "h",
        "H",
        "hB"
    ],
    "ca-ES": [
        "H",
        "h",
        "hB"
    ],
    "CF": [
        "H",
        "h",
        "hB"
    ],
    "CM": [
        "H",
        "h",
        "hB"
    ],
    "fr-CA": [
        "H",
        "h",
        "hB"
    ],
    "gl-ES": [
        "H",
        "h",
        "hB"
    ],
    "it-CH": [
        "H",
        "h",
        "hB"
    ],
    "it-IT": [
        "H",
        "h",
        "hB"
    ],
    "LU": [
        "H",
        "h",
        "hB"
    ],
    "NP": [
        "H",
        "h",
        "hB"
    ],
    "PF": [
        "H",
        "h",
        "hB"
    ],
    "SC": [
        "H",
        "h",
        "hB"
    ],
    "SM": [
        "H",
        "h",
        "hB"
    ],
    "SN": [
        "H",
        "h",
        "hB"
    ],
    "TF": [
        "H",
        "h",
        "hB"
    ],
    "VA": [
        "H",
        "h",
        "hB"
    ],
    "CY": [
        "h",
        "H",
        "hb",
        "hB"
    ],
    "GR": [
        "h",
        "H",
        "hb",
        "hB"
    ],
    "CO": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "DO": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "KP": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "KR": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "NA": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "PA": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "PR": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "VE": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "AC": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "AI": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "BW": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "BZ": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "CC": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "CK": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "CX": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "DG": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "FK": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "GB": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "GG": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "GI": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "IE": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "IM": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "IO": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "JE": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "LT": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "MK": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "MN": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "MS": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NF": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NG": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NR": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NU": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "PN": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "SH": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "SX": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "TA": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "ZA": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "af-ZA": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "AR": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "CL": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "CR": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "CU": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "EA": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-BO": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-BR": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-EC": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-ES": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-GQ": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-PE": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "GT": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "HN": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "IC": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "KG": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "KM": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "LK": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "MA": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "MX": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "NI": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "PY": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "SV": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "UY": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "JP": [
        "H",
        "h",
        "K"
    ],
    "AD": [
        "H",
        "hB"
    ],
    "AM": [
        "H",
        "hB"
    ],
    "AO": [
        "H",
        "hB"
    ],
    "AT": [
        "H",
        "hB"
    ],
    "AW": [
        "H",
        "hB"
    ],
    "BE": [
        "H",
        "hB"
    ],
    "BF": [
        "H",
        "hB"
    ],
    "BJ": [
        "H",
        "hB"
    ],
    "BL": [
        "H",
        "hB"
    ],
    "BR": [
        "H",
        "hB"
    ],
    "CG": [
        "H",
        "hB"
    ],
    "CI": [
        "H",
        "hB"
    ],
    "CV": [
        "H",
        "hB"
    ],
    "DE": [
        "H",
        "hB"
    ],
    "EE": [
        "H",
        "hB"
    ],
    "FR": [
        "H",
        "hB"
    ],
    "GA": [
        "H",
        "hB"
    ],
    "GF": [
        "H",
        "hB"
    ],
    "GN": [
        "H",
        "hB"
    ],
    "GP": [
        "H",
        "hB"
    ],
    "GW": [
        "H",
        "hB"
    ],
    "HR": [
        "H",
        "hB"
    ],
    "IL": [
        "H",
        "hB"
    ],
    "IT": [
        "H",
        "hB"
    ],
    "KZ": [
        "H",
        "hB"
    ],
    "MC": [
        "H",
        "hB"
    ],
    "MD": [
        "H",
        "hB"
    ],
    "MF": [
        "H",
        "hB"
    ],
    "MQ": [
        "H",
        "hB"
    ],
    "MZ": [
        "H",
        "hB"
    ],
    "NC": [
        "H",
        "hB"
    ],
    "NL": [
        "H",
        "hB"
    ],
    "PM": [
        "H",
        "hB"
    ],
    "PT": [
        "H",
        "hB"
    ],
    "RE": [
        "H",
        "hB"
    ],
    "RO": [
        "H",
        "hB"
    ],
    "SI": [
        "H",
        "hB"
    ],
    "SR": [
        "H",
        "hB"
    ],
    "ST": [
        "H",
        "hB"
    ],
    "TG": [
        "H",
        "hB"
    ],
    "TR": [
        "H",
        "hB"
    ],
    "WF": [
        "H",
        "hB"
    ],
    "YT": [
        "H",
        "hB"
    ],
    "BD": [
        "h",
        "hB",
        "H"
    ],
    "PK": [
        "h",
        "hB",
        "H"
    ],
    "AZ": [
        "H",
        "hB",
        "h"
    ],
    "BA": [
        "H",
        "hB",
        "h"
    ],
    "BG": [
        "H",
        "hB",
        "h"
    ],
    "CH": [
        "H",
        "hB",
        "h"
    ],
    "GE": [
        "H",
        "hB",
        "h"
    ],
    "LI": [
        "H",
        "hB",
        "h"
    ],
    "ME": [
        "H",
        "hB",
        "h"
    ],
    "RS": [
        "H",
        "hB",
        "h"
    ],
    "UA": [
        "H",
        "hB",
        "h"
    ],
    "UZ": [
        "H",
        "hB",
        "h"
    ],
    "XK": [
        "H",
        "hB",
        "h"
    ],
    "AG": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "AU": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "BB": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "BM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "BS": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "CA": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "DM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "en-001": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "FJ": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "FM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "GD": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "GM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "GU": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "GY": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "JM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "KI": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "KN": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "KY": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "LC": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "LR": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "MH": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "MP": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "MW": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "NZ": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SB": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SG": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SL": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SS": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SZ": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "TC": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "TT": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "UM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "US": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "VC": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "VG": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "VI": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "ZM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "BO": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "EC": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "ES": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "GQ": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "PE": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "AE": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "ar-001": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "BH": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "DZ": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "EG": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "EH": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "HK": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "IQ": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "JO": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "KW": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "LB": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "LY": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "MO": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "MR": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "OM": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "PH": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "PS": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "QA": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "SA": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "SD": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "SY": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "TN": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "YE": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "AF": [
        "H",
        "hb",
        "hB",
        "h"
    ],
    "LA": [
        "H",
        "hb",
        "hB",
        "h"
    ],
    "CN": [
        "H",
        "hB",
        "hb",
        "h"
    ],
    "LV": [
        "H",
        "hB",
        "hb",
        "h"
    ],
    "TL": [
        "H",
        "hB",
        "hb",
        "h"
    ],
    "zu-ZA": [
        "H",
        "hB",
        "hb",
        "h"
    ],
    "CD": [
        "hB",
        "H"
    ],
    "IR": [
        "hB",
        "H"
    ],
    "hi-IN": [
        "hB",
        "h",
        "H"
    ],
    "kn-IN": [
        "hB",
        "h",
        "H"
    ],
    "ml-IN": [
        "hB",
        "h",
        "H"
    ],
    "te-IN": [
        "hB",
        "h",
        "H"
    ],
    "KH": [
        "hB",
        "h",
        "H",
        "hb"
    ],
    "ta-IN": [
        "hB",
        "h",
        "hb",
        "H"
    ],
    "BN": [
        "hb",
        "hB",
        "h",
        "H"
    ],
    "MY": [
        "hb",
        "hB",
        "h",
        "H"
    ],
    "ET": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "gu-IN": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "mr-IN": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "pa-IN": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "TW": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "KE": [
        "hB",
        "hb",
        "H",
        "h"
    ],
    "MM": [
        "hB",
        "hb",
        "H",
        "h"
    ],
    "TZ": [
        "hB",
        "hb",
        "H",
        "h"
    ],
    "UG": [
        "hB",
        "hb",
        "H",
        "h"
    ]
};

});




parcelRegister("pW1k6", function(module, exports) {
$parcel$export(module.exports, "default", () => $04df578bb1e82bb6$export$2e2bcd8739ae039);
$parcel$export(module.exports, "strategies", () => $04df578bb1e82bb6$export$c5491a8691a23b9e);
//
// Main
//
function $04df578bb1e82bb6$export$2e2bcd8739ae039(fn, options) {
    var cache = options && options.cache ? options.cache : $04df578bb1e82bb6$var$cacheDefault;
    var serializer = options && options.serializer ? options.serializer : $04df578bb1e82bb6$var$serializerDefault;
    var strategy = options && options.strategy ? options.strategy : $04df578bb1e82bb6$var$strategyDefault;
    return strategy(fn, {
        cache: cache,
        serializer: serializer
    });
}
//
// Strategy
//
function $04df578bb1e82bb6$var$isPrimitive(value) {
    return value == null || typeof value === 'number' || typeof value === 'boolean'; // || typeof value === "string" 'unsafe' primitive for our needs
}
function $04df578bb1e82bb6$var$monadic(fn, cache, serializer, arg) {
    var cacheKey = $04df578bb1e82bb6$var$isPrimitive(arg) ? arg : serializer(arg);
    var computedValue = cache.get(cacheKey);
    if (typeof computedValue === 'undefined') {
        computedValue = fn.call(this, arg);
        cache.set(cacheKey, computedValue);
    }
    return computedValue;
}
function $04df578bb1e82bb6$var$variadic(fn, cache, serializer) {
    var args = Array.prototype.slice.call(arguments, 3);
    var cacheKey = serializer(args);
    var computedValue = cache.get(cacheKey);
    if (typeof computedValue === 'undefined') {
        computedValue = fn.apply(this, args);
        cache.set(cacheKey, computedValue);
    }
    return computedValue;
}
function $04df578bb1e82bb6$var$assemble(fn, context, strategy, cache, serialize) {
    return strategy.bind(context, fn, cache, serialize);
}
function $04df578bb1e82bb6$var$strategyDefault(fn, options) {
    var strategy = fn.length === 1 ? $04df578bb1e82bb6$var$monadic : $04df578bb1e82bb6$var$variadic;
    return $04df578bb1e82bb6$var$assemble(fn, this, strategy, options.cache.create(), options.serializer);
}
function $04df578bb1e82bb6$var$strategyVariadic(fn, options) {
    return $04df578bb1e82bb6$var$assemble(fn, this, $04df578bb1e82bb6$var$variadic, options.cache.create(), options.serializer);
}
function $04df578bb1e82bb6$var$strategyMonadic(fn, options) {
    return $04df578bb1e82bb6$var$assemble(fn, this, $04df578bb1e82bb6$var$monadic, options.cache.create(), options.serializer);
}
//
// Serializer
//
var $04df578bb1e82bb6$var$serializerDefault = function() {
    return JSON.stringify(arguments);
};
//
// Cache
//
function $04df578bb1e82bb6$var$ObjectWithoutPrototypeCache() {
    this.cache = Object.create(null);
}
$04df578bb1e82bb6$var$ObjectWithoutPrototypeCache.prototype.get = function(key) {
    return this.cache[key];
};
$04df578bb1e82bb6$var$ObjectWithoutPrototypeCache.prototype.set = function(key, value) {
    this.cache[key] = value;
};
var $04df578bb1e82bb6$var$cacheDefault = {
    create: function create() {
        // @ts-ignore
        return new $04df578bb1e82bb6$var$ObjectWithoutPrototypeCache();
    }
};
var $04df578bb1e82bb6$export$c5491a8691a23b9e = {
    variadic: $04df578bb1e82bb6$var$strategyVariadic,
    monadic: $04df578bb1e82bb6$var$strategyMonadic
};

});

parcelRegister("b1zcR", function(module, exports) {
$parcel$export(module.exports, "PART_TYPE", () => $806b18fc72f08d6f$export$49694c2877b44c57);
$parcel$export(module.exports, "isFormatXMLElementFn", () => $806b18fc72f08d6f$export$df0c12a2d414a163);
$parcel$export(module.exports, "formatToParts", () => $806b18fc72f08d6f$export$275d4a3bb5f66fda);
parcelRequire("6dpFj");
var $4VghZ = parcelRequire("4VghZ");

var $jpwqX = parcelRequire("jpwqX");
var $806b18fc72f08d6f$export$49694c2877b44c57;
(function(PART_TYPE) {
    PART_TYPE[PART_TYPE["literal"] = 0] = "literal";
    PART_TYPE[PART_TYPE["object"] = 1] = "object";
})($806b18fc72f08d6f$export$49694c2877b44c57 || ($806b18fc72f08d6f$export$49694c2877b44c57 = {}));
function $806b18fc72f08d6f$var$mergeLiteral(parts) {
    if (parts.length < 2) return parts;
    return parts.reduce(function(all, part) {
        var lastPart = all[all.length - 1];
        if (!lastPart || lastPart.type !== $806b18fc72f08d6f$export$49694c2877b44c57.literal || part.type !== $806b18fc72f08d6f$export$49694c2877b44c57.literal) all.push(part);
        else lastPart.value += part.value;
        return all;
    }, []);
}
function $806b18fc72f08d6f$export$df0c12a2d414a163(el) {
    return typeof el === 'function';
}
function $806b18fc72f08d6f$export$275d4a3bb5f66fda(els, locales, formatters, formats, values, currentPluralValue, // For debugging
originalMessage) {
    // Hot path for straight simple msg translations
    if (els.length === 1 && (0, $4VghZ.isLiteralElement)(els[0])) return [
        {
            type: $806b18fc72f08d6f$export$49694c2877b44c57.literal,
            value: els[0].value
        }
    ];
    var result = [];
    for(var _i = 0, els_1 = els; _i < els_1.length; _i++){
        var el = els_1[_i];
        // Exit early for string parts.
        if ((0, $4VghZ.isLiteralElement)(el)) {
            result.push({
                type: $806b18fc72f08d6f$export$49694c2877b44c57.literal,
                value: el.value
            });
            continue;
        }
        // TODO: should this part be literal type?
        // Replace `#` in plural rules with the actual numeric value.
        if ((0, $4VghZ.isPoundElement)(el)) {
            if (typeof currentPluralValue === 'number') result.push({
                type: $806b18fc72f08d6f$export$49694c2877b44c57.literal,
                value: formatters.getNumberFormat(locales).format(currentPluralValue)
            });
            continue;
        }
        var varName = el.value;
        // Enforce that all required values are provided by the caller.
        if (!(values && varName in values)) throw new (0, $jpwqX.MissingValueError)(varName, originalMessage);
        var value = values[varName];
        if ((0, $4VghZ.isArgumentElement)(el)) {
            if (!value || typeof value === 'string' || typeof value === 'number') value = typeof value === 'string' || typeof value === 'number' ? String(value) : '';
            result.push({
                type: typeof value === 'string' ? $806b18fc72f08d6f$export$49694c2877b44c57.literal : $806b18fc72f08d6f$export$49694c2877b44c57.object,
                value: value
            });
            continue;
        }
        // Recursively format plural and select parts' option — which can be a
        // nested pattern structure. The choosing of the option to use is
        // abstracted-by and delegated-to the part helper object.
        if ((0, $4VghZ.isDateElement)(el)) {
            var style = typeof el.style === 'string' ? formats.date[el.style] : (0, $4VghZ.isDateTimeSkeleton)(el.style) ? el.style.parsedOptions : undefined;
            result.push({
                type: $806b18fc72f08d6f$export$49694c2877b44c57.literal,
                value: formatters.getDateTimeFormat(locales, style).format(value)
            });
            continue;
        }
        if ((0, $4VghZ.isTimeElement)(el)) {
            var style = typeof el.style === 'string' ? formats.time[el.style] : (0, $4VghZ.isDateTimeSkeleton)(el.style) ? el.style.parsedOptions : formats.time.medium;
            result.push({
                type: $806b18fc72f08d6f$export$49694c2877b44c57.literal,
                value: formatters.getDateTimeFormat(locales, style).format(value)
            });
            continue;
        }
        if ((0, $4VghZ.isNumberElement)(el)) {
            var style = typeof el.style === 'string' ? formats.number[el.style] : (0, $4VghZ.isNumberSkeleton)(el.style) ? el.style.parsedOptions : undefined;
            if (style && style.scale) value = value * (style.scale || 1);
            result.push({
                type: $806b18fc72f08d6f$export$49694c2877b44c57.literal,
                value: formatters.getNumberFormat(locales, style).format(value)
            });
            continue;
        }
        if ((0, $4VghZ.isTagElement)(el)) {
            var children = el.children, value_1 = el.value;
            var formatFn = values[value_1];
            if (!$806b18fc72f08d6f$export$df0c12a2d414a163(formatFn)) throw new (0, $jpwqX.InvalidValueTypeError)(value_1, 'function', originalMessage);
            var parts = $806b18fc72f08d6f$export$275d4a3bb5f66fda(children, locales, formatters, formats, values, currentPluralValue);
            var chunks = formatFn(parts.map(function(p) {
                return p.value;
            }));
            if (!Array.isArray(chunks)) chunks = [
                chunks
            ];
            result.push.apply(result, chunks.map(function(c) {
                return {
                    type: typeof c === 'string' ? $806b18fc72f08d6f$export$49694c2877b44c57.literal : $806b18fc72f08d6f$export$49694c2877b44c57.object,
                    value: c
                };
            }));
        }
        if ((0, $4VghZ.isSelectElement)(el)) {
            var opt = el.options[value] || el.options.other;
            if (!opt) throw new (0, $jpwqX.InvalidValueError)(el.value, value, Object.keys(el.options), originalMessage);
            result.push.apply(result, $806b18fc72f08d6f$export$275d4a3bb5f66fda(opt.value, locales, formatters, formats, values));
            continue;
        }
        if ((0, $4VghZ.isPluralElement)(el)) {
            var opt = el.options["=".concat(value)];
            if (!opt) {
                if (!Intl.PluralRules) throw new (0, $jpwqX.FormatError)("Intl.PluralRules is not available in this environment.\nTry polyfilling it using \"@formatjs/intl-pluralrules\"\n", (0, $jpwqX.ErrorCode).MISSING_INTL_API, originalMessage);
                var rule = formatters.getPluralRules(locales, {
                    type: el.pluralType
                }).select(value - (el.offset || 0));
                opt = el.options[rule] || el.options.other;
            }
            if (!opt) throw new (0, $jpwqX.InvalidValueError)(el.value, value, Object.keys(el.options), originalMessage);
            result.push.apply(result, $806b18fc72f08d6f$export$275d4a3bb5f66fda(opt.value, locales, formatters, formats, values, value - (el.offset || 0)));
            continue;
        }
    }
    return $806b18fc72f08d6f$var$mergeLiteral(result);
}

});
parcelRegister("jpwqX", function(module, exports) {
$parcel$export(module.exports, "ErrorCode", () => $e21982ce468ea34f$export$d4e71bc0b80dc0fb);
$parcel$export(module.exports, "FormatError", () => $e21982ce468ea34f$export$7369836851cc1329);
$parcel$export(module.exports, "InvalidValueError", () => $e21982ce468ea34f$export$565c3afc07dfa382);
$parcel$export(module.exports, "InvalidValueTypeError", () => $e21982ce468ea34f$export$cbc0db47c750f7c9);
$parcel$export(module.exports, "MissingValueError", () => $e21982ce468ea34f$export$8bfc137e4d23fdf0);

var $l2Z7B = parcelRequire("l2Z7B");
var $e21982ce468ea34f$export$d4e71bc0b80dc0fb;
(function(ErrorCode) {
    // When we have a placeholder but no value to format
    ErrorCode["MISSING_VALUE"] = "MISSING_VALUE";
    // When value supplied is invalid
    ErrorCode["INVALID_VALUE"] = "INVALID_VALUE";
    // When we need specific Intl API but it's not available
    ErrorCode["MISSING_INTL_API"] = "MISSING_INTL_API";
})($e21982ce468ea34f$export$d4e71bc0b80dc0fb || ($e21982ce468ea34f$export$d4e71bc0b80dc0fb = {}));
var $e21982ce468ea34f$export$7369836851cc1329 = /** @class */ function(_super) {
    (0, $l2Z7B.__extends)(FormatError, _super);
    function FormatError(msg, code, originalMessage) {
        var _this = _super.call(this, msg) || this;
        _this.code = code;
        _this.originalMessage = originalMessage;
        return _this;
    }
    FormatError.prototype.toString = function() {
        return "[formatjs Error: ".concat(this.code, "] ").concat(this.message);
    };
    return FormatError;
}(Error);
var $e21982ce468ea34f$export$565c3afc07dfa382 = /** @class */ function(_super) {
    (0, $l2Z7B.__extends)(InvalidValueError, _super);
    function InvalidValueError(variableId, value, options, originalMessage) {
        return _super.call(this, "Invalid values for \"".concat(variableId, "\": \"").concat(value, "\". Options are \"").concat(Object.keys(options).join('", "'), "\""), $e21982ce468ea34f$export$d4e71bc0b80dc0fb.INVALID_VALUE, originalMessage) || this;
    }
    return InvalidValueError;
}($e21982ce468ea34f$export$7369836851cc1329);
var $e21982ce468ea34f$export$cbc0db47c750f7c9 = /** @class */ function(_super) {
    (0, $l2Z7B.__extends)(InvalidValueTypeError, _super);
    function InvalidValueTypeError(value, type, originalMessage) {
        return _super.call(this, "Value for \"".concat(value, "\" must be of type ").concat(type), $e21982ce468ea34f$export$d4e71bc0b80dc0fb.INVALID_VALUE, originalMessage) || this;
    }
    return InvalidValueTypeError;
}($e21982ce468ea34f$export$7369836851cc1329);
var $e21982ce468ea34f$export$8bfc137e4d23fdf0 = /** @class */ function(_super) {
    (0, $l2Z7B.__extends)(MissingValueError, _super);
    function MissingValueError(variableId, originalMessage) {
        return _super.call(this, "The intl string context variable \"".concat(variableId, "\" was not provided to the string \"").concat(originalMessage, "\""), $e21982ce468ea34f$export$d4e71bc0b80dc0fb.MISSING_VALUE, originalMessage) || this;
    }
    return MissingValueError;
}($e21982ce468ea34f$export$7369836851cc1329);

});



parcelRegister("lxO85", function(module, exports) {
$parcel$export(module.exports, "IntlErrorCode", () => $faf390ae03ac8755$export$557d6acb76e8a244);
$parcel$export(module.exports, "IntlError", () => $faf390ae03ac8755$export$c016d36112f6ddf8);
$parcel$export(module.exports, "UnsupportedFormatterError", () => $faf390ae03ac8755$export$549f97e137a05c90);
$parcel$export(module.exports, "InvalidConfigError", () => $faf390ae03ac8755$export$3ca04dd7fb305893);
$parcel$export(module.exports, "MissingDataError", () => $faf390ae03ac8755$export$c1eaf877d81384b6);
$parcel$export(module.exports, "IntlFormatError", () => $faf390ae03ac8755$export$e3b7eee1dbc44895);
$parcel$export(module.exports, "MessageFormatError", () => $faf390ae03ac8755$export$74a601a3d3f31621);
$parcel$export(module.exports, "MissingTranslationError", () => $faf390ae03ac8755$export$2ddcb436d0aa3688);

var $l2Z7B = parcelRequire("l2Z7B");
var $faf390ae03ac8755$export$557d6acb76e8a244;
(function(IntlErrorCode) {
    IntlErrorCode["FORMAT_ERROR"] = "FORMAT_ERROR";
    IntlErrorCode["UNSUPPORTED_FORMATTER"] = "UNSUPPORTED_FORMATTER";
    IntlErrorCode["INVALID_CONFIG"] = "INVALID_CONFIG";
    IntlErrorCode["MISSING_DATA"] = "MISSING_DATA";
    IntlErrorCode["MISSING_TRANSLATION"] = "MISSING_TRANSLATION";
})($faf390ae03ac8755$export$557d6acb76e8a244 || ($faf390ae03ac8755$export$557d6acb76e8a244 = {}));
var $faf390ae03ac8755$export$c016d36112f6ddf8 = /** @class */ function(_super) {
    (0, $l2Z7B.__extends)(IntlError, _super);
    function IntlError(code, message, exception) {
        var _this = this;
        var err = exception ? exception instanceof Error ? exception : new Error(String(exception)) : undefined;
        _this = _super.call(this, "[@formatjs/intl Error ".concat(code, "] ").concat(message, " \n").concat(err ? "\n".concat(err.message, "\n").concat(err.stack) : '')) || this;
        _this.code = code;
        // @ts-ignore just so we don't need to declare dep on @types/node
        if (typeof Error.captureStackTrace === 'function') // @ts-ignore just so we don't need to declare dep on @types/node
        Error.captureStackTrace(_this, IntlError);
        return _this;
    }
    return IntlError;
}(Error);
var $faf390ae03ac8755$export$549f97e137a05c90 = /** @class */ function(_super) {
    (0, $l2Z7B.__extends)(UnsupportedFormatterError, _super);
    function UnsupportedFormatterError(message, exception) {
        return _super.call(this, $faf390ae03ac8755$export$557d6acb76e8a244.UNSUPPORTED_FORMATTER, message, exception) || this;
    }
    return UnsupportedFormatterError;
}($faf390ae03ac8755$export$c016d36112f6ddf8);
var $faf390ae03ac8755$export$3ca04dd7fb305893 = /** @class */ function(_super) {
    (0, $l2Z7B.__extends)(InvalidConfigError, _super);
    function InvalidConfigError(message, exception) {
        return _super.call(this, $faf390ae03ac8755$export$557d6acb76e8a244.INVALID_CONFIG, message, exception) || this;
    }
    return InvalidConfigError;
}($faf390ae03ac8755$export$c016d36112f6ddf8);
var $faf390ae03ac8755$export$c1eaf877d81384b6 = /** @class */ function(_super) {
    (0, $l2Z7B.__extends)(MissingDataError, _super);
    function MissingDataError(message, exception) {
        return _super.call(this, $faf390ae03ac8755$export$557d6acb76e8a244.MISSING_DATA, message, exception) || this;
    }
    return MissingDataError;
}($faf390ae03ac8755$export$c016d36112f6ddf8);
var $faf390ae03ac8755$export$e3b7eee1dbc44895 = /** @class */ function(_super) {
    (0, $l2Z7B.__extends)(IntlFormatError, _super);
    function IntlFormatError(message, locale, exception) {
        return _super.call(this, $faf390ae03ac8755$export$557d6acb76e8a244.FORMAT_ERROR, "".concat(message, " \nLocale: ").concat(locale, "\n"), exception) || this;
    }
    return IntlFormatError;
}($faf390ae03ac8755$export$c016d36112f6ddf8);
var $faf390ae03ac8755$export$74a601a3d3f31621 = /** @class */ function(_super) {
    (0, $l2Z7B.__extends)(MessageFormatError, _super);
    function MessageFormatError(message, locale, descriptor, exception) {
        var _this = _super.call(this, "".concat(message, " \nMessageID: ").concat(descriptor === null || descriptor === void 0 ? void 0 : descriptor.id, "\nDefault Message: ").concat(descriptor === null || descriptor === void 0 ? void 0 : descriptor.defaultMessage, "\nDescription: ").concat(descriptor === null || descriptor === void 0 ? void 0 : descriptor.description, " \n"), locale, exception) || this;
        _this.descriptor = descriptor;
        return _this;
    }
    return MessageFormatError;
}($faf390ae03ac8755$export$e3b7eee1dbc44895);
var $faf390ae03ac8755$export$2ddcb436d0aa3688 = /** @class */ function(_super) {
    (0, $l2Z7B.__extends)(MissingTranslationError, _super);
    function MissingTranslationError(descriptor, locale) {
        var _this = _super.call(this, $faf390ae03ac8755$export$557d6acb76e8a244.MISSING_TRANSLATION, "Missing message: \"".concat(descriptor.id, "\" for locale \"").concat(locale, "\", using ").concat(descriptor.defaultMessage ? 'default message' : 'id', " as fallback.")) || this;
        _this.descriptor = descriptor;
        return _this;
    }
    return MissingTranslationError;
}($faf390ae03ac8755$export$c016d36112f6ddf8);

});




parcelRegister("htSVt", function(module, exports) {
$parcel$export(module.exports, "createIntl", () => $cb9fc0461b2a2e42$export$7e4cbedfdd7b4c0d);

var $l2Z7B = parcelRequire("l2Z7B");

var $ftB2S = parcelRequire("ftB2S");

var $lxO85 = parcelRequire("lxO85");

var $8IvbH = parcelRequire("8IvbH");

var $3h18O = parcelRequire("3h18O");

var $63ABF = parcelRequire("63ABF");

var $37L44 = parcelRequire("37L44");

var $2k5ES = parcelRequire("2k5ES");

var $cEdDX = parcelRequire("cEdDX");

var $bNLaT = parcelRequire("bNLaT");
function $cb9fc0461b2a2e42$var$messagesContainString(messages) {
    var firstMessage = messages ? messages[Object.keys(messages)[0]] : undefined;
    return typeof firstMessage === 'string';
}
function $cb9fc0461b2a2e42$var$verifyConfigMessages(config) {
    if (config.onWarn && config.defaultRichTextElements && $cb9fc0461b2a2e42$var$messagesContainString(config.messages || {})) config.onWarn("[@formatjs/intl] \"defaultRichTextElements\" was specified but \"message\" was not pre-compiled. \nPlease consider using \"@formatjs/cli\" to pre-compile your messages for performance.\nFor more details see https://formatjs.io/docs/getting-started/message-distribution");
}
function $cb9fc0461b2a2e42$export$7e4cbedfdd7b4c0d(config, cache) {
    var formatters = (0, $ftB2S.createFormatters)(cache);
    var resolvedConfig = (0, $l2Z7B.__assign)((0, $l2Z7B.__assign)({}, (0, $ftB2S.DEFAULT_INTL_CONFIG)), config);
    var locale = resolvedConfig.locale, defaultLocale = resolvedConfig.defaultLocale, onError = resolvedConfig.onError;
    if (!locale) {
        if (onError) onError(new (0, $lxO85.InvalidConfigError)("\"locale\" was not configured, using \"".concat(defaultLocale, "\" as fallback. See https://formatjs.io/docs/react-intl/api#intlshape for more details")));
        // Since there's no registered locale data for `locale`, this will
        // fallback to the `defaultLocale` to make sure things can render.
        // The `messages` are overridden to the `defaultProps` empty object
        // to maintain referential equality across re-renders. It's assumed
        // each <FormattedMessage> contains a `defaultMessage` prop.
        resolvedConfig.locale = resolvedConfig.defaultLocale || 'en';
    } else if (!Intl.NumberFormat.supportedLocalesOf(locale).length && onError) onError(new (0, $lxO85.MissingDataError)("Missing locale data for locale: \"".concat(locale, "\" in Intl.NumberFormat. Using default locale: \"").concat(defaultLocale, "\" as fallback. See https://formatjs.io/docs/react-intl#runtime-requirements for more details")));
    else if (!Intl.DateTimeFormat.supportedLocalesOf(locale).length && onError) onError(new (0, $lxO85.MissingDataError)("Missing locale data for locale: \"".concat(locale, "\" in Intl.DateTimeFormat. Using default locale: \"").concat(defaultLocale, "\" as fallback. See https://formatjs.io/docs/react-intl#runtime-requirements for more details")));
    $cb9fc0461b2a2e42$var$verifyConfigMessages(resolvedConfig);
    return (0, $l2Z7B.__assign)((0, $l2Z7B.__assign)({}, resolvedConfig), {
        formatters: formatters,
        formatNumber: (0, $8IvbH.formatNumber).bind(null, resolvedConfig, formatters.getNumberFormat),
        formatNumberToParts: (0, $8IvbH.formatNumberToParts).bind(null, resolvedConfig, formatters.getNumberFormat),
        formatRelativeTime: (0, $3h18O.formatRelativeTime).bind(null, resolvedConfig, formatters.getRelativeTimeFormat),
        formatDate: (0, $63ABF.formatDate).bind(null, resolvedConfig, formatters.getDateTimeFormat),
        formatDateToParts: (0, $63ABF.formatDateToParts).bind(null, resolvedConfig, formatters.getDateTimeFormat),
        formatTime: (0, $63ABF.formatTime).bind(null, resolvedConfig, formatters.getDateTimeFormat),
        formatDateTimeRange: (0, $63ABF.formatDateTimeRange).bind(null, resolvedConfig, formatters.getDateTimeFormat),
        formatTimeToParts: (0, $63ABF.formatTimeToParts).bind(null, resolvedConfig, formatters.getDateTimeFormat),
        formatPlural: (0, $37L44.formatPlural).bind(null, resolvedConfig, formatters.getPluralRules),
        formatMessage: (0, $2k5ES.formatMessage).bind(null, resolvedConfig, formatters),
        $t: (0, $2k5ES.formatMessage).bind(null, resolvedConfig, formatters),
        formatList: (0, $cEdDX.formatList).bind(null, resolvedConfig, formatters.getListFormat),
        formatListToParts: (0, $cEdDX.formatListToParts).bind(null, resolvedConfig, formatters.getListFormat),
        formatDisplayName: (0, $bNLaT.formatDisplayName).bind(null, resolvedConfig, formatters.getDisplayNames)
    });
}

});
parcelRegister("8IvbH", function(module, exports) {
$parcel$export(module.exports, "formatNumber", () => $658aa001f74e17e0$export$f5dd818bff069720);
$parcel$export(module.exports, "formatNumberToParts", () => $658aa001f74e17e0$export$6871080848f10b2f);

var $ftB2S = parcelRequire("ftB2S");

var $lxO85 = parcelRequire("lxO85");
var $658aa001f74e17e0$var$NUMBER_FORMAT_OPTIONS = [
    'localeMatcher',
    'style',
    'currency',
    'currencyDisplay',
    'unit',
    'unitDisplay',
    'useGrouping',
    'minimumIntegerDigits',
    'minimumFractionDigits',
    'maximumFractionDigits',
    'minimumSignificantDigits',
    'maximumSignificantDigits',
    // ES2020 NumberFormat
    'compactDisplay',
    'currencyDisplay',
    'currencySign',
    'notation',
    'signDisplay',
    'unit',
    'unitDisplay',
    'numberingSystem'
];
function $658aa001f74e17e0$export$a7f9565e3c81cd54(_a, getNumberFormat, options) {
    var locale = _a.locale, formats = _a.formats, onError = _a.onError;
    if (options === void 0) options = {};
    var format = options.format;
    var defaults = format && (0, $ftB2S.getNamedFormat)(formats, 'number', format, onError) || {};
    var filteredOptions = (0, $ftB2S.filterProps)(options, $658aa001f74e17e0$var$NUMBER_FORMAT_OPTIONS, defaults);
    return getNumberFormat(locale, filteredOptions);
}
function $658aa001f74e17e0$export$f5dd818bff069720(config, getNumberFormat, value, options) {
    if (options === void 0) options = {};
    try {
        return $658aa001f74e17e0$export$a7f9565e3c81cd54(config, getNumberFormat, options).format(value);
    } catch (e) {
        config.onError(new (0, $lxO85.IntlError)((0, $lxO85.IntlErrorCode).FORMAT_ERROR, 'Error formatting number.', e));
    }
    return String(value);
}
function $658aa001f74e17e0$export$6871080848f10b2f(config, getNumberFormat, value, options) {
    if (options === void 0) options = {};
    try {
        return $658aa001f74e17e0$export$a7f9565e3c81cd54(config, getNumberFormat, options).formatToParts(value);
    } catch (e) {
        config.onError(new (0, $lxO85.IntlError)((0, $lxO85.IntlErrorCode).FORMAT_ERROR, 'Error formatting number.', e));
    }
    return [];
}

});

parcelRegister("3h18O", function(module, exports) {
$parcel$export(module.exports, "formatRelativeTime", () => $2623d837842f9cad$export$b4ea3b48dcf921f6);

var $ftB2S = parcelRequire("ftB2S");

var $jpwqX = parcelRequire("jpwqX");

var $lxO85 = parcelRequire("lxO85");
var $2623d837842f9cad$var$RELATIVE_TIME_FORMAT_OPTIONS = [
    'numeric',
    'style'
];
function $2623d837842f9cad$var$getFormatter(_a, getRelativeTimeFormat, options) {
    var locale = _a.locale, formats = _a.formats, onError = _a.onError;
    if (options === void 0) options = {};
    var format = options.format;
    var defaults = !!format && (0, $ftB2S.getNamedFormat)(formats, 'relative', format, onError) || {};
    var filteredOptions = (0, $ftB2S.filterProps)(options, $2623d837842f9cad$var$RELATIVE_TIME_FORMAT_OPTIONS, defaults);
    return getRelativeTimeFormat(locale, filteredOptions);
}
function $2623d837842f9cad$export$b4ea3b48dcf921f6(config, getRelativeTimeFormat, value, unit, options) {
    if (options === void 0) options = {};
    if (!unit) unit = 'second';
    var RelativeTimeFormat = Intl.RelativeTimeFormat;
    if (!RelativeTimeFormat) config.onError(new (0, $jpwqX.FormatError)("Intl.RelativeTimeFormat is not available in this environment.\nTry polyfilling it using \"@formatjs/intl-relativetimeformat\"\n", (0, $jpwqX.ErrorCode).MISSING_INTL_API));
    try {
        return $2623d837842f9cad$var$getFormatter(config, getRelativeTimeFormat, options).format(value, unit);
    } catch (e) {
        config.onError(new (0, $lxO85.IntlFormatError)('Error formatting relative time.', config.locale, e));
    }
    return String(value);
}

});

parcelRegister("63ABF", function(module, exports) {
$parcel$export(module.exports, "formatDate", () => $468f6b2d6b5b6e33$export$3ae94a2503e890a1);
$parcel$export(module.exports, "formatTime", () => $468f6b2d6b5b6e33$export$3203edd9e5edd663);
$parcel$export(module.exports, "formatDateTimeRange", () => $468f6b2d6b5b6e33$export$a7fc3a91cb2ec376);
$parcel$export(module.exports, "formatDateToParts", () => $468f6b2d6b5b6e33$export$dc1f059bce486b1);
$parcel$export(module.exports, "formatTimeToParts", () => $468f6b2d6b5b6e33$export$af6e5d7a5c73edeb);

var $l2Z7B = parcelRequire("l2Z7B");

var $ftB2S = parcelRequire("ftB2S");

var $lxO85 = parcelRequire("lxO85");
var $468f6b2d6b5b6e33$var$DATE_TIME_FORMAT_OPTIONS = [
    'localeMatcher',
    'formatMatcher',
    'timeZone',
    'hour12',
    'weekday',
    'era',
    'year',
    'month',
    'day',
    'hour',
    'minute',
    'second',
    'timeZoneName',
    'hourCycle',
    'dateStyle',
    'timeStyle',
    'calendar',
    // 'dayPeriod',
    'numberingSystem'
];
function $468f6b2d6b5b6e33$export$a7f9565e3c81cd54(_a, type, getDateTimeFormat, options) {
    var locale = _a.locale, formats = _a.formats, onError = _a.onError, timeZone = _a.timeZone;
    if (options === void 0) options = {};
    var format = options.format;
    var defaults = (0, $l2Z7B.__assign)((0, $l2Z7B.__assign)({}, timeZone && {
        timeZone: timeZone
    }), format && (0, $ftB2S.getNamedFormat)(formats, type, format, onError));
    var filteredOptions = (0, $ftB2S.filterProps)(options, $468f6b2d6b5b6e33$var$DATE_TIME_FORMAT_OPTIONS, defaults);
    if (type === 'time' && !filteredOptions.hour && !filteredOptions.minute && !filteredOptions.second && !filteredOptions.timeStyle && !filteredOptions.dateStyle) // Add default formatting options if hour, minute, or second isn't defined.
    filteredOptions = (0, $l2Z7B.__assign)((0, $l2Z7B.__assign)({}, filteredOptions), {
        hour: 'numeric',
        minute: 'numeric'
    });
    return getDateTimeFormat(locale, filteredOptions);
}
function $468f6b2d6b5b6e33$export$3ae94a2503e890a1(config, getDateTimeFormat) {
    var _a = [];
    for(var _i = 2; _i < arguments.length; _i++)_a[_i - 2] = arguments[_i];
    var value = _a[0], _b = _a[1], options = _b === void 0 ? {} : _b;
    var date = typeof value === 'string' ? new Date(value || 0) : value;
    try {
        return $468f6b2d6b5b6e33$export$a7f9565e3c81cd54(config, 'date', getDateTimeFormat, options).format(date);
    } catch (e) {
        config.onError(new (0, $lxO85.IntlError)((0, $lxO85.IntlErrorCode).FORMAT_ERROR, 'Error formatting date.', e));
    }
    return String(date);
}
function $468f6b2d6b5b6e33$export$3203edd9e5edd663(config, getDateTimeFormat) {
    var _a = [];
    for(var _i = 2; _i < arguments.length; _i++)_a[_i - 2] = arguments[_i];
    var value = _a[0], _b = _a[1], options = _b === void 0 ? {} : _b;
    var date = typeof value === 'string' ? new Date(value || 0) : value;
    try {
        return $468f6b2d6b5b6e33$export$a7f9565e3c81cd54(config, 'time', getDateTimeFormat, options).format(date);
    } catch (e) {
        config.onError(new (0, $lxO85.IntlError)((0, $lxO85.IntlErrorCode).FORMAT_ERROR, 'Error formatting time.', e));
    }
    return String(date);
}
function $468f6b2d6b5b6e33$export$a7fc3a91cb2ec376(config, getDateTimeFormat) {
    var _a = [];
    for(var _i = 2; _i < arguments.length; _i++)_a[_i - 2] = arguments[_i];
    var from = _a[0], to = _a[1], _b = _a[2], options = _b === void 0 ? {} : _b;
    var timeZone = config.timeZone, locale = config.locale, onError = config.onError;
    var filteredOptions = (0, $ftB2S.filterProps)(options, $468f6b2d6b5b6e33$var$DATE_TIME_FORMAT_OPTIONS, timeZone ? {
        timeZone: timeZone
    } : {});
    try {
        return getDateTimeFormat(locale, filteredOptions).formatRange(from, to);
    } catch (e) {
        onError(new (0, $lxO85.IntlError)((0, $lxO85.IntlErrorCode).FORMAT_ERROR, 'Error formatting date time range.', e));
    }
    return String(from);
}
function $468f6b2d6b5b6e33$export$dc1f059bce486b1(config, getDateTimeFormat) {
    var _a = [];
    for(var _i = 2; _i < arguments.length; _i++)_a[_i - 2] = arguments[_i];
    var value = _a[0], _b = _a[1], options = _b === void 0 ? {} : _b;
    var date = typeof value === 'string' ? new Date(value || 0) : value;
    try {
        return $468f6b2d6b5b6e33$export$a7f9565e3c81cd54(config, 'date', getDateTimeFormat, options).formatToParts(date);
    } catch (e) {
        config.onError(new (0, $lxO85.IntlError)((0, $lxO85.IntlErrorCode).FORMAT_ERROR, 'Error formatting date.', e));
    }
    return [];
}
function $468f6b2d6b5b6e33$export$af6e5d7a5c73edeb(config, getDateTimeFormat) {
    var _a = [];
    for(var _i = 2; _i < arguments.length; _i++)_a[_i - 2] = arguments[_i];
    var value = _a[0], _b = _a[1], options = _b === void 0 ? {} : _b;
    var date = typeof value === 'string' ? new Date(value || 0) : value;
    try {
        return $468f6b2d6b5b6e33$export$a7f9565e3c81cd54(config, 'time', getDateTimeFormat, options).formatToParts(date);
    } catch (e) {
        config.onError(new (0, $lxO85.IntlError)((0, $lxO85.IntlErrorCode).FORMAT_ERROR, 'Error formatting time.', e));
    }
    return [];
}

});

parcelRegister("37L44", function(module, exports) {
$parcel$export(module.exports, "formatPlural", () => $2466889469f751f1$export$bbbd05c900f3568d);

var $ftB2S = parcelRequire("ftB2S");

var $lxO85 = parcelRequire("lxO85");

var $jpwqX = parcelRequire("jpwqX");
var $2466889469f751f1$var$PLURAL_FORMAT_OPTIONS = [
    'localeMatcher',
    'type'
];
function $2466889469f751f1$export$bbbd05c900f3568d(_a, getPluralRules, value, options) {
    var locale = _a.locale, onError = _a.onError;
    if (options === void 0) options = {};
    if (!Intl.PluralRules) onError(new (0, $jpwqX.FormatError)("Intl.PluralRules is not available in this environment.\nTry polyfilling it using \"@formatjs/intl-pluralrules\"\n", (0, $jpwqX.ErrorCode).MISSING_INTL_API));
    var filteredOptions = (0, $ftB2S.filterProps)(options, $2466889469f751f1$var$PLURAL_FORMAT_OPTIONS);
    try {
        return getPluralRules(locale, filteredOptions).select(value);
    } catch (e) {
        onError(new (0, $lxO85.IntlFormatError)('Error formatting plural.', locale, e));
    }
    return 'other';
}

});

parcelRegister("2k5ES", function(module, exports) {
$parcel$export(module.exports, "formatMessage", () => $1b11d6a681c9014e$export$25868d1e8e76735f);

var $l2Z7B = parcelRequire("l2Z7B");

var $kVTHJ = parcelRequire("kVTHJ");

var $9exF4 = parcelRequire("9exF4");

var $lxO85 = parcelRequire("lxO85");
parcelRequire("6dpFj");
var $4VghZ = parcelRequire("4VghZ");
function $1b11d6a681c9014e$var$setTimeZoneInOptions(opts, timeZone) {
    return Object.keys(opts).reduce(function(all, k) {
        all[k] = (0, $l2Z7B.__assign)({
            timeZone: timeZone
        }, opts[k]);
        return all;
    }, {});
}
function $1b11d6a681c9014e$var$deepMergeOptions(opts1, opts2) {
    var keys = Object.keys((0, $l2Z7B.__assign)((0, $l2Z7B.__assign)({}, opts1), opts2));
    return keys.reduce(function(all, k) {
        all[k] = (0, $l2Z7B.__assign)((0, $l2Z7B.__assign)({}, opts1[k] || {}), opts2[k] || {});
        return all;
    }, {});
}
function $1b11d6a681c9014e$var$deepMergeFormatsAndSetTimeZone(f1, timeZone) {
    if (!timeZone) return f1;
    var mfFormats = (0, $9exF4.IntlMessageFormat).formats;
    return (0, $l2Z7B.__assign)((0, $l2Z7B.__assign)((0, $l2Z7B.__assign)({}, mfFormats), f1), {
        date: $1b11d6a681c9014e$var$deepMergeOptions($1b11d6a681c9014e$var$setTimeZoneInOptions(mfFormats.date, timeZone), $1b11d6a681c9014e$var$setTimeZoneInOptions(f1.date || {}, timeZone)),
        time: $1b11d6a681c9014e$var$deepMergeOptions($1b11d6a681c9014e$var$setTimeZoneInOptions(mfFormats.time, timeZone), $1b11d6a681c9014e$var$setTimeZoneInOptions(f1.time || {}, timeZone))
    });
}
function $1b11d6a681c9014e$export$25868d1e8e76735f(_a, state, messageDescriptor, values, opts) {
    var locale = _a.locale, formats = _a.formats, messages = _a.messages, defaultLocale = _a.defaultLocale, defaultFormats = _a.defaultFormats, fallbackOnEmptyString = _a.fallbackOnEmptyString, onError = _a.onError, timeZone = _a.timeZone, defaultRichTextElements = _a.defaultRichTextElements;
    if (messageDescriptor === void 0) messageDescriptor = {
        id: ''
    };
    var msgId = messageDescriptor.id, defaultMessage = messageDescriptor.defaultMessage;
    // `id` is a required field of a Message Descriptor.
    (0, $kVTHJ.invariant)(!!msgId, "[@formatjs/intl] An `id` must be provided to format a message. You can either:\n1. Configure your build toolchain with [babel-plugin-formatjs](https://formatjs.io/docs/tooling/babel-plugin)\nor [@formatjs/ts-transformer](https://formatjs.io/docs/tooling/ts-transformer) OR\n2. Configure your `eslint` config to include [eslint-plugin-formatjs](https://formatjs.io/docs/tooling/linter#enforce-id)\nto autofix this issue");
    var id = String(msgId);
    var message = // In case messages is Object.create(null)
    // e.g import('foo.json') from webpack)
    // See https://github.com/formatjs/formatjs/issues/1914
    messages && Object.prototype.hasOwnProperty.call(messages, id) && messages[id];
    // IMPORTANT: Hot path if `message` is AST with a single literal node
    if (Array.isArray(message) && message.length === 1 && message[0].type === (0, $4VghZ.TYPE).literal) return message[0].value;
    // IMPORTANT: Hot path straight lookup for performance
    if (!values && message && typeof message === 'string' && !defaultRichTextElements) return message.replace(/'\{(.*?)\}'/gi, "{$1}");
    values = (0, $l2Z7B.__assign)((0, $l2Z7B.__assign)({}, defaultRichTextElements), values || {});
    formats = $1b11d6a681c9014e$var$deepMergeFormatsAndSetTimeZone(formats, timeZone);
    defaultFormats = $1b11d6a681c9014e$var$deepMergeFormatsAndSetTimeZone(defaultFormats, timeZone);
    if (!message) {
        if (fallbackOnEmptyString === false && message === '') return message;
        if (!defaultMessage || locale && locale.toLowerCase() !== defaultLocale.toLowerCase()) // This prevents warnings from littering the console in development
        // when no `messages` are passed into the <IntlProvider> for the
        // default locale.
        onError(new (0, $lxO85.MissingTranslationError)(messageDescriptor, locale));
        if (defaultMessage) try {
            var formatter = state.getMessageFormat(defaultMessage, defaultLocale, defaultFormats, opts);
            return formatter.format(values);
        } catch (e) {
            onError(new (0, $lxO85.MessageFormatError)("Error formatting default message for: \"".concat(id, "\", rendering default message verbatim"), locale, messageDescriptor, e));
            return typeof defaultMessage === 'string' ? defaultMessage : id;
        }
        return id;
    }
    // We have the translated message
    try {
        var formatter = state.getMessageFormat(message, locale, formats, (0, $l2Z7B.__assign)({
            formatters: state
        }, opts || {}));
        return formatter.format(values);
    } catch (e) {
        onError(new (0, $lxO85.MessageFormatError)("Error formatting message: \"".concat(id, "\", using ").concat(defaultMessage ? 'default message' : 'id', " as fallback."), locale, messageDescriptor, e));
    }
    if (defaultMessage) try {
        var formatter = state.getMessageFormat(defaultMessage, defaultLocale, defaultFormats, opts);
        return formatter.format(values);
    } catch (e) {
        onError(new (0, $lxO85.MessageFormatError)("Error formatting the default message for: \"".concat(id, "\", rendering message verbatim"), locale, messageDescriptor, e));
    }
    if (typeof message === 'string') return message;
    if (typeof defaultMessage === 'string') return defaultMessage;
    return id;
}

});

parcelRegister("cEdDX", function(module, exports) {
$parcel$export(module.exports, "formatList", () => $9353cdc81fe3f1a9$export$e8b8be48b45905bb);
$parcel$export(module.exports, "formatListToParts", () => $9353cdc81fe3f1a9$export$6f284aad1934db69);

var $l2Z7B = parcelRequire("l2Z7B");

var $ftB2S = parcelRequire("ftB2S");

var $jpwqX = parcelRequire("jpwqX");

var $lxO85 = parcelRequire("lxO85");
var $9353cdc81fe3f1a9$var$LIST_FORMAT_OPTIONS = [
    'localeMatcher',
    'type',
    'style'
];
var $9353cdc81fe3f1a9$var$now = Date.now();
function $9353cdc81fe3f1a9$var$generateToken(i) {
    return "".concat($9353cdc81fe3f1a9$var$now, "_").concat(i, "_").concat($9353cdc81fe3f1a9$var$now);
}
function $9353cdc81fe3f1a9$export$e8b8be48b45905bb(opts, getListFormat, values, options) {
    if (options === void 0) options = {};
    var results = $9353cdc81fe3f1a9$export$6f284aad1934db69(opts, getListFormat, values, options).reduce(function(all, el) {
        var val = el.value;
        if (typeof val !== 'string') all.push(val);
        else if (typeof all[all.length - 1] === 'string') all[all.length - 1] += val;
        else all.push(val);
        return all;
    }, []);
    return results.length === 1 ? results[0] : results;
}
function $9353cdc81fe3f1a9$export$6f284aad1934db69(_a, getListFormat, values, options) {
    var locale = _a.locale, onError = _a.onError;
    if (options === void 0) options = {};
    var ListFormat = Intl.ListFormat;
    if (!ListFormat) onError(new (0, $jpwqX.FormatError)("Intl.ListFormat is not available in this environment.\nTry polyfilling it using \"@formatjs/intl-listformat\"\n", (0, $jpwqX.ErrorCode).MISSING_INTL_API));
    var filteredOptions = (0, $ftB2S.filterProps)(options, $9353cdc81fe3f1a9$var$LIST_FORMAT_OPTIONS);
    try {
        var richValues_1 = {};
        var serializedValues = values.map(function(v, i) {
            if (typeof v === 'object') {
                var id = $9353cdc81fe3f1a9$var$generateToken(i);
                richValues_1[id] = v;
                return id;
            }
            return String(v);
        });
        return getListFormat(locale, filteredOptions).formatToParts(serializedValues).map(function(part) {
            return part.type === 'literal' ? part : (0, $l2Z7B.__assign)((0, $l2Z7B.__assign)({}, part), {
                value: richValues_1[part.value] || part.value
            });
        });
    } catch (e) {
        onError(new (0, $lxO85.IntlError)((0, $lxO85.IntlErrorCode).FORMAT_ERROR, 'Error formatting list.', e));
    }
    // @ts-ignore
    return values;
}

});

parcelRegister("bNLaT", function(module, exports) {
$parcel$export(module.exports, "formatDisplayName", () => $8978dd3e5f4a7a94$export$62fe1a4d9e891fa2);

var $ftB2S = parcelRequire("ftB2S");

var $jpwqX = parcelRequire("jpwqX");

var $lxO85 = parcelRequire("lxO85");
var $8978dd3e5f4a7a94$var$DISPLAY_NAMES_OPTONS = [
    'localeMatcher',
    'style',
    'type',
    'fallback'
];
function $8978dd3e5f4a7a94$export$62fe1a4d9e891fa2(_a, getDisplayNames, value, options) {
    var locale = _a.locale, onError = _a.onError;
    var DisplayNames = Intl.DisplayNames;
    if (!DisplayNames) onError(new (0, $jpwqX.FormatError)("Intl.DisplayNames is not available in this environment.\nTry polyfilling it using \"@formatjs/intl-displaynames\"\n", (0, $jpwqX.ErrorCode).MISSING_INTL_API));
    var filteredOptions = (0, $ftB2S.filterProps)(options, $8978dd3e5f4a7a94$var$DISPLAY_NAMES_OPTONS);
    try {
        return getDisplayNames(locale, filteredOptions).of(value);
    } catch (e) {
        onError(new (0, $lxO85.IntlError)((0, $lxO85.IntlErrorCode).FORMAT_ERROR, 'Error formatting display name.', e));
    }
}

});



parcelRegister("74Zh5", function(module, exports) {
$parcel$export(module.exports, "css", () => $527870009e653bdb$export$dbf350e5966cf602);
$parcel$export(module.exports, "keyframes", () => $527870009e653bdb$export$d25ddfdf17c3ad3e);
$parcel$export(module.exports, "ClassNames", () => $527870009e653bdb$export$9b9c0f9d9f3552b8);
$parcel$export(module.exports, "jsx", () => $527870009e653bdb$export$c8a8987d4410bf2d);
$parcel$export(module.exports, "ThemeContext", () => (parcelRequire("rxpl9")).T);
$parcel$export(module.exports, "withEmotionCache", () => (parcelRequire("rxpl9")).w);

var $rxpl9 = parcelRequire("rxpl9");

var $5FkrB = parcelRequire("5FkrB");

var $eP8dQ = parcelRequire("eP8dQ");

var $5qnXH = parcelRequire("5qnXH");

var $ckRFu = parcelRequire("ckRFu");
parcelRequire("bR2Nz");
parcelRequire("kqp0i");
parcelRequire("1QNjI");

parcelRequire("knBeW");
var $527870009e653bdb$export$c8a8987d4410bf2d = function jsx(type, props) {
    // eslint-disable-next-line prefer-rest-params
    var args = arguments;
    if (props == null || !(0, $rxpl9.h).call(props, 'css')) return $5FkrB.createElement.apply(undefined, args);
    var argsLength = args.length;
    var createElementArgArray = new Array(argsLength);
    createElementArgArray[0] = (0, $rxpl9.E);
    createElementArgArray[1] = (0, $rxpl9.c)(type, props);
    for(var i = 2; i < argsLength; i++)createElementArgArray[i] = args[i];
    return $5FkrB.createElement.apply(null, createElementArgArray);
};
(function(_jsx) {
    var JSX;
    JSX || (JSX = _jsx.JSX || (_jsx.JSX = {}));
})($527870009e653bdb$export$c8a8987d4410bf2d || ($527870009e653bdb$export$c8a8987d4410bf2d = {}));
// initial render from browser, insertBefore context.sheet.tags[0] or if a style hasn't been inserted there yet, appendChild
// initial client-side render from SSR, use place of hydrating tag
var $527870009e653bdb$export$98f03c5d19621d70 = /* #__PURE__ */ (0, $rxpl9.w)(function(props, cache) {
    var styles = props.styles;
    var serialized = (0, $ckRFu.serializeStyles)([
        styles
    ], undefined, $5FkrB.useContext((0, $rxpl9.T)));
    if (!(0, $rxpl9.i)) {
        var _ref;
        var serializedNames = serialized.name;
        var serializedStyles = serialized.styles;
        var next = serialized.next;
        while(next !== undefined){
            serializedNames += ' ' + next.name;
            serializedStyles += next.styles;
            next = next.next;
        }
        var shouldCache = cache.compat === true;
        var rules = cache.insert("", {
            name: serializedNames,
            styles: serializedStyles
        }, cache.sheet, shouldCache);
        if (shouldCache) return null;
        return /*#__PURE__*/ $5FkrB.createElement("style", (_ref = {}, _ref["data-emotion"] = cache.key + "-global " + serializedNames, _ref.dangerouslySetInnerHTML = {
            __html: rules
        }, _ref.nonce = cache.sheet.nonce, _ref));
    } // yes, i know these hooks are used conditionally
    // but it is based on a constant that will never change at runtime
    // it's effectively like having two implementations and switching them out
    // so it's not actually breaking anything
    var sheetRef = $5FkrB.useRef();
    (0, $5qnXH.useInsertionEffectWithLayoutFallback)(function() {
        var key = cache.key + "-global"; // use case of https://github.com/emotion-js/emotion/issues/2675
        var sheet = new cache.sheet.constructor({
            key: key,
            nonce: cache.sheet.nonce,
            container: cache.sheet.container,
            speedy: cache.sheet.isSpeedy
        });
        var rehydrating = false;
        var node = document.querySelector("style[data-emotion=\"" + key + " " + serialized.name + "\"]");
        if (cache.sheet.tags.length) sheet.before = cache.sheet.tags[0];
        if (node !== null) {
            rehydrating = true; // clear the hash so this node won't be recognizable as rehydratable by other <Global/>s
            node.setAttribute('data-emotion', key);
            sheet.hydrate([
                node
            ]);
        }
        sheetRef.current = [
            sheet,
            rehydrating
        ];
        return function() {
            sheet.flush();
        };
    }, [
        cache
    ]);
    (0, $5qnXH.useInsertionEffectWithLayoutFallback)(function() {
        var sheetRefCurrent = sheetRef.current;
        var sheet = sheetRefCurrent[0], rehydrating = sheetRefCurrent[1];
        if (rehydrating) {
            sheetRefCurrent[1] = false;
            return;
        }
        if (serialized.next !== undefined) // insert keyframes
        (0, $eP8dQ.insertStyles)(cache, serialized.next, true);
        if (sheet.tags.length) {
            // if this doesn't exist then it will be null so the style element will be appended
            var element = sheet.tags[sheet.tags.length - 1].nextElementSibling;
            sheet.before = element;
            sheet.flush();
        }
        cache.insert("", serialized, sheet, false);
    }, [
        cache,
        serialized.name
    ]);
    return null;
});
function $527870009e653bdb$export$dbf350e5966cf602() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return (0, $ckRFu.serializeStyles)(args);
}
function $527870009e653bdb$export$d25ddfdf17c3ad3e() {
    var insertable = $527870009e653bdb$export$dbf350e5966cf602.apply(void 0, arguments);
    var name = "animation-" + insertable.name;
    return {
        name: name,
        styles: "@keyframes " + name + "{" + insertable.styles + "}",
        anim: 1,
        toString: function toString() {
            return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
        }
    };
}
var $527870009e653bdb$var$classnames = function classnames(args) {
    var len = args.length;
    var i = 0;
    var cls = '';
    for(; i < len; i++){
        var arg = args[i];
        if (arg == null) continue;
        var toAdd = void 0;
        switch(typeof arg){
            case 'boolean':
                break;
            case 'object':
                if (Array.isArray(arg)) toAdd = classnames(arg);
                else {
                    toAdd = '';
                    for(var k in arg)if (arg[k] && k) {
                        toAdd && (toAdd += ' ');
                        toAdd += k;
                    }
                }
                break;
            default:
                toAdd = arg;
        }
        if (toAdd) {
            cls && (cls += ' ');
            cls += toAdd;
        }
    }
    return cls;
};
function $527870009e653bdb$var$merge(registered, css, className) {
    var registeredStyles = [];
    var rawClassName = (0, $eP8dQ.getRegisteredStyles)(registered, registeredStyles, className);
    if (registeredStyles.length < 2) return className;
    return rawClassName + css(registeredStyles);
}
var $527870009e653bdb$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serializedArr = _ref.serializedArr;
    var rules = (0, $5qnXH.useInsertionEffectAlwaysWithSyncFallback)(function() {
        var rules = '';
        for(var i = 0; i < serializedArr.length; i++){
            var res = (0, $eP8dQ.insertStyles)(cache, serializedArr[i], false);
            if (!(0, $rxpl9.i) && res !== undefined) rules += res;
        }
        if (!(0, $rxpl9.i)) return rules;
    });
    if (!(0, $rxpl9.i) && rules.length !== 0) {
        var _ref2;
        return /*#__PURE__*/ $5FkrB.createElement("style", (_ref2 = {}, _ref2["data-emotion"] = cache.key + " " + serializedArr.map(function(serialized) {
            return serialized.name;
        }).join(' '), _ref2.dangerouslySetInnerHTML = {
            __html: rules
        }, _ref2.nonce = cache.sheet.nonce, _ref2));
    }
    return null;
};
var $527870009e653bdb$export$9b9c0f9d9f3552b8 = /* #__PURE__ */ (0, $rxpl9.w)(function(props, cache) {
    var hasRendered = false;
    var serializedArr = [];
    var css = function css() {
        if (hasRendered && (0, $rxpl9.a)) throw new Error('css can only be used during render');
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var serialized = (0, $ckRFu.serializeStyles)(args, cache.registered);
        serializedArr.push(serialized); // registration has to happen here as the result of this might get consumed by `cx`
        (0, $eP8dQ.registerStyles)(cache, serialized, false);
        return cache.key + "-" + serialized.name;
    };
    var cx = function cx() {
        if (hasRendered && (0, $rxpl9.a)) throw new Error('cx can only be used during render');
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        return $527870009e653bdb$var$merge(cache.registered, css, $527870009e653bdb$var$classnames(args));
    };
    var content = {
        css: css,
        cx: cx,
        theme: $5FkrB.useContext((0, $rxpl9.T))
    };
    var ele = props.children(content);
    hasRendered = true;
    return /*#__PURE__*/ $5FkrB.createElement($5FkrB.Fragment, null, /*#__PURE__*/ $5FkrB.createElement($527870009e653bdb$var$Insertion, {
        cache: cache,
        serializedArr: serializedArr
    }), ele);
});

});
parcelRegister("rxpl9", function(module, exports) {
$parcel$export(module.exports, "a", () => $052c6fce9badda23$export$407448d2b89b1813);
$parcel$export(module.exports, "i", () => $052c6fce9badda23$export$23f2a1d2818174ef);
$parcel$export(module.exports, "w", () => $052c6fce9badda23$export$efccba1c4a2ef57b);
$parcel$export(module.exports, "T", () => $052c6fce9badda23$export$971d5caa766a69d7);
$parcel$export(module.exports, "b", () => $052c6fce9badda23$export$8b22cf2602fb60ce);
$parcel$export(module.exports, "h", () => $052c6fce9badda23$export$dda1d9f60106f0e9);
$parcel$export(module.exports, "c", () => $052c6fce9badda23$export$db3b6bfb95261072);
$parcel$export(module.exports, "E", () => $052c6fce9badda23$export$a9c23c6ac3fc3eca);

var $5FkrB = parcelRequire("5FkrB");

var $bR2Nz = parcelRequire("bR2Nz");

var $d1G9Q = parcelRequire("d1G9Q");

var $1QNjI = parcelRequire("1QNjI");

var $7XQ8u = parcelRequire("7XQ8u");

var $eP8dQ = parcelRequire("eP8dQ");

var $ckRFu = parcelRequire("ckRFu");

var $5qnXH = parcelRequire("5qnXH");
var $052c6fce9badda23$export$407448d2b89b1813 = false;
var $052c6fce9badda23$export$23f2a1d2818174ef = typeof document !== 'undefined';
var $052c6fce9badda23$var$EmotionCacheContext = /* #__PURE__ */ $5FkrB.createContext(// because this module is primarily intended for the browser and node
// but it's also required in react native and similar environments sometimes
// and we could have a special build just for that
// but this is much easier and the native packages
// might use a different theme context in the future anyway
typeof HTMLElement !== 'undefined' ? /* #__PURE__ */ (0, $bR2Nz.default)({
    key: 'css'
}) : null);
var $052c6fce9badda23$export$e7094788287c5e9b = $052c6fce9badda23$var$EmotionCacheContext.Provider;
var $052c6fce9badda23$export$71511d61b312f219 = function useEmotionCache() {
    return (0, $5FkrB.useContext)($052c6fce9badda23$var$EmotionCacheContext);
};
var $052c6fce9badda23$export$efccba1c4a2ef57b = function withEmotionCache(func) {
    return /*#__PURE__*/ (0, $5FkrB.forwardRef)(function(props, ref) {
        // the cache will never be null in the browser
        var cache = (0, $5FkrB.useContext)($052c6fce9badda23$var$EmotionCacheContext);
        return func(props, cache, ref);
    });
};
if (!$052c6fce9badda23$export$23f2a1d2818174ef) $052c6fce9badda23$export$efccba1c4a2ef57b = function withEmotionCache(func) {
    return function(props) {
        var cache = (0, $5FkrB.useContext)($052c6fce9badda23$var$EmotionCacheContext);
        if (cache === null) {
            // yes, we're potentially creating this on every render
            // it doesn't actually matter though since it's only on the server
            // so there will only every be a single render
            // that could change in the future because of suspense and etc. but for now,
            // this works and i don't want to optimise for a future thing that we aren't sure about
            cache = (0, $bR2Nz.default)({
                key: 'css'
            });
            return /*#__PURE__*/ $5FkrB.createElement($052c6fce9badda23$var$EmotionCacheContext.Provider, {
                value: cache
            }, func(props, cache));
        } else return func(props, cache);
    };
};
var $052c6fce9badda23$export$971d5caa766a69d7 = /* #__PURE__ */ $5FkrB.createContext({});
var $052c6fce9badda23$export$3b14a55fb2447963 = function useTheme() {
    return $5FkrB.useContext($052c6fce9badda23$export$971d5caa766a69d7);
};
var $052c6fce9badda23$var$getTheme = function getTheme(outerTheme, theme) {
    if (typeof theme === 'function') {
        var mergedTheme = theme(outerTheme);
        return mergedTheme;
    }
    return (0, $d1G9Q.default)({}, outerTheme, theme);
};
var $052c6fce9badda23$var$createCacheWithTheme = /* #__PURE__ */ (0, $1QNjI.default)(function(outerTheme) {
    return (0, $1QNjI.default)(function(theme) {
        return $052c6fce9badda23$var$getTheme(outerTheme, theme);
    });
});
var $052c6fce9badda23$export$8b22cf2602fb60ce = function ThemeProvider(props) {
    var theme = $5FkrB.useContext($052c6fce9badda23$export$971d5caa766a69d7);
    if (props.theme !== theme) theme = $052c6fce9badda23$var$createCacheWithTheme(theme)(props.theme);
    return /*#__PURE__*/ $5FkrB.createElement($052c6fce9badda23$export$971d5caa766a69d7.Provider, {
        value: theme
    }, props.children);
};
function $052c6fce9badda23$export$4368d992c4eafac0(Component) {
    var componentName = Component.displayName || Component.name || 'Component';
    var WithTheme = /*#__PURE__*/ $5FkrB.forwardRef(function render(props, ref) {
        var theme = $5FkrB.useContext($052c6fce9badda23$export$971d5caa766a69d7);
        return /*#__PURE__*/ $5FkrB.createElement(Component, (0, $d1G9Q.default)({
            theme: theme,
            ref: ref
        }, props));
    });
    WithTheme.displayName = "WithTheme(" + componentName + ")";
    return (0, $7XQ8u.default)(WithTheme, Component);
}
var $052c6fce9badda23$export$dda1d9f60106f0e9 = {}.hasOwnProperty;
var $052c6fce9badda23$var$typePropName = '__EMOTION_TYPE_PLEASE_DO_NOT_USE__';
var $052c6fce9badda23$export$db3b6bfb95261072 = function createEmotionProps(type, props) {
    var newProps = {};
    for(var _key in props)if ($052c6fce9badda23$export$dda1d9f60106f0e9.call(props, _key)) newProps[_key] = props[_key];
    newProps[$052c6fce9badda23$var$typePropName] = type; // Runtime labeling is an opt-in feature because:
    return newProps;
};
var $052c6fce9badda23$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serialized = _ref.serialized, isStringTag = _ref.isStringTag;
    (0, $eP8dQ.registerStyles)(cache, serialized, isStringTag);
    var rules = (0, $5qnXH.useInsertionEffectAlwaysWithSyncFallback)(function() {
        return (0, $eP8dQ.insertStyles)(cache, serialized, isStringTag);
    });
    if (!$052c6fce9badda23$export$23f2a1d2818174ef && rules !== undefined) {
        var _ref2;
        var serializedNames = serialized.name;
        var next = serialized.next;
        while(next !== undefined){
            serializedNames += ' ' + next.name;
            next = next.next;
        }
        return /*#__PURE__*/ $5FkrB.createElement("style", (_ref2 = {}, _ref2["data-emotion"] = cache.key + " " + serializedNames, _ref2.dangerouslySetInnerHTML = {
            __html: rules
        }, _ref2.nonce = cache.sheet.nonce, _ref2));
    }
    return null;
};
var $052c6fce9badda23$var$Emotion = /* #__PURE__ */ $052c6fce9badda23$export$efccba1c4a2ef57b(function(props, cache, ref) {
    var cssProp = props.css; // so that using `css` from `emotion` and passing the result to the css prop works
    // not passing the registered cache to serializeStyles because it would
    // make certain babel optimisations not possible
    if (typeof cssProp === 'string' && cache.registered[cssProp] !== undefined) cssProp = cache.registered[cssProp];
    var WrappedComponent = props[$052c6fce9badda23$var$typePropName];
    var registeredStyles = [
        cssProp
    ];
    var className = '';
    if (typeof props.className === 'string') className = (0, $eP8dQ.getRegisteredStyles)(cache.registered, registeredStyles, props.className);
    else if (props.className != null) className = props.className + " ";
    var serialized = (0, $ckRFu.serializeStyles)(registeredStyles, undefined, $5FkrB.useContext($052c6fce9badda23$export$971d5caa766a69d7));
    className += cache.key + "-" + serialized.name;
    var newProps = {};
    for(var _key2 in props)if ($052c6fce9badda23$export$dda1d9f60106f0e9.call(props, _key2) && _key2 !== 'css' && _key2 !== $052c6fce9badda23$var$typePropName && !$052c6fce9badda23$export$407448d2b89b1813) newProps[_key2] = props[_key2];
    newProps.className = className;
    if (ref) newProps.ref = ref;
    return /*#__PURE__*/ $5FkrB.createElement($5FkrB.Fragment, null, /*#__PURE__*/ $5FkrB.createElement($052c6fce9badda23$var$Insertion, {
        cache: cache,
        serialized: serialized,
        isStringTag: typeof WrappedComponent === 'string'
    }), /*#__PURE__*/ $5FkrB.createElement(WrappedComponent, newProps));
});
var $052c6fce9badda23$export$a9c23c6ac3fc3eca = $052c6fce9badda23$var$Emotion;

});
parcelRegister("bR2Nz", function(module, exports) {
$parcel$export(module.exports, "default", () => $8a16d0b2f64d987f$export$2e2bcd8739ae039);

var $iSXTx = parcelRequire("iSXTx");

var $fPB28 = parcelRequire("fPB28");

var $1QNjI = parcelRequire("1QNjI");

var $7VhhO = parcelRequire("7VhhO");
var $8a16d0b2f64d987f$var$isBrowser = typeof document !== 'undefined';
var $8a16d0b2f64d987f$var$identifierWithPointTracking = function identifierWithPointTracking(begin, points, index) {
    var previous = 0;
    var character = 0;
    while(true){
        previous = character;
        character = (0, $fPB28.peek)(); // &\f
        if (previous === 38 && character === 12) points[index] = 1;
        if ((0, $fPB28.token)(character)) break;
        (0, $fPB28.next)();
    }
    return (0, $fPB28.slice)(begin, (0, $fPB28.position));
};
var $8a16d0b2f64d987f$var$toRules = function toRules(parsed, points) {
    // pretend we've started with a comma
    var index = -1;
    var character = 44;
    do switch((0, $fPB28.token)(character)){
        case 0:
            // &\f
            if (character === 38 && (0, $fPB28.peek)() === 12) // this is not 100% correct, we don't account for literal sequences here - like for example quoted strings
            // stylis inserts \f after & to know when & where it should replace this sequence with the context selector
            // and when it should just concatenate the outer and inner selectors
            // it's very unlikely for this sequence to actually appear in a different context, so we just leverage this fact here
            points[index] = 1;
            parsed[index] += $8a16d0b2f64d987f$var$identifierWithPointTracking((0, $fPB28.position) - 1, points, index);
            break;
        case 2:
            parsed[index] += (0, $fPB28.delimit)(character);
            break;
        case 4:
            // comma
            if (character === 44) {
                // colon
                parsed[++index] = (0, $fPB28.peek)() === 58 ? '&\f' : '';
                points[index] = parsed[index].length;
                break;
            }
        // fallthrough
        default:
            parsed[index] += (0, $fPB28.from)(character);
    }
    while (character = (0, $fPB28.next)());
    return parsed;
};
var $8a16d0b2f64d987f$var$getRules = function getRules(value, points) {
    return (0, $fPB28.dealloc)($8a16d0b2f64d987f$var$toRules((0, $fPB28.alloc)(value), points));
}; // WeakSet would be more appropriate, but only WeakMap is supported in IE11
var $8a16d0b2f64d987f$var$fixedElements = /* #__PURE__ */ new WeakMap();
var $8a16d0b2f64d987f$var$compat = function compat(element) {
    if (element.type !== 'rule' || !element.parent || // positive .length indicates that this rule contains pseudo
    // negative .length indicates that this rule has been already prefixed
    element.length < 1) return;
    var value = element.value;
    var parent = element.parent;
    var isImplicitRule = element.column === parent.column && element.line === parent.line;
    while(parent.type !== 'rule'){
        parent = parent.parent;
        if (!parent) return;
    } // short-circuit for the simplest case
    if (element.props.length === 1 && value.charCodeAt(0) !== 58 && !$8a16d0b2f64d987f$var$fixedElements.get(parent)) return;
     // if this is an implicitly inserted rule (the one eagerly inserted at the each new nested level)
    // then the props has already been manipulated beforehand as they that array is shared between it and its "rule parent"
    if (isImplicitRule) return;
    $8a16d0b2f64d987f$var$fixedElements.set(element, true);
    var points = [];
    var rules = $8a16d0b2f64d987f$var$getRules(value, points);
    var parentRules = parent.props;
    for(var i = 0, k = 0; i < rules.length; i++)for(var j = 0; j < parentRules.length; j++, k++)element.props[k] = points[i] ? rules[i].replace(/&\f/g, parentRules[j]) : parentRules[j] + " " + rules[i];
};
var $8a16d0b2f64d987f$var$removeLabel = function removeLabel(element) {
    if (element.type === 'decl') {
        var value = element.value;
        if (value.charCodeAt(0) === 108 && // charcode for b
        value.charCodeAt(2) === 98) {
            // this ignores label
            element["return"] = '';
            element.value = '';
        }
    }
};
/* eslint-disable no-fallthrough */ function $8a16d0b2f64d987f$var$prefix(value, length) {
    switch((0, $fPB28.hash)(value, length)){
        // color-adjust
        case 5103:
            return (0, $fPB28.WEBKIT) + 'print-' + value + value;
        // animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return (0, $fPB28.WEBKIT) + value + value;
        // appearance, user-select, transform, hyphens, text-size-adjust
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return (0, $fPB28.WEBKIT) + value + (0, $fPB28.MOZ) + value + (0, $fPB28.MS) + value + value;
        // flex, flex-direction
        case 6828:
        case 4268:
            return (0, $fPB28.WEBKIT) + value + (0, $fPB28.MS) + value + value;
        // order
        case 6165:
            return (0, $fPB28.WEBKIT) + value + (0, $fPB28.MS) + 'flex-' + value + value;
        // align-items
        case 5187:
            return (0, $fPB28.WEBKIT) + value + (0, $fPB28.replace)(value, /(\w+).+(:[^]+)/, (0, $fPB28.WEBKIT) + 'box-$1$2' + (0, $fPB28.MS) + 'flex-$1$2') + value;
        // align-self
        case 5443:
            return (0, $fPB28.WEBKIT) + value + (0, $fPB28.MS) + 'flex-item-' + (0, $fPB28.replace)(value, /flex-|-self/, '') + value;
        // align-content
        case 4675:
            return (0, $fPB28.WEBKIT) + value + (0, $fPB28.MS) + 'flex-line-pack' + (0, $fPB28.replace)(value, /align-content|flex-|-self/, '') + value;
        // flex-shrink
        case 5548:
            return (0, $fPB28.WEBKIT) + value + (0, $fPB28.MS) + (0, $fPB28.replace)(value, 'shrink', 'negative') + value;
        // flex-basis
        case 5292:
            return (0, $fPB28.WEBKIT) + value + (0, $fPB28.MS) + (0, $fPB28.replace)(value, 'basis', 'preferred-size') + value;
        // flex-grow
        case 6060:
            return (0, $fPB28.WEBKIT) + 'box-' + (0, $fPB28.replace)(value, '-grow', '') + (0, $fPB28.WEBKIT) + value + (0, $fPB28.MS) + (0, $fPB28.replace)(value, 'grow', 'positive') + value;
        // transition
        case 4554:
            return (0, $fPB28.WEBKIT) + (0, $fPB28.replace)(value, /([^-])(transform)/g, '$1' + (0, $fPB28.WEBKIT) + '$2') + value;
        // cursor
        case 6187:
            return (0, $fPB28.replace)((0, $fPB28.replace)((0, $fPB28.replace)(value, /(zoom-|grab)/, (0, $fPB28.WEBKIT) + '$1'), /(image-set)/, (0, $fPB28.WEBKIT) + '$1'), value, '') + value;
        // background, background-image
        case 5495:
        case 3959:
            return (0, $fPB28.replace)(value, /(image-set\([^]*)/, (0, $fPB28.WEBKIT) + '$1' + '$`$1');
        // justify-content
        case 4968:
            return (0, $fPB28.replace)((0, $fPB28.replace)(value, /(.+:)(flex-)?(.*)/, (0, $fPB28.WEBKIT) + 'box-pack:$3' + (0, $fPB28.MS) + 'flex-pack:$3'), /s.+-b[^;]+/, 'justify') + (0, $fPB28.WEBKIT) + value + value;
        // (margin|padding)-inline-(start|end)
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return (0, $fPB28.replace)(value, /(.+)-inline(.+)/, (0, $fPB28.WEBKIT) + '$1$2') + value;
        // (min|max)?(width|height|inline-size|block-size)
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            // stretch, max-content, min-content, fill-available
            if ((0, $fPB28.strlen)(value) - 1 - length > 6) switch((0, $fPB28.charat)(value, length + 1)){
                // (m)ax-content, (m)in-content
                case 109:
                    // -
                    if ((0, $fPB28.charat)(value, length + 4) !== 45) break;
                // (f)ill-available, (f)it-content
                case 102:
                    return (0, $fPB28.replace)(value, /(.+:)(.+)-([^]+)/, '$1' + (0, $fPB28.WEBKIT) + '$2-$3' + '$1' + (0, $fPB28.MOZ) + ((0, $fPB28.charat)(value, length + 3) == 108 ? '$3' : '$2-$3')) + value;
                // (s)tretch
                case 115:
                    return ~(0, $fPB28.indexof)(value, 'stretch') ? $8a16d0b2f64d987f$var$prefix((0, $fPB28.replace)(value, 'stretch', 'fill-available'), length) + value : value;
            }
            break;
        // position: sticky
        case 4949:
            // (s)ticky?
            if ((0, $fPB28.charat)(value, length + 1) !== 115) break;
        // display: (flex|inline-flex)
        case 6444:
            switch((0, $fPB28.charat)(value, (0, $fPB28.strlen)(value) - 3 - (~(0, $fPB28.indexof)(value, '!important') && 10))){
                // stic(k)y
                case 107:
                    return (0, $fPB28.replace)(value, ':', ':' + (0, $fPB28.WEBKIT)) + value;
                // (inline-)?fl(e)x
                case 101:
                    return (0, $fPB28.replace)(value, /(.+:)([^;!]+)(;|!.+)?/, '$1' + (0, $fPB28.WEBKIT) + ((0, $fPB28.charat)(value, 14) === 45 ? 'inline-' : '') + 'box$3' + '$1' + (0, $fPB28.WEBKIT) + '$2$3' + '$1' + (0, $fPB28.MS) + '$2box$3') + value;
            }
            break;
        // writing-mode
        case 5936:
            switch((0, $fPB28.charat)(value, length + 11)){
                // vertical-l(r)
                case 114:
                    return (0, $fPB28.WEBKIT) + value + (0, $fPB28.MS) + (0, $fPB28.replace)(value, /[svh]\w+-[tblr]{2}/, 'tb') + value;
                // vertical-r(l)
                case 108:
                    return (0, $fPB28.WEBKIT) + value + (0, $fPB28.MS) + (0, $fPB28.replace)(value, /[svh]\w+-[tblr]{2}/, 'tb-rl') + value;
                // horizontal(-)tb
                case 45:
                    return (0, $fPB28.WEBKIT) + value + (0, $fPB28.MS) + (0, $fPB28.replace)(value, /[svh]\w+-[tblr]{2}/, 'lr') + value;
            }
            return (0, $fPB28.WEBKIT) + value + (0, $fPB28.MS) + value + value;
    }
    return value;
}
var $8a16d0b2f64d987f$var$prefixer = function prefixer(element, index, children, callback) {
    if (element.length > -1) {
        if (!element["return"]) switch(element.type){
            case 0, $fPB28.DECLARATION:
                element["return"] = $8a16d0b2f64d987f$var$prefix(element.value, element.length);
                break;
            case 0, $fPB28.KEYFRAMES:
                return (0, $fPB28.serialize)([
                    (0, $fPB28.copy)(element, {
                        value: (0, $fPB28.replace)(element.value, '@', '@' + (0, $fPB28.WEBKIT))
                    })
                ], callback);
            case 0, $fPB28.RULESET:
                if (element.length) return (0, $fPB28.combine)(element.props, function(value) {
                    switch((0, $fPB28.match)(value, /(::plac\w+|:read-\w+)/)){
                        // :read-(only|write)
                        case ':read-only':
                        case ':read-write':
                            return (0, $fPB28.serialize)([
                                (0, $fPB28.copy)(element, {
                                    props: [
                                        (0, $fPB28.replace)(value, /:(read-\w+)/, ':' + (0, $fPB28.MOZ) + '$1')
                                    ]
                                })
                            ], callback);
                        // :placeholder
                        case '::placeholder':
                            return (0, $fPB28.serialize)([
                                (0, $fPB28.copy)(element, {
                                    props: [
                                        (0, $fPB28.replace)(value, /:(plac\w+)/, ':' + (0, $fPB28.WEBKIT) + 'input-$1')
                                    ]
                                }),
                                (0, $fPB28.copy)(element, {
                                    props: [
                                        (0, $fPB28.replace)(value, /:(plac\w+)/, ':' + (0, $fPB28.MOZ) + '$1')
                                    ]
                                }),
                                (0, $fPB28.copy)(element, {
                                    props: [
                                        (0, $fPB28.replace)(value, /:(plac\w+)/, (0, $fPB28.MS) + 'input-$1')
                                    ]
                                })
                            ], callback);
                    }
                    return '';
                });
        }
    }
};
var $8a16d0b2f64d987f$var$getServerStylisCache = $8a16d0b2f64d987f$var$isBrowser ? undefined : (0, $1QNjI.default)(function() {
    return (0, $7VhhO.default)(function() {
        return {};
    });
});
var $8a16d0b2f64d987f$var$defaultStylisPlugins = [
    $8a16d0b2f64d987f$var$prefixer
];
var $8a16d0b2f64d987f$export$2e2bcd8739ae039 = function createCache(options) {
    var key = options.key;
    if ($8a16d0b2f64d987f$var$isBrowser && key === 'css') {
        var ssrStyles = document.querySelectorAll("style[data-emotion]:not([data-s])"); // get SSRed styles out of the way of React's hydration
        // document.head is a safe place to move them to(though note document.head is not necessarily the last place they will be)
        // note this very very intentionally targets all style elements regardless of the key to ensure
        // that creating a cache works inside of render of a React component
        Array.prototype.forEach.call(ssrStyles, function(node) {
            // we want to only move elements which have a space in the data-emotion attribute value
            // because that indicates that it is an Emotion 11 server-side rendered style elements
            // while we will already ignore Emotion 11 client-side inserted styles because of the :not([data-s]) part in the selector
            // Emotion 10 client-side inserted styles did not have data-s (but importantly did not have a space in their data-emotion attributes)
            // so checking for the space ensures that loading Emotion 11 after Emotion 10 has inserted some styles
            // will not result in the Emotion 10 styles being destroyed
            var dataEmotionAttribute = node.getAttribute('data-emotion');
            if (dataEmotionAttribute.indexOf(' ') === -1) return;
            document.head.appendChild(node);
            node.setAttribute('data-s', '');
        });
    }
    var stylisPlugins = options.stylisPlugins || $8a16d0b2f64d987f$var$defaultStylisPlugins;
    var inserted = {};
    var container;
    var nodesToHydrate = [];
    if ($8a16d0b2f64d987f$var$isBrowser) {
        container = options.container || document.head;
        Array.prototype.forEach.call(// means that the style elements we're looking at are only Emotion 11 server-rendered style elements
        document.querySelectorAll("style[data-emotion^=\"" + key + " \"]"), function(node) {
            var attrib = node.getAttribute("data-emotion").split(' ');
            for(var i = 1; i < attrib.length; i++)inserted[attrib[i]] = true;
            nodesToHydrate.push(node);
        });
    }
    var _insert;
    var omnipresentPlugins = [
        $8a16d0b2f64d987f$var$compat,
        $8a16d0b2f64d987f$var$removeLabel
    ];
    if (!$8a16d0b2f64d987f$var$getServerStylisCache) {
        var currentSheet;
        var finalizingPlugins = [
            (0, $fPB28.stringify),
            (0, $fPB28.rulesheet)(function(rule) {
                currentSheet.insert(rule);
            })
        ];
        var serializer = (0, $fPB28.middleware)(omnipresentPlugins.concat(stylisPlugins, finalizingPlugins));
        var stylis = function stylis(styles) {
            return (0, $fPB28.serialize)((0, $fPB28.compile)(styles), serializer);
        };
        _insert = function insert(selector, serialized, sheet, shouldCache) {
            currentSheet = sheet;
            stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);
            if (shouldCache) cache.inserted[serialized.name] = true;
        };
    } else {
        var _finalizingPlugins = [
            (0, $fPB28.stringify)
        ];
        var _serializer = (0, $fPB28.middleware)(omnipresentPlugins.concat(stylisPlugins, _finalizingPlugins));
        var _stylis = function _stylis(styles) {
            return (0, $fPB28.serialize)((0, $fPB28.compile)(styles), _serializer);
        };
        var serverStylisCache = $8a16d0b2f64d987f$var$getServerStylisCache(stylisPlugins)(key);
        var getRules = function getRules(selector, serialized) {
            var name = serialized.name;
            if (serverStylisCache[name] === undefined) serverStylisCache[name] = _stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);
            return serverStylisCache[name];
        };
        _insert = function _insert(selector, serialized, sheet, shouldCache) {
            var name = serialized.name;
            var rules = getRules(selector, serialized);
            if (cache.compat === undefined) {
                // in regular mode, we don't set the styles on the inserted cache
                // since we don't need to and that would be wasting memory
                // we return them so that they are rendered in a style tag
                if (shouldCache) cache.inserted[name] = true;
                return rules;
            } else {
                // in compat mode, we put the styles on the inserted cache so
                // that emotion-server can pull out the styles
                // except when we don't want to cache it which was in Global but now
                // is nowhere but we don't want to do a major right now
                // and just in case we're going to leave the case here
                // it's also not affecting client side bundle size
                // so it's really not a big deal
                if (shouldCache) cache.inserted[name] = rules;
                else return rules;
            }
        };
    }
    var cache = {
        key: key,
        sheet: new (0, $iSXTx.StyleSheet)({
            key: key,
            container: container,
            nonce: options.nonce,
            speedy: options.speedy,
            prepend: options.prepend,
            insertionPoint: options.insertionPoint
        }),
        nonce: options.nonce,
        inserted: inserted,
        registered: {},
        insert: _insert
    };
    cache.sheet.hydrate(nodesToHydrate);
    return cache;
};

});
parcelRegister("iSXTx", function(module, exports) {
$parcel$export(module.exports, "StyleSheet", () => $dbfbbb00930f8e37$export$9d753cd7ae895cce);
var $dbfbbb00930f8e37$var$isDevelopment = false;
/*

Based off glamor's StyleSheet, thanks Sunil ❤️

high performance StyleSheet for css-in-js systems

- uses multiple style tags behind the scenes for millions of rules
- uses `insertRule` for appending in production for *much* faster performance

// usage

import { StyleSheet } from '@emotion/sheet'

let styleSheet = new StyleSheet({ key: '', container: document.head })

styleSheet.insert('#box { border: 1px solid red; }')
- appends a css rule into the stylesheet

styleSheet.flush()
- empties the stylesheet of all its contents

*/ function $dbfbbb00930f8e37$var$sheetForTag(tag) {
    if (tag.sheet) return tag.sheet;
     // this weirdness brought to you by firefox
    /* istanbul ignore next */ for(var i = 0; i < document.styleSheets.length; i++){
        if (document.styleSheets[i].ownerNode === tag) return document.styleSheets[i];
    } // this function should always return with a value
    // TS can't understand it though so we make it stop complaining here
    return undefined;
}
function $dbfbbb00930f8e37$var$createStyleElement(options) {
    var tag = document.createElement('style');
    tag.setAttribute('data-emotion', options.key);
    if (options.nonce !== undefined) tag.setAttribute('nonce', options.nonce);
    tag.appendChild(document.createTextNode(''));
    tag.setAttribute('data-s', '');
    return tag;
}
var $dbfbbb00930f8e37$export$9d753cd7ae895cce = /*#__PURE__*/ function() {
    // Using Node instead of HTMLElement since container may be a ShadowRoot
    function StyleSheet(options) {
        var _this = this;
        this._insertTag = function(tag) {
            var before;
            if (_this.tags.length === 0) {
                if (_this.insertionPoint) before = _this.insertionPoint.nextSibling;
                else if (_this.prepend) before = _this.container.firstChild;
                else before = _this.before;
            } else before = _this.tags[_this.tags.length - 1].nextSibling;
            _this.container.insertBefore(tag, before);
            _this.tags.push(tag);
        };
        this.isSpeedy = options.speedy === undefined ? !$dbfbbb00930f8e37$var$isDevelopment : options.speedy;
        this.tags = [];
        this.ctr = 0;
        this.nonce = options.nonce; // key is the value of the data-emotion attribute, it's used to identify different sheets
        this.key = options.key;
        this.container = options.container;
        this.prepend = options.prepend;
        this.insertionPoint = options.insertionPoint;
        this.before = null;
    }
    var _proto = StyleSheet.prototype;
    _proto.hydrate = function hydrate(nodes) {
        nodes.forEach(this._insertTag);
    };
    _proto.insert = function insert(rule) {
        // the max length is how many rules we have per style tag, it's 65000 in speedy mode
        // it's 1 in dev because we insert source maps that map a single rule to a location
        // and you can only have one source map per style tag
        if (this.ctr % (this.isSpeedy ? 65000 : 1) === 0) this._insertTag($dbfbbb00930f8e37$var$createStyleElement(this));
        var tag = this.tags[this.tags.length - 1];
        if (this.isSpeedy) {
            var sheet = $dbfbbb00930f8e37$var$sheetForTag(tag);
            try {
                // this is the ultrafast version, works across browsers
                // the big drawback is that the css won't be editable in devtools
                sheet.insertRule(rule, sheet.cssRules.length);
            } catch (e) {}
        } else tag.appendChild(document.createTextNode(rule));
        this.ctr++;
    };
    _proto.flush = function flush() {
        this.tags.forEach(function(tag) {
            var _tag$parentNode;
            return (_tag$parentNode = tag.parentNode) == null ? void 0 : _tag$parentNode.removeChild(tag);
        });
        this.tags = [];
        this.ctr = 0;
    };
    return StyleSheet;
}();

});

parcelRegister("fPB28", function(module, exports) {
$parcel$export(module.exports, "MS", () => $b868588574af2763$export$71ad59f2e432cfe8);
$parcel$export(module.exports, "MOZ", () => $b868588574af2763$export$2c0f367103c8d01c);
$parcel$export(module.exports, "WEBKIT", () => $b868588574af2763$export$39dfd62a25e0fe93);
$parcel$export(module.exports, "RULESET", () => $b868588574af2763$export$aa3a2e812ca8570d);
$parcel$export(module.exports, "DECLARATION", () => $b868588574af2763$export$527d108ccf083c2b);
$parcel$export(module.exports, "KEYFRAMES", () => $b868588574af2763$export$b44a8529a35fcb60);
$parcel$export(module.exports, "from", () => $b868588574af2763$export$6788812c4e6611e6);
$parcel$export(module.exports, "hash", () => $b868588574af2763$export$d6af199866bfb566);
$parcel$export(module.exports, "charat", () => $b868588574af2763$export$a9db5e087081082d);
$parcel$export(module.exports, "match", () => $b868588574af2763$export$4659b591c19bdf3d);
$parcel$export(module.exports, "replace", () => $b868588574af2763$export$77ad94ebf1c2b9ed);
$parcel$export(module.exports, "indexof", () => $b868588574af2763$export$f8e21b1e77979a08);
$parcel$export(module.exports, "strlen", () => $b868588574af2763$export$36776f635604f274);
$parcel$export(module.exports, "combine", () => $b868588574af2763$export$1be1fc439b849fdf);
$parcel$export(module.exports, "position", () => $b868588574af2763$export$5880b8b5730aff45);
$parcel$export(module.exports, "copy", () => $b868588574af2763$export$784d13d8ee351f07);
$parcel$export(module.exports, "next", () => $b868588574af2763$export$48cfd1e771a65c4f);
$parcel$export(module.exports, "peek", () => $b868588574af2763$export$4d3fb11e950abb9e);
$parcel$export(module.exports, "slice", () => $b868588574af2763$export$58adb3bec8346d0f);
$parcel$export(module.exports, "token", () => $b868588574af2763$export$9e1725a4cfeada27);
$parcel$export(module.exports, "alloc", () => $b868588574af2763$export$2de70f21292aac9e);
$parcel$export(module.exports, "dealloc", () => $b868588574af2763$export$45918ac1574455b1);
$parcel$export(module.exports, "delimit", () => $b868588574af2763$export$410ac95b9ec204b8);
$parcel$export(module.exports, "compile", () => $b868588574af2763$export$ef7acd7185315e22);
$parcel$export(module.exports, "serialize", () => $b868588574af2763$export$dfdc1655ccc5b9cb);
$parcel$export(module.exports, "stringify", () => $b868588574af2763$export$fac44ee5b035f737);
$parcel$export(module.exports, "middleware", () => $b868588574af2763$export$5a7767152ae0305f);
$parcel$export(module.exports, "rulesheet", () => $b868588574af2763$export$38bcb760f1d4871c);
var $b868588574af2763$export$71ad59f2e432cfe8 = "-ms-";
var $b868588574af2763$export$2c0f367103c8d01c = "-moz-";
var $b868588574af2763$export$39dfd62a25e0fe93 = "-webkit-";
var $b868588574af2763$export$a29989082612d0d9 = "comm";
var $b868588574af2763$export$aa3a2e812ca8570d = "rule";
var $b868588574af2763$export$527d108ccf083c2b = "decl";
var $b868588574af2763$export$d3d35020fa5b54f0 = "@page";
var $b868588574af2763$export$500415a86c544f73 = "@media";
var $b868588574af2763$export$a763edbf796b780a = "@import";
var $b868588574af2763$export$2790aeb8b4e5c826 = "@charset";
var $b868588574af2763$export$1cc683e23b84b133 = "@viewport";
var $b868588574af2763$export$9447a5efea57e862 = "@supports";
var $b868588574af2763$export$ef011b4e114b1fba = "@document";
var $b868588574af2763$export$6aad947bda0f3f46 = "@namespace";
var $b868588574af2763$export$b44a8529a35fcb60 = "@keyframes";
var $b868588574af2763$export$2c16de31893252e6 = "@font-face";
var $b868588574af2763$export$3d846dd52e150c6f = "@counter-style";
var $b868588574af2763$export$22314bfbb57653fe = "@font-feature-values";
var $b868588574af2763$export$d773506282b3cfe6 = "@layer";
var $b868588574af2763$export$2335f513bbd82c6d = Math.abs;
var $b868588574af2763$export$6788812c4e6611e6 = String.fromCharCode;
var $b868588574af2763$export$e6e34fd1f2686227 = Object.assign;
function $b868588574af2763$export$d6af199866bfb566(e, r) {
    return $b868588574af2763$export$a9db5e087081082d(e, 0) ^ 45 ? (((r << 2 ^ $b868588574af2763$export$a9db5e087081082d(e, 0)) << 2 ^ $b868588574af2763$export$a9db5e087081082d(e, 1)) << 2 ^ $b868588574af2763$export$a9db5e087081082d(e, 2)) << 2 ^ $b868588574af2763$export$a9db5e087081082d(e, 3) : 0;
}
function $b868588574af2763$export$87c2784dc9fc4ab(e) {
    return e.trim();
}
function $b868588574af2763$export$4659b591c19bdf3d(e, r) {
    return (e = r.exec(e)) ? e[0] : e;
}
function $b868588574af2763$export$77ad94ebf1c2b9ed(e, r, a) {
    return e.replace(r, a);
}
function $b868588574af2763$export$f8e21b1e77979a08(e, r) {
    return e.indexOf(r);
}
function $b868588574af2763$export$a9db5e087081082d(e, r) {
    return e.charCodeAt(r) | 0;
}
function $b868588574af2763$export$2f35ab04d2335697(e, r, a) {
    return e.slice(r, a);
}
function $b868588574af2763$export$36776f635604f274(e) {
    return e.length;
}
function $b868588574af2763$export$f9084667e487ed46(e) {
    return e.length;
}
function $b868588574af2763$export$10d8903dec122b9d(e, r) {
    return r.push(e), e;
}
function $b868588574af2763$export$1be1fc439b849fdf(e, r) {
    return e.map(r).join("");
}
var $b868588574af2763$export$53f1d5ea8de3d7c = 1;
var $b868588574af2763$export$4e0c71f277ca26b3 = 1;
var $b868588574af2763$export$f24224f1c91d8156 = 0;
var $b868588574af2763$export$5880b8b5730aff45 = 0;
var $b868588574af2763$export$c0306caf338ac095 = 0;
var $b868588574af2763$export$30a86d91af8ff6e6 = "";
function $b868588574af2763$export$35059013cd4a06db(e, r, a, n, c, s, t) {
    return {
        value: e,
        root: r,
        parent: a,
        type: n,
        props: c,
        children: s,
        line: $b868588574af2763$export$53f1d5ea8de3d7c,
        column: $b868588574af2763$export$4e0c71f277ca26b3,
        length: t,
        return: ""
    };
}
function $b868588574af2763$export$784d13d8ee351f07(e, r) {
    return $b868588574af2763$export$e6e34fd1f2686227($b868588574af2763$export$35059013cd4a06db("", null, null, "", null, null, 0), e, {
        length: -e.length
    }, r);
}
function $b868588574af2763$export$eba6f6f03b0a92e7() {
    return $b868588574af2763$export$c0306caf338ac095;
}
function $b868588574af2763$export$232faf9add678146() {
    $b868588574af2763$export$c0306caf338ac095 = $b868588574af2763$export$5880b8b5730aff45 > 0 ? $b868588574af2763$export$a9db5e087081082d($b868588574af2763$export$30a86d91af8ff6e6, --$b868588574af2763$export$5880b8b5730aff45) : 0;
    if ($b868588574af2763$export$4e0c71f277ca26b3--, $b868588574af2763$export$c0306caf338ac095 === 10) $b868588574af2763$export$4e0c71f277ca26b3 = 1, $b868588574af2763$export$53f1d5ea8de3d7c--;
    return $b868588574af2763$export$c0306caf338ac095;
}
function $b868588574af2763$export$48cfd1e771a65c4f() {
    $b868588574af2763$export$c0306caf338ac095 = $b868588574af2763$export$5880b8b5730aff45 < $b868588574af2763$export$f24224f1c91d8156 ? $b868588574af2763$export$a9db5e087081082d($b868588574af2763$export$30a86d91af8ff6e6, $b868588574af2763$export$5880b8b5730aff45++) : 0;
    if ($b868588574af2763$export$4e0c71f277ca26b3++, $b868588574af2763$export$c0306caf338ac095 === 10) $b868588574af2763$export$4e0c71f277ca26b3 = 1, $b868588574af2763$export$53f1d5ea8de3d7c++;
    return $b868588574af2763$export$c0306caf338ac095;
}
function $b868588574af2763$export$4d3fb11e950abb9e() {
    return $b868588574af2763$export$a9db5e087081082d($b868588574af2763$export$30a86d91af8ff6e6, $b868588574af2763$export$5880b8b5730aff45);
}
function $b868588574af2763$export$e88cb2efb12ae807() {
    return $b868588574af2763$export$5880b8b5730aff45;
}
function $b868588574af2763$export$58adb3bec8346d0f(e, r) {
    return $b868588574af2763$export$2f35ab04d2335697($b868588574af2763$export$30a86d91af8ff6e6, e, r);
}
function $b868588574af2763$export$9e1725a4cfeada27(e) {
    switch(e){
        case 0:
        case 9:
        case 10:
        case 13:
        case 32:
            return 5;
        case 33:
        case 43:
        case 44:
        case 47:
        case 62:
        case 64:
        case 126:
        case 59:
        case 123:
        case 125:
            return 4;
        case 58:
            return 3;
        case 34:
        case 39:
        case 40:
        case 91:
            return 2;
        case 41:
        case 93:
            return 1;
    }
    return 0;
}
function $b868588574af2763$export$2de70f21292aac9e(e) {
    return $b868588574af2763$export$53f1d5ea8de3d7c = $b868588574af2763$export$4e0c71f277ca26b3 = 1, $b868588574af2763$export$f24224f1c91d8156 = $b868588574af2763$export$36776f635604f274($b868588574af2763$export$30a86d91af8ff6e6 = e), $b868588574af2763$export$5880b8b5730aff45 = 0, [];
}
function $b868588574af2763$export$45918ac1574455b1(e) {
    return $b868588574af2763$export$30a86d91af8ff6e6 = "", e;
}
function $b868588574af2763$export$410ac95b9ec204b8(e) {
    return $b868588574af2763$export$87c2784dc9fc4ab($b868588574af2763$export$58adb3bec8346d0f($b868588574af2763$export$5880b8b5730aff45 - 1, $b868588574af2763$export$c889f2fcc19dbf12(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function $b868588574af2763$export$660b2ee2d4fb4eff(e) {
    return $b868588574af2763$export$45918ac1574455b1($b868588574af2763$export$5f8c09e3ae6f64e1($b868588574af2763$export$2de70f21292aac9e(e)));
}
function $b868588574af2763$export$7af1228ff777d175(e) {
    while($b868588574af2763$export$c0306caf338ac095 = $b868588574af2763$export$4d3fb11e950abb9e())if ($b868588574af2763$export$c0306caf338ac095 < 33) $b868588574af2763$export$48cfd1e771a65c4f();
    else break;
    return $b868588574af2763$export$9e1725a4cfeada27(e) > 2 || $b868588574af2763$export$9e1725a4cfeada27($b868588574af2763$export$c0306caf338ac095) > 3 ? "" : " ";
}
function $b868588574af2763$export$5f8c09e3ae6f64e1(e) {
    while($b868588574af2763$export$48cfd1e771a65c4f())switch($b868588574af2763$export$9e1725a4cfeada27($b868588574af2763$export$c0306caf338ac095)){
        case 0:
            $b868588574af2763$export$10d8903dec122b9d($b868588574af2763$export$c2ab62c7bf24634($b868588574af2763$export$5880b8b5730aff45 - 1), e);
            break;
        case 2:
            $b868588574af2763$export$10d8903dec122b9d($b868588574af2763$export$410ac95b9ec204b8($b868588574af2763$export$c0306caf338ac095), e);
            break;
        default:
            $b868588574af2763$export$10d8903dec122b9d($b868588574af2763$export$6788812c4e6611e6($b868588574af2763$export$c0306caf338ac095), e);
    }
    return e;
}
function $b868588574af2763$export$955ba06d119e085e(e, r) {
    while(--r && $b868588574af2763$export$48cfd1e771a65c4f())if ($b868588574af2763$export$c0306caf338ac095 < 48 || $b868588574af2763$export$c0306caf338ac095 > 102 || $b868588574af2763$export$c0306caf338ac095 > 57 && $b868588574af2763$export$c0306caf338ac095 < 65 || $b868588574af2763$export$c0306caf338ac095 > 70 && $b868588574af2763$export$c0306caf338ac095 < 97) break;
    return $b868588574af2763$export$58adb3bec8346d0f(e, $b868588574af2763$export$e88cb2efb12ae807() + (r < 6 && $b868588574af2763$export$4d3fb11e950abb9e() == 32 && $b868588574af2763$export$48cfd1e771a65c4f() == 32));
}
function $b868588574af2763$export$c889f2fcc19dbf12(e) {
    while($b868588574af2763$export$48cfd1e771a65c4f())switch($b868588574af2763$export$c0306caf338ac095){
        case e:
            return $b868588574af2763$export$5880b8b5730aff45;
        case 34:
        case 39:
            if (e !== 34 && e !== 39) $b868588574af2763$export$c889f2fcc19dbf12($b868588574af2763$export$c0306caf338ac095);
            break;
        case 40:
            if (e === 41) $b868588574af2763$export$c889f2fcc19dbf12(e);
            break;
        case 92:
            $b868588574af2763$export$48cfd1e771a65c4f();
            break;
    }
    return $b868588574af2763$export$5880b8b5730aff45;
}
function $b868588574af2763$export$4254d4e2b3745c4c(e, r) {
    while($b868588574af2763$export$48cfd1e771a65c4f())if (e + $b868588574af2763$export$c0306caf338ac095 === 57) break;
    else if (e + $b868588574af2763$export$c0306caf338ac095 === 84 && $b868588574af2763$export$4d3fb11e950abb9e() === 47) break;
    return "/*" + $b868588574af2763$export$58adb3bec8346d0f(r, $b868588574af2763$export$5880b8b5730aff45 - 1) + "*" + $b868588574af2763$export$6788812c4e6611e6(e === 47 ? e : $b868588574af2763$export$48cfd1e771a65c4f());
}
function $b868588574af2763$export$c2ab62c7bf24634(e) {
    while(!$b868588574af2763$export$9e1725a4cfeada27($b868588574af2763$export$4d3fb11e950abb9e()))$b868588574af2763$export$48cfd1e771a65c4f();
    return $b868588574af2763$export$58adb3bec8346d0f(e, $b868588574af2763$export$5880b8b5730aff45);
}
function $b868588574af2763$export$ef7acd7185315e22(e) {
    return $b868588574af2763$export$45918ac1574455b1($b868588574af2763$export$98e6a39c04603d36("", null, null, null, [
        ""
    ], e = $b868588574af2763$export$2de70f21292aac9e(e), 0, [
        0
    ], e));
}
function $b868588574af2763$export$98e6a39c04603d36(e, r, a, n, c, s, t, u, i) {
    var f = 0;
    var o = 0;
    var l = t;
    var v = 0;
    var p = 0;
    var h = 0;
    var b = 1;
    var w = 1;
    var d = 1;
    var $ = 0;
    var g = "";
    var m = c;
    var x = s;
    var y = n;
    var j = g;
    while(w)switch(h = $, $ = $b868588574af2763$export$48cfd1e771a65c4f()){
        case 40:
            if (h != 108 && $b868588574af2763$export$a9db5e087081082d(j, l - 1) == 58) {
                if ($b868588574af2763$export$f8e21b1e77979a08(j += $b868588574af2763$export$77ad94ebf1c2b9ed($b868588574af2763$export$410ac95b9ec204b8($), "&", "&\f"), "&\f") != -1) d = -1;
                break;
            }
        case 34:
        case 39:
        case 91:
            j += $b868588574af2763$export$410ac95b9ec204b8($);
            break;
        case 9:
        case 10:
        case 13:
        case 32:
            j += $b868588574af2763$export$7af1228ff777d175(h);
            break;
        case 92:
            j += $b868588574af2763$export$955ba06d119e085e($b868588574af2763$export$e88cb2efb12ae807() - 1, 7);
            continue;
        case 47:
            switch($b868588574af2763$export$4d3fb11e950abb9e()){
                case 42:
                case 47:
                    $b868588574af2763$export$10d8903dec122b9d($b868588574af2763$export$4a34f930e789283c($b868588574af2763$export$4254d4e2b3745c4c($b868588574af2763$export$48cfd1e771a65c4f(), $b868588574af2763$export$e88cb2efb12ae807()), r, a), i);
                    break;
                default:
                    j += "/";
            }
            break;
        case 123 * b:
            u[f++] = $b868588574af2763$export$36776f635604f274(j) * d;
        case 125 * b:
        case 59:
        case 0:
            switch($){
                case 0:
                case 125:
                    w = 0;
                case 59 + o:
                    if (d == -1) j = $b868588574af2763$export$77ad94ebf1c2b9ed(j, /\f/g, "");
                    if (p > 0 && $b868588574af2763$export$36776f635604f274(j) - l) $b868588574af2763$export$10d8903dec122b9d(p > 32 ? $b868588574af2763$export$f8483753829ec8f3(j + ";", n, a, l - 1) : $b868588574af2763$export$f8483753829ec8f3($b868588574af2763$export$77ad94ebf1c2b9ed(j, " ", "") + ";", n, a, l - 2), i);
                    break;
                case 59:
                    j += ";";
                default:
                    $b868588574af2763$export$10d8903dec122b9d(y = $b868588574af2763$export$3307ffa7023ede1e(j, r, a, f, o, c, u, g, m = [], x = [], l), s);
                    if ($ === 123) {
                        if (o === 0) $b868588574af2763$export$98e6a39c04603d36(j, r, y, y, m, s, l, u, x);
                        else switch(v === 99 && $b868588574af2763$export$a9db5e087081082d(j, 3) === 110 ? 100 : v){
                            case 100:
                            case 108:
                            case 109:
                            case 115:
                                $b868588574af2763$export$98e6a39c04603d36(e, y, y, n && $b868588574af2763$export$10d8903dec122b9d($b868588574af2763$export$3307ffa7023ede1e(e, y, y, 0, 0, c, u, g, c, m = [], l), x), c, x, l, u, n ? m : x);
                                break;
                            default:
                                $b868588574af2763$export$98e6a39c04603d36(j, y, y, y, [
                                    ""
                                ], x, 0, u, x);
                        }
                    }
            }
            f = o = p = 0, b = d = 1, g = j = "", l = t;
            break;
        case 58:
            l = 1 + $b868588574af2763$export$36776f635604f274(j), p = h;
        default:
            if (b < 1) {
                if ($ == 123) --b;
                else if ($ == 125 && b++ == 0 && $b868588574af2763$export$232faf9add678146() == 125) continue;
            }
            switch(j += $b868588574af2763$export$6788812c4e6611e6($), $ * b){
                case 38:
                    d = o > 0 ? 1 : (j += "\f", -1);
                    break;
                case 44:
                    u[f++] = ($b868588574af2763$export$36776f635604f274(j) - 1) * d, d = 1;
                    break;
                case 64:
                    if ($b868588574af2763$export$4d3fb11e950abb9e() === 45) j += $b868588574af2763$export$410ac95b9ec204b8($b868588574af2763$export$48cfd1e771a65c4f());
                    v = $b868588574af2763$export$4d3fb11e950abb9e(), o = l = $b868588574af2763$export$36776f635604f274(g = j += $b868588574af2763$export$c2ab62c7bf24634($b868588574af2763$export$e88cb2efb12ae807())), $++;
                    break;
                case 45:
                    if (h === 45 && $b868588574af2763$export$36776f635604f274(j) == 2) b = 0;
            }
    }
    return s;
}
function $b868588574af2763$export$3307ffa7023ede1e(e, r, a, n, s, t, u, i, f, o, l) {
    var v = s - 1;
    var p = s === 0 ? t : [
        ""
    ];
    var h = $b868588574af2763$export$f9084667e487ed46(p);
    for(var b = 0, w = 0, d = 0; b < n; ++b)for(var $ = 0, k = $b868588574af2763$export$2f35ab04d2335697(e, v + 1, v = $b868588574af2763$export$2335f513bbd82c6d(w = u[b])), m = e; $ < h; ++$)if (m = $b868588574af2763$export$87c2784dc9fc4ab(w > 0 ? p[$] + " " + k : $b868588574af2763$export$77ad94ebf1c2b9ed(k, /&\f/g, p[$]))) f[d++] = m;
    return $b868588574af2763$export$35059013cd4a06db(e, r, a, s === 0 ? $b868588574af2763$export$aa3a2e812ca8570d : i, f, o, l);
}
function $b868588574af2763$export$4a34f930e789283c(e, r, a) {
    return $b868588574af2763$export$35059013cd4a06db(e, r, a, $b868588574af2763$export$a29989082612d0d9, $b868588574af2763$export$6788812c4e6611e6($b868588574af2763$export$eba6f6f03b0a92e7()), $b868588574af2763$export$2f35ab04d2335697(e, 2, -2), 0);
}
function $b868588574af2763$export$f8483753829ec8f3(e, r, a, n) {
    return $b868588574af2763$export$35059013cd4a06db(e, r, a, $b868588574af2763$export$527d108ccf083c2b, $b868588574af2763$export$2f35ab04d2335697(e, 0, n), $b868588574af2763$export$2f35ab04d2335697(e, n + 1, -1), n);
}
function $b868588574af2763$export$82e9f45cca5ba907(n, c, s) {
    switch($b868588574af2763$export$d6af199866bfb566(n, c)){
        case 5103:
            return $b868588574af2763$export$39dfd62a25e0fe93 + "print-" + n + n;
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return $b868588574af2763$export$39dfd62a25e0fe93 + n + n;
        case 4789:
            return $b868588574af2763$export$2c0f367103c8d01c + n + n;
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return $b868588574af2763$export$39dfd62a25e0fe93 + n + $b868588574af2763$export$2c0f367103c8d01c + n + $b868588574af2763$export$71ad59f2e432cfe8 + n + n;
        case 5936:
            switch($b868588574af2763$export$a9db5e087081082d(n, c + 11)){
                case 114:
                    return $b868588574af2763$export$39dfd62a25e0fe93 + n + $b868588574af2763$export$71ad59f2e432cfe8 + $b868588574af2763$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "tb") + n;
                case 108:
                    return $b868588574af2763$export$39dfd62a25e0fe93 + n + $b868588574af2763$export$71ad59f2e432cfe8 + $b868588574af2763$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "tb-rl") + n;
                case 45:
                    return $b868588574af2763$export$39dfd62a25e0fe93 + n + $b868588574af2763$export$71ad59f2e432cfe8 + $b868588574af2763$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "lr") + n;
            }
        case 6828:
        case 4268:
        case 2903:
            return $b868588574af2763$export$39dfd62a25e0fe93 + n + $b868588574af2763$export$71ad59f2e432cfe8 + n + n;
        case 6165:
            return $b868588574af2763$export$39dfd62a25e0fe93 + n + $b868588574af2763$export$71ad59f2e432cfe8 + "flex-" + n + n;
        case 5187:
            return $b868588574af2763$export$39dfd62a25e0fe93 + n + $b868588574af2763$export$77ad94ebf1c2b9ed(n, /(\w+).+(:[^]+)/, $b868588574af2763$export$39dfd62a25e0fe93 + "box-$1$2" + $b868588574af2763$export$71ad59f2e432cfe8 + "flex-$1$2") + n;
        case 5443:
            return $b868588574af2763$export$39dfd62a25e0fe93 + n + $b868588574af2763$export$71ad59f2e432cfe8 + "flex-item-" + $b868588574af2763$export$77ad94ebf1c2b9ed(n, /flex-|-self/g, "") + (!$b868588574af2763$export$4659b591c19bdf3d(n, /flex-|baseline/) ? $b868588574af2763$export$71ad59f2e432cfe8 + "grid-row-" + $b868588574af2763$export$77ad94ebf1c2b9ed(n, /flex-|-self/g, "") : "") + n;
        case 4675:
            return $b868588574af2763$export$39dfd62a25e0fe93 + n + $b868588574af2763$export$71ad59f2e432cfe8 + "flex-line-pack" + $b868588574af2763$export$77ad94ebf1c2b9ed(n, /align-content|flex-|-self/g, "") + n;
        case 5548:
            return $b868588574af2763$export$39dfd62a25e0fe93 + n + $b868588574af2763$export$71ad59f2e432cfe8 + $b868588574af2763$export$77ad94ebf1c2b9ed(n, "shrink", "negative") + n;
        case 5292:
            return $b868588574af2763$export$39dfd62a25e0fe93 + n + $b868588574af2763$export$71ad59f2e432cfe8 + $b868588574af2763$export$77ad94ebf1c2b9ed(n, "basis", "preferred-size") + n;
        case 6060:
            return $b868588574af2763$export$39dfd62a25e0fe93 + "box-" + $b868588574af2763$export$77ad94ebf1c2b9ed(n, "-grow", "") + $b868588574af2763$export$39dfd62a25e0fe93 + n + $b868588574af2763$export$71ad59f2e432cfe8 + $b868588574af2763$export$77ad94ebf1c2b9ed(n, "grow", "positive") + n;
        case 4554:
            return $b868588574af2763$export$39dfd62a25e0fe93 + $b868588574af2763$export$77ad94ebf1c2b9ed(n, /([^-])(transform)/g, "$1" + $b868588574af2763$export$39dfd62a25e0fe93 + "$2") + n;
        case 6187:
            return $b868588574af2763$export$77ad94ebf1c2b9ed($b868588574af2763$export$77ad94ebf1c2b9ed($b868588574af2763$export$77ad94ebf1c2b9ed(n, /(zoom-|grab)/, $b868588574af2763$export$39dfd62a25e0fe93 + "$1"), /(image-set)/, $b868588574af2763$export$39dfd62a25e0fe93 + "$1"), n, "") + n;
        case 5495:
        case 3959:
            return $b868588574af2763$export$77ad94ebf1c2b9ed(n, /(image-set\([^]*)/, $b868588574af2763$export$39dfd62a25e0fe93 + "$1" + "$`$1");
        case 4968:
            return $b868588574af2763$export$77ad94ebf1c2b9ed($b868588574af2763$export$77ad94ebf1c2b9ed(n, /(.+:)(flex-)?(.*)/, $b868588574af2763$export$39dfd62a25e0fe93 + "box-pack:$3" + $b868588574af2763$export$71ad59f2e432cfe8 + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + $b868588574af2763$export$39dfd62a25e0fe93 + n + n;
        case 4200:
            if (!$b868588574af2763$export$4659b591c19bdf3d(n, /flex-|baseline/)) return $b868588574af2763$export$71ad59f2e432cfe8 + "grid-column-align" + $b868588574af2763$export$2f35ab04d2335697(n, c) + n;
            break;
        case 2592:
        case 3360:
            return $b868588574af2763$export$71ad59f2e432cfe8 + $b868588574af2763$export$77ad94ebf1c2b9ed(n, "template-", "") + n;
        case 4384:
        case 3616:
            if (s && s.some(function(e, r) {
                return c = r, $b868588574af2763$export$4659b591c19bdf3d(e.props, /grid-\w+-end/);
            })) return ~$b868588574af2763$export$f8e21b1e77979a08(n + (s = s[c].value), "span") ? n : $b868588574af2763$export$71ad59f2e432cfe8 + $b868588574af2763$export$77ad94ebf1c2b9ed(n, "-start", "") + n + $b868588574af2763$export$71ad59f2e432cfe8 + "grid-row-span:" + (~$b868588574af2763$export$f8e21b1e77979a08(s, "span") ? $b868588574af2763$export$4659b591c19bdf3d(s, /\d+/) : +$b868588574af2763$export$4659b591c19bdf3d(s, /\d+/) - +$b868588574af2763$export$4659b591c19bdf3d(n, /\d+/)) + ";";
            return $b868588574af2763$export$71ad59f2e432cfe8 + $b868588574af2763$export$77ad94ebf1c2b9ed(n, "-start", "") + n;
        case 4896:
        case 4128:
            return s && s.some(function(e) {
                return $b868588574af2763$export$4659b591c19bdf3d(e.props, /grid-\w+-start/);
            }) ? n : $b868588574af2763$export$71ad59f2e432cfe8 + $b868588574af2763$export$77ad94ebf1c2b9ed($b868588574af2763$export$77ad94ebf1c2b9ed(n, "-end", "-span"), "span ", "") + n;
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return $b868588574af2763$export$77ad94ebf1c2b9ed(n, /(.+)-inline(.+)/, $b868588574af2763$export$39dfd62a25e0fe93 + "$1$2") + n;
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            if ($b868588574af2763$export$36776f635604f274(n) - 1 - c > 6) switch($b868588574af2763$export$a9db5e087081082d(n, c + 1)){
                case 109:
                    if ($b868588574af2763$export$a9db5e087081082d(n, c + 4) !== 45) break;
                case 102:
                    return $b868588574af2763$export$77ad94ebf1c2b9ed(n, /(.+:)(.+)-([^]+)/, "$1" + $b868588574af2763$export$39dfd62a25e0fe93 + "$2-$3" + "$1" + $b868588574af2763$export$2c0f367103c8d01c + ($b868588574af2763$export$a9db5e087081082d(n, c + 3) == 108 ? "$3" : "$2-$3")) + n;
                case 115:
                    return ~$b868588574af2763$export$f8e21b1e77979a08(n, "stretch") ? $b868588574af2763$export$82e9f45cca5ba907($b868588574af2763$export$77ad94ebf1c2b9ed(n, "stretch", "fill-available"), c, s) + n : n;
            }
            break;
        case 5152:
        case 5920:
            return $b868588574af2763$export$77ad94ebf1c2b9ed(n, /(.+?):(\d+)(\s*\/\s*(span)?\s*(\d+))?(.*)/, function(r, a, c, s, t, u, i) {
                return $b868588574af2763$export$71ad59f2e432cfe8 + a + ":" + c + i + (s ? $b868588574af2763$export$71ad59f2e432cfe8 + a + "-span:" + (t ? u : +u - +c) + i : "") + n;
            });
        case 4949:
            if ($b868588574af2763$export$a9db5e087081082d(n, c + 6) === 121) return $b868588574af2763$export$77ad94ebf1c2b9ed(n, ":", ":" + $b868588574af2763$export$39dfd62a25e0fe93) + n;
            break;
        case 6444:
            switch($b868588574af2763$export$a9db5e087081082d(n, $b868588574af2763$export$a9db5e087081082d(n, 14) === 45 ? 18 : 11)){
                case 120:
                    return $b868588574af2763$export$77ad94ebf1c2b9ed(n, /(.+:)([^;\s!]+)(;|(\s+)?!.+)?/, "$1" + $b868588574af2763$export$39dfd62a25e0fe93 + ($b868588574af2763$export$a9db5e087081082d(n, 14) === 45 ? "inline-" : "") + "box$3" + "$1" + $b868588574af2763$export$39dfd62a25e0fe93 + "$2$3" + "$1" + $b868588574af2763$export$71ad59f2e432cfe8 + "$2box$3") + n;
                case 100:
                    return $b868588574af2763$export$77ad94ebf1c2b9ed(n, ":", ":" + $b868588574af2763$export$71ad59f2e432cfe8) + n;
            }
            break;
        case 5719:
        case 2647:
        case 2135:
        case 3927:
        case 2391:
            return $b868588574af2763$export$77ad94ebf1c2b9ed(n, "scroll-", "scroll-snap-") + n;
    }
    return n;
}
function $b868588574af2763$export$dfdc1655ccc5b9cb(e, r) {
    var a = "";
    var n = $b868588574af2763$export$f9084667e487ed46(e);
    for(var c = 0; c < n; c++)a += r(e[c], c, e, r) || "";
    return a;
}
function $b868588574af2763$export$fac44ee5b035f737(e, r, a, t) {
    switch(e.type){
        case $b868588574af2763$export$d773506282b3cfe6:
            if (e.children.length) break;
        case $b868588574af2763$export$a763edbf796b780a:
        case $b868588574af2763$export$527d108ccf083c2b:
            return e.return = e.return || e.value;
        case $b868588574af2763$export$a29989082612d0d9:
            return "";
        case $b868588574af2763$export$b44a8529a35fcb60:
            return e.return = e.value + "{" + $b868588574af2763$export$dfdc1655ccc5b9cb(e.children, t) + "}";
        case $b868588574af2763$export$aa3a2e812ca8570d:
            e.value = e.props.join(",");
    }
    return $b868588574af2763$export$36776f635604f274(a = $b868588574af2763$export$dfdc1655ccc5b9cb(e.children, t)) ? e.return = e.value + "{" + a + "}" : "";
}
function $b868588574af2763$export$5a7767152ae0305f(e) {
    var r = $b868588574af2763$export$f9084667e487ed46(e);
    return function(a, n, c, s) {
        var t = "";
        for(var u = 0; u < r; u++)t += e[u](a, n, c, s) || "";
        return t;
    };
}
function $b868588574af2763$export$38bcb760f1d4871c(e) {
    return function(r) {
        if (!r.root) {
            if (r = r.return) e(r);
        }
    };
}
function $b868588574af2763$export$e08c7d021b829b7a(n, t, u, i) {
    if (n.length > -1) {
        if (!n.return) switch(n.type){
            case $b868588574af2763$export$527d108ccf083c2b:
                n.return = $b868588574af2763$export$82e9f45cca5ba907(n.value, n.length, u);
                return;
            case $b868588574af2763$export$b44a8529a35fcb60:
                return $b868588574af2763$export$dfdc1655ccc5b9cb([
                    $b868588574af2763$export$784d13d8ee351f07(n, {
                        value: $b868588574af2763$export$77ad94ebf1c2b9ed(n.value, "@", "@" + $b868588574af2763$export$39dfd62a25e0fe93)
                    })
                ], i);
            case $b868588574af2763$export$aa3a2e812ca8570d:
                if (n.length) return $b868588574af2763$export$1be1fc439b849fdf(n.props, function(c) {
                    switch($b868588574af2763$export$4659b591c19bdf3d(c, /(::plac\w+|:read-\w+)/)){
                        case ":read-only":
                        case ":read-write":
                            return $b868588574af2763$export$dfdc1655ccc5b9cb([
                                $b868588574af2763$export$784d13d8ee351f07(n, {
                                    props: [
                                        $b868588574af2763$export$77ad94ebf1c2b9ed(c, /:(read-\w+)/, ":" + $b868588574af2763$export$2c0f367103c8d01c + "$1")
                                    ]
                                })
                            ], i);
                        case "::placeholder":
                            return $b868588574af2763$export$dfdc1655ccc5b9cb([
                                $b868588574af2763$export$784d13d8ee351f07(n, {
                                    props: [
                                        $b868588574af2763$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, ":" + $b868588574af2763$export$39dfd62a25e0fe93 + "input-$1")
                                    ]
                                }),
                                $b868588574af2763$export$784d13d8ee351f07(n, {
                                    props: [
                                        $b868588574af2763$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, ":" + $b868588574af2763$export$2c0f367103c8d01c + "$1")
                                    ]
                                }),
                                $b868588574af2763$export$784d13d8ee351f07(n, {
                                    props: [
                                        $b868588574af2763$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, $b868588574af2763$export$71ad59f2e432cfe8 + "input-$1")
                                    ]
                                })
                            ], i);
                    }
                    return "";
                });
        }
    }
}
function $b868588574af2763$export$76a88f7de6507443(e) {
    switch(e.type){
        case $b868588574af2763$export$aa3a2e812ca8570d:
            e.props = e.props.map(function(r) {
                return $b868588574af2763$export$1be1fc439b849fdf($b868588574af2763$export$660b2ee2d4fb4eff(r), function(r, a, n) {
                    switch($b868588574af2763$export$a9db5e087081082d(r, 0)){
                        case 12:
                            return $b868588574af2763$export$2f35ab04d2335697(r, 1, $b868588574af2763$export$36776f635604f274(r));
                        case 0:
                        case 40:
                        case 43:
                        case 62:
                        case 126:
                            return r;
                        case 58:
                            if (n[++a] === "global") n[a] = "", n[++a] = "\f" + $b868588574af2763$export$2f35ab04d2335697(n[a], a = 1, -1);
                        case 32:
                            return a === 1 ? "" : r;
                        default:
                            switch(a){
                                case 0:
                                    e = r;
                                    return $b868588574af2763$export$f9084667e487ed46(n) > 1 ? "" : r;
                                case a = $b868588574af2763$export$f9084667e487ed46(n) - 1:
                                case 2:
                                    return a === 2 ? r + e + e : r + e;
                                default:
                                    return r;
                            }
                    }
                });
            });
    }
}

});

parcelRegister("1QNjI", function(module, exports) {
$parcel$export(module.exports, "default", () => $1590e71a06f1c94c$export$2e2bcd8739ae039);
var $1590e71a06f1c94c$export$2e2bcd8739ae039 = function weakMemoize(func) {
    var cache = new WeakMap();
    return function(arg) {
        if (cache.has(arg)) // Use non-null assertion because we just checked that the cache `has` it
        // This allows us to remove `undefined` from the return value
        return cache.get(arg);
        var ret = func(arg);
        cache.set(arg, ret);
        return ret;
    };
};

});

parcelRegister("7VhhO", function(module, exports) {
$parcel$export(module.exports, "default", () => $5c4b43fa4ca9ca56$export$2e2bcd8739ae039);
function $5c4b43fa4ca9ca56$export$2e2bcd8739ae039(fn) {
    var cache = Object.create(null);
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}

});


parcelRegister("d1G9Q", function(module, exports) {
$parcel$export(module.exports, "default", () => $97bc1202558212af$export$2e2bcd8739ae039);
function $97bc1202558212af$export$2e2bcd8739ae039() {
    return $97bc1202558212af$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $97bc1202558212af$export$2e2bcd8739ae039.apply(null, arguments);
}

});

parcelRegister("7XQ8u", function(module, exports) {
$parcel$export(module.exports, "default", () => $5cc67c33c01a8707$export$2e2bcd8739ae039);

var $knBeW = parcelRequire("knBeW");
// this file isolates this package that is not tree-shakeable
// and if this module doesn't actually contain any logic of its own
// then Rollup just use 'hoist-non-react-statics' directly in other chunks
var $5cc67c33c01a8707$export$2e2bcd8739ae039 = function(targetComponent, sourceComponent) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($knBeW)))(targetComponent, sourceComponent);
};

});

parcelRegister("eP8dQ", function(module, exports) {
$parcel$export(module.exports, "getRegisteredStyles", () => $acac34e4571973dc$export$95d99596f328fd52);
$parcel$export(module.exports, "registerStyles", () => $acac34e4571973dc$export$580009a5da2a8b4b);
$parcel$export(module.exports, "insertStyles", () => $acac34e4571973dc$export$6f077d94b33a01aa);
var $acac34e4571973dc$var$isBrowser = typeof document !== 'undefined';
function $acac34e4571973dc$export$95d99596f328fd52(registered, registeredStyles, classNames) {
    var rawClassName = '';
    classNames.split(' ').forEach(function(className) {
        if (registered[className] !== undefined) registeredStyles.push(registered[className] + ";");
        else if (className) rawClassName += className + " ";
    });
    return rawClassName;
}
var $acac34e4571973dc$export$580009a5da2a8b4b = function registerStyles(cache, serialized, isStringTag) {
    var className = cache.key + "-" + serialized.name;
    if (// class name could be used further down
    // the tree but if it's a string tag, we know it won't
    // so we don't have to add it to registered cache.
    // this improves memory usage since we can avoid storing the whole style string
    (isStringTag === false || // we need to always store it if we're in compat mode and
    // in node since emotion-server relies on whether a style is in
    // the registered cache to know whether a style is global or not
    // also, note that this check will be dead code eliminated in the browser
    $acac34e4571973dc$var$isBrowser === false && cache.compat !== undefined) && cache.registered[className] === undefined) cache.registered[className] = serialized.styles;
};
var $acac34e4571973dc$export$6f077d94b33a01aa = function insertStyles(cache, serialized, isStringTag) {
    $acac34e4571973dc$export$580009a5da2a8b4b(cache, serialized, isStringTag);
    var className = cache.key + "-" + serialized.name;
    if (cache.inserted[serialized.name] === undefined) {
        var stylesForSSR = '';
        var current = serialized;
        do {
            var maybeStyles = cache.insert(serialized === current ? "." + className : '', current, cache.sheet, true);
            if (!$acac34e4571973dc$var$isBrowser && maybeStyles !== undefined) stylesForSSR += maybeStyles;
            current = current.next;
        }while (current !== undefined);
        if (!$acac34e4571973dc$var$isBrowser && stylesForSSR.length !== 0) return stylesForSSR;
    }
};

});

parcelRegister("ckRFu", function(module, exports) {
$parcel$export(module.exports, "serializeStyles", () => $8fb0fbaac7a2e807$export$6321afa313b251b5);

var $1gJfi = parcelRequire("1gJfi");

var $aLo9l = parcelRequire("aLo9l");

var $7VhhO = parcelRequire("7VhhO");
var $8fb0fbaac7a2e807$var$isDevelopment = false;
var $8fb0fbaac7a2e807$var$hyphenateRegex = /[A-Z]|^ms/g;
var $8fb0fbaac7a2e807$var$animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;
var $8fb0fbaac7a2e807$var$isCustomProperty = function isCustomProperty(property) {
    return property.charCodeAt(1) === 45;
};
var $8fb0fbaac7a2e807$var$isProcessableValue = function isProcessableValue(value) {
    return value != null && typeof value !== 'boolean';
};
var $8fb0fbaac7a2e807$var$processStyleName = /* #__PURE__ */ (0, $7VhhO.default)(function(styleName) {
    return $8fb0fbaac7a2e807$var$isCustomProperty(styleName) ? styleName : styleName.replace($8fb0fbaac7a2e807$var$hyphenateRegex, '-$&').toLowerCase();
});
var $8fb0fbaac7a2e807$var$processStyleValue = function processStyleValue(key, value) {
    switch(key){
        case 'animation':
        case 'animationName':
            if (typeof value === 'string') return value.replace($8fb0fbaac7a2e807$var$animationRegex, function(match, p1, p2) {
                $8fb0fbaac7a2e807$var$cursor = {
                    name: p1,
                    styles: p2,
                    next: $8fb0fbaac7a2e807$var$cursor
                };
                return p1;
            });
    }
    if ((0, $aLo9l.default)[key] !== 1 && !$8fb0fbaac7a2e807$var$isCustomProperty(key) && typeof value === 'number' && value !== 0) return value + 'px';
    return value;
};
var $8fb0fbaac7a2e807$var$noComponentSelectorMessage = "Component selectors can only be used in conjunction with @emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware compiler transform.";
function $8fb0fbaac7a2e807$var$handleInterpolation(mergedProps, registered, interpolation) {
    if (interpolation == null) return '';
    var componentSelector = interpolation;
    if (componentSelector.__emotion_styles !== undefined) return componentSelector;
    switch(typeof interpolation){
        case 'boolean':
            return '';
        case 'object':
            var keyframes = interpolation;
            if (keyframes.anim === 1) {
                $8fb0fbaac7a2e807$var$cursor = {
                    name: keyframes.name,
                    styles: keyframes.styles,
                    next: $8fb0fbaac7a2e807$var$cursor
                };
                return keyframes.name;
            }
            var serializedStyles = interpolation;
            if (serializedStyles.styles !== undefined) {
                var next = serializedStyles.next;
                if (next !== undefined) // not the most efficient thing ever but this is a pretty rare case
                // and there will be very few iterations of this generally
                while(next !== undefined){
                    $8fb0fbaac7a2e807$var$cursor = {
                        name: next.name,
                        styles: next.styles,
                        next: $8fb0fbaac7a2e807$var$cursor
                    };
                    next = next.next;
                }
                var styles = serializedStyles.styles + ";";
                return styles;
            }
            return $8fb0fbaac7a2e807$var$createStringFromObject(mergedProps, registered, interpolation);
        case 'function':
            if (mergedProps !== undefined) {
                var previousCursor = $8fb0fbaac7a2e807$var$cursor;
                var result = interpolation(mergedProps);
                $8fb0fbaac7a2e807$var$cursor = previousCursor;
                return $8fb0fbaac7a2e807$var$handleInterpolation(mergedProps, registered, result);
            }
            break;
    } // finalize string values (regular strings and functions interpolated into css calls)
    var asString = interpolation;
    if (registered == null) return asString;
    var cached = registered[asString];
    return cached !== undefined ? cached : asString;
}
function $8fb0fbaac7a2e807$var$createStringFromObject(mergedProps, registered, obj) {
    var string = '';
    if (Array.isArray(obj)) for(var i = 0; i < obj.length; i++)string += $8fb0fbaac7a2e807$var$handleInterpolation(mergedProps, registered, obj[i]) + ";";
    else for(var key in obj){
        var value = obj[key];
        if (typeof value !== 'object') {
            var asString = value;
            if (registered != null && registered[asString] !== undefined) string += key + "{" + registered[asString] + "}";
            else if ($8fb0fbaac7a2e807$var$isProcessableValue(asString)) string += $8fb0fbaac7a2e807$var$processStyleName(key) + ":" + $8fb0fbaac7a2e807$var$processStyleValue(key, asString) + ";";
        } else {
            if (key === 'NO_COMPONENT_SELECTOR' && $8fb0fbaac7a2e807$var$isDevelopment) throw new Error($8fb0fbaac7a2e807$var$noComponentSelectorMessage);
            if (Array.isArray(value) && typeof value[0] === 'string' && (registered == null || registered[value[0]] === undefined)) {
                for(var _i = 0; _i < value.length; _i++)if ($8fb0fbaac7a2e807$var$isProcessableValue(value[_i])) string += $8fb0fbaac7a2e807$var$processStyleName(key) + ":" + $8fb0fbaac7a2e807$var$processStyleValue(key, value[_i]) + ";";
            } else {
                var interpolated = $8fb0fbaac7a2e807$var$handleInterpolation(mergedProps, registered, value);
                switch(key){
                    case 'animation':
                    case 'animationName':
                        string += $8fb0fbaac7a2e807$var$processStyleName(key) + ":" + interpolated + ";";
                        break;
                    default:
                        string += key + "{" + interpolated + "}";
                }
            }
        }
    }
    return string;
}
var $8fb0fbaac7a2e807$var$labelPattern = /label:\s*([^\s;{]+)\s*(;|$)/g; // this is the cursor for keyframes
// keyframes are stored on the SerializedStyles object as a linked list
var $8fb0fbaac7a2e807$var$cursor;
function $8fb0fbaac7a2e807$export$6321afa313b251b5(args, registered, mergedProps) {
    if (args.length === 1 && typeof args[0] === 'object' && args[0] !== null && args[0].styles !== undefined) return args[0];
    var stringMode = true;
    var styles = '';
    $8fb0fbaac7a2e807$var$cursor = undefined;
    var strings = args[0];
    if (strings == null || strings.raw === undefined) {
        stringMode = false;
        styles += $8fb0fbaac7a2e807$var$handleInterpolation(mergedProps, registered, strings);
    } else {
        var asTemplateStringsArr = strings;
        styles += asTemplateStringsArr[0];
    } // we start at 1 since we've already handled the first arg
    for(var i = 1; i < args.length; i++){
        styles += $8fb0fbaac7a2e807$var$handleInterpolation(mergedProps, registered, args[i]);
        if (stringMode) {
            var templateStringsArr = strings;
            styles += templateStringsArr[i];
        }
    } // using a global regex with .exec is stateful so lastIndex has to be reset each time
    $8fb0fbaac7a2e807$var$labelPattern.lastIndex = 0;
    var identifierName = '';
    var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5
    while((match = $8fb0fbaac7a2e807$var$labelPattern.exec(styles)) !== null)identifierName += '-' + match[1];
    var name = (0, $1gJfi.default)(styles) + identifierName;
    return {
        name: name,
        styles: styles,
        next: $8fb0fbaac7a2e807$var$cursor
    };
}

});
parcelRegister("1gJfi", function(module, exports) {
$parcel$export(module.exports, "default", () => $0eca61e9ec9ac574$export$2e2bcd8739ae039);
/* eslint-disable */ // Inspired by https://github.com/garycourt/murmurhash-js
// Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86
function $0eca61e9ec9ac574$export$2e2bcd8739ae039(str) {
    // 'm' and 'r' are mixing constants generated offline.
    // They're not really 'magic', they just happen to work well.
    // const m = 0x5bd1e995;
    // const r = 24;
    // Initialize the hash
    var h = 0; // Mix 4 bytes at a time into the hash
    var k, i = 0, len = str.length;
    for(; len >= 4; ++i, len -= 4){
        k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
        k = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
        k ^= /* k >>> r: */ k >>> 24;
        h = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^ /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Handle the last few bytes of the input array
    switch(len){
        case 3:
            h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
        case 2:
            h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
        case 1:
            h ^= str.charCodeAt(i) & 0xff;
            h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Do a few final mixes of the hash to ensure the last few
    // bytes are well-incorporated.
    h ^= h >>> 13;
    h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    return ((h ^ h >>> 15) >>> 0).toString(36);
}

});

parcelRegister("aLo9l", function(module, exports) {
$parcel$export(module.exports, "default", () => $7d6106d35293dee3$export$2e2bcd8739ae039);
var $7d6106d35293dee3$export$2e2bcd8739ae039 = {
    animationIterationCount: 1,
    aspectRatio: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    msGridRow: 1,
    msGridRowSpan: 1,
    msGridColumn: 1,
    msGridColumnSpan: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    scale: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    // SVG-related properties
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
};

});


parcelRegister("5qnXH", function(module, exports) {
$parcel$export(module.exports, "useInsertionEffectAlwaysWithSyncFallback", () => $3f31f7cc4627f3ab$export$db21c7ffa21794e7);
$parcel$export(module.exports, "useInsertionEffectWithLayoutFallback", () => $3f31f7cc4627f3ab$export$811a713a7276cb9d);

var $5FkrB = parcelRequire("5FkrB");
var $3f31f7cc4627f3ab$var$isBrowser = typeof document !== 'undefined';
var $3f31f7cc4627f3ab$var$syncFallback = function syncFallback(create) {
    return create();
};
var $3f31f7cc4627f3ab$var$useInsertionEffect = $5FkrB.useInsertionEffect ? $5FkrB.useInsertionEffect : false;
var $3f31f7cc4627f3ab$export$db21c7ffa21794e7 = !$3f31f7cc4627f3ab$var$isBrowser ? $3f31f7cc4627f3ab$var$syncFallback : $3f31f7cc4627f3ab$var$useInsertionEffect || $3f31f7cc4627f3ab$var$syncFallback;
var $3f31f7cc4627f3ab$export$811a713a7276cb9d = $3f31f7cc4627f3ab$var$useInsertionEffect || $5FkrB.useLayoutEffect;

});


parcelRegister("kqp0i", function(module, exports) {
function $ede9a19b7e4a528d$var$_extends() {
    return module.exports = $ede9a19b7e4a528d$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $ede9a19b7e4a528d$var$_extends.apply(null, arguments);
}
module.exports = $ede9a19b7e4a528d$var$_extends, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("9ztDu", function(module, exports) {
$parcel$export(module.exports, "default", () => $6f7e5f007cf95a87$export$2e2bcd8739ae039);
/* spinner.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $970q7 = parcelRequire("970q7");

var $5FkrB = parcelRequire("5FkrB");

var $eqVaP = parcelRequire("eqVaP");

var $bGB2r = parcelRequire("bGB2r");

var $fKJ1H = parcelRequire("fKJ1H");
/**
 * Returns the appropriate circle stroke color.
 */ function $6f7e5f007cf95a87$var$getStrokeColor(appearance) {
    return appearance === 'inherit' ? "var(--ds-icon-subtle, ".concat((0, $bGB2r.N500), ")") : "var(--ds-icon-inverse, ".concat((0, $bGB2r.N0), ")");
}
var $6f7e5f007cf95a87$var$rotate = null;
/**
 * There are three parts to the load in animation:
 * 1. Accelerated spin
 * 2. Stretch the spinner line
 */ var $6f7e5f007cf95a87$var$loadIn = null;
var $6f7e5f007cf95a87$var$styles = {
    rotateStyles: "_j7hqsf8s _5sag12kz _tip812c5 _1pgl2qsq _8hrz1h6o",
    loadInStyles: "_j7hq1ky6 _5sag9cwz _1pgl1ytf _1o51q7pw",
    wrapperStyles: "_1e0c116y _s7n4nkob",
    circleStyles: "_lswuglyw _7ljx1dhp _1snbbs82 _jcxd7g3v _1tjm1onz"
};
/**
 * `useLayoutEffect` is being used in SSR safe form. On the server, this work doesn’t need to run.
 * `useEffect` is used in-place, because `useEffect` is not run on the server and it matches types
 * which makes things simpler than doing an `isServer` check or a `null` check.
 *
 * @see https://hello.atlassian.net/wiki/spaces/DST/pages/2081696628/DSTDACI-010+-+Interaction+Tracing+hooks+in+DS+components
 */ var $6f7e5f007cf95a87$var$useLayoutEffect = typeof window === 'undefined' ? (0, $5FkrB.useEffect) : (0, $5FkrB.useLayoutEffect);
/**
 * __Spinner__
 *
 * A spinner is an animated spinning icon that lets users know content is being loaded.
 *
 * - [Examples](https://atlassian.design/components/spinner/examples)
 * - [Code](https://atlassian.design/components/spinner/code)
 * - [Usage](https://atlassian.design/components/spinner/usage)
 */ var $6f7e5f007cf95a87$var$Spinner = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).forwardRef(function Spinner(_ref, ref) {
    var _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'inherit' : _ref$appearance, _ref$delay = _ref.delay, delay = _ref$delay === void 0 ? 0 : _ref$delay, interactionName = _ref.interactionName, label = _ref.label, _ref$size = _ref.size, providedSize = _ref$size === void 0 ? 'medium' : _ref$size, testId = _ref.testId;
    var size = typeof providedSize === 'number' ? providedSize : (0, $fKJ1H.presetSizes)[providedSize];
    var animationDelay = "".concat(delay, "ms");
    var stroke = $6f7e5f007cf95a87$var$getStrokeColor(appearance);
    var context = (0, $5FkrB.useContext)((0, $eqVaP.default));
    $6f7e5f007cf95a87$var$useLayoutEffect(function() {
        if (context != null) return context.hold(interactionName);
    }, [
        context,
        interactionName
    ]);
    /**
   * The Spinner animation uses a combination of two
   * css animations on two separate elements.
   */ return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("span", {
        "data-testid": testId ? "".concat(testId, "-wrapper") : 'spinner-wrapper',
        style: {
            animationDelay: animationDelay,
            width: size,
            height: size
        },
        className: (0, $970q7.default)([
            $6f7e5f007cf95a87$var$styles.wrapperStyles,
            $6f7e5f007cf95a87$var$styles.rotateStyles
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("svg", {
        height: size,
        width: size,
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg",
        "data-testid": testId,
        ref: ref,
        "aria-label": label || undefined,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            animationDelay: animationDelay
        },
        role: label ? 'img' : 'none',
        className: (0, $970q7.default)([
            $6f7e5f007cf95a87$var$styles.loadInStyles
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("circle", {
        cx: "8",
        cy: "8",
        r: "7",
        style: {
            stroke: stroke
        },
        className: (0, $970q7.default)([
            $6f7e5f007cf95a87$var$styles.circleStyles
        ])
    })));
}));
var $6f7e5f007cf95a87$export$2e2bcd8739ae039 = $6f7e5f007cf95a87$var$Spinner;

});
parcelRegister("970q7", function(module, exports) {
$parcel$export(module.exports, "default", () => $6a2517f1a964148b$export$2e2bcd8739ae039);
/**
 * This length includes the underscore,
 * e.g. `"_1s4A"` would be a valid atomic group hash.
 */ const $6a2517f1a964148b$var$ATOMIC_GROUP_LENGTH = 5;
function $6a2517f1a964148b$export$2e2bcd8739ae039(classNames) {
    // Shortcut: nothing to do
    if (!classNames.length) return;
    // Shortcut: don't need to do anything if we only have a single classname
    if (classNames.length === 1 && classNames[0] && // checking to see if `classNames[0]` is a string that contains other classnames
    !classNames[0].includes(' ')) return classNames[0];
    // Using an object rather than a `Map` as it performed better in our benchmarks.
    // Would be happy to move to `Map` if it proved to be better under real conditions.
    const map = {};
    // Note: using loops to minimize iterations over the collection
    for (const value of classNames){
        // Exclude all falsy values, which leaves us with populated strings
        if (!value) continue;
        // a `value` can contain multiple classnames
        const list = value.split(' ');
        for (const className of list){
            /**
             * For atomic style classnames: the `key` is the `group`
             *
             * - Later atomic classnames with the same `group` will override earlier ones
             *   (which is what we want).
             * - Assumes atomic classnames are the only things that start with `_`
             * - Could use a regex to ensure that atomic classnames are structured how we expect,
             *   but did not add that for now as it did slow things down a bit.
             *
             * For other classnames: the `key` is the whole classname
             * - Okay to remove duplicates as doing so does not impact specificity
             *
             * */ const key = className.startsWith('_') ? className.slice(0, $6a2517f1a964148b$var$ATOMIC_GROUP_LENGTH) : className;
            map[key] = className;
        }
    }
    /**
     * We are converting the `map` into a string.
     *
     * The simple way to do this would be `Object.values(map).join(' ')`.
     * However, the approach below performs 10%-20% better in benchmarks.
     *
     * For `ax()` it feels right to squeeze as much runtime performance out as we can.
     */ let result = '';
    for(const key in map)result += map[key] + ' ';
    // If we have an empty string, then our `map` was empty.
    if (!result) return;
    // remove last " " from the result (we added " " at the end of every value)
    return result.trimEnd();
}

});

parcelRegister("eqVaP", function(module, exports) {
$parcel$export(module.exports, "default", () => $a81fd7e45a8c2ef5$export$2e2bcd8739ae039);

var $5FkrB = parcelRequire("5FkrB");
var $a81fd7e45a8c2ef5$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $5FkrB.createContext)(null);

});

parcelRegister("bGB2r", function(module, exports) {
$parcel$export(module.exports, "N0", () => $88205903ce4e234b$export$29a4f05edc054374);
$parcel$export(module.exports, "N500", () => $88205903ce4e234b$export$c39c0fe0f26207ae);
// Reds
var $88205903ce4e234b$export$4b84fd0e2c617bd = '#FFEBE6';
var $88205903ce4e234b$export$b34b069eff244586 = '#FFBDAD';
var $88205903ce4e234b$export$be802dd0d8b57f35 = '#FF8F73';
var $88205903ce4e234b$export$60847d42f9da92a6 = '#FF7452';
var $88205903ce4e234b$export$4a7404f376229999 = '#FF5630';
var $88205903ce4e234b$export$2010d0fb4295b346 = '#DE350B';
var $88205903ce4e234b$export$2837b5a1a71d5c02 = '#BF2600';
var $88205903ce4e234b$export$8d9596b529bbb9cf = '#FFFAE6';
var $88205903ce4e234b$export$41060a744ab0b7ae = '#FFF0B3';
var $88205903ce4e234b$export$1cc05bbbf340e559 = '#FFE380';
var $88205903ce4e234b$export$5aae31392d72caaa = '#FFC400';
var $88205903ce4e234b$export$c6930421db9fa514 = '#FFAB00';
var $88205903ce4e234b$export$59619663aa6500fb = '#FF991F';
var $88205903ce4e234b$export$874739ea9e379ab6 = '#FF8B00';
var $88205903ce4e234b$export$8a6341c32b6a3ee6 = '#E3FCEF';
var $88205903ce4e234b$export$69a3bf21b9686c2b = '#ABF5D1';
var $88205903ce4e234b$export$afbce1382ec95f73 = '#79F2C0';
var $88205903ce4e234b$export$747d86715d4175de = '#57D9A3';
var $88205903ce4e234b$export$940e1f69e873f202 = '#36B37E';
var $88205903ce4e234b$export$a49394138f7b8e85 = '#00875A';
var $88205903ce4e234b$export$6fa04827ac68a4fb = '#006644';
var $88205903ce4e234b$export$226de0355ed012f8 = '#DEEBFF';
var $88205903ce4e234b$export$8c13c2ee36917869 = '#B3D4FF';
var $88205903ce4e234b$export$ecfc1dff386a3e7a = '#4C9AFF';
var $88205903ce4e234b$export$215b7063051591f1 = '#2684FF';
var $88205903ce4e234b$export$e62e8919cca44969 = '#0065FF';
var $88205903ce4e234b$export$b3de0ae08da2ce64 = '#0052CC';
var $88205903ce4e234b$export$a6ee3d71bc067634 = '#0747A6';
var $88205903ce4e234b$export$67f15409e87642a1 = '#669DF1';
var $88205903ce4e234b$export$f0539dbc42dbb067 = '#8FB8F6';
var $88205903ce4e234b$export$363e4475840015bb = '#EAE6FF';
var $88205903ce4e234b$export$4b0a4417ed59760f = '#C0B6F2';
var $88205903ce4e234b$export$6011520a64d9a187 = '#998DD9';
var $88205903ce4e234b$export$a7175d4e9206bc80 = '#8777D9';
var $88205903ce4e234b$export$b48405b95304b5a1 = '#6554C0';
var $88205903ce4e234b$export$c71e4279dd54a18d = '#5243AA';
var $88205903ce4e234b$export$147899de772240ec = '#403294';
var $88205903ce4e234b$export$2cf711fe14c66f06 = '#E6FCFF';
var $88205903ce4e234b$export$7a8f4d33f6f9772c = '#B3F5FF';
var $88205903ce4e234b$export$776c9c497ef08533 = '#79E2F2';
var $88205903ce4e234b$export$69cb3ca10c1e330e = '#00C7E6';
var $88205903ce4e234b$export$9dc1ef0f3f48059b = '#00B8D9';
var $88205903ce4e234b$export$7c835c78b6fcdef8 = '#00A3BF';
var $88205903ce4e234b$export$6036577f95c3877e = '#008DA6';
var $88205903ce4e234b$export$29a4f05edc054374 = '#FFFFFF';
var $88205903ce4e234b$export$e655ef011c4aa1a2 = '#FAFBFC';
var $88205903ce4e234b$export$9fdfb749e33cdf97 = '#F4F5F7';
var $88205903ce4e234b$export$3e51e8f1440314ba = '#EBECF0';
var $88205903ce4e234b$export$1ce2d1575d444ceb = '#DFE1E6';
var $88205903ce4e234b$export$8754fc7e6d8b3000 = '#C1C7D0';
var $88205903ce4e234b$export$c2e91cbeada39b8b = '#B3BAC5';
var $88205903ce4e234b$export$5f71e19f3a7ad9de = '#A5ADBA';
var $88205903ce4e234b$export$eaa8c8a70ac22806 = '#97A0AF';
var $88205903ce4e234b$export$7c87d337fb91a97d = '#8993A4';
var $88205903ce4e234b$export$d6447c357493214f = '#7A869A';
var $88205903ce4e234b$export$f563ee71e9ee74cd = '#6B778C';
var $88205903ce4e234b$export$e2ef2124cf4024b1 = '#5E6C84';
var $88205903ce4e234b$export$eece5f492e429f08 = '#505F79';
var $88205903ce4e234b$export$c39c0fe0f26207ae = '#42526E';
var $88205903ce4e234b$export$7090862dc3038a9f = '#344563';
var $88205903ce4e234b$export$ad0bacf983b7ddaa = '#253858';
var $88205903ce4e234b$export$7d61b15e0da132af = '#172B4D';
var $88205903ce4e234b$export$fbda843f0a27fe96 = '#091E42';
var $88205903ce4e234b$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
var $88205903ce4e234b$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
var $88205903ce4e234b$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
var $88205903ce4e234b$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
var $88205903ce4e234b$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
var $88205903ce4e234b$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
var $88205903ce4e234b$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
var $88205903ce4e234b$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
var $88205903ce4e234b$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
var $88205903ce4e234b$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
var $88205903ce4e234b$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
var $88205903ce4e234b$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
var $88205903ce4e234b$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
var $88205903ce4e234b$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
var $88205903ce4e234b$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
var $88205903ce4e234b$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
var $88205903ce4e234b$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
var $88205903ce4e234b$export$2f6319cf7d736c2a = '#E6EDFA';
var $88205903ce4e234b$export$95126bc8884d6634 = '#DCE5F5';
var $88205903ce4e234b$export$8338d8c35d44ff1 = '#CED9EB';
var $88205903ce4e234b$export$5368d76ae4fbbda7 = '#B8C7E0';
var $88205903ce4e234b$export$9f0a771d16ec8d36 = '#ABBBD6';
var $88205903ce4e234b$export$abcf8c38338b4aa5 = '#9FB0CC';
var $88205903ce4e234b$export$97e81faa16a182c7 = '#8C9CB8';
var $88205903ce4e234b$export$bfe21c59123ecf33 = '#7988A3';
var $88205903ce4e234b$export$ee82aa2ea6a1558 = '#67758F';
var $88205903ce4e234b$export$682927c6ed76be02 = '#56637A';
var $88205903ce4e234b$export$91fd9994c5be9757 = '#455166';
var $88205903ce4e234b$export$d281fbfe3cff2df6 = '#3B475C';
var $88205903ce4e234b$export$3902c91d8b98a753 = '#313D52';
var $88205903ce4e234b$export$8e8133c1ba5845b5 = '#283447';
var $88205903ce4e234b$export$33ff357f6620b39 = '#202B3D';
var $88205903ce4e234b$export$633847cf062b69e0 = '#1B2638';
var $88205903ce4e234b$export$9776a6e503bdbf76 = '#121A29';
var $88205903ce4e234b$export$6c813d5160dff5db = '#0E1624';
var $88205903ce4e234b$export$3d4f271a500072a = '#0D1424';
var $88205903ce4e234b$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
var $88205903ce4e234b$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
var $88205903ce4e234b$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
var $88205903ce4e234b$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
var $88205903ce4e234b$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
var $88205903ce4e234b$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
var $88205903ce4e234b$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
var $88205903ce4e234b$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
var $88205903ce4e234b$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
var $88205903ce4e234b$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
var $88205903ce4e234b$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
var $88205903ce4e234b$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
var $88205903ce4e234b$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
var $88205903ce4e234b$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
var $88205903ce4e234b$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
var $88205903ce4e234b$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
var $88205903ce4e234b$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';
var $88205903ce4e234b$export$d2adc5dedf09fced = '#292A2E';
var $88205903ce4e234b$export$f51762073d2bb381 = '#94C748';
var $88205903ce4e234b$export$95e26d54def96891 = '#B3DF72';

});

parcelRegister("fKJ1H", function(module, exports) {
$parcel$export(module.exports, "presetSizes", () => $b77e143823b2f7d8$export$4e9f1640bbe7a1a8);
var $b77e143823b2f7d8$export$4e9f1640bbe7a1a8 = {
    xsmall: 12,
    small: 16,
    medium: 24,
    large: 48,
    xlarge: 96
};

});


parcelRegister("gNUZr", function(module, exports) {
$parcel$export(module.exports, "createHook", () => $c3bd6dfdb3d51ec8$export$e7f733c8fc2b8a24);
$parcel$export(module.exports, "createActionsHook", () => $c3bd6dfdb3d51ec8$export$7c643e1d6648e418);
$parcel$export(module.exports, "createStateHook", () => $c3bd6dfdb3d51ec8$export$6e4e5611de132e85);

var $5FkrB = parcelRequire("5FkrB");

var $h209R = parcelRequire("h209R");

var $h0ORH = parcelRequire("h0ORH");

var $czK0u = parcelRequire("czK0u");
const $c3bd6dfdb3d51ec8$var$EMPTY_SELECTOR = ()=>undefined;
const $c3bd6dfdb3d51ec8$var$DEFAULT_SELECTOR = (state)=>state;
function $c3bd6dfdb3d51ec8$export$e7f733c8fc2b8a24(Store, _temp) {
    let { selector: selector } = _temp === void 0 ? {} : _temp;
    return function useSweetState(propsArg) {
        const { retrieveStore: retrieveStore } = (0, $5FkrB.useContext)((0, $h0ORH.Context));
        const { storeState: storeState, actions: actions } = retrieveStore(Store);
        const hasPropsArg = propsArg !== undefined;
        const propsArgRef = (0, $5FkrB.useRef)(propsArg);
        propsArgRef.current = propsArg;
        const stateSelector = (0, $5FkrB.useMemo)(()=>selector ? (0, $czK0u.getSelectorInstance)(selector, storeState, hasPropsArg) : selector === null ? $c3bd6dfdb3d51ec8$var$EMPTY_SELECTOR : $c3bd6dfdb3d51ec8$var$DEFAULT_SELECTOR, [
            hasPropsArg,
            storeState
        ]);
        const forceUpdate = (0, $5FkrB.useState)({})[1];
        const getSnapshot = (0, $5FkrB.useCallback)(()=>{
            // parent scope has changed and notify was explicitly triggered by the container
            // we need to force the hook to re-render to listen new storeState
            if (retrieveStore(Store).storeState !== storeState) forceUpdate({});
            const state = storeState.getState();
            return stateSelector(state, propsArgRef.current);
        }, [
            retrieveStore,
            storeState,
            stateSelector,
            forceUpdate
        ]);
        const currentState = (0, $h209R.useSyncExternalStore)(storeState.subscribe, getSnapshot, getSnapshot);
        return [
            currentState,
            actions
        ];
    };
}
function $c3bd6dfdb3d51ec8$export$7c643e1d6648e418(Store) {
    const useHook = $c3bd6dfdb3d51ec8$export$e7f733c8fc2b8a24(Store, {
        selector: null
    });
    return function useSweetStateActions() {
        return useHook()[1];
    };
}
function $c3bd6dfdb3d51ec8$export$6e4e5611de132e85(Store, _temp2) {
    let { selector: selector } = _temp2 === void 0 ? {} : _temp2;
    const useHook = $c3bd6dfdb3d51ec8$export$e7f733c8fc2b8a24(Store, {
        selector: selector
    });
    return function useSweetStateState(propsArg) {
        return useHook(propsArg)[0];
    };
}

});
parcelRegister("h209R", function(module, exports) {
'use strict';

module.exports = (parcelRequire("cZxCB"));

});
parcelRegister("cZxCB", function(module, exports) {
$parcel$export(module.exports, "useSyncExternalStore", () => $97554319fd766d9f$export$306c0aa65ff9ec16, (v) => $97554319fd766d9f$export$306c0aa65ff9ec16 = v);
/**
 * @license React
 * use-sync-external-store-shim.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $97554319fd766d9f$export$306c0aa65ff9ec16;
"use strict";

var $5FkrB = parcelRequire("5FkrB");
function $97554319fd766d9f$var$is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var $97554319fd766d9f$var$objectIs = "function" === typeof Object.is ? Object.is : $97554319fd766d9f$var$is, $97554319fd766d9f$var$useState = $5FkrB.useState, $97554319fd766d9f$var$useEffect = $5FkrB.useEffect, $97554319fd766d9f$var$useLayoutEffect = $5FkrB.useLayoutEffect, $97554319fd766d9f$var$useDebugValue = $5FkrB.useDebugValue;
function $97554319fd766d9f$var$useSyncExternalStore$2(subscribe, getSnapshot) {
    var value = getSnapshot(), _useState = $97554319fd766d9f$var$useState({
        inst: {
            value: value,
            getSnapshot: getSnapshot
        }
    }), inst = _useState[0].inst, forceUpdate = _useState[1];
    $97554319fd766d9f$var$useLayoutEffect(function() {
        inst.value = value;
        inst.getSnapshot = getSnapshot;
        $97554319fd766d9f$var$checkIfSnapshotChanged(inst) && forceUpdate({
            inst: inst
        });
    }, [
        subscribe,
        value,
        getSnapshot
    ]);
    $97554319fd766d9f$var$useEffect(function() {
        $97554319fd766d9f$var$checkIfSnapshotChanged(inst) && forceUpdate({
            inst: inst
        });
        return subscribe(function() {
            $97554319fd766d9f$var$checkIfSnapshotChanged(inst) && forceUpdate({
                inst: inst
            });
        });
    }, [
        subscribe
    ]);
    $97554319fd766d9f$var$useDebugValue(value);
    return value;
}
function $97554319fd766d9f$var$checkIfSnapshotChanged(inst) {
    var latestGetSnapshot = inst.getSnapshot;
    inst = inst.value;
    try {
        var nextValue = latestGetSnapshot();
        return !$97554319fd766d9f$var$objectIs(inst, nextValue);
    } catch (error) {
        return !0;
    }
}
function $97554319fd766d9f$var$useSyncExternalStore$1(subscribe, getSnapshot) {
    return getSnapshot();
}
var $97554319fd766d9f$var$shim = "undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement ? $97554319fd766d9f$var$useSyncExternalStore$1 : $97554319fd766d9f$var$useSyncExternalStore$2;
$97554319fd766d9f$export$306c0aa65ff9ec16 = void 0 !== $5FkrB.useSyncExternalStore ? $5FkrB.useSyncExternalStore : $97554319fd766d9f$var$shim;

});


parcelRegister("h0ORH", function(module, exports) {
$parcel$export(module.exports, "Context", () => $c629e488311fc925$export$841858b892ce1f4c);

var $5FkrB = parcelRequire("5FkrB");

var $8i0MQ = parcelRequire("8i0MQ");
const $c629e488311fc925$export$841858b892ce1f4c = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createContext({
    globalRegistry: (0, $8i0MQ.defaultRegistry),
    retrieveStore: (Store)=>(0, $8i0MQ.defaultRegistry).getStore(Store)
}, ()=>0);

});
parcelRegister("8i0MQ", function(module, exports) {
$parcel$export(module.exports, "StoreRegistry", () => $60909d64c4d3805d$export$acb47f32da33501e);
$parcel$export(module.exports, "defaultRegistry", () => $60909d64c4d3805d$export$9d726ae4880b1060);

var $3anWS = parcelRequire("3anWS");

var $7qpgv = parcelRequire("7qpgv");

var $5wOUy = parcelRequire("5wOUy");
const $60909d64c4d3805d$export$e4d628ba0054221b = '__global__';
class $60909d64c4d3805d$export$acb47f32da33501e {
    constructor(defaultScope){
        var _this = this;
        if (defaultScope === void 0) defaultScope = $60909d64c4d3805d$export$e4d628ba0054221b;
        this.stores = new Map();
        this.initStore = (key, Store, config)=>{
            const { initialState: initialState, actions: actions } = Store;
            if (Store.containedBy && !config.contained(Store)) {
                const err = new Error(`Store ${Store.key} should be contained by a container but it is used globally. ` + `While it might still work, it will likely cause unexpected behaviours.`);
                if ((0, $3anWS.default).scheduling()) Promise.reject(err);
                else throw err;
            }
            const storeState = (0, $5wOUy.default)(key, initialState);
            let boundActions;
            const store = {
                storeState: storeState,
                // these are used only when container-less, so we generate them on-demand
                get actions () {
                    if (!boundActions) boundActions = (0, $7qpgv.bindActions)(actions, storeState, config);
                    return boundActions;
                }
            };
            this.stores.set(key, store);
            return store;
        };
        this.hasStore = function(Store, scopeId) {
            if (scopeId === void 0) scopeId = _this.defaultScope;
            const key = _this.generateKey(Store, scopeId);
            return _this.stores.has(key);
        };
        this.getStore = function(Store, scopeId, config) {
            if (scopeId === void 0) scopeId = _this.defaultScope;
            if (config === void 0) config = {
                props: ()=>({}),
                contained: ()=>false
            };
            const key = _this.generateKey(Store, scopeId);
            return _this.stores.get(key) || config && _this.initStore(key, Store, config);
        };
        this.deleteStore = function(Store, scopeId) {
            if (scopeId === void 0) scopeId = _this.defaultScope;
            const key = _this.generateKey(Store, scopeId);
            _this.stores.delete(key);
        };
        this.generateKey = (Store, scopeId)=>`${Store.key}@${scopeId}`;
        this.defaultScope = defaultScope;
    }
}
const $60909d64c4d3805d$export$9d726ae4880b1060 = new $60909d64c4d3805d$export$acb47f32da33501e();

});
parcelRegister("3anWS", function(module, exports) {
$parcel$export(module.exports, "default", () => $24e4e1fa0485bf7c$export$2e2bcd8739ae039);
const $24e4e1fa0485bf7c$var$supports = {
    scheduling () {
        return typeof window !== 'undefined' && typeof MessageChannel === 'function';
    }
};
var $24e4e1fa0485bf7c$export$2e2bcd8739ae039 = $24e4e1fa0485bf7c$var$supports;

});

parcelRegister("7qpgv", function(module, exports) {
$parcel$export(module.exports, "bindActions", () => $567e8f4619a691de$export$5ee1d46cd0883a22);

var $8IUIa = parcelRequire("8IUIa");
const $567e8f4619a691de$var$namedMutator = (storeState, actionName)=>function() {
        storeState.mutator.actionName = actionName;
        return storeState.mutator(...arguments);
    };
const $567e8f4619a691de$var$warnings = new WeakMap();
const $567e8f4619a691de$export$5f944353e69b9bf3 = (storeState, actionFn, actionKey, config, actions)=>{
    const callThunk = (instance, thunkFn, actionName)=>thunkFn({
            setState: (0, $8IUIa.default).devtools ? $567e8f4619a691de$var$namedMutator(instance.storeState, actionName) : instance.storeState.mutator,
            getState: instance.storeState.getState,
            get actions () {
                if (!$567e8f4619a691de$var$warnings.has(actionFn)) $567e8f4619a691de$var$warnings.set(actionFn, console.warn(`react-sweet-state 'actions' property has been deprecated and will be removed in the next mayor. ` + `Please check action '${actionName}' of Store '${instance.storeState.key}' and use 'dispatch' instead`));
                return actions;
            },
            dispatch: (tFn)=>callThunk(instance, tFn, `${actionName}.dispatch`)
        }, config.props());
    return function() {
        return callThunk({
            storeState: storeState,
            actions: actions
        }, actionFn(...arguments), actionKey);
    };
};
const $567e8f4619a691de$export$5ee1d46cd0883a22 = function bindActions(actions, storeState, config, boundActions) {
    if (boundActions === void 0) boundActions = null;
    return Object.keys(actions).reduce((acc, k)=>{
        acc[k] = $567e8f4619a691de$export$5f944353e69b9bf3(storeState, actions[k], k, config, boundActions || acc);
        return acc;
    }, {});
};

});
parcelRegister("8IUIa", function(module, exports) {
$parcel$export(module.exports, "default", () => $659e6c773637eb0b$export$2e2bcd8739ae039);

var $5FkrB = parcelRequire("5FkrB");
const $659e6c773637eb0b$var$defaultMutator = (prevState, partialState)=>{
    // Merge the partial state and the previous state.
    return Object.assign({}, prevState, partialState);
};
const $659e6c773637eb0b$var$defaults = {
    batchUpdates: 'useSyncExternalStore' in (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))),
    devtools: false,
    middlewares: new Set(),
    mutator: $659e6c773637eb0b$var$defaultMutator
};
var $659e6c773637eb0b$export$2e2bcd8739ae039 = $659e6c773637eb0b$var$defaults;

});


parcelRegister("5wOUy", function(module, exports) {
$parcel$export(module.exports, "default", () => $40676ed4f7792fba$export$2e2bcd8739ae039);

var $7Vo5b = parcelRequire("7Vo5b");

var $7lZpM = parcelRequire("7lZpM");

var $8IUIa = parcelRequire("8IUIa");

var $6dx62 = parcelRequire("6dx62");
function $40676ed4f7792fba$var$createStoreState(key, initialState) {
    let listeners = new Set();
    let currentState = initialState;
    const storeState = {
        key: key,
        getState () {
            return currentState;
        },
        setState (nextState) {
            currentState = nextState; // Instead of notifying all handlers immediately, we wait next tick
            // so multiple actions affecting the same store gets combined
            (0, $6dx62.default)(storeState.notify);
        },
        resetState () {
            storeState.setState(initialState);
        },
        notify () {
            for (const listener of listeners)listener(storeState.getState());
        },
        subscribe (listener) {
            listeners.add(listener);
            return function unsubscribe() {
                listeners.delete(listener);
            };
        },
        listeners () {
            return listeners;
        }
    };
    storeState.mutator = (0, $7Vo5b.default)(storeState, (0, $8IUIa.default).middlewares);
    return storeState;
}
var $40676ed4f7792fba$export$2e2bcd8739ae039 = (0, $7lZpM.default)($40676ed4f7792fba$var$createStoreState);

});
parcelRegister("7Vo5b", function(module, exports) {
$parcel$export(module.exports, "default", () => $5c50899a0dea3342$export$2e2bcd8739ae039);

var $8IUIa = parcelRequire("8IUIa");

var $fFj9N = parcelRequire("fFj9N");
const $5c50899a0dea3342$var$applyMiddleware = (storeState, middlewares)=>Array.from(middlewares).concat((0, $fFj9N.default)).reduceRight((next, mw)=>mw(storeState)(next), (0, $8IUIa.default).mutator);
var $5c50899a0dea3342$export$2e2bcd8739ae039 = $5c50899a0dea3342$var$applyMiddleware;

});
parcelRegister("fFj9N", function(module, exports) {
$parcel$export(module.exports, "default", () => $b6798b84ef80633c$export$2e2bcd8739ae039);

var $6Qh0T = parcelRequire("6Qh0T");
const $b6798b84ef80633c$var$updateMiddleware = (storeState)=>(next)=>(arg)=>{
            let output;
            const state = storeState.getState();
            const nextState = next(state, arg, (out)=>{
                output = out;
            });
            if (!(0, $6Qh0T.default)(nextState, state)) storeState.setState(nextState);
            return output;
        };
var $b6798b84ef80633c$export$2e2bcd8739ae039 = $b6798b84ef80633c$var$updateMiddleware;

});
parcelRegister("6Qh0T", function(module, exports) {
$parcel$export(module.exports, "default", () => $4fb4cbecfc4ff1e8$export$2e2bcd8739ae039);
// Mostly copied from fbjs/packages/fbjs/src/core/shallowEqual.js
// enhanced with keys cache as might get called multiple times with same args
const $4fb4cbecfc4ff1e8$var$hasOwnProperty = Object.prototype.hasOwnProperty;
const $4fb4cbecfc4ff1e8$var$CACHE = new WeakMap();
function $4fb4cbecfc4ff1e8$export$2e2bcd8739ae039(objA, objB) {
    if (objA === objB) return true;
    if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) return false;
    if (Array.isArray(objA) && Array.isArray(objB)) {
        // do array comparison
        if (objA.length !== objB.length) return false;
        for(let i = 0; i < objA.length; i++){
            if (objA[i] !== objB[i]) return false;
        }
        return true;
    } else {
        // Handle Date, RegExp, String, Number, ... and complex objects
        const strA = '' + objA;
        const strB = '' + objB;
        if (strA !== strB || strA[0] === '[' && strA !== '[object Object]') return false;
         // do object comparison
        let keysA;
        if ($4fb4cbecfc4ff1e8$var$CACHE.has(objA)) keysA = $4fb4cbecfc4ff1e8$var$CACHE.get(objA);
        else {
            keysA = Object.keys(objA);
            $4fb4cbecfc4ff1e8$var$CACHE.set(objA, keysA);
        }
        let keysB;
        if ($4fb4cbecfc4ff1e8$var$CACHE.has(objB)) keysB = $4fb4cbecfc4ff1e8$var$CACHE.get(objB);
        else {
            keysB = Object.keys(objB);
            $4fb4cbecfc4ff1e8$var$CACHE.set(objB, keysB);
        }
        if (keysA.length !== keysB.length) return false;
         // Test for A's keys different from B.
        for(let i = 0; i < keysA.length; i++){
            if (!$4fb4cbecfc4ff1e8$var$hasOwnProperty.call(objB, keysA[i]) || objA[keysA[i]] !== objB[keysA[i]]) return false;
        }
        return true;
    }
}

});



parcelRegister("7lZpM", function(module, exports) {
$parcel$export(module.exports, "default", () => $55aa2244d18072e9$export$2e2bcd8739ae039);

var $8IUIa = parcelRequire("8IUIa");
const $55aa2244d18072e9$var$connectDevTools = (storeState, config)=>{
    const devTools = window.__REDUX_DEVTOOLS_EXTENSION__.connect(Object.assign({
        name: `Store ${storeState.key}`,
        serialize: true,
        trace: true
    }, config));
    devTools.init(storeState.getState());
    devTools.subscribe((message)=>{
        if (message.type === 'DISPATCH') switch(message.payload.type){
            case 'RESET':
                storeState.resetState();
                devTools.init(storeState.getState());
                return;
            case 'COMMIT':
                devTools.init(storeState.getState());
                return;
            case 'ROLLBACK':
                storeState.setState(JSON.parse(message.state));
                devTools.init(storeState.getState());
                return;
            case 'JUMP_TO_STATE':
            case 'JUMP_TO_ACTION':
                storeState.setState(JSON.parse(message.state));
                return;
        }
        else if (message.type === 'ACTION') {
            let action = JSON.parse(message.payload);
            storeState.setState(action.payload);
        }
    });
    return devTools;
};
const $55aa2244d18072e9$var$withDevtools = (createStoreState)=>function() {
        const storeState = createStoreState(...arguments);
        if ((0, $8IUIa.default).devtools && window && window.__REDUX_DEVTOOLS_EXTENSION__) {
            const origMutator = storeState.mutator;
            let devTools;
            const devtoolMutator = (arg)=>{
                const result = origMutator(arg);
                try {
                    if (!devTools) {
                        const config = typeof (0, $8IUIa.default).devtools === 'function' ? (0, $8IUIa.default).devtools(storeState) : {};
                        devTools = $55aa2244d18072e9$var$connectDevTools(storeState, config);
                    }
                    devTools.send({
                        type: storeState.mutator.actionName,
                        payload: arg
                    }, storeState.getState(), {}, storeState.key);
                } catch (err) {
                /* ignore devtools errors */ }
                return result;
            };
            storeState.mutator = devtoolMutator;
        }
        return storeState;
    };
var $55aa2244d18072e9$export$2e2bcd8739ae039 = $55aa2244d18072e9$var$withDevtools;

});

parcelRegister("6dx62", function(module, exports) {
$parcel$export(module.exports, "default", () => $486da13a078d111a$export$2e2bcd8739ae039);

var $8IUIa = parcelRequire("8IUIa");

var $6lPP6 = parcelRequire("6lPP6");

var $3anWS = parcelRequire("3anWS");
const $486da13a078d111a$var$QUEUE = [];
let $486da13a078d111a$var$scheduled;
function $486da13a078d111a$export$2e2bcd8739ae039(fn) {
    // if we are in node/tests or feature disabled, make updates sync batched
    if (!(0, $8IUIa.default).batchUpdates || !(0, $3anWS.default).scheduling()) return (0, $6lPP6.batch)(()=>fn()); // Add to queue if not already there
    // so we avoid multiple notifications to same store listeners
    if (!$486da13a078d111a$var$QUEUE.includes(fn)) $486da13a078d111a$var$QUEUE.push(fn); // if something already started schedule, skip
    if ($486da13a078d111a$var$scheduled) return;
    $486da13a078d111a$var$scheduled = (0, $6lPP6.batch)(()=>{
        let queueFn;
        while(queueFn = $486da13a078d111a$var$QUEUE.shift())queueFn();
        $486da13a078d111a$var$scheduled = null;
    });
}

});
parcelRegister("6lPP6", function(module, exports) {
$parcel$export(module.exports, "batch", () => $49fce73d954fc894$export$712ea50be43a7858);
/* eslint-disable import/no-unresolved */ 
var $aLeHs = parcelRequire("aLeHs");

var $3hvsM = parcelRequire("3hvsM");

var $8IUIa = parcelRequire("8IUIa");

var $3anWS = parcelRequire("3anWS");
let $49fce73d954fc894$var$isInsideBatchedSchedule = false;
function $49fce73d954fc894$export$712ea50be43a7858(fn) {
    // if we are in node/tests or nested schedule
    if (!(0, $8IUIa.default).batchUpdates || !(0, $3anWS.default).scheduling() || $49fce73d954fc894$var$isInsideBatchedSchedule) return (0, $aLeHs.unstable_batchedUpdates)(fn);
    $49fce73d954fc894$var$isInsideBatchedSchedule = true; // Use ImmediatePriority as it has -1ms timeout
    // https://github.com/facebook/react/blob/main/packages/scheduler/src/forks/Scheduler.js#L65
    return (0, $3hvsM.unstable_scheduleCallback)((0, $3hvsM.unstable_ImmediatePriority), function scheduleBatchedUpdates() {
        (0, $aLeHs.unstable_batchedUpdates)(fn);
        $49fce73d954fc894$var$isInsideBatchedSchedule = false;
    });
}

});





parcelRegister("czK0u", function(module, exports) {
$parcel$export(module.exports, "createSelector", () => $927c70ef7a7597a6$export$595d22ed68ca2841);
$parcel$export(module.exports, "getSelectorInstance", () => $927c70ef7a7597a6$export$38d24f3c60944dd5);

var $bvyk1 = parcelRequire("bvyk1");
function $927c70ef7a7597a6$export$595d22ed68ca2841() {
    for(var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++)funcs[_key] = arguments[_key];
    const resultFunc = funcs.pop();
    const dependencies = Array.isArray(funcs[0]) ? funcs[0] : funcs;
    const memoizedResultFunc = (0, $bvyk1.default)(function() {
        return resultFunc.apply(null, arguments);
    }); // this memoisation is optimised for 2 arguments (state, props)
    const selector = (0, $bvyk1.default)(function() {
        // calculate all dependencies results
        const params = [];
        for(let i = 0; i < dependencies.length; i++)params.push(dependencies[i].apply(null, arguments));
         // then call the final func with all them as arguments
        return memoizedResultFunc.apply(null, params);
    }, true); // expose so we can create per scope selectors
    // API compatible with reselect@^4
    selector.resultFunc = resultFunc;
    selector.dependencies = dependencies;
    return selector;
}
function $927c70ef7a7597a6$export$d2c200d79fc82f8c(selector) {
    const isReselector = typeof selector.resultFunc === 'function' && Array.isArray(selector.dependencies);
    const dependencies = isReselector ? selector.dependencies : [
        (s)=>s,
        (_, p)=>p
    ];
    const resultFunc = isReselector ? selector.resultFunc : selector;
    return $927c70ef7a7597a6$export$595d22ed68ca2841(dependencies, resultFunc);
}
const $927c70ef7a7597a6$var$cache = new WeakMap();
function $927c70ef7a7597a6$export$38d24f3c60944dd5(selector, storeState, hasProps) {
    if (!hasProps) {
        if (!$927c70ef7a7597a6$var$cache.has(storeState)) $927c70ef7a7597a6$var$cache.set(storeState, new WeakMap());
        const scopeSelectors = $927c70ef7a7597a6$var$cache.get(storeState);
        if (!scopeSelectors.has(selector)) scopeSelectors.set(selector, $927c70ef7a7597a6$export$d2c200d79fc82f8c(selector));
        return scopeSelectors.get(selector);
    }
    return $927c70ef7a7597a6$export$d2c200d79fc82f8c(selector);
}

});
parcelRegister("bvyk1", function(module, exports) {
$parcel$export(module.exports, "default", () => $860d3699eb69e62e$export$2e2bcd8739ae039);

var $6Qh0T = parcelRequire("6Qh0T");
function $860d3699eb69e62e$var$exactEqual(objA, objB) {
    return objA === objB;
}
function $860d3699eb69e62e$var$areArgumentsEqual(propsMode, prev, next) {
    if (prev === null || next === null || prev.length !== next.length) return false; // If propsMode and 2 arguments, means it is an input selector
    // and we check for shallow equality on 2nd one to optimise props
    if (propsMode && prev.length === 2) return prev[0] === next[0] && (0, $6Qh0T.default)(prev[1], next[1]);
    for(let i = 0; i < prev.length; i++){
        if (!$860d3699eb69e62e$var$exactEqual(prev[i], next[i])) return false;
    }
    return true;
}
function $860d3699eb69e62e$export$2e2bcd8739ae039(resultFn, propsMode) {
    if (propsMode === void 0) propsMode = false;
    let lastArgs = [];
    let lastResult;
    let calledOnce = false;
    const result = function result() {
        if (calledOnce && $860d3699eb69e62e$var$areArgumentsEqual(propsMode, arguments, lastArgs)) return lastResult;
        const nextResult = resultFn.apply(this, arguments);
        if (!propsMode && (0, $6Qh0T.default)(nextResult, lastResult)) return lastResult;
        lastResult = nextResult;
        calledOnce = true;
        lastArgs = arguments;
        return lastResult;
    };
    return result;
}

});



parcelRegister("dWq0h", function(module, exports) {
$parcel$export(module.exports, "createContainer", () => $a264dce57acd4232$export$26ae5ca175b4ec5a);

var $5FkrB = parcelRequire("5FkrB");

var $8vJ0V = parcelRequire("8vJ0V");

var $h0ORH = parcelRequire("h0ORH");

var $7qpgv = parcelRequire("7qpgv");
var $8i0MQ = parcelRequire("8i0MQ");

var $6Qh0T = parcelRequire("6Qh0T");
const $a264dce57acd4232$var$_excluded = [
    "children"
], $a264dce57acd4232$var$_excluded2 = [
    "scope",
    "isGlobal"
];
function $a264dce57acd4232$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
const $a264dce57acd4232$var$noop = ()=>()=>{};
function $a264dce57acd4232$export$26ae5ca175b4ec5a(StoreOrOptions, _temp) {
    if (StoreOrOptions === void 0) StoreOrOptions = {};
    let { onInit: _onInit = $a264dce57acd4232$var$noop, onUpdate: onUpdate = $a264dce57acd4232$var$noop, onCleanup: onCleanup = $a264dce57acd4232$var$noop, displayName: displayName = '' } = _temp === void 0 ? {} : _temp;
    if ('key' in StoreOrOptions) {
        const Store = StoreOrOptions;
        const dn = displayName || `Container(${Store.key.split('__')[0]})`;
        return $a264dce57acd4232$var$createFunctionContainer({
            displayName: dn,
            // compat fields
            override: {
                Store: Store,
                handlers: Object.assign({}, _onInit !== $a264dce57acd4232$var$noop && {
                    onInit: ()=>_onInit()
                }, onCleanup !== $a264dce57acd4232$var$noop && {
                    onDestroy: ()=>onCleanup()
                }, onUpdate !== $a264dce57acd4232$var$noop && {
                    onContainerUpdate: ()=>onUpdate()
                })
            }
        });
    }
    return $a264dce57acd4232$var$createFunctionContainer(StoreOrOptions);
}
function $a264dce57acd4232$var$useRegistry(scope, isGlobal, _ref) {
    let { globalRegistry: globalRegistry } = _ref;
    return (0, $5FkrB.useMemo)(()=>{
        const isLocal = !scope && !isGlobal;
        return isLocal ? new (0, $8i0MQ.StoreRegistry)('__local__') : globalRegistry;
    }, [
        scope,
        isGlobal,
        globalRegistry
    ]);
}
function $a264dce57acd4232$var$useContainedStore(scope, registry, propsRef, check, override) {
    // Store contained scopes in a map, but throwing it away on scope change
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const containedStores = (0, $5FkrB.useMemo)(()=>new Map(), [
        scope
    ]);
    const getContainedStore = (0, $5FkrB.useCallback)((Store)=>{
        let containedStore = containedStores.get(Store); // first time it gets called we add store to contained map bound
        // so we can provide props to actions (only triggered by children)
        if (!containedStore) {
            const isExisting = registry.hasStore(Store, scope);
            const config = {
                props: ()=>propsRef.current.sub,
                contained: check
            };
            const { storeState: storeState } = registry.getStore(Store, scope, config);
            const actions = (0, $7qpgv.bindActions)(Store.actions, storeState, config);
            const handlers = (0, $7qpgv.bindActions)(Object.assign({}, Store.handlers, override == null ? void 0 : override.handlers), storeState, config, actions);
            containedStore = {
                storeState: storeState,
                actions: actions,
                handlers: handlers,
                unsubscribe: undefined
            };
            containedStores.set(Store, containedStore); // Signal store is contained and ready now, so by the time
            // consumers subscribe we already have updated the store (if needed).
            // Also if override maintain legacy behaviour, triggered on every mount
            if (!isExisting || override) handlers.onInit == null || handlers.onInit();
        }
        return containedStore;
    }, [
        containedStores,
        scope,
        registry,
        propsRef,
        check,
        override
    ]);
    return [
        containedStores,
        getContainedStore
    ];
}
function $a264dce57acd4232$var$useApi(check, getContainedStore, _ref2) {
    let { globalRegistry: globalRegistry, retrieveStore: retrieveStore } = _ref2;
    const retrieveRef = (0, $5FkrB.useRef)();
    retrieveRef.current = (Store)=>check(Store) ? getContainedStore(Store) : retrieveStore(Store); // This api is "frozen", as changing it will trigger re-render across all consumers
    // so we link retrieveStore dynamically and manually call notify() on scope change
    return (0, $5FkrB.useMemo)(()=>({
            globalRegistry: globalRegistry,
            retrieveStore: (s)=>retrieveRef.current(s)
        }), [
        globalRegistry
    ]);
}
function $a264dce57acd4232$var$createFunctionContainer(_temp2) {
    let { displayName: displayName, override: override } = _temp2 === void 0 ? {} : _temp2;
    const check = (store)=>override ? store === override.Store : store.containedBy === FunctionContainer;
    function FunctionContainer(props) {
        const { children: children } = props, restProps = $a264dce57acd4232$var$_objectWithoutPropertiesLoose(props, $a264dce57acd4232$var$_excluded);
        const { scope: scope, isGlobal: isGlobal } = restProps, subProps = $a264dce57acd4232$var$_objectWithoutPropertiesLoose(restProps, $a264dce57acd4232$var$_excluded2);
        const ctx = (0, $5FkrB.useContext)((0, $h0ORH.Context));
        const registry = $a264dce57acd4232$var$useRegistry(scope, isGlobal, ctx); // Store props in a ref to avoid re-binding actions when they change and re-rendering all
        // consumers unnecessarily. The update is handled by an effect on the component instead
        const propsRef = (0, $5FkrB.useRef)({
            prev: null,
            next: restProps,
            sub: subProps
        });
        propsRef.current = {
            prev: propsRef.current.next,
            next: restProps,
            sub: subProps // TODO remove on next major
        };
        const [containedStores, getContainedStore] = $a264dce57acd4232$var$useContainedStore(scope, registry, propsRef, check, override); // Use a stable object as is passed as value to context Provider
        const api = $a264dce57acd4232$var$useApi(check, getContainedStore, ctx); // This listens for custom props change, and so we trigger container update actions
        // before the re-render gets to consumers (hence why side effect on render).
        // We do not use React hooks because num of restProps might change and react will throws
        if (!(0, $6Qh0T.default)(propsRef.current.next, propsRef.current.prev)) containedStores.forEach((_ref3)=>{
            let { handlers: handlers } = _ref3;
            handlers.onContainerUpdate == null || handlers.onContainerUpdate(propsRef.current.next, propsRef.current.prev);
        });
         // Every time we add/remove a contained store, we ensure we are subscribed to the updates
        // as an effect to properly handle strict mode
        (0, $5FkrB.useEffect)(()=>{
            containedStores.forEach((containedStore)=>{
                if (!containedStore.unsubscribe) {
                    const unsub = containedStore.storeState.subscribe(()=>containedStore.handlers.onUpdate == null ? void 0 : containedStore.handlers.onUpdate());
                    containedStore.unsubscribe = ()=>{
                        unsub();
                        containedStore.unsubscribe = undefined;
                    };
                }
            });
        }, [
            containedStores,
            containedStores.size
        ]); // We support renderding "bootstrap" containers without children with override API
        // so in this case we call getCS to initialize the store globally asap
        if (override && !containedStores.size && (scope || isGlobal)) getContainedStore(override.Store);
         // This listens for scope change or component unmount, to notify all consumers
        // so all work is done on cleanup
        (0, $5FkrB.useEffect)(()=>{
            return ()=>{
                containedStores.forEach((_ref4, Store)=>{
                    let { storeState: storeState, handlers: handlers, unsubscribe: unsubscribe } = _ref4;
                    // Detatch container from subscription
                    unsubscribe == null || unsubscribe(); // Trigger a forced update on all subscribers as we opted out from context
                    // Some might have already re-rendered naturally, but we "force update" all anyway.
                    // This is sub-optimal as if there are other containers with the same
                    // old scope id we will re-render those too, but still better than context
                    storeState.notify(); // Given unsubscription is handled by useSyncExternalStore, we have no control on when
                    // React decides to do it. So we schedule on next tick to run last
                    Promise.resolve().then(()=>{
                        var _registry$getStore;
                        if (!storeState.listeners().size && // ensure registry has not already created a new store with same scope
                        storeState === ((_registry$getStore = registry.getStore(Store, scope, null)) == null ? void 0 : _registry$getStore.storeState)) {
                            handlers.onDestroy == null || handlers.onDestroy(); // We only delete scoped stores, as global shall persist and local are auto-deleted
                            if (!isGlobal) registry.deleteStore(Store, scope);
                        }
                    });
                }); // no need to reset containedStores as the map is already bound to scope
            };
        }, [
            registry,
            scope,
            isGlobal,
            containedStores
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $h0ORH.Context).Provider, {
            value: api
        }, children);
    }
    FunctionContainer.displayName = displayName || `Container`;
    FunctionContainer.propTypes = {
        children: (0, (/*@__PURE__*/$parcel$interopDefault($8vJ0V))).node,
        scope: (0, (/*@__PURE__*/$parcel$interopDefault($8vJ0V))).string,
        isGlobal: (0, (/*@__PURE__*/$parcel$interopDefault($8vJ0V))).bool
    };
    return FunctionContainer;
}

});
parcelRegister("8vJ0V", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $632422cfaa3e0ff5$var$ReactIs, $632422cfaa3e0ff5$var$throwOnDirectAccess;

// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
module.exports = (parcelRequire("6u0Zy"))();

});
parcelRegister("6u0Zy", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';

var $7XPdg = parcelRequire("7XPdg");
function $4b8650625e933407$var$emptyFunction() {}
function $4b8650625e933407$var$emptyFunctionWithReset() {}
$4b8650625e933407$var$emptyFunctionWithReset.resetWarningCache = $4b8650625e933407$var$emptyFunction;
module.exports = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === $7XPdg) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = 'Invariant Violation';
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bigint: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: $4b8650625e933407$var$emptyFunctionWithReset,
        resetWarningCache: $4b8650625e933407$var$emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

});
parcelRegister("7XPdg", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
var $5cc5c4e4ae50b046$var$ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
module.exports = $5cc5c4e4ae50b046$var$ReactPropTypesSecret;

});




parcelRegister("1uA8D", function(module, exports) {
$parcel$export(module.exports, "createStore", () => $1164a01562ee8563$export$f51a9068ac82ea43);

var $1TyI7 = parcelRequire("1TyI7");
function $1164a01562ee8563$var$createKey(initialState, actions, name) {
    const src = !name ? Object.keys(actions).reduce((acc, k)=>acc + actions[k].toString(), '') : '';
    return [
        name,
        (0, $1TyI7.default)(src + JSON.stringify(initialState))
    ].filter(Boolean).join('__');
}
function $1164a01562ee8563$export$f51a9068ac82ea43(_ref) {
    let { name: name = '', initialState: initialState, actions: actions, containedBy: containedBy, handlers: handlers = {} } = _ref;
    let key;
    return {
        get key () {
            // lazy evaluate key on first access
            return key || (key = $1164a01562ee8563$var$createKey(initialState, actions, name));
        },
        initialState: initialState,
        actions: actions,
        containedBy: containedBy,
        handlers: handlers
    };
}

});
parcelRegister("1TyI7", function(module, exports) {
$parcel$export(module.exports, "default", () => $1615da4702e70caf$export$2e2bcd8739ae039);
/* eslint-disable */ // murmurhash2 via https://github.com/garycourt/murmurhash-js/blob/master/murmurhash2_gc.js
function $1615da4702e70caf$export$2e2bcd8739ae039(str) {
    var l = str.length, h = l ^ l, i = 0, k;
    while(l >= 4){
        k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
        k = (k & 0xffff) * 0x5bd1e995 + (((k >>> 16) * 0x5bd1e995 & 0xffff) << 16);
        k ^= k >>> 24;
        k = (k & 0xffff) * 0x5bd1e995 + (((k >>> 16) * 0x5bd1e995 & 0xffff) << 16);
        h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16) ^ k;
        l -= 4;
        ++i;
    }
    switch(l){
        case 3:
            h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
        case 2:
            h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
        case 1:
            h ^= str.charCodeAt(i) & 0xff;
            h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16);
    }
    h ^= h >>> 13;
    h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16);
    h ^= h >>> 15;
    return (h >>> 0).toString(36);
}

});


parcelRegister("5zmEe", function(module, exports) {
$parcel$export(module.exports, "isNodeEnv", () => isNodeEnv);

var $7V87c = parcelRequire("7V87c");

var $3ZMUU = parcelRequire("3ZMUU");
/**
 * NOTE: In order to avoid circular dependencies, if you add a function to this module and it needs to print something,
 * you must either a) use `console.log` rather than the `debug` singleton, or b) put your function elsewhere.
 */ /**
 * Checks whether we're in the Node.js or Browser environment
 *
 * @returns Answer to given question
 */ function isNodeEnv() {
    // explicitly check for browser bundles as those can be optimized statically
    // by terser/rollup.
    return !(0, $7V87c.isBrowserBundle)() && Object.prototype.toString.call(typeof $3ZMUU !== 'undefined' ? $3ZMUU : 0) === '[object process]';
}
/**
 * Requires a module which is protected against bundler minification.
 *
 * @param request The module path to resolve
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function dynamicRequire(mod, request) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return mod.require(request);
}
/**
 * Helper for dynamically loading module that should work with linked dependencies.
 * The problem is that we _should_ be using `require(require.resolve(moduleName, { paths: [cwd()] }))`
 * However it's _not possible_ to do that with Webpack, as it has to know all the dependencies during
 * build time. `require.resolve` is also not available in any other way, so we cannot create,
 * a fake helper like we do with `dynamicRequire`.
 *
 * We always prefer to use local package, thus the value is not returned early from each `try/catch` block.
 * That is to mimic the behavior of `require.resolve` exactly.
 *
 * @param moduleName module name to require
 * @param existingModule module to use for requiring
 * @returns possibly required module
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function loadModule(moduleName, existingModule = module) {
    let mod;
    try {
        mod = dynamicRequire(existingModule, moduleName);
    } catch  {
    // no-empty
    }
    if (!mod) try {
        const { cwd } = dynamicRequire(existingModule, 'process');
        mod = dynamicRequire(existingModule, `${cwd()}/node_modules/${moduleName}`);
    } catch  {
    // no-empty
    }
    return mod;
}

});
parcelRegister("7V87c", function(module, exports) {
$parcel$export(module.exports, "isBrowserBundle", () => $5c4426c0b9a98751$export$2928c40372e623c0);
$parcel$export(module.exports, "getSDKSource", () => $5c4426c0b9a98751$export$8ad33f488b1ab046);
/*
 * This module exists for optimizations in the build process through rollup and terser.  We define some global
 * constants, which can be overridden during build. By guarding certain pieces of code with functions that return these
 * constants, we can control whether or not they appear in the final bundle. (Any code guarded by a false condition will
 * never run, and will hence be dropped during treeshaking.) The two primary uses for this are stripping out calls to
 * `debug` and preventing node-related code from appearing in browser bundles.
 *
 * Attention:
 * This file should not be used to define constants/flags that are intended to be used for tree-shaking conducted by
 * users. These flags should live in their respective packages, as we identified user tooling (specifically webpack)
 * having issues tree-shaking these constants across package boundaries.
 * An example for this is the __SENTRY_DEBUG__ constant. It is declared in each package individually because we want
 * users to be able to shake away expressions that it guards.
 */ /**
 * Figures out if we're building a browser bundle.
 *
 * @returns true if this is a browser bundle build.
 */ function $5c4426c0b9a98751$export$2928c40372e623c0() {
    return typeof __SENTRY_BROWSER_BUNDLE__ !== 'undefined' && !!__SENTRY_BROWSER_BUNDLE__;
}
/**
 * Get source of SDK.
 */ function $5c4426c0b9a98751$export$8ad33f488b1ab046() {
    // This comment is used to identify this line in the CDN bundle build step and replace this with "return 'cdn';"
    /* __SENTRY_SDK_SOURCE__ */ return 'npm';
}

});


parcelRegister("eVb4V", function(module, exports) {
$parcel$export(module.exports, "default", () => $adcefb868cf2fc9d$export$2e2bcd8739ae039);
/**
 * An empty function which does nothing.
 */ function $adcefb868cf2fc9d$export$2e2bcd8739ae039() {}

});

parcelRegister("dLGML", function(module, exports) {
$parcel$export(module.exports, "useCallbackOne", () => $a060da77483cc5d3$export$33752cf3ee811995);

var $5FkrB = parcelRequire("5FkrB");
function $a060da77483cc5d3$var$areInputsEqual(newInputs, lastInputs) {
    if (newInputs.length !== lastInputs.length) return false;
    for(var i = 0; i < newInputs.length; i++){
        if (newInputs[i] !== lastInputs[i]) return false;
    }
    return true;
}
function $a060da77483cc5d3$export$b6feb8998cd9b342(getResult, inputs) {
    var initial = (0, $5FkrB.useState)(function() {
        return {
            inputs: inputs,
            result: getResult()
        };
    })[0];
    var isFirstRun = (0, $5FkrB.useRef)(true);
    var committed = (0, $5FkrB.useRef)(initial);
    var useCache = isFirstRun.current || Boolean(inputs && committed.current.inputs && $a060da77483cc5d3$var$areInputsEqual(inputs, committed.current.inputs));
    var cache = useCache ? committed.current : {
        inputs: inputs,
        result: getResult()
    };
    (0, $5FkrB.useEffect)(function() {
        isFirstRun.current = false;
        committed.current = cache;
    }, [
        cache
    ]);
    return cache.result;
}
function $a060da77483cc5d3$export$33752cf3ee811995(callback, inputs) {
    return $a060da77483cc5d3$export$b6feb8998cd9b342(function() {
        return callback;
    }, inputs);
}
var $a060da77483cc5d3$export$1538c33de8887b59 = $a060da77483cc5d3$export$b6feb8998cd9b342;
var $a060da77483cc5d3$export$35808ee640e87ca7 = $a060da77483cc5d3$export$33752cf3ee811995;

});

parcelRegister("iyyOp", function(module, exports) {
$parcel$export(module.exports, "default", () => $d82667e77467cbe0$export$2e2bcd8739ae039);

var $46PbR = parcelRequire("46PbR");
var $d82667e77467cbe0$export$2e2bcd8739ae039 = (0, $46PbR.default);

});
parcelRegister("46PbR", function(module, exports) {
$parcel$export(module.exports, "default", () => $2fdf6e45620f1c96$export$2e2bcd8739ae039);

var $5FkrB = parcelRequire("5FkrB");
var $2fdf6e45620f1c96$var$AnalyticsNextContext = (0, $5FkrB.createContext)({
    getAtlaskitAnalyticsContext: function() {
        return [];
    },
    getAtlaskitAnalyticsEventHandlers: function() {
        return [];
    }
});
var $2fdf6e45620f1c96$export$2e2bcd8739ae039 = $2fdf6e45620f1c96$var$AnalyticsNextContext;

});


parcelRegister("gpUQB", function(module, exports) {
$parcel$export(module.exports, "default", () => $bf3b13d9d73de104$export$2e2bcd8739ae039);

var $5FkrB = parcelRequire("5FkrB");
function $bf3b13d9d73de104$export$2e2bcd8739ae039(ref, autoFocus) {
    var initialMount = (0, $5FkrB.useRef)(true);
    (0, $5FkrB.useEffect)(function() {
        if (ref && initialMount.current && autoFocus && ref.current) ref.current.focus();
        initialMount.current = false;
    }, [
        autoFocus,
        ref
    ]);
}

});

parcelRegister("eYQvF", function(module, exports) {
$parcel$export(module.exports, "default", () => $ae7f66a126864790$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5FkrB = parcelRequire("5FkrB");

var $74Zh5 = parcelRequire("74Zh5");
var $ae7f66a126864790$var$BORDER_WIDTH = 2;
var $ae7f66a126864790$var$baseFocusOutsideStyles = (0, $74Zh5.css)({
    outline: "var(--ds-border-width-focused, 2px)".concat(" solid ", "var(--ds-border-focused, #2684FF)"),
    outlineOffset: $ae7f66a126864790$var$BORDER_WIDTH
});
var $ae7f66a126864790$var$baseInsetStyles = (0, $74Zh5.css)({
    outlineColor: "var(--ds-border-focused, #2684FF)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    outlineOffset: -$ae7f66a126864790$var$BORDER_WIDTH,
    outlineStyle: 'solid',
    outlineWidth: "var(--ds-border-width-focused, 2px)"
});
var $ae7f66a126864790$var$focusRingStyles = (0, $74Zh5.css)({
    // Focus styles used when :focus-visible isn't supported
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
    '&:focus': $ae7f66a126864790$var$baseFocusOutsideStyles,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
    '&:focus-visible': $ae7f66a126864790$var$baseFocusOutsideStyles,
    // Remove default focus styles for mouse interactions if :focus-visible is supported
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
    '&:focus:not(:focus-visible)': {
        outline: 'none'
    },
    '@media screen and (forced-colors: active), screen and (-ms-high-contrast: active)': {
        '&:focus-visible': {
            outline: "var(--ds-border-width, 1px)".concat(" solid")
        }
    }
});
var $ae7f66a126864790$var$insetFocusRingStyles = (0, $74Zh5.css)({
    // Focus styles used when :focus-visible isn't supported
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
    '&:focus': $ae7f66a126864790$var$baseInsetStyles,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
    '&:focus-visible': $ae7f66a126864790$var$baseInsetStyles,
    // Remove default focus styles for mouse interactions if :focus-visible is supported
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
    '&:focus:not(:focus-visible)': {
        outline: 'none'
    },
    '@media screen and (forced-colors: active), screen and (-ms-high-contrast: active)': {
        '&:focus-visible': {
            outline: "var(--ds-border-width, 1px)".concat(" solid"),
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
            outlineOffset: '-1px'
        }
    }
});
/**
 * __Focus ring__
 *
 * A focus ring visually indicates the currently focused item.
 *
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/focus-ring)
 *
 * @example
 * ```jsx
 * import FocusRing from '@atlaskit/focus-ring';
 *
 * const InteractiveComponent = () => (
 *   <FocusRing>
 *     <button type="button">Hello</button>
 *   </FocusRing>
 * )
 * ```
 */ var $ae7f66a126864790$var$FocusRing = /*#__PURE__*/ (0, $5FkrB.memo)(function(_ref) {
    var children = _ref.children, isInset = _ref.isInset, focus = _ref.focus;
    var controlledStyles = isInset ? $ae7f66a126864790$var$baseInsetStyles : $ae7f66a126864790$var$baseFocusOutsideStyles;
    var uncontrolledStyles = isInset ? $ae7f66a126864790$var$insetFocusRingStyles : $ae7f66a126864790$var$focusRingStyles;
    var focusCls = typeof focus === 'undefined' ? uncontrolledStyles : focus === 'on' && controlledStyles;
    return (0, $74Zh5.jsx)((0, $74Zh5.ClassNames), null, function(_ref2) {
        var css = _ref2.css, cx = _ref2.cx;
        return (0, $5FkrB.Children).only(// This may look unwieldy but means we skip applying styles / cloning if no className is applicable
        focusCls ? /*#__PURE__*/ // eslint-disable-next-line @repo/internal/react/no-clone-element
        (0, $5FkrB.cloneElement)(children, {
            className: cx([
                css(focusCls),
                children.props.className
            ])
        }) : children);
    });
});
$ae7f66a126864790$var$FocusRing.displayName = 'FocusRing';
var $ae7f66a126864790$export$2e2bcd8739ae039 = $ae7f66a126864790$var$FocusRing;

});

parcelRegister("lsgol", function(module, exports) {
$parcel$export(module.exports, "Popper", () => $f9e8ed8665cc0109$export$badac9ada3a0bdf9);

var $5FkrB = parcelRequire("5FkrB");

var $hvYLl = parcelRequire("hvYLl");

var $728oi = parcelRequire("728oi");

var $15fNX = parcelRequire("15fNX");
var $f9e8ed8665cc0109$var$NOOP = function NOOP() {
    return void 0;
};
var $f9e8ed8665cc0109$var$NOOP_PROMISE = function NOOP_PROMISE() {
    return Promise.resolve(null);
};
var $f9e8ed8665cc0109$var$EMPTY_MODIFIERS = [];
function $f9e8ed8665cc0109$export$badac9ada3a0bdf9(_ref) {
    var _ref$placement = _ref.placement, placement = _ref$placement === void 0 ? 'bottom' : _ref$placement, _ref$strategy = _ref.strategy, strategy = _ref$strategy === void 0 ? 'absolute' : _ref$strategy, _ref$modifiers = _ref.modifiers, modifiers = _ref$modifiers === void 0 ? $f9e8ed8665cc0109$var$EMPTY_MODIFIERS : _ref$modifiers, referenceElement = _ref.referenceElement, onFirstUpdate = _ref.onFirstUpdate, innerRef = _ref.innerRef, children = _ref.children;
    var referenceNode = $5FkrB.useContext((0, $hvYLl.ManagerReferenceNodeContext));
    var _React$useState = $5FkrB.useState(null), popperElement = _React$useState[0], setPopperElement = _React$useState[1];
    var _React$useState2 = $5FkrB.useState(null), arrowElement = _React$useState2[0], setArrowElement = _React$useState2[1];
    $5FkrB.useEffect(function() {
        (0, $728oi.setRef)(innerRef, popperElement);
    }, [
        innerRef,
        popperElement
    ]);
    var options = $5FkrB.useMemo(function() {
        return {
            placement: placement,
            strategy: strategy,
            onFirstUpdate: onFirstUpdate,
            modifiers: [].concat(modifiers, [
                {
                    name: 'arrow',
                    enabled: arrowElement != null,
                    options: {
                        element: arrowElement
                    }
                }
            ])
        };
    }, [
        placement,
        strategy,
        onFirstUpdate,
        modifiers,
        arrowElement
    ]);
    var _usePopper = (0, $15fNX.usePopper)(referenceElement || referenceNode, popperElement, options), state = _usePopper.state, styles = _usePopper.styles, forceUpdate = _usePopper.forceUpdate, update = _usePopper.update;
    var childrenProps = $5FkrB.useMemo(function() {
        return {
            ref: setPopperElement,
            style: styles.popper,
            placement: state ? state.placement : placement,
            hasPopperEscaped: state && state.modifiersData.hide ? state.modifiersData.hide.hasPopperEscaped : null,
            isReferenceHidden: state && state.modifiersData.hide ? state.modifiersData.hide.isReferenceHidden : null,
            arrowProps: {
                style: styles.arrow,
                ref: setArrowElement
            },
            forceUpdate: forceUpdate || $f9e8ed8665cc0109$var$NOOP,
            update: update || $f9e8ed8665cc0109$var$NOOP_PROMISE
        };
    }, [
        setPopperElement,
        setArrowElement,
        placement,
        state,
        styles,
        update,
        forceUpdate
    ]);
    return (0, $728oi.unwrapArray)(children)(childrenProps);
}

});
parcelRegister("hvYLl", function(module, exports) {
$parcel$export(module.exports, "ManagerReferenceNodeContext", () => $cc0477161a7a3c78$export$3dbd3405086fec7b);
$parcel$export(module.exports, "ManagerReferenceNodeSetterContext", () => $cc0477161a7a3c78$export$cbabb21c2529b130);
$parcel$export(module.exports, "Manager", () => $cc0477161a7a3c78$export$d0d38e7dec7a1a61);

var $5FkrB = parcelRequire("5FkrB");
var $cc0477161a7a3c78$export$3dbd3405086fec7b = $5FkrB.createContext();
var $cc0477161a7a3c78$export$cbabb21c2529b130 = $5FkrB.createContext();
function $cc0477161a7a3c78$export$d0d38e7dec7a1a61(_ref) {
    var children = _ref.children;
    var _React$useState = $5FkrB.useState(null), referenceNode = _React$useState[0], setReferenceNode = _React$useState[1];
    var hasUnmounted = $5FkrB.useRef(false);
    $5FkrB.useEffect(function() {
        return function() {
            hasUnmounted.current = true;
        };
    }, []);
    var handleSetReferenceNode = $5FkrB.useCallback(function(node) {
        if (!hasUnmounted.current) setReferenceNode(node);
    }, []);
    return /*#__PURE__*/ $5FkrB.createElement($cc0477161a7a3c78$export$3dbd3405086fec7b.Provider, {
        value: referenceNode
    }, /*#__PURE__*/ $5FkrB.createElement($cc0477161a7a3c78$export$cbabb21c2529b130.Provider, {
        value: handleSetReferenceNode
    }, children));
}

});

parcelRegister("728oi", function(module, exports) {
$parcel$export(module.exports, "unwrapArray", () => $51ef3a8e2c42379b$export$f52c55943429c8b6);
$parcel$export(module.exports, "safeInvoke", () => $51ef3a8e2c42379b$export$3dfa7c28635fe028);
$parcel$export(module.exports, "setRef", () => $51ef3a8e2c42379b$export$4bb192c7cacf928f);
$parcel$export(module.exports, "fromEntries", () => $51ef3a8e2c42379b$export$5150077fc2e7c662);
$parcel$export(module.exports, "useIsomorphicLayoutEffect", () => $51ef3a8e2c42379b$export$700979bc83e7db82);

var $5FkrB = parcelRequire("5FkrB");
var $51ef3a8e2c42379b$export$f52c55943429c8b6 = function unwrapArray(arg) {
    return Array.isArray(arg) ? arg[0] : arg;
};
var $51ef3a8e2c42379b$export$3dfa7c28635fe028 = function safeInvoke(fn) {
    if (typeof fn === 'function') {
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
        return fn.apply(void 0, args);
    }
};
var $51ef3a8e2c42379b$export$4bb192c7cacf928f = function setRef(ref, node) {
    // if its a function call it
    if (typeof ref === 'function') return $51ef3a8e2c42379b$export$3dfa7c28635fe028(ref, node);
    else if (ref != null) ref.current = node;
};
var $51ef3a8e2c42379b$export$5150077fc2e7c662 = function fromEntries(entries) {
    return entries.reduce(function(acc, _ref) {
        var key = _ref[0], value = _ref[1];
        acc[key] = value;
        return acc;
    }, {});
};
var $51ef3a8e2c42379b$export$700979bc83e7db82 = typeof window !== 'undefined' && window.document && window.document.createElement ? $5FkrB.useLayoutEffect : $5FkrB.useEffect;

});

parcelRegister("15fNX", function(module, exports) {
$parcel$export(module.exports, "usePopper", () => $0ca28497a8a04ea7$export$f4d5bf230a36dd6e);

var $5FkrB = parcelRequire("5FkrB");

var $aLeHs = parcelRequire("aLeHs");

var $hTJWj = parcelRequire("hTJWj");

var $dcrmD = parcelRequire("dcrmD");

var $728oi = parcelRequire("728oi");
var $0ca28497a8a04ea7$var$EMPTY_MODIFIERS = [];
var $0ca28497a8a04ea7$export$f4d5bf230a36dd6e = function usePopper(referenceElement, popperElement, options) {
    if (options === void 0) options = {};
    var prevOptions = $5FkrB.useRef(null);
    var optionsWithDefaults = {
        onFirstUpdate: options.onFirstUpdate,
        placement: options.placement || 'bottom',
        strategy: options.strategy || 'absolute',
        modifiers: options.modifiers || $0ca28497a8a04ea7$var$EMPTY_MODIFIERS
    };
    var _React$useState = $5FkrB.useState({
        styles: {
            popper: {
                position: optionsWithDefaults.strategy,
                left: '0',
                top: '0'
            },
            arrow: {
                position: 'absolute'
            }
        },
        attributes: {}
    }), state = _React$useState[0], setState = _React$useState[1];
    var updateStateModifier = $5FkrB.useMemo(function() {
        return {
            name: 'updateState',
            enabled: true,
            phase: 'write',
            fn: function fn(_ref) {
                var state = _ref.state;
                var elements = Object.keys(state.elements);
                $aLeHs.flushSync(function() {
                    setState({
                        styles: (0, $728oi.fromEntries)(elements.map(function(element) {
                            return [
                                element,
                                state.styles[element] || {}
                            ];
                        })),
                        attributes: (0, $728oi.fromEntries)(elements.map(function(element) {
                            return [
                                element,
                                state.attributes[element]
                            ];
                        }))
                    });
                });
            },
            requires: [
                'computeStyles'
            ]
        };
    }, []);
    var popperOptions = $5FkrB.useMemo(function() {
        var newOptions = {
            onFirstUpdate: optionsWithDefaults.onFirstUpdate,
            placement: optionsWithDefaults.placement,
            strategy: optionsWithDefaults.strategy,
            modifiers: [].concat(optionsWithDefaults.modifiers, [
                updateStateModifier,
                {
                    name: 'applyStyles',
                    enabled: false
                }
            ])
        };
        if ((0, (/*@__PURE__*/$parcel$interopDefault($dcrmD)))(prevOptions.current, newOptions)) return prevOptions.current || newOptions;
        else {
            prevOptions.current = newOptions;
            return newOptions;
        }
    }, [
        optionsWithDefaults.onFirstUpdate,
        optionsWithDefaults.placement,
        optionsWithDefaults.strategy,
        optionsWithDefaults.modifiers,
        updateStateModifier
    ]);
    var popperInstanceRef = $5FkrB.useRef();
    (0, $728oi.useIsomorphicLayoutEffect)(function() {
        if (popperInstanceRef.current) popperInstanceRef.current.setOptions(popperOptions);
    }, [
        popperOptions
    ]);
    (0, $728oi.useIsomorphicLayoutEffect)(function() {
        if (referenceElement == null || popperElement == null) return;
        var createPopper = options.createPopper || (0, $hTJWj.createPopper);
        var popperInstance = createPopper(referenceElement, popperElement, popperOptions);
        popperInstanceRef.current = popperInstance;
        return function() {
            popperInstance.destroy();
            popperInstanceRef.current = null;
        };
    }, [
        referenceElement,
        popperElement,
        options.createPopper
    ]);
    return {
        state: popperInstanceRef.current ? popperInstanceRef.current.state : null,
        styles: state.styles,
        attributes: state.attributes,
        update: popperInstanceRef.current ? popperInstanceRef.current.update : null,
        forceUpdate: popperInstanceRef.current ? popperInstanceRef.current.forceUpdate : null
    };
};

});
parcelRegister("hTJWj", function(module, exports) {
$parcel$export(module.exports, "createPopper", () => $d07b3555e5780154$export$8f7491d57c8f97a9);

var $gqwtB = parcelRequire("gqwtB");

var $AYfmq = parcelRequire("AYfmq");

var $jiyhn = parcelRequire("jiyhn");

var $8xQBR = parcelRequire("8xQBR");

var $95K1c = parcelRequire("95K1c");

var $lexRm = parcelRequire("lexRm");

var $euI62 = parcelRequire("euI62");

var $hlR4d = parcelRequire("hlR4d");

var $1ISmI = parcelRequire("1ISmI");

var $hoRGB = parcelRequire("hoRGB");


var $d07b3555e5780154$export$d34966752335dd47 = [
    (0, $AYfmq.default),
    (0, $jiyhn.default),
    (0, $8xQBR.default),
    (0, $95K1c.default),
    (0, $lexRm.default),
    (0, $euI62.default),
    (0, $hlR4d.default),
    (0, $1ISmI.default),
    (0, $hoRGB.default)
];
var $d07b3555e5780154$export$8f7491d57c8f97a9 = /*#__PURE__*/ (0, $gqwtB.popperGenerator)({
    defaultModifiers: $d07b3555e5780154$export$d34966752335dd47
}); // eslint-disable-next-line import/no-unused-modules

});
parcelRegister("gqwtB", function(module, exports) {
$parcel$export(module.exports, "popperGenerator", () => $bf58442f71e0a59e$export$ed5e13716264f202);

var $4b52x = parcelRequire("4b52x");

var $cI2gV = parcelRequire("cI2gV");

var $h2klf = parcelRequire("h2klf");

var $b40rk = parcelRequire("b40rk");

var $aUEAQ = parcelRequire("aUEAQ");

var $jp2vh = parcelRequire("jp2vh");

var $45WlR = parcelRequire("45WlR");


var $lxsPK = parcelRequire("lxsPK");
var $bf58442f71e0a59e$var$DEFAULT_OPTIONS = {
    placement: 'bottom',
    modifiers: [],
    strategy: 'absolute'
};
function $bf58442f71e0a59e$var$areValidElements() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return !args.some(function(element) {
        return !(element && typeof element.getBoundingClientRect === 'function');
    });
}
function $bf58442f71e0a59e$export$ed5e13716264f202(generatorOptions) {
    if (generatorOptions === void 0) generatorOptions = {};
    var _generatorOptions = generatorOptions, _generatorOptions$def = _generatorOptions.defaultModifiers, defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def, _generatorOptions$def2 = _generatorOptions.defaultOptions, defaultOptions = _generatorOptions$def2 === void 0 ? $bf58442f71e0a59e$var$DEFAULT_OPTIONS : _generatorOptions$def2;
    return function createPopper(reference, popper, options) {
        if (options === void 0) options = defaultOptions;
        var state = {
            placement: 'bottom',
            orderedModifiers: [],
            options: Object.assign({}, $bf58442f71e0a59e$var$DEFAULT_OPTIONS, defaultOptions),
            modifiersData: {},
            elements: {
                reference: reference,
                popper: popper
            },
            attributes: {},
            styles: {}
        };
        var effectCleanupFns = [];
        var isDestroyed = false;
        var instance = {
            state: state,
            setOptions: function setOptions(setOptionsAction) {
                var options = typeof setOptionsAction === 'function' ? setOptionsAction(state.options) : setOptionsAction;
                cleanupModifierEffects();
                state.options = Object.assign({}, defaultOptions, state.options, options);
                state.scrollParents = {
                    reference: (0, $lxsPK.isElement)(reference) ? (0, $h2klf.default)(reference) : reference.contextElement ? (0, $h2klf.default)(reference.contextElement) : [],
                    popper: (0, $h2klf.default)(popper)
                }; // Orders the modifiers based on their dependencies and `phase`
                // properties
                var orderedModifiers = (0, $aUEAQ.default)((0, $45WlR.default)([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers
                state.orderedModifiers = orderedModifiers.filter(function(m) {
                    return m.enabled;
                });
                runModifierEffects();
                return instance.update();
            },
            // Sync update – it will always be executed, even if not necessary. This
            // is useful for low frequency updates where sync behavior simplifies the
            // logic.
            // For high frequency updates (e.g. `resize` and `scroll` events), always
            // prefer the async Popper#update method
            forceUpdate: function forceUpdate() {
                if (isDestroyed) return;
                var _state$elements = state.elements, reference = _state$elements.reference, popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
                // anymore
                if (!$bf58442f71e0a59e$var$areValidElements(reference, popper)) return;
                 // Store the reference and popper rects to be read by modifiers
                state.rects = {
                    reference: (0, $4b52x.default)(reference, (0, $b40rk.default)(popper), state.options.strategy === 'fixed'),
                    popper: (0, $cI2gV.default)(popper)
                }; // Modifiers have the ability to reset the current update cycle. The
                // most common use case for this is the `flip` modifier changing the
                // placement, which then needs to re-run all the modifiers, because the
                // logic was previously ran for the previous placement and is therefore
                // stale/incorrect
                state.reset = false;
                state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
                // is filled with the initial data specified by the modifier. This means
                // it doesn't persist and is fresh on each update.
                // To ensure persistent data, use `${name}#persistent`
                state.orderedModifiers.forEach(function(modifier) {
                    return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
                });
                for(var index = 0; index < state.orderedModifiers.length; index++){
                    if (state.reset === true) {
                        state.reset = false;
                        index = -1;
                        continue;
                    }
                    var _state$orderedModifie = state.orderedModifiers[index], fn = _state$orderedModifie.fn, _state$orderedModifie2 = _state$orderedModifie.options, _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2, name = _state$orderedModifie.name;
                    if (typeof fn === 'function') state = fn({
                        state: state,
                        options: _options,
                        name: name,
                        instance: instance
                    }) || state;
                }
            },
            // Async and optimistically optimized update – it will not be executed if
            // not necessary (debounced to run at most once-per-tick)
            update: (0, $jp2vh.default)(function() {
                return new Promise(function(resolve) {
                    instance.forceUpdate();
                    resolve(state);
                });
            }),
            destroy: function destroy() {
                cleanupModifierEffects();
                isDestroyed = true;
            }
        };
        if (!$bf58442f71e0a59e$var$areValidElements(reference, popper)) return instance;
        instance.setOptions(options).then(function(state) {
            if (!isDestroyed && options.onFirstUpdate) options.onFirstUpdate(state);
        }); // Modifiers have the ability to execute arbitrary code before the first
        // update cycle runs. They will be executed in the same order as the update
        // cycle. This is useful when a modifier adds some persistent data that
        // other modifiers need to use, but the modifier is run after the dependent
        // one.
        function runModifierEffects() {
            state.orderedModifiers.forEach(function(_ref) {
                var name = _ref.name, _ref$options = _ref.options, options = _ref$options === void 0 ? {} : _ref$options, effect = _ref.effect;
                if (typeof effect === 'function') {
                    var cleanupFn = effect({
                        state: state,
                        name: name,
                        instance: instance,
                        options: options
                    });
                    var noopFn = function noopFn() {};
                    effectCleanupFns.push(cleanupFn || noopFn);
                }
            });
        }
        function cleanupModifierEffects() {
            effectCleanupFns.forEach(function(fn) {
                return fn();
            });
            effectCleanupFns = [];
        }
        return instance;
    };
}
var $bf58442f71e0a59e$export$8f7491d57c8f97a9 = /*#__PURE__*/ $bf58442f71e0a59e$export$ed5e13716264f202(); // eslint-disable-next-line import/no-unused-modules

});
parcelRegister("4b52x", function(module, exports) {
$parcel$export(module.exports, "default", () => $30ac1953654104c9$export$2e2bcd8739ae039);

var $5SX2j = parcelRequire("5SX2j");

var $hMsdL = parcelRequire("hMsdL");

var $bFqu3 = parcelRequire("bFqu3");

var $lxsPK = parcelRequire("lxsPK");

var $8iNOc = parcelRequire("8iNOc");

var $2vuXD = parcelRequire("2vuXD");

var $jCpkw = parcelRequire("jCpkw");

var $kDvUD = parcelRequire("kDvUD");
function $30ac1953654104c9$var$isElementScaled(element) {
    var rect = element.getBoundingClientRect();
    var scaleX = (0, $kDvUD.round)(rect.width) / element.offsetWidth || 1;
    var scaleY = (0, $kDvUD.round)(rect.height) / element.offsetHeight || 1;
    return scaleX !== 1 || scaleY !== 1;
} // Returns the composite rect of an element relative to its offsetParent.
function $30ac1953654104c9$export$2e2bcd8739ae039(elementOrVirtualElement, offsetParent, isFixed) {
    if (isFixed === void 0) isFixed = false;
    var isOffsetParentAnElement = (0, $lxsPK.isHTMLElement)(offsetParent);
    var offsetParentIsScaled = (0, $lxsPK.isHTMLElement)(offsetParent) && $30ac1953654104c9$var$isElementScaled(offsetParent);
    var documentElement = (0, $2vuXD.default)(offsetParent);
    var rect = (0, $5SX2j.default)(elementOrVirtualElement, offsetParentIsScaled, isFixed);
    var scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    var offsets = {
        x: 0,
        y: 0
    };
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $bFqu3.default)(offsetParent) !== 'body' || // https://github.com/popperjs/popper-core/issues/1078
        (0, $jCpkw.default)(documentElement)) scroll = (0, $hMsdL.default)(offsetParent);
        if ((0, $lxsPK.isHTMLElement)(offsetParent)) {
            offsets = (0, $5SX2j.default)(offsetParent, true);
            offsets.x += offsetParent.clientLeft;
            offsets.y += offsetParent.clientTop;
        } else if (documentElement) offsets.x = (0, $8iNOc.default)(documentElement);
    }
    return {
        x: rect.left + scroll.scrollLeft - offsets.x,
        y: rect.top + scroll.scrollTop - offsets.y,
        width: rect.width,
        height: rect.height
    };
}

});
parcelRegister("5SX2j", function(module, exports) {
$parcel$export(module.exports, "default", () => $448fca4b88e71bae$export$2e2bcd8739ae039);

var $lxsPK = parcelRequire("lxsPK");

var $kDvUD = parcelRequire("kDvUD");

var $jqcF0 = parcelRequire("jqcF0");

var $gNwrE = parcelRequire("gNwrE");
function $448fca4b88e71bae$export$2e2bcd8739ae039(element, includeScale, isFixedStrategy) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    var clientRect = element.getBoundingClientRect();
    var scaleX = 1;
    var scaleY = 1;
    if (includeScale && (0, $lxsPK.isHTMLElement)(element)) {
        scaleX = element.offsetWidth > 0 ? (0, $kDvUD.round)(clientRect.width) / element.offsetWidth || 1 : 1;
        scaleY = element.offsetHeight > 0 ? (0, $kDvUD.round)(clientRect.height) / element.offsetHeight || 1 : 1;
    }
    var _ref = (0, $lxsPK.isElement)(element) ? (0, $jqcF0.default)(element) : window, visualViewport = _ref.visualViewport;
    var addVisualOffsets = !(0, $gNwrE.default)() && isFixedStrategy;
    var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
    var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
    var width = clientRect.width / scaleX;
    var height = clientRect.height / scaleY;
    return {
        width: width,
        height: height,
        top: y,
        right: x + width,
        bottom: y + height,
        left: x,
        x: x,
        y: y
    };
}

});
parcelRegister("lxsPK", function(module, exports) {
$parcel$export(module.exports, "isElement", () => $fae30bcfba640a43$export$45a5e7f76e0caa8d);
$parcel$export(module.exports, "isHTMLElement", () => $fae30bcfba640a43$export$1b3bfaa9684536aa);
$parcel$export(module.exports, "isShadowRoot", () => $fae30bcfba640a43$export$af51f0f06c0f328a);

var $jqcF0 = parcelRequire("jqcF0");
function $fae30bcfba640a43$export$45a5e7f76e0caa8d(node) {
    var OwnElement = (0, $jqcF0.default)(node).Element;
    return node instanceof OwnElement || node instanceof Element;
}
function $fae30bcfba640a43$export$1b3bfaa9684536aa(node) {
    var OwnElement = (0, $jqcF0.default)(node).HTMLElement;
    return node instanceof OwnElement || node instanceof HTMLElement;
}
function $fae30bcfba640a43$export$af51f0f06c0f328a(node) {
    // IE 11 has no ShadowRoot
    if (typeof ShadowRoot === 'undefined') return false;
    var OwnElement = (0, $jqcF0.default)(node).ShadowRoot;
    return node instanceof OwnElement || node instanceof ShadowRoot;
}

});
parcelRegister("jqcF0", function(module, exports) {
$parcel$export(module.exports, "default", () => $e23a441bbff67a45$export$2e2bcd8739ae039);
function $e23a441bbff67a45$export$2e2bcd8739ae039(node) {
    if (node == null) return window;
    if (node.toString() !== '[object Window]') {
        var ownerDocument = node.ownerDocument;
        return ownerDocument ? ownerDocument.defaultView || window : window;
    }
    return node;
}

});


parcelRegister("kDvUD", function(module, exports) {
$parcel$export(module.exports, "max", () => $f060345502b6b7d0$export$8960430cfd85939f);
$parcel$export(module.exports, "min", () => $f060345502b6b7d0$export$96ec731ed4dcb222);
$parcel$export(module.exports, "round", () => $f060345502b6b7d0$export$2077e0241d6afd3c);
var $f060345502b6b7d0$export$8960430cfd85939f = Math.max;
var $f060345502b6b7d0$export$96ec731ed4dcb222 = Math.min;
var $f060345502b6b7d0$export$2077e0241d6afd3c = Math.round;

});

parcelRegister("gNwrE", function(module, exports) {
$parcel$export(module.exports, "default", () => $c3aa63da5ec3538b$export$2e2bcd8739ae039);

var $fttMi = parcelRequire("fttMi");
function $c3aa63da5ec3538b$export$2e2bcd8739ae039() {
    return !/^((?!chrome|android).)*safari/i.test((0, $fttMi.default)());
}

});
parcelRegister("fttMi", function(module, exports) {
$parcel$export(module.exports, "default", () => $b440a9b7db95e092$export$2e2bcd8739ae039);
function $b440a9b7db95e092$export$2e2bcd8739ae039() {
    var uaData = navigator.userAgentData;
    if (uaData != null && uaData.brands && Array.isArray(uaData.brands)) return uaData.brands.map(function(item) {
        return item.brand + "/" + item.version;
    }).join(' ');
    return navigator.userAgent;
}

});



parcelRegister("hMsdL", function(module, exports) {
$parcel$export(module.exports, "default", () => $cf1ccf76c8705f19$export$2e2bcd8739ae039);

var $9U1SB = parcelRequire("9U1SB");

var $jqcF0 = parcelRequire("jqcF0");

var $lxsPK = parcelRequire("lxsPK");

var $lK3r3 = parcelRequire("lK3r3");
function $cf1ccf76c8705f19$export$2e2bcd8739ae039(node) {
    if (node === (0, $jqcF0.default)(node) || !(0, $lxsPK.isHTMLElement)(node)) return (0, $9U1SB.default)(node);
    else return (0, $lK3r3.default)(node);
}

});
parcelRegister("9U1SB", function(module, exports) {
$parcel$export(module.exports, "default", () => $735acd4717b89a9b$export$2e2bcd8739ae039);

var $jqcF0 = parcelRequire("jqcF0");
function $735acd4717b89a9b$export$2e2bcd8739ae039(node) {
    var win = (0, $jqcF0.default)(node);
    var scrollLeft = win.pageXOffset;
    var scrollTop = win.pageYOffset;
    return {
        scrollLeft: scrollLeft,
        scrollTop: scrollTop
    };
}

});

parcelRegister("lK3r3", function(module, exports) {
$parcel$export(module.exports, "default", () => $fd408f0f7fc6f904$export$2e2bcd8739ae039);
function $fd408f0f7fc6f904$export$2e2bcd8739ae039(element) {
    return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
}

});


parcelRegister("bFqu3", function(module, exports) {
$parcel$export(module.exports, "default", () => $87e8112f115e0ba7$export$2e2bcd8739ae039);
function $87e8112f115e0ba7$export$2e2bcd8739ae039(element) {
    return element ? (element.nodeName || '').toLowerCase() : null;
}

});

parcelRegister("8iNOc", function(module, exports) {
$parcel$export(module.exports, "default", () => $60b6a422aa1d7c27$export$2e2bcd8739ae039);

var $5SX2j = parcelRequire("5SX2j");

var $2vuXD = parcelRequire("2vuXD");

var $9U1SB = parcelRequire("9U1SB");
function $60b6a422aa1d7c27$export$2e2bcd8739ae039(element) {
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    // Popper 1 is broken in this case and never had a bug report so let's assume
    // it's not an issue. I don't think anyone ever specifies width on <html>
    // anyway.
    // Browsers where the left scrollbar doesn't cause an issue report `0` for
    // this (e.g. Edge 2019, IE11, Safari)
    return (0, $5SX2j.default)((0, $2vuXD.default)(element)).left + (0, $9U1SB.default)(element).scrollLeft;
}

});
parcelRegister("2vuXD", function(module, exports) {
$parcel$export(module.exports, "default", () => $1d367e31a7efd199$export$2e2bcd8739ae039);

var $lxsPK = parcelRequire("lxsPK");
function $1d367e31a7efd199$export$2e2bcd8739ae039(element) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return (((0, $lxsPK.isElement)(element) ? element.ownerDocument : element.document) || window.document).documentElement;
}

});


parcelRegister("jCpkw", function(module, exports) {
$parcel$export(module.exports, "default", () => $e48536f1c83ff3f8$export$2e2bcd8739ae039);

var $hEE65 = parcelRequire("hEE65");
function $e48536f1c83ff3f8$export$2e2bcd8739ae039(element) {
    // Firefox wants us to check `-x` and `-y` variations as well
    var _getComputedStyle = (0, $hEE65.default)(element), overflow = _getComputedStyle.overflow, overflowX = _getComputedStyle.overflowX, overflowY = _getComputedStyle.overflowY;
    return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}

});
parcelRegister("hEE65", function(module, exports) {
$parcel$export(module.exports, "default", () => $cda54693c6d70b8e$export$2e2bcd8739ae039);

var $jqcF0 = parcelRequire("jqcF0");
function $cda54693c6d70b8e$export$2e2bcd8739ae039(element) {
    return (0, $jqcF0.default)(element).getComputedStyle(element);
}

});



parcelRegister("cI2gV", function(module, exports) {
$parcel$export(module.exports, "default", () => $940b5b44ec492788$export$2e2bcd8739ae039);

var $5SX2j = parcelRequire("5SX2j");
function $940b5b44ec492788$export$2e2bcd8739ae039(element) {
    var clientRect = (0, $5SX2j.default)(element); // Use the clientRect sizes if it's not been transformed.
    // Fixes https://github.com/popperjs/popper-core/issues/1223
    var width = element.offsetWidth;
    var height = element.offsetHeight;
    if (Math.abs(clientRect.width - width) <= 1) width = clientRect.width;
    if (Math.abs(clientRect.height - height) <= 1) height = clientRect.height;
    return {
        x: element.offsetLeft,
        y: element.offsetTop,
        width: width,
        height: height
    };
}

});

parcelRegister("h2klf", function(module, exports) {
$parcel$export(module.exports, "default", () => $c6726702709c9e29$export$2e2bcd8739ae039);

var $ef0ZL = parcelRequire("ef0ZL");

var $ljRpf = parcelRequire("ljRpf");

var $jqcF0 = parcelRequire("jqcF0");

var $jCpkw = parcelRequire("jCpkw");
function $c6726702709c9e29$export$2e2bcd8739ae039(element, list) {
    var _element$ownerDocumen;
    if (list === void 0) list = [];
    var scrollParent = (0, $ef0ZL.default)(element);
    var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
    var win = (0, $jqcF0.default)(scrollParent);
    var target = isBody ? [
        win
    ].concat(win.visualViewport || [], (0, $jCpkw.default)(scrollParent) ? scrollParent : []) : scrollParent;
    var updatedList = list.concat(target);
    return isBody ? updatedList : updatedList.concat($c6726702709c9e29$export$2e2bcd8739ae039((0, $ljRpf.default)(target)));
}

});
parcelRegister("ef0ZL", function(module, exports) {
$parcel$export(module.exports, "default", () => $a5e33d0134a56fa3$export$2e2bcd8739ae039);

var $ljRpf = parcelRequire("ljRpf");

var $jCpkw = parcelRequire("jCpkw");

var $bFqu3 = parcelRequire("bFqu3");

var $lxsPK = parcelRequire("lxsPK");
function $a5e33d0134a56fa3$export$2e2bcd8739ae039(node) {
    if ([
        'html',
        'body',
        '#document'
    ].indexOf((0, $bFqu3.default)(node)) >= 0) // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
    if ((0, $lxsPK.isHTMLElement)(node) && (0, $jCpkw.default)(node)) return node;
    return $a5e33d0134a56fa3$export$2e2bcd8739ae039((0, $ljRpf.default)(node));
}

});
parcelRegister("ljRpf", function(module, exports) {
$parcel$export(module.exports, "default", () => $f854ccb3f447e492$export$2e2bcd8739ae039);

var $bFqu3 = parcelRequire("bFqu3");

var $2vuXD = parcelRequire("2vuXD");

var $lxsPK = parcelRequire("lxsPK");
function $f854ccb3f447e492$export$2e2bcd8739ae039(element) {
    if ((0, $bFqu3.default)(element) === 'html') return element;
    return(// $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || ((0, $lxsPK.isShadowRoot)(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    (0, $2vuXD.default)(element) // fallback
    );
}

});



parcelRegister("b40rk", function(module, exports) {
$parcel$export(module.exports, "default", () => $80e068c783f2bee0$export$2e2bcd8739ae039);

var $jqcF0 = parcelRequire("jqcF0");

var $bFqu3 = parcelRequire("bFqu3");

var $hEE65 = parcelRequire("hEE65");

var $lxsPK = parcelRequire("lxsPK");

var $aADW2 = parcelRequire("aADW2");

var $ljRpf = parcelRequire("ljRpf");

var $fttMi = parcelRequire("fttMi");
function $80e068c783f2bee0$var$getTrueOffsetParent(element) {
    if (!(0, $lxsPK.isHTMLElement)(element) || // https://github.com/popperjs/popper-core/issues/837
    (0, $hEE65.default)(element).position === 'fixed') return null;
    return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block
function $80e068c783f2bee0$var$getContainingBlock(element) {
    var isFirefox = /firefox/i.test((0, $fttMi.default)());
    var isIE = /Trident/i.test((0, $fttMi.default)());
    if (isIE && (0, $lxsPK.isHTMLElement)(element)) {
        // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
        var elementCss = (0, $hEE65.default)(element);
        if (elementCss.position === 'fixed') return null;
    }
    var currentNode = (0, $ljRpf.default)(element);
    if ((0, $lxsPK.isShadowRoot)(currentNode)) currentNode = currentNode.host;
    while((0, $lxsPK.isHTMLElement)(currentNode) && [
        'html',
        'body'
    ].indexOf((0, $bFqu3.default)(currentNode)) < 0){
        var css = (0, $hEE65.default)(currentNode); // This is non-exhaustive but covers the most common CSS properties that
        // create a containing block.
        // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
        if (css.transform !== 'none' || css.perspective !== 'none' || css.contain === 'paint' || [
            'transform',
            'perspective'
        ].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === 'filter' || isFirefox && css.filter && css.filter !== 'none') return currentNode;
        else currentNode = currentNode.parentNode;
    }
    return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
function $80e068c783f2bee0$export$2e2bcd8739ae039(element) {
    var window = (0, $jqcF0.default)(element);
    var offsetParent = $80e068c783f2bee0$var$getTrueOffsetParent(element);
    while(offsetParent && (0, $aADW2.default)(offsetParent) && (0, $hEE65.default)(offsetParent).position === 'static')offsetParent = $80e068c783f2bee0$var$getTrueOffsetParent(offsetParent);
    if (offsetParent && ((0, $bFqu3.default)(offsetParent) === 'html' || (0, $bFqu3.default)(offsetParent) === 'body' && (0, $hEE65.default)(offsetParent).position === 'static')) return window;
    return offsetParent || $80e068c783f2bee0$var$getContainingBlock(element) || window;
}

});
parcelRegister("aADW2", function(module, exports) {
$parcel$export(module.exports, "default", () => $7b5c3e787e434546$export$2e2bcd8739ae039);

var $bFqu3 = parcelRequire("bFqu3");
function $7b5c3e787e434546$export$2e2bcd8739ae039(element) {
    return [
        'table',
        'td',
        'th'
    ].indexOf((0, $bFqu3.default)(element)) >= 0;
}

});


parcelRegister("aUEAQ", function(module, exports) {
$parcel$export(module.exports, "default", () => $7f1e9f55695d8404$export$2e2bcd8739ae039);

var $eeoSb = parcelRequire("eeoSb");
function $7f1e9f55695d8404$var$order(modifiers) {
    var map = new Map();
    var visited = new Set();
    var result = [];
    modifiers.forEach(function(modifier) {
        map.set(modifier.name, modifier);
    }); // On visiting object, check for its dependencies and visit them recursively
    function sort(modifier) {
        visited.add(modifier.name);
        var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
        requires.forEach(function(dep) {
            if (!visited.has(dep)) {
                var depModifier = map.get(dep);
                if (depModifier) sort(depModifier);
            }
        });
        result.push(modifier);
    }
    modifiers.forEach(function(modifier) {
        if (!visited.has(modifier.name)) // check for visited object
        sort(modifier);
    });
    return result;
}
function $7f1e9f55695d8404$export$2e2bcd8739ae039(modifiers) {
    // order based on dependencies
    var orderedModifiers = $7f1e9f55695d8404$var$order(modifiers); // order based on phase
    return (0, $eeoSb.modifierPhases).reduce(function(acc, phase) {
        return acc.concat(orderedModifiers.filter(function(modifier) {
            return modifier.phase === phase;
        }));
    }, []);
}

});
parcelRegister("eeoSb", function(module, exports) {
$parcel$export(module.exports, "top", () => $02ac7a7efb891b05$export$1e95b668f3b82d);
$parcel$export(module.exports, "bottom", () => $02ac7a7efb891b05$export$40e543e69a8b3fbb);
$parcel$export(module.exports, "right", () => $02ac7a7efb891b05$export$79ffe56a765070d2);
$parcel$export(module.exports, "left", () => $02ac7a7efb891b05$export$eabcd2c8791e7bf4);
$parcel$export(module.exports, "auto", () => $02ac7a7efb891b05$export$dfb5619354ba860);
$parcel$export(module.exports, "basePlacements", () => $02ac7a7efb891b05$export$aec2ce47c367b8c3);
$parcel$export(module.exports, "start", () => $02ac7a7efb891b05$export$b3571188c770cc5a);
$parcel$export(module.exports, "end", () => $02ac7a7efb891b05$export$bd5df0f255a350f8);
$parcel$export(module.exports, "clippingParents", () => $02ac7a7efb891b05$export$390fd549c5303b4d);
$parcel$export(module.exports, "viewport", () => $02ac7a7efb891b05$export$d7b7311ec04a3e8f);
$parcel$export(module.exports, "popper", () => $02ac7a7efb891b05$export$ae5ab1c730825774);
$parcel$export(module.exports, "reference", () => $02ac7a7efb891b05$export$ca50aac9f3ba507f);
$parcel$export(module.exports, "variationPlacements", () => $02ac7a7efb891b05$export$368f9a87e87fa4e1);
$parcel$export(module.exports, "placements", () => $02ac7a7efb891b05$export$803cd8101b6c182b);
$parcel$export(module.exports, "modifierPhases", () => $02ac7a7efb891b05$export$d087d3878fdf71d5);
var $02ac7a7efb891b05$export$1e95b668f3b82d = 'top';
var $02ac7a7efb891b05$export$40e543e69a8b3fbb = 'bottom';
var $02ac7a7efb891b05$export$79ffe56a765070d2 = 'right';
var $02ac7a7efb891b05$export$eabcd2c8791e7bf4 = 'left';
var $02ac7a7efb891b05$export$dfb5619354ba860 = 'auto';
var $02ac7a7efb891b05$export$aec2ce47c367b8c3 = [
    $02ac7a7efb891b05$export$1e95b668f3b82d,
    $02ac7a7efb891b05$export$40e543e69a8b3fbb,
    $02ac7a7efb891b05$export$79ffe56a765070d2,
    $02ac7a7efb891b05$export$eabcd2c8791e7bf4
];
var $02ac7a7efb891b05$export$b3571188c770cc5a = 'start';
var $02ac7a7efb891b05$export$bd5df0f255a350f8 = 'end';
var $02ac7a7efb891b05$export$390fd549c5303b4d = 'clippingParents';
var $02ac7a7efb891b05$export$d7b7311ec04a3e8f = 'viewport';
var $02ac7a7efb891b05$export$ae5ab1c730825774 = 'popper';
var $02ac7a7efb891b05$export$ca50aac9f3ba507f = 'reference';
var $02ac7a7efb891b05$export$368f9a87e87fa4e1 = /*#__PURE__*/ $02ac7a7efb891b05$export$aec2ce47c367b8c3.reduce(function(acc, placement) {
    return acc.concat([
        placement + "-" + $02ac7a7efb891b05$export$b3571188c770cc5a,
        placement + "-" + $02ac7a7efb891b05$export$bd5df0f255a350f8
    ]);
}, []);
var $02ac7a7efb891b05$export$803cd8101b6c182b = /*#__PURE__*/ [].concat($02ac7a7efb891b05$export$aec2ce47c367b8c3, [
    $02ac7a7efb891b05$export$dfb5619354ba860
]).reduce(function(acc, placement) {
    return acc.concat([
        placement,
        placement + "-" + $02ac7a7efb891b05$export$b3571188c770cc5a,
        placement + "-" + $02ac7a7efb891b05$export$bd5df0f255a350f8
    ]);
}, []); // modifiers that need to read the DOM
var $02ac7a7efb891b05$export$421679a7c3d56e = 'beforeRead';
var $02ac7a7efb891b05$export$aafa59e2e03f2942 = 'read';
var $02ac7a7efb891b05$export$6964f6c886723980 = 'afterRead'; // pure-logic modifiers
var $02ac7a7efb891b05$export$c65e99957a05207c = 'beforeMain';
var $02ac7a7efb891b05$export$f22da7240b7add18 = 'main';
var $02ac7a7efb891b05$export$bab79516f2d662fe = 'afterMain'; // modifier with the purpose to write to the DOM (or write into a framework state)
var $02ac7a7efb891b05$export$8d4d2d70e7d46032 = 'beforeWrite';
var $02ac7a7efb891b05$export$68d8715fc104d294 = 'write';
var $02ac7a7efb891b05$export$70a6e5159acce2e6 = 'afterWrite';
var $02ac7a7efb891b05$export$d087d3878fdf71d5 = [
    $02ac7a7efb891b05$export$421679a7c3d56e,
    $02ac7a7efb891b05$export$aafa59e2e03f2942,
    $02ac7a7efb891b05$export$6964f6c886723980,
    $02ac7a7efb891b05$export$c65e99957a05207c,
    $02ac7a7efb891b05$export$f22da7240b7add18,
    $02ac7a7efb891b05$export$bab79516f2d662fe,
    $02ac7a7efb891b05$export$8d4d2d70e7d46032,
    $02ac7a7efb891b05$export$68d8715fc104d294,
    $02ac7a7efb891b05$export$70a6e5159acce2e6
];

});


parcelRegister("jp2vh", function(module, exports) {
$parcel$export(module.exports, "default", () => $e2024b46b66a297d$export$2e2bcd8739ae039);
function $e2024b46b66a297d$export$2e2bcd8739ae039(fn) {
    var pending;
    return function() {
        if (!pending) pending = new Promise(function(resolve) {
            Promise.resolve().then(function() {
                pending = undefined;
                resolve(fn());
            });
        });
        return pending;
    };
}

});

parcelRegister("45WlR", function(module, exports) {
$parcel$export(module.exports, "default", () => $2fb4e4733e092ed9$export$2e2bcd8739ae039);
function $2fb4e4733e092ed9$export$2e2bcd8739ae039(modifiers) {
    var merged = modifiers.reduce(function(merged, current) {
        var existing = merged[current.name];
        merged[current.name] = existing ? Object.assign({}, existing, current, {
            options: Object.assign({}, existing.options, current.options),
            data: Object.assign({}, existing.data, current.data)
        }) : current;
        return merged;
    }, {}); // IE11 does not support Object.values
    return Object.keys(merged).map(function(key) {
        return merged[key];
    });
}

});


parcelRegister("AYfmq", function(module, exports) {
$parcel$export(module.exports, "default", () => $06f218a851c306cc$export$2e2bcd8739ae039);

var $jqcF0 = parcelRequire("jqcF0");
var $06f218a851c306cc$var$passive = {
    passive: true
};
function $06f218a851c306cc$var$effect(_ref) {
    var state = _ref.state, instance = _ref.instance, options = _ref.options;
    var _options$scroll = options.scroll, scroll = _options$scroll === void 0 ? true : _options$scroll, _options$resize = options.resize, resize = _options$resize === void 0 ? true : _options$resize;
    var window = (0, $jqcF0.default)(state.elements.popper);
    var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);
    if (scroll) scrollParents.forEach(function(scrollParent) {
        scrollParent.addEventListener('scroll', instance.update, $06f218a851c306cc$var$passive);
    });
    if (resize) window.addEventListener('resize', instance.update, $06f218a851c306cc$var$passive);
    return function() {
        if (scroll) scrollParents.forEach(function(scrollParent) {
            scrollParent.removeEventListener('scroll', instance.update, $06f218a851c306cc$var$passive);
        });
        if (resize) window.removeEventListener('resize', instance.update, $06f218a851c306cc$var$passive);
    };
} // eslint-disable-next-line import/no-unused-modules
var $06f218a851c306cc$export$2e2bcd8739ae039 = {
    name: 'eventListeners',
    enabled: true,
    phase: 'write',
    fn: function fn() {},
    effect: $06f218a851c306cc$var$effect,
    data: {}
};

});

parcelRegister("jiyhn", function(module, exports) {
$parcel$export(module.exports, "default", () => $e0ca49ea984cd711$export$2e2bcd8739ae039);

var $59O1l = parcelRequire("59O1l");
function $e0ca49ea984cd711$var$popperOffsets(_ref) {
    var state = _ref.state, name = _ref.name;
    // Offsets are the actual position the popper needs to have to be
    // properly positioned near its reference element
    // This is the most basic placement, and will be adjusted by
    // the modifiers in the next step
    state.modifiersData[name] = (0, $59O1l.default)({
        reference: state.rects.reference,
        element: state.rects.popper,
        strategy: 'absolute',
        placement: state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $e0ca49ea984cd711$export$2e2bcd8739ae039 = {
    name: 'popperOffsets',
    enabled: true,
    phase: 'read',
    fn: $e0ca49ea984cd711$var$popperOffsets,
    data: {}
};

});
parcelRegister("59O1l", function(module, exports) {
$parcel$export(module.exports, "default", () => $3c149818943b8402$export$2e2bcd8739ae039);

var $5DtdC = parcelRequire("5DtdC");

var $j73B1 = parcelRequire("j73B1");

var $9WY3v = parcelRequire("9WY3v");

var $eeoSb = parcelRequire("eeoSb");
function $3c149818943b8402$export$2e2bcd8739ae039(_ref) {
    var reference = _ref.reference, element = _ref.element, placement = _ref.placement;
    var basePlacement = placement ? (0, $5DtdC.default)(placement) : null;
    var variation = placement ? (0, $j73B1.default)(placement) : null;
    var commonX = reference.x + reference.width / 2 - element.width / 2;
    var commonY = reference.y + reference.height / 2 - element.height / 2;
    var offsets;
    switch(basePlacement){
        case 0, $eeoSb.top:
            offsets = {
                x: commonX,
                y: reference.y - element.height
            };
            break;
        case 0, $eeoSb.bottom:
            offsets = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 0, $eeoSb.right:
            offsets = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 0, $eeoSb.left:
            offsets = {
                x: reference.x - element.width,
                y: commonY
            };
            break;
        default:
            offsets = {
                x: reference.x,
                y: reference.y
            };
    }
    var mainAxis = basePlacement ? (0, $9WY3v.default)(basePlacement) : null;
    if (mainAxis != null) {
        var len = mainAxis === 'y' ? 'height' : 'width';
        switch(variation){
            case 0, $eeoSb.start:
                offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
                break;
            case 0, $eeoSb.end:
                offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
                break;
            default:
        }
    }
    return offsets;
}

});
parcelRegister("5DtdC", function(module, exports) {
$parcel$export(module.exports, "default", () => $41a74276d1437cf3$export$2e2bcd8739ae039);

function $41a74276d1437cf3$export$2e2bcd8739ae039(placement) {
    return placement.split('-')[0];
}

});

parcelRegister("j73B1", function(module, exports) {
$parcel$export(module.exports, "default", () => $dea175e1fbb039f4$export$2e2bcd8739ae039);
function $dea175e1fbb039f4$export$2e2bcd8739ae039(placement) {
    return placement.split('-')[1];
}

});

parcelRegister("9WY3v", function(module, exports) {
$parcel$export(module.exports, "default", () => $73e81d9ee133d820$export$2e2bcd8739ae039);
function $73e81d9ee133d820$export$2e2bcd8739ae039(placement) {
    return [
        'top',
        'bottom'
    ].indexOf(placement) >= 0 ? 'x' : 'y';
}

});



parcelRegister("8xQBR", function(module, exports) {
$parcel$export(module.exports, "default", () => $638a36f4ddb5d6c8$export$2e2bcd8739ae039);

var $eeoSb = parcelRequire("eeoSb");

var $b40rk = parcelRequire("b40rk");

var $jqcF0 = parcelRequire("jqcF0");

var $2vuXD = parcelRequire("2vuXD");

var $hEE65 = parcelRequire("hEE65");

var $5DtdC = parcelRequire("5DtdC");

var $j73B1 = parcelRequire("j73B1");

var $kDvUD = parcelRequire("kDvUD");
var $638a36f4ddb5d6c8$var$unsetSides = {
    top: 'auto',
    right: 'auto',
    bottom: 'auto',
    left: 'auto'
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.
function $638a36f4ddb5d6c8$var$roundOffsetsByDPR(_ref, win) {
    var x = _ref.x, y = _ref.y;
    var dpr = win.devicePixelRatio || 1;
    return {
        x: (0, $kDvUD.round)(x * dpr) / dpr || 0,
        y: (0, $kDvUD.round)(y * dpr) / dpr || 0
    };
}
function $638a36f4ddb5d6c8$export$378fa78a8fea596f(_ref2) {
    var _Object$assign2;
    var popper = _ref2.popper, popperRect = _ref2.popperRect, placement = _ref2.placement, variation = _ref2.variation, offsets = _ref2.offsets, position = _ref2.position, gpuAcceleration = _ref2.gpuAcceleration, adaptive = _ref2.adaptive, roundOffsets = _ref2.roundOffsets, isFixed = _ref2.isFixed;
    var _offsets$x = offsets.x, x = _offsets$x === void 0 ? 0 : _offsets$x, _offsets$y = offsets.y, y = _offsets$y === void 0 ? 0 : _offsets$y;
    var _ref3 = typeof roundOffsets === 'function' ? roundOffsets({
        x: x,
        y: y
    }) : {
        x: x,
        y: y
    };
    x = _ref3.x;
    y = _ref3.y;
    var hasX = offsets.hasOwnProperty('x');
    var hasY = offsets.hasOwnProperty('y');
    var sideX = (0, $eeoSb.left);
    var sideY = (0, $eeoSb.top);
    var win = window;
    if (adaptive) {
        var offsetParent = (0, $b40rk.default)(popper);
        var heightProp = 'clientHeight';
        var widthProp = 'clientWidth';
        if (offsetParent === (0, $jqcF0.default)(popper)) {
            offsetParent = (0, $2vuXD.default)(popper);
            if ((0, $hEE65.default)(offsetParent).position !== 'static' && position === 'absolute') {
                heightProp = 'scrollHeight';
                widthProp = 'scrollWidth';
            }
        } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it
        offsetParent;
        if (placement === (0, $eeoSb.top) || (placement === (0, $eeoSb.left) || placement === (0, $eeoSb.right)) && variation === (0, $eeoSb.end)) {
            sideY = (0, $eeoSb.bottom);
            var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : offsetParent[heightProp];
            y -= offsetY - popperRect.height;
            y *= gpuAcceleration ? 1 : -1;
        }
        if (placement === (0, $eeoSb.left) || (placement === (0, $eeoSb.top) || placement === (0, $eeoSb.bottom)) && variation === (0, $eeoSb.end)) {
            sideX = (0, $eeoSb.right);
            var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : offsetParent[widthProp];
            x -= offsetX - popperRect.width;
            x *= gpuAcceleration ? 1 : -1;
        }
    }
    var commonStyles = Object.assign({
        position: position
    }, adaptive && $638a36f4ddb5d6c8$var$unsetSides);
    var _ref4 = roundOffsets === true ? $638a36f4ddb5d6c8$var$roundOffsetsByDPR({
        x: x,
        y: y
    }, (0, $jqcF0.default)(popper)) : {
        x: x,
        y: y
    };
    x = _ref4.x;
    y = _ref4.y;
    if (gpuAcceleration) {
        var _Object$assign;
        return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? '0' : '', _Object$assign[sideX] = hasX ? '0' : '', _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
    }
    return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : '', _Object$assign2[sideX] = hasX ? x + "px" : '', _Object$assign2.transform = '', _Object$assign2));
}
function $638a36f4ddb5d6c8$var$computeStyles(_ref5) {
    var state = _ref5.state, options = _ref5.options;
    var _options$gpuAccelerat = options.gpuAcceleration, gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat, _options$adaptive = options.adaptive, adaptive = _options$adaptive === void 0 ? true : _options$adaptive, _options$roundOffsets = options.roundOffsets, roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
    var commonStyles = {
        placement: (0, $5DtdC.default)(state.placement),
        variation: (0, $j73B1.default)(state.placement),
        popper: state.elements.popper,
        popperRect: state.rects.popper,
        gpuAcceleration: gpuAcceleration,
        isFixed: state.options.strategy === 'fixed'
    };
    if (state.modifiersData.popperOffsets != null) state.styles.popper = Object.assign({}, state.styles.popper, $638a36f4ddb5d6c8$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.popperOffsets,
        position: state.options.strategy,
        adaptive: adaptive,
        roundOffsets: roundOffsets
    })));
    if (state.modifiersData.arrow != null) state.styles.arrow = Object.assign({}, state.styles.arrow, $638a36f4ddb5d6c8$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.arrow,
        position: 'absolute',
        adaptive: false,
        roundOffsets: roundOffsets
    })));
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-placement': state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $638a36f4ddb5d6c8$export$2e2bcd8739ae039 = {
    name: 'computeStyles',
    enabled: true,
    phase: 'beforeWrite',
    fn: $638a36f4ddb5d6c8$var$computeStyles,
    data: {}
};

});

parcelRegister("95K1c", function(module, exports) {
$parcel$export(module.exports, "default", () => $69e846f9616ad096$export$2e2bcd8739ae039);

var $bFqu3 = parcelRequire("bFqu3");

var $lxsPK = parcelRequire("lxsPK");
// and applies them to the HTMLElements such as popper and arrow
function $69e846f9616ad096$var$applyStyles(_ref) {
    var state = _ref.state;
    Object.keys(state.elements).forEach(function(name) {
        var style = state.styles[name] || {};
        var attributes = state.attributes[name] || {};
        var element = state.elements[name]; // arrow is optional + virtual elements
        if (!(0, $lxsPK.isHTMLElement)(element) || !(0, $bFqu3.default)(element)) return;
         // Flow doesn't support to extend this property, but it's the most
        // effective way to apply styles to an HTMLElement
        // $FlowFixMe[cannot-write]
        Object.assign(element.style, style);
        Object.keys(attributes).forEach(function(name) {
            var value = attributes[name];
            if (value === false) element.removeAttribute(name);
            else element.setAttribute(name, value === true ? '' : value);
        });
    });
}
function $69e846f9616ad096$var$effect(_ref2) {
    var state = _ref2.state;
    var initialStyles = {
        popper: {
            position: state.options.strategy,
            left: '0',
            top: '0',
            margin: '0'
        },
        arrow: {
            position: 'absolute'
        },
        reference: {}
    };
    Object.assign(state.elements.popper.style, initialStyles.popper);
    state.styles = initialStyles;
    if (state.elements.arrow) Object.assign(state.elements.arrow.style, initialStyles.arrow);
    return function() {
        Object.keys(state.elements).forEach(function(name) {
            var element = state.elements[name];
            var attributes = state.attributes[name] || {};
            var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]); // Set all values to an empty string to unset them
            var style = styleProperties.reduce(function(style, property) {
                style[property] = '';
                return style;
            }, {}); // arrow is optional + virtual elements
            if (!(0, $lxsPK.isHTMLElement)(element) || !(0, $bFqu3.default)(element)) return;
            Object.assign(element.style, style);
            Object.keys(attributes).forEach(function(attribute) {
                element.removeAttribute(attribute);
            });
        });
    };
} // eslint-disable-next-line import/no-unused-modules
var $69e846f9616ad096$export$2e2bcd8739ae039 = {
    name: 'applyStyles',
    enabled: true,
    phase: 'write',
    fn: $69e846f9616ad096$var$applyStyles,
    effect: $69e846f9616ad096$var$effect,
    requires: [
        'computeStyles'
    ]
};

});

parcelRegister("lexRm", function(module, exports) {
$parcel$export(module.exports, "default", () => $f7552b997e91c31f$export$2e2bcd8739ae039);

var $5DtdC = parcelRequire("5DtdC");

var $eeoSb = parcelRequire("eeoSb");
function $f7552b997e91c31f$export$7fa02d8595b015ed(placement, rects, offset) {
    var basePlacement = (0, $5DtdC.default)(placement);
    var invertDistance = [
        (0, $eeoSb.left),
        (0, $eeoSb.top)
    ].indexOf(basePlacement) >= 0 ? -1 : 1;
    var _ref = typeof offset === 'function' ? offset(Object.assign({}, rects, {
        placement: placement
    })) : offset, skidding = _ref[0], distance = _ref[1];
    skidding = skidding || 0;
    distance = (distance || 0) * invertDistance;
    return [
        (0, $eeoSb.left),
        (0, $eeoSb.right)
    ].indexOf(basePlacement) >= 0 ? {
        x: distance,
        y: skidding
    } : {
        x: skidding,
        y: distance
    };
}
function $f7552b997e91c31f$var$offset(_ref2) {
    var state = _ref2.state, options = _ref2.options, name = _ref2.name;
    var _options$offset = options.offset, offset = _options$offset === void 0 ? [
        0,
        0
    ] : _options$offset;
    var data = (0, $eeoSb.placements).reduce(function(acc, placement) {
        acc[placement] = $f7552b997e91c31f$export$7fa02d8595b015ed(placement, state.rects, offset);
        return acc;
    }, {});
    var _data$state$placement = data[state.placement], x = _data$state$placement.x, y = _data$state$placement.y;
    if (state.modifiersData.popperOffsets != null) {
        state.modifiersData.popperOffsets.x += x;
        state.modifiersData.popperOffsets.y += y;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $f7552b997e91c31f$export$2e2bcd8739ae039 = {
    name: 'offset',
    enabled: true,
    phase: 'main',
    requires: [
        'popperOffsets'
    ],
    fn: $f7552b997e91c31f$var$offset
};

});

parcelRegister("euI62", function(module, exports) {
$parcel$export(module.exports, "default", () => $a8d612a7f4de3fca$export$2e2bcd8739ae039);

var $41KCE = parcelRequire("41KCE");

var $5DtdC = parcelRequire("5DtdC");

var $8eKAj = parcelRequire("8eKAj");

var $a9NCa = parcelRequire("a9NCa");

var $1ybP7 = parcelRequire("1ybP7");

var $eeoSb = parcelRequire("eeoSb");

var $j73B1 = parcelRequire("j73B1");
function $a8d612a7f4de3fca$var$getExpandedFallbackPlacements(placement) {
    if ((0, $5DtdC.default)(placement) === (0, $eeoSb.auto)) return [];
    var oppositePlacement = (0, $41KCE.default)(placement);
    return [
        (0, $8eKAj.default)(placement),
        oppositePlacement,
        (0, $8eKAj.default)(oppositePlacement)
    ];
}
function $a8d612a7f4de3fca$var$flip(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    if (state.modifiersData[name]._skip) return;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis, specifiedFallbackPlacements = options.fallbackPlacements, padding = options.padding, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, _options$flipVariatio = options.flipVariations, flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio, allowedAutoPlacements = options.allowedAutoPlacements;
    var preferredPlacement = state.options.placement;
    var basePlacement = (0, $5DtdC.default)(preferredPlacement);
    var isBasePlacement = basePlacement === preferredPlacement;
    var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [
        (0, $41KCE.default)(preferredPlacement)
    ] : $a8d612a7f4de3fca$var$getExpandedFallbackPlacements(preferredPlacement));
    var placements = [
        preferredPlacement
    ].concat(fallbackPlacements).reduce(function(acc, placement) {
        return acc.concat((0, $5DtdC.default)(placement) === (0, $eeoSb.auto) ? (0, $1ybP7.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding,
            flipVariations: flipVariations,
            allowedAutoPlacements: allowedAutoPlacements
        }) : placement);
    }, []);
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var checksMap = new Map();
    var makeFallbackChecks = true;
    var firstFittingPlacement = placements[0];
    for(var i = 0; i < placements.length; i++){
        var placement = placements[i];
        var _basePlacement = (0, $5DtdC.default)(placement);
        var isStartVariation = (0, $j73B1.default)(placement) === (0, $eeoSb.start);
        var isVertical = [
            (0, $eeoSb.top),
            (0, $eeoSb.bottom)
        ].indexOf(_basePlacement) >= 0;
        var len = isVertical ? 'width' : 'height';
        var overflow = (0, $a9NCa.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            altBoundary: altBoundary,
            padding: padding
        });
        var mainVariationSide = isVertical ? isStartVariation ? (0, $eeoSb.right) : (0, $eeoSb.left) : isStartVariation ? (0, $eeoSb.bottom) : (0, $eeoSb.top);
        if (referenceRect[len] > popperRect[len]) mainVariationSide = (0, $41KCE.default)(mainVariationSide);
        var altVariationSide = (0, $41KCE.default)(mainVariationSide);
        var checks = [];
        if (checkMainAxis) checks.push(overflow[_basePlacement] <= 0);
        if (checkAltAxis) checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
        if (checks.every(function(check) {
            return check;
        })) {
            firstFittingPlacement = placement;
            makeFallbackChecks = false;
            break;
        }
        checksMap.set(placement, checks);
    }
    if (makeFallbackChecks) {
        // `2` may be desired in some cases – research later
        var numberOfChecks = flipVariations ? 3 : 1;
        var _loop = function _loop(_i) {
            var fittingPlacement = placements.find(function(placement) {
                var checks = checksMap.get(placement);
                if (checks) return checks.slice(0, _i).every(function(check) {
                    return check;
                });
            });
            if (fittingPlacement) {
                firstFittingPlacement = fittingPlacement;
                return "break";
            }
        };
        for(var _i = numberOfChecks; _i > 0; _i--){
            var _ret = _loop(_i);
            if (_ret === "break") break;
        }
    }
    if (state.placement !== firstFittingPlacement) {
        state.modifiersData[name]._skip = true;
        state.placement = firstFittingPlacement;
        state.reset = true;
    }
} // eslint-disable-next-line import/no-unused-modules
var $a8d612a7f4de3fca$export$2e2bcd8739ae039 = {
    name: 'flip',
    enabled: true,
    phase: 'main',
    fn: $a8d612a7f4de3fca$var$flip,
    requiresIfExists: [
        'offset'
    ],
    data: {
        _skip: false
    }
};

});
parcelRegister("41KCE", function(module, exports) {
$parcel$export(module.exports, "default", () => $2eeb6ba489107ea4$export$2e2bcd8739ae039);
var $2eeb6ba489107ea4$var$hash = {
    left: 'right',
    right: 'left',
    bottom: 'top',
    top: 'bottom'
};
function $2eeb6ba489107ea4$export$2e2bcd8739ae039(placement) {
    return placement.replace(/left|right|bottom|top/g, function(matched) {
        return $2eeb6ba489107ea4$var$hash[matched];
    });
}

});

parcelRegister("8eKAj", function(module, exports) {
$parcel$export(module.exports, "default", () => $5ff3c44405c30b93$export$2e2bcd8739ae039);
var $5ff3c44405c30b93$var$hash = {
    start: 'end',
    end: 'start'
};
function $5ff3c44405c30b93$export$2e2bcd8739ae039(placement) {
    return placement.replace(/start|end/g, function(matched) {
        return $5ff3c44405c30b93$var$hash[matched];
    });
}

});

parcelRegister("a9NCa", function(module, exports) {
$parcel$export(module.exports, "default", () => $76513b0dab162e77$export$2e2bcd8739ae039);

var $KtIU2 = parcelRequire("KtIU2");

var $2vuXD = parcelRequire("2vuXD");

var $5SX2j = parcelRequire("5SX2j");

var $59O1l = parcelRequire("59O1l");

var $dyjBZ = parcelRequire("dyjBZ");

var $eeoSb = parcelRequire("eeoSb");

var $lxsPK = parcelRequire("lxsPK");

var $1kKwt = parcelRequire("1kKwt");

var $737LB = parcelRequire("737LB");
function $76513b0dab162e77$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, _options$placement = _options.placement, placement = _options$placement === void 0 ? state.placement : _options$placement, _options$strategy = _options.strategy, strategy = _options$strategy === void 0 ? state.strategy : _options$strategy, _options$boundary = _options.boundary, boundary = _options$boundary === void 0 ? (0, $eeoSb.clippingParents) : _options$boundary, _options$rootBoundary = _options.rootBoundary, rootBoundary = _options$rootBoundary === void 0 ? (0, $eeoSb.viewport) : _options$rootBoundary, _options$elementConte = _options.elementContext, elementContext = _options$elementConte === void 0 ? (0, $eeoSb.popper) : _options$elementConte, _options$altBoundary = _options.altBoundary, altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary, _options$padding = _options.padding, padding = _options$padding === void 0 ? 0 : _options$padding;
    var paddingObject = (0, $1kKwt.default)(typeof padding !== 'number' ? padding : (0, $737LB.default)(padding, (0, $eeoSb.basePlacements)));
    var altContext = elementContext === (0, $eeoSb.popper) ? (0, $eeoSb.reference) : (0, $eeoSb.popper);
    var popperRect = state.rects.popper;
    var element = state.elements[altBoundary ? altContext : elementContext];
    var clippingClientRect = (0, $KtIU2.default)((0, $lxsPK.isElement)(element) ? element : element.contextElement || (0, $2vuXD.default)(state.elements.popper), boundary, rootBoundary, strategy);
    var referenceClientRect = (0, $5SX2j.default)(state.elements.reference);
    var popperOffsets = (0, $59O1l.default)({
        reference: referenceClientRect,
        element: popperRect,
        strategy: 'absolute',
        placement: placement
    });
    var popperClientRect = (0, $dyjBZ.default)(Object.assign({}, popperRect, popperOffsets));
    var elementClientRect = elementContext === (0, $eeoSb.popper) ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
    // 0 or negative = within the clipping rect
    var overflowOffsets = {
        top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
        bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
        left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
        right: elementClientRect.right - clippingClientRect.right + paddingObject.right
    };
    var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element
    if (elementContext === (0, $eeoSb.popper) && offsetData) {
        var offset = offsetData[placement];
        Object.keys(overflowOffsets).forEach(function(key) {
            var multiply = [
                (0, $eeoSb.right),
                (0, $eeoSb.bottom)
            ].indexOf(key) >= 0 ? 1 : -1;
            var axis = [
                (0, $eeoSb.top),
                (0, $eeoSb.bottom)
            ].indexOf(key) >= 0 ? 'y' : 'x';
            overflowOffsets[key] += offset[axis] * multiply;
        });
    }
    return overflowOffsets;
}

});
parcelRegister("KtIU2", function(module, exports) {
$parcel$export(module.exports, "default", () => $08bb5a68a7569dd1$export$2e2bcd8739ae039);

var $eeoSb = parcelRequire("eeoSb");

var $cUoeH = parcelRequire("cUoeH");

var $bxSZJ = parcelRequire("bxSZJ");

var $h2klf = parcelRequire("h2klf");

var $b40rk = parcelRequire("b40rk");

var $2vuXD = parcelRequire("2vuXD");

var $hEE65 = parcelRequire("hEE65");

var $lxsPK = parcelRequire("lxsPK");

var $5SX2j = parcelRequire("5SX2j");

var $ljRpf = parcelRequire("ljRpf");

var $kIXW4 = parcelRequire("kIXW4");

var $bFqu3 = parcelRequire("bFqu3");

var $dyjBZ = parcelRequire("dyjBZ");

var $kDvUD = parcelRequire("kDvUD");
function $08bb5a68a7569dd1$var$getInnerBoundingClientRect(element, strategy) {
    var rect = (0, $5SX2j.default)(element, false, strategy === 'fixed');
    rect.top = rect.top + element.clientTop;
    rect.left = rect.left + element.clientLeft;
    rect.bottom = rect.top + element.clientHeight;
    rect.right = rect.left + element.clientWidth;
    rect.width = element.clientWidth;
    rect.height = element.clientHeight;
    rect.x = rect.left;
    rect.y = rect.top;
    return rect;
}
function $08bb5a68a7569dd1$var$getClientRectFromMixedType(element, clippingParent, strategy) {
    return clippingParent === (0, $eeoSb.viewport) ? (0, $dyjBZ.default)((0, $cUoeH.default)(element, strategy)) : (0, $lxsPK.isElement)(clippingParent) ? $08bb5a68a7569dd1$var$getInnerBoundingClientRect(clippingParent, strategy) : (0, $dyjBZ.default)((0, $bxSZJ.default)((0, $2vuXD.default)(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`
function $08bb5a68a7569dd1$var$getClippingParents(element) {
    var clippingParents = (0, $h2klf.default)((0, $ljRpf.default)(element));
    var canEscapeClipping = [
        'absolute',
        'fixed'
    ].indexOf((0, $hEE65.default)(element).position) >= 0;
    var clipperElement = canEscapeClipping && (0, $lxsPK.isHTMLElement)(element) ? (0, $b40rk.default)(element) : element;
    if (!(0, $lxsPK.isElement)(clipperElement)) return [];
     // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414
    return clippingParents.filter(function(clippingParent) {
        return (0, $lxsPK.isElement)(clippingParent) && (0, $kIXW4.default)(clippingParent, clipperElement) && (0, $bFqu3.default)(clippingParent) !== 'body';
    });
} // Gets the maximum area that the element is visible in due to any number of
function $08bb5a68a7569dd1$export$2e2bcd8739ae039(element, boundary, rootBoundary, strategy) {
    var mainClippingParents = boundary === 'clippingParents' ? $08bb5a68a7569dd1$var$getClippingParents(element) : [].concat(boundary);
    var clippingParents = [].concat(mainClippingParents, [
        rootBoundary
    ]);
    var firstClippingParent = clippingParents[0];
    var clippingRect = clippingParents.reduce(function(accRect, clippingParent) {
        var rect = $08bb5a68a7569dd1$var$getClientRectFromMixedType(element, clippingParent, strategy);
        accRect.top = (0, $kDvUD.max)(rect.top, accRect.top);
        accRect.right = (0, $kDvUD.min)(rect.right, accRect.right);
        accRect.bottom = (0, $kDvUD.min)(rect.bottom, accRect.bottom);
        accRect.left = (0, $kDvUD.max)(rect.left, accRect.left);
        return accRect;
    }, $08bb5a68a7569dd1$var$getClientRectFromMixedType(element, firstClippingParent, strategy));
    clippingRect.width = clippingRect.right - clippingRect.left;
    clippingRect.height = clippingRect.bottom - clippingRect.top;
    clippingRect.x = clippingRect.left;
    clippingRect.y = clippingRect.top;
    return clippingRect;
}

});
parcelRegister("cUoeH", function(module, exports) {
$parcel$export(module.exports, "default", () => $965d83c411363a82$export$2e2bcd8739ae039);

var $jqcF0 = parcelRequire("jqcF0");

var $2vuXD = parcelRequire("2vuXD");

var $8iNOc = parcelRequire("8iNOc");

var $gNwrE = parcelRequire("gNwrE");
function $965d83c411363a82$export$2e2bcd8739ae039(element, strategy) {
    var win = (0, $jqcF0.default)(element);
    var html = (0, $2vuXD.default)(element);
    var visualViewport = win.visualViewport;
    var width = html.clientWidth;
    var height = html.clientHeight;
    var x = 0;
    var y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        var layoutViewport = (0, $gNwrE.default)();
        if (layoutViewport || !layoutViewport && strategy === 'fixed') {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x + (0, $8iNOc.default)(element),
        y: y
    };
}

});

parcelRegister("bxSZJ", function(module, exports) {
$parcel$export(module.exports, "default", () => $867d6f9773686e85$export$2e2bcd8739ae039);

var $2vuXD = parcelRequire("2vuXD");

var $hEE65 = parcelRequire("hEE65");

var $8iNOc = parcelRequire("8iNOc");

var $9U1SB = parcelRequire("9U1SB");

var $kDvUD = parcelRequire("kDvUD");
function $867d6f9773686e85$export$2e2bcd8739ae039(element) {
    var _element$ownerDocumen;
    var html = (0, $2vuXD.default)(element);
    var winScroll = (0, $9U1SB.default)(element);
    var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
    var width = (0, $kDvUD.max)(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
    var height = (0, $kDvUD.max)(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
    var x = -winScroll.scrollLeft + (0, $8iNOc.default)(element);
    var y = -winScroll.scrollTop;
    if ((0, $hEE65.default)(body || html).direction === 'rtl') x += (0, $kDvUD.max)(html.clientWidth, body ? body.clientWidth : 0) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}

});

parcelRegister("kIXW4", function(module, exports) {
$parcel$export(module.exports, "default", () => $f16668aaebdec374$export$2e2bcd8739ae039);

var $lxsPK = parcelRequire("lxsPK");
function $f16668aaebdec374$export$2e2bcd8739ae039(parent, child) {
    var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method
    if (parent.contains(child)) return true;
    else if (rootNode && (0, $lxsPK.isShadowRoot)(rootNode)) {
        var next = child;
        do {
            if (next && parent.isSameNode(next)) return true;
             // $FlowFixMe[prop-missing]: need a better way to handle this...
            next = next.parentNode || next.host;
        }while (next);
    } // Give up, the result is false
    return false;
}

});

parcelRegister("dyjBZ", function(module, exports) {
$parcel$export(module.exports, "default", () => $9ddda9cf12580473$export$2e2bcd8739ae039);
function $9ddda9cf12580473$export$2e2bcd8739ae039(rect) {
    return Object.assign({}, rect, {
        left: rect.x,
        top: rect.y,
        right: rect.x + rect.width,
        bottom: rect.y + rect.height
    });
}

});


parcelRegister("1kKwt", function(module, exports) {
$parcel$export(module.exports, "default", () => $0f8bbf2cee5893df$export$2e2bcd8739ae039);

var $dGQny = parcelRequire("dGQny");
function $0f8bbf2cee5893df$export$2e2bcd8739ae039(paddingObject) {
    return Object.assign({}, (0, $dGQny.default)(), paddingObject);
}

});
parcelRegister("dGQny", function(module, exports) {
$parcel$export(module.exports, "default", () => $9f77d3f4875fb909$export$2e2bcd8739ae039);
function $9f77d3f4875fb909$export$2e2bcd8739ae039() {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    };
}

});


parcelRegister("737LB", function(module, exports) {
$parcel$export(module.exports, "default", () => $521ed68a58dda134$export$2e2bcd8739ae039);
function $521ed68a58dda134$export$2e2bcd8739ae039(value, keys) {
    return keys.reduce(function(hashMap, key) {
        hashMap[key] = value;
        return hashMap;
    }, {});
}

});


parcelRegister("1ybP7", function(module, exports) {
$parcel$export(module.exports, "default", () => $12122352a478c0c2$export$2e2bcd8739ae039);

var $j73B1 = parcelRequire("j73B1");

var $eeoSb = parcelRequire("eeoSb");

var $a9NCa = parcelRequire("a9NCa");

var $5DtdC = parcelRequire("5DtdC");
function $12122352a478c0c2$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, placement = _options.placement, boundary = _options.boundary, rootBoundary = _options.rootBoundary, padding = _options.padding, flipVariations = _options.flipVariations, _options$allowedAutoP = _options.allowedAutoPlacements, allowedAutoPlacements = _options$allowedAutoP === void 0 ? (0, $eeoSb.placements) : _options$allowedAutoP;
    var variation = (0, $j73B1.default)(placement);
    var placements = variation ? flipVariations ? (0, $eeoSb.variationPlacements) : (0, $eeoSb.variationPlacements).filter(function(placement) {
        return (0, $j73B1.default)(placement) === variation;
    }) : (0, $eeoSb.basePlacements);
    var allowedPlacements = placements.filter(function(placement) {
        return allowedAutoPlacements.indexOf(placement) >= 0;
    });
    if (allowedPlacements.length === 0) allowedPlacements = placements;
     // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...
    var overflows = allowedPlacements.reduce(function(acc, placement) {
        acc[placement] = (0, $a9NCa.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding
        })[(0, $5DtdC.default)(placement)];
        return acc;
    }, {});
    return Object.keys(overflows).sort(function(a, b) {
        return overflows[a] - overflows[b];
    });
}

});


parcelRegister("hlR4d", function(module, exports) {
$parcel$export(module.exports, "default", () => $ca1d8fd29157d544$export$2e2bcd8739ae039);

var $eeoSb = parcelRequire("eeoSb");

var $5DtdC = parcelRequire("5DtdC");

var $9WY3v = parcelRequire("9WY3v");

var $2x9Hn = parcelRequire("2x9Hn");

var $b5qu5 = parcelRequire("b5qu5");

var $cI2gV = parcelRequire("cI2gV");

var $b40rk = parcelRequire("b40rk");

var $a9NCa = parcelRequire("a9NCa");

var $j73B1 = parcelRequire("j73B1");

var $dGQny = parcelRequire("dGQny");

var $kDvUD = parcelRequire("kDvUD");
function $ca1d8fd29157d544$var$preventOverflow(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, padding = options.padding, _options$tether = options.tether, tether = _options$tether === void 0 ? true : _options$tether, _options$tetherOffset = options.tetherOffset, tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
    var overflow = (0, $a9NCa.default)(state, {
        boundary: boundary,
        rootBoundary: rootBoundary,
        padding: padding,
        altBoundary: altBoundary
    });
    var basePlacement = (0, $5DtdC.default)(state.placement);
    var variation = (0, $j73B1.default)(state.placement);
    var isBasePlacement = !variation;
    var mainAxis = (0, $9WY3v.default)(basePlacement);
    var altAxis = (0, $2x9Hn.default)(mainAxis);
    var popperOffsets = state.modifiersData.popperOffsets;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var tetherOffsetValue = typeof tetherOffset === 'function' ? tetherOffset(Object.assign({}, state.rects, {
        placement: state.placement
    })) : tetherOffset;
    var normalizedTetherOffsetValue = typeof tetherOffsetValue === 'number' ? {
        mainAxis: tetherOffsetValue,
        altAxis: tetherOffsetValue
    } : Object.assign({
        mainAxis: 0,
        altAxis: 0
    }, tetherOffsetValue);
    var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
    var data = {
        x: 0,
        y: 0
    };
    if (!popperOffsets) return;
    if (checkMainAxis) {
        var _offsetModifierState$;
        var mainSide = mainAxis === 'y' ? (0, $eeoSb.top) : (0, $eeoSb.left);
        var altSide = mainAxis === 'y' ? (0, $eeoSb.bottom) : (0, $eeoSb.right);
        var len = mainAxis === 'y' ? 'height' : 'width';
        var offset = popperOffsets[mainAxis];
        var min = offset + overflow[mainSide];
        var max = offset - overflow[altSide];
        var additive = tether ? -popperRect[len] / 2 : 0;
        var minLen = variation === (0, $eeoSb.start) ? referenceRect[len] : popperRect[len];
        var maxLen = variation === (0, $eeoSb.start) ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
        // outside the reference bounds
        var arrowElement = state.elements.arrow;
        var arrowRect = tether && arrowElement ? (0, $cI2gV.default)(arrowElement) : {
            width: 0,
            height: 0
        };
        var arrowPaddingObject = state.modifiersData['arrow#persistent'] ? state.modifiersData['arrow#persistent'].padding : (0, $dGQny.default)();
        var arrowPaddingMin = arrowPaddingObject[mainSide];
        var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
        // to include its full size in the calculation. If the reference is small
        // and near the edge of a boundary, the popper can overflow even if the
        // reference is not overflowing as well (e.g. virtual elements with no
        // width or height)
        var arrowLen = (0, $b5qu5.within)(0, referenceRect[len], arrowRect[len]);
        var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
        var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
        var arrowOffsetParent = state.elements.arrow && (0, $b40rk.default)(state.elements.arrow);
        var clientOffset = arrowOffsetParent ? mainAxis === 'y' ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
        var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
        var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
        var tetherMax = offset + maxOffset - offsetModifierValue;
        var preventedOffset = (0, $b5qu5.within)(tether ? (0, $kDvUD.min)(min, tetherMin) : min, offset, tether ? (0, $kDvUD.max)(max, tetherMax) : max);
        popperOffsets[mainAxis] = preventedOffset;
        data[mainAxis] = preventedOffset - offset;
    }
    if (checkAltAxis) {
        var _offsetModifierState$2;
        var _mainSide = mainAxis === 'x' ? (0, $eeoSb.top) : (0, $eeoSb.left);
        var _altSide = mainAxis === 'x' ? (0, $eeoSb.bottom) : (0, $eeoSb.right);
        var _offset = popperOffsets[altAxis];
        var _len = altAxis === 'y' ? 'height' : 'width';
        var _min = _offset + overflow[_mainSide];
        var _max = _offset - overflow[_altSide];
        var isOriginSide = [
            (0, $eeoSb.top),
            (0, $eeoSb.left)
        ].indexOf(basePlacement) !== -1;
        var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;
        var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;
        var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;
        var _preventedOffset = tether && isOriginSide ? (0, $b5qu5.withinMaxClamp)(_tetherMin, _offset, _tetherMax) : (0, $b5qu5.within)(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);
        popperOffsets[altAxis] = _preventedOffset;
        data[altAxis] = _preventedOffset - _offset;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $ca1d8fd29157d544$export$2e2bcd8739ae039 = {
    name: 'preventOverflow',
    enabled: true,
    phase: 'main',
    fn: $ca1d8fd29157d544$var$preventOverflow,
    requiresIfExists: [
        'offset'
    ]
};

});
parcelRegister("2x9Hn", function(module, exports) {
$parcel$export(module.exports, "default", () => $1d862fcd66e44014$export$2e2bcd8739ae039);
function $1d862fcd66e44014$export$2e2bcd8739ae039(axis) {
    return axis === 'x' ? 'y' : 'x';
}

});

parcelRegister("b5qu5", function(module, exports) {
$parcel$export(module.exports, "within", () => $8124b495417018b8$export$f28d906d67a997f3);
$parcel$export(module.exports, "withinMaxClamp", () => $8124b495417018b8$export$86c8af6d3ef0b4a);

var $kDvUD = parcelRequire("kDvUD");
function $8124b495417018b8$export$f28d906d67a997f3(min, value, max) {
    return (0, $kDvUD.max)(min, (0, $kDvUD.min)(value, max));
}
function $8124b495417018b8$export$86c8af6d3ef0b4a(min, value, max) {
    var v = $8124b495417018b8$export$f28d906d67a997f3(min, value, max);
    return v > max ? max : v;
}

});


parcelRegister("1ISmI", function(module, exports) {
$parcel$export(module.exports, "default", () => $14141253d5c51d60$export$2e2bcd8739ae039);

var $5DtdC = parcelRequire("5DtdC");

var $cI2gV = parcelRequire("cI2gV");

var $kIXW4 = parcelRequire("kIXW4");

var $b40rk = parcelRequire("b40rk");

var $9WY3v = parcelRequire("9WY3v");

var $b5qu5 = parcelRequire("b5qu5");

var $1kKwt = parcelRequire("1kKwt");

var $737LB = parcelRequire("737LB");

var $eeoSb = parcelRequire("eeoSb");
var $14141253d5c51d60$var$toPaddingObject = function toPaddingObject(padding, state) {
    padding = typeof padding === 'function' ? padding(Object.assign({}, state.rects, {
        placement: state.placement
    })) : padding;
    return (0, $1kKwt.default)(typeof padding !== 'number' ? padding : (0, $737LB.default)(padding, (0, $eeoSb.basePlacements)));
};
function $14141253d5c51d60$var$arrow(_ref) {
    var _state$modifiersData$;
    var state = _ref.state, name = _ref.name, options = _ref.options;
    var arrowElement = state.elements.arrow;
    var popperOffsets = state.modifiersData.popperOffsets;
    var basePlacement = (0, $5DtdC.default)(state.placement);
    var axis = (0, $9WY3v.default)(basePlacement);
    var isVertical = [
        (0, $eeoSb.left),
        (0, $eeoSb.right)
    ].indexOf(basePlacement) >= 0;
    var len = isVertical ? 'height' : 'width';
    if (!arrowElement || !popperOffsets) return;
    var paddingObject = $14141253d5c51d60$var$toPaddingObject(options.padding, state);
    var arrowRect = (0, $cI2gV.default)(arrowElement);
    var minProp = axis === 'y' ? (0, $eeoSb.top) : (0, $eeoSb.left);
    var maxProp = axis === 'y' ? (0, $eeoSb.bottom) : (0, $eeoSb.right);
    var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
    var startDiff = popperOffsets[axis] - state.rects.reference[axis];
    var arrowOffsetParent = (0, $b40rk.default)(arrowElement);
    var clientSize = arrowOffsetParent ? axis === 'y' ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
    var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
    // outside of the popper bounds
    var min = paddingObject[minProp];
    var max = clientSize - arrowRect[len] - paddingObject[maxProp];
    var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
    var offset = (0, $b5qu5.within)(min, center, max); // Prevents breaking syntax highlighting...
    var axisProp = axis;
    state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}
function $14141253d5c51d60$var$effect(_ref2) {
    var state = _ref2.state, options = _ref2.options;
    var _options$element = options.element, arrowElement = _options$element === void 0 ? '[data-popper-arrow]' : _options$element;
    if (arrowElement == null) return;
     // CSS selector
    if (typeof arrowElement === 'string') {
        arrowElement = state.elements.popper.querySelector(arrowElement);
        if (!arrowElement) return;
    }
    if (!(0, $kIXW4.default)(state.elements.popper, arrowElement)) return;
    state.elements.arrow = arrowElement;
} // eslint-disable-next-line import/no-unused-modules
var $14141253d5c51d60$export$2e2bcd8739ae039 = {
    name: 'arrow',
    enabled: true,
    phase: 'main',
    fn: $14141253d5c51d60$var$arrow,
    effect: $14141253d5c51d60$var$effect,
    requires: [
        'popperOffsets'
    ],
    requiresIfExists: [
        'preventOverflow'
    ]
};

});

parcelRegister("hoRGB", function(module, exports) {
$parcel$export(module.exports, "default", () => $caae528698324902$export$2e2bcd8739ae039);

var $eeoSb = parcelRequire("eeoSb");

var $a9NCa = parcelRequire("a9NCa");
function $caae528698324902$var$getSideOffsets(overflow, rect, preventedOffsets) {
    if (preventedOffsets === void 0) preventedOffsets = {
        x: 0,
        y: 0
    };
    return {
        top: overflow.top - rect.height - preventedOffsets.y,
        right: overflow.right - rect.width + preventedOffsets.x,
        bottom: overflow.bottom - rect.height + preventedOffsets.y,
        left: overflow.left - rect.width - preventedOffsets.x
    };
}
function $caae528698324902$var$isAnySideFullyClipped(overflow) {
    return [
        (0, $eeoSb.top),
        (0, $eeoSb.right),
        (0, $eeoSb.bottom),
        (0, $eeoSb.left)
    ].some(function(side) {
        return overflow[side] >= 0;
    });
}
function $caae528698324902$var$hide(_ref) {
    var state = _ref.state, name = _ref.name;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var preventedOffsets = state.modifiersData.preventOverflow;
    var referenceOverflow = (0, $a9NCa.default)(state, {
        elementContext: 'reference'
    });
    var popperAltOverflow = (0, $a9NCa.default)(state, {
        altBoundary: true
    });
    var referenceClippingOffsets = $caae528698324902$var$getSideOffsets(referenceOverflow, referenceRect);
    var popperEscapeOffsets = $caae528698324902$var$getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
    var isReferenceHidden = $caae528698324902$var$isAnySideFullyClipped(referenceClippingOffsets);
    var hasPopperEscaped = $caae528698324902$var$isAnySideFullyClipped(popperEscapeOffsets);
    state.modifiersData[name] = {
        referenceClippingOffsets: referenceClippingOffsets,
        popperEscapeOffsets: popperEscapeOffsets,
        isReferenceHidden: isReferenceHidden,
        hasPopperEscaped: hasPopperEscaped
    };
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-reference-hidden': isReferenceHidden,
        'data-popper-escaped': hasPopperEscaped
    });
} // eslint-disable-next-line import/no-unused-modules
var $caae528698324902$export$2e2bcd8739ae039 = {
    name: 'hide',
    enabled: true,
    phase: 'main',
    requiresIfExists: [
        'preventOverflow'
    ],
    fn: $caae528698324902$var$hide
};

});


parcelRegister("dcrmD", function(module, exports) {
/* global Map:readonly, Set:readonly, ArrayBuffer:readonly */ var $99c19f4408065da5$var$hasElementType = typeof Element !== 'undefined';
var $99c19f4408065da5$var$hasMap = typeof Map === 'function';
var $99c19f4408065da5$var$hasSet = typeof Set === 'function';
var $99c19f4408065da5$var$hasArrayBuffer = typeof ArrayBuffer === 'function' && !!ArrayBuffer.isView;
// Note: We **don't** need `envHasBigInt64Array` in fde es6/index.js
function $99c19f4408065da5$var$equal(a, b) {
    // START: fast-deep-equal es6/index.js 3.1.3
    if (a === b) return true;
    if (a && b && typeof a == 'object' && typeof b == 'object') {
        if (a.constructor !== b.constructor) return false;
        var length, i, keys;
        if (Array.isArray(a)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (!$99c19f4408065da5$var$equal(a[i], b[i])) return false;
            return true;
        }
        // START: Modifications:
        // 1. Extra `has<Type> &&` helpers in initial condition allow es6 code
        //    to co-exist with es5.
        // 2. Replace `for of` with es5 compliant iteration using `for`.
        //    Basically, take:
        //
        //    ```js
        //    for (i of a.entries())
        //      if (!b.has(i[0])) return false;
        //    ```
        //
        //    ... and convert to:
        //
        //    ```js
        //    it = a.entries();
        //    while (!(i = it.next()).done)
        //      if (!b.has(i.value[0])) return false;
        //    ```
        //
        //    **Note**: `i` access switches to `i.value`.
        var it;
        if ($99c19f4408065da5$var$hasMap && a instanceof Map && b instanceof Map) {
            if (a.size !== b.size) return false;
            it = a.entries();
            while(!(i = it.next()).done)if (!b.has(i.value[0])) return false;
            it = a.entries();
            while(!(i = it.next()).done)if (!$99c19f4408065da5$var$equal(i.value[1], b.get(i.value[0]))) return false;
            return true;
        }
        if ($99c19f4408065da5$var$hasSet && a instanceof Set && b instanceof Set) {
            if (a.size !== b.size) return false;
            it = a.entries();
            while(!(i = it.next()).done)if (!b.has(i.value[0])) return false;
            return true;
        }
        // END: Modifications
        if ($99c19f4408065da5$var$hasArrayBuffer && ArrayBuffer.isView(a) && ArrayBuffer.isView(b)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (a[i] !== b[i]) return false;
            return true;
        }
        if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
        // START: Modifications:
        // Apply guards for `Object.create(null)` handling. See:
        // - https://github.com/FormidableLabs/react-fast-compare/issues/64
        // - https://github.com/epoberezkin/fast-deep-equal/issues/49
        if (a.valueOf !== Object.prototype.valueOf && typeof a.valueOf === 'function' && typeof b.valueOf === 'function') return a.valueOf() === b.valueOf();
        if (a.toString !== Object.prototype.toString && typeof a.toString === 'function' && typeof b.toString === 'function') return a.toString() === b.toString();
        // END: Modifications
        keys = Object.keys(a);
        length = keys.length;
        if (length !== Object.keys(b).length) return false;
        for(i = length; i-- !== 0;)if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
        // END: fast-deep-equal
        // START: react-fast-compare
        // custom handling for DOM elements
        if ($99c19f4408065da5$var$hasElementType && a instanceof Element) return false;
        // custom handling for React/Preact
        for(i = length; i-- !== 0;){
            if ((keys[i] === '_owner' || keys[i] === '__v' || keys[i] === '__o') && a.$$typeof) continue;
            // all other properties should be traversed as usual
            if (!$99c19f4408065da5$var$equal(a[keys[i]], b[keys[i]])) return false;
        }
        // END: react-fast-compare
        // START: fast-deep-equal
        return true;
    }
    return a !== a && b !== b;
}
// end fast-deep-equal
module.exports = function isEqual(a, b) {
    try {
        return $99c19f4408065da5$var$equal(a, b);
    } catch (error) {
        if ((error.message || '').match(/stack|recursion/i)) {
            // warn on circular references, don't crash
            // browsers give this different errors name and messages:
            // chrome/safari: "RangeError", "Maximum call stack size exceeded"
            // firefox: "InternalError", too much recursion"
            // edge: "Error", "Out of stack space"
            console.warn('react-fast-compare cannot handle circular refs');
            return false;
        }
        // some other error. we should definitely know about these
        throw error;
    }
};

});



parcelRegister("cAVP0", function(module, exports) {
$parcel$export(module.exports, "default", () => $92b5b303238413ad$export$2e2bcd8739ae039);
/**
 * Returns a CSS custom property value with an optional suffix & prefix.
 * Prefix will only be added if there is a suffix.
 * If the value is undefined a fallback value will be returned to prevent children inheriting parent values.
 *
 * @param value
 * @param suffix
 * @param prefix
 */ function $92b5b303238413ad$export$2e2bcd8739ae039(value, suffix, prefix) {
    if (value != undefined) {
        if (suffix) {
            if (prefix) return prefix + value + suffix;
            return value + suffix;
        }
        return value;
    }
    // Currently React trims these values so we can't use a space " " to block the value.
    // Instead we use a CSS variable that doesn't exist which falls back to " ".
    // Bug raised here: https://github.com/facebook/react/issues/20497
    return 'var(--c-, )';
}

});

parcelRegister("afMOk", function(module, exports) {
$parcel$export(module.exports, "default", () => $77712ae8b5d25352$export$2e2bcd8739ae039);
var $77712ae8b5d25352$var$isProduction = true;
var $77712ae8b5d25352$var$prefix = 'Invariant failed';
function $77712ae8b5d25352$export$2e2bcd8739ae039(condition, message) {
    if (condition) return;
    if ($77712ae8b5d25352$var$isProduction) throw new Error($77712ae8b5d25352$var$prefix);
    var provided = typeof message === 'function' ? message() : message;
    var value = provided ? "".concat($77712ae8b5d25352$var$prefix, ": ").concat(provided) : $77712ae8b5d25352$var$prefix;
    throw new Error(value);
}

});

parcelRegister("6eqzM", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::03f86cbf4091cea96938f1feb145f315>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4898aa5267f26f35$var$_react = $4898aa5267f26f35$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $4898aa5267f26f35$var$_UNSAFE_baseNew = $4898aa5267f26f35$var$_interopRequireDefault((parcelRequire("bPdWt")));
function $4898aa5267f26f35$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Close".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for closing an element.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $4898aa5267f26f35$var$CloseIcon = (props)=>/*#__PURE__*/ $4898aa5267f26f35$var$_react.default.createElement($4898aa5267f26f35$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M2.5 13.5 8 8m5.5-5.5L8 8m0 0L2.5 2.5M8 8l5.5 5.5"/>`
    }, props));
$4898aa5267f26f35$var$CloseIcon.displayName = 'CloseIcon';
var $4898aa5267f26f35$var$_default = module.exports.default = $4898aa5267f26f35$var$CloseIcon;

});
parcelRegister("bPdWt", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => (parcelRequire("jpq6X")).default);
$parcel$export(module.exports, "Icon", () => (parcelRequire("jpq6X")).Icon);

var $jpq6X = parcelRequire("jpq6X");

});
parcelRegister("jpq6X", function(module, exports) {
$parcel$export(module.exports, "Icon", () => $e2149b474c781d8d$export$f04a61298a47a40f);
$parcel$export(module.exports, "default", () => $e2149b474c781d8d$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5FkrB = parcelRequire("5FkrB");

var $74Zh5 = parcelRequire("74Zh5");

var $5Y2Mt = parcelRequire("5Y2Mt");
/**
 * We are hiding this props from consumers as it's reserved
 * for use by Icon Tile.
 */ var $e2149b474c781d8d$var$commonSVGStyles = (0, $74Zh5.css)({
    overflow: 'hidden',
    pointerEvents: 'none',
    /**
   * Stop-color doesn't properly apply in chrome when the inherited/current color changes.
   * We have to initially set stop-color to inherit (either via DOM attribute or an initial CSS
   * rule) and then override it with currentColor for the color changes to be picked up.
   */ // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    stop: {
        stopColor: 'currentColor'
    }
});
var $e2149b474c781d8d$var$svgStyles = (0, $74Zh5.css)({
    color: 'currentColor',
    verticalAlign: 'bottom'
});
var $e2149b474c781d8d$var$iconStyles = (0, $74Zh5.css)({
    display: 'inline-block',
    boxSizing: 'border-box',
    flexShrink: 0,
    lineHeight: 1,
    paddingInlineEnd: 'var(--ds--button--new-icon-padding-end, 0)',
    paddingInlineStart: 'var(--ds--button--new-icon-padding-start, 0)'
});
var $e2149b474c781d8d$var$utilityIconStyles = (0, $74Zh5.css)({
    lineHeight: "var(--ds-space-150, 12px)"
});
var $e2149b474c781d8d$var$scaleStyles = (0, $74Zh5.css)({
    width: 'inherit',
    height: 'inherit'
});
/**
 * For windows high contrast mode
 */ var $e2149b474c781d8d$var$baseHcmStyles = (0, $74Zh5.css)({
    '@media screen and (forced-colors: active)': {
        color: 'CanvasText',
        filter: 'grayscale(1)'
    }
});
var $e2149b474c781d8d$var$scaleSize = (0, $74Zh5.css)({
    width: 'inherit',
    height: 'inherit'
});
var $e2149b474c781d8d$var$sizeMap = {
    core: {
        none: (0, $74Zh5.css)({
            width: "var(--ds-space-200, 16px)",
            height: "var(--ds-space-200, 16px)"
        }),
        spacious: (0, $74Zh5.css)({
            width: "var(--ds-space-300, 24px)",
            height: "var(--ds-space-300, 24px)"
        })
    },
    utility: {
        none: (0, $74Zh5.css)({
            width: "var(--ds-space-150, 12px)",
            height: "var(--ds-space-150, 12px)"
        }),
        compact: (0, $74Zh5.css)({
            width: "var(--ds-space-200, 16px)",
            height: "var(--ds-space-200, 16px)"
        }),
        spacious: (0, $74Zh5.css)({
            width: "var(--ds-space-300, 24px)",
            height: "var(--ds-space-300, 24px)"
        })
    }
};
var $e2149b474c781d8d$var$baseSizeMap = {
    core: 16,
    utility: 12
};
var $e2149b474c781d8d$var$paddingMap = {
    core: {
        none: 0,
        spacious: 4
    },
    utility: {
        none: 0,
        compact: 2,
        spacious: 6
    }
};
var $e2149b474c781d8d$export$f04a61298a47a40f = /*#__PURE__*/ (0, $5FkrB.memo)(function Icon(props) {
    var _props$type, _props$spacing3, _props$spacing4;
    var _ref = props, _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, testId = _ref.testId, label = _ref.label, LEGACY_primaryColor = _ref.LEGACY_primaryColor, LEGACY_secondaryColor = _ref.LEGACY_secondaryColor, LEGACY_size = _ref.LEGACY_size, FallbackIcon = _ref.LEGACY_fallbackIcon, dangerouslySetGlyph = _ref.dangerouslySetGlyph, shouldScale = _ref.shouldScale, LEGACY_margin = _ref.LEGACY_margin;
    var dangerouslySetInnerHTML = dangerouslySetGlyph ? {
        __html: dangerouslySetGlyph
    } : undefined;
    // Fall back to old icon
    if (FallbackIcon && !(0, $5Y2Mt.fg)('platform-visual-refresh-icons')) // parse out unnecessary props
    return (0, $74Zh5.jsx)(FallbackIcon, {
        primaryColor: LEGACY_primaryColor !== null && LEGACY_primaryColor !== void 0 ? LEGACY_primaryColor : color,
        secondaryColor: LEGACY_secondaryColor,
        size: LEGACY_size,
        label: label,
        testId: testId,
        UNSAFE_margin: LEGACY_margin
    });
    var baseSize = $e2149b474c781d8d$var$baseSizeMap[(_props$type = props.type) !== null && _props$type !== void 0 ? _props$type : 'core'];
    var viewBoxPadding;
    if (props.type === 'utility') {
        var _props$spacing;
        viewBoxPadding = $e2149b474c781d8d$var$paddingMap[props.type][(_props$spacing = props.spacing) !== null && _props$spacing !== void 0 ? _props$spacing : 'none'];
    } else {
        var _props$spacing2;
        viewBoxPadding = $e2149b474c781d8d$var$paddingMap['core'][(_props$spacing2 = props.spacing) !== null && _props$spacing2 !== void 0 ? _props$spacing2 : 'none'];
    }
    var viewBoxSize = baseSize + 2 * viewBoxPadding;
    // Workaround for the transparency in our disabled icon token.
    // Because we have multiple strokes in icons, opacities overlap
    // This filter has an impact on render performance, but this is
    // acceptable as icons aren't commonly disabled en-masse
    var iconColor = color;
    if (dangerouslySetInnerHTML && color === "var(--ds-icon-disabled, #091E424F)") {
        dangerouslySetInnerHTML.__html = "\n<filter id=\"ds-newIconOpacityFilter\">\n  <feFlood flood-color=\"var(--ds-icon-disabled)\" />\n  <feComposite in2=\"SourceGraphic\" operator=\"in\" />\n</filter>\n<g filter=\"url(#ds-newIconOpacityFilter)\">\n  ".concat(dangerouslySetInnerHTML.__html, "\n</g>");
        iconColor = "var(--ds-icon, #44546F)";
    }
    return (0, $74Zh5.jsx)("span", {
        "data-testid": testId,
        role: label ? 'img' : undefined,
        "aria-label": label ? label : undefined,
        "aria-hidden": label ? undefined : true,
        style: {
            color: iconColor
        },
        css: [
            $e2149b474c781d8d$var$iconStyles,
            $e2149b474c781d8d$var$baseHcmStyles,
            shouldScale && $e2149b474c781d8d$var$scaleStyles,
            props.type === 'utility' && $e2149b474c781d8d$var$utilityIconStyles
        ]
    }, (0, $74Zh5.jsx)("svg", {
        fill: "none",
        viewBox: "".concat(0 - viewBoxPadding, " ").concat(0 - viewBoxPadding, " ").concat(viewBoxSize, " ").concat(viewBoxSize),
        role: "presentation",
        css: [
            $e2149b474c781d8d$var$commonSVGStyles,
            $e2149b474c781d8d$var$svgStyles,
            shouldScale ? $e2149b474c781d8d$var$scaleSize : props.type === 'utility' ? $e2149b474c781d8d$var$sizeMap[props.type][(_props$spacing3 = props.spacing) !== null && _props$spacing3 !== void 0 ? _props$spacing3 : 'none'] : $e2149b474c781d8d$var$sizeMap['core'][(_props$spacing4 = props.spacing) !== null && _props$spacing4 !== void 0 ? _props$spacing4 : 'none']
        ],
        dangerouslySetInnerHTML: dangerouslySetInnerHTML
    }));
});
var $e2149b474c781d8d$export$2e2bcd8739ae039 = $e2149b474c781d8d$export$f04a61298a47a40f;

});
parcelRegister("5Y2Mt", function(module, exports) {
$parcel$export(module.exports, "fg", () => $4584b692e0bf28ba$export$b40ec24ac8275656);

var $3lNzr = parcelRequire("3lNzr");
function $4584b692e0bf28ba$export$ba05d765b8392e5e(flagResolver) {
    (0, $3lNzr.setBooleanResolver)(flagResolver);
}
function $4584b692e0bf28ba$export$470e5c2be1411c89(name) {
    return (0, $3lNzr.resolveBooleanFlag)(name);
}
function $4584b692e0bf28ba$export$b40ec24ac8275656(name) {
    return (0, $3lNzr.resolveBooleanFlag)(name);
}

});
parcelRegister("3lNzr", function(module, exports) {
$parcel$export(module.exports, "setBooleanResolver", () => $2709c8f7e7bb8045$export$f2b591175b3e424c);
$parcel$export(module.exports, "resolveBooleanFlag", () => $2709c8f7e7bb8045$export$6333b6aff9fc6275);

var $fv8wc = parcelRequire("fv8wc");

var $3ZMUU = parcelRequire("3ZMUU");
var $2709c8f7e7bb8045$var$pkgName = '@atlaskit/platform-feature-flags';
var $2709c8f7e7bb8045$export$7e41b1b2bdee3f98 = '__PLATFORM_FEATURE_FLAGS__';
var $2709c8f7e7bb8045$var$hasProcessEnv = typeof $3ZMUU !== 'undefined' && typeof $3ZMUU.env !== 'undefined';
// FF global overrides can be configured by test runners or Storybook
var $2709c8f7e7bb8045$var$ENV_ENABLE_PLATFORM_FF = $2709c8f7e7bb8045$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
// STORYBOOK_ENABLE_PLATFORM_FF is included as storybook only allows env vars prefixed with STORYBOOK
// https://github.com/storybookjs/storybook/issues/12270
var $2709c8f7e7bb8045$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF = $2709c8f7e7bb8045$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
var $2709c8f7e7bb8045$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE = $2709c8f7e7bb8045$var$ENV_ENABLE_PLATFORM_FF || $2709c8f7e7bb8045$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF;
var $2709c8f7e7bb8045$var$DEFAULT_PFF_GLOBAL = {
    // In development mode we want to capture any feature flag checks that happen using the default resolver and log this result when the resolver is replaced.
    // This is because evaluating feature flags when the resolver/FF client is loaded asynchronously could cause unexpected issues.
    earlyResolvedFlags: new Map(),
    booleanResolver: function booleanResolver(flagKey) {
        var unresolvedFlagCount;
        return false;
    }
};
var $2709c8f7e7bb8045$var$globalVar = typeof window !== 'undefined' ? window : globalThis;
$2709c8f7e7bb8045$var$globalVar[$2709c8f7e7bb8045$export$7e41b1b2bdee3f98] = $2709c8f7e7bb8045$var$globalVar[$2709c8f7e7bb8045$export$7e41b1b2bdee3f98] || $2709c8f7e7bb8045$var$DEFAULT_PFF_GLOBAL;
function $2709c8f7e7bb8045$export$f2b591175b3e424c(resolver) {
    $2709c8f7e7bb8045$var$globalVar[$2709c8f7e7bb8045$export$7e41b1b2bdee3f98].booleanResolver = resolver;
    var _globalVar$PFF_GLOBAL;
}
function $2709c8f7e7bb8045$export$6333b6aff9fc6275(flagKey) {
    if ($2709c8f7e7bb8045$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE) {
        (0, $fv8wc.debug)('[%s]: The feature flags were enabled while running tests. The flag "%s" will be always enabled.', $2709c8f7e7bb8045$var$pkgName, flagKey);
        return true;
    }
    try {
        var _globalVar$PFF_GLOBAL2;
        var result = (_globalVar$PFF_GLOBAL2 = $2709c8f7e7bb8045$var$globalVar[$2709c8f7e7bb8045$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL2 === void 0 ? void 0 : _globalVar$PFF_GLOBAL2.booleanResolver(flagKey);
        if (typeof result !== 'boolean') {
            // eslint-disable-next-line no-console
            console.warn("".concat(flagKey, " resolved to a non-boolean value, returning false for safety"));
            return false;
        }
        return result;
    } catch (e) {
        return false;
    }
}

});
parcelRegister("fv8wc", function(module, exports) {
$parcel$export(module.exports, "debug", () => $b4905bd7c6b84ead$export$1c9f709888824e05);
var $b4905bd7c6b84ead$var$_ref, $b4905bd7c6b84ead$var$_process, $b4905bd7c6b84ead$var$_process2;
// We can't rely on NODE_ENV === 'test' if its value is already configured by the consumer to some other value, so better to use JEST_WORKER_ID
// https://jestjs.io/docs/environment-variables#jest_worker_id
var $b4905bd7c6b84ead$var$TESTS_MODE = ($b4905bd7c6b84ead$var$_ref = (globalThis === null || globalThis === void 0 || ($b4905bd7c6b84ead$var$_process = globalThis.process) === null || $b4905bd7c6b84ead$var$_process === void 0 || ($b4905bd7c6b84ead$var$_process = $b4905bd7c6b84ead$var$_process.env) === null || $b4905bd7c6b84ead$var$_process === void 0 ? void 0 : $b4905bd7c6b84ead$var$_process.JEST_WORKER_ID) !== undefined, $b4905bd7c6b84ead$var$_ref !== void 0) ? $b4905bd7c6b84ead$var$_ref : false;
var $b4905bd7c6b84ead$var$DEBUG_MODE = !$b4905bd7c6b84ead$var$TESTS_MODE && (globalThis === null || globalThis === void 0 || ($b4905bd7c6b84ead$var$_process2 = globalThis.process) === null || $b4905bd7c6b84ead$var$_process2 === void 0 || ($b4905bd7c6b84ead$var$_process2 = $b4905bd7c6b84ead$var$_process2.env) === null || $b4905bd7c6b84ead$var$_process2 === void 0 ? void 0 : $b4905bd7c6b84ead$var$_process2.NODE_ENV) !== 'production';
var $b4905bd7c6b84ead$export$1c9f709888824e05 = function debug() {
    var _console;
    if (!$b4905bd7c6b84ead$var$DEBUG_MODE) return;
    // eslint-disable-next-line no-console
    (_console = console).debug.apply(_console, arguments);
};

});






parcelRegister("aBp15", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6bfe67a5a24a2dcfb0853d331aeb2068>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7b80c3d6520e58ce$var$_react = $7b80c3d6520e58ce$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $7b80c3d6520e58ce$var$_UNSAFE_baseNew = $7b80c3d6520e58ce$var$_interopRequireDefault((parcelRequire("bPdWt")));
function $7b80c3d6520e58ce$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "ArrowUpRight".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $7b80c3d6520e58ce$var$ArrowUpRightIcon = (props)=>/*#__PURE__*/ $7b80c3d6520e58ce$var$_react.default.createElement($7b80c3d6520e58ce$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="m3 13 9.25-9.25m-6.5-.5h7v7"/>`
    }, props));
$7b80c3d6520e58ce$var$ArrowUpRightIcon.displayName = 'ArrowUpRightIcon';
var $7b80c3d6520e58ce$var$_default = module.exports.default = $7b80c3d6520e58ce$var$ArrowUpRightIcon;

});

parcelRegister("exnso", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d8cb0749e395cf6d25ab2f6745905850>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a95657d5bf2b1720$var$_react = $a95657d5bf2b1720$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $a95657d5bf2b1720$var$_UNSAFE_baseNew = $a95657d5bf2b1720$var$_interopRequireDefault((parcelRequire("bPdWt")));
function $a95657d5bf2b1720$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Download".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for file downloads.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a95657d5bf2b1720$var$DownloadIcon = (props)=>/*#__PURE__*/ $a95657d5bf2b1720$var$_react.default.createElement($a95657d5bf2b1720$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M1.75 9v4c0 .69.56 1.25 1.25 1.25h10c.69 0 1.25-.56 1.25-1.25V9M8 1v8.75m-4-3.5 4 4 4-4"/>`
    }, props));
$a95657d5bf2b1720$var$DownloadIcon.displayName = 'DownloadIcon';
var $a95657d5bf2b1720$var$_default = module.exports.default = $a95657d5bf2b1720$var$DownloadIcon;

});

parcelRegister("ln0Ih", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d611fb3947c00fee344914368e144168>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f8ec4c98b0af414e$var$_react = $f8ec4c98b0af414e$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $f8ec4c98b0af414e$var$_UNSAFE_baseNew = $f8ec4c98b0af414e$var$_interopRequireDefault((parcelRequire("bPdWt")));
function $f8ec4c98b0af414e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Location".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: location in Atlas.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $f8ec4c98b0af414e$var$LocationIcon = (props)=>/*#__PURE__*/ $f8ec4c98b0af414e$var$_react.default.createElement($f8ec4c98b0af414e$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M3.677 8.982 8 15.25l4.323-6.268C14.725 5.5 12.232.75 8 .75c-4.231 0-6.725 4.749-4.323 8.232Z"/><path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M9.75 6a1.75 1.75 0 1 1-3.5 0 1.75 1.75 0 0 1 3.5 0Z"/>`
    }, props));
$f8ec4c98b0af414e$var$LocationIcon.displayName = 'LocationIcon';
var $f8ec4c98b0af414e$var$_default = module.exports.default = $f8ec4c98b0af414e$var$LocationIcon;

});

parcelRegister("jfDBU", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::28198ce9e0c3202094e2855b88c09086>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e03e24db334664c9$var$_react = $e03e24db334664c9$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $e03e24db334664c9$var$_UNSAFE_baseNew = $e03e24db334664c9$var$_interopRequireDefault((parcelRequire("bPdWt")));
function $e03e24db334664c9$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Add".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for creating and adding an object.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $e03e24db334664c9$var$AddIcon = (props)=>/*#__PURE__*/ $e03e24db334664c9$var$_react.default.createElement($e03e24db334664c9$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-width="1.5" d="M8 8h7M8 8H1m7 0V1m0 7v7"/>`
    }, props));
$e03e24db334664c9$var$AddIcon.displayName = 'AddIcon';
var $e03e24db334664c9$var$_default = module.exports.default = $e03e24db334664c9$var$AddIcon;

});

parcelRegister("ldiUp", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d8eff4e7c48a4dd161566c1dd735476d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f7197ac65ba3f230$var$_react = $f7197ac65ba3f230$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $f7197ac65ba3f230$var$_UNSAFE_baseNew = $f7197ac65ba3f230$var$_interopRequireDefault((parcelRequire("bPdWt")));
function $f7197ac65ba3f230$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "ArrowLeft".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: back to previous screen, previous slide.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $f7197ac65ba3f230$var$ArrowLeftIcon = (props)=>/*#__PURE__*/ $f7197ac65ba3f230$var$_react.default.createElement($f7197ac65ba3f230$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M15 8H2.25m4.5-5-5 5 5 5"/>`
    }, props));
$f7197ac65ba3f230$var$ArrowLeftIcon.displayName = 'ArrowLeftIcon';
var $f7197ac65ba3f230$var$_default = module.exports.default = $f7197ac65ba3f230$var$ArrowLeftIcon;

});

parcelRegister("5GKWl", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6a0af1361c1c47b464cd1f3e8c2b50c2>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4245494da0fe5130$var$_react = $4245494da0fe5130$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $4245494da0fe5130$var$_UNSAFE_baseNew = $4245494da0fe5130$var$_interopRequireDefault((parcelRequire("bPdWt")));
function $4245494da0fe5130$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "ArrowRight".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: link to nested menu item, a linked menu item, next slide.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $4245494da0fe5130$var$ArrowRightIcon = (props)=>/*#__PURE__*/ $4245494da0fe5130$var$_react.default.createElement($4245494da0fe5130$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M1 8h12.75m-4.5-5 5 5-5 5"/>`
    }, props));
$4245494da0fe5130$var$ArrowRightIcon.displayName = 'ArrowRightIcon';
var $4245494da0fe5130$var$_default = module.exports.default = $4245494da0fe5130$var$ArrowRightIcon;

});

parcelRegister("5mlBi", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f57cdfdfff00f4122214ded49823394f>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3e6fc33902ea2145$var$_react = $3e6fc33902ea2145$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $3e6fc33902ea2145$var$_UNSAFE_baseNew = $3e6fc33902ea2145$var$_interopRequireDefault((parcelRequire("bPdWt")));
function $3e6fc33902ea2145$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "ArrowUp".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: back to top.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $3e6fc33902ea2145$var$ArrowUpIcon = (props)=>/*#__PURE__*/ $3e6fc33902ea2145$var$_react.default.createElement($3e6fc33902ea2145$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M8 15V2.25m-5 4.5 5-5 5 5"/>`
    }, props));
$3e6fc33902ea2145$var$ArrowUpIcon.displayName = 'ArrowUpIcon';
var $3e6fc33902ea2145$var$_default = module.exports.default = $3e6fc33902ea2145$var$ArrowUpIcon;

});

parcelRegister("bE62y", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::209317c625743d387bf26edea0c296a9>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $87a81d9353dfd9e5$var$_react = $87a81d9353dfd9e5$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $87a81d9353dfd9e5$var$_UNSAFE_baseNew = $87a81d9353dfd9e5$var$_interopRequireDefault((parcelRequire("bPdWt")));
function $87a81d9353dfd9e5$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "CheckMark".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: table cells, checkboxes.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $87a81d9353dfd9e5$var$CheckMarkIcon = (props)=>/*#__PURE__*/ $87a81d9353dfd9e5$var$_react.default.createElement($87a81d9353dfd9e5$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="m1.5 8 4.25 5.25 8.75-10.5"/>`
    }, props));
$87a81d9353dfd9e5$var$CheckMarkIcon.displayName = 'CheckMarkIcon';
var $87a81d9353dfd9e5$var$_default = module.exports.default = $87a81d9353dfd9e5$var$CheckMarkIcon;

});

parcelRegister("4AP9B", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3f4494144da7877c599489a550534c1d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3582344d7fa5dcf3$var$_react = $3582344d7fa5dcf3$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $3582344d7fa5dcf3$var$_UNSAFE_baseNew = $3582344d7fa5dcf3$var$_interopRequireDefault((parcelRequire("bPdWt")));
function $3582344d7fa5dcf3$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Success".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single-purpose - Reserved for success section messages and form validation messages.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $3582344d7fa5dcf3$var$SuccessIcon = (props)=>/*#__PURE__*/ $3582344d7fa5dcf3$var$_react.default.createElement($3582344d7fa5dcf3$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8m12.326-2.52-1.152-.96L6.75 9.828 4.826 7.52l-1.152.96 2.5 3a.75.75 0 0 0 1.152 0z" clip-rule="evenodd"/>`
    }, props));
$3582344d7fa5dcf3$var$SuccessIcon.displayName = 'SuccessIcon';
var $3582344d7fa5dcf3$var$_default = module.exports.default = $3582344d7fa5dcf3$var$SuccessIcon;

});

parcelRegister("eC7kC", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::33c5439f087752870260bcf48e3a4598>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $aa3a4d38428adcec$var$_react = $aa3a4d38428adcec$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $aa3a4d38428adcec$var$_UNSAFE_baseNew = $aa3a4d38428adcec$var$_interopRequireDefault((parcelRequire("bPdWt")));
function $aa3a4d38428adcec$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "CheckCircle".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: completed items, productivity emoji category. Completed task issue status in JSM Calendar view.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $aa3a4d38428adcec$var$CheckCircleIcon = (props)=>/*#__PURE__*/ $aa3a4d38428adcec$var$_react.default.createElement($aa3a4d38428adcec$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="m4.25 8 2.5 3 5-6M8 .75a7.25 7.25 0 1 0 0 14.5A7.25 7.25 0 0 0 8 .75Z"/>`
    }, props));
$aa3a4d38428adcec$var$CheckCircleIcon.displayName = 'CheckCircleIcon';
var $aa3a4d38428adcec$var$_default = module.exports.default = $aa3a4d38428adcec$var$CheckCircleIcon;

});

parcelRegister("5Y5FQ", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3c58509c5f883b07cf4640f47a045782>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4586f51195fee032$var$_react = $4586f51195fee032$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $4586f51195fee032$var$_UNSAFE_baseNew = $4586f51195fee032$var$_interopRequireDefault((parcelRequire("bPdWt")));
function $4586f51195fee032$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "ChevronDown".
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for dropdown menus, selects, accordions, and expands.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $4586f51195fee032$var$ChevronDownIcon = (props)=>/*#__PURE__*/ $4586f51195fee032$var$_react.default.createElement($4586f51195fee032$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M10.5 4.5 8.25 6.75 6 9 3.75 6.75 1.5 4.5"/>`,
        type: 'utility'
    }, props));
$4586f51195fee032$var$ChevronDownIcon.displayName = 'ChevronDownIcon';
var $4586f51195fee032$var$_default = module.exports.default = $4586f51195fee032$var$ChevronDownIcon;

});

parcelRegister("447N2", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::53517bd082840f7b30aeaa6b952f5491>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2f5d940f7dfc484b$var$_react = $2f5d940f7dfc484b$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $2f5d940f7dfc484b$var$_UNSAFE_baseNew = $2f5d940f7dfc484b$var$_interopRequireDefault((parcelRequire("bPdWt")));
function $2f5d940f7dfc484b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "ChevronLeft".
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for collapse side nav and to indicate previous in dates.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $2f5d940f7dfc484b$var$ChevronLeftIcon = (props)=>/*#__PURE__*/ $2f5d940f7dfc484b$var$_react.default.createElement($2f5d940f7dfc484b$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M7.5 10.5 3 6l4.5-4.5"/>`,
        type: 'utility'
    }, props));
$2f5d940f7dfc484b$var$ChevronLeftIcon.displayName = 'ChevronLeftIcon';
var $2f5d940f7dfc484b$var$_default = module.exports.default = $2f5d940f7dfc484b$var$ChevronLeftIcon;

});

parcelRegister("jiU5J", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a9bfbdf898b5516a0a7c630d609b6042>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e0db35598b898136$var$_react = $e0db35598b898136$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $e0db35598b898136$var$_UNSAFE_baseNew = $e0db35598b898136$var$_interopRequireDefault((parcelRequire("bPdWt")));
function $e0db35598b898136$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "ChevronRight".
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for menu fly outs and to indicate next in dates.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $e0db35598b898136$var$ChevronRightIcon = (props)=>/*#__PURE__*/ $e0db35598b898136$var$_react.default.createElement($e0db35598b898136$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M4.5 10.5 9 6 4.5 1.5"/>`,
        type: 'utility'
    }, props));
$e0db35598b898136$var$ChevronRightIcon.displayName = 'ChevronRightIcon';
var $e0db35598b898136$var$_default = module.exports.default = $e0db35598b898136$var$ChevronRightIcon;

});

parcelRegister("cS1ic", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f998c57d427ae10203b04c2186c5e29c>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $95eb87dfd7aaf542$var$_react = $95eb87dfd7aaf542$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $95eb87dfd7aaf542$var$_UNSAFE_baseNew = $95eb87dfd7aaf542$var$_interopRequireDefault((parcelRequire("bPdWt")));
function $95eb87dfd7aaf542$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "ChevronUp".
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for accordions.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $95eb87dfd7aaf542$var$ChevronUpIcon = (props)=>/*#__PURE__*/ $95eb87dfd7aaf542$var$_react.default.createElement($95eb87dfd7aaf542$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M10.5 7.5 6 3 1.5 7.5"/>`,
        type: 'utility'
    }, props));
$95eb87dfd7aaf542$var$ChevronUpIcon.displayName = 'ChevronUpIcon';
var $95eb87dfd7aaf542$var$_default = module.exports.default = $95eb87dfd7aaf542$var$ChevronUpIcon;

});

parcelRegister("gxkfx", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::0ba7502fd657c116f257aba05875c56e>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c09f6f8967b695b2$var$_react = $c09f6f8967b695b2$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $c09f6f8967b695b2$var$_UNSAFE_baseNew = $c09f6f8967b695b2$var$_interopRequireDefault((parcelRequire("bPdWt")));
function $c09f6f8967b695b2$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Copy".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for copying data such as text, code or other objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c09f6f8967b695b2$var$CopyIcon = (props)=>/*#__PURE__*/ $c09f6f8967b695b2$var$_react.default.createElement($c09f6f8967b695b2$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-width="1.5" d="M1.75 3c0-.69.56-1.25 1.25-1.25h8c.69 0 1.25.56 1.25 1.25v8c0 .69-.56 1.25-1.25 1.25H3c-.69 0-1.25-.56-1.25-1.25z"/><path stroke="currentcolor" stroke-width="1.5" d="M6 15.25h6.75a2.5 2.5 0 0 0 2.5-2.5V6"/>`
    }, props));
$c09f6f8967b695b2$var$CopyIcon.displayName = 'CopyIcon';
var $c09f6f8967b695b2$var$_default = module.exports.default = $c09f6f8967b695b2$var$CopyIcon;

});

parcelRegister("dI7Bp", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d48c51235c7072e6617b637653c3f4fe>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9fb5481de0946722$var$_react = $9fb5481de0946722$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $9fb5481de0946722$var$_UNSAFE_baseNew = $9fb5481de0946722$var$_interopRequireDefault((parcelRequire("bPdWt")));
function $9fb5481de0946722$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Edit".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for editing objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $9fb5481de0946722$var$EditIcon = (props)=>/*#__PURE__*/ $9fb5481de0946722$var$_react.default.createElement($9fb5481de0946722$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M6 1.751H3c-.69 0-1.25.56-1.25 1.25v10c0 .69.56 1.25 1.25 1.25h10c.69 0 1.25-.56 1.25-1.25V10m-.75-5 1.116-1.116a1.25 1.25 0 0 0 0-1.768l-.732-.732a1.25 1.25 0 0 0-1.768 0L11 2.5M13.5 5 9.479 9.021c-.15.15-.336.26-.54.318l-3.189.911.911-3.189a1.25 1.25 0 0 1 .318-.54L11 2.5M13.5 5 11 2.5"/>`
    }, props));
$9fb5481de0946722$var$EditIcon.displayName = 'EditIcon';
var $9fb5481de0946722$var$_default = module.exports.default = $9fb5481de0946722$var$EditIcon;

});

parcelRegister("b37du", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ccc84bee668fd63ce995277b659b1b62>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $80b592924604b138$var$_react = $80b592924604b138$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $80b592924604b138$var$_UNSAFE_baseNew = $80b592924604b138$var$_interopRequireDefault((parcelRequire("bPdWt")));
function $80b592924604b138$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "ContentWrapRight".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for right aligning media and content with wrapping enabled.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $80b592924604b138$var$ContentWrapRightIcon = (props)=>/*#__PURE__*/ $80b592924604b138$var$_react.default.createElement($80b592924604b138$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M1 1.75h14M1 14.25h14M1 5.917h6m-6 4.166h6m6.625.167h-3.25a.625.625 0 0 1-.625-.625v-3.25c0-.345.28-.625.625-.625h3.25c.345 0 .625.28.625.625v3.25c0 .345-.28.625-.625.625Z"/>`
    }, props));
$80b592924604b138$var$ContentWrapRightIcon.displayName = 'ContentWrapRightIcon';
var $80b592924604b138$var$_default = module.exports.default = $80b592924604b138$var$ContentWrapRightIcon;

});

parcelRegister("93YpG", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6db48d6c22f8d07c19434865c237f982>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $699341ac301ccbcd$var$_react = $699341ac301ccbcd$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $699341ac301ccbcd$var$_UNSAFE_baseNew = $699341ac301ccbcd$var$_interopRequireDefault((parcelRequire("bPdWt")));
function $699341ac301ccbcd$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Information".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Known uses: information state in section messages or inline messages.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $699341ac301ccbcd$var$InformationIcon = (props)=>/*#__PURE__*/ $699341ac301ccbcd$var$_react.default.createElement($699341ac301ccbcd$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8m6.5-1.25H8a.75.75 0 0 1 .75.75v5h-1.5V8.25H6.5zM8 5.5a1 1 0 1 0 0-2 1 1 0 0 0 0 2" clip-rule="evenodd"/>`
    }, props));
$699341ac301ccbcd$var$InformationIcon.displayName = 'InformationIcon';
var $699341ac301ccbcd$var$_default = module.exports.default = $699341ac301ccbcd$var$InformationIcon;

});

parcelRegister("bWJYo", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4362663ac35e79a0a9cff3b383986020>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8b28c5c2dc2db7c8$var$_react = $8b28c5c2dc2db7c8$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $8b28c5c2dc2db7c8$var$_UNSAFE_baseNew = $8b28c5c2dc2db7c8$var$_interopRequireDefault((parcelRequire("bPdWt")));
function $8b28c5c2dc2db7c8$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Grid".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: spaces in Confluence, and grid view, all content in Confluence.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $8b28c5c2dc2db7c8$var$GridIcon = (props)=>/*#__PURE__*/ $8b28c5c2dc2db7c8$var$_react.default.createElement($8b28c5c2dc2db7c8$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M8 1.75H3c-.69 0-1.25.56-1.25 1.25v5M8 1.75h5c.69 0 1.25.56 1.25 1.25v5M8 1.75v12.5m0 0h5c.69 0 1.25-.56 1.25-1.25V8M8 14.25H3c-.69 0-1.25-.56-1.25-1.25V8m0 0h12.5"/>`
    }, props));
$8b28c5c2dc2db7c8$var$GridIcon.displayName = 'GridIcon';
var $8b28c5c2dc2db7c8$var$_default = module.exports.default = $8b28c5c2dc2db7c8$var$GridIcon;

});

parcelRegister("cJnPm", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::5a48a035a6b6ee27b8a00a2b1992b2cd>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $944c2ba5b5fba3a7$var$_react = $944c2ba5b5fba3a7$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $944c2ba5b5fba3a7$var$_UNSAFE_baseNew = $944c2ba5b5fba3a7$var$_interopRequireDefault((parcelRequire("bPdWt")));
function $944c2ba5b5fba3a7$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Clock".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: recent, time input, sprint time remaining. Overdue task issue status in JSM Calendar view.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $944c2ba5b5fba3a7$var$ClockIcon = (props)=>/*#__PURE__*/ $944c2ba5b5fba3a7$var$_react.default.createElement($944c2ba5b5fba3a7$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-width="1.5" d="M8 3.25V8l2.5 2m4.75-2A7.25 7.25 0 1 1 .75 8a7.25 7.25 0 0 1 14.5 0Z"/>`
    }, props));
$944c2ba5b5fba3a7$var$ClockIcon.displayName = 'ClockIcon';
var $944c2ba5b5fba3a7$var$_default = module.exports.default = $944c2ba5b5fba3a7$var$ClockIcon;

});

parcelRegister("czNKk", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6f2df9b6d4b219d15d7e01ad6e3eb71a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $927f5782c5ac6ee5$var$_react = $927f5782c5ac6ee5$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $927f5782c5ac6ee5$var$_UNSAFE_baseNew = $927f5782c5ac6ee5$var$_interopRequireDefault((parcelRequire("bPdWt")));
function $927f5782c5ac6ee5$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Heart".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: emoji symbols in Editor.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $927f5782c5ac6ee5$var$HeartIcon = (props)=>/*#__PURE__*/ $927f5782c5ac6ee5$var$_react.default.createElement($927f5782c5ac6ee5$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-width="1.5" d="M8 14.5a.6.6 0 0 1-.245-.061 1.5 1.5 0 0 1-.244-.123q-1.917-1.225-3.324-2.567-1.408-1.348-2.176-2.764-.76-1.422-.761-2.873 0-.905.286-1.654.291-.756.808-1.307A3.6 3.6 0 0 1 5.036 2q1 0 1.754.51.754.511 1.21 1.349A3.76 3.76 0 0 1 9.217 2.51Q9.97 2 10.964 2q.801 0 1.488.3.694.3 1.204.85.516.552.802 1.308.292.749.292 1.654 0 1.45-.768 2.873-.761 1.416-2.169 2.765-1.4 1.342-3.317 2.566a1.4 1.4 0 0 1-.251.123A.6.6 0 0 1 8 14.5Z"/>`
    }, props));
$927f5782c5ac6ee5$var$HeartIcon.displayName = 'HeartIcon';
var $927f5782c5ac6ee5$var$_default = module.exports.default = $927f5782c5ac6ee5$var$HeartIcon;

});

parcelRegister("4YUxz", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::8547c3f91abc335ca9c5bbfd88dd7340>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3a089fca738cfe99$var$_react = $3a089fca738cfe99$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $3a089fca738cfe99$var$_UNSAFE_baseNew = $3a089fca738cfe99$var$_interopRequireDefault((parcelRequire("bPdWt")));
function $3a089fca738cfe99$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Error".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for when there is an error.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $3a089fca738cfe99$var$ErrorIcon = (props)=>/*#__PURE__*/ $3a089fca738cfe99$var$_react.default.createElement($3a089fca738cfe99$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6.586.604a2 2 0 0 1 2.828 0l5.982 5.982a2 2 0 0 1 0 2.828l-5.982 5.983a2 2 0 0 1-2.828 0L.604 9.414a2 2 0 0 1 0-2.828zM7.25 9V3.75h1.5V9zM8 12.25a1 1 0 1 0 0-2 1 1 0 0 0 0 2" clip-rule="evenodd"/>`
    }, props));
$3a089fca738cfe99$var$ErrorIcon.displayName = 'ErrorIcon';
var $3a089fca738cfe99$var$_default = module.exports.default = $3a089fca738cfe99$var$ErrorIcon;

});

parcelRegister("ie0cB", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ebc22958da752d07e6dcf81116f518ec>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d449b0f30f542f2d$var$_react = $d449b0f30f542f2d$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $d449b0f30f542f2d$var$_UNSAFE_baseNew = $d449b0f30f542f2d$var$_interopRequireDefault((parcelRequire("bPdWt")));
function $d449b0f30f542f2d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Upload".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for upload in Editor.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $d449b0f30f542f2d$var$UploadIcon = (props)=>/*#__PURE__*/ $d449b0f30f542f2d$var$_react.default.createElement($d449b0f30f542f2d$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M1.75 9v4c0 .69.56 1.25 1.25 1.25h10c.69 0 1.25-.56 1.25-1.25V9M8 11V2.25m-4 3.5 4-4 4 4"/>`
    }, props));
$d449b0f30f542f2d$var$UploadIcon.displayName = 'UploadIcon';
var $d449b0f30f542f2d$var$_default = module.exports.default = $d449b0f30f542f2d$var$UploadIcon;

});

parcelRegister("86XB8", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2e33235fde7b24564b92256907cba586>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5e7d1d2803548c47$var$_react = $5e7d1d2803548c47$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $5e7d1d2803548c47$var$_UNSAFE_baseNew = $5e7d1d2803548c47$var$_interopRequireDefault((parcelRequire("bPdWt")));
function $5e7d1d2803548c47$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Filter".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for filterting data or objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $5e7d1d2803548c47$var$FilterIcon = (props)=>/*#__PURE__*/ $5e7d1d2803548c47$var$_react.default.createElement($5e7d1d2803548c47$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-width="1.5" d="M3 8h10M1 2.75h14M5 13.25h6"/>`
    }, props));
$5e7d1d2803548c47$var$FilterIcon.displayName = 'FilterIcon';
var $5e7d1d2803548c47$var$_default = module.exports.default = $5e7d1d2803548c47$var$FilterIcon;

});

parcelRegister("kmK71", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::00d261b1bfdc09ff1b2f03c198e27896>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ed39a1aa5907c07c$var$_react = $ed39a1aa5907c07c$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $ed39a1aa5907c07c$var$_UNSAFE_baseNew = $ed39a1aa5907c07c$var$_interopRequireDefault((parcelRequire("bPdWt")));
function $ed39a1aa5907c07c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Image".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: images, image upload.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $ed39a1aa5907c07c$var$ImageIcon = (props)=>/*#__PURE__*/ $ed39a1aa5907c07c$var$_react.default.createElement($ed39a1aa5907c07c$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="M6.75 5.75a1 1 0 1 1-2 0 1 1 0 0 1 2 0"/><path fill="currentcolor" fill-rule="evenodd" d="M5.75 6.75a1 1 0 1 0 0-2 1 1 0 0 0 0 2" clip-rule="evenodd"/><path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M4 14.25h9c.69 0 1.25-.56 1.25-1.25v-2M4 14.25H3c-.69 0-1.25-.56-1.25-1.25V3c0-.69.56-1.25 1.25-1.25h10c.69 0 1.25.56 1.25 1.25v8M4 14.25 10 7l4.25 4m-7.5-5.25a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z"/>`
    }, props));
$ed39a1aa5907c07c$var$ImageIcon.displayName = 'ImageIcon';
var $ed39a1aa5907c07c$var$_default = module.exports.default = $ed39a1aa5907c07c$var$ImageIcon;

});

parcelRegister("bgEmk", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::af316a11070150755855d308e4656f28>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $83407ed11bdd347f$var$_react = $83407ed11bdd347f$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $83407ed11bdd347f$var$_UNSAFE_baseNew = $83407ed11bdd347f$var$_interopRequireDefault((parcelRequire("bPdWt")));
function $83407ed11bdd347f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Link".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for links, urls, or copy link.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $83407ed11bdd347f$var$LinkIcon = (props)=>/*#__PURE__*/ $83407ed11bdd347f$var$_react.default.createElement($83407ed11bdd347f$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-width="1.5" d="m5.25 10.75 5.5-5.5M5 6.5 2.75 8.75a3.182 3.182 0 0 0 4.5 4.5L9.5 11m-3-6 2.25-2.25a3.182 3.182 0 0 1 4.5 4.5L11 9.5"/>`
    }, props));
$83407ed11bdd347f$var$LinkIcon.displayName = 'LinkIcon';
var $83407ed11bdd347f$var$_default = module.exports.default = $83407ed11bdd347f$var$LinkIcon;

});

parcelRegister("4cYNL", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ce7319a8e7b6756c4415855e934f6695>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $310772594f388aaa$var$_react = $310772594f388aaa$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $310772594f388aaa$var$_UNSAFE_baseNew = $310772594f388aaa$var$_interopRequireDefault((parcelRequire("bPdWt")));
function $310772594f388aaa$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "ZoomIn".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for zooming in of an object or view.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $310772594f388aaa$var$ZoomInIcon = (props)=>/*#__PURE__*/ $310772594f388aaa$var$_react.default.createElement($310772594f388aaa$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-width="1.5" d="m14.5 14.5-3.788-3.788m0 0a5.25 5.25 0 1 0-7.425-7.425 5.25 5.25 0 0 0 7.425 7.425ZM4 7h3m3 0H7m0 0V4m0 3v3"/>`
    }, props));
$310772594f388aaa$var$ZoomInIcon.displayName = 'ZoomInIcon';
var $310772594f388aaa$var$_default = module.exports.default = $310772594f388aaa$var$ZoomInIcon;

});

parcelRegister("zmEJd", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f96a81b9e560eaf29acabc60a3927a4c>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $06a4d7fd7781c8d0$var$_react = $06a4d7fd7781c8d0$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $06a4d7fd7781c8d0$var$_UNSAFE_baseNew = $06a4d7fd7781c8d0$var$_interopRequireDefault((parcelRequire("bPdWt")));
function $06a4d7fd7781c8d0$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "ZoomOut".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for zooming out of an object or view.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $06a4d7fd7781c8d0$var$ZoomOutIcon = (props)=>/*#__PURE__*/ $06a4d7fd7781c8d0$var$_react.default.createElement($06a4d7fd7781c8d0$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-width="1.5" d="m14.5 14.5-3.788-3.788m0 0a5.25 5.25 0 1 0-7.425-7.425 5.25 5.25 0 0 0 7.425 7.425ZM4 7h6"/>`
    }, props));
$06a4d7fd7781c8d0$var$ZoomOutIcon.displayName = 'ZoomOutIcon';
var $06a4d7fd7781c8d0$var$_default = module.exports.default = $06a4d7fd7781c8d0$var$ZoomOutIcon;

});

parcelRegister("3sJq9", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::9176a30c0755d77947ceea47f5dcd51a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $28573839a119ea3b$var$_react = $28573839a119ea3b$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $28573839a119ea3b$var$_UNSAFE_baseNew = $28573839a119ea3b$var$_interopRequireDefault((parcelRequire("bPdWt")));
function $28573839a119ea3b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Menu".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for accessing the menu in global product navigation.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $28573839a119ea3b$var$MenuIcon = (props)=>/*#__PURE__*/ $28573839a119ea3b$var$_react.default.createElement($28573839a119ea3b$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-width="1.5" d="M1 13.25h14M1 8h14M1 2.75h14"/>`
    }, props));
$28573839a119ea3b$var$MenuIcon.displayName = 'MenuIcon';
var $28573839a119ea3b$var$_default = module.exports.default = $28573839a119ea3b$var$MenuIcon;

});

parcelRegister("iQYaZ", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ed4cbb05f695c79bf1a6c2a07fef2f24>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $db9bc30d273e3ad9$var$_react = $db9bc30d273e3ad9$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $db9bc30d273e3ad9$var$_UNSAFE_baseNew = $db9bc30d273e3ad9$var$_interopRequireDefault((parcelRequire("bPdWt")));
function $db9bc30d273e3ad9$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "ShowMoreVertical".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for more action menus, traditionally on mobile.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $db9bc30d273e3ad9$var$ShowMoreVerticalIcon = (props)=>/*#__PURE__*/ $db9bc30d273e3ad9$var$_react.default.createElement($db9bc30d273e3ad9$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="M8.75 1.5a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0m0 6.5a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0m0 6.5a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0"/><path stroke="currentcolor" stroke-width="1.5" d="M8.75 1.5a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0Zm0 6.5a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0Zm0 6.5a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0Z"/>`
    }, props));
$db9bc30d273e3ad9$var$ShowMoreVerticalIcon.displayName = 'ShowMoreVerticalIcon';
var $db9bc30d273e3ad9$var$_default = module.exports.default = $db9bc30d273e3ad9$var$ShowMoreVerticalIcon;

});

parcelRegister("acHUo", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6b38d718ca9f4aa1019c5485273ebd51>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $76dd15b85043362c$var$_react = $76dd15b85043362c$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $76dd15b85043362c$var$_UNSAFE_baseNew = $76dd15b85043362c$var$_interopRequireDefault((parcelRequire("bPdWt")));
function $76dd15b85043362c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "AlignLeft".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: align text left, align content left, summary.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $76dd15b85043362c$var$AlignLeftIcon = (props)=>/*#__PURE__*/ $76dd15b85043362c$var$_react.default.createElement($76dd15b85043362c$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-width="1.5" d="M1 2.75h14M1 13.25h7M1 8h14"/>`
    }, props));
$76dd15b85043362c$var$AlignLeftIcon.displayName = 'AlignLeftIcon';
var $76dd15b85043362c$var$_default = module.exports.default = $76dd15b85043362c$var$AlignLeftIcon;

});

parcelRegister("lEjQC", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::10497e41582acb6b3539681c38bd8368>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $fc2cbac28e9f2a19$var$_react = $fc2cbac28e9f2a19$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $fc2cbac28e9f2a19$var$_UNSAFE_baseNew = $fc2cbac28e9f2a19$var$_interopRequireDefault((parcelRequire("bPdWt")));
function $fc2cbac28e9f2a19$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "QuestionCircle".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: help, tip.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $fc2cbac28e9f2a19$var$QuestionCircleIcon = (props)=>/*#__PURE__*/ $fc2cbac28e9f2a19$var$_react.default.createElement($fc2cbac28e9f2a19$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M6.25 6C6.25 5 7 4.25 8 4.25S9.75 5 9.75 6C9.75 7.5 8 7.5 8 8.75v.75M15.25 8A7.25 7.25 0 1 1 .75 8a7.25 7.25 0 0 1 14.5 0Z"/><path fill="currentcolor" d="M9 11.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0"/>`
    }, props));
$fc2cbac28e9f2a19$var$QuestionCircleIcon.displayName = 'QuestionCircleIcon';
var $fc2cbac28e9f2a19$var$_default = module.exports.default = $fc2cbac28e9f2a19$var$QuestionCircleIcon;

});

parcelRegister("1qAa4", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::53a1e2fd011260ddfe6bcff1f1f84f50>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $10a4450ae982de07$var$_react = $10a4450ae982de07$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $10a4450ae982de07$var$_UNSAFE_baseNew = $10a4450ae982de07$var$_interopRequireDefault((parcelRequire("bPdWt")));
function $10a4450ae982de07$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Refresh".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for expanding a object or panel.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $10a4450ae982de07$var$RefreshIcon = (props)=>/*#__PURE__*/ $10a4450ae982de07$var$_react.default.createElement($10a4450ae982de07$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M6.25 6V1.75H2m5.5 12.48c-3.218-.254-5.75-2.447-5.75-5.73 0-3.368 2.42-4.921 4-6.29m4 7.77v4.25H14M8.5 1.75c3.218.255 5.75 2.447 5.75 5.73 0 3.352-2.397 4.906-3.977 6.27"/>`
    }, props));
$10a4450ae982de07$var$RefreshIcon.displayName = 'RefreshIcon';
var $10a4450ae982de07$var$_default = module.exports.default = $10a4450ae982de07$var$RefreshIcon;

});

parcelRegister("e3tIz", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::aaf30f230bb1e005401a7fdb410093c0>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a3b865d95a4ae262$var$_react = $a3b865d95a4ae262$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $a3b865d95a4ae262$var$_UNSAFE_baseNew = $a3b865d95a4ae262$var$_interopRequireDefault((parcelRequire("bPdWt")));
function $a3b865d95a4ae262$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Search".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for searching objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a3b865d95a4ae262$var$SearchIcon = (props)=>/*#__PURE__*/ $a3b865d95a4ae262$var$_react.default.createElement($a3b865d95a4ae262$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-width="1.5" d="m14.5 14.5-3.788-3.788m0 0a5.25 5.25 0 1 0-7.425-7.425 5.25 5.25 0 0 0 7.425 7.425Z"/>`
    }, props));
$a3b865d95a4ae262$var$SearchIcon.displayName = 'SearchIcon';
var $a3b865d95a4ae262$var$_default = module.exports.default = $a3b865d95a4ae262$var$SearchIcon;

});

parcelRegister("gmX7n", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c415ea6f37a3ed0eb78bc36e015407f4>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $beac8f0680f54250$var$_react = $beac8f0680f54250$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $beac8f0680f54250$var$_UNSAFE_baseNew = $beac8f0680f54250$var$_interopRequireDefault((parcelRequire("bPdWt")));
function $beac8f0680f54250$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Settings".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for any object or user settings.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $beac8f0680f54250$var$SettingsIcon = (props)=>/*#__PURE__*/ $beac8f0680f54250$var$_react.default.createElement($beac8f0680f54250$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M6.75.75 5.687 3.302a.625.625 0 0 1-.667.378l-2.674-.388-1.25 2.166L2.72 7.625a.625.625 0 0 1 0 .75l-1.624 2.168 1.25 2.165 2.674-.388a.625.625 0 0 1 .667.378L6.75 15.25h2.5l1.063-2.552a.625.625 0 0 1 .667-.378l2.674.388 1.25-2.165-1.623-2.168a.625.625 0 0 1 0-.75l1.623-2.167-1.25-2.166-2.674.388a.625.625 0 0 1-.667-.378L9.25.75z"/><path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M10.25 8a2.25 2.25 0 1 1-4.5 0 2.25 2.25 0 0 1 4.5 0Z"/>`
    }, props));
$beac8f0680f54250$var$SettingsIcon.displayName = 'SettingsIcon';
var $beac8f0680f54250$var$_default = module.exports.default = $beac8f0680f54250$var$SettingsIcon;

});

parcelRegister("ecMhW", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::530cf6124b77e826fb9d0e1e695d5d78>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a577a4bc55f01779$var$_react = $a577a4bc55f01779$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $a577a4bc55f01779$var$_UNSAFE_baseNew = $a577a4bc55f01779$var$_interopRequireDefault((parcelRequire("bPdWt")));
function $a577a4bc55f01779$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Share".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for sharing an object.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a577a4bc55f01779$var$ShareIcon = (props)=>/*#__PURE__*/ $a577a4bc55f01779$var$_react.default.createElement($a577a4bc55f01779$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-width="1.5" d="M10.434 11.717a1.75 1.75 0 1 0 3.131 1.566 1.75 1.75 0 0 0-3.13-1.566Zm0 0L5.316 8.783m0 0a1.74 1.74 0 0 0 0-1.566m0 1.566a1.75 1.75 0 1 1 0-1.566m0 0 5.118-2.934m0 0a1.75 1.75 0 1 0 3.13-1.566 1.75 1.75 0 0 0-3.13 1.566Z"/>`
    }, props));
$a577a4bc55f01779$var$ShareIcon.displayName = 'ShareIcon';
var $a577a4bc55f01779$var$_default = module.exports.default = $a577a4bc55f01779$var$ShareIcon;

});

parcelRegister("8heaH", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::63d7759306dd75de9f8738c35cafb7b3>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $606ae76cd3e8422e$var$_react = $606ae76cd3e8422e$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $606ae76cd3e8422e$var$_UNSAFE_baseNew = $606ae76cd3e8422e$var$_interopRequireDefault((parcelRequire("bPdWt")));
function $606ae76cd3e8422e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "StarUnstarred".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for starring or favoriting objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $606ae76cd3e8422e$var$StarUnstarredIcon = (props)=>/*#__PURE__*/ $606ae76cd3e8422e$var$_react.default.createElement($606ae76cd3e8422e$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="m8 11.25.424-.618L8 10.34l-.424.29zm-4.375 3-.724-.194a.75.75 0 0 0 1.148.813zM5 9.125l.724.194.125-.463-.369-.307zM1.25 6l-.058-.748A.75.75 0 0 0 .77 6.576zm4.875-.375.058.748.472-.037.17-.442zM8 .75l.7-.27a.75.75 0 0 0-1.4 0zm1.875 4.875-.7.27.17.441.472.037zM14.75 6l.48.576a.75.75 0 0 0-.423-1.324zM11 9.125l-.48-.576-.369.307.125.463zm1.375 5.125-.424.619a.75.75 0 0 0 1.148-.813zm-4.8-3.618-4.374 3 .848 1.237 4.375-3zM4.35 14.444 5.724 9.32l-1.448-.388L2.9 14.056zM5.48 8.55 1.73 5.424.77 6.576l3.75 3.125zM1.308 6.748l4.875-.375-.116-1.496-4.875.375zm5.517-.854L8.7 1.02 7.3.481 5.425 5.356zM7.3 1.02l1.875 4.875 1.4-.538L8.7.48zm2.517 5.354 4.876.375.114-1.496-4.874-.375zm4.453-.95L10.52 8.55l.96 1.152 3.75-3.125zM10.276 9.32l1.375 5.125 1.448-.388-1.375-5.125zm2.523 4.313-4.375-3-.848 1.237 4.375 3z"/>`
    }, props));
$606ae76cd3e8422e$var$StarUnstarredIcon.displayName = 'StarUnstarredIcon';
var $606ae76cd3e8422e$var$_default = module.exports.default = $606ae76cd3e8422e$var$StarUnstarredIcon;

});

parcelRegister("9ujTo", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::84516badc93a96e757d14d99cc61886d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6e8658a21861dc13$var$_react = $6e8658a21861dc13$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $6e8658a21861dc13$var$_UNSAFE_baseNew = $6e8658a21861dc13$var$_interopRequireDefault((parcelRequire("bPdWt")));
function $6e8658a21861dc13$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "StarStarred".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for starred or favourited objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $6e8658a21861dc13$var$StarStarredIcon = (props)=>/*#__PURE__*/ $6e8658a21861dc13$var$_react.default.createElement($6e8658a21861dc13$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="m8 11.25-4.375 3L5 9.125 1.25 6l4.875-.375L8 .75l1.875 4.875L14.75 6 11 9.125l1.375 5.125z"/><path fill="currentcolor" d="m8 11.25.424-.618L8 10.34l-.424.29zm-4.375 3-.724-.194a.75.75 0 0 0 1.148.813zM5 9.125l.724.194.125-.463-.369-.307zM1.25 6l-.058-.748A.75.75 0 0 0 .77 6.576zm4.875-.375.058.748.472-.037.17-.442zM8 .75l.7-.27a.75.75 0 0 0-1.4 0zm1.875 4.875-.7.27.17.441.472.037zM14.75 6l.48.576a.75.75 0 0 0-.423-1.324zM11 9.125l-.48-.576-.369.307.125.463zm1.375 5.125-.424.618a.75.75 0 0 0 1.148-.812zm-4.8-3.618-4.374 3 .848 1.236 4.375-3zM4.35 14.444 5.724 9.32l-1.448-.388L2.9 14.056zM5.48 8.55 1.73 5.424.77 6.576l3.75 3.125zM1.308 6.748l4.875-.375-.116-1.496-4.875.375zm5.517-.854L8.7 1.02 7.3.481 5.425 5.356zM7.3 1.02l1.875 4.875 1.4-.538L8.7.48zm2.517 5.354 4.876.375.114-1.496-4.874-.375zm4.453-.95L10.52 8.55l.96 1.152 3.75-3.125zM10.276 9.32l1.375 5.125 1.448-.388-1.375-5.125zm2.523 4.313-4.375-3-.848 1.236 4.375 3z"/>`
    }, props));
$6e8658a21861dc13$var$StarStarredIcon.displayName = 'StarStarredIcon';
var $6e8658a21861dc13$var$_default = module.exports.default = $6e8658a21861dc13$var$StarStarredIcon;

});

parcelRegister("72WPR", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e9ea8e93d14ecb2cc0f36d0ba6200033>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $52165bcd947d3285$var$_react = $52165bcd947d3285$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $52165bcd947d3285$var$_UNSAFE_baseNew = $52165bcd947d3285$var$_interopRequireDefault((parcelRequire("bPdWt")));
function $52165bcd947d3285$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Warning".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for warning system status.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $52165bcd947d3285$var$WarningIcon = (props)=>/*#__PURE__*/ $52165bcd947d3285$var$_react.default.createElement($52165bcd947d3285$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6.242 1.168c.757-1.395 2.76-1.395 3.516 0l5.9 10.878C16.381 13.38 15.416 15 13.9 15H2.1C.584 15-.38 13.38.342 12.047zM7.25 9.5v-5h1.5v5zM8 12.75a1 1 0 1 0 0-2 1 1 0 0 0 0 2" clip-rule="evenodd"/>`
    }, props));
$52165bcd947d3285$var$WarningIcon.displayName = 'WarningIcon';
var $52165bcd947d3285$var$_default = module.exports.default = $52165bcd947d3285$var$WarningIcon;

});

parcelRegister("k6VkH", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => (parcelRequire("jOPGt")).default);
$parcel$export(module.exports, "Icon", () => (parcelRequire("jOPGt")).Icon);

var $jOPGt = parcelRequire("jOPGt");

});
parcelRegister("jOPGt", function(module, exports) {
$parcel$export(module.exports, "Icon", () => $e6dac7366be8d5a7$export$f04a61298a47a40f);
$parcel$export(module.exports, "default", () => $e6dac7366be8d5a7$export$2e2bcd8739ae039);
/* icon-new.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");
/**
 * We are hiding this props from consumers as it's reserved
 * for use by Icon Tile.
 */ var $e6dac7366be8d5a7$var$svgStyles = null;
var $e6dac7366be8d5a7$var$iconStyles = null;
var $e6dac7366be8d5a7$var$smallIconStyles = null;
var $e6dac7366be8d5a7$var$scaleStyles = null;
/**
 * For windows high contrast mode
 */ var $e6dac7366be8d5a7$var$baseHcmStyles = null;
var $e6dac7366be8d5a7$var$scaleSize = null;
var $e6dac7366be8d5a7$var$coreSizeMedium = {
    none: "_1bsbpxbi _4t3ipxbi",
    compact: "_1bsb1ejb _4t3i1ejb",
    spacious: "_1bsb1ejb _4t3i1ejb"
};
var $e6dac7366be8d5a7$var$coreSizeSmall = {
    none: "_1bsbutpp _4t3iutpp",
    compact: "_1bsbpxbi _4t3ipxbi",
    spacious: "_1bsb1ejb _4t3i1ejb"
};
var $e6dac7366be8d5a7$var$paddingMap = {
    medium: {
        none: 0,
        compact: 4,
        spacious: 4
    },
    small: {
        none: 0,
        compact: 2.66,
        spacious: 8
    }
};
var $e6dac7366be8d5a7$export$f04a61298a47a40f = /*#__PURE__*/ (0, $5FkrB.memo)(function Icon(props) {
    var _ref = props, _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, testId = _ref.testId, label = _ref.label, dangerouslySetGlyph = _ref.dangerouslySetGlyph, shouldScale = _ref.shouldScale, _ref$spacing = _ref.spacing, spacing = _ref$spacing === void 0 ? 'none' : _ref$spacing, name = _ref.name;
    var dangerouslySetInnerHTML = dangerouslySetGlyph ? {
        __html: dangerouslySetGlyph
    } : undefined;
    var size = 'medium';
    if ('size' in props && props.size !== undefined) {
        if (typeof props.size === 'string') size = props.size === 'small' || props.size === 'medium' ? props.size : size;
        else if (name) {
            var newSize = props.size(name);
            size = newSize === 'small' || newSize === 'medium' ? newSize : size;
        }
    }
    var baseSize = 16;
    var viewBoxPadding = $e6dac7366be8d5a7$var$paddingMap[size][spacing];
    var viewBoxSize = baseSize + 2 * viewBoxPadding;
    return /*#__PURE__*/ $5FkrB.createElement("span", {
        "data-testid": testId,
        role: label ? 'img' : undefined,
        "aria-label": label ? label : undefined,
        "aria-hidden": label ? undefined : true,
        style: {
            color: color
        },
        className: (0, $970q7.default)([
            "_1e0c1o8l _vchhusvi _1o9zidpf _vwz4kb7n _y4ti1igz _bozg1mb9",
            "_12va1onz _jcxd1r8n",
            shouldScale && "_1bsb1kw7 _4t3i1kw7",
            size === 'small' && "_vwz4utpp"
        ])
    }, /*#__PURE__*/ $5FkrB.createElement("svg", {
        fill: "none",
        viewBox: "".concat(0 - viewBoxPadding, " ").concat(0 - viewBoxPadding, " ").concat(viewBoxSize, " ").concat(viewBoxSize),
        role: "presentation",
        dangerouslySetInnerHTML: dangerouslySetInnerHTML,
        className: (0, $970q7.default)([
            "_1reo15vq _18m915vq _syaz1r31 _lcxvglyw _s7n4yfq0 _vc881r31",
            shouldScale ? "_1bsb1kw7 _4t3i1kw7" : size === 'small' ? $e6dac7366be8d5a7$var$coreSizeSmall[spacing] : $e6dac7366be8d5a7$var$coreSizeMedium[spacing]
        ])
    }));
});
var $e6dac7366be8d5a7$export$2e2bcd8739ae039 = $e6dac7366be8d5a7$export$f04a61298a47a40f;

});


parcelRegister("Pd8py", function(module, exports) {
$parcel$export(module.exports, "createStrictAPI", () => $099ef3ce425dd0d2$export$39716b4af53f4ad);

var $fExW7 = parcelRequire("fExW7");

var $hUFig = parcelRequire("hUFig");
function $099ef3ce425dd0d2$export$39716b4af53f4ad() {
    return {
        css () {
            throw (0, $fExW7.createStrictSetupError)();
        },
        cssMap () {
            throw (0, $fExW7.createStrictSetupError)();
        },
        cx: $hUFig.cx,
        XCSSProp () {
            throw (0, $fExW7.createStrictSetupError)();
        }
    };
}

});
parcelRegister("fExW7", function(module, exports) {
$parcel$export(module.exports, "createStrictSetupError", () => $b654ea81990ec19e$export$c4df1cb0c2b4d77c);
const $b654ea81990ec19e$export$6c9a87045746941d = ()=>{
    return new Error(`
 \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2557}   \u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2557}     \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}
\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}
\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}   \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}  \u{2588}\u{2588}\u{2551}  \u{2588}\u{2588}\u{2551}
\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}   \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}\u{255A}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{255D} \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{255D}  \u{2588}\u{2588}\u{2551}  \u{2588}\u{2588}\u{2551}
\u{255A}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{255A}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551} \u{255A}\u{2550}\u{255D} \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}
 \u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D} \u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D} \u{255A}\u{2550}\u{255D}     \u{255A}\u{2550}\u{255D}\u{255A}\u{2550}\u{255D}     \u{255A}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}

  @compiled/react

  Code was executed when it shouldn't have. This could have happened because:

  1. You haven't configured a transformer yet. Visit https://compiledcssinjs.com/docs/installation and follow the instructions.
  2. You have duplicate versions of React and hooks are blowing up. You need to de-duplicate your dependencies.

  Good luck!
`);
};
const $b654ea81990ec19e$export$c4df1cb0c2b4d77c = ()=>{
    return new Error(`
 \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2557}   \u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2557}     \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}
\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}
\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}   \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}  \u{2588}\u{2588}\u{2551}  \u{2588}\u{2588}\u{2551}
\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}   \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}\u{255A}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{255D} \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{255D}  \u{2588}\u{2588}\u{2551}  \u{2588}\u{2588}\u{2551}
\u{255A}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{255A}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551} \u{255A}\u{2550}\u{255D} \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}
 \u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D} \u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D} \u{255A}\u{2550}\u{255D}     \u{255A}\u{2550}\u{255D}\u{255A}\u{2550}\u{255D}     \u{255A}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}

  @compiled/react

  Code was executed when it shouldn't have. To resolve make sure to:

  1. Set up Compiled.
  2. Configure importSources in your Compiled config to point to the module that exports the output of createStrictAPI().

  For more information visit https://compiledcssinjs.com/docs/installation and follow the instructions.
`);
};

});

parcelRegister("hUFig", function(module, exports) {
$parcel$export(module.exports, "cx", () => $d0a7b2aae633a080$export$a274e22fb40f762e);

var $970q7 = parcelRequire("970q7");
const $d0a7b2aae633a080$export$a274e22fb40f762e = (...styles)=>{
    // At runtime TStyles is resolved down to strings, but not at compile time.
    // We circumvent the type system here because of that.
    const actualStyles = styles;
    // The output should be a union type of passed in styles. This ensures the call
    // site of xcss prop can raise violations when disallowed styles have been passed.
    return (0, $970q7.default)(actualStyles);
};

});


parcelRegister("iO8GM", function(module, exports) {
$parcel$export(module.exports, "default", () => $db13a2f91f6a0f56$export$2e2bcd8739ae039);

var $ekGgq = parcelRequire("ekGgq");
function $db13a2f91f6a0f56$export$2e2bcd8739ae039(refs) {
    return function(value) {
        refs.forEach(function(ref) {
            if (typeof ref === 'function') ref(value);
            else if (ref !== null && (0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(ref) === 'object') ref.current = value;
        });
    };
}

});

parcelRegister("h8qvJ", function(module, exports) {
$parcel$export(module.exports, "useId", () => $c797bf80d6171378$export$f680877a34711e37);
$parcel$export(module.exports, "IdProvider", () => $c797bf80d6171378$export$6be90bcb437e928f);
$parcel$export(module.exports, "useIdSeed", () => $c797bf80d6171378$export$6ee17796e3d70de2);

var $ekGgq = parcelRequire("ekGgq");

var $5FkrB = parcelRequire("5FkrB");

var $b5lkZ = parcelRequire("b5lkZ");

var $9Zzpd = parcelRequire("9Zzpd");
var $c797bf80d6171378$var$_React$useId;
// Type copied from https://github.com/thearnica/react-uid/blob/0f507fbbdb1ab84acf477ec32698afe3d2191e49/src/hooks.ts#L12
// Copied rather than inferred to make the type transparent
// @ts-ignore - useId is not accessible in React 16
var $c797bf80d6171378$var$react18UseId = ($c797bf80d6171378$var$_React$useId = (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).useId) !== null && $c797bf80d6171378$var$_React$useId !== void 0 ? $c797bf80d6171378$var$_React$useId : undefined;
function $c797bf80d6171378$export$f680877a34711e37() {
    if ($c797bf80d6171378$var$react18UseId && (0, $9Zzpd.fg)('platform-dst-react-18-use-id')) {
        if ((0, $9Zzpd.fg)('platform-dst-react-18-use-id-selector-safe')) // tl;dr: React uses `:` or `«»` in selectors which breaks `document.querySelector(…)`
        // in hundreds of tests. So we replace it with a safe string of `_` to match future
        // React 19 functionality: https://github.com/facebook/react/pull/33422
        return $c797bf80d6171378$var$react18UseId().replace(/[:«»]/g, '_');
        return $c797bf80d6171378$var$react18UseId();
    }
    return "uid".concat((0, $b5lkZ.useUID)());
}
var $c797bf80d6171378$export$6be90bcb437e928f = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function(_ref, ref) {
    var children = _ref.children, _ref$postfix = _ref.postfix, postfix = _ref$postfix === void 0 ? '' : _ref$postfix, _ref$prefix = _ref.prefix, prefix = _ref$prefix === void 0 ? '' : _ref$prefix;
    var id = "".concat(prefix).concat($c797bf80d6171378$export$f680877a34711e37()).concat(postfix);
    (0, $5FkrB.useEffect)(function() {
        if (!ref) return;
        switch((0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(ref)){
            case 'function':
                ref(id);
                break;
            case 'object':
                ref.current = id;
                break;
            default:
                throw new Error("Unreachable case for unsupported type of ref \"".concat((0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(ref), "\""));
        }
    }, [
        id,
        ref
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).Fragment, null, typeof children === 'function' ? children({
        id: id
    }) : children);
});
function $c797bf80d6171378$export$6ee17796e3d70de2() {
    if ($c797bf80d6171378$var$react18UseId && (0, $9Zzpd.fg)('platform-dst-react-18-use-id')) {
        // eslint-disable-next-line react-hooks/rules-of-hooks -- cleanup with feature gating
        var uid = $c797bf80d6171378$export$f680877a34711e37();
        return function(id) {
            return "".concat(uid, "-").concat(id.toString());
        };
    }
    return (0, $b5lkZ.useUIDSeed)();
}

});
parcelRegister("b5lkZ", function(module, exports) {
$parcel$export(module.exports, "useUID", () => $8120b68af314e225$export$87d05f07e65211f1);
$parcel$export(module.exports, "useUIDSeed", () => $8120b68af314e225$export$bb5ca5fba6fb4f1f);

var $5FkrB = parcelRequire("5FkrB");

var $bDoJR = parcelRequire("bDoJR");
var $8120b68af314e225$var$generateUID = function(context) {
    var quartz = context || (0, $bDoJR.counter);
    var prefix = (0, $bDoJR.getPrefix)(quartz);
    var id = (0, $bDoJR.getId)(quartz);
    var uid = prefix + id;
    var gen = function(item) {
        return uid + quartz.uid(item);
    };
    return {
        uid: uid,
        gen: gen
    };
};
var $8120b68af314e225$var$useUIDState = function() {
    var context = (0, $5FkrB.useContext)((0, $bDoJR.source));
    var uid = (0, $5FkrB.useState)(function() {
        return $8120b68af314e225$var$generateUID(context);
    })[0];
    return uid;
};
var $8120b68af314e225$export$87d05f07e65211f1 = function() {
    var uid = $8120b68af314e225$var$useUIDState().uid;
    return uid;
};
var $8120b68af314e225$export$bb5ca5fba6fb4f1f = function() {
    var gen = $8120b68af314e225$var$useUIDState().gen;
    return gen;
};

});
parcelRegister("bDoJR", function(module, exports) {
$parcel$export(module.exports, "counter", () => $878686cdae50c4f9$export$e575061ef2a070eb);
$parcel$export(module.exports, "source", () => $878686cdae50c4f9$export$b4d5da5f34fb77ad);
$parcel$export(module.exports, "getId", () => $878686cdae50c4f9$export$218c8c3169c024d2);
$parcel$export(module.exports, "getPrefix", () => $878686cdae50c4f9$export$36e24695f02d4503);

var $5FkrB = parcelRequire("5FkrB");

var $k4xEj = parcelRequire("k4xEj");
var $878686cdae50c4f9$export$1921362e86c73c88 = function(prefix) {
    if (prefix === void 0) prefix = '';
    return {
        value: 1,
        prefix: prefix,
        uid: (0, $k4xEj.generateUID)()
    };
};
var $878686cdae50c4f9$export$e575061ef2a070eb = $878686cdae50c4f9$export$1921362e86c73c88();
var $878686cdae50c4f9$export$b4d5da5f34fb77ad = $5FkrB.createContext($878686cdae50c4f9$export$1921362e86c73c88());
var $878686cdae50c4f9$export$218c8c3169c024d2 = function(source) {
    return source.value++;
};
var $878686cdae50c4f9$export$36e24695f02d4503 = function(source) {
    return source ? source.prefix : '';
};

});
parcelRegister("k4xEj", function(module, exports) {
$parcel$export(module.exports, "generateUID", () => $e9ce486011a08a46$export$bdbb4cbb3078e58d);
/**
 * generates a UID factory
 * @internal
 * @example
 * const uid = generateUID();
 * uid(object) = 1;
 * uid(object) = 1;
 * uid(anotherObject) = 2;
 */ var $e9ce486011a08a46$export$bdbb4cbb3078e58d = function() {
    var counter = 1;
    var map = new WeakMap();
    /**
     * @borrows {uid}
     */ var uid = function(item, index) {
        if (typeof item === 'number' || typeof item === 'string') return index ? "idx-".concat(index) : "val-".concat(item);
        if (!map.has(item)) {
            map.set(item, counter++);
            return uid(item);
        }
        return 'uid' + map.get(item);
    };
    return uid;
};
var $e9ce486011a08a46$export$e2a22331486dcca0 = $e9ce486011a08a46$export$bdbb4cbb3078e58d();

});




parcelRegister("hy47X", function(module, exports) {
$parcel$export(module.exports, "default", () => $cc68d04423a653c6$export$2e2bcd8739ae039);

var $5FkrB = parcelRequire("5FkrB");

var $7QpUe = parcelRequire("7QpUe");

var $lmG37 = parcelRequire("lmG37");
function $cc68d04423a653c6$export$2e2bcd8739ae039(_ref) {
    var onClose = _ref.onClose, isDisabled = _ref.isDisabled;
    var escapePressed = (0, $5FkrB.useRef)(false);
    var onKeyDown = (0, $5FkrB.useCallback)(function(e) {
        if (isDisabled || escapePressed.current || e.key !== (0, $lmG37.ESCAPE)) // We're either already handling the key down event or it's not escape.
        // Bail early!
        return;
        escapePressed.current = true;
        onClose(e);
    }, [
        onClose,
        isDisabled
    ]);
    var onKeyUp = (0, $5FkrB.useCallback)(function() {
        escapePressed.current = false;
    }, []);
    (0, $5FkrB.useEffect)(function() {
        // Don't attach document event listeners if the hook is disabled
        if (isDisabled) return;
        return (0, $7QpUe.bindAll)(document, [
            {
                type: 'keydown',
                listener: onKeyDown
            },
            {
                type: 'keyup',
                listener: onKeyUp
            }
        ], {
            capture: false
        });
    }, [
        onKeyDown,
        onKeyUp,
        isDisabled
    ]);
}

});
parcelRegister("lmG37", function(module, exports) {
$parcel$export(module.exports, "KEY_UP", () => $f8dc452a9f988247$export$390330c10ff2b9a1);
$parcel$export(module.exports, "KEY_DOWN", () => $f8dc452a9f988247$export$a80636c6f41931fe);
$parcel$export(module.exports, "KEY_HOME", () => $f8dc452a9f988247$export$4af703091671bc);
$parcel$export(module.exports, "KEY_END", () => $f8dc452a9f988247$export$e2bc30913faa5db7);
$parcel$export(module.exports, "KEY_TAB", () => $f8dc452a9f988247$export$10f6869ed0a7d75b);
$parcel$export(module.exports, "KEY_ENTER", () => $f8dc452a9f988247$export$8152f929a25a0ff4);
$parcel$export(module.exports, "KEY_SPACE", () => $f8dc452a9f988247$export$e51a3576c045c8d5);
$parcel$export(module.exports, "ESCAPE", () => $f8dc452a9f988247$export$2bb790b9008907b4);
/**
 * Character key codes which can be used in keyboard events.
 */ var $f8dc452a9f988247$export$390330c10ff2b9a1 = 'ArrowUp';
var $f8dc452a9f988247$export$a80636c6f41931fe = 'ArrowDown';
var $f8dc452a9f988247$export$4af703091671bc = 'Home';
var $f8dc452a9f988247$export$e2bc30913faa5db7 = 'End';
var $f8dc452a9f988247$export$10f6869ed0a7d75b = 'Tab';
var $f8dc452a9f988247$export$8152f929a25a0ff4 = 'Enter';
var $f8dc452a9f988247$export$e51a3576c045c8d5 = 'Space';
var $f8dc452a9f988247$export$2bb790b9008907b4 = 'Escape';

});


parcelRegister("3UUXy", function(module, exports) {
$parcel$export(module.exports, "default", () => $2da2c910992d9a40$export$2e2bcd8739ae039);

var $5FkrB = parcelRequire("5FkrB");
function $2da2c910992d9a40$export$2e2bcd8739ae039(value) {
    var ref = (0, $5FkrB.useRef)(value);
    (0, $5FkrB.useEffect)(function() {
        ref.current = value;
    }, [
        value
    ]);
    return ref;
}

});

parcelRegister("iUCre", function(module, exports) {
$parcel$export(module.exports, "useNotifyOpenLayerObserver", () => $dc4b45f7ee6225f5$export$469bb693f11edc7f);

var $5FkrB = parcelRequire("5FkrB");

var $lHXR8 = parcelRequire("lHXR8");

var $2AINz = parcelRequire("2AINz");
function $dc4b45f7ee6225f5$export$469bb693f11edc7f(_ref) {
    var isOpen = _ref.isOpen, type = _ref.type, onClose = _ref.onClose;
    var context = (0, $5FkrB.useContext)((0, $lHXR8.OpenLayerObserverContext));
    var namespace = (0, $2AINz.useOpenLayerObserverNamespace)();
    (0, $5FkrB.useEffect)(function() {
        /**
     * Registers the `onClose` callback with the OpenLayerObserver.
     */ if (context === null) return;
        if (!isOpen) /**
       * If the layer is not open, we are not registering the `onClose` callback.
       * This is important to prevent the `onClose` from being called for layers that
       * are not open.
       *
       * Some consumers mistakenly pass "toggle" functions to `onClose` callbacks for
       * layer components, as Popup, e.g. `onClose={() => setIsOpen(!isOpen)}`.
       */ return;
        return context.onClose(onClose, {
            namespace: namespace,
            type: type
        });
    }, [
        context,
        isOpen,
        namespace,
        onClose,
        type
    ]);
}

});
parcelRegister("lHXR8", function(module, exports) {
$parcel$export(module.exports, "OpenLayerObserverContext", () => $fcdc0b4830f2aedd$export$5fbf4d7fae6cdc00);

var $5FkrB = parcelRequire("5FkrB");
var $fcdc0b4830f2aedd$export$5fbf4d7fae6cdc00 = /*#__PURE__*/ (0, $5FkrB.createContext)(null);

});

parcelRegister("2AINz", function(module, exports) {
$parcel$export(module.exports, "useOpenLayerObserverNamespace", () => $1e31b1a2322b2689$export$1d57e79091cc3046);

var $5FkrB = parcelRequire("5FkrB");

var $33jD0 = parcelRequire("33jD0");
function $1e31b1a2322b2689$export$1d57e79091cc3046() {
    var namespace = (0, $5FkrB.useContext)((0, $33jD0.OpenLayerObserverNamespaceContext));
    return namespace;
}

});
parcelRegister("33jD0", function(module, exports) {
$parcel$export(module.exports, "OpenLayerObserverNamespaceContext", () => $2390e0a738ab81f9$export$644a49f3b8c50fcd);

var $5FkrB = parcelRequire("5FkrB");
var $2390e0a738ab81f9$export$644a49f3b8c50fcd = /*#__PURE__*/ (0, $5FkrB.createContext)(null);

});



parcelRegister("5K5L9", function(module, exports) {
$parcel$export(module.exports, "Popper", () => $42e5b75ea169c552$export$badac9ada3a0bdf9);

var $fC8ib = parcelRequire("fC8ib");

var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");

var $lsgol = parcelRequire("lsgol");

var $kmo34 = parcelRequire("kmo34");

// Export types from PopperJS / React Popper
var $42e5b75ea169c552$var$viewportPadding = 5;
var $42e5b75ea169c552$var$constantModifiers = [
    {
        name: 'flip',
        options: {
            flipVariations: false,
            padding: $42e5b75ea169c552$var$viewportPadding,
            boundary: 'clippingParents',
            rootBoundary: 'viewport'
        }
    }
];
function $42e5b75ea169c552$var$defaultChildrenFn() {
    return null;
}
var $42e5b75ea169c552$var$defaultOffset = [
    0,
    8
];
function $42e5b75ea169c552$export$badac9ada3a0bdf9(_ref) {
    var _ref$children = _ref.children, children = _ref$children === void 0 ? $42e5b75ea169c552$var$defaultChildrenFn : _ref$children, _ref$offset = _ref.offset, offset = _ref$offset === void 0 ? $42e5b75ea169c552$var$defaultOffset : _ref$offset, _ref$placement = _ref.placement, placement = _ref$placement === void 0 ? 'bottom-start' : _ref$placement, _ref$referenceElement = _ref.referenceElement, referenceElement = _ref$referenceElement === void 0 ? undefined : _ref$referenceElement, modifiers = _ref.modifiers, _ref$strategy = _ref.strategy, strategy = _ref$strategy === void 0 ? 'fixed' : _ref$strategy, _ref$shouldFitViewpor = _ref.shouldFitViewport, shouldFitViewport = _ref$shouldFitViewpor === void 0 ? false : _ref$shouldFitViewpor;
    var _offset = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(offset, 2), offsetX = _offset[0], offsetY = _offset[1];
    var internalModifiers = (0, $5FkrB.useMemo)(function() {
        var preventOverflowModifier = {
            name: 'preventOverflow',
            options: {
                padding: $42e5b75ea169c552$var$viewportPadding,
                rootBoundary: shouldFitViewport ? 'viewport' : 'document'
            }
        };
        var offsetModifier = {
            name: 'offset',
            options: {
                offset: [
                    offsetX,
                    offsetY
                ]
            }
        };
        var maxSizeModifiers = shouldFitViewport ? (0, $kmo34.getMaxSizeModifiers)({
            viewportPadding: $42e5b75ea169c552$var$viewportPadding
        }) : [];
        // @ts-ignore Type errors from incompatible @popperjs/core versions between Jira and AFM Platform... we are using ts-ignore here because ts-expect-error will cause an "Unused '@ts-expect-error' directive." error
        return [].concat($42e5b75ea169c552$var$constantModifiers, [
            preventOverflowModifier,
            offsetModifier
        ], (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(maxSizeModifiers));
    }, [
        offsetX,
        offsetY,
        shouldFitViewport
    ]);
    // Merge custom props and memoize
    var mergedModifiers = (0, $5FkrB.useMemo)(function() {
        if (modifiers == null) return internalModifiers;
        return [].concat((0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(internalModifiers), (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(modifiers));
    }, [
        internalModifiers,
        modifiers
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $lsgol.Popper), {
        modifiers: mergedModifiers,
        placement: placement,
        strategy: strategy,
        referenceElement: referenceElement
    }, children);
}

});
parcelRegister("kmo34", function(module, exports) {
$parcel$export(module.exports, "getMaxSizeModifiers", () => $ed28843bb38c002b$export$6d8c2b45c99d6e3f);

var $iYJcE = parcelRequire("iYJcE");
function $ed28843bb38c002b$export$6d8c2b45c99d6e3f(_ref) {
    var viewportPadding = _ref.viewportPadding;
    return [
        {
            /**
     * Performing DOM measurements in the 'read' phase,
     * which is the convention for popper modifiers
     */ name: 'maxSizeData',
            enabled: true,
            phase: 'read',
            fn: function fn(_ref2) {
                var state = _ref2.state, name = _ref2.name;
                if (!window.visualViewport) return;
                state.modifiersData[name] = {
                    viewport: {
                        width: window.visualViewport.width,
                        height: window.visualViewport.height
                    }
                };
            }
        },
        {
            /**
     * Applying max size CSS
     */ name: 'maxSize',
            enabled: true,
            phase: 'beforeWrite',
            requiresIfExists: [
                'offset',
                'preventOverflow',
                'flip'
            ],
            fn: function fn(_ref3) {
                var _data$viewport, _data$viewport2, _state$modifiersData$2, _state$modifiersData;
                var state = _ref3.state;
                var data = state.modifiersData.maxSizeData;
                if (typeof (data === null || data === void 0 || (_data$viewport = data.viewport) === null || _data$viewport === void 0 ? void 0 : _data$viewport.width) !== 'number' || typeof (data === null || data === void 0 || (_data$viewport2 = data.viewport) === null || _data$viewport2 === void 0 ? void 0 : _data$viewport2.height) !== 'number') // This shouldn't occur in a real browser but might in non-browser test environments
                return;
                var viewport = data.viewport;
                var _state$modifiersData$ = state.modifiersData.popperOffsets, popperOffsets = _state$modifiersData$ === void 0 ? {
                    x: 0,
                    y: 0
                } : _state$modifiersData$;
                var _state$placement$spli = state.placement.split('-'), _state$placement$spli2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_state$placement$spli, 1), basePlacement = _state$placement$spli2[0];
                var placementOffset = (_state$modifiersData$2 = (_state$modifiersData = state.modifiersData) === null || _state$modifiersData === void 0 || (_state$modifiersData = _state$modifiersData.offset) === null || _state$modifiersData === void 0 ? void 0 : _state$modifiersData[state.placement]) !== null && _state$modifiersData$2 !== void 0 ? _state$modifiersData$2 : {
                    x: 0,
                    y: 0
                };
                // By default we set these to the entire viewport (minus padding)
                // Each placement direction will overwrite one of these
                var maxWidth = viewport.width - 2 * viewportPadding;
                var maxHeight = viewport.height - 2 * viewportPadding;
                if (basePlacement === 'top') maxHeight = state.rects.reference.y + // Viewport-relative position of reference element
                placementOffset.y - // Space between popper and reference
                viewportPadding;
                if (basePlacement === 'bottom') maxHeight = viewport.height - popperOffsets.y - // Viewport-relative position of popper
                viewportPadding;
                if (basePlacement === 'left') maxWidth = state.rects.reference.x + // Viewport-relative position of reference element
                placementOffset.x - // Space between popper and reference
                viewportPadding;
                if (basePlacement === 'right') maxWidth = viewport.width - popperOffsets.x - // Viewport-relative position of popper
                viewportPadding;
                state.styles.popper.maxWidth = "".concat(maxWidth, "px");
                state.styles.popper.maxHeight = "".concat(maxHeight, "px");
            }
        }
    ];
}

});


parcelRegister("a1YOk", function(module, exports) {
$parcel$export(module.exports, "THEME_DATA_ATTRIBUTE", () => $74d92b1dbf88028f$export$4ef52930e33717cd);
$parcel$export(module.exports, "SUBTREE_THEME_ATTRIBUTE", () => $74d92b1dbf88028f$export$cb374d25ded7f6ab);
$parcel$export(module.exports, "COLOR_MODE_ATTRIBUTE", () => $74d92b1dbf88028f$export$a00eac3f8684bcd0);
$parcel$export(module.exports, "CONTRAST_MODE_ATTRIBUTE", () => $74d92b1dbf88028f$export$2112803007239c61);
$parcel$export(module.exports, "CUSTOM_THEME_ATTRIBUTE", () => $74d92b1dbf88028f$export$352e418ed5b6193a);
var $74d92b1dbf88028f$export$4ef52930e33717cd = 'data-theme';
var $74d92b1dbf88028f$export$cb374d25ded7f6ab = 'data-subtree-theme';
var $74d92b1dbf88028f$export$a00eac3f8684bcd0 = 'data-color-mode';
var $74d92b1dbf88028f$export$2112803007239c61 = 'data-contrast-mode';
var $74d92b1dbf88028f$export$352e418ed5b6193a = 'data-custom-theme';
var $74d92b1dbf88028f$export$6f0c6fb8c80fcc92 = 'ds';
var $74d92b1dbf88028f$export$4d0c7bbf80185957 = [
    'opacity',
    'font',
    'space',
    'border',
    'radius'
];
var $74d92b1dbf88028f$export$dddac1532e822863 = "--".concat($74d92b1dbf88028f$export$6f0c6fb8c80fcc92, "-token-not-found");
var $74d92b1dbf88028f$export$9d7b58831ae93caa = "--".concat($74d92b1dbf88028f$export$6f0c6fb8c80fcc92, "-elevation-surface-current");

});

parcelRegister("3myK9", function(module, exports) {
$parcel$export(module.exports, "themeColorModes", () => $272e60805366a409$export$83993de8eb66733);
$parcel$export(module.exports, "themeIds", () => $272e60805366a409$export$7d43e72a58e3283f);
$parcel$export(module.exports, "themeStateDefaults", () => $272e60805366a409$export$9aedcfa7336a207);
$parcel$export(module.exports, "default", () => $272e60805366a409$export$2e2bcd8739ae039);

var $dU8Y3 = parcelRequire("dU8Y3");
var $272e60805366a409$export$83993de8eb66733 = [
    'light',
    'dark',
    'auto'
];
/**
 * Contrast preferences: The system contrast preference
 */ var $272e60805366a409$var$themeContrastModes = [
    'more',
    'no-preference',
    'auto'
];
var $272e60805366a409$export$7d43e72a58e3283f = [
    'light-increased-contrast',
    'light',
    'light-future',
    'dark',
    'dark-future',
    'dark-increased-contrast',
    'legacy-light',
    'legacy-dark',
    'spacing',
    'shape',
    'typography'
];
/**
 * Theme override ids: the equivalent of themeIds for theme overrides.
 * Theme overrides are temporary and there may not be any defined at times.
 */ var $272e60805366a409$var$themeOverrideIds = [];
var $272e60805366a409$export$92ba366331403db2 = [].concat($272e60805366a409$export$7d43e72a58e3283f, $272e60805366a409$var$themeOverrideIds);
/**
 * Theme to use a base. This will create the theme as
 * an extension with all token values marked as optional
 * to allow tokens to be overridden as required.
 */ /**
 * Palettes: The set of base tokens a given theme may be populated with.
 * For example: legacy light & dark themes use the "legacyPalette" containing colors from our
 * previous color set.
 */ /**
 * ThemeConfig: the source of truth for all theme meta-data.
 * This object should be used whenever interfacing with themes.
 */ var $272e60805366a409$var$themeConfig = {
    'atlassian-light': {
        id: 'light',
        displayName: 'Light Theme',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'light'
        }
    },
    'atlassian-light-future': {
        id: 'light-future',
        displayName: 'Future Light Theme',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'light'
        },
        override: 'light'
    },
    'atlassian-light-increased-contrast': {
        id: 'light-increased-contrast',
        displayName: 'Light Theme (increased contrast)',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'light'
        },
        extends: 'light',
        increasesContrastFor: 'light'
    },
    'atlassian-dark': {
        id: 'dark',
        displayName: 'Dark Theme',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'dark'
        }
    },
    'atlassian-dark-future': {
        id: 'dark-future',
        displayName: 'Future Dark Theme',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'dark'
        },
        override: 'light'
    },
    'atlassian-dark-increased-contrast': {
        id: 'dark-increased-contrast',
        displayName: 'Dark Theme (increased contrast)',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'dark'
        },
        extends: 'dark',
        increasesContrastFor: 'dark'
    },
    'atlassian-legacy-light': {
        id: 'legacy-light',
        displayName: 'Light Theme (legacy)',
        palette: 'legacyPalette',
        attributes: {
            type: 'color',
            mode: 'light'
        }
    },
    'atlassian-legacy-dark': {
        id: 'legacy-dark',
        displayName: 'Dark Theme (legacy)',
        palette: 'legacyPalette',
        attributes: {
            type: 'color',
            mode: 'dark'
        }
    },
    'atlassian-spacing': {
        id: 'spacing',
        displayName: 'Atlassian Spacing',
        palette: 'spacingScale',
        attributes: {
            type: 'spacing'
        }
    },
    'atlassian-typography': {
        id: 'typography',
        displayName: 'Atlassian Typography',
        palette: 'typographyPalette',
        attributes: {
            type: 'typography'
        }
    },
    'atlassian-shape': {
        id: 'shape',
        displayName: 'Shape',
        palette: 'shapePalette',
        attributes: {
            type: 'shape'
        }
    }
};
var $272e60805366a409$export$9aedcfa7336a207 = {
    colorMode: 'auto',
    contrastMode: 'auto',
    dark: 'dark',
    light: 'light',
    shape: function shape() {
        if ((0, $dU8Y3.fg)('platform-dst-shape-theme-default')) return 'shape';
        return undefined;
    },
    spacing: 'spacing',
    typography: 'typography',
    UNSAFE_themeOptions: undefined
};
var /**
 * Represents theme state once mounted to the page
 * (the page doesn't have an "auto" color mode, it's either light or dark)
 */ $272e60805366a409$export$2e2bcd8739ae039 = $272e60805366a409$var$themeConfig;

});
parcelRegister("dU8Y3", function(module, exports) {
$parcel$export(module.exports, "fg", () => $a1f77617c4784515$export$b40ec24ac8275656);

var $a0sMN = parcelRequire("a0sMN");
function $a1f77617c4784515$export$ba05d765b8392e5e(flagResolver) {
    (0, $a0sMN.setBooleanResolver)(flagResolver);
}
function $a1f77617c4784515$export$470e5c2be1411c89(name) {
    return (0, $a0sMN.resolveBooleanFlag)(name);
}
function $a1f77617c4784515$export$b40ec24ac8275656(name) {
    return (0, $a0sMN.resolveBooleanFlag)(name);
}

});
parcelRegister("a0sMN", function(module, exports) {
$parcel$export(module.exports, "setBooleanResolver", () => $01e14b49696e78de$export$f2b591175b3e424c);
$parcel$export(module.exports, "resolveBooleanFlag", () => $01e14b49696e78de$export$6333b6aff9fc6275);

var $9dOvm = parcelRequire("9dOvm");

var $gP3up = parcelRequire("gP3up");

var $3ZMUU = parcelRequire("3ZMUU");
var $01e14b49696e78de$var$pkgName = '@atlaskit/platform-feature-flags';
var $01e14b49696e78de$export$7e41b1b2bdee3f98 = '__PLATFORM_FEATURE_FLAGS__';
var $01e14b49696e78de$var$hasProcessEnv = typeof $3ZMUU !== 'undefined' && typeof $3ZMUU.env !== 'undefined';
// FF global overrides can be configured by test runners or Storybook
var $01e14b49696e78de$var$ENV_ENABLE_PLATFORM_FF = $01e14b49696e78de$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
// STORYBOOK_ENABLE_PLATFORM_FF is included as storybook only allows env vars prefixed with STORYBOOK
// https://github.com/storybookjs/storybook/issues/12270
var $01e14b49696e78de$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF = $01e14b49696e78de$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
var $01e14b49696e78de$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE = $01e14b49696e78de$var$ENV_ENABLE_PLATFORM_FF || $01e14b49696e78de$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF;
var $01e14b49696e78de$var$DEFAULT_PFF_GLOBAL = {
    booleanResolver: undefined
};
var $01e14b49696e78de$var$globalVar = typeof window !== 'undefined' ? window : globalThis;
$01e14b49696e78de$var$globalVar[$01e14b49696e78de$export$7e41b1b2bdee3f98] = $01e14b49696e78de$var$globalVar[$01e14b49696e78de$export$7e41b1b2bdee3f98] || $01e14b49696e78de$var$DEFAULT_PFF_GLOBAL;
function $01e14b49696e78de$export$f2b591175b3e424c(resolver) {
    $01e14b49696e78de$var$globalVar[$01e14b49696e78de$export$7e41b1b2bdee3f98].booleanResolver = resolver;
}
function $01e14b49696e78de$export$6333b6aff9fc6275(flagKey) {
    if ($01e14b49696e78de$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE) {
        (0, $gP3up.debug)('[%s]: The feature flags were enabled while running tests. The flag "%s" will be always enabled.', $01e14b49696e78de$var$pkgName, flagKey);
        return true;
    }
    try {
        var _globalVar$PFF_GLOBAL, _globalVar$PFF_GLOBAL2, _globalVar$PFF_GLOBAL3;
        // booleanResolver will be empty for products like Trello, Elevate, Recruit etc.
        // Currently only Confluence, Jira and Bitbucket has set it.
        if (((_globalVar$PFF_GLOBAL = $01e14b49696e78de$var$globalVar[$01e14b49696e78de$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL === void 0 ? void 0 : _globalVar$PFF_GLOBAL.booleanResolver) === undefined || ((_globalVar$PFF_GLOBAL2 = $01e14b49696e78de$var$globalVar[$01e14b49696e78de$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL2 === void 0 ? void 0 : _globalVar$PFF_GLOBAL2.booleanResolver) === null) // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
        return (0, $9dOvm.default).checkGate(flagKey);
        var result = (_globalVar$PFF_GLOBAL3 = $01e14b49696e78de$var$globalVar[$01e14b49696e78de$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL3 === void 0 ? void 0 : _globalVar$PFF_GLOBAL3.booleanResolver(flagKey);
        if (typeof result !== 'boolean') {
            // eslint-disable-next-line no-console
            console.warn("".concat(flagKey, " resolved to a non-boolean value, returning false for safety"));
            return false;
        }
        return result;
    } catch (e) {
        return false;
    }
}

});
parcelRegister("9dOvm", function(module, exports) {
$parcel$export(module.exports, "default", () => $6b6c8129f5a844c6$export$2e2bcd8739ae039);

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $25nEq = parcelRequire("25nEq");

var $1Odth = parcelRequire("1Odth");

var $89UMm = parcelRequire("89UMm");



var $6b6c8129f5a844c6$var$_FeatureGates;
/**
 * Access the FeatureGates object via the default export.
 * ```ts
 * import FeatureGates from '@atlaskit/feature-gate-js-client';
 * ```
 */ var $6b6c8129f5a844c6$var$FeatureGates = /*#__PURE__*/ function() {
    function FeatureGates() {
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, FeatureGates);
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(FeatureGates, null, [
        {
            key: "isGateExists",
            value: function isGateExists(gateName) {
                return this.client.isGateExist(gateName);
            }
        },
        {
            key: "isExperimentExists",
            value: function isExperimentExists(experimentName) {
                return this.client.isExperimentExist(experimentName);
            }
        }
    ]);
}();
$6b6c8129f5a844c6$var$_FeatureGates = $6b6c8129f5a844c6$var$FeatureGates;
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($6b6c8129f5a844c6$var$FeatureGates, "client", new (0, $1Odth.Client)());
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($6b6c8129f5a844c6$var$FeatureGates, "hasCheckGateErrorOccurred", false);
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($6b6c8129f5a844c6$var$FeatureGates, "hasGetExperimentValueErrorOccurred", false);
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($6b6c8129f5a844c6$var$FeatureGates, "checkGate", function(gateName, options) {
    try {
        // Check if the CRITERION override mechanism is available
        if (typeof window !== 'undefined' && window.__CRITERION__ && typeof window.__CRITERION__.getFeatureFlagOverride === 'function') {
            // Attempt to retrieve an override value for the feature gate
            var overrideValue = window.__CRITERION__.getFeatureFlagOverride(gateName);
            // If an override value is found, return it immediately
            if (overrideValue !== undefined) return overrideValue;
        }
    } catch (error) {
        // Log the first occurrence of the error
        if (!$6b6c8129f5a844c6$var$_FeatureGates.hasCheckGateErrorOccurred) {
            // eslint-disable-next-line no-console
            console.warn({
                msg: 'An error has occurred checking the feature gate from criterion override. Only the first occurrence of this error is logged.',
                gateName: gateName,
                error: error
            });
            $6b6c8129f5a844c6$var$_FeatureGates.hasCheckGateErrorOccurred = true;
        }
    }
    // Proceed with the main logic if no override is found
    return $6b6c8129f5a844c6$var$_FeatureGates.client.checkGate(gateName, options);
});
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($6b6c8129f5a844c6$var$FeatureGates, "getExperimentValue", function(experimentName, parameterName, defaultValue, options) {
    try {
        // Check if the CRITERION override mechanism is available
        if (typeof window !== 'undefined' && window.__CRITERION__ && typeof window.__CRITERION__.getExperimentValueOverride === 'function') {
            var overrideValue = window.__CRITERION__.getExperimentValueOverride(experimentName, parameterName);
            if (overrideValue !== undefined && overrideValue !== null) return overrideValue;
        }
    } catch (error) {
        // Log the first occurrence of the error
        if (!$6b6c8129f5a844c6$var$_FeatureGates.hasGetExperimentValueErrorOccurred) {
            // eslint-disable-next-line no-console
            console.warn({
                msg: 'An error has occurred getting the experiment value from criterion override. Only the first occurrence of this error is logged.',
                experimentName: experimentName,
                defaultValue: defaultValue,
                options: options,
                error: error
            });
            $6b6c8129f5a844c6$var$_FeatureGates.hasGetExperimentValueErrorOccurred = true;
        }
        return defaultValue;
    }
    // Proceed with the main logic if no override is found
    return $6b6c8129f5a844c6$var$_FeatureGates.client.getExperimentValue(experimentName, parameterName, defaultValue, options);
});
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($6b6c8129f5a844c6$var$FeatureGates, "initializeCalled", $6b6c8129f5a844c6$var$_FeatureGates.client.initializeCalled.bind($6b6c8129f5a844c6$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($6b6c8129f5a844c6$var$FeatureGates, "initializeCompleted", $6b6c8129f5a844c6$var$_FeatureGates.client.initializeCompleted.bind($6b6c8129f5a844c6$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($6b6c8129f5a844c6$var$FeatureGates, "waitUntilInitializeCompleted", $6b6c8129f5a844c6$var$_FeatureGates.client.waitUntilInitializeCompleted.bind($6b6c8129f5a844c6$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($6b6c8129f5a844c6$var$FeatureGates, "initialize", $6b6c8129f5a844c6$var$_FeatureGates.client.initialize.bind($6b6c8129f5a844c6$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($6b6c8129f5a844c6$var$FeatureGates, "initializeWithProvider", $6b6c8129f5a844c6$var$_FeatureGates.client.initializeWithProvider.bind($6b6c8129f5a844c6$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($6b6c8129f5a844c6$var$FeatureGates, "initializeFromValues", $6b6c8129f5a844c6$var$_FeatureGates.client.initializeFromValues.bind($6b6c8129f5a844c6$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($6b6c8129f5a844c6$var$FeatureGates, "manuallyLogGateExposure", $6b6c8129f5a844c6$var$_FeatureGates.client.manuallyLogGateExposure.bind($6b6c8129f5a844c6$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($6b6c8129f5a844c6$var$FeatureGates, "getExperiment", $6b6c8129f5a844c6$var$_FeatureGates.client.getExperiment.bind($6b6c8129f5a844c6$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($6b6c8129f5a844c6$var$FeatureGates, "manuallyLogExperimentExposure", $6b6c8129f5a844c6$var$_FeatureGates.client.manuallyLogExperimentExposure.bind($6b6c8129f5a844c6$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($6b6c8129f5a844c6$var$FeatureGates, "manuallyLogLayerExposure", $6b6c8129f5a844c6$var$_FeatureGates.client.manuallyLogLayerExposure.bind($6b6c8129f5a844c6$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($6b6c8129f5a844c6$var$FeatureGates, "shutdownStatsig", $6b6c8129f5a844c6$var$_FeatureGates.client.shutdownStatsig.bind($6b6c8129f5a844c6$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($6b6c8129f5a844c6$var$FeatureGates, "overrideGate", $6b6c8129f5a844c6$var$_FeatureGates.client.overrideGate.bind($6b6c8129f5a844c6$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($6b6c8129f5a844c6$var$FeatureGates, "clearGateOverride", $6b6c8129f5a844c6$var$_FeatureGates.client.clearGateOverride.bind($6b6c8129f5a844c6$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($6b6c8129f5a844c6$var$FeatureGates, "overrideConfig", $6b6c8129f5a844c6$var$_FeatureGates.client.overrideConfig.bind($6b6c8129f5a844c6$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($6b6c8129f5a844c6$var$FeatureGates, "clearConfigOverride", $6b6c8129f5a844c6$var$_FeatureGates.client.clearConfigOverride.bind($6b6c8129f5a844c6$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($6b6c8129f5a844c6$var$FeatureGates, "setOverrides", $6b6c8129f5a844c6$var$_FeatureGates.client.setOverrides.bind($6b6c8129f5a844c6$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($6b6c8129f5a844c6$var$FeatureGates, "getOverrides", $6b6c8129f5a844c6$var$_FeatureGates.client.getOverrides.bind($6b6c8129f5a844c6$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($6b6c8129f5a844c6$var$FeatureGates, "clearAllOverrides", $6b6c8129f5a844c6$var$_FeatureGates.client.clearAllOverrides.bind($6b6c8129f5a844c6$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($6b6c8129f5a844c6$var$FeatureGates, "isCurrentUser", $6b6c8129f5a844c6$var$_FeatureGates.client.isCurrentUser.bind($6b6c8129f5a844c6$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($6b6c8129f5a844c6$var$FeatureGates, "onGateUpdated", $6b6c8129f5a844c6$var$_FeatureGates.client.onGateUpdated.bind($6b6c8129f5a844c6$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($6b6c8129f5a844c6$var$FeatureGates, "onExperimentValueUpdated", $6b6c8129f5a844c6$var$_FeatureGates.client.onExperimentValueUpdated.bind($6b6c8129f5a844c6$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($6b6c8129f5a844c6$var$FeatureGates, "onAnyUpdated", $6b6c8129f5a844c6$var$_FeatureGates.client.onAnyUpdated.bind($6b6c8129f5a844c6$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($6b6c8129f5a844c6$var$FeatureGates, "updateUser", $6b6c8129f5a844c6$var$_FeatureGates.client.updateUser.bind($6b6c8129f5a844c6$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($6b6c8129f5a844c6$var$FeatureGates, "updateUserWithProvider", $6b6c8129f5a844c6$var$_FeatureGates.client.updateUserWithProvider.bind($6b6c8129f5a844c6$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($6b6c8129f5a844c6$var$FeatureGates, "updateUserWithValues", $6b6c8129f5a844c6$var$_FeatureGates.client.updateUserWithValues.bind($6b6c8129f5a844c6$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($6b6c8129f5a844c6$var$FeatureGates, "getPackageVersion", $6b6c8129f5a844c6$var$_FeatureGates.client.getPackageVersion.bind($6b6c8129f5a844c6$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($6b6c8129f5a844c6$var$FeatureGates, "getLayer", $6b6c8129f5a844c6$var$_FeatureGates.client.getLayer.bind($6b6c8129f5a844c6$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($6b6c8129f5a844c6$var$FeatureGates, "getLayerValue", $6b6c8129f5a844c6$var$_FeatureGates.client.getLayerValue.bind($6b6c8129f5a844c6$var$_FeatureGates.client));
var $6b6c8129f5a844c6$var$boundFGJS = $6b6c8129f5a844c6$var$FeatureGates;
// This makes it possible to get a reference to the FeatureGates client at runtime.
// This is important for overriding values in Cypress tests, as there needs to be a
// way to get the exact instance for a window in order to mock some of its methods.
if (typeof window !== 'undefined') {
    if (window.__FEATUREGATES_JS__ === undefined) window.__FEATUREGATES_JS__ = $6b6c8129f5a844c6$var$FeatureGates;
    else {
        var $6b6c8129f5a844c6$var$_boundFGJS, $6b6c8129f5a844c6$var$_boundFGJS$getPackage;
        $6b6c8129f5a844c6$var$boundFGJS = window.__FEATUREGATES_JS__;
        var $6b6c8129f5a844c6$var$boundVersion = (($6b6c8129f5a844c6$var$_boundFGJS = $6b6c8129f5a844c6$var$boundFGJS) === null || $6b6c8129f5a844c6$var$_boundFGJS === void 0 || ($6b6c8129f5a844c6$var$_boundFGJS$getPackage = $6b6c8129f5a844c6$var$_boundFGJS.getPackageVersion) === null || $6b6c8129f5a844c6$var$_boundFGJS$getPackage === void 0 ? void 0 : $6b6c8129f5a844c6$var$_boundFGJS$getPackage.call($6b6c8129f5a844c6$var$_boundFGJS)) || '4.10.0 or earlier';
        if ($6b6c8129f5a844c6$var$boundVersion !== (0, $89UMm.CLIENT_VERSION)) {
            var $6b6c8129f5a844c6$var$message = "Multiple versions of FeatureGateClients found on the current page.\n      The currently bound version is ".concat($6b6c8129f5a844c6$var$boundVersion, " when module version ").concat((0, $89UMm.CLIENT_VERSION), " was loading.");
            // eslint-disable-next-line no-console
            console.warn($6b6c8129f5a844c6$var$message);
        }
    }
}
var /**
 * @property {FeatureGates} FeatureGate default export
 */ $6b6c8129f5a844c6$export$2e2bcd8739ae039 = $6b6c8129f5a844c6$var$boundFGJS;

});
parcelRegister("1Odth", function(module, exports) {
$parcel$export(module.exports, "Client", () => $1514e90f383af0c2$export$1f2bb630327ac4b6);

var $1Vcia = parcelRequire("1Vcia");

var $iYJcE = parcelRequire("iYJcE");

var $fL8KA = parcelRequire("fL8KA");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $25nEq = parcelRequire("25nEq");

var $6HG4S = parcelRequire("6HG4S");

var $iFR7a = parcelRequire("iFR7a");

var $guzUG = parcelRequire("guzUG");

var $gnEZW = parcelRequire("gnEZW");

var $knFmu = parcelRequire("knFmu");

var $kgfMl = parcelRequire("kgfMl");

var $lSU5S = parcelRequire("lSU5S");

var $aZyWe = parcelRequire("aZyWe");

var $9A4g1 = parcelRequire("9A4g1");

var $g5oCJ = parcelRequire("g5oCJ");

var $3sxkV = parcelRequire("3sxkV");

var $89UMm = parcelRequire("89UMm");
var $1514e90f383af0c2$var$_excluded = [
    "sdkKey",
    "environment",
    "updateUserCompletionCallback",
    "perimeter"
];
function $1514e90f383af0c2$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $1514e90f383af0c2$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $1514e90f383af0c2$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $1514e90f383af0c2$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $1514e90f383af0c2$var$DEFAULT_CLIENT_KEY = 'client-default-key';
// default event logging api is Atlassian proxy rather than Statsig's domain, to avoid ad blockers
var $1514e90f383af0c2$var$DEFAULT_EVENT_LOGGING_API = 'https://xp.atlassian.com/v1/rgstr';
var $1514e90f383af0c2$export$1f2bb630327ac4b6 = /*#__PURE__*/ function() {
    function Client() {
        var _this = this;
        var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, _ref$localStorageKey = _ref.localStorageKey, localStorageKey = _ref$localStorageKey === void 0 ? (0, $9A4g1.LOCAL_STORAGE_KEY) : _ref$localStorageKey, overrideAdapter = _ref.overrideAdapter;
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, Client);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "initPromise", null);
        /** True if an initialize method was called and completed successfully. */ (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "initCompleted", false);
        /**
     * True if an initialize method was called and completed, meaning the client is now usable.
     * However if there was an error during initialization it may have initialized with default
     * values. Use {@link initCompleted} to check for this.
     */ (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "initWithDefaults", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "hasCheckGateErrorOccurred", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "hasGetExperimentErrorOccurred", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "hasGetExperimentValueErrorOccurred", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "hasGetLayerErrorOccurred", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "hasGetLayerValueErrorOccurred", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "subscriptions", new (0, $guzUG.default)());
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "dataAdapter", new (0, $aZyWe.NoFetchDataAdapter)());
        /**
     * Call this if modifying the values being served by the Statsig library since it has its own
     * memoization cache which will not be updated if the values are changed outside of the library.
     */ (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "statsigValuesUpdated", function() {
            if (_this.user) // Trigger a reset of the memoize cache
            _this.statsigClient.updateUserSync(_this.user, {
                disableBackgroundCacheRefresh: true
            });
            _this.subscriptions.anyUpdated();
        });
        this.overrideAdapter = overrideAdapter || new (0, $9A4g1.PersistentOverrideAdapter)(localStorageKey);
    }
    /**
   * @description
   * This method initializes the client using a network call to fetch the bootstrap values.
   * If the client is inialized with an `analyticsWebClient`, it will send an operational event
   * to GASv3 with the following attributes:
   * - targetApp: the target app of the client
   * - clientVersion: the version of the client
   * - success: whether the initialization was successful
   * - startTime: the time when the initialization started
   * - totalTime: the total time it took to initialize the client
   * - apiKey: the api key used to initialize the client
   * @param clientOptions {ClientOptions}
   * @param identifiers {Identifiers}
   * @param customAttributes {CustomAttributes}
   * @returns {Promise<void>}
   */ return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(Client, [
        {
            key: "initialize",
            value: function() {
                var _initialize = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee(clientOptions, identifiers, customAttributes) {
                    var _this2 = this;
                    var clientOptionsWithDefaults, startTime;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee$(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                clientOptionsWithDefaults = (0, $3sxkV.getOptionsWithDefaults)(clientOptions);
                                if (!this.initPromise) {
                                    _context.next = 4;
                                    break;
                                }
                                if (!(0, $3sxkV.shallowEquals)(clientOptionsWithDefaults, this.initOptions)) // eslint-disable-next-line no-console
                                console.warn('Feature Gates client already initialized with different options. New options were not applied.');
                                return _context.abrupt("return", this.initPromise);
                            case 4:
                                startTime = performance.now();
                                this.initOptions = clientOptionsWithDefaults;
                                this.initPromise = this.init(clientOptionsWithDefaults, identifiers, customAttributes).then(function() {
                                    _this2.initCompleted = true;
                                    _this2.initWithDefaults = true;
                                }).finally(function() {
                                    var endTime = performance.now();
                                    var totalTime = endTime - startTime;
                                    _this2.fireClientEvent(startTime, totalTime, 'initialize', _this2.initCompleted, clientOptionsWithDefaults.apiKey);
                                });
                                return _context.abrupt("return", this.initPromise);
                            case 8:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee, this);
                }));
                function initialize(_x, _x2, _x3) {
                    return _initialize.apply(this, arguments);
                }
                return initialize;
            }()
        },
        {
            key: "initializeWithProvider",
            value: function() {
                var _initializeWithProvider = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee2(clientOptions, provider, identifiers, customAttributes) {
                    var _this3 = this;
                    var clientOptionsWithDefaults, startTime;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee2$(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                clientOptionsWithDefaults = (0, $3sxkV.getOptionsWithDefaults)(clientOptions);
                                if (!this.initPromise) {
                                    _context2.next = 4;
                                    break;
                                }
                                if (!(0, $3sxkV.shallowEquals)(clientOptionsWithDefaults, this.initOptions)) // eslint-disable-next-line no-console
                                console.warn('Feature Gates client already initialized with different options. New options were not applied.');
                                return _context2.abrupt("return", this.initPromise);
                            case 4:
                                startTime = performance.now();
                                this.initOptions = clientOptionsWithDefaults;
                                this.provider = provider;
                                this.provider.setClientVersion((0, $89UMm.CLIENT_VERSION));
                                if (this.provider.setApplyUpdateCallback) this.provider.setApplyUpdateCallback(this.applyUpdateCallback.bind(this));
                                this.initPromise = this.initWithProvider(clientOptionsWithDefaults, provider, identifiers, customAttributes).then(function() {
                                    _this3.initCompleted = true;
                                    _this3.initWithDefaults = true;
                                }).finally(function() {
                                    var endTime = performance.now();
                                    var totalTime = endTime - startTime;
                                    _this3.fireClientEvent(startTime, totalTime, 'initializeWithProvider', _this3.initCompleted, provider.getApiKey ? provider.getApiKey() : undefined);
                                });
                                return _context2.abrupt("return", this.initPromise);
                            case 11:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2, this);
                }));
                function initializeWithProvider(_x4, _x5, _x6, _x7) {
                    return _initializeWithProvider.apply(this, arguments);
                }
                return initializeWithProvider;
            }()
        },
        {
            key: "applyUpdateCallback",
            value: function applyUpdateCallback(experimentsResult) {
                try {
                    if (this.initCompleted || this.initWithDefaults) {
                        this.assertInitialized(this.statsigClient);
                        this.dataAdapter.setBootstrapData(experimentsResult.experimentValues);
                        this.dataAdapter.setData(JSON.stringify(experimentsResult.experimentValues));
                        this.statsigValuesUpdated();
                    }
                } catch (error) {
                    // eslint-disable-next-line no-console
                    console.warn('Error when attempting to apply update', error);
                }
            }
        },
        {
            key: "fireClientEvent",
            value: function fireClientEvent(startTime, totalTime, action, success) {
                var _analyticsWebClient, _this4 = this;
                var apiKey = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
                (_analyticsWebClient = this.initOptions.analyticsWebClient) === null || _analyticsWebClient === void 0 || _analyticsWebClient.then(function(analyticsWebClient) {
                    var attributes = $1514e90f383af0c2$var$_objectSpread({
                        targetApp: _this4.initOptions.targetApp,
                        clientVersion: (0, $89UMm.CLIENT_VERSION),
                        success: success,
                        startTime: startTime,
                        totalTime: totalTime
                    }, apiKey && {
                        apiKey: apiKey
                    });
                    analyticsWebClient.sendOperationalEvent({
                        action: action,
                        actionSubject: 'featureGatesClient',
                        attributes: attributes,
                        tags: [
                            'measurement'
                        ],
                        source: '@atlaskit/feature-gate-js-client'
                    });
                }).catch(function(err) {
                    if (_this4.initOptions.environment !== (0, $g5oCJ.FeatureGateEnvironment).Production) // eslint-disable-next-line no-console
                    console.error('Analytics web client promise did not resolve', err);
                });
            }
        },
        {
            key: "initializeFromValues",
            value: function() {
                var _initializeFromValues = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee3(clientOptions, identifiers, customAttributes) {
                    var _this5 = this;
                    var initializeValues, clientOptionsWithDefaults, startTime, _args3 = arguments;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee3$(_context3) {
                        while(true)switch(_context3.prev = _context3.next){
                            case 0:
                                initializeValues = _args3.length > 3 && _args3[3] !== undefined ? _args3[3] : {};
                                clientOptionsWithDefaults = (0, $3sxkV.getOptionsWithDefaults)(clientOptions);
                                if (!this.initPromise) {
                                    _context3.next = 5;
                                    break;
                                }
                                if (!(0, $3sxkV.shallowEquals)(clientOptionsWithDefaults, this.initOptions)) // eslint-disable-next-line no-console
                                console.warn('Feature Gates client already initialized with different options. New options were not applied.');
                                return _context3.abrupt("return", this.initPromise);
                            case 5:
                                // This makes sure the new Statsig client behaves like the old when bootstrap data is
                                // passed, and `has_updates` isn't specified (which happens a lot in product integration tests).
                                if (!Object.prototype.hasOwnProperty.call(initializeValues, 'has_updates')) initializeValues['has_updates'] = true;
                                startTime = performance.now();
                                this.initOptions = clientOptionsWithDefaults;
                                this.initPromise = this.initFromValues(clientOptionsWithDefaults, identifiers, customAttributes, initializeValues).then(function() {
                                    _this5.initCompleted = true;
                                    _this5.initWithDefaults = true;
                                }).finally(function() {
                                    var endTime = performance.now();
                                    var totalTime = endTime - startTime;
                                    _this5.fireClientEvent(startTime, totalTime, 'initializeFromValues', _this5.initCompleted);
                                });
                                return _context3.abrupt("return", this.initPromise);
                            case 10:
                            case "end":
                                return _context3.stop();
                        }
                    }, _callee3, this);
                }));
                function initializeFromValues(_x8, _x9, _x0) {
                    return _initializeFromValues.apply(this, arguments);
                }
                return initializeFromValues;
            }()
        },
        {
            key: "assertInitialized",
            value: function assertInitialized(statsigClient) {
                if (!statsigClient) throw new Error('Client must be initialized before using this method');
            }
        },
        {
            key: "updateUser",
            value: function() {
                var _updateUser = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee4(fetchOptions, identifiers, customAttributes) {
                    var fetchOptionsWithDefaults, initializeValuesProducer;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee4$(_context4) {
                        while(true)switch(_context4.prev = _context4.next){
                            case 0:
                                this.assertInitialized(this.statsigClient);
                                fetchOptionsWithDefaults = (0, $3sxkV.getOptionsWithDefaults)(fetchOptions);
                                initializeValuesProducer = function initializeValuesProducer() {
                                    return (0, $lSU5S.default).fetchExperimentValues(fetchOptionsWithDefaults, identifiers, customAttributes).then(function(_ref2) {
                                        var experimentValues = _ref2.experimentValues, customAttributes = _ref2.customAttributes;
                                        return {
                                            experimentValues: experimentValues,
                                            customAttributesFromFetch: customAttributes
                                        };
                                    });
                                };
                                _context4.next = 5;
                                return this.updateUserUsingInitializeValuesProducer(initializeValuesProducer, identifiers, customAttributes);
                            case 5:
                            case "end":
                                return _context4.stop();
                        }
                    }, _callee4, this);
                }));
                function updateUser(_x1, _x10, _x11) {
                    return _updateUser.apply(this, arguments);
                }
                return updateUser;
            }()
        },
        {
            key: "updateUserWithProvider",
            value: function() {
                var _updateUserWithProvider = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee5(identifiers, customAttributes) {
                    var _this6 = this;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee5$(_context5) {
                        while(true)switch(_context5.prev = _context5.next){
                            case 0:
                                this.assertInitialized(this.statsigClient);
                                if (this.provider) {
                                    _context5.next = 3;
                                    break;
                                }
                                throw new Error('Cannot update user using provider as the client was not initialised with a provider');
                            case 3:
                                _context5.next = 5;
                                return this.provider.setProfile(this.initOptions, identifiers, customAttributes);
                            case 5:
                                _context5.next = 7;
                                return this.updateUserUsingInitializeValuesProducer(function() {
                                    return _this6.provider.getExperimentValues();
                                }, identifiers, customAttributes);
                            case 7:
                            case "end":
                                return _context5.stop();
                        }
                    }, _callee5, this);
                }));
                function updateUserWithProvider(_x12, _x13) {
                    return _updateUserWithProvider.apply(this, arguments);
                }
                return updateUserWithProvider;
            }()
        },
        {
            key: "updateUserWithValues",
            value: function() {
                var _updateUserWithValues = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee6(identifiers, customAttributes) {
                    var initializeValues, initializeValuesProducer, _args6 = arguments;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee6$(_context6) {
                        while(true)switch(_context6.prev = _context6.next){
                            case 0:
                                initializeValues = _args6.length > 2 && _args6[2] !== undefined ? _args6[2] : {};
                                this.assertInitialized(this.statsigClient);
                                initializeValuesProducer = function initializeValuesProducer() {
                                    return Promise.resolve({
                                        experimentValues: initializeValues,
                                        customAttributesFromFetch: customAttributes
                                    });
                                };
                                _context6.next = 5;
                                return this.updateUserUsingInitializeValuesProducer(initializeValuesProducer, identifiers, customAttributes);
                            case 5:
                            case "end":
                                return _context6.stop();
                        }
                    }, _callee6, this);
                }));
                function updateUserWithValues(_x14, _x15) {
                    return _updateUserWithValues.apply(this, arguments);
                }
                return updateUserWithValues;
            }()
        },
        {
            key: "initializeCalled",
            value: function initializeCalled() {
                return this.initPromise != null;
            }
        },
        {
            key: "initializeCompleted",
            value: function initializeCompleted() {
                return this.initCompleted;
            }
        },
        {
            key: "waitUntilInitializeCompleted",
            value: function() {
                var _waitUntilInitializeCompleted = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee7() {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee7$(_context7) {
                        while(true)switch(_context7.prev = _context7.next){
                            case 0:
                                if (this.initPromise) {
                                    _context7.next = 2;
                                    break;
                                }
                                throw new Error('The client must be initialized before you can wait until initialized.');
                            case 2:
                                if (!this.initCompleted) {
                                    _context7.next = 4;
                                    break;
                                }
                                return _context7.abrupt("return");
                            case 4:
                                _context7.next = 6;
                                return this.initPromise;
                            case 6:
                            case "end":
                                return _context7.stop();
                        }
                    }, _callee7, this);
                }));
                function waitUntilInitializeCompleted() {
                    return _waitUntilInitializeCompleted.apply(this, arguments);
                }
                return waitUntilInitializeCompleted;
            }()
        },
        {
            key: "checkGate",
            value: function checkGate(gateName) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                try {
                    this.assertInitialized(this.statsigClient);
                    var _options$fireGateExpo = options.fireGateExposure, fireGateExposure = _options$fireGateExpo === void 0 ? true : _options$fireGateExpo;
                    return this.statsigClient.checkGate(gateName, {
                        disableExposureLog: !fireGateExposure
                    });
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!this.hasCheckGateErrorOccurred) {
                        // eslint-disable-next-line no-console
                        console.warn({
                            msg: 'An error has occurred checking the feature gate. Only the first occurrence of this error is logged.',
                            gateName: gateName,
                            error: error
                        });
                        this.hasCheckGateErrorOccurred = true;
                    }
                    return false;
                }
            }
        },
        {
            key: "isGateExist",
            value: function isGateExist(gateName) {
                try {
                    this.assertInitialized(this.statsigClient);
                    var gate = this.statsigClient.getFeatureGate(gateName, {
                        disableExposureLog: true
                    });
                    return !gate.details.reason.includes('Unrecognized');
                } catch (error) {
                    // eslint-disable-next-line no-console
                    console.error("Error occurred when trying to check FeatureGate: ".concat(error));
                    // in case of error report true to avoid false positives.
                    return true;
                }
            }
        },
        {
            key: "isExperimentExist",
            value: function isExperimentExist(experimentName) {
                try {
                    this.assertInitialized(this.statsigClient);
                    var config = this.statsigClient.getExperiment(experimentName, {
                        disableExposureLog: true
                    });
                    return !config.details.reason.includes('Unrecognized');
                } catch (error) {
                    // eslint-disable-next-line no-console
                    console.error("Error occurred when trying to check Experiment: ".concat(error));
                    // in case of error report true to avoid false positives.
                    return true;
                }
            }
        },
        {
            key: "manuallyLogGateExposure",
            value: function manuallyLogGateExposure(gateName) {
                this.assertInitialized(this.statsigClient);
                // This is the approach recommended in the docs
                // https://docs.statsig.com/client/javascript-sdk/#manual-exposures-
                this.statsigClient.checkGate(gateName);
            }
        },
        {
            key: "getExperiment",
            value: function getExperiment(experimentName) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                try {
                    this.assertInitialized(this.statsigClient);
                    var _options$fireExperime = options.fireExperimentExposure, fireExperimentExposure = _options$fireExperime === void 0 ? true : _options$fireExperime;
                    return (0, $gnEZW.DynamicConfig).fromExperiment(this.statsigClient.getExperiment(experimentName, {
                        disableExposureLog: !fireExperimentExposure
                    }));
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!this.hasGetExperimentErrorOccurred) {
                        // eslint-disable-next-line no-console
                        console.warn({
                            msg: 'An error has occurred getting the experiment. Only the first occurrence of this error is logged.',
                            experimentName: experimentName,
                            error: error
                        });
                        this.hasGetExperimentErrorOccurred = true;
                    }
                    // Return a default value
                    return new (0, $gnEZW.DynamicConfig)(experimentName, {}, '', {
                        time: Date.now(),
                        reason: (0, $kgfMl.EvaluationReason).Error
                    });
                }
            }
        },
        {
            key: "getExperimentValue",
            value: function getExperimentValue(experimentName, parameterName, defaultValue) {
                var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var experiment = this.getExperiment(experimentName, options);
                try {
                    var typeGuard = options.typeGuard;
                    return experiment.get(parameterName, defaultValue, typeGuard);
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!this.hasGetExperimentValueErrorOccurred) {
                        // eslint-disable-next-line no-console
                        console.warn({
                            msg: 'An error has occurred getting the experiment value. Only the first occurrence of this error is logged.',
                            experimentName: experimentName,
                            defaultValue: defaultValue,
                            options: options,
                            error: error
                        });
                        this.hasGetExperimentValueErrorOccurred = true;
                    }
                    return defaultValue;
                }
            }
        },
        {
            key: "manuallyLogExperimentExposure",
            value: function manuallyLogExperimentExposure(experimentName) {
                this.assertInitialized(this.statsigClient);
                // This is the approach recommended in the docs
                // https://docs.statsig.com/client/javascript-sdk/#manual-exposures-
                this.statsigClient.getExperiment(experimentName);
            }
        },
        {
            key: "manuallyLogLayerExposure",
            value: function manuallyLogLayerExposure(layerName, parameterName) {
                var _this$statsigClient$g;
                this.assertInitialized(this.statsigClient);
                // This is the approach recommended in the docs
                // https://docs.statsig.com/client/javascript-sdk/#manual-exposures-
                (_this$statsigClient$g = this.statsigClient.getLayer(layerName)) === null || _this$statsigClient$g === void 0 || _this$statsigClient$g.get(parameterName);
            }
        },
        {
            key: "shutdownStatsig",
            value: function shutdownStatsig() {
                this.assertInitialized(this.statsigClient);
                this.statsigClient.shutdown();
            }
        },
        {
            key: "overrideGate",
            value: function overrideGate(gateName, value) {
                this.overrideAdapter.overrideGate(gateName, value);
                // Trigger a reset of the memoized gate value
                if (this.user) {
                    var _this$statsigClient;
                    (_this$statsigClient = this.statsigClient) === null || _this$statsigClient === void 0 || _this$statsigClient.updateUserSync(this.user, {
                        disableBackgroundCacheRefresh: true
                    });
                }
                this.statsigValuesUpdated();
            }
        },
        {
            key: "clearGateOverride",
            value: function clearGateOverride(gateName) {
                this.overrideAdapter.removeGateOverride(gateName);
                this.statsigValuesUpdated();
            }
        },
        {
            key: "overrideConfig",
            value: function overrideConfig(experimentName, values) {
                this.overrideAdapter.overrideDynamicConfig(experimentName, values);
                this.statsigValuesUpdated();
            }
        },
        {
            key: "clearConfigOverride",
            value: function clearConfigOverride(experimentName) {
                this.overrideAdapter.removeDynamicConfigOverride(experimentName);
                this.statsigValuesUpdated();
            }
        },
        {
            key: "setOverrides",
            value: function setOverrides(overrides) {
                this.overrideAdapter.setOverrides(overrides);
                this.statsigValuesUpdated();
            }
        },
        {
            key: "getOverrides",
            value: function getOverrides() {
                return this.overrideAdapter.getOverrides();
            }
        },
        {
            key: "clearAllOverrides",
            value: function clearAllOverrides() {
                this.overrideAdapter.removeAllOverrides();
                this.statsigValuesUpdated();
            }
        },
        {
            key: "isCurrentUser",
            value: function isCurrentUser(identifiers, customAttributes) {
                return (0, $3sxkV.shallowEquals)(this.currentIdentifiers, identifiers) && (0, $3sxkV.shallowEquals)(this.currentAttributes, customAttributes);
            }
        },
        {
            key: "onGateUpdated",
            value: function onGateUpdated(gateName, callback) {
                var _this7 = this;
                var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var wrapCallback = function wrapCallback(value) {
                    var _options$fireGateExpo2 = options.fireGateExposure, fireGateExposure = _options$fireGateExpo2 === void 0 ? true : _options$fireGateExpo2;
                    if (fireGateExposure) _this7.manuallyLogGateExposure(gateName);
                    try {
                        callback(value);
                    } catch (error) {
                        // eslint-disable-next-line no-console
                        console.warn("Error calling callback for gate ".concat(gateName, " with value ").concat(value), error);
                    }
                };
                return this.subscriptions.onGateUpdated(gateName, wrapCallback, this.checkGate.bind(this), options);
            }
        },
        {
            key: "onExperimentValueUpdated",
            value: function onExperimentValueUpdated(experimentName, parameterName, defaultValue, callback) {
                var _this8 = this;
                var options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
                var wrapCallback = function wrapCallback(value) {
                    var _options$fireExperime2 = options.fireExperimentExposure, fireExperimentExposure = _options$fireExperime2 === void 0 ? true : _options$fireExperime2;
                    if (fireExperimentExposure) _this8.manuallyLogExperimentExposure(experimentName);
                    try {
                        callback(value);
                    } catch (error) {
                        // eslint-disable-next-line no-console
                        console.warn("Error calling callback for experiment ".concat(experimentName, " with value ").concat(value), error);
                    }
                };
                return this.subscriptions.onExperimentValueUpdated(experimentName, parameterName, defaultValue, wrapCallback, this.getExperimentValue.bind(this), options);
            }
        },
        {
            key: "onAnyUpdated",
            value: function onAnyUpdated(callback) {
                return this.subscriptions.onAnyUpdated(callback);
            }
        },
        {
            key: "init",
            value: function() {
                var _init = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee8(clientOptions, identifiers, customAttributes) {
                    var fromValuesClientOptions, experimentValues, customAttributesFromResult, clientSdkKeyPromise, experimentValuesPromise, _yield$Promise$all, _yield$Promise$all2, experimentValuesResult;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee8$(_context8) {
                        while(true)switch(_context8.prev = _context8.next){
                            case 0:
                                fromValuesClientOptions = $1514e90f383af0c2$var$_objectSpread({}, clientOptions);
                                _context8.prev = 1;
                                // If client sdk key fetch fails, an error would be thrown and handled instead of waiting for
                                // the experiment values request to be settled, and it will fall back to use default values.
                                clientSdkKeyPromise = (0, $lSU5S.default).fetchClientSdk(clientOptions).then(function(value) {
                                    return fromValuesClientOptions.sdkKey = value.clientSdkKey;
                                });
                                experimentValuesPromise = (0, $lSU5S.default).fetchExperimentValues(clientOptions, identifiers, customAttributes); // Only wait for the experiment values request to finish and try to initialise the client
                                // with experiment values if both requests are successful. Else an error would be thrown and
                                // handled by the catch
                                _context8.next = 6;
                                return Promise.all([
                                    clientSdkKeyPromise,
                                    experimentValuesPromise
                                ]);
                            case 6:
                                _yield$Promise$all = _context8.sent;
                                _yield$Promise$all2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_yield$Promise$all, 2);
                                experimentValuesResult = _yield$Promise$all2[1];
                                experimentValues = experimentValuesResult.experimentValues;
                                customAttributesFromResult = experimentValuesResult.customAttributes;
                                _context8.next = 20;
                                break;
                            case 13:
                                _context8.prev = 13;
                                _context8.t0 = _context8["catch"](1);
                                if (_context8.t0 instanceof Error) // eslint-disable-next-line no-console
                                console.error("Error occurred when trying to fetch the Feature Gates client values, error: ".concat(_context8.t0 === null || _context8.t0 === void 0 ? void 0 : _context8.t0.message));
                                // eslint-disable-next-line no-console
                                console.warn("Initialising Statsig client without values");
                                _context8.next = 19;
                                return this.initFromValues(fromValuesClientOptions, identifiers, customAttributes);
                            case 19:
                                throw _context8.t0;
                            case 20:
                                return _context8.abrupt("return", this.initFromValues(fromValuesClientOptions, identifiers, customAttributesFromResult, experimentValues));
                            case 21:
                            case "end":
                                return _context8.stop();
                        }
                    }, _callee8, this, [
                        [
                            1,
                            13
                        ]
                    ]);
                }));
                function init(_x16, _x17, _x18) {
                    return _init.apply(this, arguments);
                }
                return init;
            }()
        },
        {
            key: "initWithProvider",
            value: function() {
                var _initWithProvider = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee9(baseClientOptions, provider, identifiers, customAttributes) {
                    var fromValuesClientOptions, experimentValues, customAttributesFromResult, clientSdkKeyPromise, experimentValuesPromise, _yield$Promise$all3, _yield$Promise$all4, experimentValuesResult;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee9$(_context9) {
                        while(true)switch(_context9.prev = _context9.next){
                            case 0:
                                fromValuesClientOptions = $1514e90f383af0c2$var$_objectSpread($1514e90f383af0c2$var$_objectSpread({}, baseClientOptions), {}, {
                                    disableCurrentPageLogging: true
                                });
                                _context9.prev = 1;
                                _context9.next = 4;
                                return provider.setProfile(baseClientOptions, identifiers, customAttributes);
                            case 4:
                                // If client sdk key fetch fails, an error would be thrown and handled instead of waiting for
                                // the experiment values request to be settled, and it will fall back to use default values.
                                clientSdkKeyPromise = provider.getClientSdkKey().then(function(value) {
                                    return fromValuesClientOptions.sdkKey = value;
                                });
                                experimentValuesPromise = provider.getExperimentValues(); // Only wait for the experiment values request to finish and try to initialise the client
                                // with experiment values if both requests are successful. Else an error would be thrown and
                                // handled by the catch
                                _context9.next = 8;
                                return Promise.all([
                                    clientSdkKeyPromise,
                                    experimentValuesPromise
                                ]);
                            case 8:
                                _yield$Promise$all3 = _context9.sent;
                                _yield$Promise$all4 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_yield$Promise$all3, 2);
                                experimentValuesResult = _yield$Promise$all4[1];
                                experimentValues = experimentValuesResult.experimentValues;
                                customAttributesFromResult = experimentValuesResult.customAttributesFromFetch;
                                _context9.next = 22;
                                break;
                            case 15:
                                _context9.prev = 15;
                                _context9.t0 = _context9["catch"](1);
                                if (_context9.t0 instanceof Error) // eslint-disable-next-line no-console
                                console.error("Error occurred when trying to fetch the Feature Gates client values, error: ".concat(_context9.t0 === null || _context9.t0 === void 0 ? void 0 : _context9.t0.message));
                                // eslint-disable-next-line no-console
                                console.warn("Initialising Statsig client without values");
                                _context9.next = 21;
                                return this.initFromValues(fromValuesClientOptions, identifiers, customAttributes);
                            case 21:
                                throw _context9.t0;
                            case 22:
                                return _context9.abrupt("return", this.initFromValues(fromValuesClientOptions, identifiers, customAttributesFromResult, experimentValues));
                            case 23:
                            case "end":
                                return _context9.stop();
                        }
                    }, _callee9, this, [
                        [
                            1,
                            15
                        ]
                    ]);
                }));
                function initWithProvider(_x19, _x20, _x21, _x22) {
                    return _initWithProvider.apply(this, arguments);
                }
                return initWithProvider;
            }()
        },
        {
            key: "initFromValues",
            value: function() {
                var _initFromValues = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee0(clientOptions, identifiers, customAttributes) {
                    var _newClientOptions$net;
                    var initializeValues, newClientOptions, sdkKey, environment, _updateUserCompletionCallback, _perimeter, restClientOptions, statsigOptions, _args0 = arguments;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee0$(_context0) {
                        while(true)switch(_context0.prev = _context0.next){
                            case 0:
                                initializeValues = _args0.length > 3 && _args0[3] !== undefined ? _args0[3] : {};
                                this.overrideAdapter.initFromStoredOverrides();
                                this.currentIdentifiers = identifiers;
                                this.currentAttributes = customAttributes;
                                newClientOptions = (0, $3sxkV.migrateInitializationOptions)(clientOptions);
                                if (!newClientOptions.sdkKey) newClientOptions.sdkKey = $1514e90f383af0c2$var$DEFAULT_CLIENT_KEY;
                                if (!((_newClientOptions$net = newClientOptions.networkConfig) !== null && _newClientOptions$net !== void 0 && _newClientOptions$net.logEventUrl)) newClientOptions.networkConfig = $1514e90f383af0c2$var$_objectSpread($1514e90f383af0c2$var$_objectSpread({}, newClientOptions.networkConfig), {}, {
                                    logEventUrl: $1514e90f383af0c2$var$DEFAULT_EVENT_LOGGING_API
                                });
                                if (newClientOptions.perimeter === (0, $g5oCJ.PerimeterType).FEDRAMP_MODERATE) // disable all logging in FedRAMP to prevent egress of sensitive data
                                newClientOptions.disableLogging = true;
                                sdkKey = newClientOptions.sdkKey, environment = newClientOptions.environment, _updateUserCompletionCallback = newClientOptions.updateUserCompletionCallback, _perimeter = newClientOptions.perimeter, restClientOptions = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(newClientOptions, $1514e90f383af0c2$var$_excluded);
                                this.user = (0, $3sxkV.toStatsigUser)(identifiers, customAttributes);
                                statsigOptions = $1514e90f383af0c2$var$_objectSpread($1514e90f383af0c2$var$_objectSpread({}, restClientOptions), {}, {
                                    environment: {
                                        tier: environment
                                    },
                                    includeCurrentPageUrlWithEvents: false,
                                    dataAdapter: this.dataAdapter,
                                    overrideAdapter: this.overrideAdapter,
                                    logEventCompressionMode: (0, $iFR7a.LogEventCompressionMode).Forced
                                }); // Statsig validates the provided stableId against their own cookie, so we either need
                                // to update the cookie to match, or disable the validation completely.
                                if (identifiers.stableId) (0, $iFR7a.StableID).setOverride(identifiers.stableId, sdkKey);
                                else statsigOptions.disableStableID = true;
                                _context0.prev = 12;
                                this.statsigClient = new (0, $iFR7a.StatsigClient)(sdkKey, this.user, statsigOptions);
                                this.dataAdapter.setBootstrapData(initializeValues);
                                _context0.next = 17;
                                return this.statsigClient.initializeAsync();
                            case 17:
                                _context0.next = 29;
                                break;
                            case 19:
                                _context0.prev = 19;
                                _context0.t0 = _context0["catch"](12);
                                if (_context0.t0 instanceof Error) // eslint-disable-next-line no-console
                                console.error("Error occurred when trying to initialise the Statsig client, error: ".concat(_context0.t0 === null || _context0.t0 === void 0 ? void 0 : _context0.t0.message));
                                // eslint-disable-next-line no-console
                                console.warn("Initialising Statsig client with default sdk key and without values");
                                this.statsigClient = new (0, $iFR7a.StatsigClient)($1514e90f383af0c2$var$DEFAULT_CLIENT_KEY, this.user, statsigOptions);
                                this.dataAdapter.setBootstrapData();
                                _context0.next = 27;
                                return this.statsigClient.initializeAsync();
                            case 27:
                                this.initWithDefaults = true;
                                throw _context0.t0;
                            case 29:
                            case "end":
                                return _context0.stop();
                        }
                    }, _callee0, this, [
                        [
                            12,
                            19
                        ]
                    ]);
                }));
                function initFromValues(_x23, _x24, _x25) {
                    return _initFromValues.apply(this, arguments);
                }
                return initFromValues;
            }()
        },
        {
            key: "updateUserUsingInitializeValuesProducer",
            value: function() {
                var _updateUserUsingInitializeValuesProducer = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee10(getInitializeValues, identifiers, customAttributes) {
                    var _this9 = this;
                    var originalInitPromise, initializeValuesPromise, updateUserPromise;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee10$(_context10) {
                        while(true)switch(_context10.prev = _context10.next){
                            case 0:
                                this.assertInitialized(this.statsigClient);
                                if (this.initPromise) {
                                    _context10.next = 3;
                                    break;
                                }
                                throw new Error('The client must be initialized before you can update the user.');
                            case 3:
                                if (!this.isCurrentUser(identifiers, customAttributes)) {
                                    _context10.next = 5;
                                    break;
                                }
                                return _context10.abrupt("return", this.initPromise);
                            case 5:
                                // Wait for the current initialize/update to finish
                                originalInitPromise = this.initPromise;
                                _context10.prev = 6;
                                _context10.next = 9;
                                return this.initPromise;
                            case 9:
                                _context10.next = 13;
                                break;
                            case 11:
                                _context10.prev = 11;
                                _context10.t0 = _context10["catch"](6);
                            case 13:
                                initializeValuesPromise = getInitializeValues();
                                updateUserPromise = this.updateStatsigClientUser(initializeValuesPromise, identifiers, customAttributes); // We replace the init promise here since we are essentially re-initializing the client at this
                                // point. Any subsequent calls to await client.initialize() or client.updateUser()
                                // will now also await this user update.
                                this.initPromise = updateUserPromise.catch(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee1() {
                                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee1$(_context1) {
                                        while(true)switch(_context1.prev = _context1.next){
                                            case 0:
                                                // If the update failed then it changed nothing, so revert back to the original promise.
                                                _this9.initPromise = originalInitPromise;
                                                // Set the user profile again to revert back to the current user
                                                if (!_this9.provider) {
                                                    _context1.next = 4;
                                                    break;
                                                }
                                                _context1.next = 4;
                                                return _this9.provider.setProfile(_this9.initOptions, _this9.currentIdentifiers, _this9.currentAttributes);
                                            case 4:
                                            case "end":
                                                return _context1.stop();
                                        }
                                    }, _callee1);
                                })));
                                return _context10.abrupt("return", updateUserPromise);
                            case 17:
                            case "end":
                                return _context10.stop();
                        }
                    }, _callee10, this, [
                        [
                            6,
                            11
                        ]
                    ]);
                }));
                function updateUserUsingInitializeValuesProducer(_x26, _x27, _x28) {
                    return _updateUserUsingInitializeValuesProducer.apply(this, arguments);
                }
                return updateUserUsingInitializeValuesProducer;
            }()
        },
        {
            key: "updateStatsigClientUser",
            value: function() {
                var _updateStatsigClientUser = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee11(initializeValuesPromise, identifiers, customAttributes) {
                    var _this$initOptions, _this$initOptions$upd;
                    var initializeValues, user, _updateUserCompletion, _ref4, errMsg, success, errorMessage;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee11$(_context11) {
                        while(true)switch(_context11.prev = _context11.next){
                            case 0:
                                this.assertInitialized(this.statsigClient);
                                _context11.prev = 1;
                                _context11.next = 4;
                                return initializeValuesPromise;
                            case 4:
                                initializeValues = _context11.sent;
                                user = (0, $3sxkV.toStatsigUser)(identifiers, initializeValues.customAttributesFromFetch);
                                _context11.next = 13;
                                break;
                            case 8:
                                _context11.prev = 8;
                                _context11.t0 = _context11["catch"](1);
                                // Make sure the updateUserCompletionCallback is called for any errors in our custom code.
                                // This is not necessary for the updateUserWithValues call, because the Statsig client will
                                // already invoke the callback itself.
                                errMsg = _context11.t0 instanceof Error ? _context11.t0.message : JSON.stringify(_context11.t0);
                                (_updateUserCompletion = (_ref4 = this.initOptions).updateUserCompletionCallback) === null || _updateUserCompletion === void 0 || _updateUserCompletion.call(_ref4, false, errMsg);
                                throw _context11.t0;
                            case 13:
                                success = true;
                                errorMessage = null;
                                _context11.prev = 15;
                                this.dataAdapter.setBootstrapData(initializeValues.experimentValues);
                                this.user = user;
                                if (!this.user) {
                                    _context11.next = 21;
                                    break;
                                }
                                _context11.next = 21;
                                return this.statsigClient.updateUserAsync(this.user);
                            case 21:
                                _context11.next = 27;
                                break;
                            case 23:
                                _context11.prev = 23;
                                _context11.t1 = _context11["catch"](15);
                                success = false;
                                errorMessage = String(_context11.t1);
                            case 27:
                                (_this$initOptions = this.initOptions) === null || _this$initOptions === void 0 || (_this$initOptions$upd = _this$initOptions.updateUserCompletionCallback) === null || _this$initOptions$upd === void 0 || _this$initOptions$upd.call(_this$initOptions, success, errorMessage);
                                if (!success) {
                                    _context11.next = 34;
                                    break;
                                }
                                this.currentIdentifiers = identifiers;
                                this.currentAttributes = customAttributes;
                                this.subscriptions.anyUpdated();
                                _context11.next = 35;
                                break;
                            case 34:
                                throw new Error('Failed to update user. An unexpected error occured.');
                            case 35:
                            case "end":
                                return _context11.stop();
                        }
                    }, _callee11, this, [
                        [
                            1,
                            8
                        ],
                        [
                            15,
                            23
                        ]
                    ]);
                }));
                function updateStatsigClientUser(_x29, _x30, _x31) {
                    return _updateStatsigClientUser.apply(this, arguments);
                }
                return updateStatsigClientUser;
            }()
        },
        {
            key: "getPackageVersion",
            value: /**
     * @returns string version of the current package in semver style.
     */ function getPackageVersion() {
                return 0, $89UMm.CLIENT_VERSION;
            }
        },
        {
            key: "getLayer",
            value: function getLayer(/** The name of the layer */ layerName) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                try {
                    this.assertInitialized(this.statsigClient);
                    var _options$fireLayerExp = options.fireLayerExposure, fireLayerExposure = _options$fireLayerExp === void 0 ? true : _options$fireLayerExp;
                    return (0, $knFmu.Layer).fromLayer(this.statsigClient.getLayer(layerName, {
                        disableExposureLog: !fireLayerExposure
                    }));
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!this.hasGetLayerErrorOccurred) {
                        // eslint-disable-next-line no-console
                        console.warn({
                            msg: 'An error has occurred getting the layer. Only the first occurrence of this error is logged.',
                            layerName: layerName,
                            error: error
                        });
                        this.hasGetLayerErrorOccurred = true;
                    }
                    // Return a default value
                    return (0, $knFmu.Layer).fromLayer((0, $iFR7a._makeLayer)(layerName, {
                        reason: 'Error'
                    }, null));
                }
            }
        },
        {
            key: "getLayerValue",
            value: function getLayerValue(layerName, parameterName, defaultValue) {
                var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var layer = this.getLayer(layerName, options);
                try {
                    var typeGuard = options.typeGuard;
                    return layer.get(parameterName, defaultValue, typeGuard);
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!this.hasGetLayerValueErrorOccurred) {
                        // eslint-disable-next-line no-console
                        console.warn({
                            msg: 'An error has occurred getting the layer value. Only the first occurrence of this error is logged.',
                            layerName: layerName,
                            defaultValue: defaultValue,
                            options: options,
                            error: error
                        });
                        this.hasGetLayerValueErrorOccurred = true;
                    }
                    return defaultValue;
                }
            }
        }
    ]);
}();

});
parcelRegister("guzUG", function(module, exports) {
$parcel$export(module.exports, "default", () => $c01b4e4fd6ad81bc$export$2e2bcd8739ae039);

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $25nEq = parcelRequire("25nEq");

var $hLfKH = parcelRequire("hLfKH");
function $c01b4e4fd6ad81bc$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $c01b4e4fd6ad81bc$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $c01b4e4fd6ad81bc$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $c01b4e4fd6ad81bc$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $c01b4e4fd6ad81bc$export$a66cbd9b2289cd78 = '@all-features';
var $c01b4e4fd6ad81bc$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function Subscriptions() {
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, Subscriptions);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "eventToValue", new Map());
        this.emitter = new (0, (/*@__PURE__*/$parcel$interopDefault($hLfKH)))();
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(Subscriptions, [
        {
            key: "onGateUpdated",
            value: function onGateUpdated(gateName, callback, checkGate, options) {
                var _this = this;
                var value = checkGate(gateName, $c01b4e4fd6ad81bc$var$_objectSpread($c01b4e4fd6ad81bc$var$_objectSpread({}, options), {}, {
                    fireGateExposure: false
                }));
                if (this.eventToValue.get(callback) === undefined) this.eventToValue.set(callback, value);
                var wrapCallback = function wrapCallback() {
                    var value = checkGate(gateName, $c01b4e4fd6ad81bc$var$_objectSpread($c01b4e4fd6ad81bc$var$_objectSpread({}, options), {}, {
                        fireGateExposure: false
                    }));
                    var existingValue = _this.eventToValue.get(callback);
                    if (existingValue !== value) {
                        _this.eventToValue.set(callback, value);
                        callback(value);
                    }
                };
                this.emitter.on(gateName, wrapCallback);
                return function() {
                    _this.emitter.off(gateName, wrapCallback);
                };
            }
        },
        {
            key: "onExperimentValueUpdated",
            value: function onExperimentValueUpdated(experimentName, parameterName, defaultValue, callback, getExperimentValue, options) {
                var _this2 = this;
                var experimentEventName = "".concat(experimentName, ".").concat(parameterName);
                var value = getExperimentValue(experimentName, parameterName, defaultValue, $c01b4e4fd6ad81bc$var$_objectSpread($c01b4e4fd6ad81bc$var$_objectSpread({}, options), {}, {
                    fireExperimentExposure: false
                }));
                if (this.eventToValue.get(callback) === undefined) this.eventToValue.set(callback, value);
                var wrapCallback = function wrapCallback() {
                    var value = getExperimentValue(experimentName, parameterName, defaultValue, $c01b4e4fd6ad81bc$var$_objectSpread($c01b4e4fd6ad81bc$var$_objectSpread({}, options), {}, {
                        fireExperimentExposure: false
                    }));
                    var existingValue = _this2.eventToValue.get(callback);
                    if (existingValue !== value) {
                        _this2.eventToValue.set(callback, value);
                        callback(value);
                    }
                };
                this.emitter.on(experimentEventName, wrapCallback);
                return function() {
                    _this2.emitter.off(experimentEventName, wrapCallback);
                };
            }
        },
        {
            key: "onAnyUpdated",
            value: function onAnyUpdated(callback) {
                var _this3 = this;
                this.emitter.on($c01b4e4fd6ad81bc$export$a66cbd9b2289cd78, callback);
                return function() {
                    _this3.emitter.off($c01b4e4fd6ad81bc$export$a66cbd9b2289cd78, callback);
                };
            }
        },
        {
            key: "anyUpdated",
            value: function anyUpdated() {
                var _this4 = this;
                this.emitter.emit($c01b4e4fd6ad81bc$export$a66cbd9b2289cd78);
                this.emitter.eventNames().filter(function(name) {
                    return name !== $c01b4e4fd6ad81bc$export$a66cbd9b2289cd78;
                }).forEach(function(event) {
                    _this4.emitter.emit(event);
                });
            }
        }
    ]);
}();

});

parcelRegister("gnEZW", function(module, exports) {
$parcel$export(module.exports, "DynamicConfig", () => $bece98b50d9303e1$export$6dc24881a3d96325);

var $ekGgq = parcelRequire("ekGgq");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $3sxkV = parcelRequire("3sxkV");
var $bece98b50d9303e1$export$6dc24881a3d96325 = /*#__PURE__*/ function() {
    function DynamicConfig(configName, configValue, ruleID, evaluationDetails) {
        var secondaryExposures = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : [];
        var allocatedExperimentName = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : '';
        var onDefaultValueFallback = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : null;
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, DynamicConfig);
        this.value = configValue;
        this._name = configName;
        this._ruleID = ruleID;
        this._secondaryExposures = secondaryExposures;
        this._allocatedExperimentName = allocatedExperimentName;
        this._evaluationDetails = evaluationDetails;
        this._onDefaultValueFallback = onDefaultValueFallback;
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(DynamicConfig, [
        {
            key: "get",
            value: function get(key, defaultValue, typeGuard) {
                var _this$_onDefaultValue2;
                var val = this.getValue(key, defaultValue);
                if (val == null) return defaultValue;
                var expectedType = Array.isArray(defaultValue) ? 'array' : (0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(defaultValue);
                var actualType = Array.isArray(val) ? 'array' : (0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(val);
                if (typeGuard) {
                    var _this$_onDefaultValue;
                    if (typeGuard(val)) {
                        this.fireExposure(key);
                        return val;
                    }
                    (_this$_onDefaultValue = this._onDefaultValueFallback) === null || _this$_onDefaultValue === void 0 || _this$_onDefaultValue.call(this, this, key, expectedType, actualType);
                    return defaultValue;
                }
                if (defaultValue == null || expectedType === actualType) {
                    this.fireExposure(key);
                    return val;
                }
                (_this$_onDefaultValue2 = this._onDefaultValueFallback) === null || _this$_onDefaultValue2 === void 0 || _this$_onDefaultValue2.call(this, this, key, expectedType, actualType);
                return defaultValue;
            }
        },
        {
            key: "getValue",
            value: function getValue(key, defaultValue) {
                if (key == null) return this.value;
                if (defaultValue == null) defaultValue = null;
                if (this.value[key] == null) return defaultValue;
                this.fireExposure(key);
                return this.value[key];
            }
        },
        {
            key: "fireExposure",
            value: function fireExposure(key) {
                // Call the wrapped experiment's get method to fire exposure
                if (this.experiment) this.experiment.get(key);
            }
        }
    ], [
        {
            key: "fromExperiment",
            value: function fromExperiment(experiment) {
                var _experiment$__evaluat, _experiment$__evaluat2, _experiment$groupName;
                var config = new DynamicConfig(experiment.name, experiment.value, experiment.ruleID, (0, $3sxkV.migrateEvaluationDetails)(experiment.details), (0, $3sxkV.migrateSecondaryExposures)((_experiment$__evaluat = (_experiment$__evaluat2 = experiment.__evaluation) === null || _experiment$__evaluat2 === void 0 ? void 0 : _experiment$__evaluat2.secondary_exposures) !== null && _experiment$__evaluat !== void 0 ? _experiment$__evaluat : []), (_experiment$groupName = experiment.groupName) !== null && _experiment$groupName !== void 0 ? _experiment$groupName : undefined);
                config.experiment = experiment;
                return config;
            }
        }
    ]);
}();

});
parcelRegister("3sxkV", function(module, exports) {
$parcel$export(module.exports, "getOptionsWithDefaults", () => $284dd888d93e9bb1$export$d119b37e5f788b43);
$parcel$export(module.exports, "shallowEquals", () => $284dd888d93e9bb1$export$fa1c2bbf4100b8bc);
$parcel$export(module.exports, "toStatsigUser", () => $284dd888d93e9bb1$export$3dad1db244472f32);
$parcel$export(module.exports, "migrateInitializationOptions", () => $284dd888d93e9bb1$export$202946b690d26d22);
$parcel$export(module.exports, "migrateEvaluationDetails", () => $284dd888d93e9bb1$export$18ad168d3dbac899);
$parcel$export(module.exports, "migrateSecondaryExposures", () => $284dd888d93e9bb1$export$55fd683752d01e67);

var $1Vcia = parcelRequire("1Vcia");

var $iYJcE = parcelRequire("iYJcE");

var $25nEq = parcelRequire("25nEq");

var $ygbGG = parcelRequire("ygbGG");

var $kgfMl = parcelRequire("kgfMl");

var $g5oCJ = parcelRequire("g5oCJ");
var $284dd888d93e9bb1$var$_excluded = [
    "api",
    "disableCurrentPageLogging",
    "loggingIntervalMillis",
    "loggingBufferMaxSize",
    "localMode",
    "eventLoggingApi",
    "eventLoggingApiForRetries",
    "disableLocalStorage",
    "ignoreWindowUndefined",
    "disableAllLogging",
    "initTimeoutMs",
    "disableNetworkKeepalive",
    "overrideStableID",
    "disableErrorLogging",
    "disableAutoMetricsLogging"
];
function $284dd888d93e9bb1$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $284dd888d93e9bb1$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $284dd888d93e9bb1$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $284dd888d93e9bb1$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $284dd888d93e9bb1$export$d119b37e5f788b43 = function getOptionsWithDefaults(options) {
    return $284dd888d93e9bb1$var$_objectSpread({
        /**
     * If more federal PerimeterTypes are added in the future, this should be updated so
     * that isFedRamp() === true always returns the strictest perimeter.
     */ perimeter: (0, $ygbGG.isFedRamp)() ? (0, $g5oCJ.PerimeterType).FEDRAMP_MODERATE : (0, $g5oCJ.PerimeterType).COMMERCIAL
    }, options);
};
var $284dd888d93e9bb1$export$fa1c2bbf4100b8bc = function shallowEquals(objectA, objectB) {
    if (!objectA && !objectB) return true;
    if (!objectA || !objectB) return false;
    var aEntries = Object.entries(objectA);
    var bEntries = Object.entries(objectB);
    if (aEntries.length !== bEntries.length) return false;
    var ascendingKeyOrder = function ascendingKeyOrder(_ref, _ref2) {
        var _ref3 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_ref, 1), key1 = _ref3[0];
        var _ref4 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_ref2, 1), key2 = _ref4[0];
        return key1.localeCompare(key2);
    };
    aEntries.sort(ascendingKeyOrder);
    bEntries.sort(ascendingKeyOrder);
    for(var i = 0; i < aEntries.length; i++){
        var _aEntries$i = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(aEntries[i], 2), aValue = _aEntries$i[1];
        var _bEntries$i = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(bEntries[i], 2), bValue = _bEntries$i[1];
        if (aValue !== bValue) return false;
    }
    return true;
};
var $284dd888d93e9bb1$export$3dad1db244472f32 = function toStatsigUser(identifiers, customAttributes) {
    var user = {
        customIDs: identifiers,
        custom: customAttributes
    };
    if (identifiers.atlassianAccountId) user.userID = identifiers.atlassianAccountId;
    return user;
};
var $284dd888d93e9bb1$export$202946b690d26d22 = function migrateInitializationOptions(options) {
    var api = options.api, disableCurrentPageLogging = options.disableCurrentPageLogging, loggingIntervalMillis = options.loggingIntervalMillis, loggingBufferMaxSize = options.loggingBufferMaxSize, localMode = options.localMode, eventLoggingApi = options.eventLoggingApi, eventLoggingApiForRetries = options.eventLoggingApiForRetries, disableLocalStorage = options.disableLocalStorage, ignoreWindowUndefined = options.ignoreWindowUndefined, disableAllLogging = options.disableAllLogging, _initTimeoutMs = options.initTimeoutMs, _disableNetworkKeepalive = options.disableNetworkKeepalive, _overrideStableID = options.overrideStableID, _disableErrorLogging = options.disableErrorLogging, _disableAutoMetricsLogging = options.disableAutoMetricsLogging, rest = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(options, $284dd888d93e9bb1$var$_excluded);
    return $284dd888d93e9bb1$var$_objectSpread($284dd888d93e9bb1$var$_objectSpread({}, rest), {}, {
        networkConfig: {
            api: api,
            logEventUrl: eventLoggingApi ? eventLoggingApi + 'rgstr' : undefined,
            logEventFallbackUrls: eventLoggingApiForRetries ? [
                eventLoggingApiForRetries
            ] : undefined,
            preventAllNetworkTraffic: localMode || !ignoreWindowUndefined && typeof window === 'undefined'
        },
        includeCurrentPageUrlWithEvents: !disableCurrentPageLogging,
        loggingIntervalMs: loggingIntervalMillis,
        loggingBufferMaxSize: loggingBufferMaxSize,
        disableStorage: disableLocalStorage === undefined ? localMode : disableLocalStorage,
        disableLogging: disableAllLogging === undefined ? localMode : disableAllLogging
    });
};
var $284dd888d93e9bb1$var$evaluationReasonMappings = Object.entries((0, $kgfMl.EvaluationReason)).map(function(_ref5) {
    var _ref6 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_ref5, 2), key = _ref6[0], value = _ref6[1];
    return [
        key.toLowerCase(),
        value
    ];
});
var $284dd888d93e9bb1$export$18ad168d3dbac899 = function migrateEvaluationDetails(details) {
    var _evaluationReasonMapp, _evaluationReasonMapp2, _details$receivedAt;
    var reasonLower = details.reason.toLowerCase();
    return {
        reason: (_evaluationReasonMapp = (_evaluationReasonMapp2 = $284dd888d93e9bb1$var$evaluationReasonMappings.find(function(_ref7) {
            var _ref8 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_ref7, 1), key = _ref8[0];
            return reasonLower.includes(key);
        })) === null || _evaluationReasonMapp2 === void 0 ? void 0 : _evaluationReasonMapp2[1]) !== null && _evaluationReasonMapp !== void 0 ? _evaluationReasonMapp : (0, $kgfMl.EvaluationReason).Unknown,
        time: (_details$receivedAt = details.receivedAt) !== null && _details$receivedAt !== void 0 ? _details$receivedAt : Date.now()
    };
};
var $284dd888d93e9bb1$export$55fd683752d01e67 = function migrateSecondaryExposures(secondaryExposures) {
    return secondaryExposures.map(function(exposure) {
        if (typeof exposure === 'string') // This should ideally have gateValue and ruleID fields too, but it's not possible for us
        // to determine the correct values for these.
        return {
            gate: exposure
        };
        return exposure;
    });
};

});
parcelRegister("kgfMl", function(module, exports) {
$parcel$export(module.exports, "EvaluationReason", () => $ec018a9ac5ddfa0e$export$c62558b199e46828);
// Reference: https://github.com/statsig-io/js-lite/blob/main/src/StatsigStore.ts
var $ec018a9ac5ddfa0e$export$c62558b199e46828 = /*#__PURE__*/ function(EvaluationReason) {
    // Order is important since the logic for migrating from a new client reason to an old one
    // returns the first which is a substring of the new client reason
    EvaluationReason["Error"] = "Error";
    EvaluationReason["LocalOverride"] = "LocalOverride";
    EvaluationReason["Unrecognized"] = "Unrecognized";
    EvaluationReason["Uninitialized"] = "Uninitialized";
    EvaluationReason["NetworkNotModified"] = "NetworkNotModified";
    EvaluationReason["Network"] = "Network";
    EvaluationReason["InvalidBootstrap"] = "InvalidBootstrap";
    EvaluationReason["Bootstrap"] = "Bootstrap";
    EvaluationReason["Cache"] = "Cache";
    // For when we could not migrate the reason from the new client
    EvaluationReason["Unknown"] = "Unknown";
    return EvaluationReason;
}({}); // Reference: https://github.com/statsig-io/js-lite/blob/main/src/StatsigSDKOptions.ts

});

parcelRegister("g5oCJ", function(module, exports) {
$parcel$export(module.exports, "FeatureGateEnvironment", () => $bb6036bae4cfc158$export$479e7351a733299);
$parcel$export(module.exports, "PerimeterType", () => $bb6036bae4cfc158$export$c42b7bbc5e7ba555);
/**
 * The identifiers for the user. Options are restricted to the set that is currently supported.
 */ /**
 * Base client options. Does not include any options specific to providers
 * @interface BaseClientOptions
 * @property {FeatureGateEnvironment} environment - The environment for the client.
 * @property {string} targetApp - The target app for the client.
 * @property {AnalyticsWebClient} analyticsWebClient - The analytics web client.
 * @property {PerimeterType} perimeter - The perimeter for the client.
 */ /**
 * The options for the client.
 * @interface ClientOptions
 * @extends {BaseClientOptions}
 * @property {string} apiKey - The API key for the client.
 * @property {fetchTimeoutMs} fetchTimeoutMs - The timeout for the fetch request in milliseconds. Defaults to 5000.
 * @property {boolean} useGatewayURL - Whether to use the gateway URL. Defaults to false.
 */ /**
 * The custom attributes for the user.
 */ var $bb6036bae4cfc158$export$479e7351a733299 = /*#__PURE__*/ function(FeatureGateEnvironment) {
    FeatureGateEnvironment["Development"] = "development";
    FeatureGateEnvironment["Staging"] = "staging";
    FeatureGateEnvironment["Production"] = "production";
    return FeatureGateEnvironment;
}({});
var $bb6036bae4cfc158$export$c42b7bbc5e7ba555 = /*#__PURE__*/ function(PerimeterType) {
    PerimeterType["COMMERCIAL"] = "commercial";
    PerimeterType["FEDRAMP_MODERATE"] = "fedramp-moderate";
    return PerimeterType;
}({});
var $bb6036bae4cfc158$export$42f4885608027d0c = 'non_boolean'; // Type magic to get the JSDoc comments from the Client class methods to appear on the static
 // methods in FeatureGates where the property name and function type are identical

});



parcelRegister("knFmu", function(module, exports) {
$parcel$export(module.exports, "Layer", () => $ed660a3563e5c443$export$936d0764594b6eb3);

var $ekGgq = parcelRequire("ekGgq");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $3sxkV = parcelRequire("3sxkV");
var $ed660a3563e5c443$export$936d0764594b6eb3 = /*#__PURE__*/ function() {
    function Layer(name, layerValue, ruleID, evaluationDetails) {
        var logParameterFunction = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
        var secondaryExposures = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : [];
        var undelegatedSecondaryExposures = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : [];
        var allocatedExperimentName = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : '';
        var explicitParameters = arguments.length > 8 && arguments[8] !== undefined ? arguments[8] : [];
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, Layer);
        this._logParameterFunction = logParameterFunction;
        this._name = name;
        this._value = JSON.parse(JSON.stringify(layerValue !== null && layerValue !== void 0 ? layerValue : {}));
        this._ruleID = ruleID !== null && ruleID !== void 0 ? ruleID : '';
        this._evaluationDetails = evaluationDetails;
        this._secondaryExposures = secondaryExposures;
        this._undelegatedSecondaryExposures = undelegatedSecondaryExposures;
        this._allocatedExperimentName = allocatedExperimentName;
        this._explicitParameters = explicitParameters;
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(Layer, [
        {
            key: "get",
            value: function get(key, defaultValue, typeGuard) {
                var _this = this;
                var val = this._value[key];
                if (val == null) return defaultValue;
                var logAndReturn = function logAndReturn() {
                    _this._logLayerParameterExposure(key);
                    return val;
                };
                if (typeGuard) return typeGuard(val) ? logAndReturn() : defaultValue;
                if (defaultValue == null) return logAndReturn();
                if ((0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(val) === (0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(defaultValue) && Array.isArray(defaultValue) === Array.isArray(val)) return logAndReturn();
                return defaultValue;
            }
        },
        {
            key: "getValue",
            value: function getValue(key, defaultValue) {
                // eslint-disable-next-line eqeqeq
                if (defaultValue == undefined) defaultValue = null;
                var val = this._value[key];
                if (val != null) this._logLayerParameterExposure(key);
                return val !== null && val !== void 0 ? val : defaultValue;
            }
        },
        {
            key: "_logLayerParameterExposure",
            value: function _logLayerParameterExposure(parameterName) {
                var _this$_logParameterFu;
                (_this$_logParameterFu = this._logParameterFunction) === null || _this$_logParameterFu === void 0 || _this$_logParameterFu.call(this, this, parameterName);
            }
        }
    ], [
        {
            key: "fromLayer",
            value: function fromLayer(layer) {
                var _layer$__evaluation$s, _layer$__evaluation, _layer$__evaluation$u, _layer$__evaluation2, _layer$__evaluation3, _layer$__evaluation4;
                var value = new Layer(layer.name, layer.__value, layer.ruleID, (0, $3sxkV.migrateEvaluationDetails)(layer.details), function(_layer, parameterName) {
                    return layer.get(parameterName);
                }, (0, $3sxkV.migrateSecondaryExposures)((_layer$__evaluation$s = (_layer$__evaluation = layer.__evaluation) === null || _layer$__evaluation === void 0 ? void 0 : _layer$__evaluation.secondary_exposures) !== null && _layer$__evaluation$s !== void 0 ? _layer$__evaluation$s : []), (0, $3sxkV.migrateSecondaryExposures)((_layer$__evaluation$u = (_layer$__evaluation2 = layer.__evaluation) === null || _layer$__evaluation2 === void 0 ? void 0 : _layer$__evaluation2.undelegated_secondary_exposures) !== null && _layer$__evaluation$u !== void 0 ? _layer$__evaluation$u : []), (_layer$__evaluation3 = layer.__evaluation) === null || _layer$__evaluation3 === void 0 ? void 0 : _layer$__evaluation3.allocated_experiment_name, (_layer$__evaluation4 = layer.__evaluation) === null || _layer$__evaluation4 === void 0 ? void 0 : _layer$__evaluation4.explicit_parameters);
                return value;
            }
        }
    ]);
}();

});

parcelRegister("lSU5S", function(module, exports) {
$parcel$export(module.exports, "default", () => $feea2733aaae4efb$export$2e2bcd8739ae039);

var $25nEq = parcelRequire("25nEq");

var $fL8KA = parcelRequire("fL8KA");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $6HG4S = parcelRequire("6HG4S");

var $g5oCJ = parcelRequire("g5oCJ");

var $89UMm = parcelRequire("89UMm");

var $3OdZR = parcelRequire("3OdZR");
function $feea2733aaae4efb$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $feea2733aaae4efb$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $feea2733aaae4efb$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $feea2733aaae4efb$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $feea2733aaae4efb$var$DEFAULT_REQUEST_TIMEOUT_MS = 5000;
var $feea2733aaae4efb$export$250a58ecde616daa = 'https://api.atlassian.com/flags';
var $feea2733aaae4efb$export$942ba04389b0d5a2 = 'https://api.stg.atlassian.com/flags';
var $feea2733aaae4efb$export$f058dbf75c3bc647 = 'https://api.dev.atlassian.com/flags';
var $feea2733aaae4efb$export$1a401a0da8da3565 = 'https://api.stg.atlassian-us-gov-mod.com/flags';
var $feea2733aaae4efb$export$18c93900db9358a4 = 'https://api.atlassian-us-gov-mod.com/flags';
var $feea2733aaae4efb$export$4e8a0415edbfa1f7 = 'https://atlassian-statsig-proxy-archetype.atl-paas.%s.atl-ic.net';
var $feea2733aaae4efb$export$cb3cd156f70d7e94 = 'oasis-stg.com/flags';
var $feea2733aaae4efb$export$921fbc6cdfd4eee0 = 'atlassian-isolated.net/flags';
var $feea2733aaae4efb$export$450bd8fb2a6d7ace = '/gateway/api/flags';
var $feea2733aaae4efb$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function Fetcher() {
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, Fetcher);
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(Fetcher, null, [
        {
            key: "fetchClientSdk",
            value: function() {
                var _fetchClientSdk = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee(fetcherOptions) {
                    var targetApp, url;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee$(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                targetApp = fetcherOptions.targetApp;
                                url = "/api/v2/frontend/clientSdkKey/".concat(targetApp);
                                _context.prev = 2;
                                _context.next = 5;
                                return this.fetchRequest(url, 'GET', fetcherOptions);
                            case 5:
                                return _context.abrupt("return", _context.sent);
                            case 8:
                                _context.prev = 8;
                                _context.t0 = _context["catch"](2);
                                if (!(_context.t0 instanceof Error)) {
                                    _context.next = 12;
                                    break;
                                }
                                throw _context.t0;
                            case 12:
                                throw Error('Failed to retrieve client sdk key');
                            case 13:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee, this, [
                        [
                            2,
                            8
                        ]
                    ]);
                }));
                function fetchClientSdk(_x) {
                    return _fetchClientSdk.apply(this, arguments);
                }
                return fetchClientSdk;
            }()
        },
        {
            key: "fetchExperimentValues",
            value: function() {
                var _fetchExperimentValues = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee2(fetcherOptions, identifiers, customAttributes) {
                    var requestBody;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee2$(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                requestBody = {
                                    identifiers: identifiers,
                                    customAttributes: customAttributes,
                                    targetApp: fetcherOptions.targetApp
                                };
                                _context2.prev = 1;
                                _context2.next = 4;
                                return this.fetchRequest('/api/v2/frontend/experimentValues', 'POST', fetcherOptions, requestBody);
                            case 4:
                                return _context2.abrupt("return", _context2.sent);
                            case 7:
                                _context2.prev = 7;
                                _context2.t0 = _context2["catch"](1);
                                if (!(_context2.t0 instanceof Error)) {
                                    _context2.next = 11;
                                    break;
                                }
                                throw _context2.t0;
                            case 11:
                                throw Error('Failed to retrieve experiment values');
                            case 12:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2, this, [
                        [
                            1,
                            7
                        ]
                    ]);
                }));
                function fetchExperimentValues(_x2, _x3, _x4) {
                    return _fetchExperimentValues.apply(this, arguments);
                }
                return fetchExperimentValues;
            }()
        },
        {
            key: "handleResponseError",
            value: function() {
                var _handleResponseError = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee3(response) {
                    var body;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee3$(_context3) {
                        while(true)switch(_context3.prev = _context3.next){
                            case 0:
                                if (response.ok) {
                                    _context3.next = 5;
                                    break;
                                }
                                _context3.next = 3;
                                return response.text();
                            case 3:
                                body = _context3.sent;
                                throw new (0, $3OdZR.ResponseError)("Non 2xx response status received, status: ".concat(response.status, ", body: ").concat(JSON.stringify(body)));
                            case 5:
                                if (!(response.status === 204)) {
                                    _context3.next = 7;
                                    break;
                                }
                                throw new (0, $3OdZR.ResponseError)('Unexpected 204 response');
                            case 7:
                            case "end":
                                return _context3.stop();
                        }
                    }, _callee3);
                }));
                function handleResponseError(_x5) {
                    return _handleResponseError.apply(this, arguments);
                }
                return handleResponseError;
            }()
        },
        {
            key: "extractResponseBody",
            value: function() {
                var _extractResponseBody = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee4(response) {
                    var value;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee4$(_context4) {
                        while(true)switch(_context4.prev = _context4.next){
                            case 0:
                                _context4.next = 2;
                                return response.text();
                            case 2:
                                value = _context4.sent;
                                return _context4.abrupt("return", JSON.parse(value));
                            case 4:
                            case "end":
                                return _context4.stop();
                        }
                    }, _callee4);
                }));
                function extractResponseBody(_x6) {
                    return _extractResponseBody.apply(this, arguments);
                }
                return extractResponseBody;
            }()
        },
        {
            key: "getBaseUrl",
            value: function getBaseUrl(serviceEnv) {
                var useGatewayUrl = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
                var perimeter = arguments.length > 2 ? arguments[2] : undefined;
                var isolationContextId = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
                if (useGatewayUrl) return $feea2733aaae4efb$export$450bd8fb2a6d7ace;
                if (perimeter === (0, $g5oCJ.PerimeterType).FEDRAMP_MODERATE) switch(serviceEnv){
                    case (0, $g5oCJ.FeatureGateEnvironment).Production:
                        return $feea2733aaae4efb$export$18c93900db9358a4;
                    case (0, $g5oCJ.FeatureGateEnvironment).Staging:
                        return $feea2733aaae4efb$export$1a401a0da8da3565;
                    default:
                        throw new Error("Invalid environment \"".concat(serviceEnv, "\" for \"").concat(perimeter, "\" perimeter"));
                }
                else if (perimeter === (0, $g5oCJ.PerimeterType).COMMERCIAL) switch(serviceEnv){
                    case (0, $g5oCJ.FeatureGateEnvironment).Development:
                        return $feea2733aaae4efb$export$f058dbf75c3bc647;
                    case (0, $g5oCJ.FeatureGateEnvironment).Staging:
                        var apiUrl = this.getApiUrl(isolationContextId);
                        if (apiUrl !== null) return apiUrl;
                        return $feea2733aaae4efb$export$942ba04389b0d5a2;
                    default:
                        var prodApiUrl = this.getApiUrl(isolationContextId);
                        if (prodApiUrl !== null) return prodApiUrl;
                        return $feea2733aaae4efb$export$250a58ecde616daa;
                }
                else throw new Error("Invalid perimeter \"".concat(perimeter, "\""));
            }
        },
        {
            key: "fetchRequest",
            value: function() {
                var _fetchRequest = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee5(path, method, fetcherOptions, body) {
                    var baseUrl, fetchTimeout, abortSignal, abortController, response;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee5$(_context5) {
                        while(true)switch(_context5.prev = _context5.next){
                            case 0:
                                baseUrl = Fetcher.getBaseUrl(fetcherOptions.environment, fetcherOptions.useGatewayURL, fetcherOptions.perimeter, fetcherOptions.isolationContextId);
                                fetchTimeout = fetcherOptions.fetchTimeoutMs || $feea2733aaae4efb$var$DEFAULT_REQUEST_TIMEOUT_MS;
                                if (AbortSignal.timeout) abortSignal = AbortSignal.timeout(fetchTimeout);
                                else if (AbortController) {
                                    abortController = new AbortController();
                                    abortSignal = abortController.signal;
                                    setTimeout(function() {
                                        return abortController.abort();
                                    }, fetchTimeout);
                                }
                                _context5.next = 5;
                                return fetch("".concat(baseUrl).concat(path), $feea2733aaae4efb$var$_objectSpread({
                                    method: method,
                                    headers: {
                                        'Content-Type': 'application/json',
                                        'X-Client-Name': 'feature-gate-js-client',
                                        'X-Client-Version': (0, $89UMm.CLIENT_VERSION),
                                        'X-API-KEY': fetcherOptions.apiKey
                                    },
                                    signal: abortSignal
                                }, body && {
                                    body: JSON.stringify(body)
                                }));
                            case 5:
                                response = _context5.sent;
                                _context5.next = 8;
                                return this.handleResponseError(response);
                            case 8:
                                _context5.next = 10;
                                return this.extractResponseBody(response);
                            case 10:
                                return _context5.abrupt("return", _context5.sent);
                            case 11:
                            case "end":
                                return _context5.stop();
                        }
                    }, _callee5, this);
                }));
                function fetchRequest(_x7, _x8, _x9, _x0) {
                    return _fetchRequest.apply(this, arguments);
                }
                return fetchRequest;
            }()
        },
        {
            key: "getApiUrl",
            value: function getApiUrl(isolationContextId) {
                var window1 = this.getWindowLocation();
                if (window1 === undefined) {
                    //this is needed when this SDK is used for SSR or plugin use cases where secret keys not available to use backend SDKs
                    if (!isolationContextId) return null;
                    return $feea2733aaae4efb$export$4e8a0415edbfa1f7.replace('%s', isolationContextId);
                }
                var protocol = window1.protocol, hostname = window1.hostname;
                // Match last subdomain fragment before oasis-stg.com
                var oasisMatch = hostname.match(/([^.]+)\.oasis-stg\.com$/);
                if (oasisMatch) return "".concat(protocol, "//api.").concat(oasisMatch[1], ".").concat($feea2733aaae4efb$export$cb3cd156f70d7e94);
                // Match last subdomain fragment before atlassian-isolated.net
                var isolatedMatch = hostname.match(/([^.]+)\.atlassian-isolated\.net$/);
                if (isolatedMatch) return "".concat(protocol, "//api.").concat(isolatedMatch[1], ".").concat($feea2733aaae4efb$export$921fbc6cdfd4eee0);
                return null;
            }
        },
        {
            key: "getWindowLocation",
            value: function getWindowLocation() {
                if (typeof window !== 'undefined' && window.location) return window.location;
                return undefined;
            }
        }
    ]);
}();

});
parcelRegister("89UMm", function(module, exports) {
$parcel$export(module.exports, "CLIENT_VERSION", () => $5f0b3520a40f2cb0$export$a59f8d67326bd1cb);
/// <reference types="node" />
var $5f0b3520a40f2cb0$export$a59f8d67326bd1cb = "0.0.0-development";

});

parcelRegister("3OdZR", function(module, exports) {
$parcel$export(module.exports, "ResponseError", () => $2c60e611fa966a23$export$286baf652d0b1206);

var $arMYe = parcelRequire("arMYe");

var $9P61R = parcelRequire("9P61R");

var $kIXpt = parcelRequire("kIXpt");

var $cYPzS = parcelRequire("cYPzS");

var $eyuDe = parcelRequire("eyuDe");

var $c7s0H = parcelRequire("c7s0H");
function $2c60e611fa966a23$var$_callSuper(t, o, e) {
    return o = (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(o), (0, (/*@__PURE__*/$parcel$interopDefault($kIXpt)))(t, $2c60e611fa966a23$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(t).constructor) : o.apply(t, e));
}
function $2c60e611fa966a23$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($2c60e611fa966a23$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $2c60e611fa966a23$export$286baf652d0b1206 = /*#__PURE__*/ function(_Error) {
    function ResponseError(message) {
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, ResponseError);
        return $2c60e611fa966a23$var$_callSuper(this, ResponseError, [
            message
        ]);
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($eyuDe)))(ResponseError, _Error);
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(ResponseError);
}(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($c7s0H)))(Error));

});


parcelRegister("aZyWe", function(module, exports) {
$parcel$export(module.exports, "NoFetchDataAdapter", () => $800ab3e485f9d56f$export$55fffef3474104af);

var $fL8KA = parcelRequire("fL8KA");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $kIXpt = parcelRequire("kIXpt");

var $cYPzS = parcelRequire("cYPzS");

var $lwlXp = parcelRequire("lwlXp");

var $eyuDe = parcelRequire("eyuDe");

var $25nEq = parcelRequire("25nEq");

var $6HG4S = parcelRequire("6HG4S");

var $iFR7a = parcelRequire("iFR7a");
function $800ab3e485f9d56f$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $800ab3e485f9d56f$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $800ab3e485f9d56f$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $800ab3e485f9d56f$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $800ab3e485f9d56f$var$_callSuper(t, o, e) {
    return o = (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(o), (0, (/*@__PURE__*/$parcel$interopDefault($kIXpt)))(t, $800ab3e485f9d56f$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(t).constructor) : o.apply(t, e));
}
function $800ab3e485f9d56f$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($800ab3e485f9d56f$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $800ab3e485f9d56f$var$_superPropGet(t, o, e, r) {
    var p = (0, (/*@__PURE__*/$parcel$interopDefault($lwlXp)))((0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(1 & r ? t.prototype : t), o, e);
    return 2 & r && "function" == typeof p ? function(t) {
        return p.apply(e, t);
    } : p;
}
var $800ab3e485f9d56f$export$55fffef3474104af = /*#__PURE__*/ function(_DataAdapterCore) {
    function NoFetchDataAdapter() {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, NoFetchDataAdapter);
        _this = $800ab3e485f9d56f$var$_callSuper(this, NoFetchDataAdapter, [
            'NoFetchDataAdapter',
            'nofetch'
        ]);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "bootstrapResult", null);
        return _this;
    }
    /**
   * Make sure to call this **before** calling `initializeAsync` or `updateUserAsync` but
   * after the Statsig client has been created!
   */ (0, (/*@__PURE__*/$parcel$interopDefault($eyuDe)))(NoFetchDataAdapter, _DataAdapterCore);
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(NoFetchDataAdapter, [
        {
            key: "setBootstrapData",
            value: function setBootstrapData(data) {
                this.bootstrapResult = data ? {
                    source: 'Bootstrap',
                    data: JSON.stringify(data),
                    receivedAt: Date.now(),
                    stableID: (0, $iFR7a.StableID).get(this._getSdkKey()),
                    fullUserHash: null
                } : null;
            }
        },
        {
            key: "prefetchData",
            value: function() {
                var _prefetchData = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee(_user, _options) {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee$(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee);
                }));
                function prefetchData(_x, _x2) {
                    return _prefetchData.apply(this, arguments);
                }
                return prefetchData;
            }()
        },
        {
            key: "getDataAsync",
            value: function() {
                var _getDataAsync = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee2(_current, user, _options) {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee2$(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                return _context2.abrupt("return", this.bootstrapResult && $800ab3e485f9d56f$var$_objectSpread($800ab3e485f9d56f$var$_objectSpread({}, this.bootstrapResult), {}, {
                                    fullUserHash: (0, $iFR7a._getFullUserHash)(user)
                                }));
                            case 1:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2, this);
                }));
                function getDataAsync(_x3, _x4, _x5) {
                    return _getDataAsync.apply(this, arguments);
                }
                return getDataAsync;
            }()
        },
        {
            key: "getDataSync",
            value: function getDataSync(user) {
                return this.bootstrapResult && $800ab3e485f9d56f$var$_objectSpread($800ab3e485f9d56f$var$_objectSpread({}, this.bootstrapResult), {}, {
                    fullUserHash: (0, $iFR7a._getFullUserHash)(user)
                });
            }
        },
        {
            key: "_fetchFromNetwork",
            value: function() {
                var _fetchFromNetwork2 = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee3(_current, _user, _options) {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee3$(_context3) {
                        while(true)switch(_context3.prev = _context3.next){
                            case 0:
                                return _context3.abrupt("return", null);
                            case 1:
                            case "end":
                                return _context3.stop();
                        }
                    }, _callee3);
                }));
                function _fetchFromNetwork(_x6, _x7, _x8) {
                    return _fetchFromNetwork2.apply(this, arguments);
                }
                return _fetchFromNetwork;
            }()
        },
        {
            key: "_getCacheKey",
            value: function _getCacheKey(user) {
                // Same logic as default data adapter
                // https://github.com/statsig-io/js-client-monorepo/blob/main/packages/js-client/src/StatsigEvaluationsDataAdapter.ts
                var key = (0, $iFR7a._getStorageKey)(this._getSdkKey(), user);
                return "".concat((0, $iFR7a.DataAdapterCachePrefix), ".").concat(this._cacheSuffix, ".").concat(key);
            }
        },
        {
            key: "_isCachedResultValidFor204",
            value: function _isCachedResultValidFor204(_result, _user) {
                return false;
            }
        },
        {
            key: "setDataLegacy",
            value: function setDataLegacy(data, user) {
                $800ab3e485f9d56f$var$_superPropGet(NoFetchDataAdapter, "setData", this, 3)([
                    data,
                    user
                ]);
            }
        },
        {
            key: "toJSON",
            value: function toJSON() {
                var result = $800ab3e485f9d56f$var$_objectSpread({}, this);
                delete result._options;
                delete result._inMemoryCache;
                delete result.bootstrapResult;
                return result;
            }
        }
    ]);
}((0, $iFR7a.DataAdapterCore));

});

parcelRegister("9A4g1", function(module, exports) {
$parcel$export(module.exports, "LOCAL_STORAGE_KEY", () => $6f9ac74d14e5e0d5$export$d8474cff104280f3);
$parcel$export(module.exports, "PersistentOverrideAdapter", () => $6f9ac74d14e5e0d5$export$bcb28fbac1def494);

var $25nEq = parcelRequire("25nEq");

var $iYJcE = parcelRequire("iYJcE");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $dtn6l = parcelRequire("dtn6l");
function $6f9ac74d14e5e0d5$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $6f9ac74d14e5e0d5$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $6f9ac74d14e5e0d5$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $6f9ac74d14e5e0d5$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $6f9ac74d14e5e0d5$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $6f9ac74d14e5e0d5$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $6f9ac74d14e5e0d5$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $6f9ac74d14e5e0d5$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $6f9ac74d14e5e0d5$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $6f9ac74d14e5e0d5$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
var $6f9ac74d14e5e0d5$var$LOCAL_OVERRIDE_REASON = 'LocalOverride:Recognized';
var $6f9ac74d14e5e0d5$export$d8474cff104280f3 = 'STATSIG_OVERRIDES';
var $6f9ac74d14e5e0d5$var$LEGACY_LOCAL_STORAGE_KEY = 'STATSIG_JS_LITE_LOCAL_OVERRIDES';
var $6f9ac74d14e5e0d5$var$makeEmptyStore = function makeEmptyStore() {
    return {
        gates: {},
        configs: {},
        layers: {}
    };
};
var $6f9ac74d14e5e0d5$var$djb2MapKey = function djb2MapKey(hash, kind) {
    return kind + ':' + hash;
};
var $6f9ac74d14e5e0d5$export$bcb28fbac1def494 = /*#__PURE__*/ function() {
    function PersistentOverrideAdapter(localStorageKey) {
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, PersistentOverrideAdapter);
        this._overrides = $6f9ac74d14e5e0d5$var$makeEmptyStore();
        this._djb2Map = new Map();
        this._localStorageKey = localStorageKey;
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(PersistentOverrideAdapter, [
        {
            key: "parseStoredOverrides",
            value: function parseStoredOverrides(localStorageKey) {
                try {
                    var json = window.localStorage.getItem(localStorageKey);
                    if (!json) return $6f9ac74d14e5e0d5$var$makeEmptyStore();
                    return JSON.parse(json);
                } catch (_unused) {
                    return $6f9ac74d14e5e0d5$var$makeEmptyStore();
                }
            }
        },
        {
            key: "mergeOverrides",
            value: function mergeOverrides() {
                var merged = $6f9ac74d14e5e0d5$var$makeEmptyStore();
                for(var _len = arguments.length, allOverrides = new Array(_len), _key = 0; _key < _len; _key++)allOverrides[_key] = arguments[_key];
                for(var _i = 0, _allOverrides = allOverrides; _i < _allOverrides.length; _i++){
                    var overrides = _allOverrides[_i];
                    for(var _i2 = 0, _Object$entries = Object.entries((_overrides$gates = overrides.gates) !== null && _overrides$gates !== void 0 ? _overrides$gates : {}); _i2 < _Object$entries.length; _i2++){
                        var _overrides$gates;
                        var _Object$entries$_i = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_Object$entries[_i2], 2), name = _Object$entries$_i[0], value = _Object$entries$_i[1];
                        merged.gates[name] = value;
                    }
                    for(var _i3 = 0, _Object$entries2 = Object.entries((_overrides$configs = overrides.configs) !== null && _overrides$configs !== void 0 ? _overrides$configs : {}); _i3 < _Object$entries2.length; _i3++){
                        var _overrides$configs;
                        var _Object$entries2$_i = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_Object$entries2[_i3], 2), _name = _Object$entries2$_i[0], _value = _Object$entries2$_i[1];
                        merged.configs[_name] = _value;
                    }
                    for(var _i4 = 0, _Object$entries3 = Object.entries((_overrides$layers = overrides.layers) !== null && _overrides$layers !== void 0 ? _overrides$layers : {}); _i4 < _Object$entries3.length; _i4++){
                        var _overrides$layers;
                        var _Object$entries3$_i = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_Object$entries3[_i4], 2), _name2 = _Object$entries3$_i[0], _value2 = _Object$entries3$_i[1];
                        merged.layers[_name2] = _value2;
                    }
                }
                return merged;
            }
        },
        {
            key: "initFromStoredOverrides",
            value: function initFromStoredOverrides() {
                var storedOverrides = this.mergeOverrides(this._overrides, this.parseStoredOverrides($6f9ac74d14e5e0d5$var$LEGACY_LOCAL_STORAGE_KEY), this.parseStoredOverrides(this._localStorageKey));
                // Clear data from legacy local storage key now we've read from it.
                // This prevents things being stuck in there that are always read but never written to.
                try {
                    window.localStorage.removeItem($6f9ac74d14e5e0d5$var$LEGACY_LOCAL_STORAGE_KEY);
                } catch (_unused2) {
                // ignored - window is not defined in non-browser environments, and we don't save things there
                // (things like SSR, etc)
                }
                // In version 4.24.0 we introduced hashes in this override adapter, but had a bug which would cause
                // multiple hashes to continue being created. This code here removes these hashes since we've moved
                // to using a more reliable and easier to maintain map in `_djb2Map`.
                for(var _i5 = 0, _Object$values = Object.values(storedOverrides); _i5 < _Object$values.length; _i5++){
                    var container = _Object$values[_i5];
                    var allKeys = new Set(Object.keys(container));
                    var _iterator = $6f9ac74d14e5e0d5$var$_createForOfIteratorHelper(allKeys), _step;
                    try {
                        for(_iterator.s(); !(_step = _iterator.n()).done;){
                            var name = _step.value;
                            var hash = (0, $dtn6l._DJB2)(name);
                            if (allKeys.has(hash)) delete container[hash];
                        }
                    } catch (err) {
                        _iterator.e(err);
                    } finally{
                        _iterator.f();
                    }
                }
                this.applyOverrides(storedOverrides);
            }
        },
        {
            key: "saveOverrides",
            value: function saveOverrides() {
                try {
                    window.localStorage.setItem(this._localStorageKey, JSON.stringify(this._overrides));
                } catch (_unused3) {
                // ignored - window is not defined in non-browser environments, and we don't save things there
                // (things like SSR, etc)
                }
            }
        },
        {
            key: "getOverrides",
            value: function getOverrides() {
                return this.mergeOverrides(this._overrides);
            }
        },
        {
            key: "applyOverrides",
            value: function applyOverrides(overrides) {
                var newOverrides = $6f9ac74d14e5e0d5$var$_objectSpread($6f9ac74d14e5e0d5$var$_objectSpread({}, $6f9ac74d14e5e0d5$var$makeEmptyStore()), overrides);
                this._djb2Map.clear();
                for(var _i6 = 0, _Object$entries4 = Object.entries(newOverrides); _i6 < _Object$entries4.length; _i6++){
                    var _Object$entries4$_i = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_Object$entries4[_i6], 2), containerName = _Object$entries4$_i[0], container = _Object$entries4$_i[1];
                    for(var _i7 = 0, _Object$entries5 = Object.entries(container); _i7 < _Object$entries5.length; _i7++){
                        var _Object$entries5$_i = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_Object$entries5[_i7], 2), name = _Object$entries5$_i[0], value = _Object$entries5$_i[1];
                        this._djb2Map.set($6f9ac74d14e5e0d5$var$djb2MapKey((0, $dtn6l._DJB2)(name), containerName), value);
                    }
                }
                this._overrides = newOverrides;
            }
        },
        {
            key: "setOverrides",
            value: function setOverrides(overrides) {
                this.applyOverrides(overrides);
                this.saveOverrides();
            }
        },
        {
            key: "overrideGate",
            value: function overrideGate(name, value) {
                this._overrides.gates[name] = value;
                this._djb2Map.set($6f9ac74d14e5e0d5$var$djb2MapKey((0, $dtn6l._DJB2)(name), 'gates'), value);
                this.saveOverrides();
            }
        },
        {
            key: "removeGateOverride",
            value: function removeGateOverride(name) {
                delete this._overrides.gates[name];
                this._djb2Map.delete($6f9ac74d14e5e0d5$var$djb2MapKey((0, $dtn6l._DJB2)(name), 'gates'));
                this.saveOverrides();
            }
        },
        {
            key: "getGateOverride",
            value: function getGateOverride(current, _user) {
                var _this$_overrides$gate;
                var overridden = (_this$_overrides$gate = this._overrides.gates[current.name]) !== null && _this$_overrides$gate !== void 0 ? _this$_overrides$gate : this._djb2Map.get($6f9ac74d14e5e0d5$var$djb2MapKey(current.name, 'gates'));
                if (overridden == null) return null;
                return $6f9ac74d14e5e0d5$var$_objectSpread($6f9ac74d14e5e0d5$var$_objectSpread({}, current), {}, {
                    value: overridden,
                    details: $6f9ac74d14e5e0d5$var$_objectSpread($6f9ac74d14e5e0d5$var$_objectSpread({}, current.details), {}, {
                        reason: $6f9ac74d14e5e0d5$var$LOCAL_OVERRIDE_REASON
                    })
                });
            }
        },
        {
            key: "overrideDynamicConfig",
            value: function overrideDynamicConfig(name, value) {
                this._overrides.configs[name] = value;
                this._djb2Map.set($6f9ac74d14e5e0d5$var$djb2MapKey((0, $dtn6l._DJB2)(name), 'configs'), value);
                this.saveOverrides();
            }
        },
        {
            key: "removeDynamicConfigOverride",
            value: function removeDynamicConfigOverride(name) {
                delete this._overrides.configs[name];
                this._djb2Map.delete($6f9ac74d14e5e0d5$var$djb2MapKey((0, $dtn6l._DJB2)(name), 'configs'));
                this.saveOverrides();
            }
        },
        {
            key: "getDynamicConfigOverride",
            value: function getDynamicConfigOverride(current, _user) {
                return this._getConfigOverride(current, this._overrides.configs);
            }
        },
        {
            key: "overrideExperiment",
            value: function overrideExperiment(name, value) {
                this._overrides.configs[name] = value;
                this._djb2Map.set($6f9ac74d14e5e0d5$var$djb2MapKey((0, $dtn6l._DJB2)(name), 'configs'), value);
                this.saveOverrides();
            }
        },
        {
            key: "removeExperimentOverride",
            value: function removeExperimentOverride(name) {
                delete this._overrides.configs[name];
                this._djb2Map.delete($6f9ac74d14e5e0d5$var$djb2MapKey((0, $dtn6l._DJB2)(name), 'configs'));
                this.saveOverrides();
            }
        },
        {
            key: "getExperimentOverride",
            value: function getExperimentOverride(current, _user) {
                return this._getConfigOverride(current, this._overrides.configs);
            }
        },
        {
            key: "overrideLayer",
            value: function overrideLayer(name, value) {
                this._overrides.layers[name] = value;
                this._djb2Map.set($6f9ac74d14e5e0d5$var$djb2MapKey((0, $dtn6l._DJB2)(name), 'layers'), value);
                this.saveOverrides();
            }
        },
        {
            key: "removeLayerOverride",
            value: function removeLayerOverride(name) {
                delete this._overrides.layers[name];
                this._djb2Map.delete($6f9ac74d14e5e0d5$var$djb2MapKey((0, $dtn6l._DJB2)(name), 'layers'));
                this.saveOverrides();
            }
        },
        {
            key: "removeAllOverrides",
            value: function removeAllOverrides() {
                this._overrides = $6f9ac74d14e5e0d5$var$makeEmptyStore();
                try {
                    window.localStorage.removeItem(this._localStorageKey);
                } catch (_unused4) {
                // ignored - window is not defined in non-browser environments, and we don't save things there
                // (things like SSR, etc)
                }
            }
        },
        {
            key: "getLayerOverride",
            value: function getLayerOverride(current, _user) {
                var _this$_overrides$laye;
                var overridden = (_this$_overrides$laye = this._overrides.layers[current.name]) !== null && _this$_overrides$laye !== void 0 ? _this$_overrides$laye : this._djb2Map.get($6f9ac74d14e5e0d5$var$djb2MapKey(current.name, 'layers'));
                if (overridden == null) return null;
                return $6f9ac74d14e5e0d5$var$_objectSpread($6f9ac74d14e5e0d5$var$_objectSpread({}, current), {}, {
                    __value: overridden,
                    get: (0, $dtn6l._makeTypedGet)(current.name, overridden),
                    details: $6f9ac74d14e5e0d5$var$_objectSpread($6f9ac74d14e5e0d5$var$_objectSpread({}, current.details), {}, {
                        reason: $6f9ac74d14e5e0d5$var$LOCAL_OVERRIDE_REASON
                    })
                });
            }
        },
        {
            key: "_getConfigOverride",
            value: function _getConfigOverride(current, lookup) {
                var _lookup$current$name;
                var overridden = (_lookup$current$name = lookup[current.name]) !== null && _lookup$current$name !== void 0 ? _lookup$current$name : this._djb2Map.get($6f9ac74d14e5e0d5$var$djb2MapKey(current.name, 'configs'));
                if (overridden == null) return null;
                return $6f9ac74d14e5e0d5$var$_objectSpread($6f9ac74d14e5e0d5$var$_objectSpread({}, current), {}, {
                    value: overridden,
                    get: (0, $dtn6l._makeTypedGet)(current.name, overridden),
                    details: $6f9ac74d14e5e0d5$var$_objectSpread($6f9ac74d14e5e0d5$var$_objectSpread({}, current.details), {}, {
                        reason: $6f9ac74d14e5e0d5$var$LOCAL_OVERRIDE_REASON
                    })
                });
            }
        }
    ]);
}();

});



parcelRegister("gP3up", function(module, exports) {
$parcel$export(module.exports, "debug", () => $c3f41dae1e199dfc$export$1c9f709888824e05);
var $c3f41dae1e199dfc$var$_process, $c3f41dae1e199dfc$var$_process2;
// We can't rely on NODE_ENV === 'test' if its value is already configured by the consumer to some other value, so better to use JEST_WORKER_ID
// https://jestjs.io/docs/environment-variables#jest_worker_id
var $c3f41dae1e199dfc$var$TESTS_MODE = (globalThis === null || globalThis === void 0 || ($c3f41dae1e199dfc$var$_process = globalThis.process) === null || $c3f41dae1e199dfc$var$_process === void 0 || ($c3f41dae1e199dfc$var$_process = $c3f41dae1e199dfc$var$_process.env) === null || $c3f41dae1e199dfc$var$_process === void 0 ? void 0 : $c3f41dae1e199dfc$var$_process.JEST_WORKER_ID) !== undefined;
var $c3f41dae1e199dfc$var$DEBUG_MODE = !$c3f41dae1e199dfc$var$TESTS_MODE && (globalThis === null || globalThis === void 0 || ($c3f41dae1e199dfc$var$_process2 = globalThis.process) === null || $c3f41dae1e199dfc$var$_process2 === void 0 || ($c3f41dae1e199dfc$var$_process2 = $c3f41dae1e199dfc$var$_process2.env) === null || $c3f41dae1e199dfc$var$_process2 === void 0 ? void 0 : $c3f41dae1e199dfc$var$_process2.NODE_ENV) !== 'production';
var $c3f41dae1e199dfc$export$1c9f709888824e05 = function debug() {
    var _console;
    if (!$c3f41dae1e199dfc$var$DEBUG_MODE) return;
    // eslint-disable-next-line no-console
    (_console = console).debug.apply(_console, arguments);
};

});




parcelRegister("7BgMu", function(module, exports) {
$parcel$export(module.exports, "isValidBrandHex", () => $5889017aa52743df$export$53031ac1ecb71f44);
$parcel$export(module.exports, "rgbToHex", () => $5889017aa52743df$export$34d09c4a771c46ef);
$parcel$export(module.exports, "hexToRgbA", () => $5889017aa52743df$export$b36dbdb4f463f05c);
$parcel$export(module.exports, "hexToRgb", () => $5889017aa52743df$export$5a544e13ad4e1fa5);
$parcel$export(module.exports, "hexToHSL", () => $5889017aa52743df$export$47ea145a83f50dc0);
$parcel$export(module.exports, "HSLToRGB", () => $5889017aa52743df$export$1ff93e992dd58bec);
$parcel$export(module.exports, "relativeLuminanceW3C", () => $5889017aa52743df$export$e770b01b744f3745);
$parcel$export(module.exports, "getContrastRatio", () => $5889017aa52743df$export$d061e26956a60b0a);
$parcel$export(module.exports, "deltaE", () => $5889017aa52743df$export$e8ddad763b4bebf9);
// valid hex color with 6 digits
var $5889017aa52743df$export$53031ac1ecb71f44 = function isValidBrandHex(hex) {
    return /^#[0-9A-F]{6}$/i.test(hex);
};
// valid hex color with 4, 6 or 8 digits
var $5889017aa52743df$var$isValidHex = function isValidHex(hex) {
    return /^#([A-Fa-f0-9]{3,4}){1,2}$/.test(hex);
};
function $5889017aa52743df$export$34d09c4a771c46ef(r, g, b) {
    return '#' + (16777216 + (r << 16) + (g << 8) + b).toString(16).slice(1);
}
function $5889017aa52743df$export$1212645cf40ebf71(hex) {
    if (hex.length === 9) {
        var int = parseInt(hex.slice(7, 9), 16) / 255;
        return Number(parseFloat(int.toString()).toFixed(2));
    }
    return 1;
}
function $5889017aa52743df$export$b36dbdb4f463f05c(hex) {
    if (!$5889017aa52743df$var$isValidHex(hex)) throw new Error('Invalid HEX');
    var c;
    c = hex.substring(1).split('');
    if (c.length === 3) c = [
        c[0],
        c[0],
        c[1],
        c[1],
        c[2],
        c[2]
    ];
    c = '0x' + c.join('');
    return [
        c >> 16 & 255,
        c >> 8 & 255,
        c & 255,
        $5889017aa52743df$export$1212645cf40ebf71(hex)
    ];
}
function $5889017aa52743df$export$5a544e13ad4e1fa5(hex) {
    if (!$5889017aa52743df$var$isValidHex(hex)) throw new Error('Invalid HEX');
    var c;
    c = hex.substring(1).split('');
    if (c.length === 3) c = [
        c[0],
        c[0],
        c[1],
        c[1],
        c[2],
        c[2]
    ];
    c = '0x' + c.join('');
    return [
        c >> 16 & 255,
        c >> 8 & 255,
        c & 255
    ];
}
function $5889017aa52743df$export$47ea145a83f50dc0(hex) {
    if (!$5889017aa52743df$var$isValidHex(hex)) throw new Error('Invalid HEX');
    var r = 0, g = 0, b = 0;
    if (hex.length === 4) {
        r = '0x' + hex[1] + hex[1];
        g = '0x' + hex[2] + hex[2];
        b = '0x' + hex[3] + hex[3];
    } else if (hex.length === 7) {
        r = '0x' + hex[1] + hex[2];
        g = '0x' + hex[3] + hex[4];
        b = '0x' + hex[5] + hex[6];
    }
    // Then to HSL
    r /= 255;
    g /= 255;
    b /= 255;
    var cmin = Math.min(r, g, b), cmax = Math.max(r, g, b), delta = cmax - cmin, h = 0, s = 0, l = 0;
    if (delta === 0) h = 0;
    else if (cmax === r) h = (g - b) / delta % 6;
    else if (cmax === g) h = (b - r) / delta + 2;
    else h = (r - g) / delta + 4;
    h = Math.round(h * 60);
    if (h < 0) h += 360;
    l = (cmax + cmin) / 2;
    s = delta === 0 ? 0 : delta / (1 - Math.abs(2 * l - 1));
    s = +(s * 100).toFixed(1);
    l = +(l * 100).toFixed(1);
    return [
        h,
        s,
        l
    ];
}
function $5889017aa52743df$export$1ff93e992dd58bec(h, s, l) {
    s /= 100;
    l /= 100;
    var k = function k(n) {
        return (n + h / 30) % 12;
    };
    var a = s * Math.min(l, 1 - l);
    var f = function f(n) {
        return l - a * Math.max(-1, Math.min(k(n) - 3, Math.min(9 - k(n), 1)));
    };
    return [
        255 * f(0),
        255 * f(8),
        255 * f(4)
    ];
}
function $5889017aa52743df$export$e770b01b744f3745(r, g, b) {
    var RsRGB = r / 255;
    var GsRGB = g / 255;
    var BsRGB = b / 255;
    var R = RsRGB <= 0.03928 ? RsRGB / 12.92 : Math.pow((RsRGB + 0.055) / 1.055, 2.4);
    var G = GsRGB <= 0.03928 ? GsRGB / 12.92 : Math.pow((GsRGB + 0.055) / 1.055, 2.4);
    var B = BsRGB <= 0.03928 ? BsRGB / 12.92 : Math.pow((BsRGB + 0.055) / 1.055, 2.4);
    // For the sRGB colorspace, the relative luminance of a color is defined as:
    var L = 0.2126 * R + 0.7152 * G + 0.0722 * B;
    return L;
}
function $5889017aa52743df$export$d061e26956a60b0a(foreground, background) {
    if (!$5889017aa52743df$var$isValidHex(foreground) || !$5889017aa52743df$var$isValidHex(background)) throw new Error('Invalid HEX');
    var foregroundRgb = $5889017aa52743df$export$5a544e13ad4e1fa5(foreground);
    var backgroundRgb = $5889017aa52743df$export$5a544e13ad4e1fa5(background);
    var foregroundLuminance = $5889017aa52743df$export$e770b01b744f3745(foregroundRgb[0], foregroundRgb[1], foregroundRgb[2]);
    var backgroundLuminance = $5889017aa52743df$export$e770b01b744f3745(backgroundRgb[0], backgroundRgb[1], backgroundRgb[2]);
    // calculate the color contrast ratio
    var brightest = Math.max(foregroundLuminance, backgroundLuminance);
    var darkest = Math.min(foregroundLuminance, backgroundLuminance);
    return (brightest + 0.05) / (darkest + 0.05);
}
function $5889017aa52743df$export$e8ddad763b4bebf9(rgbA, rgbB) {
    var labA = $5889017aa52743df$var$rgbToLab(rgbA);
    var labB = $5889017aa52743df$var$rgbToLab(rgbB);
    var deltaL = labA[0] - labB[0];
    var deltaA = labA[1] - labB[1];
    var deltaB = labA[2] - labB[2];
    var c1 = Math.sqrt(labA[1] * labA[1] + labA[2] * labA[2]);
    var c2 = Math.sqrt(labB[1] * labB[1] + labB[2] * labB[2]);
    var deltaC = c1 - c2;
    var deltaH = deltaA * deltaA + deltaB * deltaB - deltaC * deltaC;
    deltaH = deltaH < 0 ? 0 : Math.sqrt(deltaH);
    var sc = 1.0 + 0.045 * c1;
    var sh = 1.0 + 0.015 * c1;
    var deltaLKlsl = deltaL / 1.0;
    var deltaCkcsc = deltaC / sc;
    var deltaHkhsh = deltaH / sh;
    var i = deltaLKlsl * deltaLKlsl + deltaCkcsc * deltaCkcsc + deltaHkhsh * deltaHkhsh;
    return i < 0 ? 0 : Math.sqrt(i);
}
function $5889017aa52743df$var$rgbToLab(rgb) {
    var r = rgb[0] / 255, g = rgb[1] / 255, b = rgb[2] / 255, x, y, z;
    r = r > 0.04045 ? Math.pow((r + 0.055) / 1.055, 2.4) : r / 12.92;
    g = g > 0.04045 ? Math.pow((g + 0.055) / 1.055, 2.4) : g / 12.92;
    b = b > 0.04045 ? Math.pow((b + 0.055) / 1.055, 2.4) : b / 12.92;
    x = (r * 0.4124 + g * 0.3576 + b * 0.1805) / 0.95047;
    y = (r * 0.2126 + g * 0.7152 + b * 0.0722) / 1.0;
    z = (r * 0.0193 + g * 0.1192 + b * 0.9505) / 1.08883;
    x = x > 0.008856 ? Math.pow(x, 1 / 3) : 7.787 * x + 16 / 116;
    y = y > 0.008856 ? Math.pow(y, 1 / 3) : 7.787 * y + 16 / 116;
    z = z > 0.008856 ? Math.pow(z, 1 / 3) : 7.787 * z + 16 / 116;
    return [
        116 * y - 16,
        500 * (x - y),
        200 * (y - z)
    ];
}

});

parcelRegister("7OC9w", function(module, exports) {
$parcel$export(module.exports, "hash", () => $5b0acc3ba75b772a$export$d6af199866bfb566);
var $5b0acc3ba75b772a$export$d6af199866bfb566 = function hash(str) {
    var hash = 0;
    for(var i = 0; i < str.length; i++){
        var char = str.charCodeAt(i);
        hash = (hash << 5) - hash + char;
        hash &= hash; // Convert to 32bit integer
    }
    return new Uint32Array([
        hash
    ])[0].toString(36);
};

});

parcelRegister("jWjO0", function(module, exports) {

var $iKwew = parcelRequire("iKwew");
module.exports = $iKwew("krm23").then(()=>parcelRequire('39Ndh'));

});

parcelRegister("5yZ6f", function(module, exports) {

var $iKwew = parcelRequire("iKwew");
module.exports = $iKwew("c3vzU").then(()=>parcelRequire('k2TW5'));

});

parcelRegister("6imoA", function(module, exports) {

var $iKwew = parcelRequire("iKwew");
module.exports = $iKwew("7Vlbn").then(()=>parcelRequire('kuztH'));

});

parcelRegister("aKbCl", function(module, exports) {

var $iKwew = parcelRequire("iKwew");
module.exports = $iKwew("c4iiB").then(()=>parcelRequire('ghLm0'));

});

parcelRegister("gK10y", function(module, exports) {

var $iKwew = parcelRequire("iKwew");
module.exports = $iKwew("2VohK").then(()=>parcelRequire('hPTx4'));

});

parcelRegister("2CkAK", function(module, exports) {

var $iKwew = parcelRequire("iKwew");
module.exports = $iKwew("a0C8k").then(()=>parcelRequire('5LGcl'));

});

parcelRegister("ifXfp", function(module, exports) {

var $iKwew = parcelRequire("iKwew");
module.exports = $iKwew("7eGGT").then(()=>parcelRequire('gpVDz'));

});

parcelRegister("juzct", function(module, exports) {

var $iKwew = parcelRequire("iKwew");
module.exports = $iKwew("ix8hC").then(()=>parcelRequire('7mxxu'));

});

parcelRegister("fkr37", function(module, exports) {

var $iKwew = parcelRequire("iKwew");
module.exports = $iKwew("jf6X7").then(()=>parcelRequire('3o3dV'));

});

parcelRegister("44JHn", function(module, exports) {

var $iKwew = parcelRequire("iKwew");
module.exports = $iKwew("dzvR8").then(()=>parcelRequire('c3YJp'));

});

parcelRegister("kgf22", function(module, exports) {

var $iKwew = parcelRequire("iKwew");
module.exports = $iKwew("jz4sq").then(()=>parcelRequire('8xZxZ'));

});

parcelRegister("3dPVw", function(module, exports) {
$parcel$export(module.exports, "findMissingCustomStyleElements", () => $258add9078684d9e$export$bd1ac9300b0e885a);
$parcel$export(module.exports, "limitSizeOfCustomStyleElements", () => $258add9078684d9e$export$e7ae172320e03461);
$parcel$export(module.exports, "reduceTokenMap", () => $258add9078684d9e$export$e673f367da2ff23e);

var $iYJcE = parcelRequire("iYJcE");

var $fC8ib = parcelRequire("fC8ib");

var $48n60 = parcelRequire("48n60");

var $a1YOk = parcelRequire("a1YOk");

var $7OC9w = parcelRequire("7OC9w");
function $258add9078684d9e$export$bd1ac9300b0e885a(UNSAFE_themeOptions, mode) {
    var optionString = JSON.stringify(UNSAFE_themeOptions);
    var uniqueId = (0, $7OC9w.hash)(optionString);
    var attrOfMissingCustomStyles = [];
    (mode === 'auto' ? [
        'light',
        'dark'
    ] : [
        mode
    ]).forEach(function(themeId) {
        var element = document.head.querySelector("style[".concat((0, $a1YOk.CUSTOM_THEME_ATTRIBUTE), "=\"").concat(uniqueId, "\"][").concat((0, $a1YOk.THEME_DATA_ATTRIBUTE), "=\"").concat(themeId, "\"]"));
        if (element) // Append the existing custom styles to take precedence over others
        document.head.appendChild(element);
        else attrOfMissingCustomStyles.push(themeId);
    });
    return attrOfMissingCustomStyles;
}
function $258add9078684d9e$export$e7ae172320e03461(sizeThreshold) {
    var styleTags = (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(Array.from(document.head.querySelectorAll("style[".concat((0, $a1YOk.CUSTOM_THEME_ATTRIBUTE), "][").concat((0, $a1YOk.THEME_DATA_ATTRIBUTE), "]"))));
    if (styleTags.length < sizeThreshold) return;
    styleTags.slice(0, styleTags.length - (sizeThreshold - 1)).forEach(function(element) {
        return element.remove();
    });
}
function $258add9078684d9e$export$e673f367da2ff23e(tokenMap, themeRamp) {
    return Object.entries(tokenMap).reduce(function(acc, _ref) {
        var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_ref, 2), key = _ref2[0], value = _ref2[1];
        var cssVar = (0, $48n60.default)[key];
        return cssVar ? "".concat(acc, "\n  ").concat(cssVar, ": ").concat(typeof value === 'string' ? value : themeRamp[value], ";") : acc;
    }, '');
}

});
parcelRegister("48n60", function(module, exports) {
$parcel$export(module.exports, "default", () => $3029d327115e35b3$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::71ab6af4453c6807be4d4249ca7614bc>>
 * @codegenCommand yarn build tokens
 */ var $3029d327115e35b3$var$tokens = {
    'color.text': '--ds-text',
    'color.text.accent.lime': '--ds-text-accent-lime',
    'color.text.accent.lime.bolder': '--ds-text-accent-lime-bolder',
    'color.text.accent.red': '--ds-text-accent-red',
    'color.text.accent.red.bolder': '--ds-text-accent-red-bolder',
    'color.text.accent.orange': '--ds-text-accent-orange',
    'color.text.accent.orange.bolder': '--ds-text-accent-orange-bolder',
    'color.text.accent.yellow': '--ds-text-accent-yellow',
    'color.text.accent.yellow.bolder': '--ds-text-accent-yellow-bolder',
    'color.text.accent.green': '--ds-text-accent-green',
    'color.text.accent.green.bolder': '--ds-text-accent-green-bolder',
    'color.text.accent.teal': '--ds-text-accent-teal',
    'color.text.accent.teal.bolder': '--ds-text-accent-teal-bolder',
    'color.text.accent.blue': '--ds-text-accent-blue',
    'color.text.accent.blue.bolder': '--ds-text-accent-blue-bolder',
    'color.text.accent.purple': '--ds-text-accent-purple',
    'color.text.accent.purple.bolder': '--ds-text-accent-purple-bolder',
    'color.text.accent.magenta': '--ds-text-accent-magenta',
    'color.text.accent.magenta.bolder': '--ds-text-accent-magenta-bolder',
    'color.text.accent.gray': '--ds-text-accent-gray',
    'color.text.accent.gray.bolder': '--ds-text-accent-gray-bolder',
    'color.text.disabled': '--ds-text-disabled',
    'color.text.inverse': '--ds-text-inverse',
    'color.text.selected': '--ds-text-selected',
    'color.text.brand': '--ds-text-brand',
    'color.text.danger': '--ds-text-danger',
    'color.text.danger.bolder': '--ds-text-danger-bolder',
    'color.text.warning': '--ds-text-warning',
    'color.text.warning.inverse': '--ds-text-warning-inverse',
    'color.text.warning.bolder': '--ds-text-warning-bolder',
    'color.text.success': '--ds-text-success',
    'color.text.success.bolder': '--ds-text-success-bolder',
    'color.text.discovery': '--ds-text-discovery',
    'color.text.discovery.bolder': '--ds-text-discovery-bolder',
    'color.text.information': '--ds-text-information',
    'color.text.information.bolder': '--ds-text-information-bolder',
    'color.text.subtlest': '--ds-text-subtlest',
    'color.text.subtle': '--ds-text-subtle',
    'color.link': '--ds-link',
    'color.link.pressed': '--ds-link-pressed',
    'color.link.visited': '--ds-link-visited',
    'color.link.visited.pressed': '--ds-link-visited-pressed',
    'color.icon': '--ds-icon',
    'color.icon.accent.lime': '--ds-icon-accent-lime',
    'color.icon.accent.red': '--ds-icon-accent-red',
    'color.icon.accent.orange': '--ds-icon-accent-orange',
    'color.icon.accent.yellow': '--ds-icon-accent-yellow',
    'color.icon.accent.green': '--ds-icon-accent-green',
    'color.icon.accent.teal': '--ds-icon-accent-teal',
    'color.icon.accent.blue': '--ds-icon-accent-blue',
    'color.icon.accent.purple': '--ds-icon-accent-purple',
    'color.icon.accent.magenta': '--ds-icon-accent-magenta',
    'color.icon.accent.gray': '--ds-icon-accent-gray',
    'color.icon.disabled': '--ds-icon-disabled',
    'color.icon.inverse': '--ds-icon-inverse',
    'color.icon.selected': '--ds-icon-selected',
    'color.icon.brand': '--ds-icon-brand',
    'color.icon.danger': '--ds-icon-danger',
    'color.icon.warning': '--ds-icon-warning',
    'color.icon.warning.inverse': '--ds-icon-warning-inverse',
    'color.icon.success': '--ds-icon-success',
    'color.icon.discovery': '--ds-icon-discovery',
    'color.icon.information': '--ds-icon-information',
    'color.icon.subtlest': '--ds-icon-subtlest',
    'color.icon.subtle': '--ds-icon-subtle',
    'color.border': '--ds-border',
    'color.border.accent.lime': '--ds-border-accent-lime',
    'color.border.accent.red': '--ds-border-accent-red',
    'color.border.accent.orange': '--ds-border-accent-orange',
    'color.border.accent.yellow': '--ds-border-accent-yellow',
    'color.border.accent.green': '--ds-border-accent-green',
    'color.border.accent.teal': '--ds-border-accent-teal',
    'color.border.accent.blue': '--ds-border-accent-blue',
    'color.border.accent.purple': '--ds-border-accent-purple',
    'color.border.accent.magenta': '--ds-border-accent-magenta',
    'color.border.accent.gray': '--ds-border-accent-gray',
    'color.border.disabled': '--ds-border-disabled',
    'color.border.focused': '--ds-border-focused',
    'color.border.input': '--ds-border-input',
    'color.border.inverse': '--ds-border-inverse',
    'color.border.selected': '--ds-border-selected',
    'color.border.brand': '--ds-border-brand',
    'color.border.danger': '--ds-border-danger',
    'color.border.warning': '--ds-border-warning',
    'color.border.success': '--ds-border-success',
    'color.border.discovery': '--ds-border-discovery',
    'color.border.information': '--ds-border-information',
    'color.border.bold': '--ds-border-bold',
    'color.background.accent.lime.subtlest': '--ds-background-accent-lime-subtlest',
    'color.background.accent.lime.subtlest.hovered': '--ds-background-accent-lime-subtlest-hovered',
    'color.background.accent.lime.subtlest.pressed': '--ds-background-accent-lime-subtlest-pressed',
    'color.background.accent.lime.subtler': '--ds-background-accent-lime-subtler',
    'color.background.accent.lime.subtler.hovered': '--ds-background-accent-lime-subtler-hovered',
    'color.background.accent.lime.subtler.pressed': '--ds-background-accent-lime-subtler-pressed',
    'color.background.accent.lime.subtle': '--ds-background-accent-lime-subtle',
    'color.background.accent.lime.subtle.hovered': '--ds-background-accent-lime-subtle-hovered',
    'color.background.accent.lime.subtle.pressed': '--ds-background-accent-lime-subtle-pressed',
    'color.background.accent.lime.bolder': '--ds-background-accent-lime-bolder',
    'color.background.accent.lime.bolder.hovered': '--ds-background-accent-lime-bolder-hovered',
    'color.background.accent.lime.bolder.pressed': '--ds-background-accent-lime-bolder-pressed',
    'color.background.accent.red.subtlest': '--ds-background-accent-red-subtlest',
    'color.background.accent.red.subtlest.hovered': '--ds-background-accent-red-subtlest-hovered',
    'color.background.accent.red.subtlest.pressed': '--ds-background-accent-red-subtlest-pressed',
    'color.background.accent.red.subtler': '--ds-background-accent-red-subtler',
    'color.background.accent.red.subtler.hovered': '--ds-background-accent-red-subtler-hovered',
    'color.background.accent.red.subtler.pressed': '--ds-background-accent-red-subtler-pressed',
    'color.background.accent.red.subtle': '--ds-background-accent-red-subtle',
    'color.background.accent.red.subtle.hovered': '--ds-background-accent-red-subtle-hovered',
    'color.background.accent.red.subtle.pressed': '--ds-background-accent-red-subtle-pressed',
    'color.background.accent.red.bolder': '--ds-background-accent-red-bolder',
    'color.background.accent.red.bolder.hovered': '--ds-background-accent-red-bolder-hovered',
    'color.background.accent.red.bolder.pressed': '--ds-background-accent-red-bolder-pressed',
    'color.background.accent.orange.subtlest': '--ds-background-accent-orange-subtlest',
    'color.background.accent.orange.subtlest.hovered': '--ds-background-accent-orange-subtlest-hovered',
    'color.background.accent.orange.subtlest.pressed': '--ds-background-accent-orange-subtlest-pressed',
    'color.background.accent.orange.subtler': '--ds-background-accent-orange-subtler',
    'color.background.accent.orange.subtler.hovered': '--ds-background-accent-orange-subtler-hovered',
    'color.background.accent.orange.subtler.pressed': '--ds-background-accent-orange-subtler-pressed',
    'color.background.accent.orange.subtle': '--ds-background-accent-orange-subtle',
    'color.background.accent.orange.subtle.hovered': '--ds-background-accent-orange-subtle-hovered',
    'color.background.accent.orange.subtle.pressed': '--ds-background-accent-orange-subtle-pressed',
    'color.background.accent.orange.bolder': '--ds-background-accent-orange-bolder',
    'color.background.accent.orange.bolder.hovered': '--ds-background-accent-orange-bolder-hovered',
    'color.background.accent.orange.bolder.pressed': '--ds-background-accent-orange-bolder-pressed',
    'color.background.accent.yellow.subtlest': '--ds-background-accent-yellow-subtlest',
    'color.background.accent.yellow.subtlest.hovered': '--ds-background-accent-yellow-subtlest-hovered',
    'color.background.accent.yellow.subtlest.pressed': '--ds-background-accent-yellow-subtlest-pressed',
    'color.background.accent.yellow.subtler': '--ds-background-accent-yellow-subtler',
    'color.background.accent.yellow.subtler.hovered': '--ds-background-accent-yellow-subtler-hovered',
    'color.background.accent.yellow.subtler.pressed': '--ds-background-accent-yellow-subtler-pressed',
    'color.background.accent.yellow.subtle': '--ds-background-accent-yellow-subtle',
    'color.background.accent.yellow.subtle.hovered': '--ds-background-accent-yellow-subtle-hovered',
    'color.background.accent.yellow.subtle.pressed': '--ds-background-accent-yellow-subtle-pressed',
    'color.background.accent.yellow.bolder': '--ds-background-accent-yellow-bolder',
    'color.background.accent.yellow.bolder.hovered': '--ds-background-accent-yellow-bolder-hovered',
    'color.background.accent.yellow.bolder.pressed': '--ds-background-accent-yellow-bolder-pressed',
    'color.background.accent.green.subtlest': '--ds-background-accent-green-subtlest',
    'color.background.accent.green.subtlest.hovered': '--ds-background-accent-green-subtlest-hovered',
    'color.background.accent.green.subtlest.pressed': '--ds-background-accent-green-subtlest-pressed',
    'color.background.accent.green.subtler': '--ds-background-accent-green-subtler',
    'color.background.accent.green.subtler.hovered': '--ds-background-accent-green-subtler-hovered',
    'color.background.accent.green.subtler.pressed': '--ds-background-accent-green-subtler-pressed',
    'color.background.accent.green.subtle': '--ds-background-accent-green-subtle',
    'color.background.accent.green.subtle.hovered': '--ds-background-accent-green-subtle-hovered',
    'color.background.accent.green.subtle.pressed': '--ds-background-accent-green-subtle-pressed',
    'color.background.accent.green.bolder': '--ds-background-accent-green-bolder',
    'color.background.accent.green.bolder.hovered': '--ds-background-accent-green-bolder-hovered',
    'color.background.accent.green.bolder.pressed': '--ds-background-accent-green-bolder-pressed',
    'color.background.accent.teal.subtlest': '--ds-background-accent-teal-subtlest',
    'color.background.accent.teal.subtlest.hovered': '--ds-background-accent-teal-subtlest-hovered',
    'color.background.accent.teal.subtlest.pressed': '--ds-background-accent-teal-subtlest-pressed',
    'color.background.accent.teal.subtler': '--ds-background-accent-teal-subtler',
    'color.background.accent.teal.subtler.hovered': '--ds-background-accent-teal-subtler-hovered',
    'color.background.accent.teal.subtler.pressed': '--ds-background-accent-teal-subtler-pressed',
    'color.background.accent.teal.subtle': '--ds-background-accent-teal-subtle',
    'color.background.accent.teal.subtle.hovered': '--ds-background-accent-teal-subtle-hovered',
    'color.background.accent.teal.subtle.pressed': '--ds-background-accent-teal-subtle-pressed',
    'color.background.accent.teal.bolder': '--ds-background-accent-teal-bolder',
    'color.background.accent.teal.bolder.hovered': '--ds-background-accent-teal-bolder-hovered',
    'color.background.accent.teal.bolder.pressed': '--ds-background-accent-teal-bolder-pressed',
    'color.background.accent.blue.subtlest': '--ds-background-accent-blue-subtlest',
    'color.background.accent.blue.subtlest.hovered': '--ds-background-accent-blue-subtlest-hovered',
    'color.background.accent.blue.subtlest.pressed': '--ds-background-accent-blue-subtlest-pressed',
    'color.background.accent.blue.subtler': '--ds-background-accent-blue-subtler',
    'color.background.accent.blue.subtler.hovered': '--ds-background-accent-blue-subtler-hovered',
    'color.background.accent.blue.subtler.pressed': '--ds-background-accent-blue-subtler-pressed',
    'color.background.accent.blue.subtle': '--ds-background-accent-blue-subtle',
    'color.background.accent.blue.subtle.hovered': '--ds-background-accent-blue-subtle-hovered',
    'color.background.accent.blue.subtle.pressed': '--ds-background-accent-blue-subtle-pressed',
    'color.background.accent.blue.bolder': '--ds-background-accent-blue-bolder',
    'color.background.accent.blue.bolder.hovered': '--ds-background-accent-blue-bolder-hovered',
    'color.background.accent.blue.bolder.pressed': '--ds-background-accent-blue-bolder-pressed',
    'color.background.accent.purple.subtlest': '--ds-background-accent-purple-subtlest',
    'color.background.accent.purple.subtlest.hovered': '--ds-background-accent-purple-subtlest-hovered',
    'color.background.accent.purple.subtlest.pressed': '--ds-background-accent-purple-subtlest-pressed',
    'color.background.accent.purple.subtler': '--ds-background-accent-purple-subtler',
    'color.background.accent.purple.subtler.hovered': '--ds-background-accent-purple-subtler-hovered',
    'color.background.accent.purple.subtler.pressed': '--ds-background-accent-purple-subtler-pressed',
    'color.background.accent.purple.subtle': '--ds-background-accent-purple-subtle',
    'color.background.accent.purple.subtle.hovered': '--ds-background-accent-purple-subtle-hovered',
    'color.background.accent.purple.subtle.pressed': '--ds-background-accent-purple-subtle-pressed',
    'color.background.accent.purple.bolder': '--ds-background-accent-purple-bolder',
    'color.background.accent.purple.bolder.hovered': '--ds-background-accent-purple-bolder-hovered',
    'color.background.accent.purple.bolder.pressed': '--ds-background-accent-purple-bolder-pressed',
    'color.background.accent.magenta.subtlest': '--ds-background-accent-magenta-subtlest',
    'color.background.accent.magenta.subtlest.hovered': '--ds-background-accent-magenta-subtlest-hovered',
    'color.background.accent.magenta.subtlest.pressed': '--ds-background-accent-magenta-subtlest-pressed',
    'color.background.accent.magenta.subtler': '--ds-background-accent-magenta-subtler',
    'color.background.accent.magenta.subtler.hovered': '--ds-background-accent-magenta-subtler-hovered',
    'color.background.accent.magenta.subtler.pressed': '--ds-background-accent-magenta-subtler-pressed',
    'color.background.accent.magenta.subtle': '--ds-background-accent-magenta-subtle',
    'color.background.accent.magenta.subtle.hovered': '--ds-background-accent-magenta-subtle-hovered',
    'color.background.accent.magenta.subtle.pressed': '--ds-background-accent-magenta-subtle-pressed',
    'color.background.accent.magenta.bolder': '--ds-background-accent-magenta-bolder',
    'color.background.accent.magenta.bolder.hovered': '--ds-background-accent-magenta-bolder-hovered',
    'color.background.accent.magenta.bolder.pressed': '--ds-background-accent-magenta-bolder-pressed',
    'color.background.accent.gray.subtlest': '--ds-background-accent-gray-subtlest',
    'color.background.accent.gray.subtlest.hovered': '--ds-background-accent-gray-subtlest-hovered',
    'color.background.accent.gray.subtlest.pressed': '--ds-background-accent-gray-subtlest-pressed',
    'color.background.accent.gray.subtler': '--ds-background-accent-gray-subtler',
    'color.background.accent.gray.subtler.hovered': '--ds-background-accent-gray-subtler-hovered',
    'color.background.accent.gray.subtler.pressed': '--ds-background-accent-gray-subtler-pressed',
    'color.background.accent.gray.subtle': '--ds-background-accent-gray-subtle',
    'color.background.accent.gray.subtle.hovered': '--ds-background-accent-gray-subtle-hovered',
    'color.background.accent.gray.subtle.pressed': '--ds-background-accent-gray-subtle-pressed',
    'color.background.accent.gray.bolder': '--ds-background-accent-gray-bolder',
    'color.background.accent.gray.bolder.hovered': '--ds-background-accent-gray-bolder-hovered',
    'color.background.accent.gray.bolder.pressed': '--ds-background-accent-gray-bolder-pressed',
    'color.background.disabled': '--ds-background-disabled',
    'color.background.input': '--ds-background-input',
    'color.background.input.hovered': '--ds-background-input-hovered',
    'color.background.input.pressed': '--ds-background-input-pressed',
    'color.background.inverse.subtle': '--ds-background-inverse-subtle',
    'color.background.inverse.subtle.hovered': '--ds-background-inverse-subtle-hovered',
    'color.background.inverse.subtle.pressed': '--ds-background-inverse-subtle-pressed',
    'color.background.neutral': '--ds-background-neutral',
    'color.background.neutral.hovered': '--ds-background-neutral-hovered',
    'color.background.neutral.pressed': '--ds-background-neutral-pressed',
    'color.background.neutral.subtle': '--ds-background-neutral-subtle',
    'color.background.neutral.subtle.hovered': '--ds-background-neutral-subtle-hovered',
    'color.background.neutral.subtle.pressed': '--ds-background-neutral-subtle-pressed',
    'color.background.neutral.bold': '--ds-background-neutral-bold',
    'color.background.neutral.bold.hovered': '--ds-background-neutral-bold-hovered',
    'color.background.neutral.bold.pressed': '--ds-background-neutral-bold-pressed',
    'color.background.selected': '--ds-background-selected',
    'color.background.selected.hovered': '--ds-background-selected-hovered',
    'color.background.selected.pressed': '--ds-background-selected-pressed',
    'color.background.selected.bold': '--ds-background-selected-bold',
    'color.background.selected.bold.hovered': '--ds-background-selected-bold-hovered',
    'color.background.selected.bold.pressed': '--ds-background-selected-bold-pressed',
    'color.background.brand.subtlest': '--ds-background-brand-subtlest',
    'color.background.brand.subtlest.hovered': '--ds-background-brand-subtlest-hovered',
    'color.background.brand.subtlest.pressed': '--ds-background-brand-subtlest-pressed',
    'color.background.brand.bold': '--ds-background-brand-bold',
    'color.background.brand.bold.hovered': '--ds-background-brand-bold-hovered',
    'color.background.brand.bold.pressed': '--ds-background-brand-bold-pressed',
    'color.background.brand.boldest': '--ds-background-brand-boldest',
    'color.background.brand.boldest.hovered': '--ds-background-brand-boldest-hovered',
    'color.background.brand.boldest.pressed': '--ds-background-brand-boldest-pressed',
    'color.background.danger': '--ds-background-danger',
    'color.background.danger.hovered': '--ds-background-danger-hovered',
    'color.background.danger.pressed': '--ds-background-danger-pressed',
    'color.background.danger.subtler': '--ds-background-danger-subtler',
    'color.background.danger.subtler.hovered': '--ds-background-danger-subtler-hovered',
    'color.background.danger.subtler.pressed': '--ds-background-danger-subtler-pressed',
    'color.background.danger.bold': '--ds-background-danger-bold',
    'color.background.danger.bold.hovered': '--ds-background-danger-bold-hovered',
    'color.background.danger.bold.pressed': '--ds-background-danger-bold-pressed',
    'color.background.warning': '--ds-background-warning',
    'color.background.warning.hovered': '--ds-background-warning-hovered',
    'color.background.warning.pressed': '--ds-background-warning-pressed',
    'color.background.warning.subtler': '--ds-background-warning-subtler',
    'color.background.warning.subtler.hovered': '--ds-background-warning-subtler-hovered',
    'color.background.warning.subtler.pressed': '--ds-background-warning-subtler-pressed',
    'color.background.warning.bold': '--ds-background-warning-bold',
    'color.background.warning.bold.hovered': '--ds-background-warning-bold-hovered',
    'color.background.warning.bold.pressed': '--ds-background-warning-bold-pressed',
    'color.background.success': '--ds-background-success',
    'color.background.success.hovered': '--ds-background-success-hovered',
    'color.background.success.pressed': '--ds-background-success-pressed',
    'color.background.success.subtler': '--ds-background-success-subtler',
    'color.background.success.subtler.hovered': '--ds-background-success-subtler-hovered',
    'color.background.success.subtler.pressed': '--ds-background-success-subtler-pressed',
    'color.background.success.bold': '--ds-background-success-bold',
    'color.background.success.bold.hovered': '--ds-background-success-bold-hovered',
    'color.background.success.bold.pressed': '--ds-background-success-bold-pressed',
    'color.background.discovery': '--ds-background-discovery',
    'color.background.discovery.hovered': '--ds-background-discovery-hovered',
    'color.background.discovery.pressed': '--ds-background-discovery-pressed',
    'color.background.discovery.subtler': '--ds-background-discovery-subtler',
    'color.background.discovery.subtler.hovered': '--ds-background-discovery-subtler-hovered',
    'color.background.discovery.subtler.pressed': '--ds-background-discovery-subtler-pressed',
    'color.background.discovery.bold': '--ds-background-discovery-bold',
    'color.background.discovery.bold.hovered': '--ds-background-discovery-bold-hovered',
    'color.background.discovery.bold.pressed': '--ds-background-discovery-bold-pressed',
    'color.background.information': '--ds-background-information',
    'color.background.information.hovered': '--ds-background-information-hovered',
    'color.background.information.pressed': '--ds-background-information-pressed',
    'color.background.information.subtler': '--ds-background-information-subtler',
    'color.background.information.subtler.hovered': '--ds-background-information-subtler-hovered',
    'color.background.information.subtler.pressed': '--ds-background-information-subtler-pressed',
    'color.background.information.bold': '--ds-background-information-bold',
    'color.background.information.bold.hovered': '--ds-background-information-bold-hovered',
    'color.background.information.bold.pressed': '--ds-background-information-bold-pressed',
    'color.blanket': '--ds-blanket',
    'color.blanket.selected': '--ds-blanket-selected',
    'color.blanket.danger': '--ds-blanket-danger',
    'color.interaction.hovered': '--ds-interaction-hovered',
    'color.interaction.pressed': '--ds-interaction-pressed',
    'color.skeleton': '--ds-skeleton',
    'color.skeleton.subtle': '--ds-skeleton-subtle',
    'color.chart.categorical.1': '--ds-chart-categorical-1',
    'color.chart.categorical.1.hovered': '--ds-chart-categorical-1-hovered',
    'color.chart.categorical.2': '--ds-chart-categorical-2',
    'color.chart.categorical.2.hovered': '--ds-chart-categorical-2-hovered',
    'color.chart.categorical.3': '--ds-chart-categorical-3',
    'color.chart.categorical.3.hovered': '--ds-chart-categorical-3-hovered',
    'color.chart.categorical.4': '--ds-chart-categorical-4',
    'color.chart.categorical.4.hovered': '--ds-chart-categorical-4-hovered',
    'color.chart.categorical.5': '--ds-chart-categorical-5',
    'color.chart.categorical.5.hovered': '--ds-chart-categorical-5-hovered',
    'color.chart.categorical.6': '--ds-chart-categorical-6',
    'color.chart.categorical.6.hovered': '--ds-chart-categorical-6-hovered',
    'color.chart.categorical.7': '--ds-chart-categorical-7',
    'color.chart.categorical.7.hovered': '--ds-chart-categorical-7-hovered',
    'color.chart.categorical.8': '--ds-chart-categorical-8',
    'color.chart.categorical.8.hovered': '--ds-chart-categorical-8-hovered',
    'color.chart.lime.bold': '--ds-chart-lime-bold',
    'color.chart.lime.bold.hovered': '--ds-chart-lime-bold-hovered',
    'color.chart.lime.bolder': '--ds-chart-lime-bolder',
    'color.chart.lime.bolder.hovered': '--ds-chart-lime-bolder-hovered',
    'color.chart.lime.boldest': '--ds-chart-lime-boldest',
    'color.chart.lime.boldest.hovered': '--ds-chart-lime-boldest-hovered',
    'color.chart.neutral': '--ds-chart-neutral',
    'color.chart.neutral.hovered': '--ds-chart-neutral-hovered',
    'color.chart.red.bold': '--ds-chart-red-bold',
    'color.chart.red.bold.hovered': '--ds-chart-red-bold-hovered',
    'color.chart.red.bolder': '--ds-chart-red-bolder',
    'color.chart.red.bolder.hovered': '--ds-chart-red-bolder-hovered',
    'color.chart.red.boldest': '--ds-chart-red-boldest',
    'color.chart.red.boldest.hovered': '--ds-chart-red-boldest-hovered',
    'color.chart.orange.bold': '--ds-chart-orange-bold',
    'color.chart.orange.bold.hovered': '--ds-chart-orange-bold-hovered',
    'color.chart.orange.bolder': '--ds-chart-orange-bolder',
    'color.chart.orange.bolder.hovered': '--ds-chart-orange-bolder-hovered',
    'color.chart.orange.boldest': '--ds-chart-orange-boldest',
    'color.chart.orange.boldest.hovered': '--ds-chart-orange-boldest-hovered',
    'color.chart.yellow.bold': '--ds-chart-yellow-bold',
    'color.chart.yellow.bold.hovered': '--ds-chart-yellow-bold-hovered',
    'color.chart.yellow.bolder': '--ds-chart-yellow-bolder',
    'color.chart.yellow.bolder.hovered': '--ds-chart-yellow-bolder-hovered',
    'color.chart.yellow.boldest': '--ds-chart-yellow-boldest',
    'color.chart.yellow.boldest.hovered': '--ds-chart-yellow-boldest-hovered',
    'color.chart.green.bold': '--ds-chart-green-bold',
    'color.chart.green.bold.hovered': '--ds-chart-green-bold-hovered',
    'color.chart.green.bolder': '--ds-chart-green-bolder',
    'color.chart.green.bolder.hovered': '--ds-chart-green-bolder-hovered',
    'color.chart.green.boldest': '--ds-chart-green-boldest',
    'color.chart.green.boldest.hovered': '--ds-chart-green-boldest-hovered',
    'color.chart.teal.bold': '--ds-chart-teal-bold',
    'color.chart.teal.bold.hovered': '--ds-chart-teal-bold-hovered',
    'color.chart.teal.bolder': '--ds-chart-teal-bolder',
    'color.chart.teal.bolder.hovered': '--ds-chart-teal-bolder-hovered',
    'color.chart.teal.boldest': '--ds-chart-teal-boldest',
    'color.chart.teal.boldest.hovered': '--ds-chart-teal-boldest-hovered',
    'color.chart.blue.bold': '--ds-chart-blue-bold',
    'color.chart.blue.bold.hovered': '--ds-chart-blue-bold-hovered',
    'color.chart.blue.bolder': '--ds-chart-blue-bolder',
    'color.chart.blue.bolder.hovered': '--ds-chart-blue-bolder-hovered',
    'color.chart.blue.boldest': '--ds-chart-blue-boldest',
    'color.chart.blue.boldest.hovered': '--ds-chart-blue-boldest-hovered',
    'color.chart.purple.bold': '--ds-chart-purple-bold',
    'color.chart.purple.bold.hovered': '--ds-chart-purple-bold-hovered',
    'color.chart.purple.bolder': '--ds-chart-purple-bolder',
    'color.chart.purple.bolder.hovered': '--ds-chart-purple-bolder-hovered',
    'color.chart.purple.boldest': '--ds-chart-purple-boldest',
    'color.chart.purple.boldest.hovered': '--ds-chart-purple-boldest-hovered',
    'color.chart.magenta.bold': '--ds-chart-magenta-bold',
    'color.chart.magenta.bold.hovered': '--ds-chart-magenta-bold-hovered',
    'color.chart.magenta.bolder': '--ds-chart-magenta-bolder',
    'color.chart.magenta.bolder.hovered': '--ds-chart-magenta-bolder-hovered',
    'color.chart.magenta.boldest': '--ds-chart-magenta-boldest',
    'color.chart.magenta.boldest.hovered': '--ds-chart-magenta-boldest-hovered',
    'color.chart.gray.bold': '--ds-chart-gray-bold',
    'color.chart.gray.bold.hovered': '--ds-chart-gray-bold-hovered',
    'color.chart.gray.bolder': '--ds-chart-gray-bolder',
    'color.chart.gray.bolder.hovered': '--ds-chart-gray-bolder-hovered',
    'color.chart.gray.boldest': '--ds-chart-gray-boldest',
    'color.chart.gray.boldest.hovered': '--ds-chart-gray-boldest-hovered',
    'color.chart.brand': '--ds-chart-brand',
    'color.chart.brand.hovered': '--ds-chart-brand-hovered',
    'color.chart.danger': '--ds-chart-danger',
    'color.chart.danger.hovered': '--ds-chart-danger-hovered',
    'color.chart.danger.bold': '--ds-chart-danger-bold',
    'color.chart.danger.bold.hovered': '--ds-chart-danger-bold-hovered',
    'color.chart.warning': '--ds-chart-warning',
    'color.chart.warning.hovered': '--ds-chart-warning-hovered',
    'color.chart.warning.bold': '--ds-chart-warning-bold',
    'color.chart.warning.bold.hovered': '--ds-chart-warning-bold-hovered',
    'color.chart.success': '--ds-chart-success',
    'color.chart.success.hovered': '--ds-chart-success-hovered',
    'color.chart.success.bold': '--ds-chart-success-bold',
    'color.chart.success.bold.hovered': '--ds-chart-success-bold-hovered',
    'color.chart.discovery': '--ds-chart-discovery',
    'color.chart.discovery.hovered': '--ds-chart-discovery-hovered',
    'color.chart.discovery.bold': '--ds-chart-discovery-bold',
    'color.chart.discovery.bold.hovered': '--ds-chart-discovery-bold-hovered',
    'color.chart.information': '--ds-chart-information',
    'color.chart.information.hovered': '--ds-chart-information-hovered',
    'color.chart.information.bold': '--ds-chart-information-bold',
    'color.chart.information.bold.hovered': '--ds-chart-information-bold-hovered',
    'elevation.surface': '--ds-surface',
    'elevation.surface.hovered': '--ds-surface-hovered',
    'elevation.surface.pressed': '--ds-surface-pressed',
    'elevation.surface.overlay': '--ds-surface-overlay',
    'elevation.surface.overlay.hovered': '--ds-surface-overlay-hovered',
    'elevation.surface.overlay.pressed': '--ds-surface-overlay-pressed',
    'elevation.surface.raised': '--ds-surface-raised',
    'elevation.surface.raised.hovered': '--ds-surface-raised-hovered',
    'elevation.surface.raised.pressed': '--ds-surface-raised-pressed',
    'elevation.surface.sunken': '--ds-surface-sunken',
    'elevation.shadow.overflow': '--ds-shadow-overflow',
    'elevation.shadow.overflow.perimeter': '--ds-shadow-overflow-perimeter',
    'elevation.shadow.overflow.spread': '--ds-shadow-overflow-spread',
    'elevation.shadow.overlay': '--ds-shadow-overlay',
    'elevation.shadow.raised': '--ds-shadow-raised',
    'opacity.disabled': '--ds-opacity-disabled',
    'opacity.loading': '--ds-opacity-loading',
    'utility.UNSAFE.transparent': '--ds-UNSAFE-transparent',
    'utility.elevation.surface.current': '--ds-elevation-surface-current',
    'space.0': '--ds-space-0',
    'space.025': '--ds-space-025',
    'space.050': '--ds-space-050',
    'space.075': '--ds-space-075',
    'space.100': '--ds-space-100',
    'space.150': '--ds-space-150',
    'space.200': '--ds-space-200',
    'space.250': '--ds-space-250',
    'space.300': '--ds-space-300',
    'space.400': '--ds-space-400',
    'space.500': '--ds-space-500',
    'space.600': '--ds-space-600',
    'space.800': '--ds-space-800',
    'space.1000': '--ds-space-1000',
    'space.negative.025': '--ds-space-negative-025',
    'space.negative.050': '--ds-space-negative-050',
    'space.negative.075': '--ds-space-negative-075',
    'space.negative.100': '--ds-space-negative-100',
    'space.negative.150': '--ds-space-negative-150',
    'space.negative.200': '--ds-space-negative-200',
    'space.negative.250': '--ds-space-negative-250',
    'space.negative.300': '--ds-space-negative-300',
    'space.negative.400': '--ds-space-negative-400',
    'font.heading.xxlarge': '--ds-font-heading-xxlarge',
    'font.heading.xlarge': '--ds-font-heading-xlarge',
    'font.heading.large': '--ds-font-heading-large',
    'font.heading.medium': '--ds-font-heading-medium',
    'font.heading.small': '--ds-font-heading-small',
    'font.heading.xsmall': '--ds-font-heading-xsmall',
    'font.heading.xxsmall': '--ds-font-heading-xxsmall',
    'font.body.large': '--ds-font-body-large',
    'font.body': '--ds-font-body',
    'font.body.small': '--ds-font-body-small',
    'font.body.UNSAFE_small': '--ds-font-body-UNSAFE_small',
    'font.metric.large': '--ds-font-metric-large',
    'font.metric.medium': '--ds-font-metric-medium',
    'font.metric.small': '--ds-font-metric-small',
    'font.code': '--ds-font-code',
    'font.weight.regular': '--ds-font-weight-regular',
    'font.weight.medium': '--ds-font-weight-medium',
    'font.weight.semibold': '--ds-font-weight-semibold',
    'font.weight.bold': '--ds-font-weight-bold',
    'font.family.heading': '--ds-font-family-heading',
    'font.family.body': '--ds-font-family-body',
    'font.family.code': '--ds-font-family-code',
    'font.family.brand.heading': '--ds-font-family-brand-heading',
    'font.family.brand.body': '--ds-font-family-brand-body',
    'radius.xsmall': '--ds-radius-xsmall',
    'radius.small': '--ds-radius-small',
    'radius.medium': '--ds-radius-medium',
    'radius.large': '--ds-radius-large',
    'radius.xlarge': '--ds-radius-xlarge',
    'radius.xxlarge': '--ds-radius-xxlarge',
    'radius.full': '--ds-radius-full',
    'radius.tile': '--ds-radius-tile',
    'border.width': '--ds-border-width',
    'border.width.selected': '--ds-border-width-selected',
    'border.width.focused': '--ds-border-width-focused'
};
var $3029d327115e35b3$export$2e2bcd8739ae039 = $3029d327115e35b3$var$tokens;

});


parcelRegister("3Yyny", function(module, exports) {

var $iKwew = parcelRequire("iKwew");
module.exports = $iKwew("3iS86").then(()=>parcelRequire('jZRXU'));

});

parcelRegister("hBCYb", function(module, exports) {
$parcel$export(module.exports, "getDocument", () => $cd141eeb67af3524$export$f65ca476c09acec0);
var $cd141eeb67af3524$export$f65ca476c09acec0 = function getDocument() {
    if (typeof document !== 'undefined') return document;
    return null;
};

});

parcelRegister("kxpsr", function(module, exports) {
$parcel$export(module.exports, "default", () => $ef3aa319a548c3c6$export$2e2bcd8739ae039);

var $kRflf = parcelRequire("kRflf");

var $3ZMUU = parcelRequire("3ZMUU");
function $ef3aa319a548c3c6$export$2e2bcd8739ae039(packageName, api, additionalMessage) {
    (0, $kRflf.default)("[".concat(packageName, "]: The ").concat(api, " is deprecated.").concat(additionalMessage && " ".concat(additionalMessage)));
}
function $ef3aa319a548c3c6$export$eb1decd851a5ae56(packageName, propName, predicate, deprecationAnnouncementOnDAC) {
    typeof $3ZMUU;
}

});
parcelRegister("kRflf", function(module, exports) {
$parcel$export(module.exports, "default", () => $f2f4a868e548940a$export$2e2bcd8739ae039);
/* eslint-disable no-console */ var $f2f4a868e548940a$var$printed = {};
function $f2f4a868e548940a$export$2e2bcd8739ae039(message) {
    if ($f2f4a868e548940a$var$printed[message]) return;
    $f2f4a868e548940a$var$printed[message] = true;
    if (typeof window !== 'undefined') console.warn(message);
}

});


parcelRegister("lAD7C", function(module, exports) {
function $fb7b4e90f3581f68$var$_taggedTemplateLiteral(e, t) {
    return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, {
        raw: {
            value: Object.freeze(t)
        }
    }));
}
module.exports = $fb7b4e90f3581f68$var$_taggedTemplateLiteral, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("gENTG", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a7f51491040268dbfa9258c45e59f2b2>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c207164c875990c8$var$_react = $c207164c875990c8$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $c207164c875990c8$var$_baseNew = $c207164c875990c8$var$_interopRequireDefault((parcelRequire("kAFi5")));
function $c207164c875990c8$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Person".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Known uses: representing a person or user, owner, contributor.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c207164c875990c8$var$PersonIcon = (props)=>/*#__PURE__*/ $c207164c875990c8$var$_react.default.createElement($c207164c875990c8$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M13.25 15v-2.25a3 3 0 0 0-3-3h-4.5a3 3 0 0 0-3 3V15m8.5-11a3.25 3.25 0 1 1-6.5 0 3.25 3.25 0 0 1 6.5 0Z"/>`
    }, props));
$c207164c875990c8$var$PersonIcon.displayName = 'PersonIcon';
var $c207164c875990c8$var$_default = module.exports.default = $c207164c875990c8$var$PersonIcon;

});
parcelRegister("kAFi5", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => (parcelRequire("6iTyl")).default);
$parcel$export(module.exports, "Icon", () => (parcelRequire("6iTyl")).Icon);

var $6iTyl = parcelRequire("6iTyl");

});
parcelRegister("6iTyl", function(module, exports) {
$parcel$export(module.exports, "Icon", () => $496f84277c701194$export$f04a61298a47a40f);
$parcel$export(module.exports, "default", () => $496f84277c701194$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5FkrB = parcelRequire("5FkrB");

var $74Zh5 = parcelRequire("74Zh5");

var $dU8Y3 = parcelRequire("dU8Y3");
/**
 * We are hiding this props from consumers as it's reserved
 * for use by Icon Tile.
 */ var $496f84277c701194$var$commonSVGStyles = (0, $74Zh5.css)({
    overflow: 'hidden',
    pointerEvents: 'none',
    /**
   * Stop-color doesn't properly apply in chrome when the inherited/current color changes.
   * We have to initially set stop-color to inherit (either via DOM attribute or an initial CSS
   * rule) and then override it with currentColor for the color changes to be picked up.
   */ // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    stop: {
        stopColor: 'currentColor'
    }
});
var $496f84277c701194$var$svgStyles = (0, $74Zh5.css)({
    color: 'currentColor',
    verticalAlign: 'bottom'
});
var $496f84277c701194$var$iconStyles = (0, $74Zh5.css)({
    display: 'inline-block',
    boxSizing: 'border-box',
    flexShrink: 0,
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: 1,
    paddingInlineEnd: 'var(--ds--button--new-icon-padding-end, 0)',
    paddingInlineStart: 'var(--ds--button--new-icon-padding-start, 0)'
});
var $496f84277c701194$var$utilityIconStyles = (0, $74Zh5.css)({
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: "var(--ds-space-150, 12px)"
});
var $496f84277c701194$var$scaleStyles = (0, $74Zh5.css)({
    width: 'inherit',
    height: 'inherit'
});
/**
 * For windows high contrast mode
 */ var $496f84277c701194$var$baseHcmStyles = (0, $74Zh5.css)({
    '@media screen and (forced-colors: active)': {
        color: 'CanvasText',
        filter: 'grayscale(1)'
    }
});
var $496f84277c701194$var$scaleSize = (0, $74Zh5.css)({
    width: 'inherit',
    height: 'inherit'
});
var $496f84277c701194$var$sizeMap = {
    core: {
        none: (0, $74Zh5.css)({
            width: "var(--ds-space-200, 16px)",
            height: "var(--ds-space-200, 16px)"
        }),
        spacious: (0, $74Zh5.css)({
            width: "var(--ds-space-300, 24px)",
            height: "var(--ds-space-300, 24px)"
        })
    },
    utility: {
        none: (0, $74Zh5.css)({
            width: "var(--ds-space-150, 12px)",
            height: "var(--ds-space-150, 12px)"
        }),
        compact: (0, $74Zh5.css)({
            width: "var(--ds-space-200, 16px)",
            height: "var(--ds-space-200, 16px)"
        }),
        spacious: (0, $74Zh5.css)({
            width: "var(--ds-space-300, 24px)",
            height: "var(--ds-space-300, 24px)"
        })
    }
};
var $496f84277c701194$var$baseSizeMap = {
    core: 16,
    utility: 12
};
var $496f84277c701194$var$paddingMap = {
    core: {
        none: 0,
        spacious: 4
    },
    utility: {
        none: 0,
        compact: 2,
        spacious: 6
    }
};
var $496f84277c701194$export$f04a61298a47a40f = /*#__PURE__*/ (0, $5FkrB.memo)(function Icon(props) {
    var _props$type, _props$spacing3, _props$spacing4;
    var _ref = props, _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, testId = _ref.testId, label = _ref.label, LEGACY_primaryColor = _ref.LEGACY_primaryColor, LEGACY_secondaryColor = _ref.LEGACY_secondaryColor, LEGACY_size = _ref.LEGACY_size, FallbackIcon = _ref.LEGACY_fallbackIcon, dangerouslySetGlyph = _ref.dangerouslySetGlyph, shouldScale = _ref.shouldScale, LEGACY_margin = _ref.LEGACY_margin;
    var dangerouslySetInnerHTML = dangerouslySetGlyph ? {
        __html: dangerouslySetGlyph
    } : undefined;
    // Fall back to old icon
    if (FallbackIcon && !(0, $dU8Y3.fg)('platform-visual-refresh-icons')) // parse out unnecessary props
    return (0, $74Zh5.jsx)(FallbackIcon, {
        primaryColor: LEGACY_primaryColor !== null && LEGACY_primaryColor !== void 0 ? LEGACY_primaryColor : color,
        secondaryColor: LEGACY_secondaryColor,
        size: LEGACY_size,
        label: label,
        testId: testId,
        UNSAFE_margin: LEGACY_margin
    });
    var baseSize = $496f84277c701194$var$baseSizeMap[(_props$type = props.type) !== null && _props$type !== void 0 ? _props$type : 'core'];
    var viewBoxPadding;
    if (props.type === 'utility') {
        var _props$spacing;
        viewBoxPadding = $496f84277c701194$var$paddingMap[props.type][(_props$spacing = props.spacing) !== null && _props$spacing !== void 0 ? _props$spacing : 'none'];
    } else {
        var _props$spacing2;
        viewBoxPadding = $496f84277c701194$var$paddingMap['core'][(_props$spacing2 = props.spacing) !== null && _props$spacing2 !== void 0 ? _props$spacing2 : 'none'];
    }
    var viewBoxSize = baseSize + 2 * viewBoxPadding;
    // Workaround for the transparency in our disabled icon token.
    // Because we have multiple strokes in icons, opacities overlap
    // This filter has an impact on render performance, but this is
    // acceptable as icons aren't commonly disabled en-masse
    var iconColor = color;
    if (dangerouslySetInnerHTML && color === "var(--ds-icon-disabled, #091E424F)") {
        dangerouslySetInnerHTML.__html = "\n<filter id=\"ds-newIconOpacityFilter\">\n  <feFlood flood-color=\"var(--ds-icon-disabled)\" />\n  <feComposite in2=\"SourceGraphic\" operator=\"in\" />\n</filter>\n<g filter=\"url(#ds-newIconOpacityFilter)\">\n  ".concat(dangerouslySetInnerHTML.__html, "\n</g>");
        iconColor = "var(--ds-icon, #44546F)";
    }
    return (0, $74Zh5.jsx)("span", {
        "data-testid": testId,
        role: label ? 'img' : undefined,
        "aria-label": label ? label : undefined,
        "aria-hidden": label ? undefined : true,
        style: {
            color: iconColor
        },
        css: [
            $496f84277c701194$var$iconStyles,
            $496f84277c701194$var$baseHcmStyles,
            shouldScale && $496f84277c701194$var$scaleStyles,
            props.type === 'utility' && $496f84277c701194$var$utilityIconStyles
        ]
    }, (0, $74Zh5.jsx)("svg", {
        fill: "none",
        viewBox: "".concat(0 - viewBoxPadding, " ").concat(0 - viewBoxPadding, " ").concat(viewBoxSize, " ").concat(viewBoxSize),
        role: "presentation",
        css: [
            $496f84277c701194$var$commonSVGStyles,
            $496f84277c701194$var$svgStyles,
            shouldScale ? $496f84277c701194$var$scaleSize : props.type === 'utility' ? $496f84277c701194$var$sizeMap[props.type][(_props$spacing3 = props.spacing) !== null && _props$spacing3 !== void 0 ? _props$spacing3 : 'none'] : $496f84277c701194$var$sizeMap['core'][(_props$spacing4 = props.spacing) !== null && _props$spacing4 !== void 0 ? _props$spacing4 : 'none']
        ],
        dangerouslySetInnerHTML: dangerouslySetInnerHTML
    }));
});
var $496f84277c701194$export$2e2bcd8739ae039 = $496f84277c701194$export$f04a61298a47a40f;

});



parcelRegister("fjELu", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b2684071cf01d70a$var$_react = $b2684071cf01d70a$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $7m1ty = parcelRequire("7m1ty");

var $b2684071cf01d70a$var$_person = $b2684071cf01d70a$var$_interopRequireDefault((parcelRequire("gENTG")));
function $b2684071cf01d70a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $b2684071cf01d70a$var$PersonIcon = (props)=>/*#__PURE__*/ $b2684071cf01d70a$var$_react.default.createElement($7m1ty.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path d="M6 14c0-1.105.902-2 2.009-2h7.982c1.11 0 2.009.894 2.009 2.006v4.44c0 3.405-12 3.405-12 0z"/><circle cx="12" cy="7" r="4"/></g></svg>`
    }, props, {
        newIcon: $b2684071cf01d70a$var$_person.default
    }));
$b2684071cf01d70a$var$PersonIcon.displayName = 'PersonIcon';
var $b2684071cf01d70a$var$_default = module.exports.default = $b2684071cf01d70a$var$PersonIcon;

});
parcelRegister("7m1ty", function(module, exports) {
$parcel$export(module.exports, "IconFacade", () => $55abbb8236b48e91$export$3cfb73f70dfca966);

var $kqp0i = parcelRequire("kqp0i");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");

var $dU8Y3 = parcelRequire("dU8Y3");

var $9d9mx = parcelRequire("9d9mx");
var $55abbb8236b48e91$var$_excluded = [
    "dangerouslySetGlyph"
];
var $55abbb8236b48e91$var$sizeSpacingMap = {
    utility: {
        small: 'compact',
        medium: 'spacious'
    },
    core: {
        small: 'none',
        medium: 'spacious'
    }
};
var $55abbb8236b48e91$export$3cfb73f70dfca966 = /*#__PURE__*/ (0, $5FkrB.memo)(function IconFacade(_ref) {
    var _props$size;
    var dangerouslySetGlyph = _ref.dangerouslySetGlyph, props = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $55abbb8236b48e91$var$_excluded);
    var NewIcon = props.newIcon;
    // By default, the icon size will be medium for core icons and small for utility icons
    var size = (_props$size = props.size) !== null && _props$size !== void 0 ? _props$size : 'medium';
    var useNewIcon = !props.isFacadeDisabled && // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
    (0, $dU8Y3.fg)('platform-visual-refresh-icons-legacy-facade');
    if (useNewIcon && NewIcon && (size === 'small' || size === 'medium')) {
        if (props.iconType === 'utility') {
            var Icon = NewIcon;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(Icon, (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, props, {
                spacing: (0, $dU8Y3.fg)('platform-visual-refresh-icons-facade-button-fix') ? $55abbb8236b48e91$var$sizeSpacingMap['utility'][size] : 'none',
                color: props.primaryColor || 'currentColor',
                type: props.iconType
            }));
        } else {
            var _Icon = NewIcon;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(_Icon, (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, props, {
                spacing: $55abbb8236b48e91$var$sizeSpacingMap['core'][size],
                color: props.primaryColor || 'currentColor',
                type: props.iconType
            }));
        }
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $9d9mx.Icon), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        dangerouslySetGlyph: dangerouslySetGlyph
    }, props));
});

});
parcelRegister("9d9mx", function(module, exports) {
$parcel$export(module.exports, "Icon", () => $6b4c972a7ce3c858$export$f04a61298a47a40f);

var $kqp0i = parcelRequire("kqp0i");

var $25nEq = parcelRequire("25nEq");

var $5FkrB = parcelRequire("5FkrB");

var $74Zh5 = parcelRequire("74Zh5");

var $3eBhS = parcelRequire("3eBhS");

var $fNB8Z = parcelRequire("fNB8Z");
function $6b4c972a7ce3c858$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $6b4c972a7ce3c858$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $6b4c972a7ce3c858$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $6b4c972a7ce3c858$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
/**
 * We are hiding these props from consumers as they're used to
 * hack around icon sizing specifically for icon-file-type.
 */ var $6b4c972a7ce3c858$var$iconStyles = (0, $74Zh5.css)({
    display: 'inline-block',
    flexShrink: 0,
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: 1,
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '> svg': $6b4c972a7ce3c858$var$_objectSpread($6b4c972a7ce3c858$var$_objectSpread({}, (0, $3eBhS.commonSVGStyles)), {}, {
        maxWidth: '100%',
        maxHeight: '100%',
        color: 'var(--icon-primary-color)',
        fill: 'var(--icon-secondary-color)',
        verticalAlign: 'bottom'
    })
});
/**
 * For windows high contrast mode
 */ var $6b4c972a7ce3c858$var$baseHcmStyles = (0, $74Zh5.css)({
    '@media screen and (forced-colors: active)': {
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '> svg': {
            filter: 'grayscale(1)',
            '--icon-primary-color': 'CanvasText',
            // foreground
            '--icon-secondary-color': 'Canvas' // background
        }
    }
});
var $6b4c972a7ce3c858$var$primaryEqualsSecondaryHcmStyles = (0, $74Zh5.css)({
    '@media screen and (forced-colors: active)': {
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '> svg': {
            // if the primaryColor is the same as the secondaryColor we
            // set the --icon-primary-color to Canvas
            // this is usually to convey state i.e. Checkbox checked -> not checked
            '--icon-primary-color': 'Canvas' // foreground
        }
    }
});
var $6b4c972a7ce3c858$var$secondaryTransparentHcmStyles = (0, $74Zh5.css)({
    '@media screen and (forced-colors: active)': {
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '> svg': {
            '--icon-secondary-color': 'transparent' // background
        }
    }
});
var $6b4c972a7ce3c858$export$f04a61298a47a40f = /*#__PURE__*/ (0, $5FkrB.memo)(function Icon(props) {
    var _ref = props, Glyph = _ref.glyph, dangerouslySetGlyph = _ref.dangerouslySetGlyph, _ref$primaryColor = _ref.primaryColor, primaryColor = _ref$primaryColor === void 0 ? 'currentColor' : _ref$primaryColor, secondaryColor = _ref.secondaryColor, size = _ref.size, testId = _ref.testId, label = _ref.label, width = _ref.width, height = _ref.height, UNSAFE_margin = _ref.UNSAFE_margin;
    var glyphProps = dangerouslySetGlyph ? {
        dangerouslySetInnerHTML: {
            __html: dangerouslySetGlyph
        }
    } : {
        children: Glyph ? (0, $74Zh5.jsx)(Glyph, {
            role: "presentation"
        }) : null
    };
    var dimensions = (0, $3eBhS.getIconSize)({
        width: width,
        height: height,
        size: size
    });
    return (0, $74Zh5.jsx)("span", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        "data-testid": testId,
        "data-vc": "icon-".concat(testId),
        role: label ? 'img' : undefined,
        "aria-label": label ? label : undefined,
        "aria-hidden": label ? undefined : true,
        style: {
            '--icon-primary-color': primaryColor,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            '--icon-secondary-color': secondaryColor || (0, $fNB8Z.getBackground)(),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            margin: UNSAFE_margin
        }
    }, glyphProps, {
        css: [
            $6b4c972a7ce3c858$var$iconStyles,
            $6b4c972a7ce3c858$var$baseHcmStyles,
            primaryColor === secondaryColor && $6b4c972a7ce3c858$var$primaryEqualsSecondaryHcmStyles,
            secondaryColor === 'transparent' && $6b4c972a7ce3c858$var$secondaryTransparentHcmStyles,
            // NB: This can be resolved if this component, composes base SVG / and/or skeleton
            // We could then simplify how common styles are dealt with simply by encapsulating them
            // at their appropriate level and/or having a singular approach to css variables in the package
            dimensions && // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $74Zh5.css)({
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                width: dimensions.width,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                height: dimensions.height,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                '> svg': dimensions
            })
        ]
    }));
});
var $6b4c972a7ce3c858$export$2e2bcd8739ae039 = $6b4c972a7ce3c858$export$f04a61298a47a40f;

});
parcelRegister("3eBhS", function(module, exports) {
$parcel$export(module.exports, "commonSVGStyles", () => $25af9a65d34ebc51$export$16374db1c3e6dfba);
$parcel$export(module.exports, "getIconSize", () => $25af9a65d34ebc51$export$3eb7d6130acfda37);

var $d4aiZ = parcelRequire("d4aiZ");

var $74Zh5 = parcelRequire("74Zh5");
var $25af9a65d34ebc51$export$16374db1c3e6dfba = {
    overflow: 'hidden',
    pointerEvents: 'none',
    /**
   * Stop-color doesn't properly apply in chrome when the inherited/current color changes.
   * We have to initially set stop-color to inherit (either via DOM attribute or an initial CSS
   * rule) and then override it with currentColor for the color changes to be picked up.
   */ stop: {
        stopColor: 'currentColor'
    }
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
var $25af9a65d34ebc51$var$smallStyles = (0, $74Zh5.css)((0, $d4aiZ.dimensions).small);
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
var $25af9a65d34ebc51$var$mediumStyles = (0, $74Zh5.css)((0, $d4aiZ.dimensions).medium);
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
var $25af9a65d34ebc51$var$largeStyles = (0, $74Zh5.css)((0, $d4aiZ.dimensions).large);
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
var $25af9a65d34ebc51$var$xlargeStyles = (0, $74Zh5.css)((0, $d4aiZ.dimensions).xlarge);
var $25af9a65d34ebc51$export$ef0ad74202575b64 = {
    small: $25af9a65d34ebc51$var$smallStyles,
    medium: $25af9a65d34ebc51$var$mediumStyles,
    large: $25af9a65d34ebc51$var$largeStyles,
    xlarge: $25af9a65d34ebc51$var$xlargeStyles
};
var $25af9a65d34ebc51$export$3eb7d6130acfda37 = function getIconSize(_ref) {
    var width = _ref.width, height = _ref.height, size = _ref.size;
    if (width && height) return {
        width: width,
        height: height
    };
    if (size) return (0, $d4aiZ.dimensions)[size];
    return undefined;
};

});
parcelRegister("d4aiZ", function(module, exports) {
$parcel$export(module.exports, "dimensions", () => $9833a482098f67bb$export$62ad7b0c781000e9);
var $9833a482098f67bb$export$c647cb0ee6e282fe = {
    small: '16px',
    medium: '24px',
    large: '32px',
    xlarge: '48px'
};
var $9833a482098f67bb$export$7bd66fc94c81bf84 = {
    small: 'small',
    medium: 'medium',
    large: 'large',
    xlarge: 'xlarge'
};
var $9833a482098f67bb$export$62ad7b0c781000e9 = {
    small: {
        width: $9833a482098f67bb$export$c647cb0ee6e282fe.small,
        height: $9833a482098f67bb$export$c647cb0ee6e282fe.small
    },
    medium: {
        width: $9833a482098f67bb$export$c647cb0ee6e282fe.medium,
        height: $9833a482098f67bb$export$c647cb0ee6e282fe.medium
    },
    large: {
        width: $9833a482098f67bb$export$c647cb0ee6e282fe.large,
        height: $9833a482098f67bb$export$c647cb0ee6e282fe.large
    },
    xlarge: {
        width: $9833a482098f67bb$export$c647cb0ee6e282fe.xlarge,
        height: $9833a482098f67bb$export$c647cb0ee6e282fe.xlarge
    }
};

});


parcelRegister("fNB8Z", function(module, exports) {
$parcel$export(module.exports, "getBackground", () => $b8083eaafc730cc5$export$18cb9425622d4e06);
var $b8083eaafc730cc5$export$18cb9425622d4e06 = function getBackground() {
    return "var(--ds-surface, #FFFFFF)";
};

});




parcelRegister("3w44K", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::08061a6d953c7d73b57c2e6e0bdac389>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $28f78592181d8380$var$_react = $28f78592181d8380$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $28f78592181d8380$var$_baseNew = $28f78592181d8380$var$_interopRequireDefault((parcelRequire("kAFi5")));
function $28f78592181d8380$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Release".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for releases in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $28f78592181d8380$var$ReleaseIcon = (props)=>/*#__PURE__*/ $28f78592181d8380$var$_react.default.createElement($28f78592181d8380$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="M.75 7.75V7a.75.75 0 0 0-.75.75zm14.5 0 .646.382A.75.75 0 0 0 15.25 7zm-12.5-3V4a.75.75 0 0 0-.75.75zm6.25 0 .648-.378A.75.75 0 0 0 9 4zm-4.25-2V2H4v.75zm1.5 0H7V2h-.75zm6.113 9.886.646.382zm2.241-5.268-2.887 4.886 1.292.764 2.887-4.886zM11.287 12.5H2V14h9.287zM1.5 12V7.75H0V12zM.75 8.5h2V7h-2zm2.75-.75v-3H2v3zm-.75.75h8V7h-8zm8 0h4.5V7h-4.5zM8.352 5.128l1.75 3 1.296-.756-1.75-3zM2.75 5.5h2V4h-2zm2.75-.75v-2H4v2zM4.75 3.5h1.5V2h-1.5zm0 2h1.5V4h-1.5zm1.5 0H9V4H6.25zM5.5 2.75v2H7v-2zM2 12.5a.5.5 0 0 1-.5-.5H0a2 2 0 0 0 2 2zm9.717-.246a.5.5 0 0 1-.43.246V14a2 2 0 0 0 1.722-.982z"/>`
    }, props));
$28f78592181d8380$var$ReleaseIcon.displayName = 'ReleaseIcon';
var $28f78592181d8380$var$_default = module.exports.default = $28f78592181d8380$var$ReleaseIcon;

});

parcelRegister("7EoFn", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $591f670c7fd4f4ae$var$_react = $591f670c7fd4f4ae$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $7m1ty = parcelRequire("7m1ty");

var $591f670c7fd4f4ae$var$_release = $591f670c7fd4f4ae$var$_interopRequireDefault((parcelRequire("3w44K")));
function $591f670c7fd4f4ae$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $591f670c7fd4f4ae$var$ShipIcon = (props)=>/*#__PURE__*/ $591f670c7fd4f4ae$var$_react.default.createElement($7m1ty.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path fill-rule="nonzero" d="M6 12h8v-2H6zM4 8.99C4 8.445 4.456 8 5.002 8h9.996C15.55 8 16 8.451 16 8.99V14H4z"/><path d="M6 7.005C6 5.898 6.898 5 7.998 5h2.004C11.106 5 12 5.894 12 7.005V10H6zm4 0V7H7.999c.005 0 .002.003.002.005V8h2z"/><path fill-rule="nonzero" d="M4.5 17h13.994l1.002-3H4.14zm-2.495-4.012A.862.862 0 0 1 2.883 12h18.393c.55 0 .857.417.681.944l-1.707 5.112c-.174.521-.758.944-1.315.944H3.725a1.15 1.15 0 0 1-1.118-.988z"/></g></svg>`
    }, props, {
        newIcon: $591f670c7fd4f4ae$var$_release.default
    }));
$591f670c7fd4f4ae$var$ShipIcon.displayName = 'ShipIcon';
var $591f670c7fd4f4ae$var$_default = module.exports.default = $591f670c7fd4f4ae$var$ShipIcon;

});

parcelRegister("69J3E", function(module, exports) {
$parcel$export(module.exports, "default", () => $47b688e257f5d676$export$2e2bcd8739ae039);

var $49WdW = parcelRequire("49WdW");

var $47b688e257f5d676$export$2e2bcd8739ae039 = (0, $49WdW.default);

});
parcelRegister("49WdW", function(module, exports) {
$parcel$export(module.exports, "default", () => $30752ab56a6a5229$export$2e2bcd8739ae039);

var $kuWQN = parcelRequire("kuWQN");

var $d1G9Q = parcelRequire("d1G9Q");

var $5FkrB = parcelRequire("5FkrB");

var $77PHu = parcelRequire("77PHu");

var $1Pqk6 = parcelRequire("1Pqk6");
var $30752ab56a6a5229$var$FocusLockCombination = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function FocusLockUICombination(props, ref) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $77PHu.default), (0, $d1G9Q.default)({
        sideCar: (0, $1Pqk6.default),
        ref: ref
    }, props));
});
var $30752ab56a6a5229$var$_ref = (0, $77PHu.default).propTypes || {}, $30752ab56a6a5229$var$sideCar = $30752ab56a6a5229$var$_ref.sideCar, $30752ab56a6a5229$var$propTypes = (0, $kuWQN.default)($30752ab56a6a5229$var$_ref, [
    "sideCar"
]);
$30752ab56a6a5229$var$FocusLockCombination.propTypes = {};
var $30752ab56a6a5229$export$2e2bcd8739ae039 = $30752ab56a6a5229$var$FocusLockCombination;

});
parcelRegister("kuWQN", function(module, exports) {
$parcel$export(module.exports, "default", () => $eec4427b8bcf239c$export$2e2bcd8739ae039);
function $eec4427b8bcf239c$export$2e2bcd8739ae039(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}

});

parcelRegister("77PHu", function(module, exports) {
$parcel$export(module.exports, "default", () => $53014a7bddb695f5$export$2e2bcd8739ae039);

var $d1G9Q = parcelRequire("d1G9Q");

var $5FkrB = parcelRequire("5FkrB");


var $a9Isk = parcelRequire("a9Isk");

var $8X9rs = parcelRequire("8X9rs");

var $h6OtI = parcelRequire("h6OtI");

var $ljihP = parcelRequire("ljihP");

var $g4LL1 = parcelRequire("g4LL1");
var $53014a7bddb695f5$var$emptyArray = [];
var $53014a7bddb695f5$var$FocusLock = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function FocusLockUI(props, parentRef) {
    var _extends2;
    var _useState = (0, $5FkrB.useState)(), realObserved = _useState[0], setObserved = _useState[1];
    var observed = (0, $5FkrB.useRef)();
    var isActive = (0, $5FkrB.useRef)(false);
    var originalFocusedElement = (0, $5FkrB.useRef)(null);
    var _useState2 = (0, $5FkrB.useState)({}), update = _useState2[1];
    var children = props.children, _props$disabled = props.disabled, disabled = _props$disabled === void 0 ? false : _props$disabled, _props$noFocusGuards = props.noFocusGuards, noFocusGuards = _props$noFocusGuards === void 0 ? false : _props$noFocusGuards, _props$persistentFocu = props.persistentFocus, persistentFocus = _props$persistentFocu === void 0 ? false : _props$persistentFocu, _props$crossFrame = props.crossFrame, crossFrame = _props$crossFrame === void 0 ? true : _props$crossFrame, _props$autoFocus = props.autoFocus, autoFocus = _props$autoFocus === void 0 ? true : _props$autoFocus, allowTextSelection = props.allowTextSelection, group = props.group, className = props.className, whiteList = props.whiteList, hasPositiveIndices = props.hasPositiveIndices, _props$shards = props.shards, shards = _props$shards === void 0 ? $53014a7bddb695f5$var$emptyArray : _props$shards, _props$as = props.as, Container = _props$as === void 0 ? 'div' : _props$as, _props$lockProps = props.lockProps, containerProps = _props$lockProps === void 0 ? {} : _props$lockProps, SideCar = props.sideCar, _props$returnFocus = props.returnFocus, shouldReturnFocus = _props$returnFocus === void 0 ? false : _props$returnFocus, focusOptions = props.focusOptions, onActivationCallback = props.onActivation, onDeactivationCallback = props.onDeactivation;
    var _useState3 = (0, $5FkrB.useState)({}), id = _useState3[0];
    var onActivation = (0, $5FkrB.useCallback)(function(_ref) {
        var captureFocusRestore = _ref.captureFocusRestore;
        if (!originalFocusedElement.current) {
            var _document;
            var activeElement = (_document = document) == null ? void 0 : _document.activeElement;
            originalFocusedElement.current = activeElement;
            if (activeElement !== document.body) originalFocusedElement.current = captureFocusRestore(activeElement);
        }
        if (observed.current && onActivationCallback) onActivationCallback(observed.current);
        isActive.current = true;
        update();
    }, [
        onActivationCallback
    ]);
    var onDeactivation = (0, $5FkrB.useCallback)(function() {
        isActive.current = false;
        if (onDeactivationCallback) onDeactivationCallback(observed.current);
        update();
    }, [
        onDeactivationCallback
    ]);
    var returnFocus = (0, $5FkrB.useCallback)(function(allowDefer) {
        var focusRestore = originalFocusedElement.current;
        if (focusRestore) {
            var returnFocusTo = (typeof focusRestore === 'function' ? focusRestore() : focusRestore) || document.body;
            var howToReturnFocus = typeof shouldReturnFocus === 'function' ? shouldReturnFocus(returnFocusTo) : shouldReturnFocus;
            if (howToReturnFocus) {
                var returnFocusOptions = typeof howToReturnFocus === 'object' ? howToReturnFocus : undefined;
                originalFocusedElement.current = null;
                if (allowDefer) Promise.resolve().then(function() {
                    return returnFocusTo.focus(returnFocusOptions);
                });
                else returnFocusTo.focus(returnFocusOptions);
            }
        }
    }, [
        shouldReturnFocus
    ]);
    var onFocus = (0, $5FkrB.useCallback)(function(event) {
        if (isActive.current) (0, $ljihP.mediumFocus).useMedium(event);
    }, []);
    var onBlur = (0, $ljihP.mediumBlur).useMedium;
    var setObserveNode = (0, $5FkrB.useCallback)(function(newObserved) {
        if (observed.current !== newObserved) {
            observed.current = newObserved;
            setObserved(newObserved);
        }
    }, []);
    var lockProps = (0, $d1G9Q.default)((_extends2 = {}, _extends2[0, $a9Isk.FOCUS_DISABLED] = disabled && 'disabled', _extends2[0, $a9Isk.FOCUS_GROUP] = group, _extends2), containerProps);
    var hasLeadingGuards = noFocusGuards !== true;
    var hasTailingGuards = hasLeadingGuards && noFocusGuards !== 'tail';
    var mergedRef = (0, $8X9rs.useMergeRefs)([
        parentRef,
        setObserveNode
    ]);
    var focusScopeValue = (0, $5FkrB.useMemo)(function() {
        return {
            observed: observed,
            shards: shards,
            enabled: !disabled,
            get active () {
                return isActive.current;
            }
        };
    }, [
        disabled,
        isActive,
        shards,
        observed
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $5FkrB.Fragment), null, hasLeadingGuards && [
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("div", {
            key: "guard-first",
            "data-focus-guard": true,
            tabIndex: disabled ? -1 : 0,
            style: (0, $h6OtI.hiddenGuard)
        }),
        hasPositiveIndices ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("div", {
            key: "guard-nearest",
            "data-focus-guard": true,
            tabIndex: disabled ? -1 : 1,
            style: (0, $h6OtI.hiddenGuard)
        }) : null
    ], !disabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(SideCar, {
        id: id,
        sideCar: (0, $ljihP.mediumSidecar),
        observed: realObserved,
        disabled: disabled,
        persistentFocus: persistentFocus,
        crossFrame: crossFrame,
        autoFocus: autoFocus,
        whiteList: whiteList,
        shards: shards,
        onActivation: onActivation,
        onDeactivation: onDeactivation,
        returnFocus: returnFocus,
        focusOptions: focusOptions,
        noFocusGuards: noFocusGuards
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(Container, (0, $d1G9Q.default)({
        ref: mergedRef
    }, lockProps, {
        className: className,
        onBlur: onBlur,
        onFocus: onFocus
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $g4LL1.focusScope).Provider, {
        value: focusScopeValue
    }, children)), hasTailingGuards && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("div", {
        "data-focus-guard": true,
        tabIndex: disabled ? -1 : 0,
        style: (0, $h6OtI.hiddenGuard)
    }));
});
$53014a7bddb695f5$var$FocusLock.propTypes = {};
var $53014a7bddb695f5$export$2e2bcd8739ae039 = $53014a7bddb695f5$var$FocusLock;

});
parcelRegister("a9Isk", function(module, exports) {
$parcel$export(module.exports, "FOCUS_GROUP", () => $764d3aac8890a574$export$4f9a06cb7441a087);
$parcel$export(module.exports, "FOCUS_DISABLED", () => $764d3aac8890a574$export$aeda8252e54b50f7);
$parcel$export(module.exports, "FOCUS_ALLOW", () => $764d3aac8890a574$export$54ecf528c58f9ef6);
$parcel$export(module.exports, "FOCUS_AUTO", () => $764d3aac8890a574$export$70e9b4a1820af101);
$parcel$export(module.exports, "FOCUS_NO_AUTOFOCUS", () => $764d3aac8890a574$export$134ebef29fd94853);
/**
 * defines a focus group
 */ var $764d3aac8890a574$export$4f9a06cb7441a087 = 'data-focus-lock';
var $764d3aac8890a574$export$aeda8252e54b50f7 = 'data-focus-lock-disabled';
var $764d3aac8890a574$export$54ecf528c58f9ef6 = 'data-no-focus-lock';
var $764d3aac8890a574$export$70e9b4a1820af101 = 'data-autofocus-inside';
var $764d3aac8890a574$export$134ebef29fd94853 = 'data-no-autofocus';

});

parcelRegister("8X9rs", function(module, exports) {
$parcel$export(module.exports, "useMergeRefs", () => $684b28614ec143a7$export$74665b213cb5c4cf);

var $5FkrB = parcelRequire("5FkrB");

var $eurAs = parcelRequire("eurAs");

var $kdfIQ = parcelRequire("kdfIQ");
var $684b28614ec143a7$var$useIsomorphicLayoutEffect = typeof window !== 'undefined' ? $5FkrB.useLayoutEffect : $5FkrB.useEffect;
var $684b28614ec143a7$var$currentValues = new WeakMap();
function $684b28614ec143a7$export$74665b213cb5c4cf(refs, defaultValue) {
    var callbackRef = (0, $kdfIQ.useCallbackRef)(defaultValue || null, function(newValue) {
        return refs.forEach(function(ref) {
            return (0, $eurAs.assignRef)(ref, newValue);
        });
    });
    // handle refs changes - added or removed
    $684b28614ec143a7$var$useIsomorphicLayoutEffect(function() {
        var oldValue = $684b28614ec143a7$var$currentValues.get(callbackRef);
        if (oldValue) {
            var prevRefs_1 = new Set(oldValue);
            var nextRefs_1 = new Set(refs);
            var current_1 = callbackRef.current;
            prevRefs_1.forEach(function(ref) {
                if (!nextRefs_1.has(ref)) (0, $eurAs.assignRef)(ref, null);
            });
            nextRefs_1.forEach(function(ref) {
                if (!prevRefs_1.has(ref)) (0, $eurAs.assignRef)(ref, current_1);
            });
        }
        $684b28614ec143a7$var$currentValues.set(callbackRef, refs);
    }, [
        refs
    ]);
    return callbackRef;
}

});
parcelRegister("eurAs", function(module, exports) {
$parcel$export(module.exports, "assignRef", () => $a8c944370e1d2a09$export$d734136a7b018efe);
/**
 * Assigns a value for a given ref, no matter of the ref format
 * @param {RefObject} ref - a callback function or ref object
 * @param value - a new value
 *
 * @see https://github.com/theKashey/use-callback-ref#assignref
 * @example
 * const refObject = useRef();
 * const refFn = (ref) => {....}
 *
 * assignRef(refObject, "refValue");
 * assignRef(refFn, "refValue");
 */ function $a8c944370e1d2a09$export$d734136a7b018efe(ref, value) {
    if (typeof ref === 'function') ref(value);
    else if (ref) ref.current = value;
    return ref;
}

});

parcelRegister("kdfIQ", function(module, exports) {
$parcel$export(module.exports, "useCallbackRef", () => $eb7137ab9f133859$export$25bec8c6f54ee79a);

var $5FkrB = parcelRequire("5FkrB");
function $eb7137ab9f133859$export$25bec8c6f54ee79a(initialValue, callback) {
    var ref = (0, $5FkrB.useState)(function() {
        return {
            // value
            value: initialValue,
            // last callback
            callback: callback,
            // "memoized" public interface
            facade: {
                get current () {
                    return ref.value;
                },
                set current (value){
                    var last = ref.value;
                    if (last !== value) {
                        ref.value = value;
                        ref.callback(value, last);
                    }
                }
            }
        };
    })[0];
    // update callback
    ref.callback = callback;
    return ref.facade;
}

});


parcelRegister("h6OtI", function(module, exports) {
$parcel$export(module.exports, "hiddenGuard", () => $c74a27259105fd78$export$b8c7b07253306600);

var $5FkrB = parcelRequire("5FkrB");

var $c74a27259105fd78$export$b8c7b07253306600 = {
    width: '1px',
    height: '0px',
    padding: 0,
    overflow: 'hidden',
    position: 'fixed',
    top: '1px',
    left: '1px'
};
var $c74a27259105fd78$var$InFocusGuard = function InFocusGuard(_ref) {
    var _ref$children = _ref.children, children = _ref$children === void 0 ? null : _ref$children;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $5FkrB.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("div", {
        key: "guard-first",
        "data-focus-guard": true,
        "data-focus-auto-guard": true,
        style: $c74a27259105fd78$export$b8c7b07253306600
    }), children, children && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("div", {
        key: "guard-last",
        "data-focus-guard": true,
        "data-focus-auto-guard": true,
        style: $c74a27259105fd78$export$b8c7b07253306600
    }));
};
$c74a27259105fd78$var$InFocusGuard.propTypes = {};
var $c74a27259105fd78$export$2e2bcd8739ae039 = $c74a27259105fd78$var$InFocusGuard;

});

parcelRegister("ljihP", function(module, exports) {
$parcel$export(module.exports, "mediumFocus", () => $f8398ea4b64234e0$export$5733e022b1d538cb);
$parcel$export(module.exports, "mediumBlur", () => $f8398ea4b64234e0$export$b3e9a9312f73723c);
$parcel$export(module.exports, "mediumEffect", () => $f8398ea4b64234e0$export$3a1d52767cbc07b8);
$parcel$export(module.exports, "mediumSidecar", () => $f8398ea4b64234e0$export$892cbf28e5518020);

var $6QSj6 = parcelRequire("6QSj6");
var $f8398ea4b64234e0$export$5733e022b1d538cb = (0, $6QSj6.createMedium)({}, function(_ref) {
    var target = _ref.target, currentTarget = _ref.currentTarget;
    return {
        target: target,
        currentTarget: currentTarget
    };
});
var $f8398ea4b64234e0$export$b3e9a9312f73723c = (0, $6QSj6.createMedium)();
var $f8398ea4b64234e0$export$3a1d52767cbc07b8 = (0, $6QSj6.createMedium)();
var $f8398ea4b64234e0$export$892cbf28e5518020 = (0, $6QSj6.createSidecarMedium)({
    async: true,
    ssr: typeof document !== 'undefined'
});

});
parcelRegister("6QSj6", function(module, exports) {
$parcel$export(module.exports, "createMedium", () => $4fd1b9ad472e40cb$export$9ffbfcaf067b02c6);
$parcel$export(module.exports, "createSidecarMedium", () => $4fd1b9ad472e40cb$export$e13ec7dd7a14088d);

var $l2Z7B = parcelRequire("l2Z7B");
function $4fd1b9ad472e40cb$var$ItoI(a) {
    return a;
}
function $4fd1b9ad472e40cb$var$innerCreateMedium(defaults, middleware) {
    if (middleware === void 0) middleware = $4fd1b9ad472e40cb$var$ItoI;
    var buffer = [];
    var assigned = false;
    var medium = {
        read: function() {
            if (assigned) throw new Error('Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.');
            if (buffer.length) return buffer[buffer.length - 1];
            return defaults;
        },
        useMedium: function(data) {
            var item = middleware(data, assigned);
            buffer.push(item);
            return function() {
                buffer = buffer.filter(function(x) {
                    return x !== item;
                });
            };
        },
        assignSyncMedium: function(cb) {
            assigned = true;
            while(buffer.length){
                var cbs = buffer;
                buffer = [];
                cbs.forEach(cb);
            }
            buffer = {
                push: function(x) {
                    return cb(x);
                },
                filter: function() {
                    return buffer;
                }
            };
        },
        assignMedium: function(cb) {
            assigned = true;
            var pendingQueue = [];
            if (buffer.length) {
                var cbs = buffer;
                buffer = [];
                cbs.forEach(cb);
                pendingQueue = buffer;
            }
            var executeQueue = function() {
                var cbs = pendingQueue;
                pendingQueue = [];
                cbs.forEach(cb);
            };
            var cycle = function() {
                return Promise.resolve().then(executeQueue);
            };
            cycle();
            buffer = {
                push: function(x) {
                    pendingQueue.push(x);
                    cycle();
                },
                filter: function(filter) {
                    pendingQueue = pendingQueue.filter(filter);
                    return buffer;
                }
            };
        }
    };
    return medium;
}
function $4fd1b9ad472e40cb$export$9ffbfcaf067b02c6(defaults, middleware) {
    if (middleware === void 0) middleware = $4fd1b9ad472e40cb$var$ItoI;
    return $4fd1b9ad472e40cb$var$innerCreateMedium(defaults, middleware);
}
function $4fd1b9ad472e40cb$export$e13ec7dd7a14088d(options) {
    if (options === void 0) options = {};
    var medium = $4fd1b9ad472e40cb$var$innerCreateMedium(null);
    medium.options = (0, $l2Z7B.__assign)({
        async: true,
        ssr: false
    }, options);
    return medium;
}

});


parcelRegister("g4LL1", function(module, exports) {
$parcel$export(module.exports, "focusScope", () => $bb4210ad376d9407$export$f5272e9b1168239c);

var $5FkrB = parcelRequire("5FkrB");
var $bb4210ad376d9407$export$f5272e9b1168239c = /*#__PURE__*/ (0, $5FkrB.createContext)(undefined);

});


parcelRegister("1Pqk6", function(module, exports) {
$parcel$export(module.exports, "default", () => $154ef9172a209d8a$export$2e2bcd8739ae039);

var $5FkrB = parcelRequire("5FkrB");


var $i7ZOa = parcelRequire("i7ZOa");

var $3LvY8 = parcelRequire("3LvY8");
var $gWC5V = parcelRequire("gWC5V");
var $738X1 = parcelRequire("738X1");
var $chs63 = parcelRequire("chs63");
var $75ruL = parcelRequire("75ruL");
var $4YVKI = parcelRequire("4YVKI");parcelRequire("cHP2I");
var $i8qpR = parcelRequire("i8qpR");

var $65prp = parcelRequire("65prp");

var $ljihP = parcelRequire("ljihP");
var $154ef9172a209d8a$var$focusOnBody = function focusOnBody() {
    return document && document.activeElement === document.body;
};
var $154ef9172a209d8a$var$isFreeFocus = function isFreeFocus() {
    return $154ef9172a209d8a$var$focusOnBody() || (0, $75ruL.focusIsHidden)();
};
var $154ef9172a209d8a$var$lastActiveTrap = null;
var $154ef9172a209d8a$var$lastActiveFocus = null;
var $154ef9172a209d8a$var$tryRestoreFocus = function tryRestoreFocus() {
    return null;
};
var $154ef9172a209d8a$var$lastPortaledElement = null;
var $154ef9172a209d8a$var$focusWasOutsideWindow = false;
var $154ef9172a209d8a$var$windowFocused = false;
var $154ef9172a209d8a$var$defaultWhitelist = function defaultWhitelist() {
    return true;
};
var $154ef9172a209d8a$var$focusWhitelisted = function focusWhitelisted(activeElement) {
    return ($154ef9172a209d8a$var$lastActiveTrap.whiteList || $154ef9172a209d8a$var$defaultWhitelist)(activeElement);
};
var $154ef9172a209d8a$var$recordPortal = function recordPortal(observerNode, portaledElement) {
    $154ef9172a209d8a$var$lastPortaledElement = {
        observerNode: observerNode,
        portaledElement: portaledElement
    };
};
var $154ef9172a209d8a$var$focusIsPortaledPair = function focusIsPortaledPair(element) {
    return $154ef9172a209d8a$var$lastPortaledElement && $154ef9172a209d8a$var$lastPortaledElement.portaledElement === element;
};
function $154ef9172a209d8a$var$autoGuard(startIndex, end, step, allNodes) {
    var lastGuard = null;
    var i = startIndex;
    do {
        var item = allNodes[i];
        if (item.guard) {
            if (item.node.dataset.focusAutoGuard) lastGuard = item;
        } else if (item.lockItem) {
            if (i !== startIndex) return;
            lastGuard = null;
        } else break;
    }while ((i += step) !== end);
    if (lastGuard) lastGuard.node.tabIndex = 0;
}
var $154ef9172a209d8a$var$focusWasOutside = function focusWasOutside(crossFrameOption) {
    if (crossFrameOption) return Boolean($154ef9172a209d8a$var$focusWasOutsideWindow);
    return $154ef9172a209d8a$var$focusWasOutsideWindow === 'meanwhile';
};
var $154ef9172a209d8a$var$checkInHost = function checkInHost(check, el, boundary) {
    return el && (el.host === check && (!el.activeElement || boundary.contains(el.activeElement)) || el.parentNode && checkInHost(check, el.parentNode, boundary));
};
var $154ef9172a209d8a$var$withinHost = function withinHost(activeElement, workingArea) {
    return workingArea.some(function(area) {
        return $154ef9172a209d8a$var$checkInHost(activeElement, area, area);
    });
};
var $154ef9172a209d8a$var$getNodeFocusables = function getNodeFocusables(nodes) {
    return (0, $4YVKI.getFocusableNodes)(nodes, new Map());
};
var $154ef9172a209d8a$var$isNotFocusable = function isNotFocusable(node) {
    return !$154ef9172a209d8a$var$getNodeFocusables([
        node.parentNode
    ]).some(function(el) {
        return el.node === node;
    });
};
var $154ef9172a209d8a$var$activateTrap = function activateTrap() {
    var result = false;
    if ($154ef9172a209d8a$var$lastActiveTrap) {
        var _lastActiveTrap = $154ef9172a209d8a$var$lastActiveTrap, observed = _lastActiveTrap.observed, persistentFocus = _lastActiveTrap.persistentFocus, autoFocus = _lastActiveTrap.autoFocus, shards = _lastActiveTrap.shards, crossFrame = _lastActiveTrap.crossFrame, focusOptions = _lastActiveTrap.focusOptions, noFocusGuards = _lastActiveTrap.noFocusGuards;
        var workingNode = observed || $154ef9172a209d8a$var$lastPortaledElement && $154ef9172a209d8a$var$lastPortaledElement.portaledElement;
        if ($154ef9172a209d8a$var$focusOnBody() && $154ef9172a209d8a$var$lastActiveFocus && $154ef9172a209d8a$var$lastActiveFocus !== document.body) {
            if (!document.body.contains($154ef9172a209d8a$var$lastActiveFocus) || $154ef9172a209d8a$var$isNotFocusable($154ef9172a209d8a$var$lastActiveFocus)) {
                var newTarget = $154ef9172a209d8a$var$tryRestoreFocus();
                if (newTarget) newTarget.focus();
            }
        }
        var activeElement = document && document.activeElement;
        if (workingNode) {
            var workingArea = [
                workingNode
            ].concat(shards.map((0, $65prp.extractRef)).filter(Boolean));
            var shouldForceRestoreFocus = function shouldForceRestoreFocus() {
                if (!$154ef9172a209d8a$var$focusWasOutside(crossFrame) || !noFocusGuards || !$154ef9172a209d8a$var$lastActiveFocus || $154ef9172a209d8a$var$windowFocused) return false;
                var nodes = $154ef9172a209d8a$var$getNodeFocusables(workingArea);
                var lastIndex = nodes.findIndex(function(_ref) {
                    var node = _ref.node;
                    return node === $154ef9172a209d8a$var$lastActiveFocus;
                });
                return lastIndex === 0 || lastIndex === nodes.length - 1;
            };
            if (!activeElement || $154ef9172a209d8a$var$focusWhitelisted(activeElement)) {
                if (persistentFocus || shouldForceRestoreFocus() || !$154ef9172a209d8a$var$isFreeFocus() || !$154ef9172a209d8a$var$lastActiveFocus && autoFocus) {
                    if (workingNode && !((0, $chs63.focusInside)(workingArea) || activeElement && $154ef9172a209d8a$var$withinHost(activeElement, workingArea) || $154ef9172a209d8a$var$focusIsPortaledPair(activeElement, workingNode))) {
                        if (document && !$154ef9172a209d8a$var$lastActiveFocus && activeElement && !autoFocus) {
                            if (activeElement.blur) activeElement.blur();
                            document.body.focus();
                        } else {
                            result = (0, $i8qpR.moveFocusInside)(workingArea, $154ef9172a209d8a$var$lastActiveFocus, {
                                focusOptions: focusOptions
                            });
                            $154ef9172a209d8a$var$lastPortaledElement = {};
                        }
                    }
                    $154ef9172a209d8a$var$lastActiveFocus = document && document.activeElement;
                    if ($154ef9172a209d8a$var$lastActiveFocus !== document.body) $154ef9172a209d8a$var$tryRestoreFocus = (0, $3LvY8.captureFocusRestore)($154ef9172a209d8a$var$lastActiveFocus);
                    $154ef9172a209d8a$var$focusWasOutsideWindow = false;
                }
            }
            if (document && activeElement !== document.activeElement && document.querySelector('[data-focus-auto-guard]')) {
                var newActiveElement = document && document.activeElement;
                var allNodes = (0, $gWC5V.expandFocusableNodes)(workingArea);
                var focusedIndex = allNodes.map(function(_ref2) {
                    var node = _ref2.node;
                    return node;
                }).indexOf(newActiveElement);
                if (focusedIndex > -1) {
                    allNodes.filter(function(_ref3) {
                        var guard = _ref3.guard, node = _ref3.node;
                        return guard && node.dataset.focusAutoGuard;
                    }).forEach(function(_ref4) {
                        var node = _ref4.node;
                        return node.removeAttribute('tabIndex');
                    });
                    $154ef9172a209d8a$var$autoGuard(focusedIndex, allNodes.length, 1, allNodes);
                    $154ef9172a209d8a$var$autoGuard(focusedIndex, -1, -1, allNodes);
                }
            }
        }
    }
    return result;
};
var $154ef9172a209d8a$var$onTrap = function onTrap(event) {
    if ($154ef9172a209d8a$var$activateTrap() && event) {
        event.stopPropagation();
        event.preventDefault();
    }
};
var $154ef9172a209d8a$var$onBlur = function onBlur() {
    return (0, $65prp.deferAction)($154ef9172a209d8a$var$activateTrap);
};
var $154ef9172a209d8a$var$onFocus = function onFocus(event) {
    var source = event.target;
    var currentNode = event.currentTarget;
    if (!currentNode.contains(source)) $154ef9172a209d8a$var$recordPortal(currentNode, source);
};
var $154ef9172a209d8a$var$FocusWatcher = function FocusWatcher() {
    return null;
};
var $154ef9172a209d8a$var$FocusTrap = function FocusTrap(_ref5) {
    var children = _ref5.children;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("div", {
        onBlur: $154ef9172a209d8a$var$onBlur,
        onFocus: $154ef9172a209d8a$var$onFocus
    }, children);
};
$154ef9172a209d8a$var$FocusTrap.propTypes = {};
var $154ef9172a209d8a$var$onWindowFocus = function onWindowFocus() {
    $154ef9172a209d8a$var$windowFocused = true;
};
var $154ef9172a209d8a$var$onWindowBlur = function onWindowBlur() {
    $154ef9172a209d8a$var$windowFocused = false;
    $154ef9172a209d8a$var$focusWasOutsideWindow = 'just';
    (0, $65prp.deferAction)(function() {
        $154ef9172a209d8a$var$focusWasOutsideWindow = 'meanwhile';
    });
};
var $154ef9172a209d8a$var$attachHandler = function attachHandler() {
    document.addEventListener('focusin', $154ef9172a209d8a$var$onTrap);
    document.addEventListener('focusout', $154ef9172a209d8a$var$onBlur);
    window.addEventListener('focus', $154ef9172a209d8a$var$onWindowFocus);
    window.addEventListener('blur', $154ef9172a209d8a$var$onWindowBlur);
};
var $154ef9172a209d8a$var$detachHandler = function detachHandler() {
    document.removeEventListener('focusin', $154ef9172a209d8a$var$onTrap);
    document.removeEventListener('focusout', $154ef9172a209d8a$var$onBlur);
    window.removeEventListener('focus', $154ef9172a209d8a$var$onWindowFocus);
    window.removeEventListener('blur', $154ef9172a209d8a$var$onWindowBlur);
};
function $154ef9172a209d8a$var$reducePropsToState(propsList) {
    return propsList.filter(function(_ref6) {
        var disabled = _ref6.disabled;
        return !disabled;
    });
}
var $154ef9172a209d8a$var$focusLockAPI = {
    moveFocusInside: (0, $i8qpR.moveFocusInside),
    focusInside: (0, $chs63.focusInside),
    focusNextElement: (0, $738X1.focusNextElement),
    focusPrevElement: (0, $738X1.focusPrevElement),
    focusFirstElement: (0, $738X1.focusFirstElement),
    focusLastElement: (0, $738X1.focusLastElement),
    captureFocusRestore: (0, $3LvY8.captureFocusRestore)
};
function $154ef9172a209d8a$var$handleStateChangeOnClient(traps) {
    var trap = traps.slice(-1)[0];
    if (trap && !$154ef9172a209d8a$var$lastActiveTrap) $154ef9172a209d8a$var$attachHandler();
    var lastTrap = $154ef9172a209d8a$var$lastActiveTrap;
    var sameTrap = lastTrap && trap && trap.id === lastTrap.id;
    $154ef9172a209d8a$var$lastActiveTrap = trap;
    if (lastTrap && !sameTrap) {
        lastTrap.onDeactivation();
        if (!traps.filter(function(_ref7) {
            var id = _ref7.id;
            return id === lastTrap.id;
        }).length) lastTrap.returnFocus(!trap);
    }
    if (trap) {
        $154ef9172a209d8a$var$lastActiveFocus = null;
        if (!sameTrap || lastTrap.observed !== trap.observed) trap.onActivation($154ef9172a209d8a$var$focusLockAPI);
        $154ef9172a209d8a$var$activateTrap(true);
        (0, $65prp.deferAction)($154ef9172a209d8a$var$activateTrap);
    } else {
        $154ef9172a209d8a$var$detachHandler();
        $154ef9172a209d8a$var$lastActiveFocus = null;
    }
}
(0, $ljihP.mediumFocus).assignSyncMedium($154ef9172a209d8a$var$onFocus);
(0, $ljihP.mediumBlur).assignMedium($154ef9172a209d8a$var$onBlur);
(0, $ljihP.mediumEffect).assignMedium(function(cb) {
    return cb($154ef9172a209d8a$var$focusLockAPI);
});
var $154ef9172a209d8a$export$2e2bcd8739ae039 = (0, $i7ZOa.default)($154ef9172a209d8a$var$reducePropsToState, $154ef9172a209d8a$var$handleStateChangeOnClient)($154ef9172a209d8a$var$FocusWatcher);

});
parcelRegister("i7ZOa", function(module, exports) {
$parcel$export(module.exports, "default", () => $d328d346166c2227$export$2e2bcd8739ae039);

var $3opc4 = parcelRequire("3opc4");

var $jpOKD = parcelRequire("jpOKD");

var $5FkrB = parcelRequire("5FkrB");
function $d328d346166c2227$var$withSideEffect(reducePropsToState, handleStateChangeOnClient) {
    function getDisplayName(WrappedComponent) {
        return WrappedComponent.displayName || WrappedComponent.name || 'Component';
    }
    return function wrap(WrappedComponent) {
        var mountedInstances = [];
        var state;
        function emitChange() {
            state = reducePropsToState(mountedInstances.map(function(instance) {
                return instance.props;
            }));
            handleStateChangeOnClient(state);
        }
        var SideEffect = /*#__PURE__*/ function(_PureComponent) {
            (0, $3opc4.default)(SideEffect, _PureComponent);
            function SideEffect() {
                return _PureComponent.apply(this, arguments) || this;
            }
            // Try to use displayName of wrapped component
            SideEffect.peek = function peek() {
                return state;
            };
            var _proto = SideEffect.prototype;
            _proto.componentDidMount = function componentDidMount() {
                mountedInstances.push(this);
                emitChange();
            };
            _proto.componentDidUpdate = function componentDidUpdate() {
                emitChange();
            };
            _proto.componentWillUnmount = function componentWillUnmount() {
                var index = mountedInstances.indexOf(this);
                mountedInstances.splice(index, 1);
                emitChange();
            };
            _proto.render = function render() {
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(WrappedComponent, this.props);
            };
            return SideEffect;
        }((0, $5FkrB.PureComponent));
        (0, $jpOKD.default)(SideEffect, "displayName", "SideEffect(" + getDisplayName(WrappedComponent) + ")");
        return SideEffect;
    };
}
var $d328d346166c2227$export$2e2bcd8739ae039 = $d328d346166c2227$var$withSideEffect;

});
parcelRegister("3opc4", function(module, exports) {
$parcel$export(module.exports, "default", () => $278727eb54862fdd$export$2e2bcd8739ae039);

var $5h2NW = parcelRequire("5h2NW");
function $278727eb54862fdd$export$2e2bcd8739ae039(t, o) {
    t.prototype = Object.create(o.prototype), t.prototype.constructor = t, (0, $5h2NW.default)(t, o);
}

});
parcelRegister("5h2NW", function(module, exports) {
$parcel$export(module.exports, "default", () => $3d70b73588f4b16a$export$2e2bcd8739ae039);
function $3d70b73588f4b16a$export$2e2bcd8739ae039(t, e) {
    return $3d70b73588f4b16a$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, $3d70b73588f4b16a$export$2e2bcd8739ae039(t, e);
}

});


parcelRegister("jpOKD", function(module, exports) {
$parcel$export(module.exports, "default", () => $e227b838dc112aad$export$2e2bcd8739ae039);

var $9ngsp = parcelRequire("9ngsp");
function $e227b838dc112aad$export$2e2bcd8739ae039(e, r, t) {
    return (r = (0, $9ngsp.default)(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}

});
parcelRegister("9ngsp", function(module, exports) {
$parcel$export(module.exports, "default", () => $6d33071d8186e866$export$2e2bcd8739ae039);

var $4bFFZ = parcelRequire("4bFFZ");

var $gSxx7 = parcelRequire("gSxx7");
function $6d33071d8186e866$export$2e2bcd8739ae039(t) {
    var i = (0, $gSxx7.default)(t, "string");
    return "symbol" == (0, $4bFFZ.default)(i) ? i : i + "";
}

});
parcelRegister("4bFFZ", function(module, exports) {
$parcel$export(module.exports, "default", () => $30c8848c4f74b91f$export$2e2bcd8739ae039);
function $30c8848c4f74b91f$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $30c8848c4f74b91f$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $30c8848c4f74b91f$export$2e2bcd8739ae039(o);
}

});

parcelRegister("gSxx7", function(module, exports) {
$parcel$export(module.exports, "default", () => $032bcd3793381cce$export$2e2bcd8739ae039);

var $4bFFZ = parcelRequire("4bFFZ");
function $032bcd3793381cce$export$2e2bcd8739ae039(t, r) {
    if ("object" != (0, $4bFFZ.default)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, $4bFFZ.default)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}

});




parcelRegister("3LvY8", function(module, exports) {
$parcel$export(module.exports, "captureFocusRestore", () => $2bde8f3efaf2ecc9$export$d357db6e554ff59a);

var $4YVKI = parcelRequire("4YVKI");
function $2bde8f3efaf2ecc9$var$weakRef(value) {
    if (!value) return null;
    // #68 Safari 14.1 dont have it yet
    // FIXME: remove in 2025
    if (typeof WeakRef === 'undefined') return function() {
        return value || null;
    };
    var w = value ? new WeakRef(value) : null;
    return function() {
        return (w === null || w === void 0 ? void 0 : w.deref()) || null;
    };
}
var $2bde8f3efaf2ecc9$export$5061a7725be48ff9 = function(element) {
    if (!element) return null;
    var stack = [];
    var currentElement = element;
    while(currentElement && currentElement !== document.body){
        stack.push({
            current: $2bde8f3efaf2ecc9$var$weakRef(currentElement),
            parent: $2bde8f3efaf2ecc9$var$weakRef(currentElement.parentElement),
            left: $2bde8f3efaf2ecc9$var$weakRef(currentElement.previousElementSibling),
            right: $2bde8f3efaf2ecc9$var$weakRef(currentElement.nextElementSibling)
        });
        currentElement = currentElement.parentElement;
    }
    return {
        element: $2bde8f3efaf2ecc9$var$weakRef(element),
        stack: stack,
        ownerDocument: element.ownerDocument
    };
};
var $2bde8f3efaf2ecc9$var$restoreFocusTo = function(location) {
    var _a, _b, _c, _d, _e;
    if (!location) return undefined;
    var stack = location.stack, ownerDocument = location.ownerDocument;
    var visibilityCache = new Map();
    for(var _i = 0, stack_1 = stack; _i < stack_1.length; _i++){
        var line = stack_1[_i];
        var parent_1 = (_a = line.parent) === null || _a === void 0 ? void 0 : _a.call(line);
        // is it still here?
        if (parent_1 && ownerDocument.contains(parent_1)) {
            var left = (_b = line.left) === null || _b === void 0 ? void 0 : _b.call(line);
            var savedCurrent = line.current();
            var current = parent_1.contains(savedCurrent) ? savedCurrent : undefined;
            var right = (_c = line.right) === null || _c === void 0 ? void 0 : _c.call(line);
            var focusables = (0, $4YVKI.getTabbableNodes)([
                parent_1
            ], visibilityCache);
            var aim = // that is element itself
            (_e = (_d = current !== null && current !== void 0 ? current : // or something in it's place
            left === null || left === void 0 ? void 0 : left.nextElementSibling) !== null && _d !== void 0 ? _d : // or somebody to the right, still close enough
            right) !== null && _e !== void 0 ? _e : // or somebody to the left, something?
            left;
            while(aim){
                for(var _f = 0, focusables_1 = focusables; _f < focusables_1.length; _f++){
                    var focusable = focusables_1[_f];
                    if (aim === null || aim === void 0 ? void 0 : aim.contains(focusable.node)) return focusable.node;
                }
                aim = aim.nextElementSibling;
            }
            if (focusables.length) // if parent contains a focusable - move there
            return focusables[0].node;
        }
    }
    // nothing matched
    return undefined;
};
var $2bde8f3efaf2ecc9$export$d357db6e554ff59a = function(targetElement) {
    var location = $2bde8f3efaf2ecc9$export$5061a7725be48ff9(targetElement);
    return function() {
        return $2bde8f3efaf2ecc9$var$restoreFocusTo(location);
    };
};

});
parcelRegister("4YVKI", function(module, exports) {
$parcel$export(module.exports, "filterAutoFocusable", () => $3a09907090b85585$export$2f70373d403a5d2b);
$parcel$export(module.exports, "getTabbableNodes", () => $3a09907090b85585$export$3738e313571e2ad2);
$parcel$export(module.exports, "getFocusableNodes", () => $3a09907090b85585$export$493d05a3a8e6532d);
$parcel$export(module.exports, "parentAutofocusables", () => $3a09907090b85585$export$dc26309a71d1ce47);
$parcel$export(module.exports, "contains", () => $3a09907090b85585$export$2344b14b097df817);

var $ady3j = parcelRequire("ady3j");

var $k3Vqr = parcelRequire("k3Vqr");

var $2Tuzr = parcelRequire("2Tuzr");

var $gfzXb = parcelRequire("gfzXb");
var $3a09907090b85585$export$6266a5cd5915dc33 = function(nodes, visibilityCache) {
    return (0, $ady3j.toArray)(nodes).filter(function(node) {
        return (0, $k3Vqr.isVisibleCached)(visibilityCache, node);
    }).filter(function(node) {
        return (0, $k3Vqr.notHiddenInput)(node);
    });
};
var $3a09907090b85585$export$2f70373d403a5d2b = function(nodes, cache) {
    if (cache === void 0) cache = new Map();
    return (0, $ady3j.toArray)(nodes).filter(function(node) {
        return (0, $k3Vqr.isAutoFocusAllowedCached)(cache, node);
    });
};
var $3a09907090b85585$export$3738e313571e2ad2 = function(topNodes, visibilityCache, withGuards) {
    return (0, $2Tuzr.orderByTabIndex)($3a09907090b85585$export$6266a5cd5915dc33((0, $gfzXb.getFocusables)(topNodes, withGuards), visibilityCache), true, withGuards);
};
var $3a09907090b85585$export$493d05a3a8e6532d = function(topNodes, visibilityCache) {
    return (0, $2Tuzr.orderByTabIndex)($3a09907090b85585$export$6266a5cd5915dc33((0, $gfzXb.getFocusables)(topNodes), visibilityCache), false);
};
var $3a09907090b85585$export$dc26309a71d1ce47 = function(topNode, visibilityCache) {
    return $3a09907090b85585$export$6266a5cd5915dc33((0, $gfzXb.getParentAutofocusables)(topNode), visibilityCache);
};
var $3a09907090b85585$export$2344b14b097df817 = function(scope, element) {
    if (scope.shadowRoot) return $3a09907090b85585$export$2344b14b097df817(scope.shadowRoot, element);
    else {
        if (Object.getPrototypeOf(scope).contains !== undefined && Object.getPrototypeOf(scope).contains.call(scope, element)) return true;
        return (0, $ady3j.toArray)(scope.children).some(function(child) {
            var _a;
            if (child instanceof HTMLIFrameElement) {
                var iframeBody = (_a = child.contentDocument) === null || _a === void 0 ? void 0 : _a.body;
                if (iframeBody) return $3a09907090b85585$export$2344b14b097df817(iframeBody, element);
                return false;
            }
            return $3a09907090b85585$export$2344b14b097df817(child, element);
        });
    }
};

});
parcelRegister("ady3j", function(module, exports) {
$parcel$export(module.exports, "toArray", () => $770588658e9e371c$export$45b10814cc054894);
$parcel$export(module.exports, "asArray", () => $770588658e9e371c$export$75093a47a9fa838d);
$parcel$export(module.exports, "getFirst", () => $770588658e9e371c$export$bcd7afcd904dce14);
/*
IE11 support
 */ var $770588658e9e371c$export$45b10814cc054894 = function(a) {
    var ret = Array(a.length);
    for(var i = 0; i < a.length; ++i)ret[i] = a[i];
    return ret;
};
var $770588658e9e371c$export$75093a47a9fa838d = function(a) {
    return Array.isArray(a) ? a : [
        a
    ];
};
var $770588658e9e371c$export$bcd7afcd904dce14 = function(a) {
    return Array.isArray(a) ? a[0] : a;
};

});

parcelRegister("k3Vqr", function(module, exports) {
$parcel$export(module.exports, "isVisibleCached", () => $e9b0a1fc8596c084$export$3c9dc299685ad160);
$parcel$export(module.exports, "isAutoFocusAllowedCached", () => $e9b0a1fc8596c084$export$bcaa50628f6a736e);
$parcel$export(module.exports, "getDataset", () => $e9b0a1fc8596c084$export$698b339b0c8edae3);
$parcel$export(module.exports, "isRadioElement", () => $e9b0a1fc8596c084$export$9d74f6fbc6f469d0);
$parcel$export(module.exports, "notHiddenInput", () => $e9b0a1fc8596c084$export$8197b0ea56b3b055);
$parcel$export(module.exports, "isGuard", () => $e9b0a1fc8596c084$export$d94b8b58ec2f30eb);
$parcel$export(module.exports, "isNotAGuard", () => $e9b0a1fc8596c084$export$602e5a0d338d7750);
$parcel$export(module.exports, "isDefined", () => $e9b0a1fc8596c084$export$4e62c701997796c1);

var $a9Isk = parcelRequire("a9Isk");
var $e9b0a1fc8596c084$var$isElementHidden = function(node) {
    // we can measure only "elements"
    // consider others as "visible"
    if (node.nodeType !== Node.ELEMENT_NODE) return false;
    var computedStyle = window.getComputedStyle(node, null);
    if (!computedStyle || !computedStyle.getPropertyValue) return false;
    return computedStyle.getPropertyValue('display') === 'none' || computedStyle.getPropertyValue('visibility') === 'hidden';
};
var $e9b0a1fc8596c084$var$getParentNode = function(node) {
    // DOCUMENT_FRAGMENT_NODE can also point on ShadowRoot. In this case .host will point on the next node
    return node.parentNode && node.parentNode.nodeType === Node.DOCUMENT_FRAGMENT_NODE ? node.parentNode.host : node.parentNode;
};
var $e9b0a1fc8596c084$var$isTopNode = function(node) {
    // @ts-ignore
    return node === document || node && node.nodeType === Node.DOCUMENT_NODE;
};
var $e9b0a1fc8596c084$var$isInert = function(node) {
    return node.hasAttribute('inert');
};
/**
 * @see https://github.com/testing-library/jest-dom/blob/main/src/to-be-visible.js
 */ var $e9b0a1fc8596c084$var$isVisibleUncached = function(node, checkParent) {
    return !node || $e9b0a1fc8596c084$var$isTopNode(node) || !$e9b0a1fc8596c084$var$isElementHidden(node) && !$e9b0a1fc8596c084$var$isInert(node) && checkParent($e9b0a1fc8596c084$var$getParentNode(node));
};
var $e9b0a1fc8596c084$export$3c9dc299685ad160 = function(visibilityCache, node) {
    var cached = visibilityCache.get(node);
    if (cached !== undefined) return cached;
    var result = $e9b0a1fc8596c084$var$isVisibleUncached(node, $e9b0a1fc8596c084$export$3c9dc299685ad160.bind(undefined, visibilityCache));
    visibilityCache.set(node, result);
    return result;
};
var $e9b0a1fc8596c084$var$isAutoFocusAllowedUncached = function(node, checkParent) {
    return node && !$e9b0a1fc8596c084$var$isTopNode(node) ? $e9b0a1fc8596c084$export$b8550e27de209d85(node) ? checkParent($e9b0a1fc8596c084$var$getParentNode(node)) : false : true;
};
var $e9b0a1fc8596c084$export$bcaa50628f6a736e = function(cache, node) {
    var cached = cache.get(node);
    if (cached !== undefined) return cached;
    var result = $e9b0a1fc8596c084$var$isAutoFocusAllowedUncached(node, $e9b0a1fc8596c084$export$bcaa50628f6a736e.bind(undefined, cache));
    cache.set(node, result);
    return result;
};
var $e9b0a1fc8596c084$export$698b339b0c8edae3 = function(node) {
    // @ts-ignore
    return node.dataset;
};
var $e9b0a1fc8596c084$export$65aad1b6bc934b11 = function(node) {
    return node.tagName === 'BUTTON';
};
var $e9b0a1fc8596c084$export$88a6ceeed5737ba3 = function(node) {
    return node.tagName === 'INPUT';
};
var $e9b0a1fc8596c084$export$9d74f6fbc6f469d0 = function(node) {
    return $e9b0a1fc8596c084$export$88a6ceeed5737ba3(node) && node.type === 'radio';
};
var $e9b0a1fc8596c084$export$8197b0ea56b3b055 = function(node) {
    return !(($e9b0a1fc8596c084$export$88a6ceeed5737ba3(node) || $e9b0a1fc8596c084$export$65aad1b6bc934b11(node)) && (node.type === 'hidden' || node.disabled));
};
var $e9b0a1fc8596c084$export$b8550e27de209d85 = function(node) {
    var attribute = node.getAttribute((0, $a9Isk.FOCUS_NO_AUTOFOCUS));
    return ![
        true,
        'true',
        ''
    ].includes(attribute);
};
var $e9b0a1fc8596c084$export$d94b8b58ec2f30eb = function(node) {
    var _a;
    return Boolean(node && ((_a = $e9b0a1fc8596c084$export$698b339b0c8edae3(node)) === null || _a === void 0 ? void 0 : _a.focusGuard));
};
var $e9b0a1fc8596c084$export$602e5a0d338d7750 = function(node) {
    return !$e9b0a1fc8596c084$export$d94b8b58ec2f30eb(node);
};
var $e9b0a1fc8596c084$export$4e62c701997796c1 = function(x) {
    return Boolean(x);
};

});

parcelRegister("2Tuzr", function(module, exports) {
$parcel$export(module.exports, "orderByTabIndex", () => $21b86e87d5f46a98$export$cb40ee071f0d5226);

var $ady3j = parcelRequire("ady3j");
var $21b86e87d5f46a98$export$350ee6c095d98996 = function(a, b) {
    var aTab = Math.max(0, a.tabIndex);
    var bTab = Math.max(0, b.tabIndex);
    var tabDiff = aTab - bTab;
    var indexDiff = a.index - b.index;
    if (tabDiff) {
        if (!aTab) return 1;
        if (!bTab) return -1;
    }
    return tabDiff || indexDiff;
};
var $21b86e87d5f46a98$var$getTabIndex = function(node) {
    if (node.tabIndex < 0) {
        // all "focusable" elements are already preselected
        // but some might have implicit negative tabIndex
        // return 0 for <audio without tabIndex attribute - it is "tabbable"
        if (!node.hasAttribute('tabindex')) return 0;
    }
    return node.tabIndex;
};
var $21b86e87d5f46a98$export$cb40ee071f0d5226 = function(nodes, filterNegative, keepGuards) {
    return (0, $ady3j.toArray)(nodes).map(function(node, index) {
        var tabIndex = $21b86e87d5f46a98$var$getTabIndex(node);
        return {
            node: node,
            index: index,
            tabIndex: keepGuards && tabIndex === -1 ? (node.dataset || {}).focusGuard ? 0 : -1 : tabIndex
        };
    }).filter(function(data) {
        return !filterNegative || data.tabIndex >= 0;
    }).sort($21b86e87d5f46a98$export$350ee6c095d98996);
};

});

parcelRegister("gfzXb", function(module, exports) {
$parcel$export(module.exports, "getFocusables", () => $bd49efae73506932$export$f6768025e418420e);
$parcel$export(module.exports, "getParentAutofocusables", () => $bd49efae73506932$export$853fa94d922e78b9);

var $a9Isk = parcelRequire("a9Isk");

var $ady3j = parcelRequire("ady3j");

var $lHtVL = parcelRequire("lHtVL");
var $bd49efae73506932$var$queryTabbables = (0, $lHtVL.tabbables).join(',');
var $bd49efae73506932$var$queryGuardTabbables = "".concat($bd49efae73506932$var$queryTabbables, ", [data-focus-guard]");
var $bd49efae73506932$var$getFocusablesWithShadowDom = function(parent, withGuards) {
    return (0, $ady3j.toArray)((parent.shadowRoot || parent).children).reduce(function(acc, child) {
        return acc.concat(child.matches(withGuards ? $bd49efae73506932$var$queryGuardTabbables : $bd49efae73506932$var$queryTabbables) ? [
            child
        ] : [], $bd49efae73506932$var$getFocusablesWithShadowDom(child));
    }, []);
};
var $bd49efae73506932$var$getFocusablesWithIFrame = function(parent, withGuards) {
    var _a;
    // contentDocument of iframe will be null if current origin cannot access it
    if (parent instanceof HTMLIFrameElement && ((_a = parent.contentDocument) === null || _a === void 0 ? void 0 : _a.body)) return $bd49efae73506932$export$f6768025e418420e([
        parent.contentDocument.body
    ], withGuards);
    return [
        parent
    ];
};
var $bd49efae73506932$export$f6768025e418420e = function(parents, withGuards) {
    return parents.reduce(function(acc, parent) {
        var _a;
        var focusableWithShadowDom = $bd49efae73506932$var$getFocusablesWithShadowDom(parent, withGuards);
        var focusableWithIframes = (_a = []).concat.apply(_a, focusableWithShadowDom.map(function(node) {
            return $bd49efae73506932$var$getFocusablesWithIFrame(node, withGuards);
        }));
        return acc.concat(// add all tabbables inside and within shadow DOMs in DOM order
        focusableWithIframes, // add if node is tabbable itself
        parent.parentNode ? (0, $ady3j.toArray)(parent.parentNode.querySelectorAll($bd49efae73506932$var$queryTabbables)).filter(function(node) {
            return node === parent;
        }) : []);
    }, []);
};
var $bd49efae73506932$export$853fa94d922e78b9 = function(parent) {
    var parentFocus = parent.querySelectorAll("[".concat((0, $a9Isk.FOCUS_AUTO), "]"));
    return (0, $ady3j.toArray)(parentFocus).map(function(node) {
        return $bd49efae73506932$export$f6768025e418420e([
            node
        ]);
    }).reduce(function(acc, nodes) {
        return acc.concat(nodes);
    }, []);
};

});
parcelRegister("lHtVL", function(module, exports) {
$parcel$export(module.exports, "tabbables", () => $fcc4d4b8545dd10c$export$8555f4622e95784);
/**
 * list of the object to be considered as focusable
 */ var $fcc4d4b8545dd10c$export$8555f4622e95784 = [
    'button:enabled',
    'select:enabled',
    'textarea:enabled',
    'input:enabled',
    // elements with explicit roles will also use explicit tabindex
    // '[role="button"]',
    'a[href]',
    'area[href]',
    'summary',
    'iframe',
    'object',
    'embed',
    'audio[controls]',
    'video[controls]',
    '[tabindex]',
    '[contenteditable]',
    '[autofocus]'
];

});




parcelRegister("gWC5V", function(module, exports) {
$parcel$export(module.exports, "expandFocusableNodes", () => $c55f9cebdb24174a$export$f89ac71e91767111);

var $hwzGt = parcelRequire("hwzGt");

var $k3Vqr = parcelRequire("k3Vqr");

var $eRdn6 = parcelRequire("eRdn6");

var $2Tuzr = parcelRequire("2Tuzr");

var $gfzXb = parcelRequire("gfzXb");
var $c55f9cebdb24174a$export$f89ac71e91767111 = function(topNode) {
    var entries = (0, $hwzGt.getAllAffectedNodes)(topNode).filter((0, $k3Vqr.isNotAGuard));
    var commonParent = (0, $eRdn6.getTopCommonParent)(topNode, topNode, entries);
    var outerNodes = (0, $2Tuzr.orderByTabIndex)((0, $gfzXb.getFocusables)([
        commonParent
    ], true), true, true);
    var innerElements = (0, $gfzXb.getFocusables)(entries, false);
    return outerNodes.map(function(_a) {
        var node = _a.node, index = _a.index;
        return {
            node: node,
            index: index,
            lockItem: innerElements.indexOf(node) >= 0,
            guard: (0, $k3Vqr.isGuard)(node)
        };
    });
};

});
parcelRegister("hwzGt", function(module, exports) {
$parcel$export(module.exports, "getAllAffectedNodes", () => $cc211af334b43a48$export$7e87c4720b9b279b);

var $a9Isk = parcelRequire("a9Isk");

var $ady3j = parcelRequire("ady3j");
/**
 * in case of multiple nodes nested inside each other
 * keeps only top ones
 * this is O(nlogn)
 * @param nodes
 * @returns {*}
 */ var $cc211af334b43a48$var$filterNested = function(nodes) {
    var contained = new Set();
    var l = nodes.length;
    for(var i = 0; i < l; i += 1)for(var j = i + 1; j < l; j += 1){
        var position = nodes[i].compareDocumentPosition(nodes[j]);
        /* eslint-disable no-bitwise */ if ((position & Node.DOCUMENT_POSITION_CONTAINED_BY) > 0) contained.add(j);
        if ((position & Node.DOCUMENT_POSITION_CONTAINS) > 0) contained.add(i);
    /* eslint-enable */ }
    return nodes.filter(function(_, index) {
        return !contained.has(index);
    });
};
/**
 * finds top most parent for a node
 * @param node
 * @returns {*}
 */ var $cc211af334b43a48$var$getTopParent = function(node) {
    return node.parentNode ? $cc211af334b43a48$var$getTopParent(node.parentNode) : node;
};
var $cc211af334b43a48$export$7e87c4720b9b279b = function(node) {
    var nodes = (0, $ady3j.asArray)(node);
    return nodes.filter(Boolean).reduce(function(acc, currentNode) {
        var group = currentNode.getAttribute((0, $a9Isk.FOCUS_GROUP));
        acc.push.apply(acc, group ? $cc211af334b43a48$var$filterNested((0, $ady3j.toArray)($cc211af334b43a48$var$getTopParent(currentNode).querySelectorAll("[".concat((0, $a9Isk.FOCUS_GROUP), "=\"").concat(group, "\"]:not([").concat((0, $a9Isk.FOCUS_DISABLED), "=\"disabled\"])")))) : [
            currentNode
        ]);
        return acc;
    }, []);
};

});

parcelRegister("eRdn6", function(module, exports) {
$parcel$export(module.exports, "getTopCommonParent", () => $ad10633a795569ac$export$a9a7252b5f2e280e);
$parcel$export(module.exports, "allParentAutofocusables", () => $ad10633a795569ac$export$8f99714c70a37db1);

var $4YVKI = parcelRequire("4YVKI");

var $ady3j = parcelRequire("ady3j");
var $ad10633a795569ac$var$getParents = function(node, parents) {
    if (parents === void 0) parents = [];
    parents.push(node);
    if (node.parentNode) $ad10633a795569ac$var$getParents(node.parentNode.host || node.parentNode, parents);
    return parents;
};
var $ad10633a795569ac$export$a08e5f53769bce53 = function(nodeA, nodeB) {
    var parentsA = $ad10633a795569ac$var$getParents(nodeA);
    var parentsB = $ad10633a795569ac$var$getParents(nodeB);
    // tslint:disable-next-line:prefer-for-of
    for(var i = 0; i < parentsA.length; i += 1){
        var currentParent = parentsA[i];
        if (parentsB.indexOf(currentParent) >= 0) return currentParent;
    }
    return false;
};
var $ad10633a795569ac$export$a9a7252b5f2e280e = function(baseActiveElement, leftEntry, rightEntries) {
    var activeElements = (0, $ady3j.asArray)(baseActiveElement);
    var leftEntries = (0, $ady3j.asArray)(leftEntry);
    var activeElement = activeElements[0];
    var topCommon = false;
    leftEntries.filter(Boolean).forEach(function(entry) {
        topCommon = $ad10633a795569ac$export$a08e5f53769bce53(topCommon || entry, entry) || topCommon;
        rightEntries.filter(Boolean).forEach(function(subEntry) {
            var common = $ad10633a795569ac$export$a08e5f53769bce53(activeElement, subEntry);
            if (common) {
                if (!topCommon || (0, $4YVKI.contains)(common, topCommon)) topCommon = common;
                else topCommon = $ad10633a795569ac$export$a08e5f53769bce53(common, topCommon);
            }
        });
    });
    // TODO: add assert here?
    return topCommon;
};
var $ad10633a795569ac$export$8f99714c70a37db1 = function(entries, visibilityCache) {
    return entries.reduce(function(acc, node) {
        return acc.concat((0, $4YVKI.parentAutofocusables)(node, visibilityCache));
    }, []);
};

});


parcelRegister("738X1", function(module, exports) {
$parcel$export(module.exports, "focusNextElement", () => $521fc1b3da6a3f71$export$3b0237e8566c8d65);
$parcel$export(module.exports, "focusPrevElement", () => $521fc1b3da6a3f71$export$33b47db07a82b2fb);
$parcel$export(module.exports, "focusFirstElement", () => $521fc1b3da6a3f71$export$2a791d8097a66406);
$parcel$export(module.exports, "focusLastElement", () => $521fc1b3da6a3f71$export$6a79073ddabfd6c3);

var $4E2yD = parcelRequire("4E2yD");

var $4YVKI = parcelRequire("4YVKI");

var $ady3j = parcelRequire("ady3j");
var $521fc1b3da6a3f71$export$1b42c72592537703 = function(element, scope, useTabbables) {
    if (!element || !scope) {
        console.error('no element or scope given');
        return {};
    }
    var shards = (0, $ady3j.asArray)(scope);
    if (shards.every(function(shard) {
        return !(0, $4YVKI.contains)(shard, element);
    })) {
        console.error('Active element is not contained in the scope');
        return {};
    }
    var focusables = useTabbables ? (0, $4YVKI.getTabbableNodes)(shards, new Map()) : (0, $4YVKI.getFocusableNodes)(shards, new Map());
    var current = focusables.findIndex(function(_a) {
        var node = _a.node;
        return node === element;
    });
    if (current === -1) // an edge case, when anchor element is not found
    return undefined;
    return {
        prev: focusables[current - 1],
        next: focusables[current + 1],
        first: focusables[0],
        last: focusables[focusables.length - 1]
    };
};
var $521fc1b3da6a3f71$var$getBoundary = function(shards, useTabbables) {
    var set = useTabbables ? (0, $4YVKI.getTabbableNodes)((0, $ady3j.asArray)(shards), new Map()) : (0, $4YVKI.getFocusableNodes)((0, $ady3j.asArray)(shards), new Map());
    return {
        first: set[0],
        last: set[set.length - 1]
    };
};
var $521fc1b3da6a3f71$var$defaultOptions = function(options) {
    return Object.assign({
        scope: document.body,
        cycle: true,
        onlyTabbable: true
    }, options);
};
var $521fc1b3da6a3f71$var$moveFocus = function(fromElement, options, cb) {
    if (options === void 0) options = {};
    var newOptions = $521fc1b3da6a3f71$var$defaultOptions(options);
    var solution = $521fc1b3da6a3f71$export$1b42c72592537703(fromElement, newOptions.scope, newOptions.onlyTabbable);
    if (!solution) return;
    var target = cb(solution, newOptions.cycle);
    if (target) (0, $4E2yD.focusOn)(target.node, newOptions.focusOptions);
};
var $521fc1b3da6a3f71$export$3b0237e8566c8d65 = function(fromElement, options) {
    if (options === void 0) options = {};
    $521fc1b3da6a3f71$var$moveFocus(fromElement, options, function(_a, cycle) {
        var next = _a.next, first = _a.first;
        return next || cycle && first;
    });
};
var $521fc1b3da6a3f71$export$33b47db07a82b2fb = function(fromElement, options) {
    if (options === void 0) options = {};
    $521fc1b3da6a3f71$var$moveFocus(fromElement, options, function(_a, cycle) {
        var prev = _a.prev, last = _a.last;
        return prev || cycle && last;
    });
};
var $521fc1b3da6a3f71$var$pickBoundary = function(scope, options, what) {
    var _a;
    var boundary = $521fc1b3da6a3f71$var$getBoundary(scope, (_a = options.onlyTabbable) !== null && _a !== void 0 ? _a : true);
    var node = boundary[what];
    if (node) (0, $4E2yD.focusOn)(node.node, options.focusOptions);
};
var $521fc1b3da6a3f71$export$2a791d8097a66406 = function(scope, options) {
    if (options === void 0) options = {};
    $521fc1b3da6a3f71$var$pickBoundary(scope, options, 'first');
};
var $521fc1b3da6a3f71$export$6a79073ddabfd6c3 = function(scope, options) {
    if (options === void 0) options = {};
    $521fc1b3da6a3f71$var$pickBoundary(scope, options, 'last');
};

});
parcelRegister("4E2yD", function(module, exports) {
$parcel$export(module.exports, "focusOn", () => $361ce1b8c2cd8208$export$c12b3da842c43a8);
var $361ce1b8c2cd8208$export$c12b3da842c43a8 = function(target, focusOptions) {
    if (!target) // not clear how, but is possible https://github.com/theKashey/focus-lock/issues/53
    return;
    if ('focus' in target) target.focus(focusOptions);
    if ('contentWindow' in target && target.contentWindow) target.contentWindow.focus();
};

});


parcelRegister("chs63", function(module, exports) {
$parcel$export(module.exports, "focusInside", () => $8f0cddf89bdfad1b$export$20115f8da7baa6fa);

var $4YVKI = parcelRequire("4YVKI");

var $hwzGt = parcelRequire("hwzGt");

var $ady3j = parcelRequire("ady3j");

var $dSYXr = parcelRequire("dSYXr");
var $8f0cddf89bdfad1b$var$focusInFrame = function(frame, activeElement) {
    return frame === activeElement;
};
var $8f0cddf89bdfad1b$var$focusInsideIframe = function(topNode, activeElement) {
    return Boolean((0, $ady3j.toArray)(topNode.querySelectorAll('iframe')).some(function(node) {
        return $8f0cddf89bdfad1b$var$focusInFrame(node, activeElement);
    }));
};
var $8f0cddf89bdfad1b$export$20115f8da7baa6fa = function(topNode, activeElement) {
    // const activeElement = document && getActiveElement();
    if (activeElement === void 0) activeElement = (0, $dSYXr.getActiveElement)((0, $ady3j.getFirst)(topNode).ownerDocument);
    if (!activeElement || activeElement.dataset && activeElement.dataset.focusGuard) return false;
    return (0, $hwzGt.getAllAffectedNodes)(topNode).some(function(node) {
        return (0, $4YVKI.contains)(node, activeElement) || $8f0cddf89bdfad1b$var$focusInsideIframe(node, activeElement);
    });
};

});
parcelRegister("dSYXr", function(module, exports) {
$parcel$export(module.exports, "getActiveElement", () => $a1bf9a6baf43edf3$export$cd4e5573fbe2b576);
/**
 * returns active element from document or from nested shadowdoms
 */ 
var $3yce2 = parcelRequire("3yce2");
var $a1bf9a6baf43edf3$export$cd4e5573fbe2b576 = function(inDocument) {
    if (inDocument === void 0) inDocument = document;
    if (!inDocument || !inDocument.activeElement) return undefined;
    var activeElement = inDocument.activeElement;
    return activeElement.shadowRoot ? $a1bf9a6baf43edf3$export$cd4e5573fbe2b576(activeElement.shadowRoot) : activeElement instanceof HTMLIFrameElement && (0, $3yce2.safeProbe)(function() {
        return activeElement.contentWindow.document;
    }) ? $a1bf9a6baf43edf3$export$cd4e5573fbe2b576(activeElement.contentWindow.document) : activeElement;
};

});
parcelRegister("3yce2", function(module, exports) {
$parcel$export(module.exports, "safeProbe", () => $295e07c6e2e5c92a$export$78d20aae35adef88);
var $295e07c6e2e5c92a$export$78d20aae35adef88 = function(cb) {
    try {
        return cb();
    } catch (e) {
        return undefined;
    }
};

});



parcelRegister("75ruL", function(module, exports) {
$parcel$export(module.exports, "focusIsHidden", () => $528e54078796510d$export$be6b21806d3fd485);

var $a9Isk = parcelRequire("a9Isk");

var $4YVKI = parcelRequire("4YVKI");

var $ady3j = parcelRequire("ady3j");

var $dSYXr = parcelRequire("dSYXr");
var $528e54078796510d$export$be6b21806d3fd485 = function(inDocument) {
    if (inDocument === void 0) inDocument = document;
    var activeElement = (0, $dSYXr.getActiveElement)(inDocument);
    if (!activeElement) return false;
    // this does not support setting FOCUS_ALLOW within shadow dom
    return (0, $ady3j.toArray)(inDocument.querySelectorAll("[".concat((0, $a9Isk.FOCUS_ALLOW), "]"))).some(function(node) {
        return (0, $4YVKI.contains)(node, activeElement);
    });
};

});

parcelRegister("cHP2I", function(module, exports) {
$parcel$export(module.exports, "moveFocusInside", () => (parcelRequire("i8qpR")).moveFocusInside);

var $a9Isk = parcelRequire("a9Isk");

var $chs63 = parcelRequire("chs63");

var $75ruL = parcelRequire("75ruL");


var $gWC5V = parcelRequire("gWC5V");

var $i8qpR = parcelRequire("i8qpR");

var $3LvY8 = parcelRequire("3LvY8");

var $738X1 = parcelRequire("738X1");

var $4YVKI = parcelRequire("4YVKI");
/**
 * magic symbols to control focus behavior from DOM
 * see description of every particular one
 */ var $94011839a8ef1fc4$export$1a988e7317c65621 = $a9Isk;
/**
 * @deprecated - please use {@link moveFocusInside} named export
 */ var $94011839a8ef1fc4$var$deprecated_default_moveFocusInside = (0, $i8qpR.moveFocusInside);
var $94011839a8ef1fc4$export$2e2bcd8739ae039 //
 = $94011839a8ef1fc4$var$deprecated_default_moveFocusInside;

});
parcelRegister("i8qpR", function(module, exports) {
$parcel$export(module.exports, "moveFocusInside", () => $d33d77039de67bde$export$cd599851e879a025);

var $4E2yD = parcelRequire("4E2yD");

var $401iO = parcelRequire("401iO");
var $d33d77039de67bde$var$guardCount = 0;
var $d33d77039de67bde$var$lockDisabled = false;
var $d33d77039de67bde$export$cd599851e879a025 = function(topNode, lastNode, options) {
    if (options === void 0) options = {};
    var focusable = (0, $401iO.focusSolver)(topNode, lastNode);
    // global local side effect to countain recursive lock activation and resolve focus-fighting
    if ($d33d77039de67bde$var$lockDisabled) return;
    if (focusable) {
        /** +FOCUS-FIGHTING prevention **/ if ($d33d77039de67bde$var$guardCount > 2) {
            // we have recursive entered back the lock activation
            console.error("FocusLock: focus-fighting detected. Only one focus management system could be active. See https://github.com/theKashey/focus-lock/#focus-fighting");
            $d33d77039de67bde$var$lockDisabled = true;
            setTimeout(function() {
                $d33d77039de67bde$var$lockDisabled = false;
            }, 1);
            return;
        }
        $d33d77039de67bde$var$guardCount++;
        (0, $4E2yD.focusOn)(focusable.node, options.focusOptions);
        $d33d77039de67bde$var$guardCount--;
    }
};

});
parcelRegister("401iO", function(module, exports) {
$parcel$export(module.exports, "focusSolver", () => $2e982c204732a835$export$305758c744b57f6f);

var $3LNgr = parcelRequire("3LNgr");

var $4YVKI = parcelRequire("4YVKI");

var $hwzGt = parcelRequire("hwzGt");

var $ady3j = parcelRequire("ady3j");

var $eunIZ = parcelRequire("eunIZ");

var $dSYXr = parcelRequire("dSYXr");

var $k3Vqr = parcelRequire("k3Vqr");

var $eRdn6 = parcelRequire("eRdn6");
var $2e982c204732a835$var$reorderNodes = function(srcNodes, dstNodes) {
    var remap = new Map();
    // no Set(dstNodes) for IE11 :(
    dstNodes.forEach(function(entity) {
        return remap.set(entity.node, entity);
    });
    // remap to dstNodes
    return srcNodes.map(function(node) {
        return remap.get(node);
    }).filter((0, $k3Vqr.isDefined));
};
var $2e982c204732a835$export$305758c744b57f6f = function(topNode, lastNode) {
    var activeElement = (0, $dSYXr.getActiveElement)((0, $ady3j.asArray)(topNode).length > 0 ? document : (0, $ady3j.getFirst)(topNode).ownerDocument);
    var entries = (0, $hwzGt.getAllAffectedNodes)(topNode).filter((0, $k3Vqr.isNotAGuard));
    var commonParent = (0, $eRdn6.getTopCommonParent)(activeElement || topNode, topNode, entries);
    var visibilityCache = new Map();
    var anyFocusable = (0, $4YVKI.getFocusableNodes)(entries, visibilityCache);
    var innerElements = anyFocusable.filter(function(_a) {
        var node = _a.node;
        return (0, $k3Vqr.isNotAGuard)(node);
    });
    if (!innerElements[0]) return undefined;
    var outerNodes = (0, $4YVKI.getFocusableNodes)([
        commonParent
    ], visibilityCache).map(function(_a) {
        var node = _a.node;
        return node;
    });
    var orderedInnerElements = $2e982c204732a835$var$reorderNodes(outerNodes, innerElements);
    // collect inner focusable and separately tabbables
    var innerFocusables = orderedInnerElements.map(function(_a) {
        var node = _a.node;
        return node;
    });
    var innerTabbable = orderedInnerElements.filter(function(_a) {
        var tabIndex = _a.tabIndex;
        return tabIndex >= 0;
    }).map(function(_a) {
        var node = _a.node;
        return node;
    });
    var newId = (0, $3LNgr.newFocus)(innerFocusables, innerTabbable, outerNodes, activeElement, lastNode);
    if (newId === (0, $3LNgr.NEW_FOCUS)) {
        var focusNode = // first try only tabbable, and the fallback to all focusable, as long as at least one element should be picked for focus
        (0, $eunIZ.pickAutofocus)(anyFocusable, innerTabbable, (0, $eRdn6.allParentAutofocusables)(entries, visibilityCache)) || (0, $eunIZ.pickAutofocus)(anyFocusable, innerFocusables, (0, $eRdn6.allParentAutofocusables)(entries, visibilityCache));
        if (focusNode) return {
            node: focusNode
        };
        else {
            console.warn('focus-lock: cannot find any node to move focus into');
            return undefined;
        }
    }
    if (newId === undefined) return newId;
    return orderedInnerElements[newId];
};

});
parcelRegister("3LNgr", function(module, exports) {
$parcel$export(module.exports, "NEW_FOCUS", () => $2bebf9b6d8246224$export$85710b12cf912438);
$parcel$export(module.exports, "newFocus", () => $2bebf9b6d8246224$export$65842178e9bb4205);

var $cLEEN = parcelRequire("cLEEN");

var $lqX84 = parcelRequire("lqX84");

var $k3Vqr = parcelRequire("k3Vqr");
var $2bebf9b6d8246224$export$85710b12cf912438 = 'NEW_FOCUS';
var $2bebf9b6d8246224$export$65842178e9bb4205 = function(innerNodes, innerTabbables, outerNodes, activeElement, lastNode) {
    var cnt = innerNodes.length;
    var firstFocus = innerNodes[0];
    var lastFocus = innerNodes[cnt - 1];
    var isOnGuard = (0, $k3Vqr.isGuard)(activeElement);
    // focus is inside
    if (activeElement && innerNodes.indexOf(activeElement) >= 0) return undefined;
    var activeIndex = activeElement !== undefined ? outerNodes.indexOf(activeElement) : -1;
    var lastIndex = lastNode ? outerNodes.indexOf(lastNode) : activeIndex;
    var lastNodeInside = lastNode ? innerNodes.indexOf(lastNode) : -1;
    // no active focus (or focus is on the body)
    if (activeIndex === -1) {
        // known fallback
        if (lastNodeInside !== -1) return lastNodeInside;
        return $2bebf9b6d8246224$export$85710b12cf912438;
    }
    // new focus, nothing to calculate
    if (lastNodeInside === -1) return $2bebf9b6d8246224$export$85710b12cf912438;
    var indexDiff = activeIndex - lastIndex;
    var firstNodeIndex = outerNodes.indexOf(firstFocus);
    var lastNodeIndex = outerNodes.indexOf(lastFocus);
    var correctedNodes = (0, $cLEEN.correctNodes)(outerNodes);
    var currentFocusableIndex = activeElement !== undefined ? correctedNodes.indexOf(activeElement) : -1;
    var previousFocusableIndex = lastNode ? correctedNodes.indexOf(lastNode) : currentFocusableIndex;
    var tabbableNodes = correctedNodes.filter(function(node) {
        return node.tabIndex >= 0;
    });
    var currentTabbableIndex = activeElement !== undefined ? tabbableNodes.indexOf(activeElement) : -1;
    var previousTabbableIndex = lastNode ? tabbableNodes.indexOf(lastNode) : currentTabbableIndex;
    var focusIndexDiff = currentTabbableIndex >= 0 && previousTabbableIndex >= 0 ? previousTabbableIndex - currentTabbableIndex : previousFocusableIndex - currentFocusableIndex;
    // old focus
    if (!indexDiff && lastNodeInside >= 0) return lastNodeInside;
    // no tabbable elements, autofocus is not possible
    if (innerTabbables.length === 0) // an edge case with no tabbable elements
    // return the last focusable one
    // with some probability this will prevent focus from cycling across the lock, but there is no tabbale elements to cycle to
    return lastNodeInside;
    var returnFirstNode = (0, $lqX84.pickFocusable)(innerNodes, innerTabbables[0]);
    var returnLastNode = (0, $lqX84.pickFocusable)(innerNodes, innerTabbables[innerTabbables.length - 1]);
    // first element
    if (activeIndex <= firstNodeIndex && isOnGuard && Math.abs(indexDiff) > 1) return returnLastNode;
    // last element
    if (activeIndex >= lastNodeIndex && isOnGuard && Math.abs(indexDiff) > 1) return returnFirstNode;
    // jump out, but not on the guard
    if (indexDiff && Math.abs(focusIndexDiff) > 1) return lastNodeInside;
    // focus above lock
    if (activeIndex <= firstNodeIndex) return returnLastNode;
    // focus below lock
    if (activeIndex > lastNodeIndex) return returnFirstNode;
    // index is inside tab order, but outside Lock
    if (indexDiff) {
        if (Math.abs(indexDiff) > 1) return lastNodeInside;
        return (cnt + lastNodeInside + indexDiff) % cnt;
    }
    // do nothing
    return undefined;
};

});
parcelRegister("cLEEN", function(module, exports) {
$parcel$export(module.exports, "correctNode", () => $94b96979054b176f$export$5261662167ad7ced);
$parcel$export(module.exports, "correctNodes", () => $94b96979054b176f$export$4a5a72a7124e45f9);

var $k3Vqr = parcelRequire("k3Vqr");
var $94b96979054b176f$var$findSelectedRadio = function(node, nodes) {
    return nodes.filter((0, $k3Vqr.isRadioElement)).filter(function(el) {
        return el.name === node.name;
    }).filter(function(el) {
        return el.checked;
    })[0] || node;
};
var $94b96979054b176f$export$5261662167ad7ced = function(node, nodes) {
    if ((0, $k3Vqr.isRadioElement)(node) && node.name) return $94b96979054b176f$var$findSelectedRadio(node, nodes);
    return node;
};
var $94b96979054b176f$export$4a5a72a7124e45f9 = function(nodes) {
    // IE11 has no Set(array) constructor
    var resultSet = new Set();
    nodes.forEach(function(node) {
        return resultSet.add($94b96979054b176f$export$5261662167ad7ced(node, nodes));
    });
    // using filter to support IE11
    return nodes.filter(function(node) {
        return resultSet.has(node);
    });
};

});

parcelRegister("lqX84", function(module, exports) {
$parcel$export(module.exports, "pickFirstFocus", () => $f9a9e480c51d51f0$export$f4e86cfa0679b9cc);
$parcel$export(module.exports, "pickFocusable", () => $f9a9e480c51d51f0$export$e06728ee87c96122);

var $cLEEN = parcelRequire("cLEEN");
var $f9a9e480c51d51f0$export$f4e86cfa0679b9cc = function(nodes) {
    if (nodes[0] && nodes.length > 1) return (0, $cLEEN.correctNode)(nodes[0], nodes);
    return nodes[0];
};
var $f9a9e480c51d51f0$export$e06728ee87c96122 = function(nodes, node) {
    return nodes.indexOf((0, $cLEEN.correctNode)(node, nodes));
};

});


parcelRegister("eunIZ", function(module, exports) {
$parcel$export(module.exports, "pickAutofocus", () => $a8c6453a3667ca33$export$cfb742983e257555);

var $4YVKI = parcelRequire("4YVKI");

var $lqX84 = parcelRequire("lqX84");

var $k3Vqr = parcelRequire("k3Vqr");
var $a8c6453a3667ca33$var$findAutoFocused = function(autoFocusables) {
    return function(node) {
        var _a;
        var autofocus = (_a = (0, $k3Vqr.getDataset)(node)) === null || _a === void 0 ? void 0 : _a.autofocus;
        return(// @ts-expect-error
        node.autofocus || //
        autofocus !== undefined && autofocus !== 'false' || //
        autoFocusables.indexOf(node) >= 0);
    };
};
var $a8c6453a3667ca33$export$cfb742983e257555 = function(nodesIndexes, orderedNodes, groups) {
    var nodes = nodesIndexes.map(function(_a) {
        var node = _a.node;
        return node;
    });
    var autoFocusable = (0, $4YVKI.filterAutoFocusable)(nodes.filter($a8c6453a3667ca33$var$findAutoFocused(groups)));
    if (autoFocusable && autoFocusable.length) return (0, $lqX84.pickFirstFocus)(autoFocusable);
    return (0, $lqX84.pickFirstFocus)((0, $4YVKI.filterAutoFocusable)(orderedNodes));
};

});




parcelRegister("65prp", function(module, exports) {
$parcel$export(module.exports, "deferAction", () => $46e6f1c10d391412$export$6523025722806278);
$parcel$export(module.exports, "extractRef", () => $46e6f1c10d391412$export$c613fed06e332533);
function $46e6f1c10d391412$export$6523025722806278(action) {
    setTimeout(action, 1);
}
var $46e6f1c10d391412$export$db10c343af3f20fa = function inlineProp(name, value) {
    var obj = {};
    obj[name] = value;
    return obj;
};
var $46e6f1c10d391412$export$c613fed06e332533 = function extractRef(ref) {
    return ref && 'current' in ref ? ref.current : ref;
};

});




parcelRegister("3FlkA", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $c6xho = parcelRequire("c6xho");
Object.defineProperty(module.exports, 'default', {
    enumerable: true,
    get: function get() {
        return $2ab5bf555a107c00$var$_interopRequireDefault($c6xho).default;
    }
});

var $epxCz = parcelRequire("epxCz");
Object.defineProperty(module.exports, 'TouchScrollable', {
    enumerable: true,
    get: function get() {
        return $epxCz.TouchScrollable;
    }
});
function $2ab5bf555a107c00$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}

});
parcelRegister("c6xho", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $8cffdc2bd0697df9$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

var $5FkrB = parcelRequire("5FkrB");
var $8cffdc2bd0697df9$var$_react2 = $8cffdc2bd0697df9$var$_interopRequireDefault($5FkrB);

var $61SNt = parcelRequire("61SNt");

var $epxCz = parcelRequire("epxCz");

var $4dm8g = parcelRequire("4dm8g");
var $8cffdc2bd0697df9$var$_withLockSheet2 = $8cffdc2bd0697df9$var$_interopRequireDefault($4dm8g);

var $8KBm9 = parcelRequire("8KBm9");
var $8cffdc2bd0697df9$var$_withTouchListeners2 = $8cffdc2bd0697df9$var$_interopRequireDefault($8KBm9);

var $jmnQv = parcelRequire("jmnQv");
function $8cffdc2bd0697df9$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $8cffdc2bd0697df9$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $8cffdc2bd0697df9$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $8cffdc2bd0697df9$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $8cffdc2bd0697df9$var$ScrollLock = function(_PureComponent) {
    $8cffdc2bd0697df9$var$_inherits(ScrollLock, _PureComponent);
    function ScrollLock() {
        $8cffdc2bd0697df9$var$_classCallCheck(this, ScrollLock);
        return $8cffdc2bd0697df9$var$_possibleConstructorReturn(this, (ScrollLock.__proto__ || Object.getPrototypeOf(ScrollLock)).apply(this, arguments));
    }
    $8cffdc2bd0697df9$var$_createClass(ScrollLock, [
        {
            key: 'componentDidMount',
            value: function componentDidMount() {
                if (!$61SNt.canUseDOM) return;
                this.initialHeight = window.innerHeight;
            }
        },
        {
            key: 'componentWillUnmount',
            value: function componentWillUnmount() {
                var offset = window.innerHeight - this.initialHeight;
                // adjust scroll if the window has been resized since the lock was engaged
                // e.g. mobile safari dynamic chrome heights
                if (offset) window.scrollTo(0, window.pageYOffset + offset);
                // reset the initial height in case this scroll lock is used again
                this.initialHeight = window.innerHeight;
            }
        },
        {
            key: 'render',
            value: function render() {
                var children = this.props.children;
                return children ? $8cffdc2bd0697df9$var$_react2.default.createElement($epxCz.TouchScrollable, null, children) : null;
            }
        }
    ]);
    return ScrollLock;
}($5FkrB.PureComponent);
// attach the stylesheet and inject styles on [un]mount
var $8cffdc2bd0697df9$var$compose = (0, $jmnQv.pipe)($8cffdc2bd0697df9$var$_withTouchListeners2.default, $8cffdc2bd0697df9$var$_withLockSheet2.default);
var $8cffdc2bd0697df9$var$SheetLock = $8cffdc2bd0697df9$var$compose($8cffdc2bd0697df9$var$ScrollLock);
// toggle the lock based on `isActive` prop
var $8cffdc2bd0697df9$var$LockToggle = function LockToggle(props) {
    return props.isActive ? $8cffdc2bd0697df9$var$_react2.default.createElement($8cffdc2bd0697df9$var$SheetLock, props) : props.children;
};
$8cffdc2bd0697df9$var$LockToggle.defaultProps = {
    accountForScrollbars: true,
    children: null,
    isActive: true
};
module.exports.default = $8cffdc2bd0697df9$var$LockToggle;

});
parcelRegister("61SNt", function(module, exports) {
/*!
  Copyright (c) 2015 Jed Watson.
  Based on code that is Copyright 2013-2015, Facebook, Inc.
  All rights reserved.
*/ /* global define */ (function() {
    'use strict';
    var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
    var ExecutionEnvironment = {
        canUseDOM: canUseDOM,
        canUseWorkers: typeof Worker !== 'undefined',
        canUseEventListeners: canUseDOM && !!(window.addEventListener || window.attachEvent),
        canUseViewport: canUseDOM && !!window.screen
    };
    if (typeof define === 'function' && typeof define.amd === 'object' && define.amd) define(function() {
        return ExecutionEnvironment;
    });
    else if (0, module.exports) module.exports = ExecutionEnvironment;
    else window.ExecutionEnvironment = ExecutionEnvironment;
})();

});

parcelRegister("epxCz", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TouchScrollable = undefined;
var $a7dd7aedb3dfffe8$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $a7dd7aedb3dfffe8$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

var $5FkrB = parcelRequire("5FkrB");

var $61SNt = parcelRequire("61SNt");

var $jmnQv = parcelRequire("jmnQv");
function $a7dd7aedb3dfffe8$var$_objectWithoutProperties(obj, keys) {
    var target = {};
    for(var i in obj){
        if (keys.indexOf(i) >= 0) continue;
        if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
        target[i] = obj[i];
    }
    return target;
}
function $a7dd7aedb3dfffe8$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $a7dd7aedb3dfffe8$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $a7dd7aedb3dfffe8$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $a7dd7aedb3dfffe8$var$TouchScrollable = module.exports.TouchScrollable = function(_PureComponent) {
    $a7dd7aedb3dfffe8$var$_inherits(TouchScrollable, _PureComponent);
    function TouchScrollable() {
        var _ref;
        var _temp, _this, _ret;
        $a7dd7aedb3dfffe8$var$_classCallCheck(this, TouchScrollable);
        for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return _ret = (_temp = (_this = $a7dd7aedb3dfffe8$var$_possibleConstructorReturn(this, (_ref = TouchScrollable.__proto__ || Object.getPrototypeOf(TouchScrollable)).call.apply(_ref, [
            this
        ].concat(args))), _this), _this.getScrollableArea = function(ref) {
            _this.scrollableArea = ref;
        }, _temp), $a7dd7aedb3dfffe8$var$_possibleConstructorReturn(_this, _ret);
    }
    $a7dd7aedb3dfffe8$var$_createClass(TouchScrollable, [
        {
            key: 'componentDidMount',
            value: function componentDidMount() {
                if (!$61SNt.canUseEventListeners) return;
                this.scrollableArea.addEventListener('touchstart', $jmnQv.preventInertiaScroll, $jmnQv.listenerOptions);
                this.scrollableArea.addEventListener('touchmove', $jmnQv.allowTouchMove, $jmnQv.listenerOptions);
            }
        },
        {
            key: 'componentWillUnmount',
            value: function componentWillUnmount() {
                if (!$61SNt.canUseEventListeners) return;
                this.scrollableArea.removeEventListener('touchstart', $jmnQv.preventInertiaScroll, $jmnQv.listenerOptions);
                this.scrollableArea.removeEventListener('touchmove', $jmnQv.allowTouchMove, $jmnQv.listenerOptions);
            }
        },
        {
            key: 'render',
            value: function render() {
                var _props = this.props, children = _props.children, rest = $a7dd7aedb3dfffe8$var$_objectWithoutProperties(_props, [
                    'children'
                ]);
                return typeof children === 'function' ? children(this.getScrollableArea) : (0, $5FkrB.cloneElement)(children, $a7dd7aedb3dfffe8$var$_extends({
                    ref: this.getScrollableArea
                }, rest));
            }
        }
    ]);
    return TouchScrollable;
}($5FkrB.PureComponent);

});
parcelRegister("jmnQv", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.pipe = module.exports.listenerOptions = undefined;
module.exports.preventTouchMove = $e18291ad983e38c7$var$preventTouchMove;
module.exports.allowTouchMove = $e18291ad983e38c7$var$allowTouchMove;
module.exports.preventInertiaScroll = $e18291ad983e38c7$var$preventInertiaScroll;
module.exports.isTouchDevice = $e18291ad983e38c7$var$isTouchDevice;
module.exports.camelToKebab = $e18291ad983e38c7$var$camelToKebab;
module.exports.parse = $e18291ad983e38c7$var$parse;
module.exports.getPadding = $e18291ad983e38c7$var$getPadding;
module.exports.getWindowHeight = $e18291ad983e38c7$var$getWindowHeight;
module.exports.getDocumentHeight = $e18291ad983e38c7$var$getDocumentHeight;
module.exports.makeStyleTag = $e18291ad983e38c7$var$makeStyleTag;
module.exports.injectStyles = $e18291ad983e38c7$var$injectStyles;
module.exports.insertStyleTag = $e18291ad983e38c7$var$insertStyleTag;

var $61SNt = parcelRequire("61SNt");
var $e18291ad983e38c7$var$listenerOptions = module.exports.listenerOptions = {
    capture: false,
    passive: false
};
// ==============================
// Touch Helpers
// ==============================
function $e18291ad983e38c7$var$preventTouchMove(e) {
    e.preventDefault();
    return false;
}
function $e18291ad983e38c7$var$allowTouchMove(e) {
    var target = e.currentTarget;
    if (target.scrollHeight > target.clientHeight) {
        e.stopPropagation();
        return true;
    }
    e.preventDefault();
    return false;
}
function $e18291ad983e38c7$var$preventInertiaScroll() {
    var top = this.scrollTop;
    var totalScroll = this.scrollHeight;
    var currentScroll = top + this.offsetHeight;
    if (top === 0) this.scrollTop = 1;
    else if (currentScroll === totalScroll) this.scrollTop = top - 1;
}
// `ontouchstart` check works on most browsers
// `maxTouchPoints` works on IE10/11 and Surface
function $e18291ad983e38c7$var$isTouchDevice() {
    if (!$61SNt.canUseDOM) return false;
    return 'ontouchstart' in window || navigator.maxTouchPoints;
}
// ==============================
// Misc.
// ==============================
function $e18291ad983e38c7$var$camelToKebab(str) {
    return str.replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase();
}
function $e18291ad983e38c7$var$parse(val) {
    return isNaN(val) ? val : val + 'px';
}
// Take a list of functions and return a function that applies the list of
// functions from left to right
var $e18291ad983e38c7$var$pipeFns = function pipeFns(a, b) {
    return function() {
        return b(a.apply(undefined, arguments));
    };
};
var $e18291ad983e38c7$var$pipe = module.exports.pipe = function pipe() {
    for(var _len = arguments.length, fns = Array(_len), _key = 0; _key < _len; _key++)fns[_key] = arguments[_key];
    return fns.reduce($e18291ad983e38c7$var$pipeFns);
};
// ==============================
// Document Helpers
// ==============================
function $e18291ad983e38c7$var$getPadding() {
    if (!$61SNt.canUseDOM) return 0;
    var paddingRight = parseInt(window.getComputedStyle(document.body).paddingRight, 10);
    var scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
    return paddingRight + scrollbarWidth;
}
function $e18291ad983e38c7$var$getWindowHeight() {
    var multiplier = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
    if ($61SNt.canUseDOM) return window.innerHeight * multiplier;
}
function $e18291ad983e38c7$var$getDocumentHeight() {
    if ($61SNt.canUseDOM) return document.body.clientHeight;
}
// ==============================
// Style Sheets
// ==============================
function $e18291ad983e38c7$var$makeStyleTag() {
    if (!$61SNt.canUseDOM) return;
    var tag = document.createElement('style');
    tag.type = 'text/css';
    tag.setAttribute('data-react-scrolllock', '');
    return tag;
}
function $e18291ad983e38c7$var$injectStyles(tag, css) {
    if (!$61SNt.canUseDOM) return;
    if (tag.styleSheet) tag.styleSheet.cssText = css;
    else tag.appendChild(document.createTextNode(css));
}
function $e18291ad983e38c7$var$insertStyleTag(tag) {
    if (!$61SNt.canUseDOM) return;
    var head = document.head || document.getElementsByTagName('head')[0];
    head.appendChild(tag);
}

});


parcelRegister("4dm8g", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $31198b58f382798e$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
module.exports.default = $31198b58f382798e$var$withLockSheet;

var $5FkrB = parcelRequire("5FkrB");
var $31198b58f382798e$var$_react2 = $31198b58f382798e$var$_interopRequireDefault($5FkrB);

var $jmnQv = parcelRequire("jmnQv");
function $31198b58f382798e$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $31198b58f382798e$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $31198b58f382798e$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $31198b58f382798e$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
function $31198b58f382798e$var$withLockSheet(WrappedComponent) {
    return function(_PureComponent) {
        $31198b58f382798e$var$_inherits(SheetProvider, _PureComponent);
        function SheetProvider() {
            var _ref;
            var _temp, _this, _ret;
            $31198b58f382798e$var$_classCallCheck(this, SheetProvider);
            for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            return _ret = (_temp = (_this = $31198b58f382798e$var$_possibleConstructorReturn(this, (_ref = SheetProvider.__proto__ || Object.getPrototypeOf(SheetProvider)).call.apply(_ref, [
                this
            ].concat(args))), _this), _this.addSheet = function() {
                var styles = _this.getStyles();
                var sheet = (0, $jmnQv.makeStyleTag)();
                if (!sheet) return;
                (0, $jmnQv.injectStyles)(sheet, styles);
                (0, $jmnQv.insertStyleTag)(sheet);
                _this.sheet = sheet;
            }, _this.getStyles = function() {
                var accountForScrollbars = _this.props.accountForScrollbars;
                var height = (0, $jmnQv.getDocumentHeight)();
                var paddingRight = accountForScrollbars ? (0, $jmnQv.getPadding)() : null;
                var styles = 'body {\n        box-sizing: border-box !important;\n        overflow: hidden !important;\n        position: relative !important;\n        ' + (height ? 'height: ' + height + 'px !important;' : '') + '\n        ' + (paddingRight ? 'padding-right: ' + paddingRight + 'px !important;' : '') + '\n      }';
                return styles;
            }, _temp), $31198b58f382798e$var$_possibleConstructorReturn(_this, _ret);
        }
        $31198b58f382798e$var$_createClass(SheetProvider, [
            {
                key: 'componentDidMount',
                value: function componentDidMount() {
                    this.addSheet();
                }
            },
            {
                key: 'removeSheet',
                value: function removeSheet() {
                    if (!this.sheet) return;
                    // $FlowFixMe
                    this.sheet.parentNode.removeChild(this.sheet);
                    this.sheet = null;
                }
            },
            {
                key: 'componentWillUnmount',
                value: function componentWillUnmount() {
                    this.removeSheet();
                }
            },
            {
                key: 'render',
                value: function render() {
                    return $31198b58f382798e$var$_react2.default.createElement(WrappedComponent, this.props);
                }
            }
        ]);
        return SheetProvider;
    }($5FkrB.PureComponent);
}

});

parcelRegister("8KBm9", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $65ef98c39640e000$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
module.exports.default = $65ef98c39640e000$var$withTouchListeners;

var $5FkrB = parcelRequire("5FkrB");
var $65ef98c39640e000$var$_react2 = $65ef98c39640e000$var$_interopRequireDefault($5FkrB);

var $61SNt = parcelRequire("61SNt");

var $jmnQv = parcelRequire("jmnQv");
function $65ef98c39640e000$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $65ef98c39640e000$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $65ef98c39640e000$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $65ef98c39640e000$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
// Mobile Safari ignores { overflow: hidden } declaration on the body,
// so we have to prevent touchmove events via JS
function $65ef98c39640e000$var$withTouchListeners(WrappedComponent) {
    return function(_PureComponent) {
        $65ef98c39640e000$var$_inherits(TouchProvider, _PureComponent);
        function TouchProvider() {
            $65ef98c39640e000$var$_classCallCheck(this, TouchProvider);
            return $65ef98c39640e000$var$_possibleConstructorReturn(this, (TouchProvider.__proto__ || Object.getPrototypeOf(TouchProvider)).apply(this, arguments));
        }
        $65ef98c39640e000$var$_createClass(TouchProvider, [
            {
                key: 'componentDidMount',
                value: function componentDidMount() {
                    if (!$61SNt.canUseDOM || !(0, $jmnQv.isTouchDevice)()) return;
                    document.addEventListener('touchmove', $jmnQv.preventTouchMove, $jmnQv.listenerOptions);
                }
            },
            {
                key: 'componentWillUnmount',
                value: function componentWillUnmount() {
                    if (!$61SNt.canUseDOM || !(0, $jmnQv.isTouchDevice)()) return;
                    document.removeEventListener('touchmove', $jmnQv.preventTouchMove, $jmnQv.listenerOptions);
                }
            },
            {
                key: 'render',
                value: function render() {
                    return $65ef98c39640e000$var$_react2.default.createElement(WrappedComponent, this.props);
                }
            }
        ]);
        return TouchProvider;
    }($5FkrB.PureComponent);
}

});



parcelRegister("1qBWl", function(module, exports) {
$parcel$export(module.exports, "default", () => $10a5a63f6ce4b0e3$export$2e2bcd8739ae039);
/* blanket.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $25nEq = parcelRequire("25nEq");

var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");
var $cAVP0 = parcelRequire("cAVP0");

var $cIdgB = parcelRequire("cIdgB");

var $eVb4V = parcelRequire("eVb4V");

var $k5KM6 = parcelRequire("k5KM6");

function $10a5a63f6ce4b0e3$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $10a5a63f6ce4b0e3$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $10a5a63f6ce4b0e3$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $10a5a63f6ce4b0e3$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $10a5a63f6ce4b0e3$var$packageName = "@atlaskit/blanket";
var $10a5a63f6ce4b0e3$var$packageVersion = "0.0.0-development";
var $10a5a63f6ce4b0e3$var$analyticsAttributes = {
    componentName: 'blanket',
    packageName: $10a5a63f6ce4b0e3$var$packageName,
    packageVersion: $10a5a63f6ce4b0e3$var$packageVersion
};
var $10a5a63f6ce4b0e3$var$baseStyles = null;
var $10a5a63f6ce4b0e3$var$shouldAllowClickThroughStyles = null;
var $10a5a63f6ce4b0e3$var$invisibleStyles = null;
/**
 * __Blanket__
 *
 * A Blanket provides the overlay layer for components such as a modal dialog or a tooltip
 *
 * - [Examples](https://atlaskit.atlassian.com/examples/design-system/blanket/basic-usage)
 */ var $10a5a63f6ce4b0e3$var$Blanket = /*#__PURE__*/ (0, $5FkrB.memo)(/*#__PURE__*/ (0, $5FkrB.forwardRef)(function Blanket(_ref, ref) {
    var _ref$shouldAllowClick = _ref.shouldAllowClickThrough, shouldAllowClickThrough = _ref$shouldAllowClick === void 0 ? false : _ref$shouldAllowClick, _ref$isTinted = _ref.isTinted, isTinted = _ref$isTinted === void 0 ? false : _ref$isTinted, _ref$onBlanketClicked = _ref.onBlanketClicked, onBlanketClicked = _ref$onBlanketClicked === void 0 ? (0, $eVb4V.default) : _ref$onBlanketClicked, testId = _ref.testId, children = _ref.children, analyticsContext = _ref.analyticsContext;
    var mouseDownTarget = (0, $5FkrB.useRef)(null);
    var onBlanketClickedWithAnalytics = (0, $cIdgB.usePlatformLeafEventHandler)($10a5a63f6ce4b0e3$var$_objectSpread({
        fn: onBlanketClicked,
        action: 'clicked',
        analyticsData: analyticsContext
    }, $10a5a63f6ce4b0e3$var$analyticsAttributes));
    var blanketClickOutsideChildren = (0, $5FkrB.useCallback)(function(e) {
        return e.currentTarget === e.target && mouseDownTarget.current === e.target ? onBlanketClickedWithAnalytics(e) : undefined;
    }, [
        onBlanketClickedWithAnalytics
    ]);
    var onClick = shouldAllowClickThrough ? undefined : blanketClickOutsideChildren;
    var onMouseDown = (0, $5FkrB.useCallback)(function(e) {
        mouseDownTarget.current = e.target;
    }, []);
    return /*#__PURE__*/ $5FkrB.createElement("div", {
        role: "presentation",
        onClick: onClick,
        onMouseDown: onMouseDown,
        "data-testid": testId,
        ref: ref,
        className: (0, $970q7.default)([
            "_1r04idpf _kqsw1n9t _1pbybfng _bfhk705f _18m91wug _lcxv1wug",
            shouldAllowClickThrough && "_lcxvglyw",
            !isTinted && "_bfhk1j28"
        ]),
        style: {
            "--_10avjlk": (0, $cAVP0.default)("var(--ds-blanket, ".concat((0, $k5KM6.N100A), ")"))
        }
    }, children);
}));
$10a5a63f6ce4b0e3$var$Blanket.displayName = 'Blanket';
var $10a5a63f6ce4b0e3$export$2e2bcd8739ae039 = $10a5a63f6ce4b0e3$var$Blanket;

});
parcelRegister("cIdgB", function(module, exports) {
$parcel$export(module.exports, "usePlatformLeafEventHandler", () => $9413e2972bdca877$export$a4687b0234b40e28);

var $25nEq = parcelRequire("25nEq");

var $5FkrB = parcelRequire("5FkrB");

var $k3YQ4 = parcelRequire("k3YQ4");

var $8l35U = parcelRequire("8l35U");
function $9413e2972bdca877$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $9413e2972bdca877$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $9413e2972bdca877$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $9413e2972bdca877$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $9413e2972bdca877$export$a4687b0234b40e28(_ref) {
    var fn = _ref.fn, action = _ref.action, componentName = _ref.componentName, actionSubject = _ref.actionSubject, packageName = _ref.packageName, packageVersion = _ref.packageVersion, analyticsData = _ref.analyticsData;
    var _useAnalyticsEvents = (0, $k3YQ4.useAnalyticsEvents)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
    // We put analyticsData and fn in a ref so that we don't need to break
    // memoization.
    // Generally these could be defined by consumers inline
    // and so we do this to avoid breaking memoization of useCallback
    var dataRef = (0, $8l35U.useTrackedRef)(analyticsData);
    var fnRef = (0, $8l35U.useTrackedRef)(fn);
    var handler = (0, $5FkrB.useCallback)(function(value) {
        var analyticsEvent = createAnalyticsEvent({
            action: action,
            actionSubject: actionSubject || componentName,
            attributes: {
                componentName: componentName,
                packageName: packageName,
                packageVersion: packageVersion
            }
        });
        // To avoid wrapping this component in AnalyticsContext we manually
        // push the parent context's meta data into the context.
        // Note: this new 'context'
        var context = $9413e2972bdca877$var$_objectSpread({
            componentName: componentName,
            packageName: packageName,
            packageVersion: packageVersion
        }, dataRef.current);
        analyticsEvent.context.push(context);
        // fire an event on the atlaskit channel
        var clone = analyticsEvent.clone();
        if (clone) clone.fire('atlaskit');
        fnRef.current(value, analyticsEvent);
    }, [
        // These are strings and won't change
        action,
        componentName,
        actionSubject,
        packageName,
        packageVersion,
        // This function is memoized in the context
        createAnalyticsEvent,
        // these are a stable ref because of the useTrackedRef hook
        dataRef,
        fnRef
    ]);
    return handler;
}

});
parcelRegister("k3YQ4", function(module, exports) {
$parcel$export(module.exports, "useAnalyticsEvents", () => $e9b347c4c72c058d$export$5bf35293e545f20c);

var $dLGML = parcelRequire("dLGML");

var $kNZH6 = parcelRequire("kNZH6");

var $csYzD = parcelRequire("csYzD");
function $e9b347c4c72c058d$export$5bf35293e545f20c() {
    var analyticsContext = (0, $csYzD.useAnalyticsContext)();
    var createAnalyticsEvent = (0, $dLGML.useCallbackOne)(function(payload) {
        return new (0, $kNZH6.default)({
            context: analyticsContext.getAtlaskitAnalyticsContext(),
            handlers: analyticsContext.getAtlaskitAnalyticsEventHandlers(),
            payload: payload
        });
    }, [
        analyticsContext
    ]);
    return {
        createAnalyticsEvent: createAnalyticsEvent
    };
}

});
parcelRegister("kNZH6", function(module, exports) {
$parcel$export(module.exports, "default", () => $f2583d6b776f194f$export$2e2bcd8739ae039);

var $fC8ib = parcelRequire("fC8ib");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $kIXpt = parcelRequire("kIXpt");

var $cYPzS = parcelRequire("cYPzS");

var $lwlXp = parcelRequire("lwlXp");

var $eyuDe = parcelRequire("eyuDe");

var $25nEq = parcelRequire("25nEq");

var $eQ0s8 = parcelRequire("eQ0s8");
function $f2583d6b776f194f$var$_callSuper(t, o, e) {
    return o = (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(o), (0, (/*@__PURE__*/$parcel$interopDefault($kIXpt)))(t, $f2583d6b776f194f$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(t).constructor) : o.apply(t, e));
}
function $f2583d6b776f194f$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($f2583d6b776f194f$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $f2583d6b776f194f$var$_superPropGet(t, o, e, r) {
    var p = (0, (/*@__PURE__*/$parcel$interopDefault($lwlXp)))((0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(1 & r ? t.prototype : t), o, e);
    return 2 & r && "function" == typeof p ? function(t) {
        return p.apply(e, t);
    } : p;
}
var $f2583d6b776f194f$export$35f8383928ba8d7 = function isUIAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $f2583d6b776f194f$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isUIAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === 'UIAnalyticsEvent';
};
var $f2583d6b776f194f$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_AnalyticsEvent) {
    function UIAnalyticsEvent(props) {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, UIAnalyticsEvent);
        _this = $f2583d6b776f194f$var$_callSuper(this, UIAnalyticsEvent, [
            props
        ]);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "_isUIAnalyticsEvent", true);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "clone", function() {
            if (_this.hasFired) return null;
            var context = (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(_this.context);
            var handlers = (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(_this.handlers);
            /**
       * A hacky "deep clone" of the object. This is limited in that it wont
       * support functions, regexs, Maps, Sets, etc, but none of those need to
       * be represented in our payload.
       */ var payload = JSON.parse(JSON.stringify(_this.payload));
            return new UIAnalyticsEvent({
                context: context,
                handlers: handlers,
                payload: payload
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "fire", function(channel) {
            if (_this.hasFired) return;
            _this.handlers.forEach(function(handler) {
                return handler(_this, channel);
            });
            _this.hasFired = true;
        });
        _this.context = props.context || [];
        _this.handlers = props.handlers || [];
        _this.hasFired = false;
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($eyuDe)))(UIAnalyticsEvent, _AnalyticsEvent);
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(UIAnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (this.hasFired) return this;
                return $f2583d6b776f194f$var$_superPropGet(UIAnalyticsEvent, "update", this, 3)([
                    updater
                ]);
            }
        }
    ]);
}((0, $eQ0s8.default));

});
parcelRegister("eQ0s8", function(module, exports) {
$parcel$export(module.exports, "default", () => $acd645f250b56966$export$2e2bcd8739ae039);

var $ekGgq = parcelRequire("ekGgq");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $25nEq = parcelRequire("25nEq");
function $acd645f250b56966$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $acd645f250b56966$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $acd645f250b56966$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $acd645f250b56966$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $acd645f250b56966$export$ad4be5c2ec28cecf = function isAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $acd645f250b56966$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === 'AnalyticsEvent';
};
var $acd645f250b56966$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function AnalyticsEvent(props) {
        var _this = this;
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, AnalyticsEvent);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "_isAnalyticsEvent", true);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "clone", function() {
            // just a shallow clone, don't change sub refs unless you want to
            // affect the original's too
            var payload = $acd645f250b56966$var$_objectSpread({}, _this.payload);
            return new AnalyticsEvent({
                payload: payload
            });
        });
        this.payload = props.payload;
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(AnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (typeof updater === 'function') this.payload = updater(this.payload);
                if ((0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(updater) === 'object') this.payload = $acd645f250b56966$var$_objectSpread($acd645f250b56966$var$_objectSpread({}, this.payload), updater);
                return this;
            }
        }
    ]);
}();

});


parcelRegister("csYzD", function(module, exports) {
$parcel$export(module.exports, "useAnalyticsContext", () => $9137164068814680$export$d1f587f82ad51c4);

var $5FkrB = parcelRequire("5FkrB");

var $iyyOp = parcelRequire("iyyOp");
var $9137164068814680$export$d1f587f82ad51c4 = function useAnalyticsContext() {
    return (0, $5FkrB.useContext)((0, $iyyOp.default));
};

});


parcelRegister("8l35U", function(module, exports) {
$parcel$export(module.exports, "useTrackedRef", () => $6122af5d102e8bcf$export$1d27a74659855e44);

var $5FkrB = parcelRequire("5FkrB");
var $6122af5d102e8bcf$export$1d27a74659855e44 = function useTrackedRef(value) {
    var ref = (0, $5FkrB.useRef)(value);
    ref.current = value;
    return ref;
};

});


parcelRegister("k5KM6", function(module, exports) {
$parcel$export(module.exports, "N100A", () => $ea088ec52f1f7ae6$export$486ab785e4bac3c6);
// Reds
var $ea088ec52f1f7ae6$export$4b84fd0e2c617bd = '#FFEBE6';
var $ea088ec52f1f7ae6$export$b34b069eff244586 = '#FFBDAD';
var $ea088ec52f1f7ae6$export$be802dd0d8b57f35 = '#FF8F73';
var $ea088ec52f1f7ae6$export$60847d42f9da92a6 = '#FF7452';
var $ea088ec52f1f7ae6$export$4a7404f376229999 = '#FF5630';
var $ea088ec52f1f7ae6$export$2010d0fb4295b346 = '#DE350B';
var $ea088ec52f1f7ae6$export$2837b5a1a71d5c02 = '#BF2600';
var $ea088ec52f1f7ae6$export$8d9596b529bbb9cf = '#FFFAE6';
var $ea088ec52f1f7ae6$export$41060a744ab0b7ae = '#FFF0B3';
var $ea088ec52f1f7ae6$export$1cc05bbbf340e559 = '#FFE380';
var $ea088ec52f1f7ae6$export$5aae31392d72caaa = '#FFC400';
var $ea088ec52f1f7ae6$export$c6930421db9fa514 = '#FFAB00';
var $ea088ec52f1f7ae6$export$59619663aa6500fb = '#FF991F';
var $ea088ec52f1f7ae6$export$874739ea9e379ab6 = '#FF8B00';
var $ea088ec52f1f7ae6$export$8a6341c32b6a3ee6 = '#E3FCEF';
var $ea088ec52f1f7ae6$export$69a3bf21b9686c2b = '#ABF5D1';
var $ea088ec52f1f7ae6$export$afbce1382ec95f73 = '#79F2C0';
var $ea088ec52f1f7ae6$export$747d86715d4175de = '#57D9A3';
var $ea088ec52f1f7ae6$export$940e1f69e873f202 = '#36B37E';
var $ea088ec52f1f7ae6$export$a49394138f7b8e85 = '#00875A';
var $ea088ec52f1f7ae6$export$6fa04827ac68a4fb = '#006644';
var $ea088ec52f1f7ae6$export$226de0355ed012f8 = '#DEEBFF';
var $ea088ec52f1f7ae6$export$8c13c2ee36917869 = '#B3D4FF';
var $ea088ec52f1f7ae6$export$ecfc1dff386a3e7a = '#4C9AFF';
var $ea088ec52f1f7ae6$export$215b7063051591f1 = '#2684FF';
var $ea088ec52f1f7ae6$export$e62e8919cca44969 = '#0065FF';
var $ea088ec52f1f7ae6$export$b3de0ae08da2ce64 = '#0052CC';
var $ea088ec52f1f7ae6$export$a6ee3d71bc067634 = '#0747A6';
var $ea088ec52f1f7ae6$export$67f15409e87642a1 = '#669DF1';
var $ea088ec52f1f7ae6$export$f0539dbc42dbb067 = '#8FB8F6';
var $ea088ec52f1f7ae6$export$363e4475840015bb = '#EAE6FF';
var $ea088ec52f1f7ae6$export$4b0a4417ed59760f = '#C0B6F2';
var $ea088ec52f1f7ae6$export$6011520a64d9a187 = '#998DD9';
var $ea088ec52f1f7ae6$export$a7175d4e9206bc80 = '#8777D9';
var $ea088ec52f1f7ae6$export$b48405b95304b5a1 = '#6554C0';
var $ea088ec52f1f7ae6$export$c71e4279dd54a18d = '#5243AA';
var $ea088ec52f1f7ae6$export$147899de772240ec = '#403294';
var $ea088ec52f1f7ae6$export$2cf711fe14c66f06 = '#E6FCFF';
var $ea088ec52f1f7ae6$export$7a8f4d33f6f9772c = '#B3F5FF';
var $ea088ec52f1f7ae6$export$776c9c497ef08533 = '#79E2F2';
var $ea088ec52f1f7ae6$export$69cb3ca10c1e330e = '#00C7E6';
var $ea088ec52f1f7ae6$export$9dc1ef0f3f48059b = '#00B8D9';
var $ea088ec52f1f7ae6$export$7c835c78b6fcdef8 = '#00A3BF';
var $ea088ec52f1f7ae6$export$6036577f95c3877e = '#008DA6';
var $ea088ec52f1f7ae6$export$29a4f05edc054374 = '#FFFFFF';
var $ea088ec52f1f7ae6$export$e655ef011c4aa1a2 = '#FAFBFC';
var $ea088ec52f1f7ae6$export$9fdfb749e33cdf97 = '#F4F5F7';
var $ea088ec52f1f7ae6$export$3e51e8f1440314ba = '#EBECF0';
var $ea088ec52f1f7ae6$export$1ce2d1575d444ceb = '#DFE1E6';
var $ea088ec52f1f7ae6$export$8754fc7e6d8b3000 = '#C1C7D0';
var $ea088ec52f1f7ae6$export$c2e91cbeada39b8b = '#B3BAC5';
var $ea088ec52f1f7ae6$export$5f71e19f3a7ad9de = '#A5ADBA';
var $ea088ec52f1f7ae6$export$eaa8c8a70ac22806 = '#97A0AF';
var $ea088ec52f1f7ae6$export$7c87d337fb91a97d = '#8993A4';
var $ea088ec52f1f7ae6$export$d6447c357493214f = '#7A869A';
var $ea088ec52f1f7ae6$export$f563ee71e9ee74cd = '#6B778C';
var $ea088ec52f1f7ae6$export$e2ef2124cf4024b1 = '#5E6C84';
var $ea088ec52f1f7ae6$export$eece5f492e429f08 = '#505F79';
var $ea088ec52f1f7ae6$export$c39c0fe0f26207ae = '#42526E';
var $ea088ec52f1f7ae6$export$7090862dc3038a9f = '#344563';
var $ea088ec52f1f7ae6$export$ad0bacf983b7ddaa = '#253858';
var $ea088ec52f1f7ae6$export$7d61b15e0da132af = '#172B4D';
var $ea088ec52f1f7ae6$export$fbda843f0a27fe96 = '#091E42';
var $ea088ec52f1f7ae6$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
var $ea088ec52f1f7ae6$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
var $ea088ec52f1f7ae6$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
var $ea088ec52f1f7ae6$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
var $ea088ec52f1f7ae6$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
var $ea088ec52f1f7ae6$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
var $ea088ec52f1f7ae6$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
var $ea088ec52f1f7ae6$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
var $ea088ec52f1f7ae6$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
var $ea088ec52f1f7ae6$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
var $ea088ec52f1f7ae6$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
var $ea088ec52f1f7ae6$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
var $ea088ec52f1f7ae6$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
var $ea088ec52f1f7ae6$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
var $ea088ec52f1f7ae6$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
var $ea088ec52f1f7ae6$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
var $ea088ec52f1f7ae6$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
var $ea088ec52f1f7ae6$export$2f6319cf7d736c2a = '#E6EDFA';
var $ea088ec52f1f7ae6$export$95126bc8884d6634 = '#DCE5F5';
var $ea088ec52f1f7ae6$export$8338d8c35d44ff1 = '#CED9EB';
var $ea088ec52f1f7ae6$export$5368d76ae4fbbda7 = '#B8C7E0';
var $ea088ec52f1f7ae6$export$9f0a771d16ec8d36 = '#ABBBD6';
var $ea088ec52f1f7ae6$export$abcf8c38338b4aa5 = '#9FB0CC';
var $ea088ec52f1f7ae6$export$97e81faa16a182c7 = '#8C9CB8';
var $ea088ec52f1f7ae6$export$bfe21c59123ecf33 = '#7988A3';
var $ea088ec52f1f7ae6$export$ee82aa2ea6a1558 = '#67758F';
var $ea088ec52f1f7ae6$export$682927c6ed76be02 = '#56637A';
var $ea088ec52f1f7ae6$export$91fd9994c5be9757 = '#455166';
var $ea088ec52f1f7ae6$export$d281fbfe3cff2df6 = '#3B475C';
var $ea088ec52f1f7ae6$export$3902c91d8b98a753 = '#313D52';
var $ea088ec52f1f7ae6$export$8e8133c1ba5845b5 = '#283447';
var $ea088ec52f1f7ae6$export$33ff357f6620b39 = '#202B3D';
var $ea088ec52f1f7ae6$export$633847cf062b69e0 = '#1B2638';
var $ea088ec52f1f7ae6$export$9776a6e503bdbf76 = '#121A29';
var $ea088ec52f1f7ae6$export$6c813d5160dff5db = '#0E1624';
var $ea088ec52f1f7ae6$export$3d4f271a500072a = '#0D1424';
var $ea088ec52f1f7ae6$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
var $ea088ec52f1f7ae6$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
var $ea088ec52f1f7ae6$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
var $ea088ec52f1f7ae6$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
var $ea088ec52f1f7ae6$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
var $ea088ec52f1f7ae6$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
var $ea088ec52f1f7ae6$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
var $ea088ec52f1f7ae6$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
var $ea088ec52f1f7ae6$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
var $ea088ec52f1f7ae6$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
var $ea088ec52f1f7ae6$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
var $ea088ec52f1f7ae6$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
var $ea088ec52f1f7ae6$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
var $ea088ec52f1f7ae6$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
var $ea088ec52f1f7ae6$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
var $ea088ec52f1f7ae6$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
var $ea088ec52f1f7ae6$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';
var $ea088ec52f1f7ae6$export$d2adc5dedf09fced = '#292A2E';
var $ea088ec52f1f7ae6$export$f51762073d2bb381 = '#94C748';
var $ea088ec52f1f7ae6$export$95e26d54def96891 = '#B3DF72';

});


parcelRegister("jkmxD", function(module, exports) {
$parcel$export(module.exports, "combine", () => (parcelRequire("fGFYU")).combine);

var $fGFYU = parcelRequire("fGFYU");

});
parcelRegister("fGFYU", function(module, exports) {
$parcel$export(module.exports, "combine", () => $b6bb57e4a4d18bce$export$1be1fc439b849fdf);
/** Create a new combined function that will call all the provided functions */ function $b6bb57e4a4d18bce$export$1be1fc439b849fdf() {
    for(var _len = arguments.length, fns = new Array(_len), _key = 0; _key < _len; _key++)fns[_key] = arguments[_key];
    return function cleanup() {
        fns.forEach(function(fn) {
            return fn();
        });
    };
}

});


parcelRegister("5ldyY", function(module, exports) {
$parcel$export(module.exports, "draggable", () => (parcelRequire("f8loy")).draggable);
$parcel$export(module.exports, "dropTargetForElements", () => (parcelRequire("f8loy")).dropTargetForElements);
$parcel$export(module.exports, "monitorForElements", () => (parcelRequire("f8loy")).monitorForElements);

var $f8loy = parcelRequire("f8loy");
 // Payload for the draggable being dragged

});
parcelRegister("f8loy", function(module, exports) {
$parcel$export(module.exports, "dropTargetForElements", () => $b04832f95b4a814c$export$e7140b68045b5036);
$parcel$export(module.exports, "monitorForElements", () => $b04832f95b4a814c$export$59a074bac4c54f54);
$parcel$export(module.exports, "draggable", () => $b04832f95b4a814c$export$c746a5152d4ba26c);

var $iYJcE = parcelRequire("iYJcE");

var $7QpUe = parcelRequire("7QpUe");

var $dYpf0 = parcelRequire("dYpf0");

var $9yVBQ = parcelRequire("9yVBQ");

var $96VL5 = parcelRequire("96VL5");

var $fGFYU = parcelRequire("fGFYU");

var $hqNxG = parcelRequire("hqNxG");

var $dfTau = parcelRequire("dfTau");

var $2NDx0 = parcelRequire("2NDx0");

var $dM1qa = parcelRequire("dM1qa");

var $egYGR = parcelRequire("egYGR");

var $WZ6t3 = parcelRequire("WZ6t3");

var $ivIaH = parcelRequire("ivIaH");
var $b04832f95b4a814c$var$draggableRegistry = new WeakMap();
function $b04832f95b4a814c$var$addToRegistry(args) {
    $b04832f95b4a814c$var$draggableRegistry.set(args.element, args);
    return function cleanup() {
        $b04832f95b4a814c$var$draggableRegistry.delete(args.element);
    };
}
var $b04832f95b4a814c$var$honeyPotFix = (0, $9yVBQ.makeHoneyPotFix)();
var $b04832f95b4a814c$var$adapter = (0, $96VL5.makeAdapter)({
    typeKey: 'element',
    defaultDropEffect: 'move',
    mount: function mount(api) {
        /**  Binding event listeners the `document` rather than `window` so that
     * this adapter always gets preference over the text adapter.
     * `document` is the first `EventTarget` under `window`
     * https://twitter.com/alexandereardon/status/1604658588311465985
     */ return (0, $fGFYU.combine)($b04832f95b4a814c$var$honeyPotFix.bindEvents(), (0, $7QpUe.bind)(document, {
            type: 'dragstart',
            listener: function listener(event) {
                var _entry$dragHandle, _entry$getInitialData, _entry$getInitialData2, _entry$dragHandle2, _entry$getInitialData3, _entry$getInitialData4;
                if (!api.canStart(event)) return;
                // If the "dragstart" event is cancelled, then a drag won't start
                // There will be no further drag operation events (eg no "dragend" event)
                if (event.defaultPrevented) return;
                // Technically `dataTransfer` can be `null` according to the types
                // But that behaviour does not seem to appear in the spec.
                // If there is not `dataTransfer`, we can assume something is wrong and not
                // start a drag
                if (!event.dataTransfer) return;
                // the closest parent that is a draggable element will be marked as
                // the `event.target` for the event
                var target = event.target;
                // this source is only for elements
                // Note: only HTMLElements can have the "draggable" attribute
                if (!(target instanceof HTMLElement)) return;
                // see if the thing being dragged is owned by us
                var entry = $b04832f95b4a814c$var$draggableRegistry.get(target);
                // no matching element found
                // → dragging an element with `draggable="true"` that is not controlled by us
                if (!entry) return;
                /**
         * A text selection drag _can_ have the `draggable` element be
         * the `event.target` if the user is dragging the text selection
         * from the `draggable`.
         *
         * To know if the `draggable` is being dragged, we look at whether any
         * `"text/plain"` data is being dragged. If it is, then a text selection
         * drag is occurring.
         *
         * This behaviour has been validated on:
         *
         * - Chrome@128 on Android@14
         * - Chrome@128 on iOS@17.6.1
         * - Chrome@128 on Windows@11
         * - Chrome@128 on MacOS@14.6.1
         * - Firefox@129 on Windows@11 (not possible for user to select text in a draggable)
         * - Firefox@129 on MacOS@14.6.1 (not possible for user to select text in a draggable)
         *
         * Note: Could usually just use: `event.dataTransfer.types.includes(textMediaType)`
         * but unfortunately ProseMirror is always setting `""` as the dragged text
         *
         * Note: Unfortunately editor is (heavily) leaning on the current functionality today
         * and unwinding it will be a decent amount of effort. So for now, a text selection
         * where the `event.target` is a `draggable` element will still trigger the
         * element adapter.
         *
         * // Future state:
         * if(event.dataTransfer.getData(textMediaType)) {
         * 	return;
         * }
         *
         */ var input = (0, $dM1qa.getInput)(event);
                var feedback = {
                    element: entry.element,
                    dragHandle: (_entry$dragHandle = entry.dragHandle) !== null && _entry$dragHandle !== void 0 ? _entry$dragHandle : null,
                    input: input
                };
                // Check: does the draggable want to allow dragging?
                if (entry.canDrag && !entry.canDrag(feedback)) {
                    // cancel drag operation if we cannot drag
                    event.preventDefault();
                    return;
                }
                // Check: is there a drag handle and is the user using it?
                if (entry.dragHandle) {
                    // technically don't need this util, but just being
                    // consistent with how we look up what is under the users
                    // cursor.
                    var over = (0, $dYpf0.getElementFromPointWithoutHoneypot)({
                        x: input.clientX,
                        y: input.clientY
                    });
                    // if we are not dragging from the drag handle (or something inside the drag handle)
                    // then we will cancel the active drag
                    if (!entry.dragHandle.contains(over)) {
                        event.preventDefault();
                        return;
                    }
                }
                /**
         *  **Goal**
         *  Pass information to other applications
         *
         * **Approach**
         *  Put data into the native data store
         *
         *  **What about the native adapter?**
         *  When the element adapter puts native data into the native data store
         *  the native adapter is not triggered in the current window,
         *  but a native adapter in an external window _can_ be triggered
         *
         *  **Why bake this into core?**
         *  This functionality could be pulled out and exposed inside of
         *  `onGenerateDragPreview`. But decided to make it a part of the
         *  base API as it felt like a common enough use case and ended
         *  up being a similar amount of code to include this function as
         *  it was to expose the hook for it
         */ var nativeData = (_entry$getInitialData = (_entry$getInitialData2 = entry.getInitialDataForExternal) === null || _entry$getInitialData2 === void 0 ? void 0 : _entry$getInitialData2.call(entry, feedback)) !== null && _entry$getInitialData !== void 0 ? _entry$getInitialData : null;
                if (nativeData) for(var _i = 0, _Object$entries = Object.entries(nativeData); _i < _Object$entries.length; _i++){
                    var _Object$entries$_i = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_Object$entries[_i], 2), key = _Object$entries$_i[0], data = _Object$entries$_i[1];
                    event.dataTransfer.setData(key, data !== null && data !== void 0 ? data : '');
                }
                /**
         *  📱 For Android devices, a drag operation will not start unless
         * "text/plain" or "text/uri-list" data exists in the native data store
         * https://twitter.com/alexandereardon/status/1732189803754713424
         *
         * Tested on:
         * Device: Google Pixel 5
         * Android version: 14 (November 5, 2023)
         * Chrome version: 120.0
         */ if ((0, $2NDx0.isAndroid)() && !event.dataTransfer.types.includes((0, $egYGR.textMediaType)) && !event.dataTransfer.types.includes((0, $WZ6t3.URLMediaType))) event.dataTransfer.setData((0, $egYGR.textMediaType), (0, $2NDx0.androidFallbackText));
                /**
         * 1. Must set any media type for `iOS15` to work
         * 2. We are also doing adding data so that the native adapter
         * can know that the element adapter has handled this drag
         *
         * We used to wrap this `setData()` in a `try/catch` for Firefox,
         * but it looks like that was not needed.
         *
         * Tested using: https://codesandbox.io/s/checking-firefox-throw-behaviour-on-dragstart-qt8h4f
         *
         * - ✅ Firefox@70.0 (Oct 2019) on macOS Sonoma
         * - ✅ Firefox@70.0 (Oct 2019) on macOS Big Sur
         * - ✅ Firefox@70.0 (Oct 2019) on Windows 10
         *
         * // just checking a few more combinations to be super safe
         *
         * - ✅ Chrome@78 (Oct 2019) on macOS Big Sur
         * - ✅ Chrome@78 (Oct 2019) on Windows 10
         * - ✅ Safari@14.1 on macOS Big Sur
         */ event.dataTransfer.setData((0, $ivIaH.elementAdapterNativeDataKey), '');
                var payload = {
                    element: entry.element,
                    dragHandle: (_entry$dragHandle2 = entry.dragHandle) !== null && _entry$dragHandle2 !== void 0 ? _entry$dragHandle2 : null,
                    data: (_entry$getInitialData3 = (_entry$getInitialData4 = entry.getInitialData) === null || _entry$getInitialData4 === void 0 ? void 0 : _entry$getInitialData4.call(entry, feedback)) !== null && _entry$getInitialData3 !== void 0 ? _entry$getInitialData3 : {}
                };
                var dragType = {
                    type: 'element',
                    payload: payload,
                    startedFrom: 'internal'
                };
                api.start({
                    event: event,
                    dragType: dragType
                });
            }
        }));
    },
    dispatchEventToSource: function dispatchEventToSource(_ref) {
        var _draggableRegistry$ge, _draggableRegistry$ge2;
        var eventName = _ref.eventName, payload = _ref.payload;
        // During a drag operation, a draggable can be:
        // - remounted with different functions
        // - removed completely
        // So we need to get the latest entry from the registry in order
        // to call the latest event functions
        (_draggableRegistry$ge = $b04832f95b4a814c$var$draggableRegistry.get(payload.source.element)) === null || _draggableRegistry$ge === void 0 || (_draggableRegistry$ge2 = _draggableRegistry$ge[eventName]) === null || _draggableRegistry$ge2 === void 0 || _draggableRegistry$ge2.call(_draggableRegistry$ge, // I cannot seem to get the types right here.
        // TS doesn't seem to like that one event can need `nativeSetDragImage`
        // @ts-expect-error
        payload);
    },
    onPostDispatch: $b04832f95b4a814c$var$honeyPotFix.getOnPostDispatch()
});
var $b04832f95b4a814c$export$e7140b68045b5036 = $b04832f95b4a814c$var$adapter.dropTarget;
var $b04832f95b4a814c$export$59a074bac4c54f54 = $b04832f95b4a814c$var$adapter.monitor;
function $b04832f95b4a814c$export$c746a5152d4ba26c(args) {
    var existing;
    var cleanup = (0, $fGFYU.combine)(// making the draggable register the adapter rather than drop targets
    // this is because you *must* have a draggable element to start a drag
    // but you _might_ not have any drop targets immediately
    // (You might create drop targets async)
    $b04832f95b4a814c$var$adapter.registerUsage(), $b04832f95b4a814c$var$addToRegistry(args), (0, $dfTau.addAttribute)(args.element, {
        attribute: 'draggable',
        value: 'true'
    }));
    // Wrapping in `once` to prevent unexpected side effects if consumers call
    // the clean up function multiple times.
    return (0, $hqNxG.once)(cleanup);
} /** Common event payload for all events */  /** A map containing payloads for all events */  /** Common event payload for all drop target events */  /** A map containing payloads for all events on drop targets */  /** Arguments given to all feedback functions (eg `canDrag()`) on for a `draggable()` */  /** Arguments given to all feedback functions (eg `canDrop()`) on a `dropTargetForElements()` */  /** Arguments given to all monitor feedback functions (eg `canMonitor()`) for a `monitorForElements` */ 

});
parcelRegister("dYpf0", function(module, exports) {
$parcel$export(module.exports, "getElementFromPointWithoutHoneypot", () => $a2c4754b0fac697b$export$81d0353f25f5dd);

var $iYJcE = parcelRequire("iYJcE");

var $iz1zp = parcelRequire("iz1zp");
function $a2c4754b0fac697b$export$81d0353f25f5dd(client) {
    // eslint-disable-next-line no-restricted-syntax
    var _document$elementsFro = document.elementsFromPoint(client.x, client.y), _document$elementsFro2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_document$elementsFro, 2), top = _document$elementsFro2[0], second = _document$elementsFro2[1];
    if (!top) return null;
    if ((0, $iz1zp.isHoneyPotElement)(top)) return second !== null && second !== void 0 ? second : null;
    return top;
}

});
parcelRegister("iz1zp", function(module, exports) {
$parcel$export(module.exports, "isHoneyPotElement", () => $d83cb6a881bf6431$export$821bdcd739a2706b);

var $hNgn9 = parcelRequire("hNgn9");
function $d83cb6a881bf6431$export$821bdcd739a2706b(target) {
    return target instanceof Element && target.hasAttribute((0, $hNgn9.honeyPotDataAttribute));
}

});
parcelRegister("hNgn9", function(module, exports) {
$parcel$export(module.exports, "honeyPotDataAttribute", () => $cf43b67caec6451d$export$6eafea55f7947469);
// pulling this into a separate file so adapter(s) that don't
// need the honey pot can pay as little as possible for it.
var $cf43b67caec6451d$export$6eafea55f7947469 = 'data-pdnd-honey-pot';

});



parcelRegister("9yVBQ", function(module, exports) {
$parcel$export(module.exports, "makeHoneyPotFix", () => $6f63fa0f2e945f3a$export$8ecad27c959e89e0);

var $25nEq = parcelRequire("25nEq");

var $7QpUe = parcelRequire("7QpUe");

var $e6RxJ = parcelRequire("e6RxJ");

var $hNgn9 = parcelRequire("hNgn9");
function $6f63fa0f2e945f3a$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $6f63fa0f2e945f3a$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $6f63fa0f2e945f3a$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $6f63fa0f2e945f3a$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $6f63fa0f2e945f3a$var$honeyPotSize = 2;
var $6f63fa0f2e945f3a$var$halfHoneyPotSize = $6f63fa0f2e945f3a$var$honeyPotSize / 2;
/**
 * `clientX` and `clientY` can be in sub pixels (eg `2.332`)
 * However, browser hitbox testing is commonly do to the closest pixel.
 *
 * → https://issues.chromium.org/issues/40940531
 *
 * To be sure that the honey pot will be over the `client` position,
 * we `.floor()` `clientX` and`clientY` and then make it `2px` in size.
 **/ function $6f63fa0f2e945f3a$var$floorToClosestPixel(point) {
    return {
        x: Math.floor(point.x),
        y: Math.floor(point.y)
    };
}
/**
 * We want to make sure the honey pot sits around the users position.
 * This seemed to be the most resilient while testing.
 */ function $6f63fa0f2e945f3a$var$pullBackByHalfHoneyPotSize(point) {
    return {
        x: point.x - $6f63fa0f2e945f3a$var$halfHoneyPotSize,
        y: point.y - $6f63fa0f2e945f3a$var$halfHoneyPotSize
    };
}
/**
 * Prevent the honey pot from changing the window size.
 * This is super unlikely to occur, but just being safe.
 */ function $6f63fa0f2e945f3a$var$preventGoingBackwardsOffScreen(point) {
    return {
        x: Math.max(point.x, 0),
        y: Math.max(point.y, 0)
    };
}
/**
 * Prevent the honey pot from changing the window size.
 * This is super unlikely to occur, but just being safe.
 */ function $6f63fa0f2e945f3a$var$preventGoingForwardsOffScreen(point) {
    return {
        x: Math.min(point.x, window.innerWidth - $6f63fa0f2e945f3a$var$honeyPotSize),
        y: Math.min(point.y, window.innerHeight - $6f63fa0f2e945f3a$var$honeyPotSize)
    };
}
/**
 * Create a `2x2` `DOMRect` around the `client` position
 */ function $6f63fa0f2e945f3a$var$getHoneyPotRectFor(_ref) {
    var client = _ref.client;
    var point = $6f63fa0f2e945f3a$var$preventGoingForwardsOffScreen($6f63fa0f2e945f3a$var$preventGoingBackwardsOffScreen($6f63fa0f2e945f3a$var$pullBackByHalfHoneyPotSize($6f63fa0f2e945f3a$var$floorToClosestPixel(client))));
    // When debugging, it is helpful to
    // make this element a bit bigger
    return DOMRect.fromRect({
        x: point.x,
        y: point.y,
        width: $6f63fa0f2e945f3a$var$honeyPotSize,
        height: $6f63fa0f2e945f3a$var$honeyPotSize
    });
}
function $6f63fa0f2e945f3a$var$getRectStyles(_ref2) {
    var clientRect = _ref2.clientRect;
    return {
        left: "".concat(clientRect.left, "px"),
        top: "".concat(clientRect.top, "px"),
        width: "".concat(clientRect.width, "px"),
        height: "".concat(clientRect.height, "px")
    };
}
function $6f63fa0f2e945f3a$var$isWithin(_ref3) {
    var client = _ref3.client, clientRect = _ref3.clientRect;
    return(// is within horizontal bounds
    client.x >= clientRect.x && client.x <= clientRect.x + clientRect.width && // is within vertical bounds
    client.y >= clientRect.y && client.y <= clientRect.y + clientRect.height);
}
/**
 * The honey pot fix is designed to get around a painful bug in all browsers.
 *
 * [Overview](https://www.youtube.com/watch?v=udE9qbFTeQg)
 *
 * **Background**
 *
 * When a drag starts, browsers incorrectly think that the users pointer is
 * still depressed where the drag started. Any element that goes under this position
 * will be entered into, causing `"mouseenter"` events and `":hover"` styles to be applied.
 *
 * _This is a violation of the spec_
 *
 * > "From the moment that the user agent is to initiate the drag-and-drop operation,
 * > until the end 	of the drag-and-drop operation, device input events
 * > (e.g. mouse and keyboard events) must be suppressed."
 * >
 * > - https://html.spec.whatwg.org/multipage/dnd.html#drag-and-drop-processing-model
 *
 * _Some impacts_
 *
 * - `":hover"` styles being applied where they shouldn't (looks messy)
 * - components such as tooltips responding to `"mouseenter"` can show during a drag,
 *   and on an element the user isn't even over
 *
 * Bug: https://issues.chromium.org/issues/41129937
 *
 * **Honey pot fix**
 *
 * 1. Create an element where the browser thinks the depressed pointer is
 *    to absorb the incorrect pointer events
 * 2. Remove that element when it is no longer needed
 */ function $6f63fa0f2e945f3a$var$mountHoneyPot(_ref4) {
    var initial = _ref4.initial;
    var element = document.createElement('div');
    element.setAttribute((0, $hNgn9.honeyPotDataAttribute), 'true');
    // can shift during the drag thanks to Firefox
    var clientRect = $6f63fa0f2e945f3a$var$getHoneyPotRectFor({
        client: initial
    });
    Object.assign(element.style, $6f63fa0f2e945f3a$var$_objectSpread($6f63fa0f2e945f3a$var$_objectSpread({
        // Setting a background color explicitly to avoid any inherited styles.
        // Looks like this could be `opacity: 0`, but worried that _might_
        // cause the element to be ignored on some platforms.
        // When debugging, set backgroundColor to something like "red".
        backgroundColor: 'transparent',
        position: 'fixed',
        // Being explicit to avoid inheriting styles
        padding: 0,
        margin: 0,
        boxSizing: 'border-box'
    }, $6f63fa0f2e945f3a$var$getRectStyles({
        clientRect: clientRect
    })), {}, {
        // We want this element to absorb pointer events,
        // it's kind of the whole point 😉
        pointerEvents: 'auto',
        // Want to make sure the honey pot is top of everything else.
        // Don't need to worry about native drag previews, as they will
        // have been rendered (and removed) before the honey pot is rendered
        zIndex: (0, $e6RxJ.maxZIndex)
    }));
    document.body.appendChild(element);
    /**
   *  🦊 In firefox we can get `"pointermove"` events after the drag
   * has started, which is a spec violation.
   * The final `"pointermove"` will reveal where the "depressed" position
   * is for our honey pot fix.
   */ var unbindPointerMove = (0, $7QpUe.bind)(window, {
        type: 'pointermove',
        listener: function listener(event) {
            var client = {
                x: event.clientX,
                y: event.clientY
            };
            clientRect = $6f63fa0f2e945f3a$var$getHoneyPotRectFor({
                client: client
            });
            Object.assign(element.style, $6f63fa0f2e945f3a$var$getRectStyles({
                clientRect: clientRect
            }));
        },
        // using capture so we are less likely to be impacted by event stopping
        options: {
            capture: true
        }
    });
    return function finish(_ref5) {
        var current = _ref5.current;
        // Don't need this any more
        unbindPointerMove();
        // If the user is hover the honey pot, we remove it
        // so that the user can continue to interact with the page normally.
        if ($6f63fa0f2e945f3a$var$isWithin({
            client: current,
            clientRect: clientRect
        })) {
            element.remove();
            return;
        }
        function cleanup() {
            unbindPostDragEvents();
            element.remove();
        }
        var unbindPostDragEvents = (0, $7QpUe.bindAll)(window, [
            {
                type: 'pointerdown',
                listener: cleanup
            },
            {
                type: 'pointermove',
                listener: cleanup
            },
            {
                type: 'focusin',
                listener: cleanup
            },
            {
                type: 'focusout',
                listener: cleanup
            },
            // a 'pointerdown' should happen before 'dragstart', but just being super safe
            {
                type: 'dragstart',
                listener: cleanup
            },
            // if the user has dragged something out of the window
            // and then is dragging something back into the window
            // the first events we will see are "dragenter" (and then "dragover").
            // So if we see any of these we need to clear the post drag fix.
            {
                type: 'dragenter',
                listener: cleanup
            },
            {
                type: 'dragover',
                listener: cleanup
            }
        ], {
            // Using `capture` so less likely to be impacted by other code stopping events
            capture: true
        });
    };
}
function $6f63fa0f2e945f3a$export$8ecad27c959e89e0() {
    var latestPointerMove = null;
    function bindEvents() {
        // For sanity, only collecting this value from when events are first bound.
        // This prevents the case where a super old "pointermove" could be used
        // from a prior interaction.
        latestPointerMove = null;
        return (0, $7QpUe.bind)(window, {
            type: 'pointermove',
            listener: function listener(event) {
                latestPointerMove = {
                    x: event.clientX,
                    y: event.clientY
                };
            },
            // listening for pointer move in capture phase
            // so we are less likely to be impacted by events being stopped.
            options: {
                capture: true
            }
        });
    }
    function getOnPostDispatch() {
        var finish = null;
        return function onPostEvent(_ref6) {
            var eventName = _ref6.eventName, payload = _ref6.payload;
            // We are adding the honey pot `onDragStart` so we don't
            // impact the creation of the native drag preview.
            if (eventName === 'onDragStart') {
                var input = payload.location.initial.input;
                // Sometimes there will be no latest "pointermove" (eg iOS).
                // In which case, we use the start position of the drag.
                var initial = latestPointerMove !== null && latestPointerMove !== void 0 ? latestPointerMove : {
                    x: input.clientX,
                    y: input.clientY
                };
                // Don't need to defensively call `finish()` as `onDrop` from
                // one interaction is guaranteed to be called before `onDragStart`
                // of the next.
                finish = $6f63fa0f2e945f3a$var$mountHoneyPot({
                    initial: initial
                });
            }
            if (eventName === 'onDrop') {
                var _finish;
                var _input = payload.location.current.input;
                (_finish = finish) === null || _finish === void 0 || _finish({
                    current: {
                        x: _input.clientX,
                        y: _input.clientY
                    }
                });
                finish = null;
                // this interaction is finished, we want to use
                // the latest "pointermove" for each interaction
                latestPointerMove = null;
            }
        };
    }
    return {
        bindEvents: bindEvents,
        getOnPostDispatch: getOnPostDispatch
    };
}

});
parcelRegister("e6RxJ", function(module, exports) {
$parcel$export(module.exports, "maxZIndex", () => $a45b28c75c72f22f$export$7d0a15ee70427305);
// Maximum possible z-index
// https://stackoverflow.com/questions/491052/minimum-and-maximum-value-of-z-index
var $a45b28c75c72f22f$export$7d0a15ee70427305 = 2147483647;

});


parcelRegister("96VL5", function(module, exports) {
$parcel$export(module.exports, "makeAdapter", () => $6a217a393a3f33e2$export$2aa3a33160990d96);

var $c3hQN = parcelRequire("c3hQN");

var $aCyzs = parcelRequire("aCyzs");

var $kEq2l = parcelRequire("kEq2l");

var $7EPoC = parcelRequire("7EPoC");
function $6a217a393a3f33e2$export$2aa3a33160990d96(_ref) {
    var typeKey = _ref.typeKey, mount = _ref.mount, dispatchEventToSource = _ref.dispatchEventToSource, onPostDispatch = _ref.onPostDispatch, defaultDropEffect = _ref.defaultDropEffect;
    var monitorAPI = (0, $7EPoC.makeMonitor)();
    var dropTargetAPI = (0, $kEq2l.makeDropTarget)({
        typeKey: typeKey,
        defaultDropEffect: defaultDropEffect
    });
    function dispatchEvent(args) {
        // 1. forward the event to source
        dispatchEventToSource === null || dispatchEventToSource === void 0 || dispatchEventToSource(args);
        // 2. forward the event to relevant dropTargets
        dropTargetAPI.dispatchEvent(args);
        // 3. forward event to monitors
        monitorAPI.dispatchEvent(args);
        // 4. post consumer dispatch (used for honey pot fix)
        onPostDispatch === null || onPostDispatch === void 0 || onPostDispatch(args);
    }
    function start(_ref2) {
        var event = _ref2.event, dragType = _ref2.dragType;
        (0, $c3hQN.lifecycle).start({
            event: event,
            dragType: dragType,
            getDropTargetsOver: dropTargetAPI.getIsOver,
            dispatchEvent: dispatchEvent
        });
    }
    function registerUsage() {
        function mountAdapter() {
            var api = {
                canStart: (0, $c3hQN.lifecycle).canStart,
                start: start
            };
            return mount(api);
        }
        return (0, $aCyzs.register)({
            typeKey: typeKey,
            mount: mountAdapter
        });
    }
    return {
        registerUsage: registerUsage,
        dropTarget: dropTargetAPI.dropTargetForConsumers,
        monitor: monitorAPI.monitorForConsumers
    };
}

});
parcelRegister("c3hQN", function(module, exports) {
$parcel$export(module.exports, "lifecycle", () => $8c639c980a1d0fd5$export$3efdceeb8ca25c51);

var $fC8ib = parcelRequire("fC8ib");

var $7QpUe = parcelRequire("7QpUe");

var $dYpf0 = parcelRequire("dYpf0");

var $iz1zp = parcelRequire("iz1zp");

var $3yJwy = parcelRequire("3yJwy");

var $b5JMg = parcelRequire("b5JMg");

var $dM1qa = parcelRequire("dM1qa");

var $bD8GS = parcelRequire("bD8GS");
var $8c639c980a1d0fd5$var$globalState = {
    isActive: false
};
function $8c639c980a1d0fd5$var$canStart() {
    return !$8c639c980a1d0fd5$var$globalState.isActive;
}
function $8c639c980a1d0fd5$var$getNativeSetDragImage(event) {
    if (event.dataTransfer) // need to use `.bind` as `setDragImage` is required
    // to be run with `event.dataTransfer` as the "this" context
    return event.dataTransfer.setDragImage.bind(event.dataTransfer);
    return null;
}
function $8c639c980a1d0fd5$var$hasHierarchyChanged(_ref) {
    var current = _ref.current, next = _ref.next;
    if (current.length !== next.length) return true;
    // not checking stickiness, data or dropEffect,
    // just whether the hierarchy has changed
    for(var i = 0; i < current.length; i++){
        if (current[i].element !== next[i].element) return true;
    }
    return false;
}
function $8c639c980a1d0fd5$var$start(_ref2) {
    var event = _ref2.event, dragType = _ref2.dragType, getDropTargetsOver = _ref2.getDropTargetsOver, dispatchEvent = _ref2.dispatchEvent;
    if (!$8c639c980a1d0fd5$var$canStart()) return;
    var initial = $8c639c980a1d0fd5$var$getStartLocation({
        event: event,
        dragType: dragType,
        getDropTargetsOver: getDropTargetsOver
    });
    $8c639c980a1d0fd5$var$globalState.isActive = true;
    var state = {
        current: initial
    };
    // Setting initial drop effect for the drag
    $8c639c980a1d0fd5$var$setDropEffectOnEvent({
        event: event,
        current: initial.dropTargets
    });
    var dispatch = (0, $bD8GS.makeDispatch)({
        source: dragType.payload,
        dispatchEvent: dispatchEvent,
        initial: initial
    });
    function updateState(next) {
        // only looking at whether hierarchy has changed to determine whether something as 'changed'
        var hasChanged = $8c639c980a1d0fd5$var$hasHierarchyChanged({
            current: state.current.dropTargets,
            next: next.dropTargets
        });
        // Always updating the state to include latest data, dropEffect and stickiness
        // Only updating consumers if the hierarchy has changed in some way
        // Consumers can get the latest data by using `onDrag`
        state.current = next;
        if (hasChanged) dispatch.dragUpdate({
            current: state.current
        });
    }
    function onUpdateEvent(event) {
        var input = (0, $dM1qa.getInput)(event);
        // If we are over the honey pot, we need to get the element
        // that the user would have been over if not for the honey pot
        var target = (0, $iz1zp.isHoneyPotElement)(event.target) ? (0, $dYpf0.getElementFromPointWithoutHoneypot)({
            x: input.clientX,
            y: input.clientY
        }) : event.target;
        var nextDropTargets = getDropTargetsOver({
            target: target,
            input: input,
            source: dragType.payload,
            current: state.current.dropTargets
        });
        if (nextDropTargets.length) {
            // 🩸 must call `event.preventDefault()` to allow a browser drop to occur
            event.preventDefault();
            $8c639c980a1d0fd5$var$setDropEffectOnEvent({
                event: event,
                current: nextDropTargets
            });
        }
        updateState({
            dropTargets: nextDropTargets,
            input: input
        });
    }
    function cancel() {
        // The spec behaviour is that when a drag is cancelled, or when dropping on no drop targets,
        // a "dragleave" event is fired on the active drop target before a "dragend" event.
        // We are replicating that behaviour in `cancel` if there are any active drop targets to
        // ensure consistent behaviour.
        //
        // Note: When cancelling, or dropping on no drop targets, a "dragleave" event
        // will have already cleared the dropTargets to `[]` (as that particular "dragleave" has a `relatedTarget` of `null`)
        if (state.current.dropTargets.length) updateState({
            dropTargets: [],
            input: state.current.input
        });
        dispatch.drop({
            current: state.current,
            updatedSourcePayload: null
        });
        finish();
    }
    function finish() {
        $8c639c980a1d0fd5$var$globalState.isActive = false;
        unbindEvents();
    }
    var unbindEvents = (0, $7QpUe.bindAll)(window, [
        {
            // 👋 Note: we are repurposing the `dragover` event as our `drag` event
            // this is because firefox does not publish pointer coordinates during
            // a `drag` event, but does for every other type of drag event
            // `dragover` fires on all elements that are being dragged over
            // Because we are binding to `window` - our `dragover` is effectively the same as a `drag`
            // 🦊😤
            type: 'dragover',
            listener: function listener(event) {
                // We need to regularly calculate the drop targets in order to allow:
                //  - dynamic `canDrop()` checks
                //  - rapid updating `getData()` calls to attach data in response to user input (eg for edge detection)
                // Sadly we cannot schedule inspecting changes resulting from this event
                // we need to be able to conditionally cancel the event with `event.preventDefault()`
                // to enable the correct native drop experience.
                // 1. check to see if anything has changed
                onUpdateEvent(event);
                // 2. let consumers know a move has occurred
                // This will include the latest 'input' values
                dispatch.drag({
                    current: state.current
                });
            }
        },
        {
            type: 'dragenter',
            listener: onUpdateEvent
        },
        {
            type: 'dragleave',
            listener: function listener(event) {
                if (!(0, $3yJwy.isLeavingWindow)({
                    dragLeave: event
                })) return;
                /**
       * At this point we don't know if a drag is being cancelled,
       * or if a drag is leaving the `window`.
       *
       * Both have:
       *   1. "dragleave" (with `relatedTarget: null`)
       *   2. "dragend" (a "dragend" can occur when outside the `window`)
       *
       * **Clearing drop targets**
       *
       * For either case we are clearing the the drop targets
       *
       * - cancelling: we clear drop targets in `"dragend"` anyway
       * - leaving the `window`: we clear the drop targets (to clear stickiness)
       *
       * **Leaving the window and finishing the drag**
       *
       * _internal drags_
       *
       * - The drag continues when the user is outside the `window`
       *   and can resume if the user drags back over the `window`,
       *   or end when the user drops in an external `window`.
       * - We will get a `"dragend"`, or we can listen for other
       *   events to determine the drag is finished when the user re-enters the `window`).
       *
       * _external drags_
       *
       * - We conclude the drag operation.
       * - We have no idea if the user will drag back over the `window`,
       *   or if the drag ends elsewhere.
       * - We will create a new drag if the user re-enters the `window`.
       *
       * **Not updating `input`**
       *
       * 🐛 Bug[Chrome] the final `"dragleave"` has default input values (eg `clientX == 0`)
       * Workaround: intentionally not updating `input` in "dragleave"
       * rather than the users current input values
       * - [Conversation](https://twitter.com/alexandereardon/status/1642697633864241152)
       * - [Bug](https://bugs.chromium.org/p/chromium/issues/detail?id=1429937)
       **/ updateState({
                    input: state.current.input,
                    dropTargets: []
                });
                if (dragType.startedFrom === 'external') cancel();
            }
        },
        {
            // A "drop" can only happen if the browser allowed the drop
            type: 'drop',
            listener: function listener(event) {
                // Capture the final input.
                // We are capturing the final `input` for the
                // most accurate honey pot experience
                state.current = {
                    dropTargets: state.current.dropTargets,
                    input: (0, $dM1qa.getInput)(event)
                };
                /** If there are no drop targets, then we will get
       * a "drop" event if:
       * - `preventUnhandled()` is being used
       * - there is an unmanaged drop target (eg another library)
       * In these cases, it's up to the consumer
       * to handle the drop if it's not over one of our drop targets
       * - `preventUnhandled()` will cancel the "drop"
       * - unmanaged drop targets can handle the "drop" how they want to
       * We won't call `event.preventDefault()` in this call path */ if (!state.current.dropTargets.length) {
                    cancel();
                    return;
                }
                event.preventDefault();
                // applying the latest drop effect to the event
                $8c639c980a1d0fd5$var$setDropEffectOnEvent({
                    event: event,
                    current: state.current.dropTargets
                });
                dispatch.drop({
                    current: state.current,
                    // When dropping something native, we need to extract the latest
                    // `.items` from the "drop" event as it is now accessible
                    updatedSourcePayload: dragType.type === 'external' ? dragType.getDropPayload(event) : null
                });
                finish();
            }
        },
        {
            // "dragend" fires when on the drag source (eg a draggable element)
            // when the drag is finished.
            // "dragend" will fire after "drop" (if there was a successful drop)
            // "dragend" does not fire if the draggable source has been removed during the drag
            // or for external drag sources (eg files)
            // This "dragend" listener will not fire if there was a successful drop
            // as we will have already removed the event listener
            type: 'dragend',
            listener: function listener(event) {
                // In firefox, the position of the "dragend" event can
                // be a bit different to the last "dragover" event.
                // Updating the input so we can get the best possible
                // information for the honey pot.
                state.current = {
                    dropTargets: state.current.dropTargets,
                    input: (0, $dM1qa.getInput)(event)
                };
                cancel();
            }
        }
    ].concat((0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))((0, $b5JMg.getBindingsForBrokenDrags)({
        onDragEnd: cancel
    }))), // Once we have started a managed drag operation it is important that we see / own all drag events
    // We got one adoption bug pop up where some code was stopping (`event.stopPropagation()`)
    // all "drop" events in the bubble phase on the `document.body`.
    // This meant that we never saw the "drop" event.
    {
        capture: true
    });
    dispatch.start({
        nativeSetDragImage: $8c639c980a1d0fd5$var$getNativeSetDragImage(event)
    });
}
function $8c639c980a1d0fd5$var$setDropEffectOnEvent(_ref3) {
    var _current$;
    var event = _ref3.event, current = _ref3.current;
    // setting the `dropEffect` to be the innerMost drop targets dropEffect
    var innerMost = (_current$ = current[0]) === null || _current$ === void 0 ? void 0 : _current$.dropEffect;
    if (innerMost != null && event.dataTransfer) event.dataTransfer.dropEffect = innerMost;
}
function $8c639c980a1d0fd5$var$getStartLocation(_ref4) {
    var event = _ref4.event, dragType = _ref4.dragType, getDropTargetsOver = _ref4.getDropTargetsOver;
    var input = (0, $dM1qa.getInput)(event);
    // When dragging from outside of the browser,
    // the drag is not being sourced from any local drop targets
    if (dragType.startedFrom === 'external') return {
        input: input,
        dropTargets: []
    };
    var dropTargets = getDropTargetsOver({
        input: input,
        source: dragType.payload,
        target: event.target,
        current: []
    });
    return {
        input: input,
        dropTargets: dropTargets
    };
}
var $8c639c980a1d0fd5$export$3efdceeb8ca25c51 = {
    canStart: $8c639c980a1d0fd5$var$canStart,
    start: $8c639c980a1d0fd5$var$start
};

});
parcelRegister("3yJwy", function(module, exports) {
$parcel$export(module.exports, "isLeavingWindow", () => $2977dc31a4f0daf8$export$57d220c74e84a273);

var $f7oM5 = parcelRequire("f7oM5");

var $8nu2B = parcelRequire("8nu2B");

var $7FN5w = parcelRequire("7FN5w");

var $2eElm = parcelRequire("2eElm");
function $2977dc31a4f0daf8$export$57d220c74e84a273(_ref) {
    var dragLeave = _ref.dragLeave;
    var type = dragLeave.type, relatedTarget = dragLeave.relatedTarget;
    if (type !== 'dragleave') return false;
    if ((0, $8nu2B.isSafari)()) return (0, $7FN5w.isLeavingWindowInSafari)({
        dragLeave: dragLeave
    });
    // Standard check: if going to `null` we are leaving the `window`
    if (relatedTarget == null) return true;
    /**
   * 🦊 Exception: `iframe` in Firefox (`125.0`)
   *
   * Case 1: parent `window` → child `iframe`
   * `dragLeave.relatedTarget` is element _inside_ the child `iframe`
   * (foreign element)
   *
   * Case 2: child `iframe` → parent `window`
   * `dragLeave.relatedTarget` is the `iframe` in the parent `window`
   * (foreign element)
   */ if ((0, $f7oM5.isFirefox)()) return (0, $2eElm.isFromAnotherWindow)(relatedTarget);
    /**
   * 🌏 Exception: `iframe` in Chrome (`124.0`)
   *
   * Case 1: parent `window` → child `iframe`
   * `dragLeave.relatedTarget` is the `iframe` in the parent `window`
   *
   * Case 2: child `iframe` → parent `window`
   * `dragLeave.relatedTarget` is `null` *(standard check)*
   */ // Case 2
    // Using `instanceof` check as the element will be in the same `window`
    return relatedTarget instanceof HTMLIFrameElement;
}

});
parcelRegister("f7oM5", function(module, exports) {
$parcel$export(module.exports, "isFirefox", () => $b01aba297b4ce34f$export$b7d78993b74f766d);

var $hqNxG = parcelRequire("hqNxG");
var $b01aba297b4ce34f$export$b7d78993b74f766d = (0, $hqNxG.once)(function isFirefox() {
    return navigator.userAgent.includes('Firefox');
});

});
parcelRegister("hqNxG", function(module, exports) {
$parcel$export(module.exports, "once", () => $cb0b4b6c09f939a3$export$d2de3aaeafa91619);
/** Provide a function that you only ever want to be called a single time */ function $cb0b4b6c09f939a3$export$d2de3aaeafa91619(fn) {
    var cache = null;
    return function wrapped() {
        if (!cache) {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            var result = fn.apply(this, args);
            cache = {
                result: result
            };
        }
        return cache.result;
    };
}

});


parcelRegister("8nu2B", function(module, exports) {
$parcel$export(module.exports, "isSafari", () => $6197c6371b414d1f$export$95df08bae54cb4df);

var $hqNxG = parcelRequire("hqNxG");
var $6197c6371b414d1f$export$95df08bae54cb4df = (0, $hqNxG.once)(function isSafari() {
    var _navigator = navigator, userAgent = _navigator.userAgent;
    return userAgent.includes('AppleWebKit') && !userAgent.includes('Chrome');
});

});

parcelRegister("7FN5w", function(module, exports) {
$parcel$export(module.exports, "isEnteringWindowInSafari", () => $5962709fc58bfb50$export$de68634bd94ed596);
$parcel$export(module.exports, "isLeavingWindowInSafari", () => $5962709fc58bfb50$export$f21837c338005454);

var $7QpUe = parcelRequire("7QpUe");

var $8nu2B = parcelRequire("8nu2B");
/* For "dragenter" events, the browser should set `relatedTarget` to the previous element.
 * For external drag operations, our first "dragenter" event should have a `event.relatedTarget` of `null`.
 *
 *  Unfortunately in Safari `event.relatedTarget` is *always* set to `null`
 *  Safari bug: https://bugs.webkit.org/show_bug.cgi?id=242627
 *  To work around this we count "dragenter" and "dragleave" events */ // Using symbols for event properties so we don't clash with
// anything on the `event` object
var $5962709fc58bfb50$var$symbols = {
    isLeavingWindow: Symbol('leaving'),
    isEnteringWindow: Symbol('entering')
};
function $5962709fc58bfb50$export$de68634bd94ed596(_ref) {
    var dragEnter = _ref.dragEnter;
    if (!(0, $8nu2B.isSafari)()) return false;
    return dragEnter.hasOwnProperty($5962709fc58bfb50$var$symbols.isEnteringWindow);
}
function $5962709fc58bfb50$export$f21837c338005454(_ref2) {
    var dragLeave = _ref2.dragLeave;
    if (!(0, $8nu2B.isSafari)()) return false;
    return dragLeave.hasOwnProperty($5962709fc58bfb50$var$symbols.isLeavingWindow);
}
(function fixSafari() {
    // Don't do anything when server side rendering
    if (typeof window === 'undefined') return;
    if (!(0, $8nu2B.isSafari)()) return;
    function getInitialState() {
        return {
            enterCount: 0,
            isOverWindow: false
        };
    }
    var state = getInitialState();
    function resetState() {
        state = getInitialState();
    }
    // These event listeners are bound _forever_ and _never_ removed
    // We don't bother cleaning up these event listeners (for now)
    // as this workaround is only for Safari
    // This is how the event count works:
    //
    // lift (+1 enterCount)
    // - dragstart(draggable) [enterCount: 0]
    // - dragenter(draggable) [enterCount: 1]
    // leaving draggable (+0 enterCount)
    // - dragenter(document.body) [enterCount: 2]
    // - dragleave(draggable) [enterCount: 1]
    // leaving window (-1 enterCount)
    // - dragleave(document.body) [enterCount: 0] {leaving the window}
    // Things to note:
    // - dragenter and dragleave bubble
    // - the first dragenter when entering a window might not be on `window`
    //   - it could be on an element that is pressed up against the window
    //   - (so we cannot rely on `event.target` values)
    (0, $7QpUe.bindAll)(window, [
        {
            type: 'dragstart',
            listener: function listener() {
                state.enterCount = 0;
                // drag start occurs in the source window
                state.isOverWindow = true;
            // When a drag first starts it will also trigger a "dragenter" on the draggable element
            }
        },
        {
            type: 'drop',
            listener: resetState
        },
        {
            type: 'dragend',
            listener: resetState
        },
        {
            type: 'dragenter',
            listener: function listener(event) {
                if (!state.isOverWindow && state.enterCount === 0) // Patching the `event` object
                // The `event` object is shared with all event listeners for the event
                event[$5962709fc58bfb50$var$symbols.isEnteringWindow] = true;
                state.isOverWindow = true;
                state.enterCount++;
            }
        },
        {
            type: 'dragleave',
            listener: function listener(event) {
                state.enterCount--;
                if (state.isOverWindow && state.enterCount === 0) {
                    // Patching the `event` object as it is shared with all event listeners
                    // The `event` object is shared with all event listeners for the event
                    event[$5962709fc58bfb50$var$symbols.isLeavingWindow] = true;
                    state.isOverWindow = false;
                }
            }
        }
    ], // using `capture: true` so that adding event listeners
    // in bubble phase will have the correct symbols
    {
        capture: true
    });
})();

});

parcelRegister("2eElm", function(module, exports) {
$parcel$export(module.exports, "isFromAnotherWindow", () => $1a0c2ef27ee6e05a$export$e46810fef53b5b0e);
/**
 * Does the `EventTarget` look like a `Node` based on "duck typing".
 *
 * Helpful when the `Node` might be outside of the current document
 * so we cannot to an `target instanceof Node` check.
 */ function $1a0c2ef27ee6e05a$var$isNodeLike(target) {
    return 'nodeName' in target;
}
function $1a0c2ef27ee6e05a$export$e46810fef53b5b0e(eventTarget) {
    return $1a0c2ef27ee6e05a$var$isNodeLike(eventTarget) && eventTarget.ownerDocument !== document;
}

});


parcelRegister("b5JMg", function(module, exports) {
$parcel$export(module.exports, "getBindingsForBrokenDrags", () => $8133abce30b35113$export$ac5e5b0daf997b2);
function $8133abce30b35113$export$ac5e5b0daf997b2(_ref) {
    var onDragEnd = _ref.onDragEnd;
    return [
        // ## Detecting drag ending for removed draggables
        //
        // If a draggable element is removed during a drag and the user drops:
        // 1. if over a valid drop target: we get a "drop" event to know the drag is finished
        // 2. if not over a valid drop target (or cancelled): we get nothing
        // The "dragend" event will not fire on the source draggable if it has been
        // removed from the DOM.
        // So we need to figure out if a drag operation has finished by looking at other events
        // We can do this by looking at other events
        // ### First detection: "pointermove" events
        // 1. "pointermove" events cannot fire during a drag and drop operation
        // according to the spec. So if we get a "pointermove" it means that
        // the drag and drop operations has finished. So if we get a "pointermove"
        // we know that the drag is over
        // 2. 🦊😤 Drag and drop operations are _supposed_ to suppress
        // other pointer events. However, firefox will allow a few
        // pointer event to get through after a drag starts.
        // The most I've seen is 3
        {
            type: 'pointermove',
            listener: function() {
                var callCount = 0;
                return function listener() {
                    // Using 20 as it is far bigger than the most observed (3)
                    if (callCount < 20) {
                        callCount++;
                        return;
                    }
                    onDragEnd();
                };
            }()
        },
        // ### Second detection: "pointerdown" events
        // If we receive this event then we know that a drag operation has finished
        // and potentially another one is about to start.
        // Note: `pointerdown` fires on all browsers / platforms before "dragstart"
        {
            type: 'pointerdown',
            listener: onDragEnd
        }
    ];
}

});

parcelRegister("dM1qa", function(module, exports) {
$parcel$export(module.exports, "getInput", () => $a070dc391d41a0d6$export$7c112ceec8941e67);
function $a070dc391d41a0d6$export$7c112ceec8941e67(event) {
    return {
        altKey: event.altKey,
        button: event.button,
        buttons: event.buttons,
        ctrlKey: event.ctrlKey,
        metaKey: event.metaKey,
        shiftKey: event.shiftKey,
        clientX: event.clientX,
        clientY: event.clientY,
        pageX: event.pageX,
        pageY: event.pageY
    };
}

});

parcelRegister("bD8GS", function(module, exports) {
$parcel$export(module.exports, "makeDispatch", () => $877a140085167b69$export$9f13ecc44e83d682);

var $45Zis = parcelRequire("45Zis");
var $877a140085167b69$var$scheduleOnDrag = (0, $45Zis.default)(function(fn) {
    return fn();
});
var $877a140085167b69$var$dragStart = function() {
    var scheduled = null;
    function schedule(fn) {
        var frameId = requestAnimationFrame(function() {
            scheduled = null;
            fn();
        });
        scheduled = {
            frameId: frameId,
            fn: fn
        };
    }
    function flush() {
        if (scheduled) {
            cancelAnimationFrame(scheduled.frameId);
            scheduled.fn();
            scheduled = null;
        }
    }
    return {
        schedule: schedule,
        flush: flush
    };
}();
function $877a140085167b69$export$9f13ecc44e83d682(_ref) {
    var source = _ref.source, initial = _ref.initial, dispatchEvent = _ref.dispatchEvent;
    var previous = {
        dropTargets: []
    };
    function safeDispatch(args) {
        dispatchEvent(args);
        previous = {
            dropTargets: args.payload.location.current.dropTargets
        };
    }
    var dispatch = {
        start: function start(_ref2) {
            var nativeSetDragImage = _ref2.nativeSetDragImage;
            // Ensuring that both `onGenerateDragPreview` and `onDragStart` get the same location.
            // We do this so that `previous` is`[]` in `onDragStart` (which is logical)
            var location = {
                current: initial,
                previous: previous,
                initial: initial
            };
            // a `onGenerateDragPreview` does _not_ add another entry for `previous`
            // onDragPreview
            safeDispatch({
                eventName: 'onGenerateDragPreview',
                payload: {
                    source: source,
                    location: location,
                    nativeSetDragImage: nativeSetDragImage
                }
            });
            $877a140085167b69$var$dragStart.schedule(function() {
                safeDispatch({
                    eventName: 'onDragStart',
                    payload: {
                        source: source,
                        location: location
                    }
                });
            });
        },
        dragUpdate: function dragUpdate(_ref3) {
            var current = _ref3.current;
            $877a140085167b69$var$dragStart.flush();
            $877a140085167b69$var$scheduleOnDrag.cancel();
            safeDispatch({
                eventName: 'onDropTargetChange',
                payload: {
                    source: source,
                    location: {
                        initial: initial,
                        previous: previous,
                        current: current
                    }
                }
            });
        },
        drag: function drag(_ref4) {
            var current = _ref4.current;
            $877a140085167b69$var$scheduleOnDrag(function() {
                $877a140085167b69$var$dragStart.flush();
                var location = {
                    initial: initial,
                    previous: previous,
                    current: current
                };
                safeDispatch({
                    eventName: 'onDrag',
                    payload: {
                        source: source,
                        location: location
                    }
                });
            });
        },
        drop: function drop(_ref5) {
            var current = _ref5.current, updatedSourcePayload = _ref5.updatedSourcePayload;
            $877a140085167b69$var$dragStart.flush();
            $877a140085167b69$var$scheduleOnDrag.cancel();
            safeDispatch({
                eventName: 'onDrop',
                payload: {
                    source: updatedSourcePayload !== null && updatedSourcePayload !== void 0 ? updatedSourcePayload : source,
                    location: {
                        current: current,
                        previous: previous,
                        initial: initial
                    }
                }
            });
        }
    };
    return dispatch;
}

});
parcelRegister("45Zis", function(module, exports) {
$parcel$export(module.exports, "default", () => $2fb72d4a32455831$export$2e2bcd8739ae039);
var $2fb72d4a32455831$var$rafSchd = function rafSchd(fn) {
    var lastArgs = [];
    var frameId = null;
    var wrapperFn = function wrapperFn() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        lastArgs = args;
        if (frameId) return;
        frameId = requestAnimationFrame(function() {
            frameId = null;
            fn.apply(void 0, lastArgs);
        });
    };
    wrapperFn.cancel = function() {
        if (!frameId) return;
        cancelAnimationFrame(frameId);
        frameId = null;
    };
    return wrapperFn;
};
var $2fb72d4a32455831$export$2e2bcd8739ae039 = $2fb72d4a32455831$var$rafSchd;

});



parcelRegister("aCyzs", function(module, exports) {
$parcel$export(module.exports, "register", () => $7bb8450b5527e11b$export$6503ec6e8aabbaf);
// Extending `Map` to allow us to link Key and Values together
var $7bb8450b5527e11b$var$ledger = new Map();
function $7bb8450b5527e11b$var$registerUsage(_ref) {
    var typeKey = _ref.typeKey, mount = _ref.mount;
    var entry = $7bb8450b5527e11b$var$ledger.get(typeKey);
    if (entry) {
        entry.usageCount++;
        return entry;
    }
    var initial = {
        typeKey: typeKey,
        unmount: mount(),
        usageCount: 1
    };
    $7bb8450b5527e11b$var$ledger.set(typeKey, initial);
    return initial;
}
function $7bb8450b5527e11b$export$6503ec6e8aabbaf(args) {
    var entry = $7bb8450b5527e11b$var$registerUsage(args);
    return function unregister() {
        entry.usageCount--;
        if (entry.usageCount > 0) return;
        // Only a single usage left, remove it
        entry.unmount();
        $7bb8450b5527e11b$var$ledger.delete(args.typeKey);
    };
}

});

parcelRegister("kEq2l", function(module, exports) {
$parcel$export(module.exports, "makeDropTarget", () => $f08bbd6b15e5cf31$export$47d10e7bd9c81890);

var $25nEq = parcelRequire("25nEq");

var $fC8ib = parcelRequire("fC8ib");

var $fGFYU = parcelRequire("fGFYU");

var $hqNxG = parcelRequire("hqNxG");

var $dfTau = parcelRequire("dfTau");
function $f08bbd6b15e5cf31$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $f08bbd6b15e5cf31$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $f08bbd6b15e5cf31$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $f08bbd6b15e5cf31$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $f08bbd6b15e5cf31$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $f08bbd6b15e5cf31$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $f08bbd6b15e5cf31$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $f08bbd6b15e5cf31$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $f08bbd6b15e5cf31$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $f08bbd6b15e5cf31$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $f08bbd6b15e5cf31$var$copyReverse(array) {
    return array.slice(0).reverse();
}
function $f08bbd6b15e5cf31$export$47d10e7bd9c81890(_ref) {
    var typeKey = _ref.typeKey, defaultDropEffect = _ref.defaultDropEffect;
    var registry = new WeakMap();
    var dropTargetDataAtt = "data-drop-target-for-".concat(typeKey);
    var dropTargetSelector = "[".concat(dropTargetDataAtt, "]");
    function addToRegistry(args) {
        registry.set(args.element, args);
        return function() {
            return registry.delete(args.element);
        };
    }
    function dropTargetForConsumers(args) {
        var existing;
        var cleanup = (0, $fGFYU.combine)((0, $dfTau.addAttribute)(args.element, {
            attribute: dropTargetDataAtt,
            value: 'true'
        }), addToRegistry(args));
        // Wrapping in `once` to prevent unexpected side effects if consumers call
        // the clean up function multiple times.
        return (0, $hqNxG.once)(cleanup);
    }
    function getActualDropTargets(_ref2) {
        var _args$getData, _args$getData2, _args$getDropEffect, _args$getDropEffect2;
        var source = _ref2.source, target = _ref2.target, input = _ref2.input, _ref2$result = _ref2.result, result = _ref2$result === void 0 ? [] : _ref2$result;
        if (target == null) return result;
        if (!(target instanceof Element)) {
            // For "text-selection" drags, the original `target`
            // is not an `Element`, so we need to start looking from
            // the parent element
            if (target instanceof Node) return getActualDropTargets({
                source: source,
                target: target.parentElement,
                input: input,
                result: result
            });
            // not sure what we are working with,
            // so we can exit.
            return result;
        }
        var closest = target.closest(dropTargetSelector);
        // Cannot find anything else
        if (closest == null) return result;
        var args = registry.get(closest);
        // error: something had a dropTargetSelector but we could not
        // find a match. For now, failing silently
        if (args == null) return result;
        var feedback = {
            input: input,
            source: source,
            element: args.element
        };
        // if dropping is not allowed, skip this drop target
        // and continue looking up the DOM tree
        if (args.canDrop && !args.canDrop(feedback)) return getActualDropTargets({
            source: source,
            target: args.element.parentElement,
            input: input,
            result: result
        });
        // calculate our new record
        var data = (_args$getData = (_args$getData2 = args.getData) === null || _args$getData2 === void 0 ? void 0 : _args$getData2.call(args, feedback)) !== null && _args$getData !== void 0 ? _args$getData : {};
        var dropEffect = (_args$getDropEffect = (_args$getDropEffect2 = args.getDropEffect) === null || _args$getDropEffect2 === void 0 ? void 0 : _args$getDropEffect2.call(args, feedback)) !== null && _args$getDropEffect !== void 0 ? _args$getDropEffect : defaultDropEffect;
        var record = {
            data: data,
            element: args.element,
            dropEffect: dropEffect,
            // we are collecting _actual_ drop targets, so these are
            // being applied _not_ due to stickiness
            isActiveDueToStickiness: false
        };
        return getActualDropTargets({
            source: source,
            target: args.element.parentElement,
            input: input,
            // Using bubble ordering. Same ordering as `event.getPath()`
            result: [].concat((0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(result), [
                record
            ])
        });
    }
    function notifyCurrent(_ref3) {
        var eventName = _ref3.eventName, payload = _ref3.payload;
        var _iterator = $f08bbd6b15e5cf31$var$_createForOfIteratorHelper(payload.location.current.dropTargets), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var _entry$eventName;
                var record = _step.value;
                var entry = registry.get(record.element);
                var args = $f08bbd6b15e5cf31$var$_objectSpread($f08bbd6b15e5cf31$var$_objectSpread({}, payload), {}, {
                    self: record
                });
                entry === null || entry === void 0 || (_entry$eventName = entry[eventName]) === null || _entry$eventName === void 0 || _entry$eventName.call(entry, // I cannot seem to get the types right here.
                // TS doesn't seem to like that one event can need `nativeSetDragImage`
                // @ts-expect-error
                args);
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
    }
    var actions = {
        onGenerateDragPreview: notifyCurrent,
        onDrag: notifyCurrent,
        onDragStart: notifyCurrent,
        onDrop: notifyCurrent,
        onDropTargetChange: function onDropTargetChange(_ref4) {
            var payload = _ref4.payload;
            var isCurrent = new Set(payload.location.current.dropTargets.map(function(record) {
                return record.element;
            }));
            var visited = new Set();
            var _iterator2 = $f08bbd6b15e5cf31$var$_createForOfIteratorHelper(payload.location.previous.dropTargets), _step2;
            try {
                for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                    var _entry$onDropTargetCh;
                    var record = _step2.value;
                    visited.add(record.element);
                    var entry = registry.get(record.element);
                    var isOver = isCurrent.has(record.element);
                    var args = $f08bbd6b15e5cf31$var$_objectSpread($f08bbd6b15e5cf31$var$_objectSpread({}, payload), {}, {
                        self: record
                    });
                    entry === null || entry === void 0 || (_entry$onDropTargetCh = entry.onDropTargetChange) === null || _entry$onDropTargetCh === void 0 || _entry$onDropTargetCh.call(entry, args);
                    // if we cannot find the drop target in the current array, then it has been left
                    if (!isOver) {
                        var _entry$onDragLeave;
                        entry === null || entry === void 0 || (_entry$onDragLeave = entry.onDragLeave) === null || _entry$onDragLeave === void 0 || _entry$onDragLeave.call(entry, args);
                    }
                }
            } catch (err) {
                _iterator2.e(err);
            } finally{
                _iterator2.f();
            }
            var _iterator3 = $f08bbd6b15e5cf31$var$_createForOfIteratorHelper(payload.location.current.dropTargets), _step3;
            try {
                for(_iterator3.s(); !(_step3 = _iterator3.n()).done;){
                    var _entry$onDropTargetCh2, _entry$onDragEnter;
                    var _record = _step3.value;
                    // already published an update to this drop target
                    if (visited.has(_record.element)) continue;
                    // at this point we have a new drop target that is being entered into
                    var _args = $f08bbd6b15e5cf31$var$_objectSpread($f08bbd6b15e5cf31$var$_objectSpread({}, payload), {}, {
                        self: _record
                    });
                    var _entry = registry.get(_record.element);
                    _entry === null || _entry === void 0 || (_entry$onDropTargetCh2 = _entry.onDropTargetChange) === null || _entry$onDropTargetCh2 === void 0 || _entry$onDropTargetCh2.call(_entry, _args);
                    _entry === null || _entry === void 0 || (_entry$onDragEnter = _entry.onDragEnter) === null || _entry$onDragEnter === void 0 || _entry$onDragEnter.call(_entry, _args);
                }
            } catch (err) {
                _iterator3.e(err);
            } finally{
                _iterator3.f();
            }
        }
    };
    function dispatchEvent(args) {
        actions[args.eventName](args);
    }
    function getIsOver(_ref5) {
        var source = _ref5.source, target = _ref5.target, input = _ref5.input, current = _ref5.current;
        var actual = getActualDropTargets({
            source: source,
            target: target,
            input: input
        });
        // stickiness is only relevant when we have less
        // drop targets than we did before
        if (actual.length >= current.length) return actual;
        // less 'actual' drop targets than before,
        // we need to see if 'stickiness' applies
        // An old drop target will continue to be dropped on if:
        // 1. it has the same parent
        // 2. nothing exists in it's previous index
        var lastCaptureOrdered = $f08bbd6b15e5cf31$var$copyReverse(current);
        var actualCaptureOrdered = $f08bbd6b15e5cf31$var$copyReverse(actual);
        var resultCaptureOrdered = [];
        for(var index = 0; index < lastCaptureOrdered.length; index++){
            var _argsForLast$getIsSti;
            var last = lastCaptureOrdered[index];
            var fresh = actualCaptureOrdered[index];
            // if a record is in the new index -> use that
            // it will have the latest data + dropEffect
            if (fresh != null) {
                resultCaptureOrdered.push(fresh);
                continue;
            }
            // At this point we have no drop target in the old spot
            // Check to see if we can use a previous sticky drop target
            // The "parent" is the one inside of `resultCaptureOrdered`
            // (the parent might be a drop target that was sticky)
            var parent = resultCaptureOrdered[index - 1];
            var lastParent = lastCaptureOrdered[index - 1];
            // Stickiness is based on parent relationships, so if the parent relationship has change
            // then we can stop our search
            if ((parent === null || parent === void 0 ? void 0 : parent.element) !== (lastParent === null || lastParent === void 0 ? void 0 : lastParent.element)) break;
            // We need to check whether the old drop target can still be dropped on
            var argsForLast = registry.get(last.element);
            // We cannot drop on a drop target that is no longer mounted
            if (!argsForLast) break;
            var feedback = {
                input: input,
                source: source,
                element: argsForLast.element
            };
            // We cannot drop on a drop target that no longer allows being dropped on
            if (argsForLast.canDrop && !argsForLast.canDrop(feedback)) break;
            // We cannot drop on a drop target that is no longer sticky
            if (!((_argsForLast$getIsSti = argsForLast.getIsSticky) !== null && _argsForLast$getIsSti !== void 0 && _argsForLast$getIsSti.call(argsForLast, feedback))) break;
            // Note: intentionally not recollecting `getData()` or `getDropEffect()`
            // Previous values for `data` and `dropEffect` will be borrowed
            // This is to prevent things like the 'closest edge' changing when
            // no longer over a drop target.
            // We could change our mind on this behaviour in the future
            resultCaptureOrdered.push($f08bbd6b15e5cf31$var$_objectSpread($f08bbd6b15e5cf31$var$_objectSpread({}, last), {}, {
                // making it clear to consumers this drop target is active due to stickiness
                isActiveDueToStickiness: true
            }));
        }
        // return bubble ordered result
        return $f08bbd6b15e5cf31$var$copyReverse(resultCaptureOrdered);
    }
    return {
        dropTargetForConsumers: dropTargetForConsumers,
        getIsOver: getIsOver,
        dispatchEvent: dispatchEvent
    };
}

});
parcelRegister("dfTau", function(module, exports) {
$parcel$export(module.exports, "addAttribute", () => $9a67785920e46268$export$5dcb5c23b6ba980a);
function $9a67785920e46268$export$5dcb5c23b6ba980a(element, _ref) {
    var attribute = _ref.attribute, value = _ref.value;
    element.setAttribute(attribute, value);
    return function() {
        return element.removeAttribute(attribute);
    };
}

});


parcelRegister("7EPoC", function(module, exports) {
$parcel$export(module.exports, "makeMonitor", () => $5934230967ac1c51$export$5dd4ed888d5b12ca);

var $25nEq = parcelRequire("25nEq");

var $hqNxG = parcelRequire("hqNxG");
function $5934230967ac1c51$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $5934230967ac1c51$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $5934230967ac1c51$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $5934230967ac1c51$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $5934230967ac1c51$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $5934230967ac1c51$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $5934230967ac1c51$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $5934230967ac1c51$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $5934230967ac1c51$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $5934230967ac1c51$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $5934230967ac1c51$export$5dd4ed888d5b12ca() {
    var registry = new Set();
    var dragging = null;
    function tryAddToActive(monitor) {
        if (!dragging) return;
        // Monitor is allowed to monitor events if:
        // 1. It has no `canMonitor` function (default is that a monitor can listen to everything)
        // 2. `canMonitor` returns true
        if (!monitor.canMonitor || monitor.canMonitor(dragging.canMonitorArgs)) dragging.active.add(monitor);
    }
    function monitorForConsumers(args) {
        // We are giving each `args` a new reference so that you
        // can create multiple monitors with the same `args`.
        var entry = $5934230967ac1c51$var$_objectSpread({}, args);
        registry.add(entry);
        // if there is an active drag we need to see if this new monitor is relevant
        tryAddToActive(entry);
        function cleanup() {
            registry.delete(entry);
            // We need to stop publishing events during a drag to this monitor!
            if (dragging) dragging.active.delete(entry);
        }
        // Wrapping in `once` to prevent unexpected side effects if consumers call
        // the clean up function multiple times.
        return (0, $hqNxG.once)(cleanup);
    }
    function dispatchEvent(_ref) {
        var eventName = _ref.eventName, payload = _ref.payload;
        if (eventName === 'onGenerateDragPreview') {
            dragging = {
                canMonitorArgs: {
                    initial: payload.location.initial,
                    source: payload.source
                },
                active: new Set()
            };
            var _iterator = $5934230967ac1c51$var$_createForOfIteratorHelper(registry), _step;
            try {
                for(_iterator.s(); !(_step = _iterator.n()).done;){
                    var monitor = _step.value;
                    tryAddToActive(monitor);
                }
            } catch (err) {
                _iterator.e(err);
            } finally{
                _iterator.f();
            }
        }
        // This should never happen.
        if (!dragging) return;
        // Creating an array from the set _before_ iterating
        // This is so that monitors added during the current event will not be called.
        // This behaviour matches native EventTargets where an event listener
        // cannot add another event listener during an active event to the same
        // event target in the same event (for us we have a single global event target)
        var active = Array.from(dragging.active);
        for(var _i = 0, _active = active; _i < _active.length; _i++){
            var _monitor = _active[_i];
            // A monitor can be removed by another monitor during an event.
            // We need to check that the monitor is still registered before calling it
            if (dragging.active.has(_monitor)) {
                var _monitor$eventName;
                // @ts-expect-error: I cannot get this type working!
                (_monitor$eventName = _monitor[eventName]) === null || _monitor$eventName === void 0 || _monitor$eventName.call(_monitor, payload);
            }
        }
        if (eventName === 'onDrop') {
            dragging.active.clear();
            dragging = null;
        }
    }
    return {
        dispatchEvent: dispatchEvent,
        monitorForConsumers: monitorForConsumers
    };
}

});


parcelRegister("2NDx0", function(module, exports) {
$parcel$export(module.exports, "isAndroid", () => $209ed274009a1d32$export$a11b0059900ceec8);
$parcel$export(module.exports, "androidFallbackText", () => $209ed274009a1d32$export$aceb3ed8b7f7bd2c);

var $hqNxG = parcelRequire("hqNxG");
var $209ed274009a1d32$export$a11b0059900ceec8 = (0, $hqNxG.once)(function isAndroid() {
    return navigator.userAgent.toLocaleLowerCase().includes('android');
});
var $209ed274009a1d32$export$aceb3ed8b7f7bd2c = 'pdnd:android-fallback';

});

parcelRegister("egYGR", function(module, exports) {
$parcel$export(module.exports, "textMediaType", () => $a641a3213db5433a$export$fd3d00026297c0ad);
// Why we put the media types in their own files:
//
// - we are not putting them all in one file as not all adapters need all types
// - we are not putting them in the external helpers as some things just need the
//   types and not the external functions code
var $a641a3213db5433a$export$fd3d00026297c0ad = 'text/plain';

});

parcelRegister("WZ6t3", function(module, exports) {
$parcel$export(module.exports, "URLMediaType", () => $0b14d0bd7b3695e8$export$4c44a460f123106);
// Why we put the media types in their own files:
//
// - we are not putting them all in one file as not all adapters need all types
// - we are not putting them in the external helpers as some things just need the
//   types and not the external functions code
var $0b14d0bd7b3695e8$export$4c44a460f123106 = 'text/uri-list';

});

parcelRegister("ivIaH", function(module, exports) {
$parcel$export(module.exports, "elementAdapterNativeDataKey", () => $d79d62cc1f9c3c9d$export$c9c4cc54e73b125d);
/**
 * This key has been pulled into a separate module
 * so that the external adapter does not need to import
 * the element adapter
 */ var $d79d62cc1f9c3c9d$export$c9c4cc54e73b125d = 'application/vnd.pdnd';

});



parcelRegister("aPh0Z", function(module, exports) {
$parcel$export(module.exports, "monitorForExternal", () => (parcelRequire("h6ZPT")).monitorForExternal);

var $h6ZPT = parcelRequire("h6ZPT");
 // The data that is being dragged

});
parcelRegister("h6ZPT", function(module, exports) {
$parcel$export(module.exports, "monitorForExternal", () => $c752f68697c59bdc$export$bb1740f3194979c1);

var $fC8ib = parcelRequire("fC8ib");

var $7QpUe = parcelRequire("7QpUe");

var $96VL5 = parcelRequire("96VL5");

var $2NDx0 = parcelRequire("2NDx0");

var $jBWab = parcelRequire("jBWab");

var $b5JMg = parcelRequire("b5JMg");

var $egYGR = parcelRequire("egYGR");

var $ivIaH = parcelRequire("ivIaH");
function $c752f68697c59bdc$export$a8e56a860d7957c7(_ref) {
    var type = _ref.type, value = _ref.value;
    // We don't want to expose our private elementAdapter key / value
    if (type === (0, $ivIaH.elementAdapterNativeDataKey)) return false;
    // Not exposing "text/plain" if it contains the android fallback text
    // We _could_ add an `isAndroid()` check, but it's probably safest
    // to trim this data out, regardless of what OS we see it on.
    if (type === (0, $egYGR.textMediaType) && value === (0, $2NDx0.androidFallbackText)) return false;
    return true;
}
function $c752f68697c59bdc$export$8c257a3856120a77(transfer) {
    return Array.from(transfer.types).filter(function(type) {
        return $c752f68697c59bdc$export$a8e56a860d7957c7({
            type: type,
            value: transfer.getData(type)
        });
    });
}
function $c752f68697c59bdc$export$8d28cfecded8dcab(dataTransfer) {
    // item.kind is 'string' | 'file'
    // For 'string' item.type is the mimeType (eg 'text/plain')
    // For 'file' item.type is the file type (eg 'image/jpg')
    return Array.from(dataTransfer.items).filter(function(item) {
        return item.kind === 'file' || $c752f68697c59bdc$export$a8e56a860d7957c7({
            type: item.type,
            value: dataTransfer.getData(item.type)
        });
    });
}
var $c752f68697c59bdc$var$didDragStartLocally = false;
var $c752f68697c59bdc$var$adapter = (0, $96VL5.makeAdapter)({
    typeKey: 'external',
    // for external drags, we are generally making a copy of something that is being dragged
    defaultDropEffect: 'copy',
    mount: function mount(api) {
        // Binding to the `window` so that the element adapter
        // has a chance to get in first on the`document`.
        // We are giving preference to the element adapter.
        return (0, $7QpUe.bind)(window, {
            type: 'dragenter',
            listener: function listener(event) {
                // drag operation was started within the document, it won't be an "external" drag
                if ($c752f68697c59bdc$var$didDragStartLocally) return;
                // Note: not checking if event was cancelled (`event.defaultPrevented`) as
                // cancelling a "dragenter" accepts the drag operation (not prevent it)
                // Something has gone wrong with our drag event
                if (!event.dataTransfer) return;
                if (!api.canStart(event)) return;
                if (!(0, $jBWab.isEnteringWindow)({
                    dragEnter: event
                })) return;
                // Note: not checking types for `elementAdapterNativeDataKey` as we expect to see that
                // key when pdnd started the drag in another document
                var types = $c752f68697c59bdc$export$8c257a3856120a77(event.dataTransfer);
                if (!types.length) return;
                var locked = {
                    types: types,
                    items: [],
                    getStringData: function getStringData() {
                        return null;
                    }
                };
                api.start({
                    event: event,
                    dragType: {
                        type: 'external',
                        startedFrom: 'external',
                        payload: locked,
                        getDropPayload: function getDropPayload(event) {
                            // this would be a platform error
                            // trying to handle it gracefully rather than throwing (for now)
                            if (!event.dataTransfer) return locked;
                            var items = $c752f68697c59bdc$export$8d28cfecded8dcab(event.dataTransfer);
                            // need to use `.bind` as `getData` is required
                            // to be run with `event.dataTransfer` as the "this" context
                            var nativeGetData = event.dataTransfer.getData.bind(event.dataTransfer);
                            return {
                                types: types,
                                items: items,
                                // return `null` if there is no result, otherwise string
                                getStringData: function getStringData(mediaType) {
                                    // not dragging the requested type
                                    // return `null` (no result)
                                    if (!types.includes(mediaType)) return null;
                                    // nativeGetData will return `""` when there is no value,
                                    // but at this point we know we will only get explicitly set
                                    // values back as we have checked the `types`.
                                    // `""` can be an explicitly set value.
                                    var value = nativeGetData(mediaType);
                                    // not exposing data for unavailable types
                                    if (!$c752f68697c59bdc$export$a8e56a860d7957c7({
                                        type: mediaType,
                                        value: value
                                    })) return null;
                                    return value;
                                }
                            };
                        }
                    }
                });
            }
        });
    }
});
function $c752f68697c59bdc$export$9edc779df9a85289(args) {
    // not removing unused events, just leaning on the type system
    return $c752f68697c59bdc$var$adapter.dropTarget(args);
}
function $c752f68697c59bdc$export$bb1740f3194979c1(args) {
    // not removing unused events, just leaning on the type system
    return $c752f68697c59bdc$var$adapter.monitor(args);
}
(function startup() {
    // server side rendering check
    if (typeof window === 'undefined') return;
    // A shared single usage registration as we want to capture
    // all external drag operations, even if there are no drop targets
    // on the page yet
    $c752f68697c59bdc$var$adapter.registerUsage();
    // independent of pdnd, we need to keep track of
    // all drag operations so that we can know if a drag operation
    // has started locally
    var idle = {
        type: 'idle'
    };
    var state = idle;
    function clear() {
        if (state.type !== 'dragging') return;
        $c752f68697c59bdc$var$didDragStartLocally = false;
        state.cleanup();
        state = idle;
    }
    function bindEndEvents() {
        return (0, $7QpUe.bindAll)(window, [
            {
                type: 'dragend',
                listener: clear
            }
        ].concat((0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))((0, $b5JMg.getBindingsForBrokenDrags)({
            onDragEnd: clear
        }))), // we want to make sure we get all the events,
        // and this helps avoid not seeing events when folks stop
        // them later on the event path
        {
            capture: true
        });
    }
    // we always keep this event listener active
    (0, $7QpUe.bind)(window, {
        type: 'dragstart',
        listener: function listener() {
            // something bad has happened if this is true!
            if (state.type !== 'idle') return;
            // set our global flag
            $c752f68697c59bdc$var$didDragStartLocally = true;
            state = {
                type: 'dragging',
                cleanup: bindEndEvents()
            };
        },
        // binding in the capture phase so these listeners are called
        // before our listeners in the adapters `mount` function
        options: {
            capture: true
        }
    });
})(); /** Common event payload for all events */  /** A map containing payloads for all events */  /** Common event payload for all drop target events */  /** A map containing payloads for all events on drop targets */  /** Arguments given to all feedback functions (eg `canDrop()`) on a `dropTargetForExternal` */  /** Arguments given to all monitor feedback functions (eg `canMonitor()`) for a `monitorForExternal` */ 

});
parcelRegister("jBWab", function(module, exports) {
$parcel$export(module.exports, "isEnteringWindow", () => $e46e970932b10f13$export$d1c6f249e893cdf4);

var $f7oM5 = parcelRequire("f7oM5");

var $8nu2B = parcelRequire("8nu2B");

var $7FN5w = parcelRequire("7FN5w");

var $2eElm = parcelRequire("2eElm");
function $e46e970932b10f13$export$d1c6f249e893cdf4(_ref) {
    var dragEnter = _ref.dragEnter;
    var type = dragEnter.type, relatedTarget = dragEnter.relatedTarget;
    if (type !== 'dragenter') return false;
    if ((0, $8nu2B.isSafari)()) return (0, $7FN5w.isEnteringWindowInSafari)({
        dragEnter: dragEnter
    });
    // standard check
    if (relatedTarget == null) return true;
    /**
   * 🦊 Exception: `iframe` in Firefox (`125.0`)
   *
   * Case 1: parent `window` → child `iframe`
   * `relatedTarget` is the `iframe` element in the parent `window`
   * (foreign element)
   *
   * Case 2: child `iframe` → parent `window`
   * `relatedTarget` is an element inside the child `iframe`
   * (foreign element)
   */ if ((0, $f7oM5.isFirefox)()) return (0, $2eElm.isFromAnotherWindow)(relatedTarget);
    /**
   * 🌏 Exception: `iframe` in Chrome (`124.0`)
   *
   * Case 1: parent `window` → child `iframe`
   * `relatedTarget` is `null` *(standard check)*
   *
   * Case 2: child `iframe` → parent `window`
   * `relatedTarget` is the `iframe` element in the parent `window`
   */ // Case 2
    // Using `instanceof` check as the element will be in the same `window`
    return relatedTarget instanceof HTMLIFrameElement;
}

});



parcelRegister("4p4mj", function(module, exports) {
$parcel$export(module.exports, "monitorForTextSelection", () => (parcelRequire("5O7Kz")).monitorForTextSelection);

var $5O7Kz = parcelRequire("5O7Kz");
 // Payload for the text selection being dragged

});
parcelRegister("5O7Kz", function(module, exports) {
$parcel$export(module.exports, "monitorForTextSelection", () => $43a7a24835c609f6$export$2e178e3647f5e6e9);

var $7QpUe = parcelRequire("7QpUe");

var $9yVBQ = parcelRequire("9yVBQ");

var $96VL5 = parcelRequire("96VL5");

var $fGFYU = parcelRequire("fGFYU");

var $8nu2B = parcelRequire("8nu2B");

var $ltjac = parcelRequire("ltjac");

var $egYGR = parcelRequire("egYGR");

var $ivIaH = parcelRequire("ivIaH");
function $43a7a24835c609f6$var$findTextNode(event) {
    var _event$dataTransfer;
    // Standard: the `event.target` should be the closest `Text` node.
    if (event.target instanceof Text) return event.target;
    // Structuring things this way so that if Safari fixes their bug
    // then the standard check will start working
    if (!(0, $8nu2B.isSafari)()) return null;
    /**
   * According to the spec, `event.target` should be the `Text` node that
   * the drag started from when dragging a text selection.
   *
   * → https://html.spec.whatwg.org/multipage/dnd.html#drag-and-drop-processing-model
   *
   * However, in Safari the closest `HTMLElement` is returned.
   * So we need to figure out if text is dragging ourselves.
   *
   * → https://bugs.webkit.org/show_bug.cgi?id=268959
   */ if (!(event.target instanceof HTMLElement)) return null;
    // Unlikely that this particular drag is a text selection drag
    if (event.target.draggable) return null;
    // if the drag contains no text data, then not dragging selected text
    // return `null` if there is no dataTransfer, or if `getData()` returns ""
    if (!((_event$dataTransfer = event.dataTransfer) !== null && _event$dataTransfer !== void 0 && _event$dataTransfer.getData((0, $egYGR.textMediaType)))) return null;
    /**
   * Grab the first Text node and use that.
   * Only doing a single level search as that is all we need for this bug.
   */ var text = Array.from(event.target.childNodes).find(function(node) {
        return node.nodeType === Node.TEXT_NODE;
    });
    return text !== null && text !== void 0 ? text : null;
}
var $43a7a24835c609f6$var$honeyPotFix = (0, $9yVBQ.makeHoneyPotFix)();
var $43a7a24835c609f6$var$adapter = (0, $96VL5.makeAdapter)({
    typeKey: 'text-selection',
    // for text selection, we will usually be making a copy of the text
    defaultDropEffect: 'copy',
    mount: function mount(api) {
        // Binding to the `window` so that the element adapter has a
        // chance to get in first on the `document`.
        // We are giving preference to the element adapter.
        return (0, $fGFYU.combine)($43a7a24835c609f6$var$honeyPotFix.bindEvents(), (0, $7QpUe.bind)(window, {
            type: 'dragstart',
            listener: function listener(event) {
                // If the "dragstart" event is cancelled, then a drag won't start
                // There will be no further drag operation events (eg no "dragend" event)
                if (event.defaultPrevented) return;
                // Something has gone wrong with our drag event
                if (!event.dataTransfer) return;
                // Drag is being handled by the element adapter
                if (event.dataTransfer.types.includes((0, $ivIaH.elementAdapterNativeDataKey))) return;
                // Something else is handling this drag
                if (!api.canStart(event)) return;
                // no text being dragged
                if (!event.dataTransfer.types.includes((0, $egYGR.textMediaType))) return;
                var target = $43a7a24835c609f6$var$findTextNode(event);
                // could not find `Text` node that is being dragged from
                if (!target) return;
                var payload = {
                    // The `Text` node that is the `target` is the `Text` node
                    // that the user started the drag from.
                    // The full text being dragged can be looked up from the `dataTransfer`.
                    target: target,
                    plain: event.dataTransfer.getData((0, $egYGR.textMediaType)),
                    HTML: event.dataTransfer.getData((0, $ltjac.HTMLMediaType))
                };
                api.start({
                    event: event,
                    dragType: {
                        type: 'text-selection',
                        startedFrom: 'internal',
                        payload: payload
                    }
                });
            }
        }));
    },
    onPostDispatch: $43a7a24835c609f6$var$honeyPotFix.getOnPostDispatch()
});
function $43a7a24835c609f6$export$9bfaa8eb182300d1(args) {
    // note: not removing `onGenerateDragPreview`; just leaning on the type system
    return $43a7a24835c609f6$var$adapter.dropTarget(args);
}
// A shared single usage registration as any text can be dragged at any time
(function register() {
    // server side rendering check
    if (typeof window === 'undefined') return;
    $43a7a24835c609f6$var$adapter.registerUsage();
})();
function $43a7a24835c609f6$export$2e178e3647f5e6e9(args) {
    // note: not removing `onGenerateDragPreview`; just leaning on the type system
    return $43a7a24835c609f6$var$adapter.monitor(args);
} /** Common event payload for all events */  /** A map containing payloads for all events */  /** Common event payload for all drop target events */  /** A map containing payloads for all events on drop targets */  /** Argument given to all feedback functions (eg `canDrop()`) on a `dropTargetForExternal` */  /** Argument given to all monitor feedback functions (eg `canMonitor()`) for a `monitorForExternal` */ 

});
parcelRegister("ltjac", function(module, exports) {
$parcel$export(module.exports, "HTMLMediaType", () => $fa1b2bde86a492fb$export$338a9f6c7a1f02b0);
// Why we put the media types in their own files:
//
// - we are not putting them all in one file as not all adapters need all types
// - we are not putting them in the external helpers as some things just need the
//   types and not the external functions code
var $fa1b2bde86a492fb$export$338a9f6c7a1f02b0 = 'text/html';

});



parcelRegister("7KfP5", function(module, exports) {
$parcel$export(module.exports, "Buffer", () => $5a391a6961854a1b$export$a143d493d941bafc, (v) => $5a391a6961854a1b$export$a143d493d941bafc = v);
$parcel$export(module.exports, "SlowBuffer", () => $5a391a6961854a1b$export$e4cf37d7f6fb9e0a, (v) => $5a391a6961854a1b$export$e4cf37d7f6fb9e0a = v);
$parcel$export(module.exports, "INSPECT_MAX_BYTES", () => $5a391a6961854a1b$export$f99ded8fe4b79145, (v) => $5a391a6961854a1b$export$f99ded8fe4b79145 = v);
$parcel$export(module.exports, "kMaxLength", () => $5a391a6961854a1b$export$599f31c3813fae4d, (v) => $5a391a6961854a1b$export$599f31c3813fae4d = v);
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $5a391a6961854a1b$export$a143d493d941bafc;
var $5a391a6961854a1b$export$e4cf37d7f6fb9e0a;
var $5a391a6961854a1b$export$f99ded8fe4b79145;
var $5a391a6961854a1b$export$599f31c3813fae4d;
'use strict';

var $dgRjT = parcelRequire("dgRjT");

var $ixcFU = parcelRequire("ixcFU");
var $5a391a6961854a1b$var$customInspectSymbol = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' // eslint-disable-line dot-notation
 ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
 : null;
$5a391a6961854a1b$export$a143d493d941bafc = $5a391a6961854a1b$var$Buffer;
$5a391a6961854a1b$export$e4cf37d7f6fb9e0a = $5a391a6961854a1b$var$SlowBuffer;
$5a391a6961854a1b$export$f99ded8fe4b79145 = 50;
var $5a391a6961854a1b$var$K_MAX_LENGTH = 0x7fffffff;
$5a391a6961854a1b$export$599f31c3813fae4d = $5a391a6961854a1b$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $5a391a6961854a1b$var$Buffer.TYPED_ARRAY_SUPPORT = $5a391a6961854a1b$var$typedArraySupport();
if (!$5a391a6961854a1b$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $5a391a6961854a1b$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        var arr = new Uint8Array(1);
        var proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($5a391a6961854a1b$var$Buffer.prototype, 'parent', {
    enumerable: true,
    get: function() {
        if (!$5a391a6961854a1b$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($5a391a6961854a1b$var$Buffer.prototype, 'offset', {
    enumerable: true,
    get: function() {
        if (!$5a391a6961854a1b$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $5a391a6961854a1b$var$createBuffer(length) {
    if (length > $5a391a6961854a1b$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    var buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $5a391a6961854a1b$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $5a391a6961854a1b$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') throw new TypeError('The "string" argument must be of type string. Received type number');
        return $5a391a6961854a1b$var$allocUnsafe(arg);
    }
    return $5a391a6961854a1b$var$from(arg, encodingOrOffset, length);
}
$5a391a6961854a1b$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $5a391a6961854a1b$var$from(value, encodingOrOffset, length) {
    if (typeof value === 'string') return $5a391a6961854a1b$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $5a391a6961854a1b$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($5a391a6961854a1b$var$isInstance(value, ArrayBuffer) || value && $5a391a6961854a1b$var$isInstance(value.buffer, ArrayBuffer)) return $5a391a6961854a1b$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== 'undefined' && ($5a391a6961854a1b$var$isInstance(value, SharedArrayBuffer) || value && $5a391a6961854a1b$var$isInstance(value.buffer, SharedArrayBuffer))) return $5a391a6961854a1b$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type number');
    var valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $5a391a6961854a1b$var$Buffer.from(valueOf, encodingOrOffset, length);
    var b = $5a391a6961854a1b$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') return $5a391a6961854a1b$var$Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $5a391a6961854a1b$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $5a391a6961854a1b$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($5a391a6961854a1b$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($5a391a6961854a1b$var$Buffer, Uint8Array);
function $5a391a6961854a1b$var$assertSize(size) {
    if (typeof size !== 'number') throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $5a391a6961854a1b$var$alloc(size, fill, encoding) {
    $5a391a6961854a1b$var$assertSize(size);
    if (size <= 0) return $5a391a6961854a1b$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string' ? $5a391a6961854a1b$var$createBuffer(size).fill(fill, encoding) : $5a391a6961854a1b$var$createBuffer(size).fill(fill);
    return $5a391a6961854a1b$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $5a391a6961854a1b$var$Buffer.alloc = function(size, fill, encoding) {
    return $5a391a6961854a1b$var$alloc(size, fill, encoding);
};
function $5a391a6961854a1b$var$allocUnsafe(size) {
    $5a391a6961854a1b$var$assertSize(size);
    return $5a391a6961854a1b$var$createBuffer(size < 0 ? 0 : $5a391a6961854a1b$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $5a391a6961854a1b$var$Buffer.allocUnsafe = function(size) {
    return $5a391a6961854a1b$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $5a391a6961854a1b$var$Buffer.allocUnsafeSlow = function(size) {
    return $5a391a6961854a1b$var$allocUnsafe(size);
};
function $5a391a6961854a1b$var$fromString(string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!$5a391a6961854a1b$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
    var length = $5a391a6961854a1b$var$byteLength(string, encoding) | 0;
    var buf = $5a391a6961854a1b$var$createBuffer(length);
    var actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $5a391a6961854a1b$var$fromArrayLike(array) {
    var length = array.length < 0 ? 0 : $5a391a6961854a1b$var$checked(array.length) | 0;
    var buf = $5a391a6961854a1b$var$createBuffer(length);
    for(var i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $5a391a6961854a1b$var$fromArrayView(arrayView) {
    if ($5a391a6961854a1b$var$isInstance(arrayView, Uint8Array)) {
        var copy = new Uint8Array(arrayView);
        return $5a391a6961854a1b$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $5a391a6961854a1b$var$fromArrayLike(arrayView);
}
function $5a391a6961854a1b$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    var buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $5a391a6961854a1b$var$Buffer.prototype);
    return buf;
}
function $5a391a6961854a1b$var$fromObject(obj) {
    if ($5a391a6961854a1b$var$Buffer.isBuffer(obj)) {
        var len = $5a391a6961854a1b$var$checked(obj.length) | 0;
        var buf = $5a391a6961854a1b$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== 'number' || $5a391a6961854a1b$var$numberIsNaN(obj.length)) return $5a391a6961854a1b$var$createBuffer(0);
        return $5a391a6961854a1b$var$fromArrayLike(obj);
    }
    if (obj.type === 'Buffer' && Array.isArray(obj.data)) return $5a391a6961854a1b$var$fromArrayLike(obj.data);
}
function $5a391a6961854a1b$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $5a391a6961854a1b$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $5a391a6961854a1b$var$K_MAX_LENGTH.toString(16) + ' bytes');
    return length | 0;
}
function $5a391a6961854a1b$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $5a391a6961854a1b$var$Buffer.alloc(+length);
}
$5a391a6961854a1b$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $5a391a6961854a1b$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$5a391a6961854a1b$var$Buffer.compare = function compare(a, b) {
    if ($5a391a6961854a1b$var$isInstance(a, Uint8Array)) a = $5a391a6961854a1b$var$Buffer.from(a, a.offset, a.byteLength);
    if ($5a391a6961854a1b$var$isInstance(b, Uint8Array)) b = $5a391a6961854a1b$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$5a391a6961854a1b$var$Buffer.isBuffer(a) || !$5a391a6961854a1b$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    var x = a.length;
    var y = b.length;
    for(var i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$5a391a6961854a1b$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
$5a391a6961854a1b$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $5a391a6961854a1b$var$Buffer.alloc(0);
    var i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    var buffer = $5a391a6961854a1b$var$Buffer.allocUnsafe(length);
    var pos = 0;
    for(i = 0; i < list.length; ++i){
        var buf = list[i];
        if ($5a391a6961854a1b$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) $5a391a6961854a1b$var$Buffer.from(buf).copy(buffer, pos);
            else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$5a391a6961854a1b$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $5a391a6961854a1b$var$byteLength(string, encoding) {
    if ($5a391a6961854a1b$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $5a391a6961854a1b$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== 'string') throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    var len = string.length;
    var mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    var loweredCase = false;
    for(;;)switch(encoding){
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
            return $5a391a6961854a1b$var$utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return $5a391a6961854a1b$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $5a391a6961854a1b$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
}
$5a391a6961854a1b$var$Buffer.byteLength = $5a391a6961854a1b$var$byteLength;
function $5a391a6961854a1b$var$slowToString(encoding, start, end) {
    var loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return '';
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return '';
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return '';
    if (!encoding) encoding = 'utf8';
    while(true)switch(encoding){
        case 'hex':
            return $5a391a6961854a1b$var$hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return $5a391a6961854a1b$var$utf8Slice(this, start, end);
        case 'ascii':
            return $5a391a6961854a1b$var$asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return $5a391a6961854a1b$var$latin1Slice(this, start, end);
        case 'base64':
            return $5a391a6961854a1b$var$base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $5a391a6961854a1b$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$5a391a6961854a1b$var$Buffer.prototype._isBuffer = true;
function $5a391a6961854a1b$var$swap(b, n, m) {
    var i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$5a391a6961854a1b$var$Buffer.prototype.swap16 = function swap16() {
    var len = this.length;
    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
    for(var i = 0; i < len; i += 2)$5a391a6961854a1b$var$swap(this, i, i + 1);
    return this;
};
$5a391a6961854a1b$var$Buffer.prototype.swap32 = function swap32() {
    var len = this.length;
    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
    for(var i = 0; i < len; i += 4){
        $5a391a6961854a1b$var$swap(this, i, i + 3);
        $5a391a6961854a1b$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$5a391a6961854a1b$var$Buffer.prototype.swap64 = function swap64() {
    var len = this.length;
    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
    for(var i = 0; i < len; i += 8){
        $5a391a6961854a1b$var$swap(this, i, i + 7);
        $5a391a6961854a1b$var$swap(this, i + 1, i + 6);
        $5a391a6961854a1b$var$swap(this, i + 2, i + 5);
        $5a391a6961854a1b$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$5a391a6961854a1b$var$Buffer.prototype.toString = function toString() {
    var length = this.length;
    if (length === 0) return '';
    if (arguments.length === 0) return $5a391a6961854a1b$var$utf8Slice(this, 0, length);
    return $5a391a6961854a1b$var$slowToString.apply(this, arguments);
};
$5a391a6961854a1b$var$Buffer.prototype.toLocaleString = $5a391a6961854a1b$var$Buffer.prototype.toString;
$5a391a6961854a1b$var$Buffer.prototype.equals = function equals(b) {
    if (!$5a391a6961854a1b$var$Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return $5a391a6961854a1b$var$Buffer.compare(this, b) === 0;
};
$5a391a6961854a1b$var$Buffer.prototype.inspect = function inspect() {
    var str = '';
    var max = $5a391a6961854a1b$export$f99ded8fe4b79145;
    str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
    if (this.length > max) str += ' ... ';
    return '<Buffer ' + str + '>';
};
if ($5a391a6961854a1b$var$customInspectSymbol) $5a391a6961854a1b$var$Buffer.prototype[$5a391a6961854a1b$var$customInspectSymbol] = $5a391a6961854a1b$var$Buffer.prototype.inspect;
$5a391a6961854a1b$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($5a391a6961854a1b$var$isInstance(target, Uint8Array)) target = $5a391a6961854a1b$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$5a391a6961854a1b$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    var x = thisEnd - thisStart;
    var y = end - start;
    var len = Math.min(x, y);
    var thisCopy = this.slice(thisStart, thisEnd);
    var targetCopy = target.slice(start, end);
    for(var i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $5a391a6961854a1b$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($5a391a6961854a1b$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === 'string') val = $5a391a6961854a1b$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($5a391a6961854a1b$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $5a391a6961854a1b$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $5a391a6961854a1b$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function $5a391a6961854a1b$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    var indexSize = 1;
    var arrLength = arr.length;
    var valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    var i;
    if (dir) {
        var foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            var found = true;
            for(var j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$5a391a6961854a1b$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$5a391a6961854a1b$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $5a391a6961854a1b$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$5a391a6961854a1b$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $5a391a6961854a1b$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $5a391a6961854a1b$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    var remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    var strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    for(var i = 0; i < length; ++i){
        var parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($5a391a6961854a1b$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $5a391a6961854a1b$var$utf8Write(buf, string, offset, length) {
    return $5a391a6961854a1b$var$blitBuffer($5a391a6961854a1b$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $5a391a6961854a1b$var$asciiWrite(buf, string, offset, length) {
    return $5a391a6961854a1b$var$blitBuffer($5a391a6961854a1b$var$asciiToBytes(string), buf, offset, length);
}
function $5a391a6961854a1b$var$base64Write(buf, string, offset, length) {
    return $5a391a6961854a1b$var$blitBuffer($5a391a6961854a1b$var$base64ToBytes(string), buf, offset, length);
}
function $5a391a6961854a1b$var$ucs2Write(buf, string, offset, length) {
    return $5a391a6961854a1b$var$blitBuffer($5a391a6961854a1b$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$5a391a6961854a1b$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    var remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
    if (!encoding) encoding = 'utf8';
    var loweredCase = false;
    for(;;)switch(encoding){
        case 'hex':
            return $5a391a6961854a1b$var$hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return $5a391a6961854a1b$var$utf8Write(this, string, offset, length);
        case 'ascii':
        case 'latin1':
        case 'binary':
            return $5a391a6961854a1b$var$asciiWrite(this, string, offset, length);
        case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return $5a391a6961854a1b$var$base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $5a391a6961854a1b$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
};
$5a391a6961854a1b$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $5a391a6961854a1b$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $dgRjT.fromByteArray(buf);
    else return $dgRjT.fromByteArray(buf.slice(start, end));
}
function $5a391a6961854a1b$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    var res = [];
    var i = start;
    while(i < end){
        var firstByte = buf[i];
        var codePoint = null;
        var bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            var secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $5a391a6961854a1b$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var $5a391a6961854a1b$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $5a391a6961854a1b$var$decodeCodePointsArray(codePoints) {
    var len = codePoints.length;
    if (len <= $5a391a6961854a1b$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    var res = '';
    var i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $5a391a6961854a1b$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $5a391a6961854a1b$var$asciiSlice(buf, start, end) {
    var ret = '';
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $5a391a6961854a1b$var$latin1Slice(buf, start, end) {
    var ret = '';
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $5a391a6961854a1b$var$hexSlice(buf, start, end) {
    var len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    var out = '';
    for(var i = start; i < end; ++i)out += $5a391a6961854a1b$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $5a391a6961854a1b$var$utf16leSlice(buf, start, end) {
    var bytes = buf.slice(start, end);
    var res = '';
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(var i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$5a391a6961854a1b$var$Buffer.prototype.slice = function slice(start, end) {
    var len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    var newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $5a391a6961854a1b$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $5a391a6961854a1b$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
$5a391a6961854a1b$var$Buffer.prototype.readUintLE = $5a391a6961854a1b$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $5a391a6961854a1b$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$5a391a6961854a1b$var$Buffer.prototype.readUintBE = $5a391a6961854a1b$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $5a391a6961854a1b$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset + --byteLength];
    var mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$5a391a6961854a1b$var$Buffer.prototype.readUint8 = $5a391a6961854a1b$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $5a391a6961854a1b$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$5a391a6961854a1b$var$Buffer.prototype.readUint16LE = $5a391a6961854a1b$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $5a391a6961854a1b$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$5a391a6961854a1b$var$Buffer.prototype.readUint16BE = $5a391a6961854a1b$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $5a391a6961854a1b$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$5a391a6961854a1b$var$Buffer.prototype.readUint32LE = $5a391a6961854a1b$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $5a391a6961854a1b$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$5a391a6961854a1b$var$Buffer.prototype.readUint32BE = $5a391a6961854a1b$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $5a391a6961854a1b$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$5a391a6961854a1b$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $5a391a6961854a1b$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$5a391a6961854a1b$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $5a391a6961854a1b$var$checkOffset(offset, byteLength, this.length);
    var i = byteLength;
    var mul = 1;
    var val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$5a391a6961854a1b$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $5a391a6961854a1b$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$5a391a6961854a1b$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $5a391a6961854a1b$var$checkOffset(offset, 2, this.length);
    var val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$5a391a6961854a1b$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $5a391a6961854a1b$var$checkOffset(offset, 2, this.length);
    var val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$5a391a6961854a1b$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $5a391a6961854a1b$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$5a391a6961854a1b$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $5a391a6961854a1b$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$5a391a6961854a1b$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $5a391a6961854a1b$var$checkOffset(offset, 4, this.length);
    return $ixcFU.read(this, offset, true, 23, 4);
};
$5a391a6961854a1b$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $5a391a6961854a1b$var$checkOffset(offset, 4, this.length);
    return $ixcFU.read(this, offset, false, 23, 4);
};
$5a391a6961854a1b$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $5a391a6961854a1b$var$checkOffset(offset, 8, this.length);
    return $ixcFU.read(this, offset, true, 52, 8);
};
$5a391a6961854a1b$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $5a391a6961854a1b$var$checkOffset(offset, 8, this.length);
    return $ixcFU.read(this, offset, false, 52, 8);
};
function $5a391a6961854a1b$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$5a391a6961854a1b$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
$5a391a6961854a1b$var$Buffer.prototype.writeUintLE = $5a391a6961854a1b$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $5a391a6961854a1b$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var mul = 1;
    var i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$5a391a6961854a1b$var$Buffer.prototype.writeUintBE = $5a391a6961854a1b$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $5a391a6961854a1b$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var i = byteLength - 1;
    var mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$5a391a6961854a1b$var$Buffer.prototype.writeUint8 = $5a391a6961854a1b$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $5a391a6961854a1b$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$5a391a6961854a1b$var$Buffer.prototype.writeUint16LE = $5a391a6961854a1b$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $5a391a6961854a1b$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$5a391a6961854a1b$var$Buffer.prototype.writeUint16BE = $5a391a6961854a1b$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $5a391a6961854a1b$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$5a391a6961854a1b$var$Buffer.prototype.writeUint32LE = $5a391a6961854a1b$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $5a391a6961854a1b$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$5a391a6961854a1b$var$Buffer.prototype.writeUint32BE = $5a391a6961854a1b$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $5a391a6961854a1b$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$5a391a6961854a1b$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $5a391a6961854a1b$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = 0;
    var mul = 1;
    var sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$5a391a6961854a1b$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $5a391a6961854a1b$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = byteLength - 1;
    var mul = 1;
    var sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$5a391a6961854a1b$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $5a391a6961854a1b$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$5a391a6961854a1b$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $5a391a6961854a1b$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$5a391a6961854a1b$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $5a391a6961854a1b$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$5a391a6961854a1b$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $5a391a6961854a1b$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$5a391a6961854a1b$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $5a391a6961854a1b$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $5a391a6961854a1b$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
}
function $5a391a6961854a1b$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $5a391a6961854a1b$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $ixcFU.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$5a391a6961854a1b$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $5a391a6961854a1b$var$writeFloat(this, value, offset, true, noAssert);
};
$5a391a6961854a1b$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $5a391a6961854a1b$var$writeFloat(this, value, offset, false, noAssert);
};
function $5a391a6961854a1b$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $5a391a6961854a1b$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $ixcFU.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$5a391a6961854a1b$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $5a391a6961854a1b$var$writeDouble(this, value, offset, true, noAssert);
};
$5a391a6961854a1b$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $5a391a6961854a1b$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$5a391a6961854a1b$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$5a391a6961854a1b$var$Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
    if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    var len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$5a391a6961854a1b$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
        if (typeof encoding === 'string' && !$5a391a6961854a1b$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
        if (val.length === 1) {
            var code = val.charCodeAt(0);
            if (encoding === 'utf8' && code < 128 || encoding === 'latin1') // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === 'number') val = val & 255;
    else if (typeof val === 'boolean') val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    var i;
    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
    else {
        var bytes = $5a391a6961854a1b$var$Buffer.isBuffer(val) ? val : $5a391a6961854a1b$var$Buffer.from(val, encoding);
        var len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// HELPER FUNCTIONS
// ================
var $5a391a6961854a1b$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $5a391a6961854a1b$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split('=')[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($5a391a6961854a1b$var$INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + '=';
    return str;
}
function $5a391a6961854a1b$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    var codePoint;
    var length = string.length;
    var leadSurrogate = null;
    var bytes = [];
    for(var i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function $5a391a6961854a1b$var$asciiToBytes(str) {
    var byteArray = [];
    for(var i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $5a391a6961854a1b$var$utf16leToBytes(str, units) {
    var c, hi, lo;
    var byteArray = [];
    for(var i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $5a391a6961854a1b$var$base64ToBytes(str) {
    return $dgRjT.toByteArray($5a391a6961854a1b$var$base64clean(str));
}
function $5a391a6961854a1b$var$blitBuffer(src, dst, offset, length) {
    for(var i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $5a391a6961854a1b$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $5a391a6961854a1b$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
var $5a391a6961854a1b$var$hexSliceLookupTable = function() {
    var alphabet = '0123456789abcdef';
    var table = new Array(256);
    for(var i = 0; i < 16; ++i){
        var i16 = i * 16;
        for(var j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();

});
parcelRegister("dgRjT", function(module, exports) {
$parcel$export(module.exports, "toByteArray", () => $9a96212d3d126b36$export$d622b2ad8d90c771, (v) => $9a96212d3d126b36$export$d622b2ad8d90c771 = v);
$parcel$export(module.exports, "fromByteArray", () => $9a96212d3d126b36$export$6100ba28696e12de, (v) => $9a96212d3d126b36$export$6100ba28696e12de = v);
var $9a96212d3d126b36$export$a48f0734ac7c2329;
var $9a96212d3d126b36$export$d622b2ad8d90c771;
var $9a96212d3d126b36$export$6100ba28696e12de;
'use strict';
$9a96212d3d126b36$export$a48f0734ac7c2329 = $9a96212d3d126b36$var$byteLength;
$9a96212d3d126b36$export$d622b2ad8d90c771 = $9a96212d3d126b36$var$toByteArray;
$9a96212d3d126b36$export$6100ba28696e12de = $9a96212d3d126b36$var$fromByteArray;
var $9a96212d3d126b36$var$lookup = [];
var $9a96212d3d126b36$var$revLookup = [];
var $9a96212d3d126b36$var$Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array;
var $9a96212d3d126b36$var$code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
for(var $9a96212d3d126b36$var$i = 0, $9a96212d3d126b36$var$len = $9a96212d3d126b36$var$code.length; $9a96212d3d126b36$var$i < $9a96212d3d126b36$var$len; ++$9a96212d3d126b36$var$i){
    $9a96212d3d126b36$var$lookup[$9a96212d3d126b36$var$i] = $9a96212d3d126b36$var$code[$9a96212d3d126b36$var$i];
    $9a96212d3d126b36$var$revLookup[$9a96212d3d126b36$var$code.charCodeAt($9a96212d3d126b36$var$i)] = $9a96212d3d126b36$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$9a96212d3d126b36$var$revLookup['-'.charCodeAt(0)] = 62;
$9a96212d3d126b36$var$revLookup['_'.charCodeAt(0)] = 63;
function $9a96212d3d126b36$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error('Invalid string. Length must be a multiple of 4');
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf('=');
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $9a96212d3d126b36$var$byteLength(b64) {
    var lens = $9a96212d3d126b36$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $9a96212d3d126b36$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $9a96212d3d126b36$var$toByteArray(b64) {
    var tmp;
    var lens = $9a96212d3d126b36$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $9a96212d3d126b36$var$Arr($9a96212d3d126b36$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $9a96212d3d126b36$var$revLookup[b64.charCodeAt(i)] << 18 | $9a96212d3d126b36$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $9a96212d3d126b36$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $9a96212d3d126b36$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $9a96212d3d126b36$var$revLookup[b64.charCodeAt(i)] << 2 | $9a96212d3d126b36$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $9a96212d3d126b36$var$revLookup[b64.charCodeAt(i)] << 10 | $9a96212d3d126b36$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $9a96212d3d126b36$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $9a96212d3d126b36$var$tripletToBase64(num) {
    return $9a96212d3d126b36$var$lookup[num >> 18 & 0x3F] + $9a96212d3d126b36$var$lookup[num >> 12 & 0x3F] + $9a96212d3d126b36$var$lookup[num >> 6 & 0x3F] + $9a96212d3d126b36$var$lookup[num & 0x3F];
}
function $9a96212d3d126b36$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($9a96212d3d126b36$var$tripletToBase64(tmp));
    }
    return output.join('');
}
function $9a96212d3d126b36$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($9a96212d3d126b36$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($9a96212d3d126b36$var$lookup[tmp >> 2] + $9a96212d3d126b36$var$lookup[tmp << 4 & 0x3F] + '==');
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($9a96212d3d126b36$var$lookup[tmp >> 10] + $9a96212d3d126b36$var$lookup[tmp >> 4 & 0x3F] + $9a96212d3d126b36$var$lookup[tmp << 2 & 0x3F] + '=');
    }
    return parts.join('');
}

});

parcelRegister("ixcFU", function(module, exports) {
$parcel$export(module.exports, "read", () => $d7e5240a5359e1f9$export$aafa59e2e03f2942, (v) => $d7e5240a5359e1f9$export$aafa59e2e03f2942 = v);
$parcel$export(module.exports, "write", () => $d7e5240a5359e1f9$export$68d8715fc104d294, (v) => $d7e5240a5359e1f9$export$68d8715fc104d294 = v);
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $d7e5240a5359e1f9$export$aafa59e2e03f2942;
var $d7e5240a5359e1f9$export$68d8715fc104d294;
$d7e5240a5359e1f9$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$d7e5240a5359e1f9$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};

});


parcelRegister("8kEM5", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::11bb746989e6f2f05a6a45e4a2d4e804>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $610fd1f4fd211056$var$_react = $610fd1f4fd211056$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $610fd1f4fd211056$var$_baseNew = $610fd1f4fd211056$var$_interopRequireDefault((parcelRequire("4HGDC")));
function $610fd1f4fd211056$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "ChevronDown".
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for dropdown menus, selects, accordions, and expands.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $610fd1f4fd211056$var$ChevronDownIcon = (props)=>/*#__PURE__*/ $610fd1f4fd211056$var$_react.default.createElement($610fd1f4fd211056$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M10.5 4.5 8.25 6.75 6 9 3.75 6.75 1.5 4.5"/>`,
        type: 'utility'
    }, props));
$610fd1f4fd211056$var$ChevronDownIcon.displayName = 'ChevronDownIcon';
var $610fd1f4fd211056$var$_default = module.exports.default = $610fd1f4fd211056$var$ChevronDownIcon;

});
parcelRegister("4HGDC", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => (parcelRequire("bCh0R")).default);
$parcel$export(module.exports, "Icon", () => (parcelRequire("bCh0R")).Icon);

var $bCh0R = parcelRequire("bCh0R");

});
parcelRegister("bCh0R", function(module, exports) {
$parcel$export(module.exports, "Icon", () => $875070b3dad420e8$export$f04a61298a47a40f);
$parcel$export(module.exports, "default", () => $875070b3dad420e8$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5FkrB = parcelRequire("5FkrB");

var $74Zh5 = parcelRequire("74Zh5");

var $dU8Y3 = parcelRequire("dU8Y3");
/**
 * We are hiding this props from consumers as it's reserved
 * for use by Icon Tile.
 */ var $875070b3dad420e8$var$commonSVGStyles = (0, $74Zh5.css)({
    overflow: 'hidden',
    pointerEvents: 'none',
    /**
   * Stop-color doesn't properly apply in chrome when the inherited/current color changes.
   * We have to initially set stop-color to inherit (either via DOM attribute or an initial CSS
   * rule) and then override it with currentColor for the color changes to be picked up.
   */ // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    stop: {
        stopColor: 'currentColor'
    }
});
var $875070b3dad420e8$var$svgStyles = (0, $74Zh5.css)({
    color: 'currentColor',
    verticalAlign: 'bottom'
});
var $875070b3dad420e8$var$iconStyles = (0, $74Zh5.css)({
    display: 'inline-block',
    boxSizing: 'border-box',
    flexShrink: 0,
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: 1,
    paddingInlineEnd: 'var(--ds--button--new-icon-padding-end, 0)',
    paddingInlineStart: 'var(--ds--button--new-icon-padding-start, 0)'
});
var $875070b3dad420e8$var$utilityIconStyles = (0, $74Zh5.css)({
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: "var(--ds-space-150, 12px)"
});
var $875070b3dad420e8$var$scaleStyles = (0, $74Zh5.css)({
    width: 'inherit',
    height: 'inherit'
});
/**
 * For windows high contrast mode
 */ var $875070b3dad420e8$var$baseHcmStyles = (0, $74Zh5.css)({
    '@media screen and (forced-colors: active)': {
        color: 'CanvasText',
        filter: 'grayscale(1)'
    }
});
var $875070b3dad420e8$var$scaleSize = (0, $74Zh5.css)({
    width: 'inherit',
    height: 'inherit'
});
var $875070b3dad420e8$var$sizeMap = {
    core: {
        none: (0, $74Zh5.css)({
            width: "var(--ds-space-200, 16px)",
            height: "var(--ds-space-200, 16px)"
        }),
        spacious: (0, $74Zh5.css)({
            width: "var(--ds-space-300, 24px)",
            height: "var(--ds-space-300, 24px)"
        })
    },
    utility: {
        none: (0, $74Zh5.css)({
            width: "var(--ds-space-150, 12px)",
            height: "var(--ds-space-150, 12px)"
        }),
        compact: (0, $74Zh5.css)({
            width: "var(--ds-space-200, 16px)",
            height: "var(--ds-space-200, 16px)"
        }),
        spacious: (0, $74Zh5.css)({
            width: "var(--ds-space-300, 24px)",
            height: "var(--ds-space-300, 24px)"
        })
    }
};
var $875070b3dad420e8$var$baseSizeMap = {
    core: 16,
    utility: 12
};
var $875070b3dad420e8$var$paddingMap = {
    core: {
        none: 0,
        spacious: 4
    },
    utility: {
        none: 0,
        compact: 2,
        spacious: 6
    }
};
var $875070b3dad420e8$export$f04a61298a47a40f = /*#__PURE__*/ (0, $5FkrB.memo)(function Icon(props) {
    var _props$type, _props$spacing3, _props$spacing4;
    var _ref = props, _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, testId = _ref.testId, label = _ref.label, LEGACY_primaryColor = _ref.LEGACY_primaryColor, LEGACY_secondaryColor = _ref.LEGACY_secondaryColor, LEGACY_size = _ref.LEGACY_size, FallbackIcon = _ref.LEGACY_fallbackIcon, dangerouslySetGlyph = _ref.dangerouslySetGlyph, shouldScale = _ref.shouldScale, LEGACY_margin = _ref.LEGACY_margin;
    var dangerouslySetInnerHTML = dangerouslySetGlyph ? {
        __html: dangerouslySetGlyph
    } : undefined;
    // Fall back to old icon
    if (FallbackIcon && !(0, $dU8Y3.fg)('platform-visual-refresh-icons')) // parse out unnecessary props
    return (0, $74Zh5.jsx)(FallbackIcon, {
        primaryColor: LEGACY_primaryColor !== null && LEGACY_primaryColor !== void 0 ? LEGACY_primaryColor : color,
        secondaryColor: LEGACY_secondaryColor,
        size: LEGACY_size,
        label: label,
        testId: testId,
        UNSAFE_margin: LEGACY_margin
    });
    var baseSize = $875070b3dad420e8$var$baseSizeMap[(_props$type = props.type) !== null && _props$type !== void 0 ? _props$type : 'core'];
    var viewBoxPadding;
    if (props.type === 'utility') {
        var _props$spacing;
        viewBoxPadding = $875070b3dad420e8$var$paddingMap[props.type][(_props$spacing = props.spacing) !== null && _props$spacing !== void 0 ? _props$spacing : 'none'];
    } else {
        var _props$spacing2;
        viewBoxPadding = $875070b3dad420e8$var$paddingMap['core'][(_props$spacing2 = props.spacing) !== null && _props$spacing2 !== void 0 ? _props$spacing2 : 'none'];
    }
    var viewBoxSize = baseSize + 2 * viewBoxPadding;
    // Workaround for the transparency in our disabled icon token.
    // Because we have multiple strokes in icons, opacities overlap
    // This filter has an impact on render performance, but this is
    // acceptable as icons aren't commonly disabled en-masse
    var iconColor = color;
    if (dangerouslySetInnerHTML && color === "var(--ds-icon-disabled, #091E424F)") {
        dangerouslySetInnerHTML.__html = "\n<filter id=\"ds-newIconOpacityFilter\">\n  <feFlood flood-color=\"var(--ds-icon-disabled)\" />\n  <feComposite in2=\"SourceGraphic\" operator=\"in\" />\n</filter>\n<g filter=\"url(#ds-newIconOpacityFilter)\">\n  ".concat(dangerouslySetInnerHTML.__html, "\n</g>");
        iconColor = "var(--ds-icon, #44546F)";
    }
    return (0, $74Zh5.jsx)("span", {
        "data-testid": testId,
        role: label ? 'img' : undefined,
        "aria-label": label ? label : undefined,
        "aria-hidden": label ? undefined : true,
        style: {
            color: iconColor
        },
        css: [
            $875070b3dad420e8$var$iconStyles,
            $875070b3dad420e8$var$baseHcmStyles,
            shouldScale && $875070b3dad420e8$var$scaleStyles,
            props.type === 'utility' && $875070b3dad420e8$var$utilityIconStyles
        ]
    }, (0, $74Zh5.jsx)("svg", {
        fill: "none",
        viewBox: "".concat(0 - viewBoxPadding, " ").concat(0 - viewBoxPadding, " ").concat(viewBoxSize, " ").concat(viewBoxSize),
        role: "presentation",
        css: [
            $875070b3dad420e8$var$commonSVGStyles,
            $875070b3dad420e8$var$svgStyles,
            shouldScale ? $875070b3dad420e8$var$scaleSize : props.type === 'utility' ? $875070b3dad420e8$var$sizeMap[props.type][(_props$spacing3 = props.spacing) !== null && _props$spacing3 !== void 0 ? _props$spacing3 : 'none'] : $875070b3dad420e8$var$sizeMap['core'][(_props$spacing4 = props.spacing) !== null && _props$spacing4 !== void 0 ? _props$spacing4 : 'none']
        ],
        dangerouslySetInnerHTML: dangerouslySetInnerHTML
    }));
});
var $875070b3dad420e8$export$2e2bcd8739ae039 = $875070b3dad420e8$export$f04a61298a47a40f;

});



parcelRegister("kINa4", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f15e0d2b1a71c23a$var$_react = $f15e0d2b1a71c23a$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $47gXd = parcelRequire("47gXd");

var $f15e0d2b1a71c23a$var$_chevronDown = $f15e0d2b1a71c23a$var$_interopRequireDefault((parcelRequire("8kEM5")));
function $f15e0d2b1a71c23a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $f15e0d2b1a71c23a$var$ChevronDownIcon = (props)=>/*#__PURE__*/ $f15e0d2b1a71c23a$var$_react.default.createElement($47gXd.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M8.292 10.293a1.01 1.01 0 0 0 0 1.419l2.939 2.965c.218.215.5.322.779.322s.556-.107.769-.322l2.93-2.955a1.01 1.01 0 0 0 0-1.419.987.987 0 0 0-1.406 0l-2.298 2.317-2.307-2.327a.99.99 0 0 0-1.406 0"/></svg>`
    }, props, {
        newIcon: $f15e0d2b1a71c23a$var$_chevronDown.default,
        iconType: "utility"
    }));
$f15e0d2b1a71c23a$var$ChevronDownIcon.displayName = 'ChevronDownIcon';
var $f15e0d2b1a71c23a$var$_default = module.exports.default = $f15e0d2b1a71c23a$var$ChevronDownIcon;

});
parcelRegister("47gXd", function(module, exports) {
$parcel$export(module.exports, "IconFacade", () => $2ff4f79ec0708ec4$export$3cfb73f70dfca966);

var $kqp0i = parcelRequire("kqp0i");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");

var $dU8Y3 = parcelRequire("dU8Y3");

var $juN94 = parcelRequire("juN94");
var $2ff4f79ec0708ec4$var$_excluded = [
    "dangerouslySetGlyph"
];
var $2ff4f79ec0708ec4$var$sizeSpacingMap = {
    utility: {
        small: 'compact',
        medium: 'spacious'
    },
    core: {
        small: 'none',
        medium: 'spacious'
    }
};
var $2ff4f79ec0708ec4$export$3cfb73f70dfca966 = /*#__PURE__*/ (0, $5FkrB.memo)(function IconFacade(_ref) {
    var _props$size;
    var dangerouslySetGlyph = _ref.dangerouslySetGlyph, props = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $2ff4f79ec0708ec4$var$_excluded);
    var NewIcon = props.newIcon;
    // By default, the icon size will be medium for core icons and small for utility icons
    var size = (_props$size = props.size) !== null && _props$size !== void 0 ? _props$size : 'medium';
    var useNewIcon = !props.isFacadeDisabled && // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
    (0, $dU8Y3.fg)('platform-visual-refresh-icons-legacy-facade');
    if (useNewIcon && NewIcon && (size === 'small' || size === 'medium')) {
        if (props.iconType === 'utility') {
            var Icon = NewIcon;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(Icon, (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, props, {
                spacing: (0, $dU8Y3.fg)('platform-visual-refresh-icons-facade-button-fix') ? $2ff4f79ec0708ec4$var$sizeSpacingMap['utility'][size] : 'none',
                color: props.primaryColor || 'currentColor',
                type: props.iconType
            }));
        } else {
            var _Icon = NewIcon;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(_Icon, (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, props, {
                spacing: $2ff4f79ec0708ec4$var$sizeSpacingMap['core'][size],
                color: props.primaryColor || 'currentColor',
                type: props.iconType
            }));
        }
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $juN94.Icon), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        dangerouslySetGlyph: dangerouslySetGlyph
    }, props));
});

});
parcelRegister("juN94", function(module, exports) {
$parcel$export(module.exports, "Icon", () => $e316f0e4b02f2334$export$f04a61298a47a40f);

var $kqp0i = parcelRequire("kqp0i");

var $25nEq = parcelRequire("25nEq");

var $5FkrB = parcelRequire("5FkrB");

var $74Zh5 = parcelRequire("74Zh5");

var $1b631 = parcelRequire("1b631");

var $cw16F = parcelRequire("cw16F");
function $e316f0e4b02f2334$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $e316f0e4b02f2334$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $e316f0e4b02f2334$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $e316f0e4b02f2334$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
/**
 * We are hiding these props from consumers as they're used to
 * hack around icon sizing specifically for icon-file-type.
 */ var $e316f0e4b02f2334$var$iconStyles = (0, $74Zh5.css)({
    display: 'inline-block',
    flexShrink: 0,
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: 1,
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '> svg': $e316f0e4b02f2334$var$_objectSpread($e316f0e4b02f2334$var$_objectSpread({}, (0, $1b631.commonSVGStyles)), {}, {
        maxWidth: '100%',
        maxHeight: '100%',
        color: 'var(--icon-primary-color)',
        fill: 'var(--icon-secondary-color)',
        verticalAlign: 'bottom'
    })
});
/**
 * For windows high contrast mode
 */ var $e316f0e4b02f2334$var$baseHcmStyles = (0, $74Zh5.css)({
    '@media screen and (forced-colors: active)': {
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '> svg': {
            filter: 'grayscale(1)',
            '--icon-primary-color': 'CanvasText',
            // foreground
            '--icon-secondary-color': 'Canvas' // background
        }
    }
});
var $e316f0e4b02f2334$var$primaryEqualsSecondaryHcmStyles = (0, $74Zh5.css)({
    '@media screen and (forced-colors: active)': {
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '> svg': {
            // if the primaryColor is the same as the secondaryColor we
            // set the --icon-primary-color to Canvas
            // this is usually to convey state i.e. Checkbox checked -> not checked
            '--icon-primary-color': 'Canvas' // foreground
        }
    }
});
var $e316f0e4b02f2334$var$secondaryTransparentHcmStyles = (0, $74Zh5.css)({
    '@media screen and (forced-colors: active)': {
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '> svg': {
            '--icon-secondary-color': 'transparent' // background
        }
    }
});
var $e316f0e4b02f2334$export$f04a61298a47a40f = /*#__PURE__*/ (0, $5FkrB.memo)(function Icon(props) {
    var _ref = props, Glyph = _ref.glyph, dangerouslySetGlyph = _ref.dangerouslySetGlyph, _ref$primaryColor = _ref.primaryColor, primaryColor = _ref$primaryColor === void 0 ? 'currentColor' : _ref$primaryColor, secondaryColor = _ref.secondaryColor, size = _ref.size, testId = _ref.testId, label = _ref.label, width = _ref.width, height = _ref.height, UNSAFE_margin = _ref.UNSAFE_margin;
    var glyphProps = dangerouslySetGlyph ? {
        dangerouslySetInnerHTML: {
            __html: dangerouslySetGlyph
        }
    } : {
        children: Glyph ? (0, $74Zh5.jsx)(Glyph, {
            role: "presentation"
        }) : null
    };
    var dimensions = (0, $1b631.getIconSize)({
        width: width,
        height: height,
        size: size
    });
    return (0, $74Zh5.jsx)("span", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        "data-testid": testId,
        "data-vc": "icon-".concat(testId),
        role: label ? 'img' : undefined,
        "aria-label": label ? label : undefined,
        "aria-hidden": label ? undefined : true,
        style: {
            '--icon-primary-color': primaryColor,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            '--icon-secondary-color': secondaryColor || (0, $cw16F.getBackground)(),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            margin: UNSAFE_margin
        }
    }, glyphProps, {
        css: [
            $e316f0e4b02f2334$var$iconStyles,
            $e316f0e4b02f2334$var$baseHcmStyles,
            primaryColor === secondaryColor && $e316f0e4b02f2334$var$primaryEqualsSecondaryHcmStyles,
            secondaryColor === 'transparent' && $e316f0e4b02f2334$var$secondaryTransparentHcmStyles,
            // NB: This can be resolved if this component, composes base SVG / and/or skeleton
            // We could then simplify how common styles are dealt with simply by encapsulating them
            // at their appropriate level and/or having a singular approach to css variables in the package
            dimensions && // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $74Zh5.css)({
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                width: dimensions.width,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                height: dimensions.height,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                '> svg': dimensions
            })
        ]
    }));
});
var $e316f0e4b02f2334$export$2e2bcd8739ae039 = $e316f0e4b02f2334$export$f04a61298a47a40f;

});
parcelRegister("1b631", function(module, exports) {
$parcel$export(module.exports, "commonSVGStyles", () => $0dbb82789c1a2c80$export$16374db1c3e6dfba);
$parcel$export(module.exports, "sizeStyleMap", () => $0dbb82789c1a2c80$export$ef0ad74202575b64);
$parcel$export(module.exports, "getIconSize", () => $0dbb82789c1a2c80$export$3eb7d6130acfda37);

var $iAlRz = parcelRequire("iAlRz");

var $74Zh5 = parcelRequire("74Zh5");
var $0dbb82789c1a2c80$export$16374db1c3e6dfba = {
    overflow: 'hidden',
    pointerEvents: 'none',
    /**
   * Stop-color doesn't properly apply in chrome when the inherited/current color changes.
   * We have to initially set stop-color to inherit (either via DOM attribute or an initial CSS
   * rule) and then override it with currentColor for the color changes to be picked up.
   */ stop: {
        stopColor: 'currentColor'
    }
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
var $0dbb82789c1a2c80$var$smallStyles = (0, $74Zh5.css)((0, $iAlRz.dimensions).small);
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
var $0dbb82789c1a2c80$var$mediumStyles = (0, $74Zh5.css)((0, $iAlRz.dimensions).medium);
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
var $0dbb82789c1a2c80$var$largeStyles = (0, $74Zh5.css)((0, $iAlRz.dimensions).large);
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
var $0dbb82789c1a2c80$var$xlargeStyles = (0, $74Zh5.css)((0, $iAlRz.dimensions).xlarge);
var $0dbb82789c1a2c80$export$ef0ad74202575b64 = {
    small: $0dbb82789c1a2c80$var$smallStyles,
    medium: $0dbb82789c1a2c80$var$mediumStyles,
    large: $0dbb82789c1a2c80$var$largeStyles,
    xlarge: $0dbb82789c1a2c80$var$xlargeStyles
};
var $0dbb82789c1a2c80$export$3eb7d6130acfda37 = function getIconSize(_ref) {
    var width = _ref.width, height = _ref.height, size = _ref.size;
    if (width && height) return {
        width: width,
        height: height
    };
    if (size) return (0, $iAlRz.dimensions)[size];
    return undefined;
};

});
parcelRegister("iAlRz", function(module, exports) {
$parcel$export(module.exports, "dimensions", () => $d87c8c5068a95233$export$62ad7b0c781000e9);
var $d87c8c5068a95233$export$c647cb0ee6e282fe = {
    small: '16px',
    medium: '24px',
    large: '32px',
    xlarge: '48px'
};
var $d87c8c5068a95233$export$7bd66fc94c81bf84 = {
    small: 'small',
    medium: 'medium',
    large: 'large',
    xlarge: 'xlarge'
};
var $d87c8c5068a95233$export$62ad7b0c781000e9 = {
    small: {
        width: $d87c8c5068a95233$export$c647cb0ee6e282fe.small,
        height: $d87c8c5068a95233$export$c647cb0ee6e282fe.small
    },
    medium: {
        width: $d87c8c5068a95233$export$c647cb0ee6e282fe.medium,
        height: $d87c8c5068a95233$export$c647cb0ee6e282fe.medium
    },
    large: {
        width: $d87c8c5068a95233$export$c647cb0ee6e282fe.large,
        height: $d87c8c5068a95233$export$c647cb0ee6e282fe.large
    },
    xlarge: {
        width: $d87c8c5068a95233$export$c647cb0ee6e282fe.xlarge,
        height: $d87c8c5068a95233$export$c647cb0ee6e282fe.xlarge
    }
};

});


parcelRegister("cw16F", function(module, exports) {
$parcel$export(module.exports, "getBackground", () => $0259f4fbaa42ad65$export$18cb9425622d4e06);
var $0259f4fbaa42ad65$export$18cb9425622d4e06 = function getBackground() {
    return "var(--ds-surface, #FFFFFF)";
};

});




parcelRegister("agyC9", function(module, exports) {
$parcel$export(module.exports, "Reference", () => $77963faf785db48a$export$e0be378c32fb70a7);

var $5FkrB = parcelRequire("5FkrB");

var $6JvGg = parcelRequire("6JvGg");

var $hvYLl = parcelRequire("hvYLl");

var $728oi = parcelRequire("728oi");
function $77963faf785db48a$export$e0be378c32fb70a7(_ref) {
    var children = _ref.children, innerRef = _ref.innerRef;
    var setReferenceNode = $5FkrB.useContext((0, $hvYLl.ManagerReferenceNodeSetterContext));
    var refHandler = $5FkrB.useCallback(function(node) {
        (0, $728oi.setRef)(innerRef, node);
        (0, $728oi.safeInvoke)(setReferenceNode, node);
    }, [
        innerRef,
        setReferenceNode
    ]); // ran on unmount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    $5FkrB.useEffect(function() {
        return function() {
            return (0, $728oi.setRef)(innerRef, null);
        };
    }, []);
    $5FkrB.useEffect(function() {
        (0, (/*@__PURE__*/$parcel$interopDefault($6JvGg)))(Boolean(setReferenceNode), '`Reference` should not be used outside of a `Manager` component.');
    }, [
        setReferenceNode
    ]);
    return (0, $728oi.unwrapArray)(children)({
        ref: refHandler
    });
}

});
parcelRegister("6JvGg", function(module, exports) {
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */ var $4e6f8530dbdc4e71$var$__DEV__ = false;
var $4e6f8530dbdc4e71$var$warning = function() {};
if ($4e6f8530dbdc4e71$var$__DEV__) {
    var $4e6f8530dbdc4e71$var$printWarning = function printWarning(format, args) {
        var len = arguments.length;
        args = new Array(len > 1 ? len - 1 : 0);
        for(var key = 1; key < len; key++)args[key - 1] = arguments[key];
        var argIndex = 0;
        var message = 'Warning: ' + format.replace(/%s/g, function() {
            return args[argIndex++];
        });
        if (typeof console !== 'undefined') console.error(message);
        try {
            // --- Welcome to debugging React ---
            // This error was thrown as a convenience so that you can use this stack
            // to find the callsite that caused this warning to fire.
            throw new Error(message);
        } catch (x) {}
    };
    $4e6f8530dbdc4e71$var$warning = function(condition, format, args) {
        var len = arguments.length;
        args = new Array(len > 2 ? len - 2 : 0);
        for(var key = 2; key < len; key++)args[key - 2] = arguments[key];
        if (format === undefined) throw new Error("`warning(condition, format, ...args)` requires a warning message argument");
        if (!condition) $4e6f8530dbdc4e71$var$printWarning.apply(null, [
            format
        ].concat(args));
    };
}
module.exports = $4e6f8530dbdc4e71$var$warning;

});


parcelRegister("b6Hjk", function(module, exports) {

var $lQ8M2 = parcelRequire("lQ8M2");
var $8161d9da2c93c765$var$listeningFocusTrap = null;
function $8161d9da2c93c765$var$focusTrap(element, userOptions) {
    var tabbableNodes = [];
    var firstTabbableNode = null;
    var lastTabbableNode = null;
    var nodeFocusedBeforeActivation = null;
    var active = false;
    var paused = false;
    var tabEvent = null;
    var container = typeof element === 'string' ? document.querySelector(element) : element;
    var config = userOptions || {};
    config.returnFocusOnDeactivate = userOptions && userOptions.returnFocusOnDeactivate !== undefined ? userOptions.returnFocusOnDeactivate : true;
    config.escapeDeactivates = userOptions && userOptions.escapeDeactivates !== undefined ? userOptions.escapeDeactivates : true;
    var trap = {
        activate: activate,
        deactivate: deactivate,
        pause: pause,
        unpause: unpause
    };
    return trap;
    function activate(activateOptions) {
        if (active) return;
        var defaultedActivateOptions = {
            onActivate: activateOptions && activateOptions.onActivate !== undefined ? activateOptions.onActivate : config.onActivate
        };
        active = true;
        paused = false;
        nodeFocusedBeforeActivation = document.activeElement;
        if (defaultedActivateOptions.onActivate) defaultedActivateOptions.onActivate();
        addListeners();
        return trap;
    }
    function deactivate(deactivateOptions) {
        if (!active) return;
        var defaultedDeactivateOptions = {
            returnFocus: deactivateOptions && deactivateOptions.returnFocus !== undefined ? deactivateOptions.returnFocus : config.returnFocusOnDeactivate,
            onDeactivate: deactivateOptions && deactivateOptions.onDeactivate !== undefined ? deactivateOptions.onDeactivate : config.onDeactivate
        };
        removeListeners();
        if (defaultedDeactivateOptions.onDeactivate) defaultedDeactivateOptions.onDeactivate();
        if (defaultedDeactivateOptions.returnFocus) setTimeout(function() {
            $8161d9da2c93c765$var$tryFocus(nodeFocusedBeforeActivation);
        }, 0);
        active = false;
        paused = false;
        return this;
    }
    function pause() {
        if (paused || !active) return;
        paused = true;
        removeListeners();
    }
    function unpause() {
        if (!paused || !active) return;
        paused = false;
        addListeners();
    }
    function addListeners() {
        if (!active) return;
        // There can be only one listening focus trap at a time
        if ($8161d9da2c93c765$var$listeningFocusTrap) $8161d9da2c93c765$var$listeningFocusTrap.pause();
        $8161d9da2c93c765$var$listeningFocusTrap = trap;
        updateTabbableNodes();
        // Ensure that the focused element doesn't capture the event that caused the focus trap activation
        setTimeout(function() {
            $8161d9da2c93c765$var$tryFocus(firstFocusNode());
        }, 0);
        document.addEventListener('focus', checkFocus, true);
        document.addEventListener('click', checkClick, true);
        document.addEventListener('mousedown', checkPointerDown, true);
        document.addEventListener('touchstart', checkPointerDown, true);
        document.addEventListener('keydown', checkKey, true);
        return trap;
    }
    function removeListeners() {
        if (!active || $8161d9da2c93c765$var$listeningFocusTrap !== trap) return;
        document.removeEventListener('focus', checkFocus, true);
        document.removeEventListener('click', checkClick, true);
        document.removeEventListener('mousedown', checkPointerDown, true);
        document.removeEventListener('touchstart', checkPointerDown, true);
        document.removeEventListener('keydown', checkKey, true);
        $8161d9da2c93c765$var$listeningFocusTrap = null;
        return trap;
    }
    function getNodeForOption(optionName) {
        var optionValue = config[optionName];
        var node = optionValue;
        if (!optionValue) return null;
        if (typeof optionValue === 'string') {
            node = document.querySelector(optionValue);
            if (!node) throw new Error('`' + optionName + '` refers to no known node');
        }
        if (typeof optionValue === 'function') {
            node = optionValue();
            if (!node) throw new Error('`' + optionName + '` did not return a node');
        }
        return node;
    }
    function firstFocusNode() {
        var node;
        if (getNodeForOption('initialFocus') !== null) node = getNodeForOption('initialFocus');
        else if (container.contains(document.activeElement)) node = document.activeElement;
        else node = tabbableNodes[0] || getNodeForOption('fallbackFocus');
        if (!node) throw new Error('You can\'t have a focus-trap without at least one focusable element');
        return node;
    }
    // This needs to be done on mousedown and touchstart instead of click
    // so that it precedes the focus event
    function checkPointerDown(e) {
        if (config.clickOutsideDeactivates && !container.contains(e.target)) deactivate({
            returnFocus: false
        });
    }
    function checkClick(e) {
        if (config.clickOutsideDeactivates) return;
        if (container.contains(e.target)) return;
        e.preventDefault();
        e.stopImmediatePropagation();
    }
    function checkFocus(e) {
        if (container.contains(e.target)) return;
        e.preventDefault();
        e.stopImmediatePropagation();
        // Checking for a blur method here resolves a Firefox issue (#15)
        if (typeof e.target.blur === 'function') e.target.blur();
        if (tabEvent) readjustFocus(tabEvent);
    }
    function checkKey(e) {
        if (e.key === 'Tab' || e.keyCode === 9) handleTab(e);
        if (config.escapeDeactivates !== false && $8161d9da2c93c765$var$isEscapeEvent(e)) deactivate();
    }
    function handleTab(e) {
        updateTabbableNodes();
        if (e.target.hasAttribute('tabindex') && Number(e.target.getAttribute('tabindex')) < 0) return tabEvent = e;
        e.preventDefault();
        var currentFocusIndex = tabbableNodes.indexOf(e.target);
        if (e.shiftKey) {
            if (e.target === firstTabbableNode || tabbableNodes.indexOf(e.target) === -1) return $8161d9da2c93c765$var$tryFocus(lastTabbableNode);
            return $8161d9da2c93c765$var$tryFocus(tabbableNodes[currentFocusIndex - 1]);
        }
        if (e.target === lastTabbableNode) return $8161d9da2c93c765$var$tryFocus(firstTabbableNode);
        $8161d9da2c93c765$var$tryFocus(tabbableNodes[currentFocusIndex + 1]);
    }
    function updateTabbableNodes() {
        tabbableNodes = $lQ8M2(container);
        firstTabbableNode = tabbableNodes[0];
        lastTabbableNode = tabbableNodes[tabbableNodes.length - 1];
    }
    function readjustFocus(e) {
        if (e.shiftKey) return $8161d9da2c93c765$var$tryFocus(lastTabbableNode);
        $8161d9da2c93c765$var$tryFocus(firstTabbableNode);
    }
}
function $8161d9da2c93c765$var$isEscapeEvent(e) {
    return e.key === 'Escape' || e.key === 'Esc' || e.keyCode === 27;
}
function $8161d9da2c93c765$var$tryFocus(node) {
    if (!node || !node.focus) return;
    if (node === document.activeElement) return;
    node.focus();
    if (node.tagName.toLowerCase() === 'input') node.select();
}
module.exports = $8161d9da2c93c765$var$focusTrap;

});
parcelRegister("lQ8M2", function(module, exports) {
module.exports = function(el, options) {
    options = options || {};
    var elementDocument = el.ownerDocument || el;
    var basicTabbables = [];
    var orderedTabbables = [];
    // A node is "available" if
    // - it's computed style
    var isUnavailable = $fe654298f8d91f4b$var$createIsUnavailable(elementDocument);
    var candidateSelectors = [
        'input',
        'select',
        'a[href]',
        'textarea',
        'button',
        '[tabindex]'
    ];
    var candidates = el.querySelectorAll(candidateSelectors.join(','));
    if (options.includeContainer) {
        var matches = Element.prototype.matches || Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
        if (candidateSelectors.some(function(candidateSelector) {
            return matches.call(el, candidateSelector);
        })) {
            candidates = Array.prototype.slice.apply(candidates);
            candidates.unshift(el);
        }
    }
    var candidate, candidateIndexAttr, candidateIndex;
    for(var i = 0, l = candidates.length; i < l; i++){
        candidate = candidates[i];
        candidateIndexAttr = parseInt(candidate.getAttribute('tabindex'), 10);
        candidateIndex = isNaN(candidateIndexAttr) ? candidate.tabIndex : candidateIndexAttr;
        if (candidateIndex < 0 || candidate.tagName === 'INPUT' && candidate.type === 'hidden' || candidate.disabled || isUnavailable(candidate, elementDocument)) continue;
        if (candidateIndex === 0) basicTabbables.push(candidate);
        else orderedTabbables.push({
            index: i,
            tabIndex: candidateIndex,
            node: candidate
        });
    }
    var tabbableNodes = orderedTabbables.sort(function(a, b) {
        return a.tabIndex === b.tabIndex ? a.index - b.index : a.tabIndex - b.tabIndex;
    }).map(function(a) {
        return a.node;
    });
    Array.prototype.push.apply(tabbableNodes, basicTabbables);
    return tabbableNodes;
};
function $fe654298f8d91f4b$var$createIsUnavailable(elementDocument) {
    // Node cache must be refreshed on every check, in case
    // the content of the element has changed
    var isOffCache = [];
    // "off" means `display: none;`, as opposed to "hidden",
    // which means `visibility: hidden;`. getComputedStyle
    // accurately reflects visiblity in context but not
    // "off" state, so we need to recursively check parents.
    function isOff(node, nodeComputedStyle) {
        if (node === elementDocument.documentElement) return false;
        // Find the cached node (Array.prototype.find not available in IE9)
        for(var i = 0, length = isOffCache.length; i < length; i++){
            if (isOffCache[i][0] === node) return isOffCache[i][1];
        }
        nodeComputedStyle = nodeComputedStyle || elementDocument.defaultView.getComputedStyle(node);
        var result = false;
        if (nodeComputedStyle.display === 'none') result = true;
        else if (node.parentNode) result = isOff(node.parentNode);
        isOffCache.push([
            node,
            result
        ]);
        return result;
    }
    return function isUnavailable(node) {
        if (node === elementDocument.documentElement) return false;
        var computedStyle = elementDocument.defaultView.getComputedStyle(node);
        if (isOff(node, computedStyle)) return true;
        return computedStyle.visibility === 'hidden';
    };
}

});


parcelRegister("cvlyC", function(module, exports) {
$parcel$export(module.exports, "default", () => $91a91a1bf1b7e1c6$export$2e2bcd8739ae039);
var $91a91a1bf1b7e1c6$var$safeIsNaN = Number.isNaN || function ponyfill(value) {
    return typeof value === 'number' && value !== value;
};
function $91a91a1bf1b7e1c6$var$isEqual(first, second) {
    if (first === second) return true;
    if ($91a91a1bf1b7e1c6$var$safeIsNaN(first) && $91a91a1bf1b7e1c6$var$safeIsNaN(second)) return true;
    return false;
}
function $91a91a1bf1b7e1c6$var$areInputsEqual(newInputs, lastInputs) {
    if (newInputs.length !== lastInputs.length) return false;
    for(var i = 0; i < newInputs.length; i++){
        if (!$91a91a1bf1b7e1c6$var$isEqual(newInputs[i], lastInputs[i])) return false;
    }
    return true;
}
function $91a91a1bf1b7e1c6$export$2e2bcd8739ae039(resultFn, isEqual) {
    if (isEqual === void 0) isEqual = $91a91a1bf1b7e1c6$var$areInputsEqual;
    var cache = null;
    function memoized() {
        var newArgs = [];
        for(var _i = 0; _i < arguments.length; _i++)newArgs[_i] = arguments[_i];
        if (cache && cache.lastThis === this && isEqual(newArgs, cache.lastArgs)) return cache.lastResult;
        var lastResult = resultFn.apply(this, newArgs);
        cache = {
            lastResult: lastResult,
            lastArgs: newArgs,
            lastThis: this
        };
        return lastResult;
    }
    memoized.clear = function clear() {
        cache = null;
    };
    return memoized;
}

});

parcelRegister("6ILNo", function(module, exports) {
$parcel$export(module.exports, "getIn", () => $4e4bed591426b6a1$export$c52e5867d5879e24);
$parcel$export(module.exports, "createForm", () => $4e4bed591426b6a1$export$f681a8129d2e9d28);

var $d1G9Q = parcelRequire("d1G9Q");

var $kuWQN = parcelRequire("kuWQN");
//      
var $4e4bed591426b6a1$var$charCodeOfDot = ".".charCodeAt(0);
var $4e4bed591426b6a1$var$reEscapeChar = /\\(\\)?/g;
var $4e4bed591426b6a1$var$rePropName = RegExp(// Match anything that isn't a dot or bracket.
"[^.[\\]]+|\\[(?:([^\"'][^[]*)|([\"'])((?:(?!\\2)[^\\\\]|\\\\.)*?)\\2)\\]|(?=(?:\\.|\\[\\])(?:\\.|\\[\\]|$))", "g");
/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */ var $4e4bed591426b6a1$var$stringToPath = function stringToPath(string) {
    var result = [];
    if (string.charCodeAt(0) === $4e4bed591426b6a1$var$charCodeOfDot) result.push("");
    string.replace($4e4bed591426b6a1$var$rePropName, function(match, expression, quote, subString) {
        var key = match;
        if (quote) key = subString.replace($4e4bed591426b6a1$var$reEscapeChar, "$1");
        else if (expression) key = expression.trim();
        result.push(key);
    });
    return result;
};
var $4e4bed591426b6a1$var$keysCache = {};
var $4e4bed591426b6a1$var$keysRegex = /[.[\]]+/;
var $4e4bed591426b6a1$var$toPath = function toPath(key) {
    if (key === null || key === undefined || !key.length) return [];
    if (typeof key !== "string") throw new Error("toPath() expects a string");
    if ($4e4bed591426b6a1$var$keysCache[key] == null) {
        /**
     * The following patch fixes issue 456, introduced since v4.20.3:
     *
     * Before v4.20.3, i.e. in v4.20.2, a `key` like 'choices[]' would map to ['choices']
     * (e.g. an array of choices used where 'choices[]' is name attribute of an input of type checkbox).
     *
     * Since v4.20.3, a `key` like 'choices[]' would map to ['choices', ''] which is wrong and breaks
     * this kind of inputs e.g. in React.
     *
     * v4.20.3 introduced an unwanted breaking change, this patch fixes it, see the issue at the link below.
     *
     * @see https://github.com/final-form/final-form/issues/456
     */ if (key.endsWith("[]")) // v4.20.2 (a `key` like 'choices[]' should map to ['choices'], which is fine).
        $4e4bed591426b6a1$var$keysCache[key] = key.split($4e4bed591426b6a1$var$keysRegex).filter(Boolean);
        else // v4.20.3 (a `key` like 'choices[]' maps to ['choices', ''], which breaks applications relying on inputs like `<input type="checkbox" name="choices[]" />`).
        $4e4bed591426b6a1$var$keysCache[key] = $4e4bed591426b6a1$var$stringToPath(key);
    }
    return $4e4bed591426b6a1$var$keysCache[key];
};
//      
var $4e4bed591426b6a1$export$c52e5867d5879e24 = function getIn(state, complexKey) {
    // Intentionally using iteration rather than recursion
    var path = $4e4bed591426b6a1$var$toPath(complexKey);
    var current = state;
    for(var i = 0; i < path.length; i++){
        var key = path[i];
        if (current === undefined || current === null || typeof current !== "object" || Array.isArray(current) && isNaN(key)) return undefined;
        current = current[key];
    }
    return current;
};
function $4e4bed591426b6a1$var$_toPropertyKey(arg) {
    var key = $4e4bed591426b6a1$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function $4e4bed591426b6a1$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var $4e4bed591426b6a1$var$setInRecursor = function setInRecursor(current, index, path, value1, destroyArrays) {
    if (index >= path.length) // end of recursion
    return value1;
    var key = path[index];
    // determine type of key
    if (isNaN(key)) {
        var _extends2;
        // object set
        if (current === undefined || current === null) {
            var _ref;
            // recurse
            var _result = setInRecursor(undefined, index + 1, path, value1, destroyArrays);
            // delete or create an object
            return _result === undefined ? undefined : (_ref = {}, _ref[key] = _result, _ref);
        }
        if (Array.isArray(current)) throw new Error("Cannot set a non-numeric property on an array");
        // current exists, so make a copy of all its values, and add/update the new one
        var _result2 = setInRecursor(current[key], index + 1, path, value1, destroyArrays);
        if (_result2 === undefined) {
            var numKeys = Object.keys(current).length;
            if (current[key] === undefined && numKeys === 0) // object was already empty
            return undefined;
            if (current[key] !== undefined && numKeys <= 1) {
                // only key we had was the one we are deleting
                if (!isNaN(path[index - 1]) && !destroyArrays) // we are in an array, so return an empty object
                return {};
                else return undefined;
            }
            current[key];
            var _final = (0, $kuWQN.default)(current, [
                key
            ].map($4e4bed591426b6a1$var$_toPropertyKey));
            return _final;
        }
        // set result in key
        return (0, $d1G9Q.default)({}, current, (_extends2 = {}, _extends2[key] = _result2, _extends2));
    }
    // array set
    var numericKey = Number(key);
    if (current === undefined || current === null) {
        // recurse
        var _result3 = setInRecursor(undefined, index + 1, path, value1, destroyArrays);
        // if nothing returned, delete it
        if (_result3 === undefined) return undefined;
        // create an array
        var _array = [];
        _array[numericKey] = _result3;
        return _array;
    }
    if (!Array.isArray(current)) throw new Error("Cannot set a numeric property on an object");
    // recurse
    var existingValue = current[numericKey];
    var result = setInRecursor(existingValue, index + 1, path, value1, destroyArrays);
    // current exists, so make a copy of all its values, and add/update the new one
    var array = [].concat(current);
    if (destroyArrays && result === undefined) {
        array.splice(numericKey, 1);
        if (array.length === 0) return undefined;
    } else array[numericKey] = result;
    return array;
};
var $4e4bed591426b6a1$export$e6bdf135a54e021b = function setIn(state, key, value1, destroyArrays) {
    if (destroyArrays === void 0) destroyArrays = false;
    if (state === undefined || state === null) throw new Error("Cannot call setIn() with " + String(state) + " state");
    if (key === undefined || key === null) throw new Error("Cannot call setIn() with " + String(key) + " key");
    // Recursive function needs to accept and return State, but public API should
    // only deal with Objects
    return $4e4bed591426b6a1$var$setInRecursor(state, 0, $4e4bed591426b6a1$var$toPath(key), value1, destroyArrays);
};
var $4e4bed591426b6a1$export$97cd7fc25dd32915 = "FINAL_FORM/form-error";
var $4e4bed591426b6a1$export$735bebc8ffabf28a = "FINAL_FORM/array-error";
//      
/**
 * Converts internal field state to published field state
 */ function $4e4bed591426b6a1$var$publishFieldState(formState, field) {
    var errors = formState.errors, initialValues = formState.initialValues, lastSubmittedValues = formState.lastSubmittedValues, submitErrors = formState.submitErrors, submitFailed = formState.submitFailed, submitSucceeded = formState.submitSucceeded, submitting = formState.submitting, values = formState.values;
    var active = field.active, blur = field.blur, change = field.change, data = field.data, focus = field.focus, modified = field.modified, modifiedSinceLastSubmit = field.modifiedSinceLastSubmit, name = field.name, touched = field.touched, validating = field.validating, visited = field.visited;
    var value1 = $4e4bed591426b6a1$export$c52e5867d5879e24(values, name);
    var error = $4e4bed591426b6a1$export$c52e5867d5879e24(errors, name);
    if (error && error[$4e4bed591426b6a1$export$735bebc8ffabf28a]) error = error[$4e4bed591426b6a1$export$735bebc8ffabf28a];
    var submitError = submitErrors && $4e4bed591426b6a1$export$c52e5867d5879e24(submitErrors, name);
    var initial = initialValues && $4e4bed591426b6a1$export$c52e5867d5879e24(initialValues, name);
    var pristine = field.isEqual(initial, value1);
    var dirtySinceLastSubmit = !!(lastSubmittedValues && !field.isEqual($4e4bed591426b6a1$export$c52e5867d5879e24(lastSubmittedValues, name), value1));
    var valid = !error && !submitError;
    return {
        active: active,
        blur: blur,
        change: change,
        data: data,
        dirty: !pristine,
        dirtySinceLastSubmit: dirtySinceLastSubmit,
        error: error,
        focus: focus,
        initial: initial,
        invalid: !valid,
        length: Array.isArray(value1) ? value1.length : undefined,
        modified: modified,
        modifiedSinceLastSubmit: modifiedSinceLastSubmit,
        name: name,
        pristine: pristine,
        submitError: submitError,
        submitFailed: submitFailed,
        submitSucceeded: submitSucceeded,
        submitting: submitting,
        touched: touched,
        valid: valid,
        value: value1,
        visited: visited,
        validating: validating
    };
}
//      
var $4e4bed591426b6a1$export$41e855cb628c1b55 = [
    "active",
    "data",
    "dirty",
    "dirtySinceLastSubmit",
    "error",
    "initial",
    "invalid",
    "length",
    "modified",
    "modifiedSinceLastSubmit",
    "pristine",
    "submitError",
    "submitFailed",
    "submitSucceeded",
    "submitting",
    "touched",
    "valid",
    "value",
    "visited",
    "validating"
];
//      
var $4e4bed591426b6a1$var$shallowEqual = function shallowEqual(a, b) {
    if (a === b) return true;
    if (typeof a !== "object" || !a || typeof b !== "object" || !b) return false;
    var keysA = Object.keys(a);
    var keysB = Object.keys(b);
    if (keysA.length !== keysB.length) return false;
    var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(b);
    for(var idx = 0; idx < keysA.length; idx++){
        var key = keysA[idx];
        if (!bHasOwnProperty(key) || a[key] !== b[key]) return false;
    }
    return true;
};
//      
function $4e4bed591426b6a1$var$subscriptionFilter(dest, src, previous, subscription, keys, shallowEqualKeys) {
    var different = false;
    keys.forEach(function(key) {
        if (subscription[key]) {
            dest[key] = src[key];
            if (!previous || (~shallowEqualKeys.indexOf(key) ? !$4e4bed591426b6a1$var$shallowEqual(src[key], previous[key]) : src[key] !== previous[key])) different = true;
        }
    });
    return different;
}
//      
var $4e4bed591426b6a1$var$shallowEqualKeys$1 = [
    "data"
];
/**
 * Filters items in a FieldState based on a FieldSubscription
 */ var $4e4bed591426b6a1$var$filterFieldState = function filterFieldState(state, previousState, subscription, force) {
    var result = {
        blur: state.blur,
        change: state.change,
        focus: state.focus,
        name: state.name
    };
    var different = $4e4bed591426b6a1$var$subscriptionFilter(result, state, previousState, subscription, $4e4bed591426b6a1$export$41e855cb628c1b55, $4e4bed591426b6a1$var$shallowEqualKeys$1) || !previousState;
    return different || force ? result : undefined;
};
//      
var $4e4bed591426b6a1$export$f1ff97b9d1c7a3c3 = [
    "active",
    "dirty",
    "dirtyFields",
    "dirtyFieldsSinceLastSubmit",
    "dirtySinceLastSubmit",
    "error",
    "errors",
    "hasSubmitErrors",
    "hasValidationErrors",
    "initialValues",
    "invalid",
    "modified",
    "modifiedSinceLastSubmit",
    "pristine",
    "submitting",
    "submitError",
    "submitErrors",
    "submitFailed",
    "submitSucceeded",
    "touched",
    "valid",
    "validating",
    "values",
    "visited"
];
//      
var $4e4bed591426b6a1$var$shallowEqualKeys = [
    "touched",
    "visited"
];
/**
 * Filters items in a FormState based on a FormSubscription
 */ function $4e4bed591426b6a1$var$filterFormState(state, previousState, subscription, force) {
    var result = {};
    var different = $4e4bed591426b6a1$var$subscriptionFilter(result, state, previousState, subscription, $4e4bed591426b6a1$export$f1ff97b9d1c7a3c3, $4e4bed591426b6a1$var$shallowEqualKeys) || !previousState;
    return different || force ? result : undefined;
}
//      
var $4e4bed591426b6a1$var$memoize = function memoize(fn) {
    var lastArgs;
    var lastResult;
    return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        if (!lastArgs || args.length !== lastArgs.length || args.some(function(arg, index) {
            return !$4e4bed591426b6a1$var$shallowEqual(lastArgs[index], arg);
        })) {
            lastArgs = args;
            lastResult = fn.apply(void 0, args);
        }
        return lastResult;
    };
};
var $4e4bed591426b6a1$var$isPromise = function(obj) {
    return !!obj && (typeof obj === "object" || typeof obj === "function") && typeof obj.then === "function";
};
var $4e4bed591426b6a1$export$83d89fbfd8236492 = "4.20.10";
var $4e4bed591426b6a1$export$480bc304a47a3b09 = [
    "debug",
    "initialValues",
    "keepDirtyOnReinitialize",
    "mutators",
    "onSubmit",
    "validate",
    "validateOnBlur"
];
var $4e4bed591426b6a1$var$tripleEquals = function tripleEquals(a, b) {
    return a === b;
};
var $4e4bed591426b6a1$var$hasAnyError = function hasAnyError(errors) {
    return Object.keys(errors).some(function(key) {
        var value1 = errors[key];
        if (value1 && typeof value1 === "object" && !(value1 instanceof Error)) return hasAnyError(value1);
        return typeof value1 !== "undefined";
    });
};
function $4e4bed591426b6a1$var$convertToExternalFormState(_ref) {
    var active = _ref.active, dirtySinceLastSubmit = _ref.dirtySinceLastSubmit, modifiedSinceLastSubmit = _ref.modifiedSinceLastSubmit, error = _ref.error, errors = _ref.errors, initialValues = _ref.initialValues, pristine = _ref.pristine, submitting = _ref.submitting, submitFailed = _ref.submitFailed, submitSucceeded = _ref.submitSucceeded, submitError = _ref.submitError, submitErrors = _ref.submitErrors, valid = _ref.valid, validating = _ref.validating, values = _ref.values;
    return {
        active: active,
        dirty: !pristine,
        dirtySinceLastSubmit: dirtySinceLastSubmit,
        modifiedSinceLastSubmit: modifiedSinceLastSubmit,
        error: error,
        errors: errors,
        hasSubmitErrors: !!(submitError || submitErrors && $4e4bed591426b6a1$var$hasAnyError(submitErrors)),
        hasValidationErrors: !!(error || $4e4bed591426b6a1$var$hasAnyError(errors)),
        invalid: !valid,
        initialValues: initialValues,
        pristine: pristine,
        submitting: submitting,
        submitFailed: submitFailed,
        submitSucceeded: submitSucceeded,
        submitError: submitError,
        submitErrors: submitErrors,
        valid: valid,
        validating: validating > 0,
        values: values
    };
}
function $4e4bed591426b6a1$var$notifySubscriber(subscriber, subscription, state, lastState, filter, force) {
    var notification = filter(state, lastState, subscription, force);
    if (notification) {
        subscriber(notification);
        return true;
    }
    return false;
}
function $4e4bed591426b6a1$var$notify(_ref2, state, lastState, filter, force) {
    var entries = _ref2.entries;
    Object.keys(entries).forEach(function(key) {
        var entry = entries[Number(key)];
        // istanbul ignore next
        if (entry) {
            var subscription = entry.subscription, subscriber = entry.subscriber, notified = entry.notified;
            if ($4e4bed591426b6a1$var$notifySubscriber(subscriber, subscription, state, lastState, filter, force || !notified)) entry.notified = true;
        }
    });
}
function $4e4bed591426b6a1$export$f681a8129d2e9d28(config) {
    if (!config) throw new Error("No config specified");
    var debug = config.debug, destroyOnUnregister = config.destroyOnUnregister, keepDirtyOnReinitialize = config.keepDirtyOnReinitialize, initialValues = config.initialValues, mutators = config.mutators, onSubmit = config.onSubmit, validate = config.validate, validateOnBlur = config.validateOnBlur;
    if (!onSubmit) throw new Error("No onSubmit function specified");
    var state = {
        subscribers: {
            index: 0,
            entries: {}
        },
        fieldSubscribers: {},
        fields: {},
        formState: {
            asyncErrors: {},
            dirtySinceLastSubmit: false,
            modifiedSinceLastSubmit: false,
            errors: {},
            initialValues: initialValues && (0, $d1G9Q.default)({}, initialValues),
            invalid: false,
            pristine: true,
            submitting: false,
            submitFailed: false,
            submitSucceeded: false,
            resetWhileSubmitting: false,
            valid: true,
            validating: 0,
            values: initialValues ? (0, $d1G9Q.default)({}, initialValues) : {}
        },
        lastFormState: undefined
    };
    var inBatch = 0;
    var validationPaused = false;
    var validationBlocked = false;
    var preventNotificationWhileValidationPaused = false;
    var nextAsyncValidationKey = 0;
    var asyncValidationPromises = {};
    var clearAsyncValidationPromise = function clearAsyncValidationPromise(key) {
        return function(result) {
            delete asyncValidationPromises[key];
            return result;
        };
    };
    var changeValue = function changeValue(state, name, mutate) {
        var before = $4e4bed591426b6a1$export$c52e5867d5879e24(state.formState.values, name);
        var after = mutate(before);
        state.formState.values = $4e4bed591426b6a1$export$e6bdf135a54e021b(state.formState.values, name, after) || {};
    };
    var renameField = function renameField(state, from, to) {
        if (state.fields[from]) {
            var _extends2, _extends3;
            state.fields = (0, $d1G9Q.default)({}, state.fields, (_extends2 = {}, _extends2[to] = (0, $d1G9Q.default)({}, state.fields[from], {
                name: to,
                // rebind event handlers
                blur: function blur() {
                    return api.blur(to);
                },
                change: function change(value1) {
                    return api.change(to, value1);
                },
                focus: function focus() {
                    return api.focus(to);
                },
                lastFieldState: undefined
            }), _extends2));
            delete state.fields[from];
            state.fieldSubscribers = (0, $d1G9Q.default)({}, state.fieldSubscribers, (_extends3 = {}, _extends3[to] = state.fieldSubscribers[from], _extends3));
            delete state.fieldSubscribers[from];
            var value1 = $4e4bed591426b6a1$export$c52e5867d5879e24(state.formState.values, from);
            state.formState.values = $4e4bed591426b6a1$export$e6bdf135a54e021b(state.formState.values, from, undefined) || {};
            state.formState.values = $4e4bed591426b6a1$export$e6bdf135a54e021b(state.formState.values, to, value1);
            delete state.lastFormState;
        }
    };
    // bind state to mutators
    var getMutatorApi = function getMutatorApi(key) {
        return function() {
            // istanbul ignore next
            if (mutators) {
                // ^^ causes branch coverage warning, but needed to appease the Flow gods
                var mutatableState = {
                    formState: state.formState,
                    fields: state.fields,
                    fieldSubscribers: state.fieldSubscribers,
                    lastFormState: state.lastFormState
                };
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                var returnValue = mutators[key](args, mutatableState, {
                    changeValue: changeValue,
                    getIn: $4e4bed591426b6a1$export$c52e5867d5879e24,
                    renameField: renameField,
                    resetFieldState: api.resetFieldState,
                    setIn: $4e4bed591426b6a1$export$e6bdf135a54e021b,
                    shallowEqual: $4e4bed591426b6a1$var$shallowEqual
                });
                state.formState = mutatableState.formState;
                state.fields = mutatableState.fields;
                state.fieldSubscribers = mutatableState.fieldSubscribers;
                state.lastFormState = mutatableState.lastFormState;
                runValidation(undefined, function() {
                    notifyFieldListeners();
                    notifyFormListeners();
                });
                return returnValue;
            }
        };
    };
    var mutatorsApi = mutators ? Object.keys(mutators).reduce(function(result, key) {
        result[key] = getMutatorApi(key);
        return result;
    }, {}) : {};
    var runRecordLevelValidation = function runRecordLevelValidation(setErrors) {
        var promises = [];
        if (validate) {
            var errorsOrPromise = validate((0, $d1G9Q.default)({}, state.formState.values)); // clone to avoid writing
            if ($4e4bed591426b6a1$var$isPromise(errorsOrPromise)) promises.push(errorsOrPromise.then(function(errors) {
                return setErrors(errors, true);
            }));
            else setErrors(errorsOrPromise, false);
        }
        return promises;
    };
    var getValidators = function getValidators(field) {
        return Object.keys(field.validators).reduce(function(result, index) {
            var validator = field.validators[Number(index)]();
            if (validator) result.push(validator);
            return result;
        }, []);
    };
    var runFieldLevelValidation = function runFieldLevelValidation(field, setError) {
        var promises = [];
        var validators = getValidators(field);
        if (validators.length) {
            var error;
            validators.forEach(function(validator) {
                var errorOrPromise = validator($4e4bed591426b6a1$export$c52e5867d5879e24(state.formState.values, field.name), state.formState.values, validator.length === 0 || validator.length === 3 ? $4e4bed591426b6a1$var$publishFieldState(state.formState, state.fields[field.name]) : undefined);
                if (errorOrPromise && $4e4bed591426b6a1$var$isPromise(errorOrPromise)) {
                    field.validating = true;
                    var promise = errorOrPromise.then(function(error) {
                        if (state.fields[field.name]) {
                            state.fields[field.name].validating = false;
                            setError(error);
                        }
                    }); // errors must be resolved, not rejected
                    promises.push(promise);
                } else if (!error) // first registered validator wins
                error = errorOrPromise;
            });
            setError(error);
        }
        return promises;
    };
    var runValidation = function runValidation(fieldChanged, callback) {
        if (validationPaused) {
            validationBlocked = true;
            callback();
            return;
        }
        var fields = state.fields, formState = state.formState;
        var safeFields = (0, $d1G9Q.default)({}, fields);
        var fieldKeys = Object.keys(safeFields);
        if (!validate && !fieldKeys.some(function(key) {
            return getValidators(safeFields[key]).length;
        })) {
            callback();
            return; // no validation rules
        }
        // pare down field keys to actually validate
        var limitedFieldLevelValidation = false;
        if (fieldChanged) {
            var changedField = safeFields[fieldChanged];
            if (changedField) {
                var validateFields = changedField.validateFields;
                if (validateFields) {
                    limitedFieldLevelValidation = true;
                    fieldKeys = validateFields.length ? validateFields.concat(fieldChanged) : [
                        fieldChanged
                    ];
                }
            }
        }
        var recordLevelErrors = {};
        var asyncRecordLevelErrors = {};
        var fieldLevelErrors = {};
        var promises = [].concat(runRecordLevelValidation(function(errors, wasAsync) {
            if (wasAsync) asyncRecordLevelErrors = errors || {};
            else recordLevelErrors = errors || {};
        }), fieldKeys.reduce(function(result, name) {
            return result.concat(runFieldLevelValidation(fields[name], function(error) {
                fieldLevelErrors[name] = error;
            }));
        }, []));
        var hasAsyncValidations = promises.length > 0;
        var asyncValidationPromiseKey = ++nextAsyncValidationKey;
        var promise = Promise.all(promises).then(clearAsyncValidationPromise(asyncValidationPromiseKey));
        // backwards-compat: add promise to submit-blocking promises iff there are any promises to await
        if (hasAsyncValidations) asyncValidationPromises[asyncValidationPromiseKey] = promise;
        var processErrors = function processErrors(afterAsync) {
            var merged = (0, $d1G9Q.default)({}, limitedFieldLevelValidation ? formState.errors : {}, recordLevelErrors, afterAsync ? asyncRecordLevelErrors // new async errors
             : formState.asyncErrors);
            var forEachError = function forEachError(fn) {
                fieldKeys.forEach(function(name) {
                    if (fields[name]) {
                        // make sure field is still registered
                        // field-level errors take precedent over record-level errors
                        var recordLevelError = $4e4bed591426b6a1$export$c52e5867d5879e24(recordLevelErrors, name);
                        var errorFromParent = $4e4bed591426b6a1$export$c52e5867d5879e24(merged, name);
                        var hasFieldLevelValidation = getValidators(safeFields[name]).length;
                        var fieldLevelError = fieldLevelErrors[name];
                        fn(name, hasFieldLevelValidation && fieldLevelError || validate && recordLevelError || (!recordLevelError && !limitedFieldLevelValidation ? errorFromParent : undefined));
                    }
                });
            };
            forEachError(function(name, error) {
                merged = $4e4bed591426b6a1$export$e6bdf135a54e021b(merged, name, error) || {};
            });
            forEachError(function(name, error) {
                if (error && error[$4e4bed591426b6a1$export$735bebc8ffabf28a]) {
                    var existing = $4e4bed591426b6a1$export$c52e5867d5879e24(merged, name);
                    var copy = [].concat(existing);
                    copy[$4e4bed591426b6a1$export$735bebc8ffabf28a] = error[$4e4bed591426b6a1$export$735bebc8ffabf28a];
                    merged = $4e4bed591426b6a1$export$e6bdf135a54e021b(merged, name, copy);
                }
            });
            if (!$4e4bed591426b6a1$var$shallowEqual(formState.errors, merged)) formState.errors = merged;
            if (afterAsync) formState.asyncErrors = asyncRecordLevelErrors;
            formState.error = recordLevelErrors[$4e4bed591426b6a1$export$97cd7fc25dd32915];
        };
        if (hasAsyncValidations) {
            // async validations are running, ensure validating is true before notifying
            state.formState.validating++;
            callback();
        }
        // process sync errors
        processErrors(false);
        // sync errors have been set. notify listeners while we wait for others
        callback();
        if (hasAsyncValidations) {
            var afterPromise = function afterPromise() {
                state.formState.validating--;
                callback();
                // field async validation may affect formState validating
                // so force notifyFormListeners if validating is still 0 after callback finished
                // and lastFormState validating is true
                if (state.formState.validating === 0 && state.lastFormState.validating) notifyFormListeners();
            };
            promise.then(function() {
                if (nextAsyncValidationKey > asyncValidationPromiseKey) // if this async validator has been superseded by another, ignore its results
                return;
                processErrors(true);
            }).then(afterPromise, afterPromise);
        }
    };
    var notifyFieldListeners = function notifyFieldListeners(name) {
        if (inBatch) return;
        var fields = state.fields, fieldSubscribers = state.fieldSubscribers, formState = state.formState;
        var safeFields = (0, $d1G9Q.default)({}, fields);
        var notifyField = function notifyField(name) {
            var field = safeFields[name];
            var fieldState = $4e4bed591426b6a1$var$publishFieldState(formState, field);
            var lastFieldState = field.lastFieldState;
            field.lastFieldState = fieldState;
            var fieldSubscriber = fieldSubscribers[name];
            if (fieldSubscriber) $4e4bed591426b6a1$var$notify(fieldSubscriber, fieldState, lastFieldState, $4e4bed591426b6a1$var$filterFieldState, lastFieldState === undefined);
        };
        if (name) notifyField(name);
        else Object.keys(safeFields).forEach(notifyField);
    };
    var markAllFieldsTouched = function markAllFieldsTouched() {
        Object.keys(state.fields).forEach(function(key) {
            state.fields[key].touched = true;
        });
    };
    var hasSyncErrors = function hasSyncErrors() {
        return !!(state.formState.error || $4e4bed591426b6a1$var$hasAnyError(state.formState.errors));
    };
    var calculateNextFormState = function calculateNextFormState() {
        var fields = state.fields, formState = state.formState, lastFormState = state.lastFormState;
        var safeFields = (0, $d1G9Q.default)({}, fields);
        var safeFieldKeys = Object.keys(safeFields);
        // calculate dirty/pristine
        var foundDirty = false;
        var dirtyFields = safeFieldKeys.reduce(function(result, key) {
            var dirty = !safeFields[key].isEqual($4e4bed591426b6a1$export$c52e5867d5879e24(formState.values, key), $4e4bed591426b6a1$export$c52e5867d5879e24(formState.initialValues || {}, key));
            if (dirty) {
                foundDirty = true;
                result[key] = true;
            }
            return result;
        }, {});
        var dirtyFieldsSinceLastSubmit = safeFieldKeys.reduce(function(result, key) {
            // istanbul ignore next
            var nonNullLastSubmittedValues = formState.lastSubmittedValues || {}; // || {} is for flow, but causes branch coverage complaint
            if (!safeFields[key].isEqual($4e4bed591426b6a1$export$c52e5867d5879e24(formState.values, key), $4e4bed591426b6a1$export$c52e5867d5879e24(nonNullLastSubmittedValues, key))) result[key] = true;
            return result;
        }, {});
        formState.pristine = !foundDirty;
        formState.dirtySinceLastSubmit = !!(formState.lastSubmittedValues && Object.values(dirtyFieldsSinceLastSubmit).some(function(value1) {
            return value1;
        }));
        formState.modifiedSinceLastSubmit = !!(formState.lastSubmittedValues && // Object.values would treat values as mixed (facebook/flow#2221)
        Object.keys(safeFields).some(function(value1) {
            return safeFields[value1].modifiedSinceLastSubmit;
        }));
        formState.valid = !formState.error && !formState.submitError && !$4e4bed591426b6a1$var$hasAnyError(formState.errors) && !(formState.submitErrors && $4e4bed591426b6a1$var$hasAnyError(formState.submitErrors));
        var nextFormState = $4e4bed591426b6a1$var$convertToExternalFormState(formState);
        var _safeFieldKeys$reduce = safeFieldKeys.reduce(function(result, key) {
            result.modified[key] = safeFields[key].modified;
            result.touched[key] = safeFields[key].touched;
            result.visited[key] = safeFields[key].visited;
            return result;
        }, {
            modified: {},
            touched: {},
            visited: {}
        }), modified = _safeFieldKeys$reduce.modified, touched = _safeFieldKeys$reduce.touched, visited = _safeFieldKeys$reduce.visited;
        nextFormState.dirtyFields = lastFormState && $4e4bed591426b6a1$var$shallowEqual(lastFormState.dirtyFields, dirtyFields) ? lastFormState.dirtyFields : dirtyFields;
        nextFormState.dirtyFieldsSinceLastSubmit = lastFormState && $4e4bed591426b6a1$var$shallowEqual(lastFormState.dirtyFieldsSinceLastSubmit, dirtyFieldsSinceLastSubmit) ? lastFormState.dirtyFieldsSinceLastSubmit : dirtyFieldsSinceLastSubmit;
        nextFormState.modified = lastFormState && $4e4bed591426b6a1$var$shallowEqual(lastFormState.modified, modified) ? lastFormState.modified : modified;
        nextFormState.touched = lastFormState && $4e4bed591426b6a1$var$shallowEqual(lastFormState.touched, touched) ? lastFormState.touched : touched;
        nextFormState.visited = lastFormState && $4e4bed591426b6a1$var$shallowEqual(lastFormState.visited, visited) ? lastFormState.visited : visited;
        return lastFormState && $4e4bed591426b6a1$var$shallowEqual(lastFormState, nextFormState) ? lastFormState : nextFormState;
    };
    var callDebug = function callDebug() {
        return debug && true && debug(calculateNextFormState(), Object.keys(state.fields).reduce(function(result, key) {
            result[key] = state.fields[key];
            return result;
        }, {}));
    };
    var notifying = false;
    var scheduleNotification = false;
    var notifyFormListeners = function notifyFormListeners() {
        if (notifying) scheduleNotification = true;
        else {
            notifying = true;
            callDebug();
            if (!inBatch && !(validationPaused && preventNotificationWhileValidationPaused)) {
                var lastFormState = state.lastFormState;
                var nextFormState = calculateNextFormState();
                if (nextFormState !== lastFormState) {
                    state.lastFormState = nextFormState;
                    $4e4bed591426b6a1$var$notify(state.subscribers, nextFormState, lastFormState, $4e4bed591426b6a1$var$filterFormState);
                }
            }
            notifying = false;
            if (scheduleNotification) {
                scheduleNotification = false;
                notifyFormListeners();
            }
        }
    };
    var beforeSubmit = function beforeSubmit() {
        return Object.keys(state.fields).some(function(name) {
            return state.fields[name].beforeSubmit && state.fields[name].beforeSubmit() === false;
        });
    };
    var afterSubmit = function afterSubmit() {
        return Object.keys(state.fields).forEach(function(name) {
            return state.fields[name].afterSubmit && state.fields[name].afterSubmit();
        });
    };
    var resetModifiedAfterSubmit = function resetModifiedAfterSubmit() {
        return Object.keys(state.fields).forEach(function(key) {
            return state.fields[key].modifiedSinceLastSubmit = false;
        });
    };
    // generate initial errors
    runValidation(undefined, function() {
        notifyFormListeners();
    });
    var api = {
        batch: function batch(fn) {
            inBatch++;
            fn();
            inBatch--;
            notifyFieldListeners();
            notifyFormListeners();
        },
        blur: function blur(name) {
            var fields = state.fields, formState = state.formState;
            var previous = fields[name];
            if (previous) {
                // can only blur registered fields
                delete formState.active;
                fields[name] = (0, $d1G9Q.default)({}, previous, {
                    active: false,
                    touched: true
                });
                if (validateOnBlur) runValidation(name, function() {
                    notifyFieldListeners();
                    notifyFormListeners();
                });
                else {
                    notifyFieldListeners();
                    notifyFormListeners();
                }
            }
        },
        change: function change(name, value1) {
            var fields = state.fields, formState = state.formState;
            if ($4e4bed591426b6a1$export$c52e5867d5879e24(formState.values, name) !== value1) {
                changeValue(state, name, function() {
                    return value1;
                });
                var previous = fields[name];
                if (previous) // only track modified for registered fields
                fields[name] = (0, $d1G9Q.default)({}, previous, {
                    modified: true,
                    modifiedSinceLastSubmit: !!formState.lastSubmittedValues
                });
                if (validateOnBlur) {
                    notifyFieldListeners();
                    notifyFormListeners();
                } else runValidation(name, function() {
                    notifyFieldListeners();
                    notifyFormListeners();
                });
            }
        },
        get destroyOnUnregister () {
            return !!destroyOnUnregister;
        },
        set destroyOnUnregister (value){
            destroyOnUnregister = value;
        },
        focus: function focus(name) {
            var field = state.fields[name];
            if (field && !field.active) {
                state.formState.active = name;
                field.active = true;
                field.visited = true;
                notifyFieldListeners();
                notifyFormListeners();
            }
        },
        mutators: mutatorsApi,
        getFieldState: function getFieldState(name) {
            var field = state.fields[name];
            return field && field.lastFieldState;
        },
        getRegisteredFields: function getRegisteredFields() {
            return Object.keys(state.fields);
        },
        getState: function getState() {
            return calculateNextFormState();
        },
        initialize: function initialize(data) {
            var fields = state.fields, formState = state.formState;
            var safeFields = (0, $d1G9Q.default)({}, fields);
            var values = typeof data === "function" ? data(formState.values) : data;
            if (!keepDirtyOnReinitialize) formState.values = values;
            /**
       * Hello, inquisitive code reader! Thanks for taking the time to dig in!
       *
       * The following code is the way it is to allow for non-registered deep
       * field values to be set via initialize()
       */ // save dirty values
            var savedDirtyValues = keepDirtyOnReinitialize ? Object.keys(safeFields).reduce(function(result, key) {
                var field = safeFields[key];
                var pristine = field.isEqual($4e4bed591426b6a1$export$c52e5867d5879e24(formState.values, key), $4e4bed591426b6a1$export$c52e5867d5879e24(formState.initialValues || {}, key));
                if (!pristine) result[key] = $4e4bed591426b6a1$export$c52e5867d5879e24(formState.values, key);
                return result;
            }, {}) : {};
            // update initalValues and values
            formState.initialValues = values;
            formState.values = values;
            // restore the dirty values
            Object.keys(savedDirtyValues).forEach(function(key) {
                formState.values = $4e4bed591426b6a1$export$e6bdf135a54e021b(formState.values, key, savedDirtyValues[key]) || {};
            });
            runValidation(undefined, function() {
                notifyFieldListeners();
                notifyFormListeners();
            });
        },
        isValidationPaused: function isValidationPaused() {
            return validationPaused;
        },
        pauseValidation: function pauseValidation(preventNotification) {
            if (preventNotification === void 0) preventNotification = true;
            validationPaused = true;
            preventNotificationWhileValidationPaused = preventNotification;
        },
        registerField: function registerField(name, subscriber, subscription, fieldConfig) {
            if (subscription === void 0) subscription = {};
            if (!state.fieldSubscribers[name]) state.fieldSubscribers[name] = {
                index: 0,
                entries: {}
            };
            var index = state.fieldSubscribers[name].index++;
            // save field subscriber callback
            state.fieldSubscribers[name].entries[index] = {
                subscriber: $4e4bed591426b6a1$var$memoize(subscriber),
                subscription: subscription,
                notified: false
            };
            // create initial field state if not exists
            var field = state.fields[name] || {
                active: false,
                afterSubmit: fieldConfig && fieldConfig.afterSubmit,
                beforeSubmit: fieldConfig && fieldConfig.beforeSubmit,
                data: fieldConfig && fieldConfig.data || {},
                isEqual: fieldConfig && fieldConfig.isEqual || $4e4bed591426b6a1$var$tripleEquals,
                lastFieldState: undefined,
                modified: false,
                modifiedSinceLastSubmit: false,
                name: name,
                touched: false,
                valid: true,
                validateFields: fieldConfig && fieldConfig.validateFields,
                validators: {},
                validating: false,
                visited: false
            };
            // Mutators can create a field in order to keep the field states
            // We must update this field when registerField is called afterwards
            field.blur = field.blur || function() {
                return api.blur(name);
            };
            field.change = field.change || function(value1) {
                return api.change(name, value1);
            };
            field.focus = field.focus || function() {
                return api.focus(name);
            };
            state.fields[name] = field;
            var haveValidator = false;
            var silent = fieldConfig && fieldConfig.silent;
            var notify = function notify() {
                if (silent && state.fields[name]) notifyFieldListeners(name);
                else {
                    notifyFormListeners();
                    notifyFieldListeners();
                }
            };
            if (fieldConfig) {
                haveValidator = !!(fieldConfig.getValidator && fieldConfig.getValidator());
                if (fieldConfig.getValidator) state.fields[name].validators[index] = fieldConfig.getValidator;
                var noValueInFormState = $4e4bed591426b6a1$export$c52e5867d5879e24(state.formState.values, name) === undefined;
                if (fieldConfig.initialValue !== undefined && (noValueInFormState || $4e4bed591426b6a1$export$c52e5867d5879e24(state.formState.values, name) === $4e4bed591426b6a1$export$c52e5867d5879e24(state.formState.initialValues, name))) {
                    state.formState.initialValues = $4e4bed591426b6a1$export$e6bdf135a54e021b(state.formState.initialValues || {}, name, fieldConfig.initialValue);
                    state.formState.values = $4e4bed591426b6a1$export$e6bdf135a54e021b(state.formState.values, name, fieldConfig.initialValue);
                    runValidation(undefined, notify);
                }
                // only use defaultValue if we don't yet have any value for this field
                if (fieldConfig.defaultValue !== undefined && fieldConfig.initialValue === undefined && $4e4bed591426b6a1$export$c52e5867d5879e24(state.formState.initialValues, name) === undefined && noValueInFormState) state.formState.values = $4e4bed591426b6a1$export$e6bdf135a54e021b(state.formState.values, name, fieldConfig.defaultValue);
            }
            if (haveValidator) runValidation(undefined, notify);
            else notify();
            return function() {
                var validatorRemoved = false;
                // istanbul ignore next
                if (state.fields[name]) {
                    // state.fields[name] may have been removed by a mutator
                    validatorRemoved = !!(state.fields[name].validators[index] && state.fields[name].validators[index]());
                    delete state.fields[name].validators[index];
                }
                var hasFieldSubscribers = !!state.fieldSubscribers[name];
                if (hasFieldSubscribers) // state.fieldSubscribers[name] may have been removed by a mutator
                delete state.fieldSubscribers[name].entries[index];
                var lastOne = hasFieldSubscribers && !Object.keys(state.fieldSubscribers[name].entries).length;
                if (lastOne) {
                    delete state.fieldSubscribers[name];
                    delete state.fields[name];
                    if (validatorRemoved) state.formState.errors = $4e4bed591426b6a1$export$e6bdf135a54e021b(state.formState.errors, name, undefined) || {};
                    if (destroyOnUnregister) state.formState.values = $4e4bed591426b6a1$export$e6bdf135a54e021b(state.formState.values, name, undefined, true) || {};
                }
                if (!silent) {
                    if (validatorRemoved) runValidation(undefined, function() {
                        notifyFormListeners();
                        notifyFieldListeners();
                    });
                    else if (lastOne) // values or errors may have changed
                    notifyFormListeners();
                }
            };
        },
        reset: function reset(initialValues) {
            if (initialValues === void 0) initialValues = state.formState.initialValues;
            if (state.formState.submitting) state.formState.resetWhileSubmitting = true;
            state.formState.submitFailed = false;
            state.formState.submitSucceeded = false;
            delete state.formState.submitError;
            delete state.formState.submitErrors;
            delete state.formState.lastSubmittedValues;
            api.initialize(initialValues || {});
        },
        /**
     * Resets all field flags (e.g. touched, visited, etc.) to their initial state
     */ resetFieldState: function resetFieldState(name) {
            state.fields[name] = (0, $d1G9Q.default)({}, state.fields[name], {
                active: false,
                lastFieldState: undefined,
                modified: false,
                touched: false,
                valid: true,
                validating: false,
                visited: false
            });
            runValidation(undefined, function() {
                notifyFieldListeners();
                notifyFormListeners();
            });
        },
        /**
     * Returns the form to a clean slate; that is:
     * - Clear all values
     * - Resets all fields to their initial state
     */ restart: function restart(initialValues) {
            if (initialValues === void 0) initialValues = state.formState.initialValues;
            api.batch(function() {
                for(var name in state.fields){
                    api.resetFieldState(name);
                    state.fields[name] = (0, $d1G9Q.default)({}, state.fields[name], {
                        active: false,
                        lastFieldState: undefined,
                        modified: false,
                        modifiedSinceLastSubmit: false,
                        touched: false,
                        valid: true,
                        validating: false,
                        visited: false
                    });
                }
                api.reset(initialValues);
            });
        },
        resumeValidation: function resumeValidation() {
            validationPaused = false;
            preventNotificationWhileValidationPaused = false;
            if (validationBlocked) // validation was attempted while it was paused, so run it now
            runValidation(undefined, function() {
                notifyFieldListeners();
                notifyFormListeners();
            });
            validationBlocked = false;
        },
        setConfig: function setConfig(name, value1) {
            switch(name){
                case "debug":
                    debug = value1;
                    break;
                case "destroyOnUnregister":
                    destroyOnUnregister = value1;
                    break;
                case "initialValues":
                    api.initialize(value1);
                    break;
                case "keepDirtyOnReinitialize":
                    keepDirtyOnReinitialize = value1;
                    break;
                case "mutators":
                    mutators = value1;
                    if (value1) {
                        Object.keys(mutatorsApi).forEach(function(key) {
                            if (!(key in value1)) delete mutatorsApi[key];
                        });
                        Object.keys(value1).forEach(function(key) {
                            mutatorsApi[key] = getMutatorApi(key);
                        });
                    } else Object.keys(mutatorsApi).forEach(function(key) {
                        delete mutatorsApi[key];
                    });
                    break;
                case "onSubmit":
                    onSubmit = value1;
                    break;
                case "validate":
                    validate = value1;
                    runValidation(undefined, function() {
                        notifyFieldListeners();
                        notifyFormListeners();
                    });
                    break;
                case "validateOnBlur":
                    validateOnBlur = value1;
                    break;
                default:
                    throw new Error("Unrecognised option " + name);
            }
        },
        submit: function submit() {
            var formState = state.formState;
            if (formState.submitting) return;
            delete formState.submitErrors;
            delete formState.submitError;
            formState.lastSubmittedValues = (0, $d1G9Q.default)({}, formState.values);
            if (hasSyncErrors()) {
                markAllFieldsTouched();
                resetModifiedAfterSubmit();
                state.formState.submitFailed = true;
                notifyFormListeners();
                notifyFieldListeners();
                return; // no submit for you!!
            }
            var asyncValidationPromisesKeys = Object.keys(asyncValidationPromises);
            if (asyncValidationPromisesKeys.length) {
                // still waiting on async validation to complete...
                Promise.all(asyncValidationPromisesKeys.map(function(key) {
                    return asyncValidationPromises[Number(key)];
                })).then(api.submit, console.error);
                return;
            }
            var submitIsBlocked = beforeSubmit();
            if (submitIsBlocked) return;
            var resolvePromise;
            var completeCalled = false;
            var complete = function complete(errors) {
                formState.submitting = false;
                var resetWhileSubmitting = formState.resetWhileSubmitting;
                if (resetWhileSubmitting) formState.resetWhileSubmitting = false;
                if (errors && $4e4bed591426b6a1$var$hasAnyError(errors)) {
                    formState.submitFailed = true;
                    formState.submitSucceeded = false;
                    formState.submitErrors = errors;
                    formState.submitError = errors[$4e4bed591426b6a1$export$97cd7fc25dd32915];
                    markAllFieldsTouched();
                } else {
                    if (!resetWhileSubmitting) {
                        formState.submitFailed = false;
                        formState.submitSucceeded = true;
                    }
                    afterSubmit();
                }
                notifyFormListeners();
                notifyFieldListeners();
                completeCalled = true;
                if (resolvePromise) resolvePromise(errors);
                return errors;
            };
            formState.submitting = true;
            formState.submitFailed = false;
            formState.submitSucceeded = false;
            formState.lastSubmittedValues = (0, $d1G9Q.default)({}, formState.values);
            resetModifiedAfterSubmit();
            // onSubmit is either sync, callback or async with a Promise
            var result = onSubmit(formState.values, api, complete);
            if (!completeCalled) {
                if (result && $4e4bed591426b6a1$var$isPromise(result)) {
                    // onSubmit is async with a Promise
                    notifyFormListeners(); // let everyone know we are submitting
                    notifyFieldListeners(); // notify fields also
                    return result.then(complete, function(error) {
                        complete();
                        throw error;
                    });
                } else if (onSubmit.length >= 3) {
                    // must be async, so we should return a Promise
                    notifyFormListeners(); // let everyone know we are submitting
                    notifyFieldListeners(); // notify fields also
                    return new Promise(function(resolve) {
                        resolvePromise = resolve;
                    });
                } else // onSubmit is sync
                complete(result);
            }
        },
        subscribe: function subscribe(subscriber, subscription) {
            if (!subscriber) throw new Error("No callback given.");
            if (!subscription) throw new Error("No subscription provided. What values do you want to listen to?");
            var memoized = $4e4bed591426b6a1$var$memoize(subscriber);
            var subscribers = state.subscribers;
            var index = subscribers.index++;
            subscribers.entries[index] = {
                subscriber: memoized,
                subscription: subscription,
                notified: false
            };
            var nextFormState = calculateNextFormState();
            $4e4bed591426b6a1$var$notifySubscriber(memoized, subscription, nextFormState, nextFormState, $4e4bed591426b6a1$var$filterFormState, true);
            return function() {
                delete subscribers.entries[index];
            };
        }
    };
    return api;
}

});

parcelRegister("jOmHm", function(module, exports) {
$parcel$export(module.exports, "default", () => $e6c44b4368aad9af$export$2e2bcd8739ae039);

var $6ILNo = parcelRequire("6ILNo");
//      
/**
 * Predicate to identify inputs that can have focus() called on them
 */ var $e6c44b4368aad9af$var$isFocusableInput = function isFocusableInput(wtf) {
    return !!(wtf && typeof wtf.focus === 'function');
};
//      
/**
 * Gets all the inputs inside all forms on the page
 */ var $e6c44b4368aad9af$var$getAllInputs = function getAllInputs() {
    if (typeof document === 'undefined') return [];
    return Array.prototype.slice.call(document.forms).reduce(function(accumulator, form) {
        return accumulator.concat(Array.prototype.slice.call(form).filter($e6c44b4368aad9af$var$isFocusableInput));
    }, []);
};
//      
/**
 * Finds the input by looking if the name attribute path is existing in the errors object
 */ var $e6c44b4368aad9af$var$findInput = function findInput(inputs, errors) {
    return inputs.find(function(input) {
        return input.name && (0, $6ILNo.getIn)(errors, input.name);
    });
};
//      
var $e6c44b4368aad9af$var$noop = function noop() {};
var $e6c44b4368aad9af$var$createDecorator = function createDecorator(getInputs, findInput$$1) {
    return function(form) {
        var focusOnFirstError = function focusOnFirstError(errors) {
            if (!getInputs) getInputs = $e6c44b4368aad9af$var$getAllInputs;
            if (!findInput$$1) findInput$$1 = $e6c44b4368aad9af$var$findInput;
            var firstInput = findInput$$1(getInputs(), errors);
            if (firstInput) firstInput.focus();
        }; // Save original submit function
        var originalSubmit = form.submit; // Subscribe to errors, and keep a local copy of them
        var state = {};
        var unsubscribe = form.subscribe(function(nextState) {
            state = nextState;
        }, {
            errors: true,
            submitErrors: true
        }); // What to do after submit
        var afterSubmit = function afterSubmit() {
            var _state = state, errors = _state.errors, submitErrors = _state.submitErrors;
            if (errors && Object.keys(errors).length) focusOnFirstError(errors);
            else if (submitErrors && Object.keys(submitErrors).length) focusOnFirstError(submitErrors);
        }; // Rewrite submit function
        form.submit = function() {
            var result = originalSubmit.call(form);
            if (result && typeof result.then === 'function') // async
            result.then(afterSubmit, $e6c44b4368aad9af$var$noop);
            else // sync
            afterSubmit();
            return result;
        };
        return function() {
            unsubscribe();
            form.submit = originalSubmit;
        };
    };
};
//      
/**
 * Generates a function to get all the inputs in a form with the specified name
 */ var $e6c44b4368aad9af$export$a53c79cbd9f0d029 = function getFormInputs(name) {
    return function() {
        if (typeof document === 'undefined') return [];
         // $FlowFixMe
        var form = document.forms[name];
        return form && form.length ? Array.prototype.slice.call(form).filter($e6c44b4368aad9af$var$isFocusableInput) : []; // cast cheat to get from HTMLFormElement children to FocusableInput
    };
};
var //
$e6c44b4368aad9af$export$2e2bcd8739ae039 = $e6c44b4368aad9af$var$createDecorator;

});

parcelRegister("117fZ", function(module, exports) {

var $dZPHh = parcelRequire("dZPHh");
/**
 * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
 * it's created. Arrays are created for missing index properties while objects
 * are created for all other missing properties. Use `_.setWith` to customize
 * `path` creation.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.set(object, 'a[0].b.c', 4);
 * console.log(object.a[0].b.c);
 * // => 4
 *
 * _.set(object, ['x', '0', 'y', 'z'], 5);
 * console.log(object.x[0].y.z);
 * // => 5
 */ function $0bdb8386e438bed3$var$set(object, path, value) {
    return object == null ? object : $dZPHh(object, path, value);
}
module.exports = $0bdb8386e438bed3$var$set;

});
parcelRegister("dZPHh", function(module, exports) {

var $3vX86 = parcelRequire("3vX86");

var $33EWK = parcelRequire("33EWK");

var $kgLdF = parcelRequire("kgLdF");

var $lIhLB = parcelRequire("lIhLB");

var $WbaOC = parcelRequire("WbaOC");
/**
 * The base implementation of `_.set`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @param {Function} [customizer] The function to customize path creation.
 * @returns {Object} Returns `object`.
 */ function $a30912d0deb5c62a$var$baseSet(object, path, value, customizer) {
    if (!$lIhLB(object)) return object;
    path = $33EWK(path, object);
    var index = -1, length = path.length, lastIndex = length - 1, nested = object;
    while(nested != null && ++index < length){
        var key = $WbaOC(path[index]), newValue = value;
        if (key === '__proto__' || key === 'constructor' || key === 'prototype') return object;
        if (index != lastIndex) {
            var objValue = nested[key];
            newValue = customizer ? customizer(objValue, key, nested) : undefined;
            if (newValue === undefined) newValue = $lIhLB(objValue) ? objValue : $kgLdF(path[index + 1]) ? [] : {};
        }
        $3vX86(nested, key, newValue);
        nested = nested[key];
    }
    return object;
}
module.exports = $a30912d0deb5c62a$var$baseSet;

});
parcelRegister("3vX86", function(module, exports) {

var $dJvo4 = parcelRequire("dJvo4");

var $grAle = parcelRequire("grAle");
/** Used for built-in method references. */ var $28f22245a6137b2a$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $28f22245a6137b2a$var$hasOwnProperty = $28f22245a6137b2a$var$objectProto.hasOwnProperty;
/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $28f22245a6137b2a$var$assignValue(object, key, value) {
    var objValue = object[key];
    if (!($28f22245a6137b2a$var$hasOwnProperty.call(object, key) && $grAle(objValue, value)) || value === undefined && !(key in object)) $dJvo4(object, key, value);
}
module.exports = $28f22245a6137b2a$var$assignValue;

});
parcelRegister("dJvo4", function(module, exports) {

var $hDKHs = parcelRequire("hDKHs");
/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $9ff7d3288d835e7f$var$baseAssignValue(object, key, value) {
    if (key == '__proto__' && $hDKHs) $hDKHs(object, key, {
        'configurable': true,
        'enumerable': true,
        'value': value,
        'writable': true
    });
    else object[key] = value;
}
module.exports = $9ff7d3288d835e7f$var$baseAssignValue;

});
parcelRegister("hDKHs", function(module, exports) {

var $76YAf = parcelRequire("76YAf");
var $03506c9c1b01a400$var$defineProperty = function() {
    try {
        var func = $76YAf(Object, 'defineProperty');
        func({}, '', {});
        return func;
    } catch (e) {}
}();
module.exports = $03506c9c1b01a400$var$defineProperty;

});
parcelRegister("76YAf", function(module, exports) {

var $2dbaL = parcelRequire("2dbaL");

var $1CRtL = parcelRequire("1CRtL");
/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function $52d8169341102371$var$getNative(object, key) {
    var value = $1CRtL(object, key);
    return $2dbaL(value) ? value : undefined;
}
module.exports = $52d8169341102371$var$getNative;

});
parcelRegister("2dbaL", function(module, exports) {

var $78AO6 = parcelRequire("78AO6");

var $ccj3g = parcelRequire("ccj3g");

var $lIhLB = parcelRequire("lIhLB");

var $1DbD2 = parcelRequire("1DbD2");
/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var $19c57656b708725a$var$reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */ var $19c57656b708725a$var$reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used for built-in method references. */ var $19c57656b708725a$var$funcProto = Function.prototype, $19c57656b708725a$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $19c57656b708725a$var$funcToString = $19c57656b708725a$var$funcProto.toString;
/** Used to check objects for own properties. */ var $19c57656b708725a$var$hasOwnProperty = $19c57656b708725a$var$objectProto.hasOwnProperty;
/** Used to detect if a method is native. */ var $19c57656b708725a$var$reIsNative = RegExp('^' + $19c57656b708725a$var$funcToString.call($19c57656b708725a$var$hasOwnProperty).replace($19c57656b708725a$var$reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function $19c57656b708725a$var$baseIsNative(value) {
    if (!$lIhLB(value) || $ccj3g(value)) return false;
    var pattern = $78AO6(value) ? $19c57656b708725a$var$reIsNative : $19c57656b708725a$var$reIsHostCtor;
    return pattern.test($1DbD2(value));
}
module.exports = $19c57656b708725a$var$baseIsNative;

});
parcelRegister("78AO6", function(module, exports) {

var $7Vpf7 = parcelRequire("7Vpf7");

var $lIhLB = parcelRequire("lIhLB");
/** `Object#toString` result references. */ var $5325d4e3f7b9e6cb$var$asyncTag = '[object AsyncFunction]', $5325d4e3f7b9e6cb$var$funcTag = '[object Function]', $5325d4e3f7b9e6cb$var$genTag = '[object GeneratorFunction]', $5325d4e3f7b9e6cb$var$proxyTag = '[object Proxy]';
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function $5325d4e3f7b9e6cb$var$isFunction(value) {
    if (!$lIhLB(value)) return false;
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 9 which returns 'object' for typed arrays and other constructors.
    var tag = $7Vpf7(value);
    return tag == $5325d4e3f7b9e6cb$var$funcTag || tag == $5325d4e3f7b9e6cb$var$genTag || tag == $5325d4e3f7b9e6cb$var$asyncTag || tag == $5325d4e3f7b9e6cb$var$proxyTag;
}
module.exports = $5325d4e3f7b9e6cb$var$isFunction;

});
parcelRegister("7Vpf7", function(module, exports) {

var $fb7PP = parcelRequire("fb7PP");

var $5mW7B = parcelRequire("5mW7B");

var $38atd = parcelRequire("38atd");
/** `Object#toString` result references. */ var $5c516ff9b4ec4333$var$nullTag = '[object Null]', $5c516ff9b4ec4333$var$undefinedTag = '[object Undefined]';
/** Built-in value references. */ var $5c516ff9b4ec4333$var$symToStringTag = $fb7PP ? $fb7PP.toStringTag : undefined;
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function $5c516ff9b4ec4333$var$baseGetTag(value) {
    if (value == null) return value === undefined ? $5c516ff9b4ec4333$var$undefinedTag : $5c516ff9b4ec4333$var$nullTag;
    return $5c516ff9b4ec4333$var$symToStringTag && $5c516ff9b4ec4333$var$symToStringTag in Object(value) ? $5mW7B(value) : $38atd(value);
}
module.exports = $5c516ff9b4ec4333$var$baseGetTag;

});
parcelRegister("fb7PP", function(module, exports) {

var $iXqsg = parcelRequire("iXqsg");
/** Built-in value references. */ var $b0cdf5f82c284b2b$var$Symbol = $iXqsg.Symbol;
module.exports = $b0cdf5f82c284b2b$var$Symbol;

});
parcelRegister("iXqsg", function(module, exports) {

var $2eo3w = parcelRequire("2eo3w");
/** Detect free variable `self`. */ var $dcd24212e9610d38$var$freeSelf = typeof self == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $dcd24212e9610d38$var$root = $2eo3w || $dcd24212e9610d38$var$freeSelf || Function('return this')();
module.exports = $dcd24212e9610d38$var$root;

});
parcelRegister("2eo3w", function(module, exports) {
/** Detect free variable `global` from Node.js. */ var $19ff8c897068d84b$var$freeGlobal = typeof $parcel$global == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
module.exports = $19ff8c897068d84b$var$freeGlobal;

});



parcelRegister("5mW7B", function(module, exports) {

var $fb7PP = parcelRequire("fb7PP");
/** Used for built-in method references. */ var $3e8c179708a8a55c$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $3e8c179708a8a55c$var$hasOwnProperty = $3e8c179708a8a55c$var$objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $3e8c179708a8a55c$var$nativeObjectToString = $3e8c179708a8a55c$var$objectProto.toString;
/** Built-in value references. */ var $3e8c179708a8a55c$var$symToStringTag = $fb7PP ? $fb7PP.toStringTag : undefined;
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function $3e8c179708a8a55c$var$getRawTag(value) {
    var isOwn = $3e8c179708a8a55c$var$hasOwnProperty.call(value, $3e8c179708a8a55c$var$symToStringTag), tag = value[$3e8c179708a8a55c$var$symToStringTag];
    try {
        value[$3e8c179708a8a55c$var$symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = $3e8c179708a8a55c$var$nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[$3e8c179708a8a55c$var$symToStringTag] = tag;
        else delete value[$3e8c179708a8a55c$var$symToStringTag];
    }
    return result;
}
module.exports = $3e8c179708a8a55c$var$getRawTag;

});

parcelRegister("38atd", function(module, exports) {
/** Used for built-in method references. */ var $247a3d9d42b555d0$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $247a3d9d42b555d0$var$nativeObjectToString = $247a3d9d42b555d0$var$objectProto.toString;
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function $247a3d9d42b555d0$var$objectToString(value) {
    return $247a3d9d42b555d0$var$nativeObjectToString.call(value);
}
module.exports = $247a3d9d42b555d0$var$objectToString;

});


parcelRegister("lIhLB", function(module, exports) {
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $fceb7d20fd150820$var$isObject(value) {
    var type = typeof value;
    return value != null && (type == 'object' || type == 'function');
}
module.exports = $fceb7d20fd150820$var$isObject;

});


parcelRegister("ccj3g", function(module, exports) {

var $lUx9l = parcelRequire("lUx9l");
/** Used to detect methods masquerading as native. */ var $8e1562442cf48937$var$maskSrcKey = function() {
    var uid = /[^.]+$/.exec($lUx9l && $lUx9l.keys && $lUx9l.keys.IE_PROTO || '');
    return uid ? 'Symbol(src)_1.' + uid : '';
}();
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function $8e1562442cf48937$var$isMasked(func) {
    return !!$8e1562442cf48937$var$maskSrcKey && $8e1562442cf48937$var$maskSrcKey in func;
}
module.exports = $8e1562442cf48937$var$isMasked;

});
parcelRegister("lUx9l", function(module, exports) {

var $iXqsg = parcelRequire("iXqsg");
/** Used to detect overreaching core-js shims. */ var $ff388ac2014073b4$var$coreJsData = $iXqsg["__core-js_shared__"];
module.exports = $ff388ac2014073b4$var$coreJsData;

});


parcelRegister("1DbD2", function(module, exports) {
/** Used for built-in method references. */ var $13027427a864304f$var$funcProto = Function.prototype;
/** Used to resolve the decompiled source of functions. */ var $13027427a864304f$var$funcToString = $13027427a864304f$var$funcProto.toString;
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */ function $13027427a864304f$var$toSource(func) {
    if (func != null) {
        try {
            return $13027427a864304f$var$funcToString.call(func);
        } catch (e) {}
        try {
            return func + '';
        } catch (e) {}
    }
    return '';
}
module.exports = $13027427a864304f$var$toSource;

});


parcelRegister("1CRtL", function(module, exports) {
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function $12f2d2e13527409c$var$getValue(object, key) {
    return object == null ? undefined : object[key];
}
module.exports = $12f2d2e13527409c$var$getValue;

});




parcelRegister("grAle", function(module, exports) {
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function $bf8b5b9aa9842838$var$eq(value, other) {
    return value === other || value !== value && other !== other;
}
module.exports = $bf8b5b9aa9842838$var$eq;

});


parcelRegister("33EWK", function(module, exports) {

var $4vMNO = parcelRequire("4vMNO");

var $agaje = parcelRequire("agaje");

var $9vTjC = parcelRequire("9vTjC");

var $duo48 = parcelRequire("duo48");
/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */ function $23a16a070edeb957$var$castPath(value, object) {
    if ($4vMNO(value)) return value;
    return $agaje(value, object) ? [
        value
    ] : $9vTjC($duo48(value));
}
module.exports = $23a16a070edeb957$var$castPath;

});
parcelRegister("4vMNO", function(module, exports) {
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var $348fe9d38102b495$var$isArray = Array.isArray;
module.exports = $348fe9d38102b495$var$isArray;

});

parcelRegister("agaje", function(module, exports) {

var $4vMNO = parcelRequire("4vMNO");

var $3sIvm = parcelRequire("3sIvm");
/** Used to match property names within property paths. */ var $7783653137015a52$var$reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, $7783653137015a52$var$reIsPlainProp = /^\w*$/;
/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */ function $7783653137015a52$var$isKey(value, object) {
    if ($4vMNO(value)) return false;
    var type = typeof value;
    if (type == 'number' || type == 'symbol' || type == 'boolean' || value == null || $3sIvm(value)) return true;
    return $7783653137015a52$var$reIsPlainProp.test(value) || !$7783653137015a52$var$reIsDeepProp.test(value) || object != null && value in Object(object);
}
module.exports = $7783653137015a52$var$isKey;

});
parcelRegister("3sIvm", function(module, exports) {

var $7Vpf7 = parcelRequire("7Vpf7");

var $9Msco = parcelRequire("9Msco");
/** `Object#toString` result references. */ var $2856825500e2bbb2$var$symbolTag = '[object Symbol]';
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $2856825500e2bbb2$var$isSymbol(value) {
    return typeof value == 'symbol' || $9Msco(value) && $7Vpf7(value) == $2856825500e2bbb2$var$symbolTag;
}
module.exports = $2856825500e2bbb2$var$isSymbol;

});
parcelRegister("9Msco", function(module, exports) {
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $71ee7875aed49df0$var$isObjectLike(value) {
    return value != null && typeof value == 'object';
}
module.exports = $71ee7875aed49df0$var$isObjectLike;

});



parcelRegister("9vTjC", function(module, exports) {

var $03RV2 = parcelRequire("03RV2");
/** Used to match property names within property paths. */ var $6ed1eacd5e09b7fb$var$rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
/** Used to match backslashes in property paths. */ var $6ed1eacd5e09b7fb$var$reEscapeChar = /\\(\\)?/g;
/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */ var $6ed1eacd5e09b7fb$var$stringToPath = $03RV2(function(string) {
    var result = [];
    if (string.charCodeAt(0) === 46 /* . */ ) result.push('');
    string.replace($6ed1eacd5e09b7fb$var$rePropName, function(match, number, quote, subString) {
        result.push(quote ? subString.replace($6ed1eacd5e09b7fb$var$reEscapeChar, '$1') : number || match);
    });
    return result;
});
module.exports = $6ed1eacd5e09b7fb$var$stringToPath;

});
parcelRegister("03RV2", function(module, exports) {

var $dIO46 = parcelRequire("dIO46");
/** Used as the maximum memoize cache size. */ var $00ba1b22d1fcd440$var$MAX_MEMOIZE_SIZE = 500;
/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */ function $00ba1b22d1fcd440$var$memoizeCapped(func) {
    var result = $dIO46(func, function(key) {
        if (cache.size === $00ba1b22d1fcd440$var$MAX_MEMOIZE_SIZE) cache.clear();
        return key;
    });
    var cache = result.cache;
    return result;
}
module.exports = $00ba1b22d1fcd440$var$memoizeCapped;

});
parcelRegister("dIO46", function(module, exports) {

var $fbj5d = parcelRequire("fbj5d");
/** Error message constants. */ var $9fd638579fffdec8$var$FUNC_ERROR_TEXT = 'Expected a function';
/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */ function $9fd638579fffdec8$var$memoize(func, resolver) {
    if (typeof func != 'function' || resolver != null && typeof resolver != 'function') throw new TypeError($9fd638579fffdec8$var$FUNC_ERROR_TEXT);
    var memoized = function() {
        var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
        if (cache.has(key)) return cache.get(key);
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
    };
    memoized.cache = new ($9fd638579fffdec8$var$memoize.Cache || $fbj5d);
    return memoized;
}
// Expose `MapCache`.
$9fd638579fffdec8$var$memoize.Cache = $fbj5d;
module.exports = $9fd638579fffdec8$var$memoize;

});
parcelRegister("fbj5d", function(module, exports) {

var $er8Pk = parcelRequire("er8Pk");

var $ghz8V = parcelRequire("ghz8V");

var $iQpci = parcelRequire("iQpci");

var $h9SOd = parcelRequire("h9SOd");

var $h2NgB = parcelRequire("h2NgB");
/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $b0d6af9660a8fa69$var$MapCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `MapCache`.
$b0d6af9660a8fa69$var$MapCache.prototype.clear = $er8Pk;
$b0d6af9660a8fa69$var$MapCache.prototype['delete'] = $ghz8V;
$b0d6af9660a8fa69$var$MapCache.prototype.get = $iQpci;
$b0d6af9660a8fa69$var$MapCache.prototype.has = $h9SOd;
$b0d6af9660a8fa69$var$MapCache.prototype.set = $h2NgB;
module.exports = $b0d6af9660a8fa69$var$MapCache;

});
parcelRegister("er8Pk", function(module, exports) {

var $30Ct0 = parcelRequire("30Ct0");

var $jcImH = parcelRequire("jcImH");

var $45eKn = parcelRequire("45eKn");
/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function $a82a6f262cf8e66a$var$mapCacheClear() {
    this.size = 0;
    this.__data__ = {
        'hash': new $30Ct0,
        'map': new ($45eKn || $jcImH),
        'string': new $30Ct0
    };
}
module.exports = $a82a6f262cf8e66a$var$mapCacheClear;

});
parcelRegister("30Ct0", function(module, exports) {

var $871ZP = parcelRequire("871ZP");

var $lcs46 = parcelRequire("lcs46");

var $imrLk = parcelRequire("imrLk");

var $g3QR4 = parcelRequire("g3QR4");

var $6a9Ih = parcelRequire("6a9Ih");
/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $230f35e322a45463$var$Hash(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `Hash`.
$230f35e322a45463$var$Hash.prototype.clear = $871ZP;
$230f35e322a45463$var$Hash.prototype['delete'] = $lcs46;
$230f35e322a45463$var$Hash.prototype.get = $imrLk;
$230f35e322a45463$var$Hash.prototype.has = $g3QR4;
$230f35e322a45463$var$Hash.prototype.set = $6a9Ih;
module.exports = $230f35e322a45463$var$Hash;

});
parcelRegister("871ZP", function(module, exports) {

var $Fnv0I = parcelRequire("Fnv0I");
/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function $5e8086945122e336$var$hashClear() {
    this.__data__ = $Fnv0I ? $Fnv0I(null) : {};
    this.size = 0;
}
module.exports = $5e8086945122e336$var$hashClear;

});
parcelRegister("Fnv0I", function(module, exports) {

var $76YAf = parcelRequire("76YAf");
/* Built-in method references that are verified to be native. */ var $07c60ee53783fc5a$var$nativeCreate = $76YAf(Object, 'create');
module.exports = $07c60ee53783fc5a$var$nativeCreate;

});


parcelRegister("lcs46", function(module, exports) {
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $f6f07d19c3518e08$var$hashDelete(key) {
    var result = this.has(key) && delete this.__data__[key];
    this.size -= result ? 1 : 0;
    return result;
}
module.exports = $f6f07d19c3518e08$var$hashDelete;

});

parcelRegister("imrLk", function(module, exports) {

var $Fnv0I = parcelRequire("Fnv0I");
/** Used to stand-in for `undefined` hash values. */ var $d5dfd11c59d2c646$var$HASH_UNDEFINED = '__lodash_hash_undefined__';
/** Used for built-in method references. */ var $d5dfd11c59d2c646$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $d5dfd11c59d2c646$var$hasOwnProperty = $d5dfd11c59d2c646$var$objectProto.hasOwnProperty;
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $d5dfd11c59d2c646$var$hashGet(key) {
    var data = this.__data__;
    if ($Fnv0I) {
        var result = data[key];
        return result === $d5dfd11c59d2c646$var$HASH_UNDEFINED ? undefined : result;
    }
    return $d5dfd11c59d2c646$var$hasOwnProperty.call(data, key) ? data[key] : undefined;
}
module.exports = $d5dfd11c59d2c646$var$hashGet;

});

parcelRegister("g3QR4", function(module, exports) {

var $Fnv0I = parcelRequire("Fnv0I");
/** Used for built-in method references. */ var $bb15ed13a7a39f75$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $bb15ed13a7a39f75$var$hasOwnProperty = $bb15ed13a7a39f75$var$objectProto.hasOwnProperty;
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $bb15ed13a7a39f75$var$hashHas(key) {
    var data = this.__data__;
    return $Fnv0I ? data[key] !== undefined : $bb15ed13a7a39f75$var$hasOwnProperty.call(data, key);
}
module.exports = $bb15ed13a7a39f75$var$hashHas;

});

parcelRegister("6a9Ih", function(module, exports) {

var $Fnv0I = parcelRequire("Fnv0I");
/** Used to stand-in for `undefined` hash values. */ var $47cb361097e4c3d1$var$HASH_UNDEFINED = '__lodash_hash_undefined__';
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function $47cb361097e4c3d1$var$hashSet(key, value) {
    var data = this.__data__;
    this.size += this.has(key) ? 0 : 1;
    data[key] = $Fnv0I && value === undefined ? $47cb361097e4c3d1$var$HASH_UNDEFINED : value;
    return this;
}
module.exports = $47cb361097e4c3d1$var$hashSet;

});


parcelRegister("jcImH", function(module, exports) {

var $dZMET = parcelRequire("dZMET");

var $gb5sH = parcelRequire("gb5sH");

var $2Xzdc = parcelRequire("2Xzdc");

var $2AHOZ = parcelRequire("2AHOZ");

var $f4ae7 = parcelRequire("f4ae7");
/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $dfb18d52eff00d4f$var$ListCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `ListCache`.
$dfb18d52eff00d4f$var$ListCache.prototype.clear = $dZMET;
$dfb18d52eff00d4f$var$ListCache.prototype['delete'] = $gb5sH;
$dfb18d52eff00d4f$var$ListCache.prototype.get = $2Xzdc;
$dfb18d52eff00d4f$var$ListCache.prototype.has = $2AHOZ;
$dfb18d52eff00d4f$var$ListCache.prototype.set = $f4ae7;
module.exports = $dfb18d52eff00d4f$var$ListCache;

});
parcelRegister("dZMET", function(module, exports) {
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function $a306b76d367e196d$var$listCacheClear() {
    this.__data__ = [];
    this.size = 0;
}
module.exports = $a306b76d367e196d$var$listCacheClear;

});

parcelRegister("gb5sH", function(module, exports) {

var $98eF4 = parcelRequire("98eF4");
/** Used for built-in method references. */ var $bc71e907d1372534$var$arrayProto = Array.prototype;
/** Built-in value references. */ var $bc71e907d1372534$var$splice = $bc71e907d1372534$var$arrayProto.splice;
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $bc71e907d1372534$var$listCacheDelete(key) {
    var data = this.__data__, index = $98eF4(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else $bc71e907d1372534$var$splice.call(data, index, 1);
    --this.size;
    return true;
}
module.exports = $bc71e907d1372534$var$listCacheDelete;

});
parcelRegister("98eF4", function(module, exports) {

var $grAle = parcelRequire("grAle");
/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $6a603bdd9bd9966a$var$assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if ($grAle(array[length][0], key)) return length;
    }
    return -1;
}
module.exports = $6a603bdd9bd9966a$var$assocIndexOf;

});


parcelRegister("2Xzdc", function(module, exports) {

var $98eF4 = parcelRequire("98eF4");
/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $227c67cd1b4f8791$var$listCacheGet(key) {
    var data = this.__data__, index = $98eF4(data, key);
    return index < 0 ? undefined : data[index][1];
}
module.exports = $227c67cd1b4f8791$var$listCacheGet;

});

parcelRegister("2AHOZ", function(module, exports) {

var $98eF4 = parcelRequire("98eF4");
/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $1e30ef9a508c80f8$var$listCacheHas(key) {
    return $98eF4(this.__data__, key) > -1;
}
module.exports = $1e30ef9a508c80f8$var$listCacheHas;

});

parcelRegister("f4ae7", function(module, exports) {

var $98eF4 = parcelRequire("98eF4");
/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function $af7f298b23a242dd$var$listCacheSet(key, value) {
    var data = this.__data__, index = $98eF4(data, key);
    if (index < 0) {
        ++this.size;
        data.push([
            key,
            value
        ]);
    } else data[index][1] = value;
    return this;
}
module.exports = $af7f298b23a242dd$var$listCacheSet;

});


parcelRegister("45eKn", function(module, exports) {

var $76YAf = parcelRequire("76YAf");

var $iXqsg = parcelRequire("iXqsg");
/* Built-in method references that are verified to be native. */ var $2f931183d41ede7b$var$Map = $76YAf($iXqsg, 'Map');
module.exports = $2f931183d41ede7b$var$Map;

});


parcelRegister("ghz8V", function(module, exports) {

var $fBn3P = parcelRequire("fBn3P");
/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $bda97e8629d9498e$var$mapCacheDelete(key) {
    var result = $fBn3P(this, key)['delete'](key);
    this.size -= result ? 1 : 0;
    return result;
}
module.exports = $bda97e8629d9498e$var$mapCacheDelete;

});
parcelRegister("fBn3P", function(module, exports) {

var $cb3FS = parcelRequire("cb3FS");
/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function $b5bc331d15b80d9a$var$getMapData(map, key) {
    var data = map.__data__;
    return $cb3FS(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
}
module.exports = $b5bc331d15b80d9a$var$getMapData;

});
parcelRegister("cb3FS", function(module, exports) {
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function $8dd95cc91ec8ca20$var$isKeyable(value) {
    var type = typeof value;
    return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
}
module.exports = $8dd95cc91ec8ca20$var$isKeyable;

});



parcelRegister("iQpci", function(module, exports) {

var $fBn3P = parcelRequire("fBn3P");
/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $db80a0fe29114b26$var$mapCacheGet(key) {
    return $fBn3P(this, key).get(key);
}
module.exports = $db80a0fe29114b26$var$mapCacheGet;

});

parcelRegister("h9SOd", function(module, exports) {

var $fBn3P = parcelRequire("fBn3P");
/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $c7ddcad68e67f10e$var$mapCacheHas(key) {
    return $fBn3P(this, key).has(key);
}
module.exports = $c7ddcad68e67f10e$var$mapCacheHas;

});

parcelRegister("h2NgB", function(module, exports) {

var $fBn3P = parcelRequire("fBn3P");
/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function $c688d6f400c62922$var$mapCacheSet(key, value) {
    var data = $fBn3P(this, key), size = data.size;
    data.set(key, value);
    this.size += data.size == size ? 0 : 1;
    return this;
}
module.exports = $c688d6f400c62922$var$mapCacheSet;

});





parcelRegister("duo48", function(module, exports) {

var $e6Inr = parcelRequire("e6Inr");
/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */ function $9d20bea3e35643ef$var$toString(value) {
    return value == null ? '' : $e6Inr(value);
}
module.exports = $9d20bea3e35643ef$var$toString;

});
parcelRegister("e6Inr", function(module, exports) {

var $fb7PP = parcelRequire("fb7PP");

var $9hIZV = parcelRequire("9hIZV");

var $4vMNO = parcelRequire("4vMNO");

var $3sIvm = parcelRequire("3sIvm");
/** Used as references for various `Number` constants. */ var $a4540c9db65dd028$var$INFINITY = 1 / 0;
/** Used to convert symbols to primitives and strings. */ var $a4540c9db65dd028$var$symbolProto = $fb7PP ? $fb7PP.prototype : undefined, $a4540c9db65dd028$var$symbolToString = $a4540c9db65dd028$var$symbolProto ? $a4540c9db65dd028$var$symbolProto.toString : undefined;
/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */ function $a4540c9db65dd028$var$baseToString(value) {
    // Exit early for strings to avoid a performance hit in some environments.
    if (typeof value == 'string') return value;
    if ($4vMNO(value)) // Recursively convert values (susceptible to call stack limits).
    return $9hIZV(value, $a4540c9db65dd028$var$baseToString) + '';
    if ($3sIvm(value)) return $a4540c9db65dd028$var$symbolToString ? $a4540c9db65dd028$var$symbolToString.call(value) : '';
    var result = value + '';
    return result == '0' && 1 / value == -$a4540c9db65dd028$var$INFINITY ? '-0' : result;
}
module.exports = $a4540c9db65dd028$var$baseToString;

});
parcelRegister("9hIZV", function(module, exports) {
/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function $6c289b397fa4796d$var$arrayMap(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length, result = Array(length);
    while(++index < length)result[index] = iteratee(array[index], index, array);
    return result;
}
module.exports = $6c289b397fa4796d$var$arrayMap;

});




parcelRegister("kgLdF", function(module, exports) {
/** Used as references for various `Number` constants. */ var $ec19ee111509a6fd$var$MAX_SAFE_INTEGER = 9007199254740991;
/** Used to detect unsigned integer values. */ var $ec19ee111509a6fd$var$reIsUint = /^(?:0|[1-9]\d*)$/;
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function $ec19ee111509a6fd$var$isIndex(value, length) {
    var type = typeof value;
    length = length == null ? $ec19ee111509a6fd$var$MAX_SAFE_INTEGER : length;
    return !!length && (type == 'number' || type != 'symbol' && $ec19ee111509a6fd$var$reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
module.exports = $ec19ee111509a6fd$var$isIndex;

});

parcelRegister("WbaOC", function(module, exports) {

var $3sIvm = parcelRequire("3sIvm");
/** Used as references for various `Number` constants. */ var $0aee15b4faea61c9$var$INFINITY = 1 / 0;
/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */ function $0aee15b4faea61c9$var$toKey(value) {
    if (typeof value == 'string' || $3sIvm(value)) return value;
    var result = value + '';
    return result == '0' && 1 / value == -$0aee15b4faea61c9$var$INFINITY ? '-0' : result;
}
module.exports = $0aee15b4faea61c9$var$toKey;

});



parcelRegister("coPW0", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3f93f06e22108e36edaead143b4f646b>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9070030c07639d18$var$_react = $9070030c07639d18$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $9070030c07639d18$var$_baseNew = $9070030c07639d18$var$_interopRequireDefault((parcelRequire("iU83E")));
function $9070030c07639d18$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "StatusError".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for error statuses and messaging.
Filled status icons provide higher visual contrast to draw attention to important information.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $9070030c07639d18$var$StatusErrorIcon = (props)=>/*#__PURE__*/ $9070030c07639d18$var$_react.default.createElement($9070030c07639d18$var$_baseNew.default, Object.assign({
        name: "StatusErrorIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6.586.603a2 2 0 0 1 2.828 0l5.983 5.983a2 2 0 0 1 0 2.828l-5.983 5.982a2 2 0 0 1-2.828 0L.604 9.414a2 2 0 0 1 0-2.828zM8 10.25a1 1 0 1 0 0 2 1 1 0 0 0 0-2m-.75-6.5V9h1.5V3.75z" clip-rule="evenodd"/>`
    }, props));
$9070030c07639d18$var$StatusErrorIcon.displayName = 'StatusErrorIcon';
var $9070030c07639d18$var$_default = module.exports.default = $9070030c07639d18$var$StatusErrorIcon;

});
parcelRegister("iU83E", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => (parcelRequire("4nGyL")).default);
$parcel$export(module.exports, "Icon", () => (parcelRequire("4nGyL")).Icon);

var $4nGyL = parcelRequire("4nGyL");

});
parcelRegister("4nGyL", function(module, exports) {
$parcel$export(module.exports, "Icon", () => $330a52ddfdf2f1f0$export$f04a61298a47a40f);
$parcel$export(module.exports, "default", () => $330a52ddfdf2f1f0$export$2e2bcd8739ae039);
/* icon-new.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");

var $dU8Y3 = parcelRequire("dU8Y3");
/**
 * We are hiding this props from consumers as it's reserved
 * for use by Icon Tile.
 */ var $330a52ddfdf2f1f0$var$svgStyles = null;
var $330a52ddfdf2f1f0$var$iconStyles = null;
var $330a52ddfdf2f1f0$var$utilityIconStyles = null;
var $330a52ddfdf2f1f0$var$scaleStyles = null;
/**
 * For windows high contrast mode
 */ var $330a52ddfdf2f1f0$var$baseHcmStyles = null;
var $330a52ddfdf2f1f0$var$scaleSize = null;
var $330a52ddfdf2f1f0$var$coreSizeMedium = {
    none: "_1bsbpxbi _4t3ipxbi",
    compact: "_1bsb1ejb _4t3i1ejb",
    spacious: "_1bsb1ejb _4t3i1ejb"
};
var $330a52ddfdf2f1f0$var$coreSizeSmall = {
    none: "_1bsbutpp _4t3iutpp",
    compact: "_1bsbpxbi _4t3ipxbi",
    spacious: "_1bsb1ejb _4t3i1ejb"
};
var $330a52ddfdf2f1f0$var$utilSizes = {
    none: "_1bsbutpp _4t3iutpp",
    compact: "_1bsbpxbi _4t3ipxbi",
    spacious: "_1bsb1ejb _4t3i1ejb"
};
var $330a52ddfdf2f1f0$var$baseSizeMap = {
    core: 16,
    utility: 12
};
var $330a52ddfdf2f1f0$var$paddingMap = {
    core: {
        medium: {
            none: 0,
            compact: 4,
            spacious: 4
        },
        small: {
            none: 0,
            compact: 2.66,
            spacious: 8
        }
    },
    utility: {
        medium: {
            none: 0,
            compact: 2,
            spacious: 6
        },
        small: {
            none: 0,
            compact: 2,
            spacious: 6
        }
    }
};
var $330a52ddfdf2f1f0$export$f04a61298a47a40f = /*#__PURE__*/ (0, $5FkrB.memo)(function Icon(props) {
    var _props$type;
    var _ref = props, _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, testId = _ref.testId, label = _ref.label, LEGACY_primaryColor = _ref.LEGACY_primaryColor, LEGACY_secondaryColor = _ref.LEGACY_secondaryColor, LEGACY_size = _ref.LEGACY_size, FallbackIcon = _ref.LEGACY_fallbackIcon, dangerouslySetGlyph = _ref.dangerouslySetGlyph, shouldScale = _ref.shouldScale, LEGACY_margin = _ref.LEGACY_margin, _ref$spacing = _ref.spacing, spacing = _ref$spacing === void 0 ? 'none' : _ref$spacing, name = _ref.name;
    var dangerouslySetInnerHTML = dangerouslySetGlyph ? {
        __html: dangerouslySetGlyph
    } : undefined;
    // Fall back to old icon
    if (FallbackIcon && !(0, $dU8Y3.fg)('platform-visual-refresh-icons')) // parse out unnecessary props
    return /*#__PURE__*/ $5FkrB.createElement(FallbackIcon, {
        primaryColor: LEGACY_primaryColor !== null && LEGACY_primaryColor !== void 0 ? LEGACY_primaryColor : color,
        secondaryColor: LEGACY_secondaryColor,
        size: LEGACY_size,
        label: label,
        testId: testId,
        UNSAFE_margin: LEGACY_margin
    });
    var type = (_props$type = props.type) !== null && _props$type !== void 0 ? _props$type : 'core';
    var size = 'medium';
    if ('size' in props && props.size !== undefined) {
        if (typeof props.size === 'string') size = props.size === 'small' || props.size === 'medium' ? props.size : size;
        else if (name) {
            var newSize = props.size(name);
            size = newSize === 'small' || newSize === 'medium' ? newSize : size;
        }
    }
    var baseSize = $330a52ddfdf2f1f0$var$baseSizeMap[type];
    var viewBoxPadding = $330a52ddfdf2f1f0$var$paddingMap[type][size][spacing];
    var viewBoxSize = baseSize + 2 * viewBoxPadding;
    return /*#__PURE__*/ $5FkrB.createElement("span", {
        "data-testid": testId,
        role: label ? 'img' : undefined,
        "aria-label": label ? label : undefined,
        "aria-hidden": label ? undefined : true,
        style: {
            color: color
        },
        className: (0, $970q7.default)([
            "_1e0c1o8l _vchhusvi _1o9zidpf _vwz4kb7n _y4ti1igz _bozg1mb9",
            "_12va1onz _jcxd1r8n",
            shouldScale && "_1bsb1kw7 _4t3i1kw7",
            (type === 'utility' || size === 'small') && "_vwz4utpp"
        ])
    }, /*#__PURE__*/ $5FkrB.createElement("svg", {
        fill: "none",
        viewBox: "".concat(0 - viewBoxPadding, " ").concat(0 - viewBoxPadding, " ").concat(viewBoxSize, " ").concat(viewBoxSize),
        role: "presentation",
        dangerouslySetInnerHTML: dangerouslySetInnerHTML,
        className: (0, $970q7.default)([
            "_1reo15vq _18m915vq _syaz1r31 _lcxvglyw _s7n4yfq0 _vc881r31",
            shouldScale ? "_1bsb1kw7 _4t3i1kw7" : type === 'utility' ? $330a52ddfdf2f1f0$var$utilSizes[spacing] : size === 'small' ? $330a52ddfdf2f1f0$var$coreSizeSmall[spacing] : $330a52ddfdf2f1f0$var$coreSizeMedium[spacing]
        ])
    }));
});
var $330a52ddfdf2f1f0$export$2e2bcd8739ae039 = $330a52ddfdf2f1f0$export$f04a61298a47a40f;

});



parcelRegister("1yYLz", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $12381a59acec3ae6$var$_react = $12381a59acec3ae6$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $3aULa = parcelRequire("3aULa");
function $12381a59acec3ae6$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $12381a59acec3ae6$var$ErrorIcon = (props)=>/*#__PURE__*/ $12381a59acec3ae6$var$_react.default.createElement($3aULa.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><path fill="currentcolor" d="M13.416 4.417a2 2 0 0 0-2.832 0l-6.168 6.167a2 2 0 0 0 0 2.833l6.168 6.167a2 2 0 0 0 2.832 0l6.168-6.167a2 2 0 0 0 0-2.833z"/><path fill="inherit" d="M12 14a1 1 0 0 1-1-1V8a1 1 0 0 1 2 0v5a1 1 0 0 1-1 1m0 3a1 1 0 0 1 0-2 1 1 0 0 1 0 2"/></g></svg>`
    }, props));
$12381a59acec3ae6$var$ErrorIcon.displayName = 'ErrorIcon';
var $12381a59acec3ae6$var$_default = module.exports.default = $12381a59acec3ae6$var$ErrorIcon;

});
parcelRegister("3aULa", function(module, exports) {
$parcel$export(module.exports, "Icon", () => $24fe558eef75aa21$export$f04a61298a47a40f);
/* icon.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $kqp0i = parcelRequire("kqp0i");

var $25nEq = parcelRequire("25nEq");

var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");
function $24fe558eef75aa21$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $24fe558eef75aa21$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $24fe558eef75aa21$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $24fe558eef75aa21$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
/**
 * We are hiding these props from consumers as they're used to
 * hack around icon sizing specifically for icon-file-type.
 */ var $24fe558eef75aa21$var$iconStyles = null;
var $24fe558eef75aa21$var$sizeStyles = {
    small: "_1bsb7vkz _4t3i7vkz _5fdi7vkz _zbji7vkz",
    medium: "_1bsb1tcg _4t3i1tcg _5fdi1tcg _zbji1tcg",
    large: "_1bsbzwfg _4t3izwfg _5fdizwfg _zbjizwfg",
    xlarge: "_1bsbckbl _4t3ickbl _5fdickbl _zbjickbl"
};
/**
 * For windows high contrast mode
 */ var $24fe558eef75aa21$var$baseHcmStyles = null;
var $24fe558eef75aa21$var$primaryEqualsSecondaryHcmStyles = null;
var $24fe558eef75aa21$var$secondaryTransparentHcmStyles = null;
var $24fe558eef75aa21$export$f04a61298a47a40f = /*#__PURE__*/ (0, $5FkrB.memo)(function Icon(props) {
    var _ref = props, Glyph = _ref.glyph, dangerouslySetGlyph = _ref.dangerouslySetGlyph, _ref$primaryColor = _ref.primaryColor, primaryColor = _ref$primaryColor === void 0 ? 'currentColor' : _ref$primaryColor, secondaryColor = _ref.secondaryColor, size = _ref.size, testId = _ref.testId, label = _ref.label, width = _ref.width, height = _ref.height, UNSAFE_margin = _ref.UNSAFE_margin;
    var glyphProps = dangerouslySetGlyph ? {
        dangerouslySetInnerHTML: {
            __html: dangerouslySetGlyph
        }
    } : {
        children: Glyph ? /*#__PURE__*/ $5FkrB.createElement(Glyph, {
            role: "presentation"
        }) : null
    };
    var customDimensions = width && height ? {
        width: width + 'px',
        height: height + 'px'
    } : null;
    return /*#__PURE__*/ $5FkrB.createElement("span", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        "data-testid": testId,
        "data-vc": "icon-".concat(testId),
        role: label ? 'img' : undefined,
        "aria-label": label ? label : undefined,
        "aria-hidden": label ? undefined : true,
        style: $24fe558eef75aa21$var$_objectSpread($24fe558eef75aa21$var$_objectSpread({}, customDimensions), {}, {
            '--icon-primary-color': primaryColor,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            '--icon-secondary-color': secondaryColor,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            margin: UNSAFE_margin
        })
    }, glyphProps, {
        className: (0, $970q7.default)([
            "_1e0c1o8l _1o9zidpf _vyfuvuon _vwz4kb7n _1szv15vq _1tly15vq _rzyw1osq _17jb1osq _1ksvoz0e _3se1x1jp _re2rglyw _1veoyfq0 _1kg81r31",
            "_jcxd1r8n _gq0g1onz _1trkwc43",
            primaryColor === secondaryColor && "_18hbwc43",
            secondaryColor === 'transparent' && "_4fyi1j28",
            size && $24fe558eef75aa21$var$sizeStyles[size]
        ])
    }));
});
var $24fe558eef75aa21$export$2e2bcd8739ae039 = $24fe558eef75aa21$export$f04a61298a47a40f;

});


parcelRegister("bQGRN", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::174472a7e38932dc7a97866e0be8034a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8a05cd728458b3b6$var$_react = $8a05cd728458b3b6$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $8a05cd728458b3b6$var$_baseNew = $8a05cd728458b3b6$var$_interopRequireDefault((parcelRequire("iU83E")));
function $8a05cd728458b3b6$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "StatusSuccess".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for success statuses and messaging. Filled status icons provide higher visual contrast to draw attention to important information.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $8a05cd728458b3b6$var$StatusSuccessIcon = (props)=>/*#__PURE__*/ $8a05cd728458b3b6$var$_react.default.createElement($8a05cd728458b3b6$var$_baseNew.default, Object.assign({
        name: "StatusSuccessIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0M6.75 9.828 4.826 7.52l-1.152.96 2.5 3a.75.75 0 0 0 1.152 0l5-6-1.152-.96z" clip-rule="evenodd"/>`
    }, props));
$8a05cd728458b3b6$var$StatusSuccessIcon.displayName = 'StatusSuccessIcon';
var $8a05cd728458b3b6$var$_default = module.exports.default = $8a05cd728458b3b6$var$StatusSuccessIcon;

});

parcelRegister("6AF9r", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4cc606ace6e56886$var$_react = $4cc606ace6e56886$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $3aULa = parcelRequire("3aULa");
function $4cc606ace6e56886$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $4cc606ace6e56886$var$EditorSuccessIcon = (props)=>/*#__PURE__*/ $4cc606ace6e56886$var$_react.default.createElement($3aULa.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M12 20a8 8 0 1 1 0-16 8 8 0 0 1 0 16m1.364-10.964-2.152 4.11-1.543-1.39a1 1 0 1 0-1.338 1.487l2.5 2.25a1 1 0 0 0 1.555-.279l2.75-5.25a1 1 0 0 0-1.772-.928"/></svg>`
    }, props));
$4cc606ace6e56886$var$EditorSuccessIcon.displayName = 'EditorSuccessIcon';
var $4cc606ace6e56886$var$_default = module.exports.default = $4cc606ace6e56886$var$EditorSuccessIcon;

});

parcelRegister("8dIct", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::1b6fc123789ae26535b6e4ca13d1b4ea>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $018b625e5fce7336$var$_react = $018b625e5fce7336$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $018b625e5fce7336$var$_UNSAFE_baseNew = $018b625e5fce7336$var$_interopRequireDefault((parcelRequire("bPdWt")));
function $018b625e5fce7336$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "ShowMoreHorizontal".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for more action menus.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $018b625e5fce7336$var$ShowMoreHorizontalIcon = (props)=>/*#__PURE__*/ $018b625e5fce7336$var$_react.default.createElement($018b625e5fce7336$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="M2.25 8a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0m6.5 0a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0m6.5 0a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0"/><path stroke="currentcolor" stroke-width="1.5" d="M2.25 8a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0Zm6.5 0a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0Zm6.5 0a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0Z"/>`
    }, props));
$018b625e5fce7336$var$ShowMoreHorizontalIcon.displayName = 'ShowMoreHorizontalIcon';
var $018b625e5fce7336$var$_default = module.exports.default = $018b625e5fce7336$var$ShowMoreHorizontalIcon;

});

parcelRegister("igbF4", function(module, exports) {
$parcel$export(module.exports, "default", () => $d4b2c45ac4fec9db$export$2e2bcd8739ae039);

var $5FkrB = parcelRequire("5FkrB");
function $d4b2c45ac4fec9db$var$n() {
    return $d4b2c45ac4fec9db$var$n = Object.assign ? Object.assign.bind() : function(r) {
        for(var n = 1; n < arguments.length; n++){
            var e = arguments[n];
            for(var t in e)Object.prototype.hasOwnProperty.call(e, t) && (r[t] = e[t]);
        }
        return r;
    }, $d4b2c45ac4fec9db$var$n.apply(this, arguments);
}
var $d4b2c45ac4fec9db$var$e = [
    "children",
    "options"
], $d4b2c45ac4fec9db$export$e0aa44767d8750d5 = {
    blockQuote: "0",
    breakLine: "1",
    breakThematic: "2",
    codeBlock: "3",
    codeFenced: "4",
    codeInline: "5",
    footnote: "6",
    footnoteReference: "7",
    gfmTask: "8",
    heading: "9",
    headingSetext: "10",
    htmlBlock: "11",
    htmlComment: "12",
    htmlSelfClosing: "13",
    image: "14",
    link: "15",
    linkAngleBraceStyleDetector: "16",
    linkBareUrlDetector: "17",
    linkMailtoDetector: "18",
    newlineCoalescer: "19",
    orderedList: "20",
    paragraph: "21",
    ref: "22",
    refImage: "23",
    refLink: "24",
    table: "25",
    tableSeparator: "26",
    text: "27",
    textBolded: "28",
    textEmphasized: "29",
    textEscaped: "30",
    textMarked: "31",
    textStrikethroughed: "32",
    unorderedList: "33"
}, $d4b2c45ac4fec9db$var$u = [
    "allowFullScreen",
    "allowTransparency",
    "autoComplete",
    "autoFocus",
    "autoPlay",
    "cellPadding",
    "cellSpacing",
    "charSet",
    "classId",
    "colSpan",
    "contentEditable",
    "contextMenu",
    "crossOrigin",
    "encType",
    "formAction",
    "formEncType",
    "formMethod",
    "formNoValidate",
    "formTarget",
    "frameBorder",
    "hrefLang",
    "inputMode",
    "keyParams",
    "keyType",
    "marginHeight",
    "marginWidth",
    "maxLength",
    "mediaGroup",
    "minLength",
    "noValidate",
    "radioGroup",
    "readOnly",
    "rowSpan",
    "spellCheck",
    "srcDoc",
    "srcLang",
    "srcSet",
    "tabIndex",
    "useMap"
].reduce(function(r, n) {
    return r[n.toLowerCase()] = n, r;
}, {
    class: "className",
    for: "htmlFor"
}), $d4b2c45ac4fec9db$var$a = {
    amp: "&",
    apos: "'",
    gt: ">",
    lt: "<",
    nbsp: "\xa0",
    quot: "\u201C"
}, $d4b2c45ac4fec9db$var$i = [
    "style",
    "script",
    "pre"
], $d4b2c45ac4fec9db$var$o = [
    "src",
    "href",
    "data",
    "formAction",
    "srcDoc",
    "action"
], $d4b2c45ac4fec9db$var$c = /([-A-Z0-9_:]+)(?:\s*=\s*(?:(?:"((?:\\.|[^"])*)")|(?:'((?:\\.|[^'])*)')|(?:\{((?:\\.|{[^}]*?}|[^}])*)\})))?/gi, $d4b2c45ac4fec9db$var$f = /\n{2,}$/, $d4b2c45ac4fec9db$var$l = /^(\s*>[\s\S]*?)(?=\n\n|$)/, $d4b2c45ac4fec9db$var$_ = /^ *> ?/gm, $d4b2c45ac4fec9db$var$d = /^(?:\[!([^\]]*)\]\n)?([\s\S]*)/, $d4b2c45ac4fec9db$var$s = /^ {2,}\n/, $d4b2c45ac4fec9db$var$v = /^(?:([-*_])( *\1){2,}) *(?:\n *)+\n/, $d4b2c45ac4fec9db$var$p = /^(?: {1,3})?(`{3,}|~{3,}) *(\S+)? *([^\n]*?)?\n([\s\S]*?)(?:\1\n?|$)/, $d4b2c45ac4fec9db$var$y = /^(?: {4}[^\n]+\n*)+(?:\n *)+\n?/, $d4b2c45ac4fec9db$var$h = /^(`+)((?:\\`|(?!\1)`|[^`])+)\1/, $d4b2c45ac4fec9db$var$g = /^(?:\n *)*\n/, $d4b2c45ac4fec9db$var$m = /\r\n?/g, $d4b2c45ac4fec9db$var$k = /^\[\^([^\]]+)](:(.*)((\n+ {4,}.*)|(\n(?!\[\^).+))*)/, $d4b2c45ac4fec9db$var$x = /^\[\^([^\]]+)]/, $d4b2c45ac4fec9db$var$q = /\f/g, $d4b2c45ac4fec9db$var$b = /^---[ \t]*\n(.|\n)*\n---[ \t]*\n/, $d4b2c45ac4fec9db$var$S = /^\s*?\[(x|\s)\]/, $d4b2c45ac4fec9db$var$z = /^ *(#{1,6}) *([^\n]+?)(?: +#*)?(?:\n *)*(?:\n|$)/, $d4b2c45ac4fec9db$var$$ = /^ *(#{1,6}) +([^\n]+?)(?: +#*)?(?:\n *)*(?:\n|$)/, $d4b2c45ac4fec9db$var$E = /^([^\n]+)\n *(=|-)\2{2,} *\n/, $d4b2c45ac4fec9db$var$A = /^ *(?!<[a-z][^ >/]* ?\/>)<([a-z][^ >/]*) ?((?:[^>]*[^/])?)>\n?(\s*(?:<\1[^>]*?>[\s\S]*?<\/\1>|(?!<\1\b)[\s\S])*?)<\/\1>(?!<\/\1>)\n*/i, $d4b2c45ac4fec9db$var$R = /&([a-z0-9]+|#[0-9]{1,6}|#x[0-9a-fA-F]{1,6});/gi, $d4b2c45ac4fec9db$var$B = /^<!--[\s\S]*?(?:-->)/, $d4b2c45ac4fec9db$var$L = /^(data|aria|x)-[a-z_][a-z\d_.-]*$/, $d4b2c45ac4fec9db$var$O = /^ *<([a-z][a-z0-9:]*)(?:\s+((?:<.*?>|[^>])*))?\/?>(?!<\/\1>)(\s*\n)?/i, $d4b2c45ac4fec9db$var$j = /^\{.*\}$/, $d4b2c45ac4fec9db$var$C = /^(https?:\/\/[^\s<]+[^<.,:;"')\]\s])/, $d4b2c45ac4fec9db$var$I = /^<([^ >]+[:@\/][^ >]+)>/, $d4b2c45ac4fec9db$var$T = /-([a-z])?/gi, $d4b2c45ac4fec9db$var$M = /^(\|.*)\n(?: *(\|? *[-:]+ *\|[-| :]*)\n((?:.*\|.*\n)*))?\n?/, $d4b2c45ac4fec9db$var$w = /^[^\n]+(?:  \n|\n{2,})/, $d4b2c45ac4fec9db$var$D = /^\[([^\]]*)\]:\s+<?([^\s>]+)>?\s*("([^"]*)")?/, $d4b2c45ac4fec9db$var$F = /^!\[([^\]]*)\] ?\[([^\]]*)\]/, $d4b2c45ac4fec9db$var$P = /^\[([^\]]*)\] ?\[([^\]]*)\]/, $d4b2c45ac4fec9db$var$Z = /(\n|^[-*]\s|^#|^ {2,}|^-{2,}|^>\s)/, $d4b2c45ac4fec9db$var$N = /\t/g, $d4b2c45ac4fec9db$var$G = /(^ *\||\| *$)/g, $d4b2c45ac4fec9db$var$U = /^ *:-+: *$/, $d4b2c45ac4fec9db$var$V = /^ *:-+ *$/, $d4b2c45ac4fec9db$var$H = /^ *-+: *$/, $d4b2c45ac4fec9db$var$Q = function(r) {
    return "(?=[\\s\\S]+?\\1" + (r ? "\\1" : "") + ")";
}, $d4b2c45ac4fec9db$var$W = "((?:\\[.*?\\][([].*?[)\\]]|<.*?>(?:.*?<.*?>)?|`.*?`|\\\\\\1|[\\s\\S])+?)", $d4b2c45ac4fec9db$var$J = RegExp("^([*_])\\1" + $d4b2c45ac4fec9db$var$Q(1) + $d4b2c45ac4fec9db$var$W + "\\1\\1(?!\\1)"), $d4b2c45ac4fec9db$var$K = RegExp("^([*_])" + $d4b2c45ac4fec9db$var$Q(0) + $d4b2c45ac4fec9db$var$W + "\\1(?!\\1)"), $d4b2c45ac4fec9db$var$X = RegExp("^(==)" + $d4b2c45ac4fec9db$var$Q(0) + $d4b2c45ac4fec9db$var$W + "\\1"), $d4b2c45ac4fec9db$var$Y = RegExp("^(~~)" + $d4b2c45ac4fec9db$var$Q(0) + $d4b2c45ac4fec9db$var$W + "\\1"), $d4b2c45ac4fec9db$var$rr = /^(:[a-zA-Z0-9-_]+:)/, $d4b2c45ac4fec9db$var$nr = /^\\([^0-9A-Za-z\s])/, $d4b2c45ac4fec9db$var$er = /\\([^0-9A-Za-z\s])/g, $d4b2c45ac4fec9db$var$tr = /^[\s\S](?:(?!  \n|[0-9]\.|http)[^=*_~\-\n:<`\\\[!])*/, $d4b2c45ac4fec9db$var$ur = /^\n+/, $d4b2c45ac4fec9db$var$ar = /^([ \t]*)/, $d4b2c45ac4fec9db$var$ir = /(?:^|\n)( *)$/, $d4b2c45ac4fec9db$var$or = "(?:\\d+\\.)", $d4b2c45ac4fec9db$var$cr = "(?:[*+-])";
function $d4b2c45ac4fec9db$var$fr(r) {
    return "( *)(" + (1 === r ? $d4b2c45ac4fec9db$var$or : $d4b2c45ac4fec9db$var$cr) + ") +";
}
var $d4b2c45ac4fec9db$var$lr = $d4b2c45ac4fec9db$var$fr(1), $d4b2c45ac4fec9db$var$_r = $d4b2c45ac4fec9db$var$fr(2);
function $d4b2c45ac4fec9db$var$dr(r) {
    return RegExp("^" + (1 === r ? $d4b2c45ac4fec9db$var$lr : $d4b2c45ac4fec9db$var$_r));
}
var $d4b2c45ac4fec9db$var$sr = $d4b2c45ac4fec9db$var$dr(1), $d4b2c45ac4fec9db$var$vr = $d4b2c45ac4fec9db$var$dr(2);
function $d4b2c45ac4fec9db$var$pr(r) {
    return RegExp("^" + (1 === r ? $d4b2c45ac4fec9db$var$lr : $d4b2c45ac4fec9db$var$_r) + "[^\\n]*(?:\\n(?!\\1" + (1 === r ? $d4b2c45ac4fec9db$var$or : $d4b2c45ac4fec9db$var$cr) + " )[^\\n]*)*(\\n|$)", "gm");
}
var $d4b2c45ac4fec9db$var$yr = $d4b2c45ac4fec9db$var$pr(1), $d4b2c45ac4fec9db$var$hr = $d4b2c45ac4fec9db$var$pr(2);
function $d4b2c45ac4fec9db$var$gr(r) {
    var n = 1 === r ? $d4b2c45ac4fec9db$var$or : $d4b2c45ac4fec9db$var$cr;
    return RegExp("^( *)(" + n + ") [\\s\\S]+?(?:\\n{2,}(?! )(?!\\1" + n + " (?!" + n + " ))\\n*|\\s*\\n*$)");
}
var $d4b2c45ac4fec9db$var$mr = $d4b2c45ac4fec9db$var$gr(1), $d4b2c45ac4fec9db$var$kr = $d4b2c45ac4fec9db$var$gr(2);
function $d4b2c45ac4fec9db$var$xr(r, n) {
    var e = 1 === n, t = e ? $d4b2c45ac4fec9db$var$mr : $d4b2c45ac4fec9db$var$kr, u = e ? $d4b2c45ac4fec9db$var$yr : $d4b2c45ac4fec9db$var$hr, a = e ? $d4b2c45ac4fec9db$var$sr : $d4b2c45ac4fec9db$var$vr;
    return {
        t: function(r) {
            return a.test(r);
        },
        u: $d4b2c45ac4fec9db$var$jr(function(r, n) {
            var e = $d4b2c45ac4fec9db$var$ir.exec(n.prevCapture);
            return e && (n.list || !n.inline && !n.simple) ? t.exec(r = e[1] + r) : null;
        }),
        i: 1,
        o: function(r, n, t) {
            var i = e ? +r[2] : void 0, o = r[0].replace($d4b2c45ac4fec9db$var$f, "\n").match(u), c = !1;
            return {
                items: o.map(function(r, e) {
                    var u = a.exec(r)[0].length, i = RegExp("^ {1," + u + "}", "gm"), f = r.replace(i, "").replace(a, ""), l = e === o.length - 1, _ = -1 !== f.indexOf("\n\n") || l && c;
                    c = _;
                    var d, s = t.inline, v = t.list;
                    t.list = !0, _ ? (t.inline = !1, d = $d4b2c45ac4fec9db$var$zr(f) + "\n\n") : (t.inline = !0, d = $d4b2c45ac4fec9db$var$zr(f));
                    var p = n(d, t);
                    return t.inline = s, t.list = v, p;
                }),
                ordered: e,
                start: i
            };
        },
        l: function(n, e, t) {
            return r(n.ordered ? "ol" : "ul", {
                key: t.key,
                start: "20" === n.type ? n.start : void 0
            }, n.items.map(function(n, u) {
                return r("li", {
                    key: u
                }, e(n, t));
            }));
        }
    };
}
var $d4b2c45ac4fec9db$var$qr = RegExp("^\\[((?:\\[[^\\[\\]]*(?:\\[[^\\[\\]]*\\][^\\[\\]]*)*\\]|[^\\[\\]])*)\\]\\(\\s*<?((?:\\([^)]*\\)|[^\\s\\\\]|\\\\.)*?)>?(?:\\s+['\"]([\\s\\S]*?)['\"])?\\s*\\)"), $d4b2c45ac4fec9db$var$br = /^!\[(.*?)\]\( *((?:\([^)]*\)|[^() ])*) *"?([^)"]*)?"?\)/;
function $d4b2c45ac4fec9db$var$Sr(r) {
    return "string" == typeof r;
}
function $d4b2c45ac4fec9db$var$zr(r) {
    for(var n = r.length; n > 0 && r[n - 1] <= " ";)n--;
    return r.slice(0, n);
}
function $d4b2c45ac4fec9db$var$$r(r, n) {
    return r.startsWith(n);
}
function $d4b2c45ac4fec9db$var$Er(r, n, e) {
    if (Array.isArray(e)) {
        for(var t = 0; t < e.length; t++)if ($d4b2c45ac4fec9db$var$$r(r, e[t])) return !0;
        return !1;
    }
    return e(r, n);
}
function $d4b2c45ac4fec9db$export$c383cdd2a518017a(r) {
    return r.replace(/[ÀÁÂÃÄÅàáâãäåæÆ]/g, "a").replace(/[çÇ]/g, "c").replace(/[ðÐ]/g, "d").replace(/[ÈÉÊËéèêë]/g, "e").replace(/[ÏïÎîÍíÌì]/g, "i").replace(/[Ññ]/g, "n").replace(/[øØœŒÕõÔôÓóÒò]/g, "o").replace(/[ÜüÛûÚúÙù]/g, "u").replace(/[ŸÿÝý]/g, "y").replace(/[^a-z0-9- ]/gi, "").replace(/ /gi, "-").toLowerCase();
}
function $d4b2c45ac4fec9db$var$Rr(r) {
    return $d4b2c45ac4fec9db$var$H.test(r) ? "right" : $d4b2c45ac4fec9db$var$U.test(r) ? "center" : $d4b2c45ac4fec9db$var$V.test(r) ? "left" : null;
}
function $d4b2c45ac4fec9db$var$Br(r, n, e, t) {
    var u = e.inTable;
    e.inTable = !0;
    var a = [
        []
    ], i = "";
    function o() {
        if (i) {
            var r = a[a.length - 1];
            r.push.apply(r, n(i, e)), i = "";
        }
    }
    return r.trim().split(/(`[^`]*`|\\\||\|)/).filter(Boolean).forEach(function(r, n, e) {
        "|" === r.trim() && (o(), t) ? 0 !== n && n !== e.length - 1 && a.push([]) : i += r;
    }), o(), e.inTable = u, a;
}
function $d4b2c45ac4fec9db$var$Lr(r, n, e) {
    e.inline = !0;
    var t = r[2] ? r[2].replace($d4b2c45ac4fec9db$var$G, "").split("|").map($d4b2c45ac4fec9db$var$Rr) : [], u = r[3] ? function(r, n, e) {
        return r.trim().split("\n").map(function(r) {
            return $d4b2c45ac4fec9db$var$Br(r, n, e, !0);
        });
    }(r[3], n, e) : [], a = $d4b2c45ac4fec9db$var$Br(r[1], n, e, !!u.length);
    return e.inline = !1, u.length ? {
        align: t,
        cells: u,
        header: a,
        type: "25"
    } : {
        children: a,
        type: "21"
    };
}
function $d4b2c45ac4fec9db$var$Or(r, n) {
    return null == r.align[n] ? {} : {
        textAlign: r.align[n]
    };
}
function $d4b2c45ac4fec9db$var$jr(r) {
    return r.inline = 1, r;
}
function $d4b2c45ac4fec9db$var$Cr(r) {
    return $d4b2c45ac4fec9db$var$jr(function(n, e) {
        return e.inline ? r.exec(n) : null;
    });
}
function $d4b2c45ac4fec9db$var$Ir(r) {
    return $d4b2c45ac4fec9db$var$jr(function(n, e) {
        return e.inline || e.simple ? r.exec(n) : null;
    });
}
function $d4b2c45ac4fec9db$var$Tr(r) {
    return function(n, e) {
        return e.inline || e.simple ? null : r.exec(n);
    };
}
function $d4b2c45ac4fec9db$var$Mr(r) {
    return $d4b2c45ac4fec9db$var$jr(function(n) {
        return r.exec(n);
    });
}
var $d4b2c45ac4fec9db$var$wr = /(javascript|vbscript|data(?!:image)):/i;
function $d4b2c45ac4fec9db$export$3e2338ea76b578c9(r) {
    try {
        var n = decodeURIComponent(r).replace(/[^A-Za-z0-9/:]/g, "");
        if ($d4b2c45ac4fec9db$var$wr.test(n)) return null;
    } catch (r) {
        return null;
    }
    return r;
}
function $d4b2c45ac4fec9db$var$Fr(r) {
    return r ? r.replace($d4b2c45ac4fec9db$var$er, "$1") : r;
}
function $d4b2c45ac4fec9db$var$Pr(r, n, e) {
    var t = e.inline || !1, u = e.simple || !1;
    e.inline = !0, e.simple = !0;
    var a = r(n, e);
    return e.inline = t, e.simple = u, a;
}
function $d4b2c45ac4fec9db$var$Zr(r, n, e) {
    var t = e.inline || !1, u = e.simple || !1;
    e.inline = !1, e.simple = !0;
    var a = r(n, e);
    return e.inline = t, e.simple = u, a;
}
function $d4b2c45ac4fec9db$var$Nr(r, n, e) {
    var t = e.inline || !1;
    e.inline = !1;
    var u = r(n, e);
    return e.inline = t, u;
}
var $d4b2c45ac4fec9db$var$Gr = function(r, n, e) {
    return {
        children: $d4b2c45ac4fec9db$var$Pr(n, r[2], e)
    };
};
function $d4b2c45ac4fec9db$var$Ur() {
    return {};
}
function $d4b2c45ac4fec9db$var$Vr() {
    return null;
}
function $d4b2c45ac4fec9db$var$Hr() {
    return [].slice.call(arguments).filter(Boolean).join(" ");
}
function $d4b2c45ac4fec9db$var$Qr(r, n, e) {
    for(var t = r, u = n.split("."); u.length && void 0 !== (t = t[u[0]]);)u.shift();
    return t || e;
}
function $d4b2c45ac4fec9db$var$Wr(r, n) {
    var e = $d4b2c45ac4fec9db$var$Qr(n, r);
    return e ? "function" == typeof e || "object" == typeof e && "render" in e ? e : $d4b2c45ac4fec9db$var$Qr(n, r + ".component", r) : r;
}
function $d4b2c45ac4fec9db$export$69f434acfbdb0b32(e, t) {
    var f;
    void 0 === e && (e = ""), void 0 === t && (t = {}), t.overrides = t.overrides || {}, t.namedCodesToUnicode = t.namedCodesToUnicode ? $d4b2c45ac4fec9db$var$n({}, $d4b2c45ac4fec9db$var$a, t.namedCodesToUnicode) : $d4b2c45ac4fec9db$var$a;
    var G = t.slugify || $d4b2c45ac4fec9db$export$c383cdd2a518017a, U = t.sanitizer || $d4b2c45ac4fec9db$export$3e2338ea76b578c9, V = t.createElement || $5FkrB.createElement, H = [
        $d4b2c45ac4fec9db$var$l,
        $d4b2c45ac4fec9db$var$p,
        $d4b2c45ac4fec9db$var$y,
        t.enforceAtxHeadings ? $d4b2c45ac4fec9db$var$$ : $d4b2c45ac4fec9db$var$z,
        $d4b2c45ac4fec9db$var$E,
        $d4b2c45ac4fec9db$var$M,
        $d4b2c45ac4fec9db$var$mr,
        $d4b2c45ac4fec9db$var$kr
    ], Q = [].concat(H, [
        $d4b2c45ac4fec9db$var$w,
        $d4b2c45ac4fec9db$var$A,
        $d4b2c45ac4fec9db$var$B,
        $d4b2c45ac4fec9db$var$O
    ]);
    function W(r, n) {
        for(var e = 0; e < r.length; e++)if (r[e].test(n)) return !0;
        return !1;
    }
    function er(r, e) {
        var u = $d4b2c45ac4fec9db$var$Qr(t.overrides, r + ".props", {});
        return V.apply(void 0, [
            $d4b2c45ac4fec9db$var$Wr(r, t.overrides),
            $d4b2c45ac4fec9db$var$n({}, e, u, {
                className: $d4b2c45ac4fec9db$var$Hr(null == e ? void 0 : e.className, u.className) || void 0
            })
        ].concat([].slice.call(arguments, 2)));
    }
    function ir(r) {
        r = r.replace($d4b2c45ac4fec9db$var$b, "");
        var n = !1;
        t.forceInline ? n = !0 : t.forceBlock || (n = !1 === $d4b2c45ac4fec9db$var$Z.test(r));
        for(var e = dr(_r(n ? r : $d4b2c45ac4fec9db$var$zr(r).replace($d4b2c45ac4fec9db$var$ur, "") + "\n\n", {
            inline: n
        })); $d4b2c45ac4fec9db$var$Sr(e[e.length - 1]) && !e[e.length - 1].trim();)e.pop();
        if (null === t.wrapper) return e;
        var u, a = t.wrapper || (n ? "span" : "div");
        if (e.length > 1 || t.forceWrapper) u = e;
        else {
            if (1 === e.length) return "string" == typeof (u = e[0]) ? er("span", {
                key: "outer"
            }, u) : u;
            u = null;
        }
        return V(a, {
            key: "outer"
        }, u);
    }
    function or(r, n) {
        if (!n || !n.trim()) return null;
        var e = n.match($d4b2c45ac4fec9db$var$c);
        return e ? e.reduce(function(n, e) {
            var t = e.indexOf("=");
            if (-1 !== t) {
                var a = (function(r) {
                    return -1 !== r.indexOf("-") && null === r.match($d4b2c45ac4fec9db$var$L) && (r = r.replace($d4b2c45ac4fec9db$var$T, function(r, n) {
                        return n.toUpperCase();
                    })), r;
                })(e.slice(0, t)).trim(), i = function(r) {
                    var n = r[0];
                    return ('"' === n || "'" === n) && r.length >= 2 && r[r.length - 1] === n ? r.slice(1, -1) : r;
                }(e.slice(t + 1).trim()), c = $d4b2c45ac4fec9db$var$u[a] || a;
                if ("ref" === c) return n;
                var f = n[c] = function(r, n, e, t) {
                    return "style" === n ? (function(r) {
                        var n = [], e = "", t = !1, u = !1, a = "";
                        if (!r) return n;
                        for(var i = 0; i < r.length; i++){
                            var o = r[i];
                            if ('"' !== o && "'" !== o || t || (u ? o === a && (u = !1, a = "") : (u = !0, a = o)), "(" === o && e.endsWith("url") ? t = !0 : ")" === o && t && (t = !1), ";" !== o || u || t) e += o;
                            else {
                                var c = e.trim();
                                if (c) {
                                    var f = c.indexOf(":");
                                    if (f > 0) {
                                        var l = c.slice(0, f).trim(), _ = c.slice(f + 1).trim();
                                        n.push([
                                            l,
                                            _
                                        ]);
                                    }
                                }
                                e = "";
                            }
                        }
                        var d = e.trim();
                        if (d) {
                            var s = d.indexOf(":");
                            if (s > 0) {
                                var v = d.slice(0, s).trim(), p = d.slice(s + 1).trim();
                                n.push([
                                    v,
                                    p
                                ]);
                            }
                        }
                        return n;
                    })(e).reduce(function(n, e) {
                        var u = e[0], a = e[1];
                        return n[u.replace(/(-[a-z])/g, function(r) {
                            return r[1].toUpperCase();
                        })] = t(a, r, u), n;
                    }, {}) : -1 !== $d4b2c45ac4fec9db$var$o.indexOf(n) ? t($d4b2c45ac4fec9db$var$Fr(e), r, n) : (e.match($d4b2c45ac4fec9db$var$j) && (e = $d4b2c45ac4fec9db$var$Fr(e.slice(1, e.length - 1))), "true" === e || "false" !== e && e);
                }(r, a, i, U);
                "string" == typeof f && ($d4b2c45ac4fec9db$var$A.test(f) || $d4b2c45ac4fec9db$var$O.test(f)) && (n[c] = ir(f.trim()));
            } else "style" !== e && (n[$d4b2c45ac4fec9db$var$u[e] || e] = !0);
            return n;
        }, {}) : null;
    }
    var cr = [], fr = {}, lr = ((f = {})[0] = {
        t: [
            ">"
        ],
        u: $d4b2c45ac4fec9db$var$Tr($d4b2c45ac4fec9db$var$l),
        i: 1,
        o: function(r, n, e) {
            var t = r[0].replace($d4b2c45ac4fec9db$var$_, "").match($d4b2c45ac4fec9db$var$d);
            return {
                alert: t[1],
                children: n(t[2], e)
            };
        },
        l: function(r, n, e) {
            var t = {
                key: e.key
            };
            return r.alert && (t.className = "markdown-alert-" + G(r.alert.toLowerCase(), $d4b2c45ac4fec9db$export$c383cdd2a518017a), r.children.unshift({
                attrs: {},
                children: [
                    {
                        type: "27",
                        text: r.alert
                    }
                ],
                noInnerParse: !0,
                type: "11",
                tag: "header"
            })), er("blockquote", t, n(r.children, e));
        }
    }, f[1] = {
        t: [
            "  "
        ],
        u: $d4b2c45ac4fec9db$var$Mr($d4b2c45ac4fec9db$var$s),
        i: 1,
        o: $d4b2c45ac4fec9db$var$Ur,
        l: function(r, n, e) {
            return er("br", {
                key: e.key
            });
        }
    }, f[2] = {
        t: [
            "--",
            "__",
            "**",
            "- ",
            "* ",
            "_ "
        ],
        u: $d4b2c45ac4fec9db$var$Tr($d4b2c45ac4fec9db$var$v),
        i: 1,
        o: $d4b2c45ac4fec9db$var$Ur,
        l: function(r, n, e) {
            return er("hr", {
                key: e.key
            });
        }
    }, f[3] = {
        t: [
            "    "
        ],
        u: $d4b2c45ac4fec9db$var$Tr($d4b2c45ac4fec9db$var$y),
        i: 0,
        o: function(r) {
            return {
                lang: void 0,
                text: $d4b2c45ac4fec9db$var$Fr($d4b2c45ac4fec9db$var$zr(r[0].replace(/^ {4}/gm, "")))
            };
        },
        l: function(r, e, t) {
            return er("pre", {
                key: t.key
            }, er("code", $d4b2c45ac4fec9db$var$n({}, r.attrs, {
                className: r.lang ? "lang-" + r.lang : ""
            }), r.text));
        }
    }, f[4] = {
        t: [
            "```",
            "~~~"
        ],
        u: $d4b2c45ac4fec9db$var$Tr($d4b2c45ac4fec9db$var$p),
        i: 0,
        o: function(r) {
            return {
                attrs: or("code", r[3] || ""),
                lang: r[2] || void 0,
                text: r[4],
                type: "3"
            };
        }
    }, f[5] = {
        t: [
            "`"
        ],
        u: $d4b2c45ac4fec9db$var$Ir($d4b2c45ac4fec9db$var$h),
        i: 3,
        o: function(r) {
            return {
                text: $d4b2c45ac4fec9db$var$Fr(r[2])
            };
        },
        l: function(r, n, e) {
            return er("code", {
                key: e.key
            }, r.text);
        }
    }, f[6] = {
        t: [
            "[^"
        ],
        u: $d4b2c45ac4fec9db$var$Tr($d4b2c45ac4fec9db$var$k),
        i: 0,
        o: function(r) {
            return cr.push({
                footnote: r[2],
                identifier: r[1]
            }), {};
        },
        l: $d4b2c45ac4fec9db$var$Vr
    }, f[7] = {
        t: [
            "[^"
        ],
        u: $d4b2c45ac4fec9db$var$Cr($d4b2c45ac4fec9db$var$x),
        i: 1,
        o: function(r) {
            return {
                target: "#" + G(r[1], $d4b2c45ac4fec9db$export$c383cdd2a518017a),
                text: r[1]
            };
        },
        l: function(r, n, e) {
            return er("a", {
                key: e.key,
                href: U(r.target, "a", "href")
            }, er("sup", {
                key: e.key
            }, r.text));
        }
    }, f[8] = {
        t: [
            "[ ]",
            "[x]"
        ],
        u: $d4b2c45ac4fec9db$var$Cr($d4b2c45ac4fec9db$var$S),
        i: 1,
        o: function(r) {
            return {
                completed: "x" === r[1].toLowerCase()
            };
        },
        l: function(r, n, e) {
            return er("input", {
                checked: r.completed,
                key: e.key,
                readOnly: !0,
                type: "checkbox"
            });
        }
    }, f[9] = {
        t: [
            "#"
        ],
        u: $d4b2c45ac4fec9db$var$Tr(t.enforceAtxHeadings ? $d4b2c45ac4fec9db$var$$ : $d4b2c45ac4fec9db$var$z),
        i: 1,
        o: function(r, n, e) {
            return {
                children: $d4b2c45ac4fec9db$var$Pr(n, r[2], e),
                id: G(r[2], $d4b2c45ac4fec9db$export$c383cdd2a518017a),
                level: r[1].length
            };
        },
        l: function(r, n, e) {
            return er("h" + r.level, {
                id: r.id,
                key: e.key
            }, n(r.children, e));
        }
    }, f[10] = {
        t: function(r) {
            var n = r.indexOf("\n");
            return n > 0 && n < r.length - 1 && ("=" === r[n + 1] || "-" === r[n + 1]);
        },
        u: $d4b2c45ac4fec9db$var$Tr($d4b2c45ac4fec9db$var$E),
        i: 1,
        o: function(r, n, e) {
            return {
                children: $d4b2c45ac4fec9db$var$Pr(n, r[1], e),
                level: "=" === r[2] ? 1 : 2,
                type: "9"
            };
        }
    }, f[11] = {
        t: [
            "<"
        ],
        u: $d4b2c45ac4fec9db$var$Mr($d4b2c45ac4fec9db$var$A),
        i: 1,
        o: function(r, n, e) {
            var t = r[3].match($d4b2c45ac4fec9db$var$ar), u = RegExp("^" + t[1], "gm"), a = r[3].replace(u, ""), o = W(Q, a) ? $d4b2c45ac4fec9db$var$Nr : $d4b2c45ac4fec9db$var$Pr, c = r[1].toLowerCase(), f = -1 !== $d4b2c45ac4fec9db$var$i.indexOf(c), l = (f ? c : r[1]).trim(), _ = {
                attrs: or(l, r[2]),
                noInnerParse: f,
                tag: l
            };
            if (e.inAnchor = e.inAnchor || "a" === c, f) _.text = r[3];
            else {
                var d = e.inHTML;
                e.inHTML = !0, _.children = o(n, a, e), e.inHTML = d;
            }
            return e.inAnchor = !1, _;
        },
        l: function(r, e, t) {
            return er(r.tag, $d4b2c45ac4fec9db$var$n({
                key: t.key
            }, r.attrs), r.text || (r.children ? e(r.children, t) : ""));
        }
    }, f[13] = {
        t: [
            "<"
        ],
        u: $d4b2c45ac4fec9db$var$Mr($d4b2c45ac4fec9db$var$O),
        i: 1,
        o: function(r) {
            var n = r[1].trim();
            return {
                attrs: or(n, r[2] || ""),
                tag: n
            };
        },
        l: function(r, e, t) {
            return er(r.tag, $d4b2c45ac4fec9db$var$n({}, r.attrs, {
                key: t.key
            }));
        }
    }, f[12] = {
        t: [
            "\x3c!--"
        ],
        u: $d4b2c45ac4fec9db$var$Mr($d4b2c45ac4fec9db$var$B),
        i: 1,
        o: function() {
            return {};
        },
        l: $d4b2c45ac4fec9db$var$Vr
    }, f[14] = {
        t: [
            "!["
        ],
        u: $d4b2c45ac4fec9db$var$Ir($d4b2c45ac4fec9db$var$br),
        i: 1,
        o: function(r) {
            return {
                alt: $d4b2c45ac4fec9db$var$Fr(r[1]),
                target: $d4b2c45ac4fec9db$var$Fr(r[2]),
                title: $d4b2c45ac4fec9db$var$Fr(r[3])
            };
        },
        l: function(r, n, e) {
            return er("img", {
                key: e.key,
                alt: r.alt || void 0,
                title: r.title || void 0,
                src: U(r.target, "img", "src")
            });
        }
    }, f[15] = {
        t: [
            "["
        ],
        u: $d4b2c45ac4fec9db$var$Cr($d4b2c45ac4fec9db$var$qr),
        i: 3,
        o: function(r, n, e) {
            return {
                children: $d4b2c45ac4fec9db$var$Zr(n, r[1], e),
                target: $d4b2c45ac4fec9db$var$Fr(r[2]),
                title: $d4b2c45ac4fec9db$var$Fr(r[3])
            };
        },
        l: function(r, n, e) {
            return er("a", {
                key: e.key,
                href: U(r.target, "a", "href"),
                title: r.title
            }, n(r.children, e));
        }
    }, f[16] = {
        t: [
            "<"
        ],
        u: $d4b2c45ac4fec9db$var$Cr($d4b2c45ac4fec9db$var$I),
        i: 0,
        o: function(r) {
            var n = r[1], e = !1;
            return -1 !== n.indexOf("@") && -1 === n.indexOf("//") && (e = !0, n = n.replace("mailto:", "")), {
                children: [
                    {
                        text: n,
                        type: "27"
                    }
                ],
                target: e ? "mailto:" + n : n,
                type: "15"
            };
        }
    }, f[17] = {
        t: function(r, n) {
            return !n.inAnchor && !t.disableAutoLink && ($d4b2c45ac4fec9db$var$$r(r, "http://") || $d4b2c45ac4fec9db$var$$r(r, "https://"));
        },
        u: $d4b2c45ac4fec9db$var$Cr($d4b2c45ac4fec9db$var$C),
        i: 0,
        o: function(r) {
            return {
                children: [
                    {
                        text: r[1],
                        type: "27"
                    }
                ],
                target: r[1],
                title: void 0,
                type: "15"
            };
        }
    }, f[20] = $d4b2c45ac4fec9db$var$xr(er, 1), f[33] = $d4b2c45ac4fec9db$var$xr(er, 2), f[19] = {
        t: [
            "\n"
        ],
        u: $d4b2c45ac4fec9db$var$Tr($d4b2c45ac4fec9db$var$g),
        i: 3,
        o: $d4b2c45ac4fec9db$var$Ur,
        l: function() {
            return "\n";
        }
    }, f[21] = {
        u: $d4b2c45ac4fec9db$var$jr(function(r, n) {
            if (n.inline || n.simple || n.inHTML && -1 === r.indexOf("\n\n") && -1 === n.prevCapture.indexOf("\n\n")) return null;
            for(var e = "", t = 0;;){
                var u = r.indexOf("\n", t), a = r.slice(t, -1 === u ? void 0 : u + 1);
                if (W(H, a)) break;
                if (e += a, -1 === u || !a.trim()) break;
                t = u + 1;
            }
            var i = $d4b2c45ac4fec9db$var$zr(e);
            return "" === i ? null : [
                e,
                ,
                i
            ];
        }),
        i: 3,
        o: $d4b2c45ac4fec9db$var$Gr,
        l: function(r, n, e) {
            return er("p", {
                key: e.key
            }, n(r.children, e));
        }
    }, f[22] = {
        t: [
            "["
        ],
        u: $d4b2c45ac4fec9db$var$Cr($d4b2c45ac4fec9db$var$D),
        i: 0,
        o: function(r) {
            return fr[r[1]] = {
                target: r[2],
                title: r[4]
            }, {};
        },
        l: $d4b2c45ac4fec9db$var$Vr
    }, f[23] = {
        t: [
            "!["
        ],
        u: $d4b2c45ac4fec9db$var$Ir($d4b2c45ac4fec9db$var$F),
        i: 0,
        o: function(r) {
            return {
                alt: r[1] ? $d4b2c45ac4fec9db$var$Fr(r[1]) : void 0,
                ref: r[2]
            };
        },
        l: function(r, n, e) {
            return fr[r.ref] ? er("img", {
                key: e.key,
                alt: r.alt,
                src: U(fr[r.ref].target, "img", "src"),
                title: fr[r.ref].title
            }) : null;
        }
    }, f[24] = {
        t: function(r) {
            return "[" === r[0] && -1 === r.indexOf("](");
        },
        u: $d4b2c45ac4fec9db$var$Cr($d4b2c45ac4fec9db$var$P),
        i: 0,
        o: function(r, n, e) {
            return {
                children: n(r[1], e),
                fallbackChildren: r[0],
                ref: r[2]
            };
        },
        l: function(r, n, e) {
            return fr[r.ref] ? er("a", {
                key: e.key,
                href: U(fr[r.ref].target, "a", "href"),
                title: fr[r.ref].title
            }, n(r.children, e)) : er("span", {
                key: e.key
            }, r.fallbackChildren);
        }
    }, f[25] = {
        t: [
            "|"
        ],
        u: $d4b2c45ac4fec9db$var$Tr($d4b2c45ac4fec9db$var$M),
        i: 1,
        o: $d4b2c45ac4fec9db$var$Lr,
        l: function(r, n, e) {
            var t = r;
            return er("table", {
                key: e.key
            }, er("thead", null, er("tr", null, t.header.map(function(r, u) {
                return er("th", {
                    key: u,
                    style: $d4b2c45ac4fec9db$var$Or(t, u)
                }, n(r, e));
            }))), er("tbody", null, t.cells.map(function(r, u) {
                return er("tr", {
                    key: u
                }, r.map(function(r, u) {
                    return er("td", {
                        key: u,
                        style: $d4b2c45ac4fec9db$var$Or(t, u)
                    }, n(r, e));
                }));
            })));
        }
    }, f[27] = {
        u: $d4b2c45ac4fec9db$var$jr(function(r, n) {
            var e;
            return $d4b2c45ac4fec9db$var$$r(r, ":") && (e = $d4b2c45ac4fec9db$var$rr.exec(r)), e || $d4b2c45ac4fec9db$var$tr.exec(r);
        }),
        i: 4,
        o: function(r) {
            var n = r[0];
            return {
                text: -1 === n.indexOf("&") ? n : n.replace($d4b2c45ac4fec9db$var$R, function(r, n) {
                    return t.namedCodesToUnicode[n] || r;
                })
            };
        },
        l: function(r) {
            return r.text;
        }
    }, f[28] = {
        t: [
            "**",
            "__"
        ],
        u: $d4b2c45ac4fec9db$var$Ir($d4b2c45ac4fec9db$var$J),
        i: 2,
        o: function(r, n, e) {
            return {
                children: n(r[2], e)
            };
        },
        l: function(r, n, e) {
            return er("strong", {
                key: e.key
            }, n(r.children, e));
        }
    }, f[29] = {
        t: function(r) {
            var n = r[0];
            return ("*" === n || "_" === n) && r[1] !== n;
        },
        u: $d4b2c45ac4fec9db$var$Ir($d4b2c45ac4fec9db$var$K),
        i: 3,
        o: function(r, n, e) {
            return {
                children: n(r[2], e)
            };
        },
        l: function(r, n, e) {
            return er("em", {
                key: e.key
            }, n(r.children, e));
        }
    }, f[30] = {
        t: [
            "\\"
        ],
        u: $d4b2c45ac4fec9db$var$Ir($d4b2c45ac4fec9db$var$nr),
        i: 1,
        o: function(r) {
            return {
                text: r[1],
                type: "27"
            };
        }
    }, f[31] = {
        t: [
            "=="
        ],
        u: $d4b2c45ac4fec9db$var$Ir($d4b2c45ac4fec9db$var$X),
        i: 3,
        o: $d4b2c45ac4fec9db$var$Gr,
        l: function(r, n, e) {
            return er("mark", {
                key: e.key
            }, n(r.children, e));
        }
    }, f[32] = {
        t: [
            "~~"
        ],
        u: $d4b2c45ac4fec9db$var$Ir($d4b2c45ac4fec9db$var$Y),
        i: 3,
        o: $d4b2c45ac4fec9db$var$Gr,
        l: function(r, n, e) {
            return er("del", {
                key: e.key
            }, n(r.children, e));
        }
    }, f);
    !0 === t.disableParsingRawHTML && (delete lr[11], delete lr[13]);
    var _r = function(r) {
        var n = Object.keys(r);
        function e(t, u) {
            var a = [];
            if (u.prevCapture = u.prevCapture || "", t.trim()) for(; t;)for(var i = 0; i < n.length;){
                var o = n[i], c = r[o];
                if (!c.t || $d4b2c45ac4fec9db$var$Er(t, u, c.t)) {
                    var f = c.u(t, u);
                    if (f && f[0]) {
                        t = t.substring(f[0].length);
                        var l = c.o(f, e, u);
                        u.prevCapture += f[0], l.type || (l.type = o), a.push(l);
                        break;
                    }
                    i++;
                } else i++;
            }
            return u.prevCapture = "", a;
        }
        return n.sort(function(n, e) {
            return r[n].i - r[e].i || (n < e ? -1 : 1);
        }), function(r, n) {
            return e(function(r) {
                return r.replace($d4b2c45ac4fec9db$var$m, "\n").replace($d4b2c45ac4fec9db$var$q, "").replace($d4b2c45ac4fec9db$var$N, "    ");
            }(r), n);
        };
    }(lr), dr = function(r, n) {
        return function e(t, u) {
            if (void 0 === u && (u = {}), Array.isArray(t)) {
                for(var a = u.key, i = [], o = !1, c = 0; c < t.length; c++){
                    u.key = c;
                    var f = e(t[c], u), l = $d4b2c45ac4fec9db$var$Sr(f);
                    l && o ? i[i.length - 1] += f : null !== f && i.push(f), o = l;
                }
                return u.key = a, i;
            }
            return function(e, t, u) {
                var a = r[e.type].l;
                return n ? n(function() {
                    return a(e, t, u);
                }, e, t, u) : a(e, t, u);
            }(t, e, u);
        };
    }(lr, t.renderRule), sr = ir(e);
    return cr.length ? er("div", null, sr, er("footer", {
        key: "footer"
    }, cr.map(function(r) {
        return er("div", {
            id: G(r.identifier, $d4b2c45ac4fec9db$export$c383cdd2a518017a),
            key: r.identifier
        }, r.identifier, dr(_r(r.footnote, {
            inline: !0
        })));
    }))) : sr;
}
function $d4b2c45ac4fec9db$export$2e2bcd8739ae039(n) {
    var t = n.children, u = n.options, a = function(r, n) {
        if (null == r) return {};
        var e, t, u = {}, a = Object.keys(r);
        for(t = 0; t < a.length; t++)n.indexOf(e = a[t]) >= 0 || (u[e] = r[e]);
        return u;
    }(n, $d4b2c45ac4fec9db$var$e);
    return $5FkrB.cloneElement($d4b2c45ac4fec9db$export$69f434acfbdb0b32(null == t ? "" : t, u), a);
}

});

parcelRegister("dujqE", function(module, exports) {
function $9d1d25da55f1f0c6$var$_readOnlyError(r) {
    throw new TypeError('"' + r + '" is read-only');
}
module.exports = $9d1d25da55f1f0c6$var$_readOnlyError, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("dJ32z", function(module, exports) {
$parcel$export(module.exports, "isSafari", () => $9fe1d61f676e91d7$export$95df08bae54cb4df);
$parcel$export(module.exports, "isAppleDevice", () => $9fe1d61f676e91d7$export$e1865c3bedcd822b);
function $9fe1d61f676e91d7$var$testPlatform(re) {
    var _userAgentData;
    return typeof window !== 'undefined' && window.navigator != null ? re.test(((_userAgentData = window.navigator['userAgentData']) === null || _userAgentData === void 0 ? void 0 : _userAgentData.platform) || window.navigator.platform) : false;
}
function $9fe1d61f676e91d7$var$isIPhone() {
    return $9fe1d61f676e91d7$var$testPlatform(/^iPhone/i);
}
function $9fe1d61f676e91d7$var$isMac() {
    return $9fe1d61f676e91d7$var$testPlatform(/^Mac/i);
}
function $9fe1d61f676e91d7$var$isIPad() {
    return $9fe1d61f676e91d7$var$testPlatform(/^iPad/i) || // iPadOS 13 lies and says it's a Mac, but we can distinguish by detecting touch support.
    $9fe1d61f676e91d7$var$isMac() && navigator.maxTouchPoints > 1;
}
function $9fe1d61f676e91d7$var$isIOS() {
    return $9fe1d61f676e91d7$var$isIPhone() || $9fe1d61f676e91d7$var$isIPad();
}
function $9fe1d61f676e91d7$export$95df08bae54cb4df() {
    if (typeof window !== 'undefined' && window.navigator != null) {
        var _window$navigator$use;
        var ua = (_window$navigator$use = window.navigator.userAgent) === null || _window$navigator$use === void 0 ? void 0 : _window$navigator$use.toLowerCase();
        return ua ? ua.includes('safari') && !ua.includes('chrome') : false;
    }
    return false;
}
function $9fe1d61f676e91d7$export$e1865c3bedcd822b() {
    return $9fe1d61f676e91d7$var$isMac() || $9fe1d61f676e91d7$var$isIOS();
}

});

parcelRegister("k8BjC", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => (parcelRequire("1hAE6")).default);
$parcel$export(module.exports, "Icon", () => (parcelRequire("1hAE6")).Icon);

var $1hAE6 = parcelRequire("1hAE6");

});
parcelRegister("1hAE6", function(module, exports) {
$parcel$export(module.exports, "Icon", () => $0ef3ce11fb651b22$export$f04a61298a47a40f);
$parcel$export(module.exports, "default", () => $0ef3ce11fb651b22$export$2e2bcd8739ae039);
/* icon-new.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");
/**
 * We are hiding this props from consumers as it's reserved
 * for use by Icon Tile.
 */ var $0ef3ce11fb651b22$var$svgStyles = null;
var $0ef3ce11fb651b22$var$iconStyles = null;
var $0ef3ce11fb651b22$var$smallIconStyles = null;
var $0ef3ce11fb651b22$var$scaleStyles = null;
/**
 * For windows high contrast mode
 */ var $0ef3ce11fb651b22$var$baseHcmStyles = null;
var $0ef3ce11fb651b22$var$scaleSize = null;
var $0ef3ce11fb651b22$var$coreSizeMedium = {
    none: "_1bsbpxbi _4t3ipxbi",
    compact: "_1bsb1ejb _4t3i1ejb",
    spacious: "_1bsb1ejb _4t3i1ejb"
};
var $0ef3ce11fb651b22$var$coreSizeSmall = {
    none: "_1bsbutpp _4t3iutpp",
    compact: "_1bsbpxbi _4t3ipxbi",
    spacious: "_1bsb1ejb _4t3i1ejb"
};
var $0ef3ce11fb651b22$var$paddingMap = {
    medium: {
        none: 0,
        compact: 4,
        spacious: 4
    },
    small: {
        none: 0,
        compact: 2.66,
        spacious: 8
    }
};
var $0ef3ce11fb651b22$export$f04a61298a47a40f = /*#__PURE__*/ (0, $5FkrB.memo)(function Icon(props) {
    var _ref = props, _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, testId = _ref.testId, label = _ref.label, dangerouslySetGlyph = _ref.dangerouslySetGlyph, shouldScale = _ref.shouldScale, _ref$spacing = _ref.spacing, spacing = _ref$spacing === void 0 ? 'none' : _ref$spacing, name = _ref.name;
    var dangerouslySetInnerHTML = dangerouslySetGlyph ? {
        __html: dangerouslySetGlyph
    } : undefined;
    var size = 'medium';
    if ('size' in props && props.size !== undefined) {
        if (typeof props.size === 'string') size = props.size === 'small' || props.size === 'medium' ? props.size : size;
        else if (name) {
            var newSize = props.size(name);
            size = newSize === 'small' || newSize === 'medium' ? newSize : size;
        }
    }
    var baseSize = 16;
    var viewBoxPadding = $0ef3ce11fb651b22$var$paddingMap[size][spacing];
    var viewBoxSize = baseSize + 2 * viewBoxPadding;
    return /*#__PURE__*/ $5FkrB.createElement("span", {
        "data-testid": testId,
        role: label ? 'img' : undefined,
        "aria-label": label ? label : undefined,
        "aria-hidden": label ? undefined : true,
        style: {
            color: color
        },
        className: (0, $970q7.default)([
            "_1e0c1o8l _vchhusvi _1o9zidpf _vwz4kb7n _y4ti1igz _bozg1mb9",
            "_12va1onz _jcxd1r8n",
            shouldScale && "_1bsb1kw7 _4t3i1kw7",
            size === 'small' && "_vwz4utpp"
        ])
    }, /*#__PURE__*/ $5FkrB.createElement("svg", {
        fill: "none",
        viewBox: "".concat(0 - viewBoxPadding, " ").concat(0 - viewBoxPadding, " ").concat(viewBoxSize, " ").concat(viewBoxSize),
        role: "presentation",
        dangerouslySetInnerHTML: dangerouslySetInnerHTML,
        className: (0, $970q7.default)([
            "_1reo15vq _18m915vq _syaz1r31 _lcxvglyw _s7n4yfq0 _vc881r31",
            shouldScale ? "_1bsb1kw7 _4t3i1kw7" : size === 'small' ? $0ef3ce11fb651b22$var$coreSizeSmall[spacing] : $0ef3ce11fb651b22$var$coreSizeMedium[spacing]
        ])
    }));
});
var $0ef3ce11fb651b22$export$2e2bcd8739ae039 = $0ef3ce11fb651b22$export$f04a61298a47a40f;

});


parcelRegister("6I9SI", function(module, exports) {
$parcel$export(module.exports, "autoUpdate", () => $4e2e846094f3694a$export$deee3a793edee05f);

var $4qENO = parcelRequire("4qENO");
var $jUtdR = parcelRequire("jUtdR");

var $jUtdR = parcelRequire("jUtdR");

var $lCfwu = parcelRequire("lCfwu");
function $4e2e846094f3694a$var$getCssDimensions(element) {
    const css = (0, $lCfwu.getComputedStyle)(element);
    // In testing environments, the `width` and `height` properties are empty
    // strings for SVG elements, returning NaN. Fallback to `0` in this case.
    let width = parseFloat(css.width) || 0;
    let height = parseFloat(css.height) || 0;
    const hasOffset = (0, $lCfwu.isHTMLElement)(element);
    const offsetWidth = hasOffset ? element.offsetWidth : width;
    const offsetHeight = hasOffset ? element.offsetHeight : height;
    const shouldFallback = (0, $jUtdR.round)(width) !== offsetWidth || (0, $jUtdR.round)(height) !== offsetHeight;
    if (shouldFallback) {
        width = offsetWidth;
        height = offsetHeight;
    }
    return {
        width: width,
        height: height,
        $: shouldFallback
    };
}
function $4e2e846094f3694a$var$unwrapElement(element) {
    return !(0, $lCfwu.isElement)(element) ? element.contextElement : element;
}
function $4e2e846094f3694a$var$getScale(element) {
    const domElement = $4e2e846094f3694a$var$unwrapElement(element);
    if (!(0, $lCfwu.isHTMLElement)(domElement)) return (0, $jUtdR.createCoords)(1);
    const rect = domElement.getBoundingClientRect();
    const { width: width, height: height, $: $ } = $4e2e846094f3694a$var$getCssDimensions(domElement);
    let x = ($ ? (0, $jUtdR.round)(rect.width) : rect.width) / width;
    let y = ($ ? (0, $jUtdR.round)(rect.height) : rect.height) / height;
    // 0, NaN, or Infinity should always fallback to 1.
    if (!x || !Number.isFinite(x)) x = 1;
    if (!y || !Number.isFinite(y)) y = 1;
    return {
        x: x,
        y: y
    };
}
const $4e2e846094f3694a$var$noOffsets = /*#__PURE__*/ (0, $jUtdR.createCoords)(0);
function $4e2e846094f3694a$var$getVisualOffsets(element) {
    const win = (0, $lCfwu.getWindow)(element);
    if (!(0, $lCfwu.isWebKit)() || !win.visualViewport) return $4e2e846094f3694a$var$noOffsets;
    return {
        x: win.visualViewport.offsetLeft,
        y: win.visualViewport.offsetTop
    };
}
function $4e2e846094f3694a$var$shouldAddVisualOffsets(element, isFixed, floatingOffsetParent) {
    if (isFixed === void 0) isFixed = false;
    if (!floatingOffsetParent || isFixed && floatingOffsetParent !== (0, $lCfwu.getWindow)(element)) return false;
    return isFixed;
}
function $4e2e846094f3694a$var$getBoundingClientRect(element, includeScale, isFixedStrategy, offsetParent) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    const clientRect = element.getBoundingClientRect();
    const domElement = $4e2e846094f3694a$var$unwrapElement(element);
    let scale = (0, $jUtdR.createCoords)(1);
    if (includeScale) {
        if (offsetParent) {
            if ((0, $lCfwu.isElement)(offsetParent)) scale = $4e2e846094f3694a$var$getScale(offsetParent);
        } else scale = $4e2e846094f3694a$var$getScale(element);
    }
    const visualOffsets = $4e2e846094f3694a$var$shouldAddVisualOffsets(domElement, isFixedStrategy, offsetParent) ? $4e2e846094f3694a$var$getVisualOffsets(domElement) : (0, $jUtdR.createCoords)(0);
    let x = (clientRect.left + visualOffsets.x) / scale.x;
    let y = (clientRect.top + visualOffsets.y) / scale.y;
    let width = clientRect.width / scale.x;
    let height = clientRect.height / scale.y;
    if (domElement) {
        const win = (0, $lCfwu.getWindow)(domElement);
        const offsetWin = offsetParent && (0, $lCfwu.isElement)(offsetParent) ? (0, $lCfwu.getWindow)(offsetParent) : offsetParent;
        let currentWin = win;
        let currentIFrame = (0, $lCfwu.getFrameElement)(currentWin);
        while(currentIFrame && offsetParent && offsetWin !== currentWin){
            const iframeScale = $4e2e846094f3694a$var$getScale(currentIFrame);
            const iframeRect = currentIFrame.getBoundingClientRect();
            const css = (0, $lCfwu.getComputedStyle)(currentIFrame);
            const left = iframeRect.left + (currentIFrame.clientLeft + parseFloat(css.paddingLeft)) * iframeScale.x;
            const top = iframeRect.top + (currentIFrame.clientTop + parseFloat(css.paddingTop)) * iframeScale.y;
            x *= iframeScale.x;
            y *= iframeScale.y;
            width *= iframeScale.x;
            height *= iframeScale.y;
            x += left;
            y += top;
            currentWin = (0, $lCfwu.getWindow)(currentIFrame);
            currentIFrame = (0, $lCfwu.getFrameElement)(currentWin);
        }
    }
    return (0, $jUtdR.rectToClientRect)({
        width: width,
        height: height,
        x: x,
        y: y
    });
}
// If <html> has a CSS width greater than the viewport, then this will be
// incorrect for RTL.
function $4e2e846094f3694a$var$getWindowScrollBarX(element, rect) {
    const leftScroll = (0, $lCfwu.getNodeScroll)(element).scrollLeft;
    if (!rect) return $4e2e846094f3694a$var$getBoundingClientRect((0, $lCfwu.getDocumentElement)(element)).left + leftScroll;
    return rect.left + leftScroll;
}
function $4e2e846094f3694a$var$getHTMLOffset(documentElement, scroll) {
    const htmlRect = documentElement.getBoundingClientRect();
    const x = htmlRect.left + scroll.scrollLeft - $4e2e846094f3694a$var$getWindowScrollBarX(documentElement, htmlRect);
    const y = htmlRect.top + scroll.scrollTop;
    return {
        x: x,
        y: y
    };
}
function $4e2e846094f3694a$var$convertOffsetParentRelativeRectToViewportRelativeRect(_ref) {
    let { elements: elements, rect: rect, offsetParent: offsetParent, strategy: strategy } = _ref;
    const isFixed = strategy === 'fixed';
    const documentElement = (0, $lCfwu.getDocumentElement)(offsetParent);
    const topLayer = elements ? (0, $lCfwu.isTopLayer)(elements.floating) : false;
    if (offsetParent === documentElement || topLayer && isFixed) return rect;
    let scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    let scale = (0, $jUtdR.createCoords)(1);
    const offsets = (0, $jUtdR.createCoords)(0);
    const isOffsetParentAnElement = (0, $lCfwu.isHTMLElement)(offsetParent);
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $lCfwu.getNodeName)(offsetParent) !== 'body' || (0, $lCfwu.isOverflowElement)(documentElement)) scroll = (0, $lCfwu.getNodeScroll)(offsetParent);
        if ((0, $lCfwu.isHTMLElement)(offsetParent)) {
            const offsetRect = $4e2e846094f3694a$var$getBoundingClientRect(offsetParent);
            scale = $4e2e846094f3694a$var$getScale(offsetParent);
            offsets.x = offsetRect.x + offsetParent.clientLeft;
            offsets.y = offsetRect.y + offsetParent.clientTop;
        }
    }
    const htmlOffset = documentElement && !isOffsetParentAnElement && !isFixed ? $4e2e846094f3694a$var$getHTMLOffset(documentElement, scroll) : (0, $jUtdR.createCoords)(0);
    return {
        width: rect.width * scale.x,
        height: rect.height * scale.y,
        x: rect.x * scale.x - scroll.scrollLeft * scale.x + offsets.x + htmlOffset.x,
        y: rect.y * scale.y - scroll.scrollTop * scale.y + offsets.y + htmlOffset.y
    };
}
function $4e2e846094f3694a$var$getClientRects(element) {
    return Array.from(element.getClientRects());
}
// Gets the entire size of the scrollable document area, even extending outside
// of the `<html>` and `<body>` rect bounds if horizontally scrollable.
function $4e2e846094f3694a$var$getDocumentRect(element) {
    const html = (0, $lCfwu.getDocumentElement)(element);
    const scroll = (0, $lCfwu.getNodeScroll)(element);
    const body = element.ownerDocument.body;
    const width = (0, $jUtdR.max)(html.scrollWidth, html.clientWidth, body.scrollWidth, body.clientWidth);
    const height = (0, $jUtdR.max)(html.scrollHeight, html.clientHeight, body.scrollHeight, body.clientHeight);
    let x = -scroll.scrollLeft + $4e2e846094f3694a$var$getWindowScrollBarX(element);
    const y = -scroll.scrollTop;
    if ((0, $lCfwu.getComputedStyle)(body).direction === 'rtl') x += (0, $jUtdR.max)(html.clientWidth, body.clientWidth) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
// Safety check: ensure the scrollbar space is reasonable in case this
// calculation is affected by unusual styles.
// Most scrollbars leave 15-18px of space.
const $4e2e846094f3694a$var$SCROLLBAR_MAX = 25;
function $4e2e846094f3694a$var$getViewportRect(element, strategy) {
    const win = (0, $lCfwu.getWindow)(element);
    const html = (0, $lCfwu.getDocumentElement)(element);
    const visualViewport = win.visualViewport;
    let width = html.clientWidth;
    let height = html.clientHeight;
    let x = 0;
    let y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        const visualViewportBased = (0, $lCfwu.isWebKit)();
        if (!visualViewportBased || visualViewportBased && strategy === 'fixed') {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    const windowScrollbarX = $4e2e846094f3694a$var$getWindowScrollBarX(html);
    // <html> `overflow: hidden` + `scrollbar-gutter: stable` reduces the
    // visual width of the <html> but this is not considered in the size
    // of `html.clientWidth`.
    if (windowScrollbarX <= 0) {
        const doc = html.ownerDocument;
        const body = doc.body;
        const bodyStyles = getComputedStyle(body);
        const bodyMarginInline = doc.compatMode === 'CSS1Compat' ? parseFloat(bodyStyles.marginLeft) + parseFloat(bodyStyles.marginRight) || 0 : 0;
        const clippingStableScrollbarWidth = Math.abs(html.clientWidth - body.clientWidth - bodyMarginInline);
        if (clippingStableScrollbarWidth <= $4e2e846094f3694a$var$SCROLLBAR_MAX) width -= clippingStableScrollbarWidth;
    } else if (windowScrollbarX <= $4e2e846094f3694a$var$SCROLLBAR_MAX) // If the <body> scrollbar is on the left, the width needs to be extended
    // by the scrollbar amount so there isn't extra space on the right.
    width += windowScrollbarX;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
const $4e2e846094f3694a$var$absoluteOrFixed = /*#__PURE__*/ new Set([
    'absolute',
    'fixed'
]);
// Returns the inner client rect, subtracting scrollbars if present.
function $4e2e846094f3694a$var$getInnerBoundingClientRect(element, strategy) {
    const clientRect = $4e2e846094f3694a$var$getBoundingClientRect(element, true, strategy === 'fixed');
    const top = clientRect.top + element.clientTop;
    const left = clientRect.left + element.clientLeft;
    const scale = (0, $lCfwu.isHTMLElement)(element) ? $4e2e846094f3694a$var$getScale(element) : (0, $jUtdR.createCoords)(1);
    const width = element.clientWidth * scale.x;
    const height = element.clientHeight * scale.y;
    const x = left * scale.x;
    const y = top * scale.y;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
function $4e2e846094f3694a$var$getClientRectFromClippingAncestor(element, clippingAncestor, strategy) {
    let rect;
    if (clippingAncestor === 'viewport') rect = $4e2e846094f3694a$var$getViewportRect(element, strategy);
    else if (clippingAncestor === 'document') rect = $4e2e846094f3694a$var$getDocumentRect((0, $lCfwu.getDocumentElement)(element));
    else if ((0, $lCfwu.isElement)(clippingAncestor)) rect = $4e2e846094f3694a$var$getInnerBoundingClientRect(clippingAncestor, strategy);
    else {
        const visualOffsets = $4e2e846094f3694a$var$getVisualOffsets(element);
        rect = {
            x: clippingAncestor.x - visualOffsets.x,
            y: clippingAncestor.y - visualOffsets.y,
            width: clippingAncestor.width,
            height: clippingAncestor.height
        };
    }
    return (0, $jUtdR.rectToClientRect)(rect);
}
function $4e2e846094f3694a$var$hasFixedPositionAncestor(element, stopNode) {
    const parentNode = (0, $lCfwu.getParentNode)(element);
    if (parentNode === stopNode || !(0, $lCfwu.isElement)(parentNode) || (0, $lCfwu.isLastTraversableNode)(parentNode)) return false;
    return (0, $lCfwu.getComputedStyle)(parentNode).position === 'fixed' || $4e2e846094f3694a$var$hasFixedPositionAncestor(parentNode, stopNode);
}
// A "clipping ancestor" is an `overflow` element with the characteristic of
// clipping (or hiding) child elements. This returns all clipping ancestors
// of the given element up the tree.
function $4e2e846094f3694a$var$getClippingElementAncestors(element, cache) {
    const cachedResult = cache.get(element);
    if (cachedResult) return cachedResult;
    let result = (0, $lCfwu.getOverflowAncestors)(element, [], false).filter((el)=>(0, $lCfwu.isElement)(el) && (0, $lCfwu.getNodeName)(el) !== 'body');
    let currentContainingBlockComputedStyle = null;
    const elementIsFixed = (0, $lCfwu.getComputedStyle)(element).position === 'fixed';
    let currentNode = elementIsFixed ? (0, $lCfwu.getParentNode)(element) : element;
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
    while((0, $lCfwu.isElement)(currentNode) && !(0, $lCfwu.isLastTraversableNode)(currentNode)){
        const computedStyle = (0, $lCfwu.getComputedStyle)(currentNode);
        const currentNodeIsContaining = (0, $lCfwu.isContainingBlock)(currentNode);
        if (!currentNodeIsContaining && computedStyle.position === 'fixed') currentContainingBlockComputedStyle = null;
        const shouldDropCurrentNode = elementIsFixed ? !currentNodeIsContaining && !currentContainingBlockComputedStyle : !currentNodeIsContaining && computedStyle.position === 'static' && !!currentContainingBlockComputedStyle && $4e2e846094f3694a$var$absoluteOrFixed.has(currentContainingBlockComputedStyle.position) || (0, $lCfwu.isOverflowElement)(currentNode) && !currentNodeIsContaining && $4e2e846094f3694a$var$hasFixedPositionAncestor(element, currentNode);
        if (shouldDropCurrentNode) // Drop non-containing blocks.
        result = result.filter((ancestor)=>ancestor !== currentNode);
        else // Record last containing block for next iteration.
        currentContainingBlockComputedStyle = computedStyle;
        currentNode = (0, $lCfwu.getParentNode)(currentNode);
    }
    cache.set(element, result);
    return result;
}
// Gets the maximum area that the element is visible in due to any number of
// clipping ancestors.
function $4e2e846094f3694a$var$getClippingRect(_ref) {
    let { element: element, boundary: boundary, rootBoundary: rootBoundary, strategy: strategy } = _ref;
    const elementClippingAncestors = boundary === 'clippingAncestors' ? (0, $lCfwu.isTopLayer)(element) ? [] : $4e2e846094f3694a$var$getClippingElementAncestors(element, this._c) : [].concat(boundary);
    const clippingAncestors = [
        ...elementClippingAncestors,
        rootBoundary
    ];
    const firstClippingAncestor = clippingAncestors[0];
    const clippingRect = clippingAncestors.reduce((accRect, clippingAncestor)=>{
        const rect = $4e2e846094f3694a$var$getClientRectFromClippingAncestor(element, clippingAncestor, strategy);
        accRect.top = (0, $jUtdR.max)(rect.top, accRect.top);
        accRect.right = (0, $jUtdR.min)(rect.right, accRect.right);
        accRect.bottom = (0, $jUtdR.min)(rect.bottom, accRect.bottom);
        accRect.left = (0, $jUtdR.max)(rect.left, accRect.left);
        return accRect;
    }, $4e2e846094f3694a$var$getClientRectFromClippingAncestor(element, firstClippingAncestor, strategy));
    return {
        width: clippingRect.right - clippingRect.left,
        height: clippingRect.bottom - clippingRect.top,
        x: clippingRect.left,
        y: clippingRect.top
    };
}
function $4e2e846094f3694a$var$getDimensions(element) {
    const { width: width, height: height } = $4e2e846094f3694a$var$getCssDimensions(element);
    return {
        width: width,
        height: height
    };
}
function $4e2e846094f3694a$var$getRectRelativeToOffsetParent(element, offsetParent, strategy) {
    const isOffsetParentAnElement = (0, $lCfwu.isHTMLElement)(offsetParent);
    const documentElement = (0, $lCfwu.getDocumentElement)(offsetParent);
    const isFixed = strategy === 'fixed';
    const rect = $4e2e846094f3694a$var$getBoundingClientRect(element, true, isFixed, offsetParent);
    let scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    const offsets = (0, $jUtdR.createCoords)(0);
    // If the <body> scrollbar appears on the left (e.g. RTL systems). Use
    // Firefox with layout.scrollbar.side = 3 in about:config to test this.
    function setLeftRTLScrollbarOffset() {
        offsets.x = $4e2e846094f3694a$var$getWindowScrollBarX(documentElement);
    }
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $lCfwu.getNodeName)(offsetParent) !== 'body' || (0, $lCfwu.isOverflowElement)(documentElement)) scroll = (0, $lCfwu.getNodeScroll)(offsetParent);
        if (isOffsetParentAnElement) {
            const offsetRect = $4e2e846094f3694a$var$getBoundingClientRect(offsetParent, true, isFixed, offsetParent);
            offsets.x = offsetRect.x + offsetParent.clientLeft;
            offsets.y = offsetRect.y + offsetParent.clientTop;
        } else if (documentElement) setLeftRTLScrollbarOffset();
    }
    if (isFixed && !isOffsetParentAnElement && documentElement) setLeftRTLScrollbarOffset();
    const htmlOffset = documentElement && !isOffsetParentAnElement && !isFixed ? $4e2e846094f3694a$var$getHTMLOffset(documentElement, scroll) : (0, $jUtdR.createCoords)(0);
    const x = rect.left + scroll.scrollLeft - offsets.x - htmlOffset.x;
    const y = rect.top + scroll.scrollTop - offsets.y - htmlOffset.y;
    return {
        x: x,
        y: y,
        width: rect.width,
        height: rect.height
    };
}
function $4e2e846094f3694a$var$isStaticPositioned(element) {
    return (0, $lCfwu.getComputedStyle)(element).position === 'static';
}
function $4e2e846094f3694a$var$getTrueOffsetParent(element, polyfill) {
    if (!(0, $lCfwu.isHTMLElement)(element) || (0, $lCfwu.getComputedStyle)(element).position === 'fixed') return null;
    if (polyfill) return polyfill(element);
    let rawOffsetParent = element.offsetParent;
    // Firefox returns the <html> element as the offsetParent if it's non-static,
    // while Chrome and Safari return the <body> element. The <body> element must
    // be used to perform the correct calculations even if the <html> element is
    // non-static.
    if ((0, $lCfwu.getDocumentElement)(element) === rawOffsetParent) rawOffsetParent = rawOffsetParent.ownerDocument.body;
    return rawOffsetParent;
}
// Gets the closest ancestor positioned element. Handles some edge cases,
// such as table ancestors and cross browser bugs.
function $4e2e846094f3694a$var$getOffsetParent(element, polyfill) {
    const win = (0, $lCfwu.getWindow)(element);
    if ((0, $lCfwu.isTopLayer)(element)) return win;
    if (!(0, $lCfwu.isHTMLElement)(element)) {
        let svgOffsetParent = (0, $lCfwu.getParentNode)(element);
        while(svgOffsetParent && !(0, $lCfwu.isLastTraversableNode)(svgOffsetParent)){
            if ((0, $lCfwu.isElement)(svgOffsetParent) && !$4e2e846094f3694a$var$isStaticPositioned(svgOffsetParent)) return svgOffsetParent;
            svgOffsetParent = (0, $lCfwu.getParentNode)(svgOffsetParent);
        }
        return win;
    }
    let offsetParent = $4e2e846094f3694a$var$getTrueOffsetParent(element, polyfill);
    while(offsetParent && (0, $lCfwu.isTableElement)(offsetParent) && $4e2e846094f3694a$var$isStaticPositioned(offsetParent))offsetParent = $4e2e846094f3694a$var$getTrueOffsetParent(offsetParent, polyfill);
    if (offsetParent && (0, $lCfwu.isLastTraversableNode)(offsetParent) && $4e2e846094f3694a$var$isStaticPositioned(offsetParent) && !(0, $lCfwu.isContainingBlock)(offsetParent)) return win;
    return offsetParent || (0, $lCfwu.getContainingBlock)(element) || win;
}
const $4e2e846094f3694a$var$getElementRects = async function(data) {
    const getOffsetParentFn = this.getOffsetParent || $4e2e846094f3694a$var$getOffsetParent;
    const getDimensionsFn = this.getDimensions;
    const floatingDimensions = await getDimensionsFn(data.floating);
    return {
        reference: $4e2e846094f3694a$var$getRectRelativeToOffsetParent(data.reference, await getOffsetParentFn(data.floating), data.strategy),
        floating: {
            x: 0,
            y: 0,
            width: floatingDimensions.width,
            height: floatingDimensions.height
        }
    };
};
function $4e2e846094f3694a$var$isRTL(element) {
    return (0, $lCfwu.getComputedStyle)(element).direction === 'rtl';
}
const $4e2e846094f3694a$export$722a64dea1b767dc = {
    convertOffsetParentRelativeRectToViewportRelativeRect: $4e2e846094f3694a$var$convertOffsetParentRelativeRectToViewportRelativeRect,
    getDocumentElement: $lCfwu.getDocumentElement,
    getClippingRect: $4e2e846094f3694a$var$getClippingRect,
    getOffsetParent: $4e2e846094f3694a$var$getOffsetParent,
    getElementRects: $4e2e846094f3694a$var$getElementRects,
    getClientRects: $4e2e846094f3694a$var$getClientRects,
    getDimensions: $4e2e846094f3694a$var$getDimensions,
    getScale: $4e2e846094f3694a$var$getScale,
    isElement: $lCfwu.isElement,
    isRTL: $4e2e846094f3694a$var$isRTL
};
function $4e2e846094f3694a$var$rectsAreEqual(a, b) {
    return a.x === b.x && a.y === b.y && a.width === b.width && a.height === b.height;
}
// https://samthor.au/2021/observing-dom/
function $4e2e846094f3694a$var$observeMove(element, onMove) {
    let io = null;
    let timeoutId;
    const root = (0, $lCfwu.getDocumentElement)(element);
    function cleanup() {
        var _io;
        clearTimeout(timeoutId);
        (_io = io) == null || _io.disconnect();
        io = null;
    }
    function refresh(skip, threshold) {
        if (skip === void 0) skip = false;
        if (threshold === void 0) threshold = 1;
        cleanup();
        const elementRectForRootMargin = element.getBoundingClientRect();
        const { left: left, top: top, width: width, height: height } = elementRectForRootMargin;
        if (!skip) onMove();
        if (!width || !height) return;
        const insetTop = (0, $jUtdR.floor)(top);
        const insetRight = (0, $jUtdR.floor)(root.clientWidth - (left + width));
        const insetBottom = (0, $jUtdR.floor)(root.clientHeight - (top + height));
        const insetLeft = (0, $jUtdR.floor)(left);
        const rootMargin = -insetTop + "px " + -insetRight + "px " + -insetBottom + "px " + -insetLeft + "px";
        const options = {
            rootMargin: rootMargin,
            threshold: (0, $jUtdR.max)(0, (0, $jUtdR.min)(1, threshold)) || 1
        };
        let isFirstUpdate = true;
        function handleObserve(entries) {
            const ratio = entries[0].intersectionRatio;
            if (ratio !== threshold) {
                if (!isFirstUpdate) return refresh();
                if (!ratio) // If the reference is clipped, the ratio is 0. Throttle the refresh
                // to prevent an infinite loop of updates.
                timeoutId = setTimeout(()=>{
                    refresh(false, 1e-7);
                }, 1000);
                else refresh(false, ratio);
            }
            if (ratio === 1 && !$4e2e846094f3694a$var$rectsAreEqual(elementRectForRootMargin, element.getBoundingClientRect())) // It's possible that even though the ratio is reported as 1, the
            // element is not actually fully within the IntersectionObserver's root
            // area anymore. This can happen under performance constraints. This may
            // be a bug in the browser's IntersectionObserver implementation. To
            // work around this, we compare the element's bounding rect now with
            // what it was at the time we created the IntersectionObserver. If they
            // are not equal then the element moved, so we refresh.
            refresh();
            isFirstUpdate = false;
        }
        // Older browsers don't support a `document` as the root and will throw an
        // error.
        try {
            io = new IntersectionObserver(handleObserve, {
                ...options,
                // Handle <iframe>s
                root: root.ownerDocument
            });
        } catch (_e) {
            io = new IntersectionObserver(handleObserve, options);
        }
        io.observe(element);
    }
    refresh(true);
    return cleanup;
}
/**
 * Automatically updates the position of the floating element when necessary.
 * Should only be called when the floating element is mounted on the DOM or
 * visible on the screen.
 * @returns cleanup function that should be invoked when the floating element is
 * removed from the DOM or hidden from the screen.
 * @see https://floating-ui.com/docs/autoUpdate
 */ function $4e2e846094f3694a$export$deee3a793edee05f(reference, floating, update, options) {
    if (options === void 0) options = {};
    const { ancestorScroll: ancestorScroll = true, ancestorResize: ancestorResize = true, elementResize: elementResize = typeof ResizeObserver === 'function', layoutShift: layoutShift = typeof IntersectionObserver === 'function', animationFrame: animationFrame = false } = options;
    const referenceEl = $4e2e846094f3694a$var$unwrapElement(reference);
    const ancestors = ancestorScroll || ancestorResize ? [
        ...referenceEl ? (0, $lCfwu.getOverflowAncestors)(referenceEl) : [],
        ...(0, $lCfwu.getOverflowAncestors)(floating)
    ] : [];
    ancestors.forEach((ancestor)=>{
        ancestorScroll && ancestor.addEventListener('scroll', update, {
            passive: true
        });
        ancestorResize && ancestor.addEventListener('resize', update);
    });
    const cleanupIo = referenceEl && layoutShift ? $4e2e846094f3694a$var$observeMove(referenceEl, update) : null;
    let reobserveFrame = -1;
    let resizeObserver = null;
    if (elementResize) {
        resizeObserver = new ResizeObserver((_ref)=>{
            let [firstEntry] = _ref;
            if (firstEntry && firstEntry.target === referenceEl && resizeObserver) {
                // Prevent update loops when using the `size` middleware.
                // https://github.com/floating-ui/floating-ui/issues/1740
                resizeObserver.unobserve(floating);
                cancelAnimationFrame(reobserveFrame);
                reobserveFrame = requestAnimationFrame(()=>{
                    var _resizeObserver;
                    (_resizeObserver = resizeObserver) == null || _resizeObserver.observe(floating);
                });
            }
            update();
        });
        if (referenceEl && !animationFrame) resizeObserver.observe(referenceEl);
        resizeObserver.observe(floating);
    }
    let frameId;
    let prevRefRect = animationFrame ? $4e2e846094f3694a$var$getBoundingClientRect(reference) : null;
    if (animationFrame) frameLoop();
    function frameLoop() {
        const nextRefRect = $4e2e846094f3694a$var$getBoundingClientRect(reference);
        if (prevRefRect && !$4e2e846094f3694a$var$rectsAreEqual(prevRefRect, nextRefRect)) update();
        prevRefRect = nextRefRect;
        frameId = requestAnimationFrame(frameLoop);
    }
    update();
    return ()=>{
        var _resizeObserver2;
        ancestors.forEach((ancestor)=>{
            ancestorScroll && ancestor.removeEventListener('scroll', update);
            ancestorResize && ancestor.removeEventListener('resize', update);
        });
        cleanupIo == null || cleanupIo();
        (_resizeObserver2 = resizeObserver) == null || _resizeObserver2.disconnect();
        resizeObserver = null;
        if (animationFrame) cancelAnimationFrame(frameId);
    };
}
/**
 * Resolves with an object of overflow side offsets that determine how much the
 * element is overflowing a given clipping boundary on each side.
 * - positive = overflowing the boundary by that number of pixels
 * - negative = how many pixels left before it will overflow
 * - 0 = lies flush with the boundary
 * @see https://floating-ui.com/docs/detectOverflow
 */ const $4e2e846094f3694a$export$37b6bde19b108ecc = (0, $4qENO.detectOverflow);
/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */ const $4e2e846094f3694a$export$cc800923e997bb8 = (0, $4qENO.offset);
/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */ const $4e2e846094f3694a$export$91fb6ecbd551914 = (0, $4qENO.autoPlacement);
/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */ const $4e2e846094f3694a$export$fba63a578e423eb = (0, $4qENO.shift);
/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */ const $4e2e846094f3694a$export$8a83211c878a3f1f = (0, $4qENO.flip);
/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */ const $4e2e846094f3694a$export$346677f925de839c = (0, $4qENO.size);
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */ const $4e2e846094f3694a$export$fe8985bb6374093c = (0, $4qENO.hide);
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * @see https://floating-ui.com/docs/arrow
 */ const $4e2e846094f3694a$export$f2120bbfa5450bd2 = (0, $4qENO.arrow);
/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */ const $4e2e846094f3694a$export$18c8ad048e32c7d5 = (0, $4qENO.inline);
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */ const $4e2e846094f3694a$export$7bf07e38f3dc4b69 = (0, $4qENO.limitShift);
/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a given reference element.
 */ const $4e2e846094f3694a$export$48a53dcb22e581d0 = (reference, floating, options)=>{
    // This caches the expensive `getClippingElementAncestors` function so that
    // multiple lifecycle resets re-use the same result. It only lives for a
    // single call. If other functions become expensive, we can add them as well.
    const cache = new Map();
    const mergedOptions = {
        platform: $4e2e846094f3694a$export$722a64dea1b767dc,
        ...options
    };
    const platformWithCache = {
        ...mergedOptions.platform,
        _c: cache
    };
    return (0, $4qENO.computePosition)(reference, floating, {
        ...mergedOptions,
        platform: platformWithCache
    });
};

});
parcelRegister("4qENO", function(module, exports) {
$parcel$export(module.exports, "computePosition", () => $33993daa3d6e1e95$export$48a53dcb22e581d0);
$parcel$export(module.exports, "detectOverflow", () => $33993daa3d6e1e95$export$37b6bde19b108ecc);
$parcel$export(module.exports, "arrow", () => $33993daa3d6e1e95$export$f2120bbfa5450bd2);
$parcel$export(module.exports, "autoPlacement", () => $33993daa3d6e1e95$export$91fb6ecbd551914);
$parcel$export(module.exports, "flip", () => $33993daa3d6e1e95$export$8a83211c878a3f1f);
$parcel$export(module.exports, "hide", () => $33993daa3d6e1e95$export$fe8985bb6374093c);
$parcel$export(module.exports, "inline", () => $33993daa3d6e1e95$export$18c8ad048e32c7d5);
$parcel$export(module.exports, "offset", () => $33993daa3d6e1e95$export$cc800923e997bb8);
$parcel$export(module.exports, "shift", () => $33993daa3d6e1e95$export$fba63a578e423eb);
$parcel$export(module.exports, "limitShift", () => $33993daa3d6e1e95$export$7bf07e38f3dc4b69);
$parcel$export(module.exports, "size", () => $33993daa3d6e1e95$export$346677f925de839c);
$parcel$export(module.exports, "rectToClientRect", () => (parcelRequire("jUtdR")).rectToClientRect);

var $jUtdR = parcelRequire("jUtdR");
function $33993daa3d6e1e95$var$computeCoordsFromPlacement(_ref, placement, rtl) {
    let { reference: reference, floating: floating } = _ref;
    const sideAxis = (0, $jUtdR.getSideAxis)(placement);
    const alignmentAxis = (0, $jUtdR.getAlignmentAxis)(placement);
    const alignLength = (0, $jUtdR.getAxisLength)(alignmentAxis);
    const side = (0, $jUtdR.getSide)(placement);
    const isVertical = sideAxis === 'y';
    const commonX = reference.x + reference.width / 2 - floating.width / 2;
    const commonY = reference.y + reference.height / 2 - floating.height / 2;
    const commonAlign = reference[alignLength] / 2 - floating[alignLength] / 2;
    let coords;
    switch(side){
        case 'top':
            coords = {
                x: commonX,
                y: reference.y - floating.height
            };
            break;
        case 'bottom':
            coords = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 'right':
            coords = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 'left':
            coords = {
                x: reference.x - floating.width,
                y: commonY
            };
            break;
        default:
            coords = {
                x: reference.x,
                y: reference.y
            };
    }
    switch((0, $jUtdR.getAlignment)(placement)){
        case 'start':
            coords[alignmentAxis] -= commonAlign * (rtl && isVertical ? -1 : 1);
            break;
        case 'end':
            coords[alignmentAxis] += commonAlign * (rtl && isVertical ? -1 : 1);
            break;
    }
    return coords;
}
/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a given reference element.
 *
 * This export does not have any `platform` interface logic. You will need to
 * write one for the platform you are using Floating UI with.
 */ const $33993daa3d6e1e95$export$48a53dcb22e581d0 = async (reference, floating, config)=>{
    const { placement: placement = 'bottom', strategy: strategy = 'absolute', middleware: middleware = [], platform: platform } = config;
    const validMiddleware = middleware.filter(Boolean);
    const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(floating));
    let rects = await platform.getElementRects({
        reference: reference,
        floating: floating,
        strategy: strategy
    });
    let { x: x, y: y } = $33993daa3d6e1e95$var$computeCoordsFromPlacement(rects, placement, rtl);
    let statefulPlacement = placement;
    let middlewareData = {};
    let resetCount = 0;
    for(let i = 0; i < validMiddleware.length; i++){
        const { name: name, fn: fn } = validMiddleware[i];
        const { x: nextX, y: nextY, data: data, reset: reset } = await fn({
            x: x,
            y: y,
            initialPlacement: placement,
            placement: statefulPlacement,
            strategy: strategy,
            middlewareData: middlewareData,
            rects: rects,
            platform: platform,
            elements: {
                reference: reference,
                floating: floating
            }
        });
        x = nextX != null ? nextX : x;
        y = nextY != null ? nextY : y;
        middlewareData = {
            ...middlewareData,
            [name]: {
                ...middlewareData[name],
                ...data
            }
        };
        if (reset && resetCount <= 50) {
            resetCount++;
            if (typeof reset === 'object') {
                if (reset.placement) statefulPlacement = reset.placement;
                if (reset.rects) rects = reset.rects === true ? await platform.getElementRects({
                    reference: reference,
                    floating: floating,
                    strategy: strategy
                }) : reset.rects;
                ({ x: x, y: y } = $33993daa3d6e1e95$var$computeCoordsFromPlacement(rects, statefulPlacement, rtl));
            }
            i = -1;
        }
    }
    return {
        x: x,
        y: y,
        placement: statefulPlacement,
        strategy: strategy,
        middlewareData: middlewareData
    };
};
/**
 * Resolves with an object of overflow side offsets that determine how much the
 * element is overflowing a given clipping boundary on each side.
 * - positive = overflowing the boundary by that number of pixels
 * - negative = how many pixels left before it will overflow
 * - 0 = lies flush with the boundary
 * @see https://floating-ui.com/docs/detectOverflow
 */ async function $33993daa3d6e1e95$export$37b6bde19b108ecc(state, options) {
    var _await$platform$isEle;
    if (options === void 0) options = {};
    const { x: x, y: y, platform: platform, rects: rects, elements: elements, strategy: strategy } = state;
    const { boundary: boundary = 'clippingAncestors', rootBoundary: rootBoundary = 'viewport', elementContext: elementContext = 'floating', altBoundary: altBoundary = false, padding: padding = 0 } = (0, $jUtdR.evaluate)(options, state);
    const paddingObject = (0, $jUtdR.getPaddingObject)(padding);
    const altContext = elementContext === 'floating' ? 'reference' : 'floating';
    const element = elements[altBoundary ? altContext : elementContext];
    const clippingClientRect = (0, $jUtdR.rectToClientRect)(await platform.getClippingRect({
        element: ((_await$platform$isEle = await (platform.isElement == null ? void 0 : platform.isElement(element))) != null ? _await$platform$isEle : true) ? element : element.contextElement || await (platform.getDocumentElement == null ? void 0 : platform.getDocumentElement(elements.floating)),
        boundary: boundary,
        rootBoundary: rootBoundary,
        strategy: strategy
    }));
    const rect = elementContext === 'floating' ? {
        x: x,
        y: y,
        width: rects.floating.width,
        height: rects.floating.height
    } : rects.reference;
    const offsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(elements.floating));
    const offsetScale = await (platform.isElement == null ? void 0 : platform.isElement(offsetParent)) ? await (platform.getScale == null ? void 0 : platform.getScale(offsetParent)) || {
        x: 1,
        y: 1
    } : {
        x: 1,
        y: 1
    };
    const elementClientRect = (0, $jUtdR.rectToClientRect)(platform.convertOffsetParentRelativeRectToViewportRelativeRect ? await platform.convertOffsetParentRelativeRectToViewportRelativeRect({
        elements: elements,
        rect: rect,
        offsetParent: offsetParent,
        strategy: strategy
    }) : rect);
    return {
        top: (clippingClientRect.top - elementClientRect.top + paddingObject.top) / offsetScale.y,
        bottom: (elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom) / offsetScale.y,
        left: (clippingClientRect.left - elementClientRect.left + paddingObject.left) / offsetScale.x,
        right: (elementClientRect.right - clippingClientRect.right + paddingObject.right) / offsetScale.x
    };
}
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * @see https://floating-ui.com/docs/arrow
 */ const $33993daa3d6e1e95$export$f2120bbfa5450bd2 = (options)=>({
        name: 'arrow',
        options: options,
        async fn (state) {
            const { x: x, y: y, placement: placement, rects: rects, platform: platform, elements: elements, middlewareData: middlewareData } = state;
            // Since `element` is required, we don't Partial<> the type.
            const { element: element, padding: padding = 0 } = (0, $jUtdR.evaluate)(options, state) || {};
            if (element == null) return {};
            const paddingObject = (0, $jUtdR.getPaddingObject)(padding);
            const coords = {
                x: x,
                y: y
            };
            const axis = (0, $jUtdR.getAlignmentAxis)(placement);
            const length = (0, $jUtdR.getAxisLength)(axis);
            const arrowDimensions = await platform.getDimensions(element);
            const isYAxis = axis === 'y';
            const minProp = isYAxis ? 'top' : 'left';
            const maxProp = isYAxis ? 'bottom' : 'right';
            const clientProp = isYAxis ? 'clientHeight' : 'clientWidth';
            const endDiff = rects.reference[length] + rects.reference[axis] - coords[axis] - rects.floating[length];
            const startDiff = coords[axis] - rects.reference[axis];
            const arrowOffsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(element));
            let clientSize = arrowOffsetParent ? arrowOffsetParent[clientProp] : 0;
            // DOM platform can return `window` as the `offsetParent`.
            if (!clientSize || !await (platform.isElement == null ? void 0 : platform.isElement(arrowOffsetParent))) clientSize = elements.floating[clientProp] || rects.floating[length];
            const centerToReference = endDiff / 2 - startDiff / 2;
            // If the padding is large enough that it causes the arrow to no longer be
            // centered, modify the padding so that it is centered.
            const largestPossiblePadding = clientSize / 2 - arrowDimensions[length] / 2 - 1;
            const minPadding = (0, $jUtdR.min)(paddingObject[minProp], largestPossiblePadding);
            const maxPadding = (0, $jUtdR.min)(paddingObject[maxProp], largestPossiblePadding);
            // Make sure the arrow doesn't overflow the floating element if the center
            // point is outside the floating element's bounds.
            const min$1 = minPadding;
            const max = clientSize - arrowDimensions[length] - maxPadding;
            const center = clientSize / 2 - arrowDimensions[length] / 2 + centerToReference;
            const offset = (0, $jUtdR.clamp)(min$1, center, max);
            // If the reference is small enough that the arrow's padding causes it to
            // to point to nothing for an aligned placement, adjust the offset of the
            // floating element itself. To ensure `shift()` continues to take action,
            // a single reset is performed when this is true.
            const shouldAddOffset = !middlewareData.arrow && (0, $jUtdR.getAlignment)(placement) != null && center !== offset && rects.reference[length] / 2 - (center < min$1 ? minPadding : maxPadding) - arrowDimensions[length] / 2 < 0;
            const alignmentOffset = shouldAddOffset ? center < min$1 ? center - min$1 : center - max : 0;
            return {
                [axis]: coords[axis] + alignmentOffset,
                data: {
                    [axis]: offset,
                    centerOffset: center - offset - alignmentOffset,
                    ...shouldAddOffset && {
                        alignmentOffset: alignmentOffset
                    }
                },
                reset: shouldAddOffset
            };
        }
    });
function $33993daa3d6e1e95$var$getPlacementList(alignment, autoAlignment, allowedPlacements) {
    const allowedPlacementsSortedByAlignment = alignment ? [
        ...allowedPlacements.filter((placement)=>(0, $jUtdR.getAlignment)(placement) === alignment),
        ...allowedPlacements.filter((placement)=>(0, $jUtdR.getAlignment)(placement) !== alignment)
    ] : allowedPlacements.filter((placement)=>(0, $jUtdR.getSide)(placement) === placement);
    return allowedPlacementsSortedByAlignment.filter((placement)=>{
        if (alignment) return (0, $jUtdR.getAlignment)(placement) === alignment || (autoAlignment ? (0, $jUtdR.getOppositeAlignmentPlacement)(placement) !== placement : false);
        return true;
    });
}
/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */ const $33993daa3d6e1e95$export$91fb6ecbd551914 = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'autoPlacement',
        options: options,
        async fn (state) {
            var _middlewareData$autoP, _middlewareData$autoP2, _placementsThatFitOnE;
            const { rects: rects, middlewareData: middlewareData, placement: placement, platform: platform, elements: elements } = state;
            const { crossAxis: crossAxis = false, alignment: alignment, allowedPlacements: allowedPlacements = (0, $jUtdR.placements), autoAlignment: autoAlignment = true, ...detectOverflowOptions } = (0, $jUtdR.evaluate)(options, state);
            const placements$1 = alignment !== undefined || allowedPlacements === (0, $jUtdR.placements) ? $33993daa3d6e1e95$var$getPlacementList(alignment || null, autoAlignment, allowedPlacements) : allowedPlacements;
            const overflow = await $33993daa3d6e1e95$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const currentIndex = ((_middlewareData$autoP = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP.index) || 0;
            const currentPlacement = placements$1[currentIndex];
            if (currentPlacement == null) return {};
            const alignmentSides = (0, $jUtdR.getAlignmentSides)(currentPlacement, rects, await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)));
            // Make `computeCoords` start from the right place.
            if (placement !== currentPlacement) return {
                reset: {
                    placement: placements$1[0]
                }
            };
            const currentOverflows = [
                overflow[(0, $jUtdR.getSide)(currentPlacement)],
                overflow[alignmentSides[0]],
                overflow[alignmentSides[1]]
            ];
            const allOverflows = [
                ...((_middlewareData$autoP2 = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP2.overflows) || [],
                {
                    placement: currentPlacement,
                    overflows: currentOverflows
                }
            ];
            const nextPlacement = placements$1[currentIndex + 1];
            // There are more placements to check.
            if (nextPlacement) return {
                data: {
                    index: currentIndex + 1,
                    overflows: allOverflows
                },
                reset: {
                    placement: nextPlacement
                }
            };
            const placementsSortedByMostSpace = allOverflows.map((d)=>{
                const alignment = (0, $jUtdR.getAlignment)(d.placement);
                return [
                    d.placement,
                    alignment && crossAxis ? // Check along the mainAxis and main crossAxis side.
                    d.overflows.slice(0, 2).reduce((acc, v)=>acc + v, 0) : // Check only the mainAxis.
                    d.overflows[0],
                    d.overflows
                ];
            }).sort((a, b)=>a[1] - b[1]);
            const placementsThatFitOnEachSide = placementsSortedByMostSpace.filter((d)=>d[2].slice(0, // Aligned placements should not check their opposite crossAxis
                // side.
                (0, $jUtdR.getAlignment)(d[0]) ? 2 : 3).every((v)=>v <= 0));
            const resetPlacement = ((_placementsThatFitOnE = placementsThatFitOnEachSide[0]) == null ? void 0 : _placementsThatFitOnE[0]) || placementsSortedByMostSpace[0][0];
            if (resetPlacement !== placement) return {
                data: {
                    index: currentIndex + 1,
                    overflows: allOverflows
                },
                reset: {
                    placement: resetPlacement
                }
            };
            return {};
        }
    };
};
/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */ const $33993daa3d6e1e95$export$8a83211c878a3f1f = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'flip',
        options: options,
        async fn (state) {
            var _middlewareData$arrow, _middlewareData$flip;
            const { placement: placement, middlewareData: middlewareData, rects: rects, initialPlacement: initialPlacement, platform: platform, elements: elements } = state;
            const { mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = true, fallbackPlacements: specifiedFallbackPlacements, fallbackStrategy: fallbackStrategy = 'bestFit', fallbackAxisSideDirection: fallbackAxisSideDirection = 'none', flipAlignment: flipAlignment = true, ...detectOverflowOptions } = (0, $jUtdR.evaluate)(options, state);
            // If a reset by the arrow was caused due to an alignment offset being
            // added, we should skip any logic now since `flip()` has already done its
            // work.
            // https://github.com/floating-ui/floating-ui/issues/2549#issuecomment-1719601643
            if ((_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) return {};
            const side = (0, $jUtdR.getSide)(placement);
            const initialSideAxis = (0, $jUtdR.getSideAxis)(initialPlacement);
            const isBasePlacement = (0, $jUtdR.getSide)(initialPlacement) === initialPlacement;
            const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
            const fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipAlignment ? [
                (0, $jUtdR.getOppositePlacement)(initialPlacement)
            ] : (0, $jUtdR.getExpandedPlacements)(initialPlacement));
            const hasFallbackAxisSideDirection = fallbackAxisSideDirection !== 'none';
            if (!specifiedFallbackPlacements && hasFallbackAxisSideDirection) fallbackPlacements.push(...(0, $jUtdR.getOppositeAxisPlacements)(initialPlacement, flipAlignment, fallbackAxisSideDirection, rtl));
            const placements = [
                initialPlacement,
                ...fallbackPlacements
            ];
            const overflow = await $33993daa3d6e1e95$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const overflows = [];
            let overflowsData = ((_middlewareData$flip = middlewareData.flip) == null ? void 0 : _middlewareData$flip.overflows) || [];
            if (checkMainAxis) overflows.push(overflow[side]);
            if (checkCrossAxis) {
                const sides = (0, $jUtdR.getAlignmentSides)(placement, rects, rtl);
                overflows.push(overflow[sides[0]], overflow[sides[1]]);
            }
            overflowsData = [
                ...overflowsData,
                {
                    placement: placement,
                    overflows: overflows
                }
            ];
            // One or more sides is overflowing.
            if (!overflows.every((side)=>side <= 0)) {
                var _middlewareData$flip2, _overflowsData$filter;
                const nextIndex = (((_middlewareData$flip2 = middlewareData.flip) == null ? void 0 : _middlewareData$flip2.index) || 0) + 1;
                const nextPlacement = placements[nextIndex];
                if (nextPlacement) {
                    const ignoreCrossAxisOverflow = checkCrossAxis === 'alignment' ? initialSideAxis !== (0, $jUtdR.getSideAxis)(nextPlacement) : false;
                    if (!ignoreCrossAxisOverflow || // We leave the current main axis only if every placement on that axis
                    // overflows the main axis.
                    overflowsData.every((d)=>(0, $jUtdR.getSideAxis)(d.placement) === initialSideAxis ? d.overflows[0] > 0 : true)) // Try next placement and re-run the lifecycle.
                    return {
                        data: {
                            index: nextIndex,
                            overflows: overflowsData
                        },
                        reset: {
                            placement: nextPlacement
                        }
                    };
                }
                // First, find the candidates that fit on the mainAxis side of overflow,
                // then find the placement that fits the best on the main crossAxis side.
                let resetPlacement = (_overflowsData$filter = overflowsData.filter((d)=>d.overflows[0] <= 0).sort((a, b)=>a.overflows[1] - b.overflows[1])[0]) == null ? void 0 : _overflowsData$filter.placement;
                // Otherwise fallback.
                if (!resetPlacement) switch(fallbackStrategy){
                    case 'bestFit':
                        {
                            var _overflowsData$filter2;
                            const placement = (_overflowsData$filter2 = overflowsData.filter((d)=>{
                                if (hasFallbackAxisSideDirection) {
                                    const currentSideAxis = (0, $jUtdR.getSideAxis)(d.placement);
                                    return currentSideAxis === initialSideAxis || // Create a bias to the `y` side axis due to horizontal
                                    // reading directions favoring greater width.
                                    currentSideAxis === 'y';
                                }
                                return true;
                            }).map((d)=>[
                                    d.placement,
                                    d.overflows.filter((overflow)=>overflow > 0).reduce((acc, overflow)=>acc + overflow, 0)
                                ]).sort((a, b)=>a[1] - b[1])[0]) == null ? void 0 : _overflowsData$filter2[0];
                            if (placement) resetPlacement = placement;
                            break;
                        }
                    case 'initialPlacement':
                        resetPlacement = initialPlacement;
                        break;
                }
                if (placement !== resetPlacement) return {
                    reset: {
                        placement: resetPlacement
                    }
                };
            }
            return {};
        }
    };
};
function $33993daa3d6e1e95$var$getSideOffsets(overflow, rect) {
    return {
        top: overflow.top - rect.height,
        right: overflow.right - rect.width,
        bottom: overflow.bottom - rect.height,
        left: overflow.left - rect.width
    };
}
function $33993daa3d6e1e95$var$isAnySideFullyClipped(overflow) {
    return (0, $jUtdR.sides).some((side)=>overflow[side] >= 0);
}
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */ const $33993daa3d6e1e95$export$fe8985bb6374093c = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'hide',
        options: options,
        async fn (state) {
            const { rects: rects } = state;
            const { strategy: strategy = 'referenceHidden', ...detectOverflowOptions } = (0, $jUtdR.evaluate)(options, state);
            switch(strategy){
                case 'referenceHidden':
                    {
                        const overflow = await $33993daa3d6e1e95$export$37b6bde19b108ecc(state, {
                            ...detectOverflowOptions,
                            elementContext: 'reference'
                        });
                        const offsets = $33993daa3d6e1e95$var$getSideOffsets(overflow, rects.reference);
                        return {
                            data: {
                                referenceHiddenOffsets: offsets,
                                referenceHidden: $33993daa3d6e1e95$var$isAnySideFullyClipped(offsets)
                            }
                        };
                    }
                case 'escaped':
                    {
                        const overflow = await $33993daa3d6e1e95$export$37b6bde19b108ecc(state, {
                            ...detectOverflowOptions,
                            altBoundary: true
                        });
                        const offsets = $33993daa3d6e1e95$var$getSideOffsets(overflow, rects.floating);
                        return {
                            data: {
                                escapedOffsets: offsets,
                                escaped: $33993daa3d6e1e95$var$isAnySideFullyClipped(offsets)
                            }
                        };
                    }
                default:
                    return {};
            }
        }
    };
};
function $33993daa3d6e1e95$var$getBoundingRect(rects) {
    const minX = (0, $jUtdR.min)(...rects.map((rect)=>rect.left));
    const minY = (0, $jUtdR.min)(...rects.map((rect)=>rect.top));
    const maxX = (0, $jUtdR.max)(...rects.map((rect)=>rect.right));
    const maxY = (0, $jUtdR.max)(...rects.map((rect)=>rect.bottom));
    return {
        x: minX,
        y: minY,
        width: maxX - minX,
        height: maxY - minY
    };
}
function $33993daa3d6e1e95$var$getRectsByLine(rects) {
    const sortedRects = rects.slice().sort((a, b)=>a.y - b.y);
    const groups = [];
    let prevRect = null;
    for(let i = 0; i < sortedRects.length; i++){
        const rect = sortedRects[i];
        if (!prevRect || rect.y - prevRect.y > prevRect.height / 2) groups.push([
            rect
        ]);
        else groups[groups.length - 1].push(rect);
        prevRect = rect;
    }
    return groups.map((rect)=>(0, $jUtdR.rectToClientRect)($33993daa3d6e1e95$var$getBoundingRect(rect)));
}
/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */ const $33993daa3d6e1e95$export$18c8ad048e32c7d5 = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'inline',
        options: options,
        async fn (state) {
            const { placement: placement, elements: elements, rects: rects, platform: platform, strategy: strategy } = state;
            // A MouseEvent's client{X,Y} coords can be up to 2 pixels off a
            // ClientRect's bounds, despite the event listener being triggered. A
            // padding of 2 seems to handle this issue.
            const { padding: padding = 2, x: x, y: y } = (0, $jUtdR.evaluate)(options, state);
            const nativeClientRects = Array.from(await (platform.getClientRects == null ? void 0 : platform.getClientRects(elements.reference)) || []);
            const clientRects = $33993daa3d6e1e95$var$getRectsByLine(nativeClientRects);
            const fallback = (0, $jUtdR.rectToClientRect)($33993daa3d6e1e95$var$getBoundingRect(nativeClientRects));
            const paddingObject = (0, $jUtdR.getPaddingObject)(padding);
            function getBoundingClientRect() {
                // There are two rects and they are disjoined.
                if (clientRects.length === 2 && clientRects[0].left > clientRects[1].right && x != null && y != null) // Find the first rect in which the point is fully inside.
                return clientRects.find((rect)=>x > rect.left - paddingObject.left && x < rect.right + paddingObject.right && y > rect.top - paddingObject.top && y < rect.bottom + paddingObject.bottom) || fallback;
                // There are 2 or more connected rects.
                if (clientRects.length >= 2) {
                    if ((0, $jUtdR.getSideAxis)(placement) === 'y') {
                        const firstRect = clientRects[0];
                        const lastRect = clientRects[clientRects.length - 1];
                        const isTop = (0, $jUtdR.getSide)(placement) === 'top';
                        const top = firstRect.top;
                        const bottom = lastRect.bottom;
                        const left = isTop ? firstRect.left : lastRect.left;
                        const right = isTop ? firstRect.right : lastRect.right;
                        const width = right - left;
                        const height = bottom - top;
                        return {
                            top: top,
                            bottom: bottom,
                            left: left,
                            right: right,
                            width: width,
                            height: height,
                            x: left,
                            y: top
                        };
                    }
                    const isLeftSide = (0, $jUtdR.getSide)(placement) === 'left';
                    const maxRight = (0, $jUtdR.max)(...clientRects.map((rect)=>rect.right));
                    const minLeft = (0, $jUtdR.min)(...clientRects.map((rect)=>rect.left));
                    const measureRects = clientRects.filter((rect)=>isLeftSide ? rect.left === minLeft : rect.right === maxRight);
                    const top = measureRects[0].top;
                    const bottom = measureRects[measureRects.length - 1].bottom;
                    const left = minLeft;
                    const right = maxRight;
                    const width = right - left;
                    const height = bottom - top;
                    return {
                        top: top,
                        bottom: bottom,
                        left: left,
                        right: right,
                        width: width,
                        height: height,
                        x: left,
                        y: top
                    };
                }
                return fallback;
            }
            const resetRects = await platform.getElementRects({
                reference: {
                    getBoundingClientRect: getBoundingClientRect
                },
                floating: elements.floating,
                strategy: strategy
            });
            if (rects.reference.x !== resetRects.reference.x || rects.reference.y !== resetRects.reference.y || rects.reference.width !== resetRects.reference.width || rects.reference.height !== resetRects.reference.height) return {
                reset: {
                    rects: resetRects
                }
            };
            return {};
        }
    };
};
const $33993daa3d6e1e95$var$originSides = /*#__PURE__*/ new Set([
    'left',
    'top'
]);
// For type backwards-compatibility, the `OffsetOptions` type was also
// Derivable.
async function $33993daa3d6e1e95$var$convertValueToCoords(state, options) {
    const { placement: placement, platform: platform, elements: elements } = state;
    const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
    const side = (0, $jUtdR.getSide)(placement);
    const alignment = (0, $jUtdR.getAlignment)(placement);
    const isVertical = (0, $jUtdR.getSideAxis)(placement) === 'y';
    const mainAxisMulti = $33993daa3d6e1e95$var$originSides.has(side) ? -1 : 1;
    const crossAxisMulti = rtl && isVertical ? -1 : 1;
    const rawValue = (0, $jUtdR.evaluate)(options, state);
    // eslint-disable-next-line prefer-const
    let { mainAxis: mainAxis, crossAxis: crossAxis, alignmentAxis: alignmentAxis } = typeof rawValue === 'number' ? {
        mainAxis: rawValue,
        crossAxis: 0,
        alignmentAxis: null
    } : {
        mainAxis: rawValue.mainAxis || 0,
        crossAxis: rawValue.crossAxis || 0,
        alignmentAxis: rawValue.alignmentAxis
    };
    if (alignment && typeof alignmentAxis === 'number') crossAxis = alignment === 'end' ? alignmentAxis * -1 : alignmentAxis;
    return isVertical ? {
        x: crossAxis * crossAxisMulti,
        y: mainAxis * mainAxisMulti
    } : {
        x: mainAxis * mainAxisMulti,
        y: crossAxis * crossAxisMulti
    };
}
/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */ const $33993daa3d6e1e95$export$cc800923e997bb8 = function(options) {
    if (options === void 0) options = 0;
    return {
        name: 'offset',
        options: options,
        async fn (state) {
            var _middlewareData$offse, _middlewareData$arrow;
            const { x: x, y: y, placement: placement, middlewareData: middlewareData } = state;
            const diffCoords = await $33993daa3d6e1e95$var$convertValueToCoords(state, options);
            // If the placement is the same and the arrow caused an alignment offset
            // then we don't need to change the positioning coordinates.
            if (placement === ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse.placement) && (_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) return {};
            return {
                x: x + diffCoords.x,
                y: y + diffCoords.y,
                data: {
                    ...diffCoords,
                    placement: placement
                }
            };
        }
    };
};
/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */ const $33993daa3d6e1e95$export$fba63a578e423eb = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'shift',
        options: options,
        async fn (state) {
            const { x: x, y: y, placement: placement } = state;
            const { mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = false, limiter: limiter = {
                fn: (_ref)=>{
                    let { x: x, y: y } = _ref;
                    return {
                        x: x,
                        y: y
                    };
                }
            }, ...detectOverflowOptions } = (0, $jUtdR.evaluate)(options, state);
            const coords = {
                x: x,
                y: y
            };
            const overflow = await $33993daa3d6e1e95$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const crossAxis = (0, $jUtdR.getSideAxis)((0, $jUtdR.getSide)(placement));
            const mainAxis = (0, $jUtdR.getOppositeAxis)(crossAxis);
            let mainAxisCoord = coords[mainAxis];
            let crossAxisCoord = coords[crossAxis];
            if (checkMainAxis) {
                const minSide = mainAxis === 'y' ? 'top' : 'left';
                const maxSide = mainAxis === 'y' ? 'bottom' : 'right';
                const min = mainAxisCoord + overflow[minSide];
                const max = mainAxisCoord - overflow[maxSide];
                mainAxisCoord = (0, $jUtdR.clamp)(min, mainAxisCoord, max);
            }
            if (checkCrossAxis) {
                const minSide = crossAxis === 'y' ? 'top' : 'left';
                const maxSide = crossAxis === 'y' ? 'bottom' : 'right';
                const min = crossAxisCoord + overflow[minSide];
                const max = crossAxisCoord - overflow[maxSide];
                crossAxisCoord = (0, $jUtdR.clamp)(min, crossAxisCoord, max);
            }
            const limitedCoords = limiter.fn({
                ...state,
                [mainAxis]: mainAxisCoord,
                [crossAxis]: crossAxisCoord
            });
            return {
                ...limitedCoords,
                data: {
                    x: limitedCoords.x - x,
                    y: limitedCoords.y - y,
                    enabled: {
                        [mainAxis]: checkMainAxis,
                        [crossAxis]: checkCrossAxis
                    }
                }
            };
        }
    };
};
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */ const $33993daa3d6e1e95$export$7bf07e38f3dc4b69 = function(options) {
    if (options === void 0) options = {};
    return {
        options: options,
        fn (state) {
            const { x: x, y: y, placement: placement, rects: rects, middlewareData: middlewareData } = state;
            const { offset: offset = 0, mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = true } = (0, $jUtdR.evaluate)(options, state);
            const coords = {
                x: x,
                y: y
            };
            const crossAxis = (0, $jUtdR.getSideAxis)(placement);
            const mainAxis = (0, $jUtdR.getOppositeAxis)(crossAxis);
            let mainAxisCoord = coords[mainAxis];
            let crossAxisCoord = coords[crossAxis];
            const rawOffset = (0, $jUtdR.evaluate)(offset, state);
            const computedOffset = typeof rawOffset === 'number' ? {
                mainAxis: rawOffset,
                crossAxis: 0
            } : {
                mainAxis: 0,
                crossAxis: 0,
                ...rawOffset
            };
            if (checkMainAxis) {
                const len = mainAxis === 'y' ? 'height' : 'width';
                const limitMin = rects.reference[mainAxis] - rects.floating[len] + computedOffset.mainAxis;
                const limitMax = rects.reference[mainAxis] + rects.reference[len] - computedOffset.mainAxis;
                if (mainAxisCoord < limitMin) mainAxisCoord = limitMin;
                else if (mainAxisCoord > limitMax) mainAxisCoord = limitMax;
            }
            if (checkCrossAxis) {
                var _middlewareData$offse, _middlewareData$offse2;
                const len = mainAxis === 'y' ? 'width' : 'height';
                const isOriginSide = $33993daa3d6e1e95$var$originSides.has((0, $jUtdR.getSide)(placement));
                const limitMin = rects.reference[crossAxis] - rects.floating[len] + (isOriginSide ? ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse[crossAxis]) || 0 : 0) + (isOriginSide ? 0 : computedOffset.crossAxis);
                const limitMax = rects.reference[crossAxis] + rects.reference[len] + (isOriginSide ? 0 : ((_middlewareData$offse2 = middlewareData.offset) == null ? void 0 : _middlewareData$offse2[crossAxis]) || 0) - (isOriginSide ? computedOffset.crossAxis : 0);
                if (crossAxisCoord < limitMin) crossAxisCoord = limitMin;
                else if (crossAxisCoord > limitMax) crossAxisCoord = limitMax;
            }
            return {
                [mainAxis]: mainAxisCoord,
                [crossAxis]: crossAxisCoord
            };
        }
    };
};
/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */ const $33993daa3d6e1e95$export$346677f925de839c = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'size',
        options: options,
        async fn (state) {
            var _state$middlewareData, _state$middlewareData2;
            const { placement: placement, rects: rects, platform: platform, elements: elements } = state;
            const { apply: apply = ()=>{}, ...detectOverflowOptions } = (0, $jUtdR.evaluate)(options, state);
            const overflow = await $33993daa3d6e1e95$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const side = (0, $jUtdR.getSide)(placement);
            const alignment = (0, $jUtdR.getAlignment)(placement);
            const isYAxis = (0, $jUtdR.getSideAxis)(placement) === 'y';
            const { width: width, height: height } = rects.floating;
            let heightSide;
            let widthSide;
            if (side === 'top' || side === 'bottom') {
                heightSide = side;
                widthSide = alignment === (await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)) ? 'start' : 'end') ? 'left' : 'right';
            } else {
                widthSide = side;
                heightSide = alignment === 'end' ? 'top' : 'bottom';
            }
            const maximumClippingHeight = height - overflow.top - overflow.bottom;
            const maximumClippingWidth = width - overflow.left - overflow.right;
            const overflowAvailableHeight = (0, $jUtdR.min)(height - overflow[heightSide], maximumClippingHeight);
            const overflowAvailableWidth = (0, $jUtdR.min)(width - overflow[widthSide], maximumClippingWidth);
            const noShift = !state.middlewareData.shift;
            let availableHeight = overflowAvailableHeight;
            let availableWidth = overflowAvailableWidth;
            if ((_state$middlewareData = state.middlewareData.shift) != null && _state$middlewareData.enabled.x) availableWidth = maximumClippingWidth;
            if ((_state$middlewareData2 = state.middlewareData.shift) != null && _state$middlewareData2.enabled.y) availableHeight = maximumClippingHeight;
            if (noShift && !alignment) {
                const xMin = (0, $jUtdR.max)(overflow.left, 0);
                const xMax = (0, $jUtdR.max)(overflow.right, 0);
                const yMin = (0, $jUtdR.max)(overflow.top, 0);
                const yMax = (0, $jUtdR.max)(overflow.bottom, 0);
                if (isYAxis) availableWidth = width - 2 * (xMin !== 0 || xMax !== 0 ? xMin + xMax : (0, $jUtdR.max)(overflow.left, overflow.right));
                else availableHeight = height - 2 * (yMin !== 0 || yMax !== 0 ? yMin + yMax : (0, $jUtdR.max)(overflow.top, overflow.bottom));
            }
            await apply({
                ...state,
                availableWidth: availableWidth,
                availableHeight: availableHeight
            });
            const nextDimensions = await platform.getDimensions(elements.floating);
            if (width !== nextDimensions.width || height !== nextDimensions.height) return {
                reset: {
                    rects: true
                }
            };
            return {};
        }
    };
};

});
parcelRegister("jUtdR", function(module, exports) {
$parcel$export(module.exports, "sides", () => $e7e9ea41d02eb0ae$export$832b6fa47fa053d2);
$parcel$export(module.exports, "placements", () => $e7e9ea41d02eb0ae$export$803cd8101b6c182b);
$parcel$export(module.exports, "min", () => $e7e9ea41d02eb0ae$export$96ec731ed4dcb222);
$parcel$export(module.exports, "max", () => $e7e9ea41d02eb0ae$export$8960430cfd85939f);
$parcel$export(module.exports, "round", () => $e7e9ea41d02eb0ae$export$2077e0241d6afd3c);
$parcel$export(module.exports, "floor", () => $e7e9ea41d02eb0ae$export$a3fe094919f356fd);
$parcel$export(module.exports, "createCoords", () => $e7e9ea41d02eb0ae$export$a397704b5e280835);
$parcel$export(module.exports, "clamp", () => $e7e9ea41d02eb0ae$export$7d15b64cf5a3a4c4);
$parcel$export(module.exports, "evaluate", () => $e7e9ea41d02eb0ae$export$fef61f332f2c0afc);
$parcel$export(module.exports, "getSide", () => $e7e9ea41d02eb0ae$export$3c915306cb7fc97a);
$parcel$export(module.exports, "getAlignment", () => $e7e9ea41d02eb0ae$export$f0989780f32bfcda);
$parcel$export(module.exports, "getOppositeAxis", () => $e7e9ea41d02eb0ae$export$8a000a963141ac32);
$parcel$export(module.exports, "getAxisLength", () => $e7e9ea41d02eb0ae$export$320bd9d53520c68a);
$parcel$export(module.exports, "getSideAxis", () => $e7e9ea41d02eb0ae$export$f28e8f882010718a);
$parcel$export(module.exports, "getAlignmentAxis", () => $e7e9ea41d02eb0ae$export$2b57e0052a6d6d4c);
$parcel$export(module.exports, "getAlignmentSides", () => $e7e9ea41d02eb0ae$export$be42861551f17911);
$parcel$export(module.exports, "getOppositePlacement", () => $e7e9ea41d02eb0ae$export$9c5e28bad23365fa);
$parcel$export(module.exports, "getExpandedPlacements", () => $e7e9ea41d02eb0ae$export$496432a3699e50b1);
$parcel$export(module.exports, "getOppositeAlignmentPlacement", () => $e7e9ea41d02eb0ae$export$2b182c584985588b);
$parcel$export(module.exports, "getOppositeAxisPlacements", () => $e7e9ea41d02eb0ae$export$a9b6fb18fd92c3ec);
$parcel$export(module.exports, "getPaddingObject", () => $e7e9ea41d02eb0ae$export$598c291c29bc2e71);
$parcel$export(module.exports, "rectToClientRect", () => $e7e9ea41d02eb0ae$export$ee05aea0aeecbad4);
/**
 * Custom positioning reference element.
 * @see https://floating-ui.com/docs/virtual-elements
 */ const $e7e9ea41d02eb0ae$export$832b6fa47fa053d2 = [
    'top',
    'right',
    'bottom',
    'left'
];
const $e7e9ea41d02eb0ae$export$27b07d8a310ed8b5 = [
    'start',
    'end'
];
const $e7e9ea41d02eb0ae$export$803cd8101b6c182b = /*#__PURE__*/ $e7e9ea41d02eb0ae$export$832b6fa47fa053d2.reduce((acc, side)=>acc.concat(side, side + "-" + $e7e9ea41d02eb0ae$export$27b07d8a310ed8b5[0], side + "-" + $e7e9ea41d02eb0ae$export$27b07d8a310ed8b5[1]), []);
const $e7e9ea41d02eb0ae$export$96ec731ed4dcb222 = Math.min;
const $e7e9ea41d02eb0ae$export$8960430cfd85939f = Math.max;
const $e7e9ea41d02eb0ae$export$2077e0241d6afd3c = Math.round;
const $e7e9ea41d02eb0ae$export$a3fe094919f356fd = Math.floor;
const $e7e9ea41d02eb0ae$export$a397704b5e280835 = (v)=>({
        x: v,
        y: v
    });
const $e7e9ea41d02eb0ae$var$oppositeSideMap = {
    left: 'right',
    right: 'left',
    bottom: 'top',
    top: 'bottom'
};
const $e7e9ea41d02eb0ae$var$oppositeAlignmentMap = {
    start: 'end',
    end: 'start'
};
function $e7e9ea41d02eb0ae$export$7d15b64cf5a3a4c4(start, value, end) {
    return $e7e9ea41d02eb0ae$export$8960430cfd85939f(start, $e7e9ea41d02eb0ae$export$96ec731ed4dcb222(value, end));
}
function $e7e9ea41d02eb0ae$export$fef61f332f2c0afc(value, param) {
    return typeof value === 'function' ? value(param) : value;
}
function $e7e9ea41d02eb0ae$export$3c915306cb7fc97a(placement) {
    return placement.split('-')[0];
}
function $e7e9ea41d02eb0ae$export$f0989780f32bfcda(placement) {
    return placement.split('-')[1];
}
function $e7e9ea41d02eb0ae$export$8a000a963141ac32(axis) {
    return axis === 'x' ? 'y' : 'x';
}
function $e7e9ea41d02eb0ae$export$320bd9d53520c68a(axis) {
    return axis === 'y' ? 'height' : 'width';
}
const $e7e9ea41d02eb0ae$var$yAxisSides = /*#__PURE__*/ new Set([
    'top',
    'bottom'
]);
function $e7e9ea41d02eb0ae$export$f28e8f882010718a(placement) {
    return $e7e9ea41d02eb0ae$var$yAxisSides.has($e7e9ea41d02eb0ae$export$3c915306cb7fc97a(placement)) ? 'y' : 'x';
}
function $e7e9ea41d02eb0ae$export$2b57e0052a6d6d4c(placement) {
    return $e7e9ea41d02eb0ae$export$8a000a963141ac32($e7e9ea41d02eb0ae$export$f28e8f882010718a(placement));
}
function $e7e9ea41d02eb0ae$export$be42861551f17911(placement, rects, rtl) {
    if (rtl === void 0) rtl = false;
    const alignment = $e7e9ea41d02eb0ae$export$f0989780f32bfcda(placement);
    const alignmentAxis = $e7e9ea41d02eb0ae$export$2b57e0052a6d6d4c(placement);
    const length = $e7e9ea41d02eb0ae$export$320bd9d53520c68a(alignmentAxis);
    let mainAlignmentSide = alignmentAxis === 'x' ? alignment === (rtl ? 'end' : 'start') ? 'right' : 'left' : alignment === 'start' ? 'bottom' : 'top';
    if (rects.reference[length] > rects.floating[length]) mainAlignmentSide = $e7e9ea41d02eb0ae$export$9c5e28bad23365fa(mainAlignmentSide);
    return [
        mainAlignmentSide,
        $e7e9ea41d02eb0ae$export$9c5e28bad23365fa(mainAlignmentSide)
    ];
}
function $e7e9ea41d02eb0ae$export$496432a3699e50b1(placement) {
    const oppositePlacement = $e7e9ea41d02eb0ae$export$9c5e28bad23365fa(placement);
    return [
        $e7e9ea41d02eb0ae$export$2b182c584985588b(placement),
        oppositePlacement,
        $e7e9ea41d02eb0ae$export$2b182c584985588b(oppositePlacement)
    ];
}
function $e7e9ea41d02eb0ae$export$2b182c584985588b(placement) {
    return placement.replace(/start|end/g, (alignment)=>$e7e9ea41d02eb0ae$var$oppositeAlignmentMap[alignment]);
}
const $e7e9ea41d02eb0ae$var$lrPlacement = [
    'left',
    'right'
];
const $e7e9ea41d02eb0ae$var$rlPlacement = [
    'right',
    'left'
];
const $e7e9ea41d02eb0ae$var$tbPlacement = [
    'top',
    'bottom'
];
const $e7e9ea41d02eb0ae$var$btPlacement = [
    'bottom',
    'top'
];
function $e7e9ea41d02eb0ae$var$getSideList(side, isStart, rtl) {
    switch(side){
        case 'top':
        case 'bottom':
            if (rtl) return isStart ? $e7e9ea41d02eb0ae$var$rlPlacement : $e7e9ea41d02eb0ae$var$lrPlacement;
            return isStart ? $e7e9ea41d02eb0ae$var$lrPlacement : $e7e9ea41d02eb0ae$var$rlPlacement;
        case 'left':
        case 'right':
            return isStart ? $e7e9ea41d02eb0ae$var$tbPlacement : $e7e9ea41d02eb0ae$var$btPlacement;
        default:
            return [];
    }
}
function $e7e9ea41d02eb0ae$export$a9b6fb18fd92c3ec(placement, flipAlignment, direction, rtl) {
    const alignment = $e7e9ea41d02eb0ae$export$f0989780f32bfcda(placement);
    let list = $e7e9ea41d02eb0ae$var$getSideList($e7e9ea41d02eb0ae$export$3c915306cb7fc97a(placement), direction === 'start', rtl);
    if (alignment) {
        list = list.map((side)=>side + "-" + alignment);
        if (flipAlignment) list = list.concat(list.map($e7e9ea41d02eb0ae$export$2b182c584985588b));
    }
    return list;
}
function $e7e9ea41d02eb0ae$export$9c5e28bad23365fa(placement) {
    return placement.replace(/left|right|bottom|top/g, (side)=>$e7e9ea41d02eb0ae$var$oppositeSideMap[side]);
}
function $e7e9ea41d02eb0ae$export$1c66dbf1a9e34223(padding) {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        ...padding
    };
}
function $e7e9ea41d02eb0ae$export$598c291c29bc2e71(padding) {
    return typeof padding !== 'number' ? $e7e9ea41d02eb0ae$export$1c66dbf1a9e34223(padding) : {
        top: padding,
        right: padding,
        bottom: padding,
        left: padding
    };
}
function $e7e9ea41d02eb0ae$export$ee05aea0aeecbad4(rect) {
    const { x: x, y: y, width: width, height: height } = rect;
    return {
        width: width,
        height: height,
        top: y,
        left: x,
        right: x + width,
        bottom: y + height,
        x: x,
        y: y
    };
}

});


parcelRegister("lCfwu", function(module, exports) {
$parcel$export(module.exports, "getNodeName", () => $fbc93020b6eaf48c$export$651544f548703224);
$parcel$export(module.exports, "getWindow", () => $fbc93020b6eaf48c$export$38b2d434cce3ea22);
$parcel$export(module.exports, "getDocumentElement", () => $fbc93020b6eaf48c$export$e495491855dc5418);
$parcel$export(module.exports, "isElement", () => $fbc93020b6eaf48c$export$45a5e7f76e0caa8d);
$parcel$export(module.exports, "isHTMLElement", () => $fbc93020b6eaf48c$export$1b3bfaa9684536aa);
$parcel$export(module.exports, "isOverflowElement", () => $fbc93020b6eaf48c$export$989e911fa9af580a);
$parcel$export(module.exports, "getComputedStyle", () => $fbc93020b6eaf48c$export$3735103072e4a80);
$parcel$export(module.exports, "isTableElement", () => $fbc93020b6eaf48c$export$71535ffaa902797f);
$parcel$export(module.exports, "isTopLayer", () => $fbc93020b6eaf48c$export$89e651af02346cd4);
$parcel$export(module.exports, "isContainingBlock", () => $fbc93020b6eaf48c$export$d6c4e8150c35fed1);
$parcel$export(module.exports, "isWebKit", () => $fbc93020b6eaf48c$export$78551043582a6a98);
$parcel$export(module.exports, "getContainingBlock", () => $fbc93020b6eaf48c$export$940d8225183e1404);
$parcel$export(module.exports, "getParentNode", () => $fbc93020b6eaf48c$export$4e12058fc4d51d56);
$parcel$export(module.exports, "isLastTraversableNode", () => $fbc93020b6eaf48c$export$d1162fb0b6d4cd51);
$parcel$export(module.exports, "getNodeScroll", () => $fbc93020b6eaf48c$export$dc8fc79fa2800137);
$parcel$export(module.exports, "getOverflowAncestors", () => $fbc93020b6eaf48c$export$3b57c1601291186b);
$parcel$export(module.exports, "getFrameElement", () => $fbc93020b6eaf48c$export$7bf1f8740e3e34af);
function $fbc93020b6eaf48c$var$hasWindow() {
    return typeof window !== 'undefined';
}
function $fbc93020b6eaf48c$export$651544f548703224(node) {
    if ($fbc93020b6eaf48c$export$8ee0fc9ee280b4ee(node)) return (node.nodeName || '').toLowerCase();
    // Mocked nodes in testing environments may not be instances of Node. By
    // returning `#document` an infinite loop won't occur.
    // https://github.com/floating-ui/floating-ui/issues/2317
    return '#document';
}
function $fbc93020b6eaf48c$export$38b2d434cce3ea22(node) {
    var _node$ownerDocument;
    return (node == null || (_node$ownerDocument = node.ownerDocument) == null ? void 0 : _node$ownerDocument.defaultView) || window;
}
function $fbc93020b6eaf48c$export$e495491855dc5418(node) {
    var _ref;
    return (_ref = ($fbc93020b6eaf48c$export$8ee0fc9ee280b4ee(node) ? node.ownerDocument : node.document) || window.document) == null ? void 0 : _ref.documentElement;
}
function $fbc93020b6eaf48c$export$8ee0fc9ee280b4ee(value) {
    if (!$fbc93020b6eaf48c$var$hasWindow()) return false;
    return value instanceof Node || value instanceof $fbc93020b6eaf48c$export$38b2d434cce3ea22(value).Node;
}
function $fbc93020b6eaf48c$export$45a5e7f76e0caa8d(value) {
    if (!$fbc93020b6eaf48c$var$hasWindow()) return false;
    return value instanceof Element || value instanceof $fbc93020b6eaf48c$export$38b2d434cce3ea22(value).Element;
}
function $fbc93020b6eaf48c$export$1b3bfaa9684536aa(value) {
    if (!$fbc93020b6eaf48c$var$hasWindow()) return false;
    return value instanceof HTMLElement || value instanceof $fbc93020b6eaf48c$export$38b2d434cce3ea22(value).HTMLElement;
}
function $fbc93020b6eaf48c$export$af51f0f06c0f328a(value) {
    if (!$fbc93020b6eaf48c$var$hasWindow() || typeof ShadowRoot === 'undefined') return false;
    return value instanceof ShadowRoot || value instanceof $fbc93020b6eaf48c$export$38b2d434cce3ea22(value).ShadowRoot;
}
const $fbc93020b6eaf48c$var$invalidOverflowDisplayValues = /*#__PURE__*/ new Set([
    'inline',
    'contents'
]);
function $fbc93020b6eaf48c$export$989e911fa9af580a(element) {
    const { overflow: overflow, overflowX: overflowX, overflowY: overflowY, display: display } = $fbc93020b6eaf48c$export$3735103072e4a80(element);
    return /auto|scroll|overlay|hidden|clip/.test(overflow + overflowY + overflowX) && !$fbc93020b6eaf48c$var$invalidOverflowDisplayValues.has(display);
}
const $fbc93020b6eaf48c$var$tableElements = /*#__PURE__*/ new Set([
    'table',
    'td',
    'th'
]);
function $fbc93020b6eaf48c$export$71535ffaa902797f(element) {
    return $fbc93020b6eaf48c$var$tableElements.has($fbc93020b6eaf48c$export$651544f548703224(element));
}
const $fbc93020b6eaf48c$var$topLayerSelectors = [
    ':popover-open',
    ':modal'
];
function $fbc93020b6eaf48c$export$89e651af02346cd4(element) {
    return $fbc93020b6eaf48c$var$topLayerSelectors.some((selector)=>{
        try {
            return element.matches(selector);
        } catch (_e) {
            return false;
        }
    });
}
const $fbc93020b6eaf48c$var$transformProperties = [
    'transform',
    'translate',
    'scale',
    'rotate',
    'perspective'
];
const $fbc93020b6eaf48c$var$willChangeValues = [
    'transform',
    'translate',
    'scale',
    'rotate',
    'perspective',
    'filter'
];
const $fbc93020b6eaf48c$var$containValues = [
    'paint',
    'layout',
    'strict',
    'content'
];
function $fbc93020b6eaf48c$export$d6c4e8150c35fed1(elementOrCss) {
    const webkit = $fbc93020b6eaf48c$export$78551043582a6a98();
    const css = $fbc93020b6eaf48c$export$45a5e7f76e0caa8d(elementOrCss) ? $fbc93020b6eaf48c$export$3735103072e4a80(elementOrCss) : elementOrCss;
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
    // https://drafts.csswg.org/css-transforms-2/#individual-transforms
    return $fbc93020b6eaf48c$var$transformProperties.some((value)=>css[value] ? css[value] !== 'none' : false) || (css.containerType ? css.containerType !== 'normal' : false) || !webkit && (css.backdropFilter ? css.backdropFilter !== 'none' : false) || !webkit && (css.filter ? css.filter !== 'none' : false) || $fbc93020b6eaf48c$var$willChangeValues.some((value)=>(css.willChange || '').includes(value)) || $fbc93020b6eaf48c$var$containValues.some((value)=>(css.contain || '').includes(value));
}
function $fbc93020b6eaf48c$export$940d8225183e1404(element) {
    let currentNode = $fbc93020b6eaf48c$export$4e12058fc4d51d56(element);
    while($fbc93020b6eaf48c$export$1b3bfaa9684536aa(currentNode) && !$fbc93020b6eaf48c$export$d1162fb0b6d4cd51(currentNode)){
        if ($fbc93020b6eaf48c$export$d6c4e8150c35fed1(currentNode)) return currentNode;
        else if ($fbc93020b6eaf48c$export$89e651af02346cd4(currentNode)) return null;
        currentNode = $fbc93020b6eaf48c$export$4e12058fc4d51d56(currentNode);
    }
    return null;
}
function $fbc93020b6eaf48c$export$78551043582a6a98() {
    if (typeof CSS === 'undefined' || !CSS.supports) return false;
    return CSS.supports('-webkit-backdrop-filter', 'none');
}
const $fbc93020b6eaf48c$var$lastTraversableNodeNames = /*#__PURE__*/ new Set([
    'html',
    'body',
    '#document'
]);
function $fbc93020b6eaf48c$export$d1162fb0b6d4cd51(node) {
    return $fbc93020b6eaf48c$var$lastTraversableNodeNames.has($fbc93020b6eaf48c$export$651544f548703224(node));
}
function $fbc93020b6eaf48c$export$3735103072e4a80(element) {
    return $fbc93020b6eaf48c$export$38b2d434cce3ea22(element).getComputedStyle(element);
}
function $fbc93020b6eaf48c$export$dc8fc79fa2800137(element) {
    if ($fbc93020b6eaf48c$export$45a5e7f76e0caa8d(element)) return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
    return {
        scrollLeft: element.scrollX,
        scrollTop: element.scrollY
    };
}
function $fbc93020b6eaf48c$export$4e12058fc4d51d56(node) {
    if ($fbc93020b6eaf48c$export$651544f548703224(node) === 'html') return node;
    const result = // Step into the shadow DOM of the parent of a slotted node.
    node.assignedSlot || // DOM Element detected.
    node.parentNode || // ShadowRoot detected.
    $fbc93020b6eaf48c$export$af51f0f06c0f328a(node) && node.host || // Fallback.
    $fbc93020b6eaf48c$export$e495491855dc5418(node);
    return $fbc93020b6eaf48c$export$af51f0f06c0f328a(result) ? result.host : result;
}
function $fbc93020b6eaf48c$export$7cd01a57c8ca906c(node) {
    const parentNode = $fbc93020b6eaf48c$export$4e12058fc4d51d56(node);
    if ($fbc93020b6eaf48c$export$d1162fb0b6d4cd51(parentNode)) return node.ownerDocument ? node.ownerDocument.body : node.body;
    if ($fbc93020b6eaf48c$export$1b3bfaa9684536aa(parentNode) && $fbc93020b6eaf48c$export$989e911fa9af580a(parentNode)) return parentNode;
    return $fbc93020b6eaf48c$export$7cd01a57c8ca906c(parentNode);
}
function $fbc93020b6eaf48c$export$3b57c1601291186b(node, list, traverseIframes) {
    var _node$ownerDocument2;
    if (list === void 0) list = [];
    if (traverseIframes === void 0) traverseIframes = true;
    const scrollableAncestor = $fbc93020b6eaf48c$export$7cd01a57c8ca906c(node);
    const isBody = scrollableAncestor === ((_node$ownerDocument2 = node.ownerDocument) == null ? void 0 : _node$ownerDocument2.body);
    const win = $fbc93020b6eaf48c$export$38b2d434cce3ea22(scrollableAncestor);
    if (isBody) {
        const frameElement = $fbc93020b6eaf48c$export$7bf1f8740e3e34af(win);
        return list.concat(win, win.visualViewport || [], $fbc93020b6eaf48c$export$989e911fa9af580a(scrollableAncestor) ? scrollableAncestor : [], frameElement && traverseIframes ? $fbc93020b6eaf48c$export$3b57c1601291186b(frameElement) : []);
    }
    return list.concat(scrollableAncestor, $fbc93020b6eaf48c$export$3b57c1601291186b(scrollableAncestor, [], traverseIframes));
}
function $fbc93020b6eaf48c$export$7bf1f8740e3e34af(win) {
    return win.parent && Object.getPrototypeOf(win.parent) ? win.frameElement : null;
}

});


parcelRegister("g8g1T", function(module, exports) {
$parcel$export(module.exports, "default", () => $bbe9d3cebc9f4f52$export$2e2bcd8739ae039);

var $5FkrB = parcelRequire("5FkrB");
var $bbe9d3cebc9f4f52$export$2e2bcd8739ae039 = (0, $5FkrB.useLayoutEffect);

});

parcelRegister("e8kqY", function(module, exports) {
$parcel$export(module.exports, "default", () => $a4a1a9cdc7bf2d54$export$2e2bcd8739ae039);
/* visually-hidden.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");
var $a4a1a9cdc7bf2d54$var$visuallyHiddenStyles = null;
/**
 * __Visually hidden__
 *
 * A composable element to apply a visually hidden effect to children.
 * Useful for accessibility compliance.
 *
 * @example
 * ```jsx
 * import VisuallyHidden from '@atlaskit/visually-hidden';
 *
 * export default () => (
 *   <div style={{ border: '1px solid black' }}>
 *      There is text hidden between the brackets [
 *      <VisuallyHidden>Can't see me!</VisuallyHidden>]
 *   </div>
 * );
 * ```
 */ var $a4a1a9cdc7bf2d54$var$VisuallyHidden = function VisuallyHidden(_ref) {
    var children = _ref.children, testId = _ref.testId, role = _ref.role, id = _ref.id;
    return /*#__PURE__*/ $5FkrB.createElement("span", {
        id: id,
        "data-testid": testId,
        role: role,
        className: (0, $970q7.default)([
            "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19itidpf _1reo15vq _18m915vq _1bsbt94y _4t3it94y _kqswstnw _ogto7mnp _uiztglyw _o5721q9c"
        ])
    }, children);
};
var $a4a1a9cdc7bf2d54$export$2e2bcd8739ae039 = $a4a1a9cdc7bf2d54$var$VisuallyHidden;

});

parcelRegister("lnqhJ", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => (parcelRequire("9xOmG")).default);
$parcel$export(module.exports, "ModalTransition", () => (parcelRequire("4dmfM")).default);
$parcel$export(module.exports, "ModalHeader", () => (parcelRequire("9Ayri")).default);
$parcel$export(module.exports, "ModalTitle", () => (parcelRequire("9Bq1o")).default);
$parcel$export(module.exports, "ModalBody", () => (parcelRequire("7FyjL")).default);
$parcel$export(module.exports, "ModalFooter", () => (parcelRequire("bhMlj")).default);
$parcel$export(module.exports, "CloseButton", () => (parcelRequire("3aP8P")).CloseButton);
$parcel$export(module.exports, "useModal", () => (parcelRequire("2td33")).useModal);

var $9xOmG = parcelRequire("9xOmG");

var $4dmfM = parcelRequire("4dmfM");

var $9Ayri = parcelRequire("9Ayri");

var $9Bq1o = parcelRequire("9Bq1o");

var $7FyjL = parcelRequire("7FyjL");

var $bhMlj = parcelRequire("bhMlj");

var $3aP8P = parcelRequire("3aP8P");

var $2td33 = parcelRequire("2td33");

});
parcelRegister("9xOmG", function(module, exports) {
$parcel$export(module.exports, "default", () => $6f2e438a9235242f$export$2e2bcd8739ae039);

var $kqp0i = parcelRequire("kqp0i");

var $5FkrB = parcelRequire("5FkrB");

var $74Zh5 = parcelRequire("74Zh5");

var $69J3E = parcelRequire("69J3E");

var $3FlkA = parcelRequire("3FlkA");

var $ijhrq = parcelRequire("ijhrq");

var $1qBWl = parcelRequire("1qBWl");

var $6qCqe = parcelRequire("6qCqe");

var $cZQqC = parcelRequire("cZQqC");

var $eQzrx = parcelRequire("eQzrx");

var $6bqMl = parcelRequire("6bqMl");

var $H74DA = parcelRequire("H74DA");

var $6MmJQ = parcelRequire("6MmJQ");

var $60tyR = parcelRequire("60tyR");

var $deUvr = parcelRequire("deUvr");
var $6f2e438a9235242f$var$fillScreenStyles = (0, $74Zh5.css)({
    width: '100vw',
    height: '100vh',
    position: 'fixed',
    insetBlockStart: "var(--ds-space-0, 0)",
    insetInlineStart: "var(--ds-space-0, 0)",
    overflowY: 'auto',
    WebkitOverflowScrolling: 'touch'
});
var $6f2e438a9235242f$var$allowlistElements = function allowlistElements(element, callback) {
    // Allow focus to reach elements outside the modal:
    // if AUI dialog is allowListed and visible
    if (!!document.querySelector('.aui-blanket:not([hidden])')) return false;
    // allows to pass a callback function to allow elements be ignored by focus lock
    if (typeof callback === 'function') return callback(element);
    return true;
};
/**
 * __Modal wrapper__
 *
 * A modal wrapper displays content that requires user interaction, in a layer above the page.
 * This component is primary container for other modal components.
 *
 * - [Examples](https://atlassian.design/components/modal-dialog/examples)
 * - [Code](https://atlassian.design/components/modal-dialog/code)
 * - [Usage](https://atlassian.design/components/modal-dialog/usage)
 */ var $6f2e438a9235242f$var$ModalWrapper = function ModalWrapper(props) {
    var _props$autoFocus = props.autoFocus, autoFocus = _props$autoFocus === void 0 ? true : _props$autoFocus, focusLockAllowlist = props.focusLockAllowlist, _props$shouldCloseOnE = props.shouldCloseOnEscapePress, shouldCloseOnEscapePress = _props$shouldCloseOnE === void 0 ? true : _props$shouldCloseOnE, _props$shouldCloseOnO = props.shouldCloseOnOverlayClick, shouldCloseOnOverlayClick = _props$shouldCloseOnO === void 0 ? true : _props$shouldCloseOnO, _props$shouldScrollIn = props.shouldScrollInViewport, shouldScrollInViewport = _props$shouldScrollIn === void 0 ? false : _props$shouldScrollIn, _props$shouldReturnFo = props.shouldReturnFocus, shouldReturnFocus = _props$shouldReturnFo === void 0 ? true : _props$shouldReturnFo, stackIndexOverride = props.stackIndex, providedOnClose = props.onClose, _props$onStackChange = props.onStackChange, onStackChange = _props$onStackChange === void 0 ? (0, $6qCqe.default) : _props$onStackChange, isBlanketHidden = props.isBlanketHidden, children = props.children, height = props.height, width = props.width, onCloseComplete = props.onCloseComplete, onOpenComplete = props.onOpenComplete, label = props.label, testId = props.testId;
    var calculatedStackIndex = (0, $60tyR.default)({
        onStackChange: onStackChange
    });
    var stackIndex = stackIndexOverride || calculatedStackIndex;
    var isForeground = stackIndex === 0;
    // When a user supplies a ref to focus we skip auto focus via react-focus-lock
    var autoFocusLock = typeof autoFocus === 'boolean' ? autoFocus : false;
    var onCloseHandler = (0, $ijhrq.usePlatformLeafEventHandler)({
        fn: providedOnClose || (0, $6qCqe.default),
        action: 'closed',
        componentName: 'modalDialog',
        packageName: "@atlaskit/modal-dialog",
        packageVersion: "13.4.0"
    });
    var onBlanketClicked = (0, $5FkrB.useCallback)(function(e) {
        if (shouldCloseOnOverlayClick) onCloseHandler(e);
    }, [
        shouldCloseOnOverlayClick,
        onCloseHandler
    ]);
    // This ensures to prevent additional re-renders while nothing is passed to focusLockAllowlist explicitly.
    var allowListCallback = (0, $5FkrB.useCallback)(function(element) {
        return $6f2e438a9235242f$var$allowlistElements(element, focusLockAllowlist);
    }, [
        focusLockAllowlist
    ]);
    (0, $deUvr.default)();
    var modalDialogWithBlanket = (0, $74Zh5.jsx)((0, $1qBWl.default), {
        isTinted: !isBlanketHidden,
        onBlanketClicked: onBlanketClicked,
        testId: testId && "".concat(testId, "--blanket")
    }, (0, $74Zh5.jsx)((0, $6MmJQ.default), {
        testId: testId,
        label: label,
        autoFocus: autoFocus,
        stackIndex: stackIndex,
        onClose: onCloseHandler,
        shouldCloseOnEscapePress: shouldCloseOnEscapePress && isForeground,
        shouldScrollInViewport: shouldScrollInViewport,
        height: height,
        width: width,
        onCloseComplete: onCloseComplete,
        onOpenComplete: onOpenComplete,
        hasProvidedOnClose: Boolean(providedOnClose)
    }, children));
    var returnFocus = true;
    var onDeactivation;
    if ('boolean' === typeof shouldReturnFocus) returnFocus = shouldReturnFocus;
    else onDeactivation = function onDeactivation() {
        window.setTimeout(function() {
            var _shouldReturnFocus$cu;
            (_shouldReturnFocus$cu = shouldReturnFocus.current) === null || _shouldReturnFocus$cu === void 0 || _shouldReturnFocus$cu.focus();
        }, 0);
    };
    return (0, $74Zh5.jsx)((0, $cZQqC.Layering), {
        isDisabled: false
    }, (0, $74Zh5.jsx)((0, $6bqMl.default), {
        zIndex: (0, $H74DA.layers).modal()
    }, (0, $74Zh5.jsx)((0, $eQzrx.default), null, function(fadeInProps) {
        return (0, $74Zh5.jsx)("div", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, fadeInProps, {
            css: $6f2e438a9235242f$var$fillScreenStyles,
            "aria-hidden": !isForeground
        }), (0, $74Zh5.jsx)((0, $69J3E.default), {
            autoFocus: autoFocusLock,
            returnFocus: returnFocus,
            onDeactivation: onDeactivation,
            whiteList: allowListCallback
        }, (0, $74Zh5.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3FlkA))), null), shouldScrollInViewport ? (0, $74Zh5.jsx)((0, $3FlkA.TouchScrollable), null, modalDialogWithBlanket) : modalDialogWithBlanket));
    })));
};
var $6f2e438a9235242f$export$2e2bcd8739ae039 = $6f2e438a9235242f$var$ModalWrapper;

});
parcelRegister("ijhrq", function(module, exports) {
$parcel$export(module.exports, "usePlatformLeafEventHandler", () => $d54787db068fe266$export$a4687b0234b40e28);

var $25nEq = parcelRequire("25nEq");

var $5FkrB = parcelRequire("5FkrB");

var $h0OAL = parcelRequire("h0OAL");

var $b6wQg = parcelRequire("b6wQg");
function $d54787db068fe266$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $d54787db068fe266$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $d54787db068fe266$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $d54787db068fe266$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $d54787db068fe266$export$a4687b0234b40e28(_ref) {
    var fn = _ref.fn, action = _ref.action, componentName = _ref.componentName, actionSubject = _ref.actionSubject, packageName = _ref.packageName, packageVersion = _ref.packageVersion, analyticsData = _ref.analyticsData;
    var _useAnalyticsEvents = (0, $h0OAL.useAnalyticsEvents)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
    // We put analyticsData and fn in a ref so that we don't need to break
    // memoization.
    // Generally these could be defined by consumers inline
    // and so we do this to avoid breaking memoization of useCallback
    var dataRef = (0, $b6wQg.useTrackedRef)(analyticsData);
    var fnRef = (0, $b6wQg.useTrackedRef)(fn);
    var handler = (0, $5FkrB.useCallback)(function(value) {
        var analyticsEvent = createAnalyticsEvent({
            action: action,
            actionSubject: actionSubject || componentName,
            attributes: {
                componentName: componentName,
                packageName: packageName,
                packageVersion: packageVersion
            }
        });
        // To avoid wrapping this component in AnalyticsContext we manually
        // push the parent context's meta data into the context.
        // Note: this new 'context'
        var context = $d54787db068fe266$var$_objectSpread({
            componentName: componentName,
            packageName: packageName,
            packageVersion: packageVersion
        }, dataRef.current);
        analyticsEvent.context.push(context);
        // fire an event on the atlaskit channel
        var clone = analyticsEvent.clone();
        if (clone) clone.fire('atlaskit');
        fnRef.current(value, analyticsEvent);
    }, [
        // These are strings and won't change
        action,
        componentName,
        actionSubject,
        packageName,
        packageVersion,
        // This function is memoized in the context
        createAnalyticsEvent,
        // these are a stable ref because of the useTrackedRef hook
        dataRef,
        fnRef
    ]);
    return handler;
}

});
parcelRegister("h0OAL", function(module, exports) {
$parcel$export(module.exports, "useAnalyticsEvents", () => $c629ae4a42f07e5a$export$5bf35293e545f20c);

var $dLGML = parcelRequire("dLGML");

var $4rPfW = parcelRequire("4rPfW");

var $l8CIV = parcelRequire("l8CIV");
function $c629ae4a42f07e5a$export$5bf35293e545f20c() {
    var analyticsContext = (0, $l8CIV.useAnalyticsContext)();
    var createAnalyticsEvent = (0, $dLGML.useCallbackOne)(function(payload) {
        return new (0, $4rPfW.default)({
            context: analyticsContext.getAtlaskitAnalyticsContext(),
            handlers: analyticsContext.getAtlaskitAnalyticsEventHandlers(),
            payload: payload
        });
    }, [
        analyticsContext
    ]);
    return {
        createAnalyticsEvent: createAnalyticsEvent
    };
}

});
parcelRegister("4rPfW", function(module, exports) {
$parcel$export(module.exports, "default", () => $33d17171e94b4e72$export$2e2bcd8739ae039);

var $fC8ib = parcelRequire("fC8ib");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $kIXpt = parcelRequire("kIXpt");

var $cYPzS = parcelRequire("cYPzS");

var $lwlXp = parcelRequire("lwlXp");

var $eyuDe = parcelRequire("eyuDe");

var $25nEq = parcelRequire("25nEq");

var $bc7q5 = parcelRequire("bc7q5");
function $33d17171e94b4e72$var$_callSuper(t, o, e) {
    return o = (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(o), (0, (/*@__PURE__*/$parcel$interopDefault($kIXpt)))(t, $33d17171e94b4e72$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(t).constructor) : o.apply(t, e));
}
function $33d17171e94b4e72$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($33d17171e94b4e72$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $33d17171e94b4e72$var$_superPropGet(t, o, e, r) {
    var p = (0, (/*@__PURE__*/$parcel$interopDefault($lwlXp)))((0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(1 & r ? t.prototype : t), o, e);
    return 2 & r && "function" == typeof p ? function(t) {
        return p.apply(e, t);
    } : p;
}
var $33d17171e94b4e72$export$35f8383928ba8d7 = function isUIAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $33d17171e94b4e72$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isUIAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === 'UIAnalyticsEvent';
};
var $33d17171e94b4e72$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_AnalyticsEvent) {
    function UIAnalyticsEvent(props) {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, UIAnalyticsEvent);
        _this = $33d17171e94b4e72$var$_callSuper(this, UIAnalyticsEvent, [
            props
        ]);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "_isUIAnalyticsEvent", true);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "clone", function() {
            if (_this.hasFired) return null;
            var context = (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(_this.context);
            var handlers = (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(_this.handlers);
            /**
       * A hacky "deep clone" of the object. This is limited in that it wont
       * support functions, regexs, Maps, Sets, etc, but none of those need to
       * be represented in our payload.
       */ var payload = JSON.parse(JSON.stringify(_this.payload));
            return new UIAnalyticsEvent({
                context: context,
                handlers: handlers,
                payload: payload
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "fire", function(channel) {
            if (_this.hasFired) return;
            _this.handlers.forEach(function(handler) {
                return handler(_this, channel);
            });
            _this.hasFired = true;
        });
        _this.context = props.context || [];
        _this.handlers = props.handlers || [];
        _this.hasFired = false;
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($eyuDe)))(UIAnalyticsEvent, _AnalyticsEvent);
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(UIAnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (this.hasFired) return this;
                return $33d17171e94b4e72$var$_superPropGet(UIAnalyticsEvent, "update", this, 3)([
                    updater
                ]);
            }
        }
    ]);
}((0, $bc7q5.default));

});
parcelRegister("bc7q5", function(module, exports) {
$parcel$export(module.exports, "default", () => $826692188de79168$export$2e2bcd8739ae039);

var $ekGgq = parcelRequire("ekGgq");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $25nEq = parcelRequire("25nEq");
function $826692188de79168$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $826692188de79168$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $826692188de79168$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $826692188de79168$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $826692188de79168$export$ad4be5c2ec28cecf = function isAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $826692188de79168$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === 'AnalyticsEvent';
};
var $826692188de79168$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function AnalyticsEvent(props) {
        var _this = this;
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, AnalyticsEvent);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "_isAnalyticsEvent", true);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "clone", function() {
            // just a shallow clone, don't change sub refs unless you want to
            // affect the original's too
            var payload = $826692188de79168$var$_objectSpread({}, _this.payload);
            return new AnalyticsEvent({
                payload: payload
            });
        });
        this.payload = props.payload;
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(AnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (typeof updater === 'function') this.payload = updater(this.payload);
                if ((0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(updater) === 'object') this.payload = $826692188de79168$var$_objectSpread($826692188de79168$var$_objectSpread({}, this.payload), updater);
                return this;
            }
        }
    ]);
}();

});


parcelRegister("l8CIV", function(module, exports) {
$parcel$export(module.exports, "useAnalyticsContext", () => $f638620dd2640057$export$d1f587f82ad51c4);

var $5FkrB = parcelRequire("5FkrB");

var $iyyOp = parcelRequire("iyyOp");
var $f638620dd2640057$export$d1f587f82ad51c4 = function useAnalyticsContext() {
    return (0, $5FkrB.useContext)((0, $iyyOp.default));
};

});


parcelRegister("b6wQg", function(module, exports) {
$parcel$export(module.exports, "useTrackedRef", () => $8159bafcb7f117ba$export$1d27a74659855e44);

var $5FkrB = parcelRequire("5FkrB");
var $8159bafcb7f117ba$export$1d27a74659855e44 = function useTrackedRef(value) {
    var ref = (0, $5FkrB.useRef)(value);
    ref.current = value;
    return ref;
};

});


parcelRegister("6qCqe", function(module, exports) {
$parcel$export(module.exports, "default", () => $4ae2f99d0bf03fb2$export$2e2bcd8739ae039);
/**
 * An empty function which does nothing.
 */ function $4ae2f99d0bf03fb2$export$2e2bcd8739ae039() {}

});

parcelRegister("cZQqC", function(module, exports) {
$parcel$export(module.exports, "LevelContext", () => $9763d9ba42881e64$export$650d12d3c2ddb8fc);
$parcel$export(module.exports, "TopLevelContext", () => $9763d9ba42881e64$export$48b383b280e20440);
$parcel$export(module.exports, "Layering", () => $9763d9ba42881e64$export$7c885f891c940977);

var $25nEq = parcelRequire("25nEq");

var $5FkrB = parcelRequire("5FkrB");

var $6qCqe = parcelRequire("6qCqe");

var $id6Cu = parcelRequire("id6Cu");
function $9763d9ba42881e64$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $9763d9ba42881e64$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $9763d9ba42881e64$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $9763d9ba42881e64$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $9763d9ba42881e64$export$650d12d3c2ddb8fc = /*#__PURE__*/ (0, $5FkrB.createContext)(0);
var $9763d9ba42881e64$export$48b383b280e20440 = /*#__PURE__*/ (0, $5FkrB.createContext)({
    topLevelRef: {
        current: null
    },
    layerList: {
        current: null
    },
    setTopLevel: (0, $6qCqe.default)
});
/**
 *
 *  @internal
 * Context Provider Component which provider the current level of nested layers
 * It handles level management when it mounts and unmounts
 *
 */ var $9763d9ba42881e64$var$LevelProvider = function LevelProvider(_ref) {
    var children = _ref.children, currentLevel = _ref.currentLevel;
    var _useContext = (0, $5FkrB.useContext)($9763d9ba42881e64$export$48b383b280e20440), setTopLevel = _useContext.setTopLevel, topLevelRef = _useContext.topLevelRef, layerList = _useContext.layerList;
    // This is not unstable, it will run once for ref creation.
    // eslint-disable-next-line  @repo/internal/react/disallow-unstable-values
    var id = (0, $5FkrB.useRef)((0, $id6Cu.fg)('layering-top-level-use-array') ? Math.random().toString(36) : '');
    if (!(0, $id6Cu.fg)('layering-top-level-use-array')) {
        if (topLevelRef.current === null || currentLevel > topLevelRef.current) setTopLevel(currentLevel);
    }
    if (!(0, $id6Cu.fg)('layering-top-level-use-array')) // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $5FkrB.useEffect)(function() {
        return function() {
            // avoid immediate cleanup using setTimeout when component unmount
            // this will make sure non-top layer components can get the correct top level value
            // when multiple layers trigger onClose in sequence
            setTimeout(function() {
                setTopLevel(currentLevel - 1);
            }, 0);
        };
    }, [
        setTopLevel,
        currentLevel,
        topLevelRef
    ]);
    if ((0, $id6Cu.fg)('layering-top-level-use-array')) // Remove eslint error on FG cleanup
    // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $5FkrB.useEffect)(function() {
        var safeLayerList = layerList === null || layerList === void 0 ? void 0 : layerList.current;
        var safeId = id.current;
        if (!safeLayerList) return;
        safeLayerList.push(safeId);
        return function() {
            var index = safeLayerList.indexOf(safeId);
            if (index > -1) safeLayerList.splice(index, 1);
        };
    }, [
        layerList,
        id
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement($9763d9ba42881e64$export$650d12d3c2ddb8fc.Provider, {
        value: currentLevel
    }, children);
};
/**
 *
 *  @internal
 * Context Provider Component which provides the top level of all nested layers
 * It provides initial top level ref value as 0 and set top level method
 *
 */ var $9763d9ba42881e64$var$LayeringProvider = function LayeringProvider(_ref2) {
    var children = _ref2.children;
    var topLevelRef = (0, $5FkrB.useRef)(0);
    var layerList = (0, $5FkrB.useRef)([]);
    var value = (0, $5FkrB.useMemo)(function() {
        return $9763d9ba42881e64$var$_objectSpread({
            topLevelRef: topLevelRef,
            setTopLevel: function setTopLevel(level) {
                topLevelRef.current = level;
            }
        }, (0, $id6Cu.fg)('layering-top-level-use-array') ? {
            layerList: layerList
        } : {});
    }, [
        topLevelRef
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement($9763d9ba42881e64$export$48b383b280e20440.Provider, {
        value: value
    }, children);
};
var $9763d9ba42881e64$export$7c885f891c940977 = function Layering(_ref3) {
    var children = _ref3.children, _ref3$isDisabled = _ref3.isDisabled, isDisabled = _ref3$isDisabled === void 0 ? true : _ref3$isDisabled;
    var currentLevel = (0, $5FkrB.useContext)($9763d9ba42881e64$export$650d12d3c2ddb8fc);
    if (isDisabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).Fragment, null, children);
    var isNested = currentLevel > 0;
    var content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement($9763d9ba42881e64$var$LevelProvider, {
        currentLevel: currentLevel + 1
    }, children);
    return isNested ? content : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement($9763d9ba42881e64$var$LayeringProvider, null, content);
};

});
parcelRegister("id6Cu", function(module, exports) {
$parcel$export(module.exports, "fg", () => $d41e936dc38089ce$export$b40ec24ac8275656);

var $jldV4 = parcelRequire("jldV4");
function $d41e936dc38089ce$export$ba05d765b8392e5e(flagResolver) {
    (0, $jldV4.setBooleanResolver)(flagResolver);
}
function $d41e936dc38089ce$export$470e5c2be1411c89(name) {
    return (0, $jldV4.resolveBooleanFlag)(name);
}
function $d41e936dc38089ce$export$b40ec24ac8275656(name) {
    return (0, $jldV4.resolveBooleanFlag)(name);
}

});
parcelRegister("jldV4", function(module, exports) {
$parcel$export(module.exports, "setBooleanResolver", () => $e14ac69c06a98959$export$f2b591175b3e424c);
$parcel$export(module.exports, "resolveBooleanFlag", () => $e14ac69c06a98959$export$6333b6aff9fc6275);

var $jZlo3 = parcelRequire("jZlo3");

var $lzj0n = parcelRequire("lzj0n");

var $3ZMUU = parcelRequire("3ZMUU");
var $e14ac69c06a98959$var$pkgName = '@atlaskit/platform-feature-flags';
var $e14ac69c06a98959$export$7e41b1b2bdee3f98 = '__PLATFORM_FEATURE_FLAGS__';
var $e14ac69c06a98959$var$hasProcessEnv = typeof $3ZMUU !== 'undefined' && typeof $3ZMUU.env !== 'undefined';
// FF global overrides can be configured by test runners or Storybook
var $e14ac69c06a98959$var$ENV_ENABLE_PLATFORM_FF = $e14ac69c06a98959$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
// STORYBOOK_ENABLE_PLATFORM_FF is included as storybook only allows env vars prefixed with STORYBOOK
// https://github.com/storybookjs/storybook/issues/12270
var $e14ac69c06a98959$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF = $e14ac69c06a98959$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
var $e14ac69c06a98959$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE = $e14ac69c06a98959$var$ENV_ENABLE_PLATFORM_FF || $e14ac69c06a98959$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF;
var $e14ac69c06a98959$var$DEFAULT_PFF_GLOBAL = {
    booleanResolver: undefined
};
var $e14ac69c06a98959$var$globalVar = typeof window !== 'undefined' ? window : globalThis;
$e14ac69c06a98959$var$globalVar[$e14ac69c06a98959$export$7e41b1b2bdee3f98] = $e14ac69c06a98959$var$globalVar[$e14ac69c06a98959$export$7e41b1b2bdee3f98] || $e14ac69c06a98959$var$DEFAULT_PFF_GLOBAL;
function $e14ac69c06a98959$export$f2b591175b3e424c(resolver) {
    $e14ac69c06a98959$var$globalVar[$e14ac69c06a98959$export$7e41b1b2bdee3f98].booleanResolver = resolver;
}
function $e14ac69c06a98959$export$6333b6aff9fc6275(flagKey) {
    if ($e14ac69c06a98959$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE) {
        (0, $lzj0n.debug)('[%s]: The feature flags were enabled while running tests. The flag "%s" will be always enabled.', $e14ac69c06a98959$var$pkgName, flagKey);
        return true;
    }
    try {
        var _globalVar$PFF_GLOBAL, _globalVar$PFF_GLOBAL2, _globalVar$PFF_GLOBAL3;
        // booleanResolver will be empty for products like Trello, Elevate, Recruit etc.
        // Currently only Confluence, Jira and Bitbucket has set it.
        if (((_globalVar$PFF_GLOBAL = $e14ac69c06a98959$var$globalVar[$e14ac69c06a98959$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL === void 0 ? void 0 : _globalVar$PFF_GLOBAL.booleanResolver) === undefined || ((_globalVar$PFF_GLOBAL2 = $e14ac69c06a98959$var$globalVar[$e14ac69c06a98959$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL2 === void 0 ? void 0 : _globalVar$PFF_GLOBAL2.booleanResolver) === null) // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
        return (0, $jZlo3.default).checkGate(flagKey);
        var result = (_globalVar$PFF_GLOBAL3 = $e14ac69c06a98959$var$globalVar[$e14ac69c06a98959$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL3 === void 0 ? void 0 : _globalVar$PFF_GLOBAL3.booleanResolver(flagKey);
        if (typeof result !== 'boolean') {
            // eslint-disable-next-line no-console
            console.warn("".concat(flagKey, " resolved to a non-boolean value, returning false for safety"));
            return false;
        }
        return result;
    } catch (e) {
        return false;
    }
}

});
parcelRegister("jZlo3", function(module, exports) {
$parcel$export(module.exports, "default", () => $e8d44dd74978c315$export$2e2bcd8739ae039);

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $25nEq = parcelRequire("25nEq");

var $5o85S = parcelRequire("5o85S");

var $an40Y = parcelRequire("an40Y");



var $e8d44dd74978c315$var$_FeatureGates;
/**
 * Access the FeatureGates object via the default export.
 * ```ts
 * import FeatureGates from '@atlaskit/feature-gate-js-client';
 * ```
 */ var $e8d44dd74978c315$var$FeatureGates = /*#__PURE__*/ function() {
    function FeatureGates() {
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, FeatureGates);
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(FeatureGates, null, [
        {
            key: "isGateExists",
            value: function isGateExists(gateName) {
                return this.client.isGateExist(gateName);
            }
        },
        {
            key: "isExperimentExists",
            value: function isExperimentExists(experimentName) {
                return this.client.isExperimentExist(experimentName);
            }
        }
    ]);
}();
$e8d44dd74978c315$var$_FeatureGates = $e8d44dd74978c315$var$FeatureGates;
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($e8d44dd74978c315$var$FeatureGates, "client", new (0, $5o85S.Client)());
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($e8d44dd74978c315$var$FeatureGates, "hasCheckGateErrorOccurred", false);
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($e8d44dd74978c315$var$FeatureGates, "hasGetExperimentValueErrorOccurred", false);
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($e8d44dd74978c315$var$FeatureGates, "checkGate", function(gateName, options) {
    try {
        // Check if the CRITERION override mechanism is available
        if (typeof window !== 'undefined' && window.__CRITERION__ && typeof window.__CRITERION__.getFeatureFlagOverride === 'function') {
            // Attempt to retrieve an override value for the feature gate
            var overrideValue = window.__CRITERION__.getFeatureFlagOverride(gateName);
            // If an override value is found, return it immediately
            if (overrideValue !== undefined) return overrideValue;
        }
    } catch (error) {
        // Log the first occurrence of the error
        if (!$e8d44dd74978c315$var$_FeatureGates.hasCheckGateErrorOccurred) {
            // eslint-disable-next-line no-console
            console.warn({
                msg: 'An error has occurred checking the feature gate from criterion override. Only the first occurrence of this error is logged.',
                gateName: gateName,
                error: error
            });
            $e8d44dd74978c315$var$_FeatureGates.hasCheckGateErrorOccurred = true;
        }
    }
    // Proceed with the main logic if no override is found
    return $e8d44dd74978c315$var$_FeatureGates.client.checkGate(gateName, options);
});
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($e8d44dd74978c315$var$FeatureGates, "getExperimentValue", function(experimentName, parameterName, defaultValue, options) {
    try {
        // Check if the CRITERION override mechanism is available
        if (typeof window !== 'undefined' && window.__CRITERION__ && typeof window.__CRITERION__.getExperimentValueOverride === 'function') {
            var overrideValue = window.__CRITERION__.getExperimentValueOverride(experimentName, parameterName);
            if (overrideValue !== undefined && overrideValue !== null) return overrideValue;
        }
    } catch (error) {
        // Log the first occurrence of the error
        if (!$e8d44dd74978c315$var$_FeatureGates.hasGetExperimentValueErrorOccurred) {
            // eslint-disable-next-line no-console
            console.warn({
                msg: 'An error has occurred getting the experiment value from criterion override. Only the first occurrence of this error is logged.',
                experimentName: experimentName,
                defaultValue: defaultValue,
                options: options,
                error: error
            });
            $e8d44dd74978c315$var$_FeatureGates.hasGetExperimentValueErrorOccurred = true;
        }
        return defaultValue;
    }
    // Proceed with the main logic if no override is found
    return $e8d44dd74978c315$var$_FeatureGates.client.getExperimentValue(experimentName, parameterName, defaultValue, options);
});
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($e8d44dd74978c315$var$FeatureGates, "initializeCalled", $e8d44dd74978c315$var$_FeatureGates.client.initializeCalled.bind($e8d44dd74978c315$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($e8d44dd74978c315$var$FeatureGates, "initializeCompleted", $e8d44dd74978c315$var$_FeatureGates.client.initializeCompleted.bind($e8d44dd74978c315$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($e8d44dd74978c315$var$FeatureGates, "waitUntilInitializeCompleted", $e8d44dd74978c315$var$_FeatureGates.client.waitUntilInitializeCompleted.bind($e8d44dd74978c315$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($e8d44dd74978c315$var$FeatureGates, "initialize", $e8d44dd74978c315$var$_FeatureGates.client.initialize.bind($e8d44dd74978c315$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($e8d44dd74978c315$var$FeatureGates, "initializeWithProvider", $e8d44dd74978c315$var$_FeatureGates.client.initializeWithProvider.bind($e8d44dd74978c315$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($e8d44dd74978c315$var$FeatureGates, "initializeFromValues", $e8d44dd74978c315$var$_FeatureGates.client.initializeFromValues.bind($e8d44dd74978c315$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($e8d44dd74978c315$var$FeatureGates, "manuallyLogGateExposure", $e8d44dd74978c315$var$_FeatureGates.client.manuallyLogGateExposure.bind($e8d44dd74978c315$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($e8d44dd74978c315$var$FeatureGates, "getExperiment", $e8d44dd74978c315$var$_FeatureGates.client.getExperiment.bind($e8d44dd74978c315$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($e8d44dd74978c315$var$FeatureGates, "manuallyLogExperimentExposure", $e8d44dd74978c315$var$_FeatureGates.client.manuallyLogExperimentExposure.bind($e8d44dd74978c315$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($e8d44dd74978c315$var$FeatureGates, "manuallyLogLayerExposure", $e8d44dd74978c315$var$_FeatureGates.client.manuallyLogLayerExposure.bind($e8d44dd74978c315$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($e8d44dd74978c315$var$FeatureGates, "shutdownStatsig", $e8d44dd74978c315$var$_FeatureGates.client.shutdownStatsig.bind($e8d44dd74978c315$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($e8d44dd74978c315$var$FeatureGates, "overrideGate", $e8d44dd74978c315$var$_FeatureGates.client.overrideGate.bind($e8d44dd74978c315$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($e8d44dd74978c315$var$FeatureGates, "clearGateOverride", $e8d44dd74978c315$var$_FeatureGates.client.clearGateOverride.bind($e8d44dd74978c315$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($e8d44dd74978c315$var$FeatureGates, "overrideConfig", $e8d44dd74978c315$var$_FeatureGates.client.overrideConfig.bind($e8d44dd74978c315$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($e8d44dd74978c315$var$FeatureGates, "clearConfigOverride", $e8d44dd74978c315$var$_FeatureGates.client.clearConfigOverride.bind($e8d44dd74978c315$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($e8d44dd74978c315$var$FeatureGates, "setOverrides", $e8d44dd74978c315$var$_FeatureGates.client.setOverrides.bind($e8d44dd74978c315$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($e8d44dd74978c315$var$FeatureGates, "getOverrides", $e8d44dd74978c315$var$_FeatureGates.client.getOverrides.bind($e8d44dd74978c315$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($e8d44dd74978c315$var$FeatureGates, "clearAllOverrides", $e8d44dd74978c315$var$_FeatureGates.client.clearAllOverrides.bind($e8d44dd74978c315$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($e8d44dd74978c315$var$FeatureGates, "isCurrentUser", $e8d44dd74978c315$var$_FeatureGates.client.isCurrentUser.bind($e8d44dd74978c315$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($e8d44dd74978c315$var$FeatureGates, "onGateUpdated", $e8d44dd74978c315$var$_FeatureGates.client.onGateUpdated.bind($e8d44dd74978c315$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($e8d44dd74978c315$var$FeatureGates, "onExperimentValueUpdated", $e8d44dd74978c315$var$_FeatureGates.client.onExperimentValueUpdated.bind($e8d44dd74978c315$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($e8d44dd74978c315$var$FeatureGates, "onAnyUpdated", $e8d44dd74978c315$var$_FeatureGates.client.onAnyUpdated.bind($e8d44dd74978c315$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($e8d44dd74978c315$var$FeatureGates, "updateUser", $e8d44dd74978c315$var$_FeatureGates.client.updateUser.bind($e8d44dd74978c315$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($e8d44dd74978c315$var$FeatureGates, "updateUserWithProvider", $e8d44dd74978c315$var$_FeatureGates.client.updateUserWithProvider.bind($e8d44dd74978c315$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($e8d44dd74978c315$var$FeatureGates, "updateUserWithValues", $e8d44dd74978c315$var$_FeatureGates.client.updateUserWithValues.bind($e8d44dd74978c315$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($e8d44dd74978c315$var$FeatureGates, "getPackageVersion", $e8d44dd74978c315$var$_FeatureGates.client.getPackageVersion.bind($e8d44dd74978c315$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($e8d44dd74978c315$var$FeatureGates, "getLayer", $e8d44dd74978c315$var$_FeatureGates.client.getLayer.bind($e8d44dd74978c315$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($e8d44dd74978c315$var$FeatureGates, "getLayerValue", $e8d44dd74978c315$var$_FeatureGates.client.getLayerValue.bind($e8d44dd74978c315$var$_FeatureGates.client));
var $e8d44dd74978c315$var$boundFGJS = $e8d44dd74978c315$var$FeatureGates;
// This makes it possible to get a reference to the FeatureGates client at runtime.
// This is important for overriding values in Cypress tests, as there needs to be a
// way to get the exact instance for a window in order to mock some of its methods.
if (typeof window !== 'undefined') {
    if (window.__FEATUREGATES_JS__ === undefined) window.__FEATUREGATES_JS__ = $e8d44dd74978c315$var$FeatureGates;
    else {
        var $e8d44dd74978c315$var$_boundFGJS, $e8d44dd74978c315$var$_boundFGJS$getPackage;
        $e8d44dd74978c315$var$boundFGJS = window.__FEATUREGATES_JS__;
        var $e8d44dd74978c315$var$boundVersion = (($e8d44dd74978c315$var$_boundFGJS = $e8d44dd74978c315$var$boundFGJS) === null || $e8d44dd74978c315$var$_boundFGJS === void 0 || ($e8d44dd74978c315$var$_boundFGJS$getPackage = $e8d44dd74978c315$var$_boundFGJS.getPackageVersion) === null || $e8d44dd74978c315$var$_boundFGJS$getPackage === void 0 ? void 0 : $e8d44dd74978c315$var$_boundFGJS$getPackage.call($e8d44dd74978c315$var$_boundFGJS)) || '4.10.0 or earlier';
        if ($e8d44dd74978c315$var$boundVersion !== (0, $an40Y.CLIENT_VERSION)) {
            var $e8d44dd74978c315$var$message = "Multiple versions of FeatureGateClients found on the current page.\n      The currently bound version is ".concat($e8d44dd74978c315$var$boundVersion, " when module version ").concat((0, $an40Y.CLIENT_VERSION), " was loading.");
            // eslint-disable-next-line no-console
            console.warn($e8d44dd74978c315$var$message);
        }
    }
}
var /**
 * @property {FeatureGates} FeatureGate default export
 */ $e8d44dd74978c315$export$2e2bcd8739ae039 = $e8d44dd74978c315$var$boundFGJS;

});
parcelRegister("5o85S", function(module, exports) {
$parcel$export(module.exports, "Client", () => $3ec578e11f6ee57a$export$1f2bb630327ac4b6);

var $1Vcia = parcelRequire("1Vcia");

var $iYJcE = parcelRequire("iYJcE");

var $fL8KA = parcelRequire("fL8KA");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $25nEq = parcelRequire("25nEq");

var $6HG4S = parcelRequire("6HG4S");

var $iFR7a = parcelRequire("iFR7a");

var $e7NgS = parcelRequire("e7NgS");

var $iwBvv = parcelRequire("iwBvv");

var $oWFzP = parcelRequire("oWFzP");

var $fDQ0p = parcelRequire("fDQ0p");

var $gwO2H = parcelRequire("gwO2H");

var $cyIRe = parcelRequire("cyIRe");

var $iMRG8 = parcelRequire("iMRG8");

var $jLH8B = parcelRequire("jLH8B");

var $edtOW = parcelRequire("edtOW");

var $an40Y = parcelRequire("an40Y");
var $3ec578e11f6ee57a$var$_excluded = [
    "sdkKey",
    "environment",
    "updateUserCompletionCallback",
    "perimeter"
];
function $3ec578e11f6ee57a$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $3ec578e11f6ee57a$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $3ec578e11f6ee57a$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $3ec578e11f6ee57a$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $3ec578e11f6ee57a$var$DEFAULT_CLIENT_KEY = 'client-default-key';
// default event logging api is Atlassian proxy rather than Statsig's domain, to avoid ad blockers
var $3ec578e11f6ee57a$var$DEFAULT_EVENT_LOGGING_API = 'https://xp.atlassian.com/v1/rgstr';
var $3ec578e11f6ee57a$export$1f2bb630327ac4b6 = /*#__PURE__*/ function() {
    function Client() {
        var _this = this;
        var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, _ref$localStorageKey = _ref.localStorageKey, localStorageKey = _ref$localStorageKey === void 0 ? (0, $iMRG8.LOCAL_STORAGE_KEY) : _ref$localStorageKey, overrideAdapter = _ref.overrideAdapter;
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, Client);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "initPromise", null);
        /** True if an initialize method was called and completed successfully. */ (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "initCompleted", false);
        /**
     * True if an initialize method was called and completed, meaning the client is now usable.
     * However if there was an error during initialization it may have initialized with default
     * values. Use {@link initCompleted} to check for this.
     */ (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "initWithDefaults", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "hasCheckGateErrorOccurred", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "hasGetExperimentErrorOccurred", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "hasGetExperimentValueErrorOccurred", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "hasGetLayerErrorOccurred", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "hasGetLayerValueErrorOccurred", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "subscriptions", new (0, $e7NgS.default)());
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "dataAdapter", new (0, $cyIRe.NoFetchDataAdapter)());
        /**
     * Call this if modifying the values being served by the Statsig library since it has its own
     * memoization cache which will not be updated if the values are changed outside of the library.
     */ (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "statsigValuesUpdated", function() {
            if (_this.user) // Trigger a reset of the memoize cache
            _this.statsigClient.updateUserSync(_this.user, {
                disableBackgroundCacheRefresh: true
            });
            _this.subscriptions.anyUpdated();
        });
        this.overrideAdapter = overrideAdapter || new (0, $iMRG8.PersistentOverrideAdapter)(localStorageKey);
    }
    /**
   * @description
   * This method initializes the client using a network call to fetch the bootstrap values.
   * If the client is inialized with an `analyticsWebClient`, it will send an operational event
   * to GASv3 with the following attributes:
   * - targetApp: the target app of the client
   * - clientVersion: the version of the client
   * - success: whether the initialization was successful
   * - startTime: the time when the initialization started
   * - totalTime: the total time it took to initialize the client
   * - apiKey: the api key used to initialize the client
   * @param clientOptions {ClientOptions}
   * @param identifiers {Identifiers}
   * @param customAttributes {CustomAttributes}
   * @returns {Promise<void>}
   */ return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(Client, [
        {
            key: "initialize",
            value: function() {
                var _initialize = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee(clientOptions, identifiers, customAttributes) {
                    var _this2 = this;
                    var clientOptionsWithDefaults, startTime;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee$(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                clientOptionsWithDefaults = (0, $edtOW.getOptionsWithDefaults)(clientOptions);
                                if (!this.initPromise) {
                                    _context.next = 4;
                                    break;
                                }
                                if (!(0, $edtOW.shallowEquals)(clientOptionsWithDefaults, this.initOptions)) // eslint-disable-next-line no-console
                                console.warn('Feature Gates client already initialized with different options. New options were not applied.');
                                return _context.abrupt("return", this.initPromise);
                            case 4:
                                startTime = performance.now();
                                this.initOptions = clientOptionsWithDefaults;
                                this.initPromise = this.init(clientOptionsWithDefaults, identifiers, customAttributes).then(function() {
                                    _this2.initCompleted = true;
                                    _this2.initWithDefaults = true;
                                }).finally(function() {
                                    var endTime = performance.now();
                                    var totalTime = endTime - startTime;
                                    _this2.fireClientEvent(startTime, totalTime, 'initialize', _this2.initCompleted, clientOptionsWithDefaults.apiKey);
                                });
                                return _context.abrupt("return", this.initPromise);
                            case 8:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee, this);
                }));
                function initialize(_x, _x2, _x3) {
                    return _initialize.apply(this, arguments);
                }
                return initialize;
            }()
        },
        {
            key: "initializeWithProvider",
            value: function() {
                var _initializeWithProvider = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee2(clientOptions, provider, identifiers, customAttributes) {
                    var _this3 = this;
                    var clientOptionsWithDefaults, startTime;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee2$(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                clientOptionsWithDefaults = (0, $edtOW.getOptionsWithDefaults)(clientOptions);
                                if (!this.initPromise) {
                                    _context2.next = 4;
                                    break;
                                }
                                if (!(0, $edtOW.shallowEquals)(clientOptionsWithDefaults, this.initOptions)) // eslint-disable-next-line no-console
                                console.warn('Feature Gates client already initialized with different options. New options were not applied.');
                                return _context2.abrupt("return", this.initPromise);
                            case 4:
                                startTime = performance.now();
                                this.initOptions = clientOptionsWithDefaults;
                                this.provider = provider;
                                this.provider.setClientVersion((0, $an40Y.CLIENT_VERSION));
                                if (this.provider.setApplyUpdateCallback) this.provider.setApplyUpdateCallback(this.applyUpdateCallback.bind(this));
                                this.initPromise = this.initWithProvider(clientOptionsWithDefaults, provider, identifiers, customAttributes).then(function() {
                                    _this3.initCompleted = true;
                                    _this3.initWithDefaults = true;
                                }).finally(function() {
                                    var endTime = performance.now();
                                    var totalTime = endTime - startTime;
                                    _this3.fireClientEvent(startTime, totalTime, 'initializeWithProvider', _this3.initCompleted, provider.getApiKey ? provider.getApiKey() : undefined);
                                });
                                return _context2.abrupt("return", this.initPromise);
                            case 11:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2, this);
                }));
                function initializeWithProvider(_x4, _x5, _x6, _x7) {
                    return _initializeWithProvider.apply(this, arguments);
                }
                return initializeWithProvider;
            }()
        },
        {
            key: "applyUpdateCallback",
            value: function applyUpdateCallback(experimentsResult) {
                try {
                    if (this.initCompleted || this.initWithDefaults) {
                        this.assertInitialized(this.statsigClient);
                        this.dataAdapter.setBootstrapData(experimentsResult.experimentValues);
                        this.dataAdapter.setData(JSON.stringify(experimentsResult.experimentValues));
                        this.statsigValuesUpdated();
                    }
                } catch (error) {
                    // eslint-disable-next-line no-console
                    console.warn('Error when attempting to apply update', error);
                }
            }
        },
        {
            key: "fireClientEvent",
            value: function fireClientEvent(startTime, totalTime, action, success) {
                var _analyticsWebClient, _this4 = this;
                var apiKey = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
                (_analyticsWebClient = this.initOptions.analyticsWebClient) === null || _analyticsWebClient === void 0 || _analyticsWebClient.then(function(analyticsWebClient) {
                    var attributes = $3ec578e11f6ee57a$var$_objectSpread({
                        targetApp: _this4.initOptions.targetApp,
                        clientVersion: (0, $an40Y.CLIENT_VERSION),
                        success: success,
                        startTime: startTime,
                        totalTime: totalTime
                    }, apiKey && {
                        apiKey: apiKey
                    });
                    analyticsWebClient.sendOperationalEvent({
                        action: action,
                        actionSubject: 'featureGatesClient',
                        attributes: attributes,
                        tags: [
                            'measurement'
                        ],
                        source: '@atlaskit/feature-gate-js-client'
                    });
                }).catch(function(err) {
                    if (_this4.initOptions.environment !== (0, $jLH8B.FeatureGateEnvironment).Production) // eslint-disable-next-line no-console
                    console.error('Analytics web client promise did not resolve', err);
                });
            }
        },
        {
            key: "initializeFromValues",
            value: function() {
                var _initializeFromValues = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee3(clientOptions, identifiers, customAttributes) {
                    var _this5 = this;
                    var initializeValues, clientOptionsWithDefaults, startTime, _args3 = arguments;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee3$(_context3) {
                        while(true)switch(_context3.prev = _context3.next){
                            case 0:
                                initializeValues = _args3.length > 3 && _args3[3] !== undefined ? _args3[3] : {};
                                clientOptionsWithDefaults = (0, $edtOW.getOptionsWithDefaults)(clientOptions);
                                if (!this.initPromise) {
                                    _context3.next = 5;
                                    break;
                                }
                                if (!(0, $edtOW.shallowEquals)(clientOptionsWithDefaults, this.initOptions)) // eslint-disable-next-line no-console
                                console.warn('Feature Gates client already initialized with different options. New options were not applied.');
                                return _context3.abrupt("return", this.initPromise);
                            case 5:
                                // This makes sure the new Statsig client behaves like the old when bootstrap data is
                                // passed, and `has_updates` isn't specified (which happens a lot in product integration tests).
                                if (!Object.prototype.hasOwnProperty.call(initializeValues, 'has_updates')) initializeValues['has_updates'] = true;
                                startTime = performance.now();
                                this.initOptions = clientOptionsWithDefaults;
                                this.initPromise = this.initFromValues(clientOptionsWithDefaults, identifiers, customAttributes, initializeValues).then(function() {
                                    _this5.initCompleted = true;
                                    _this5.initWithDefaults = true;
                                }).finally(function() {
                                    var endTime = performance.now();
                                    var totalTime = endTime - startTime;
                                    _this5.fireClientEvent(startTime, totalTime, 'initializeFromValues', _this5.initCompleted);
                                });
                                return _context3.abrupt("return", this.initPromise);
                            case 10:
                            case "end":
                                return _context3.stop();
                        }
                    }, _callee3, this);
                }));
                function initializeFromValues(_x8, _x9, _x0) {
                    return _initializeFromValues.apply(this, arguments);
                }
                return initializeFromValues;
            }()
        },
        {
            key: "assertInitialized",
            value: function assertInitialized(statsigClient) {
                if (!statsigClient) throw new Error('Client must be initialized before using this method');
            }
        },
        {
            key: "updateUser",
            value: function() {
                var _updateUser = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee4(fetchOptions, identifiers, customAttributes) {
                    var fetchOptionsWithDefaults, initializeValuesProducer;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee4$(_context4) {
                        while(true)switch(_context4.prev = _context4.next){
                            case 0:
                                this.assertInitialized(this.statsigClient);
                                fetchOptionsWithDefaults = (0, $edtOW.getOptionsWithDefaults)(fetchOptions);
                                initializeValuesProducer = function initializeValuesProducer() {
                                    return (0, $gwO2H.default).fetchExperimentValues(fetchOptionsWithDefaults, identifiers, customAttributes).then(function(_ref2) {
                                        var experimentValues = _ref2.experimentValues, customAttributes = _ref2.customAttributes;
                                        return {
                                            experimentValues: experimentValues,
                                            customAttributesFromFetch: customAttributes
                                        };
                                    });
                                };
                                _context4.next = 5;
                                return this.updateUserUsingInitializeValuesProducer(initializeValuesProducer, identifiers, customAttributes);
                            case 5:
                            case "end":
                                return _context4.stop();
                        }
                    }, _callee4, this);
                }));
                function updateUser(_x1, _x10, _x11) {
                    return _updateUser.apply(this, arguments);
                }
                return updateUser;
            }()
        },
        {
            key: "updateUserWithProvider",
            value: function() {
                var _updateUserWithProvider = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee5(identifiers, customAttributes) {
                    var _this6 = this;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee5$(_context5) {
                        while(true)switch(_context5.prev = _context5.next){
                            case 0:
                                this.assertInitialized(this.statsigClient);
                                if (this.provider) {
                                    _context5.next = 3;
                                    break;
                                }
                                throw new Error('Cannot update user using provider as the client was not initialised with a provider');
                            case 3:
                                _context5.next = 5;
                                return this.provider.setProfile(this.initOptions, identifiers, customAttributes);
                            case 5:
                                _context5.next = 7;
                                return this.updateUserUsingInitializeValuesProducer(function() {
                                    return _this6.provider.getExperimentValues();
                                }, identifiers, customAttributes);
                            case 7:
                            case "end":
                                return _context5.stop();
                        }
                    }, _callee5, this);
                }));
                function updateUserWithProvider(_x12, _x13) {
                    return _updateUserWithProvider.apply(this, arguments);
                }
                return updateUserWithProvider;
            }()
        },
        {
            key: "updateUserWithValues",
            value: function() {
                var _updateUserWithValues = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee6(identifiers, customAttributes) {
                    var initializeValues, initializeValuesProducer, _args6 = arguments;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee6$(_context6) {
                        while(true)switch(_context6.prev = _context6.next){
                            case 0:
                                initializeValues = _args6.length > 2 && _args6[2] !== undefined ? _args6[2] : {};
                                this.assertInitialized(this.statsigClient);
                                initializeValuesProducer = function initializeValuesProducer() {
                                    return Promise.resolve({
                                        experimentValues: initializeValues,
                                        customAttributesFromFetch: customAttributes
                                    });
                                };
                                _context6.next = 5;
                                return this.updateUserUsingInitializeValuesProducer(initializeValuesProducer, identifiers, customAttributes);
                            case 5:
                            case "end":
                                return _context6.stop();
                        }
                    }, _callee6, this);
                }));
                function updateUserWithValues(_x14, _x15) {
                    return _updateUserWithValues.apply(this, arguments);
                }
                return updateUserWithValues;
            }()
        },
        {
            key: "initializeCalled",
            value: function initializeCalled() {
                return this.initPromise != null;
            }
        },
        {
            key: "initializeCompleted",
            value: function initializeCompleted() {
                return this.initCompleted;
            }
        },
        {
            key: "waitUntilInitializeCompleted",
            value: function() {
                var _waitUntilInitializeCompleted = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee7() {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee7$(_context7) {
                        while(true)switch(_context7.prev = _context7.next){
                            case 0:
                                if (this.initPromise) {
                                    _context7.next = 2;
                                    break;
                                }
                                throw new Error('The client must be initialized before you can wait until initialized.');
                            case 2:
                                if (!this.initCompleted) {
                                    _context7.next = 4;
                                    break;
                                }
                                return _context7.abrupt("return");
                            case 4:
                                _context7.next = 6;
                                return this.initPromise;
                            case 6:
                            case "end":
                                return _context7.stop();
                        }
                    }, _callee7, this);
                }));
                function waitUntilInitializeCompleted() {
                    return _waitUntilInitializeCompleted.apply(this, arguments);
                }
                return waitUntilInitializeCompleted;
            }()
        },
        {
            key: "checkGate",
            value: function checkGate(gateName) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                try {
                    this.assertInitialized(this.statsigClient);
                    var _options$fireGateExpo = options.fireGateExposure, fireGateExposure = _options$fireGateExpo === void 0 ? true : _options$fireGateExpo;
                    return this.statsigClient.checkGate(gateName, {
                        disableExposureLog: !fireGateExposure
                    });
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!this.hasCheckGateErrorOccurred) {
                        // eslint-disable-next-line no-console
                        console.warn({
                            msg: 'An error has occurred checking the feature gate. Only the first occurrence of this error is logged.',
                            gateName: gateName,
                            error: error
                        });
                        this.hasCheckGateErrorOccurred = true;
                    }
                    return false;
                }
            }
        },
        {
            key: "isGateExist",
            value: function isGateExist(gateName) {
                try {
                    this.assertInitialized(this.statsigClient);
                    var gate = this.statsigClient.getFeatureGate(gateName, {
                        disableExposureLog: true
                    });
                    return !gate.details.reason.includes('Unrecognized');
                } catch (error) {
                    // eslint-disable-next-line no-console
                    console.error("Error occurred when trying to check FeatureGate: ".concat(error));
                    // in case of error report true to avoid false positives.
                    return true;
                }
            }
        },
        {
            key: "isExperimentExist",
            value: function isExperimentExist(experimentName) {
                try {
                    this.assertInitialized(this.statsigClient);
                    var config = this.statsigClient.getExperiment(experimentName, {
                        disableExposureLog: true
                    });
                    return !config.details.reason.includes('Unrecognized');
                } catch (error) {
                    // eslint-disable-next-line no-console
                    console.error("Error occurred when trying to check Experiment: ".concat(error));
                    // in case of error report true to avoid false positives.
                    return true;
                }
            }
        },
        {
            key: "manuallyLogGateExposure",
            value: function manuallyLogGateExposure(gateName) {
                this.assertInitialized(this.statsigClient);
                // This is the approach recommended in the docs
                // https://docs.statsig.com/client/javascript-sdk/#manual-exposures-
                this.statsigClient.checkGate(gateName);
            }
        },
        {
            key: "getExperiment",
            value: function getExperiment(experimentName) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                try {
                    this.assertInitialized(this.statsigClient);
                    var _options$fireExperime = options.fireExperimentExposure, fireExperimentExposure = _options$fireExperime === void 0 ? true : _options$fireExperime;
                    return (0, $iwBvv.DynamicConfig).fromExperiment(this.statsigClient.getExperiment(experimentName, {
                        disableExposureLog: !fireExperimentExposure
                    }));
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!this.hasGetExperimentErrorOccurred) {
                        // eslint-disable-next-line no-console
                        console.warn({
                            msg: 'An error has occurred getting the experiment. Only the first occurrence of this error is logged.',
                            experimentName: experimentName,
                            error: error
                        });
                        this.hasGetExperimentErrorOccurred = true;
                    }
                    // Return a default value
                    return new (0, $iwBvv.DynamicConfig)(experimentName, {}, '', {
                        time: Date.now(),
                        reason: (0, $fDQ0p.EvaluationReason).Error
                    });
                }
            }
        },
        {
            key: "getExperimentValue",
            value: function getExperimentValue(experimentName, parameterName, defaultValue) {
                var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var experiment = this.getExperiment(experimentName, options);
                try {
                    var typeGuard = options.typeGuard;
                    return experiment.get(parameterName, defaultValue, typeGuard);
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!this.hasGetExperimentValueErrorOccurred) {
                        // eslint-disable-next-line no-console
                        console.warn({
                            msg: 'An error has occurred getting the experiment value. Only the first occurrence of this error is logged.',
                            experimentName: experimentName,
                            defaultValue: defaultValue,
                            options: options,
                            error: error
                        });
                        this.hasGetExperimentValueErrorOccurred = true;
                    }
                    return defaultValue;
                }
            }
        },
        {
            key: "manuallyLogExperimentExposure",
            value: function manuallyLogExperimentExposure(experimentName) {
                this.assertInitialized(this.statsigClient);
                // This is the approach recommended in the docs
                // https://docs.statsig.com/client/javascript-sdk/#manual-exposures-
                this.statsigClient.getExperiment(experimentName);
            }
        },
        {
            key: "manuallyLogLayerExposure",
            value: function manuallyLogLayerExposure(layerName, parameterName) {
                var _this$statsigClient$g;
                this.assertInitialized(this.statsigClient);
                // This is the approach recommended in the docs
                // https://docs.statsig.com/client/javascript-sdk/#manual-exposures-
                (_this$statsigClient$g = this.statsigClient.getLayer(layerName)) === null || _this$statsigClient$g === void 0 || _this$statsigClient$g.get(parameterName);
            }
        },
        {
            key: "shutdownStatsig",
            value: function shutdownStatsig() {
                this.assertInitialized(this.statsigClient);
                this.statsigClient.shutdown();
            }
        },
        {
            key: "overrideGate",
            value: function overrideGate(gateName, value) {
                this.overrideAdapter.overrideGate(gateName, value);
                // Trigger a reset of the memoized gate value
                if (this.user) {
                    var _this$statsigClient;
                    (_this$statsigClient = this.statsigClient) === null || _this$statsigClient === void 0 || _this$statsigClient.updateUserSync(this.user, {
                        disableBackgroundCacheRefresh: true
                    });
                }
                this.statsigValuesUpdated();
            }
        },
        {
            key: "clearGateOverride",
            value: function clearGateOverride(gateName) {
                this.overrideAdapter.removeGateOverride(gateName);
                this.statsigValuesUpdated();
            }
        },
        {
            key: "overrideConfig",
            value: function overrideConfig(experimentName, values) {
                this.overrideAdapter.overrideDynamicConfig(experimentName, values);
                this.statsigValuesUpdated();
            }
        },
        {
            key: "clearConfigOverride",
            value: function clearConfigOverride(experimentName) {
                this.overrideAdapter.removeDynamicConfigOverride(experimentName);
                this.statsigValuesUpdated();
            }
        },
        {
            key: "setOverrides",
            value: function setOverrides(overrides) {
                this.overrideAdapter.setOverrides(overrides);
                this.statsigValuesUpdated();
            }
        },
        {
            key: "getOverrides",
            value: function getOverrides() {
                return this.overrideAdapter.getOverrides();
            }
        },
        {
            key: "clearAllOverrides",
            value: function clearAllOverrides() {
                this.overrideAdapter.removeAllOverrides();
                this.statsigValuesUpdated();
            }
        },
        {
            key: "isCurrentUser",
            value: function isCurrentUser(identifiers, customAttributes) {
                return (0, $edtOW.shallowEquals)(this.currentIdentifiers, identifiers) && (0, $edtOW.shallowEquals)(this.currentAttributes, customAttributes);
            }
        },
        {
            key: "onGateUpdated",
            value: function onGateUpdated(gateName, callback) {
                var _this7 = this;
                var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var wrapCallback = function wrapCallback(value) {
                    var _options$fireGateExpo2 = options.fireGateExposure, fireGateExposure = _options$fireGateExpo2 === void 0 ? true : _options$fireGateExpo2;
                    if (fireGateExposure) _this7.manuallyLogGateExposure(gateName);
                    try {
                        callback(value);
                    } catch (error) {
                        // eslint-disable-next-line no-console
                        console.warn("Error calling callback for gate ".concat(gateName, " with value ").concat(value), error);
                    }
                };
                return this.subscriptions.onGateUpdated(gateName, wrapCallback, this.checkGate.bind(this), options);
            }
        },
        {
            key: "onExperimentValueUpdated",
            value: function onExperimentValueUpdated(experimentName, parameterName, defaultValue, callback) {
                var _this8 = this;
                var options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
                var wrapCallback = function wrapCallback(value) {
                    var _options$fireExperime2 = options.fireExperimentExposure, fireExperimentExposure = _options$fireExperime2 === void 0 ? true : _options$fireExperime2;
                    if (fireExperimentExposure) _this8.manuallyLogExperimentExposure(experimentName);
                    try {
                        callback(value);
                    } catch (error) {
                        // eslint-disable-next-line no-console
                        console.warn("Error calling callback for experiment ".concat(experimentName, " with value ").concat(value), error);
                    }
                };
                return this.subscriptions.onExperimentValueUpdated(experimentName, parameterName, defaultValue, wrapCallback, this.getExperimentValue.bind(this), options);
            }
        },
        {
            key: "onAnyUpdated",
            value: function onAnyUpdated(callback) {
                return this.subscriptions.onAnyUpdated(callback);
            }
        },
        {
            key: "init",
            value: function() {
                var _init = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee8(clientOptions, identifiers, customAttributes) {
                    var fromValuesClientOptions, experimentValues, customAttributesFromResult, clientSdkKeyPromise, experimentValuesPromise, _yield$Promise$all, _yield$Promise$all2, experimentValuesResult;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee8$(_context8) {
                        while(true)switch(_context8.prev = _context8.next){
                            case 0:
                                fromValuesClientOptions = $3ec578e11f6ee57a$var$_objectSpread({}, clientOptions);
                                _context8.prev = 1;
                                // If client sdk key fetch fails, an error would be thrown and handled instead of waiting for
                                // the experiment values request to be settled, and it will fall back to use default values.
                                clientSdkKeyPromise = (0, $gwO2H.default).fetchClientSdk(clientOptions).then(function(value) {
                                    return fromValuesClientOptions.sdkKey = value.clientSdkKey;
                                });
                                experimentValuesPromise = (0, $gwO2H.default).fetchExperimentValues(clientOptions, identifiers, customAttributes); // Only wait for the experiment values request to finish and try to initialise the client
                                // with experiment values if both requests are successful. Else an error would be thrown and
                                // handled by the catch
                                _context8.next = 6;
                                return Promise.all([
                                    clientSdkKeyPromise,
                                    experimentValuesPromise
                                ]);
                            case 6:
                                _yield$Promise$all = _context8.sent;
                                _yield$Promise$all2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_yield$Promise$all, 2);
                                experimentValuesResult = _yield$Promise$all2[1];
                                experimentValues = experimentValuesResult.experimentValues;
                                customAttributesFromResult = experimentValuesResult.customAttributes;
                                _context8.next = 20;
                                break;
                            case 13:
                                _context8.prev = 13;
                                _context8.t0 = _context8["catch"](1);
                                if (_context8.t0 instanceof Error) // eslint-disable-next-line no-console
                                console.error("Error occurred when trying to fetch the Feature Gates client values, error: ".concat(_context8.t0 === null || _context8.t0 === void 0 ? void 0 : _context8.t0.message));
                                // eslint-disable-next-line no-console
                                console.warn("Initialising Statsig client without values");
                                _context8.next = 19;
                                return this.initFromValues(fromValuesClientOptions, identifiers, customAttributes);
                            case 19:
                                throw _context8.t0;
                            case 20:
                                return _context8.abrupt("return", this.initFromValues(fromValuesClientOptions, identifiers, customAttributesFromResult, experimentValues));
                            case 21:
                            case "end":
                                return _context8.stop();
                        }
                    }, _callee8, this, [
                        [
                            1,
                            13
                        ]
                    ]);
                }));
                function init(_x16, _x17, _x18) {
                    return _init.apply(this, arguments);
                }
                return init;
            }()
        },
        {
            key: "initWithProvider",
            value: function() {
                var _initWithProvider = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee9(baseClientOptions, provider, identifiers, customAttributes) {
                    var fromValuesClientOptions, experimentValues, customAttributesFromResult, clientSdkKeyPromise, experimentValuesPromise, _yield$Promise$all3, _yield$Promise$all4, experimentValuesResult;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee9$(_context9) {
                        while(true)switch(_context9.prev = _context9.next){
                            case 0:
                                fromValuesClientOptions = $3ec578e11f6ee57a$var$_objectSpread($3ec578e11f6ee57a$var$_objectSpread({}, baseClientOptions), {}, {
                                    disableCurrentPageLogging: true
                                });
                                _context9.prev = 1;
                                _context9.next = 4;
                                return provider.setProfile(baseClientOptions, identifiers, customAttributes);
                            case 4:
                                // If client sdk key fetch fails, an error would be thrown and handled instead of waiting for
                                // the experiment values request to be settled, and it will fall back to use default values.
                                clientSdkKeyPromise = provider.getClientSdkKey().then(function(value) {
                                    return fromValuesClientOptions.sdkKey = value;
                                });
                                experimentValuesPromise = provider.getExperimentValues(); // Only wait for the experiment values request to finish and try to initialise the client
                                // with experiment values if both requests are successful. Else an error would be thrown and
                                // handled by the catch
                                _context9.next = 8;
                                return Promise.all([
                                    clientSdkKeyPromise,
                                    experimentValuesPromise
                                ]);
                            case 8:
                                _yield$Promise$all3 = _context9.sent;
                                _yield$Promise$all4 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_yield$Promise$all3, 2);
                                experimentValuesResult = _yield$Promise$all4[1];
                                experimentValues = experimentValuesResult.experimentValues;
                                customAttributesFromResult = experimentValuesResult.customAttributesFromFetch;
                                _context9.next = 22;
                                break;
                            case 15:
                                _context9.prev = 15;
                                _context9.t0 = _context9["catch"](1);
                                if (_context9.t0 instanceof Error) // eslint-disable-next-line no-console
                                console.error("Error occurred when trying to fetch the Feature Gates client values, error: ".concat(_context9.t0 === null || _context9.t0 === void 0 ? void 0 : _context9.t0.message));
                                // eslint-disable-next-line no-console
                                console.warn("Initialising Statsig client without values");
                                _context9.next = 21;
                                return this.initFromValues(fromValuesClientOptions, identifiers, customAttributes);
                            case 21:
                                throw _context9.t0;
                            case 22:
                                return _context9.abrupt("return", this.initFromValues(fromValuesClientOptions, identifiers, customAttributesFromResult, experimentValues));
                            case 23:
                            case "end":
                                return _context9.stop();
                        }
                    }, _callee9, this, [
                        [
                            1,
                            15
                        ]
                    ]);
                }));
                function initWithProvider(_x19, _x20, _x21, _x22) {
                    return _initWithProvider.apply(this, arguments);
                }
                return initWithProvider;
            }()
        },
        {
            key: "initFromValues",
            value: function() {
                var _initFromValues = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee0(clientOptions, identifiers, customAttributes) {
                    var _newClientOptions$net;
                    var initializeValues, newClientOptions, sdkKey, environment, _updateUserCompletionCallback, _perimeter, restClientOptions, statsigOptions, _args0 = arguments;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee0$(_context0) {
                        while(true)switch(_context0.prev = _context0.next){
                            case 0:
                                initializeValues = _args0.length > 3 && _args0[3] !== undefined ? _args0[3] : {};
                                this.overrideAdapter.initFromStoredOverrides();
                                this.currentIdentifiers = identifiers;
                                this.currentAttributes = customAttributes;
                                newClientOptions = (0, $edtOW.migrateInitializationOptions)(clientOptions);
                                if (!newClientOptions.sdkKey) newClientOptions.sdkKey = $3ec578e11f6ee57a$var$DEFAULT_CLIENT_KEY;
                                if (!((_newClientOptions$net = newClientOptions.networkConfig) !== null && _newClientOptions$net !== void 0 && _newClientOptions$net.logEventUrl)) newClientOptions.networkConfig = $3ec578e11f6ee57a$var$_objectSpread($3ec578e11f6ee57a$var$_objectSpread({}, newClientOptions.networkConfig), {}, {
                                    logEventUrl: $3ec578e11f6ee57a$var$DEFAULT_EVENT_LOGGING_API
                                });
                                if (newClientOptions.perimeter === (0, $jLH8B.PerimeterType).FEDRAMP_MODERATE) // disable all logging in FedRAMP to prevent egress of sensitive data
                                newClientOptions.disableLogging = true;
                                sdkKey = newClientOptions.sdkKey, environment = newClientOptions.environment, _updateUserCompletionCallback = newClientOptions.updateUserCompletionCallback, _perimeter = newClientOptions.perimeter, restClientOptions = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(newClientOptions, $3ec578e11f6ee57a$var$_excluded);
                                this.user = (0, $edtOW.toStatsigUser)(identifiers, customAttributes);
                                statsigOptions = $3ec578e11f6ee57a$var$_objectSpread($3ec578e11f6ee57a$var$_objectSpread({}, restClientOptions), {}, {
                                    environment: {
                                        tier: environment
                                    },
                                    includeCurrentPageUrlWithEvents: false,
                                    dataAdapter: this.dataAdapter,
                                    overrideAdapter: this.overrideAdapter,
                                    logEventCompressionMode: (0, $iFR7a.LogEventCompressionMode).Forced
                                }); // Statsig validates the provided stableId against their own cookie, so we either need
                                // to update the cookie to match, or disable the validation completely.
                                if (identifiers.stableId) (0, $iFR7a.StableID).setOverride(identifiers.stableId, sdkKey);
                                else statsigOptions.disableStableID = true;
                                _context0.prev = 12;
                                this.statsigClient = new (0, $iFR7a.StatsigClient)(sdkKey, this.user, statsigOptions);
                                this.dataAdapter.setBootstrapData(initializeValues);
                                _context0.next = 17;
                                return this.statsigClient.initializeAsync();
                            case 17:
                                _context0.next = 29;
                                break;
                            case 19:
                                _context0.prev = 19;
                                _context0.t0 = _context0["catch"](12);
                                if (_context0.t0 instanceof Error) // eslint-disable-next-line no-console
                                console.error("Error occurred when trying to initialise the Statsig client, error: ".concat(_context0.t0 === null || _context0.t0 === void 0 ? void 0 : _context0.t0.message));
                                // eslint-disable-next-line no-console
                                console.warn("Initialising Statsig client with default sdk key and without values");
                                this.statsigClient = new (0, $iFR7a.StatsigClient)($3ec578e11f6ee57a$var$DEFAULT_CLIENT_KEY, this.user, statsigOptions);
                                this.dataAdapter.setBootstrapData();
                                _context0.next = 27;
                                return this.statsigClient.initializeAsync();
                            case 27:
                                this.initWithDefaults = true;
                                throw _context0.t0;
                            case 29:
                            case "end":
                                return _context0.stop();
                        }
                    }, _callee0, this, [
                        [
                            12,
                            19
                        ]
                    ]);
                }));
                function initFromValues(_x23, _x24, _x25) {
                    return _initFromValues.apply(this, arguments);
                }
                return initFromValues;
            }()
        },
        {
            key: "updateUserUsingInitializeValuesProducer",
            value: function() {
                var _updateUserUsingInitializeValuesProducer = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee10(getInitializeValues, identifiers, customAttributes) {
                    var _this9 = this;
                    var originalInitPromise, initializeValuesPromise, updateUserPromise;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee10$(_context10) {
                        while(true)switch(_context10.prev = _context10.next){
                            case 0:
                                this.assertInitialized(this.statsigClient);
                                if (this.initPromise) {
                                    _context10.next = 3;
                                    break;
                                }
                                throw new Error('The client must be initialized before you can update the user.');
                            case 3:
                                if (!this.isCurrentUser(identifiers, customAttributes)) {
                                    _context10.next = 5;
                                    break;
                                }
                                return _context10.abrupt("return", this.initPromise);
                            case 5:
                                // Wait for the current initialize/update to finish
                                originalInitPromise = this.initPromise;
                                _context10.prev = 6;
                                _context10.next = 9;
                                return this.initPromise;
                            case 9:
                                _context10.next = 13;
                                break;
                            case 11:
                                _context10.prev = 11;
                                _context10.t0 = _context10["catch"](6);
                            case 13:
                                initializeValuesPromise = getInitializeValues();
                                updateUserPromise = this.updateStatsigClientUser(initializeValuesPromise, identifiers, customAttributes); // We replace the init promise here since we are essentially re-initializing the client at this
                                // point. Any subsequent calls to await client.initialize() or client.updateUser()
                                // will now also await this user update.
                                this.initPromise = updateUserPromise.catch(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee1() {
                                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee1$(_context1) {
                                        while(true)switch(_context1.prev = _context1.next){
                                            case 0:
                                                // If the update failed then it changed nothing, so revert back to the original promise.
                                                _this9.initPromise = originalInitPromise;
                                                // Set the user profile again to revert back to the current user
                                                if (!_this9.provider) {
                                                    _context1.next = 4;
                                                    break;
                                                }
                                                _context1.next = 4;
                                                return _this9.provider.setProfile(_this9.initOptions, _this9.currentIdentifiers, _this9.currentAttributes);
                                            case 4:
                                            case "end":
                                                return _context1.stop();
                                        }
                                    }, _callee1);
                                })));
                                return _context10.abrupt("return", updateUserPromise);
                            case 17:
                            case "end":
                                return _context10.stop();
                        }
                    }, _callee10, this, [
                        [
                            6,
                            11
                        ]
                    ]);
                }));
                function updateUserUsingInitializeValuesProducer(_x26, _x27, _x28) {
                    return _updateUserUsingInitializeValuesProducer.apply(this, arguments);
                }
                return updateUserUsingInitializeValuesProducer;
            }()
        },
        {
            key: "updateStatsigClientUser",
            value: function() {
                var _updateStatsigClientUser = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee11(initializeValuesPromise, identifiers, customAttributes) {
                    var _this$initOptions, _this$initOptions$upd;
                    var initializeValues, user, _updateUserCompletion, _ref4, errMsg, success, errorMessage;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee11$(_context11) {
                        while(true)switch(_context11.prev = _context11.next){
                            case 0:
                                this.assertInitialized(this.statsigClient);
                                _context11.prev = 1;
                                _context11.next = 4;
                                return initializeValuesPromise;
                            case 4:
                                initializeValues = _context11.sent;
                                user = (0, $edtOW.toStatsigUser)(identifiers, initializeValues.customAttributesFromFetch);
                                _context11.next = 13;
                                break;
                            case 8:
                                _context11.prev = 8;
                                _context11.t0 = _context11["catch"](1);
                                // Make sure the updateUserCompletionCallback is called for any errors in our custom code.
                                // This is not necessary for the updateUserWithValues call, because the Statsig client will
                                // already invoke the callback itself.
                                errMsg = _context11.t0 instanceof Error ? _context11.t0.message : JSON.stringify(_context11.t0);
                                (_updateUserCompletion = (_ref4 = this.initOptions).updateUserCompletionCallback) === null || _updateUserCompletion === void 0 || _updateUserCompletion.call(_ref4, false, errMsg);
                                throw _context11.t0;
                            case 13:
                                success = true;
                                errorMessage = null;
                                _context11.prev = 15;
                                this.dataAdapter.setBootstrapData(initializeValues.experimentValues);
                                this.user = user;
                                if (!this.user) {
                                    _context11.next = 21;
                                    break;
                                }
                                _context11.next = 21;
                                return this.statsigClient.updateUserAsync(this.user);
                            case 21:
                                _context11.next = 27;
                                break;
                            case 23:
                                _context11.prev = 23;
                                _context11.t1 = _context11["catch"](15);
                                success = false;
                                errorMessage = String(_context11.t1);
                            case 27:
                                (_this$initOptions = this.initOptions) === null || _this$initOptions === void 0 || (_this$initOptions$upd = _this$initOptions.updateUserCompletionCallback) === null || _this$initOptions$upd === void 0 || _this$initOptions$upd.call(_this$initOptions, success, errorMessage);
                                if (!success) {
                                    _context11.next = 34;
                                    break;
                                }
                                this.currentIdentifiers = identifiers;
                                this.currentAttributes = customAttributes;
                                this.subscriptions.anyUpdated();
                                _context11.next = 35;
                                break;
                            case 34:
                                throw new Error('Failed to update user. An unexpected error occured.');
                            case 35:
                            case "end":
                                return _context11.stop();
                        }
                    }, _callee11, this, [
                        [
                            1,
                            8
                        ],
                        [
                            15,
                            23
                        ]
                    ]);
                }));
                function updateStatsigClientUser(_x29, _x30, _x31) {
                    return _updateStatsigClientUser.apply(this, arguments);
                }
                return updateStatsigClientUser;
            }()
        },
        {
            key: "getPackageVersion",
            value: /**
     * @returns string version of the current package in semver style.
     */ function getPackageVersion() {
                return 0, $an40Y.CLIENT_VERSION;
            }
        },
        {
            key: "getLayer",
            value: function getLayer(/** The name of the layer */ layerName) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                try {
                    this.assertInitialized(this.statsigClient);
                    var _options$fireLayerExp = options.fireLayerExposure, fireLayerExposure = _options$fireLayerExp === void 0 ? true : _options$fireLayerExp;
                    return (0, $oWFzP.Layer).fromLayer(this.statsigClient.getLayer(layerName, {
                        disableExposureLog: !fireLayerExposure
                    }));
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!this.hasGetLayerErrorOccurred) {
                        // eslint-disable-next-line no-console
                        console.warn({
                            msg: 'An error has occurred getting the layer. Only the first occurrence of this error is logged.',
                            layerName: layerName,
                            error: error
                        });
                        this.hasGetLayerErrorOccurred = true;
                    }
                    // Return a default value
                    return (0, $oWFzP.Layer).fromLayer((0, $iFR7a._makeLayer)(layerName, {
                        reason: 'Error'
                    }, null));
                }
            }
        },
        {
            key: "getLayerValue",
            value: function getLayerValue(layerName, parameterName, defaultValue) {
                var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var layer = this.getLayer(layerName, options);
                try {
                    var typeGuard = options.typeGuard;
                    return layer.get(parameterName, defaultValue, typeGuard);
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!this.hasGetLayerValueErrorOccurred) {
                        // eslint-disable-next-line no-console
                        console.warn({
                            msg: 'An error has occurred getting the layer value. Only the first occurrence of this error is logged.',
                            layerName: layerName,
                            defaultValue: defaultValue,
                            options: options,
                            error: error
                        });
                        this.hasGetLayerValueErrorOccurred = true;
                    }
                    return defaultValue;
                }
            }
        }
    ]);
}();

});
parcelRegister("e7NgS", function(module, exports) {
$parcel$export(module.exports, "default", () => $a487f0619ffafb0f$export$2e2bcd8739ae039);

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $25nEq = parcelRequire("25nEq");

var $hLfKH = parcelRequire("hLfKH");
function $a487f0619ffafb0f$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $a487f0619ffafb0f$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $a487f0619ffafb0f$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $a487f0619ffafb0f$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $a487f0619ffafb0f$export$a66cbd9b2289cd78 = '@all-features';
var $a487f0619ffafb0f$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function Subscriptions() {
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, Subscriptions);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "eventToValue", new Map());
        this.emitter = new (0, (/*@__PURE__*/$parcel$interopDefault($hLfKH)))();
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(Subscriptions, [
        {
            key: "onGateUpdated",
            value: function onGateUpdated(gateName, callback, checkGate, options) {
                var _this = this;
                var value = checkGate(gateName, $a487f0619ffafb0f$var$_objectSpread($a487f0619ffafb0f$var$_objectSpread({}, options), {}, {
                    fireGateExposure: false
                }));
                if (this.eventToValue.get(callback) === undefined) this.eventToValue.set(callback, value);
                var wrapCallback = function wrapCallback() {
                    var value = checkGate(gateName, $a487f0619ffafb0f$var$_objectSpread($a487f0619ffafb0f$var$_objectSpread({}, options), {}, {
                        fireGateExposure: false
                    }));
                    var existingValue = _this.eventToValue.get(callback);
                    if (existingValue !== value) {
                        _this.eventToValue.set(callback, value);
                        callback(value);
                    }
                };
                this.emitter.on(gateName, wrapCallback);
                return function() {
                    _this.emitter.off(gateName, wrapCallback);
                };
            }
        },
        {
            key: "onExperimentValueUpdated",
            value: function onExperimentValueUpdated(experimentName, parameterName, defaultValue, callback, getExperimentValue, options) {
                var _this2 = this;
                var experimentEventName = "".concat(experimentName, ".").concat(parameterName);
                var value = getExperimentValue(experimentName, parameterName, defaultValue, $a487f0619ffafb0f$var$_objectSpread($a487f0619ffafb0f$var$_objectSpread({}, options), {}, {
                    fireExperimentExposure: false
                }));
                if (this.eventToValue.get(callback) === undefined) this.eventToValue.set(callback, value);
                var wrapCallback = function wrapCallback() {
                    var value = getExperimentValue(experimentName, parameterName, defaultValue, $a487f0619ffafb0f$var$_objectSpread($a487f0619ffafb0f$var$_objectSpread({}, options), {}, {
                        fireExperimentExposure: false
                    }));
                    var existingValue = _this2.eventToValue.get(callback);
                    if (existingValue !== value) {
                        _this2.eventToValue.set(callback, value);
                        callback(value);
                    }
                };
                this.emitter.on(experimentEventName, wrapCallback);
                return function() {
                    _this2.emitter.off(experimentEventName, wrapCallback);
                };
            }
        },
        {
            key: "onAnyUpdated",
            value: function onAnyUpdated(callback) {
                var _this3 = this;
                this.emitter.on($a487f0619ffafb0f$export$a66cbd9b2289cd78, callback);
                return function() {
                    _this3.emitter.off($a487f0619ffafb0f$export$a66cbd9b2289cd78, callback);
                };
            }
        },
        {
            key: "anyUpdated",
            value: function anyUpdated() {
                var _this4 = this;
                this.emitter.emit($a487f0619ffafb0f$export$a66cbd9b2289cd78);
                this.emitter.eventNames().filter(function(name) {
                    return name !== $a487f0619ffafb0f$export$a66cbd9b2289cd78;
                }).forEach(function(event) {
                    _this4.emitter.emit(event);
                });
            }
        }
    ]);
}();

});

parcelRegister("iwBvv", function(module, exports) {
$parcel$export(module.exports, "DynamicConfig", () => $d7c84f488ef006df$export$6dc24881a3d96325);

var $ekGgq = parcelRequire("ekGgq");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $edtOW = parcelRequire("edtOW");
var $d7c84f488ef006df$export$6dc24881a3d96325 = /*#__PURE__*/ function() {
    function DynamicConfig(configName, configValue, ruleID, evaluationDetails) {
        var secondaryExposures = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : [];
        var allocatedExperimentName = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : '';
        var onDefaultValueFallback = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : null;
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, DynamicConfig);
        this.value = configValue;
        this._name = configName;
        this._ruleID = ruleID;
        this._secondaryExposures = secondaryExposures;
        this._allocatedExperimentName = allocatedExperimentName;
        this._evaluationDetails = evaluationDetails;
        this._onDefaultValueFallback = onDefaultValueFallback;
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(DynamicConfig, [
        {
            key: "get",
            value: function get(key, defaultValue, typeGuard) {
                var _this$_onDefaultValue2;
                var val = this.getValue(key, defaultValue);
                if (val == null) return defaultValue;
                var expectedType = Array.isArray(defaultValue) ? 'array' : (0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(defaultValue);
                var actualType = Array.isArray(val) ? 'array' : (0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(val);
                if (typeGuard) {
                    var _this$_onDefaultValue;
                    if (typeGuard(val)) {
                        this.fireExposure(key);
                        return val;
                    }
                    (_this$_onDefaultValue = this._onDefaultValueFallback) === null || _this$_onDefaultValue === void 0 || _this$_onDefaultValue.call(this, this, key, expectedType, actualType);
                    return defaultValue;
                }
                if (defaultValue == null || expectedType === actualType) {
                    this.fireExposure(key);
                    return val;
                }
                (_this$_onDefaultValue2 = this._onDefaultValueFallback) === null || _this$_onDefaultValue2 === void 0 || _this$_onDefaultValue2.call(this, this, key, expectedType, actualType);
                return defaultValue;
            }
        },
        {
            key: "getValue",
            value: function getValue(key, defaultValue) {
                if (key == null) return this.value;
                if (defaultValue == null) defaultValue = null;
                if (this.value[key] == null) return defaultValue;
                this.fireExposure(key);
                return this.value[key];
            }
        },
        {
            key: "fireExposure",
            value: function fireExposure(key) {
                // Call the wrapped experiment's get method to fire exposure
                if (this.experiment) this.experiment.get(key);
            }
        }
    ], [
        {
            key: "fromExperiment",
            value: function fromExperiment(experiment) {
                var _experiment$__evaluat, _experiment$__evaluat2, _experiment$groupName;
                var config = new DynamicConfig(experiment.name, experiment.value, experiment.ruleID, (0, $edtOW.migrateEvaluationDetails)(experiment.details), (0, $edtOW.migrateSecondaryExposures)((_experiment$__evaluat = (_experiment$__evaluat2 = experiment.__evaluation) === null || _experiment$__evaluat2 === void 0 ? void 0 : _experiment$__evaluat2.secondary_exposures) !== null && _experiment$__evaluat !== void 0 ? _experiment$__evaluat : []), (_experiment$groupName = experiment.groupName) !== null && _experiment$groupName !== void 0 ? _experiment$groupName : undefined);
                config.experiment = experiment;
                return config;
            }
        }
    ]);
}();

});
parcelRegister("edtOW", function(module, exports) {
$parcel$export(module.exports, "getOptionsWithDefaults", () => $a5996959142470ab$export$d119b37e5f788b43);
$parcel$export(module.exports, "shallowEquals", () => $a5996959142470ab$export$fa1c2bbf4100b8bc);
$parcel$export(module.exports, "toStatsigUser", () => $a5996959142470ab$export$3dad1db244472f32);
$parcel$export(module.exports, "migrateInitializationOptions", () => $a5996959142470ab$export$202946b690d26d22);
$parcel$export(module.exports, "migrateEvaluationDetails", () => $a5996959142470ab$export$18ad168d3dbac899);
$parcel$export(module.exports, "migrateSecondaryExposures", () => $a5996959142470ab$export$55fd683752d01e67);

var $1Vcia = parcelRequire("1Vcia");

var $iYJcE = parcelRequire("iYJcE");

var $25nEq = parcelRequire("25nEq");

var $ygbGG = parcelRequire("ygbGG");

var $fDQ0p = parcelRequire("fDQ0p");

var $jLH8B = parcelRequire("jLH8B");
var $a5996959142470ab$var$_excluded = [
    "api",
    "disableCurrentPageLogging",
    "loggingIntervalMillis",
    "loggingBufferMaxSize",
    "localMode",
    "eventLoggingApi",
    "eventLoggingApiForRetries",
    "disableLocalStorage",
    "ignoreWindowUndefined",
    "disableAllLogging",
    "initTimeoutMs",
    "disableNetworkKeepalive",
    "overrideStableID",
    "disableErrorLogging",
    "disableAutoMetricsLogging"
];
function $a5996959142470ab$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $a5996959142470ab$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $a5996959142470ab$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $a5996959142470ab$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $a5996959142470ab$export$d119b37e5f788b43 = function getOptionsWithDefaults(options) {
    return $a5996959142470ab$var$_objectSpread({
        /**
     * If more federal PerimeterTypes are added in the future, this should be updated so
     * that isFedRamp() === true always returns the strictest perimeter.
     */ perimeter: (0, $ygbGG.isFedRamp)() ? (0, $jLH8B.PerimeterType).FEDRAMP_MODERATE : (0, $jLH8B.PerimeterType).COMMERCIAL
    }, options);
};
var $a5996959142470ab$export$fa1c2bbf4100b8bc = function shallowEquals(objectA, objectB) {
    if (!objectA && !objectB) return true;
    if (!objectA || !objectB) return false;
    var aEntries = Object.entries(objectA);
    var bEntries = Object.entries(objectB);
    if (aEntries.length !== bEntries.length) return false;
    var ascendingKeyOrder = function ascendingKeyOrder(_ref, _ref2) {
        var _ref3 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_ref, 1), key1 = _ref3[0];
        var _ref4 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_ref2, 1), key2 = _ref4[0];
        return key1.localeCompare(key2);
    };
    aEntries.sort(ascendingKeyOrder);
    bEntries.sort(ascendingKeyOrder);
    for(var i = 0; i < aEntries.length; i++){
        var _aEntries$i = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(aEntries[i], 2), aValue = _aEntries$i[1];
        var _bEntries$i = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(bEntries[i], 2), bValue = _bEntries$i[1];
        if (aValue !== bValue) return false;
    }
    return true;
};
var $a5996959142470ab$export$3dad1db244472f32 = function toStatsigUser(identifiers, customAttributes) {
    var user = {
        customIDs: identifiers,
        custom: customAttributes
    };
    if (identifiers.atlassianAccountId) user.userID = identifiers.atlassianAccountId;
    return user;
};
var $a5996959142470ab$export$202946b690d26d22 = function migrateInitializationOptions(options) {
    var api = options.api, disableCurrentPageLogging = options.disableCurrentPageLogging, loggingIntervalMillis = options.loggingIntervalMillis, loggingBufferMaxSize = options.loggingBufferMaxSize, localMode = options.localMode, eventLoggingApi = options.eventLoggingApi, eventLoggingApiForRetries = options.eventLoggingApiForRetries, disableLocalStorage = options.disableLocalStorage, ignoreWindowUndefined = options.ignoreWindowUndefined, disableAllLogging = options.disableAllLogging, _initTimeoutMs = options.initTimeoutMs, _disableNetworkKeepalive = options.disableNetworkKeepalive, _overrideStableID = options.overrideStableID, _disableErrorLogging = options.disableErrorLogging, _disableAutoMetricsLogging = options.disableAutoMetricsLogging, rest = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(options, $a5996959142470ab$var$_excluded);
    return $a5996959142470ab$var$_objectSpread($a5996959142470ab$var$_objectSpread({}, rest), {}, {
        networkConfig: {
            api: api,
            logEventUrl: eventLoggingApi ? eventLoggingApi + 'rgstr' : undefined,
            logEventFallbackUrls: eventLoggingApiForRetries ? [
                eventLoggingApiForRetries
            ] : undefined,
            preventAllNetworkTraffic: localMode || !ignoreWindowUndefined && typeof window === 'undefined'
        },
        includeCurrentPageUrlWithEvents: !disableCurrentPageLogging,
        loggingIntervalMs: loggingIntervalMillis,
        loggingBufferMaxSize: loggingBufferMaxSize,
        disableStorage: disableLocalStorage === undefined ? localMode : disableLocalStorage,
        disableLogging: disableAllLogging === undefined ? localMode : disableAllLogging
    });
};
var $a5996959142470ab$var$evaluationReasonMappings = Object.entries((0, $fDQ0p.EvaluationReason)).map(function(_ref5) {
    var _ref6 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_ref5, 2), key = _ref6[0], value = _ref6[1];
    return [
        key.toLowerCase(),
        value
    ];
});
var $a5996959142470ab$export$18ad168d3dbac899 = function migrateEvaluationDetails(details) {
    var _evaluationReasonMapp, _evaluationReasonMapp2, _details$receivedAt;
    var reasonLower = details.reason.toLowerCase();
    return {
        reason: (_evaluationReasonMapp = (_evaluationReasonMapp2 = $a5996959142470ab$var$evaluationReasonMappings.find(function(_ref7) {
            var _ref8 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_ref7, 1), key = _ref8[0];
            return reasonLower.includes(key);
        })) === null || _evaluationReasonMapp2 === void 0 ? void 0 : _evaluationReasonMapp2[1]) !== null && _evaluationReasonMapp !== void 0 ? _evaluationReasonMapp : (0, $fDQ0p.EvaluationReason).Unknown,
        time: (_details$receivedAt = details.receivedAt) !== null && _details$receivedAt !== void 0 ? _details$receivedAt : Date.now()
    };
};
var $a5996959142470ab$export$55fd683752d01e67 = function migrateSecondaryExposures(secondaryExposures) {
    return secondaryExposures.map(function(exposure) {
        if (typeof exposure === 'string') // This should ideally have gateValue and ruleID fields too, but it's not possible for us
        // to determine the correct values for these.
        return {
            gate: exposure
        };
        return exposure;
    });
};

});
parcelRegister("fDQ0p", function(module, exports) {
$parcel$export(module.exports, "EvaluationReason", () => $b632d6c71a1941fc$export$c62558b199e46828);
// Reference: https://github.com/statsig-io/js-lite/blob/main/src/StatsigStore.ts
var $b632d6c71a1941fc$export$c62558b199e46828 = /*#__PURE__*/ function(EvaluationReason) {
    // Order is important since the logic for migrating from a new client reason to an old one
    // returns the first which is a substring of the new client reason
    EvaluationReason["Error"] = "Error";
    EvaluationReason["LocalOverride"] = "LocalOverride";
    EvaluationReason["Unrecognized"] = "Unrecognized";
    EvaluationReason["Uninitialized"] = "Uninitialized";
    EvaluationReason["NetworkNotModified"] = "NetworkNotModified";
    EvaluationReason["Network"] = "Network";
    EvaluationReason["InvalidBootstrap"] = "InvalidBootstrap";
    EvaluationReason["Bootstrap"] = "Bootstrap";
    EvaluationReason["Cache"] = "Cache";
    // For when we could not migrate the reason from the new client
    EvaluationReason["Unknown"] = "Unknown";
    return EvaluationReason;
}({}); // Reference: https://github.com/statsig-io/js-lite/blob/main/src/StatsigSDKOptions.ts

});

parcelRegister("jLH8B", function(module, exports) {
$parcel$export(module.exports, "FeatureGateEnvironment", () => $e643de58afdb7025$export$479e7351a733299);
$parcel$export(module.exports, "PerimeterType", () => $e643de58afdb7025$export$c42b7bbc5e7ba555);
/**
 * The identifiers for the user. Options are restricted to the set that is currently supported.
 */ /**
 * Base client options. Does not include any options specific to providers
 * @interface BaseClientOptions
 * @property {FeatureGateEnvironment} environment - The environment for the client.
 * @property {string} targetApp - The target app for the client.
 * @property {AnalyticsWebClient} analyticsWebClient - The analytics web client.
 * @property {PerimeterType} perimeter - The perimeter for the client.
 */ /**
 * The options for the client.
 * @interface ClientOptions
 * @extends {BaseClientOptions}
 * @property {string} apiKey - The API key for the client.
 * @property {fetchTimeoutMs} fetchTimeoutMs - The timeout for the fetch request in milliseconds. Defaults to 5000.
 * @property {boolean} useGatewayURL - Whether to use the gateway URL. Defaults to false.
 */ /**
 * The custom attributes for the user.
 */ var $e643de58afdb7025$export$479e7351a733299 = /*#__PURE__*/ function(FeatureGateEnvironment) {
    FeatureGateEnvironment["Development"] = "development";
    FeatureGateEnvironment["Staging"] = "staging";
    FeatureGateEnvironment["Production"] = "production";
    return FeatureGateEnvironment;
}({});
var $e643de58afdb7025$export$c42b7bbc5e7ba555 = /*#__PURE__*/ function(PerimeterType) {
    PerimeterType["COMMERCIAL"] = "commercial";
    PerimeterType["FEDRAMP_MODERATE"] = "fedramp-moderate";
    return PerimeterType;
}({});
var $e643de58afdb7025$export$42f4885608027d0c = 'non_boolean'; // Type magic to get the JSDoc comments from the Client class methods to appear on the static
 // methods in FeatureGates where the property name and function type are identical

});



parcelRegister("oWFzP", function(module, exports) {
$parcel$export(module.exports, "Layer", () => $04afc090a62e6592$export$936d0764594b6eb3);

var $ekGgq = parcelRequire("ekGgq");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $edtOW = parcelRequire("edtOW");
var $04afc090a62e6592$export$936d0764594b6eb3 = /*#__PURE__*/ function() {
    function Layer(name, layerValue, ruleID, evaluationDetails) {
        var logParameterFunction = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
        var secondaryExposures = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : [];
        var undelegatedSecondaryExposures = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : [];
        var allocatedExperimentName = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : '';
        var explicitParameters = arguments.length > 8 && arguments[8] !== undefined ? arguments[8] : [];
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, Layer);
        this._logParameterFunction = logParameterFunction;
        this._name = name;
        this._value = JSON.parse(JSON.stringify(layerValue !== null && layerValue !== void 0 ? layerValue : {}));
        this._ruleID = ruleID !== null && ruleID !== void 0 ? ruleID : '';
        this._evaluationDetails = evaluationDetails;
        this._secondaryExposures = secondaryExposures;
        this._undelegatedSecondaryExposures = undelegatedSecondaryExposures;
        this._allocatedExperimentName = allocatedExperimentName;
        this._explicitParameters = explicitParameters;
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(Layer, [
        {
            key: "get",
            value: function get(key, defaultValue, typeGuard) {
                var _this = this;
                var val = this._value[key];
                if (val == null) return defaultValue;
                var logAndReturn = function logAndReturn() {
                    _this._logLayerParameterExposure(key);
                    return val;
                };
                if (typeGuard) return typeGuard(val) ? logAndReturn() : defaultValue;
                if (defaultValue == null) return logAndReturn();
                if ((0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(val) === (0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(defaultValue) && Array.isArray(defaultValue) === Array.isArray(val)) return logAndReturn();
                return defaultValue;
            }
        },
        {
            key: "getValue",
            value: function getValue(key, defaultValue) {
                // eslint-disable-next-line eqeqeq
                if (defaultValue == undefined) defaultValue = null;
                var val = this._value[key];
                if (val != null) this._logLayerParameterExposure(key);
                return val !== null && val !== void 0 ? val : defaultValue;
            }
        },
        {
            key: "_logLayerParameterExposure",
            value: function _logLayerParameterExposure(parameterName) {
                var _this$_logParameterFu;
                (_this$_logParameterFu = this._logParameterFunction) === null || _this$_logParameterFu === void 0 || _this$_logParameterFu.call(this, this, parameterName);
            }
        }
    ], [
        {
            key: "fromLayer",
            value: function fromLayer(layer) {
                var _layer$__evaluation$s, _layer$__evaluation, _layer$__evaluation$u, _layer$__evaluation2, _layer$__evaluation3, _layer$__evaluation4;
                var value = new Layer(layer.name, layer.__value, layer.ruleID, (0, $edtOW.migrateEvaluationDetails)(layer.details), function(_layer, parameterName) {
                    return layer.get(parameterName);
                }, (0, $edtOW.migrateSecondaryExposures)((_layer$__evaluation$s = (_layer$__evaluation = layer.__evaluation) === null || _layer$__evaluation === void 0 ? void 0 : _layer$__evaluation.secondary_exposures) !== null && _layer$__evaluation$s !== void 0 ? _layer$__evaluation$s : []), (0, $edtOW.migrateSecondaryExposures)((_layer$__evaluation$u = (_layer$__evaluation2 = layer.__evaluation) === null || _layer$__evaluation2 === void 0 ? void 0 : _layer$__evaluation2.undelegated_secondary_exposures) !== null && _layer$__evaluation$u !== void 0 ? _layer$__evaluation$u : []), (_layer$__evaluation3 = layer.__evaluation) === null || _layer$__evaluation3 === void 0 ? void 0 : _layer$__evaluation3.allocated_experiment_name, (_layer$__evaluation4 = layer.__evaluation) === null || _layer$__evaluation4 === void 0 ? void 0 : _layer$__evaluation4.explicit_parameters);
                return value;
            }
        }
    ]);
}();

});

parcelRegister("gwO2H", function(module, exports) {
$parcel$export(module.exports, "default", () => $c08673e2ec4692df$export$2e2bcd8739ae039);

var $25nEq = parcelRequire("25nEq");

var $fL8KA = parcelRequire("fL8KA");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $6HG4S = parcelRequire("6HG4S");

var $jLH8B = parcelRequire("jLH8B");

var $an40Y = parcelRequire("an40Y");

var $1HkPh = parcelRequire("1HkPh");
function $c08673e2ec4692df$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $c08673e2ec4692df$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $c08673e2ec4692df$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $c08673e2ec4692df$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $c08673e2ec4692df$var$DEFAULT_REQUEST_TIMEOUT_MS = 5000;
var $c08673e2ec4692df$export$250a58ecde616daa = 'https://api.atlassian.com/flags';
var $c08673e2ec4692df$export$942ba04389b0d5a2 = 'https://api.stg.atlassian.com/flags';
var $c08673e2ec4692df$export$f058dbf75c3bc647 = 'https://api.dev.atlassian.com/flags';
var $c08673e2ec4692df$export$1a401a0da8da3565 = 'https://api.stg.atlassian-us-gov-mod.com/flags';
var $c08673e2ec4692df$export$18c93900db9358a4 = 'https://api.atlassian-us-gov-mod.com/flags';
var $c08673e2ec4692df$export$4e8a0415edbfa1f7 = 'https://atlassian-statsig-proxy-archetype.atl-paas.%s.atl-ic.net';
var $c08673e2ec4692df$export$cb3cd156f70d7e94 = 'oasis-stg.com/flags';
var $c08673e2ec4692df$export$921fbc6cdfd4eee0 = 'atlassian-isolated.net/flags';
var $c08673e2ec4692df$export$450bd8fb2a6d7ace = '/gateway/api/flags';
var $c08673e2ec4692df$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function Fetcher() {
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, Fetcher);
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(Fetcher, null, [
        {
            key: "fetchClientSdk",
            value: function() {
                var _fetchClientSdk = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee(fetcherOptions) {
                    var targetApp, url;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee$(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                targetApp = fetcherOptions.targetApp;
                                url = "/api/v2/frontend/clientSdkKey/".concat(targetApp);
                                _context.prev = 2;
                                _context.next = 5;
                                return this.fetchRequest(url, 'GET', fetcherOptions);
                            case 5:
                                return _context.abrupt("return", _context.sent);
                            case 8:
                                _context.prev = 8;
                                _context.t0 = _context["catch"](2);
                                if (!(_context.t0 instanceof Error)) {
                                    _context.next = 12;
                                    break;
                                }
                                throw _context.t0;
                            case 12:
                                throw Error('Failed to retrieve client sdk key');
                            case 13:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee, this, [
                        [
                            2,
                            8
                        ]
                    ]);
                }));
                function fetchClientSdk(_x) {
                    return _fetchClientSdk.apply(this, arguments);
                }
                return fetchClientSdk;
            }()
        },
        {
            key: "fetchExperimentValues",
            value: function() {
                var _fetchExperimentValues = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee2(fetcherOptions, identifiers, customAttributes) {
                    var requestBody;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee2$(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                requestBody = {
                                    identifiers: identifiers,
                                    customAttributes: customAttributes,
                                    targetApp: fetcherOptions.targetApp
                                };
                                _context2.prev = 1;
                                _context2.next = 4;
                                return this.fetchRequest('/api/v2/frontend/experimentValues', 'POST', fetcherOptions, requestBody);
                            case 4:
                                return _context2.abrupt("return", _context2.sent);
                            case 7:
                                _context2.prev = 7;
                                _context2.t0 = _context2["catch"](1);
                                if (!(_context2.t0 instanceof Error)) {
                                    _context2.next = 11;
                                    break;
                                }
                                throw _context2.t0;
                            case 11:
                                throw Error('Failed to retrieve experiment values');
                            case 12:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2, this, [
                        [
                            1,
                            7
                        ]
                    ]);
                }));
                function fetchExperimentValues(_x2, _x3, _x4) {
                    return _fetchExperimentValues.apply(this, arguments);
                }
                return fetchExperimentValues;
            }()
        },
        {
            key: "handleResponseError",
            value: function() {
                var _handleResponseError = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee3(response) {
                    var body;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee3$(_context3) {
                        while(true)switch(_context3.prev = _context3.next){
                            case 0:
                                if (response.ok) {
                                    _context3.next = 5;
                                    break;
                                }
                                _context3.next = 3;
                                return response.text();
                            case 3:
                                body = _context3.sent;
                                throw new (0, $1HkPh.ResponseError)("Non 2xx response status received, status: ".concat(response.status, ", body: ").concat(JSON.stringify(body)));
                            case 5:
                                if (!(response.status === 204)) {
                                    _context3.next = 7;
                                    break;
                                }
                                throw new (0, $1HkPh.ResponseError)('Unexpected 204 response');
                            case 7:
                            case "end":
                                return _context3.stop();
                        }
                    }, _callee3);
                }));
                function handleResponseError(_x5) {
                    return _handleResponseError.apply(this, arguments);
                }
                return handleResponseError;
            }()
        },
        {
            key: "extractResponseBody",
            value: function() {
                var _extractResponseBody = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee4(response) {
                    var value;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee4$(_context4) {
                        while(true)switch(_context4.prev = _context4.next){
                            case 0:
                                _context4.next = 2;
                                return response.text();
                            case 2:
                                value = _context4.sent;
                                return _context4.abrupt("return", JSON.parse(value));
                            case 4:
                            case "end":
                                return _context4.stop();
                        }
                    }, _callee4);
                }));
                function extractResponseBody(_x6) {
                    return _extractResponseBody.apply(this, arguments);
                }
                return extractResponseBody;
            }()
        },
        {
            key: "getBaseUrl",
            value: function getBaseUrl(serviceEnv) {
                var useGatewayUrl = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
                var perimeter = arguments.length > 2 ? arguments[2] : undefined;
                var isolationContextId = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
                if (useGatewayUrl) return $c08673e2ec4692df$export$450bd8fb2a6d7ace;
                if (perimeter === (0, $jLH8B.PerimeterType).FEDRAMP_MODERATE) switch(serviceEnv){
                    case (0, $jLH8B.FeatureGateEnvironment).Production:
                        return $c08673e2ec4692df$export$18c93900db9358a4;
                    case (0, $jLH8B.FeatureGateEnvironment).Staging:
                        return $c08673e2ec4692df$export$1a401a0da8da3565;
                    default:
                        throw new Error("Invalid environment \"".concat(serviceEnv, "\" for \"").concat(perimeter, "\" perimeter"));
                }
                else if (perimeter === (0, $jLH8B.PerimeterType).COMMERCIAL) switch(serviceEnv){
                    case (0, $jLH8B.FeatureGateEnvironment).Development:
                        return $c08673e2ec4692df$export$f058dbf75c3bc647;
                    case (0, $jLH8B.FeatureGateEnvironment).Staging:
                        var apiUrl = this.getApiUrl(isolationContextId);
                        if (apiUrl !== null) return apiUrl;
                        return $c08673e2ec4692df$export$942ba04389b0d5a2;
                    default:
                        var prodApiUrl = this.getApiUrl(isolationContextId);
                        if (prodApiUrl !== null) return prodApiUrl;
                        return $c08673e2ec4692df$export$250a58ecde616daa;
                }
                else throw new Error("Invalid perimeter \"".concat(perimeter, "\""));
            }
        },
        {
            key: "fetchRequest",
            value: function() {
                var _fetchRequest = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee5(path, method, fetcherOptions, body) {
                    var baseUrl, fetchTimeout, abortSignal, abortController, response;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee5$(_context5) {
                        while(true)switch(_context5.prev = _context5.next){
                            case 0:
                                baseUrl = Fetcher.getBaseUrl(fetcherOptions.environment, fetcherOptions.useGatewayURL, fetcherOptions.perimeter, fetcherOptions.isolationContextId);
                                fetchTimeout = fetcherOptions.fetchTimeoutMs || $c08673e2ec4692df$var$DEFAULT_REQUEST_TIMEOUT_MS;
                                if (AbortSignal.timeout) abortSignal = AbortSignal.timeout(fetchTimeout);
                                else if (AbortController) {
                                    abortController = new AbortController();
                                    abortSignal = abortController.signal;
                                    setTimeout(function() {
                                        return abortController.abort();
                                    }, fetchTimeout);
                                }
                                _context5.next = 5;
                                return fetch("".concat(baseUrl).concat(path), $c08673e2ec4692df$var$_objectSpread({
                                    method: method,
                                    headers: {
                                        'Content-Type': 'application/json',
                                        'X-Client-Name': 'feature-gate-js-client',
                                        'X-Client-Version': (0, $an40Y.CLIENT_VERSION),
                                        'X-API-KEY': fetcherOptions.apiKey
                                    },
                                    signal: abortSignal
                                }, body && {
                                    body: JSON.stringify(body)
                                }));
                            case 5:
                                response = _context5.sent;
                                _context5.next = 8;
                                return this.handleResponseError(response);
                            case 8:
                                _context5.next = 10;
                                return this.extractResponseBody(response);
                            case 10:
                                return _context5.abrupt("return", _context5.sent);
                            case 11:
                            case "end":
                                return _context5.stop();
                        }
                    }, _callee5, this);
                }));
                function fetchRequest(_x7, _x8, _x9, _x0) {
                    return _fetchRequest.apply(this, arguments);
                }
                return fetchRequest;
            }()
        },
        {
            key: "getApiUrl",
            value: function getApiUrl(isolationContextId) {
                var window1 = this.getWindowLocation();
                if (window1 === undefined) {
                    //this is needed when this SDK is used for SSR or plugin use cases where secret keys not available to use backend SDKs
                    if (!isolationContextId) return null;
                    return $c08673e2ec4692df$export$4e8a0415edbfa1f7.replace('%s', isolationContextId);
                }
                var protocol = window1.protocol, hostname = window1.hostname;
                // Match last subdomain fragment before oasis-stg.com
                var oasisMatch = hostname.match(/([^.]+)\.oasis-stg\.com$/);
                if (oasisMatch) return "".concat(protocol, "//api.").concat(oasisMatch[1], ".").concat($c08673e2ec4692df$export$cb3cd156f70d7e94);
                // Match last subdomain fragment before atlassian-isolated.net
                var isolatedMatch = hostname.match(/([^.]+)\.atlassian-isolated\.net$/);
                if (isolatedMatch) return "".concat(protocol, "//api.").concat(isolatedMatch[1], ".").concat($c08673e2ec4692df$export$921fbc6cdfd4eee0);
                return null;
            }
        },
        {
            key: "getWindowLocation",
            value: function getWindowLocation() {
                if (typeof window !== 'undefined' && window.location) return window.location;
                return undefined;
            }
        }
    ]);
}();

});
parcelRegister("an40Y", function(module, exports) {
$parcel$export(module.exports, "CLIENT_VERSION", () => $78cf2a9a1a6ba7be$export$a59f8d67326bd1cb);
/// <reference types="node" />
var $78cf2a9a1a6ba7be$export$a59f8d67326bd1cb = "0.0.0-development";

});

parcelRegister("1HkPh", function(module, exports) {
$parcel$export(module.exports, "ResponseError", () => $13c9f63382ae0148$export$286baf652d0b1206);

var $arMYe = parcelRequire("arMYe");

var $9P61R = parcelRequire("9P61R");

var $kIXpt = parcelRequire("kIXpt");

var $cYPzS = parcelRequire("cYPzS");

var $eyuDe = parcelRequire("eyuDe");

var $c7s0H = parcelRequire("c7s0H");
function $13c9f63382ae0148$var$_callSuper(t, o, e) {
    return o = (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(o), (0, (/*@__PURE__*/$parcel$interopDefault($kIXpt)))(t, $13c9f63382ae0148$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(t).constructor) : o.apply(t, e));
}
function $13c9f63382ae0148$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($13c9f63382ae0148$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $13c9f63382ae0148$export$286baf652d0b1206 = /*#__PURE__*/ function(_Error) {
    function ResponseError(message) {
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, ResponseError);
        return $13c9f63382ae0148$var$_callSuper(this, ResponseError, [
            message
        ]);
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($eyuDe)))(ResponseError, _Error);
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(ResponseError);
}(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($c7s0H)))(Error));

});


parcelRegister("cyIRe", function(module, exports) {
$parcel$export(module.exports, "NoFetchDataAdapter", () => $924b74c5bfbcde0b$export$55fffef3474104af);

var $fL8KA = parcelRequire("fL8KA");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $kIXpt = parcelRequire("kIXpt");

var $cYPzS = parcelRequire("cYPzS");

var $lwlXp = parcelRequire("lwlXp");

var $eyuDe = parcelRequire("eyuDe");

var $25nEq = parcelRequire("25nEq");

var $6HG4S = parcelRequire("6HG4S");

var $iFR7a = parcelRequire("iFR7a");
function $924b74c5bfbcde0b$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $924b74c5bfbcde0b$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $924b74c5bfbcde0b$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $924b74c5bfbcde0b$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $924b74c5bfbcde0b$var$_callSuper(t, o, e) {
    return o = (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(o), (0, (/*@__PURE__*/$parcel$interopDefault($kIXpt)))(t, $924b74c5bfbcde0b$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(t).constructor) : o.apply(t, e));
}
function $924b74c5bfbcde0b$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($924b74c5bfbcde0b$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $924b74c5bfbcde0b$var$_superPropGet(t, o, e, r) {
    var p = (0, (/*@__PURE__*/$parcel$interopDefault($lwlXp)))((0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(1 & r ? t.prototype : t), o, e);
    return 2 & r && "function" == typeof p ? function(t) {
        return p.apply(e, t);
    } : p;
}
var $924b74c5bfbcde0b$export$55fffef3474104af = /*#__PURE__*/ function(_DataAdapterCore) {
    function NoFetchDataAdapter() {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, NoFetchDataAdapter);
        _this = $924b74c5bfbcde0b$var$_callSuper(this, NoFetchDataAdapter, [
            'NoFetchDataAdapter',
            'nofetch'
        ]);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "bootstrapResult", null);
        return _this;
    }
    /**
   * Make sure to call this **before** calling `initializeAsync` or `updateUserAsync` but
   * after the Statsig client has been created!
   */ (0, (/*@__PURE__*/$parcel$interopDefault($eyuDe)))(NoFetchDataAdapter, _DataAdapterCore);
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(NoFetchDataAdapter, [
        {
            key: "setBootstrapData",
            value: function setBootstrapData(data) {
                this.bootstrapResult = data ? {
                    source: 'Bootstrap',
                    data: JSON.stringify(data),
                    receivedAt: Date.now(),
                    stableID: (0, $iFR7a.StableID).get(this._getSdkKey()),
                    fullUserHash: null
                } : null;
            }
        },
        {
            key: "prefetchData",
            value: function() {
                var _prefetchData = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee(_user, _options) {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee$(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee);
                }));
                function prefetchData(_x, _x2) {
                    return _prefetchData.apply(this, arguments);
                }
                return prefetchData;
            }()
        },
        {
            key: "getDataAsync",
            value: function() {
                var _getDataAsync = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee2(_current, user, _options) {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee2$(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                return _context2.abrupt("return", this.bootstrapResult && $924b74c5bfbcde0b$var$_objectSpread($924b74c5bfbcde0b$var$_objectSpread({}, this.bootstrapResult), {}, {
                                    fullUserHash: (0, $iFR7a._getFullUserHash)(user)
                                }));
                            case 1:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2, this);
                }));
                function getDataAsync(_x3, _x4, _x5) {
                    return _getDataAsync.apply(this, arguments);
                }
                return getDataAsync;
            }()
        },
        {
            key: "getDataSync",
            value: function getDataSync(user) {
                return this.bootstrapResult && $924b74c5bfbcde0b$var$_objectSpread($924b74c5bfbcde0b$var$_objectSpread({}, this.bootstrapResult), {}, {
                    fullUserHash: (0, $iFR7a._getFullUserHash)(user)
                });
            }
        },
        {
            key: "_fetchFromNetwork",
            value: function() {
                var _fetchFromNetwork2 = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee3(_current, _user, _options) {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee3$(_context3) {
                        while(true)switch(_context3.prev = _context3.next){
                            case 0:
                                return _context3.abrupt("return", null);
                            case 1:
                            case "end":
                                return _context3.stop();
                        }
                    }, _callee3);
                }));
                function _fetchFromNetwork(_x6, _x7, _x8) {
                    return _fetchFromNetwork2.apply(this, arguments);
                }
                return _fetchFromNetwork;
            }()
        },
        {
            key: "_getCacheKey",
            value: function _getCacheKey(user) {
                // Same logic as default data adapter
                // https://github.com/statsig-io/js-client-monorepo/blob/main/packages/js-client/src/StatsigEvaluationsDataAdapter.ts
                var key = (0, $iFR7a._getStorageKey)(this._getSdkKey(), user);
                return "".concat((0, $iFR7a.DataAdapterCachePrefix), ".").concat(this._cacheSuffix, ".").concat(key);
            }
        },
        {
            key: "_isCachedResultValidFor204",
            value: function _isCachedResultValidFor204(_result, _user) {
                return false;
            }
        },
        {
            key: "setDataLegacy",
            value: function setDataLegacy(data, user) {
                $924b74c5bfbcde0b$var$_superPropGet(NoFetchDataAdapter, "setData", this, 3)([
                    data,
                    user
                ]);
            }
        },
        {
            key: "toJSON",
            value: function toJSON() {
                var result = $924b74c5bfbcde0b$var$_objectSpread({}, this);
                delete result._options;
                delete result._inMemoryCache;
                delete result.bootstrapResult;
                return result;
            }
        }
    ]);
}((0, $iFR7a.DataAdapterCore));

});

parcelRegister("iMRG8", function(module, exports) {
$parcel$export(module.exports, "LOCAL_STORAGE_KEY", () => $0387961536103856$export$d8474cff104280f3);
$parcel$export(module.exports, "PersistentOverrideAdapter", () => $0387961536103856$export$bcb28fbac1def494);

var $25nEq = parcelRequire("25nEq");

var $iYJcE = parcelRequire("iYJcE");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $dtn6l = parcelRequire("dtn6l");
function $0387961536103856$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $0387961536103856$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $0387961536103856$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $0387961536103856$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $0387961536103856$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $0387961536103856$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $0387961536103856$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $0387961536103856$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $0387961536103856$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $0387961536103856$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
var $0387961536103856$var$LOCAL_OVERRIDE_REASON = 'LocalOverride:Recognized';
var $0387961536103856$export$d8474cff104280f3 = 'STATSIG_OVERRIDES';
var $0387961536103856$var$LEGACY_LOCAL_STORAGE_KEY = 'STATSIG_JS_LITE_LOCAL_OVERRIDES';
var $0387961536103856$var$makeEmptyStore = function makeEmptyStore() {
    return {
        gates: {},
        configs: {},
        layers: {}
    };
};
var $0387961536103856$var$djb2MapKey = function djb2MapKey(hash, kind) {
    return kind + ':' + hash;
};
var $0387961536103856$export$bcb28fbac1def494 = /*#__PURE__*/ function() {
    function PersistentOverrideAdapter(localStorageKey) {
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, PersistentOverrideAdapter);
        this._overrides = $0387961536103856$var$makeEmptyStore();
        this._djb2Map = new Map();
        this._localStorageKey = localStorageKey;
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(PersistentOverrideAdapter, [
        {
            key: "parseStoredOverrides",
            value: function parseStoredOverrides(localStorageKey) {
                try {
                    var json = window.localStorage.getItem(localStorageKey);
                    if (!json) return $0387961536103856$var$makeEmptyStore();
                    return JSON.parse(json);
                } catch (_unused) {
                    return $0387961536103856$var$makeEmptyStore();
                }
            }
        },
        {
            key: "mergeOverrides",
            value: function mergeOverrides() {
                var merged = $0387961536103856$var$makeEmptyStore();
                for(var _len = arguments.length, allOverrides = new Array(_len), _key = 0; _key < _len; _key++)allOverrides[_key] = arguments[_key];
                for(var _i = 0, _allOverrides = allOverrides; _i < _allOverrides.length; _i++){
                    var overrides = _allOverrides[_i];
                    for(var _i2 = 0, _Object$entries = Object.entries((_overrides$gates = overrides.gates) !== null && _overrides$gates !== void 0 ? _overrides$gates : {}); _i2 < _Object$entries.length; _i2++){
                        var _overrides$gates;
                        var _Object$entries$_i = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_Object$entries[_i2], 2), name = _Object$entries$_i[0], value = _Object$entries$_i[1];
                        merged.gates[name] = value;
                    }
                    for(var _i3 = 0, _Object$entries2 = Object.entries((_overrides$configs = overrides.configs) !== null && _overrides$configs !== void 0 ? _overrides$configs : {}); _i3 < _Object$entries2.length; _i3++){
                        var _overrides$configs;
                        var _Object$entries2$_i = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_Object$entries2[_i3], 2), _name = _Object$entries2$_i[0], _value = _Object$entries2$_i[1];
                        merged.configs[_name] = _value;
                    }
                    for(var _i4 = 0, _Object$entries3 = Object.entries((_overrides$layers = overrides.layers) !== null && _overrides$layers !== void 0 ? _overrides$layers : {}); _i4 < _Object$entries3.length; _i4++){
                        var _overrides$layers;
                        var _Object$entries3$_i = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_Object$entries3[_i4], 2), _name2 = _Object$entries3$_i[0], _value2 = _Object$entries3$_i[1];
                        merged.layers[_name2] = _value2;
                    }
                }
                return merged;
            }
        },
        {
            key: "initFromStoredOverrides",
            value: function initFromStoredOverrides() {
                var storedOverrides = this.mergeOverrides(this._overrides, this.parseStoredOverrides($0387961536103856$var$LEGACY_LOCAL_STORAGE_KEY), this.parseStoredOverrides(this._localStorageKey));
                // Clear data from legacy local storage key now we've read from it.
                // This prevents things being stuck in there that are always read but never written to.
                try {
                    window.localStorage.removeItem($0387961536103856$var$LEGACY_LOCAL_STORAGE_KEY);
                } catch (_unused2) {
                // ignored - window is not defined in non-browser environments, and we don't save things there
                // (things like SSR, etc)
                }
                // In version 4.24.0 we introduced hashes in this override adapter, but had a bug which would cause
                // multiple hashes to continue being created. This code here removes these hashes since we've moved
                // to using a more reliable and easier to maintain map in `_djb2Map`.
                for(var _i5 = 0, _Object$values = Object.values(storedOverrides); _i5 < _Object$values.length; _i5++){
                    var container = _Object$values[_i5];
                    var allKeys = new Set(Object.keys(container));
                    var _iterator = $0387961536103856$var$_createForOfIteratorHelper(allKeys), _step;
                    try {
                        for(_iterator.s(); !(_step = _iterator.n()).done;){
                            var name = _step.value;
                            var hash = (0, $dtn6l._DJB2)(name);
                            if (allKeys.has(hash)) delete container[hash];
                        }
                    } catch (err) {
                        _iterator.e(err);
                    } finally{
                        _iterator.f();
                    }
                }
                this.applyOverrides(storedOverrides);
            }
        },
        {
            key: "saveOverrides",
            value: function saveOverrides() {
                try {
                    window.localStorage.setItem(this._localStorageKey, JSON.stringify(this._overrides));
                } catch (_unused3) {
                // ignored - window is not defined in non-browser environments, and we don't save things there
                // (things like SSR, etc)
                }
            }
        },
        {
            key: "getOverrides",
            value: function getOverrides() {
                return this.mergeOverrides(this._overrides);
            }
        },
        {
            key: "applyOverrides",
            value: function applyOverrides(overrides) {
                var newOverrides = $0387961536103856$var$_objectSpread($0387961536103856$var$_objectSpread({}, $0387961536103856$var$makeEmptyStore()), overrides);
                this._djb2Map.clear();
                for(var _i6 = 0, _Object$entries4 = Object.entries(newOverrides); _i6 < _Object$entries4.length; _i6++){
                    var _Object$entries4$_i = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_Object$entries4[_i6], 2), containerName = _Object$entries4$_i[0], container = _Object$entries4$_i[1];
                    for(var _i7 = 0, _Object$entries5 = Object.entries(container); _i7 < _Object$entries5.length; _i7++){
                        var _Object$entries5$_i = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_Object$entries5[_i7], 2), name = _Object$entries5$_i[0], value = _Object$entries5$_i[1];
                        this._djb2Map.set($0387961536103856$var$djb2MapKey((0, $dtn6l._DJB2)(name), containerName), value);
                    }
                }
                this._overrides = newOverrides;
            }
        },
        {
            key: "setOverrides",
            value: function setOverrides(overrides) {
                this.applyOverrides(overrides);
                this.saveOverrides();
            }
        },
        {
            key: "overrideGate",
            value: function overrideGate(name, value) {
                this._overrides.gates[name] = value;
                this._djb2Map.set($0387961536103856$var$djb2MapKey((0, $dtn6l._DJB2)(name), 'gates'), value);
                this.saveOverrides();
            }
        },
        {
            key: "removeGateOverride",
            value: function removeGateOverride(name) {
                delete this._overrides.gates[name];
                this._djb2Map.delete($0387961536103856$var$djb2MapKey((0, $dtn6l._DJB2)(name), 'gates'));
                this.saveOverrides();
            }
        },
        {
            key: "getGateOverride",
            value: function getGateOverride(current, _user) {
                var _this$_overrides$gate;
                var overridden = (_this$_overrides$gate = this._overrides.gates[current.name]) !== null && _this$_overrides$gate !== void 0 ? _this$_overrides$gate : this._djb2Map.get($0387961536103856$var$djb2MapKey(current.name, 'gates'));
                if (overridden == null) return null;
                return $0387961536103856$var$_objectSpread($0387961536103856$var$_objectSpread({}, current), {}, {
                    value: overridden,
                    details: $0387961536103856$var$_objectSpread($0387961536103856$var$_objectSpread({}, current.details), {}, {
                        reason: $0387961536103856$var$LOCAL_OVERRIDE_REASON
                    })
                });
            }
        },
        {
            key: "overrideDynamicConfig",
            value: function overrideDynamicConfig(name, value) {
                this._overrides.configs[name] = value;
                this._djb2Map.set($0387961536103856$var$djb2MapKey((0, $dtn6l._DJB2)(name), 'configs'), value);
                this.saveOverrides();
            }
        },
        {
            key: "removeDynamicConfigOverride",
            value: function removeDynamicConfigOverride(name) {
                delete this._overrides.configs[name];
                this._djb2Map.delete($0387961536103856$var$djb2MapKey((0, $dtn6l._DJB2)(name), 'configs'));
                this.saveOverrides();
            }
        },
        {
            key: "getDynamicConfigOverride",
            value: function getDynamicConfigOverride(current, _user) {
                return this._getConfigOverride(current, this._overrides.configs);
            }
        },
        {
            key: "overrideExperiment",
            value: function overrideExperiment(name, value) {
                this._overrides.configs[name] = value;
                this._djb2Map.set($0387961536103856$var$djb2MapKey((0, $dtn6l._DJB2)(name), 'configs'), value);
                this.saveOverrides();
            }
        },
        {
            key: "removeExperimentOverride",
            value: function removeExperimentOverride(name) {
                delete this._overrides.configs[name];
                this._djb2Map.delete($0387961536103856$var$djb2MapKey((0, $dtn6l._DJB2)(name), 'configs'));
                this.saveOverrides();
            }
        },
        {
            key: "getExperimentOverride",
            value: function getExperimentOverride(current, _user) {
                return this._getConfigOverride(current, this._overrides.configs);
            }
        },
        {
            key: "overrideLayer",
            value: function overrideLayer(name, value) {
                this._overrides.layers[name] = value;
                this._djb2Map.set($0387961536103856$var$djb2MapKey((0, $dtn6l._DJB2)(name), 'layers'), value);
                this.saveOverrides();
            }
        },
        {
            key: "removeLayerOverride",
            value: function removeLayerOverride(name) {
                delete this._overrides.layers[name];
                this._djb2Map.delete($0387961536103856$var$djb2MapKey((0, $dtn6l._DJB2)(name), 'layers'));
                this.saveOverrides();
            }
        },
        {
            key: "removeAllOverrides",
            value: function removeAllOverrides() {
                this._overrides = $0387961536103856$var$makeEmptyStore();
                try {
                    window.localStorage.removeItem(this._localStorageKey);
                } catch (_unused4) {
                // ignored - window is not defined in non-browser environments, and we don't save things there
                // (things like SSR, etc)
                }
            }
        },
        {
            key: "getLayerOverride",
            value: function getLayerOverride(current, _user) {
                var _this$_overrides$laye;
                var overridden = (_this$_overrides$laye = this._overrides.layers[current.name]) !== null && _this$_overrides$laye !== void 0 ? _this$_overrides$laye : this._djb2Map.get($0387961536103856$var$djb2MapKey(current.name, 'layers'));
                if (overridden == null) return null;
                return $0387961536103856$var$_objectSpread($0387961536103856$var$_objectSpread({}, current), {}, {
                    __value: overridden,
                    get: (0, $dtn6l._makeTypedGet)(current.name, overridden),
                    details: $0387961536103856$var$_objectSpread($0387961536103856$var$_objectSpread({}, current.details), {}, {
                        reason: $0387961536103856$var$LOCAL_OVERRIDE_REASON
                    })
                });
            }
        },
        {
            key: "_getConfigOverride",
            value: function _getConfigOverride(current, lookup) {
                var _lookup$current$name;
                var overridden = (_lookup$current$name = lookup[current.name]) !== null && _lookup$current$name !== void 0 ? _lookup$current$name : this._djb2Map.get($0387961536103856$var$djb2MapKey(current.name, 'configs'));
                if (overridden == null) return null;
                return $0387961536103856$var$_objectSpread($0387961536103856$var$_objectSpread({}, current), {}, {
                    value: overridden,
                    get: (0, $dtn6l._makeTypedGet)(current.name, overridden),
                    details: $0387961536103856$var$_objectSpread($0387961536103856$var$_objectSpread({}, current.details), {}, {
                        reason: $0387961536103856$var$LOCAL_OVERRIDE_REASON
                    })
                });
            }
        }
    ]);
}();

});



parcelRegister("lzj0n", function(module, exports) {
$parcel$export(module.exports, "debug", () => $fb3b9bda6d720a2f$export$1c9f709888824e05);
var $fb3b9bda6d720a2f$var$_process, $fb3b9bda6d720a2f$var$_process2;
// We can't rely on NODE_ENV === 'test' if its value is already configured by the consumer to some other value, so better to use JEST_WORKER_ID
// https://jestjs.io/docs/environment-variables#jest_worker_id
var $fb3b9bda6d720a2f$var$TESTS_MODE = (globalThis === null || globalThis === void 0 || ($fb3b9bda6d720a2f$var$_process = globalThis.process) === null || $fb3b9bda6d720a2f$var$_process === void 0 || ($fb3b9bda6d720a2f$var$_process = $fb3b9bda6d720a2f$var$_process.env) === null || $fb3b9bda6d720a2f$var$_process === void 0 ? void 0 : $fb3b9bda6d720a2f$var$_process.JEST_WORKER_ID) !== undefined;
var $fb3b9bda6d720a2f$var$DEBUG_MODE = !$fb3b9bda6d720a2f$var$TESTS_MODE && (globalThis === null || globalThis === void 0 || ($fb3b9bda6d720a2f$var$_process2 = globalThis.process) === null || $fb3b9bda6d720a2f$var$_process2 === void 0 || ($fb3b9bda6d720a2f$var$_process2 = $fb3b9bda6d720a2f$var$_process2.env) === null || $fb3b9bda6d720a2f$var$_process2 === void 0 ? void 0 : $fb3b9bda6d720a2f$var$_process2.NODE_ENV) !== 'production';
var $fb3b9bda6d720a2f$export$1c9f709888824e05 = function debug() {
    var _console;
    if (!$fb3b9bda6d720a2f$var$DEBUG_MODE) return;
    // eslint-disable-next-line no-console
    (_console = console).debug.apply(_console, arguments);
};

});




parcelRegister("eQzrx", function(module, exports) {
$parcel$export(module.exports, "default", () => $acf16a4a4d0cc0ac$export$2e2bcd8739ae039);

var $5FkrB = parcelRequire("5FkrB");

var $e8xVq = parcelRequire("e8xVq");
var $acf16a4a4d0cc0ac$var$invertedDirection = {
    top: 'bottom',
    bottom: 'top',
    left: 'right',
    right: 'left'
};
/**
 * Props for controlling the behavior of the FadeIn animation
 */ /**
 * __FadeIn__
 *
 * Useful for fading in one or more elements.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/motion/docs/entering-motions)
 */ var $acf16a4a4d0cc0ac$var$FadeIn = function FadeIn(_ref) {
    var children = _ref.children, _ref$duration = _ref.duration, duration = _ref$duration === void 0 ? 'large' : _ref$duration, entranceDirection = _ref.entranceDirection, exitDirection = _ref.exitDirection, _ref$distance = _ref.distance, distance = _ref$distance === void 0 ? 'proportional' : _ref$distance, onFinish = _ref.onFinish, isPaused = _ref.isPaused;
    var invertedEntranceDirection = entranceDirection !== undefined ? $acf16a4a4d0cc0ac$var$invertedDirection[entranceDirection] : undefined;
    var isExitDirect = Boolean(exitDirection || invertedEntranceDirection) ? "fade-out-from-".concat(exitDirection || invertedEntranceDirection).concat(distance === 'proportional' ? '' : '-constant') : 'fade-out';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $e8xVq.default), {
        duration: duration,
        enteringAnimation: entranceDirection ? "fade-in-from-".concat(entranceDirection).concat(distance === 'proportional' ? '' : '-constant') : 'fade-in',
        exitingAnimation: isExitDirect,
        animationTimingFunction: "ease-in-out",
        onFinish: onFinish,
        isPaused: isPaused
    }, children);
};
var $acf16a4a4d0cc0ac$export$2e2bcd8739ae039 = $acf16a4a4d0cc0ac$var$FadeIn;

});
parcelRegister("e8xVq", function(module, exports) {
$parcel$export(module.exports, "default", () => $a4ac20e7f0433359$export$2e2bcd8739ae039);
/* keyframes-motion.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");

var $7uyb0 = parcelRequire("7uyb0");

var $fF5v2 = parcelRequire("fF5v2");

var $euZA7 = parcelRequire("euZA7");

var $ZdqJG = parcelRequire("ZdqJG");

var $8xij1 = parcelRequire("8xij1");
var $a4ac20e7f0433359$var$zoomIn = null;
var $a4ac20e7f0433359$var$zoomOut = null;
var $a4ac20e7f0433359$var$fadeIn = null;
var $a4ac20e7f0433359$var$fadeOut = null;
var $a4ac20e7f0433359$var$fadeInFromTop = null;
var $a4ac20e7f0433359$var$fadeOutFromTop = null;
var $a4ac20e7f0433359$var$fadeInFromLeft = null;
var $a4ac20e7f0433359$var$fadeOutFromLeft = null;
var $a4ac20e7f0433359$var$fadeInFromBottom = null;
var $a4ac20e7f0433359$var$fadeOutFromBottom = null;
var $a4ac20e7f0433359$var$fadeInFromRight = null;
var $a4ac20e7f0433359$var$fadeOutFromRight = null;
var $a4ac20e7f0433359$var$fadeInFromTopConstant = null;
var $a4ac20e7f0433359$var$fadeOutFromTopConstant = null;
var $a4ac20e7f0433359$var$fadeInFromLeftConstant = null;
var $a4ac20e7f0433359$var$fadeOutFromLeftConstant = null;
var $a4ac20e7f0433359$var$fadeInFromBottomConstant = null;
var $a4ac20e7f0433359$var$fadeOutFromBottomConstant = null;
var $a4ac20e7f0433359$var$fadeInFromRightConstant = null;
var $a4ac20e7f0433359$var$fadeOutFromRightConstant = null;
var $a4ac20e7f0433359$var$slideInFromTop = null;
var $a4ac20e7f0433359$var$slideOutFromTop = null;
var $a4ac20e7f0433359$var$slideInFromRight = null;
var $a4ac20e7f0433359$var$slideOutFromRight = null;
var $a4ac20e7f0433359$var$slideInFromBottom = null;
var $a4ac20e7f0433359$var$slideOutFromBottom = null;
var $a4ac20e7f0433359$var$slideInFromLeft = null;
var $a4ac20e7f0433359$var$slideOutFromLeft = null;
/**
 * These are props that motions should use as their external props for consumers.
 * See [FadeIn](packages/helpers/motion/src/entering/fade-in.tsx) for an example usage.
 */ /**
 * This is the base INTERNAL component used for all other entering motions.
 * This does not need Javascript to execute on the client so it will run immediately
 * for any SSR rendered React apps before the JS has executed.
 */ var $a4ac20e7f0433359$var$EnteringMotion = function EnteringMotion(_ref) {
    var children = _ref.children, animationTimingFunction = _ref.animationTimingFunction, _ref$animationTimingF = _ref.animationTimingFunctionExiting, animationTimingFunctionExiting = _ref$animationTimingF === void 0 ? animationTimingFunction : _ref$animationTimingF, enteringAnimation = _ref.enteringAnimation, _ref$exitingAnimation = _ref.exitingAnimation, exitingAnimation = _ref$exitingAnimation === void 0 ? enteringAnimation : _ref$exitingAnimation, isPaused = _ref.isPaused, onFinishMotion = _ref.onFinish, _ref$duration = _ref.duration, duration = _ref$duration === void 0 ? 'large' : _ref$duration;
    var staggered = (0, $8xij1.useStaggeredEntrance)();
    var _useExitingPersistenc = (0, $ZdqJG.useExitingPersistence)(), isExiting = _useExitingPersistenc.isExiting, onExitFinished = _useExitingPersistenc.onFinish, appear = _useExitingPersistenc.appear;
    var setTimeout = (0, $euZA7.useSetTimeout)();
    var paused = isPaused || !staggered.isReady;
    var delay = isExiting ? 0 : staggered.delay;
    var state = isExiting ? 'exiting' : 'entering';
    var _useState = (0, $5FkrB.useState)(appear), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), hasAnimationStyles = _useState2[0], setHasAnimationStyles = _useState2[1];
    (0, $5FkrB.useEffect)(function() {
        // Tracking this to prevent changing state on an unmounted component
        var isCancelled = false;
        if (paused) return;
        // On initial mount if elements aren't set to animate on appear, we return early and callback
        if (!appear) {
            onFinishMotion && onFinishMotion(state);
            return;
        }
        /**
     * Updates relevant state.
     * Called when the animation is finished, or immediately with reduced motion.
     */ var onAnimationEnd = function onAnimationEnd() {
            if (state === 'exiting') // Updates the `ExitingPersistence` to remove this child
            onExitFinished === null || onExitFinished === void 0 || onExitFinished();
            if (!isCancelled) setHasAnimationStyles(false);
            onFinishMotion === null || onFinishMotion === void 0 || onFinishMotion(state);
        };
        if ((0, $7uyb0.isReducedMotion)()) {
            // If there is reduced motion there is no exit animation, so call this immediately
            onAnimationEnd();
            return;
        }
        // Elements may need animation styles back after initial mount (they could animate out)
        setHasAnimationStyles(true);
        // Queue `onAnimationEnd` for after the animation has finished
        setTimeout(onAnimationEnd, isExiting ? (0, $fF5v2.exitingDurations)[duration] : (0, $fF5v2.durations)[duration] + delay);
        return function() {
            isCancelled = true;
        };
    // We ignore this for onFinishMotion as consumers could potentially inline the function
    // which would then trigger this effect every re-render.
    // We want to make it easier for consumers so we go down this path unfortunately.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        onExitFinished,
        state,
        isExiting,
        duration,
        delay,
        paused,
        setTimeout
    ]);
    return children({
        ref: staggered.ref,
        // @ts-expect-error: `ax` is not typed correctly
        className: hasAnimationStyles ? (0, $970q7.default)([
            (0, $970q7.default)([
                "_1o51eoah _1y0co91m _1bumglyw _sedtglyw"
            ]),
            paused && (0, $970q7.default)([
                "_1y0ctrqk"
            ]),
            duration === 'small' && (0, $970q7.default)([
                "_5sag1yx9"
            ]),
            duration === 'medium' && (0, $970q7.default)([
                "_5sag1ttt"
            ]),
            duration === 'large' && (0, $970q7.default)([
                "_5sagpwmj"
            ]),
            isExiting && duration === 'small' && (0, $970q7.default)([
                "_5sag14ed"
            ]),
            isExiting && duration === 'medium' && (0, $970q7.default)([
                "_5sagluct"
            ]),
            isExiting && duration === 'large' && (0, $970q7.default)([
                "_5sag1ttt"
            ]),
            isExiting && (0, $970q7.default)([
                "_ju255cps _1o51q7pw"
            ]),
            !isExiting && animationTimingFunction === 'linear' && (0, $970q7.default)([
                "_1pglp3kn"
            ]),
            !isExiting && animationTimingFunction === 'ease-out' && (0, $970q7.default)([
                "_1pgldkwg"
            ]),
            !isExiting && animationTimingFunction === 'ease-in' && (0, $970q7.default)([
                "_1pgl1nzg"
            ]),
            !isExiting && animationTimingFunction === 'ease-in-40-out' && (0, $970q7.default)([
                "_1pgl5y64"
            ]),
            !isExiting && animationTimingFunction === 'ease-in-60-out' && (0, $970q7.default)([
                "_1pgl1ddy"
            ]),
            !isExiting && animationTimingFunction === 'ease-in-80-out' && (0, $970q7.default)([
                "_1pglannl"
            ]),
            !isExiting && animationTimingFunction === 'ease-in-out' && (0, $970q7.default)([
                "_1pgl1fu8"
            ]),
            isExiting && animationTimingFunction === 'linear' && (0, $970q7.default)([
                "_1pglp3kn"
            ]),
            isExiting && animationTimingFunctionExiting === 'ease-out' && (0, $970q7.default)([
                "_1pgldkwg"
            ]),
            isExiting && animationTimingFunctionExiting === 'ease-in' && (0, $970q7.default)([
                "_1pgl1nzg"
            ]),
            isExiting && animationTimingFunctionExiting === 'ease-in-40-out' && (0, $970q7.default)([
                "_1pgl5y64"
            ]),
            isExiting && animationTimingFunctionExiting === 'ease-in-60-out' && (0, $970q7.default)([
                "_1pgl1ddy"
            ]),
            isExiting && animationTimingFunctionExiting === 'ease-in-80-out' && (0, $970q7.default)([
                "_1pglannl"
            ]),
            isExiting && animationTimingFunctionExiting === 'ease-in-out' && (0, $970q7.default)([
                "_1pgl1fu8"
            ]),
            (!isExiting && enteringAnimation === 'fade-in' || isExiting && exitingAnimation === 'fade-in') && (0, $970q7.default)([
                "_j7hq1cgr"
            ]),
            (!isExiting && enteringAnimation === 'fade-out' || isExiting && exitingAnimation === 'fade-out') && (0, $970q7.default)([
                "_j7hq1lln"
            ]),
            (!isExiting && enteringAnimation === 'zoom-in' || isExiting && exitingAnimation === 'zoom-in') && (0, $970q7.default)([
                "_j7hqe8p0"
            ]),
            (!isExiting && enteringAnimation === 'zoom-out' || isExiting && exitingAnimation === 'zoom-out') && (0, $970q7.default)([
                "_j7hqy6ql"
            ]),
            (!isExiting && enteringAnimation === 'slide-in-from-top' || isExiting && exitingAnimation === 'slide-in-from-top') && (0, $970q7.default)([
                "_j7hqqshu"
            ]),
            (!isExiting && enteringAnimation === 'slide-out-from-top' || isExiting && exitingAnimation === 'slide-out-from-top') && (0, $970q7.default)([
                "_j7hq7ri4"
            ]),
            (!isExiting && enteringAnimation === 'slide-in-from-right' || isExiting && exitingAnimation === 'slide-in-from-right') && (0, $970q7.default)([
                "_j7hqdfjr"
            ]),
            (!isExiting && enteringAnimation === 'slide-out-from-right' || isExiting && exitingAnimation === 'slide-out-from-right') && (0, $970q7.default)([
                "_j7hqonfj"
            ]),
            (!isExiting && enteringAnimation === 'slide-in-from-bottom' || isExiting && exitingAnimation === 'slide-in-from-bottom') && (0, $970q7.default)([
                "_j7hq1liq"
            ]),
            (!isExiting && enteringAnimation === 'slide-out-from-bottom' || isExiting && exitingAnimation === 'slide-out-from-bottom') && (0, $970q7.default)([
                "_j7hqhnf1"
            ]),
            (!isExiting && enteringAnimation === 'slide-in-from-left' || isExiting && exitingAnimation === 'slide-in-from-left') && (0, $970q7.default)([
                "_j7hq1bh1"
            ]),
            (!isExiting && enteringAnimation === 'slide-out-from-left' || isExiting && exitingAnimation === 'slide-out-from-left') && (0, $970q7.default)([
                "_j7hqj08w"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-top' || isExiting && exitingAnimation === 'fade-in-from-top') && (0, $970q7.default)([
                "_j7hq2iua"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-top' || isExiting && exitingAnimation === 'fade-out-from-top') && (0, $970q7.default)([
                "_j7hq39va"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-left' || isExiting && exitingAnimation === 'fade-in-from-left') && (0, $970q7.default)([
                "_j7hq15m2"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-left' || isExiting && exitingAnimation === 'fade-out-from-left') && (0, $970q7.default)([
                "_j7hq1yiv"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-bottom' || isExiting && exitingAnimation === 'fade-in-from-bottom') && (0, $970q7.default)([
                "_j7hq1w00"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-bottom' || isExiting && exitingAnimation === 'fade-out-from-bottom') && (0, $970q7.default)([
                "_j7hqzy3z"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-right' || isExiting && exitingAnimation === 'fade-in-from-right') && (0, $970q7.default)([
                "_j7hqpqak"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-right' || isExiting && exitingAnimation === 'fade-out-from-right') && (0, $970q7.default)([
                "_j7hq1ebg"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-top-constant' || isExiting && exitingAnimation === 'fade-in-from-top-constant') && (0, $970q7.default)([
                "_j7hqm2e2"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-top-constant' || isExiting && exitingAnimation === 'fade-out-from-top-constant') && (0, $970q7.default)([
                "_j7hq97jn"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-left-constant' || isExiting && exitingAnimation === 'fade-in-from-left-constant') && (0, $970q7.default)([
                "_j7hqovgq"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-left-constant' || isExiting && exitingAnimation === 'fade-out-from-left-constant') && (0, $970q7.default)([
                "_j7hq15do"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-bottom-constant' || isExiting && exitingAnimation === 'fade-in-from-bottom-constant') && (0, $970q7.default)([
                "_j7hq797a"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-bottom-constant' || isExiting && exitingAnimation === 'fade-out-from-bottom-constant') && (0, $970q7.default)([
                "_j7hqwo7r"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-right-constant' || isExiting && exitingAnimation === 'fade-in-from-right-constant') && (0, $970q7.default)([
                "_j7hqt8u5"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-right-constant' || isExiting && exitingAnimation === 'fade-out-from-right-constant') && (0, $970q7.default)([
                "_j7hq1pgp"
            ])
        ]) : '',
        style: {
            animationDelay: "".concat(delay, "ms")
        }
    }, state);
};
var $a4ac20e7f0433359$export$2e2bcd8739ae039 = $a4ac20e7f0433359$var$EnteringMotion;

});
parcelRegister("7uyb0", function(module, exports) {
$parcel$export(module.exports, "isReducedMotion", () => $5745d88094d541bd$export$b7baf7667a68d87c);

var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");

var $7QpUe = parcelRequire("7QpUe");
var $5745d88094d541bd$var$isMatchMediaAvailable = function isMatchMediaAvailable() {
    return typeof window !== 'undefined' && 'matchMedia' in window;
};
var $5745d88094d541bd$export$b7baf7667a68d87c = function isReducedMotion() {
    if (!$5745d88094d541bd$var$isMatchMediaAvailable()) return false;
    var _window$matchMedia = window.matchMedia('(prefers-reduced-motion: reduce)'), matches = _window$matchMedia.matches;
    return matches;
};
var $5745d88094d541bd$export$c537e63161742ce3 = function useIsReducedMotion() {
    var _useState = (0, $5FkrB.useState)($5745d88094d541bd$export$b7baf7667a68d87c), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), prefersReducedMotion = _useState2[0], setPrefersReducedMotion = _useState2[1];
    (0, $5FkrB.useEffect)(function() {
        if (!$5745d88094d541bd$var$isMatchMediaAvailable()) return;
        var mediaQueryList = window.matchMedia('(prefers-reduced-motion: reduce)');
        var onChange = function onChange(event) {
            return setPrefersReducedMotion(event.matches);
        };
        return (0, $7QpUe.bind)(mediaQueryList, {
            type: 'change',
            listener: onChange
        });
    }, []);
    return prefersReducedMotion;
};
var $5745d88094d541bd$export$f0f789643ba5a83c = {
    '@media (prefers-reduced-motion: reduce)': {
        animation: 'none',
        transition: 'none'
    }
};
var $5745d88094d541bd$export$ff7706047246b98b = function prefersReducedMotion() {
    return $5745d88094d541bd$export$f0f789643ba5a83c;
};

});

parcelRegister("fF5v2", function(module, exports) {
$parcel$export(module.exports, "durations", () => $02f145fdbc85e8b6$export$38b928a7167ce124);
$parcel$export(module.exports, "exitingDurations", () => $02f145fdbc85e8b6$export$30fa1a2e62ae150c);
/**
 * Think of this as the motion equivalent of the @atlaskit/theme `grid()`.
 */ var $02f145fdbc85e8b6$export$368bacef0dacbe05 = 25;
var $02f145fdbc85e8b6$export$38b928a7167ce124 = {
    none: 0,
    small: 100,
    medium: 350,
    large: 700
};
/**
 * Used to multiply the initial duration for exiting motions.
 */ var $02f145fdbc85e8b6$var$EXITING_MOTION_MULTIPLIER = 0.5;
var $02f145fdbc85e8b6$export$30fa1a2e62ae150c = {
    none: $02f145fdbc85e8b6$export$38b928a7167ce124.none,
    small: $02f145fdbc85e8b6$export$38b928a7167ce124.small * $02f145fdbc85e8b6$var$EXITING_MOTION_MULTIPLIER,
    medium: $02f145fdbc85e8b6$export$38b928a7167ce124.medium * $02f145fdbc85e8b6$var$EXITING_MOTION_MULTIPLIER,
    large: $02f145fdbc85e8b6$export$38b928a7167ce124.large * $02f145fdbc85e8b6$var$EXITING_MOTION_MULTIPLIER
};

});

parcelRegister("euZA7", function(module, exports) {
$parcel$export(module.exports, "useSetTimeout", () => $a8e3a2d318bbb5aa$export$4f34107a2b00f39c);

var $5FkrB = parcelRequire("5FkrB");
// Handle both browser and Node.js environments
var $a8e3a2d318bbb5aa$var$getHookDeps = function getHookDeps(opts) {
    switch(opts.cleanup){
        case 'next-effect':
            return undefined;
        case 'unmount':
        default:
            return [];
    }
};
var $a8e3a2d318bbb5aa$export$1775f27e7c8051ca = function useRequestAnimationFrame() {
    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        cleanup: 'unmount'
    };
    var frames = (0, $5FkrB.useRef)([]);
    (0, $5FkrB.useEffect)(function() {
        return function() {
            if (frames.current.length) {
                frames.current.forEach(function(id) {
                    return cancelAnimationFrame(id);
                });
                frames.current = [];
            }
        };
    // We dynamically set this so we either clean up on the next effect - or on unmount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, $a8e3a2d318bbb5aa$var$getHookDeps(opts));
    return (0, $5FkrB.useCallback)(function(handler) {
        var id = requestAnimationFrame(function(time) {
            frames.current = frames.current.filter(function(frameId) {
                return frameId !== id;
            });
            handler(time);
        });
        frames.current.push(id);
    }, []);
};
var $a8e3a2d318bbb5aa$export$4f34107a2b00f39c = function useSetTimeout() {
    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        cleanup: 'unmount'
    };
    var timeouts = (0, $5FkrB.useRef)([]);
    (0, $5FkrB.useEffect)(function() {
        return function() {
            if (timeouts.current.length) {
                timeouts.current.forEach(function(id) {
                    return clearTimeout(id);
                });
                timeouts.current = [];
            }
        };
    // We dynamically set this so we either clean up on the next effect - or on unmount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, $a8e3a2d318bbb5aa$var$getHookDeps(opts));
    return (0, $5FkrB.useCallback)(function(handler, timeout) {
        for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)args[_key - 2] = arguments[_key];
        var id = setTimeout.apply(void 0, [
            function() {
                timeouts.current = timeouts.current.filter(function(timeoutId) {
                    return timeoutId !== id;
                });
                handler();
            },
            timeout
        ].concat(args));
        timeouts.current.push(id);
    }, []);
};

});

parcelRegister("ZdqJG", function(module, exports) {
$parcel$export(module.exports, "useExitingPersistence", () => $0b801d951e70b6a9$export$3b6f38abbdcbd000);
$parcel$export(module.exports, "default", () => $0b801d951e70b6a9$export$2e2bcd8739ae039);

var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");
/**
 * Internally we will be playing with an element that will always have a key defined.
 */ /**
 * Internal data passed to child motions.
 */ // We define empty context here so the object doesn't change.
var $0b801d951e70b6a9$var$emptyContext = {
    // Motions will always appear if not inside a exiting persistence component.
    appear: true,
    isExiting: false
};
/**
 * __Exiting context__
 *
 * An exiting context.
 */ var $0b801d951e70b6a9$var$ExitingContext = /*#__PURE__*/ (0, $5FkrB.createContext)($0b801d951e70b6a9$var$emptyContext);
/**
 * This method will wrap any React element with a context provider. We're using context (instead of
 * cloneElement) so we can communicate between multiple elements without the need of prop drilling
 * (results in a better API for consumers).
 */ var $0b801d951e70b6a9$var$wrapChildWithContextProvider = function wrapChildWithContextProvider(child) {
    var value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $0b801d951e70b6a9$var$emptyContext;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement($0b801d951e70b6a9$var$ExitingContext.Provider, {
        key: "".concat(child.key, "-provider"),
        value: value
    }, child);
};
/**
 * This function will convert all children types to an array while also filtering out non-valid React elements.
 */ var $0b801d951e70b6a9$var$childrenToArray = function childrenToArray(children) {
    var childrenAsArray = [];
    // We convert children to an array using this helper method as it will add keys to children that do not
    // have them, such as when we have hardcoded children that are conditionally rendered.
    (0, $5FkrB.Children).toArray(children).forEach(function(child) {
        // We ignore any boolean children to make our code a little more simple later on,
        // and also filter out any falsies (empty strings, nulls, and undefined).
        if (typeof child !== 'boolean' && Boolean(child)) // Children WILL have a key after being forced into an array using the React.Children helper.
        childrenAsArray.push(child);
    });
    return childrenAsArray;
};
var $0b801d951e70b6a9$var$spliceNewElementsIntoPrevious = function spliceNewElementsIntoPrevious(current, previous) {
    var splicedChildren = previous.concat([]);
    var previousMap = $0b801d951e70b6a9$var$childrenToObj(previous);
    for(var i = 0; i < current.length; i++){
        var child = current[i];
        var childIsNew = !previousMap[child.key];
        if (childIsNew) // This will insert the new element after the previous element.
        splicedChildren.splice(i + 1, 0, child);
    }
    return splicedChildren;
};
var $0b801d951e70b6a9$var$childrenToObj = function childrenToObj(children) {
    return children.reduce(function(acc, child) {
        acc[child.key] = child;
        return acc;
    }, {});
};
var $0b801d951e70b6a9$var$getMissingKeys = function getMissingKeys(current, previous) {
    var currentMapKeys = new Set(current.map(function(child) {
        return child.key;
    }));
    var missing = new Set();
    for(var i = 0; i < previous.length; i++){
        var element = previous[i];
        var _key = element.key;
        if (!currentMapKeys.has(_key)) missing.add(_key);
    }
    return missing;
};
/**
 * How does this component work?
 *
 * It looks at changes in its children to see what is removed.
 *
 * If a child is removed it clones it and wraps it with context providing an `onFinish` callback.
 *
 * The cloned child will call the `onFinish` when it finishes its exit animation,
 * which lets `ExitingPersistence` know to stop rendering it.
 */ /**
 * __ExitingPersistence__
 *
 * Useful for enabling elements to persist and animate away when they are removed from the DOM.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/motion/docs/entering-motions)
 */ var $0b801d951e70b6a9$var$ExitingPersistence = /*#__PURE__*/ (0, $5FkrB.memo)(function(_ref) {
    var _ref$appear = _ref.appear, appear = _ref$appear === void 0 ? false : _ref$appear, children = _ref.children, exitThenEnter = _ref.exitThenEnter;
    var _useState = (0, $5FkrB.useState)([
        null,
        children
    ]), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), stateChildren = _useState2[0], setChildren = _useState2[1];
    var _useState3 = (0, $5FkrB.useState)([]), _useState4 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState3, 2), exitingChildren = _useState4[0], setExitingChildren = _useState4[1];
    var _useState5 = (0, $5FkrB.useState)(function() {
        return {
            appear: appear,
            isExiting: false
        };
    }), _useState6 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState5, 2), defaultContext = _useState6[0], setDefaultContext = _useState6[1];
    (0, $5FkrB.useEffect)(function() {
        if (!defaultContext.appear) setDefaultContext({
            appear: true,
            isExiting: false
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    /**
   * NOTE: This is a workaround for the test case written in Jira where the stateChildren is a boolean value because
   * useState is mocked to return a boolean value.
   */ if (typeof stateChildren === 'boolean') return children;
    var _stateChildren = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(stateChildren, 2), previousChildren = _stateChildren[0], currentChildren = _stateChildren[1];
    var previous = $0b801d951e70b6a9$var$childrenToArray(previousChildren);
    var current = $0b801d951e70b6a9$var$childrenToArray(currentChildren);
    if (currentChildren !== children) setChildren([
        currentChildren,
        children
    ]);
    var missingKeys = $0b801d951e70b6a9$var$getMissingKeys(current, previous);
    var isSomeChildRemoved = !!missingKeys.size;
    var visibleChildren = current;
    if (isSomeChildRemoved) visibleChildren = $0b801d951e70b6a9$var$spliceNewElementsIntoPrevious(current, previous);
    if (exitThenEnter) {
        if (exitingChildren.length) visibleChildren = exitingChildren;
        else {
            var nextExitingChildren = visibleChildren.filter(function(child) {
                return missingKeys.has(child.key);
            });
            if (nextExitingChildren.length) setExitingChildren(nextExitingChildren);
        }
    }
    if (missingKeys.size) visibleChildren = visibleChildren.map(function(child) {
        var isExiting = missingKeys.has(child.key);
        return $0b801d951e70b6a9$var$wrapChildWithContextProvider(child, {
            appear: true,
            isExiting: isExiting,
            onFinish: isExiting ? function() {
                missingKeys.delete(child.key);
                if (missingKeys.size === 0) {
                    setChildren([
                        null,
                        children
                    ]);
                    setExitingChildren([]);
                }
            } : undefined
        });
    });
    else visibleChildren = visibleChildren.map(function(child) {
        return $0b801d951e70b6a9$var$wrapChildWithContextProvider(child, defaultContext);
    });
    return visibleChildren;
});
var $0b801d951e70b6a9$export$3b6f38abbdcbd000 = function useExitingPersistence() {
    return (0, $5FkrB.useContext)($0b801d951e70b6a9$var$ExitingContext);
};
$0b801d951e70b6a9$var$ExitingPersistence.displayName = 'ExitingPersistence';
var $0b801d951e70b6a9$export$2e2bcd8739ae039 = $0b801d951e70b6a9$var$ExitingPersistence;

});

parcelRegister("8xij1", function(module, exports) {
$parcel$export(module.exports, "useStaggeredEntrance", () => $636f9af14908446f$export$25c7213fc07ec080);

var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");

var $eVb4V = parcelRequire("eVb4V");

var $dnMEm = parcelRequire("dnMEm");

var $2Yzny = parcelRequire("2Yzny");
var $636f9af14908446f$var$StaggeredEntranceContext = /*#__PURE__*/ (0, $5FkrB.createContext)(function() {
    return {
        isReady: true,
        delay: 0,
        ref: (0, $eVb4V.default)
    };
});
var $636f9af14908446f$export$25c7213fc07ec080 = function useStaggeredEntrance() {
    var indentifier = (0, $2Yzny.useUniqueId)();
    var context = (0, $5FkrB.useContext)($636f9af14908446f$var$StaggeredEntranceContext);
    return context(indentifier);
};
/**
 * For a list of elements that need to animate in,
 * this should be used in conjunction with entering components.
 * This does not need Javascript to execute so it will run immediately for any SSR rendered React apps before the JS has executed.
 *
 * Will dynamically add delay to each child entering component.
 * Unfortunately all entering components _NEED_ to be a direct descendant.
 */ var $636f9af14908446f$var$StaggeredEntrance = function StaggeredEntrance(_ref) {
    var children = _ref.children, column = _ref.column, _ref$columns = _ref.columns, columns = _ref$columns === void 0 ? 'responsive' : _ref$columns, _ref$delayStep = _ref.delayStep, delayStep = _ref$delayStep === void 0 ? 50 : _ref$delayStep;
    var elementRefs = (0, $5FkrB.useRef)([]);
    var indexes = [];
    var _useState = (0, $5FkrB.useState)(function() {
        if (typeof columns === 'number') // A hardcoded columns is set so bail out and set it to that!
        return columns;
        if (typeof column === 'number') // A hardcoded column is set so we will set actualColumns to be 1.
        return 1;
        // We are in "responsive" mode.
        // So we will be calculating when the Javascript executes on the client how many columns there will be.
        return 0;
    }), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), actualColumns = _useState2[0], setActualColumns = _useState2[1];
    (0, $dnMEm.useLayoutEffect)(function() {
        // We want to only run this code when we are in "responsive" mode.
        // It is assumed we are in responsive mode if `columns` is "responsive",
        // we have children element refs ready to be read (i.e. if there are no children this won't run as well)
        // and finally that `actualColumns` is `0` - this is because for the first render cycle `actualColumns` will be `0` (set above)
        // and then after this layout effect runs the value for `actualColumns` will then be calculated and set.
        if (columns === 'responsive' && elementRefs.current.length && actualColumns === 0) {
            var currentTop = 0;
            var numberColumns = 0;
            if (elementRefs.current.length <= 1) {
                setActualColumns(1);
                return;
            }
            // We set the current top to the first elements.
            // We will be comparing this and incrementing the column count
            // until we hit an element that has a different offset top (or we run out of elements).
            currentTop = elementRefs.current[0] ? elementRefs.current[0].offsetTop : 0;
            for(var i = 0; i < elementRefs.current.length; i++){
                var child = elementRefs.current[i];
                if (!child) break;
                if (currentTop === child.offsetTop) {
                    numberColumns += 1;
                    if (elementRefs.current.length - 1 === i) setActualColumns(numberColumns);
                    continue;
                }
                setActualColumns(numberColumns);
                break;
            }
        }
    // We only want this effect to run once - on initial mount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement($636f9af14908446f$var$StaggeredEntranceContext.Provider, {
        value: function value(id) {
            if (!indexes.includes(id)) indexes.push(id);
            var isReady = actualColumns > 0;
            var index = indexes.indexOf(id);
            var currentColumn = column || index % actualColumns;
            var currentRow = Math.floor(index / actualColumns);
            var distanceFromTopLeftElement = currentRow + currentColumn;
            // We don't want loads of elements to have the same staggered delay as it ends up looking slow for users.
            // To get around that we calculate the logarithm using `distanceFromTopLeftElement` which ends making
            // elements appear faster the further away from the top left element.
            var delay = Math.ceil(Math.log(distanceFromTopLeftElement + 1) * delayStep * 1.5) || 0;
            return {
                delay: delay,
                isReady: isReady,
                ref: function ref(element) {
                    return elementRefs.current[index] = element;
                }
            };
        }
    }, children);
};
var $636f9af14908446f$export$2e2bcd8739ae039 = $636f9af14908446f$var$StaggeredEntrance;

});
parcelRegister("dnMEm", function(module, exports) {
$parcel$export(module.exports, "useLayoutEffect", () => $9be32935cadfca3c$export$e5c5a5f917a5871c);

var $5FkrB = parcelRequire("5FkrB");
var $9be32935cadfca3c$export$e5c5a5f917a5871c = typeof window === 'undefined' ? (0, $5FkrB.useEffect) : (0, $5FkrB.useLayoutEffect);

});

parcelRegister("2Yzny", function(module, exports) {
$parcel$export(module.exports, "useUniqueId", () => $22aca0dd9ceab63d$export$c485849f2e393253);
/* eslint-disable @repo/internal/react/disallow-unstable-values */ 
var $5FkrB = parcelRequire("5FkrB");
function $22aca0dd9ceab63d$export$c485849f2e393253() {
    var identifier = (0, $5FkrB.useRef)('');
    if (!identifier.current) identifier.current = '_' + (Number(String(Math.random()).slice(2)) + Date.now() + Math.round(performance.now())).toString(36);
    return identifier.current;
}

});




parcelRegister("6bqMl", function(module, exports) {
$parcel$export(module.exports, "default", () => $48088ada20eaf5c1$export$2e2bcd8739ae039);

var $5FkrB = parcelRequire("5FkrB");

var $id6Cu = parcelRequire("id6Cu");

var $hwn2J = parcelRequire("hwn2J");

var $f6E9k = parcelRequire("f6E9k");

var $3dF2S = parcelRequire("3dF2S");

var $2PsRr = parcelRequire("2PsRr");
function $48088ada20eaf5c1$export$2e2bcd8739ae039(_ref) {
    var _ref$zIndex = _ref.zIndex, zIndex = _ref$zIndex === void 0 ? 0 : _ref$zIndex, children = _ref.children, _ref$mountStrategy = _ref.mountStrategy, mountStrategy = _ref$mountStrategy === void 0 ? 'effect' : _ref$mountStrategy;
    var isSubsequentRender = (0, $3dF2S.default)(mountStrategy);
    (0, $2PsRr.default)(zIndex);
    return !(0, $id6Cu.fg)('platform_design_system_team_portal_logic_r18_fix') ? isSubsequentRender ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $hwn2J.default), {
        zIndex: zIndex
    }, children) : null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $f6E9k.default), {
        zIndex: zIndex
    }, children);
}

});
parcelRegister("hwn2J", function(module, exports) {
$parcel$export(module.exports, "default", () => $cc174cac925bf305$export$2e2bcd8739ae039);

var $5FkrB = parcelRequire("5FkrB");

var $aLeHs = parcelRequire("aLeHs");

var $eOz1e = parcelRequire("eOz1e");
function $cc174cac925bf305$export$2e2bcd8739ae039(props) {
    var zIndex = props.zIndex, children = props.children;
    var container = (0, $5FkrB.useMemo)(function() {
        return (0, $eOz1e.createContainer)(zIndex);
    }, [
        zIndex
    ]);
    // This is in the render method instead of useEffect so that
    // the portal will be added to the DOM before the children render.
    // For any further changes, ensure that the container does not have a
    // parent besides the portal parent.
    (0, $eOz1e.appendPortalContainerIfNotAppended)(container);
    (0, $5FkrB.useEffect)(function() {
        return function() {
            (0, $eOz1e.removePortalContainer)(container);
        };
    }, [
        container
    ]);
    return /*#__PURE__*/ (0, $aLeHs.createPortal)(children, container);
}

});
parcelRegister("eOz1e", function(module, exports) {
$parcel$export(module.exports, "createContainer", () => $ac90e6339746de43$export$26ae5ca175b4ec5a);
$parcel$export(module.exports, "removePortalContainer", () => $ac90e6339746de43$export$da99f98bf3fe55b3);
$parcel$export(module.exports, "appendPortalContainerIfNotAppended", () => $ac90e6339746de43$export$c582005add11e141);
$parcel$export(module.exports, "createAtlaskitPortal", () => $ac90e6339746de43$export$fef014d7cef9e543);
$parcel$export(module.exports, "createPortalParent", () => $ac90e6339746de43$export$95029ca7aca2989e);

var $1fcwm = parcelRequire("1fcwm");
var $ac90e6339746de43$export$26ae5ca175b4ec5a = function createContainer(zIndex) {
    var container = document.createElement('div');
    container.className = (0, $1fcwm.portalClassName);
    container.style.zIndex = "".concat(zIndex);
    return container;
};
/**
 * Returns document body element
 * @return {number} - The document body element
 */ var $ac90e6339746de43$var$getBody = function getBody() {
    return document.body;
};
/**
 * Returns portal parent container. If no container exists already then it creates a new container with class name 'atlaskit-portal-container'
 * @return {Element} - The portal parent container div element
 */ var $ac90e6339746de43$var$getPortalParent = function getPortalParent() {
    var parentElement = document.querySelector((0, $1fcwm.portalParentSelector));
    if (!parentElement) {
        var _getBody;
        var parent = document.createElement('div');
        parent.className = (0, $1fcwm.portalParentClassName);
        // we are setting display to flex because we want each portal to create a new stacking context
        // See https://developer.mozilla.org/en-US/docs/Web/CSS/CSS_Positioning/Understanding_z_index/The_stacking_context
        parent.style.display = 'flex';
        (_getBody = $ac90e6339746de43$var$getBody()) === null || _getBody === void 0 || _getBody.appendChild(parent);
        return parent;
    }
    return parentElement;
};
var $ac90e6339746de43$export$da99f98bf3fe55b3 = function removePortalContainer(container) {
    $ac90e6339746de43$var$getPortalParent().removeChild(container);
};
var $ac90e6339746de43$export$c582005add11e141 = function appendPortalContainerIfNotAppended(container) {
    if (!container.parentElement) $ac90e6339746de43$var$getPortalParent().appendChild(container);
};
var $ac90e6339746de43$var$isDocumentDefined = function isDocumentDefined() {
    return document !== undefined;
};
var $ac90e6339746de43$export$fef014d7cef9e543 = function createAtlaskitPortal(zIndex) {
    //atlaskit-portal div
    if ($ac90e6339746de43$var$isDocumentDefined()) {
        var atlaskitportal = document.createElement('div');
        atlaskitportal.className = (0, $1fcwm.portalClassName);
        atlaskitportal.style.zIndex = "".concat(zIndex);
        return atlaskitportal;
    }
    return;
};
var $ac90e6339746de43$export$95029ca7aca2989e = function createPortalParent() {
    //atlaskit-portal-container div
    if ($ac90e6339746de43$var$isDocumentDefined()) {
        var parentElement = document.querySelector((0, $1fcwm.portalParentSelector));
        if (!parentElement) {
            var _getBody2;
            var parent = document.createElement('div');
            parent.className = (0, $1fcwm.portalParentClassName);
            parent.style.display = 'flex';
            (_getBody2 = $ac90e6339746de43$var$getBody()) === null || _getBody2 === void 0 || _getBody2.appendChild(parent);
            return parent;
        }
        return parentElement;
    }
    return;
};

});
parcelRegister("1fcwm", function(module, exports) {
$parcel$export(module.exports, "portalParentClassName", () => $0e80e78bca266346$export$e4c79eb95c23a0da);
$parcel$export(module.exports, "portalParentSelector", () => $0e80e78bca266346$export$72f415121273627e);
$parcel$export(module.exports, "portalClassName", () => $0e80e78bca266346$export$13f57c02915787b3);
var $0e80e78bca266346$export$e4c79eb95c23a0da = 'atlaskit-portal-container';
var $0e80e78bca266346$export$72f415121273627e = 'body > .atlaskit-portal-container';
var $0e80e78bca266346$export$13f57c02915787b3 = 'atlaskit-portal';

});



parcelRegister("f6E9k", function(module, exports) {
$parcel$export(module.exports, "default", () => $aff68f6a72c56fe1$export$2e2bcd8739ae039);

var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");

var $aLeHs = parcelRequire("aLeHs");

var $afobQ = parcelRequire("afobQ");

var $eOz1e = parcelRequire("eOz1e");
function $aff68f6a72c56fe1$export$2e2bcd8739ae039(props) {
    var zIndex = props.zIndex, children = props.children;
    var _useState = (0, $5FkrB.useState)(null), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), atlaskitPortal = _useState2[0], setAtlaskitPortal = _useState2[1];
    (0, $afobQ.useIsomorphicLayoutEffect)(function() {
        var tempPortalContainer = (0, $eOz1e.createAtlaskitPortal)(zIndex);
        setAtlaskitPortal(tempPortalContainer);
        var portalParent = (0, $eOz1e.createPortalParent)();
        if (!tempPortalContainer || !portalParent) return;
        portalParent.appendChild(tempPortalContainer);
        return function() {
            if (tempPortalContainer) portalParent.removeChild(tempPortalContainer);
            setAtlaskitPortal(null);
        };
    }, [
        zIndex
    ]);
    /**
   * We wrap portal children with a Suspense boundary because in React 18 concurrent,
   * if you suspend from _within_ a portal to a Suspense boundary _outside_ the portal,
   * our portal gets in an infinite loop of rendering.
   */ var suspendedChildren = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $5FkrB.Suspense), {
        fallback: null
    }, children);
    return atlaskitPortal ? /*#__PURE__*/ (0, $aLeHs.createPortal)(suspendedChildren, atlaskitPortal) : null;
}

});
parcelRegister("afobQ", function(module, exports) {
$parcel$export(module.exports, "useIsomorphicLayoutEffect", () => $775e11c111bb481a$export$700979bc83e7db82);

var $5FkrB = parcelRequire("5FkrB");
var $775e11c111bb481a$export$700979bc83e7db82 = typeof window !== 'undefined' ? (0, $5FkrB.useLayoutEffect) : (0, $5FkrB.useEffect);

});


parcelRegister("3dF2S", function(module, exports) {
$parcel$export(module.exports, "default", () => $25826cbe9373f77e$export$2e2bcd8739ae039);

var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");

var $afobQ = parcelRequire("afobQ");
var $25826cbe9373f77e$var$useIsSubsequentRender = function useIsSubsequentRender(mountStrategy) {
    var _useState = (0, $5FkrB.useState)(false), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), isSubsequentRender = _useState2[0], setIsSubsequentRender = _useState2[1];
    var _useState3 = (0, $5FkrB.useState)(function() {
        return mountStrategy === 'layoutEffect' ? (0, $afobQ.useIsomorphicLayoutEffect) : (0, $5FkrB.useEffect);
    }), _useState4 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState3, 1), useMountEffect = _useState4[0];
    useMountEffect(function() {
        setIsSubsequentRender(true);
    }, []);
    return isSubsequentRender;
};
var $25826cbe9373f77e$export$2e2bcd8739ae039 = $25826cbe9373f77e$var$useIsSubsequentRender;

});

parcelRegister("2PsRr", function(module, exports) {
$parcel$export(module.exports, "default", () => $20f6bb5d1e5698a9$export$2e2bcd8739ae039);

var $5FkrB = parcelRequire("5FkrB");

var $cAcoQ = parcelRequire("cAcoQ");

var $hpyO2 = parcelRequire("hpyO2");
var $20f6bb5d1e5698a9$var$useFirePortalEvent = function useFirePortalEvent(zIndex) {
    var zIndexNumber = Number(zIndex);
    (0, $5FkrB.useEffect)(function() {
        (0, $hpyO2.default)((0, $cAcoQ.PORTAL_MOUNT_EVENT), zIndexNumber);
        return function() {
            (0, $hpyO2.default)((0, $cAcoQ.PORTAL_UNMOUNT_EVENT), zIndexNumber);
        };
    }, [
        zIndexNumber
    ]);
};
var $20f6bb5d1e5698a9$export$2e2bcd8739ae039 = $20f6bb5d1e5698a9$var$useFirePortalEvent;

});
parcelRegister("cAcoQ", function(module, exports) {
$parcel$export(module.exports, "PORTAL_MOUNT_EVENT", () => $92927723834e2e13$export$ed5835cc67e87f72);
$parcel$export(module.exports, "PORTAL_UNMOUNT_EVENT", () => $92927723834e2e13$export$80816bd900e5bd00);
var $92927723834e2e13$export$ed5835cc67e87f72 = 'akPortalMount';
var $92927723834e2e13$export$80816bd900e5bd00 = 'akPortalUnmount';

});

parcelRegister("hpyO2", function(module, exports) {
$parcel$export(module.exports, "default", () => $cacfc534fbeae109$export$2e2bcd8739ae039);
var $cacfc534fbeae109$var$zIndexToName = {
    100: 'card',
    200: 'navigation',
    300: 'dialog',
    400: 'layer',
    500: 'blanket',
    510: 'modal',
    600: 'flag',
    700: 'spotlight',
    9999: 'tooltip'
};
/**
 * return layer name in Atlassian design system corresponding to given z-index
 * @param {number} zIndex - z-index value for which layer name is needed
 * @returns {LayerName | null} - The layer name for given z-index. If layer name is not found then null is returned
 */ var $cacfc534fbeae109$var$getLayerName = function getLayerName(zIndex) {
    return $cacfc534fbeae109$var$zIndexToName.hasOwnProperty(zIndex) ? $cacfc534fbeae109$var$zIndexToName[zIndex] : null;
};
/**
 * Creates a PortalEvent object with given eventName, given zIndex and corresponding layer
 * @param {string} eventName - either of Mount or Unmount event name
 * @param {number} zIndex - z-index value which will be included in the event to be dispatched
 * @returns {PortalEvent} - The newly created PortalEvent object
 */ var $cacfc534fbeae109$var$getEvent = function getEvent(eventName, zIndex) {
    var detail = {
        layer: $cacfc534fbeae109$var$getLayerName(Number(zIndex)),
        zIndex: zIndex
    };
    return new CustomEvent(eventName, {
        detail: detail
    });
};
function $cacfc534fbeae109$export$2e2bcd8739ae039(eventName, zIndex) {
    var event = $cacfc534fbeae109$var$getEvent(eventName, zIndex);
    window.dispatchEvent(event);
}

});



parcelRegister("H74DA", function(module, exports) {
$parcel$export(module.exports, "layers", () => $081980f9c15950d3$export$7be255094ccdc533);

var $lOXpB = parcelRequire("lOXpB");

var $dSRcG = parcelRequire("dSRcG");
var $081980f9c15950d3$export$44ffba16bd48dac6 = '__ATLASKIT_THEME__';
var $081980f9c15950d3$export$c93026a968943f95 = 'light';
var $081980f9c15950d3$export$6ba72c8346b4c57e = [
    'light',
    'dark'
];
var $081980f9c15950d3$export$7a57f79000377ca2 = function borderRadius() {
    return 3;
};
var $081980f9c15950d3$export$6d8204c2cb2e06b8 = function gridSize() {
    return 8;
};
var $081980f9c15950d3$export$8e24544ddba725ee = function focusRing() {
    var color = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "var(--ds-border-focused, ".concat((0, $dSRcG.B200), ")");
    var outlineWidth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $081980f9c15950d3$export$6d8204c2cb2e06b8() / 4;
    (0, $lOXpB.default)('@atlaskit/theme', 'focus ring mixin', 'Please use `@atlaskit/focus-ring` instead.');
    return "\n  &:focus {\n    outline: none;\n    box-shadow: 0px 0px 0px ".concat(outlineWidth, "px ").concat(color, ";\n  }\n");
};
var $081980f9c15950d3$export$c0dd343266bc3261 = function noFocusRing() {
    return "\n  box-shadow: none;\n";
};
var $081980f9c15950d3$export$7be255094ccdc533 = {
    card: function card() {
        return 100;
    },
    navigation: function navigation() {
        return 200;
    },
    dialog: function dialog() {
        return 300;
    },
    layer: function layer() {
        return 400;
    },
    blanket: function blanket() {
        return 500;
    },
    modal: function modal() {
        return 510;
    },
    flag: function flag() {
        return 600;
    },
    spotlight: function spotlight() {
        return 700;
    },
    tooltip: function tooltip() {
        return 9999;
    }
};
var $081980f9c15950d3$export$a1b3edb637fb4f35 = function visuallyHidden() {
    (0, $lOXpB.default)('@atlaskit/theme', 'visually hidden mixin', 'Please use `@atlaskit/visually-hidden` instead.');
    return {
        border: '0 !important',
        clip: 'rect(1px, 1px, 1px, 1px) !important',
        height: '1px !important',
        overflow: 'hidden !important',
        padding: '0 !important',
        position: 'absolute !important',
        width: '1px !important',
        whiteSpace: 'nowrap !important'
    };
};
var $081980f9c15950d3$export$ba1d834b86d72a09 = $081980f9c15950d3$export$a1b3edb637fb4f35;
var $081980f9c15950d3$export$e497e856b4f89fcd = function skeletonShimmer() {
    return {
        css: {
            backgroundColor: "var(--ds-skeleton, ".concat((0, $dSRcG.N20A), ")"),
            animationDuration: '1.5s',
            animationIterationCount: 'infinite',
            animationTimingFunction: 'linear',
            animationDirection: 'alternate'
        },
        keyframes: {
            from: {
                backgroundColor: "var(--ds-skeleton, ".concat((0, $dSRcG.N20A), ")")
            },
            to: {
                backgroundColor: "var(--ds-skeleton-subtle, ".concat((0, $dSRcG.N30A), ")")
            }
        }
    };
};

});
parcelRegister("lOXpB", function(module, exports) {
$parcel$export(module.exports, "default", () => $fe2c5a79f16ba3bd$export$2e2bcd8739ae039);

var $4jKk3 = parcelRequire("4jKk3");

var $3ZMUU = parcelRequire("3ZMUU");
function $fe2c5a79f16ba3bd$export$2e2bcd8739ae039(packageName, api, additionalMessage) {
    (0, $4jKk3.default)("[".concat(packageName, "]: The ").concat(api, " is deprecated.").concat(additionalMessage && " ".concat(additionalMessage)));
}
function $fe2c5a79f16ba3bd$export$eb1decd851a5ae56(packageName, propName, predicate, deprecationAnnouncementOnDAC) {
    typeof $3ZMUU;
}

});
parcelRegister("4jKk3", function(module, exports) {
$parcel$export(module.exports, "default", () => $324cde792ef3e561$export$2e2bcd8739ae039);
/* eslint-disable no-console */ var $324cde792ef3e561$var$printed = {};
function $324cde792ef3e561$export$2e2bcd8739ae039(message) {
    if ($324cde792ef3e561$var$printed[message]) return;
    $324cde792ef3e561$var$printed[message] = true;
    if (typeof window !== 'undefined') console.warn(message);
}

});


parcelRegister("dSRcG", function(module, exports) {
$parcel$export(module.exports, "R400", () => $a1b9969db91895a9$export$2010d0fb4295b346);
$parcel$export(module.exports, "B200", () => $a1b9969db91895a9$export$215b7063051591f1);
$parcel$export(module.exports, "N0", () => $a1b9969db91895a9$export$29a4f05edc054374);
$parcel$export(module.exports, "N30", () => $a1b9969db91895a9$export$3e51e8f1440314ba);
$parcel$export(module.exports, "N500", () => $a1b9969db91895a9$export$c39c0fe0f26207ae);
$parcel$export(module.exports, "N800", () => $a1b9969db91895a9$export$7d61b15e0da132af);
$parcel$export(module.exports, "N900", () => $a1b9969db91895a9$export$fbda843f0a27fe96);
$parcel$export(module.exports, "N20A", () => $a1b9969db91895a9$export$8d43898f60b96a82);
$parcel$export(module.exports, "N30A", () => $a1b9969db91895a9$export$920c0d5c49070351);
$parcel$export(module.exports, "N60A", () => $a1b9969db91895a9$export$d2d3bedfb276cac0);
// Reds
var $a1b9969db91895a9$export$4b84fd0e2c617bd = '#FFEBE6';
var $a1b9969db91895a9$export$b34b069eff244586 = '#FFBDAD';
var $a1b9969db91895a9$export$be802dd0d8b57f35 = '#FF8F73';
var $a1b9969db91895a9$export$60847d42f9da92a6 = '#FF7452';
var $a1b9969db91895a9$export$4a7404f376229999 = '#FF5630';
var $a1b9969db91895a9$export$2010d0fb4295b346 = '#DE350B';
var $a1b9969db91895a9$export$2837b5a1a71d5c02 = '#BF2600';
var $a1b9969db91895a9$export$8d9596b529bbb9cf = '#FFFAE6';
var $a1b9969db91895a9$export$41060a744ab0b7ae = '#FFF0B3';
var $a1b9969db91895a9$export$1cc05bbbf340e559 = '#FFE380';
var $a1b9969db91895a9$export$5aae31392d72caaa = '#FFC400';
var $a1b9969db91895a9$export$c6930421db9fa514 = '#FFAB00';
var $a1b9969db91895a9$export$59619663aa6500fb = '#FF991F';
var $a1b9969db91895a9$export$874739ea9e379ab6 = '#FF8B00';
var $a1b9969db91895a9$export$8a6341c32b6a3ee6 = '#E3FCEF';
var $a1b9969db91895a9$export$69a3bf21b9686c2b = '#ABF5D1';
var $a1b9969db91895a9$export$afbce1382ec95f73 = '#79F2C0';
var $a1b9969db91895a9$export$747d86715d4175de = '#57D9A3';
var $a1b9969db91895a9$export$940e1f69e873f202 = '#36B37E';
var $a1b9969db91895a9$export$a49394138f7b8e85 = '#00875A';
var $a1b9969db91895a9$export$6fa04827ac68a4fb = '#006644';
var $a1b9969db91895a9$export$226de0355ed012f8 = '#DEEBFF';
var $a1b9969db91895a9$export$8c13c2ee36917869 = '#B3D4FF';
var $a1b9969db91895a9$export$ecfc1dff386a3e7a = '#4C9AFF';
var $a1b9969db91895a9$export$215b7063051591f1 = '#2684FF';
var $a1b9969db91895a9$export$e62e8919cca44969 = '#0065FF';
var $a1b9969db91895a9$export$b3de0ae08da2ce64 = '#0052CC';
var $a1b9969db91895a9$export$a6ee3d71bc067634 = '#0747A6';
var $a1b9969db91895a9$export$67f15409e87642a1 = '#669DF1';
var $a1b9969db91895a9$export$f0539dbc42dbb067 = '#8FB8F6';
var $a1b9969db91895a9$export$363e4475840015bb = '#EAE6FF';
var $a1b9969db91895a9$export$4b0a4417ed59760f = '#C0B6F2';
var $a1b9969db91895a9$export$6011520a64d9a187 = '#998DD9';
var $a1b9969db91895a9$export$a7175d4e9206bc80 = '#8777D9';
var $a1b9969db91895a9$export$b48405b95304b5a1 = '#6554C0';
var $a1b9969db91895a9$export$c71e4279dd54a18d = '#5243AA';
var $a1b9969db91895a9$export$147899de772240ec = '#403294';
var $a1b9969db91895a9$export$2cf711fe14c66f06 = '#E6FCFF';
var $a1b9969db91895a9$export$7a8f4d33f6f9772c = '#B3F5FF';
var $a1b9969db91895a9$export$776c9c497ef08533 = '#79E2F2';
var $a1b9969db91895a9$export$69cb3ca10c1e330e = '#00C7E6';
var $a1b9969db91895a9$export$9dc1ef0f3f48059b = '#00B8D9';
var $a1b9969db91895a9$export$7c835c78b6fcdef8 = '#00A3BF';
var $a1b9969db91895a9$export$6036577f95c3877e = '#008DA6';
var $a1b9969db91895a9$export$29a4f05edc054374 = '#FFFFFF';
var $a1b9969db91895a9$export$e655ef011c4aa1a2 = '#FAFBFC';
var $a1b9969db91895a9$export$9fdfb749e33cdf97 = '#F4F5F7';
var $a1b9969db91895a9$export$3e51e8f1440314ba = '#EBECF0';
var $a1b9969db91895a9$export$1ce2d1575d444ceb = '#DFE1E6';
var $a1b9969db91895a9$export$8754fc7e6d8b3000 = '#C1C7D0';
var $a1b9969db91895a9$export$c2e91cbeada39b8b = '#B3BAC5';
var $a1b9969db91895a9$export$5f71e19f3a7ad9de = '#A5ADBA';
var $a1b9969db91895a9$export$eaa8c8a70ac22806 = '#97A0AF';
var $a1b9969db91895a9$export$7c87d337fb91a97d = '#8993A4';
var $a1b9969db91895a9$export$d6447c357493214f = '#7A869A';
var $a1b9969db91895a9$export$f563ee71e9ee74cd = '#6B778C';
var $a1b9969db91895a9$export$e2ef2124cf4024b1 = '#5E6C84';
var $a1b9969db91895a9$export$eece5f492e429f08 = '#505F79';
var $a1b9969db91895a9$export$c39c0fe0f26207ae = '#42526E';
var $a1b9969db91895a9$export$7090862dc3038a9f = '#344563';
var $a1b9969db91895a9$export$ad0bacf983b7ddaa = '#253858';
var $a1b9969db91895a9$export$7d61b15e0da132af = '#172B4D';
var $a1b9969db91895a9$export$fbda843f0a27fe96 = '#091E42';
var $a1b9969db91895a9$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
var $a1b9969db91895a9$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
var $a1b9969db91895a9$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
var $a1b9969db91895a9$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
var $a1b9969db91895a9$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
var $a1b9969db91895a9$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
var $a1b9969db91895a9$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
var $a1b9969db91895a9$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
var $a1b9969db91895a9$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
var $a1b9969db91895a9$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
var $a1b9969db91895a9$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
var $a1b9969db91895a9$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
var $a1b9969db91895a9$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
var $a1b9969db91895a9$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
var $a1b9969db91895a9$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
var $a1b9969db91895a9$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
var $a1b9969db91895a9$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
var $a1b9969db91895a9$export$2f6319cf7d736c2a = '#E6EDFA';
var $a1b9969db91895a9$export$95126bc8884d6634 = '#DCE5F5';
var $a1b9969db91895a9$export$8338d8c35d44ff1 = '#CED9EB';
var $a1b9969db91895a9$export$5368d76ae4fbbda7 = '#B8C7E0';
var $a1b9969db91895a9$export$9f0a771d16ec8d36 = '#ABBBD6';
var $a1b9969db91895a9$export$abcf8c38338b4aa5 = '#9FB0CC';
var $a1b9969db91895a9$export$97e81faa16a182c7 = '#8C9CB8';
var $a1b9969db91895a9$export$bfe21c59123ecf33 = '#7988A3';
var $a1b9969db91895a9$export$ee82aa2ea6a1558 = '#67758F';
var $a1b9969db91895a9$export$682927c6ed76be02 = '#56637A';
var $a1b9969db91895a9$export$91fd9994c5be9757 = '#455166';
var $a1b9969db91895a9$export$d281fbfe3cff2df6 = '#3B475C';
var $a1b9969db91895a9$export$3902c91d8b98a753 = '#313D52';
var $a1b9969db91895a9$export$8e8133c1ba5845b5 = '#283447';
var $a1b9969db91895a9$export$33ff357f6620b39 = '#202B3D';
var $a1b9969db91895a9$export$633847cf062b69e0 = '#1B2638';
var $a1b9969db91895a9$export$9776a6e503bdbf76 = '#121A29';
var $a1b9969db91895a9$export$6c813d5160dff5db = '#0E1624';
var $a1b9969db91895a9$export$3d4f271a500072a = '#0D1424';
var $a1b9969db91895a9$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
var $a1b9969db91895a9$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
var $a1b9969db91895a9$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
var $a1b9969db91895a9$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
var $a1b9969db91895a9$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
var $a1b9969db91895a9$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
var $a1b9969db91895a9$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
var $a1b9969db91895a9$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
var $a1b9969db91895a9$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
var $a1b9969db91895a9$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
var $a1b9969db91895a9$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
var $a1b9969db91895a9$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
var $a1b9969db91895a9$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
var $a1b9969db91895a9$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
var $a1b9969db91895a9$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
var $a1b9969db91895a9$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
var $a1b9969db91895a9$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';
var $a1b9969db91895a9$export$d2adc5dedf09fced = '#292A2E';
var $a1b9969db91895a9$export$f51762073d2bb381 = '#94C748';
var $a1b9969db91895a9$export$95e26d54def96891 = '#B3DF72';

});


parcelRegister("6MmJQ", function(module, exports) {
$parcel$export(module.exports, "default", () => $4ef8dd21c0783dce$export$2e2bcd8739ae039);

var $kqp0i = parcelRequire("kqp0i");

var $iYJcE = parcelRequire("iYJcE");

var $ekGgq = parcelRequire("ekGgq");

var $25nEq = parcelRequire("25nEq");

var $5FkrB = parcelRequire("5FkrB");

var $74Zh5 = parcelRequire("74Zh5");

var $hd7HS = parcelRequire("hd7HS");

var $9mRRr = parcelRequire("9mRRr");

var $hbl7m = parcelRequire("hbl7m");

var $eYQvF = parcelRequire("eYQvF");

var $lBq6d = parcelRequire("lBq6d");

var $eQzrx = parcelRequire("eQzrx");
parcelRequire("jkmxD");
var $fGFYU = parcelRequire("fGFYU");

var $5Rrqa = parcelRequire("5Rrqa");

var $dSRcG = parcelRequire("dSRcG");

var $3CioX = parcelRequire("3CioX");

var $bwuZo = parcelRequire("bwuZo");

var $a8XWo = parcelRequire("a8XWo");

var $lDqpZ = parcelRequire("lDqpZ");

var $kLhYg = parcelRequire("kLhYg");

var $8KNdU = parcelRequire("8KNdU");

var $3dEWA = parcelRequire("3dEWA");

var $lGXDD = parcelRequire("lGXDD");
var $4ef8dd21c0783dce$var$dialogStyles = (0, $74Zh5.css)((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({
    display: 'flex',
    width: '100%',
    maxWidth: '100vw',
    height: '100%',
    minHeight: 0,
    maxHeight: '100vh',
    // Flex-grow set to 0 to prevent this element from filling its parent flexbox container
    flex: '0 1 auto',
    flexDirection: 'column',
    backgroundColor: "var(--ds-surface-overlay, ".concat((0, $dSRcG.N0), ")"),
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    color: "var(--ds-text, ".concat((0, $dSRcG.N900), ")")
}, (0, $3CioX.CURRENT_SURFACE_CSS_VAR), "var(--ds-surface-overlay, ".concat((0, $dSRcG.N0), ")")), "pointerEvents", 'auto'), (0, $5Rrqa.media).above.xs, {
    width: 'var(--modal-dialog-width)',
    maxWidth: 'inherit',
    borderRadius: "var(--ds-border-radius, 3px)",
    boxShadow: "var(--ds-shadow-overlay, ".concat("0 0 0 1px ".concat((0, $dSRcG.N30A), ", 0 2px 1px ").concat((0, $dSRcG.N30A), ", 0 0 20px -6px ").concat((0, $dSRcG.N60A)), ")"),
    marginInlineEnd: 'inherit',
    marginInlineStart: 'inherit'
}), '& > form:only-child', {
    display: 'inherit',
    maxHeight: 'inherit',
    flexDirection: 'inherit'
}));
var $4ef8dd21c0783dce$var$viewportScrollStyles = (0, $74Zh5.css)((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({
    /**
   * This ensures that the element fills the viewport on mobile
   * while also allowing it to overflow if its height is larger than
   * the viewport.
   */ minHeight: '100vh',
    maxHeight: 'none'
}, (0, $5Rrqa.media).above.xs, {
    minHeight: 'var(--modal-dialog-height)'
}));
var $4ef8dd21c0783dce$var$bodyScrollStyles = (0, $74Zh5.css)((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, (0, $5Rrqa.media).above.xs, {
    height: 'var(--modal-dialog-height)',
    maxHeight: 'inherit'
}));
var $4ef8dd21c0783dce$var$ModalDialog = function ModalDialog(props) {
    var _props$width = props.width, width = _props$width === void 0 ? 'medium' : _props$width, _props$shouldScrollIn = props.shouldScrollInViewport, shouldScrollInViewport = _props$shouldScrollIn === void 0 ? false : _props$shouldScrollIn, shouldCloseOnEscapePress = props.shouldCloseOnEscapePress, autoFocus = props.autoFocus, stackIndex = props.stackIndex, onClose = props.onClose, onCloseComplete = props.onCloseComplete, onOpenComplete = props.onOpenComplete, height = props.height, hasProvidedOnClose = props.hasProvidedOnClose, children = props.children, label = props.label, testId = props.testId;
    var id = (0, $hbl7m.useId)();
    var titleId = "modal-dialog-title-".concat(id);
    (0, $5FkrB.useEffect)(function() {
        // Modal dialogs can appear on top of iframe elements that are on another domain.
        // There is a Chrome bug where drag and drop in an element on top of a cross domain
        // iframe is not working. We are applying the workaround for this bug in modal so
        // that consumers of our modal don't have to worry about this bug and are free to
        // create whatever drag and drop experience they like inside a modal
        //
        // Chrome bug: https://issues.chromium.org/issues/362301053
        return (0, $fGFYU.combine)((0, $lDqpZ.disableDraggingToCrossOriginIFramesForElement)(), (0, $8KNdU.disableDraggingToCrossOriginIFramesForTextSelection)(), (0, $kLhYg.disableDraggingToCrossOriginIFramesForExternal)());
    }, []);
    (0, $9mRRr.default)((0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(autoFocus) === 'object' ? autoFocus : undefined, // When a user supplies  a ref to focus we enable this hook
    (0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(autoFocus) === 'object');
    var _useOnMotionFinish = (0, $a8XWo.default)({
        onOpenComplete: onOpenComplete,
        onCloseComplete: onCloseComplete
    }), _useOnMotionFinish2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useOnMotionFinish, 2), motionRef = _useOnMotionFinish2[0], onMotionFinish = _useOnMotionFinish2[1];
    var modalDialogContext = (0, $5FkrB.useMemo)(function() {
        return {
            testId: testId,
            titleId: titleId,
            onClose: onClose,
            hasProvidedOnClose: hasProvidedOnClose
        };
    }, [
        testId,
        titleId,
        onClose,
        hasProvidedOnClose
    ]);
    (0, $lBq6d.useCloseOnEscapePress)({
        onClose: onClose,
        isDisabled: !shouldCloseOnEscapePress
    });
    var _useLayering = (0, $lBq6d.useLayering)(), currentLevel = _useLayering.currentLevel;
    return (0, $74Zh5.jsx)((0, $lGXDD.default), {
        stackIndex: stackIndex,
        shouldScrollInViewport: shouldScrollInViewport,
        testId: testId
    }, (0, $74Zh5.jsx)((0, $bwuZo.ModalContext).Provider, {
        value: modalDialogContext
    }, (0, $74Zh5.jsx)((0, $bwuZo.ScrollContext).Provider, {
        value: shouldScrollInViewport
    }, (0, $74Zh5.jsx)((0, $eQzrx.default), {
        entranceDirection: "bottom",
        onFinish: onMotionFinish
    }, function(bottomFadeInProps) {
        return (0, $74Zh5.jsx)((0, $eYQvF.default), null, (0, $74Zh5.jsx)("section", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, bottomFadeInProps, {
            "aria-label": label,
            ref: (0, $hd7HS.default)([
                bottomFadeInProps.ref,
                motionRef
            ]),
            style: {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                '--modal-dialog-width': (0, $3dEWA.dialogWidth)(width),
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                '--modal-dialog-height': (0, $3dEWA.dialogHeight)(height)
            },
            css: [
                $4ef8dd21c0783dce$var$dialogStyles,
                shouldScrollInViewport ? $4ef8dd21c0783dce$var$viewportScrollStyles : $4ef8dd21c0783dce$var$bodyScrollStyles
            ],
            role: "dialog",
            "aria-labelledby": label ? undefined : titleId,
            "data-testid": testId,
            "data-modal-stack": stackIndex,
            tabIndex: -1,
            "aria-modal": true,
            "data-ds--level": currentLevel
        }), children));
    }))));
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$4ef8dd21c0783dce$export$2e2bcd8739ae039 = $4ef8dd21c0783dce$var$ModalDialog;

});
parcelRegister("hd7HS", function(module, exports) {
$parcel$export(module.exports, "default", () => $c879a0f5ae67f2a4$export$2e2bcd8739ae039);
/**
 * Assigns the node to all the refs passed in the argument.
 *
 * @param refs: An array of refs (as function or ref object)
 */ function $c879a0f5ae67f2a4$export$2e2bcd8739ae039(refs) {
    // TODO: could this be wrapped in `useCallback` so we get a stable function?
    return function(value) {
        refs.forEach(function(ref) {
            if (typeof ref === 'function') ref(value);
            else if (ref !== null) ref.current = value;
        });
    };
}

});

parcelRegister("9mRRr", function(module, exports) {
$parcel$export(module.exports, "default", () => $6d1ff2cb9950775a$export$2e2bcd8739ae039);

var $5FkrB = parcelRequire("5FkrB");
function $6d1ff2cb9950775a$export$2e2bcd8739ae039(ref, autoFocus) {
    var initialMount = (0, $5FkrB.useRef)(true);
    (0, $5FkrB.useEffect)(function() {
        if (ref && initialMount.current && autoFocus && ref.current) ref.current.focus();
        initialMount.current = false;
    }, [
        autoFocus,
        ref
    ]);
}

});

parcelRegister("hbl7m", function(module, exports) {
$parcel$export(module.exports, "useId", () => $c823d84ade0d3550$export$f680877a34711e37);
$parcel$export(module.exports, "useIdSeed", () => $c823d84ade0d3550$export$6ee17796e3d70de2);

var $ekGgq = parcelRequire("ekGgq");

var $5FkrB = parcelRequire("5FkrB");

var $b5lkZ = parcelRequire("b5lkZ");

var $id6Cu = parcelRequire("id6Cu");
var $c823d84ade0d3550$var$_React$useId;
// Type copied from https://github.com/thearnica/react-uid/blob/0f507fbbdb1ab84acf477ec32698afe3d2191e49/src/hooks.ts#L12
// Copied rather than inferred to make the type transparent
// @ts-ignore - useId is not accessible in React 16
var $c823d84ade0d3550$var$react18UseId = ($c823d84ade0d3550$var$_React$useId = (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).useId) !== null && $c823d84ade0d3550$var$_React$useId !== void 0 ? $c823d84ade0d3550$var$_React$useId : undefined;
function $c823d84ade0d3550$export$f680877a34711e37() {
    if ($c823d84ade0d3550$var$react18UseId && (0, $id6Cu.fg)('platform-dst-react-18-use-id')) return $c823d84ade0d3550$var$react18UseId();
    return "uid".concat((0, $b5lkZ.useUID)());
}
var $c823d84ade0d3550$export$6be90bcb437e928f = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function(_ref, ref) {
    var children = _ref.children, _ref$postfix = _ref.postfix, postfix = _ref$postfix === void 0 ? '' : _ref$postfix, _ref$prefix = _ref.prefix, prefix = _ref$prefix === void 0 ? '' : _ref$prefix;
    var id = "".concat(prefix).concat($c823d84ade0d3550$export$f680877a34711e37()).concat(postfix);
    (0, $5FkrB.useEffect)(function() {
        if (!ref) return;
        switch((0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(ref)){
            case 'function':
                ref(id);
                break;
            case 'object':
                ref.current = id;
                break;
            default:
                throw new Error("Unreachable case for unsupported type of ref \"".concat((0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(ref), "\""));
        }
    }, [
        id,
        ref
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).Fragment, null, typeof children === 'function' ? children({
        id: id
    }) : children);
});
function $c823d84ade0d3550$export$6ee17796e3d70de2() {
    if ($c823d84ade0d3550$var$react18UseId && (0, $id6Cu.fg)('platform-dst-react-18-use-id')) {
        var uid = $c823d84ade0d3550$var$react18UseId();
        return function(id) {
            return "".concat(uid, "-").concat(id.toString());
        };
    }
    return (0, $b5lkZ.useUIDSeed)();
}

});

parcelRegister("lBq6d", function(module, exports) {
$parcel$export(module.exports, "useCloseOnEscapePress", () => $fba14c73ed3893f8$export$4a4bf067ea9e7886);
$parcel$export(module.exports, "useLayering", () => $fba14c73ed3893f8$export$c8b4d54e03dee6ed);

var $25nEq = parcelRequire("25nEq");

var $5FkrB = parcelRequire("5FkrB");

var $7QpUe = parcelRequire("7QpUe");

var $id6Cu = parcelRequire("id6Cu");

var $cZQqC = parcelRequire("cZQqC");
function $fba14c73ed3893f8$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $fba14c73ed3893f8$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $fba14c73ed3893f8$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $fba14c73ed3893f8$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $fba14c73ed3893f8$var$ESCAPE = 'Escape';
function $fba14c73ed3893f8$export$4a4bf067ea9e7886(_ref) {
    var onClose = _ref.onClose, isDisabled = _ref.isDisabled;
    var escapePressed = (0, $5FkrB.useRef)(false);
    var _useLayering = $fba14c73ed3893f8$export$c8b4d54e03dee6ed(), isLayerDisabled = _useLayering.isLayerDisabled;
    var onKeyDown = (0, $5FkrB.useCallback)(function(e) {
        var isDisabledLayer = isLayerDisabled();
        if (isDisabled || escapePressed.current || e.key !== $fba14c73ed3893f8$var$ESCAPE || isDisabledLayer) // We're either already handling the key down event or it's not escape or disabled.
        // Bail early!
        return;
        escapePressed.current = true;
        onClose(e);
    }, [
        onClose,
        isDisabled,
        isLayerDisabled
    ]);
    var onKeyUp = (0, $5FkrB.useCallback)(function() {
        escapePressed.current = false;
    }, []);
    (0, $5FkrB.useEffect)(function() {
        return (0, $7QpUe.bindAll)(window, [
            {
                type: 'keydown',
                listener: onKeyDown
            },
            {
                type: 'keyup',
                listener: onKeyUp
            }
        ], {
            capture: false
        });
    }, [
        onKeyDown,
        onKeyUp
    ]);
}
function $fba14c73ed3893f8$export$c8b4d54e03dee6ed() {
    var currentLevel = (0, $5FkrB.useContext)((0, $cZQqC.LevelContext));
    var _useContext = (0, $5FkrB.useContext)((0, $cZQqC.TopLevelContext)), topLevelRef = _useContext.topLevelRef, layerList = _useContext.layerList;
    var isLayerDisabled = (0, $5FkrB.useCallback)(function() {
        if ((0, $id6Cu.fg)('layering-top-level-use-array')) {
            var _layerList$current$le, _layerList$current;
            return ((_layerList$current$le = layerList === null || layerList === void 0 || (_layerList$current = layerList.current) === null || _layerList$current === void 0 ? void 0 : _layerList$current.length) !== null && _layerList$current$le !== void 0 ? _layerList$current$le : 0) !== currentLevel;
        }
        return !!topLevelRef.current && currentLevel !== topLevelRef.current;
    }, [
        currentLevel,
        topLevelRef,
        layerList
    ]);
    return $fba14c73ed3893f8$var$_objectSpread({
        currentLevel: currentLevel,
        topLevelRef: topLevelRef,
        isLayerDisabled: isLayerDisabled
    }, (0, $id6Cu.fg)('layering-top-level-use-array') ? {
        layerList: layerList
    } : {});
}

});

parcelRegister("5Rrqa", function(module, exports) {
$parcel$export(module.exports, "media", () => $44472c3c5911af74$export$987d49ffe1b0900f);
/**
 * This is an object of usable media query helpers using our internal breakpoints configuration.
 *
 * When using Compiled CSS-in-JS, please ensure that only a single declaration can take effect at a time.
 * This means that you should avoid multiple breakpoints taking effect at the same time,
 * eg. ```{ [media.above.xs]: { color: 'red' }, [media.above.sm]: { color: 'green' }}```.
 * Instead, make sure that only one breakpoint can take effect at a time,
 * e.g, ```{ [media.only.xs]: { color: 'red' }, [media.above.sm]: { color: 'green' }}```.
 * For more details, please see <https://compiledcssinjs.com/docs/atomic-css#selector-specificity>.
 */ var $44472c3c5911af74$export$987d49ffe1b0900f = {
    above: {
        xxs: '@media all',
        xs: '@media (min-width: 30rem)',
        sm: '@media (min-width: 48rem)',
        md: '@media (min-width: 64rem)',
        lg: '@media (min-width: 90rem)',
        xl: '@media (min-width: 110.5rem)'
    },
    only: {
        xxs: '@media (min-width: 0rem) and (max-width: 29.99rem)',
        xs: '@media (min-width: 30rem) and (max-width: 47.99rem)',
        sm: '@media (min-width: 48rem) and (max-width: 63.99rem)',
        md: '@media (min-width: 64rem) and (max-width: 89.99rem)',
        lg: '@media (min-width: 90rem) and (max-width: 110.49rem)',
        xl: '@media (min-width: 110.5rem)'
    },
    below: {
        xs: '@media not all and (min-width: 30rem)',
        sm: '@media not all and (min-width: 48rem)',
        md: '@media not all and (min-width: 64rem)',
        lg: '@media not all and (min-width: 90rem)',
        xl: '@media not all and (min-width: 110.5rem)'
    }
};
var $44472c3c5911af74$export$c881183ca713c214 = $44472c3c5911af74$export$987d49ffe1b0900f;

});

parcelRegister("3CioX", function(module, exports) {
$parcel$export(module.exports, "CURRENT_SURFACE_CSS_VAR", () => $2a2331d9b9f69826$export$9d7b58831ae93caa);
var $2a2331d9b9f69826$export$4ef52930e33717cd = 'data-theme';
var $2a2331d9b9f69826$export$a00eac3f8684bcd0 = 'data-color-mode';
var $2a2331d9b9f69826$export$2112803007239c61 = 'data-contrast-mode';
var $2a2331d9b9f69826$export$352e418ed5b6193a = 'data-custom-theme';
var $2a2331d9b9f69826$export$6f0c6fb8c80fcc92 = 'ds';
var $2a2331d9b9f69826$export$4d0c7bbf80185957 = [
    'opacity',
    'font',
    'space',
    'border'
];
var $2a2331d9b9f69826$export$dddac1532e822863 = "--".concat($2a2331d9b9f69826$export$6f0c6fb8c80fcc92, "-token-not-found");
var $2a2331d9b9f69826$export$9d7b58831ae93caa = "--".concat($2a2331d9b9f69826$export$6f0c6fb8c80fcc92, "-elevation-surface-current");

});

parcelRegister("bwuZo", function(module, exports) {
$parcel$export(module.exports, "ModalContext", () => $863ab8af7c66a185$export$ab57792b9b6974a6);
$parcel$export(module.exports, "ScrollContext", () => $863ab8af7c66a185$export$dece24112a937f92);

var $5FkrB = parcelRequire("5FkrB");
var $863ab8af7c66a185$export$ab57792b9b6974a6 = /*#__PURE__*/ (0, $5FkrB.createContext)(null);
var $863ab8af7c66a185$export$dece24112a937f92 = /*#__PURE__*/ (0, $5FkrB.createContext)(null);

});

parcelRegister("a8XWo", function(module, exports) {
$parcel$export(module.exports, "default", () => $762925b9b37c47b8$export$2e2bcd8739ae039);

var $5FkrB = parcelRequire("5FkrB");
function $762925b9b37c47b8$export$2e2bcd8739ae039(_ref) {
    var onOpenComplete = _ref.onOpenComplete, onCloseComplete = _ref.onCloseComplete;
    var motionRef = (0, $5FkrB.useRef)(null);
    var onMotionFinish = (0, $5FkrB.useCallback)(function(state) {
        if (state === 'entering' && onOpenComplete) onOpenComplete(motionRef.current, true);
        if (state === 'exiting' && onCloseComplete) onCloseComplete(motionRef.current);
    }, [
        onOpenComplete,
        onCloseComplete
    ]);
    return [
        motionRef,
        onMotionFinish
    ];
}

});

parcelRegister("lDqpZ", function(module, exports) {
$parcel$export(module.exports, "disableDraggingToCrossOriginIFramesForElement", () => $fc01bb97daef4f06$export$ec28e97c7d8b1b35);

var $7QpUe = parcelRequire("7QpUe");
parcelRequire("jkmxD");
var $fGFYU = parcelRequire("fGFYU");
parcelRequire("5ldyY");
var $f8loy = parcelRequire("f8loy");

var $bhh1k = parcelRequire("bhh1k");
function $fc01bb97daef4f06$var$watchForInteractionEnd(_ref) {
    var stop = _ref.stop;
    var isDragging = false;
    function stopIfNotDragging() {
        if (isDragging) return;
        stop();
    }
    var unbindEvents = (0, $7QpUe.bindAll)(window, [
        {
            // Another interaction is starting, this fix should be removed.
            type: 'pointerdown',
            listener: stop
        },
        {
            // The user did not start a drag
            type: 'pointerup',
            listener: stopIfNotDragging
        },
        {
            // if a "dragstart" occurs and the flag is not set,
            // then a drag has not started.
            // Note: could not use "pointercancel" as it is not
            // published in Safari
            // → https://bugs.webkit.org/show_bug.cgi?id=222632
            type: 'dragstart',
            listener: stopIfNotDragging,
            // Need to come after the element adapter
            options: {
                capture: false
            }
        }
    ], {
        // Listening in the capture phase to increase resilience
        // against events being stopped.
        capture: true,
        // Being super clear these should only run once
        once: true
    });
    var unbindMonitor = (0, $f8loy.monitorForElements)({
        onGenerateDragPreview: function onGenerateDragPreview() {
            isDragging = true;
        },
        onDrop: function onDrop() {
            isDragging = false;
            stop();
        }
    });
    return (0, $fGFYU.combine)(unbindEvents, unbindMonitor);
}
function $fc01bb97daef4f06$var$watchForInteractionStart(_ref2) {
    var start = _ref2.start;
    return (0, $7QpUe.bind)(window, {
        // Note: Using "mousedown" rather than "pointerdown" due to a Safari bug.
        // Safari not publish a "pointerdown" on the interaction after a drag
        // → https://bugs.webkit.org/show_bug.cgi?id=279749
        type: 'mousedown',
        listener: function listener(event) {
            // Only starting if pressing down inside a draggable element
            // At this point, we are not sure which if:
            // 1. a text selection drag is starting
            // 2. a draggable managed by pdnd is going to be dragged
            // 3. a draggable not managed by pdnd is going to be dragged
            // 4. The user will be dragging anything at all (might be doing a click)
            if (event.target instanceof HTMLElement && event.target.closest('[draggable="true"]')) start();
        }
    });
}
var $fc01bb97daef4f06$var$api = (0, $bhh1k.makeFixForAdapter)({
    watchForInteractionStart: $fc01bb97daef4f06$var$watchForInteractionStart,
    watchForInteractionEnd: $fc01bb97daef4f06$var$watchForInteractionEnd
});
function $fc01bb97daef4f06$export$ec28e97c7d8b1b35() {
    return $fc01bb97daef4f06$var$api.registerUsage();
}

});
parcelRegister("bhh1k", function(module, exports) {
$parcel$export(module.exports, "makeFixForAdapter", () => $835e7c21e8d6b7cc$export$a74bff2507e6126b);

var $fC8ib = parcelRequire("fC8ib");
parcelRequire("jkmxD");
var $fGFYU = parcelRequire("fGFYU");
/**
 * Set a `style` property on a `HTMLElement`
 *
 * @returns a `cleanup` function to restore the `style` property to it's original state
 */ function $835e7c21e8d6b7cc$var$setStyle(el, _ref) {
    var property = _ref.property, rule = _ref.rule, _ref$priority = _ref.priority, priority = _ref$priority === void 0 ? '' : _ref$priority;
    var originalValue = el.style.getPropertyValue(property);
    var originalPriority = el.style.getPropertyPriority(property);
    el.style.setProperty(property, rule, priority);
    return function cleanup() {
        el.style.setProperty(property, originalValue, originalPriority);
    };
}
function $835e7c21e8d6b7cc$var$hasSameOrigin(href1, href2) {
    var url1;
    var url2;
    try {
        url1 = new URL(href1);
        url2 = new URL(href2);
    } catch (error) {
        // failed to parse a href
        return false;
    }
    // https://developer.mozilla.org/en-US/docs/Web/Security/Same-origin_policy
    return url1.protocol === url2.protocol && url1.host === url2.host && url1.port === url2.port;
}
function $835e7c21e8d6b7cc$var$isIframeOnAnotherDomain(iframe) {
    /**
   * iframe with contents defined inline. Runs on the current origin.
   * `<iframe srcdoc="<!doctype html><body>Hello</body>" />`
   */ if (iframe.srcdoc) return false;
    /**
   * iframe with contents defined inline. Runs on the current origin.
   * `<iframe src={`data:text/html;charset=utf-8,${encodeURI('<!doctype html><body>Hello</body>')}`} />`
   */ if (iframe.src.startsWith('data:')) return false;
    return !$835e7c21e8d6b7cc$var$hasSameOrigin(window.location.href, iframe.src);
}
var $835e7c21e8d6b7cc$var$registry = new Map();
function $835e7c21e8d6b7cc$var$applyFix(watchForEndOfInteraction) {
    var iframes = Array.from(document.querySelectorAll('iframe')).filter($835e7c21e8d6b7cc$var$isIframeOnAnotherDomain);
    var cleanups = iframes.map(function(iframe) {
        var entry = $835e7c21e8d6b7cc$var$registry.get(iframe);
        if (!entry) {
            entry = {
                reset: $835e7c21e8d6b7cc$var$setStyle(iframe, {
                    property: 'pointer-events',
                    rule: 'none',
                    priority: 'important'
                }),
                count: 1
            };
            $835e7c21e8d6b7cc$var$registry.set(iframe, entry);
        } else // pointer-events:none already applied to the iframe
        // increment how many things requested the fix
        entry.count++;
        return function cleanup() {
            entry.count--;
            if (entry.count < 1) {
                entry.reset();
                $835e7c21e8d6b7cc$var$registry.delete(iframe);
            }
        };
    });
    function stop() {
        cleanupWatcher();
        (0, $fGFYU.combine).apply(void 0, (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(cleanups))();
    }
    var cleanupWatcher = watchForEndOfInteraction({
        stop: stop
    });
}
function $835e7c21e8d6b7cc$export$a74bff2507e6126b(_ref2) {
    var watchForInteractionStart = _ref2.watchForInteractionStart, watchForInteractionEnd = _ref2.watchForInteractionEnd;
    var registrationCount = 0;
    var stopWatchingInteractionStart = null;
    function start() {
        $835e7c21e8d6b7cc$var$applyFix(watchForInteractionEnd);
    }
    function registerUsage() {
        if (registrationCount === 0) stopWatchingInteractionStart = watchForInteractionStart({
            start: start
        });
        registrationCount++;
        return function unregisterUsage() {
            var _stopWatchingInteract;
            registrationCount--;
            if (registrationCount !== 0) return;
            (_stopWatchingInteract = stopWatchingInteractionStart) === null || _stopWatchingInteract === void 0 || _stopWatchingInteract();
            stopWatchingInteractionStart = null;
        };
    }
    return {
        registerUsage: registerUsage
    };
}

});


parcelRegister("kLhYg", function(module, exports) {
$parcel$export(module.exports, "disableDraggingToCrossOriginIFramesForExternal", () => $f1d623140326d5fe$export$27d79116d3a4e7d5);
parcelRequire("aPh0Z");
var $h6ZPT = parcelRequire("h6ZPT");

var $bhh1k = parcelRequire("bhh1k");
function $f1d623140326d5fe$var$watchForInteractionStart(_ref) {
    var start = _ref.start;
    return (0, $h6ZPT.monitorForExternal)({
        onDragStart: function onDragStart() {
            start();
        }
    });
}
function $f1d623140326d5fe$var$watchForInteractionEnd(_ref2) {
    var stop = _ref2.stop;
    return (0, $h6ZPT.monitorForExternal)({
        onDrop: function onDrop() {
            stop();
        }
    });
}
var $f1d623140326d5fe$var$api = (0, $bhh1k.makeFixForAdapter)({
    watchForInteractionStart: $f1d623140326d5fe$var$watchForInteractionStart,
    watchForInteractionEnd: $f1d623140326d5fe$var$watchForInteractionEnd
});
function $f1d623140326d5fe$export$27d79116d3a4e7d5() {
    return $f1d623140326d5fe$var$api.registerUsage();
}

});

parcelRegister("8KNdU", function(module, exports) {
$parcel$export(module.exports, "disableDraggingToCrossOriginIFramesForTextSelection", () => $65f8cd54b0500ec2$export$9c0606fcefb5d1e2);

var $7QpUe = parcelRequire("7QpUe");
parcelRequire("jkmxD");
var $fGFYU = parcelRequire("fGFYU");
parcelRequire("4p4mj");
var $5O7Kz = parcelRequire("5O7Kz");

var $bhh1k = parcelRequire("bhh1k");
function $65f8cd54b0500ec2$var$watchForInteractionEnd(_ref) {
    var stop = _ref.stop;
    var isDragging = false;
    function stopIfNotDragging() {
        if (isDragging) return;
        stop();
    }
    var frameId = null;
    var unbindEvents = (0, $7QpUe.bindAll)(window, [
        {
            // User is starting another interaction
            type: 'pointerdown',
            listener: stop
        },
        {
            // User did not start a drag.
            // "pointerdown" won't be fired if a drag started
            type: 'pointerup',
            listener: stopIfNotDragging
        },
        {
            type: 'dragstart',
            listener: function listener() {
                /**
       * The pdnd `onDragStart()` fires in the frame after "dragstart"
       * So we are delaying our isDragging check to give a chance
       * for `onDragStart()` to set the value correctly.
       *
       * Note: could not use "pointercancel" as it is not
       * published in Safari → https://bugs.webkit.org/show_bug.cgi?id=222632
       */ frameId = requestAnimationFrame(function() {
                    frameId = null;
                    stopIfNotDragging();
                });
            },
            // need to schedule our frame after the text-selection
            // adapter queues it's `onDragStart` frame.
            options: {
                capture: false
            }
        }
    ], {
        // Listening in the capture phase to increase resilience
        // against events being stopped.
        capture: true,
        // being super clear these should only run once
        once: true
    });
    var unbindMonitor = (0, $5O7Kz.monitorForTextSelection)({
        onDragStart: function onDragStart() {
            isDragging = true;
        },
        onDrop: function onDrop() {
            isDragging = false;
            stop();
        }
    });
    return (0, $fGFYU.combine)(unbindEvents, unbindMonitor, function abortFrame() {
        if (frameId != null) cancelAnimationFrame(frameId);
    });
}
function $65f8cd54b0500ec2$var$watchForInteractionStart(_ref2) {
    var start = _ref2.start;
    return (0, $7QpUe.bind)(window, {
        // Note: Using "mousedown" rather than "pointerdown" due to a Safari bug.
        // Safari not publish a "pointerdown" on the interaction after a drag
        // → https://bugs.webkit.org/show_bug.cgi?id=279749
        type: 'mousedown',
        listener: function listener() {
            // A text selection drag will only start when there is
            // an active text selection.
            var selection = window.getSelection();
            // No selection object found
            if (!selection) return;
            // `isCollapsed` is "true" if there is currently no selected text
            if (selection.isCollapsed) return;
            start();
        }
    });
}
var $65f8cd54b0500ec2$var$api = (0, $bhh1k.makeFixForAdapter)({
    watchForInteractionStart: $65f8cd54b0500ec2$var$watchForInteractionStart,
    watchForInteractionEnd: $65f8cd54b0500ec2$var$watchForInteractionEnd
});
function $65f8cd54b0500ec2$export$9c0606fcefb5d1e2() {
    return $65f8cd54b0500ec2$var$api.registerUsage();
}

});

parcelRegister("3dEWA", function(module, exports) {
$parcel$export(module.exports, "dialogWidth", () => $2582589a0b2ae018$export$a3da89b899389ed8);
$parcel$export(module.exports, "dialogHeight", () => $2582589a0b2ae018$export$ceba93bf0bdd16f2);
var $2582589a0b2ae018$export$7e3df82ee760448c = {
    values: [
        'small',
        'medium',
        'large',
        'x-large'
    ],
    widths: {
        small: 400,
        medium: 600,
        large: 800,
        'x-large': 968
    },
    defaultValue: 'medium'
};
var $2582589a0b2ae018$export$a3da89b899389ed8 = function dialogWidth(input) {
    if (!input) return 'auto';
    var isWidthName = $2582589a0b2ae018$export$7e3df82ee760448c.values.indexOf(input.toString()) !== -1;
    var widthName = isWidthName && input;
    if (widthName) return "".concat($2582589a0b2ae018$export$7e3df82ee760448c.widths[widthName], "px");
    return typeof input === 'number' ? "".concat(input, "px") : input;
};
var $2582589a0b2ae018$export$ceba93bf0bdd16f2 = function dialogHeight(input) {
    if (!input) return 'auto';
    return typeof input === 'number' ? "".concat(input, "px") : input;
};

});

parcelRegister("lGXDD", function(module, exports) {
$parcel$export(module.exports, "default", () => $fcabc821ed842c5c$export$2e2bcd8739ae039);

var $25nEq = parcelRequire("25nEq");

var $74Zh5 = parcelRequire("74Zh5");

var $2HK8I = parcelRequire("2HK8I");

var $fF5v2 = parcelRequire("fF5v2");

var $5Rrqa = parcelRequire("5Rrqa");

var $H74DA = parcelRequire("H74DA");
var $fcabc821ed842c5c$var$gutter = 60;
var $fcabc821ed842c5c$var$maxWidthDimensions = "calc(100vw - ".concat($fcabc821ed842c5c$var$gutter * 2, "px)");
var $fcabc821ed842c5c$var$maxHeightDimensions = "calc(100vh - ".concat($fcabc821ed842c5c$var$gutter * 2 - 1, "px)");
// Flex and min-content are set to constrain the height of the body and support multi-column scrolling experiences
var $fcabc821ed842c5c$var$positionerStyles = (0, $74Zh5.css)({
    display: 'flex',
    width: '100%',
    maxWidth: '100%',
    height: '100%',
    position: 'fixed',
    zIndex: (0, $H74DA.layers).modal(),
    flexDirection: 'column',
    insetBlockStart: 0,
    insetInlineStart: 0
});
var $fcabc821ed842c5c$var$viewportScrollStyles = (0, $74Zh5.css)((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({
    height: 'auto',
    position: 'relative'
}, (0, $5Rrqa.media).above.xs, {
    margin: "".concat($fcabc821ed842c5c$var$gutter, "px auto"),
    pointerEvents: 'none'
}));
var $fcabc821ed842c5c$var$bodyScrollStyles = (0, $74Zh5.css)((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, (0, $5Rrqa.media).above.xs, {
    maxWidth: $fcabc821ed842c5c$var$maxWidthDimensions,
    maxHeight: $fcabc821ed842c5c$var$maxHeightDimensions,
    position: 'absolute',
    insetBlockStart: "".concat($fcabc821ed842c5c$var$gutter, "px"),
    insetInlineEnd: 0,
    insetInlineStart: 0,
    marginInlineEnd: 'auto',
    marginInlineStart: 'auto',
    pointerEvents: 'none'
}));
var $fcabc821ed842c5c$var$stackTransitionStyles = (0, $74Zh5.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
    transitionDuration: "".concat((0, $fF5v2.durations).medium, "ms"),
    transitionProperty: 'transform',
    transitionTimingFunction: (0, $2HK8I.easeInOut),
    /**
   * Duplicated from @atlaskit/motion/accessibility
   * because @repo/internal/styles/consistent-style-ordering
   * doesn't work well with object spreading.
   */ '@media (prefers-reduced-motion: reduce)': {
        animation: 'none',
        transition: 'none'
    }
});
var $fcabc821ed842c5c$var$stackTransformStyles = (0, $74Zh5.css)({
    transform: 'translateY(var(--modal-dialog-translate-y))'
});
var $fcabc821ed842c5c$var$stackIdleStyles = (0, $74Zh5.css)({
    transform: 'none'
});
var $fcabc821ed842c5c$var$Positioner = function Positioner(props) {
    var children = props.children, stackIndex = props.stackIndex, shouldScrollInViewport = props.shouldScrollInViewport, testId = props.testId;
    return (0, $74Zh5.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            '--modal-dialog-translate-y': "calc(".concat(stackIndex, "px * ", "var(--ds-space-100, 8px)", ")")
        },
        css: [
            $fcabc821ed842c5c$var$positionerStyles,
            $fcabc821ed842c5c$var$stackTransitionStyles,
            /* We only want to apply transform on modals shifting to the back of the stack. */ stackIndex > 0 ? $fcabc821ed842c5c$var$stackTransformStyles : $fcabc821ed842c5c$var$stackIdleStyles,
            shouldScrollInViewport ? $fcabc821ed842c5c$var$viewportScrollStyles : $fcabc821ed842c5c$var$bodyScrollStyles
        ],
        "data-testid": testId && "".concat(testId, "--positioner")
    }, children);
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$fcabc821ed842c5c$export$2e2bcd8739ae039 = $fcabc821ed842c5c$var$Positioner;

});
parcelRegister("2HK8I", function(module, exports) {
$parcel$export(module.exports, "easeInOut", () => $1f836347f90924f9$export$c07234257a03d5e9);
var $1f836347f90924f9$export$c07234257a03d5e9 = 'cubic-bezier(0.15,1,0.3,1)';
var $1f836347f90924f9$export$57636bb43b1ccbb0 = 'cubic-bezier(0.2,0,0,1)';
var $1f836347f90924f9$export$929e5a82286172a6 = 'cubic-bezier(0.8,0,0,0.8)';
var $1f836347f90924f9$export$fc825baa2ef870d0 = 'cubic-bezier(0.4,0,0,1)';
var $1f836347f90924f9$export$816ee5d79b5bd9a5 = 'cubic-bezier(0.6,0,0,1)';
var $1f836347f90924f9$export$53ce3390a1a8f2a2 = 'cubic-bezier(0.8,0,0,1)';
var $1f836347f90924f9$export$45db2fc2f15997e7 = 'cubic-bezier(0,0,1,1)';

});



parcelRegister("60tyR", function(module, exports) {
$parcel$export(module.exports, "default", () => $45f9ac6b886497d2$export$2e2bcd8739ae039);

var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");

var $1kPX3 = parcelRequire("1kPX3");

var $ciDfW = parcelRequire("ciDfW");

var $bLMGO = parcelRequire("bLMGO");

var $ZdqJG = parcelRequire("ZdqJG");
/**
 *  ________________________________________________
 * | MAJOR VERSIONS WILL NOT KNOW ABOUT EACH OTHER! |
 *  ------------------------------------------------
 *
 * An array which holds references to all currently open modal dialogs.
 * This will only work for modal dialogs of the same major version,
 * as the reference will be different between them.
 *
 * E.g. V11 won't know about any from V12.
 */ var $45f9ac6b886497d2$var$modalStackRegister = [];
function $45f9ac6b886497d2$export$2e2bcd8739ae039(_ref) {
    var onStackChange = _ref.onStackChange;
    var _useExitingPersistenc = (0, $ZdqJG.useExitingPersistence)(), isExiting = _useExitingPersistenc.isExiting;
    var _useStateRef = (0, $bLMGO.default)(0), _useStateRef2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useStateRef, 2), stackIndexRef = _useStateRef2[0], setStackIndex = _useStateRef2[1];
    var currentStackIndex = stackIndexRef.current;
    var previousStackIndex = (0, $ciDfW.default)(stackIndexRef.current);
    // We want to ensure this function **never changes** during the lifecycle of this component.
    // This is why it's assigned to a ref and not in a useMemo/useCallback.
    var updateStack = (0, $1kPX3.default)(function() {
        var newStackIndex = $45f9ac6b886497d2$var$modalStackRegister.indexOf(updateStack);
        // We access the stack index ref instead of state because this closure will always only
        // have the initial state and not any of the later values.
        if (stackIndexRef.current !== newStackIndex) {
            setStackIndex(newStackIndex);
            stackIndexRef.current = newStackIndex;
        }
    });
    (0, $5FkrB.useEffect)(function() {
        var currentStackIndex = $45f9ac6b886497d2$var$modalStackRegister.indexOf(updateStack);
        if (!isExiting && currentStackIndex === -1) // We are opening the modal dialog.
        // Add ourselves to the modal stack register!
        $45f9ac6b886497d2$var$modalStackRegister.unshift(updateStack);
        if (isExiting && currentStackIndex !== -1) // We are closing the modal dialog using a wrapping modal transition component.
        // Remove ourselves from the modal stack register!
        // NOTE: Modal dialogs that don't have a wrapping modal transition component won't flow through here!
        // For that scenario we cleanup when the component unmounts.
        $45f9ac6b886497d2$var$modalStackRegister.splice(currentStackIndex, 1);
        // Fire all registered modal dialogs to update their position in the stack.
        $45f9ac6b886497d2$var$modalStackRegister.forEach(function(cb) {
            return cb();
        });
    }, [
        updateStack,
        isExiting
    ]);
    (0, $5FkrB.useEffect)(function() {
        return function() {
            // Final cleanup just in case this modal dialog did not have a wrapping modal transition.
            var currentStackIndex = $45f9ac6b886497d2$var$modalStackRegister.indexOf(updateStack);
            if (currentStackIndex !== -1) {
                $45f9ac6b886497d2$var$modalStackRegister.splice(currentStackIndex, 1);
                $45f9ac6b886497d2$var$modalStackRegister.forEach(function(cb) {
                    return cb();
                });
            }
        };
    }, [
        updateStack
    ]);
    (0, $5FkrB.useEffect)(function() {
        if (previousStackIndex === undefined) // Initial case that we don't need to notify about.
        return;
        if (previousStackIndex !== currentStackIndex) onStackChange(currentStackIndex);
    }, [
        onStackChange,
        previousStackIndex,
        currentStackIndex
    ]);
    return currentStackIndex;
}

});
parcelRegister("1kPX3", function(module, exports) {
$parcel$export(module.exports, "default", () => $0f8ff52f3e6d1f22$export$2e2bcd8739ae039);

var $amMBV = parcelRequire("amMBV");
function $0f8ff52f3e6d1f22$export$2e2bcd8739ae039(callback) {
    var ref = (0, $amMBV.default)(function() {
        return callback;
    });
    return ref.current;
}

});
parcelRegister("amMBV", function(module, exports) {
$parcel$export(module.exports, "default", () => $78c1aa829ab850be$export$2e2bcd8739ae039);

var $5FkrB = parcelRequire("5FkrB");
var $78c1aa829ab850be$var$uniqueReferencedValue = {};
function $78c1aa829ab850be$export$2e2bcd8739ae039(initializer) {
    var ref = (0, $5FkrB.useRef)($78c1aa829ab850be$var$uniqueReferencedValue);
    if (ref.current === $78c1aa829ab850be$var$uniqueReferencedValue) ref.current = initializer();
    return ref;
}

});


parcelRegister("ciDfW", function(module, exports) {
$parcel$export(module.exports, "default", () => $8f459deb6f880ccf$export$2e2bcd8739ae039);

var $5FkrB = parcelRequire("5FkrB");
function $8f459deb6f880ccf$export$2e2bcd8739ae039(value) {
    var ref = (0, $5FkrB.useRef)();
    (0, $5FkrB.useEffect)(function() {
        ref.current = value;
    }, [
        value
    ]);
    return ref.current;
}

});

parcelRegister("bLMGO", function(module, exports) {
$parcel$export(module.exports, "default", () => $8919da37d02870d7$export$2e2bcd8739ae039);

var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");
function $8919da37d02870d7$export$2e2bcd8739ae039(initialState) {
    var _useState = (0, $5FkrB.useState)(initialState), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), value = _useState2[0], setValue = _useState2[1];
    var valueRef = (0, $5FkrB.useRef)(value);
    valueRef.current = value;
    return [
        valueRef,
        setValue
    ];
}

});


parcelRegister("deUvr", function(module, exports) {
$parcel$export(module.exports, "default", () => $9a386a1d7fb2b3ec$export$2e2bcd8739ae039);

var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");

var $7QpUe = parcelRequire("7QpUe");
/**
 * Returns how far the body is scrolled from the top of the viewport.
 *
 *   ____
 * ||____|| <-- overflow
 *  |    |  <-- viewport
 *  |____|
 *
 * Scroll distance is the height of overflow outside the viewport.
 */ function $9a386a1d7fb2b3ec$var$getScrollDistance() {
    var _document$documentEle, _document$body;
    return window.pageYOffset || ((_document$documentEle = document.documentElement) === null || _document$documentEle === void 0 ? void 0 : _document$documentEle.scrollTop) || ((_document$body = document.body) === null || _document$body === void 0 ? void 0 : _document$body.scrollTop) || 0;
}
function $9a386a1d7fb2b3ec$export$2e2bcd8739ae039() {
    var _useState = (0, $5FkrB.useState)(0), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), scrollTopOffset = _useState2[0], setScrollTopOffset = _useState2[1];
    (0, $5FkrB.useLayoutEffect)(function() {
        setScrollTopOffset($9a386a1d7fb2b3ec$var$getScrollDistance());
    }, []);
    var onWindowScroll = (0, $5FkrB.useCallback)(function() {
        if ($9a386a1d7fb2b3ec$var$getScrollDistance() !== scrollTopOffset) window.scrollTo(window.pageXOffset, scrollTopOffset);
    }, [
        scrollTopOffset
    ]);
    (0, $5FkrB.useEffect)(function() {
        return (0, $7QpUe.bind)(window, {
            type: 'scroll',
            listener: onWindowScroll
        });
    }, [
        onWindowScroll
    ]);
    return scrollTopOffset;
}

});


parcelRegister("4dmfM", function(module, exports) {
$parcel$export(module.exports, "default", () => $3119a3635b07e652$export$2e2bcd8739ae039);

var $5FkrB = parcelRequire("5FkrB");

var $ZdqJG = parcelRequire("ZdqJG");
/**
 * __Modal transition__
 *
 * A modal transition wraps a modal to provide a fluid transition upon opening and closing.
 *
 * - [Examples](https://atlassian.design/components/modal-dialog/examples)
 * - [Code](https://atlassian.design/components/modal-dialog/code)
 * - [Usage](https://atlassian.design/components/modal-dialog/usage)
 */ var $3119a3635b07e652$var$ModalTransition = function ModalTransition(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $ZdqJG.default), {
        appear: true
    }, props.children);
};
var $3119a3635b07e652$export$2e2bcd8739ae039 = $3119a3635b07e652$var$ModalTransition;

});

parcelRegister("9Ayri", function(module, exports) {
$parcel$export(module.exports, "default", () => $6fb230c2df2e6028$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ parcelRequire("5FkrB");

var $74Zh5 = parcelRequire("74Zh5");

var $2B91F = parcelRequire("2B91F");
var $aDxXf = parcelRequire("aDxXf");
var $e255n = parcelRequire("e255n");

var $3aP8P = parcelRequire("3aP8P");

var $2td33 = parcelRequire("2td33");
var $6fb230c2df2e6028$var$headerStyles = (0, $74Zh5.css)({
    display: 'flex',
    position: 'relative',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBlockEnd: "calc(-1 * ".concat("var(--ds-border-width-outline, 2px)", ")"),
    paddingBlockEnd: "var(--ds-space-200, 16px)",
    paddingBlockStart: "var(--ds-space-300, 24px)",
    paddingInline: "var(--ds-space-300, 24px)"
});
var $6fb230c2df2e6028$var$gridStyles = (0, $e255n.xcss)({
    width: '100%'
});
var $6fb230c2df2e6028$var$closeContainerStyles = (0, $e255n.xcss)({
    gridArea: 'close'
});
var $6fb230c2df2e6028$var$titleContainerStyles = (0, $e255n.xcss)({
    gridArea: 'title'
});
/**
 * __Modal header__
 *
 * A modal header contains the title of the modal and can contain other React elements such as a close button.
 *
 * - [Examples](https://atlassian.design/components/modal-dialog/examples#modal-header)
 * - [Code](https://atlassian.design/components/modal-dialog/code#modal-header-props)
 * - [Usage](https://atlassian.design/components/modal-dialog/usage)
 */ var $6fb230c2df2e6028$var$ModalHeader = function ModalHeader(props) {
    var children = props.children, userDefinedTestId = props.testId, _props$hasCloseButton = props.hasCloseButton, hasCloseButton = _props$hasCloseButton === void 0 ? false : _props$hasCloseButton;
    var _useModal = (0, $2td33.useModal)(), hasProvidedOnClose = _useModal.hasProvidedOnClose, onClose = _useModal.onClose, modalTestId = _useModal.testId;
    var testId = userDefinedTestId || modalTestId && "".concat(modalTestId, "--header");
    // Only show if an onClose was provided for the modal dialog
    var shouldShowCloseButton = hasCloseButton && hasProvidedOnClose && onClose;
    return (0, $74Zh5.jsx)("div", {
        css: $6fb230c2df2e6028$var$headerStyles,
        "data-testid": testId
    }, shouldShowCloseButton ? (0, $74Zh5.jsx)((0, $aDxXf.default), {
        gap: "space.200",
        templateAreas: [
            'title close'
        ],
        xcss: $6fb230c2df2e6028$var$gridStyles
    }, (0, $74Zh5.jsx)((0, $2B91F.default), {
        xcss: $6fb230c2df2e6028$var$titleContainerStyles,
        justifyContent: "start",
        alignItems: "center"
    }, children), (0, $74Zh5.jsx)((0, $2B91F.default), {
        xcss: $6fb230c2df2e6028$var$closeContainerStyles,
        justifyContent: "end"
    }, (0, $74Zh5.jsx)((0, $3aP8P.CloseButton), {
        onClick: onClose,
        testId: modalTestId
    }))) : children);
};
var $6fb230c2df2e6028$export$2e2bcd8739ae039 = $6fb230c2df2e6028$var$ModalHeader;

});
parcelRegister("2B91F", function(module, exports) {
$parcel$export(module.exports, "default", () => $1e4609d211929a23$export$2e2bcd8739ae039);

var $fC8ib = parcelRequire("fC8ib");

var $5FkrB = parcelRequire("5FkrB");

var $74Zh5 = parcelRequire("74Zh5");

var $lmNh5 = parcelRequire("lmNh5");

var $e255n = parcelRequire("e255n");
var $1e4609d211929a23$var$justifyContentMap = {
    start: (0, $74Zh5.css)({
        justifyContent: 'start'
    }),
    center: (0, $74Zh5.css)({
        justifyContent: 'center'
    }),
    end: (0, $74Zh5.css)({
        justifyContent: 'end'
    }),
    'space-between': (0, $74Zh5.css)({
        justifyContent: 'space-between'
    }),
    'space-around': (0, $74Zh5.css)({
        justifyContent: 'space-around'
    }),
    'space-evenly': (0, $74Zh5.css)({
        justifyContent: 'space-evenly'
    }),
    stretch: (0, $74Zh5.css)({
        justifyContent: 'stretch'
    })
};
var $1e4609d211929a23$var$flexDirectionMap = {
    column: (0, $74Zh5.css)({
        flexDirection: 'column'
    }),
    row: (0, $74Zh5.css)({
        flexDirection: 'row'
    })
};
var $1e4609d211929a23$var$flexWrapMap = {
    wrap: (0, $74Zh5.css)({
        flexWrap: 'wrap'
    }),
    nowrap: (0, $74Zh5.css)({
        flexWrap: 'nowrap'
    })
};
var $1e4609d211929a23$var$alignItemsMap = {
    start: (0, $74Zh5.css)({
        alignItems: 'start'
    }),
    center: (0, $74Zh5.css)({
        alignItems: 'center'
    }),
    baseline: (0, $74Zh5.css)({
        alignItems: 'baseline'
    }),
    end: (0, $74Zh5.css)({
        alignItems: 'end'
    }),
    stretch: (0, $74Zh5.css)({
        alignItems: 'stretch'
    })
};
var $1e4609d211929a23$var$baseStyles = (0, $74Zh5.css)({
    display: 'flex',
    boxSizing: 'border-box'
});
/**
 * __Flex__
 *
 * `Flex` is a primitive component that implements the CSS Flexbox API.
 *
 * - [Examples](https://atlassian.design/components/primitives/flex/examples)
 * - [Code](https://atlassian.design/components/primitives/flex/code)
 *
 * @example
 * ```tsx
 * // eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
 * import { Flex, Box } from '@atlaskit/primitives'
 *
 * const Component = () => (
 *   <Flex direction="column">
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *   </Flex>
 * )
 * ```
 */ var $1e4609d211929a23$var$Flex = /*#__PURE__*/ (0, $5FkrB.memo)(/*#__PURE__*/ (0, $5FkrB.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? 'div' : _ref$as, role = _ref.role, alignItems = _ref.alignItems, justifyContent = _ref.justifyContent, gap = _ref.gap, columnGap = _ref.columnGap, rowGap = _ref.rowGap, children = _ref.children, testId = _ref.testId, direction = _ref.direction, wrap = _ref.wrap, xcss = _ref.xcss, id = _ref.id;
    var resolvedStyles = (0, $e255n.parseXcss)(xcss);
    return (0, $74Zh5.jsx)(Component, {
        id: id,
        role: role,
        className: resolvedStyles.static,
        css: [
            $1e4609d211929a23$var$baseStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            gap && (0, $lmNh5.spaceStylesMap).gap[gap],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            columnGap && (0, $lmNh5.spaceStylesMap).columnGap[columnGap],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            rowGap && (0, $lmNh5.spaceStylesMap).rowGap[rowGap],
            alignItems && $1e4609d211929a23$var$alignItemsMap[alignItems],
            direction && $1e4609d211929a23$var$flexDirectionMap[direction],
            justifyContent && $1e4609d211929a23$var$justifyContentMap[justifyContent],
            wrap && $1e4609d211929a23$var$flexWrapMap[wrap]
        ].concat((0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(resolvedStyles.emotion || [])),
        "data-testid": testId,
        ref: ref
    }, children);
}));
$1e4609d211929a23$var$Flex.displayName = 'Flex';
var $1e4609d211929a23$export$2e2bcd8739ae039 = $1e4609d211929a23$var$Flex;

});
parcelRegister("lmNh5", function(module, exports) {
$parcel$export(module.exports, "dimensionMap", () => $f8e1dffa19542231$export$6ccdbebca2ee545f);
$parcel$export(module.exports, "positiveSpaceMap", () => $f8e1dffa19542231$export$958d0ae7f2977ae4);
$parcel$export(module.exports, "allSpaceMap", () => $f8e1dffa19542231$export$632685d741f3dbbf);
$parcel$export(module.exports, "opacityMap", () => $f8e1dffa19542231$export$daf94a976c798b4f);
$parcel$export(module.exports, "shadowMap", () => $f8e1dffa19542231$export$7aff6e7ba39bb774);
$parcel$export(module.exports, "borderColorMap", () => $f8e1dffa19542231$export$1531ad5bb3fbedac);
$parcel$export(module.exports, "backgroundColorMap", () => $f8e1dffa19542231$export$d1d79bf68ac056bd);
$parcel$export(module.exports, "textColorMap", () => $f8e1dffa19542231$export$8473307aa00d6ea1);
$parcel$export(module.exports, "layerMap", () => $f8e1dffa19542231$export$b5f31a7e431d2eab);
$parcel$export(module.exports, "borderWidthMap", () => $f8e1dffa19542231$export$e1b83c5210c471b8);
$parcel$export(module.exports, "borderRadiusMap", () => $f8e1dffa19542231$export$3c0a6c3e64bb180d);
$parcel$export(module.exports, "fontMap", () => $f8e1dffa19542231$export$6ffa317d5e70375);
$parcel$export(module.exports, "fontWeightMap", () => $f8e1dffa19542231$export$303e322c6b1ed114);
$parcel$export(module.exports, "fontFamilyMap", () => $f8e1dffa19542231$export$3c7e9587132614b4);
$parcel$export(module.exports, "spaceStylesMap", () => $f8e1dffa19542231$export$bf46c3f9eeafc71f);

var $25nEq = parcelRequire("25nEq");

var $74Zh5 = parcelRequire("74Zh5");

var $4EY2U = parcelRequire("4EY2U");
function $f8e1dffa19542231$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $f8e1dffa19542231$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $f8e1dffa19542231$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $f8e1dffa19542231$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $f8e1dffa19542231$export$6ccdbebca2ee545f = {
    '100%': '100%',
    'size.100': '1rem',
    'size.200': '1.5rem',
    'size.300': '2rem',
    'size.400': '2.5rem',
    'size.500': '3rem',
    'size.600': '6rem',
    'size.1000': '12rem'
};
var $f8e1dffa19542231$export$958d0ae7f2977ae4 = {
    'space.0': "var(--ds-space-0, 0px)",
    'space.025': "var(--ds-space-025, 2px)",
    'space.050': "var(--ds-space-050, 4px)",
    'space.075': "var(--ds-space-075, 6px)",
    'space.100': "var(--ds-space-100, 8px)",
    'space.150': "var(--ds-space-150, 12px)",
    'space.200': "var(--ds-space-200, 16px)",
    'space.250': "var(--ds-space-250, 20px)",
    'space.300': "var(--ds-space-300, 24px)",
    'space.400': "var(--ds-space-400, 32px)",
    'space.500': "var(--ds-space-500, 40px)",
    'space.600': "var(--ds-space-600, 48px)",
    'space.800': "var(--ds-space-800, 64px)",
    'space.1000': "var(--ds-space-1000, 80px)"
};
var $f8e1dffa19542231$export$d2dc61f58390201c = {
    'space.negative.025': "var(--ds-space-negative-025, -2px)",
    'space.negative.050': "var(--ds-space-negative-050, -4px)",
    'space.negative.075': "var(--ds-space-negative-075, -6px)",
    'space.negative.100': "var(--ds-space-negative-100, -8px)",
    'space.negative.150': "var(--ds-space-negative-150, -12px)",
    'space.negative.200': "var(--ds-space-negative-200, -16px)",
    'space.negative.250': "var(--ds-space-negative-250, -20px)",
    'space.negative.300': "var(--ds-space-negative-300, -24px)",
    'space.negative.400': "var(--ds-space-negative-400, -32px)"
};
var $f8e1dffa19542231$export$632685d741f3dbbf = $f8e1dffa19542231$var$_objectSpread($f8e1dffa19542231$var$_objectSpread({}, $f8e1dffa19542231$export$958d0ae7f2977ae4), $f8e1dffa19542231$export$d2dc61f58390201c);
var $f8e1dffa19542231$export$2185ce37f9bdd963 = {
    'color.background.neutral.bold': 'color.text.inverse',
    'color.background.neutral.bold.hovered': 'color.text.inverse',
    'color.background.neutral.bold.pressed': 'color.text.inverse',
    'color.background.selected.bold': 'color.text.inverse',
    'color.background.selected.bold.hovered': 'color.text.inverse',
    'color.background.selected.bold.pressed': 'color.text.inverse',
    'color.background.brand.bold': 'color.text.inverse',
    'color.background.brand.bold.hovered': 'color.text.inverse',
    'color.background.brand.bold.pressed': 'color.text.inverse',
    'color.background.brand.boldest': 'color.text.inverse',
    'color.background.brand.boldest.hovered': 'color.text.inverse',
    'color.background.brand.boldest.pressed': 'color.text.inverse',
    'color.background.danger.bold': 'color.text.inverse',
    'color.background.danger.bold.hovered': 'color.text.inverse',
    'color.background.danger.bold.pressed': 'color.text.inverse',
    'color.background.warning.bold': 'color.text.warning.inverse',
    'color.background.warning.bold.hovered': 'color.text.warning.inverse',
    'color.background.warning.bold.pressed': 'color.text.warning.inverse',
    'color.background.success.bold': 'color.text.inverse',
    'color.background.success.bold.hovered': 'color.text.inverse',
    'color.background.success.bold.pressed': 'color.text.inverse',
    'color.background.discovery.bold': 'color.text.inverse',
    'color.background.discovery.bold.hovered': 'color.text.inverse',
    'color.background.discovery.bold.pressed': 'color.text.inverse',
    'color.background.information.bold': 'color.text.inverse',
    'color.background.information.bold.hovered': 'color.text.inverse',
    'color.background.information.bold.pressed': 'color.text.inverse'
};
var $f8e1dffa19542231$export$daf94a976c798b4f = {
    'opacity.disabled': "var(--ds-opacity-disabled, 0.4)",
    'opacity.loading': "var(--ds-opacity-loading, 0.2)"
};
var $f8e1dffa19542231$export$7aff6e7ba39bb774 = {
    'elevation.shadow.overflow': "var(--ds-shadow-overflow, 0px 0px 8px #091e423f, 0px 0px 1px #091e424f)",
    'elevation.shadow.overflow.perimeter': "var(--ds-shadow-overflow-perimeter, #091e421f)",
    'elevation.shadow.overflow.spread': "var(--ds-shadow-overflow-spread, #091e4229)",
    'elevation.shadow.overlay': "var(--ds-shadow-overlay, 0px 8px 12px #091e423f, 0px 0px 1px #091e424f)",
    'elevation.shadow.raised': "var(--ds-shadow-raised, 0px 1px 1px #091e423f, 0px 0px 1px #091e4221)"
};
var $f8e1dffa19542231$export$41a358c9c2356760 = {
    'elevation.surface': "var(--ds-surface, #FFFFFF)",
    'elevation.surface.hovered': "var(--ds-surface-hovered, #FAFBFC)",
    'elevation.surface.pressed': "var(--ds-surface-pressed, #F4F5F7)",
    'elevation.surface.overlay': "var(--ds-surface-overlay, #FFFFFF)",
    'elevation.surface.overlay.hovered': "var(--ds-surface-overlay-hovered, #FAFBFC)",
    'elevation.surface.overlay.pressed': "var(--ds-surface-overlay-pressed, #F4F5F7)",
    'elevation.surface.raised': "var(--ds-surface-raised, #FFFFFF)",
    'elevation.surface.raised.hovered': "var(--ds-surface-raised-hovered, #FAFBFC)",
    'elevation.surface.raised.pressed': "var(--ds-surface-raised-pressed, #F4F5F7)",
    'elevation.surface.sunken': "var(--ds-surface-sunken, #F4F5F7)"
};
var $f8e1dffa19542231$export$1531ad5bb3fbedac = {
    'color.border': "var(--ds-border, #091e4221)",
    'color.border.accent.lime': "var(--ds-border-accent-lime, #6A9A23)",
    'color.border.accent.red': "var(--ds-border-accent-red, #FF5630)",
    'color.border.accent.orange': "var(--ds-border-accent-orange, #D94008)",
    'color.border.accent.yellow': "var(--ds-border-accent-yellow, #FFAB00)",
    'color.border.accent.green': "var(--ds-border-accent-green, #36B37E)",
    'color.border.accent.teal': "var(--ds-border-accent-teal, #00B8D9)",
    'color.border.accent.blue': "var(--ds-border-accent-blue, #0065FF)",
    'color.border.accent.purple': "var(--ds-border-accent-purple, #6554C0)",
    'color.border.accent.magenta': "var(--ds-border-accent-magenta, #CD519D)",
    'color.border.accent.gray': "var(--ds-border-accent-gray, #5E6C84)",
    'color.border.disabled': "var(--ds-border-disabled, #FAFBFC)",
    'color.border.focused': "var(--ds-border-focused, #2684FF)",
    'color.border.input': "var(--ds-border-input, #FAFBFC)",
    'color.border.inverse': "var(--ds-border-inverse, #FFFFFF)",
    'color.border.selected': "var(--ds-border-selected, #0052CC)",
    'color.border.brand': "var(--ds-border-brand, #0052CC)",
    'color.border.danger': "var(--ds-border-danger, #FF5630)",
    'color.border.warning': "var(--ds-border-warning, #FFC400)",
    'color.border.success': "var(--ds-border-success, #00875A)",
    'color.border.discovery': "var(--ds-border-discovery, #998DD9)",
    'color.border.information': "var(--ds-border-information, #0065FF)",
    'color.border.bold': "var(--ds-border-bold, #344563)"
};
var $f8e1dffa19542231$export$d1d79bf68ac056bd = {
    'color.background.accent.lime.subtlest': "var(--ds-background-accent-lime-subtlest, #EEFBDA)",
    'color.background.accent.lime.subtlest.hovered': "var(--ds-background-accent-lime-subtlest-hovered, #D3F1A7)",
    'color.background.accent.lime.subtlest.pressed': "var(--ds-background-accent-lime-subtlest-pressed, #B3DF72)",
    'color.background.accent.lime.subtler': "var(--ds-background-accent-lime-subtler, #D3F1A7)",
    'color.background.accent.lime.subtler.hovered': "var(--ds-background-accent-lime-subtler-hovered, #B3DF72)",
    'color.background.accent.lime.subtler.pressed': "var(--ds-background-accent-lime-subtler-pressed, #94C748)",
    'color.background.accent.lime.subtle': "var(--ds-background-accent-lime-subtle, #94C748)",
    'color.background.accent.lime.subtle.hovered': "var(--ds-background-accent-lime-subtle-hovered, #B3DF72)",
    'color.background.accent.lime.subtle.pressed': "var(--ds-background-accent-lime-subtle-pressed, #D3F1A7)",
    'color.background.accent.lime.bolder': "var(--ds-background-accent-lime-bolder, #5B7F24)",
    'color.background.accent.lime.bolder.hovered': "var(--ds-background-accent-lime-bolder-hovered, #37471F)",
    'color.background.accent.lime.bolder.pressed': "var(--ds-background-accent-lime-bolder-pressed, #37471F)",
    'color.background.accent.red.subtlest': "var(--ds-background-accent-red-subtlest, #FF8F73)",
    'color.background.accent.red.subtlest.hovered': "var(--ds-background-accent-red-subtlest-hovered, #FF7452)",
    'color.background.accent.red.subtlest.pressed': "var(--ds-background-accent-red-subtlest-pressed, #FF5630)",
    'color.background.accent.red.subtler': "var(--ds-background-accent-red-subtler, #FF7452)",
    'color.background.accent.red.subtler.hovered': "var(--ds-background-accent-red-subtler-hovered, #FF5630)",
    'color.background.accent.red.subtler.pressed': "var(--ds-background-accent-red-subtler-pressed, #DE350B)",
    'color.background.accent.red.subtle': "var(--ds-background-accent-red-subtle, #DE350B)",
    'color.background.accent.red.subtle.hovered': "var(--ds-background-accent-red-subtle-hovered, #FF5630)",
    'color.background.accent.red.subtle.pressed': "var(--ds-background-accent-red-subtle-pressed, #FF7452)",
    'color.background.accent.red.bolder': "var(--ds-background-accent-red-bolder, #DE350B)",
    'color.background.accent.red.bolder.hovered': "var(--ds-background-accent-red-bolder-hovered, #FF5630)",
    'color.background.accent.red.bolder.pressed': "var(--ds-background-accent-red-bolder-pressed, #FF7452)",
    'color.background.accent.orange.subtlest': "var(--ds-background-accent-orange-subtlest, #F18D13)",
    'color.background.accent.orange.subtlest.hovered': "var(--ds-background-accent-orange-subtlest-hovered, #FEC57B)",
    'color.background.accent.orange.subtlest.pressed': "var(--ds-background-accent-orange-subtlest-pressed, #FFE2BD)",
    'color.background.accent.orange.subtler': "var(--ds-background-accent-orange-subtler, #B65C02)",
    'color.background.accent.orange.subtler.hovered': "var(--ds-background-accent-orange-subtler-hovered, #F18D13)",
    'color.background.accent.orange.subtler.pressed': "var(--ds-background-accent-orange-subtler-pressed, #FEC57B)",
    'color.background.accent.orange.subtle': "var(--ds-background-accent-orange-subtle, #5F3811)",
    'color.background.accent.orange.subtle.hovered': "var(--ds-background-accent-orange-subtle-hovered, #974F0C)",
    'color.background.accent.orange.subtle.pressed': "var(--ds-background-accent-orange-subtle-pressed, #B65C02)",
    'color.background.accent.orange.bolder': "var(--ds-background-accent-orange-bolder, #43290F)",
    'color.background.accent.orange.bolder.hovered': "var(--ds-background-accent-orange-bolder-hovered, #5F3811)",
    'color.background.accent.orange.bolder.pressed': "var(--ds-background-accent-orange-bolder-pressed, #974F0C)",
    'color.background.accent.yellow.subtlest': "var(--ds-background-accent-yellow-subtlest, #FFE380)",
    'color.background.accent.yellow.subtlest.hovered': "var(--ds-background-accent-yellow-subtlest-hovered, #FFC400)",
    'color.background.accent.yellow.subtlest.pressed': "var(--ds-background-accent-yellow-subtlest-pressed, #FFAB00)",
    'color.background.accent.yellow.subtler': "var(--ds-background-accent-yellow-subtler, #FFC400)",
    'color.background.accent.yellow.subtler.hovered': "var(--ds-background-accent-yellow-subtler-hovered, #FFAB00)",
    'color.background.accent.yellow.subtler.pressed': "var(--ds-background-accent-yellow-subtler-pressed, #FF991F)",
    'color.background.accent.yellow.subtle': "var(--ds-background-accent-yellow-subtle, #FF991F)",
    'color.background.accent.yellow.subtle.hovered': "var(--ds-background-accent-yellow-subtle-hovered, #FFAB00)",
    'color.background.accent.yellow.subtle.pressed': "var(--ds-background-accent-yellow-subtle-pressed, #FFC400)",
    'color.background.accent.yellow.bolder': "var(--ds-background-accent-yellow-bolder, #FF991F)",
    'color.background.accent.yellow.bolder.hovered': "var(--ds-background-accent-yellow-bolder-hovered, #FFAB00)",
    'color.background.accent.yellow.bolder.pressed': "var(--ds-background-accent-yellow-bolder-pressed, #FFC400)",
    'color.background.accent.green.subtlest': "var(--ds-background-accent-green-subtlest, #79F2C0)",
    'color.background.accent.green.subtlest.hovered': "var(--ds-background-accent-green-subtlest-hovered, #57D9A3)",
    'color.background.accent.green.subtlest.pressed': "var(--ds-background-accent-green-subtlest-pressed, #36B37E)",
    'color.background.accent.green.subtler': "var(--ds-background-accent-green-subtler, #57D9A3)",
    'color.background.accent.green.subtler.hovered': "var(--ds-background-accent-green-subtler-hovered, #36B37E)",
    'color.background.accent.green.subtler.pressed': "var(--ds-background-accent-green-subtler-pressed, #00875A)",
    'color.background.accent.green.subtle': "var(--ds-background-accent-green-subtle, #00875A)",
    'color.background.accent.green.subtle.hovered': "var(--ds-background-accent-green-subtle-hovered, #36B37E)",
    'color.background.accent.green.subtle.pressed': "var(--ds-background-accent-green-subtle-pressed, #57D9A3)",
    'color.background.accent.green.bolder': "var(--ds-background-accent-green-bolder, #00875A)",
    'color.background.accent.green.bolder.hovered': "var(--ds-background-accent-green-bolder-hovered, #36B37E)",
    'color.background.accent.green.bolder.pressed': "var(--ds-background-accent-green-bolder-pressed, #57D9A3)",
    'color.background.accent.teal.subtlest': "var(--ds-background-accent-teal-subtlest, #79E2F2)",
    'color.background.accent.teal.subtlest.hovered': "var(--ds-background-accent-teal-subtlest-hovered, #00C7E6)",
    'color.background.accent.teal.subtlest.pressed': "var(--ds-background-accent-teal-subtlest-pressed, #00B8D9)",
    'color.background.accent.teal.subtler': "var(--ds-background-accent-teal-subtler, #00C7E6)",
    'color.background.accent.teal.subtler.hovered': "var(--ds-background-accent-teal-subtler-hovered, #00B8D9)",
    'color.background.accent.teal.subtler.pressed': "var(--ds-background-accent-teal-subtler-pressed, #00A3BF)",
    'color.background.accent.teal.subtle': "var(--ds-background-accent-teal-subtle, #00A3BF)",
    'color.background.accent.teal.subtle.hovered': "var(--ds-background-accent-teal-subtle-hovered, #00B8D9)",
    'color.background.accent.teal.subtle.pressed': "var(--ds-background-accent-teal-subtle-pressed, #00C7E6)",
    'color.background.accent.teal.bolder': "var(--ds-background-accent-teal-bolder, #00A3BF)",
    'color.background.accent.teal.bolder.hovered': "var(--ds-background-accent-teal-bolder-hovered, #00B8D9)",
    'color.background.accent.teal.bolder.pressed': "var(--ds-background-accent-teal-bolder-pressed, #00C7E6)",
    'color.background.accent.blue.subtlest': "var(--ds-background-accent-blue-subtlest, #4C9AFF)",
    'color.background.accent.blue.subtlest.hovered': "var(--ds-background-accent-blue-subtlest-hovered, #2684FF)",
    'color.background.accent.blue.subtlest.pressed': "var(--ds-background-accent-blue-subtlest-pressed, #0065FF)",
    'color.background.accent.blue.subtler': "var(--ds-background-accent-blue-subtler, #2684FF)",
    'color.background.accent.blue.subtler.hovered': "var(--ds-background-accent-blue-subtler-hovered, #0065FF)",
    'color.background.accent.blue.subtler.pressed': "var(--ds-background-accent-blue-subtler-pressed, #0052CC)",
    'color.background.accent.blue.subtle': "var(--ds-background-accent-blue-subtle, #0052CC)",
    'color.background.accent.blue.subtle.hovered': "var(--ds-background-accent-blue-subtle-hovered, #0065FF)",
    'color.background.accent.blue.subtle.pressed': "var(--ds-background-accent-blue-subtle-pressed, #2684FF)",
    'color.background.accent.blue.bolder': "var(--ds-background-accent-blue-bolder, #0052CC)",
    'color.background.accent.blue.bolder.hovered': "var(--ds-background-accent-blue-bolder-hovered, #0065FF)",
    'color.background.accent.blue.bolder.pressed': "var(--ds-background-accent-blue-bolder-pressed, #2684FF)",
    'color.background.accent.purple.subtlest': "var(--ds-background-accent-purple-subtlest, #998DD9)",
    'color.background.accent.purple.subtlest.hovered': "var(--ds-background-accent-purple-subtlest-hovered, #8777D9)",
    'color.background.accent.purple.subtlest.pressed': "var(--ds-background-accent-purple-subtlest-pressed, #6554C0)",
    'color.background.accent.purple.subtler': "var(--ds-background-accent-purple-subtler, #8777D9)",
    'color.background.accent.purple.subtler.hovered': "var(--ds-background-accent-purple-subtler-hovered, #6554C0)",
    'color.background.accent.purple.subtler.pressed': "var(--ds-background-accent-purple-subtler-pressed, #5243AA)",
    'color.background.accent.purple.subtle': "var(--ds-background-accent-purple-subtle, #5243AA)",
    'color.background.accent.purple.subtle.hovered': "var(--ds-background-accent-purple-subtle-hovered, #6554C0)",
    'color.background.accent.purple.subtle.pressed': "var(--ds-background-accent-purple-subtle-pressed, #8777D9)",
    'color.background.accent.purple.bolder': "var(--ds-background-accent-purple-bolder, #5243AA)",
    'color.background.accent.purple.bolder.hovered': "var(--ds-background-accent-purple-bolder-hovered, #6554C0)",
    'color.background.accent.purple.bolder.pressed': "var(--ds-background-accent-purple-bolder-pressed, #8777D9)",
    'color.background.accent.magenta.subtlest': "var(--ds-background-accent-magenta-subtlest, #FFECF8)",
    'color.background.accent.magenta.subtlest.hovered': "var(--ds-background-accent-magenta-subtlest-hovered, #FDD0EC)",
    'color.background.accent.magenta.subtlest.pressed': "var(--ds-background-accent-magenta-subtlest-pressed, #F797D2)",
    'color.background.accent.magenta.subtler': "var(--ds-background-accent-magenta-subtler, #FDD0EC)",
    'color.background.accent.magenta.subtler.hovered': "var(--ds-background-accent-magenta-subtler-hovered, #F797D2)",
    'color.background.accent.magenta.subtler.pressed': "var(--ds-background-accent-magenta-subtler-pressed, #E774BB)",
    'color.background.accent.magenta.subtle': "var(--ds-background-accent-magenta-subtle, #E774BB)",
    'color.background.accent.magenta.subtle.hovered': "var(--ds-background-accent-magenta-subtle-hovered, #F797D2)",
    'color.background.accent.magenta.subtle.pressed': "var(--ds-background-accent-magenta-subtle-pressed, #FDD0EC)",
    'color.background.accent.magenta.bolder': "var(--ds-background-accent-magenta-bolder, #AE4787)",
    'color.background.accent.magenta.bolder.hovered': "var(--ds-background-accent-magenta-bolder-hovered, #943D73)",
    'color.background.accent.magenta.bolder.pressed': "var(--ds-background-accent-magenta-bolder-pressed, #50253F)",
    'color.background.accent.gray.subtlest': "var(--ds-background-accent-gray-subtlest, #6B778C)",
    'color.background.accent.gray.subtlest.hovered': "var(--ds-background-accent-gray-subtlest-hovered, #5E6C84)",
    'color.background.accent.gray.subtlest.pressed': "var(--ds-background-accent-gray-subtlest-pressed, #505F79)",
    'color.background.accent.gray.subtler': "var(--ds-background-accent-gray-subtler, #5E6C84)",
    'color.background.accent.gray.subtler.hovered': "var(--ds-background-accent-gray-subtler-hovered, #505F79)",
    'color.background.accent.gray.subtler.pressed': "var(--ds-background-accent-gray-subtler-pressed, #42526E)",
    'color.background.accent.gray.subtle': "var(--ds-background-accent-gray-subtle, #505F79)",
    'color.background.accent.gray.subtle.hovered': "var(--ds-background-accent-gray-subtle-hovered, #5E6C84)",
    'color.background.accent.gray.subtle.pressed': "var(--ds-background-accent-gray-subtle-pressed, #6B778C)",
    'color.background.accent.gray.bolder': "var(--ds-background-accent-gray-bolder, #42526E)",
    'color.background.accent.gray.bolder.hovered': "var(--ds-background-accent-gray-bolder-hovered, #344563)",
    'color.background.accent.gray.bolder.pressed': "var(--ds-background-accent-gray-bolder-pressed, #253858)",
    'color.background.disabled': "var(--ds-background-disabled, #091e4289)",
    'color.background.input': "var(--ds-background-input, #FAFBFC)",
    'color.background.input.hovered': "var(--ds-background-input-hovered, #EBECF0)",
    'color.background.input.pressed': "var(--ds-background-input-pressed, #FFFFFF)",
    'color.background.inverse.subtle': "var(--ds-background-inverse-subtle, #00000029)",
    'color.background.inverse.subtle.hovered': "var(--ds-background-inverse-subtle-hovered, #0000003D)",
    'color.background.inverse.subtle.pressed': "var(--ds-background-inverse-subtle-pressed, #00000052)",
    'color.background.neutral': "var(--ds-background-neutral, #DFE1E6)",
    'color.background.neutral.hovered': "var(--ds-background-neutral-hovered, #091e4214)",
    'color.background.neutral.pressed': "var(--ds-background-neutral-pressed, #B3D4FF)",
    'color.background.neutral.subtle': "var(--ds-background-neutral-subtle, transparent)",
    'color.background.neutral.subtle.hovered': "var(--ds-background-neutral-subtle-hovered, #091e4214)",
    'color.background.neutral.subtle.pressed': "var(--ds-background-neutral-subtle-pressed, #B3D4FF)",
    'color.background.neutral.bold': "var(--ds-background-neutral-bold, #42526E)",
    'color.background.neutral.bold.hovered': "var(--ds-background-neutral-bold-hovered, #505F79)",
    'color.background.neutral.bold.pressed': "var(--ds-background-neutral-bold-pressed, #344563)",
    'color.background.selected': "var(--ds-background-selected, #DEEBFF)",
    'color.background.selected.hovered': "var(--ds-background-selected-hovered, #B3D4FF)",
    'color.background.selected.pressed': "var(--ds-background-selected-pressed, #4C9AFF)",
    'color.background.selected.bold': "var(--ds-background-selected-bold, #0052CC)",
    'color.background.selected.bold.hovered': "var(--ds-background-selected-bold-hovered, #2684FF)",
    'color.background.selected.bold.pressed': "var(--ds-background-selected-bold-pressed, #0052CC)",
    'color.background.brand.subtlest': "var(--ds-background-brand-subtlest, #B3D4FF)",
    'color.background.brand.subtlest.hovered': "var(--ds-background-brand-subtlest-hovered, #DEEBFF)",
    'color.background.brand.subtlest.pressed': "var(--ds-background-brand-subtlest-pressed, #4C9AFF)",
    'color.background.brand.bold': "var(--ds-background-brand-bold, #0052CC)",
    'color.background.brand.bold.hovered': "var(--ds-background-brand-bold-hovered, #0065FF)",
    'color.background.brand.bold.pressed': "var(--ds-background-brand-bold-pressed, #0747A6)",
    'color.background.brand.boldest': "var(--ds-background-brand-boldest, #0747A6)",
    'color.background.brand.boldest.hovered': "var(--ds-background-brand-boldest-hovered, #0052CC)",
    'color.background.brand.boldest.pressed': "var(--ds-background-brand-boldest-pressed, #0747A6)",
    'color.background.danger': "var(--ds-background-danger, #FFEBE6)",
    'color.background.danger.hovered': "var(--ds-background-danger-hovered, #FFBDAD)",
    'color.background.danger.pressed': "var(--ds-background-danger-pressed, #FF8F73)",
    'color.background.danger.bold': "var(--ds-background-danger-bold, #DE350B)",
    'color.background.danger.bold.hovered': "var(--ds-background-danger-bold-hovered, #FF5630)",
    'color.background.danger.bold.pressed': "var(--ds-background-danger-bold-pressed, #BF2600)",
    'color.background.warning': "var(--ds-background-warning, #FFFAE6)",
    'color.background.warning.hovered': "var(--ds-background-warning-hovered, #FFF0B3)",
    'color.background.warning.pressed': "var(--ds-background-warning-pressed, #FFE380)",
    'color.background.warning.bold': "var(--ds-background-warning-bold, #FFAB00)",
    'color.background.warning.bold.hovered': "var(--ds-background-warning-bold-hovered, #FFC400)",
    'color.background.warning.bold.pressed': "var(--ds-background-warning-bold-pressed, #FF991F)",
    'color.background.success': "var(--ds-background-success, #E3FCEF)",
    'color.background.success.hovered': "var(--ds-background-success-hovered, #ABF5D1)",
    'color.background.success.pressed': "var(--ds-background-success-pressed, #79F2C0)",
    'color.background.success.bold': "var(--ds-background-success-bold, #00875A)",
    'color.background.success.bold.hovered': "var(--ds-background-success-bold-hovered, #57D9A3)",
    'color.background.success.bold.pressed': "var(--ds-background-success-bold-pressed, #00875A)",
    'color.background.discovery': "var(--ds-background-discovery, #EAE6FF)",
    'color.background.discovery.hovered': "var(--ds-background-discovery-hovered, #C0B6F2)",
    'color.background.discovery.pressed': "var(--ds-background-discovery-pressed, #998DD9)",
    'color.background.discovery.bold': "var(--ds-background-discovery-bold, #5243AA)",
    'color.background.discovery.bold.hovered': "var(--ds-background-discovery-bold-hovered, #8777D9)",
    'color.background.discovery.bold.pressed': "var(--ds-background-discovery-bold-pressed, #5243AA)",
    'color.background.information': "var(--ds-background-information, #DEEBFF)",
    'color.background.information.hovered': "var(--ds-background-information-hovered, #B3D4FF)",
    'color.background.information.pressed': "var(--ds-background-information-pressed, #4C9AFF)",
    'color.background.information.bold': "var(--ds-background-information-bold, #0052CC)",
    'color.background.information.bold.hovered': "var(--ds-background-information-bold-hovered, #2684FF)",
    'color.background.information.bold.pressed': "var(--ds-background-information-bold-pressed, #0052CC)",
    'color.blanket': "var(--ds-blanket, #091e4289)",
    'color.blanket.selected': "var(--ds-blanket-selected, #388BFF14)",
    'color.blanket.danger': "var(--ds-blanket-danger, #EF5C4814)",
    'color.skeleton': "var(--ds-skeleton, #F4F5F7)",
    'color.skeleton.subtle': "var(--ds-skeleton-subtle, #091e420a)",
    'elevation.surface': "var(--ds-surface, #FFFFFF)",
    'elevation.surface.hovered': "var(--ds-surface-hovered, #FAFBFC)",
    'elevation.surface.pressed': "var(--ds-surface-pressed, #F4F5F7)",
    'elevation.surface.overlay': "var(--ds-surface-overlay, #FFFFFF)",
    'elevation.surface.overlay.hovered': "var(--ds-surface-overlay-hovered, #FAFBFC)",
    'elevation.surface.overlay.pressed': "var(--ds-surface-overlay-pressed, #F4F5F7)",
    'elevation.surface.raised': "var(--ds-surface-raised, #FFFFFF)",
    'elevation.surface.raised.hovered': "var(--ds-surface-raised-hovered, #FAFBFC)",
    'elevation.surface.raised.pressed': "var(--ds-surface-raised-pressed, #F4F5F7)",
    'elevation.surface.sunken': "var(--ds-surface-sunken, #F4F5F7)",
    'utility.elevation.surface.current': "var(--ds-elevation-surface-current, #FFFFFF)"
};
var $f8e1dffa19542231$export$8473307aa00d6ea1 = {
    'color.text': "var(--ds-text, #172B4D)",
    'color.text.accent.lime': "var(--ds-text-accent-lime, #4C6B1F)",
    'color.text.accent.lime.bolder': "var(--ds-text-accent-lime-bolder, #37471F)",
    'color.text.accent.red': "var(--ds-text-accent-red, #DE350B)",
    'color.text.accent.red.bolder': "var(--ds-text-accent-red-bolder, #BF2600)",
    'color.text.accent.orange': "var(--ds-text-accent-orange, #F18D13)",
    'color.text.accent.orange.bolder': "var(--ds-text-accent-orange-bolder, #B65C02)",
    'color.text.accent.yellow': "var(--ds-text-accent-yellow, #FF991F)",
    'color.text.accent.yellow.bolder': "var(--ds-text-accent-yellow-bolder, #FF8B00)",
    'color.text.accent.green': "var(--ds-text-accent-green, #00875A)",
    'color.text.accent.green.bolder': "var(--ds-text-accent-green-bolder, #006644)",
    'color.text.accent.teal': "var(--ds-text-accent-teal, #00A3BF)",
    'color.text.accent.teal.bolder': "var(--ds-text-accent-teal-bolder, #008DA6)",
    'color.text.accent.blue': "var(--ds-text-accent-blue, #0052CC)",
    'color.text.accent.blue.bolder': "var(--ds-text-accent-blue-bolder, #0747A6)",
    'color.text.accent.purple': "var(--ds-text-accent-purple, #5243AA)",
    'color.text.accent.purple.bolder': "var(--ds-text-accent-purple-bolder, #403294)",
    'color.text.accent.magenta': "var(--ds-text-accent-magenta, #E774BB)",
    'color.text.accent.magenta.bolder': "var(--ds-text-accent-magenta-bolder, #DA62AC)",
    'color.text.accent.gray': "var(--ds-text-accent-gray, #505F79)",
    'color.text.accent.gray.bolder': "var(--ds-text-accent-gray-bolder, #172B4D)",
    'color.text.disabled': "var(--ds-text-disabled, #A5ADBA)",
    'color.text.inverse': "var(--ds-text-inverse, #FFFFFF)",
    'color.text.selected': "var(--ds-text-selected, #0052CC)",
    'color.text.brand': "var(--ds-text-brand, #0065FF)",
    'color.text.danger': "var(--ds-text-danger, #DE350B)",
    'color.text.warning': "var(--ds-text-warning, #974F0C)",
    'color.text.warning.inverse': "var(--ds-text-warning-inverse, #172B4D)",
    'color.text.success': "var(--ds-text-success, #006644)",
    'color.text.discovery': "var(--ds-text-discovery, #403294)",
    'color.text.information': "var(--ds-text-information, #0052CC)",
    'color.text.subtlest': "var(--ds-text-subtlest, #7A869A)",
    'color.text.subtle': "var(--ds-text-subtle, #42526E)",
    'color.link': "var(--ds-link, #0052CC)",
    'color.link.pressed': "var(--ds-link-pressed, #0747A6)",
    'color.link.visited': "var(--ds-link-visited, #403294)",
    'color.link.visited.pressed': "var(--ds-link-visited-pressed, #403294)"
};
var $f8e1dffa19542231$export$498780f74be9af68 = {
    'color.icon': "var(--ds-icon, #505F79)",
    'color.icon.accent.lime': "var(--ds-icon-accent-lime, #6A9A23)",
    'color.icon.accent.red': "var(--ds-icon-accent-red, #FF5630)",
    'color.icon.accent.orange': "var(--ds-icon-accent-orange, #D94008)",
    'color.icon.accent.yellow': "var(--ds-icon-accent-yellow, #FFAB00)",
    'color.icon.accent.green': "var(--ds-icon-accent-green, #36B37E)",
    'color.icon.accent.teal': "var(--ds-icon-accent-teal, #00B8D9)",
    'color.icon.accent.blue': "var(--ds-icon-accent-blue, #0065FF)",
    'color.icon.accent.purple': "var(--ds-icon-accent-purple, #6554C0)",
    'color.icon.accent.magenta': "var(--ds-icon-accent-magenta, #CD519D)",
    'color.icon.accent.gray': "var(--ds-icon-accent-gray, #5E6C84)",
    'color.icon.disabled': "var(--ds-icon-disabled, #8993A4)",
    'color.icon.inverse': "var(--ds-icon-inverse, #FFFFFF)",
    'color.icon.selected': "var(--ds-icon-selected, #0052CC)",
    'color.icon.brand': "var(--ds-icon-brand, #0065FF)",
    'color.icon.danger': "var(--ds-icon-danger, #DE350B)",
    'color.icon.warning': "var(--ds-icon-warning, #FFC400)",
    'color.icon.warning.inverse': "var(--ds-icon-warning-inverse, #253858)",
    'color.icon.success': "var(--ds-icon-success, #00875A)",
    'color.icon.discovery': "var(--ds-icon-discovery, #8777D9)",
    'color.icon.information': "var(--ds-icon-information, #0747A6)",
    'color.icon.subtlest': "var(--ds-icon-subtlest, #6B778C)",
    'color.icon.subtle': "var(--ds-icon-subtle, #6B778C)"
};
var $f8e1dffa19542231$export$b5f31a7e431d2eab = {
    '1': 1,
    card: 100,
    navigation: 200,
    dialog: 300,
    layer: 400,
    blanket: 500,
    modal: 510,
    flag: 600,
    spotlight: 700,
    tooltip: 800
};
var $f8e1dffa19542231$export$e1b83c5210c471b8 = {
    'border.width': "var(--ds-border-width, 1px)",
    // @deprecated
    'border.width.0': "var(--ds-border-width-0, 0px)",
    // @deprecated
    'border.width.indicator': "var(--ds-border-width-indicator, 3px)",
    // @deprecated
    'border.width.outline': "var(--ds-border-width-outline, 2px)",
    'border.width.selected': "var(--ds-border-width-selected, 2px)",
    'border.width.focused': "var(--ds-border-width-focused, 2px)"
};
var $f8e1dffa19542231$export$3c0a6c3e64bb180d = {
    'radius.xsmall': "var(--ds-radius-xsmall, 2px)",
    'radius.small': "var(--ds-radius-small, 3px)",
    'radius.medium': "var(--ds-radius-medium, 6px)",
    'radius.large': "var(--ds-radius-large, 8px)",
    'radius.xlarge': "var(--ds-radius-xlarge, 12px)",
    'radius.full': "var(--ds-radius-full, 9999px)",
    'radius.tile': "var(--ds-radius-tile, 25%)",
    // @deprecated
    'border.radius': "var(--ds-border-radius, 3px)",
    // @deprecated
    'border.radius.050': "var(--ds-border-radius-050, 2px)",
    // @deprecated
    'border.radius.100': "var(--ds-border-radius-100, 3px)",
    // @deprecated
    'border.radius.200': "var(--ds-border-radius-200, 8px)",
    // @deprecated
    'border.radius.300': "var(--ds-border-radius-300, 12px)",
    // @deprecated
    'border.radius.400': "var(--ds-border-radius-400, 16px)",
    // @deprecated
    'border.radius.circle': "var(--ds-border-radius-circle, 9999px)"
};
var $f8e1dffa19542231$export$6ffa317d5e70375 = {
    'font.body': "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.body.UNSAFE_small': "var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.body.large': "var(--ds-font-body-large, normal 400 16px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.body.small': "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.code': "var(--ds-font-code, normal 400 0.875em/1 ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)",
    'font.heading.large': "var(--ds-font-heading-large, normal 500 24px/28px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.heading.medium': "var(--ds-font-heading-medium, normal 500 20px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.heading.small': "var(--ds-font-heading-small, normal 600 16px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.heading.xlarge': "var(--ds-font-heading-xlarge, normal 600 29px/32px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.heading.xsmall': "var(--ds-font-heading-xsmall, normal 600 14px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.heading.xxlarge': "var(--ds-font-heading-xxlarge, normal 500 35px/40px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.heading.xxsmall': "var(--ds-font-heading-xxsmall, normal 600 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.metric.large': "var(--ds-font-metric-large, normal 653 28px/32px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.metric.medium': "var(--ds-font-metric-medium, normal 653 24px/28px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.metric.small': "var(--ds-font-metric-small, normal 653 16px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
};
var $f8e1dffa19542231$export$303e322c6b1ed114 = {
    'font.weight.bold': "var(--ds-font-weight-bold, 700)",
    'font.weight.medium': "var(--ds-font-weight-medium, 500)",
    'font.weight.regular': "var(--ds-font-weight-regular, 400)",
    'font.weight.semibold': "var(--ds-font-weight-semibold, 600)"
};
var $f8e1dffa19542231$export$3c7e9587132614b4 = {
    'font.family.body': "var(--ds-font-family-body, ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.family.brand.body': "var(--ds-font-family-brand-body, \"Charlie Text\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.family.brand.heading': "var(--ds-font-family-brand-heading, \"Charlie Display\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.family.code': "var(--ds-font-family-code, ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)",
    'font.family.heading': "var(--ds-font-family-heading, ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
};
var $f8e1dffa19542231$export$236bfe3a33ef1292 = {
    medium: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    UNSAFE_small: "var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    large: "var(--ds-font-body-large, normal 400 16px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    small: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
};
var $f8e1dffa19542231$export$855cfd311192d666 = {
    bold: "var(--ds-font-weight-bold, 700)",
    medium: "var(--ds-font-weight-medium, 500)",
    regular: "var(--ds-font-weight-regular, 400)",
    semibold: "var(--ds-font-weight-semibold, 600)"
};
var $f8e1dffa19542231$export$b805719bc8cb376 = {
    large: "var(--ds-font-metric-large, normal 653 28px/32px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    medium: "var(--ds-font-metric-medium, normal 653 24px/28px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    small: "var(--ds-font-metric-small, normal 653 16px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
};
/**
 * @codegenEnd
 */ // Margin needs some bespoke types: https://atlassian.slack.com/archives/CKRHB23K8/p1712623192772909
// Generate maps for Box props. backgroundColor, padding, etc
var $f8e1dffa19542231$var$spacingProperties = [
    // Used by Box
    'padding',
    'paddingBlock',
    'paddingBlockStart',
    'paddingBlockEnd',
    'paddingInline',
    'paddingInlineStart',
    'paddingInlineEnd',
    // Used by Inline and Stack
    'gap',
    'rowGap',
    'columnGap'
];
var $f8e1dffa19542231$export$ca0f9c2de39ffed7 = function getSerializedStylesMap(cssProperty, tokenMap) {
    return Object.keys(tokenMap).reduce(function(emotionSpacingMap, token) {
        // eslint-disable-next-line @repo/internal/styles/no-exported-styles
        emotionSpacingMap[token] = (0, $74Zh5.css)((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, cssProperty, tokenMap[token]));
        return emotionSpacingMap;
    }, {});
};
var $f8e1dffa19542231$export$e615f061ca585a6c = $f8e1dffa19542231$var$spacingProperties.reduce(function(styleMap, spacingProperty) {
    styleMap[spacingProperty] = $f8e1dffa19542231$export$ca0f9c2de39ffed7(spacingProperty, $f8e1dffa19542231$export$958d0ae7f2977ae4);
    return styleMap;
}, {});
var $f8e1dffa19542231$export$bf46c3f9eeafc71f = $f8e1dffa19542231$var$spacingProperties.reduce(function(styleMap, spacingProperty) {
    styleMap[spacingProperty] = $f8e1dffa19542231$export$ca0f9c2de39ffed7(spacingProperty, $f8e1dffa19542231$export$958d0ae7f2977ae4);
    return styleMap;
}, {});
var $f8e1dffa19542231$export$e7af83bafe7f9e63 = $f8e1dffa19542231$export$ca0f9c2de39ffed7('backgroundColor', $f8e1dffa19542231$export$d1d79bf68ac056bd);
var $f8e1dffa19542231$export$3a1bcba60b23d7f0 = $f8e1dffa19542231$export$ca0f9c2de39ffed7('color', $f8e1dffa19542231$export$8473307aa00d6ea1);
var $f8e1dffa19542231$export$45f3f4fe16f9f7d5 = $f8e1dffa19542231$export$ca0f9c2de39ffed7('fontWeight', $f8e1dffa19542231$export$303e322c6b1ed114);
var $f8e1dffa19542231$export$68cc305da27dbaa4 = $f8e1dffa19542231$export$ca0f9c2de39ffed7('fontFamily', $f8e1dffa19542231$export$3c7e9587132614b4);
var $f8e1dffa19542231$export$128f10c238242f83 = $f8e1dffa19542231$export$ca0f9c2de39ffed7('font', $f8e1dffa19542231$export$6ffa317d5e70375);
var $f8e1dffa19542231$export$219d364c0da35ae4 = $f8e1dffa19542231$export$ca0f9c2de39ffed7('font', $f8e1dffa19542231$export$236bfe3a33ef1292);
var $f8e1dffa19542231$export$38845ca010b93505 = $f8e1dffa19542231$export$ca0f9c2de39ffed7('fontWeight', $f8e1dffa19542231$export$855cfd311192d666);
var $f8e1dffa19542231$export$ff257d957d48c421 = $f8e1dffa19542231$export$ca0f9c2de39ffed7((0, $4EY2U.CURRENT_SURFACE_CSS_VAR), $f8e1dffa19542231$export$41a358c9c2356760);
var $f8e1dffa19542231$export$5e65a44e5b6ecadb = function isSurfaceColorToken(color) {
    return $f8e1dffa19542231$export$41a358c9c2356760[color] !== undefined;
};
var $f8e1dffa19542231$export$7001ce64d9ff7c7f = $f8e1dffa19542231$export$ca0f9c2de39ffed7('font', $f8e1dffa19542231$export$b805719bc8cb376);

});
parcelRegister("4EY2U", function(module, exports) {
$parcel$export(module.exports, "CURRENT_SURFACE_CSS_VAR", () => $364979b5125caa6f$export$9d7b58831ae93caa);
var $364979b5125caa6f$export$4ef52930e33717cd = 'data-theme';
var $364979b5125caa6f$export$a00eac3f8684bcd0 = 'data-color-mode';
var $364979b5125caa6f$export$2112803007239c61 = 'data-contrast-mode';
var $364979b5125caa6f$export$352e418ed5b6193a = 'data-custom-theme';
var $364979b5125caa6f$export$6f0c6fb8c80fcc92 = 'ds';
var $364979b5125caa6f$export$4d0c7bbf80185957 = [
    'opacity',
    'font',
    'space',
    'border',
    'radius'
];
var $364979b5125caa6f$export$dddac1532e822863 = "--".concat($364979b5125caa6f$export$6f0c6fb8c80fcc92, "-token-not-found");
var $364979b5125caa6f$export$9d7b58831ae93caa = "--".concat($364979b5125caa6f$export$6f0c6fb8c80fcc92, "-elevation-surface-current");

});


parcelRegister("e255n", function(module, exports) {
$parcel$export(module.exports, "parseXcss", () => $a37532879cf89adc$export$a9c84988c8f81f2d);
$parcel$export(module.exports, "xcss", () => $a37532879cf89adc$export$f6c783d06584602c);

var $fC8ib = parcelRequire("fC8ib");

var $25nEq = parcelRequire("25nEq");

var $iYJcE = parcelRequire("iYJcE");

var $ekGgq = parcelRequire("ekGgq");

var $74Zh5 = parcelRequire("74Zh5");

var $lmNh5 = parcelRequire("lmNh5");

var $3ZMUU = parcelRequire("3ZMUU");
function $a37532879cf89adc$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $a37532879cf89adc$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $a37532879cf89adc$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $a37532879cf89adc$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $a37532879cf89adc$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $a37532879cf89adc$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
var $a37532879cf89adc$export$9a199fbafee0014e = {
    backgroundColor: (0, $lmNh5.backgroundColorMap),
    blockSize: (0, $lmNh5.dimensionMap),
    borderBlockColor: (0, $lmNh5.borderColorMap),
    borderBlockEndColor: (0, $lmNh5.borderColorMap),
    borderBlockEndWidth: (0, $lmNh5.borderWidthMap),
    borderBlockStartColor: (0, $lmNh5.borderColorMap),
    borderBlockStartWidth: (0, $lmNh5.borderWidthMap),
    borderBlockWidth: (0, $lmNh5.borderWidthMap),
    borderBottomColor: (0, $lmNh5.borderColorMap),
    borderBottomLeftRadius: (0, $lmNh5.borderRadiusMap),
    borderBottomRightRadius: (0, $lmNh5.borderRadiusMap),
    borderBottomWidth: (0, $lmNh5.borderWidthMap),
    borderColor: (0, $lmNh5.borderColorMap),
    borderEndEndRadius: (0, $lmNh5.borderRadiusMap),
    borderEndStartRadius: (0, $lmNh5.borderRadiusMap),
    borderInlineColor: (0, $lmNh5.borderColorMap),
    borderInlineEndColor: (0, $lmNh5.borderColorMap),
    borderInlineEndWidth: (0, $lmNh5.borderWidthMap),
    borderInlineStartColor: (0, $lmNh5.borderColorMap),
    borderInlineStartWidth: (0, $lmNh5.borderWidthMap),
    borderInlineWidth: (0, $lmNh5.borderWidthMap),
    borderLeftColor: (0, $lmNh5.borderColorMap),
    borderLeftWidth: (0, $lmNh5.borderWidthMap),
    borderRadius: (0, $lmNh5.borderRadiusMap),
    borderRightColor: (0, $lmNh5.borderColorMap),
    borderRightWidth: (0, $lmNh5.borderWidthMap),
    borderStartEndRadius: (0, $lmNh5.borderRadiusMap),
    borderStartStartRadius: (0, $lmNh5.borderRadiusMap),
    borderTopColor: (0, $lmNh5.borderColorMap),
    borderTopLeftRadius: (0, $lmNh5.borderRadiusMap),
    borderTopRightRadius: (0, $lmNh5.borderRadiusMap),
    borderTopWidth: (0, $lmNh5.borderWidthMap),
    borderWidth: (0, $lmNh5.borderWidthMap),
    bottom: (0, $lmNh5.allSpaceMap),
    boxShadow: (0, $lmNh5.shadowMap),
    color: (0, $lmNh5.textColorMap),
    columnGap: (0, $lmNh5.positiveSpaceMap),
    font: (0, $lmNh5.fontMap),
    fontFamily: (0, $lmNh5.fontFamilyMap),
    fontWeight: (0, $lmNh5.fontWeightMap),
    gap: (0, $lmNh5.positiveSpaceMap),
    height: (0, $lmNh5.dimensionMap),
    inlineSize: (0, $lmNh5.dimensionMap),
    inset: (0, $lmNh5.allSpaceMap),
    insetBlock: (0, $lmNh5.allSpaceMap),
    insetBlockEnd: (0, $lmNh5.allSpaceMap),
    insetBlockStart: (0, $lmNh5.allSpaceMap),
    insetInline: (0, $lmNh5.allSpaceMap),
    insetInlineEnd: (0, $lmNh5.allSpaceMap),
    insetInlineStart: (0, $lmNh5.allSpaceMap),
    left: (0, $lmNh5.allSpaceMap),
    margin: (0, $lmNh5.allSpaceMap),
    marginBlock: (0, $lmNh5.allSpaceMap),
    marginBlockEnd: (0, $lmNh5.allSpaceMap),
    marginBlockStart: (0, $lmNh5.allSpaceMap),
    marginBottom: (0, $lmNh5.allSpaceMap),
    marginInline: (0, $lmNh5.allSpaceMap),
    marginInlineEnd: (0, $lmNh5.allSpaceMap),
    marginInlineStart: (0, $lmNh5.allSpaceMap),
    marginLeft: (0, $lmNh5.allSpaceMap),
    marginRight: (0, $lmNh5.allSpaceMap),
    marginTop: (0, $lmNh5.allSpaceMap),
    maxBlockSize: (0, $lmNh5.dimensionMap),
    maxHeight: (0, $lmNh5.dimensionMap),
    maxInlineSize: (0, $lmNh5.dimensionMap),
    maxWidth: (0, $lmNh5.dimensionMap),
    minBlockSize: (0, $lmNh5.dimensionMap),
    minHeight: (0, $lmNh5.dimensionMap),
    minInlineSize: (0, $lmNh5.dimensionMap),
    minWidth: (0, $lmNh5.dimensionMap),
    opacity: (0, $lmNh5.opacityMap),
    outlineColor: (0, $lmNh5.borderColorMap),
    outlineOffset: (0, $lmNh5.allSpaceMap),
    outlineWidth: (0, $lmNh5.borderWidthMap),
    padding: (0, $lmNh5.positiveSpaceMap),
    paddingBlock: (0, $lmNh5.positiveSpaceMap),
    paddingBlockEnd: (0, $lmNh5.positiveSpaceMap),
    paddingBlockStart: (0, $lmNh5.positiveSpaceMap),
    paddingBottom: (0, $lmNh5.positiveSpaceMap),
    paddingInline: (0, $lmNh5.positiveSpaceMap),
    paddingInlineEnd: (0, $lmNh5.positiveSpaceMap),
    paddingInlineStart: (0, $lmNh5.positiveSpaceMap),
    paddingLeft: (0, $lmNh5.positiveSpaceMap),
    paddingRight: (0, $lmNh5.positiveSpaceMap),
    paddingTop: (0, $lmNh5.positiveSpaceMap),
    right: (0, $lmNh5.allSpaceMap),
    rowGap: (0, $lmNh5.positiveSpaceMap),
    top: (0, $lmNh5.allSpaceMap),
    width: (0, $lmNh5.dimensionMap),
    zIndex: (0, $lmNh5.layerMap)
};
var $a37532879cf89adc$var$uniqueSymbol = Symbol('UNSAFE_INTERNAL_styles');
var $a37532879cf89adc$var$isSafeEnvToThrow = function isSafeEnvToThrow() {
    return (typeof $3ZMUU === "undefined" ? "undefined" : (0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))($3ZMUU)) === 'object' && (0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))($3ZMUU.env) === 'object' && false;
};
var $a37532879cf89adc$var$reNestedSelectors = /(\.|\s|&+|\*\>|#|\[.*\])/;
var $a37532879cf89adc$var$safeSelectors = /^@media .*$|^::?.*$|^@supports .*$/;
var $a37532879cf89adc$var$_transformStyles = function transformStyles(styleObj) {
    if (!styleObj || (0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(styleObj) !== 'object') return styleObj;
    // If styles are defined as a CSSObject[], recursively call on each element until we reach CSSObject
    if (Array.isArray(styleObj)) return styleObj.map($a37532879cf89adc$var$_transformStyles);
    // Modifies styleObj in place. Be careful.
    Object.entries(styleObj).forEach(function(_ref) {
        var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_ref, 2), key = _ref2[0], value = _ref2[1];
        // If key is a pseudo class or a pseudo element, then value should be an object.
        // So, call transformStyles on the value
        if ((0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(value) === 'object' && $a37532879cf89adc$var$safeSelectors.test(key)) {
            styleObj[key] = $a37532879cf89adc$var$_transformStyles(value);
            return;
        }
        if ($a37532879cf89adc$var$isSafeEnvToThrow()) {
            // We don't support `.class`, `[data-testid]`, `> *`, `#some-id`
            if ($a37532879cf89adc$var$reNestedSelectors.test(key)) throw new Error("Styles not supported for key '".concat(key, "'."));
        }
        // We have now dealt with all the special cases, so,
        // check whether what remains is a style property
        // that can be transformed.
        if (!(key in $a37532879cf89adc$export$9a199fbafee0014e)) return;
        var tokenValue = $a37532879cf89adc$export$9a199fbafee0014e[key][value];
        styleObj[key] = tokenValue !== null && tokenValue !== void 0 ? tokenValue : value;
    });
    return styleObj;
};
var $a37532879cf89adc$var$baseXcss = function baseXcss(style) {
    var transformedStyles = $a37532879cf89adc$var$_transformStyles(style);
    return (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, $a37532879cf89adc$var$uniqueSymbol, (0, $74Zh5.css)(transformedStyles));
};
/**
 * Picks out runtime XCSS objects and build-time XCSS strings. This is needed
 * to supported both Emotion and Compiled styles until we've fully migrated
 * to Compiled.
 *
 * @private
 * @deprecated
 */ var $a37532879cf89adc$export$a9c84988c8f81f2d = function parseXcss(args) {
    if (Array.isArray(args)) {
        var emotion = [];
        var staticArr = [];
        var _iterator = $a37532879cf89adc$var$_createForOfIteratorHelper(args), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var arg = _step.value;
                var result = $a37532879cf89adc$export$a9c84988c8f81f2d(arg);
                if (result.emotion) emotion.push.apply(emotion, (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(result.emotion));
                if (result.static) staticArr.push(result.static);
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
        return {
            emotion: emotion,
            static: staticArr.join(' ')
        };
    }
    var objArgs = args;
    var _ref4 = objArgs || {}, styles = _ref4[$a37532879cf89adc$var$uniqueSymbol];
    if (styles) return {
        emotion: [
            styles
        ]
    };
    if (args) {
        // We use string interpolation here instead of .toString() just
        // in case the resulting object doesn't have the method available.
        var stringifiedArgs = "".concat(args);
        if (stringifiedArgs) return {
            static: stringifiedArgs
        };
    }
    return {};
};
function $a37532879cf89adc$export$f6c783d06584602c(style) {
    return $a37532879cf89adc$var$baseXcss(style);
}

});


parcelRegister("aDxXf", function(module, exports) {
$parcel$export(module.exports, "default", () => $7be7e28e6f379df4$export$2e2bcd8739ae039);

var $fC8ib = parcelRequire("fC8ib");

var $25nEq = parcelRequire("25nEq");

var $5FkrB = parcelRequire("5FkrB");

var $74Zh5 = parcelRequire("74Zh5");

var $lmNh5 = parcelRequire("lmNh5");

var $e255n = parcelRequire("e255n");
var $7be7e28e6f379df4$var$gridTemplateAreasVar = '--ds-grid--grid-template-areas';
var $7be7e28e6f379df4$var$gridTemplateColumnsVar = '--ds-grid--grid-template-columns';
var $7be7e28e6f379df4$var$gridTemplateRowsVar = '--ds-grid--grid-template-rows';
var $7be7e28e6f379df4$var$justifyContentMap = {
    start: (0, $74Zh5.css)({
        justifyContent: 'start'
    }),
    center: (0, $74Zh5.css)({
        justifyContent: 'center'
    }),
    end: (0, $74Zh5.css)({
        justifyContent: 'end'
    }),
    'space-between': (0, $74Zh5.css)({
        justifyContent: 'space-between'
    }),
    'space-around': (0, $74Zh5.css)({
        justifyContent: 'space-around'
    }),
    'space-evenly': (0, $74Zh5.css)({
        justifyContent: 'space-evenly'
    }),
    stretch: (0, $74Zh5.css)({
        justifyContent: 'stretch'
    })
};
var $7be7e28e6f379df4$var$justifyItemsMap = {
    start: (0, $74Zh5.css)({
        justifyItems: 'start'
    }),
    center: (0, $74Zh5.css)({
        justifyItems: 'center'
    }),
    end: (0, $74Zh5.css)({
        justifyItems: 'end'
    }),
    stretch: (0, $74Zh5.css)({
        justifyItems: 'stretch'
    })
};
var $7be7e28e6f379df4$var$alignContentMap = {
    start: (0, $74Zh5.css)({
        alignContent: 'start'
    }),
    center: (0, $74Zh5.css)({
        alignContent: 'center'
    }),
    end: (0, $74Zh5.css)({
        alignContent: 'end'
    }),
    'space-between': (0, $74Zh5.css)({
        alignContent: 'space-between'
    }),
    'space-around': (0, $74Zh5.css)({
        alignContent: 'space-around'
    }),
    'space-evenly': (0, $74Zh5.css)({
        alignContent: 'space-evenly'
    }),
    stretch: (0, $74Zh5.css)({
        alignContent: 'stretch'
    })
};
var $7be7e28e6f379df4$var$alignItemsMap = {
    start: (0, $74Zh5.css)({
        alignItems: 'start'
    }),
    center: (0, $74Zh5.css)({
        alignItems: 'center'
    }),
    baseline: (0, $74Zh5.css)({
        alignItems: 'baseline'
    }),
    end: (0, $74Zh5.css)({
        alignItems: 'end'
    })
};
var $7be7e28e6f379df4$var$baseStyles = (0, $74Zh5.css)({
    display: 'grid',
    boxSizing: 'border-box',
    gridTemplateAreas: "var(".concat($7be7e28e6f379df4$var$gridTemplateAreasVar, ")"),
    gridTemplateColumns: "var(".concat($7be7e28e6f379df4$var$gridTemplateColumnsVar, ")"),
    gridTemplateRows: "var(".concat($7be7e28e6f379df4$var$gridTemplateRowsVar, ")")
});
var $7be7e28e6f379df4$var$gridAutoFlowMap = {
    row: (0, $74Zh5.css)({
        gridAutoFlow: 'row'
    }),
    column: (0, $74Zh5.css)({
        gridAutoFlow: 'column'
    }),
    dense: (0, $74Zh5.css)({
        gridAutoFlow: 'dense'
    }),
    'row dense': (0, $74Zh5.css)({
        gridAutoFlow: 'row dense'
    }),
    'column dense': (0, $74Zh5.css)({
        gridAutoFlow: 'column dense'
    })
};
/**
 * __Grid__
 *
 * `Grid` is a primitive component that implements the CSS Grid API.
 *
 * - [Examples](https://atlassian.design/components/primitives/grid/examples)
 * - [Code](https://atlassian.design/components/primitives/grid/code)
 *
 * @example
 * ```tsx
 * // eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
 * import { Grid, Box } from '@atlaskit/primitives'
 *
 * const Component = () => (
 *   <Grid gap="space.100" gridColumns="1fr 1fr">
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *   </Grid>
 * )
 * ```
 */ var $7be7e28e6f379df4$var$Grid = /*#__PURE__*/ (0, $5FkrB.memo)(/*#__PURE__*/ (0, $5FkrB.forwardRef)(function(_ref, ref) {
    var as = _ref.as, alignItems = _ref.alignItems, alignContent = _ref.alignContent, justifyContent = _ref.justifyContent, gap = _ref.gap, columnGap = _ref.columnGap, rowGap = _ref.rowGap, children = _ref.children, id = _ref.id, role = _ref.role, testId = _ref.testId, autoFlow = _ref.autoFlow, gridTemplateAreas = _ref.templateAreas, gridTemplateRows = _ref.templateRows, gridTemplateColumns = _ref.templateColumns, xcss = _ref.xcss;
    var Component = as || 'div';
    var resolvedStyles = (0, $e255n.parseXcss)(xcss);
    /**
   * We use CSS variables to allow for dynamic grid templates instead of dynamically setting to `props.style`
   * This allows `props.xcss` to override them as `style={{ gridTemplateAreas }}` would have higher specificity.
   *
   * This must be reset to `initial` if `gridTemplateAreas` is not set, otherwise nested grids will break!
   *
   * NOTE: If we disallow `grid-template-areas` (etc) to be set via `props.xcss`, we can remove this.
   */ var style = (0, $5FkrB.useMemo)(function() {
        return (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, $7be7e28e6f379df4$var$gridTemplateAreasVar, gridTemplateAreas ? gridTemplateAreas.map(function(str) {
            return "\"".concat(str, "\"");
        }).join('\n') || 'initial' : 'initial'), $7be7e28e6f379df4$var$gridTemplateColumnsVar, gridTemplateColumns || 'initial'), $7be7e28e6f379df4$var$gridTemplateRowsVar, gridTemplateRows || 'initial');
    }, [
        gridTemplateAreas,
        gridTemplateColumns,
        gridTemplateRows
    ]);
    return (0, $74Zh5.jsx)(Component, {
        id: id,
        role: role,
        style: style,
        className: resolvedStyles.static,
        css: [
            $7be7e28e6f379df4$var$baseStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            gap && (0, $lmNh5.spaceStylesMap).gap[gap],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            columnGap && (0, $lmNh5.spaceStylesMap).columnGap[columnGap],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            rowGap && (0, $lmNh5.spaceStylesMap).rowGap[rowGap],
            alignItems && $7be7e28e6f379df4$var$alignItemsMap[alignItems],
            alignContent && $7be7e28e6f379df4$var$alignContentMap[alignContent],
            justifyContent && $7be7e28e6f379df4$var$justifyContentMap[justifyContent],
            autoFlow && $7be7e28e6f379df4$var$gridAutoFlowMap[autoFlow]
        ].concat((0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(resolvedStyles.emotion || [])),
        "data-testid": testId,
        ref: ref
    }, children);
}));
$7be7e28e6f379df4$var$Grid.displayName = 'Grid';
var $7be7e28e6f379df4$export$2e2bcd8739ae039 = $7be7e28e6f379df4$var$Grid;

});

parcelRegister("3aP8P", function(module, exports) {
$parcel$export(module.exports, "CloseButton", () => $24f9f9e3d473509c$export$de65de8213222d10);

var $5FkrB = parcelRequire("5FkrB");

var $kxUqQ = parcelRequire("kxUqQ");

var $dQOjl = parcelRequire("dQOjl");
var $24f9f9e3d473509c$export$de65de8213222d10 = function CloseButton(_ref) {
    var label = _ref.label, onClick = _ref.onClick, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $kxUqQ.default), {
        testId: testId && "".concat(testId, "--close-button"),
        appearance: "subtle",
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($dQOjl))),
        label: label || 'Close Modal',
        onClick: onClick
    });
};

});
parcelRegister("kxUqQ", function(module, exports) {
$parcel$export(module.exports, "default", () => $ef52a9f3c2b023c6$export$2e2bcd8739ae039);

var $kqp0i = parcelRequire("kqp0i");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");

var $5GRVe = parcelRequire("5GRVe");

var $5mMUQ = parcelRequire("5mMUQ");

var $9KR88 = parcelRequire("9KR88");

var $5ZsYZ = parcelRequire("5ZsYZ");

var $fxDXf = parcelRequire("fxDXf");

var $7zyz1 = parcelRequire("7zyz1");
var $ef52a9f3c2b023c6$var$_excluded = [
    "aria-label",
    "aria-labelledby",
    "analyticsContext",
    "appearance",
    "autoFocus",
    "icon",
    "interactionName",
    "isDisabled",
    "isLoading",
    "isSelected",
    "isTooltipDisabled",
    "label",
    "onClick",
    "onClickCapture",
    "onKeyDownCapture",
    "onKeyUpCapture",
    "onMouseDownCapture",
    "onMouseUpCapture",
    "onPointerDownCapture",
    "onPointerUpCapture",
    "onTouchEndCapture",
    "onTouchStartCapture",
    "shape",
    "spacing",
    "testId",
    "tooltip",
    "type"
], $ef52a9f3c2b023c6$var$_excluded2 = [
    "className",
    "css",
    "as",
    "style"
];
/**
 * __Icon Button__
 *
 * Renders an icon-only button lets people take a common and recognizable action where space is limited.
 *
 * - [Examples](https://atlassian.design/components/button/icon-button/examples)
 * - [Code](https://atlassian.design/components/button/icon-button/code)
 * - [Usage](https://atlassian.design/components/button/icon-button/usage)
 */ var $ef52a9f3c2b023c6$var$IconButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).forwardRef(function Button(_ref, ref) {
    var _tooltip$content;
    var preventedAriaLabel = _ref['aria-label'], ariaLabelledBy = _ref['aria-labelledby'], analyticsContext = _ref.analyticsContext, appearance = _ref.appearance, autoFocus = _ref.autoFocus, icon = _ref.icon, interactionName = _ref.interactionName, isDisabled = _ref.isDisabled, _ref$isLoading = _ref.isLoading, isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading, isSelected = _ref.isSelected, _ref$isTooltipDisable = _ref.isTooltipDisabled, isTooltipDisabled = _ref$isTooltipDisable === void 0 ? true : _ref$isTooltipDisable, label = _ref.label, _onClick = _ref.onClick, onClickCapture = _ref.onClickCapture, onKeyDownCapture = _ref.onKeyDownCapture, onKeyUpCapture = _ref.onKeyUpCapture, onMouseDownCapture = _ref.onMouseDownCapture, onMouseUpCapture = _ref.onMouseUpCapture, onPointerDownCapture = _ref.onPointerDownCapture, onPointerUpCapture = _ref.onPointerUpCapture, onTouchEndCapture = _ref.onTouchEndCapture, onTouchStartCapture = _ref.onTouchStartCapture, shape = _ref.shape, spacing = _ref.spacing, testId = _ref.testId, tooltip = _ref.tooltip, _ref$type = _ref.type, type = _ref$type === void 0 ? 'button' : _ref$type, unsafeRest = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $ef52a9f3c2b023c6$var$_excluded);
    // @ts-expect-error
    var _className = unsafeRest.className, _css = unsafeRest.css, _as = unsafeRest.as, _style = unsafeRest.style, saferRest = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(unsafeRest, $ef52a9f3c2b023c6$var$_excluded2);
    if (isTooltipDisabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $5ZsYZ.default), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, saferRest, {
        ref: ref,
        appearance: appearance,
        autoFocus: autoFocus,
        isDisabled: isDisabled,
        isLoading: isLoading,
        isSelected: isSelected,
        isIconButton: true,
        isCircle: shape === 'circle',
        hasIconBefore: !!icon,
        spacing: spacing,
        ariaLabelledBy: ariaLabelledBy,
        onClick: _onClick,
        onClickCapture: onClickCapture,
        onKeyDownCapture: onKeyDownCapture,
        onKeyUpCapture: onKeyUpCapture,
        onMouseDownCapture: onMouseDownCapture,
        onMouseUpCapture: onMouseUpCapture,
        onPointerDownCapture: onPointerDownCapture,
        onPointerUpCapture: onPointerUpCapture,
        onTouchStartCapture: onTouchStartCapture,
        onTouchEndCapture: onTouchEndCapture,
        testId: testId,
        componentName: "IconButton",
        analyticsContext: analyticsContext,
        type: type,
        interactionName: interactionName
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $fxDXf.default), {
        type: "icon",
        isLoading: isLoading
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $7zyz1.default), {
        icon: icon
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $9KR88.default), null, label)));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $5mMUQ.default), {
        content: (_tooltip$content = tooltip === null || tooltip === void 0 ? void 0 : tooltip.content) !== null && _tooltip$content !== void 0 ? _tooltip$content : label,
        testId: tooltip === null || tooltip === void 0 ? void 0 : tooltip.testId,
        position: tooltip === null || tooltip === void 0 ? void 0 : tooltip.position,
        delay: tooltip === null || tooltip === void 0 ? void 0 : tooltip.delay,
        onShow: tooltip === null || tooltip === void 0 ? void 0 : tooltip.onShow,
        onHide: tooltip === null || tooltip === void 0 ? void 0 : tooltip.onHide,
        mousePosition: tooltip === null || tooltip === void 0 ? void 0 : tooltip.mousePosition,
        analyticsContext: tooltip === null || tooltip === void 0 ? void 0 : tooltip.analyticsContext,
        strategy: tooltip === null || tooltip === void 0 ? void 0 : tooltip.strategy,
        tag: tooltip === null || tooltip === void 0 ? void 0 : tooltip.tag,
        truncate: tooltip === null || tooltip === void 0 ? void 0 : tooltip.truncate,
        component: tooltip === null || tooltip === void 0 ? void 0 : tooltip.component,
        hideTooltipOnClick: tooltip === null || tooltip === void 0 ? void 0 : tooltip.hideTooltipOnClick,
        hideTooltipOnMouseDown: tooltip === null || tooltip === void 0 ? void 0 : tooltip.hideTooltipOnMouseDown,
        ignoreTooltipPointerEvents: tooltip === null || tooltip === void 0 ? void 0 : tooltip.ignoreTooltipPointerEvents
    }, function(triggerProps) {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $5ZsYZ.default), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, saferRest, {
            appearance: appearance,
            autoFocus: autoFocus,
            isDisabled: isDisabled,
            isLoading: isLoading,
            isSelected: isSelected,
            isIconButton: true,
            isCircle: shape === 'circle',
            hasIconBefore: false,
            spacing: spacing,
            ariaLabelledBy: ariaLabelledBy,
            onClick: function onClick(e, analyticsEvent) {
                var _triggerProps$onClick;
                _onClick === null || _onClick === void 0 || _onClick(e, analyticsEvent);
                (_triggerProps$onClick = triggerProps.onClick) === null || _triggerProps$onClick === void 0 || _triggerProps$onClick.call(triggerProps, e);
            },
            onMouseOver: function onMouseOver(e) {
                var _triggerProps$onMouse, _saferRest$onMouseOve;
                (_triggerProps$onMouse = triggerProps.onMouseOver) === null || _triggerProps$onMouse === void 0 || _triggerProps$onMouse.call(triggerProps, e);
                (_saferRest$onMouseOve = saferRest.onMouseOver) === null || _saferRest$onMouseOve === void 0 || _saferRest$onMouseOve.call(saferRest, e);
            },
            onMouseOut: function onMouseOut(e) {
                var _triggerProps$onMouse2, _saferRest$onMouseOut;
                (_triggerProps$onMouse2 = triggerProps.onMouseOut) === null || _triggerProps$onMouse2 === void 0 || _triggerProps$onMouse2.call(triggerProps, e);
                (_saferRest$onMouseOut = saferRest.onMouseOut) === null || _saferRest$onMouseOut === void 0 || _saferRest$onMouseOut.call(saferRest, e);
            },
            onMouseMove: function onMouseMove(e) {
                var _triggerProps$onMouse3, _saferRest$onMouseMov;
                (_triggerProps$onMouse3 = triggerProps.onMouseMove) === null || _triggerProps$onMouse3 === void 0 || _triggerProps$onMouse3.call(triggerProps, e);
                (_saferRest$onMouseMov = saferRest.onMouseMove) === null || _saferRest$onMouseMov === void 0 || _saferRest$onMouseMov.call(saferRest, e);
            },
            onMouseDown: function onMouseDown(e) {
                var _triggerProps$onMouse4, _saferRest$onMouseDow;
                (_triggerProps$onMouse4 = triggerProps.onMouseDown) === null || _triggerProps$onMouse4 === void 0 || _triggerProps$onMouse4.call(triggerProps, e);
                (_saferRest$onMouseDow = saferRest.onMouseDown) === null || _saferRest$onMouseDow === void 0 || _saferRest$onMouseDow.call(saferRest, e);
            },
            onFocus: function onFocus(e) {
                var _triggerProps$onFocus, _saferRest$onFocus;
                (_triggerProps$onFocus = triggerProps.onFocus) === null || _triggerProps$onFocus === void 0 || _triggerProps$onFocus.call(triggerProps, e);
                (_saferRest$onFocus = saferRest.onFocus) === null || _saferRest$onFocus === void 0 || _saferRest$onFocus.call(saferRest, e);
            },
            onBlur: function onBlur(e) {
                var _triggerProps$onBlur, _saferRest$onBlur;
                (_triggerProps$onBlur = triggerProps.onBlur) === null || _triggerProps$onBlur === void 0 || _triggerProps$onBlur.call(triggerProps, e);
                (_saferRest$onBlur = saferRest.onBlur) === null || _saferRest$onBlur === void 0 || _saferRest$onBlur.call(saferRest, e);
            },
            ref: (0, $5GRVe.default)([
                ref,
                triggerProps === null || triggerProps === void 0 ? void 0 : triggerProps.ref
            ].filter(Boolean)),
            onMouseDownCapture: onMouseDownCapture,
            onMouseUpCapture: onMouseUpCapture,
            onKeyDownCapture: onKeyDownCapture,
            onKeyUpCapture: onKeyUpCapture,
            onTouchStartCapture: onTouchStartCapture,
            onTouchEndCapture: onTouchEndCapture,
            onPointerDownCapture: onPointerDownCapture,
            onPointerUpCapture: onPointerUpCapture,
            onClickCapture: onClickCapture,
            type: type,
            testId: testId,
            analyticsContext: analyticsContext,
            interactionName: interactionName,
            componentName: "IconButton"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $fxDXf.default), {
            type: "icon",
            isLoading: isLoading
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $7zyz1.default), {
            icon: icon
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $9KR88.default), null, label)));
    });
}));
$ef52a9f3c2b023c6$var$IconButton.displayName = 'IconButton';
var $ef52a9f3c2b023c6$export$2e2bcd8739ae039 = $ef52a9f3c2b023c6$var$IconButton;

});
parcelRegister("5GRVe", function(module, exports) {
$parcel$export(module.exports, "default", () => $424ab3c86c00d660$export$2e2bcd8739ae039);
/**
 * Assigns the node to all the refs passed in the argument.
 *
 * @param refs: An array of refs (as function or ref object)
 */ function $424ab3c86c00d660$export$2e2bcd8739ae039(refs) {
    // TODO: could this be wrapped in `useCallback` so we get a stable function?
    return function(value) {
        refs.forEach(function(ref) {
            if (typeof ref === 'function') ref(value);
            else if (ref !== null) ref.current = value;
        });
    };
}

});

parcelRegister("5mMUQ", function(module, exports) {
$parcel$export(module.exports, "default", () => $3e84f37e1f856085$export$2e2bcd8739ae039);

var $kqp0i = parcelRequire("kqp0i");

var $iYJcE = parcelRequire("iYJcE");

var $25nEq = parcelRequire("25nEq");

var $5FkrB = parcelRequire("5FkrB");

var $7QpUe = parcelRequire("7QpUe");

var $f8h2T = parcelRequire("f8h2T");

var $6qCqe = parcelRequire("6qCqe");

var $Bg0zQ = parcelRequire("Bg0zQ");

var $fGJry = parcelRequire("fGJry");

var $gu3mE = parcelRequire("gu3mE");

var $ZdqJG = parcelRequire("ZdqJG");
var $eQzrx = parcelRequire("eQzrx");

var $3SFik = parcelRequire("3SFik");

var $6bqMl = parcelRequire("6bqMl");

var $H74DA = parcelRequire("H74DA");

var $esE7Z = parcelRequire("esE7Z");

var $5sp2R = parcelRequire("5sp2R");

var $2hND8 = parcelRequire("2hND8");

var $eqvOo = parcelRequire("eqvOo");

var $37Jbg = parcelRequire("37Jbg");
function $3e84f37e1f856085$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $3e84f37e1f856085$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $3e84f37e1f856085$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $3e84f37e1f856085$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $3e84f37e1f856085$var$tooltipZIndex = (0, $H74DA.layers).tooltip();
var $3e84f37e1f856085$var$analyticsAttributes = {
    componentName: 'tooltip',
    packageName: "@atlaskit/tooltip",
    packageVersion: "20.0.4"
};
// Inverts motion direction
var $3e84f37e1f856085$var$invertedDirection = {
    top: 'bottom',
    bottom: 'top',
    left: 'right',
    right: 'left'
};
/**
 * Converts a Popper placement to it's general direction.
 *
 * @param placement - Popper Placement value, e.g. 'top-start'
 * @returns Popper Direction, e.g. 'top'
 */ var $3e84f37e1f856085$var$getDirectionFromPlacement = function getDirectionFromPlacement(placement) {
    return placement.split('-')[0];
};
/**
 * __Tooltip__
 *
 * A tooltip is a floating, non-actionable label used to explain a user interface element or feature.
 */ function $3e84f37e1f856085$var$Tooltip(_ref) {
    var children = _ref.children, _ref$position = _ref.position, position = _ref$position === void 0 ? 'bottom' : _ref$position, _ref$mousePosition = _ref.mousePosition, mousePosition = _ref$mousePosition === void 0 ? 'bottom' : _ref$mousePosition, content = _ref.content, _ref$truncate = _ref.truncate, truncate = _ref$truncate === void 0 ? false : _ref$truncate, _ref$component = _ref.component, Container = _ref$component === void 0 ? (0, $eqvOo.default) : _ref$component, _ref$tag = _ref.tag, TargetContainer = _ref$tag === void 0 ? 'div' : _ref$tag, testId = _ref.testId, _ref$delay = _ref.delay, delay = _ref$delay === void 0 ? 300 : _ref$delay, _ref$onShow = _ref.onShow, onShow = _ref$onShow === void 0 ? (0, $6qCqe.default) : _ref$onShow, _ref$onHide = _ref.onHide, onHide = _ref$onHide === void 0 ? (0, $6qCqe.default) : _ref$onHide, canAppear = _ref.canAppear, _ref$hideTooltipOnCli = _ref.hideTooltipOnClick, hideTooltipOnClick = _ref$hideTooltipOnCli === void 0 ? false : _ref$hideTooltipOnCli, _ref$hideTooltipOnMou = _ref.hideTooltipOnMouseDown, hideTooltipOnMouseDown = _ref$hideTooltipOnMou === void 0 ? false : _ref$hideTooltipOnMou, analyticsContext = _ref.analyticsContext, _ref$strategy = _ref.strategy, strategy = _ref$strategy === void 0 ? 'fixed' : _ref$strategy, _ref$ignoreTooltipPoi = _ref.ignoreTooltipPointerEvents, ignoreTooltipPointerEvents = _ref$ignoreTooltipPoi === void 0 ? false : _ref$ignoreTooltipPoi, _ref$isScreenReaderAn = _ref.isScreenReaderAnnouncementDisabled, isScreenReaderAnnouncementDisabled = _ref$isScreenReaderAn === void 0 ? false : _ref$isScreenReaderAn;
    var tooltipPosition = position === 'mouse' ? mousePosition : position;
    var onShowHandler = (0, $f8h2T.usePlatformLeafSyntheticEventHandler)($3e84f37e1f856085$var$_objectSpread({
        fn: onShow,
        action: 'displayed',
        analyticsData: analyticsContext
    }, $3e84f37e1f856085$var$analyticsAttributes));
    var onHideHandler = (0, $f8h2T.usePlatformLeafSyntheticEventHandler)($3e84f37e1f856085$var$_objectSpread({
        fn: onHide,
        action: 'hidden',
        analyticsData: analyticsContext
    }, $3e84f37e1f856085$var$analyticsAttributes));
    var apiRef = (0, $5FkrB.useRef)(null);
    var _useState = (0, $5FkrB.useState)('hide'), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), state = _useState2[0], setState = _useState2[1];
    var targetRef = (0, $5FkrB.useRef)(null);
    var containerRef = (0, $5FkrB.useRef)(null);
    // This function is deliberately _not_ memoized as it needs to re-run every render
    // to pick up any child ref changes. If you use render props you don't have this issue.
    var setImplicitRefFromChildren = function setImplicitRefFromChildren(node) {
        containerRef.current = node;
        targetRef.current = node ? node.firstElementChild : null;
    };
    // This is memoized and passed into the render props callback.
    var setDirectRef = (0, $5FkrB.useCallback)(function(node) {
        targetRef.current = node;
    }, []);
    // Putting a few things into refs so that we don't have to break memoization
    var stableState = (0, $fGJry.default)(state);
    // These props are placed in separate refs instead of a single object to reduce memory usage.
    // Placing them in the same object previously caused an increase in the number of JavaScript event listeners
    // before garbage collection.
    var onShowHandlerStable = (0, $fGJry.default)(onShowHandler);
    var onHideHandlerStable = (0, $fGJry.default)(onHideHandler);
    var delayStable = (0, $fGJry.default)(delay);
    var canAppearStable = (0, $fGJry.default)(canAppear);
    var hasCalledShowHandler = (0, $5FkrB.useRef)(false);
    var start = (0, $5FkrB.useCallback)(function(api) {
        // @ts-ignore
        apiRef.current = api;
        hasCalledShowHandler.current = false;
    }, []);
    var done = (0, $5FkrB.useCallback)(function() {
        if (!apiRef.current) return;
        // Only call onHideHandler if we have called onShowHandler
        if (hasCalledShowHandler.current) onHideHandlerStable.current();
        // @ts-ignore
        apiRef.current = null;
        // @ts-ignore
        hasCalledShowHandler.current = false;
        // just in case
        setState('hide');
    }, [
        onHideHandlerStable
    ]);
    var abort = (0, $5FkrB.useCallback)(function() {
        if (!apiRef.current) return;
        apiRef.current.abort();
        // Only call onHideHandler if we have called onShowHandler
        if (hasCalledShowHandler.current) onHideHandlerStable.current();
        // @ts-ignore
        apiRef.current = null;
    }, [
        onHideHandlerStable
    ]);
    (0, $5FkrB.useEffect)(function mount() {
        return function unmount() {
            if (apiRef.current) abort();
        };
    }, [
        abort
    ]);
    var isDraggingRef = (0, $5FkrB.useRef)(false);
    (0, $5FkrB.useEffect)(function() {
        return (0, $esE7Z.register)({
            onRegister: function onRegister(_ref2) {
                var isDragging = _ref2.isDragging;
                isDraggingRef.current = isDragging;
            },
            onDragStart: function onDragStart() {
                var _apiRef$current;
                /**
         * Hiding any visible tooltips when a drag starts because otherwise it
         * looks janky (disappears and reappears), and is not required.
         */ (_apiRef$current = apiRef.current) === null || _apiRef$current === void 0 || _apiRef$current.requestHide({
                    isImmediate: true
                });
                isDraggingRef.current = true;
            },
            onDragEnd: function onDragEnd() {
                isDraggingRef.current = false;
            }
        });
    }, []);
    var tryShowTooltip = (0, $5FkrB.useCallback)(function(source) {
        var _canAppearStable$curr;
        /**
     * Prevent tooltips from being shown during a drag. This can occur with
     * the native drag and drop API, where some pointer events can fire
     * when they should not and lead to jank with tooltips.
     */ if (isDraggingRef.current) return;
        // Another tooltip is has been active but we still have the old `api`
        // around. We need to finish up the last usage.
        // Note: just being safe - this should not happen
        if (apiRef.current && !apiRef.current.isActive()) abort();
        // This tooltip is already active, we can exit
        if (apiRef.current && apiRef.current.isActive()) {
            apiRef.current.keep();
            return;
        }
        /**
     * Check if tooltip is allowed to show.
     *
     * Once a tooltip has started, or has scheduled to start
     * we won't be checking `canAppear` again.
     *
     * - We don't want tooltips to disappear once they are shown
     * - For consistency, we start after a single positive `canAppear`.
     *   Otherwise the amount of times we ask consumers would depend on
     *   how many times we get a "mousemove", which _could_ lead to situations
     *   where moving the mouse could result in a different outcome to if
     *   the mouse was not moved.
     */ if (canAppearStable.current && !((_canAppearStable$curr = canAppearStable.current) !== null && _canAppearStable$curr !== void 0 && _canAppearStable$curr.call(canAppearStable))) return;
        var entry = {
            source: source,
            delay: delayStable.current,
            show: function show(_ref3) {
                var isImmediate = _ref3.isImmediate;
                // Call the onShow handler if it hasn't been called yet
                if (!hasCalledShowHandler.current) {
                    hasCalledShowHandler.current = true;
                    onShowHandlerStable.current();
                }
                setState(isImmediate ? 'show-immediate' : 'fade-in');
            },
            hide: function hide(_ref4) {
                var isImmediate = _ref4.isImmediate;
                if (isImmediate) setState('hide');
                else setState('before-fade-out');
            },
            done: done
        };
        var api = (0, $5sp2R.show)(entry);
        start(api);
    }, [
        canAppearStable,
        delayStable,
        done,
        start,
        abort,
        onShowHandlerStable
    ]);
    var hideTooltipOnEsc = (0, $5FkrB.useCallback)(function() {
        var _apiRef$current2;
        (_apiRef$current2 = apiRef.current) === null || _apiRef$current2 === void 0 || _apiRef$current2.requestHide({
            isImmediate: true
        });
    }, [
        apiRef
    ]);
    (0, $Bg0zQ.default)({
        onClose: hideTooltipOnEsc,
        isDisabled: state === 'hide' || state === 'fade-out'
    });
    (0, $5FkrB.useEffect)(function() {
        if (state === 'hide') return 0, $6qCqe.default;
        if (state === 'before-fade-out') setState('fade-out');
        var unbind = (0, $7QpUe.bind)(window, {
            type: 'scroll',
            listener: function listener() {
                if (apiRef.current) apiRef.current.requestHide({
                    isImmediate: true
                });
            },
            options: {
                capture: true,
                passive: true,
                once: true
            }
        });
        return unbind;
    }, [
        state
    ]);
    var onMouseDown = (0, $5FkrB.useCallback)(function() {
        if (hideTooltipOnMouseDown && apiRef.current) apiRef.current.requestHide({
            isImmediate: true
        });
    }, [
        hideTooltipOnMouseDown
    ]);
    var onClick = (0, $5FkrB.useCallback)(function() {
        if (hideTooltipOnClick && apiRef.current) apiRef.current.requestHide({
            isImmediate: true
        });
    }, [
        hideTooltipOnClick
    ]);
    // Ideally we would be using onMouseEnter here, but
    // because we are binding the event to the target parent
    // we need to listen for the mouseover of all sub elements
    // This means when moving along a tooltip we are quickly toggling
    // between api.requestHide and api.keep. This it not ideal
    var onMouseOver = (0, $5FkrB.useCallback)(function(event) {
        // Ignoring events from the container ref
        if (containerRef.current && event.target === containerRef.current) return;
        // Using prevent default as a signal that parent tooltips
        if (event.defaultPrevented) return;
        event.preventDefault();
        var source = position === 'mouse' ? {
            type: 'mouse',
            // TODO: ideally not recalculating this object each time
            mouse: (0, $37Jbg.getMousePosition)({
                left: event.clientX,
                top: event.clientY
            })
        } : {
            type: 'keyboard'
        };
        tryShowTooltip(source);
    }, [
        position,
        tryShowTooltip
    ]);
    // Ideally we would be using onMouseEnter here, but
    // because we are binding the event to the target parent
    // we need to listen for the mouseout of all sub elements
    // This means when moving along a tooltip we are quickly toggling
    // between api.requestHide and api.keep. This it not ideal
    var onMouseOut = (0, $5FkrB.useCallback)(function(event) {
        // Ignoring events from the container ref
        if (containerRef.current && event.target === containerRef.current) return;
        // Using prevent default as a signal that parent tooltips
        if (event.defaultPrevented) return;
        event.preventDefault();
        if (apiRef.current) apiRef.current.requestHide({
            isImmediate: false
        });
    }, []);
    var onMouseMove = position === 'mouse' ? function(event) {
        var _apiRef$current3;
        if ((_apiRef$current3 = apiRef.current) !== null && _apiRef$current3 !== void 0 && _apiRef$current3.isActive()) apiRef.current.mousePosition = (0, $37Jbg.getMousePosition)({
            left: event.clientX,
            top: event.clientY
        });
    } : undefined;
    var onMouseOverTooltip = (0, $5FkrB.useCallback)(function() {
        if (apiRef.current && apiRef.current.isActive()) {
            apiRef.current.keep();
            return;
        }
    }, []);
    var onFocus = (0, $5FkrB.useCallback)(function() {
        // TODO: this does not play well with `hideTooltipOnMouseDown`
        // as "focus" will occur after the "mousedown".
        tryShowTooltip({
            type: 'keyboard'
        });
    }, [
        tryShowTooltip
    ]);
    var onBlur = (0, $5FkrB.useCallback)(function() {
        if (apiRef.current) apiRef.current.requestHide({
            isImmediate: false
        });
    }, []);
    var onAnimationFinished = (0, $5FkrB.useCallback)(function(transition) {
        // Using lastState here because motion is not picking up the latest value
        if (transition === 'exiting' && stableState.current === 'fade-out' && apiRef.current) // @ts-ignore: refs are writeable
        apiRef.current.finishHideAnimation();
    }, [
        stableState
    ]);
    // Doing a cast because typescript is struggling to narrow the type
    var CastTargetContainer = TargetContainer;
    var shouldRenderTooltipPopup = state !== 'hide' && Boolean(content);
    var shouldRenderHiddenContent = !isScreenReaderAnnouncementDisabled && shouldRenderTooltipPopup;
    var shouldRenderTooltipChildren = state !== 'hide' && state !== 'fade-out';
    (0, $gu3mE.useNotifyOpenLayerObserver)({
        isOpen: shouldRenderTooltipPopup
    });
    var getReferenceElement = function getReferenceElement() {
        var _apiRef$current4;
        if (position === 'mouse' && (_apiRef$current4 = apiRef.current) !== null && _apiRef$current4 !== void 0 && _apiRef$current4.mousePosition) {
            var _apiRef$current5;
            return (_apiRef$current5 = apiRef.current) === null || _apiRef$current5 === void 0 ? void 0 : _apiRef$current5.mousePosition;
        }
        return targetRef.current || undefined;
    };
    var tooltipIdForHiddenContent = (0, $2hND8.default)('tooltip', shouldRenderHiddenContent);
    var tooltipTriggerProps = {
        onMouseOver: onMouseOver,
        onMouseOut: onMouseOut,
        onMouseMove: onMouseMove,
        onMouseDown: onMouseDown,
        onClick: onClick,
        onFocus: onFocus,
        onBlur: onBlur
    };
    // Don't set `data-testid` unless it's defined, as it's not in the interface.
    if (testId) // @ts-expect-error - Adding `data-testid` to the TriggerProps interface breaks Buttons.
    tooltipTriggerProps['data-testid'] = "".concat(testId, "--container");
    // This useEffect is purely for managing the aria attribute when using the
    // wrapped children approach.
    var isChildrenAFunction = typeof children === 'function';
    (0, $5FkrB.useEffect)(function() {
        if (isChildrenAFunction) return;
        // If `children` is _not_ a function, we are stepping outside of the public
        // API to add a `aria-describedby` attribute.
        var target = targetRef.current;
        if (!target || !tooltipIdForHiddenContent) return;
        target.setAttribute('aria-describedby', tooltipIdForHiddenContent);
        return function() {
            return target.removeAttribute('aria-describedby');
        };
    }, [
        isChildrenAFunction,
        tooltipIdForHiddenContent
    ]);
    var hiddenContent = shouldRenderHiddenContent ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("span", {
        "data-testid": testId ? "".concat(testId, "-hidden") : undefined,
        hidden: true,
        id: tooltipIdForHiddenContent
    }, typeof content === 'function' ? content({}) : content) : null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).Fragment, null, typeof children === 'function' ? /*#__PURE__*/ // once we deprecate the wrapped approach, we can put the aria
    // attribute back into the tooltipTriggerProps and make it required
    // instead of optional in `types`
    (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).Fragment, null, children($3e84f37e1f856085$var$_objectSpread($3e84f37e1f856085$var$_objectSpread({}, tooltipTriggerProps), {}, {
        'aria-describedby': tooltipIdForHiddenContent,
        ref: setDirectRef
    })), hiddenContent) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(CastTargetContainer, (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, tooltipTriggerProps, {
        ref: setImplicitRefFromChildren,
        role: "presentation"
    }), children, hiddenContent), shouldRenderTooltipPopup ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $6bqMl.default), {
        zIndex: $3e84f37e1f856085$var$tooltipZIndex
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $3SFik.Popper), {
        placement: tooltipPosition,
        referenceElement: getReferenceElement(),
        strategy: strategy
    }, function(_ref5) {
        var ref = _ref5.ref, style = _ref5.style, update = _ref5.update, placement = _ref5.placement;
        // Invert the entrance and exit directions.
        // E.g. a tooltip's position is on the 'right', it should enter from and exit to the 'left'
        // This gives the effect the tooltip is appearing from the target
        var direction = position === 'mouse' ? undefined : $3e84f37e1f856085$var$invertedDirection[$3e84f37e1f856085$var$getDirectionFromPlacement(placement)];
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $ZdqJG.default), {
            appear: true
        }, shouldRenderTooltipChildren && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $eQzrx.default), {
            distance: "constant",
            entranceDirection: direction,
            exitDirection: direction,
            onFinish: onAnimationFinished,
            duration: state !== 'show-immediate' ? 'medium' : 'none'
        }, function(_ref6) {
            var className = _ref6.className;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(Container, {
                ref: ref,
                className: "Tooltip ".concat(className),
                style: $3e84f37e1f856085$var$_objectSpread($3e84f37e1f856085$var$_objectSpread({}, style), ignoreTooltipPointerEvents && {
                    pointerEvents: 'none'
                }),
                truncate: truncate,
                placement: tooltipPosition,
                testId: getReferenceElement() ? testId : testId && "".concat(testId, "--unresolved"),
                onMouseOut: onMouseOut,
                onMouseOver: onMouseOverTooltip
            }, typeof content === 'function' ? content({
                update: update
            }) : content);
        }));
    })) : null);
}
$3e84f37e1f856085$var$Tooltip.displayName = 'Tooltip';
var $3e84f37e1f856085$export$2e2bcd8739ae039 = $3e84f37e1f856085$var$Tooltip;

});
parcelRegister("f8h2T", function(module, exports) {
$parcel$export(module.exports, "usePlatformLeafSyntheticEventHandler", () => $b044d3486e251a8e$export$1a04351537078b55);

var $25nEq = parcelRequire("25nEq");

var $5FkrB = parcelRequire("5FkrB");

var $h0OAL = parcelRequire("h0OAL");

var $b6wQg = parcelRequire("b6wQg");
function $b044d3486e251a8e$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $b044d3486e251a8e$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $b044d3486e251a8e$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $b044d3486e251a8e$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $b044d3486e251a8e$export$1a04351537078b55(_ref) {
    var fn = _ref.fn, action = _ref.action, componentName = _ref.componentName, packageName = _ref.packageName, packageVersion = _ref.packageVersion, analyticsData = _ref.analyticsData;
    var _useAnalyticsEvents = (0, $h0OAL.useAnalyticsEvents)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
    // We put analyticsData and fn in a ref so that we don't need to break
    // memoization.
    // Generally these could be defined by consumers inline
    // and so we do this to avoid breaking memoization of useCallback
    var dataRef = (0, $b6wQg.useTrackedRef)(analyticsData);
    var fnRef = (0, $b6wQg.useTrackedRef)(fn);
    var handler = (0, $5FkrB.useCallback)(function() {
        var analyticsEvent = createAnalyticsEvent({
            action: action,
            actionSubject: componentName,
            attributes: {
                componentName: componentName,
                packageName: packageName,
                packageVersion: packageVersion
            }
        });
        // To avoid wrapping this component in AnalyticsContext we manually
        // push the parent context's meta data into the context.
        // Note: this new 'context'
        var context = $b044d3486e251a8e$var$_objectSpread({
            componentName: componentName,
            packageName: packageName,
            packageVersion: packageVersion
        }, dataRef.current);
        analyticsEvent.context.push(context);
        // fire an event on the atlaskit channel
        var clone = analyticsEvent.clone();
        if (clone) clone.fire('atlaskit');
        fnRef.current(analyticsEvent);
    }, [
        // These are strings and won't change
        action,
        componentName,
        packageName,
        packageVersion,
        // This function is memoized in the context
        createAnalyticsEvent,
        // these are a stable ref because of the useTrackedRef hook
        dataRef,
        fnRef
    ]);
    return handler;
}

});

parcelRegister("Bg0zQ", function(module, exports) {
$parcel$export(module.exports, "default", () => $06ffdfbb98a81f21$export$2e2bcd8739ae039);

var $5FkrB = parcelRequire("5FkrB");

var $7QpUe = parcelRequire("7QpUe");

var $id6Cu = parcelRequire("id6Cu");

var $3Wvr5 = parcelRequire("3Wvr5");
function $06ffdfbb98a81f21$export$2e2bcd8739ae039(_ref) {
    var onClose = _ref.onClose, isDisabled = _ref.isDisabled;
    var escapePressed = (0, $5FkrB.useRef)(false);
    var onKeyDown = (0, $5FkrB.useCallback)(function(e) {
        if (isDisabled || escapePressed.current || e.key !== (0, $3Wvr5.ESCAPE)) // We're either already handling the key down event or it's not escape.
        // Bail early!
        return;
        escapePressed.current = true;
        onClose(e);
    }, [
        onClose,
        isDisabled
    ]);
    var onKeyUp = (0, $5FkrB.useCallback)(function() {
        escapePressed.current = false;
    }, []);
    (0, $5FkrB.useEffect)(function() {
        // Don't attach document event listeners if the hook is disabled
        if (isDisabled && (0, $id6Cu.fg)('platform_only_attach_escape_handler_on_view')) return;
        return (0, $7QpUe.bindAll)(document, [
            {
                type: 'keydown',
                listener: onKeyDown
            },
            {
                type: 'keyup',
                listener: onKeyUp
            }
        ], {
            capture: false
        });
    }, [
        onKeyDown,
        onKeyUp,
        isDisabled
    ]);
}

});
parcelRegister("3Wvr5", function(module, exports) {
$parcel$export(module.exports, "ESCAPE", () => $2def2c5ccca2ee64$export$2bb790b9008907b4);
/**
 * Character key codes which can be used in keyboard events.
 */ var $2def2c5ccca2ee64$export$390330c10ff2b9a1 = 'ArrowUp';
var $2def2c5ccca2ee64$export$a80636c6f41931fe = 'ArrowDown';
var $2def2c5ccca2ee64$export$4af703091671bc = 'Home';
var $2def2c5ccca2ee64$export$e2bc30913faa5db7 = 'End';
var $2def2c5ccca2ee64$export$10f6869ed0a7d75b = 'Tab';
var $2def2c5ccca2ee64$export$8152f929a25a0ff4 = 'Enter';
var $2def2c5ccca2ee64$export$e51a3576c045c8d5 = 'Space';
var $2def2c5ccca2ee64$export$2bb790b9008907b4 = 'Escape';

});


parcelRegister("fGJry", function(module, exports) {
$parcel$export(module.exports, "default", () => $b6be075dbc35dcc6$export$2e2bcd8739ae039);

var $5FkrB = parcelRequire("5FkrB");
function $b6be075dbc35dcc6$export$2e2bcd8739ae039(value) {
    var ref = (0, $5FkrB.useRef)(value);
    (0, $5FkrB.useEffect)(function() {
        ref.current = value;
    }, [
        value
    ]);
    return ref;
}

});

parcelRegister("gu3mE", function(module, exports) {
$parcel$export(module.exports, "useNotifyOpenLayerObserver", () => $c0020ec9ccf809da$export$469bb693f11edc7f);

var $5FkrB = parcelRequire("5FkrB");

var $b89FJ = parcelRequire("b89FJ");

var $eP88L = parcelRequire("eP88L");
function $c0020ec9ccf809da$export$469bb693f11edc7f(_ref) {
    var isOpen = _ref.isOpen, onClose = _ref.onClose;
    var context = (0, $5FkrB.useContext)((0, $b89FJ.OpenLayerObserverContext));
    var namespace = (0, $eP88L.useOpenLayerObserverNamespace)();
    (0, $5FkrB.useEffect)(function() {
        /**
     * Registers the `onClose` callback with the OpenLayerObserver.
     */ if (context === null) return;
        if (!isOpen) /**
       * If the layer is not open, we are not registering the `onClose` callback.
       * This is important to prevent the `onClose` from being called for layers that
       * are not open.
       *
       * Some consumers mistakenly pass "toggle" functions to `onClose` callbacks for
       * layer components, as Popup, e.g. `onClose={() => setIsOpen(!isOpen)}`.
       */ return;
        return context.onClose(onClose, {
            namespace: namespace
        });
    }, [
        context,
        isOpen,
        namespace,
        onClose
    ]);
}

});
parcelRegister("b89FJ", function(module, exports) {
$parcel$export(module.exports, "OpenLayerObserverContext", () => $81a7f1baf9970f8a$export$5fbf4d7fae6cdc00);

var $5FkrB = parcelRequire("5FkrB");
var $81a7f1baf9970f8a$export$5fbf4d7fae6cdc00 = /*#__PURE__*/ (0, $5FkrB.createContext)(null);

});

parcelRegister("eP88L", function(module, exports) {
$parcel$export(module.exports, "useOpenLayerObserverNamespace", () => $acac249b4f8cf3c7$export$1d57e79091cc3046);

var $5FkrB = parcelRequire("5FkrB");

var $dVK9q = parcelRequire("dVK9q");
function $acac249b4f8cf3c7$export$1d57e79091cc3046() {
    var namespace = (0, $5FkrB.useContext)((0, $dVK9q.OpenLayerObserverNamespaceContext));
    return namespace;
}

});
parcelRegister("dVK9q", function(module, exports) {
$parcel$export(module.exports, "OpenLayerObserverNamespaceContext", () => $a24465dead17194e$export$644a49f3b8c50fcd);

var $5FkrB = parcelRequire("5FkrB");
var $a24465dead17194e$export$644a49f3b8c50fcd = /*#__PURE__*/ (0, $5FkrB.createContext)(null);

});



parcelRegister("3SFik", function(module, exports) {
$parcel$export(module.exports, "Popper", () => $2d36727918589a7b$export$badac9ada3a0bdf9);

var $fC8ib = parcelRequire("fC8ib");

var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");

var $lsgol = parcelRequire("lsgol");

var $gXYDi = parcelRequire("gXYDi");

// Export types from PopperJS / React Popper
var $2d36727918589a7b$var$viewportPadding = 5;
var $2d36727918589a7b$var$constantModifiers = [
    {
        name: 'flip',
        options: {
            flipVariations: false,
            padding: $2d36727918589a7b$var$viewportPadding,
            boundary: 'clippingParents',
            rootBoundary: 'viewport'
        }
    }
];
function $2d36727918589a7b$var$defaultChildrenFn() {
    return null;
}
var $2d36727918589a7b$var$defaultOffset = [
    0,
    8
];
function $2d36727918589a7b$export$badac9ada3a0bdf9(_ref) {
    var _ref$children = _ref.children, children = _ref$children === void 0 ? $2d36727918589a7b$var$defaultChildrenFn : _ref$children, _ref$offset = _ref.offset, offset = _ref$offset === void 0 ? $2d36727918589a7b$var$defaultOffset : _ref$offset, _ref$placement = _ref.placement, placement = _ref$placement === void 0 ? 'bottom-start' : _ref$placement, _ref$referenceElement = _ref.referenceElement, referenceElement = _ref$referenceElement === void 0 ? undefined : _ref$referenceElement, modifiers = _ref.modifiers, _ref$strategy = _ref.strategy, strategy = _ref$strategy === void 0 ? 'fixed' : _ref$strategy, _ref$shouldFitViewpor = _ref.shouldFitViewport, shouldFitViewport = _ref$shouldFitViewpor === void 0 ? false : _ref$shouldFitViewpor;
    var _offset = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(offset, 2), offsetX = _offset[0], offsetY = _offset[1];
    var internalModifiers = (0, $5FkrB.useMemo)(function() {
        var preventOverflowModifier = {
            name: 'preventOverflow',
            options: {
                padding: $2d36727918589a7b$var$viewportPadding,
                rootBoundary: shouldFitViewport ? 'viewport' : 'document'
            }
        };
        var offsetModifier = {
            name: 'offset',
            options: {
                offset: [
                    offsetX,
                    offsetY
                ]
            }
        };
        var maxSizeModifiers = shouldFitViewport ? (0, $gXYDi.getMaxSizeModifiers)({
            viewportPadding: $2d36727918589a7b$var$viewportPadding
        }) : [];
        // @ts-ignore Type errors from incompatible @popperjs/core versions between Jira and AFM Platform... we are using ts-ignore here because ts-expect-error will cause an "Unused '@ts-expect-error' directive." error
        return [].concat($2d36727918589a7b$var$constantModifiers, [
            preventOverflowModifier,
            offsetModifier
        ], (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(maxSizeModifiers));
    }, [
        offsetX,
        offsetY,
        shouldFitViewport
    ]);
    // Merge custom props and memoize
    var mergedModifiers = (0, $5FkrB.useMemo)(function() {
        if (modifiers == null) return internalModifiers;
        return [].concat((0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(internalModifiers), (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(modifiers));
    }, [
        internalModifiers,
        modifiers
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $lsgol.Popper), {
        modifiers: mergedModifiers,
        placement: placement,
        strategy: strategy,
        referenceElement: referenceElement
    }, children);
}

});
parcelRegister("gXYDi", function(module, exports) {
$parcel$export(module.exports, "getMaxSizeModifiers", () => $c5a130760dfad3e7$export$6d8c2b45c99d6e3f);

var $iYJcE = parcelRequire("iYJcE");
function $c5a130760dfad3e7$export$6d8c2b45c99d6e3f(_ref) {
    var viewportPadding = _ref.viewportPadding;
    return [
        {
            /**
     * Performing DOM measurements in the 'read' phase,
     * which is the convention for popper modifiers
     */ name: 'maxSizeData',
            enabled: true,
            phase: 'read',
            fn: function fn(_ref2) {
                var state = _ref2.state, name = _ref2.name;
                if (!window.visualViewport) return;
                state.modifiersData[name] = {
                    viewport: {
                        width: window.visualViewport.width,
                        height: window.visualViewport.height
                    }
                };
            }
        },
        {
            /**
     * Applying max size CSS
     */ name: 'maxSize',
            enabled: true,
            phase: 'beforeWrite',
            requiresIfExists: [
                'offset',
                'preventOverflow',
                'flip'
            ],
            fn: function fn(_ref3) {
                var _data$viewport, _data$viewport2, _state$modifiersData$2, _state$modifiersData;
                var state = _ref3.state;
                var data = state.modifiersData.maxSizeData;
                if (typeof (data === null || data === void 0 || (_data$viewport = data.viewport) === null || _data$viewport === void 0 ? void 0 : _data$viewport.width) !== 'number' || typeof (data === null || data === void 0 || (_data$viewport2 = data.viewport) === null || _data$viewport2 === void 0 ? void 0 : _data$viewport2.height) !== 'number') // This shouldn't occur in a real browser but might in non-browser test environments
                return;
                var viewport = data.viewport;
                var _state$modifiersData$ = state.modifiersData.popperOffsets, popperOffsets = _state$modifiersData$ === void 0 ? {
                    x: 0,
                    y: 0
                } : _state$modifiersData$;
                var _state$placement$spli = state.placement.split('-'), _state$placement$spli2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_state$placement$spli, 1), basePlacement = _state$placement$spli2[0];
                var placementOffset = (_state$modifiersData$2 = (_state$modifiersData = state.modifiersData) === null || _state$modifiersData === void 0 || (_state$modifiersData = _state$modifiersData.offset) === null || _state$modifiersData === void 0 ? void 0 : _state$modifiersData[state.placement]) !== null && _state$modifiersData$2 !== void 0 ? _state$modifiersData$2 : {
                    x: 0,
                    y: 0
                };
                // By default we set these to the entire viewport (minus padding)
                // Each placement direction will overwrite one of these
                var maxWidth = viewport.width - 2 * viewportPadding;
                var maxHeight = viewport.height - 2 * viewportPadding;
                if (basePlacement === 'top') maxHeight = state.rects.reference.y + // Viewport-relative position of reference element
                placementOffset.y - // Space between popper and reference
                viewportPadding;
                if (basePlacement === 'bottom') maxHeight = viewport.height - popperOffsets.y - // Viewport-relative position of popper
                viewportPadding;
                if (basePlacement === 'left') maxWidth = state.rects.reference.x + // Viewport-relative position of reference element
                placementOffset.x - // Space between popper and reference
                viewportPadding;
                if (basePlacement === 'right') maxWidth = viewport.width - popperOffsets.x - // Viewport-relative position of popper
                viewportPadding;
                state.styles.popper.maxWidth = "".concat(maxWidth, "px");
                state.styles.popper.maxHeight = "".concat(maxHeight, "px");
            }
        }
    ];
}

});


parcelRegister("esE7Z", function(module, exports) {
$parcel$export(module.exports, "register", () => $a872cec7ab1db00b$export$6503ec6e8aabbaf);
/* eslint-disable @atlaskit/design-system/no-direct-use-of-web-platform-drag-and-drop */ /**
 * We are listening directly to drag events instead of using a monitor from
 * `@atlaskit/pragmatic-drag-and-drop` to avoid the bundle size cost, as it
 * would affect almost every view in every product.
 *
 * We can reconsider this choice in the future.
 */ 
var $7QpUe = parcelRequire("7QpUe");
var $a872cec7ab1db00b$var$registrations = new Set();
var $a872cec7ab1db00b$var$cleanupEndEventListeners = null;
function $a872cec7ab1db00b$var$onDragStart() {
    if ($a872cec7ab1db00b$var$cleanupEndEventListeners) // If the cleanup function exists then we've already run this
    return;
    $a872cec7ab1db00b$var$cleanupEndEventListeners = (0, $7QpUe.bindAll)(window, [
        {
            type: 'dragend',
            listener: $a872cec7ab1db00b$var$onDragEnd
        },
        {
            type: 'pointerdown',
            listener: $a872cec7ab1db00b$var$onDragEnd
        },
        {
            type: 'pointermove',
            listener: function() {
                var callCount = 0;
                return function listener() {
                    // Using 20 as it is far bigger than the most observed (3)
                    if (callCount < 20) {
                        callCount++;
                        return;
                    }
                    $a872cec7ab1db00b$var$onDragEnd();
                };
            }()
        }
    ]);
    var clone = Array.from($a872cec7ab1db00b$var$registrations);
    clone.forEach(function(subscriber) {
        subscriber.onDragStart();
    });
}
function $a872cec7ab1db00b$var$onDragEnd() {
    var _cleanupEndEventListe;
    (_cleanupEndEventListe = $a872cec7ab1db00b$var$cleanupEndEventListeners) === null || _cleanupEndEventListe === void 0 || _cleanupEndEventListe();
    $a872cec7ab1db00b$var$cleanupEndEventListeners = null;
    var clone = Array.from($a872cec7ab1db00b$var$registrations);
    clone.forEach(function(subscriber) {
        subscriber.onDragEnd();
    });
}
function $a872cec7ab1db00b$var$bindStartEvents() {
    return (0, $7QpUe.bindAll)(window, [
        {
            type: 'dragstart',
            listener: $a872cec7ab1db00b$var$onDragStart
        },
        {
            type: 'dragenter',
            listener: $a872cec7ab1db00b$var$onDragStart
        }
    ]);
}
var $a872cec7ab1db00b$var$cleanupStartEventListeners = null;
function $a872cec7ab1db00b$export$6503ec6e8aabbaf(registration) {
    // if first registration, bind event listeners
    if (!$a872cec7ab1db00b$var$cleanupStartEventListeners) // note: currently never unbinding these event listeners
    $a872cec7ab1db00b$var$cleanupStartEventListeners = $a872cec7ab1db00b$var$bindStartEvents();
    $a872cec7ab1db00b$var$registrations.add(registration);
    /**
   * The reasoning for this behavior is so that if a tooltip mounts during
   * a drag it can still be suppressed.
   *
   * We use a separate callback instead of onDragStart to avoid infinite loops.
   */ registration.onRegister({
        isDragging: $a872cec7ab1db00b$var$cleanupEndEventListeners !== null
    });
    return function unregister() {
        $a872cec7ab1db00b$var$registrations.delete(registration);
        if ($a872cec7ab1db00b$var$registrations.size === 0) {
            var _cleanupStartEventLis;
            (_cleanupStartEventLis = $a872cec7ab1db00b$var$cleanupStartEventListeners) === null || _cleanupStartEventLis === void 0 || _cleanupStartEventLis();
            $a872cec7ab1db00b$var$cleanupStartEventListeners = null;
        }
    };
}

});

parcelRegister("5sp2R", function(module, exports) {
$parcel$export(module.exports, "show", () => $3f92febc2f10d6a2$export$57bf213be019eeb0);

var $gqyYV = parcelRequire("gqyYV");
// This file is a singleton for managing tooltips
var $3f92febc2f10d6a2$var$active = null;
function $3f92febc2f10d6a2$export$57bf213be019eeb0(entry) {
    var phase = 'waiting-to-show';
    function isActive() {
        return Boolean($3f92febc2f10d6a2$var$active && $3f92febc2f10d6a2$var$active.entry === entry);
    }
    function cleanup() {
        if (isActive()) {
            (0, $gqyYV.clearScheduled)();
            $3f92febc2f10d6a2$var$active = null;
        }
    }
    function done() {
        if (isActive()) entry.done();
        phase = 'done';
        cleanup();
    }
    function immediatelyHideAndDone() {
        if (isActive()) entry.hide({
            isImmediate: true
        });
        done();
    }
    function keep() {
        if (!isActive()) return;
        // aborting a wait to hide
        if (phase === 'waiting-to-hide') {
            phase = 'shown';
            (0, $gqyYV.clearScheduled)();
            return;
        }
        // aborting hide animation
        if (phase === 'hide-animating') {
            phase = 'shown';
            (0, $gqyYV.clearScheduled)();
            entry.show({
                isImmediate: false
            });
            return;
        }
    }
    function requestHide(_ref) {
        var isImmediate = _ref.isImmediate;
        if (!isActive()) return;
        // If we were not showing yet anyway; finish straight away
        if (phase === 'waiting-to-show') {
            immediatelyHideAndDone();
            return;
        }
        // already waiting to hide
        if (phase === 'waiting-to-hide') return;
        if (isImmediate) {
            immediatelyHideAndDone();
            return;
        }
        phase = 'waiting-to-hide';
        (0, $gqyYV.scheduleTimeout)(function() {
            phase = 'hide-animating';
            entry.hide({
                isImmediate: false
            });
        }, entry.delay);
    }
    function finishHideAnimation() {
        if (isActive() && phase === 'hide-animating') done();
    }
    function isVisible() {
        return phase === 'shown' || phase === 'waiting-to-hide' || phase === 'hide-animating';
    }
    function getInitialMouse() {
        if (entry.source.type === 'mouse') return entry.source.mouse;
        return null;
    }
    function start() {
        var showImmediately = Boolean($3f92febc2f10d6a2$var$active && $3f92febc2f10d6a2$var$active.isVisible());
        // If there was an active tooltip; we tell it to remove itself at once!
        if ($3f92febc2f10d6a2$var$active) {
            (0, $gqyYV.clearScheduled)();
            $3f92febc2f10d6a2$var$active.entry.hide({
                isImmediate: true
            });
            $3f92febc2f10d6a2$var$active.entry.done();
            $3f92febc2f10d6a2$var$active = null;
        }
        // this tooltip is now the active tooltip
        $3f92febc2f10d6a2$var$active = {
            entry: entry,
            isVisible: isVisible
        };
        function show() {
            phase = 'shown';
            entry.show({
                isImmediate: showImmediately
            });
        }
        if (showImmediately) {
            show();
            return;
        }
        phase = 'waiting-to-show';
        (0, $gqyYV.scheduleTimeout)(show, entry.delay);
    }
    // let's get started!
    start();
    var result = {
        keep: keep,
        abort: cleanup,
        isActive: isActive,
        requestHide: requestHide,
        finishHideAnimation: finishHideAnimation,
        mousePosition: getInitialMouse()
    };
    return result;
}

});
parcelRegister("gqyYV", function(module, exports) {
$parcel$export(module.exports, "clearScheduled", () => $bf5a35ac4e2f18a4$export$eaf678f6f93f5250);
$parcel$export(module.exports, "scheduleTimeout", () => $bf5a35ac4e2f18a4$export$5f4d6617421d489b);
var $bf5a35ac4e2f18a4$var$delayId = null;
function $bf5a35ac4e2f18a4$export$eaf678f6f93f5250() {
    if ($bf5a35ac4e2f18a4$var$delayId != null) {
        window.clearTimeout($bf5a35ac4e2f18a4$var$delayId);
        $bf5a35ac4e2f18a4$var$delayId = null;
    }
}
function $bf5a35ac4e2f18a4$export$5f4d6617421d489b(fn, delay) {
    $bf5a35ac4e2f18a4$export$eaf678f6f93f5250();
    $bf5a35ac4e2f18a4$var$delayId = window.setTimeout(function() {
        $bf5a35ac4e2f18a4$var$delayId = null;
        fn();
    }, delay);
}

});


parcelRegister("2hND8", function(module, exports) {
$parcel$export(module.exports, "default", () => $1aa3aad41915ad32$export$2e2bcd8739ae039);

var $hbl7m = parcelRequire("hbl7m");
function $1aa3aad41915ad32$export$2e2bcd8739ae039(prefix, shouldRenderId) {
    var seed = (0, $hbl7m.useIdSeed)();
    return shouldRenderId ? "".concat(seed(prefix)) : undefined;
}

});

parcelRegister("eqvOo", function(module, exports) {
$parcel$export(module.exports, "default", () => $a80c2b91439509b8$export$2e2bcd8739ae039);
/* tooltip-container.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $25nEq = parcelRequire("25nEq");

var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");
var $cAVP0 = parcelRequire("cAVP0");

var $dSRcG = parcelRequire("dSRcG");

var $3GpPz = parcelRequire("3GpPz");
function $a80c2b91439509b8$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $a80c2b91439509b8$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $a80c2b91439509b8$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $a80c2b91439509b8$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $a80c2b91439509b8$var$baseStyles = null;
var $a80c2b91439509b8$var$truncateStyles = null;
/**
 * Used as the default tooltip container component for the exported `Tooltip` component.
 * Adds some styles to the tooltip primitive.
 */ var $a80c2b91439509b8$var$TooltipContainer = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function TooltipContainer(_ref, ref) {
    var style = _ref.style, className = _ref.className, children = _ref.children, truncate = _ref.truncate, placement = _ref.placement, testId = _ref.testId, onMouseOut = _ref.onMouseOut, onMouseOver = _ref.onMouseOver, id = _ref.id;
    return /*#__PURE__*/ $5FkrB.createElement((0, $3GpPz.default), {
        ref: ref,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $970q7.default)([
            "_2rko1sit _11c8dcr7 _vchhusvi _p12fp3fh _bfhkpioe _syaz1i9p _152tze3t _1e02ze3t _1i4q1hna _85i5v77o _1q51v77o _y4ti12x7 _bozg12x7 _slp31hna",
            truncate && "_1reo15vq _18m915vq _p12f1pna _1bto1l2s _o5721q9c",
            className
        ]),
        placement: placement,
        testId: testId,
        id: id,
        onMouseOut: onMouseOut,
        onMouseOver: onMouseOver,
        style: $a80c2b91439509b8$var$_objectSpread($a80c2b91439509b8$var$_objectSpread({}, style), {}, {
            "--_yr7xfv": (0, $cAVP0.default)("var(--ds-background-neutral-bold, ".concat((0, $dSRcG.N800), ")")),
            "--_ywovvi": (0, $cAVP0.default)("var(--ds-text-inverse, ".concat((0, $dSRcG.N0), ")"))
        })
    }, children);
});
$a80c2b91439509b8$var$TooltipContainer.displayName = 'TooltipContainer';
var $a80c2b91439509b8$export$2e2bcd8739ae039 = $a80c2b91439509b8$var$TooltipContainer;

});
parcelRegister("3GpPz", function(module, exports) {
$parcel$export(module.exports, "default", () => $2ae954d03fcd170a$export$2e2bcd8739ae039);

var $25nEq = parcelRequire("25nEq");

var $5FkrB = parcelRequire("5FkrB");

var $74Zh5 = parcelRequire("74Zh5");

var $H74DA = parcelRequire("H74DA");
function $2ae954d03fcd170a$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $2ae954d03fcd170a$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $2ae954d03fcd170a$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $2ae954d03fcd170a$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $2ae954d03fcd170a$var$VAR_PRIMITIVE_ZINDEX = 'tooltipPrimitiveZindex';
var $2ae954d03fcd170a$var$primitiveStyles = (0, $74Zh5.css)({
    zindex: "var(".concat($2ae954d03fcd170a$var$VAR_PRIMITIVE_ZINDEX, ")"),
    cursor: "default"
});
/**
 * The lower level component for rendering a tooltip.
 */ var $2ae954d03fcd170a$var$TooltipPrimitive = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function TooltipPrimitive(_ref, ref) {
    var style = _ref.style, className = _ref.className, children = _ref.children, placement = _ref.placement, testId = _ref.testId, onMouseOut = _ref.onMouseOut, onMouseOver = _ref.onMouseOver, id = _ref.id;
    var styleWithZIndex = $2ae954d03fcd170a$var$_objectSpread($2ae954d03fcd170a$var$_objectSpread({}, style), {}, (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, $2ae954d03fcd170a$var$VAR_PRIMITIVE_ZINDEX, (0, $H74DA.layers).tooltip()));
    return (0, $74Zh5.jsx)("div", {
        ref: ref,
        style: styleWithZIndex,
        "data-testid": testId ? "".concat(testId, "--wrapper") : undefined
    }, (0, $74Zh5.jsx)("div", {
        role: "tooltip",
        className: className,
        onMouseOut: onMouseOut,
        onMouseOver: onMouseOver,
        css: $2ae954d03fcd170a$var$primitiveStyles,
        "data-placement": placement,
        "data-testid": testId,
        id: id
    }, children));
});
$2ae954d03fcd170a$var$TooltipPrimitive.displayName = 'TooltipPrimitive';
var $2ae954d03fcd170a$export$2e2bcd8739ae039 = $2ae954d03fcd170a$var$TooltipPrimitive;

});


parcelRegister("37Jbg", function(module, exports) {
$parcel$export(module.exports, "getMousePosition", () => $24651280b677bee9$export$642213d516a9b928);
function $24651280b677bee9$export$642213d516a9b928(mouseCoordinates) {
    var safeMouse = mouseCoordinates || {
        top: 0,
        left: 0
    };
    var getBoundingClientRect = function getBoundingClientRect() {
        return {
            top: safeMouse.top,
            left: safeMouse.left,
            bottom: safeMouse.top,
            right: safeMouse.left,
            width: 0,
            height: 0
        };
    };
    return {
        getBoundingClientRect: getBoundingClientRect,
        clientWidth: 0,
        clientHeight: 0
    };
}

});


parcelRegister("9KR88", function(module, exports) {
$parcel$export(module.exports, "default", () => $71a19f81200847a5$export$2e2bcd8739ae039);
/* visually-hidden.tsx generated by @compiled/babel-plugin v0.36.1 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
// eslint-disable-next-line @atlaskit/design-system/use-visually-hidden

var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");
var $71a19f81200847a5$var$visuallyHiddenStyles = null;
/**
 * __Visually hidden__
 *
 * A composable element to apply a visually hidden effect to children.
 * Useful for accessibility compliance.
 *
 * @example
 * ```jsx
 * import VisuallyHidden from '@atlaskit/visually-hidden';
 *
 * export default () => (
 *   <div style={{ border: '1px solid black' }}>
 *      There is text hidden between the brackets [
 *      <VisuallyHidden>Can't see me!</VisuallyHidden>]
 *   </div>
 * );
 * ```
 */ var $71a19f81200847a5$var$VisuallyHidden = function VisuallyHidden(_ref) {
    var children = _ref.children, testId = _ref.testId, role = _ref.role, id = _ref.id;
    return /*#__PURE__*/ $5FkrB.createElement("span", {
        id: id,
        "data-testid": testId,
        role: role,
        className: (0, $970q7.default)([
            "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19itidpf _1reo15vq _18m915vq _1bsbt94y _4t3it94y _kqswstnw _ogto7mnp _o5721q9c"
        ])
    }, children);
};
var $71a19f81200847a5$export$2e2bcd8739ae039 = $71a19f81200847a5$var$VisuallyHidden;

});

parcelRegister("5ZsYZ", function(module, exports) {
$parcel$export(module.exports, "default", () => $45c9219f22f72e10$export$2e2bcd8739ae039);
/* button-base.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $kqp0i = parcelRequire("kqp0i");

var $1Vcia = parcelRequire("1Vcia");

var $970q7 = parcelRequire("970q7");

var $5FkrB = parcelRequire("5FkrB");

var $lJnLZ = parcelRequire("lJnLZ");

var $5GRVe = parcelRequire("5GRVe");

var $4KvIl = parcelRequire("4KvIl");

var $i7Fu5 = parcelRequire("i7Fu5");

var $legyX = parcelRequire("legyX");

var $hp0B0 = parcelRequire("hp0B0");

var $9KR88 = parcelRequire("9KR88");

var $lLoMC = parcelRequire("lLoMC");

var $a11no = parcelRequire("a11no");

var $13yI1 = parcelRequire("13yI1");
var $45c9219f22f72e10$var$_excluded = [
    "appearance",
    "autoFocus",
    "isDisabled",
    "isLoading",
    "isSelected",
    "isIconButton",
    "isCircle",
    "hasIconBefore",
    "hasIconAfter",
    "shouldFitContainer",
    "spacing",
    "ariaLabel",
    "ariaLabelledBy",
    "children",
    "interactionName",
    "onClick",
    "onMouseDown",
    "onMouseDownCapture",
    "onMouseUp",
    "onMouseUpCapture",
    "onKeyDown",
    "onKeyDownCapture",
    "onKeyUp",
    "onKeyUpCapture",
    "onTouchStart",
    "onTouchStartCapture",
    "onTouchEnd",
    "onTouchEndCapture",
    "onPointerDown",
    "onPointerDownCapture",
    "onPointerUp",
    "onPointerUpCapture",
    "onClickCapture",
    "testId",
    "analyticsContext",
    "componentName",
    "role",
    "onMouseOver",
    "onMouseOut",
    "onFocus",
    "onBlur",
    "onMouseMove",
    "type"
], $45c9219f22f72e10$var$_excluded2 = [
    "className",
    "css",
    "as",
    "style"
];
var $45c9219f22f72e10$var$LOADING_LABEL = ', Loading';
var $45c9219f22f72e10$var$styles = {
    base: "_2rkosqtm _11c82smr _v5649dqc _189eidpf _1rjc12x7 _1e0c116y _vchhusvi _1bsb1wug _p12f1osq _kqswh2mm _4cvr1q9y _1bah1h6o _gy1p1b66 _1o9zidpf _4t3iviql _k48p1wq8 _y4tiutpp _bozgutpp _y3gn1h6o _s7n4nkob _14mj1kw7 _9v7aze3t _1tv3nqa1 _39yqe4h9 _11fnglyw _18postnw",
    linkDecorationUnset: "_4bfu1r31 _1hmsglyw _ajmmnqa1 _1a3b1r31 _4fprglyw _5goinqa1 _9oik1r31 _1bnxglyw _jf4cnqa1 _1nrm1r31 _c2waglyw _1iohnqa1",
    disabled: "_80om13gf _bfhk1fvb _syaz1lh4 _aetrglyw _irr31fvb _30l31lh4 _1di61fvb _9h8h1lh4",
    spacingCompact: "_1rjcv77o _gy1p1b66 _4t3i1k8s _y4tiutpp _bozgutpp _s7n4nkob",
    circle: "_2rko14q2",
    fullWidth: "_1bsb1osq",
    loading: "_80om15jw",
    iconButton: "_4t3iviql _1bsbviql _y4tize3t _bozgze3t",
    iconButtonCompact: "_4t3i1k8s _1bsb1k8s",
    buttonIconBefore: "_bozgu2gc",
    buttonIconAfter: "_y4tiu2gc",
    splitButton: "_g0pbb4wl",
    loadingOverlay: "_1e0c1txw _kqswstnw _4cvr1h6o _1bah1h6o _u7coze3t _152tze3t _rjxpze3t _1e02ze3t",
    navigationSplitButton: "_1bsb1tcg _bfhksm61 _y4ti12x7 _bozg12x7"
};
var $45c9219f22f72e10$var$defaultStyles = {
    root: "_bfhk1j54 _syaz10s3 _105310s3 _f8pj10s3 _30l310s3 _9h8h10s3",
    rootRefreshed: "_bfhksm61 _syaz1gjq _8l3mmuej _aetrb3bt _10531gjq _f8pj1gjq _30l31gjq _9h8h1gjq",
    interactive: "_irr3yw9d _30l310s3 _1di6ih13 _9h8h10s3",
    interactiveRefreshed: "_irr3166n _30l31gjq _1di61dty _9h8h1gjq"
};
var $45c9219f22f72e10$var$primaryStyles = {
    root: "_bfhkomb0 _syaz15cr _105315cr _f8pj15cr _30l315cr _9h8h15cr",
    interactive: "_30l315cr _irr31wqm _9h8h15cr _1di617hq"
};
var $45c9219f22f72e10$var$warningStyles = {
    root: "_bfhk1ikc _syazal3n _1053al3n _f8pjal3n _30l3al3n _9h8hal3n",
    interactive: "_30l3al3n _irr31j43 _9h8hal3n _1di6h4op"
};
var $45c9219f22f72e10$var$dangerStyles = {
    root: "_bfhk1v7l _syaz15cr _105315cr _f8pj15cr _30l315cr _9h8h15cr",
    interactive: "_30l315cr _irr31rwk _9h8h15cr _1di6yycf"
};
var $45c9219f22f72e10$var$discoveryStyles = {
    root: "_bfhk1vbi _syaz15cr _105315cr _f8pj15cr _30l315cr _9h8h15cr",
    interactive: "_30l315cr _irr37gr8 _9h8h15cr _1di61wu2"
};
var $45c9219f22f72e10$var$subtleStyles = {
    root: "_bfhkqtfy _syaz10s3 _105310s3 _f8pj10s3 _30l310s3 _9h8h10s3",
    rootRefreshed: "_bfhkqtfy _syaz1gjq _10531gjq _f8pj1gjq _30l31gjq _9h8h1gjq",
    interactive: "_irr34mfv _30l310s3 _1di619qy _9h8h10s3",
    interactiveRefreshed: "_irr34mfv _30l31gjq _1di619qy _9h8h1gjq"
};
var $45c9219f22f72e10$var$selectedStyles = {
    root: "_bfhk7btw _syaz1pke _10531pke _f8pj1pke _30l31pke _9h8h1pke",
    rootRefreshed: "_bfhkfg4m _syaz1ldt _8l3mcoux _aetrb3bt _10531ldt _f8pj1ldt _30l31ldt _9h8h1ldt",
    insideSplitButton: "_1pbycs5v",
    interactive: "_irr3t71w _30l31pke _1di6yssv _9h8h1pke",
    warning: "_bfhkvdtc _syaz16q2 _30l31pke _irr3vdtc _9h8h1pke _1di6vdtc",
    danger: "_bfhkbeib _syaz1pke _30l31pke _irr3beib _9h8h1pke _1di6beib",
    discovery: "_bfhk1g49 _syaz1pke _30l31pke _irr31g49 _9h8h1pke _1di61g49"
};
/**
 * __button base__
 *
 * - Implements auto focus when enabled.
 * - Appends the `onClick` event with UFO analytics tracking.
 *
 * @private
 */ var $45c9219f22f72e10$var$ButtonBase = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).forwardRef(function(_ref, ref) {
    var propAppearance = _ref.appearance, _ref$autoFocus = _ref.autoFocus, autoFocus = _ref$autoFocus === void 0 ? false : _ref$autoFocus, _ref$isDisabled = _ref.isDisabled, propIsDisabled = _ref$isDisabled === void 0 ? false : _ref$isDisabled, _ref$isLoading = _ref.isLoading, isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading, _ref$isSelected = _ref.isSelected, propIsSelected = _ref$isSelected === void 0 ? false : _ref$isSelected, _ref$isIconButton = _ref.isIconButton, isIconButton = _ref$isIconButton === void 0 ? false : _ref$isIconButton, _ref$isCircle = _ref.isCircle, isCircle = _ref$isCircle === void 0 ? false : _ref$isCircle, _ref$hasIconBefore = _ref.hasIconBefore, hasIconBefore = _ref$hasIconBefore === void 0 ? false : _ref$hasIconBefore, _ref$hasIconAfter = _ref.hasIconAfter, hasIconAfter = _ref$hasIconAfter === void 0 ? false : _ref$hasIconAfter, _ref$shouldFitContain = _ref.shouldFitContainer, shouldFitContainer = _ref$shouldFitContain === void 0 ? false : _ref$shouldFitContain, _ref$spacing = _ref.spacing, propSpacing = _ref$spacing === void 0 ? 'default' : _ref$spacing, ariaLabel = _ref.ariaLabel, ariaLabelledBy = _ref.ariaLabelledBy, children = _ref.children, interactionName = _ref.interactionName, onClick = _ref.onClick, onMouseDown = _ref.onMouseDown, onMouseDownCapture = _ref.onMouseDownCapture, onMouseUp = _ref.onMouseUp, onMouseUpCapture = _ref.onMouseUpCapture, onKeyDown = _ref.onKeyDown, onKeyDownCapture = _ref.onKeyDownCapture, onKeyUp = _ref.onKeyUp, onKeyUpCapture = _ref.onKeyUpCapture, onTouchStart = _ref.onTouchStart, onTouchStartCapture = _ref.onTouchStartCapture, onTouchEnd = _ref.onTouchEnd, onTouchEndCapture = _ref.onTouchEndCapture, onPointerDown = _ref.onPointerDown, onPointerDownCapture = _ref.onPointerDownCapture, onPointerUp = _ref.onPointerUp, onPointerUpCapture = _ref.onPointerUpCapture, onClickCapture = _ref.onClickCapture, testId = _ref.testId, analyticsContext = _ref.analyticsContext, componentName = _ref.componentName, role = _ref.role, onMouseOver = _ref.onMouseOver, onMouseOut = _ref.onMouseOut, onFocus = _ref.onFocus, onBlur = _ref.onBlur, onMouseMove = _ref.onMouseMove, type = _ref.type, unsafeRest = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $45c9219f22f72e10$var$_excluded);
    var localRef = (0, $5FkrB.useRef)(null);
    var splitButtonContext = (0, $lLoMC.useSplitButtonContext)();
    var loadingLabelId = (0, $i7Fu5.useId)();
    var isSplitButton = Boolean(splitButtonContext);
    var isNavigationSplitButton = (splitButtonContext === null || splitButtonContext === void 0 ? void 0 : splitButtonContext.isNavigationSplitButton) || false;
    var isDefaultAppearanceSplitButton = (splitButtonContext === null || splitButtonContext === void 0 ? void 0 : splitButtonContext.appearance) === 'default';
    var appearance = isDefaultAppearanceSplitButton && (0, $legyX.fg)('platform-component-visual-refresh') ? 'subtle' : propAppearance || (splitButtonContext === null || splitButtonContext === void 0 ? void 0 : splitButtonContext.appearance) || 'default';
    var spacing = (splitButtonContext === null || splitButtonContext === void 0 ? void 0 : splitButtonContext.spacing) || propSpacing;
    var isDisabled = (splitButtonContext === null || splitButtonContext === void 0 ? void 0 : splitButtonContext.isDisabled) || propIsDisabled;
    var isInteractive = !isDisabled && !isLoading;
    // Also treat loading buttons as disabled
    var isEffectivelyDisabled = isDisabled || isLoading;
    var isSelected = propIsSelected && !isDisabled;
    (0, $4KvIl.default)(localRef, autoFocus);
    // @ts-expect-error
    var _className = unsafeRest.className, _css = unsafeRest.css, _as = unsafeRest.as, _style = unsafeRest.style, saferRest = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(unsafeRest, $45c9219f22f72e10$var$_excluded2);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $hp0B0.default), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, saferRest, {
        componentName: componentName || 'button',
        analyticsContext: analyticsContext,
        role: role,
        ref: (0, $5GRVe.default)([
            localRef,
            ref
        ]),
        xcss: (0, $lJnLZ.cx)($45c9219f22f72e10$var$styles.base, appearance === 'default' && ((0, $legyX.fg)('platform-component-visual-refresh') ? $45c9219f22f72e10$var$defaultStyles.rootRefreshed : $45c9219f22f72e10$var$defaultStyles.root), appearance === 'default' && isInteractive && ((0, $legyX.fg)('platform-component-visual-refresh') ? $45c9219f22f72e10$var$defaultStyles.interactiveRefreshed : $45c9219f22f72e10$var$defaultStyles.interactive), appearance === 'primary' && $45c9219f22f72e10$var$primaryStyles.root, appearance === 'primary' && isInteractive && $45c9219f22f72e10$var$primaryStyles.interactive, appearance === 'warning' && $45c9219f22f72e10$var$warningStyles.root, appearance === 'warning' && isInteractive && $45c9219f22f72e10$var$warningStyles.interactive, appearance === 'danger' && $45c9219f22f72e10$var$dangerStyles.root, appearance === 'danger' && isInteractive && $45c9219f22f72e10$var$dangerStyles.interactive, appearance === 'discovery' && $45c9219f22f72e10$var$discoveryStyles.root, appearance === 'discovery' && isInteractive && $45c9219f22f72e10$var$discoveryStyles.interactive, appearance === 'subtle' && ((0, $legyX.fg)('platform-component-visual-refresh') ? $45c9219f22f72e10$var$subtleStyles.rootRefreshed : $45c9219f22f72e10$var$subtleStyles.root), appearance === 'subtle' && isInteractive && ((0, $legyX.fg)('platform-component-visual-refresh') ? $45c9219f22f72e10$var$subtleStyles.interactiveRefreshed : $45c9219f22f72e10$var$subtleStyles.interactive), $45c9219f22f72e10$var$styles.linkDecorationUnset, isSelected && ((0, $legyX.fg)('platform-component-visual-refresh') ? $45c9219f22f72e10$var$selectedStyles.rootRefreshed : $45c9219f22f72e10$var$selectedStyles.root), isSelected && isSplitButton && $45c9219f22f72e10$var$selectedStyles.insideSplitButton, isSelected && isInteractive && $45c9219f22f72e10$var$selectedStyles.interactive, // TODO: remove me once we kill color fallbacks
        isSelected && appearance === 'danger' && $45c9219f22f72e10$var$selectedStyles.danger, // TODO: remove me once we kill color fallbacks
        isSelected && appearance === 'warning' && $45c9219f22f72e10$var$selectedStyles.warning, // TODO: remove me once we kill color fallbacks
        isSelected && appearance === 'discovery' && $45c9219f22f72e10$var$selectedStyles.discovery, isDisabled && $45c9219f22f72e10$var$styles.disabled, isCircle && !isSplitButton && $45c9219f22f72e10$var$styles.circle, spacing === 'compact' && $45c9219f22f72e10$var$styles.spacingCompact, hasIconBefore && $45c9219f22f72e10$var$styles.buttonIconBefore, shouldFitContainer && $45c9219f22f72e10$var$styles.fullWidth, hasIconAfter && $45c9219f22f72e10$var$styles.buttonIconAfter, isIconButton && $45c9219f22f72e10$var$styles.iconButton, isIconButton && spacing === 'compact' && $45c9219f22f72e10$var$styles.iconButtonCompact, isLoading && $45c9219f22f72e10$var$styles.loading, isSplitButton && $45c9219f22f72e10$var$styles.splitButton, isNavigationSplitButton && $45c9219f22f72e10$var$styles.navigationSplitButton),
        isDisabled: isEffectivelyDisabled,
        "aria-label": isLoading && ariaLabel && !ariaLabelledBy ? "".concat(ariaLabel, " ").concat($45c9219f22f72e10$var$LOADING_LABEL) : ariaLabel,
        "aria-labelledby": isLoading && ariaLabelledBy ? "".concat(ariaLabelledBy, " ").concat(loadingLabelId) : ariaLabelledBy,
        onClick: onClick
    }, (0, $a11no.default)(isEffectivelyDisabled, {
        onMouseDownCapture: onMouseDownCapture,
        onMouseUpCapture: onMouseUpCapture,
        onKeyDownCapture: onKeyDownCapture,
        onKeyUpCapture: onKeyUpCapture,
        onTouchStartCapture: onTouchStartCapture,
        onTouchEndCapture: onTouchEndCapture,
        onPointerDownCapture: onPointerDownCapture,
        onPointerUpCapture: onPointerUpCapture,
        onClickCapture: onClickCapture
    }), {
        testId: testId,
        onMouseOver: onMouseOver,
        onFocus: onFocus,
        onMouseMove: onMouseMove,
        onBlur: onBlur,
        type: type,
        interactionName: interactionName,
        onMouseDown: onMouseDown,
        onMouseUp: onMouseUp,
        onKeyDown: onKeyDown,
        onMouseOut: onMouseOut,
        onKeyUp: onKeyUp,
        onTouchStart: onTouchStart,
        onTouchEnd: onTouchEnd,
        onPointerDown: onPointerDown,
        onPointerUp: onPointerUp
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $5FkrB.Fragment), null, children, isLoading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("span", {
        className: (0, $970q7.default)([
            $45c9219f22f72e10$var$styles.loadingOverlay
        ])
    }, (0, $13yI1.default)({
        spacing: spacing,
        appearance: appearance,
        isDisabled: isDisabled,
        isSelected: isSelected,
        testId: testId
    })), isLoading && (ariaLabelledBy || !ariaLabel) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $9KR88.default), {
        id: loadingLabelId
    }, $45c9219f22f72e10$var$LOADING_LABEL)));
});
var $45c9219f22f72e10$export$2e2bcd8739ae039 = $45c9219f22f72e10$var$ButtonBase;

});
parcelRegister("lJnLZ", function(module, exports) {
$parcel$export(module.exports, "cx", () => $fd203dcc00df7a72$export$a274e22fb40f762e);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ parcelRequire("5FkrB");


var $Pd8py = parcelRequire("Pd8py");
var $fd203dcc00df7a72$var$_createStrictAPI = (0, $Pd8py.createStrictAPI)(), $fd203dcc00df7a72$var$XCSSProp = $fd203dcc00df7a72$var$_createStrictAPI.XCSSProp, $fd203dcc00df7a72$export$dbf350e5966cf602 = $fd203dcc00df7a72$var$_createStrictAPI.css, $fd203dcc00df7a72$export$eb1ecd84a24ee424 = $fd203dcc00df7a72$var$_createStrictAPI.cssMap, $fd203dcc00df7a72$export$a274e22fb40f762e = $fd203dcc00df7a72$var$_createStrictAPI.cx;
 // This is to mitigate local TS error TS2315: Type 'StrictXCSSProp' is not generic.
 // Currently for some reason tsc is generating malformed .d.ts in local dev environment, below change fixes it
 /**
 * ## StrictXCSSProp
 *
 * Declare styles your component takes with all other styles marked as violations
 * by the TypeScript compiler. There are two primary use cases for xcss prop:
 *
 * - safe style overrides
 * - inverting style declarations
 *
 * Interverting style declarations is interesting for platform teams as
 * it means products only pay for styles they use as they're now the ones who declare
 * the styles!
 *
 * The {@link StrictXCSSProp} type has generics two of which must be defined — use to explicitly
 * set what you want to maintain as API. Use {@link XCSSAllProperties} and {@link XCSSAllPseudos}
 * to enable all properties and pseudos.
 *
 * The third generic is used to declare what properties and pseudos should be required.
 *
 * ```tsx
 * interface MyComponentProps {
 *   // Color is accepted, all other properties / pseudos are considered violations.
 *   xcss?: StrictXCSSProp<'color', never>;
 *
 *   // Only background color and hover pseudo are accepted.
 *   xcss?: StrictXCSSProp<'backgroundColor', '&:hover'>;
 *
 *   // All properties are accepted, all pseudos are considered violations.
 *   xcss?: StrictXCSSProp<XCSSAllProperties, never>;
 *
 *   // All properties are accepted, only the hover pseudo is accepted.
 *   xcss?: StrictXCSSProp<XCSSAllProperties, '&:hover'>;
 *
 *   // The xcss prop is required as well as the color property. No pseudos are required.
 *   xcss: StrictXCSSProp<
 *     XCSSAllProperties,
 *     '&:hover',
 *     { requiredProperties: 'color', requiredPseudos: never }
 *   >;
 * }
 *
 * function MyComponent({ xcss }: MyComponentProps) {
 *   return <div css={{ color: 'var(--ds-text-danger)' }} className={xcss} />
 * }
 * ```
 *
 * The xcss prop works with static inline objects and the [cssMap](https://compiledcssinjs.com/docs/api-cssmap) API.
 *
 * ```jsx
 * // Declared as an inline object
 * <Component xcss={{ color: 'var(--ds-text)' }} />
 *
 * // Declared with the cssMap API
 * const styles = cssMap({ text: { color: 'var(--ds-text)' } });
 * <Component xcss={styles.text} />
 * ```
 *
 * To concatenate and conditonally apply styles use the {@link cssMap} and {@link cx} functions.
 */ 
});

parcelRegister("4KvIl", function(module, exports) {
$parcel$export(module.exports, "default", () => $37540f1c2a76f1e4$export$2e2bcd8739ae039);

var $5FkrB = parcelRequire("5FkrB");
function $37540f1c2a76f1e4$export$2e2bcd8739ae039(ref, autoFocus) {
    var initialMount = (0, $5FkrB.useRef)(true);
    (0, $5FkrB.useEffect)(function() {
        if (ref && initialMount.current && autoFocus && ref.current) ref.current.focus();
        initialMount.current = false;
    }, [
        autoFocus,
        ref
    ]);
}

});

parcelRegister("i7Fu5", function(module, exports) {
$parcel$export(module.exports, "useId", () => $d3190f5d250054f5$export$f680877a34711e37);

var $ekGgq = parcelRequire("ekGgq");

var $5FkrB = parcelRequire("5FkrB");

var $b5lkZ = parcelRequire("b5lkZ");

var $cwpsr = parcelRequire("cwpsr");
var $d3190f5d250054f5$var$_React$useId;
// Type copied from https://github.com/thearnica/react-uid/blob/0f507fbbdb1ab84acf477ec32698afe3d2191e49/src/hooks.ts#L12
// Copied rather than inferred to make the type transparent
// @ts-ignore - useId is not accessible in React 16
var $d3190f5d250054f5$var$react18UseId = ($d3190f5d250054f5$var$_React$useId = (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).useId) !== null && $d3190f5d250054f5$var$_React$useId !== void 0 ? $d3190f5d250054f5$var$_React$useId : undefined;
function $d3190f5d250054f5$export$f680877a34711e37() {
    if ($d3190f5d250054f5$var$react18UseId && (0, $cwpsr.fg)('platform-dst-react-18-use-id')) // eslint-disable-next-line react-hooks/rules-of-hooks
    return $d3190f5d250054f5$var$react18UseId();
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return "uid".concat((0, $b5lkZ.useUID)());
}
var $d3190f5d250054f5$export$6be90bcb437e928f = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function(_ref, ref) {
    var children = _ref.children, _ref$postfix = _ref.postfix, postfix = _ref$postfix === void 0 ? '' : _ref$postfix, _ref$prefix = _ref.prefix, prefix = _ref$prefix === void 0 ? '' : _ref$prefix;
    var id = "".concat(prefix).concat($d3190f5d250054f5$export$f680877a34711e37()).concat(postfix);
    (0, $5FkrB.useEffect)(function() {
        if (!ref) return;
        switch((0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(ref)){
            case 'function':
                ref(id);
                break;
            case 'object':
                ref.current = id;
                break;
            default:
                throw new Error("Unreachable case for unsupported type of ref \"".concat((0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(ref), "\""));
        }
    }, [
        id,
        ref
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).Fragment, null, typeof children === 'function' ? children({
        id: id
    }) : children);
});
function $d3190f5d250054f5$export$6ee17796e3d70de2() {
    if ($d3190f5d250054f5$var$react18UseId && (0, $cwpsr.fg)('platform-dst-react-18-use-id')) {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        var uid = $d3190f5d250054f5$var$react18UseId();
        return function(id) {
            return "".concat(uid, "-").concat(id.toString());
        };
    }
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return (0, $b5lkZ.useUIDSeed)();
}

});
parcelRegister("cwpsr", function(module, exports) {
$parcel$export(module.exports, "fg", () => $91dc388fdbb0f5d1$export$b40ec24ac8275656);

var $lVV2x = parcelRequire("lVV2x");
function $91dc388fdbb0f5d1$export$ba05d765b8392e5e(flagResolver) {
    (0, $lVV2x.setBooleanResolver)(flagResolver);
}
function $91dc388fdbb0f5d1$export$470e5c2be1411c89(name) {
    return (0, $lVV2x.resolveBooleanFlag)(name);
}
function $91dc388fdbb0f5d1$export$b40ec24ac8275656(name) {
    return (0, $lVV2x.resolveBooleanFlag)(name);
}

});
parcelRegister("lVV2x", function(module, exports) {
$parcel$export(module.exports, "setBooleanResolver", () => $ff7b2ac460a9559c$export$f2b591175b3e424c);
$parcel$export(module.exports, "resolveBooleanFlag", () => $ff7b2ac460a9559c$export$6333b6aff9fc6275);

var $jZlo3 = parcelRequire("jZlo3");

var $3sd9H = parcelRequire("3sd9H");

var $3ZMUU = parcelRequire("3ZMUU");
var $ff7b2ac460a9559c$var$pkgName = '@atlaskit/platform-feature-flags';
var $ff7b2ac460a9559c$export$7e41b1b2bdee3f98 = '__PLATFORM_FEATURE_FLAGS__';
var $ff7b2ac460a9559c$var$hasProcessEnv = typeof $3ZMUU !== 'undefined' && typeof $3ZMUU.env !== 'undefined';
// FF global overrides can be configured by test runners or Storybook
var $ff7b2ac460a9559c$var$ENV_ENABLE_PLATFORM_FF = $ff7b2ac460a9559c$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
// STORYBOOK_ENABLE_PLATFORM_FF is included as storybook only allows env vars prefixed with STORYBOOK
// https://github.com/storybookjs/storybook/issues/12270
var $ff7b2ac460a9559c$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF = $ff7b2ac460a9559c$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
var $ff7b2ac460a9559c$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE = $ff7b2ac460a9559c$var$ENV_ENABLE_PLATFORM_FF || $ff7b2ac460a9559c$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF;
var $ff7b2ac460a9559c$var$DEFAULT_PFF_GLOBAL = {
    booleanResolver: undefined
};
var $ff7b2ac460a9559c$var$globalVar = typeof window !== 'undefined' ? window : globalThis;
$ff7b2ac460a9559c$var$globalVar[$ff7b2ac460a9559c$export$7e41b1b2bdee3f98] = $ff7b2ac460a9559c$var$globalVar[$ff7b2ac460a9559c$export$7e41b1b2bdee3f98] || $ff7b2ac460a9559c$var$DEFAULT_PFF_GLOBAL;
function $ff7b2ac460a9559c$export$f2b591175b3e424c(resolver) {
    $ff7b2ac460a9559c$var$globalVar[$ff7b2ac460a9559c$export$7e41b1b2bdee3f98].booleanResolver = resolver;
}
function $ff7b2ac460a9559c$export$6333b6aff9fc6275(flagKey) {
    if ($ff7b2ac460a9559c$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE) {
        (0, $3sd9H.debug)('[%s]: The feature flags were enabled while running tests. The flag "%s" will be always enabled.', $ff7b2ac460a9559c$var$pkgName, flagKey);
        return true;
    }
    try {
        var _globalVar$PFF_GLOBAL, _globalVar$PFF_GLOBAL2, _globalVar$PFF_GLOBAL3;
        // booleanResolver will be empty for products like Trello, Elevate, Recruit etc.
        // Currently only Confluence, Jira and Bitbucket has set it.
        if (((_globalVar$PFF_GLOBAL = $ff7b2ac460a9559c$var$globalVar[$ff7b2ac460a9559c$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL === void 0 ? void 0 : _globalVar$PFF_GLOBAL.booleanResolver) === undefined || ((_globalVar$PFF_GLOBAL2 = $ff7b2ac460a9559c$var$globalVar[$ff7b2ac460a9559c$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL2 === void 0 ? void 0 : _globalVar$PFF_GLOBAL2.booleanResolver) === null) // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
        return (0, $jZlo3.default).checkGate(flagKey);
        var result = (_globalVar$PFF_GLOBAL3 = $ff7b2ac460a9559c$var$globalVar[$ff7b2ac460a9559c$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL3 === void 0 ? void 0 : _globalVar$PFF_GLOBAL3.booleanResolver(flagKey);
        if (typeof result !== 'boolean') {
            // eslint-disable-next-line no-console
            console.warn("".concat(flagKey, " resolved to a non-boolean value, returning false for safety"));
            return false;
        }
        return result;
    } catch (e) {
        return false;
    }
}

});
parcelRegister("3sd9H", function(module, exports) {
$parcel$export(module.exports, "debug", () => $283e3108fd1eb37a$export$1c9f709888824e05);
var $283e3108fd1eb37a$var$_process, $283e3108fd1eb37a$var$_process2;
// We can't rely on NODE_ENV === 'test' if its value is already configured by the consumer to some other value, so better to use JEST_WORKER_ID
// https://jestjs.io/docs/environment-variables#jest_worker_id
var $283e3108fd1eb37a$var$TESTS_MODE = (globalThis === null || globalThis === void 0 || ($283e3108fd1eb37a$var$_process = globalThis.process) === null || $283e3108fd1eb37a$var$_process === void 0 || ($283e3108fd1eb37a$var$_process = $283e3108fd1eb37a$var$_process.env) === null || $283e3108fd1eb37a$var$_process === void 0 ? void 0 : $283e3108fd1eb37a$var$_process.JEST_WORKER_ID) !== undefined;
var $283e3108fd1eb37a$var$DEBUG_MODE = !$283e3108fd1eb37a$var$TESTS_MODE && (globalThis === null || globalThis === void 0 || ($283e3108fd1eb37a$var$_process2 = globalThis.process) === null || $283e3108fd1eb37a$var$_process2 === void 0 || ($283e3108fd1eb37a$var$_process2 = $283e3108fd1eb37a$var$_process2.env) === null || $283e3108fd1eb37a$var$_process2 === void 0 ? void 0 : $283e3108fd1eb37a$var$_process2.NODE_ENV) !== 'production';
var $283e3108fd1eb37a$export$1c9f709888824e05 = function debug() {
    var _console;
    if (!$283e3108fd1eb37a$var$DEBUG_MODE) return;
    // eslint-disable-next-line no-console
    (_console = console).debug.apply(_console, arguments);
};

});




parcelRegister("legyX", function(module, exports) {
$parcel$export(module.exports, "fg", () => $f747c0cfcf677ed7$export$b40ec24ac8275656);

var $lzAam = parcelRequire("lzAam");
function $f747c0cfcf677ed7$export$ba05d765b8392e5e(flagResolver) {
    (0, $lzAam.setBooleanResolver)(flagResolver);
}
function $f747c0cfcf677ed7$export$470e5c2be1411c89(name) {
    return (0, $lzAam.resolveBooleanFlag)(name);
}
function $f747c0cfcf677ed7$export$b40ec24ac8275656(name) {
    return (0, $lzAam.resolveBooleanFlag)(name);
}

});
parcelRegister("lzAam", function(module, exports) {
$parcel$export(module.exports, "setBooleanResolver", () => $fb48ebac5cd00706$export$f2b591175b3e424c);
$parcel$export(module.exports, "resolveBooleanFlag", () => $fb48ebac5cd00706$export$6333b6aff9fc6275);

var $gWrgJ = parcelRequire("gWrgJ");

var $58gBl = parcelRequire("58gBl");

var $3ZMUU = parcelRequire("3ZMUU");
var $fb48ebac5cd00706$var$pkgName = '@atlaskit/platform-feature-flags';
var $fb48ebac5cd00706$export$7e41b1b2bdee3f98 = '__PLATFORM_FEATURE_FLAGS__';
var $fb48ebac5cd00706$var$hasProcessEnv = typeof $3ZMUU !== 'undefined' && typeof $3ZMUU.env !== 'undefined';
// FF global overrides can be configured by test runners or Storybook
var $fb48ebac5cd00706$var$ENV_ENABLE_PLATFORM_FF = $fb48ebac5cd00706$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
// STORYBOOK_ENABLE_PLATFORM_FF is included as storybook only allows env vars prefixed with STORYBOOK
// https://github.com/storybookjs/storybook/issues/12270
var $fb48ebac5cd00706$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF = $fb48ebac5cd00706$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
var $fb48ebac5cd00706$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE = $fb48ebac5cd00706$var$ENV_ENABLE_PLATFORM_FF || $fb48ebac5cd00706$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF;
var $fb48ebac5cd00706$var$DEFAULT_PFF_GLOBAL = {
    booleanResolver: undefined
};
var $fb48ebac5cd00706$var$globalVar = typeof window !== 'undefined' ? window : globalThis;
$fb48ebac5cd00706$var$globalVar[$fb48ebac5cd00706$export$7e41b1b2bdee3f98] = $fb48ebac5cd00706$var$globalVar[$fb48ebac5cd00706$export$7e41b1b2bdee3f98] || $fb48ebac5cd00706$var$DEFAULT_PFF_GLOBAL;
function $fb48ebac5cd00706$export$f2b591175b3e424c(resolver) {
    $fb48ebac5cd00706$var$globalVar[$fb48ebac5cd00706$export$7e41b1b2bdee3f98].booleanResolver = resolver;
}
function $fb48ebac5cd00706$export$6333b6aff9fc6275(flagKey) {
    if ($fb48ebac5cd00706$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE) {
        (0, $58gBl.debug)('[%s]: The feature flags were enabled while running tests. The flag "%s" will be always enabled.', $fb48ebac5cd00706$var$pkgName, flagKey);
        return true;
    }
    try {
        var _globalVar$PFF_GLOBAL, _globalVar$PFF_GLOBAL2, _globalVar$PFF_GLOBAL3;
        // booleanResolver will be empty for products like Trello, Elevate, Recruit etc.
        // Currently only Confluence, Jira and Bitbucket has set it.
        if (((_globalVar$PFF_GLOBAL = $fb48ebac5cd00706$var$globalVar[$fb48ebac5cd00706$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL === void 0 ? void 0 : _globalVar$PFF_GLOBAL.booleanResolver) === undefined || ((_globalVar$PFF_GLOBAL2 = $fb48ebac5cd00706$var$globalVar[$fb48ebac5cd00706$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL2 === void 0 ? void 0 : _globalVar$PFF_GLOBAL2.booleanResolver) === null) // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
        return (0, $gWrgJ.default).checkGate(flagKey);
        var result = (_globalVar$PFF_GLOBAL3 = $fb48ebac5cd00706$var$globalVar[$fb48ebac5cd00706$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL3 === void 0 ? void 0 : _globalVar$PFF_GLOBAL3.booleanResolver(flagKey);
        if (typeof result !== 'boolean') {
            // eslint-disable-next-line no-console
            console.warn("".concat(flagKey, " resolved to a non-boolean value, returning false for safety"));
            return false;
        }
        return result;
    } catch (e) {
        return false;
    }
}

});
parcelRegister("gWrgJ", function(module, exports) {
$parcel$export(module.exports, "default", () => $c557372396316eec$export$2e2bcd8739ae039);

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $25nEq = parcelRequire("25nEq");

var $e8zWj = parcelRequire("e8zWj");

var $2D0Es = parcelRequire("2D0Es");



var $c557372396316eec$var$_FeatureGates;
/**
 * Access the FeatureGates object via the default export.
 * ```ts
 * import FeatureGates from '@atlaskit/feature-gate-js-client';
 * ```
 */ var $c557372396316eec$var$FeatureGates = /*#__PURE__*/ function() {
    function FeatureGates() {
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, FeatureGates);
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(FeatureGates, null, [
        {
            key: "isGateExists",
            value: function isGateExists(gateName) {
                return this.client.isGateExist(gateName);
            }
        },
        {
            key: "isExperimentExists",
            value: function isExperimentExists(experimentName) {
                return this.client.isExperimentExist(experimentName);
            }
        }
    ]);
}();
$c557372396316eec$var$_FeatureGates = $c557372396316eec$var$FeatureGates;
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($c557372396316eec$var$FeatureGates, "client", new (0, $e8zWj.Client)());
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($c557372396316eec$var$FeatureGates, "hasCheckGateErrorOccurred", false);
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($c557372396316eec$var$FeatureGates, "hasGetExperimentValueErrorOccurred", false);
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($c557372396316eec$var$FeatureGates, "checkGate", function(gateName, options) {
    try {
        // Check if the CRITERION override mechanism is available
        if (typeof window !== 'undefined' && window.__CRITERION__ && typeof window.__CRITERION__.getFeatureFlagOverride === 'function') {
            // Attempt to retrieve an override value for the feature gate
            var overrideValue = window.__CRITERION__.getFeatureFlagOverride(gateName);
            // If an override value is found, return it immediately
            if (overrideValue !== undefined) return overrideValue;
        }
    } catch (error) {
        // Log the first occurrence of the error
        if (!$c557372396316eec$var$_FeatureGates.hasCheckGateErrorOccurred) {
            // eslint-disable-next-line no-console
            console.warn({
                msg: 'An error has occurred checking the feature gate from criterion override. Only the first occurrence of this error is logged.',
                gateName: gateName,
                error: error
            });
            $c557372396316eec$var$_FeatureGates.hasCheckGateErrorOccurred = true;
        }
    }
    // Proceed with the main logic if no override is found
    return $c557372396316eec$var$_FeatureGates.client.checkGate(gateName, options);
});
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($c557372396316eec$var$FeatureGates, "getExperimentValue", function(experimentName, parameterName, defaultValue, options) {
    try {
        // Check if the CRITERION override mechanism is available
        if (typeof window !== 'undefined' && window.__CRITERION__ && typeof window.__CRITERION__.getExperimentValueOverride === 'function') {
            var overrideValue = window.__CRITERION__.getExperimentValueOverride(experimentName, parameterName);
            if (overrideValue !== undefined && overrideValue !== null) return overrideValue;
        }
    } catch (error) {
        // Log the first occurrence of the error
        if (!$c557372396316eec$var$_FeatureGates.hasGetExperimentValueErrorOccurred) {
            // eslint-disable-next-line no-console
            console.warn({
                msg: 'An error has occurred getting the experiment value from criterion override. Only the first occurrence of this error is logged.',
                experimentName: experimentName,
                defaultValue: defaultValue,
                options: options,
                error: error
            });
            $c557372396316eec$var$_FeatureGates.hasGetExperimentValueErrorOccurred = true;
        }
        return defaultValue;
    }
    // Proceed with the main logic if no override is found
    return $c557372396316eec$var$_FeatureGates.client.getExperimentValue(experimentName, parameterName, defaultValue, options);
});
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($c557372396316eec$var$FeatureGates, "initializeCalled", $c557372396316eec$var$_FeatureGates.client.initializeCalled.bind($c557372396316eec$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($c557372396316eec$var$FeatureGates, "initializeCompleted", $c557372396316eec$var$_FeatureGates.client.initializeCompleted.bind($c557372396316eec$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($c557372396316eec$var$FeatureGates, "waitUntilInitializeCompleted", $c557372396316eec$var$_FeatureGates.client.waitUntilInitializeCompleted.bind($c557372396316eec$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($c557372396316eec$var$FeatureGates, "initialize", $c557372396316eec$var$_FeatureGates.client.initialize.bind($c557372396316eec$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($c557372396316eec$var$FeatureGates, "initializeWithProvider", $c557372396316eec$var$_FeatureGates.client.initializeWithProvider.bind($c557372396316eec$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($c557372396316eec$var$FeatureGates, "initializeFromValues", $c557372396316eec$var$_FeatureGates.client.initializeFromValues.bind($c557372396316eec$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($c557372396316eec$var$FeatureGates, "manuallyLogGateExposure", $c557372396316eec$var$_FeatureGates.client.manuallyLogGateExposure.bind($c557372396316eec$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($c557372396316eec$var$FeatureGates, "getExperiment", $c557372396316eec$var$_FeatureGates.client.getExperiment.bind($c557372396316eec$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($c557372396316eec$var$FeatureGates, "manuallyLogExperimentExposure", $c557372396316eec$var$_FeatureGates.client.manuallyLogExperimentExposure.bind($c557372396316eec$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($c557372396316eec$var$FeatureGates, "manuallyLogLayerExposure", $c557372396316eec$var$_FeatureGates.client.manuallyLogLayerExposure.bind($c557372396316eec$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($c557372396316eec$var$FeatureGates, "shutdownStatsig", $c557372396316eec$var$_FeatureGates.client.shutdownStatsig.bind($c557372396316eec$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($c557372396316eec$var$FeatureGates, "overrideGate", $c557372396316eec$var$_FeatureGates.client.overrideGate.bind($c557372396316eec$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($c557372396316eec$var$FeatureGates, "clearGateOverride", $c557372396316eec$var$_FeatureGates.client.clearGateOverride.bind($c557372396316eec$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($c557372396316eec$var$FeatureGates, "overrideConfig", $c557372396316eec$var$_FeatureGates.client.overrideConfig.bind($c557372396316eec$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($c557372396316eec$var$FeatureGates, "clearConfigOverride", $c557372396316eec$var$_FeatureGates.client.clearConfigOverride.bind($c557372396316eec$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($c557372396316eec$var$FeatureGates, "setOverrides", $c557372396316eec$var$_FeatureGates.client.setOverrides.bind($c557372396316eec$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($c557372396316eec$var$FeatureGates, "getOverrides", $c557372396316eec$var$_FeatureGates.client.getOverrides.bind($c557372396316eec$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($c557372396316eec$var$FeatureGates, "clearAllOverrides", $c557372396316eec$var$_FeatureGates.client.clearAllOverrides.bind($c557372396316eec$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($c557372396316eec$var$FeatureGates, "isCurrentUser", $c557372396316eec$var$_FeatureGates.client.isCurrentUser.bind($c557372396316eec$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($c557372396316eec$var$FeatureGates, "onGateUpdated", $c557372396316eec$var$_FeatureGates.client.onGateUpdated.bind($c557372396316eec$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($c557372396316eec$var$FeatureGates, "onExperimentValueUpdated", $c557372396316eec$var$_FeatureGates.client.onExperimentValueUpdated.bind($c557372396316eec$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($c557372396316eec$var$FeatureGates, "onAnyUpdated", $c557372396316eec$var$_FeatureGates.client.onAnyUpdated.bind($c557372396316eec$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($c557372396316eec$var$FeatureGates, "updateUser", $c557372396316eec$var$_FeatureGates.client.updateUser.bind($c557372396316eec$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($c557372396316eec$var$FeatureGates, "updateUserWithProvider", $c557372396316eec$var$_FeatureGates.client.updateUserWithProvider.bind($c557372396316eec$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($c557372396316eec$var$FeatureGates, "updateUserWithValues", $c557372396316eec$var$_FeatureGates.client.updateUserWithValues.bind($c557372396316eec$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($c557372396316eec$var$FeatureGates, "getPackageVersion", $c557372396316eec$var$_FeatureGates.client.getPackageVersion.bind($c557372396316eec$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($c557372396316eec$var$FeatureGates, "getLayer", $c557372396316eec$var$_FeatureGates.client.getLayer.bind($c557372396316eec$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($c557372396316eec$var$FeatureGates, "getLayerValue", $c557372396316eec$var$_FeatureGates.client.getLayerValue.bind($c557372396316eec$var$_FeatureGates.client));
var $c557372396316eec$var$boundFGJS = $c557372396316eec$var$FeatureGates;
// This makes it possible to get a reference to the FeatureGates client at runtime.
// This is important for overriding values in Cypress tests, as there needs to be a
// way to get the exact instance for a window in order to mock some of its methods.
if (typeof window !== 'undefined') {
    if (window.__FEATUREGATES_JS__ === undefined) window.__FEATUREGATES_JS__ = $c557372396316eec$var$FeatureGates;
    else {
        var $c557372396316eec$var$_boundFGJS, $c557372396316eec$var$_boundFGJS$getPackage;
        $c557372396316eec$var$boundFGJS = window.__FEATUREGATES_JS__;
        var $c557372396316eec$var$boundVersion = (($c557372396316eec$var$_boundFGJS = $c557372396316eec$var$boundFGJS) === null || $c557372396316eec$var$_boundFGJS === void 0 || ($c557372396316eec$var$_boundFGJS$getPackage = $c557372396316eec$var$_boundFGJS.getPackageVersion) === null || $c557372396316eec$var$_boundFGJS$getPackage === void 0 ? void 0 : $c557372396316eec$var$_boundFGJS$getPackage.call($c557372396316eec$var$_boundFGJS)) || '4.10.0 or earlier';
        if ($c557372396316eec$var$boundVersion !== (0, $2D0Es.CLIENT_VERSION)) {
            var $c557372396316eec$var$message = "Multiple versions of FeatureGateClients found on the current page.\n      The currently bound version is ".concat($c557372396316eec$var$boundVersion, " when module version ").concat((0, $2D0Es.CLIENT_VERSION), " was loading.");
            // eslint-disable-next-line no-console
            console.warn($c557372396316eec$var$message);
        }
    }
}
var /**
 * @property {FeatureGates} FeatureGate default export
 */ $c557372396316eec$export$2e2bcd8739ae039 = $c557372396316eec$var$boundFGJS;

});
parcelRegister("e8zWj", function(module, exports) {
$parcel$export(module.exports, "Client", () => $a4adb0e6cb266a72$export$1f2bb630327ac4b6);

var $1Vcia = parcelRequire("1Vcia");

var $iYJcE = parcelRequire("iYJcE");

var $fL8KA = parcelRequire("fL8KA");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $25nEq = parcelRequire("25nEq");

var $6HG4S = parcelRequire("6HG4S");

var $lexmS = parcelRequire("lexmS");

var $cPVi9 = parcelRequire("cPVi9");

var $ZoIdE = parcelRequire("ZoIdE");

var $dZL1s = parcelRequire("dZL1s");

var $2WRCw = parcelRequire("2WRCw");

var $3bgjw = parcelRequire("3bgjw");

var $jlkWK = parcelRequire("jlkWK");

var $gJJIF = parcelRequire("gJJIF");

var $6zapp = parcelRequire("6zapp");

var $cZJuM = parcelRequire("cZJuM");

var $2D0Es = parcelRequire("2D0Es");
var $a4adb0e6cb266a72$var$_excluded = [
    "sdkKey",
    "environment",
    "updateUserCompletionCallback",
    "perimeter"
];
function $a4adb0e6cb266a72$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $a4adb0e6cb266a72$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $a4adb0e6cb266a72$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $a4adb0e6cb266a72$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $a4adb0e6cb266a72$var$DEFAULT_CLIENT_KEY = 'client-default-key';
// default event logging api is Atlassian proxy rather than Statsig's domain, to avoid ad blockers
var $a4adb0e6cb266a72$var$DEFAULT_EVENT_LOGGING_API = 'https://xp.atlassian.com/v1/rgstr';
var $a4adb0e6cb266a72$export$1f2bb630327ac4b6 = /*#__PURE__*/ function() {
    function Client() {
        var _this = this;
        var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, _ref$localStorageKey = _ref.localStorageKey, localStorageKey = _ref$localStorageKey === void 0 ? (0, $gJJIF.LOCAL_STORAGE_KEY) : _ref$localStorageKey, overrideAdapter = _ref.overrideAdapter;
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, Client);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "initPromise", null);
        /** True if an initialize method was called and completed successfully. */ (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "initCompleted", false);
        /**
     * True if an initialize method was called and completed, meaning the client is now usable.
     * However if there was an error during initialization it may have initialized with default
     * values. Use {@link initCompleted} to check for this.
     */ (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "initWithDefaults", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "hasCheckGateErrorOccurred", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "hasGetExperimentErrorOccurred", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "hasGetExperimentValueErrorOccurred", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "hasGetLayerErrorOccurred", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "hasGetLayerValueErrorOccurred", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "subscriptions", new (0, $cPVi9.default)());
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "dataAdapter", new (0, $jlkWK.NoFetchDataAdapter)());
        /**
     * Call this if modifying the values being served by the Statsig library since it has its own
     * memoization cache which will not be updated if the values are changed outside of the library.
     */ (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "statsigValuesUpdated", function() {
            if (_this.user) // Trigger a reset of the memoize cache
            _this.statsigClient.updateUserSync(_this.user, {
                disableBackgroundCacheRefresh: true
            });
            _this.subscriptions.anyUpdated();
        });
        this.overrideAdapter = overrideAdapter || new (0, $gJJIF.PersistentOverrideAdapter)(localStorageKey);
    }
    /**
   * @description
   * This method initializes the client using a network call to fetch the bootstrap values.
   * If the client is inialized with an `analyticsWebClient`, it will send an operational event
   * to GASv3 with the following attributes:
   * - targetApp: the target app of the client
   * - clientVersion: the version of the client
   * - success: whether the initialization was successful
   * - startTime: the time when the initialization started
   * - totalTime: the total time it took to initialize the client
   * - apiKey: the api key used to initialize the client
   * @param clientOptions {ClientOptions}
   * @param identifiers {Identifiers}
   * @param customAttributes {CustomAttributes}
   * @returns {Promise<void>}
   */ return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(Client, [
        {
            key: "initialize",
            value: function() {
                var _initialize = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee(clientOptions, identifiers, customAttributes) {
                    var _this2 = this;
                    var clientOptionsWithDefaults, startTime;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee$(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                clientOptionsWithDefaults = (0, $cZJuM.getOptionsWithDefaults)(clientOptions);
                                if (!this.initPromise) {
                                    _context.next = 4;
                                    break;
                                }
                                if (!(0, $cZJuM.shallowEquals)(clientOptionsWithDefaults, this.initOptions)) // eslint-disable-next-line no-console
                                console.warn('Feature Gates client already initialized with different options. New options were not applied.');
                                return _context.abrupt("return", this.initPromise);
                            case 4:
                                startTime = performance.now();
                                this.initOptions = clientOptionsWithDefaults;
                                this.initPromise = this.init(clientOptionsWithDefaults, identifiers, customAttributes).then(function() {
                                    _this2.initCompleted = true;
                                    _this2.initWithDefaults = true;
                                }).finally(function() {
                                    var endTime = performance.now();
                                    var totalTime = endTime - startTime;
                                    _this2.fireClientEvent(startTime, totalTime, 'initialize', _this2.initCompleted, clientOptionsWithDefaults.apiKey);
                                });
                                return _context.abrupt("return", this.initPromise);
                            case 8:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee, this);
                }));
                function initialize(_x, _x2, _x3) {
                    return _initialize.apply(this, arguments);
                }
                return initialize;
            }()
        },
        {
            key: "initializeWithProvider",
            value: function() {
                var _initializeWithProvider = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee2(clientOptions, provider, identifiers, customAttributes) {
                    var _this3 = this;
                    var clientOptionsWithDefaults, startTime;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee2$(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                clientOptionsWithDefaults = (0, $cZJuM.getOptionsWithDefaults)(clientOptions);
                                if (!this.initPromise) {
                                    _context2.next = 4;
                                    break;
                                }
                                if (!(0, $cZJuM.shallowEquals)(clientOptionsWithDefaults, this.initOptions)) // eslint-disable-next-line no-console
                                console.warn('Feature Gates client already initialized with different options. New options were not applied.');
                                return _context2.abrupt("return", this.initPromise);
                            case 4:
                                startTime = performance.now();
                                this.initOptions = clientOptionsWithDefaults;
                                this.provider = provider;
                                this.provider.setClientVersion((0, $2D0Es.CLIENT_VERSION));
                                if (this.provider.setApplyUpdateCallback) this.provider.setApplyUpdateCallback(this.applyUpdateCallback.bind(this));
                                this.initPromise = this.initWithProvider(clientOptionsWithDefaults, provider, identifiers, customAttributes).then(function() {
                                    _this3.initCompleted = true;
                                    _this3.initWithDefaults = true;
                                }).finally(function() {
                                    var endTime = performance.now();
                                    var totalTime = endTime - startTime;
                                    _this3.fireClientEvent(startTime, totalTime, 'initializeWithProvider', _this3.initCompleted, provider.getApiKey ? provider.getApiKey() : undefined);
                                });
                                return _context2.abrupt("return", this.initPromise);
                            case 11:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2, this);
                }));
                function initializeWithProvider(_x4, _x5, _x6, _x7) {
                    return _initializeWithProvider.apply(this, arguments);
                }
                return initializeWithProvider;
            }()
        },
        {
            key: "applyUpdateCallback",
            value: function applyUpdateCallback(experimentsResult) {
                try {
                    if (this.initCompleted || this.initWithDefaults) {
                        this.assertInitialized(this.statsigClient);
                        this.dataAdapter.setBootstrapData(experimentsResult.experimentValues);
                        this.dataAdapter.setData(JSON.stringify(experimentsResult.experimentValues));
                        this.statsigValuesUpdated();
                    }
                } catch (error) {
                    // eslint-disable-next-line no-console
                    console.warn('Error when attempting to apply update', error);
                }
            }
        },
        {
            key: "fireClientEvent",
            value: function fireClientEvent(startTime, totalTime, action, success) {
                var _analyticsWebClient, _this4 = this;
                var apiKey = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
                (_analyticsWebClient = this.initOptions.analyticsWebClient) === null || _analyticsWebClient === void 0 || _analyticsWebClient.then(function(analyticsWebClient) {
                    var attributes = $a4adb0e6cb266a72$var$_objectSpread({
                        targetApp: _this4.initOptions.targetApp,
                        clientVersion: (0, $2D0Es.CLIENT_VERSION),
                        success: success,
                        startTime: startTime,
                        totalTime: totalTime
                    }, apiKey && {
                        apiKey: apiKey
                    });
                    analyticsWebClient.sendOperationalEvent({
                        action: action,
                        actionSubject: 'featureGatesClient',
                        attributes: attributes,
                        tags: [
                            'measurement'
                        ],
                        source: '@atlaskit/feature-gate-js-client'
                    });
                }).catch(function(err) {
                    if (_this4.initOptions.environment !== (0, $6zapp.FeatureGateEnvironment).Production) // eslint-disable-next-line no-console
                    console.error('Analytics web client promise did not resolve', err);
                });
            }
        },
        {
            key: "initializeFromValues",
            value: function() {
                var _initializeFromValues = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee3(clientOptions, identifiers, customAttributes) {
                    var _this5 = this;
                    var initializeValues, clientOptionsWithDefaults, startTime, _args3 = arguments;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee3$(_context3) {
                        while(true)switch(_context3.prev = _context3.next){
                            case 0:
                                initializeValues = _args3.length > 3 && _args3[3] !== undefined ? _args3[3] : {};
                                clientOptionsWithDefaults = (0, $cZJuM.getOptionsWithDefaults)(clientOptions);
                                if (!this.initPromise) {
                                    _context3.next = 5;
                                    break;
                                }
                                if (!(0, $cZJuM.shallowEquals)(clientOptionsWithDefaults, this.initOptions)) // eslint-disable-next-line no-console
                                console.warn('Feature Gates client already initialized with different options. New options were not applied.');
                                return _context3.abrupt("return", this.initPromise);
                            case 5:
                                // This makes sure the new Statsig client behaves like the old when bootstrap data is
                                // passed, and `has_updates` isn't specified (which happens a lot in product integration tests).
                                if (!Object.prototype.hasOwnProperty.call(initializeValues, 'has_updates')) initializeValues['has_updates'] = true;
                                startTime = performance.now();
                                this.initOptions = clientOptionsWithDefaults;
                                this.initPromise = this.initFromValues(clientOptionsWithDefaults, identifiers, customAttributes, initializeValues).then(function() {
                                    _this5.initCompleted = true;
                                    _this5.initWithDefaults = true;
                                }).finally(function() {
                                    var endTime = performance.now();
                                    var totalTime = endTime - startTime;
                                    _this5.fireClientEvent(startTime, totalTime, 'initializeFromValues', _this5.initCompleted);
                                });
                                return _context3.abrupt("return", this.initPromise);
                            case 10:
                            case "end":
                                return _context3.stop();
                        }
                    }, _callee3, this);
                }));
                function initializeFromValues(_x8, _x9, _x0) {
                    return _initializeFromValues.apply(this, arguments);
                }
                return initializeFromValues;
            }()
        },
        {
            key: "assertInitialized",
            value: function assertInitialized(statsigClient) {
                if (!statsigClient) throw new Error('Client must be initialized before using this method');
            }
        },
        {
            key: "updateUser",
            value: function() {
                var _updateUser = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee4(fetchOptions, identifiers, customAttributes) {
                    var fetchOptionsWithDefaults, initializeValuesProducer;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee4$(_context4) {
                        while(true)switch(_context4.prev = _context4.next){
                            case 0:
                                this.assertInitialized(this.statsigClient);
                                fetchOptionsWithDefaults = (0, $cZJuM.getOptionsWithDefaults)(fetchOptions);
                                initializeValuesProducer = function initializeValuesProducer() {
                                    return (0, $3bgjw.default).fetchExperimentValues(fetchOptionsWithDefaults, identifiers, customAttributes).then(function(_ref2) {
                                        var experimentValues = _ref2.experimentValues, customAttributes = _ref2.customAttributes;
                                        return {
                                            experimentValues: experimentValues,
                                            customAttributesFromFetch: customAttributes
                                        };
                                    });
                                };
                                _context4.next = 5;
                                return this.updateUserUsingInitializeValuesProducer(initializeValuesProducer, identifiers, customAttributes);
                            case 5:
                            case "end":
                                return _context4.stop();
                        }
                    }, _callee4, this);
                }));
                function updateUser(_x1, _x10, _x11) {
                    return _updateUser.apply(this, arguments);
                }
                return updateUser;
            }()
        },
        {
            key: "updateUserWithProvider",
            value: function() {
                var _updateUserWithProvider = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee5(identifiers, customAttributes) {
                    var _this6 = this;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee5$(_context5) {
                        while(true)switch(_context5.prev = _context5.next){
                            case 0:
                                this.assertInitialized(this.statsigClient);
                                if (this.provider) {
                                    _context5.next = 3;
                                    break;
                                }
                                throw new Error('Cannot update user using provider as the client was not initialised with a provider');
                            case 3:
                                _context5.next = 5;
                                return this.provider.setProfile(this.initOptions, identifiers, customAttributes);
                            case 5:
                                _context5.next = 7;
                                return this.updateUserUsingInitializeValuesProducer(function() {
                                    return _this6.provider.getExperimentValues();
                                }, identifiers, customAttributes);
                            case 7:
                            case "end":
                                return _context5.stop();
                        }
                    }, _callee5, this);
                }));
                function updateUserWithProvider(_x12, _x13) {
                    return _updateUserWithProvider.apply(this, arguments);
                }
                return updateUserWithProvider;
            }()
        },
        {
            key: "updateUserWithValues",
            value: function() {
                var _updateUserWithValues = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee6(identifiers, customAttributes) {
                    var initializeValues, initializeValuesProducer, _args6 = arguments;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee6$(_context6) {
                        while(true)switch(_context6.prev = _context6.next){
                            case 0:
                                initializeValues = _args6.length > 2 && _args6[2] !== undefined ? _args6[2] : {};
                                this.assertInitialized(this.statsigClient);
                                initializeValuesProducer = function initializeValuesProducer() {
                                    return Promise.resolve({
                                        experimentValues: initializeValues,
                                        customAttributesFromFetch: customAttributes
                                    });
                                };
                                _context6.next = 5;
                                return this.updateUserUsingInitializeValuesProducer(initializeValuesProducer, identifiers, customAttributes);
                            case 5:
                            case "end":
                                return _context6.stop();
                        }
                    }, _callee6, this);
                }));
                function updateUserWithValues(_x14, _x15) {
                    return _updateUserWithValues.apply(this, arguments);
                }
                return updateUserWithValues;
            }()
        },
        {
            key: "initializeCalled",
            value: function initializeCalled() {
                return this.initPromise != null;
            }
        },
        {
            key: "initializeCompleted",
            value: function initializeCompleted() {
                return this.initCompleted;
            }
        },
        {
            key: "waitUntilInitializeCompleted",
            value: function() {
                var _waitUntilInitializeCompleted = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee7() {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee7$(_context7) {
                        while(true)switch(_context7.prev = _context7.next){
                            case 0:
                                if (this.initPromise) {
                                    _context7.next = 2;
                                    break;
                                }
                                throw new Error('The client must be initialized before you can wait until initialized.');
                            case 2:
                                if (!this.initCompleted) {
                                    _context7.next = 4;
                                    break;
                                }
                                return _context7.abrupt("return");
                            case 4:
                                _context7.next = 6;
                                return this.initPromise;
                            case 6:
                            case "end":
                                return _context7.stop();
                        }
                    }, _callee7, this);
                }));
                function waitUntilInitializeCompleted() {
                    return _waitUntilInitializeCompleted.apply(this, arguments);
                }
                return waitUntilInitializeCompleted;
            }()
        },
        {
            key: "checkGate",
            value: function checkGate(gateName) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                try {
                    this.assertInitialized(this.statsigClient);
                    var _options$fireGateExpo = options.fireGateExposure, fireGateExposure = _options$fireGateExpo === void 0 ? true : _options$fireGateExpo;
                    return this.statsigClient.checkGate(gateName, {
                        disableExposureLog: !fireGateExposure
                    });
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!this.hasCheckGateErrorOccurred) {
                        // eslint-disable-next-line no-console
                        console.warn({
                            msg: 'An error has occurred checking the feature gate. Only the first occurrence of this error is logged.',
                            gateName: gateName,
                            error: error
                        });
                        this.hasCheckGateErrorOccurred = true;
                    }
                    return false;
                }
            }
        },
        {
            key: "isGateExist",
            value: function isGateExist(gateName) {
                try {
                    this.assertInitialized(this.statsigClient);
                    var gate = this.statsigClient.getFeatureGate(gateName, {
                        disableExposureLog: true
                    });
                    return !gate.details.reason.includes('Unrecognized');
                } catch (error) {
                    // eslint-disable-next-line no-console
                    console.error("Error occurred when trying to check FeatureGate: ".concat(error));
                    // in case of error report true to avoid false positives.
                    return true;
                }
            }
        },
        {
            key: "isExperimentExist",
            value: function isExperimentExist(experimentName) {
                try {
                    this.assertInitialized(this.statsigClient);
                    var config = this.statsigClient.getExperiment(experimentName, {
                        disableExposureLog: true
                    });
                    return !config.details.reason.includes('Unrecognized');
                } catch (error) {
                    // eslint-disable-next-line no-console
                    console.error("Error occurred when trying to check Experiment: ".concat(error));
                    // in case of error report true to avoid false positives.
                    return true;
                }
            }
        },
        {
            key: "manuallyLogGateExposure",
            value: function manuallyLogGateExposure(gateName) {
                this.assertInitialized(this.statsigClient);
                // This is the approach recommended in the docs
                // https://docs.statsig.com/client/javascript-sdk/#manual-exposures-
                this.statsigClient.checkGate(gateName);
            }
        },
        {
            key: "getExperiment",
            value: function getExperiment(experimentName) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                try {
                    this.assertInitialized(this.statsigClient);
                    var _options$fireExperime = options.fireExperimentExposure, fireExperimentExposure = _options$fireExperime === void 0 ? true : _options$fireExperime;
                    return (0, $ZoIdE.DynamicConfig).fromExperiment(this.statsigClient.getExperiment(experimentName, {
                        disableExposureLog: !fireExperimentExposure
                    }));
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!this.hasGetExperimentErrorOccurred) {
                        // eslint-disable-next-line no-console
                        console.warn({
                            msg: 'An error has occurred getting the experiment. Only the first occurrence of this error is logged.',
                            experimentName: experimentName,
                            error: error
                        });
                        this.hasGetExperimentErrorOccurred = true;
                    }
                    // Return a default value
                    return new (0, $ZoIdE.DynamicConfig)(experimentName, {}, '', {
                        time: Date.now(),
                        reason: (0, $2WRCw.EvaluationReason).Error
                    });
                }
            }
        },
        {
            key: "getExperimentValue",
            value: function getExperimentValue(experimentName, parameterName, defaultValue) {
                var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var experiment = this.getExperiment(experimentName, options);
                try {
                    var typeGuard = options.typeGuard;
                    return experiment.get(parameterName, defaultValue, typeGuard);
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!this.hasGetExperimentValueErrorOccurred) {
                        // eslint-disable-next-line no-console
                        console.warn({
                            msg: 'An error has occurred getting the experiment value. Only the first occurrence of this error is logged.',
                            experimentName: experimentName,
                            defaultValue: defaultValue,
                            options: options,
                            error: error
                        });
                        this.hasGetExperimentValueErrorOccurred = true;
                    }
                    return defaultValue;
                }
            }
        },
        {
            key: "manuallyLogExperimentExposure",
            value: function manuallyLogExperimentExposure(experimentName) {
                this.assertInitialized(this.statsigClient);
                // This is the approach recommended in the docs
                // https://docs.statsig.com/client/javascript-sdk/#manual-exposures-
                this.statsigClient.getExperiment(experimentName);
            }
        },
        {
            key: "manuallyLogLayerExposure",
            value: function manuallyLogLayerExposure(layerName, parameterName) {
                var _this$statsigClient$g;
                this.assertInitialized(this.statsigClient);
                // This is the approach recommended in the docs
                // https://docs.statsig.com/client/javascript-sdk/#manual-exposures-
                (_this$statsigClient$g = this.statsigClient.getLayer(layerName)) === null || _this$statsigClient$g === void 0 || _this$statsigClient$g.get(parameterName);
            }
        },
        {
            key: "shutdownStatsig",
            value: function shutdownStatsig() {
                this.assertInitialized(this.statsigClient);
                this.statsigClient.shutdown();
            }
        },
        {
            key: "overrideGate",
            value: function overrideGate(gateName, value) {
                this.overrideAdapter.overrideGate(gateName, value);
                // Trigger a reset of the memoized gate value
                if (this.user) {
                    var _this$statsigClient;
                    (_this$statsigClient = this.statsigClient) === null || _this$statsigClient === void 0 || _this$statsigClient.updateUserSync(this.user, {
                        disableBackgroundCacheRefresh: true
                    });
                }
                this.statsigValuesUpdated();
            }
        },
        {
            key: "clearGateOverride",
            value: function clearGateOverride(gateName) {
                this.overrideAdapter.removeGateOverride(gateName);
                this.statsigValuesUpdated();
            }
        },
        {
            key: "overrideConfig",
            value: function overrideConfig(experimentName, values) {
                this.overrideAdapter.overrideDynamicConfig(experimentName, values);
                this.statsigValuesUpdated();
            }
        },
        {
            key: "clearConfigOverride",
            value: function clearConfigOverride(experimentName) {
                this.overrideAdapter.removeDynamicConfigOverride(experimentName);
                this.statsigValuesUpdated();
            }
        },
        {
            key: "setOverrides",
            value: function setOverrides(overrides) {
                this.overrideAdapter.setOverrides(overrides);
                this.statsigValuesUpdated();
            }
        },
        {
            key: "getOverrides",
            value: function getOverrides() {
                return this.overrideAdapter.getOverrides();
            }
        },
        {
            key: "clearAllOverrides",
            value: function clearAllOverrides() {
                this.overrideAdapter.removeAllOverrides();
                this.statsigValuesUpdated();
            }
        },
        {
            key: "isCurrentUser",
            value: function isCurrentUser(identifiers, customAttributes) {
                return (0, $cZJuM.shallowEquals)(this.currentIdentifiers, identifiers) && (0, $cZJuM.shallowEquals)(this.currentAttributes, customAttributes);
            }
        },
        {
            key: "onGateUpdated",
            value: function onGateUpdated(gateName, callback) {
                var _this7 = this;
                var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var wrapCallback = function wrapCallback(value) {
                    var _options$fireGateExpo2 = options.fireGateExposure, fireGateExposure = _options$fireGateExpo2 === void 0 ? true : _options$fireGateExpo2;
                    if (fireGateExposure) _this7.manuallyLogGateExposure(gateName);
                    try {
                        callback(value);
                    } catch (error) {
                        // eslint-disable-next-line no-console
                        console.warn("Error calling callback for gate ".concat(gateName, " with value ").concat(value), error);
                    }
                };
                return this.subscriptions.onGateUpdated(gateName, wrapCallback, this.checkGate.bind(this), options);
            }
        },
        {
            key: "onExperimentValueUpdated",
            value: function onExperimentValueUpdated(experimentName, parameterName, defaultValue, callback) {
                var _this8 = this;
                var options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
                var wrapCallback = function wrapCallback(value) {
                    var _options$fireExperime2 = options.fireExperimentExposure, fireExperimentExposure = _options$fireExperime2 === void 0 ? true : _options$fireExperime2;
                    if (fireExperimentExposure) _this8.manuallyLogExperimentExposure(experimentName);
                    try {
                        callback(value);
                    } catch (error) {
                        // eslint-disable-next-line no-console
                        console.warn("Error calling callback for experiment ".concat(experimentName, " with value ").concat(value), error);
                    }
                };
                return this.subscriptions.onExperimentValueUpdated(experimentName, parameterName, defaultValue, wrapCallback, this.getExperimentValue.bind(this), options);
            }
        },
        {
            key: "onAnyUpdated",
            value: function onAnyUpdated(callback) {
                return this.subscriptions.onAnyUpdated(callback);
            }
        },
        {
            key: "init",
            value: function() {
                var _init = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee8(clientOptions, identifiers, customAttributes) {
                    var fromValuesClientOptions, experimentValues, customAttributesFromResult, clientSdkKeyPromise, experimentValuesPromise, _yield$Promise$all, _yield$Promise$all2, experimentValuesResult;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee8$(_context8) {
                        while(true)switch(_context8.prev = _context8.next){
                            case 0:
                                fromValuesClientOptions = $a4adb0e6cb266a72$var$_objectSpread({}, clientOptions);
                                if (!clientOptions.localMode) {
                                    _context8.next = 5;
                                    break;
                                }
                                _context8.next = 4;
                                return this.initFromValues(fromValuesClientOptions, identifiers, customAttributes);
                            case 4:
                                return _context8.abrupt("return");
                            case 5:
                                _context8.prev = 5;
                                // If client sdk key fetch fails, an error would be thrown and handled instead of waiting for
                                // the experiment values request to be settled, and it will fall back to use default values.
                                clientSdkKeyPromise = (0, $3bgjw.default).fetchClientSdk(clientOptions).then(function(value) {
                                    return fromValuesClientOptions.sdkKey = value.clientSdkKey;
                                });
                                experimentValuesPromise = (0, $3bgjw.default).fetchExperimentValues(clientOptions, identifiers, customAttributes); // Only wait for the experiment values request to finish and try to initialise the client
                                // with experiment values if both requests are successful. Else an error would be thrown and
                                // handled by the catch
                                _context8.next = 10;
                                return Promise.all([
                                    clientSdkKeyPromise,
                                    experimentValuesPromise
                                ]);
                            case 10:
                                _yield$Promise$all = _context8.sent;
                                _yield$Promise$all2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_yield$Promise$all, 2);
                                experimentValuesResult = _yield$Promise$all2[1];
                                experimentValues = experimentValuesResult.experimentValues;
                                customAttributesFromResult = experimentValuesResult.customAttributes;
                                _context8.next = 24;
                                break;
                            case 17:
                                _context8.prev = 17;
                                _context8.t0 = _context8["catch"](5);
                                if (_context8.t0 instanceof Error) // eslint-disable-next-line no-console
                                console.error("Error occurred when trying to fetch the Feature Gates client values, error: ".concat(_context8.t0 === null || _context8.t0 === void 0 ? void 0 : _context8.t0.message));
                                // eslint-disable-next-line no-console
                                console.warn("Initialising Statsig client without values");
                                _context8.next = 23;
                                return this.initFromValues(fromValuesClientOptions, identifiers, customAttributes);
                            case 23:
                                throw _context8.t0;
                            case 24:
                                return _context8.abrupt("return", this.initFromValues(fromValuesClientOptions, identifiers, customAttributesFromResult, experimentValues));
                            case 25:
                            case "end":
                                return _context8.stop();
                        }
                    }, _callee8, this, [
                        [
                            5,
                            17
                        ]
                    ]);
                }));
                function init(_x16, _x17, _x18) {
                    return _init.apply(this, arguments);
                }
                return init;
            }()
        },
        {
            key: "initWithProvider",
            value: function() {
                var _initWithProvider = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee9(baseClientOptions, provider, identifiers, customAttributes) {
                    var fromValuesClientOptions, experimentValues, customAttributesFromResult, clientSdkKeyPromise, experimentValuesPromise, _yield$Promise$all3, _yield$Promise$all4, experimentValuesResult;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee9$(_context9) {
                        while(true)switch(_context9.prev = _context9.next){
                            case 0:
                                fromValuesClientOptions = $a4adb0e6cb266a72$var$_objectSpread($a4adb0e6cb266a72$var$_objectSpread({}, baseClientOptions), {}, {
                                    disableCurrentPageLogging: true
                                });
                                _context9.prev = 1;
                                _context9.next = 4;
                                return provider.setProfile(baseClientOptions, identifiers, customAttributes);
                            case 4:
                                // If client sdk key fetch fails, an error would be thrown and handled instead of waiting for
                                // the experiment values request to be settled, and it will fall back to use default values.
                                clientSdkKeyPromise = provider.getClientSdkKey().then(function(value) {
                                    return fromValuesClientOptions.sdkKey = value;
                                });
                                experimentValuesPromise = provider.getExperimentValues(); // Only wait for the experiment values request to finish and try to initialise the client
                                // with experiment values if both requests are successful. Else an error would be thrown and
                                // handled by the catch
                                _context9.next = 8;
                                return Promise.all([
                                    clientSdkKeyPromise,
                                    experimentValuesPromise
                                ]);
                            case 8:
                                _yield$Promise$all3 = _context9.sent;
                                _yield$Promise$all4 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_yield$Promise$all3, 2);
                                experimentValuesResult = _yield$Promise$all4[1];
                                experimentValues = experimentValuesResult.experimentValues;
                                customAttributesFromResult = experimentValuesResult.customAttributesFromFetch;
                                _context9.next = 22;
                                break;
                            case 15:
                                _context9.prev = 15;
                                _context9.t0 = _context9["catch"](1);
                                if (_context9.t0 instanceof Error) // eslint-disable-next-line no-console
                                console.error("Error occurred when trying to fetch the Feature Gates client values, error: ".concat(_context9.t0 === null || _context9.t0 === void 0 ? void 0 : _context9.t0.message));
                                // eslint-disable-next-line no-console
                                console.warn("Initialising Statsig client without values");
                                _context9.next = 21;
                                return this.initFromValues(fromValuesClientOptions, identifiers, customAttributes);
                            case 21:
                                throw _context9.t0;
                            case 22:
                                return _context9.abrupt("return", this.initFromValues(fromValuesClientOptions, identifiers, customAttributesFromResult, experimentValues));
                            case 23:
                            case "end":
                                return _context9.stop();
                        }
                    }, _callee9, this, [
                        [
                            1,
                            15
                        ]
                    ]);
                }));
                function initWithProvider(_x19, _x20, _x21, _x22) {
                    return _initWithProvider.apply(this, arguments);
                }
                return initWithProvider;
            }()
        },
        {
            key: "initFromValues",
            value: function() {
                var _initFromValues = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee0(clientOptions, identifiers, customAttributes) {
                    var _newClientOptions$net;
                    var initializeValues, newClientOptions, sdkKey, environment, _updateUserCompletionCallback, _perimeter, restClientOptions, frontendUser, statsigOptions, _args0 = arguments;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee0$(_context0) {
                        while(true)switch(_context0.prev = _context0.next){
                            case 0:
                                initializeValues = _args0.length > 3 && _args0[3] !== undefined ? _args0[3] : {};
                                this.overrideAdapter.initFromStoredOverrides();
                                this.currentIdentifiers = identifiers;
                                this.currentAttributes = customAttributes;
                                newClientOptions = (0, $cZJuM.migrateInitializationOptions)(clientOptions);
                                if (!newClientOptions.sdkKey) newClientOptions.sdkKey = $a4adb0e6cb266a72$var$DEFAULT_CLIENT_KEY;
                                if (!((_newClientOptions$net = newClientOptions.networkConfig) !== null && _newClientOptions$net !== void 0 && _newClientOptions$net.logEventUrl)) newClientOptions.networkConfig = $a4adb0e6cb266a72$var$_objectSpread($a4adb0e6cb266a72$var$_objectSpread({}, newClientOptions.networkConfig), {}, {
                                    logEventUrl: $a4adb0e6cb266a72$var$DEFAULT_EVENT_LOGGING_API
                                });
                                if (newClientOptions.perimeter === (0, $6zapp.PerimeterType).FEDRAMP_MODERATE) // disable all logging in FedRAMP to prevent egress of sensitive data
                                newClientOptions.disableLogging = true;
                                sdkKey = newClientOptions.sdkKey, environment = newClientOptions.environment, _updateUserCompletionCallback = newClientOptions.updateUserCompletionCallback, _perimeter = newClientOptions.perimeter, restClientOptions = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(newClientOptions, $a4adb0e6cb266a72$var$_excluded);
                                frontendUser = (0, $cZJuM.toStatsigUser)(identifiers, customAttributes);
                                this.user = (0, $cZJuM.deepAssign)({}, initializeValues.user, frontendUser);
                                statsigOptions = $a4adb0e6cb266a72$var$_objectSpread($a4adb0e6cb266a72$var$_objectSpread({}, restClientOptions), {}, {
                                    environment: {
                                        tier: environment
                                    },
                                    includeCurrentPageUrlWithEvents: false,
                                    dataAdapter: this.dataAdapter,
                                    overrideAdapter: this.overrideAdapter,
                                    logEventCompressionMode: (0, $lexmS.LogEventCompressionMode).Forced
                                }); // Statsig validates the provided stableId against their own cookie, so we either need
                                // to update the cookie to match, or disable the validation completely.
                                if (identifiers.stableId) (0, $lexmS.StableID).setOverride(identifiers.stableId, sdkKey);
                                else statsigOptions.disableStableID = true;
                                _context0.prev = 13;
                                this.statsigClient = new (0, $lexmS.StatsigClient)(sdkKey, this.user, statsigOptions);
                                this.dataAdapter.setBootstrapData(initializeValues);
                                _context0.next = 18;
                                return this.statsigClient.initializeAsync();
                            case 18:
                                _context0.next = 30;
                                break;
                            case 20:
                                _context0.prev = 20;
                                _context0.t0 = _context0["catch"](13);
                                if (_context0.t0 instanceof Error) // eslint-disable-next-line no-console
                                console.error("Error occurred when trying to initialise the Statsig client, error: ".concat(_context0.t0 === null || _context0.t0 === void 0 ? void 0 : _context0.t0.message));
                                // eslint-disable-next-line no-console
                                console.warn("Initialising Statsig client with default sdk key and without values");
                                this.statsigClient = new (0, $lexmS.StatsigClient)($a4adb0e6cb266a72$var$DEFAULT_CLIENT_KEY, this.user, statsigOptions);
                                this.dataAdapter.setBootstrapData();
                                _context0.next = 28;
                                return this.statsigClient.initializeAsync();
                            case 28:
                                this.initWithDefaults = true;
                                throw _context0.t0;
                            case 30:
                            case "end":
                                return _context0.stop();
                        }
                    }, _callee0, this, [
                        [
                            13,
                            20
                        ]
                    ]);
                }));
                function initFromValues(_x23, _x24, _x25) {
                    return _initFromValues.apply(this, arguments);
                }
                return initFromValues;
            }()
        },
        {
            key: "updateUserUsingInitializeValuesProducer",
            value: function() {
                var _updateUserUsingInitializeValuesProducer = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee10(getInitializeValues, identifiers, customAttributes) {
                    var _this9 = this;
                    var originalInitPromise, initializeValuesPromise, updateUserPromise;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee10$(_context10) {
                        while(true)switch(_context10.prev = _context10.next){
                            case 0:
                                this.assertInitialized(this.statsigClient);
                                if (this.initPromise) {
                                    _context10.next = 3;
                                    break;
                                }
                                throw new Error('The client must be initialized before you can update the user.');
                            case 3:
                                if (!this.isCurrentUser(identifiers, customAttributes)) {
                                    _context10.next = 5;
                                    break;
                                }
                                return _context10.abrupt("return", this.initPromise);
                            case 5:
                                // Wait for the current initialize/update to finish
                                originalInitPromise = this.initPromise;
                                _context10.prev = 6;
                                _context10.next = 9;
                                return this.initPromise;
                            case 9:
                                _context10.next = 13;
                                break;
                            case 11:
                                _context10.prev = 11;
                                _context10.t0 = _context10["catch"](6);
                            case 13:
                                initializeValuesPromise = getInitializeValues();
                                updateUserPromise = this.updateStatsigClientUser(initializeValuesPromise, identifiers, customAttributes); // We replace the init promise here since we are essentially re-initializing the client at this
                                // point. Any subsequent calls to await client.initialize() or client.updateUser()
                                // will now also await this user update.
                                this.initPromise = updateUserPromise.catch(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee1() {
                                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee1$(_context1) {
                                        while(true)switch(_context1.prev = _context1.next){
                                            case 0:
                                                // If the update failed then it changed nothing, so revert back to the original promise.
                                                _this9.initPromise = originalInitPromise;
                                                // Set the user profile again to revert back to the current user
                                                if (!_this9.provider) {
                                                    _context1.next = 4;
                                                    break;
                                                }
                                                _context1.next = 4;
                                                return _this9.provider.setProfile(_this9.initOptions, _this9.currentIdentifiers, _this9.currentAttributes);
                                            case 4:
                                            case "end":
                                                return _context1.stop();
                                        }
                                    }, _callee1);
                                })));
                                return _context10.abrupt("return", updateUserPromise);
                            case 17:
                            case "end":
                                return _context10.stop();
                        }
                    }, _callee10, this, [
                        [
                            6,
                            11
                        ]
                    ]);
                }));
                function updateUserUsingInitializeValuesProducer(_x26, _x27, _x28) {
                    return _updateUserUsingInitializeValuesProducer.apply(this, arguments);
                }
                return updateUserUsingInitializeValuesProducer;
            }()
        },
        {
            key: "updateStatsigClientUser",
            value: function() {
                var _updateStatsigClientUser = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee11(initializeValuesPromise, identifiers, customAttributes) {
                    var _this$initOptions, _this$initOptions$upd;
                    var initializeValues, user, frontendUser, _updateUserCompletion, _ref4, errMsg, success, errorMessage;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee11$(_context11) {
                        while(true)switch(_context11.prev = _context11.next){
                            case 0:
                                this.assertInitialized(this.statsigClient);
                                _context11.prev = 1;
                                _context11.next = 4;
                                return initializeValuesPromise;
                            case 4:
                                initializeValues = _context11.sent;
                                frontendUser = (0, $cZJuM.toStatsigUser)(identifiers, initializeValues.customAttributesFromFetch);
                                user = (0, $cZJuM.deepAssign)({}, initializeValues.experimentValues.user, frontendUser);
                                _context11.next = 14;
                                break;
                            case 9:
                                _context11.prev = 9;
                                _context11.t0 = _context11["catch"](1);
                                // Make sure the updateUserCompletionCallback is called for any errors in our custom code.
                                // This is not necessary for the updateUserWithValues call, because the Statsig client will
                                // already invoke the callback itself.
                                errMsg = _context11.t0 instanceof Error ? _context11.t0.message : JSON.stringify(_context11.t0);
                                (_updateUserCompletion = (_ref4 = this.initOptions).updateUserCompletionCallback) === null || _updateUserCompletion === void 0 || _updateUserCompletion.call(_ref4, false, errMsg);
                                throw _context11.t0;
                            case 14:
                                success = true;
                                errorMessage = null;
                                _context11.prev = 16;
                                this.dataAdapter.setBootstrapData(initializeValues.experimentValues);
                                this.user = user;
                                if (!this.user) {
                                    _context11.next = 22;
                                    break;
                                }
                                _context11.next = 22;
                                return this.statsigClient.updateUserAsync(this.user);
                            case 22:
                                _context11.next = 28;
                                break;
                            case 24:
                                _context11.prev = 24;
                                _context11.t1 = _context11["catch"](16);
                                success = false;
                                errorMessage = String(_context11.t1);
                            case 28:
                                (_this$initOptions = this.initOptions) === null || _this$initOptions === void 0 || (_this$initOptions$upd = _this$initOptions.updateUserCompletionCallback) === null || _this$initOptions$upd === void 0 || _this$initOptions$upd.call(_this$initOptions, success, errorMessage);
                                if (!success) {
                                    _context11.next = 35;
                                    break;
                                }
                                this.currentIdentifiers = identifiers;
                                this.currentAttributes = customAttributes;
                                this.subscriptions.anyUpdated();
                                _context11.next = 36;
                                break;
                            case 35:
                                throw new Error('Failed to update user. An unexpected error occured.');
                            case 36:
                            case "end":
                                return _context11.stop();
                        }
                    }, _callee11, this, [
                        [
                            1,
                            9
                        ],
                        [
                            16,
                            24
                        ]
                    ]);
                }));
                function updateStatsigClientUser(_x29, _x30, _x31) {
                    return _updateStatsigClientUser.apply(this, arguments);
                }
                return updateStatsigClientUser;
            }()
        },
        {
            key: "getPackageVersion",
            value: /**
     * @returns string version of the current package in semver style.
     */ function getPackageVersion() {
                return 0, $2D0Es.CLIENT_VERSION;
            }
        },
        {
            key: "getLayer",
            value: function getLayer(/** The name of the layer */ layerName) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                try {
                    this.assertInitialized(this.statsigClient);
                    var _options$fireLayerExp = options.fireLayerExposure, fireLayerExposure = _options$fireLayerExp === void 0 ? true : _options$fireLayerExp;
                    return (0, $dZL1s.Layer).fromLayer(this.statsigClient.getLayer(layerName, {
                        disableExposureLog: !fireLayerExposure
                    }));
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!this.hasGetLayerErrorOccurred) {
                        // eslint-disable-next-line no-console
                        console.warn({
                            msg: 'An error has occurred getting the layer. Only the first occurrence of this error is logged.',
                            layerName: layerName,
                            error: error
                        });
                        this.hasGetLayerErrorOccurred = true;
                    }
                    // Return a default value
                    return (0, $dZL1s.Layer).fromLayer((0, $lexmS._makeLayer)(layerName, {
                        reason: 'Error'
                    }, null));
                }
            }
        },
        {
            key: "getLayerValue",
            value: function getLayerValue(layerName, parameterName, defaultValue) {
                var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var layer = this.getLayer(layerName, options);
                try {
                    var typeGuard = options.typeGuard;
                    return layer.get(parameterName, defaultValue, typeGuard);
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!this.hasGetLayerValueErrorOccurred) {
                        // eslint-disable-next-line no-console
                        console.warn({
                            msg: 'An error has occurred getting the layer value. Only the first occurrence of this error is logged.',
                            layerName: layerName,
                            defaultValue: defaultValue,
                            options: options,
                            error: error
                        });
                        this.hasGetLayerValueErrorOccurred = true;
                    }
                    return defaultValue;
                }
            }
        }
    ]);
}();

});
parcelRegister("lexmS", function(module, exports) {
"use strict";
var $f754c9f52cf45f81$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $f754c9f52cf45f81$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $f754c9f52cf45f81$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.StatsigClient = void 0;


var $5qZKP = parcelRequire("5qZKP");
module.exports.StatsigClient = $5qZKP.default;

$f754c9f52cf45f81$var$__exportStar((parcelRequire("9VR6c")), module.exports);
const $f754c9f52cf45f81$var$__STATSIG__ = Object.assign((0, (parcelRequire("9VR6c"))._getStatsigGlobal)(), {
    StatsigClient: $5qZKP.default
});
module.exports.default = $f754c9f52cf45f81$var$__STATSIG__;

});
parcelRegister("9VR6c", function(module, exports) {
"use strict";
var $73b2a045be6e1361$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $73b2a045be6e1361$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $73b2a045be6e1361$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Storage = module.exports.Log = module.exports.EventLogger = module.exports.Diagnostics = void 0;



Object.defineProperty(module.exports, "Diagnostics", {
    enumerable: true,
    get: function() {
        return (parcelRequire("6sWDY")).Diagnostics;
    }
});

var $8ZegJ = parcelRequire("8ZegJ");
Object.defineProperty(module.exports, "EventLogger", {
    enumerable: true,
    get: function() {
        return $8ZegJ.EventLogger;
    }
});

Object.defineProperty(module.exports, "Log", {
    enumerable: true,
    get: function() {
        return (parcelRequire("3sfpc")).Log;
    }
});


Object.defineProperty(module.exports, "Storage", {
    enumerable: true,
    get: function() {
        return (parcelRequire("9YlaE")).Storage;
    }
});

$73b2a045be6e1361$var$__exportStar((parcelRequire("khZUo")), module.exports);

$73b2a045be6e1361$var$__exportStar((parcelRequire("hxeyi")), module.exports);

$73b2a045be6e1361$var$__exportStar((parcelRequire("fPsv4")), module.exports);

$73b2a045be6e1361$var$__exportStar((parcelRequire("hcdaR")), module.exports);

$73b2a045be6e1361$var$__exportStar((parcelRequire("6sWDY")), module.exports);

$73b2a045be6e1361$var$__exportStar((parcelRequire("cl1O2")), module.exports);

$73b2a045be6e1361$var$__exportStar((parcelRequire("39jNY")), module.exports);

$73b2a045be6e1361$var$__exportStar((parcelRequire("9GgbB")), module.exports);

$73b2a045be6e1361$var$__exportStar((parcelRequire("2GG5j")), module.exports);

$73b2a045be6e1361$var$__exportStar((parcelRequire("5Gp6R")), module.exports);

$73b2a045be6e1361$var$__exportStar((parcelRequire("klfhu")), module.exports);

$73b2a045be6e1361$var$__exportStar((parcelRequire("3sfpc")), module.exports);

$73b2a045be6e1361$var$__exportStar((parcelRequire("1FVci")), module.exports);

$73b2a045be6e1361$var$__exportStar((parcelRequire("3FPX1")), module.exports);

$73b2a045be6e1361$var$__exportStar((parcelRequire("8gIKV")), module.exports);

$73b2a045be6e1361$var$__exportStar((parcelRequire("gHEAC")), module.exports);

$73b2a045be6e1361$var$__exportStar((parcelRequire("280of")), module.exports);

$73b2a045be6e1361$var$__exportStar((parcelRequire("2a4Fo")), module.exports);

$73b2a045be6e1361$var$__exportStar((parcelRequire("aiqjf")), module.exports);

$73b2a045be6e1361$var$__exportStar((parcelRequire("1pnfi")), module.exports);

$73b2a045be6e1361$var$__exportStar((parcelRequire("3MLOf")), module.exports);

$73b2a045be6e1361$var$__exportStar((parcelRequire("gxJjE")), module.exports);

$73b2a045be6e1361$var$__exportStar((parcelRequire("5P0v1")), module.exports);

$73b2a045be6e1361$var$__exportStar((parcelRequire("kL3cd")), module.exports);

$73b2a045be6e1361$var$__exportStar((parcelRequire("gXoh1")), module.exports);

$73b2a045be6e1361$var$__exportStar((parcelRequire("ewIze")), module.exports);

$73b2a045be6e1361$var$__exportStar((parcelRequire("5CBso")), module.exports);

$73b2a045be6e1361$var$__exportStar((parcelRequire("eNn8G")), module.exports);

$73b2a045be6e1361$var$__exportStar((parcelRequire("c6jZh")), module.exports);

$73b2a045be6e1361$var$__exportStar((parcelRequire("fQ7ZH")), module.exports);

$73b2a045be6e1361$var$__exportStar((parcelRequire("cCdUn")), module.exports);

$73b2a045be6e1361$var$__exportStar((parcelRequire("b8WOj")), module.exports);

$73b2a045be6e1361$var$__exportStar((parcelRequire("9YlaE")), module.exports);

$73b2a045be6e1361$var$__exportStar((parcelRequire("gCESp")), module.exports);

$73b2a045be6e1361$var$__exportStar((parcelRequire("lje2o")), module.exports);

$73b2a045be6e1361$var$__exportStar((parcelRequire("6dvVR")), module.exports);

$73b2a045be6e1361$var$__exportStar((parcelRequire("deTba")), module.exports);

$73b2a045be6e1361$var$__exportStar((parcelRequire("a4EWe")), module.exports);

$73b2a045be6e1361$var$__exportStar((parcelRequire("5KvN8")), module.exports);

$73b2a045be6e1361$var$__exportStar((parcelRequire("lGjbM")), module.exports);
Object.assign((0, (parcelRequire("khZUo"))._getStatsigGlobal)(), {
    Log: (parcelRequire("3sfpc")).Log,
    SDK_VERSION: (parcelRequire("5CBso")).SDK_VERSION
});

});
parcelRegister("khZUo", function(module, exports) {
"use strict";
/* eslint-disable @typescript-eslint/no-unsafe-assignment */ var $ec556aebabee23ef$var$_a, $ec556aebabee23ef$var$_b, $ec556aebabee23ef$var$_c;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._getInstance = module.exports._getStatsigGlobalFlag = module.exports._getStatsigGlobal = void 0;

var $3sfpc = parcelRequire("3sfpc");
const $ec556aebabee23ef$var$_getStatsigGlobal = ()=>{
    // Avoid ReferenceError, which is happening with Cloudflare pages
    try {
        return typeof __STATSIG__ !== 'undefined' ? __STATSIG__ : $ec556aebabee23ef$var$statsigGlobal;
    } catch (e) {
        return $ec556aebabee23ef$var$statsigGlobal;
    }
};
module.exports._getStatsigGlobal = $ec556aebabee23ef$var$_getStatsigGlobal;
const $ec556aebabee23ef$var$_getStatsigGlobalFlag = (flag)=>{
    return (0, module.exports._getStatsigGlobal)()[flag];
};
module.exports._getStatsigGlobalFlag = $ec556aebabee23ef$var$_getStatsigGlobalFlag;
const $ec556aebabee23ef$var$_getInstance = (sdkKey)=>{
    const gbl = (0, module.exports._getStatsigGlobal)();
    if (!sdkKey) {
        if (gbl.instances && Object.keys(gbl.instances).length > 1) $3sfpc.Log.warn('Call made to Statsig global instance without an SDK key but there is more than one client instance. If you are using mulitple clients, please specify the SDK key.');
        return gbl.firstInstance;
    }
    return gbl.instances && gbl.instances[sdkKey];
};
module.exports._getInstance = $ec556aebabee23ef$var$_getInstance;
const $ec556aebabee23ef$var$GLOBAL_KEY = '__STATSIG__';
const $ec556aebabee23ef$var$_window = typeof window !== 'undefined' ? window : {};
const $ec556aebabee23ef$var$_global = typeof $parcel$global !== 'undefined' ? $parcel$global : {};
const $ec556aebabee23ef$var$_globalThis = typeof globalThis !== 'undefined' ? globalThis : {};
const $ec556aebabee23ef$var$statsigGlobal = ($ec556aebabee23ef$var$_c = ($ec556aebabee23ef$var$_b = ($ec556aebabee23ef$var$_a = $ec556aebabee23ef$var$_window[$ec556aebabee23ef$var$GLOBAL_KEY]) !== null && $ec556aebabee23ef$var$_a !== void 0 ? $ec556aebabee23ef$var$_a : $ec556aebabee23ef$var$_global[$ec556aebabee23ef$var$GLOBAL_KEY]) !== null && $ec556aebabee23ef$var$_b !== void 0 ? $ec556aebabee23ef$var$_b : $ec556aebabee23ef$var$_globalThis[$ec556aebabee23ef$var$GLOBAL_KEY]) !== null && $ec556aebabee23ef$var$_c !== void 0 ? $ec556aebabee23ef$var$_c : {
    instance: module.exports._getInstance
};
$ec556aebabee23ef$var$_window[$ec556aebabee23ef$var$GLOBAL_KEY] = $ec556aebabee23ef$var$statsigGlobal;
$ec556aebabee23ef$var$_global[$ec556aebabee23ef$var$GLOBAL_KEY] = $ec556aebabee23ef$var$statsigGlobal;
$ec556aebabee23ef$var$_globalThis[$ec556aebabee23ef$var$GLOBAL_KEY] = $ec556aebabee23ef$var$statsigGlobal;

});
parcelRegister("3sfpc", function(module, exports) {
"use strict";
/* eslint-disable no-console */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Log = module.exports.LogLevel = void 0;
// intentionally spaced for formatting
const $283fefd3944c23d0$var$DEBUG = ' DEBUG ';
const $283fefd3944c23d0$var$_INFO = '  INFO ';
const $283fefd3944c23d0$var$_WARN = '  WARN ';
const $283fefd3944c23d0$var$ERROR = ' ERROR ';
function $283fefd3944c23d0$var$addTag(args) {
    args.unshift('[Statsig]');
    return args; // ['[Statsig]', ...args];
}
module.exports.LogLevel = {
    None: 0,
    Error: 1,
    Warn: 2,
    Info: 3,
    Debug: 4
};
class $283fefd3944c23d0$var$Log {
    static info(...args) {
        if ($283fefd3944c23d0$var$Log.level >= module.exports.LogLevel.Info) console.info($283fefd3944c23d0$var$_INFO, ...$283fefd3944c23d0$var$addTag(args));
    }
    static debug(...args) {
        if ($283fefd3944c23d0$var$Log.level >= module.exports.LogLevel.Debug) console.debug($283fefd3944c23d0$var$DEBUG, ...$283fefd3944c23d0$var$addTag(args));
    }
    static warn(...args) {
        if ($283fefd3944c23d0$var$Log.level >= module.exports.LogLevel.Warn) console.warn($283fefd3944c23d0$var$_WARN, ...$283fefd3944c23d0$var$addTag(args));
    }
    static error(...args) {
        if ($283fefd3944c23d0$var$Log.level >= module.exports.LogLevel.Error) console.error($283fefd3944c23d0$var$ERROR, ...$283fefd3944c23d0$var$addTag(args));
    }
}
module.exports.Log = $283fefd3944c23d0$var$Log;
$283fefd3944c23d0$var$Log.level = module.exports.LogLevel.Warn;

});


parcelRegister("6sWDY", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Diagnostics = void 0;
const $4b52d905caeacac4$var$MARKER_MAP = new Map();
const $4b52d905caeacac4$var$ACT_START = 'start';
const $4b52d905caeacac4$var$ACT_END = 'end';
const $4b52d905caeacac4$var$DIAGNOSTICS_EVENT = 'statsig::diagnostics';
module.exports.Diagnostics = {
    _getMarkers: (sdkKey)=>{
        return $4b52d905caeacac4$var$MARKER_MAP.get(sdkKey);
    },
    _markInitOverallStart: (sdkKey)=>{
        $4b52d905caeacac4$var$_addMarker(sdkKey, $4b52d905caeacac4$var$_createMarker({}, $4b52d905caeacac4$var$ACT_START, 'overall'));
    },
    _markInitOverallEnd: (sdkKey, success, evaluationDetails)=>{
        $4b52d905caeacac4$var$_addMarker(sdkKey, $4b52d905caeacac4$var$_createMarker({
            success: success,
            error: success ? undefined : {
                name: 'InitializeError',
                message: 'Failed to initialize'
            },
            evaluationDetails: evaluationDetails
        }, $4b52d905caeacac4$var$ACT_END, 'overall'));
    },
    _markInitNetworkReqStart: (sdkKey, data)=>{
        $4b52d905caeacac4$var$_addMarker(sdkKey, $4b52d905caeacac4$var$_createMarker(data, $4b52d905caeacac4$var$ACT_START, 'initialize', 'network_request'));
    },
    _markInitNetworkReqEnd: (sdkKey, data)=>{
        $4b52d905caeacac4$var$_addMarker(sdkKey, $4b52d905caeacac4$var$_createMarker(data, $4b52d905caeacac4$var$ACT_END, 'initialize', 'network_request'));
    },
    _markInitProcessStart: (sdkKey)=>{
        $4b52d905caeacac4$var$_addMarker(sdkKey, $4b52d905caeacac4$var$_createMarker({}, $4b52d905caeacac4$var$ACT_START, 'initialize', 'process'));
    },
    _markInitProcessEnd: (sdkKey, data)=>{
        $4b52d905caeacac4$var$_addMarker(sdkKey, $4b52d905caeacac4$var$_createMarker(data, $4b52d905caeacac4$var$ACT_END, 'initialize', 'process'));
    },
    _clearMarkers: (sdkKey)=>{
        $4b52d905caeacac4$var$MARKER_MAP.delete(sdkKey);
    },
    _formatError (e) {
        if (!(e && typeof e === 'object')) return;
        return {
            code: $4b52d905caeacac4$var$_safeGetField(e, 'code'),
            name: $4b52d905caeacac4$var$_safeGetField(e, 'name'),
            message: $4b52d905caeacac4$var$_safeGetField(e, 'message')
        };
    },
    _getDiagnosticsData (res, attempt, body, e) {
        var _a;
        return {
            success: (res === null || res === void 0 ? void 0 : res.ok) === true,
            statusCode: res === null || res === void 0 ? void 0 : res.status,
            sdkRegion: (_a = res === null || res === void 0 ? void 0 : res.headers) === null || _a === void 0 ? void 0 : _a.get('x-statsig-region'),
            isDelta: body.includes('"is_delta":true') === true ? true : undefined,
            attempt: attempt,
            error: module.exports.Diagnostics._formatError(e)
        };
    },
    _enqueueDiagnosticsEvent (user, logger, sdk, options) {
        const markers = module.exports.Diagnostics._getMarkers(sdk);
        if (markers == null || markers.length <= 0) return -1;
        const overallInitDuration = markers[markers.length - 1].timestamp - markers[0].timestamp;
        module.exports.Diagnostics._clearMarkers(sdk);
        const event = $4b52d905caeacac4$var$_makeDiagnosticsEvent(user, {
            context: 'initialize',
            markers: markers.slice(),
            statsigOptions: options
        });
        logger.enqueue(event);
        return overallInitDuration;
    }
};
function $4b52d905caeacac4$var$_createMarker(data, action, key, step) {
    return Object.assign({
        key: key,
        action: action,
        step: step,
        timestamp: Date.now()
    }, data);
}
function $4b52d905caeacac4$var$_makeDiagnosticsEvent(user, data) {
    const latencyEvent = {
        eventName: $4b52d905caeacac4$var$DIAGNOSTICS_EVENT,
        user: user,
        value: null,
        metadata: data,
        time: Date.now()
    };
    return latencyEvent;
}
function $4b52d905caeacac4$var$_addMarker(sdkKey, marker) {
    var _a;
    const markers = (_a = $4b52d905caeacac4$var$MARKER_MAP.get(sdkKey)) !== null && _a !== void 0 ? _a : [];
    markers.push(marker);
    $4b52d905caeacac4$var$MARKER_MAP.set(sdkKey, markers);
}
function $4b52d905caeacac4$var$_safeGetField(data, field) {
    if (field in data) return data[field];
    return undefined;
}

});

parcelRegister("8ZegJ", function(module, exports) {
"use strict";
var $68af16ba1f0eb895$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.EventLogger = void 0;

var $6RcCA = parcelRequire("6RcCA");

var $hxeyi = parcelRequire("hxeyi");

var $c6MRw = parcelRequire("c6MRw");

var $eTVDv = parcelRequire("eTVDv");

var $5Gp6R = parcelRequire("5Gp6R");

var $3sfpc = parcelRequire("3sfpc");

var $3FPX1 = parcelRequire("3FPX1");

var $eBdEN = parcelRequire("eBdEN");

var $2a4Fo = parcelRequire("2a4Fo");

var $ewIze = parcelRequire("ewIze");

var $eNn8G = parcelRequire("eNn8G");

var $9YlaE = parcelRequire("9YlaE");

var $6dvVR = parcelRequire("6dvVR");

var $a4EWe = parcelRequire("a4EWe");
const $68af16ba1f0eb895$var$MAX_DEDUPER_KEYS = 1000;
const $68af16ba1f0eb895$var$DEDUPER_WINDOW_DURATION_MS = 600000;
const $68af16ba1f0eb895$var$EVENT_LOGGER_MAP = {};
class $68af16ba1f0eb895$var$EventLogger {
    static _safeFlushAndForget(sdkKey) {
        var _a;
        (_a = $68af16ba1f0eb895$var$EVENT_LOGGER_MAP[sdkKey]) === null || _a === void 0 || _a.flush().catch(()=>{
        // noop
        });
    }
    constructor(_sdkKey, _emitter, _network, _options, _errorBoundary){
        var _a;
        this._sdkKey = _sdkKey;
        this._emitter = _emitter;
        this._network = _network;
        this._options = _options;
        this._errorBoundary = _errorBoundary;
        this._pendingEvents = null;
        this._batchQueue = null;
        this._flushCoordinator = null;
        this._lastExposureTimeMap = {};
        this._nonExposedChecks = {};
        this._isShuttingDown = false;
        this._storageKey = null;
        this._pendingCompressionMode = null;
        this._loggingEnabled = (_a = _options === null || _options === void 0 ? void 0 : _options.loggingEnabled) !== null && _a !== void 0 ? _a : (_options === null || _options === void 0 ? void 0 : _options.disableLogging) === true ? $eNn8G.LoggingEnabledOption.disabled : $eNn8G.LoggingEnabledOption.browserOnly;
        if ((_options === null || _options === void 0 ? void 0 : _options.loggingEnabled) && _options.disableLogging !== undefined) $3sfpc.Log.warn('Detected both loggingEnabled and disableLogging options. loggingEnabled takes precedence - please remove disableLogging.');
        const config = _options === null || _options === void 0 ? void 0 : _options.networkConfig;
        this._logEventUrlConfig = new $6dvVR.UrlConfiguration($3FPX1.Endpoint._rgstr, config === null || config === void 0 ? void 0 : config.logEventUrl, config === null || config === void 0 ? void 0 : config.api, config === null || config === void 0 ? void 0 : config.logEventFallbackUrls);
    }
    setLogEventCompressionMode(mode) {
        if (this._flushCoordinator) this._flushCoordinator.setLogEventCompressionMode(mode);
        else this._pendingCompressionMode = mode;
    }
    setLoggingEnabled(loggingEnabled) {
        const wasDisabled = this._loggingEnabled === 'disabled';
        const isNowEnabled = loggingEnabled !== 'disabled';
        this._loggingEnabled = loggingEnabled;
        if (this._flushCoordinator) this._flushCoordinator.setLoggingEnabled(loggingEnabled);
        if (wasDisabled && isNowEnabled) {
            const events = this._loadStoredEvents();
            $3sfpc.Log.debug(`Loaded ${events.length} stored event(s) from storage`);
            if (events.length > 0) {
                events.forEach((event)=>{
                    this._initFlushCoordinator().addEvent(event);
                });
                this.flush().catch((error)=>{
                    $3sfpc.Log.warn('Failed to flush events after enabling logging:', error);
                });
            }
        }
    }
    enqueue(event) {
        var _a;
        if (!this._shouldLogEvent(event)) return;
        const normalizedEvent = this._normalizeEvent(event);
        if (this._loggingEnabled === 'disabled') {
            this._storeEventToStorage(normalizedEvent);
            return;
        }
        this._initFlushCoordinator().addEvent(normalizedEvent);
        (_a = this._flushCoordinator) === null || _a === void 0 || _a.checkQuickFlush();
    }
    incrementNonExposureCount(name) {
        var _a;
        const current = (_a = this._nonExposedChecks[name]) !== null && _a !== void 0 ? _a : 0;
        this._nonExposedChecks[name] = current + 1;
    }
    reset() {
        // attempt to flush any remaining events
        this.flush().catch(()=>{
        // noop
        });
        this._lastExposureTimeMap = {};
    }
    start() {
        var _a;
        const isServerEnv = (0, $2a4Fo._isServerEnv)();
        if (isServerEnv && ((_a = this._options) === null || _a === void 0 ? void 0 : _a.loggingEnabled) !== 'always') return;
        const flushCoordinator = this._initFlushCoordinator();
        $68af16ba1f0eb895$var$EVENT_LOGGER_MAP[this._sdkKey] = this;
        if (!isServerEnv) (0, $a4EWe._subscribeToVisiblityChanged)((visibility)=>{
            if (visibility === 'background') $68af16ba1f0eb895$var$EventLogger._safeFlushAndForget(this._sdkKey);
            else if (visibility === 'foreground') flushCoordinator.startScheduledFlushCycle();
        });
        flushCoordinator.loadAndRetryShutdownFailedEvents().catch((error)=>{
            $3sfpc.Log.warn('Failed to load failed shutdown events:', error);
        });
        flushCoordinator.startScheduledFlushCycle();
    }
    stop() {
        return $68af16ba1f0eb895$var$__awaiter(this, void 0, void 0, function*() {
            this._isShuttingDown = true;
            if (this._flushCoordinator) yield this._flushCoordinator.processShutdown();
            delete $68af16ba1f0eb895$var$EVENT_LOGGER_MAP[this._sdkKey];
            this._flushCoordinator = null;
            this._pendingEvents = null;
            this._batchQueue = null;
        });
    }
    flush() {
        return $68af16ba1f0eb895$var$__awaiter(this, void 0, void 0, function*() {
            if (!this._flushCoordinator) return;
            return this._flushCoordinator.processManualFlush();
        });
    }
    appendAndResetNonExposedChecks() {
        if (Object.keys(this._nonExposedChecks).length === 0) return;
        const checks = Object.assign({}, this._nonExposedChecks);
        this._nonExposedChecks = {};
        const event = this._normalizeEvent({
            eventName: 'statsig::non_exposed_checks',
            user: null,
            time: Date.now(),
            metadata: {
                checks: checks
            }
        });
        if (!this._flushCoordinator) return;
        this._flushCoordinator.addEvent(event);
    }
    _shouldLogEvent(event) {
        var _a;
        if (((_a = this._options) === null || _a === void 0 ? void 0 : _a.loggingEnabled) !== 'always' && (0, $2a4Fo._isServerEnv)()) return false;
        if (!(0, $ewIze._isExposureEvent)(event)) return true;
        const user = event.user ? event.user : {
            statsigEnvironment: undefined
        };
        const userKey = (0, $hxeyi._getUserStorageKey)(this._sdkKey, user);
        const metadata = event.metadata ? event.metadata : {};
        const key = [
            event.eventName,
            userKey,
            metadata['gate'],
            metadata['config'],
            metadata['ruleID'],
            metadata['allocatedExperiment'],
            metadata['parameterName'],
            String(metadata['isExplicitParameter']),
            metadata['reason']
        ].join('|');
        const previous = this._lastExposureTimeMap[key];
        const now = Date.now();
        if (previous && now - previous < $68af16ba1f0eb895$var$DEDUPER_WINDOW_DURATION_MS) return false;
        if (Object.keys(this._lastExposureTimeMap).length > $68af16ba1f0eb895$var$MAX_DEDUPER_KEYS) this._lastExposureTimeMap = {};
        this._lastExposureTimeMap[key] = now;
        return true;
    }
    _getCurrentPageUrl() {
        var _a;
        if (((_a = this._options) === null || _a === void 0 ? void 0 : _a.includeCurrentPageUrlWithEvents) === false) return;
        return (0, $2a4Fo._getCurrentPageUrlSafe)();
    }
    _getStorageKey() {
        if (!this._storageKey) this._storageKey = `statsig.pending_events.${(0, $5Gp6R._DJB2)(this._sdkKey)}`;
        return this._storageKey;
    }
    _initFlushCoordinator() {
        var _a, _b;
        if (this._flushCoordinator) return this._flushCoordinator;
        const batchSize = (_b = (_a = this._options) === null || _a === void 0 ? void 0 : _a.loggingBufferMaxSize) !== null && _b !== void 0 ? _b : $c6MRw.EventRetryConstants.DEFAULT_BATCH_SIZE;
        this._pendingEvents = new $eBdEN.PendingEvents(batchSize);
        this._batchQueue = new $6RcCA.BatchQueue(batchSize);
        this._flushCoordinator = new $eTVDv.FlushCoordinator(this._batchQueue, this._pendingEvents, ()=>this.appendAndResetNonExposedChecks(), this._sdkKey, this._network, this._emitter, this._logEventUrlConfig, this._options, this._loggingEnabled, this._errorBoundary);
        if (this._pendingCompressionMode) {
            this._flushCoordinator.setLogEventCompressionMode(this._pendingCompressionMode);
            this._pendingCompressionMode = null;
        }
        return this._flushCoordinator;
    }
    _storeEventToStorage(event) {
        const storageKey = this._getStorageKey();
        try {
            let existingEvents = this._getEventsFromStorage(storageKey);
            existingEvents.push(event);
            if (existingEvents.length > $c6MRw.EventRetryConstants.MAX_LOCAL_STORAGE) existingEvents = existingEvents.slice(-$c6MRw.EventRetryConstants.MAX_LOCAL_STORAGE);
            (0, $9YlaE._setObjectInStorage)(storageKey, existingEvents);
        } catch (error) {
            $3sfpc.Log.warn('Unable to save events to storage');
        }
    }
    _getEventsFromStorage(storageKey) {
        try {
            const events = (0, $9YlaE._getObjectFromStorage)(storageKey);
            if (Array.isArray(events)) return events;
            return [];
        } catch (_a) {
            return [];
        }
    }
    _loadStoredEvents() {
        const storageKey = this._getStorageKey();
        const events = this._getEventsFromStorage(storageKey);
        if (events.length > 0) $9YlaE.Storage.removeItem(storageKey);
        return events;
    }
    _normalizeEvent(event) {
        if (event.user) {
            event.user = Object.assign({}, event.user);
            delete event.user.privateAttributes;
        }
        const extras = {};
        const currentPage = this._getCurrentPageUrl();
        if (currentPage) extras.statsigMetadata = {
            currentPage: currentPage
        };
        return Object.assign(Object.assign({}, event), extras);
    }
}
module.exports.EventLogger = $68af16ba1f0eb895$var$EventLogger;

});
parcelRegister("6RcCA", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.BatchQueue = void 0;

var $5DUgD = parcelRequire("5DUgD");

var $c6MRw = parcelRequire("c6MRw");
class $4fe17ba79519d6f9$var$BatchQueue {
    constructor(batchSize = $c6MRw.EventRetryConstants.DEFAULT_BATCH_SIZE){
        this._batches = [];
        this._batchSize = batchSize;
    }
    batchSize() {
        return this._batchSize;
    }
    requeueBatch(batch) {
        return this._enqueueBatch(batch);
    }
    hasFullBatch() {
        return this._batches.some((batch)=>batch.events.length >= this._batchSize);
    }
    takeNextBatch() {
        return this._batches.shift();
    }
    takeAllBatches() {
        const batches = this._batches;
        this._batches = [];
        return batches;
    }
    createBatches(events) {
        let i = 0;
        let droppedCount = 0;
        while(i < events.length){
            const chunk = events.slice(i, i + this._batchSize);
            droppedCount += this._enqueueBatch(new $5DUgD.EventBatch(chunk));
            i += this._batchSize;
        }
        return droppedCount;
    }
    _enqueueBatch(batch) {
        this._batches.push(batch);
        let droppedEventCount = 0;
        while(this._batches.length > $c6MRw.EventRetryConstants.MAX_PENDING_BATCHES){
            const dropped = this._batches.shift();
            if (dropped) droppedEventCount += dropped.events.length;
        }
        return droppedEventCount;
    }
}
module.exports.BatchQueue = $4fe17ba79519d6f9$var$BatchQueue;

});
parcelRegister("5DUgD", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.EventBatch = void 0;
class $41bc3dc60aeb1222$var$EventBatch {
    constructor(events){
        this.attempts = 0;
        this.createdAt = Date.now();
        this.events = events;
    }
    incrementAttempts() {
        this.attempts++;
    }
}
module.exports.EventBatch = $41bc3dc60aeb1222$var$EventBatch;

});

parcelRegister("c6MRw", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.EventRetryConstants = void 0;
module.exports.EventRetryConstants = {
    MAX_RETRY_ATTEMPTS: 5,
    DEFAULT_BATCH_SIZE: 100,
    MAX_PENDING_BATCHES: 30,
    TICK_INTERVAL_MS: 1000,
    QUICK_FLUSH_WINDOW_MS: 200,
    MAX_LOCAL_STORAGE: 500,
    get MAX_QUEUED_EVENTS () {
        return this.DEFAULT_BATCH_SIZE * this.MAX_PENDING_BATCHES;
    }
};

});


parcelRegister("hxeyi", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._getStorageKey = module.exports._getUserStorageKey = void 0;

var $5Gp6R = parcelRequire("5Gp6R");
function $cc40ce7f83b062c2$var$_getUserStorageKey(sdkKey, user, customKeyGenerator) {
    var _a;
    if (customKeyGenerator) return customKeyGenerator(sdkKey, user);
    const cids = user && user.customIDs ? user.customIDs : {};
    const parts = [
        `uid:${(_a = user === null || user === void 0 ? void 0 : user.userID) !== null && _a !== void 0 ? _a : ''}`,
        `cids:${Object.keys(cids).sort((leftKey, rightKey)=>leftKey.localeCompare(rightKey)).map((key)=>`${key}-${cids[key]}`).join(',')}`,
        `k:${sdkKey}`
    ];
    return (0, $5Gp6R._DJB2)(parts.join('|'));
}
module.exports._getUserStorageKey = $cc40ce7f83b062c2$var$_getUserStorageKey;
function $cc40ce7f83b062c2$var$_getStorageKey(sdkKey, user, customKeyGenerator) {
    if (user) return $cc40ce7f83b062c2$var$_getUserStorageKey(sdkKey, user, customKeyGenerator);
    return (0, $5Gp6R._DJB2)(`k:${sdkKey}`);
}
module.exports._getStorageKey = $cc40ce7f83b062c2$var$_getStorageKey;

});
parcelRegister("5Gp6R", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._getSortedObject = module.exports._DJB2Object = module.exports._DJB2 = void 0;

var $lje2o = parcelRequire("lje2o");
const $42345a3d8254fc0b$var$_DJB2 = (value)=>{
    let hash = 0;
    for(let i = 0; i < value.length; i++){
        const character = value.charCodeAt(i);
        hash = (hash << 5) - hash + character;
        hash = hash & hash; // Convert to 32bit integer
    }
    return String(hash >>> 0);
};
module.exports._DJB2 = $42345a3d8254fc0b$var$_DJB2;
const $42345a3d8254fc0b$var$_DJB2Object = (value, maxLevels)=>{
    return (0, module.exports._DJB2)(JSON.stringify((0, module.exports._getSortedObject)(value, maxLevels)));
};
module.exports._DJB2Object = $42345a3d8254fc0b$var$_DJB2Object;
const $42345a3d8254fc0b$var$_getSortedObject = (object, maxDepth)=>{
    if (object == null) return null;
    const keys = Object.keys(object).sort();
    const sortedObject = {};
    keys.forEach((key)=>{
        const value = object[key];
        if (maxDepth === 0 || (0, $lje2o._typeOf)(value) !== 'object') {
            sortedObject[key] = value;
            return;
        }
        sortedObject[key] = (0, module.exports._getSortedObject)(value, maxDepth != null ? maxDepth - 1 : maxDepth);
    });
    return sortedObject;
};
module.exports._getSortedObject = $42345a3d8254fc0b$var$_getSortedObject;

});
parcelRegister("lje2o", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._isTypeMatch = module.exports._typeOf = void 0;
function $f83642e04fbd001e$var$_typeOf(input) {
    return Array.isArray(input) ? 'array' : typeof input;
}
module.exports._typeOf = $f83642e04fbd001e$var$_typeOf;
function $f83642e04fbd001e$var$_isTypeMatch(a, b) {
    const typeOf = (x)=>Array.isArray(x) ? 'array' : x === null ? 'null' : typeof x;
    return typeOf(a) === typeOf(b);
}
module.exports._isTypeMatch = $f83642e04fbd001e$var$_isTypeMatch;

});



parcelRegister("eTVDv", function(module, exports) {
"use strict";
var $ad92e9137ac9e0b5$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.FlushCoordinator = void 0;

var $c6MRw = parcelRequire("c6MRw");

var $5YbMX = parcelRequire("5YbMX");

var $NFhJD = parcelRequire("NFhJD");

var $3kkqp = parcelRequire("3kkqp");

var $5Gp6R = parcelRequire("5Gp6R");

var $3sfpc = parcelRequire("3sfpc");

var $8gIKV = parcelRequire("8gIKV");

var $1pnfi = parcelRequire("1pnfi");

var $9YlaE = parcelRequire("9YlaE");
class $ad92e9137ac9e0b5$var$FlushCoordinator {
    constructor(batchQueue, pendingEvents, onPrepareFlush, // For Event Sender
    sdkKey, network, emitter, logEventUrlConfig, options, loggingEnabled, errorBoundary){
        this._cooldownTimer = null;
        this._maxIntervalTimer = null;
        this._hasRunQuickFlush = false;
        this._currentFlushPromise = null;
        this._creationTime = Date.now();
        this._isShuttingDown = false;
        this._storageKey = null;
        this._flushInterval = new $NFhJD.FlushInterval();
        this._batchQueue = batchQueue;
        this._pendingEvents = pendingEvents;
        this._onPrepareFlush = onPrepareFlush;
        this._errorBoundary = errorBoundary;
        this._sdkKey = sdkKey;
        this._eventSender = new $5YbMX.EventSender(sdkKey, network, emitter, logEventUrlConfig, options, loggingEnabled);
    }
    setLoggingEnabled(loggingEnabled) {
        this._eventSender.setLoggingEnabled(loggingEnabled);
    }
    setLogEventCompressionMode(mode) {
        this._eventSender.setLogEventCompressionMode(mode);
    }
    startScheduledFlushCycle() {
        this._scheduleNextFlush();
    }
    stopScheduledFlushCycle() {
        this._clearAllTimers();
    }
    addEvent(event) {
        this._pendingEvents.addToPendingEventsQueue(event);
        if (this._currentFlushPromise) return;
        if (this._pendingEvents.hasEventsForFullBatch()) this.processLimitFlush();
    }
    processManualFlush() {
        return $ad92e9137ac9e0b5$var$__awaiter(this, void 0, void 0, function*() {
            if (this._currentFlushPromise) yield this._currentFlushPromise;
            this._currentFlushPromise = this._executeFlush($3kkqp.FlushType.Manual).finally(()=>{
                this._currentFlushPromise = null;
                this._scheduleNextFlush();
            });
            return this._currentFlushPromise;
        });
    }
    processShutdown() {
        return $ad92e9137ac9e0b5$var$__awaiter(this, void 0, void 0, function*() {
            this._isShuttingDown = true;
            this._clearAllTimers();
            if (this._currentFlushPromise) yield this._currentFlushPromise;
            this._currentFlushPromise = this._executeFlush($3kkqp.FlushType.Shutdown).catch((error)=>{
                $3sfpc.Log.error(`Error during shutdown flush: ${error}`);
            }).finally(()=>{
                this._currentFlushPromise = null;
            });
            return this._currentFlushPromise;
        });
    }
    _executeFlush(flushType) {
        return $ad92e9137ac9e0b5$var$__awaiter(this, void 0, void 0, function*() {
            this._clearAllTimers();
            try {
                this._prepareQueueForFlush(flushType);
                const batches = this._batchQueue.takeAllBatches();
                if (batches.length === 0) return;
                yield Promise.all(batches.map((batch)=>this._processOneBatch(batch, flushType)));
            } finally{
                if (!this._isShuttingDown) this._scheduleNextFlush();
            }
        });
    }
    checkQuickFlush() {
        if (this._hasRunQuickFlush) return;
        if (Date.now() - this._creationTime > $c6MRw.EventRetryConstants.QUICK_FLUSH_WINDOW_MS) return;
        this._hasRunQuickFlush = true;
        setTimeout(()=>{
            this.processManualFlush().catch((error)=>{
                $3sfpc.Log.warn('Quick flush failed:', error);
            });
        }, $c6MRw.EventRetryConstants.QUICK_FLUSH_WINDOW_MS);
    }
    _attemptScheduledFlush() {
        if (this._currentFlushPromise) {
            this._scheduleNextFlush();
            return;
        }
        const shouldFlushBySize = this.containsAtLeastOneFullBatch();
        const shouldFlushByTime = this._flushInterval.hasReachedMaxInterval();
        if (!shouldFlushBySize && !shouldFlushByTime) {
            this._scheduleNoopPollTick();
            return;
        }
        this._flushInterval.markFlushAttempt();
        let flushType;
        if (shouldFlushBySize) flushType = $3kkqp.FlushType.ScheduledFullBatch;
        else flushType = $3kkqp.FlushType.ScheduledMaxTime;
        this._currentFlushPromise = this._processNextBatch(flushType).then(()=>{
        //This discards boolean result. Main goal here is to track completion
        }).catch((error)=>{
            $3sfpc.Log.error('Error during scheduled flush:', error);
        }).finally(()=>{
            this._currentFlushPromise = null;
            this._scheduleNextFlush();
        });
    }
    processLimitFlush() {
        if (!this._flushInterval.hasCompletelyRecoveredFromBackoff()) return;
        if (this._currentFlushPromise) return;
        this._currentFlushPromise = this._processLimitFlushInternal().catch((error)=>{
            $3sfpc.Log.error(`Error during limit flush`, error);
        }).finally(()=>{
            this._currentFlushPromise = null;
            this._scheduleNextFlush();
        });
    }
    _processLimitFlushInternal() {
        return $ad92e9137ac9e0b5$var$__awaiter(this, void 0, void 0, function*() {
            const success = yield this._processNextBatch($3kkqp.FlushType.Limit);
            if (!success) return;
            while(this._flushInterval.hasCompletelyRecoveredFromBackoff() && this.containsAtLeastOneFullBatch()){
                const success = yield this._processNextBatch($3kkqp.FlushType.Limit);
                if (!success) break;
            }
        });
    }
    _scheduleNextFlush() {
        this._clearAllTimers();
        if (this._isShuttingDown) return;
        const cooldownDelay = Math.max(0, this._flushInterval.getTimeUntilNextFlush());
        this._cooldownTimer = setTimeout(()=>{
            this._cooldownTimer = null;
            $1pnfi.StatsigSession.checkForIdleSession(this._sdkKey);
            this._attemptScheduledFlush();
        }, cooldownDelay);
        const maxIntervalDelay = Math.max(0, this._flushInterval.getTimeTillMaxInterval());
        this._maxIntervalTimer = setTimeout(()=>{
            this._maxIntervalTimer = null;
            $1pnfi.StatsigSession.checkForIdleSession(this._sdkKey);
            this._attemptScheduledFlush();
        }, maxIntervalDelay);
    }
    _clearAllTimers() {
        if (this._cooldownTimer !== null) {
            clearTimeout(this._cooldownTimer);
            this._cooldownTimer = null;
        }
        if (this._maxIntervalTimer !== null) {
            clearTimeout(this._maxIntervalTimer);
            this._maxIntervalTimer = null;
        }
    }
    _scheduleNoopPollTick() {
        this._clearAllTimers();
        if (this._isShuttingDown) return;
        this._cooldownTimer = setTimeout(()=>{
            this._cooldownTimer = null;
            $1pnfi.StatsigSession.checkForIdleSession(this._sdkKey);
            this._attemptScheduledFlush();
        }, $c6MRw.EventRetryConstants.TICK_INTERVAL_MS);
        const maxIntervalDelay = Math.max(0, this._flushInterval.getTimeTillMaxInterval());
        this._maxIntervalTimer = setTimeout(()=>{
            this._maxIntervalTimer = null;
            $1pnfi.StatsigSession.checkForIdleSession(this._sdkKey);
            this._attemptScheduledFlush();
        }, maxIntervalDelay);
    }
    _processNextBatch(flushType) {
        return $ad92e9137ac9e0b5$var$__awaiter(this, void 0, void 0, function*() {
            this._prepareQueueForFlush(flushType);
            const batch = this._batchQueue.takeNextBatch();
            if (!batch) return false;
            return this._processOneBatch(batch, flushType);
        });
    }
    _processOneBatch(batch, flushType) {
        return $ad92e9137ac9e0b5$var$__awaiter(this, void 0, void 0, function*() {
            const result = yield this._eventSender.sendBatch(batch);
            if (result.success) {
                this._flushInterval.adjustForSuccess();
                return true;
            }
            this._flushInterval.adjustForFailure();
            this._handleFailure(batch, flushType, result.statusCode);
            return false;
        });
    }
    _prepareQueueForFlush(flushType) {
        this._onPrepareFlush();
        const droppedCount = this.convertPendingEventsToBatches();
        if (droppedCount > 0) {
            $3sfpc.Log.warn(`Dropped ${droppedCount} events`);
            this._errorBoundary.logDroppedEvents(droppedCount, `Batch queue limit reached`, {
                loggingInterval: this._flushInterval.getCurrentIntervalMs(),
                batchSize: this._batchQueue.batchSize(),
                maxPendingBatches: $c6MRw.EventRetryConstants.MAX_PENDING_BATCHES,
                flushType: flushType,
                retries: 'dropped before batching'
            });
        }
    }
    containsAtLeastOneFullBatch() {
        return this._pendingEvents.hasEventsForFullBatch() || this._batchQueue.hasFullBatch();
    }
    convertPendingEventsToBatches() {
        if (this._pendingEvents.isEmpty()) return 0;
        const allEvents = this._pendingEvents.takeAll();
        return this._batchQueue.createBatches(allEvents);
    }
    _handleFailure(batch, flushType, statusCode) {
        if (flushType === $3kkqp.FlushType.Shutdown) {
            $3sfpc.Log.warn(`${flushType} flush failed during shutdown. ` + `${batch.events.length} event(s) will be saved to storage for retry in next session.`);
            this._saveShutdownFailedEventsToStorage(batch.events);
            return;
        }
        if (!$8gIKV.RETRYABLE_CODES.has(statusCode)) {
            $3sfpc.Log.warn(`${flushType} flush failed after ${batch.attempts} attempt(s). ` + `${batch.events.length} event(s) will be dropped. Non-retryable error: ${statusCode}`);
            this._errorBoundary.logEventRequestFailure(batch.events.length, `non-retryable error`, flushType, statusCode, batch.attempts);
            return;
        }
        if (batch.attempts >= $c6MRw.EventRetryConstants.MAX_RETRY_ATTEMPTS) {
            $3sfpc.Log.warn(`${flushType} flush failed after ${batch.attempts} attempt(s). ` + `${batch.events.length} event(s) will be dropped.`);
            this._errorBoundary.logEventRequestFailure(batch.events.length, `max retry attempts exceeded`, flushType, statusCode, batch.attempts);
            return;
        }
        batch.incrementAttempts();
        const droppedCount = this._batchQueue.requeueBatch(batch);
        if (droppedCount > 0) {
            $3sfpc.Log.warn(`Failed to requeue batch : dropped ${droppedCount} events due to full queue`);
            this._errorBoundary.logDroppedEvents(droppedCount, `Batch queue limit reached`, {
                loggingInterval: this._flushInterval.getCurrentIntervalMs(),
                batchSize: this._batchQueue.batchSize(),
                maxPendingBatches: $c6MRw.EventRetryConstants.MAX_PENDING_BATCHES,
                flushType: flushType,
                retries: batch.attempts
            });
        }
    }
    loadAndRetryShutdownFailedEvents() {
        return $ad92e9137ac9e0b5$var$__awaiter(this, void 0, void 0, function*() {
            const storageKey = this._getStorageKey();
            try {
                if (!$9YlaE.Storage.isReady()) yield $9YlaE.Storage.isReadyResolver();
                const events = this._getShutdownFailedEventsFromStorage(storageKey);
                if (events.length === 0) return;
                $3sfpc.Log.debug(`Loading ${events.length} failed shutdown event(s) from storage for retry`);
                $9YlaE.Storage.removeItem(storageKey);
                events.forEach((event)=>{
                    this.addEvent(event);
                });
                yield this.processManualFlush();
            } catch (error) {
                $3sfpc.Log.warn('Failed to load and retry failed shutdown events:', error);
            }
        });
    }
    _getStorageKey() {
        if (!this._storageKey) this._storageKey = `statsig.failed_shutdown_events.${(0, $5Gp6R._DJB2)(this._sdkKey)}`;
        return this._storageKey;
    }
    _saveShutdownFailedEventsToStorage(events) {
        const storageKey = this._getStorageKey();
        try {
            const existingEvents = this._getShutdownFailedEventsFromStorage(storageKey);
            let allEvents = [
                ...existingEvents,
                ...events
            ];
            if (allEvents.length > $c6MRw.EventRetryConstants.MAX_LOCAL_STORAGE) allEvents = allEvents.slice(-$c6MRw.EventRetryConstants.MAX_LOCAL_STORAGE);
            (0, $9YlaE._setObjectInStorage)(storageKey, allEvents);
            $3sfpc.Log.debug(`Saved ${events.length} failed shutdown event(s) to storage (total stored: ${allEvents.length})`);
        } catch (error) {
            $3sfpc.Log.warn('Unable to save failed shutdown events to storage:', error);
        }
    }
    _getShutdownFailedEventsFromStorage(storageKey) {
        try {
            const events = (0, $9YlaE._getObjectFromStorage)(storageKey);
            if (Array.isArray(events)) return events;
            return [];
        } catch (_a) {
            return [];
        }
    }
}
module.exports.FlushCoordinator = $ad92e9137ac9e0b5$var$FlushCoordinator;

});
parcelRegister("5YbMX", function(module, exports) {
"use strict";
var $458bb3518fc4dc49$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.EventSender = void 0;

var $3sfpc = parcelRequire("3sfpc");

var $3FPX1 = parcelRequire("3FPX1");

var $a4EWe = parcelRequire("a4EWe");
class $458bb3518fc4dc49$var$EventSender {
    constructor(sdkKey, network, emitter, logEventUrlConfig, options, loggingEnabled){
        this._sdkKey = sdkKey;
        this._network = network;
        this._emitter = emitter;
        this._options = options;
        this._logEventUrlConfig = logEventUrlConfig;
        this._loggingEnabled = loggingEnabled;
    }
    setLogEventCompressionMode(mode) {
        this._network.setLogEventCompressionMode(mode);
    }
    setLoggingEnabled(enabled) {
        this._loggingEnabled = enabled;
    }
    sendBatch(batch) {
        return $458bb3518fc4dc49$var$__awaiter(this, void 0, void 0, function*() {
            var _a, _b;
            try {
                const isClosing = (0, $a4EWe._isUnloading)();
                const shouldUseBeacon = isClosing && this._network.isBeaconSupported() && ((_b = (_a = this._options) === null || _a === void 0 ? void 0 : _a.networkConfig) === null || _b === void 0 ? void 0 : _b.networkOverrideFunc) == null;
                this._emitter({
                    name: 'pre_logs_flushed',
                    events: batch.events
                });
                const response = shouldUseBeacon ? this._sendEventsViaBeacon(batch) : yield this._sendEventsViaPost(batch);
                if (response.success) {
                    this._emitter({
                        name: 'logs_flushed',
                        events: batch.events
                    });
                    return response;
                }
                return {
                    success: false,
                    statusCode: response.statusCode
                };
            } catch (error) {
                $3sfpc.Log.warn('Failed to send batch:', error);
                return {
                    success: false,
                    statusCode: -1
                };
            }
        });
    }
    _sendEventsViaPost(batch) {
        return $458bb3518fc4dc49$var$__awaiter(this, void 0, void 0, function*() {
            var _a;
            const result = yield this._network.post(this._getRequestData(batch));
            const code = (_a = result === null || result === void 0 ? void 0 : result.code) !== null && _a !== void 0 ? _a : -1;
            return {
                success: code >= 200 && code < 300,
                statusCode: code
            };
        });
    }
    _sendEventsViaBeacon(batch) {
        const success = this._network.beacon(this._getRequestData(batch));
        return {
            success: success,
            statusCode: success ? 200 : -1
        };
    }
    _getRequestData(batch) {
        return {
            sdkKey: this._sdkKey,
            data: {
                events: batch.events
            },
            urlConfig: this._logEventUrlConfig,
            retries: 3,
            isCompressable: true,
            params: {
                [$3FPX1.NetworkParam.EventCount]: String(batch.events.length)
            },
            headers: {
                'statsig-event-count': String(batch.events.length),
                'statsig-retry-count': String(batch.attempts)
            },
            credentials: 'same-origin'
        };
    }
}
module.exports.EventSender = $458bb3518fc4dc49$var$EventSender;

});
parcelRegister("3FPX1", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.NetworkParam = module.exports.NetworkDefault = module.exports.Endpoint = void 0;
module.exports.Endpoint = {
    _initialize: 'initialize',
    _rgstr: 'rgstr',
    _download_config_specs: 'download_config_specs'
};
module.exports.NetworkDefault = {
    [module.exports.Endpoint._rgstr]: 'https://prodregistryv2.org/v1',
    [module.exports.Endpoint._initialize]: 'https://featureassets.org/v1',
    [module.exports.Endpoint._download_config_specs]: 'https://api.statsigcdn.com/v1'
};
module.exports.NetworkParam = {
    EventCount: 'ec',
    SdkKey: 'k',
    SdkType: 'st',
    SdkVersion: 'sv',
    Time: 't',
    SessionID: 'sid',
    StatsigEncoded: 'se',
    IsGzipped: 'gz'
};

});

parcelRegister("a4EWe", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._notifyVisibilityChanged = module.exports._subscribeToVisiblityChanged = module.exports._isUnloading = module.exports._isCurrentlyVisible = void 0;

var $2a4Fo = parcelRequire("2a4Fo");
const $755a0897cd2abc87$var$FOREGROUND = 'foreground';
const $755a0897cd2abc87$var$BACKGROUND = 'background';
const $755a0897cd2abc87$var$LISTENERS = [];
let $755a0897cd2abc87$var$current = $755a0897cd2abc87$var$FOREGROUND;
let $755a0897cd2abc87$var$isUnloading = false;
const $755a0897cd2abc87$var$_isCurrentlyVisible = ()=>{
    return $755a0897cd2abc87$var$current === $755a0897cd2abc87$var$FOREGROUND;
};
module.exports._isCurrentlyVisible = $755a0897cd2abc87$var$_isCurrentlyVisible;
const $755a0897cd2abc87$var$_isUnloading = ()=>$755a0897cd2abc87$var$isUnloading;
module.exports._isUnloading = $755a0897cd2abc87$var$_isUnloading;
const $755a0897cd2abc87$var$_subscribeToVisiblityChanged = (listener)=>{
    $755a0897cd2abc87$var$LISTENERS.unshift(listener);
};
module.exports._subscribeToVisiblityChanged = $755a0897cd2abc87$var$_subscribeToVisiblityChanged;
const $755a0897cd2abc87$var$_notifyVisibilityChanged = (visibility)=>{
    if (visibility === $755a0897cd2abc87$var$current) return;
    $755a0897cd2abc87$var$current = visibility;
    $755a0897cd2abc87$var$LISTENERS.forEach((l)=>l(visibility));
};
module.exports._notifyVisibilityChanged = $755a0897cd2abc87$var$_notifyVisibilityChanged;
(0, $2a4Fo._addWindowEventListenerSafe)('focus', ()=>{
    $755a0897cd2abc87$var$isUnloading = false;
    (0, module.exports._notifyVisibilityChanged)($755a0897cd2abc87$var$FOREGROUND);
});
(0, $2a4Fo._addWindowEventListenerSafe)('blur', ()=>(0, module.exports._notifyVisibilityChanged)($755a0897cd2abc87$var$BACKGROUND));
(0, $2a4Fo._addDocumentEventListenerSafe)('visibilitychange', ()=>{
    (0, module.exports._notifyVisibilityChanged)(document.visibilityState === 'visible' ? $755a0897cd2abc87$var$FOREGROUND : $755a0897cd2abc87$var$BACKGROUND);
});
(0, $2a4Fo._addWindowEventListenerSafe)((0, $2a4Fo._getUnloadEvent)(), ()=>{
    $755a0897cd2abc87$var$isUnloading = true;
    (0, module.exports._notifyVisibilityChanged)($755a0897cd2abc87$var$BACKGROUND);
});

});
parcelRegister("2a4Fo", function(module, exports) {

var $3ZMUU = parcelRequire("3ZMUU");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._cloneObject = module.exports._getUnloadEvent = module.exports._getCurrentPageUrlSafe = module.exports._addDocumentEventListenerSafe = module.exports._addWindowEventListenerSafe = module.exports._isServerEnv = module.exports._getDocumentSafe = module.exports._getWindowSafe = void 0;

var $3sfpc = parcelRequire("3sfpc");
const $1930229ffecc4100$var$_getWindowSafe = ()=>{
    return typeof window !== 'undefined' ? window : null;
};
module.exports._getWindowSafe = $1930229ffecc4100$var$_getWindowSafe;
const $1930229ffecc4100$var$_getDocumentSafe = ()=>{
    var _a;
    const win = (0, module.exports._getWindowSafe)();
    return (_a = win === null || win === void 0 ? void 0 : win.document) !== null && _a !== void 0 ? _a : null;
};
module.exports._getDocumentSafe = $1930229ffecc4100$var$_getDocumentSafe;
const $1930229ffecc4100$var$_isServerEnv = ()=>{
    if ((0, module.exports._getDocumentSafe)() !== null) return false;
    const isNode = typeof $3ZMUU !== 'undefined' && $3ZMUU.versions != null && $3ZMUU.versions.node != null;
    const isVercel = typeof EdgeRuntime === 'string';
    return isVercel || isNode;
};
module.exports._isServerEnv = $1930229ffecc4100$var$_isServerEnv;
const $1930229ffecc4100$var$_addWindowEventListenerSafe = (key, listener)=>{
    const win = (0, module.exports._getWindowSafe)();
    if (typeof (win === null || win === void 0 ? void 0 : win.addEventListener) === 'function') win.addEventListener(key, listener);
};
module.exports._addWindowEventListenerSafe = $1930229ffecc4100$var$_addWindowEventListenerSafe;
const $1930229ffecc4100$var$_addDocumentEventListenerSafe = (key, listener)=>{
    const doc = (0, module.exports._getDocumentSafe)();
    if (typeof (doc === null || doc === void 0 ? void 0 : doc.addEventListener) === 'function') doc.addEventListener(key, listener);
};
module.exports._addDocumentEventListenerSafe = $1930229ffecc4100$var$_addDocumentEventListenerSafe;
const $1930229ffecc4100$var$_getCurrentPageUrlSafe = ()=>{
    var _a;
    try {
        return (_a = (0, module.exports._getWindowSafe)()) === null || _a === void 0 ? void 0 : _a.location.href.split(/[?#]/)[0];
    } catch (_b) {
        return;
    }
};
module.exports._getCurrentPageUrlSafe = $1930229ffecc4100$var$_getCurrentPageUrlSafe;
const $1930229ffecc4100$var$_getUnloadEvent = ()=>{
    const win = (0, module.exports._getWindowSafe)();
    if (!win) return 'beforeunload';
    const eventType = 'onpagehide' in win ? 'pagehide' : 'beforeunload';
    return eventType;
};
module.exports._getUnloadEvent = $1930229ffecc4100$var$_getUnloadEvent;
const $1930229ffecc4100$var$_cloneObject = (tag, obj)=>{
    try {
        return JSON.parse(JSON.stringify(obj));
    } catch (error) {
        $3sfpc.Log.error(`Failed to clone object ${tag}`);
        return null;
    }
};
module.exports._cloneObject = $1930229ffecc4100$var$_cloneObject;

});



parcelRegister("NFhJD", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.FlushInterval = void 0;
const $09549a1180cd40b6$var$MIN_FLUSH_INTERVAL_MS = 1000;
const $09549a1180cd40b6$var$MAX_FLUSH_INTERVAL_MS = 60000;
class $09549a1180cd40b6$var$FlushInterval {
    constructor(){
        this._currentIntervalMs = $09549a1180cd40b6$var$MIN_FLUSH_INTERVAL_MS;
        this._lastFlushAttemptTime = Date.now();
    }
    getCurrentIntervalMs() {
        return this._currentIntervalMs;
    }
    markFlushAttempt() {
        this._lastFlushAttemptTime = Date.now();
    }
    getTimeSinceLastAttempt() {
        return Date.now() - this._lastFlushAttemptTime;
    }
    hasReachedMaxInterval() {
        return this.getTimeSinceLastAttempt() >= $09549a1180cd40b6$var$MAX_FLUSH_INTERVAL_MS;
    }
    getTimeTillMaxInterval() {
        return $09549a1180cd40b6$var$MAX_FLUSH_INTERVAL_MS - this.getTimeSinceLastAttempt();
    }
    hasCompletelyRecoveredFromBackoff() {
        return this._currentIntervalMs <= $09549a1180cd40b6$var$MIN_FLUSH_INTERVAL_MS;
    }
    adjustForSuccess() {
        const current = this._currentIntervalMs;
        if (current === $09549a1180cd40b6$var$MIN_FLUSH_INTERVAL_MS) return;
        this._currentIntervalMs = Math.max($09549a1180cd40b6$var$MIN_FLUSH_INTERVAL_MS, Math.floor(current / 2));
    }
    adjustForFailure() {
        const current = this._currentIntervalMs;
        this._currentIntervalMs = Math.min($09549a1180cd40b6$var$MAX_FLUSH_INTERVAL_MS, current * 2);
    }
    getTimeUntilNextFlush() {
        return this.getCurrentIntervalMs() - this.getTimeSinceLastAttempt();
    }
}
module.exports.FlushInterval = $09549a1180cd40b6$var$FlushInterval;

});

parcelRegister("3kkqp", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.FlushType = void 0;
/* eslint-disable no-restricted-syntax */ var $26c31556652aa797$var$FlushType;
(function(FlushType) {
    FlushType["ScheduledMaxTime"] = "scheduled:max_time";
    FlushType["ScheduledFullBatch"] = "scheduled:full_batch";
    FlushType["Limit"] = "limit";
    FlushType["Manual"] = "manual";
    FlushType["Shutdown"] = "shutdown";
})($26c31556652aa797$var$FlushType || (module.exports.FlushType = $26c31556652aa797$var$FlushType = {}));

});

parcelRegister("8gIKV", function(module, exports) {
"use strict";
var $605288f13d9b4857$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.NetworkCore = module.exports.RETRYABLE_CODES = void 0;

var $khZUo = parcelRequire("khZUo");

var $khZUo = parcelRequire("khZUo");

var $6sWDY = parcelRequire("6sWDY");

var $3sfpc = parcelRequire("3sfpc");

var $3FPX1 = parcelRequire("3FPX1");

var $8MXmu = parcelRequire("8MXmu");

var $lGjbM = parcelRequire("lGjbM");

var $aiqjf = parcelRequire("aiqjf");

var $2a4Fo = parcelRequire("2a4Fo");

var $1pnfi = parcelRequire("1pnfi");

var $gxJjE = parcelRequire("gxJjE");

var $kL3cd = parcelRequire("kL3cd");

var $5CBso = parcelRequire("5CBso");

var $eNn8G = parcelRequire("eNn8G");

var $a4EWe = parcelRequire("a4EWe");
const $605288f13d9b4857$var$DEFAULT_TIMEOUT_MS = 10000;
const $605288f13d9b4857$var$BACKOFF_BASE_MS = 500;
const $605288f13d9b4857$var$BACKOFF_MAX_MS = 30000;
const $605288f13d9b4857$var$RATE_LIMIT_WINDOW_MS = 1000;
const $605288f13d9b4857$var$RATE_LIMIT_MAX_REQ_COUNT = 50;
const $605288f13d9b4857$var$LEAK_RATE = $605288f13d9b4857$var$RATE_LIMIT_MAX_REQ_COUNT / $605288f13d9b4857$var$RATE_LIMIT_WINDOW_MS;
module.exports.RETRYABLE_CODES = new Set([
    408,
    500,
    502,
    503,
    504,
    522,
    524,
    599
]);
class $605288f13d9b4857$var$NetworkCore {
    constructor(options, _emitter){
        this._emitter = _emitter;
        this._errorBoundary = null;
        this._timeout = $605288f13d9b4857$var$DEFAULT_TIMEOUT_MS;
        this._netConfig = {};
        this._options = {};
        this._leakyBucket = {};
        this._lastUsedInitUrl = null;
        if (options) this._options = options;
        if (this._options.networkConfig) this._netConfig = this._options.networkConfig;
        if (this._netConfig.networkTimeoutMs) this._timeout = this._netConfig.networkTimeoutMs;
        this._fallbackResolver = new $8MXmu.NetworkFallbackResolver(this._options);
        this.setLogEventCompressionMode(this._getLogEventCompressionMode(options));
    }
    setLogEventCompressionMode(mode) {
        this._options.logEventCompressionMode = mode;
    }
    setErrorBoundary(errorBoundary) {
        this._errorBoundary = errorBoundary;
        this._errorBoundary.wrap(this);
        this._errorBoundary.wrap(this._fallbackResolver);
        this._fallbackResolver.setErrorBoundary(errorBoundary);
    }
    isBeaconSupported() {
        return typeof navigator !== 'undefined' && typeof navigator.sendBeacon === 'function';
    }
    getLastUsedInitUrlAndReset() {
        const tempUrl = this._lastUsedInitUrl;
        this._lastUsedInitUrl = null;
        return tempUrl;
    }
    beacon(args) {
        if (!$605288f13d9b4857$var$_ensureValidSdkKey(args)) return false;
        const argsInternal = this._getInternalRequestArgs('POST', args);
        const url = this._getPopulatedURL(argsInternal);
        const nav = navigator;
        return nav.sendBeacon.bind(nav)(url, argsInternal.body);
    }
    post(args) {
        return $605288f13d9b4857$var$__awaiter(this, void 0, void 0, function*() {
            const argsInternal = this._getInternalRequestArgs('POST', args);
            this._tryEncodeBody(argsInternal);
            yield this._tryToCompressBody(argsInternal);
            return this._sendRequest(argsInternal);
        });
    }
    get(args) {
        const argsInternal = this._getInternalRequestArgs('GET', args);
        return this._sendRequest(argsInternal);
    }
    _sendRequest(args) {
        return $605288f13d9b4857$var$__awaiter(this, void 0, void 0, function*() {
            var _a, _b, _c, _d;
            if (!$605288f13d9b4857$var$_ensureValidSdkKey(args)) return null;
            if (this._netConfig.preventAllNetworkTraffic) return null;
            const { method: method, body: body, retries: retries, attempt: attempt } = args;
            const endpoint = args.urlConfig.endpoint;
            if (this._isRateLimited(endpoint)) {
                $3sfpc.Log.warn(`Request to ${endpoint} was blocked because you are making requests too frequently.`);
                return null;
            }
            const currentAttempt = attempt !== null && attempt !== void 0 ? attempt : 1;
            let reqTimedOut = false;
            const populatedUrl = this._getPopulatedURL(args);
            let response = null;
            const keepalive = (0, $a4EWe._isUnloading)();
            try {
                const config = {
                    method: method,
                    body: body,
                    headers: Object.assign({}, args.headers),
                    priority: args.priority,
                    keepalive: keepalive
                };
                $605288f13d9b4857$var$_tryMarkInitStart(args, currentAttempt);
                const bucket = this._leakyBucket[endpoint];
                if (bucket) {
                    bucket.lastRequestTime = Date.now();
                    this._leakyBucket[endpoint] = bucket;
                }
                const func = (_a = this._netConfig.networkOverrideFunc) !== null && _a !== void 0 ? _a : fetch;
                let timeoutId;
                response = yield Promise.race([
                    func(populatedUrl, config).finally(()=>clearTimeout(timeoutId)),
                    new Promise((_, reject)=>{
                        timeoutId = setTimeout(()=>{
                            reqTimedOut = true;
                            reject(new Error(`Timeout of ${this._timeout}ms expired.`));
                        }, this._timeout);
                    })
                ]);
                if (!response.ok) {
                    const text = yield response.text().catch(()=>'No Text');
                    const err = new Error(`NetworkError: ${populatedUrl} ${text}`);
                    err.name = 'NetworkError';
                    throw err;
                }
                const text = yield response.text();
                $605288f13d9b4857$var$_tryMarkInitEnd(args, response, currentAttempt, text);
                this._fallbackResolver.tryBumpExpiryTime(args.sdkKey, args.urlConfig);
                return {
                    body: text,
                    code: response.status
                };
            } catch (error) {
                const errorMessage = $605288f13d9b4857$var$_getErrorMessage(error);
                const timedOut = $605288f13d9b4857$var$_didTimeout(errorMessage !== null && errorMessage !== void 0 ? errorMessage : '', reqTimedOut);
                $605288f13d9b4857$var$_tryMarkInitEnd(args, response, currentAttempt, '', error);
                const fallbackUpdated = yield this._fallbackResolver.tryFetchUpdatedFallbackInfo(args.sdkKey, args.urlConfig, errorMessage, timedOut);
                if (fallbackUpdated) args.fallbackUrl = this._fallbackResolver.getActiveFallbackUrl(args.sdkKey, args.urlConfig);
                if (!retries || currentAttempt > retries || !module.exports.RETRYABLE_CODES.has((_b = response === null || response === void 0 ? void 0 : response.status) !== null && _b !== void 0 ? _b : 500)) {
                    (_c = this._emitter) === null || _c === void 0 || _c.call(this, {
                        name: 'error',
                        error: error,
                        tag: $kL3cd.ErrorTag.NetworkError,
                        requestArgs: args
                    });
                    const formattedErrorMsg = `A networking error occurred during ${method} request to ${populatedUrl}.`;
                    $3sfpc.Log.error(formattedErrorMsg, errorMessage, error);
                    (_d = this._errorBoundary) === null || _d === void 0 || _d.attachErrorIfNoneExists(formattedErrorMsg);
                    return null;
                }
                yield $605288f13d9b4857$var$_exponentialBackoff(currentAttempt);
                return this._sendRequest(Object.assign(Object.assign({}, args), {
                    retries: retries,
                    attempt: currentAttempt + 1
                }));
            }
        });
    }
    _getLogEventCompressionMode(options) {
        // Handle backward compatibility for deprecated disableCompression flag
        let compressionMode = options === null || options === void 0 ? void 0 : options.logEventCompressionMode;
        if (!compressionMode && (options === null || options === void 0 ? void 0 : options.disableCompression) === true) compressionMode = $eNn8G.LogEventCompressionMode.Disabled;
        // Default to enabled if unset
        if (!compressionMode) compressionMode = $eNn8G.LogEventCompressionMode.Enabled;
        return compressionMode;
    }
    _isRateLimited(endpoint) {
        var _a;
        const now = Date.now();
        const bucket = (_a = this._leakyBucket[endpoint]) !== null && _a !== void 0 ? _a : {
            count: 0,
            lastRequestTime: now
        };
        const elapsed = now - bucket.lastRequestTime;
        const leakedRequests = Math.floor(elapsed * $605288f13d9b4857$var$LEAK_RATE);
        bucket.count = Math.max(0, bucket.count - leakedRequests);
        if (bucket.count >= $605288f13d9b4857$var$RATE_LIMIT_MAX_REQ_COUNT) return true;
        bucket.count += 1;
        bucket.lastRequestTime = now;
        this._leakyBucket[endpoint] = bucket;
        return false;
    }
    _getPopulatedURL(args) {
        var _a;
        const url = (_a = args.fallbackUrl) !== null && _a !== void 0 ? _a : args.urlConfig.getUrl();
        if (args.urlConfig.endpoint === $3FPX1.Endpoint._initialize || args.urlConfig.endpoint === $3FPX1.Endpoint._download_config_specs) this._lastUsedInitUrl = url;
        const params = Object.assign({
            [$3FPX1.NetworkParam.SdkKey]: args.sdkKey,
            [$3FPX1.NetworkParam.SdkType]: $aiqjf.SDKType._get(args.sdkKey),
            [$3FPX1.NetworkParam.SdkVersion]: $5CBso.SDK_VERSION,
            [$3FPX1.NetworkParam.Time]: String(Date.now()),
            [$3FPX1.NetworkParam.SessionID]: $1pnfi.SessionID.get(args.sdkKey)
        }, args.params);
        const query = Object.keys(params).map((key)=>{
            return `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`;
        }).join('&');
        return `${url}${query ? `?${query}` : ''}`;
    }
    _tryEncodeBody(args) {
        var _a;
        const win = (0, $2a4Fo._getWindowSafe)();
        const body = args.body;
        if (!args.isStatsigEncodable || this._options.disableStatsigEncoding || typeof body !== 'string' || (0, $khZUo._getStatsigGlobalFlag)('no-encode') != null || !(win === null || win === void 0 ? void 0 : win.btoa)) return;
        try {
            args.body = win.btoa(body).split('').reverse().join('');
            args.params = Object.assign(Object.assign({}, (_a = args.params) !== null && _a !== void 0 ? _a : {}), {
                [$3FPX1.NetworkParam.StatsigEncoded]: '1'
            });
        } catch (e) {
            $3sfpc.Log.warn(`Request encoding failed for ${args.urlConfig.getUrl()}`, e);
        }
    }
    _tryToCompressBody(args) {
        return $605288f13d9b4857$var$__awaiter(this, void 0, void 0, function*() {
            var _a;
            const body = args.body;
            if (typeof body !== 'string' || !$605288f13d9b4857$var$_allowCompression(args, this._options)) return;
            try {
                const bytes = new TextEncoder().encode(body);
                const stream = new CompressionStream('gzip');
                const writer = stream.writable.getWriter();
                writer.write(bytes).catch($3sfpc.Log.error);
                writer.close().catch($3sfpc.Log.error);
                const reader = stream.readable.getReader();
                const chunks = [];
                let result;
                // eslint-disable-next-line no-await-in-loop
                while(!(result = yield reader.read()).done)chunks.push(result.value);
                const totalLength = chunks.reduce((acc, chunk)=>acc + chunk.length, 0);
                const combined = new Uint8Array(totalLength);
                let offset = 0;
                for (const chunk of chunks){
                    combined.set(chunk, offset);
                    offset += chunk.length;
                }
                args.body = combined;
                args.params = Object.assign(Object.assign({}, (_a = args.params) !== null && _a !== void 0 ? _a : {}), {
                    [$3FPX1.NetworkParam.IsGzipped]: '1'
                });
            } catch (e) {
                $3sfpc.Log.warn(`Request compression failed for ${args.urlConfig.getUrl()}`, e);
            }
        });
    }
    _getInternalRequestArgs(method, args) {
        const fallbackUrl = this._fallbackResolver.getActiveFallbackUrl(args.sdkKey, args.urlConfig);
        const result = Object.assign(Object.assign({}, args), {
            method: method,
            fallbackUrl: fallbackUrl
        });
        if ('data' in args) $605288f13d9b4857$var$_populateRequestBody(result, args.data);
        return result;
    }
}
module.exports.NetworkCore = $605288f13d9b4857$var$NetworkCore;
const $605288f13d9b4857$var$_ensureValidSdkKey = (args)=>{
    if (!args.sdkKey) {
        $3sfpc.Log.warn('Unable to make request without an SDK key');
        return false;
    }
    return true;
};
const $605288f13d9b4857$var$_populateRequestBody = (args, data)=>{
    const { sdkKey: sdkKey, fallbackUrl: fallbackUrl } = args;
    const stableID = $gxJjE.StableID.get(sdkKey);
    const sessionID = $1pnfi.SessionID.get(sdkKey);
    const sdkType = $aiqjf.SDKType._get(sdkKey);
    args.body = JSON.stringify(Object.assign(Object.assign({}, data), {
        statsigMetadata: Object.assign(Object.assign({}, $5CBso.StatsigMetadataProvider.get()), {
            stableID: stableID,
            sessionID: sessionID,
            sdkType: sdkType,
            fallbackUrl: fallbackUrl
        })
    }));
};
function $605288f13d9b4857$var$_allowCompression(args, options) {
    if (!args.isCompressable) return false;
    // Never compress if 'no-compress' is set globally or required APIs are unavailable
    if ((0, $khZUo._getStatsigGlobalFlag)('no-compress') != null || typeof CompressionStream === 'undefined' || typeof TextEncoder === 'undefined') return false;
    const isProxy = args.urlConfig.customUrl != null || args.urlConfig.fallbackUrls != null;
    const flagEnabled = $lGjbM.SDKFlags.get(args.sdkKey, 'enable_log_event_compression') === true;
    switch(options.logEventCompressionMode){
        case $eNn8G.LogEventCompressionMode.Disabled:
            return false;
        case $eNn8G.LogEventCompressionMode.Enabled:
            // Only compress through proxy if flag is explicitly on
            if (isProxy && !flagEnabled) return false;
            return true;
        case $eNn8G.LogEventCompressionMode.Forced:
            return true;
        default:
            return false;
    }
}
function $605288f13d9b4857$var$_getErrorMessage(error) {
    if (typeof error === 'string') return error;
    if (error instanceof Error) return `${error.name}: ${error.message}`;
    return 'Unknown Error';
}
function $605288f13d9b4857$var$_didTimeout(errorMsg, abortedByTimeout) {
    const timeout = errorMsg.includes('Timeout'); // probably not needed but just in case
    return timeout || abortedByTimeout;
}
function $605288f13d9b4857$var$_tryMarkInitStart(args, attempt) {
    if (args.urlConfig.endpoint !== $3FPX1.Endpoint._initialize) return;
    $6sWDY.Diagnostics._markInitNetworkReqStart(args.sdkKey, {
        attempt: attempt
    });
}
function $605288f13d9b4857$var$_tryMarkInitEnd(args, response, attempt, body, err) {
    if (args.urlConfig.endpoint !== $3FPX1.Endpoint._initialize) return;
    $6sWDY.Diagnostics._markInitNetworkReqEnd(args.sdkKey, $6sWDY.Diagnostics._getDiagnosticsData(response, attempt, body, err));
}
function $605288f13d9b4857$var$_exponentialBackoff(attempt) {
    return $605288f13d9b4857$var$__awaiter(this, void 0, void 0, function*() {
        // 1*1*1000 1s
        // 2*2*1000 4s
        // 3*3*1000 9s
        // 4*4*1000 16s
        // 5*5*1000 25s
        yield new Promise((r)=>setTimeout(r, Math.min($605288f13d9b4857$var$BACKOFF_BASE_MS * (attempt * attempt), $605288f13d9b4857$var$BACKOFF_MAX_MS)));
    });
}

});
parcelRegister("8MXmu", function(module, exports) {
"use strict";
var $6660da695f44840a$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._isDomainFailure = module.exports.NetworkFallbackResolver = void 0;

var $jKRcc = parcelRequire("jKRcc");

var $5Gp6R = parcelRequire("5Gp6R");

var $3sfpc = parcelRequire("3sfpc");

var $9YlaE = parcelRequire("9YlaE");
const $6660da695f44840a$var$DEFAULT_TTL_MS = 604800000; // 7 days
const $6660da695f44840a$var$COOLDOWN_TIME_MS = 14400000; // 4 hours
class $6660da695f44840a$var$NetworkFallbackResolver {
    constructor(options){
        var _a;
        this._fallbackInfo = null;
        this._errorBoundary = null;
        this._dnsQueryCooldowns = {};
        this._networkOverrideFunc = (_a = options.networkConfig) === null || _a === void 0 ? void 0 : _a.networkOverrideFunc;
    }
    setErrorBoundary(errorBoundary) {
        this._errorBoundary = errorBoundary;
    }
    tryBumpExpiryTime(sdkKey, urlConfig) {
        var _a;
        const info = (_a = this._fallbackInfo) === null || _a === void 0 ? void 0 : _a[urlConfig.endpoint];
        if (!info) return;
        info.expiryTime = Date.now() + $6660da695f44840a$var$DEFAULT_TTL_MS;
        $6660da695f44840a$var$_tryWriteFallbackInfoToCache(sdkKey, Object.assign(Object.assign({}, this._fallbackInfo), {
            [urlConfig.endpoint]: info
        }));
    }
    getActiveFallbackUrl(sdkKey, urlConfig) {
        var _a, _b;
        if (urlConfig.customUrl != null && urlConfig.fallbackUrls != null) return null;
        let info = this._fallbackInfo;
        if (info == null) {
            info = (_a = $6660da695f44840a$var$_readFallbackInfoFromCache(sdkKey)) !== null && _a !== void 0 ? _a : {};
            this._fallbackInfo = info;
        }
        const entry = info[urlConfig.endpoint];
        if (!entry || Date.now() > ((_b = entry.expiryTime) !== null && _b !== void 0 ? _b : 0) || urlConfig.getChecksum() !== entry.urlConfigChecksum) {
            delete info[urlConfig.endpoint];
            this._fallbackInfo = info;
            $6660da695f44840a$var$_tryWriteFallbackInfoToCache(sdkKey, this._fallbackInfo);
            return null;
        }
        if (entry.url) return entry.url;
        return null;
    }
    tryFetchUpdatedFallbackInfo(sdkKey, urlConfig, errorMessage, timedOut) {
        return $6660da695f44840a$var$__awaiter(this, void 0, void 0, function*() {
            var _a, _b;
            try {
                if (!$6660da695f44840a$var$_isDomainFailure(errorMessage, timedOut)) return false;
                const canUseNetworkFallbacks = urlConfig.customUrl == null && urlConfig.fallbackUrls == null;
                const urls = canUseNetworkFallbacks ? yield this._tryFetchFallbackUrlsFromNetwork(urlConfig) : urlConfig.fallbackUrls;
                const newUrl = this._pickNewFallbackUrl((_a = this._fallbackInfo) === null || _a === void 0 ? void 0 : _a[urlConfig.endpoint], urls);
                if (!newUrl) return false;
                this._updateFallbackInfoWithNewUrl(sdkKey, urlConfig, newUrl);
                return true;
            } catch (error) {
                (_b = this._errorBoundary) === null || _b === void 0 || _b.logError('tryFetchUpdatedFallbackInfo', error);
                return false;
            }
        });
    }
    _updateFallbackInfoWithNewUrl(sdkKey, urlConfig, newUrl) {
        var _a, _b, _c;
        const newFallbackInfo = {
            urlConfigChecksum: urlConfig.getChecksum(),
            url: newUrl,
            expiryTime: Date.now() + $6660da695f44840a$var$DEFAULT_TTL_MS,
            previous: []
        };
        const endpoint = urlConfig.endpoint;
        const previousInfo = (_a = this._fallbackInfo) === null || _a === void 0 ? void 0 : _a[endpoint];
        if (previousInfo) newFallbackInfo.previous.push(...previousInfo.previous);
        if (newFallbackInfo.previous.length > 10) newFallbackInfo.previous = [];
        const previousUrl = (_c = (_b = this._fallbackInfo) === null || _b === void 0 ? void 0 : _b[endpoint]) === null || _c === void 0 ? void 0 : _c.url;
        if (previousUrl != null) newFallbackInfo.previous.push(previousUrl);
        this._fallbackInfo = Object.assign(Object.assign({}, this._fallbackInfo), {
            [endpoint]: newFallbackInfo
        });
        $6660da695f44840a$var$_tryWriteFallbackInfoToCache(sdkKey, this._fallbackInfo);
    }
    _tryFetchFallbackUrlsFromNetwork(urlConfig) {
        return $6660da695f44840a$var$__awaiter(this, void 0, void 0, function*() {
            var _a;
            const cooldown = this._dnsQueryCooldowns[urlConfig.endpoint];
            if (cooldown && Date.now() < cooldown) return null;
            this._dnsQueryCooldowns[urlConfig.endpoint] = Date.now() + $6660da695f44840a$var$COOLDOWN_TIME_MS;
            const result = [];
            const records = yield (0, $jKRcc._fetchTxtRecords)((_a = this._networkOverrideFunc) !== null && _a !== void 0 ? _a : fetch);
            const path = $6660da695f44840a$var$_extractPathFromUrl(urlConfig.defaultUrl);
            for (const record of records){
                if (!record.startsWith(urlConfig.endpointDnsKey + '=')) continue;
                const parts = record.split('=');
                if (parts.length > 1) {
                    let baseUrl = parts[1];
                    if (baseUrl.endsWith('/')) baseUrl = baseUrl.slice(0, -1);
                    result.push(`https://${baseUrl}${path}`);
                }
            }
            return result;
        });
    }
    _pickNewFallbackUrl(currentFallbackInfo, urls) {
        var _a;
        if (urls == null) return null;
        const previouslyUsed = new Set((_a = currentFallbackInfo === null || currentFallbackInfo === void 0 ? void 0 : currentFallbackInfo.previous) !== null && _a !== void 0 ? _a : []);
        const currentFallbackUrl = currentFallbackInfo === null || currentFallbackInfo === void 0 ? void 0 : currentFallbackInfo.url;
        let found = null;
        for (const loopUrl of urls){
            const url = loopUrl.endsWith('/') ? loopUrl.slice(0, -1) : loopUrl;
            if (!previouslyUsed.has(loopUrl) && url !== currentFallbackUrl) {
                found = url;
                break;
            }
        }
        return found;
    }
}
module.exports.NetworkFallbackResolver = $6660da695f44840a$var$NetworkFallbackResolver;
function $6660da695f44840a$var$_isDomainFailure(errorMsg, timedOut) {
    var _a;
    const lowerErrorMsg = (_a = errorMsg === null || errorMsg === void 0 ? void 0 : errorMsg.toLowerCase()) !== null && _a !== void 0 ? _a : '';
    return timedOut || lowerErrorMsg.includes('uncaught exception') || lowerErrorMsg.includes('failed to fetch') || lowerErrorMsg.includes('networkerror when attempting to fetch resource');
}
module.exports._isDomainFailure = $6660da695f44840a$var$_isDomainFailure;
function $6660da695f44840a$var$_getFallbackInfoStorageKey(sdkKey) {
    return `statsig.network_fallback.${(0, $5Gp6R._DJB2)(sdkKey)}`;
}
function $6660da695f44840a$var$_tryWriteFallbackInfoToCache(sdkKey, info) {
    const hashKey = $6660da695f44840a$var$_getFallbackInfoStorageKey(sdkKey);
    if (!info || Object.keys(info).length === 0) {
        $9YlaE.Storage.removeItem(hashKey);
        return;
    }
    $9YlaE.Storage.setItem(hashKey, JSON.stringify(info));
}
function $6660da695f44840a$var$_readFallbackInfoFromCache(sdkKey) {
    const hashKey = $6660da695f44840a$var$_getFallbackInfoStorageKey(sdkKey);
    const data = $9YlaE.Storage.getItem(hashKey);
    if (!data) return null;
    try {
        return JSON.parse(data);
    } catch (_a) {
        $3sfpc.Log.error('Failed to parse FallbackInfo');
        return null;
    }
}
function $6660da695f44840a$var$_extractPathFromUrl(urlString) {
    try {
        const url = new URL(urlString);
        return url.pathname;
    } catch (error) {
        return null;
    }
}

});
parcelRegister("jKRcc", function(module, exports) {
"use strict";
var $e61b93c3a6b2e729$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._fetchTxtRecords = void 0;
// See example: https://github.com/statsig-io/private-js-client-monorepo/pull/340
const $e61b93c3a6b2e729$var$FEATURE_ASSETS_DNS_QUERY = new Uint8Array([
    0x00,
    0x00,
    0x01,
    0x00,
    0x00,
    0x01,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x0d,
    0x66,
    0x65,
    0x61,
    0x74,
    0x75,
    0x72,
    0x65,
    0x61,
    0x73,
    0x73,
    0x65,
    0x74,
    0x73,
    0x03,
    0x6f,
    0x72,
    0x67,
    0x00,
    0x00,
    0x10,
    0x00,
    0x01
]);
const $e61b93c3a6b2e729$var$DNS_QUERY_ENDPOINT = 'https://cloudflare-dns.com/dns-query';
const $e61b93c3a6b2e729$var$DOMAIN_CHARS = [
    'i',
    'e',
    'd'
];
const $e61b93c3a6b2e729$var$MAX_START_LOOKUP = 200;
function $e61b93c3a6b2e729$var$_fetchTxtRecords(networkFunc) {
    return $e61b93c3a6b2e729$var$__awaiter(this, void 0, void 0, function*() {
        const response = yield networkFunc($e61b93c3a6b2e729$var$DNS_QUERY_ENDPOINT, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/dns-message',
                Accept: 'application/dns-message'
            },
            body: $e61b93c3a6b2e729$var$FEATURE_ASSETS_DNS_QUERY
        });
        if (!response.ok) {
            const err = new Error('Failed to fetch TXT records from DNS');
            err.name = 'DnsTxtFetchError';
            throw err;
        }
        const data = yield response.arrayBuffer();
        const bytes = new Uint8Array(data);
        return $e61b93c3a6b2e729$var$_parseDnsResponse(bytes);
    });
}
module.exports._fetchTxtRecords = $e61b93c3a6b2e729$var$_fetchTxtRecords;
function $e61b93c3a6b2e729$var$_parseDnsResponse(input) {
    // loop until we find the first valid domain char. One of [i=, e=, d=]
    const start = input.findIndex((byte, index)=>index < $e61b93c3a6b2e729$var$MAX_START_LOOKUP && String.fromCharCode(byte) === '=' && $e61b93c3a6b2e729$var$DOMAIN_CHARS.includes(String.fromCharCode(input[index - 1])));
    if (start === -1) {
        const err = new Error('Failed to parse TXT records from DNS');
        err.name = 'DnsTxtParseError';
        throw err;
    }
    // decode the remaining bytes as a string
    let result = '';
    for(let i = start - 1; i < input.length; i++)result += String.fromCharCode(input[i]);
    return result.split(',');
}

});

parcelRegister("9YlaE", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._setObjectInStorage = module.exports._getObjectFromStorage = module.exports.Storage = void 0;

var $3sfpc = parcelRequire("3sfpc");

var $2a4Fo = parcelRequire("2a4Fo");
const $742a23c1973c92a7$var$inMemoryStore = {};
const $742a23c1973c92a7$var$_inMemoryProvider = {
    isReady: ()=>true,
    isReadyResolver: ()=>null,
    getProviderName: ()=>'InMemory',
    getItem: (key)=>$742a23c1973c92a7$var$inMemoryStore[key] ? $742a23c1973c92a7$var$inMemoryStore[key] : null,
    setItem: (key, value)=>{
        $742a23c1973c92a7$var$inMemoryStore[key] = value;
    },
    removeItem: (key)=>{
        delete $742a23c1973c92a7$var$inMemoryStore[key];
    },
    getAllKeys: ()=>Object.keys($742a23c1973c92a7$var$inMemoryStore)
};
let $742a23c1973c92a7$var$_localStorageProvider = null;
try {
    const win = (0, $2a4Fo._getWindowSafe)();
    if (win && win.localStorage && typeof win.localStorage.getItem === 'function') $742a23c1973c92a7$var$_localStorageProvider = {
        isReady: ()=>true,
        isReadyResolver: ()=>null,
        getProviderName: ()=>'LocalStorage',
        getItem: (key)=>win.localStorage.getItem(key),
        setItem: (key, value)=>win.localStorage.setItem(key, value),
        removeItem: (key)=>win.localStorage.removeItem(key),
        getAllKeys: ()=>Object.keys(win.localStorage)
    };
} catch (error) {
    $3sfpc.Log.warn('Failed to setup localStorageProvider.');
}
let $742a23c1973c92a7$var$_main = $742a23c1973c92a7$var$_localStorageProvider !== null && $742a23c1973c92a7$var$_localStorageProvider !== void 0 ? $742a23c1973c92a7$var$_localStorageProvider : $742a23c1973c92a7$var$_inMemoryProvider;
let $742a23c1973c92a7$var$_current = $742a23c1973c92a7$var$_main;
function $742a23c1973c92a7$var$_inMemoryBreaker(action) {
    try {
        return action();
    } catch (error) {
        if (error instanceof Error && error.name === 'SecurityError') {
            module.exports.Storage._setProvider($742a23c1973c92a7$var$_inMemoryProvider);
            return null;
        }
        throw error;
    }
}
module.exports.Storage = {
    isReady: ()=>$742a23c1973c92a7$var$_current.isReady(),
    isReadyResolver: ()=>$742a23c1973c92a7$var$_current.isReadyResolver(),
    getProviderName: ()=>$742a23c1973c92a7$var$_current.getProviderName(),
    getItem: (key)=>$742a23c1973c92a7$var$_inMemoryBreaker(()=>$742a23c1973c92a7$var$_current.getItem(key)),
    setItem: (key, value)=>$742a23c1973c92a7$var$_inMemoryBreaker(()=>$742a23c1973c92a7$var$_current.setItem(key, value)),
    removeItem: (key)=>$742a23c1973c92a7$var$_current.removeItem(key),
    getAllKeys: ()=>$742a23c1973c92a7$var$_current.getAllKeys(),
    // StorageProviderManagment
    _setProvider: (newProvider)=>{
        $742a23c1973c92a7$var$_main = newProvider;
        $742a23c1973c92a7$var$_current = newProvider;
    },
    _setDisabled: (isDisabled)=>{
        if (isDisabled) $742a23c1973c92a7$var$_current = $742a23c1973c92a7$var$_inMemoryProvider;
        else $742a23c1973c92a7$var$_current = $742a23c1973c92a7$var$_main;
    }
};
function $742a23c1973c92a7$var$_getObjectFromStorage(key) {
    const value = module.exports.Storage.getItem(key);
    try {
        return JSON.parse(value !== null && value !== void 0 ? value : 'null');
    } catch (e) {
        $3sfpc.Log.error(`Failed to parse value for key "${key}"`);
        return null;
    }
}
module.exports._getObjectFromStorage = $742a23c1973c92a7$var$_getObjectFromStorage;
function $742a23c1973c92a7$var$_setObjectInStorage(key, obj) {
    module.exports.Storage.setItem(key, JSON.stringify(obj));
}
module.exports._setObjectInStorage = $742a23c1973c92a7$var$_setObjectInStorage;

});


parcelRegister("lGjbM", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SDKFlags = void 0;
const $fc8c67c37cdb5950$var$FLAGMAP = {};
module.exports.SDKFlags = {
    setFlags: (sdkKey, flags)=>{
        $fc8c67c37cdb5950$var$FLAGMAP[sdkKey] = flags;
    },
    get: (sdkKey, flagKey)=>{
        var _a, _b;
        return (_b = (_a = $fc8c67c37cdb5950$var$FLAGMAP[sdkKey]) === null || _a === void 0 ? void 0 : _a[flagKey]) !== null && _b !== void 0 ? _b : false;
    }
};

});

parcelRegister("aiqjf", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SDKType = void 0;
const $77effe57de7849ba$var$SDK_CLIENT = {};
let $77effe57de7849ba$var$suffix;
module.exports.SDKType = {
    _get: (sdkKey)=>{
        var _a;
        return ((_a = $77effe57de7849ba$var$SDK_CLIENT[sdkKey]) !== null && _a !== void 0 ? _a : 'js-mono') + ($77effe57de7849ba$var$suffix !== null && $77effe57de7849ba$var$suffix !== void 0 ? $77effe57de7849ba$var$suffix : '');
    },
    _setClientType (sdkKey, client) {
        $77effe57de7849ba$var$SDK_CLIENT[sdkKey] = client;
    },
    _setBindingType (binding) {
        if (!$77effe57de7849ba$var$suffix || $77effe57de7849ba$var$suffix === '-react') $77effe57de7849ba$var$suffix = '-' + binding;
    }
};

});

parcelRegister("1pnfi", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.StatsigSession = module.exports.SessionID = void 0;

var $hxeyi = parcelRequire("hxeyi");

var $3sfpc = parcelRequire("3sfpc");

var $9YlaE = parcelRequire("9YlaE");

var $deTba = parcelRequire("deTba");

var $a4EWe = parcelRequire("a4EWe");
const $106a2858ecb814f5$var$MAX_SESSION_IDLE_TIME = 1800000; // 30 minutes
const $106a2858ecb814f5$var$MAX_SESSION_AGE = 14400000; // 4 hours
const $106a2858ecb814f5$var$PERSIST_THROTTLE_MS = 15000;
const $106a2858ecb814f5$var$SESSION_MAP = {};
(0, $a4EWe._subscribeToVisiblityChanged)((visibility)=>{
    if (visibility === 'background') Object.values($106a2858ecb814f5$var$SESSION_MAP).forEach((session)=>$106a2858ecb814f5$var$_persistNow(session));
});
module.exports.SessionID = {
    get: (sdkKey)=>{
        return module.exports.StatsigSession.get(sdkKey).data.sessionID;
    }
};
module.exports.StatsigSession = {
    get: (sdkKey, bumpSession = true)=>{
        if ($106a2858ecb814f5$var$SESSION_MAP[sdkKey] == null) $106a2858ecb814f5$var$SESSION_MAP[sdkKey] = $106a2858ecb814f5$var$_loadOrCreateSharedSession(sdkKey);
        const session = $106a2858ecb814f5$var$SESSION_MAP[sdkKey];
        return $106a2858ecb814f5$var$_maybeBumpSession(session, bumpSession);
    },
    overrideInitialSessionID: (override, sdkKey)=>{
        const now = Date.now();
        const session = {
            data: {
                sessionID: override,
                startTime: now,
                lastUpdate: now
            },
            sdkKey: sdkKey,
            lastPersistedAt: Date.now(),
            storageKey: $106a2858ecb814f5$var$_getSessionIDStorageKey(sdkKey)
        };
        $106a2858ecb814f5$var$_persistNow(session);
        $106a2858ecb814f5$var$SESSION_MAP[sdkKey] = session;
    },
    checkForIdleSession: (sdkKey)=>{
        const session = $106a2858ecb814f5$var$SESSION_MAP[sdkKey];
        if (!session) return;
        const sessionExpired = $106a2858ecb814f5$var$_checkForExpiredSession(session);
        if (sessionExpired) $106a2858ecb814f5$var$_persistNow(session);
    }
};
function $106a2858ecb814f5$var$_maybeBumpSession(session, allowSessionBump) {
    const now = Date.now();
    const sessionExpired = $106a2858ecb814f5$var$_checkForExpiredSession(session);
    if (sessionExpired) $106a2858ecb814f5$var$_persistNow(session);
    else if (allowSessionBump) {
        session.data.lastUpdate = now;
        $106a2858ecb814f5$var$_persistThrottled(session);
    }
    return session;
}
function $106a2858ecb814f5$var$_checkForExpiredSession(session) {
    var _a;
    const data = session.data;
    const sessionExpired = $106a2858ecb814f5$var$_isIdle(data) || $106a2858ecb814f5$var$_hasRunTooLong(data);
    if (sessionExpired) {
        session.data = $106a2858ecb814f5$var$_newSessionData();
        (_a = __STATSIG__ === null || __STATSIG__ === void 0 ? void 0 : __STATSIG__.instance(session.sdkKey)) === null || _a === void 0 || _a.$emt({
            name: 'session_expired'
        });
    }
    return sessionExpired;
}
function $106a2858ecb814f5$var$_isIdle({ lastUpdate: lastUpdate }) {
    return Date.now() - lastUpdate > $106a2858ecb814f5$var$MAX_SESSION_IDLE_TIME;
}
function $106a2858ecb814f5$var$_hasRunTooLong({ startTime: startTime }) {
    return Date.now() - startTime > $106a2858ecb814f5$var$MAX_SESSION_AGE;
}
function $106a2858ecb814f5$var$_getSessionIDStorageKey(sdkKey) {
    return `statsig.session_id.${(0, $hxeyi._getStorageKey)(sdkKey)}`;
}
function $106a2858ecb814f5$var$_persistNow(session) {
    try {
        (0, $9YlaE._setObjectInStorage)(session.storageKey, session.data);
        session.lastPersistedAt = Date.now();
    } catch (e) {
        $3sfpc.Log.warn('Failed to save SessionID');
    }
}
function $106a2858ecb814f5$var$_persistThrottled(session) {
    const now = Date.now();
    if (now - session.lastPersistedAt > $106a2858ecb814f5$var$PERSIST_THROTTLE_MS) $106a2858ecb814f5$var$_persistNow(session);
}
function $106a2858ecb814f5$var$_loadSessionFromStorage(storageKey) {
    const data = (0, $9YlaE._getObjectFromStorage)(storageKey);
    return data;
}
function $106a2858ecb814f5$var$_loadOrCreateSharedSession(sdkKey) {
    const storageKey = $106a2858ecb814f5$var$_getSessionIDStorageKey(sdkKey);
    const existing = $106a2858ecb814f5$var$_loadSessionFromStorage(storageKey);
    if (existing && existing.sessionID && existing.startTime && existing.lastUpdate) return {
        data: existing,
        sdkKey: sdkKey,
        lastPersistedAt: 0,
        storageKey: storageKey
    };
    return {
        data: $106a2858ecb814f5$var$_newSessionData(),
        sdkKey: sdkKey,
        lastPersistedAt: 0,
        storageKey: storageKey
    };
}
function $106a2858ecb814f5$var$_newSessionData() {
    return {
        sessionID: (0, $deTba.getUUID)(),
        startTime: Date.now(),
        lastUpdate: Date.now()
    };
}

});
parcelRegister("deTba", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getUUID = void 0;
function $9a376294eec4924d$var$getUUID() {
    if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') return crypto.randomUUID();
    let d = new Date().getTime();
    let d2 = typeof performance !== 'undefined' && performance.now && performance.now() * 1000 || 0;
    const y = '89ab'[Math.floor(Math.random() * 4)];
    return `xxxxxxxx-xxxx-4xxx-${y}xxx-xxxxxxxxxxxx`.replace(/[xy]/g, (c)=>{
        let r = Math.random() * 16;
        if (d > 0) {
            r = (d + r) % 16 | 0;
            d = Math.floor(d / 16);
        } else {
            r = (d2 + r) % 16 | 0;
            d2 = Math.floor(d2 / 16);
        }
        return (c === 'x' ? r : r & 0x7 | 0x8).toString(16);
    });
}
module.exports.getUUID = $9a376294eec4924d$var$getUUID;

});


parcelRegister("gxJjE", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getCookieName = module.exports.StableID = void 0;

var $hxeyi = parcelRequire("hxeyi");

var $3sfpc = parcelRequire("3sfpc");

var $2a4Fo = parcelRequire("2a4Fo");

var $9YlaE = parcelRequire("9YlaE");

var $deTba = parcelRequire("deTba");
const $c0b2e13326c72eea$var$PROMISE_MAP = {};
const $c0b2e13326c72eea$var$COOKIE_ENABLED_MAP = {};
const $c0b2e13326c72eea$var$DISABLED_MAP = {};
module.exports.StableID = {
    cookiesEnabled: false,
    randomID: Math.random().toString(36),
    get: (sdkKey)=>{
        if ($c0b2e13326c72eea$var$DISABLED_MAP[sdkKey]) return null;
        if ($c0b2e13326c72eea$var$PROMISE_MAP[sdkKey] != null) return $c0b2e13326c72eea$var$PROMISE_MAP[sdkKey];
        let stableID = null;
        stableID = $c0b2e13326c72eea$var$_loadFromCookie(sdkKey);
        if (stableID != null) {
            $c0b2e13326c72eea$var$PROMISE_MAP[sdkKey] = stableID;
            $c0b2e13326c72eea$var$_persistToStorage(stableID, sdkKey);
            return stableID;
        }
        stableID = $c0b2e13326c72eea$var$_loadFromStorage(sdkKey);
        if (stableID == null) stableID = (0, $deTba.getUUID)();
        $c0b2e13326c72eea$var$_persistToStorage(stableID, sdkKey);
        $c0b2e13326c72eea$var$_persistToCookie(stableID, sdkKey);
        $c0b2e13326c72eea$var$PROMISE_MAP[sdkKey] = stableID;
        return stableID;
    },
    setOverride: (override, sdkKey)=>{
        $c0b2e13326c72eea$var$PROMISE_MAP[sdkKey] = override;
        $c0b2e13326c72eea$var$_persistToStorage(override, sdkKey);
        $c0b2e13326c72eea$var$_persistToCookie(override, sdkKey);
    },
    _setCookiesEnabled: (sdkKey, cookiesEnabled)=>{
        $c0b2e13326c72eea$var$COOKIE_ENABLED_MAP[sdkKey] = cookiesEnabled;
    },
    _setDisabled: (sdkKey, disabled)=>{
        $c0b2e13326c72eea$var$DISABLED_MAP[sdkKey] = disabled;
    }
};
function $c0b2e13326c72eea$var$_getStableIDStorageKey(sdkKey) {
    return `statsig.stable_id.${(0, $hxeyi._getStorageKey)(sdkKey)}`;
}
function $c0b2e13326c72eea$var$_persistToStorage(stableID, sdkKey) {
    const storageKey = $c0b2e13326c72eea$var$_getStableIDStorageKey(sdkKey);
    try {
        (0, $9YlaE._setObjectInStorage)(storageKey, stableID);
    } catch (e) {
        $3sfpc.Log.warn('Failed to save StableID to storage');
    }
}
function $c0b2e13326c72eea$var$_loadFromStorage(sdkKey) {
    const storageKey = $c0b2e13326c72eea$var$_getStableIDStorageKey(sdkKey);
    return (0, $9YlaE._getObjectFromStorage)(storageKey);
}
function $c0b2e13326c72eea$var$_loadFromCookie(sdkKey) {
    if (!$c0b2e13326c72eea$var$COOKIE_ENABLED_MAP[sdkKey] || (0, $2a4Fo._getDocumentSafe)() == null) return null;
    const cookies = document.cookie.split(';');
    for (const cookie of cookies){
        const [key, value] = cookie.trim().split('=');
        if (key === $c0b2e13326c72eea$var$getCookieName(sdkKey)) return decodeURIComponent(value);
    }
    return null;
}
function $c0b2e13326c72eea$var$_persistToCookie(stableID, sdkKey) {
    if (!$c0b2e13326c72eea$var$COOKIE_ENABLED_MAP[sdkKey] || (0, $2a4Fo._getDocumentSafe)() == null) return;
    const expiryDate = new Date();
    expiryDate.setFullYear(expiryDate.getFullYear() + 1);
    document.cookie = `${$c0b2e13326c72eea$var$getCookieName(sdkKey)}=${encodeURIComponent(stableID)}; expires=${expiryDate.toUTCString()}; path=/`;
}
function $c0b2e13326c72eea$var$getCookieName(sdkKey) {
    return `statsig.stable_id.${(0, $hxeyi._getStorageKey)(sdkKey)}`;
}
module.exports.getCookieName = $c0b2e13326c72eea$var$getCookieName;

});

parcelRegister("kL3cd", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ErrorTag = void 0;
module.exports.ErrorTag = {
    NetworkError: 'NetworkError'
};

});

parcelRegister("5CBso", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.StatsigMetadataProvider = module.exports.SDK_VERSION = void 0;
module.exports.SDK_VERSION = '3.32.0';
let $417d8e821e74e6c9$var$metadata = {
    sdkVersion: module.exports.SDK_VERSION,
    sdkType: 'js-mono'
};
module.exports.StatsigMetadataProvider = {
    get: ()=>$417d8e821e74e6c9$var$metadata,
    add: (additions)=>{
        $417d8e821e74e6c9$var$metadata = Object.assign(Object.assign({}, $417d8e821e74e6c9$var$metadata), additions);
    }
};

});

parcelRegister("eNn8G", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LoggingEnabledOption = module.exports.LogEventCompressionMode = void 0;
module.exports.LogEventCompressionMode = {
    /** Do not compress request bodies */ Disabled: 'd',
    /** Compress request bodies unless a network proxy is configured */ Enabled: 'e',
    /** Always compress request bodies, even when a proxy is configured */ Forced: 'f'
};
module.exports.LoggingEnabledOption = {
    disabled: 'disabled',
    browserOnly: 'browser-only',
    always: 'always'
};

});



parcelRegister("eBdEN", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PendingEvents = void 0;

var $3sfpc = parcelRequire("3sfpc");
class $aa0f1d63a6f2a571$var$PendingEvents {
    constructor(batchSize){
        this._pendingEvents = [];
        this._batchSize = batchSize;
    }
    addToPendingEventsQueue(event) {
        this._pendingEvents.push(event);
        $3sfpc.Log.debug('Enqueued Event:', event);
    }
    hasEventsForFullBatch() {
        return this._pendingEvents.length >= this._batchSize;
    }
    takeAll() {
        const events = this._pendingEvents;
        this._pendingEvents = [];
        return events;
    }
    isEmpty() {
        return this._pendingEvents.length === 0;
    }
}
module.exports.PendingEvents = $aa0f1d63a6f2a571$var$PendingEvents;

});

parcelRegister("ewIze", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._createLayerParameterExposure = module.exports._createConfigExposure = module.exports._mapExposures = module.exports._createGateExposure = module.exports._isExposureEvent = void 0;
const $a9369ff6a8758f74$var$CONFIG_EXPOSURE_NAME = 'statsig::config_exposure';
const $a9369ff6a8758f74$var$GATE_EXPOSURE_NAME = 'statsig::gate_exposure';
const $a9369ff6a8758f74$var$LAYER_EXPOSURE_NAME = 'statsig::layer_exposure';
const $a9369ff6a8758f74$var$_createExposure = (eventName, user, details, metadata, secondaryExposures)=>{
    if (details.bootstrapMetadata) metadata['bootstrapMetadata'] = details.bootstrapMetadata;
    return {
        eventName: eventName,
        user: user,
        value: null,
        metadata: $a9369ff6a8758f74$var$_addEvaluationDetailsToMetadata(details, metadata),
        secondaryExposures: secondaryExposures,
        time: Date.now()
    };
};
const $a9369ff6a8758f74$var$_isExposureEvent = ({ eventName: eventName })=>{
    return eventName === $a9369ff6a8758f74$var$GATE_EXPOSURE_NAME || eventName === $a9369ff6a8758f74$var$CONFIG_EXPOSURE_NAME || eventName === $a9369ff6a8758f74$var$LAYER_EXPOSURE_NAME;
};
module.exports._isExposureEvent = $a9369ff6a8758f74$var$_isExposureEvent;
const $a9369ff6a8758f74$var$_createGateExposure = (user, gate, exposureMapping)=>{
    var _a, _b, _c;
    const metadata = {
        gate: gate.name,
        gateValue: String(gate.value),
        ruleID: gate.ruleID
    };
    if (((_a = gate.__evaluation) === null || _a === void 0 ? void 0 : _a.version) != null) metadata['configVersion'] = gate.__evaluation.version;
    return $a9369ff6a8758f74$var$_createExposure($a9369ff6a8758f74$var$GATE_EXPOSURE_NAME, user, gate.details, metadata, $a9369ff6a8758f74$var$_mapExposures((_c = (_b = gate.__evaluation) === null || _b === void 0 ? void 0 : _b.secondary_exposures) !== null && _c !== void 0 ? _c : [], exposureMapping));
};
module.exports._createGateExposure = $a9369ff6a8758f74$var$_createGateExposure;
function $a9369ff6a8758f74$var$_mapExposures(exposures, exposureMapping) {
    return exposures.map((exposure)=>{
        if (typeof exposure === 'string') return (exposureMapping !== null && exposureMapping !== void 0 ? exposureMapping : {})[exposure];
        return exposure;
    }).filter((exposure)=>exposure != null);
}
module.exports._mapExposures = $a9369ff6a8758f74$var$_mapExposures;
const $a9369ff6a8758f74$var$_createConfigExposure = (user, config, exposureMapping)=>{
    var _a, _b, _c, _d;
    const metadata = {
        config: config.name,
        ruleID: config.ruleID
    };
    if (((_a = config.__evaluation) === null || _a === void 0 ? void 0 : _a.version) != null) metadata['configVersion'] = config.__evaluation.version;
    if (((_b = config.__evaluation) === null || _b === void 0 ? void 0 : _b.passed) != null) metadata['rulePassed'] = String(config.__evaluation.passed);
    return $a9369ff6a8758f74$var$_createExposure($a9369ff6a8758f74$var$CONFIG_EXPOSURE_NAME, user, config.details, metadata, $a9369ff6a8758f74$var$_mapExposures((_d = (_c = config.__evaluation) === null || _c === void 0 ? void 0 : _c.secondary_exposures) !== null && _d !== void 0 ? _d : [], exposureMapping));
};
module.exports._createConfigExposure = $a9369ff6a8758f74$var$_createConfigExposure;
const $a9369ff6a8758f74$var$_createLayerParameterExposure = (user, layer, parameterName, exposureMapping)=>{
    var _a, _b, _c, _d, _e, _f, _g;
    const evaluation = layer.__evaluation;
    const isExplicit = ((_a = evaluation === null || evaluation === void 0 ? void 0 : evaluation.explicit_parameters) === null || _a === void 0 ? void 0 : _a.includes(parameterName)) === true;
    let allocatedExperiment = '';
    let secondaryExposures = (_b = evaluation === null || evaluation === void 0 ? void 0 : evaluation.undelegated_secondary_exposures) !== null && _b !== void 0 ? _b : [];
    if (isExplicit) {
        allocatedExperiment = (_c = evaluation.allocated_experiment_name) !== null && _c !== void 0 ? _c : '';
        secondaryExposures = (_d = evaluation.secondary_exposures) !== null && _d !== void 0 ? _d : [];
    }
    const parameterRuleIDs = (_e = layer.__evaluation) === null || _e === void 0 ? void 0 : _e.parameter_rule_ids;
    const metadata = {
        config: layer.name,
        parameterName: parameterName,
        ruleID: (_f = parameterRuleIDs === null || parameterRuleIDs === void 0 ? void 0 : parameterRuleIDs[parameterName]) !== null && _f !== void 0 ? _f : layer.ruleID,
        allocatedExperiment: allocatedExperiment,
        isExplicitParameter: String(isExplicit)
    };
    if (((_g = layer.__evaluation) === null || _g === void 0 ? void 0 : _g.version) != null) metadata['configVersion'] = layer.__evaluation.version;
    return $a9369ff6a8758f74$var$_createExposure($a9369ff6a8758f74$var$LAYER_EXPOSURE_NAME, user, layer.details, metadata, $a9369ff6a8758f74$var$_mapExposures(secondaryExposures, exposureMapping));
};
module.exports._createLayerParameterExposure = $a9369ff6a8758f74$var$_createLayerParameterExposure;
const $a9369ff6a8758f74$var$_addEvaluationDetailsToMetadata = (details, metadata)=>{
    metadata['reason'] = details.reason;
    if (details.lcut) metadata['lcut'] = String(details.lcut);
    if (details.receivedAt) metadata['receivedAt'] = String(details.receivedAt);
    return metadata;
};

});

parcelRegister("6dvVR", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.UrlConfiguration = void 0;

var $5Gp6R = parcelRequire("5Gp6R");

var $3FPX1 = parcelRequire("3FPX1");
const $486cba13af17e12a$var$ENDPOINT_DNS_KEY_MAP = {
    [$3FPX1.Endpoint._initialize]: 'i',
    [$3FPX1.Endpoint._rgstr]: 'e',
    [$3FPX1.Endpoint._download_config_specs]: 'd'
};
class $486cba13af17e12a$var$UrlConfiguration {
    constructor(endpoint, customUrl, customApi, fallbackUrls){
        this.customUrl = null;
        this.fallbackUrls = null;
        this.endpoint = endpoint;
        this.endpointDnsKey = $486cba13af17e12a$var$ENDPOINT_DNS_KEY_MAP[endpoint];
        if (customUrl) this.customUrl = customUrl;
        if (!customUrl && customApi) this.customUrl = customApi.endsWith('/') ? `${customApi}${endpoint}` : `${customApi}/${endpoint}`;
        if (fallbackUrls) this.fallbackUrls = fallbackUrls;
        const defaultApi = $3FPX1.NetworkDefault[endpoint];
        this.defaultUrl = `${defaultApi}/${endpoint}`;
    }
    getUrl() {
        var _a;
        return (_a = this.customUrl) !== null && _a !== void 0 ? _a : this.defaultUrl;
    }
    getChecksum() {
        var _a;
        const fallbacks = ((_a = this.fallbackUrls) !== null && _a !== void 0 ? _a : []).sort().join(',');
        return (0, $5Gp6R._DJB2)(this.customUrl + fallbacks);
    }
}
module.exports.UrlConfiguration = $486cba13af17e12a$var$UrlConfiguration;

});


parcelRegister("fPsv4", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PrecomputedEvaluationsContextHandle = void 0;

var $3sfpc = parcelRequire("3sfpc");

var $2a4Fo = parcelRequire("2a4Fo");

var $1pnfi = parcelRequire("1pnfi");

var $gxJjE = parcelRequire("gxJjE");
/**
 * A handle to the PrecomputedEvaluationsContext that computes fields lazily on access.
 * This avoids unnecessary computation (e.g., cloning the user) when only certain fields are needed.
 * The handle is created once and reused; individual getters fetch current values on each access.
 */ class $b861b9fd2db56594$var$PrecomputedEvaluationsContextHandle {
    constructor(sdkKey, getOptions, getErrorBoundary, getValues, getUser, getSdkInstanceID){
        this._sdkKey = sdkKey;
        this._getOptions = getOptions;
        this._getErrorBoundary = getErrorBoundary;
        this._getValues = getValues;
        this._getUser = getUser;
        this._getSdkInstanceID = getSdkInstanceID;
    }
    get sdkKey() {
        return this._sdkKey;
    }
    get options() {
        return this._getOptions();
    }
    get errorBoundary() {
        return this._getErrorBoundary();
    }
    get values() {
        return this._getValues();
    }
    get user() {
        let user = (0, $2a4Fo._cloneObject)('StatsigUser', this._getUser());
        if (user == null) {
            $3sfpc.Log.error('Failed to clone user');
            user = {};
        }
        return user;
    }
    /**
     * Gets the current session.
     * @param {boolean} [bumpSession=true] - Whether to bump/update the session timing. Set to false to read without affecting session state.
     */ getSession(bumpSession = true) {
        return $1pnfi.StatsigSession.get(this._sdkKey, bumpSession);
    }
    get stableID() {
        return $gxJjE.StableID.get(this._sdkKey);
    }
    get sdkInstanceID() {
        return this._getSdkInstanceID();
    }
    /**
     * Returns the full PrecomputedEvaluationsContext object.
     * Use this when you need all fields at once.
     * @param {boolean} [bumpSession=true] - Whether to bump the session when building the context.
     */ toContext(bumpSession = true) {
        return {
            sdkKey: this.sdkKey,
            options: this.options,
            values: this.values,
            user: this.user,
            errorBoundary: this.errorBoundary,
            session: this.getSession(bumpSession),
            stableID: this.stableID,
            sdkInstanceID: this.sdkInstanceID
        };
    }
}
module.exports.PrecomputedEvaluationsContextHandle = $b861b9fd2db56594$var$PrecomputedEvaluationsContextHandle;

});

parcelRegister("hcdaR", function(module, exports) {
"use strict";
var $c84dc6c463f65040$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._makeDataAdapterResult = module.exports.DataAdapterCore = void 0;

var $3sfpc = parcelRequire("3sfpc");

var $gxJjE = parcelRequire("gxJjE");

var $b8WOj = parcelRequire("b8WOj");

var $9YlaE = parcelRequire("9YlaE");

var $gCESp = parcelRequire("gCESp");
const $c84dc6c463f65040$var$CACHE_LIMIT = 10;
const $c84dc6c463f65040$var$MAX_CACHE_WRITE_ATTEMPTS = 8;
class $c84dc6c463f65040$var$DataAdapterCore {
    constructor(_adapterName, _cacheSuffix){
        this._adapterName = _adapterName;
        this._cacheSuffix = _cacheSuffix;
        this._options = null;
        this._sdkKey = null;
        this._cacheLimit = $c84dc6c463f65040$var$CACHE_LIMIT;
        this._lastModifiedStoreKey = `statsig.last_modified_time.${_cacheSuffix}`;
        this._inMemoryCache = new $c84dc6c463f65040$var$InMemoryCache();
    }
    attach(sdkKey, options, _network) {
        this._sdkKey = sdkKey;
        this._options = options;
    }
    getDataSync(user) {
        const normalized = user && (0, $b8WOj._normalizeUser)(user, this._options);
        const cacheKey = this._getCacheKey(normalized);
        const inMem = this._inMemoryCache.get(cacheKey, normalized);
        if (inMem && this._getIsCacheValueValid(inMem)) return inMem;
        const cache = this._loadFromCache(cacheKey);
        if (cache && this._getIsCacheValueValid(cache)) {
            this._inMemoryCache.add(cacheKey, cache, this._cacheLimit);
            return this._inMemoryCache.get(cacheKey, normalized);
        }
        return null;
    }
    setData(data, user) {
        const normalized = user && (0, $b8WOj._normalizeUser)(user, this._options);
        const cacheKey = this._getCacheKey(normalized);
        this._inMemoryCache.add(cacheKey, $c84dc6c463f65040$var$_makeDataAdapterResult('Bootstrap', data, null, normalized), this._cacheLimit);
    }
    _getIsCacheValueValid(current) {
        return current.stableID == null || current.stableID === $gxJjE.StableID.get(this._getSdkKey());
    }
    _getDataAsyncImpl(current, user, options) {
        return $c84dc6c463f65040$var$__awaiter(this, void 0, void 0, function*() {
            if (!$9YlaE.Storage.isReady()) yield $9YlaE.Storage.isReadyResolver();
            const cache = current !== null && current !== void 0 ? current : this.getDataSync(user);
            const ops = [
                this._fetchAndPrepFromNetwork(cache, user, options)
            ];
            if (options === null || options === void 0 ? void 0 : options.timeoutMs) ops.push(new Promise((r)=>setTimeout(r, options.timeoutMs)).then(()=>{
                $3sfpc.Log.debug('Fetching latest value timed out');
                return null;
            }));
            return yield Promise.race(ops);
        });
    }
    _prefetchDataImpl(user, options) {
        return $c84dc6c463f65040$var$__awaiter(this, void 0, void 0, function*() {
            const normalized = user && (0, $b8WOj._normalizeUser)(user, this._options);
            const cacheKey = this._getCacheKey(normalized);
            const result = yield this._getDataAsyncImpl(null, normalized, options);
            if (result) this._inMemoryCache.add(cacheKey, Object.assign(Object.assign({}, result), {
                source: 'Prefetch'
            }), this._cacheLimit);
        });
    }
    _fetchAndPrepFromNetwork(cachedResult, user, options) {
        return $c84dc6c463f65040$var$__awaiter(this, void 0, void 0, function*() {
            var _a;
            const cachedData = (_a = cachedResult === null || cachedResult === void 0 ? void 0 : cachedResult.data) !== null && _a !== void 0 ? _a : null;
            const isCacheValidFor204 = cachedResult != null && this._isCachedResultValidFor204(cachedResult, user);
            const latest = yield this._fetchFromNetwork(cachedData, user, options, isCacheValidFor204);
            if (!latest) {
                $3sfpc.Log.debug('No response returned for latest value');
                return null;
            }
            const response = (0, $gCESp._typedJsonParse)(latest, 'has_updates', 'Response');
            const sdkKey = this._getSdkKey();
            const stableID = $gxJjE.StableID.get(sdkKey);
            let result = null;
            if ((response === null || response === void 0 ? void 0 : response.has_updates) === true) result = $c84dc6c463f65040$var$_makeDataAdapterResult('Network', latest, stableID, user);
            else if (cachedData && (response === null || response === void 0 ? void 0 : response.has_updates) === false) result = $c84dc6c463f65040$var$_makeDataAdapterResult('NetworkNotModified', cachedData, stableID, user);
            else return null;
            const cacheKey = this._getCacheKey(user);
            this._inMemoryCache.add(cacheKey, result, this._cacheLimit);
            this._writeToCache(cacheKey, result);
            return result;
        });
    }
    _getSdkKey() {
        if (this._sdkKey != null) return this._sdkKey;
        $3sfpc.Log.error(`${this._adapterName} is not attached to a Client`);
        return '';
    }
    _loadFromCache(cacheKey) {
        var _a;
        const cache = (_a = $9YlaE.Storage.getItem) === null || _a === void 0 ? void 0 : _a.call($9YlaE.Storage, cacheKey);
        if (cache == null) return null;
        const result = (0, $gCESp._typedJsonParse)(cache, 'source', 'Cached Result');
        return result ? Object.assign(Object.assign({}, result), {
            source: 'Cache'
        }) : null;
    }
    _writeToCache(cacheKey, result) {
        const resultString = JSON.stringify(result);
        for(let i = 0; i < $c84dc6c463f65040$var$MAX_CACHE_WRITE_ATTEMPTS; i++)try {
            $9YlaE.Storage.setItem(cacheKey, resultString);
            break;
        } catch (error) {
            if (!(error instanceof Error) || !(error.toString().includes('QuotaExceededError') || error.toString().includes('QUOTA_EXCEEDED_ERR')) || this._cacheLimit <= 1) throw error;
            this._cacheLimit = Math.ceil(this._cacheLimit / 2);
            this._runLocalStorageCacheEviction(cacheKey, this._cacheLimit - 1);
        }
        this._runLocalStorageCacheEviction(cacheKey);
    }
    _runLocalStorageCacheEviction(cacheKey, cacheLimit = this._cacheLimit) {
        var _a;
        const lastModifiedTimeMap = (_a = (0, $9YlaE._getObjectFromStorage)(this._lastModifiedStoreKey)) !== null && _a !== void 0 ? _a : {};
        lastModifiedTimeMap[cacheKey] = Date.now();
        const evictableKeys = $c84dc6c463f65040$var$_getEvictableKeys(lastModifiedTimeMap, cacheLimit);
        for (const evictable of evictableKeys){
            delete lastModifiedTimeMap[evictable];
            $9YlaE.Storage.removeItem(evictable);
        }
        (0, $9YlaE._setObjectInStorage)(this._lastModifiedStoreKey, lastModifiedTimeMap);
    }
}
module.exports.DataAdapterCore = $c84dc6c463f65040$var$DataAdapterCore;
function $c84dc6c463f65040$var$_makeDataAdapterResult(source, data, stableID, user) {
    return {
        source: source,
        data: data,
        receivedAt: Date.now(),
        stableID: stableID,
        fullUserHash: (0, $b8WOj._getFullUserHash)(user)
    };
}
module.exports._makeDataAdapterResult = $c84dc6c463f65040$var$_makeDataAdapterResult;
class $c84dc6c463f65040$var$InMemoryCache {
    constructor(){
        this._data = {};
    }
    get(cacheKey, user) {
        var _a;
        const result = this._data[cacheKey];
        const cached = result === null || result === void 0 ? void 0 : result.stableID;
        const provided = (_a = user === null || user === void 0 ? void 0 : user.customIDs) === null || _a === void 0 ? void 0 : _a.stableID;
        if (provided && cached && provided !== cached) {
            $3sfpc.Log.warn("'StatsigUser.customIDs.stableID' mismatch");
            return null;
        }
        return result;
    }
    add(cacheKey, value, cacheLimit) {
        const evictableKeys = $c84dc6c463f65040$var$_getEvictableKeys(this._data, cacheLimit - 1);
        for (const evictable of evictableKeys)delete this._data[evictable];
        this._data[cacheKey] = value;
    }
    merge(values) {
        this._data = Object.assign(Object.assign({}, this._data), values);
    }
}
function $c84dc6c463f65040$var$_getEvictableKeys(data, limit) {
    const keys = Object.keys(data);
    if (keys.length <= limit) return [];
    if (limit === 0) return keys;
    return keys.sort((keyA, keyB)=>{
        const valueA = data[keyA];
        const valueB = data[keyB];
        if (typeof valueA === 'object' && typeof valueB === 'object') return valueA.receivedAt - valueB.receivedAt;
        return valueA - valueB;
    }).slice(0, keys.length - limit);
}

});
parcelRegister("b8WOj", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._getUnitIDFromUser = module.exports._getFullUserHash = module.exports._normalizeUser = void 0;

var $5Gp6R = parcelRequire("5Gp6R");

var $3sfpc = parcelRequire("3sfpc");

var $2a4Fo = parcelRequire("2a4Fo");
function $81ce0fa0499fcae7$var$_normalizeUser(original, options, fallbackEnvironment) {
    const copy = (0, $2a4Fo._cloneObject)('StatsigUser', original);
    if (copy == null) {
        $3sfpc.Log.error('Failed to clone user');
        return {
            statsigEnvironment: undefined
        };
    }
    if (options != null && options.environment != null) copy.statsigEnvironment = options.environment;
    else if (fallbackEnvironment != null) copy.statsigEnvironment = {
        tier: fallbackEnvironment
    };
    return copy;
}
module.exports._normalizeUser = $81ce0fa0499fcae7$var$_normalizeUser;
function $81ce0fa0499fcae7$var$_getFullUserHash(user) {
    return user ? (0, $5Gp6R._DJB2Object)(user) : null;
}
module.exports._getFullUserHash = $81ce0fa0499fcae7$var$_getFullUserHash;
function $81ce0fa0499fcae7$var$_getUnitIDFromUser(user, idType) {
    var _a, _b, _c;
    if (typeof idType !== 'string') return user.userID;
    const lowered = idType.toLowerCase();
    if (lowered !== 'userid') return (_b = (_a = user.customIDs) === null || _a === void 0 ? void 0 : _a[idType]) !== null && _b !== void 0 ? _b : (_c = user.customIDs) === null || _c === void 0 ? void 0 : _c[lowered];
    return user.userID;
}
module.exports._getUnitIDFromUser = $81ce0fa0499fcae7$var$_getUnitIDFromUser;

});

parcelRegister("gCESp", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._typedJsonParse = void 0;

var $3sfpc = parcelRequire("3sfpc");
/**
 *
 * @param {string} data The values to parse into T
 * @param {string} guard A field that must exists on the parsed object for the parse to be valid
 * @param {string} error An error to print via Log.error() when parsing fails
 * @returns {T | null} The parse object T or null if it failed
 */ function $c19fe72ea26e67c3$var$_typedJsonParse(data, guard, typeName) {
    try {
        const result = JSON.parse(data);
        if (result && typeof result === 'object' && guard in result) return result;
    } catch (_a) {
    // noop
    }
    $3sfpc.Log.error(`Failed to parse ${typeName}`);
    return null;
}
module.exports._typedJsonParse = $c19fe72ea26e67c3$var$_typedJsonParse;

});


parcelRegister("cl1O2", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("39jNY", function(module, exports) {
"use strict";
var $24b19336c2ac1113$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ErrorBoundary = module.exports.EXCEPTION_ENDPOINT = void 0;

var $3sfpc = parcelRequire("3sfpc");

var $aiqjf = parcelRequire("aiqjf");

var $5CBso = parcelRequire("5CBso");
module.exports.EXCEPTION_ENDPOINT = 'https://statsigapi.net/v1/sdk_exception';
const $24b19336c2ac1113$var$UNKNOWN_ERROR = '[Statsig] UnknownError';
class $24b19336c2ac1113$var$ErrorBoundary {
    constructor(_sdkKey, _options, _emitter, _lastSeenError){
        this._sdkKey = _sdkKey;
        this._options = _options;
        this._emitter = _emitter;
        this._lastSeenError = _lastSeenError;
        this._seen = new Set();
    }
    wrap(instance, namePrefix) {
        try {
            const obj = instance;
            $24b19336c2ac1113$var$_getAllInstanceMethodNames(obj).forEach((name)=>{
                const original = obj[name];
                if ('$EB' in original) return;
                obj[name] = (...args)=>{
                    return this._capture(namePrefix ? `${namePrefix}:${name}` : name, ()=>original.apply(instance, args));
                };
                obj[name].$EB = true;
            });
        } catch (err) {
            this._onError('eb:wrap', err);
        }
    }
    logError(tag, error) {
        this._onError(tag, error);
    }
    logDroppedEvents(count, reason, metadata) {
        const extra = {
            eventCount: String(count)
        };
        if (metadata) Object.keys(metadata).forEach((key)=>{
            extra[key] = String(metadata[key]);
        });
        this._onError(`statsig::log_event_dropped_event_count`, new Error(reason), true, extra);
    }
    logEventRequestFailure(count, reason, flushType, statusCode, retries) {
        const extra = {
            eventCount: String(count),
            flushType: flushType,
            statusCode: String(statusCode),
            reason: reason,
            retries: String(retries)
        };
        this._onError(`statsig::log_event_failed`, new Error(reason), true, extra);
    }
    getLastSeenErrorAndReset() {
        const tempError = this._lastSeenError;
        this._lastSeenError = undefined;
        return tempError !== null && tempError !== void 0 ? tempError : null;
    }
    attachErrorIfNoneExists(error) {
        if (this._lastSeenError) return;
        this._lastSeenError = $24b19336c2ac1113$var$_resolveError(error);
    }
    _capture(tag, task) {
        try {
            const res = task();
            if (res && res instanceof Promise) return res.catch((err)=>this._onError(tag, err));
            return res;
        } catch (error) {
            this._onError(tag, error);
            return null;
        }
    }
    _onError(tag, error, bypassDedupe = false, extra) {
        try {
            $3sfpc.Log.warn(`Caught error in ${tag}`, {
                error: error
            });
            const impl = ()=>$24b19336c2ac1113$var$__awaiter(this, void 0, void 0, function*() {
                    var _a, _b, _c, _d, _e, _f, _g;
                    const unwrapped = error ? error : Error($24b19336c2ac1113$var$UNKNOWN_ERROR);
                    const isError = unwrapped instanceof Error;
                    const name = isError ? unwrapped.name : 'No Name';
                    const resolvedError = $24b19336c2ac1113$var$_resolveError(unwrapped);
                    this._lastSeenError = resolvedError;
                    if (!bypassDedupe && this._seen.has(name)) return;
                    this._seen.add(name);
                    if ((_b = (_a = this._options) === null || _a === void 0 ? void 0 : _a.networkConfig) === null || _b === void 0 ? void 0 : _b.preventAllNetworkTraffic) {
                        (_c = this._emitter) === null || _c === void 0 || _c.call(this, {
                            name: 'error',
                            error: error,
                            tag: tag
                        });
                        return;
                    }
                    const sdkType = $aiqjf.SDKType._get(this._sdkKey);
                    const statsigMetadata = $5CBso.StatsigMetadataProvider.get();
                    const info = isError ? unwrapped.stack : $24b19336c2ac1113$var$_getDescription(unwrapped);
                    const body = Object.assign(Object.assign({
                        tag: tag,
                        exception: name,
                        info: info,
                        statsigOptions: $24b19336c2ac1113$var$_getStatsigOptionLoggingCopy(this._options)
                    }, Object.assign(Object.assign({}, statsigMetadata), {
                        sdkType: sdkType
                    })), extra !== null && extra !== void 0 ? extra : {});
                    const func = (_f = (_e = (_d = this._options) === null || _d === void 0 ? void 0 : _d.networkConfig) === null || _e === void 0 ? void 0 : _e.networkOverrideFunc) !== null && _f !== void 0 ? _f : fetch;
                    yield func(module.exports.EXCEPTION_ENDPOINT, {
                        method: 'POST',
                        headers: {
                            'STATSIG-API-KEY': this._sdkKey,
                            'STATSIG-SDK-TYPE': String(sdkType),
                            'STATSIG-SDK-VERSION': String(statsigMetadata.sdkVersion),
                            'Content-Type': 'application/json'
                        },
                        body: JSON.stringify(body)
                    });
                    (_g = this._emitter) === null || _g === void 0 || _g.call(this, {
                        name: 'error',
                        error: error,
                        tag: tag
                    });
                });
            impl().then(()=>{
            /* noop */ }).catch(()=>{
            /* noop */ });
        } catch (_error) {
        /* noop */ }
    }
}
module.exports.ErrorBoundary = $24b19336c2ac1113$var$ErrorBoundary;
function $24b19336c2ac1113$var$_resolveError(error) {
    if (error instanceof Error) return error;
    else if (typeof error === 'string') return new Error(error);
    else return new Error('An unknown error occurred.');
}
function $24b19336c2ac1113$var$_getDescription(obj) {
    try {
        return JSON.stringify(obj);
    } catch (_a) {
        return $24b19336c2ac1113$var$UNKNOWN_ERROR;
    }
}
function $24b19336c2ac1113$var$_getAllInstanceMethodNames(instance) {
    const names = new Set();
    let proto = Object.getPrototypeOf(instance);
    while(proto && proto !== Object.prototype){
        Object.getOwnPropertyNames(proto).filter((prop)=>typeof (proto === null || proto === void 0 ? void 0 : proto[prop]) === 'function').forEach((name)=>names.add(name));
        proto = Object.getPrototypeOf(proto);
    }
    return Array.from(names);
}
function $24b19336c2ac1113$var$_getStatsigOptionLoggingCopy(options) {
    if (!options) return {};
    const loggingCopy = {};
    Object.keys(options).forEach((key)=>{
        const option = key;
        const value = options[option];
        const valueType = typeof value;
        switch(valueType){
            case 'number':
            case 'bigint':
            case 'boolean':
                loggingCopy[String(option)] = value;
                break;
            case 'string':
                if (value.length < 50) loggingCopy[String(option)] = value;
                else loggingCopy[String(option)] = 'set';
                break;
            case 'object':
                if (option === 'environment') loggingCopy['environment'] = value;
                else if (option === 'networkConfig') loggingCopy['networkConfig'] = value;
                else loggingCopy[String(option)] = value != null ? 'set' : 'unset';
                break;
            default:
        }
    });
    return loggingCopy;
}

});

parcelRegister("9GgbB", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("2GG5j", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("klfhu", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("1FVci", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.createMemoKey = module.exports.MemoPrefix = void 0;
module.exports.MemoPrefix = {
    _gate: 'g',
    _dynamicConfig: 'c',
    _experiment: 'e',
    _configList: 'cl',
    _layer: 'l',
    _paramStore: 'p'
};
const $1385fcf6d30c3e23$var$EXIST_KEYS = new Set([]);
const $1385fcf6d30c3e23$var$DO_NOT_MEMO_KEYS = new Set([
    // Add keys that if exist, should not be memoized
    'userPersistedValues'
]);
function $1385fcf6d30c3e23$var$createMemoKey(prefix, name, options) {
    let cacheKey = `${prefix}|${name}`;
    if (!options) return cacheKey;
    for (const key of Object.keys(options)){
        if ($1385fcf6d30c3e23$var$DO_NOT_MEMO_KEYS.has(key)) return undefined;
        if ($1385fcf6d30c3e23$var$EXIST_KEYS.has(key)) cacheKey += `|${key}=true`;
        else cacheKey += `|${key}=${options[key]}`;
    }
    return cacheKey;
}
module.exports.createMemoKey = $1385fcf6d30c3e23$var$createMemoKey;

});

parcelRegister("gHEAC", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("280of", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("3MLOf", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._fastApproxSizeOf = void 0;
const $2c1af0c121253003$var$CURLY_AND_SQUARE_BRACKET_SIZE = 2; // [] for array, {} for object
const $2c1af0c121253003$var$APPROX_ADDITIONAL_SIZE = 1; // additional size for comma and stuff
const $2c1af0c121253003$var$_fastApproxSizeOf = (obj, max)=>{
    let size = 0;
    const keys = Object.keys(obj);
    for(let i = 0; i < keys.length; i++){
        const key = keys[i];
        const value = obj[key];
        size += key.length;
        if (typeof value === 'object' && value !== null) size += (0, module.exports._fastApproxSizeOf)(value, max) + $2c1af0c121253003$var$CURLY_AND_SQUARE_BRACKET_SIZE;
        else size += String(value).length + $2c1af0c121253003$var$APPROX_ADDITIONAL_SIZE;
        if (size >= max) // exit early if we've exceeded the max
        return size;
    }
    return size;
};
module.exports._fastApproxSizeOf = $2c1af0c121253003$var$_fastApproxSizeOf;

});

parcelRegister("5P0v1", function(module, exports) {
"use strict";
var $43d21a57a2b76706$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.StatsigClientBase = void 0;

var $khZUo = parcelRequire("khZUo");

var $khZUo = parcelRequire("khZUo");

var $39jNY = parcelRequire("39jNY");

var $8ZegJ = parcelRequire("8ZegJ");

var $3sfpc = parcelRequire("3sfpc");

var $1FVci = parcelRequire("1FVci");

var $2a4Fo = parcelRequire("2a4Fo");

var $1pnfi = parcelRequire("1pnfi");

var $gxJjE = parcelRequire("gxJjE");

var $eNn8G = parcelRequire("eNn8G");

var $9YlaE = parcelRequire("9YlaE");
const $43d21a57a2b76706$var$MAX_MEMO_CACHE_SIZE = 3000;
class $43d21a57a2b76706$var$StatsigClientBase {
    constructor(sdkKey, adapter, network, options){
        var _a, _b, _c, _d;
        this.loadingStatus = 'Uninitialized';
        this._initializePromise = null;
        this._listeners = {};
        const emitter = this.$emt.bind(this);
        (options === null || options === void 0 ? void 0 : options.logLevel) != null && ($3sfpc.Log.level = options.logLevel);
        (options === null || options === void 0 ? void 0 : options.disableStorage) && $9YlaE.Storage._setDisabled(true);
        (options === null || options === void 0 ? void 0 : options.initialSessionID) && $1pnfi.StatsigSession.overrideInitialSessionID(options.initialSessionID, sdkKey);
        (options === null || options === void 0 ? void 0 : options.storageProvider) && $9YlaE.Storage._setProvider(options.storageProvider);
        (options === null || options === void 0 ? void 0 : options.enableCookies) && $gxJjE.StableID._setCookiesEnabled(sdkKey, options.enableCookies);
        (options === null || options === void 0 ? void 0 : options.disableStableID) && $gxJjE.StableID._setDisabled(sdkKey, true);
        this._sdkKey = sdkKey;
        this._options = options !== null && options !== void 0 ? options : {};
        this._memoCache = {};
        this.overrideAdapter = (_a = options === null || options === void 0 ? void 0 : options.overrideAdapter) !== null && _a !== void 0 ? _a : null;
        this._errorBoundary = new $39jNY.ErrorBoundary(sdkKey, options, emitter);
        this._logger = new $8ZegJ.EventLogger(sdkKey, emitter, network, options, this._errorBoundary);
        this._errorBoundary.wrap(this);
        this._errorBoundary.wrap(adapter);
        this._errorBoundary.wrap(this._logger);
        network.setErrorBoundary(this._errorBoundary);
        this.dataAdapter = adapter;
        this.dataAdapter.attach(sdkKey, options, network);
        this.storageProvider = $9YlaE.Storage;
        (_d = (_c = (_b = this.overrideAdapter) === null || _b === void 0 ? void 0 : _b.loadFromStorage) === null || _c === void 0 ? void 0 : _c.call(_b)) === null || _d === void 0 || _d.catch((e)=>this._errorBoundary.logError('OA::loadFromStorage', e));
        this._primeReadyRipcord();
        $43d21a57a2b76706$var$_assignGlobalInstance(sdkKey, this);
    }
    /**
     * Updates runtime configuration options for the SDK, allowing toggling of certain behaviors such as logging and storage to comply with user preferences or regulations such as GDPR.
     *
     * @param {StatsigRuntimeMutableOptions} options - The configuration options that dictate the runtime behavior of the SDK.
     */ updateRuntimeOptions(options) {
        if (options.loggingEnabled) {
            this._options.loggingEnabled = options.loggingEnabled;
            this._logger.setLoggingEnabled(options.loggingEnabled);
        } else if (options.disableLogging != null) {
            this._options.disableLogging = options.disableLogging;
            this._logger.setLoggingEnabled(options.disableLogging ? 'disabled' : 'browser-only');
        }
        if (options.disableStorage != null) {
            this._options.disableStorage = options.disableStorage;
            $9YlaE.Storage._setDisabled(options.disableStorage);
        }
        if (options.enableCookies != null) {
            this._options.enableCookies = options.enableCookies;
            $gxJjE.StableID._setCookiesEnabled(this._sdkKey, options.enableCookies);
        }
        if (options.logEventCompressionMode) this._logger.setLogEventCompressionMode(options.logEventCompressionMode);
        else if (options.disableCompression) this._logger.setLogEventCompressionMode($eNn8G.LogEventCompressionMode.Disabled);
    }
    /**
     * Flushes any currently queued events.
     */ flush() {
        return this._logger.flush();
    }
    /**
     * Gracefully shuts down the SDK, ensuring that all pending events are send before the SDK stops.
     * This function emits a 'pre_shutdown' event and then waits for the logger to complete its shutdown process.
     *
     * @returns {Promise<void>} A promise that resolves when all shutdown procedures, including logging shutdown, have been completed.
     */ shutdown() {
        return $43d21a57a2b76706$var$__awaiter(this, void 0, void 0, function*() {
            this.$emt({
                name: 'pre_shutdown'
            });
            this._setStatus('Uninitialized', null);
            this._initializePromise = null;
            yield this._logger.stop();
        });
    }
    /**
     * Subscribes a callback function to a specific {@link StatsigClientEvent} or all StatsigClientEvents if the wildcard '*' is used.
     * Once subscribed, the listener callback will be invoked whenever the specified event is emitted.
     *
     * @param {StatsigClientEventName} event - The name of the event to subscribe to, or '*' to subscribe to all events.
     * @param {StatsigClientEventCallback<T>} listener - The callback function to execute when the event occurs. The function receives event-specific data as its parameter.
     * @see {@link off} for unsubscribing from events.
     */ on(event, listener) {
        if (!this._listeners[event]) this._listeners[event] = [];
        this._listeners[event].push(listener);
    }
    /**
     * Unsubscribes a previously registered callback function from a specific {@link StatsigClientEvent} or all StatsigClientEvents if the wildcard '*' is used.
     *
     * @param {StatsigClientEventName} event - The name of the event from which to unsubscribe, or '*' to unsubscribe from all events.
     * @param {StatsigClientEventCallback<T>} listener - The callback function to remove from the event's notification list.
     * @see {@link on} for subscribing to events.
     */ off(event, listener) {
        if (this._listeners[event]) {
            const index = this._listeners[event].indexOf(listener);
            if (index !== -1) this._listeners[event].splice(index, 1);
        }
    }
    $on(event, listener) {
        listener.__isInternal = true;
        this.on(event, listener);
    }
    $emt(event) {
        var _a;
        const barrier = (listener)=>{
            try {
                listener(event);
            } catch (error) {
                if (listener.__isInternal === true) {
                    this._errorBoundary.logError(`__emit:${event.name}`, error);
                    return;
                }
                $3sfpc.Log.error(`An error occurred in a StatsigClientEvent listener. This is not an issue with Statsig.`, event);
            }
        };
        if (this._listeners[event.name]) this._listeners[event.name].forEach((l)=>barrier(l));
        (_a = this._listeners['*']) === null || _a === void 0 || _a.forEach(barrier);
    }
    _setStatus(newStatus, values) {
        this.loadingStatus = newStatus;
        this._memoCache = {};
        this.$emt({
            name: 'values_updated',
            status: newStatus,
            values: values
        });
    }
    _enqueueExposure(name, exposure, options) {
        if ((options === null || options === void 0 ? void 0 : options.disableExposureLog) === true) {
            this._logger.incrementNonExposureCount(name);
            return;
        }
        this._logger.enqueue(exposure);
    }
    _memoize(prefix, fn) {
        return (name, options)=>{
            if (this._options.disableEvaluationMemoization) return fn(name, options);
            const memoKey = (0, $1FVci.createMemoKey)(prefix, name, options);
            if (!memoKey) return fn(name, options);
            if (!(memoKey in this._memoCache)) {
                if (Object.keys(this._memoCache).length >= $43d21a57a2b76706$var$MAX_MEMO_CACHE_SIZE) this._memoCache = {};
                this._memoCache[memoKey] = fn(name, options);
            }
            return this._memoCache[memoKey];
        };
    }
}
module.exports.StatsigClientBase = $43d21a57a2b76706$var$StatsigClientBase;
function $43d21a57a2b76706$var$_assignGlobalInstance(sdkKey, client) {
    var _a;
    if ((0, $2a4Fo._isServerEnv)()) return;
    const statsigGlobal = (0, $khZUo._getStatsigGlobal)();
    const instances = (_a = statsigGlobal.instances) !== null && _a !== void 0 ? _a : {};
    const inst = client;
    if (instances[sdkKey] != null) $3sfpc.Log.warn('Creating multiple Statsig clients with the same SDK key can lead to unexpected behavior. Multi-instance support requires different SDK keys.');
    instances[sdkKey] = inst;
    if (!statsigGlobal.firstInstance) statsigGlobal.firstInstance = inst;
    statsigGlobal.instances = instances;
    __STATSIG__ = statsigGlobal;
}

});

parcelRegister("gXoh1", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DataAdapterCachePrefix = void 0;
module.exports.DataAdapterCachePrefix = 'statsig.cached';

});

parcelRegister("c6jZh", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("fQ7ZH", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._makeTypedGet = module.exports._mergeOverride = module.exports._makeLayer = module.exports._makeExperiment = module.exports._makeDynamicConfig = module.exports._makeFeatureGate = void 0;

var $3sfpc = parcelRequire("3sfpc");

var $lje2o = parcelRequire("lje2o");
function $b881e9d2634e4595$var$_makeEvaluation(name, details, evaluation, value) {
    var _a;
    return {
        name: name,
        details: details,
        ruleID: (_a = evaluation === null || evaluation === void 0 ? void 0 : evaluation.rule_id) !== null && _a !== void 0 ? _a : '',
        __evaluation: evaluation,
        value: value
    };
}
function $b881e9d2634e4595$var$_makeFeatureGate(name, details, evaluation) {
    var _a;
    return Object.assign(Object.assign({}, $b881e9d2634e4595$var$_makeEvaluation(name, details, evaluation, (evaluation === null || evaluation === void 0 ? void 0 : evaluation.value) === true)), {
        idType: (_a = evaluation === null || evaluation === void 0 ? void 0 : evaluation.id_type) !== null && _a !== void 0 ? _a : null
    });
}
module.exports._makeFeatureGate = $b881e9d2634e4595$var$_makeFeatureGate;
function $b881e9d2634e4595$var$_makeDynamicConfig(name, details, evaluation) {
    var _a, _b;
    const value = (_a = evaluation === null || evaluation === void 0 ? void 0 : evaluation.value) !== null && _a !== void 0 ? _a : {};
    return Object.assign(Object.assign({}, $b881e9d2634e4595$var$_makeEvaluation(name, details, evaluation, value)), {
        idType: (_b = evaluation === null || evaluation === void 0 ? void 0 : evaluation.id_type) !== null && _b !== void 0 ? _b : null,
        get: $b881e9d2634e4595$var$_makeTypedGet(name, evaluation === null || evaluation === void 0 ? void 0 : evaluation.value)
    });
}
module.exports._makeDynamicConfig = $b881e9d2634e4595$var$_makeDynamicConfig;
function $b881e9d2634e4595$var$_makeExperiment(name, details, evaluation) {
    var _a;
    const result = $b881e9d2634e4595$var$_makeDynamicConfig(name, details, evaluation);
    return Object.assign(Object.assign({}, result), {
        groupName: (_a = evaluation === null || evaluation === void 0 ? void 0 : evaluation.group_name) !== null && _a !== void 0 ? _a : null
    });
}
module.exports._makeExperiment = $b881e9d2634e4595$var$_makeExperiment;
function $b881e9d2634e4595$var$_makeLayer(name, details, evaluation, exposeFunc) {
    var _a, _b;
    return Object.assign(Object.assign({}, $b881e9d2634e4595$var$_makeEvaluation(name, details, evaluation, undefined)), {
        get: $b881e9d2634e4595$var$_makeTypedGet(name, evaluation === null || evaluation === void 0 ? void 0 : evaluation.value, exposeFunc),
        groupName: (_a = evaluation === null || evaluation === void 0 ? void 0 : evaluation.group_name) !== null && _a !== void 0 ? _a : null,
        __value: (_b = evaluation === null || evaluation === void 0 ? void 0 : evaluation.value) !== null && _b !== void 0 ? _b : {}
    });
}
module.exports._makeLayer = $b881e9d2634e4595$var$_makeLayer;
function $b881e9d2634e4595$var$_mergeOverride(original, overridden, value, exposeFunc) {
    return Object.assign(Object.assign(Object.assign({}, original), overridden), {
        get: $b881e9d2634e4595$var$_makeTypedGet(original.name, value, exposeFunc)
    });
}
module.exports._mergeOverride = $b881e9d2634e4595$var$_mergeOverride;
function $b881e9d2634e4595$var$_makeTypedGet(name, value, exposeFunc) {
    return (param, fallback)=>{
        var _a;
        const found = (_a = value === null || value === void 0 ? void 0 : value[param]) !== null && _a !== void 0 ? _a : null;
        if (found == null) return fallback !== null && fallback !== void 0 ? fallback : null;
        if (fallback != null && !(0, $lje2o._isTypeMatch)(found, fallback)) {
            $3sfpc.Log.warn(`Parameter type mismatch. '${name}.${param}' was found to be type '${typeof found}' but fallback/return type is '${typeof fallback}'. See https://docs.statsig.com/client/javascript-sdk/#typed-getters`);
            return fallback !== null && fallback !== void 0 ? fallback : null;
        }
        exposeFunc === null || exposeFunc === void 0 || exposeFunc(param);
        return found;
    };
}
module.exports._makeTypedGet = $b881e9d2634e4595$var$_makeTypedGet;

});

parcelRegister("cCdUn", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("5KvN8", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.UPDATE_DETAIL_ERROR_MESSAGES = module.exports.createUpdateDetails = void 0;
const $42f9e8c355f91ef0$var$createUpdateDetails = (success, source, initDuration, error, sourceUrl, warnings)=>{
    return {
        duration: initDuration,
        source: source,
        success: success,
        error: error,
        sourceUrl: sourceUrl,
        warnings: warnings
    };
};
module.exports.createUpdateDetails = $42f9e8c355f91ef0$var$createUpdateDetails;
module.exports.UPDATE_DETAIL_ERROR_MESSAGES = {
    NO_NETWORK_DATA: 'No data was returned from the network. This may be due to a network timeout if a timeout value was specified in the options or ad blocker error.'
};

});


parcelRegister("5qZKP", function(module, exports) {
"use strict";
var $3f4f489405772007$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $9VR6c = parcelRequire("9VR6c");

var $er3Eg = parcelRequire("er3Eg");

var $fmin1 = parcelRequire("fmin1");

var $l1Iiv = parcelRequire("l1Iiv");

var $kk2vN = parcelRequire("kk2vN");
class $3f4f489405772007$var$StatsigClient extends $9VR6c.StatsigClientBase {
    /**
     * Retrieves an instance of the StatsigClient based on the provided SDK key.
     *  If no SDK key is provided, the method returns the most recently created instance of the StatsigClient.
     *  The method ensures that each unique SDK key corresponds to a single instance of StatsigClient, effectively implementing a singleton pattern for each key.
     *  If no instance exists for the given SDK key, a new StatsigClient instance will be created and returned.
     *
     * @param {string} [sdkKey] - Optional. The SDK key used to identify a specific instance of the StatsigClient. If omitted, the method returns the last created instance.
     * @returns {StatsigClient} Returns the StatsigClient instance associated with the given SDK key, creating a new one if needed.
     */ static instance(sdkKey) {
        const instance = (0, $9VR6c._getStatsigGlobal)().instance(sdkKey);
        if (instance instanceof $3f4f489405772007$var$StatsigClient) return instance;
        $9VR6c.Log.warn((0, $9VR6c._isServerEnv)() ? 'StatsigClient.instance is not supported in server environments' : 'Unable to find StatsigClient instance');
        return new $3f4f489405772007$var$StatsigClient(sdkKey !== null && sdkKey !== void 0 ? sdkKey : '', {});
    }
    /**
     * StatsigClient constructor
     *
     * @param {string} sdkKey A Statsig client SDK key. eg "client-xyz123..."
     * @param {StatsigUser} user StatsigUser object containing various attributes related to a user.
     * @param {StatsigOptions | null} options StatsigOptions, used to customize the behavior of the SDK.
     */ constructor(sdkKey, user, options = null){
        var _a, _b;
        $9VR6c.SDKType._setClientType(sdkKey, 'javascript-client');
        const network = new $fmin1.default(options, (e)=>{
            this.$emt(e);
        });
        super(sdkKey, (_a = options === null || options === void 0 ? void 0 : options.dataAdapter) !== null && _a !== void 0 ? _a : new $kk2vN.StatsigEvaluationsDataAdapter(), network, options);
        this._possibleFirstTouchMetadata = {};
        /**
         * Retrieves the value of a feature gate for the current user, represented as a {@link FeatureGate} object.
         *
         * @param {string} name - The name of the feature gate to retrieve.
         * @param {FeatureGateEvaluationOptions} [options] - Optional. Additional options to customize the method call.
         * @returns {FeatureGate} - The {@link FeatureGate} object representing the gate's current evaluation results for the user.
         */ this.getFeatureGate = this._memoize($9VR6c.MemoPrefix._gate, this._getFeatureGateImpl.bind(this));
        /**
         * Retrieves the value of a dynamic config for the current user.
         *
         * @param {string} name The name of the dynamic config to get.
         * @param {DynamicConfigEvaluationOptions} [options] - Optional. Additional options to customize the method call.
         * @returns {DynamicConfig} - The {@link DynamicConfig} object representing the dynamic configs's current evaluation results for the user.
         */ this.getDynamicConfig = this._memoize($9VR6c.MemoPrefix._dynamicConfig, this._getDynamicConfigImpl.bind(this));
        /**
         * Retrieves the value of a experiment for the current user.
         *
         * @param {string} name The name of the experiment to get.
         * @param {ExperimentEvaluationOptions} [options] - Optional. Additional options to customize the method call.
         * @returns {Experiment} - The {@link Experiment} object representing the experiments's current evaluation results for the user.
         */ this.getExperiment = this._memoize($9VR6c.MemoPrefix._experiment, this._getExperimentImpl.bind(this));
        /**
         * Retrieves the list of all Dynamic Configs and Experiments for the current user.
         *
         * @returns {string[]} The list of all Dynamic Config and Experiment names for the current user. Note - these will be hashed unless you've disabled hashing.
         * This is intended to be used for debugging.
         */ this.getConfigList = this._memoize($9VR6c.MemoPrefix._configList, this._getConfigListImpl.bind(this));
        /**
         * Retrieves the value of a layer for the current user.
         *
         * @param {string} name The name of the layer to get.
         * @param {LayerEvaluationOptions} [options] - Optional. Additional options to customize the method call.
         * @returns {Layer} - The {@link Layer} object representing the layers's current evaluation results for the user.
         */ this.getLayer = this._memoize($9VR6c.MemoPrefix._layer, this._getLayerImpl.bind(this));
        /**
         * Retrieves the value of a parameter store for the current user.
         *
         * @param {string} name The name of the parameter store to get.
         * @param {ParameterStoreEvaluationOptions} [options] - Optional. Additional options to customize the method call.
         * @returns {ParameterStore} - The {@link ParameterStore} object representing the parameter store's current mappings for the user.
         */ this.getParameterStore = this._memoize($9VR6c.MemoPrefix._paramStore, this._getParameterStoreImpl.bind(this));
        this._store = new $er3Eg.default(sdkKey, options !== null && options !== void 0 ? options : null);
        this._network = network;
        this._user = this._configureUser(user, options);
        this._sdkInstanceID = (0, $9VR6c.getUUID)();
        this._contextHandle = new $9VR6c.PrecomputedEvaluationsContextHandle(sdkKey, ()=>this._options, ()=>this._errorBoundary, ()=>this._store.getValues(), ()=>this._user, ()=>this._sdkInstanceID);
        const plugins = (_b = options === null || options === void 0 ? void 0 : options.plugins) !== null && _b !== void 0 ? _b : [];
        for (const plugin of plugins)plugin.bind(this);
    }
    /**
     * Initializes the StatsigClient using cached values. This method sets up the client synchronously by utilizing previously cached values.
     * After initialization, cache values are updated in the background for future use, either in subsequent sessions or when `updateUser` is called.
     * This is useful for quickly starting with the last-known-good configurations while refreshing data to keep settings up-to-date.
     *
     * @see {@link initializeAsync} for the asynchronous version of this method.
     */ initializeSync(options) {
        var _a;
        if (this.loadingStatus !== 'Uninitialized') return (0, $9VR6c.createUpdateDetails)(true, this._store.getSource(), -1, null, null, [
            'MultipleInitializations',
            ...(_a = this._store.getWarnings()) !== null && _a !== void 0 ? _a : []
        ]);
        this._logger.start();
        return this.updateUserSync(this._user, options);
    }
    /**
     * Initializes the StatsigClient asynchronously by first using cached values and then updating to the latest values from the network.
     * Once the network values are fetched, they replace the existing cached values. If this method's promise is not awaited,
     * there might be a transition from cached to network values during the session, which can affect consistency.
     * This method is useful when it's acceptable to begin with potentially stale data and switch to the latest configuration as it becomes available.
     *
     * @param {AsyncUpdateOptions} [options] - Optional. Additional options to customize the method call.
     * @returns {Promise<void>} A promise that resolves once the client is fully initialized with the latest values from the network or a timeout (if set) is hit.
     * @see {@link initializeSync} for the synchronous version of this method.
     */ initializeAsync(options) {
        return $3f4f489405772007$var$__awaiter(this, void 0, void 0, function*() {
            if (this._initializePromise) return this._initializePromise;
            this._initializePromise = this._initializeAsyncImpl(options);
            return this._initializePromise;
        });
    }
    /**
     * Synchronously updates the user in the Statsig client and switches the internal state to use cached values for the newly specified user.
     * After the initial switch to cached values, this method updates these values in the background, preparing them for future sessions or subsequent calls to updateUser.
     * This method ensures the client is quickly ready with available data.
     *
     * @param {StatsigUser} user - The new StatsigUser for which the client should update its internal state.
     * @see {@link updateUserAsync} for the asynchronous version of this method.
     */ updateUserSync(user, options) {
        const startTime = performance.now();
        try {
            return this._updateUserSyncImpl(user, options, startTime);
        } catch (e) {
            const err = e instanceof Error ? e : new Error(String(e));
            return this._createErrorUpdateDetails(err, startTime);
        }
    }
    _updateUserSyncImpl(user, options, startTime) {
        var _a;
        const warnings = [
            ...(_a = this._store.getWarnings()) !== null && _a !== void 0 ? _a : []
        ];
        this._resetForUser(user);
        const result = this.dataAdapter.getDataSync(this._user);
        if (result == null) warnings.push('NoCachedValues');
        this._store.setValues(result, this._user);
        this._finalizeUpdate(result);
        const disable = options === null || options === void 0 ? void 0 : options.disableBackgroundCacheRefresh;
        if (disable === true || disable == null && (result === null || result === void 0 ? void 0 : result.source) === 'Bootstrap') return (0, $9VR6c.createUpdateDetails)(true, this._store.getSource(), performance.now() - startTime, this._errorBoundary.getLastSeenErrorAndReset(), this._network.getLastUsedInitUrlAndReset(), warnings);
        this._runPostUpdate(result !== null && result !== void 0 ? result : null, this._user);
        return (0, $9VR6c.createUpdateDetails)(true, this._store.getSource(), performance.now() - startTime, this._errorBoundary.getLastSeenErrorAndReset(), this._network.getLastUsedInitUrlAndReset(), warnings);
    }
    /**
     * Asynchronously updates the user in the Statsig client by initially using cached values and then fetching the latest values from the network.
     * When the latest values are fetched, they replace the cached values. If the promise returned by this method is not awaited,
     * the client's state may shift from cached to updated network values during the session, potentially affecting consistency.
     * This method is best used in scenarios where up-to-date configuration is critical and initial delays are acceptable.
     *
     * @param {StatsigUser} user - The new StatsigUser for which the client should update its internal state.
     * @param {AsyncUpdateOptions} [options] - Optional. Additional options to customize the method call.
     * @returns {Promise<void>} A promise that resolves once the client is fully updated with the latest values from the network or a timeout (if set) is hit.
     * @see {@link updateUserSync} for the synchronous version of this method.
     */ updateUserAsync(user, options) {
        return $3f4f489405772007$var$__awaiter(this, void 0, void 0, function*() {
            const startTime = performance.now();
            try {
                return yield this._updateUserAsyncImpl(user, options);
            } catch (e) {
                const err = e instanceof Error ? e : new Error(String(e));
                return this._createErrorUpdateDetails(err, startTime);
            }
        });
    }
    _updateUserAsyncImpl(user, options) {
        return $3f4f489405772007$var$__awaiter(this, void 0, void 0, function*() {
            this._resetForUser(user);
            const initiator = this._user;
            $9VR6c.Diagnostics._markInitOverallStart(this._sdkKey);
            let result = this.dataAdapter.getDataSync(initiator);
            this._store.setValues(result, this._user);
            this._setStatus('Loading', result);
            result = yield this.dataAdapter.getDataAsync(result, initiator, options);
            // ensure the user hasn't changed while we were waiting
            if (initiator !== this._user) return (0, $9VR6c.createUpdateDetails)(false, this._store.getSource(), -1, new Error('User changed during update'), this._network.getLastUsedInitUrlAndReset());
            let isUsingNetworkValues = false;
            if (result != null) {
                $9VR6c.Diagnostics._markInitProcessStart(this._sdkKey);
                isUsingNetworkValues = this._store.setValues(result, this._user);
                $9VR6c.Diagnostics._markInitProcessEnd(this._sdkKey, {
                    success: isUsingNetworkValues
                });
            }
            this._finalizeUpdate(result);
            if (!isUsingNetworkValues) {
                this._errorBoundary.attachErrorIfNoneExists($9VR6c.UPDATE_DETAIL_ERROR_MESSAGES.NO_NETWORK_DATA);
                this.$emt({
                    name: 'initialization_failure'
                });
            }
            $9VR6c.Diagnostics._markInitOverallEnd(this._sdkKey, isUsingNetworkValues, this._store.getCurrentSourceDetails());
            const initDuration = $9VR6c.Diagnostics._enqueueDiagnosticsEvent(this._user, this._logger, this._sdkKey, this._options);
            return (0, $9VR6c.createUpdateDetails)(isUsingNetworkValues, this._store.getSource(), initDuration, this._errorBoundary.getLastSeenErrorAndReset(), this._network.getLastUsedInitUrlAndReset(), this._store.getWarnings());
        });
    }
    /**
     * Retrieves a synchronous context containing data currently being used by the SDK. Represented as a {@link PrecomputedEvaluationsContext} object.
     *
     * @returns {PrecomputedEvaluationsContext} The current synchronous context for the this StatsigClient instance.
     */ getContext() {
        let user = (0, $9VR6c._cloneObject)('StatsigUser', this._user);
        if (user == null) {
            $9VR6c.Log.error('Failed to clone user');
            user = {};
        }
        return {
            sdkKey: this._sdkKey,
            options: this._options,
            values: this._store.getValues(),
            user: user,
            errorBoundary: this._errorBoundary,
            session: $9VR6c.StatsigSession.get(this._sdkKey),
            stableID: $9VR6c.StableID.get(this._sdkKey),
            sdkInstanceID: this._sdkInstanceID
        };
    }
    /**
     * Retrieves a context handle that computes fields lazily on access.
     * This is more efficient than getContext() when you only need certain fields,
     *
     * @returns {PrecomputedEvaluationsContextHandle} A handle with lazy getters for context fields.
     */ getContextHandle() {
        return this._contextHandle;
    }
    /**
     * Retrieves the value of a feature gate for the current user, represented as a simple boolean.
     *
     * @param {string} name - The name of the feature gate to retrieve.
     * @param {FeatureGateEvaluationOptions} [options] - Optional. Additional options to customize the method call.
     * @returns {boolean} - The boolean value representing the gate's current evaluation results for the user.
     */ checkGate(name, options) {
        return this.getFeatureGate(name, options).value;
    }
    /**
     * Logs an event to the internal logging system. This function allows logging by either passing a fully formed event object or by specifying the event name with optional value and metadata.
     *
     * @param {StatsigEvent|string} eventOrName - The event object conforming to the StatsigEvent interface, or the name of the event as a string.
     * @param {string|number} value - Optional. The value associated with the event, which can be a string or a number. This parameter is ignored if the first parameter is a StatsigEvent object.
     * @param {Record<string, string>} metadata - Optional. A key-value record containing metadata about the event. This is also ignored if the first parameter is an event object.
     */ logEvent(eventOrName, value, metadata) {
        const event = typeof eventOrName === 'string' ? {
            eventName: eventOrName,
            value: value,
            metadata: metadata
        } : eventOrName;
        this.$emt({
            name: 'log_event_called',
            event: event
        });
        this._logger.enqueue(Object.assign(Object.assign({}, event), {
            user: this._user,
            time: Date.now()
        }));
    }
    /**
     * Updates the user with analytics only metadata. This will override any existing analytics only metadata.
     *
     * @param {Record<string, string | number | boolean>} metadata - The metadata to add to the user.
     */ updateUserWithAnalyticsOnlyMetadata(metadata) {
        this._user = this._configureUser(Object.assign(Object.assign({}, this._user), {
            analyticsOnlyMetadata: metadata
        }), this._options);
    }
    _primeReadyRipcord() {
        this.$on('error', ()=>{
            this.loadingStatus === 'Loading' && this._finalizeUpdate(null);
        });
    }
    _initializeAsyncImpl(options) {
        return $3f4f489405772007$var$__awaiter(this, void 0, void 0, function*() {
            if (!$9VR6c.Storage.isReady()) yield $9VR6c.Storage.isReadyResolver();
            this._logger.start();
            return this.updateUserAsync(this._user, options);
        });
    }
    _createErrorUpdateDetails(error, startTime) {
        var _a;
        return (0, $9VR6c.createUpdateDetails)(false, this._store.getSource(), performance.now() - startTime, error, null, [
            ...(_a = this._store.getWarnings()) !== null && _a !== void 0 ? _a : []
        ]);
    }
    _finalizeUpdate(values) {
        this._store.finalize();
        this._setStatus('Ready', values);
    }
    _runPostUpdate(current, user) {
        this.dataAdapter.getDataAsync(current, user, {
            priority: 'low'
        }).catch((err)=>{
            $9VR6c.Log.error('An error occurred after update.', err);
        });
    }
    _resetForUser(user) {
        this._logger.reset();
        this._store.reset();
        this._user = this._configureUser(user, this._options);
    }
    _configureUser(originalUser, options) {
        var _a, _b, _c;
        const user = (0, $9VR6c._normalizeUser)(originalUser, options);
        const stableIdOverride = (_a = user.customIDs) === null || _a === void 0 ? void 0 : _a.stableID;
        if (stableIdOverride) {
            const readyPromise = (_c = (_b = this.storageProvider).isReadyResolver) === null || _c === void 0 ? void 0 : _c.call(_b);
            if (readyPromise) readyPromise.then(()=>$9VR6c.StableID.setOverride(stableIdOverride, this._sdkKey), ()=>$9VR6c.StableID.setOverride(stableIdOverride, this._sdkKey));
            else $9VR6c.StableID.setOverride(stableIdOverride, this._sdkKey);
        }
        // Only attach first touch metadata if it's not empty
        if (Object.keys(this._possibleFirstTouchMetadata).length > 0) user.analyticsOnlyMetadata = Object.assign(Object.assign({}, user.analyticsOnlyMetadata), this._possibleFirstTouchMetadata);
        return user;
    }
    _getFeatureGateImpl(name, options) {
        var _a, _b;
        const { result: evaluation, details: details } = this._store.getGate(name);
        this._checkUserHasIdForEvaluation(evaluation === null || evaluation === void 0 ? void 0 : evaluation.id_type, name, 'Gate');
        this._checkInitializationStatus(details.reason);
        const gate = (0, $9VR6c._makeFeatureGate)(name, details, evaluation);
        const overridden = (_b = (_a = this.overrideAdapter) === null || _a === void 0 ? void 0 : _a.getGateOverride) === null || _b === void 0 ? void 0 : _b.call(_a, gate, this._user, options);
        const result = overridden !== null && overridden !== void 0 ? overridden : gate;
        this._enqueueExposure(name, (0, $9VR6c._createGateExposure)(this._user, result, this._store.getExposureMapping()), options);
        this.$emt({
            name: 'gate_evaluation',
            gate: result
        });
        return result;
    }
    _getDynamicConfigImpl(name, options) {
        var _a, _b;
        const { result: evaluation, details: details } = this._store.getConfig(name);
        this._checkUserHasIdForEvaluation(evaluation === null || evaluation === void 0 ? void 0 : evaluation.id_type, name, 'Dynamic config');
        this._checkInitializationStatus(details.reason);
        const config = (0, $9VR6c._makeDynamicConfig)(name, details, evaluation);
        const overridden = (_b = (_a = this.overrideAdapter) === null || _a === void 0 ? void 0 : _a.getDynamicConfigOverride) === null || _b === void 0 ? void 0 : _b.call(_a, config, this._user, options);
        const result = overridden !== null && overridden !== void 0 ? overridden : config;
        this._enqueueExposure(name, (0, $9VR6c._createConfigExposure)(this._user, result, this._store.getExposureMapping()), options);
        this.$emt({
            name: 'dynamic_config_evaluation',
            dynamicConfig: result
        });
        return result;
    }
    _getExperimentImpl(name, options) {
        var _a, _b, _c, _d;
        const { result: evaluation, details: details } = this._store.getConfig(name);
        this._checkUserHasIdForEvaluation(evaluation === null || evaluation === void 0 ? void 0 : evaluation.id_type, name, 'Experiment');
        this._checkInitializationStatus(details.reason);
        const experiment = (0, $9VR6c._makeExperiment)(name, details, evaluation);
        if (experiment.__evaluation != null) experiment.__evaluation.secondary_exposures = (0, $9VR6c._mapExposures)((_b = (_a = experiment.__evaluation) === null || _a === void 0 ? void 0 : _a.secondary_exposures) !== null && _b !== void 0 ? _b : [], this._store.getExposureMapping());
        const overridden = (_d = (_c = this.overrideAdapter) === null || _c === void 0 ? void 0 : _c.getExperimentOverride) === null || _d === void 0 ? void 0 : _d.call(_c, experiment, this._user, options);
        const result = overridden !== null && overridden !== void 0 ? overridden : experiment;
        this._enqueueExposure(name, (0, $9VR6c._createConfigExposure)(this._user, result, this._store.getExposureMapping()), options);
        this.$emt({
            name: 'experiment_evaluation',
            experiment: result
        });
        return result;
    }
    _getConfigListImpl() {
        return this._store.getConfigList();
    }
    _getLayerImpl(name, options) {
        var _a, _b, _c;
        const { result: evaluation, details: details } = this._store.getLayer(name);
        const layer = (0, $9VR6c._makeLayer)(name, details, evaluation);
        const overridden = (_b = (_a = this.overrideAdapter) === null || _a === void 0 ? void 0 : _a.getLayerOverride) === null || _b === void 0 ? void 0 : _b.call(_a, layer, this._user, options);
        if (options === null || options === void 0 ? void 0 : options.disableExposureLog) this._logger.incrementNonExposureCount(name);
        const result = (0, $9VR6c._mergeOverride)(layer, overridden, (_c = overridden === null || overridden === void 0 ? void 0 : overridden.__value) !== null && _c !== void 0 ? _c : layer.__value, (param)=>{
            if (options === null || options === void 0 ? void 0 : options.disableExposureLog) return;
            this._enqueueExposure(name, (0, $9VR6c._createLayerParameterExposure)(this._user, result, param, this._store.getExposureMapping()), options);
        });
        this.$emt({
            name: 'layer_evaluation',
            layer: result
        });
        return result;
    }
    _getParameterStoreImpl(name, options) {
        var _a, _b;
        const { result: configuration, details: details } = this._store.getParamStore(name);
        this._logger.incrementNonExposureCount(name);
        const paramStore = {
            name: name,
            details: details,
            __configuration: configuration,
            get: (0, $l1Iiv._makeParamStoreGetter)(this, configuration, options)
        };
        const overridden = (_b = (_a = this.overrideAdapter) === null || _a === void 0 ? void 0 : _a.getParamStoreOverride) === null || _b === void 0 ? void 0 : _b.call(_a, paramStore, options);
        if (overridden != null) {
            paramStore.__configuration = overridden.config;
            paramStore.details = overridden.details;
            paramStore.get = (0, $l1Iiv._makeParamStoreGetter)(this, overridden.config, options);
        }
        return paramStore;
    }
    _checkUserHasIdForEvaluation(idType, name, type) {
        if (!idType) return;
        if (!(0, $9VR6c._getUnitIDFromUser)(this._user, idType)) $9VR6c.Log.warn(`The user does not have the required id_type "${idType}" for ${type} "${name}"`);
    }
    _checkInitializationStatus(reason) {
        if (reason === 'Uninitialized' || reason.startsWith('Loading')) $9VR6c.Log.warn(`SDK initialization has not completed. Reason: ${reason}`);
    }
}
module.exports.default = $3f4f489405772007$var$StatsigClient;

});
parcelRegister("er3Eg", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $9VR6c = parcelRequire("9VR6c");

var $5vLe4 = parcelRequire("5vLe4");

var $7eiGh = parcelRequire("7eiGh");
class $a8266ad1662a75da$var$EvaluationStore {
    constructor(_sdkKey, _options){
        this._sdkKey = _sdkKey;
        this._options = _options;
        this._valuesForExternalUse = null;
        this._values = null;
        this._source = 'Uninitialized';
        this._lcut = 0;
        this._receivedAt = 0;
        this._bootstrapMetadata = null;
        this._warnings = new Set();
    }
    reset() {
        this._values = null;
        this._valuesForExternalUse = null;
        this._source = 'Loading';
        this._lcut = 0;
        this._receivedAt = 0;
        this._bootstrapMetadata = null;
        this._warnings.clear();
    }
    finalize() {
        if (this._values) return;
        this._source = 'NoValues';
    }
    getValues() {
        // we do not give out the actual _values object to avoid mutating it
        return this._valuesForExternalUse;
    }
    setValues(result, user) {
        var _a, _b;
        if (!result) return false;
        const values = (0, $9VR6c._typedJsonParse)(result.data, 'has_updates', 'EvaluationResponse');
        if (values == null) return false;
        this._source = result.source;
        if ((values === null || values === void 0 ? void 0 : values.has_updates) !== true) return true;
        const updatedLcut = (_a = values.time) !== null && _a !== void 0 ? _a : 0;
        if (updatedLcut < this._lcut) return true;
        this._valuesForExternalUse = (0, $9VR6c._typedJsonParse)(result.data, 'has_updates', 'EvaluationResponse');
        this._lcut = values.time;
        this._receivedAt = result.receivedAt;
        if (values.response_format === 'init-v2') this._values = new $7eiGh.V2InitializeContainer(values);
        else this._values = new $5vLe4.V1InitializeContainer(values);
        this._bootstrapMetadata = this._extractBootstrapMetadata(result.source, values);
        if (result.source && values.user) this._setWarningState(user, values);
        $9VR6c.SDKFlags.setFlags(this._sdkKey, (_b = values.sdk_flags) !== null && _b !== void 0 ? _b : {});
        return true;
    }
    getWarnings() {
        if (this._warnings.size === 0) return undefined;
        return Array.from(this._warnings);
    }
    getGate(name) {
        const res = this._values ? this._values.getGate(name) : null;
        return this._getDetailedStoreResult(res);
    }
    getConfig(name) {
        const res = this._values ? this._values.getConfig(name) : null;
        return this._getDetailedStoreResult(res);
    }
    getConfigList() {
        if (!this._values) return [];
        return this._values.getConfigList();
    }
    getLayer(name) {
        const res = this._values ? this._values.getLayer(name) : null;
        return this._getDetailedStoreResult(res);
    }
    getParamStore(name) {
        const res = this._values ? this._values.getParamStore(name) : null;
        return this._getDetailedStoreResult(res);
    }
    getSource() {
        return this._source;
    }
    getExposureMapping() {
        var _a;
        return (_a = this._values) === null || _a === void 0 ? void 0 : _a.getExposureMapping();
    }
    _extractBootstrapMetadata(source, values) {
        if (source !== 'Bootstrap') return null;
        const bootstrapMetadata = {};
        if (values.user) bootstrapMetadata.user = values.user;
        if (values.sdkInfo) bootstrapMetadata.generatorSDKInfo = values.sdkInfo;
        bootstrapMetadata.lcut = values.time;
        return bootstrapMetadata;
    }
    _getDetailedStoreResult(result) {
        return {
            result: result,
            details: this._getDetails(result == null)
        };
    }
    _setWarningState(user, values) {
        var _a, _b, _c;
        const stableID = $9VR6c.StableID.get(this._sdkKey);
        if (((_a = user.customIDs) === null || _a === void 0 ? void 0 : _a.stableID) !== stableID && // don't throw if they're both undefined
        (((_b = user.customIDs) === null || _b === void 0 ? void 0 : _b.stableID) || stableID)) {
            this._warnings.add('StableIDMismatch');
            return;
        }
        if ('user' in values) {
            let bootstrapUser = values['user'];
            let userForComparison = Object.assign(Object.assign({}, user), {
                analyticsOnlyMetadata: undefined,
                privateAttributes: undefined
            });
            if ((_c = this._options) === null || _c === void 0 ? void 0 : _c.disableStableID) {
                userForComparison = Object.assign(Object.assign({}, userForComparison), {
                    customIDs: Object.assign(Object.assign({}, userForComparison.customIDs), {
                        stableID: undefined
                    })
                });
                bootstrapUser = Object.assign(Object.assign({}, bootstrapUser), {
                    customIDs: Object.assign(Object.assign({}, bootstrapUser.customIDs), {
                        stableID: undefined
                    })
                });
            }
            if ((0, $9VR6c._getFullUserHash)(userForComparison) !== (0, $9VR6c._getFullUserHash)(bootstrapUser)) this._warnings.add('PartialUserMatch');
        }
    }
    getCurrentSourceDetails() {
        if (this._source === 'Uninitialized' || this._source === 'NoValues') return {
            reason: this._source
        };
        const sourceDetails = {
            reason: this._source,
            lcut: this._lcut,
            receivedAt: this._receivedAt
        };
        if (this._warnings.size > 0) sourceDetails.warnings = Array.from(this._warnings);
        return sourceDetails;
    }
    _getDetails(isUnrecognized) {
        var _a, _b;
        const sourceDetails = this.getCurrentSourceDetails();
        let reason = sourceDetails.reason;
        const warnings = (_a = sourceDetails.warnings) !== null && _a !== void 0 ? _a : [];
        if (this._source === 'Bootstrap' && warnings.length > 0) reason = reason + warnings[0];
        if (reason !== 'Uninitialized' && reason !== 'NoValues') {
            const subreason = isUnrecognized ? 'Unrecognized' : 'Recognized';
            reason = `${reason}:${subreason}`;
        }
        const bootstrapMetadata = this._source === 'Bootstrap' ? (_b = this._bootstrapMetadata) !== null && _b !== void 0 ? _b : undefined : undefined;
        if (bootstrapMetadata) sourceDetails.bootstrapMetadata = bootstrapMetadata;
        return Object.assign(Object.assign({}, sourceDetails), {
            reason: reason
        });
    }
}
module.exports.default = $a8266ad1662a75da$var$EvaluationStore;

});
parcelRegister("5vLe4", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.V1InitializeContainer = void 0;

var $9VR6c = parcelRequire("9VR6c");
class $40347b108a4c7461$var$V1InitializeContainer {
    constructor(_values){
        this._values = _values;
    }
    getGate(name) {
        return this._getResultFromLookup(this._values.feature_gates, name);
    }
    getConfig(name) {
        return this._getResultFromLookup(this._values.dynamic_configs, name);
    }
    getLayer(name) {
        return this._getResultFromLookup(this._values.layer_configs, name);
    }
    getParamStore(name) {
        return this._getResultFromLookup(this._values.param_stores, name);
    }
    getConfigList() {
        return Object.keys(this._values.dynamic_configs);
    }
    getExposureMapping() {
        return this._values.exposures;
    }
    _getResultFromLookup(lookup, name) {
        var _a, _b;
        if (!lookup) return null;
        return (_b = (_a = lookup[name]) !== null && _a !== void 0 ? _a : lookup[(0, $9VR6c._DJB2)(name)]) !== null && _b !== void 0 ? _b : null;
    }
}
module.exports.V1InitializeContainer = $40347b108a4c7461$var$V1InitializeContainer;

});

parcelRegister("7eiGh", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.V2InitializeContainer = void 0;

var $9VR6c = parcelRequire("9VR6c");
class $543854d8f9a6d11a$var$V2InitializeContainer {
    constructor(_values){
        this._values = _values;
    }
    getGate(name) {
        var _a, _b, _c;
        const evalV2 = this._getResultFromLookup(this._values.feature_gates, name);
        if (!evalV2) return null;
        return {
            name: name,
            value: evalV2.v === true,
            rule_id: (_a = evalV2.r) !== null && _a !== void 0 ? _a : 'default',
            secondary_exposures: (_b = evalV2.s) !== null && _b !== void 0 ? _b : [],
            id_type: (_c = evalV2.i) !== null && _c !== void 0 ? _c : ''
        };
    }
    getConfig(name) {
        var _a, _b, _c, _d;
        const evalV2 = this._getResultFromLookup(this._values.dynamic_configs, name);
        if (!evalV2) return null;
        return {
            name: name,
            value: (_a = this._values.values[evalV2.v]) !== null && _a !== void 0 ? _a : {},
            rule_id: evalV2.r,
            secondary_exposures: (_b = evalV2.s) !== null && _b !== void 0 ? _b : [],
            id_type: (_c = evalV2.i) !== null && _c !== void 0 ? _c : '',
            is_user_in_experiment: evalV2.ue === true ? true : false,
            passed: evalV2.p === true,
            group_name: (_d = evalV2.gn) !== null && _d !== void 0 ? _d : undefined,
            is_experiment_active: evalV2.ea === true ? true : false,
            group: evalV2.r,
            is_device_based: evalV2.i === 'stableID'
        };
    }
    getLayer(name) {
        var _a, _b, _c, _d, _e, _f;
        const evalV2 = this._getResultFromLookup(this._values.layer_configs, name);
        if (!evalV2) return null;
        return {
            name: name,
            value: (_a = this._values.values[evalV2.v]) !== null && _a !== void 0 ? _a : {},
            rule_id: evalV2.r,
            secondary_exposures: (_b = evalV2.s) !== null && _b !== void 0 ? _b : [],
            is_user_in_experiment: evalV2.ue === true ? true : false,
            group_name: (_c = evalV2.gn) !== null && _c !== void 0 ? _c : undefined,
            is_experiment_active: evalV2.ea === true ? true : false,
            group: evalV2.r,
            is_device_based: evalV2.i === 'stableID',
            allocated_experiment_name: (_d = evalV2.ae) !== null && _d !== void 0 ? _d : '',
            explicit_parameters: (_e = evalV2.ep) !== null && _e !== void 0 ? _e : [],
            undelegated_secondary_exposures: (_f = evalV2.us) !== null && _f !== void 0 ? _f : [],
            parameter_rule_ids: evalV2.pr
        };
    }
    getParamStore(name) {
        return this._getResultFromLookup(this._values.param_stores, name);
    }
    getConfigList() {
        return Object.keys(this._values.dynamic_configs);
    }
    getExposureMapping() {
        return this._values.exposures;
    }
    _getResultFromLookup(lookup, name) {
        var _a, _b;
        if (!lookup) return null;
        return (_b = (_a = lookup[name]) !== null && _a !== void 0 ? _a : lookup[(0, $9VR6c._DJB2)(name)]) !== null && _b !== void 0 ? _b : null;
    }
}
module.exports.V2InitializeContainer = $543854d8f9a6d11a$var$V2InitializeContainer;

});


parcelRegister("fmin1", function(module, exports) {
"use strict";
var $b2e72913108a51ad$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $9VR6c = parcelRequire("9VR6c");

var $hIbwg = parcelRequire("hIbwg");
class $b2e72913108a51ad$var$StatsigNetwork extends $9VR6c.NetworkCore {
    constructor(options, emitter){
        super(options, emitter);
        const config = options === null || options === void 0 ? void 0 : options.networkConfig;
        this._option = options;
        this._initializeUrlConfig = new $9VR6c.UrlConfiguration($9VR6c.Endpoint._initialize, config === null || config === void 0 ? void 0 : config.initializeUrl, config === null || config === void 0 ? void 0 : config.api, config === null || config === void 0 ? void 0 : config.initializeFallbackUrls);
    }
    fetchEvaluations(sdkKey, current, priority, user, isCacheValidFor204) {
        return $b2e72913108a51ad$var$__awaiter(this, void 0, void 0, function*() {
            var _a, _b, _c, _d, _e, _f;
            const cache = current ? (0, $9VR6c._typedJsonParse)(current, 'has_updates', 'InitializeResponse') : null;
            let data = {
                user: user,
                hash: (_c = (_b = (_a = this._option) === null || _a === void 0 ? void 0 : _a.networkConfig) === null || _b === void 0 ? void 0 : _b.initializeHashAlgorithm) !== null && _c !== void 0 ? _c : 'djb2',
                deltasResponseRequested: false,
                full_checksum: null
            };
            if (cache === null || cache === void 0 ? void 0 : cache.has_updates) {
                const hasHashChanged = (cache === null || cache === void 0 ? void 0 : cache.hash_used) !== ((_f = (_e = (_d = this._option) === null || _d === void 0 ? void 0 : _d.networkConfig) === null || _e === void 0 ? void 0 : _e.initializeHashAlgorithm) !== null && _f !== void 0 ? _f : 'djb2');
                data = Object.assign(Object.assign({}, data), {
                    sinceTime: isCacheValidFor204 && !hasHashChanged ? cache.time : 0,
                    previousDerivedFields: 'derived_fields' in cache && isCacheValidFor204 ? cache.derived_fields : {},
                    deltasResponseRequested: true,
                    full_checksum: cache.full_checksum,
                    partialUserMatchSinceTime: !hasHashChanged ? cache.time : 0
                });
            }
            return this._fetchEvaluations(sdkKey, cache, data, priority);
        });
    }
    _fetchEvaluations(sdkKey, cache, data, priority) {
        return $b2e72913108a51ad$var$__awaiter(this, void 0, void 0, function*() {
            var _a, _b;
            const response = yield this.post({
                sdkKey: sdkKey,
                urlConfig: this._initializeUrlConfig,
                data: data,
                retries: 2,
                isStatsigEncodable: true,
                priority: priority
            });
            if ((response === null || response === void 0 ? void 0 : response.code) === 204) return '{"has_updates": false}';
            if ((response === null || response === void 0 ? void 0 : response.code) !== 200) return (_a = response === null || response === void 0 ? void 0 : response.body) !== null && _a !== void 0 ? _a : null;
            if ((cache === null || cache === void 0 ? void 0 : cache.has_updates) !== true || ((_b = response.body) === null || _b === void 0 ? void 0 : _b.includes('"is_delta":true')) !== true || data.deltasResponseRequested !== true) return response.body;
            const result = (0, $hIbwg._resolveDeltasResponse)(cache, response.body);
            if (typeof result === 'string') return result;
            // retry without deltas
            return this._fetchEvaluations(sdkKey, cache, Object.assign(Object.assign(Object.assign({}, data), result), {
                deltasResponseRequested: false
            }), priority);
        });
    }
}
module.exports.default = $b2e72913108a51ad$var$StatsigNetwork;

});
parcelRegister("hIbwg", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._resolveDeltasResponse = void 0;

var $9VR6c = parcelRequire("9VR6c");
const $ce4f7b38576ae496$var$MAX_DELTAS_SORT_DEPTH = 2;
function $ce4f7b38576ae496$var$_resolveDeltasResponse(cache, deltasString) {
    const deltas = (0, $9VR6c._typedJsonParse)(deltasString, 'checksum', 'DeltasEvaluationResponse');
    if (!deltas) return {
        hadBadDeltaChecksum: true
    };
    const merged = $ce4f7b38576ae496$var$_mergeDeltasIntoCache(cache, deltas);
    const resolved = $ce4f7b38576ae496$var$_handleDeletedEntries(merged);
    const actualChecksum = (0, $9VR6c._DJB2Object)({
        feature_gates: resolved.feature_gates,
        dynamic_configs: resolved.dynamic_configs,
        layer_configs: resolved.layer_configs
    }, $ce4f7b38576ae496$var$MAX_DELTAS_SORT_DEPTH);
    const isMatch = actualChecksum === deltas.checksumV2;
    if (!isMatch) return {
        hadBadDeltaChecksum: true,
        badChecksum: actualChecksum,
        badMergedConfigs: resolved,
        badFullResponse: deltas.deltas_full_response
    };
    return JSON.stringify(resolved);
}
module.exports._resolveDeltasResponse = $ce4f7b38576ae496$var$_resolveDeltasResponse;
function $ce4f7b38576ae496$var$_mergeDeltasIntoCache(cache, deltas) {
    return Object.assign(Object.assign(Object.assign({}, cache), deltas), {
        feature_gates: Object.assign(Object.assign({}, cache.feature_gates), deltas.feature_gates),
        layer_configs: Object.assign(Object.assign({}, cache.layer_configs), deltas.layer_configs),
        dynamic_configs: Object.assign(Object.assign({}, cache.dynamic_configs), deltas.dynamic_configs)
    });
}
function $ce4f7b38576ae496$var$_handleDeletedEntries(deltas) {
    const result = deltas;
    $ce4f7b38576ae496$var$_deleteEntriesInRecord(deltas.deleted_gates, result.feature_gates);
    delete result.deleted_gates;
    $ce4f7b38576ae496$var$_deleteEntriesInRecord(deltas.deleted_configs, result.dynamic_configs);
    delete result.deleted_configs;
    $ce4f7b38576ae496$var$_deleteEntriesInRecord(deltas.deleted_layers, result.layer_configs);
    delete result.deleted_layers;
    return result;
}
function $ce4f7b38576ae496$var$_deleteEntriesInRecord(keys, values) {
    keys === null || keys === void 0 || keys.forEach((key)=>{
        delete values[key];
    });
}

});


parcelRegister("l1Iiv", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._makeParamStoreGetter = void 0;

var $9VR6c = parcelRequire("9VR6c");
const $f4ec0d8786294f21$var$NO_EXPOSURE_OPT = {
    disableExposureLog: true
};
function $f4ec0d8786294f21$var$_shouldLogExposure(options) {
    return options == null || options.disableExposureLog === false;
}
function $f4ec0d8786294f21$var$_shouldReturnFallback(value, fallback) {
    return fallback != null && !(0, $9VR6c._isTypeMatch)(value, fallback);
}
function $f4ec0d8786294f21$var$_getMappedStaticValue(param, _options) {
    return param.value;
}
function $f4ec0d8786294f21$var$_getMappedGateValue(client, param, options) {
    const gate = client.getFeatureGate(param.gate_name, $f4ec0d8786294f21$var$_shouldLogExposure(options) ? undefined : $f4ec0d8786294f21$var$NO_EXPOSURE_OPT);
    if (gate.value) return param.pass_value;
    return param.fail_value;
}
function $f4ec0d8786294f21$var$_getMappedDynamicConfigValue(client, param, fallback, options) {
    const config = client.getDynamicConfig(param.config_name, $f4ec0d8786294f21$var$_shouldLogExposure(options) ? undefined : $f4ec0d8786294f21$var$NO_EXPOSURE_OPT);
    const value = config.get(param.param_name);
    if ($f4ec0d8786294f21$var$_shouldReturnFallback(value, fallback)) return fallback;
    return value;
}
function $f4ec0d8786294f21$var$_getMappedExperimentValue(client, param, fallback, options) {
    const experiment = client.getExperiment(param.experiment_name, $f4ec0d8786294f21$var$_shouldLogExposure(options) ? undefined : $f4ec0d8786294f21$var$NO_EXPOSURE_OPT);
    const value = experiment.get(param.param_name);
    if ($f4ec0d8786294f21$var$_shouldReturnFallback(value, fallback)) return fallback;
    return value;
}
function $f4ec0d8786294f21$var$_getMappedLayerValue(client, param, fallback, options) {
    const layer = client.getLayer(param.layer_name, $f4ec0d8786294f21$var$_shouldLogExposure(options) ? undefined : $f4ec0d8786294f21$var$NO_EXPOSURE_OPT);
    const value = layer.get(param.param_name);
    if ($f4ec0d8786294f21$var$_shouldReturnFallback(value, fallback)) return fallback;
    return value;
}
function $f4ec0d8786294f21$var$_makeParamStoreGetter(client, config, options) {
    return (paramName, fallback)=>{
        if (config == null) return fallback;
        const param = config[paramName];
        if (param == null || fallback != null && (0, $9VR6c._typeOf)(fallback) !== param.param_type) return fallback;
        switch(param.ref_type){
            case 'static':
                return $f4ec0d8786294f21$var$_getMappedStaticValue(param, options);
            case 'gate':
                return $f4ec0d8786294f21$var$_getMappedGateValue(client, param, options);
            case 'dynamic_config':
                return $f4ec0d8786294f21$var$_getMappedDynamicConfigValue(client, param, fallback, options);
            case 'experiment':
                return $f4ec0d8786294f21$var$_getMappedExperimentValue(client, param, fallback, options);
            case 'layer':
                return $f4ec0d8786294f21$var$_getMappedLayerValue(client, param, fallback, options);
            default:
                return fallback;
        }
    };
}
module.exports._makeParamStoreGetter = $f4ec0d8786294f21$var$_makeParamStoreGetter;

});

parcelRegister("kk2vN", function(module, exports) {
"use strict";
var $ecb79fb6d00fca7c$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.StatsigEvaluationsDataAdapter = void 0;

var $9VR6c = parcelRequire("9VR6c");

var $fmin1 = parcelRequire("fmin1");
class $ecb79fb6d00fca7c$var$StatsigEvaluationsDataAdapter extends $9VR6c.DataAdapterCore {
    constructor(){
        super('EvaluationsDataAdapter', 'evaluations');
        this._network = null;
        this._options = null;
    }
    attach(sdkKey, options, network) {
        super.attach(sdkKey, options, network);
        if (network !== null && network instanceof $fmin1.default) this._network = network;
        else this._network = new $fmin1.default(options !== null && options !== void 0 ? options : {});
    }
    getDataAsync(current, user, options) {
        return this._getDataAsyncImpl(current, (0, $9VR6c._normalizeUser)(user, this._options), options);
    }
    prefetchData(user, options) {
        return this._prefetchDataImpl(user, options);
    }
    setData(data) {
        const values = (0, $9VR6c._typedJsonParse)(data, 'has_updates', 'data');
        if (values && 'user' in values) super.setData(data, values.user);
        else $9VR6c.Log.error('StatsigUser not found. You may be using an older server SDK version. Please upgrade your SDK or use setDataLegacy.');
    }
    setDataLegacy(data, user) {
        super.setData(data, user);
    }
    _fetchFromNetwork(current, user, options, isCacheValidFor204) {
        return $ecb79fb6d00fca7c$var$__awaiter(this, void 0, void 0, function*() {
            var _a;
            const result = yield (_a = this._network) === null || _a === void 0 ? void 0 : _a.fetchEvaluations(this._getSdkKey(), current, options === null || options === void 0 ? void 0 : options.priority, user, isCacheValidFor204);
            return result !== null && result !== void 0 ? result : null;
        });
    }
    _getCacheKey(user) {
        var _a;
        const key = (0, $9VR6c._getStorageKey)(this._getSdkKey(), user, (_a = this._options) === null || _a === void 0 ? void 0 : _a.customUserCacheKeyFunc);
        return `${$9VR6c.DataAdapterCachePrefix}.${this._cacheSuffix}.${key}`;
    }
    _isCachedResultValidFor204(result, user) {
        return result.fullUserHash != null && result.fullUserHash === (0, $9VR6c._getFullUserHash)(user);
    }
}
module.exports.StatsigEvaluationsDataAdapter = $ecb79fb6d00fca7c$var$StatsigEvaluationsDataAdapter;

});



parcelRegister("cPVi9", function(module, exports) {
$parcel$export(module.exports, "default", () => $9586b06436bef89e$export$2e2bcd8739ae039);

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $25nEq = parcelRequire("25nEq");

var $hLfKH = parcelRequire("hLfKH");
function $9586b06436bef89e$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $9586b06436bef89e$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $9586b06436bef89e$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $9586b06436bef89e$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $9586b06436bef89e$export$a66cbd9b2289cd78 = '@all-features';
var $9586b06436bef89e$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function Subscriptions() {
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, Subscriptions);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "eventToValue", new Map());
        this.emitter = new (0, (/*@__PURE__*/$parcel$interopDefault($hLfKH)))();
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(Subscriptions, [
        {
            key: "onGateUpdated",
            value: function onGateUpdated(gateName, callback, checkGate, options) {
                var _this = this;
                var value = checkGate(gateName, $9586b06436bef89e$var$_objectSpread($9586b06436bef89e$var$_objectSpread({}, options), {}, {
                    fireGateExposure: false
                }));
                if (this.eventToValue.get(callback) === undefined) this.eventToValue.set(callback, value);
                var wrapCallback = function wrapCallback() {
                    var value = checkGate(gateName, $9586b06436bef89e$var$_objectSpread($9586b06436bef89e$var$_objectSpread({}, options), {}, {
                        fireGateExposure: false
                    }));
                    var existingValue = _this.eventToValue.get(callback);
                    if (existingValue !== value) {
                        _this.eventToValue.set(callback, value);
                        callback(value);
                    }
                };
                this.emitter.on(gateName, wrapCallback);
                return function() {
                    _this.emitter.off(gateName, wrapCallback);
                };
            }
        },
        {
            key: "onExperimentValueUpdated",
            value: function onExperimentValueUpdated(experimentName, parameterName, defaultValue, callback, getExperimentValue, options) {
                var _this2 = this;
                var experimentEventName = "".concat(experimentName, ".").concat(parameterName);
                var value = getExperimentValue(experimentName, parameterName, defaultValue, $9586b06436bef89e$var$_objectSpread($9586b06436bef89e$var$_objectSpread({}, options), {}, {
                    fireExperimentExposure: false
                }));
                if (this.eventToValue.get(callback) === undefined) this.eventToValue.set(callback, value);
                var wrapCallback = function wrapCallback() {
                    var value = getExperimentValue(experimentName, parameterName, defaultValue, $9586b06436bef89e$var$_objectSpread($9586b06436bef89e$var$_objectSpread({}, options), {}, {
                        fireExperimentExposure: false
                    }));
                    var existingValue = _this2.eventToValue.get(callback);
                    if (existingValue !== value) {
                        _this2.eventToValue.set(callback, value);
                        callback(value);
                    }
                };
                this.emitter.on(experimentEventName, wrapCallback);
                return function() {
                    _this2.emitter.off(experimentEventName, wrapCallback);
                };
            }
        },
        {
            key: "onAnyUpdated",
            value: function onAnyUpdated(callback) {
                var _this3 = this;
                this.emitter.on($9586b06436bef89e$export$a66cbd9b2289cd78, callback);
                return function() {
                    _this3.emitter.off($9586b06436bef89e$export$a66cbd9b2289cd78, callback);
                };
            }
        },
        {
            key: "anyUpdated",
            value: function anyUpdated() {
                var _this4 = this;
                this.emitter.emit($9586b06436bef89e$export$a66cbd9b2289cd78);
                this.emitter.eventNames().filter(function(name) {
                    return name !== $9586b06436bef89e$export$a66cbd9b2289cd78;
                }).forEach(function(event) {
                    _this4.emitter.emit(event);
                });
            }
        }
    ]);
}();

});

parcelRegister("ZoIdE", function(module, exports) {
$parcel$export(module.exports, "DynamicConfig", () => $0b88ddf34124df2e$export$6dc24881a3d96325);

var $ekGgq = parcelRequire("ekGgq");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $cZJuM = parcelRequire("cZJuM");
var $0b88ddf34124df2e$export$6dc24881a3d96325 = /*#__PURE__*/ function() {
    function DynamicConfig(configName, configValue, ruleID, evaluationDetails) {
        var secondaryExposures = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : [];
        var allocatedExperimentName = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : '';
        var onDefaultValueFallback = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : null;
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, DynamicConfig);
        this.value = configValue;
        this._name = configName;
        this._ruleID = ruleID;
        this._secondaryExposures = secondaryExposures;
        this._allocatedExperimentName = allocatedExperimentName;
        this._evaluationDetails = evaluationDetails;
        this._onDefaultValueFallback = onDefaultValueFallback;
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(DynamicConfig, [
        {
            key: "get",
            value: function get(key, defaultValue, typeGuard) {
                var _this$_onDefaultValue2;
                var val = this.getValue(key, defaultValue);
                if (val == null) return defaultValue;
                var expectedType = Array.isArray(defaultValue) ? 'array' : (0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(defaultValue);
                var actualType = Array.isArray(val) ? 'array' : (0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(val);
                if (typeGuard) {
                    var _this$_onDefaultValue;
                    if (typeGuard(val)) {
                        this.fireExposure(key);
                        return val;
                    }
                    (_this$_onDefaultValue = this._onDefaultValueFallback) === null || _this$_onDefaultValue === void 0 || _this$_onDefaultValue.call(this, this, key, expectedType, actualType);
                    return defaultValue;
                }
                if (defaultValue == null || expectedType === actualType) {
                    this.fireExposure(key);
                    return val;
                }
                (_this$_onDefaultValue2 = this._onDefaultValueFallback) === null || _this$_onDefaultValue2 === void 0 || _this$_onDefaultValue2.call(this, this, key, expectedType, actualType);
                return defaultValue;
            }
        },
        {
            key: "getValue",
            value: function getValue(key, defaultValue) {
                if (key == null) return this.value;
                if (defaultValue == null) defaultValue = null;
                if (this.value[key] == null) return defaultValue;
                this.fireExposure(key);
                return this.value[key];
            }
        },
        {
            key: "fireExposure",
            value: function fireExposure(key) {
                // Call the wrapped experiment's get method to fire exposure
                if (this.experiment) this.experiment.get(key);
            }
        }
    ], [
        {
            key: "fromExperiment",
            value: function fromExperiment(experiment) {
                var _experiment$__evaluat, _experiment$__evaluat2, _experiment$groupName;
                var config = new DynamicConfig(experiment.name, experiment.value, experiment.ruleID, (0, $cZJuM.migrateEvaluationDetails)(experiment.details), (0, $cZJuM.migrateSecondaryExposures)((_experiment$__evaluat = (_experiment$__evaluat2 = experiment.__evaluation) === null || _experiment$__evaluat2 === void 0 ? void 0 : _experiment$__evaluat2.secondary_exposures) !== null && _experiment$__evaluat !== void 0 ? _experiment$__evaluat : []), (_experiment$groupName = experiment.groupName) !== null && _experiment$groupName !== void 0 ? _experiment$groupName : undefined);
                config.experiment = experiment;
                return config;
            }
        }
    ]);
}();

});
parcelRegister("cZJuM", function(module, exports) {
$parcel$export(module.exports, "getOptionsWithDefaults", () => $975e7902dc606485$export$d119b37e5f788b43);
$parcel$export(module.exports, "shallowEquals", () => $975e7902dc606485$export$fa1c2bbf4100b8bc);
$parcel$export(module.exports, "toStatsigUser", () => $975e7902dc606485$export$3dad1db244472f32);
$parcel$export(module.exports, "deepAssign", () => $975e7902dc606485$export$1148cb79ceecd5fa);
$parcel$export(module.exports, "migrateInitializationOptions", () => $975e7902dc606485$export$202946b690d26d22);
$parcel$export(module.exports, "migrateEvaluationDetails", () => $975e7902dc606485$export$18ad168d3dbac899);
$parcel$export(module.exports, "migrateSecondaryExposures", () => $975e7902dc606485$export$55fd683752d01e67);

var $1Vcia = parcelRequire("1Vcia");

var $ekGgq = parcelRequire("ekGgq");

var $fC8ib = parcelRequire("fC8ib");

var $iYJcE = parcelRequire("iYJcE");

var $25nEq = parcelRequire("25nEq");

var $ygbGG = parcelRequire("ygbGG");

var $2WRCw = parcelRequire("2WRCw");

var $6zapp = parcelRequire("6zapp");
var $975e7902dc606485$var$_excluded = [
    "api",
    "disableCurrentPageLogging",
    "loggingIntervalMillis",
    "loggingBufferMaxSize",
    "localMode",
    "eventLoggingApi",
    "eventLoggingApiForRetries",
    "disableLocalStorage",
    "ignoreWindowUndefined",
    "disableAllLogging",
    "initTimeoutMs",
    "disableNetworkKeepalive",
    "overrideStableID",
    "disableErrorLogging",
    "disableAutoMetricsLogging"
];
function $975e7902dc606485$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $975e7902dc606485$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $975e7902dc606485$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $975e7902dc606485$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $975e7902dc606485$export$d119b37e5f788b43 = function getOptionsWithDefaults(options) {
    return $975e7902dc606485$var$_objectSpread({
        /**
     * If more federal PerimeterTypes are added in the future, this should be updated so
     * that isFedRamp() === true always returns the strictest perimeter.
     */ perimeter: (0, $ygbGG.isFedRamp)() ? (0, $6zapp.PerimeterType).FEDRAMP_MODERATE : (0, $6zapp.PerimeterType).COMMERCIAL
    }, options);
};
var $975e7902dc606485$export$fa1c2bbf4100b8bc = function shallowEquals(objectA, objectB) {
    if (!objectA && !objectB) return true;
    if (!objectA || !objectB) return false;
    var aEntries = Object.entries(objectA);
    var bEntries = Object.entries(objectB);
    if (aEntries.length !== bEntries.length) return false;
    var ascendingKeyOrder = function ascendingKeyOrder(_ref, _ref2) {
        var _ref3 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_ref, 1), key1 = _ref3[0];
        var _ref4 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_ref2, 1), key2 = _ref4[0];
        return key1.localeCompare(key2);
    };
    aEntries.sort(ascendingKeyOrder);
    bEntries.sort(ascendingKeyOrder);
    for(var i = 0; i < aEntries.length; i++){
        var _aEntries$i = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(aEntries[i], 2), aValue = _aEntries$i[1];
        var _bEntries$i = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(bEntries[i], 2), bValue = _bEntries$i[1];
        if (aValue !== bValue) return false;
    }
    return true;
};
var $975e7902dc606485$export$3dad1db244472f32 = function toStatsigUser(identifiers, customAttributes) {
    var user = {
        customIDs: identifiers,
        custom: customAttributes
    };
    if (identifiers.atlassianAccountId) user.userID = identifiers.atlassianAccountId;
    return user;
};
function $975e7902dc606485$export$1148cb79ceecd5fa(target) {
    for(var _len = arguments.length, sources = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)sources[_key - 1] = arguments[_key];
    if (!sources.length) return target;
    var source = sources.shift();
    if (source === undefined || source === null) return $975e7902dc606485$export$1148cb79ceecd5fa.apply(void 0, [
        target
    ].concat((0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(sources)));
    for(var _i = 0, _Object$entries = Object.entries(source); _i < _Object$entries.length; _i++){
        var _Object$entries$_i = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_Object$entries[_i], 2), key = _Object$entries$_i[0], src = _Object$entries$_i[1];
        var dst = target[key];
        var srcIsObj = src && (0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(src) === 'object' && !Array.isArray(src);
        var dstIsObj = dst && (0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(dst) === 'object' && !Array.isArray(dst);
        if (srcIsObj && dstIsObj) target[key] = $975e7902dc606485$export$1148cb79ceecd5fa(dst, src);
        else target[key] = src;
    }
    return $975e7902dc606485$export$1148cb79ceecd5fa.apply(void 0, [
        target
    ].concat((0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(sources)));
}
var $975e7902dc606485$export$202946b690d26d22 = function migrateInitializationOptions(options) {
    var api = options.api, disableCurrentPageLogging = options.disableCurrentPageLogging, loggingIntervalMillis = options.loggingIntervalMillis, loggingBufferMaxSize = options.loggingBufferMaxSize, localMode = options.localMode, eventLoggingApi = options.eventLoggingApi, eventLoggingApiForRetries = options.eventLoggingApiForRetries, disableLocalStorage = options.disableLocalStorage, ignoreWindowUndefined = options.ignoreWindowUndefined, disableAllLogging = options.disableAllLogging, _initTimeoutMs = options.initTimeoutMs, _disableNetworkKeepalive = options.disableNetworkKeepalive, _overrideStableID = options.overrideStableID, _disableErrorLogging = options.disableErrorLogging, _disableAutoMetricsLogging = options.disableAutoMetricsLogging, rest = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(options, $975e7902dc606485$var$_excluded);
    return $975e7902dc606485$var$_objectSpread($975e7902dc606485$var$_objectSpread({}, rest), {}, {
        networkConfig: {
            api: api,
            logEventUrl: eventLoggingApi ? eventLoggingApi + 'rgstr' : undefined,
            logEventFallbackUrls: eventLoggingApiForRetries ? [
                eventLoggingApiForRetries
            ] : undefined,
            preventAllNetworkTraffic: localMode || !ignoreWindowUndefined && typeof window === 'undefined'
        },
        includeCurrentPageUrlWithEvents: !disableCurrentPageLogging,
        loggingIntervalMs: loggingIntervalMillis,
        loggingBufferMaxSize: loggingBufferMaxSize,
        disableStorage: disableLocalStorage === undefined ? localMode : disableLocalStorage,
        disableLogging: disableAllLogging === undefined ? localMode : disableAllLogging
    });
};
var $975e7902dc606485$var$evaluationReasonMappings = Object.entries((0, $2WRCw.EvaluationReason)).map(function(_ref5) {
    var _ref6 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_ref5, 2), key = _ref6[0], value = _ref6[1];
    return [
        key.toLowerCase(),
        value
    ];
});
var $975e7902dc606485$export$18ad168d3dbac899 = function migrateEvaluationDetails(details) {
    var _evaluationReasonMapp, _evaluationReasonMapp2, _details$receivedAt;
    var reasonLower = details.reason.toLowerCase();
    return {
        reason: (_evaluationReasonMapp = (_evaluationReasonMapp2 = $975e7902dc606485$var$evaluationReasonMappings.find(function(_ref7) {
            var _ref8 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_ref7, 1), key = _ref8[0];
            return reasonLower.includes(key);
        })) === null || _evaluationReasonMapp2 === void 0 ? void 0 : _evaluationReasonMapp2[1]) !== null && _evaluationReasonMapp !== void 0 ? _evaluationReasonMapp : (0, $2WRCw.EvaluationReason).Unknown,
        time: (_details$receivedAt = details.receivedAt) !== null && _details$receivedAt !== void 0 ? _details$receivedAt : Date.now()
    };
};
var $975e7902dc606485$export$55fd683752d01e67 = function migrateSecondaryExposures(secondaryExposures) {
    return secondaryExposures.map(function(exposure) {
        if (typeof exposure === 'string') // This should ideally have gateValue and ruleID fields too, but it's not possible for us
        // to determine the correct values for these.
        return {
            gate: exposure
        };
        return exposure;
    });
};

});
parcelRegister("2WRCw", function(module, exports) {
$parcel$export(module.exports, "EvaluationReason", () => $225a9773e90d17cd$export$c62558b199e46828);
// Reference: https://github.com/statsig-io/js-lite/blob/main/src/StatsigStore.ts
var $225a9773e90d17cd$export$c62558b199e46828 = {
    // Order is important since the logic for migrating from a new client reason to an old one
    // returns the first which is a substring of the new client reason
    Error: 'Error',
    LocalOverride: 'LocalOverride',
    Unrecognized: 'Unrecognized',
    Uninitialized: 'Uninitialized',
    NetworkNotModified: 'NetworkNotModified',
    Network: 'Network',
    InvalidBootstrap: 'InvalidBootstrap',
    Bootstrap: 'Bootstrap',
    Cache: 'Cache',
    // For when we could not migrate the reason from the new client
    Unknown: 'Unknown'
}; // Reference: https://github.com/statsig-io/js-lite/blob/main/src/StatsigSDKOptions.ts

});

parcelRegister("6zapp", function(module, exports) {
$parcel$export(module.exports, "FeatureGateEnvironment", () => $4c7e15f5872a2e69$export$479e7351a733299);
$parcel$export(module.exports, "PerimeterType", () => $4c7e15f5872a2e69$export$c42b7bbc5e7ba555);
/**
 * The identifiers for the user. Options are restricted to the set that is currently supported.
 */ /**
 * Base client options. Does not include any options specific to providers
 * @interface BaseClientOptions
 * @property {FeatureGateEnvironment} environment - The environment for the client.
 * @property {string} targetApp - The target app for the client.
 * @property {AnalyticsWebClient} analyticsWebClient - The analytics web client.
 * @property {PerimeterType} perimeter - The perimeter for the client.
 */ /**
 * The options for the client.
 * @interface ClientOptions
 * @extends {BaseClientOptions}
 * @property {string} apiKey - The API key for the client.
 * @property {fetchTimeoutMs} fetchTimeoutMs - The timeout for the fetch request in milliseconds. Defaults to 5000.
 * @property {boolean} useGatewayURL - Whether to use the gateway URL. Defaults to false.
 */ /**
 * The custom attributes for the user.
 */ var $4c7e15f5872a2e69$export$479e7351a733299 = {
    Development: 'development',
    Staging: 'staging',
    Production: 'production'
};
var $4c7e15f5872a2e69$export$c42b7bbc5e7ba555 = {
    COMMERCIAL: 'commercial',
    FEDRAMP_MODERATE: 'fedramp-moderate'
};
var $4c7e15f5872a2e69$export$42f4885608027d0c = 'non_boolean'; // Type magic to get the JSDoc comments from the Client class methods to appear on the static
 // methods in FeatureGates where the property name and function type are identical

});



parcelRegister("dZL1s", function(module, exports) {
$parcel$export(module.exports, "Layer", () => $a305729166cd0171$export$936d0764594b6eb3);

var $ekGgq = parcelRequire("ekGgq");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $cZJuM = parcelRequire("cZJuM");
var $a305729166cd0171$export$936d0764594b6eb3 = /*#__PURE__*/ function() {
    function Layer(name, layerValue, ruleID, evaluationDetails) {
        var logParameterFunction = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
        var secondaryExposures = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : [];
        var undelegatedSecondaryExposures = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : [];
        var allocatedExperimentName = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : '';
        var explicitParameters = arguments.length > 8 && arguments[8] !== undefined ? arguments[8] : [];
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, Layer);
        this._logParameterFunction = logParameterFunction;
        this._name = name;
        this._value = JSON.parse(JSON.stringify(layerValue !== null && layerValue !== void 0 ? layerValue : {}));
        this._ruleID = ruleID !== null && ruleID !== void 0 ? ruleID : '';
        this._evaluationDetails = evaluationDetails;
        this._secondaryExposures = secondaryExposures;
        this._undelegatedSecondaryExposures = undelegatedSecondaryExposures;
        this._allocatedExperimentName = allocatedExperimentName;
        this._explicitParameters = explicitParameters;
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(Layer, [
        {
            key: "get",
            value: function get(key, defaultValue, typeGuard) {
                var _this = this;
                var val = this._value[key];
                if (val == null) return defaultValue;
                var logAndReturn = function logAndReturn() {
                    _this._logLayerParameterExposure(key);
                    return val;
                };
                if (typeGuard) return typeGuard(val) ? logAndReturn() : defaultValue;
                if (defaultValue == null) return logAndReturn();
                if ((0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(val) === (0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(defaultValue) && Array.isArray(defaultValue) === Array.isArray(val)) return logAndReturn();
                return defaultValue;
            }
        },
        {
            key: "getValue",
            value: function getValue(key, defaultValue) {
                // eslint-disable-next-line eqeqeq
                if (defaultValue == undefined) defaultValue = null;
                var val = this._value[key];
                if (val != null) this._logLayerParameterExposure(key);
                return val !== null && val !== void 0 ? val : defaultValue;
            }
        },
        {
            key: "_logLayerParameterExposure",
            value: function _logLayerParameterExposure(parameterName) {
                var _this$_logParameterFu;
                (_this$_logParameterFu = this._logParameterFunction) === null || _this$_logParameterFu === void 0 || _this$_logParameterFu.call(this, this, parameterName);
            }
        }
    ], [
        {
            key: "fromLayer",
            value: function fromLayer(layer) {
                var _layer$__evaluation$s, _layer$__evaluation, _layer$__evaluation$u, _layer$__evaluation2, _layer$__evaluation3, _layer$__evaluation4;
                var value = new Layer(layer.name, layer.__value, layer.ruleID, (0, $cZJuM.migrateEvaluationDetails)(layer.details), function(_layer, parameterName) {
                    return layer.get(parameterName);
                }, (0, $cZJuM.migrateSecondaryExposures)((_layer$__evaluation$s = (_layer$__evaluation = layer.__evaluation) === null || _layer$__evaluation === void 0 ? void 0 : _layer$__evaluation.secondary_exposures) !== null && _layer$__evaluation$s !== void 0 ? _layer$__evaluation$s : []), (0, $cZJuM.migrateSecondaryExposures)((_layer$__evaluation$u = (_layer$__evaluation2 = layer.__evaluation) === null || _layer$__evaluation2 === void 0 ? void 0 : _layer$__evaluation2.undelegated_secondary_exposures) !== null && _layer$__evaluation$u !== void 0 ? _layer$__evaluation$u : []), (_layer$__evaluation3 = layer.__evaluation) === null || _layer$__evaluation3 === void 0 ? void 0 : _layer$__evaluation3.allocated_experiment_name, (_layer$__evaluation4 = layer.__evaluation) === null || _layer$__evaluation4 === void 0 ? void 0 : _layer$__evaluation4.explicit_parameters);
                return value;
            }
        }
    ]);
}();

});

parcelRegister("3bgjw", function(module, exports) {
$parcel$export(module.exports, "default", () => $250f0dca8756a278$export$2e2bcd8739ae039);

var $25nEq = parcelRequire("25nEq");

var $fL8KA = parcelRequire("fL8KA");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $6HG4S = parcelRequire("6HG4S");

var $6zapp = parcelRequire("6zapp");

var $2D0Es = parcelRequire("2D0Es");

var $8VzB6 = parcelRequire("8VzB6");
function $250f0dca8756a278$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $250f0dca8756a278$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $250f0dca8756a278$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $250f0dca8756a278$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $250f0dca8756a278$var$DEFAULT_REQUEST_TIMEOUT_MS = 5000;
var $250f0dca8756a278$export$250a58ecde616daa = 'https://api.atlassian.com/flags';
var $250f0dca8756a278$export$942ba04389b0d5a2 = 'https://api.stg.atlassian.com/flags';
var $250f0dca8756a278$export$f058dbf75c3bc647 = 'https://api.dev.atlassian.com/flags';
var $250f0dca8756a278$export$1a401a0da8da3565 = 'https://api.stg.atlassian-us-gov-mod.com/flags';
var $250f0dca8756a278$export$18c93900db9358a4 = 'https://api.atlassian-us-gov-mod.com/flags';
var $250f0dca8756a278$export$4e8a0415edbfa1f7 = 'https://atlassian-statsig-proxy-archetype.atl-paas.%s.atl-ic.net';
var $250f0dca8756a278$export$cb3cd156f70d7e94 = 'oasis-stg.com/flags';
var $250f0dca8756a278$export$921fbc6cdfd4eee0 = 'atlassian-isolated.net/flags';
var $250f0dca8756a278$export$450bd8fb2a6d7ace = '/gateway/api/flags';
var $250f0dca8756a278$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function Fetcher() {
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, Fetcher);
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(Fetcher, null, [
        {
            key: "fetchClientSdk",
            value: function() {
                var _fetchClientSdk = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee(fetcherOptions) {
                    var targetApp, url;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee$(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                targetApp = fetcherOptions.targetApp;
                                url = "/api/v2/frontend/clientSdkKey/".concat(targetApp);
                                _context.prev = 2;
                                _context.next = 5;
                                return this.fetchRequest(url, 'GET', fetcherOptions);
                            case 5:
                                return _context.abrupt("return", _context.sent);
                            case 8:
                                _context.prev = 8;
                                _context.t0 = _context["catch"](2);
                                if (!(_context.t0 instanceof Error)) {
                                    _context.next = 12;
                                    break;
                                }
                                throw _context.t0;
                            case 12:
                                throw Error('Failed to retrieve client sdk key');
                            case 13:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee, this, [
                        [
                            2,
                            8
                        ]
                    ]);
                }));
                function fetchClientSdk(_x) {
                    return _fetchClientSdk.apply(this, arguments);
                }
                return fetchClientSdk;
            }()
        },
        {
            key: "fetchExperimentValues",
            value: function() {
                var _fetchExperimentValues = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee2(fetcherOptions, identifiers, customAttributes) {
                    var requestBody;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee2$(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                requestBody = {
                                    identifiers: identifiers,
                                    customAttributes: customAttributes,
                                    targetApp: fetcherOptions.targetApp
                                };
                                _context2.prev = 1;
                                _context2.next = 4;
                                return this.fetchRequest('/api/v2/frontend/experimentValues', 'POST', fetcherOptions, requestBody);
                            case 4:
                                return _context2.abrupt("return", _context2.sent);
                            case 7:
                                _context2.prev = 7;
                                _context2.t0 = _context2["catch"](1);
                                if (!(_context2.t0 instanceof Error)) {
                                    _context2.next = 11;
                                    break;
                                }
                                throw _context2.t0;
                            case 11:
                                throw Error('Failed to retrieve experiment values');
                            case 12:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2, this, [
                        [
                            1,
                            7
                        ]
                    ]);
                }));
                function fetchExperimentValues(_x2, _x3, _x4) {
                    return _fetchExperimentValues.apply(this, arguments);
                }
                return fetchExperimentValues;
            }()
        },
        {
            key: "handleResponseError",
            value: function() {
                var _handleResponseError = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee3(response) {
                    var body;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee3$(_context3) {
                        while(true)switch(_context3.prev = _context3.next){
                            case 0:
                                if (response.ok) {
                                    _context3.next = 5;
                                    break;
                                }
                                _context3.next = 3;
                                return response.text();
                            case 3:
                                body = _context3.sent;
                                throw new (0, $8VzB6.ResponseError)("Non 2xx response status received, status: ".concat(response.status, ", body: ").concat(JSON.stringify(body)));
                            case 5:
                                if (!(response.status === 204)) {
                                    _context3.next = 7;
                                    break;
                                }
                                throw new (0, $8VzB6.ResponseError)('Unexpected 204 response');
                            case 7:
                            case "end":
                                return _context3.stop();
                        }
                    }, _callee3);
                }));
                function handleResponseError(_x5) {
                    return _handleResponseError.apply(this, arguments);
                }
                return handleResponseError;
            }()
        },
        {
            key: "extractResponseBody",
            value: function() {
                var _extractResponseBody = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee4(response) {
                    var value;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee4$(_context4) {
                        while(true)switch(_context4.prev = _context4.next){
                            case 0:
                                _context4.next = 2;
                                return response.text();
                            case 2:
                                value = _context4.sent;
                                return _context4.abrupt("return", JSON.parse(value));
                            case 4:
                            case "end":
                                return _context4.stop();
                        }
                    }, _callee4);
                }));
                function extractResponseBody(_x6) {
                    return _extractResponseBody.apply(this, arguments);
                }
                return extractResponseBody;
            }()
        },
        {
            key: "getBaseUrl",
            value: function getBaseUrl(serviceEnv) {
                var useGatewayUrl = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
                var perimeter = arguments.length > 2 ? arguments[2] : undefined;
                var isolationContextId = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
                if (useGatewayUrl) return $250f0dca8756a278$export$450bd8fb2a6d7ace;
                if (perimeter === (0, $6zapp.PerimeterType).FEDRAMP_MODERATE) switch(serviceEnv){
                    case (0, $6zapp.FeatureGateEnvironment).Production:
                        return $250f0dca8756a278$export$18c93900db9358a4;
                    case (0, $6zapp.FeatureGateEnvironment).Staging:
                        return $250f0dca8756a278$export$1a401a0da8da3565;
                    default:
                        throw new Error("Invalid environment \"".concat(serviceEnv, "\" for \"").concat(perimeter, "\" perimeter"));
                }
                else if (perimeter === (0, $6zapp.PerimeterType).COMMERCIAL) switch(serviceEnv){
                    case (0, $6zapp.FeatureGateEnvironment).Development:
                        return $250f0dca8756a278$export$f058dbf75c3bc647;
                    case (0, $6zapp.FeatureGateEnvironment).Staging:
                        var apiUrl = this.getApiUrl(isolationContextId);
                        if (apiUrl !== null) return apiUrl;
                        return $250f0dca8756a278$export$942ba04389b0d5a2;
                    default:
                        var prodApiUrl = this.getApiUrl(isolationContextId);
                        if (prodApiUrl !== null) return prodApiUrl;
                        return $250f0dca8756a278$export$250a58ecde616daa;
                }
                else throw new Error("Invalid perimeter \"".concat(perimeter, "\""));
            }
        },
        {
            key: "fetchRequest",
            value: function() {
                var _fetchRequest = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee5(path, method, fetcherOptions, body) {
                    var baseUrl, fetchTimeout, abortSignal, abortController, response;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee5$(_context5) {
                        while(true)switch(_context5.prev = _context5.next){
                            case 0:
                                baseUrl = Fetcher.getBaseUrl(fetcherOptions.environment, fetcherOptions.useGatewayURL, fetcherOptions.perimeter, fetcherOptions.isolationContextId);
                                fetchTimeout = fetcherOptions.fetchTimeoutMs || $250f0dca8756a278$var$DEFAULT_REQUEST_TIMEOUT_MS;
                                if (AbortSignal.timeout) abortSignal = AbortSignal.timeout(fetchTimeout);
                                else if (AbortController) {
                                    abortController = new AbortController();
                                    abortSignal = abortController.signal;
                                    setTimeout(function() {
                                        return abortController.abort();
                                    }, fetchTimeout);
                                }
                                _context5.next = 5;
                                return fetch("".concat(baseUrl).concat(path), $250f0dca8756a278$var$_objectSpread({
                                    method: method,
                                    headers: {
                                        'Content-Type': 'application/json',
                                        'X-Client-Name': 'feature-gate-js-client',
                                        'X-Client-Version': (0, $2D0Es.CLIENT_VERSION),
                                        'X-API-KEY': fetcherOptions.apiKey
                                    },
                                    signal: abortSignal
                                }, body && {
                                    body: JSON.stringify(body)
                                }));
                            case 5:
                                response = _context5.sent;
                                _context5.next = 8;
                                return this.handleResponseError(response);
                            case 8:
                                _context5.next = 10;
                                return this.extractResponseBody(response);
                            case 10:
                                return _context5.abrupt("return", _context5.sent);
                            case 11:
                            case "end":
                                return _context5.stop();
                        }
                    }, _callee5, this);
                }));
                function fetchRequest(_x7, _x8, _x9, _x0) {
                    return _fetchRequest.apply(this, arguments);
                }
                return fetchRequest;
            }()
        },
        {
            key: "getApiUrl",
            value: function getApiUrl(isolationContextId) {
                var window1 = this.getWindowLocation();
                if (window1 === undefined) {
                    //this is needed when this SDK is used for SSR or plugin use cases where secret keys not available to use backend SDKs
                    if (!isolationContextId) return null;
                    return $250f0dca8756a278$export$4e8a0415edbfa1f7.replace('%s', isolationContextId);
                }
                var protocol = window1.protocol, hostname = window1.hostname;
                // Match last subdomain fragment before oasis-stg.com
                var oasisMatch = hostname.match(/([^.]+)\.oasis-stg\.com$/);
                if (oasisMatch) return "".concat(protocol, "//api.").concat(oasisMatch[1], ".").concat($250f0dca8756a278$export$cb3cd156f70d7e94);
                // Match last subdomain fragment before atlassian-isolated.net
                var isolatedMatch = hostname.match(/([^.]+)\.atlassian-isolated\.net$/);
                if (isolatedMatch) return "".concat(protocol, "//api.").concat(isolatedMatch[1], ".").concat($250f0dca8756a278$export$921fbc6cdfd4eee0);
                return null;
            }
        },
        {
            key: "getWindowLocation",
            value: function getWindowLocation() {
                if (typeof window !== 'undefined' && window.location) return window.location;
                return undefined;
            }
        }
    ]);
}();

});
parcelRegister("2D0Es", function(module, exports) {
$parcel$export(module.exports, "CLIENT_VERSION", () => $1e9fbaa8aef43a2a$export$a59f8d67326bd1cb);
/// <reference types="node" />
var $1e9fbaa8aef43a2a$export$a59f8d67326bd1cb = "0.0.0-development";

});

parcelRegister("8VzB6", function(module, exports) {
$parcel$export(module.exports, "ResponseError", () => $67ff4280ad904fc0$export$286baf652d0b1206);

var $arMYe = parcelRequire("arMYe");

var $9P61R = parcelRequire("9P61R");

var $kIXpt = parcelRequire("kIXpt");

var $cYPzS = parcelRequire("cYPzS");

var $eyuDe = parcelRequire("eyuDe");

var $c7s0H = parcelRequire("c7s0H");
function $67ff4280ad904fc0$var$_callSuper(t, o, e) {
    return o = (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(o), (0, (/*@__PURE__*/$parcel$interopDefault($kIXpt)))(t, $67ff4280ad904fc0$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(t).constructor) : o.apply(t, e));
}
function $67ff4280ad904fc0$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($67ff4280ad904fc0$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $67ff4280ad904fc0$export$286baf652d0b1206 = /*#__PURE__*/ function(_Error) {
    function ResponseError(message) {
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, ResponseError);
        return $67ff4280ad904fc0$var$_callSuper(this, ResponseError, [
            message
        ]);
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($eyuDe)))(ResponseError, _Error);
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(ResponseError);
}(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($c7s0H)))(Error));

});


parcelRegister("jlkWK", function(module, exports) {
$parcel$export(module.exports, "NoFetchDataAdapter", () => $e1503a0e58764e86$export$55fffef3474104af);

var $fL8KA = parcelRequire("fL8KA");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $kIXpt = parcelRequire("kIXpt");

var $cYPzS = parcelRequire("cYPzS");

var $lwlXp = parcelRequire("lwlXp");

var $eyuDe = parcelRequire("eyuDe");

var $25nEq = parcelRequire("25nEq");

var $6HG4S = parcelRequire("6HG4S");

var $lexmS = parcelRequire("lexmS");
function $e1503a0e58764e86$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $e1503a0e58764e86$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $e1503a0e58764e86$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $e1503a0e58764e86$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $e1503a0e58764e86$var$_callSuper(t, o, e) {
    return o = (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(o), (0, (/*@__PURE__*/$parcel$interopDefault($kIXpt)))(t, $e1503a0e58764e86$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(t).constructor) : o.apply(t, e));
}
function $e1503a0e58764e86$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($e1503a0e58764e86$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $e1503a0e58764e86$var$_superPropGet(t, o, e, r) {
    var p = (0, (/*@__PURE__*/$parcel$interopDefault($lwlXp)))((0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(1 & r ? t.prototype : t), o, e);
    return 2 & r && "function" == typeof p ? function(t) {
        return p.apply(e, t);
    } : p;
}
var $e1503a0e58764e86$export$55fffef3474104af = /*#__PURE__*/ function(_DataAdapterCore) {
    function NoFetchDataAdapter() {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, NoFetchDataAdapter);
        _this = $e1503a0e58764e86$var$_callSuper(this, NoFetchDataAdapter, [
            'NoFetchDataAdapter',
            'nofetch'
        ]);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "bootstrapResult", null);
        return _this;
    }
    /**
   * Make sure to call this **before** calling `initializeAsync` or `updateUserAsync` but
   * after the Statsig client has been created!
   */ (0, (/*@__PURE__*/$parcel$interopDefault($eyuDe)))(NoFetchDataAdapter, _DataAdapterCore);
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(NoFetchDataAdapter, [
        {
            key: "setBootstrapData",
            value: function setBootstrapData(data) {
                this.bootstrapResult = data ? {
                    source: 'Bootstrap',
                    data: JSON.stringify(data),
                    receivedAt: Date.now(),
                    stableID: (0, $lexmS.StableID).get(this._getSdkKey()),
                    fullUserHash: null
                } : null;
            }
        },
        {
            key: "prefetchData",
            value: function() {
                var _prefetchData = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee(_user, _options) {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee$(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee);
                }));
                function prefetchData(_x, _x2) {
                    return _prefetchData.apply(this, arguments);
                }
                return prefetchData;
            }()
        },
        {
            key: "getDataAsync",
            value: function() {
                var _getDataAsync = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee2(_current, user, _options) {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee2$(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                return _context2.abrupt("return", this.bootstrapResult && $e1503a0e58764e86$var$_objectSpread($e1503a0e58764e86$var$_objectSpread({}, this.bootstrapResult), {}, {
                                    fullUserHash: (0, $lexmS._getFullUserHash)(user)
                                }));
                            case 1:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2, this);
                }));
                function getDataAsync(_x3, _x4, _x5) {
                    return _getDataAsync.apply(this, arguments);
                }
                return getDataAsync;
            }()
        },
        {
            key: "getDataSync",
            value: function getDataSync(user) {
                return this.bootstrapResult && $e1503a0e58764e86$var$_objectSpread($e1503a0e58764e86$var$_objectSpread({}, this.bootstrapResult), {}, {
                    fullUserHash: (0, $lexmS._getFullUserHash)(user)
                });
            }
        },
        {
            key: "_fetchFromNetwork",
            value: function() {
                var _fetchFromNetwork2 = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee3(_current, _user, _options) {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee3$(_context3) {
                        while(true)switch(_context3.prev = _context3.next){
                            case 0:
                                return _context3.abrupt("return", null);
                            case 1:
                            case "end":
                                return _context3.stop();
                        }
                    }, _callee3);
                }));
                function _fetchFromNetwork(_x6, _x7, _x8) {
                    return _fetchFromNetwork2.apply(this, arguments);
                }
                return _fetchFromNetwork;
            }()
        },
        {
            key: "_getCacheKey",
            value: function _getCacheKey(user) {
                // Same logic as default data adapter
                // https://github.com/statsig-io/js-client-monorepo/blob/main/packages/js-client/src/StatsigEvaluationsDataAdapter.ts
                var key = (0, $lexmS._getStorageKey)(this._getSdkKey(), user);
                return "".concat((0, $lexmS.DataAdapterCachePrefix), ".").concat(this._cacheSuffix, ".").concat(key);
            }
        },
        {
            key: "_isCachedResultValidFor204",
            value: function _isCachedResultValidFor204(_result, _user) {
                return false;
            }
        },
        {
            key: "setDataLegacy",
            value: function setDataLegacy(data, user) {
                $e1503a0e58764e86$var$_superPropGet(NoFetchDataAdapter, "setData", this, 3)([
                    data,
                    user
                ]);
            }
        },
        {
            key: "toJSON",
            value: function toJSON() {
                var result = $e1503a0e58764e86$var$_objectSpread({}, this);
                delete result._options;
                delete result._inMemoryCache;
                delete result.bootstrapResult;
                return result;
            }
        }
    ]);
}((0, $lexmS.DataAdapterCore));

});

parcelRegister("gJJIF", function(module, exports) {
$parcel$export(module.exports, "LOCAL_STORAGE_KEY", () => $c2f45040bec869b9$export$d8474cff104280f3);
$parcel$export(module.exports, "PersistentOverrideAdapter", () => $c2f45040bec869b9$export$bcb28fbac1def494);

var $25nEq = parcelRequire("25nEq");

var $iYJcE = parcelRequire("iYJcE");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $9VR6c = parcelRequire("9VR6c");
function $c2f45040bec869b9$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $c2f45040bec869b9$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $c2f45040bec869b9$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $c2f45040bec869b9$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $c2f45040bec869b9$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $c2f45040bec869b9$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $c2f45040bec869b9$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $c2f45040bec869b9$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $c2f45040bec869b9$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $c2f45040bec869b9$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
var $c2f45040bec869b9$var$LOCAL_OVERRIDE_REASON = 'LocalOverride:Recognized';
var $c2f45040bec869b9$export$d8474cff104280f3 = 'STATSIG_OVERRIDES';
var $c2f45040bec869b9$var$LEGACY_LOCAL_STORAGE_KEY = 'STATSIG_JS_LITE_LOCAL_OVERRIDES';
var $c2f45040bec869b9$var$makeEmptyStore = function makeEmptyStore() {
    return {
        gates: {},
        configs: {},
        layers: {}
    };
};
var $c2f45040bec869b9$var$djb2MapKey = function djb2MapKey(hash, kind) {
    return kind + ':' + hash;
};
var $c2f45040bec869b9$export$bcb28fbac1def494 = /*#__PURE__*/ function() {
    function PersistentOverrideAdapter(localStorageKey) {
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, PersistentOverrideAdapter);
        this._overrides = $c2f45040bec869b9$var$makeEmptyStore();
        this._djb2Map = new Map();
        this._localStorageKey = localStorageKey;
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(PersistentOverrideAdapter, [
        {
            key: "parseStoredOverrides",
            value: function parseStoredOverrides(localStorageKey) {
                try {
                    var json = window.localStorage.getItem(localStorageKey);
                    if (!json) return $c2f45040bec869b9$var$makeEmptyStore();
                    return JSON.parse(json);
                } catch (_unused) {
                    return $c2f45040bec869b9$var$makeEmptyStore();
                }
            }
        },
        {
            key: "mergeOverrides",
            value: function mergeOverrides() {
                var merged = $c2f45040bec869b9$var$makeEmptyStore();
                for(var _len = arguments.length, allOverrides = new Array(_len), _key = 0; _key < _len; _key++)allOverrides[_key] = arguments[_key];
                for(var _i = 0, _allOverrides = allOverrides; _i < _allOverrides.length; _i++){
                    var overrides = _allOverrides[_i];
                    for(var _i2 = 0, _Object$entries = Object.entries((_overrides$gates = overrides.gates) !== null && _overrides$gates !== void 0 ? _overrides$gates : {}); _i2 < _Object$entries.length; _i2++){
                        var _overrides$gates;
                        var _Object$entries$_i = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_Object$entries[_i2], 2), name = _Object$entries$_i[0], value = _Object$entries$_i[1];
                        merged.gates[name] = value;
                    }
                    for(var _i3 = 0, _Object$entries2 = Object.entries((_overrides$configs = overrides.configs) !== null && _overrides$configs !== void 0 ? _overrides$configs : {}); _i3 < _Object$entries2.length; _i3++){
                        var _overrides$configs;
                        var _Object$entries2$_i = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_Object$entries2[_i3], 2), _name = _Object$entries2$_i[0], _value = _Object$entries2$_i[1];
                        merged.configs[_name] = _value;
                    }
                    for(var _i4 = 0, _Object$entries3 = Object.entries((_overrides$layers = overrides.layers) !== null && _overrides$layers !== void 0 ? _overrides$layers : {}); _i4 < _Object$entries3.length; _i4++){
                        var _overrides$layers;
                        var _Object$entries3$_i = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_Object$entries3[_i4], 2), _name2 = _Object$entries3$_i[0], _value2 = _Object$entries3$_i[1];
                        merged.layers[_name2] = _value2;
                    }
                }
                return merged;
            }
        },
        {
            key: "initFromStoredOverrides",
            value: function initFromStoredOverrides() {
                var storedOverrides = this.mergeOverrides(this._overrides, this.parseStoredOverrides($c2f45040bec869b9$var$LEGACY_LOCAL_STORAGE_KEY), this.parseStoredOverrides(this._localStorageKey));
                // Clear data from legacy local storage key now we've read from it.
                // This prevents things being stuck in there that are always read but never written to.
                try {
                    window.localStorage.removeItem($c2f45040bec869b9$var$LEGACY_LOCAL_STORAGE_KEY);
                } catch (_unused2) {
                // ignored - window is not defined in non-browser environments, and we don't save things there
                // (things like SSR, etc)
                }
                // In version 4.24.0 we introduced hashes in this override adapter, but had a bug which would cause
                // multiple hashes to continue being created. This code here removes these hashes since we've moved
                // to using a more reliable and easier to maintain map in `_djb2Map`.
                for(var _i5 = 0, _Object$values = Object.values(storedOverrides); _i5 < _Object$values.length; _i5++){
                    var container = _Object$values[_i5];
                    var allKeys = new Set(Object.keys(container));
                    var _iterator = $c2f45040bec869b9$var$_createForOfIteratorHelper(allKeys), _step;
                    try {
                        for(_iterator.s(); !(_step = _iterator.n()).done;){
                            var name = _step.value;
                            var hash = (0, $9VR6c._DJB2)(name);
                            if (allKeys.has(hash)) delete container[hash];
                        }
                    } catch (err) {
                        _iterator.e(err);
                    } finally{
                        _iterator.f();
                    }
                }
                this.applyOverrides(storedOverrides);
            }
        },
        {
            key: "saveOverrides",
            value: function saveOverrides() {
                try {
                    window.localStorage.setItem(this._localStorageKey, JSON.stringify(this._overrides));
                } catch (_unused3) {
                // ignored - window is not defined in non-browser environments, and we don't save things there
                // (things like SSR, etc)
                }
            }
        },
        {
            key: "getOverrides",
            value: function getOverrides() {
                return this.mergeOverrides(this._overrides);
            }
        },
        {
            key: "applyOverrides",
            value: function applyOverrides(overrides) {
                var newOverrides = $c2f45040bec869b9$var$_objectSpread($c2f45040bec869b9$var$_objectSpread({}, $c2f45040bec869b9$var$makeEmptyStore()), overrides);
                this._djb2Map.clear();
                for(var _i6 = 0, _Object$entries4 = Object.entries(newOverrides); _i6 < _Object$entries4.length; _i6++){
                    var _Object$entries4$_i = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_Object$entries4[_i6], 2), containerName = _Object$entries4$_i[0], container = _Object$entries4$_i[1];
                    for(var _i7 = 0, _Object$entries5 = Object.entries(container); _i7 < _Object$entries5.length; _i7++){
                        var _Object$entries5$_i = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_Object$entries5[_i7], 2), name = _Object$entries5$_i[0], value = _Object$entries5$_i[1];
                        this._djb2Map.set($c2f45040bec869b9$var$djb2MapKey((0, $9VR6c._DJB2)(name), containerName), value);
                    }
                }
                this._overrides = newOverrides;
            }
        },
        {
            key: "setOverrides",
            value: function setOverrides(overrides) {
                this.applyOverrides(overrides);
                this.saveOverrides();
            }
        },
        {
            key: "overrideGate",
            value: function overrideGate(name, value) {
                this._overrides.gates[name] = value;
                this._djb2Map.set($c2f45040bec869b9$var$djb2MapKey((0, $9VR6c._DJB2)(name), 'gates'), value);
                this.saveOverrides();
            }
        },
        {
            key: "removeGateOverride",
            value: function removeGateOverride(name) {
                delete this._overrides.gates[name];
                this._djb2Map.delete($c2f45040bec869b9$var$djb2MapKey((0, $9VR6c._DJB2)(name), 'gates'));
                this.saveOverrides();
            }
        },
        {
            key: "getGateOverride",
            value: function getGateOverride(current, _user) {
                var _this$_overrides$gate;
                var overridden = (_this$_overrides$gate = this._overrides.gates[current.name]) !== null && _this$_overrides$gate !== void 0 ? _this$_overrides$gate : this._djb2Map.get($c2f45040bec869b9$var$djb2MapKey(current.name, 'gates'));
                if (overridden == null) return null;
                return $c2f45040bec869b9$var$_objectSpread($c2f45040bec869b9$var$_objectSpread({}, current), {}, {
                    value: overridden,
                    details: $c2f45040bec869b9$var$_objectSpread($c2f45040bec869b9$var$_objectSpread({}, current.details), {}, {
                        reason: $c2f45040bec869b9$var$LOCAL_OVERRIDE_REASON
                    })
                });
            }
        },
        {
            key: "overrideDynamicConfig",
            value: function overrideDynamicConfig(name, value) {
                this._overrides.configs[name] = value;
                this._djb2Map.set($c2f45040bec869b9$var$djb2MapKey((0, $9VR6c._DJB2)(name), 'configs'), value);
                this.saveOverrides();
            }
        },
        {
            key: "removeDynamicConfigOverride",
            value: function removeDynamicConfigOverride(name) {
                delete this._overrides.configs[name];
                this._djb2Map.delete($c2f45040bec869b9$var$djb2MapKey((0, $9VR6c._DJB2)(name), 'configs'));
                this.saveOverrides();
            }
        },
        {
            key: "getDynamicConfigOverride",
            value: function getDynamicConfigOverride(current, _user) {
                return this._getConfigOverride(current, this._overrides.configs);
            }
        },
        {
            key: "overrideExperiment",
            value: function overrideExperiment(name, value) {
                this._overrides.configs[name] = value;
                this._djb2Map.set($c2f45040bec869b9$var$djb2MapKey((0, $9VR6c._DJB2)(name), 'configs'), value);
                this.saveOverrides();
            }
        },
        {
            key: "removeExperimentOverride",
            value: function removeExperimentOverride(name) {
                delete this._overrides.configs[name];
                this._djb2Map.delete($c2f45040bec869b9$var$djb2MapKey((0, $9VR6c._DJB2)(name), 'configs'));
                this.saveOverrides();
            }
        },
        {
            key: "getExperimentOverride",
            value: function getExperimentOverride(current, _user) {
                return this._getConfigOverride(current, this._overrides.configs);
            }
        },
        {
            key: "overrideLayer",
            value: function overrideLayer(name, value) {
                this._overrides.layers[name] = value;
                this._djb2Map.set($c2f45040bec869b9$var$djb2MapKey((0, $9VR6c._DJB2)(name), 'layers'), value);
                this.saveOverrides();
            }
        },
        {
            key: "removeLayerOverride",
            value: function removeLayerOverride(name) {
                delete this._overrides.layers[name];
                this._djb2Map.delete($c2f45040bec869b9$var$djb2MapKey((0, $9VR6c._DJB2)(name), 'layers'));
                this.saveOverrides();
            }
        },
        {
            key: "removeAllOverrides",
            value: function removeAllOverrides() {
                this._overrides = $c2f45040bec869b9$var$makeEmptyStore();
                try {
                    window.localStorage.removeItem(this._localStorageKey);
                } catch (_unused4) {
                // ignored - window is not defined in non-browser environments, and we don't save things there
                // (things like SSR, etc)
                }
            }
        },
        {
            key: "getLayerOverride",
            value: function getLayerOverride(current, _user) {
                var _this$_overrides$laye;
                var overridden = (_this$_overrides$laye = this._overrides.layers[current.name]) !== null && _this$_overrides$laye !== void 0 ? _this$_overrides$laye : this._djb2Map.get($c2f45040bec869b9$var$djb2MapKey(current.name, 'layers'));
                if (overridden == null) return null;
                return $c2f45040bec869b9$var$_objectSpread($c2f45040bec869b9$var$_objectSpread({}, current), {}, {
                    __value: overridden,
                    get: (0, $9VR6c._makeTypedGet)(current.name, overridden),
                    details: $c2f45040bec869b9$var$_objectSpread($c2f45040bec869b9$var$_objectSpread({}, current.details), {}, {
                        reason: $c2f45040bec869b9$var$LOCAL_OVERRIDE_REASON
                    })
                });
            }
        },
        {
            key: "_getConfigOverride",
            value: function _getConfigOverride(current, lookup) {
                var _lookup$current$name;
                var overridden = (_lookup$current$name = lookup[current.name]) !== null && _lookup$current$name !== void 0 ? _lookup$current$name : this._djb2Map.get($c2f45040bec869b9$var$djb2MapKey(current.name, 'configs'));
                if (overridden == null) return null;
                return $c2f45040bec869b9$var$_objectSpread($c2f45040bec869b9$var$_objectSpread({}, current), {}, {
                    value: overridden,
                    get: (0, $9VR6c._makeTypedGet)(current.name, overridden),
                    details: $c2f45040bec869b9$var$_objectSpread($c2f45040bec869b9$var$_objectSpread({}, current.details), {}, {
                        reason: $c2f45040bec869b9$var$LOCAL_OVERRIDE_REASON
                    })
                });
            }
        }
    ]);
}();

});



parcelRegister("58gBl", function(module, exports) {
$parcel$export(module.exports, "debug", () => $3bca93cb4c4c0d28$export$1c9f709888824e05);
var $3bca93cb4c4c0d28$var$_process, $3bca93cb4c4c0d28$var$_process2;
// We can't rely on NODE_ENV === 'test' if its value is already configured by the consumer to some other value, so better to use JEST_WORKER_ID
// https://jestjs.io/docs/environment-variables#jest_worker_id
var $3bca93cb4c4c0d28$var$TESTS_MODE = (globalThis === null || globalThis === void 0 || ($3bca93cb4c4c0d28$var$_process = globalThis.process) === null || $3bca93cb4c4c0d28$var$_process === void 0 || ($3bca93cb4c4c0d28$var$_process = $3bca93cb4c4c0d28$var$_process.env) === null || $3bca93cb4c4c0d28$var$_process === void 0 ? void 0 : $3bca93cb4c4c0d28$var$_process.JEST_WORKER_ID) !== undefined;
var $3bca93cb4c4c0d28$var$DEBUG_MODE = !$3bca93cb4c4c0d28$var$TESTS_MODE && (globalThis === null || globalThis === void 0 || ($3bca93cb4c4c0d28$var$_process2 = globalThis.process) === null || $3bca93cb4c4c0d28$var$_process2 === void 0 || ($3bca93cb4c4c0d28$var$_process2 = $3bca93cb4c4c0d28$var$_process2.env) === null || $3bca93cb4c4c0d28$var$_process2 === void 0 ? void 0 : $3bca93cb4c4c0d28$var$_process2.NODE_ENV) !== 'production';
var $3bca93cb4c4c0d28$export$1c9f709888824e05 = function debug() {
    var _console;
    if (!$3bca93cb4c4c0d28$var$DEBUG_MODE) return;
    // eslint-disable-next-line no-console
    (_console = console).debug.apply(_console, arguments);
};

});



parcelRegister("hp0B0", function(module, exports) {
$parcel$export(module.exports, "default", () => $cab53bcd13330d54$export$2e2bcd8739ae039);
/* pressable.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $kqp0i = parcelRequire("kqp0i");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");


var $hUFig = parcelRequire("hUFig");

var $ijhrq = parcelRequire("ijhrq");

var $9PIsK = parcelRequire("9PIsK");

var $eEFdc = parcelRequire("eEFdc");

var $d1i5w = parcelRequire("d1i5w");
var $cab53bcd13330d54$var$_excluded = [
    "children",
    "isDisabled",
    "type",
    "onClick",
    "interactionName",
    "componentName",
    "analyticsContext",
    "style",
    "testId",
    "xcss"
], $cab53bcd13330d54$var$_excluded2 = [
    "className"
];
var $cab53bcd13330d54$var$styles = {
    root: "_19itglyw _vchhusvi _r06hglyw _80omtlke",
    disabled: "_80om13gf"
};
/**
 * __Pressable__
 *
 * A primitive for building custom buttons.
 *
 * - [Examples](https://atlassian.design/components/primitives/pressable/examples)
 * - [Code](https://atlassian.design/components/primitives/pressable/code)
 * - [Usage](https://atlassian.design/components/primitives/pressable/usage)
 */ var $cab53bcd13330d54$var$Pressable = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function(_ref, ref) {
    var children = _ref.children, isDisabled = _ref.isDisabled, _ref$type = _ref.type, type = _ref$type === void 0 ? 'button' : _ref$type, _ref$onClick = _ref.onClick, providedOnClick = _ref$onClick === void 0 ? (0, $9PIsK.default) : _ref$onClick, interactionName = _ref.interactionName, componentName = _ref.componentName, analyticsContext = _ref.analyticsContext, style = _ref.style, testId = _ref.testId, xcss = _ref.xcss, htmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $cab53bcd13330d54$var$_excluded);
    var interactionContext = (0, $5FkrB.useContext)((0, $eEFdc.default));
    var handleClick = (0, $5FkrB.useCallback)(function(e, analyticsEvent) {
        interactionContext && interactionContext.tracePress(interactionName, e.timeStamp);
        providedOnClick(e, analyticsEvent);
    }, [
        providedOnClick,
        interactionContext,
        interactionName
    ]);
    var onClick = (0, $ijhrq.usePlatformLeafEventHandler)({
        fn: handleClick,
        action: 'clicked',
        componentName: componentName || 'Pressable',
        packageName: "@atlaskit/primitives",
        packageVersion: "14.2.2",
        analyticsData: analyticsContext,
        actionSubject: 'button'
    });
    // This is to remove className from safeHtmlAttributes
    // @ts-expect-error className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(htmlAttributes, $cab53bcd13330d54$var$_excluded2);
    return /*#__PURE__*/ $5FkrB.createElement((0, $d1i5w.default), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        as: "button",
        style: style
    }, safeHtmlAttributes, {
        // eslint-disable-next-line react/button-has-type
        type: type,
        onClick: onClick,
        disabled: isDisabled,
        xcss: (0, $hUFig.cx)($cab53bcd13330d54$var$styles.root, isDisabled && $cab53bcd13330d54$var$styles.disabled, xcss),
        testId: testId,
        ref: ref
    }), children);
});
var $cab53bcd13330d54$export$2e2bcd8739ae039 = $cab53bcd13330d54$var$Pressable;

});
parcelRegister("9PIsK", function(module, exports) {
$parcel$export(module.exports, "default", () => $728b5dd98ca29270$export$2e2bcd8739ae039);
/**
 * An empty function which does nothing.
 */ function $728b5dd98ca29270$export$2e2bcd8739ae039() {}

});

parcelRegister("eEFdc", function(module, exports) {
$parcel$export(module.exports, "default", () => $aab4c4eb7d8dc10b$export$2e2bcd8739ae039);

var $5FkrB = parcelRequire("5FkrB");
var $aab4c4eb7d8dc10b$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $5FkrB.createContext)(null);

});

parcelRegister("d1i5w", function(module, exports) {
$parcel$export(module.exports, "default", () => $97a96649e208e7dc$export$2e2bcd8739ae039);
/* focusable.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $kqp0i = parcelRequire("kqp0i");

var $25nEq = parcelRequire("25nEq");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");
var $cAVP0 = parcelRequire("cAVP0");
var $97a96649e208e7dc$var$_excluded = [
    "as",
    "children",
    "isInset",
    "testId",
    "style",
    "xcss"
], $97a96649e208e7dc$var$_excluded2 = [
    "className"
];
function $97a96649e208e7dc$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $97a96649e208e7dc$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $97a96649e208e7dc$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $97a96649e208e7dc$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $97a96649e208e7dc$var$focusRingStyles = null;
var $97a96649e208e7dc$var$insetFocusRingStyles = null;
/**
 * __Focus ring__
 *
 * A focus ring visually indicates the currently focused item.
 *
 */ var $97a96649e208e7dc$var$Focusable = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? 'button' : _ref$as, children = _ref.children, isInset = _ref.isInset, testId = _ref.testId, style = _ref.style, xcss = _ref.xcss, htmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $97a96649e208e7dc$var$_excluded);
    // This is to remove className from safeHtmlAttributes
    // @ts-expect-error className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(htmlAttributes, $97a96649e208e7dc$var$_excluded2);
    return /*#__PURE__*/ $5FkrB.createElement(Component, (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, safeHtmlAttributes, {
        // @ts-ignore Expression produces a union type that is too complex to represent. We may be able to narrow the type here but unsure.
        ref: ref,
        className: (0, $970q7.default)([
            "_mizu194a _1ah31bk5 _ra3xnqa1 _128m1bk5 _1cvmnqa1 _4davt94y",
            isInset && "_1ah3115h _2mwq115h",
            xcss
        ]),
        "data-testid": testId,
        style: $97a96649e208e7dc$var$_objectSpread($97a96649e208e7dc$var$_objectSpread({}, style), {}, {
            "--_1203r2w": (0, $cAVP0.default)("calc(0px - ".concat("var(--ds-border-width-outline, 2px)", ")"))
        })
    }), children);
});
var $97a96649e208e7dc$export$2e2bcd8739ae039 = $97a96649e208e7dc$var$Focusable;

});


parcelRegister("lLoMC", function(module, exports) {
$parcel$export(module.exports, "useSplitButtonContext", () => $fd81362b6246f0fa$export$47e2c6fdb142d947);

var $5FkrB = parcelRequire("5FkrB");
var $fd81362b6246f0fa$export$4b86304b2c0d7e71 = /*#__PURE__*/ (0, $5FkrB.createContext)(undefined);
var $fd81362b6246f0fa$export$47e2c6fdb142d947 = function useSplitButtonContext() {
    var context = (0, $5FkrB.useContext)($fd81362b6246f0fa$export$4b86304b2c0d7e71);
    if (!context) return undefined;
    if (context.appearance === 'navigation') {
        var newContext = {
            spacing: 'default',
            appearance: 'subtle',
            isDisabled: false,
            isActiveOverSelected: false,
            isNavigationSplitButton: true,
            isHighlighted: context.isHighlighted
        };
        return newContext;
    }
    var splitButtonContext = {
        spacing: context.spacing,
        appearance: context.appearance,
        isDisabled: context.isDisabled,
        isActiveOverSelected: true,
        isNavigationSplitButton: false,
        isHighlighted: false
    };
    return splitButtonContext;
};

});

parcelRegister("a11no", function(module, exports) {
$parcel$export(module.exports, "default", () => $74ab10ad3aa1e7bb$export$2e2bcd8739ae039);
function $74ab10ad3aa1e7bb$var$abort(event) {
    event.preventDefault();
    event.stopPropagation();
}
var $74ab10ad3aa1e7bb$var$tabKeyCode = 9;
function $74ab10ad3aa1e7bb$var$onKey(event) {
    // Allowing tab so that a user can move focus away
    if (event.keyCode === $74ab10ad3aa1e7bb$var$tabKeyCode) return;
    $74ab10ad3aa1e7bb$var$abort(event);
}
function $74ab10ad3aa1e7bb$export$2e2bcd8739ae039(shouldBlockEvents, events) {
    return shouldBlockEvents ? {
        onMouseDownCapture: $74ab10ad3aa1e7bb$var$abort,
        onMouseUpCapture: $74ab10ad3aa1e7bb$var$abort,
        onKeyDownCapture: $74ab10ad3aa1e7bb$var$onKey,
        onKeyUpCapture: $74ab10ad3aa1e7bb$var$onKey,
        onTouchStartCapture: $74ab10ad3aa1e7bb$var$abort,
        onTouchEndCapture: $74ab10ad3aa1e7bb$var$abort,
        onPointerDownCapture: $74ab10ad3aa1e7bb$var$abort,
        onPointerUpCapture: $74ab10ad3aa1e7bb$var$abort,
        onClickCapture: $74ab10ad3aa1e7bb$var$abort,
        // Just smashing the existing onClick for good measure
        onClick: $74ab10ad3aa1e7bb$var$abort
    } : events;
}

});

parcelRegister("13yI1", function(module, exports) {
$parcel$export(module.exports, "default", () => $0c50febf2596508c$export$2e2bcd8739ae039);

var $5FkrB = parcelRequire("5FkrB");

var $6hfNg = parcelRequire("6hfNg");
function $0c50febf2596508c$var$getIconSpacing(spacing) {
    switch(spacing){
        case 'compact':
            return 'small';
        default:
            return 'medium';
    }
}
function $0c50febf2596508c$var$getSpinnerAppearance(_ref) {
    var appearance = _ref.appearance, isDisabled = _ref.isDisabled, isSelected = _ref.isSelected;
    if (isDisabled || isSelected) return 'inherit';
    if (appearance === 'primary' || appearance === 'danger' || appearance === 'discovery') return 'invert';
    return 'inherit';
}
function $0c50febf2596508c$export$2e2bcd8739ae039(_ref2) {
    var appearance = _ref2.appearance, spacing = _ref2.spacing, isDisabled = _ref2.isDisabled, isSelected = _ref2.isSelected, testId = _ref2.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $6hfNg.default), {
        size: $0c50febf2596508c$var$getIconSpacing(spacing),
        appearance: $0c50febf2596508c$var$getSpinnerAppearance({
            appearance: appearance,
            isDisabled: isDisabled,
            isSelected: isSelected
        }),
        testId: testId ? "".concat(testId, "--loading-spinner") : undefined
    });
}

});
parcelRegister("6hfNg", function(module, exports) {
$parcel$export(module.exports, "default", () => $492094e1d40d4ca9$export$2e2bcd8739ae039);
/* spinner.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $970q7 = parcelRequire("970q7");

var $5FkrB = parcelRequire("5FkrB");

var $eqVaP = parcelRequire("eqVaP");

var $dSRcG = parcelRequire("dSRcG");

var $2oN5i = parcelRequire("2oN5i");
/**
 * Returns the appropriate circle stroke color.
 */ function $492094e1d40d4ca9$var$getStrokeColor(appearance) {
    return appearance === 'inherit' ? "var(--ds-icon-subtle, ".concat((0, $dSRcG.N500), ")") : "var(--ds-icon-inverse, ".concat((0, $dSRcG.N0), ")");
}
var $492094e1d40d4ca9$var$rotate = null;
/**
 * There are three parts to the load in animation:
 * 1. Fade in
 * 2. Accelerated spin
 * 3. Stretch the spinner line
 */ var $492094e1d40d4ca9$var$loadIn = null;
var $492094e1d40d4ca9$var$styles = {
    rotateStyles: "_y44v1ozz _1pgl2qsq _8hrz1h6o",
    loadInStyles: "_y44v1a7z _1o51q7pw _tzy4idpf",
    wrapperStyles: "_1e0c116y _s7n4nkob",
    circleStyles: "_lswuglyw _7ljx1dhp _opj11kw7 _134c892t _1snbbs82 _jcxd7g3v _1tjm1onz"
};
/**
 * `useLayoutEffect` is being used in SSR safe form. On the server, this work doesn’t need to run.
 * `useEffect` is used in-place, because `useEffect` is not run on the server and it matches types
 * which makes things simpler than doing an `isServer` check or a `null` check.
 *
 * @see https://hello.atlassian.net/wiki/spaces/DST/pages/2081696628/DSTDACI-010+-+Interaction+Tracing+hooks+in+DS+components
 */ var $492094e1d40d4ca9$var$useLayoutEffect = typeof window === 'undefined' ? (0, $5FkrB.useEffect) : (0, $5FkrB.useLayoutEffect);
/**
 * __Spinner__
 *
 * A spinner is an animated spinning icon that lets users know content is being loaded.
 *
 * - [Examples](https://atlassian.design/components/spinner/examples)
 * - [Code](https://atlassian.design/components/spinner/code)
 * - [Usage](https://atlassian.design/components/spinner/usage)
 */ var $492094e1d40d4ca9$var$Spinner = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).forwardRef(function Spinner(_ref, ref) {
    var _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'inherit' : _ref$appearance, _ref$delay = _ref.delay, delay = _ref$delay === void 0 ? 0 : _ref$delay, interactionName = _ref.interactionName, label = _ref.label, _ref$size = _ref.size, providedSize = _ref$size === void 0 ? 'medium' : _ref$size, testId = _ref.testId;
    var size = typeof providedSize === 'number' ? providedSize : (0, $2oN5i.presetSizes)[providedSize];
    var animationDelay = "".concat(delay, "ms");
    var stroke = $492094e1d40d4ca9$var$getStrokeColor(appearance);
    var context = (0, $5FkrB.useContext)((0, $eqVaP.default));
    $492094e1d40d4ca9$var$useLayoutEffect(function() {
        if (context != null) return context.hold(interactionName);
    }, [
        context,
        interactionName
    ]);
    /**
   * The Spinner animation uses a combination of two
   * css animations on two separate elements.
   */ return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("span", {
        "data-testid": testId ? "".concat(testId, "-wrapper") : 'spinner-wrapper',
        style: {
            animationDelay: animationDelay,
            width: size,
            height: size
        },
        className: (0, $970q7.default)([
            $492094e1d40d4ca9$var$styles.wrapperStyles,
            $492094e1d40d4ca9$var$styles.rotateStyles
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("svg", {
        height: size,
        width: size,
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg",
        "data-testid": testId,
        ref: ref,
        "aria-label": label || undefined,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            animationDelay: animationDelay
        },
        role: label ? 'img' : 'none',
        className: (0, $970q7.default)([
            $492094e1d40d4ca9$var$styles.loadInStyles
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("circle", {
        cx: "8",
        cy: "8",
        r: "7",
        style: {
            stroke: stroke
        },
        className: (0, $970q7.default)([
            $492094e1d40d4ca9$var$styles.circleStyles
        ])
    })));
}));
var $492094e1d40d4ca9$export$2e2bcd8739ae039 = $492094e1d40d4ca9$var$Spinner;

});
parcelRegister("2oN5i", function(module, exports) {
$parcel$export(module.exports, "presetSizes", () => $1bf3e5ce047ce5c4$export$4e9f1640bbe7a1a8);
var $1bf3e5ce047ce5c4$export$4e9f1640bbe7a1a8 = {
    xsmall: 8,
    small: 16,
    medium: 24,
    large: 48,
    xlarge: 96
};

});




parcelRegister("fxDXf", function(module, exports) {
$parcel$export(module.exports, "default", () => $b508ee3c22103f11$export$2e2bcd8739ae039);
/* content.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $970q7 = parcelRequire("970q7");

var $5FkrB = parcelRequire("5FkrB");
var $b508ee3c22103f11$var$styles = {
    text: "_1reo15vq _18m915vq _16jlkb7n _1o9zkb7n _1bto1l2s _o5721q9c",
    icon: "_1e0c1txw _16jlidpf _1o9zidpf _1wpz1h6o _1wybidpf _vwz4idpf _uiztglyw",
    beforeIcon: "_1he91b66 _w795v77o",
    afterIcon: "_1he9v77o _w7951b66",
    common: "_v564g17y",
    fade: "_tzy4idpf"
};
/**
 * __Content__
 *
 * Used for slots within a Button, including icons and text content.
 */ var $b508ee3c22103f11$var$Content = function Content(_ref) {
    var children = _ref.children, _ref$type = _ref.type, type = _ref$type === void 0 ? 'text' : _ref$type, isLoading = _ref.isLoading, position = _ref.position;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("span", {
        className: (0, $970q7.default)([
            $b508ee3c22103f11$var$styles.common,
            type === 'text' && $b508ee3c22103f11$var$styles.text,
            type === 'icon' && $b508ee3c22103f11$var$styles.icon,
            isLoading && $b508ee3c22103f11$var$styles.fade,
            position === 'before' && $b508ee3c22103f11$var$styles.beforeIcon,
            position === 'after' && $b508ee3c22103f11$var$styles.afterIcon
        ])
    }, children);
};
var $b508ee3c22103f11$export$2e2bcd8739ae039 = $b508ee3c22103f11$var$Content;

});

parcelRegister("7zyz1", function(module, exports) {
$parcel$export(module.exports, "default", () => $58369cf6c8ceabe1$export$2e2bcd8739ae039);

var $5FkrB = parcelRequire("5FkrB");
function $58369cf6c8ceabe1$var$isIconRenderProp(func) {
    return !func.displayName && // most function components and class components have a displayName, negate them
    !func.render && // forwardRef doesn't require a display name, however it does include a render function, negate them
    typeof func === 'function' // at the very least we need to be a function
    ;
}
/**
 * __Icon renderer__
 *
 * Used to support render props with icons.
 *
 */ var $58369cf6c8ceabe1$var$IconRenderer = function IconRenderer(_ref) {
    var Icon = _ref.icon;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).Fragment, null, $58369cf6c8ceabe1$var$isIconRenderProp(Icon) ? Icon({
        label: '',
        color: 'currentColor'
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(Icon, {
        label: "",
        color: 'currentColor'
    }));
};
var $58369cf6c8ceabe1$export$2e2bcd8739ae039 = $58369cf6c8ceabe1$var$IconRenderer;

});


parcelRegister("dQOjl", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e25fa526c0658720d6f2766d6bdbde06>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a1572865ee472039$var$_react = $a1572865ee472039$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $a1572865ee472039$var$_close = $a1572865ee472039$var$_interopRequireDefault((parcelRequire("dY7ZR")));

var $a1572865ee472039$var$_cross = $a1572865ee472039$var$_interopRequireDefault((parcelRequire("2gDpX")));
function $a1572865ee472039$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for CloseIcon.
 * This component is CloseIcon, with `UNSAFE_fallbackIcon` set to "CrossIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for closing an element.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a1572865ee472039$var$CloseIcon = (props)=>/*#__PURE__*/ $a1572865ee472039$var$_react.default.createElement($a1572865ee472039$var$_close.default, Object.assign({
        LEGACY_fallbackIcon: $a1572865ee472039$var$_cross.default
    }, props));
$a1572865ee472039$var$CloseIcon.Name = 'CloseIconMigration';
var $a1572865ee472039$var$_default = module.exports.default = $a1572865ee472039$var$CloseIcon;

});
parcelRegister("dY7ZR", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::13d0fc846b6bef3d8e704c9e8e0a2026>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a2b714f30c762d84$var$_react = $a2b714f30c762d84$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $a2b714f30c762d84$var$_baseNew = $a2b714f30c762d84$var$_interopRequireDefault((parcelRequire("g471E")));
function $a2b714f30c762d84$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Close".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for closing an element.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a2b714f30c762d84$var$CloseIcon = (props)=>/*#__PURE__*/ $a2b714f30c762d84$var$_react.default.createElement($a2b714f30c762d84$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="m9.06 8 4.97-4.97-1.06-1.06L8 6.94 3.03 1.97 1.97 3.03 6.94 8l-4.97 4.97 1.06 1.06L8 9.06l4.97 4.97 1.06-1.06z" clip-rule="evenodd"/>`
    }, props));
$a2b714f30c762d84$var$CloseIcon.displayName = 'CloseIcon';
var $a2b714f30c762d84$var$_default = module.exports.default = $a2b714f30c762d84$var$CloseIcon;

});
parcelRegister("g471E", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => (parcelRequire("lnzKb")).default);
$parcel$export(module.exports, "Icon", () => (parcelRequire("lnzKb")).Icon);

var $lnzKb = parcelRequire("lnzKb");

});
parcelRegister("lnzKb", function(module, exports) {
$parcel$export(module.exports, "Icon", () => $f90778f181fc87c1$export$f04a61298a47a40f);
$parcel$export(module.exports, "default", () => $f90778f181fc87c1$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5FkrB = parcelRequire("5FkrB");

var $74Zh5 = parcelRequire("74Zh5");

var $id6Cu = parcelRequire("id6Cu");
/**
 * We are hiding this props from consumers as it's reserved
 * for use by Icon Tile.
 */ var $f90778f181fc87c1$var$commonSVGStyles = (0, $74Zh5.css)({
    overflow: 'hidden',
    pointerEvents: 'none',
    /**
   * Stop-color doesn't properly apply in chrome when the inherited/current color changes.
   * We have to initially set stop-color to inherit (either via DOM attribute or an initial CSS
   * rule) and then override it with currentColor for the color changes to be picked up.
   */ // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    stop: {
        stopColor: 'currentColor'
    }
});
var $f90778f181fc87c1$var$svgStyles = (0, $74Zh5.css)({
    color: 'currentColor',
    verticalAlign: 'bottom'
});
var $f90778f181fc87c1$var$iconStyles = (0, $74Zh5.css)({
    display: 'inline-block',
    boxSizing: 'border-box',
    flexShrink: 0,
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: 1,
    paddingInlineEnd: 'var(--ds--button--new-icon-padding-end, 0)',
    paddingInlineStart: 'var(--ds--button--new-icon-padding-start, 0)'
});
var $f90778f181fc87c1$var$utilityIconStyles = (0, $74Zh5.css)({
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: "var(--ds-space-150, 12px)"
});
var $f90778f181fc87c1$var$scaleStyles = (0, $74Zh5.css)({
    width: 'inherit',
    height: 'inherit'
});
/**
 * For windows high contrast mode
 */ var $f90778f181fc87c1$var$baseHcmStyles = (0, $74Zh5.css)({
    '@media screen and (forced-colors: active)': {
        color: 'CanvasText',
        filter: 'grayscale(1)'
    }
});
var $f90778f181fc87c1$var$scaleSize = (0, $74Zh5.css)({
    width: 'inherit',
    height: 'inherit'
});
var $f90778f181fc87c1$var$sizeMap = {
    core: {
        none: (0, $74Zh5.css)({
            width: "var(--ds-space-200, 16px)",
            height: "var(--ds-space-200, 16px)"
        }),
        spacious: (0, $74Zh5.css)({
            width: "var(--ds-space-300, 24px)",
            height: "var(--ds-space-300, 24px)"
        })
    },
    utility: {
        none: (0, $74Zh5.css)({
            width: "var(--ds-space-150, 12px)",
            height: "var(--ds-space-150, 12px)"
        }),
        compact: (0, $74Zh5.css)({
            width: "var(--ds-space-200, 16px)",
            height: "var(--ds-space-200, 16px)"
        }),
        spacious: (0, $74Zh5.css)({
            width: "var(--ds-space-300, 24px)",
            height: "var(--ds-space-300, 24px)"
        })
    }
};
var $f90778f181fc87c1$var$baseSizeMap = {
    core: 16,
    utility: 12
};
var $f90778f181fc87c1$var$paddingMap = {
    core: {
        none: 0,
        spacious: 4
    },
    utility: {
        none: 0,
        compact: 2,
        spacious: 6
    }
};
var $f90778f181fc87c1$export$f04a61298a47a40f = /*#__PURE__*/ (0, $5FkrB.memo)(function Icon(props) {
    var _props$type, _props$spacing3, _props$spacing4;
    var _ref = props, _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, testId = _ref.testId, label = _ref.label, LEGACY_primaryColor = _ref.LEGACY_primaryColor, LEGACY_secondaryColor = _ref.LEGACY_secondaryColor, LEGACY_size = _ref.LEGACY_size, FallbackIcon = _ref.LEGACY_fallbackIcon, dangerouslySetGlyph = _ref.dangerouslySetGlyph, shouldScale = _ref.shouldScale, LEGACY_margin = _ref.LEGACY_margin;
    var dangerouslySetInnerHTML = dangerouslySetGlyph ? {
        __html: dangerouslySetGlyph
    } : undefined;
    // Fall back to old icon
    if (FallbackIcon && !(0, $id6Cu.fg)('platform-visual-refresh-icons')) // parse out unnecessary props
    return (0, $74Zh5.jsx)(FallbackIcon, {
        primaryColor: LEGACY_primaryColor !== null && LEGACY_primaryColor !== void 0 ? LEGACY_primaryColor : color,
        secondaryColor: LEGACY_secondaryColor,
        size: LEGACY_size,
        label: label,
        testId: testId,
        UNSAFE_margin: LEGACY_margin
    });
    var baseSize = $f90778f181fc87c1$var$baseSizeMap[(_props$type = props.type) !== null && _props$type !== void 0 ? _props$type : 'core'];
    var viewBoxPadding;
    if (props.type === 'utility') {
        var _props$spacing;
        viewBoxPadding = $f90778f181fc87c1$var$paddingMap[props.type][(_props$spacing = props.spacing) !== null && _props$spacing !== void 0 ? _props$spacing : 'none'];
    } else {
        var _props$spacing2;
        viewBoxPadding = $f90778f181fc87c1$var$paddingMap['core'][(_props$spacing2 = props.spacing) !== null && _props$spacing2 !== void 0 ? _props$spacing2 : 'none'];
    }
    var viewBoxSize = baseSize + 2 * viewBoxPadding;
    return (0, $74Zh5.jsx)("span", {
        "data-testid": testId,
        role: label ? 'img' : undefined,
        "aria-label": label ? label : undefined,
        "aria-hidden": label ? undefined : true,
        style: {
            color: color
        },
        css: [
            $f90778f181fc87c1$var$iconStyles,
            $f90778f181fc87c1$var$baseHcmStyles,
            shouldScale && $f90778f181fc87c1$var$scaleStyles,
            props.type === 'utility' && $f90778f181fc87c1$var$utilityIconStyles
        ]
    }, (0, $74Zh5.jsx)("svg", {
        fill: "none",
        viewBox: "".concat(0 - viewBoxPadding, " ").concat(0 - viewBoxPadding, " ").concat(viewBoxSize, " ").concat(viewBoxSize),
        role: "presentation",
        css: [
            $f90778f181fc87c1$var$commonSVGStyles,
            $f90778f181fc87c1$var$svgStyles,
            shouldScale ? $f90778f181fc87c1$var$scaleSize : props.type === 'utility' ? $f90778f181fc87c1$var$sizeMap[props.type][(_props$spacing3 = props.spacing) !== null && _props$spacing3 !== void 0 ? _props$spacing3 : 'none'] : $f90778f181fc87c1$var$sizeMap['core'][(_props$spacing4 = props.spacing) !== null && _props$spacing4 !== void 0 ? _props$spacing4 : 'none']
        ],
        dangerouslySetInnerHTML: dangerouslySetInnerHTML
    }));
});
var $f90778f181fc87c1$export$2e2bcd8739ae039 = $f90778f181fc87c1$export$f04a61298a47a40f;

});



parcelRegister("2gDpX", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1a6ba6e5daa4a994$var$_react = $1a6ba6e5daa4a994$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $0X9jl = parcelRequire("0X9jl");

var $1a6ba6e5daa4a994$var$_close = $1a6ba6e5daa4a994$var$_interopRequireDefault((parcelRequire("dY7ZR")));
function $1a6ba6e5daa4a994$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $1a6ba6e5daa4a994$var$CrossIcon = (props)=>/*#__PURE__*/ $1a6ba6e5daa4a994$var$_react.default.createElement($0X9jl.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M12 10.586 6.707 5.293a1 1 0 0 0-1.414 1.414L10.586 12l-5.293 5.293a1 1 0 0 0 1.414 1.414L12 13.414l5.293 5.293a1 1 0 0 0 1.414-1.414L13.414 12l5.293-5.293a1 1 0 1 0-1.414-1.414z"/></svg>`
    }, props, {
        newIcon: $1a6ba6e5daa4a994$var$_close.default
    }));
$1a6ba6e5daa4a994$var$CrossIcon.displayName = 'CrossIcon';
var $1a6ba6e5daa4a994$var$_default = module.exports.default = $1a6ba6e5daa4a994$var$CrossIcon;

});
parcelRegister("0X9jl", function(module, exports) {
$parcel$export(module.exports, "IconFacade", () => $002de1ff0bc21e58$export$3cfb73f70dfca966);

var $kqp0i = parcelRequire("kqp0i");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");

var $id6Cu = parcelRequire("id6Cu");

var $1Rj5x = parcelRequire("1Rj5x");
var $002de1ff0bc21e58$var$_excluded = [
    "dangerouslySetGlyph"
];
var $002de1ff0bc21e58$var$sizeSpacingMap = {
    utility: {
        small: 'compact',
        medium: 'spacious'
    },
    core: {
        small: 'none',
        medium: 'spacious'
    }
};
var $002de1ff0bc21e58$export$3cfb73f70dfca966 = /*#__PURE__*/ (0, $5FkrB.memo)(function IconFacade(_ref) {
    var _props$size;
    var dangerouslySetGlyph = _ref.dangerouslySetGlyph, props = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $002de1ff0bc21e58$var$_excluded);
    var NewIcon = props.newIcon;
    // By default, the icon size will be medium for core icons and small for utility icons
    var size = (_props$size = props.size) !== null && _props$size !== void 0 ? _props$size : 'medium';
    var useNewIcon = !props.isFacadeDisabled && // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
    (0, $id6Cu.fg)('platform-visual-refresh-icons-legacy-facade');
    if (useNewIcon && NewIcon && (size === 'small' || size === 'medium')) {
        if (props.iconType === 'utility') {
            var Icon = NewIcon;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(Icon, (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, props, {
                spacing: (0, $id6Cu.fg)('platform-visual-refresh-icons-facade-button-fix') ? $002de1ff0bc21e58$var$sizeSpacingMap['utility'][size] : 'none',
                color: props.primaryColor || 'currentColor',
                type: props.iconType
            }));
        } else {
            var _Icon = NewIcon;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(_Icon, (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, props, {
                spacing: $002de1ff0bc21e58$var$sizeSpacingMap['core'][size],
                color: props.primaryColor || 'currentColor',
                type: props.iconType
            }));
        }
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $1Rj5x.Icon), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        dangerouslySetGlyph: dangerouslySetGlyph
    }, props));
});

});
parcelRegister("1Rj5x", function(module, exports) {
$parcel$export(module.exports, "Icon", () => $15a98c3aa6523ac9$export$f04a61298a47a40f);

var $kqp0i = parcelRequire("kqp0i");

var $25nEq = parcelRequire("25nEq");

var $5FkrB = parcelRequire("5FkrB");

var $74Zh5 = parcelRequire("74Zh5");

var $ffzGa = parcelRequire("ffzGa");

var $iy6m4 = parcelRequire("iy6m4");
function $15a98c3aa6523ac9$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $15a98c3aa6523ac9$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $15a98c3aa6523ac9$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $15a98c3aa6523ac9$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
/**
 * We are hiding these props from consumers as they're used to
 * hack around icon sizing specifically for icon-file-type.
 */ var $15a98c3aa6523ac9$var$iconStyles = (0, $74Zh5.css)({
    display: 'inline-block',
    flexShrink: 0,
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: 1,
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '> svg': $15a98c3aa6523ac9$var$_objectSpread($15a98c3aa6523ac9$var$_objectSpread({}, (0, $ffzGa.commonSVGStyles)), {}, {
        maxWidth: '100%',
        maxHeight: '100%',
        color: 'var(--icon-primary-color)',
        fill: 'var(--icon-secondary-color)',
        verticalAlign: 'bottom'
    })
});
/**
 * For windows high contrast mode
 */ var $15a98c3aa6523ac9$var$baseHcmStyles = (0, $74Zh5.css)({
    '@media screen and (forced-colors: active)': {
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '> svg': {
            filter: 'grayscale(1)',
            '--icon-primary-color': 'CanvasText',
            // foreground
            '--icon-secondary-color': 'Canvas' // background
        }
    }
});
var $15a98c3aa6523ac9$var$primaryEqualsSecondaryHcmStyles = (0, $74Zh5.css)({
    '@media screen and (forced-colors: active)': {
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '> svg': {
            // if the primaryColor is the same as the secondaryColor we
            // set the --icon-primary-color to Canvas
            // this is usually to convey state i.e. Checkbox checked -> not checked
            '--icon-primary-color': 'Canvas' // foreground
        }
    }
});
var $15a98c3aa6523ac9$var$secondaryTransparentHcmStyles = (0, $74Zh5.css)({
    '@media screen and (forced-colors: active)': {
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '> svg': {
            '--icon-secondary-color': 'transparent' // background
        }
    }
});
var $15a98c3aa6523ac9$export$f04a61298a47a40f = /*#__PURE__*/ (0, $5FkrB.memo)(function Icon(props) {
    var _ref = props, Glyph = _ref.glyph, dangerouslySetGlyph = _ref.dangerouslySetGlyph, _ref$primaryColor = _ref.primaryColor, primaryColor = _ref$primaryColor === void 0 ? 'currentColor' : _ref$primaryColor, secondaryColor = _ref.secondaryColor, size = _ref.size, testId = _ref.testId, label = _ref.label, width = _ref.width, height = _ref.height, UNSAFE_margin = _ref.UNSAFE_margin;
    var glyphProps = dangerouslySetGlyph ? {
        dangerouslySetInnerHTML: {
            __html: dangerouslySetGlyph
        }
    } : {
        children: Glyph ? (0, $74Zh5.jsx)(Glyph, {
            role: "presentation"
        }) : null
    };
    var dimensions = (0, $ffzGa.getIconSize)({
        width: width,
        height: height,
        size: size
    });
    return (0, $74Zh5.jsx)("span", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        "data-testid": testId,
        "data-vc": "icon-".concat(testId),
        role: label ? 'img' : undefined,
        "aria-label": label ? label : undefined,
        "aria-hidden": label ? undefined : true,
        style: {
            '--icon-primary-color': primaryColor,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            '--icon-secondary-color': secondaryColor || (0, $iy6m4.getBackground)(),
            margin: UNSAFE_margin
        }
    }, glyphProps, {
        css: [
            $15a98c3aa6523ac9$var$iconStyles,
            $15a98c3aa6523ac9$var$baseHcmStyles,
            primaryColor === secondaryColor && $15a98c3aa6523ac9$var$primaryEqualsSecondaryHcmStyles,
            secondaryColor === 'transparent' && $15a98c3aa6523ac9$var$secondaryTransparentHcmStyles,
            // NB: This can be resolved if this component, composes base SVG / and/or skeleton
            // We could then simplify how common styles are dealt with simply by encapsulating them
            // at their appropriate level and/or having a singular approach to css variables in the package
            dimensions && // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $74Zh5.css)({
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                width: dimensions.width,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                height: dimensions.height,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                '> svg': dimensions
            })
        ]
    }));
});
var $15a98c3aa6523ac9$export$2e2bcd8739ae039 = $15a98c3aa6523ac9$export$f04a61298a47a40f;

});
parcelRegister("ffzGa", function(module, exports) {
$parcel$export(module.exports, "commonSVGStyles", () => $b1a3eed6ffefb9ab$export$16374db1c3e6dfba);
$parcel$export(module.exports, "getIconSize", () => $b1a3eed6ffefb9ab$export$3eb7d6130acfda37);

var $k9xkr = parcelRequire("k9xkr");

var $74Zh5 = parcelRequire("74Zh5");
var $b1a3eed6ffefb9ab$export$16374db1c3e6dfba = {
    overflow: 'hidden',
    pointerEvents: 'none',
    /**
   * Stop-color doesn't properly apply in chrome when the inherited/current color changes.
   * We have to initially set stop-color to inherit (either via DOM attribute or an initial CSS
   * rule) and then override it with currentColor for the color changes to be picked up.
   */ stop: {
        stopColor: 'currentColor'
    }
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
var $b1a3eed6ffefb9ab$var$smallStyles = (0, $74Zh5.css)((0, $k9xkr.dimensions).small);
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
var $b1a3eed6ffefb9ab$var$mediumStyles = (0, $74Zh5.css)((0, $k9xkr.dimensions).medium);
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
var $b1a3eed6ffefb9ab$var$largeStyles = (0, $74Zh5.css)((0, $k9xkr.dimensions).large);
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
var $b1a3eed6ffefb9ab$var$xlargeStyles = (0, $74Zh5.css)((0, $k9xkr.dimensions).xlarge);
var $b1a3eed6ffefb9ab$export$ef0ad74202575b64 = {
    small: $b1a3eed6ffefb9ab$var$smallStyles,
    medium: $b1a3eed6ffefb9ab$var$mediumStyles,
    large: $b1a3eed6ffefb9ab$var$largeStyles,
    xlarge: $b1a3eed6ffefb9ab$var$xlargeStyles
};
var $b1a3eed6ffefb9ab$export$3eb7d6130acfda37 = function getIconSize(_ref) {
    var width = _ref.width, height = _ref.height, size = _ref.size;
    if (width && height) return {
        width: width,
        height: height
    };
    if (size) return (0, $k9xkr.dimensions)[size];
    return undefined;
};

});
parcelRegister("k9xkr", function(module, exports) {
$parcel$export(module.exports, "dimensions", () => $eabe8045da22f240$export$62ad7b0c781000e9);
var $eabe8045da22f240$export$c647cb0ee6e282fe = {
    small: '16px',
    medium: '24px',
    large: '32px',
    xlarge: '48px'
};
var $eabe8045da22f240$export$7bd66fc94c81bf84 = {
    small: 'small',
    medium: 'medium',
    large: 'large',
    xlarge: 'xlarge'
};
var $eabe8045da22f240$export$62ad7b0c781000e9 = {
    small: {
        width: $eabe8045da22f240$export$c647cb0ee6e282fe.small,
        height: $eabe8045da22f240$export$c647cb0ee6e282fe.small
    },
    medium: {
        width: $eabe8045da22f240$export$c647cb0ee6e282fe.medium,
        height: $eabe8045da22f240$export$c647cb0ee6e282fe.medium
    },
    large: {
        width: $eabe8045da22f240$export$c647cb0ee6e282fe.large,
        height: $eabe8045da22f240$export$c647cb0ee6e282fe.large
    },
    xlarge: {
        width: $eabe8045da22f240$export$c647cb0ee6e282fe.xlarge,
        height: $eabe8045da22f240$export$c647cb0ee6e282fe.xlarge
    }
};

});


parcelRegister("iy6m4", function(module, exports) {
$parcel$export(module.exports, "getBackground", () => $d81054f0ea4b1866$export$18cb9425622d4e06);
var $d81054f0ea4b1866$export$18cb9425622d4e06 = function getBackground() {
    return "var(--ds-surface, #FFFFFF)";
};

});






parcelRegister("2td33", function(module, exports) {
$parcel$export(module.exports, "useModal", () => $1cc8694e54deb3bc$export$33ffd74ebf07f060);

var $5FkrB = parcelRequire("5FkrB");

var $bwuZo = parcelRequire("bwuZo");
var $1cc8694e54deb3bc$export$33ffd74ebf07f060 = function useModal() {
    var modalContext = (0, $5FkrB.useContext)((0, $bwuZo.ModalContext));
    if (modalContext == null) throw Error("@atlaskit/modal-dialog: Modal context unavailable \u2013 this component needs to be a child of ModalDialog.");
    return modalContext;
};

});


parcelRegister("9Bq1o", function(module, exports) {
$parcel$export(module.exports, "default", () => $6fdbc114bff1abaa$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $74Zh5 = parcelRequire("74Zh5");

var $g6NAb = parcelRequire("g6NAb");

var $dOHNL = parcelRequire("dOHNL");

var $dSRcG = parcelRequire("dSRcG");

var $2td33 = parcelRequire("2td33");
var $6fdbc114bff1abaa$var$iconColor = {
    danger: "var(--ds-icon-danger, ".concat((0, $dSRcG.R400), ")"),
    warning: "var(--ds-icon-warning, #D97008)"
};
var $6fdbc114bff1abaa$var$iconStyles = (0, $74Zh5.css)({
    flex: '0 0 auto',
    // The following properties have been added purely to avoid a global style override in Jira breaking alignment between the icon and title text.
    // https://stash.atlassian.com/projects/JIRACLOUD/repos/jira/browse/jira-components/jira-legacy-frontend/jira-atlaskit-module/src/main/resources/jira-atlaskit-module/css/adg3-general-overrides.less?at=master#24
    // When the override is removed, these can be removed.
    color: 'inherit',
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    fontSize: 'inherit',
    fontStyle: 'inherit',
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    fontWeight: 'inherit',
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    letterSpacing: 'inherit',
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: 'inherit'
});
var $6fdbc114bff1abaa$var$titleStyles = (0, $74Zh5.css)({
    display: 'flex',
    minWidth: 0,
    margin: "var(--ds-space-0, 0px)",
    gap: "var(--ds-space-100, 8px)",
    font: "var(--ds-font-heading-medium, normal 500 20px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
});
var $6fdbc114bff1abaa$var$textStyles = (0, $74Zh5.css)({
    minWidth: 0,
    /**
   * This ensures that the element fills the whole header space
   * and its content does not overflow (since flex items don't
   * shrink past its content size by default).
   */ flex: '1 1 auto',
    wordWrap: 'break-word'
});
var $6fdbc114bff1abaa$var$truncatedTextStyles = (0, $74Zh5.css)({
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
});
var $6fdbc114bff1abaa$var$TitleIcon = function TitleIcon(_ref) {
    var appearance = _ref.appearance;
    var Icon = appearance === 'danger' ? (0, (/*@__PURE__*/$parcel$interopDefault($g6NAb))) : (0, (/*@__PURE__*/$parcel$interopDefault($dOHNL)));
    return (0, $74Zh5.jsx)("span", {
        css: $6fdbc114bff1abaa$var$iconStyles
    }, (0, $74Zh5.jsx)(Icon, {
        label: appearance,
        color: $6fdbc114bff1abaa$var$iconColor[appearance],
        spacing: "spacious"
    }));
};
/**
 * __Modal title__
 *
 * A modal title is used to display a title within a modal.
 *
 * - [Examples](https://atlassian.design/components/modal-dialog/examples)
 * - [Code](https://atlassian.design/components/modal-dialog/code)
 * - [Usage](https://atlassian.design/components/modal-dialog/usage)
 */ var $6fdbc114bff1abaa$var$ModalTitle = function ModalTitle(props) {
    var appearance = props.appearance, children = props.children, _props$isMultiline = props.isMultiline, isMultiline = _props$isMultiline === void 0 ? true : _props$isMultiline, userDefinedTestId = props.testId;
    var _useModal = (0, $2td33.useModal)(), titleId = _useModal.titleId, modalTestId = _useModal.testId;
    var testId = userDefinedTestId || modalTestId && "".concat(modalTestId, "--title");
    return(// eslint-disable-next-line @atlaskit/design-system/use-heading
    (0, $74Zh5.jsx)("h1", {
        css: $6fdbc114bff1abaa$var$titleStyles,
        "data-testid": testId
    }, appearance && (0, $74Zh5.jsx)($6fdbc114bff1abaa$var$TitleIcon, {
        appearance: appearance
    }), (0, $74Zh5.jsx)("span", {
        id: titleId,
        css: [
            $6fdbc114bff1abaa$var$textStyles,
            !isMultiline && $6fdbc114bff1abaa$var$truncatedTextStyles
        ],
        "data-testid": testId && "".concat(testId, "-text")
    }, children)));
};
var $6fdbc114bff1abaa$export$2e2bcd8739ae039 = $6fdbc114bff1abaa$var$ModalTitle;

});
parcelRegister("g6NAb", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3a36a65999ae3c13d3a1917b5e2b052e>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $bba3aaee00089d4d$var$_react = $bba3aaee00089d4d$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $bba3aaee00089d4d$var$_error = $bba3aaee00089d4d$var$_interopRequireDefault((parcelRequire("2di5f")));

var $bba3aaee00089d4d$var$_error2 = $bba3aaee00089d4d$var$_interopRequireDefault((parcelRequire("23r95")));
function $bba3aaee00089d4d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for ErrorIcon.
 * This component is ErrorIcon, with `UNSAFE_fallbackIcon` set to "ErrorIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for when there is an error.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $bba3aaee00089d4d$var$ErrorIcon = (props)=>/*#__PURE__*/ $bba3aaee00089d4d$var$_react.default.createElement($bba3aaee00089d4d$var$_error.default, Object.assign({
        LEGACY_fallbackIcon: $bba3aaee00089d4d$var$_error2.default
    }, props));
$bba3aaee00089d4d$var$ErrorIcon.Name = 'ErrorIconMigration';
var $bba3aaee00089d4d$var$_default = module.exports.default = $bba3aaee00089d4d$var$ErrorIcon;

});
parcelRegister("2di5f", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::257fef37d04db299e24e95484ff9b12f>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $19cad2b3a12f00c6$var$_react = $19cad2b3a12f00c6$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $19cad2b3a12f00c6$var$_baseNew = $19cad2b3a12f00c6$var$_interopRequireDefault((parcelRequire("g471E")));
function $19cad2b3a12f00c6$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Error".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for when there is an error.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $19cad2b3a12f00c6$var$ErrorIcon = (props)=>/*#__PURE__*/ $19cad2b3a12f00c6$var$_react.default.createElement($19cad2b3a12f00c6$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6.586.604a2 2 0 0 1 2.828 0l5.982 5.982a2 2 0 0 1 0 2.828l-5.982 5.983a2 2 0 0 1-2.828 0L.604 9.414a2 2 0 0 1 0-2.828zM7.25 9V3.75h1.5V9zM8 12.25a1 1 0 1 0 0-2 1 1 0 0 0 0 2" clip-rule="evenodd"/>`
    }, props));
$19cad2b3a12f00c6$var$ErrorIcon.displayName = 'ErrorIcon';
var $19cad2b3a12f00c6$var$_default = module.exports.default = $19cad2b3a12f00c6$var$ErrorIcon;

});

parcelRegister("23r95", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $17f0eb1c35d045f0$var$_react = $17f0eb1c35d045f0$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $0X9jl = parcelRequire("0X9jl");

var $17f0eb1c35d045f0$var$_error = $17f0eb1c35d045f0$var$_interopRequireDefault((parcelRequire("2di5f")));
function $17f0eb1c35d045f0$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $17f0eb1c35d045f0$var$ErrorIcon = (props)=>/*#__PURE__*/ $17f0eb1c35d045f0$var$_react.default.createElement($0X9jl.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><path fill="currentcolor" d="M13.416 4.417a2 2 0 0 0-2.832 0l-6.168 6.167a2 2 0 0 0 0 2.833l6.168 6.167a2 2 0 0 0 2.832 0l6.168-6.167a2 2 0 0 0 0-2.833z"/><path fill="inherit" d="M12 14a1 1 0 0 1-1-1V8a1 1 0 0 1 2 0v5a1 1 0 0 1-1 1m0 3a1 1 0 0 1 0-2 1 1 0 0 1 0 2"/></g></svg>`
    }, props, {
        newIcon: $17f0eb1c35d045f0$var$_error.default
    }));
$17f0eb1c35d045f0$var$ErrorIcon.displayName = 'ErrorIcon';
var $17f0eb1c35d045f0$var$_default = module.exports.default = $17f0eb1c35d045f0$var$ErrorIcon;

});


parcelRegister("dOHNL", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::783ce92761ea23bbb39745cb99e4a6be>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a0f1ebf580fdcc58$var$_react = $a0f1ebf580fdcc58$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $a0f1ebf580fdcc58$var$_warning = $a0f1ebf580fdcc58$var$_interopRequireDefault((parcelRequire("huCdT")));

var $a0f1ebf580fdcc58$var$_warning2 = $a0f1ebf580fdcc58$var$_interopRequireDefault((parcelRequire("fY37a")));
function $a0f1ebf580fdcc58$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for WarningIcon.
 * This component is WarningIcon, with `UNSAFE_fallbackIcon` set to "WarningIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for warning system status.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a0f1ebf580fdcc58$var$WarningIcon = (props)=>/*#__PURE__*/ $a0f1ebf580fdcc58$var$_react.default.createElement($a0f1ebf580fdcc58$var$_warning.default, Object.assign({
        LEGACY_fallbackIcon: $a0f1ebf580fdcc58$var$_warning2.default
    }, props));
$a0f1ebf580fdcc58$var$WarningIcon.Name = 'WarningIconMigration';
var $a0f1ebf580fdcc58$var$_default = module.exports.default = $a0f1ebf580fdcc58$var$WarningIcon;

});
parcelRegister("huCdT", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::1447c2d9394cec1fac504fd0d225fa23>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $cbc2e3512191778a$var$_react = $cbc2e3512191778a$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $cbc2e3512191778a$var$_baseNew = $cbc2e3512191778a$var$_interopRequireDefault((parcelRequire("g471E")));
function $cbc2e3512191778a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Warning".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for warning system status.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $cbc2e3512191778a$var$WarningIcon = (props)=>/*#__PURE__*/ $cbc2e3512191778a$var$_react.default.createElement($cbc2e3512191778a$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6.242 1.169c.757-1.396 2.76-1.396 3.516 0l5.9 10.878C16.381 13.379 15.416 15 13.9 15H2.1C.584 15-.38 13.38.342 12.047zM7.25 9.5v-5h1.5v5zM8 12.75a1 1 0 1 0 0-2 1 1 0 0 0 0 2" clip-rule="evenodd"/>`
    }, props));
$cbc2e3512191778a$var$WarningIcon.displayName = 'WarningIcon';
var $cbc2e3512191778a$var$_default = module.exports.default = $cbc2e3512191778a$var$WarningIcon;

});

parcelRegister("fY37a", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b9fee0180e753f5e$var$_react = $b9fee0180e753f5e$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $0X9jl = parcelRequire("0X9jl");

var $b9fee0180e753f5e$var$_warning = $b9fee0180e753f5e$var$_interopRequireDefault((parcelRequire("huCdT")));
function $b9fee0180e753f5e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $b9fee0180e753f5e$var$WarningIcon = (props)=>/*#__PURE__*/ $b9fee0180e753f5e$var$_react.default.createElement($0X9jl.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><path fill="currentcolor" d="M12.938 4.967c-.518-.978-1.36-.974-1.876 0L3.938 18.425c-.518.978-.045 1.771 1.057 1.771h14.01c1.102 0 1.573-.797 1.057-1.771z"/><path fill="inherit" d="M12 15a1 1 0 0 1-1-1V9a1 1 0 0 1 2 0v5a1 1 0 0 1-1 1m0 3a1 1 0 0 1 0-2 1 1 0 0 1 0 2"/></g></svg>`
    }, props, {
        newIcon: $b9fee0180e753f5e$var$_warning.default
    }));
$b9fee0180e753f5e$var$WarningIcon.displayName = 'WarningIcon';
var $b9fee0180e753f5e$var$_default = module.exports.default = $b9fee0180e753f5e$var$WarningIcon;

});



parcelRegister("7FyjL", function(module, exports) {
$parcel$export(module.exports, "default", () => $5956fb8d0e7a0c50$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ parcelRequire("5FkrB");

var $74Zh5 = parcelRequire("74Zh5");

var $3FlkA = parcelRequire("3FlkA");

var $id6Cu = parcelRequire("id6Cu");

var $2td33 = parcelRequire("2td33");

var $7R1rZ = parcelRequire("7R1rZ");

var $27ytc = parcelRequire("27ytc");
var $5956fb8d0e7a0c50$var$bodyStyles = (0, $74Zh5.css)({
    /* This ensures the body fills the whole space between header and footer. */ flex: '1 1 auto'
});
var $5956fb8d0e7a0c50$var$fontStyles = (0, $74Zh5.css)({
    font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
});
/**
 * Adding the padding here avoids cropping the keyline on its sides.
 * The combined vertical spacing is maintained by subtracting the
 * keyline height from header and footer using negative margins.
 */ var $5956fb8d0e7a0c50$var$bodyScrollStyles = (0, $74Zh5.css)({
    paddingBlock: "var(--ds-border-width-outline, 2px)",
    paddingInline: "var(--ds-space-300, 24px)"
});
/**
 * Keylines will not be shown if scrolling in viewport so we do
 * not account for them in this case.
 */ var $5956fb8d0e7a0c50$var$viewportScrollStyles = (0, $74Zh5.css)({
    paddingInline: "var(--ds-space-300, 24px)"
});
/**
 * __Modal body__
 *
 * A modal body is used to display the main content of a modal.
 *
 * - [Examples](https://atlassian.design/components/modal-dialog/examples)
 * - [Code](https://atlassian.design/components/modal-dialog/code#modal-body-props)
 * - [Usage](https://atlassian.design/components/modal-dialog/usage)
 */ var $5956fb8d0e7a0c50$var$ModalBody = function ModalBody(props) {
    var children = props.children, userDefinedTestId = props.testId;
    var _useModal = (0, $2td33.useModal)(), modalTestId = _useModal.testId;
    var shouldScrollInViewport = (0, $27ytc.default)();
    var testId = userDefinedTestId || modalTestId && "".concat(modalTestId, "--body");
    return shouldScrollInViewport ? (0, $74Zh5.jsx)("div", {
        css: [
            $5956fb8d0e7a0c50$var$bodyStyles,
            $5956fb8d0e7a0c50$var$viewportScrollStyles,
            (0, $id6Cu.fg)('platform_ads_explicit_font_styles') && $5956fb8d0e7a0c50$var$fontStyles
        ],
        "data-testid": testId
    }, children) : (0, $74Zh5.jsx)((0, $3FlkA.TouchScrollable), null, (0, $74Zh5.jsx)((0, $7R1rZ.default), {
        testId: userDefinedTestId || modalTestId
    }, (0, $74Zh5.jsx)("div", {
        css: [
            $5956fb8d0e7a0c50$var$bodyStyles,
            $5956fb8d0e7a0c50$var$bodyScrollStyles,
            (0, $id6Cu.fg)('platform_ads_explicit_font_styles') && $5956fb8d0e7a0c50$var$fontStyles
        ],
        "data-testid": testId
    }, children)));
};
var $5956fb8d0e7a0c50$export$2e2bcd8739ae039 = $5956fb8d0e7a0c50$var$ModalBody;

});
parcelRegister("7R1rZ", function(module, exports) {
$parcel$export(module.exports, "default", () => $5b7e9baa2f3a5c96$export$2e2bcd8739ae039);

var $iYJcE = parcelRequire("iYJcE");

var $25nEq = parcelRequire("25nEq");

var $5FkrB = parcelRequire("5FkrB");

var $74Zh5 = parcelRequire("74Zh5");

var $7QpUe = parcelRequire("7QpUe");

var $45Zis = parcelRequire("45Zis");

var $hd7HS = parcelRequire("hd7HS");

var $6qCqe = parcelRequire("6qCqe");

var $1kPX3 = parcelRequire("1kPX3");

var $eYQvF = parcelRequire("eYQvF");

var $5Rrqa = parcelRequire("5Rrqa");

var $dSRcG = parcelRequire("dSRcG");
var $5b7e9baa2f3a5c96$var$keylineColor = "var(--ds-border, ".concat((0, $dSRcG.N30), ")");
var $5b7e9baa2f3a5c96$var$baseStyles = (0, $74Zh5.css)((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({
    display: 'inherit',
    margin: "var(--ds-space-0, 0px)",
    flex: 'inherit',
    flexDirection: 'inherit',
    flexGrow: 1,
    overflowX: 'hidden',
    overflowY: 'auto'
}, (0, $5Rrqa.media).above.xs, {
    height: 'unset',
    overflowY: 'auto'
}));
var $5b7e9baa2f3a5c96$var$keylineHeight = 2;
var $5b7e9baa2f3a5c96$var$topKeylineStyles = (0, $74Zh5.css)({
    borderBlockStart: "var(--ds-border-width-outline, 2px)".concat(" solid ", $5b7e9baa2f3a5c96$var$keylineColor)
});
var $5b7e9baa2f3a5c96$var$bottomKeylineStyles = (0, $74Zh5.css)({
    borderBlockEnd: "var(--ds-border-width-outline, 2px)".concat(" solid ", $5b7e9baa2f3a5c96$var$keylineColor)
});
/**
 * A container that shows top and bottom keylines when the
 * content overflows into the scrollable element.
 */ var $5b7e9baa2f3a5c96$var$ScrollContainer = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function(_ref, ref) {
    var testId = _ref.testId, children = _ref.children;
    var scrollableRef = (0, $5FkrB.useRef)(null);
    var _useState = (0, $5FkrB.useState)(false), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), showTopKeyline = _useState2[0], setTopKeyline = _useState2[1];
    var _useState3 = (0, $5FkrB.useState)(false), _useState4 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState3, 2), showBottomKeyline = _useState4[0], setBottomKeyline = _useState4[1];
    var _useState5 = (0, $5FkrB.useState)(false), _useState6 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState5, 2), showContentFocus = _useState6[0], setContentFocus = _useState6[1];
    // Schedule a content focus on the target element
    // WARNING: In theory, `target` may not be available when `rafSchedule` hits in concurrent rendering
    (0, $5FkrB.useEffect)(function() {
        var schedule = (0, $45Zis.default)(function() {
            var target = scrollableRef.current;
            target && setContentFocus(target.scrollHeight > target.clientHeight);
        });
        schedule();
    }, [
        scrollableRef
    ]);
    var setLazyKeylines = (0, $1kPX3.default)((0, $45Zis.default)(function() {
        var target = scrollableRef.current;
        if (target) {
            var scrollableDistance = target.scrollHeight - target.clientHeight;
            if (target.previousElementSibling) setTopKeyline(target.scrollTop > $5b7e9baa2f3a5c96$var$keylineHeight);
            if (target.nextElementSibling) setBottomKeyline(target.scrollTop <= scrollableDistance - $5b7e9baa2f3a5c96$var$keylineHeight);
        }
    }));
    // On load (and scroll/resize events), we set "keylines"
    // these border the content to indicate scrollability when content underflows the header or footer
    (0, $5FkrB.useEffect)(function() {
        var target = scrollableRef.current;
        setLazyKeylines();
        var unbindWindowEvent = (0, $7QpUe.bind)(window, {
            type: 'resize',
            listener: setLazyKeylines
        });
        var unbindTargetEvent = target ? (0, $7QpUe.bind)(target, {
            type: 'scroll',
            listener: setLazyKeylines
        }) : (0, $6qCqe.default);
        return function() {
            unbindWindowEvent();
            unbindTargetEvent();
        };
    }, [
        setLazyKeylines
    ]);
    return (0, $74Zh5.jsx)((0, $eYQvF.default), {
        isInset: true
    }, (0, $74Zh5.jsx)("div", {
        // tabindex is allowed here so that keyboard users can scroll content
        // eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex
        tabIndex: showContentFocus ? 0 : undefined,
        role: showContentFocus ? 'region' : undefined,
        "aria-label": showContentFocus ? 'Scrollable content' : undefined,
        "data-testid": testId && "".concat(testId, "--scrollable"),
        ref: (0, $hd7HS.default)([
            ref,
            scrollableRef
        ]),
        css: [
            $5b7e9baa2f3a5c96$var$baseStyles,
            showTopKeyline && $5b7e9baa2f3a5c96$var$topKeylineStyles,
            showBottomKeyline && $5b7e9baa2f3a5c96$var$bottomKeylineStyles
        ]
    }, children));
});
$5b7e9baa2f3a5c96$var$ScrollContainer.displayName = 'ScrollContainer';
var $5b7e9baa2f3a5c96$export$2e2bcd8739ae039 = $5b7e9baa2f3a5c96$var$ScrollContainer;

});

parcelRegister("27ytc", function(module, exports) {
$parcel$export(module.exports, "default", () => $18b6f939cbfe7197$export$2e2bcd8739ae039);

var $5FkrB = parcelRequire("5FkrB");

var $bwuZo = parcelRequire("bwuZo");
function $18b6f939cbfe7197$export$2e2bcd8739ae039() {
    var shouldScrollInViewport = (0, $5FkrB.useContext)((0, $bwuZo.ScrollContext));
    if (shouldScrollInViewport == null) throw Error("@atlaskit/modal-dialog: Scroll context unavailable \u2013 this component needs to be a child of ModalDialog.");
    return shouldScrollInViewport;
}

});


parcelRegister("bhMlj", function(module, exports) {
$parcel$export(module.exports, "default", () => $8376c81df8fe94b6$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $74Zh5 = parcelRequire("74Zh5");

var $2td33 = parcelRequire("2td33");
var $8376c81df8fe94b6$var$footerStyles = (0, $74Zh5.css)({
    display: 'flex',
    position: 'relative',
    alignItems: 'center',
    justifyContent: 'flex-end',
    gap: "var(--ds-space-100, 8px)",
    marginBlockStart: "calc(-1 * ".concat("var(--ds-border-width-outline, 2px)", ")"),
    paddingBlockEnd: "var(--ds-space-300, 24px)",
    paddingBlockStart: "var(--ds-space-200, 16px)",
    paddingInline: "var(--ds-space-300, 24px)"
});
/**
 * __Modal footer__
 *
 * A modal footer often contains a primary action and the ability to cancel and close the dialog, though can contain any React element.
 *
 * - [Examples](https://atlassian.design/components/modal-dialog/examples#modal-footer)
 * - [Code](https://atlassian.design/components/modal-dialog/code#modal-footer-props)
 * - [Usage](https://atlassian.design/components/modal-dialog/usage)
 */ var $8376c81df8fe94b6$var$ModalFooter = function ModalFooter(props) {
    var children = props.children, userDefinedTestId = props.testId;
    var _useModal = (0, $2td33.useModal)(), modalTestId = _useModal.testId;
    var testId = userDefinedTestId || modalTestId && "".concat(modalTestId, "--footer");
    return (0, $74Zh5.jsx)("div", {
        css: $8376c81df8fe94b6$var$footerStyles,
        "data-testid": testId
    }, children);
};
var $8376c81df8fe94b6$export$2e2bcd8739ae039 = $8376c81df8fe94b6$var$ModalFooter;

});


parcelRegister("427nl", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => (parcelRequire("2CKum")).default);
$parcel$export(module.exports, "LinkButton", () => (parcelRequire("3WRgz")).default);
$parcel$export(module.exports, "IconButton", () => (parcelRequire("lyGTA")).default);
$parcel$export(module.exports, "LinkIconButton", () => (parcelRequire("b1PNV")).default);
$parcel$export(module.exports, "SplitButton", () => (parcelRequire("c0yaC")).SplitButton);

var $2CKum = parcelRequire("2CKum");

var $3WRgz = parcelRequire("3WRgz");

var $lyGTA = parcelRequire("lyGTA");

var $b1PNV = parcelRequire("b1PNV");

var $c0yaC = parcelRequire("c0yaC");

});
parcelRegister("2CKum", function(module, exports) {
$parcel$export(module.exports, "default", () => $1e93311623e425b4$export$2e2bcd8739ae039);

var $kqp0i = parcelRequire("kqp0i");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");

var $1C5BS = parcelRequire("1C5BS");

var $gGtQh = parcelRequire("gGtQh");
var $1e93311623e425b4$var$_excluded = [
    "analyticsContext",
    "appearance",
    "aria-label",
    "aria-labelledby",
    "autoFocus",
    "children",
    "iconAfter",
    "iconBefore",
    "interactionName",
    "isDisabled",
    "isLoading",
    "isSelected",
    "onClick",
    "onClickCapture",
    "onKeyDownCapture",
    "onKeyUpCapture",
    "onMouseDownCapture",
    "onMouseUpCapture",
    "onPointerDownCapture",
    "onPointerUpCapture",
    "onTouchEndCapture",
    "onTouchStartCapture",
    "shouldFitContainer",
    "spacing",
    "testId",
    "type"
], $1e93311623e425b4$var$_excluded2 = [
    "className",
    "css",
    "as",
    "style"
];
/**
 * __Button__
 *
 * A button triggers an event or action.
 *
 * - [Examples](https://atlassian.design/components/button/examples)
 * - [Code](https://atlassian.design/components/button/code)
 * - [Usage](https://atlassian.design/components/button/usage)
 */ var $1e93311623e425b4$var$Button = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).forwardRef(function Button(_ref, ref) {
    var analyticsContext = _ref.analyticsContext, appearance = _ref.appearance, ariaLabel = _ref['aria-label'], ariaLabelledBy = _ref['aria-labelledby'], autoFocus = _ref.autoFocus, children = _ref.children, iconAfter = _ref.iconAfter, iconBefore = _ref.iconBefore, interactionName = _ref.interactionName, isDisabled = _ref.isDisabled, isLoading = _ref.isLoading, isSelected = _ref.isSelected, onClick = _ref.onClick, onClickCapture = _ref.onClickCapture, onKeyDownCapture = _ref.onKeyDownCapture, onKeyUpCapture = _ref.onKeyUpCapture, onMouseDownCapture = _ref.onMouseDownCapture, onMouseUpCapture = _ref.onMouseUpCapture, onPointerDownCapture = _ref.onPointerDownCapture, onPointerUpCapture = _ref.onPointerUpCapture, onTouchEndCapture = _ref.onTouchEndCapture, onTouchStartCapture = _ref.onTouchStartCapture, shouldFitContainer = _ref.shouldFitContainer, spacing = _ref.spacing, testId = _ref.testId, _ref$type = _ref.type, type = _ref$type === void 0 ? 'button' : _ref$type, unsafeRest = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $1e93311623e425b4$var$_excluded);
    // @ts-expect-error
    var _className = unsafeRest.className, _css = unsafeRest.css, _as = unsafeRest.as, _style = unsafeRest.style, saferRest = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(unsafeRest, $1e93311623e425b4$var$_excluded2);
    var baseProps = (0, $gGtQh.default)({
        ariaLabel: ariaLabel,
        ariaLabelledBy: ariaLabelledBy,
        analyticsContext: analyticsContext,
        appearance: appearance,
        autoFocus: autoFocus,
        buttonType: 'button',
        children: children,
        iconAfter: iconAfter,
        iconBefore: iconBefore,
        interactionName: interactionName,
        isDisabled: isDisabled,
        isLoading: isLoading,
        isSelected: isSelected,
        onClick: onClick,
        onClickCapture: onClickCapture,
        onKeyDownCapture: onKeyDownCapture,
        onKeyUpCapture: onKeyUpCapture,
        onMouseDownCapture: onMouseDownCapture,
        onMouseUpCapture: onMouseUpCapture,
        onPointerDownCapture: onPointerDownCapture,
        onPointerUpCapture: onPointerUpCapture,
        onTouchEndCapture: onTouchEndCapture,
        onTouchStartCapture: onTouchStartCapture,
        ref: ref,
        shouldFitContainer: shouldFitContainer,
        spacing: spacing,
        testId: testId
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $1C5BS.default), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, saferRest, {
        "aria-label": baseProps['aria-label'],
        "aria-labelledby": baseProps['aria-labelledby'],
        ref: baseProps.ref,
        xcss: baseProps.xcss,
        isDisabled: baseProps.isDisabled,
        onClick: baseProps.onClick,
        onMouseDownCapture: baseProps.onMouseDownCapture,
        onMouseUpCapture: baseProps.onMouseUpCapture,
        onKeyDownCapture: baseProps.onKeyDownCapture,
        onKeyUpCapture: baseProps.onKeyUpCapture,
        onTouchStartCapture: baseProps.onTouchStartCapture,
        onTouchEndCapture: baseProps.onTouchEndCapture,
        onPointerDownCapture: baseProps.onPointerDownCapture,
        onPointerUpCapture: baseProps.onPointerUpCapture,
        onClickCapture: baseProps.onClickCapture,
        type: type,
        testId: testId,
        analyticsContext: analyticsContext,
        interactionName: interactionName,
        componentName: "Button"
    }), baseProps.children);
}));
$1e93311623e425b4$var$Button.displayName = 'Button';
var $1e93311623e425b4$export$2e2bcd8739ae039 = $1e93311623e425b4$var$Button;

});
parcelRegister("1C5BS", function(module, exports) {
$parcel$export(module.exports, "default", () => $12cdb10bcb916007$export$2e2bcd8739ae039);

var $kqp0i = parcelRequire("kqp0i");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");

var $74Zh5 = parcelRequire("74Zh5");

var $cmfNk = parcelRequire("cmfNk");

var $h1LyZ = parcelRequire("h1LyZ");

var $i0Qin = parcelRequire("i0Qin");

var $hkJI5 = parcelRequire("hkJI5");

var $d7pIx = parcelRequire("d7pIx");
var $12cdb10bcb916007$var$_excluded = [
    "children",
    "backgroundColor",
    "padding",
    "paddingBlock",
    "paddingBlockStart",
    "paddingBlockEnd",
    "paddingInline",
    "paddingInlineStart",
    "paddingInlineEnd",
    "isDisabled",
    "type",
    "onClick",
    "interactionName",
    "componentName",
    "analyticsContext",
    "style",
    "testId",
    "xcss"
], $12cdb10bcb916007$var$_excluded2 = [
    "className"
];
// This duplicates FocusRing styles from `@atlaskit/focus-ring`.
var $12cdb10bcb916007$var$focusRingStyles = (0, $74Zh5.css)({
    '&:focus, &:focus-visible': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        outlineColor: (0, $hkJI5.borderColorMap)['color.border.focused'],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        outlineOffset: (0, $hkJI5.positiveSpaceMap)['space.025'],
        outlineStyle: 'solid',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        outlineWidth: (0, $hkJI5.borderWidthMap)['border.width.outline']
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
    '&:focus:not(:focus-visible)': {
        outline: 'none'
    },
    '@media screen and (forced-colors: active), screen and (-ms-high-contrast: active)': {
        '&:focus-visible': {
            outline: '1px solid'
        }
    }
});
var $12cdb10bcb916007$var$baseStyles = (0, $74Zh5.css)({
    boxSizing: 'border-box',
    appearance: 'none',
    border: 'none'
});
var $12cdb10bcb916007$var$enabledStyles = (0, $74Zh5.css)({
    cursor: 'pointer'
});
var $12cdb10bcb916007$var$disabledStyles = (0, $74Zh5.css)({
    cursor: 'not-allowed'
});
/**
 * __Pressable__
 *
 * A primitive for building custom buttons.
 *
 * - [Examples](https://atlassian.design/components/primitives/pressable/examples)
 * - [Code](https://atlassian.design/components/primitives/pressable/code)
 * - [Usage](https://atlassian.design/components/primitives/pressable/usage)
 */ var $12cdb10bcb916007$var$Pressable = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function(_ref, ref) {
    var children = _ref.children, backgroundColor = _ref.backgroundColor, padding = _ref.padding, paddingBlock = _ref.paddingBlock, paddingBlockStart = _ref.paddingBlockStart, paddingBlockEnd = _ref.paddingBlockEnd, paddingInline = _ref.paddingInline, paddingInlineStart = _ref.paddingInlineStart, paddingInlineEnd = _ref.paddingInlineEnd, isDisabled = _ref.isDisabled, _ref$type = _ref.type, type = _ref$type === void 0 ? 'button' : _ref$type, _ref$onClick = _ref.onClick, providedOnClick = _ref$onClick === void 0 ? (0, $h1LyZ.default) : _ref$onClick, interactionName = _ref.interactionName, componentName = _ref.componentName, analyticsContext = _ref.analyticsContext, style = _ref.style, testId = _ref.testId, xcss = _ref.xcss, htmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $12cdb10bcb916007$var$_excluded);
    var interactionContext = (0, $5FkrB.useContext)((0, $i0Qin.default));
    var handleClick = (0, $5FkrB.useCallback)(function(e, analyticsEvent) {
        interactionContext && interactionContext.tracePress(interactionName, e.timeStamp);
        providedOnClick(e, analyticsEvent);
    }, [
        providedOnClick,
        interactionContext,
        interactionName
    ]);
    var onClick = (0, $cmfNk.usePlatformLeafEventHandler)({
        fn: handleClick,
        action: 'clicked',
        componentName: componentName || 'Pressable',
        packageName: "@atlaskit/primitives",
        packageVersion: "13.6.0",
        analyticsData: analyticsContext,
        actionSubject: 'button'
    });
    // This is to remove className from safeHtmlAttributes
    // @ts-expect-error className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(htmlAttributes, $12cdb10bcb916007$var$_excluded2);
    var resolvedStyles = (0, $d7pIx.parseXcss)(xcss);
    return(// eslint-disable-next-line @atlaskit/design-system/no-html-button
    (0, $74Zh5.jsx)("button", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: style,
        ref: ref,
        className: resolvedStyles.static
    }, safeHtmlAttributes, {
        // eslint-disable-next-line react/button-has-type
        type: type,
        onClick: onClick,
        disabled: isDisabled,
        css: [
            $12cdb10bcb916007$var$baseStyles,
            $12cdb10bcb916007$var$focusRingStyles,
            isDisabled ? $12cdb10bcb916007$var$disabledStyles : $12cdb10bcb916007$var$enabledStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            backgroundColor && (0, $hkJI5.backgroundColorStylesMap)[backgroundColor],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            padding && (0, $hkJI5.paddingStylesMap).padding[padding],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlock && (0, $hkJI5.paddingStylesMap).paddingBlock[paddingBlock],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlockStart && (0, $hkJI5.paddingStylesMap).paddingBlockStart[paddingBlockStart],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlockEnd && (0, $hkJI5.paddingStylesMap).paddingBlockEnd[paddingBlockEnd],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInline && (0, $hkJI5.paddingStylesMap).paddingInline[paddingInline],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInlineStart && (0, $hkJI5.paddingStylesMap).paddingInlineStart[paddingInlineStart],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInlineEnd && (0, $hkJI5.paddingStylesMap).paddingInlineEnd[paddingInlineEnd],
            // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
            resolvedStyles.emotion
        ],
        "data-testid": testId
    }), children));
});
var $12cdb10bcb916007$export$2e2bcd8739ae039 = $12cdb10bcb916007$var$Pressable;

});
parcelRegister("cmfNk", function(module, exports) {
$parcel$export(module.exports, "usePlatformLeafEventHandler", () => $8ff3ca9578ff378c$export$a4687b0234b40e28);

var $25nEq = parcelRequire("25nEq");

var $5FkrB = parcelRequire("5FkrB");

var $hQ6Uq = parcelRequire("hQ6Uq");

var $aFyjd = parcelRequire("aFyjd");
function $8ff3ca9578ff378c$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $8ff3ca9578ff378c$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $8ff3ca9578ff378c$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $8ff3ca9578ff378c$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $8ff3ca9578ff378c$export$a4687b0234b40e28(_ref) {
    var fn = _ref.fn, action = _ref.action, componentName = _ref.componentName, actionSubject = _ref.actionSubject, packageName = _ref.packageName, packageVersion = _ref.packageVersion, analyticsData = _ref.analyticsData;
    var _useAnalyticsEvents = (0, $hQ6Uq.useAnalyticsEvents)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
    // We put analyticsData and fn in a ref so that we don't need to break
    // memoization.
    // Generally these could be defined by consumers inline
    // and so we do this to avoid breaking memoization of useCallback
    var dataRef = (0, $aFyjd.useTrackedRef)(analyticsData);
    var fnRef = (0, $aFyjd.useTrackedRef)(fn);
    var handler = (0, $5FkrB.useCallback)(function(value) {
        var analyticsEvent = createAnalyticsEvent({
            action: action,
            actionSubject: actionSubject || componentName,
            attributes: {
                componentName: componentName,
                packageName: packageName,
                packageVersion: packageVersion
            }
        });
        // To avoid wrapping this component in AnalyticsContext we manually
        // push the parent context's meta data into the context.
        // Note: this new 'context'
        var context = $8ff3ca9578ff378c$var$_objectSpread({
            componentName: componentName,
            packageName: packageName,
            packageVersion: packageVersion
        }, dataRef.current);
        analyticsEvent.context.push(context);
        // fire an event on the atlaskit channel
        var clone = analyticsEvent.clone();
        if (clone) clone.fire('atlaskit');
        fnRef.current(value, analyticsEvent);
    }, [
        // These are strings and won't change
        action,
        componentName,
        actionSubject,
        packageName,
        packageVersion,
        // This function is memoized in the context
        createAnalyticsEvent,
        // these are a stable ref because of the useTrackedRef hook
        dataRef,
        fnRef
    ]);
    return handler;
}

});
parcelRegister("hQ6Uq", function(module, exports) {
$parcel$export(module.exports, "useAnalyticsEvents", () => $cfcca6fd3e1ba90a$export$5bf35293e545f20c);

var $dLGML = parcelRequire("dLGML");

var $dyWaF = parcelRequire("dyWaF");

var $ePFpc = parcelRequire("ePFpc");
function $cfcca6fd3e1ba90a$export$5bf35293e545f20c() {
    var analyticsContext = (0, $ePFpc.useAnalyticsContext)();
    var createAnalyticsEvent = (0, $dLGML.useCallbackOne)(function(payload) {
        return new (0, $dyWaF.default)({
            context: analyticsContext.getAtlaskitAnalyticsContext(),
            handlers: analyticsContext.getAtlaskitAnalyticsEventHandlers(),
            payload: payload
        });
    }, [
        analyticsContext
    ]);
    return {
        createAnalyticsEvent: createAnalyticsEvent
    };
}

});
parcelRegister("dyWaF", function(module, exports) {
$parcel$export(module.exports, "default", () => $9dfb92eba949427e$export$2e2bcd8739ae039);

var $fC8ib = parcelRequire("fC8ib");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $kIXpt = parcelRequire("kIXpt");

var $cYPzS = parcelRequire("cYPzS");

var $lwlXp = parcelRequire("lwlXp");

var $eyuDe = parcelRequire("eyuDe");

var $25nEq = parcelRequire("25nEq");

var $5VbcN = parcelRequire("5VbcN");
function $9dfb92eba949427e$var$_callSuper(t, o, e) {
    return o = (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(o), (0, (/*@__PURE__*/$parcel$interopDefault($kIXpt)))(t, $9dfb92eba949427e$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(t).constructor) : o.apply(t, e));
}
function $9dfb92eba949427e$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($9dfb92eba949427e$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $9dfb92eba949427e$var$_superPropGet(t, o, e, r) {
    var p = (0, (/*@__PURE__*/$parcel$interopDefault($lwlXp)))((0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(1 & r ? t.prototype : t), o, e);
    return 2 & r && "function" == typeof p ? function(t) {
        return p.apply(e, t);
    } : p;
}
var $9dfb92eba949427e$export$35f8383928ba8d7 = function isUIAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $9dfb92eba949427e$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isUIAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === 'UIAnalyticsEvent';
};
var $9dfb92eba949427e$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_AnalyticsEvent) {
    function UIAnalyticsEvent(props) {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, UIAnalyticsEvent);
        _this = $9dfb92eba949427e$var$_callSuper(this, UIAnalyticsEvent, [
            props
        ]);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "_isUIAnalyticsEvent", true);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "clone", function() {
            if (_this.hasFired) return null;
            var context = (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(_this.context);
            var handlers = (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(_this.handlers);
            /**
       * A hacky "deep clone" of the object. This is limited in that it wont
       * support functions, regexs, Maps, Sets, etc, but none of those need to
       * be represented in our payload.
       */ var payload = JSON.parse(JSON.stringify(_this.payload));
            return new UIAnalyticsEvent({
                context: context,
                handlers: handlers,
                payload: payload
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "fire", function(channel) {
            if (_this.hasFired) return;
            _this.handlers.forEach(function(handler) {
                return handler(_this, channel);
            });
            _this.hasFired = true;
        });
        _this.context = props.context || [];
        _this.handlers = props.handlers || [];
        _this.hasFired = false;
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($eyuDe)))(UIAnalyticsEvent, _AnalyticsEvent);
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(UIAnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (this.hasFired) return this;
                return $9dfb92eba949427e$var$_superPropGet(UIAnalyticsEvent, "update", this, 3)([
                    updater
                ]);
            }
        }
    ]);
}((0, $5VbcN.default));

});
parcelRegister("5VbcN", function(module, exports) {
$parcel$export(module.exports, "default", () => $44faf7c6995638d8$export$2e2bcd8739ae039);

var $ekGgq = parcelRequire("ekGgq");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $25nEq = parcelRequire("25nEq");
function $44faf7c6995638d8$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $44faf7c6995638d8$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $44faf7c6995638d8$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $44faf7c6995638d8$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $44faf7c6995638d8$export$ad4be5c2ec28cecf = function isAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $44faf7c6995638d8$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === 'AnalyticsEvent';
};
var $44faf7c6995638d8$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function AnalyticsEvent(props) {
        var _this = this;
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, AnalyticsEvent);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "_isAnalyticsEvent", true);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "clone", function() {
            // just a shallow clone, don't change sub refs unless you want to
            // affect the original's too
            var payload = $44faf7c6995638d8$var$_objectSpread({}, _this.payload);
            return new AnalyticsEvent({
                payload: payload
            });
        });
        this.payload = props.payload;
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(AnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (typeof updater === 'function') this.payload = updater(this.payload);
                if ((0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(updater) === 'object') this.payload = $44faf7c6995638d8$var$_objectSpread($44faf7c6995638d8$var$_objectSpread({}, this.payload), updater);
                return this;
            }
        }
    ]);
}();

});


parcelRegister("ePFpc", function(module, exports) {
$parcel$export(module.exports, "useAnalyticsContext", () => $acc5f258667171ce$export$d1f587f82ad51c4);

var $5FkrB = parcelRequire("5FkrB");

var $iyyOp = parcelRequire("iyyOp");
var $acc5f258667171ce$export$d1f587f82ad51c4 = function useAnalyticsContext() {
    return (0, $5FkrB.useContext)((0, $iyyOp.default));
};

});


parcelRegister("aFyjd", function(module, exports) {
$parcel$export(module.exports, "useTrackedRef", () => $7c4858bfffb8599c$export$1d27a74659855e44);

var $5FkrB = parcelRequire("5FkrB");
var $7c4858bfffb8599c$export$1d27a74659855e44 = function useTrackedRef(value) {
    var ref = (0, $5FkrB.useRef)(value);
    ref.current = value;
    return ref;
};

});


parcelRegister("h1LyZ", function(module, exports) {
$parcel$export(module.exports, "default", () => $c6576cc46a999172$export$2e2bcd8739ae039);
/**
 * An empty function which does nothing.
 */ // eslint-disable-next-line @repo/internal/react/use-noop
function $c6576cc46a999172$export$2e2bcd8739ae039() {}

});

parcelRegister("i0Qin", function(module, exports) {
$parcel$export(module.exports, "default", () => $d1d0cadada59f03d$export$2e2bcd8739ae039);

var $5FkrB = parcelRequire("5FkrB");
var $d1d0cadada59f03d$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $5FkrB.createContext)(null);

});

parcelRegister("hkJI5", function(module, exports) {
$parcel$export(module.exports, "dimensionMap", () => $c9e7c30141c6e39c$export$6ccdbebca2ee545f);
$parcel$export(module.exports, "positiveSpaceMap", () => $c9e7c30141c6e39c$export$958d0ae7f2977ae4);
$parcel$export(module.exports, "allSpaceMap", () => $c9e7c30141c6e39c$export$632685d741f3dbbf);
$parcel$export(module.exports, "opacityMap", () => $c9e7c30141c6e39c$export$daf94a976c798b4f);
$parcel$export(module.exports, "shadowMap", () => $c9e7c30141c6e39c$export$7aff6e7ba39bb774);
$parcel$export(module.exports, "borderColorMap", () => $c9e7c30141c6e39c$export$1531ad5bb3fbedac);
$parcel$export(module.exports, "backgroundColorMap", () => $c9e7c30141c6e39c$export$d1d79bf68ac056bd);
$parcel$export(module.exports, "textColorMap", () => $c9e7c30141c6e39c$export$8473307aa00d6ea1);
$parcel$export(module.exports, "layerMap", () => $c9e7c30141c6e39c$export$b5f31a7e431d2eab);
$parcel$export(module.exports, "borderWidthMap", () => $c9e7c30141c6e39c$export$e1b83c5210c471b8);
$parcel$export(module.exports, "borderRadiusMap", () => $c9e7c30141c6e39c$export$3c0a6c3e64bb180d);
$parcel$export(module.exports, "fontMap", () => $c9e7c30141c6e39c$export$6ffa317d5e70375);
$parcel$export(module.exports, "fontWeightMap", () => $c9e7c30141c6e39c$export$303e322c6b1ed114);
$parcel$export(module.exports, "fontFamilyMap", () => $c9e7c30141c6e39c$export$3c7e9587132614b4);
$parcel$export(module.exports, "paddingStylesMap", () => $c9e7c30141c6e39c$export$e615f061ca585a6c);
$parcel$export(module.exports, "spaceStylesMap", () => $c9e7c30141c6e39c$export$bf46c3f9eeafc71f);
$parcel$export(module.exports, "backgroundColorStylesMap", () => $c9e7c30141c6e39c$export$e7af83bafe7f9e63);
$parcel$export(module.exports, "surfaceColorStylesMap", () => $c9e7c30141c6e39c$export$ff257d957d48c421);
$parcel$export(module.exports, "isSurfaceColorToken", () => $c9e7c30141c6e39c$export$5e65a44e5b6ecadb);

var $25nEq = parcelRequire("25nEq");

var $74Zh5 = parcelRequire("74Zh5");

var $4tSBK = parcelRequire("4tSBK");
function $c9e7c30141c6e39c$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $c9e7c30141c6e39c$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $c9e7c30141c6e39c$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $c9e7c30141c6e39c$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $c9e7c30141c6e39c$export$6ccdbebca2ee545f = {
    '100%': '100%',
    'size.100': '1rem',
    'size.200': '1.5rem',
    'size.300': '2rem',
    'size.400': '2.5rem',
    'size.500': '3rem',
    'size.600': '6rem',
    'size.1000': '12rem'
};
var $c9e7c30141c6e39c$export$958d0ae7f2977ae4 = {
    'space.0': "var(--ds-space-0, 0px)",
    'space.025': "var(--ds-space-025, 2px)",
    'space.050': "var(--ds-space-050, 4px)",
    'space.075': "var(--ds-space-075, 6px)",
    'space.100': "var(--ds-space-100, 8px)",
    'space.150': "var(--ds-space-150, 12px)",
    'space.200': "var(--ds-space-200, 16px)",
    'space.250': "var(--ds-space-250, 20px)",
    'space.300': "var(--ds-space-300, 24px)",
    'space.400': "var(--ds-space-400, 32px)",
    'space.500': "var(--ds-space-500, 40px)",
    'space.600': "var(--ds-space-600, 48px)",
    'space.800': "var(--ds-space-800, 64px)",
    'space.1000': "var(--ds-space-1000, 80px)"
};
var $c9e7c30141c6e39c$export$d2dc61f58390201c = {
    'space.negative.025': "var(--ds-space-negative-025, -2px)",
    'space.negative.050': "var(--ds-space-negative-050, -4px)",
    'space.negative.075': "var(--ds-space-negative-075, -6px)",
    'space.negative.100': "var(--ds-space-negative-100, -8px)",
    'space.negative.150': "var(--ds-space-negative-150, -12px)",
    'space.negative.200': "var(--ds-space-negative-200, -16px)",
    'space.negative.250': "var(--ds-space-negative-250, -20px)",
    'space.negative.300': "var(--ds-space-negative-300, -24px)",
    'space.negative.400': "var(--ds-space-negative-400, -32px)"
};
var $c9e7c30141c6e39c$export$632685d741f3dbbf = $c9e7c30141c6e39c$var$_objectSpread($c9e7c30141c6e39c$var$_objectSpread({}, $c9e7c30141c6e39c$export$958d0ae7f2977ae4), $c9e7c30141c6e39c$export$d2dc61f58390201c);
var $c9e7c30141c6e39c$export$2185ce37f9bdd963 = {
    'color.background.neutral.bold': 'color.text.inverse',
    'color.background.neutral.bold.hovered': 'color.text.inverse',
    'color.background.neutral.bold.pressed': 'color.text.inverse',
    'color.background.selected.bold': 'color.text.inverse',
    'color.background.selected.bold.hovered': 'color.text.inverse',
    'color.background.selected.bold.pressed': 'color.text.inverse',
    'color.background.brand.bold': 'color.text.inverse',
    'color.background.brand.bold.hovered': 'color.text.inverse',
    'color.background.brand.bold.pressed': 'color.text.inverse',
    'color.background.brand.boldest': 'color.text.inverse',
    'color.background.brand.boldest.hovered': 'color.text.inverse',
    'color.background.brand.boldest.pressed': 'color.text.inverse',
    'color.background.danger.bold': 'color.text.inverse',
    'color.background.danger.bold.hovered': 'color.text.inverse',
    'color.background.danger.bold.pressed': 'color.text.inverse',
    'color.background.warning.bold': 'color.text.warning.inverse',
    'color.background.warning.bold.hovered': 'color.text.warning.inverse',
    'color.background.warning.bold.pressed': 'color.text.warning.inverse',
    'color.background.success.bold': 'color.text.inverse',
    'color.background.success.bold.hovered': 'color.text.inverse',
    'color.background.success.bold.pressed': 'color.text.inverse',
    'color.background.discovery.bold': 'color.text.inverse',
    'color.background.discovery.bold.hovered': 'color.text.inverse',
    'color.background.discovery.bold.pressed': 'color.text.inverse',
    'color.background.information.bold': 'color.text.inverse',
    'color.background.information.bold.hovered': 'color.text.inverse',
    'color.background.information.bold.pressed': 'color.text.inverse'
};
var $c9e7c30141c6e39c$export$daf94a976c798b4f = {
    'opacity.disabled': "var(--ds-opacity-disabled, 0.4)",
    'opacity.loading': "var(--ds-opacity-loading, 0.2)"
};
var $c9e7c30141c6e39c$export$7aff6e7ba39bb774 = {
    'elevation.shadow.overflow': "var(--ds-shadow-overflow, 0px 0px 8px #091e423f, 0px 0px 1px #091e424f)",
    'elevation.shadow.overflow.perimeter': "var(--ds-shadow-overflow-perimeter, #091e421f)",
    'elevation.shadow.overflow.spread': "var(--ds-shadow-overflow-spread, #091e4229)",
    'elevation.shadow.overlay': "var(--ds-shadow-overlay, 0px 8px 12px #091e423f, 0px 0px 1px #091e424f)",
    'elevation.shadow.raised': "var(--ds-shadow-raised, 0px 1px 1px #091e423f, 0px 0px 1px #091e4221)"
};
var $c9e7c30141c6e39c$export$41a358c9c2356760 = {
    'elevation.surface': "var(--ds-surface, #FFFFFF)",
    'elevation.surface.hovered': "var(--ds-surface-hovered, #FAFBFC)",
    'elevation.surface.pressed': "var(--ds-surface-pressed, #F4F5F7)",
    'elevation.surface.overlay': "var(--ds-surface-overlay, #FFFFFF)",
    'elevation.surface.overlay.hovered': "var(--ds-surface-overlay-hovered, #FAFBFC)",
    'elevation.surface.overlay.pressed': "var(--ds-surface-overlay-pressed, #F4F5F7)",
    'elevation.surface.raised': "var(--ds-surface-raised, #FFFFFF)",
    'elevation.surface.raised.hovered': "var(--ds-surface-raised-hovered, #FAFBFC)",
    'elevation.surface.raised.pressed': "var(--ds-surface-raised-pressed, #F4F5F7)",
    'elevation.surface.sunken': "var(--ds-surface-sunken, #F4F5F7)"
};
var $c9e7c30141c6e39c$export$1531ad5bb3fbedac = {
    'color.border': "var(--ds-border, #091e4221)",
    'color.border.accent.lime': "var(--ds-border-accent-lime, #6A9A23)",
    'color.border.accent.red': "var(--ds-border-accent-red, #FF5630)",
    'color.border.accent.orange': "var(--ds-border-accent-orange, #D94008)",
    'color.border.accent.yellow': "var(--ds-border-accent-yellow, #FFAB00)",
    'color.border.accent.green': "var(--ds-border-accent-green, #36B37E)",
    'color.border.accent.teal': "var(--ds-border-accent-teal, #00B8D9)",
    'color.border.accent.blue': "var(--ds-border-accent-blue, #0065FF)",
    'color.border.accent.purple': "var(--ds-border-accent-purple, #6554C0)",
    'color.border.accent.magenta': "var(--ds-border-accent-magenta, #CD519D)",
    'color.border.accent.gray': "var(--ds-border-accent-gray, #5E6C84)",
    'color.border.disabled': "var(--ds-border-disabled, #FAFBFC)",
    'color.border.focused': "var(--ds-border-focused, #2684FF)",
    'color.border.input': "var(--ds-border-input, #FAFBFC)",
    'color.border.inverse': "var(--ds-border-inverse, #FFFFFF)",
    'color.border.selected': "var(--ds-border-selected, #0052CC)",
    'color.border.brand': "var(--ds-border-brand, #0052CC)",
    'color.border.danger': "var(--ds-border-danger, #FF5630)",
    'color.border.warning': "var(--ds-border-warning, #FFC400)",
    'color.border.success': "var(--ds-border-success, #00875A)",
    'color.border.discovery': "var(--ds-border-discovery, #998DD9)",
    'color.border.information': "var(--ds-border-information, #0065FF)",
    'color.border.bold': "var(--ds-border-bold, #344563)"
};
var $c9e7c30141c6e39c$export$d1d79bf68ac056bd = {
    'color.background.accent.lime.subtlest': "var(--ds-background-accent-lime-subtlest, #EEFBDA)",
    'color.background.accent.lime.subtlest.hovered': "var(--ds-background-accent-lime-subtlest-hovered, #D3F1A7)",
    'color.background.accent.lime.subtlest.pressed': "var(--ds-background-accent-lime-subtlest-pressed, #B3DF72)",
    'color.background.accent.lime.subtler': "var(--ds-background-accent-lime-subtler, #D3F1A7)",
    'color.background.accent.lime.subtler.hovered': "var(--ds-background-accent-lime-subtler-hovered, #B3DF72)",
    'color.background.accent.lime.subtler.pressed': "var(--ds-background-accent-lime-subtler-pressed, #94C748)",
    'color.background.accent.lime.subtle': "var(--ds-background-accent-lime-subtle, #94C748)",
    'color.background.accent.lime.subtle.hovered': "var(--ds-background-accent-lime-subtle-hovered, #B3DF72)",
    'color.background.accent.lime.subtle.pressed': "var(--ds-background-accent-lime-subtle-pressed, #D3F1A7)",
    'color.background.accent.lime.bolder': "var(--ds-background-accent-lime-bolder, #5B7F24)",
    'color.background.accent.lime.bolder.hovered': "var(--ds-background-accent-lime-bolder-hovered, #37471F)",
    'color.background.accent.lime.bolder.pressed': "var(--ds-background-accent-lime-bolder-pressed, #37471F)",
    'color.background.accent.red.subtlest': "var(--ds-background-accent-red-subtlest, #FF8F73)",
    'color.background.accent.red.subtlest.hovered': "var(--ds-background-accent-red-subtlest-hovered, #FF7452)",
    'color.background.accent.red.subtlest.pressed': "var(--ds-background-accent-red-subtlest-pressed, #FF5630)",
    'color.background.accent.red.subtler': "var(--ds-background-accent-red-subtler, #FF7452)",
    'color.background.accent.red.subtler.hovered': "var(--ds-background-accent-red-subtler-hovered, #FF5630)",
    'color.background.accent.red.subtler.pressed': "var(--ds-background-accent-red-subtler-pressed, #DE350B)",
    'color.background.accent.red.subtle': "var(--ds-background-accent-red-subtle, #DE350B)",
    'color.background.accent.red.subtle.hovered': "var(--ds-background-accent-red-subtle-hovered, #FF5630)",
    'color.background.accent.red.subtle.pressed': "var(--ds-background-accent-red-subtle-pressed, #FF7452)",
    'color.background.accent.red.bolder': "var(--ds-background-accent-red-bolder, #DE350B)",
    'color.background.accent.red.bolder.hovered': "var(--ds-background-accent-red-bolder-hovered, #FF5630)",
    'color.background.accent.red.bolder.pressed': "var(--ds-background-accent-red-bolder-pressed, #FF7452)",
    'color.background.accent.orange.subtlest': "var(--ds-background-accent-orange-subtlest, #F18D13)",
    'color.background.accent.orange.subtlest.hovered': "var(--ds-background-accent-orange-subtlest-hovered, #FEC57B)",
    'color.background.accent.orange.subtlest.pressed': "var(--ds-background-accent-orange-subtlest-pressed, #FFE2BD)",
    'color.background.accent.orange.subtler': "var(--ds-background-accent-orange-subtler, #B65C02)",
    'color.background.accent.orange.subtler.hovered': "var(--ds-background-accent-orange-subtler-hovered, #F18D13)",
    'color.background.accent.orange.subtler.pressed': "var(--ds-background-accent-orange-subtler-pressed, #FEC57B)",
    'color.background.accent.orange.subtle': "var(--ds-background-accent-orange-subtle, #5F3811)",
    'color.background.accent.orange.subtle.hovered': "var(--ds-background-accent-orange-subtle-hovered, #974F0C)",
    'color.background.accent.orange.subtle.pressed': "var(--ds-background-accent-orange-subtle-pressed, #B65C02)",
    'color.background.accent.orange.bolder': "var(--ds-background-accent-orange-bolder, #43290F)",
    'color.background.accent.orange.bolder.hovered': "var(--ds-background-accent-orange-bolder-hovered, #5F3811)",
    'color.background.accent.orange.bolder.pressed': "var(--ds-background-accent-orange-bolder-pressed, #974F0C)",
    'color.background.accent.yellow.subtlest': "var(--ds-background-accent-yellow-subtlest, #FFE380)",
    'color.background.accent.yellow.subtlest.hovered': "var(--ds-background-accent-yellow-subtlest-hovered, #FFC400)",
    'color.background.accent.yellow.subtlest.pressed': "var(--ds-background-accent-yellow-subtlest-pressed, #FFAB00)",
    'color.background.accent.yellow.subtler': "var(--ds-background-accent-yellow-subtler, #FFC400)",
    'color.background.accent.yellow.subtler.hovered': "var(--ds-background-accent-yellow-subtler-hovered, #FFAB00)",
    'color.background.accent.yellow.subtler.pressed': "var(--ds-background-accent-yellow-subtler-pressed, #FF991F)",
    'color.background.accent.yellow.subtle': "var(--ds-background-accent-yellow-subtle, #FF991F)",
    'color.background.accent.yellow.subtle.hovered': "var(--ds-background-accent-yellow-subtle-hovered, #FFAB00)",
    'color.background.accent.yellow.subtle.pressed': "var(--ds-background-accent-yellow-subtle-pressed, #FFC400)",
    'color.background.accent.yellow.bolder': "var(--ds-background-accent-yellow-bolder, #FF991F)",
    'color.background.accent.yellow.bolder.hovered': "var(--ds-background-accent-yellow-bolder-hovered, #FFAB00)",
    'color.background.accent.yellow.bolder.pressed': "var(--ds-background-accent-yellow-bolder-pressed, #FFC400)",
    'color.background.accent.green.subtlest': "var(--ds-background-accent-green-subtlest, #79F2C0)",
    'color.background.accent.green.subtlest.hovered': "var(--ds-background-accent-green-subtlest-hovered, #57D9A3)",
    'color.background.accent.green.subtlest.pressed': "var(--ds-background-accent-green-subtlest-pressed, #36B37E)",
    'color.background.accent.green.subtler': "var(--ds-background-accent-green-subtler, #57D9A3)",
    'color.background.accent.green.subtler.hovered': "var(--ds-background-accent-green-subtler-hovered, #36B37E)",
    'color.background.accent.green.subtler.pressed': "var(--ds-background-accent-green-subtler-pressed, #00875A)",
    'color.background.accent.green.subtle': "var(--ds-background-accent-green-subtle, #00875A)",
    'color.background.accent.green.subtle.hovered': "var(--ds-background-accent-green-subtle-hovered, #36B37E)",
    'color.background.accent.green.subtle.pressed': "var(--ds-background-accent-green-subtle-pressed, #57D9A3)",
    'color.background.accent.green.bolder': "var(--ds-background-accent-green-bolder, #00875A)",
    'color.background.accent.green.bolder.hovered': "var(--ds-background-accent-green-bolder-hovered, #36B37E)",
    'color.background.accent.green.bolder.pressed': "var(--ds-background-accent-green-bolder-pressed, #57D9A3)",
    'color.background.accent.teal.subtlest': "var(--ds-background-accent-teal-subtlest, #79E2F2)",
    'color.background.accent.teal.subtlest.hovered': "var(--ds-background-accent-teal-subtlest-hovered, #00C7E6)",
    'color.background.accent.teal.subtlest.pressed': "var(--ds-background-accent-teal-subtlest-pressed, #00B8D9)",
    'color.background.accent.teal.subtler': "var(--ds-background-accent-teal-subtler, #00C7E6)",
    'color.background.accent.teal.subtler.hovered': "var(--ds-background-accent-teal-subtler-hovered, #00B8D9)",
    'color.background.accent.teal.subtler.pressed': "var(--ds-background-accent-teal-subtler-pressed, #00A3BF)",
    'color.background.accent.teal.subtle': "var(--ds-background-accent-teal-subtle, #00A3BF)",
    'color.background.accent.teal.subtle.hovered': "var(--ds-background-accent-teal-subtle-hovered, #00B8D9)",
    'color.background.accent.teal.subtle.pressed': "var(--ds-background-accent-teal-subtle-pressed, #00C7E6)",
    'color.background.accent.teal.bolder': "var(--ds-background-accent-teal-bolder, #00A3BF)",
    'color.background.accent.teal.bolder.hovered': "var(--ds-background-accent-teal-bolder-hovered, #00B8D9)",
    'color.background.accent.teal.bolder.pressed': "var(--ds-background-accent-teal-bolder-pressed, #00C7E6)",
    'color.background.accent.blue.subtlest': "var(--ds-background-accent-blue-subtlest, #4C9AFF)",
    'color.background.accent.blue.subtlest.hovered': "var(--ds-background-accent-blue-subtlest-hovered, #2684FF)",
    'color.background.accent.blue.subtlest.pressed': "var(--ds-background-accent-blue-subtlest-pressed, #0065FF)",
    'color.background.accent.blue.subtler': "var(--ds-background-accent-blue-subtler, #2684FF)",
    'color.background.accent.blue.subtler.hovered': "var(--ds-background-accent-blue-subtler-hovered, #0065FF)",
    'color.background.accent.blue.subtler.pressed': "var(--ds-background-accent-blue-subtler-pressed, #0052CC)",
    'color.background.accent.blue.subtle': "var(--ds-background-accent-blue-subtle, #0052CC)",
    'color.background.accent.blue.subtle.hovered': "var(--ds-background-accent-blue-subtle-hovered, #0065FF)",
    'color.background.accent.blue.subtle.pressed': "var(--ds-background-accent-blue-subtle-pressed, #2684FF)",
    'color.background.accent.blue.bolder': "var(--ds-background-accent-blue-bolder, #0052CC)",
    'color.background.accent.blue.bolder.hovered': "var(--ds-background-accent-blue-bolder-hovered, #0065FF)",
    'color.background.accent.blue.bolder.pressed': "var(--ds-background-accent-blue-bolder-pressed, #2684FF)",
    'color.background.accent.purple.subtlest': "var(--ds-background-accent-purple-subtlest, #998DD9)",
    'color.background.accent.purple.subtlest.hovered': "var(--ds-background-accent-purple-subtlest-hovered, #8777D9)",
    'color.background.accent.purple.subtlest.pressed': "var(--ds-background-accent-purple-subtlest-pressed, #6554C0)",
    'color.background.accent.purple.subtler': "var(--ds-background-accent-purple-subtler, #8777D9)",
    'color.background.accent.purple.subtler.hovered': "var(--ds-background-accent-purple-subtler-hovered, #6554C0)",
    'color.background.accent.purple.subtler.pressed': "var(--ds-background-accent-purple-subtler-pressed, #5243AA)",
    'color.background.accent.purple.subtle': "var(--ds-background-accent-purple-subtle, #5243AA)",
    'color.background.accent.purple.subtle.hovered': "var(--ds-background-accent-purple-subtle-hovered, #6554C0)",
    'color.background.accent.purple.subtle.pressed': "var(--ds-background-accent-purple-subtle-pressed, #8777D9)",
    'color.background.accent.purple.bolder': "var(--ds-background-accent-purple-bolder, #5243AA)",
    'color.background.accent.purple.bolder.hovered': "var(--ds-background-accent-purple-bolder-hovered, #6554C0)",
    'color.background.accent.purple.bolder.pressed': "var(--ds-background-accent-purple-bolder-pressed, #8777D9)",
    'color.background.accent.magenta.subtlest': "var(--ds-background-accent-magenta-subtlest, #FFECF8)",
    'color.background.accent.magenta.subtlest.hovered': "var(--ds-background-accent-magenta-subtlest-hovered, #FDD0EC)",
    'color.background.accent.magenta.subtlest.pressed': "var(--ds-background-accent-magenta-subtlest-pressed, #F797D2)",
    'color.background.accent.magenta.subtler': "var(--ds-background-accent-magenta-subtler, #FDD0EC)",
    'color.background.accent.magenta.subtler.hovered': "var(--ds-background-accent-magenta-subtler-hovered, #F797D2)",
    'color.background.accent.magenta.subtler.pressed': "var(--ds-background-accent-magenta-subtler-pressed, #E774BB)",
    'color.background.accent.magenta.subtle': "var(--ds-background-accent-magenta-subtle, #E774BB)",
    'color.background.accent.magenta.subtle.hovered': "var(--ds-background-accent-magenta-subtle-hovered, #F797D2)",
    'color.background.accent.magenta.subtle.pressed': "var(--ds-background-accent-magenta-subtle-pressed, #FDD0EC)",
    'color.background.accent.magenta.bolder': "var(--ds-background-accent-magenta-bolder, #AE4787)",
    'color.background.accent.magenta.bolder.hovered': "var(--ds-background-accent-magenta-bolder-hovered, #943D73)",
    'color.background.accent.magenta.bolder.pressed': "var(--ds-background-accent-magenta-bolder-pressed, #50253F)",
    'color.background.accent.gray.subtlest': "var(--ds-background-accent-gray-subtlest, #6B778C)",
    'color.background.accent.gray.subtlest.hovered': "var(--ds-background-accent-gray-subtlest-hovered, #5E6C84)",
    'color.background.accent.gray.subtlest.pressed': "var(--ds-background-accent-gray-subtlest-pressed, #505F79)",
    'color.background.accent.gray.subtler': "var(--ds-background-accent-gray-subtler, #5E6C84)",
    'color.background.accent.gray.subtler.hovered': "var(--ds-background-accent-gray-subtler-hovered, #505F79)",
    'color.background.accent.gray.subtler.pressed': "var(--ds-background-accent-gray-subtler-pressed, #42526E)",
    'color.background.accent.gray.subtle': "var(--ds-background-accent-gray-subtle, #505F79)",
    'color.background.accent.gray.subtle.hovered': "var(--ds-background-accent-gray-subtle-hovered, #5E6C84)",
    'color.background.accent.gray.subtle.pressed': "var(--ds-background-accent-gray-subtle-pressed, #6B778C)",
    'color.background.accent.gray.bolder': "var(--ds-background-accent-gray-bolder, #42526E)",
    'color.background.accent.gray.bolder.hovered': "var(--ds-background-accent-gray-bolder-hovered, #344563)",
    'color.background.accent.gray.bolder.pressed': "var(--ds-background-accent-gray-bolder-pressed, #253858)",
    'color.background.disabled': "var(--ds-background-disabled, #091e4289)",
    'color.background.input': "var(--ds-background-input, #FAFBFC)",
    'color.background.input.hovered': "var(--ds-background-input-hovered, #EBECF0)",
    'color.background.input.pressed': "var(--ds-background-input-pressed, #FFFFFF)",
    'color.background.inverse.subtle': "var(--ds-background-inverse-subtle, #00000029)",
    'color.background.inverse.subtle.hovered': "var(--ds-background-inverse-subtle-hovered, #0000003D)",
    'color.background.inverse.subtle.pressed': "var(--ds-background-inverse-subtle-pressed, #00000052)",
    'color.background.neutral': "var(--ds-background-neutral, #DFE1E6)",
    'color.background.neutral.hovered': "var(--ds-background-neutral-hovered, #091e4214)",
    'color.background.neutral.pressed': "var(--ds-background-neutral-pressed, #B3D4FF)",
    'color.background.neutral.subtle': "var(--ds-background-neutral-subtle, transparent)",
    'color.background.neutral.subtle.hovered': "var(--ds-background-neutral-subtle-hovered, #091e4214)",
    'color.background.neutral.subtle.pressed': "var(--ds-background-neutral-subtle-pressed, #B3D4FF)",
    'color.background.neutral.bold': "var(--ds-background-neutral-bold, #42526E)",
    'color.background.neutral.bold.hovered': "var(--ds-background-neutral-bold-hovered, #505F79)",
    'color.background.neutral.bold.pressed': "var(--ds-background-neutral-bold-pressed, #344563)",
    'color.background.selected': "var(--ds-background-selected, #DEEBFF)",
    'color.background.selected.hovered': "var(--ds-background-selected-hovered, #B3D4FF)",
    'color.background.selected.pressed': "var(--ds-background-selected-pressed, #4C9AFF)",
    'color.background.selected.bold': "var(--ds-background-selected-bold, #0052CC)",
    'color.background.selected.bold.hovered': "var(--ds-background-selected-bold-hovered, #2684FF)",
    'color.background.selected.bold.pressed': "var(--ds-background-selected-bold-pressed, #0052CC)",
    'color.background.brand.subtlest': "var(--ds-background-brand-subtlest, #B3D4FF)",
    'color.background.brand.subtlest.hovered': "var(--ds-background-brand-subtlest-hovered, #DEEBFF)",
    'color.background.brand.subtlest.pressed': "var(--ds-background-brand-subtlest-pressed, #4C9AFF)",
    'color.background.brand.bold': "var(--ds-background-brand-bold, #0052CC)",
    'color.background.brand.bold.hovered': "var(--ds-background-brand-bold-hovered, #0065FF)",
    'color.background.brand.bold.pressed': "var(--ds-background-brand-bold-pressed, #0747A6)",
    'color.background.brand.boldest': "var(--ds-background-brand-boldest, #0747A6)",
    'color.background.brand.boldest.hovered': "var(--ds-background-brand-boldest-hovered, #0052CC)",
    'color.background.brand.boldest.pressed': "var(--ds-background-brand-boldest-pressed, #0747A6)",
    'color.background.danger': "var(--ds-background-danger, #FFEBE6)",
    'color.background.danger.hovered': "var(--ds-background-danger-hovered, #FFBDAD)",
    'color.background.danger.pressed': "var(--ds-background-danger-pressed, #FF8F73)",
    'color.background.danger.bold': "var(--ds-background-danger-bold, #DE350B)",
    'color.background.danger.bold.hovered': "var(--ds-background-danger-bold-hovered, #FF5630)",
    'color.background.danger.bold.pressed': "var(--ds-background-danger-bold-pressed, #BF2600)",
    'color.background.warning': "var(--ds-background-warning, #FFFAE6)",
    'color.background.warning.hovered': "var(--ds-background-warning-hovered, #FFF0B3)",
    'color.background.warning.pressed': "var(--ds-background-warning-pressed, #FFE380)",
    'color.background.warning.bold': "var(--ds-background-warning-bold, #FFAB00)",
    'color.background.warning.bold.hovered': "var(--ds-background-warning-bold-hovered, #FFC400)",
    'color.background.warning.bold.pressed': "var(--ds-background-warning-bold-pressed, #FF991F)",
    'color.background.success': "var(--ds-background-success, #E3FCEF)",
    'color.background.success.hovered': "var(--ds-background-success-hovered, #ABF5D1)",
    'color.background.success.pressed': "var(--ds-background-success-pressed, #79F2C0)",
    'color.background.success.bold': "var(--ds-background-success-bold, #00875A)",
    'color.background.success.bold.hovered': "var(--ds-background-success-bold-hovered, #57D9A3)",
    'color.background.success.bold.pressed': "var(--ds-background-success-bold-pressed, #00875A)",
    'color.background.discovery': "var(--ds-background-discovery, #EAE6FF)",
    'color.background.discovery.hovered': "var(--ds-background-discovery-hovered, #C0B6F2)",
    'color.background.discovery.pressed': "var(--ds-background-discovery-pressed, #998DD9)",
    'color.background.discovery.bold': "var(--ds-background-discovery-bold, #5243AA)",
    'color.background.discovery.bold.hovered': "var(--ds-background-discovery-bold-hovered, #8777D9)",
    'color.background.discovery.bold.pressed': "var(--ds-background-discovery-bold-pressed, #5243AA)",
    'color.background.information': "var(--ds-background-information, #DEEBFF)",
    'color.background.information.hovered': "var(--ds-background-information-hovered, #B3D4FF)",
    'color.background.information.pressed': "var(--ds-background-information-pressed, #4C9AFF)",
    'color.background.information.bold': "var(--ds-background-information-bold, #0052CC)",
    'color.background.information.bold.hovered': "var(--ds-background-information-bold-hovered, #2684FF)",
    'color.background.information.bold.pressed': "var(--ds-background-information-bold-pressed, #0052CC)",
    'color.blanket': "var(--ds-blanket, #091e4289)",
    'color.blanket.selected': "var(--ds-blanket-selected, #388BFF14)",
    'color.blanket.danger': "var(--ds-blanket-danger, #EF5C4814)",
    'color.skeleton': "var(--ds-skeleton, #F4F5F7)",
    'color.skeleton.subtle': "var(--ds-skeleton-subtle, #091e420a)",
    'elevation.surface': "var(--ds-surface, #FFFFFF)",
    'elevation.surface.hovered': "var(--ds-surface-hovered, #FAFBFC)",
    'elevation.surface.pressed': "var(--ds-surface-pressed, #F4F5F7)",
    'elevation.surface.overlay': "var(--ds-surface-overlay, #FFFFFF)",
    'elevation.surface.overlay.hovered': "var(--ds-surface-overlay-hovered, #FAFBFC)",
    'elevation.surface.overlay.pressed': "var(--ds-surface-overlay-pressed, #F4F5F7)",
    'elevation.surface.raised': "var(--ds-surface-raised, #FFFFFF)",
    'elevation.surface.raised.hovered': "var(--ds-surface-raised-hovered, #FAFBFC)",
    'elevation.surface.raised.pressed': "var(--ds-surface-raised-pressed, #F4F5F7)",
    'elevation.surface.sunken': "var(--ds-surface-sunken, #F4F5F7)",
    'utility.elevation.surface.current': "var(--ds-elevation-surface-current, #FFFFFF)"
};
var $c9e7c30141c6e39c$export$8473307aa00d6ea1 = {
    'color.text': "var(--ds-text, #172B4D)",
    'color.text.accent.lime': "var(--ds-text-accent-lime, #4C6B1F)",
    'color.text.accent.lime.bolder': "var(--ds-text-accent-lime-bolder, #37471F)",
    'color.text.accent.red': "var(--ds-text-accent-red, #DE350B)",
    'color.text.accent.red.bolder': "var(--ds-text-accent-red-bolder, #BF2600)",
    'color.text.accent.orange': "var(--ds-text-accent-orange, #F18D13)",
    'color.text.accent.orange.bolder': "var(--ds-text-accent-orange-bolder, #B65C02)",
    'color.text.accent.yellow': "var(--ds-text-accent-yellow, #FF991F)",
    'color.text.accent.yellow.bolder': "var(--ds-text-accent-yellow-bolder, #FF8B00)",
    'color.text.accent.green': "var(--ds-text-accent-green, #00875A)",
    'color.text.accent.green.bolder': "var(--ds-text-accent-green-bolder, #006644)",
    'color.text.accent.teal': "var(--ds-text-accent-teal, #00A3BF)",
    'color.text.accent.teal.bolder': "var(--ds-text-accent-teal-bolder, #008DA6)",
    'color.text.accent.blue': "var(--ds-text-accent-blue, #0052CC)",
    'color.text.accent.blue.bolder': "var(--ds-text-accent-blue-bolder, #0747A6)",
    'color.text.accent.purple': "var(--ds-text-accent-purple, #5243AA)",
    'color.text.accent.purple.bolder': "var(--ds-text-accent-purple-bolder, #403294)",
    'color.text.accent.magenta': "var(--ds-text-accent-magenta, #E774BB)",
    'color.text.accent.magenta.bolder': "var(--ds-text-accent-magenta-bolder, #DA62AC)",
    'color.text.accent.gray': "var(--ds-text-accent-gray, #505F79)",
    'color.text.accent.gray.bolder': "var(--ds-text-accent-gray-bolder, #172B4D)",
    'color.text.disabled': "var(--ds-text-disabled, #A5ADBA)",
    'color.text.inverse': "var(--ds-text-inverse, #FFFFFF)",
    'color.text.selected': "var(--ds-text-selected, #0052CC)",
    'color.text.brand': "var(--ds-text-brand, #0065FF)",
    'color.text.danger': "var(--ds-text-danger, #DE350B)",
    'color.text.warning': "var(--ds-text-warning, #974F0C)",
    'color.text.warning.inverse': "var(--ds-text-warning-inverse, #172B4D)",
    'color.text.success': "var(--ds-text-success, #006644)",
    'color.text.discovery': "var(--ds-text-discovery, #403294)",
    'color.text.information': "var(--ds-text-information, #0052CC)",
    'color.text.subtlest': "var(--ds-text-subtlest, #7A869A)",
    'color.text.subtle': "var(--ds-text-subtle, #42526E)",
    'color.link': "var(--ds-link, #0052CC)",
    'color.link.pressed': "var(--ds-link-pressed, #0747A6)",
    'color.link.visited': "var(--ds-link-visited, #403294)",
    'color.link.visited.pressed': "var(--ds-link-visited-pressed, #403294)"
};
var $c9e7c30141c6e39c$export$498780f74be9af68 = {
    'color.icon': "var(--ds-icon, #505F79)",
    'color.icon.accent.lime': "var(--ds-icon-accent-lime, #6A9A23)",
    'color.icon.accent.red': "var(--ds-icon-accent-red, #FF5630)",
    'color.icon.accent.orange': "var(--ds-icon-accent-orange, #D94008)",
    'color.icon.accent.yellow': "var(--ds-icon-accent-yellow, #FFAB00)",
    'color.icon.accent.green': "var(--ds-icon-accent-green, #36B37E)",
    'color.icon.accent.teal': "var(--ds-icon-accent-teal, #00B8D9)",
    'color.icon.accent.blue': "var(--ds-icon-accent-blue, #0065FF)",
    'color.icon.accent.purple': "var(--ds-icon-accent-purple, #6554C0)",
    'color.icon.accent.magenta': "var(--ds-icon-accent-magenta, #CD519D)",
    'color.icon.accent.gray': "var(--ds-icon-accent-gray, #5E6C84)",
    'color.icon.disabled': "var(--ds-icon-disabled, #8993A4)",
    'color.icon.inverse': "var(--ds-icon-inverse, #FFFFFF)",
    'color.icon.selected': "var(--ds-icon-selected, #0052CC)",
    'color.icon.brand': "var(--ds-icon-brand, #0065FF)",
    'color.icon.danger': "var(--ds-icon-danger, #DE350B)",
    'color.icon.warning': "var(--ds-icon-warning, #FFC400)",
    'color.icon.warning.inverse': "var(--ds-icon-warning-inverse, #253858)",
    'color.icon.success': "var(--ds-icon-success, #00875A)",
    'color.icon.discovery': "var(--ds-icon-discovery, #8777D9)",
    'color.icon.information': "var(--ds-icon-information, #0747A6)",
    'color.icon.subtle': "var(--ds-icon-subtle, #6B778C)"
};
var $c9e7c30141c6e39c$export$b5f31a7e431d2eab = {
    '1': 1,
    card: 100,
    navigation: 200,
    dialog: 300,
    layer: 400,
    blanket: 500,
    modal: 510,
    flag: 600,
    spotlight: 700,
    tooltip: 800
};
var $c9e7c30141c6e39c$export$e1b83c5210c471b8 = {
    'border.width': "var(--ds-border-width, 1px)",
    'border.width.0': "var(--ds-border-width-0, 0px)",
    'border.width.indicator': "var(--ds-border-width-indicator, 3px)",
    'border.width.outline': "var(--ds-border-width-outline, 2px)"
};
var $c9e7c30141c6e39c$export$3c0a6c3e64bb180d = {
    'border.radius.050': "var(--ds-border-radius-050, 2px)",
    'border.radius': "var(--ds-border-radius, 3px)",
    'border.radius.100': "var(--ds-border-radius-100, 3px)",
    'border.radius.200': "var(--ds-border-radius-200, 8px)",
    'border.radius.300': "var(--ds-border-radius-300, 12px)",
    'border.radius.400': "var(--ds-border-radius-400, 16px)",
    'border.radius.circle': "var(--ds-border-radius-circle, 32032px)"
};
var $c9e7c30141c6e39c$export$6ffa317d5e70375 = {
    'font.body': "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    'font.body.UNSAFE_small': "var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    'font.body.large': "var(--ds-font-body-large, normal 400 16px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    'font.body.small': "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    'font.code': "var(--ds-font-code, normal 400 0.875em/1 ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)",
    'font.heading.large': "var(--ds-font-heading-large, normal 500 24px/28px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    'font.heading.medium': "var(--ds-font-heading-medium, normal 500 20px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    'font.heading.small': "var(--ds-font-heading-small, normal 600 16px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    'font.heading.xlarge': "var(--ds-font-heading-xlarge, normal 600 29px/32px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    'font.heading.xsmall': "var(--ds-font-heading-xsmall, normal 600 14px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    'font.heading.xxlarge': "var(--ds-font-heading-xxlarge, normal 500 35px/40px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    'font.heading.xxsmall': "var(--ds-font-heading-xxsmall, normal 600 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)"
};
var $c9e7c30141c6e39c$export$303e322c6b1ed114 = {
    'font.weight.bold': "var(--ds-font-weight-bold, 700)",
    'font.weight.medium': "var(--ds-font-weight-medium, 500)",
    'font.weight.regular': "var(--ds-font-weight-regular, 400)",
    'font.weight.semibold': "var(--ds-font-weight-semibold, 600)"
};
var $c9e7c30141c6e39c$export$3c7e9587132614b4 = {
    'font.family.body': "var(--ds-font-family-body, ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    'font.family.brand.body': "var(--ds-font-family-brand-body, \"Charlie Text\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    'font.family.brand.heading': "var(--ds-font-family-brand-heading, \"Charlie Display\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    'font.family.code': "var(--ds-font-family-code, ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)",
    'font.family.heading': "var(--ds-font-family-heading, ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)"
};
var $c9e7c30141c6e39c$export$236bfe3a33ef1292 = {
    medium: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    UNSAFE_small: "var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    large: "var(--ds-font-body-large, normal 400 16px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    small: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)"
};
var $c9e7c30141c6e39c$export$855cfd311192d666 = {
    bold: "var(--ds-font-weight-bold, 700)",
    medium: "var(--ds-font-weight-medium, 500)",
    regular: "var(--ds-font-weight-regular, 400)",
    semibold: "var(--ds-font-weight-semibold, 600)"
};
/**
 * @codegenEnd
 */ // Margin needs some bespoke types: https://atlassian.slack.com/archives/CKRHB23K8/p1712623192772909
// Generate maps for Box props. backgroundColor, padding, etc
var $c9e7c30141c6e39c$var$spacingProperties = [
    // Used by Box
    'padding',
    'paddingBlock',
    'paddingBlockStart',
    'paddingBlockEnd',
    'paddingInline',
    'paddingInlineStart',
    'paddingInlineEnd',
    // Used by Inline and Stack
    'gap',
    'rowGap',
    'columnGap'
];
var $c9e7c30141c6e39c$export$ca0f9c2de39ffed7 = function getSerializedStylesMap(cssProperty, tokenMap) {
    return Object.keys(tokenMap).reduce(function(emotionSpacingMap, token) {
        // eslint-disable-next-line @repo/internal/styles/no-exported-styles
        emotionSpacingMap[token] = (0, $74Zh5.css)((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, cssProperty, tokenMap[token]));
        return emotionSpacingMap;
    }, {});
};
var $c9e7c30141c6e39c$export$e615f061ca585a6c = $c9e7c30141c6e39c$var$spacingProperties.reduce(function(styleMap, spacingProperty) {
    styleMap[spacingProperty] = $c9e7c30141c6e39c$export$ca0f9c2de39ffed7(spacingProperty, $c9e7c30141c6e39c$export$958d0ae7f2977ae4);
    return styleMap;
}, {});
var $c9e7c30141c6e39c$export$bf46c3f9eeafc71f = $c9e7c30141c6e39c$var$spacingProperties.reduce(function(styleMap, spacingProperty) {
    styleMap[spacingProperty] = $c9e7c30141c6e39c$export$ca0f9c2de39ffed7(spacingProperty, $c9e7c30141c6e39c$export$958d0ae7f2977ae4);
    return styleMap;
}, {});
var $c9e7c30141c6e39c$export$e7af83bafe7f9e63 = $c9e7c30141c6e39c$export$ca0f9c2de39ffed7('backgroundColor', $c9e7c30141c6e39c$export$d1d79bf68ac056bd);
var $c9e7c30141c6e39c$export$3a1bcba60b23d7f0 = $c9e7c30141c6e39c$export$ca0f9c2de39ffed7('color', $c9e7c30141c6e39c$export$8473307aa00d6ea1);
var $c9e7c30141c6e39c$export$45f3f4fe16f9f7d5 = $c9e7c30141c6e39c$export$ca0f9c2de39ffed7('fontWeight', $c9e7c30141c6e39c$export$303e322c6b1ed114);
var $c9e7c30141c6e39c$export$68cc305da27dbaa4 = $c9e7c30141c6e39c$export$ca0f9c2de39ffed7('fontFamily', $c9e7c30141c6e39c$export$3c7e9587132614b4);
var $c9e7c30141c6e39c$export$128f10c238242f83 = $c9e7c30141c6e39c$export$ca0f9c2de39ffed7('font', $c9e7c30141c6e39c$export$6ffa317d5e70375);
var $c9e7c30141c6e39c$export$219d364c0da35ae4 = $c9e7c30141c6e39c$export$ca0f9c2de39ffed7('font', $c9e7c30141c6e39c$export$236bfe3a33ef1292);
var $c9e7c30141c6e39c$export$38845ca010b93505 = $c9e7c30141c6e39c$export$ca0f9c2de39ffed7('fontWeight', $c9e7c30141c6e39c$export$855cfd311192d666);
var $c9e7c30141c6e39c$export$ff257d957d48c421 = $c9e7c30141c6e39c$export$ca0f9c2de39ffed7((0, $4tSBK.CURRENT_SURFACE_CSS_VAR), $c9e7c30141c6e39c$export$41a358c9c2356760);
var $c9e7c30141c6e39c$export$5e65a44e5b6ecadb = function isSurfaceColorToken(color) {
    return $c9e7c30141c6e39c$export$41a358c9c2356760[color] !== undefined;
};

});
parcelRegister("4tSBK", function(module, exports) {
$parcel$export(module.exports, "CURRENT_SURFACE_CSS_VAR", () => $34343ad623b21121$export$9d7b58831ae93caa);
var $34343ad623b21121$export$4ef52930e33717cd = 'data-theme';
var $34343ad623b21121$export$a00eac3f8684bcd0 = 'data-color-mode';
var $34343ad623b21121$export$2112803007239c61 = 'data-contrast-mode';
var $34343ad623b21121$export$352e418ed5b6193a = 'data-custom-theme';
var $34343ad623b21121$export$2faeed762aac6741 = 'light';
var $34343ad623b21121$export$6f0c6fb8c80fcc92 = 'ds';
var $34343ad623b21121$export$4d0c7bbf80185957 = [
    'opacity',
    'font',
    'space',
    'border'
];
var $34343ad623b21121$export$dddac1532e822863 = "--".concat($34343ad623b21121$export$6f0c6fb8c80fcc92, "-token-not-found");
var $34343ad623b21121$export$9d7b58831ae93caa = "--".concat($34343ad623b21121$export$6f0c6fb8c80fcc92, "-elevation-surface-current");

});


parcelRegister("d7pIx", function(module, exports) {
$parcel$export(module.exports, "parseXcss", () => $98cfe0bf6fbc0454$export$a9c84988c8f81f2d);
$parcel$export(module.exports, "xcss", () => $98cfe0bf6fbc0454$export$f6c783d06584602c);

var $fC8ib = parcelRequire("fC8ib");

var $25nEq = parcelRequire("25nEq");

var $iYJcE = parcelRequire("iYJcE");

var $ekGgq = parcelRequire("ekGgq");

var $74Zh5 = parcelRequire("74Zh5");

var $hkJI5 = parcelRequire("hkJI5");

var $3ZMUU = parcelRequire("3ZMUU");
function $98cfe0bf6fbc0454$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $98cfe0bf6fbc0454$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $98cfe0bf6fbc0454$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $98cfe0bf6fbc0454$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $98cfe0bf6fbc0454$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $98cfe0bf6fbc0454$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
var $98cfe0bf6fbc0454$export$9a199fbafee0014e = {
    backgroundColor: (0, $hkJI5.backgroundColorMap),
    blockSize: (0, $hkJI5.dimensionMap),
    borderBlockColor: (0, $hkJI5.borderColorMap),
    borderBlockEndColor: (0, $hkJI5.borderColorMap),
    borderBlockEndWidth: (0, $hkJI5.borderWidthMap),
    borderBlockStartColor: (0, $hkJI5.borderColorMap),
    borderBlockStartWidth: (0, $hkJI5.borderWidthMap),
    borderBlockWidth: (0, $hkJI5.borderWidthMap),
    borderBottomColor: (0, $hkJI5.borderColorMap),
    borderBottomLeftRadius: (0, $hkJI5.borderRadiusMap),
    borderBottomRightRadius: (0, $hkJI5.borderRadiusMap),
    borderBottomWidth: (0, $hkJI5.borderWidthMap),
    borderColor: (0, $hkJI5.borderColorMap),
    borderEndEndRadius: (0, $hkJI5.borderRadiusMap),
    borderEndStartRadius: (0, $hkJI5.borderRadiusMap),
    borderInlineColor: (0, $hkJI5.borderColorMap),
    borderInlineEndColor: (0, $hkJI5.borderColorMap),
    borderInlineEndWidth: (0, $hkJI5.borderWidthMap),
    borderInlineStartColor: (0, $hkJI5.borderColorMap),
    borderInlineStartWidth: (0, $hkJI5.borderWidthMap),
    borderInlineWidth: (0, $hkJI5.borderWidthMap),
    borderLeftColor: (0, $hkJI5.borderColorMap),
    borderLeftWidth: (0, $hkJI5.borderWidthMap),
    borderRadius: (0, $hkJI5.borderRadiusMap),
    borderRightColor: (0, $hkJI5.borderColorMap),
    borderRightWidth: (0, $hkJI5.borderWidthMap),
    borderStartEndRadius: (0, $hkJI5.borderRadiusMap),
    borderStartStartRadius: (0, $hkJI5.borderRadiusMap),
    borderTopColor: (0, $hkJI5.borderColorMap),
    borderTopLeftRadius: (0, $hkJI5.borderRadiusMap),
    borderTopRightRadius: (0, $hkJI5.borderRadiusMap),
    borderTopWidth: (0, $hkJI5.borderWidthMap),
    borderWidth: (0, $hkJI5.borderWidthMap),
    bottom: (0, $hkJI5.allSpaceMap),
    boxShadow: (0, $hkJI5.shadowMap),
    color: (0, $hkJI5.textColorMap),
    columnGap: (0, $hkJI5.positiveSpaceMap),
    font: (0, $hkJI5.fontMap),
    fontFamily: (0, $hkJI5.fontFamilyMap),
    fontWeight: (0, $hkJI5.fontWeightMap),
    gap: (0, $hkJI5.positiveSpaceMap),
    height: (0, $hkJI5.dimensionMap),
    inlineSize: (0, $hkJI5.dimensionMap),
    inset: (0, $hkJI5.allSpaceMap),
    insetBlock: (0, $hkJI5.allSpaceMap),
    insetBlockEnd: (0, $hkJI5.allSpaceMap),
    insetBlockStart: (0, $hkJI5.allSpaceMap),
    insetInline: (0, $hkJI5.allSpaceMap),
    insetInlineEnd: (0, $hkJI5.allSpaceMap),
    insetInlineStart: (0, $hkJI5.allSpaceMap),
    left: (0, $hkJI5.allSpaceMap),
    margin: (0, $hkJI5.allSpaceMap),
    marginBlock: (0, $hkJI5.allSpaceMap),
    marginBlockEnd: (0, $hkJI5.allSpaceMap),
    marginBlockStart: (0, $hkJI5.allSpaceMap),
    marginBottom: (0, $hkJI5.allSpaceMap),
    marginInline: (0, $hkJI5.allSpaceMap),
    marginInlineEnd: (0, $hkJI5.allSpaceMap),
    marginInlineStart: (0, $hkJI5.allSpaceMap),
    marginLeft: (0, $hkJI5.allSpaceMap),
    marginRight: (0, $hkJI5.allSpaceMap),
    marginTop: (0, $hkJI5.allSpaceMap),
    maxBlockSize: (0, $hkJI5.dimensionMap),
    maxHeight: (0, $hkJI5.dimensionMap),
    maxInlineSize: (0, $hkJI5.dimensionMap),
    maxWidth: (0, $hkJI5.dimensionMap),
    minBlockSize: (0, $hkJI5.dimensionMap),
    minHeight: (0, $hkJI5.dimensionMap),
    minInlineSize: (0, $hkJI5.dimensionMap),
    minWidth: (0, $hkJI5.dimensionMap),
    opacity: (0, $hkJI5.opacityMap),
    outlineColor: (0, $hkJI5.borderColorMap),
    outlineOffset: (0, $hkJI5.positiveSpaceMap),
    outlineWidth: (0, $hkJI5.borderWidthMap),
    padding: (0, $hkJI5.positiveSpaceMap),
    paddingBlock: (0, $hkJI5.positiveSpaceMap),
    paddingBlockEnd: (0, $hkJI5.positiveSpaceMap),
    paddingBlockStart: (0, $hkJI5.positiveSpaceMap),
    paddingBottom: (0, $hkJI5.positiveSpaceMap),
    paddingInline: (0, $hkJI5.positiveSpaceMap),
    paddingInlineEnd: (0, $hkJI5.positiveSpaceMap),
    paddingInlineStart: (0, $hkJI5.positiveSpaceMap),
    paddingLeft: (0, $hkJI5.positiveSpaceMap),
    paddingRight: (0, $hkJI5.positiveSpaceMap),
    paddingTop: (0, $hkJI5.positiveSpaceMap),
    right: (0, $hkJI5.allSpaceMap),
    rowGap: (0, $hkJI5.positiveSpaceMap),
    top: (0, $hkJI5.allSpaceMap),
    width: (0, $hkJI5.dimensionMap),
    zIndex: (0, $hkJI5.layerMap)
};
var $98cfe0bf6fbc0454$var$uniqueSymbol = Symbol('UNSAFE_INTERNAL_styles');
var $98cfe0bf6fbc0454$var$isSafeEnvToThrow = function isSafeEnvToThrow() {
    return (typeof $3ZMUU === "undefined" ? "undefined" : (0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))($3ZMUU)) === 'object' && (0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))($3ZMUU.env) === 'object' && false;
};
var $98cfe0bf6fbc0454$var$reNestedSelectors = /(\.|\s|&+|\*\>|#|\[.*\])/;
var $98cfe0bf6fbc0454$var$safeSelectors = /^@media .*$|^::?.*$|^@supports .*$/;
var $98cfe0bf6fbc0454$var$_transformStyles = function transformStyles(styleObj) {
    if (!styleObj || (0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(styleObj) !== 'object') return styleObj;
    // If styles are defined as a CSSObject[], recursively call on each element until we reach CSSObject
    if (Array.isArray(styleObj)) return styleObj.map($98cfe0bf6fbc0454$var$_transformStyles);
    // Modifies styleObj in place. Be careful.
    Object.entries(styleObj).forEach(function(_ref) {
        var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_ref, 2), key = _ref2[0], value = _ref2[1];
        // If key is a pseudo class or a pseudo element, then value should be an object.
        // So, call transformStyles on the value
        if ((0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(value) === 'object' && $98cfe0bf6fbc0454$var$safeSelectors.test(key)) {
            styleObj[key] = $98cfe0bf6fbc0454$var$_transformStyles(value);
            return;
        }
        if ($98cfe0bf6fbc0454$var$isSafeEnvToThrow()) {
            // We don't support `.class`, `[data-testid]`, `> *`, `#some-id`
            if ($98cfe0bf6fbc0454$var$reNestedSelectors.test(key)) throw new Error("Styles not supported for key '".concat(key, "'."));
        }
        // We have now dealt with all the special cases, so,
        // check whether what remains is a style property
        // that can be transformed.
        if (!(key in $98cfe0bf6fbc0454$export$9a199fbafee0014e)) return;
        var tokenValue = $98cfe0bf6fbc0454$export$9a199fbafee0014e[key][value];
        styleObj[key] = tokenValue !== null && tokenValue !== void 0 ? tokenValue : value;
    });
    return styleObj;
};
var $98cfe0bf6fbc0454$var$baseXcss = function baseXcss(style) {
    var transformedStyles = $98cfe0bf6fbc0454$var$_transformStyles(style);
    return (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, $98cfe0bf6fbc0454$var$uniqueSymbol, (0, $74Zh5.css)(transformedStyles));
};
/**
 * Picks out runtime XCSS objects and build-time XCSS strings. This is needed
 * to supported both Emotion and Compiled styles until we've fully migrated
 * to Compiled.
 *
 * @private
 * @deprecated
 */ var $98cfe0bf6fbc0454$export$a9c84988c8f81f2d = function parseXcss(args) {
    if (Array.isArray(args)) {
        var emotion = [];
        var staticArr = [];
        var _iterator = $98cfe0bf6fbc0454$var$_createForOfIteratorHelper(args), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var arg = _step.value;
                var result = $98cfe0bf6fbc0454$export$a9c84988c8f81f2d(arg);
                if (result.emotion) emotion.push.apply(emotion, (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(result.emotion));
                if (result.static) staticArr.push(result.static);
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
        return {
            emotion: emotion,
            static: staticArr.join(' ')
        };
    }
    var objArgs = args;
    var _ref4 = objArgs || {}, styles = _ref4[$98cfe0bf6fbc0454$var$uniqueSymbol];
    if (styles) return {
        emotion: [
            styles
        ]
    };
    if (args) {
        // We use string interpolation here instead of .toString() just
        // in case the resulting object doesn't have the method available.
        var stringifiedArgs = "".concat(args);
        if (stringifiedArgs) return {
            static: stringifiedArgs
        };
    }
    return {};
};
function $98cfe0bf6fbc0454$export$f6c783d06584602c(style) {
    return $98cfe0bf6fbc0454$var$baseXcss(style);
}

});


parcelRegister("gGtQh", function(module, exports) {
$parcel$export(module.exports, "default", () => $c257b79ae3ca396d$export$2e2bcd8739ae039);

var $5FkrB = parcelRequire("5FkrB");

var $dGLWv = parcelRequire("dGLWv");

var $dIzAm = parcelRequire("dIzAm");

var $kBPlY = parcelRequire("kBPlY");
/**
 * __Use default button base__
 *
 * A React hook that accepts a set of default Button props,
 * and processes them to return consistent base props for usage
 * across Button and LinkButton variants.
 *
 * @private
 */ var $c257b79ae3ca396d$var$useDefaultButton = function useDefaultButton(_ref) {
    var analyticsContext = _ref.analyticsContext, appearance = _ref.appearance, ariaLabel = _ref.ariaLabel, ariaLabelledBy = _ref.ariaLabelledBy, autoFocus = _ref.autoFocus, buttonType = _ref.buttonType, children = _ref.children, iconAfter = _ref.iconAfter, iconBefore = _ref.iconBefore, interactionName = _ref.interactionName, isDisabled = _ref.isDisabled, _ref$isLoading = _ref.isLoading, isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading, isSelected = _ref.isSelected, onClick = _ref.onClick, onClickCapture = _ref.onClickCapture, onKeyDownCapture = _ref.onKeyDownCapture, onKeyUpCapture = _ref.onKeyUpCapture, onMouseDownCapture = _ref.onMouseDownCapture, onMouseUpCapture = _ref.onMouseUpCapture, onPointerDownCapture = _ref.onPointerDownCapture, onPointerUpCapture = _ref.onPointerUpCapture, onTouchEndCapture = _ref.onTouchEndCapture, onTouchStartCapture = _ref.onTouchStartCapture, ref = _ref.ref, shouldFitContainer = _ref.shouldFitContainer, spacing = _ref.spacing, testId = _ref.testId;
    var baseProps = (0, $kBPlY.default)({
        analyticsContext: analyticsContext,
        appearance: appearance,
        autoFocus: autoFocus,
        ariaLabel: ariaLabel,
        ariaLabelledBy: ariaLabelledBy,
        buttonType: buttonType,
        children: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $5FkrB.Fragment), null, iconBefore && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $dGLWv.default), {
            type: "icon",
            position: "before",
            isLoading: isLoading
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $dIzAm.default), {
            icon: iconBefore
        })), children && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $dGLWv.default), {
            isLoading: isLoading
        }, children), iconAfter && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $dGLWv.default), {
            type: "icon",
            position: "after",
            isLoading: isLoading
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $dIzAm.default), {
            icon: iconAfter
        }))),
        interactionName: interactionName,
        isDisabled: isDisabled,
        isLoading: isLoading,
        isSelected: isSelected,
        onClick: onClick,
        onMouseDownCapture: onMouseDownCapture,
        onMouseUpCapture: onMouseUpCapture,
        onKeyDownCapture: onKeyDownCapture,
        onKeyUpCapture: onKeyUpCapture,
        onTouchStartCapture: onTouchStartCapture,
        onTouchEndCapture: onTouchEndCapture,
        onPointerDownCapture: onPointerDownCapture,
        onPointerUpCapture: onPointerUpCapture,
        onClickCapture: onClickCapture,
        ref: ref,
        shouldFitContainer: shouldFitContainer,
        spacing: spacing,
        testId: testId,
        hasIconBefore: Boolean(iconBefore),
        hasIconAfter: Boolean(iconAfter)
    });
    return baseProps;
};
var $c257b79ae3ca396d$export$2e2bcd8739ae039 = $c257b79ae3ca396d$var$useDefaultButton;

});
parcelRegister("dGLWv", function(module, exports) {
$parcel$export(module.exports, "default", () => $9f746300b23efb9f$export$2e2bcd8739ae039);

var $fC8ib = parcelRequire("fC8ib");

var $5FkrB = parcelRequire("5FkrB");

var $ayeN2 = parcelRequire("ayeN2");
var $d7pIx = parcelRequire("d7pIx");
var $9f746300b23efb9f$var$textStyles = (0, $d7pIx.xcss)({
    // content can grow and shrink
    flexGrow: 1,
    flexShrink: 1,
    // ellipsis for overflow text
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
});
var $9f746300b23efb9f$var$iconStyles = (0, $d7pIx.xcss)({
    display: 'flex',
    // icon size cannot grow and shrink
    flexGrow: 0,
    flexShrink: 0,
    alignSelf: 'center',
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    fontSize: 0,
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: 0,
    userSelect: 'none'
});
var $9f746300b23efb9f$var$commonStyles = (0, $d7pIx.xcss)({
    transition: 'opacity 0.3s'
});
var $9f746300b23efb9f$var$fadeStyles = (0, $d7pIx.xcss)({
    opacity: 0
});
/**
 * These CSS variables consumed by the new icons, to allow them to have appropriate
 * padding inside Button while also maintaining spacing for the existing icons.
 *
 * These styles can be removed once the new icons are fully rolled out, feature flag
 * platform-visual-refresh-icons is cleaned up,
 * and we bump Button to set padding based on the new icons.
 */ var $9f746300b23efb9f$var$beforeIconStyles = (0, $d7pIx.xcss)({
    // @ts-ignore
    '--ds--button--new-icon-padding-start': "var(--ds-space-050, 4px)",
    // @ts-ignore
    '--ds--button--new-icon-padding-end': "var(--ds-space-025, 2px)"
});
var $9f746300b23efb9f$var$afterIconStyles = (0, $d7pIx.xcss)({
    // @ts-ignore
    '--ds--button--new-icon-padding-start': "var(--ds-space-025, 2px)",
    // @ts-ignore
    '--ds--button--new-icon-padding-end': "var(--ds-space-050, 4px)"
});
/**
 * __Content__
 *
 * Used for slots within a Button, including icons and text content.
 */ var $9f746300b23efb9f$var$Content = function Content(_ref) {
    var children = _ref.children, _ref$type = _ref.type, type = _ref$type === void 0 ? 'text' : _ref$type, isLoading = _ref.isLoading, position = _ref.position;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $ayeN2.default), {
        as: "span",
        xcss: [
            $9f746300b23efb9f$var$commonStyles
        ].concat((0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(type === 'text' ? [
            $9f746300b23efb9f$var$textStyles
        ] : [
            $9f746300b23efb9f$var$iconStyles
        ]), (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(isLoading ? [
            $9f746300b23efb9f$var$fadeStyles
        ] : []), (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(position === 'before' ? [
            $9f746300b23efb9f$var$beforeIconStyles
        ] : []), (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(position === 'after' ? [
            $9f746300b23efb9f$var$afterIconStyles
        ] : []))
    }, children);
};
var $9f746300b23efb9f$export$2e2bcd8739ae039 = $9f746300b23efb9f$var$Content;

});
parcelRegister("ayeN2", function(module, exports) {
$parcel$export(module.exports, "default", () => $7ae88d55a31a3e47$export$2e2bcd8739ae039);

var $kqp0i = parcelRequire("kqp0i");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");

var $74Zh5 = parcelRequire("74Zh5");

var $ldA2L = parcelRequire("ldA2L");

var $hkJI5 = parcelRequire("hkJI5");

var $d7pIx = parcelRequire("d7pIx");
var $7ae88d55a31a3e47$var$_excluded = [
    "as",
    "children",
    "backgroundColor",
    "padding",
    "paddingBlock",
    "paddingBlockStart",
    "paddingBlockEnd",
    "paddingInline",
    "paddingInlineStart",
    "paddingInlineEnd",
    "style",
    "testId",
    "xcss"
], $7ae88d55a31a3e47$var$_excluded2 = [
    "className"
];
var $7ae88d55a31a3e47$export$e71c4d32a2263218 = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? 'div' : _ref$as, children = _ref.children, backgroundColor = _ref.backgroundColor, padding = _ref.padding, paddingBlock = _ref.paddingBlock, paddingBlockStart = _ref.paddingBlockStart, paddingBlockEnd = _ref.paddingBlockEnd, paddingInline = _ref.paddingInline, paddingInlineStart = _ref.paddingInlineStart, paddingInlineEnd = _ref.paddingInlineEnd, style = _ref.style, testId = _ref.testId, xcss = _ref.xcss, htmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $7ae88d55a31a3e47$var$_excluded);
    // This is to remove className from safeHtmlAttributes
    // @ts-expect-error className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(htmlAttributes, $7ae88d55a31a3e47$var$_excluded2);
    var resolvedStyles = (0, $d7pIx.parseXcss)(xcss);
    var node = // @ts-expect-error Expression produces a union type that is too complex to represent. I think this is unavoidable
    (0, $74Zh5.jsx)(Component, (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        style: style,
        ref: ref,
        className: resolvedStyles.static
    }, safeHtmlAttributes, {
        css: [
            $7ae88d55a31a3e47$var$baseStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            backgroundColor && (0, $hkJI5.backgroundColorStylesMap)[backgroundColor],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $hkJI5.isSurfaceColorToken)(backgroundColor) && (0, $hkJI5.surfaceColorStylesMap)[backgroundColor],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            padding && (0, $hkJI5.paddingStylesMap).padding[padding],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlock && (0, $hkJI5.paddingStylesMap).paddingBlock[paddingBlock],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlockStart && (0, $hkJI5.paddingStylesMap).paddingBlockStart[paddingBlockStart],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlockEnd && (0, $hkJI5.paddingStylesMap).paddingBlockEnd[paddingBlockEnd],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInline && (0, $hkJI5.paddingStylesMap).paddingInline[paddingInline],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInlineStart && (0, $hkJI5.paddingStylesMap).paddingInlineStart[paddingInlineStart],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInlineEnd && (0, $hkJI5.paddingStylesMap).paddingInlineEnd[paddingInlineEnd],
            // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
            resolvedStyles.emotion
        ],
        "data-testid": testId
    }), children);
    return backgroundColor ? (0, $74Zh5.jsx)((0, $ldA2L.SurfaceContext).Provider, {
        value: backgroundColor
    }, node) : node;
});
var $7ae88d55a31a3e47$export$2e2bcd8739ae039 = $7ae88d55a31a3e47$export$e71c4d32a2263218;
var $7ae88d55a31a3e47$var$baseStyles = (0, $74Zh5.css)({
    boxSizing: 'border-box',
    appearance: 'none',
    border: 'none'
});

});
parcelRegister("ldA2L", function(module, exports) {
$parcel$export(module.exports, "SurfaceContext", () => $f726c55c5c02a95b$export$1ca2a26fecb070ae);

var $5FkrB = parcelRequire("5FkrB");
var $f726c55c5c02a95b$export$1ca2a26fecb070ae = /*#__PURE__*/ (0, $5FkrB.createContext)('elevation.surface');
var $f726c55c5c02a95b$export$1aeb4f6b93c4540d = function useSurface() {
    return (0, $5FkrB.useContext)($f726c55c5c02a95b$export$1ca2a26fecb070ae);
};
$f726c55c5c02a95b$export$1ca2a26fecb070ae.displayName = 'SurfaceProvider';

});



parcelRegister("dIzAm", function(module, exports) {
$parcel$export(module.exports, "default", () => $9fcafcf53a02502f$export$2e2bcd8739ae039);

var $5FkrB = parcelRequire("5FkrB");
function $9fcafcf53a02502f$var$isIconRenderProp(func) {
    return !func.displayName && // most function components and class components have a displayName, negate them
    !func.render && // forwardRef doesn't require a display name, however it does include a render function, negate them
    typeof func === 'function' // at the very least we need to be a function
    ;
}
/**
 * __Icon renderer__
 *
 * Used to support render props with icons.
 *
 */ var $9fcafcf53a02502f$var$IconRenderer = function IconRenderer(_ref) {
    var Icon = _ref.icon;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).Fragment, null, $9fcafcf53a02502f$var$isIconRenderProp(Icon) ? Icon({
        label: '',
        color: 'currentColor'
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(Icon, {
        label: "",
        color: 'currentColor'
    }));
};
var $9fcafcf53a02502f$export$2e2bcd8739ae039 = $9fcafcf53a02502f$var$IconRenderer;

});

parcelRegister("kBPlY", function(module, exports) {
$parcel$export(module.exports, "default", () => $f00f19134f4b6309$export$2e2bcd8739ae039);

var $25nEq = parcelRequire("25nEq");

var $5FkrB = parcelRequire("5FkrB");

var $jrKPH = parcelRequire("jrKPH");

var $8ijNL = parcelRequire("8ijNL");

var $aEouc = parcelRequire("aEouc");

var $id6Cu = parcelRequire("id6Cu");

var $ayeN2 = parcelRequire("ayeN2");
var $d7pIx = parcelRequire("d7pIx");

var $h0N4L = parcelRequire("h0N4L");

var $0cQiR = parcelRequire("0cQiR");

var $7OBJ1 = parcelRequire("7OBJ1");

var $ctTCB = parcelRequire("ctTCB");

var $979NR = parcelRequire("979NR");

var $d6tze = parcelRequire("d6tze");
function $f00f19134f4b6309$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $f00f19134f4b6309$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $f00f19134f4b6309$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $f00f19134f4b6309$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
// If updating `buttonStyles`, also update `buttonStylesWithRem`.
var $f00f19134f4b6309$var$buttonStyles = (0, $d7pIx.xcss)({
    display: 'inline-flex',
    boxSizing: 'border-box',
    width: 'auto',
    maxWidth: '100%',
    position: 'relative',
    alignItems: 'baseline',
    justifyContent: 'center',
    columnGap: 'space.050',
    borderRadius: 'border.radius.100',
    borderWidth: 'border.width.0',
    flexShrink: 0,
    height: "".concat(32 / 14, "em"),
    font: 'font.body',
    fontWeight: 'font.weight.medium',
    paddingBlock: 'space.075',
    paddingInlineEnd: 'space.150',
    paddingInlineStart: 'space.150',
    textAlign: 'center',
    transition: 'background 0.1s ease-out',
    verticalAlign: 'middle',
    '::after': {
        borderRadius: 'inherit',
        inset: 'space.0',
        borderStyle: 'solid',
        borderWidth: "var(--ds-border-width, 1px)",
        pointerEvents: 'none',
        position: 'absolute'
    }
});
var $f00f19134f4b6309$var$buttonStylesWithRem = (0, $d7pIx.xcss)({
    display: 'inline-flex',
    boxSizing: 'border-box',
    width: 'auto',
    maxWidth: '100%',
    position: 'relative',
    alignItems: 'baseline',
    justifyContent: 'center',
    columnGap: 'space.050',
    borderRadius: 'border.radius.100',
    borderWidth: 'border.width.0',
    flexShrink: 0,
    height: '2rem',
    font: 'font.body',
    fontWeight: 'font.weight.medium',
    paddingBlock: 'space.075',
    paddingInlineEnd: 'space.150',
    paddingInlineStart: 'space.150',
    textAlign: 'center',
    transition: 'background 0.1s ease-out',
    verticalAlign: 'middle',
    '::after': {
        borderRadius: 'inherit',
        inset: 'space.0',
        borderStyle: 'solid',
        borderWidth: "var(--ds-border-width, 1px)",
        pointerEvents: 'none',
        position: 'absolute'
    }
});
var $f00f19134f4b6309$var$defaultInteractiveStyles = (0, $d7pIx.xcss)({
    ':hover': {
        background: "var(--ds-background-neutral-hovered, #091e4214)",
        // @ts-expect-error
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        color: "var(--ds-text, ".concat($h0N4L.N500, ")")
    },
    ':active': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        background: "var(--ds-background-neutral-pressed, ".concat($h0N4L.B75, ")"),
        // @ts-expect-error
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        color: "var(--ds-text, ".concat($h0N4L.B400, ")")
    }
});
var $f00f19134f4b6309$var$defaultInteractiveRefreshedStyles = (0, $d7pIx.xcss)({
    ':hover': {
        background: "var(--ds-background-neutral-subtle-hovered, #091E420F)",
        color: 'color.text.subtle'
    },
    ':active': {
        background: "var(--ds-background-neutral-subtle-pressed, #091E4224)",
        color: 'color.text.subtle'
    }
});
var $f00f19134f4b6309$var$defaultStyles = (0, $d7pIx.xcss)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
    background: "var(--ds-background-neutral, ".concat($h0N4L.N20A, ")"),
    // @ts-expect-error — using tokens for explicit fallback usage.
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values --  -- Ignored via go/DSP-18766
    color: "var(--ds-text, ".concat($h0N4L.N500, ")"),
    ':visited': {
        // @ts-expect-error
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        color: "var(--ds-text, ".concat($h0N4L.N500, ")")
    }
});
var $f00f19134f4b6309$var$defaultRefreshedStyles = (0, $d7pIx.xcss)({
    background: "var(--ds-background-neutral-subtle, #00000000)",
    color: 'color.text.subtle',
    '::after': {
        content: '""',
        borderColor: 'color.border'
    },
    ':visited': {
        color: 'color.text.subtle'
    }
});
var $f00f19134f4b6309$var$primaryStyles = (0, $d7pIx.xcss)({
    background: "var(--ds-background-brand-bold, #0052CC)",
    // @ts-expect-error
    color: "var(--ds-text-inverse, #FFFFFF)",
    ':visited': {
        // @ts-expect-error
        color: "var(--ds-text-inverse, #FFFFFF)"
    }
});
var $f00f19134f4b6309$var$primaryInteractiveStyles = (0, $d7pIx.xcss)({
    ':hover': {
        // @ts-expect-error
        color: "var(--ds-text-inverse, #FFFFFF)",
        background: "var(--ds-background-brand-bold-hovered, #0065FF)"
    },
    ':active': {
        // @ts-expect-error
        color: "var(--ds-text-inverse, #FFFFFF)",
        background: "var(--ds-background-brand-bold-pressed, #0747A6)"
    }
});
var $f00f19134f4b6309$var$warningStyles = (0, $d7pIx.xcss)({
    background: "var(--ds-background-warning-bold, #FFAB00)",
    // @ts-expect-error
    color: "var(--ds-text-warning-inverse, #172B4D)",
    ':visited': {
        // @ts-expect-error
        color: "var(--ds-text-warning-inverse, #172B4D)"
    }
});
var $f00f19134f4b6309$var$warningInteractiveStyles = (0, $d7pIx.xcss)({
    ':hover': {
        // @ts-expect-error
        color: "var(--ds-text-warning-inverse, #172B4D)",
        background: "var(--ds-background-warning-bold-hovered, #FFC400)"
    },
    ':active': {
        // @ts-expect-error
        color: "var(--ds-text-warning-inverse, #172B4D)",
        background: "var(--ds-background-warning-bold-pressed, #FF991F)"
    }
});
var $f00f19134f4b6309$var$dangerStyles = (0, $d7pIx.xcss)({
    background: "var(--ds-background-danger-bold, #DE350B)",
    color: 'color.text.inverse',
    ':visited': {
        color: 'color.text.inverse'
    }
});
var $f00f19134f4b6309$var$dangerInteractiveStyles = (0, $d7pIx.xcss)({
    ':hover': {
        color: 'color.text.inverse',
        background: "var(--ds-background-danger-bold-hovered, #FF5630)"
    },
    ':active': {
        color: 'color.text.inverse',
        background: "var(--ds-background-danger-bold-pressed, #BF2600)"
    }
});
var $f00f19134f4b6309$var$discoveryStyles = (0, $d7pIx.xcss)({
    background: "var(--ds-background-discovery-bold, #5243AA)",
    color: 'color.text.inverse',
    ':visited': {
        color: 'color.text.inverse'
    }
});
var $f00f19134f4b6309$var$discoveryInteractiveStyles = (0, $d7pIx.xcss)({
    ':hover': {
        color: 'color.text.inverse',
        background: "var(--ds-background-discovery-bold-hovered, #8777D9)"
    },
    ':active': {
        color: 'color.text.inverse',
        background: "var(--ds-background-discovery-bold-pressed, #5243AA)"
    }
});
var $f00f19134f4b6309$var$subtleStyles = (0, $d7pIx.xcss)({
    background: "var(--ds-background-neutral-subtle, transparent)",
    // @ts-expect-error
    color: "var(--ds-text, #42526E)",
    ':visited': {
        // @ts-expect-error
        color: "var(--ds-text, #42526E)"
    }
});
var $f00f19134f4b6309$var$subtleRefreshedStyles = (0, $d7pIx.xcss)({
    background: "var(--ds-background-neutral-subtle, transparent)",
    color: 'color.text.subtle',
    ':visited': {
        color: 'color.text.subtle'
    }
});
var $f00f19134f4b6309$var$subtleInteractiveStyles = (0, $d7pIx.xcss)({
    ':hover': {
        background: "var(--ds-background-neutral-subtle-hovered, #091e4214)",
        // @ts-expect-error
        color: "var(--ds-text, #42526E)"
    },
    ':active': {
        background: "var(--ds-background-neutral-subtle-pressed, #B3D4FF)",
        // @ts-expect-error
        color: "var(--ds-text, #42526E)"
    }
});
var $f00f19134f4b6309$var$subtleInteractiveRefreshedStyles = (0, $d7pIx.xcss)({
    ':hover': {
        background: "var(--ds-background-neutral-subtle-hovered, #091e4214)",
        color: 'color.text.subtle'
    },
    ':active': {
        background: "var(--ds-background-neutral-subtle-pressed, #B3D4FF)",
        color: 'color.text.subtle'
    }
});
// Required due to Jira's AUI CSS reset: https://product-fabric.atlassian.net/browse/DSP-15687
var $f00f19134f4b6309$var$linkDecorationUnsetStyles = (0, $d7pIx.xcss)({
    textDecoration: 'none',
    ':hover': {
        textDecoration: 'none'
    },
    ':active': {
        textDecoration: 'none'
    },
    ':focus': {
        textDecoration: 'none'
    }
});
var $f00f19134f4b6309$var$disabledStyles = (0, $d7pIx.xcss)({
    cursor: 'not-allowed',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    background: "var(--ds-background-disabled, ".concat($h0N4L.N20A, ")"),
    // @ts-expect-error
    color: "var(--ds-text-disabled, #091E424F)",
    ':hover': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        background: "var(--ds-background-disabled, ".concat($h0N4L.N20A, ")"),
        // @ts-expect-error
        color: "var(--ds-text-disabled, #091E424F)"
    },
    ':active': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        background: "var(--ds-background-disabled, ".concat($h0N4L.N20A, ")"),
        // @ts-expect-error
        color: "var(--ds-text-disabled, #091E424F)"
    },
    '::after': {
        content: 'none'
    }
});
var $f00f19134f4b6309$var$selectedStyles = (0, $d7pIx.xcss)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    background: "var(--ds-background-selected, ".concat($h0N4L.N700, ")"),
    // @ts-expect-error
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    color: "var(--ds-text-selected, ".concat($h0N4L.N20, ")"),
    ':visited': {
        // @ts-expect-error
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        color: "var(--ds-text-selected, ".concat($h0N4L.N20, ")")
    }
});
var $f00f19134f4b6309$var$selectedRefreshedStyles = (0, $d7pIx.xcss)({
    background: "var(--ds-background-selected, #E9F2FF)",
    color: 'color.text.selected',
    '::after': {
        content: '""',
        borderColor: 'color.border.selected'
    },
    ':visited': {
        color: 'color.text.selected'
    }
});
var $f00f19134f4b6309$var$selectedInsideSplitButtonStyles = (0, $d7pIx.xcss)({
    // This is 2 so it appears above the split button divider when selected.
    // See split-button.tsx.
    // @ts-expect-error — We need a local zindex just for button.
    zIndex: 2
});
var $f00f19134f4b6309$var$selectedInteractiveStyles = (0, $d7pIx.xcss)({
    ':hover': {
        // @ts-expect-error
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        color: "var(--ds-text-selected, ".concat($h0N4L.N20, ")"),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        background: "var(--ds-background-selected-hovered, ".concat($h0N4L.N700, ")")
    },
    ':active': {
        // @ts-expect-error
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        color: "var(--ds-text-selected, ".concat($h0N4L.N20, ")"),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        background: "var(--ds-background-selected-pressed, ".concat($h0N4L.N700, ")")
    }
});
// TODO: Remove me once we kill color fallbacks
var $f00f19134f4b6309$var$selectedWarningStyles = (0, $d7pIx.xcss)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    background: "var(--ds-background-selected, ".concat($h0N4L.Y400, ")"),
    // @ts-expect-error
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    color: "var(--ds-text-selected, ".concat($h0N4L.N800, ")"),
    ':hover': {
        // @ts-expect-error
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        color: "var(--ds-text-selected, ".concat($h0N4L.N20, ")"),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        background: "var(--ds-background-selected, ".concat($h0N4L.Y400, ")")
    },
    ':active': {
        // @ts-expect-error
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        color: "var(--ds-text-selected, ".concat($h0N4L.N20, ")"),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        background: "var(--ds-background-selected, ".concat($h0N4L.Y400, ")")
    }
});
// TODO: Remove me once we kill color fallbacks
var $f00f19134f4b6309$var$selectedDangerStyles = (0, $d7pIx.xcss)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    background: "var(--ds-background-selected, ".concat($h0N4L.R500, ")"),
    // @ts-expect-error
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    color: "var(--ds-text-selected, ".concat($h0N4L.N20, ")"),
    ':hover': {
        // @ts-expect-error
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        color: "var(--ds-text-selected, ".concat($h0N4L.N20, ")"),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        background: "var(--ds-background-selected, ".concat($h0N4L.R500, ")")
    },
    ':active': {
        // @ts-expect-error
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        color: "var(--ds-text-selected, ".concat($h0N4L.N20, ")"),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        background: "var(--ds-background-selected, ".concat($h0N4L.R500, ")")
    }
});
// TODO: Remove me once we kill color fallbacks
var $f00f19134f4b6309$var$selectedDiscoveryStyles = (0, $d7pIx.xcss)({
    background: "var(--ds-background-selected, #403294)",
    // @ts-expect-error
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    color: "var(--ds-text-selected, ".concat($h0N4L.N20, ")"),
    ':hover': {
        // @ts-expect-error
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        color: "var(--ds-text-selected, ".concat($h0N4L.N20, ")"),
        background: "var(--ds-background-selected, #403294)"
    },
    ':active': {
        // @ts-expect-error
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        color: "var(--ds-text-selected, ".concat($h0N4L.N20, ")"),
        background: "var(--ds-background-selected, #403294)"
    }
});
// If updating `spacingCompactStyles`, also update `spacingCompactStylesWithRem`.
var $f00f19134f4b6309$var$spacingCompactStyles = (0, $d7pIx.xcss)({
    columnGap: 'space.050',
    height: "".concat(24 / 14, "em"),
    paddingBlock: 'space.025',
    paddingInlineEnd: 'space.150',
    paddingInlineStart: 'space.150',
    verticalAlign: 'middle'
});
var $f00f19134f4b6309$var$spacingCompactStylesWithRem = (0, $d7pIx.xcss)({
    columnGap: 'space.050',
    height: '1.5rem',
    paddingBlock: 'space.025',
    paddingInlineEnd: 'space.150',
    paddingInlineStart: 'space.150',
    verticalAlign: 'middle'
});
var $f00f19134f4b6309$var$circleStyles = (0, $d7pIx.xcss)({
    borderRadius: 'border.radius.circle'
});
var $f00f19134f4b6309$var$fullWidthStyles = (0, $d7pIx.xcss)({
    width: '100%'
});
var $f00f19134f4b6309$var$loadingStyles = (0, $d7pIx.xcss)({
    cursor: 'progress'
});
// If updating `iconButtonStyles`, also update `iconButtonStylesWithRem`.
var $f00f19134f4b6309$var$iconButtonStyles = (0, $d7pIx.xcss)({
    height: "".concat(32 / 14, "em"),
    width: "".concat(32 / 14, "em"),
    paddingInlineEnd: 'space.0',
    paddingInlineStart: 'space.0'
});
var $f00f19134f4b6309$var$iconButtonStylesWithRem = (0, $d7pIx.xcss)({
    height: '2rem',
    width: '2rem',
    paddingInlineEnd: 'space.0',
    paddingInlineStart: 'space.0'
});
// If updating `iconButtonCompactStyles`, also update `iconButtonCompactStylesWithRem`.
var $f00f19134f4b6309$var$iconButtonCompactStyles = (0, $d7pIx.xcss)({
    width: "".concat(24 / 14, "em"),
    height: "".concat(24 / 14, "em")
});
var $f00f19134f4b6309$var$iconButtonCompactStylesWithRem = (0, $d7pIx.xcss)({
    width: '1.5rem',
    height: '1.5rem'
});
var $f00f19134f4b6309$var$buttonIconBeforeStyles = (0, $d7pIx.xcss)({
    paddingInlineStart: 'space.100'
});
var $f00f19134f4b6309$var$buttonIconAfterStyles = (0, $d7pIx.xcss)({
    paddingInlineEnd: 'space.100'
});
var $f00f19134f4b6309$var$splitButtonStyles = (0, $d7pIx.xcss)({
    ':focus-visible': {
        zIndex: 'card'
    }
});
var $f00f19134f4b6309$var$navigationSplitButtonStyles = (0, $d7pIx.xcss)({
    width: '24px',
    backgroundColor: 'color.background.neutral.subtle',
    paddingInlineEnd: 'space.075',
    paddingInlineStart: 'space.075'
});
var $f00f19134f4b6309$var$loadingOverlayStyles = (0, $d7pIx.xcss)({
    display: 'flex',
    position: 'absolute',
    alignItems: 'center',
    justifyContent: 'center',
    insetBlockEnd: 'space.0',
    insetBlockStart: 'space.0',
    insetInlineEnd: 'space.0',
    insetInlineStart: 'space.0'
});
/**
 * __Use button base__
 *
 * A React hook that accepts a set of common Button props,
 * and processes them to return consistent base props for usage
 * across various Button components.
 *
 * It also:
 * - Implements auto focus when enabled.
 * - Appends the `onClick` event with UFO analytics tracking.
 *
 * @private
 */ var $f00f19134f4b6309$var$useButtonBase = function useButtonBase(_ref) {
    var _ref$appearance = _ref.appearance, propAppearance = _ref$appearance === void 0 ? 'default' : _ref$appearance, _ref$autoFocus = _ref.autoFocus, autoFocus = _ref$autoFocus === void 0 ? false : _ref$autoFocus, _ref$isDisabled = _ref.isDisabled, propIsDisabled = _ref$isDisabled === void 0 ? false : _ref$isDisabled, _ref$isLoading = _ref.isLoading, isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading, _ref$isSelected = _ref.isSelected, propIsSelected = _ref$isSelected === void 0 ? false : _ref$isSelected, _ref$isIconButton = _ref.isIconButton, isIconButton = _ref$isIconButton === void 0 ? false : _ref$isIconButton, _ref$isCircle = _ref.isCircle, isCircle = _ref$isCircle === void 0 ? false : _ref$isCircle, _ref$hasIconBefore = _ref.hasIconBefore, hasIconBefore = _ref$hasIconBefore === void 0 ? false : _ref$hasIconBefore, _ref$hasIconAfter = _ref.hasIconAfter, hasIconAfter = _ref$hasIconAfter === void 0 ? false : _ref$hasIconAfter, children = _ref.children, onClick = _ref.onClick, onMouseDownCapture = _ref.onMouseDownCapture, onMouseUpCapture = _ref.onMouseUpCapture, onKeyDownCapture = _ref.onKeyDownCapture, onKeyUpCapture = _ref.onKeyUpCapture, onTouchStartCapture = _ref.onTouchStartCapture, onTouchEndCapture = _ref.onTouchEndCapture, onPointerDownCapture = _ref.onPointerDownCapture, onPointerUpCapture = _ref.onPointerUpCapture, onClickCapture = _ref.onClickCapture, ref = _ref.ref, _ref$shouldFitContain = _ref.shouldFitContainer, shouldFitContainer = _ref$shouldFitContain === void 0 ? false : _ref$shouldFitContain, _ref$spacing = _ref.spacing, propSpacing = _ref$spacing === void 0 ? 'default' : _ref$spacing, testId = _ref.testId, ariaLabel = _ref.ariaLabel, ariaLabelledBy = _ref.ariaLabelledBy;
    var localRef = (0, $5FkrB.useRef)(null);
    var splitButtonContext = (0, $7OBJ1.useSplitButtonContext)();
    var loadingLabelId = (0, $aEouc.useId)();
    var isSplitButton = Boolean(splitButtonContext);
    var isNavigationSplitButton = (splitButtonContext === null || splitButtonContext === void 0 ? void 0 : splitButtonContext.isNavigationSplitButton) || false;
    var isDefaultAppearanceSplitButton = (splitButtonContext === null || splitButtonContext === void 0 ? void 0 : splitButtonContext.appearance) === 'default';
    var appearance = isDefaultAppearanceSplitButton && (0, $id6Cu.fg)('platform-component-visual-refresh') ? 'subtle' : (splitButtonContext === null || splitButtonContext === void 0 ? void 0 : splitButtonContext.appearance) || propAppearance;
    var spacing = (splitButtonContext === null || splitButtonContext === void 0 ? void 0 : splitButtonContext.spacing) || propSpacing;
    var isDisabled = (splitButtonContext === null || splitButtonContext === void 0 ? void 0 : splitButtonContext.isDisabled) || propIsDisabled;
    var isInteractive = !isDisabled && !isLoading;
    // Also treat loading buttons as disabled
    var isEffectivelyDisabled = isDisabled || isLoading;
    var isSelected = propIsSelected && !isDisabled;
    (0, $8ijNL.default)(localRef, autoFocus);
    return $f00f19134f4b6309$var$_objectSpread({
        ref: (0, $jrKPH.default)([
            localRef,
            ref
        ]),
        xcss: [
            (0, $id6Cu.fg)('platform_dst_button_replace_em_with_rem') ? $f00f19134f4b6309$var$buttonStylesWithRem : $f00f19134f4b6309$var$buttonStyles,
            appearance === 'default' && ((0, $id6Cu.fg)('platform-component-visual-refresh') ? $f00f19134f4b6309$var$defaultRefreshedStyles : $f00f19134f4b6309$var$defaultStyles),
            appearance === 'default' && isInteractive && ((0, $id6Cu.fg)('platform-component-visual-refresh') ? $f00f19134f4b6309$var$defaultInteractiveRefreshedStyles : $f00f19134f4b6309$var$defaultInteractiveStyles),
            appearance === 'primary' && $f00f19134f4b6309$var$primaryStyles,
            appearance === 'primary' && isInteractive && $f00f19134f4b6309$var$primaryInteractiveStyles,
            appearance === 'warning' && $f00f19134f4b6309$var$warningStyles,
            appearance === 'warning' && isInteractive && $f00f19134f4b6309$var$warningInteractiveStyles,
            appearance === 'danger' && $f00f19134f4b6309$var$dangerStyles,
            appearance === 'danger' && isInteractive && $f00f19134f4b6309$var$dangerInteractiveStyles,
            appearance === 'discovery' && $f00f19134f4b6309$var$discoveryStyles,
            appearance === 'discovery' && isInteractive && $f00f19134f4b6309$var$discoveryInteractiveStyles,
            appearance === 'subtle' && ((0, $id6Cu.fg)('platform-component-visual-refresh') ? $f00f19134f4b6309$var$subtleRefreshedStyles : $f00f19134f4b6309$var$subtleStyles),
            appearance === 'subtle' && isInteractive && ((0, $id6Cu.fg)('platform-component-visual-refresh') ? $f00f19134f4b6309$var$subtleInteractiveRefreshedStyles : $f00f19134f4b6309$var$subtleInteractiveStyles),
            $f00f19134f4b6309$var$linkDecorationUnsetStyles,
            isSelected && ((0, $id6Cu.fg)('platform-component-visual-refresh') ? $f00f19134f4b6309$var$selectedRefreshedStyles : $f00f19134f4b6309$var$selectedStyles),
            isSelected && isSplitButton && $f00f19134f4b6309$var$selectedInsideSplitButtonStyles,
            isSelected && isInteractive && $f00f19134f4b6309$var$selectedInteractiveStyles,
            // TODO: remove me once we kill color fallbacks
            isSelected && appearance === 'danger' && $f00f19134f4b6309$var$selectedDangerStyles,
            // TODO: remove me once we kill color fallbacks
            isSelected && appearance === 'warning' && $f00f19134f4b6309$var$selectedWarningStyles,
            // TODO: remove me once we kill color fallbacks
            isSelected && appearance === 'discovery' && $f00f19134f4b6309$var$selectedDiscoveryStyles,
            isDisabled && $f00f19134f4b6309$var$disabledStyles,
            isCircle && !isSplitButton && $f00f19134f4b6309$var$circleStyles,
            spacing === 'compact' && ((0, $id6Cu.fg)('platform_dst_button_replace_em_with_rem') ? $f00f19134f4b6309$var$spacingCompactStylesWithRem : $f00f19134f4b6309$var$spacingCompactStyles),
            hasIconBefore && $f00f19134f4b6309$var$buttonIconBeforeStyles,
            hasIconAfter && $f00f19134f4b6309$var$buttonIconAfterStyles,
            isIconButton && ((0, $id6Cu.fg)('platform_dst_button_replace_em_with_rem') ? $f00f19134f4b6309$var$iconButtonStylesWithRem : $f00f19134f4b6309$var$iconButtonStyles),
            isIconButton && spacing === 'compact' && ((0, $id6Cu.fg)('platform_dst_button_replace_em_with_rem') ? $f00f19134f4b6309$var$iconButtonCompactStylesWithRem : $f00f19134f4b6309$var$iconButtonCompactStyles),
            shouldFitContainer && $f00f19134f4b6309$var$fullWidthStyles,
            isLoading && $f00f19134f4b6309$var$loadingStyles,
            isSplitButton && $f00f19134f4b6309$var$splitButtonStyles,
            isNavigationSplitButton && $f00f19134f4b6309$var$navigationSplitButtonStyles
        ],
        isDisabled: isEffectivelyDisabled,
        children: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $7OBJ1.SplitButtonContext).Provider, {
            value: undefined
        }, children, isLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $ayeN2.default), {
            as: "span",
            xcss: $f00f19134f4b6309$var$loadingOverlayStyles
        }, (0, $d6tze.default)({
            spacing: spacing,
            appearance: appearance,
            isDisabled: isDisabled,
            isSelected: isSelected,
            testId: testId
        })) : null, isLoading && (children && !ariaLabel && !ariaLabelledBy || ariaLabelledBy) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $0cQiR.default), {
            id: loadingLabelId
        }, (0, $979NR.LOADING_LABEL))),
        'aria-label': isLoading && ariaLabel && !ariaLabelledBy ? "".concat(ariaLabel, " ").concat((0, $979NR.LOADING_LABEL)) : ariaLabel,
        'aria-labelledby': isLoading && ariaLabelledBy ? "".concat(ariaLabelledBy, " ").concat(loadingLabelId) : ariaLabelledBy
    }, (0, $ctTCB.default)(isEffectivelyDisabled, {
        onClick: onClick,
        onMouseDownCapture: onMouseDownCapture,
        onMouseUpCapture: onMouseUpCapture,
        onKeyDownCapture: onKeyDownCapture,
        onKeyUpCapture: onKeyUpCapture,
        onTouchStartCapture: onTouchStartCapture,
        onTouchEndCapture: onTouchEndCapture,
        onPointerDownCapture: onPointerDownCapture,
        onPointerUpCapture: onPointerUpCapture,
        onClickCapture: onClickCapture
    }));
};
var $f00f19134f4b6309$export$2e2bcd8739ae039 = $f00f19134f4b6309$var$useButtonBase;

});
parcelRegister("jrKPH", function(module, exports) {
$parcel$export(module.exports, "default", () => $e284ddf8ef95e2b6$export$2e2bcd8739ae039);
/**
 * Assigns the node to all the refs passed in the argument.
 *
 * @param refs: An array of refs (as function or ref object)
 */ function $e284ddf8ef95e2b6$export$2e2bcd8739ae039(refs) {
    // TODO: could this be wrapped in `useCallback` so we get a stable function?
    return function(value) {
        refs.forEach(function(ref) {
            if (typeof ref === 'function') ref(value);
            else if (ref !== null) ref.current = value;
        });
    };
}

});

parcelRegister("8ijNL", function(module, exports) {
$parcel$export(module.exports, "default", () => $609f5d604ea802ae$export$2e2bcd8739ae039);

var $5FkrB = parcelRequire("5FkrB");
function $609f5d604ea802ae$export$2e2bcd8739ae039(ref, autoFocus) {
    var initialMount = (0, $5FkrB.useRef)(true);
    (0, $5FkrB.useEffect)(function() {
        if (ref && initialMount.current && autoFocus && ref.current) ref.current.focus();
        initialMount.current = false;
    }, [
        autoFocus,
        ref
    ]);
}

});

parcelRegister("aEouc", function(module, exports) {
$parcel$export(module.exports, "useId", () => $7c10a2415bf78b99$export$f680877a34711e37);

var $ekGgq = parcelRequire("ekGgq");

var $5FkrB = parcelRequire("5FkrB");

var $b5lkZ = parcelRequire("b5lkZ");

var $78pe3 = parcelRequire("78pe3");
var $7c10a2415bf78b99$var$_React$useId;
// Type copied from https://github.com/thearnica/react-uid/blob/0f507fbbdb1ab84acf477ec32698afe3d2191e49/src/hooks.ts#L12
// Copied rather than inferred to make the type transparent
// @ts-ignore - useId is not accessible in React 16
var $7c10a2415bf78b99$var$react18UseId = ($7c10a2415bf78b99$var$_React$useId = (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).useId) !== null && $7c10a2415bf78b99$var$_React$useId !== void 0 ? $7c10a2415bf78b99$var$_React$useId : undefined;
function $7c10a2415bf78b99$export$f680877a34711e37() {
    if ($7c10a2415bf78b99$var$react18UseId && (0, $78pe3.fg)('platform.design-system-team.react-18-use-id_mn8q4')) // eslint-disable-next-line react-hooks/rules-of-hooks
    return $7c10a2415bf78b99$var$react18UseId();
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return "uid".concat((0, $b5lkZ.useUID)());
}
var $7c10a2415bf78b99$export$6be90bcb437e928f = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function(_ref, ref) {
    var children = _ref.children, _ref$postfix = _ref.postfix, postfix = _ref$postfix === void 0 ? '' : _ref$postfix, _ref$prefix = _ref.prefix, prefix = _ref$prefix === void 0 ? '' : _ref$prefix;
    var id = "".concat(prefix).concat($7c10a2415bf78b99$export$f680877a34711e37()).concat(postfix);
    (0, $5FkrB.useEffect)(function() {
        if (!ref) return;
        switch((0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(ref)){
            case 'function':
                ref(id);
                break;
            case 'object':
                ref.current = id;
                break;
            default:
                throw new Error("Unreachable case for unsupported type of ref \"".concat((0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(ref), "\""));
        }
    }, [
        id,
        ref
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).Fragment, null, typeof children === 'function' ? children({
        id: id
    }) : children);
});
function $7c10a2415bf78b99$export$6ee17796e3d70de2() {
    if ($7c10a2415bf78b99$var$react18UseId && (0, $78pe3.fg)('platform.design-system-team.react-18-use-id_mn8q4')) {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        var uid = $7c10a2415bf78b99$var$react18UseId();
        return function(id) {
            return "".concat(uid, "-").concat(id.toString());
        };
    }
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return (0, $b5lkZ.useUIDSeed)();
}

});
parcelRegister("78pe3", function(module, exports) {
$parcel$export(module.exports, "fg", () => $531cd90a97e4b6a1$export$b40ec24ac8275656);

var $bMcax = parcelRequire("bMcax");
function $531cd90a97e4b6a1$export$ba05d765b8392e5e(flagResolver) {
    (0, $bMcax.setBooleanResolver)(flagResolver);
}
function $531cd90a97e4b6a1$export$470e5c2be1411c89(name) {
    return (0, $bMcax.resolveBooleanFlag)(name);
}
function $531cd90a97e4b6a1$export$b40ec24ac8275656(name) {
    return (0, $bMcax.resolveBooleanFlag)(name);
}

});
parcelRegister("bMcax", function(module, exports) {
$parcel$export(module.exports, "setBooleanResolver", () => $892d9de8a657669a$export$f2b591175b3e424c);
$parcel$export(module.exports, "resolveBooleanFlag", () => $892d9de8a657669a$export$6333b6aff9fc6275);

var $jZlo3 = parcelRequire("jZlo3");

var $gj07O = parcelRequire("gj07O");

var $3ZMUU = parcelRequire("3ZMUU");
var $892d9de8a657669a$var$pkgName = '@atlaskit/platform-feature-flags';
var $892d9de8a657669a$export$7e41b1b2bdee3f98 = '__PLATFORM_FEATURE_FLAGS__';
var $892d9de8a657669a$var$hasProcessEnv = typeof $3ZMUU !== 'undefined' && typeof $3ZMUU.env !== 'undefined';
// FF global overrides can be configured by test runners or Storybook
var $892d9de8a657669a$var$ENV_ENABLE_PLATFORM_FF = $892d9de8a657669a$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
// STORYBOOK_ENABLE_PLATFORM_FF is included as storybook only allows env vars prefixed with STORYBOOK
// https://github.com/storybookjs/storybook/issues/12270
var $892d9de8a657669a$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF = $892d9de8a657669a$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
var $892d9de8a657669a$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE = $892d9de8a657669a$var$ENV_ENABLE_PLATFORM_FF || $892d9de8a657669a$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF;
var $892d9de8a657669a$var$DEFAULT_PFF_GLOBAL = {
    booleanResolver: undefined
};
var $892d9de8a657669a$var$globalVar = typeof window !== 'undefined' ? window : globalThis;
$892d9de8a657669a$var$globalVar[$892d9de8a657669a$export$7e41b1b2bdee3f98] = $892d9de8a657669a$var$globalVar[$892d9de8a657669a$export$7e41b1b2bdee3f98] || $892d9de8a657669a$var$DEFAULT_PFF_GLOBAL;
function $892d9de8a657669a$export$f2b591175b3e424c(resolver) {
    $892d9de8a657669a$var$globalVar[$892d9de8a657669a$export$7e41b1b2bdee3f98].booleanResolver = resolver;
}
function $892d9de8a657669a$export$6333b6aff9fc6275(flagKey) {
    if ($892d9de8a657669a$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE) {
        (0, $gj07O.debug)('[%s]: The feature flags were enabled while running tests. The flag "%s" will be always enabled.', $892d9de8a657669a$var$pkgName, flagKey);
        return true;
    }
    try {
        var _globalVar$PFF_GLOBAL, _globalVar$PFF_GLOBAL2, _globalVar$PFF_GLOBAL3;
        // booleanResolver will be empty for products like Trello, Elevate, Recruit etc.
        // Currently only Confluence, Jira and Bitbucket has set it.
        if (((_globalVar$PFF_GLOBAL = $892d9de8a657669a$var$globalVar[$892d9de8a657669a$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL === void 0 ? void 0 : _globalVar$PFF_GLOBAL.booleanResolver) === undefined || ((_globalVar$PFF_GLOBAL2 = $892d9de8a657669a$var$globalVar[$892d9de8a657669a$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL2 === void 0 ? void 0 : _globalVar$PFF_GLOBAL2.booleanResolver) === null) // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
        return (0, $jZlo3.default).checkGate(flagKey);
        var result = (_globalVar$PFF_GLOBAL3 = $892d9de8a657669a$var$globalVar[$892d9de8a657669a$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL3 === void 0 ? void 0 : _globalVar$PFF_GLOBAL3.booleanResolver(flagKey);
        if (typeof result !== 'boolean') {
            // eslint-disable-next-line no-console
            console.warn("".concat(flagKey, " resolved to a non-boolean value, returning false for safety"));
            return false;
        }
        return result;
    } catch (e) {
        return false;
    }
}

});
parcelRegister("gj07O", function(module, exports) {
$parcel$export(module.exports, "debug", () => $bdee8487dc67a036$export$1c9f709888824e05);
var $bdee8487dc67a036$var$_process, $bdee8487dc67a036$var$_process2;
// We can't rely on NODE_ENV === 'test' if its value is already configured by the consumer to some other value, so better to use JEST_WORKER_ID
// https://jestjs.io/docs/environment-variables#jest_worker_id
var $bdee8487dc67a036$var$TESTS_MODE = (globalThis === null || globalThis === void 0 || ($bdee8487dc67a036$var$_process = globalThis.process) === null || $bdee8487dc67a036$var$_process === void 0 || ($bdee8487dc67a036$var$_process = $bdee8487dc67a036$var$_process.env) === null || $bdee8487dc67a036$var$_process === void 0 ? void 0 : $bdee8487dc67a036$var$_process.JEST_WORKER_ID) !== undefined;
var $bdee8487dc67a036$var$DEBUG_MODE = !$bdee8487dc67a036$var$TESTS_MODE && (globalThis === null || globalThis === void 0 || ($bdee8487dc67a036$var$_process2 = globalThis.process) === null || $bdee8487dc67a036$var$_process2 === void 0 || ($bdee8487dc67a036$var$_process2 = $bdee8487dc67a036$var$_process2.env) === null || $bdee8487dc67a036$var$_process2 === void 0 ? void 0 : $bdee8487dc67a036$var$_process2.NODE_ENV) !== 'production';
var $bdee8487dc67a036$export$1c9f709888824e05 = function debug() {
    var _console;
    if (!$bdee8487dc67a036$var$DEBUG_MODE) return;
    // eslint-disable-next-line no-console
    (_console = console).debug.apply(_console, arguments);
};

});




parcelRegister("h0N4L", function(module, exports) {
$parcel$export(module.exports, "R300", () => $c62881328c28048a$export$4a7404f376229999);
$parcel$export(module.exports, "R400", () => $c62881328c28048a$export$2010d0fb4295b346);
$parcel$export(module.exports, "R500", () => $c62881328c28048a$export$2837b5a1a71d5c02);
$parcel$export(module.exports, "Y400", () => $c62881328c28048a$export$59619663aa6500fb);
$parcel$export(module.exports, "G300", () => $c62881328c28048a$export$940e1f69e873f202);
$parcel$export(module.exports, "G400", () => $c62881328c28048a$export$a49394138f7b8e85);
$parcel$export(module.exports, "B75", () => $c62881328c28048a$export$8c13c2ee36917869);
$parcel$export(module.exports, "B200", () => $c62881328c28048a$export$215b7063051591f1);
$parcel$export(module.exports, "B400", () => $c62881328c28048a$export$b3de0ae08da2ce64);
$parcel$export(module.exports, "P300", () => $c62881328c28048a$export$b48405b95304b5a1);
$parcel$export(module.exports, "N0", () => $c62881328c28048a$export$29a4f05edc054374);
$parcel$export(module.exports, "N10", () => $c62881328c28048a$export$e655ef011c4aa1a2);
$parcel$export(module.exports, "N20", () => $c62881328c28048a$export$9fdfb749e33cdf97);
$parcel$export(module.exports, "N30", () => $c62881328c28048a$export$3e51e8f1440314ba);
$parcel$export(module.exports, "N40", () => $c62881328c28048a$export$1ce2d1575d444ceb);
$parcel$export(module.exports, "N90", () => $c62881328c28048a$export$7c87d337fb91a97d);
$parcel$export(module.exports, "N100", () => $c62881328c28048a$export$d6447c357493214f);
$parcel$export(module.exports, "N200", () => $c62881328c28048a$export$f563ee71e9ee74cd);
$parcel$export(module.exports, "N300", () => $c62881328c28048a$export$e2ef2124cf4024b1);
$parcel$export(module.exports, "N500", () => $c62881328c28048a$export$c39c0fe0f26207ae);
$parcel$export(module.exports, "N700", () => $c62881328c28048a$export$ad0bacf983b7ddaa);
$parcel$export(module.exports, "N800", () => $c62881328c28048a$export$7d61b15e0da132af);
$parcel$export(module.exports, "N20A", () => $c62881328c28048a$export$8d43898f60b96a82);
$parcel$export(module.exports, "N30A", () => $c62881328c28048a$export$920c0d5c49070351);
$parcel$export(module.exports, "N50A", () => $c62881328c28048a$export$7d3359664e8bb0e5);
$parcel$export(module.exports, "N60A", () => $c62881328c28048a$export$d2d3bedfb276cac0);
$parcel$export(module.exports, "N70A", () => $c62881328c28048a$export$6e5e7499ff054f6d);
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ // Reds
var $c62881328c28048a$export$4b84fd0e2c617bd = '#FFEBE6';
var $c62881328c28048a$export$b34b069eff244586 = '#FFBDAD';
var $c62881328c28048a$export$be802dd0d8b57f35 = '#FF8F73';
var $c62881328c28048a$export$60847d42f9da92a6 = '#FF7452';
var $c62881328c28048a$export$4a7404f376229999 = '#FF5630';
var $c62881328c28048a$export$2010d0fb4295b346 = '#DE350B';
var $c62881328c28048a$export$2837b5a1a71d5c02 = '#BF2600';
var $c62881328c28048a$export$8d9596b529bbb9cf = '#FFFAE6';
var $c62881328c28048a$export$41060a744ab0b7ae = '#FFF0B3';
var $c62881328c28048a$export$1cc05bbbf340e559 = '#FFE380';
var $c62881328c28048a$export$5aae31392d72caaa = '#FFC400';
var $c62881328c28048a$export$c6930421db9fa514 = '#FFAB00';
var $c62881328c28048a$export$59619663aa6500fb = '#FF991F';
var $c62881328c28048a$export$874739ea9e379ab6 = '#FF8B00';
var $c62881328c28048a$export$8a6341c32b6a3ee6 = '#E3FCEF';
var $c62881328c28048a$export$69a3bf21b9686c2b = '#ABF5D1';
var $c62881328c28048a$export$afbce1382ec95f73 = '#79F2C0';
var $c62881328c28048a$export$747d86715d4175de = '#57D9A3';
var $c62881328c28048a$export$940e1f69e873f202 = '#36B37E';
var $c62881328c28048a$export$a49394138f7b8e85 = '#00875A';
var $c62881328c28048a$export$6fa04827ac68a4fb = '#006644';
var $c62881328c28048a$export$226de0355ed012f8 = '#DEEBFF';
var $c62881328c28048a$export$8c13c2ee36917869 = '#B3D4FF';
var $c62881328c28048a$export$ecfc1dff386a3e7a = '#4C9AFF';
var $c62881328c28048a$export$215b7063051591f1 = '#2684FF';
var $c62881328c28048a$export$e62e8919cca44969 = '#0065FF';
var $c62881328c28048a$export$b3de0ae08da2ce64 = '#0052CC';
var $c62881328c28048a$export$a6ee3d71bc067634 = '#0747A6';
var $c62881328c28048a$export$67f15409e87642a1 = '#669DF1';
var $c62881328c28048a$export$f0539dbc42dbb067 = '#8FB8F6';
var $c62881328c28048a$export$363e4475840015bb = '#EAE6FF';
var $c62881328c28048a$export$4b0a4417ed59760f = '#C0B6F2';
var $c62881328c28048a$export$6011520a64d9a187 = '#998DD9';
var $c62881328c28048a$export$a7175d4e9206bc80 = '#8777D9';
var $c62881328c28048a$export$b48405b95304b5a1 = '#6554C0';
var $c62881328c28048a$export$c71e4279dd54a18d = '#5243AA';
var $c62881328c28048a$export$147899de772240ec = '#403294';
var $c62881328c28048a$export$2cf711fe14c66f06 = '#E6FCFF';
var $c62881328c28048a$export$7a8f4d33f6f9772c = '#B3F5FF';
var $c62881328c28048a$export$776c9c497ef08533 = '#79E2F2';
var $c62881328c28048a$export$69cb3ca10c1e330e = '#00C7E6';
var $c62881328c28048a$export$9dc1ef0f3f48059b = '#00B8D9';
var $c62881328c28048a$export$7c835c78b6fcdef8 = '#00A3BF';
var $c62881328c28048a$export$6036577f95c3877e = '#008DA6';
var $c62881328c28048a$export$29a4f05edc054374 = '#FFFFFF';
var $c62881328c28048a$export$e655ef011c4aa1a2 = '#FAFBFC';
var $c62881328c28048a$export$9fdfb749e33cdf97 = '#F4F5F7';
var $c62881328c28048a$export$3e51e8f1440314ba = '#EBECF0';
var $c62881328c28048a$export$1ce2d1575d444ceb = '#DFE1E6';
var $c62881328c28048a$export$8754fc7e6d8b3000 = '#C1C7D0';
var $c62881328c28048a$export$c2e91cbeada39b8b = '#B3BAC5';
var $c62881328c28048a$export$5f71e19f3a7ad9de = '#A5ADBA';
var $c62881328c28048a$export$eaa8c8a70ac22806 = '#97A0AF';
var $c62881328c28048a$export$7c87d337fb91a97d = '#8993A4';
var $c62881328c28048a$export$d6447c357493214f = '#7A869A';
var $c62881328c28048a$export$f563ee71e9ee74cd = '#6B778C';
var $c62881328c28048a$export$e2ef2124cf4024b1 = '#5E6C84';
var $c62881328c28048a$export$eece5f492e429f08 = '#505F79';
var $c62881328c28048a$export$c39c0fe0f26207ae = '#42526E';
var $c62881328c28048a$export$7090862dc3038a9f = '#344563';
var $c62881328c28048a$export$ad0bacf983b7ddaa = '#253858';
var $c62881328c28048a$export$7d61b15e0da132af = '#172B4D';
var $c62881328c28048a$export$fbda843f0a27fe96 = '#091E42';
var $c62881328c28048a$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
var $c62881328c28048a$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
var $c62881328c28048a$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
var $c62881328c28048a$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
var $c62881328c28048a$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
var $c62881328c28048a$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
var $c62881328c28048a$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
var $c62881328c28048a$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
var $c62881328c28048a$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
var $c62881328c28048a$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
var $c62881328c28048a$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
var $c62881328c28048a$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
var $c62881328c28048a$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
var $c62881328c28048a$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
var $c62881328c28048a$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
var $c62881328c28048a$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
var $c62881328c28048a$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
var $c62881328c28048a$export$2f6319cf7d736c2a = '#E6EDFA';
var $c62881328c28048a$export$95126bc8884d6634 = '#DCE5F5';
var $c62881328c28048a$export$8338d8c35d44ff1 = '#CED9EB';
var $c62881328c28048a$export$5368d76ae4fbbda7 = '#B8C7E0';
var $c62881328c28048a$export$9f0a771d16ec8d36 = '#ABBBD6';
var $c62881328c28048a$export$abcf8c38338b4aa5 = '#9FB0CC';
var $c62881328c28048a$export$97e81faa16a182c7 = '#8C9CB8';
var $c62881328c28048a$export$bfe21c59123ecf33 = '#7988A3';
var $c62881328c28048a$export$ee82aa2ea6a1558 = '#67758F';
var $c62881328c28048a$export$682927c6ed76be02 = '#56637A';
var $c62881328c28048a$export$91fd9994c5be9757 = '#455166';
var $c62881328c28048a$export$d281fbfe3cff2df6 = '#3B475C';
var $c62881328c28048a$export$3902c91d8b98a753 = '#313D52';
var $c62881328c28048a$export$8e8133c1ba5845b5 = '#283447';
var $c62881328c28048a$export$33ff357f6620b39 = '#202B3D';
var $c62881328c28048a$export$633847cf062b69e0 = '#1B2638';
var $c62881328c28048a$export$9776a6e503bdbf76 = '#121A29';
var $c62881328c28048a$export$6c813d5160dff5db = '#0E1624';
var $c62881328c28048a$export$3d4f271a500072a = '#0D1424';
var $c62881328c28048a$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
var $c62881328c28048a$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
var $c62881328c28048a$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
var $c62881328c28048a$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
var $c62881328c28048a$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
var $c62881328c28048a$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
var $c62881328c28048a$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
var $c62881328c28048a$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
var $c62881328c28048a$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
var $c62881328c28048a$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
var $c62881328c28048a$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
var $c62881328c28048a$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
var $c62881328c28048a$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
var $c62881328c28048a$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
var $c62881328c28048a$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
var $c62881328c28048a$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
var $c62881328c28048a$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';
var $c62881328c28048a$export$d2adc5dedf09fced = '#292A2E';
var $c62881328c28048a$export$f51762073d2bb381 = '#94C748';
var $c62881328c28048a$export$95e26d54def96891 = '#B3DF72';

});

parcelRegister("0cQiR", function(module, exports) {
$parcel$export(module.exports, "default", () => $0009f679887ac480$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $74Zh5 = parcelRequire("74Zh5");
// eslint-disable-next-line @atlaskit/design-system/use-visually-hidden
var $0009f679887ac480$var$visuallyHiddenStyles = (0, $74Zh5.css)({
    width: '1px',
    height: '1px',
    padding: '0',
    position: 'absolute',
    border: '0',
    clip: 'rect(1px, 1px, 1px, 1px)',
    overflow: 'hidden',
    whiteSpace: 'nowrap'
});
/**
 * __Visually hidden__
 *
 * A composable element to apply a visually hidden effect to children.
 * Useful for accessibility compliance.
 *
 * @example
 * ```jsx
 * import VisuallyHidden from '@atlaskit/visually-hidden';
 *
 * export default () => (
 *   <div style={{ border: '1px solid black' }}>
 *      There is text hidden between the brackets [
 *      <VisuallyHidden>Can't see me!</VisuallyHidden>]
 *   </div>
 * );
 * ```
 */ var $0009f679887ac480$var$VisuallyHidden = function VisuallyHidden(_ref) {
    var children = _ref.children, testId = _ref.testId, role = _ref.role, id = _ref.id;
    return (0, $74Zh5.jsx)("span", {
        id: id,
        "data-testid": testId,
        css: $0009f679887ac480$var$visuallyHiddenStyles,
        role: role
    }, children);
};
var $0009f679887ac480$export$2e2bcd8739ae039 = $0009f679887ac480$var$VisuallyHidden;

});

parcelRegister("7OBJ1", function(module, exports) {
$parcel$export(module.exports, "SplitButtonContext", () => $5b0a775cbcd0fa5c$export$4b86304b2c0d7e71);
$parcel$export(module.exports, "useSplitButtonContext", () => $5b0a775cbcd0fa5c$export$47e2c6fdb142d947);

var $5FkrB = parcelRequire("5FkrB");
var $5b0a775cbcd0fa5c$export$4b86304b2c0d7e71 = /*#__PURE__*/ (0, $5FkrB.createContext)(undefined);
var $5b0a775cbcd0fa5c$export$47e2c6fdb142d947 = function useSplitButtonContext() {
    var context = (0, $5FkrB.useContext)($5b0a775cbcd0fa5c$export$4b86304b2c0d7e71);
    if (!context) return undefined;
    if (context.appearance === 'navigation') {
        var newContext = {
            spacing: 'default',
            appearance: 'subtle',
            isDisabled: false,
            isActiveOverSelected: false,
            isNavigationSplitButton: true,
            isHighlighted: context.isHighlighted
        };
        return newContext;
    }
    var splitButtonContext = {
        spacing: context.spacing,
        appearance: context.appearance,
        isDisabled: context.isDisabled,
        isActiveOverSelected: true,
        isNavigationSplitButton: false,
        isHighlighted: false
    };
    return splitButtonContext;
};

});

parcelRegister("ctTCB", function(module, exports) {
$parcel$export(module.exports, "default", () => $916356c7ef4debc8$export$2e2bcd8739ae039);
function $916356c7ef4debc8$var$abort(event) {
    event.preventDefault();
    event.stopPropagation();
}
var $916356c7ef4debc8$var$tabKeyCode = 9;
function $916356c7ef4debc8$var$onKey(event) {
    // Allowing tab so that a user can move focus away
    if (event.keyCode === $916356c7ef4debc8$var$tabKeyCode) return;
    $916356c7ef4debc8$var$abort(event);
}
function $916356c7ef4debc8$export$2e2bcd8739ae039(shouldBlockEvents, events) {
    return shouldBlockEvents ? {
        onMouseDownCapture: $916356c7ef4debc8$var$abort,
        onMouseUpCapture: $916356c7ef4debc8$var$abort,
        onKeyDownCapture: $916356c7ef4debc8$var$onKey,
        onKeyUpCapture: $916356c7ef4debc8$var$onKey,
        onTouchStartCapture: $916356c7ef4debc8$var$abort,
        onTouchEndCapture: $916356c7ef4debc8$var$abort,
        onPointerDownCapture: $916356c7ef4debc8$var$abort,
        onPointerUpCapture: $916356c7ef4debc8$var$abort,
        onClickCapture: $916356c7ef4debc8$var$abort,
        // Just smashing the existing onClick for good measure
        onClick: $916356c7ef4debc8$var$abort
    } : events;
}

});

parcelRegister("979NR", function(module, exports) {
$parcel$export(module.exports, "LOADING_LABEL", () => $6a2c5f361181b6fd$export$d4c5499dc806c969);
var $6a2c5f361181b6fd$export$d4c5499dc806c969 = ', Loading';

});

parcelRegister("d6tze", function(module, exports) {
$parcel$export(module.exports, "default", () => $98a2c558f2ae3cfa$export$2e2bcd8739ae039);

var $5FkrB = parcelRequire("5FkrB");

var $9F9ad = parcelRequire("9F9ad");
function $98a2c558f2ae3cfa$var$getIconSpacing(spacing) {
    switch(spacing){
        case 'compact':
            return 'small';
        default:
            return 'medium';
    }
}
function $98a2c558f2ae3cfa$var$getSpinnerAppearance(_ref) {
    var appearance = _ref.appearance, isDisabled = _ref.isDisabled, isSelected = _ref.isSelected;
    if (isDisabled || isSelected) return 'inherit';
    if (appearance === 'primary' || appearance === 'danger' || appearance === 'discovery') return 'invert';
    return 'inherit';
}
function $98a2c558f2ae3cfa$export$2e2bcd8739ae039(_ref2) {
    var appearance = _ref2.appearance, spacing = _ref2.spacing, isDisabled = _ref2.isDisabled, isSelected = _ref2.isSelected, testId = _ref2.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $9F9ad.default), {
        size: $98a2c558f2ae3cfa$var$getIconSpacing(spacing),
        appearance: $98a2c558f2ae3cfa$var$getSpinnerAppearance({
            appearance: appearance,
            isDisabled: isDisabled,
            isSelected: isSelected
        }),
        testId: testId ? "".concat(testId, "--loading-spinner") : undefined
    });
}

});
parcelRegister("9F9ad", function(module, exports) {
$parcel$export(module.exports, "default", () => $708f0d2567535014$export$2e2bcd8739ae039);
/* spinner.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $970q7 = parcelRequire("970q7");

var $5FkrB = parcelRequire("5FkrB");

var $3LnwD = parcelRequire("3LnwD");

var $h0N4L = parcelRequire("h0N4L");

var $4zd3K = parcelRequire("4zd3K");
/**
 * Returns the appropriate circle stroke color.
 */ function $708f0d2567535014$var$getStrokeColor(appearance) {
    return appearance === 'inherit' ? "var(--ds-icon-subtle, ".concat((0, $h0N4L.N500), ")") : "var(--ds-icon-inverse, ".concat((0, $h0N4L.N0), ")");
}
var $708f0d2567535014$var$rotate = null;
/**
 * There are three parts to the load in animation:
 * 1. Fade in
 * 2. Accelerated spin
 * 3. Stretch the spinner line
 */ var $708f0d2567535014$var$loadIn = null;
var $708f0d2567535014$var$styles = {
    rotateStyles: "_y44v1ozz _1pgl2qsq _8hrz1h6o",
    loadInStyles: "_y44v1a7z _1o51q7pw _tzy4idpf",
    wrapperStyles: "_1e0c116y _s7n4nkob",
    circleStyles: "_lswuglyw _7ljx1dhp _opj11kw7 _134c892t _1snbbs82 _jcxd7g3v _1tjm1onz"
};
/**
 * `useLayoutEffect` is being used in SSR safe form. On the server, this work doesn’t need to run.
 * `useEffect` is used in-place, because `useEffect` is not run on the server and it matches types
 * which makes things simpler than doing an `isServer` check or a `null` check.
 *
 * @see https://hello.atlassian.net/wiki/spaces/DST/pages/2081696628/DSTDACI-010+-+Interaction+Tracing+hooks+in+DS+components
 */ var $708f0d2567535014$var$useLayoutEffect = typeof window === 'undefined' ? (0, $5FkrB.useEffect) : (0, $5FkrB.useLayoutEffect);
/**
 * __Spinner__
 *
 * A spinner is an animated spinning icon that lets users know content is being loaded.
 *
 * - [Examples](https://atlassian.design/components/spinner/examples)
 * - [Code](https://atlassian.design/components/spinner/code)
 * - [Usage](https://atlassian.design/components/spinner/usage)
 */ var $708f0d2567535014$var$Spinner = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).forwardRef(function Spinner(_ref, ref) {
    var _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'inherit' : _ref$appearance, _ref$delay = _ref.delay, delay = _ref$delay === void 0 ? 0 : _ref$delay, interactionName = _ref.interactionName, label = _ref.label, _ref$size = _ref.size, providedSize = _ref$size === void 0 ? 'medium' : _ref$size, testId = _ref.testId;
    var size = typeof providedSize === 'number' ? providedSize : (0, $4zd3K.presetSizes)[providedSize];
    var animationDelay = "".concat(delay, "ms");
    var stroke = $708f0d2567535014$var$getStrokeColor(appearance);
    var context = (0, $5FkrB.useContext)((0, $3LnwD.default));
    $708f0d2567535014$var$useLayoutEffect(function() {
        if (context != null) return context.hold(interactionName);
    }, [
        context,
        interactionName
    ]);
    /**
   * The Spinner animation uses a combination of two
   * css animations on two separate elements.
   */ return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("span", {
        "data-testid": testId ? "".concat(testId, "-wrapper") : 'spinner-wrapper',
        style: {
            animationDelay: animationDelay,
            width: size,
            height: size
        },
        className: (0, $970q7.default)([
            $708f0d2567535014$var$styles.wrapperStyles,
            $708f0d2567535014$var$styles.rotateStyles
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("svg", {
        height: size,
        width: size,
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg",
        "data-testid": testId,
        ref: ref,
        "aria-label": label || undefined,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            animationDelay: animationDelay
        },
        role: label ? 'img' : 'none',
        className: (0, $970q7.default)([
            $708f0d2567535014$var$styles.loadInStyles
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("circle", {
        cx: "8",
        cy: "8",
        r: "7",
        style: {
            stroke: stroke
        },
        className: (0, $970q7.default)([
            $708f0d2567535014$var$styles.circleStyles
        ])
    })));
}));
var $708f0d2567535014$export$2e2bcd8739ae039 = $708f0d2567535014$var$Spinner;

});
parcelRegister("3LnwD", function(module, exports) {
$parcel$export(module.exports, "default", () => $2bd802835c17554f$export$2e2bcd8739ae039);

var $5FkrB = parcelRequire("5FkrB");
var $2bd802835c17554f$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $5FkrB.createContext)(null);

});

parcelRegister("4zd3K", function(module, exports) {
$parcel$export(module.exports, "presetSizes", () => $35348fa7b9e29036$export$4e9f1640bbe7a1a8);
var $35348fa7b9e29036$export$4e9f1640bbe7a1a8 = {
    xsmall: 8,
    small: 16,
    medium: 24,
    large: 48,
    xlarge: 96
};

});






parcelRegister("3WRgz", function(module, exports) {
$parcel$export(module.exports, "default", () => $2e001b78fddcc5d8$export$2e2bcd8739ae039);

var $kqp0i = parcelRequire("kqp0i");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");

var $59LlV = parcelRequire("59LlV");

var $gGtQh = parcelRequire("gGtQh");
var $2e001b78fddcc5d8$var$_excluded = [
    "analyticsContext",
    "appearance",
    "aria-label",
    "aria-labelledby",
    "autoFocus",
    "children",
    "href",
    "iconAfter",
    "iconBefore",
    "interactionName",
    "isDisabled",
    "isSelected",
    "onClick",
    "onClickCapture",
    "onKeyDownCapture",
    "onKeyUpCapture",
    "onMouseDownCapture",
    "onMouseUpCapture",
    "onPointerDownCapture",
    "onPointerUpCapture",
    "onTouchEndCapture",
    "onTouchStartCapture",
    "shouldFitContainer",
    "spacing",
    "testId"
], $2e001b78fddcc5d8$var$_excluded2 = [
    "className",
    "css",
    "as",
    "style"
];
var $2e001b78fddcc5d8$var$LinkButtonBase = function LinkButtonBase(_ref, ref) {
    var analyticsContext = _ref.analyticsContext, appearance = _ref.appearance, ariaLabel = _ref['aria-label'], ariaLabelledBy = _ref['aria-labelledby'], autoFocus = _ref.autoFocus, children = _ref.children, href = _ref.href, iconAfter = _ref.iconAfter, iconBefore = _ref.iconBefore, interactionName = _ref.interactionName, isDisabled = _ref.isDisabled, isSelected = _ref.isSelected, onClick = _ref.onClick, onClickCapture = _ref.onClickCapture, onKeyDownCapture = _ref.onKeyDownCapture, onKeyUpCapture = _ref.onKeyUpCapture, onMouseDownCapture = _ref.onMouseDownCapture, onMouseUpCapture = _ref.onMouseUpCapture, onPointerDownCapture = _ref.onPointerDownCapture, onPointerUpCapture = _ref.onPointerUpCapture, onTouchEndCapture = _ref.onTouchEndCapture, onTouchStartCapture = _ref.onTouchStartCapture, shouldFitContainer = _ref.shouldFitContainer, spacing = _ref.spacing, testId = _ref.testId, unsafeRest = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $2e001b78fddcc5d8$var$_excluded);
    // @ts-expect-error
    var _className = unsafeRest.className, _css = unsafeRest.css, _as = unsafeRest.as, _style = unsafeRest.style, saferRest = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(unsafeRest, $2e001b78fddcc5d8$var$_excluded2);
    var baseProps = (0, $gGtQh.default)({
        analyticsContext: analyticsContext,
        appearance: appearance,
        ariaLabel: ariaLabel,
        ariaLabelledBy: ariaLabelledBy,
        autoFocus: autoFocus,
        buttonType: 'link',
        children: children,
        iconAfter: iconAfter,
        iconBefore: iconBefore,
        interactionName: interactionName,
        isDisabled: isDisabled,
        isSelected: isSelected,
        onClick: onClick,
        onClickCapture: onClickCapture,
        onKeyDownCapture: onKeyDownCapture,
        onKeyUpCapture: onKeyUpCapture,
        onMouseDownCapture: onMouseDownCapture,
        onMouseUpCapture: onMouseUpCapture,
        onPointerDownCapture: onPointerDownCapture,
        onPointerUpCapture: onPointerUpCapture,
        onTouchEndCapture: onTouchEndCapture,
        onTouchStartCapture: onTouchStartCapture,
        ref: ref,
        shouldFitContainer: shouldFitContainer,
        spacing: spacing,
        testId: testId
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $59LlV.default), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, saferRest, {
        "aria-label": baseProps['aria-label'],
        "aria-labelledby": baseProps['aria-labelledby'],
        ref: baseProps.ref,
        xcss: baseProps.xcss,
        onClick: baseProps.onClick,
        onMouseDownCapture: baseProps.onMouseDownCapture,
        onMouseUpCapture: baseProps.onMouseUpCapture,
        onKeyDownCapture: baseProps.onKeyDownCapture,
        onKeyUpCapture: baseProps.onKeyUpCapture,
        onTouchStartCapture: baseProps.onTouchStartCapture,
        onTouchEndCapture: baseProps.onTouchEndCapture,
        onPointerDownCapture: baseProps.onPointerDownCapture,
        onPointerUpCapture: baseProps.onPointerUpCapture,
        onClickCapture: baseProps.onClickCapture,
        testId: testId,
        href: baseProps.isDisabled ? undefined : href,
        role: baseProps.isDisabled ? 'link' : undefined,
        "aria-disabled": baseProps.isDisabled === true ? true : undefined,
        analyticsContext: analyticsContext,
        interactionName: interactionName,
        componentName: "LinkButton"
    }), baseProps.children);
};
// Workarounds to support generic types with forwardRef + memo
var $2e001b78fddcc5d8$var$WithRef = /*#__PURE__*/ (0, $5FkrB.forwardRef)($2e001b78fddcc5d8$var$LinkButtonBase);
/**
 * __Link Button__
 *
 * Renders a link in the style of a button.
 *
 * - [Examples](https://atlassian.design/components/link-button/examples)
 * - [Code](https://atlassian.design/components/link-button/code)
 * - [Usage](https://atlassian.design/components/link-button/usage)
 */ var $2e001b78fddcc5d8$var$LinkButton = /*#__PURE__*/ (0, $5FkrB.memo)($2e001b78fddcc5d8$var$WithRef);
var $2e001b78fddcc5d8$export$2e2bcd8739ae039 = $2e001b78fddcc5d8$var$LinkButton;

});
parcelRegister("59LlV", function(module, exports) {
$parcel$export(module.exports, "default", () => $3c128641fee713e3$export$2e2bcd8739ae039);

var $kqp0i = parcelRequire("kqp0i");

var $ekGgq = parcelRequire("ekGgq");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");

var $74Zh5 = parcelRequire("74Zh5");

var $afMOk = parcelRequire("afMOk");

var $cmfNk = parcelRequire("cmfNk");

var $ivFqH = parcelRequire("ivFqH");

var $h1LyZ = parcelRequire("h1LyZ");

var $iqQs4 = parcelRequire("iqQs4");

var $i0Qin = parcelRequire("i0Qin");

var $alPfP = parcelRequire("alPfP");

var $hkJI5 = parcelRequire("hkJI5");

var $d7pIx = parcelRequire("d7pIx");
var $3c128641fee713e3$var$_excluded = [
    "href",
    "children",
    "backgroundColor",
    "newWindowLabel",
    "padding",
    "paddingBlock",
    "paddingBlockStart",
    "paddingBlockEnd",
    "paddingInline",
    "paddingInlineStart",
    "paddingInlineEnd",
    "onClick",
    "interactionName",
    "componentName",
    "analyticsContext",
    "aria-label",
    "aria-labelledby",
    "style",
    "target",
    "testId",
    "xcss"
], $3c128641fee713e3$var$_excluded2 = [
    "className"
];
// TODO: duplicates FocusRing styles from `@atlaskit/focus-ring`.
var $3c128641fee713e3$var$focusRingStyles = (0, $74Zh5.css)({
    '&:focus, &:focus-visible': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        outlineColor: (0, $hkJI5.borderColorMap)['color.border.focused'],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        outlineOffset: (0, $hkJI5.positiveSpaceMap)['space.025'],
        outlineStyle: 'solid',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        outlineWidth: (0, $hkJI5.borderWidthMap)['border.width.outline']
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
    '&:focus:not(:focus-visible)': {
        outline: 'none'
    },
    '@media screen and (forced-colors: active), screen and (-ms-high-contrast: active)': {
        '&:focus-visible': {
            outline: '1px solid'
        }
    }
});
var $3c128641fee713e3$var$baseStyles = (0, $74Zh5.css)({
    boxSizing: 'border-box',
    textDecoration: 'underline'
});
var $3c128641fee713e3$var$IS_EXTERNAL_LINK_REGEX = /^(?:(http|https):\/\/)/;
var $3c128641fee713e3$var$IS_NON_HTTP_BASED = /^(((mailto|tel|sms):)|(#))/;
// Comma is added here to add a slight pause between announcing the anchor label and "opens in new window"
var $3c128641fee713e3$var$OPENS_NEW_WINDOW_LABEL = '(opens new window)';
/**
 * __Anchor__
 *
 * A primitive for building custom anchor links.
 *
 * - [Examples](https://atlassian.design/components/primitives/anchor/examples)
 * - [Code](https://atlassian.design/components/primitives/anchor/code)
 * - [Usage](https://atlassian.design/components/primitives/anchor/usage)
 */ var $3c128641fee713e3$var$AnchorNoRef = function AnchorNoRef(_ref, ref) {
    var href = _ref.href, children = _ref.children, backgroundColor = _ref.backgroundColor, newWindowLabel = _ref.newWindowLabel, padding = _ref.padding, paddingBlock = _ref.paddingBlock, paddingBlockStart = _ref.paddingBlockStart, paddingBlockEnd = _ref.paddingBlockEnd, paddingInline = _ref.paddingInline, paddingInlineStart = _ref.paddingInlineStart, paddingInlineEnd = _ref.paddingInlineEnd, _ref$onClick = _ref.onClick, providedOnClick = _ref$onClick === void 0 ? (0, $h1LyZ.default) : _ref$onClick, interactionName = _ref.interactionName, componentName = _ref.componentName, analyticsContext = _ref.analyticsContext, ariaLabel = _ref['aria-label'], ariaLabelledBy = _ref['aria-labelledby'], style = _ref.style, target = _ref.target, testId = _ref.testId, xcss = _ref.xcss, htmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $3c128641fee713e3$var$_excluded);
    var interactionContext = (0, $5FkrB.useContext)((0, $i0Qin.default));
    var handleClick = (0, $5FkrB.useCallback)(function(e, analyticsEvent) {
        interactionContext && interactionContext.tracePress(interactionName, e.timeStamp);
        providedOnClick(e, analyticsEvent);
    }, [
        providedOnClick,
        interactionContext,
        interactionName
    ]);
    var opensNewWindowLabelId = (0, $iqQs4.useId)();
    var onClick = (0, $cmfNk.usePlatformLeafEventHandler)({
        fn: handleClick,
        action: 'clicked',
        componentName: componentName || 'Anchor',
        packageName: "@atlaskit/primitives",
        packageVersion: "13.6.0",
        analyticsData: analyticsContext,
        actionSubject: 'link'
    });
    // This is to remove className from safeHtmlAttributes
    // @ts-expect-error className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(htmlAttributes, $3c128641fee713e3$var$_excluded2);
    var resolvedStyles = (0, $d7pIx.parseXcss)(xcss);
    var RouterLink = (0, $ivFqH.default)();
    var isExternal = typeof href === 'string' && $3c128641fee713e3$var$IS_EXTERNAL_LINK_REGEX.test(href);
    var isNonHttpBased = typeof href === 'string' && $3c128641fee713e3$var$IS_NON_HTTP_BASED.test(href);
    /**
   * Renders a router link if:
   *
   * - a link component is set in the app provider
   * - it's not an external link (starting with `http://` or `https://`)
   * - it's not a non-HTTP-based link (e.g. emails, phone numbers, hash links etc.).
   */ var isRouterLink = RouterLink && !isExternal && !isNonHttpBased;
    var hrefObjectUsedWithoutRouterLink = RouterLink === undefined && (0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(href) === 'object';
    (0, $afMOk.default)(!hrefObjectUsedWithoutRouterLink, "@atlaskit/primitives: Anchor primitive cannot pass an object to 'href' unless a router link is configured in the AppProvider");
    var Component = isRouterLink ? RouterLink : 'a';
    return (0, $74Zh5.jsx)(Component, (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        style: style,
        ref: ref,
        className: resolvedStyles.static
    }, safeHtmlAttributes, {
        // @ts-expect-error
        href: !isRouterLink && typeof href !== 'string' ? undefined : href,
        target: target,
        onClick: onClick,
        "aria-label": ariaLabel && target === '_blank' && !ariaLabelledBy ? "".concat(ariaLabel, " , ").concat(newWindowLabel ? newWindowLabel : $3c128641fee713e3$var$OPENS_NEW_WINDOW_LABEL) : ariaLabel,
        "aria-labelledby": ariaLabelledBy && target === '_blank' ? "".concat(ariaLabelledBy, " ").concat(opensNewWindowLabelId) : ariaLabelledBy,
        css: [
            $3c128641fee713e3$var$baseStyles,
            $3c128641fee713e3$var$focusRingStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            backgroundColor && (0, $hkJI5.backgroundColorStylesMap)[backgroundColor],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            padding && (0, $hkJI5.paddingStylesMap).padding[padding],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlock && (0, $hkJI5.paddingStylesMap).paddingBlock[paddingBlock],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlockStart && (0, $hkJI5.paddingStylesMap).paddingBlockStart[paddingBlockStart],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlockEnd && (0, $hkJI5.paddingStylesMap).paddingBlockEnd[paddingBlockEnd],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInline && (0, $hkJI5.paddingStylesMap).paddingInline[paddingInline],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInlineStart && (0, $hkJI5.paddingStylesMap).paddingInlineStart[paddingInlineStart],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInlineEnd && (0, $hkJI5.paddingStylesMap).paddingInlineEnd[paddingInlineEnd],
            // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
            resolvedStyles.emotion
        ],
        "data-testid": testId,
        "data-is-router-link": testId ? isRouterLink ? 'true' : 'false' : undefined
    }), children, target === '_blank' && (children && !ariaLabel && !ariaLabelledBy || ariaLabelledBy) && (0, $74Zh5.jsx)((0, $alPfP.default), {
        id: opensNewWindowLabelId
    }, ", ".concat(newWindowLabel ? newWindowLabel : $3c128641fee713e3$var$OPENS_NEW_WINDOW_LABEL)));
};
// Workarounds to support generic types with forwardRef
/**
 * __Anchor__
 *
 * Anchor is a primitive for building custom anchor links. It's a wrapper around the HTML `<a>` element that provides a consistent API for handling client-side routing and Atlassian Design System styling.
 *
 * - [Examples](https://atlassian.design/components/primitives/anchor/examples)
 * - [Code](https://atlassian.design/components/primitives/anchor/code)
 * - [Usage](https://atlassian.design/components/primitives/anchor/usage)
 */ var $3c128641fee713e3$var$Anchor = /*#__PURE__*/ (0, $5FkrB.forwardRef)($3c128641fee713e3$var$AnchorNoRef);
var $3c128641fee713e3$export$2e2bcd8739ae039 = $3c128641fee713e3$var$Anchor;

});
parcelRegister("ivFqH", function(module, exports) {
$parcel$export(module.exports, "default", () => $d79b424db91dd030$export$2e2bcd8739ae039);

var $5FkrB = parcelRequire("5FkrB");

var $dXQy6 = parcelRequire("dXQy6");
/**
 * __useRouterLink()__
 *
 * Hook: Returns app-configured router link component.
 *
 * A generic can be passed to define advanced link configuration:
 * ```
 * type MyRouterLinkConfig = {
 *  to: string;
 *  replace?: boolean;
 * }
 *
 * const RouterLink = useRouterLink<MyRouterLinkConfig>();
 * ```
 */ var $d79b424db91dd030$var$useRouterLink = function useRouterLink() {
    var _useContext = (0, $5FkrB.useContext)((0, $dXQy6.RouterLinkProviderContext)), routerLinkComponent = _useContext.routerLinkComponent;
    if (routerLinkComponent) return routerLinkComponent;
};
var $d79b424db91dd030$export$2e2bcd8739ae039 = $d79b424db91dd030$var$useRouterLink;

});
parcelRegister("dXQy6", function(module, exports) {
$parcel$export(module.exports, "RouterLinkProviderContext", () => $a2a98c30de0c2e1a$export$2931e0ee690eee88);

var $5FkrB = parcelRequire("5FkrB");
var $a2a98c30de0c2e1a$export$2931e0ee690eee88 = /*#__PURE__*/ (0, $5FkrB.createContext)({});
/**
 * __RouterLinkProvider__
 *
 * Provides a configured router link component for use
 * within Design System components.
 */ var $a2a98c30de0c2e1a$var$RouterLinkProvider = function RouterLinkProvider(_ref) {
    var routerLinkComponent = _ref.routerLinkComponent, children = _ref.children;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement($a2a98c30de0c2e1a$export$2931e0ee690eee88.Provider, {
        value: {
            routerLinkComponent: routerLinkComponent
        }
    }, children);
};
var $a2a98c30de0c2e1a$export$2e2bcd8739ae039 = $a2a98c30de0c2e1a$var$RouterLinkProvider;

});


parcelRegister("iqQs4", function(module, exports) {
$parcel$export(module.exports, "useId", () => $d6b35781c966d2af$export$f680877a34711e37);

var $ekGgq = parcelRequire("ekGgq");

var $5FkrB = parcelRequire("5FkrB");

var $b5lkZ = parcelRequire("b5lkZ");

var $a4Qxy = parcelRequire("a4Qxy");
var $d6b35781c966d2af$var$_React$useId;
// Type copied from https://github.com/thearnica/react-uid/blob/0f507fbbdb1ab84acf477ec32698afe3d2191e49/src/hooks.ts#L12
// Copied rather than inferred to make the type transparent
// @ts-ignore - useId is not accessible in React 16
var $d6b35781c966d2af$var$react18UseId = ($d6b35781c966d2af$var$_React$useId = (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).useId) !== null && $d6b35781c966d2af$var$_React$useId !== void 0 ? $d6b35781c966d2af$var$_React$useId : undefined;
function $d6b35781c966d2af$export$f680877a34711e37() {
    if ($d6b35781c966d2af$var$react18UseId && (0, $a4Qxy.fg)('platform.design-system-team.react-18-use-id_mn8q4')) // eslint-disable-next-line react-hooks/rules-of-hooks
    return $d6b35781c966d2af$var$react18UseId();
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return "uid".concat((0, $b5lkZ.useUID)());
}
var $d6b35781c966d2af$export$6be90bcb437e928f = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function(_ref, ref) {
    var children = _ref.children, _ref$postfix = _ref.postfix, postfix = _ref$postfix === void 0 ? '' : _ref$postfix, _ref$prefix = _ref.prefix, prefix = _ref$prefix === void 0 ? '' : _ref$prefix;
    var id = "".concat(prefix).concat($d6b35781c966d2af$export$f680877a34711e37()).concat(postfix);
    (0, $5FkrB.useEffect)(function() {
        if (!ref) return;
        switch((0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(ref)){
            case 'function':
                ref(id);
                break;
            case 'object':
                ref.current = id;
                break;
            default:
                throw new Error("Unreachable case for unsupported type of ref \"".concat((0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(ref), "\""));
        }
    }, [
        id,
        ref
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).Fragment, null, typeof children === 'function' ? children({
        id: id
    }) : children);
});
function $d6b35781c966d2af$export$6ee17796e3d70de2() {
    if ($d6b35781c966d2af$var$react18UseId && (0, $a4Qxy.fg)('platform.design-system-team.react-18-use-id_mn8q4')) {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        var uid = $d6b35781c966d2af$var$react18UseId();
        return function(id) {
            return "".concat(uid, "-").concat(id.toString());
        };
    }
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return (0, $b5lkZ.useUIDSeed)();
}

});
parcelRegister("a4Qxy", function(module, exports) {
$parcel$export(module.exports, "fg", () => $7563088141b15ffb$export$b40ec24ac8275656);

var $5cXps = parcelRequire("5cXps");
function $7563088141b15ffb$export$ba05d765b8392e5e(flagResolver) {
    (0, $5cXps.setBooleanResolver)(flagResolver);
}
function $7563088141b15ffb$export$470e5c2be1411c89(name) {
    return (0, $5cXps.resolveBooleanFlag)(name);
}
function $7563088141b15ffb$export$b40ec24ac8275656(name) {
    return (0, $5cXps.resolveBooleanFlag)(name);
}

});
parcelRegister("5cXps", function(module, exports) {
$parcel$export(module.exports, "setBooleanResolver", () => $3cac2841b801aa90$export$f2b591175b3e424c);
$parcel$export(module.exports, "resolveBooleanFlag", () => $3cac2841b801aa90$export$6333b6aff9fc6275);

var $jZlo3 = parcelRequire("jZlo3");

var $2lDjO = parcelRequire("2lDjO");

var $3ZMUU = parcelRequire("3ZMUU");
var $3cac2841b801aa90$var$pkgName = '@atlaskit/platform-feature-flags';
var $3cac2841b801aa90$export$7e41b1b2bdee3f98 = '__PLATFORM_FEATURE_FLAGS__';
var $3cac2841b801aa90$var$hasProcessEnv = typeof $3ZMUU !== 'undefined' && typeof $3ZMUU.env !== 'undefined';
// FF global overrides can be configured by test runners or Storybook
var $3cac2841b801aa90$var$ENV_ENABLE_PLATFORM_FF = $3cac2841b801aa90$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
// STORYBOOK_ENABLE_PLATFORM_FF is included as storybook only allows env vars prefixed with STORYBOOK
// https://github.com/storybookjs/storybook/issues/12270
var $3cac2841b801aa90$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF = $3cac2841b801aa90$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
var $3cac2841b801aa90$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE = $3cac2841b801aa90$var$ENV_ENABLE_PLATFORM_FF || $3cac2841b801aa90$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF;
var $3cac2841b801aa90$var$DEFAULT_PFF_GLOBAL = {
    booleanResolver: undefined
};
var $3cac2841b801aa90$var$globalVar = typeof window !== 'undefined' ? window : globalThis;
$3cac2841b801aa90$var$globalVar[$3cac2841b801aa90$export$7e41b1b2bdee3f98] = $3cac2841b801aa90$var$globalVar[$3cac2841b801aa90$export$7e41b1b2bdee3f98] || $3cac2841b801aa90$var$DEFAULT_PFF_GLOBAL;
function $3cac2841b801aa90$export$f2b591175b3e424c(resolver) {
    $3cac2841b801aa90$var$globalVar[$3cac2841b801aa90$export$7e41b1b2bdee3f98].booleanResolver = resolver;
}
function $3cac2841b801aa90$export$6333b6aff9fc6275(flagKey) {
    if ($3cac2841b801aa90$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE) {
        (0, $2lDjO.debug)('[%s]: The feature flags were enabled while running tests. The flag "%s" will be always enabled.', $3cac2841b801aa90$var$pkgName, flagKey);
        return true;
    }
    try {
        var _globalVar$PFF_GLOBAL, _globalVar$PFF_GLOBAL2, _globalVar$PFF_GLOBAL3;
        // booleanResolver will be empty for products like Trello, Elevate, Recruit etc.
        // Currently only Confluence, Jira and Bitbucket has set it.
        if (((_globalVar$PFF_GLOBAL = $3cac2841b801aa90$var$globalVar[$3cac2841b801aa90$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL === void 0 ? void 0 : _globalVar$PFF_GLOBAL.booleanResolver) === undefined || ((_globalVar$PFF_GLOBAL2 = $3cac2841b801aa90$var$globalVar[$3cac2841b801aa90$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL2 === void 0 ? void 0 : _globalVar$PFF_GLOBAL2.booleanResolver) === null) // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
        return (0, $jZlo3.default).checkGate(flagKey);
        var result = (_globalVar$PFF_GLOBAL3 = $3cac2841b801aa90$var$globalVar[$3cac2841b801aa90$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL3 === void 0 ? void 0 : _globalVar$PFF_GLOBAL3.booleanResolver(flagKey);
        if (typeof result !== 'boolean') {
            // eslint-disable-next-line no-console
            console.warn("".concat(flagKey, " resolved to a non-boolean value, returning false for safety"));
            return false;
        }
        return result;
    } catch (e) {
        return false;
    }
}

});
parcelRegister("2lDjO", function(module, exports) {
$parcel$export(module.exports, "debug", () => $1b5c0ac491de75fd$export$1c9f709888824e05);
var $1b5c0ac491de75fd$var$_process, $1b5c0ac491de75fd$var$_process2;
// We can't rely on NODE_ENV === 'test' if its value is already configured by the consumer to some other value, so better to use JEST_WORKER_ID
// https://jestjs.io/docs/environment-variables#jest_worker_id
var $1b5c0ac491de75fd$var$TESTS_MODE = (globalThis === null || globalThis === void 0 || ($1b5c0ac491de75fd$var$_process = globalThis.process) === null || $1b5c0ac491de75fd$var$_process === void 0 || ($1b5c0ac491de75fd$var$_process = $1b5c0ac491de75fd$var$_process.env) === null || $1b5c0ac491de75fd$var$_process === void 0 ? void 0 : $1b5c0ac491de75fd$var$_process.JEST_WORKER_ID) !== undefined;
var $1b5c0ac491de75fd$var$DEBUG_MODE = !$1b5c0ac491de75fd$var$TESTS_MODE && (globalThis === null || globalThis === void 0 || ($1b5c0ac491de75fd$var$_process2 = globalThis.process) === null || $1b5c0ac491de75fd$var$_process2 === void 0 || ($1b5c0ac491de75fd$var$_process2 = $1b5c0ac491de75fd$var$_process2.env) === null || $1b5c0ac491de75fd$var$_process2 === void 0 ? void 0 : $1b5c0ac491de75fd$var$_process2.NODE_ENV) !== 'production';
var $1b5c0ac491de75fd$export$1c9f709888824e05 = function debug() {
    var _console;
    if (!$1b5c0ac491de75fd$var$DEBUG_MODE) return;
    // eslint-disable-next-line no-console
    (_console = console).debug.apply(_console, arguments);
};

});




parcelRegister("alPfP", function(module, exports) {
$parcel$export(module.exports, "default", () => $78939f90a2f455c0$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $74Zh5 = parcelRequire("74Zh5");
// eslint-disable-next-line @atlaskit/design-system/use-visually-hidden
var $78939f90a2f455c0$var$visuallyHiddenStyles = (0, $74Zh5.css)({
    width: '1px',
    height: '1px',
    padding: '0',
    position: 'absolute',
    border: '0',
    clip: 'rect(1px, 1px, 1px, 1px)',
    overflow: 'hidden',
    whiteSpace: 'nowrap'
});
/**
 * __Visually hidden__
 *
 * A composable element to apply a visually hidden effect to children.
 * Useful for accessibility compliance.
 *
 * @example
 * ```jsx
 * import VisuallyHidden from '@atlaskit/visually-hidden';
 *
 * export default () => (
 *   <div style={{ border: '1px solid black' }}>
 *      There is text hidden between the brackets [
 *      <VisuallyHidden>Can't see me!</VisuallyHidden>]
 *   </div>
 * );
 * ```
 */ var $78939f90a2f455c0$var$VisuallyHidden = function VisuallyHidden(_ref) {
    var children = _ref.children, testId = _ref.testId, role = _ref.role, id = _ref.id;
    return (0, $74Zh5.jsx)("span", {
        id: id,
        "data-testid": testId,
        css: $78939f90a2f455c0$var$visuallyHiddenStyles,
        role: role
    }, children);
};
var $78939f90a2f455c0$export$2e2bcd8739ae039 = $78939f90a2f455c0$var$VisuallyHidden;

});



parcelRegister("lyGTA", function(module, exports) {
$parcel$export(module.exports, "default", () => $fb1e0c1d2dd49e6a$export$2e2bcd8739ae039);

var $kqp0i = parcelRequire("kqp0i");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");

var $1C5BS = parcelRequire("1C5BS");

var $1oVT1 = parcelRequire("1oVT1");

var $fmio1 = parcelRequire("fmio1");
var $fb1e0c1d2dd49e6a$var$_excluded = [
    "aria-label",
    "aria-labelledby",
    "analyticsContext",
    "appearance",
    "autoFocus",
    "icon",
    "interactionName",
    "isDisabled",
    "isLoading",
    "isSelected",
    "isTooltipDisabled",
    "label",
    "onClick",
    "onClickCapture",
    "onKeyDownCapture",
    "onKeyUpCapture",
    "onMouseDownCapture",
    "onMouseUpCapture",
    "onPointerDownCapture",
    "onPointerUpCapture",
    "onTouchEndCapture",
    "onTouchStartCapture",
    "shape",
    "spacing",
    "testId",
    "tooltip",
    "type"
], $fb1e0c1d2dd49e6a$var$_excluded2 = [
    "className",
    "css",
    "as",
    "style"
];
/**
 * __Icon Button__
 *
 * Renders an icon-only button lets people take a common and recognizable action where space is limited.
 *
 * - [Examples](https://atlassian.design/components/button/icon-button/examples)
 * - [Code](https://atlassian.design/components/button/icon-button/code)
 * - [Usage](https://atlassian.design/components/button/icon-button/usage)
 */ var $fb1e0c1d2dd49e6a$var$IconButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).forwardRef(function Button(_ref, ref) {
    var preventedAriaLabel = _ref['aria-label'], ariaLabelledBy = _ref['aria-labelledby'], analyticsContext = _ref.analyticsContext, appearance = _ref.appearance, autoFocus = _ref.autoFocus, icon = _ref.icon, interactionName = _ref.interactionName, isDisabled = _ref.isDisabled, isLoading = _ref.isLoading, isSelected = _ref.isSelected, _ref$isTooltipDisable = _ref.isTooltipDisabled, isTooltipDisabled = _ref$isTooltipDisable === void 0 ? true : _ref$isTooltipDisable, label = _ref.label, onClick = _ref.onClick, onClickCapture = _ref.onClickCapture, onKeyDownCapture = _ref.onKeyDownCapture, onKeyUpCapture = _ref.onKeyUpCapture, onMouseDownCapture = _ref.onMouseDownCapture, onMouseUpCapture = _ref.onMouseUpCapture, onPointerDownCapture = _ref.onPointerDownCapture, onPointerUpCapture = _ref.onPointerUpCapture, onTouchEndCapture = _ref.onTouchEndCapture, onTouchStartCapture = _ref.onTouchStartCapture, shape = _ref.shape, spacing = _ref.spacing, testId = _ref.testId, tooltip = _ref.tooltip, _ref$type = _ref.type, type = _ref$type === void 0 ? 'button' : _ref$type, unsafeRest = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $fb1e0c1d2dd49e6a$var$_excluded);
    // @ts-expect-error
    var _className = unsafeRest.className, _css = unsafeRest.css, _as = unsafeRest.as, _style = unsafeRest.style, saferRest = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(unsafeRest, $fb1e0c1d2dd49e6a$var$_excluded2);
    /**
   * TODO: At some stage I'll look into re-using more logic across 'default' and 'icon'
   * buttons. It's currently duplicated and mostly the same.
   */ var baseProps = (0, $fmio1.default)({
        analyticsContext: analyticsContext,
        appearance: appearance,
        ariaLabelledBy: ariaLabelledBy,
        autoFocus: autoFocus,
        buttonType: 'button',
        icon: icon,
        interactionName: interactionName,
        isDisabled: isDisabled,
        isLoading: isLoading,
        isSelected: isSelected,
        label: label,
        onClick: onClick,
        onClickCapture: onClickCapture,
        onKeyDownCapture: onKeyDownCapture,
        onKeyUpCapture: onKeyUpCapture,
        onMouseDownCapture: onMouseDownCapture,
        onMouseUpCapture: onMouseUpCapture,
        onPointerDownCapture: onPointerDownCapture,
        onPointerUpCapture: onPointerUpCapture,
        onTouchEndCapture: onTouchEndCapture,
        onTouchStartCapture: onTouchStartCapture,
        ref: ref,
        shape: shape,
        spacing: spacing,
        testId: testId
    });
    if (!isTooltipDisabled) {
        var _tooltip$content;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $1oVT1.default), {
            content: (_tooltip$content = tooltip === null || tooltip === void 0 ? void 0 : tooltip.content) !== null && _tooltip$content !== void 0 ? _tooltip$content : label,
            testId: tooltip === null || tooltip === void 0 ? void 0 : tooltip.testId,
            position: tooltip === null || tooltip === void 0 ? void 0 : tooltip.position,
            delay: tooltip === null || tooltip === void 0 ? void 0 : tooltip.delay,
            onShow: tooltip === null || tooltip === void 0 ? void 0 : tooltip.onShow,
            onHide: tooltip === null || tooltip === void 0 ? void 0 : tooltip.onHide,
            mousePosition: tooltip === null || tooltip === void 0 ? void 0 : tooltip.mousePosition,
            analyticsContext: tooltip === null || tooltip === void 0 ? void 0 : tooltip.analyticsContext,
            strategy: tooltip === null || tooltip === void 0 ? void 0 : tooltip.strategy,
            tag: tooltip === null || tooltip === void 0 ? void 0 : tooltip.tag,
            truncate: tooltip === null || tooltip === void 0 ? void 0 : tooltip.truncate,
            component: tooltip === null || tooltip === void 0 ? void 0 : tooltip.component,
            hideTooltipOnClick: tooltip === null || tooltip === void 0 ? void 0 : tooltip.hideTooltipOnClick,
            hideTooltipOnMouseDown: tooltip === null || tooltip === void 0 ? void 0 : tooltip.hideTooltipOnMouseDown,
            ignoreTooltipPointerEvents: tooltip === null || tooltip === void 0 ? void 0 : tooltip.ignoreTooltipPointerEvents
        }, function(triggerProps) {
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $1C5BS.default), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, saferRest, {
                // Top level props
                "aria-labelledby": baseProps['aria-labelledby'],
                type: type,
                testId: testId,
                componentName: "IconButton",
                analyticsContext: analyticsContext,
                interactionName: interactionName,
                onMouseOver: function onMouseOver(e) {
                    var _triggerProps$onMouse, _saferRest$onMouseOve;
                    (_triggerProps$onMouse = triggerProps.onMouseOver) === null || _triggerProps$onMouse === void 0 || _triggerProps$onMouse.call(triggerProps, e);
                    (_saferRest$onMouseOve = saferRest.onMouseOver) === null || _saferRest$onMouseOve === void 0 || _saferRest$onMouseOve.call(saferRest, e);
                },
                onMouseOut: function onMouseOut(e) {
                    var _triggerProps$onMouse2, _saferRest$onMouseOut;
                    (_triggerProps$onMouse2 = triggerProps.onMouseOut) === null || _triggerProps$onMouse2 === void 0 || _triggerProps$onMouse2.call(triggerProps, e);
                    (_saferRest$onMouseOut = saferRest.onMouseOut) === null || _saferRest$onMouseOut === void 0 || _saferRest$onMouseOut.call(saferRest, e);
                },
                onMouseMove: function onMouseMove(e) {
                    var _triggerProps$onMouse3, _saferRest$onMouseMov;
                    (_triggerProps$onMouse3 = triggerProps.onMouseMove) === null || _triggerProps$onMouse3 === void 0 || _triggerProps$onMouse3.call(triggerProps, e);
                    (_saferRest$onMouseMov = saferRest.onMouseMove) === null || _saferRest$onMouseMov === void 0 || _saferRest$onMouseMov.call(saferRest, e);
                },
                onMouseDown: function onMouseDown(e) {
                    var _triggerProps$onMouse4, _saferRest$onMouseDow;
                    (_triggerProps$onMouse4 = triggerProps.onMouseDown) === null || _triggerProps$onMouse4 === void 0 || _triggerProps$onMouse4.call(triggerProps, e);
                    (_saferRest$onMouseDow = saferRest.onMouseDown) === null || _saferRest$onMouseDow === void 0 || _saferRest$onMouseDow.call(saferRest, e);
                },
                onFocus: function onFocus(e) {
                    var _triggerProps$onFocus, _saferRest$onFocus;
                    (_triggerProps$onFocus = triggerProps.onFocus) === null || _triggerProps$onFocus === void 0 || _triggerProps$onFocus.call(triggerProps, e);
                    (_saferRest$onFocus = saferRest.onFocus) === null || _saferRest$onFocus === void 0 || _saferRest$onFocus.call(saferRest, e);
                },
                onBlur: function onBlur(e) {
                    var _triggerProps$onBlur, _saferRest$onBlur;
                    (_triggerProps$onBlur = triggerProps.onBlur) === null || _triggerProps$onBlur === void 0 || _triggerProps$onBlur.call(triggerProps, e);
                    (_saferRest$onBlur = saferRest.onBlur) === null || _saferRest$onBlur === void 0 || _saferRest$onBlur.call(saferRest, e);
                },
                onClick: function onClick(event, analyticsEvent) {
                    var _baseProps$onClick, _triggerProps$onClick;
                    baseProps === null || baseProps === void 0 || (_baseProps$onClick = baseProps.onClick) === null || _baseProps$onClick === void 0 || _baseProps$onClick.call(baseProps, event, analyticsEvent);
                    triggerProps === null || triggerProps === void 0 || (_triggerProps$onClick = triggerProps.onClick) === null || _triggerProps$onClick === void 0 || _triggerProps$onClick.call(triggerProps, event);
                },
                ref: function ref(_ref2) {
                    var _triggerProps$ref;
                    baseProps.ref(_ref2);
                    triggerProps === null || triggerProps === void 0 || (_triggerProps$ref = triggerProps.ref) === null || _triggerProps$ref === void 0 || _triggerProps$ref.call(triggerProps, _ref2);
                },
                xcss: baseProps.xcss,
                isDisabled: baseProps.isDisabled,
                onMouseDownCapture: baseProps.onMouseDownCapture,
                onMouseUpCapture: baseProps.onMouseUpCapture,
                onKeyDownCapture: baseProps.onKeyDownCapture,
                onKeyUpCapture: baseProps.onKeyUpCapture,
                onTouchStartCapture: baseProps.onTouchStartCapture,
                onTouchEndCapture: baseProps.onTouchEndCapture,
                onPointerDownCapture: baseProps.onPointerDownCapture,
                onPointerUpCapture: baseProps.onPointerUpCapture,
                onClickCapture: baseProps.onClickCapture
            }), baseProps.children);
        });
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $1C5BS.default), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, saferRest, {
        "aria-labelledby": baseProps['aria-labelledby'],
        ref: baseProps.ref,
        xcss: baseProps.xcss,
        isDisabled: baseProps.isDisabled,
        onClick: baseProps.onClick,
        onMouseDownCapture: baseProps.onMouseDownCapture,
        onMouseUpCapture: baseProps.onMouseUpCapture,
        onKeyDownCapture: baseProps.onKeyDownCapture,
        onKeyUpCapture: baseProps.onKeyUpCapture,
        onTouchStartCapture: baseProps.onTouchStartCapture,
        onTouchEndCapture: baseProps.onTouchEndCapture,
        onPointerDownCapture: baseProps.onPointerDownCapture,
        onPointerUpCapture: baseProps.onPointerUpCapture,
        onClickCapture: baseProps.onClickCapture,
        type: type,
        testId: testId,
        componentName: "IconButton",
        analyticsContext: analyticsContext,
        interactionName: interactionName
    }), baseProps.children);
}));
$fb1e0c1d2dd49e6a$var$IconButton.displayName = 'IconButton';
var $fb1e0c1d2dd49e6a$export$2e2bcd8739ae039 = $fb1e0c1d2dd49e6a$var$IconButton;

});
parcelRegister("1oVT1", function(module, exports) {
$parcel$export(module.exports, "default", () => $1054ef677ee15d9a$export$2e2bcd8739ae039);

var $kqp0i = parcelRequire("kqp0i");

var $iYJcE = parcelRequire("iYJcE");

var $25nEq = parcelRequire("25nEq");

var $5FkrB = parcelRequire("5FkrB");

var $7QpUe = parcelRequire("7QpUe");

var $l3edN = parcelRequire("l3edN");

var $35QIf = parcelRequire("35QIf");

var $h5mrR = parcelRequire("h5mrR");

var $1AQ59 = parcelRequire("1AQ59");

var $ky91o = parcelRequire("ky91o");

var $8mpiS = parcelRequire("8mpiS");
var $6b2cA = parcelRequire("6b2cA");

var $dGqY2 = parcelRequire("dGqY2");

var $9tRs0 = parcelRequire("9tRs0");

var $7LfsS = parcelRequire("7LfsS");

var $6PYYg = parcelRequire("6PYYg");

var $c0Z2u = parcelRequire("c0Z2u");

var $9Nvet = parcelRequire("9Nvet");

var $fArWw = parcelRequire("fArWw");

var $059LA = parcelRequire("059LA");
function $1054ef677ee15d9a$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $1054ef677ee15d9a$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $1054ef677ee15d9a$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $1054ef677ee15d9a$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $1054ef677ee15d9a$var$tooltipZIndex = (0, $7LfsS.layers).tooltip();
var $1054ef677ee15d9a$var$analyticsAttributes = {
    componentName: 'tooltip',
    packageName: "@atlaskit/tooltip",
    packageVersion: "19.2.0"
};
// Inverts motion direction
var $1054ef677ee15d9a$var$invertedDirection = {
    top: 'bottom',
    bottom: 'top',
    left: 'right',
    right: 'left'
};
/**
 * Converts a Popper placement to it's general direction.
 *
 * @param placement - Popper Placement value, e.g. 'top-start'
 * @returns Popper Direction, e.g. 'top'
 */ var $1054ef677ee15d9a$var$getDirectionFromPlacement = function getDirectionFromPlacement(placement) {
    return placement.split('-')[0];
};
/**
 * __Tooltip__
 *
 * A tooltip is a floating, non-actionable label used to explain a user interface element or feature.
 */ function $1054ef677ee15d9a$var$Tooltip(_ref) {
    var children = _ref.children, _ref$position = _ref.position, position = _ref$position === void 0 ? 'bottom' : _ref$position, _ref$mousePosition = _ref.mousePosition, mousePosition = _ref$mousePosition === void 0 ? 'bottom' : _ref$mousePosition, content = _ref.content, _ref$truncate = _ref.truncate, truncate = _ref$truncate === void 0 ? false : _ref$truncate, _ref$component = _ref.component, Container = _ref$component === void 0 ? (0, $fArWw.default) : _ref$component, _ref$tag = _ref.tag, TargetContainer = _ref$tag === void 0 ? 'div' : _ref$tag, testId = _ref.testId, _ref$delay = _ref.delay, delay = _ref$delay === void 0 ? 300 : _ref$delay, _ref$onShow = _ref.onShow, onShow = _ref$onShow === void 0 ? (0, $35QIf.default) : _ref$onShow, _ref$onHide = _ref.onHide, onHide = _ref$onHide === void 0 ? (0, $35QIf.default) : _ref$onHide, canAppear = _ref.canAppear, _ref$hideTooltipOnCli = _ref.hideTooltipOnClick, hideTooltipOnClick = _ref$hideTooltipOnCli === void 0 ? false : _ref$hideTooltipOnCli, _ref$hideTooltipOnMou = _ref.hideTooltipOnMouseDown, hideTooltipOnMouseDown = _ref$hideTooltipOnMou === void 0 ? false : _ref$hideTooltipOnMou, analyticsContext = _ref.analyticsContext, _ref$strategy = _ref.strategy, strategy = _ref$strategy === void 0 ? 'fixed' : _ref$strategy, _ref$ignoreTooltipPoi = _ref.ignoreTooltipPointerEvents, ignoreTooltipPointerEvents = _ref$ignoreTooltipPoi === void 0 ? false : _ref$ignoreTooltipPoi, _ref$isScreenReaderAn = _ref.isScreenReaderAnnouncementDisabled, isScreenReaderAnnouncementDisabled = _ref$isScreenReaderAn === void 0 ? false : _ref$isScreenReaderAn;
    var tooltipPosition = position === 'mouse' ? mousePosition : position;
    var onShowHandler = (0, $l3edN.usePlatformLeafSyntheticEventHandler)($1054ef677ee15d9a$var$_objectSpread({
        fn: onShow,
        action: 'displayed',
        analyticsData: analyticsContext
    }, $1054ef677ee15d9a$var$analyticsAttributes));
    var onHideHandler = (0, $l3edN.usePlatformLeafSyntheticEventHandler)($1054ef677ee15d9a$var$_objectSpread({
        fn: onHide,
        action: 'hidden',
        analyticsData: analyticsContext
    }, $1054ef677ee15d9a$var$analyticsAttributes));
    var apiRef = (0, $5FkrB.useRef)(null);
    var _useState = (0, $5FkrB.useState)('hide'), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), state = _useState2[0], setState = _useState2[1];
    var targetRef = (0, $5FkrB.useRef)(null);
    var containerRef = (0, $5FkrB.useRef)(null);
    // This function is deliberately _not_ memoized as it needs to re-run every render
    // to pick up any child ref changes. If you use render props you don't have this issue.
    var setImplicitRefFromChildren = function setImplicitRefFromChildren(node) {
        containerRef.current = node;
        targetRef.current = node ? node.firstElementChild : null;
    };
    // This is memoized and passed into the render props callback.
    var setDirectRef = (0, $5FkrB.useCallback)(function(node) {
        targetRef.current = node;
    }, []);
    // Putting a few things into refs so that we don't have to break memoization
    var stableState = (0, $1AQ59.default)(state);
    // These props are placed in separate refs instead of a single object to reduce memory usage.
    // Placing them in the same object previously caused an increase in the number of JavaScript event listeners
    // before garbage collection.
    var onShowHandlerStable = (0, $1AQ59.default)(onShowHandler);
    var onHideHandlerStable = (0, $1AQ59.default)(onHideHandler);
    var delayStable = (0, $1AQ59.default)(delay);
    var canAppearStable = (0, $1AQ59.default)(canAppear);
    var hasCalledShowHandler = (0, $5FkrB.useRef)(false);
    var start = (0, $5FkrB.useCallback)(function(api) {
        // @ts-ignore
        apiRef.current = api;
        hasCalledShowHandler.current = false;
    }, []);
    var done = (0, $5FkrB.useCallback)(function() {
        if (!apiRef.current) return;
        // Only call onHideHandler if we have called onShowHandler
        if (hasCalledShowHandler.current) onHideHandlerStable.current();
        // @ts-ignore
        apiRef.current = null;
        // @ts-ignore
        hasCalledShowHandler.current = false;
        // just in case
        setState('hide');
    }, [
        onHideHandlerStable
    ]);
    var abort = (0, $5FkrB.useCallback)(function() {
        if (!apiRef.current) return;
        apiRef.current.abort();
        // Only call onHideHandler if we have called onShowHandler
        if (hasCalledShowHandler.current) onHideHandlerStable.current();
        // @ts-ignore
        apiRef.current = null;
    }, [
        onHideHandlerStable
    ]);
    (0, $5FkrB.useEffect)(function mount() {
        return function unmount() {
            if (apiRef.current) abort();
        };
    }, [
        abort
    ]);
    var isDraggingRef = (0, $5FkrB.useRef)(false);
    (0, $5FkrB.useEffect)(function() {
        return (0, $6PYYg.register)({
            onRegister: function onRegister(_ref2) {
                var isDragging = _ref2.isDragging;
                isDraggingRef.current = isDragging;
            },
            onDragStart: function onDragStart() {
                var _apiRef$current;
                /**
         * Hiding any visible tooltips when a drag starts because otherwise it
         * looks janky (disappears and reappears), and is not required.
         */ (_apiRef$current = apiRef.current) === null || _apiRef$current === void 0 || _apiRef$current.requestHide({
                    isImmediate: true
                });
                isDraggingRef.current = true;
            },
            onDragEnd: function onDragEnd() {
                isDraggingRef.current = false;
            }
        });
    }, []);
    var tryShowTooltip = (0, $5FkrB.useCallback)(function(source) {
        var _canAppearStable$curr;
        /**
     * Prevent tooltips from being shown during a drag. This can occur with
     * the native drag and drop API, where some pointer events can fire
     * when they should not and lead to jank with tooltips.
     */ if (isDraggingRef.current) return;
        // Another tooltip is has been active but we still have the old `api`
        // around. We need to finish up the last usage.
        // Note: just being safe - this should not happen
        if (apiRef.current && !apiRef.current.isActive()) abort();
        // This tooltip is already active, we can exit
        if (apiRef.current && apiRef.current.isActive()) {
            apiRef.current.keep();
            return;
        }
        /**
     * Check if tooltip is allowed to show.
     *
     * Once a tooltip has started, or has scheduled to start
     * we won't be checking `canAppear` again.
     *
     * - We don't want tooltips to disappear once they are shown
     * - For consistency, we start after a single positive `canAppear`.
     *   Otherwise the amount of times we ask consumers would depend on
     *   how many times we get a "mousemove", which _could_ lead to situations
     *   where moving the mouse could result in a different outcome to if
     *   the mouse was not moved.
     */ if (canAppearStable.current && !((_canAppearStable$curr = canAppearStable.current) !== null && _canAppearStable$curr !== void 0 && _canAppearStable$curr.call(canAppearStable))) return;
        var entry = {
            source: source,
            delay: delayStable.current,
            show: function show(_ref3) {
                var isImmediate = _ref3.isImmediate;
                // Call the onShow handler if it hasn't been called yet
                if (!hasCalledShowHandler.current) {
                    hasCalledShowHandler.current = true;
                    onShowHandlerStable.current();
                }
                setState(isImmediate ? 'show-immediate' : 'fade-in');
            },
            hide: function hide(_ref4) {
                var isImmediate = _ref4.isImmediate;
                if (isImmediate) setState('hide');
                else setState('before-fade-out');
            },
            done: done
        };
        var api = (0, $c0Z2u.show)(entry);
        start(api);
    }, [
        canAppearStable,
        delayStable,
        done,
        start,
        abort,
        onShowHandlerStable
    ]);
    var hideTooltipOnEsc = (0, $5FkrB.useCallback)(function() {
        var _apiRef$current2;
        (_apiRef$current2 = apiRef.current) === null || _apiRef$current2 === void 0 || _apiRef$current2.requestHide({
            isImmediate: true
        });
    }, [
        apiRef
    ]);
    (0, $h5mrR.default)({
        onClose: hideTooltipOnEsc,
        isDisabled: state === 'hide' || state === 'fade-out'
    });
    (0, $5FkrB.useEffect)(function() {
        if (state === 'hide') return 0, $35QIf.default;
        if (state === 'before-fade-out') setState('fade-out');
        var unbind = (0, $7QpUe.bind)(window, {
            type: 'scroll',
            listener: function listener() {
                if (apiRef.current) apiRef.current.requestHide({
                    isImmediate: true
                });
            },
            options: {
                capture: true,
                passive: true,
                once: true
            }
        });
        return unbind;
    }, [
        state
    ]);
    var onMouseDown = (0, $5FkrB.useCallback)(function() {
        if (hideTooltipOnMouseDown && apiRef.current) apiRef.current.requestHide({
            isImmediate: true
        });
    }, [
        hideTooltipOnMouseDown
    ]);
    var onClick = (0, $5FkrB.useCallback)(function() {
        if (hideTooltipOnClick && apiRef.current) apiRef.current.requestHide({
            isImmediate: true
        });
    }, [
        hideTooltipOnClick
    ]);
    // Ideally we would be using onMouseEnter here, but
    // because we are binding the event to the target parent
    // we need to listen for the mouseover of all sub elements
    // This means when moving along a tooltip we are quickly toggling
    // between api.requestHide and api.keep. This it not ideal
    var onMouseOver = (0, $5FkrB.useCallback)(function(event) {
        // Ignoring events from the container ref
        if (containerRef.current && event.target === containerRef.current) return;
        // Using prevent default as a signal that parent tooltips
        if (event.defaultPrevented) return;
        event.preventDefault();
        var source = position === 'mouse' ? {
            type: 'mouse',
            // TODO: ideally not recalculating this object each time
            mouse: (0, $059LA.getMousePosition)({
                left: event.clientX,
                top: event.clientY
            })
        } : {
            type: 'keyboard'
        };
        tryShowTooltip(source);
    }, [
        position,
        tryShowTooltip
    ]);
    // Ideally we would be using onMouseEnter here, but
    // because we are binding the event to the target parent
    // we need to listen for the mouseout of all sub elements
    // This means when moving along a tooltip we are quickly toggling
    // between api.requestHide and api.keep. This it not ideal
    var onMouseOut = (0, $5FkrB.useCallback)(function(event) {
        // Ignoring events from the container ref
        if (containerRef.current && event.target === containerRef.current) return;
        // Using prevent default as a signal that parent tooltips
        if (event.defaultPrevented) return;
        event.preventDefault();
        if (apiRef.current) apiRef.current.requestHide({
            isImmediate: false
        });
    }, []);
    var onMouseMove = position === 'mouse' ? function(event) {
        var _apiRef$current3;
        if ((_apiRef$current3 = apiRef.current) !== null && _apiRef$current3 !== void 0 && _apiRef$current3.isActive()) apiRef.current.mousePosition = (0, $059LA.getMousePosition)({
            left: event.clientX,
            top: event.clientY
        });
    } : undefined;
    var onMouseOverTooltip = (0, $5FkrB.useCallback)(function() {
        if (apiRef.current && apiRef.current.isActive()) {
            apiRef.current.keep();
            return;
        }
    }, []);
    var onFocus = (0, $5FkrB.useCallback)(function() {
        // TODO: this does not play well with `hideTooltipOnMouseDown`
        // as "focus" will occur after the "mousedown".
        tryShowTooltip({
            type: 'keyboard'
        });
    }, [
        tryShowTooltip
    ]);
    var onBlur = (0, $5FkrB.useCallback)(function() {
        if (apiRef.current) apiRef.current.requestHide({
            isImmediate: false
        });
    }, []);
    var onAnimationFinished = (0, $5FkrB.useCallback)(function(transition) {
        // Using lastState here because motion is not picking up the latest value
        if (transition === 'exiting' && stableState.current === 'fade-out' && apiRef.current) // @ts-ignore: refs are writeable
        apiRef.current.finishHideAnimation();
    }, [
        stableState
    ]);
    // Doing a cast because typescript is struggling to narrow the type
    var CastTargetContainer = TargetContainer;
    var shouldRenderTooltipPopup = state !== 'hide' && Boolean(content);
    var shouldRenderHiddenContent = !isScreenReaderAnnouncementDisabled && shouldRenderTooltipPopup;
    var shouldRenderTooltipChildren = state !== 'hide' && state !== 'fade-out';
    (0, $ky91o.useNotifyOpenLayerObserver)({
        isOpen: shouldRenderTooltipPopup
    });
    var getReferenceElement = function getReferenceElement() {
        var _apiRef$current4;
        if (position === 'mouse' && (_apiRef$current4 = apiRef.current) !== null && _apiRef$current4 !== void 0 && _apiRef$current4.mousePosition) {
            var _apiRef$current5;
            return (_apiRef$current5 = apiRef.current) === null || _apiRef$current5 === void 0 ? void 0 : _apiRef$current5.mousePosition;
        }
        return targetRef.current || undefined;
    };
    var tooltipIdForHiddenContent = (0, $9Nvet.default)('tooltip', shouldRenderHiddenContent);
    var tooltipTriggerProps = {
        onMouseOver: onMouseOver,
        onMouseOut: onMouseOut,
        onMouseMove: onMouseMove,
        onMouseDown: onMouseDown,
        onClick: onClick,
        onFocus: onFocus,
        onBlur: onBlur
    };
    // Don't set `data-testid` unless it's defined, as it's not in the interface.
    if (testId) // @ts-expect-error - Adding `data-testid` to the TriggerProps interface breaks Buttons.
    tooltipTriggerProps['data-testid'] = "".concat(testId, "--container");
    // This useEffect is purely for managing the aria attribute when using the
    // wrapped children approach.
    var isChildrenAFunction = typeof children === 'function';
    (0, $5FkrB.useEffect)(function() {
        if (isChildrenAFunction) return;
        // If `children` is _not_ a function, we are stepping outside of the public
        // API to add a `aria-describedby` attribute.
        var target = targetRef.current;
        if (!target || !tooltipIdForHiddenContent) return;
        target.setAttribute('aria-describedby', tooltipIdForHiddenContent);
        return function() {
            return target.removeAttribute('aria-describedby');
        };
    }, [
        isChildrenAFunction,
        tooltipIdForHiddenContent
    ]);
    var hiddenContent = shouldRenderHiddenContent ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("span", {
        "data-testid": testId ? "".concat(testId, "-hidden") : undefined,
        hidden: true,
        id: tooltipIdForHiddenContent
    }, typeof content === 'function' ? content({}) : content) : null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).Fragment, null, typeof children === 'function' ? /*#__PURE__*/ // once we deprecate the wrapped approach, we can put the aria
    // attribute back into the tooltipTriggerProps and make it required
    // instead of optional in `types`
    (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).Fragment, null, children($1054ef677ee15d9a$var$_objectSpread($1054ef677ee15d9a$var$_objectSpread({}, tooltipTriggerProps), {}, {
        'aria-describedby': tooltipIdForHiddenContent,
        ref: setDirectRef
    })), hiddenContent) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(CastTargetContainer, (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, tooltipTriggerProps, {
        ref: setImplicitRefFromChildren,
        role: "presentation"
    }), children, hiddenContent), shouldRenderTooltipPopup ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $9tRs0.default), {
        zIndex: $1054ef677ee15d9a$var$tooltipZIndex
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $dGqY2.Popper), {
        placement: tooltipPosition,
        referenceElement: getReferenceElement(),
        strategy: strategy
    }, function(_ref5) {
        var ref = _ref5.ref, style = _ref5.style, update = _ref5.update, placement = _ref5.placement;
        // Invert the entrance and exit directions.
        // E.g. a tooltip's position is on the 'right', it should enter from and exit to the 'left'
        // This gives the effect the tooltip is appearing from the target
        var direction = position === 'mouse' ? undefined : $1054ef677ee15d9a$var$invertedDirection[$1054ef677ee15d9a$var$getDirectionFromPlacement(placement)];
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $8mpiS.default), {
            appear: true
        }, shouldRenderTooltipChildren && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $6b2cA.default), {
            distance: "constant",
            entranceDirection: direction,
            exitDirection: direction,
            onFinish: onAnimationFinished,
            duration: state !== 'show-immediate' ? 'medium' : 'none'
        }, function(_ref6) {
            var className = _ref6.className;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(Container, {
                ref: ref,
                className: "Tooltip ".concat(className),
                style: $1054ef677ee15d9a$var$_objectSpread($1054ef677ee15d9a$var$_objectSpread({}, style), ignoreTooltipPointerEvents && {
                    pointerEvents: 'none'
                }),
                truncate: truncate,
                placement: tooltipPosition,
                testId: getReferenceElement() ? testId : testId && "".concat(testId, "--unresolved"),
                onMouseOut: onMouseOut,
                onMouseOver: onMouseOverTooltip
            }, typeof content === 'function' ? content({
                update: update
            }) : content);
        }));
    })) : null);
}
$1054ef677ee15d9a$var$Tooltip.displayName = 'Tooltip';
var $1054ef677ee15d9a$export$2e2bcd8739ae039 = $1054ef677ee15d9a$var$Tooltip;

});
parcelRegister("l3edN", function(module, exports) {
$parcel$export(module.exports, "usePlatformLeafSyntheticEventHandler", () => $f534e8dbc52fc7bb$export$1a04351537078b55);

var $25nEq = parcelRequire("25nEq");

var $5FkrB = parcelRequire("5FkrB");

var $hQ6Uq = parcelRequire("hQ6Uq");

var $aFyjd = parcelRequire("aFyjd");
function $f534e8dbc52fc7bb$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $f534e8dbc52fc7bb$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $f534e8dbc52fc7bb$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $f534e8dbc52fc7bb$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $f534e8dbc52fc7bb$export$1a04351537078b55(_ref) {
    var fn = _ref.fn, action = _ref.action, componentName = _ref.componentName, packageName = _ref.packageName, packageVersion = _ref.packageVersion, analyticsData = _ref.analyticsData;
    var _useAnalyticsEvents = (0, $hQ6Uq.useAnalyticsEvents)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
    // We put analyticsData and fn in a ref so that we don't need to break
    // memoization.
    // Generally these could be defined by consumers inline
    // and so we do this to avoid breaking memoization of useCallback
    var dataRef = (0, $aFyjd.useTrackedRef)(analyticsData);
    var fnRef = (0, $aFyjd.useTrackedRef)(fn);
    var handler = (0, $5FkrB.useCallback)(function() {
        var analyticsEvent = createAnalyticsEvent({
            action: action,
            actionSubject: componentName,
            attributes: {
                componentName: componentName,
                packageName: packageName,
                packageVersion: packageVersion
            }
        });
        // To avoid wrapping this component in AnalyticsContext we manually
        // push the parent context's meta data into the context.
        // Note: this new 'context'
        var context = $f534e8dbc52fc7bb$var$_objectSpread({
            componentName: componentName,
            packageName: packageName,
            packageVersion: packageVersion
        }, dataRef.current);
        analyticsEvent.context.push(context);
        // fire an event on the atlaskit channel
        var clone = analyticsEvent.clone();
        if (clone) clone.fire('atlaskit');
        fnRef.current(analyticsEvent);
    }, [
        // These are strings and won't change
        action,
        componentName,
        packageName,
        packageVersion,
        // This function is memoized in the context
        createAnalyticsEvent,
        // these are a stable ref because of the useTrackedRef hook
        dataRef,
        fnRef
    ]);
    return handler;
}

});

parcelRegister("35QIf", function(module, exports) {
$parcel$export(module.exports, "default", () => $240aba59e88a9193$export$2e2bcd8739ae039);
/**
 * An empty function which does nothing.
 */ // eslint-disable-next-line @repo/internal/react/use-noop
function $240aba59e88a9193$export$2e2bcd8739ae039() {}

});

parcelRegister("h5mrR", function(module, exports) {
$parcel$export(module.exports, "default", () => $c704511645c66547$export$2e2bcd8739ae039);

var $5FkrB = parcelRequire("5FkrB");

var $7QpUe = parcelRequire("7QpUe");

var $g8ZSm = parcelRequire("g8ZSm");
function $c704511645c66547$export$2e2bcd8739ae039(_ref) {
    var onClose = _ref.onClose, isDisabled = _ref.isDisabled;
    var escapePressed = (0, $5FkrB.useRef)(false);
    var onKeyDown = (0, $5FkrB.useCallback)(function(e) {
        if (isDisabled || escapePressed.current || e.key !== (0, $g8ZSm.ESCAPE)) // We're either already handling the key down event or it's not escape.
        // Bail early!
        return;
        escapePressed.current = true;
        onClose(e);
    }, [
        onClose,
        isDisabled
    ]);
    var onKeyUp = (0, $5FkrB.useCallback)(function() {
        escapePressed.current = false;
    }, []);
    (0, $5FkrB.useEffect)(function() {
        return (0, $7QpUe.bindAll)(document, [
            {
                type: 'keydown',
                listener: onKeyDown
            },
            {
                type: 'keyup',
                listener: onKeyUp
            }
        ], {
            capture: false
        });
    }, [
        onKeyDown,
        onKeyUp
    ]);
}

});
parcelRegister("g8ZSm", function(module, exports) {
$parcel$export(module.exports, "ESCAPE", () => $bc0d63f3467e10e4$export$2bb790b9008907b4);
/**
 * Character key codes which can be used in keyboard events.
 */ var $bc0d63f3467e10e4$export$390330c10ff2b9a1 = 'ArrowUp';
var $bc0d63f3467e10e4$export$a80636c6f41931fe = 'ArrowDown';
var $bc0d63f3467e10e4$export$4af703091671bc = 'Home';
var $bc0d63f3467e10e4$export$e2bc30913faa5db7 = 'End';
var $bc0d63f3467e10e4$export$10f6869ed0a7d75b = 'Tab';
var $bc0d63f3467e10e4$export$8152f929a25a0ff4 = 'Enter';
var $bc0d63f3467e10e4$export$e51a3576c045c8d5 = 'Space';
var $bc0d63f3467e10e4$export$2bb790b9008907b4 = 'Escape';

});


parcelRegister("1AQ59", function(module, exports) {
$parcel$export(module.exports, "default", () => $12918da117d80e5a$export$2e2bcd8739ae039);

var $5FkrB = parcelRequire("5FkrB");
function $12918da117d80e5a$export$2e2bcd8739ae039(value) {
    var ref = (0, $5FkrB.useRef)(value);
    (0, $5FkrB.useEffect)(function() {
        ref.current = value;
    }, [
        value
    ]);
    return ref;
}

});

parcelRegister("ky91o", function(module, exports) {
$parcel$export(module.exports, "useNotifyOpenLayerObserver", () => $ef5dfb15b62858cd$export$469bb693f11edc7f);

var $5FkrB = parcelRequire("5FkrB");

var $lz6Tj = parcelRequire("lz6Tj");
function $ef5dfb15b62858cd$export$469bb693f11edc7f() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, _ref$isOpen = _ref.isOpen, isOpen = _ref$isOpen === void 0 ? true : _ref$isOpen;
    var context = (0, $5FkrB.useContext)((0, $lz6Tj.OpenLayerObserverContext));
    (0, $5FkrB.useEffect)(function() {
        if (context === null) return;
        if (!isOpen) return;
        context.increment();
        return function() {
            context.decrement();
        };
    }, [
        context,
        isOpen
    ]);
}

});
parcelRegister("lz6Tj", function(module, exports) {
$parcel$export(module.exports, "OpenLayerObserverContext", () => $fb323646d507eb7f$export$5fbf4d7fae6cdc00);

var $5FkrB = parcelRequire("5FkrB");
var $fb323646d507eb7f$export$5fbf4d7fae6cdc00 = /*#__PURE__*/ (0, $5FkrB.createContext)(null);

});


parcelRegister("8mpiS", function(module, exports) {
$parcel$export(module.exports, "useExitingPersistence", () => $616401909694f17d$export$3b6f38abbdcbd000);
$parcel$export(module.exports, "default", () => $616401909694f17d$export$2e2bcd8739ae039);

var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");

var $6Nr26 = parcelRequire("6Nr26");
/**
 * Internally we will be playing with an element that will always have a key defined.
 */ /**
 * Internal data passed to child motions.
 */ // We define empty context here so the object doesn't change.
var $616401909694f17d$var$emptyContext = {
    // Motions will always appear if not inside a exiting persistence component.
    appear: true,
    isExiting: false
};
/**
 * __Exiting context__
 *
 * An exiting context.
 */ var $616401909694f17d$var$ExitingContext = /*#__PURE__*/ (0, $5FkrB.createContext)($616401909694f17d$var$emptyContext);
/**
 * This method will wrap any React element with a context provider. We're using context (instead of
 * cloneElement) so we can communicate between multiple elements without the need of prop drilling
 * (results in a better API for consumers).
 */ var $616401909694f17d$var$wrapChildWithContextProvider = function wrapChildWithContextProvider(child) {
    var value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $616401909694f17d$var$emptyContext;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement($616401909694f17d$var$ExitingContext.Provider, {
        key: "".concat(child.key, "-provider"),
        value: value
    }, child);
};
/**
 * This function will convert all children types to an array while also filtering out non-valid React elements.
 */ var $616401909694f17d$var$childrenToArray = function childrenToArray(children) {
    var childrenAsArray = [];
    // We convert children to an array using this helper method as it will add keys to children that do not
    // have them, such as when we have hardcoded children that are conditionally rendered.
    (0, $5FkrB.Children).toArray(children).forEach(function(child) {
        // We ignore any boolean children to make our code a little more simple later on,
        // and also filter out any falsies (empty strings, nulls, and undefined).
        if (typeof child !== 'boolean' && Boolean(child)) // Children WILL have a key after being forced into an array using the React.Children helper.
        childrenAsArray.push(child);
    });
    return childrenAsArray;
};
var $616401909694f17d$var$spliceNewElementsIntoPrevious = function spliceNewElementsIntoPrevious(current, previous) {
    var splicedChildren = previous.concat([]);
    var previousMap = $616401909694f17d$var$childrenToObj(previous);
    for(var i = 0; i < current.length; i++){
        var child = current[i];
        var childIsNew = !previousMap[child.key];
        if (childIsNew) // This will insert the new element after the previous element.
        splicedChildren.splice(i + 1, 0, child);
    }
    return splicedChildren;
};
var $616401909694f17d$var$childrenToObj = function childrenToObj(children) {
    return children.reduce(function(acc, child) {
        acc[child.key] = child;
        return acc;
    }, {});
};
var $616401909694f17d$var$getMissingKeys = function getMissingKeys(current, previous) {
    var currentMapKeys = new Set(current.map(function(child) {
        return child.key;
    }));
    var missing = new Set();
    for(var i = 0; i < previous.length; i++){
        var element = previous[i];
        var _key = element.key;
        if (!currentMapKeys.has(_key)) missing.add(_key);
    }
    return missing;
};
/**
 * __ExitingPersistence__
 *
 * Useful for enabling elements to persist and animate away when they are removed from the DOM.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/motion/docs/entering-motions)
 */ var $616401909694f17d$var$ExitingPersistence = /*#__PURE__*/ (0, $5FkrB.memo)(function(_ref) {
    var _ref$appear = _ref.appear, appear = _ref$appear === void 0 ? false : _ref$appear, children = _ref.children, exitThenEnter = _ref.exitThenEnter;
    var _useState = (0, $5FkrB.useState)([
        null,
        children
    ]), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), stateChildren = _useState2[0], setChildren = _useState2[1];
    var _useState3 = (0, $5FkrB.useState)([]), _useState4 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState3, 2), exitingChildren = _useState4[0], setExitingChildren = _useState4[1];
    var _useState5 = (0, $5FkrB.useState)(function() {
        return {
            appear: appear,
            isExiting: false
        };
    }), _useState6 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState5, 2), defaultContext = _useState6[0], setDefaultContext = _useState6[1];
    (0, $5FkrB.useEffect)(function() {
        if (!defaultContext.appear) setDefaultContext({
            appear: true,
            isExiting: false
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    if ((0, $6Nr26.isReducedMotion)()) return children;
    /**
   * NOTE: This is a workaround for the test case written in Jira where the stateChildren is a boolean value because
   * useState is mocked to return a boolean value.
   */ if (typeof stateChildren === 'boolean') return children;
    var _stateChildren = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(stateChildren, 2), previousChildren = _stateChildren[0], currentChildren = _stateChildren[1];
    var previous = $616401909694f17d$var$childrenToArray(previousChildren);
    var current = $616401909694f17d$var$childrenToArray(currentChildren);
    if (currentChildren !== children) setChildren([
        currentChildren,
        children
    ]);
    var missingKeys = $616401909694f17d$var$getMissingKeys(current, previous);
    var isSomeChildRemoved = !!missingKeys.size;
    var visibleChildren = current;
    if (isSomeChildRemoved) visibleChildren = $616401909694f17d$var$spliceNewElementsIntoPrevious(current, previous);
    if (exitThenEnter) {
        if (exitingChildren.length) visibleChildren = exitingChildren;
        else {
            var nextExitingChildren = visibleChildren.filter(function(child) {
                return missingKeys.has(child.key);
            });
            if (nextExitingChildren.length) setExitingChildren(nextExitingChildren);
        }
    }
    if (missingKeys.size) visibleChildren = visibleChildren.map(function(child) {
        var isExiting = missingKeys.has(child.key);
        return $616401909694f17d$var$wrapChildWithContextProvider(child, {
            appear: true,
            isExiting: isExiting,
            onFinish: isExiting ? function() {
                missingKeys.delete(child.key);
                if (missingKeys.size === 0) {
                    setChildren([
                        null,
                        children
                    ]);
                    setExitingChildren([]);
                }
            } : undefined
        });
    });
    else visibleChildren = visibleChildren.map(function(child) {
        return $616401909694f17d$var$wrapChildWithContextProvider(child, defaultContext);
    });
    return visibleChildren;
});
var $616401909694f17d$export$3b6f38abbdcbd000 = function useExitingPersistence() {
    return (0, $5FkrB.useContext)($616401909694f17d$var$ExitingContext);
};
$616401909694f17d$var$ExitingPersistence.displayName = 'ExitingPersistence';
var $616401909694f17d$export$2e2bcd8739ae039 = $616401909694f17d$var$ExitingPersistence;

});
parcelRegister("6Nr26", function(module, exports) {
$parcel$export(module.exports, "isReducedMotion", () => $4f2c49d95740b230$export$b7baf7667a68d87c);
$parcel$export(module.exports, "reduceMotionAsPerUserPreference", () => $4f2c49d95740b230$export$f0f789643ba5a83c);

var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");

var $7QpUe = parcelRequire("7QpUe");
var $4f2c49d95740b230$var$isMatchMediaAvailable = function isMatchMediaAvailable() {
    return typeof window !== 'undefined' && 'matchMedia' in window;
};
var $4f2c49d95740b230$export$b7baf7667a68d87c = function isReducedMotion() {
    if (!$4f2c49d95740b230$var$isMatchMediaAvailable()) return false;
    var _window$matchMedia = window.matchMedia('(prefers-reduced-motion: reduce)'), matches = _window$matchMedia.matches;
    return matches;
};
var $4f2c49d95740b230$export$c537e63161742ce3 = function useIsReducedMotion() {
    var _useState = (0, $5FkrB.useState)($4f2c49d95740b230$export$b7baf7667a68d87c), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), prefersReducedMotion = _useState2[0], setPrefersReducedMotion = _useState2[1];
    (0, $5FkrB.useEffect)(function() {
        if (!$4f2c49d95740b230$var$isMatchMediaAvailable()) return;
        var mediaQueryList = window.matchMedia('(prefers-reduced-motion: reduce)');
        var onChange = function onChange(event) {
            return setPrefersReducedMotion(event.matches);
        };
        return (0, $7QpUe.bind)(mediaQueryList, {
            type: 'change',
            listener: onChange
        });
    }, []);
    return prefersReducedMotion;
};
var $4f2c49d95740b230$export$f0f789643ba5a83c = {
    '@media (prefers-reduced-motion: reduce)': {
        animation: 'none',
        transition: 'none'
    }
};
var $4f2c49d95740b230$export$ff7706047246b98b = function prefersReducedMotion() {
    return $4f2c49d95740b230$export$f0f789643ba5a83c;
};

});


parcelRegister("6b2cA", function(module, exports) {
$parcel$export(module.exports, "default", () => $47f57a688da58420$export$2e2bcd8739ae039);

var $25nEq = parcelRequire("25nEq");

var $5FkrB = parcelRequire("5FkrB");

var $9qQZg = parcelRequire("9qQZg");
function $47f57a688da58420$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $47f57a688da58420$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $47f57a688da58420$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $47f57a688da58420$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $47f57a688da58420$var$directionMotions = {
    proportional: {
        bottom: 'translate3d(0, calc(5% + 4px), 0)',
        left: 'translate3d(calc(-5% - 4px), 0, 0)',
        right: 'translate3d(calc(5% + 4px), 0, 0)',
        top: 'translate3d(0, calc(-5% - 4px), 0)'
    },
    constant: {
        bottom: 'translate3d(0, 4px, 0)',
        left: 'translate3d(-4px, 0, 0)',
        right: 'translate3d(4px, 0, 0)',
        top: 'translate3d(0, -4px, 0)'
    }
};
var $47f57a688da58420$var$invertedDirection = {
    top: 'bottom',
    bottom: 'top',
    left: 'right',
    right: 'left'
};
var $47f57a688da58420$export$8497679fcaaeceb = function fadeInAnimation(direction) {
    var distance = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'proportional';
    return {
        from: $47f57a688da58420$var$_objectSpread({
            opacity: 0
        }, direction !== undefined && {
            transform: $47f57a688da58420$var$directionMotions[distance][direction]
        }),
        '50%': {
            opacity: 1
        },
        to: {
            transform: direction !== undefined ? 'none' : undefined
        }
    };
};
var $47f57a688da58420$export$c9190c6659ea755b = function fadeOutAnimation(direction) {
    var distance = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'proportional';
    return {
        from: {
            opacity: 1,
            transform: direction !== undefined ? 'translate3d(0, 0, 0)' : undefined
        },
        to: $47f57a688da58420$var$_objectSpread({
            opacity: 0
        }, direction !== undefined && {
            transform: $47f57a688da58420$var$directionMotions[distance][direction]
        })
    };
};
/**
 * Props for controlling the behavior of the FadeIn animation
 */ /**
 * __FadeIn__
 *
 * Useful for fading in one or more elements.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/motion/docs/entering-motions)
 */ var $47f57a688da58420$var$FadeIn = function FadeIn(_ref) {
    var children = _ref.children, _ref$duration = _ref.duration, duration = _ref$duration === void 0 ? 'large' : _ref$duration, entranceDirection = _ref.entranceDirection, exitDirection = _ref.exitDirection, _ref$distance = _ref.distance, distance = _ref$distance === void 0 ? 'proportional' : _ref$distance, onFinish = _ref.onFinish, isPaused = _ref.isPaused;
    var invertedEntranceDirection = entranceDirection && $47f57a688da58420$var$invertedDirection[entranceDirection];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $9qQZg.default), {
        duration: duration,
        enteringAnimation: $47f57a688da58420$export$8497679fcaaeceb(entranceDirection, distance),
        exitingAnimation: $47f57a688da58420$export$c9190c6659ea755b(exitDirection || invertedEntranceDirection, distance),
        animationTimingFunction: "ease-in-out",
        onFinish: onFinish,
        isPaused: isPaused
    }, children);
};
var $47f57a688da58420$export$2e2bcd8739ae039 = $47f57a688da58420$var$FadeIn;

});
parcelRegister("9qQZg", function(module, exports) {
$parcel$export(module.exports, "default", () => $6ddfa4e3575a375f$export$2e2bcd8739ae039);

var $25nEq = parcelRequire("25nEq");

var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");

var $74Zh5 = parcelRequire("74Zh5");

var $6Nr26 = parcelRequire("6Nr26");

var $84ukS = parcelRequire("84ukS");

var $lFUuG = parcelRequire("lFUuG");

var $8mpiS = parcelRequire("8mpiS");

var $iEgoa = parcelRequire("iEgoa");
function $6ddfa4e3575a375f$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $6ddfa4e3575a375f$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $6ddfa4e3575a375f$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $6ddfa4e3575a375f$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
/**
 * These are props that motions should use as their external props for consumers.
 * See [FadeIn](packages/helpers/motion/src/entering/fade-in.tsx) for an example usage.
 */ /**
 * This is the base INTERNAL component used for all other entering motions.
 * This does not need Javascript to execute on the client so it will run immediately
 * for any SSR rendered React apps before the JS has executed.
 */ var $6ddfa4e3575a375f$var$EnteringMotion = function EnteringMotion(_ref) {
    var children = _ref.children, animationTimingFunction = _ref.animationTimingFunction, _ref$animationTimingF = _ref.animationTimingFunctionExiting, animationTimingFunctionExiting = _ref$animationTimingF === void 0 ? animationTimingFunction : _ref$animationTimingF, enteringAnimation = _ref.enteringAnimation, _ref$exitingAnimation = _ref.exitingAnimation, exitingAnimation = _ref$exitingAnimation === void 0 ? enteringAnimation : _ref$exitingAnimation, isPaused = _ref.isPaused, onFinishMotion = _ref.onFinish, _ref$duration = _ref.duration, duration = _ref$duration === void 0 ? 'large' : _ref$duration;
    var staggered = (0, $iEgoa.useStaggeredEntrance)();
    var _useExitingPersistenc = (0, $8mpiS.useExitingPersistence)(), isExiting = _useExitingPersistenc.isExiting, onExitFinished = _useExitingPersistenc.onFinish, appear = _useExitingPersistenc.appear;
    var setTimeout = (0, $lFUuG.useSetTimeout)();
    var paused = isPaused || !staggered.isReady;
    var delay = isExiting ? 0 : staggered.delay;
    var state = isExiting ? 'exiting' : 'entering';
    var _useState = (0, $5FkrB.useState)(appear), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), hasAnimationStyles = _useState2[0], setHasAnimationStyles = _useState2[1];
    (0, $5FkrB.useEffect)(function() {
        // Tracking this to prevent changing state on an unmounted component
        var isCancelled = false;
        if (paused) return;
        // On initial mount if elements aren't set to animate on appear, we return early and callback
        if (!appear) {
            onFinishMotion && onFinishMotion(state);
            return;
        }
        // Elements may need animation styles back after initial mount (they could animate out)
        setHasAnimationStyles(true);
        setTimeout(function() {
            if (state === 'exiting') onExitFinished && onExitFinished();
            if (!isCancelled) setHasAnimationStyles(false);
            onFinishMotion && onFinishMotion(state);
        }, isExiting ? (0, $84ukS.exitingDurations)[duration] : (0, $84ukS.durations)[duration] + delay);
        return function() {
            isCancelled = true;
        };
    // We ignore this for onFinishMotion as consumers could potentially inline the function
    // which would then trigger this effect every re-render.
    // We want to make it easier for consumers so we go down this path unfortunately.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        onExitFinished,
        state,
        isExiting,
        duration,
        delay,
        paused,
        setTimeout
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $74Zh5.ClassNames), null, function(_ref2) {
        var css = _ref2.css, cx = _ref2.cx;
        return children({
            ref: staggered.ref,
            className: hasAnimationStyles ? cx(css($6ddfa4e3575a375f$var$_objectSpread($6ddfa4e3575a375f$var$_objectSpread({}, (0, $6Nr26.reduceMotionAsPerUserPreference)), {}, {
                animationDelay: "".concat(delay, "ms"),
                animationFillMode: 'backwards',
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
                animationName: (0, $74Zh5.keyframes)(enteringAnimation),
                animationPlayState: 'running'
            })), paused && css({
                animationPlayState: 'paused'
            }), duration === 'small' && css({
                animationDuration: '100ms'
            }), duration === 'medium' && css({
                animationDuration: '350ms'
            }), duration === 'large' && css({
                animationDuration: '700ms'
            }), isExiting && duration === 'small' && css({
                animationDuration: '50ms'
            }), isExiting && duration === 'medium' && css({
                animationDuration: '175ms'
            }), isExiting && duration === 'large' && css({
                animationDuration: '350ms'
            }), isExiting && css({
                animationDelay: '0ms',
                animationFillMode: 'forwards',
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
                animationName: (0, $74Zh5.keyframes)(exitingAnimation)
            }), !isExiting && animationTimingFunction === 'linear' && css({
                animationTimingFunction: 'cubic-bezier(0,0,1,1)'
            }), !isExiting && animationTimingFunction === 'ease-out' && css({
                animationTimingFunction: 'cubic-bezier(0.2,0,0,1)'
            }), !isExiting && animationTimingFunction === 'ease-in' && css({
                animationTimingFunction: 'cubic-bezier(0.8,0,0,0.8)'
            }), !isExiting && animationTimingFunction === 'ease-in-out' && css({
                animationTimingFunction: 'cubic-bezier(0.15,1,0.3,1)'
            }), isExiting && animationTimingFunction === 'linear' && css({
                animationTimingFunction: 'cubic-bezier(0,0,1,1)'
            }), isExiting && animationTimingFunctionExiting === 'ease-out' && css({
                animationTimingFunction: 'cubic-bezier(0.2,0,0,1)'
            }), isExiting && animationTimingFunctionExiting === 'ease-in' && css({
                animationTimingFunction: 'cubic-bezier(0.8,0,0,0.8)'
            }), isExiting && animationTimingFunctionExiting === 'ease-in-out' && css({
                animationTimingFunction: 'cubic-bezier(0.15,1,0.3,1)'
            })) : ''
        }, state);
    });
};
var $6ddfa4e3575a375f$export$2e2bcd8739ae039 = $6ddfa4e3575a375f$var$EnteringMotion;

});
parcelRegister("84ukS", function(module, exports) {
$parcel$export(module.exports, "durations", () => $5e063a8358c0ee84$export$38b928a7167ce124);
$parcel$export(module.exports, "exitingDurations", () => $5e063a8358c0ee84$export$30fa1a2e62ae150c);
/**
 * Think of this as the motion equivalent of the @atlaskit/theme `grid()`.
 */ var $5e063a8358c0ee84$export$368bacef0dacbe05 = 25;
var $5e063a8358c0ee84$export$38b928a7167ce124 = {
    none: 0,
    small: 100,
    medium: 350,
    large: 700
};
/**
 * Used to multiply the initial duration for exiting motions.
 */ var $5e063a8358c0ee84$var$EXITING_MOTION_MULTIPLIER = 0.5;
var $5e063a8358c0ee84$export$30fa1a2e62ae150c = {
    none: $5e063a8358c0ee84$export$38b928a7167ce124.none,
    small: $5e063a8358c0ee84$export$38b928a7167ce124.small * $5e063a8358c0ee84$var$EXITING_MOTION_MULTIPLIER,
    medium: $5e063a8358c0ee84$export$38b928a7167ce124.medium * $5e063a8358c0ee84$var$EXITING_MOTION_MULTIPLIER,
    large: $5e063a8358c0ee84$export$38b928a7167ce124.large * $5e063a8358c0ee84$var$EXITING_MOTION_MULTIPLIER
};

});

parcelRegister("lFUuG", function(module, exports) {
$parcel$export(module.exports, "useSetTimeout", () => $fc793fcb48f10308$export$4f34107a2b00f39c);

var $5FkrB = parcelRequire("5FkrB");
var $fc793fcb48f10308$var$getHookDeps = function getHookDeps(opts) {
    switch(opts.cleanup){
        case 'next-effect':
            return undefined;
        case 'unmount':
        default:
            return [];
    }
};
var $fc793fcb48f10308$export$1775f27e7c8051ca = function useRequestAnimationFrame() {
    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        cleanup: 'unmount'
    };
    var frames = (0, $5FkrB.useRef)([]);
    (0, $5FkrB.useEffect)(function() {
        return function() {
            if (frames.current.length) {
                frames.current.forEach(function(id) {
                    return cancelAnimationFrame(id);
                });
                frames.current = [];
            }
        };
    // We dynamically set this so we either clean up on the next effect - or on unmount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, $fc793fcb48f10308$var$getHookDeps(opts));
    return (0, $5FkrB.useCallback)(function(handler) {
        var id = requestAnimationFrame(function(time) {
            frames.current = frames.current.filter(function(frameId) {
                return frameId !== id;
            });
            handler(time);
        });
        frames.current.push(id);
    }, []);
};
var $fc793fcb48f10308$export$4f34107a2b00f39c = function useSetTimeout() {
    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        cleanup: 'unmount'
    };
    var timeouts = (0, $5FkrB.useRef)([]);
    (0, $5FkrB.useEffect)(function() {
        return function() {
            if (timeouts.current.length) {
                timeouts.current.forEach(function(id) {
                    return clearTimeout(id);
                });
                timeouts.current = [];
            }
        };
    // We dynamically set this so we either clean up on the next effect - or on unmount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, $fc793fcb48f10308$var$getHookDeps(opts));
    return (0, $5FkrB.useCallback)(function(handler, timeout) {
        for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)args[_key - 2] = arguments[_key];
        var id = setTimeout.apply(void 0, [
            function() {
                timeouts.current = timeouts.current.filter(function(timeoutId) {
                    return timeoutId !== id;
                });
                handler();
            },
            timeout
        ].concat(args));
        timeouts.current.push(id);
    }, []);
};

});

parcelRegister("iEgoa", function(module, exports) {
$parcel$export(module.exports, "useStaggeredEntrance", () => $d938ace8734493b4$export$25c7213fc07ec080);

var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");

var $35QIf = parcelRequire("35QIf");

var $9lKHn = parcelRequire("9lKHn");

var $d64hN = parcelRequire("d64hN");
var $d938ace8734493b4$var$StaggeredEntranceContext = /*#__PURE__*/ (0, $5FkrB.createContext)(function() {
    return {
        isReady: true,
        delay: 0,
        ref: (0, $35QIf.default)
    };
});
var $d938ace8734493b4$export$25c7213fc07ec080 = function useStaggeredEntrance() {
    var indentifier = (0, $d64hN.useUniqueId)();
    var context = (0, $5FkrB.useContext)($d938ace8734493b4$var$StaggeredEntranceContext);
    return context(indentifier);
};
/**
 * For a list of elements that need to animate in,
 * this should be used in conjunction with entering components.
 * This does not need Javascript to execute so it will run immediately for any SSR rendered React apps before the JS has executed.
 *
 * Will dynamically add delay to each child entering component.
 * Unfortunately all entering components _NEED_ to be a direct descendant.
 */ var $d938ace8734493b4$var$StaggeredEntrance = function StaggeredEntrance(_ref) {
    var children = _ref.children, column = _ref.column, _ref$columns = _ref.columns, columns = _ref$columns === void 0 ? 'responsive' : _ref$columns, _ref$delayStep = _ref.delayStep, delayStep = _ref$delayStep === void 0 ? 50 : _ref$delayStep;
    var elementRefs = (0, $5FkrB.useRef)([]);
    var indexes = [];
    var _useState = (0, $5FkrB.useState)(function() {
        if (typeof columns === 'number') // A hardcoded columns is set so bail out and set it to that!
        return columns;
        if (typeof column === 'number') // A hardcoded column is set so we will set actualColumns to be 1.
        return 1;
        // We are in "responsive" mode.
        // So we will be calculating when the Javascript executes on the client how many columns there will be.
        return 0;
    }), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), actualColumns = _useState2[0], setActualColumns = _useState2[1];
    (0, $9lKHn.useLayoutEffect)(function() {
        // We want to only run this code when we are in "responsive" mode.
        // It is assumed we are in responsive mode if `columns` is "responsive",
        // we have children element refs ready to be read (i.e. if there are no children this won't run as well)
        // and finally that `actualColumns` is `0` - this is because for the first render cycle `actualColumns` will be `0` (set above)
        // and then after this layout effect runs the value for `actualColumns` will then be calculated and set.
        if (columns === 'responsive' && elementRefs.current.length && actualColumns === 0) {
            var currentTop = 0;
            var numberColumns = 0;
            if (elementRefs.current.length <= 1) {
                setActualColumns(1);
                return;
            }
            // We set the current top to the first elements.
            // We will be comparing this and incrementing the column count
            // until we hit an element that has a different offset top (or we run out of elements).
            currentTop = elementRefs.current[0] ? elementRefs.current[0].offsetTop : 0;
            for(var i = 0; i < elementRefs.current.length; i++){
                var child = elementRefs.current[i];
                if (!child) break;
                if (currentTop === child.offsetTop) {
                    numberColumns += 1;
                    if (elementRefs.current.length - 1 === i) setActualColumns(numberColumns);
                    continue;
                }
                setActualColumns(numberColumns);
                break;
            }
        }
    // We only want this effect to run once - on initial mount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement($d938ace8734493b4$var$StaggeredEntranceContext.Provider, {
        value: function value(id) {
            if (!indexes.includes(id)) indexes.push(id);
            var isReady = actualColumns > 0;
            var index = indexes.indexOf(id);
            var currentColumn = column || index % actualColumns;
            var currentRow = Math.floor(index / actualColumns);
            var distanceFromTopLeftElement = currentRow + currentColumn;
            // We don't want loads of elements to have the same staggered delay as it ends up looking slow for users.
            // To get around that we calculate the logarithm using `distanceFromTopLeftElement` which ends making
            // elements appear faster the further away from the top left element.
            var delay = Math.ceil(Math.log(distanceFromTopLeftElement + 1) * delayStep * 1.5) || 0;
            return {
                delay: delay,
                isReady: isReady,
                ref: function ref(element) {
                    return elementRefs.current[index] = element;
                }
            };
        }
    }, children);
};
var $d938ace8734493b4$export$2e2bcd8739ae039 = $d938ace8734493b4$var$StaggeredEntrance;

});
parcelRegister("9lKHn", function(module, exports) {
$parcel$export(module.exports, "useLayoutEffect", () => $6cea4c9af6e5d926$export$e5c5a5f917a5871c);

var $5FkrB = parcelRequire("5FkrB");
var $6cea4c9af6e5d926$export$e5c5a5f917a5871c = typeof window === 'undefined' ? (0, $5FkrB.useEffect) : (0, $5FkrB.useLayoutEffect);

});

parcelRegister("d64hN", function(module, exports) {
$parcel$export(module.exports, "useUniqueId", () => $988f2907c4571c63$export$c485849f2e393253);
/* eslint-disable @repo/internal/react/disallow-unstable-values */ 
var $5FkrB = parcelRequire("5FkrB");
function $988f2907c4571c63$export$c485849f2e393253() {
    var identifier = (0, $5FkrB.useRef)('');
    if (!identifier.current) identifier.current = '_' + (Number(String(Math.random()).slice(2)) + Date.now() + Math.round(performance.now())).toString(36);
    return identifier.current;
}

});




parcelRegister("dGqY2", function(module, exports) {
$parcel$export(module.exports, "Popper", () => $9f641dc865988a85$export$badac9ada3a0bdf9);

var $fC8ib = parcelRequire("fC8ib");

var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");

var $lsgol = parcelRequire("lsgol");

var $bvcx5 = parcelRequire("bvcx5");

// Export types from PopperJS / React Popper
var $9f641dc865988a85$var$viewportPadding = 5;
var $9f641dc865988a85$var$constantModifiers = [
    {
        name: 'flip',
        options: {
            flipVariations: false,
            padding: $9f641dc865988a85$var$viewportPadding,
            boundary: 'clippingParents',
            rootBoundary: 'viewport'
        }
    }
];
function $9f641dc865988a85$var$defaultChildrenFn() {
    return null;
}
var $9f641dc865988a85$var$defaultOffset = [
    0,
    8
];
function $9f641dc865988a85$export$badac9ada3a0bdf9(_ref) {
    var _ref$children = _ref.children, children = _ref$children === void 0 ? $9f641dc865988a85$var$defaultChildrenFn : _ref$children, _ref$offset = _ref.offset, offset = _ref$offset === void 0 ? $9f641dc865988a85$var$defaultOffset : _ref$offset, _ref$placement = _ref.placement, placement = _ref$placement === void 0 ? 'bottom-start' : _ref$placement, _ref$referenceElement = _ref.referenceElement, referenceElement = _ref$referenceElement === void 0 ? undefined : _ref$referenceElement, modifiers = _ref.modifiers, _ref$strategy = _ref.strategy, strategy = _ref$strategy === void 0 ? 'fixed' : _ref$strategy, _ref$shouldFitViewpor = _ref.shouldFitViewport, shouldFitViewport = _ref$shouldFitViewpor === void 0 ? false : _ref$shouldFitViewpor;
    var _offset = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(offset, 2), offsetX = _offset[0], offsetY = _offset[1];
    var internalModifiers = (0, $5FkrB.useMemo)(function() {
        var preventOverflowModifier = {
            name: 'preventOverflow',
            options: {
                padding: $9f641dc865988a85$var$viewportPadding,
                rootBoundary: shouldFitViewport ? 'viewport' : 'document'
            }
        };
        var offsetModifier = {
            name: 'offset',
            options: {
                offset: [
                    offsetX,
                    offsetY
                ]
            }
        };
        var maxSizeModifiers = shouldFitViewport ? (0, $bvcx5.getMaxSizeModifiers)({
            viewportPadding: $9f641dc865988a85$var$viewportPadding
        }) : [];
        // @ts-ignore Type errors from incompatible @popperjs/core versions between Jira and AFM Platform... we are using ts-ignore here because ts-expect-error will cause an "Unused '@ts-expect-error' directive." error
        return [].concat($9f641dc865988a85$var$constantModifiers, [
            preventOverflowModifier,
            offsetModifier
        ], (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(maxSizeModifiers));
    }, [
        offsetX,
        offsetY,
        shouldFitViewport
    ]);
    // Merge custom props and memoize
    var mergedModifiers = (0, $5FkrB.useMemo)(function() {
        if (modifiers == null) return internalModifiers;
        return [].concat((0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(internalModifiers), (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(modifiers));
    }, [
        internalModifiers,
        modifiers
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $lsgol.Popper), {
        modifiers: mergedModifiers,
        placement: placement,
        strategy: strategy,
        referenceElement: referenceElement
    }, children);
}

});
parcelRegister("bvcx5", function(module, exports) {
$parcel$export(module.exports, "getMaxSizeModifiers", () => $85fc4faa7e7c77d5$export$6d8c2b45c99d6e3f);

var $iYJcE = parcelRequire("iYJcE");
function $85fc4faa7e7c77d5$export$6d8c2b45c99d6e3f(_ref) {
    var viewportPadding = _ref.viewportPadding;
    return [
        {
            /**
     * Performing DOM measurements in the 'read' phase,
     * which is the convention for popper modifiers
     */ name: 'maxSizeData',
            enabled: true,
            phase: 'read',
            fn: function fn(_ref2) {
                var state = _ref2.state, name = _ref2.name;
                if (!window.visualViewport) return;
                state.modifiersData[name] = {
                    viewport: {
                        width: window.visualViewport.width,
                        height: window.visualViewport.height
                    }
                };
            }
        },
        {
            /**
     * Applying max size CSS
     */ name: 'maxSize',
            enabled: true,
            phase: 'beforeWrite',
            requiresIfExists: [
                'offset',
                'preventOverflow',
                'flip'
            ],
            fn: function fn(_ref3) {
                var _data$viewport, _data$viewport2, _state$modifiersData$2, _state$modifiersData;
                var state = _ref3.state;
                var data = state.modifiersData.maxSizeData;
                if (typeof (data === null || data === void 0 || (_data$viewport = data.viewport) === null || _data$viewport === void 0 ? void 0 : _data$viewport.width) !== 'number' || typeof (data === null || data === void 0 || (_data$viewport2 = data.viewport) === null || _data$viewport2 === void 0 ? void 0 : _data$viewport2.height) !== 'number') // This shouldn't occur in a real browser but might in non-browser test environments
                return;
                var viewport = data.viewport;
                var _state$modifiersData$ = state.modifiersData.popperOffsets, popperOffsets = _state$modifiersData$ === void 0 ? {
                    x: 0,
                    y: 0
                } : _state$modifiersData$;
                var _state$placement$spli = state.placement.split('-'), _state$placement$spli2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_state$placement$spli, 1), basePlacement = _state$placement$spli2[0];
                var placementOffset = (_state$modifiersData$2 = (_state$modifiersData = state.modifiersData) === null || _state$modifiersData === void 0 || (_state$modifiersData = _state$modifiersData.offset) === null || _state$modifiersData === void 0 ? void 0 : _state$modifiersData[state.placement]) !== null && _state$modifiersData$2 !== void 0 ? _state$modifiersData$2 : {
                    x: 0,
                    y: 0
                };
                // By default we set these to the entire viewport (minus padding)
                // Each placement direction will overwrite one of these
                var maxWidth = viewport.width - 2 * viewportPadding;
                var maxHeight = viewport.height - 2 * viewportPadding;
                if (basePlacement === 'top') maxHeight = state.rects.reference.y + // Viewport-relative position of reference element
                placementOffset.y - // Space between popper and reference
                viewportPadding;
                if (basePlacement === 'bottom') maxHeight = viewport.height - popperOffsets.y - // Viewport-relative position of popper
                viewportPadding;
                if (basePlacement === 'left') maxWidth = state.rects.reference.x + // Viewport-relative position of reference element
                placementOffset.x - // Space between popper and reference
                viewportPadding;
                if (basePlacement === 'right') maxWidth = viewport.width - popperOffsets.x - // Viewport-relative position of popper
                viewportPadding;
                state.styles.popper.maxWidth = "".concat(maxWidth, "px");
                state.styles.popper.maxHeight = "".concat(maxHeight, "px");
            }
        }
    ];
}

});


parcelRegister("9tRs0", function(module, exports) {
$parcel$export(module.exports, "default", () => $6e7048b39b194fc7$export$2e2bcd8739ae039);

var $5FkrB = parcelRequire("5FkrB");

var $id6Cu = parcelRequire("id6Cu");

var $5ZOby = parcelRequire("5ZOby");

var $fHqna = parcelRequire("fHqna");

var $f3GCr = parcelRequire("f3GCr");

var $5hdNS = parcelRequire("5hdNS");
function $6e7048b39b194fc7$export$2e2bcd8739ae039(_ref) {
    var _ref$zIndex = _ref.zIndex, zIndex = _ref$zIndex === void 0 ? 0 : _ref$zIndex, children = _ref.children, _ref$mountStrategy = _ref.mountStrategy, mountStrategy = _ref$mountStrategy === void 0 ? 'effect' : _ref$mountStrategy;
    var isSubsequentRender = (0, $f3GCr.default)(mountStrategy);
    (0, $5hdNS.default)(zIndex);
    // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
    return !(0, $id6Cu.fg)('platform_design_system_team_portal_logic_r18_fix') ? isSubsequentRender ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $5ZOby.default), {
        zIndex: zIndex
    }, children) : null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $fHqna.default), {
        zIndex: zIndex
    }, children);
}

});
parcelRegister("5ZOby", function(module, exports) {
$parcel$export(module.exports, "default", () => $45d994097c0cb25f$export$2e2bcd8739ae039);

var $5FkrB = parcelRequire("5FkrB");

var $aLeHs = parcelRequire("aLeHs");

var $3rpKi = parcelRequire("3rpKi");
function $45d994097c0cb25f$export$2e2bcd8739ae039(props) {
    var zIndex = props.zIndex, children = props.children;
    var container = (0, $5FkrB.useMemo)(function() {
        return (0, $3rpKi.createContainer)(zIndex);
    }, [
        zIndex
    ]);
    // This is in the render method instead of useEffect so that
    // the portal will be added to the DOM before the children render.
    // For any further changes, ensure that the container does not have a
    // parent besides the portal parent.
    (0, $3rpKi.appendPortalContainerIfNotAppended)(container);
    (0, $5FkrB.useEffect)(function() {
        return function() {
            (0, $3rpKi.removePortalContainer)(container);
        };
    }, [
        container
    ]);
    return /*#__PURE__*/ (0, $aLeHs.createPortal)(children, container);
}

});
parcelRegister("3rpKi", function(module, exports) {
$parcel$export(module.exports, "createContainer", () => $2817dd4a3ed21424$export$26ae5ca175b4ec5a);
$parcel$export(module.exports, "removePortalContainer", () => $2817dd4a3ed21424$export$da99f98bf3fe55b3);
$parcel$export(module.exports, "appendPortalContainerIfNotAppended", () => $2817dd4a3ed21424$export$c582005add11e141);
$parcel$export(module.exports, "createAtlaskitPortal", () => $2817dd4a3ed21424$export$fef014d7cef9e543);
$parcel$export(module.exports, "createPortalParent", () => $2817dd4a3ed21424$export$95029ca7aca2989e);

var $k0fne = parcelRequire("k0fne");
var $2817dd4a3ed21424$export$26ae5ca175b4ec5a = function createContainer(zIndex) {
    var container = document.createElement('div');
    container.className = (0, $k0fne.portalClassName);
    container.style.zIndex = "".concat(zIndex);
    return container;
};
/**
 * Returns document body element
 * @return {number} - The document body element
 */ var $2817dd4a3ed21424$var$getBody = function getBody() {
    return document.body;
};
/**
 * Returns portal parent container. If no container exists already then it creates a new container with class name 'atlaskit-portal-container'
 * @return {Element} - The portal parent container div element
 */ var $2817dd4a3ed21424$var$getPortalParent = function getPortalParent() {
    var parentElement = document.querySelector((0, $k0fne.portalParentSelector));
    if (!parentElement) {
        var _getBody;
        var parent = document.createElement('div');
        parent.className = (0, $k0fne.portalParentClassName);
        // we are setting display to flex because we want each portal to create a new stacking context
        // See https://developer.mozilla.org/en-US/docs/Web/CSS/CSS_Positioning/Understanding_z_index/The_stacking_context
        parent.style.display = 'flex';
        (_getBody = $2817dd4a3ed21424$var$getBody()) === null || _getBody === void 0 || _getBody.appendChild(parent);
        return parent;
    }
    return parentElement;
};
var $2817dd4a3ed21424$export$da99f98bf3fe55b3 = function removePortalContainer(container) {
    $2817dd4a3ed21424$var$getPortalParent().removeChild(container);
};
var $2817dd4a3ed21424$export$c582005add11e141 = function appendPortalContainerIfNotAppended(container) {
    if (!container.parentElement) $2817dd4a3ed21424$var$getPortalParent().appendChild(container);
};
var $2817dd4a3ed21424$export$842dfe7a9f24298 = function isDocumentDefined() {
    return document !== undefined;
};
var $2817dd4a3ed21424$export$fef014d7cef9e543 = function createAtlaskitPortal(zIndex) {
    //atlaskit-portal div
    if ($2817dd4a3ed21424$export$842dfe7a9f24298()) {
        var atlaskitportal = document.createElement('div');
        atlaskitportal.className = (0, $k0fne.portalClassName);
        atlaskitportal.style.zIndex = "".concat(zIndex);
        return atlaskitportal;
    }
};
var $2817dd4a3ed21424$export$95029ca7aca2989e = function createPortalParent() {
    //atlaskit-portal-container div
    if ($2817dd4a3ed21424$export$842dfe7a9f24298()) {
        var parentElement = document.querySelector((0, $k0fne.portalParentSelector));
        if (!parentElement) {
            var _getBody2;
            var parent = document.createElement('div');
            parent.className = (0, $k0fne.portalParentClassName);
            parent.style.display = 'flex';
            (_getBody2 = $2817dd4a3ed21424$var$getBody()) === null || _getBody2 === void 0 || _getBody2.appendChild(parent);
            return parent;
        }
        return parentElement;
    }
};

});
parcelRegister("k0fne", function(module, exports) {
$parcel$export(module.exports, "portalParentClassName", () => $e8ffbba2ed2914bd$export$e4c79eb95c23a0da);
$parcel$export(module.exports, "portalParentSelector", () => $e8ffbba2ed2914bd$export$72f415121273627e);
$parcel$export(module.exports, "portalClassName", () => $e8ffbba2ed2914bd$export$13f57c02915787b3);
var $e8ffbba2ed2914bd$export$e4c79eb95c23a0da = 'atlaskit-portal-container';
var $e8ffbba2ed2914bd$export$72f415121273627e = 'body > .atlaskit-portal-container';
var $e8ffbba2ed2914bd$export$13f57c02915787b3 = 'atlaskit-portal';

});



parcelRegister("fHqna", function(module, exports) {
$parcel$export(module.exports, "default", () => $b6df543a8bbb9b47$export$2e2bcd8739ae039);

var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");

var $aLeHs = parcelRequire("aLeHs");

var $id6Cu = parcelRequire("id6Cu");

var $iY9wj = parcelRequire("iY9wj");

var $3rpKi = parcelRequire("3rpKi");
function $b6df543a8bbb9b47$export$2e2bcd8739ae039(props) {
    var zIndex = props.zIndex, children = props.children;
    var _useState = (0, $5FkrB.useState)(null), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), atlaskitPortal = _useState2[0], setAtlaskitPortal = _useState2[1];
    (0, $iY9wj.useIsomorphicLayoutEffect)(function() {
        var tempPortalContainer = (0, $3rpKi.createAtlaskitPortal)(zIndex);
        setAtlaskitPortal(tempPortalContainer);
        var portalParent = (0, $3rpKi.createPortalParent)();
        if (!tempPortalContainer || !portalParent) return;
        portalParent.appendChild(tempPortalContainer);
        return function() {
            if (tempPortalContainer) portalParent.removeChild(tempPortalContainer);
            setAtlaskitPortal(null);
        };
    }, [
        zIndex
    ]);
    /**
   * Conditionally wrap ALL portal children with Suspense behind a feature gate for safe rollout.
   *
   * This is here because in React 18 concurrent, if you suspend from _within_ a portal to a
   * suspense boundary _outside_ a portal, our portal gets in an infinite loop of re-rendering.
   */ var conditionallySuspendedChildren = (0, $id6Cu.fg)('platform_design_system_suspend_portal_children') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $5FkrB.Suspense), {
        fallback: null
    }, children) : children;
    return atlaskitPortal ? /*#__PURE__*/ (0, $aLeHs.createPortal)(conditionallySuspendedChildren, atlaskitPortal) : null;
}

});
parcelRegister("iY9wj", function(module, exports) {
$parcel$export(module.exports, "useIsomorphicLayoutEffect", () => $dcf53716d60b6394$export$700979bc83e7db82);

var $5FkrB = parcelRequire("5FkrB");
var $dcf53716d60b6394$export$700979bc83e7db82 = typeof window !== 'undefined' ? (0, $5FkrB.useLayoutEffect) : (0, $5FkrB.useEffect);

});


parcelRegister("f3GCr", function(module, exports) {
$parcel$export(module.exports, "default", () => $af68321895c2b1d3$export$2e2bcd8739ae039);

var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");

var $iY9wj = parcelRequire("iY9wj");
var $af68321895c2b1d3$var$useIsSubsequentRender = function useIsSubsequentRender(mountStrategy) {
    var _useState = (0, $5FkrB.useState)(false), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), isSubsequentRender = _useState2[0], setIsSubsequentRender = _useState2[1];
    var _useState3 = (0, $5FkrB.useState)(function() {
        return mountStrategy === 'layoutEffect' ? (0, $iY9wj.useIsomorphicLayoutEffect) : (0, $5FkrB.useEffect);
    }), _useState4 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState3, 1), useMountEffect = _useState4[0];
    useMountEffect(function() {
        setIsSubsequentRender(true);
    }, []);
    return isSubsequentRender;
};
var $af68321895c2b1d3$export$2e2bcd8739ae039 = $af68321895c2b1d3$var$useIsSubsequentRender;

});

parcelRegister("5hdNS", function(module, exports) {
$parcel$export(module.exports, "default", () => $3d793f62db63638d$export$2e2bcd8739ae039);

var $5FkrB = parcelRequire("5FkrB");

var $aUMqx = parcelRequire("aUMqx");

var $d5d6Y = parcelRequire("d5d6Y");
var $3d793f62db63638d$var$useFirePortalEvent = function useFirePortalEvent(zIndex) {
    var zIndexNumber = Number(zIndex);
    (0, $5FkrB.useEffect)(function() {
        (0, $d5d6Y.default)((0, $aUMqx.PORTAL_MOUNT_EVENT), zIndexNumber);
        return function() {
            (0, $d5d6Y.default)((0, $aUMqx.PORTAL_UNMOUNT_EVENT), zIndexNumber);
        };
    }, [
        zIndexNumber
    ]);
};
var $3d793f62db63638d$export$2e2bcd8739ae039 = $3d793f62db63638d$var$useFirePortalEvent;

});
parcelRegister("aUMqx", function(module, exports) {
$parcel$export(module.exports, "PORTAL_MOUNT_EVENT", () => $7f24b2f43b273b98$export$ed5835cc67e87f72);
$parcel$export(module.exports, "PORTAL_UNMOUNT_EVENT", () => $7f24b2f43b273b98$export$80816bd900e5bd00);
var $7f24b2f43b273b98$export$ed5835cc67e87f72 = 'akPortalMount';
var $7f24b2f43b273b98$export$80816bd900e5bd00 = 'akPortalUnmount';

});

parcelRegister("d5d6Y", function(module, exports) {
$parcel$export(module.exports, "default", () => $9865e9a93466f458$export$2e2bcd8739ae039);
var $9865e9a93466f458$var$zIndexToName = {
    100: 'card',
    200: 'navigation',
    300: 'dialog',
    400: 'layer',
    500: 'blanket',
    510: 'modal',
    600: 'flag',
    700: 'spotlight',
    9999: 'tooltip'
};
/**
 * return layer name in Atlassian design system corresponding to given z-index
 * @param {number} zIndex - z-index value for which layer name is needed
 * @returns {LayerName | null} - The layer name for given z-index. If layer name is not found then null is returned
 */ var $9865e9a93466f458$var$getLayerName = function getLayerName(zIndex) {
    return $9865e9a93466f458$var$zIndexToName.hasOwnProperty(zIndex) ? $9865e9a93466f458$var$zIndexToName[zIndex] : null;
};
/**
 * Creates a PortalEvent object with given eventName, given zIndex and corresponding layer
 * @param {string} eventName - either of Mount or Unmount event name
 * @param {number} zIndex - z-index value which will be included in the event to be dispatched
 * @returns {PortalEvent} - The newly created PortalEvent object
 */ var $9865e9a93466f458$var$getEvent = function getEvent(eventName, zIndex) {
    var detail = {
        layer: $9865e9a93466f458$var$getLayerName(Number(zIndex)),
        zIndex: zIndex
    };
    return new CustomEvent(eventName, {
        detail: detail
    });
};
function $9865e9a93466f458$export$2e2bcd8739ae039(eventName, zIndex) {
    var event = $9865e9a93466f458$var$getEvent(eventName, zIndex);
    window.dispatchEvent(event);
}

});



parcelRegister("7LfsS", function(module, exports) {
$parcel$export(module.exports, "gridSize", () => $5a68eb2a4c95efce$export$6d8204c2cb2e06b8);
$parcel$export(module.exports, "layers", () => $5a68eb2a4c95efce$export$7be255094ccdc533);

var $dGpXj = parcelRequire("dGpXj");

var $h0N4L = parcelRequire("h0N4L");
var $5a68eb2a4c95efce$export$44ffba16bd48dac6 = '__ATLASKIT_THEME__';
var $5a68eb2a4c95efce$export$c93026a968943f95 = 'light';
var $5a68eb2a4c95efce$export$6ba72c8346b4c57e = [
    'light',
    'dark'
];
var $5a68eb2a4c95efce$export$7a57f79000377ca2 = function borderRadius() {
    return 3;
};
var $5a68eb2a4c95efce$export$6d8204c2cb2e06b8 = function gridSize() {
    return 8;
};
var $5a68eb2a4c95efce$export$8e24544ddba725ee = function focusRing() {
    var color = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "var(--ds-border-focused, ".concat((0, $h0N4L.B200), ")");
    var outlineWidth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $5a68eb2a4c95efce$export$6d8204c2cb2e06b8() / 4;
    (0, $dGpXj.default)('@atlaskit/theme', 'focus ring mixin', 'Please use `@atlaskit/focus-ring` instead.');
    return "\n  &:focus {\n    outline: none;\n    box-shadow: 0px 0px 0px ".concat(outlineWidth, "px ").concat(color, ";\n  }\n");
};
var $5a68eb2a4c95efce$export$c0dd343266bc3261 = function noFocusRing() {
    return "\n  box-shadow: none;\n";
};
var $5a68eb2a4c95efce$export$7be255094ccdc533 = {
    card: function card() {
        return 100;
    },
    navigation: function navigation() {
        return 200;
    },
    dialog: function dialog() {
        return 300;
    },
    layer: function layer() {
        return 400;
    },
    blanket: function blanket() {
        return 500;
    },
    modal: function modal() {
        return 510;
    },
    flag: function flag() {
        return 600;
    },
    spotlight: function spotlight() {
        return 700;
    },
    tooltip: function tooltip() {
        return 9999;
    }
};
var $5a68eb2a4c95efce$export$a1b3edb637fb4f35 = function visuallyHidden() {
    (0, $dGpXj.default)('@atlaskit/theme', 'visually hidden mixin', 'Please use `@atlaskit/visually-hidden` instead.');
    return {
        border: '0 !important',
        clip: 'rect(1px, 1px, 1px, 1px) !important',
        height: '1px !important',
        overflow: 'hidden !important',
        padding: '0 !important',
        position: 'absolute !important',
        width: '1px !important',
        whiteSpace: 'nowrap !important'
    };
};
var $5a68eb2a4c95efce$export$ba1d834b86d72a09 = $5a68eb2a4c95efce$export$a1b3edb637fb4f35;
var $5a68eb2a4c95efce$export$e497e856b4f89fcd = function skeletonShimmer() {
    return {
        css: {
            backgroundColor: "var(--ds-skeleton, ".concat((0, $h0N4L.N20A), ")"),
            animationDuration: '1.5s',
            animationIterationCount: 'infinite',
            animationTimingFunction: 'linear',
            animationDirection: 'alternate'
        },
        keyframes: {
            from: {
                backgroundColor: "var(--ds-skeleton, ".concat((0, $h0N4L.N20A), ")")
            },
            to: {
                backgroundColor: "var(--ds-skeleton-subtle, ".concat((0, $h0N4L.N30A), ")")
            }
        }
    };
};

});
parcelRegister("dGpXj", function(module, exports) {
$parcel$export(module.exports, "default", () => $9f6354daacc73bfd$export$2e2bcd8739ae039);

var $hm4Q3 = parcelRequire("hm4Q3");

var $3ZMUU = parcelRequire("3ZMUU");
function $9f6354daacc73bfd$export$2e2bcd8739ae039(packageName, api, additionalMessage) {
    (0, $hm4Q3.default)("[".concat(packageName, "]: The ").concat(api, " is deprecated.").concat(additionalMessage && " ".concat(additionalMessage)));
}
function $9f6354daacc73bfd$export$eb1decd851a5ae56(packageName, propName, predicate, deprecationAnnouncementOnDAC) {
    typeof $3ZMUU;
}

});
parcelRegister("hm4Q3", function(module, exports) {
$parcel$export(module.exports, "default", () => $ca283e96b1f46976$export$2e2bcd8739ae039);
/* eslint-disable no-console */ var $ca283e96b1f46976$var$printed = {};
function $ca283e96b1f46976$export$2e2bcd8739ae039(message) {
    if ($ca283e96b1f46976$var$printed[message]) return;
    $ca283e96b1f46976$var$printed[message] = true;
    if (typeof window !== 'undefined') console.warn(message);
}

});



parcelRegister("6PYYg", function(module, exports) {
$parcel$export(module.exports, "register", () => $4fa6cd0af20a1572$export$6503ec6e8aabbaf);
/* eslint-disable @atlaskit/design-system/no-direct-use-of-web-platform-drag-and-drop */ /**
 * We are listening directly to drag events instead of using a monitor from
 * `@atlaskit/pragmatic-drag-and-drop` to avoid the bundle size cost, as it
 * would affect almost every view in every product.
 *
 * We can reconsider this choice in the future.
 */ 
var $7QpUe = parcelRequire("7QpUe");
var $4fa6cd0af20a1572$var$registrations = new Set();
var $4fa6cd0af20a1572$var$cleanupEndEventListeners = null;
function $4fa6cd0af20a1572$var$onDragStart() {
    if ($4fa6cd0af20a1572$var$cleanupEndEventListeners) // If the cleanup function exists then we've already run this
    return;
    $4fa6cd0af20a1572$var$cleanupEndEventListeners = (0, $7QpUe.bindAll)(window, [
        {
            type: 'dragend',
            listener: $4fa6cd0af20a1572$var$onDragEnd
        },
        {
            type: 'pointerdown',
            listener: $4fa6cd0af20a1572$var$onDragEnd
        },
        {
            type: 'pointermove',
            listener: function() {
                var callCount = 0;
                return function listener() {
                    // Using 20 as it is far bigger than the most observed (3)
                    if (callCount < 20) {
                        callCount++;
                        return;
                    }
                    $4fa6cd0af20a1572$var$onDragEnd();
                };
            }()
        }
    ]);
    var clone = Array.from($4fa6cd0af20a1572$var$registrations);
    clone.forEach(function(subscriber) {
        subscriber.onDragStart();
    });
}
function $4fa6cd0af20a1572$var$onDragEnd() {
    var _cleanupEndEventListe;
    (_cleanupEndEventListe = $4fa6cd0af20a1572$var$cleanupEndEventListeners) === null || _cleanupEndEventListe === void 0 || _cleanupEndEventListe();
    $4fa6cd0af20a1572$var$cleanupEndEventListeners = null;
    var clone = Array.from($4fa6cd0af20a1572$var$registrations);
    clone.forEach(function(subscriber) {
        subscriber.onDragEnd();
    });
}
function $4fa6cd0af20a1572$var$bindStartEvents() {
    return (0, $7QpUe.bindAll)(window, [
        {
            type: 'dragstart',
            listener: $4fa6cd0af20a1572$var$onDragStart
        },
        {
            type: 'dragenter',
            listener: $4fa6cd0af20a1572$var$onDragStart
        }
    ]);
}
var $4fa6cd0af20a1572$var$cleanupStartEventListeners = null;
function $4fa6cd0af20a1572$export$6503ec6e8aabbaf(registration) {
    // if first registration, bind event listeners
    if (!$4fa6cd0af20a1572$var$cleanupStartEventListeners) // note: currently never unbinding these event listeners
    $4fa6cd0af20a1572$var$cleanupStartEventListeners = $4fa6cd0af20a1572$var$bindStartEvents();
    $4fa6cd0af20a1572$var$registrations.add(registration);
    /**
   * The reasoning for this behavior is so that if a tooltip mounts during
   * a drag it can still be suppressed.
   *
   * We use a separate callback instead of onDragStart to avoid infinite loops.
   */ registration.onRegister({
        isDragging: $4fa6cd0af20a1572$var$cleanupEndEventListeners !== null
    });
    return function unregister() {
        $4fa6cd0af20a1572$var$registrations.delete(registration);
        if ($4fa6cd0af20a1572$var$registrations.size === 0) {
            var _cleanupStartEventLis;
            (_cleanupStartEventLis = $4fa6cd0af20a1572$var$cleanupStartEventListeners) === null || _cleanupStartEventLis === void 0 || _cleanupStartEventLis();
            $4fa6cd0af20a1572$var$cleanupStartEventListeners = null;
        }
    };
}

});

parcelRegister("c0Z2u", function(module, exports) {
$parcel$export(module.exports, "show", () => $8bf4d54073dfb8d7$export$57bf213be019eeb0);

var $bgGR3 = parcelRequire("bgGR3");
// This file is a singleton for managing tooltips
var $8bf4d54073dfb8d7$var$active = null;
function $8bf4d54073dfb8d7$export$57bf213be019eeb0(entry) {
    var phase = 'waiting-to-show';
    function isActive() {
        return Boolean($8bf4d54073dfb8d7$var$active && $8bf4d54073dfb8d7$var$active.entry === entry);
    }
    function cleanup() {
        if (isActive()) {
            (0, $bgGR3.clearScheduled)();
            $8bf4d54073dfb8d7$var$active = null;
        }
    }
    function done() {
        if (isActive()) entry.done();
        phase = 'done';
        cleanup();
    }
    function immediatelyHideAndDone() {
        if (isActive()) entry.hide({
            isImmediate: true
        });
        done();
    }
    function keep() {
        if (!isActive()) return;
        // aborting a wait to hide
        if (phase === 'waiting-to-hide') {
            phase = 'shown';
            (0, $bgGR3.clearScheduled)();
            return;
        }
        // aborting hide animation
        if (phase === 'hide-animating') {
            phase = 'shown';
            (0, $bgGR3.clearScheduled)();
            entry.show({
                isImmediate: false
            });
            return;
        }
    }
    function requestHide(_ref) {
        var isImmediate = _ref.isImmediate;
        if (!isActive()) return;
        // If we were not showing yet anyway; finish straight away
        if (phase === 'waiting-to-show') {
            immediatelyHideAndDone();
            return;
        }
        // already waiting to hide
        if (phase === 'waiting-to-hide') return;
        if (isImmediate) {
            immediatelyHideAndDone();
            return;
        }
        phase = 'waiting-to-hide';
        (0, $bgGR3.scheduleTimeout)(function() {
            phase = 'hide-animating';
            entry.hide({
                isImmediate: false
            });
        }, entry.delay);
    }
    function finishHideAnimation() {
        if (isActive() && phase === 'hide-animating') done();
    }
    function isVisible() {
        return phase === 'shown' || phase === 'waiting-to-hide' || phase === 'hide-animating';
    }
    function getInitialMouse() {
        if (entry.source.type === 'mouse') return entry.source.mouse;
        return null;
    }
    function start() {
        var showImmediately = Boolean($8bf4d54073dfb8d7$var$active && $8bf4d54073dfb8d7$var$active.isVisible());
        // If there was an active tooltip; we tell it to remove itself at once!
        if ($8bf4d54073dfb8d7$var$active) {
            (0, $bgGR3.clearScheduled)();
            $8bf4d54073dfb8d7$var$active.entry.hide({
                isImmediate: true
            });
            $8bf4d54073dfb8d7$var$active.entry.done();
            $8bf4d54073dfb8d7$var$active = null;
        }
        // this tooltip is now the active tooltip
        $8bf4d54073dfb8d7$var$active = {
            entry: entry,
            isVisible: isVisible
        };
        function show() {
            phase = 'shown';
            entry.show({
                isImmediate: showImmediately
            });
        }
        if (showImmediately) {
            show();
            return;
        }
        phase = 'waiting-to-show';
        (0, $bgGR3.scheduleTimeout)(show, entry.delay);
    }
    // let's get started!
    start();
    var result = {
        keep: keep,
        abort: cleanup,
        isActive: isActive,
        requestHide: requestHide,
        finishHideAnimation: finishHideAnimation,
        mousePosition: getInitialMouse()
    };
    return result;
}

});
parcelRegister("bgGR3", function(module, exports) {
$parcel$export(module.exports, "clearScheduled", () => $83426e5de6197765$export$eaf678f6f93f5250);
$parcel$export(module.exports, "scheduleTimeout", () => $83426e5de6197765$export$5f4d6617421d489b);
var $83426e5de6197765$var$delayId = null;
function $83426e5de6197765$export$eaf678f6f93f5250() {
    if ($83426e5de6197765$var$delayId != null) {
        window.clearTimeout($83426e5de6197765$var$delayId);
        $83426e5de6197765$var$delayId = null;
    }
}
function $83426e5de6197765$export$5f4d6617421d489b(fn, delay) {
    $83426e5de6197765$export$eaf678f6f93f5250();
    $83426e5de6197765$var$delayId = window.setTimeout(function() {
        $83426e5de6197765$var$delayId = null;
        fn();
    }, delay);
}

});


parcelRegister("9Nvet", function(module, exports) {
$parcel$export(module.exports, "default", () => $7220eac72dce661d$export$2e2bcd8739ae039);

var $7P37d = parcelRequire("7P37d");
function $7220eac72dce661d$export$2e2bcd8739ae039(prefix, shouldRenderId) {
    var seed = (0, $7P37d.useIdSeed)();
    return shouldRenderId ? "".concat(seed(prefix)) : undefined;
}

});
parcelRegister("7P37d", function(module, exports) {
$parcel$export(module.exports, "useIdSeed", () => $5b1fb67ed92ea032$export$6ee17796e3d70de2);

var $ekGgq = parcelRequire("ekGgq");

var $5FkrB = parcelRequire("5FkrB");

var $b5lkZ = parcelRequire("b5lkZ");

var $cGwag = parcelRequire("cGwag");
var $5b1fb67ed92ea032$var$_React$useId;
// Type copied from https://github.com/thearnica/react-uid/blob/0f507fbbdb1ab84acf477ec32698afe3d2191e49/src/hooks.ts#L12
// Copied rather than inferred to make the type transparent
// @ts-ignore - useId is not accessible in React 16
var $5b1fb67ed92ea032$var$react18UseId = ($5b1fb67ed92ea032$var$_React$useId = (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).useId) !== null && $5b1fb67ed92ea032$var$_React$useId !== void 0 ? $5b1fb67ed92ea032$var$_React$useId : undefined;
function $5b1fb67ed92ea032$export$f680877a34711e37() {
    if ($5b1fb67ed92ea032$var$react18UseId && (0, $cGwag.fg)('platform.design-system-team.react-18-use-id_mn8q4')) // eslint-disable-next-line react-hooks/rules-of-hooks
    return $5b1fb67ed92ea032$var$react18UseId();
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return "uid".concat((0, $b5lkZ.useUID)());
}
var $5b1fb67ed92ea032$export$6be90bcb437e928f = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function(_ref, ref) {
    var children = _ref.children, _ref$postfix = _ref.postfix, postfix = _ref$postfix === void 0 ? '' : _ref$postfix, _ref$prefix = _ref.prefix, prefix = _ref$prefix === void 0 ? '' : _ref$prefix;
    var id = "".concat(prefix).concat($5b1fb67ed92ea032$export$f680877a34711e37()).concat(postfix);
    (0, $5FkrB.useEffect)(function() {
        if (!ref) return;
        switch((0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(ref)){
            case 'function':
                ref(id);
                break;
            case 'object':
                ref.current = id;
                break;
            default:
                throw new Error("Unreachable case for unsupported type of ref \"".concat((0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(ref), "\""));
        }
    }, [
        id,
        ref
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).Fragment, null, typeof children === 'function' ? children({
        id: id
    }) : children);
});
function $5b1fb67ed92ea032$export$6ee17796e3d70de2() {
    if ($5b1fb67ed92ea032$var$react18UseId && (0, $cGwag.fg)('platform.design-system-team.react-18-use-id_mn8q4')) {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        var uid = $5b1fb67ed92ea032$var$react18UseId();
        return function(id) {
            return "".concat(uid, "-").concat(id.toString());
        };
    }
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return (0, $b5lkZ.useUIDSeed)();
}

});
parcelRegister("cGwag", function(module, exports) {
$parcel$export(module.exports, "fg", () => $93c25b7a7de1f297$export$b40ec24ac8275656);

var $4TfXd = parcelRequire("4TfXd");
function $93c25b7a7de1f297$export$ba05d765b8392e5e(flagResolver) {
    (0, $4TfXd.setBooleanResolver)(flagResolver);
}
function $93c25b7a7de1f297$export$470e5c2be1411c89(name) {
    return (0, $4TfXd.resolveBooleanFlag)(name);
}
function $93c25b7a7de1f297$export$b40ec24ac8275656(name) {
    return (0, $4TfXd.resolveBooleanFlag)(name);
}

});
parcelRegister("4TfXd", function(module, exports) {
$parcel$export(module.exports, "setBooleanResolver", () => $38f8aca3031a7530$export$f2b591175b3e424c);
$parcel$export(module.exports, "resolveBooleanFlag", () => $38f8aca3031a7530$export$6333b6aff9fc6275);

var $jZlo3 = parcelRequire("jZlo3");

var $lbgrH = parcelRequire("lbgrH");

var $3ZMUU = parcelRequire("3ZMUU");
var $38f8aca3031a7530$var$pkgName = '@atlaskit/platform-feature-flags';
var $38f8aca3031a7530$export$7e41b1b2bdee3f98 = '__PLATFORM_FEATURE_FLAGS__';
var $38f8aca3031a7530$var$hasProcessEnv = typeof $3ZMUU !== 'undefined' && typeof $3ZMUU.env !== 'undefined';
// FF global overrides can be configured by test runners or Storybook
var $38f8aca3031a7530$var$ENV_ENABLE_PLATFORM_FF = $38f8aca3031a7530$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
// STORYBOOK_ENABLE_PLATFORM_FF is included as storybook only allows env vars prefixed with STORYBOOK
// https://github.com/storybookjs/storybook/issues/12270
var $38f8aca3031a7530$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF = $38f8aca3031a7530$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
var $38f8aca3031a7530$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE = $38f8aca3031a7530$var$ENV_ENABLE_PLATFORM_FF || $38f8aca3031a7530$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF;
var $38f8aca3031a7530$var$DEFAULT_PFF_GLOBAL = {
    booleanResolver: undefined
};
var $38f8aca3031a7530$var$globalVar = typeof window !== 'undefined' ? window : globalThis;
$38f8aca3031a7530$var$globalVar[$38f8aca3031a7530$export$7e41b1b2bdee3f98] = $38f8aca3031a7530$var$globalVar[$38f8aca3031a7530$export$7e41b1b2bdee3f98] || $38f8aca3031a7530$var$DEFAULT_PFF_GLOBAL;
function $38f8aca3031a7530$export$f2b591175b3e424c(resolver) {
    $38f8aca3031a7530$var$globalVar[$38f8aca3031a7530$export$7e41b1b2bdee3f98].booleanResolver = resolver;
}
function $38f8aca3031a7530$export$6333b6aff9fc6275(flagKey) {
    if ($38f8aca3031a7530$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE) {
        (0, $lbgrH.debug)('[%s]: The feature flags were enabled while running tests. The flag "%s" will be always enabled.', $38f8aca3031a7530$var$pkgName, flagKey);
        return true;
    }
    try {
        var _globalVar$PFF_GLOBAL, _globalVar$PFF_GLOBAL2, _globalVar$PFF_GLOBAL3;
        // booleanResolver will be empty for products like Trello, Elevate, Recruit etc.
        // Currently only Confluence, Jira and Bitbucket has set it.
        if (((_globalVar$PFF_GLOBAL = $38f8aca3031a7530$var$globalVar[$38f8aca3031a7530$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL === void 0 ? void 0 : _globalVar$PFF_GLOBAL.booleanResolver) === undefined || ((_globalVar$PFF_GLOBAL2 = $38f8aca3031a7530$var$globalVar[$38f8aca3031a7530$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL2 === void 0 ? void 0 : _globalVar$PFF_GLOBAL2.booleanResolver) === null) // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
        return (0, $jZlo3.default).checkGate(flagKey);
        var result = (_globalVar$PFF_GLOBAL3 = $38f8aca3031a7530$var$globalVar[$38f8aca3031a7530$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL3 === void 0 ? void 0 : _globalVar$PFF_GLOBAL3.booleanResolver(flagKey);
        if (typeof result !== 'boolean') {
            // eslint-disable-next-line no-console
            console.warn("".concat(flagKey, " resolved to a non-boolean value, returning false for safety"));
            return false;
        }
        return result;
    } catch (e) {
        return false;
    }
}

});
parcelRegister("lbgrH", function(module, exports) {
$parcel$export(module.exports, "debug", () => $f6b761d6b749a438$export$1c9f709888824e05);
var $f6b761d6b749a438$var$_process, $f6b761d6b749a438$var$_process2;
// We can't rely on NODE_ENV === 'test' if its value is already configured by the consumer to some other value, so better to use JEST_WORKER_ID
// https://jestjs.io/docs/environment-variables#jest_worker_id
var $f6b761d6b749a438$var$TESTS_MODE = (globalThis === null || globalThis === void 0 || ($f6b761d6b749a438$var$_process = globalThis.process) === null || $f6b761d6b749a438$var$_process === void 0 || ($f6b761d6b749a438$var$_process = $f6b761d6b749a438$var$_process.env) === null || $f6b761d6b749a438$var$_process === void 0 ? void 0 : $f6b761d6b749a438$var$_process.JEST_WORKER_ID) !== undefined;
var $f6b761d6b749a438$var$DEBUG_MODE = !$f6b761d6b749a438$var$TESTS_MODE && (globalThis === null || globalThis === void 0 || ($f6b761d6b749a438$var$_process2 = globalThis.process) === null || $f6b761d6b749a438$var$_process2 === void 0 || ($f6b761d6b749a438$var$_process2 = $f6b761d6b749a438$var$_process2.env) === null || $f6b761d6b749a438$var$_process2 === void 0 ? void 0 : $f6b761d6b749a438$var$_process2.NODE_ENV) !== 'production';
var $f6b761d6b749a438$export$1c9f709888824e05 = function debug() {
    var _console;
    if (!$f6b761d6b749a438$var$DEBUG_MODE) return;
    // eslint-disable-next-line no-console
    (_console = console).debug.apply(_console, arguments);
};

});





parcelRegister("fArWw", function(module, exports) {
$parcel$export(module.exports, "default", () => $b58fe4aba84c5818$export$2e2bcd8739ae039);
/* tooltip-container.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $25nEq = parcelRequire("25nEq");

var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");
var $cAVP0 = parcelRequire("cAVP0");

var $h0N4L = parcelRequire("h0N4L");

var $Sw95I = parcelRequire("Sw95I");
function $b58fe4aba84c5818$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $b58fe4aba84c5818$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $b58fe4aba84c5818$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $b58fe4aba84c5818$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $b58fe4aba84c5818$var$baseStyles = null;
var $b58fe4aba84c5818$var$truncateStyles = null;
/**
 * Used as the default tooltip container component for the exported `Tooltip` component.
 * Adds some styles to the tooltip primitive.
 */ var $b58fe4aba84c5818$var$TooltipContainer = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function TooltipContainer(_ref, ref) {
    var style = _ref.style, className = _ref.className, children = _ref.children, truncate = _ref.truncate, placement = _ref.placement, testId = _ref.testId, onMouseOut = _ref.onMouseOut, onMouseOver = _ref.onMouseOver, id = _ref.id;
    return /*#__PURE__*/ $5FkrB.createElement((0, $Sw95I.default), {
        ref: ref,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $970q7.default)([
            "_2rko1sit _11c8qk37 _vchhusvi _p12fp3fh _bfhkpioe _syaz1i9p _152tze3t _1e02ze3t _1i4q1hna _85i5v77o _1q51v77o _y4ti12x7 _bozg12x7 _slp31hna",
            truncate && "_1reo15vq _18m915vq _p12f1pna _1bto1l2s _o5721q9c",
            className
        ]),
        placement: placement,
        testId: testId,
        id: id,
        onMouseOut: onMouseOut,
        onMouseOver: onMouseOver,
        style: $b58fe4aba84c5818$var$_objectSpread($b58fe4aba84c5818$var$_objectSpread({}, style), {}, {
            "--_yr7xfv": (0, $cAVP0.default)("var(--ds-background-neutral-bold, ".concat((0, $h0N4L.N800), ")")),
            "--_ywovvi": (0, $cAVP0.default)("var(--ds-text-inverse, ".concat((0, $h0N4L.N0), ")"))
        })
    }, children);
});
$b58fe4aba84c5818$var$TooltipContainer.displayName = 'TooltipContainer';
var $b58fe4aba84c5818$export$2e2bcd8739ae039 = $b58fe4aba84c5818$var$TooltipContainer;

});
parcelRegister("Sw95I", function(module, exports) {
$parcel$export(module.exports, "default", () => $0a3dfab6ab7dbac4$export$2e2bcd8739ae039);

var $25nEq = parcelRequire("25nEq");

var $5FkrB = parcelRequire("5FkrB");

var $74Zh5 = parcelRequire("74Zh5");

var $7LfsS = parcelRequire("7LfsS");
function $0a3dfab6ab7dbac4$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $0a3dfab6ab7dbac4$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $0a3dfab6ab7dbac4$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $0a3dfab6ab7dbac4$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $0a3dfab6ab7dbac4$var$VAR_PRIMITIVE_ZINDEX = 'tooltipPrimitiveZindex';
var $0a3dfab6ab7dbac4$var$primitiveStyles = (0, $74Zh5.css)({
    zindex: "var(".concat($0a3dfab6ab7dbac4$var$VAR_PRIMITIVE_ZINDEX, ")"),
    cursor: "default"
});
/**
 * The lower level component for rendering a tooltip.
 */ var $0a3dfab6ab7dbac4$var$TooltipPrimitive = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function TooltipPrimitive(_ref, ref) {
    var style = _ref.style, className = _ref.className, children = _ref.children, placement = _ref.placement, testId = _ref.testId, onMouseOut = _ref.onMouseOut, onMouseOver = _ref.onMouseOver, id = _ref.id;
    var styleWithZIndex = $0a3dfab6ab7dbac4$var$_objectSpread($0a3dfab6ab7dbac4$var$_objectSpread({}, style), {}, (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, $0a3dfab6ab7dbac4$var$VAR_PRIMITIVE_ZINDEX, (0, $7LfsS.layers).tooltip()));
    return (0, $74Zh5.jsx)("div", {
        ref: ref,
        style: styleWithZIndex,
        "data-testid": testId ? "".concat(testId, "--wrapper") : undefined
    }, (0, $74Zh5.jsx)("div", {
        role: "tooltip",
        className: className,
        onMouseOut: onMouseOut,
        onMouseOver: onMouseOver,
        css: $0a3dfab6ab7dbac4$var$primitiveStyles,
        "data-placement": placement,
        "data-testid": testId,
        id: id
    }, children));
});
$0a3dfab6ab7dbac4$var$TooltipPrimitive.displayName = 'TooltipPrimitive';
var $0a3dfab6ab7dbac4$export$2e2bcd8739ae039 = $0a3dfab6ab7dbac4$var$TooltipPrimitive;

});


parcelRegister("059LA", function(module, exports) {
$parcel$export(module.exports, "getMousePosition", () => $00f80b2c515c307e$export$642213d516a9b928);
function $00f80b2c515c307e$export$642213d516a9b928(mouseCoordinates) {
    var safeMouse = mouseCoordinates || {
        top: 0,
        left: 0
    };
    var getBoundingClientRect = function getBoundingClientRect() {
        return {
            top: safeMouse.top,
            left: safeMouse.left,
            bottom: safeMouse.top,
            right: safeMouse.left,
            width: 0,
            height: 0
        };
    };
    return {
        getBoundingClientRect: getBoundingClientRect,
        clientWidth: 0,
        clientHeight: 0
    };
}

});


parcelRegister("fmio1", function(module, exports) {
$parcel$export(module.exports, "default", () => $b2e72c460fbdbe2d$export$2e2bcd8739ae039);

var $5FkrB = parcelRequire("5FkrB");

var $0cQiR = parcelRequire("0cQiR");

var $dGLWv = parcelRequire("dGLWv");

var $dIzAm = parcelRequire("dIzAm");

var $kBPlY = parcelRequire("kBPlY");
/**
 * __Use icon button__
 *
 * A React hook that accepts a set of icon Button props,
 * and processes them to return consistent base props for usage
 * across IconButton and LinkIconButton variants.
 *
 * @private
 */ var $b2e72c460fbdbe2d$var$useIconButton = function useIconButton(_ref) {
    var analyticsContext = _ref.analyticsContext, appearance = _ref.appearance, ariaLabel = _ref.ariaLabel, ariaLabelledBy = _ref.ariaLabelledBy, autoFocus = _ref.autoFocus, buttonType = _ref.buttonType, icon = _ref.icon, interactionName = _ref.interactionName, isDisabled = _ref.isDisabled, _ref$isLoading = _ref.isLoading, isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading, isSelected = _ref.isSelected, label = _ref.label, onClick = _ref.onClick, onClickCapture = _ref.onClickCapture, onKeyDownCapture = _ref.onKeyDownCapture, onKeyUpCapture = _ref.onKeyUpCapture, onMouseDownCapture = _ref.onMouseDownCapture, onMouseUpCapture = _ref.onMouseUpCapture, onPointerDownCapture = _ref.onPointerDownCapture, onPointerUpCapture = _ref.onPointerUpCapture, onTouchEndCapture = _ref.onTouchEndCapture, onTouchStartCapture = _ref.onTouchStartCapture, ref = _ref.ref, shape = _ref.shape, shouldFitContainer = _ref.shouldFitContainer, spacing = _ref.spacing, testId = _ref.testId;
    var isCircle = shape === 'circle';
    var baseProps = (0, $kBPlY.default)({
        analyticsContext: analyticsContext,
        appearance: appearance,
        autoFocus: autoFocus,
        ariaLabel: ariaLabel,
        ariaLabelledBy: ariaLabelledBy,
        buttonType: buttonType,
        children: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $dGLWv.default), {
            type: "icon",
            isLoading: isLoading
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $dIzAm.default), {
            icon: icon
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $0cQiR.default), null, label)),
        interactionName: interactionName,
        isDisabled: isDisabled,
        isLoading: isLoading,
        isSelected: isSelected,
        isIconButton: true,
        isCircle: isCircle,
        onClick: onClick,
        onMouseDownCapture: onMouseDownCapture,
        onMouseUpCapture: onMouseUpCapture,
        onKeyDownCapture: onKeyDownCapture,
        onKeyUpCapture: onKeyUpCapture,
        onTouchStartCapture: onTouchStartCapture,
        onTouchEndCapture: onTouchEndCapture,
        onPointerDownCapture: onPointerDownCapture,
        onPointerUpCapture: onPointerUpCapture,
        onClickCapture: onClickCapture,
        ref: ref,
        shouldFitContainer: shouldFitContainer,
        spacing: spacing,
        testId: testId
    });
    return baseProps;
};
var $b2e72c460fbdbe2d$export$2e2bcd8739ae039 = $b2e72c460fbdbe2d$var$useIconButton;

});


parcelRegister("b1PNV", function(module, exports) {
$parcel$export(module.exports, "default", () => $8077f8ee52f2006a$export$2e2bcd8739ae039);

var $kqp0i = parcelRequire("kqp0i");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");

var $59LlV = parcelRequire("59LlV");

var $1oVT1 = parcelRequire("1oVT1");

var $fmio1 = parcelRequire("fmio1");
var $8077f8ee52f2006a$var$_excluded = [
    "aria-label",
    "aria-labelledby",
    "analyticsContext",
    "appearance",
    "autoFocus",
    "href",
    "icon",
    "interactionName",
    "isDisabled",
    "isSelected",
    "isTooltipDisabled",
    "label",
    "onClick",
    "onClickCapture",
    "onKeyDownCapture",
    "onKeyUpCapture",
    "onMouseDownCapture",
    "onMouseUpCapture",
    "onPointerDownCapture",
    "onPointerUpCapture",
    "onTouchEndCapture",
    "onTouchStartCapture",
    "shape",
    "spacing",
    "testId",
    "tooltip"
], $8077f8ee52f2006a$var$_excluded2 = [
    "className",
    "css",
    "as",
    "style"
];
var $8077f8ee52f2006a$var$LinkIconButtonBase = function LinkIconButtonBase(_ref, ref) {
    var preventedAriaLabel = _ref['aria-label'], ariaLabelledBy = _ref['aria-labelledby'], analyticsContext = _ref.analyticsContext, appearance = _ref.appearance, autoFocus = _ref.autoFocus, href = _ref.href, icon = _ref.icon, interactionName = _ref.interactionName, isDisabled = _ref.isDisabled, isSelected = _ref.isSelected, _ref$isTooltipDisable = _ref.isTooltipDisabled, isTooltipDisabled = _ref$isTooltipDisable === void 0 ? true : _ref$isTooltipDisable, label = _ref.label, onClick = _ref.onClick, onClickCapture = _ref.onClickCapture, onKeyDownCapture = _ref.onKeyDownCapture, onKeyUpCapture = _ref.onKeyUpCapture, onMouseDownCapture = _ref.onMouseDownCapture, onMouseUpCapture = _ref.onMouseUpCapture, onPointerDownCapture = _ref.onPointerDownCapture, onPointerUpCapture = _ref.onPointerUpCapture, onTouchEndCapture = _ref.onTouchEndCapture, onTouchStartCapture = _ref.onTouchStartCapture, shape = _ref.shape, spacing = _ref.spacing, testId = _ref.testId, tooltip = _ref.tooltip, unsafeRest = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $8077f8ee52f2006a$var$_excluded);
    // @ts-expect-error
    var _className = unsafeRest.className, _css = unsafeRest.css, _as = unsafeRest.as, _style = unsafeRest.style, saferRest = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(unsafeRest, $8077f8ee52f2006a$var$_excluded2);
    var baseProps = (0, $fmio1.default)({
        analyticsContext: analyticsContext,
        appearance: appearance,
        ariaLabelledBy: ariaLabelledBy,
        autoFocus: autoFocus,
        buttonType: 'link',
        icon: icon,
        interactionName: interactionName,
        isDisabled: isDisabled,
        isSelected: isSelected,
        label: label,
        onClick: onClick,
        onClickCapture: onClickCapture,
        onKeyDownCapture: onKeyDownCapture,
        onKeyUpCapture: onKeyUpCapture,
        onMouseDownCapture: onMouseDownCapture,
        onMouseUpCapture: onMouseUpCapture,
        onPointerDownCapture: onPointerDownCapture,
        onPointerUpCapture: onPointerUpCapture,
        onTouchEndCapture: onTouchEndCapture,
        onTouchStartCapture: onTouchStartCapture,
        ref: ref,
        shape: shape,
        spacing: spacing,
        testId: testId
    });
    if (!isTooltipDisabled) {
        var _tooltip$content;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $1oVT1.default), {
            content: (_tooltip$content = tooltip === null || tooltip === void 0 ? void 0 : tooltip.content) !== null && _tooltip$content !== void 0 ? _tooltip$content : label,
            testId: tooltip === null || tooltip === void 0 ? void 0 : tooltip.testId,
            position: tooltip === null || tooltip === void 0 ? void 0 : tooltip.position,
            delay: tooltip === null || tooltip === void 0 ? void 0 : tooltip.delay,
            onShow: tooltip === null || tooltip === void 0 ? void 0 : tooltip.onShow,
            onHide: tooltip === null || tooltip === void 0 ? void 0 : tooltip.onHide,
            mousePosition: tooltip === null || tooltip === void 0 ? void 0 : tooltip.mousePosition,
            analyticsContext: tooltip === null || tooltip === void 0 ? void 0 : tooltip.analyticsContext,
            strategy: tooltip === null || tooltip === void 0 ? void 0 : tooltip.strategy,
            tag: tooltip === null || tooltip === void 0 ? void 0 : tooltip.tag,
            truncate: tooltip === null || tooltip === void 0 ? void 0 : tooltip.truncate,
            component: tooltip === null || tooltip === void 0 ? void 0 : tooltip.component,
            hideTooltipOnClick: tooltip === null || tooltip === void 0 ? void 0 : tooltip.hideTooltipOnClick,
            hideTooltipOnMouseDown: tooltip === null || tooltip === void 0 ? void 0 : tooltip.hideTooltipOnMouseDown,
            ignoreTooltipPointerEvents: tooltip === null || tooltip === void 0 ? void 0 : tooltip.ignoreTooltipPointerEvents
        }, function(triggerProps) {
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $59LlV.default), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, saferRest, {
                "aria-labelledby": baseProps['aria-labelledby'],
                testId: testId,
                componentName: "LinkIconButton",
                analyticsContext: analyticsContext,
                interactionName: interactionName,
                onMouseOver: function onMouseOver(e) {
                    var _triggerProps$onMouse, _saferRest$onMouseOve;
                    (_triggerProps$onMouse = triggerProps.onMouseOver) === null || _triggerProps$onMouse === void 0 || _triggerProps$onMouse.call(triggerProps, e);
                    (_saferRest$onMouseOve = saferRest.onMouseOver) === null || _saferRest$onMouseOve === void 0 || _saferRest$onMouseOve.call(saferRest, e);
                },
                onMouseOut: function onMouseOut(e) {
                    var _triggerProps$onMouse2, _saferRest$onMouseOut;
                    (_triggerProps$onMouse2 = triggerProps.onMouseOut) === null || _triggerProps$onMouse2 === void 0 || _triggerProps$onMouse2.call(triggerProps, e);
                    (_saferRest$onMouseOut = saferRest.onMouseOut) === null || _saferRest$onMouseOut === void 0 || _saferRest$onMouseOut.call(saferRest, e);
                },
                onMouseMove: function onMouseMove(e) {
                    var _triggerProps$onMouse3, _saferRest$onMouseMov;
                    (_triggerProps$onMouse3 = triggerProps.onMouseMove) === null || _triggerProps$onMouse3 === void 0 || _triggerProps$onMouse3.call(triggerProps, e);
                    (_saferRest$onMouseMov = saferRest.onMouseMove) === null || _saferRest$onMouseMov === void 0 || _saferRest$onMouseMov.call(saferRest, e);
                },
                onMouseDown: function onMouseDown(e) {
                    var _triggerProps$onMouse4, _saferRest$onMouseDow;
                    (_triggerProps$onMouse4 = triggerProps.onMouseDown) === null || _triggerProps$onMouse4 === void 0 || _triggerProps$onMouse4.call(triggerProps, e);
                    (_saferRest$onMouseDow = saferRest.onMouseDown) === null || _saferRest$onMouseDow === void 0 || _saferRest$onMouseDow.call(saferRest, e);
                },
                onFocus: function onFocus(e) {
                    var _triggerProps$onFocus, _saferRest$onFocus;
                    (_triggerProps$onFocus = triggerProps.onFocus) === null || _triggerProps$onFocus === void 0 || _triggerProps$onFocus.call(triggerProps, e);
                    (_saferRest$onFocus = saferRest.onFocus) === null || _saferRest$onFocus === void 0 || _saferRest$onFocus.call(saferRest, e);
                },
                onBlur: function onBlur(e) {
                    var _triggerProps$onBlur, _saferRest$onBlur;
                    (_triggerProps$onBlur = triggerProps.onBlur) === null || _triggerProps$onBlur === void 0 || _triggerProps$onBlur.call(triggerProps, e);
                    (_saferRest$onBlur = saferRest.onBlur) === null || _saferRest$onBlur === void 0 || _saferRest$onBlur.call(saferRest, e);
                },
                onClick: function onClick(event, analyticsEvent) {
                    var _baseProps$onClick, _triggerProps$onClick;
                    baseProps === null || baseProps === void 0 || (_baseProps$onClick = baseProps.onClick) === null || _baseProps$onClick === void 0 || _baseProps$onClick.call(baseProps, event, analyticsEvent);
                    triggerProps === null || triggerProps === void 0 || (_triggerProps$onClick = triggerProps.onClick) === null || _triggerProps$onClick === void 0 || _triggerProps$onClick.call(triggerProps, event);
                },
                ref: function ref(_ref2) {
                    var _triggerProps$ref;
                    baseProps.ref(_ref2);
                    triggerProps === null || triggerProps === void 0 || (_triggerProps$ref = triggerProps.ref) === null || _triggerProps$ref === void 0 || _triggerProps$ref.call(triggerProps, _ref2);
                },
                xcss: baseProps.xcss,
                onMouseDownCapture: baseProps.onMouseDownCapture,
                onMouseUpCapture: baseProps.onMouseUpCapture,
                onKeyDownCapture: baseProps.onKeyDownCapture,
                onKeyUpCapture: baseProps.onKeyUpCapture,
                onTouchStartCapture: baseProps.onTouchStartCapture,
                onTouchEndCapture: baseProps.onTouchEndCapture,
                onPointerDownCapture: baseProps.onPointerDownCapture,
                onPointerUpCapture: baseProps.onPointerUpCapture,
                onClickCapture: baseProps.onClickCapture,
                href: baseProps.isDisabled ? undefined : href,
                role: baseProps.isDisabled ? 'link' : undefined,
                "aria-disabled": baseProps.isDisabled === true ? true : undefined
            }), baseProps.children);
        });
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $59LlV.default), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, saferRest, {
        "aria-labelledby": baseProps['aria-labelledby'],
        ref: baseProps.ref,
        xcss: baseProps.xcss,
        onClick: baseProps.onClick,
        onMouseDownCapture: baseProps.onMouseDownCapture,
        onMouseUpCapture: baseProps.onMouseUpCapture,
        onKeyDownCapture: baseProps.onKeyDownCapture,
        onKeyUpCapture: baseProps.onKeyUpCapture,
        onTouchStartCapture: baseProps.onTouchStartCapture,
        onTouchEndCapture: baseProps.onTouchEndCapture,
        onPointerDownCapture: baseProps.onPointerDownCapture,
        onPointerUpCapture: baseProps.onPointerUpCapture,
        onClickCapture: baseProps.onClickCapture,
        testId: testId,
        href: baseProps.isDisabled ? undefined : href,
        role: baseProps.isDisabled ? 'link' : undefined,
        "aria-disabled": baseProps.isDisabled === true ? true : undefined,
        componentName: "LinkIconButton",
        analyticsContext: analyticsContext,
        interactionName: interactionName
    }), baseProps.children);
};
// Workarounds to support generic types with forwardRef + memo
var $8077f8ee52f2006a$var$WithRef = /*#__PURE__*/ (0, $5FkrB.forwardRef)($8077f8ee52f2006a$var$LinkIconButtonBase);
/**
 * __Link Icon Button__
 *
 * Renders a link in the style of an icon button.
 *
 * - [Examples](https://atlassian.design/components/button/link-icon-button/examples)
 * - [Code](https://atlassian.design/components/button/link-icon-button/code)
 * - [Usage](https://atlassian.design/components/button/link-icon-button/usage)
 */ var $8077f8ee52f2006a$var$LinkIconButton = /*#__PURE__*/ (0, $5FkrB.memo)($8077f8ee52f2006a$var$WithRef);
var $8077f8ee52f2006a$export$2e2bcd8739ae039 = $8077f8ee52f2006a$var$LinkIconButton;

});

parcelRegister("c0yaC", function(module, exports) {
$parcel$export(module.exports, "SplitButton", () => $8bdffda66d351be4$export$651ad66661acd392);

var $25nEq = parcelRequire("25nEq");

var $74Zh5 = parcelRequire("74Zh5");

var $id6Cu = parcelRequire("id6Cu");

var $7OBJ1 = parcelRequire("7OBJ1");

var $7RmFb = parcelRequire("7RmFb");
function $8bdffda66d351be4$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $8bdffda66d351be4$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $8bdffda66d351be4$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $8bdffda66d351be4$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $8bdffda66d351be4$var$baseDividerStyles = (0, $74Zh5.css)({
    width: "var(--ds-border-width, 1px)",
    position: 'relative',
    // This is 1 so it appears above buttons by default.
    // When buttons are selected they have a zIndex of 2 applied.
    // See use-button-base.tsx.
    zIndex: 1
});
var $8bdffda66d351be4$var$dividerDisabledStyles = (0, $74Zh5.css)({
    backgroundColor: "var(--ds-text-disabled, #091E4224)",
    cursor: 'not-allowed',
    opacity: 0.51
});
var $8bdffda66d351be4$var$dividerDisabledRefreshedStyles = (0, $74Zh5.css)({
    backgroundColor: "var(--ds-border-disabled, #091E4224)",
    cursor: 'not-allowed'
});
var $8bdffda66d351be4$var$dividerAppearance = {
    default: (0, $74Zh5.css)({
        backgroundColor: "var(--ds-text, #172B4D)",
        opacity: 0.51
    }),
    primary: (0, $74Zh5.css)({
        backgroundColor: "var(--ds-text-inverse, #FFF)",
        opacity: 0.64
    }),
    navigation: (0, $74Zh5.css)({
        height: '16px',
        margin: "var(--ds-space-100, 8px)".concat(" -0.5px"),
        backgroundColor: "var(--ds-text-subtle, #0052cc)",
        opacity: 0.62
    })
};
var $8bdffda66d351be4$var$dividerRefreshedAppearance = $8bdffda66d351be4$var$_objectSpread($8bdffda66d351be4$var$_objectSpread({}, $8bdffda66d351be4$var$dividerAppearance), {}, {
    default: (0, $74Zh5.css)({
        backgroundColor: "var(--ds-border, #091E4224)"
    }),
    primary: (0, $74Zh5.css)({
        backgroundColor: "var(--ds-border-inverse, #FFF)",
        opacity: 0.64
    })
});
var $8bdffda66d351be4$var$dividerRefreshedOffsetStyles = (0, $74Zh5.css)({
    marginInline: "calc(0px - ".concat("var(--ds-border-width, 1px)", ")")
});
var $8bdffda66d351be4$var$dividerHeight = {
    default: (0, $74Zh5.css)({
        height: "".concat(32 / 14, "em")
    }),
    compact: (0, $74Zh5.css)({
        height: "".concat(24 / 14, "em")
    })
};
var $8bdffda66d351be4$var$dividerHeightWithRem = {
    default: (0, $74Zh5.css)({
        height: '2rem'
    }),
    compact: (0, $74Zh5.css)({
        height: '1.5rem'
    })
};
var $8bdffda66d351be4$var$defaultDividerHeight = {
    // The divider height is calculated by subtracting twice the border width from the button height.
    // This ensures the divider does not intersect with the button's border, avoiding visual issues
    // caused by overlapping alpha colors (color.border) at the intersection.
    default: (0, $74Zh5.css)({
        height: "calc(".concat(32 / 14, "em - ", "var(--ds-border-width, 1px)", " - ", "var(--ds-border-width, 1px)", ")")
    }),
    compact: (0, $74Zh5.css)({
        height: "calc(".concat(24 / 14, "em - ", "var(--ds-border-width, 1px)", " - ", "var(--ds-border-width, 1px)", ")")
    })
};
var $8bdffda66d351be4$var$defaultDividerHeightWithRem = {
    // The divider height is calculated by subtracting twice the border width from the button height.
    // This ensures the divider does not intersect with the button's border, avoiding visual issues
    // caused by overlapping alpha colors (color.border) at the intersection.
    default: (0, $74Zh5.css)({
        height: "calc(2rem - ".concat("var(--ds-border-width, 1px)", " - ", "var(--ds-border-width, 1px)", ")")
    }),
    compact: (0, $74Zh5.css)({
        height: "calc(1.5rem - ".concat("var(--ds-border-width, 1px)", " - ", "var(--ds-border-width, 1px)", ")")
    })
};
var $8bdffda66d351be4$export$2e0a83ec2e27ecbb = function Divider(_ref) {
    var appearance = _ref.appearance, spacing = _ref.spacing, _ref$isDisabled = _ref.isDisabled, isDisabled = _ref$isDisabled === void 0 ? false : _ref$isDisabled;
    // Pulling these out of the below `css` prop to avoid nested ternaries
    var defaultDividerHeightStyles = (0, $id6Cu.fg)('platform_dst_button_replace_em_with_rem') ? $8bdffda66d351be4$var$defaultDividerHeightWithRem : $8bdffda66d351be4$var$defaultDividerHeight;
    var dividerHeightStyles = (0, $id6Cu.fg)('platform_dst_button_replace_em_with_rem') ? $8bdffda66d351be4$var$dividerHeightWithRem : $8bdffda66d351be4$var$dividerHeight;
    return(// I find it funny to provide a div for Divider
    (0, $74Zh5.jsx)("div", {
        css: [
            $8bdffda66d351be4$var$baseDividerStyles,
            appearance === 'default' && !isDisabled && (0, $id6Cu.fg)('platform-component-visual-refresh') ? defaultDividerHeightStyles[spacing] : dividerHeightStyles[spacing],
            isDisabled && ((0, $id6Cu.fg)('platform-component-visual-refresh') ? $8bdffda66d351be4$var$dividerDisabledRefreshedStyles : $8bdffda66d351be4$var$dividerDisabledStyles),
            !isDisabled && ((0, $id6Cu.fg)('platform-component-visual-refresh') ? $8bdffda66d351be4$var$dividerRefreshedAppearance[appearance] : $8bdffda66d351be4$var$dividerAppearance[appearance]),
            (0, $id6Cu.fg)('platform-component-visual-refresh') && $8bdffda66d351be4$var$dividerRefreshedOffsetStyles
        ]
    }));
};
var $8bdffda66d351be4$var$splitButtonStyles = (0, $74Zh5.css)({
    display: 'inline-flex',
    position: 'relative',
    alignItems: 'center',
    whiteSpace: 'nowrap'
});
var $8bdffda66d351be4$var$primaryButtonStyles = (0, $74Zh5.css)({
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    'button,a': {
        borderEndEndRadius: 0,
        borderStartEndRadius: 0
    }
});
var $8bdffda66d351be4$var$secondaryButtonStyles = (0, $74Zh5.css)({
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    'button,a': {
        borderEndStartRadius: 0,
        borderStartStartRadius: 0
    }
});
var $8bdffda66d351be4$var$defaultAppearanceContainerStyles = (0, $74Zh5.css)({
    borderRadius: "var(--ds-border-radius, 3px)",
    outlineColor: "var(--ds-border, #091E4224)",
    outlineOffset: "calc(0px - ".concat("var(--ds-border-width, 1px)", ")"),
    outlineStyle: 'solid',
    outlineWidth: "var(--ds-border-width, 1px)"
});
var $8bdffda66d351be4$export$994ba1b4c598f7 = function SplitButtonContainer(_ref2) {
    var appearance = _ref2.appearance, children = _ref2.children, _ref2$isDisabled = _ref2.isDisabled, isDisabled = _ref2$isDisabled === void 0 ? false : _ref2$isDisabled;
    return (0, $74Zh5.jsx)("div", {
        css: [
            appearance === 'default' && !isDisabled && (0, $id6Cu.fg)('platform-component-visual-refresh') && $8bdffda66d351be4$var$defaultAppearanceContainerStyles,
            $8bdffda66d351be4$var$splitButtonStyles
        ]
    }, children);
};
var $8bdffda66d351be4$export$651ad66661acd392 = function SplitButton(_ref3) {
    var children = _ref3.children, _ref3$appearance = _ref3.appearance, appearance = _ref3$appearance === void 0 ? 'default' : _ref3$appearance, _ref3$spacing = _ref3.spacing, spacing = _ref3$spacing === void 0 ? 'default' : _ref3$spacing, _ref3$isDisabled = _ref3.isDisabled, isDisabled = _ref3$isDisabled === void 0 ? false : _ref3$isDisabled;
    var _getActions = (0, $7RmFb.getActions)(children), PrimaryAction = _getActions.PrimaryAction, SecondaryAction = _getActions.SecondaryAction;
    return (0, $74Zh5.jsx)($8bdffda66d351be4$export$994ba1b4c598f7, {
        appearance: appearance,
        isDisabled: isDisabled
    }, (0, $74Zh5.jsx)((0, $7OBJ1.SplitButtonContext).Provider, {
        value: {
            appearance: appearance,
            spacing: spacing,
            isDisabled: isDisabled
        }
    }, (0, $74Zh5.jsx)("div", {
        css: $8bdffda66d351be4$var$primaryButtonStyles
    }, PrimaryAction), (0, $74Zh5.jsx)($8bdffda66d351be4$export$2e0a83ec2e27ecbb, {
        appearance: appearance,
        spacing: spacing,
        isDisabled: isDisabled
    }), (0, $74Zh5.jsx)("div", {
        css: $8bdffda66d351be4$var$secondaryButtonStyles
    }, SecondaryAction)));
};
var $8bdffda66d351be4$export$e3ca81100b492e15 = function SplitButtonWithSlots(_ref4) {
    var primaryAction = _ref4.primaryAction, secondaryAction = _ref4.secondaryAction, _ref4$appearance = _ref4.appearance, appearance = _ref4$appearance === void 0 ? 'default' : _ref4$appearance, _ref4$spacing = _ref4.spacing, spacing = _ref4$spacing === void 0 ? 'default' : _ref4$spacing, _ref4$isDisabled = _ref4.isDisabled, isDisabled = _ref4$isDisabled === void 0 ? false : _ref4$isDisabled;
    return (0, $74Zh5.jsx)($8bdffda66d351be4$export$994ba1b4c598f7, {
        appearance: appearance,
        isDisabled: isDisabled
    }, (0, $74Zh5.jsx)((0, $7OBJ1.SplitButtonContext).Provider, {
        value: {
            appearance: appearance,
            spacing: spacing,
            isDisabled: isDisabled
        }
    }, (0, $74Zh5.jsx)("div", {
        css: $8bdffda66d351be4$var$primaryButtonStyles
    }, primaryAction), (0, $74Zh5.jsx)($8bdffda66d351be4$export$2e0a83ec2e27ecbb, {
        appearance: appearance,
        spacing: spacing,
        isDisabled: isDisabled
    }), (0, $74Zh5.jsx)("div", {
        css: $8bdffda66d351be4$var$secondaryButtonStyles
    }, secondaryAction)));
};

});
parcelRegister("7RmFb", function(module, exports) {
$parcel$export(module.exports, "getActions", () => $5b8f101d545dd71b$export$fe3955935f564b31);

var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");

var $3ZMUU = parcelRequire("3ZMUU");
var $5b8f101d545dd71b$export$fe3955935f564b31 = function getActions(children) {
    var _Children$toArray = (0, $5FkrB.Children).toArray(children), _Children$toArray2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_Children$toArray, 2), PrimaryAction = _Children$toArray2[0], SecondaryAction = _Children$toArray2[1];
    typeof $3ZMUU;
    return {
        PrimaryAction: PrimaryAction,
        SecondaryAction: SecondaryAction
    };
};

});



parcelRegister("4qBHc", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $3396d4b8d139bb82$var$Environment;
(function(Environment) {
    Environment["TEST"] = "test";
    Environment["LOCAL"] = "local";
    Environment["DEV"] = "dev";
    Environment["STAGE"] = "stage";
    Environment["PROD"] = "prod";
})($3396d4b8d139bb82$var$Environment = module.exports.Environment || (module.exports.Environment = {}));
var $3396d4b8d139bb82$var$XIDItemType;
(function(XIDItemType) {
    XIDItemType["XC"] = "xc";
    XIDItemType["UID"] = "uid";
})($3396d4b8d139bb82$var$XIDItemType = module.exports.XIDItemType || (module.exports.XIDItemType = {}));
var $3396d4b8d139bb82$var$XIDState;
(function(XIDState) {
    XIDState["NEW"] = "NEW";
    XIDState["CHANGED"] = "CHANGED";
    XIDState["EXISTING"] = "EXISTING";
    XIDState["TIMEOUT"] = "TIMEOUT";
    XIDState["ERROR"] = "ERROR";
    XIDState["UNAVAILABLE"] = "UNAVAILABLE";
    XIDState["MALFORMED"] = "MALFORMED";
    XIDState["UNKNOWN"] = "UNKNOWN";
})($3396d4b8d139bb82$var$XIDState = module.exports.XIDState || (module.exports.XIDState = {}));
var $3396d4b8d139bb82$var$XIDGenerateMode;
(function(XIDGenerateMode) {
    XIDGenerateMode["XC_ONLY"] = "XC_ONLY";
    XIDGenerateMode["UID_ONLY"] = "UID_ONLY";
    XIDGenerateMode["CACHE_ONLY"] = "CACHE_ONLY";
    XIDGenerateMode["XC_UID"] = "XC_UID";
    XIDGenerateMode["CACHE_XC_UID"] = "CACHE_XC_UID";
})($3396d4b8d139bb82$var$XIDGenerateMode = module.exports.XIDGenerateMode || (module.exports.XIDGenerateMode = {}));

});

parcelRegister("7UOcZ", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $5c34b5b787a35ef6$export$2e2bcd8739ae039);

var $1lpW0 = parcelRequire("1lpW0");

var $7Apz3 = parcelRequire("7Apz3");

var $a301b = parcelRequire("a301b");
// Store setTimeout reference so promise-polyfill will be unaffected by
// other code modifying setTimeout (like sinon.useFakeTimers())
var $5c34b5b787a35ef6$var$setTimeoutFunc = setTimeout;
function $5c34b5b787a35ef6$var$isArray(x) {
    return Boolean(x && typeof x.length !== 'undefined');
}
function $5c34b5b787a35ef6$var$noop() {}
// Polyfill for Function.prototype.bind
function $5c34b5b787a35ef6$var$bind(fn, thisArg) {
    return function() {
        fn.apply(thisArg, arguments);
    };
}
/**
 * @constructor
 * @param {Function} fn
 */ function $5c34b5b787a35ef6$var$Promise(fn) {
    if (!(this instanceof $5c34b5b787a35ef6$var$Promise)) throw new TypeError('Promises must be constructed via new');
    if (typeof fn !== 'function') throw new TypeError('not a function');
    /** @type {!number} */ this._state = 0;
    /** @type {!boolean} */ this._handled = false;
    /** @type {Promise|undefined} */ this._value = undefined;
    /** @type {!Array<!Function>} */ this._deferreds = [];
    $5c34b5b787a35ef6$var$doResolve(fn, this);
}
function $5c34b5b787a35ef6$var$handle(self, deferred) {
    while(self._state === 3)self = self._value;
    if (self._state === 0) {
        self._deferreds.push(deferred);
        return;
    }
    self._handled = true;
    $5c34b5b787a35ef6$var$Promise._immediateFn(function() {
        var cb = self._state === 1 ? deferred.onFulfilled : deferred.onRejected;
        if (cb === null) {
            (self._state === 1 ? $5c34b5b787a35ef6$var$resolve : $5c34b5b787a35ef6$var$reject)(deferred.promise, self._value);
            return;
        }
        var ret;
        try {
            ret = cb(self._value);
        } catch (e) {
            $5c34b5b787a35ef6$var$reject(deferred.promise, e);
            return;
        }
        $5c34b5b787a35ef6$var$resolve(deferred.promise, ret);
    });
}
function $5c34b5b787a35ef6$var$resolve(self, newValue) {
    try {
        // Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
        if (newValue === self) throw new TypeError('A promise cannot be resolved with itself.');
        if (newValue && (typeof newValue === 'object' || typeof newValue === 'function')) {
            var then = newValue.then;
            if (newValue instanceof $5c34b5b787a35ef6$var$Promise) {
                self._state = 3;
                self._value = newValue;
                $5c34b5b787a35ef6$var$finale(self);
                return;
            } else if (typeof then === 'function') {
                $5c34b5b787a35ef6$var$doResolve($5c34b5b787a35ef6$var$bind(then, newValue), self);
                return;
            }
        }
        self._state = 1;
        self._value = newValue;
        $5c34b5b787a35ef6$var$finale(self);
    } catch (e) {
        $5c34b5b787a35ef6$var$reject(self, e);
    }
}
function $5c34b5b787a35ef6$var$reject(self, newValue) {
    self._state = 2;
    self._value = newValue;
    $5c34b5b787a35ef6$var$finale(self);
}
function $5c34b5b787a35ef6$var$finale(self) {
    if (self._state === 2 && self._deferreds.length === 0) $5c34b5b787a35ef6$var$Promise._immediateFn(function() {
        if (!self._handled) $5c34b5b787a35ef6$var$Promise._unhandledRejectionFn(self._value);
    });
    for(var i = 0, len = self._deferreds.length; i < len; i++)$5c34b5b787a35ef6$var$handle(self, self._deferreds[i]);
    self._deferreds = null;
}
/**
 * @constructor
 */ function $5c34b5b787a35ef6$var$Handler(onFulfilled, onRejected, promise) {
    this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
    this.onRejected = typeof onRejected === 'function' ? onRejected : null;
    this.promise = promise;
}
/**
 * Take a potentially misbehaving resolver function and make sure
 * onFulfilled and onRejected are only called once.
 *
 * Makes no guarantees about asynchrony.
 */ function $5c34b5b787a35ef6$var$doResolve(fn, self) {
    var done = false;
    try {
        fn(function(value) {
            if (done) return;
            done = true;
            $5c34b5b787a35ef6$var$resolve(self, value);
        }, function(reason) {
            if (done) return;
            done = true;
            $5c34b5b787a35ef6$var$reject(self, reason);
        });
    } catch (ex) {
        if (done) return;
        done = true;
        $5c34b5b787a35ef6$var$reject(self, ex);
    }
}
$5c34b5b787a35ef6$var$Promise.prototype['catch'] = function(onRejected) {
    return this.then(null, onRejected);
};
$5c34b5b787a35ef6$var$Promise.prototype.then = function(onFulfilled, onRejected) {
    // @ts-ignore
    var prom = new this.constructor($5c34b5b787a35ef6$var$noop);
    $5c34b5b787a35ef6$var$handle(this, new $5c34b5b787a35ef6$var$Handler(onFulfilled, onRejected, prom));
    return prom;
};
$5c34b5b787a35ef6$var$Promise.prototype['finally'] = (0, $1lpW0.default);
$5c34b5b787a35ef6$var$Promise.all = function(arr) {
    return new $5c34b5b787a35ef6$var$Promise(function(resolve, reject) {
        if (!$5c34b5b787a35ef6$var$isArray(arr)) return reject(new TypeError('Promise.all accepts an array'));
        var args = Array.prototype.slice.call(arr);
        if (args.length === 0) return resolve([]);
        var remaining = args.length;
        function res(i, val) {
            try {
                if (val && (typeof val === 'object' || typeof val === 'function')) {
                    var then = val.then;
                    if (typeof then === 'function') {
                        then.call(val, function(val) {
                            res(i, val);
                        }, reject);
                        return;
                    }
                }
                args[i] = val;
                if (--remaining === 0) resolve(args);
            } catch (ex) {
                reject(ex);
            }
        }
        for(var i = 0; i < args.length; i++)res(i, args[i]);
    });
};
$5c34b5b787a35ef6$var$Promise.any = (0, $a301b.default);
$5c34b5b787a35ef6$var$Promise.allSettled = (0, $7Apz3.default);
$5c34b5b787a35ef6$var$Promise.resolve = function(value) {
    if (value && typeof value === 'object' && value.constructor === $5c34b5b787a35ef6$var$Promise) return value;
    return new $5c34b5b787a35ef6$var$Promise(function(resolve) {
        resolve(value);
    });
};
$5c34b5b787a35ef6$var$Promise.reject = function(value) {
    return new $5c34b5b787a35ef6$var$Promise(function(resolve, reject) {
        reject(value);
    });
};
$5c34b5b787a35ef6$var$Promise.race = function(arr) {
    return new $5c34b5b787a35ef6$var$Promise(function(resolve, reject) {
        if (!$5c34b5b787a35ef6$var$isArray(arr)) return reject(new TypeError('Promise.race accepts an array'));
        for(var i = 0, len = arr.length; i < len; i++)$5c34b5b787a35ef6$var$Promise.resolve(arr[i]).then(resolve, reject);
    });
};
// Use polyfill for setImmediate for performance gains
$5c34b5b787a35ef6$var$Promise._immediateFn = // @ts-ignore
typeof setImmediate === 'function' && function(fn) {
    // @ts-ignore
    setImmediate(fn);
} || function(fn) {
    $5c34b5b787a35ef6$var$setTimeoutFunc(fn, 0);
};
$5c34b5b787a35ef6$var$Promise._unhandledRejectionFn = function _unhandledRejectionFn(err) {
    if (typeof console !== 'undefined' && console) console.warn('Possible Unhandled Promise Rejection:', err); // eslint-disable-line no-console
};
var $5c34b5b787a35ef6$export$2e2bcd8739ae039 = $5c34b5b787a35ef6$var$Promise;

});
parcelRegister("1lpW0", function(module, exports) {
$parcel$export(module.exports, "default", () => $0fabdea6eb005102$export$2e2bcd8739ae039);
/**
 * @this {Promise}
 */ function $0fabdea6eb005102$var$finallyConstructor(callback) {
    var constructor = this.constructor;
    return this.then(function(value) {
        // @ts-ignore
        return constructor.resolve(callback()).then(function() {
            return value;
        });
    }, function(reason) {
        // @ts-ignore
        return constructor.resolve(callback()).then(function() {
            // @ts-ignore
            return constructor.reject(reason);
        });
    });
}
var $0fabdea6eb005102$export$2e2bcd8739ae039 = $0fabdea6eb005102$var$finallyConstructor;

});

parcelRegister("7Apz3", function(module, exports) {
$parcel$export(module.exports, "default", () => $585fb9c186935d92$export$2e2bcd8739ae039);
function $585fb9c186935d92$var$allSettled(arr) {
    var P = this;
    return new P(function(resolve, reject) {
        if (!(arr && typeof arr.length !== 'undefined')) return reject(new TypeError(typeof arr + ' ' + arr + ' is not iterable(cannot read property Symbol(Symbol.iterator))'));
        var args = Array.prototype.slice.call(arr);
        if (args.length === 0) return resolve([]);
        var remaining = args.length;
        function res(i, val) {
            if (val && (typeof val === 'object' || typeof val === 'function')) {
                var then = val.then;
                if (typeof then === 'function') {
                    then.call(val, function(val) {
                        res(i, val);
                    }, function(e) {
                        args[i] = {
                            status: 'rejected',
                            reason: e
                        };
                        if (--remaining === 0) resolve(args);
                    });
                    return;
                }
            }
            args[i] = {
                status: 'fulfilled',
                value: val
            };
            if (--remaining === 0) resolve(args);
        }
        for(var i = 0; i < args.length; i++)res(i, args[i]);
    });
}
var $585fb9c186935d92$export$2e2bcd8739ae039 = $585fb9c186935d92$var$allSettled;

});

parcelRegister("a301b", function(module, exports) {
$parcel$export(module.exports, "default", () => $750a32cd72385239$export$2e2bcd8739ae039);
/**
 * @constructor
 */ function $750a32cd72385239$var$AggregateError(errors, message) {
    this.name = 'AggregateError', this.errors = errors;
    this.message = message || '';
}
$750a32cd72385239$var$AggregateError.prototype = Error.prototype;
function $750a32cd72385239$var$any(arr) {
    var P = this;
    return new P(function(resolve, reject) {
        if (!(arr && typeof arr.length !== 'undefined')) return reject(new TypeError('Promise.any accepts an array'));
        var args = Array.prototype.slice.call(arr);
        if (args.length === 0) return reject();
        var rejectionReasons = [];
        for(var i = 0; i < args.length; i++)try {
            P.resolve(args[i]).then(resolve).catch(function(error) {
                rejectionReasons.push(error);
                if (rejectionReasons.length === args.length) reject(new $750a32cd72385239$var$AggregateError(rejectionReasons, 'All promises were rejected'));
            });
        } catch (ex) {
            reject(ex);
        }
    });
}
var $750a32cd72385239$export$2e2bcd8739ae039 = $750a32cd72385239$var$any;

});


parcelRegister("iNMs5", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::03f86cbf4091cea96938f1feb145f315>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $db026324fec9f32b$var$_react = $db026324fec9f32b$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $db026324fec9f32b$var$_UNSAFE_baseNew = $db026324fec9f32b$var$_interopRequireDefault((parcelRequire("kjkwu")));
function $db026324fec9f32b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Close".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for closing an element.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $db026324fec9f32b$var$CloseIcon = (props)=>/*#__PURE__*/ $db026324fec9f32b$var$_react.default.createElement($db026324fec9f32b$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M2.5 13.5 8 8m5.5-5.5L8 8m0 0L2.5 2.5M8 8l5.5 5.5"/>`
    }, props));
$db026324fec9f32b$var$CloseIcon.displayName = 'CloseIcon';
var $db026324fec9f32b$var$_default = module.exports.default = $db026324fec9f32b$var$CloseIcon;

});
parcelRegister("kjkwu", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => (parcelRequire("coD2y")).default);
$parcel$export(module.exports, "Icon", () => (parcelRequire("coD2y")).Icon);

var $coD2y = parcelRequire("coD2y");

});
parcelRegister("coD2y", function(module, exports) {
$parcel$export(module.exports, "Icon", () => $9066027fdce76dd6$export$f04a61298a47a40f);
$parcel$export(module.exports, "default", () => $9066027fdce76dd6$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5FkrB = parcelRequire("5FkrB");

var $74Zh5 = parcelRequire("74Zh5");

var $auUAM = parcelRequire("auUAM");
/**
 * We are hiding this props from consumers as it's reserved
 * for use by Icon Tile.
 */ var $9066027fdce76dd6$var$commonSVGStyles = (0, $74Zh5.css)({
    overflow: 'hidden',
    pointerEvents: 'none',
    /**
   * Stop-color doesn't properly apply in chrome when the inherited/current color changes.
   * We have to initially set stop-color to inherit (either via DOM attribute or an initial CSS
   * rule) and then override it with currentColor for the color changes to be picked up.
   */ // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    stop: {
        stopColor: 'currentColor'
    }
});
var $9066027fdce76dd6$var$svgStyles = (0, $74Zh5.css)({
    color: 'currentColor',
    verticalAlign: 'bottom'
});
var $9066027fdce76dd6$var$iconStyles = (0, $74Zh5.css)({
    display: 'inline-block',
    boxSizing: 'border-box',
    flexShrink: 0,
    lineHeight: 1,
    paddingInlineEnd: 'var(--ds--button--new-icon-padding-end, 0)',
    paddingInlineStart: 'var(--ds--button--new-icon-padding-start, 0)'
});
var $9066027fdce76dd6$var$utilityIconStyles = (0, $74Zh5.css)({
    lineHeight: "var(--ds-space-150, 12px)"
});
var $9066027fdce76dd6$var$scaleStyles = (0, $74Zh5.css)({
    width: 'inherit',
    height: 'inherit'
});
/**
 * For windows high contrast mode
 */ var $9066027fdce76dd6$var$baseHcmStyles = (0, $74Zh5.css)({
    '@media screen and (forced-colors: active)': {
        color: 'CanvasText',
        filter: 'grayscale(1)'
    }
});
var $9066027fdce76dd6$var$scaleSize = (0, $74Zh5.css)({
    width: 'inherit',
    height: 'inherit'
});
var $9066027fdce76dd6$var$sizeMap = {
    core: {
        none: (0, $74Zh5.css)({
            width: "var(--ds-space-200, 16px)",
            height: "var(--ds-space-200, 16px)"
        }),
        spacious: (0, $74Zh5.css)({
            width: "var(--ds-space-300, 24px)",
            height: "var(--ds-space-300, 24px)"
        })
    },
    utility: {
        none: (0, $74Zh5.css)({
            width: "var(--ds-space-150, 12px)",
            height: "var(--ds-space-150, 12px)"
        }),
        compact: (0, $74Zh5.css)({
            width: "var(--ds-space-200, 16px)",
            height: "var(--ds-space-200, 16px)"
        }),
        spacious: (0, $74Zh5.css)({
            width: "var(--ds-space-300, 24px)",
            height: "var(--ds-space-300, 24px)"
        })
    }
};
var $9066027fdce76dd6$var$baseSizeMap = {
    core: 16,
    utility: 12
};
var $9066027fdce76dd6$var$paddingMap = {
    core: {
        none: 0,
        spacious: 4
    },
    utility: {
        none: 0,
        compact: 2,
        spacious: 6
    }
};
var $9066027fdce76dd6$export$f04a61298a47a40f = /*#__PURE__*/ (0, $5FkrB.memo)(function Icon(props) {
    var _props$type, _props$spacing3, _props$spacing4;
    var _ref = props, _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, testId = _ref.testId, label = _ref.label, LEGACY_primaryColor = _ref.LEGACY_primaryColor, LEGACY_secondaryColor = _ref.LEGACY_secondaryColor, LEGACY_size = _ref.LEGACY_size, FallbackIcon = _ref.LEGACY_fallbackIcon, dangerouslySetGlyph = _ref.dangerouslySetGlyph, shouldScale = _ref.shouldScale, LEGACY_margin = _ref.LEGACY_margin;
    var dangerouslySetInnerHTML = dangerouslySetGlyph ? {
        __html: dangerouslySetGlyph
    } : undefined;
    // Fall back to old icon
    if (FallbackIcon && !(0, $auUAM.fg)('platform-visual-refresh-icons')) // parse out unnecessary props
    return (0, $74Zh5.jsx)(FallbackIcon, {
        primaryColor: LEGACY_primaryColor !== null && LEGACY_primaryColor !== void 0 ? LEGACY_primaryColor : color,
        secondaryColor: LEGACY_secondaryColor,
        size: LEGACY_size,
        label: label,
        testId: testId,
        UNSAFE_margin: LEGACY_margin
    });
    var baseSize = $9066027fdce76dd6$var$baseSizeMap[(_props$type = props.type) !== null && _props$type !== void 0 ? _props$type : 'core'];
    var viewBoxPadding;
    if (props.type === 'utility') {
        var _props$spacing;
        viewBoxPadding = $9066027fdce76dd6$var$paddingMap[props.type][(_props$spacing = props.spacing) !== null && _props$spacing !== void 0 ? _props$spacing : 'none'];
    } else {
        var _props$spacing2;
        viewBoxPadding = $9066027fdce76dd6$var$paddingMap['core'][(_props$spacing2 = props.spacing) !== null && _props$spacing2 !== void 0 ? _props$spacing2 : 'none'];
    }
    var viewBoxSize = baseSize + 2 * viewBoxPadding;
    // Workaround for the transparency in our disabled icon token.
    // Because we have multiple strokes in icons, opacities overlap
    // This filter has an impact on render performance, but this is
    // acceptable as icons aren't commonly disabled en-masse
    var iconColor = color;
    if (dangerouslySetInnerHTML && color === "var(--ds-icon-disabled, #091E424F)") {
        dangerouslySetInnerHTML.__html = "\n<filter id=\"ds-newIconOpacityFilter\">\n  <feFlood flood-color=\"var(--ds-icon-disabled)\" />\n  <feComposite in2=\"SourceGraphic\" operator=\"in\" />\n</filter>\n<g filter=\"url(#ds-newIconOpacityFilter)\">\n  ".concat(dangerouslySetInnerHTML.__html, "\n</g>");
        iconColor = "var(--ds-icon, #44546F)";
    }
    return (0, $74Zh5.jsx)("span", {
        "data-testid": testId,
        role: label ? 'img' : undefined,
        "aria-label": label ? label : undefined,
        "aria-hidden": label ? undefined : true,
        style: {
            color: iconColor
        },
        css: [
            $9066027fdce76dd6$var$iconStyles,
            $9066027fdce76dd6$var$baseHcmStyles,
            shouldScale && $9066027fdce76dd6$var$scaleStyles,
            props.type === 'utility' && $9066027fdce76dd6$var$utilityIconStyles
        ]
    }, (0, $74Zh5.jsx)("svg", {
        fill: "none",
        viewBox: "".concat(0 - viewBoxPadding, " ").concat(0 - viewBoxPadding, " ").concat(viewBoxSize, " ").concat(viewBoxSize),
        role: "presentation",
        css: [
            $9066027fdce76dd6$var$commonSVGStyles,
            $9066027fdce76dd6$var$svgStyles,
            shouldScale ? $9066027fdce76dd6$var$scaleSize : props.type === 'utility' ? $9066027fdce76dd6$var$sizeMap[props.type][(_props$spacing3 = props.spacing) !== null && _props$spacing3 !== void 0 ? _props$spacing3 : 'none'] : $9066027fdce76dd6$var$sizeMap['core'][(_props$spacing4 = props.spacing) !== null && _props$spacing4 !== void 0 ? _props$spacing4 : 'none']
        ],
        dangerouslySetInnerHTML: dangerouslySetInnerHTML
    }));
});
var $9066027fdce76dd6$export$2e2bcd8739ae039 = $9066027fdce76dd6$export$f04a61298a47a40f;

});
parcelRegister("auUAM", function(module, exports) {
$parcel$export(module.exports, "fg", () => $7a489ac3fd57d9f4$export$b40ec24ac8275656);

var $kpIM0 = parcelRequire("kpIM0");
function $7a489ac3fd57d9f4$export$ba05d765b8392e5e(flagResolver) {
    (0, $kpIM0.setBooleanResolver)(flagResolver);
}
function $7a489ac3fd57d9f4$export$470e5c2be1411c89(name) {
    return (0, $kpIM0.resolveBooleanFlag)(name);
}
function $7a489ac3fd57d9f4$export$b40ec24ac8275656(name) {
    return (0, $kpIM0.resolveBooleanFlag)(name);
}

});
parcelRegister("kpIM0", function(module, exports) {
$parcel$export(module.exports, "setBooleanResolver", () => $edc8df7af758cd89$export$f2b591175b3e424c);
$parcel$export(module.exports, "resolveBooleanFlag", () => $edc8df7af758cd89$export$6333b6aff9fc6275);

var $1RYVj = parcelRequire("1RYVj");

var $3ZMUU = parcelRequire("3ZMUU");
var $edc8df7af758cd89$var$pkgName = '@atlaskit/platform-feature-flags';
var $edc8df7af758cd89$export$7e41b1b2bdee3f98 = '__PLATFORM_FEATURE_FLAGS__';
var $edc8df7af758cd89$var$hasProcessEnv = typeof $3ZMUU !== 'undefined' && typeof $3ZMUU.env !== 'undefined';
// FF global overrides can be configured by test runners or Storybook
var $edc8df7af758cd89$var$ENV_ENABLE_PLATFORM_FF = $edc8df7af758cd89$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
// STORYBOOK_ENABLE_PLATFORM_FF is included as storybook only allows env vars prefixed with STORYBOOK
// https://github.com/storybookjs/storybook/issues/12270
var $edc8df7af758cd89$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF = $edc8df7af758cd89$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
var $edc8df7af758cd89$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE = $edc8df7af758cd89$var$ENV_ENABLE_PLATFORM_FF || $edc8df7af758cd89$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF;
var $edc8df7af758cd89$var$DEFAULT_PFF_GLOBAL = {
    // In development mode we want to capture any feature flag checks that happen using the default resolver and log this result when the resolver is replaced.
    // This is because evaluating feature flags when the resolver/FF client is loaded asynchronously could cause unexpected issues.
    earlyResolvedFlags: new Map(),
    booleanResolver: function booleanResolver(flagKey) {
        var unresolvedFlagCount;
        return false;
    }
};
var $edc8df7af758cd89$var$globalVar = typeof window !== 'undefined' ? window : globalThis;
$edc8df7af758cd89$var$globalVar[$edc8df7af758cd89$export$7e41b1b2bdee3f98] = $edc8df7af758cd89$var$globalVar[$edc8df7af758cd89$export$7e41b1b2bdee3f98] || $edc8df7af758cd89$var$DEFAULT_PFF_GLOBAL;
function $edc8df7af758cd89$export$f2b591175b3e424c(resolver) {
    $edc8df7af758cd89$var$globalVar[$edc8df7af758cd89$export$7e41b1b2bdee3f98].booleanResolver = resolver;
    var _globalVar$PFF_GLOBAL;
}
function $edc8df7af758cd89$export$6333b6aff9fc6275(flagKey) {
    if ($edc8df7af758cd89$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE) {
        (0, $1RYVj.debug)('[%s]: The feature flags were enabled while running tests. The flag "%s" will be always enabled.', $edc8df7af758cd89$var$pkgName, flagKey);
        return true;
    }
    try {
        var _globalVar$PFF_GLOBAL2;
        var result = (_globalVar$PFF_GLOBAL2 = $edc8df7af758cd89$var$globalVar[$edc8df7af758cd89$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL2 === void 0 ? void 0 : _globalVar$PFF_GLOBAL2.booleanResolver(flagKey);
        if (typeof result !== 'boolean') {
            // eslint-disable-next-line no-console
            console.warn("".concat(flagKey, " resolved to a non-boolean value, returning false for safety"));
            return false;
        }
        return result;
    } catch (e) {
        return false;
    }
}

});
parcelRegister("1RYVj", function(module, exports) {
$parcel$export(module.exports, "debug", () => $15c9ffd0ef8af79d$export$1c9f709888824e05);
var $15c9ffd0ef8af79d$var$_ref, $15c9ffd0ef8af79d$var$_process, $15c9ffd0ef8af79d$var$_process2;
// We can't rely on NODE_ENV === 'test' if its value is already configured by the consumer to some other value, so better to use JEST_WORKER_ID
// https://jestjs.io/docs/environment-variables#jest_worker_id
var $15c9ffd0ef8af79d$var$TESTS_MODE = ($15c9ffd0ef8af79d$var$_ref = (globalThis === null || globalThis === void 0 || ($15c9ffd0ef8af79d$var$_process = globalThis.process) === null || $15c9ffd0ef8af79d$var$_process === void 0 || ($15c9ffd0ef8af79d$var$_process = $15c9ffd0ef8af79d$var$_process.env) === null || $15c9ffd0ef8af79d$var$_process === void 0 ? void 0 : $15c9ffd0ef8af79d$var$_process.JEST_WORKER_ID) !== undefined, $15c9ffd0ef8af79d$var$_ref !== void 0) ? $15c9ffd0ef8af79d$var$_ref : false;
var $15c9ffd0ef8af79d$var$DEBUG_MODE = !$15c9ffd0ef8af79d$var$TESTS_MODE && (globalThis === null || globalThis === void 0 || ($15c9ffd0ef8af79d$var$_process2 = globalThis.process) === null || $15c9ffd0ef8af79d$var$_process2 === void 0 || ($15c9ffd0ef8af79d$var$_process2 = $15c9ffd0ef8af79d$var$_process2.env) === null || $15c9ffd0ef8af79d$var$_process2 === void 0 ? void 0 : $15c9ffd0ef8af79d$var$_process2.NODE_ENV) !== 'production';
var $15c9ffd0ef8af79d$export$1c9f709888824e05 = function debug() {
    var _console;
    if (!$15c9ffd0ef8af79d$var$DEBUG_MODE) return;
    // eslint-disable-next-line no-console
    (_console = console).debug.apply(_console, arguments);
};

});






parcelRegister("kdnK6", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6bfe67a5a24a2dcfb0853d331aeb2068>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $eb7770551a9b109e$var$_react = $eb7770551a9b109e$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $eb7770551a9b109e$var$_UNSAFE_baseNew = $eb7770551a9b109e$var$_interopRequireDefault((parcelRequire("kjkwu")));
function $eb7770551a9b109e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "ArrowUpRight".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $eb7770551a9b109e$var$ArrowUpRightIcon = (props)=>/*#__PURE__*/ $eb7770551a9b109e$var$_react.default.createElement($eb7770551a9b109e$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="m3 13 9.25-9.25m-6.5-.5h7v7"/>`
    }, props));
$eb7770551a9b109e$var$ArrowUpRightIcon.displayName = 'ArrowUpRightIcon';
var $eb7770551a9b109e$var$_default = module.exports.default = $eb7770551a9b109e$var$ArrowUpRightIcon;

});

parcelRegister("6KNbq", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d8cb0749e395cf6d25ab2f6745905850>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4ead30ba2e8349f9$var$_react = $4ead30ba2e8349f9$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $4ead30ba2e8349f9$var$_UNSAFE_baseNew = $4ead30ba2e8349f9$var$_interopRequireDefault((parcelRequire("kjkwu")));
function $4ead30ba2e8349f9$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Download".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for file downloads.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $4ead30ba2e8349f9$var$DownloadIcon = (props)=>/*#__PURE__*/ $4ead30ba2e8349f9$var$_react.default.createElement($4ead30ba2e8349f9$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M1.75 9v4c0 .69.56 1.25 1.25 1.25h10c.69 0 1.25-.56 1.25-1.25V9M8 1v8.75m-4-3.5 4 4 4-4"/>`
    }, props));
$4ead30ba2e8349f9$var$DownloadIcon.displayName = 'DownloadIcon';
var $4ead30ba2e8349f9$var$_default = module.exports.default = $4ead30ba2e8349f9$var$DownloadIcon;

});

parcelRegister("lD59F", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d611fb3947c00fee344914368e144168>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $fbf13d25122b42ab$var$_react = $fbf13d25122b42ab$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $fbf13d25122b42ab$var$_UNSAFE_baseNew = $fbf13d25122b42ab$var$_interopRequireDefault((parcelRequire("kjkwu")));
function $fbf13d25122b42ab$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Location".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: location in Atlas.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $fbf13d25122b42ab$var$LocationIcon = (props)=>/*#__PURE__*/ $fbf13d25122b42ab$var$_react.default.createElement($fbf13d25122b42ab$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M3.677 8.982 8 15.25l4.323-6.268C14.725 5.5 12.232.75 8 .75c-4.231 0-6.725 4.749-4.323 8.232Z"/><path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M9.75 6a1.75 1.75 0 1 1-3.5 0 1.75 1.75 0 0 1 3.5 0Z"/>`
    }, props));
$fbf13d25122b42ab$var$LocationIcon.displayName = 'LocationIcon';
var $fbf13d25122b42ab$var$_default = module.exports.default = $fbf13d25122b42ab$var$LocationIcon;

});

parcelRegister("jzoQw", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::28198ce9e0c3202094e2855b88c09086>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e3f48f1d9a562e5a$var$_react = $e3f48f1d9a562e5a$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $e3f48f1d9a562e5a$var$_UNSAFE_baseNew = $e3f48f1d9a562e5a$var$_interopRequireDefault((parcelRequire("kjkwu")));
function $e3f48f1d9a562e5a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Add".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for creating and adding an object.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $e3f48f1d9a562e5a$var$AddIcon = (props)=>/*#__PURE__*/ $e3f48f1d9a562e5a$var$_react.default.createElement($e3f48f1d9a562e5a$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-width="1.5" d="M8 8h7M8 8H1m7 0V1m0 7v7"/>`
    }, props));
$e3f48f1d9a562e5a$var$AddIcon.displayName = 'AddIcon';
var $e3f48f1d9a562e5a$var$_default = module.exports.default = $e3f48f1d9a562e5a$var$AddIcon;

});

parcelRegister("8h205", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d8eff4e7c48a4dd161566c1dd735476d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6061767e1b940a73$var$_react = $6061767e1b940a73$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $6061767e1b940a73$var$_UNSAFE_baseNew = $6061767e1b940a73$var$_interopRequireDefault((parcelRequire("kjkwu")));
function $6061767e1b940a73$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "ArrowLeft".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: back to previous screen, previous slide.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $6061767e1b940a73$var$ArrowLeftIcon = (props)=>/*#__PURE__*/ $6061767e1b940a73$var$_react.default.createElement($6061767e1b940a73$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M15 8H2.25m4.5-5-5 5 5 5"/>`
    }, props));
$6061767e1b940a73$var$ArrowLeftIcon.displayName = 'ArrowLeftIcon';
var $6061767e1b940a73$var$_default = module.exports.default = $6061767e1b940a73$var$ArrowLeftIcon;

});

parcelRegister("gNhoZ", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6a0af1361c1c47b464cd1f3e8c2b50c2>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c39eb8a5dd4980fe$var$_react = $c39eb8a5dd4980fe$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $c39eb8a5dd4980fe$var$_UNSAFE_baseNew = $c39eb8a5dd4980fe$var$_interopRequireDefault((parcelRequire("kjkwu")));
function $c39eb8a5dd4980fe$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "ArrowRight".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: link to nested menu item, a linked menu item, next slide.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c39eb8a5dd4980fe$var$ArrowRightIcon = (props)=>/*#__PURE__*/ $c39eb8a5dd4980fe$var$_react.default.createElement($c39eb8a5dd4980fe$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M1 8h12.75m-4.5-5 5 5-5 5"/>`
    }, props));
$c39eb8a5dd4980fe$var$ArrowRightIcon.displayName = 'ArrowRightIcon';
var $c39eb8a5dd4980fe$var$_default = module.exports.default = $c39eb8a5dd4980fe$var$ArrowRightIcon;

});

parcelRegister("daJf6", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f57cdfdfff00f4122214ded49823394f>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $996f4dcb64250d32$var$_react = $996f4dcb64250d32$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $996f4dcb64250d32$var$_UNSAFE_baseNew = $996f4dcb64250d32$var$_interopRequireDefault((parcelRequire("kjkwu")));
function $996f4dcb64250d32$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "ArrowUp".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: back to top.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $996f4dcb64250d32$var$ArrowUpIcon = (props)=>/*#__PURE__*/ $996f4dcb64250d32$var$_react.default.createElement($996f4dcb64250d32$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M8 15V2.25m-5 4.5 5-5 5 5"/>`
    }, props));
$996f4dcb64250d32$var$ArrowUpIcon.displayName = 'ArrowUpIcon';
var $996f4dcb64250d32$var$_default = module.exports.default = $996f4dcb64250d32$var$ArrowUpIcon;

});

parcelRegister("6HR91", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::209317c625743d387bf26edea0c296a9>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4e1ffb9b2db539e2$var$_react = $4e1ffb9b2db539e2$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $4e1ffb9b2db539e2$var$_UNSAFE_baseNew = $4e1ffb9b2db539e2$var$_interopRequireDefault((parcelRequire("kjkwu")));
function $4e1ffb9b2db539e2$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "CheckMark".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: table cells, checkboxes.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $4e1ffb9b2db539e2$var$CheckMarkIcon = (props)=>/*#__PURE__*/ $4e1ffb9b2db539e2$var$_react.default.createElement($4e1ffb9b2db539e2$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="m1.5 8 4.25 5.25 8.75-10.5"/>`
    }, props));
$4e1ffb9b2db539e2$var$CheckMarkIcon.displayName = 'CheckMarkIcon';
var $4e1ffb9b2db539e2$var$_default = module.exports.default = $4e1ffb9b2db539e2$var$CheckMarkIcon;

});

parcelRegister("bOyku", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3f4494144da7877c599489a550534c1d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $899efe5ba88f9af3$var$_react = $899efe5ba88f9af3$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $899efe5ba88f9af3$var$_UNSAFE_baseNew = $899efe5ba88f9af3$var$_interopRequireDefault((parcelRequire("kjkwu")));
function $899efe5ba88f9af3$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Success".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single-purpose - Reserved for success section messages and form validation messages.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $899efe5ba88f9af3$var$SuccessIcon = (props)=>/*#__PURE__*/ $899efe5ba88f9af3$var$_react.default.createElement($899efe5ba88f9af3$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8m12.326-2.52-1.152-.96L6.75 9.828 4.826 7.52l-1.152.96 2.5 3a.75.75 0 0 0 1.152 0z" clip-rule="evenodd"/>`
    }, props));
$899efe5ba88f9af3$var$SuccessIcon.displayName = 'SuccessIcon';
var $899efe5ba88f9af3$var$_default = module.exports.default = $899efe5ba88f9af3$var$SuccessIcon;

});

parcelRegister("1Eagz", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::33c5439f087752870260bcf48e3a4598>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $13317d8e71e304f9$var$_react = $13317d8e71e304f9$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $13317d8e71e304f9$var$_UNSAFE_baseNew = $13317d8e71e304f9$var$_interopRequireDefault((parcelRequire("kjkwu")));
function $13317d8e71e304f9$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "CheckCircle".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: completed items, productivity emoji category. Completed task issue status in JSM Calendar view.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $13317d8e71e304f9$var$CheckCircleIcon = (props)=>/*#__PURE__*/ $13317d8e71e304f9$var$_react.default.createElement($13317d8e71e304f9$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="m4.25 8 2.5 3 5-6M8 .75a7.25 7.25 0 1 0 0 14.5A7.25 7.25 0 0 0 8 .75Z"/>`
    }, props));
$13317d8e71e304f9$var$CheckCircleIcon.displayName = 'CheckCircleIcon';
var $13317d8e71e304f9$var$_default = module.exports.default = $13317d8e71e304f9$var$CheckCircleIcon;

});

parcelRegister("1u6rG", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3c58509c5f883b07cf4640f47a045782>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $114d97ba7534998b$var$_react = $114d97ba7534998b$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $114d97ba7534998b$var$_UNSAFE_baseNew = $114d97ba7534998b$var$_interopRequireDefault((parcelRequire("kjkwu")));
function $114d97ba7534998b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "ChevronDown".
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for dropdown menus, selects, accordions, and expands.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $114d97ba7534998b$var$ChevronDownIcon = (props)=>/*#__PURE__*/ $114d97ba7534998b$var$_react.default.createElement($114d97ba7534998b$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M10.5 4.5 8.25 6.75 6 9 3.75 6.75 1.5 4.5"/>`,
        type: 'utility'
    }, props));
$114d97ba7534998b$var$ChevronDownIcon.displayName = 'ChevronDownIcon';
var $114d97ba7534998b$var$_default = module.exports.default = $114d97ba7534998b$var$ChevronDownIcon;

});

parcelRegister("79sHj", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::53517bd082840f7b30aeaa6b952f5491>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $534fa26f53b18311$var$_react = $534fa26f53b18311$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $534fa26f53b18311$var$_UNSAFE_baseNew = $534fa26f53b18311$var$_interopRequireDefault((parcelRequire("kjkwu")));
function $534fa26f53b18311$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "ChevronLeft".
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for collapse side nav and to indicate previous in dates.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $534fa26f53b18311$var$ChevronLeftIcon = (props)=>/*#__PURE__*/ $534fa26f53b18311$var$_react.default.createElement($534fa26f53b18311$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M7.5 10.5 3 6l4.5-4.5"/>`,
        type: 'utility'
    }, props));
$534fa26f53b18311$var$ChevronLeftIcon.displayName = 'ChevronLeftIcon';
var $534fa26f53b18311$var$_default = module.exports.default = $534fa26f53b18311$var$ChevronLeftIcon;

});

parcelRegister("61RFB", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a9bfbdf898b5516a0a7c630d609b6042>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $463c77d2dab01cfb$var$_react = $463c77d2dab01cfb$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $463c77d2dab01cfb$var$_UNSAFE_baseNew = $463c77d2dab01cfb$var$_interopRequireDefault((parcelRequire("kjkwu")));
function $463c77d2dab01cfb$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "ChevronRight".
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for menu fly outs and to indicate next in dates.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $463c77d2dab01cfb$var$ChevronRightIcon = (props)=>/*#__PURE__*/ $463c77d2dab01cfb$var$_react.default.createElement($463c77d2dab01cfb$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M4.5 10.5 9 6 4.5 1.5"/>`,
        type: 'utility'
    }, props));
$463c77d2dab01cfb$var$ChevronRightIcon.displayName = 'ChevronRightIcon';
var $463c77d2dab01cfb$var$_default = module.exports.default = $463c77d2dab01cfb$var$ChevronRightIcon;

});

parcelRegister("cRECB", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f998c57d427ae10203b04c2186c5e29c>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $95d9f1df43ed6864$var$_react = $95d9f1df43ed6864$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $95d9f1df43ed6864$var$_UNSAFE_baseNew = $95d9f1df43ed6864$var$_interopRequireDefault((parcelRequire("kjkwu")));
function $95d9f1df43ed6864$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "ChevronUp".
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for accordions.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $95d9f1df43ed6864$var$ChevronUpIcon = (props)=>/*#__PURE__*/ $95d9f1df43ed6864$var$_react.default.createElement($95d9f1df43ed6864$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M10.5 7.5 6 3 1.5 7.5"/>`,
        type: 'utility'
    }, props));
$95d9f1df43ed6864$var$ChevronUpIcon.displayName = 'ChevronUpIcon';
var $95d9f1df43ed6864$var$_default = module.exports.default = $95d9f1df43ed6864$var$ChevronUpIcon;

});

parcelRegister("5xSGp", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::0ba7502fd657c116f257aba05875c56e>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $409a73b6aa939e45$var$_react = $409a73b6aa939e45$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $409a73b6aa939e45$var$_UNSAFE_baseNew = $409a73b6aa939e45$var$_interopRequireDefault((parcelRequire("kjkwu")));
function $409a73b6aa939e45$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Copy".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for copying data such as text, code or other objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $409a73b6aa939e45$var$CopyIcon = (props)=>/*#__PURE__*/ $409a73b6aa939e45$var$_react.default.createElement($409a73b6aa939e45$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-width="1.5" d="M1.75 3c0-.69.56-1.25 1.25-1.25h8c.69 0 1.25.56 1.25 1.25v8c0 .69-.56 1.25-1.25 1.25H3c-.69 0-1.25-.56-1.25-1.25z"/><path stroke="currentcolor" stroke-width="1.5" d="M6 15.25h6.75a2.5 2.5 0 0 0 2.5-2.5V6"/>`
    }, props));
$409a73b6aa939e45$var$CopyIcon.displayName = 'CopyIcon';
var $409a73b6aa939e45$var$_default = module.exports.default = $409a73b6aa939e45$var$CopyIcon;

});

parcelRegister("7mI24", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d48c51235c7072e6617b637653c3f4fe>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $55ccbe66472ec120$var$_react = $55ccbe66472ec120$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $55ccbe66472ec120$var$_UNSAFE_baseNew = $55ccbe66472ec120$var$_interopRequireDefault((parcelRequire("kjkwu")));
function $55ccbe66472ec120$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Edit".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for editing objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $55ccbe66472ec120$var$EditIcon = (props)=>/*#__PURE__*/ $55ccbe66472ec120$var$_react.default.createElement($55ccbe66472ec120$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M6 1.751H3c-.69 0-1.25.56-1.25 1.25v10c0 .69.56 1.25 1.25 1.25h10c.69 0 1.25-.56 1.25-1.25V10m-.75-5 1.116-1.116a1.25 1.25 0 0 0 0-1.768l-.732-.732a1.25 1.25 0 0 0-1.768 0L11 2.5M13.5 5 9.479 9.021c-.15.15-.336.26-.54.318l-3.189.911.911-3.189a1.25 1.25 0 0 1 .318-.54L11 2.5M13.5 5 11 2.5"/>`
    }, props));
$55ccbe66472ec120$var$EditIcon.displayName = 'EditIcon';
var $55ccbe66472ec120$var$_default = module.exports.default = $55ccbe66472ec120$var$EditIcon;

});

parcelRegister("kR2ul", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ccc84bee668fd63ce995277b659b1b62>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f2eab00862dc487d$var$_react = $f2eab00862dc487d$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $f2eab00862dc487d$var$_UNSAFE_baseNew = $f2eab00862dc487d$var$_interopRequireDefault((parcelRequire("kjkwu")));
function $f2eab00862dc487d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "ContentWrapRight".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for right aligning media and content with wrapping enabled.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $f2eab00862dc487d$var$ContentWrapRightIcon = (props)=>/*#__PURE__*/ $f2eab00862dc487d$var$_react.default.createElement($f2eab00862dc487d$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M1 1.75h14M1 14.25h14M1 5.917h6m-6 4.166h6m6.625.167h-3.25a.625.625 0 0 1-.625-.625v-3.25c0-.345.28-.625.625-.625h3.25c.345 0 .625.28.625.625v3.25c0 .345-.28.625-.625.625Z"/>`
    }, props));
$f2eab00862dc487d$var$ContentWrapRightIcon.displayName = 'ContentWrapRightIcon';
var $f2eab00862dc487d$var$_default = module.exports.default = $f2eab00862dc487d$var$ContentWrapRightIcon;

});

parcelRegister("9lQhd", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6db48d6c22f8d07c19434865c237f982>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6ceea048e2633809$var$_react = $6ceea048e2633809$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $6ceea048e2633809$var$_UNSAFE_baseNew = $6ceea048e2633809$var$_interopRequireDefault((parcelRequire("kjkwu")));
function $6ceea048e2633809$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Information".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Known uses: information state in section messages or inline messages.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $6ceea048e2633809$var$InformationIcon = (props)=>/*#__PURE__*/ $6ceea048e2633809$var$_react.default.createElement($6ceea048e2633809$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8m6.5-1.25H8a.75.75 0 0 1 .75.75v5h-1.5V8.25H6.5zM8 5.5a1 1 0 1 0 0-2 1 1 0 0 0 0 2" clip-rule="evenodd"/>`
    }, props));
$6ceea048e2633809$var$InformationIcon.displayName = 'InformationIcon';
var $6ceea048e2633809$var$_default = module.exports.default = $6ceea048e2633809$var$InformationIcon;

});

parcelRegister("abVHt", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4362663ac35e79a0a9cff3b383986020>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $76b7b0829399d7e1$var$_react = $76b7b0829399d7e1$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $76b7b0829399d7e1$var$_UNSAFE_baseNew = $76b7b0829399d7e1$var$_interopRequireDefault((parcelRequire("kjkwu")));
function $76b7b0829399d7e1$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Grid".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: spaces in Confluence, and grid view, all content in Confluence.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $76b7b0829399d7e1$var$GridIcon = (props)=>/*#__PURE__*/ $76b7b0829399d7e1$var$_react.default.createElement($76b7b0829399d7e1$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M8 1.75H3c-.69 0-1.25.56-1.25 1.25v5M8 1.75h5c.69 0 1.25.56 1.25 1.25v5M8 1.75v12.5m0 0h5c.69 0 1.25-.56 1.25-1.25V8M8 14.25H3c-.69 0-1.25-.56-1.25-1.25V8m0 0h12.5"/>`
    }, props));
$76b7b0829399d7e1$var$GridIcon.displayName = 'GridIcon';
var $76b7b0829399d7e1$var$_default = module.exports.default = $76b7b0829399d7e1$var$GridIcon;

});

parcelRegister("1vjAO", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::5a48a035a6b6ee27b8a00a2b1992b2cd>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1187e262f651c2ea$var$_react = $1187e262f651c2ea$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $1187e262f651c2ea$var$_UNSAFE_baseNew = $1187e262f651c2ea$var$_interopRequireDefault((parcelRequire("kjkwu")));
function $1187e262f651c2ea$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Clock".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: recent, time input, sprint time remaining. Overdue task issue status in JSM Calendar view.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $1187e262f651c2ea$var$ClockIcon = (props)=>/*#__PURE__*/ $1187e262f651c2ea$var$_react.default.createElement($1187e262f651c2ea$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-width="1.5" d="M8 3.25V8l2.5 2m4.75-2A7.25 7.25 0 1 1 .75 8a7.25 7.25 0 0 1 14.5 0Z"/>`
    }, props));
$1187e262f651c2ea$var$ClockIcon.displayName = 'ClockIcon';
var $1187e262f651c2ea$var$_default = module.exports.default = $1187e262f651c2ea$var$ClockIcon;

});

parcelRegister("iQQkv", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6f2df9b6d4b219d15d7e01ad6e3eb71a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $db95aced0ba2a4ba$var$_react = $db95aced0ba2a4ba$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $db95aced0ba2a4ba$var$_UNSAFE_baseNew = $db95aced0ba2a4ba$var$_interopRequireDefault((parcelRequire("kjkwu")));
function $db95aced0ba2a4ba$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Heart".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: emoji symbols in Editor.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $db95aced0ba2a4ba$var$HeartIcon = (props)=>/*#__PURE__*/ $db95aced0ba2a4ba$var$_react.default.createElement($db95aced0ba2a4ba$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-width="1.5" d="M8 14.5a.6.6 0 0 1-.245-.061 1.5 1.5 0 0 1-.244-.123q-1.917-1.225-3.324-2.567-1.408-1.348-2.176-2.764-.76-1.422-.761-2.873 0-.905.286-1.654.291-.756.808-1.307A3.6 3.6 0 0 1 5.036 2q1 0 1.754.51.754.511 1.21 1.349A3.76 3.76 0 0 1 9.217 2.51Q9.97 2 10.964 2q.801 0 1.488.3.694.3 1.204.85.516.552.802 1.308.292.749.292 1.654 0 1.45-.768 2.873-.761 1.416-2.169 2.765-1.4 1.342-3.317 2.566a1.4 1.4 0 0 1-.251.123A.6.6 0 0 1 8 14.5Z"/>`
    }, props));
$db95aced0ba2a4ba$var$HeartIcon.displayName = 'HeartIcon';
var $db95aced0ba2a4ba$var$_default = module.exports.default = $db95aced0ba2a4ba$var$HeartIcon;

});

parcelRegister("584U1", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::8547c3f91abc335ca9c5bbfd88dd7340>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3bc180a591eac193$var$_react = $3bc180a591eac193$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $3bc180a591eac193$var$_UNSAFE_baseNew = $3bc180a591eac193$var$_interopRequireDefault((parcelRequire("kjkwu")));
function $3bc180a591eac193$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Error".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for when there is an error.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $3bc180a591eac193$var$ErrorIcon = (props)=>/*#__PURE__*/ $3bc180a591eac193$var$_react.default.createElement($3bc180a591eac193$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6.586.604a2 2 0 0 1 2.828 0l5.982 5.982a2 2 0 0 1 0 2.828l-5.982 5.983a2 2 0 0 1-2.828 0L.604 9.414a2 2 0 0 1 0-2.828zM7.25 9V3.75h1.5V9zM8 12.25a1 1 0 1 0 0-2 1 1 0 0 0 0 2" clip-rule="evenodd"/>`
    }, props));
$3bc180a591eac193$var$ErrorIcon.displayName = 'ErrorIcon';
var $3bc180a591eac193$var$_default = module.exports.default = $3bc180a591eac193$var$ErrorIcon;

});

parcelRegister("5rnGN", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ebc22958da752d07e6dcf81116f518ec>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3f61d98d3d8bd0b9$var$_react = $3f61d98d3d8bd0b9$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $3f61d98d3d8bd0b9$var$_UNSAFE_baseNew = $3f61d98d3d8bd0b9$var$_interopRequireDefault((parcelRequire("kjkwu")));
function $3f61d98d3d8bd0b9$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Upload".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for upload in Editor.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $3f61d98d3d8bd0b9$var$UploadIcon = (props)=>/*#__PURE__*/ $3f61d98d3d8bd0b9$var$_react.default.createElement($3f61d98d3d8bd0b9$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M1.75 9v4c0 .69.56 1.25 1.25 1.25h10c.69 0 1.25-.56 1.25-1.25V9M8 11V2.25m-4 3.5 4-4 4 4"/>`
    }, props));
$3f61d98d3d8bd0b9$var$UploadIcon.displayName = 'UploadIcon';
var $3f61d98d3d8bd0b9$var$_default = module.exports.default = $3f61d98d3d8bd0b9$var$UploadIcon;

});

parcelRegister("ipSgm", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2e33235fde7b24564b92256907cba586>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d684a740cdb03725$var$_react = $d684a740cdb03725$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $d684a740cdb03725$var$_UNSAFE_baseNew = $d684a740cdb03725$var$_interopRequireDefault((parcelRequire("kjkwu")));
function $d684a740cdb03725$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Filter".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for filterting data or objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $d684a740cdb03725$var$FilterIcon = (props)=>/*#__PURE__*/ $d684a740cdb03725$var$_react.default.createElement($d684a740cdb03725$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-width="1.5" d="M3 8h10M1 2.75h14M5 13.25h6"/>`
    }, props));
$d684a740cdb03725$var$FilterIcon.displayName = 'FilterIcon';
var $d684a740cdb03725$var$_default = module.exports.default = $d684a740cdb03725$var$FilterIcon;

});

parcelRegister("kLwd2", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::00d261b1bfdc09ff1b2f03c198e27896>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f1e12e8588d525c5$var$_react = $f1e12e8588d525c5$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $f1e12e8588d525c5$var$_UNSAFE_baseNew = $f1e12e8588d525c5$var$_interopRequireDefault((parcelRequire("kjkwu")));
function $f1e12e8588d525c5$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Image".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: images, image upload.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $f1e12e8588d525c5$var$ImageIcon = (props)=>/*#__PURE__*/ $f1e12e8588d525c5$var$_react.default.createElement($f1e12e8588d525c5$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="M6.75 5.75a1 1 0 1 1-2 0 1 1 0 0 1 2 0"/><path fill="currentcolor" fill-rule="evenodd" d="M5.75 6.75a1 1 0 1 0 0-2 1 1 0 0 0 0 2" clip-rule="evenodd"/><path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M4 14.25h9c.69 0 1.25-.56 1.25-1.25v-2M4 14.25H3c-.69 0-1.25-.56-1.25-1.25V3c0-.69.56-1.25 1.25-1.25h10c.69 0 1.25.56 1.25 1.25v8M4 14.25 10 7l4.25 4m-7.5-5.25a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z"/>`
    }, props));
$f1e12e8588d525c5$var$ImageIcon.displayName = 'ImageIcon';
var $f1e12e8588d525c5$var$_default = module.exports.default = $f1e12e8588d525c5$var$ImageIcon;

});

parcelRegister("gG4Jd", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::af316a11070150755855d308e4656f28>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c2443c84bd6224e7$var$_react = $c2443c84bd6224e7$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $c2443c84bd6224e7$var$_UNSAFE_baseNew = $c2443c84bd6224e7$var$_interopRequireDefault((parcelRequire("kjkwu")));
function $c2443c84bd6224e7$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Link".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for links, urls, or copy link.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c2443c84bd6224e7$var$LinkIcon = (props)=>/*#__PURE__*/ $c2443c84bd6224e7$var$_react.default.createElement($c2443c84bd6224e7$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-width="1.5" d="m5.25 10.75 5.5-5.5M5 6.5 2.75 8.75a3.182 3.182 0 0 0 4.5 4.5L9.5 11m-3-6 2.25-2.25a3.182 3.182 0 0 1 4.5 4.5L11 9.5"/>`
    }, props));
$c2443c84bd6224e7$var$LinkIcon.displayName = 'LinkIcon';
var $c2443c84bd6224e7$var$_default = module.exports.default = $c2443c84bd6224e7$var$LinkIcon;

});

parcelRegister("dG71V", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ce7319a8e7b6756c4415855e934f6695>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9f54a69b9e2c5528$var$_react = $9f54a69b9e2c5528$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $9f54a69b9e2c5528$var$_UNSAFE_baseNew = $9f54a69b9e2c5528$var$_interopRequireDefault((parcelRequire("kjkwu")));
function $9f54a69b9e2c5528$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "ZoomIn".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for zooming in of an object or view.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $9f54a69b9e2c5528$var$ZoomInIcon = (props)=>/*#__PURE__*/ $9f54a69b9e2c5528$var$_react.default.createElement($9f54a69b9e2c5528$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-width="1.5" d="m14.5 14.5-3.788-3.788m0 0a5.25 5.25 0 1 0-7.425-7.425 5.25 5.25 0 0 0 7.425 7.425ZM4 7h3m3 0H7m0 0V4m0 3v3"/>`
    }, props));
$9f54a69b9e2c5528$var$ZoomInIcon.displayName = 'ZoomInIcon';
var $9f54a69b9e2c5528$var$_default = module.exports.default = $9f54a69b9e2c5528$var$ZoomInIcon;

});

parcelRegister("dIlMP", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f96a81b9e560eaf29acabc60a3927a4c>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9fc048c4e414c98a$var$_react = $9fc048c4e414c98a$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $9fc048c4e414c98a$var$_UNSAFE_baseNew = $9fc048c4e414c98a$var$_interopRequireDefault((parcelRequire("kjkwu")));
function $9fc048c4e414c98a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "ZoomOut".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for zooming out of an object or view.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $9fc048c4e414c98a$var$ZoomOutIcon = (props)=>/*#__PURE__*/ $9fc048c4e414c98a$var$_react.default.createElement($9fc048c4e414c98a$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-width="1.5" d="m14.5 14.5-3.788-3.788m0 0a5.25 5.25 0 1 0-7.425-7.425 5.25 5.25 0 0 0 7.425 7.425ZM4 7h6"/>`
    }, props));
$9fc048c4e414c98a$var$ZoomOutIcon.displayName = 'ZoomOutIcon';
var $9fc048c4e414c98a$var$_default = module.exports.default = $9fc048c4e414c98a$var$ZoomOutIcon;

});

parcelRegister("1noF8", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::9176a30c0755d77947ceea47f5dcd51a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $100b11df0d470f1e$var$_react = $100b11df0d470f1e$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $100b11df0d470f1e$var$_UNSAFE_baseNew = $100b11df0d470f1e$var$_interopRequireDefault((parcelRequire("kjkwu")));
function $100b11df0d470f1e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Menu".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for accessing the menu in global product navigation.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $100b11df0d470f1e$var$MenuIcon = (props)=>/*#__PURE__*/ $100b11df0d470f1e$var$_react.default.createElement($100b11df0d470f1e$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-width="1.5" d="M1 13.25h14M1 8h14M1 2.75h14"/>`
    }, props));
$100b11df0d470f1e$var$MenuIcon.displayName = 'MenuIcon';
var $100b11df0d470f1e$var$_default = module.exports.default = $100b11df0d470f1e$var$MenuIcon;

});

parcelRegister("h6bsN", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ed4cbb05f695c79bf1a6c2a07fef2f24>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c72be3a0821200ab$var$_react = $c72be3a0821200ab$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $c72be3a0821200ab$var$_UNSAFE_baseNew = $c72be3a0821200ab$var$_interopRequireDefault((parcelRequire("kjkwu")));
function $c72be3a0821200ab$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "ShowMoreVertical".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for more action menus, traditionally on mobile.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c72be3a0821200ab$var$ShowMoreVerticalIcon = (props)=>/*#__PURE__*/ $c72be3a0821200ab$var$_react.default.createElement($c72be3a0821200ab$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="M8.75 1.5a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0m0 6.5a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0m0 6.5a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0"/><path stroke="currentcolor" stroke-width="1.5" d="M8.75 1.5a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0Zm0 6.5a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0Zm0 6.5a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0Z"/>`
    }, props));
$c72be3a0821200ab$var$ShowMoreVerticalIcon.displayName = 'ShowMoreVerticalIcon';
var $c72be3a0821200ab$var$_default = module.exports.default = $c72be3a0821200ab$var$ShowMoreVerticalIcon;

});

parcelRegister("f3wJC", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6b38d718ca9f4aa1019c5485273ebd51>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $af6087410a99077c$var$_react = $af6087410a99077c$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $af6087410a99077c$var$_UNSAFE_baseNew = $af6087410a99077c$var$_interopRequireDefault((parcelRequire("kjkwu")));
function $af6087410a99077c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "AlignLeft".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: align text left, align content left, summary.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $af6087410a99077c$var$AlignLeftIcon = (props)=>/*#__PURE__*/ $af6087410a99077c$var$_react.default.createElement($af6087410a99077c$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-width="1.5" d="M1 2.75h14M1 13.25h7M1 8h14"/>`
    }, props));
$af6087410a99077c$var$AlignLeftIcon.displayName = 'AlignLeftIcon';
var $af6087410a99077c$var$_default = module.exports.default = $af6087410a99077c$var$AlignLeftIcon;

});

parcelRegister("8tqvv", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::10497e41582acb6b3539681c38bd8368>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $62b597e8e74cd8c6$var$_react = $62b597e8e74cd8c6$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $62b597e8e74cd8c6$var$_UNSAFE_baseNew = $62b597e8e74cd8c6$var$_interopRequireDefault((parcelRequire("kjkwu")));
function $62b597e8e74cd8c6$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "QuestionCircle".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: help, tip.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $62b597e8e74cd8c6$var$QuestionCircleIcon = (props)=>/*#__PURE__*/ $62b597e8e74cd8c6$var$_react.default.createElement($62b597e8e74cd8c6$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M6.25 6C6.25 5 7 4.25 8 4.25S9.75 5 9.75 6C9.75 7.5 8 7.5 8 8.75v.75M15.25 8A7.25 7.25 0 1 1 .75 8a7.25 7.25 0 0 1 14.5 0Z"/><path fill="currentcolor" d="M9 11.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0"/>`
    }, props));
$62b597e8e74cd8c6$var$QuestionCircleIcon.displayName = 'QuestionCircleIcon';
var $62b597e8e74cd8c6$var$_default = module.exports.default = $62b597e8e74cd8c6$var$QuestionCircleIcon;

});

parcelRegister("dvLdE", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::53a1e2fd011260ddfe6bcff1f1f84f50>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9d62cc5664365ccc$var$_react = $9d62cc5664365ccc$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $9d62cc5664365ccc$var$_UNSAFE_baseNew = $9d62cc5664365ccc$var$_interopRequireDefault((parcelRequire("kjkwu")));
function $9d62cc5664365ccc$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Refresh".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for expanding a object or panel.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $9d62cc5664365ccc$var$RefreshIcon = (props)=>/*#__PURE__*/ $9d62cc5664365ccc$var$_react.default.createElement($9d62cc5664365ccc$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M6.25 6V1.75H2m5.5 12.48c-3.218-.254-5.75-2.447-5.75-5.73 0-3.368 2.42-4.921 4-6.29m4 7.77v4.25H14M8.5 1.75c3.218.255 5.75 2.447 5.75 5.73 0 3.352-2.397 4.906-3.977 6.27"/>`
    }, props));
$9d62cc5664365ccc$var$RefreshIcon.displayName = 'RefreshIcon';
var $9d62cc5664365ccc$var$_default = module.exports.default = $9d62cc5664365ccc$var$RefreshIcon;

});

parcelRegister("5YCyx", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::aaf30f230bb1e005401a7fdb410093c0>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $011f7dc97be2ca4b$var$_react = $011f7dc97be2ca4b$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $011f7dc97be2ca4b$var$_UNSAFE_baseNew = $011f7dc97be2ca4b$var$_interopRequireDefault((parcelRequire("kjkwu")));
function $011f7dc97be2ca4b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Search".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for searching objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $011f7dc97be2ca4b$var$SearchIcon = (props)=>/*#__PURE__*/ $011f7dc97be2ca4b$var$_react.default.createElement($011f7dc97be2ca4b$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-width="1.5" d="m14.5 14.5-3.788-3.788m0 0a5.25 5.25 0 1 0-7.425-7.425 5.25 5.25 0 0 0 7.425 7.425Z"/>`
    }, props));
$011f7dc97be2ca4b$var$SearchIcon.displayName = 'SearchIcon';
var $011f7dc97be2ca4b$var$_default = module.exports.default = $011f7dc97be2ca4b$var$SearchIcon;

});

parcelRegister("69p1m", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c415ea6f37a3ed0eb78bc36e015407f4>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $47a6fdfc64682742$var$_react = $47a6fdfc64682742$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $47a6fdfc64682742$var$_UNSAFE_baseNew = $47a6fdfc64682742$var$_interopRequireDefault((parcelRequire("kjkwu")));
function $47a6fdfc64682742$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Settings".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for any object or user settings.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $47a6fdfc64682742$var$SettingsIcon = (props)=>/*#__PURE__*/ $47a6fdfc64682742$var$_react.default.createElement($47a6fdfc64682742$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M6.75.75 5.687 3.302a.625.625 0 0 1-.667.378l-2.674-.388-1.25 2.166L2.72 7.625a.625.625 0 0 1 0 .75l-1.624 2.168 1.25 2.165 2.674-.388a.625.625 0 0 1 .667.378L6.75 15.25h2.5l1.063-2.552a.625.625 0 0 1 .667-.378l2.674.388 1.25-2.165-1.623-2.168a.625.625 0 0 1 0-.75l1.623-2.167-1.25-2.166-2.674.388a.625.625 0 0 1-.667-.378L9.25.75z"/><path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M10.25 8a2.25 2.25 0 1 1-4.5 0 2.25 2.25 0 0 1 4.5 0Z"/>`
    }, props));
$47a6fdfc64682742$var$SettingsIcon.displayName = 'SettingsIcon';
var $47a6fdfc64682742$var$_default = module.exports.default = $47a6fdfc64682742$var$SettingsIcon;

});

parcelRegister("diyZy", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::530cf6124b77e826fb9d0e1e695d5d78>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9ae81972743121a7$var$_react = $9ae81972743121a7$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $9ae81972743121a7$var$_UNSAFE_baseNew = $9ae81972743121a7$var$_interopRequireDefault((parcelRequire("kjkwu")));
function $9ae81972743121a7$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Share".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for sharing an object.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $9ae81972743121a7$var$ShareIcon = (props)=>/*#__PURE__*/ $9ae81972743121a7$var$_react.default.createElement($9ae81972743121a7$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-width="1.5" d="M10.434 11.717a1.75 1.75 0 1 0 3.131 1.566 1.75 1.75 0 0 0-3.13-1.566Zm0 0L5.316 8.783m0 0a1.74 1.74 0 0 0 0-1.566m0 1.566a1.75 1.75 0 1 1 0-1.566m0 0 5.118-2.934m0 0a1.75 1.75 0 1 0 3.13-1.566 1.75 1.75 0 0 0-3.13 1.566Z"/>`
    }, props));
$9ae81972743121a7$var$ShareIcon.displayName = 'ShareIcon';
var $9ae81972743121a7$var$_default = module.exports.default = $9ae81972743121a7$var$ShareIcon;

});

parcelRegister("kGA9o", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::63d7759306dd75de9f8738c35cafb7b3>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f0f3c5a606f2ba9d$var$_react = $f0f3c5a606f2ba9d$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $f0f3c5a606f2ba9d$var$_UNSAFE_baseNew = $f0f3c5a606f2ba9d$var$_interopRequireDefault((parcelRequire("kjkwu")));
function $f0f3c5a606f2ba9d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "StarUnstarred".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for starring or favoriting objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $f0f3c5a606f2ba9d$var$StarUnstarredIcon = (props)=>/*#__PURE__*/ $f0f3c5a606f2ba9d$var$_react.default.createElement($f0f3c5a606f2ba9d$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="m8 11.25.424-.618L8 10.34l-.424.29zm-4.375 3-.724-.194a.75.75 0 0 0 1.148.813zM5 9.125l.724.194.125-.463-.369-.307zM1.25 6l-.058-.748A.75.75 0 0 0 .77 6.576zm4.875-.375.058.748.472-.037.17-.442zM8 .75l.7-.27a.75.75 0 0 0-1.4 0zm1.875 4.875-.7.27.17.441.472.037zM14.75 6l.48.576a.75.75 0 0 0-.423-1.324zM11 9.125l-.48-.576-.369.307.125.463zm1.375 5.125-.424.619a.75.75 0 0 0 1.148-.813zm-4.8-3.618-4.374 3 .848 1.237 4.375-3zM4.35 14.444 5.724 9.32l-1.448-.388L2.9 14.056zM5.48 8.55 1.73 5.424.77 6.576l3.75 3.125zM1.308 6.748l4.875-.375-.116-1.496-4.875.375zm5.517-.854L8.7 1.02 7.3.481 5.425 5.356zM7.3 1.02l1.875 4.875 1.4-.538L8.7.48zm2.517 5.354 4.876.375.114-1.496-4.874-.375zm4.453-.95L10.52 8.55l.96 1.152 3.75-3.125zM10.276 9.32l1.375 5.125 1.448-.388-1.375-5.125zm2.523 4.313-4.375-3-.848 1.237 4.375 3z"/>`
    }, props));
$f0f3c5a606f2ba9d$var$StarUnstarredIcon.displayName = 'StarUnstarredIcon';
var $f0f3c5a606f2ba9d$var$_default = module.exports.default = $f0f3c5a606f2ba9d$var$StarUnstarredIcon;

});

parcelRegister("5MuEE", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::84516badc93a96e757d14d99cc61886d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $435936cf72e81dfa$var$_react = $435936cf72e81dfa$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $435936cf72e81dfa$var$_UNSAFE_baseNew = $435936cf72e81dfa$var$_interopRequireDefault((parcelRequire("kjkwu")));
function $435936cf72e81dfa$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "StarStarred".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for starred or favourited objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $435936cf72e81dfa$var$StarStarredIcon = (props)=>/*#__PURE__*/ $435936cf72e81dfa$var$_react.default.createElement($435936cf72e81dfa$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="m8 11.25-4.375 3L5 9.125 1.25 6l4.875-.375L8 .75l1.875 4.875L14.75 6 11 9.125l1.375 5.125z"/><path fill="currentcolor" d="m8 11.25.424-.618L8 10.34l-.424.29zm-4.375 3-.724-.194a.75.75 0 0 0 1.148.813zM5 9.125l.724.194.125-.463-.369-.307zM1.25 6l-.058-.748A.75.75 0 0 0 .77 6.576zm4.875-.375.058.748.472-.037.17-.442zM8 .75l.7-.27a.75.75 0 0 0-1.4 0zm1.875 4.875-.7.27.17.441.472.037zM14.75 6l.48.576a.75.75 0 0 0-.423-1.324zM11 9.125l-.48-.576-.369.307.125.463zm1.375 5.125-.424.618a.75.75 0 0 0 1.148-.812zm-4.8-3.618-4.374 3 .848 1.236 4.375-3zM4.35 14.444 5.724 9.32l-1.448-.388L2.9 14.056zM5.48 8.55 1.73 5.424.77 6.576l3.75 3.125zM1.308 6.748l4.875-.375-.116-1.496-4.875.375zm5.517-.854L8.7 1.02 7.3.481 5.425 5.356zM7.3 1.02l1.875 4.875 1.4-.538L8.7.48zm2.517 5.354 4.876.375.114-1.496-4.874-.375zm4.453-.95L10.52 8.55l.96 1.152 3.75-3.125zM10.276 9.32l1.375 5.125 1.448-.388-1.375-5.125zm2.523 4.313-4.375-3-.848 1.236 4.375 3z"/>`
    }, props));
$435936cf72e81dfa$var$StarStarredIcon.displayName = 'StarStarredIcon';
var $435936cf72e81dfa$var$_default = module.exports.default = $435936cf72e81dfa$var$StarStarredIcon;

});

parcelRegister("89fFk", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e9ea8e93d14ecb2cc0f36d0ba6200033>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5eeb50d40bb42b52$var$_react = $5eeb50d40bb42b52$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $5eeb50d40bb42b52$var$_UNSAFE_baseNew = $5eeb50d40bb42b52$var$_interopRequireDefault((parcelRequire("kjkwu")));
function $5eeb50d40bb42b52$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Warning".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for warning system status.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $5eeb50d40bb42b52$var$WarningIcon = (props)=>/*#__PURE__*/ $5eeb50d40bb42b52$var$_react.default.createElement($5eeb50d40bb42b52$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6.242 1.168c.757-1.395 2.76-1.395 3.516 0l5.9 10.878C16.381 13.38 15.416 15 13.9 15H2.1C.584 15-.38 13.38.342 12.047zM7.25 9.5v-5h1.5v5zM8 12.75a1 1 0 1 0 0-2 1 1 0 0 0 0 2" clip-rule="evenodd"/>`
    }, props));
$5eeb50d40bb42b52$var$WarningIcon.displayName = 'WarningIcon';
var $5eeb50d40bb42b52$var$_default = module.exports.default = $5eeb50d40bb42b52$var$WarningIcon;

});

parcelRegister("1ZlwN", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => (parcelRequire("7omxW")).default);
$parcel$export(module.exports, "Icon", () => (parcelRequire("7omxW")).Icon);

var $7omxW = parcelRequire("7omxW");

});
parcelRegister("7omxW", function(module, exports) {
$parcel$export(module.exports, "Icon", () => $561c4390521ff8e5$export$f04a61298a47a40f);
$parcel$export(module.exports, "default", () => $561c4390521ff8e5$export$2e2bcd8739ae039);
/* icon-new.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");
/**
 * We are hiding this props from consumers as it's reserved
 * for use by Icon Tile.
 */ var $561c4390521ff8e5$var$svgStyles = null;
var $561c4390521ff8e5$var$iconStyles = null;
var $561c4390521ff8e5$var$smallIconStyles = null;
var $561c4390521ff8e5$var$scaleStyles = null;
/**
 * For windows high contrast mode
 */ var $561c4390521ff8e5$var$baseHcmStyles = null;
var $561c4390521ff8e5$var$scaleSize = null;
var $561c4390521ff8e5$var$coreSizeMedium = {
    none: "_1bsbpxbi _4t3ipxbi",
    compact: "_1bsb1ejb _4t3i1ejb",
    spacious: "_1bsb1ejb _4t3i1ejb"
};
var $561c4390521ff8e5$var$coreSizeSmall = {
    none: "_1bsbutpp _4t3iutpp",
    compact: "_1bsbpxbi _4t3ipxbi",
    spacious: "_1bsb1ejb _4t3i1ejb"
};
var $561c4390521ff8e5$var$paddingMap = {
    medium: {
        none: 0,
        compact: 4,
        spacious: 4
    },
    small: {
        none: 0,
        compact: 2.66,
        spacious: 8
    }
};
var $561c4390521ff8e5$export$f04a61298a47a40f = /*#__PURE__*/ (0, $5FkrB.memo)(function Icon(props) {
    var _ref = props, _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, testId = _ref.testId, label = _ref.label, dangerouslySetGlyph = _ref.dangerouslySetGlyph, shouldScale = _ref.shouldScale, _ref$spacing = _ref.spacing, spacing = _ref$spacing === void 0 ? 'none' : _ref$spacing, name = _ref.name;
    var dangerouslySetInnerHTML = dangerouslySetGlyph ? {
        __html: dangerouslySetGlyph
    } : undefined;
    var size = 'medium';
    if ('size' in props && props.size !== undefined) {
        if (typeof props.size === 'string') size = props.size === 'small' || props.size === 'medium' ? props.size : size;
        else if (name) {
            var newSize = props.size(name);
            size = newSize === 'small' || newSize === 'medium' ? newSize : size;
        }
    }
    var baseSize = 16;
    var viewBoxPadding = $561c4390521ff8e5$var$paddingMap[size][spacing];
    var viewBoxSize = baseSize + 2 * viewBoxPadding;
    return /*#__PURE__*/ $5FkrB.createElement("span", {
        "data-testid": testId,
        role: label ? 'img' : undefined,
        "aria-label": label ? label : undefined,
        "aria-hidden": label ? undefined : true,
        style: {
            color: color
        },
        className: (0, $970q7.default)([
            "_1e0c1o8l _vchhusvi _1o9zidpf _vwz4kb7n _y4ti1igz _bozg1mb9",
            "_12va1onz _jcxd1r8n",
            shouldScale && "_1bsb1kw7 _4t3i1kw7",
            size === 'small' && "_vwz4utpp"
        ])
    }, /*#__PURE__*/ $5FkrB.createElement("svg", {
        fill: "none",
        viewBox: "".concat(0 - viewBoxPadding, " ").concat(0 - viewBoxPadding, " ").concat(viewBoxSize, " ").concat(viewBoxSize),
        role: "presentation",
        dangerouslySetInnerHTML: dangerouslySetInnerHTML,
        className: (0, $970q7.default)([
            "_1reo15vq _18m915vq _syaz1r31 _lcxvglyw _s7n4yfq0 _vc881r31",
            shouldScale ? "_1bsb1kw7 _4t3i1kw7" : size === 'small' ? $561c4390521ff8e5$var$coreSizeSmall[spacing] : $561c4390521ff8e5$var$coreSizeMedium[spacing]
        ])
    }));
});
var $561c4390521ff8e5$export$2e2bcd8739ae039 = $561c4390521ff8e5$export$f04a61298a47a40f;

});


parcelRegister("4Q00M", function(module, exports) {
$parcel$export(module.exports, "THEME_DATA_ATTRIBUTE", () => $385c070e9c0a6682$export$4ef52930e33717cd);
$parcel$export(module.exports, "SUBTREE_THEME_ATTRIBUTE", () => $385c070e9c0a6682$export$cb374d25ded7f6ab);
$parcel$export(module.exports, "COLOR_MODE_ATTRIBUTE", () => $385c070e9c0a6682$export$a00eac3f8684bcd0);
$parcel$export(module.exports, "CONTRAST_MODE_ATTRIBUTE", () => $385c070e9c0a6682$export$2112803007239c61);
$parcel$export(module.exports, "CUSTOM_THEME_ATTRIBUTE", () => $385c070e9c0a6682$export$352e418ed5b6193a);
var $385c070e9c0a6682$export$4ef52930e33717cd = 'data-theme';
var $385c070e9c0a6682$export$cb374d25ded7f6ab = 'data-subtree-theme';
var $385c070e9c0a6682$export$a00eac3f8684bcd0 = 'data-color-mode';
var $385c070e9c0a6682$export$2112803007239c61 = 'data-contrast-mode';
var $385c070e9c0a6682$export$352e418ed5b6193a = 'data-custom-theme';
var $385c070e9c0a6682$export$6f0c6fb8c80fcc92 = 'ds';
var $385c070e9c0a6682$export$4d0c7bbf80185957 = [
    'opacity',
    'font',
    'space',
    'border',
    'radius'
];
var $385c070e9c0a6682$export$dddac1532e822863 = "--".concat($385c070e9c0a6682$export$6f0c6fb8c80fcc92, "-token-not-found");
var $385c070e9c0a6682$export$9d7b58831ae93caa = "--".concat($385c070e9c0a6682$export$6f0c6fb8c80fcc92, "-elevation-surface-current");

});

parcelRegister("jOCEz", function(module, exports) {
$parcel$export(module.exports, "themeColorModes", () => $e6d0ab9929008b7a$export$83993de8eb66733);
$parcel$export(module.exports, "themeIds", () => $e6d0ab9929008b7a$export$7d43e72a58e3283f);
$parcel$export(module.exports, "themeStateDefaults", () => $e6d0ab9929008b7a$export$9aedcfa7336a207);
$parcel$export(module.exports, "default", () => $e6d0ab9929008b7a$export$2e2bcd8739ae039);

var $id6Cu = parcelRequire("id6Cu");
var $e6d0ab9929008b7a$export$83993de8eb66733 = [
    'light',
    'dark',
    'auto'
];
/**
 * Contrast preferences: The system contrast preference
 */ var $e6d0ab9929008b7a$var$themeContrastModes = [
    'more',
    'no-preference',
    'auto'
];
var $e6d0ab9929008b7a$export$7d43e72a58e3283f = [
    'light-increased-contrast',
    'light',
    'light-future',
    'dark',
    'dark-future',
    'dark-increased-contrast',
    'legacy-light',
    'legacy-dark',
    'spacing',
    'shape',
    'typography'
];
/**
 * Theme override ids: the equivalent of themeIds for theme overrides.
 * Theme overrides are temporary and there may not be any defined at times.
 */ var $e6d0ab9929008b7a$var$themeOverrideIds = [];
var $e6d0ab9929008b7a$export$92ba366331403db2 = [].concat($e6d0ab9929008b7a$export$7d43e72a58e3283f, $e6d0ab9929008b7a$var$themeOverrideIds);
/**
 * Theme to use a base. This will create the theme as
 * an extension with all token values marked as optional
 * to allow tokens to be overridden as required.
 */ /**
 * Palettes: The set of base tokens a given theme may be populated with.
 * For example: legacy light & dark themes use the "legacyPalette" containing colors from our
 * previous color set.
 */ /**
 * ThemeConfig: the source of truth for all theme meta-data.
 * This object should be used whenever interfacing with themes.
 */ var $e6d0ab9929008b7a$var$themeConfig = {
    'atlassian-light': {
        id: 'light',
        displayName: 'Light Theme',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'light'
        }
    },
    'atlassian-light-future': {
        id: 'light-future',
        displayName: 'Future Light Theme',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'light'
        },
        override: 'light'
    },
    'atlassian-light-increased-contrast': {
        id: 'light-increased-contrast',
        displayName: 'Light Theme (increased contrast)',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'light'
        },
        extends: 'light',
        increasesContrastFor: 'light'
    },
    'atlassian-dark': {
        id: 'dark',
        displayName: 'Dark Theme',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'dark'
        }
    },
    'atlassian-dark-future': {
        id: 'dark-future',
        displayName: 'Future Dark Theme',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'dark'
        },
        override: 'light'
    },
    'atlassian-dark-increased-contrast': {
        id: 'dark-increased-contrast',
        displayName: 'Dark Theme (increased contrast)',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'dark'
        },
        extends: 'dark',
        increasesContrastFor: 'dark'
    },
    'atlassian-legacy-light': {
        id: 'legacy-light',
        displayName: 'Light Theme (legacy)',
        palette: 'legacyPalette',
        attributes: {
            type: 'color',
            mode: 'light'
        }
    },
    'atlassian-legacy-dark': {
        id: 'legacy-dark',
        displayName: 'Dark Theme (legacy)',
        palette: 'legacyPalette',
        attributes: {
            type: 'color',
            mode: 'dark'
        }
    },
    'atlassian-spacing': {
        id: 'spacing',
        displayName: 'Atlassian Spacing',
        palette: 'spacingScale',
        attributes: {
            type: 'spacing'
        }
    },
    'atlassian-typography': {
        id: 'typography',
        displayName: 'Atlassian Typography',
        palette: 'typographyPalette',
        attributes: {
            type: 'typography'
        }
    },
    'atlassian-shape': {
        id: 'shape',
        displayName: 'Shape',
        palette: 'shapePalette',
        attributes: {
            type: 'shape'
        }
    }
};
var $e6d0ab9929008b7a$export$9aedcfa7336a207 = {
    colorMode: 'auto',
    contrastMode: 'auto',
    dark: 'dark',
    light: 'light',
    shape: function shape() {
        if ((0, $id6Cu.fg)('platform-dst-shape-theme-default')) return 'shape';
        return undefined;
    },
    spacing: 'spacing',
    typography: 'typography',
    UNSAFE_themeOptions: undefined
};
var /**
 * Represents theme state once mounted to the page
 * (the page doesn't have an "auto" color mode, it's either light or dark)
 */ $e6d0ab9929008b7a$export$2e2bcd8739ae039 = $e6d0ab9929008b7a$var$themeConfig;

});

parcelRegister("j8wi6", function(module, exports) {
$parcel$export(module.exports, "isValidBrandHex", () => $dee7cff918a229d4$export$53031ac1ecb71f44);
$parcel$export(module.exports, "rgbToHex", () => $dee7cff918a229d4$export$34d09c4a771c46ef);
$parcel$export(module.exports, "hexToRgbA", () => $dee7cff918a229d4$export$b36dbdb4f463f05c);
$parcel$export(module.exports, "hexToRgb", () => $dee7cff918a229d4$export$5a544e13ad4e1fa5);
$parcel$export(module.exports, "hexToHSL", () => $dee7cff918a229d4$export$47ea145a83f50dc0);
$parcel$export(module.exports, "HSLToRGB", () => $dee7cff918a229d4$export$1ff93e992dd58bec);
$parcel$export(module.exports, "relativeLuminanceW3C", () => $dee7cff918a229d4$export$e770b01b744f3745);
$parcel$export(module.exports, "getContrastRatio", () => $dee7cff918a229d4$export$d061e26956a60b0a);
$parcel$export(module.exports, "deltaE", () => $dee7cff918a229d4$export$e8ddad763b4bebf9);
// valid hex color with 6 digits
var $dee7cff918a229d4$export$53031ac1ecb71f44 = function isValidBrandHex(hex) {
    return /^#[0-9A-F]{6}$/i.test(hex);
};
// valid hex color with 4, 6 or 8 digits
var $dee7cff918a229d4$var$isValidHex = function isValidHex(hex) {
    return /^#([A-Fa-f0-9]{3,4}){1,2}$/.test(hex);
};
function $dee7cff918a229d4$export$34d09c4a771c46ef(r, g, b) {
    return '#' + (16777216 + (r << 16) + (g << 8) + b).toString(16).slice(1);
}
function $dee7cff918a229d4$export$1212645cf40ebf71(hex) {
    if (hex.length === 9) {
        var int = parseInt(hex.slice(7, 9), 16) / 255;
        return Number(parseFloat(int.toString()).toFixed(2));
    }
    return 1;
}
function $dee7cff918a229d4$export$b36dbdb4f463f05c(hex) {
    if (!$dee7cff918a229d4$var$isValidHex(hex)) throw new Error('Invalid HEX');
    var c;
    c = hex.substring(1).split('');
    if (c.length === 3) c = [
        c[0],
        c[0],
        c[1],
        c[1],
        c[2],
        c[2]
    ];
    c = '0x' + c.join('');
    return [
        c >> 16 & 255,
        c >> 8 & 255,
        c & 255,
        $dee7cff918a229d4$export$1212645cf40ebf71(hex)
    ];
}
function $dee7cff918a229d4$export$5a544e13ad4e1fa5(hex) {
    if (!$dee7cff918a229d4$var$isValidHex(hex)) throw new Error('Invalid HEX');
    var c;
    c = hex.substring(1).split('');
    if (c.length === 3) c = [
        c[0],
        c[0],
        c[1],
        c[1],
        c[2],
        c[2]
    ];
    c = '0x' + c.join('');
    return [
        c >> 16 & 255,
        c >> 8 & 255,
        c & 255
    ];
}
function $dee7cff918a229d4$export$47ea145a83f50dc0(hex) {
    if (!$dee7cff918a229d4$var$isValidHex(hex)) throw new Error('Invalid HEX');
    var r = 0, g = 0, b = 0;
    if (hex.length === 4) {
        r = '0x' + hex[1] + hex[1];
        g = '0x' + hex[2] + hex[2];
        b = '0x' + hex[3] + hex[3];
    } else if (hex.length === 7) {
        r = '0x' + hex[1] + hex[2];
        g = '0x' + hex[3] + hex[4];
        b = '0x' + hex[5] + hex[6];
    }
    // Then to HSL
    r /= 255;
    g /= 255;
    b /= 255;
    var cmin = Math.min(r, g, b), cmax = Math.max(r, g, b), delta = cmax - cmin, h = 0, s = 0, l = 0;
    if (delta === 0) h = 0;
    else if (cmax === r) h = (g - b) / delta % 6;
    else if (cmax === g) h = (b - r) / delta + 2;
    else h = (r - g) / delta + 4;
    h = Math.round(h * 60);
    if (h < 0) h += 360;
    l = (cmax + cmin) / 2;
    s = delta === 0 ? 0 : delta / (1 - Math.abs(2 * l - 1));
    s = +(s * 100).toFixed(1);
    l = +(l * 100).toFixed(1);
    return [
        h,
        s,
        l
    ];
}
function $dee7cff918a229d4$export$1ff93e992dd58bec(h, s, l) {
    s /= 100;
    l /= 100;
    var k = function k(n) {
        return (n + h / 30) % 12;
    };
    var a = s * Math.min(l, 1 - l);
    var f = function f(n) {
        return l - a * Math.max(-1, Math.min(k(n) - 3, Math.min(9 - k(n), 1)));
    };
    return [
        255 * f(0),
        255 * f(8),
        255 * f(4)
    ];
}
function $dee7cff918a229d4$export$e770b01b744f3745(r, g, b) {
    var RsRGB = r / 255;
    var GsRGB = g / 255;
    var BsRGB = b / 255;
    var R = RsRGB <= 0.03928 ? RsRGB / 12.92 : Math.pow((RsRGB + 0.055) / 1.055, 2.4);
    var G = GsRGB <= 0.03928 ? GsRGB / 12.92 : Math.pow((GsRGB + 0.055) / 1.055, 2.4);
    var B = BsRGB <= 0.03928 ? BsRGB / 12.92 : Math.pow((BsRGB + 0.055) / 1.055, 2.4);
    // For the sRGB colorspace, the relative luminance of a color is defined as:
    var L = 0.2126 * R + 0.7152 * G + 0.0722 * B;
    return L;
}
function $dee7cff918a229d4$export$d061e26956a60b0a(foreground, background) {
    if (!$dee7cff918a229d4$var$isValidHex(foreground) || !$dee7cff918a229d4$var$isValidHex(background)) throw new Error('Invalid HEX');
    var foregroundRgb = $dee7cff918a229d4$export$5a544e13ad4e1fa5(foreground);
    var backgroundRgb = $dee7cff918a229d4$export$5a544e13ad4e1fa5(background);
    var foregroundLuminance = $dee7cff918a229d4$export$e770b01b744f3745(foregroundRgb[0], foregroundRgb[1], foregroundRgb[2]);
    var backgroundLuminance = $dee7cff918a229d4$export$e770b01b744f3745(backgroundRgb[0], backgroundRgb[1], backgroundRgb[2]);
    // calculate the color contrast ratio
    var brightest = Math.max(foregroundLuminance, backgroundLuminance);
    var darkest = Math.min(foregroundLuminance, backgroundLuminance);
    return (brightest + 0.05) / (darkest + 0.05);
}
function $dee7cff918a229d4$export$e8ddad763b4bebf9(rgbA, rgbB) {
    var labA = $dee7cff918a229d4$var$rgbToLab(rgbA);
    var labB = $dee7cff918a229d4$var$rgbToLab(rgbB);
    var deltaL = labA[0] - labB[0];
    var deltaA = labA[1] - labB[1];
    var deltaB = labA[2] - labB[2];
    var c1 = Math.sqrt(labA[1] * labA[1] + labA[2] * labA[2]);
    var c2 = Math.sqrt(labB[1] * labB[1] + labB[2] * labB[2]);
    var deltaC = c1 - c2;
    var deltaH = deltaA * deltaA + deltaB * deltaB - deltaC * deltaC;
    deltaH = deltaH < 0 ? 0 : Math.sqrt(deltaH);
    var sc = 1.0 + 0.045 * c1;
    var sh = 1.0 + 0.015 * c1;
    var deltaLKlsl = deltaL / 1.0;
    var deltaCkcsc = deltaC / sc;
    var deltaHkhsh = deltaH / sh;
    var i = deltaLKlsl * deltaLKlsl + deltaCkcsc * deltaCkcsc + deltaHkhsh * deltaHkhsh;
    return i < 0 ? 0 : Math.sqrt(i);
}
function $dee7cff918a229d4$var$rgbToLab(rgb) {
    var r = rgb[0] / 255, g = rgb[1] / 255, b = rgb[2] / 255, x, y, z;
    r = r > 0.04045 ? Math.pow((r + 0.055) / 1.055, 2.4) : r / 12.92;
    g = g > 0.04045 ? Math.pow((g + 0.055) / 1.055, 2.4) : g / 12.92;
    b = b > 0.04045 ? Math.pow((b + 0.055) / 1.055, 2.4) : b / 12.92;
    x = (r * 0.4124 + g * 0.3576 + b * 0.1805) / 0.95047;
    y = (r * 0.2126 + g * 0.7152 + b * 0.0722) / 1.0;
    z = (r * 0.0193 + g * 0.1192 + b * 0.9505) / 1.08883;
    x = x > 0.008856 ? Math.pow(x, 1 / 3) : 7.787 * x + 16 / 116;
    y = y > 0.008856 ? Math.pow(y, 1 / 3) : 7.787 * y + 16 / 116;
    z = z > 0.008856 ? Math.pow(z, 1 / 3) : 7.787 * z + 16 / 116;
    return [
        116 * y - 16,
        500 * (x - y),
        200 * (y - z)
    ];
}

});

parcelRegister("92luE", function(module, exports) {
$parcel$export(module.exports, "hash", () => $6944f912ab59b2dc$export$d6af199866bfb566);
var $6944f912ab59b2dc$export$d6af199866bfb566 = function hash(str) {
    var hash = 0;
    for(var i = 0; i < str.length; i++){
        var char = str.charCodeAt(i);
        hash = (hash << 5) - hash + char;
        hash &= hash; // Convert to 32bit integer
    }
    return new Uint32Array([
        hash
    ])[0].toString(36);
};

});

parcelRegister("2fjgr", function(module, exports) {

var $iKwew = parcelRequire("iKwew");
module.exports = $iKwew("030v0").then(()=>parcelRequire('lAexS'));

});

parcelRegister("hegm5", function(module, exports) {

var $iKwew = parcelRequire("iKwew");
module.exports = $iKwew("eE3iA").then(()=>parcelRequire('5Ntle'));

});

parcelRegister("cOZbX", function(module, exports) {

var $iKwew = parcelRequire("iKwew");
module.exports = $iKwew("7wK5x").then(()=>parcelRequire('aWThT'));

});

parcelRegister("4oKtr", function(module, exports) {

var $iKwew = parcelRequire("iKwew");
module.exports = $iKwew("fmSWS").then(()=>parcelRequire('cERlx'));

});

parcelRegister("evQOy", function(module, exports) {

var $iKwew = parcelRequire("iKwew");
module.exports = $iKwew("9Y9wv").then(()=>parcelRequire('fwfvh'));

});

parcelRegister("dic3Q", function(module, exports) {

var $iKwew = parcelRequire("iKwew");
module.exports = $iKwew("iXAQA").then(()=>parcelRequire('1AYG0'));

});

parcelRegister("hmiLY", function(module, exports) {

var $iKwew = parcelRequire("iKwew");
module.exports = $iKwew("88PGJ").then(()=>parcelRequire('kJsMJ'));

});

parcelRegister("3Vrjp", function(module, exports) {

var $iKwew = parcelRequire("iKwew");
module.exports = $iKwew("2A8vF").then(()=>parcelRequire('3JC4T'));

});

parcelRegister("doBio", function(module, exports) {

var $iKwew = parcelRequire("iKwew");
module.exports = $iKwew("ckT5f").then(()=>parcelRequire('1rAsM'));

});

parcelRegister("jvj2B", function(module, exports) {

var $iKwew = parcelRequire("iKwew");
module.exports = $iKwew("9y37j").then(()=>parcelRequire('9svyF'));

});

parcelRegister("gNA7A", function(module, exports) {

var $iKwew = parcelRequire("iKwew");
module.exports = $iKwew("j6I67").then(()=>parcelRequire('8eg4l'));

});

parcelRegister("89dnb", function(module, exports) {
$parcel$export(module.exports, "findMissingCustomStyleElements", () => $5ee9899342908354$export$bd1ac9300b0e885a);
$parcel$export(module.exports, "limitSizeOfCustomStyleElements", () => $5ee9899342908354$export$e7ae172320e03461);
$parcel$export(module.exports, "reduceTokenMap", () => $5ee9899342908354$export$e673f367da2ff23e);

var $iYJcE = parcelRequire("iYJcE");

var $fC8ib = parcelRequire("fC8ib");

var $gAhh1 = parcelRequire("gAhh1");

var $4Q00M = parcelRequire("4Q00M");

var $92luE = parcelRequire("92luE");
function $5ee9899342908354$export$bd1ac9300b0e885a(UNSAFE_themeOptions, mode) {
    var optionString = JSON.stringify(UNSAFE_themeOptions);
    var uniqueId = (0, $92luE.hash)(optionString);
    var attrOfMissingCustomStyles = [];
    (mode === 'auto' ? [
        'light',
        'dark'
    ] : [
        mode
    ]).forEach(function(themeId) {
        var element = document.head.querySelector("style[".concat((0, $4Q00M.CUSTOM_THEME_ATTRIBUTE), "=\"").concat(uniqueId, "\"][").concat((0, $4Q00M.THEME_DATA_ATTRIBUTE), "=\"").concat(themeId, "\"]"));
        if (element) // Append the existing custom styles to take precedence over others
        document.head.appendChild(element);
        else attrOfMissingCustomStyles.push(themeId);
    });
    return attrOfMissingCustomStyles;
}
function $5ee9899342908354$export$e7ae172320e03461(sizeThreshold) {
    var styleTags = (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(Array.from(document.head.querySelectorAll("style[".concat((0, $4Q00M.CUSTOM_THEME_ATTRIBUTE), "][").concat((0, $4Q00M.THEME_DATA_ATTRIBUTE), "]"))));
    if (styleTags.length < sizeThreshold) return;
    styleTags.slice(0, styleTags.length - (sizeThreshold - 1)).forEach(function(element) {
        return element.remove();
    });
}
function $5ee9899342908354$export$e673f367da2ff23e(tokenMap, themeRamp) {
    return Object.entries(tokenMap).reduce(function(acc, _ref) {
        var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_ref, 2), key = _ref2[0], value = _ref2[1];
        var cssVar = (0, $gAhh1.default)[key];
        return cssVar ? "".concat(acc, "\n  ").concat(cssVar, ": ").concat(typeof value === 'string' ? value : themeRamp[value], ";") : acc;
    }, '');
}

});
parcelRegister("gAhh1", function(module, exports) {
$parcel$export(module.exports, "default", () => $c12d6850bd87ed32$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::71ab6af4453c6807be4d4249ca7614bc>>
 * @codegenCommand yarn build tokens
 */ var $c12d6850bd87ed32$var$tokens = {
    'color.text': '--ds-text',
    'color.text.accent.lime': '--ds-text-accent-lime',
    'color.text.accent.lime.bolder': '--ds-text-accent-lime-bolder',
    'color.text.accent.red': '--ds-text-accent-red',
    'color.text.accent.red.bolder': '--ds-text-accent-red-bolder',
    'color.text.accent.orange': '--ds-text-accent-orange',
    'color.text.accent.orange.bolder': '--ds-text-accent-orange-bolder',
    'color.text.accent.yellow': '--ds-text-accent-yellow',
    'color.text.accent.yellow.bolder': '--ds-text-accent-yellow-bolder',
    'color.text.accent.green': '--ds-text-accent-green',
    'color.text.accent.green.bolder': '--ds-text-accent-green-bolder',
    'color.text.accent.teal': '--ds-text-accent-teal',
    'color.text.accent.teal.bolder': '--ds-text-accent-teal-bolder',
    'color.text.accent.blue': '--ds-text-accent-blue',
    'color.text.accent.blue.bolder': '--ds-text-accent-blue-bolder',
    'color.text.accent.purple': '--ds-text-accent-purple',
    'color.text.accent.purple.bolder': '--ds-text-accent-purple-bolder',
    'color.text.accent.magenta': '--ds-text-accent-magenta',
    'color.text.accent.magenta.bolder': '--ds-text-accent-magenta-bolder',
    'color.text.accent.gray': '--ds-text-accent-gray',
    'color.text.accent.gray.bolder': '--ds-text-accent-gray-bolder',
    'color.text.disabled': '--ds-text-disabled',
    'color.text.inverse': '--ds-text-inverse',
    'color.text.selected': '--ds-text-selected',
    'color.text.brand': '--ds-text-brand',
    'color.text.danger': '--ds-text-danger',
    'color.text.danger.bolder': '--ds-text-danger-bolder',
    'color.text.warning': '--ds-text-warning',
    'color.text.warning.inverse': '--ds-text-warning-inverse',
    'color.text.warning.bolder': '--ds-text-warning-bolder',
    'color.text.success': '--ds-text-success',
    'color.text.success.bolder': '--ds-text-success-bolder',
    'color.text.discovery': '--ds-text-discovery',
    'color.text.discovery.bolder': '--ds-text-discovery-bolder',
    'color.text.information': '--ds-text-information',
    'color.text.information.bolder': '--ds-text-information-bolder',
    'color.text.subtlest': '--ds-text-subtlest',
    'color.text.subtle': '--ds-text-subtle',
    'color.link': '--ds-link',
    'color.link.pressed': '--ds-link-pressed',
    'color.link.visited': '--ds-link-visited',
    'color.link.visited.pressed': '--ds-link-visited-pressed',
    'color.icon': '--ds-icon',
    'color.icon.accent.lime': '--ds-icon-accent-lime',
    'color.icon.accent.red': '--ds-icon-accent-red',
    'color.icon.accent.orange': '--ds-icon-accent-orange',
    'color.icon.accent.yellow': '--ds-icon-accent-yellow',
    'color.icon.accent.green': '--ds-icon-accent-green',
    'color.icon.accent.teal': '--ds-icon-accent-teal',
    'color.icon.accent.blue': '--ds-icon-accent-blue',
    'color.icon.accent.purple': '--ds-icon-accent-purple',
    'color.icon.accent.magenta': '--ds-icon-accent-magenta',
    'color.icon.accent.gray': '--ds-icon-accent-gray',
    'color.icon.disabled': '--ds-icon-disabled',
    'color.icon.inverse': '--ds-icon-inverse',
    'color.icon.selected': '--ds-icon-selected',
    'color.icon.brand': '--ds-icon-brand',
    'color.icon.danger': '--ds-icon-danger',
    'color.icon.warning': '--ds-icon-warning',
    'color.icon.warning.inverse': '--ds-icon-warning-inverse',
    'color.icon.success': '--ds-icon-success',
    'color.icon.discovery': '--ds-icon-discovery',
    'color.icon.information': '--ds-icon-information',
    'color.icon.subtlest': '--ds-icon-subtlest',
    'color.icon.subtle': '--ds-icon-subtle',
    'color.border': '--ds-border',
    'color.border.accent.lime': '--ds-border-accent-lime',
    'color.border.accent.red': '--ds-border-accent-red',
    'color.border.accent.orange': '--ds-border-accent-orange',
    'color.border.accent.yellow': '--ds-border-accent-yellow',
    'color.border.accent.green': '--ds-border-accent-green',
    'color.border.accent.teal': '--ds-border-accent-teal',
    'color.border.accent.blue': '--ds-border-accent-blue',
    'color.border.accent.purple': '--ds-border-accent-purple',
    'color.border.accent.magenta': '--ds-border-accent-magenta',
    'color.border.accent.gray': '--ds-border-accent-gray',
    'color.border.disabled': '--ds-border-disabled',
    'color.border.focused': '--ds-border-focused',
    'color.border.input': '--ds-border-input',
    'color.border.inverse': '--ds-border-inverse',
    'color.border.selected': '--ds-border-selected',
    'color.border.brand': '--ds-border-brand',
    'color.border.danger': '--ds-border-danger',
    'color.border.warning': '--ds-border-warning',
    'color.border.success': '--ds-border-success',
    'color.border.discovery': '--ds-border-discovery',
    'color.border.information': '--ds-border-information',
    'color.border.bold': '--ds-border-bold',
    'color.background.accent.lime.subtlest': '--ds-background-accent-lime-subtlest',
    'color.background.accent.lime.subtlest.hovered': '--ds-background-accent-lime-subtlest-hovered',
    'color.background.accent.lime.subtlest.pressed': '--ds-background-accent-lime-subtlest-pressed',
    'color.background.accent.lime.subtler': '--ds-background-accent-lime-subtler',
    'color.background.accent.lime.subtler.hovered': '--ds-background-accent-lime-subtler-hovered',
    'color.background.accent.lime.subtler.pressed': '--ds-background-accent-lime-subtler-pressed',
    'color.background.accent.lime.subtle': '--ds-background-accent-lime-subtle',
    'color.background.accent.lime.subtle.hovered': '--ds-background-accent-lime-subtle-hovered',
    'color.background.accent.lime.subtle.pressed': '--ds-background-accent-lime-subtle-pressed',
    'color.background.accent.lime.bolder': '--ds-background-accent-lime-bolder',
    'color.background.accent.lime.bolder.hovered': '--ds-background-accent-lime-bolder-hovered',
    'color.background.accent.lime.bolder.pressed': '--ds-background-accent-lime-bolder-pressed',
    'color.background.accent.red.subtlest': '--ds-background-accent-red-subtlest',
    'color.background.accent.red.subtlest.hovered': '--ds-background-accent-red-subtlest-hovered',
    'color.background.accent.red.subtlest.pressed': '--ds-background-accent-red-subtlest-pressed',
    'color.background.accent.red.subtler': '--ds-background-accent-red-subtler',
    'color.background.accent.red.subtler.hovered': '--ds-background-accent-red-subtler-hovered',
    'color.background.accent.red.subtler.pressed': '--ds-background-accent-red-subtler-pressed',
    'color.background.accent.red.subtle': '--ds-background-accent-red-subtle',
    'color.background.accent.red.subtle.hovered': '--ds-background-accent-red-subtle-hovered',
    'color.background.accent.red.subtle.pressed': '--ds-background-accent-red-subtle-pressed',
    'color.background.accent.red.bolder': '--ds-background-accent-red-bolder',
    'color.background.accent.red.bolder.hovered': '--ds-background-accent-red-bolder-hovered',
    'color.background.accent.red.bolder.pressed': '--ds-background-accent-red-bolder-pressed',
    'color.background.accent.orange.subtlest': '--ds-background-accent-orange-subtlest',
    'color.background.accent.orange.subtlest.hovered': '--ds-background-accent-orange-subtlest-hovered',
    'color.background.accent.orange.subtlest.pressed': '--ds-background-accent-orange-subtlest-pressed',
    'color.background.accent.orange.subtler': '--ds-background-accent-orange-subtler',
    'color.background.accent.orange.subtler.hovered': '--ds-background-accent-orange-subtler-hovered',
    'color.background.accent.orange.subtler.pressed': '--ds-background-accent-orange-subtler-pressed',
    'color.background.accent.orange.subtle': '--ds-background-accent-orange-subtle',
    'color.background.accent.orange.subtle.hovered': '--ds-background-accent-orange-subtle-hovered',
    'color.background.accent.orange.subtle.pressed': '--ds-background-accent-orange-subtle-pressed',
    'color.background.accent.orange.bolder': '--ds-background-accent-orange-bolder',
    'color.background.accent.orange.bolder.hovered': '--ds-background-accent-orange-bolder-hovered',
    'color.background.accent.orange.bolder.pressed': '--ds-background-accent-orange-bolder-pressed',
    'color.background.accent.yellow.subtlest': '--ds-background-accent-yellow-subtlest',
    'color.background.accent.yellow.subtlest.hovered': '--ds-background-accent-yellow-subtlest-hovered',
    'color.background.accent.yellow.subtlest.pressed': '--ds-background-accent-yellow-subtlest-pressed',
    'color.background.accent.yellow.subtler': '--ds-background-accent-yellow-subtler',
    'color.background.accent.yellow.subtler.hovered': '--ds-background-accent-yellow-subtler-hovered',
    'color.background.accent.yellow.subtler.pressed': '--ds-background-accent-yellow-subtler-pressed',
    'color.background.accent.yellow.subtle': '--ds-background-accent-yellow-subtle',
    'color.background.accent.yellow.subtle.hovered': '--ds-background-accent-yellow-subtle-hovered',
    'color.background.accent.yellow.subtle.pressed': '--ds-background-accent-yellow-subtle-pressed',
    'color.background.accent.yellow.bolder': '--ds-background-accent-yellow-bolder',
    'color.background.accent.yellow.bolder.hovered': '--ds-background-accent-yellow-bolder-hovered',
    'color.background.accent.yellow.bolder.pressed': '--ds-background-accent-yellow-bolder-pressed',
    'color.background.accent.green.subtlest': '--ds-background-accent-green-subtlest',
    'color.background.accent.green.subtlest.hovered': '--ds-background-accent-green-subtlest-hovered',
    'color.background.accent.green.subtlest.pressed': '--ds-background-accent-green-subtlest-pressed',
    'color.background.accent.green.subtler': '--ds-background-accent-green-subtler',
    'color.background.accent.green.subtler.hovered': '--ds-background-accent-green-subtler-hovered',
    'color.background.accent.green.subtler.pressed': '--ds-background-accent-green-subtler-pressed',
    'color.background.accent.green.subtle': '--ds-background-accent-green-subtle',
    'color.background.accent.green.subtle.hovered': '--ds-background-accent-green-subtle-hovered',
    'color.background.accent.green.subtle.pressed': '--ds-background-accent-green-subtle-pressed',
    'color.background.accent.green.bolder': '--ds-background-accent-green-bolder',
    'color.background.accent.green.bolder.hovered': '--ds-background-accent-green-bolder-hovered',
    'color.background.accent.green.bolder.pressed': '--ds-background-accent-green-bolder-pressed',
    'color.background.accent.teal.subtlest': '--ds-background-accent-teal-subtlest',
    'color.background.accent.teal.subtlest.hovered': '--ds-background-accent-teal-subtlest-hovered',
    'color.background.accent.teal.subtlest.pressed': '--ds-background-accent-teal-subtlest-pressed',
    'color.background.accent.teal.subtler': '--ds-background-accent-teal-subtler',
    'color.background.accent.teal.subtler.hovered': '--ds-background-accent-teal-subtler-hovered',
    'color.background.accent.teal.subtler.pressed': '--ds-background-accent-teal-subtler-pressed',
    'color.background.accent.teal.subtle': '--ds-background-accent-teal-subtle',
    'color.background.accent.teal.subtle.hovered': '--ds-background-accent-teal-subtle-hovered',
    'color.background.accent.teal.subtle.pressed': '--ds-background-accent-teal-subtle-pressed',
    'color.background.accent.teal.bolder': '--ds-background-accent-teal-bolder',
    'color.background.accent.teal.bolder.hovered': '--ds-background-accent-teal-bolder-hovered',
    'color.background.accent.teal.bolder.pressed': '--ds-background-accent-teal-bolder-pressed',
    'color.background.accent.blue.subtlest': '--ds-background-accent-blue-subtlest',
    'color.background.accent.blue.subtlest.hovered': '--ds-background-accent-blue-subtlest-hovered',
    'color.background.accent.blue.subtlest.pressed': '--ds-background-accent-blue-subtlest-pressed',
    'color.background.accent.blue.subtler': '--ds-background-accent-blue-subtler',
    'color.background.accent.blue.subtler.hovered': '--ds-background-accent-blue-subtler-hovered',
    'color.background.accent.blue.subtler.pressed': '--ds-background-accent-blue-subtler-pressed',
    'color.background.accent.blue.subtle': '--ds-background-accent-blue-subtle',
    'color.background.accent.blue.subtle.hovered': '--ds-background-accent-blue-subtle-hovered',
    'color.background.accent.blue.subtle.pressed': '--ds-background-accent-blue-subtle-pressed',
    'color.background.accent.blue.bolder': '--ds-background-accent-blue-bolder',
    'color.background.accent.blue.bolder.hovered': '--ds-background-accent-blue-bolder-hovered',
    'color.background.accent.blue.bolder.pressed': '--ds-background-accent-blue-bolder-pressed',
    'color.background.accent.purple.subtlest': '--ds-background-accent-purple-subtlest',
    'color.background.accent.purple.subtlest.hovered': '--ds-background-accent-purple-subtlest-hovered',
    'color.background.accent.purple.subtlest.pressed': '--ds-background-accent-purple-subtlest-pressed',
    'color.background.accent.purple.subtler': '--ds-background-accent-purple-subtler',
    'color.background.accent.purple.subtler.hovered': '--ds-background-accent-purple-subtler-hovered',
    'color.background.accent.purple.subtler.pressed': '--ds-background-accent-purple-subtler-pressed',
    'color.background.accent.purple.subtle': '--ds-background-accent-purple-subtle',
    'color.background.accent.purple.subtle.hovered': '--ds-background-accent-purple-subtle-hovered',
    'color.background.accent.purple.subtle.pressed': '--ds-background-accent-purple-subtle-pressed',
    'color.background.accent.purple.bolder': '--ds-background-accent-purple-bolder',
    'color.background.accent.purple.bolder.hovered': '--ds-background-accent-purple-bolder-hovered',
    'color.background.accent.purple.bolder.pressed': '--ds-background-accent-purple-bolder-pressed',
    'color.background.accent.magenta.subtlest': '--ds-background-accent-magenta-subtlest',
    'color.background.accent.magenta.subtlest.hovered': '--ds-background-accent-magenta-subtlest-hovered',
    'color.background.accent.magenta.subtlest.pressed': '--ds-background-accent-magenta-subtlest-pressed',
    'color.background.accent.magenta.subtler': '--ds-background-accent-magenta-subtler',
    'color.background.accent.magenta.subtler.hovered': '--ds-background-accent-magenta-subtler-hovered',
    'color.background.accent.magenta.subtler.pressed': '--ds-background-accent-magenta-subtler-pressed',
    'color.background.accent.magenta.subtle': '--ds-background-accent-magenta-subtle',
    'color.background.accent.magenta.subtle.hovered': '--ds-background-accent-magenta-subtle-hovered',
    'color.background.accent.magenta.subtle.pressed': '--ds-background-accent-magenta-subtle-pressed',
    'color.background.accent.magenta.bolder': '--ds-background-accent-magenta-bolder',
    'color.background.accent.magenta.bolder.hovered': '--ds-background-accent-magenta-bolder-hovered',
    'color.background.accent.magenta.bolder.pressed': '--ds-background-accent-magenta-bolder-pressed',
    'color.background.accent.gray.subtlest': '--ds-background-accent-gray-subtlest',
    'color.background.accent.gray.subtlest.hovered': '--ds-background-accent-gray-subtlest-hovered',
    'color.background.accent.gray.subtlest.pressed': '--ds-background-accent-gray-subtlest-pressed',
    'color.background.accent.gray.subtler': '--ds-background-accent-gray-subtler',
    'color.background.accent.gray.subtler.hovered': '--ds-background-accent-gray-subtler-hovered',
    'color.background.accent.gray.subtler.pressed': '--ds-background-accent-gray-subtler-pressed',
    'color.background.accent.gray.subtle': '--ds-background-accent-gray-subtle',
    'color.background.accent.gray.subtle.hovered': '--ds-background-accent-gray-subtle-hovered',
    'color.background.accent.gray.subtle.pressed': '--ds-background-accent-gray-subtle-pressed',
    'color.background.accent.gray.bolder': '--ds-background-accent-gray-bolder',
    'color.background.accent.gray.bolder.hovered': '--ds-background-accent-gray-bolder-hovered',
    'color.background.accent.gray.bolder.pressed': '--ds-background-accent-gray-bolder-pressed',
    'color.background.disabled': '--ds-background-disabled',
    'color.background.input': '--ds-background-input',
    'color.background.input.hovered': '--ds-background-input-hovered',
    'color.background.input.pressed': '--ds-background-input-pressed',
    'color.background.inverse.subtle': '--ds-background-inverse-subtle',
    'color.background.inverse.subtle.hovered': '--ds-background-inverse-subtle-hovered',
    'color.background.inverse.subtle.pressed': '--ds-background-inverse-subtle-pressed',
    'color.background.neutral': '--ds-background-neutral',
    'color.background.neutral.hovered': '--ds-background-neutral-hovered',
    'color.background.neutral.pressed': '--ds-background-neutral-pressed',
    'color.background.neutral.subtle': '--ds-background-neutral-subtle',
    'color.background.neutral.subtle.hovered': '--ds-background-neutral-subtle-hovered',
    'color.background.neutral.subtle.pressed': '--ds-background-neutral-subtle-pressed',
    'color.background.neutral.bold': '--ds-background-neutral-bold',
    'color.background.neutral.bold.hovered': '--ds-background-neutral-bold-hovered',
    'color.background.neutral.bold.pressed': '--ds-background-neutral-bold-pressed',
    'color.background.selected': '--ds-background-selected',
    'color.background.selected.hovered': '--ds-background-selected-hovered',
    'color.background.selected.pressed': '--ds-background-selected-pressed',
    'color.background.selected.bold': '--ds-background-selected-bold',
    'color.background.selected.bold.hovered': '--ds-background-selected-bold-hovered',
    'color.background.selected.bold.pressed': '--ds-background-selected-bold-pressed',
    'color.background.brand.subtlest': '--ds-background-brand-subtlest',
    'color.background.brand.subtlest.hovered': '--ds-background-brand-subtlest-hovered',
    'color.background.brand.subtlest.pressed': '--ds-background-brand-subtlest-pressed',
    'color.background.brand.bold': '--ds-background-brand-bold',
    'color.background.brand.bold.hovered': '--ds-background-brand-bold-hovered',
    'color.background.brand.bold.pressed': '--ds-background-brand-bold-pressed',
    'color.background.brand.boldest': '--ds-background-brand-boldest',
    'color.background.brand.boldest.hovered': '--ds-background-brand-boldest-hovered',
    'color.background.brand.boldest.pressed': '--ds-background-brand-boldest-pressed',
    'color.background.danger': '--ds-background-danger',
    'color.background.danger.hovered': '--ds-background-danger-hovered',
    'color.background.danger.pressed': '--ds-background-danger-pressed',
    'color.background.danger.subtler': '--ds-background-danger-subtler',
    'color.background.danger.subtler.hovered': '--ds-background-danger-subtler-hovered',
    'color.background.danger.subtler.pressed': '--ds-background-danger-subtler-pressed',
    'color.background.danger.bold': '--ds-background-danger-bold',
    'color.background.danger.bold.hovered': '--ds-background-danger-bold-hovered',
    'color.background.danger.bold.pressed': '--ds-background-danger-bold-pressed',
    'color.background.warning': '--ds-background-warning',
    'color.background.warning.hovered': '--ds-background-warning-hovered',
    'color.background.warning.pressed': '--ds-background-warning-pressed',
    'color.background.warning.subtler': '--ds-background-warning-subtler',
    'color.background.warning.subtler.hovered': '--ds-background-warning-subtler-hovered',
    'color.background.warning.subtler.pressed': '--ds-background-warning-subtler-pressed',
    'color.background.warning.bold': '--ds-background-warning-bold',
    'color.background.warning.bold.hovered': '--ds-background-warning-bold-hovered',
    'color.background.warning.bold.pressed': '--ds-background-warning-bold-pressed',
    'color.background.success': '--ds-background-success',
    'color.background.success.hovered': '--ds-background-success-hovered',
    'color.background.success.pressed': '--ds-background-success-pressed',
    'color.background.success.subtler': '--ds-background-success-subtler',
    'color.background.success.subtler.hovered': '--ds-background-success-subtler-hovered',
    'color.background.success.subtler.pressed': '--ds-background-success-subtler-pressed',
    'color.background.success.bold': '--ds-background-success-bold',
    'color.background.success.bold.hovered': '--ds-background-success-bold-hovered',
    'color.background.success.bold.pressed': '--ds-background-success-bold-pressed',
    'color.background.discovery': '--ds-background-discovery',
    'color.background.discovery.hovered': '--ds-background-discovery-hovered',
    'color.background.discovery.pressed': '--ds-background-discovery-pressed',
    'color.background.discovery.subtler': '--ds-background-discovery-subtler',
    'color.background.discovery.subtler.hovered': '--ds-background-discovery-subtler-hovered',
    'color.background.discovery.subtler.pressed': '--ds-background-discovery-subtler-pressed',
    'color.background.discovery.bold': '--ds-background-discovery-bold',
    'color.background.discovery.bold.hovered': '--ds-background-discovery-bold-hovered',
    'color.background.discovery.bold.pressed': '--ds-background-discovery-bold-pressed',
    'color.background.information': '--ds-background-information',
    'color.background.information.hovered': '--ds-background-information-hovered',
    'color.background.information.pressed': '--ds-background-information-pressed',
    'color.background.information.subtler': '--ds-background-information-subtler',
    'color.background.information.subtler.hovered': '--ds-background-information-subtler-hovered',
    'color.background.information.subtler.pressed': '--ds-background-information-subtler-pressed',
    'color.background.information.bold': '--ds-background-information-bold',
    'color.background.information.bold.hovered': '--ds-background-information-bold-hovered',
    'color.background.information.bold.pressed': '--ds-background-information-bold-pressed',
    'color.blanket': '--ds-blanket',
    'color.blanket.selected': '--ds-blanket-selected',
    'color.blanket.danger': '--ds-blanket-danger',
    'color.interaction.hovered': '--ds-interaction-hovered',
    'color.interaction.pressed': '--ds-interaction-pressed',
    'color.skeleton': '--ds-skeleton',
    'color.skeleton.subtle': '--ds-skeleton-subtle',
    'color.chart.categorical.1': '--ds-chart-categorical-1',
    'color.chart.categorical.1.hovered': '--ds-chart-categorical-1-hovered',
    'color.chart.categorical.2': '--ds-chart-categorical-2',
    'color.chart.categorical.2.hovered': '--ds-chart-categorical-2-hovered',
    'color.chart.categorical.3': '--ds-chart-categorical-3',
    'color.chart.categorical.3.hovered': '--ds-chart-categorical-3-hovered',
    'color.chart.categorical.4': '--ds-chart-categorical-4',
    'color.chart.categorical.4.hovered': '--ds-chart-categorical-4-hovered',
    'color.chart.categorical.5': '--ds-chart-categorical-5',
    'color.chart.categorical.5.hovered': '--ds-chart-categorical-5-hovered',
    'color.chart.categorical.6': '--ds-chart-categorical-6',
    'color.chart.categorical.6.hovered': '--ds-chart-categorical-6-hovered',
    'color.chart.categorical.7': '--ds-chart-categorical-7',
    'color.chart.categorical.7.hovered': '--ds-chart-categorical-7-hovered',
    'color.chart.categorical.8': '--ds-chart-categorical-8',
    'color.chart.categorical.8.hovered': '--ds-chart-categorical-8-hovered',
    'color.chart.lime.bold': '--ds-chart-lime-bold',
    'color.chart.lime.bold.hovered': '--ds-chart-lime-bold-hovered',
    'color.chart.lime.bolder': '--ds-chart-lime-bolder',
    'color.chart.lime.bolder.hovered': '--ds-chart-lime-bolder-hovered',
    'color.chart.lime.boldest': '--ds-chart-lime-boldest',
    'color.chart.lime.boldest.hovered': '--ds-chart-lime-boldest-hovered',
    'color.chart.neutral': '--ds-chart-neutral',
    'color.chart.neutral.hovered': '--ds-chart-neutral-hovered',
    'color.chart.red.bold': '--ds-chart-red-bold',
    'color.chart.red.bold.hovered': '--ds-chart-red-bold-hovered',
    'color.chart.red.bolder': '--ds-chart-red-bolder',
    'color.chart.red.bolder.hovered': '--ds-chart-red-bolder-hovered',
    'color.chart.red.boldest': '--ds-chart-red-boldest',
    'color.chart.red.boldest.hovered': '--ds-chart-red-boldest-hovered',
    'color.chart.orange.bold': '--ds-chart-orange-bold',
    'color.chart.orange.bold.hovered': '--ds-chart-orange-bold-hovered',
    'color.chart.orange.bolder': '--ds-chart-orange-bolder',
    'color.chart.orange.bolder.hovered': '--ds-chart-orange-bolder-hovered',
    'color.chart.orange.boldest': '--ds-chart-orange-boldest',
    'color.chart.orange.boldest.hovered': '--ds-chart-orange-boldest-hovered',
    'color.chart.yellow.bold': '--ds-chart-yellow-bold',
    'color.chart.yellow.bold.hovered': '--ds-chart-yellow-bold-hovered',
    'color.chart.yellow.bolder': '--ds-chart-yellow-bolder',
    'color.chart.yellow.bolder.hovered': '--ds-chart-yellow-bolder-hovered',
    'color.chart.yellow.boldest': '--ds-chart-yellow-boldest',
    'color.chart.yellow.boldest.hovered': '--ds-chart-yellow-boldest-hovered',
    'color.chart.green.bold': '--ds-chart-green-bold',
    'color.chart.green.bold.hovered': '--ds-chart-green-bold-hovered',
    'color.chart.green.bolder': '--ds-chart-green-bolder',
    'color.chart.green.bolder.hovered': '--ds-chart-green-bolder-hovered',
    'color.chart.green.boldest': '--ds-chart-green-boldest',
    'color.chart.green.boldest.hovered': '--ds-chart-green-boldest-hovered',
    'color.chart.teal.bold': '--ds-chart-teal-bold',
    'color.chart.teal.bold.hovered': '--ds-chart-teal-bold-hovered',
    'color.chart.teal.bolder': '--ds-chart-teal-bolder',
    'color.chart.teal.bolder.hovered': '--ds-chart-teal-bolder-hovered',
    'color.chart.teal.boldest': '--ds-chart-teal-boldest',
    'color.chart.teal.boldest.hovered': '--ds-chart-teal-boldest-hovered',
    'color.chart.blue.bold': '--ds-chart-blue-bold',
    'color.chart.blue.bold.hovered': '--ds-chart-blue-bold-hovered',
    'color.chart.blue.bolder': '--ds-chart-blue-bolder',
    'color.chart.blue.bolder.hovered': '--ds-chart-blue-bolder-hovered',
    'color.chart.blue.boldest': '--ds-chart-blue-boldest',
    'color.chart.blue.boldest.hovered': '--ds-chart-blue-boldest-hovered',
    'color.chart.purple.bold': '--ds-chart-purple-bold',
    'color.chart.purple.bold.hovered': '--ds-chart-purple-bold-hovered',
    'color.chart.purple.bolder': '--ds-chart-purple-bolder',
    'color.chart.purple.bolder.hovered': '--ds-chart-purple-bolder-hovered',
    'color.chart.purple.boldest': '--ds-chart-purple-boldest',
    'color.chart.purple.boldest.hovered': '--ds-chart-purple-boldest-hovered',
    'color.chart.magenta.bold': '--ds-chart-magenta-bold',
    'color.chart.magenta.bold.hovered': '--ds-chart-magenta-bold-hovered',
    'color.chart.magenta.bolder': '--ds-chart-magenta-bolder',
    'color.chart.magenta.bolder.hovered': '--ds-chart-magenta-bolder-hovered',
    'color.chart.magenta.boldest': '--ds-chart-magenta-boldest',
    'color.chart.magenta.boldest.hovered': '--ds-chart-magenta-boldest-hovered',
    'color.chart.gray.bold': '--ds-chart-gray-bold',
    'color.chart.gray.bold.hovered': '--ds-chart-gray-bold-hovered',
    'color.chart.gray.bolder': '--ds-chart-gray-bolder',
    'color.chart.gray.bolder.hovered': '--ds-chart-gray-bolder-hovered',
    'color.chart.gray.boldest': '--ds-chart-gray-boldest',
    'color.chart.gray.boldest.hovered': '--ds-chart-gray-boldest-hovered',
    'color.chart.brand': '--ds-chart-brand',
    'color.chart.brand.hovered': '--ds-chart-brand-hovered',
    'color.chart.danger': '--ds-chart-danger',
    'color.chart.danger.hovered': '--ds-chart-danger-hovered',
    'color.chart.danger.bold': '--ds-chart-danger-bold',
    'color.chart.danger.bold.hovered': '--ds-chart-danger-bold-hovered',
    'color.chart.warning': '--ds-chart-warning',
    'color.chart.warning.hovered': '--ds-chart-warning-hovered',
    'color.chart.warning.bold': '--ds-chart-warning-bold',
    'color.chart.warning.bold.hovered': '--ds-chart-warning-bold-hovered',
    'color.chart.success': '--ds-chart-success',
    'color.chart.success.hovered': '--ds-chart-success-hovered',
    'color.chart.success.bold': '--ds-chart-success-bold',
    'color.chart.success.bold.hovered': '--ds-chart-success-bold-hovered',
    'color.chart.discovery': '--ds-chart-discovery',
    'color.chart.discovery.hovered': '--ds-chart-discovery-hovered',
    'color.chart.discovery.bold': '--ds-chart-discovery-bold',
    'color.chart.discovery.bold.hovered': '--ds-chart-discovery-bold-hovered',
    'color.chart.information': '--ds-chart-information',
    'color.chart.information.hovered': '--ds-chart-information-hovered',
    'color.chart.information.bold': '--ds-chart-information-bold',
    'color.chart.information.bold.hovered': '--ds-chart-information-bold-hovered',
    'elevation.surface': '--ds-surface',
    'elevation.surface.hovered': '--ds-surface-hovered',
    'elevation.surface.pressed': '--ds-surface-pressed',
    'elevation.surface.overlay': '--ds-surface-overlay',
    'elevation.surface.overlay.hovered': '--ds-surface-overlay-hovered',
    'elevation.surface.overlay.pressed': '--ds-surface-overlay-pressed',
    'elevation.surface.raised': '--ds-surface-raised',
    'elevation.surface.raised.hovered': '--ds-surface-raised-hovered',
    'elevation.surface.raised.pressed': '--ds-surface-raised-pressed',
    'elevation.surface.sunken': '--ds-surface-sunken',
    'elevation.shadow.overflow': '--ds-shadow-overflow',
    'elevation.shadow.overflow.perimeter': '--ds-shadow-overflow-perimeter',
    'elevation.shadow.overflow.spread': '--ds-shadow-overflow-spread',
    'elevation.shadow.overlay': '--ds-shadow-overlay',
    'elevation.shadow.raised': '--ds-shadow-raised',
    'opacity.disabled': '--ds-opacity-disabled',
    'opacity.loading': '--ds-opacity-loading',
    'utility.UNSAFE.transparent': '--ds-UNSAFE-transparent',
    'utility.elevation.surface.current': '--ds-elevation-surface-current',
    'space.0': '--ds-space-0',
    'space.025': '--ds-space-025',
    'space.050': '--ds-space-050',
    'space.075': '--ds-space-075',
    'space.100': '--ds-space-100',
    'space.150': '--ds-space-150',
    'space.200': '--ds-space-200',
    'space.250': '--ds-space-250',
    'space.300': '--ds-space-300',
    'space.400': '--ds-space-400',
    'space.500': '--ds-space-500',
    'space.600': '--ds-space-600',
    'space.800': '--ds-space-800',
    'space.1000': '--ds-space-1000',
    'space.negative.025': '--ds-space-negative-025',
    'space.negative.050': '--ds-space-negative-050',
    'space.negative.075': '--ds-space-negative-075',
    'space.negative.100': '--ds-space-negative-100',
    'space.negative.150': '--ds-space-negative-150',
    'space.negative.200': '--ds-space-negative-200',
    'space.negative.250': '--ds-space-negative-250',
    'space.negative.300': '--ds-space-negative-300',
    'space.negative.400': '--ds-space-negative-400',
    'font.heading.xxlarge': '--ds-font-heading-xxlarge',
    'font.heading.xlarge': '--ds-font-heading-xlarge',
    'font.heading.large': '--ds-font-heading-large',
    'font.heading.medium': '--ds-font-heading-medium',
    'font.heading.small': '--ds-font-heading-small',
    'font.heading.xsmall': '--ds-font-heading-xsmall',
    'font.heading.xxsmall': '--ds-font-heading-xxsmall',
    'font.body.large': '--ds-font-body-large',
    'font.body': '--ds-font-body',
    'font.body.small': '--ds-font-body-small',
    'font.body.UNSAFE_small': '--ds-font-body-UNSAFE_small',
    'font.metric.large': '--ds-font-metric-large',
    'font.metric.medium': '--ds-font-metric-medium',
    'font.metric.small': '--ds-font-metric-small',
    'font.code': '--ds-font-code',
    'font.weight.regular': '--ds-font-weight-regular',
    'font.weight.medium': '--ds-font-weight-medium',
    'font.weight.semibold': '--ds-font-weight-semibold',
    'font.weight.bold': '--ds-font-weight-bold',
    'font.family.heading': '--ds-font-family-heading',
    'font.family.body': '--ds-font-family-body',
    'font.family.code': '--ds-font-family-code',
    'font.family.brand.heading': '--ds-font-family-brand-heading',
    'font.family.brand.body': '--ds-font-family-brand-body',
    'radius.xsmall': '--ds-radius-xsmall',
    'radius.small': '--ds-radius-small',
    'radius.medium': '--ds-radius-medium',
    'radius.large': '--ds-radius-large',
    'radius.xlarge': '--ds-radius-xlarge',
    'radius.xxlarge': '--ds-radius-xxlarge',
    'radius.full': '--ds-radius-full',
    'radius.tile': '--ds-radius-tile',
    'border.width': '--ds-border-width',
    'border.width.selected': '--ds-border-width-selected',
    'border.width.focused': '--ds-border-width-focused'
};
var $c12d6850bd87ed32$export$2e2bcd8739ae039 = $c12d6850bd87ed32$var$tokens;

});


parcelRegister("ejdjF", function(module, exports) {

var $iKwew = parcelRequire("iKwew");
module.exports = $iKwew("3aqbw").then(()=>parcelRequire('68CGJ'));

});

parcelRegister("6ndzp", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a7f51491040268dbfa9258c45e59f2b2>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4a3f6acc4d23c998$var$_react = $4a3f6acc4d23c998$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $4a3f6acc4d23c998$var$_baseNew = $4a3f6acc4d23c998$var$_interopRequireDefault((parcelRequire("fBGjY")));
function $4a3f6acc4d23c998$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Person".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Known uses: representing a person or user, owner, contributor.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $4a3f6acc4d23c998$var$PersonIcon = (props)=>/*#__PURE__*/ $4a3f6acc4d23c998$var$_react.default.createElement($4a3f6acc4d23c998$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M13.25 15v-2.25a3 3 0 0 0-3-3h-4.5a3 3 0 0 0-3 3V15m8.5-11a3.25 3.25 0 1 1-6.5 0 3.25 3.25 0 0 1 6.5 0Z"/>`
    }, props));
$4a3f6acc4d23c998$var$PersonIcon.displayName = 'PersonIcon';
var $4a3f6acc4d23c998$var$_default = module.exports.default = $4a3f6acc4d23c998$var$PersonIcon;

});
parcelRegister("fBGjY", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => (parcelRequire("ewRia")).default);
$parcel$export(module.exports, "Icon", () => (parcelRequire("ewRia")).Icon);

var $ewRia = parcelRequire("ewRia");

});
parcelRegister("ewRia", function(module, exports) {
$parcel$export(module.exports, "Icon", () => $a93d6485a8542a20$export$f04a61298a47a40f);
$parcel$export(module.exports, "default", () => $a93d6485a8542a20$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5FkrB = parcelRequire("5FkrB");

var $74Zh5 = parcelRequire("74Zh5");

var $id6Cu = parcelRequire("id6Cu");
/**
 * We are hiding this props from consumers as it's reserved
 * for use by Icon Tile.
 */ var $a93d6485a8542a20$var$commonSVGStyles = (0, $74Zh5.css)({
    overflow: 'hidden',
    pointerEvents: 'none',
    /**
   * Stop-color doesn't properly apply in chrome when the inherited/current color changes.
   * We have to initially set stop-color to inherit (either via DOM attribute or an initial CSS
   * rule) and then override it with currentColor for the color changes to be picked up.
   */ // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    stop: {
        stopColor: 'currentColor'
    }
});
var $a93d6485a8542a20$var$svgStyles = (0, $74Zh5.css)({
    color: 'currentColor',
    verticalAlign: 'bottom'
});
var $a93d6485a8542a20$var$iconStyles = (0, $74Zh5.css)({
    display: 'inline-block',
    boxSizing: 'border-box',
    flexShrink: 0,
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: 1,
    paddingInlineEnd: 'var(--ds--button--new-icon-padding-end, 0)',
    paddingInlineStart: 'var(--ds--button--new-icon-padding-start, 0)'
});
var $a93d6485a8542a20$var$utilityIconStyles = (0, $74Zh5.css)({
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: "var(--ds-space-150, 12px)"
});
var $a93d6485a8542a20$var$scaleStyles = (0, $74Zh5.css)({
    width: 'inherit',
    height: 'inherit'
});
/**
 * For windows high contrast mode
 */ var $a93d6485a8542a20$var$baseHcmStyles = (0, $74Zh5.css)({
    '@media screen and (forced-colors: active)': {
        color: 'CanvasText',
        filter: 'grayscale(1)'
    }
});
var $a93d6485a8542a20$var$scaleSize = (0, $74Zh5.css)({
    width: 'inherit',
    height: 'inherit'
});
var $a93d6485a8542a20$var$sizeMap = {
    core: {
        none: (0, $74Zh5.css)({
            width: "var(--ds-space-200, 16px)",
            height: "var(--ds-space-200, 16px)"
        }),
        spacious: (0, $74Zh5.css)({
            width: "var(--ds-space-300, 24px)",
            height: "var(--ds-space-300, 24px)"
        })
    },
    utility: {
        none: (0, $74Zh5.css)({
            width: "var(--ds-space-150, 12px)",
            height: "var(--ds-space-150, 12px)"
        }),
        compact: (0, $74Zh5.css)({
            width: "var(--ds-space-200, 16px)",
            height: "var(--ds-space-200, 16px)"
        }),
        spacious: (0, $74Zh5.css)({
            width: "var(--ds-space-300, 24px)",
            height: "var(--ds-space-300, 24px)"
        })
    }
};
var $a93d6485a8542a20$var$baseSizeMap = {
    core: 16,
    utility: 12
};
var $a93d6485a8542a20$var$paddingMap = {
    core: {
        none: 0,
        spacious: 4
    },
    utility: {
        none: 0,
        compact: 2,
        spacious: 6
    }
};
var $a93d6485a8542a20$export$f04a61298a47a40f = /*#__PURE__*/ (0, $5FkrB.memo)(function Icon(props) {
    var _props$type, _props$spacing3, _props$spacing4;
    var _ref = props, _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, testId = _ref.testId, label = _ref.label, LEGACY_primaryColor = _ref.LEGACY_primaryColor, LEGACY_secondaryColor = _ref.LEGACY_secondaryColor, LEGACY_size = _ref.LEGACY_size, FallbackIcon = _ref.LEGACY_fallbackIcon, dangerouslySetGlyph = _ref.dangerouslySetGlyph, shouldScale = _ref.shouldScale, LEGACY_margin = _ref.LEGACY_margin;
    var dangerouslySetInnerHTML = dangerouslySetGlyph ? {
        __html: dangerouslySetGlyph
    } : undefined;
    // Fall back to old icon
    if (FallbackIcon && !(0, $id6Cu.fg)('platform-visual-refresh-icons')) // parse out unnecessary props
    return (0, $74Zh5.jsx)(FallbackIcon, {
        primaryColor: LEGACY_primaryColor !== null && LEGACY_primaryColor !== void 0 ? LEGACY_primaryColor : color,
        secondaryColor: LEGACY_secondaryColor,
        size: LEGACY_size,
        label: label,
        testId: testId,
        UNSAFE_margin: LEGACY_margin
    });
    var baseSize = $a93d6485a8542a20$var$baseSizeMap[(_props$type = props.type) !== null && _props$type !== void 0 ? _props$type : 'core'];
    var viewBoxPadding;
    if (props.type === 'utility') {
        var _props$spacing;
        viewBoxPadding = $a93d6485a8542a20$var$paddingMap[props.type][(_props$spacing = props.spacing) !== null && _props$spacing !== void 0 ? _props$spacing : 'none'];
    } else {
        var _props$spacing2;
        viewBoxPadding = $a93d6485a8542a20$var$paddingMap['core'][(_props$spacing2 = props.spacing) !== null && _props$spacing2 !== void 0 ? _props$spacing2 : 'none'];
    }
    var viewBoxSize = baseSize + 2 * viewBoxPadding;
    // Workaround for the transparency in our disabled icon token.
    // Because we have multiple strokes in icons, opacities overlap
    // This filter has an impact on render performance, but this is
    // acceptable as icons aren't commonly disabled en-masse
    var iconColor = color;
    if (dangerouslySetInnerHTML && color === "var(--ds-icon-disabled, #091E424F)") {
        dangerouslySetInnerHTML.__html = "\n<filter id=\"ds-newIconOpacityFilter\">\n  <feFlood flood-color=\"var(--ds-icon-disabled)\" />\n  <feComposite in2=\"SourceGraphic\" operator=\"in\" />\n</filter>\n<g filter=\"url(#ds-newIconOpacityFilter)\">\n  ".concat(dangerouslySetInnerHTML.__html, "\n</g>");
        iconColor = "var(--ds-icon, #44546F)";
    }
    return (0, $74Zh5.jsx)("span", {
        "data-testid": testId,
        role: label ? 'img' : undefined,
        "aria-label": label ? label : undefined,
        "aria-hidden": label ? undefined : true,
        style: {
            color: iconColor
        },
        css: [
            $a93d6485a8542a20$var$iconStyles,
            $a93d6485a8542a20$var$baseHcmStyles,
            shouldScale && $a93d6485a8542a20$var$scaleStyles,
            props.type === 'utility' && $a93d6485a8542a20$var$utilityIconStyles
        ]
    }, (0, $74Zh5.jsx)("svg", {
        fill: "none",
        viewBox: "".concat(0 - viewBoxPadding, " ").concat(0 - viewBoxPadding, " ").concat(viewBoxSize, " ").concat(viewBoxSize),
        role: "presentation",
        css: [
            $a93d6485a8542a20$var$commonSVGStyles,
            $a93d6485a8542a20$var$svgStyles,
            shouldScale ? $a93d6485a8542a20$var$scaleSize : props.type === 'utility' ? $a93d6485a8542a20$var$sizeMap[props.type][(_props$spacing3 = props.spacing) !== null && _props$spacing3 !== void 0 ? _props$spacing3 : 'none'] : $a93d6485a8542a20$var$sizeMap['core'][(_props$spacing4 = props.spacing) !== null && _props$spacing4 !== void 0 ? _props$spacing4 : 'none']
        ],
        dangerouslySetInnerHTML: dangerouslySetInnerHTML
    }));
});
var $a93d6485a8542a20$export$2e2bcd8739ae039 = $a93d6485a8542a20$export$f04a61298a47a40f;

});



parcelRegister("5S8H3", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4468bd3c973d801a$var$_react = $4468bd3c973d801a$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $6ajaV = parcelRequire("6ajaV");

var $4468bd3c973d801a$var$_person = $4468bd3c973d801a$var$_interopRequireDefault((parcelRequire("6ndzp")));
function $4468bd3c973d801a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $4468bd3c973d801a$var$PersonIcon = (props)=>/*#__PURE__*/ $4468bd3c973d801a$var$_react.default.createElement($6ajaV.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path d="M6 14c0-1.105.902-2 2.009-2h7.982c1.11 0 2.009.894 2.009 2.006v4.44c0 3.405-12 3.405-12 0z"/><circle cx="12" cy="7" r="4"/></g></svg>`
    }, props, {
        newIcon: $4468bd3c973d801a$var$_person.default
    }));
$4468bd3c973d801a$var$PersonIcon.displayName = 'PersonIcon';
var $4468bd3c973d801a$var$_default = module.exports.default = $4468bd3c973d801a$var$PersonIcon;

});
parcelRegister("6ajaV", function(module, exports) {
$parcel$export(module.exports, "IconFacade", () => $47d28d125977eb7e$export$3cfb73f70dfca966);

var $kqp0i = parcelRequire("kqp0i");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");

var $id6Cu = parcelRequire("id6Cu");

var $hIexN = parcelRequire("hIexN");
var $47d28d125977eb7e$var$_excluded = [
    "dangerouslySetGlyph"
];
var $47d28d125977eb7e$var$sizeSpacingMap = {
    utility: {
        small: 'compact',
        medium: 'spacious'
    },
    core: {
        small: 'none',
        medium: 'spacious'
    }
};
var $47d28d125977eb7e$export$3cfb73f70dfca966 = /*#__PURE__*/ (0, $5FkrB.memo)(function IconFacade(_ref) {
    var _props$size;
    var dangerouslySetGlyph = _ref.dangerouslySetGlyph, props = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $47d28d125977eb7e$var$_excluded);
    var NewIcon = props.newIcon;
    // By default, the icon size will be medium for core icons and small for utility icons
    var size = (_props$size = props.size) !== null && _props$size !== void 0 ? _props$size : 'medium';
    var useNewIcon = !props.isFacadeDisabled && // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
    (0, $id6Cu.fg)('platform-visual-refresh-icons-legacy-facade');
    if (useNewIcon && NewIcon && (size === 'small' || size === 'medium')) {
        if (props.iconType === 'utility') {
            var Icon = NewIcon;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(Icon, (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, props, {
                spacing: (0, $id6Cu.fg)('platform-visual-refresh-icons-facade-button-fix') ? $47d28d125977eb7e$var$sizeSpacingMap['utility'][size] : 'none',
                color: props.primaryColor || 'currentColor',
                type: props.iconType
            }));
        } else {
            var _Icon = NewIcon;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(_Icon, (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, props, {
                spacing: $47d28d125977eb7e$var$sizeSpacingMap['core'][size],
                color: props.primaryColor || 'currentColor',
                type: props.iconType
            }));
        }
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $hIexN.Icon), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        dangerouslySetGlyph: dangerouslySetGlyph
    }, props));
});

});
parcelRegister("hIexN", function(module, exports) {
$parcel$export(module.exports, "Icon", () => $ce51d3e5999154e8$export$f04a61298a47a40f);

var $kqp0i = parcelRequire("kqp0i");

var $25nEq = parcelRequire("25nEq");

var $5FkrB = parcelRequire("5FkrB");

var $74Zh5 = parcelRequire("74Zh5");

var $72BvW = parcelRequire("72BvW");

var $6Nzx3 = parcelRequire("6Nzx3");
function $ce51d3e5999154e8$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $ce51d3e5999154e8$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $ce51d3e5999154e8$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $ce51d3e5999154e8$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
/**
 * We are hiding these props from consumers as they're used to
 * hack around icon sizing specifically for icon-file-type.
 */ var $ce51d3e5999154e8$var$iconStyles = (0, $74Zh5.css)({
    display: 'inline-block',
    flexShrink: 0,
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: 1,
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '> svg': $ce51d3e5999154e8$var$_objectSpread($ce51d3e5999154e8$var$_objectSpread({}, (0, $72BvW.commonSVGStyles)), {}, {
        maxWidth: '100%',
        maxHeight: '100%',
        color: 'var(--icon-primary-color)',
        fill: 'var(--icon-secondary-color)',
        verticalAlign: 'bottom'
    })
});
/**
 * For windows high contrast mode
 */ var $ce51d3e5999154e8$var$baseHcmStyles = (0, $74Zh5.css)({
    '@media screen and (forced-colors: active)': {
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '> svg': {
            filter: 'grayscale(1)',
            '--icon-primary-color': 'CanvasText',
            // foreground
            '--icon-secondary-color': 'Canvas' // background
        }
    }
});
var $ce51d3e5999154e8$var$primaryEqualsSecondaryHcmStyles = (0, $74Zh5.css)({
    '@media screen and (forced-colors: active)': {
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '> svg': {
            // if the primaryColor is the same as the secondaryColor we
            // set the --icon-primary-color to Canvas
            // this is usually to convey state i.e. Checkbox checked -> not checked
            '--icon-primary-color': 'Canvas' // foreground
        }
    }
});
var $ce51d3e5999154e8$var$secondaryTransparentHcmStyles = (0, $74Zh5.css)({
    '@media screen and (forced-colors: active)': {
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '> svg': {
            '--icon-secondary-color': 'transparent' // background
        }
    }
});
var $ce51d3e5999154e8$export$f04a61298a47a40f = /*#__PURE__*/ (0, $5FkrB.memo)(function Icon(props) {
    var _ref = props, Glyph = _ref.glyph, dangerouslySetGlyph = _ref.dangerouslySetGlyph, _ref$primaryColor = _ref.primaryColor, primaryColor = _ref$primaryColor === void 0 ? 'currentColor' : _ref$primaryColor, secondaryColor = _ref.secondaryColor, size = _ref.size, testId = _ref.testId, label = _ref.label, width = _ref.width, height = _ref.height, UNSAFE_margin = _ref.UNSAFE_margin;
    var glyphProps = dangerouslySetGlyph ? {
        dangerouslySetInnerHTML: {
            __html: dangerouslySetGlyph
        }
    } : {
        children: Glyph ? (0, $74Zh5.jsx)(Glyph, {
            role: "presentation"
        }) : null
    };
    var dimensions = (0, $72BvW.getIconSize)({
        width: width,
        height: height,
        size: size
    });
    return (0, $74Zh5.jsx)("span", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        "data-testid": testId,
        "data-vc": "icon-".concat(testId),
        role: label ? 'img' : undefined,
        "aria-label": label ? label : undefined,
        "aria-hidden": label ? undefined : true,
        style: {
            '--icon-primary-color': primaryColor,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            '--icon-secondary-color': secondaryColor || (0, $6Nzx3.getBackground)(),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            margin: UNSAFE_margin
        }
    }, glyphProps, {
        css: [
            $ce51d3e5999154e8$var$iconStyles,
            $ce51d3e5999154e8$var$baseHcmStyles,
            primaryColor === secondaryColor && $ce51d3e5999154e8$var$primaryEqualsSecondaryHcmStyles,
            secondaryColor === 'transparent' && $ce51d3e5999154e8$var$secondaryTransparentHcmStyles,
            // NB: This can be resolved if this component, composes base SVG / and/or skeleton
            // We could then simplify how common styles are dealt with simply by encapsulating them
            // at their appropriate level and/or having a singular approach to css variables in the package
            dimensions && // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $74Zh5.css)({
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                width: dimensions.width,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                height: dimensions.height,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                '> svg': dimensions
            })
        ]
    }));
});
var $ce51d3e5999154e8$export$2e2bcd8739ae039 = $ce51d3e5999154e8$export$f04a61298a47a40f;

});
parcelRegister("72BvW", function(module, exports) {
$parcel$export(module.exports, "commonSVGStyles", () => $5205d1d15c0ca184$export$16374db1c3e6dfba);
$parcel$export(module.exports, "getIconSize", () => $5205d1d15c0ca184$export$3eb7d6130acfda37);

var $jJiGv = parcelRequire("jJiGv");

var $74Zh5 = parcelRequire("74Zh5");
var $5205d1d15c0ca184$export$16374db1c3e6dfba = {
    overflow: 'hidden',
    pointerEvents: 'none',
    /**
   * Stop-color doesn't properly apply in chrome when the inherited/current color changes.
   * We have to initially set stop-color to inherit (either via DOM attribute or an initial CSS
   * rule) and then override it with currentColor for the color changes to be picked up.
   */ stop: {
        stopColor: 'currentColor'
    }
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
var $5205d1d15c0ca184$var$smallStyles = (0, $74Zh5.css)((0, $jJiGv.dimensions).small);
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
var $5205d1d15c0ca184$var$mediumStyles = (0, $74Zh5.css)((0, $jJiGv.dimensions).medium);
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
var $5205d1d15c0ca184$var$largeStyles = (0, $74Zh5.css)((0, $jJiGv.dimensions).large);
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
var $5205d1d15c0ca184$var$xlargeStyles = (0, $74Zh5.css)((0, $jJiGv.dimensions).xlarge);
var $5205d1d15c0ca184$export$ef0ad74202575b64 = {
    small: $5205d1d15c0ca184$var$smallStyles,
    medium: $5205d1d15c0ca184$var$mediumStyles,
    large: $5205d1d15c0ca184$var$largeStyles,
    xlarge: $5205d1d15c0ca184$var$xlargeStyles
};
var $5205d1d15c0ca184$export$3eb7d6130acfda37 = function getIconSize(_ref) {
    var width = _ref.width, height = _ref.height, size = _ref.size;
    if (width && height) return {
        width: width,
        height: height
    };
    if (size) return (0, $jJiGv.dimensions)[size];
    return undefined;
};

});
parcelRegister("jJiGv", function(module, exports) {
$parcel$export(module.exports, "dimensions", () => $e5d0b6ae66cfcf11$export$62ad7b0c781000e9);
var $e5d0b6ae66cfcf11$export$c647cb0ee6e282fe = {
    small: '16px',
    medium: '24px',
    large: '32px',
    xlarge: '48px'
};
var $e5d0b6ae66cfcf11$export$7bd66fc94c81bf84 = {
    small: 'small',
    medium: 'medium',
    large: 'large',
    xlarge: 'xlarge'
};
var $e5d0b6ae66cfcf11$export$62ad7b0c781000e9 = {
    small: {
        width: $e5d0b6ae66cfcf11$export$c647cb0ee6e282fe.small,
        height: $e5d0b6ae66cfcf11$export$c647cb0ee6e282fe.small
    },
    medium: {
        width: $e5d0b6ae66cfcf11$export$c647cb0ee6e282fe.medium,
        height: $e5d0b6ae66cfcf11$export$c647cb0ee6e282fe.medium
    },
    large: {
        width: $e5d0b6ae66cfcf11$export$c647cb0ee6e282fe.large,
        height: $e5d0b6ae66cfcf11$export$c647cb0ee6e282fe.large
    },
    xlarge: {
        width: $e5d0b6ae66cfcf11$export$c647cb0ee6e282fe.xlarge,
        height: $e5d0b6ae66cfcf11$export$c647cb0ee6e282fe.xlarge
    }
};

});


parcelRegister("6Nzx3", function(module, exports) {
$parcel$export(module.exports, "getBackground", () => $4f32e199d0b9cc68$export$18cb9425622d4e06);
var $4f32e199d0b9cc68$export$18cb9425622d4e06 = function getBackground() {
    return "var(--ds-surface, #FFFFFF)";
};

});




parcelRegister("kc1v6", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::08061a6d953c7d73b57c2e6e0bdac389>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $eb3617a1615eaf39$var$_react = $eb3617a1615eaf39$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $eb3617a1615eaf39$var$_baseNew = $eb3617a1615eaf39$var$_interopRequireDefault((parcelRequire("fBGjY")));
function $eb3617a1615eaf39$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Release".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for releases in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $eb3617a1615eaf39$var$ReleaseIcon = (props)=>/*#__PURE__*/ $eb3617a1615eaf39$var$_react.default.createElement($eb3617a1615eaf39$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="M.75 7.75V7a.75.75 0 0 0-.75.75zm14.5 0 .646.382A.75.75 0 0 0 15.25 7zm-12.5-3V4a.75.75 0 0 0-.75.75zm6.25 0 .648-.378A.75.75 0 0 0 9 4zm-4.25-2V2H4v.75zm1.5 0H7V2h-.75zm6.113 9.886.646.382zm2.241-5.268-2.887 4.886 1.292.764 2.887-4.886zM11.287 12.5H2V14h9.287zM1.5 12V7.75H0V12zM.75 8.5h2V7h-2zm2.75-.75v-3H2v3zm-.75.75h8V7h-8zm8 0h4.5V7h-4.5zM8.352 5.128l1.75 3 1.296-.756-1.75-3zM2.75 5.5h2V4h-2zm2.75-.75v-2H4v2zM4.75 3.5h1.5V2h-1.5zm0 2h1.5V4h-1.5zm1.5 0H9V4H6.25zM5.5 2.75v2H7v-2zM2 12.5a.5.5 0 0 1-.5-.5H0a2 2 0 0 0 2 2zm9.717-.246a.5.5 0 0 1-.43.246V14a2 2 0 0 0 1.722-.982z"/>`
    }, props));
$eb3617a1615eaf39$var$ReleaseIcon.displayName = 'ReleaseIcon';
var $eb3617a1615eaf39$var$_default = module.exports.default = $eb3617a1615eaf39$var$ReleaseIcon;

});

parcelRegister("2CTaT", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1e99edf00ea518b4$var$_react = $1e99edf00ea518b4$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $6ajaV = parcelRequire("6ajaV");

var $1e99edf00ea518b4$var$_release = $1e99edf00ea518b4$var$_interopRequireDefault((parcelRequire("kc1v6")));
function $1e99edf00ea518b4$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $1e99edf00ea518b4$var$ShipIcon = (props)=>/*#__PURE__*/ $1e99edf00ea518b4$var$_react.default.createElement($6ajaV.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path fill-rule="nonzero" d="M6 12h8v-2H6zM4 8.99C4 8.445 4.456 8 5.002 8h9.996C15.55 8 16 8.451 16 8.99V14H4z"/><path d="M6 7.005C6 5.898 6.898 5 7.998 5h2.004C11.106 5 12 5.894 12 7.005V10H6zm4 0V7H7.999c.005 0 .002.003.002.005V8h2z"/><path fill-rule="nonzero" d="M4.5 17h13.994l1.002-3H4.14zm-2.495-4.012A.862.862 0 0 1 2.883 12h18.393c.55 0 .857.417.681.944l-1.707 5.112c-.174.521-.758.944-1.315.944H3.725a1.15 1.15 0 0 1-1.118-.988z"/></g></svg>`
    }, props, {
        newIcon: $1e99edf00ea518b4$var$_release.default
    }));
$1e99edf00ea518b4$var$ShipIcon.displayName = 'ShipIcon';
var $1e99edf00ea518b4$var$_default = module.exports.default = $1e99edf00ea518b4$var$ShipIcon;

});

parcelRegister("1SmDc", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::11bb746989e6f2f05a6a45e4a2d4e804>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $15dc63b396dfe9e2$var$_react = $15dc63b396dfe9e2$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $15dc63b396dfe9e2$var$_baseNew = $15dc63b396dfe9e2$var$_interopRequireDefault((parcelRequire("8rNEu")));
function $15dc63b396dfe9e2$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "ChevronDown".
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for dropdown menus, selects, accordions, and expands.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $15dc63b396dfe9e2$var$ChevronDownIcon = (props)=>/*#__PURE__*/ $15dc63b396dfe9e2$var$_react.default.createElement($15dc63b396dfe9e2$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M10.5 4.5 8.25 6.75 6 9 3.75 6.75 1.5 4.5"/>`,
        type: 'utility'
    }, props));
$15dc63b396dfe9e2$var$ChevronDownIcon.displayName = 'ChevronDownIcon';
var $15dc63b396dfe9e2$var$_default = module.exports.default = $15dc63b396dfe9e2$var$ChevronDownIcon;

});
parcelRegister("8rNEu", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => (parcelRequire("8TTDd")).default);
$parcel$export(module.exports, "Icon", () => (parcelRequire("8TTDd")).Icon);

var $8TTDd = parcelRequire("8TTDd");

});
parcelRegister("8TTDd", function(module, exports) {
$parcel$export(module.exports, "Icon", () => $67ae9d053250ea28$export$f04a61298a47a40f);
$parcel$export(module.exports, "default", () => $67ae9d053250ea28$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5FkrB = parcelRequire("5FkrB");

var $74Zh5 = parcelRequire("74Zh5");

var $id6Cu = parcelRequire("id6Cu");
/**
 * We are hiding this props from consumers as it's reserved
 * for use by Icon Tile.
 */ var $67ae9d053250ea28$var$commonSVGStyles = (0, $74Zh5.css)({
    overflow: 'hidden',
    pointerEvents: 'none',
    /**
   * Stop-color doesn't properly apply in chrome when the inherited/current color changes.
   * We have to initially set stop-color to inherit (either via DOM attribute or an initial CSS
   * rule) and then override it with currentColor for the color changes to be picked up.
   */ // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    stop: {
        stopColor: 'currentColor'
    }
});
var $67ae9d053250ea28$var$svgStyles = (0, $74Zh5.css)({
    color: 'currentColor',
    verticalAlign: 'bottom'
});
var $67ae9d053250ea28$var$iconStyles = (0, $74Zh5.css)({
    display: 'inline-block',
    boxSizing: 'border-box',
    flexShrink: 0,
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: 1,
    paddingInlineEnd: 'var(--ds--button--new-icon-padding-end, 0)',
    paddingInlineStart: 'var(--ds--button--new-icon-padding-start, 0)'
});
var $67ae9d053250ea28$var$utilityIconStyles = (0, $74Zh5.css)({
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: "var(--ds-space-150, 12px)"
});
var $67ae9d053250ea28$var$scaleStyles = (0, $74Zh5.css)({
    width: 'inherit',
    height: 'inherit'
});
/**
 * For windows high contrast mode
 */ var $67ae9d053250ea28$var$baseHcmStyles = (0, $74Zh5.css)({
    '@media screen and (forced-colors: active)': {
        color: 'CanvasText',
        filter: 'grayscale(1)'
    }
});
var $67ae9d053250ea28$var$scaleSize = (0, $74Zh5.css)({
    width: 'inherit',
    height: 'inherit'
});
var $67ae9d053250ea28$var$sizeMap = {
    core: {
        none: (0, $74Zh5.css)({
            width: "var(--ds-space-200, 16px)",
            height: "var(--ds-space-200, 16px)"
        }),
        spacious: (0, $74Zh5.css)({
            width: "var(--ds-space-300, 24px)",
            height: "var(--ds-space-300, 24px)"
        })
    },
    utility: {
        none: (0, $74Zh5.css)({
            width: "var(--ds-space-150, 12px)",
            height: "var(--ds-space-150, 12px)"
        }),
        compact: (0, $74Zh5.css)({
            width: "var(--ds-space-200, 16px)",
            height: "var(--ds-space-200, 16px)"
        }),
        spacious: (0, $74Zh5.css)({
            width: "var(--ds-space-300, 24px)",
            height: "var(--ds-space-300, 24px)"
        })
    }
};
var $67ae9d053250ea28$var$baseSizeMap = {
    core: 16,
    utility: 12
};
var $67ae9d053250ea28$var$paddingMap = {
    core: {
        none: 0,
        spacious: 4
    },
    utility: {
        none: 0,
        compact: 2,
        spacious: 6
    }
};
var $67ae9d053250ea28$export$f04a61298a47a40f = /*#__PURE__*/ (0, $5FkrB.memo)(function Icon(props) {
    var _props$type, _props$spacing3, _props$spacing4;
    var _ref = props, _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, testId = _ref.testId, label = _ref.label, LEGACY_primaryColor = _ref.LEGACY_primaryColor, LEGACY_secondaryColor = _ref.LEGACY_secondaryColor, LEGACY_size = _ref.LEGACY_size, FallbackIcon = _ref.LEGACY_fallbackIcon, dangerouslySetGlyph = _ref.dangerouslySetGlyph, shouldScale = _ref.shouldScale, LEGACY_margin = _ref.LEGACY_margin;
    var dangerouslySetInnerHTML = dangerouslySetGlyph ? {
        __html: dangerouslySetGlyph
    } : undefined;
    // Fall back to old icon
    if (FallbackIcon && !(0, $id6Cu.fg)('platform-visual-refresh-icons')) // parse out unnecessary props
    return (0, $74Zh5.jsx)(FallbackIcon, {
        primaryColor: LEGACY_primaryColor !== null && LEGACY_primaryColor !== void 0 ? LEGACY_primaryColor : color,
        secondaryColor: LEGACY_secondaryColor,
        size: LEGACY_size,
        label: label,
        testId: testId,
        UNSAFE_margin: LEGACY_margin
    });
    var baseSize = $67ae9d053250ea28$var$baseSizeMap[(_props$type = props.type) !== null && _props$type !== void 0 ? _props$type : 'core'];
    var viewBoxPadding;
    if (props.type === 'utility') {
        var _props$spacing;
        viewBoxPadding = $67ae9d053250ea28$var$paddingMap[props.type][(_props$spacing = props.spacing) !== null && _props$spacing !== void 0 ? _props$spacing : 'none'];
    } else {
        var _props$spacing2;
        viewBoxPadding = $67ae9d053250ea28$var$paddingMap['core'][(_props$spacing2 = props.spacing) !== null && _props$spacing2 !== void 0 ? _props$spacing2 : 'none'];
    }
    var viewBoxSize = baseSize + 2 * viewBoxPadding;
    // Workaround for the transparency in our disabled icon token.
    // Because we have multiple strokes in icons, opacities overlap
    // This filter has an impact on render performance, but this is
    // acceptable as icons aren't commonly disabled en-masse
    var iconColor = color;
    if (dangerouslySetInnerHTML && color === "var(--ds-icon-disabled, #091E424F)") {
        dangerouslySetInnerHTML.__html = "\n<filter id=\"ds-newIconOpacityFilter\">\n  <feFlood flood-color=\"var(--ds-icon-disabled)\" />\n  <feComposite in2=\"SourceGraphic\" operator=\"in\" />\n</filter>\n<g filter=\"url(#ds-newIconOpacityFilter)\">\n  ".concat(dangerouslySetInnerHTML.__html, "\n</g>");
        iconColor = "var(--ds-icon, #44546F)";
    }
    return (0, $74Zh5.jsx)("span", {
        "data-testid": testId,
        role: label ? 'img' : undefined,
        "aria-label": label ? label : undefined,
        "aria-hidden": label ? undefined : true,
        style: {
            color: iconColor
        },
        css: [
            $67ae9d053250ea28$var$iconStyles,
            $67ae9d053250ea28$var$baseHcmStyles,
            shouldScale && $67ae9d053250ea28$var$scaleStyles,
            props.type === 'utility' && $67ae9d053250ea28$var$utilityIconStyles
        ]
    }, (0, $74Zh5.jsx)("svg", {
        fill: "none",
        viewBox: "".concat(0 - viewBoxPadding, " ").concat(0 - viewBoxPadding, " ").concat(viewBoxSize, " ").concat(viewBoxSize),
        role: "presentation",
        css: [
            $67ae9d053250ea28$var$commonSVGStyles,
            $67ae9d053250ea28$var$svgStyles,
            shouldScale ? $67ae9d053250ea28$var$scaleSize : props.type === 'utility' ? $67ae9d053250ea28$var$sizeMap[props.type][(_props$spacing3 = props.spacing) !== null && _props$spacing3 !== void 0 ? _props$spacing3 : 'none'] : $67ae9d053250ea28$var$sizeMap['core'][(_props$spacing4 = props.spacing) !== null && _props$spacing4 !== void 0 ? _props$spacing4 : 'none']
        ],
        dangerouslySetInnerHTML: dangerouslySetInnerHTML
    }));
});
var $67ae9d053250ea28$export$2e2bcd8739ae039 = $67ae9d053250ea28$export$f04a61298a47a40f;

});



parcelRegister("zf9Qj", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $069f07036823b7a1$var$_react = $069f07036823b7a1$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $jCxDJ = parcelRequire("jCxDJ");

var $069f07036823b7a1$var$_chevronDown = $069f07036823b7a1$var$_interopRequireDefault((parcelRequire("1SmDc")));
function $069f07036823b7a1$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $069f07036823b7a1$var$ChevronDownIcon = (props)=>/*#__PURE__*/ $069f07036823b7a1$var$_react.default.createElement($jCxDJ.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M8.292 10.293a1.01 1.01 0 0 0 0 1.419l2.939 2.965c.218.215.5.322.779.322s.556-.107.769-.322l2.93-2.955a1.01 1.01 0 0 0 0-1.419.987.987 0 0 0-1.406 0l-2.298 2.317-2.307-2.327a.99.99 0 0 0-1.406 0"/></svg>`
    }, props, {
        newIcon: $069f07036823b7a1$var$_chevronDown.default,
        iconType: "utility"
    }));
$069f07036823b7a1$var$ChevronDownIcon.displayName = 'ChevronDownIcon';
var $069f07036823b7a1$var$_default = module.exports.default = $069f07036823b7a1$var$ChevronDownIcon;

});
parcelRegister("jCxDJ", function(module, exports) {
$parcel$export(module.exports, "IconFacade", () => $e48ba916aff03558$export$3cfb73f70dfca966);

var $kqp0i = parcelRequire("kqp0i");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");

var $id6Cu = parcelRequire("id6Cu");

var $enEer = parcelRequire("enEer");
var $e48ba916aff03558$var$_excluded = [
    "dangerouslySetGlyph"
];
var $e48ba916aff03558$var$sizeSpacingMap = {
    utility: {
        small: 'compact',
        medium: 'spacious'
    },
    core: {
        small: 'none',
        medium: 'spacious'
    }
};
var $e48ba916aff03558$export$3cfb73f70dfca966 = /*#__PURE__*/ (0, $5FkrB.memo)(function IconFacade(_ref) {
    var _props$size;
    var dangerouslySetGlyph = _ref.dangerouslySetGlyph, props = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $e48ba916aff03558$var$_excluded);
    var NewIcon = props.newIcon;
    // By default, the icon size will be medium for core icons and small for utility icons
    var size = (_props$size = props.size) !== null && _props$size !== void 0 ? _props$size : 'medium';
    var useNewIcon = !props.isFacadeDisabled && // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
    (0, $id6Cu.fg)('platform-visual-refresh-icons-legacy-facade');
    if (useNewIcon && NewIcon && (size === 'small' || size === 'medium')) {
        if (props.iconType === 'utility') {
            var Icon = NewIcon;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(Icon, (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, props, {
                spacing: (0, $id6Cu.fg)('platform-visual-refresh-icons-facade-button-fix') ? $e48ba916aff03558$var$sizeSpacingMap['utility'][size] : 'none',
                color: props.primaryColor || 'currentColor',
                type: props.iconType
            }));
        } else {
            var _Icon = NewIcon;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(_Icon, (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, props, {
                spacing: $e48ba916aff03558$var$sizeSpacingMap['core'][size],
                color: props.primaryColor || 'currentColor',
                type: props.iconType
            }));
        }
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $enEer.Icon), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        dangerouslySetGlyph: dangerouslySetGlyph
    }, props));
});

});
parcelRegister("enEer", function(module, exports) {
$parcel$export(module.exports, "Icon", () => $a7826be6f9ecf4a8$export$f04a61298a47a40f);

var $kqp0i = parcelRequire("kqp0i");

var $25nEq = parcelRequire("25nEq");

var $5FkrB = parcelRequire("5FkrB");

var $74Zh5 = parcelRequire("74Zh5");

var $8dO48 = parcelRequire("8dO48");

var $ccYVa = parcelRequire("ccYVa");
function $a7826be6f9ecf4a8$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $a7826be6f9ecf4a8$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $a7826be6f9ecf4a8$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $a7826be6f9ecf4a8$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
/**
 * We are hiding these props from consumers as they're used to
 * hack around icon sizing specifically for icon-file-type.
 */ var $a7826be6f9ecf4a8$var$iconStyles = (0, $74Zh5.css)({
    display: 'inline-block',
    flexShrink: 0,
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: 1,
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '> svg': $a7826be6f9ecf4a8$var$_objectSpread($a7826be6f9ecf4a8$var$_objectSpread({}, (0, $8dO48.commonSVGStyles)), {}, {
        maxWidth: '100%',
        maxHeight: '100%',
        color: 'var(--icon-primary-color)',
        fill: 'var(--icon-secondary-color)',
        verticalAlign: 'bottom'
    })
});
/**
 * For windows high contrast mode
 */ var $a7826be6f9ecf4a8$var$baseHcmStyles = (0, $74Zh5.css)({
    '@media screen and (forced-colors: active)': {
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '> svg': {
            filter: 'grayscale(1)',
            '--icon-primary-color': 'CanvasText',
            // foreground
            '--icon-secondary-color': 'Canvas' // background
        }
    }
});
var $a7826be6f9ecf4a8$var$primaryEqualsSecondaryHcmStyles = (0, $74Zh5.css)({
    '@media screen and (forced-colors: active)': {
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '> svg': {
            // if the primaryColor is the same as the secondaryColor we
            // set the --icon-primary-color to Canvas
            // this is usually to convey state i.e. Checkbox checked -> not checked
            '--icon-primary-color': 'Canvas' // foreground
        }
    }
});
var $a7826be6f9ecf4a8$var$secondaryTransparentHcmStyles = (0, $74Zh5.css)({
    '@media screen and (forced-colors: active)': {
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '> svg': {
            '--icon-secondary-color': 'transparent' // background
        }
    }
});
var $a7826be6f9ecf4a8$export$f04a61298a47a40f = /*#__PURE__*/ (0, $5FkrB.memo)(function Icon(props) {
    var _ref = props, Glyph = _ref.glyph, dangerouslySetGlyph = _ref.dangerouslySetGlyph, _ref$primaryColor = _ref.primaryColor, primaryColor = _ref$primaryColor === void 0 ? 'currentColor' : _ref$primaryColor, secondaryColor = _ref.secondaryColor, size = _ref.size, testId = _ref.testId, label = _ref.label, width = _ref.width, height = _ref.height, UNSAFE_margin = _ref.UNSAFE_margin;
    var glyphProps = dangerouslySetGlyph ? {
        dangerouslySetInnerHTML: {
            __html: dangerouslySetGlyph
        }
    } : {
        children: Glyph ? (0, $74Zh5.jsx)(Glyph, {
            role: "presentation"
        }) : null
    };
    var dimensions = (0, $8dO48.getIconSize)({
        width: width,
        height: height,
        size: size
    });
    return (0, $74Zh5.jsx)("span", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        "data-testid": testId,
        "data-vc": "icon-".concat(testId),
        role: label ? 'img' : undefined,
        "aria-label": label ? label : undefined,
        "aria-hidden": label ? undefined : true,
        style: {
            '--icon-primary-color': primaryColor,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            '--icon-secondary-color': secondaryColor || (0, $ccYVa.getBackground)(),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            margin: UNSAFE_margin
        }
    }, glyphProps, {
        css: [
            $a7826be6f9ecf4a8$var$iconStyles,
            $a7826be6f9ecf4a8$var$baseHcmStyles,
            primaryColor === secondaryColor && $a7826be6f9ecf4a8$var$primaryEqualsSecondaryHcmStyles,
            secondaryColor === 'transparent' && $a7826be6f9ecf4a8$var$secondaryTransparentHcmStyles,
            // NB: This can be resolved if this component, composes base SVG / and/or skeleton
            // We could then simplify how common styles are dealt with simply by encapsulating them
            // at their appropriate level and/or having a singular approach to css variables in the package
            dimensions && // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $74Zh5.css)({
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                width: dimensions.width,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                height: dimensions.height,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                '> svg': dimensions
            })
        ]
    }));
});
var $a7826be6f9ecf4a8$export$2e2bcd8739ae039 = $a7826be6f9ecf4a8$export$f04a61298a47a40f;

});
parcelRegister("8dO48", function(module, exports) {
$parcel$export(module.exports, "commonSVGStyles", () => $5fc65fa2d313bc2a$export$16374db1c3e6dfba);
$parcel$export(module.exports, "sizeStyleMap", () => $5fc65fa2d313bc2a$export$ef0ad74202575b64);
$parcel$export(module.exports, "getIconSize", () => $5fc65fa2d313bc2a$export$3eb7d6130acfda37);

var $8eT8I = parcelRequire("8eT8I");

var $74Zh5 = parcelRequire("74Zh5");
var $5fc65fa2d313bc2a$export$16374db1c3e6dfba = {
    overflow: 'hidden',
    pointerEvents: 'none',
    /**
   * Stop-color doesn't properly apply in chrome when the inherited/current color changes.
   * We have to initially set stop-color to inherit (either via DOM attribute or an initial CSS
   * rule) and then override it with currentColor for the color changes to be picked up.
   */ stop: {
        stopColor: 'currentColor'
    }
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
var $5fc65fa2d313bc2a$var$smallStyles = (0, $74Zh5.css)((0, $8eT8I.dimensions).small);
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
var $5fc65fa2d313bc2a$var$mediumStyles = (0, $74Zh5.css)((0, $8eT8I.dimensions).medium);
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
var $5fc65fa2d313bc2a$var$largeStyles = (0, $74Zh5.css)((0, $8eT8I.dimensions).large);
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
var $5fc65fa2d313bc2a$var$xlargeStyles = (0, $74Zh5.css)((0, $8eT8I.dimensions).xlarge);
var $5fc65fa2d313bc2a$export$ef0ad74202575b64 = {
    small: $5fc65fa2d313bc2a$var$smallStyles,
    medium: $5fc65fa2d313bc2a$var$mediumStyles,
    large: $5fc65fa2d313bc2a$var$largeStyles,
    xlarge: $5fc65fa2d313bc2a$var$xlargeStyles
};
var $5fc65fa2d313bc2a$export$3eb7d6130acfda37 = function getIconSize(_ref) {
    var width = _ref.width, height = _ref.height, size = _ref.size;
    if (width && height) return {
        width: width,
        height: height
    };
    if (size) return (0, $8eT8I.dimensions)[size];
    return undefined;
};

});
parcelRegister("8eT8I", function(module, exports) {
$parcel$export(module.exports, "dimensions", () => $5ffa67183db67e18$export$62ad7b0c781000e9);
var $5ffa67183db67e18$export$c647cb0ee6e282fe = {
    small: '16px',
    medium: '24px',
    large: '32px',
    xlarge: '48px'
};
var $5ffa67183db67e18$export$7bd66fc94c81bf84 = {
    small: 'small',
    medium: 'medium',
    large: 'large',
    xlarge: 'xlarge'
};
var $5ffa67183db67e18$export$62ad7b0c781000e9 = {
    small: {
        width: $5ffa67183db67e18$export$c647cb0ee6e282fe.small,
        height: $5ffa67183db67e18$export$c647cb0ee6e282fe.small
    },
    medium: {
        width: $5ffa67183db67e18$export$c647cb0ee6e282fe.medium,
        height: $5ffa67183db67e18$export$c647cb0ee6e282fe.medium
    },
    large: {
        width: $5ffa67183db67e18$export$c647cb0ee6e282fe.large,
        height: $5ffa67183db67e18$export$c647cb0ee6e282fe.large
    },
    xlarge: {
        width: $5ffa67183db67e18$export$c647cb0ee6e282fe.xlarge,
        height: $5ffa67183db67e18$export$c647cb0ee6e282fe.xlarge
    }
};

});


parcelRegister("ccYVa", function(module, exports) {
$parcel$export(module.exports, "getBackground", () => $8e35dcb3196909bc$export$18cb9425622d4e06);
var $8e35dcb3196909bc$export$18cb9425622d4e06 = function getBackground() {
    return "var(--ds-surface, #FFFFFF)";
};

});




parcelRegister("3oMHR", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3f93f06e22108e36edaead143b4f646b>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $27996513631f9138$var$_react = $27996513631f9138$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $27996513631f9138$var$_baseNew = $27996513631f9138$var$_interopRequireDefault((parcelRequire("8DiDr")));
function $27996513631f9138$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "StatusError".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for error statuses and messaging.
Filled status icons provide higher visual contrast to draw attention to important information.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $27996513631f9138$var$StatusErrorIcon = (props)=>/*#__PURE__*/ $27996513631f9138$var$_react.default.createElement($27996513631f9138$var$_baseNew.default, Object.assign({
        name: "StatusErrorIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6.586.603a2 2 0 0 1 2.828 0l5.983 5.983a2 2 0 0 1 0 2.828l-5.983 5.982a2 2 0 0 1-2.828 0L.604 9.414a2 2 0 0 1 0-2.828zM8 10.25a1 1 0 1 0 0 2 1 1 0 0 0 0-2m-.75-6.5V9h1.5V3.75z" clip-rule="evenodd"/>`
    }, props));
$27996513631f9138$var$StatusErrorIcon.displayName = 'StatusErrorIcon';
var $27996513631f9138$var$_default = module.exports.default = $27996513631f9138$var$StatusErrorIcon;

});
parcelRegister("8DiDr", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => (parcelRequire("f2y9x")).default);
$parcel$export(module.exports, "Icon", () => (parcelRequire("f2y9x")).Icon);

var $f2y9x = parcelRequire("f2y9x");

});
parcelRegister("f2y9x", function(module, exports) {
$parcel$export(module.exports, "Icon", () => $af3188f823dbfb24$export$f04a61298a47a40f);
$parcel$export(module.exports, "default", () => $af3188f823dbfb24$export$2e2bcd8739ae039);
/* icon-new.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");

var $id6Cu = parcelRequire("id6Cu");
/**
 * We are hiding this props from consumers as it's reserved
 * for use by Icon Tile.
 */ var $af3188f823dbfb24$var$svgStyles = null;
var $af3188f823dbfb24$var$iconStyles = null;
var $af3188f823dbfb24$var$utilityIconStyles = null;
var $af3188f823dbfb24$var$scaleStyles = null;
/**
 * For windows high contrast mode
 */ var $af3188f823dbfb24$var$baseHcmStyles = null;
var $af3188f823dbfb24$var$scaleSize = null;
var $af3188f823dbfb24$var$coreSizeMedium = {
    none: "_1bsbpxbi _4t3ipxbi",
    compact: "_1bsb1ejb _4t3i1ejb",
    spacious: "_1bsb1ejb _4t3i1ejb"
};
var $af3188f823dbfb24$var$coreSizeSmall = {
    none: "_1bsbutpp _4t3iutpp",
    compact: "_1bsbpxbi _4t3ipxbi",
    spacious: "_1bsb1ejb _4t3i1ejb"
};
var $af3188f823dbfb24$var$utilSizes = {
    none: "_1bsbutpp _4t3iutpp",
    compact: "_1bsbpxbi _4t3ipxbi",
    spacious: "_1bsb1ejb _4t3i1ejb"
};
var $af3188f823dbfb24$var$baseSizeMap = {
    core: 16,
    utility: 12
};
var $af3188f823dbfb24$var$paddingMap = {
    core: {
        medium: {
            none: 0,
            compact: 4,
            spacious: 4
        },
        small: {
            none: 0,
            compact: 2.66,
            spacious: 8
        }
    },
    utility: {
        medium: {
            none: 0,
            compact: 2,
            spacious: 6
        },
        small: {
            none: 0,
            compact: 2,
            spacious: 6
        }
    }
};
var $af3188f823dbfb24$export$f04a61298a47a40f = /*#__PURE__*/ (0, $5FkrB.memo)(function Icon(props) {
    var _props$type;
    var _ref = props, _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, testId = _ref.testId, label = _ref.label, LEGACY_primaryColor = _ref.LEGACY_primaryColor, LEGACY_secondaryColor = _ref.LEGACY_secondaryColor, LEGACY_size = _ref.LEGACY_size, FallbackIcon = _ref.LEGACY_fallbackIcon, dangerouslySetGlyph = _ref.dangerouslySetGlyph, shouldScale = _ref.shouldScale, LEGACY_margin = _ref.LEGACY_margin, _ref$spacing = _ref.spacing, spacing = _ref$spacing === void 0 ? 'none' : _ref$spacing, name = _ref.name;
    var dangerouslySetInnerHTML = dangerouslySetGlyph ? {
        __html: dangerouslySetGlyph
    } : undefined;
    // Fall back to old icon
    if (FallbackIcon && !(0, $id6Cu.fg)('platform-visual-refresh-icons')) // parse out unnecessary props
    return /*#__PURE__*/ $5FkrB.createElement(FallbackIcon, {
        primaryColor: LEGACY_primaryColor !== null && LEGACY_primaryColor !== void 0 ? LEGACY_primaryColor : color,
        secondaryColor: LEGACY_secondaryColor,
        size: LEGACY_size,
        label: label,
        testId: testId,
        UNSAFE_margin: LEGACY_margin
    });
    var type = (_props$type = props.type) !== null && _props$type !== void 0 ? _props$type : 'core';
    var size = 'medium';
    if ('size' in props && props.size !== undefined) {
        if (typeof props.size === 'string') size = props.size === 'small' || props.size === 'medium' ? props.size : size;
        else if (name) {
            var newSize = props.size(name);
            size = newSize === 'small' || newSize === 'medium' ? newSize : size;
        }
    }
    var baseSize = $af3188f823dbfb24$var$baseSizeMap[type];
    var viewBoxPadding = $af3188f823dbfb24$var$paddingMap[type][size][spacing];
    var viewBoxSize = baseSize + 2 * viewBoxPadding;
    return /*#__PURE__*/ $5FkrB.createElement("span", {
        "data-testid": testId,
        role: label ? 'img' : undefined,
        "aria-label": label ? label : undefined,
        "aria-hidden": label ? undefined : true,
        style: {
            color: color
        },
        className: (0, $970q7.default)([
            "_1e0c1o8l _vchhusvi _1o9zidpf _vwz4kb7n _y4ti1igz _bozg1mb9",
            "_12va1onz _jcxd1r8n",
            shouldScale && "_1bsb1kw7 _4t3i1kw7",
            (type === 'utility' || size === 'small') && "_vwz4utpp"
        ])
    }, /*#__PURE__*/ $5FkrB.createElement("svg", {
        fill: "none",
        viewBox: "".concat(0 - viewBoxPadding, " ").concat(0 - viewBoxPadding, " ").concat(viewBoxSize, " ").concat(viewBoxSize),
        role: "presentation",
        dangerouslySetInnerHTML: dangerouslySetInnerHTML,
        className: (0, $970q7.default)([
            "_1reo15vq _18m915vq _syaz1r31 _lcxvglyw _s7n4yfq0 _vc881r31",
            shouldScale ? "_1bsb1kw7 _4t3i1kw7" : type === 'utility' ? $af3188f823dbfb24$var$utilSizes[spacing] : size === 'small' ? $af3188f823dbfb24$var$coreSizeSmall[spacing] : $af3188f823dbfb24$var$coreSizeMedium[spacing]
        ])
    }));
});
var $af3188f823dbfb24$export$2e2bcd8739ae039 = $af3188f823dbfb24$export$f04a61298a47a40f;

});



parcelRegister("e08VJ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a317fe188f7b9e4c$var$_react = $a317fe188f7b9e4c$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $l2qxx = parcelRequire("l2qxx");
function $a317fe188f7b9e4c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $a317fe188f7b9e4c$var$ErrorIcon = (props)=>/*#__PURE__*/ $a317fe188f7b9e4c$var$_react.default.createElement($l2qxx.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><path fill="currentcolor" d="M13.416 4.417a2 2 0 0 0-2.832 0l-6.168 6.167a2 2 0 0 0 0 2.833l6.168 6.167a2 2 0 0 0 2.832 0l6.168-6.167a2 2 0 0 0 0-2.833z"/><path fill="inherit" d="M12 14a1 1 0 0 1-1-1V8a1 1 0 0 1 2 0v5a1 1 0 0 1-1 1m0 3a1 1 0 0 1 0-2 1 1 0 0 1 0 2"/></g></svg>`
    }, props));
$a317fe188f7b9e4c$var$ErrorIcon.displayName = 'ErrorIcon';
var $a317fe188f7b9e4c$var$_default = module.exports.default = $a317fe188f7b9e4c$var$ErrorIcon;

});
parcelRegister("l2qxx", function(module, exports) {
$parcel$export(module.exports, "Icon", () => $f50e5f2d18686266$export$f04a61298a47a40f);
/* icon.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $kqp0i = parcelRequire("kqp0i");

var $25nEq = parcelRequire("25nEq");

var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");
function $f50e5f2d18686266$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $f50e5f2d18686266$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $f50e5f2d18686266$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $f50e5f2d18686266$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
/**
 * We are hiding these props from consumers as they're used to
 * hack around icon sizing specifically for icon-file-type.
 */ var $f50e5f2d18686266$var$iconStyles = null;
var $f50e5f2d18686266$var$sizeStyles = {
    small: "_1bsb7vkz _4t3i7vkz _5fdi7vkz _zbji7vkz",
    medium: "_1bsb1tcg _4t3i1tcg _5fdi1tcg _zbji1tcg",
    large: "_1bsbzwfg _4t3izwfg _5fdizwfg _zbjizwfg",
    xlarge: "_1bsbckbl _4t3ickbl _5fdickbl _zbjickbl"
};
/**
 * For windows high contrast mode
 */ var $f50e5f2d18686266$var$baseHcmStyles = null;
var $f50e5f2d18686266$var$primaryEqualsSecondaryHcmStyles = null;
var $f50e5f2d18686266$var$secondaryTransparentHcmStyles = null;
var $f50e5f2d18686266$export$f04a61298a47a40f = /*#__PURE__*/ (0, $5FkrB.memo)(function Icon(props) {
    var _ref = props, Glyph = _ref.glyph, dangerouslySetGlyph = _ref.dangerouslySetGlyph, _ref$primaryColor = _ref.primaryColor, primaryColor = _ref$primaryColor === void 0 ? 'currentColor' : _ref$primaryColor, secondaryColor = _ref.secondaryColor, size = _ref.size, testId = _ref.testId, label = _ref.label, width = _ref.width, height = _ref.height, UNSAFE_margin = _ref.UNSAFE_margin;
    var glyphProps = dangerouslySetGlyph ? {
        dangerouslySetInnerHTML: {
            __html: dangerouslySetGlyph
        }
    } : {
        children: Glyph ? /*#__PURE__*/ $5FkrB.createElement(Glyph, {
            role: "presentation"
        }) : null
    };
    var customDimensions = width && height ? {
        width: width + 'px',
        height: height + 'px'
    } : null;
    return /*#__PURE__*/ $5FkrB.createElement("span", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        "data-testid": testId,
        "data-vc": "icon-".concat(testId),
        role: label ? 'img' : undefined,
        "aria-label": label ? label : undefined,
        "aria-hidden": label ? undefined : true,
        style: $f50e5f2d18686266$var$_objectSpread($f50e5f2d18686266$var$_objectSpread({}, customDimensions), {}, {
            '--icon-primary-color': primaryColor,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            '--icon-secondary-color': secondaryColor,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            margin: UNSAFE_margin
        })
    }, glyphProps, {
        className: (0, $970q7.default)([
            "_1e0c1o8l _1o9zidpf _vyfuvuon _vwz4kb7n _1szv15vq _1tly15vq _rzyw1osq _17jb1osq _1ksvoz0e _3se1x1jp _re2rglyw _1veoyfq0 _1kg81r31",
            "_jcxd1r8n _gq0g1onz _1trkwc43",
            primaryColor === secondaryColor && "_18hbwc43",
            secondaryColor === 'transparent' && "_4fyi1j28",
            size && $f50e5f2d18686266$var$sizeStyles[size]
        ])
    }));
});
var $f50e5f2d18686266$export$2e2bcd8739ae039 = $f50e5f2d18686266$export$f04a61298a47a40f;

});


parcelRegister("kxD1Z", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::174472a7e38932dc7a97866e0be8034a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $03dbf44c4cf47a0f$var$_react = $03dbf44c4cf47a0f$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $03dbf44c4cf47a0f$var$_baseNew = $03dbf44c4cf47a0f$var$_interopRequireDefault((parcelRequire("8DiDr")));
function $03dbf44c4cf47a0f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "StatusSuccess".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for success statuses and messaging. Filled status icons provide higher visual contrast to draw attention to important information.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $03dbf44c4cf47a0f$var$StatusSuccessIcon = (props)=>/*#__PURE__*/ $03dbf44c4cf47a0f$var$_react.default.createElement($03dbf44c4cf47a0f$var$_baseNew.default, Object.assign({
        name: "StatusSuccessIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0M6.75 9.828 4.826 7.52l-1.152.96 2.5 3a.75.75 0 0 0 1.152 0l5-6-1.152-.96z" clip-rule="evenodd"/>`
    }, props));
$03dbf44c4cf47a0f$var$StatusSuccessIcon.displayName = 'StatusSuccessIcon';
var $03dbf44c4cf47a0f$var$_default = module.exports.default = $03dbf44c4cf47a0f$var$StatusSuccessIcon;

});

parcelRegister("ksBYL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ee53e20c28854e87$var$_react = $ee53e20c28854e87$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $l2qxx = parcelRequire("l2qxx");
function $ee53e20c28854e87$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $ee53e20c28854e87$var$EditorSuccessIcon = (props)=>/*#__PURE__*/ $ee53e20c28854e87$var$_react.default.createElement($l2qxx.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M12 20a8 8 0 1 1 0-16 8 8 0 0 1 0 16m1.364-10.964-2.152 4.11-1.543-1.39a1 1 0 1 0-1.338 1.487l2.5 2.25a1 1 0 0 0 1.555-.279l2.75-5.25a1 1 0 0 0-1.772-.928"/></svg>`
    }, props));
$ee53e20c28854e87$var$EditorSuccessIcon.displayName = 'EditorSuccessIcon';
var $ee53e20c28854e87$var$_default = module.exports.default = $ee53e20c28854e87$var$EditorSuccessIcon;

});

parcelRegister("3j4LJ", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::1b6fc123789ae26535b6e4ca13d1b4ea>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2686d86dd536748f$var$_react = $2686d86dd536748f$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $2686d86dd536748f$var$_UNSAFE_baseNew = $2686d86dd536748f$var$_interopRequireDefault((parcelRequire("kjkwu")));
function $2686d86dd536748f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "ShowMoreHorizontal".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for more action menus.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $2686d86dd536748f$var$ShowMoreHorizontalIcon = (props)=>/*#__PURE__*/ $2686d86dd536748f$var$_react.default.createElement($2686d86dd536748f$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="M2.25 8a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0m6.5 0a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0m6.5 0a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0"/><path stroke="currentcolor" stroke-width="1.5" d="M2.25 8a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0Zm6.5 0a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0Zm6.5 0a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0Z"/>`
    }, props));
$2686d86dd536748f$var$ShowMoreHorizontalIcon.displayName = 'ShowMoreHorizontalIcon';
var $2686d86dd536748f$var$_default = module.exports.default = $2686d86dd536748f$var$ShowMoreHorizontalIcon;

});

parcelRegister("lw4o3", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => (parcelRequire("4VVyZ")).default);
$parcel$export(module.exports, "Icon", () => (parcelRequire("4VVyZ")).Icon);

var $4VVyZ = parcelRequire("4VVyZ");

});
parcelRegister("4VVyZ", function(module, exports) {
$parcel$export(module.exports, "Icon", () => $397923276d004f27$export$f04a61298a47a40f);
$parcel$export(module.exports, "default", () => $397923276d004f27$export$2e2bcd8739ae039);
/* icon-new.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");
/**
 * We are hiding this props from consumers as it's reserved
 * for use by Icon Tile.
 */ var $397923276d004f27$var$svgStyles = null;
var $397923276d004f27$var$iconStyles = null;
var $397923276d004f27$var$smallIconStyles = null;
var $397923276d004f27$var$scaleStyles = null;
/**
 * For windows high contrast mode
 */ var $397923276d004f27$var$baseHcmStyles = null;
var $397923276d004f27$var$scaleSize = null;
var $397923276d004f27$var$coreSizeMedium = {
    none: "_1bsbpxbi _4t3ipxbi",
    compact: "_1bsb1ejb _4t3i1ejb",
    spacious: "_1bsb1ejb _4t3i1ejb"
};
var $397923276d004f27$var$coreSizeSmall = {
    none: "_1bsbutpp _4t3iutpp",
    compact: "_1bsbpxbi _4t3ipxbi",
    spacious: "_1bsb1ejb _4t3i1ejb"
};
var $397923276d004f27$var$paddingMap = {
    medium: {
        none: 0,
        compact: 4,
        spacious: 4
    },
    small: {
        none: 0,
        compact: 2.66,
        spacious: 8
    }
};
var $397923276d004f27$export$f04a61298a47a40f = /*#__PURE__*/ (0, $5FkrB.memo)(function Icon(props) {
    var _ref = props, _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, testId = _ref.testId, label = _ref.label, dangerouslySetGlyph = _ref.dangerouslySetGlyph, shouldScale = _ref.shouldScale, _ref$spacing = _ref.spacing, spacing = _ref$spacing === void 0 ? 'none' : _ref$spacing, name = _ref.name;
    var dangerouslySetInnerHTML = dangerouslySetGlyph ? {
        __html: dangerouslySetGlyph
    } : undefined;
    var size = 'medium';
    if ('size' in props && props.size !== undefined) {
        if (typeof props.size === 'string') size = props.size === 'small' || props.size === 'medium' ? props.size : size;
        else if (name) {
            var newSize = props.size(name);
            size = newSize === 'small' || newSize === 'medium' ? newSize : size;
        }
    }
    var baseSize = 16;
    var viewBoxPadding = $397923276d004f27$var$paddingMap[size][spacing];
    var viewBoxSize = baseSize + 2 * viewBoxPadding;
    return /*#__PURE__*/ $5FkrB.createElement("span", {
        "data-testid": testId,
        role: label ? 'img' : undefined,
        "aria-label": label ? label : undefined,
        "aria-hidden": label ? undefined : true,
        style: {
            color: color
        },
        className: (0, $970q7.default)([
            "_1e0c1o8l _vchhusvi _1o9zidpf _vwz4kb7n _y4ti1igz _bozg1mb9",
            "_12va1onz _jcxd1r8n",
            shouldScale && "_1bsb1kw7 _4t3i1kw7",
            size === 'small' && "_vwz4utpp"
        ])
    }, /*#__PURE__*/ $5FkrB.createElement("svg", {
        fill: "none",
        viewBox: "".concat(0 - viewBoxPadding, " ").concat(0 - viewBoxPadding, " ").concat(viewBoxSize, " ").concat(viewBoxSize),
        role: "presentation",
        dangerouslySetInnerHTML: dangerouslySetInnerHTML,
        className: (0, $970q7.default)([
            "_1reo15vq _18m915vq _syaz1r31 _lcxvglyw _s7n4yfq0 _vc881r31",
            shouldScale ? "_1bsb1kw7 _4t3i1kw7" : size === 'small' ? $397923276d004f27$var$coreSizeSmall[spacing] : $397923276d004f27$var$coreSizeMedium[spacing]
        ])
    }));
});
var $397923276d004f27$export$2e2bcd8739ae039 = $397923276d004f27$export$f04a61298a47a40f;

});


parcelRegister("bAhZ8", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $86f101f6cbb0f65e$var$_react = $86f101f6cbb0f65e$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $86f101f6cbb0f65e$var$_spinner = $86f101f6cbb0f65e$var$_interopRequireDefault((parcelRequire("98ZMc")));
function $86f101f6cbb0f65e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
var $86f101f6cbb0f65e$var$LoadingSpinner = function LoadingSpinner() {
    return /*#__PURE__*/ $86f101f6cbb0f65e$var$_react["default"].createElement("div", {
        style: $86f101f6cbb0f65e$var$spinnerStyles
    }, /*#__PURE__*/ $86f101f6cbb0f65e$var$_react["default"].createElement($86f101f6cbb0f65e$var$_spinner["default"], {
        interactionName: "load",
        size: "xlarge"
    }));
};
var $86f101f6cbb0f65e$var$_default = module.exports["default"] = $86f101f6cbb0f65e$var$LoadingSpinner;
var $86f101f6cbb0f65e$var$spinnerStyles = {
    position: 'fixed',
    left: '50%',
    top: '350px'
};

});
parcelRegister("98ZMc", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => (parcelRequire("QCI6S")).default);

var $QCI6S = parcelRequire("QCI6S");

});
parcelRegister("QCI6S", function(module, exports) {
$parcel$export(module.exports, "default", () => $09e2e288466f605e$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5FkrB = parcelRequire("5FkrB");

var $74Zh5 = parcelRequire("74Zh5");

var $dxYZv = parcelRequire("dxYZv");

var $kfcAZ = parcelRequire("kfcAZ");

var $iwXJJ = parcelRequire("iwXJJ");
/**
 * Returns the appropriate circle stroke color.
 */ function $09e2e288466f605e$var$getStrokeColor(appearance) {
    return appearance === 'inherit' ? "var(--ds-icon-subtle, ".concat((0, $kfcAZ.N500), ")") : "var(--ds-icon-inverse, ".concat((0, $kfcAZ.N0), ")");
}
var $09e2e288466f605e$var$rotate = (0, $74Zh5.keyframes)({
    to: {
        transform: 'rotate(360deg)'
    }
});
var $09e2e288466f605e$var$rotateStyles = (0, $74Zh5.css)({
    animation: "".concat($09e2e288466f605e$var$rotate, " 0.86s infinite"),
    animationTimingFunction: 'cubic-bezier(0.4, 0.15, 0.6, 0.85)',
    transformOrigin: 'center'
});
/**
 * There are three parts to the load in animation:
 * 1. Fade in
 * 2. Accelerated spin
 * 3. Stretch the spinner line
 */ var $09e2e288466f605e$var$loadIn = (0, $74Zh5.keyframes)({
    from: {
        transform: 'rotate(50deg)',
        opacity: 0,
        strokeDashoffset: 60
    },
    to: {
        transform: 'rotate(230deg)',
        opacity: 1,
        strokeDashoffset: 50
    }
});
var $09e2e288466f605e$var$loadInStyles = (0, $74Zh5.css)({
    animation: "".concat($09e2e288466f605e$var$loadIn, " 1s ease-in-out"),
    /**
   * When the animation completes, stay at the last frame of the animation.
   */ animationFillMode: 'forwards',
    /**
   * We are going to animate this in.
   */ opacity: 0
});
var $09e2e288466f605e$var$wrapperStyles = (0, $74Zh5.css)({
    display: 'inline-flex',
    /**
   * Align better inline with text.
   */ verticalAlign: 'middle'
});
var $09e2e288466f605e$var$circleStyles = (0, $74Zh5.css)({
    fill: 'none',
    strokeDasharray: 60,
    strokeDashoffset: 'inherit',
    strokeLinecap: 'round',
    strokeWidth: 1.5,
    '@media screen and (forced-colors: active)': {
        filter: 'grayscale(100%)',
        stroke: 'CanvasText'
    }
});
/**
 * `useLayoutEffect` is being used in SSR safe form. On the server, this work doesn’t need to run.
 * `useEffect` is used in-place, because `useEffect` is not run on the server and it matches types
 * which makes things simpler than doing an `isServer` check or a `null` check.
 *
 * @see https://hello.atlassian.net/wiki/spaces/DST/pages/2081696628/DSTDACI-010+-+Interaction+Tracing+hooks+in+DS+components
 */ var $09e2e288466f605e$var$useLayoutEffect = typeof window === 'undefined' ? (0, $5FkrB.useEffect) : (0, $5FkrB.useLayoutEffect);
/**
 * __Spinner__
 *
 * A spinner is an animated spinning icon that lets users know content is being loaded.
 *
 * - [Examples](https://atlassian.design/components/spinner/examples)
 * - [Code](https://atlassian.design/components/spinner/code)
 * - [Usage](https://atlassian.design/components/spinner/usage)
 */ var $09e2e288466f605e$var$Spinner = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).forwardRef(function Spinner(_ref, ref) {
    var _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'inherit' : _ref$appearance, _ref$delay = _ref.delay, delay = _ref$delay === void 0 ? 0 : _ref$delay, interactionName = _ref.interactionName, label = _ref.label, _ref$size = _ref.size, providedSize = _ref$size === void 0 ? 'medium' : _ref$size, testId = _ref.testId;
    var size = typeof providedSize === 'number' ? providedSize : (0, $iwXJJ.presetSizes)[providedSize];
    var animationDelay = "".concat(delay, "ms");
    var stroke = $09e2e288466f605e$var$getStrokeColor(appearance);
    var context = (0, $5FkrB.useContext)((0, $dxYZv.default));
    $09e2e288466f605e$var$useLayoutEffect(function() {
        if (context != null) return context.hold(interactionName);
    }, [
        context,
        interactionName
    ]);
    /**
   * The Spinner animation uses a combination of two
   * css animations on two separate elements.
   */ return (0, $74Zh5.jsx)("span", {
        /**
     * This span exists to off-load animations from the circle element,
     * which were causing performance issues (style recalculations)
     * on Safari and older versions of Chrome.
     *
     * This can be removed and styles placed back on the circle element once
     * Safari fixes this bug and off-loads rendering to the GPU from the CPU.
     */ css: [
            $09e2e288466f605e$var$wrapperStyles,
            $09e2e288466f605e$var$rotateStyles
        ],
        "data-testid": testId && "".concat(testId, "-wrapper"),
        style: {
            animationDelay: animationDelay,
            width: size,
            height: size
        }
    }, (0, $74Zh5.jsx)("svg", {
        height: size,
        width: size,
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg",
        "data-testid": testId,
        ref: ref,
        "aria-label": label || undefined,
        css: $09e2e288466f605e$var$loadInStyles,
        style: {
            animationDelay: animationDelay
        },
        role: label ? 'img' : 'none'
    }, (0, $74Zh5.jsx)("circle", {
        cx: "8",
        cy: "8",
        r: "7",
        css: $09e2e288466f605e$var$circleStyles,
        style: {
            stroke: stroke
        }
    })));
}));
var $09e2e288466f605e$export$2e2bcd8739ae039 = $09e2e288466f605e$var$Spinner;

});
parcelRegister("dxYZv", function(module, exports) {
$parcel$export(module.exports, "default", () => $9dcdaafbde52f503$export$2e2bcd8739ae039);

var $5FkrB = parcelRequire("5FkrB");
var $9dcdaafbde52f503$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $5FkrB.createContext)(null);

});

parcelRegister("kfcAZ", function(module, exports) {
$parcel$export(module.exports, "N0", () => $ebcefa9befae152b$export$29a4f05edc054374);
$parcel$export(module.exports, "N500", () => $ebcefa9befae152b$export$c39c0fe0f26207ae);
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ // Reds
var $ebcefa9befae152b$export$4b84fd0e2c617bd = '#FFEBE6';
var $ebcefa9befae152b$export$b34b069eff244586 = '#FFBDAD';
var $ebcefa9befae152b$export$be802dd0d8b57f35 = '#FF8F73';
var $ebcefa9befae152b$export$60847d42f9da92a6 = '#FF7452';
var $ebcefa9befae152b$export$4a7404f376229999 = '#FF5630';
var $ebcefa9befae152b$export$2010d0fb4295b346 = '#DE350B';
var $ebcefa9befae152b$export$2837b5a1a71d5c02 = '#BF2600';
var $ebcefa9befae152b$export$8d9596b529bbb9cf = '#FFFAE6';
var $ebcefa9befae152b$export$41060a744ab0b7ae = '#FFF0B3';
var $ebcefa9befae152b$export$1cc05bbbf340e559 = '#FFE380';
var $ebcefa9befae152b$export$5aae31392d72caaa = '#FFC400';
var $ebcefa9befae152b$export$c6930421db9fa514 = '#FFAB00';
var $ebcefa9befae152b$export$59619663aa6500fb = '#FF991F';
var $ebcefa9befae152b$export$874739ea9e379ab6 = '#FF8B00';
var $ebcefa9befae152b$export$8a6341c32b6a3ee6 = '#E3FCEF';
var $ebcefa9befae152b$export$69a3bf21b9686c2b = '#ABF5D1';
var $ebcefa9befae152b$export$afbce1382ec95f73 = '#79F2C0';
var $ebcefa9befae152b$export$747d86715d4175de = '#57D9A3';
var $ebcefa9befae152b$export$940e1f69e873f202 = '#36B37E';
var $ebcefa9befae152b$export$a49394138f7b8e85 = '#00875A';
var $ebcefa9befae152b$export$6fa04827ac68a4fb = '#006644';
var $ebcefa9befae152b$export$226de0355ed012f8 = '#DEEBFF';
var $ebcefa9befae152b$export$8c13c2ee36917869 = '#B3D4FF';
var $ebcefa9befae152b$export$ecfc1dff386a3e7a = '#4C9AFF';
var $ebcefa9befae152b$export$215b7063051591f1 = '#2684FF';
var $ebcefa9befae152b$export$e62e8919cca44969 = '#0065FF';
var $ebcefa9befae152b$export$b3de0ae08da2ce64 = '#0052CC';
var $ebcefa9befae152b$export$a6ee3d71bc067634 = '#0747A6';
var $ebcefa9befae152b$export$67f15409e87642a1 = '#669DF1';
var $ebcefa9befae152b$export$f0539dbc42dbb067 = '#8FB8F6';
var $ebcefa9befae152b$export$363e4475840015bb = '#EAE6FF';
var $ebcefa9befae152b$export$4b0a4417ed59760f = '#C0B6F2';
var $ebcefa9befae152b$export$6011520a64d9a187 = '#998DD9';
var $ebcefa9befae152b$export$a7175d4e9206bc80 = '#8777D9';
var $ebcefa9befae152b$export$b48405b95304b5a1 = '#6554C0';
var $ebcefa9befae152b$export$c71e4279dd54a18d = '#5243AA';
var $ebcefa9befae152b$export$147899de772240ec = '#403294';
var $ebcefa9befae152b$export$2cf711fe14c66f06 = '#E6FCFF';
var $ebcefa9befae152b$export$7a8f4d33f6f9772c = '#B3F5FF';
var $ebcefa9befae152b$export$776c9c497ef08533 = '#79E2F2';
var $ebcefa9befae152b$export$69cb3ca10c1e330e = '#00C7E6';
var $ebcefa9befae152b$export$9dc1ef0f3f48059b = '#00B8D9';
var $ebcefa9befae152b$export$7c835c78b6fcdef8 = '#00A3BF';
var $ebcefa9befae152b$export$6036577f95c3877e = '#008DA6';
var $ebcefa9befae152b$export$29a4f05edc054374 = '#FFFFFF';
var $ebcefa9befae152b$export$e655ef011c4aa1a2 = '#FAFBFC';
var $ebcefa9befae152b$export$9fdfb749e33cdf97 = '#F4F5F7';
var $ebcefa9befae152b$export$3e51e8f1440314ba = '#EBECF0';
var $ebcefa9befae152b$export$1ce2d1575d444ceb = '#DFE1E6';
var $ebcefa9befae152b$export$8754fc7e6d8b3000 = '#C1C7D0';
var $ebcefa9befae152b$export$c2e91cbeada39b8b = '#B3BAC5';
var $ebcefa9befae152b$export$5f71e19f3a7ad9de = '#A5ADBA';
var $ebcefa9befae152b$export$eaa8c8a70ac22806 = '#97A0AF';
var $ebcefa9befae152b$export$7c87d337fb91a97d = '#8993A4';
var $ebcefa9befae152b$export$d6447c357493214f = '#7A869A';
var $ebcefa9befae152b$export$f563ee71e9ee74cd = '#6B778C';
var $ebcefa9befae152b$export$e2ef2124cf4024b1 = '#5E6C84';
var $ebcefa9befae152b$export$eece5f492e429f08 = '#505F79';
var $ebcefa9befae152b$export$c39c0fe0f26207ae = '#42526E';
var $ebcefa9befae152b$export$7090862dc3038a9f = '#344563';
var $ebcefa9befae152b$export$ad0bacf983b7ddaa = '#253858';
var $ebcefa9befae152b$export$7d61b15e0da132af = '#172B4D';
var $ebcefa9befae152b$export$fbda843f0a27fe96 = '#091E42';
var $ebcefa9befae152b$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
var $ebcefa9befae152b$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
var $ebcefa9befae152b$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
var $ebcefa9befae152b$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
var $ebcefa9befae152b$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
var $ebcefa9befae152b$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
var $ebcefa9befae152b$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
var $ebcefa9befae152b$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
var $ebcefa9befae152b$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
var $ebcefa9befae152b$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
var $ebcefa9befae152b$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
var $ebcefa9befae152b$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
var $ebcefa9befae152b$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
var $ebcefa9befae152b$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
var $ebcefa9befae152b$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
var $ebcefa9befae152b$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
var $ebcefa9befae152b$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
var $ebcefa9befae152b$export$2f6319cf7d736c2a = '#E6EDFA';
var $ebcefa9befae152b$export$95126bc8884d6634 = '#DCE5F5';
var $ebcefa9befae152b$export$8338d8c35d44ff1 = '#CED9EB';
var $ebcefa9befae152b$export$5368d76ae4fbbda7 = '#B8C7E0';
var $ebcefa9befae152b$export$9f0a771d16ec8d36 = '#ABBBD6';
var $ebcefa9befae152b$export$abcf8c38338b4aa5 = '#9FB0CC';
var $ebcefa9befae152b$export$97e81faa16a182c7 = '#8C9CB8';
var $ebcefa9befae152b$export$bfe21c59123ecf33 = '#7988A3';
var $ebcefa9befae152b$export$ee82aa2ea6a1558 = '#67758F';
var $ebcefa9befae152b$export$682927c6ed76be02 = '#56637A';
var $ebcefa9befae152b$export$91fd9994c5be9757 = '#455166';
var $ebcefa9befae152b$export$d281fbfe3cff2df6 = '#3B475C';
var $ebcefa9befae152b$export$3902c91d8b98a753 = '#313D52';
var $ebcefa9befae152b$export$8e8133c1ba5845b5 = '#283447';
var $ebcefa9befae152b$export$33ff357f6620b39 = '#202B3D';
var $ebcefa9befae152b$export$633847cf062b69e0 = '#1B2638';
var $ebcefa9befae152b$export$9776a6e503bdbf76 = '#121A29';
var $ebcefa9befae152b$export$6c813d5160dff5db = '#0E1624';
var $ebcefa9befae152b$export$3d4f271a500072a = '#0D1424';
var $ebcefa9befae152b$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
var $ebcefa9befae152b$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
var $ebcefa9befae152b$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
var $ebcefa9befae152b$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
var $ebcefa9befae152b$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
var $ebcefa9befae152b$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
var $ebcefa9befae152b$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
var $ebcefa9befae152b$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
var $ebcefa9befae152b$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
var $ebcefa9befae152b$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
var $ebcefa9befae152b$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
var $ebcefa9befae152b$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
var $ebcefa9befae152b$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
var $ebcefa9befae152b$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
var $ebcefa9befae152b$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
var $ebcefa9befae152b$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
var $ebcefa9befae152b$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';
var $ebcefa9befae152b$export$d2adc5dedf09fced = '#292A2E';
var $ebcefa9befae152b$export$f51762073d2bb381 = '#94C748';
var $ebcefa9befae152b$export$95e26d54def96891 = '#B3DF72';

});

parcelRegister("iwXJJ", function(module, exports) {
$parcel$export(module.exports, "presetSizes", () => $d7d98d9eb3c243a0$export$4e9f1640bbe7a1a8);
var $d7d98d9eb3c243a0$export$4e9f1640bbe7a1a8 = {
    xsmall: 8,
    small: 16,
    medium: 24,
    large: 48,
    xlarge: 96
};

});




parcelRegister("6JfQX", function(module, exports) {
$parcel$export(module.exports, "default", () => $4e633e29480db1dc$export$2e2bcd8739ae039);

var $g41Mq = parcelRequire("g41Mq");

var $2XSqJ = parcelRequire("2XSqJ");

var $aZ1fh = parcelRequire("aZ1fh");
function $4e633e29480db1dc$var$v4(options, buf, offset) {
    if ((0, $g41Mq.default).randomUUID && !buf && !options) return (0, $g41Mq.default).randomUUID();
    options = options || {};
    const rnds = options.random ?? options.rng?.() ?? (0, $2XSqJ.default)();
    if (rnds.length < 16) throw new Error('Random bytes length must be >= 16');
    rnds[6] = rnds[6] & 0x0f | 0x40;
    rnds[8] = rnds[8] & 0x3f | 0x80;
    if (buf) {
        offset = offset || 0;
        if (offset < 0 || offset + 16 > buf.length) throw new RangeError(`UUID byte range ${offset}:${offset + 15} is out of buffer bounds`);
        for(let i = 0; i < 16; ++i)buf[offset + i] = rnds[i];
        return buf;
    }
    return (0, $aZ1fh.unsafeStringify)(rnds);
}
var $4e633e29480db1dc$export$2e2bcd8739ae039 = $4e633e29480db1dc$var$v4;

});
parcelRegister("g41Mq", function(module, exports) {
$parcel$export(module.exports, "default", () => $bb1e66910c70589f$export$2e2bcd8739ae039);
const $bb1e66910c70589f$var$randomUUID = typeof crypto !== 'undefined' && crypto.randomUUID && crypto.randomUUID.bind(crypto);
var $bb1e66910c70589f$export$2e2bcd8739ae039 = {
    randomUUID: $bb1e66910c70589f$var$randomUUID
};

});

parcelRegister("2XSqJ", function(module, exports) {
$parcel$export(module.exports, "default", () => $228b5021bd25790a$export$2e2bcd8739ae039);
let $228b5021bd25790a$var$getRandomValues;
const $228b5021bd25790a$var$rnds8 = new Uint8Array(16);
function $228b5021bd25790a$export$2e2bcd8739ae039() {
    if (!$228b5021bd25790a$var$getRandomValues) {
        if (typeof crypto === 'undefined' || !crypto.getRandomValues) throw new Error('crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported');
        $228b5021bd25790a$var$getRandomValues = crypto.getRandomValues.bind(crypto);
    }
    return $228b5021bd25790a$var$getRandomValues($228b5021bd25790a$var$rnds8);
}

});

parcelRegister("aZ1fh", function(module, exports) {
$parcel$export(module.exports, "unsafeStringify", () => $7ff09135a273f813$export$8fb373d660548968);

var $j24O5 = parcelRequire("j24O5");
const $7ff09135a273f813$var$byteToHex = [];
for(let i = 0; i < 256; ++i)$7ff09135a273f813$var$byteToHex.push((i + 0x100).toString(16).slice(1));
function $7ff09135a273f813$export$8fb373d660548968(arr, offset = 0) {
    return ($7ff09135a273f813$var$byteToHex[arr[offset + 0]] + $7ff09135a273f813$var$byteToHex[arr[offset + 1]] + $7ff09135a273f813$var$byteToHex[arr[offset + 2]] + $7ff09135a273f813$var$byteToHex[arr[offset + 3]] + '-' + $7ff09135a273f813$var$byteToHex[arr[offset + 4]] + $7ff09135a273f813$var$byteToHex[arr[offset + 5]] + '-' + $7ff09135a273f813$var$byteToHex[arr[offset + 6]] + $7ff09135a273f813$var$byteToHex[arr[offset + 7]] + '-' + $7ff09135a273f813$var$byteToHex[arr[offset + 8]] + $7ff09135a273f813$var$byteToHex[arr[offset + 9]] + '-' + $7ff09135a273f813$var$byteToHex[arr[offset + 10]] + $7ff09135a273f813$var$byteToHex[arr[offset + 11]] + $7ff09135a273f813$var$byteToHex[arr[offset + 12]] + $7ff09135a273f813$var$byteToHex[arr[offset + 13]] + $7ff09135a273f813$var$byteToHex[arr[offset + 14]] + $7ff09135a273f813$var$byteToHex[arr[offset + 15]]).toLowerCase();
}
function $7ff09135a273f813$var$stringify(arr, offset = 0) {
    const uuid = $7ff09135a273f813$export$8fb373d660548968(arr, offset);
    if (!(0, $j24O5.default)(uuid)) throw TypeError('Stringified UUID is invalid');
    return uuid;
}
var $7ff09135a273f813$export$2e2bcd8739ae039 = $7ff09135a273f813$var$stringify;

});
parcelRegister("j24O5", function(module, exports) {
$parcel$export(module.exports, "default", () => $ddb1eebf7c062598$export$2e2bcd8739ae039);

var $5n5xm = parcelRequire("5n5xm");
function $ddb1eebf7c062598$var$validate(uuid) {
    return typeof uuid === 'string' && (0, $5n5xm.default).test(uuid);
}
var $ddb1eebf7c062598$export$2e2bcd8739ae039 = $ddb1eebf7c062598$var$validate;

});
parcelRegister("5n5xm", function(module, exports) {
$parcel$export(module.exports, "default", () => $3e936542e888e8b2$export$2e2bcd8739ae039);
var $3e936542e888e8b2$export$2e2bcd8739ae039 = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-8][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/i;

});




parcelRegister("lSdkB", function(module, exports) {
$parcel$export(module.exports, "extract", () => $fec8fb70a184cf01$export$f9380c9a627682d3, (v) => $fec8fb70a184cf01$export$f9380c9a627682d3 = v);
$parcel$export(module.exports, "parse", () => $fec8fb70a184cf01$export$98e6a39c04603d36, (v) => $fec8fb70a184cf01$export$98e6a39c04603d36 = v);
$parcel$export(module.exports, "stringify", () => $fec8fb70a184cf01$export$fac44ee5b035f737, (v) => $fec8fb70a184cf01$export$fac44ee5b035f737 = v);
$parcel$export(module.exports, "parseUrl", () => $fec8fb70a184cf01$export$7a5253c0f62e0150, (v) => $fec8fb70a184cf01$export$7a5253c0f62e0150 = v);
$parcel$export(module.exports, "stringifyUrl", () => $fec8fb70a184cf01$export$a8c1621ea79325d3, (v) => $fec8fb70a184cf01$export$a8c1621ea79325d3 = v);
$parcel$export(module.exports, "pick", () => $fec8fb70a184cf01$export$357523c63a2253b9, (v) => $fec8fb70a184cf01$export$357523c63a2253b9 = v);
$parcel$export(module.exports, "exclude", () => $fec8fb70a184cf01$export$44c361b8ec72ef7f, (v) => $fec8fb70a184cf01$export$44c361b8ec72ef7f = v);
var $fec8fb70a184cf01$export$f9380c9a627682d3;
var $fec8fb70a184cf01$export$98e6a39c04603d36;
var $fec8fb70a184cf01$export$fac44ee5b035f737;
var $fec8fb70a184cf01$export$7a5253c0f62e0150;
var $fec8fb70a184cf01$export$a8c1621ea79325d3;
var $fec8fb70a184cf01$export$357523c63a2253b9;
var $fec8fb70a184cf01$export$44c361b8ec72ef7f;
'use strict';

var $6XEYK = parcelRequire("6XEYK");

var $9YPP7 = parcelRequire("9YPP7");

var $l4Qn0 = parcelRequire("l4Qn0");

var $9PyLY = parcelRequire("9PyLY");
const $fec8fb70a184cf01$var$isNullOrUndefined = (value)=>value === null || value === undefined;
function $fec8fb70a184cf01$var$encoderForArrayFormat(options) {
    switch(options.arrayFormat){
        case 'index':
            return (key)=>(result, value)=>{
                    const index = result.length;
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === '') return result;
                    if (value === null) return [
                        ...result,
                        [
                            $fec8fb70a184cf01$var$encode(key, options),
                            '[',
                            index,
                            ']'
                        ].join('')
                    ];
                    return [
                        ...result,
                        [
                            $fec8fb70a184cf01$var$encode(key, options),
                            '[',
                            $fec8fb70a184cf01$var$encode(index, options),
                            ']=',
                            $fec8fb70a184cf01$var$encode(value, options)
                        ].join('')
                    ];
                };
        case 'bracket':
            return (key)=>(result, value)=>{
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === '') return result;
                    if (value === null) return [
                        ...result,
                        [
                            $fec8fb70a184cf01$var$encode(key, options),
                            '[]'
                        ].join('')
                    ];
                    return [
                        ...result,
                        [
                            $fec8fb70a184cf01$var$encode(key, options),
                            '[]=',
                            $fec8fb70a184cf01$var$encode(value, options)
                        ].join('')
                    ];
                };
        case 'comma':
        case 'separator':
            return (key)=>(result, value)=>{
                    if (value === null || value === undefined || value.length === 0) return result;
                    if (result.length === 0) return [
                        [
                            $fec8fb70a184cf01$var$encode(key, options),
                            '=',
                            $fec8fb70a184cf01$var$encode(value, options)
                        ].join('')
                    ];
                    return [
                        [
                            result,
                            $fec8fb70a184cf01$var$encode(value, options)
                        ].join(options.arrayFormatSeparator)
                    ];
                };
        default:
            return (key)=>(result, value)=>{
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === '') return result;
                    if (value === null) return [
                        ...result,
                        $fec8fb70a184cf01$var$encode(key, options)
                    ];
                    return [
                        ...result,
                        [
                            $fec8fb70a184cf01$var$encode(key, options),
                            '=',
                            $fec8fb70a184cf01$var$encode(value, options)
                        ].join('')
                    ];
                };
    }
}
function $fec8fb70a184cf01$var$parserForArrayFormat(options) {
    let result;
    switch(options.arrayFormat){
        case 'index':
            return (key, value, accumulator)=>{
                result = /\[(\d*)\]$/.exec(key);
                key = key.replace(/\[\d*\]$/, '');
                if (!result) {
                    accumulator[key] = value;
                    return;
                }
                if (accumulator[key] === undefined) accumulator[key] = {};
                accumulator[key][result[1]] = value;
            };
        case 'bracket':
            return (key, value, accumulator)=>{
                result = /(\[\])$/.exec(key);
                key = key.replace(/\[\]$/, '');
                if (!result) {
                    accumulator[key] = value;
                    return;
                }
                if (accumulator[key] === undefined) {
                    accumulator[key] = [
                        value
                    ];
                    return;
                }
                accumulator[key] = [].concat(accumulator[key], value);
            };
        case 'comma':
        case 'separator':
            return (key, value, accumulator)=>{
                const isArray = typeof value === 'string' && value.includes(options.arrayFormatSeparator);
                const isEncodedArray = typeof value === 'string' && !isArray && $fec8fb70a184cf01$var$decode(value, options).includes(options.arrayFormatSeparator);
                value = isEncodedArray ? $fec8fb70a184cf01$var$decode(value, options) : value;
                const newValue = isArray || isEncodedArray ? value.split(options.arrayFormatSeparator).map((item)=>$fec8fb70a184cf01$var$decode(item, options)) : value === null ? value : $fec8fb70a184cf01$var$decode(value, options);
                accumulator[key] = newValue;
            };
        default:
            return (key, value, accumulator)=>{
                if (accumulator[key] === undefined) {
                    accumulator[key] = value;
                    return;
                }
                accumulator[key] = [].concat(accumulator[key], value);
            };
    }
}
function $fec8fb70a184cf01$var$validateArrayFormatSeparator(value) {
    if (typeof value !== 'string' || value.length !== 1) throw new TypeError('arrayFormatSeparator must be single character string');
}
function $fec8fb70a184cf01$var$encode(value, options) {
    if (options.encode) return options.strict ? $6XEYK(value) : encodeURIComponent(value);
    return value;
}
function $fec8fb70a184cf01$var$decode(value, options) {
    if (options.decode) return $9YPP7(value);
    return value;
}
function $fec8fb70a184cf01$var$keysSorter(input) {
    if (Array.isArray(input)) return input.sort();
    if (typeof input === 'object') return $fec8fb70a184cf01$var$keysSorter(Object.keys(input)).sort((a, b)=>Number(a) - Number(b)).map((key)=>input[key]);
    return input;
}
function $fec8fb70a184cf01$var$removeHash(input) {
    const hashStart = input.indexOf('#');
    if (hashStart !== -1) input = input.slice(0, hashStart);
    return input;
}
function $fec8fb70a184cf01$var$getHash(url) {
    let hash = '';
    const hashStart = url.indexOf('#');
    if (hashStart !== -1) hash = url.slice(hashStart);
    return hash;
}
function $fec8fb70a184cf01$var$extract(input) {
    input = $fec8fb70a184cf01$var$removeHash(input);
    const queryStart = input.indexOf('?');
    if (queryStart === -1) return '';
    return input.slice(queryStart + 1);
}
function $fec8fb70a184cf01$var$parseValue(value, options) {
    if (options.parseNumbers && !Number.isNaN(Number(value)) && typeof value === 'string' && value.trim() !== '') value = Number(value);
    else if (options.parseBooleans && value !== null && (value.toLowerCase() === 'true' || value.toLowerCase() === 'false')) value = value.toLowerCase() === 'true';
    return value;
}
function $fec8fb70a184cf01$var$parse(query, options) {
    options = Object.assign({
        decode: true,
        sort: true,
        arrayFormat: 'none',
        arrayFormatSeparator: ',',
        parseNumbers: false,
        parseBooleans: false
    }, options);
    $fec8fb70a184cf01$var$validateArrayFormatSeparator(options.arrayFormatSeparator);
    const formatter = $fec8fb70a184cf01$var$parserForArrayFormat(options);
    // Create an object with no prototype
    const ret = Object.create(null);
    if (typeof query !== 'string') return ret;
    query = query.trim().replace(/^[?#&]/, '');
    if (!query) return ret;
    for (const param of query.split('&')){
        if (param === '') continue;
        let [key, value] = $l4Qn0(options.decode ? param.replace(/\+/g, ' ') : param, '=');
        // Missing `=` should be `null`:
        // http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
        value = value === undefined ? null : [
            'comma',
            'separator'
        ].includes(options.arrayFormat) ? value : $fec8fb70a184cf01$var$decode(value, options);
        formatter($fec8fb70a184cf01$var$decode(key, options), value, ret);
    }
    for (const key of Object.keys(ret)){
        const value = ret[key];
        if (typeof value === 'object' && value !== null) for (const k of Object.keys(value))value[k] = $fec8fb70a184cf01$var$parseValue(value[k], options);
        else ret[key] = $fec8fb70a184cf01$var$parseValue(value, options);
    }
    if (options.sort === false) return ret;
    return (options.sort === true ? Object.keys(ret).sort() : Object.keys(ret).sort(options.sort)).reduce((result, key)=>{
        const value = ret[key];
        if (Boolean(value) && typeof value === 'object' && !Array.isArray(value)) // Sort object keys, not values
        result[key] = $fec8fb70a184cf01$var$keysSorter(value);
        else result[key] = value;
        return result;
    }, Object.create(null));
}
$fec8fb70a184cf01$export$f9380c9a627682d3 = $fec8fb70a184cf01$var$extract;
$fec8fb70a184cf01$export$98e6a39c04603d36 = $fec8fb70a184cf01$var$parse;
$fec8fb70a184cf01$export$fac44ee5b035f737 = (object, options)=>{
    if (!object) return '';
    options = Object.assign({
        encode: true,
        strict: true,
        arrayFormat: 'none',
        arrayFormatSeparator: ','
    }, options);
    $fec8fb70a184cf01$var$validateArrayFormatSeparator(options.arrayFormatSeparator);
    const shouldFilter = (key)=>options.skipNull && $fec8fb70a184cf01$var$isNullOrUndefined(object[key]) || options.skipEmptyString && object[key] === '';
    const formatter = $fec8fb70a184cf01$var$encoderForArrayFormat(options);
    const objectCopy = {};
    for (const key of Object.keys(object))if (!shouldFilter(key)) objectCopy[key] = object[key];
    const keys = Object.keys(objectCopy);
    if (options.sort !== false) keys.sort(options.sort);
    return keys.map((key)=>{
        const value = object[key];
        if (value === undefined) return '';
        if (value === null) return $fec8fb70a184cf01$var$encode(key, options);
        if (Array.isArray(value)) return value.reduce(formatter(key), []).join('&');
        return $fec8fb70a184cf01$var$encode(key, options) + '=' + $fec8fb70a184cf01$var$encode(value, options);
    }).filter((x)=>x.length > 0).join('&');
};
$fec8fb70a184cf01$export$7a5253c0f62e0150 = (url, options)=>{
    options = Object.assign({
        decode: true
    }, options);
    const [url_, hash] = $l4Qn0(url, '#');
    return Object.assign({
        url: url_.split('?')[0] || '',
        query: $fec8fb70a184cf01$var$parse($fec8fb70a184cf01$var$extract(url), options)
    }, options && options.parseFragmentIdentifier && hash ? {
        fragmentIdentifier: $fec8fb70a184cf01$var$decode(hash, options)
    } : {});
};
$fec8fb70a184cf01$export$a8c1621ea79325d3 = (object, options)=>{
    options = Object.assign({
        encode: true,
        strict: true
    }, options);
    const url = $fec8fb70a184cf01$var$removeHash(object.url).split('?')[0] || '';
    const queryFromUrl = $fec8fb70a184cf01$export$f9380c9a627682d3(object.url);
    const parsedQueryFromUrl = $fec8fb70a184cf01$export$98e6a39c04603d36(queryFromUrl, {
        sort: false
    });
    const query = Object.assign(parsedQueryFromUrl, object.query);
    let queryString = $fec8fb70a184cf01$export$fac44ee5b035f737(query, options);
    if (queryString) queryString = `?${queryString}`;
    let hash = $fec8fb70a184cf01$var$getHash(object.url);
    if (object.fragmentIdentifier) hash = `#${$fec8fb70a184cf01$var$encode(object.fragmentIdentifier, options)}`;
    return `${url}${queryString}${hash}`;
};
$fec8fb70a184cf01$export$357523c63a2253b9 = (input, filter, options)=>{
    options = Object.assign({
        parseFragmentIdentifier: true
    }, options);
    const { url: url, query: query, fragmentIdentifier: fragmentIdentifier } = $fec8fb70a184cf01$export$7a5253c0f62e0150(input, options);
    return $fec8fb70a184cf01$export$a8c1621ea79325d3({
        url: url,
        query: $9PyLY(query, filter),
        fragmentIdentifier: fragmentIdentifier
    }, options);
};
$fec8fb70a184cf01$export$44c361b8ec72ef7f = (input, filter, options)=>{
    const exclusionFilter = Array.isArray(filter) ? (key)=>!filter.includes(key) : (key, value)=>!filter(key, value);
    return $fec8fb70a184cf01$export$357523c63a2253b9(input, exclusionFilter, options);
};

});
parcelRegister("6XEYK", function(module, exports) {
'use strict';
module.exports = (str)=>encodeURIComponent(str).replace(/[!'()*]/g, (x)=>`%${x.charCodeAt(0).toString(16).toUpperCase()}`);

});

parcelRegister("9YPP7", function(module, exports) {
'use strict';
var $7441eabb5801ca04$var$token = '%[a-f0-9]{2}';
var $7441eabb5801ca04$var$singleMatcher = new RegExp('(' + $7441eabb5801ca04$var$token + ')|([^%]+?)', 'gi');
var $7441eabb5801ca04$var$multiMatcher = new RegExp('(' + $7441eabb5801ca04$var$token + ')+', 'gi');
function $7441eabb5801ca04$var$decodeComponents(components, split) {
    try {
        // Try to decode the entire string first
        return [
            decodeURIComponent(components.join(''))
        ];
    } catch (err) {
    // Do nothing
    }
    if (components.length === 1) return components;
    split = split || 1;
    // Split the array in 2 parts
    var left = components.slice(0, split);
    var right = components.slice(split);
    return Array.prototype.concat.call([], $7441eabb5801ca04$var$decodeComponents(left), $7441eabb5801ca04$var$decodeComponents(right));
}
function $7441eabb5801ca04$var$decode(input) {
    try {
        return decodeURIComponent(input);
    } catch (err) {
        var tokens = input.match($7441eabb5801ca04$var$singleMatcher) || [];
        for(var i = 1; i < tokens.length; i++){
            input = $7441eabb5801ca04$var$decodeComponents(tokens, i).join('');
            tokens = input.match($7441eabb5801ca04$var$singleMatcher) || [];
        }
        return input;
    }
}
function $7441eabb5801ca04$var$customDecodeURIComponent(input) {
    // Keep track of all the replacements and prefill the map with the `BOM`
    var replaceMap = {
        '%FE%FF': '\uFFFD\uFFFD',
        '%FF%FE': '\uFFFD\uFFFD'
    };
    var match = $7441eabb5801ca04$var$multiMatcher.exec(input);
    while(match){
        try {
            // Decode as big chunks as possible
            replaceMap[match[0]] = decodeURIComponent(match[0]);
        } catch (err) {
            var result = $7441eabb5801ca04$var$decode(match[0]);
            if (result !== match[0]) replaceMap[match[0]] = result;
        }
        match = $7441eabb5801ca04$var$multiMatcher.exec(input);
    }
    // Add `%C2` at the end of the map to make sure it does not replace the combinator before everything else
    replaceMap['%C2'] = '\uFFFD';
    var entries = Object.keys(replaceMap);
    for(var i = 0; i < entries.length; i++){
        // Replace all decoded components
        var key = entries[i];
        input = input.replace(new RegExp(key, 'g'), replaceMap[key]);
    }
    return input;
}
module.exports = function(encodedURI) {
    if (typeof encodedURI !== 'string') throw new TypeError('Expected `encodedURI` to be of type `string`, got `' + typeof encodedURI + '`');
    try {
        encodedURI = encodedURI.replace(/\+/g, ' ');
        // Try the built in decoder first
        return decodeURIComponent(encodedURI);
    } catch (err) {
        // Fallback to a more advanced decoder
        return $7441eabb5801ca04$var$customDecodeURIComponent(encodedURI);
    }
};

});

parcelRegister("l4Qn0", function(module, exports) {
'use strict';
module.exports = (string, separator)=>{
    if (!(typeof string === 'string' && typeof separator === 'string')) throw new TypeError('Expected the arguments to be of type `string`');
    if (separator === '') return [
        string
    ];
    const separatorIndex = string.indexOf(separator);
    if (separatorIndex === -1) return [
        string
    ];
    return [
        string.slice(0, separatorIndex),
        string.slice(separatorIndex + separator.length)
    ];
};

});

parcelRegister("9PyLY", function(module, exports) {
'use strict';
module.exports = function(obj, predicate) {
    var ret = {};
    var keys = Object.keys(obj);
    var isArr = Array.isArray(predicate);
    for(var i = 0; i < keys.length; i++){
        var key = keys[i];
        var val = obj[key];
        if (isArr ? predicate.indexOf(key) !== -1 : predicate(key, val, obj)) ret[key] = val;
    }
    return ret;
};

});


parcelRegister("1q4dW", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => (parcelRequire("iQNGT")).default);
$parcel$export(module.exports, "apdexType", () => (parcelRequire("iVpQc")).apdexType);
$parcel$export(module.exports, "envType", () => (parcelRequire("iVpQc")).envType);
$parcel$export(module.exports, "eventType", () => (parcelRequire("iVpQc")).eventType);
$parcel$export(module.exports, "originType", () => (parcelRequire("iVpQc")).originType);
$parcel$export(module.exports, "platformType", () => (parcelRequire("iVpQc")).platformType);
$parcel$export(module.exports, "tenantType", () => (parcelRequire("iVpQc")).tenantType);
$parcel$export(module.exports, "userType", () => (parcelRequire("iVpQc")).userType);
$parcel$export(module.exports, "originTracingType", () => (parcelRequire("iVpQc")).originTracingType);
$parcel$export(module.exports, "TypeAheadHelper", () => (parcelRequire("7fyW0")).default);
$parcel$export(module.exports, "DwellTimeHelper", () => (parcelRequire("4IOyp")).default);
$parcel$export(module.exports, "DwellTimeHelperWithBrowserInteraction", () => (parcelRequire("d38aa")).default);
$parcel$export(module.exports, "CompressionRule", () => (parcelRequire("bn5mH")).CompressionRule);
$parcel$export(module.exports, "ResilienceMechanism", () => (parcelRequire("aj05j")).ResilienceMechanism);
$parcel$export(module.exports, "StopLowPriorityEventDelayReason", () => (parcelRequire("dMV8Y")).StopLowPriorityEventDelayReason);
$parcel$export(module.exports, "STARGATE_PROXY_PATH", () => (parcelRequire("iQNGT")).STARGATE_PROXY_PATH);
$parcel$export(module.exports, "perimeterType", () => (parcelRequire("iVpQc")).perimeterType);
$parcel$export(module.exports, "aliasType", () => (parcelRequire("iVpQc")).aliasType);
$parcel$export(module.exports, "groupType", () => (parcelRequire("iVpQc")).groupType);

var $iQNGT = parcelRequire("iQNGT");

var $iVpQc = parcelRequire("iVpQc");

var $4IOyp = parcelRequire("4IOyp");

var $d38aa = parcelRequire("d38aa");

var $bn5mH = parcelRequire("bn5mH");
var $dMV8Y = parcelRequire("dMV8Y");

var $aj05j = parcelRequire("aj05j");

var $7fyW0 = parcelRequire("7fyW0");

});
parcelRegister("iQNGT", function(module, exports) {
$parcel$export(module.exports, "STARGATE_PROXY_PATH", () => $db93a0e66fe7f206$export$5df9262e102d0c32);
$parcel$export(module.exports, "default", () => $db93a0e66fe7f206$export$2e2bcd8739ae039);

var $25nEq = parcelRequire("25nEq");

var $6JfQX = parcelRequire("6JfQX");

var $iVpQc = parcelRequire("iVpQc");

var $3LT12 = parcelRequire("3LT12");

var $337gE = parcelRequire("337gE");

var $9YLuf = parcelRequire("9YLuf");

var $jWGj7 = parcelRequire("jWGj7");

var $8t1l5 = parcelRequire("8t1l5");

var $b1pOA = parcelRequire("b1pOA");

var $hyJWt = parcelRequire("hyJWt");

var $iRRLL = parcelRequire("iRRLL");

var $5ocp8 = parcelRequire("5ocp8");

var $fXo9B = parcelRequire("fXo9B");

var $8xdZA = parcelRequire("8xdZA");

var $iY1fJ = parcelRequire("iY1fJ");

var $jKAaS = parcelRequire("jKAaS");

var $ec3mM = parcelRequire("ec3mM");

var $jx7KB = parcelRequire("jx7KB");

var $6W7Sk = parcelRequire("6W7Sk");

var $buh9e = parcelRequire("buh9e");

var $3Vdyi = parcelRequire("3Vdyi");
function $db93a0e66fe7f206$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $db93a0e66fe7f206$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $db93a0e66fe7f206$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $db93a0e66fe7f206$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
const $db93a0e66fe7f206$export$5df9262e102d0c32 = '/gateway/api/gasv3/api/v1';
const $db93a0e66fe7f206$var$LAST_SCREEN_EVENT_STORAGE_KEY = 'last.screen.event';
class $db93a0e66fe7f206$export$48361b6ed38f1b0 {
    static callback(response) {
        const statusCode = response.getStatusCode();
        if (statusCode >= 200 && statusCode <= 299) {
            if (response.getEventResponseList().length === 0) // eslint-disable-next-line no-console
            console.debug('Event(s) submitted to GASv3');
            else response.getEventResponseList().forEach((eventResponse)=>{
                // eslint-disable-next-line no-console
                console.warn('Validation report for event with message ID %s:\n', eventResponse.getMessageId(), eventResponse);
            });
        } else if (statusCode === 400 || statusCode === 404) {
            // eslint-disable-next-line no-console
            console.warn('GASv3 submission failed with HTTP Status Code %d: %s', response.getStatusCode(), response.getMessage());
            response.getEventResponseList().forEach((eventResponse)=>{
                // eslint-disable-next-line no-console
                console.warn('Event with message ID %s:\n', eventResponse.getMessageId(), eventResponse);
            });
        } else {
            // eslint-disable-next-line no-console
            console.info('GASv3 submission failed with HTTP Status Code %d: %s', response.getStatusCode(), response.getMessage());
            response.eventResponseList.forEach((eventResponse)=>{
                // eslint-disable-next-line no-console
                console.debug('Event with message ID %s:\n', eventResponse.getMessageId(), eventResponse);
            });
        }
    }
}
class $db93a0e66fe7f206$export$2e2bcd8739ae039 {
    constructor(productInfo, settings = {}){
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "_useStargate", (useStargate)=>{
            if (useStargate == null) return true;
            return useStargate;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "_endsWith", (str, suffix)=>str.indexOf(suffix, str.length - suffix.length) !== -1);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "_changeInternalUserId", (userId, anonymousId)=>{
            this.eventProcessor.getUser().setUserId(userId);
            if (anonymousId && anonymousId !== this.eventProcessor.getUser().getAnonymousId()) // Setting anonymous id can take a long time. Reading is a lot faster.
            // Only update if it has changed.
            this.eventProcessor.getUser().setAnonymousId(anonymousId);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "_createSubproductGetter", (subproduct)=>(0, $337gE.default)(subproduct, 'Cannot get subproduct from the callback. Proceeding without it.'));
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "_createEmbeddedProductGetter", (embeddedProduct)=>(0, $337gE.default)(embeddedProduct, 'Cannot get embeddedProduct from the callback. Proceeding without it.'));
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "_getLastScreenEvent", ()=>{
            try {
                return JSON.parse(this._safeSessionStorage.getItem($db93a0e66fe7f206$var$LAST_SCREEN_EVENT_STORAGE_KEY) || '');
            } catch (err) {
                this._safeSessionStorage.removeItem($db93a0e66fe7f206$var$LAST_SCREEN_EVENT_STORAGE_KEY);
                return null;
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "_setLastScreenEvent", (event)=>{
            this._safeSessionStorage.setItem($db93a0e66fe7f206$var$LAST_SCREEN_EVENT_STORAGE_KEY, JSON.stringify({
                name: event.name,
                attributes: event.attributes
            }));
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "_shouldEventBeDelayed", (event)=>{
            // TODO: this is a temporary restriction for the purposes of the Track All Changes project
            // The delay mechanism has a chance of event loss, which we can only accept for our own data at this point.
            // Once the delay queue implementation has been improved and measured to confirm that it is reliable enough,
            // then we will be able to open it up for other products to use by removing this check.
            if (!event.tags || event.tags.indexOf('measurement') === -1) return false;
            const isEventHighPriority = event.highPriority !== false; // defaults to true if excluded
            return this.eventDelayQueue.isDelayingLowPriorityEvents() && !isEventHighPriority;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "_fireEvent", (identifier, builtEvent, context, callback)=>{
            switch(builtEvent.eventType){
                case (0, $iVpQc.eventType).UI:
                case (0, $iVpQc.eventType).OPERATIONAL:
                case (0, $iVpQc.eventType).TRACK:
                    return this.eventProcessor.track(identifier, builtEvent, context, callback);
                case (0, $iVpQc.eventType).SCREEN:
                    return this.eventProcessor.page(identifier, builtEvent, context, callback);
                case (0, $iVpQc.eventType).IDENTIFY:
                    return this.eventProcessor.identify(identifier, builtEvent, context, callback);
                default:
                    throw new Error(`No handler has been defined for events of type ${builtEvent.eventType}`);
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "_fireDelayedEvent", (identifier, builtEvent, context, userInfo)=>{
            try {
                // User information can change while the delay period is active, so we need to restore the values that
                // were active when the event was originally fired.
                this._changeInternalUserId(userInfo.userId, userInfo.anonymousId);
                builtEvent.tags = [
                    ...builtEvent.tags || [],
                    'sentWithDelay'
                ];
                // The callbacks for delayed events are fired immediately, so there is nothing to pass through for this argument.
                this._fireEvent(identifier, builtEvent, context, undefined);
            } finally{
                this._changeInternalUserId(this._userInfo.userId, this._userInfo.anonymousId);
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "_delayEvent", (identifier, builtEvent, context, userInfo, callback)=>{
            this.eventDelayQueue.push(identifier, builtEvent, context, userInfo);
            // Fire the callback immediately, as we can consider the event successfully processed at this point
            if (callback) callback();
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "_processEvent", (identifier, builtEvent, context, callback)=>{
            this._testingCache.saveEvent(builtEvent);
            if (this._shouldEventBeDelayed(builtEvent)) {
                this._delayEvent(identifier, builtEvent, context, this._userInfo, callback);
                return Promise.resolve();
            } else return this._fireEvent(identifier, builtEvent, context, callback);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "setEmbeddedProduct", (embeddedProduct)=>{
            this._productInfo.embeddedProduct = this._createEmbeddedProductGetter(embeddedProduct);
            this.resetUIViewedTimers();
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "clearEmbeddedProduct", ()=>{
            this._productInfo.embeddedProduct = this._createEmbeddedProductGetter(null);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "setSubproduct", (subproduct)=>{
            this._productInfo.subproduct = this._createSubproductGetter(subproduct);
            this.resetUIViewedTimers();
        });
        /**
      * Calling this function in the intialisation of the client in product
      * captures specified 'origin tracing' URL params and fires a single origin landed event
      * <p>
      * This function expects a mapping between the keys for any URL parameters
      *  that should be captured and removed for origin tracing
      * Multiple parameters may be captured simultaneously if multiple key: handler function pairs are provided
      * Each handler function should return an object with two items
      * a) 'originTracingAttributes' - an object that will be added to the 'origin landed' event's attributes under 'originTracing
      * b) 'taskSessionId' (optional) - an Id string that will be added to the tasksessions for any event that fires from the tab, with the key
      *    matching the URL parameter, for the purpose of attributing subsequent analytics event to the origin land.
      * </p>
      * The general use case for this feature is for allowing attributation of user behaviour to a out of product or cross product link,
      * e.g. from a share or email
      *
      * An example calling this function using an external decoding library, with taskSessionId specified to persist
      * analyticsWebClient.setOriginTracingHandlers({
           atlOrigin: encodedOrigin => {
               const { id, product } = OriginTracing.fromEncoded(encodedOrigin);
               return { originTracingAttributes: {'id': id, 'product': product}, taskSessionId: id };
           },
       });
      *
      * @param  {Object} originParamHandlerMapping a dictionary of mappings between origin url param keys and handler functions
      * @this {AnalyticsWebClient}
      */ (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "setOriginTracingHandlers", (originParamHandlerMapping)=>{
            const capturedOriginTraces = this.originTracing.handleOriginParameters(originParamHandlerMapping, this._historyReplaceFn);
            Object.keys(capturedOriginTraces).forEach((x)=>{
                if (typeof capturedOriginTraces[x].taskSessionId !== 'undefined') this.task.createTaskSessionWithProvidedId(x, capturedOriginTraces[x].taskSessionId);
            });
            const originAttributes = {};
            Object.keys(capturedOriginTraces).forEach((x)=>{
                if (capturedOriginTraces[x].originTracingAttributes) originAttributes[x] = capturedOriginTraces[x].originTracingAttributes;
                else // eslint-disable-next-line no-console
                console.warn(`Handling method for origin parameter ${x} has not returned any attributes`);
            });
            if (Object.keys(capturedOriginTraces).length > 0) return this.sendOperationalEvent({
                action: 'landed',
                actionSubject: 'origin',
                source: 'webClient',
                attributes: {
                    originTracesLanded: originAttributes
                }
            }, // eslint-disable-next-line @typescript-eslint/no-empty-function
            ()=>{});
            return Promise.resolve();
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "setTenantInfo", (tenantIdType, tenantId)=>{
            if (!tenantIdType) throw new Error('Missing tenantIdType');
            if (tenantIdType !== (0, $iVpQc.tenantType).NONE && !tenantId) throw new Error('Missing tenantId');
            if (!(0, $iVpQc.isType)((0, $iVpQc.tenantType), tenantIdType)) throw new Error(`Invalid tenantIdType '${tenantIdType}', ` + `must be an tenantType: [${(0, $iVpQc.objectValues)((0, $iVpQc.tenantType))}]`);
            this._tenantInfo = {
                tenantIdType: tenantIdType,
                tenantId: tenantId
            };
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "clearTenantInfo", ()=>{
            this._tenantInfo = {};
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "setOrgInfo", (orgId)=>{
            if (!orgId) throw new Error('Missing orgId');
            this._orgInfo = {
                orgId: orgId
            };
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "clearOrgInfo", ()=>{
            this._orgInfo = {};
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "setWorkspaceInfo", (workspaceId)=>{
            if (!workspaceId) throw new Error('Missing workspaceId');
            this._workspaceInfo = {
                workspaceId: workspaceId
            };
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "clearWorkspaceInfo", ()=>{
            this._workspaceInfo = {};
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "setUserInfo", (userIdType, userId)=>{
            (0, $8t1l5.validateIdentifyEvent)(userIdType, userId);
            this._changeInternalUserId(userId);
            this._userInfo = {
                userIdType: userIdType,
                userId: userId,
                anonymousId: this.eventProcessor.getUser().getAnonymousId()
            };
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "clearUserInfo", ()=>{
            this._changeInternalUserId(undefined);
            this._userInfo = {
                anonymousId: this.eventProcessor.getUser().getAnonymousId()
            };
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "setAlias", (aliasKeyType, alias)=>{
            if (!aliasKeyType) throw new Error('Missing aliasType');
            if (!(0, $iVpQc.isType)((0, $iVpQc.aliasType), aliasKeyType)) throw new Error(`Invalid aliasType '${aliasKeyType}', ` + `must be an aliasType: [${(0, $iVpQc.objectValues)((0, $iVpQc.aliasType))}]`);
            this._aliases[aliasKeyType] = alias;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "clearAlias", ()=>{
            this._aliases = {};
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "setGroup", (groupsKeyType, group)=>{
            if (!groupsKeyType) throw new Error('Missing groupType');
            if (!(0, $iVpQc.isType)((0, $iVpQc.groupType), groupsKeyType)) throw new Error(`Invalid groupType '${groupsKeyType}', ` + `must be an groupType: [${(0, $iVpQc.objectValues)((0, $iVpQc.groupType))}]`);
            this._groups[groupsKeyType] = group;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "clearGroup", ()=>{
            this._groups = {};
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "getAnonymousId", ()=>this._userInfo.anonymousId);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "setUIViewedAttributes", (uiViewedAttributes)=>{
            if (!uiViewedAttributes) throw new Error('Missing uiViewedAttributes');
            if (typeof uiViewedAttributes !== 'object' || Array.isArray(uiViewedAttributes)) throw new Error('Invalid uiViewedAttributes type, should be a non array object');
            this._uiViewedAttributes = $db93a0e66fe7f206$var$_objectSpread({}, uiViewedAttributes);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "getUIViewedAttributes", ()=>{
            return this._uiViewedAttributes;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "clearUIViewedAttributes", ()=>{
            this._uiViewedAttributes = {};
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "sendIdentifyEvent", (userIdType, userId, callback)=>{
            this.setUserInfo(userIdType, userId);
            const builtEvent = {
                userIdType: userIdType,
                eventType: (0, $iVpQc.eventType).IDENTIFY
            };
            return this._processEvent(userId, builtEvent, this._context, callback);
        });
        /**
     * @deprecated
     * please use {@link sendScreenEvent instead)
     */ (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "sendPageEvent", (name, callback)=>{
            return this.sendScreenEvent(name, callback);
        });
        /**
     * send screen event
     * @param event The event / For retrocompatibility event name is still supported here.
     * @param callback
     * @param attributes. Deprecated, will get ignored if using an event object as first param.
     */ (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "sendScreenEvent", (event, callback, attributes)=>{
            let screenName;
            let screenAttributes;
            let screenContainers;
            let screenTags;
            if (typeof event === 'object') {
                /* This is for retrocompatibility */ screenName = event.name;
                screenAttributes = event.attributes;
                screenContainers = event.containers;
                screenTags = event.tags;
            } else {
                screenName = event;
                screenAttributes = attributes;
            }
            (0, $8t1l5.validateScreenEvent)(screenName);
            (0, $8t1l5.validateContainers)(screenContainers);
            const builtEvent = (0, $9YLuf.buildScreenEvent)(this._productInfo, this._tenantInfo, this._userInfo, screenAttributes, // TODO: Remove the as any and move into a place where we know event is an object
            event.nonPrivacySafeAttributes, screenTags, this._tabTracking.getCurrentTabId(), this._sessionTracking.getCurrentSessionId(), this.task.getAllTaskSessions(), this._orgInfo, this._pageLoadId, this._workspaceInfo, event, screenContainers, this._aliases, this._groups);
            const builtEventWithName = $db93a0e66fe7f206$var$_objectSpread({
                name: screenName
            }, builtEvent);
            this._setLastScreenEvent(builtEventWithName);
            return this._processEvent(screenName, builtEventWithName, this._context, (0, $buh9e.default)(callback, builtEventWithName));
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "sendTrackEvent", (event, callback)=>{
            (0, $8t1l5.validateTrackEvent)(event);
            const builtEvent = (0, $9YLuf.buildActionEvent)(this._productInfo, this._tenantInfo, this._userInfo, event, (0, $iVpQc.eventType).TRACK, this._tabTracking.getCurrentTabId(), this._sessionTracking.getCurrentSessionId(), this.task.getAllTaskSessions(), this._orgInfo, this._pageLoadId, this._workspaceInfo, this._aliases, this._groups);
            return this._processEvent((0, $9YLuf.buildActionName)(event), builtEvent, this._context, (0, $buh9e.default)(callback, builtEvent));
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "sendUIEvent", (event, callback)=>{
            (0, $8t1l5.validateUIEvent)(event);
            const builtEvent = (0, $9YLuf.buildActionEvent)(this._productInfo, this._tenantInfo, this._userInfo, event, (0, $iVpQc.eventType).UI, this._tabTracking.getCurrentTabId(), this._sessionTracking.getCurrentSessionId(), this.task.getAllTaskSessions(), this._orgInfo, this._pageLoadId, this._workspaceInfo, this._aliases, this._groups);
            return this._processEvent((0, $9YLuf.buildActionName)(event), builtEvent, this._context, (0, $buh9e.default)(callback, builtEvent));
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "sendOperationalEvent", (event, callback)=>{
            (0, $8t1l5.validateOperationalEvent)(event);
            const builtEvent = (0, $9YLuf.buildActionEvent)(this._productInfo, this._tenantInfo, this._userInfo, event, (0, $iVpQc.eventType).OPERATIONAL, this._tabTracking.getCurrentTabId(), this._sessionTracking.getCurrentSessionId(), this.task.getAllTaskSessions(), this._orgInfo, this._pageLoadId, this._workspaceInfo, this._aliases, this._groups);
            return this._processEvent((0, $9YLuf.buildActionName)(event), builtEvent, this._context, (0, $buh9e.default)(callback, builtEvent));
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "startUIViewedEvent", (callback)=>{
            this.stopUIViewedEvent();
            this._uiViewedEvent = new (0, $jx7KB.default)(this._productInfo, ()=>({
                    embeddedProduct: this._productInfo.embeddedProduct(),
                    subproduct: this._productInfo.subproduct(),
                    tenantIdType: this._tenantInfo.tenantIdType,
                    tenantId: this._tenantInfo.tenantId,
                    userId: this._userInfo.userId,
                    lastScreenEvent: this._getLastScreenEvent(),
                    attributes: this._uiViewedAttributes
                }), (event)=>this.sendUIEvent(event, callback));
            this._uiViewedEvent.start();
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "stopUIViewedEvent", ()=>{
            if (this._uiViewedEvent) {
                this._uiViewedEvent.stop();
                this._uiViewedEvent = null;
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "resetUIViewedTimers", ()=>{
            if (this._uiViewedEvent) this._uiViewedEvent.resetTimers();
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "startApdexEvent", (apdexEvent)=>{
            this._apdexEvent.start(apdexEvent);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "getApdexStart", (apdexEvent)=>this._apdexEvent.getStart(apdexEvent));
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "stopApdexEvent", (apdexEvent, callback)=>{
            this._apdexEvent.stop(apdexEvent, callback);
        });
        // TODO If we ever make another breaking change, merge these two optional args into an `options` object arg.
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "startLowPriorityEventDelay", (timeout, callback)=>{
            this.eventDelayQueue.startLowPriorityEventDelay(timeout, callback);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "stopLowPriorityEventDelay", ()=>{
            this.eventDelayQueue.stopLowPriorityEventDelay();
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "onEvent", (_analyticsId, analyticsData)=>{
            if (!analyticsData) throw new Error('Missing analyticsData');
            if (!analyticsData.eventType) throw new Error('Missing analyticsData.eventType');
            if (analyticsData.eventType === (0, $iVpQc.eventType).TRACK) return this.sendTrackEvent(analyticsData);
            else if (analyticsData.eventType === (0, $iVpQc.eventType).UI) return this.sendUIEvent(analyticsData);
            else if (analyticsData.eventType === (0, $iVpQc.eventType).OPERATIONAL) return this.sendOperationalEvent(analyticsData);
            else if (analyticsData.eventType === (0, $iVpQc.eventType).SCREEN) return this.sendScreenEvent(analyticsData.name, null, analyticsData.attributes);
            else if (analyticsData.eventType === (0, $iVpQc.eventType).IDENTIFY) return this.sendIdentifyEvent(analyticsData.userIdType, analyticsData.userId);
            throw new Error(`Invalid analyticsData.eventType '${analyticsData.eventType}', ` + `must be an eventType: [${(0, $iVpQc.objectValues)((0, $iVpQc.eventType))}]`);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "setResponseCallback", (responseCallback)=>{
            this.eventProcessor.setResponseCallback(responseCallback);
        });
        if (!productInfo) throw new Error('Missing productInfo');
        if (!productInfo.env) throw new Error('Missing productInfo.env');
        if (!productInfo.product) throw new Error('Missing productInfo.product');
        if (!(0, $iVpQc.isType)((0, $iVpQc.envType), productInfo.env)) throw new Error(`Invalid productInfo.env '${productInfo.env}', ` + `must be an envType: [${(0, $iVpQc.objectValues)((0, $iVpQc.envType))}]`);
        if (productInfo.perimeter && !(0, $iVpQc.isType)((0, $iVpQc.perimeterType), productInfo.perimeter)) throw new Error(`Invalid productInfo.perimeter '${productInfo.perimeter}', ` + `must be an perimeterType: [${(0, $iVpQc.objectValues)((0, $iVpQc.perimeterType))}]`);
        if (!productInfo.origin) productInfo.origin = (0, $iVpQc.originType).WEB;
        else if (!(0, $iVpQc.isType)((0, $iVpQc.originType), productInfo.origin)) throw new Error(`Invalid productInfo.origin '${productInfo.origin}', ` + `must be an originType: [${(0, $iVpQc.objectValues)((0, $iVpQc.originType))}]`);
        if (!productInfo.platform) productInfo.platform = productInfo.origin === (0, $iVpQc.originType).WEB ? (0, $iVpQc.platformType).WEB : (0, $iVpQc.platformType).DESKTOP;
        else (0, $8t1l5.validatePlatform)(productInfo);
        this.logger = settings.logger || console;
        this._productInfo = $db93a0e66fe7f206$var$_objectSpread($db93a0e66fe7f206$var$_objectSpread({}, productInfo), {}, {
            subproduct: this._createSubproductGetter(productInfo.subproduct),
            embeddedProduct: this._createEmbeddedProductGetter(productInfo.embeddedProduct)
        });
        this._tenantInfo = {};
        this._orgInfo = {};
        this._uiViewedAttributes = {};
        this._context = (0, $9YLuf.buildContext)(this._productInfo);
        this._safeSessionStorage = new (0, $8xdZA.default)();
        const _useStargate = this._useStargate(settings.useStargate);
        const apiHost = settings.apiHost || (0, $5ocp8.selectHost)({
            useStargate: _useStargate,
            env: productInfo.env,
            useLegacyUrl: settings.useLegacyUrl,
            perimeter: productInfo.perimeter,
            envOverride: productInfo.envOverride
        });
        const apiHostProtocol = settings.apiHostProtocol || 'https';
        const minRetryDelay = settings.minRetryDelay || 1000;
        const retryQueueOptions = {
            maxRetryDelay: 60000,
            minRetryDelay: minRetryDelay,
            backoffFactor: 2,
            flushWaitMs: settings.flushWaitInterval,
            flushBeforeUnload: settings.flushBeforeUnload
        };
        const retryQueuePrefix = `awc-${productInfo.env}`;
        const xidPromiseGetter = ()=>(0, $3Vdyi.XIDPromise)(settings.xidConsent, settings.xidPromiseFn);
        const disableCookiePersistence = settings.disableCookiePersistence || false;
        this.eventProcessor = new (0, $b1pOA.default)({
            apiHost: apiHost,
            apiHostProtocol: apiHostProtocol,
            product: productInfo.product,
            retryQueuePrefix: retryQueuePrefix,
            retryQueueOptions: retryQueueOptions,
            xidPromiseGetter: xidPromiseGetter,
            logger: this.logger,
            disableCookiePersistence: disableCookiePersistence,
            responseCallback: $db93a0e66fe7f206$export$48361b6ed38f1b0.callback
        });
        this._userInfo = {
            anonymousId: this.eventProcessor.getUser().getAnonymousId(settings === null || settings === void 0 ? void 0 : settings.customAnonymousIdGenerator)
        };
        this._pageVisibility = new (0, $iRRLL.default)();
        this._tabTracking = new (0, $iY1fJ.default)();
        this._sessionTracking = new (0, $fXo9B.default)({
            sessionExpiryTime: settings.sessionExpiryTime,
            onNewSessionStarted: settings.onNewSessionStarted
        });
        this.task = new (0, $jKAaS.default)();
        this.originTracing = new (0, $hyJWt.default)();
        // Init Apdex
        this._apdexEvent = new (0, $3LT12.default)(this.sendOperationalEvent, this._pageVisibility);
        this._historyReplaceFn = typeof settings.historyReplaceFn === 'function' ? settings.historyReplaceFn : (0, $6W7Sk.defaultHistoryReplaceFn);
        this.eventDelayQueue = new (0, $jWGj7.default)(this._fireDelayedEvent, settings.delayQueueCompressors || []);
        this._testingCache = new (0, $ec3mM.default)();
        this._pageLoadId = (0, $6JfQX.default)();
        this._workspaceInfo = {};
        this._aliases = {};
        this._groups = {};
    }
    setEventValidationMode(eventValidationMode) {
        this._context.context.validationMode = eventValidationMode;
    }
}

});
parcelRegister("iVpQc", function(module, exports) {
$parcel$export(module.exports, "envType", () => $dc71985173ea2d22$export$56ac8ebc9870b1b9);
$parcel$export(module.exports, "eventType", () => $dc71985173ea2d22$export$4c045e605d532c98);
$parcel$export(module.exports, "platformType", () => $dc71985173ea2d22$export$6b4f396210e539f3);
$parcel$export(module.exports, "originType", () => $dc71985173ea2d22$export$f73e9fcd368bb695);
$parcel$export(module.exports, "tenantType", () => $dc71985173ea2d22$export$496f06ac2a964da2);
$parcel$export(module.exports, "userType", () => $dc71985173ea2d22$export$1827adfd178b4870);
$parcel$export(module.exports, "apdexType", () => $dc71985173ea2d22$export$99b37380a464d794);
$parcel$export(module.exports, "desktopPlatforms", () => $dc71985173ea2d22$export$809831be6c4c6227);
$parcel$export(module.exports, "webPlatforms", () => $dc71985173ea2d22$export$19c579398ad213e7);
$parcel$export(module.exports, "originTracingType", () => $dc71985173ea2d22$export$62a500c02dc63ee);
$parcel$export(module.exports, "objectValues", () => $dc71985173ea2d22$export$ad1854f4a08c15f8);
$parcel$export(module.exports, "isType", () => $dc71985173ea2d22$export$26b9f946b448f23e);
$parcel$export(module.exports, "perimeterType", () => $dc71985173ea2d22$export$bdd41749d2096e4b);
$parcel$export(module.exports, "aliasType", () => $dc71985173ea2d22$export$a8c99e46b781d936);
$parcel$export(module.exports, "groupType", () => $dc71985173ea2d22$export$e73680b18d9b7c6e);
// These types have been converted from frozen objects to enums.
// We cannot change their name, or even capitalise them without breaking API.
let $dc71985173ea2d22$export$56ac8ebc9870b1b9 = /*#__PURE__*/ function(envType) {
    envType["LOCAL"] = "local";
    envType["DEV"] = "dev";
    envType["STAGING"] = "staging";
    envType["PROD"] = "prod";
    return envType;
}({});
let $dc71985173ea2d22$export$4c045e605d532c98 = /*#__PURE__*/ function(eventType) {
    eventType["TRACK"] = "track";
    eventType["UI"] = "ui";
    eventType["OPERATIONAL"] = "operational";
    eventType["SCREEN"] = "screen";
    eventType["IDENTIFY"] = "identify";
    return eventType;
}({});
let $dc71985173ea2d22$export$6b4f396210e539f3 = /*#__PURE__*/ function(platformType) {
    platformType["MAC"] = "mac";
    platformType["LINUX"] = "linux";
    platformType["WINDOWS"] = "windows";
    platformType["DESKTOP"] = "desktop";
    platformType["WEB"] = "web";
    platformType["MOBILE_WEB"] = "mobileWeb";
    return platformType;
}({});
let $dc71985173ea2d22$export$f73e9fcd368bb695 = /*#__PURE__*/ function(originType) {
    originType["DESKTOP"] = "desktop";
    originType["WEB"] = "web";
    return originType;
}({});
let $dc71985173ea2d22$export$496f06ac2a964da2 = /*#__PURE__*/ function(tenantType) {
    tenantType["CLOUD_ID"] = "cloudId";
    tenantType["ORG_ID"] = "orgId";
    tenantType["OPSGENIE_CUSTOMER_ID"] = "opsgenieCustomerId";
    tenantType["HALP_TEAM_ID"] = "halpTeamId";
    tenantType["LOOM_ORG_ID"] = "loomOrgId";
    tenantType["TRANSACTION_ACCOUNT_ID"] = "transactionAccountId";
    tenantType["TRELLO_WORKSPACE_ID"] = "trelloWorkspaceId";
    tenantType["JA_WORKSPACE_ID"] = "jiraAlignWorkspaceId";
    tenantType["NONE"] = "none";
    return tenantType;
}({});
let $dc71985173ea2d22$export$1827adfd178b4870 = /*#__PURE__*/ function(userType) {
    userType["ATLASSIAN_ACCOUNT"] = "atlassianAccount";
    userType["HASHED_EMAIL"] = "hashedEmail";
    userType["LOOM"] = "loom";
    userType["TRELLO"] = "trello";
    userType["OPSGENIE"] = "opsgenie";
    userType["JA_USER_ID"] = "jiraAlign";
    userType["HALP"] = "halp";
    return userType;
}({});
let $dc71985173ea2d22$export$99b37380a464d794 = /*#__PURE__*/ function(apdexType) {
    apdexType["TRANSITION"] = "transition";
    apdexType["INITIAL_LOAD"] = "initialLoad";
    return apdexType;
}({});
const $dc71985173ea2d22$export$809831be6c4c6227 = Object.freeze([
    $dc71985173ea2d22$export$6b4f396210e539f3.DESKTOP,
    $dc71985173ea2d22$export$6b4f396210e539f3.MAC,
    $dc71985173ea2d22$export$6b4f396210e539f3.LINUX,
    $dc71985173ea2d22$export$6b4f396210e539f3.WINDOWS
]);
const $dc71985173ea2d22$export$19c579398ad213e7 = Object.freeze([
    $dc71985173ea2d22$export$6b4f396210e539f3.WEB,
    $dc71985173ea2d22$export$6b4f396210e539f3.MOBILE_WEB
]);
let $dc71985173ea2d22$export$62a500c02dc63ee = /*#__PURE__*/ function(originTracingType) {
    originTracingType["ATL_ORIGIN"] = "atlOrigin";
    return originTracingType;
}({});
function $dc71985173ea2d22$export$ad1854f4a08c15f8(object) {
    return Object.values(object);
}
function $dc71985173ea2d22$export$26b9f946b448f23e(type, value) {
    return Object.values(type).indexOf(value) > -1;
}
let $dc71985173ea2d22$export$bdd41749d2096e4b = /*#__PURE__*/ function(perimeterType) {
    perimeterType["C5"] = "c5";
    perimeterType["COMMERCIAL"] = "commercial";
    perimeterType["FEDRAMP_MODERATE"] = "fedramp-moderate";
    perimeterType["FEDRAMP_HIGH"] = "fedramp-high";
    return perimeterType;
}({});
let $dc71985173ea2d22$export$a8c99e46b781d936 = /*#__PURE__*/ function(aliasType) {
    return aliasType;
}({});
let $dc71985173ea2d22$export$e73680b18d9b7c6e = /*#__PURE__*/ function(groupType) {
    groupType["TRANSACTION_ACCOUNT_ID"] = "transactionAccountId";
    return groupType;
}({});
let $dc71985173ea2d22$export$12b75c708da5a04b = /*#__PURE__*/ function(envOverrides) {
    return envOverrides;
}({});

});

parcelRegister("3LT12", function(module, exports) {
$parcel$export(module.exports, "default", () => $2bf06fd7a60f9df3$export$2e2bcd8739ae039);

var $25nEq = parcelRequire("25nEq");

var $iVpQc = parcelRequire("iVpQc");

var $iRRLL = parcelRequire("iRRLL");

var $13OZR = parcelRequire("13OZR");
function $2bf06fd7a60f9df3$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $2bf06fd7a60f9df3$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $2bf06fd7a60f9df3$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $2bf06fd7a60f9df3$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
class $2bf06fd7a60f9df3$export$2e2bcd8739ae039 {
    constructor(onEvent, pageVisibility){
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "_getEventKey", ({ task: task, taskId: taskId })=>taskId ? `${task}.${taskId}` : task);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "_getEventTimingByName", (name)=>{
            const eventTimings = this._performance.getEntriesByName(name);
            const eventTiming = eventTimings[eventTimings.length - 1];
            return eventTiming;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "_getApdexFields", (event)=>{
            const apdexTimings = this._getApdexTimings(event);
            const apdexScore = this._calculateApdex({
                duration: apdexTimings.duration,
                threshold: event.threshold
            });
            return $2bf06fd7a60f9df3$var$_objectSpread($2bf06fd7a60f9df3$var$_objectSpread({}, apdexTimings), {}, {
                apdex: apdexScore
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "_getApdexTimings", (event)=>{
            const eventKey = this._getEventKey(event);
            const eventStartName = `${eventKey}-start`;
            const startTime = event.startTime || this._getStartTime(event, eventStartName);
            const stopTime = event.stopTime || this._getStopTime();
            // We do some clean up of the marks and started events
            this._cleanApdexState(eventKey);
            return {
                startTime: startTime,
                stopTime: stopTime,
                duration: stopTime - startTime
            };
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "_getStartTime", (event, eventName)=>{
            let startTime;
            const timeOrigin = this._performance.getTimeOrigin();
            if (event.type === (0, $iVpQc.apdexType).INITIAL_LOAD) startTime = timeOrigin;
            else {
                const eventTiming = this._getEventTimingByName(eventName);
                startTime = timeOrigin + eventTiming.startTime;
            }
            return startTime;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "_getStopTime", ()=>this._performance.getTimeOrigin() + this._performance.now());
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "_cleanApdexState", (eventKey)=>{
            this._performance.clearMarks(`${eventKey}-start`);
            this._performance.clearMarks(`${eventKey}-stop`);
            this._startedEvents.delete(eventKey);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "_getVisibilityFields", (event)=>{
            let isActiveTab;
            /**
       * For initialLoad type:
       * 1. if tab was not ever hidden (!_wasPreviouslyHidden)
       *
       * For transition type:
       * 1. active status is tracked in active events map (_isActiveEvents)
       *
       * For any type, if startTime or stopTime is specified:
       * 1. If currently active (!_isHidden)
       */ if (event.type === (0, $iVpQc.apdexType).INITIAL_LOAD) isActiveTab = !this._wasPreviouslyHidden;
            else if (event.type === (0, $iVpQc.apdexType).TRANSITION) {
                const eventKey = this._getEventKey(event);
                isActiveTab = this._isActiveEvents.get(eventKey);
            }
            if (event.startTime || event.stopTime) isActiveTab = !this._pageVisibility.getIsHidden();
            return {
                isActiveTab: isActiveTab
            };
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "_calculateApdex", ({ duration: duration, threshold: threshold = this._threshold })=>{
            let apdex;
            const satisfiedThreshold = threshold;
            const tolerableThreshold = threshold * 4;
            if (duration <= satisfiedThreshold) apdex = 1;
            else if (duration <= tolerableThreshold) apdex = 0.5;
            else apdex = 0;
            return apdex;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "_validateStartEvent", (event)=>{
            if (!event) throw new Error('Missing "event" in Apdex start event');
            if (!event.task) throw new Error('Missing "task" in Apdex start event');
            if (typeof event.task !== 'string') throw new Error('Invalid "task" in Apdex start event');
            if (event.taskId && typeof event.taskId !== 'string') throw new Error('Invalid "taskId" in Apdex start event');
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "_validateStopEvent", (event)=>{
            if (!event) throw new Error('Missing "event" in Apdex stop event');
            if (!event.task) throw new Error('Missing "task" in Apdex stop event');
            if (typeof event.task !== 'string') throw new Error('Invalid "task" in Apdex stop event');
            if (event.taskId && typeof event.taskId !== 'string') throw new Error('Invalid "taskId" in Apdex stop event');
            if (!event.type) throw new Error('Missing "type" in Apdex stop event');
            if (event.type && !(0, $iVpQc.isType)((0, $iVpQc.apdexType), event.type)) throw new Error('Invalid "type" in Apdex stop event');
            if (event.threshold && typeof event.threshold !== 'number') throw new Error('Invalid "threshold" in Apdex stop event');
            /*
       * For a transition, if the startTime was not specified,
       * the start event should have been present.
       */ if (!event.startTime && event.type === (0, $iVpQc.apdexType).TRANSITION) {
                const eventKey = this._getEventKey(event);
                if (!this._startedEvents.has(eventKey)) throw new Error(`Apdex event transition "${eventKey}" was not started`);
            }
            if (event.startTime && !(typeof event.startTime === 'number' && event.startTime >= 0)) throw new Error('Invalid "startTime" in Apdex stop event');
            if (event.stopTime && typeof event.stopTime !== 'number') throw new Error('Invalid "stopTime" in Apdex stop event');
            if (event.stopTime <= event.startTime) throw new Error('"stopTime" should be greater than "startTime" in Apdex stop event');
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "_shouldSendEvent", (event)=>{
            if (!event) return false;
            if (typeof event.apdex !== 'number') return false;
            return true;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "_sendEvent", (event, callback)=>{
            if (this._shouldSendEvent(event)) this._onEvent({
                source: 'ui',
                action: 'readyForUser',
                actionSubject: 'ui',
                attributes: $2bf06fd7a60f9df3$var$_objectSpread($2bf06fd7a60f9df3$var$_objectSpread({}, event.additionalAttributes), {}, {
                    task: event.task,
                    taskId: event.taskId,
                    type: event.type,
                    threshold: event.threshold || this._threshold,
                    apdex: event.apdex,
                    startTime: event.startTime,
                    stopTime: event.stopTime,
                    duration: event.duration,
                    isActiveTab: event.isActiveTab
                })
            }, callback);
        });
        if (!onEvent) throw new Error('Missing onEvent callback');
        if (typeof onEvent !== 'function') throw new Error('Invalid onEvent, must be function');
        if (!(pageVisibility instanceof (0, $iRRLL.default))) throw new Error('Invalid pageVisibility, must be PageVisibility class');
        this._startedEvents = new Map();
        this._performance = new (0, $13OZR.default)();
        this._onEvent = onEvent;
        this._threshold = 1000;
        this._wasPreviouslyHidden = pageVisibility.getIsHidden();
        this._isActiveEvents = new Map();
        this._pageVisibility = pageVisibility;
        this._pageVisibility.addCallback('apdexEvent', (isHidden)=>{
            this.onVisibilityChange(!isHidden);
        });
    }
    start(event) {
        this._validateStartEvent(event);
        if (!this._performance.isAvailable()) return;
        const eventKey = this._getEventKey(event);
        const eventStartName = `${eventKey}-start`;
        this._startedEvents.set(eventKey, true);
        this._isActiveEvents.set(eventKey, !this._pageVisibility.getIsHidden());
        this._performance.clearMarks(eventStartName);
        this._performance.mark(eventStartName);
    }
    getStart(event) {
        this._validateStartEvent(event);
        if (!this._performance.isAvailable()) return undefined;
        const eventKey = this._getEventKey(event);
        const eventStartName = `${eventKey}-start`;
        return this._getEventTimingByName(eventStartName);
    }
    stop(event, callback) {
        this._validateStopEvent(event);
        if (!this._performance.isAvailable()) return;
        const apdexFields = this._getApdexFields(event);
        const visibilityFields = this._getVisibilityFields(event);
        this._sendEvent($2bf06fd7a60f9df3$var$_objectSpread($2bf06fd7a60f9df3$var$_objectSpread($2bf06fd7a60f9df3$var$_objectSpread({}, event), apdexFields), visibilityFields), callback);
    }
    onVisibilityChange(isActive) {
        if (!isActive) {
            this._wasPreviouslyHidden = true;
            Array.from(this._isActiveEvents.keys()).forEach((key)=>this._isActiveEvents.set(key, false));
        }
    }
}

});
parcelRegister("iRRLL", function(module, exports) {
$parcel$export(module.exports, "default", () => $dbc6e2bb1d998e96$export$2e2bcd8739ae039);

var $25nEq = parcelRequire("25nEq");
class $dbc6e2bb1d998e96$export$2e2bcd8739ae039 {
    constructor(){
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "_bindEventListeners", ()=>{
            document.addEventListener(this._visibilityChange, this._handleVisibilityChange, false);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "_handleVisibilityChange", ()=>{
            const isHidden = document[this._hidden];
            this._isHidden = isHidden;
            this._callbacks.forEach((callbackFn)=>callbackFn(isHidden));
        });
        this._isHidden = false;
        this._callbacks = new Map();
        this._hidden = undefined;
        this._visibilityChange = undefined;
        if (typeof document !== 'undefined') {
            if (typeof document.hidden !== 'undefined') {
                // Opera 12.10 and Firefox 18 and later support
                this._isHidden = document.hidden;
                this._hidden = 'hidden';
                this._visibilityChange = 'visibilitychange';
            } else if (typeof document.msHidden !== 'undefined') {
                this._isHidden = document.msHidden;
                this._hidden = 'msHidden';
                this._visibilityChange = 'msvisibilitychange';
            } else if (typeof document.webkitHidden !== 'undefined') {
                this._isHidden = document.webkitHidden;
                this._hidden = 'webkitHidden';
                this._visibilityChange = 'webkitvisibilitychange';
            }
            if (typeof document.addEventListener !== 'undefined' && this._hidden !== undefined) this._bindEventListeners();
        }
    }
    addCallback(name, fn) {
        if (typeof name !== 'string') throw new Error('Invalid name, must be string');
        if (typeof fn !== 'function') throw new Error('Invalid callback, must be function');
        this._callbacks.set(name, fn);
    }
    removeCallback(name) {
        if (this._callbacks.has(name)) this._callbacks.delete(name);
    }
    getIsHidden() {
        return this._isHidden;
    }
}

});

parcelRegister("13OZR", function(module, exports) {
$parcel$export(module.exports, "default", () => $0c5da12a8aac30c0$export$2e2bcd8739ae039);
class $0c5da12a8aac30c0$export$2e2bcd8739ae039 {
    constructor(){
        this._performance = window.performance;
    }
    clearMarks(...args) {
        if (!this._performance || !this._performance.clearMarks) return;
        this._performance.clearMarks(...args);
    }
    mark(...args) {
        if (!this._performance || !this._performance.mark) return;
        this._performance.mark(...args);
    }
    getEntriesByName(...args) {
        if (!this._performance || !this._performance.getEntriesByName) return [];
        return this._performance.getEntriesByName(...args);
    }
    getTimeOrigin() {
        if (!this._performance || !this._performance.timeOrigin && !this._performance.timing) return 0;
        return this._performance.timeOrigin || this._performance.timing.navigationStart;
    }
    now() {
        if (!this._performance || !this._performance.now) return Date.now ? Date.now() : +new Date();
        return this._performance.now();
    }
    isAvailable() {
        return !!this._performance && !!this._performance.clearMarks && !!this._performance.mark && !!this._performance.getEntriesByName && !!this._performance.timing;
    }
}

});


parcelRegister("337gE", function(module, exports) {
$parcel$export(module.exports, "default", () => $23874a19e9786324$export$2e2bcd8739ae039);
/**
 * Wraps {possibleFn} into a error-safe function and handles cases where {possibleFn}
 * is a function or object
 *
 * @param possibleFn - function that returns and object or the object itself
 * @param errorMessage - error message to log if {possibleFn} is a function and
 *                        throws an error when called
 * @returns {Function}
 */ const $23874a19e9786324$var$isFunction = (possibleFn)=>typeof possibleFn === 'function';
var $23874a19e9786324$export$2e2bcd8739ae039 = (possibleFn, errorMessage)=>{
    return ()=>{
        if ($23874a19e9786324$var$isFunction(possibleFn)) try {
            return possibleFn();
        } catch (e) {
            // eslint-disable-next-line no-console
            console.error(`${errorMessage} - ${e instanceof Error ? e.message : String(e)}`);
            return undefined;
        }
        return possibleFn;
    };
};

});

parcelRegister("9YLuf", function(module, exports) {
$parcel$export(module.exports, "buildActionFields", () => $743e8d9343fbd7a9$export$655ecf7241feac42);
$parcel$export(module.exports, "buildScreenEvent", () => $743e8d9343fbd7a9$export$c7d9a5f56acc4b19);
$parcel$export(module.exports, "buildActionName", () => $743e8d9343fbd7a9$export$9c5623a792efc9b0);
$parcel$export(module.exports, "buildContext", () => $743e8d9343fbd7a9$export$3a7fe28f9bf4f3d9);
$parcel$export(module.exports, "buildActionEvent", () => $743e8d9343fbd7a9$export$7bf451af4a8e3dd9);

var $25nEq = parcelRequire("25nEq");

var $iVpQc = parcelRequire("iVpQc");

var $drkuY = parcelRequire("drkuY");
function $743e8d9343fbd7a9$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $743e8d9343fbd7a9$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $743e8d9343fbd7a9$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $743e8d9343fbd7a9$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
const $743e8d9343fbd7a9$var$libraryVersion = "4.27.1";
function $743e8d9343fbd7a9$var$buildTenantFields(tenantInfo) {
    return {
        tenantIdType: tenantInfo.tenantIdType,
        tenantId: tenantInfo.tenantId
    };
}
function $743e8d9343fbd7a9$var$buildUserFields(userInfo) {
    return {
        userIdType: userInfo.userIdType
    };
}
function $743e8d9343fbd7a9$var$buildOrgFields(orgInfo) {
    return {
        orgId: orgInfo.orgId
    };
}
function $743e8d9343fbd7a9$var$buildWorkspaceFields(workspaceInfo) {
    return {
        workspaceId: workspaceInfo.workspaceId
    };
}
function $743e8d9343fbd7a9$var$buildAliases(aliases) {
    if ($743e8d9343fbd7a9$var$isNotEmptyObject(aliases)) return {
        aliases: aliases
    };
    return undefined;
}
function $743e8d9343fbd7a9$var$buildGroups(groups) {
    if ($743e8d9343fbd7a9$var$isNotEmptyObject(groups)) return {
        groups: groups
    };
    return undefined;
}
function $743e8d9343fbd7a9$var$buildEventOverrides(event) {
    if (event.anonymousId) return {
        anonymousId: event.anonymousId
    };
    return {};
}
function $743e8d9343fbd7a9$var$getProductField(field, override) {
    return override === undefined ? field : override;
}
function $743e8d9343fbd7a9$var$buildProductFields(productInfo, productOverrides) {
    const overrides = productOverrides || {};
    const env = $743e8d9343fbd7a9$var$getProductField(productInfo.env, overrides.env);
    const product = $743e8d9343fbd7a9$var$getProductField(productInfo.product, overrides.product);
    const subproduct = $743e8d9343fbd7a9$var$getProductField(productInfo.subproduct(), overrides.subproduct);
    const version = $743e8d9343fbd7a9$var$getProductField(productInfo.version, overrides.version);
    const origin = $743e8d9343fbd7a9$var$getProductField(productInfo.origin, overrides.origin);
    const platform = $743e8d9343fbd7a9$var$getProductField(productInfo.platform, overrides.platform);
    return {
        env: env,
        product: product,
        subproduct: subproduct,
        version: version,
        origin: origin,
        platform: platform
    };
}
function $743e8d9343fbd7a9$var$isNotEmptyObject(obj) {
    return (0, $drkuY.isPlainObject)(obj) && Object.keys(obj).length > 0;
}
function $743e8d9343fbd7a9$var$buildAttributesWithName(name, attrObject) {
    return $743e8d9343fbd7a9$var$isNotEmptyObject(attrObject) ? {
        [name]: attrObject
    } : undefined;
}
function $743e8d9343fbd7a9$var$buildAttributes(attributes) {
    return $743e8d9343fbd7a9$var$buildAttributesWithName('attributes', attributes);
}
function $743e8d9343fbd7a9$export$3f5115a568819c1a(containers) {
    const validContainers = {};
    Object.keys(containers).forEach((key)=>{
        const value = containers[key];
        validContainers[key] = {
            id: value.id,
            type: value.type
        };
    });
    return validContainers;
}
function $743e8d9343fbd7a9$export$f045f238d77c002a(containers) {
    if ($743e8d9343fbd7a9$var$isNotEmptyObject(containers)) {
        const validContainers = $743e8d9343fbd7a9$export$3f5115a568819c1a(containers);
        return $743e8d9343fbd7a9$var$buildAttributesWithName('containers', validContainers);
    }
    return undefined;
}
function $743e8d9343fbd7a9$export$655ecf7241feac42(event, actionEventType) {
    return $743e8d9343fbd7a9$var$_objectSpread({
        containerType: event.containerType,
        containerId: event.containerId,
        source: event.source,
        objectType: event.objectType,
        objectId: event.objectId,
        actionSubject: event.actionSubject,
        action: event.action,
        actionSubjectId: event.actionSubjectId,
        attributes: event.attributes,
        nonPrivacySafeAttributes: event.nonPrivacySafeAttributes,
        tags: event.tags,
        highPriority: event.highPriority,
        eventType: actionEventType
    }, $743e8d9343fbd7a9$export$f045f238d77c002a(event.containers));
}
function $743e8d9343fbd7a9$var$buildNonPrivacySafeAttributes(nonPrivacySafeAttributes) {
    return $743e8d9343fbd7a9$var$buildAttributesWithName('nonPrivacySafeAttributes', nonPrivacySafeAttributes);
}
function $743e8d9343fbd7a9$export$c7d9a5f56acc4b19(productInfo, tenantInfo, userInfo, attributes, nonPrivacySafeAttributes, tags, tabId, sessionId, taskSessions, orgInfo, pageLoadId, workspaceInfo, event, containers, aliases, groups) {
    const productFields = $743e8d9343fbd7a9$var$buildProductFields(productInfo);
    const tenantFields = $743e8d9343fbd7a9$var$buildTenantFields(tenantInfo);
    const userFields = $743e8d9343fbd7a9$var$buildUserFields(userInfo);
    const orgFields = $743e8d9343fbd7a9$var$buildOrgFields(orgInfo);
    const workspaceFields = $743e8d9343fbd7a9$var$buildWorkspaceFields(workspaceInfo);
    const overrides = {
        title: '',
        path: '',
        url: '',
        referrer: '',
        search: '',
        eventType: (0, $iVpQc.eventType).SCREEN
    };
    return $743e8d9343fbd7a9$var$_objectSpread($743e8d9343fbd7a9$var$_objectSpread($743e8d9343fbd7a9$var$_objectSpread($743e8d9343fbd7a9$var$_objectSpread($743e8d9343fbd7a9$var$_objectSpread($743e8d9343fbd7a9$var$_objectSpread($743e8d9343fbd7a9$var$_objectSpread($743e8d9343fbd7a9$var$_objectSpread($743e8d9343fbd7a9$var$_objectSpread($743e8d9343fbd7a9$var$_objectSpread($743e8d9343fbd7a9$var$_objectSpread($743e8d9343fbd7a9$var$_objectSpread({}, productFields), tenantFields), userFields), orgFields), overrides), $743e8d9343fbd7a9$var$buildAttributes(attributes)), $743e8d9343fbd7a9$var$buildNonPrivacySafeAttributes(nonPrivacySafeAttributes)), $743e8d9343fbd7a9$export$f045f238d77c002a(containers)), $743e8d9343fbd7a9$var$buildEventOverrides(event)), {}, {
        tags: tags,
        tabId: tabId,
        sessionId: sessionId,
        taskSessions: taskSessions,
        pageLoadId: pageLoadId
    }, workspaceFields), $743e8d9343fbd7a9$var$buildAliases(aliases)), $743e8d9343fbd7a9$var$buildGroups(groups));
}
function $743e8d9343fbd7a9$export$9c5623a792efc9b0(event) {
    return `${event.actionSubject} ${event.action}`;
}
let $743e8d9343fbd7a9$export$fbd92247fb4d6159 = /*#__PURE__*/ function(validationMode) {
    validationMode["QUIET"] = "quiet";
    validationMode["STANDARD"] = "standard";
    validationMode["COMPLETE"] = "complete";
    return validationMode;
}({});
function $743e8d9343fbd7a9$var$getDefaultValidationMode(productInfo) {
    const environment = productInfo.env;
    if (environment === undefined) return $743e8d9343fbd7a9$export$fbd92247fb4d6159.QUIET;
    if (environment.includes('prod')) return $743e8d9343fbd7a9$export$fbd92247fb4d6159.QUIET;
    return $743e8d9343fbd7a9$export$fbd92247fb4d6159.COMPLETE;
}
function $743e8d9343fbd7a9$export$3a7fe28f9bf4f3d9(productInfo) {
    const screen = window.screen || {};
    return {
        context: {
            locale: productInfo.locale,
            screen: {
                width: screen.width,
                height: screen.height,
                density: window.devicePixelRatio
            },
            library: {
                name: 'analytics.js',
                version: $743e8d9343fbd7a9$var$libraryVersion
            },
            validationMode: $743e8d9343fbd7a9$var$getDefaultValidationMode(productInfo)
        }
    };
}
function $743e8d9343fbd7a9$export$e3d99b4bfec06f6e(event) {
    const { env: env, product: product, subproduct: subproduct, version: version, origin: origin, platform: platform } = event;
    return {
        env: env,
        product: product,
        subproduct: subproduct,
        version: version,
        origin: origin,
        platform: platform
    };
}
function $743e8d9343fbd7a9$export$7bf451af4a8e3dd9(productInfo, tenantInfo, userInfo, event, actionEventType, tabId, sessionId, taskSessions, orgInfo, pageLoadId, workspaceInfo, aliases, groups) {
    const productFields = $743e8d9343fbd7a9$var$buildProductFields(productInfo, $743e8d9343fbd7a9$export$e3d99b4bfec06f6e(event));
    const tenantFields = $743e8d9343fbd7a9$var$buildTenantFields(tenantInfo);
    const orgFields = $743e8d9343fbd7a9$var$buildOrgFields(orgInfo);
    const workspaceFields = $743e8d9343fbd7a9$var$buildWorkspaceFields(workspaceInfo);
    const userFields = $743e8d9343fbd7a9$var$buildUserFields(userInfo);
    const actionFields = $743e8d9343fbd7a9$export$655ecf7241feac42(event, actionEventType);
    return $743e8d9343fbd7a9$var$_objectSpread($743e8d9343fbd7a9$var$_objectSpread($743e8d9343fbd7a9$var$_objectSpread($743e8d9343fbd7a9$var$_objectSpread($743e8d9343fbd7a9$var$_objectSpread($743e8d9343fbd7a9$var$_objectSpread($743e8d9343fbd7a9$var$_objectSpread($743e8d9343fbd7a9$var$_objectSpread($743e8d9343fbd7a9$var$_objectSpread({}, productFields), tenantFields), orgFields), userFields), actionFields), $743e8d9343fbd7a9$var$buildEventOverrides(event)), {}, {
        tabId: tabId,
        sessionId: sessionId,
        taskSessions: taskSessions,
        pageLoadId: pageLoadId
    }, workspaceFields), $743e8d9343fbd7a9$var$buildAliases(aliases)), $743e8d9343fbd7a9$var$buildGroups(groups));
}

});
parcelRegister("drkuY", function(module, exports) {
$parcel$export(module.exports, "isPlainObject", () => $9c8db295ff5e2f16$export$53b83ca8eaab0383);
// Modified from https://github.com/jonschlinkert/is-plain-object/blob/master/index.js
function $9c8db295ff5e2f16$var$isObject(val) {
    return val !== null && typeof val === 'object' && Array.isArray(val) === false;
}
function $9c8db295ff5e2f16$var$isObjectObject(o) {
    return $9c8db295ff5e2f16$var$isObject(o) === true && Object.prototype.toString.call(o) === '[object Object]';
}
function $9c8db295ff5e2f16$export$53b83ca8eaab0383(o) {
    if ($9c8db295ff5e2f16$var$isObjectObject(o) === false) return false;
    // If has modified constructor
    const ctor = o.constructor;
    if (typeof ctor !== 'function') return false;
    // If has modified prototype
    const prot = ctor.prototype;
    if ($9c8db295ff5e2f16$var$isObjectObject(prot) === false) return false;
    // If constructor does not have an Object-specific method
    if (!('isPrototypeOf' in prot)) return false;
    // Most likely a plain Object
    return true;
}

});


parcelRegister("jWGj7", function(module, exports) {
$parcel$export(module.exports, "default", () => $e854407d0d7318d4$export$2e2bcd8739ae039);

var $25nEq = parcelRequire("25nEq");

var $2Tnct = parcelRequire("2Tnct");

var $lkCmZ = parcelRequire("lkCmZ");

var $dMV8Y = parcelRequire("dMV8Y");
class $e854407d0d7318d4$export$2e2bcd8739ae039 {
    constructor(fireDelayedEvent, compressors){
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "push", (identifier, builtEvent, context, userInfo)=>{
            this.delayQueue.push(identifier, builtEvent, context, userInfo);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "startLowPriorityEventDelay", (timeout = (0, $2Tnct.DEFAULT_DELAY_TIMEOUT), callback)=>{
            if (Number.isNaN(timeout) || timeout <= 0) throw new Error(`Invalid timeout period: ${timeout}, must be a number greater than 0`);
            if (this.delayTimeout) clearTimeout(this.delayTimeout);
            const delayTimeoutPeriod = timeout ? Math.min(timeout, (0, $2Tnct.MAX_DELAY_TIMEOUT)) : (0, $2Tnct.MAX_DELAY_TIMEOUT);
            this.delayCallback = callback;
            this.delayTimeout = setTimeout(()=>this.stopLowPriorityEventDelay((0, $dMV8Y.StopLowPriorityEventDelayReason).TIMEOUT), delayTimeoutPeriod);
            // If the queue is still flushing from a previous delay period, then we should cancel that flush
            // to stop it from negatively impacting the performance of the new critical section
            this.delayQueue.cancelFlush();
            this.isDelaying = true;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "stopLowPriorityEventDelay", (reason = (0, $dMV8Y.StopLowPriorityEventDelayReason).MANUAL)=>{
            var _this$delayCallback;
            if (this.delayTimeout) {
                clearTimeout(this.delayTimeout);
                this.delayTimeout = undefined;
            }
            this.delayQueue.startFlush();
            this.isDelaying = false;
            (_this$delayCallback = this.delayCallback) === null || _this$delayCallback === void 0 || _this$delayCallback.call(this, reason);
            this.delayCallback = undefined;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "isDelayingLowPriorityEvents", ()=>this.isDelaying);
        this.isDelaying = false;
        this.delayQueue = new (0, $lkCmZ.default)(fireDelayedEvent, compressors);
    }
}

});
parcelRegister("2Tnct", function(module, exports) {
$parcel$export(module.exports, "DEFAULT_DELAY_TIMEOUT", () => $21b2b6e77c52e2a4$export$cf090d5281b5ae06);
$parcel$export(module.exports, "MAX_DELAY_TIMEOUT", () => $21b2b6e77c52e2a4$export$8575e30be0feb909);
const $21b2b6e77c52e2a4$export$cf090d5281b5ae06 = 10000;
const $21b2b6e77c52e2a4$export$8575e30be0feb909 = 30000;

});

parcelRegister("lkCmZ", function(module, exports) {
$parcel$export(module.exports, "default", () => $f8793aaa2ef339c6$export$2e2bcd8739ae039);

var $25nEq = parcelRequire("25nEq");

var $9YLuf = parcelRequire("9YLuf");

var $JnB9d = parcelRequire("JnB9d");

var $dnm2H = parcelRequire("dnm2H");
// We want to throttle the flush rate so that we don't have a huge upfront performance hit from starting the flush,
// and so that the underlying Segment client has some time to process some events in its queue before more are added.
const $f8793aaa2ef339c6$var$FLUSH_BATCH_SIZE = 7; // aligns with the default batch size of Segment's BatchableQueue
const $f8793aaa2ef339c6$var$FLUSH_BATCH_BACKOFF_PERIOD = 100;
class $f8793aaa2ef339c6$export$2e2bcd8739ae039 {
    constructor(processFn, compressionRules){
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "push", (identifier, builtEvent, context, userInfo)=>{
            this.eventArgs.push({
                identifier: identifier,
                builtEvent: builtEvent,
                context: context,
                userInfo: userInfo
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "size", ()=>this.eventArgs.length);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "startFlush", ()=>{
            try {
                this.eventArgs = this.compressEventArgs(this.eventArgs);
            } catch (e) {
                // eslint-disable-next-line no-console
                console.warn('Failed to perform compression on the delayed analytics events. ' + `Error: ${e.message}. Sending ${this.eventArgs.length} uncompressed events instead`);
            }
            this.flushNextBatch();
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "cancelFlush", ()=>{
            if (this.flushBatchTimeout) {
                clearTimeout(this.flushBatchTimeout);
                this.flushBatchTimeout = null;
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "flushNextBatch", ()=>{
            const batch = this.eventArgs.splice(0, $f8793aaa2ef339c6$var$FLUSH_BATCH_SIZE);
            batch.forEach((item)=>this.processFn(item.identifier, item.builtEvent, item.context, item.userInfo));
            if (this.eventArgs.length > 0) this.flushBatchTimeout = setTimeout(()=>this.flushNextBatch(), $f8793aaa2ef339c6$var$FLUSH_BATCH_BACKOFF_PERIOD);
            else this.flushBatchTimeout = null;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "compressEventArgs", (eventArgs)=>{
            const [compressibleEventArgs, incompressibleEventArgs] = (0, $JnB9d.partition)(eventArgs, (args)=>this.compressor.canCompress(args.builtEvent));
            // Events can only be compressed together if they share the same context and user info, since these are top-level
            // fields that need to exist on the fired event and can only be set to a single value.
            // We can achieve this by grouping our events by context prior to passing them to the compressor.
            const contextGroups = compressibleEventArgs.reduce((groups, args)=>{
                const matchingGroup = groups.find((group)=>(0, $JnB9d.equals)(group.userInfo, args.userInfo) && (0, $JnB9d.equals)(group.context, args.context));
                if (matchingGroup) matchingGroup.eventArgs.push(args);
                else groups.push({
                    userInfo: args.userInfo,
                    context: args.context,
                    eventArgs: [
                        args
                    ]
                });
                return groups;
            }, []);
            // Run the compressor on each group
            const allCompressedEventArgs = contextGroups.reduce((acc, group)=>{
                try {
                    const events = group.eventArgs.map((args)=>args.builtEvent);
                    const compressedEvents = this.compressor.compress(events);
                    const compressedEventArgs = compressedEvents.map((compressedEvent)=>({
                            identifier: (0, $9YLuf.buildActionName)(compressedEvent),
                            builtEvent: compressedEvent,
                            userInfo: group.userInfo,
                            context: group.context
                        }));
                    return acc.concat(compressedEventArgs);
                } catch (e) {
                    // If anything goes wrong while compressing this group, then just fall back on the
                    // uncompressed events instead. The event compressor already handles errors with invalid
                    // generator functions or results, but this is an extra layer of defense to prevent data
                    // loss in the event of an unexpected error.
                    // eslint-disable-next-line no-console
                    console.warn('Failed to compress some analytics events. ' + `Error: ${e.message}. Sending ${group.eventArgs.length} uncompressed events instead`);
                    return group.eventArgs;
                }
            }, []);
            incompressibleEventArgs.forEach((args)=>allCompressedEventArgs.push(args));
            return allCompressedEventArgs;
        });
        this.processFn = processFn;
        this.flushBatchTimeout = null;
        this.eventArgs = [];
        this.compressor = new (0, $dnm2H.default)(compressionRules);
    }
}

});
parcelRegister("JnB9d", function(module, exports) {
$parcel$export(module.exports, "mapKeys", () => $0886822fb2c47c3e$export$781522908e4e76a1);
$parcel$export(module.exports, "pick", () => $0886822fb2c47c3e$export$357523c63a2253b9);
$parcel$export(module.exports, "omitBy", () => $0886822fb2c47c3e$export$d7a617dda645b4e3);
$parcel$export(module.exports, "pickBy", () => $0886822fb2c47c3e$export$b460b275d6c6aa0);
$parcel$export(module.exports, "omit", () => $0886822fb2c47c3e$export$30a06c8d3562193f);
$parcel$export(module.exports, "equals", () => $0886822fb2c47c3e$export$e9bab7fafb253603);
$parcel$export(module.exports, "partition", () => $0886822fb2c47c3e$export$b29f828819edca8d);
/* eslint-disable no-return-assign, no-sequences */ // https://www.30secondsofcode.org/js/s/map-keys
const $0886822fb2c47c3e$export$781522908e4e76a1 = (obj, fn)=>Object.keys(obj).reduce((acc, k)=>{
        const key = fn(obj[k], k, obj);
        acc[key] = obj[k];
        return acc;
    }, {});
// https://www.30secondsofcode.org/js/s/pick
const $0886822fb2c47c3e$export$357523c63a2253b9 = (obj, arr)=>arr.reduce((acc, curr)=>(curr in obj && (acc[curr] = obj[curr]), acc), {});
// https://www.30secondsofcode.org/js/s/omit-by
const $0886822fb2c47c3e$export$d7a617dda645b4e3 = (obj, fn)=>Object.keys(obj).filter((k)=>!fn(obj[k], k)).reduce((acc, key)=>(acc[key] = obj[key], acc), {});
// https://www.30secondsofcode.org/js/s/pick-by
const $0886822fb2c47c3e$export$b460b275d6c6aa0 = (obj, fn)=>Object.keys(obj).filter((k)=>fn(obj[k], k)).reduce((acc, key)=>(acc[key] = obj[key], acc), {});
// https://www.30secondsofcode.org/js/s/omit
const $0886822fb2c47c3e$export$30a06c8d3562193f = (obj, arr)=>Object.keys(obj).filter((k)=>arr.indexOf(k) < 0).reduce((acc, key)=>(acc[key] = obj[key], acc), {});
// https://www.30secondsofcode.org/js/s/equals
const $0886822fb2c47c3e$export$e9bab7fafb253603 = (a, b)=>{
    if (a === b) return true;
    if (a instanceof Date && b instanceof Date) return a.getTime() === b.getTime();
    if (!a || !b || typeof a !== 'object' && typeof b !== 'object') return a === b;
    if (a.prototype !== b.prototype) return false;
    const keys = Object.keys(a);
    if (keys.length !== Object.keys(b).length) return false;
    return keys.every((k)=>$0886822fb2c47c3e$export$e9bab7fafb253603(a[k], b[k]));
};
// https://www.30secondsofcode.org/js/s/partition
const $0886822fb2c47c3e$export$b29f828819edca8d = (arr, fn)=>arr.reduce(// eslint-disable-next-line no-shadow
    (acc, val, i, arr)=>{
        acc[fn(val, i, arr) ? 0 : 1].push(val);
        return acc;
    }, [
        [],
        []
    ]);

});

parcelRegister("dnm2H", function(module, exports) {
$parcel$export(module.exports, "default", () => $9bce858d67b211c3$export$2e2bcd8739ae039);

var $25nEq = parcelRequire("25nEq");

var $9YLuf = parcelRequire("9YLuf");

var $JnB9d = parcelRequire("JnB9d");

var $bn5mH = parcelRequire("bn5mH");
function $9bce858d67b211c3$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $9bce858d67b211c3$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $9bce858d67b211c3$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $9bce858d67b211c3$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
class $9bce858d67b211c3$export$2e2bcd8739ae039 {
    constructor(compressionRules = []){
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "canCompress", (event)=>this.compressionRules.some((compressionRule)=>compressionRule.canCompress(event)));
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "compress", (events)=>{
            const groups = this.createGroups(events);
            return groups.reduce((allCompressedEvents, group)=>{
                const groupCompressedEvents = this.compressGroup(group);
                return allCompressedEvents.concat(groupCompressedEvents);
            }, []);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "createGroups", (events)=>// Group events based on contextual fields. These fields are anything that is added by the client itself,
            // rather than passed in by the caller (eg. product, org. and tenant info)
            events.reduce((groups, event)=>{
                const matchingCompressor = this.compressionRules.find((compressor)=>compressor.canCompress(event));
                let contextFields;
                if (matchingCompressor) {
                    const actionFields = (0, $9YLuf.buildActionFields)(event, event.eventType);
                    contextFields = (0, $JnB9d.omit)(event, Object.keys(actionFields));
                }
                const matchingGroup = groups.find((group)=>matchingCompressor === group.compressor && (0, $JnB9d.equals)(contextFields, group.contextFields));
                if (matchingGroup) matchingGroup.events.push(event);
                else groups.push({
                    contextFields: contextFields,
                    compressor: matchingCompressor,
                    events: [
                        event
                    ]
                });
                return groups;
            }, []));
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "compressGroup", (group)=>{
            // If this group doesn't have any compressor, then the event args are already in their final format
            if (!group.compressor) return group.events;
            try {
                // Run the compressor on the group to generate some new events.
                // The compression function is only expected to return the action fields for each
                // event that it generates, since all other fields are generated by the client.
                const compressedEventActionFields = group.compressor.compress(group.events);
                // Add the context fields to each of the resulting events to inflate them into a full action event
                return compressedEventActionFields.map((actionFields)=>$9bce858d67b211c3$var$_objectSpread($9bce858d67b211c3$var$_objectSpread({}, actionFields), group.contextFields));
            } catch (e) {
                // If we fail to compress the events, then just fall back the uncompressed events
                // so that no data is lost. This can happen if the compression function throws an error
                // or returns some invalid event payloads.
                // eslint-disable-next-line no-console
                console.warn('Failed to compress some analytics events. ' + `Error: ${e.message}. Sending ${group.events.length} uncompressed events instead`);
                return group.events;
            }
        });
        if (!Array.isArray(compressionRules)) throw new Error('Event compressors must be constructed with an array of CompressionRules');
        if (!compressionRules.every((rule)=>rule instanceof (0, $bn5mH.CompressionRule))) throw new Error('Event compressors can only be constructed with instances of CompressionRule');
        this.compressionRules = compressionRules;
    }
}

});
parcelRegister("bn5mH", function(module, exports) {
$parcel$export(module.exports, "CompressionRule", () => $8476011c4327889d$export$89b3253ddfd2e6e8);

var $25nEq = parcelRequire("25nEq");

var $8t1l5 = parcelRequire("8t1l5");

var $JnB9d = parcelRequire("JnB9d");
class $8476011c4327889d$export$89b3253ddfd2e6e8 {
    /**
   * @callback EventPredicate
   * @param {object} event An analytics event
   * @returns {boolean} A flag indicating whether or not the event matches the conditions
   */ /**
   * @callback CompressionFunction
   * @param {Array.<Object>} events A collection of analytics events that match the predicate of this compression rule
   * @returns {Array.<Object>} compressedEvents The compressed analytics events to fire
   */ /**
   * This constructor defines a new rule for compressing analytics events.
   * @param {EventPredicate} predicate
   * @param {CompressionFunction} compressFn
   */ constructor(predicate, compressFn){
        /**
     * This function returns a flag indicating whether or not this instance is capable of compressing the given event.
     * @param event
     * @returns {boolean}
     */ (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "canCompress", (event)=>{
            try {
                return event && (0, $8t1l5.isActionEventType)(event.eventType) && this.predicate(event);
            } catch (e) {
                return false;
            }
        });
        /**
     * This function compresses as many events in the given collection as possible.<p>
     * Any events in the given collection that do not match the conditions of {@link canCompress} will be left uncompressed and
     * appended to the end of the resulting array.
     *
     * @param events A collection of analytic events to compress
     * @returns {Array.<Object>} The action fields for the resulting compressed events
     */ (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "compress", (events)=>{
            const [compatibleEvents, incompatibleEvents] = (0, $JnB9d.partition)(events, (event)=>this.canCompress(event));
            const compressedEvents = this.compressFn(compatibleEvents);
            if (!compressedEvents) throw new Error('No events were returned from the compression function');
            compressedEvents.forEach((event)=>{
                (0, $8t1l5.validateActionEventType)(event.eventType);
                (0, $8t1l5.validateActionEvent)(event);
            });
            return compressedEvents.concat(incompatibleEvents);
        });
        if (typeof predicate !== 'function') throw new Error('Invalid predicate, must be a function that accepts an event and returns a boolean');
        if (typeof compressFn !== 'function') throw new Error('Invalid compressFn, must be a function that both accepts and returns an array of events');
        this.predicate = predicate;
        this.compressFn = compressFn;
    }
}

});
parcelRegister("8t1l5", function(module, exports) {
$parcel$export(module.exports, "validateContainers", () => $62a21213e46430d1$export$e63ea5d8477971d3);
$parcel$export(module.exports, "isActionEventType", () => $62a21213e46430d1$export$d19cebda16f7579a);
$parcel$export(module.exports, "validateActionEventType", () => $62a21213e46430d1$export$4a8d7476662aebcc);
$parcel$export(module.exports, "validateActionEvent", () => $62a21213e46430d1$export$e0c121325c66ed4c);
$parcel$export(module.exports, "validateScreenEvent", () => $62a21213e46430d1$export$dc993432a592dc27);
$parcel$export(module.exports, "validateTrackEvent", () => $62a21213e46430d1$export$8c014fd74b0c8b99);
$parcel$export(module.exports, "validateDwellBaseEvent", () => $62a21213e46430d1$export$39d6334da9a44984);
$parcel$export(module.exports, "validateUIEvent", () => $62a21213e46430d1$export$e5bac0930c812e90);
$parcel$export(module.exports, "validateOperationalEvent", () => $62a21213e46430d1$export$1e561554275607ef);
$parcel$export(module.exports, "validateIdentifyEvent", () => $62a21213e46430d1$export$c16a4e16aa4026c0);
$parcel$export(module.exports, "validatePlatform", () => $62a21213e46430d1$export$801b46c35394d316);

var $iVpQc = parcelRequire("iVpQc");

var $drkuY = parcelRequire("drkuY");
const $62a21213e46430d1$var$actionEventTypes = Object.freeze([
    (0, $iVpQc.eventType).OPERATIONAL,
    (0, $iVpQc.eventType).TRACK,
    (0, $iVpQc.eventType).UI
]);
function $62a21213e46430d1$export$df8ff30e3c960006(container) {
    if (!(0, $drkuY.isPlainObject)(container)) throw new Error('properties.containers must be an Object');
    if (!('id' in container)) throw new Error("properties.containers is missing field 'id'");
    if (typeof container.id !== 'string') throw new Error('properties.containers.id must be of type String');
    if ('type' in container && typeof container.type !== 'string') throw new Error('properties.containers.type must be of type String');
}
function $62a21213e46430d1$export$e63ea5d8477971d3(containers) {
    if (!containers) return;
    if (containers && containers.constructor !== Object) throw new Error('properties.containers must be an Object');
    Object.values(containers).forEach((container)=>$62a21213e46430d1$export$df8ff30e3c960006(container));
}
function $62a21213e46430d1$export$d19cebda16f7579a(type) {
    switch(type){
        case (0, $iVpQc.eventType).OPERATIONAL:
        case (0, $iVpQc.eventType).TRACK:
        case (0, $iVpQc.eventType).UI:
            return true;
        default:
            return false;
    }
}
function $62a21213e46430d1$export$4a8d7476662aebcc(type) {
    if (!$62a21213e46430d1$export$d19cebda16f7579a(type)) throw new Error(`Invalid action event type: ${type}, must be one of: [${$62a21213e46430d1$var$actionEventTypes}]`);
    return true;
}
function $62a21213e46430d1$export$e0c121325c66ed4c(event) {
    if (!event) throw new Error('Missing event');
    if (!event.source) throw new Error('Missing event.source');
    if (!event.actionSubject) throw new Error('Missing event.actionSubject');
    if (!event.action) throw new Error('Missing event.action');
    $62a21213e46430d1$export$e63ea5d8477971d3(event.containers);
}
function $62a21213e46430d1$export$dc993432a592dc27(name) {
    if (!name) throw new Error('Missing name');
}
function $62a21213e46430d1$export$8c014fd74b0c8b99(event) {
    $62a21213e46430d1$export$e0c121325c66ed4c(event);
}
function $62a21213e46430d1$export$39d6334da9a44984(event) {
    if (!event) throw new Error('Missing event');
    if (!event.source) throw new Error('Missing event.source');
    if (!event.actionSubject) throw new Error('Missing event.actionSubject');
}
function $62a21213e46430d1$export$e5bac0930c812e90(event) {
    $62a21213e46430d1$export$e0c121325c66ed4c(event);
}
function $62a21213e46430d1$export$1e561554275607ef(event) {
    $62a21213e46430d1$export$e0c121325c66ed4c(event);
}
function $62a21213e46430d1$export$c16a4e16aa4026c0(userIdType, userId) {
    if (!userIdType) throw new Error('Missing userIdType');
    if (!userId) throw new Error('Missing userId');
    if (!(0, $iVpQc.isType)((0, $iVpQc.userType), userIdType)) throw new Error(`Invalid userIdType '${userIdType}', ` + `must be an userType: [${(0, $iVpQc.objectValues)((0, $iVpQc.userType))}]`);
}
function $62a21213e46430d1$export$801b46c35394d316(productInfo) {
    if (!(0, $iVpQc.isType)((0, $iVpQc.platformType), productInfo.platform)) throw new Error(`Invalid productInfo.platform '${productInfo.platform}', ` + `must be a platformType: [${(0, $iVpQc.objectValues)((0, $iVpQc.platformType))}]`);
    if (productInfo.origin === (0, $iVpQc.originType).DESKTOP && !(0, $iVpQc.isType)((0, $iVpQc.desktopPlatforms), productInfo.platform)) throw new Error(`Invalid productInfo.platform '${productInfo.platform}', ` + 'must be one of [mac, linux, windows]');
    if (productInfo.origin === (0, $iVpQc.originType).WEB && !(0, $iVpQc.isType)((0, $iVpQc.webPlatforms), productInfo.platform)) throw new Error(`Invalid productInfo.platform '${productInfo.platform}', must be one of [web, mobileWeb]`);
}

});




parcelRegister("dMV8Y", function(module, exports) {
$parcel$export(module.exports, "StopLowPriorityEventDelayReason", () => $a09c159ff13806bc$export$fa6e3729c21cb8f);
let $a09c159ff13806bc$export$fa6e3729c21cb8f = /*#__PURE__*/ function(StopLowPriorityEventDelayReason) {
    StopLowPriorityEventDelayReason["TIMEOUT"] = "timeout";
    StopLowPriorityEventDelayReason["MANUAL"] = "manual";
    return StopLowPriorityEventDelayReason;
}({});

});


parcelRegister("b1pOA", function(module, exports) {
$parcel$export(module.exports, "default", () => $8063d006f94016e3$export$2e2bcd8739ae039);

var $25nEq = parcelRequire("25nEq");

var $6JfQX = parcelRequire("6JfQX");

var $2eqm2 = parcelRequire("2eqm2");

var $f7ZYI = parcelRequire("f7ZYI");

var $i5knz = parcelRequire("i5knz");

var $ek8hZ = parcelRequire("ek8hZ");

var $cE3l4 = parcelRequire("cE3l4");

var $1guog = parcelRequire("1guog");

var $98R0b = parcelRequire("98R0b");

var $h2dqi = parcelRequire("h2dqi");

var $5U49X = parcelRequire("5U49X");
function $8063d006f94016e3$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $8063d006f94016e3$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $8063d006f94016e3$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $8063d006f94016e3$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
class $8063d006f94016e3$var$AnalyticsAPIResponse {
    constructor(success, validationErrors, message, code, validationReports){
        this.success = success;
        this.validationErrors = validationErrors;
        this.message = message;
        this.code = code;
        this.validationReports = validationReports;
    }
    isSuccess() {
        return this.success;
    }
    getValidationErrors() {
        return this.validationErrors;
    }
    getMessage() {
        return this.message;
    }
    getCode() {
        return this.code;
    }
    getValidationReports() {
        return this.validationReports;
    }
}
class $8063d006f94016e3$var$Message {
    constructor(error){
        this.error = error;
    }
}
class $8063d006f94016e3$var$EventValidationReport {
    constructor(messageId, results){
        this.messageId = messageId;
        this.results = results;
    }
    getMessageId() {
        return this.messageId;
    }
    getResults() {
        return this.results;
    }
}
class $8063d006f94016e3$export$133650fcdde1b226 {
    constructor(success, statusCode, message, eventResponseList){
        this.success = success;
        this.statusCode = statusCode;
        this.message = message;
        this.eventResponseList = eventResponseList;
    }
    isSuccess() {
        return this.success;
    }
    getStatusCode() {
        return this.statusCode;
    }
    getMessage() {
        return this.message;
    }
    getEventResponseList() {
        return this.eventResponseList;
    }
}
class $8063d006f94016e3$var$EventResponse {
    constructor(messageId, results, segmentEvent){
        this.messageId = messageId;
        this.results = results;
        this.segmentEvent = segmentEvent;
    }
    getMessageId() {
        return this.messageId;
    }
    getResults() {
        return this.results;
    }
    getSegmentEvent() {
        return this.segmentEvent;
    }
}
class $8063d006f94016e3$var$EventValidationResult {
    constructor(type, severity, propertyPath, message){
        this.type = type;
        this.severity = severity;
        this.propertyPath = propertyPath;
        this.message = message;
    }
    getType() {
        return this.type;
    }
    getSeverity() {
        return this.severity;
    }
    getPropertyPath() {
        return this.propertyPath;
    }
    getMessage() {
        return this.message;
    }
}
class $8063d006f94016e3$export$2e2bcd8739ae039 {
    constructor(options){
        var _this$options;
        // Using anonymous function so it can have the BatchFlushCallback type associated with it
        // And to allow it to not need bind when passing through to ResilieceQueue.
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "sendEvents", async (items, callback)=>{
            const httpRetryCount = this.resilienceQueue.getGlobalRetryCount();
            const metricsPayload = this.metrics.getMetricsPayload();
            const metadata = $8063d006f94016e3$var$_objectSpread($8063d006f94016e3$var$_objectSpread({}, metricsPayload), {}, {
                httpRetryCount: httpRetryCount
            });
            for(let key in metadata)// @ts-ignore Some keys maybe a string, but these will never equal 0
            if (metadata[key] === 0) // @ts-ignore Save space in requests by removing metrics with no impact
            delete metadata[key];
            const eventsWithXID = await this.attachXIDs(items);
            // Calculating sentAt after the XID generation as this may take some time.
            const sentAt = new Date().toISOString();
            const unpackagedEvents = eventsWithXID.map((item)=>{
                item.msg.sentAt = sentAt;
                return item.msg;
            });
            const batchBody = {
                batch: unpackagedEvents,
                sentAt: sentAt,
                metadata: metadata
            };
            const localResponseCallback = this.responseCallback;
            try {
                const response = await (0, $1guog.sendEvents)({
                    url: this.gasv3BatchUrl,
                    batch: batchBody,
                    timeout: this.options.requestTimeout
                });
                this.metrics.subtractFromMetrics(metricsPayload);
                callback(null, response);
                if (localResponseCallback !== null && response !== null) {
                    const analyticsAPIResponse = await response.clone().json();
                    const analyticsResponse = $8063d006f94016e3$var$BatchInterceptor.toAnalyticsResponse(items, null, analyticsAPIResponse);
                    localResponseCallback(analyticsResponse);
                }
            } catch (error) {
                callback(error, null);
                if (localResponseCallback !== null && error !== null) {
                    const analyticsResponse = $8063d006f94016e3$var$BatchInterceptor.toAnalyticsResponse(items, error, null);
                    localResponseCallback(analyticsResponse);
                }
            }
        });
        this.options = $8063d006f94016e3$var$_objectSpread($8063d006f94016e3$var$_objectSpread({}, options), {}, {
            requestTimeout: options.requestTimeout || (0, $ek8hZ.DEFAULT_REQUEST_TIMEOUT),
            retryQueueOptions: options.retryQueueOptions || {},
            logger: options.logger || console,
            disableCookiePersistence: options.disableCookiePersistence || false
        });
        this.user = new (0, $h2dqi.default)((_this$options = this.options) === null || _this$options === void 0 ? void 0 : _this$options.disableCookiePersistence);
        this.xidPromiseCallback = options.xidPromiseGetter();
        this.gasv3BatchUrl = `${options.apiHostProtocol}://${options.apiHost}/batch`;
        this.metrics = (0, $f7ZYI.default)();
        this.responseCallback = options.responseCallback;
        this.resilienceQueue = (0, $2eqm2.default)(options.retryQueuePrefix, options.product, this.options.retryQueueOptions, this.options.logger);
        this.resilienceQueue.start(this.sendEvents);
    }
    getUser() {
        return this.user;
    }
    async track(eventName, builtEvent, context, callback) {
        const baseEvent = this.buildBaseEvent(context, (0, $98R0b.SegmentEventTypes).TRACK, builtEvent);
        const eventWithoutMessageId = $8063d006f94016e3$var$_objectSpread($8063d006f94016e3$var$_objectSpread({}, baseEvent), {}, {
            type: (0, $98R0b.SegmentEventTypes).TRACK,
            properties: (0, $5U49X.prepareEventProperties)(builtEvent),
            event: eventName
        });
        const event = $8063d006f94016e3$var$_objectSpread($8063d006f94016e3$var$_objectSpread({}, eventWithoutMessageId), {}, {
            messageId: this.createMessageId()
        });
        const packagedEvent = this.packageEvent(event);
        await this.resilienceQueue.addItem(packagedEvent);
        if (callback) callback();
    }
    async page(eventName, builtEvent, context, callback) {
        const baseEvent = this.buildBaseEvent(context, (0, $98R0b.SegmentEventTypes).PAGE, builtEvent);
        const eventWithoutMessageId = $8063d006f94016e3$var$_objectSpread($8063d006f94016e3$var$_objectSpread({}, baseEvent), {}, {
            type: (0, $98R0b.SegmentEventTypes).PAGE,
            properties: (0, $5U49X.prepareEventProperties)(builtEvent),
            name: eventName
        });
        const event = $8063d006f94016e3$var$_objectSpread($8063d006f94016e3$var$_objectSpread({}, eventWithoutMessageId), {}, {
            messageId: this.createMessageId()
        });
        const packagedEvent = this.packageEvent(event);
        await this.resilienceQueue.addItem(packagedEvent);
        if (callback) callback();
    }
    // Segment uses the identifier to update user id which we have already done in the analyticsWebClient.ts
    async identify(_identifier, builtEvent, context, callback) {
        const baseEvent = this.buildBaseEvent(context, (0, $98R0b.SegmentEventTypes).IDENTIFY, builtEvent);
        const eventWithoutMessageId = $8063d006f94016e3$var$_objectSpread($8063d006f94016e3$var$_objectSpread({}, baseEvent), {}, {
            type: (0, $98R0b.SegmentEventTypes).IDENTIFY,
            traits: (0, $5U49X.prepareEventProperties)(builtEvent)
        });
        const event = $8063d006f94016e3$var$_objectSpread($8063d006f94016e3$var$_objectSpread({}, eventWithoutMessageId), {}, {
            messageId: this.createMessageId()
        });
        const packagedEvent = this.packageEvent(event);
        await this.resilienceQueue.addItem(packagedEvent);
        if (callback) callback();
    }
    buildBaseEvent(context, type, overrides) {
        const clonedContext = (0, $5U49X.prepareEventProperties)(context);
        const segmentContext = (0, $5U49X.buildContext)(clonedContext);
        return {
            context: segmentContext,
            timestamp: new Date().toISOString(),
            type: type,
            userId: this.user.getUserId(),
            anonymousId: overrides.anonymousId || this.user.getAnonymousId()
        };
    }
    createMessageId() {
        return `ajs-${(0, $6JfQX.default)()}`;
    }
    packageEvent(event) {
        const { apiHost: apiHost, apiHostProtocol: apiHostProtocol } = this.options;
        return {
            headers: {
                'Content-Type': 'text/plain'
            },
            msg: event,
            url: `${apiHostProtocol}://${apiHost}/${event.type.charAt(0)}`
        };
    }
    async attachXIDs(items) {
        if (this.xidPromiseCallback) return (0, $i5knz.attachXidToMultipleEvents)(items, this.xidPromiseCallback);
        return Promise.resolve(items);
    }
    setResponseCallback(responseCallback) {
        this.responseCallback = responseCallback;
    }
}
class $8063d006f94016e3$var$BatchInterceptor {
    static toAnalyticsResponse(items, error, analyticsAPIResponse) {
        const eventResponseList = [];
        if (analyticsAPIResponse !== null) {
            const [statusCode, success] = [
                analyticsAPIResponse.code,
                analyticsAPIResponse.success
            ];
            if (statusCode >= 200 && statusCode <= 299) {
                var _analyticsAPIResponse;
                (_analyticsAPIResponse = analyticsAPIResponse.validationReports) === null || _analyticsAPIResponse === void 0 || _analyticsAPIResponse.forEach((report)=>{
                    const matchedEvent = items.find((item)=>item.msg.messageId === report.messageId);
                    if (matchedEvent) eventResponseList.push(new $8063d006f94016e3$var$EventResponse(matchedEvent.msg.messageId, report.results, matchedEvent.msg));
                });
                return new $8063d006f94016e3$export$133650fcdde1b226(success, statusCode, (0, $cE3l4.HTTP_STATUS_CODE_MAP).get(statusCode), eventResponseList);
            } else if (statusCode >= 400 && statusCode <= 499) {
                var _analyticsAPIResponse2;
                // not exluding "HTTP 429 Too Many Requests error" as it is thrown as an error and handled below
                const errorMessage = ((_analyticsAPIResponse2 = analyticsAPIResponse.message) === null || _analyticsAPIResponse2 === void 0 ? void 0 : _analyticsAPIResponse2.error) !== null ? analyticsAPIResponse.message.error : (0, $cE3l4.HTTP_STATUS_CODE_MAP).has(statusCode) ? (0, $cE3l4.HTTP_STATUS_CODE_MAP).get(statusCode) : (0, $cE3l4.HTTP_STATUS_CODE_MAP).get(-1);
                items.forEach((item)=>{
                    eventResponseList.push(new $8063d006f94016e3$var$EventResponse(item.msg.messageId, [], item.msg));
                });
                return new $8063d006f94016e3$export$133650fcdde1b226(success, statusCode, errorMessage, eventResponseList);
            }
        } else if (error !== null && error.message !== null) {
            const match = error.message.match($8063d006f94016e3$var$BatchInterceptor.http_error_regex);
            if (match) {
                items.forEach((item)=>{
                    eventResponseList.push(new $8063d006f94016e3$var$EventResponse(item.msg.messageId, [], item.msg));
                });
                return new $8063d006f94016e3$export$133650fcdde1b226(false, Number(match[1]), match[2], eventResponseList);
            }
        }
        items.forEach((item)=>{
            eventResponseList.push(new $8063d006f94016e3$var$EventResponse(item.msg.messageId, [], item.msg));
        });
        return new $8063d006f94016e3$export$133650fcdde1b226(false, -1, (0, $cE3l4.HTTP_STATUS_CODE_MAP).get(-1), eventResponseList);
    }
}
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($8063d006f94016e3$var$BatchInterceptor, "http_error_regex", /HTTP Error\s([0-9]{3})\s\((.+)\)/);

});
parcelRegister("2eqm2", function(module, exports) {
$parcel$export(module.exports, "default", () => $1a0155095a3f2ec1$export$2e2bcd8739ae039);

var $5GCGS = parcelRequire("5GCGS");

var $aj05j = parcelRequire("aj05j");
var $1a0155095a3f2ec1$export$2e2bcd8739ae039 = (retryQueuePrefix, product, options, logger)=>{
    return new (0, $5GCGS.default)(retryQueuePrefix, product, options || {}, logger);
};

});
parcelRegister("5GCGS", function(module, exports) {
$parcel$export(module.exports, "default", () => $423ee3281e0e5431$export$2e2bcd8739ae039);

var $25nEq = parcelRequire("25nEq");

var $HtOhi = parcelRequire("HtOhi");
var $iGJ4b = parcelRequire("iGJ4b");

var $hhxHW = parcelRequire("hhxHW");
var $fra0H = parcelRequire("fra0H");
var $1WplY = parcelRequire("1WplY");

var $f7ZYI = parcelRequire("f7ZYI");

var $cBhno = parcelRequire("cBhno");

var $6KF64 = parcelRequire("6KF64");
var $gWFU9 = parcelRequire("gWFU9");

var $aj05j = parcelRequire("aj05j");
function $423ee3281e0e5431$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $423ee3281e0e5431$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $423ee3281e0e5431$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $423ee3281e0e5431$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
const $423ee3281e0e5431$var$ONE_MINUTE = 60000;
const $423ee3281e0e5431$var$LONG_POLLING_OPTIONS = {
    backoffFactor: 0,
    backoffJitterPercentage: 0,
    flushWaitMs: $423ee3281e0e5431$var$ONE_MINUTE,
    minRetryDelay: $423ee3281e0e5431$var$ONE_MINUTE,
    maxRetryDelay: $423ee3281e0e5431$var$ONE_MINUTE
};
const $423ee3281e0e5431$export$d219df4fe04c04a7 = {
    backoffFactor: 2,
    backoffJitterPercentage: 0.2,
    batchFlushSize: 7,
    flushBeforeUnload: false,
    flushWaitMs: 500,
    maxAttempts: 10,
    // TODO figure out this number. For indexeddb we are sharing the queue with all tabs
    maxItems: 1000,
    maxRetryDelay: 30000,
    minRetryDelay: 1000
};
class $423ee3281e0e5431$export$2e2bcd8739ae039 {
    constructor(queuePrefix, product, options, logger){
        this.queuePrefix = queuePrefix;
        // Avoiding using options in ResilienceDB at this stage as
        // the options are optimised for the PushBatchableQueue
        this.resilience = new (0, $fra0H.default)(product, {
            logger: logger,
            maxAttempts: options === null || options === void 0 ? void 0 : options.maxAttempts,
            maxEventLimit: options === null || options === void 0 ? void 0 : options.maxItems
        });
        this.options = this.buildOptions(options);
        this.scheduler = new (0, $6KF64.default)($423ee3281e0e5431$var$_objectSpread($423ee3281e0e5431$var$_objectSpread({}, this.options), {}, {
            waitInterval: options !== null && options !== void 0 && options.flushBeforeUnload ? 0 : this.options.flushWaitMs
        }), this.scheduleCallback.bind(this));
        this.longPollingScheduler = new (0, $6KF64.default)($423ee3281e0e5431$var$_objectSpread($423ee3281e0e5431$var$_objectSpread({}, $423ee3281e0e5431$var$LONG_POLLING_OPTIONS), {}, {
            waitInterval: $423ee3281e0e5431$var$LONG_POLLING_OPTIONS.flushWaitMs
        }), this.scheduleLongCallBack.bind(this));
        this.metricsCollector = (0, $f7ZYI.default)();
        this.networkStatus = new (0, $cBhno.default)((status)=>{
            if (status === (0, $aj05j.NetworkStatusEnum).OFFLINE) this.scheduler.stop();
            else this.checkEventCountAndReschedule();
        });
    }
    start(flushCallback) {
        this.batchFlushCallback = flushCallback;
        this.longPollingScheduler.schedule();
    }
    stop() {
        this.scheduler.stop();
        this.longPollingScheduler.stop();
    }
    async addItem(item) {
        // Since Jira and Confluence use `.toJSON` on objects that should be strings
        // And expect us to use `JSON.stringify` on these objects,
        // And indexeddb strips these functions from the objects when adding them to the DB,
        // We must run this silly stringify and parse before passing the event to the resilience meechanism.
        // Planning on removing this in v4
        const jsonStringifiedAndParsedItem = JSON.parse(JSON.stringify(item));
        const { numberOfEvictedItems: numberOfEvictedItems } = await this.resilience.addItem(jsonStringifiedAndParsedItem, {}, (0, $1WplY.GuardPolicy).EVICT);
        this.scheduler.schedule();
        this.metricsCollector.addToEventCount();
        if (numberOfEvictedItems > 0) this.metricsCollector.addToItemsDiscardedByOverflowCounter(numberOfEvictedItems);
    }
    getGlobalRetryCount() {
        return this.scheduler.getFailureCount();
    }
    async scheduleCallback(done) {
        // Even though we stopped the scheduler, it can be restarted with a call to schedule.
        // This could be triggered by a new event or the longPollingScheduler
        if (this.networkStatus.getNetworkStatus() === (0, $aj05j.NetworkStatusEnum).OFFLINE) {
            done((0, $gWFU9.DoneState).NOOP);
            return;
        }
        try {
            const result = await this.resilience.processItems(this.flush.bind(this), this.options.batchFlushSize);
            done(result);
        } catch (error) {
            if (error.name === (0, $hhxHW.CallbackProcessingErrorName)) {
                done((0, $gWFU9.DoneState).ERROR);
                return;
            }
        // TODO we can probably log here but throwing is useless as it will just be shallowed by the Scheduler
        // In theory something else should catch all other errors from indexeddb and this should never happen.
        } finally{
            await this.checkEventCountAndReschedule();
        }
    }
    async checkEventCountAndReschedule() {
        const eventWaitingCount = await this.resilience.getItemCount();
        if (eventWaitingCount > 0) this.scheduler.schedule({
            immediate: eventWaitingCount >= this.options.batchFlushSize
        });
    }
    async scheduleLongCallBack(done) {
        // Eventually we will want to send data about how many queues were purged
        const numberOfQueuesPurged = (0, $HtOhi.default)(this.queuePrefix);
        this.metricsCollector.addToPurgedQueuesMetrics(numberOfQueuesPurged);
        // Eventually we will want to send data about how attempted reclaims and actual reclaims were made
        const reclaimMetrics = await (0, $iGJ4b.default)(this.queuePrefix, async (localStorageItems)=>{
            const itemsToAdd = localStorageItems.map((localStorageItem)=>({
                    item: localStorageItem.item,
                    retryAttempts: localStorageItem.attemptNumber,
                    id: localStorageItem.id
                }));
            const { items: addedEvents } = await this.resilience.bulkAddItem(itemsToAdd, (0, $1WplY.GuardPolicy).IGNORE);
            if (addedEvents.length === itemsToAdd.length) return {
                status: 'successful'
            };
            else return {
                status: 'partial',
                acceptedItemIds: addedEvents.map((event)=>event.id)
            };
        });
        this.metricsCollector.addToReclaimMetrics(reclaimMetrics);
        // We dont want to flush events from here as there maybe issues with analytics-service
        // Scheduler has all the context and can schedule the next batch accordingly
        await this.checkEventCountAndReschedule();
        done((0, $gWFU9.DoneState).SUCCESS);
        this.longPollingScheduler.schedule();
    }
    flush(wrappedItems, otherMetadata) {
        this.metricsCollector.setResilienceMechanism(this.resilience.storeType());
        const { batchFlushCallback: batchFlushCallback } = this;
        if (!batchFlushCallback) throw new Error('batchFlushCallback has not been set. Call PullBatchableQueue#start first.');
        return new Promise((resolve, reject)=>{
            if (wrappedItems.length <= 0) {
                resolve((0, $gWFU9.DoneState).NOOP);
                return;
            }
            const items = wrappedItems.map((wrappedItem)=>{
                const item = wrappedItem.item;
                if (wrappedItem.retryAttempts > 0 && item.msg) {
                    if (!item.msg._metadata) item.msg._metadata = {};
                    item.msg._metadata.failedAttempts = wrappedItem.retryAttempts;
                }
                return item;
            });
            batchFlushCallback(items, (error)=>{
                if (error) {
                    if (otherMetadata.numberOfDeletedItems > 0) this.metricsCollector.addToItemsDiscardedByRetryCounter(otherMetadata.numberOfDeletedItems);
                    reject(error);
                } else resolve((0, $gWFU9.DoneState).SUCCESS);
            });
        });
    }
    buildOptions(options) {
        return {
            backoffFactor: (options === null || options === void 0 ? void 0 : options.backoffFactor) || $423ee3281e0e5431$export$d219df4fe04c04a7.backoffFactor,
            backoffJitterPercentage: (options === null || options === void 0 ? void 0 : options.backoffJitterPercentage) !== undefined ? options.backoffJitterPercentage : $423ee3281e0e5431$export$d219df4fe04c04a7.backoffJitterPercentage,
            batchFlushSize: (options === null || options === void 0 ? void 0 : options.batchFlushSize) || $423ee3281e0e5431$export$d219df4fe04c04a7.batchFlushSize,
            flushBeforeUnload: (options === null || options === void 0 ? void 0 : options.flushBeforeUnload) || $423ee3281e0e5431$export$d219df4fe04c04a7.flushBeforeUnload,
            flushWaitMs: (options === null || options === void 0 ? void 0 : options.flushWaitMs) || $423ee3281e0e5431$export$d219df4fe04c04a7.flushWaitMs,
            maxItems: (options === null || options === void 0 ? void 0 : options.maxItems) || $423ee3281e0e5431$export$d219df4fe04c04a7.maxItems,
            maxAttempts: (options === null || options === void 0 ? void 0 : options.maxAttempts) || $423ee3281e0e5431$export$d219df4fe04c04a7.maxAttempts,
            maxRetryDelay: (options === null || options === void 0 ? void 0 : options.maxRetryDelay) || $423ee3281e0e5431$export$d219df4fe04c04a7.maxRetryDelay,
            minRetryDelay: (options === null || options === void 0 ? void 0 : options.minRetryDelay) || $423ee3281e0e5431$export$d219df4fe04c04a7.minRetryDelay
        };
    }
}

});
parcelRegister("HtOhi", function(module, exports) {
$parcel$export(module.exports, "default", () => $082b23e62c13d3af$export$2e2bcd8739ae039);

var $2pjLp = parcelRequire("2pjLp");

var $axTpD = parcelRequire("axTpD");
// For more details on this funciton, see https://hello.atlassian.net/wiki/spaces/MEASURE/pages/585086028/Investigation+Local+storage+full
// TL;DR
// If a queue looses its `ack` key in localstorage, it will never get claimed.
// There is a small chance that this can happen.
// This function is to run through queues and clean any that have been orphaned.
// Keys stolen from https://github.com/segmentio/localstorage-retry/blob/master/lib/index.js#L55
const $082b23e62c13d3af$var$validSuffixs = Object.values((0, $2pjLp.LocalStorageKeySuffix));
var $082b23e62c13d3af$export$2e2bcd8739ae039 = (prefix)=>{
    if (typeof prefix !== 'string' || prefix.length === 0) // We do not want to start deleting everything in localstorage
    return 0;
    try {
        const queueStates = Object.keys(localStorage).filter((key)=>key && key.startsWith(`${prefix}.`) || false).map((key)=>key.split('.')).filter((splitKeys)=>splitKeys.length === 3 && $082b23e62c13d3af$var$validSuffixs.includes(splitKeys[2])).reduce((accumulator, currentKeys)=>{
            const [, id, suffix] = currentKeys;
            if (accumulator[id] === undefined) accumulator[id] = {};
            accumulator[id][suffix] = true;
            return accumulator;
        }, {});
        const queuesToPurge = Object.keys(queueStates).filter((id)=>queueStates[id][(0, $2pjLp.LocalStorageKeySuffix).ACK] !== true);
        queuesToPurge.forEach((id)=>{
            const { queue: queue, inProgress: inProgress, reclaimStart: reclaimStart, reclaimEnd: reclaimEnd } = (0, $axTpD.createLocalStorageKeys)(prefix, id);
            localStorage.removeItem(inProgress);
            localStorage.removeItem(queue);
            localStorage.removeItem(reclaimStart);
            localStorage.removeItem(reclaimEnd);
        });
        return queuesToPurge.length;
    } catch (_error) {
    // Ignore errors from localStorage.
    }
    return 0;
};

});
parcelRegister("2pjLp", function(module, exports) {
$parcel$export(module.exports, "LocalStorageKeySuffix", () => $1c0d3f3df37832ee$export$ecfa71cbc9b28241);
$parcel$export(module.exports, "Timers", () => $1c0d3f3df37832ee$export$8bb2c1fb2b1765a9);
let $1c0d3f3df37832ee$export$ecfa71cbc9b28241 = /*#__PURE__*/ function(LocalStorageKeySuffix) {
    LocalStorageKeySuffix["IN_PROGRESS"] = "inProgress";
    LocalStorageKeySuffix["QUEUE"] = "queue";
    LocalStorageKeySuffix["RECLAIM_START"] = "reclaimStart";
    LocalStorageKeySuffix["RECLAIM_END"] = "reclaimEnd";
    LocalStorageKeySuffix["ACK"] = "ack";
    return LocalStorageKeySuffix;
}({});
let $1c0d3f3df37832ee$export$8bb2c1fb2b1765a9 = /*#__PURE__*/ function(Timers) {
    Timers[Timers["RECLAIM_TIMEOUT"] = 10000] = "RECLAIM_TIMEOUT";
    Timers[Timers["RECLAIM_WAIT"] = 500] = "RECLAIM_WAIT";
    Timers[Timers["RECLAIM_WAIT_THRESHOLD"] = 2000] = "RECLAIM_WAIT_THRESHOLD";
    return Timers;
}({});

});

parcelRegister("axTpD", function(module, exports) {
$parcel$export(module.exports, "createLocalStorageKeys", () => $7ad7f83c4208ee8a$export$8433d54f767cbec5);

var $2pjLp = parcelRequire("2pjLp");
const $7ad7f83c4208ee8a$export$8433d54f767cbec5 = (queuePrefix, queueId)=>({
        [(0, $2pjLp.LocalStorageKeySuffix).ACK]: `${queuePrefix}.${queueId}.${(0, $2pjLp.LocalStorageKeySuffix).ACK}`,
        [(0, $2pjLp.LocalStorageKeySuffix).QUEUE]: `${queuePrefix}.${queueId}.${(0, $2pjLp.LocalStorageKeySuffix).QUEUE}`,
        [(0, $2pjLp.LocalStorageKeySuffix).IN_PROGRESS]: `${queuePrefix}.${queueId}.${(0, $2pjLp.LocalStorageKeySuffix).IN_PROGRESS}`,
        [(0, $2pjLp.LocalStorageKeySuffix).RECLAIM_START]: `${queuePrefix}.${queueId}.${(0, $2pjLp.LocalStorageKeySuffix).RECLAIM_START}`,
        [(0, $2pjLp.LocalStorageKeySuffix).RECLAIM_END]: `${queuePrefix}.${queueId}.${(0, $2pjLp.LocalStorageKeySuffix).RECLAIM_END}`
    });

});


parcelRegister("iGJ4b", function(module, exports) {
$parcel$export(module.exports, "default", () => $d9af1b819e4f58d3$export$2e2bcd8739ae039);

var $25nEq = parcelRequire("25nEq");

var $6JfQX = parcelRequire("6JfQX");

var $2pjLp = parcelRequire("2pjLp");

var $axTpD = parcelRequire("axTpD");
function $d9af1b819e4f58d3$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $d9af1b819e4f58d3$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $d9af1b819e4f58d3$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $d9af1b819e4f58d3$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
// Code we need to mimic:
// https://github.com/segmentio/localstorage-retry/blob/master/lib/index.js#L262-L357
// Note we do not want to run this library due to the performance, duplication and memory leak issues.
const $d9af1b819e4f58d3$var$promisedSetTimeout = (msToWait)=>new Promise((resolve)=>{
        setTimeout(resolve, msToWait);
    });
const $d9af1b819e4f58d3$var$findOtherQueues = (queuePrefix)=>{
    try {
        return Object.keys(localStorage).filter((key)=>key.startsWith(queuePrefix)).map((key)=>key.split('.')).filter((split)=>{
            if (split.length === 3 && split[0] === queuePrefix && split[2] === (0, $2pjLp.LocalStorageKeySuffix).ACK) try {
                const ackTimestamp = localStorage.getItem(split.join('.'));
                if (ackTimestamp) {
                    const ackTimestampNumber = parseInt(ackTimestamp);
                    return (0, $2pjLp.Timers).RECLAIM_TIMEOUT + ackTimestampNumber < Date.now();
                }
            } catch (error) {
            // ignore and drop value
            }
            return false;
        }).map((split)=>split[1]);
    } catch (_error) {
    // Ignore errors from accessing localStorage.
    }
    return [];
};
const $d9af1b819e4f58d3$var$tryReclaim = async (options, callback)=>{
    const { ack: ack, reclaimStart: reclaimStart, reclaimEnd: reclaimEnd } = options.storageKeys;
    const start = Date.now();
    localStorage.setItem(reclaimStart, options.reclaimProcessId);
    localStorage.setItem(ack, start.toString());
    await $d9af1b819e4f58d3$var$promisedSetTimeout((0, $2pjLp.Timers).RECLAIM_WAIT);
    if (// Prevent duplicates when extracting events from localstorage due to CPU / Memory pressure on client
    Date.now() > start + (0, $2pjLp.Timers).RECLAIM_WAIT_THRESHOLD || // Either the parent has caught up and removed our claim, or someone else started a claim instead
    localStorage.getItem(reclaimStart) !== options.reclaimProcessId) throw new Error('Took to long to callback, reclaim abandonded. After reclaimStart.');
    localStorage.setItem(reclaimEnd, options.reclaimProcessId);
    await $d9af1b819e4f58d3$var$promisedSetTimeout((0, $2pjLp.Timers).RECLAIM_WAIT);
    if (// Prevent duplicates when extracting events from localstorage due to CPU / Memory pressure on client
    Date.now() > start + (0, $2pjLp.Timers).RECLAIM_WAIT_THRESHOLD || // Either the parent has caught up and removed our claim, or someone else started a claim instead
    localStorage.getItem(reclaimStart) !== options.reclaimProcessId || localStorage.getItem(reclaimEnd) !== options.reclaimProcessId) throw new Error('Took to long to callback, reclaim abandonded. After reclaimEnd.');
    return $d9af1b819e4f58d3$var$reclaim(options, callback);
};
const $d9af1b819e4f58d3$var$reclaim = async (options, callback)=>{
    const { queue: queue, inProgress: inProgress } = options.storageKeys;
    // Queue is an array of events while inProgress is an object with a uuid for key
    // Either of these queues may legitimately be missing.
    const eventsInQueue = JSON.parse(localStorage.getItem(queue) || '[]');
    const eventsInProgress = JSON.parse(localStorage.getItem(inProgress) || '{}');
    const arrayOfEventsInProgress = Object.entries(eventsInProgress).map(([key, item])=>{
        const itemWithId = $d9af1b819e4f58d3$var$_objectSpread($d9af1b819e4f58d3$var$_objectSpread({}, item), {}, {
            // LocalStorage-retry would add the attemptCounter after failure, rather than
            // as it was being processed
            attemptNumber: item.attemptNumber + 1,
            id: key
        });
        return itemWithId;
    });
    const eventsToProcess = [
        ...eventsInQueue,
        ...arrayOfEventsInProgress
    ];
    if (eventsToProcess.length > 0) {
        const result = await callback(eventsToProcess);
        if (result.status === 'successful') $d9af1b819e4f58d3$var$clearLocalStorageKeys(options.storageKeys);
        else if (result.status === 'partial') {
            // Dont delete all events if we are only able to take some of them.
            const leftover = eventsToProcess.filter((event)=>!result.acceptedItemIds.includes(event.id));
            // This way around, we can almost ensure that we wont hit memory quota exceeded errors.
            // However, there is a very small chance that we may lose events if the process exits between these two commands.
            localStorage.removeItem(inProgress);
            localStorage.setItem(queue, JSON.stringify(leftover));
            return {
                fullReclaim: false
            };
        }
    } else $d9af1b819e4f58d3$var$clearLocalStorageKeys(options.storageKeys);
    return {
        fullReclaim: true
    };
};
// Exterminate
const $d9af1b819e4f58d3$var$clearLocalStorageKeys = (keys)=>{
    // Always good to do queue and inprogress first to reduce duplications
    // and to free up more space in localstorage
    localStorage.removeItem(keys.queue);
    localStorage.removeItem(keys.inProgress);
    localStorage.removeItem(keys.reclaimEnd);
    localStorage.removeItem(keys.reclaimStart);
    // This has to be last or we risk leaving things in localStorage that have to be purged
    localStorage.removeItem(keys.ack);
};
var $d9af1b819e4f58d3$export$2e2bcd8739ae039 = async (queuePrefix, callback)=>{
    if (typeof queuePrefix !== 'string' || queuePrefix.length === 0) // We do not want to start deleting everything in localstorage
    return {
        fullReclaims: 0,
        partialReclaims: 0,
        failedReclaims: 0
    };
    const reclaimProcessId = (0, $6JfQX.default)();
    const queuesToReclaim = $d9af1b819e4f58d3$var$findOtherQueues(queuePrefix);
    const claims = queuesToReclaim.map((id)=>$d9af1b819e4f58d3$var$tryReclaim({
            queuePrefix: queuePrefix,
            reclaimProcessId: reclaimProcessId,
            storageKeys: (0, $axTpD.createLocalStorageKeys)(queuePrefix, id)
        }, callback));
    const settledClaims = await Promise.allSettled(claims);
    const failedReclaims = settledClaims.filter((claim)=>claim.status === 'rejected');
    const successfulClaims = settledClaims.filter((settledValue)=>settledValue.status === 'fulfilled').map((result)=>result.value);
    const fullReclaims = successfulClaims.filter((claim)=>claim.fullReclaim);
    const partialReclaims = successfulClaims.filter((claim)=>!claim.fullReclaim);
    return {
        failedReclaims: failedReclaims.length,
        partialReclaims: partialReclaims.length,
        fullReclaims: fullReclaims.length
    };
};

});

parcelRegister("hhxHW", function(module, exports) {
$parcel$export(module.exports, "CallbackProcessingErrorName", () => $c94e2bdc5ed2232d$export$a409c8de90e11e14);
$parcel$export(module.exports, "default", () => $c94e2bdc5ed2232d$export$2e2bcd8739ae039);
const $c94e2bdc5ed2232d$export$a409c8de90e11e14 = 'CallbackProcessingError';
class $c94e2bdc5ed2232d$export$2e2bcd8739ae039 extends Error {
    constructor(error){
        const messageFromError = error && typeof error === 'object' && 'toString' in error && typeof error.toString === 'function' && error.toString();
        const messageFromString = typeof error === 'string' && error;
        const message = messageFromError || messageFromString || 'Argument passed to CallbackProcessingError was not an Error or string.';
        super(`Error thrown while processing events in callback: ${message}`);
        // Must reset the prototypes after calling super of builtin classes
        // https://github.com/Microsoft/TypeScript/wiki/Breaking-Changes#extending-built-ins-like-error-array-and-map-may-no-longer-work
        Object.setPrototypeOf(this, $c94e2bdc5ed2232d$export$2e2bcd8739ae039.prototype);
        this.name = $c94e2bdc5ed2232d$export$a409c8de90e11e14;
    }
}

});

parcelRegister("fra0H", function(module, exports) {
$parcel$export(module.exports, "default", () => $b3d1247d54022003$export$2e2bcd8739ae039);

var $3SNIx = parcelRequire("3SNIx");

var $1WplY = parcelRequire("1WplY");

var $hhxHW = parcelRequire("hhxHW");
var $b3d1247d54022003$export$2e2bcd8739ae039 = (0, $3SNIx.default);

});
parcelRegister("3SNIx", function(module, exports) {
$parcel$export(module.exports, "default", () => $2d3cfb10efc658b6$export$2e2bcd8739ae039);

var $1WplY = parcelRequire("1WplY");

var $dRiso = parcelRequire("dRiso");
var $3pjih = parcelRequire("3pjih");

var $lXcF4 = parcelRequire("lXcF4");

var $7qakG = parcelRequire("7qakG");

var $5qvuM = parcelRequire("5qvuM");
class $2d3cfb10efc658b6$export$2e2bcd8739ae039 {
    constructor(namespace, options = {}){
        this.namespace = namespace;
        this.options = (0, $5qvuM.createOptionsWithDefaults)(options);
        if (!namespace || namespace.length === 0 || typeof namespace !== 'string') throw new Error('Invalid namespace provided');
        this.resilience = this.getResilienceMechanism(namespace, options);
    }
    getResilienceMechanism(namespace, options) {
        if (!options.useMemory) try {
            return new (0, $lXcF4.default)(namespace, options);
        } catch (error) {
            if (!(error instanceof (0, $dRiso.default))) {
                var _options$logger;
                (_options$logger = options.logger) === null || _options$logger === void 0 || _options$logger.warn('Attempted to create IndexedDbResilience but failed. Using memory instead.');
            }
        }
        return new (0, $7qakG.default)(this.namespace, options);
    }
    addItem(item, options, policy = (0, $1WplY.GuardPolicy).ABANDON) {
        return this.runOrFailOver(()=>this.resilience.addItem(item, options, policy));
    }
    bulkAddItem(itemOptions, policy = (0, $1WplY.GuardPolicy).ABANDON) {
        return this.runOrFailOver(()=>this.resilience.bulkAddItem(itemOptions, policy));
    }
    getItems(count) {
        return this.runOrFailOver(()=>this.resilience.getItems(count));
    }
    deleteItems(itemIds) {
        return this.runOrFailOver(()=>this.resilience.deleteItems(itemIds));
    }
    getItemCount() {
        return this.runOrFailOver(()=>this.resilience.getItemCount());
    }
    processItems(processFn, count) {
        return this.runOrFailOver(()=>this.resilience.processItems(processFn, count));
    }
    storeType() {
        return this.resilience.storeType();
    }
    async runOrFailOver(runnable) {
        try {
            return await runnable();
        } catch (error) {
            if ((0, $3pjih.shouldIgnoreResilienceDbError)(error)) throw error;
            else if (this.resilience.storeType() === (0, $1WplY.StoreType).INDEXEDDB) await this.failOver();
            return runnable();
        }
    }
    async failOver() {
        // Attempt to get any events we can and put them into memory
        const oldResilience = this.resilience;
        const newResilience = new (0, $7qakG.default)(this.namespace, this.options);
        this.resilience = newResilience;
        try {
            const { items: items } = await oldResilience.getItems(this.options.maxEventLimit);
            if (items.length > 0) {
                const bulkAddItemsResponse = await newResilience.bulkAddItemWrapperType(items, (0, $1WplY.GuardPolicy).IGNORE);
                const addedItemIds = bulkAddItemsResponse.items.map((item)=>item.id);
                await oldResilience.deleteItems(addedItemIds);
            }
        } catch (error) {
            this.options.logger.warn('Unexpected error from ResilienceDb, switching to MemoryDb');
        // Dont need to catch. We are just getting events if we can
        }
    }
}

});
parcelRegister("1WplY", function(module, exports) {
$parcel$export(module.exports, "NAMESPACE_AND_TIME_ADDED_INDEX", () => $169edfe3bdff1bfd$export$d21fbb25eb37b5bf);
$parcel$export(module.exports, "RESILIENCE_DB_NAME", () => $169edfe3bdff1bfd$export$8cad224051643259);
$parcel$export(module.exports, "RESILIENCE_STORE_NAME", () => $169edfe3bdff1bfd$export$3d8420be07b276ab);
$parcel$export(module.exports, "TIME_TO_PROCESS_AFTER_INDEX", () => $169edfe3bdff1bfd$export$a512a65455fce2a6);
$parcel$export(module.exports, "TIME_ADDED_INDEX", () => $169edfe3bdff1bfd$export$89d9c1ff8ac91862);
$parcel$export(module.exports, "RETRY_INDEX", () => $169edfe3bdff1bfd$export$a37d385bcd713809);
$parcel$export(module.exports, "INDEXEDDB_TIMEOUT", () => $169edfe3bdff1bfd$export$6d8635fed0e4b14d);
$parcel$export(module.exports, "StoreType", () => $169edfe3bdff1bfd$export$39337ab5872e9457);
$parcel$export(module.exports, "GuardPolicy", () => $169edfe3bdff1bfd$export$7710d69e6f450f20);
const $169edfe3bdff1bfd$export$d21fbb25eb37b5bf = 'namespace-timeAdded';
const $169edfe3bdff1bfd$export$8cad224051643259 = 'analytics-web-client';
const $169edfe3bdff1bfd$export$3d8420be07b276ab = 'analytics-resilience';
const $169edfe3bdff1bfd$export$a512a65455fce2a6 = 'timeToBeProcessedAfter';
const $169edfe3bdff1bfd$export$89d9c1ff8ac91862 = 'timeAdded';
const $169edfe3bdff1bfd$export$a37d385bcd713809 = 'retryAttempts';
const $169edfe3bdff1bfd$export$6d8635fed0e4b14d = 15000;
let $169edfe3bdff1bfd$export$39337ab5872e9457 = /*#__PURE__*/ function(StoreType) {
    StoreType["INDEXEDDB"] = "indexeddb";
    StoreType["MEMORY"] = "memory";
    return StoreType;
}({});
let $169edfe3bdff1bfd$export$7710d69e6f450f20 = /*#__PURE__*/ function(GuardPolicy) {
    GuardPolicy["IGNORE"] = "ignore";
    GuardPolicy["ABANDON"] = "abandon";
    GuardPolicy["EVICT"] = "evict";
    return GuardPolicy;
}({});

});

parcelRegister("dRiso", function(module, exports) {
$parcel$export(module.exports, "default", () => $a16e8ac8262a29f2$export$2e2bcd8739ae039);
const $a16e8ac8262a29f2$export$fc14cf6dcea0f8ed = 'NoIndexedDbError';
class $a16e8ac8262a29f2$export$2e2bcd8739ae039 extends Error {
    constructor(){
        super('window.indexeddb is undefined.');
        // Must reset the prototypes after calling super of builtin classes
        // https://github.com/Microsoft/TypeScript/wiki/Breaking-Changes#extending-built-ins-like-error-array-and-map-may-no-longer-work
        Object.setPrototypeOf(this, $a16e8ac8262a29f2$export$2e2bcd8739ae039.prototype);
        this.name = $a16e8ac8262a29f2$export$fc14cf6dcea0f8ed;
    }
}

});

parcelRegister("3pjih", function(module, exports) {
$parcel$export(module.exports, "shouldIgnoreResilienceDbError", () => $27b2ac3cd23eb6c1$export$74101021e0969375);

var $kxmBB = parcelRequire("kxmBB");

var $hhxHW = parcelRequire("hhxHW");

var $2Ndpn = parcelRequire("2Ndpn");
const $27b2ac3cd23eb6c1$export$74101021e0969375 = (error)=>{
    if (error && typeof error === 'object' && 'name' in error) {
        const errorWithName = error;
        return typeof errorWithName.name === 'string' && (errorWithName.name === (0, $kxmBB.AbandonWriteErrorName) || errorWithName.name === (0, $hhxHW.CallbackProcessingErrorName) || errorWithName.name === (0, $2Ndpn.InvalidPolicyErrorName));
    }
    return false;
};

});
parcelRegister("kxmBB", function(module, exports) {
$parcel$export(module.exports, "AbandonWriteErrorName", () => $ef386cadee09cfc3$export$ba95206613c96b28);
$parcel$export(module.exports, "default", () => $ef386cadee09cfc3$export$2e2bcd8739ae039);
const $ef386cadee09cfc3$export$ba95206613c96b28 = 'AbandonWriteError';
class $ef386cadee09cfc3$export$2e2bcd8739ae039 extends Error {
    constructor(source){
        super(`Event Limit reached. Abandoning write to: ${source}`);
        // Must reset the prototypes after calling super of builtin classes
        // https://github.com/Microsoft/TypeScript/wiki/Breaking-Changes#extending-built-ins-like-error-array-and-map-may-no-longer-work
        Object.setPrototypeOf(this, $ef386cadee09cfc3$export$2e2bcd8739ae039.prototype);
        this.name = $ef386cadee09cfc3$export$ba95206613c96b28;
    }
}

});

parcelRegister("2Ndpn", function(module, exports) {
$parcel$export(module.exports, "InvalidPolicyErrorName", () => $208a8f01aec8957b$export$7e7aee9a953465ec);
$parcel$export(module.exports, "default", () => $208a8f01aec8957b$export$2e2bcd8739ae039);
const $208a8f01aec8957b$export$7e7aee9a953465ec = 'InvalidPolicyError';
class $208a8f01aec8957b$export$2e2bcd8739ae039 extends Error {
    constructor(policy, method){
        super(`Method '${method}' cannot be called with policy '${policy}'.`);
        this.name = $208a8f01aec8957b$export$7e7aee9a953465ec;
    }
}

});


parcelRegister("lXcF4", function(module, exports) {
$parcel$export(module.exports, "default", () => $ffb8edf8aa3ed3d8$export$2e2bcd8739ae039);

var $1Vcia = parcelRequire("1Vcia");

var $25nEq = parcelRequire("25nEq");

var $1WplY = parcelRequire("1WplY");

var $65t6J = parcelRequire("65t6J");

var $hhxHW = parcelRequire("hhxHW");
var $2Ndpn = parcelRequire("2Ndpn");
var $dRiso = parcelRequire("dRiso");
var $3pjih = parcelRequire("3pjih");

var $04uPR = parcelRequire("04uPR");

var $5qvuM = parcelRequire("5qvuM");
const $ffb8edf8aa3ed3d8$var$_excluded = [
    "item"
], $ffb8edf8aa3ed3d8$var$_excluded2 = [
    "items"
];
function $ffb8edf8aa3ed3d8$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $ffb8edf8aa3ed3d8$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $ffb8edf8aa3ed3d8$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $ffb8edf8aa3ed3d8$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
class $ffb8edf8aa3ed3d8$export$2e2bcd8739ae039 {
    constructor(_namespace, _options = {}){
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "startDB", async ()=>{
            return new Promise(async (resolve, reject)=>{
                if (typeof window !== 'undefined') {
                    const dbTimeout = window.setTimeout(()=>{
                        this.logger.warn('IndexedDB timed out.');
                        reject(new (0, $dRiso.default)());
                    }, (0, $1WplY.INDEXEDDB_TIMEOUT));
                    /*
           * The database version number can never change.
           * An upgrade transaction is limited to only one connection to the database.
           * Once this is done, we cannot open any connections with older versions of the schema.
           * https://www.w3.org/TR/IndexedDB/#upgrade-transaction-construct
           *
           * Due to the nature of how AWC is used (multiple tabs that are very long lived),
           * we will not be able to run version upgrades via indexeddb.
           *
           * This does not mean we cant change what is stored in the tables,
           * this limitation just prevents us from:
           *   - Creating new ObjectStores in this database connection, and
           *   - Creating new indexes on our ObjectStores
           *
           * Any upgrades we wish to run in the future will have to create a new database,
           * and migrate all the data from older databases.
           *
           * This also means any migrations we make will have to be supported until we have evidence
           * that no events are coming from old versions of the database.
           * This may take a long time.
           */ const request = window.indexedDB.open((0, $1WplY.RESILIENCE_DB_NAME), 1);
                    request.onupgradeneeded = (event)=>{
                        if (event.oldVersion !== 0) throw new Error('We cannot upgrade the database. Do not do this.');
                        const db = request.result;
                        const store = db.createObjectStore((0, $1WplY.RESILIENCE_STORE_NAME), {
                            keyPath: 'id'
                        });
                        store.createIndex((0, $1WplY.TIME_TO_PROCESS_AFTER_INDEX), (0, $1WplY.TIME_TO_PROCESS_AFTER_INDEX), {
                            unique: false
                        });
                        store.createIndex((0, $1WplY.RETRY_INDEX), (0, $1WplY.RETRY_INDEX), {
                            unique: false
                        });
                        store.createIndex((0, $1WplY.TIME_ADDED_INDEX), (0, $1WplY.TIME_ADDED_INDEX), {
                            unique: false
                        });
                        // Compound key index of product - timeAdded.
                        store.createIndex((0, $1WplY.NAMESPACE_AND_TIME_ADDED_INDEX), [
                            'namespace',
                            'timeAdded'
                        ], {
                            unique: false
                        });
                    };
                    request.onerror = function() {
                        reject(new (0, $dRiso.default)());
                    };
                    try {
                        await (0, $5qvuM.requestToPromise)(request);
                        return resolve(request.result);
                    } catch (error) {
                        this.logger.warn('IndexedDB failed to initialise.', error);
                        reject(new (0, $dRiso.default)());
                    } finally{
                        window.clearTimeout(dbTimeout);
                    }
                } else {
                    this.logger.warn("IndexedDB failed to initialise. No 'window' object.");
                    reject(new (0, $dRiso.default)());
                }
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "addItem", async (item, options = {}, policy = (0, $1WplY.GuardPolicy).ABANDON)=>{
            const { logger: logger, namespace: namespace } = this;
            const value = (0, $5qvuM.convertToItemWrapper)(item, namespace, options);
            const { objectStore: objectStore } = await this.getObjectStoreAndTransaction('readwrite');
            if (policy === (0, $1WplY.GuardPolicy).IGNORE) throw new (0, $2Ndpn.default)(policy, 'IndexedDbConnector#addItem');
            try {
                if (!value.namespace || value.namespace.length === 0 || typeof value.namespace !== 'string') throw new Error('Namespace not specified');
                // Making space for 1 event, if required.
                const bulkAddResult = await this.globalEventLimitGuard.insertItems(objectStore, [
                    value
                ], policy);
                if (bulkAddResult.items.length === 1) return {
                    item: bulkAddResult.items[0],
                    numberOfEvictedItems: bulkAddResult.numberOfEvictedItems
                };
                // Should never happen as the Policy and EventCountGuard should cause another pathway
                throw new Error(`Incorrect number of items added. Expected: 1, got: ${bulkAddResult.items.length}`);
            } catch (error) {
                if ((0, $3pjih.shouldIgnoreResilienceDbError)(error)) throw error;
                logger.log('Failed to add item to table', error);
                throw new Error('Request to add item to table failed');
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "bulkAddItem", async (itemOptions, policy = (0, $1WplY.GuardPolicy).ABANDON)=>{
            const { logger: logger, namespace: namespace } = this;
            const items = itemOptions.map((_ref)=>{
                let { item: item } = _ref, options = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $ffb8edf8aa3ed3d8$var$_excluded);
                return (0, $5qvuM.convertToItemWrapper)(item, namespace, options);
            });
            const { objectStore: objectStore } = await this.getObjectStoreAndTransaction('readwrite');
            try {
                return await this.globalEventLimitGuard.insertItems(objectStore, items, policy);
            } catch (error) {
                if ((0, $3pjih.shouldIgnoreResilienceDbError)(error)) throw error;
                logger.log('Failed to add item to table', error);
                throw new Error('Request to add item to table failed');
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "getItems", async (count = (0, $65t6J.GET_ITEM_COUNT))=>{
            const fixedCount = count > 0 ? count : (0, $65t6J.GET_ITEM_COUNT);
            const { logger: logger } = this;
            const maxAttempts = this.options.maxAttempts;
            const { transaction: transaction, objectStore: objectStore } = await this.getObjectStoreAndTransaction('readwrite');
            const timeIndex = objectStore.index((0, $1WplY.TIME_TO_PROCESS_AFTER_INDEX));
            const upperBoundOpenKeyRange = IDBKeyRange.upperBound(Date.now());
            const request = timeIndex.openCursor(upperBoundOpenKeyRange);
            const getResult = await new Promise(async (resolve, reject)=>{
                const items = [];
                let numberOfDeletedItems = 0;
                request.onerror = (error)=>{
                    logger.error('Failed to open cursor:', error);
                    reject('Failed to open cursor');
                };
                // Requests for Cursors call onsuccess multiple times and cannot be converted to promises
                request.onsuccess = (event)=>{
                    const cursor = event.target.result;
                    if (cursor) {
                        // Prevent mutation of the value we are returning
                        const value = $ffb8edf8aa3ed3d8$var$_objectSpread({}, cursor.value);
                        items.push(value);
                        // Mutations seem to be required for testing indexeddb library
                        const updatedValue = cursor.value;
                        updatedValue.retryAttempts += 1;
                        updatedValue.timeToBeProcessedAfter = Date.now() + (0, $65t6J.VISIBILITY_TIMEOUT);
                        if (updatedValue.retryAttempts >= maxAttempts) {
                            ++numberOfDeletedItems;
                            const request = cursor.delete();
                            (0, $5qvuM.monitorErrorsOnRequest)(request, logger);
                        } else {
                            const request = cursor.update(updatedValue);
                            (0, $5qvuM.monitorErrorsOnRequest)(request, logger);
                        }
                        if (items.length < fixedCount) cursor.continue();
                        else resolve({
                            items: items,
                            numberOfDeletedItems: numberOfDeletedItems
                        });
                    } else resolve({
                        items: items,
                        numberOfDeletedItems: numberOfDeletedItems
                    });
                };
            });
            await (0, $5qvuM.commitTransaction)(transaction, this.logger);
            return getResult;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "deleteItems", async (itemIds)=>{
            const { transaction: transaction, objectStore: objectStore } = await this.getObjectStoreAndTransaction('readwrite');
            try {
                const deletePromises = itemIds.map((id)=>this.deleteItem(objectStore, id));
                await (0, $5qvuM.commitTransaction)(transaction, this.logger);
                await Promise.all(deletePromises);
            } catch (error) {
                this.logger.warn('Failed to delete items from indexeddb.', error);
                throw error;
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "getItemCount", async ()=>{
            const { transaction: transaction, objectStore: objectStore } = await this.getObjectStoreAndTransaction('readonly');
            const timeIndex = objectStore.index((0, $1WplY.TIME_TO_PROCESS_AFTER_INDEX));
            const upperBoundOpenKeyRange = IDBKeyRange.upperBound(Date.now());
            const request = timeIndex.count(upperBoundOpenKeyRange);
            const event = await (0, $5qvuM.requestToPromise)(request);
            await (0, $5qvuM.commitTransaction)(transaction, this.logger);
            return event.target.result;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "processItems", async (processFn, count = (0, $65t6J.GET_ITEM_COUNT))=>{
            const _await$this$getItems = await this.getItems(count), { items: items } = _await$this$getItems, partialResult = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_await$this$getItems, $ffb8edf8aa3ed3d8$var$_excluded2);
            try {
                const result = await processFn(items, partialResult);
                const itemIds = items.map((item)=>item.id);
                // We should not await this delete as a rejected promise would get caught by the catch statement
                await this.deleteItems(itemIds);
                return result;
            } catch (error) {
                // Eventually we will need a intermediate class to catch all errors but we should ignore this error
                // This allows libraries beneath to distinguish between a success or failure in processing to update schedulers or anything else
                // To provide back off or any other mechanism to allow what ever is cauing the errors to recover
                throw new (0, $hhxHW.default)(error);
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "deleteItem", async (objectStore, id)=>{
            const { logger: logger } = this;
            try {
                await (0, $5qvuM.requestToPromise)(objectStore.delete(id));
            } catch (error) {
                logger.error('Failed to delete item:', id, error);
                throw error;
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "getObjectStoreAndTransaction", async (mode)=>{
            const transaction = (await this.db).transaction((0, $1WplY.RESILIENCE_STORE_NAME), mode);
            const objectStore = transaction.objectStore((0, $1WplY.RESILIENCE_STORE_NAME));
            return {
                transaction: transaction,
                objectStore: objectStore
            };
        });
        this.options = (0, $5qvuM.createOptionsWithDefaults)(_options);
        this.namespace = _namespace;
        this.logger = this.options.logger;
        if (!window.indexedDB) throw new (0, $dRiso.default)();
        this.db = this.startDB();
        // We just swallow any errors as we know that these are intermittent errors
        // when switching from indexeddb -> localStorage
        this.db.catch(()=>{});
        /**
     *
     * This class will enforce the number of analytics events we can store in our IndexedDB object store
     * if asked before adding items to the object store.
     */ this.globalEventLimitGuard = new (0, $04uPR.default)(this.options.maxEventLimit, this.namespace, this.logger, this.deleteItem);
    }
    storeType() {
        return (0, $1WplY.StoreType).INDEXEDDB;
    }
}

});
parcelRegister("65t6J", function(module, exports) {
$parcel$export(module.exports, "GET_ITEM_COUNT", () => $46e9c9e3a6806fe3$export$b6df3d334cec060f);
$parcel$export(module.exports, "VISIBILITY_TIMEOUT", () => $46e9c9e3a6806fe3$export$14ef152a03a4b6ee);
$parcel$export(module.exports, "MAX_ATTEMPTS", () => $46e9c9e3a6806fe3$export$da9ab7b2fd5998e8);
$parcel$export(module.exports, "EVENT_COUNT_LIMIT", () => $46e9c9e3a6806fe3$export$1188664dfff364c8);
const $46e9c9e3a6806fe3$export$b6df3d334cec060f = 7;
const $46e9c9e3a6806fe3$export$14ef152a03a4b6ee = 60000;
const $46e9c9e3a6806fe3$export$da9ab7b2fd5998e8 = 10;
const $46e9c9e3a6806fe3$export$1188664dfff364c8 = 5000;

});

parcelRegister("04uPR", function(module, exports) {
$parcel$export(module.exports, "default", () => $00d84b248a17d37c$export$2e2bcd8739ae039);

var $25nEq = parcelRequire("25nEq");

var $1WplY = parcelRequire("1WplY");

var $kxmBB = parcelRequire("kxmBB");

var $5qvuM = parcelRequire("5qvuM");
class $00d84b248a17d37c$export$2e2bcd8739ae039 {
    constructor(eventLimit, namespace, logger, deleteItemHandler){
        /**
     * This query fetches the oldest events currently stored in AWC IndexedDb object store
     * and deletes them sequentially
     */ (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "deleteOldestNEvents", async (objectStore, count)=>{
            var _target;
            const productTimeAddedIndex = objectStore.index((0, $1WplY.NAMESPACE_AND_TIME_ADDED_INDEX));
            const keyRangeValues = IDBKeyRange.bound([
                this.namespace,
                0
            ], [
                this.namespace,
                Date.now()
            ]);
            const getAllRequest = productTimeAddedIndex.getAllKeys(keyRangeValues, count);
            const event = await (0, $5qvuM.requestToPromise)(getAllRequest);
            const result = event === null || event === void 0 || (_target = event.target) === null || _target === void 0 ? void 0 : _target.result;
            // Adding extra safety
            if (result && Array.isArray(result) && result.length > 0) try {
                const deletePromises = result.map((item)=>this.deleteItemHandler(objectStore, item));
                await Promise.all(deletePromises);
            } catch (error) {
                this.logger.warn('Failed to delete items from indexeddb.', error);
                throw error;
            }
        });
        if (eventLimit > 0) this.eventLimit = eventLimit;
        else throw Error('Event Limit has to be set higher than 1');
        this.namespace = namespace;
        this.logger = logger;
        this.deleteItemHandler = deleteItemHandler;
    }
    /**
   * This function checks the number of events currently in AWC IndexedDB object store and if necessary,
   * will evict the oldest events in favour of the events we want to add.
   *
   * The indexed is treated as effectively: partitioned by product and sorted by timeAdded.
   *
   * This function can be re-used when the bulk add functionality is added in IndexedDbConnector.
   *
   * @param countOfEventsToAdd - The number of events we are proposing to add.
   */ async insertItems(objectStore, items, policy = (0, $1WplY.GuardPolicy).ABANDON) {
        const itemsToAdd = [
            ...items
        ];
        let numberOfEvictedItems = 0;
        switch(policy){
            case (0, $1WplY.GuardPolicy).ABANDON:
                await this.throwIfNotEnoughSpace(objectStore, items.length);
                break;
            case (0, $1WplY.GuardPolicy).EVICT:
                numberOfEvictedItems = await this.evictIfNotEnoughSpace(objectStore, items.length);
                break;
            case (0, $1WplY.GuardPolicy).IGNORE:
                // Removed items from `itemsToAdd` if there is insufficient space
                await this.calculateHowManyEventsWeCanAdd(objectStore, itemsToAdd);
                break;
        }
        const promises = itemsToAdd.map((item)=>(0, $5qvuM.requestToPromise)(objectStore.add(item)));
        await Promise.all(promises);
        await (0, $5qvuM.commitTransaction)(objectStore.transaction, this.logger);
        return {
            items: itemsToAdd,
            numberOfEvictedItems: numberOfEvictedItems
        };
    }
    async throwIfNotEnoughSpace(objectStore, requiredSpace) {
        const freeSpace = await this.calculateFreeSpace(objectStore);
        if (freeSpace < requiredSpace) throw new (0, $kxmBB.default)(`Not enough space in IndexedDb. Needed ${requiredSpace} but only had ${freeSpace}`);
    }
    async evictIfNotEnoughSpace(objectStore, requiredSpace) {
        const freeSpace = await this.calculateFreeSpace(objectStore);
        if (freeSpace < requiredSpace) {
            const extraSpace = requiredSpace - freeSpace;
            await this.deleteOldestNEvents(objectStore, extraSpace);
            return extraSpace;
        }
        return 0;
    }
    async calculateHowManyEventsWeCanAdd(objectStore, items) {
        const freeSpace = await this.calculateFreeSpace(objectStore);
        if (freeSpace < items.length) {
            const numberOfItemsToRemove = items.length - freeSpace;
            const start = items.length - numberOfItemsToRemove;
            items.splice(start, numberOfItemsToRemove);
        }
    }
    async calculateFreeSpace(objectStore) {
        const numberOfEventsInDb = await this.getCountofEventsInObjectStore(objectStore);
        return this.eventLimit - numberOfEventsInDb;
    }
    /**
   * This query returns the count of items held in AWC IndexedDB object store per product.
   */ async getCountofEventsInObjectStore(objectStore) {
        const productTimeAddedIndex = objectStore.index((0, $1WplY.NAMESPACE_AND_TIME_ADDED_INDEX));
        const keyRangeValues = IDBKeyRange.bound([
            this.namespace,
            0
        ], [
            this.namespace,
            Date.now()
        ]);
        const request = productTimeAddedIndex.count(keyRangeValues);
        const event = await (0, $5qvuM.requestToPromise)(request);
        return event.target.result;
    }
}

});
parcelRegister("5qvuM", function(module, exports) {
$parcel$export(module.exports, "convertToItemWrapper", () => $3f37cfcc237a1044$export$aec476f33d77be11);
$parcel$export(module.exports, "createOptionsWithDefaults", () => $3f37cfcc237a1044$export$ddc6718318090f71);
$parcel$export(module.exports, "requestToPromise", () => $3f37cfcc237a1044$export$85ceed0783e42041);
$parcel$export(module.exports, "commitTransaction", () => $3f37cfcc237a1044$export$feab8418f018df89);
$parcel$export(module.exports, "monitorErrorsOnRequest", () => $3f37cfcc237a1044$export$342d941b6f724995);

var $6JfQX = parcelRequire("6JfQX");

var $65t6J = parcelRequire("65t6J");
const $3f37cfcc237a1044$export$aec476f33d77be11 = (item, namespace, { id: id, retryAttempts: retryAttempts, timeToProcessOffset: timeToProcessOffset })=>({
        item: item,
        id: id || (0, $6JfQX.default)(),
        retryAttempts: retryAttempts || 0,
        timeToBeProcessedAfter: Date.now() + (timeToProcessOffset || 0),
        namespace: namespace,
        timeAdded: Date.now()
    });
const $3f37cfcc237a1044$export$ddc6718318090f71 = (options)=>({
        logger: options.logger || console,
        useMemory: options.useMemory || false,
        maxAttempts: options.maxAttempts || (0, $65t6J.MAX_ATTEMPTS),
        // This is so that we can customise `maxEventLimit`, primarily for testing.
        maxEventLimit: options.maxEventLimit || (0, $65t6J.EVENT_COUNT_LIMIT)
    });
const $3f37cfcc237a1044$export$85ceed0783e42041 = (request)=>{
    return new Promise((resolve, reject)=>{
        request.onsuccess = (event)=>{
            resolve(event);
        };
        request.onerror = (event)=>{
            reject(event);
        };
    });
};
const $3f37cfcc237a1044$export$2a5213bce1720b42 = (transaction)=>{
    return new Promise((resolve, reject)=>{
        // We will have to see how much cost there is to waiting for the transaction to complete in the real world.
        // In theory in some cases we could return as soon as the request is complete and
        // just monitor errors on transactions with the logger.
        // This maybe more of an issue in Safari and other older browsers where commit isnt available
        // and we would have to wait for the transaction to complete itself.
        transaction.oncomplete = ()=>{
            resolve();
        };
        transaction.onerror = (event)=>{
            reject(event);
        };
        transaction.onabort = (event)=>{
            reject(event);
        };
    });
};
const $3f37cfcc237a1044$export$feab8418f018df89 = (transaction, logger)=>{
    try {
        if (typeof transaction.commit === 'function') transaction.commit();
    } catch (error) {
        logger.error('Failed to force commit transaction:', error);
        throw error;
    }
    return $3f37cfcc237a1044$export$2a5213bce1720b42(transaction);
};
const $3f37cfcc237a1044$export$342d941b6f724995 = (request, logger)=>{
    request.onerror = (event)=>{
        logger.warn('Error thrown from request:', event);
    };
};

});



parcelRegister("7qakG", function(module, exports) {
$parcel$export(module.exports, "default", () => $5672f9f2dc7da63a$export$2e2bcd8739ae039);

var $25nEq = parcelRequire("25nEq");

var $1Vcia = parcelRequire("1Vcia");

var $1WplY = parcelRequire("1WplY");

var $65t6J = parcelRequire("65t6J");

var $hhxHW = parcelRequire("hhxHW");
var $2Ndpn = parcelRequire("2Ndpn");

var $fS30h = parcelRequire("fS30h");

var $5qvuM = parcelRequire("5qvuM");
const $5672f9f2dc7da63a$var$_excluded = [
    "item"
], $5672f9f2dc7da63a$var$_excluded2 = [
    "items"
];
function $5672f9f2dc7da63a$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $5672f9f2dc7da63a$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $5672f9f2dc7da63a$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $5672f9f2dc7da63a$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
class $5672f9f2dc7da63a$export$2e2bcd8739ae039 {
    constructor(namespace, options = {}){
        this.namespace = namespace;
        this.memoryStore = [];
        this.options = (0, $5qvuM.createOptionsWithDefaults)(options);
        /**
     * This class will enforce the number of analytics events we can store in our MemoryDb
     */ this.globalEventLimitGuard = new (0, $fS30h.default)(this.options.maxEventLimit, {
            addItems: this.addItems.bind(this),
            getItemCount: this.getItemCount.bind(this),
            evictEventsIfNeeded: this.evictEventsIfNeeded.bind(this)
        });
    }
    /**
   * This method is used mainly to write new events to MemoryDB and uses the MEMORY_DB_GUARD_POLICY.EVICT_OLDEST_IF_LIMIT_EXECEEDED policy
   * to removes oldest events when limit is reached.
   */ async addItem(item, options = {}, policy = (0, $1WplY.GuardPolicy).ABANDON) {
        if (policy === (0, $1WplY.GuardPolicy).IGNORE) throw new (0, $2Ndpn.default)(policy, 'IndexedDbConnector#addItem');
        const storedValue = (0, $5qvuM.convertToItemWrapper)(item, this.namespace, options);
        // Delegated responsiblity to event limit guard to insert to memory stored
        const bulkAddItemsResult = await this.globalEventLimitGuard.insertItemsToMemoryStore([
            storedValue
        ], policy);
        return Promise.resolve({
            item: bulkAddItemsResult.items[0],
            numberOfEvictedItems: bulkAddItemsResult.numberOfEvictedItems
        });
    }
    bulkAddItem(itemOptions, policy = (0, $1WplY.GuardPolicy).ABANDON) {
        const items = itemOptions.map((_ref)=>{
            let { item: item } = _ref, addOptions = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $5672f9f2dc7da63a$var$_excluded);
            return (0, $5qvuM.convertToItemWrapper)(item, this.namespace, addOptions);
        });
        return this.bulkAddItemWrapperType(items, policy);
    }
    /**
   * This method is used mainly to write events to MemoryDB when unknown errors are thrown from IndexedDB.
   */ bulkAddItemWrapperType(items, policy = (0, $1WplY.GuardPolicy).ABANDON) {
        return Promise.resolve(this.globalEventLimitGuard.insertItemsToMemoryStore(items, policy));
    }
    getItems(count = (0, $65t6J.GET_ITEM_COUNT)) {
        return Promise.resolve(this.synchronousGetItems(count));
    }
    synchronousGetItems(count = (0, $65t6J.GET_ITEM_COUNT)) {
        const fixedCount = count > 0 ? count : (0, $65t6J.GET_ITEM_COUNT);
        const now = Date.now();
        const wrappedItems = [];
        const itemsToRemove = [];
        for (let wrappedItem of this.memoryStore){
            if (wrappedItem.timeToBeProcessedAfter <= now) {
                wrappedItems.push($5672f9f2dc7da63a$var$_objectSpread({}, wrappedItem));
                // Mutates the item in the memoryStore array, but not whats inside of wrappedItems
                wrappedItem.timeToBeProcessedAfter += (0, $65t6J.VISIBILITY_TIMEOUT);
                wrappedItem.retryAttempts += 1;
                if (wrappedItem.retryAttempts >= this.options.maxAttempts) itemsToRemove.push(wrappedItem);
            }
            if (wrappedItems.length >= fixedCount) break;
        }
        itemsToRemove.forEach((item)=>{
            const index = this.memoryStore.indexOf(item);
            this.memoryStore.splice(index, 1);
        });
        return {
            items: wrappedItems,
            numberOfDeletedItems: itemsToRemove.length
        };
    }
    deleteItems(itemIds) {
        this.memoryStore = this.memoryStore.filter((item)=>!itemIds.includes(item.id));
        return Promise.resolve(void 0);
    }
    getItemCount() {
        const now = Date.now();
        const count = this.memoryStore.filter((item)=>item.timeToBeProcessedAfter <= now).length;
        return Promise.resolve(count);
    }
    async processItems(processFn, count) {
        const _this$synchronousGetI = this.synchronousGetItems(count), { items: items } = _this$synchronousGetI, partialGetResult = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_this$synchronousGetI, $5672f9f2dc7da63a$var$_excluded2);
        const itemIds = items.map((i)=>i.id);
        try {
            const result = await processFn(items, partialGetResult);
            await this.deleteItems(itemIds);
            return result;
        } catch (error) {
            throw new (0, $hhxHW.default)(error);
        }
    }
    storeType() {
        return (0, $1WplY.StoreType).MEMORY;
    }
    /**
   * This function is adding items to the tail of the memoryStore and as it adds new items it keeps the
   * memory store sorted by timeAdded property. This makes evictions easier and adding elements to
   * memoryStore much faster.
   *
   * @param itemsToAdd
   */ addItems(itemsToAdd) {
        this.memoryStore.push(...itemsToAdd);
        // Sorting everytime, intentionally.
        this.memoryStore.sort(function(a, b) {
            return a.timeAdded - b.timeAdded;
        });
    }
    /**
   * This function checks the number of events currently in AWC MemoryDb and if necessary,
   * will evict the oldest events in favour of the events we want to add.
   *
   * @param countOfEventsToAdd - The number of events we are proposing to add.
   */ evictEventsIfNeeded(eventLimit) {
        const numberOfEventsInDb = this.memoryStore.length;
        // The number of analytics events currently in MemoryDb and
        // the Z events we are proposing to add will exceed our event count limit.
        if (numberOfEventsInDb > eventLimit) {
            const m = numberOfEventsInDb - eventLimit;
            // Removing oldest M events
            this.memoryStore.splice(0, m);
            return m;
        }
        return 0;
    }
}

});
parcelRegister("fS30h", function(module, exports) {
$parcel$export(module.exports, "default", () => $b8de3a92cd492eb6$export$2e2bcd8739ae039);

var $25nEq = parcelRequire("25nEq");

var $1WplY = parcelRequire("1WplY");

var $kxmBB = parcelRequire("kxmBB");
class $b8de3a92cd492eb6$export$2e2bcd8739ae039 {
    constructor(eventLimit, memoryItemHandlers){
        /**
     * Unlike IndexedDb, we cannot take advantage of any index. So we are,
     * treating the memory store as a sorted set when adding items.
     */ (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "insertItemsToMemoryStore", (itemsToAdd, policy)=>{
            switch(policy){
                case (0, $1WplY.GuardPolicy).ABANDON:
                    return this.handleAbandonIfLimitWillExceedPolicy(itemsToAdd);
                case (0, $1WplY.GuardPolicy).EVICT:
                    return Promise.resolve(this.handleEvictOldestIfLimitExceededPolicy(itemsToAdd));
                case (0, $1WplY.GuardPolicy).IGNORE:
                    return this.handleAddAsManyAsPossible(itemsToAdd);
            }
        });
        if (eventLimit > 0) this.eventLimit = eventLimit;
        else throw Error('Event Limit has to be set higher than 1');
        this.memoryItemHandlers = memoryItemHandlers;
    }
    async handleAbandonIfLimitWillExceedPolicy(itemsToAdd) {
        const itemCount = await this.memoryItemHandlers.getItemCount();
        if (itemCount + itemsToAdd.length > this.eventLimit) throw new (0, $kxmBB.default)((0, $1WplY.StoreType).MEMORY);
        this.memoryItemHandlers.addItems(itemsToAdd);
        return {
            items: itemsToAdd,
            numberOfEvictedItems: 0
        };
    }
    handleEvictOldestIfLimitExceededPolicy(itemsToAdd) {
        this.memoryItemHandlers.addItems(itemsToAdd);
        const numberOfEvictedItems = this.memoryItemHandlers.evictEventsIfNeeded(this.eventLimit);
        return {
            items: itemsToAdd,
            numberOfEvictedItems: numberOfEvictedItems
        };
    }
    async handleAddAsManyAsPossible(itemsToAdd) {
        const freeSpace = this.eventLimit - await this.memoryItemHandlers.getItemCount();
        const partialEventsToAdd = freeSpace > itemsToAdd.length ? itemsToAdd : itemsToAdd.slice(0, freeSpace);
        this.memoryItemHandlers.addItems(partialEventsToAdd);
        return {
            items: partialEventsToAdd,
            numberOfEvictedItems: 0
        };
    }
}

});




parcelRegister("f7ZYI", function(module, exports) {
$parcel$export(module.exports, "default", () => $b037960a9b602d7e$export$2e2bcd8739ae039);

var $25nEq = parcelRequire("25nEq");

var $aj05j = parcelRequire("aj05j");
class $b037960a9b602d7e$export$4b62ee5120ab50a8 {
    constructor(){
        // Number of events discarded due to exceeding retry limits.
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "itemsDiscardedByRetry", 0);
        // Number of events created by the product in current tab.
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "eventCount", 0);
        // Number of events discarded due to reaching queue max size.
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "itemsDiscardedByOverflow", 0);
        // Will be used in the future when we get more resilience mechanisms
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "resilienceMechanism", (0, $aj05j.ResilienceMechanism).INDEXEDDB);
        /* --- LocalStorage specific metrics --- */ // Emitted by purgeOrphanedQueues to tell us how many queues we have had to clean up due to
        // https://github.com/segmentio/localstorage-retry/pull/17
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "localstorageNumberOfQueuesPurged", 0);
        // Emitted by reclaimEvents to tell us how many queues were seen in the process of reclaim.
        // We will only emit metrics for queues that are not currently being maintained (i.e. `ack` is not being updated).
        // Queue was found, all events removed and put into resilienceDb.
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "localstorageNumberOfFullReclaims", 0);
        // Queue was found but not all events were able to be put into resilienceDb.
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "localstorageNumberOfPartialReclaims", 0);
        // Reclaim failed for a queue and reclaim was abandonded.
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "localstorageNumberOfFailedReclaims", 0);
    }
    addToItemsDiscardedByRetryCounter(numberOfDeletedEvents = 1) {
        this.itemsDiscardedByRetry += numberOfDeletedEvents;
    }
    addToEventCount() {
        this.eventCount++;
    }
    addToItemsDiscardedByOverflowCounter(numberOfDeletedEvents = 1) {
        this.itemsDiscardedByOverflow += numberOfDeletedEvents;
    }
    setResilienceMechanism(mechanism) {
        this.resilienceMechanism = mechanism;
    }
    /* <Localstorage specific> */ addToReclaimMetrics(reclaimMetrics) {
        this.localstorageNumberOfFullReclaims += reclaimMetrics.fullReclaims;
        this.localstorageNumberOfPartialReclaims += reclaimMetrics.partialReclaims;
        this.localstorageNumberOfFailedReclaims += reclaimMetrics.failedReclaims;
    }
    addToPurgedQueuesMetrics(numberOfQueuesPurged) {
        this.localstorageNumberOfQueuesPurged += numberOfQueuesPurged;
    }
    /* </Localstorage specific> */ subtractFromMetrics(sentMetrics) {
        this.itemsDiscardedByRetry = this.subtractFromCount(this.itemsDiscardedByRetry, sentMetrics.itemsDiscardedByRetry);
        this.eventCount = this.subtractFromCount(this.eventCount, sentMetrics.eventCount);
        this.itemsDiscardedByOverflow = this.subtractFromCount(this.itemsDiscardedByOverflow, sentMetrics.itemsDiscardedByOverflow);
        // Localstorage specific
        this.localstorageNumberOfFullReclaims = this.subtractFromCount(this.localstorageNumberOfFullReclaims, sentMetrics.fullReclaims);
        this.localstorageNumberOfPartialReclaims = this.subtractFromCount(this.localstorageNumberOfPartialReclaims, sentMetrics.partialReclaims);
        this.localstorageNumberOfFailedReclaims = this.subtractFromCount(this.localstorageNumberOfFailedReclaims, sentMetrics.failedReclaims);
        this.localstorageNumberOfQueuesPurged = this.subtractFromCount(this.localstorageNumberOfQueuesPurged, sentMetrics.localstorageQueuesPurged);
    }
    subtractFromCount(count, subtract) {
        return Math.max(count - (subtract || 0), 0);
    }
    getMetricsPayload() {
        return {
            itemsDiscardedByRetry: this.itemsDiscardedByRetry,
            eventCount: this.eventCount,
            itemsDiscardedByOverflow: this.itemsDiscardedByOverflow,
            resilienceMechanism: this.resilienceMechanism,
            // Localstorage specific
            localstorageQueuesPurged: this.localstorageNumberOfQueuesPurged,
            fullReclaims: this.localstorageNumberOfFullReclaims,
            partialReclaims: this.localstorageNumberOfPartialReclaims,
            failedReclaims: this.localstorageNumberOfFailedReclaims
        };
    }
}
let $b037960a9b602d7e$var$cachedMetricsClient = null;
var $b037960a9b602d7e$export$2e2bcd8739ae039 = ()=>{
    if (!$b037960a9b602d7e$var$cachedMetricsClient) $b037960a9b602d7e$var$cachedMetricsClient = new $b037960a9b602d7e$export$4b62ee5120ab50a8();
    return $b037960a9b602d7e$var$cachedMetricsClient;
};

});
parcelRegister("aj05j", function(module, exports) {
$parcel$export(module.exports, "ResilienceMechanism", () => $780bbe8db05e9873$export$c75161629e3ec34e);
$parcel$export(module.exports, "NetworkStatusEnum", () => $780bbe8db05e9873$export$ee138fa712d11b84);
let $780bbe8db05e9873$export$c75161629e3ec34e = /*#__PURE__*/ function(ResilienceMechanism) {
    ResilienceMechanism["INDEXEDDB"] = "indexeddb";
    ResilienceMechanism["MEMORY"] = "memory";
    return ResilienceMechanism;
}({});
let $780bbe8db05e9873$export$ee138fa712d11b84 = /*#__PURE__*/ function(NetworkStatusEnum) {
    NetworkStatusEnum[NetworkStatusEnum["ONLINE"] = 0] = "ONLINE";
    NetworkStatusEnum[NetworkStatusEnum["OFFLINE"] = 1] = "OFFLINE";
    return NetworkStatusEnum;
}({});

});


parcelRegister("cBhno", function(module, exports) {
$parcel$export(module.exports, "default", () => $92c66b4da0fc1a60$export$2e2bcd8739ae039);

var $aj05j = parcelRequire("aj05j");
class $92c66b4da0fc1a60$export$2e2bcd8739ae039 {
    constructor(networkChangeCallback){
        if (typeof window !== 'undefined') {
            window.addEventListener('offline', ()=>networkChangeCallback((0, $aj05j.NetworkStatusEnum).OFFLINE));
            window.addEventListener('online', ()=>networkChangeCallback((0, $aj05j.NetworkStatusEnum).ONLINE));
        }
    }
    getNetworkStatus() {
        if (window.navigator.onLine) return (0, $aj05j.NetworkStatusEnum).ONLINE;
        return (0, $aj05j.NetworkStatusEnum).OFFLINE;
    }
}

});

parcelRegister("6KF64", function(module, exports) {
$parcel$export(module.exports, "default", () => $4ea6eaf65a70f9b1$export$2e2bcd8739ae039);

var $25nEq = parcelRequire("25nEq");

var $b1RZ3 = parcelRequire("b1RZ3");

var $gWFU9 = parcelRequire("gWFU9");
const $4ea6eaf65a70f9b1$var$SCHEDULER_OPTIONS_DEFAULT = {
    minRetryDelay: 1000,
    maxRetryDelay: 30000,
    backoffFactor: 2,
    backoffJitterPercentage: 0,
    waitInterval: 500,
    callbackTimeoutPeriod: 5000
};
let $4ea6eaf65a70f9b1$export$8bb92baee001fc60 = /*#__PURE__*/ function(QueuedScheduleTypes) {
    QueuedScheduleTypes[QueuedScheduleTypes["NONE"] = 0] = "NONE";
    QueuedScheduleTypes[QueuedScheduleTypes["IMMEDIATE"] = 1] = "IMMEDIATE";
    QueuedScheduleTypes[QueuedScheduleTypes["WAIT"] = 2] = "WAIT";
    return QueuedScheduleTypes;
}({});
class $4ea6eaf65a70f9b1$export$2e2bcd8739ae039 {
    constructor(retryOptions, callback){
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "schedule", ({ immediate: immediate } = {
            immediate: false
        })=>{
            if (typeof window === 'undefined') return;
            if (this.operationInFlight) {
                if (immediate) this.queuedSchedule = $4ea6eaf65a70f9b1$export$8bb92baee001fc60.IMMEDIATE;
                else if (this.queuedSchedule !== $4ea6eaf65a70f9b1$export$8bb92baee001fc60.IMMEDIATE) this.queuedSchedule = $4ea6eaf65a70f9b1$export$8bb92baee001fc60.WAIT;
            // Only run immediately if we have no failures
            } else if ((immediate || this.options.waitInterval <= 0) && this.failureCount === 0) {
                this.clearTimeout();
                this.run();
            // Backoff
            } else if (this.failureCount > 0 && this.scheduledTimeout === null) this.scheduledTimeout = window.setTimeout(this.run, this.calculateBackoff());
            else if (this.scheduledTimeout === null) this.scheduledTimeout = window.setTimeout(this.run, this.options.waitInterval);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "stop", ()=>{
            this.clearTimeout();
            this.queuedSchedule = $4ea6eaf65a70f9b1$export$8bb92baee001fc60.NONE;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "getFailureCount", ()=>this.failureCount);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "getCallbackStatus", ()=>{
            return this.callbackTimer.getCallbackStatus();
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "clearTimeout", ()=>{
            if (typeof window !== 'undefined' && this.scheduledTimeout !== null) {
                window.clearTimeout(this.scheduledTimeout);
                this.scheduledTimeout = null;
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "run", ()=>{
            this.operationInFlight = true;
            this.clearTimeout();
            try {
                this.callbackTimer.executeCallbackWithTimeout(// callback to execute
                this.callback, // when callback completes, call this function
                this.done, // on timeout, do this instead
                ()=>this.done((0, $gWFU9.DoneState).ERROR));
            } catch (err) {
                this.done(err);
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "done", (state)=>{
            this.operationInFlight = false;
            if (state === (0, $gWFU9.DoneState).ERROR || this.callbackTimer.getCallbackStatus() === (0, $b1RZ3.CallbackStatus).TIMED_OUT) {
                this.failureCount++;
                this.clearTimeout();
            } else if (state === (0, $gWFU9.DoneState).SUCCESS) this.failureCount = 0;
            this.processQueuedSchedule();
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "processQueuedSchedule", ()=>{
            if (this.queuedSchedule !== $4ea6eaf65a70f9b1$export$8bb92baee001fc60.NONE) {
                const immediate = this.queuedSchedule === $4ea6eaf65a70f9b1$export$8bb92baee001fc60.IMMEDIATE;
                this.queuedSchedule = $4ea6eaf65a70f9b1$export$8bb92baee001fc60.NONE;
                this.schedule({
                    immediate: immediate
                });
            } else if (this.failureCount > 0) // This will schedule tasks when this._done was called with a truthy value
            // For example, when this.callback(this._done) was not called within
            // this.callbackTimeoutPeriod
            this.schedule();
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "calculateBackoff", ()=>{
            const { minRetryDelay: minRetryDelay, maxRetryDelay: maxRetryDelay, backoffFactor: backoffFactor, backoffJitterPercentage: backoffJitterPercentage } = this.options;
            let ms = minRetryDelay * backoffFactor ** this.failureCount;
            if (backoffJitterPercentage) {
                const rand = Math.random();
                const deviation = Math.floor(rand * backoffJitterPercentage * ms);
                if (Math.floor(rand * 10) < 5) ms -= deviation;
                else ms += deviation;
            }
            return Number(Math.min(ms, maxRetryDelay).toPrecision(1));
        });
        this.options = {
            minRetryDelay: retryOptions.minRetryDelay || $4ea6eaf65a70f9b1$var$SCHEDULER_OPTIONS_DEFAULT.minRetryDelay,
            maxRetryDelay: retryOptions.maxRetryDelay || $4ea6eaf65a70f9b1$var$SCHEDULER_OPTIONS_DEFAULT.maxRetryDelay,
            backoffFactor: retryOptions.backoffFactor || $4ea6eaf65a70f9b1$var$SCHEDULER_OPTIONS_DEFAULT.backoffFactor,
            backoffJitterPercentage: retryOptions.backoffJitterPercentage || $4ea6eaf65a70f9b1$var$SCHEDULER_OPTIONS_DEFAULT.backoffJitterPercentage,
            waitInterval: retryOptions.waitInterval !== undefined ? retryOptions.waitInterval : $4ea6eaf65a70f9b1$var$SCHEDULER_OPTIONS_DEFAULT.waitInterval,
            callbackTimeoutPeriod: retryOptions.callbackTimeoutPeriod || $4ea6eaf65a70f9b1$var$SCHEDULER_OPTIONS_DEFAULT.callbackTimeoutPeriod
        };
        this.scheduledTimeout = null;
        this.failureCount = 0;
        this.callback = callback;
        this.operationInFlight = false;
        this.queuedSchedule = $4ea6eaf65a70f9b1$export$8bb92baee001fc60.NONE;
        this.callbackTimer = new (0, $b1RZ3.CallbackWithTimeout)(this.options.callbackTimeoutPeriod);
    }
}

});
parcelRegister("b1RZ3", function(module, exports) {
$parcel$export(module.exports, "CallbackStatus", () => $8079a9c5c8a2265d$export$ef3353088fca369c);
$parcel$export(module.exports, "CallbackWithTimeout", () => $8079a9c5c8a2265d$export$590a718599f8f8b3);

var $25nEq = parcelRequire("25nEq");
let $8079a9c5c8a2265d$export$ef3353088fca369c = /*#__PURE__*/ function(CallbackStatus) {
    CallbackStatus["IDLE"] = "idle";
    CallbackStatus["RUNNING"] = "running";
    CallbackStatus["COMPLETED"] = "completed";
    CallbackStatus["TIMED_OUT"] = "timedOut";
    return CallbackStatus;
}({});
let $8079a9c5c8a2265d$export$def7d978353eaa0 = /*#__PURE__*/ function(CallbackEvent) {
    CallbackEvent["EXECUTE"] = "execute";
    CallbackEvent["COMPLETE"] = "complete";
    CallbackEvent["TIMEOUT"] = "timeout";
    return CallbackEvent;
}({});
class $8079a9c5c8a2265d$export$590a718599f8f8b3 {
    constructor(timeoutPeriod){
        // Milliseconds to wait
        // Tracks the settimeout; so that we can clear the timeout
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "timeoutHandle", undefined);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "callbackStatus", $8079a9c5c8a2265d$export$ef3353088fca369c.IDLE);
        if (timeoutPeriod > 0) {
            this.timeoutPeriod = timeoutPeriod;
            return;
        }
        throw new Error('CallbackWithTimeout requires timeout period higher than 0');
    }
    // This is a state machine to control the flow of execution.
    // IDLE -> RUNNING -> COMPLETED
    // IDLE -> RUNNING -> TIMEDOUT
    transitionCallbackStatus(currentStatus, event) {
        switch(currentStatus){
            case $8079a9c5c8a2265d$export$ef3353088fca369c.IDLE:
            case $8079a9c5c8a2265d$export$ef3353088fca369c.TIMED_OUT:
            case $8079a9c5c8a2265d$export$ef3353088fca369c.COMPLETED:
                if (event === $8079a9c5c8a2265d$export$def7d978353eaa0.EXECUTE) this.callbackStatus = $8079a9c5c8a2265d$export$ef3353088fca369c.RUNNING;
                break;
            case $8079a9c5c8a2265d$export$ef3353088fca369c.RUNNING:
                switch(event){
                    case $8079a9c5c8a2265d$export$def7d978353eaa0.COMPLETE:
                        this.callbackStatus = $8079a9c5c8a2265d$export$ef3353088fca369c.COMPLETED;
                        break;
                    case $8079a9c5c8a2265d$export$def7d978353eaa0.TIMEOUT:
                        this.callbackStatus = $8079a9c5c8a2265d$export$ef3353088fca369c.TIMED_OUT;
                        break;
                }
                break;
            default:
                this.callbackStatus = currentStatus;
        }
    }
    // Start a timeout. If this.callback(this._done) does not finish
    // by this.options.callbackTimeoutPeriod time period,
    // we will call done with a true value.
    executeCallbackWithTimeout(callback, onDone, onTimeout) {
        if (typeof window === 'undefined') return;
        this.transitionCallbackStatus(this.callbackStatus, $8079a9c5c8a2265d$export$def7d978353eaa0.EXECUTE);
        // Setting timeout
        this.timeoutHandle = window.setTimeout(()=>{
            this.transitionCallbackStatus(this.callbackStatus, $8079a9c5c8a2265d$export$def7d978353eaa0.TIMEOUT);
            onTimeout();
        }, this.timeoutPeriod);
        // Executing callback
        callback((state)=>{
            this.cancelTimeout();
            if (this.getCallbackStatus() !== $8079a9c5c8a2265d$export$ef3353088fca369c.TIMED_OUT) {
                this.transitionCallbackStatus(this.callbackStatus, $8079a9c5c8a2265d$export$def7d978353eaa0.COMPLETE);
                onDone(state);
            }
        });
    }
    getCallbackStatus() {
        return this.callbackStatus;
    }
    // This allows us to cancel the timeout function, for example, if the callback finishes before the timeout period
    // or, if the user wants to manually cancel the timeout
    cancelTimeout() {
        if (typeof window !== 'undefined' && this.timeoutPeriod > 0 && this.timeoutHandle) {
            window.clearTimeout(this.timeoutHandle);
            this.timeoutHandle = undefined;
        }
    }
}

});

parcelRegister("gWFU9", function(module, exports) {
$parcel$export(module.exports, "DoneState", () => $c56291884c9ca578$export$f93c40fda808dd0c);
// Clients can optionally provide the callbackTimeoutPeriod parameter
let $c56291884c9ca578$export$f93c40fda808dd0c = /*#__PURE__*/ function(DoneState) {
    DoneState[DoneState["NOOP"] = 0] = "NOOP";
    DoneState[DoneState["SUCCESS"] = 1] = "SUCCESS";
    DoneState[DoneState["ERROR"] = 2] = "ERROR";
    return DoneState;
}({});

});




parcelRegister("i5knz", function(module, exports) {
$parcel$export(module.exports, "attachXidToMultipleEvents", () => $d2a8808361f8abd6$export$c21270cab66ab290);

var $25nEq = parcelRequire("25nEq");

var $98R0b = parcelRequire("98R0b");
function $d2a8808361f8abd6$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $d2a8808361f8abd6$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $d2a8808361f8abd6$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $d2a8808361f8abd6$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $d2a8808361f8abd6$export$c9c3aaf655d6f275(item, xidCallback) {
    if (!(xidCallback && xidCallback instanceof Function)) return item;
    if (item.msg.type === (0, $98R0b.SegmentEventTypes).PAGE || item.msg.type === (0, $98R0b.SegmentEventTypes).TRACK) {
        const xid = xidCallback();
        if (xid && Array.isArray(xid)) item.msg.properties = $d2a8808361f8abd6$var$_objectSpread($d2a8808361f8abd6$var$_objectSpread({}, item.msg.properties), {}, {
            xid: xid
        });
    } else if (item.msg.traits && item.msg.type === (0, $98R0b.SegmentEventTypes).IDENTIFY) {
        const xid = xidCallback();
        if (xid && Array.isArray(xid)) item.msg.traits = $d2a8808361f8abd6$var$_objectSpread($d2a8808361f8abd6$var$_objectSpread({}, item.msg.traits), {}, {
            xid: xid
        });
    }
    return item;
}
async function $d2a8808361f8abd6$export$c21270cab66ab290(items, xidItemPromiseCallback) {
    try {
        const xidCallback = await xidItemPromiseCallback;
        return items.map((item)=>$d2a8808361f8abd6$export$c9c3aaf655d6f275(item, xidCallback));
    } catch (error) {
        return items;
    }
}

});
parcelRegister("98R0b", function(module, exports) {
$parcel$export(module.exports, "SegmentEventTypes", () => $6a7df981f7d9357b$export$ddf929981dc6feb3);
// Segment event types copied from our backend
// https://bitbucket.org/atlassian/analytics-service/src/master/api/src/main/java/com/atlassian/dataservices/analytics/service/api/segment/
let $6a7df981f7d9357b$export$ddf929981dc6feb3 = /*#__PURE__*/ function(SegmentEventTypes) {
    SegmentEventTypes["IDENTIFY"] = "identify";
    SegmentEventTypes["PAGE"] = "page";
    SegmentEventTypes["TRACK"] = "track";
    return SegmentEventTypes;
}({});
let $6a7df981f7d9357b$export$8d8db47b9b0efb63 = /*#__PURE__*/ function(CrossDomainIdentifierType) {
    CrossDomainIdentifierType["XC"] = "xc";
    CrossDomainIdentifierType["UID"] = "uid";
    return CrossDomainIdentifierType;
}({});
let $6a7df981f7d9357b$export$2140495465f9e528 = /*#__PURE__*/ function(CrossDomainIdentifierState) {
    CrossDomainIdentifierState["NEW"] = "NEW";
    CrossDomainIdentifierState["CHANGED"] = "CHANGED";
    CrossDomainIdentifierState["EXISTING"] = "EXISTING";
    CrossDomainIdentifierState["TIMEOUT"] = "TIMEOUT";
    CrossDomainIdentifierState["ERROR"] = "ERROR";
    CrossDomainIdentifierState["UNAVAILABLE"] = "UNAVAILABLE";
    CrossDomainIdentifierState["MALFORMED"] = "MALFORMED";
    CrossDomainIdentifierState["UNKNOWN"] = "UNKNOWN";
    return CrossDomainIdentifierState;
}({});

});


parcelRegister("ek8hZ", function(module, exports) {
$parcel$export(module.exports, "DEFAULT_REQUEST_TIMEOUT", () => $a6d95d05cc7a29a1$export$9175ce0e1c95daf2);
const $a6d95d05cc7a29a1$export$9175ce0e1c95daf2 = 10000; // 10 seconds

});

parcelRegister("cE3l4", function(module, exports) {
$parcel$export(module.exports, "HTTP_STATUS_CODE_MAP", () => $934bcf7d35b8c393$export$ba118f9de1e5ac63);
const $934bcf7d35b8c393$export$ba118f9de1e5ac63 = new Map([
    [
        200,
        'OK'
    ],
    [
        400,
        'Bad Request'
    ],
    [
        401,
        'Unauthorized'
    ],
    [
        402,
        'Payment Required'
    ],
    [
        403,
        'Forbidden'
    ],
    [
        404,
        'Not Found'
    ],
    [
        405,
        'Method Not Allowed'
    ],
    [
        406,
        'Not Acceptable'
    ],
    [
        407,
        'Proxy Authentication Required'
    ],
    [
        408,
        'Request Timeout'
    ],
    [
        409,
        'Conflict'
    ],
    [
        410,
        'Gone'
    ],
    [
        411,
        'Length Required'
    ],
    [
        412,
        'Precondition Failed'
    ],
    [
        413,
        'Payload Too Large'
    ],
    [
        414,
        'URI Too Long'
    ],
    [
        415,
        'Unsupported Media Type'
    ],
    [
        416,
        'Requested range not satisfiable'
    ],
    [
        417,
        'Expectation Failed'
    ],
    [
        418,
        "I'm a teapot"
    ],
    [
        422,
        'Unprocessable Entity'
    ],
    [
        423,
        'Locked'
    ],
    [
        424,
        'Failed Dependency'
    ],
    [
        425,
        'Too Early'
    ],
    [
        426,
        'Upgrade Required'
    ],
    [
        428,
        'Precondition Required'
    ],
    [
        429,
        'Too Many Requests'
    ],
    [
        431,
        'Request Header Fields Too Large'
    ],
    [
        451,
        'Unavailable For Legal Reasons'
    ],
    [
        500,
        'Internal Server Error'
    ],
    [
        501,
        'Not Implemented'
    ],
    [
        502,
        'Bad Gateway'
    ],
    [
        503,
        'Service Unavailable'
    ],
    [
        504,
        'Gateway Timeout'
    ],
    [
        505,
        'HTTP Version not supported'
    ],
    [
        506,
        'Variant Also Negotiates'
    ],
    [
        507,
        'Insufficient Storage'
    ],
    [
        508,
        'Loop Detected'
    ],
    [
        509,
        'Bandwidth Limit Exceeded'
    ],
    [
        510,
        'Not Extended'
    ],
    [
        511,
        'Network Authentication Required'
    ],
    [
        -1,
        'Unknown Status'
    ]
]);

});

parcelRegister("1guog", function(module, exports) {
$parcel$export(module.exports, "sendEvents", () => $0ebedbf6cbaaa04e$export$8e8f0180c1b41fad);

var $25nEq = parcelRequire("25nEq");

var $cvlyC = parcelRequire("cvlyC");
function $0ebedbf6cbaaa04e$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $0ebedbf6cbaaa04e$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $0ebedbf6cbaaa04e$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $0ebedbf6cbaaa04e$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
const $0ebedbf6cbaaa04e$export$8e8f0180c1b41fad = async (options)=>{
    var _createOrGetAbortCont;
    const signal = (_createOrGetAbortCont = $0ebedbf6cbaaa04e$var$createOrGetAbortController(options)) === null || _createOrGetAbortCont === void 0 ? void 0 : _createOrGetAbortCont.signal;
    const corsOptions = $0ebedbf6cbaaa04e$var$getCorsForUrl(options.url);
    const response = await fetch(options.url, $0ebedbf6cbaaa04e$var$_objectSpread({
        method: 'POST',
        // Content-type has to be text/plain in order to prevent unnecessary `OPTIONS` requests.
        headers: {
            'Content-Type': 'text/plain'
        },
        body: JSON.stringify(options.batch),
        signal: signal
    }, corsOptions));
    if (response.status === 429 || response.status >= 500 && response.status < 600) throw new Error(`HTTP Error ${response.status} (${response.statusText})`);
    return response;
};
const $0ebedbf6cbaaa04e$var$createOrGetAbortController = (options)=>{
    if (options.abortController) return options.abortController;
    else if (options.timeout) {
        const abortController = new AbortController();
        // After a fetch has completed, calling abort is ignored.
        setTimeout(()=>{
            abortController.abort();
        }, options.timeout);
        return abortController;
    }
};
// To ensure we always have cookies, we should check if the origins match.
// If they dont, we need to set mode to `cors` and credentials to `include`.
const $0ebedbf6cbaaa04e$var$getCorsForUrl = (0, $cvlyC.default)((url)=>{
    const origin = new URL(url).origin;
    if (origin === location.origin) return {};
    else return {
        mode: 'cors',
        credentials: 'include'
    };
});

});

parcelRegister("h2dqi", function(module, exports) {
$parcel$export(module.exports, "default", () => $c66d092252cfbece$export$2e2bcd8739ae039);

var $eWmwA = parcelRequire("eWmwA");

var $6JfQX = parcelRequire("6JfQX");

var $kwVVh = parcelRequire("kwVVh");
var $1FuyH = parcelRequire("1FuyH");

var $hqn4q = parcelRequire("hqn4q");
// Cookie is stale, if anonymousId was generated 7 days ago.
const $c66d092252cfbece$var$ANONYMOUS_ID_COOKIE_STALE_DAYS = 7;
const $c66d092252cfbece$var$SAFE = 'SAFE';
const $c66d092252cfbece$var$UNSAFE = 'UNSAFE';
const $c66d092252cfbece$var$NOT_FOUND = 'NOT_FOUND';
const $c66d092252cfbece$var$COOKIE = 'COOKIE';
const $c66d092252cfbece$var$LOCAL_STORAGE = 'LOCAL_STORAGE';
class $c66d092252cfbece$export$2e2bcd8739ae039 {
    constructor(disableCookiePersistence){
        this.store = new (0, $hqn4q.default)({
            useStoragePrefix: false
        });
        this.cookie = new (0, $1FuyH.default)(disableCookiePersistence);
    }
    getUserId() {
        return this.userId || null;
    }
    setUserId(userId) {
        this.userId = userId;
    }
    getAnonymousId(customAnonymousIdGenerator) {
        /**
     * Prefer localStorage as there cant be duplicate keys, and its faster. Also update cookie, if stale.
     * If not set in localStorage, check cookies. Also set localStorage for future attempts.
     * If not in cookies, generate a new one. Set both cookie and localStorage keys.
     */ return this.getAnonymousIdFromLocalStorageAndUpdateCookieIfStale() || this.getAnonymousIdFromCookieAndUpdateLocalStorage() || this.generateNewAnonymousId(customAnonymousIdGenerator);
    }
    setAnonymousId(anonymousId) {
        const stringifyAnonymosId = JSON.stringify(anonymousId);
        this.cookie.set((0, $kwVVh.AWCCookiesKeys).AJS_ANONYMOUS_ID, stringifyAnonymosId);
        this.lastAnonymousIdCookieUpdate = Date.now();
        return this.store.setItem((0, $kwVVh.AllAnalyticsCookies).AJS_ANONYMOUS_ID.getKey(), stringifyAnonymosId);
    }
    getAnonymousIdFromStorage(source) {
        const rawStorageAnonidValue = source === $c66d092252cfbece$var$LOCAL_STORAGE ? this.store.getItem((0, $kwVVh.AllAnalyticsCookies).AJS_ANONYMOUS_ID.getKey()) : this.cookie.get((0, $kwVVh.AWCCookiesKeys).AJS_ANONYMOUS_ID);
        if (rawStorageAnonidValue) {
            const unsafeValue = {
                type: $c66d092252cfbece$var$UNSAFE,
                anonymousId: rawStorageAnonidValue
            };
            try {
                const parsedAnonId = JSON.parse(rawStorageAnonidValue);
                if (parsedAnonId && typeof parsedAnonId === 'string') return {
                    type: $c66d092252cfbece$var$SAFE,
                    anonymousId: parsedAnonId
                };
                return unsafeValue;
            } catch (err) {
                /*
         * Segments new Analytics-next client will store strings as strings without stringifing.
         * The legacy Segment client and AWC always stringify and parse cookies and values.
         * If the new Segment analytics-client stores a cookie and local storage value first, it will
         * breaking old clients.
         *
         * Additionally, JSON.parse can cause exceptions to be thrown in some browsers; see AAP-324.
         *
         * Intentionally swalling errors here and returning the original value found in storage to avoid ping-pong.
         */ return unsafeValue;
            }
        }
        return {
            type: $c66d092252cfbece$var$NOT_FOUND
        };
    }
    getAnonymousIdFromLocalStorageAndUpdateCookieIfStale() {
        const localStorageValue = this.getAnonymousIdFromStorage($c66d092252cfbece$var$LOCAL_STORAGE);
        let shouldUpdateCookie = false;
        if (!this.lastAnonymousIdCookieUpdate || (0, $eWmwA.default)(new Date(), new Date(this.lastAnonymousIdCookieUpdate)) >= $c66d092252cfbece$var$ANONYMOUS_ID_COOKIE_STALE_DAYS) shouldUpdateCookie = true;
        switch(localStorageValue.type){
            case $c66d092252cfbece$var$SAFE:
                if (shouldUpdateCookie) this.setAnonymousId(localStorageValue.anonymousId);
                return localStorageValue.anonymousId;
            case $c66d092252cfbece$var$UNSAFE:
                return localStorageValue.anonymousId;
            case $c66d092252cfbece$var$NOT_FOUND:
            default:
                return null;
        }
    }
    getAnonymousIdFromCookieAndUpdateLocalStorage() {
        const cookieValue = this.getAnonymousIdFromStorage($c66d092252cfbece$var$COOKIE);
        switch(cookieValue.type){
            case $c66d092252cfbece$var$SAFE:
            case $c66d092252cfbece$var$UNSAFE:
                this.store.setItem((0, $kwVVh.AllAnalyticsCookies).AJS_ANONYMOUS_ID.getKey(), JSON.stringify(cookieValue.anonymousId));
                return cookieValue.anonymousId;
            case $c66d092252cfbece$var$NOT_FOUND:
            default:
                return null;
        }
    }
    generateNewAnonymousId(customAnonymousIdGenerator = (0, $6JfQX.default)) {
        const newAnonId = customAnonymousIdGenerator();
        this.setAnonymousId(newAnonId);
        return newAnonId;
    }
}

});
parcelRegister("eWmwA", function(module, exports) {
$parcel$export(module.exports, "default", () => $ae07f466ece1f6b1$export$2e2bcd8739ae039);

var $k0voR = parcelRequire("k0voR");

var $6XY0b = parcelRequire("6XY0b");

var $aCKXn = parcelRequire("aCKXn");
// for accurate equality comparisons of UTC timestamps that end up
// having the same representation in local time, e.g. one hour before
// DST ends vs. the instant that DST ends.
function $ae07f466ece1f6b1$var$compareLocalAsc(dateLeft, dateRight) {
    var diff = dateLeft.getFullYear() - dateRight.getFullYear() || dateLeft.getMonth() - dateRight.getMonth() || dateLeft.getDate() - dateRight.getDate() || dateLeft.getHours() - dateRight.getHours() || dateLeft.getMinutes() - dateRight.getMinutes() || dateLeft.getSeconds() - dateRight.getSeconds() || dateLeft.getMilliseconds() - dateRight.getMilliseconds();
    if (diff < 0) return -1;
    else if (diff > 0) return 1;
    else return diff;
}
function $ae07f466ece1f6b1$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $aCKXn.default)(2, arguments);
    var dateLeft = (0, $k0voR.default)(dirtyDateLeft);
    var dateRight = (0, $k0voR.default)(dirtyDateRight);
    var sign = $ae07f466ece1f6b1$var$compareLocalAsc(dateLeft, dateRight);
    var difference = Math.abs((0, $6XY0b.default)(dateLeft, dateRight));
    dateLeft.setDate(dateLeft.getDate() - sign * difference);
    // Math.abs(diff in full days - diff in calendar days) === 1 if last calendar day is not full
    // If so, result must be decreased by 1 in absolute value
    var isLastDayNotFull = Number($ae07f466ece1f6b1$var$compareLocalAsc(dateLeft, dateRight) === -sign);
    var result = sign * (difference - isLastDayNotFull);
    // Prevent negative zero
    return result === 0 ? 0 : result;
}

});
parcelRegister("k0voR", function(module, exports) {
$parcel$export(module.exports, "default", () => $e90c2a187f20b2a5$export$2e2bcd8739ae039);

var $4bFFZ = parcelRequire("4bFFZ");

var $aCKXn = parcelRequire("aCKXn");
function $e90c2a187f20b2a5$export$2e2bcd8739ae039(argument) {
    (0, $aCKXn.default)(1, arguments);
    var argStr = Object.prototype.toString.call(argument);
    // Clone the date
    if (argument instanceof Date || (0, $4bFFZ.default)(argument) === 'object' && argStr === '[object Date]') // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new Date(argument.getTime());
    else if (typeof argument === 'number' || argStr === '[object Number]') return new Date(argument);
    else {
        if ((typeof argument === 'string' || argStr === '[object String]') && typeof console !== 'undefined') {
            // eslint-disable-next-line no-console
            console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#string-arguments");
            // eslint-disable-next-line no-console
            console.warn(new Error().stack);
        }
        return new Date(NaN);
    }
}

});
parcelRegister("aCKXn", function(module, exports) {
$parcel$export(module.exports, "default", () => $7bc1e09ac693047d$export$2e2bcd8739ae039);
function $7bc1e09ac693047d$export$2e2bcd8739ae039(required, args) {
    if (args.length < required) throw new TypeError(required + ' argument' + (required > 1 ? 's' : '') + ' required, but only ' + args.length + ' present');
}

});


parcelRegister("6XY0b", function(module, exports) {
$parcel$export(module.exports, "default", () => $5126cbe4c03a9703$export$2e2bcd8739ae039);

var $9jQRB = parcelRequire("9jQRB");

var $dQr7B = parcelRequire("dQr7B");

var $aCKXn = parcelRequire("aCKXn");
var $5126cbe4c03a9703$var$MILLISECONDS_IN_DAY = 86400000;
function $5126cbe4c03a9703$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $aCKXn.default)(2, arguments);
    var startOfDayLeft = (0, $dQr7B.default)(dirtyDateLeft);
    var startOfDayRight = (0, $dQr7B.default)(dirtyDateRight);
    var timestampLeft = startOfDayLeft.getTime() - (0, $9jQRB.default)(startOfDayLeft);
    var timestampRight = startOfDayRight.getTime() - (0, $9jQRB.default)(startOfDayRight);
    // Round the number of days to the nearest integer
    // because the number of milliseconds in a day is not constant
    // (e.g. it's different in the day of the daylight saving time clock shift)
    return Math.round((timestampLeft - timestampRight) / $5126cbe4c03a9703$var$MILLISECONDS_IN_DAY);
}

});
parcelRegister("9jQRB", function(module, exports) {
$parcel$export(module.exports, "default", () => $6c8ee502bc30586d$export$2e2bcd8739ae039);
/**
 * Google Chrome as of 67.0.3396.87 introduced timezones with offset that includes seconds.
 * They usually appear for dates that denote time before the timezones were introduced
 * (e.g. for 'Europe/Prague' timezone the offset is GMT+00:57:44 before 1 October 1891
 * and GMT+01:00:00 after that date)
 *
 * Date#getTimezoneOffset returns the offset in minutes and would return 57 for the example above,
 * which would lead to incorrect calculations.
 *
 * This function returns the timezone offset in milliseconds that takes seconds in account.
 */ function $6c8ee502bc30586d$export$2e2bcd8739ae039(date) {
    var utcDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds()));
    utcDate.setUTCFullYear(date.getFullYear());
    return date.getTime() - utcDate.getTime();
}

});

parcelRegister("dQr7B", function(module, exports) {
$parcel$export(module.exports, "default", () => $a1452b7a9be621b1$export$2e2bcd8739ae039);

var $k0voR = parcelRequire("k0voR");

var $aCKXn = parcelRequire("aCKXn");
function $a1452b7a9be621b1$export$2e2bcd8739ae039(dirtyDate) {
    (0, $aCKXn.default)(1, arguments);
    var date = (0, $k0voR.default)(dirtyDate);
    date.setHours(0, 0, 0, 0);
    return date;
}

});



parcelRegister("kwVVh", function(module, exports) {
$parcel$export(module.exports, "AWCCookiesKeys", () => $ef23ba13b696517d$export$202d555a5dbfd90c);
$parcel$export(module.exports, "AllAnalyticsCookies", () => $ef23ba13b696517d$export$d4cb17942ea57c95);
let $ef23ba13b696517d$export$202d555a5dbfd90c = /*#__PURE__*/ function(AWCCookiesKeys) {
    AWCCookiesKeys["AWC_TLD_TEST"] = "AWC_TLD_TEST";
    AWCCookiesKeys["AWC_ANALYTICS_DEBUG"] = "AWC_ANALYTICS_DEBUG";
    AWCCookiesKeys["AJS_ANONYMOUS_ID"] = "AJS_ANONYMOUS_ID";
    return AWCCookiesKeys;
}({});
class $ef23ba13b696517d$var$CookieSchema {
    constructor(key, options){
        this.key = key;
        this.options = options;
    }
    getAttributes() {
        return this.options;
    }
    getKey() {
        return this.key;
    }
}
const $ef23ba13b696517d$var$isSecure = ()=>{
    try {
        return window && window.location && window.location.protocol === 'https:';
    } catch (err) {
        return false;
    }
};
const $ef23ba13b696517d$export$d4cb17942ea57c95 = {
    [$ef23ba13b696517d$export$202d555a5dbfd90c.AWC_TLD_TEST]: new $ef23ba13b696517d$var$CookieSchema('__awc_tld_test__', {
        expires: 365,
        secure: $ef23ba13b696517d$var$isSecure(),
        path: '/'
    }),
    [$ef23ba13b696517d$export$202d555a5dbfd90c.AWC_ANALYTICS_DEBUG]: new $ef23ba13b696517d$var$CookieSchema('atlassian_analytics_debug', {
        expires: 365,
        secure: $ef23ba13b696517d$var$isSecure(),
        path: '/'
    }),
    [$ef23ba13b696517d$export$202d555a5dbfd90c.AJS_ANONYMOUS_ID]: new $ef23ba13b696517d$var$CookieSchema('ajs_anonymous_id', {
        expires: 365,
        secure: $ef23ba13b696517d$var$isSecure(),
        path: '/'
    })
};

});

parcelRegister("1FuyH", function(module, exports) {
$parcel$export(module.exports, "default", () => $1371531745387b2d$export$2e2bcd8739ae039);

var $25nEq = parcelRequire("25nEq");

var $bDLqY = parcelRequire("bDLqY");

var $kwVVh = parcelRequire("kwVVh");

var $5kSLN = parcelRequire("5kSLN");

var $gkrqG = parcelRequire("gkrqG");
function $1371531745387b2d$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $1371531745387b2d$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $1371531745387b2d$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $1371531745387b2d$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
class $1371531745387b2d$export$2e2bcd8739ae039 {
    constructor(disableCookiePersistence){
        this.cookieLike = (0, $gkrqG.canUseCookie)(disableCookiePersistence) ? (0, (/*@__PURE__*/$parcel$interopDefault($bDLqY))) : new (0, $5kSLN.default)();
    }
    set(name, value, options) {
        // no-op
        if (!(0, $kwVVh.AllAnalyticsCookies)[name]) {
            // eslint-disable-next-line no-console
            console.warn(`Unknown cookie key ${name} provided, not set.`);
            return;
        }
        return this.cookieLike.set((0, $kwVVh.AllAnalyticsCookies)[name].getKey(), value, $1371531745387b2d$var$_objectSpread($1371531745387b2d$var$_objectSpread({}, (0, $kwVVh.AllAnalyticsCookies)[name].getAttributes()), {}, {
            // Function is memoized so we only calculate this once per page load
            domain: (0, $gkrqG.getTld)()
        }, options));
    }
    get(name) {
        if (!(0, $kwVVh.AllAnalyticsCookies)[name]) {
            // eslint-disable-next-line no-console
            console.warn(`Unknown cookie key ${name} provided, not fetched.`);
            return;
        }
        return this.cookieLike.get((0, $kwVVh.AllAnalyticsCookies)[name].getKey());
    }
    remove(name, options) {
        if (!(0, $kwVVh.AllAnalyticsCookies)[name]) {
            // eslint-disable-next-line no-console
            console.warn(`Unknown cookie key ${name} provided, not removed.`);
            return;
        }
        this.cookieLike.remove((0, $kwVVh.AllAnalyticsCookies)[name].getKey(), $1371531745387b2d$var$_objectSpread({}, options));
    }
}

});
parcelRegister("bDLqY", function(module, exports) {
(function(global, factory) {
    module.exports = factory();
})(module.exports, function() {
    'use strict';
    function assign(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (key === '__proto__') continue;
                target[key] = source[key];
            }
        }
        return target;
    }
    var defaultConverter = {
        read: function(value) {
            if (value[0] === '"') value = value.slice(1, -1);
            return value.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent);
        },
        write: function(value) {
            return encodeURIComponent(value).replace(/%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g, decodeURIComponent);
        }
    };
    function init(converter, defaultAttributes) {
        function set(name, value, attributes) {
            if (typeof document === 'undefined') return;
            attributes = assign({}, defaultAttributes, attributes);
            if (typeof attributes.expires === 'number') attributes.expires = new Date(Date.now() + attributes.expires * 864e5);
            if (attributes.expires) attributes.expires = attributes.expires.toUTCString();
            name = encodeURIComponent(name).replace(/%(2[346B]|5E|60|7C)/g, decodeURIComponent).replace(/[()]/g, escape);
            var stringifiedAttributes = '';
            for(var attributeName in attributes){
                if (!attributes[attributeName]) continue;
                stringifiedAttributes += '; ' + attributeName;
                if (attributes[attributeName] === true) continue;
                // Considers RFC 6265 section 5.2:
                // ...
                // 3.  If the remaining unparsed-attributes contains a %x3B (";")
                //     character:
                // Consume the characters of the unparsed-attributes up to,
                // not including, the first %x3B (";") character.
                // ...
                stringifiedAttributes += '=' + attributes[attributeName].split(';')[0];
            }
            return document.cookie = name + '=' + converter.write(value, name) + stringifiedAttributes;
        }
        function get(name) {
            if (typeof document === 'undefined' || arguments.length && !name) return;
            // To prevent the for loop in the first place assign an empty array
            // in case there are no cookies at all.
            var cookies = document.cookie ? document.cookie.split('; ') : [];
            var jar = {};
            for(var i = 0; i < cookies.length; i++){
                var parts = cookies[i].split('=');
                var value = parts.slice(1).join('=');
                try {
                    var found = decodeURIComponent(parts[0]);
                    if (!(found in jar)) jar[found] = converter.read(value, found);
                    if (name === found) break;
                } catch (_e) {
                // Do nothing...
                }
            }
            return name ? jar[name] : jar;
        }
        return Object.create({
            set: set,
            get: get,
            remove: function(name, attributes) {
                set(name, '', assign({}, attributes, {
                    expires: -1
                }));
            },
            withAttributes: function(attributes) {
                return init(this.converter, assign({}, this.attributes, attributes));
            },
            withConverter: function(converter) {
                return init(assign({}, this.converter, converter), this.attributes);
            }
        }, {
            attributes: {
                value: Object.freeze(defaultAttributes)
            },
            converter: {
                value: Object.freeze(converter)
            }
        });
    }
    var api = init(defaultConverter, {
        path: '/'
    });
    return api;
});

});

parcelRegister("5kSLN", function(module, exports) {
$parcel$export(module.exports, "default", () => $3e294e25b330160a$export$2e2bcd8739ae039);

var $hqn4q = parcelRequire("hqn4q");
class $3e294e25b330160a$export$2e2bcd8739ae039 {
    constructor(){
        this.safeStorage = new (0, $hqn4q.default)({
            useStoragePrefix: false
        });
    }
    set(name, value) {
        this.safeStorage.setItem(name, value);
        return value;
    }
    get(name) {
        const value = this.safeStorage.getItem(name);
        return value || undefined;
    }
    remove(name) {
        this.safeStorage.removeItem(name);
    }
}

});
parcelRegister("hqn4q", function(module, exports) {
$parcel$export(module.exports, "default", () => $caf6c2acc113d09e$export$2e2bcd8739ae039);

var $45wGM = parcelRequire("45wGM");

var $hh2HV = parcelRequire("hh2HV");
class $caf6c2acc113d09e$export$2e2bcd8739ae039 extends (0, $hh2HV.default) {
    constructor(options){
        let storageToUse;
        try {
            storageToUse = window.localStorage || (0, $45wGM.default);
        } catch (err) {
            storageToUse = (0, $45wGM.default);
        }
        super(storageToUse, options);
    }
}

});
parcelRegister("45wGM", function(module, exports) {
$parcel$export(module.exports, "default", () => $2fa0fc68a972bc5e$export$2e2bcd8739ae039);

var $25nEq = parcelRequire("25nEq");
class $2fa0fc68a972bc5e$export$90e3e001bcac59c7 {
    constructor(){
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "_data", {});
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "length", 0);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "setItem", (key, value)=>{
            this._data[key] = value;
            this.length = Object.keys(this._data).length;
            return value;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "getItem", (key)=>{
            if (key in this._data) return this._data[key];
            return null;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "removeItem", (key)=>{
            if (key in this._data) delete this._data[key];
            this.length = Object.keys(this._data).length;
            return null;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "clear", ()=>{
            this._data = {};
            this.length = 0;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "key", (index)=>Object.keys(this._data)[index]);
    }
}
var // eslint-disable-next-line import/no-anonymous-default-export
$2fa0fc68a972bc5e$export$2e2bcd8739ae039 = new $2fa0fc68a972bc5e$export$90e3e001bcac59c7();

});

parcelRegister("hh2HV", function(module, exports) {
$parcel$export(module.exports, "default", () => $c9361fd4d130cb01$export$2e2bcd8739ae039);

var $25nEq = parcelRequire("25nEq");

var $iVpQc = parcelRequire("iVpQc");

var $45wGM = parcelRequire("45wGM");
const $c9361fd4d130cb01$export$41c06fdd37b7e9a5 = 'awc';
const $c9361fd4d130cb01$export$770aa8bc07b3de03 = 'awcInMemoryStorageFallback';
function $c9361fd4d130cb01$export$48c17662a6902497(store) {
    const TEST_VALUE = 'test_value';
    if (!store) return false;
    try {
        const key = 'awc.storage.support';
        store.setItem(key, TEST_VALUE);
        const value = store.getItem(key);
        store.removeItem(key);
        // handle localStorage silently failing
        return value === TEST_VALUE;
    } catch (e) {
        // Can throw if localStorage is disabled
        return false;
    }
}
function $c9361fd4d130cb01$export$6325979d1c67607f(e) {
    let quotaExceeded = false;
    if (e.code) switch(e.code){
        case 22:
            quotaExceeded = true;
            break;
        case 1014:
            // Firefox
            if (e.name === 'NS_ERROR_DOM_QUOTA_REACHED') quotaExceeded = true;
            break;
        default:
            break;
    }
    else if (e.number === -2147024882) // Internet Explorer 8
    quotaExceeded = true;
    return quotaExceeded;
}
class $c9361fd4d130cb01$export$2e2bcd8739ae039 {
    constructor(storageToUse, options = {}){
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "getStore", ()=>this._store);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "getItem", (key)=>this._store.getItem(this.createKey(key)));
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "removeItem", (key)=>this._store.removeItem(this.createKey(key)));
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "setItem", (key, value)=>{
            try {
                this._store.setItem(this.createKey(key), value);
            } catch (err) {
                if ($c9361fd4d130cb01$export$6325979d1c67607f(err)) {
                    this.swapToInMemory();
                    this._store.setItem(this.createKey(key), value);
                }
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "swapToInMemory", ()=>{
            if (this._store === (0, $45wGM.default) || typeof window === 'undefined') return;
            const keys = Object.keys(this._store || {});
            let inMemoryStorage;
            if ($c9361fd4d130cb01$export$48c17662a6902497(window[$c9361fd4d130cb01$export$770aa8bc07b3de03])) inMemoryStorage = window[$c9361fd4d130cb01$export$770aa8bc07b3de03];
            else {
                inMemoryStorage = (0, $45wGM.default);
                if (!window[$c9361fd4d130cb01$export$770aa8bc07b3de03]) // If not already attached to window then attach our instance of InMemoryStorage
                // We need to do this because if there are multiple instances of Analytics Client in multiple scopes,
                // there is no way to guarantee the throttling behaviour of the UI viewed event across those instances without a global singleton
                window[$c9361fd4d130cb01$export$770aa8bc07b3de03] = (0, $45wGM.default);
            }
            keys.forEach((key)=>{
                if (key.indexOf(this.getPrefix()) === 0) {
                    const value = this._store.getItem(key);
                    if (value) inMemoryStorage.setItem(key, value);
                }
            });
            this._store = inMemoryStorage;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "clear", ()=>this._store.clear());
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "key", (index)=>this._store.key(index));
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "getPrefix", ()=>this._prefix);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "createKey", (key)=>{
            if (this._prefix) return `${this.getPrefix()}.${key}`;
            return key;
        });
        this.options = options;
        const prefixes = [];
        if (options.useStoragePrefix === undefined || options.useStoragePrefix) prefixes.push($c9361fd4d130cb01$export$41c06fdd37b7e9a5);
        if (options.envPrefix && options.envPrefix !== (0, $iVpQc.envType).PROD) prefixes.push(options.envPrefix);
        this._prefix = prefixes.join('-');
        if ($c9361fd4d130cb01$export$48c17662a6902497(storageToUse)) this._store = storageToUse;
        else this.swapToInMemory();
    }
}

});



parcelRegister("gkrqG", function(module, exports) {
$parcel$export(module.exports, "canUseCookie", () => $be33ca8402b7cb1d$export$a9330601ee8f4d95);
$parcel$export(module.exports, "getTld", () => $be33ca8402b7cb1d$export$de6821eed3d5f32d);

var $bDLqY = parcelRequire("bDLqY");

var $cvlyC = parcelRequire("cvlyC");

var $kwVVh = parcelRequire("kwVVh");
const $be33ca8402b7cb1d$export$a9330601ee8f4d95 = (disableCookiePersistence = false)=>{
    if (disableCookiePersistence) return false;
    return !(location.protocol === 'file:' || location.protocol === 'chrome-extension:');
};
const $be33ca8402b7cb1d$export$eb80e1beaa8dacf8 = (0, $kwVVh.AllAnalyticsCookies).AWC_TLD_TEST.getKey();
const $be33ca8402b7cb1d$export$19164982d36535d8 = 'tld_test';
const $be33ca8402b7cb1d$export$de6821eed3d5f32d = (0, $cvlyC.default)(()=>{
    if (typeof location === 'undefined') return '';
    const { hostname: hostname } = location;
    const splitHostname = hostname.split('.');
    for(let i = 1; i <= splitHostname.length; i++){
        const domainParts = splitHostname.slice(i * -1);
        const domain = `.${domainParts.join('.')}`;
        (0, (/*@__PURE__*/$parcel$interopDefault($bDLqY))).set($be33ca8402b7cb1d$export$eb80e1beaa8dacf8, $be33ca8402b7cb1d$export$19164982d36535d8, {
            domain: domain
        });
        if ((0, (/*@__PURE__*/$parcel$interopDefault($bDLqY))).get($be33ca8402b7cb1d$export$eb80e1beaa8dacf8) === $be33ca8402b7cb1d$export$19164982d36535d8) {
            (0, (/*@__PURE__*/$parcel$interopDefault($bDLqY))).remove($be33ca8402b7cb1d$export$eb80e1beaa8dacf8, {
                domain: domain
            });
            return domain;
        }
    }
    return hostname;
});

});



parcelRegister("5U49X", function(module, exports) {
$parcel$export(module.exports, "buildContext", () => $44c568baf64d82a5$export$3a7fe28f9bf4f3d9);
$parcel$export(module.exports, "prepareEventProperties", () => $44c568baf64d82a5$export$44d22e5fb02cc68e);

var $25nEq = parcelRequire("25nEq");

var $dMCb6 = parcelRequire("dMCb6");
function $44c568baf64d82a5$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $44c568baf64d82a5$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $44c568baf64d82a5$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $44c568baf64d82a5$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
const $44c568baf64d82a5$export$3a7fe28f9bf4f3d9 = (context)=>{
    return $44c568baf64d82a5$var$_objectSpread($44c568baf64d82a5$var$_objectSpread({}, context.context), {}, {
        userAgent: navigator.userAgent
    });
};
const $44c568baf64d82a5$export$44d22e5fb02cc68e = (properties)=>{
    const propertiesWithoutUndefined = $44c568baf64d82a5$export$2250ccecd1e040fd(properties);
    return (0, (/*@__PURE__*/$parcel$interopDefault($dMCb6)))(propertiesWithoutUndefined);
};
const $44c568baf64d82a5$export$2250ccecd1e040fd = (obj)=>{
    if (obj === null || typeof obj !== 'object') return obj;
    const clone = {};
    Object.keys(obj).forEach((key)=>{
        const value = $44c568baf64d82a5$var$getValueOfObject(obj, key);
        if (value !== undefined) {
            if (Array.isArray(value)) clone[key] = value.map((i)=>$44c568baf64d82a5$export$2250ccecd1e040fd(i));
            else if (typeof value === 'object' && value !== null) clone[key] = $44c568baf64d82a5$export$2250ccecd1e040fd(value);
            else clone[key] = value;
        }
    });
    return clone;
};
// Using ts-ignore everywhere urked me
const $44c568baf64d82a5$var$getValueOfObject = (obj, key)=>{
    // @ts-ignore This is an object
    return obj[key];
};

});
parcelRegister("dMCb6", function(module, exports) {
'use strict';

var $6so8c = parcelRequire("6so8c");
/**
 * Expose `traverse`.
 */ module.exports = $a08d5f71a1a1eb97$var$traverse;
/**
 * Recursively traverse an object or array, and convert
 * all ISO date strings parse into Date objects.
 *
 * @param {Object} input - object, array, or string to convert
 * @param {Boolean} strict - only convert strings with year, month, and date
 * @return {Object}
 */ function $a08d5f71a1a1eb97$var$traverse(input, strict) {
    if (strict === undefined) strict = true;
    if (input && typeof input === 'object') return $a08d5f71a1a1eb97$var$traverseObject(input, strict);
    else if (Array.isArray(input)) return $a08d5f71a1a1eb97$var$traverseArray(input, strict);
    else if ($6so8c.is(input, strict)) return $6so8c.parse(input);
    return input;
}
/**
 * Object traverser helper function.
 *
 * @param {Object} obj - object to traverse
 * @param {Boolean} strict - only convert strings with year, month, and date
 * @return {Object}
 */ function $a08d5f71a1a1eb97$var$traverseObject(obj, strict) {
    Object.keys(obj).forEach(function(key) {
        obj[key] = $a08d5f71a1a1eb97$var$traverse(obj[key], strict);
    });
    return obj;
}
/**
 * Array traverser helper function
 *
 * @param {Array} arr - array to traverse
 * @param {Boolean} strict - only convert strings with year, month, and date
 * @return {Array}
 */ function $a08d5f71a1a1eb97$var$traverseArray(arr, strict) {
    arr.forEach(function(value, index) {
        arr[index] = $a08d5f71a1a1eb97$var$traverse(value, strict);
    });
    return arr;
}

});
parcelRegister("6so8c", function(module, exports) {
$parcel$export(module.exports, "parse", () => $4b381390c1569522$export$98e6a39c04603d36, (v) => $4b381390c1569522$export$98e6a39c04603d36 = v);
$parcel$export(module.exports, "is", () => $4b381390c1569522$export$226b3eccf92c9ed9, (v) => $4b381390c1569522$export$226b3eccf92c9ed9 = v);
/**
 * Convert an ISO date string to a date. Fallback to native `Date.parse`.
 *
 * https://github.com/csnover/js-iso8601/blob/lax/iso8601.js
 *
 * @param {String} iso
 * @return {Date}
 */ var $4b381390c1569522$export$98e6a39c04603d36;
/**
 * Checks whether a `string` is an ISO date string. `strict` mode requires that
 * the date string at least have a year, month and date.
 *
 * @param {String} string
 * @param {Boolean} strict
 * @return {Boolean}
 */ var $4b381390c1569522$export$226b3eccf92c9ed9;
'use strict';
/**
 * Matcher, slightly modified from:
 *
 * https://github.com/csnover/js-iso8601/blob/lax/iso8601.js
 */ var $4b381390c1569522$var$matcher = /^(\d{4})(?:-?(\d{2})(?:-?(\d{2}))?)?(?:([ T])(\d{2}):?(\d{2})(?::?(\d{2})(?:[,\.](\d{1,}))?)?(?:(Z)|([+\-])(\d{2})(?::?(\d{2}))?)?)?$/;
$4b381390c1569522$export$98e6a39c04603d36 = function(iso) {
    var numericKeys = [
        1,
        5,
        6,
        7,
        11,
        12
    ];
    var arr = $4b381390c1569522$var$matcher.exec(iso);
    var offset = 0;
    // fallback to native parsing
    if (!arr) return new Date(iso);
    /* eslint-disable no-cond-assign */ // remove undefined values
    for(var i = 0, val; val = numericKeys[i]; i++)arr[val] = parseInt(arr[val], 10) || 0;
    /* eslint-enable no-cond-assign */ // allow undefined days and months
    arr[2] = parseInt(arr[2], 10) || 1;
    arr[3] = parseInt(arr[3], 10) || 1;
    // month is 0-11
    arr[2]--;
    // allow abitrary sub-second precision
    arr[8] = arr[8] ? (arr[8] + '00').substring(0, 3) : 0;
    // apply timezone if one exists
    if (arr[4] === ' ') offset = new Date().getTimezoneOffset();
    else if (arr[9] !== 'Z' && arr[10]) {
        offset = arr[11] * 60 + arr[12];
        if (arr[10] === '+') offset = 0 - offset;
    }
    var millis = Date.UTC(arr[1], arr[2], arr[3], arr[5], arr[6] + offset, arr[7], arr[8]);
    return new Date(millis);
};
$4b381390c1569522$export$226b3eccf92c9ed9 = function(string, strict) {
    if (typeof string !== 'string') return false;
    if (strict && /^\d{4}-\d{2}-\d{2}/.test(string) === false) return false;
    return $4b381390c1569522$var$matcher.test(string);
};

});




parcelRegister("hyJWt", function(module, exports) {
$parcel$export(module.exports, "default", () => $cc893fcc8d136f6d$export$2e2bcd8739ae039);

var $25nEq = parcelRequire("25nEq");

var $iVpQc = parcelRequire("iVpQc");

var $6W7Sk = parcelRequire("6W7Sk");
class $cc893fcc8d136f6d$export$2e2bcd8739ae039 {
    constructor(){
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "handleOriginParameters", (originParamHandlerMapping, historyReplaceFn)=>{
            // Collect all the parameter labels to be handled
            const originParamLabelList = Object.keys(originParamHandlerMapping);
            if (!(originParamLabelList.length > 0)) throw new Error('Empty parameter mapping provided');
            // Check if the parameter labels are valid. If any invalid labels are found throw an exception.
            const invalidParams = originParamLabelList.filter((x)=>Object.values((0, $iVpQc.originTracingType)).indexOf(x) < 0);
            if (invalidParams.length > 0) throw new Error(`Invalid Origin Tracing Parameter(s) supplied: ${invalidParams.join()}!`);
            const isCaptureParam = (_, key)=>originParamLabelList.indexOf(key) >= 0;
            // Capture and remove params from URL
            const capturedURLParams = (0, $6W7Sk.default)(isCaptureParam, historyReplaceFn);
            // Apply provided handler function to extract origin trace ID from each URL parameter
            const applyHandlerFunction = (key)=>{
                const x = originParamHandlerMapping[key](capturedURLParams[key]);
                return {
                    [key]: x
                };
            };
            const extractedOriginID = Object.keys(capturedURLParams).map(applyHandlerFunction).reduce((accumulator, currentValue)=>Object.assign(accumulator, currentValue), {});
            return extractedOriginID;
        });
        this._originStore = {};
    }
}

});
parcelRegister("6W7Sk", function(module, exports) {
$parcel$export(module.exports, "defaultHistoryReplaceFn", () => $50ce44b50e87e267$export$600dd5bf1b049f11);
$parcel$export(module.exports, "default", () => $50ce44b50e87e267$export$2e2bcd8739ae039);

var $9fYGa = parcelRequire("9fYGa");

var $JnB9d = parcelRequire("JnB9d");
const $50ce44b50e87e267$export$600dd5bf1b049f11 = (newUrl)=>window.history.replaceState({}, '', newUrl);
const $50ce44b50e87e267$var$urlParamExtractor = (isCaptureParam, historyReplaceFn = $50ce44b50e87e267$export$600dd5bf1b049f11)=>{
    // Extract target parameters and values from URL if present
    const originalUrl = window.location.href;
    const fragmentHash = window.location.hash;
    const removedFragmentURL = fragmentHash !== '' ? originalUrl.replace(fragmentHash, '') : originalUrl;
    const { url: url, query: query } = (0, $9fYGa.parseUrl)(removedFragmentURL);
    const captureParams = (0, $JnB9d.pickBy)(query, isCaptureParam);
    // Do not modify URL if no matches
    if (Object.keys(captureParams).length > 0) {
        const queryWithoutCaptureParams = (0, $JnB9d.omitBy)(query, isCaptureParam);
        // Replace the URL minus captured parameters
        if (Object.keys(queryWithoutCaptureParams).length > 0) {
            const newUrl = `${url}?${(0, $9fYGa.stringify)(queryWithoutCaptureParams)}${fragmentHash}`;
            historyReplaceFn(newUrl);
        } else historyReplaceFn(`${url}${fragmentHash}`);
    }
    return captureParams;
};
var $50ce44b50e87e267$export$2e2bcd8739ae039 = $50ce44b50e87e267$var$urlParamExtractor;

});
parcelRegister("9fYGa", function(module, exports) {
$parcel$export(module.exports, "extract", () => $6bd4955d3d75cba1$export$f9380c9a627682d3, (v) => $6bd4955d3d75cba1$export$f9380c9a627682d3 = v);
$parcel$export(module.exports, "parse", () => $6bd4955d3d75cba1$export$98e6a39c04603d36, (v) => $6bd4955d3d75cba1$export$98e6a39c04603d36 = v);
$parcel$export(module.exports, "stringify", () => $6bd4955d3d75cba1$export$fac44ee5b035f737, (v) => $6bd4955d3d75cba1$export$fac44ee5b035f737 = v);
$parcel$export(module.exports, "parseUrl", () => $6bd4955d3d75cba1$export$7a5253c0f62e0150, (v) => $6bd4955d3d75cba1$export$7a5253c0f62e0150 = v);
$parcel$export(module.exports, "stringifyUrl", () => $6bd4955d3d75cba1$export$a8c1621ea79325d3, (v) => $6bd4955d3d75cba1$export$a8c1621ea79325d3 = v);
$parcel$export(module.exports, "pick", () => $6bd4955d3d75cba1$export$357523c63a2253b9, (v) => $6bd4955d3d75cba1$export$357523c63a2253b9 = v);
var $6bd4955d3d75cba1$export$f9380c9a627682d3;
var $6bd4955d3d75cba1$export$98e6a39c04603d36;
var $6bd4955d3d75cba1$export$fac44ee5b035f737;
var $6bd4955d3d75cba1$export$7a5253c0f62e0150;
var $6bd4955d3d75cba1$export$a8c1621ea79325d3;
var $6bd4955d3d75cba1$export$357523c63a2253b9;
var $6bd4955d3d75cba1$export$44c361b8ec72ef7f;
'use strict';

var $6XEYK = parcelRequire("6XEYK");

var $9YPP7 = parcelRequire("9YPP7");

var $l4Qn0 = parcelRequire("l4Qn0");

var $9PyLY = parcelRequire("9PyLY");
const $6bd4955d3d75cba1$var$isNullOrUndefined = (value)=>value === null || value === undefined;
const $6bd4955d3d75cba1$var$encodeFragmentIdentifier = Symbol('encodeFragmentIdentifier');
function $6bd4955d3d75cba1$var$encoderForArrayFormat(options) {
    switch(options.arrayFormat){
        case 'index':
            return (key)=>(result, value)=>{
                    const index = result.length;
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === '') return result;
                    if (value === null) return [
                        ...result,
                        [
                            $6bd4955d3d75cba1$var$encode(key, options),
                            '[',
                            index,
                            ']'
                        ].join('')
                    ];
                    return [
                        ...result,
                        [
                            $6bd4955d3d75cba1$var$encode(key, options),
                            '[',
                            $6bd4955d3d75cba1$var$encode(index, options),
                            ']=',
                            $6bd4955d3d75cba1$var$encode(value, options)
                        ].join('')
                    ];
                };
        case 'bracket':
            return (key)=>(result, value)=>{
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === '') return result;
                    if (value === null) return [
                        ...result,
                        [
                            $6bd4955d3d75cba1$var$encode(key, options),
                            '[]'
                        ].join('')
                    ];
                    return [
                        ...result,
                        [
                            $6bd4955d3d75cba1$var$encode(key, options),
                            '[]=',
                            $6bd4955d3d75cba1$var$encode(value, options)
                        ].join('')
                    ];
                };
        case 'colon-list-separator':
            return (key)=>(result, value)=>{
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === '') return result;
                    if (value === null) return [
                        ...result,
                        [
                            $6bd4955d3d75cba1$var$encode(key, options),
                            ':list='
                        ].join('')
                    ];
                    return [
                        ...result,
                        [
                            $6bd4955d3d75cba1$var$encode(key, options),
                            ':list=',
                            $6bd4955d3d75cba1$var$encode(value, options)
                        ].join('')
                    ];
                };
        case 'comma':
        case 'separator':
        case 'bracket-separator':
            {
                const keyValueSep = options.arrayFormat === 'bracket-separator' ? '[]=' : '=';
                return (key)=>(result, value)=>{
                        if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === '') return result;
                        // Translate null to an empty string so that it doesn't serialize as 'null'
                        value = value === null ? '' : value;
                        if (result.length === 0) return [
                            [
                                $6bd4955d3d75cba1$var$encode(key, options),
                                keyValueSep,
                                $6bd4955d3d75cba1$var$encode(value, options)
                            ].join('')
                        ];
                        return [
                            [
                                result,
                                $6bd4955d3d75cba1$var$encode(value, options)
                            ].join(options.arrayFormatSeparator)
                        ];
                    };
            }
        default:
            return (key)=>(result, value)=>{
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === '') return result;
                    if (value === null) return [
                        ...result,
                        $6bd4955d3d75cba1$var$encode(key, options)
                    ];
                    return [
                        ...result,
                        [
                            $6bd4955d3d75cba1$var$encode(key, options),
                            '=',
                            $6bd4955d3d75cba1$var$encode(value, options)
                        ].join('')
                    ];
                };
    }
}
function $6bd4955d3d75cba1$var$parserForArrayFormat(options) {
    let result;
    switch(options.arrayFormat){
        case 'index':
            return (key, value, accumulator)=>{
                result = /\[(\d*)\]$/.exec(key);
                key = key.replace(/\[\d*\]$/, '');
                if (!result) {
                    accumulator[key] = value;
                    return;
                }
                if (accumulator[key] === undefined) accumulator[key] = {};
                accumulator[key][result[1]] = value;
            };
        case 'bracket':
            return (key, value, accumulator)=>{
                result = /(\[\])$/.exec(key);
                key = key.replace(/\[\]$/, '');
                if (!result) {
                    accumulator[key] = value;
                    return;
                }
                if (accumulator[key] === undefined) {
                    accumulator[key] = [
                        value
                    ];
                    return;
                }
                accumulator[key] = [].concat(accumulator[key], value);
            };
        case 'colon-list-separator':
            return (key, value, accumulator)=>{
                result = /(:list)$/.exec(key);
                key = key.replace(/:list$/, '');
                if (!result) {
                    accumulator[key] = value;
                    return;
                }
                if (accumulator[key] === undefined) {
                    accumulator[key] = [
                        value
                    ];
                    return;
                }
                accumulator[key] = [].concat(accumulator[key], value);
            };
        case 'comma':
        case 'separator':
            return (key, value, accumulator)=>{
                const isArray = typeof value === 'string' && value.includes(options.arrayFormatSeparator);
                const isEncodedArray = typeof value === 'string' && !isArray && $6bd4955d3d75cba1$var$decode(value, options).includes(options.arrayFormatSeparator);
                value = isEncodedArray ? $6bd4955d3d75cba1$var$decode(value, options) : value;
                const newValue = isArray || isEncodedArray ? value.split(options.arrayFormatSeparator).map((item)=>$6bd4955d3d75cba1$var$decode(item, options)) : value === null ? value : $6bd4955d3d75cba1$var$decode(value, options);
                accumulator[key] = newValue;
            };
        case 'bracket-separator':
            return (key, value, accumulator)=>{
                const isArray = /(\[\])$/.test(key);
                key = key.replace(/\[\]$/, '');
                if (!isArray) {
                    accumulator[key] = value ? $6bd4955d3d75cba1$var$decode(value, options) : value;
                    return;
                }
                const arrayValue = value === null ? [] : value.split(options.arrayFormatSeparator).map((item)=>$6bd4955d3d75cba1$var$decode(item, options));
                if (accumulator[key] === undefined) {
                    accumulator[key] = arrayValue;
                    return;
                }
                accumulator[key] = [].concat(accumulator[key], arrayValue);
            };
        default:
            return (key, value, accumulator)=>{
                if (accumulator[key] === undefined) {
                    accumulator[key] = value;
                    return;
                }
                accumulator[key] = [].concat(accumulator[key], value);
            };
    }
}
function $6bd4955d3d75cba1$var$validateArrayFormatSeparator(value) {
    if (typeof value !== 'string' || value.length !== 1) throw new TypeError('arrayFormatSeparator must be single character string');
}
function $6bd4955d3d75cba1$var$encode(value, options) {
    if (options.encode) return options.strict ? $6XEYK(value) : encodeURIComponent(value);
    return value;
}
function $6bd4955d3d75cba1$var$decode(value, options) {
    if (options.decode) return $9YPP7(value);
    return value;
}
function $6bd4955d3d75cba1$var$keysSorter(input) {
    if (Array.isArray(input)) return input.sort();
    if (typeof input === 'object') return $6bd4955d3d75cba1$var$keysSorter(Object.keys(input)).sort((a, b)=>Number(a) - Number(b)).map((key)=>input[key]);
    return input;
}
function $6bd4955d3d75cba1$var$removeHash(input) {
    const hashStart = input.indexOf('#');
    if (hashStart !== -1) input = input.slice(0, hashStart);
    return input;
}
function $6bd4955d3d75cba1$var$getHash(url) {
    let hash = '';
    const hashStart = url.indexOf('#');
    if (hashStart !== -1) hash = url.slice(hashStart);
    return hash;
}
function $6bd4955d3d75cba1$var$extract(input) {
    input = $6bd4955d3d75cba1$var$removeHash(input);
    const queryStart = input.indexOf('?');
    if (queryStart === -1) return '';
    return input.slice(queryStart + 1);
}
function $6bd4955d3d75cba1$var$parseValue(value, options) {
    if (options.parseNumbers && !Number.isNaN(Number(value)) && typeof value === 'string' && value.trim() !== '') value = Number(value);
    else if (options.parseBooleans && value !== null && (value.toLowerCase() === 'true' || value.toLowerCase() === 'false')) value = value.toLowerCase() === 'true';
    return value;
}
function $6bd4955d3d75cba1$var$parse(query, options) {
    options = Object.assign({
        decode: true,
        sort: true,
        arrayFormat: 'none',
        arrayFormatSeparator: ',',
        parseNumbers: false,
        parseBooleans: false
    }, options);
    $6bd4955d3d75cba1$var$validateArrayFormatSeparator(options.arrayFormatSeparator);
    const formatter = $6bd4955d3d75cba1$var$parserForArrayFormat(options);
    // Create an object with no prototype
    const ret = Object.create(null);
    if (typeof query !== 'string') return ret;
    query = query.trim().replace(/^[?#&]/, '');
    if (!query) return ret;
    for (const param of query.split('&')){
        if (param === '') continue;
        let [key, value] = $l4Qn0(options.decode ? param.replace(/\+/g, ' ') : param, '=');
        // Missing `=` should be `null`:
        // http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
        value = value === undefined ? null : [
            'comma',
            'separator',
            'bracket-separator'
        ].includes(options.arrayFormat) ? value : $6bd4955d3d75cba1$var$decode(value, options);
        formatter($6bd4955d3d75cba1$var$decode(key, options), value, ret);
    }
    for (const key of Object.keys(ret)){
        const value = ret[key];
        if (typeof value === 'object' && value !== null) for (const k of Object.keys(value))value[k] = $6bd4955d3d75cba1$var$parseValue(value[k], options);
        else ret[key] = $6bd4955d3d75cba1$var$parseValue(value, options);
    }
    if (options.sort === false) return ret;
    return (options.sort === true ? Object.keys(ret).sort() : Object.keys(ret).sort(options.sort)).reduce((result, key)=>{
        const value = ret[key];
        if (Boolean(value) && typeof value === 'object' && !Array.isArray(value)) // Sort object keys, not values
        result[key] = $6bd4955d3d75cba1$var$keysSorter(value);
        else result[key] = value;
        return result;
    }, Object.create(null));
}
$6bd4955d3d75cba1$export$f9380c9a627682d3 = $6bd4955d3d75cba1$var$extract;
$6bd4955d3d75cba1$export$98e6a39c04603d36 = $6bd4955d3d75cba1$var$parse;
$6bd4955d3d75cba1$export$fac44ee5b035f737 = (object, options)=>{
    if (!object) return '';
    options = Object.assign({
        encode: true,
        strict: true,
        arrayFormat: 'none',
        arrayFormatSeparator: ','
    }, options);
    $6bd4955d3d75cba1$var$validateArrayFormatSeparator(options.arrayFormatSeparator);
    const shouldFilter = (key)=>options.skipNull && $6bd4955d3d75cba1$var$isNullOrUndefined(object[key]) || options.skipEmptyString && object[key] === '';
    const formatter = $6bd4955d3d75cba1$var$encoderForArrayFormat(options);
    const objectCopy = {};
    for (const key of Object.keys(object))if (!shouldFilter(key)) objectCopy[key] = object[key];
    const keys = Object.keys(objectCopy);
    if (options.sort !== false) keys.sort(options.sort);
    return keys.map((key)=>{
        const value = object[key];
        if (value === undefined) return '';
        if (value === null) return $6bd4955d3d75cba1$var$encode(key, options);
        if (Array.isArray(value)) {
            if (value.length === 0 && options.arrayFormat === 'bracket-separator') return $6bd4955d3d75cba1$var$encode(key, options) + '[]';
            return value.reduce(formatter(key), []).join('&');
        }
        return $6bd4955d3d75cba1$var$encode(key, options) + '=' + $6bd4955d3d75cba1$var$encode(value, options);
    }).filter((x)=>x.length > 0).join('&');
};
$6bd4955d3d75cba1$export$7a5253c0f62e0150 = (url, options)=>{
    options = Object.assign({
        decode: true
    }, options);
    const [url_, hash] = $l4Qn0(url, '#');
    return Object.assign({
        url: url_.split('?')[0] || '',
        query: $6bd4955d3d75cba1$var$parse($6bd4955d3d75cba1$var$extract(url), options)
    }, options && options.parseFragmentIdentifier && hash ? {
        fragmentIdentifier: $6bd4955d3d75cba1$var$decode(hash, options)
    } : {});
};
$6bd4955d3d75cba1$export$a8c1621ea79325d3 = (object, options)=>{
    options = Object.assign({
        encode: true,
        strict: true,
        [$6bd4955d3d75cba1$var$encodeFragmentIdentifier]: true
    }, options);
    const url = $6bd4955d3d75cba1$var$removeHash(object.url).split('?')[0] || '';
    const queryFromUrl = $6bd4955d3d75cba1$export$f9380c9a627682d3(object.url);
    const parsedQueryFromUrl = $6bd4955d3d75cba1$export$98e6a39c04603d36(queryFromUrl, {
        sort: false
    });
    const query = Object.assign(parsedQueryFromUrl, object.query);
    let queryString = $6bd4955d3d75cba1$export$fac44ee5b035f737(query, options);
    if (queryString) queryString = `?${queryString}`;
    let hash = $6bd4955d3d75cba1$var$getHash(object.url);
    if (object.fragmentIdentifier) hash = `#${options[$6bd4955d3d75cba1$var$encodeFragmentIdentifier] ? $6bd4955d3d75cba1$var$encode(object.fragmentIdentifier, options) : object.fragmentIdentifier}`;
    return `${url}${queryString}${hash}`;
};
$6bd4955d3d75cba1$export$357523c63a2253b9 = (input, filter, options)=>{
    options = Object.assign({
        parseFragmentIdentifier: true,
        [$6bd4955d3d75cba1$var$encodeFragmentIdentifier]: false
    }, options);
    const { url: url, query: query, fragmentIdentifier: fragmentIdentifier } = $6bd4955d3d75cba1$export$7a5253c0f62e0150(input, options);
    return $6bd4955d3d75cba1$export$a8c1621ea79325d3({
        url: url,
        query: $9PyLY(query, filter),
        fragmentIdentifier: fragmentIdentifier
    }, options);
};
$6bd4955d3d75cba1$export$44c361b8ec72ef7f = (input, filter, options)=>{
    const exclusionFilter = Array.isArray(filter) ? (key)=>!filter.includes(key) : (key, value)=>!filter(key, value);
    return $6bd4955d3d75cba1$export$357523c63a2253b9(input, exclusionFilter, options);
};

});



parcelRegister("5ocp8", function(module, exports) {
$parcel$export(module.exports, "selectHost", () => $3ec8d0e634426cf0$export$18c0b81944902eae);

var $iVpQc = parcelRequire("iVpQc");
const $3ec8d0e634426cf0$var$PROD_HOST = 'as.atlassian.com/api/v1';
const $3ec8d0e634426cf0$var$STARGATE_PROD_HOST = 'api-private.atlassian.com/gasv3/api/v1';
const $3ec8d0e634426cf0$var$STAGING_HOST = 'as.staging.atl-paas.net/api/v1';
const $3ec8d0e634426cf0$var$STARGATE_STAGING_HOST = 'api-private.stg.atlassian.com/gasv3/api/v1';
const $3ec8d0e634426cf0$var$FEDRAMP_STAGING_HOST = 'as.staging.atl-paas-us-gov-mod.net/api/v1';
const $3ec8d0e634426cf0$var$FEDRAMP_PROD_HOST = 'as.atlassian-us-gov-mod.com/api/v1';
const $3ec8d0e634426cf0$var$STARGATE_FEDRAMP_STAGING_HOST = 'api.stg.atlassian-us-gov-mod.com/gasv3/api/v1';
const $3ec8d0e634426cf0$var$STARGATE_FEDRAMP_PROD_HOST = 'api.atlassian-us-gov-mod.com/gasv3/api/v1';
const $3ec8d0e634426cf0$var$STARGATE_PROXY_PATH = '/gateway/api/gasv3/api/v1';
const $3ec8d0e634426cf0$var$handleFedRampStagingDirect = ()=>{
    return $3ec8d0e634426cf0$var$FEDRAMP_STAGING_HOST;
};
const $3ec8d0e634426cf0$var$handleFedRampStagingStargate = ()=>{
    return $3ec8d0e634426cf0$var$STARGATE_FEDRAMP_STAGING_HOST;
};
const $3ec8d0e634426cf0$var$handleFedRampModerate = ({ useStargate: useStargate, env: env, useLegacyUrl: useLegacyUrl, envOverride: envOverride })=>{
    if (env === (0, $iVpQc.envType).LOCAL || env === (0, $iVpQc.envType).DEV) throw Error('No LOCAL or DEV environments for FedRAMP.');
    if (env === (0, $iVpQc.envType).PROD && envOverride) throw Error('Cannot override to FedRAMP Sandbox for Prod.');
    if (!useStargate) return env === (0, $iVpQc.envType).PROD ? $3ec8d0e634426cf0$var$FEDRAMP_PROD_HOST : $3ec8d0e634426cf0$var$handleFedRampStagingDirect();
    if (useLegacyUrl) return env === (0, $iVpQc.envType).PROD ? $3ec8d0e634426cf0$var$STARGATE_FEDRAMP_PROD_HOST : $3ec8d0e634426cf0$var$handleFedRampStagingStargate();
    /**
   * Stargate proxy path now needs to be the default to work around browser restrictions with cookies.
   * For more details, see:
   *  - https://experimentation-platform.atlassian.net/browse/MHD-326, and
   *  - https://hello.atlassian.net/wiki/spaces/I/pages/1217206437/api-private+is+broken+is+your+product+impacted
   */ return window.location.host + $3ec8d0e634426cf0$var$STARGATE_PROXY_PATH;
};
const $3ec8d0e634426cf0$var$handleCommercial = ({ useStargate: useStargate, env: env, useLegacyUrl: useLegacyUrl })=>{
    if (!useStargate) return env === (0, $iVpQc.envType).PROD ? $3ec8d0e634426cf0$var$PROD_HOST : $3ec8d0e634426cf0$var$STAGING_HOST;
    if (useLegacyUrl) return env === (0, $iVpQc.envType).PROD ? $3ec8d0e634426cf0$var$STARGATE_PROD_HOST : $3ec8d0e634426cf0$var$STARGATE_STAGING_HOST;
    /**
   * Stargate proxy path now needs to be the default to work around browser restrictions with cookies.
   * For more details, see:
   *  - https://experimentation-platform.atlassian.net/browse/MHD-326, and
   *  - https://hello.atlassian.net/wiki/spaces/I/pages/1217206437/api-private+is+broken+is+your+product+impacted
   */ return window.location.host + $3ec8d0e634426cf0$var$STARGATE_PROXY_PATH;
};
function $3ec8d0e634426cf0$export$18c0b81944902eae({ useStargate: useStargate, env: env, useLegacyUrl: useLegacyUrl, perimeter: perimeter, envOverride: envOverride }) {
    if (perimeter === (0, $iVpQc.perimeterType).FEDRAMP_MODERATE) return $3ec8d0e634426cf0$var$handleFedRampModerate({
        useStargate: useStargate,
        env: env,
        useLegacyUrl: useLegacyUrl,
        envOverride: envOverride
    });
    return $3ec8d0e634426cf0$var$handleCommercial({
        useStargate: useStargate,
        env: env,
        useLegacyUrl: useLegacyUrl
    });
}

});

parcelRegister("fXo9B", function(module, exports) {
$parcel$export(module.exports, "default", () => $b9df1a2a6dfc144a$export$2e2bcd8739ae039);

var $25nEq = parcelRequire("25nEq");

var $hqn4q = parcelRequire("hqn4q");
const $b9df1a2a6dfc144a$var$SESSION_ID_STORAGE_KEY = 'session.id';
const $b9df1a2a6dfc144a$var$SESSION_EXPIRY_STORAGE_KEY = 'session.expiry';
const $b9df1a2a6dfc144a$var$ONLY_NUMBERS_REGEX = /^\d+$/;
const $b9df1a2a6dfc144a$export$285f6bddd927a06d = 1800000; // 30 minutes
const $b9df1a2a6dfc144a$export$a92e915d70316eb2 = 5000; // 5 seconds
const $b9df1a2a6dfc144a$export$de43760b2dc10c19 = 0.9; // 90% of expiry
const $b9df1a2a6dfc144a$export$5702a91a6f42969f = ()=>{};
class $b9df1a2a6dfc144a$export$2e2bcd8739ae039 {
    constructor(options = {}){
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "_generateNewSessionId", ()=>{
            const newSessionId = Date.now().toString();
            this._safeLocalStorage.setItem($b9df1a2a6dfc144a$var$SESSION_ID_STORAGE_KEY, newSessionId);
            // COMMENTS-123 - When a new session starts, call the callback if it is given
            this._onNewSessionStarted && this._onNewSessionStarted();
            return newSessionId;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "_updateSessionExpiry", ()=>{
            const expiry = Date.now() + this._sessionExpiryTime;
            this._safeLocalStorage.setItem($b9df1a2a6dfc144a$var$SESSION_EXPIRY_STORAGE_KEY, expiry.toString());
            return expiry;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "_debouncedUpdateSessionExpiry", (currentExpiry)=>{
            const { _updateSessionExpiry: _updateSessionExpiry } = this;
            // If the current expiry is out of date by more than 10% of the expiry, update immediately
            if (currentExpiry < Date.now() + this._sessionExpiryDebounceThresholdPercentage * this._sessionExpiryTime) return _updateSessionExpiry();
            else {
                if (this._sessionExpiryDebounceTimer) clearTimeout(this._sessionExpiryDebounceTimer);
                // @ts-ignore Something wrong with our types... this is legit
                this._sessionExpiryDebounceTimer = setTimeout(()=>{
                    _updateSessionExpiry();
                }, this._sessionExpiryDebounce);
            }
        });
        this._sessionExpiryTime = options.sessionExpiryTime || $b9df1a2a6dfc144a$export$285f6bddd927a06d;
        this._sessionExpiryDebounce = options.sessionExpiryDebounce || $b9df1a2a6dfc144a$export$a92e915d70316eb2;
        this._sessionExpiryDebounceThresholdPercentage = options.sessionExpiryDebounceThresholdPercentage || $b9df1a2a6dfc144a$export$de43760b2dc10c19;
        this._onNewSessionStarted = options.onNewSessionStarted ? options.onNewSessionStarted : $b9df1a2a6dfc144a$export$5702a91a6f42969f;
        this._safeLocalStorage = new (0, $hqn4q.default)();
    }
    getCurrentSessionId() {
        const sessionId = this._safeLocalStorage.getItem($b9df1a2a6dfc144a$var$SESSION_ID_STORAGE_KEY);
        const sessionExpiry = parseInt(this._safeLocalStorage.getItem($b9df1a2a6dfc144a$var$SESSION_EXPIRY_STORAGE_KEY) || '0', 10) || 0;
        this._debouncedUpdateSessionExpiry(sessionExpiry);
        if (!sessionId || sessionExpiry <= Date.now() || Number.isNaN(sessionExpiry)) return this._generateNewSessionId();
        // Old versions of sessionId were UUIDs which caused issues for Amplitude which only accepts
        // integers for this field. In these scenarios we want to regenerate the sessionId as an integer
        if (!$b9df1a2a6dfc144a$var$ONLY_NUMBERS_REGEX.test(sessionId)) return this._generateNewSessionId();
        return sessionId;
    }
}

});

parcelRegister("8xdZA", function(module, exports) {
$parcel$export(module.exports, "default", () => $636c426458db307a$export$2e2bcd8739ae039);

var $45wGM = parcelRequire("45wGM");

var $hh2HV = parcelRequire("hh2HV");
class $636c426458db307a$export$2e2bcd8739ae039 extends (0, $hh2HV.default) {
    constructor(options){
        let storageToUse;
        try {
            storageToUse = window.sessionStorage || (0, $45wGM.default);
        } catch (err) {
            storageToUse = (0, $45wGM.default);
        }
        super(storageToUse, options);
    }
}

});

parcelRegister("iY1fJ", function(module, exports) {
$parcel$export(module.exports, "default", () => $dceecd5ba44d1d63$export$2e2bcd8739ae039);

var $25nEq = parcelRequire("25nEq");

var $6JfQX = parcelRequire("6JfQX");

var $8xdZA = parcelRequire("8xdZA");
const $dceecd5ba44d1d63$var$STORAGE_KEY = 'tab.id';
class $dceecd5ba44d1d63$export$2e2bcd8739ae039 {
    constructor(){
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "_generateNewTabId", ()=>{
            const newTabId = (0, $6JfQX.default)();
            this._safeSessionStorage.setItem($dceecd5ba44d1d63$var$STORAGE_KEY, newTabId);
            return newTabId;
        });
        this._safeSessionStorage = new (0, $8xdZA.default)();
    }
    getCurrentTabId() {
        let tabId = this._safeSessionStorage.getItem($dceecd5ba44d1d63$var$STORAGE_KEY);
        if (!tabId) tabId = this._generateNewTabId();
        return tabId;
    }
}

});

parcelRegister("jKAaS", function(module, exports) {
$parcel$export(module.exports, "default", () => $e60e5fb1692e2f03$export$2e2bcd8739ae039);

var $25nEq = parcelRequire("25nEq");

var $9fYGa = parcelRequire("9fYGa");

var $6JfQX = parcelRequire("6JfQX");

var $iVpQc = parcelRequire("iVpQc");

var $JnB9d = parcelRequire("JnB9d");

var $8xdZA = parcelRequire("8xdZA");

var $6W7Sk = parcelRequire("6W7Sk");
function $e60e5fb1692e2f03$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $e60e5fb1692e2f03$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $e60e5fb1692e2f03$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $e60e5fb1692e2f03$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
const $e60e5fb1692e2f03$var$STORAGE_KEY = 'taskSessions';
const $e60e5fb1692e2f03$var$INIT_KEY = 'taskSessionsInit';
const $e60e5fb1692e2f03$var$AWC_PARAM_PREFIX = 'awc.';
const $e60e5fb1692e2f03$var$TASK_SESSION_RELOAD_TIME = 3000;
class $e60e5fb1692e2f03$export$2e2bcd8739ae039 {
    constructor(){
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "_taskSessionsNotRecentlyInitialised", (currentTimestamp)=>this._safeSessionStorage.getItem($e60e5fb1692e2f03$var$STORAGE_KEY) === null || this._safeSessionStorage.getItem($e60e5fb1692e2f03$var$INIT_KEY) === null || parseInt(this._safeSessionStorage.getItem($e60e5fb1692e2f03$var$INIT_KEY) || '0', 10) < currentTimestamp - $e60e5fb1692e2f03$var$TASK_SESSION_RELOAD_TIME);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "_removeTaskSessionPrefix", (_, taskSessionName)=>taskSessionName.split($e60e5fb1692e2f03$var$AWC_PARAM_PREFIX)[1]);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "_isTaskSessionQueryParam", (_, taskSessionName)=>taskSessionName.startsWith($e60e5fb1692e2f03$var$AWC_PARAM_PREFIX));
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "getAllTaskSessions", ()=>{
            try {
                return JSON.parse(this._safeSessionStorage.getItem($e60e5fb1692e2f03$var$STORAGE_KEY) || '');
            } catch (e) {
                return {};
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "_writeToSessionStorage", (taskSessions)=>{
            try {
                this._safeSessionStorage.setItem($e60e5fb1692e2f03$var$STORAGE_KEY, JSON.stringify(taskSessions));
            // eslint-disable-next-line no-empty
            } catch (e) {}
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "_appendTaskSessions", (newTaskSessions)=>{
            const currentState = this.getAllTaskSessions();
            const newState = currentState === null ? newTaskSessions : Object.assign(currentState, newTaskSessions);
            this._writeToSessionStorage(newState);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "_safelyRemoveKey", (currentState, taskSessionName)=>{
            if (currentState === null) return {};
            delete currentState[taskSessionName];
            return currentState;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "createTaskSession", (taskSessionName)=>{
            const taskSessionId = (0, $6JfQX.default)();
            const newTaskSessions = {};
            newTaskSessions[taskSessionName] = taskSessionId;
            this._appendTaskSessions(newTaskSessions);
            return taskSessionId;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "createTaskSessionWithProvidedId", (taskSessionName, taskSessionId)=>{
            if (typeof taskSessionId !== 'string') throw new TypeError('invalid taskSessionId, must be string');
            const newTaskSessions = {};
            newTaskSessions[taskSessionName] = taskSessionId;
            this._appendTaskSessions(newTaskSessions);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "completeTaskSession", (taskSessionName)=>{
            const currentState = this.getAllTaskSessions();
            const updatedState = this._safelyRemoveKey(currentState, taskSessionName);
            this._writeToSessionStorage(updatedState);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "formatTaskSessionQueryString", ({ uri: uri, includedTaskSessions: includedTaskSessions })=>{
            const { url: url, query: query } = (0, $9fYGa.parseUrl)(uri);
            const currentState = this.getAllTaskSessions();
            // Use specified task sessions, otherwise all tasksessions excluding originTracing sessions
            const filteredTaskSessions = includedTaskSessions ? (0, $JnB9d.pick)(currentState, includedTaskSessions) : (0, $JnB9d.omit)(currentState, Object.values((0, $iVpQc.originTracingType)));
            if (Object.keys(filteredTaskSessions).length === 0) return uri;
            const queryWithTaskSessions = $e60e5fb1692e2f03$var$_objectSpread($e60e5fb1692e2f03$var$_objectSpread({}, (0, $JnB9d.mapKeys)(filteredTaskSessions, (_, taskSessionName)=>$e60e5fb1692e2f03$var$AWC_PARAM_PREFIX + taskSessionName)), query);
            return `${url}?${(0, $9fYGa.stringify)(queryWithTaskSessions)}`;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "stripQueryParameters", ()=>{
            const extractedTaskSessions = (0, $JnB9d.mapKeys)((0, $6W7Sk.default)(this._isTaskSessionQueryParam), this._removeTaskSessionPrefix);
            this._appendTaskSessions(extractedTaskSessions);
        });
        const _currentTimestamp = Date.now();
        this._safeSessionStorage = new (0, $8xdZA.default)();
        // Wrapping all sessionStorage calls in try catch to stop any error propogation, taskSessions should gracefully fail.
        try {
            if (this._taskSessionsNotRecentlyInitialised(_currentTimestamp)) {
                this._writeToSessionStorage({});
                this._safeSessionStorage.setItem($e60e5fb1692e2f03$var$INIT_KEY, _currentTimestamp.toString());
            }
        // eslint-disable-next-line no-empty
        } catch (e) {}
    }
}

});

parcelRegister("ec3mM", function(module, exports) {
$parcel$export(module.exports, "default", () => $a554cc30c572a317$export$2e2bcd8739ae039);

var $25nEq = parcelRequire("25nEq");

var $bDLqY = parcelRequire("bDLqY");

var $kwVVh = parcelRequire("kwVVh");
const $a554cc30c572a317$var$MAX_CACHE_SIZE = 100;
const $a554cc30c572a317$var$COOKIE_NAME = (0, $kwVVh.AllAnalyticsCookies).AWC_ANALYTICS_DEBUG.getKey();
const $a554cc30c572a317$var$DEBUG_TAG = 'synthetic';
const $a554cc30c572a317$var$getDebugCookie = ()=>{
    try {
        return JSON.parse((0, (/*@__PURE__*/$parcel$interopDefault($bDLqY))).get($a554cc30c572a317$var$COOKIE_NAME) || 'false');
    } catch (error) {
        (0, (/*@__PURE__*/$parcel$interopDefault($bDLqY))).remove($a554cc30c572a317$var$COOKIE_NAME);
    }
    return false;
};
class $a554cc30c572a317$var$TestingCache {
    constructor(){
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "_bind", ()=>{
            if (typeof window === 'undefined' || window.testAnalytics) return;
            window.testAnalytics = {
                eventCache: [],
                events: ()=>window.testAnalytics.eventCache,
                clear: ()=>{
                    window.testAnalytics.eventCache = [];
                    try {
                        localStorage.removeItem('awc.ui.viewed.last.sent');
                        localStorage.removeItem('awc-staging.ui.viewed.last.sent');
                        localStorage.removeItem('awc-dev.ui.viewed.last.sent');
                        localStorage.removeItem('awc-local.ui.viewed.last.sent');
                    } catch (_error) {
                    // Ignore errors from localStorage.
                    }
                }
            };
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "_cache", (event)=>{
            if (typeof window === 'undefined') return;
            if (window.testAnalytics.eventCache.length >= $a554cc30c572a317$var$MAX_CACHE_SIZE) window.testAnalytics.eventCache = window.testAnalytics.eventCache.slice(1, window.testAnalytics.eventCache.length);
            window.testAnalytics.eventCache.push(event);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "_shouldCacheEvent", ()=>this._isDebugCookieEnabled);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "saveEvent", (event)=>{
            if (event && this._shouldCacheEvent()) {
                if (!window.testAnalytics) this._bind();
                if (event.tags instanceof Array) event.tags.push($a554cc30c572a317$var$DEBUG_TAG);
                else event.tags = [
                    $a554cc30c572a317$var$DEBUG_TAG
                ];
                this._cache(event);
            }
        });
        this._isDebugCookieEnabled = $a554cc30c572a317$var$getDebugCookie();
        if (this._isDebugCookieEnabled) this._bind();
    }
}
var $a554cc30c572a317$export$2e2bcd8739ae039 = $a554cc30c572a317$var$TestingCache;

});

parcelRegister("jx7KB", function(module, exports) {
$parcel$export(module.exports, "default", () => $e3871c80d64e837e$export$2e2bcd8739ae039);

var $1Vcia = parcelRequire("1Vcia");

var $25nEq = parcelRequire("25nEq");

var $iVpQc = parcelRequire("iVpQc");

var $hqn4q = parcelRequire("hqn4q");
const $e3871c80d64e837e$var$_excluded = [
    "embeddedProduct"
];
function $e3871c80d64e837e$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $e3871c80d64e837e$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $e3871c80d64e837e$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $e3871c80d64e837e$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
const $e3871c80d64e837e$var$DEFAULT_DELAY = 2000; // 2 seconds
const $e3871c80d64e837e$var$DEFAULT_THROTTLE = 3600000; // 1 hour
const $e3871c80d64e837e$var$DEFAULT_STORAGE_KEY = 'ui.viewed.last.sent';
class $e3871c80d64e837e$export$2e2bcd8739ae039 {
    constructor(productInfo, getContext, onEvent, settings = {}){
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "start", ()=>{
            this._startInterval();
            this._bindEventListeners();
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "stop", ()=>{
            this._stopInterval();
            this._unbindEventListeners();
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "resetTimers", ()=>{
            if (this._intervalId) {
                this.stop();
                this.start();
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "_bindEventListeners", ()=>{
            if (typeof window !== 'undefined') {
                window.addEventListener('focus', this._focusListener);
                window.addEventListener('blur', this._blurListener);
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "_unbindEventListeners", ()=>{
            if (typeof window !== 'undefined') {
                window.removeEventListener('focus', this._focusListener);
                window.removeEventListener('blur', this._blurListener);
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "_startInterval", ()=>{
            clearInterval(this._intervalId);
            this._intervalId = setInterval(this._handleInterval, this._delay);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "_stopInterval", ()=>{
            if (this._intervalId) {
                clearInterval(this._intervalId);
                this._intervalId = null;
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "_getProductKey", (product, subproduct)=>{
            let productKey = product;
            if (subproduct) productKey += `-${subproduct}`;
            return productKey;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "_getLastSentTimestamp", (productKey, tenantId, userId)=>{
            const json = this._parseLocalStorageData() || {};
            const u = json[userId] || {};
            const t = u[tenantId] || {};
            const p = t[productKey] || null;
            return p;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "_parseLocalStorageData", ()=>{
            const data = this._safeLocalStorage.getItem(this._storageKey);
            try {
                return JSON.parse(data || '');
            } catch (error) {
                this._safeLocalStorage.removeItem(this._storageKey);
                return null;
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "_setLastSentTimestamp", (productKey, tenantId, userId)=>{
            const json = this._parseLocalStorageData() || {};
            const u = json[userId] || {};
            const t = u[tenantId] || {};
            t[productKey] = Date.now();
            u[tenantId] = t;
            json[userId] = u;
            this._safeLocalStorage.setItem(this._storageKey, JSON.stringify(json));
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "_shouldSendEvent", (productKey, tenantIdType, tenantId, userId)=>{
            if (!document.hasFocus()) return false;
            if (tenantIdType !== (0, $iVpQc.tenantType).NONE && !tenantId || !userId) return false;
            const sinceLastSent = Date.now() - this._getLastSentTimestamp(productKey, tenantId, userId);
            return sinceLastSent > this._throttle;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "_handleInterval", ()=>{
            const _this$_getContext = this._getContext(), { embeddedProduct: embeddedProduct } = _this$_getContext, context = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_this$_getContext, $e3871c80d64e837e$var$_excluded);
            this._sendEvent(this._product, context);
            if (embeddedProduct) this._sendEvent(embeddedProduct, context, true);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "_sendEvent", (product, context, isEmbeddedProduct = false)=>{
            const { subproduct: subproduct, tenantIdType: tenantIdType, tenantId: tenantId, userId: userId, lastScreenEvent: lastScreenEvent, attributes: attributes } = context;
            const productKey = this._getProductKey(product, subproduct);
            if (this._shouldSendEvent(productKey, tenantIdType, tenantId, userId)) {
                this._setLastSentTimestamp(productKey, tenantId, userId);
                const event = this._createEvent(product, subproduct, isEmbeddedProduct, lastScreenEvent, attributes);
                this._onEvent(event);
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "_createEvent", (product, subproduct, isEmbeddedProduct, lastScreenEvent, extraAttributes)=>{
            const event = {
                product: product,
                source: 'ui',
                action: 'viewed',
                actionSubject: 'ui',
                attributes: extraAttributes
            };
            if (isEmbeddedProduct) {
                // Clear the subproduct and version as they don't relate to the embedded product
                event.subproduct = null;
                event.version = null;
                event.attributes = $e3871c80d64e837e$var$_objectSpread($e3871c80d64e837e$var$_objectSpread({}, event.attributes), {}, {
                    embeddedInEnv: this._productInfo.env,
                    embeddedInProduct: this._productInfo.product,
                    embeddedInSubproduct: subproduct,
                    embeddedInVersion: this._productInfo.version,
                    embeddedInOrigin: this._productInfo.origin,
                    embeddedInPlatform: this._productInfo.platform
                });
            }
            if (lastScreenEvent) event.attributes = $e3871c80d64e837e$var$_objectSpread($e3871c80d64e837e$var$_objectSpread({}, event.attributes), {}, {
                lastScreenEvent: {
                    name: lastScreenEvent.name,
                    attributes: lastScreenEvent.attributes
                }
            });
            return event;
        });
        if (!productInfo) throw new Error('Missing productInfo');
        if (!productInfo.product) throw new Error('Missing productInfo.product');
        if (!getContext) throw new Error('Missing getContext callback');
        if (typeof getContext !== 'function') throw new Error('Invalid getContext, must be function');
        if (!onEvent) throw new Error('Missing onEvent callback');
        if (typeof onEvent !== 'function') throw new Error('Invalid onEvent, must be function');
        this._productInfo = productInfo;
        this._product = productInfo.product;
        this._getContext = getContext;
        this._onEvent = onEvent;
        this._delay = settings.delay || $e3871c80d64e837e$var$DEFAULT_DELAY;
        this._throttle = settings.throttle || $e3871c80d64e837e$var$DEFAULT_THROTTLE;
        this._storageKey = settings.storageKey || $e3871c80d64e837e$var$DEFAULT_STORAGE_KEY;
        this._safeLocalStorage = new (0, $hqn4q.default)({
            envPrefix: this._productInfo.env
        });
        this._focusListener = ()=>{
            this._startInterval();
        };
        this._blurListener = ()=>{
            this._stopInterval();
        };
    }
}

});

parcelRegister("buh9e", function(module, exports) {
$parcel$export(module.exports, "default", () => $85cfcc438f3daf60$export$2e2bcd8739ae039);
function $85cfcc438f3daf60$export$2e2bcd8739ae039(callback, event) {
    if (!callback || typeof callback !== 'function') return null;
    return ()=>{
        callback(event);
    };
}

});

parcelRegister("3Vdyi", function(module, exports) {
$parcel$export(module.exports, "XIDPromise", () => $2db135269885c00d$export$fbe53bbbe682bcdd);

var $kz0Y7 = parcelRequire("kz0Y7");
const $2db135269885c00d$export$fbe53bbbe682bcdd = (xidConsent, xidPromiseFn)=>{
    if (xidConsent && xidPromiseFn && typeof xidPromiseFn === 'function') {
        const timeoutPromise = ()=>{
            return new Promise((resolve)=>{
                setTimeout(()=>resolve(()=>(0, $kz0Y7.createTimeoutXid)()), (0, $kz0Y7.XID_TIMEOUT));
            });
        };
        const xidPromise = ()=>{
            return xidPromiseFn().catch(()=>()=>(0, $kz0Y7.createUnknownXid)());
        };
        return Promise.race([
            xidPromise(),
            timeoutPromise()
        ]);
    }
    return undefined;
};

});
parcelRegister("kz0Y7", function(module, exports) {
$parcel$export(module.exports, "XID_TIMEOUT", () => $ef87d3e2b05a3657$export$545bcbd53afabfa3);
$parcel$export(module.exports, "createTimeoutXid", () => $ef87d3e2b05a3657$export$af4087e36d63846);
$parcel$export(module.exports, "createUnknownXid", () => $ef87d3e2b05a3657$export$fa341d0c750d705b);

var $h9RIa = parcelRequire("h9RIa");
const $ef87d3e2b05a3657$export$545bcbd53afabfa3 = 5000;
const $ef87d3e2b05a3657$export$af4087e36d63846 = ()=>[
        {
            type: (0, $h9RIa.XIDItemType).XC,
            state: 'TIMEOUT'
        },
        {
            type: (0, $h9RIa.XIDItemType).UID,
            state: 'TIMEOUT'
        }
    ];
const $ef87d3e2b05a3657$export$fa341d0c750d705b = ()=>[
        {
            type: (0, $h9RIa.XIDItemType).XC,
            state: 'UNKNOWN'
        },
        {
            type: (0, $h9RIa.XIDItemType).UID,
            state: 'UNKNOWN'
        }
    ];

});
parcelRegister("h9RIa", function(module, exports) {
$parcel$export(module.exports, "XIDItemType", () => $c7dcf0e056c92374$export$92ca0438bcb0d396);
let $c7dcf0e056c92374$export$92ca0438bcb0d396 = /*#__PURE__*/ function(XIDItemType) {
    XIDItemType["XC"] = "xc";
    XIDItemType["UID"] = "uid";
    return XIDItemType;
}({});
let $c7dcf0e056c92374$export$c9079017d1f5aab9 = /*#__PURE__*/ function(XIDState) {
    XIDState["NEW"] = "NEW";
    XIDState["CHANGED"] = "CHANGED";
    XIDState["EXISTING"] = "EXISTING";
    XIDState["TIMEOUT"] = "TIMEOUT";
    XIDState["ERROR"] = "ERROR";
    XIDState["UNAVAILABLE"] = "UNAVAILABLE";
    XIDState["MALFORMED"] = "MALFORMED";
    XIDState["UNKNOWN"] = "UNKNOWN";
    return XIDState;
}({});

});




parcelRegister("4IOyp", function(module, exports) {
$parcel$export(module.exports, "default", () => $37027c7001d3cc25$export$2e2bcd8739ae039);

var $25nEq = parcelRequire("25nEq");

var $2HsPW = parcelRequire("2HsPW");

var $8t1l5 = parcelRequire("8t1l5");
function $37027c7001d3cc25$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $37027c7001d3cc25$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $37027c7001d3cc25$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $37027c7001d3cc25$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
const $37027c7001d3cc25$var$DEFAULT_TIMING = {
    initialPollInterval: 5,
    pollBackoffRate: 2,
    idleTimeout: 30
};
class $37027c7001d3cc25$export$2e2bcd8739ae039 {
    /**
   * Callback for sending a 'track' analytics event. This callback should either be the
   * 'sendTrackEvent' method on the AnalyticsWebClient, or a method that eventually delegates to it.
   * The data for the dwell event will be passed to this method for sending.
   *
   * @callback trackCallback
   * @param {Object} eventData - the base event data that will be added to the track event.
   */ /**
   * Creates and initialises the DwellTimeHelper.
   *
   * @param {trackCallback} trackCallback - the track callback responsible for actually sending
   * the event.
   * @param {Object} eventData - the base data that will be added to the track event.
   * Additional dwell time attributes will be appended to this data. Note that you don't need to
   * include the 'action' property, as this will be added automatically.
   * @param {?string} searchSessionId - a unique identifier for the related search session.
   * @param {?Object} timingOptions - for the purpose of debugging, you can override the default
   * timing used for measuring dwell time. The following values are possible:
   * - initialPollInterval: how long to wait before the first dwell milestone event
   * is fired (in seconds). Default = 5.
   * - pollBackoffRate: how much to multiply the last poll interval by on each dwell milestone.
   * event. Default = 2.
   * - idleTimeout: how long to wait for no user activity before pausing
   * the dwell timer (in seconds). Default = 30s.
   * @param {?DwellTimeHelperOptions} dwellTimeHelperOptions - options provided to customise behaviour
   * of the helper.
   * - iframeDwell = enable detection of activity in iframes.
   */ constructor(trackCallback, _eventData, _searchSessionId, timingOptions, dwellTimeHelperOptions){
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "timeMeInitialized", false);
        /**
     * Starts the dwell timer. This method should be called upon the initial page load.
     */ (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "start", ()=>{
            if (this.timeMeInitialized) throw new Error('DwellTimeHelper should only be initialised once per page load.');
            this.timeMeInitialized = true;
            this._initDwellTimeCounterAndPolling();
            if (typeof window !== 'undefined') window.addEventListener('beforeunload', ()=>{
                this.stop();
            });
        });
        /**
     * Stops the dwell timer and sends the final dwell event. Call this method if you wish to
     * finalise a dwell measurement without starting a new one. When switching to a new page in a
     * single-page app, use newPage instead.
     */ (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "stop", ()=>{
            if ((0, (/*@__PURE__*/$parcel$interopDefault($2HsPW))).isUserCurrentlyOnPage) this._sendDwellEvent(this._eventData, this._searchSessionId, true);
            (0, (/*@__PURE__*/$parcel$interopDefault($2HsPW))).stopAllTimers();
            (0, (/*@__PURE__*/$parcel$interopDefault($2HsPW))).resetAllRecordedPageTimes();
            (0, (/*@__PURE__*/$parcel$interopDefault($2HsPW))).timeElapsedCallbacks = [];
            this.timeMeInitialized = false;
        });
        /**
     * Send the final dwell event and reinitialise the dwell timer for a new page.
     * This method should be called whenever a new page is switched to in a single-page app context.
     *
     * @param {Object} eventData - the base data that will be added to the track event.
     * @param {?string} searchSessionId - the new search session ID.
     */ (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "newPage", (eventData, searchSessionId)=>{
            (0, $8t1l5.validateDwellBaseEvent)(eventData);
            this.stop();
            this._eventData = eventData;
            this._searchSessionId = searchSessionId;
            this._initDwellTimeCounterAndPolling();
        });
        /**
     * This is a modified version of timeit's original listForIdleEvents function,
     * which also listens to events inside same-origin iframes (such as Confluence whiteboards and databases).
     * https://github.com/jasonzissman/TimeMe.js/blob/master/timeme.js#L338
     */ (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "_listForIdleEvents", ()=>{
            document.addEventListener('mousemove', ()=>{
                (0, (/*@__PURE__*/$parcel$interopDefault($2HsPW))).userActivityDetected();
            });
            document.addEventListener('keyup', ()=>{
                (0, (/*@__PURE__*/$parcel$interopDefault($2HsPW))).userActivityDetected();
            });
            document.addEventListener('touchstart', ()=>{
                (0, (/*@__PURE__*/$parcel$interopDefault($2HsPW))).userActivityDetected();
            });
            window.addEventListener('scroll', ()=>{
                (0, (/*@__PURE__*/$parcel$interopDefault($2HsPW))).userActivityDetected();
            });
            /**
       * Find all same origin iframes (same origin allow access to contentWindow.document)
       * and add event listeners to them too.
       */ const iframes = document.getElementsByTagName('iframe');
            for(let i = 0; i < iframes.length; i++){
                const iframe = iframes[i];
                try {
                    var _iframe$contentWindow, _iframe$contentWindow2, _iframe$contentWindow3;
                    iframe === null || iframe === void 0 || (_iframe$contentWindow = iframe.contentWindow) === null || _iframe$contentWindow === void 0 || _iframe$contentWindow.document.addEventListener('mousemove', ()=>{
                        (0, (/*@__PURE__*/$parcel$interopDefault($2HsPW))).userActivityDetected();
                    });
                    iframe === null || iframe === void 0 || (_iframe$contentWindow2 = iframe.contentWindow) === null || _iframe$contentWindow2 === void 0 || _iframe$contentWindow2.document.addEventListener('keyup', ()=>{
                        (0, (/*@__PURE__*/$parcel$interopDefault($2HsPW))).userActivityDetected();
                    });
                    iframe === null || iframe === void 0 || (_iframe$contentWindow3 = iframe.contentWindow) === null || _iframe$contentWindow3 === void 0 || _iframe$contentWindow3.document.addEventListener('touchstart', ()=>{
                        (0, (/*@__PURE__*/$parcel$interopDefault($2HsPW))).userActivityDetected();
                    });
                } catch (e) {
                // do nothing: We don't want to listen to cross-origin iframes
                }
            }
            setInterval(()=>{
                if ((0, (/*@__PURE__*/$parcel$interopDefault($2HsPW))).isUserCurrentlyIdle !== true) {
                    (0, (/*@__PURE__*/$parcel$interopDefault($2HsPW))).checkIdleState();
                    // This ensures the timer continues when switching between the iframe and the rest of the page
                    (0, (/*@__PURE__*/$parcel$interopDefault($2HsPW))).startTimer();
                }
            }, (0, (/*@__PURE__*/$parcel$interopDefault($2HsPW))).checkIdleStateRateMs);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "_initDwellTimeCounterAndPolling", ()=>{
            var _this$_dwellTimeHelpe;
            // If iframeDwell is enabled, override the listener for idle events to also listen to events in iframes.
            if ((_this$_dwellTimeHelpe = this._dwellTimeHelperOptions) !== null && _this$_dwellTimeHelpe !== void 0 && _this$_dwellTimeHelpe.iframeDwell) (0, (/*@__PURE__*/$parcel$interopDefault($2HsPW))).listForIdleEvents = this._listForIdleEvents;
            (0, (/*@__PURE__*/$parcel$interopDefault($2HsPW))).initialize({
                idleTimeoutInSeconds: this._timing.idleTimeout
            });
            this._pollDwellTime(this._timing.initialPollInterval, this._searchSessionId, this._eventData);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "_pollDwellTime", (pollTime, searchSessionId, eventData)=>{
            (0, (/*@__PURE__*/$parcel$interopDefault($2HsPW))).callAfterTimeElapsedInSeconds(pollTime, ()=>{
                this._sendDwellEvent(eventData, searchSessionId, false);
                this._pollDwellTime(pollTime * this._timing.pollBackoffRate, searchSessionId, eventData);
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "_sendDwellEvent", (eventData, searchSessionId, isFinalDwellEvent)=>{
            const dwellAttributes = {
                dwellTime: (0, (/*@__PURE__*/$parcel$interopDefault($2HsPW))).getTimeOnCurrentPageInMilliseconds(),
                searchReferrer: searchSessionId,
                finalDwellEvent: isFinalDwellEvent
            };
            this._trackCallback({
                action: 'dwelled',
                actionSubject: eventData.actionSubject,
                actionSubjectId: eventData.actionSubjectId,
                source: eventData.source,
                containerType: eventData.containerType,
                containerId: eventData.containerId,
                containers: eventData.containers,
                objectType: eventData.objectType,
                objectId: eventData.objectId,
                attributes: $37027c7001d3cc25$var$_objectSpread($37027c7001d3cc25$var$_objectSpread({}, dwellAttributes), eventData.attributes),
                tags: eventData.tags
            });
        });
        if (!trackCallback) throw new Error('trackCallback is required for DwellTimeHelper');
        (0, $8t1l5.validateDwellBaseEvent)(_eventData);
        this._trackCallback = trackCallback;
        this._eventData = _eventData;
        this._searchSessionId = _searchSessionId;
        this._timing = $37027c7001d3cc25$var$_objectSpread($37027c7001d3cc25$var$_objectSpread({}, $37027c7001d3cc25$var$DEFAULT_TIMING), timingOptions);
        this._dwellTimeHelperOptions = dwellTimeHelperOptions;
    }
}

});
parcelRegister("2HsPW", function(module, exports) {
/*Copyright (c) 2020 Jason Zissman
Permission is hereby granted, free of charge, to any person obtaining a copy of
this software and associated documentation files (the "Software"), to deal in
the Software without restriction, including without limitation the rights to
use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of
the Software, and to permit persons to whom the Software is furnished to do so,
subject to the following conditions:

The above copyright notice and this permission notice shall be included in all
copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS
FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR
COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER
IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN
CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
*/ (()=>{
    ((root, factory)=>{
        if (0, module.exports) // CommonJS
        return module.exports = factory();
        else if (typeof define === 'function' && define.amd) // AMD
        define([], ()=>{
            return root.TimeMe = factory();
        });
        else // Global Variables
        return root.TimeMe = factory();
    })(module.exports, ()=>{
        let TimeMe = {
            startStopTimes: {},
            idleTimeoutMs: 30000,
            currentIdleTimeMs: 0,
            checkIdleStateRateMs: 250,
            isUserCurrentlyOnPage: true,
            isUserCurrentlyIdle: false,
            currentPageName: "default-page-name",
            timeElapsedCallbacks: [],
            userLeftCallbacks: [],
            userReturnCallbacks: [],
            trackTimeOnElement: (elementId)=>{
                let element = document.getElementById(elementId);
                if (element) {
                    element.addEventListener("mouseover", ()=>{
                        TimeMe.startTimer(elementId);
                    });
                    element.addEventListener("mousemove", ()=>{
                        TimeMe.startTimer(elementId);
                    });
                    element.addEventListener("mouseleave", ()=>{
                        TimeMe.stopTimer(elementId);
                    });
                    element.addEventListener("keypress", ()=>{
                        TimeMe.startTimer(elementId);
                    });
                    element.addEventListener("focus", ()=>{
                        TimeMe.startTimer(elementId);
                    });
                }
            },
            getTimeOnElementInSeconds: (elementId)=>{
                let time = TimeMe.getTimeOnPageInSeconds(elementId);
                if (time) return time;
                else return 0;
            },
            // startTime is optional. If provided, must be of type Date(). By providing
            // startTime, you are overriding the internal timing mechanism and manually
            // indicating the start time.
            startTimer: (pageName, startTime)=>{
                if (!pageName) pageName = TimeMe.currentPageName;
                if (TimeMe.startStopTimes[pageName] === undefined) TimeMe.startStopTimes[pageName] = [];
                else {
                    let arrayOfTimes = TimeMe.startStopTimes[pageName];
                    let latestStartStopEntry = arrayOfTimes[arrayOfTimes.length - 1];
                    if (latestStartStopEntry !== undefined && latestStartStopEntry.stopTime === undefined) // Can't start new timer until previous finishes.
                    return;
                }
                TimeMe.startStopTimes[pageName].push({
                    "startTime": startTime || new Date(),
                    "stopTime": undefined
                });
            },
            stopAllTimers: ()=>{
                let pageNames = Object.keys(TimeMe.startStopTimes);
                for(let i = 0; i < pageNames.length; i++)TimeMe.stopTimer(pageNames[i]);
            },
            // stopTime is optional. If provided, must be of type Date(). By providing
            // stopTime, you are overriding the internal timing mechanism and manually
            // indicating the stop time.
            stopTimer: (pageName, stopTime)=>{
                if (!pageName) pageName = TimeMe.currentPageName;
                let arrayOfTimes = TimeMe.startStopTimes[pageName];
                if (arrayOfTimes === undefined || arrayOfTimes.length === 0) // Can't stop timer before you've started it.
                return;
                if (arrayOfTimes[arrayOfTimes.length - 1].stopTime === undefined) arrayOfTimes[arrayOfTimes.length - 1].stopTime = stopTime || new Date();
            },
            getTimeOnCurrentPageInSeconds: ()=>{
                return TimeMe.getTimeOnPageInSeconds(TimeMe.currentPageName);
            },
            getTimeOnPageInSeconds: (pageName)=>{
                let timeInMs = TimeMe.getTimeOnPageInMilliseconds(pageName);
                if (timeInMs === undefined) return undefined;
                else return timeInMs / 1000;
            },
            getTimeOnCurrentPageInMilliseconds: ()=>{
                return TimeMe.getTimeOnPageInMilliseconds(TimeMe.currentPageName);
            },
            getTimeOnPageInMilliseconds: (pageName)=>{
                let totalTimeOnPage = 0;
                let arrayOfTimes = TimeMe.startStopTimes[pageName];
                if (arrayOfTimes === undefined) // Can't get time on page before you've started the timer.
                return;
                let timeSpentOnPageInSeconds = 0;
                for(let i = 0; i < arrayOfTimes.length; i++){
                    let startTime = arrayOfTimes[i].startTime;
                    let stopTime = arrayOfTimes[i].stopTime;
                    if (stopTime === undefined) stopTime = new Date();
                    let difference = stopTime - startTime;
                    timeSpentOnPageInSeconds += difference;
                }
                totalTimeOnPage = Number(timeSpentOnPageInSeconds);
                return totalTimeOnPage;
            },
            getTimeOnAllPagesInSeconds: ()=>{
                let allTimes = [];
                let pageNames = Object.keys(TimeMe.startStopTimes);
                for(let i = 0; i < pageNames.length; i++){
                    let pageName = pageNames[i];
                    let timeOnPage = TimeMe.getTimeOnPageInSeconds(pageName);
                    allTimes.push({
                        "pageName": pageName,
                        "timeOnPage": timeOnPage
                    });
                }
                return allTimes;
            },
            setIdleDurationInSeconds: (duration)=>{
                let durationFloat = parseFloat(duration);
                if (isNaN(durationFloat) === false) TimeMe.idleTimeoutMs = duration * 1000;
                else throw {
                    name: "InvalidDurationException",
                    message: "An invalid duration time (" + duration + ") was provided."
                };
            },
            setCurrentPageName: (pageName)=>{
                TimeMe.currentPageName = pageName;
            },
            resetRecordedPageTime: (pageName)=>{
                delete TimeMe.startStopTimes[pageName];
            },
            resetAllRecordedPageTimes: ()=>{
                let pageNames = Object.keys(TimeMe.startStopTimes);
                for(let i = 0; i < pageNames.length; i++)TimeMe.resetRecordedPageTime(pageNames[i]);
            },
            userActivityDetected: ()=>{
                if (TimeMe.isUserCurrentlyIdle) TimeMe.triggerUserHasReturned();
                TimeMe.resetIdleCountdown();
            },
            resetIdleCountdown: ()=>{
                TimeMe.isUserCurrentlyIdle = false;
                TimeMe.currentIdleTimeMs = 0;
            },
            callWhenUserLeaves: (callback, numberOfTimesToInvoke)=>{
                TimeMe.userLeftCallbacks.push({
                    callback: callback,
                    numberOfTimesToInvoke: numberOfTimesToInvoke
                });
            },
            callWhenUserReturns: (callback, numberOfTimesToInvoke)=>{
                TimeMe.userReturnCallbacks.push({
                    callback: callback,
                    numberOfTimesToInvoke: numberOfTimesToInvoke
                });
            },
            triggerUserHasReturned: ()=>{
                if (!TimeMe.isUserCurrentlyOnPage) {
                    TimeMe.isUserCurrentlyOnPage = true;
                    TimeMe.resetIdleCountdown();
                    for(let i = 0; i < TimeMe.userReturnCallbacks.length; i++){
                        let userReturnedCallback = TimeMe.userReturnCallbacks[i];
                        let numberTimes = userReturnedCallback.numberOfTimesToInvoke;
                        if (isNaN(numberTimes) || numberTimes === undefined || numberTimes > 0) {
                            userReturnedCallback.numberOfTimesToInvoke -= 1;
                            userReturnedCallback.callback();
                        }
                    }
                }
                TimeMe.startTimer();
            },
            // TODO - we are muddying the waters in between
            // 'user left page' and 'user gone idle'. Really should be
            // two separate concepts entirely. Need to break this into smaller  functions
            // for either scenario.
            triggerUserHasLeftPageOrGoneIdle: ()=>{
                if (TimeMe.isUserCurrentlyOnPage) {
                    TimeMe.isUserCurrentlyOnPage = false;
                    for(let i = 0; i < TimeMe.userLeftCallbacks.length; i++){
                        let userHasLeftCallback = TimeMe.userLeftCallbacks[i];
                        let numberTimes = userHasLeftCallback.numberOfTimesToInvoke;
                        if (isNaN(numberTimes) || numberTimes === undefined || numberTimes > 0) {
                            userHasLeftCallback.numberOfTimesToInvoke -= 1;
                            userHasLeftCallback.callback();
                        }
                    }
                }
                TimeMe.stopAllTimers();
            },
            callAfterTimeElapsedInSeconds: (timeInSeconds, callback)=>{
                TimeMe.timeElapsedCallbacks.push({
                    timeInSeconds: timeInSeconds,
                    callback: callback,
                    pending: true
                });
            },
            checkIdleState: ()=>{
                for(let i = 0; i < TimeMe.timeElapsedCallbacks.length; i++)if (TimeMe.timeElapsedCallbacks[i].pending && TimeMe.getTimeOnCurrentPageInSeconds() > TimeMe.timeElapsedCallbacks[i].timeInSeconds) {
                    TimeMe.timeElapsedCallbacks[i].callback();
                    TimeMe.timeElapsedCallbacks[i].pending = false;
                }
                if (TimeMe.isUserCurrentlyIdle === false && TimeMe.currentIdleTimeMs > TimeMe.idleTimeoutMs) {
                    TimeMe.isUserCurrentlyIdle = true;
                    TimeMe.triggerUserHasLeftPageOrGoneIdle();
                } else TimeMe.currentIdleTimeMs += TimeMe.checkIdleStateRateMs;
            },
            visibilityChangeEventName: undefined,
            hiddenPropName: undefined,
            listenForVisibilityEvents: (trackWhenUserLeavesPage, trackWhenUserGoesIdle)=>{
                if (trackWhenUserLeavesPage) TimeMe.listenForUserLeavesOrReturnsEvents();
                if (trackWhenUserGoesIdle) TimeMe.listForIdleEvents();
            },
            listenForUserLeavesOrReturnsEvents: ()=>{
                if (typeof document.hidden !== "undefined") {
                    TimeMe.hiddenPropName = "hidden";
                    TimeMe.visibilityChangeEventName = "visibilitychange";
                } else if (typeof document.mozHidden !== "undefined") {
                    TimeMe.hiddenPropName = "mozHidden";
                    TimeMe.visibilityChangeEventName = "mozvisibilitychange";
                } else if (typeof document.msHidden !== "undefined") {
                    TimeMe.hiddenPropName = "msHidden";
                    TimeMe.visibilityChangeEventName = "msvisibilitychange";
                } else if (typeof document.webkitHidden !== "undefined") {
                    TimeMe.hiddenPropName = "webkitHidden";
                    TimeMe.visibilityChangeEventName = "webkitvisibilitychange";
                }
                document.addEventListener(TimeMe.visibilityChangeEventName, ()=>{
                    if (document[TimeMe.hiddenPropName]) TimeMe.triggerUserHasLeftPageOrGoneIdle();
                    else TimeMe.triggerUserHasReturned();
                }, false);
                window.addEventListener('blur', ()=>{
                    TimeMe.triggerUserHasLeftPageOrGoneIdle();
                });
                window.addEventListener('focus', ()=>{
                    TimeMe.triggerUserHasReturned();
                });
            },
            listForIdleEvents: ()=>{
                document.addEventListener("mousemove", ()=>{
                    TimeMe.userActivityDetected();
                });
                document.addEventListener("keyup", ()=>{
                    TimeMe.userActivityDetected();
                });
                document.addEventListener("touchstart", ()=>{
                    TimeMe.userActivityDetected();
                });
                window.addEventListener("scroll", ()=>{
                    TimeMe.userActivityDetected();
                });
                setInterval(()=>{
                    if (TimeMe.isUserCurrentlyIdle !== true) TimeMe.checkIdleState();
                }, TimeMe.checkIdleStateRateMs);
            },
            websocket: undefined,
            websocketHost: undefined,
            setUpWebsocket: (websocketOptions)=>{
                if (window.WebSocket && websocketOptions) {
                    let websocketHost = websocketOptions.websocketHost; // "ws://hostname:port"
                    try {
                        TimeMe.websocket = new WebSocket(websocketHost);
                        window.onbeforeunload = ()=>{
                            TimeMe.sendCurrentTime(websocketOptions.appId);
                        };
                        TimeMe.websocket.onopen = ()=>{
                            TimeMe.sendInitWsRequest(websocketOptions.appId);
                        };
                        TimeMe.websocket.onerror = (error)=>{
                            if (console) console.log("Error occurred in websocket connection: " + error);
                        };
                        TimeMe.websocket.onmessage = (event)=>{
                            if (console) console.log(event.data);
                        };
                    } catch (error) {
                        if (console) console.error("Failed to connect to websocket host.  Error:" + error);
                    }
                }
            },
            websocketSend: (data)=>{
                TimeMe.websocket.send(JSON.stringify(data));
            },
            sendCurrentTime: (appId)=>{
                let timeSpentOnPage = TimeMe.getTimeOnCurrentPageInMilliseconds();
                let data = {
                    type: "INSERT_TIME",
                    appId: appId,
                    timeOnPageMs: timeSpentOnPage,
                    pageName: TimeMe.currentPageName
                };
                TimeMe.websocketSend(data);
            },
            sendInitWsRequest: (appId)=>{
                let data = {
                    type: "INIT",
                    appId: appId
                };
                TimeMe.websocketSend(data);
            },
            initialize: (options)=>{
                let idleTimeoutInSeconds = TimeMe.idleTimeoutMs || 30;
                let currentPageName = TimeMe.currentPageName || "default-page-name";
                let websocketOptions = undefined;
                let initialStartTime = undefined;
                let trackWhenUserLeavesPage = true;
                let trackWhenUserGoesIdle = true;
                if (options) {
                    idleTimeoutInSeconds = options.idleTimeoutInSeconds || idleTimeoutInSeconds;
                    currentPageName = options.currentPageName || currentPageName;
                    websocketOptions = options.websocketOptions;
                    initialStartTime = options.initialStartTime;
                    if (options.trackWhenUserLeavesPage === false) trackWhenUserLeavesPage = false;
                    if (options.trackWhenUserGoesIdle === false) trackWhenUserGoesIdle = false;
                }
                TimeMe.setIdleDurationInSeconds(idleTimeoutInSeconds);
                TimeMe.setCurrentPageName(currentPageName);
                TimeMe.setUpWebsocket(websocketOptions);
                TimeMe.listenForVisibilityEvents(trackWhenUserLeavesPage, trackWhenUserGoesIdle);
                // TODO - only do this if page currently visible.
                TimeMe.startTimer(undefined, initialStartTime);
            }
        };
        return TimeMe;
    });
}).call(module.exports);

});


parcelRegister("d38aa", function(module, exports) {
$parcel$export(module.exports, "default", () => $9801e332d69b0d62$export$2e2bcd8739ae039);

var $25nEq = parcelRequire("25nEq");

var $jvN07 = parcelRequire("jvN07");

var $8t1l5 = parcelRequire("8t1l5");
function $9801e332d69b0d62$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $9801e332d69b0d62$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $9801e332d69b0d62$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $9801e332d69b0d62$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
const $9801e332d69b0d62$var$DEFAULT_TIMING = {
    initialPollInterval: 5000,
    idleTimeout: 30000,
    multiplierCallback: (x)=>x + x
};
class $9801e332d69b0d62$export$2e2bcd8739ae039 {
    /**
   * Callback for sending a 'track' analytics event. This callback should either be the
   * 'sendTrackEvent' method on the AnalyticsWebClient, or a method that eventually delegates to it.
   * The data for the dwell event will be passed to this method for sending.
   *
   * @callback trackCallback
   * @param {Object} eventData - the base event data that will be added to the track event.
   */ /**
   * Creates and initialises the DwellTimeHelper.
   *
   * @param {trackCallback} trackCallback - the track callback responsible for actually sending
   * the event.
   * @param {Object} eventData - the base data that will be added to the track event.
   * Additional dwell time attributes will be appended to this data. Note that you don't need to
   * include the 'action' property, as this will be added automatically.
   * @param {?string} searchSessionId - a unique identifier for the related search session.
   * @param {?Object} timingOptions - for the purpose of debugging, you can override the default
   * timing used for measuring dwell time. The following values are possible:
   * - initialPollInterval: how long to wait before the first dwell milestone event
   * is fired (in seconds). Default = 5.
   * - pollBackoffRate: how much to multiply the last poll interval by on each dwell milestone.
   * event. Default = 2.
   * - idleTimeout: how long to wait for no user activity before pausing
   * the dwell timer (in seconds). Default = 30s.
   */ constructor(trackCallback, _eventData, _searchSessionId, timingOptions){
        /**
     * Starts the dwell timer. This method should be called upon the initial page load.
     */ (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "start", ()=>{
            this.browserInteractionTime.startTimer();
            this.browserInteractionTime.addTimeIntervalEllapsedCallback({
                callback: (timeInMilliseconds)=>this._sendDwellEvent(this._eventData, this._searchSessionId, timeInMilliseconds, false),
                timeInMilliseconds: this._timing.initialPollInterval,
                multiplier: this._timing.multiplierCallback
            });
            if (typeof window !== 'undefined') window.addEventListener('beforeunload', this._onBeforeUnload);
        });
        /**
     * Stops the dwell timer and sends the final dwell event. Call this method if you wish to
     * finalise a dwell measurement without starting a new one. When switching to a new page in a
     * single-page app, use newPage instead.
     */ (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "stop", ()=>{
            if (this.browserInteractionTime.isRunning()) this._sendDwellEvent(this._eventData, this._searchSessionId, this.browserInteractionTime.getTimeInMilliseconds(), true);
            this.browserInteractionTime.stopTimer();
        });
        /**
     * Send the final dwell event and reinitialise the dwell timer for a new page.
     * This method should be called whenever a new page is switched to in a single-page app context.
     *
     * @param {Object} eventData - the base data that will be added to the track event.
     * @param {?string} searchSessionId - the new search session ID.
     */ (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "newPage", (eventData, searchSessionId)=>{
            (0, $8t1l5.validateDwellBaseEvent)(eventData);
            this.stop();
            this.browserInteractionTime.reset();
            this.setEventData(eventData);
            this.setSearchSessionId(searchSessionId);
            this.start();
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "setEventData", (eventData)=>{
            this._eventData = eventData;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "getEventData", ()=>this._eventData);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "setSearchSessionId", (searchSessionId)=>{
            this._searchSessionId = searchSessionId;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "getSearchSessionId", ()=>this._searchSessionId);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "destroy", ()=>{
            this.browserInteractionTime.destroy();
            if (typeof window !== 'undefined') window.removeEventListener('beforeunload', this._onBeforeUnload);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "_onBeforeUnload", ()=>{
            this.stop();
            this.destroy();
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "_sendDwellEvent", (eventData, searchSessionId, timeInMilliseconds, isFinalDwellEvent)=>{
            const dwellAttributes = {
                dwellTime: timeInMilliseconds,
                searchReferrer: searchSessionId,
                finalDwellEvent: isFinalDwellEvent
            };
            this._trackCallback({
                action: 'dwelled',
                actionSubject: eventData.actionSubject,
                actionSubjectId: eventData.actionSubjectId,
                source: eventData.source,
                containerType: eventData.containerType,
                containerId: eventData.containerId,
                objectType: eventData.objectType,
                objectId: eventData.objectId,
                attributes: $9801e332d69b0d62$var$_objectSpread($9801e332d69b0d62$var$_objectSpread({}, dwellAttributes), eventData.attributes),
                tags: eventData.tags
            });
        });
        if (!trackCallback) throw new Error('trackCallback is required for DwellTimeHelper');
        (0, $8t1l5.validateDwellBaseEvent)(_eventData);
        this._trackCallback = trackCallback;
        this._eventData = _eventData;
        this._searchSessionId = _searchSessionId;
        this._timing = $9801e332d69b0d62$var$_objectSpread($9801e332d69b0d62$var$_objectSpread({}, $9801e332d69b0d62$var$DEFAULT_TIMING), timingOptions);
        this.browserInteractionTime = new (0, $jvN07.default)({
            idleTimeoutMs: this._timing.idleTimeout,
            checkCallbacksIntervalMs: 500
        });
    }
}

});
parcelRegister("jvN07", function(module, exports) {
$parcel$export(module.exports, "default", () => $e346ec1cd3eefb72$export$2e2bcd8739ae039);
/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */ var $e346ec1cd3eefb72$var$__assign = function() {
    $e346ec1cd3eefb72$var$__assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $e346ec1cd3eefb72$var$__assign.apply(this, arguments);
};
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $e346ec1cd3eefb72$var$isObject(value) {
    var type = typeof value;
    return value != null && (type == 'object' || type == 'function');
}
var $e346ec1cd3eefb72$var$isObject_1 = $e346ec1cd3eefb72$var$isObject;
var $e346ec1cd3eefb72$var$commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof $parcel$global !== 'undefined' ? $parcel$global : typeof self !== 'undefined' ? self : {};
/** Detect free variable `global` from Node.js. */ var $e346ec1cd3eefb72$var$freeGlobal = typeof $e346ec1cd3eefb72$var$commonjsGlobal == 'object' && $e346ec1cd3eefb72$var$commonjsGlobal && $e346ec1cd3eefb72$var$commonjsGlobal.Object === Object && $e346ec1cd3eefb72$var$commonjsGlobal;
var $e346ec1cd3eefb72$var$_freeGlobal = $e346ec1cd3eefb72$var$freeGlobal;
/** Detect free variable `self`. */ var $e346ec1cd3eefb72$var$freeSelf = typeof self == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $e346ec1cd3eefb72$var$root = $e346ec1cd3eefb72$var$_freeGlobal || $e346ec1cd3eefb72$var$freeSelf || Function('return this')();
var $e346ec1cd3eefb72$var$_root = $e346ec1cd3eefb72$var$root;
/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */ var $e346ec1cd3eefb72$var$now = function() {
    return $e346ec1cd3eefb72$var$_root.Date.now();
};
var $e346ec1cd3eefb72$var$now_1 = $e346ec1cd3eefb72$var$now;
/** Built-in value references. */ var $e346ec1cd3eefb72$var$Symbol = $e346ec1cd3eefb72$var$_root.Symbol;
var $e346ec1cd3eefb72$var$_Symbol = $e346ec1cd3eefb72$var$Symbol;
/** Used for built-in method references. */ var $e346ec1cd3eefb72$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $e346ec1cd3eefb72$var$hasOwnProperty = $e346ec1cd3eefb72$var$objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $e346ec1cd3eefb72$var$nativeObjectToString = $e346ec1cd3eefb72$var$objectProto.toString;
/** Built-in value references. */ var $e346ec1cd3eefb72$var$symToStringTag = $e346ec1cd3eefb72$var$_Symbol ? $e346ec1cd3eefb72$var$_Symbol.toStringTag : undefined;
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function $e346ec1cd3eefb72$var$getRawTag(value) {
    var isOwn = $e346ec1cd3eefb72$var$hasOwnProperty.call(value, $e346ec1cd3eefb72$var$symToStringTag), tag = value[$e346ec1cd3eefb72$var$symToStringTag];
    try {
        value[$e346ec1cd3eefb72$var$symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = $e346ec1cd3eefb72$var$nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[$e346ec1cd3eefb72$var$symToStringTag] = tag;
        else delete value[$e346ec1cd3eefb72$var$symToStringTag];
    }
    return result;
}
var $e346ec1cd3eefb72$var$_getRawTag = $e346ec1cd3eefb72$var$getRawTag;
/** Used for built-in method references. */ var $e346ec1cd3eefb72$var$objectProto$1 = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $e346ec1cd3eefb72$var$nativeObjectToString$1 = $e346ec1cd3eefb72$var$objectProto$1.toString;
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function $e346ec1cd3eefb72$var$objectToString(value) {
    return $e346ec1cd3eefb72$var$nativeObjectToString$1.call(value);
}
var $e346ec1cd3eefb72$var$_objectToString = $e346ec1cd3eefb72$var$objectToString;
/** `Object#toString` result references. */ var $e346ec1cd3eefb72$var$nullTag = '[object Null]', $e346ec1cd3eefb72$var$undefinedTag = '[object Undefined]';
/** Built-in value references. */ var $e346ec1cd3eefb72$var$symToStringTag$1 = $e346ec1cd3eefb72$var$_Symbol ? $e346ec1cd3eefb72$var$_Symbol.toStringTag : undefined;
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function $e346ec1cd3eefb72$var$baseGetTag(value) {
    if (value == null) return value === undefined ? $e346ec1cd3eefb72$var$undefinedTag : $e346ec1cd3eefb72$var$nullTag;
    return $e346ec1cd3eefb72$var$symToStringTag$1 && $e346ec1cd3eefb72$var$symToStringTag$1 in Object(value) ? $e346ec1cd3eefb72$var$_getRawTag(value) : $e346ec1cd3eefb72$var$_objectToString(value);
}
var $e346ec1cd3eefb72$var$_baseGetTag = $e346ec1cd3eefb72$var$baseGetTag;
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $e346ec1cd3eefb72$var$isObjectLike(value) {
    return value != null && typeof value == 'object';
}
var $e346ec1cd3eefb72$var$isObjectLike_1 = $e346ec1cd3eefb72$var$isObjectLike;
/** `Object#toString` result references. */ var $e346ec1cd3eefb72$var$symbolTag = '[object Symbol]';
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $e346ec1cd3eefb72$var$isSymbol(value) {
    return typeof value == 'symbol' || $e346ec1cd3eefb72$var$isObjectLike_1(value) && $e346ec1cd3eefb72$var$_baseGetTag(value) == $e346ec1cd3eefb72$var$symbolTag;
}
var $e346ec1cd3eefb72$var$isSymbol_1 = $e346ec1cd3eefb72$var$isSymbol;
/** Used as references for various `Number` constants. */ var $e346ec1cd3eefb72$var$NAN = 0 / 0;
/** Used to match leading and trailing whitespace. */ var $e346ec1cd3eefb72$var$reTrim = /^\s+|\s+$/g;
/** Used to detect bad signed hexadecimal string values. */ var $e346ec1cd3eefb72$var$reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
/** Used to detect binary string values. */ var $e346ec1cd3eefb72$var$reIsBinary = /^0b[01]+$/i;
/** Used to detect octal string values. */ var $e346ec1cd3eefb72$var$reIsOctal = /^0o[0-7]+$/i;
/** Built-in method references without a dependency on `root`. */ var $e346ec1cd3eefb72$var$freeParseInt = parseInt;
/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */ function $e346ec1cd3eefb72$var$toNumber(value) {
    if (typeof value == 'number') return value;
    if ($e346ec1cd3eefb72$var$isSymbol_1(value)) return $e346ec1cd3eefb72$var$NAN;
    if ($e346ec1cd3eefb72$var$isObject_1(value)) {
        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
        value = $e346ec1cd3eefb72$var$isObject_1(other) ? other + '' : other;
    }
    if (typeof value != 'string') return value === 0 ? value : +value;
    value = value.replace($e346ec1cd3eefb72$var$reTrim, '');
    var isBinary = $e346ec1cd3eefb72$var$reIsBinary.test(value);
    return isBinary || $e346ec1cd3eefb72$var$reIsOctal.test(value) ? $e346ec1cd3eefb72$var$freeParseInt(value.slice(2), isBinary ? 2 : 8) : $e346ec1cd3eefb72$var$reIsBadHex.test(value) ? $e346ec1cd3eefb72$var$NAN : +value;
}
var $e346ec1cd3eefb72$var$toNumber_1 = $e346ec1cd3eefb72$var$toNumber;
/** Error message constants. */ var $e346ec1cd3eefb72$var$FUNC_ERROR_TEXT = 'Expected a function';
/* Built-in method references for those with the same name as other `lodash` methods. */ var $e346ec1cd3eefb72$var$nativeMax = Math.max, $e346ec1cd3eefb72$var$nativeMin = Math.min;
/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */ function $e346ec1cd3eefb72$var$debounce(func, wait, options) {
    var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
    if (typeof func != 'function') throw new TypeError($e346ec1cd3eefb72$var$FUNC_ERROR_TEXT);
    wait = $e346ec1cd3eefb72$var$toNumber_1(wait) || 0;
    if ($e346ec1cd3eefb72$var$isObject_1(options)) {
        leading = !!options.leading;
        maxing = 'maxWait' in options;
        maxWait = maxing ? $e346ec1cd3eefb72$var$nativeMax($e346ec1cd3eefb72$var$toNumber_1(options.maxWait) || 0, wait) : maxWait;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
    }
    function invokeFunc(time) {
        var args = lastArgs, thisArg = lastThis;
        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
    }
    function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
    }
    function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
        return maxing ? $e346ec1cd3eefb72$var$nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
    }
    function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
    }
    function timerExpired() {
        var time = $e346ec1cd3eefb72$var$now_1();
        if (shouldInvoke(time)) return trailingEdge(time);
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
    }
    function trailingEdge(time) {
        timerId = undefined;
        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) return invokeFunc(time);
        lastArgs = lastThis = undefined;
        return result;
    }
    function cancel() {
        if (timerId !== undefined) clearTimeout(timerId);
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
    }
    function flush() {
        return timerId === undefined ? result : trailingEdge($e346ec1cd3eefb72$var$now_1());
    }
    function debounced() {
        var time = $e346ec1cd3eefb72$var$now_1(), isInvoking = shouldInvoke(time);
        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;
        if (isInvoking) {
            if (timerId === undefined) return leadingEdge(lastCallTime);
            if (maxing) {
                // Handle invocations in a tight loop.
                timerId = setTimeout(timerExpired, wait);
                return invokeFunc(lastCallTime);
            }
        }
        if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
        return result;
    }
    debounced.cancel = cancel;
    debounced.flush = flush;
    return debounced;
}
var $e346ec1cd3eefb72$var$debounce_1 = $e346ec1cd3eefb72$var$debounce;
/** Error message constants. */ var $e346ec1cd3eefb72$var$FUNC_ERROR_TEXT$1 = 'Expected a function';
/**
 * Creates a throttled function that only invokes `func` at most once per
 * every `wait` milliseconds. The throttled function comes with a `cancel`
 * method to cancel delayed `func` invocations and a `flush` method to
 * immediately invoke them. Provide `options` to indicate whether `func`
 * should be invoked on the leading and/or trailing edge of the `wait`
 * timeout. The `func` is invoked with the last arguments provided to the
 * throttled function. Subsequent calls to the throttled function return the
 * result of the last `func` invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the throttled function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.throttle` and `_.debounce`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to throttle.
 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=true]
 *  Specify invoking on the leading edge of the timeout.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new throttled function.
 * @example
 *
 * // Avoid excessively updating the position while scrolling.
 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
 *
 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
 * jQuery(element).on('click', throttled);
 *
 * // Cancel the trailing throttled invocation.
 * jQuery(window).on('popstate', throttled.cancel);
 */ function $e346ec1cd3eefb72$var$throttle(func, wait, options) {
    var leading = true, trailing = true;
    if (typeof func != 'function') throw new TypeError($e346ec1cd3eefb72$var$FUNC_ERROR_TEXT$1);
    if ($e346ec1cd3eefb72$var$isObject_1(options)) {
        leading = 'leading' in options ? !!options.leading : leading;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
    }
    return $e346ec1cd3eefb72$var$debounce_1(func, wait, {
        'leading': leading,
        'maxWait': wait,
        'trailing': trailing
    });
}
var $e346ec1cd3eefb72$var$throttle_1 = $e346ec1cd3eefb72$var$throttle;
var $e346ec1cd3eefb72$var$windowIdleEvents = [
    'scroll',
    'resize'
];
var $e346ec1cd3eefb72$var$documentIdleEvents = [
    'wheel',
    'keydown',
    'keyup',
    'mousedown',
    'mousemove',
    'touchstart',
    'touchmove',
    'click',
    'contextmenu'
];
var $e346ec1cd3eefb72$var$BrowserInteractionTime = /** @class */ function() {
    function BrowserInteractionTime(_a) {
        var _b = _a.timeIntervalEllapsedCallbacks, timeIntervalEllapsedCallbacks = _b === void 0 ? [] : _b, _c = _a.absoluteTimeEllapsedCallbacks, absoluteTimeEllapsedCallbacks = _c === void 0 ? [] : _c, _d = _a.checkCallbacksIntervalMs, checkCallbacksIntervalMs = _d === void 0 ? 100 : _d, _e = _a.browserTabInactiveCallbacks, browserTabInactiveCallbacks = _e === void 0 ? [] : _e, _f = _a.idleCallbacks, idleCallbacks = _f === void 0 ? [] : _f, _g = _a.stopTimerOnTabchange, stopTimerOnTabchange = _g === void 0 ? true : _g, _h = _a.activeCallbacks, activeCallbacks = _h === void 0 ? [] : _h, _j = _a.browserTabActiveCallbacks, browserTabActiveCallbacks = _j === void 0 ? [] : _j, _k = _a.idleTimeoutMs, idleTimeoutMs = _k === void 0 ? 3000 : _k;
        var _this = this;
        this.onBrowserTabInactive = function() {
            // if running pause timer
            if (_this.isRunning() && _this.stopTimerOnTabchange) _this.stopTimer();
            _this.browserTabInactiveCallbacks.forEach(function(fn) {
                return fn(_this.getTimeInMilliseconds());
            });
        };
        this.onBrowserTabActive = function() {
            // if not running start timer
            if (!_this.isRunning()) _this.startTimer();
            _this.browserTabActiveCallbacks.forEach(function(fn) {
                return fn(_this.getTimeInMilliseconds());
            });
        };
        this.onBrowserActiveChange = function() {
            if (document.visibilityState === 'visible') _this.onBrowserTabActive();
            else _this.onBrowserTabInactive();
        };
        this.onTimePassed = function() {
            // check all callbacks time and if passed execute callback
            _this.absoluteTimeEllapsedCallbacks.forEach(function(_a, index) {
                var callback = _a.callback, pending = _a.pending, timeInMilliseconds = _a.timeInMilliseconds;
                if (pending && timeInMilliseconds <= _this.getTimeInMilliseconds()) {
                    callback(_this.getTimeInMilliseconds());
                    _this.absoluteTimeEllapsedCallbacks[index].pending = false;
                }
            });
            _this.timeIntervalEllapsedCallbacks.forEach(function(_a, index) {
                var callback = _a.callback, timeInMilliseconds = _a.timeInMilliseconds, multiplier = _a.multiplier;
                if (timeInMilliseconds <= _this.getTimeInMilliseconds()) {
                    callback(_this.getTimeInMilliseconds());
                    _this.timeIntervalEllapsedCallbacks[index].timeInMilliseconds = multiplier(timeInMilliseconds);
                }
            });
            if (_this.currentIdleTimeMs >= _this.idleTimeoutMs && _this.isRunning()) {
                _this.idle = true;
                _this.stopTimer();
                _this.idleCallbacks.forEach(function(fn) {
                    return fn(_this.getTimeInMilliseconds());
                });
            } else _this.currentIdleTimeMs += _this.checkCallbacksIntervalMs;
        };
        this.resetIdleTime = function() {
            if (_this.idle) _this.startTimer();
            _this.activeCallbacks.forEach(function(fn) {
                return fn(_this.getTimeInMilliseconds());
            });
            _this.idle = false;
            _this.currentIdleTimeMs = 0;
        };
        this.registerEventListeners = function() {
            var documentListenerOptions = {
                passive: true
            };
            var windowListenerOptions = $e346ec1cd3eefb72$var$__assign({}, documentListenerOptions, {
                capture: true
            });
            document.addEventListener('visibilitychange', _this.onBrowserActiveChange);
            var throttleResetIdleTime = $e346ec1cd3eefb72$var$throttle_1(_this.resetIdleTime, 2000, {
                leading: true,
                trailing: false
            });
            $e346ec1cd3eefb72$var$windowIdleEvents.forEach(function(event) {
                window.addEventListener(event, throttleResetIdleTime, windowListenerOptions);
            });
            $e346ec1cd3eefb72$var$documentIdleEvents.forEach(function(event) {
                return document.addEventListener(event, throttleResetIdleTime, documentListenerOptions);
            });
        };
        this.unregisterEventListeners = function() {
            document.removeEventListener('visibilitychange', _this.onBrowserActiveChange);
            $e346ec1cd3eefb72$var$windowIdleEvents.forEach(function(event) {
                return window.removeEventListener(event, _this.resetIdleTime);
            });
            $e346ec1cd3eefb72$var$documentIdleEvents.forEach(function(event) {
                return document.removeEventListener(event, _this.resetIdleTime);
            });
        };
        this.checkCallbacksOnInterval = function() {
            _this.checkCallbackIntervalId = window.setInterval(function() {
                _this.onTimePassed();
            }, _this.checkCallbacksIntervalMs);
        };
        this.startTimer = function() {
            if (!_this.checkCallbackIntervalId) _this.checkCallbacksOnInterval();
            var last = _this.times[_this.times.length - 1];
            if (last && last.stop === null) return;
            _this.times.push({
                start: performance.now(),
                stop: null
            });
            _this.running = true;
        };
        this.stopTimer = function() {
            if (!_this.times.length) return;
            _this.times[_this.times.length - 1].stop = performance.now();
            _this.running = false;
        };
        this.addTimeIntervalEllapsedCallback = function(timeIntervalEllapsedCallback) {
            _this.timeIntervalEllapsedCallbacks.push(timeIntervalEllapsedCallback);
        };
        this.addAbsoluteTimeEllapsedCallback = function(absoluteTimeEllapsedCallback) {
            _this.absoluteTimeEllapsedCallbacks.push(absoluteTimeEllapsedCallback);
        };
        this.addBrowserTabInactiveCallback = function(browserTabInactiveCallback) {
            _this.browserTabInactiveCallbacks.push(browserTabInactiveCallback);
        };
        this.addBrowserTabActiveCallback = function(browserTabActiveCallback) {
            _this.browserTabActiveCallbacks.push(browserTabActiveCallback);
        };
        this.addIdleCallback = function(inactiveCallback) {
            _this.idleCallbacks.push(inactiveCallback);
        };
        this.addActiveCallback = function(activeCallback) {
            _this.activeCallbacks.push(activeCallback);
        };
        this.getTimeInMilliseconds = function() {
            return _this.times.reduce(function(acc, current) {
                if (current.stop) acc = acc + (current.stop - current.start);
                else acc = acc + (performance.now() - current.start);
                return acc;
            }, 0);
        };
        this.isRunning = function() {
            return _this.running;
        };
        this.isIdle = function() {
            return _this.idle;
        };
        this.reset = function() {
            _this.times = [];
        };
        this.destroy = function() {
            _this.unregisterEventListeners();
            if (_this.checkCallbackIntervalId) window.clearInterval(_this.checkCallbackIntervalId);
        };
        this.running = false;
        this.times = [];
        this.idle = false;
        this.currentIdleTimeMs = 0;
        this.marks = {};
        this.measures = {};
        this.stopTimerOnTabchange = stopTimerOnTabchange;
        this.browserTabActiveCallbacks = browserTabActiveCallbacks;
        this.browserTabInactiveCallbacks = browserTabInactiveCallbacks;
        this.checkCallbacksIntervalMs = checkCallbacksIntervalMs;
        this.idleTimeoutMs = idleTimeoutMs;
        this.timeIntervalEllapsedCallbacks = timeIntervalEllapsedCallbacks;
        this.absoluteTimeEllapsedCallbacks = absoluteTimeEllapsedCallbacks;
        this.idleCallbacks = idleCallbacks;
        this.activeCallbacks = activeCallbacks;
        this.registerEventListeners();
    }
    BrowserInteractionTime.prototype.mark = function(key) {
        if (!this.marks[key]) this.marks[key] = [];
        this.marks[key].push({
            time: this.getTimeInMilliseconds()
        });
    };
    BrowserInteractionTime.prototype.getMarks = function(name) {
        if (this.marks[name].length < 1) return;
        return this.marks[name];
    };
    BrowserInteractionTime.prototype.measure = function(name, startMarkName, endMarkName) {
        var startMarks = this.marks[startMarkName];
        var startMark = startMarks[startMarks.length - 1];
        var endMarks = this.marks[endMarkName];
        var endMark = endMarks[endMarks.length - 1];
        if (!this.measures[name]) this.measures[name] = [];
        this.measures[name].push({
            name: name,
            startTime: startMark.time,
            duration: endMark.time - startMark.time
        });
    };
    BrowserInteractionTime.prototype.getMeasures = function(name) {
        if (!this.measures[name] && this.measures[name].length < 1) return;
        return this.measures[name];
    };
    return BrowserInteractionTime;
}();
var $e346ec1cd3eefb72$export$2e2bcd8739ae039 = $e346ec1cd3eefb72$var$BrowserInteractionTime;

});


parcelRegister("7fyW0", function(module, exports) {
$parcel$export(module.exports, "default", () => $54750867cc20d6d4$export$2e2bcd8739ae039);

var $25nEq = parcelRequire("25nEq");
function $54750867cc20d6d4$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $54750867cc20d6d4$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $54750867cc20d6d4$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $54750867cc20d6d4$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
/**
 * TypeAheadHelper is helper file which assists in
 * tracking analytics around typeahead components, such as mentions, in
 * a consistent way. It generates objects that can be passed into
 * an instance of analyticsWebClient to trigger events.
 *
 * Example usage:
 *
 * const typeAheadHelper = new TypeAheadHelper(
 *   webClient.sendTrackEvent,
 *   baseEvent // an object containing the action + additional context attributes
 * );
 *
 * mentionHelper.search('abc');
 * mentionHelper.searched(resultsArray);
 * mentionHelper.selected(selectedIndex);
 */ function $54750867cc20d6d4$var$combineWithBaseEvent(action, extraAttributes, baseEvent) {
    const event = $54750867cc20d6d4$var$_objectSpread({
        action: action
    }, baseEvent);
    event.attributes = $54750867cc20d6d4$var$_objectSpread($54750867cc20d6d4$var$_objectSpread({}, extraAttributes), event.attributes);
    return event;
}
class $54750867cc20d6d4$export$2e2bcd8739ae039 {
    /**
   * Constructs a new instance of TypeAheadHelper.
   *
   * @param {Function} onEvent the function to call when an analytics event must be fired.
   *  There will be one argument, the analytics event object.
   * @param {Object} baseEvent base event with action and context to use when triggering events.
   *  More details here: https://product-fabric.atlassian.net/wiki/x/XQCZFg
   */ constructor(onEvent, baseEvent){
        this._onEvent = onEvent;
        this._baseEvent = baseEvent;
        this._searchStartedTime = null;
        this._lastQueryResultsTime = null;
        this._queryLength = null;
        this._baseEvent = $54750867cc20d6d4$var$_objectSpread({}, baseEvent);
    }
    /**
   * Records the start time of the first web request
   * and a copy of the query length for sending later in an analytics event.
   *
   * It should be called before the web request is initially made.
   *
   * @param {String} query the string entered as the query
   */ search(query) {
        if (!query && query !== '') throw new Error('Missing query param');
        this._searchStartedTime = Date.now();
        this._queryLength = (query || '').length;
    }
    /**
   * searched() tracks an event representing the completion of the web request
   * to fetch results for a given typeahead query.
   *
   * Events are structured as follows:
   *
   * <actionSubject>.searched {
   *    queryLength: 12, // length in characters
   *    responseTimeMs: 5023, // time to return results in milliseconds
   *    results: [ 'abc', '123' ] // actual result content
   * }
   *
   * It should be called after the response returns from the web server.
   *
   * @param {Array} results List of results returned by the server. MUST NOT CONTAIN UGC.
   */ searched(results) {
        if (!results) throw new Error('Missing results param');
        if (this._queryLength === null) throw new Error('search() must be called before searched().');
        const responseTimeMs = Date.now() - this._searchStartedTime;
        this._lastQueryResultsTime = Date.now();
        this._lastResults = results;
        const extraAttributes = {
            responseTimeMs: responseTimeMs,
            queryLength: this._queryLength,
            results: results
        };
        const event = $54750867cc20d6d4$var$combineWithBaseEvent('searched', extraAttributes, this._baseEvent);
        this._onEvent(event);
    }
    /**
   * selected() tracks an event representing one of the results in the typeahead
   * being chosen.
   *
   * Events are structured as follows:
   *
   * <actionSubject>.selected {
   *    queryLength: 12,
   *    selectionIndex: 0,
   *    selectionTimeMs: 123 // ms since the response came back
   *    searchTimeMs: 123 // ms since the search was made, i.e. selection + response time
   * }
   *
   * @param {Number} selectionIndex the index of the result was selected.
   */ selected(selectionIndex) {
        if (!selectionIndex && selectionIndex !== 0) throw new Error('Missing selectionIndex param');
        if (!this._lastQueryResultsTime) throw new Error('searched() must be called before selected().');
        const now = Date.now();
        const selectionTimeMs = now - this._lastQueryResultsTime;
        const searchTimeMs = now - this._searchStartedTime;
        const selectedResultValue = this._lastResults[selectionIndex];
        const extraAttributes = {
            queryLength: this._queryLength,
            selectionIndex: selectionIndex,
            selectionTimeMs: selectionTimeMs,
            searchTimeMs: searchTimeMs,
            selectedResultValue: selectedResultValue
        };
        const event = $54750867cc20d6d4$var$combineWithBaseEvent('selected', extraAttributes, this._baseEvent);
        this._onEvent(event);
    }
}

});


parcelRegister("aRMzY", function(module, exports) {
$parcel$export(module.exports, "defineMessages", () => $7e94896e68874ec2$export$1adfeb024f5185b);
$parcel$export(module.exports, "FormattedDate", () => $7e94896e68874ec2$export$40ae3194919d16b);
$parcel$export(module.exports, "FormattedNumber", () => $7e94896e68874ec2$export$db80edc1e6b2f63d);

var $cX5YV = parcelRequire("cX5YV");

var $3IjMA = parcelRequire("3IjMA");

var $6Wx3K = parcelRequire("6Wx3K");

var $2DGGf = parcelRequire("2DGGf");

var $9du5U = parcelRequire("9du5U");


var $iBNQo = parcelRequire("iBNQo");


var $ftB2S = parcelRequire("ftB2S");
function $7e94896e68874ec2$export$1adfeb024f5185b(msgs) {
    return msgs;
}
function $7e94896e68874ec2$export$747d244ee58120dd(msg) {
    return msg;
}
var $7e94896e68874ec2$export$40ae3194919d16b = (0, $cX5YV.createFormattedComponent)('formatDate');
var $7e94896e68874ec2$export$5b390a54f8a846f7 = (0, $cX5YV.createFormattedComponent)('formatTime');
var $7e94896e68874ec2$export$db80edc1e6b2f63d = (0, $cX5YV.createFormattedComponent)('formatNumber');
var $7e94896e68874ec2$export$f52b44e459e6e71d = (0, $cX5YV.createFormattedComponent)('formatList');
var $7e94896e68874ec2$export$c2336ea5aaab92fa = (0, $cX5YV.createFormattedComponent)('formatDisplayName');
var $7e94896e68874ec2$export$7fdc7d2c91ce149b = (0, $cX5YV.createFormattedDateTimePartsComponent)('formatDate');
var $7e94896e68874ec2$export$ec35873761676c2a = (0, $cX5YV.createFormattedDateTimePartsComponent)('formatTime');

});
parcelRegister("cX5YV", function(module, exports) {
$parcel$export(module.exports, "createFormattedDateTimePartsComponent", () => $96dfa288cab30b1c$export$7448277f6036d2ab);
$parcel$export(module.exports, "createFormattedComponent", () => $96dfa288cab30b1c$export$b37e14176d001dec);

var $l2Z7B = parcelRequire("l2Z7B");

var $5FkrB = parcelRequire("5FkrB");

var $6Wx3K = parcelRequire("6Wx3K");
var $96dfa288cab30b1c$var$DisplayName;
(function(DisplayName) {
    DisplayName["formatDate"] = "FormattedDate";
    DisplayName["formatTime"] = "FormattedTime";
    DisplayName["formatNumber"] = "FormattedNumber";
    DisplayName["formatList"] = "FormattedList";
    // Note that this DisplayName is the locale display name, not to be confused with
    // the name of the enum, which is for React component display name in dev tools.
    DisplayName["formatDisplayName"] = "FormattedDisplayName";
})($96dfa288cab30b1c$var$DisplayName || ($96dfa288cab30b1c$var$DisplayName = {}));
var $96dfa288cab30b1c$var$DisplayNameParts;
(function(DisplayNameParts) {
    DisplayNameParts["formatDate"] = "FormattedDateParts";
    DisplayNameParts["formatTime"] = "FormattedTimeParts";
    DisplayNameParts["formatNumber"] = "FormattedNumberParts";
    DisplayNameParts["formatList"] = "FormattedListParts";
})($96dfa288cab30b1c$var$DisplayNameParts || ($96dfa288cab30b1c$var$DisplayNameParts = {}));
var $96dfa288cab30b1c$export$54d4989ed3eea1ea = function(props) {
    var intl = (0, $6Wx3K.default)();
    var value = props.value, children = props.children, formatProps = (0, $l2Z7B.__rest)(props, [
        "value",
        "children"
    ]);
    return children(intl.formatNumberToParts(value, formatProps));
};
$96dfa288cab30b1c$export$54d4989ed3eea1ea.displayName = 'FormattedNumberParts';
var $96dfa288cab30b1c$export$5ac259c7da6d2188 = function(props) {
    var intl = (0, $6Wx3K.default)();
    var value = props.value, children = props.children, formatProps = (0, $l2Z7B.__rest)(props, [
        "value",
        "children"
    ]);
    return children(intl.formatListToParts(value, formatProps));
};
$96dfa288cab30b1c$export$54d4989ed3eea1ea.displayName = 'FormattedNumberParts';
function $96dfa288cab30b1c$export$7448277f6036d2ab(name) {
    var ComponentParts = function(props) {
        var intl = (0, $6Wx3K.default)();
        var value = props.value, children = props.children, formatProps = (0, $l2Z7B.__rest)(props, [
            "value",
            "children"
        ]);
        var date = typeof value === 'string' ? new Date(value || 0) : value;
        var formattedParts = name === 'formatDate' ? intl.formatDateToParts(date, formatProps) : intl.formatTimeToParts(date, formatProps);
        return children(formattedParts);
    };
    ComponentParts.displayName = $96dfa288cab30b1c$var$DisplayNameParts[name];
    return ComponentParts;
}
function $96dfa288cab30b1c$export$b37e14176d001dec(name) {
    var Component = function(props) {
        var intl = (0, $6Wx3K.default)();
        var value = props.value, children = props.children, formatProps = (0, $l2Z7B.__rest)(props, [
            "value",
            "children"
        ]);
        // TODO: fix TS type definition for localeMatcher upstream
        var formattedValue = intl[name](value, formatProps);
        if (typeof children === 'function') return children(formattedValue);
        var Text = intl.textComponent || $5FkrB.Fragment;
        return $5FkrB.createElement(Text, null, formattedValue);
    };
    Component.displayName = $96dfa288cab30b1c$var$DisplayName[name];
    return Component;
}

});
parcelRegister("6Wx3K", function(module, exports) {
$parcel$export(module.exports, "default", () => $50e1cdc87cad912e$export$2e2bcd8739ae039);

var $5FkrB = parcelRequire("5FkrB");

var $3IjMA = parcelRequire("3IjMA");

var $ktNo6 = parcelRequire("ktNo6");
function $50e1cdc87cad912e$export$2e2bcd8739ae039() {
    var intl = $5FkrB.useContext((0, $3IjMA.Context));
    (0, $ktNo6.invariantIntlContext)(intl);
    return intl;
}

});


parcelRegister("9du5U", function(module, exports) {
$parcel$export(module.exports, "default", () => $6b5cac0e25aa4278$export$2e2bcd8739ae039);

var $l2Z7B = parcelRequire("l2Z7B");

var $5FkrB = parcelRequire("5FkrB");

var $kVTHJ = parcelRequire("kVTHJ");

var $6Wx3K = parcelRequire("6Wx3K");
var $6b5cac0e25aa4278$var$MINUTE = 60;
var $6b5cac0e25aa4278$var$HOUR = 3600;
var $6b5cac0e25aa4278$var$DAY = 86400;
function $6b5cac0e25aa4278$var$selectUnit(seconds) {
    var absValue = Math.abs(seconds);
    if (absValue < $6b5cac0e25aa4278$var$MINUTE) return 'second';
    if (absValue < $6b5cac0e25aa4278$var$HOUR) return 'minute';
    if (absValue < $6b5cac0e25aa4278$var$DAY) return 'hour';
    return 'day';
}
function $6b5cac0e25aa4278$var$getDurationInSeconds(unit) {
    switch(unit){
        case 'second':
            return 1;
        case 'minute':
            return $6b5cac0e25aa4278$var$MINUTE;
        case 'hour':
            return $6b5cac0e25aa4278$var$HOUR;
        default:
            return $6b5cac0e25aa4278$var$DAY;
    }
}
function $6b5cac0e25aa4278$var$valueToSeconds(value, unit) {
    if (!value) return 0;
    switch(unit){
        case 'second':
            return value;
        case 'minute':
            return value * $6b5cac0e25aa4278$var$MINUTE;
        default:
            return value * $6b5cac0e25aa4278$var$HOUR;
    }
}
var $6b5cac0e25aa4278$var$INCREMENTABLE_UNITS = [
    'second',
    'minute',
    'hour'
];
function $6b5cac0e25aa4278$var$canIncrement(unit) {
    if (unit === void 0) unit = 'second';
    return $6b5cac0e25aa4278$var$INCREMENTABLE_UNITS.indexOf(unit) > -1;
}
var $6b5cac0e25aa4278$var$SimpleFormattedRelativeTime = function(props) {
    var _a = (0, $6Wx3K.default)(), formatRelativeTime = _a.formatRelativeTime, Text = _a.textComponent;
    var children = props.children, value = props.value, unit = props.unit, otherProps = (0, $l2Z7B.__rest)(props, [
        "children",
        "value",
        "unit"
    ]);
    var formattedRelativeTime = formatRelativeTime(value || 0, unit, otherProps);
    if (typeof children === 'function') return children(formattedRelativeTime);
    if (Text) return $5FkrB.createElement(Text, null, formattedRelativeTime);
    return $5FkrB.createElement($5FkrB.Fragment, null, formattedRelativeTime);
};
var $6b5cac0e25aa4278$var$FormattedRelativeTime = function(_a) {
    var value = _a.value, unit = _a.unit, updateIntervalInSeconds = _a.updateIntervalInSeconds, otherProps = (0, $l2Z7B.__rest)(_a, [
        "value",
        "unit",
        "updateIntervalInSeconds"
    ]);
    (0, $kVTHJ.invariant)(!updateIntervalInSeconds || !!(updateIntervalInSeconds && $6b5cac0e25aa4278$var$canIncrement(unit)), 'Cannot schedule update with unit longer than hour');
    var _b = $5FkrB.useState(), prevUnit = _b[0], setPrevUnit = _b[1];
    var _c = $5FkrB.useState(0), prevValue = _c[0], setPrevValue = _c[1];
    var _d = $5FkrB.useState(0), currentValueInSeconds = _d[0], setCurrentValueInSeconds = _d[1];
    var updateTimer;
    if (unit !== prevUnit || value !== prevValue) {
        setPrevValue(value || 0);
        setPrevUnit(unit);
        setCurrentValueInSeconds($6b5cac0e25aa4278$var$canIncrement(unit) ? $6b5cac0e25aa4278$var$valueToSeconds(value, unit) : 0);
    }
    $5FkrB.useEffect(function() {
        function clearUpdateTimer() {
            clearTimeout(updateTimer);
        }
        clearUpdateTimer();
        // If there's no interval and we cannot increment this unit, do nothing
        if (!updateIntervalInSeconds || !$6b5cac0e25aa4278$var$canIncrement(unit)) return clearUpdateTimer;
        // Figure out the next interesting time
        var nextValueInSeconds = currentValueInSeconds - updateIntervalInSeconds;
        var nextUnit = $6b5cac0e25aa4278$var$selectUnit(nextValueInSeconds);
        // We've reached the max auto incrementable unit, don't schedule another update
        if (nextUnit === 'day') return clearUpdateTimer;
        var unitDuration = $6b5cac0e25aa4278$var$getDurationInSeconds(nextUnit);
        var remainder = nextValueInSeconds % unitDuration;
        var prevInterestingValueInSeconds = nextValueInSeconds - remainder;
        var nextInterestingValueInSeconds = prevInterestingValueInSeconds >= currentValueInSeconds ? prevInterestingValueInSeconds - unitDuration : prevInterestingValueInSeconds;
        var delayInSeconds = Math.abs(nextInterestingValueInSeconds - currentValueInSeconds);
        if (currentValueInSeconds !== nextInterestingValueInSeconds) updateTimer = setTimeout(function() {
            return setCurrentValueInSeconds(nextInterestingValueInSeconds);
        }, delayInSeconds * 1e3);
        return clearUpdateTimer;
    }, [
        currentValueInSeconds,
        updateIntervalInSeconds,
        unit
    ]);
    var currentValue = value || 0;
    var currentUnit = unit;
    if ($6b5cac0e25aa4278$var$canIncrement(unit) && typeof currentValueInSeconds === 'number' && updateIntervalInSeconds) {
        currentUnit = $6b5cac0e25aa4278$var$selectUnit(currentValueInSeconds);
        var unitDuration = $6b5cac0e25aa4278$var$getDurationInSeconds(currentUnit);
        currentValue = Math.round(currentValueInSeconds / unitDuration);
    }
    return $5FkrB.createElement($6b5cac0e25aa4278$var$SimpleFormattedRelativeTime, (0, $l2Z7B.__assign)({
        value: currentValue,
        unit: currentUnit
    }, otherProps));
};
$6b5cac0e25aa4278$var$FormattedRelativeTime.displayName = 'FormattedRelativeTime';
$6b5cac0e25aa4278$var$FormattedRelativeTime.defaultProps = {
    value: 0,
    unit: 'second'
};
var $6b5cac0e25aa4278$export$2e2bcd8739ae039 = $6b5cac0e25aa4278$var$FormattedRelativeTime;

});

parcelRegister("iBNQo", function(module, exports) {
$parcel$export(module.exports, "default", () => $d8c258b384a9ab14$export$2e2bcd8739ae039);
/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */ 
var $l2Z7B = parcelRequire("l2Z7B");

var $5FkrB = parcelRequire("5FkrB");

var $6Wx3K = parcelRequire("6Wx3K");

var $ktNo6 = parcelRequire("ktNo6");
function $d8c258b384a9ab14$var$areEqual(prevProps, nextProps) {
    var values = prevProps.values, otherProps = (0, $l2Z7B.__rest)(prevProps, [
        "values"
    ]);
    var nextValues = nextProps.values, nextOtherProps = (0, $l2Z7B.__rest)(nextProps, [
        "values"
    ]);
    return (0, $ktNo6.shallowEqual)(nextValues, values) && (0, $ktNo6.shallowEqual)(otherProps, nextOtherProps);
}
function $d8c258b384a9ab14$var$FormattedMessage(props) {
    var intl = (0, $6Wx3K.default)();
    var formatMessage = intl.formatMessage, _a = intl.textComponent, Text = _a === void 0 ? $5FkrB.Fragment : _a;
    var id = props.id, description = props.description, defaultMessage = props.defaultMessage, values = props.values, children = props.children, _b = props.tagName, Component = _b === void 0 ? Text : _b, ignoreTag = props.ignoreTag;
    var descriptor = {
        id: id,
        description: description,
        defaultMessage: defaultMessage
    };
    var nodes = formatMessage(descriptor, values, {
        ignoreTag: ignoreTag
    });
    if (typeof children === 'function') return children(Array.isArray(nodes) ? nodes : [
        nodes
    ]);
    if (Component) return $5FkrB.createElement(Component, null, $5FkrB.Children.toArray(nodes));
    return $5FkrB.createElement($5FkrB.Fragment, null, nodes);
}
$d8c258b384a9ab14$var$FormattedMessage.displayName = 'FormattedMessage';
var $d8c258b384a9ab14$var$MemoizedFormattedMessage = $5FkrB.memo($d8c258b384a9ab14$var$FormattedMessage, $d8c258b384a9ab14$var$areEqual);
$d8c258b384a9ab14$var$MemoizedFormattedMessage.displayName = 'MemoizedFormattedMessage';
var $d8c258b384a9ab14$export$2e2bcd8739ae039 = $d8c258b384a9ab14$var$MemoizedFormattedMessage;

});


parcelRegister("jSI6G", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */ var $e795462a5dbdab0d$var$invariant = function(condition, format, a, b, c, d, e, f) {
    if (!condition) {
        var error;
        if (format === undefined) error = new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");
        else {
            var args = [
                a,
                b,
                c,
                d,
                e,
                f
            ];
            var argIndex = 0;
            error = new Error(format.replace(/%s/g, function() {
                return args[argIndex++];
            }));
            error.name = 'Invariant Violation';
        }
        error.framesToPop = 1; // we don't care about invariant's own frame
        throw error;
    }
};
module.exports = $e795462a5dbdab0d$var$invariant;

});

parcelRegister("bb0Oq", function(module, exports) {
$parcel$export(module.exports, "default", () => $82315a19372f332f$export$2e2bcd8739ae039);
/* heading.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");

var $JacHq = parcelRequire("JacHq");

var $dBFVZ = parcelRequire("dBFVZ");

var $62HmU = parcelRequire("62HmU");

var $gTJhB = parcelRequire("gTJhB");

var $3ZMUU = parcelRequire("3ZMUU");
var $82315a19372f332f$var$sizeTagMap = {
    xxlarge: 'h1',
    xlarge: 'h1',
    large: 'h2',
    medium: 'h3',
    small: 'h4',
    xsmall: 'h5',
    xxsmall: 'h6'
};
/**
 * Using '&&' here to increase specificity of Heading styles such that app styles like ".wiki-content h4" cannot override this component.
 */ var $82315a19372f332f$var$styles = {
    reset: "_dxsyidpf _1i144jg8 _nmk4glyw"
};
/**
 * Using '&&' here to increase specificity of Heading styles such that app styles like ".wiki-content h4" cannot override this component.
 */ var $82315a19372f332f$var$headingColorStyles = {
    'color.text': "_1w90i7uo",
    'color.text.inverse': "_1w9015cr",
    'color.text.warning.inverse': "_1w901yd3"
};
/**
 * Using '&&' here to increase specificity of Heading styles such that app styles like ".wiki-content h4" cannot override this component.
 */ var $82315a19372f332f$var$headingSizeStyles = {
    xxlarge: "_fqox1iff",
    xlarge: "_fqox12ln",
    large: "_fqox10sd",
    medium: "_fqox1af2",
    small: "_fqox1e3o",
    xsmall: "_fqox1qyo",
    xxsmall: "_fqoxi4vh"
};
/**
 * @codegenEnd
 */ var $82315a19372f332f$var$useColor = function useColor(colorProp) {
    var surface = (0, $62HmU.useSurface)();
    if (colorProp) return colorProp;
    if ((0, $dBFVZ.inverseColorMap).hasOwnProperty(surface)) return (0, $dBFVZ.inverseColorMap)[surface];
    return 'color.text';
};
/**
 * __Heading__
 *
 * Heading is a typography component used to display text in defined sizes and styles.
 *
 * @example
 *
 * ```jsx
 * <Heading size="xxlarge">Page title</Heading>
 * ```
 */ var $82315a19372f332f$var$Heading = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function(props, ref) {
    var children = props.children, size = props.size, id = props.id, testId = props.testId, as = props.as, colorProp = props.color;
    typeof $3ZMUU;
    var _useHeading = (0, $gTJhB.useHeading)($82315a19372f332f$var$sizeTagMap[size]), _useHeading2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useHeading, 2), hLevel = _useHeading2[0], inferredElement = _useHeading2[1];
    var Component = as || inferredElement;
    var needsAriaRole = Component === 'div' && hLevel;
    var color = $82315a19372f332f$var$useColor(colorProp);
    return /*#__PURE__*/ $5FkrB.createElement(Component, {
        id: id,
        ref: ref,
        "data-testid": testId,
        role: needsAriaRole ? 'heading' : undefined,
        "aria-level": needsAriaRole ? hLevel : undefined,
        className: (0, $JacHq.default)([
            $82315a19372f332f$var$styles.reset,
            $82315a19372f332f$var$headingSizeStyles[size],
            $82315a19372f332f$var$headingColorStyles[color]
        ])
    }, children);
});
var $82315a19372f332f$export$2e2bcd8739ae039 = $82315a19372f332f$var$Heading;

});
parcelRegister("JacHq", function(module, exports) {
$parcel$export(module.exports, "default", () => $087c1e5a0faa63af$export$2e2bcd8739ae039);
/**
 * This length includes the underscore,
 * e.g. `"_1s4A"` would be a valid atomic group hash.
 */ const $087c1e5a0faa63af$var$ATOMIC_GROUP_LENGTH = 5;
function $087c1e5a0faa63af$export$2e2bcd8739ae039(classNames) {
    // Shortcut: nothing to do
    if (!classNames.length) return;
    // Shortcut: don't need to do anything if we only have a single classname
    if (classNames.length === 1 && classNames[0] && // checking to see if `classNames[0]` is a string that contains other classnames
    !classNames[0].includes(' ')) return classNames[0];
    // Using an object rather than a `Map` as it performed better in our benchmarks.
    // Would be happy to move to `Map` if it proved to be better under real conditions.
    const map = {};
    // Note: using loops to minimize iterations over the collection
    for (const value of classNames){
        // Exclude all falsy values, which leaves us with populated strings
        if (!value) continue;
        // a `value` can contain multiple classnames
        const list = value.split(' ');
        for (const className of list){
            /**
             * For atomic style classnames: the `key` is the `group`
             *
             * - Later atomic classnames with the same `group` will override earlier ones
             *   (which is what we want).
             * - Assumes atomic classnames are the only things that start with `_`
             * - Could use a regex to ensure that atomic classnames are structured how we expect,
             *   but did not add that for now as it did slow things down a bit.
             *
             * For other classnames: the `key` is the whole classname
             * - Okay to remove duplicates as doing so does not impact specificity
             *
             * */ const key = className.startsWith('_') ? className.slice(0, $087c1e5a0faa63af$var$ATOMIC_GROUP_LENGTH) : className;
            map[key] = className;
        }
    }
    /**
     * We are converting the `map` into a string.
     *
     * The simple way to do this would be `Object.values(map).join(' ')`.
     * However, the approach below performs 10%-20% better in benchmarks.
     *
     * For `ax()` it feels right to squeeze as much runtime performance out as we can.
     */ let result = '';
    for(const key in map)result += map[key] + ' ';
    // If we have an empty string, then our `map` was empty.
    if (!result) return;
    // remove last " " from the result (we added " " at the end of every value)
    return result.trimEnd();
}

});

parcelRegister("dBFVZ", function(module, exports) {
$parcel$export(module.exports, "inverseColorMap", () => $9e7f425b8bdc7913$export$2185ce37f9bdd963);

var $25nEq = parcelRequire("25nEq");

var $74Zh5 = parcelRequire("74Zh5");

var $b4ssl = parcelRequire("b4ssl");
function $9e7f425b8bdc7913$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $9e7f425b8bdc7913$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $9e7f425b8bdc7913$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $9e7f425b8bdc7913$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $9e7f425b8bdc7913$export$6ccdbebca2ee545f = {
    '100%': '100%',
    'size.100': '1rem',
    'size.200': '1.5rem',
    'size.300': '2rem',
    'size.400': '2.5rem',
    'size.500': '3rem',
    'size.600': '6rem',
    'size.1000': '12rem'
};
var $9e7f425b8bdc7913$export$958d0ae7f2977ae4 = {
    'space.0': "var(--ds-space-0, 0px)",
    'space.025': "var(--ds-space-025, 2px)",
    'space.050': "var(--ds-space-050, 4px)",
    'space.075': "var(--ds-space-075, 6px)",
    'space.100': "var(--ds-space-100, 8px)",
    'space.150': "var(--ds-space-150, 12px)",
    'space.200': "var(--ds-space-200, 16px)",
    'space.250': "var(--ds-space-250, 20px)",
    'space.300': "var(--ds-space-300, 24px)",
    'space.400': "var(--ds-space-400, 32px)",
    'space.500': "var(--ds-space-500, 40px)",
    'space.600': "var(--ds-space-600, 48px)",
    'space.800': "var(--ds-space-800, 64px)",
    'space.1000': "var(--ds-space-1000, 80px)"
};
var $9e7f425b8bdc7913$export$d2dc61f58390201c = {
    'space.negative.025': "var(--ds-space-negative-025, -2px)",
    'space.negative.050': "var(--ds-space-negative-050, -4px)",
    'space.negative.075': "var(--ds-space-negative-075, -6px)",
    'space.negative.100': "var(--ds-space-negative-100, -8px)",
    'space.negative.150': "var(--ds-space-negative-150, -12px)",
    'space.negative.200': "var(--ds-space-negative-200, -16px)",
    'space.negative.250': "var(--ds-space-negative-250, -20px)",
    'space.negative.300': "var(--ds-space-negative-300, -24px)",
    'space.negative.400': "var(--ds-space-negative-400, -32px)"
};
var $9e7f425b8bdc7913$export$632685d741f3dbbf = $9e7f425b8bdc7913$var$_objectSpread($9e7f425b8bdc7913$var$_objectSpread({}, $9e7f425b8bdc7913$export$958d0ae7f2977ae4), $9e7f425b8bdc7913$export$d2dc61f58390201c);
var $9e7f425b8bdc7913$export$2185ce37f9bdd963 = {
    'color.background.neutral.bold': 'color.text.inverse',
    'color.background.neutral.bold.hovered': 'color.text.inverse',
    'color.background.neutral.bold.pressed': 'color.text.inverse',
    'color.background.selected.bold': 'color.text.inverse',
    'color.background.selected.bold.hovered': 'color.text.inverse',
    'color.background.selected.bold.pressed': 'color.text.inverse',
    'color.background.brand.bold': 'color.text.inverse',
    'color.background.brand.bold.hovered': 'color.text.inverse',
    'color.background.brand.bold.pressed': 'color.text.inverse',
    'color.background.brand.boldest': 'color.text.inverse',
    'color.background.brand.boldest.hovered': 'color.text.inverse',
    'color.background.brand.boldest.pressed': 'color.text.inverse',
    'color.background.danger.bold': 'color.text.inverse',
    'color.background.danger.bold.hovered': 'color.text.inverse',
    'color.background.danger.bold.pressed': 'color.text.inverse',
    'color.background.warning.bold': 'color.text.warning.inverse',
    'color.background.warning.bold.hovered': 'color.text.warning.inverse',
    'color.background.warning.bold.pressed': 'color.text.warning.inverse',
    'color.background.success.bold': 'color.text.inverse',
    'color.background.success.bold.hovered': 'color.text.inverse',
    'color.background.success.bold.pressed': 'color.text.inverse',
    'color.background.discovery.bold': 'color.text.inverse',
    'color.background.discovery.bold.hovered': 'color.text.inverse',
    'color.background.discovery.bold.pressed': 'color.text.inverse',
    'color.background.information.bold': 'color.text.inverse',
    'color.background.information.bold.hovered': 'color.text.inverse',
    'color.background.information.bold.pressed': 'color.text.inverse'
};
var $9e7f425b8bdc7913$export$daf94a976c798b4f = {
    'opacity.disabled': "var(--ds-opacity-disabled, 0.4)",
    'opacity.loading': "var(--ds-opacity-loading, 0.2)"
};
var $9e7f425b8bdc7913$export$7aff6e7ba39bb774 = {
    'elevation.shadow.overflow': "var(--ds-shadow-overflow, 0px 0px 8px #1E1F21, 0px 0px 1px #1E1F21)",
    'elevation.shadow.overflow.perimeter': "var(--ds-shadow-overflow-perimeter, #1E1F211f)",
    'elevation.shadow.overflow.spread': "var(--ds-shadow-overflow-spread, #1E1F2129)",
    'elevation.shadow.overlay': "var(--ds-shadow-overlay, 0px 8px 12px #1E1F21, 0px 0px 1px #1E1F21)",
    'elevation.shadow.raised': "var(--ds-shadow-raised, 0px 1px 1px #1E1F21, 0px 0px 1px #1E1F21)"
};
var $9e7f425b8bdc7913$export$41a358c9c2356760 = {
    'elevation.surface': "var(--ds-surface, #FFFFFF)",
    'elevation.surface.hovered': "var(--ds-surface-hovered, #F0F1F2)",
    'elevation.surface.pressed': "var(--ds-surface-pressed, #DDDEE1)",
    'elevation.surface.overlay': "var(--ds-surface-overlay, #FFFFFF)",
    'elevation.surface.overlay.hovered': "var(--ds-surface-overlay-hovered, #F0F1F2)",
    'elevation.surface.overlay.pressed': "var(--ds-surface-overlay-pressed, #DDDEE1)",
    'elevation.surface.raised': "var(--ds-surface-raised, #FFFFFF)",
    'elevation.surface.raised.hovered': "var(--ds-surface-raised-hovered, #F0F1F2)",
    'elevation.surface.raised.pressed': "var(--ds-surface-raised-pressed, #DDDEE1)",
    'elevation.surface.sunken': "var(--ds-surface-sunken, #F8F8F8)"
};
var $9e7f425b8bdc7913$export$1531ad5bb3fbedac = {
    'color.border': "var(--ds-border, #0B120E24)",
    'color.border.accent.lime': "var(--ds-border-accent-lime, #6A9A23)",
    'color.border.accent.red': "var(--ds-border-accent-red, #E2483D)",
    'color.border.accent.orange': "var(--ds-border-accent-orange, #E06C00)",
    'color.border.accent.yellow': "var(--ds-border-accent-yellow, #B38600)",
    'color.border.accent.green': "var(--ds-border-accent-green, #22A06B)",
    'color.border.accent.teal': "var(--ds-border-accent-teal, #2898BD)",
    'color.border.accent.blue': "var(--ds-border-accent-blue, #357DE8)",
    'color.border.accent.purple': "var(--ds-border-accent-purple, #AF59E1)",
    'color.border.accent.magenta': "var(--ds-border-accent-magenta, #CD519D)",
    'color.border.accent.gray': "var(--ds-border-accent-gray, #7D818A)",
    'color.border.disabled': "var(--ds-border-disabled, #0515240F)",
    'color.border.focused': "var(--ds-border-focused, #4688EC)",
    'color.border.input': "var(--ds-border-input, #8C8F97)",
    'color.border.inverse': "var(--ds-border-inverse, #FFFFFF)",
    'color.border.selected': "var(--ds-border-selected, #1868DB)",
    'color.border.brand': "var(--ds-border-brand, #1868DB)",
    'color.border.danger': "var(--ds-border-danger, #E2483D)",
    'color.border.warning': "var(--ds-border-warning, #E06C00)",
    'color.border.success': "var(--ds-border-success, #6A9A23)",
    'color.border.discovery': "var(--ds-border-discovery, #AF59E1)",
    'color.border.information': "var(--ds-border-information, #357DE8)",
    'color.border.bold': "var(--ds-border-bold, #7D818A)"
};
var $9e7f425b8bdc7913$export$d1d79bf68ac056bd = {
    'color.background.accent.lime.subtlest': "var(--ds-background-accent-lime-subtlest, #EFFFD6)",
    'color.background.accent.lime.subtlest.hovered': "var(--ds-background-accent-lime-subtlest-hovered, #D3F1A7)",
    'color.background.accent.lime.subtlest.pressed': "var(--ds-background-accent-lime-subtlest-pressed, #BDE97C)",
    'color.background.accent.lime.subtler': "var(--ds-background-accent-lime-subtler, #D3F1A7)",
    'color.background.accent.lime.subtler.hovered': "var(--ds-background-accent-lime-subtler-hovered, #BDE97C)",
    'color.background.accent.lime.subtler.pressed': "var(--ds-background-accent-lime-subtler-pressed, #B3DF72)",
    'color.background.accent.lime.subtle': "var(--ds-background-accent-lime-subtle, #94C748)",
    'color.background.accent.lime.subtle.hovered': "var(--ds-background-accent-lime-subtle-hovered, #B3DF72)",
    'color.background.accent.lime.subtle.pressed': "var(--ds-background-accent-lime-subtle-pressed, #BDE97C)",
    'color.background.accent.lime.bolder': "var(--ds-background-accent-lime-bolder, #5B7F24)",
    'color.background.accent.lime.bolder.hovered': "var(--ds-background-accent-lime-bolder-hovered, #4C6B1F)",
    'color.background.accent.lime.bolder.pressed': "var(--ds-background-accent-lime-bolder-pressed, #3F5224)",
    'color.background.accent.red.subtlest': "var(--ds-background-accent-red-subtlest, #FFECEB)",
    'color.background.accent.red.subtlest.hovered': "var(--ds-background-accent-red-subtlest-hovered, #FFD5D2)",
    'color.background.accent.red.subtlest.pressed': "var(--ds-background-accent-red-subtlest-pressed, #FFB8B2)",
    'color.background.accent.red.subtler': "var(--ds-background-accent-red-subtler, #FFD5D2)",
    'color.background.accent.red.subtler.hovered': "var(--ds-background-accent-red-subtler-hovered, #FFB8B2)",
    'color.background.accent.red.subtler.pressed': "var(--ds-background-accent-red-subtler-pressed, #FD9891)",
    'color.background.accent.red.subtle': "var(--ds-background-accent-red-subtle, #F87168)",
    'color.background.accent.red.subtle.hovered': "var(--ds-background-accent-red-subtle-hovered, #FD9891)",
    'color.background.accent.red.subtle.pressed': "var(--ds-background-accent-red-subtle-pressed, #FFB8B2)",
    'color.background.accent.red.bolder': "var(--ds-background-accent-red-bolder, #C9372C)",
    'color.background.accent.red.bolder.hovered': "var(--ds-background-accent-red-bolder-hovered, #AE2E24)",
    'color.background.accent.red.bolder.pressed': "var(--ds-background-accent-red-bolder-pressed, #872821)",
    'color.background.accent.orange.subtlest': "var(--ds-background-accent-orange-subtlest, #FFF5DB)",
    'color.background.accent.orange.subtlest.hovered': "var(--ds-background-accent-orange-subtlest-hovered, #FCE4A6)",
    'color.background.accent.orange.subtlest.pressed': "var(--ds-background-accent-orange-subtlest-pressed, #FBD779)",
    'color.background.accent.orange.subtler': "var(--ds-background-accent-orange-subtler, #FCE4A6)",
    'color.background.accent.orange.subtler.hovered': "var(--ds-background-accent-orange-subtler-hovered, #FBD779)",
    'color.background.accent.orange.subtler.pressed': "var(--ds-background-accent-orange-subtler-pressed, #FBC828)",
    'color.background.accent.orange.subtle': "var(--ds-background-accent-orange-subtle, #FCA700)",
    'color.background.accent.orange.subtle.hovered': "var(--ds-background-accent-orange-subtle-hovered, #FBC828)",
    'color.background.accent.orange.subtle.pressed': "var(--ds-background-accent-orange-subtle-pressed, #FBD779)",
    'color.background.accent.orange.bolder': "var(--ds-background-accent-orange-bolder, #BD5B00)",
    'color.background.accent.orange.bolder.hovered': "var(--ds-background-accent-orange-bolder-hovered, #9E4C00)",
    'color.background.accent.orange.bolder.pressed': "var(--ds-background-accent-orange-bolder-pressed, #7A3B00)",
    'color.background.accent.yellow.subtlest': "var(--ds-background-accent-yellow-subtlest, #FEF7C8)",
    'color.background.accent.yellow.subtlest.hovered': "var(--ds-background-accent-yellow-subtlest-hovered, #F5E989)",
    'color.background.accent.yellow.subtlest.pressed': "var(--ds-background-accent-yellow-subtlest-pressed, #EFDD4E)",
    'color.background.accent.yellow.subtler': "var(--ds-background-accent-yellow-subtler, #F5E989)",
    'color.background.accent.yellow.subtler.hovered': "var(--ds-background-accent-yellow-subtler-hovered, #EFDD4E)",
    'color.background.accent.yellow.subtler.pressed': "var(--ds-background-accent-yellow-subtler-pressed, #EED12B)",
    'color.background.accent.yellow.subtle': "var(--ds-background-accent-yellow-subtle, #EED12B)",
    'color.background.accent.yellow.subtle.hovered': "var(--ds-background-accent-yellow-subtle-hovered, #DDB30E)",
    'color.background.accent.yellow.subtle.pressed': "var(--ds-background-accent-yellow-subtle-pressed, #EFDD4E)",
    'color.background.accent.yellow.bolder': "var(--ds-background-accent-yellow-bolder, #946F00)",
    'color.background.accent.yellow.bolder.hovered': "var(--ds-background-accent-yellow-bolder-hovered, #7F5F01)",
    'color.background.accent.yellow.bolder.pressed': "var(--ds-background-accent-yellow-bolder-pressed, #614A05)",
    'color.background.accent.green.subtlest': "var(--ds-background-accent-green-subtlest, #DCFFF1)",
    'color.background.accent.green.subtlest.hovered': "var(--ds-background-accent-green-subtlest-hovered, #BAF3DB)",
    'color.background.accent.green.subtlest.pressed': "var(--ds-background-accent-green-subtlest-pressed, #97EDC9)",
    'color.background.accent.green.subtler': "var(--ds-background-accent-green-subtler, #BAF3DB)",
    'color.background.accent.green.subtler.hovered': "var(--ds-background-accent-green-subtler-hovered, #97EDC9)",
    'color.background.accent.green.subtler.pressed': "var(--ds-background-accent-green-subtler-pressed, #7EE2B8)",
    'color.background.accent.green.subtle': "var(--ds-background-accent-green-subtle, #4BCE97)",
    'color.background.accent.green.subtle.hovered': "var(--ds-background-accent-green-subtle-hovered, #7EE2B8)",
    'color.background.accent.green.subtle.pressed': "var(--ds-background-accent-green-subtle-pressed, #97EDC9)",
    'color.background.accent.green.bolder': "var(--ds-background-accent-green-bolder, #1F845A)",
    'color.background.accent.green.bolder.hovered': "var(--ds-background-accent-green-bolder-hovered, #216E4E)",
    'color.background.accent.green.bolder.pressed': "var(--ds-background-accent-green-bolder-pressed, #19573D)",
    'color.background.accent.teal.subtlest': "var(--ds-background-accent-teal-subtlest, #E7F9FF)",
    'color.background.accent.teal.subtlest.hovered': "var(--ds-background-accent-teal-subtlest-hovered, #C6EDFB)",
    'color.background.accent.teal.subtlest.pressed': "var(--ds-background-accent-teal-subtlest-pressed, #B1E4F7)",
    'color.background.accent.teal.subtler': "var(--ds-background-accent-teal-subtler, #C6EDFB)",
    'color.background.accent.teal.subtler.hovered': "var(--ds-background-accent-teal-subtler-hovered, #B1E4F7)",
    'color.background.accent.teal.subtler.pressed': "var(--ds-background-accent-teal-subtler-pressed, #9DD9EE)",
    'color.background.accent.teal.subtle': "var(--ds-background-accent-teal-subtle, #6CC3E0)",
    'color.background.accent.teal.subtle.hovered': "var(--ds-background-accent-teal-subtle-hovered, #9DD9EE)",
    'color.background.accent.teal.subtle.pressed': "var(--ds-background-accent-teal-subtle-pressed, #B1E4F7)",
    'color.background.accent.teal.bolder': "var(--ds-background-accent-teal-bolder, #227D9B)",
    'color.background.accent.teal.bolder.hovered': "var(--ds-background-accent-teal-bolder-hovered, #206A83)",
    'color.background.accent.teal.bolder.pressed': "var(--ds-background-accent-teal-bolder-pressed, #1A5265)",
    'color.background.accent.blue.subtlest': "var(--ds-background-accent-blue-subtlest, #E9F2FE)",
    'color.background.accent.blue.subtlest.hovered': "var(--ds-background-accent-blue-subtlest-hovered, #CFE1FD)",
    'color.background.accent.blue.subtlest.pressed': "var(--ds-background-accent-blue-subtlest-pressed, #ADCBFB)",
    'color.background.accent.blue.subtler': "var(--ds-background-accent-blue-subtler, #CFE1FD)",
    'color.background.accent.blue.subtler.hovered': "var(--ds-background-accent-blue-subtler-hovered, #ADCBFB)",
    'color.background.accent.blue.subtler.pressed': "var(--ds-background-accent-blue-subtler-pressed, #8FB8F6)",
    'color.background.accent.blue.subtle': "var(--ds-background-accent-blue-subtle, #669DF1)",
    'color.background.accent.blue.subtle.hovered': "var(--ds-background-accent-blue-subtle-hovered, #8FB8F6)",
    'color.background.accent.blue.subtle.pressed': "var(--ds-background-accent-blue-subtle-pressed, #ADCBFB)",
    'color.background.accent.blue.bolder': "var(--ds-background-accent-blue-bolder, #1868DB)",
    'color.background.accent.blue.bolder.hovered': "var(--ds-background-accent-blue-bolder-hovered, #1558BC)",
    'color.background.accent.blue.bolder.pressed': "var(--ds-background-accent-blue-bolder-pressed, #144794)",
    'color.background.accent.purple.subtlest': "var(--ds-background-accent-purple-subtlest, #F8EEFE)",
    'color.background.accent.purple.subtlest.hovered': "var(--ds-background-accent-purple-subtlest-hovered, #EED7FC)",
    'color.background.accent.purple.subtlest.pressed': "var(--ds-background-accent-purple-subtlest-pressed, #E3BDFA)",
    'color.background.accent.purple.subtler': "var(--ds-background-accent-purple-subtler, #EED7FC)",
    'color.background.accent.purple.subtler.hovered': "var(--ds-background-accent-purple-subtler-hovered, #E3BDFA)",
    'color.background.accent.purple.subtler.pressed': "var(--ds-background-accent-purple-subtler-pressed, #D8A0F7)",
    'color.background.accent.purple.subtle': "var(--ds-background-accent-purple-subtle, #C97CF4)",
    'color.background.accent.purple.subtle.hovered': "var(--ds-background-accent-purple-subtle-hovered, #D8A0F7)",
    'color.background.accent.purple.subtle.pressed': "var(--ds-background-accent-purple-subtle-pressed, #E3BDFA)",
    'color.background.accent.purple.bolder': "var(--ds-background-accent-purple-bolder, #964AC0)",
    'color.background.accent.purple.bolder.hovered': "var(--ds-background-accent-purple-bolder-hovered, #803FA5)",
    'color.background.accent.purple.bolder.pressed': "var(--ds-background-accent-purple-bolder-pressed, #673286)",
    'color.background.accent.magenta.subtlest': "var(--ds-background-accent-magenta-subtlest, #FFECF8)",
    'color.background.accent.magenta.subtlest.hovered': "var(--ds-background-accent-magenta-subtlest-hovered, #FDD0EC)",
    'color.background.accent.magenta.subtlest.pressed': "var(--ds-background-accent-magenta-subtlest-pressed, #FCB6E1)",
    'color.background.accent.magenta.subtler': "var(--ds-background-accent-magenta-subtler, #FDD0EC)",
    'color.background.accent.magenta.subtler.hovered': "var(--ds-background-accent-magenta-subtler-hovered, #FCB6E1)",
    'color.background.accent.magenta.subtler.pressed': "var(--ds-background-accent-magenta-subtler-pressed, #F797D2)",
    'color.background.accent.magenta.subtle': "var(--ds-background-accent-magenta-subtle, #E774BB)",
    'color.background.accent.magenta.subtle.hovered': "var(--ds-background-accent-magenta-subtle-hovered, #F797D2)",
    'color.background.accent.magenta.subtle.pressed': "var(--ds-background-accent-magenta-subtle-pressed, #FCB6E1)",
    'color.background.accent.magenta.bolder': "var(--ds-background-accent-magenta-bolder, #AE4787)",
    'color.background.accent.magenta.bolder.hovered': "var(--ds-background-accent-magenta-bolder-hovered, #943D73)",
    'color.background.accent.magenta.bolder.pressed': "var(--ds-background-accent-magenta-bolder-pressed, #77325B)",
    'color.background.accent.gray.subtlest': "var(--ds-background-accent-gray-subtlest, #F0F1F2)",
    'color.background.accent.gray.subtlest.hovered': "var(--ds-background-accent-gray-subtlest-hovered, #DDDEE1)",
    'color.background.accent.gray.subtlest.pressed': "var(--ds-background-accent-gray-subtlest-pressed, #B7B9BE)",
    'color.background.accent.gray.subtler': "var(--ds-background-accent-gray-subtler, #DDDEE1)",
    'color.background.accent.gray.subtler.hovered': "var(--ds-background-accent-gray-subtler-hovered, #B7B9BE)",
    'color.background.accent.gray.subtler.pressed': "var(--ds-background-accent-gray-subtler-pressed, #8C8F97)",
    'color.background.accent.gray.subtle': "var(--ds-background-accent-gray-subtle, #8C8F97)",
    'color.background.accent.gray.subtle.hovered': "var(--ds-background-accent-gray-subtle-hovered, #B7B9BE)",
    'color.background.accent.gray.subtle.pressed': "var(--ds-background-accent-gray-subtle-pressed, #DDDEE1)",
    'color.background.accent.gray.bolder': "var(--ds-background-accent-gray-bolder, #6B6E76)",
    'color.background.accent.gray.bolder.hovered': "var(--ds-background-accent-gray-bolder-hovered, #505258)",
    'color.background.accent.gray.bolder.pressed': "var(--ds-background-accent-gray-bolder-pressed, #3B3D42)",
    'color.background.disabled': "var(--ds-background-disabled, #17171708)",
    'color.background.input': "var(--ds-background-input, #FFFFFF)",
    'color.background.input.hovered': "var(--ds-background-input-hovered, #F8F8F8)",
    'color.background.input.pressed': "var(--ds-background-input-pressed, #FFFFFF)",
    'color.background.inverse.subtle': "var(--ds-background-inverse-subtle, #00000029)",
    'color.background.inverse.subtle.hovered': "var(--ds-background-inverse-subtle-hovered, #0000003D)",
    'color.background.inverse.subtle.pressed': "var(--ds-background-inverse-subtle-pressed, #00000052)",
    'color.background.neutral': "var(--ds-background-neutral, #0515240F)",
    'color.background.neutral.hovered': "var(--ds-background-neutral-hovered, #0B120E24)",
    'color.background.neutral.pressed': "var(--ds-background-neutral-pressed, #080F214A)",
    'color.background.neutral.subtle': "var(--ds-background-neutral-subtle, #00000000)",
    'color.background.neutral.subtle.hovered': "var(--ds-background-neutral-subtle-hovered, #0515240F)",
    'color.background.neutral.subtle.pressed': "var(--ds-background-neutral-subtle-pressed, #0B120E24)",
    'color.background.neutral.bold': "var(--ds-background-neutral-bold, #292A2E)",
    'color.background.neutral.bold.hovered': "var(--ds-background-neutral-bold-hovered, #3B3D42)",
    'color.background.neutral.bold.pressed': "var(--ds-background-neutral-bold-pressed, #505258)",
    'color.background.selected': "var(--ds-background-selected, #E9F2FE)",
    'color.background.selected.hovered': "var(--ds-background-selected-hovered, #CFE1FD)",
    'color.background.selected.pressed': "var(--ds-background-selected-pressed, #8FB8F6)",
    'color.background.selected.bold': "var(--ds-background-selected-bold, #1868DB)",
    'color.background.selected.bold.hovered': "var(--ds-background-selected-bold-hovered, #1558BC)",
    'color.background.selected.bold.pressed': "var(--ds-background-selected-bold-pressed, #123263)",
    'color.background.brand.subtlest': "var(--ds-background-brand-subtlest, #E9F2FE)",
    'color.background.brand.subtlest.hovered': "var(--ds-background-brand-subtlest-hovered, #CFE1FD)",
    'color.background.brand.subtlest.pressed': "var(--ds-background-brand-subtlest-pressed, #ADCBFB)",
    'color.background.brand.bold': "var(--ds-background-brand-bold, #1868DB)",
    'color.background.brand.bold.hovered': "var(--ds-background-brand-bold-hovered, #1558BC)",
    'color.background.brand.bold.pressed': "var(--ds-background-brand-bold-pressed, #144794)",
    'color.background.brand.boldest': "var(--ds-background-brand-boldest, #1C2B42)",
    'color.background.brand.boldest.hovered': "var(--ds-background-brand-boldest-hovered, #123263)",
    'color.background.brand.boldest.pressed': "var(--ds-background-brand-boldest-pressed, #144794)",
    'color.background.danger': "var(--ds-background-danger, #FFECEB)",
    'color.background.danger.hovered': "var(--ds-background-danger-hovered, #FFD5D2)",
    'color.background.danger.pressed': "var(--ds-background-danger-pressed, #FFB8B2)",
    'color.background.danger.subtler': "var(--ds-background-danger-subtler, #FFD5D2)",
    'color.background.danger.subtler.hovered': "var(--ds-background-danger-subtler-hovered, #FFB8B2)",
    'color.background.danger.subtler.pressed': "var(--ds-background-danger-subtler-pressed, #FD9891)",
    'color.background.danger.bold': "var(--ds-background-danger-bold, #C9372C)",
    'color.background.danger.bold.hovered': "var(--ds-background-danger-bold-hovered, #AE2E24)",
    'color.background.danger.bold.pressed': "var(--ds-background-danger-bold-pressed, #872821)",
    'color.background.warning': "var(--ds-background-warning, #FFF5DB)",
    'color.background.warning.hovered': "var(--ds-background-warning-hovered, #FCE4A6)",
    'color.background.warning.pressed': "var(--ds-background-warning-pressed, #FBD779)",
    'color.background.warning.subtler': "var(--ds-background-warning-subtler, #FCE4A6)",
    'color.background.warning.subtler.hovered': "var(--ds-background-warning-subtler-hovered, #FBD779)",
    'color.background.warning.subtler.pressed': "var(--ds-background-warning-subtler-pressed, #FBC828)",
    'color.background.warning.bold': "var(--ds-background-warning-bold, #FBC828)",
    'color.background.warning.bold.hovered': "var(--ds-background-warning-bold-hovered, #FCA700)",
    'color.background.warning.bold.pressed': "var(--ds-background-warning-bold-pressed, #F68909)",
    'color.background.success': "var(--ds-background-success, #EFFFD6)",
    'color.background.success.hovered': "var(--ds-background-success-hovered, #D3F1A7)",
    'color.background.success.pressed': "var(--ds-background-success-pressed, #BDE97C)",
    'color.background.success.subtler': "var(--ds-background-success-subtler, #D3F1A7)",
    'color.background.success.subtler.hovered': "var(--ds-background-success-subtler-hovered, #BDE97C)",
    'color.background.success.subtler.pressed': "var(--ds-background-success-subtler-pressed, #B3DF72)",
    'color.background.success.bold': "var(--ds-background-success-bold, #5B7F24)",
    'color.background.success.bold.hovered': "var(--ds-background-success-bold-hovered, #4C6B1F)",
    'color.background.success.bold.pressed': "var(--ds-background-success-bold-pressed, #3F5224)",
    'color.background.discovery': "var(--ds-background-discovery, #F8EEFE)",
    'color.background.discovery.hovered': "var(--ds-background-discovery-hovered, #EED7FC)",
    'color.background.discovery.pressed': "var(--ds-background-discovery-pressed, #E3BDFA)",
    'color.background.discovery.subtler': "var(--ds-background-discovery-subtler, #EED7FC)",
    'color.background.discovery.subtler.hovered': "var(--ds-background-discovery-subtler-hovered, #E3BDFA)",
    'color.background.discovery.subtler.pressed': "var(--ds-background-discovery-subtler-pressed, #D8A0F7)",
    'color.background.discovery.bold': "var(--ds-background-discovery-bold, #964AC0)",
    'color.background.discovery.bold.hovered': "var(--ds-background-discovery-bold-hovered, #803FA5)",
    'color.background.discovery.bold.pressed': "var(--ds-background-discovery-bold-pressed, #673286)",
    'color.background.information': "var(--ds-background-information, #E9F2FE)",
    'color.background.information.hovered': "var(--ds-background-information-hovered, #CFE1FD)",
    'color.background.information.pressed': "var(--ds-background-information-pressed, #ADCBFB)",
    'color.background.information.subtler': "var(--ds-background-information-subtler, #CFE1FD)",
    'color.background.information.subtler.hovered': "var(--ds-background-information-subtler-hovered, #ADCBFB)",
    'color.background.information.subtler.pressed': "var(--ds-background-information-subtler-pressed, #8FB8F6)",
    'color.background.information.bold': "var(--ds-background-information-bold, #1868DB)",
    'color.background.information.bold.hovered': "var(--ds-background-information-bold-hovered, #1558BC)",
    'color.background.information.bold.pressed': "var(--ds-background-information-bold-pressed, #144794)",
    'color.blanket': "var(--ds-blanket, #050C1F75)",
    'color.blanket.selected': "var(--ds-blanket-selected, #388BFF14)",
    'color.blanket.danger': "var(--ds-blanket-danger, #EF5C4814)",
    'color.skeleton': "var(--ds-skeleton, #0515240F)",
    'color.skeleton.subtle': "var(--ds-skeleton-subtle, #17171708)",
    'elevation.surface': "var(--ds-surface, #FFFFFF)",
    'elevation.surface.hovered': "var(--ds-surface-hovered, #F0F1F2)",
    'elevation.surface.pressed': "var(--ds-surface-pressed, #DDDEE1)",
    'elevation.surface.overlay': "var(--ds-surface-overlay, #FFFFFF)",
    'elevation.surface.overlay.hovered': "var(--ds-surface-overlay-hovered, #F0F1F2)",
    'elevation.surface.overlay.pressed': "var(--ds-surface-overlay-pressed, #DDDEE1)",
    'elevation.surface.raised': "var(--ds-surface-raised, #FFFFFF)",
    'elevation.surface.raised.hovered': "var(--ds-surface-raised-hovered, #F0F1F2)",
    'elevation.surface.raised.pressed': "var(--ds-surface-raised-pressed, #DDDEE1)",
    'elevation.surface.sunken': "var(--ds-surface-sunken, #F8F8F8)",
    'utility.elevation.surface.current': "var(--ds-elevation-surface-current, #FFFFFF)"
};
var $9e7f425b8bdc7913$export$8473307aa00d6ea1 = {
    'color.text': "var(--ds-text, #292A2E)",
    'color.text.accent.lime': "var(--ds-text-accent-lime, #4C6B1F)",
    'color.text.accent.lime.bolder': "var(--ds-text-accent-lime-bolder, #37471F)",
    'color.text.accent.red': "var(--ds-text-accent-red, #AE2E24)",
    'color.text.accent.red.bolder': "var(--ds-text-accent-red-bolder, #5D1F1A)",
    'color.text.accent.orange': "var(--ds-text-accent-orange, #9E4C00)",
    'color.text.accent.orange.bolder': "var(--ds-text-accent-orange-bolder, #693200)",
    'color.text.accent.yellow': "var(--ds-text-accent-yellow, #7F5F01)",
    'color.text.accent.yellow.bolder': "var(--ds-text-accent-yellow-bolder, #533F04)",
    'color.text.accent.green': "var(--ds-text-accent-green, #216E4E)",
    'color.text.accent.green.bolder': "var(--ds-text-accent-green-bolder, #164B35)",
    'color.text.accent.teal': "var(--ds-text-accent-teal, #206A83)",
    'color.text.accent.teal.bolder': "var(--ds-text-accent-teal-bolder, #164555)",
    'color.text.accent.blue': "var(--ds-text-accent-blue, #1558BC)",
    'color.text.accent.blue.bolder': "var(--ds-text-accent-blue-bolder, #123263)",
    'color.text.accent.purple': "var(--ds-text-accent-purple, #803FA5)",
    'color.text.accent.purple.bolder': "var(--ds-text-accent-purple-bolder, #48245D)",
    'color.text.accent.magenta': "var(--ds-text-accent-magenta, #943D73)",
    'color.text.accent.magenta.bolder': "var(--ds-text-accent-magenta-bolder, #50253F)",
    'color.text.accent.gray': "var(--ds-text-accent-gray, #505258)",
    'color.text.accent.gray.bolder': "var(--ds-text-accent-gray-bolder, #1E1F21)",
    'color.text.disabled': "var(--ds-text-disabled, #080F214A)",
    'color.text.inverse': "var(--ds-text-inverse, #FFFFFF)",
    'color.text.selected': "var(--ds-text-selected, #1868DB)",
    'color.text.brand': "var(--ds-text-brand, #1868DB)",
    'color.text.danger': "var(--ds-text-danger, #AE2E24)",
    'color.text.danger.bolder': "var(--ds-text-danger-bolder, #5D1F1A)",
    'color.text.warning': "var(--ds-text-warning, #9E4C00)",
    'color.text.warning.inverse': "var(--ds-text-warning-inverse, #292A2E)",
    'color.text.warning.bolder': "var(--ds-text-warning-bolder, #693200)",
    'color.text.success': "var(--ds-text-success, #4C6B1F)",
    'color.text.success.bolder': "var(--ds-text-success-bolder, #37471F)",
    'color.text.discovery': "var(--ds-text-discovery, #803FA5)",
    'color.text.discovery.bolder': "var(--ds-text-discovery-bolder, #48245D)",
    'color.text.information': "var(--ds-text-information, #1558BC)",
    'color.text.information.bolder': "var(--ds-text-information-bolder, #123263)",
    'color.text.subtlest': "var(--ds-text-subtlest, #6B6E76)",
    'color.text.subtle': "var(--ds-text-subtle, #505258)",
    'color.link': "var(--ds-link, #1868DB)",
    'color.link.pressed': "var(--ds-link-pressed, #1558BC)",
    'color.link.visited': "var(--ds-link-visited, #803FA5)",
    'color.link.visited.pressed': "var(--ds-link-visited-pressed, #48245D)"
};
var $9e7f425b8bdc7913$export$498780f74be9af68 = {
    'color.icon': "var(--ds-icon, #292A2E)",
    'color.icon.accent.lime': "var(--ds-icon-accent-lime, #6A9A23)",
    'color.icon.accent.red': "var(--ds-icon-accent-red, #C9372C)",
    'color.icon.accent.orange': "var(--ds-icon-accent-orange, #E06C00)",
    'color.icon.accent.yellow': "var(--ds-icon-accent-yellow, #B38600)",
    'color.icon.accent.green': "var(--ds-icon-accent-green, #22A06B)",
    'color.icon.accent.teal': "var(--ds-icon-accent-teal, #2898BD)",
    'color.icon.accent.blue': "var(--ds-icon-accent-blue, #357DE8)",
    'color.icon.accent.purple': "var(--ds-icon-accent-purple, #AF59E1)",
    'color.icon.accent.magenta': "var(--ds-icon-accent-magenta, #CD519D)",
    'color.icon.accent.gray': "var(--ds-icon-accent-gray, #7D818A)",
    'color.icon.disabled': "var(--ds-icon-disabled, #080F214A)",
    'color.icon.inverse': "var(--ds-icon-inverse, #FFFFFF)",
    'color.icon.selected': "var(--ds-icon-selected, #1868DB)",
    'color.icon.brand': "var(--ds-icon-brand, #1868DB)",
    'color.icon.danger': "var(--ds-icon-danger, #C9372C)",
    'color.icon.warning': "var(--ds-icon-warning, #E06C00)",
    'color.icon.warning.inverse': "var(--ds-icon-warning-inverse, #292A2E)",
    'color.icon.success': "var(--ds-icon-success, #6A9A23)",
    'color.icon.discovery': "var(--ds-icon-discovery, #AF59E1)",
    'color.icon.information': "var(--ds-icon-information, #357DE8)",
    'color.icon.subtlest': "var(--ds-icon-subtlest, #6B6E76)",
    'color.icon.subtle': "var(--ds-icon-subtle, #505258)"
};
var $9e7f425b8bdc7913$export$b5f31a7e431d2eab = {
    '1': 1,
    card: 100,
    navigation: 200,
    dialog: 300,
    layer: 400,
    blanket: 500,
    modal: 510,
    flag: 600,
    spotlight: 700,
    tooltip: 800
};
var $9e7f425b8bdc7913$export$e1b83c5210c471b8 = {
    'border.width': "var(--ds-border-width, 1px)",
    'border.width.selected': "var(--ds-border-width-selected, 2px)",
    'border.width.focused': "var(--ds-border-width-focused, 2px)"
};
var $9e7f425b8bdc7913$export$3c0a6c3e64bb180d = {
    'radius.xsmall': "var(--ds-radius-xsmall, 2px)",
    'radius.small': "var(--ds-radius-small, 3px)",
    'radius.medium': "var(--ds-radius-medium, 6px)",
    'radius.large': "var(--ds-radius-large, 8px)",
    'radius.xlarge': "var(--ds-radius-xlarge, 12px)",
    'radius.xxlarge': "var(--ds-radius-xxlarge, 16px)",
    'radius.full': "var(--ds-radius-full, 9999px)",
    'radius.tile': "var(--ds-radius-tile, 25%)"
};
var $9e7f425b8bdc7913$export$6ffa317d5e70375 = {
    'font.body': "var(--ds-font-body, normal 400 14px/20px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    // @deprecated
    'font.body.UNSAFE_small': "var(--ds-font-body-UNSAFE_small, normal 400 12px/16px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.body.large': "var(--ds-font-body-large, normal 400 16px/24px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.body.small': "var(--ds-font-body-small, normal 400 12px/16px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.code': "var(--ds-font-code, normal 400 0.875em/1 \"Atlassian Mono\", ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)",
    'font.heading.large': "var(--ds-font-heading-large, normal 653 24px/28px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.heading.medium': "var(--ds-font-heading-medium, normal 653 20px/24px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.heading.small': "var(--ds-font-heading-small, normal 653 16px/20px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.heading.xlarge': "var(--ds-font-heading-xlarge, normal 653 28px/32px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.heading.xsmall': "var(--ds-font-heading-xsmall, normal 653 14px/20px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.heading.xxlarge': "var(--ds-font-heading-xxlarge, normal 653 32px/36px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.heading.xxsmall': "var(--ds-font-heading-xxsmall, normal 653 12px/16px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.metric.large': "var(--ds-font-metric-large, normal 653 28px/32px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.metric.medium': "var(--ds-font-metric-medium, normal 653 24px/28px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.metric.small': "var(--ds-font-metric-small, normal 653 16px/20px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
};
var $9e7f425b8bdc7913$export$303e322c6b1ed114 = {
    'font.weight.bold': "var(--ds-font-weight-bold, 653)",
    'font.weight.medium': "var(--ds-font-weight-medium, 500)",
    'font.weight.regular': "var(--ds-font-weight-regular, 400)",
    'font.weight.semibold': "var(--ds-font-weight-semibold, 600)"
};
var $9e7f425b8bdc7913$export$3c7e9587132614b4 = {
    'font.family.body': "var(--ds-font-family-body, \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.family.brand.body': "var(--ds-font-family-brand-body, \"Charlie Text\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.family.brand.heading': "var(--ds-font-family-brand-heading, \"Charlie Display\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.family.code': "var(--ds-font-family-code, \"Atlassian Mono\", ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)",
    'font.family.heading': "var(--ds-font-family-heading, \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
};
var $9e7f425b8bdc7913$export$236bfe3a33ef1292 = {
    medium: "var(--ds-font-body, normal 400 14px/20px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    UNSAFE_small: "var(--ds-font-body-UNSAFE_small, normal 400 12px/16px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    large: "var(--ds-font-body-large, normal 400 16px/24px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    small: "var(--ds-font-body-small, normal 400 12px/16px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
};
var $9e7f425b8bdc7913$export$855cfd311192d666 = {
    bold: "var(--ds-font-weight-bold, 653)",
    medium: "var(--ds-font-weight-medium, 500)",
    regular: "var(--ds-font-weight-regular, 400)",
    semibold: "var(--ds-font-weight-semibold, 600)"
};
var $9e7f425b8bdc7913$export$b805719bc8cb376 = {
    large: "var(--ds-font-metric-large, normal 653 28px/32px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    medium: "var(--ds-font-metric-medium, normal 653 24px/28px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    small: "var(--ds-font-metric-small, normal 653 16px/20px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
};
/**
 * @codegenEnd
 */ // Margin needs some bespoke types: https://atlassian.slack.com/archives/CKRHB23K8/p1712623192772909
/**
 * Token functions are currently allowed for borderRadius in xcss to ease migration.
 * Because 'radius.small' defaults to 3px, we need a mechanism to allow for 4px values to be provided:
 * This is done by calling the token function - token('radius.small')
 *
 * TODO: Remove once shape them is rolled out and fg platform-dst-shape-theme-default removed
 */ // Generate maps for Box props. backgroundColor, padding, etc
var $9e7f425b8bdc7913$var$spacingProperties = [
    // Used by Box
    'padding',
    'paddingBlock',
    'paddingBlockStart',
    'paddingBlockEnd',
    'paddingInline',
    'paddingInlineStart',
    'paddingInlineEnd',
    // Used by Inline and Stack
    'gap',
    'rowGap',
    'columnGap'
];
var $9e7f425b8bdc7913$export$ca0f9c2de39ffed7 = function getSerializedStylesMap(cssProperty, tokenMap) {
    return Object.keys(tokenMap).reduce(function(emotionSpacingMap, token) {
        // eslint-disable-next-line @repo/internal/styles/no-exported-styles
        emotionSpacingMap[token] = (0, $74Zh5.css)((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, cssProperty, tokenMap[token]));
        return emotionSpacingMap;
    }, {});
};
var $9e7f425b8bdc7913$export$e615f061ca585a6c = $9e7f425b8bdc7913$var$spacingProperties.reduce(function(styleMap, spacingProperty) {
    styleMap[spacingProperty] = $9e7f425b8bdc7913$export$ca0f9c2de39ffed7(spacingProperty, $9e7f425b8bdc7913$export$958d0ae7f2977ae4);
    return styleMap;
}, {});
var $9e7f425b8bdc7913$export$bf46c3f9eeafc71f = $9e7f425b8bdc7913$var$spacingProperties.reduce(function(styleMap, spacingProperty) {
    styleMap[spacingProperty] = $9e7f425b8bdc7913$export$ca0f9c2de39ffed7(spacingProperty, $9e7f425b8bdc7913$export$958d0ae7f2977ae4);
    return styleMap;
}, {});
var $9e7f425b8bdc7913$export$e7af83bafe7f9e63 = $9e7f425b8bdc7913$export$ca0f9c2de39ffed7('backgroundColor', $9e7f425b8bdc7913$export$d1d79bf68ac056bd);
var $9e7f425b8bdc7913$export$3a1bcba60b23d7f0 = $9e7f425b8bdc7913$export$ca0f9c2de39ffed7('color', $9e7f425b8bdc7913$export$8473307aa00d6ea1);
var $9e7f425b8bdc7913$export$45f3f4fe16f9f7d5 = $9e7f425b8bdc7913$export$ca0f9c2de39ffed7('fontWeight', $9e7f425b8bdc7913$export$303e322c6b1ed114);
var $9e7f425b8bdc7913$export$68cc305da27dbaa4 = $9e7f425b8bdc7913$export$ca0f9c2de39ffed7('fontFamily', $9e7f425b8bdc7913$export$3c7e9587132614b4);
var $9e7f425b8bdc7913$export$128f10c238242f83 = $9e7f425b8bdc7913$export$ca0f9c2de39ffed7('font', $9e7f425b8bdc7913$export$6ffa317d5e70375);
var $9e7f425b8bdc7913$export$219d364c0da35ae4 = $9e7f425b8bdc7913$export$ca0f9c2de39ffed7('font', $9e7f425b8bdc7913$export$236bfe3a33ef1292);
var $9e7f425b8bdc7913$export$38845ca010b93505 = $9e7f425b8bdc7913$export$ca0f9c2de39ffed7('fontWeight', $9e7f425b8bdc7913$export$855cfd311192d666);
var $9e7f425b8bdc7913$export$ff257d957d48c421 = $9e7f425b8bdc7913$export$ca0f9c2de39ffed7((0, $b4ssl.CURRENT_SURFACE_CSS_VAR), $9e7f425b8bdc7913$export$41a358c9c2356760);
var $9e7f425b8bdc7913$export$5e65a44e5b6ecadb = function isSurfaceColorToken(color) {
    return $9e7f425b8bdc7913$export$41a358c9c2356760[color] !== undefined;
};
var $9e7f425b8bdc7913$export$7001ce64d9ff7c7f = $9e7f425b8bdc7913$export$ca0f9c2de39ffed7('font', $9e7f425b8bdc7913$export$b805719bc8cb376);

});
parcelRegister("b4ssl", function(module, exports) {
$parcel$export(module.exports, "CURRENT_SURFACE_CSS_VAR", () => $80f62439d8ed3bed$export$9d7b58831ae93caa);
var $80f62439d8ed3bed$export$4ef52930e33717cd = 'data-theme';
var $80f62439d8ed3bed$export$cb374d25ded7f6ab = 'data-subtree-theme';
var $80f62439d8ed3bed$export$a00eac3f8684bcd0 = 'data-color-mode';
var $80f62439d8ed3bed$export$2112803007239c61 = 'data-contrast-mode';
var $80f62439d8ed3bed$export$352e418ed5b6193a = 'data-custom-theme';
var $80f62439d8ed3bed$export$6f0c6fb8c80fcc92 = 'ds';
var $80f62439d8ed3bed$export$4d0c7bbf80185957 = [
    'opacity',
    'font',
    'space',
    'border',
    'radius'
];
var $80f62439d8ed3bed$export$dddac1532e822863 = "--".concat($80f62439d8ed3bed$export$6f0c6fb8c80fcc92, "-token-not-found");
var $80f62439d8ed3bed$export$9d7b58831ae93caa = "--".concat($80f62439d8ed3bed$export$6f0c6fb8c80fcc92, "-elevation-surface-current");

});


parcelRegister("62HmU", function(module, exports) {
$parcel$export(module.exports, "useSurface", () => $466492159be5cfbe$export$1aeb4f6b93c4540d);

var $5FkrB = parcelRequire("5FkrB");
var $466492159be5cfbe$export$1ca2a26fecb070ae = /*#__PURE__*/ (0, $5FkrB.createContext)('elevation.surface');
var $466492159be5cfbe$export$1aeb4f6b93c4540d = function useSurface() {
    return (0, $5FkrB.useContext)($466492159be5cfbe$export$1ca2a26fecb070ae);
};
$466492159be5cfbe$export$1ca2a26fecb070ae.displayName = 'SurfaceProvider';

});

parcelRegister("gTJhB", function(module, exports) {
$parcel$export(module.exports, "useHeading", () => $c4d4e8a7ad44ecf5$export$97a37b1befbbf9b1);

var $5FkrB = parcelRequire("5FkrB");
// Allows support for heading levels 1-9 via aria-level
var $c4d4e8a7ad44ecf5$var$HeadingLevelContext = /*#__PURE__*/ (0, $5FkrB.createContext)(0);
/**
 * @internal
 * @returns The current heading level context.
 */ var $c4d4e8a7ad44ecf5$var$useHeadingLevel = function useHeadingLevel() {
    return (0, $5FkrB.useContext)($c4d4e8a7ad44ecf5$var$HeadingLevelContext);
};
var $c4d4e8a7ad44ecf5$export$97a37b1befbbf9b1 = function useHeading(fallback) {
    var hLevel = $c4d4e8a7ad44ecf5$var$useHeadingLevel();
    /**
   * Order here is important, we for now apply
   * 1. inferred a11y level (this only applies if context is present)
   * 2. default final fallback
   */ return [
        hLevel,
        hLevel && (hLevel > 6 ? 'div' : "h".concat(hLevel)) || fallback
    ];
};
/**
 * __Heading level provider__
 *
 * The Heading level provider injects the heading level to all `Heading` components below it in the component tree.
 *
 * @example
 * ```tsx
 * // Will correctly infer the heading level
 * <HeadingContext value={1}>
 *  <Heading>H1</Heading>
 *  <HeadingContext>
 *    <Heading>H2</Heading>
 *  </HeadingContext>
 * </HeadingContext>
 * ```
 */ var $c4d4e8a7ad44ecf5$var$HeadingLevelContextProvider = function HeadingLevelContextProvider(_ref) {
    var children = _ref.children, value = _ref.value;
    var parentHeadingLevel = $c4d4e8a7ad44ecf5$var$useHeadingLevel();
    var headingLevel = parentHeadingLevel + 1;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement($c4d4e8a7ad44ecf5$var$HeadingLevelContext.Provider, {
        value: value || headingLevel
    }, children);
};
var $c4d4e8a7ad44ecf5$export$2e2bcd8739ae039 = $c4d4e8a7ad44ecf5$var$HeadingLevelContextProvider;

});


parcelRegister("eMiEC", function(module, exports) {
$parcel$export(module.exports, "default", () => $ac2404b057b8688e$export$2e2bcd8739ae039);
/* section-message.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");

var $5yfDB = parcelRequire("5yfDB");

var $iKVNi = parcelRequire("iKVNi");

var $j7gwl = parcelRequire("j7gwl");

var $9KL0W = parcelRequire("9KL0W");
var $ddWyY = parcelRequire("ddWyY");

var $4iLXE = parcelRequire("4iLXE");
var $ac2404b057b8688e$var$sectionMessageStyles = {
    container: "_2rko12b0 _1rjcpxbi _18zrpxbi _1nmz1hna",
    iconContainer: "_1mou1i6y _1e0c1txw",
    contentContainer: "_16jlkb7n",
    content: "_11c82smr _syazi7uo",
    actionsContainer: "_11c82smr",
    dismissButtonContainer: "_1pfh1i6y"
};
var $ac2404b057b8688e$var$appearanceStyles = {
    information: "_bfhk19ip",
    warning: "_bfhk1917",
    error: "_bfhk1gly",
    success: "_bfhk1y9u",
    discovery: "_bfhk6vm6"
};
/**
 * __Section message__
 *
 * A section message is used to alert users to a particular section of the screen.
 *
 * - [Examples](https://atlassian.design/components/section-message/examples)
 * - [Code](https://atlassian.design/components/section-message/code)
 * - [Usage](https://atlassian.design/components/section-message/usage)
 */ var $ac2404b057b8688e$var$SectionMessage = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function SectionMessage(_ref, ref) {
    var children = _ref.children, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'information' : _ref$appearance, actions = _ref.actions, title = _ref.title, icon = _ref.icon, isDismissible = _ref.isDismissible, onDismiss = _ref.onDismiss, testId = _ref.testId;
    var _useState = (0, $5FkrB.useState)(false), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), dismissed = _useState2[0], setDismissed = _useState2[1];
    var handleDismiss = (0, $5FkrB.useCallback)(function() {
        onDismiss === null || onDismiss === void 0 || onDismiss();
        setDismissed(true);
    }, [
        onDismiss
    ]);
    var _getAppearanceIconSty = (0, $4iLXE.getAppearanceIconStyles)(appearance, icon), primaryColor = _getAppearanceIconSty.primaryIconColor, secondaryColor = _getAppearanceIconSty.backgroundColor, Icon = _getAppearanceIconSty.Icon;
    var actionElements = actions && actions.type === (0, $5FkrB.Fragment) ? actions.props.children : actions;
    var actionsArray = (0, $5FkrB.Children).toArray(actionElements);
    return isDismissible && dismissed ? null : /*#__PURE__*/ $5FkrB.createElement("section", {
        "data-testid": testId,
        ref: ref,
        className: (0, $970q7.default)([
            $ac2404b057b8688e$var$sectionMessageStyles.container,
            $ac2404b057b8688e$var$appearanceStyles[appearance]
        ])
    }, /*#__PURE__*/ $5FkrB.createElement((0, $9KL0W.default), {
        space: "space.200",
        alignBlock: "stretch"
    }, /*#__PURE__*/ $5FkrB.createElement("div", {
        className: (0, $970q7.default)([
            $ac2404b057b8688e$var$sectionMessageStyles.iconContainer
        ])
    }, /*#__PURE__*/ $5FkrB.createElement(Icon, {
        size: "medium",
        primaryColor: primaryColor,
        secondaryColor: secondaryColor,
        LEGACY_size: "medium",
        color: primaryColor,
        spacing: "spacious"
    })), /*#__PURE__*/ $5FkrB.createElement((0, $ddWyY.default), {
        space: "space.100",
        testId: testId && "".concat(testId, "--content"),
        xcss: $ac2404b057b8688e$var$sectionMessageStyles.contentContainer
    }, !!title && /*#__PURE__*/ $5FkrB.createElement((0, $iKVNi.default), {
        as: "h2",
        size: "small"
    }, title), /*#__PURE__*/ $5FkrB.createElement("div", {
        className: (0, $970q7.default)([
            $ac2404b057b8688e$var$sectionMessageStyles.content
        ])
    }, children), actionsArray.length > 0 && /*#__PURE__*/ $5FkrB.createElement((0, $9KL0W.default), {
        shouldWrap: true,
        testId: testId && "".concat(testId, "--actions"),
        separator: "\xB7",
        space: "space.100",
        rowSpace: "space.0",
        role: actionsArray.length > 1 ? 'list' : undefined,
        xcss: $ac2404b057b8688e$var$sectionMessageStyles.actionsContainer
    }, actionsArray.map(function(action, id) {
        return(/*#__PURE__*/ // Only use a listitem role if more than one action is present
        $5FkrB.createElement((0, $9KL0W.default), {
            role: actionsArray.length > 1 ? 'listitem' : undefined,
            key: id
        }, action));
    }))), isDismissible && /*#__PURE__*/ $5FkrB.createElement("div", {
        className: (0, $970q7.default)([
            $ac2404b057b8688e$var$sectionMessageStyles.dismissButtonContainer
        ])
    }, /*#__PURE__*/ $5FkrB.createElement((0, $5yfDB.default), {
        testId: testId && "".concat(testId, "--dismiss-button"),
        label: "Dismiss",
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($j7gwl))),
        appearance: "subtle",
        onClick: handleDismiss,
        spacing: "compact"
    }))));
});
$ac2404b057b8688e$var$SectionMessage.displayName = 'SectionMessage';
var $ac2404b057b8688e$export$2e2bcd8739ae039 = $ac2404b057b8688e$var$SectionMessage;

});
parcelRegister("5yfDB", function(module, exports) {
$parcel$export(module.exports, "default", () => $40ac4214599ec615$export$2e2bcd8739ae039);

var $kqp0i = parcelRequire("kqp0i");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");

var $iO8GM = parcelRequire("iO8GM");

var $cphPJ = parcelRequire("cphPJ");

var $e8kqY = parcelRequire("e8kqY");

var $abSTK = parcelRequire("abSTK");

var $ccBRl = parcelRequire("ccBRl");

var $goIky = parcelRequire("goIky");
var $40ac4214599ec615$var$_excluded = [
    "aria-label",
    "aria-labelledby",
    "analyticsContext",
    "appearance",
    "autoFocus",
    "icon",
    "interactionName",
    "isDisabled",
    "isLoading",
    "isSelected",
    "isTooltipDisabled",
    "label",
    "onClick",
    "onClickCapture",
    "onKeyDownCapture",
    "onKeyUpCapture",
    "onMouseDownCapture",
    "onMouseUpCapture",
    "onPointerDownCapture",
    "onPointerUpCapture",
    "onTouchEndCapture",
    "onTouchStartCapture",
    "shape",
    "spacing",
    "testId",
    "tooltip",
    "type"
], $40ac4214599ec615$var$_excluded2 = [
    "className",
    "css",
    "as",
    "style"
];
/**
 * __Icon Button__
 *
 * Renders an icon-only button lets people take a common and recognizable action where space is limited.
 *
 * - [Examples](https://atlassian.design/components/button/icon-button/examples)
 * - [Code](https://atlassian.design/components/button/icon-button/code)
 * - [Usage](https://atlassian.design/components/button/icon-button/usage)
 */ var $40ac4214599ec615$var$IconButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).forwardRef(function Button(_ref, ref) {
    var _tooltip$content;
    var preventedAriaLabel = _ref['aria-label'], ariaLabelledBy = _ref['aria-labelledby'], analyticsContext = _ref.analyticsContext, appearance = _ref.appearance, autoFocus = _ref.autoFocus, icon = _ref.icon, interactionName = _ref.interactionName, isDisabled = _ref.isDisabled, _ref$isLoading = _ref.isLoading, isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading, isSelected = _ref.isSelected, _ref$isTooltipDisable = _ref.isTooltipDisabled, isTooltipDisabled = _ref$isTooltipDisable === void 0 ? true : _ref$isTooltipDisable, label = _ref.label, _onClick = _ref.onClick, onClickCapture = _ref.onClickCapture, onKeyDownCapture = _ref.onKeyDownCapture, onKeyUpCapture = _ref.onKeyUpCapture, onMouseDownCapture = _ref.onMouseDownCapture, onMouseUpCapture = _ref.onMouseUpCapture, onPointerDownCapture = _ref.onPointerDownCapture, onPointerUpCapture = _ref.onPointerUpCapture, onTouchEndCapture = _ref.onTouchEndCapture, onTouchStartCapture = _ref.onTouchStartCapture, shape = _ref.shape, spacing = _ref.spacing, testId = _ref.testId, tooltip = _ref.tooltip, _ref$type = _ref.type, type = _ref$type === void 0 ? 'button' : _ref$type, unsafeRest = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $40ac4214599ec615$var$_excluded);
    // @ts-expect-error
    var _className = unsafeRest.className, _css = unsafeRest.css, _as = unsafeRest.as, _style = unsafeRest.style, saferRest = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(unsafeRest, $40ac4214599ec615$var$_excluded2);
    if (isTooltipDisabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $abSTK.default), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, saferRest, {
        ref: ref,
        appearance: appearance,
        autoFocus: autoFocus,
        isDisabled: isDisabled,
        isLoading: isLoading,
        isSelected: isSelected,
        isIconButton: true,
        isCircle: shape === 'circle',
        hasIconBefore: !!icon,
        spacing: spacing,
        ariaLabelledBy: ariaLabelledBy,
        onClick: _onClick,
        onClickCapture: onClickCapture,
        onKeyDownCapture: onKeyDownCapture,
        onKeyUpCapture: onKeyUpCapture,
        onMouseDownCapture: onMouseDownCapture,
        onMouseUpCapture: onMouseUpCapture,
        onPointerDownCapture: onPointerDownCapture,
        onPointerUpCapture: onPointerUpCapture,
        onTouchStartCapture: onTouchStartCapture,
        onTouchEndCapture: onTouchEndCapture,
        testId: testId,
        componentName: "IconButton",
        analyticsContext: analyticsContext,
        type: type,
        interactionName: interactionName
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $ccBRl.default), {
        type: "icon",
        isLoading: isLoading
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $goIky.default), {
        icon: icon
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $e8kqY.default), null, label)));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $cphPJ.default), {
        content: (_tooltip$content = tooltip === null || tooltip === void 0 ? void 0 : tooltip.content) !== null && _tooltip$content !== void 0 ? _tooltip$content : label,
        testId: tooltip === null || tooltip === void 0 ? void 0 : tooltip.testId,
        position: tooltip === null || tooltip === void 0 ? void 0 : tooltip.position,
        delay: tooltip === null || tooltip === void 0 ? void 0 : tooltip.delay,
        onShow: tooltip === null || tooltip === void 0 ? void 0 : tooltip.onShow,
        onHide: tooltip === null || tooltip === void 0 ? void 0 : tooltip.onHide,
        mousePosition: tooltip === null || tooltip === void 0 ? void 0 : tooltip.mousePosition,
        analyticsContext: tooltip === null || tooltip === void 0 ? void 0 : tooltip.analyticsContext,
        strategy: tooltip === null || tooltip === void 0 ? void 0 : tooltip.strategy,
        tag: tooltip === null || tooltip === void 0 ? void 0 : tooltip.tag,
        truncate: tooltip === null || tooltip === void 0 ? void 0 : tooltip.truncate,
        component: tooltip === null || tooltip === void 0 ? void 0 : tooltip.component,
        hideTooltipOnClick: tooltip === null || tooltip === void 0 ? void 0 : tooltip.hideTooltipOnClick,
        hideTooltipOnMouseDown: tooltip === null || tooltip === void 0 ? void 0 : tooltip.hideTooltipOnMouseDown,
        ignoreTooltipPointerEvents: tooltip === null || tooltip === void 0 ? void 0 : tooltip.ignoreTooltipPointerEvents,
        shortcut: tooltip === null || tooltip === void 0 ? void 0 : tooltip.shortcut
    }, function(triggerProps) {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $abSTK.default), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, saferRest, {
            appearance: appearance,
            autoFocus: autoFocus,
            isDisabled: isDisabled,
            isLoading: isLoading,
            isSelected: isSelected,
            isIconButton: true,
            isCircle: shape === 'circle',
            hasIconBefore: false,
            spacing: spacing,
            ariaLabelledBy: ariaLabelledBy,
            onClick: function onClick(e, analyticsEvent) {
                var _triggerProps$onClick;
                _onClick === null || _onClick === void 0 || _onClick(e, analyticsEvent);
                (_triggerProps$onClick = triggerProps.onClick) === null || _triggerProps$onClick === void 0 || _triggerProps$onClick.call(triggerProps, e);
            },
            onMouseOver: function onMouseOver(e) {
                var _triggerProps$onMouse, _saferRest$onMouseOve;
                (_triggerProps$onMouse = triggerProps.onMouseOver) === null || _triggerProps$onMouse === void 0 || _triggerProps$onMouse.call(triggerProps, e);
                (_saferRest$onMouseOve = saferRest.onMouseOver) === null || _saferRest$onMouseOve === void 0 || _saferRest$onMouseOve.call(saferRest, e);
            },
            onMouseOut: function onMouseOut(e) {
                var _triggerProps$onMouse2, _saferRest$onMouseOut;
                (_triggerProps$onMouse2 = triggerProps.onMouseOut) === null || _triggerProps$onMouse2 === void 0 || _triggerProps$onMouse2.call(triggerProps, e);
                (_saferRest$onMouseOut = saferRest.onMouseOut) === null || _saferRest$onMouseOut === void 0 || _saferRest$onMouseOut.call(saferRest, e);
            },
            onMouseMove: function onMouseMove(e) {
                var _triggerProps$onMouse3, _saferRest$onMouseMov;
                (_triggerProps$onMouse3 = triggerProps.onMouseMove) === null || _triggerProps$onMouse3 === void 0 || _triggerProps$onMouse3.call(triggerProps, e);
                (_saferRest$onMouseMov = saferRest.onMouseMove) === null || _saferRest$onMouseMov === void 0 || _saferRest$onMouseMov.call(saferRest, e);
            },
            onMouseDown: function onMouseDown(e) {
                var _triggerProps$onMouse4, _saferRest$onMouseDow;
                (_triggerProps$onMouse4 = triggerProps.onMouseDown) === null || _triggerProps$onMouse4 === void 0 || _triggerProps$onMouse4.call(triggerProps, e);
                (_saferRest$onMouseDow = saferRest.onMouseDown) === null || _saferRest$onMouseDow === void 0 || _saferRest$onMouseDow.call(saferRest, e);
            },
            onFocus: function onFocus(e) {
                var _triggerProps$onFocus, _saferRest$onFocus;
                (_triggerProps$onFocus = triggerProps.onFocus) === null || _triggerProps$onFocus === void 0 || _triggerProps$onFocus.call(triggerProps, e);
                (_saferRest$onFocus = saferRest.onFocus) === null || _saferRest$onFocus === void 0 || _saferRest$onFocus.call(saferRest, e);
            },
            onBlur: function onBlur(e) {
                var _triggerProps$onBlur, _saferRest$onBlur;
                (_triggerProps$onBlur = triggerProps.onBlur) === null || _triggerProps$onBlur === void 0 || _triggerProps$onBlur.call(triggerProps, e);
                (_saferRest$onBlur = saferRest.onBlur) === null || _saferRest$onBlur === void 0 || _saferRest$onBlur.call(saferRest, e);
            },
            ref: (0, $iO8GM.default)([
                ref,
                triggerProps === null || triggerProps === void 0 ? void 0 : triggerProps.ref
            ].filter(Boolean)),
            onMouseDownCapture: onMouseDownCapture,
            onMouseUpCapture: onMouseUpCapture,
            onKeyDownCapture: onKeyDownCapture,
            onKeyUpCapture: onKeyUpCapture,
            onTouchStartCapture: onTouchStartCapture,
            onTouchEndCapture: onTouchEndCapture,
            onPointerDownCapture: onPointerDownCapture,
            onPointerUpCapture: onPointerUpCapture,
            onClickCapture: onClickCapture,
            type: type,
            testId: testId,
            analyticsContext: analyticsContext,
            interactionName: interactionName,
            componentName: "IconButton"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $ccBRl.default), {
            type: "icon",
            isLoading: isLoading
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $goIky.default), {
            icon: icon
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $e8kqY.default), null, label)));
    });
}));
$40ac4214599ec615$var$IconButton.displayName = 'IconButton';
var $40ac4214599ec615$export$2e2bcd8739ae039 = $40ac4214599ec615$var$IconButton;

});
parcelRegister("cphPJ", function(module, exports) {
$parcel$export(module.exports, "default", () => $9085a729b9bce335$export$2e2bcd8739ae039);

var $kqp0i = parcelRequire("kqp0i");

var $iYJcE = parcelRequire("iYJcE");

var $25nEq = parcelRequire("25nEq");

var $5FkrB = parcelRequire("5FkrB");

var $7QpUe = parcelRequire("7QpUe");

var $eS29F = parcelRequire("eS29F");

var $eVb4V = parcelRequire("eVb4V");

var $hy47X = parcelRequire("hy47X");

var $3UUXy = parcelRequire("3UUXy");

var $eFRYv = parcelRequire("eFRYv");

var $hGuZe = parcelRequire("hGuZe");
var $lUsc6 = parcelRequire("lUsc6");

var $5K5L9 = parcelRequire("5K5L9");

var $6vLi9 = parcelRequire("6vLi9");

var $cVIoC = parcelRequire("cVIoC");

var $bJM2o = parcelRequire("bJM2o");

var $hRDE5 = parcelRequire("hRDE5");

var $9YYdW = parcelRequire("9YYdW");

var $5vdru = parcelRequire("5vdru");

var $bDd2o = parcelRequire("bDd2o");
function $9085a729b9bce335$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $9085a729b9bce335$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $9085a729b9bce335$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $9085a729b9bce335$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $9085a729b9bce335$var$tooltipZIndex = (0, $cVIoC.layers).tooltip();
var $9085a729b9bce335$var$analyticsAttributes = {
    componentName: 'tooltip',
    packageName: "@atlaskit/tooltip",
    packageVersion: "20.9.0"
};
// Inverts motion direction
var $9085a729b9bce335$var$invertedDirection = {
    top: 'bottom',
    bottom: 'top',
    left: 'right',
    right: 'left'
};
/**
 * Converts a Popper placement to it's general direction.
 *
 * @param placement - Popper Placement value, e.g. 'top-start'
 * @returns Popper Direction, e.g. 'top'
 */ var $9085a729b9bce335$var$getDirectionFromPlacement = function getDirectionFromPlacement(placement) {
    return placement.split('-')[0];
};
/**
 * __Tooltip__
 *
 * A tooltip is a floating, non-actionable label used to explain a user interface element or feature.
 */ function $9085a729b9bce335$var$Tooltip(_ref) {
    var children = _ref.children, _ref$position = _ref.position, position = _ref$position === void 0 ? 'bottom' : _ref$position, _ref$mousePosition = _ref.mousePosition, mousePosition = _ref$mousePosition === void 0 ? 'bottom' : _ref$mousePosition, content = _ref.content, _ref$truncate = _ref.truncate, truncate = _ref$truncate === void 0 ? false : _ref$truncate, _ref$component = _ref.component, Container = _ref$component === void 0 ? (0, $5vdru.default) : _ref$component, _ref$tag = _ref.tag, TargetContainer = _ref$tag === void 0 ? 'div' : _ref$tag, testId = _ref.testId, _ref$delay = _ref.delay, delay = _ref$delay === void 0 ? 300 : _ref$delay, _ref$onShow = _ref.onShow, onShow = _ref$onShow === void 0 ? (0, $eVb4V.default) : _ref$onShow, _ref$onHide = _ref.onHide, onHide = _ref$onHide === void 0 ? (0, $eVb4V.default) : _ref$onHide, canAppear = _ref.canAppear, _ref$hideTooltipOnCli = _ref.hideTooltipOnClick, hideTooltipOnClick = _ref$hideTooltipOnCli === void 0 ? false : _ref$hideTooltipOnCli, _ref$hideTooltipOnMou = _ref.hideTooltipOnMouseDown, hideTooltipOnMouseDown = _ref$hideTooltipOnMou === void 0 ? false : _ref$hideTooltipOnMou, analyticsContext = _ref.analyticsContext, _ref$strategy = _ref.strategy, strategy = _ref$strategy === void 0 ? 'fixed' : _ref$strategy, _ref$ignoreTooltipPoi = _ref.ignoreTooltipPointerEvents, ignoreTooltipPointerEvents = _ref$ignoreTooltipPoi === void 0 ? false : _ref$ignoreTooltipPoi, _ref$isScreenReaderAn = _ref.isScreenReaderAnnouncementDisabled, isScreenReaderAnnouncementDisabled = _ref$isScreenReaderAn === void 0 ? false : _ref$isScreenReaderAn, shortcut = _ref.shortcut;
    var tooltipPosition = position === 'mouse' ? mousePosition : position;
    var onShowHandler = (0, $eS29F.usePlatformLeafSyntheticEventHandler)($9085a729b9bce335$var$_objectSpread({
        fn: onShow,
        action: 'displayed',
        analyticsData: analyticsContext
    }, $9085a729b9bce335$var$analyticsAttributes));
    var onHideHandler = (0, $eS29F.usePlatformLeafSyntheticEventHandler)($9085a729b9bce335$var$_objectSpread({
        fn: onHide,
        action: 'hidden',
        analyticsData: analyticsContext
    }, $9085a729b9bce335$var$analyticsAttributes));
    var apiRef = (0, $5FkrB.useRef)(null);
    var _useState = (0, $5FkrB.useState)('hide'), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), state = _useState2[0], setState = _useState2[1];
    var targetRef = (0, $5FkrB.useRef)(null);
    var containerRef = (0, $5FkrB.useRef)(null);
    // This function is deliberately _not_ memoized as it needs to re-run every render
    // to pick up any child ref changes. If you use render props you don't have this issue.
    var setImplicitRefFromChildren = function setImplicitRefFromChildren(node) {
        containerRef.current = node;
        targetRef.current = node ? node.firstElementChild : null;
    };
    // This is memoized and passed into the render props callback.
    var setDirectRef = (0, $5FkrB.useCallback)(function(node) {
        targetRef.current = node;
    }, []);
    // Putting a few things into refs so that we don't have to break memoization
    var stableState = (0, $3UUXy.default)(state);
    // These props are placed in separate refs instead of a single object to reduce memory usage.
    // Placing them in the same object previously caused an increase in the number of JavaScript event listeners
    // before garbage collection.
    var onShowHandlerStable = (0, $3UUXy.default)(onShowHandler);
    var onHideHandlerStable = (0, $3UUXy.default)(onHideHandler);
    var delayStable = (0, $3UUXy.default)(delay);
    var canAppearStable = (0, $3UUXy.default)(canAppear);
    var hasCalledShowHandler = (0, $5FkrB.useRef)(false);
    var start = (0, $5FkrB.useCallback)(function(api) {
        // @ts-ignore
        apiRef.current = api;
        hasCalledShowHandler.current = false;
    }, []);
    var done = (0, $5FkrB.useCallback)(function() {
        if (!apiRef.current) return;
        // Only call onHideHandler if we have called onShowHandler
        if (hasCalledShowHandler.current) onHideHandlerStable.current();
        // @ts-ignore
        apiRef.current = null;
        // @ts-ignore
        hasCalledShowHandler.current = false;
        // just in case
        setState('hide');
    }, [
        onHideHandlerStable
    ]);
    var abort = (0, $5FkrB.useCallback)(function() {
        if (!apiRef.current) return;
        apiRef.current.abort();
        // Only call onHideHandler if we have called onShowHandler
        if (hasCalledShowHandler.current) onHideHandlerStable.current();
        // @ts-ignore
        apiRef.current = null;
    }, [
        onHideHandlerStable
    ]);
    (0, $5FkrB.useEffect)(function mount() {
        return function unmount() {
            if (apiRef.current) abort();
        };
    }, [
        abort
    ]);
    var isDraggingRef = (0, $5FkrB.useRef)(false);
    (0, $5FkrB.useEffect)(function() {
        return (0, $bJM2o.register)({
            onRegister: function onRegister(_ref2) {
                var isDragging = _ref2.isDragging;
                isDraggingRef.current = isDragging;
            },
            onDragStart: function onDragStart() {
                var _apiRef$current;
                /**
         * Hiding any visible tooltips when a drag starts because otherwise it
         * looks janky (disappears and reappears), and is not required.
         */ (_apiRef$current = apiRef.current) === null || _apiRef$current === void 0 || _apiRef$current.requestHide({
                    isImmediate: true
                });
                isDraggingRef.current = true;
            },
            onDragEnd: function onDragEnd() {
                isDraggingRef.current = false;
            }
        });
    }, []);
    var tryShowTooltip = (0, $5FkrB.useCallback)(function(source) {
        var _canAppearStable$curr;
        /**
     * Prevent tooltips from being shown during a drag. This can occur with
     * the native drag and drop API, where some pointer events can fire
     * when they should not and lead to jank with tooltips.
     */ if (isDraggingRef.current) return;
        // Another tooltip is has been active but we still have the old `api`
        // around. We need to finish up the last usage.
        // Note: just being safe - this should not happen
        if (apiRef.current && !apiRef.current.isActive()) abort();
        // This tooltip is already active, we can exit
        if (apiRef.current && apiRef.current.isActive()) {
            apiRef.current.keep();
            return;
        }
        /**
     * Check if tooltip is allowed to show.
     *
     * Once a tooltip has started, or has scheduled to start
     * we won't be checking `canAppear` again.
     *
     * - We don't want tooltips to disappear once they are shown
     * - For consistency, we start after a single positive `canAppear`.
     *   Otherwise the amount of times we ask consumers would depend on
     *   how many times we get a "mousemove", which _could_ lead to situations
     *   where moving the mouse could result in a different outcome to if
     *   the mouse was not moved.
     */ if (canAppearStable.current && !((_canAppearStable$curr = canAppearStable.current) !== null && _canAppearStable$curr !== void 0 && _canAppearStable$curr.call(canAppearStable))) return;
        var entry = {
            source: source,
            delay: delayStable.current,
            show: function show(_ref3) {
                var isImmediate = _ref3.isImmediate;
                // Call the onShow handler if it hasn't been called yet
                if (!hasCalledShowHandler.current) {
                    hasCalledShowHandler.current = true;
                    onShowHandlerStable.current();
                }
                setState(isImmediate ? 'show-immediate' : 'fade-in');
            },
            hide: function hide(_ref4) {
                var isImmediate = _ref4.isImmediate;
                if (isImmediate) setState('hide');
                else setState('before-fade-out');
            },
            done: done
        };
        var api = (0, $hRDE5.show)(entry);
        start(api);
    }, [
        canAppearStable,
        delayStable,
        done,
        start,
        abort,
        onShowHandlerStable
    ]);
    var hideTooltipOnEsc = (0, $5FkrB.useCallback)(function() {
        var _apiRef$current2;
        (_apiRef$current2 = apiRef.current) === null || _apiRef$current2 === void 0 || _apiRef$current2.requestHide({
            isImmediate: true
        });
    }, [
        apiRef
    ]);
    (0, $hy47X.default)({
        onClose: hideTooltipOnEsc,
        isDisabled: state === 'hide' || state === 'fade-out'
    });
    (0, $5FkrB.useEffect)(function() {
        if (state === 'hide') return 0, $eVb4V.default;
        if (state === 'before-fade-out') setState('fade-out');
        var unbind = (0, $7QpUe.bind)(window, {
            type: 'scroll',
            listener: function listener() {
                if (apiRef.current) apiRef.current.requestHide({
                    isImmediate: true
                });
            },
            options: {
                capture: true,
                passive: true,
                once: true
            }
        });
        return unbind;
    }, [
        state
    ]);
    var onMouseDown = (0, $5FkrB.useCallback)(function() {
        if (hideTooltipOnMouseDown && apiRef.current) apiRef.current.requestHide({
            isImmediate: true
        });
    }, [
        hideTooltipOnMouseDown
    ]);
    var onClick = (0, $5FkrB.useCallback)(function() {
        if (hideTooltipOnClick && apiRef.current) apiRef.current.requestHide({
            isImmediate: true
        });
    }, [
        hideTooltipOnClick
    ]);
    // Ideally we would be using onMouseEnter here, but
    // because we are binding the event to the target parent
    // we need to listen for the mouseover of all sub elements
    // This means when moving along a tooltip we are quickly toggling
    // between api.requestHide and api.keep. This it not ideal
    var onMouseOver = (0, $5FkrB.useCallback)(function(event) {
        // Ignoring events from the container ref
        if (containerRef.current && event.target === containerRef.current) return;
        // Using prevent default as a signal that parent tooltips
        if (event.defaultPrevented) return;
        event.preventDefault();
        var source = position === 'mouse' ? {
            type: 'mouse',
            // TODO: ideally not recalculating this object each time
            mouse: (0, $bDd2o.getMousePosition)({
                left: event.clientX,
                top: event.clientY
            })
        } : {
            type: 'keyboard'
        };
        tryShowTooltip(source);
    }, [
        position,
        tryShowTooltip
    ]);
    // Ideally we would be using onMouseEnter here, but
    // because we are binding the event to the target parent
    // we need to listen for the mouseout of all sub elements
    // This means when moving along a tooltip we are quickly toggling
    // between api.requestHide and api.keep. This it not ideal
    var onMouseOut = (0, $5FkrB.useCallback)(function(event) {
        // Ignoring events from the container ref
        if (containerRef.current && event.target === containerRef.current) return;
        // Using prevent default as a signal that parent tooltips
        if (event.defaultPrevented) return;
        event.preventDefault();
        if (apiRef.current) apiRef.current.requestHide({
            isImmediate: false
        });
    }, []);
    var onMouseMove = position === 'mouse' ? function(event) {
        var _apiRef$current3;
        if ((_apiRef$current3 = apiRef.current) !== null && _apiRef$current3 !== void 0 && _apiRef$current3.isActive()) apiRef.current.mousePosition = (0, $bDd2o.getMousePosition)({
            left: event.clientX,
            top: event.clientY
        });
    } : undefined;
    var onMouseOverTooltip = (0, $5FkrB.useCallback)(function() {
        if (apiRef.current && apiRef.current.isActive()) {
            apiRef.current.keep();
            return;
        }
    }, []);
    var onFocus = (0, $5FkrB.useCallback)(function(e) {
        // Check if focus-visible
        // Prevents tooltips from showing when focus is not visible,
        // i.e., when focus is moved onto tooltip trigger inside a popup on open
        try {
            if (!e.target.matches(':focus-visible')) return;
        } catch (_) {
        // Ignore errors from environments that don't support :focus-visible
        }
        // TODO: this does not play well with `hideTooltipOnMouseDown`
        // as "focus" will occur after the "mousedown".
        tryShowTooltip({
            type: 'keyboard'
        });
    }, [
        tryShowTooltip
    ]);
    var onBlur = (0, $5FkrB.useCallback)(function() {
        if (apiRef.current) apiRef.current.requestHide({
            isImmediate: false
        });
    }, []);
    var onAnimationFinished = (0, $5FkrB.useCallback)(function(transition) {
        // Using lastState here because motion is not picking up the latest value
        if (transition === 'exiting' && stableState.current === 'fade-out' && apiRef.current) // @ts-ignore: refs are writeable
        apiRef.current.finishHideAnimation();
    }, [
        stableState
    ]);
    // Doing a cast because typescript is struggling to narrow the type
    var CastTargetContainer = TargetContainer;
    var shouldRenderTooltipPopup = state !== 'hide' && Boolean(content);
    var shouldRenderHiddenContent = !isScreenReaderAnnouncementDisabled && shouldRenderTooltipPopup;
    var shouldRenderTooltipChildren = state !== 'hide' && state !== 'fade-out';
    var handleOpenLayerObserverCloseSignal = (0, $5FkrB.useCallback)(function() {
        var _apiRef$current4;
        (_apiRef$current4 = apiRef.current) === null || _apiRef$current4 === void 0 || _apiRef$current4.requestHide({
            isImmediate: true
        });
    }, []);
    (0, $eFRYv.useNotifyOpenLayerObserver)({
        // Layer is only visually open if both the tooltip popup (container) and children are rendered.
        isOpen: shouldRenderTooltipPopup && shouldRenderTooltipChildren,
        /**
     * We don't strictly need to provide an onClose callback at this time, as there is
     * already code that handles hiding the tooltip when a drag is started (and the only
     * usage right now is closing all layers when the user resizes the side nav).
     *
     * However, for future-proofing and semantic reasons, it makes sense to close the tooltip
     * whenever the open layer observer requests a close.
     */ onClose: handleOpenLayerObserverCloseSignal
    });
    var getReferenceElement = function getReferenceElement() {
        var _apiRef$current5;
        if (position === 'mouse' && (_apiRef$current5 = apiRef.current) !== null && _apiRef$current5 !== void 0 && _apiRef$current5.mousePosition) {
            var _apiRef$current6;
            return (_apiRef$current6 = apiRef.current) === null || _apiRef$current6 === void 0 ? void 0 : _apiRef$current6.mousePosition;
        }
        return targetRef.current || undefined;
    };
    var tooltipIdForHiddenContent = (0, $9YYdW.default)('tooltip', shouldRenderHiddenContent);
    var tooltipTriggerProps = {
        onMouseOver: onMouseOver,
        onMouseOut: onMouseOut,
        onMouseMove: onMouseMove,
        onMouseDown: onMouseDown,
        onClick: onClick,
        onFocus: onFocus,
        onBlur: onBlur
    };
    // Don't set `data-testid` unless it's defined, as it's not in the interface.
    if (testId) // Adding `data-testid` to the TriggerProps interface breaks Buttons, so we use type assertion
    tooltipTriggerProps['data-testid'] = "".concat(testId, "--container");
    // This useEffect is purely for managing the aria attribute when using the
    // wrapped children approach.
    var isChildrenAFunction = typeof children === 'function';
    (0, $5FkrB.useEffect)(function() {
        if (isChildrenAFunction) return;
        // If `children` is _not_ a function, we are stepping outside of the public
        // API to add a `aria-describedby` attribute.
        var target = targetRef.current;
        if (!target || !tooltipIdForHiddenContent) return;
        target.setAttribute('aria-describedby', tooltipIdForHiddenContent);
        return function() {
            return target.removeAttribute('aria-describedby');
        };
    }, [
        isChildrenAFunction,
        tooltipIdForHiddenContent
    ]);
    var hiddenContent = shouldRenderHiddenContent ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("span", {
        "data-testid": testId ? "".concat(testId, "-hidden") : undefined,
        hidden: true,
        id: tooltipIdForHiddenContent
    }, typeof content === 'function' ? content({}) : content) : null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).Fragment, null, typeof children === 'function' ? /*#__PURE__*/ // once we deprecate the wrapped approach, we can put the aria
    // attribute back into the tooltipTriggerProps and make it required
    // instead of optional in `types`
    (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).Fragment, null, children($9085a729b9bce335$var$_objectSpread($9085a729b9bce335$var$_objectSpread({}, tooltipTriggerProps), {}, {
        'aria-describedby': tooltipIdForHiddenContent,
        ref: setDirectRef
    })), hiddenContent) : /*#__PURE__*/ // @ts-ignore
    (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(CastTargetContainer, (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, tooltipTriggerProps, {
        ref: setImplicitRefFromChildren,
        role: "presentation"
    }), children, hiddenContent), shouldRenderTooltipPopup ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $6vLi9.default), {
        zIndex: $9085a729b9bce335$var$tooltipZIndex
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $5K5L9.Popper), {
        placement: tooltipPosition,
        referenceElement: getReferenceElement(),
        strategy: strategy
    }, function(_ref5) {
        var ref = _ref5.ref, style = _ref5.style, update = _ref5.update, placement = _ref5.placement;
        // Invert the entrance and exit directions.
        // E.g. a tooltip's position is on the 'right', it should enter from and exit to the 'left'
        // This gives the effect the tooltip is appearing from the target
        var direction = position === 'mouse' ? undefined : $9085a729b9bce335$var$invertedDirection[$9085a729b9bce335$var$getDirectionFromPlacement(placement)];
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $hGuZe.default), {
            appear: true
        }, shouldRenderTooltipChildren && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $lUsc6.default), {
            distance: "constant",
            entranceDirection: direction,
            exitDirection: direction,
            onFinish: onAnimationFinished,
            duration: state !== 'show-immediate' ? 'medium' : 'none'
        }, function(_ref6) {
            var className = _ref6.className;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(Container, {
                ref: ref,
                className: "Tooltip ".concat(className),
                style: $9085a729b9bce335$var$_objectSpread($9085a729b9bce335$var$_objectSpread({}, style), ignoreTooltipPointerEvents && {
                    pointerEvents: 'none'
                }),
                truncate: truncate,
                placement: tooltipPosition,
                testId: getReferenceElement() ? testId : testId && "".concat(testId, "--unresolved"),
                onMouseOut: onMouseOut,
                onMouseOver: onMouseOverTooltip,
                shortcut: shortcut
            }, typeof content === 'function' ? content({
                update: update
            }) : content);
        }));
    })) : null);
}
var $9085a729b9bce335$export$2e2bcd8739ae039 = $9085a729b9bce335$var$Tooltip;

});
parcelRegister("eS29F", function(module, exports) {
$parcel$export(module.exports, "usePlatformLeafSyntheticEventHandler", () => $ad37c7c26968393a$export$1a04351537078b55);

var $25nEq = parcelRequire("25nEq");

var $5FkrB = parcelRequire("5FkrB");

var $jBycd = parcelRequire("jBycd");

var $79FeR = parcelRequire("79FeR");
function $ad37c7c26968393a$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $ad37c7c26968393a$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $ad37c7c26968393a$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $ad37c7c26968393a$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $ad37c7c26968393a$export$1a04351537078b55(_ref) {
    var fn = _ref.fn, action = _ref.action, componentName = _ref.componentName, packageName = _ref.packageName, packageVersion = _ref.packageVersion, analyticsData = _ref.analyticsData;
    var _useAnalyticsEvents = (0, $jBycd.useAnalyticsEvents)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
    // We put analyticsData and fn in a ref so that we don't need to break
    // memoization.
    // Generally these could be defined by consumers inline
    // and so we do this to avoid breaking memoization of useCallback
    var dataRef = (0, $79FeR.useTrackedRef)(analyticsData);
    var fnRef = (0, $79FeR.useTrackedRef)(fn);
    var handler = (0, $5FkrB.useCallback)(function() {
        var analyticsEvent = createAnalyticsEvent({
            action: action,
            actionSubject: componentName,
            attributes: {
                componentName: componentName,
                packageName: packageName,
                packageVersion: packageVersion
            }
        });
        // To avoid wrapping this component in AnalyticsContext we manually
        // push the parent context's meta data into the context.
        // Note: this new 'context'
        var context = $ad37c7c26968393a$var$_objectSpread({
            componentName: componentName,
            packageName: packageName,
            packageVersion: packageVersion
        }, dataRef.current);
        analyticsEvent.context.push(context);
        // fire an event on the atlaskit channel
        var clone = analyticsEvent.clone();
        if (clone) clone.fire('atlaskit');
        fnRef.current(analyticsEvent);
    }, [
        // These are strings and won't change
        action,
        componentName,
        packageName,
        packageVersion,
        // This function is memoized in the context
        createAnalyticsEvent,
        // these are a stable ref because of the useTrackedRef hook
        dataRef,
        fnRef
    ]);
    return handler;
}

});
parcelRegister("jBycd", function(module, exports) {
$parcel$export(module.exports, "useAnalyticsEvents", () => $e45bffa9c92e0ccd$export$5bf35293e545f20c);

var $dLGML = parcelRequire("dLGML");

var $flVBa = parcelRequire("flVBa");

var $bSE6z = parcelRequire("bSE6z");
function $e45bffa9c92e0ccd$export$5bf35293e545f20c() {
    var analyticsContext = (0, $bSE6z.useAnalyticsContext)();
    var createAnalyticsEvent = (0, $dLGML.useCallbackOne)(function(payload) {
        return new (0, $flVBa.default)({
            context: analyticsContext.getAtlaskitAnalyticsContext(),
            handlers: analyticsContext.getAtlaskitAnalyticsEventHandlers(),
            payload: payload
        });
    }, [
        analyticsContext
    ]);
    return {
        createAnalyticsEvent: createAnalyticsEvent
    };
}

});
parcelRegister("flVBa", function(module, exports) {
$parcel$export(module.exports, "default", () => $b2d57f0f976706e4$export$2e2bcd8739ae039);

var $fC8ib = parcelRequire("fC8ib");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $kIXpt = parcelRequire("kIXpt");

var $cYPzS = parcelRequire("cYPzS");

var $lwlXp = parcelRequire("lwlXp");

var $eyuDe = parcelRequire("eyuDe");

var $25nEq = parcelRequire("25nEq");

var $97p3r = parcelRequire("97p3r");
function $b2d57f0f976706e4$var$_callSuper(t, o, e) {
    return o = (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(o), (0, (/*@__PURE__*/$parcel$interopDefault($kIXpt)))(t, $b2d57f0f976706e4$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(t).constructor) : o.apply(t, e));
}
function $b2d57f0f976706e4$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($b2d57f0f976706e4$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $b2d57f0f976706e4$var$_superPropGet(t, o, e, r) {
    var p = (0, (/*@__PURE__*/$parcel$interopDefault($lwlXp)))((0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(1 & r ? t.prototype : t), o, e);
    return 2 & r && "function" == typeof p ? function(t) {
        return p.apply(e, t);
    } : p;
}
var $b2d57f0f976706e4$export$35f8383928ba8d7 = function isUIAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $b2d57f0f976706e4$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isUIAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === 'UIAnalyticsEvent';
};
var $b2d57f0f976706e4$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_AnalyticsEvent) {
    function UIAnalyticsEvent(props) {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, UIAnalyticsEvent);
        _this = $b2d57f0f976706e4$var$_callSuper(this, UIAnalyticsEvent, [
            props
        ]);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "_isUIAnalyticsEvent", true);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "clone", function() {
            if (_this.hasFired) return null;
            var context = (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(_this.context);
            var handlers = (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(_this.handlers);
            /**
       * A hacky "deep clone" of the object. This is limited in that it wont
       * support functions, regexs, Maps, Sets, etc, but none of those need to
       * be represented in our payload.
       */ var payload = JSON.parse(JSON.stringify(_this.payload));
            return new UIAnalyticsEvent({
                context: context,
                handlers: handlers,
                payload: payload
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "fire", function(channel) {
            if (_this.hasFired) return;
            _this.handlers.forEach(function(handler) {
                return handler(_this, channel);
            });
            _this.hasFired = true;
        });
        _this.context = props.context || [];
        _this.handlers = props.handlers || [];
        _this.hasFired = false;
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($eyuDe)))(UIAnalyticsEvent, _AnalyticsEvent);
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(UIAnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (this.hasFired) return this;
                return $b2d57f0f976706e4$var$_superPropGet(UIAnalyticsEvent, "update", this, 3)([
                    updater
                ]);
            }
        }
    ]);
}((0, $97p3r.default));

});
parcelRegister("97p3r", function(module, exports) {
$parcel$export(module.exports, "default", () => $6a3833d12211de39$export$2e2bcd8739ae039);

var $ekGgq = parcelRequire("ekGgq");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $25nEq = parcelRequire("25nEq");
function $6a3833d12211de39$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $6a3833d12211de39$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $6a3833d12211de39$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $6a3833d12211de39$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $6a3833d12211de39$export$ad4be5c2ec28cecf = function isAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $6a3833d12211de39$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === 'AnalyticsEvent';
};
var $6a3833d12211de39$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function AnalyticsEvent(props) {
        var _this = this;
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, AnalyticsEvent);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "_isAnalyticsEvent", true);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "clone", function() {
            // just a shallow clone, don't change sub refs unless you want to
            // affect the original's too
            var payload = $6a3833d12211de39$var$_objectSpread({}, _this.payload);
            return new AnalyticsEvent({
                payload: payload
            });
        });
        this.payload = props.payload;
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(AnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (typeof updater === 'function') this.payload = updater(this.payload);
                if ((0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(updater) === 'object') this.payload = $6a3833d12211de39$var$_objectSpread($6a3833d12211de39$var$_objectSpread({}, this.payload), updater);
                return this;
            }
        }
    ]);
}();

});


parcelRegister("bSE6z", function(module, exports) {
$parcel$export(module.exports, "useAnalyticsContext", () => $8a63d8dd07a9e189$export$d1f587f82ad51c4);

var $5FkrB = parcelRequire("5FkrB");

var $iyyOp = parcelRequire("iyyOp");
var $8a63d8dd07a9e189$export$d1f587f82ad51c4 = function useAnalyticsContext() {
    return (0, $5FkrB.useContext)((0, $iyyOp.default));
};

});


parcelRegister("79FeR", function(module, exports) {
$parcel$export(module.exports, "useTrackedRef", () => $53595ccef641993f$export$1d27a74659855e44);

var $5FkrB = parcelRequire("5FkrB");
var $53595ccef641993f$export$1d27a74659855e44 = function useTrackedRef(value) {
    var ref = (0, $5FkrB.useRef)(value);
    ref.current = value;
    return ref;
};

});


parcelRegister("eFRYv", function(module, exports) {
$parcel$export(module.exports, "useNotifyOpenLayerObserver", () => $aaeec34dc3951f04$export$469bb693f11edc7f);

var $5FkrB = parcelRequire("5FkrB");

var $k8d4l = parcelRequire("k8d4l");

var $eI34S = parcelRequire("eI34S");
function $aaeec34dc3951f04$export$469bb693f11edc7f(_ref) {
    var isOpen = _ref.isOpen, type = _ref.type, onClose = _ref.onClose;
    var context = (0, $5FkrB.useContext)((0, $k8d4l.OpenLayerObserverContext));
    var namespace = (0, $eI34S.useOpenLayerObserverNamespace)();
    (0, $5FkrB.useEffect)(function() {
        /**
     * Registers the `onClose` callback with the OpenLayerObserver.
     */ if (context === null) return;
        if (!isOpen) /**
       * If the layer is not open, we are not registering the `onClose` callback.
       * This is important to prevent the `onClose` from being called for layers that
       * are not open.
       *
       * Some consumers mistakenly pass "toggle" functions to `onClose` callbacks for
       * layer components, as Popup, e.g. `onClose={() => setIsOpen(!isOpen)}`.
       */ return;
        return context.onClose(onClose, {
            namespace: namespace,
            type: type
        });
    }, [
        context,
        isOpen,
        namespace,
        onClose,
        type
    ]);
}

});
parcelRegister("k8d4l", function(module, exports) {
$parcel$export(module.exports, "OpenLayerObserverContext", () => $ea7eb14486bd6f92$export$5fbf4d7fae6cdc00);

var $5FkrB = parcelRequire("5FkrB");
var $ea7eb14486bd6f92$export$5fbf4d7fae6cdc00 = /*#__PURE__*/ (0, $5FkrB.createContext)(null);

});

parcelRegister("eI34S", function(module, exports) {
$parcel$export(module.exports, "useOpenLayerObserverNamespace", () => $ab578fe3c1f8740d$export$1d57e79091cc3046);

var $5FkrB = parcelRequire("5FkrB");

var $jpnbW = parcelRequire("jpnbW");
function $ab578fe3c1f8740d$export$1d57e79091cc3046() {
    var namespace = (0, $5FkrB.useContext)((0, $jpnbW.OpenLayerObserverNamespaceContext));
    return namespace;
}

});
parcelRegister("jpnbW", function(module, exports) {
$parcel$export(module.exports, "OpenLayerObserverNamespaceContext", () => $e212577911eb2f3f$export$644a49f3b8c50fcd);

var $5FkrB = parcelRequire("5FkrB");
var $e212577911eb2f3f$export$644a49f3b8c50fcd = /*#__PURE__*/ (0, $5FkrB.createContext)(null);

});



parcelRegister("hGuZe", function(module, exports) {
$parcel$export(module.exports, "useExitingPersistence", () => $cdfe652fd33ae7fa$export$3b6f38abbdcbd000);
$parcel$export(module.exports, "default", () => $cdfe652fd33ae7fa$export$2e2bcd8739ae039);

var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");
/**
 * Internally we will be playing with an element that will always have a key defined.
 */ /**
 * Internal data passed to child motions.
 */ // We define empty context here so the object doesn't change.
var $cdfe652fd33ae7fa$var$emptyContext = {
    // Motions will always appear if not inside a exiting persistence component.
    appear: true,
    isExiting: false
};
/**
 * __Exiting context__
 *
 * An exiting context.
 */ var $cdfe652fd33ae7fa$var$ExitingContext = /*#__PURE__*/ (0, $5FkrB.createContext)($cdfe652fd33ae7fa$var$emptyContext);
/**
 * This method will wrap any React element with a context provider. We're using context (instead of
 * cloneElement) so we can communicate between multiple elements without the need of prop drilling
 * (results in a better API for consumers).
 */ var $cdfe652fd33ae7fa$var$wrapChildWithContextProvider = function wrapChildWithContextProvider(child) {
    var value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $cdfe652fd33ae7fa$var$emptyContext;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement($cdfe652fd33ae7fa$var$ExitingContext.Provider, {
        key: "".concat(child.key, "-provider"),
        value: value
    }, child);
};
/**
 * This function will convert all children types to an array while also filtering out non-valid React elements.
 */ var $cdfe652fd33ae7fa$var$childrenToArray = function childrenToArray(children) {
    var childrenAsArray = [];
    // We convert children to an array using this helper method as it will add keys to children that do not
    // have them, such as when we have hardcoded children that are conditionally rendered.
    (0, $5FkrB.Children).toArray(children).forEach(function(child) {
        // We ignore any boolean children to make our code a little more simple later on,
        // and also filter out any falsies (empty strings, nulls, and undefined).
        if (typeof child !== 'boolean' && Boolean(child)) // Children WILL have a key after being forced into an array using the React.Children helper.
        childrenAsArray.push(child);
    });
    return childrenAsArray;
};
var $cdfe652fd33ae7fa$var$spliceNewElementsIntoPrevious = function spliceNewElementsIntoPrevious(current, previous) {
    var splicedChildren = previous.concat([]);
    var previousMap = $cdfe652fd33ae7fa$var$childrenToObj(previous);
    for(var i = 0; i < current.length; i++){
        var child = current[i];
        var childIsNew = !previousMap[child.key];
        if (childIsNew) // This will insert the new element after the previous element.
        splicedChildren.splice(i + 1, 0, child);
    }
    return splicedChildren;
};
var $cdfe652fd33ae7fa$var$childrenToObj = function childrenToObj(children) {
    return children.reduce(function(acc, child) {
        acc[child.key] = child;
        return acc;
    }, {});
};
var $cdfe652fd33ae7fa$var$getMissingKeys = function getMissingKeys(current, previous) {
    var currentMapKeys = new Set(current.map(function(child) {
        return child.key;
    }));
    var missing = new Set();
    for(var i = 0; i < previous.length; i++){
        var element = previous[i];
        var _key = element.key;
        if (!currentMapKeys.has(_key)) missing.add(_key);
    }
    return missing;
};
/**
 * How does this component work?
 *
 * It looks at changes in its children to see what is removed.
 *
 * If a child is removed it clones it and wraps it with context providing an `onFinish` callback.
 *
 * The cloned child will call the `onFinish` when it finishes its exit animation,
 * which lets `ExitingPersistence` know to stop rendering it.
 */ /**
 * __ExitingPersistence__
 *
 * Useful for enabling elements to persist and animate away when they are removed from the DOM.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/motion/docs/entering-motions)
 */ var $cdfe652fd33ae7fa$var$ExitingPersistence = /*#__PURE__*/ (0, $5FkrB.memo)(function(_ref) {
    var _ref$appear = _ref.appear, appear = _ref$appear === void 0 ? false : _ref$appear, children = _ref.children, exitThenEnter = _ref.exitThenEnter;
    var _useState = (0, $5FkrB.useState)([
        null,
        children
    ]), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), stateChildren = _useState2[0], setChildren = _useState2[1];
    var _useState3 = (0, $5FkrB.useState)([]), _useState4 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState3, 2), exitingChildren = _useState4[0], setExitingChildren = _useState4[1];
    var _useState5 = (0, $5FkrB.useState)(function() {
        return {
            appear: appear,
            isExiting: false
        };
    }), _useState6 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState5, 2), defaultContext = _useState6[0], setDefaultContext = _useState6[1];
    (0, $5FkrB.useEffect)(function() {
        if (!defaultContext.appear) setDefaultContext({
            appear: true,
            isExiting: false
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    /**
   * NOTE: This is a workaround for the test case written in Jira where the stateChildren is a boolean value because
   * useState is mocked to return a boolean value.
   */ if (typeof stateChildren === 'boolean') return children;
    var _stateChildren = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(stateChildren, 2), previousChildren = _stateChildren[0], currentChildren = _stateChildren[1];
    var previous = $cdfe652fd33ae7fa$var$childrenToArray(previousChildren);
    var current = $cdfe652fd33ae7fa$var$childrenToArray(currentChildren);
    if (currentChildren !== children) setChildren([
        currentChildren,
        children
    ]);
    var missingKeys = $cdfe652fd33ae7fa$var$getMissingKeys(current, previous);
    var isSomeChildRemoved = !!missingKeys.size;
    var visibleChildren = current;
    if (isSomeChildRemoved) visibleChildren = $cdfe652fd33ae7fa$var$spliceNewElementsIntoPrevious(current, previous);
    if (exitThenEnter) {
        if (exitingChildren.length) visibleChildren = exitingChildren;
        else {
            var nextExitingChildren = visibleChildren.filter(function(child) {
                return missingKeys.has(child.key);
            });
            if (nextExitingChildren.length) setExitingChildren(nextExitingChildren);
        }
    }
    if (missingKeys.size) visibleChildren = visibleChildren.map(function(child) {
        var isExiting = missingKeys.has(child.key);
        return $cdfe652fd33ae7fa$var$wrapChildWithContextProvider(child, {
            appear: true,
            isExiting: isExiting,
            onFinish: isExiting ? function() {
                missingKeys.delete(child.key);
                if (missingKeys.size === 0) {
                    setChildren([
                        null,
                        children
                    ]);
                    setExitingChildren([]);
                }
            } : undefined
        });
    });
    else visibleChildren = visibleChildren.map(function(child) {
        return $cdfe652fd33ae7fa$var$wrapChildWithContextProvider(child, defaultContext);
    });
    return visibleChildren;
});
var $cdfe652fd33ae7fa$export$3b6f38abbdcbd000 = function useExitingPersistence() {
    return (0, $5FkrB.useContext)($cdfe652fd33ae7fa$var$ExitingContext);
};
$cdfe652fd33ae7fa$var$ExitingPersistence.displayName = 'ExitingPersistence';
var $cdfe652fd33ae7fa$export$2e2bcd8739ae039 = $cdfe652fd33ae7fa$var$ExitingPersistence;

});

parcelRegister("lUsc6", function(module, exports) {
$parcel$export(module.exports, "default", () => $ff34b2b748e791c3$export$2e2bcd8739ae039);

var $5FkrB = parcelRequire("5FkrB");

var $E2AMl = parcelRequire("E2AMl");
var $ff34b2b748e791c3$var$invertedDirection = {
    top: 'bottom',
    bottom: 'top',
    left: 'right',
    right: 'left'
};
/**
 * Props for controlling the behavior of the FadeIn animation
 */ /**
 * __FadeIn__
 *
 * Useful for fading in one or more elements.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/motion/docs/entering-motions)
 */ var $ff34b2b748e791c3$var$FadeIn = function FadeIn(_ref) {
    var children = _ref.children, _ref$duration = _ref.duration, duration = _ref$duration === void 0 ? 'large' : _ref$duration, entranceDirection = _ref.entranceDirection, exitDirection = _ref.exitDirection, _ref$distance = _ref.distance, distance = _ref$distance === void 0 ? 'proportional' : _ref$distance, onFinish = _ref.onFinish, isPaused = _ref.isPaused;
    var invertedEntranceDirection = entranceDirection !== undefined ? $ff34b2b748e791c3$var$invertedDirection[entranceDirection] : undefined;
    var isExitDirect = Boolean(exitDirection || invertedEntranceDirection) ? "fade-out-from-".concat(exitDirection || invertedEntranceDirection).concat(distance === 'proportional' ? '' : '-constant') : 'fade-out';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $E2AMl.default), {
        duration: duration,
        enteringAnimation: entranceDirection ? "fade-in-from-".concat(entranceDirection).concat(distance === 'proportional' ? '' : '-constant') : 'fade-in',
        exitingAnimation: isExitDirect,
        animationTimingFunction: "ease-in-out",
        onFinish: onFinish,
        isPaused: isPaused
    }, children);
};
var $ff34b2b748e791c3$export$2e2bcd8739ae039 = $ff34b2b748e791c3$var$FadeIn;

});
parcelRegister("E2AMl", function(module, exports) {
$parcel$export(module.exports, "default", () => $0785bf4cb3cc6754$export$2e2bcd8739ae039);
/* keyframes-motion.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");

var $a2UTr = parcelRequire("a2UTr");

var $b8LPn = parcelRequire("b8LPn");

var $4BMdD = parcelRequire("4BMdD");

var $hGuZe = parcelRequire("hGuZe");

var $7uIRT = parcelRequire("7uIRT");
var $0785bf4cb3cc6754$var$zoomIn = null;
var $0785bf4cb3cc6754$var$zoomOut = null;
var $0785bf4cb3cc6754$var$fadeIn = null;
var $0785bf4cb3cc6754$var$fadeOut = null;
var $0785bf4cb3cc6754$var$fadeInFromTop = null;
var $0785bf4cb3cc6754$var$fadeOutFromTop = null;
var $0785bf4cb3cc6754$var$fadeInFromLeft = null;
var $0785bf4cb3cc6754$var$fadeOutFromLeft = null;
var $0785bf4cb3cc6754$var$fadeInFromBottom = null;
var $0785bf4cb3cc6754$var$fadeOutFromBottom = null;
var $0785bf4cb3cc6754$var$fadeInFromRight = null;
var $0785bf4cb3cc6754$var$fadeOutFromRight = null;
var $0785bf4cb3cc6754$var$fadeInFromTopConstant = null;
var $0785bf4cb3cc6754$var$fadeOutFromTopConstant = null;
var $0785bf4cb3cc6754$var$fadeInFromLeftConstant = null;
var $0785bf4cb3cc6754$var$fadeOutFromLeftConstant = null;
var $0785bf4cb3cc6754$var$fadeInFromBottomConstant = null;
var $0785bf4cb3cc6754$var$fadeOutFromBottomConstant = null;
var $0785bf4cb3cc6754$var$fadeInFromRightConstant = null;
var $0785bf4cb3cc6754$var$fadeOutFromRightConstant = null;
var $0785bf4cb3cc6754$var$slideInFromTop = null;
var $0785bf4cb3cc6754$var$slideOutFromTop = null;
var $0785bf4cb3cc6754$var$slideInFromRight = null;
var $0785bf4cb3cc6754$var$slideOutFromRight = null;
var $0785bf4cb3cc6754$var$slideInFromBottom = null;
var $0785bf4cb3cc6754$var$slideOutFromBottom = null;
var $0785bf4cb3cc6754$var$slideInFromLeft = null;
var $0785bf4cb3cc6754$var$slideOutFromLeft = null;
/**
 * These are props that motions should use as their external props for consumers.
 * See [FadeIn](packages/helpers/motion/src/entering/fade-in.tsx) for an example usage.
 */ /**
 * This is the base INTERNAL component used for all other entering motions.
 * This does not need Javascript to execute on the client so it will run immediately
 * for any SSR rendered React apps before the JS has executed.
 */ var $0785bf4cb3cc6754$var$EnteringMotion = function EnteringMotion(_ref) {
    var children = _ref.children, animationTimingFunction = _ref.animationTimingFunction, _ref$animationTimingF = _ref.animationTimingFunctionExiting, animationTimingFunctionExiting = _ref$animationTimingF === void 0 ? animationTimingFunction : _ref$animationTimingF, enteringAnimation = _ref.enteringAnimation, _ref$exitingAnimation = _ref.exitingAnimation, exitingAnimation = _ref$exitingAnimation === void 0 ? enteringAnimation : _ref$exitingAnimation, isPaused = _ref.isPaused, onFinishMotion = _ref.onFinish, _ref$duration = _ref.duration, duration = _ref$duration === void 0 ? 'large' : _ref$duration;
    var staggered = (0, $7uIRT.useStaggeredEntrance)();
    var _useExitingPersistenc = (0, $hGuZe.useExitingPersistence)(), isExiting = _useExitingPersistenc.isExiting, onExitFinished = _useExitingPersistenc.onFinish, appear = _useExitingPersistenc.appear;
    var setTimeout = (0, $4BMdD.useSetTimeout)();
    var paused = isPaused || !staggered.isReady;
    var delay = isExiting ? 0 : staggered.delay;
    var state = isExiting ? 'exiting' : 'entering';
    var _useState = (0, $5FkrB.useState)(appear), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), hasAnimationStyles = _useState2[0], setHasAnimationStyles = _useState2[1];
    (0, $5FkrB.useEffect)(function() {
        // Tracking this to prevent changing state on an unmounted component
        var isCancelled = false;
        if (paused) return;
        // On initial mount if elements aren't set to animate on appear, we return early and callback
        if (!appear) {
            onFinishMotion && onFinishMotion(state);
            return;
        }
        /**
     * Updates relevant state.
     * Called when the animation is finished, or immediately with reduced motion.
     */ var onAnimationEnd = function onAnimationEnd() {
            if (state === 'exiting') // Updates the `ExitingPersistence` to remove this child
            onExitFinished === null || onExitFinished === void 0 || onExitFinished();
            if (!isCancelled) setHasAnimationStyles(false);
            onFinishMotion === null || onFinishMotion === void 0 || onFinishMotion(state);
        };
        if ((0, $a2UTr.isReducedMotion)()) {
            // If there is reduced motion there is no exit animation, so call this immediately
            onAnimationEnd();
            return;
        }
        // Elements may need animation styles back after initial mount (they could animate out)
        setHasAnimationStyles(true);
        // Queue `onAnimationEnd` for after the animation has finished
        setTimeout(onAnimationEnd, isExiting ? (0, $b8LPn.exitingDurations)[duration] : (0, $b8LPn.durations)[duration] + delay);
        return function() {
            isCancelled = true;
        };
    // We ignore this for onFinishMotion as consumers could potentially inline the function
    // which would then trigger this effect every re-render.
    // We want to make it easier for consumers so we go down this path unfortunately.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        onExitFinished,
        state,
        isExiting,
        duration,
        delay,
        paused,
        setTimeout
    ]);
    return children({
        ref: staggered.ref,
        // @ts-expect-error: `ax` is not typed correctly
        className: hasAnimationStyles ? (0, $970q7.default)([
            (0, $970q7.default)([
                "_1o51eoah _1y0co91m _1bumglyw _sedtglyw"
            ]),
            paused && (0, $970q7.default)([
                "_1y0ctrqk"
            ]),
            duration === 'small' && (0, $970q7.default)([
                "_5sag1yx9"
            ]),
            duration === 'medium' && (0, $970q7.default)([
                "_5sag1ttt"
            ]),
            duration === 'large' && (0, $970q7.default)([
                "_5sagpwmj"
            ]),
            isExiting && duration === 'small' && (0, $970q7.default)([
                "_5sag14ed"
            ]),
            isExiting && duration === 'medium' && (0, $970q7.default)([
                "_5sagluct"
            ]),
            isExiting && duration === 'large' && (0, $970q7.default)([
                "_5sag1ttt"
            ]),
            isExiting && (0, $970q7.default)([
                "_ju255cps _1o51q7pw"
            ]),
            !isExiting && animationTimingFunction === 'linear' && (0, $970q7.default)([
                "_1pglp3kn"
            ]),
            !isExiting && animationTimingFunction === 'ease-out' && (0, $970q7.default)([
                "_1pgldkwg"
            ]),
            !isExiting && animationTimingFunction === 'ease-in' && (0, $970q7.default)([
                "_1pgl1nzg"
            ]),
            !isExiting && animationTimingFunction === 'ease-in-40-out' && (0, $970q7.default)([
                "_1pgl5y64"
            ]),
            !isExiting && animationTimingFunction === 'ease-in-60-out' && (0, $970q7.default)([
                "_1pgl1ddy"
            ]),
            !isExiting && animationTimingFunction === 'ease-in-80-out' && (0, $970q7.default)([
                "_1pglannl"
            ]),
            !isExiting && animationTimingFunction === 'ease-in-out' && (0, $970q7.default)([
                "_1pgl1fu8"
            ]),
            isExiting && animationTimingFunction === 'linear' && (0, $970q7.default)([
                "_1pglp3kn"
            ]),
            isExiting && animationTimingFunctionExiting === 'ease-out' && (0, $970q7.default)([
                "_1pgldkwg"
            ]),
            isExiting && animationTimingFunctionExiting === 'ease-in' && (0, $970q7.default)([
                "_1pgl1nzg"
            ]),
            isExiting && animationTimingFunctionExiting === 'ease-in-40-out' && (0, $970q7.default)([
                "_1pgl5y64"
            ]),
            isExiting && animationTimingFunctionExiting === 'ease-in-60-out' && (0, $970q7.default)([
                "_1pgl1ddy"
            ]),
            isExiting && animationTimingFunctionExiting === 'ease-in-80-out' && (0, $970q7.default)([
                "_1pglannl"
            ]),
            isExiting && animationTimingFunctionExiting === 'ease-in-out' && (0, $970q7.default)([
                "_1pgl1fu8"
            ]),
            (!isExiting && enteringAnimation === 'fade-in' || isExiting && exitingAnimation === 'fade-in') && (0, $970q7.default)([
                "_j7hq1cgr"
            ]),
            (!isExiting && enteringAnimation === 'fade-out' || isExiting && exitingAnimation === 'fade-out') && (0, $970q7.default)([
                "_j7hq1lln"
            ]),
            (!isExiting && enteringAnimation === 'zoom-in' || isExiting && exitingAnimation === 'zoom-in') && (0, $970q7.default)([
                "_j7hqe8p0"
            ]),
            (!isExiting && enteringAnimation === 'zoom-out' || isExiting && exitingAnimation === 'zoom-out') && (0, $970q7.default)([
                "_j7hqy6ql"
            ]),
            (!isExiting && enteringAnimation === 'slide-in-from-top' || isExiting && exitingAnimation === 'slide-in-from-top') && (0, $970q7.default)([
                "_j7hqqshu"
            ]),
            (!isExiting && enteringAnimation === 'slide-out-from-top' || isExiting && exitingAnimation === 'slide-out-from-top') && (0, $970q7.default)([
                "_j7hq7ri4"
            ]),
            (!isExiting && enteringAnimation === 'slide-in-from-right' || isExiting && exitingAnimation === 'slide-in-from-right') && (0, $970q7.default)([
                "_j7hqdfjr"
            ]),
            (!isExiting && enteringAnimation === 'slide-out-from-right' || isExiting && exitingAnimation === 'slide-out-from-right') && (0, $970q7.default)([
                "_j7hqonfj"
            ]),
            (!isExiting && enteringAnimation === 'slide-in-from-bottom' || isExiting && exitingAnimation === 'slide-in-from-bottom') && (0, $970q7.default)([
                "_j7hq1liq"
            ]),
            (!isExiting && enteringAnimation === 'slide-out-from-bottom' || isExiting && exitingAnimation === 'slide-out-from-bottom') && (0, $970q7.default)([
                "_j7hqhnf1"
            ]),
            (!isExiting && enteringAnimation === 'slide-in-from-left' || isExiting && exitingAnimation === 'slide-in-from-left') && (0, $970q7.default)([
                "_j7hq1bh1"
            ]),
            (!isExiting && enteringAnimation === 'slide-out-from-left' || isExiting && exitingAnimation === 'slide-out-from-left') && (0, $970q7.default)([
                "_j7hqj08w"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-top' || isExiting && exitingAnimation === 'fade-in-from-top') && (0, $970q7.default)([
                "_j7hq2iua"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-top' || isExiting && exitingAnimation === 'fade-out-from-top') && (0, $970q7.default)([
                "_j7hq39va"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-left' || isExiting && exitingAnimation === 'fade-in-from-left') && (0, $970q7.default)([
                "_j7hq15m2"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-left' || isExiting && exitingAnimation === 'fade-out-from-left') && (0, $970q7.default)([
                "_j7hq1yiv"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-bottom' || isExiting && exitingAnimation === 'fade-in-from-bottom') && (0, $970q7.default)([
                "_j7hq1w00"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-bottom' || isExiting && exitingAnimation === 'fade-out-from-bottom') && (0, $970q7.default)([
                "_j7hqzy3z"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-right' || isExiting && exitingAnimation === 'fade-in-from-right') && (0, $970q7.default)([
                "_j7hqpqak"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-right' || isExiting && exitingAnimation === 'fade-out-from-right') && (0, $970q7.default)([
                "_j7hq1ebg"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-top-constant' || isExiting && exitingAnimation === 'fade-in-from-top-constant') && (0, $970q7.default)([
                "_j7hqm2e2"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-top-constant' || isExiting && exitingAnimation === 'fade-out-from-top-constant') && (0, $970q7.default)([
                "_j7hq97jn"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-left-constant' || isExiting && exitingAnimation === 'fade-in-from-left-constant') && (0, $970q7.default)([
                "_j7hqovgq"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-left-constant' || isExiting && exitingAnimation === 'fade-out-from-left-constant') && (0, $970q7.default)([
                "_j7hq15do"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-bottom-constant' || isExiting && exitingAnimation === 'fade-in-from-bottom-constant') && (0, $970q7.default)([
                "_j7hq797a"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-bottom-constant' || isExiting && exitingAnimation === 'fade-out-from-bottom-constant') && (0, $970q7.default)([
                "_j7hqwo7r"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-right-constant' || isExiting && exitingAnimation === 'fade-in-from-right-constant') && (0, $970q7.default)([
                "_j7hqt8u5"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-right-constant' || isExiting && exitingAnimation === 'fade-out-from-right-constant') && (0, $970q7.default)([
                "_j7hq1pgp"
            ])
        ]) : '',
        style: {
            animationDelay: "".concat(delay, "ms")
        }
    }, state);
};
var $0785bf4cb3cc6754$export$2e2bcd8739ae039 = $0785bf4cb3cc6754$var$EnteringMotion;

});
parcelRegister("a2UTr", function(module, exports) {
$parcel$export(module.exports, "isReducedMotion", () => $7506391dbf22417e$export$b7baf7667a68d87c);

var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");

var $7QpUe = parcelRequire("7QpUe");
var $7506391dbf22417e$var$isMatchMediaAvailable = function isMatchMediaAvailable() {
    return typeof window !== 'undefined' && 'matchMedia' in window;
};
var $7506391dbf22417e$export$b7baf7667a68d87c = function isReducedMotion() {
    if (!$7506391dbf22417e$var$isMatchMediaAvailable()) return false;
    var _window$matchMedia = window.matchMedia('(prefers-reduced-motion: reduce)'), matches = _window$matchMedia.matches;
    return matches;
};
var $7506391dbf22417e$export$c537e63161742ce3 = function useIsReducedMotion() {
    var _useState = (0, $5FkrB.useState)($7506391dbf22417e$export$b7baf7667a68d87c), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), prefersReducedMotion = _useState2[0], setPrefersReducedMotion = _useState2[1];
    (0, $5FkrB.useEffect)(function() {
        if (!$7506391dbf22417e$var$isMatchMediaAvailable()) return;
        var mediaQueryList = window.matchMedia('(prefers-reduced-motion: reduce)');
        var onChange = function onChange(event) {
            return setPrefersReducedMotion(event.matches);
        };
        return (0, $7QpUe.bind)(mediaQueryList, {
            type: 'change',
            listener: onChange
        });
    }, []);
    return prefersReducedMotion;
};
var $7506391dbf22417e$export$f0f789643ba5a83c = {
    '@media (prefers-reduced-motion: reduce)': {
        animation: 'none',
        transition: 'none'
    }
};
var $7506391dbf22417e$export$ff7706047246b98b = function prefersReducedMotion() {
    return $7506391dbf22417e$export$f0f789643ba5a83c;
};

});

parcelRegister("b8LPn", function(module, exports) {
$parcel$export(module.exports, "durations", () => $81c58aa9f6fc9dbf$export$38b928a7167ce124);
$parcel$export(module.exports, "exitingDurations", () => $81c58aa9f6fc9dbf$export$30fa1a2e62ae150c);
/**
 * Think of this as the motion equivalent of the @atlaskit/theme `grid()`.
 */ var $81c58aa9f6fc9dbf$export$368bacef0dacbe05 = 25;
var $81c58aa9f6fc9dbf$export$38b928a7167ce124 = {
    none: 0,
    small: 100,
    medium: 350,
    large: 700
};
/**
 * Used to multiply the initial duration for exiting motions.
 */ var $81c58aa9f6fc9dbf$var$EXITING_MOTION_MULTIPLIER = 0.5;
var $81c58aa9f6fc9dbf$export$30fa1a2e62ae150c = {
    none: $81c58aa9f6fc9dbf$export$38b928a7167ce124.none,
    small: $81c58aa9f6fc9dbf$export$38b928a7167ce124.small * $81c58aa9f6fc9dbf$var$EXITING_MOTION_MULTIPLIER,
    medium: $81c58aa9f6fc9dbf$export$38b928a7167ce124.medium * $81c58aa9f6fc9dbf$var$EXITING_MOTION_MULTIPLIER,
    large: $81c58aa9f6fc9dbf$export$38b928a7167ce124.large * $81c58aa9f6fc9dbf$var$EXITING_MOTION_MULTIPLIER
};

});

parcelRegister("4BMdD", function(module, exports) {
$parcel$export(module.exports, "useSetTimeout", () => $35b005605eeb2acd$export$4f34107a2b00f39c);

var $5FkrB = parcelRequire("5FkrB");
// Handle both browser and Node.js environments
var $35b005605eeb2acd$var$getHookDeps = function getHookDeps(opts) {
    switch(opts.cleanup){
        case 'next-effect':
            return undefined;
        case 'unmount':
        default:
            return [];
    }
};
var $35b005605eeb2acd$export$1775f27e7c8051ca = function useRequestAnimationFrame() {
    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        cleanup: 'unmount'
    };
    var frames = (0, $5FkrB.useRef)([]);
    (0, $5FkrB.useEffect)(function() {
        return function() {
            if (frames.current.length) {
                frames.current.forEach(function(id) {
                    return cancelAnimationFrame(id);
                });
                frames.current = [];
            }
        };
    // We dynamically set this so we either clean up on the next effect - or on unmount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, $35b005605eeb2acd$var$getHookDeps(opts));
    return (0, $5FkrB.useCallback)(function(handler) {
        var id = requestAnimationFrame(function(time) {
            frames.current = frames.current.filter(function(frameId) {
                return frameId !== id;
            });
            handler(time);
        });
        frames.current.push(id);
    }, []);
};
var $35b005605eeb2acd$export$4f34107a2b00f39c = function useSetTimeout() {
    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        cleanup: 'unmount'
    };
    var timeouts = (0, $5FkrB.useRef)([]);
    (0, $5FkrB.useEffect)(function() {
        return function() {
            if (timeouts.current.length) {
                timeouts.current.forEach(function(id) {
                    return clearTimeout(id);
                });
                timeouts.current = [];
            }
        };
    // We dynamically set this so we either clean up on the next effect - or on unmount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, $35b005605eeb2acd$var$getHookDeps(opts));
    return (0, $5FkrB.useCallback)(function(handler, timeout) {
        for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)args[_key - 2] = arguments[_key];
        var id = setTimeout.apply(void 0, [
            function() {
                timeouts.current = timeouts.current.filter(function(timeoutId) {
                    return timeoutId !== id;
                });
                handler();
            },
            timeout
        ].concat(args));
        timeouts.current.push(id);
    }, []);
};

});

parcelRegister("7uIRT", function(module, exports) {
$parcel$export(module.exports, "useStaggeredEntrance", () => $574e23a4a5aefd8e$export$25c7213fc07ec080);

var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");

var $eVb4V = parcelRequire("eVb4V");

var $4OnYY = parcelRequire("4OnYY");

var $eYTth = parcelRequire("eYTth");
var $574e23a4a5aefd8e$var$StaggeredEntranceContext = /*#__PURE__*/ (0, $5FkrB.createContext)(function() {
    return {
        isReady: true,
        delay: 0,
        ref: (0, $eVb4V.default)
    };
});
var $574e23a4a5aefd8e$export$25c7213fc07ec080 = function useStaggeredEntrance() {
    var indentifier = (0, $eYTth.useUniqueId)();
    var context = (0, $5FkrB.useContext)($574e23a4a5aefd8e$var$StaggeredEntranceContext);
    return context(indentifier);
};
/**
 * For a list of elements that need to animate in,
 * this should be used in conjunction with entering components.
 * This does not need Javascript to execute so it will run immediately for any SSR rendered React apps before the JS has executed.
 *
 * Will dynamically add delay to each child entering component.
 * Unfortunately all entering components _NEED_ to be a direct descendant.
 */ var $574e23a4a5aefd8e$var$StaggeredEntrance = function StaggeredEntrance(_ref) {
    var children = _ref.children, column = _ref.column, _ref$columns = _ref.columns, columns = _ref$columns === void 0 ? 'responsive' : _ref$columns, _ref$delayStep = _ref.delayStep, delayStep = _ref$delayStep === void 0 ? 50 : _ref$delayStep;
    var elementRefs = (0, $5FkrB.useRef)([]);
    var indexes = [];
    var _useState = (0, $5FkrB.useState)(function() {
        if (typeof columns === 'number') // A hardcoded columns is set so bail out and set it to that!
        return columns;
        if (typeof column === 'number') // A hardcoded column is set so we will set actualColumns to be 1.
        return 1;
        // We are in "responsive" mode.
        // So we will be calculating when the Javascript executes on the client how many columns there will be.
        return 0;
    }), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), actualColumns = _useState2[0], setActualColumns = _useState2[1];
    (0, $4OnYY.useLayoutEffect)(function() {
        // We want to only run this code when we are in "responsive" mode.
        // It is assumed we are in responsive mode if `columns` is "responsive",
        // we have children element refs ready to be read (i.e. if there are no children this won't run as well)
        // and finally that `actualColumns` is `0` - this is because for the first render cycle `actualColumns` will be `0` (set above)
        // and then after this layout effect runs the value for `actualColumns` will then be calculated and set.
        if (columns === 'responsive' && elementRefs.current.length && actualColumns === 0) {
            var currentTop = 0;
            var numberColumns = 0;
            if (elementRefs.current.length <= 1) {
                setActualColumns(1);
                return;
            }
            // We set the current top to the first elements.
            // We will be comparing this and incrementing the column count
            // until we hit an element that has a different offset top (or we run out of elements).
            currentTop = elementRefs.current[0] ? elementRefs.current[0].offsetTop : 0;
            for(var i = 0; i < elementRefs.current.length; i++){
                var child = elementRefs.current[i];
                if (!child) break;
                if (currentTop === child.offsetTop) {
                    numberColumns += 1;
                    if (elementRefs.current.length - 1 === i) setActualColumns(numberColumns);
                    continue;
                }
                setActualColumns(numberColumns);
                break;
            }
        }
    // We only want this effect to run once - on initial mount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement($574e23a4a5aefd8e$var$StaggeredEntranceContext.Provider, {
        value: function value(id) {
            if (!indexes.includes(id)) indexes.push(id);
            var isReady = actualColumns > 0;
            var index = indexes.indexOf(id);
            var currentColumn = column || index % actualColumns;
            var currentRow = Math.floor(index / actualColumns);
            var distanceFromTopLeftElement = currentRow + currentColumn;
            // We don't want loads of elements to have the same staggered delay as it ends up looking slow for users.
            // To get around that we calculate the logarithm using `distanceFromTopLeftElement` which ends making
            // elements appear faster the further away from the top left element.
            var delay = Math.ceil(Math.log(distanceFromTopLeftElement + 1) * delayStep * 1.5) || 0;
            return {
                delay: delay,
                isReady: isReady,
                ref: function ref(element) {
                    return elementRefs.current[index] = element;
                }
            };
        }
    }, children);
};
var $574e23a4a5aefd8e$export$2e2bcd8739ae039 = $574e23a4a5aefd8e$var$StaggeredEntrance;

});
parcelRegister("4OnYY", function(module, exports) {
$parcel$export(module.exports, "useLayoutEffect", () => $380e6f54ec1c4101$export$e5c5a5f917a5871c);

var $5FkrB = parcelRequire("5FkrB");
var $380e6f54ec1c4101$export$e5c5a5f917a5871c = typeof window === 'undefined' ? (0, $5FkrB.useEffect) : (0, $5FkrB.useLayoutEffect);

});

parcelRegister("eYTth", function(module, exports) {
$parcel$export(module.exports, "useUniqueId", () => $ae81b2b87b9813d5$export$c485849f2e393253);
/* eslint-disable @repo/internal/react/disallow-unstable-values */ 
var $5FkrB = parcelRequire("5FkrB");
function $ae81b2b87b9813d5$export$c485849f2e393253() {
    var identifier = (0, $5FkrB.useRef)('');
    if (!identifier.current) identifier.current = '_' + (Number(String(Math.random()).slice(2)) + Date.now() + Math.round(performance.now())).toString(36);
    return identifier.current;
}

});




parcelRegister("6vLi9", function(module, exports) {
$parcel$export(module.exports, "default", () => $4bda52820e5a8f86$export$2e2bcd8739ae039);

var $5FkrB = parcelRequire("5FkrB");

var $9Zzpd = parcelRequire("9Zzpd");

var $gwxMb = parcelRequire("gwxMb");

var $4n0WE = parcelRequire("4n0WE");

var $ezv9T = parcelRequire("ezv9T");

var $c5wmc = parcelRequire("c5wmc");
function $4bda52820e5a8f86$export$2e2bcd8739ae039(_ref) {
    var _ref$zIndex = _ref.zIndex, zIndex = _ref$zIndex === void 0 ? 0 : _ref$zIndex, children = _ref.children, _ref$mountStrategy = _ref.mountStrategy, mountStrategy = _ref$mountStrategy === void 0 ? 'effect' : _ref$mountStrategy;
    var isSubsequentRender = (0, $ezv9T.default)(mountStrategy);
    (0, $c5wmc.default)(zIndex);
    return !(0, $9Zzpd.fg)('platform_design_system_team_portal_logic_r18_fix') ? isSubsequentRender ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $gwxMb.default), {
        zIndex: zIndex
    }, children) : null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $4n0WE.default), {
        zIndex: zIndex
    }, children);
}

});
parcelRegister("gwxMb", function(module, exports) {
$parcel$export(module.exports, "default", () => $c079d5ba276d215d$export$2e2bcd8739ae039);

var $5FkrB = parcelRequire("5FkrB");

var $aLeHs = parcelRequire("aLeHs");

var $2gfRh = parcelRequire("2gfRh");
function $c079d5ba276d215d$export$2e2bcd8739ae039(props) {
    var zIndex = props.zIndex, children = props.children;
    var container = (0, $5FkrB.useMemo)(function() {
        return (0, $2gfRh.createContainer)(zIndex);
    }, [
        zIndex
    ]);
    // This is in the render method instead of useEffect so that
    // the portal will be added to the DOM before the children render.
    // For any further changes, ensure that the container does not have a
    // parent besides the portal parent.
    (0, $2gfRh.appendPortalContainerIfNotAppended)(container);
    (0, $5FkrB.useEffect)(function() {
        return function() {
            (0, $2gfRh.removePortalContainer)(container);
        };
    }, [
        container
    ]);
    return /*#__PURE__*/ (0, $aLeHs.createPortal)(children, container);
}

});
parcelRegister("2gfRh", function(module, exports) {
$parcel$export(module.exports, "createContainer", () => $1a59608a9af4e2ed$export$26ae5ca175b4ec5a);
$parcel$export(module.exports, "removePortalContainer", () => $1a59608a9af4e2ed$export$da99f98bf3fe55b3);
$parcel$export(module.exports, "appendPortalContainerIfNotAppended", () => $1a59608a9af4e2ed$export$c582005add11e141);
$parcel$export(module.exports, "createAtlaskitPortal", () => $1a59608a9af4e2ed$export$fef014d7cef9e543);
$parcel$export(module.exports, "createPortalParent", () => $1a59608a9af4e2ed$export$95029ca7aca2989e);

var $3Eb4S = parcelRequire("3Eb4S");
var $1a59608a9af4e2ed$export$26ae5ca175b4ec5a = function createContainer(zIndex) {
    var container = document.createElement('div');
    container.className = (0, $3Eb4S.portalClassName);
    container.style.zIndex = "".concat(zIndex);
    return container;
};
/**
 * Returns document body element
 * @return {number} - The document body element
 */ var $1a59608a9af4e2ed$var$getBody = function getBody() {
    return document.body;
};
/**
 * Returns portal parent container. If no container exists already then it creates a new container with class name 'atlaskit-portal-container'
 * @return {Element} - The portal parent container div element
 */ var $1a59608a9af4e2ed$var$getPortalParent = function getPortalParent() {
    var parentElement = document.querySelector((0, $3Eb4S.portalParentSelector));
    if (!parentElement) {
        var _getBody;
        var parent = document.createElement('div');
        parent.className = (0, $3Eb4S.portalParentClassName);
        // we are setting display to flex because we want each portal to create a new stacking context
        // See https://developer.mozilla.org/en-US/docs/Web/CSS/CSS_Positioning/Understanding_z_index/The_stacking_context
        parent.style.display = 'flex';
        (_getBody = $1a59608a9af4e2ed$var$getBody()) === null || _getBody === void 0 || _getBody.appendChild(parent);
        return parent;
    }
    return parentElement;
};
var $1a59608a9af4e2ed$export$da99f98bf3fe55b3 = function removePortalContainer(container) {
    $1a59608a9af4e2ed$var$getPortalParent().removeChild(container);
};
var $1a59608a9af4e2ed$export$c582005add11e141 = function appendPortalContainerIfNotAppended(container) {
    if (!container.parentElement) $1a59608a9af4e2ed$var$getPortalParent().appendChild(container);
};
var $1a59608a9af4e2ed$var$isDocumentDefined = function isDocumentDefined() {
    return document !== undefined;
};
var $1a59608a9af4e2ed$export$fef014d7cef9e543 = function createAtlaskitPortal(zIndex) {
    //atlaskit-portal div
    if ($1a59608a9af4e2ed$var$isDocumentDefined()) {
        var atlaskitportal = document.createElement('div');
        atlaskitportal.className = (0, $3Eb4S.portalClassName);
        atlaskitportal.style.zIndex = "".concat(zIndex);
        return atlaskitportal;
    }
    return;
};
var $1a59608a9af4e2ed$export$95029ca7aca2989e = function createPortalParent() {
    //atlaskit-portal-container div
    if ($1a59608a9af4e2ed$var$isDocumentDefined()) {
        var parentElement = document.querySelector((0, $3Eb4S.portalParentSelector));
        if (!parentElement) {
            var _getBody2;
            var parent = document.createElement('div');
            parent.className = (0, $3Eb4S.portalParentClassName);
            parent.style.display = 'flex';
            (_getBody2 = $1a59608a9af4e2ed$var$getBody()) === null || _getBody2 === void 0 || _getBody2.appendChild(parent);
            return parent;
        }
        return parentElement;
    }
    return;
};

});
parcelRegister("3Eb4S", function(module, exports) {
$parcel$export(module.exports, "portalParentClassName", () => $2a7db34fa9de9c7b$export$e4c79eb95c23a0da);
$parcel$export(module.exports, "portalParentSelector", () => $2a7db34fa9de9c7b$export$72f415121273627e);
$parcel$export(module.exports, "portalClassName", () => $2a7db34fa9de9c7b$export$13f57c02915787b3);
var $2a7db34fa9de9c7b$export$e4c79eb95c23a0da = 'atlaskit-portal-container';
var $2a7db34fa9de9c7b$export$72f415121273627e = 'body > .atlaskit-portal-container';
var $2a7db34fa9de9c7b$export$13f57c02915787b3 = 'atlaskit-portal';

});



parcelRegister("4n0WE", function(module, exports) {
$parcel$export(module.exports, "default", () => $32ea0b0bc9044006$export$2e2bcd8739ae039);

var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");

var $aLeHs = parcelRequire("aLeHs");

var $1CPle = parcelRequire("1CPle");

var $2gfRh = parcelRequire("2gfRh");
function $32ea0b0bc9044006$export$2e2bcd8739ae039(props) {
    var zIndex = props.zIndex, children = props.children;
    var _useState = (0, $5FkrB.useState)(null), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), atlaskitPortal = _useState2[0], setAtlaskitPortal = _useState2[1];
    (0, $1CPle.useIsomorphicLayoutEffect)(function() {
        var tempPortalContainer = (0, $2gfRh.createAtlaskitPortal)(zIndex);
        setAtlaskitPortal(tempPortalContainer);
        var portalParent = (0, $2gfRh.createPortalParent)();
        if (!tempPortalContainer || !portalParent) return;
        portalParent.appendChild(tempPortalContainer);
        return function() {
            if (tempPortalContainer) portalParent.removeChild(tempPortalContainer);
            setAtlaskitPortal(null);
        };
    }, [
        zIndex
    ]);
    /**
   * We wrap portal children with a Suspense boundary because in React 18 concurrent,
   * if you suspend from _within_ a portal to a Suspense boundary _outside_ the portal,
   * our portal gets in an infinite loop of rendering.
   */ var suspendedChildren = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $5FkrB.Suspense), {
        fallback: null
    }, children);
    return atlaskitPortal ? /*#__PURE__*/ (0, $aLeHs.createPortal)(suspendedChildren, atlaskitPortal) : null;
}

});
parcelRegister("1CPle", function(module, exports) {
$parcel$export(module.exports, "useIsomorphicLayoutEffect", () => $12f12a5f89577976$export$700979bc83e7db82);

var $5FkrB = parcelRequire("5FkrB");
var $12f12a5f89577976$export$700979bc83e7db82 = typeof window !== 'undefined' ? (0, $5FkrB.useLayoutEffect) : (0, $5FkrB.useEffect);

});


parcelRegister("ezv9T", function(module, exports) {
$parcel$export(module.exports, "default", () => $a9bc80fdcf7857e7$export$2e2bcd8739ae039);

var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");

var $1CPle = parcelRequire("1CPle");
var $a9bc80fdcf7857e7$var$useIsSubsequentRender = function useIsSubsequentRender(mountStrategy) {
    var _useState = (0, $5FkrB.useState)(false), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), isSubsequentRender = _useState2[0], setIsSubsequentRender = _useState2[1];
    var _useState3 = (0, $5FkrB.useState)(function() {
        return mountStrategy === 'layoutEffect' ? (0, $1CPle.useIsomorphicLayoutEffect) : (0, $5FkrB.useEffect);
    }), _useState4 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState3, 1), useMountEffect = _useState4[0];
    useMountEffect(function() {
        setIsSubsequentRender(true);
    }, []);
    return isSubsequentRender;
};
var $a9bc80fdcf7857e7$export$2e2bcd8739ae039 = $a9bc80fdcf7857e7$var$useIsSubsequentRender;

});

parcelRegister("c5wmc", function(module, exports) {
$parcel$export(module.exports, "default", () => $8ccf0d178e589fcb$export$2e2bcd8739ae039);

var $5FkrB = parcelRequire("5FkrB");

var $9XDvW = parcelRequire("9XDvW");

var $3Dz9u = parcelRequire("3Dz9u");
var $8ccf0d178e589fcb$var$useFirePortalEvent = function useFirePortalEvent(zIndex) {
    var zIndexNumber = Number(zIndex);
    (0, $5FkrB.useEffect)(function() {
        (0, $3Dz9u.default)((0, $9XDvW.PORTAL_MOUNT_EVENT), zIndexNumber);
        return function() {
            (0, $3Dz9u.default)((0, $9XDvW.PORTAL_UNMOUNT_EVENT), zIndexNumber);
        };
    }, [
        zIndexNumber
    ]);
};
var $8ccf0d178e589fcb$export$2e2bcd8739ae039 = $8ccf0d178e589fcb$var$useFirePortalEvent;

});
parcelRegister("9XDvW", function(module, exports) {
$parcel$export(module.exports, "PORTAL_MOUNT_EVENT", () => $7408467569a07882$export$ed5835cc67e87f72);
$parcel$export(module.exports, "PORTAL_UNMOUNT_EVENT", () => $7408467569a07882$export$80816bd900e5bd00);
var $7408467569a07882$export$ed5835cc67e87f72 = 'akPortalMount';
var $7408467569a07882$export$80816bd900e5bd00 = 'akPortalUnmount';

});

parcelRegister("3Dz9u", function(module, exports) {
$parcel$export(module.exports, "default", () => $2a60481a8c765186$export$2e2bcd8739ae039);
var $2a60481a8c765186$var$zIndexToName = {
    100: 'card',
    200: 'navigation',
    300: 'dialog',
    400: 'layer',
    500: 'blanket',
    510: 'modal',
    600: 'flag',
    700: 'spotlight',
    9999: 'tooltip'
};
/**
 * return layer name in Atlassian design system corresponding to given z-index
 * @param {number} zIndex - z-index value for which layer name is needed
 * @returns {LayerName | null} - The layer name for given z-index. If layer name is not found then null is returned
 */ var $2a60481a8c765186$var$getLayerName = function getLayerName(zIndex) {
    return $2a60481a8c765186$var$zIndexToName.hasOwnProperty(zIndex) ? $2a60481a8c765186$var$zIndexToName[zIndex] : null;
};
/**
 * Creates a PortalEvent object with given eventName, given zIndex and corresponding layer
 * @param {string} eventName - either of Mount or Unmount event name
 * @param {number} zIndex - z-index value which will be included in the event to be dispatched
 * @returns {PortalEvent} - The newly created PortalEvent object
 */ var $2a60481a8c765186$var$getEvent = function getEvent(eventName, zIndex) {
    var detail = {
        layer: $2a60481a8c765186$var$getLayerName(Number(zIndex)),
        zIndex: zIndex
    };
    return new CustomEvent(eventName, {
        detail: detail
    });
};
function $2a60481a8c765186$export$2e2bcd8739ae039(eventName, zIndex) {
    var event = $2a60481a8c765186$var$getEvent(eventName, zIndex);
    window.dispatchEvent(event);
}

});



parcelRegister("cVIoC", function(module, exports) {
$parcel$export(module.exports, "layers", () => $969d3f0f67bbf4a1$export$7be255094ccdc533);

var $kxpsr = parcelRequire("kxpsr");

var $Tr1sB = parcelRequire("Tr1sB");
var $969d3f0f67bbf4a1$export$44ffba16bd48dac6 = '__ATLASKIT_THEME__';
var $969d3f0f67bbf4a1$export$c93026a968943f95 = 'light';
var $969d3f0f67bbf4a1$export$6ba72c8346b4c57e = [
    'light',
    'dark'
];
var $969d3f0f67bbf4a1$export$8e24544ddba725ee = function focusRing() {
    var color = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "var(--ds-border-focused, ".concat((0, $Tr1sB.B200), ")");
    var outlineWidth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
    (0, $kxpsr.default)('@atlaskit/theme', 'focus ring mixin', 'Please use `@atlaskit/focus-ring` instead.');
    return "\n  &:focus {\n    outline: none;\n    box-shadow: 0px 0px 0px ".concat(outlineWidth, "px ").concat(color, ";\n  }\n");
};
var $969d3f0f67bbf4a1$export$c0dd343266bc3261 = function noFocusRing() {
    return "\n  box-shadow: none;\n";
};
var $969d3f0f67bbf4a1$export$7be255094ccdc533 = {
    card: function card() {
        return 100;
    },
    navigation: function navigation() {
        return 200;
    },
    dialog: function dialog() {
        return 300;
    },
    layer: function layer() {
        return 400;
    },
    blanket: function blanket() {
        return 500;
    },
    modal: function modal() {
        return 510;
    },
    flag: function flag() {
        return 600;
    },
    spotlight: function spotlight() {
        return 700;
    },
    tooltip: function tooltip() {
        return 9999;
    }
};
var $969d3f0f67bbf4a1$export$a1b3edb637fb4f35 = function visuallyHidden() {
    (0, $kxpsr.default)('@atlaskit/theme', 'visually hidden mixin', 'Please use `@atlaskit/visually-hidden` instead.');
    return {
        border: '0 !important',
        clip: 'rect(1px, 1px, 1px, 1px) !important',
        height: '1px !important',
        overflow: 'hidden !important',
        padding: '0 !important',
        position: 'absolute !important',
        width: '1px !important',
        whiteSpace: 'nowrap !important'
    };
};
var $969d3f0f67bbf4a1$export$ba1d834b86d72a09 = $969d3f0f67bbf4a1$export$a1b3edb637fb4f35;
var $969d3f0f67bbf4a1$export$e497e856b4f89fcd = function skeletonShimmer() {
    return {
        css: {
            backgroundColor: "var(--ds-skeleton, ".concat((0, $Tr1sB.N20A), ")"),
            animationDuration: '1.5s',
            animationIterationCount: 'infinite',
            animationTimingFunction: 'linear',
            animationDirection: 'alternate'
        },
        keyframes: {
            from: {
                backgroundColor: "var(--ds-skeleton, ".concat((0, $Tr1sB.N20A), ")")
            },
            to: {
                backgroundColor: "var(--ds-skeleton-subtle, ".concat((0, $Tr1sB.N30A), ")")
            }
        }
    };
};

});
parcelRegister("Tr1sB", function(module, exports) {
$parcel$export(module.exports, "B200", () => $0a6a194912e4654c$export$215b7063051591f1);
$parcel$export(module.exports, "N500", () => $0a6a194912e4654c$export$c39c0fe0f26207ae);
$parcel$export(module.exports, "N20A", () => $0a6a194912e4654c$export$8d43898f60b96a82);
$parcel$export(module.exports, "N30A", () => $0a6a194912e4654c$export$920c0d5c49070351);
// Reds
var $0a6a194912e4654c$export$4b84fd0e2c617bd = '#FFEBE6';
var $0a6a194912e4654c$export$b34b069eff244586 = '#FFBDAD';
var $0a6a194912e4654c$export$be802dd0d8b57f35 = '#FF8F73';
var $0a6a194912e4654c$export$60847d42f9da92a6 = '#FF7452';
var $0a6a194912e4654c$export$4a7404f376229999 = '#FF5630';
var $0a6a194912e4654c$export$2010d0fb4295b346 = '#DE350B';
var $0a6a194912e4654c$export$2837b5a1a71d5c02 = '#BF2600';
var $0a6a194912e4654c$export$8d9596b529bbb9cf = '#FFFAE6';
var $0a6a194912e4654c$export$41060a744ab0b7ae = '#FFF0B3';
var $0a6a194912e4654c$export$1cc05bbbf340e559 = '#FFE380';
var $0a6a194912e4654c$export$5aae31392d72caaa = '#FFC400';
var $0a6a194912e4654c$export$c6930421db9fa514 = '#FFAB00';
var $0a6a194912e4654c$export$59619663aa6500fb = '#FF991F';
var $0a6a194912e4654c$export$874739ea9e379ab6 = '#FF8B00';
var $0a6a194912e4654c$export$8a6341c32b6a3ee6 = '#E3FCEF';
var $0a6a194912e4654c$export$69a3bf21b9686c2b = '#ABF5D1';
var $0a6a194912e4654c$export$afbce1382ec95f73 = '#79F2C0';
var $0a6a194912e4654c$export$747d86715d4175de = '#57D9A3';
var $0a6a194912e4654c$export$940e1f69e873f202 = '#36B37E';
var $0a6a194912e4654c$export$a49394138f7b8e85 = '#00875A';
var $0a6a194912e4654c$export$6fa04827ac68a4fb = '#006644';
var $0a6a194912e4654c$export$226de0355ed012f8 = '#DEEBFF';
var $0a6a194912e4654c$export$8c13c2ee36917869 = '#B3D4FF';
var $0a6a194912e4654c$export$ecfc1dff386a3e7a = '#4C9AFF';
var $0a6a194912e4654c$export$215b7063051591f1 = '#2684FF';
var $0a6a194912e4654c$export$e62e8919cca44969 = '#0065FF';
var $0a6a194912e4654c$export$b3de0ae08da2ce64 = '#0052CC';
var $0a6a194912e4654c$export$a6ee3d71bc067634 = '#0747A6';
var $0a6a194912e4654c$export$67f15409e87642a1 = '#669DF1';
var $0a6a194912e4654c$export$f0539dbc42dbb067 = '#8FB8F6';
var $0a6a194912e4654c$export$363e4475840015bb = '#EAE6FF';
var $0a6a194912e4654c$export$4b0a4417ed59760f = '#C0B6F2';
var $0a6a194912e4654c$export$6011520a64d9a187 = '#998DD9';
var $0a6a194912e4654c$export$a7175d4e9206bc80 = '#8777D9';
var $0a6a194912e4654c$export$b48405b95304b5a1 = '#6554C0';
var $0a6a194912e4654c$export$c71e4279dd54a18d = '#5243AA';
var $0a6a194912e4654c$export$147899de772240ec = '#403294';
var $0a6a194912e4654c$export$2cf711fe14c66f06 = '#E6FCFF';
var $0a6a194912e4654c$export$7a8f4d33f6f9772c = '#B3F5FF';
var $0a6a194912e4654c$export$776c9c497ef08533 = '#79E2F2';
var $0a6a194912e4654c$export$69cb3ca10c1e330e = '#00C7E6';
var $0a6a194912e4654c$export$9dc1ef0f3f48059b = '#00B8D9';
var $0a6a194912e4654c$export$7c835c78b6fcdef8 = '#00A3BF';
var $0a6a194912e4654c$export$6036577f95c3877e = '#008DA6';
var $0a6a194912e4654c$export$29a4f05edc054374 = '#FFFFFF';
var $0a6a194912e4654c$export$e655ef011c4aa1a2 = '#FAFBFC';
var $0a6a194912e4654c$export$9fdfb749e33cdf97 = '#F4F5F7';
var $0a6a194912e4654c$export$3e51e8f1440314ba = '#EBECF0';
var $0a6a194912e4654c$export$1ce2d1575d444ceb = '#DFE1E6';
var $0a6a194912e4654c$export$8754fc7e6d8b3000 = '#C1C7D0';
var $0a6a194912e4654c$export$c2e91cbeada39b8b = '#B3BAC5';
var $0a6a194912e4654c$export$5f71e19f3a7ad9de = '#A5ADBA';
var $0a6a194912e4654c$export$eaa8c8a70ac22806 = '#97A0AF';
var $0a6a194912e4654c$export$7c87d337fb91a97d = '#8993A4';
var $0a6a194912e4654c$export$d6447c357493214f = '#7A869A';
var $0a6a194912e4654c$export$f563ee71e9ee74cd = '#6B778C';
var $0a6a194912e4654c$export$e2ef2124cf4024b1 = '#5E6C84';
var $0a6a194912e4654c$export$eece5f492e429f08 = '#505F79';
var $0a6a194912e4654c$export$c39c0fe0f26207ae = '#42526E';
var $0a6a194912e4654c$export$7090862dc3038a9f = '#344563';
var $0a6a194912e4654c$export$ad0bacf983b7ddaa = '#253858';
var $0a6a194912e4654c$export$7d61b15e0da132af = '#172B4D';
var $0a6a194912e4654c$export$fbda843f0a27fe96 = '#091E42';
var $0a6a194912e4654c$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
var $0a6a194912e4654c$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
var $0a6a194912e4654c$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
var $0a6a194912e4654c$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
var $0a6a194912e4654c$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
var $0a6a194912e4654c$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
var $0a6a194912e4654c$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
var $0a6a194912e4654c$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
var $0a6a194912e4654c$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
var $0a6a194912e4654c$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
var $0a6a194912e4654c$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
var $0a6a194912e4654c$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
var $0a6a194912e4654c$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
var $0a6a194912e4654c$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
var $0a6a194912e4654c$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
var $0a6a194912e4654c$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
var $0a6a194912e4654c$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
var $0a6a194912e4654c$export$2f6319cf7d736c2a = '#E6EDFA';
var $0a6a194912e4654c$export$95126bc8884d6634 = '#DCE5F5';
var $0a6a194912e4654c$export$8338d8c35d44ff1 = '#CED9EB';
var $0a6a194912e4654c$export$5368d76ae4fbbda7 = '#B8C7E0';
var $0a6a194912e4654c$export$9f0a771d16ec8d36 = '#ABBBD6';
var $0a6a194912e4654c$export$abcf8c38338b4aa5 = '#9FB0CC';
var $0a6a194912e4654c$export$97e81faa16a182c7 = '#8C9CB8';
var $0a6a194912e4654c$export$bfe21c59123ecf33 = '#7988A3';
var $0a6a194912e4654c$export$ee82aa2ea6a1558 = '#67758F';
var $0a6a194912e4654c$export$682927c6ed76be02 = '#56637A';
var $0a6a194912e4654c$export$91fd9994c5be9757 = '#455166';
var $0a6a194912e4654c$export$d281fbfe3cff2df6 = '#3B475C';
var $0a6a194912e4654c$export$3902c91d8b98a753 = '#313D52';
var $0a6a194912e4654c$export$8e8133c1ba5845b5 = '#283447';
var $0a6a194912e4654c$export$33ff357f6620b39 = '#202B3D';
var $0a6a194912e4654c$export$633847cf062b69e0 = '#1B2638';
var $0a6a194912e4654c$export$9776a6e503bdbf76 = '#121A29';
var $0a6a194912e4654c$export$6c813d5160dff5db = '#0E1624';
var $0a6a194912e4654c$export$3d4f271a500072a = '#0D1424';
var $0a6a194912e4654c$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
var $0a6a194912e4654c$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
var $0a6a194912e4654c$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
var $0a6a194912e4654c$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
var $0a6a194912e4654c$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
var $0a6a194912e4654c$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
var $0a6a194912e4654c$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
var $0a6a194912e4654c$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
var $0a6a194912e4654c$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
var $0a6a194912e4654c$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
var $0a6a194912e4654c$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
var $0a6a194912e4654c$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
var $0a6a194912e4654c$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
var $0a6a194912e4654c$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
var $0a6a194912e4654c$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
var $0a6a194912e4654c$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
var $0a6a194912e4654c$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';
var $0a6a194912e4654c$export$d2adc5dedf09fced = '#292A2E';
var $0a6a194912e4654c$export$f51762073d2bb381 = '#94C748';
var $0a6a194912e4654c$export$95e26d54def96891 = '#B3DF72';

});


parcelRegister("bJM2o", function(module, exports) {
$parcel$export(module.exports, "register", () => $88b928f695379dbd$export$6503ec6e8aabbaf);
/* eslint-disable @atlaskit/design-system/no-direct-use-of-web-platform-drag-and-drop */ /**
 * We are listening directly to drag events instead of using a monitor from
 * `@atlaskit/pragmatic-drag-and-drop` to avoid the bundle size cost, as it
 * would affect almost every view in every app.
 *
 * We can reconsider this choice in the future.
 */ 
var $7QpUe = parcelRequire("7QpUe");
var $88b928f695379dbd$var$registrations = new Set();
var $88b928f695379dbd$var$cleanupEndEventListeners = null;
function $88b928f695379dbd$var$onDragStart() {
    if ($88b928f695379dbd$var$cleanupEndEventListeners) // If the cleanup function exists then we've already run this
    return;
    $88b928f695379dbd$var$cleanupEndEventListeners = (0, $7QpUe.bindAll)(window, [
        {
            type: 'dragend',
            listener: $88b928f695379dbd$var$onDragEnd
        },
        {
            type: 'pointerdown',
            listener: $88b928f695379dbd$var$onDragEnd
        },
        {
            type: 'pointermove',
            listener: function() {
                var callCount = 0;
                return function listener() {
                    // Using 20 as it is far bigger than the most observed (3)
                    if (callCount < 20) {
                        callCount++;
                        return;
                    }
                    $88b928f695379dbd$var$onDragEnd();
                };
            }()
        }
    ]);
    var clone = Array.from($88b928f695379dbd$var$registrations);
    clone.forEach(function(subscriber) {
        subscriber.onDragStart();
    });
}
function $88b928f695379dbd$var$onDragEnd() {
    var _cleanupEndEventListe;
    (_cleanupEndEventListe = $88b928f695379dbd$var$cleanupEndEventListeners) === null || _cleanupEndEventListe === void 0 || _cleanupEndEventListe();
    $88b928f695379dbd$var$cleanupEndEventListeners = null;
    var clone = Array.from($88b928f695379dbd$var$registrations);
    clone.forEach(function(subscriber) {
        subscriber.onDragEnd();
    });
}
function $88b928f695379dbd$var$bindStartEvents() {
    return (0, $7QpUe.bindAll)(window, [
        {
            type: 'dragstart',
            listener: $88b928f695379dbd$var$onDragStart
        },
        {
            type: 'dragenter',
            listener: $88b928f695379dbd$var$onDragStart
        }
    ]);
}
var $88b928f695379dbd$var$cleanupStartEventListeners = null;
function $88b928f695379dbd$export$6503ec6e8aabbaf(registration) {
    // if first registration, bind event listeners
    if (!$88b928f695379dbd$var$cleanupStartEventListeners) // note: currently never unbinding these event listeners
    $88b928f695379dbd$var$cleanupStartEventListeners = $88b928f695379dbd$var$bindStartEvents();
    $88b928f695379dbd$var$registrations.add(registration);
    /**
   * The reasoning for this behavior is so that if a tooltip mounts during
   * a drag it can still be suppressed.
   *
   * We use a separate callback instead of onDragStart to avoid infinite loops.
   */ registration.onRegister({
        isDragging: $88b928f695379dbd$var$cleanupEndEventListeners !== null
    });
    return function unregister() {
        $88b928f695379dbd$var$registrations.delete(registration);
        if ($88b928f695379dbd$var$registrations.size === 0) {
            var _cleanupStartEventLis;
            (_cleanupStartEventLis = $88b928f695379dbd$var$cleanupStartEventListeners) === null || _cleanupStartEventLis === void 0 || _cleanupStartEventLis();
            $88b928f695379dbd$var$cleanupStartEventListeners = null;
        }
    };
}

});

parcelRegister("hRDE5", function(module, exports) {
$parcel$export(module.exports, "show", () => $d01623b356a550b3$export$57bf213be019eeb0);

var $etOD9 = parcelRequire("etOD9");
// This file is a singleton for managing tooltips
var $d01623b356a550b3$var$active = null;
function $d01623b356a550b3$export$57bf213be019eeb0(entry) {
    var phase = 'waiting-to-show';
    function isActive() {
        return Boolean($d01623b356a550b3$var$active && $d01623b356a550b3$var$active.entry === entry);
    }
    function cleanup() {
        if (isActive()) {
            (0, $etOD9.clearScheduled)();
            $d01623b356a550b3$var$active = null;
        }
    }
    function done() {
        if (isActive()) entry.done();
        phase = 'done';
        cleanup();
    }
    function immediatelyHideAndDone() {
        if (isActive()) entry.hide({
            isImmediate: true
        });
        done();
    }
    function keep() {
        if (!isActive()) return;
        // aborting a wait to hide
        if (phase === 'waiting-to-hide') {
            phase = 'shown';
            (0, $etOD9.clearScheduled)();
            return;
        }
        // aborting hide animation
        if (phase === 'hide-animating') {
            phase = 'shown';
            (0, $etOD9.clearScheduled)();
            entry.show({
                isImmediate: false
            });
            return;
        }
    }
    function requestHide(_ref) {
        var isImmediate = _ref.isImmediate;
        if (!isActive()) return;
        // If we were not showing yet anyway; finish straight away
        if (phase === 'waiting-to-show') {
            immediatelyHideAndDone();
            return;
        }
        // already waiting to hide
        if (phase === 'waiting-to-hide') return;
        if (isImmediate) {
            immediatelyHideAndDone();
            return;
        }
        phase = 'waiting-to-hide';
        (0, $etOD9.scheduleTimeout)(function() {
            phase = 'hide-animating';
            entry.hide({
                isImmediate: false
            });
        }, entry.delay);
    }
    function finishHideAnimation() {
        if (isActive() && phase === 'hide-animating') done();
    }
    function isVisible() {
        return phase === 'shown' || phase === 'waiting-to-hide' || phase === 'hide-animating';
    }
    function getInitialMouse() {
        if (entry.source.type === 'mouse') return entry.source.mouse;
        return null;
    }
    function start() {
        var showImmediately = Boolean($d01623b356a550b3$var$active && $d01623b356a550b3$var$active.isVisible());
        // If there was an active tooltip; we tell it to remove itself at once!
        if ($d01623b356a550b3$var$active) {
            (0, $etOD9.clearScheduled)();
            $d01623b356a550b3$var$active.entry.hide({
                isImmediate: true
            });
            $d01623b356a550b3$var$active.entry.done();
            $d01623b356a550b3$var$active = null;
        }
        // this tooltip is now the active tooltip
        $d01623b356a550b3$var$active = {
            entry: entry,
            isVisible: isVisible
        };
        function show() {
            phase = 'shown';
            entry.show({
                isImmediate: showImmediately
            });
        }
        if (showImmediately) {
            show();
            return;
        }
        phase = 'waiting-to-show';
        (0, $etOD9.scheduleTimeout)(show, entry.delay);
    }
    // let's get started!
    start();
    var result = {
        keep: keep,
        abort: cleanup,
        isActive: isActive,
        requestHide: requestHide,
        finishHideAnimation: finishHideAnimation,
        mousePosition: getInitialMouse()
    };
    return result;
}

});
parcelRegister("etOD9", function(module, exports) {
$parcel$export(module.exports, "clearScheduled", () => $a8ab0c492b031c5a$export$eaf678f6f93f5250);
$parcel$export(module.exports, "scheduleTimeout", () => $a8ab0c492b031c5a$export$5f4d6617421d489b);
var $a8ab0c492b031c5a$var$delayId = null;
function $a8ab0c492b031c5a$export$eaf678f6f93f5250() {
    if ($a8ab0c492b031c5a$var$delayId != null) {
        window.clearTimeout($a8ab0c492b031c5a$var$delayId);
        $a8ab0c492b031c5a$var$delayId = null;
    }
}
function $a8ab0c492b031c5a$export$5f4d6617421d489b(fn, delay) {
    $a8ab0c492b031c5a$export$eaf678f6f93f5250();
    $a8ab0c492b031c5a$var$delayId = window.setTimeout(function() {
        $a8ab0c492b031c5a$var$delayId = null;
        fn();
    }, delay);
}

});


parcelRegister("9YYdW", function(module, exports) {
$parcel$export(module.exports, "default", () => $74486ee000787ada$export$2e2bcd8739ae039);

var $h8qvJ = parcelRequire("h8qvJ");
function $74486ee000787ada$export$2e2bcd8739ae039(prefix, shouldRenderId) {
    var seed = (0, $h8qvJ.useIdSeed)();
    return shouldRenderId ? "".concat(seed(prefix)) : undefined;
}

});

parcelRegister("5vdru", function(module, exports) {
$parcel$export(module.exports, "default", () => $401a465ab09cbbf1$export$2e2bcd8739ae039);
/* tooltip-container.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");

var $1LSlO = parcelRequire("1LSlO");
var $401a465ab09cbbf1$var$styles = {
    base: "_2rkofajl _11c8dcr7 _vchhusvi _p12fp3fh _bfhkgkf6 _syaz15cr _152tze3t _1e02ze3t _1i4q1hna _1q511b66 _85i51b66 _y4ti12x7 _bozg12x7 _slp31hna",
    truncate: "_1reo15vq _18m915vq _p12f1pna _1bto1l2s _o5721q9c"
};
/**
 * Used as the default tooltip container component for the exported `Tooltip` component.
 * Adds some styles to the tooltip primitive.
 */ var $401a465ab09cbbf1$var$TooltipContainer = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function TooltipContainer(_ref, ref) {
    var style = _ref.style, className = _ref.className, children = _ref.children, truncate = _ref.truncate, placement = _ref.placement, testId = _ref.testId, onMouseOut = _ref.onMouseOut, onMouseOver = _ref.onMouseOver, id = _ref.id, shortcut = _ref.shortcut;
    return /*#__PURE__*/ $5FkrB.createElement((0, $1LSlO.default), {
        ref: ref,
        style: style,
        className: (0, $970q7.default)([
            $401a465ab09cbbf1$var$styles.base,
            truncate && $401a465ab09cbbf1$var$styles.truncate,
            className
        ]),
        placement: placement,
        testId: testId,
        id: id,
        onMouseOut: onMouseOut,
        onMouseOver: onMouseOver,
        shortcut: shortcut
    }, children);
});
$401a465ab09cbbf1$var$TooltipContainer.displayName = 'TooltipContainer';
var $401a465ab09cbbf1$export$2e2bcd8739ae039 = $401a465ab09cbbf1$var$TooltipContainer;

});
parcelRegister("1LSlO", function(module, exports) {
$parcel$export(module.exports, "default", () => $14a4572a1ada16fb$export$2e2bcd8739ae039);
/* tooltip-primitive.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");

var $eKLdC = parcelRequire("eKLdC");
var $14a4572a1ada16fb$var$primitiveStyles = null;
/**
 * The lower level component for rendering a tooltip.
 */ var $14a4572a1ada16fb$var$TooltipPrimitive = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function TooltipPrimitive(_ref, ref) {
    var style = _ref.style, className = _ref.className, children = _ref.children, placement = _ref.placement, testId = _ref.testId, onMouseOut = _ref.onMouseOut, onMouseOver = _ref.onMouseOver, id = _ref.id, shortcut = _ref.shortcut;
    return /*#__PURE__*/ $5FkrB.createElement("div", {
        ref: ref,
        style: style,
        "data-testid": testId ? "".concat(testId, "--wrapper") : undefined
    }, /*#__PURE__*/ $5FkrB.createElement("div", {
        role: "tooltip",
        className: (0, $970q7.default)([
            "_80om73ad",
            className
        ]),
        onMouseOut: onMouseOut,
        onMouseOver: onMouseOver,
        "data-placement": placement,
        "data-testid": testId,
        id: id
    }, children, shortcut && /*#__PURE__*/ $5FkrB.createElement((0, $eKLdC.TooltipShortcut), {
        shortcut: shortcut
    })));
});
$14a4572a1ada16fb$var$TooltipPrimitive.displayName = 'TooltipPrimitive';
var $14a4572a1ada16fb$export$2e2bcd8739ae039 = $14a4572a1ada16fb$var$TooltipPrimitive;

});
parcelRegister("eKLdC", function(module, exports) {
$parcel$export(module.exports, "TooltipShortcut", () => $abd9fd2ee0b2ad59$export$5bcbc43c84236222);
/* tooltip-shortcut.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");

var $9Zzpd = parcelRequire("9Zzpd");
var $abd9fd2ee0b2ad59$var$styles = {
    shortcutSegmentsContainer: "_zulpv77o _1e0c1txw _1q511b66 _85i5v77o",
    shortcutSegment: "_11c81u0j _2rkolb4i _1dqonqa1 _189ee4h9 _1h6d1ihb _1e0c1txw _4cvr1h6o _4t3i1k92 _vchhusvi _1q51v77o _85i5v77o _bozg12x7 _y4ti12x7 _16qsn7od _1254n7od _cgnln7od _syazn7od _ahbqn7od _12l2n7od _1pfhn7od _6rthn7od _1ul9n7od _w19jn7od _bfhk261p",
    regularFont: "_11c81o8v"
};
var $abd9fd2ee0b2ad59$export$5bcbc43c84236222 = function TooltipShortcut(_ref) {
    var shortcut = _ref.shortcut;
    return /*#__PURE__*/ $5FkrB.createElement("div", {
        className: (0, $970q7.default)([
            $abd9fd2ee0b2ad59$var$styles.shortcutSegmentsContainer
        ])
    }, shortcut.map(function(segment, index) {
        return /*#__PURE__*/ $5FkrB.createElement("kbd", {
            key: "".concat(segment, "-").concat(index),
            className: (0, $970q7.default)([
                $abd9fd2ee0b2ad59$var$styles.shortcutSegment,
                (0, $9Zzpd.fg)('platform-tooltip-shortcuts-regular-font') && $abd9fd2ee0b2ad59$var$styles.regularFont
            ])
        }, segment);
    }));
};

});



parcelRegister("bDd2o", function(module, exports) {
$parcel$export(module.exports, "getMousePosition", () => $877d7339d8a01262$export$642213d516a9b928);
function $877d7339d8a01262$export$642213d516a9b928(mouseCoordinates) {
    var safeMouse = mouseCoordinates || {
        top: 0,
        left: 0
    };
    var getBoundingClientRect = function getBoundingClientRect() {
        return {
            top: safeMouse.top,
            left: safeMouse.left,
            bottom: safeMouse.top,
            right: safeMouse.left,
            width: 0,
            height: 0
        };
    };
    return {
        getBoundingClientRect: getBoundingClientRect,
        clientWidth: 0,
        clientHeight: 0
    };
}

});


parcelRegister("abSTK", function(module, exports) {
$parcel$export(module.exports, "default", () => $76b58416a5044cb0$export$2e2bcd8739ae039);
/* button-base.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $kqp0i = parcelRequire("kqp0i");

var $1Vcia = parcelRequire("1Vcia");

var $970q7 = parcelRequire("970q7");

var $5FkrB = parcelRequire("5FkrB");

var $gVtSA = parcelRequire("gVtSA");

var $iO8GM = parcelRequire("iO8GM");

var $gpUQB = parcelRequire("gpUQB");

var $h8qvJ = parcelRequire("h8qvJ");

var $ivut0 = parcelRequire("ivut0");

var $e8kqY = parcelRequire("e8kqY");

var $9lDWQ = parcelRequire("9lDWQ");

var $iZn4f = parcelRequire("iZn4f");

var $cgjHo = parcelRequire("cgjHo");
var $76b58416a5044cb0$var$_excluded = [
    "appearance",
    "autoFocus",
    "isDisabled",
    "isLoading",
    "isSelected",
    "isIconButton",
    "isCircle",
    "hasIconBefore",
    "hasIconAfter",
    "shouldFitContainer",
    "spacing",
    "ariaLabel",
    "ariaLabelledBy",
    "children",
    "interactionName",
    "onClick",
    "onMouseDown",
    "onMouseDownCapture",
    "onMouseUp",
    "onMouseUpCapture",
    "onKeyDown",
    "onKeyDownCapture",
    "onKeyUp",
    "onKeyUpCapture",
    "onTouchStart",
    "onTouchStartCapture",
    "onTouchEnd",
    "onTouchEndCapture",
    "onPointerDown",
    "onPointerDownCapture",
    "onPointerUp",
    "onPointerUpCapture",
    "onClickCapture",
    "testId",
    "analyticsContext",
    "componentName",
    "role",
    "onMouseOver",
    "onMouseOut",
    "onFocus",
    "onBlur",
    "onMouseMove",
    "type"
], $76b58416a5044cb0$var$_excluded2 = [
    "className",
    "css",
    "as",
    "style"
];
var $76b58416a5044cb0$var$LOADING_LABEL = ', Loading';
var $76b58416a5044cb0$var$styles = {
    base: "_2rkofajl _11c82smr _v5649dqc _189eidpf _1rjc12x7 _1e0c116y _vchhusvi _1bsb1wug _p12f1osq _kqswh2mm _4cvr1q9y _1bah1h6o _gy1p1b66 _1o9zidpf _4t3iviql _k48p1wq8 _y4tiutpp _bozgutpp _y3gn1h6o _s7n4nkob _14mj1kw7 _9v7aze3t _1tv3nqa1 _39yqe4h9 _11fnglyw _18postnw",
    linkDecorationUnset: "_4bfu1r31 _1hmsglyw _ajmmnqa1 _1a3b1r31 _4fprglyw _5goinqa1 _9oik1r31 _1bnxglyw _jf4cnqa1 _1nrm1r31 _c2waglyw _1iohnqa1",
    disabled: "_80om13gf _syaz1gmx _30l31gmx _9h8h1gmx",
    sharedDisabled: "_bfhk1fvb _irr31fvb _1di61fvb",
    spacingCompact: "_1rjcv77o _gy1p1b66 _4t3i1k8s _y4tiutpp _bozgutpp _s7n4nkob",
    circle: "_2rko1rr0",
    fullWidth: "_1bsb1osq",
    loading: "_80om15jw",
    iconButton: "_4t3iviql _1bsbviql _y4tize3t _bozgze3t",
    iconButtonCompact: "_4t3i1k8s _1bsb1k8s",
    buttonIconBefore: "_bozgu2gc",
    buttonIconAfter: "_y4tiu2gc",
    splitButton: "_g0pbb4wl",
    loadingOverlay: "_1reo15vq _18m915vq _1e0c1txw _kqswstnw _4cvr1h6o _1bah1h6o _u7coze3t _152tze3t _rjxpze3t _1e02ze3t",
    navigationSplitButton: "_1bsb1tcg _bfhksm61 _y4ti12x7 _bozg12x7"
};
var $76b58416a5044cb0$var$defaultStyles = {
    root: "_bfhksm61 _syazazsu _8l3m1l7x _aetrb3bt _1053azsu _f8pjazsu _30l3azsu _9h8hazsu",
    interactive: "_irr31dpa _30l3azsu _1di6fcek _9h8hazsu",
    disabled: "_bfhk1j28 _8l3mbk0g _irr31j28 _1di61j28"
};
var $76b58416a5044cb0$var$primaryStyles = {
    root: "_bfhkomb0 _syaz15cr _105315cr _f8pj15cr _30l315cr _9h8h15cr",
    interactive: "_30l315cr _irr31wqm _9h8h15cr _1di617hq"
};
var $76b58416a5044cb0$var$warningStyles = {
    root: "_bfhk1ikc _syazal3n _1053al3n _f8pjal3n _30l3al3n _9h8hal3n",
    interactive: "_30l3al3n _irr31j43 _9h8hal3n _1di6h4op"
};
var $76b58416a5044cb0$var$dangerStyles = {
    root: "_bfhk1v7l _syaz15cr _105315cr _f8pj15cr _30l315cr _9h8h15cr",
    interactive: "_30l315cr _irr31rwk _9h8h15cr _1di6yycf"
};
var $76b58416a5044cb0$var$discoveryStyles = {
    root: "_bfhk1vbi _syaz15cr _105315cr _f8pj15cr _30l315cr _9h8h15cr",
    interactive: "_30l315cr _irr37gr8 _9h8h15cr _1di61wu2"
};
var $76b58416a5044cb0$var$subtleStyles = {
    root: "_bfhkqtfy _syazazsu _1053azsu _f8pjazsu _30l3azsu _9h8hazsu",
    interactive: "_irr34mfv _30l3azsu _1di619qy _9h8hazsu",
    disabled: "_bfhk1j28 _8l3mbk0g _irr31j28 _1di61j28"
};
var $76b58416a5044cb0$var$selectedStyles = {
    root: "_bfhk15s3 _syaz1ldt _8l3mcoux _aetrb3bt _10531ldt _f8pj1ldt _30l31ldt _9h8h1ldt",
    insideSplitButton: "_1pbycs5v",
    interactive: "_irr3t71w _30l31pke _1di6yssv _9h8h1pke",
    warning: "_bfhkvdtc _syaz16q2 _30l31pke _irr3vdtc _9h8h1pke _1di6vdtc",
    danger: "_bfhkbeib _syaz1pke _30l31pke _irr3beib _9h8h1pke _1di6beib",
    discovery: "_bfhk1g49 _syaz1pke _30l31pke _irr31g49 _9h8h1pke _1di61g49"
};
/**
 * __button base__
 *
 * - Implements auto focus when enabled.
 * - Appends the `onClick` event with UFO analytics tracking.
 *
 * @private
 */ var $76b58416a5044cb0$var$ButtonBase = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).forwardRef(// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore: to unblock React 18.2.0 -> 18.3.1 version bump in Jira
function(_ref, ref) {
    var propAppearance = _ref.appearance, _ref$autoFocus = _ref.autoFocus, autoFocus = _ref$autoFocus === void 0 ? false : _ref$autoFocus, _ref$isDisabled = _ref.isDisabled, propIsDisabled = _ref$isDisabled === void 0 ? false : _ref$isDisabled, _ref$isLoading = _ref.isLoading, isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading, _ref$isSelected = _ref.isSelected, propIsSelected = _ref$isSelected === void 0 ? false : _ref$isSelected, _ref$isIconButton = _ref.isIconButton, isIconButton = _ref$isIconButton === void 0 ? false : _ref$isIconButton, _ref$isCircle = _ref.isCircle, isCircle = _ref$isCircle === void 0 ? false : _ref$isCircle, _ref$hasIconBefore = _ref.hasIconBefore, hasIconBefore = _ref$hasIconBefore === void 0 ? false : _ref$hasIconBefore, _ref$hasIconAfter = _ref.hasIconAfter, hasIconAfter = _ref$hasIconAfter === void 0 ? false : _ref$hasIconAfter, _ref$shouldFitContain = _ref.shouldFitContainer, shouldFitContainer = _ref$shouldFitContain === void 0 ? false : _ref$shouldFitContain, _ref$spacing = _ref.spacing, propSpacing = _ref$spacing === void 0 ? 'default' : _ref$spacing, ariaLabel = _ref.ariaLabel, ariaLabelledBy = _ref.ariaLabelledBy, children = _ref.children, interactionName = _ref.interactionName, onClick = _ref.onClick, onMouseDown = _ref.onMouseDown, onMouseDownCapture = _ref.onMouseDownCapture, onMouseUp = _ref.onMouseUp, onMouseUpCapture = _ref.onMouseUpCapture, onKeyDown = _ref.onKeyDown, onKeyDownCapture = _ref.onKeyDownCapture, onKeyUp = _ref.onKeyUp, onKeyUpCapture = _ref.onKeyUpCapture, onTouchStart = _ref.onTouchStart, onTouchStartCapture = _ref.onTouchStartCapture, onTouchEnd = _ref.onTouchEnd, onTouchEndCapture = _ref.onTouchEndCapture, onPointerDown = _ref.onPointerDown, onPointerDownCapture = _ref.onPointerDownCapture, onPointerUp = _ref.onPointerUp, onPointerUpCapture = _ref.onPointerUpCapture, onClickCapture = _ref.onClickCapture, testId = _ref.testId, analyticsContext = _ref.analyticsContext, componentName = _ref.componentName, role = _ref.role, onMouseOver = _ref.onMouseOver, onMouseOut = _ref.onMouseOut, onFocus = _ref.onFocus, onBlur = _ref.onBlur, onMouseMove = _ref.onMouseMove, type = _ref.type, unsafeRest = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $76b58416a5044cb0$var$_excluded);
    var localRef = (0, $5FkrB.useRef)(null);
    var splitButtonContext = (0, $9lDWQ.useSplitButtonContext)();
    var loadingLabelId = (0, $h8qvJ.useId)();
    var isSplitButton = Boolean(splitButtonContext);
    var isNavigationSplitButton = (splitButtonContext === null || splitButtonContext === void 0 ? void 0 : splitButtonContext.isNavigationSplitButton) || false;
    var isDefaultAppearanceSplitButton = (splitButtonContext === null || splitButtonContext === void 0 ? void 0 : splitButtonContext.appearance) === 'default';
    var appearance = isDefaultAppearanceSplitButton ? 'subtle' : propAppearance || (splitButtonContext === null || splitButtonContext === void 0 ? void 0 : splitButtonContext.appearance) || 'default';
    var spacing = (splitButtonContext === null || splitButtonContext === void 0 ? void 0 : splitButtonContext.spacing) || propSpacing;
    var isDisabled = (splitButtonContext === null || splitButtonContext === void 0 ? void 0 : splitButtonContext.isDisabled) || propIsDisabled;
    var isInteractive = !isDisabled && !isLoading;
    // Also treat loading buttons as disabled
    var isEffectivelyDisabled = isDisabled || isLoading;
    var isSelected = propIsSelected && !isDisabled;
    (0, $gpUQB.default)(localRef, autoFocus);
    // @ts-expect-error
    var _className = unsafeRest.className, _css = unsafeRest.css, _as = unsafeRest.as, _style = unsafeRest.style, saferRest = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(unsafeRest, $76b58416a5044cb0$var$_excluded2);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $ivut0.default), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, saferRest, {
        componentName: componentName || 'button',
        analyticsContext: analyticsContext,
        role: role,
        ref: (0, $iO8GM.default)([
            localRef,
            ref
        ]),
        xcss: (0, $gVtSA.cx)($76b58416a5044cb0$var$styles.base, appearance === 'default' && $76b58416a5044cb0$var$defaultStyles.root, appearance === 'default' && isInteractive && $76b58416a5044cb0$var$defaultStyles.interactive, appearance === 'primary' && $76b58416a5044cb0$var$primaryStyles.root, appearance === 'primary' && isInteractive && $76b58416a5044cb0$var$primaryStyles.interactive, appearance === 'warning' && $76b58416a5044cb0$var$warningStyles.root, appearance === 'warning' && isInteractive && $76b58416a5044cb0$var$warningStyles.interactive, appearance === 'danger' && $76b58416a5044cb0$var$dangerStyles.root, appearance === 'danger' && isInteractive && $76b58416a5044cb0$var$dangerStyles.interactive, appearance === 'discovery' && $76b58416a5044cb0$var$discoveryStyles.root, appearance === 'discovery' && isInteractive && $76b58416a5044cb0$var$discoveryStyles.interactive, appearance === 'subtle' && $76b58416a5044cb0$var$subtleStyles.root, appearance === 'subtle' && isInteractive && $76b58416a5044cb0$var$subtleStyles.interactive, $76b58416a5044cb0$var$styles.linkDecorationUnset, isSelected && $76b58416a5044cb0$var$selectedStyles.root, isSelected && isSplitButton && $76b58416a5044cb0$var$selectedStyles.insideSplitButton, isSelected && isInteractive && $76b58416a5044cb0$var$selectedStyles.interactive, // TODO: remove me once we kill color fallbacks
        isSelected && appearance === 'danger' && $76b58416a5044cb0$var$selectedStyles.danger, // TODO: remove me once we kill color fallbacks
        isSelected && appearance === 'warning' && $76b58416a5044cb0$var$selectedStyles.warning, // TODO: remove me once we kill color fallbacks
        isSelected && appearance === 'discovery' && $76b58416a5044cb0$var$selectedStyles.discovery, isDisabled && $76b58416a5044cb0$var$styles.disabled, isDisabled && appearance !== 'default' && appearance !== 'subtle' && $76b58416a5044cb0$var$styles.sharedDisabled, isDisabled && appearance === 'default' && $76b58416a5044cb0$var$defaultStyles.disabled, isCircle && !isSplitButton && $76b58416a5044cb0$var$styles.circle, spacing === 'compact' && $76b58416a5044cb0$var$styles.spacingCompact, hasIconBefore && $76b58416a5044cb0$var$styles.buttonIconBefore, shouldFitContainer && $76b58416a5044cb0$var$styles.fullWidth, hasIconAfter && $76b58416a5044cb0$var$styles.buttonIconAfter, isIconButton && $76b58416a5044cb0$var$styles.iconButton, isIconButton && spacing === 'compact' && $76b58416a5044cb0$var$styles.iconButtonCompact, isLoading && $76b58416a5044cb0$var$styles.loading, isSplitButton && $76b58416a5044cb0$var$styles.splitButton, isNavigationSplitButton && $76b58416a5044cb0$var$styles.navigationSplitButton),
        isDisabled: isEffectivelyDisabled,
        "aria-label": isLoading && ariaLabel && !ariaLabelledBy ? "".concat(ariaLabel, " ").concat($76b58416a5044cb0$var$LOADING_LABEL) : ariaLabel,
        "aria-labelledby": isLoading && ariaLabelledBy ? "".concat(ariaLabelledBy, " ").concat(loadingLabelId) : ariaLabelledBy,
        onClick: onClick
    }, (0, $iZn4f.default)(isEffectivelyDisabled, {
        onMouseDownCapture: onMouseDownCapture,
        onMouseUpCapture: onMouseUpCapture,
        onKeyDownCapture: onKeyDownCapture,
        onKeyUpCapture: onKeyUpCapture,
        onTouchStartCapture: onTouchStartCapture,
        onTouchEndCapture: onTouchEndCapture,
        onPointerDownCapture: onPointerDownCapture,
        onPointerUpCapture: onPointerUpCapture,
        onClickCapture: onClickCapture
    }), {
        testId: testId,
        onMouseOver: onMouseOver,
        onFocus: onFocus,
        onMouseMove: onMouseMove,
        onBlur: onBlur,
        type: type,
        interactionName: interactionName,
        onMouseDown: onMouseDown,
        onMouseUp: onMouseUp,
        onKeyDown: onKeyDown,
        onMouseOut: onMouseOut,
        onKeyUp: onKeyUp,
        onTouchStart: onTouchStart,
        onTouchEnd: onTouchEnd,
        onPointerDown: onPointerDown,
        onPointerUp: onPointerUp
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $9lDWQ.SplitButtonContext).Provider, {
        value: undefined
    }, children, isLoading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("span", {
        className: (0, $970q7.default)([
            $76b58416a5044cb0$var$styles.loadingOverlay
        ])
    }, (0, $cgjHo.default)({
        spacing: spacing,
        appearance: appearance,
        isDisabled: isDisabled,
        isSelected: isSelected,
        testId: testId
    })), isLoading && (ariaLabelledBy || !ariaLabel) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $e8kqY.default), {
        id: loadingLabelId
    }, $76b58416a5044cb0$var$LOADING_LABEL)));
});
var $76b58416a5044cb0$export$2e2bcd8739ae039 = $76b58416a5044cb0$var$ButtonBase;

});
parcelRegister("gVtSA", function(module, exports) {
$parcel$export(module.exports, "cx", () => $c52925ab3e44b65f$export$a274e22fb40f762e);
/* index.tsx generated by @compiled/babel-plugin v0.38.1 */ parcelRequire("5FkrB");


var $Pd8py = parcelRequire("Pd8py");
var $c52925ab3e44b65f$var$strictApi = (0, $Pd8py.createStrictAPI)();
var $c52925ab3e44b65f$export$dbf350e5966cf602 = $c52925ab3e44b65f$var$strictApi.css;
var $c52925ab3e44b65f$export$eb1ecd84a24ee424 = $c52925ab3e44b65f$var$strictApi.cssMap;
$c52925ab3e44b65f$var$strictApi.cssMap;
var $c52925ab3e44b65f$export$a274e22fb40f762e = $c52925ab3e44b65f$var$strictApi.cx;
var $c52925ab3e44b65f$var$XCSSProp = $c52925ab3e44b65f$var$strictApi.XCSSProp; // This is to mitigate local TS error TS2315: Type 'StrictXCSSProp' is not generic.
 // Currently for some reason tsc is generating malformed .d.ts in local dev environment, below change fixes it
 /**
 * ## StrictXCSSProp
 *
 * Declare styles your component takes with all other styles marked as violations
 * by the TypeScript compiler. There are two primary use cases for xcss prop:
 *
 * - safe style overrides
 * - inverting style declarations
 *
 * Interverting style declarations is interesting for platform teams as
 * it means apps only pay for styles they use as they're now the ones who declare
 * the styles!
 *
 * The {@link StrictXCSSProp} type has generics two of which must be defined — use to explicitly
 * set what you want to maintain as API. Use {@link XCSSAllProperties} and {@link XCSSAllPseudos}
 * to enable all properties and pseudos.
 *
 * The third generic is used to declare what properties and pseudos should be required.
 *
 * ```tsx
 * interface MyComponentProps {
 *   // Color is accepted, all other properties / pseudos are considered violations.
 *   xcss?: StrictXCSSProp<'color', never>;
 *
 *   // Only background color and hover pseudo are accepted.
 *   xcss?: StrictXCSSProp<'backgroundColor', '&:hover'>;
 *
 *   // All properties are accepted, all pseudos are considered violations.
 *   xcss?: StrictXCSSProp<XCSSAllProperties, never>;
 *
 *   // All properties are accepted, only the hover pseudo is accepted.
 *   xcss?: StrictXCSSProp<XCSSAllProperties, '&:hover'>;
 *
 *   // The xcss prop is required as well as the color property. No pseudos are required.
 *   xcss: StrictXCSSProp<
 *     XCSSAllProperties,
 *     '&:hover',
 *     { requiredProperties: 'color', requiredPseudos: never }
 *   >;
 * }
 *
 * function MyComponent({ xcss }: MyComponentProps) {
 *   return <div css={{ color: 'var(--ds-text-danger)' }} className={xcss} />
 * }
 * ```
 *
 * The xcss prop works with static inline objects and the [cssMap](https://compiledcssinjs.com/docs/api-cssmap) API.
 *
 * ```jsx
 * // Declared as an inline object
 * <Component xcss={{ color: 'var(--ds-text)' }} />
 *
 * // Declared with the cssMap API
 * const styles = cssMap({ text: { color: 'var(--ds-text)' } });
 * <Component xcss={styles.text} />
 * ```
 *
 * To concatenate and conditonally apply styles use the {@link cssMap} and {@link cx} functions.
 */ 

});

parcelRegister("ivut0", function(module, exports) {
$parcel$export(module.exports, "default", () => $d792c14de96dd16a$export$2e2bcd8739ae039);
/* pressable.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $kqp0i = parcelRequire("kqp0i");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");


var $hUFig = parcelRequire("hUFig");

var $6Oq3u = parcelRequire("6Oq3u");

var $dJ32z = parcelRequire("dJ32z");

var $eVb4V = parcelRequire("eVb4V");

var $eqVaP = parcelRequire("eqVaP");

var $7QHW4 = parcelRequire("7QHW4");
var $d792c14de96dd16a$var$_excluded = [
    "children",
    "isDisabled",
    "type",
    "onClick",
    "interactionName",
    "componentName",
    "analyticsContext",
    "style",
    "testId",
    "xcss",
    "tabIndex"
], $d792c14de96dd16a$var$_excluded2 = [
    "className"
];
var $d792c14de96dd16a$var$styles = {
    root: "_19itglyw _vchhusvi _r06hglyw _80omtlke",
    disabled: "_80om13gf"
};
/**
 * __Pressable__
 *
 * A primitive for building custom buttons.
 *
 * - [Examples](https://atlassian.design/components/primitives/pressable/examples)
 * - [Code](https://atlassian.design/components/primitives/pressable/code)
 * - [Usage](https://atlassian.design/components/primitives/pressable/usage)
 */ var $d792c14de96dd16a$var$Pressable = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function(_ref, ref) {
    var children = _ref.children, isDisabled = _ref.isDisabled, _ref$type = _ref.type, type = _ref$type === void 0 ? 'button' : _ref$type, _ref$onClick = _ref.onClick, providedOnClick = _ref$onClick === void 0 ? (0, $eVb4V.default) : _ref$onClick, interactionName = _ref.interactionName, componentName = _ref.componentName, analyticsContext = _ref.analyticsContext, style = _ref.style, testId = _ref.testId, xcss = _ref.xcss, tabIndex = _ref.tabIndex, htmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $d792c14de96dd16a$var$_excluded);
    var interactionContext = (0, $5FkrB.useContext)((0, $eqVaP.default));
    var handleClick = (0, $5FkrB.useCallback)(function(e, analyticsEvent) {
        interactionContext && interactionContext.tracePress(interactionName, e.timeStamp);
        providedOnClick(e, analyticsEvent);
    }, [
        providedOnClick,
        interactionContext,
        interactionName
    ]);
    var onClick = (0, $6Oq3u.usePlatformLeafEventHandler)({
        fn: handleClick,
        action: 'clicked',
        componentName: componentName || 'Pressable',
        packageName: "@atlaskit/primitives",
        packageVersion: "16.4.4",
        analyticsData: analyticsContext,
        actionSubject: 'button'
    });
    // This is to remove className from safeHtmlAttributes
    // @ts-expect-error className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(htmlAttributes, $d792c14de96dd16a$var$_excluded2);
    return /*#__PURE__*/ $5FkrB.createElement((0, $7QHW4.default), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        as: "button",
        tabIndex: tabIndex !== null && tabIndex !== void 0 ? tabIndex : (0, $dJ32z.isSafari)() && !isDisabled ? 0 : undefined,
        style: style
    }, safeHtmlAttributes, {
        type: type,
        onClick: onClick,
        disabled: isDisabled,
        xcss: (0, $hUFig.cx)($d792c14de96dd16a$var$styles.root, isDisabled && $d792c14de96dd16a$var$styles.disabled, xcss),
        testId: testId,
        ref: ref
    }), children);
});
var $d792c14de96dd16a$export$2e2bcd8739ae039 = $d792c14de96dd16a$var$Pressable;

});
parcelRegister("6Oq3u", function(module, exports) {
$parcel$export(module.exports, "usePlatformLeafEventHandler", () => $4f5b9fa262d22e36$export$a4687b0234b40e28);

var $25nEq = parcelRequire("25nEq");

var $5FkrB = parcelRequire("5FkrB");

var $jBycd = parcelRequire("jBycd");

var $79FeR = parcelRequire("79FeR");
function $4f5b9fa262d22e36$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $4f5b9fa262d22e36$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $4f5b9fa262d22e36$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $4f5b9fa262d22e36$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $4f5b9fa262d22e36$export$a4687b0234b40e28(_ref) {
    var fn = _ref.fn, action = _ref.action, componentName = _ref.componentName, actionSubject = _ref.actionSubject, packageName = _ref.packageName, packageVersion = _ref.packageVersion, analyticsData = _ref.analyticsData;
    var _useAnalyticsEvents = (0, $jBycd.useAnalyticsEvents)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
    // We put analyticsData and fn in a ref so that we don't need to break
    // memoization.
    // Generally these could be defined by consumers inline
    // and so we do this to avoid breaking memoization of useCallback
    var dataRef = (0, $79FeR.useTrackedRef)(analyticsData);
    var fnRef = (0, $79FeR.useTrackedRef)(fn);
    var handler = (0, $5FkrB.useCallback)(function(value) {
        var analyticsEvent = createAnalyticsEvent({
            action: action,
            actionSubject: actionSubject || componentName,
            attributes: {
                componentName: componentName,
                packageName: packageName,
                packageVersion: packageVersion
            }
        });
        // To avoid wrapping this component in AnalyticsContext we manually
        // push the parent context's meta data into the context.
        // Note: this new 'context'
        var context = $4f5b9fa262d22e36$var$_objectSpread({
            componentName: componentName,
            packageName: packageName,
            packageVersion: packageVersion
        }, dataRef.current);
        analyticsEvent.context.push(context);
        // fire an event on the atlaskit channel
        var clone = analyticsEvent.clone();
        if (clone) clone.fire('atlaskit');
        fnRef.current(value, analyticsEvent);
    }, [
        // These are strings and won't change
        action,
        componentName,
        actionSubject,
        packageName,
        packageVersion,
        // This function is memoized in the context
        createAnalyticsEvent,
        // these are a stable ref because of the useTrackedRef hook
        dataRef,
        fnRef
    ]);
    return handler;
}

});

parcelRegister("7QHW4", function(module, exports) {
$parcel$export(module.exports, "default", () => $5b6f78740483cfa9$export$2e2bcd8739ae039);
/* focusable.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $kqp0i = parcelRequire("kqp0i");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");
var $5b6f78740483cfa9$var$_excluded = [
    "as",
    "children",
    "isInset",
    "testId",
    "style",
    "xcss"
], $5b6f78740483cfa9$var$_excluded2 = [
    "className"
];
var $5b6f78740483cfa9$var$focusRingStyles = null;
var $5b6f78740483cfa9$var$insetFocusRingStyles = null;
/**
 * __Focus ring__
 *
 * A focus ring visually indicates the currently focused item.
 *
 */ var $5b6f78740483cfa9$var$Focusable = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? 'button' : _ref$as, children = _ref.children, isInset = _ref.isInset, testId = _ref.testId, style = _ref.style, xcss = _ref.xcss, htmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $5b6f78740483cfa9$var$_excluded);
    // This is to remove className from safeHtmlAttributes
    // @ts-ignore -- not using expect since it causes issues with help-center local consumption - className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(htmlAttributes, $5b6f78740483cfa9$var$_excluded2);
    return /*#__PURE__*/ $5FkrB.createElement(Component, (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, safeHtmlAttributes, {
        // @ts-ignore Expression produces a union type that is too complex to represent. We may be able to narrow the type here but unsure.
        ref: ref,
        className: (0, $970q7.default)([
            "_ymio1r31 _ypr0glyw _zcxs1o36 _mizu194a _1ah3dkaa _ra3xnqa1 _128mdkaa _1cvmnqa1 _4davt94y",
            isInset && "_1ah31gjf _2mwq1gjf",
            xcss
        ]),
        style: style,
        "data-testid": testId
    }), children);
});
var $5b6f78740483cfa9$export$2e2bcd8739ae039 = $5b6f78740483cfa9$var$Focusable;

});


parcelRegister("9lDWQ", function(module, exports) {
$parcel$export(module.exports, "SplitButtonContext", () => $6ce5101b12a1b7f3$export$4b86304b2c0d7e71);
$parcel$export(module.exports, "useSplitButtonContext", () => $6ce5101b12a1b7f3$export$47e2c6fdb142d947);

var $5FkrB = parcelRequire("5FkrB");
var $6ce5101b12a1b7f3$export$4b86304b2c0d7e71 = /*#__PURE__*/ (0, $5FkrB.createContext)(undefined);
var $6ce5101b12a1b7f3$export$47e2c6fdb142d947 = function useSplitButtonContext() {
    var context = (0, $5FkrB.useContext)($6ce5101b12a1b7f3$export$4b86304b2c0d7e71);
    if (!context) return undefined;
    if (context.appearance === 'navigation') {
        var newContext = {
            spacing: 'default',
            appearance: 'subtle',
            isDisabled: false,
            isActiveOverSelected: false,
            isNavigationSplitButton: true,
            isHighlighted: context.isHighlighted
        };
        return newContext;
    }
    var splitButtonContext = {
        spacing: context.spacing,
        appearance: context.appearance,
        isDisabled: context.isDisabled,
        isActiveOverSelected: true,
        isNavigationSplitButton: false,
        isHighlighted: false
    };
    return splitButtonContext;
};

});

parcelRegister("iZn4f", function(module, exports) {
$parcel$export(module.exports, "default", () => $dd2fd13b7e17523c$export$2e2bcd8739ae039);
function $dd2fd13b7e17523c$var$abort(event) {
    event.preventDefault();
    event.stopPropagation();
}
var $dd2fd13b7e17523c$var$tabKeyCode = 9;
function $dd2fd13b7e17523c$var$onKey(event) {
    // Allowing tab so that a user can move focus away
    if (event.keyCode === $dd2fd13b7e17523c$var$tabKeyCode) return;
    $dd2fd13b7e17523c$var$abort(event);
}
function $dd2fd13b7e17523c$export$2e2bcd8739ae039(shouldBlockEvents, events) {
    return shouldBlockEvents ? {
        onMouseDownCapture: $dd2fd13b7e17523c$var$abort,
        onMouseUpCapture: $dd2fd13b7e17523c$var$abort,
        onKeyDownCapture: $dd2fd13b7e17523c$var$onKey,
        onKeyUpCapture: $dd2fd13b7e17523c$var$onKey,
        onTouchStartCapture: $dd2fd13b7e17523c$var$abort,
        onTouchEndCapture: $dd2fd13b7e17523c$var$abort,
        onPointerDownCapture: $dd2fd13b7e17523c$var$abort,
        onPointerUpCapture: $dd2fd13b7e17523c$var$abort,
        onClickCapture: $dd2fd13b7e17523c$var$abort,
        // Just smashing the existing onClick for good measure
        onClick: $dd2fd13b7e17523c$var$abort
    } : events;
}

});

parcelRegister("cgjHo", function(module, exports) {
$parcel$export(module.exports, "default", () => $8ed64276c2b30505$export$2e2bcd8739ae039);

var $5FkrB = parcelRequire("5FkrB");

var $9ztDu = parcelRequire("9ztDu");
function $8ed64276c2b30505$var$getIconSpacing(spacing) {
    switch(spacing){
        case 'compact':
            return 'small';
        default:
            return 'medium';
    }
}
function $8ed64276c2b30505$var$getSpinnerAppearance(_ref) {
    var appearance = _ref.appearance, isDisabled = _ref.isDisabled, isSelected = _ref.isSelected;
    if (isDisabled || isSelected) return 'inherit';
    if (appearance === 'primary' || appearance === 'danger' || appearance === 'discovery') return 'invert';
    return 'inherit';
}
function $8ed64276c2b30505$export$2e2bcd8739ae039(_ref2) {
    var appearance = _ref2.appearance, spacing = _ref2.spacing, isDisabled = _ref2.isDisabled, isSelected = _ref2.isSelected, testId = _ref2.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $9ztDu.default), {
        size: $8ed64276c2b30505$var$getIconSpacing(spacing),
        appearance: $8ed64276c2b30505$var$getSpinnerAppearance({
            appearance: appearance,
            isDisabled: isDisabled,
            isSelected: isSelected
        }),
        testId: testId ? "".concat(testId, "--loading-spinner") : undefined
    });
}

});


parcelRegister("ccBRl", function(module, exports) {
$parcel$export(module.exports, "default", () => $8e23f919bcd6960d$export$2e2bcd8739ae039);
/* content.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $970q7 = parcelRequire("970q7");

var $5FkrB = parcelRequire("5FkrB");
var $8e23f919bcd6960d$var$styles = {
    text: "_1reo15vq _18m915vq _16jlkb7n _1o9zkb7n _1bto1l2s _o5721q9c",
    icon: "_1e0c1txw _16jlidpf _1o9zidpf _1wpz1h6o _1wybidpf _vwz4idpf _uiztglyw",
    beforeIcon: "_1he91b66 _w795v77o",
    afterIcon: "_1he9v77o _w7951b66",
    common: "_v564g17y",
    fade: "_tzy4idpf"
};
/**
 * __Content__
 *
 * Used for slots within a Button, including icons and text content.
 */ var $8e23f919bcd6960d$var$Content = function Content(_ref) {
    var children = _ref.children, _ref$type = _ref.type, type = _ref$type === void 0 ? 'text' : _ref$type, isLoading = _ref.isLoading, position = _ref.position;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("span", {
        className: (0, $970q7.default)([
            $8e23f919bcd6960d$var$styles.common,
            type === 'text' && $8e23f919bcd6960d$var$styles.text,
            type === 'icon' && $8e23f919bcd6960d$var$styles.icon,
            isLoading && $8e23f919bcd6960d$var$styles.fade,
            position === 'before' && $8e23f919bcd6960d$var$styles.beforeIcon,
            position === 'after' && $8e23f919bcd6960d$var$styles.afterIcon
        ])
    }, children);
};
var $8e23f919bcd6960d$export$2e2bcd8739ae039 = $8e23f919bcd6960d$var$Content;

});

parcelRegister("goIky", function(module, exports) {
$parcel$export(module.exports, "default", () => $bf01465dd7c7d1ef$export$2e2bcd8739ae039);

var $5FkrB = parcelRequire("5FkrB");

var $9Zzpd = parcelRequire("9Zzpd");
function $bf01465dd7c7d1ef$var$isIconRenderProp(func) {
    return !func.displayName && // most function components and class components have a displayName, negate them
    !func.render && // forwardRef doesn't require a display name, however it does include a render function, negate them
    typeof func === 'function' // at the very least we need to be a function
    ;
}
/**
 * __Icon renderer__
 *
 * Used to support render props with icons.
 *
 */ var $bf01465dd7c7d1ef$var$IconRenderer = function IconRenderer(_ref) {
    var Icon = _ref.icon;
    var isRenderProp = $bf01465dd7c7d1ef$var$isIconRenderProp(Icon);
    var iconProps = {
        label: '',
        color: 'currentColor',
        size: (0, $9Zzpd.fg)('platform_dst_button_chevron_sizing') ? function(iconName) {
            return iconName.startsWith('Chevron') ? 'small' : 'medium';
        } : undefined
    };
    // @ts-ignore - TS2322 TypeScript 5.9.2 upgrade
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).Fragment, null, isRenderProp ? Icon(iconProps) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(Icon, iconProps));
};
var $bf01465dd7c7d1ef$export$2e2bcd8739ae039 = $bf01465dd7c7d1ef$var$IconRenderer;

});


parcelRegister("iKVNi", function(module, exports) {
$parcel$export(module.exports, "default", () => $da795a970ec52435$export$2e2bcd8739ae039);
/* heading.partial.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");

var $1vrLf = parcelRequire("1vrLf");

var $bemp3 = parcelRequire("bemp3");

var $6zfDF = parcelRequire("6zfDF");

var $3ZMUU = parcelRequire("3ZMUU");
var $da795a970ec52435$var$sizeTagMap = {
    xxlarge: 'h1',
    xlarge: 'h1',
    large: 'h2',
    medium: 'h3',
    small: 'h4',
    xsmall: 'h5',
    xxsmall: 'h6'
};
var $da795a970ec52435$var$styles = {
    reset: "_1mouidpf _1dyz4jg8 _1p1dglyw"
};
var $da795a970ec52435$var$headingColorStylesMap = {
    'color.text': "_syazi7uo",
    'color.text.inverse': "_syaz15cr",
    'color.text.warning.inverse': "_syaz1yd3"
};
/**
 * THIS SECTION WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::406afb01e5634a0b459f50de660d8c2e>>
 * @codegenId typography
 * @codegenCommand yarn workspace @atlaskit/heading codegen
 */ var $da795a970ec52435$var$headingSizeStylesMap = {
    xxlarge: "_11c84xcc",
    xlarge: "_11c81c04",
    large: "_11c8nf1z",
    medium: "_11c8lodh",
    small: "_11c8nbxd",
    xsmall: "_11c8140y",
    xxsmall: "_11c81vhk"
};
/**
 * @codegenEnd
 */ var $da795a970ec52435$var$useColor = function useColor(colorProp) {
    var surface = (0, $bemp3.useSurface)();
    if (colorProp) return colorProp;
    if ((0, $1vrLf.inverseColorMap).hasOwnProperty(surface)) return (0, $1vrLf.inverseColorMap)[surface];
    return 'color.text';
};
/**
 * __Heading__
 *
 * Heading is a typography component used to display text in defined sizes and styles.
 *
 * @example
 *
 * ```jsx
 * <Heading size="xxlarge">Page title</Heading>
 * ```
 */ var $da795a970ec52435$var$Heading = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function(props, ref) {
    var children = props.children, size = props.size, id = props.id, testId = props.testId, as = props.as, colorProp = props.color;
    typeof $3ZMUU;
    var _useHeading = (0, $6zfDF.useHeading)($da795a970ec52435$var$sizeTagMap[size]), _useHeading2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useHeading, 2), hLevel = _useHeading2[0], inferredElement = _useHeading2[1];
    var Component = as || inferredElement;
    var needsAriaRole = Component === 'div' && hLevel;
    var color = $da795a970ec52435$var$useColor(colorProp);
    return /*#__PURE__*/ $5FkrB.createElement(Component, {
        id: id,
        ref: ref,
        "data-testid": testId,
        role: needsAriaRole ? 'heading' : undefined,
        "aria-level": needsAriaRole ? hLevel : undefined,
        className: (0, $970q7.default)([
            $da795a970ec52435$var$styles.reset,
            size && $da795a970ec52435$var$headingSizeStylesMap[size],
            $da795a970ec52435$var$headingColorStylesMap[color]
        ])
    }, children);
});
var $da795a970ec52435$export$2e2bcd8739ae039 = $da795a970ec52435$var$Heading;

});
parcelRegister("1vrLf", function(module, exports) {
$parcel$export(module.exports, "inverseColorMap", () => $118e387c67bd0da2$export$2185ce37f9bdd963);

var $25nEq = parcelRequire("25nEq");

var $74Zh5 = parcelRequire("74Zh5");

var $idDoJ = parcelRequire("idDoJ");
function $118e387c67bd0da2$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $118e387c67bd0da2$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $118e387c67bd0da2$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $118e387c67bd0da2$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $118e387c67bd0da2$export$6ccdbebca2ee545f = {
    '100%': '100%',
    'size.100': '1rem',
    'size.200': '1.5rem',
    'size.300': '2rem',
    'size.400': '2.5rem',
    'size.500': '3rem',
    'size.600': '6rem',
    'size.1000': '12rem'
};
var $118e387c67bd0da2$export$958d0ae7f2977ae4 = {
    'space.0': "var(--ds-space-0, 0px)",
    'space.025': "var(--ds-space-025, 2px)",
    'space.050': "var(--ds-space-050, 4px)",
    'space.075': "var(--ds-space-075, 6px)",
    'space.100': "var(--ds-space-100, 8px)",
    'space.150': "var(--ds-space-150, 12px)",
    'space.200': "var(--ds-space-200, 16px)",
    'space.250': "var(--ds-space-250, 20px)",
    'space.300': "var(--ds-space-300, 24px)",
    'space.400': "var(--ds-space-400, 32px)",
    'space.500': "var(--ds-space-500, 40px)",
    'space.600': "var(--ds-space-600, 48px)",
    'space.800': "var(--ds-space-800, 64px)",
    'space.1000': "var(--ds-space-1000, 80px)"
};
var $118e387c67bd0da2$export$d2dc61f58390201c = {
    'space.negative.025': "var(--ds-space-negative-025, -2px)",
    'space.negative.050': "var(--ds-space-negative-050, -4px)",
    'space.negative.075': "var(--ds-space-negative-075, -6px)",
    'space.negative.100': "var(--ds-space-negative-100, -8px)",
    'space.negative.150': "var(--ds-space-negative-150, -12px)",
    'space.negative.200': "var(--ds-space-negative-200, -16px)",
    'space.negative.250': "var(--ds-space-negative-250, -20px)",
    'space.negative.300': "var(--ds-space-negative-300, -24px)",
    'space.negative.400': "var(--ds-space-negative-400, -32px)"
};
var $118e387c67bd0da2$export$632685d741f3dbbf = $118e387c67bd0da2$var$_objectSpread($118e387c67bd0da2$var$_objectSpread({}, $118e387c67bd0da2$export$958d0ae7f2977ae4), $118e387c67bd0da2$export$d2dc61f58390201c);
var $118e387c67bd0da2$export$2185ce37f9bdd963 = {
    'color.background.neutral.bold': 'color.text.inverse',
    'color.background.neutral.bold.hovered': 'color.text.inverse',
    'color.background.neutral.bold.pressed': 'color.text.inverse',
    'color.background.selected.bold': 'color.text.inverse',
    'color.background.selected.bold.hovered': 'color.text.inverse',
    'color.background.selected.bold.pressed': 'color.text.inverse',
    'color.background.brand.bold': 'color.text.inverse',
    'color.background.brand.bold.hovered': 'color.text.inverse',
    'color.background.brand.bold.pressed': 'color.text.inverse',
    'color.background.brand.boldest': 'color.text.inverse',
    'color.background.brand.boldest.hovered': 'color.text.inverse',
    'color.background.brand.boldest.pressed': 'color.text.inverse',
    'color.background.danger.bold': 'color.text.inverse',
    'color.background.danger.bold.hovered': 'color.text.inverse',
    'color.background.danger.bold.pressed': 'color.text.inverse',
    'color.background.warning.bold': 'color.text.warning.inverse',
    'color.background.warning.bold.hovered': 'color.text.warning.inverse',
    'color.background.warning.bold.pressed': 'color.text.warning.inverse',
    'color.background.success.bold': 'color.text.inverse',
    'color.background.success.bold.hovered': 'color.text.inverse',
    'color.background.success.bold.pressed': 'color.text.inverse',
    'color.background.discovery.bold': 'color.text.inverse',
    'color.background.discovery.bold.hovered': 'color.text.inverse',
    'color.background.discovery.bold.pressed': 'color.text.inverse',
    'color.background.information.bold': 'color.text.inverse',
    'color.background.information.bold.hovered': 'color.text.inverse',
    'color.background.information.bold.pressed': 'color.text.inverse'
};
var $118e387c67bd0da2$export$daf94a976c798b4f = {
    'opacity.disabled': "var(--ds-opacity-disabled, 0.4)",
    'opacity.loading': "var(--ds-opacity-loading, 0.2)"
};
var $118e387c67bd0da2$export$7aff6e7ba39bb774 = {
    'elevation.shadow.overflow': "var(--ds-shadow-overflow, 0px 0px 8px #091e423f, 0px 0px 1px #091e424f)",
    'elevation.shadow.overflow.perimeter': "var(--ds-shadow-overflow-perimeter, #091e421f)",
    'elevation.shadow.overflow.spread': "var(--ds-shadow-overflow-spread, #091e4229)",
    'elevation.shadow.overlay': "var(--ds-shadow-overlay, 0px 8px 12px #091e423f, 0px 0px 1px #091e424f)",
    'elevation.shadow.raised': "var(--ds-shadow-raised, 0px 1px 1px #091e423f, 0px 0px 1px #091e4221)"
};
var $118e387c67bd0da2$export$41a358c9c2356760 = {
    'elevation.surface': "var(--ds-surface, #FFFFFF)",
    'elevation.surface.hovered': "var(--ds-surface-hovered, #FAFBFC)",
    'elevation.surface.pressed': "var(--ds-surface-pressed, #F4F5F7)",
    'elevation.surface.overlay': "var(--ds-surface-overlay, #FFFFFF)",
    'elevation.surface.overlay.hovered': "var(--ds-surface-overlay-hovered, #FAFBFC)",
    'elevation.surface.overlay.pressed': "var(--ds-surface-overlay-pressed, #F4F5F7)",
    'elevation.surface.raised': "var(--ds-surface-raised, #FFFFFF)",
    'elevation.surface.raised.hovered': "var(--ds-surface-raised-hovered, #FAFBFC)",
    'elevation.surface.raised.pressed': "var(--ds-surface-raised-pressed, #F4F5F7)",
    'elevation.surface.sunken': "var(--ds-surface-sunken, #F4F5F7)"
};
var $118e387c67bd0da2$export$1531ad5bb3fbedac = {
    'color.border': "var(--ds-border, #091e4221)",
    'color.border.accent.lime': "var(--ds-border-accent-lime, #6A9A23)",
    'color.border.accent.red': "var(--ds-border-accent-red, #FF5630)",
    'color.border.accent.orange': "var(--ds-border-accent-orange, #D94008)",
    'color.border.accent.yellow': "var(--ds-border-accent-yellow, #FFAB00)",
    'color.border.accent.green': "var(--ds-border-accent-green, #36B37E)",
    'color.border.accent.teal': "var(--ds-border-accent-teal, #00B8D9)",
    'color.border.accent.blue': "var(--ds-border-accent-blue, #0065FF)",
    'color.border.accent.purple': "var(--ds-border-accent-purple, #6554C0)",
    'color.border.accent.magenta': "var(--ds-border-accent-magenta, #CD519D)",
    'color.border.accent.gray': "var(--ds-border-accent-gray, #5E6C84)",
    'color.border.disabled': "var(--ds-border-disabled, #FAFBFC)",
    'color.border.focused': "var(--ds-border-focused, #2684FF)",
    'color.border.input': "var(--ds-border-input, #FAFBFC)",
    'color.border.inverse': "var(--ds-border-inverse, #FFFFFF)",
    'color.border.selected': "var(--ds-border-selected, #0052CC)",
    'color.border.brand': "var(--ds-border-brand, #0052CC)",
    'color.border.danger': "var(--ds-border-danger, #FF5630)",
    'color.border.warning': "var(--ds-border-warning, #FFC400)",
    'color.border.success': "var(--ds-border-success, #00875A)",
    'color.border.discovery': "var(--ds-border-discovery, #998DD9)",
    'color.border.information': "var(--ds-border-information, #0065FF)",
    'color.border.bold': "var(--ds-border-bold, #344563)"
};
var $118e387c67bd0da2$export$d1d79bf68ac056bd = {
    'color.background.accent.lime.subtlest': "var(--ds-background-accent-lime-subtlest, #EEFBDA)",
    'color.background.accent.lime.subtlest.hovered': "var(--ds-background-accent-lime-subtlest-hovered, #D3F1A7)",
    'color.background.accent.lime.subtlest.pressed': "var(--ds-background-accent-lime-subtlest-pressed, #B3DF72)",
    'color.background.accent.lime.subtler': "var(--ds-background-accent-lime-subtler, #D3F1A7)",
    'color.background.accent.lime.subtler.hovered': "var(--ds-background-accent-lime-subtler-hovered, #B3DF72)",
    'color.background.accent.lime.subtler.pressed': "var(--ds-background-accent-lime-subtler-pressed, #94C748)",
    'color.background.accent.lime.subtle': "var(--ds-background-accent-lime-subtle, #94C748)",
    'color.background.accent.lime.subtle.hovered': "var(--ds-background-accent-lime-subtle-hovered, #B3DF72)",
    'color.background.accent.lime.subtle.pressed': "var(--ds-background-accent-lime-subtle-pressed, #D3F1A7)",
    'color.background.accent.lime.bolder': "var(--ds-background-accent-lime-bolder, #5B7F24)",
    'color.background.accent.lime.bolder.hovered': "var(--ds-background-accent-lime-bolder-hovered, #37471F)",
    'color.background.accent.lime.bolder.pressed': "var(--ds-background-accent-lime-bolder-pressed, #37471F)",
    'color.background.accent.red.subtlest': "var(--ds-background-accent-red-subtlest, #FF8F73)",
    'color.background.accent.red.subtlest.hovered': "var(--ds-background-accent-red-subtlest-hovered, #FF7452)",
    'color.background.accent.red.subtlest.pressed': "var(--ds-background-accent-red-subtlest-pressed, #FF5630)",
    'color.background.accent.red.subtler': "var(--ds-background-accent-red-subtler, #FF7452)",
    'color.background.accent.red.subtler.hovered': "var(--ds-background-accent-red-subtler-hovered, #FF5630)",
    'color.background.accent.red.subtler.pressed': "var(--ds-background-accent-red-subtler-pressed, #DE350B)",
    'color.background.accent.red.subtle': "var(--ds-background-accent-red-subtle, #DE350B)",
    'color.background.accent.red.subtle.hovered': "var(--ds-background-accent-red-subtle-hovered, #FF5630)",
    'color.background.accent.red.subtle.pressed': "var(--ds-background-accent-red-subtle-pressed, #FF7452)",
    'color.background.accent.red.bolder': "var(--ds-background-accent-red-bolder, #DE350B)",
    'color.background.accent.red.bolder.hovered': "var(--ds-background-accent-red-bolder-hovered, #FF5630)",
    'color.background.accent.red.bolder.pressed': "var(--ds-background-accent-red-bolder-pressed, #FF7452)",
    'color.background.accent.orange.subtlest': "var(--ds-background-accent-orange-subtlest, #F18D13)",
    'color.background.accent.orange.subtlest.hovered': "var(--ds-background-accent-orange-subtlest-hovered, #FEC57B)",
    'color.background.accent.orange.subtlest.pressed': "var(--ds-background-accent-orange-subtlest-pressed, #FFE2BD)",
    'color.background.accent.orange.subtler': "var(--ds-background-accent-orange-subtler, #B65C02)",
    'color.background.accent.orange.subtler.hovered': "var(--ds-background-accent-orange-subtler-hovered, #F18D13)",
    'color.background.accent.orange.subtler.pressed': "var(--ds-background-accent-orange-subtler-pressed, #FEC57B)",
    'color.background.accent.orange.subtle': "var(--ds-background-accent-orange-subtle, #5F3811)",
    'color.background.accent.orange.subtle.hovered': "var(--ds-background-accent-orange-subtle-hovered, #974F0C)",
    'color.background.accent.orange.subtle.pressed': "var(--ds-background-accent-orange-subtle-pressed, #B65C02)",
    'color.background.accent.orange.bolder': "var(--ds-background-accent-orange-bolder, #43290F)",
    'color.background.accent.orange.bolder.hovered': "var(--ds-background-accent-orange-bolder-hovered, #5F3811)",
    'color.background.accent.orange.bolder.pressed': "var(--ds-background-accent-orange-bolder-pressed, #974F0C)",
    'color.background.accent.yellow.subtlest': "var(--ds-background-accent-yellow-subtlest, #FFE380)",
    'color.background.accent.yellow.subtlest.hovered': "var(--ds-background-accent-yellow-subtlest-hovered, #FFC400)",
    'color.background.accent.yellow.subtlest.pressed': "var(--ds-background-accent-yellow-subtlest-pressed, #FFAB00)",
    'color.background.accent.yellow.subtler': "var(--ds-background-accent-yellow-subtler, #FFC400)",
    'color.background.accent.yellow.subtler.hovered': "var(--ds-background-accent-yellow-subtler-hovered, #FFAB00)",
    'color.background.accent.yellow.subtler.pressed': "var(--ds-background-accent-yellow-subtler-pressed, #FF991F)",
    'color.background.accent.yellow.subtle': "var(--ds-background-accent-yellow-subtle, #FF991F)",
    'color.background.accent.yellow.subtle.hovered': "var(--ds-background-accent-yellow-subtle-hovered, #FFAB00)",
    'color.background.accent.yellow.subtle.pressed': "var(--ds-background-accent-yellow-subtle-pressed, #FFC400)",
    'color.background.accent.yellow.bolder': "var(--ds-background-accent-yellow-bolder, #FF991F)",
    'color.background.accent.yellow.bolder.hovered': "var(--ds-background-accent-yellow-bolder-hovered, #FFAB00)",
    'color.background.accent.yellow.bolder.pressed': "var(--ds-background-accent-yellow-bolder-pressed, #FFC400)",
    'color.background.accent.green.subtlest': "var(--ds-background-accent-green-subtlest, #79F2C0)",
    'color.background.accent.green.subtlest.hovered': "var(--ds-background-accent-green-subtlest-hovered, #57D9A3)",
    'color.background.accent.green.subtlest.pressed': "var(--ds-background-accent-green-subtlest-pressed, #36B37E)",
    'color.background.accent.green.subtler': "var(--ds-background-accent-green-subtler, #57D9A3)",
    'color.background.accent.green.subtler.hovered': "var(--ds-background-accent-green-subtler-hovered, #36B37E)",
    'color.background.accent.green.subtler.pressed': "var(--ds-background-accent-green-subtler-pressed, #00875A)",
    'color.background.accent.green.subtle': "var(--ds-background-accent-green-subtle, #00875A)",
    'color.background.accent.green.subtle.hovered': "var(--ds-background-accent-green-subtle-hovered, #36B37E)",
    'color.background.accent.green.subtle.pressed': "var(--ds-background-accent-green-subtle-pressed, #57D9A3)",
    'color.background.accent.green.bolder': "var(--ds-background-accent-green-bolder, #00875A)",
    'color.background.accent.green.bolder.hovered': "var(--ds-background-accent-green-bolder-hovered, #36B37E)",
    'color.background.accent.green.bolder.pressed': "var(--ds-background-accent-green-bolder-pressed, #57D9A3)",
    'color.background.accent.teal.subtlest': "var(--ds-background-accent-teal-subtlest, #79E2F2)",
    'color.background.accent.teal.subtlest.hovered': "var(--ds-background-accent-teal-subtlest-hovered, #00C7E6)",
    'color.background.accent.teal.subtlest.pressed': "var(--ds-background-accent-teal-subtlest-pressed, #00B8D9)",
    'color.background.accent.teal.subtler': "var(--ds-background-accent-teal-subtler, #00C7E6)",
    'color.background.accent.teal.subtler.hovered': "var(--ds-background-accent-teal-subtler-hovered, #00B8D9)",
    'color.background.accent.teal.subtler.pressed': "var(--ds-background-accent-teal-subtler-pressed, #00A3BF)",
    'color.background.accent.teal.subtle': "var(--ds-background-accent-teal-subtle, #00A3BF)",
    'color.background.accent.teal.subtle.hovered': "var(--ds-background-accent-teal-subtle-hovered, #00B8D9)",
    'color.background.accent.teal.subtle.pressed': "var(--ds-background-accent-teal-subtle-pressed, #00C7E6)",
    'color.background.accent.teal.bolder': "var(--ds-background-accent-teal-bolder, #00A3BF)",
    'color.background.accent.teal.bolder.hovered': "var(--ds-background-accent-teal-bolder-hovered, #00B8D9)",
    'color.background.accent.teal.bolder.pressed': "var(--ds-background-accent-teal-bolder-pressed, #00C7E6)",
    'color.background.accent.blue.subtlest': "var(--ds-background-accent-blue-subtlest, #4C9AFF)",
    'color.background.accent.blue.subtlest.hovered': "var(--ds-background-accent-blue-subtlest-hovered, #2684FF)",
    'color.background.accent.blue.subtlest.pressed': "var(--ds-background-accent-blue-subtlest-pressed, #0065FF)",
    'color.background.accent.blue.subtler': "var(--ds-background-accent-blue-subtler, #2684FF)",
    'color.background.accent.blue.subtler.hovered': "var(--ds-background-accent-blue-subtler-hovered, #0065FF)",
    'color.background.accent.blue.subtler.pressed': "var(--ds-background-accent-blue-subtler-pressed, #0052CC)",
    'color.background.accent.blue.subtle': "var(--ds-background-accent-blue-subtle, #0052CC)",
    'color.background.accent.blue.subtle.hovered': "var(--ds-background-accent-blue-subtle-hovered, #0065FF)",
    'color.background.accent.blue.subtle.pressed': "var(--ds-background-accent-blue-subtle-pressed, #2684FF)",
    'color.background.accent.blue.bolder': "var(--ds-background-accent-blue-bolder, #0052CC)",
    'color.background.accent.blue.bolder.hovered': "var(--ds-background-accent-blue-bolder-hovered, #0065FF)",
    'color.background.accent.blue.bolder.pressed': "var(--ds-background-accent-blue-bolder-pressed, #2684FF)",
    'color.background.accent.purple.subtlest': "var(--ds-background-accent-purple-subtlest, #998DD9)",
    'color.background.accent.purple.subtlest.hovered': "var(--ds-background-accent-purple-subtlest-hovered, #8777D9)",
    'color.background.accent.purple.subtlest.pressed': "var(--ds-background-accent-purple-subtlest-pressed, #6554C0)",
    'color.background.accent.purple.subtler': "var(--ds-background-accent-purple-subtler, #8777D9)",
    'color.background.accent.purple.subtler.hovered': "var(--ds-background-accent-purple-subtler-hovered, #6554C0)",
    'color.background.accent.purple.subtler.pressed': "var(--ds-background-accent-purple-subtler-pressed, #5243AA)",
    'color.background.accent.purple.subtle': "var(--ds-background-accent-purple-subtle, #5243AA)",
    'color.background.accent.purple.subtle.hovered': "var(--ds-background-accent-purple-subtle-hovered, #6554C0)",
    'color.background.accent.purple.subtle.pressed': "var(--ds-background-accent-purple-subtle-pressed, #8777D9)",
    'color.background.accent.purple.bolder': "var(--ds-background-accent-purple-bolder, #5243AA)",
    'color.background.accent.purple.bolder.hovered': "var(--ds-background-accent-purple-bolder-hovered, #6554C0)",
    'color.background.accent.purple.bolder.pressed': "var(--ds-background-accent-purple-bolder-pressed, #8777D9)",
    'color.background.accent.magenta.subtlest': "var(--ds-background-accent-magenta-subtlest, #FFECF8)",
    'color.background.accent.magenta.subtlest.hovered': "var(--ds-background-accent-magenta-subtlest-hovered, #FDD0EC)",
    'color.background.accent.magenta.subtlest.pressed': "var(--ds-background-accent-magenta-subtlest-pressed, #F797D2)",
    'color.background.accent.magenta.subtler': "var(--ds-background-accent-magenta-subtler, #FDD0EC)",
    'color.background.accent.magenta.subtler.hovered': "var(--ds-background-accent-magenta-subtler-hovered, #F797D2)",
    'color.background.accent.magenta.subtler.pressed': "var(--ds-background-accent-magenta-subtler-pressed, #E774BB)",
    'color.background.accent.magenta.subtle': "var(--ds-background-accent-magenta-subtle, #E774BB)",
    'color.background.accent.magenta.subtle.hovered': "var(--ds-background-accent-magenta-subtle-hovered, #F797D2)",
    'color.background.accent.magenta.subtle.pressed': "var(--ds-background-accent-magenta-subtle-pressed, #FDD0EC)",
    'color.background.accent.magenta.bolder': "var(--ds-background-accent-magenta-bolder, #AE4787)",
    'color.background.accent.magenta.bolder.hovered': "var(--ds-background-accent-magenta-bolder-hovered, #943D73)",
    'color.background.accent.magenta.bolder.pressed': "var(--ds-background-accent-magenta-bolder-pressed, #50253F)",
    'color.background.accent.gray.subtlest': "var(--ds-background-accent-gray-subtlest, #6B778C)",
    'color.background.accent.gray.subtlest.hovered': "var(--ds-background-accent-gray-subtlest-hovered, #5E6C84)",
    'color.background.accent.gray.subtlest.pressed': "var(--ds-background-accent-gray-subtlest-pressed, #505F79)",
    'color.background.accent.gray.subtler': "var(--ds-background-accent-gray-subtler, #5E6C84)",
    'color.background.accent.gray.subtler.hovered': "var(--ds-background-accent-gray-subtler-hovered, #505F79)",
    'color.background.accent.gray.subtler.pressed': "var(--ds-background-accent-gray-subtler-pressed, #42526E)",
    'color.background.accent.gray.subtle': "var(--ds-background-accent-gray-subtle, #505F79)",
    'color.background.accent.gray.subtle.hovered': "var(--ds-background-accent-gray-subtle-hovered, #5E6C84)",
    'color.background.accent.gray.subtle.pressed': "var(--ds-background-accent-gray-subtle-pressed, #6B778C)",
    'color.background.accent.gray.bolder': "var(--ds-background-accent-gray-bolder, #42526E)",
    'color.background.accent.gray.bolder.hovered': "var(--ds-background-accent-gray-bolder-hovered, #344563)",
    'color.background.accent.gray.bolder.pressed': "var(--ds-background-accent-gray-bolder-pressed, #253858)",
    'color.background.disabled': "var(--ds-background-disabled, #091e4289)",
    'color.background.input': "var(--ds-background-input, #FAFBFC)",
    'color.background.input.hovered': "var(--ds-background-input-hovered, #EBECF0)",
    'color.background.input.pressed': "var(--ds-background-input-pressed, #FFFFFF)",
    'color.background.inverse.subtle': "var(--ds-background-inverse-subtle, #00000029)",
    'color.background.inverse.subtle.hovered': "var(--ds-background-inverse-subtle-hovered, #0000003D)",
    'color.background.inverse.subtle.pressed': "var(--ds-background-inverse-subtle-pressed, #00000052)",
    'color.background.neutral': "var(--ds-background-neutral, #DFE1E6)",
    'color.background.neutral.hovered': "var(--ds-background-neutral-hovered, #091e4214)",
    'color.background.neutral.pressed': "var(--ds-background-neutral-pressed, #B3D4FF)",
    'color.background.neutral.subtle': "var(--ds-background-neutral-subtle, transparent)",
    'color.background.neutral.subtle.hovered': "var(--ds-background-neutral-subtle-hovered, #091e4214)",
    'color.background.neutral.subtle.pressed': "var(--ds-background-neutral-subtle-pressed, #B3D4FF)",
    'color.background.neutral.bold': "var(--ds-background-neutral-bold, #42526E)",
    'color.background.neutral.bold.hovered': "var(--ds-background-neutral-bold-hovered, #505F79)",
    'color.background.neutral.bold.pressed': "var(--ds-background-neutral-bold-pressed, #344563)",
    'color.background.selected': "var(--ds-background-selected, #DEEBFF)",
    'color.background.selected.hovered': "var(--ds-background-selected-hovered, #B3D4FF)",
    'color.background.selected.pressed': "var(--ds-background-selected-pressed, #4C9AFF)",
    'color.background.selected.bold': "var(--ds-background-selected-bold, #0052CC)",
    'color.background.selected.bold.hovered': "var(--ds-background-selected-bold-hovered, #2684FF)",
    'color.background.selected.bold.pressed': "var(--ds-background-selected-bold-pressed, #0052CC)",
    'color.background.brand.subtlest': "var(--ds-background-brand-subtlest, #B3D4FF)",
    'color.background.brand.subtlest.hovered': "var(--ds-background-brand-subtlest-hovered, #DEEBFF)",
    'color.background.brand.subtlest.pressed': "var(--ds-background-brand-subtlest-pressed, #4C9AFF)",
    'color.background.brand.bold': "var(--ds-background-brand-bold, #0052CC)",
    'color.background.brand.bold.hovered': "var(--ds-background-brand-bold-hovered, #0065FF)",
    'color.background.brand.bold.pressed': "var(--ds-background-brand-bold-pressed, #0747A6)",
    'color.background.brand.boldest': "var(--ds-background-brand-boldest, #0747A6)",
    'color.background.brand.boldest.hovered': "var(--ds-background-brand-boldest-hovered, #0052CC)",
    'color.background.brand.boldest.pressed': "var(--ds-background-brand-boldest-pressed, #0747A6)",
    'color.background.danger': "var(--ds-background-danger, #FFEBE6)",
    'color.background.danger.hovered': "var(--ds-background-danger-hovered, #FFBDAD)",
    'color.background.danger.pressed': "var(--ds-background-danger-pressed, #FF8F73)",
    'color.background.danger.subtler': "var(--ds-background-danger-subtler, #FFBDAD)",
    'color.background.danger.subtler.hovered': "var(--ds-background-danger-subtler-hovered, #FF8F73)",
    'color.background.danger.subtler.pressed': "var(--ds-background-danger-subtler-pressed, #FF7452)",
    'color.background.danger.bold': "var(--ds-background-danger-bold, #DE350B)",
    'color.background.danger.bold.hovered': "var(--ds-background-danger-bold-hovered, #FF5630)",
    'color.background.danger.bold.pressed': "var(--ds-background-danger-bold-pressed, #BF2600)",
    'color.background.warning': "var(--ds-background-warning, #FFFAE6)",
    'color.background.warning.hovered': "var(--ds-background-warning-hovered, #FFF0B3)",
    'color.background.warning.pressed': "var(--ds-background-warning-pressed, #FFE380)",
    'color.background.warning.subtler': "var(--ds-background-warning-subtler, #FFF0B3)",
    'color.background.warning.subtler.hovered': "var(--ds-background-warning-subtler-hovered, #FFE380)",
    'color.background.warning.subtler.pressed': "var(--ds-background-warning-subtler-pressed, #FFC400)",
    'color.background.warning.bold': "var(--ds-background-warning-bold, #FFAB00)",
    'color.background.warning.bold.hovered': "var(--ds-background-warning-bold-hovered, #FFC400)",
    'color.background.warning.bold.pressed': "var(--ds-background-warning-bold-pressed, #FF991F)",
    'color.background.success': "var(--ds-background-success, #E3FCEF)",
    'color.background.success.hovered': "var(--ds-background-success-hovered, #ABF5D1)",
    'color.background.success.pressed': "var(--ds-background-success-pressed, #79F2C0)",
    'color.background.success.subtler': "var(--ds-background-success-subtler, #ABF5D1)",
    'color.background.success.subtler.hovered': "var(--ds-background-success-subtler-hovered, #79F2C0)",
    'color.background.success.subtler.pressed': "var(--ds-background-success-subtler-pressed, #57D9A3)",
    'color.background.success.bold': "var(--ds-background-success-bold, #00875A)",
    'color.background.success.bold.hovered': "var(--ds-background-success-bold-hovered, #57D9A3)",
    'color.background.success.bold.pressed': "var(--ds-background-success-bold-pressed, #00875A)",
    'color.background.discovery': "var(--ds-background-discovery, #EAE6FF)",
    'color.background.discovery.hovered': "var(--ds-background-discovery-hovered, #C0B6F2)",
    'color.background.discovery.pressed': "var(--ds-background-discovery-pressed, #998DD9)",
    'color.background.discovery.subtler': "var(--ds-background-discovery-subtler, #C0B6F2)",
    'color.background.discovery.subtler.hovered': "var(--ds-background-discovery-subtler-hovered, #998DD9)",
    'color.background.discovery.subtler.pressed': "var(--ds-background-discovery-subtler-pressed, #8777D9)",
    'color.background.discovery.bold': "var(--ds-background-discovery-bold, #5243AA)",
    'color.background.discovery.bold.hovered': "var(--ds-background-discovery-bold-hovered, #8777D9)",
    'color.background.discovery.bold.pressed': "var(--ds-background-discovery-bold-pressed, #5243AA)",
    'color.background.information': "var(--ds-background-information, #DEEBFF)",
    'color.background.information.hovered': "var(--ds-background-information-hovered, #B3D4FF)",
    'color.background.information.pressed': "var(--ds-background-information-pressed, #4C9AFF)",
    'color.background.information.subtler': "var(--ds-background-information-subtler, #B3D4FF)",
    'color.background.information.subtler.hovered': "var(--ds-background-information-subtler-hovered, #4C9AFF)",
    'color.background.information.subtler.pressed': "var(--ds-background-information-subtler-pressed, #2684FF)",
    'color.background.information.bold': "var(--ds-background-information-bold, #0052CC)",
    'color.background.information.bold.hovered': "var(--ds-background-information-bold-hovered, #2684FF)",
    'color.background.information.bold.pressed': "var(--ds-background-information-bold-pressed, #0052CC)",
    'color.blanket': "var(--ds-blanket, #091e4289)",
    'color.blanket.selected': "var(--ds-blanket-selected, #388BFF14)",
    'color.blanket.danger': "var(--ds-blanket-danger, #EF5C4814)",
    'color.skeleton': "var(--ds-skeleton, #F4F5F7)",
    'color.skeleton.subtle': "var(--ds-skeleton-subtle, #091e420a)",
    'elevation.surface': "var(--ds-surface, #FFFFFF)",
    'elevation.surface.hovered': "var(--ds-surface-hovered, #FAFBFC)",
    'elevation.surface.pressed': "var(--ds-surface-pressed, #F4F5F7)",
    'elevation.surface.overlay': "var(--ds-surface-overlay, #FFFFFF)",
    'elevation.surface.overlay.hovered': "var(--ds-surface-overlay-hovered, #FAFBFC)",
    'elevation.surface.overlay.pressed': "var(--ds-surface-overlay-pressed, #F4F5F7)",
    'elevation.surface.raised': "var(--ds-surface-raised, #FFFFFF)",
    'elevation.surface.raised.hovered': "var(--ds-surface-raised-hovered, #FAFBFC)",
    'elevation.surface.raised.pressed': "var(--ds-surface-raised-pressed, #F4F5F7)",
    'elevation.surface.sunken': "var(--ds-surface-sunken, #F4F5F7)",
    'utility.elevation.surface.current': "var(--ds-elevation-surface-current, #FFFFFF)"
};
var $118e387c67bd0da2$export$8473307aa00d6ea1 = {
    'color.text': "var(--ds-text, #172B4D)",
    'color.text.accent.lime': "var(--ds-text-accent-lime, #4C6B1F)",
    'color.text.accent.lime.bolder': "var(--ds-text-accent-lime-bolder, #37471F)",
    'color.text.accent.red': "var(--ds-text-accent-red, #DE350B)",
    'color.text.accent.red.bolder': "var(--ds-text-accent-red-bolder, #BF2600)",
    'color.text.accent.orange': "var(--ds-text-accent-orange, #F18D13)",
    'color.text.accent.orange.bolder': "var(--ds-text-accent-orange-bolder, #B65C02)",
    'color.text.accent.yellow': "var(--ds-text-accent-yellow, #FF991F)",
    'color.text.accent.yellow.bolder': "var(--ds-text-accent-yellow-bolder, #FF8B00)",
    'color.text.accent.green': "var(--ds-text-accent-green, #00875A)",
    'color.text.accent.green.bolder': "var(--ds-text-accent-green-bolder, #006644)",
    'color.text.accent.teal': "var(--ds-text-accent-teal, #00A3BF)",
    'color.text.accent.teal.bolder': "var(--ds-text-accent-teal-bolder, #008DA6)",
    'color.text.accent.blue': "var(--ds-text-accent-blue, #0052CC)",
    'color.text.accent.blue.bolder': "var(--ds-text-accent-blue-bolder, #0747A6)",
    'color.text.accent.purple': "var(--ds-text-accent-purple, #5243AA)",
    'color.text.accent.purple.bolder': "var(--ds-text-accent-purple-bolder, #403294)",
    'color.text.accent.magenta': "var(--ds-text-accent-magenta, #E774BB)",
    'color.text.accent.magenta.bolder': "var(--ds-text-accent-magenta-bolder, #DA62AC)",
    'color.text.accent.gray': "var(--ds-text-accent-gray, #505F79)",
    'color.text.accent.gray.bolder': "var(--ds-text-accent-gray-bolder, #172B4D)",
    'color.text.disabled': "var(--ds-text-disabled, #A5ADBA)",
    'color.text.inverse': "var(--ds-text-inverse, #FFFFFF)",
    'color.text.selected': "var(--ds-text-selected, #0052CC)",
    'color.text.brand': "var(--ds-text-brand, #0065FF)",
    'color.text.danger': "var(--ds-text-danger, #DE350B)",
    'color.text.danger.bolder': "var(--ds-text-danger-bolder, #BF2600)",
    'color.text.warning': "var(--ds-text-warning, #974F0C)",
    'color.text.warning.inverse': "var(--ds-text-warning-inverse, #172B4D)",
    'color.text.warning.bolder': "var(--ds-text-warning-bolder, #974F0C)",
    'color.text.success': "var(--ds-text-success, #006644)",
    'color.text.success.bolder': "var(--ds-text-success-bolder, #006644)",
    'color.text.discovery': "var(--ds-text-discovery, #403294)",
    'color.text.discovery.bolder': "var(--ds-text-discovery-bolder, #403294)",
    'color.text.information': "var(--ds-text-information, #0052CC)",
    'color.text.information.bolder': "var(--ds-text-information-bolder, #0747A6)",
    'color.text.subtlest': "var(--ds-text-subtlest, #7A869A)",
    'color.text.subtle': "var(--ds-text-subtle, #42526E)",
    'color.link': "var(--ds-link, #0052CC)",
    'color.link.pressed': "var(--ds-link-pressed, #0747A6)",
    'color.link.visited': "var(--ds-link-visited, #403294)",
    'color.link.visited.pressed': "var(--ds-link-visited-pressed, #403294)"
};
var $118e387c67bd0da2$export$498780f74be9af68 = {
    'color.icon': "var(--ds-icon, #505F79)",
    'color.icon.accent.lime': "var(--ds-icon-accent-lime, #6A9A23)",
    'color.icon.accent.red': "var(--ds-icon-accent-red, #FF5630)",
    'color.icon.accent.orange': "var(--ds-icon-accent-orange, #D94008)",
    'color.icon.accent.yellow': "var(--ds-icon-accent-yellow, #FFAB00)",
    'color.icon.accent.green': "var(--ds-icon-accent-green, #36B37E)",
    'color.icon.accent.teal': "var(--ds-icon-accent-teal, #00B8D9)",
    'color.icon.accent.blue': "var(--ds-icon-accent-blue, #0065FF)",
    'color.icon.accent.purple': "var(--ds-icon-accent-purple, #6554C0)",
    'color.icon.accent.magenta': "var(--ds-icon-accent-magenta, #CD519D)",
    'color.icon.accent.gray': "var(--ds-icon-accent-gray, #5E6C84)",
    'color.icon.disabled': "var(--ds-icon-disabled, #8993A4)",
    'color.icon.inverse': "var(--ds-icon-inverse, #FFFFFF)",
    'color.icon.selected': "var(--ds-icon-selected, #0052CC)",
    'color.icon.brand': "var(--ds-icon-brand, #0065FF)",
    'color.icon.danger': "var(--ds-icon-danger, #DE350B)",
    'color.icon.warning': "var(--ds-icon-warning, #FFC400)",
    'color.icon.warning.inverse': "var(--ds-icon-warning-inverse, #253858)",
    'color.icon.success': "var(--ds-icon-success, #00875A)",
    'color.icon.discovery': "var(--ds-icon-discovery, #8777D9)",
    'color.icon.information': "var(--ds-icon-information, #0747A6)",
    'color.icon.subtlest': "var(--ds-icon-subtlest, #6B778C)",
    'color.icon.subtle': "var(--ds-icon-subtle, #6B778C)"
};
var $118e387c67bd0da2$export$b5f31a7e431d2eab = {
    '1': 1,
    card: 100,
    navigation: 200,
    dialog: 300,
    layer: 400,
    blanket: 500,
    modal: 510,
    flag: 600,
    spotlight: 700,
    tooltip: 800
};
var $118e387c67bd0da2$export$e1b83c5210c471b8 = {
    'border.width': "var(--ds-border-width, 1px)",
    'border.width.selected': "var(--ds-border-width-selected, 2px)",
    'border.width.focused': "var(--ds-border-width-focused, 2px)"
};
var $118e387c67bd0da2$export$3c0a6c3e64bb180d = {
    'radius.xsmall': "var(--ds-radius-xsmall, 2px)",
    'radius.small': "var(--ds-radius-small, 3px)",
    'radius.medium': "var(--ds-radius-medium, 6px)",
    'radius.large': "var(--ds-radius-large, 8px)",
    'radius.xlarge': "var(--ds-radius-xlarge, 12px)",
    'radius.xxlarge': "var(--ds-radius-xxlarge, 16px)",
    'radius.full': "var(--ds-radius-full, 9999px)",
    'radius.tile': "var(--ds-radius-tile, 25%)"
};
var $118e387c67bd0da2$export$6ffa317d5e70375 = {
    'font.body': "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.body.UNSAFE_small': "var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.body.large': "var(--ds-font-body-large, normal 400 16px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.body.small': "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.code': "var(--ds-font-code, normal 400 0.875em/1 ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)",
    'font.heading.large': "var(--ds-font-heading-large, normal 500 24px/28px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.heading.medium': "var(--ds-font-heading-medium, normal 500 20px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.heading.small': "var(--ds-font-heading-small, normal 600 16px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.heading.xlarge': "var(--ds-font-heading-xlarge, normal 600 29px/32px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.heading.xsmall': "var(--ds-font-heading-xsmall, normal 600 14px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.heading.xxlarge': "var(--ds-font-heading-xxlarge, normal 500 35px/40px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.heading.xxsmall': "var(--ds-font-heading-xxsmall, normal 600 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.metric.large': "var(--ds-font-metric-large, normal 653 28px/32px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.metric.medium': "var(--ds-font-metric-medium, normal 653 24px/28px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.metric.small': "var(--ds-font-metric-small, normal 653 16px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
};
var $118e387c67bd0da2$export$303e322c6b1ed114 = {
    'font.weight.bold': "var(--ds-font-weight-bold, 700)",
    'font.weight.medium': "var(--ds-font-weight-medium, 500)",
    'font.weight.regular': "var(--ds-font-weight-regular, 400)",
    'font.weight.semibold': "var(--ds-font-weight-semibold, 600)"
};
var $118e387c67bd0da2$export$3c7e9587132614b4 = {
    'font.family.body': "var(--ds-font-family-body, ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.family.brand.body': "var(--ds-font-family-brand-body, \"Charlie Text\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.family.brand.heading': "var(--ds-font-family-brand-heading, \"Charlie Display\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.family.code': "var(--ds-font-family-code, ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)",
    'font.family.heading': "var(--ds-font-family-heading, ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
};
var $118e387c67bd0da2$export$236bfe3a33ef1292 = {
    medium: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    UNSAFE_small: "var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    large: "var(--ds-font-body-large, normal 400 16px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    small: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
};
var $118e387c67bd0da2$export$855cfd311192d666 = {
    bold: "var(--ds-font-weight-bold, 700)",
    medium: "var(--ds-font-weight-medium, 500)",
    regular: "var(--ds-font-weight-regular, 400)",
    semibold: "var(--ds-font-weight-semibold, 600)"
};
var $118e387c67bd0da2$export$b805719bc8cb376 = {
    large: "var(--ds-font-metric-large, normal 653 28px/32px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    medium: "var(--ds-font-metric-medium, normal 653 24px/28px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    small: "var(--ds-font-metric-small, normal 653 16px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
};
/**
 * @codegenEnd
 */ // Margin needs some bespoke types: https://atlassian.slack.com/archives/CKRHB23K8/p1712623192772909
// Generate maps for Box props. backgroundColor, padding, etc
var $118e387c67bd0da2$var$spacingProperties = [
    // Used by Box
    'padding',
    'paddingBlock',
    'paddingBlockStart',
    'paddingBlockEnd',
    'paddingInline',
    'paddingInlineStart',
    'paddingInlineEnd',
    // Used by Inline and Stack
    'gap',
    'rowGap',
    'columnGap'
];
var $118e387c67bd0da2$export$ca0f9c2de39ffed7 = function getSerializedStylesMap(cssProperty, tokenMap) {
    return Object.keys(tokenMap).reduce(function(emotionSpacingMap, token) {
        // eslint-disable-next-line @repo/internal/styles/no-exported-styles
        emotionSpacingMap[token] = (0, $74Zh5.css)((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, cssProperty, tokenMap[token]));
        return emotionSpacingMap;
    }, {});
};
var $118e387c67bd0da2$export$e615f061ca585a6c = $118e387c67bd0da2$var$spacingProperties.reduce(function(styleMap, spacingProperty) {
    styleMap[spacingProperty] = $118e387c67bd0da2$export$ca0f9c2de39ffed7(spacingProperty, $118e387c67bd0da2$export$958d0ae7f2977ae4);
    return styleMap;
}, {});
var $118e387c67bd0da2$export$bf46c3f9eeafc71f = $118e387c67bd0da2$var$spacingProperties.reduce(function(styleMap, spacingProperty) {
    styleMap[spacingProperty] = $118e387c67bd0da2$export$ca0f9c2de39ffed7(spacingProperty, $118e387c67bd0da2$export$958d0ae7f2977ae4);
    return styleMap;
}, {});
var $118e387c67bd0da2$export$e7af83bafe7f9e63 = $118e387c67bd0da2$export$ca0f9c2de39ffed7('backgroundColor', $118e387c67bd0da2$export$d1d79bf68ac056bd);
var $118e387c67bd0da2$export$3a1bcba60b23d7f0 = $118e387c67bd0da2$export$ca0f9c2de39ffed7('color', $118e387c67bd0da2$export$8473307aa00d6ea1);
var $118e387c67bd0da2$export$45f3f4fe16f9f7d5 = $118e387c67bd0da2$export$ca0f9c2de39ffed7('fontWeight', $118e387c67bd0da2$export$303e322c6b1ed114);
var $118e387c67bd0da2$export$68cc305da27dbaa4 = $118e387c67bd0da2$export$ca0f9c2de39ffed7('fontFamily', $118e387c67bd0da2$export$3c7e9587132614b4);
var $118e387c67bd0da2$export$128f10c238242f83 = $118e387c67bd0da2$export$ca0f9c2de39ffed7('font', $118e387c67bd0da2$export$6ffa317d5e70375);
var $118e387c67bd0da2$export$219d364c0da35ae4 = $118e387c67bd0da2$export$ca0f9c2de39ffed7('font', $118e387c67bd0da2$export$236bfe3a33ef1292);
var $118e387c67bd0da2$export$38845ca010b93505 = $118e387c67bd0da2$export$ca0f9c2de39ffed7('fontWeight', $118e387c67bd0da2$export$855cfd311192d666);
var $118e387c67bd0da2$export$ff257d957d48c421 = $118e387c67bd0da2$export$ca0f9c2de39ffed7((0, $idDoJ.CURRENT_SURFACE_CSS_VAR), $118e387c67bd0da2$export$41a358c9c2356760);
var $118e387c67bd0da2$export$5e65a44e5b6ecadb = function isSurfaceColorToken(color) {
    return $118e387c67bd0da2$export$41a358c9c2356760[color] !== undefined;
};
var $118e387c67bd0da2$export$7001ce64d9ff7c7f = $118e387c67bd0da2$export$ca0f9c2de39ffed7('font', $118e387c67bd0da2$export$b805719bc8cb376);

});
parcelRegister("idDoJ", function(module, exports) {
$parcel$export(module.exports, "CURRENT_SURFACE_CSS_VAR", () => $d438007942e1f40e$export$9d7b58831ae93caa);
var $d438007942e1f40e$export$4ef52930e33717cd = 'data-theme';
var $d438007942e1f40e$export$a00eac3f8684bcd0 = 'data-color-mode';
var $d438007942e1f40e$export$2112803007239c61 = 'data-contrast-mode';
var $d438007942e1f40e$export$352e418ed5b6193a = 'data-custom-theme';
var $d438007942e1f40e$export$6f0c6fb8c80fcc92 = 'ds';
var $d438007942e1f40e$export$4d0c7bbf80185957 = [
    'opacity',
    'font',
    'space',
    'border',
    'radius'
];
var $d438007942e1f40e$export$dddac1532e822863 = "--".concat($d438007942e1f40e$export$6f0c6fb8c80fcc92, "-token-not-found");
var $d438007942e1f40e$export$9d7b58831ae93caa = "--".concat($d438007942e1f40e$export$6f0c6fb8c80fcc92, "-elevation-surface-current");

});


parcelRegister("bemp3", function(module, exports) {
$parcel$export(module.exports, "SurfaceContext", () => $82d2614f68639fbf$export$1ca2a26fecb070ae);
$parcel$export(module.exports, "useSurface", () => $82d2614f68639fbf$export$1aeb4f6b93c4540d);

var $5FkrB = parcelRequire("5FkrB");
var $82d2614f68639fbf$export$1ca2a26fecb070ae = /*#__PURE__*/ (0, $5FkrB.createContext)('elevation.surface');
var $82d2614f68639fbf$export$1aeb4f6b93c4540d = function useSurface() {
    return (0, $5FkrB.useContext)($82d2614f68639fbf$export$1ca2a26fecb070ae);
};
$82d2614f68639fbf$export$1ca2a26fecb070ae.displayName = 'SurfaceProvider';

});

parcelRegister("6zfDF", function(module, exports) {
$parcel$export(module.exports, "useHeading", () => $4c82247c56d8bc2b$export$97a37b1befbbf9b1);

var $5FkrB = parcelRequire("5FkrB");
// Allows support for heading levels 1-9 via aria-level
var $4c82247c56d8bc2b$var$HeadingLevelContext = /*#__PURE__*/ (0, $5FkrB.createContext)(0);
/**
 * @internal
 * @returns The current heading level context.
 */ var $4c82247c56d8bc2b$var$useHeadingLevel = function useHeadingLevel() {
    return (0, $5FkrB.useContext)($4c82247c56d8bc2b$var$HeadingLevelContext);
};
var $4c82247c56d8bc2b$export$97a37b1befbbf9b1 = function useHeading(fallback) {
    var hLevel = $4c82247c56d8bc2b$var$useHeadingLevel();
    /**
   * Order here is important, we for now apply
   * 1. inferred a11y level (this only applies if context is present)
   * 2. default final fallback
   */ return [
        hLevel,
        hLevel && (hLevel > 6 ? 'div' : "h".concat(hLevel)) || fallback
    ];
};
/**
 * __Heading level provider__
 *
 * The Heading level provider injects the heading level to all `Heading` components below it in the component tree.
 *
 * @example
 * ```tsx
 * // Will correctly infer the heading level
 * <HeadingContext value={1}>
 *  <Heading>H1</Heading>
 *  <HeadingContext>
 *    <Heading>H2</Heading>
 *  </HeadingContext>
 * </HeadingContext>
 * ```
 */ var $4c82247c56d8bc2b$var$HeadingLevelContextProvider = function HeadingLevelContextProvider(_ref) {
    var children = _ref.children, value = _ref.value;
    var parentHeadingLevel = $4c82247c56d8bc2b$var$useHeadingLevel();
    var headingLevel = parentHeadingLevel + 1;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement($4c82247c56d8bc2b$var$HeadingLevelContext.Provider, {
        value: value || headingLevel
    }, children);
};
var $4c82247c56d8bc2b$export$2e2bcd8739ae039 = $4c82247c56d8bc2b$var$HeadingLevelContextProvider;

});


parcelRegister("j7gwl", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a2c17176afeb2169f76dc501092efdf0>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $deab7c6cee7697b3$var$_react = $deab7c6cee7697b3$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $deab7c6cee7697b3$var$_cross = $deab7c6cee7697b3$var$_interopRequireDefault((parcelRequire("ac8VW")));

var $deab7c6cee7697b3$var$_cross2 = $deab7c6cee7697b3$var$_interopRequireDefault((parcelRequire("9fPWo")));
function $deab7c6cee7697b3$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for CrossIcon.
 * This component is CrossIcon, with `UNSAFE_fallbackIcon` set to "CrossIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Known uses: closing modals, panels, and transient views; removing tags
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $deab7c6cee7697b3$var$CrossIcon = (props)=>/*#__PURE__*/ $deab7c6cee7697b3$var$_react.default.createElement($deab7c6cee7697b3$var$_cross.default, Object.assign({
        name: "CrossIcon",
        LEGACY_fallbackIcon: $deab7c6cee7697b3$var$_cross2.default
    }, props));
$deab7c6cee7697b3$var$CrossIcon.displayName = 'CrossIconMigration';
var $deab7c6cee7697b3$var$_default = module.exports.default = $deab7c6cee7697b3$var$CrossIcon;

});
parcelRegister("ac8VW", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::13080645a1b889dca339823c8ecd9929>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $76c1f46438176f91$var$_react = $76c1f46438176f91$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $76c1f46438176f91$var$_baseNew = $76c1f46438176f91$var$_interopRequireDefault((parcelRequire("axuVY")));
function $76c1f46438176f91$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Cross".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Known uses: closing modals, panels, and transient views; removing tags
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $76c1f46438176f91$var$CrossIcon = (props)=>/*#__PURE__*/ $76c1f46438176f91$var$_react.default.createElement($76c1f46438176f91$var$_baseNew.default, Object.assign({
        name: "CrossIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M14.03 3.03 9.06 8l4.97 4.97-1.06 1.06L8 9.06l-4.97 4.97-1.06-1.06L6.94 8 1.97 3.03l1.06-1.06L8 6.94l4.97-4.97z"/>`
    }, props));
$76c1f46438176f91$var$CrossIcon.displayName = 'CrossIcon';
var $76c1f46438176f91$var$_default = module.exports.default = $76c1f46438176f91$var$CrossIcon;

});
parcelRegister("axuVY", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => (parcelRequire("gDzom")).default);
$parcel$export(module.exports, "Icon", () => (parcelRequire("gDzom")).Icon);

var $gDzom = parcelRequire("gDzom");

});
parcelRegister("gDzom", function(module, exports) {
$parcel$export(module.exports, "Icon", () => $c1cbbdf3204a3ef0$export$f04a61298a47a40f);
$parcel$export(module.exports, "default", () => $c1cbbdf3204a3ef0$export$2e2bcd8739ae039);
/* icon-new.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");

var $9Zzpd = parcelRequire("9Zzpd");
/**
 * We are hiding this props from consumers as it's reserved
 * for use by Icon Tile.
 */ var $c1cbbdf3204a3ef0$var$svgStyles = null;
var $c1cbbdf3204a3ef0$var$iconStyles = null;
var $c1cbbdf3204a3ef0$var$smallIconStyles = null;
var $c1cbbdf3204a3ef0$var$scaleStyles = null;
/**
 * For windows high contrast mode
 */ var $c1cbbdf3204a3ef0$var$baseHcmStyles = null;
var $c1cbbdf3204a3ef0$var$scaleSize = null;
var $c1cbbdf3204a3ef0$var$coreSizeMedium = {
    none: "_1bsbpxbi _4t3ipxbi",
    compact: "_1bsb1ejb _4t3i1ejb",
    spacious: "_1bsb1ejb _4t3i1ejb"
};
var $c1cbbdf3204a3ef0$var$coreSizeSmall = {
    none: "_1bsbutpp _4t3iutpp",
    compact: "_1bsbpxbi _4t3ipxbi",
    spacious: "_1bsb1ejb _4t3i1ejb"
};
var $c1cbbdf3204a3ef0$var$paddingMap = {
    medium: {
        none: 0,
        compact: 4,
        spacious: 4
    },
    small: {
        none: 0,
        compact: 2.66,
        spacious: 8
    }
};
var $c1cbbdf3204a3ef0$export$f04a61298a47a40f = /*#__PURE__*/ (0, $5FkrB.memo)(function Icon(props) {
    var _ref = props, _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, testId = _ref.testId, label = _ref.label, LEGACY_primaryColor = _ref.LEGACY_primaryColor, LEGACY_secondaryColor = _ref.LEGACY_secondaryColor, LEGACY_size = _ref.LEGACY_size, FallbackIcon = _ref.LEGACY_fallbackIcon, dangerouslySetGlyph = _ref.dangerouslySetGlyph, shouldScale = _ref.shouldScale, LEGACY_margin = _ref.LEGACY_margin, _ref$spacing = _ref.spacing, spacing = _ref$spacing === void 0 ? 'none' : _ref$spacing, name = _ref.name;
    var dangerouslySetInnerHTML = dangerouslySetGlyph ? {
        __html: dangerouslySetGlyph
    } : undefined;
    // Fall back to old icon
    if (FallbackIcon && !(0, $9Zzpd.fg)('platform-visual-refresh-icons')) // parse out unnecessary props
    return /*#__PURE__*/ $5FkrB.createElement(FallbackIcon, {
        primaryColor: LEGACY_primaryColor !== null && LEGACY_primaryColor !== void 0 ? LEGACY_primaryColor : color,
        secondaryColor: LEGACY_secondaryColor,
        size: LEGACY_size,
        label: label,
        testId: testId,
        UNSAFE_margin: LEGACY_margin
    });
    var size = 'medium';
    if ('size' in props && props.size !== undefined) {
        if (typeof props.size === 'string') size = props.size === 'small' || props.size === 'medium' ? props.size : size;
        else if (name) {
            var newSize = props.size(name);
            size = newSize === 'small' || newSize === 'medium' ? newSize : size;
        }
    }
    var baseSize = 16;
    var viewBoxPadding = $c1cbbdf3204a3ef0$var$paddingMap[size][spacing];
    var viewBoxSize = baseSize + 2 * viewBoxPadding;
    return /*#__PURE__*/ $5FkrB.createElement("span", {
        "data-testid": testId,
        role: label ? 'img' : undefined,
        "aria-label": label ? label : undefined,
        "aria-hidden": label ? undefined : true,
        style: {
            color: color
        },
        className: (0, $970q7.default)([
            "_1e0c1o8l _vchhusvi _1o9zidpf _vwz4kb7n _y4ti1igz _bozg1mb9",
            "_12va1onz _jcxd1r8n",
            shouldScale && "_1bsb1kw7 _4t3i1kw7",
            size === 'small' && "_vwz4utpp"
        ])
    }, /*#__PURE__*/ $5FkrB.createElement("svg", {
        fill: "none",
        viewBox: "".concat(0 - viewBoxPadding, " ").concat(0 - viewBoxPadding, " ").concat(viewBoxSize, " ").concat(viewBoxSize),
        role: "presentation",
        dangerouslySetInnerHTML: dangerouslySetInnerHTML,
        className: (0, $970q7.default)([
            "_1reo15vq _18m915vq _syaz1r31 _lcxvglyw _s7n4yfq0 _vc881r31",
            shouldScale ? "_1bsb1kw7 _4t3i1kw7" : size === 'small' ? $c1cbbdf3204a3ef0$var$coreSizeSmall[spacing] : $c1cbbdf3204a3ef0$var$coreSizeMedium[spacing]
        ])
    }));
});
var $c1cbbdf3204a3ef0$export$2e2bcd8739ae039 = $c1cbbdf3204a3ef0$export$f04a61298a47a40f;

});



parcelRegister("9fPWo", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6bcdce1e93e39ea9$var$_react = $6bcdce1e93e39ea9$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $2SuPM = parcelRequire("2SuPM");
function $6bcdce1e93e39ea9$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $6bcdce1e93e39ea9$var$CrossIcon = (props)=>/*#__PURE__*/ $6bcdce1e93e39ea9$var$_react.default.createElement($2SuPM.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M12 10.586 6.707 5.293a1 1 0 0 0-1.414 1.414L10.586 12l-5.293 5.293a1 1 0 0 0 1.414 1.414L12 13.414l5.293 5.293a1 1 0 0 0 1.414-1.414L13.414 12l5.293-5.293a1 1 0 1 0-1.414-1.414z"/></svg>`
    }, props));
$6bcdce1e93e39ea9$var$CrossIcon.displayName = 'CrossIcon';
var $6bcdce1e93e39ea9$var$_default = module.exports.default = $6bcdce1e93e39ea9$var$CrossIcon;

});
parcelRegister("2SuPM", function(module, exports) {
$parcel$export(module.exports, "Icon", () => $21888af2d2e194e9$export$f04a61298a47a40f);
$parcel$export(module.exports, "default", () => $21888af2d2e194e9$export$2e2bcd8739ae039);
/* icon.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $kqp0i = parcelRequire("kqp0i");

var $25nEq = parcelRequire("25nEq");

var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");
function $21888af2d2e194e9$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $21888af2d2e194e9$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $21888af2d2e194e9$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $21888af2d2e194e9$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
/**
 * We are hiding these props from consumers as they're used to
 * hack around icon sizing specifically for icon-file-type.
 */ var $21888af2d2e194e9$var$iconStyles = null;
var $21888af2d2e194e9$var$sizeStyles = {
    small: "_1bsb7vkz _4t3i7vkz _5fdi7vkz _zbji7vkz",
    medium: "_1bsb1tcg _4t3i1tcg _5fdi1tcg _zbji1tcg",
    large: "_1bsbzwfg _4t3izwfg _5fdizwfg _zbjizwfg",
    xlarge: "_1bsbckbl _4t3ickbl _5fdickbl _zbjickbl"
};
/**
 * For windows high contrast mode
 */ var $21888af2d2e194e9$var$baseHcmStyles = null;
var $21888af2d2e194e9$var$primaryEqualsSecondaryHcmStyles = null;
var $21888af2d2e194e9$var$secondaryTransparentHcmStyles = null;
var $21888af2d2e194e9$export$f04a61298a47a40f = /*#__PURE__*/ (0, $5FkrB.memo)(function Icon(props) {
    var _ref = props, Glyph = _ref.glyph, dangerouslySetGlyph = _ref.dangerouslySetGlyph, _ref$primaryColor = _ref.primaryColor, primaryColor = _ref$primaryColor === void 0 ? 'currentColor' : _ref$primaryColor, secondaryColor = _ref.secondaryColor, size = _ref.size, testId = _ref.testId, label = _ref.label, width = _ref.width, height = _ref.height, UNSAFE_margin = _ref.UNSAFE_margin;
    var glyphProps = dangerouslySetGlyph ? {
        dangerouslySetInnerHTML: {
            __html: dangerouslySetGlyph
        }
    } : {
        children: Glyph ? /*#__PURE__*/ $5FkrB.createElement(Glyph, {
            role: "presentation"
        }) : null
    };
    var customDimensions = width && height ? {
        width: width + 'px',
        height: height + 'px'
    } : null;
    return /*#__PURE__*/ $5FkrB.createElement("span", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        "data-testid": testId,
        "data-vc": "icon-".concat(testId),
        role: label ? 'img' : undefined,
        "aria-label": label ? label : undefined,
        "aria-hidden": label ? undefined : true,
        style: $21888af2d2e194e9$var$_objectSpread($21888af2d2e194e9$var$_objectSpread({}, customDimensions), {}, {
            '--icon-primary-color': primaryColor,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            '--icon-secondary-color': secondaryColor,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            margin: UNSAFE_margin
        })
    }, glyphProps, {
        className: (0, $970q7.default)([
            "_1e0c1o8l _1o9zidpf _vyfuvuon _vwz4kb7n _1szv15vq _1tly15vq _rzyw1osq _17jb1osq _1ksvoz0e _3se1x1jp _re2rglyw _1veoyfq0 _1kg81r31",
            "_jcxd1r8n _gq0g1onz _1trkwc43",
            primaryColor === secondaryColor && "_18hbwc43",
            secondaryColor === 'transparent' && "_4fyi1j28",
            size && $21888af2d2e194e9$var$sizeStyles[size]
        ])
    }));
});
var $21888af2d2e194e9$export$2e2bcd8739ae039 = $21888af2d2e194e9$export$f04a61298a47a40f;

});



parcelRegister("9KL0W", function(module, exports) {
$parcel$export(module.exports, "default", () => $719ce0f2ce4e24d3$export$2e2bcd8739ae039);
/* inline.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $kqp0i = parcelRequire("kqp0i");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");

var $imej5 = parcelRequire("imej5");

var $bF5Ex = parcelRequire("bF5Ex");
var $719ce0f2ce4e24d3$var$_excluded = [
    "as",
    "alignInline",
    "alignBlock",
    "shouldWrap",
    "spread",
    "grow",
    "space",
    "rowSpace",
    "separator",
    "xcss",
    "testId",
    "role",
    "children"
];
var $719ce0f2ce4e24d3$var$styles = {
    separator: "_1mouze3t _195g1i6y _syazjjyb _lcxvglyw _uiztglyw",
    hug: "_16jlidpf",
    fill: "_1bsb1osq _16jlkb7n"
};
var $719ce0f2ce4e24d3$var$Separator = function Separator(_ref) {
    var children = _ref.children;
    return /*#__PURE__*/ $5FkrB.createElement("span", {
        className: (0, $970q7.default)([
            $719ce0f2ce4e24d3$var$styles.separator
        ])
    }, children);
};
/**
 * __Inline__
 *
 * Inline is a primitive component based on CSS Flexbox that manages the horizontal layout of direct children.
 *
 * @example
 * ```tsx
 *  <Inline>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *  </Inline>
 * ```
 *
 */ var $719ce0f2ce4e24d3$var$Inline = /*#__PURE__*/ (0, $5FkrB.memo)(/*#__PURE__*/ (0, $5FkrB.forwardRef)(function(_ref2, ref) {
    var as = _ref2.as, alignInline = _ref2.alignInline, _ref2$alignBlock = _ref2.alignBlock, alignItems = _ref2$alignBlock === void 0 ? 'start' : _ref2$alignBlock, _ref2$shouldWrap = _ref2.shouldWrap, shouldWrap = _ref2$shouldWrap === void 0 ? false : _ref2$shouldWrap, spread = _ref2.spread, grow = _ref2.grow, space = _ref2.space, rowSpace = _ref2.rowSpace, separator = _ref2.separator, xcss = _ref2.xcss, testId = _ref2.testId, role = _ref2.role, rawChildren = _ref2.children, ariaAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref2, $719ce0f2ce4e24d3$var$_excluded);
    var separatorComponent = typeof separator === 'string' ? /*#__PURE__*/ $5FkrB.createElement($719ce0f2ce4e24d3$var$Separator, null, separator) : separator;
    var children = separatorComponent ? (0, $5FkrB.Children).toArray(rawChildren).filter(Boolean).map(function(child, index) {
        return /*#__PURE__*/ $5FkrB.createElement((0, $5FkrB.Fragment), {
            key: index
        }, separator && index > 0 ? separatorComponent : null, child);
    }) : rawChildren;
    return /*#__PURE__*/ $5FkrB.createElement((0, $bF5Ex.default), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, ariaAttributes, {
        as: as,
        role: role,
        alignItems: alignItems,
        justifyContent: spread || alignInline,
        direction: "row",
        gap: space,
        rowGap: rowSpace,
        wrap: shouldWrap ? 'wrap' : undefined,
        xcss: (0, $imej5.cx)(grow === 'hug' && $719ce0f2ce4e24d3$var$styles.hug, grow === 'fill' && $719ce0f2ce4e24d3$var$styles.fill, xcss),
        testId: testId,
        ref: ref
    }), children);
}));
$719ce0f2ce4e24d3$var$Inline.displayName = 'Inline';
var $719ce0f2ce4e24d3$export$2e2bcd8739ae039 = $719ce0f2ce4e24d3$var$Inline;

});
parcelRegister("imej5", function(module, exports) {
$parcel$export(module.exports, "cx", () => $d5d5611a26f9f86e$export$a274e22fb40f762e);
/* index.tsx generated by @compiled/babel-plugin v0.38.1 */ parcelRequire("5FkrB");


var $Pd8py = parcelRequire("Pd8py");
var $d5d5611a26f9f86e$var$strictApi = (0, $Pd8py.createStrictAPI)();
var $d5d5611a26f9f86e$export$dbf350e5966cf602 = $d5d5611a26f9f86e$var$strictApi.css;
var $d5d5611a26f9f86e$export$eb1ecd84a24ee424 = $d5d5611a26f9f86e$var$strictApi.cssMap;
$d5d5611a26f9f86e$var$strictApi.cssMap;
var $d5d5611a26f9f86e$export$a274e22fb40f762e = $d5d5611a26f9f86e$var$strictApi.cx;
var $d5d5611a26f9f86e$var$XCSSProp = $d5d5611a26f9f86e$var$strictApi.XCSSProp; // This is to mitigate local TS error TS2315: Type 'StrictXCSSProp' is not generic.
 // Currently for some reason tsc is generating malformed .d.ts in local dev environment, below change fixes it
 /**
 * ## StrictXCSSProp
 *
 * Declare styles your component takes with all other styles marked as violations
 * by the TypeScript compiler. There are two primary use cases for xcss prop:
 *
 * - safe style overrides
 * - inverting style declarations
 *
 * Interverting style declarations is interesting for platform teams as
 * it means apps only pay for styles they use as they're now the ones who declare
 * the styles!
 *
 * The {@link StrictXCSSProp} type has generics two of which must be defined — use to explicitly
 * set what you want to maintain as API. Use {@link XCSSAllProperties} and {@link XCSSAllPseudos}
 * to enable all properties and pseudos.
 *
 * The third generic is used to declare what properties and pseudos should be required.
 *
 * ```tsx
 * interface MyComponentProps {
 *   // Color is accepted, all other properties / pseudos are considered violations.
 *   xcss?: StrictXCSSProp<'color', never>;
 *
 *   // Only background color and hover pseudo are accepted.
 *   xcss?: StrictXCSSProp<'backgroundColor', '&:hover'>;
 *
 *   // All properties are accepted, all pseudos are considered violations.
 *   xcss?: StrictXCSSProp<XCSSAllProperties, never>;
 *
 *   // All properties are accepted, only the hover pseudo is accepted.
 *   xcss?: StrictXCSSProp<XCSSAllProperties, '&:hover'>;
 *
 *   // The xcss prop is required as well as the color property. No pseudos are required.
 *   xcss: StrictXCSSProp<
 *     XCSSAllProperties,
 *     '&:hover',
 *     { requiredProperties: 'color', requiredPseudos: never }
 *   >;
 * }
 *
 * function MyComponent({ xcss }: MyComponentProps) {
 *   return <div css={{ color: 'var(--ds-text-danger)' }} className={xcss} />
 * }
 * ```
 *
 * The xcss prop works with static inline objects and the [cssMap](https://compiledcssinjs.com/docs/api-cssmap) API.
 *
 * ```jsx
 * // Declared as an inline object
 * <Component xcss={{ color: 'var(--ds-text)' }} />
 *
 * // Declared with the cssMap API
 * const styles = cssMap({ text: { color: 'var(--ds-text)' } });
 * <Component xcss={styles.text} />
 * ```
 *
 * To concatenate and conditonally apply styles use the {@link cssMap} and {@link cx} functions.
 */ 

});

parcelRegister("bF5Ex", function(module, exports) {
$parcel$export(module.exports, "default", () => $87d7e898dee4d9f1$export$2e2bcd8739ae039);
/* flex.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $kqp0i = parcelRequire("kqp0i");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");
var $87d7e898dee4d9f1$var$_excluded = [
    "as",
    "role",
    "alignItems",
    "justifyContent",
    "gap",
    "columnGap",
    "rowGap",
    "children",
    "testId",
    "direction",
    "wrap",
    "xcss"
];
var $87d7e898dee4d9f1$var$rowGapMap = {
    'space.0': "_1p57ze3t",
    'space.025': "_1p57v77o",
    'space.050': "_1p571b66",
    'space.075': "_1p5712x7",
    'space.100': "_1p57u2gc",
    'space.150': "_1p57utpp",
    'space.200': "_1p57pxbi",
    'space.250': "_1p57v47k",
    'space.300': "_1p571ejb",
    'space.400': "_1p57xy5q",
    'space.500': "_1p571jfw",
    'space.600': "_1p57oahv",
    'space.800': "_1p57xncg",
    'space.1000': "_1p571epz"
};
var $87d7e898dee4d9f1$var$columnGapMap = {
    'space.0': "_gy1pze3t",
    'space.025': "_gy1pv77o",
    'space.050': "_gy1p1b66",
    'space.075': "_gy1p12x7",
    'space.100': "_gy1pu2gc",
    'space.150': "_gy1putpp",
    'space.200': "_gy1ppxbi",
    'space.250': "_gy1pv47k",
    'space.300': "_gy1p1ejb",
    'space.400': "_gy1pxy5q",
    'space.500': "_gy1p1jfw",
    'space.600': "_gy1poahv",
    'space.800': "_gy1pxncg",
    'space.1000': "_gy1p1epz"
};
var $87d7e898dee4d9f1$var$justifyContentMap = {
    start: "_1bahv2br",
    center: "_1bah1h6o",
    end: "_1bahh9n0",
    'space-between': "_1bah1yb4",
    'space-around': "_1bah1b1v",
    'space-evenly': "_1bahitcz",
    stretch: "_1bah1fhb"
};
var $87d7e898dee4d9f1$var$flexDirectionMap = {
    column: "_2lx21bp4",
    row: "_2lx2vrvc"
};
var $87d7e898dee4d9f1$var$flexWrapMap = {
    wrap: "_1n261g80",
    nowrap: "_1n261q9c"
};
var $87d7e898dee4d9f1$var$alignItemsMap = {
    start: "_4cvrv2br",
    center: "_4cvr1h6o",
    baseline: "_4cvr1q9y",
    end: "_4cvrh9n0",
    stretch: "_4cvr1fhb"
};
var $87d7e898dee4d9f1$var$styles = {
    root: "_1e0c1txw _vchhusvi"
};
/**
 * __Flex__
 *
 * `Flex` is a primitive component that implements the CSS Flexbox API.
 *
 * - [Examples](https://atlassian.design/components/primitives/flex/examples)
 * - [Code](https://atlassian.design/components/primitives/flex/code)
 *
 * @example
 * ```tsx
 * // eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
 * import { Flex, Box } from '@atlaskit/primitives'
 *
 * const Component = () => (
 *   <Flex direction="column">
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *   </Flex>
 * )
 * ```
 */ var $87d7e898dee4d9f1$var$Flex = /*#__PURE__*/ (0, $5FkrB.memo)(/*#__PURE__*/ (0, $5FkrB.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? 'div' : _ref$as, role = _ref.role, alignItems = _ref.alignItems, justifyContent = _ref.justifyContent, gap = _ref.gap, columnGap = _ref.columnGap, rowGap = _ref.rowGap, children = _ref.children, testId = _ref.testId, direction = _ref.direction, wrap = _ref.wrap, xcss = _ref.xcss, ariaAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $87d7e898dee4d9f1$var$_excluded);
    return /*#__PURE__*/ $5FkrB.createElement(Component, (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, ariaAttributes, {
        role: role,
        className: (0, $970q7.default)([
            $87d7e898dee4d9f1$var$styles.root,
            gap && $87d7e898dee4d9f1$var$columnGapMap[gap],
            columnGap && $87d7e898dee4d9f1$var$columnGapMap[columnGap],
            gap && $87d7e898dee4d9f1$var$rowGapMap[gap],
            rowGap && $87d7e898dee4d9f1$var$rowGapMap[rowGap],
            alignItems && $87d7e898dee4d9f1$var$alignItemsMap[alignItems],
            direction && $87d7e898dee4d9f1$var$flexDirectionMap[direction],
            justifyContent && $87d7e898dee4d9f1$var$justifyContentMap[justifyContent],
            wrap && $87d7e898dee4d9f1$var$flexWrapMap[wrap],
            xcss
        ]),
        "data-testid": testId,
        ref: ref
    }), children);
}));
$87d7e898dee4d9f1$var$Flex.displayName = 'Flex';
var $87d7e898dee4d9f1$export$2e2bcd8739ae039 = $87d7e898dee4d9f1$var$Flex;

});


parcelRegister("ddWyY", function(module, exports) {
$parcel$export(module.exports, "default", () => $9a09eaae6de1b673$export$2e2bcd8739ae039);
/* stack.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $kqp0i = parcelRequire("kqp0i");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");


var $imej5 = parcelRequire("imej5");

var $bF5Ex = parcelRequire("bF5Ex");
var $9a09eaae6de1b673$var$_excluded = [
    "as",
    "alignInline",
    "alignBlock",
    "spread",
    "grow",
    "space",
    "children",
    "testId",
    "xcss",
    "role"
];
var $9a09eaae6de1b673$var$styles = {
    hug: "_16jlidpf",
    fill: "_1bsb1osq _16jlkb7n"
};
/**
 * __Stack__
 *
 * Stack is a primitive component based on flexbox that manages the block layout of direct children.
 *
 * @example
 * ```tsx
 *  <Stack>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *  </Stack>
 * ```
 *
 */ var $9a09eaae6de1b673$var$Stack = /*#__PURE__*/ (0, $5FkrB.memo)(/*#__PURE__*/ (0, $5FkrB.forwardRef)(function(_ref, ref) {
    var as = _ref.as, alignItems = _ref.alignInline, _ref$alignBlock = _ref.alignBlock, alignBlock = _ref$alignBlock === void 0 ? 'stretch' : _ref$alignBlock, spread = _ref.spread, grow = _ref.grow, space = _ref.space, children = _ref.children, testId = _ref.testId, xcss = _ref.xcss, role = _ref.role, ariaAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $9a09eaae6de1b673$var$_excluded);
    return /*#__PURE__*/ $5FkrB.createElement((0, $bF5Ex.default), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, ariaAttributes, {
        as: as,
        role: role,
        gap: space,
        direction: "column",
        alignItems: alignItems,
        justifyContent: spread || alignBlock,
        xcss: (0, $imej5.cx)(grow === 'hug' && $9a09eaae6de1b673$var$styles.hug, grow === 'fill' && $9a09eaae6de1b673$var$styles.fill, xcss),
        testId: testId,
        ref: ref
    }), children);
}));
$9a09eaae6de1b673$var$Stack.displayName = 'Stack';
var $9a09eaae6de1b673$export$2e2bcd8739ae039 = $9a09eaae6de1b673$var$Stack;

});

parcelRegister("4iLXE", function(module, exports) {
$parcel$export(module.exports, "getAppearanceIconStyles", () => $321e0bf4d8386b43$export$e9b82d2e21ac0c1f);

var $25nEq = parcelRequire("25nEq");

var $5FkrB = parcelRequire("5FkrB");

var $fTsMe = parcelRequire("fTsMe");

var $bwEq0 = parcelRequire("bwEq0");

var $fbBKm = parcelRequire("fbBKm");

var $kGnVa = parcelRequire("kGnVa");

var $k9qhj = parcelRequire("k9qhj");

var $9OR81 = parcelRequire("9OR81");
function $321e0bf4d8386b43$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $321e0bf4d8386b43$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $321e0bf4d8386b43$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $321e0bf4d8386b43$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $321e0bf4d8386b43$var$appearanceIconSchema = {
    information: {
        backgroundColor: "var(--ds-background-information, ".concat((0, $9OR81.B50), ")"),
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($fbBKm))),
        primaryIconColor: "var(--ds-icon-information, ".concat((0, $9OR81.B500), ")")
    },
    warning: {
        backgroundColor: "var(--ds-background-warning, ".concat((0, $9OR81.Y50), ")"),
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($k9qhj))),
        primaryIconColor: "var(--ds-icon-warning, ".concat((0, $9OR81.Y500), ")")
    },
    error: {
        backgroundColor: "var(--ds-background-danger, ".concat((0, $9OR81.R50), ")"),
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($bwEq0))),
        primaryIconColor: "var(--ds-icon-danger, ".concat((0, $9OR81.R500), ")")
    },
    success: {
        backgroundColor: "var(--ds-background-success, ".concat((0, $9OR81.G50), ")"),
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($kGnVa))),
        primaryIconColor: "var(--ds-icon-success, ".concat((0, $9OR81.G500), ")")
    },
    discovery: {
        backgroundColor: "var(--ds-background-discovery, ".concat((0, $9OR81.P50), ")"),
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($fTsMe))),
        primaryIconColor: "var(--ds-icon-discovery, ".concat((0, $9OR81.P500), ")")
    }
};
function $321e0bf4d8386b43$export$e9b82d2e21ac0c1f(appearance, icon) {
    var appearanceIconStyles = $321e0bf4d8386b43$var$appearanceIconSchema[appearance] || $321e0bf4d8386b43$var$appearanceIconSchema.information;
    var AppearanceIcon = function AppearanceIcon(_ref) {
        var size = _ref.size, primaryColor = _ref.primaryColor, secondaryColor = _ref.secondaryColor;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(appearanceIconStyles.Icon, {
            LEGACY_size: size,
            color: primaryColor,
            spacing: "spacious",
            LEGACY_primaryColor: primaryColor,
            LEGACY_secondaryColor: secondaryColor,
            label: appearance
        });
    };
    var Icon = icon || AppearanceIcon;
    return $321e0bf4d8386b43$var$_objectSpread($321e0bf4d8386b43$var$_objectSpread({}, appearanceIconStyles), {}, {
        Icon: Icon
    });
}

});
parcelRegister("fTsMe", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::5501f2ec2c7fc2907a8ddc6771935d76>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b922508c320d9ba8$var$_react = $b922508c320d9ba8$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $b922508c320d9ba8$var$_discovery = $b922508c320d9ba8$var$_interopRequireDefault((parcelRequire("58IFL")));

var $b922508c320d9ba8$var$_note = $b922508c320d9ba8$var$_interopRequireDefault((parcelRequire("6SjAl")));
function $b922508c320d9ba8$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for DiscoveryIcon.
 * This component is DiscoveryIcon, with `UNSAFE_fallbackIcon` set to "EditorNoteIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for discovery statuses and messaging.
Filled status icons provide higher visual contrast to draw attention to important information.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $b922508c320d9ba8$var$DiscoveryIcon = (props)=>/*#__PURE__*/ $b922508c320d9ba8$var$_react.default.createElement($b922508c320d9ba8$var$_discovery.default, Object.assign({
        name: "DiscoveryIcon",
        LEGACY_fallbackIcon: $b922508c320d9ba8$var$_note.default
    }, props));
$b922508c320d9ba8$var$DiscoveryIcon.displayName = 'DiscoveryIconMigration';
var $b922508c320d9ba8$var$_default = module.exports.default = $b922508c320d9ba8$var$DiscoveryIcon;

});
parcelRegister("58IFL", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::84ac540d37aa7b8e7ab349dbbb474c30>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3be05a2839879bbc$var$_react = $3be05a2839879bbc$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $3be05a2839879bbc$var$_baseNew = $3be05a2839879bbc$var$_interopRequireDefault((parcelRequire("axuVY")));
function $3be05a2839879bbc$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Discovery".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for discovery statuses and messaging.
Filled status icons provide higher visual contrast to draw attention to important information.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $3be05a2839879bbc$var$DiscoveryIcon = (props)=>/*#__PURE__*/ $3be05a2839879bbc$var$_react.default.createElement($3be05a2839879bbc$var$_baseNew.default, Object.assign({
        name: "DiscoveryIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M13 1H3a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h6v-4.75C9 9.56 9.56 9 10.25 9H15V3a2 2 0 0 0-2-2M4 5.5h7V4H4zM4 9h3V7.5H4z" clip-rule="evenodd"/><path fill="currentcolor" d="M11.25 10.5a.75.75 0 0 0-.75.75v3.81l4.56-4.56z"/>`
    }, props));
$3be05a2839879bbc$var$DiscoveryIcon.displayName = 'DiscoveryIcon';
var $3be05a2839879bbc$var$_default = module.exports.default = $3be05a2839879bbc$var$DiscoveryIcon;

});

parcelRegister("6SjAl", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5016fa6aa9a75655$var$_react = $5016fa6aa9a75655$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $2SuPM = parcelRequire("2SuPM");
function $5016fa6aa9a75655$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $5016fa6aa9a75655$var$EditorNoteIcon = (props)=>/*#__PURE__*/ $5016fa6aa9a75655$var$_react.default.createElement($2SuPM.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M8 4h8a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2m1.5 4a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h5a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5zm0 4a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5z"/></svg>`
    }, props));
$5016fa6aa9a75655$var$EditorNoteIcon.displayName = 'EditorNoteIcon';
var $5016fa6aa9a75655$var$_default = module.exports.default = $5016fa6aa9a75655$var$EditorNoteIcon;

});


parcelRegister("bwEq0", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f636032ea4a949f6a3ed21b2a88730cd>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8642091d24fd8666$var$_react = $8642091d24fd8666$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $8642091d24fd8666$var$_statusError = $8642091d24fd8666$var$_interopRequireDefault((parcelRequire("cMVCI")));

var $8642091d24fd8666$var$_error = $8642091d24fd8666$var$_interopRequireDefault((parcelRequire("3Ypqy")));
function $8642091d24fd8666$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for StatusErrorIcon.
 * This component is StatusErrorIcon, with `UNSAFE_fallbackIcon` set to "ErrorIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for error statuses and messaging.
Filled status icons provide higher visual contrast to draw attention to important information.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $8642091d24fd8666$var$StatusErrorIcon = (props)=>/*#__PURE__*/ $8642091d24fd8666$var$_react.default.createElement($8642091d24fd8666$var$_statusError.default, Object.assign({
        name: "StatusErrorIcon",
        LEGACY_fallbackIcon: $8642091d24fd8666$var$_error.default
    }, props));
$8642091d24fd8666$var$StatusErrorIcon.displayName = 'StatusErrorIconMigration';
var $8642091d24fd8666$var$_default = module.exports.default = $8642091d24fd8666$var$StatusErrorIcon;

});
parcelRegister("cMVCI", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3f93f06e22108e36edaead143b4f646b>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $94f6aa88698e8a20$var$_react = $94f6aa88698e8a20$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $94f6aa88698e8a20$var$_baseNew = $94f6aa88698e8a20$var$_interopRequireDefault((parcelRequire("axuVY")));
function $94f6aa88698e8a20$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "StatusError".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for error statuses and messaging.
Filled status icons provide higher visual contrast to draw attention to important information.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $94f6aa88698e8a20$var$StatusErrorIcon = (props)=>/*#__PURE__*/ $94f6aa88698e8a20$var$_react.default.createElement($94f6aa88698e8a20$var$_baseNew.default, Object.assign({
        name: "StatusErrorIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6.586.603a2 2 0 0 1 2.828 0l5.983 5.983a2 2 0 0 1 0 2.828l-5.983 5.982a2 2 0 0 1-2.828 0L.604 9.414a2 2 0 0 1 0-2.828zM8 10.25a1 1 0 1 0 0 2 1 1 0 0 0 0-2m-.75-6.5V9h1.5V3.75z" clip-rule="evenodd"/>`
    }, props));
$94f6aa88698e8a20$var$StatusErrorIcon.displayName = 'StatusErrorIcon';
var $94f6aa88698e8a20$var$_default = module.exports.default = $94f6aa88698e8a20$var$StatusErrorIcon;

});

parcelRegister("3Ypqy", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2e4ab306a0f5e369$var$_react = $2e4ab306a0f5e369$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $2SuPM = parcelRequire("2SuPM");
function $2e4ab306a0f5e369$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $2e4ab306a0f5e369$var$ErrorIcon = (props)=>/*#__PURE__*/ $2e4ab306a0f5e369$var$_react.default.createElement($2SuPM.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><path fill="currentcolor" d="M13.416 4.417a2 2 0 0 0-2.832 0l-6.168 6.167a2 2 0 0 0 0 2.833l6.168 6.167a2 2 0 0 0 2.832 0l6.168-6.167a2 2 0 0 0 0-2.833z"/><path fill="inherit" d="M12 14a1 1 0 0 1-1-1V8a1 1 0 0 1 2 0v5a1 1 0 0 1-1 1m0 3a1 1 0 0 1 0-2 1 1 0 0 1 0 2"/></g></svg>`
    }, props));
$2e4ab306a0f5e369$var$ErrorIcon.displayName = 'ErrorIcon';
var $2e4ab306a0f5e369$var$_default = module.exports.default = $2e4ab306a0f5e369$var$ErrorIcon;

});


parcelRegister("fbBKm", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::750ecc162e36259ef90344888c589176>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b0e529d5e830d792$var$_react = $b0e529d5e830d792$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $b0e529d5e830d792$var$_statusInformation = $b0e529d5e830d792$var$_interopRequireDefault((parcelRequire("7bxOu")));

var $b0e529d5e830d792$var$_info = $b0e529d5e830d792$var$_interopRequireDefault((parcelRequire("83Dod")));
function $b0e529d5e830d792$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for StatusInformationIcon.
 * This component is StatusInformationIcon, with `UNSAFE_fallbackIcon` set to "InfoIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for information statuses and messaging. 
Filled status icons provide higher visual contrast to draw attention to important information.
For information tooltips, use the unfilled 'information circle' icon.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $b0e529d5e830d792$var$StatusInformationIcon = (props)=>/*#__PURE__*/ $b0e529d5e830d792$var$_react.default.createElement($b0e529d5e830d792$var$_statusInformation.default, Object.assign({
        name: "StatusInformationIcon",
        LEGACY_fallbackIcon: $b0e529d5e830d792$var$_info.default
    }, props));
$b0e529d5e830d792$var$StatusInformationIcon.displayName = 'StatusInformationIconMigration';
var $b0e529d5e830d792$var$_default = module.exports.default = $b0e529d5e830d792$var$StatusInformationIcon;

});
parcelRegister("7bxOu", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::456639fbdc991aefe1af05acf697365d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $53b3ca20ba4a049e$var$_react = $53b3ca20ba4a049e$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $53b3ca20ba4a049e$var$_baseNew = $53b3ca20ba4a049e$var$_interopRequireDefault((parcelRequire("axuVY")));
function $53b3ca20ba4a049e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "StatusInformation".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for information statuses and messaging. 
Filled status icons provide higher visual contrast to draw attention to important information.
For information tooltips, use the unfilled 'information circle' icon.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $53b3ca20ba4a049e$var$StatusInformationIcon = (props)=>/*#__PURE__*/ $53b3ca20ba4a049e$var$_react.default.createElement($53b3ca20ba4a049e$var$_baseNew.default, Object.assign({
        name: "StatusInformationIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0M6.5 6.75v1.5h.75v4.25h1.5v-5A.75.75 0 0 0 8 6.75zM8 3.5a1 1 0 1 0 0 2 1 1 0 0 0 0-2" clip-rule="evenodd"/>`
    }, props));
$53b3ca20ba4a049e$var$StatusInformationIcon.displayName = 'StatusInformationIcon';
var $53b3ca20ba4a049e$var$_default = module.exports.default = $53b3ca20ba4a049e$var$StatusInformationIcon;

});

parcelRegister("83Dod", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5ddd28818dd6cd80$var$_react = $5ddd28818dd6cd80$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $2SuPM = parcelRequire("2SuPM");
function $5ddd28818dd6cd80$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $5ddd28818dd6cd80$var$InfoIcon = (props)=>/*#__PURE__*/ $5ddd28818dd6cd80$var$_react.default.createElement($2SuPM.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><path fill="currentcolor" d="M2 12c0 5.523 4.477 10 10 10s10-4.477 10-10S17.523 2 12 2 2 6.477 2 12"/><rect width="2" height="7" x="11" y="10" fill="inherit" rx="1"/><circle cx="12" cy="8" r="1" fill="inherit"/></g></svg>`
    }, props));
$5ddd28818dd6cd80$var$InfoIcon.displayName = 'InfoIcon';
var $5ddd28818dd6cd80$var$_default = module.exports.default = $5ddd28818dd6cd80$var$InfoIcon;

});


parcelRegister("kGnVa", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f966e8890debb57eaf4e6f167681f98b>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f0ea491c9d0ab674$var$_react = $f0ea491c9d0ab674$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $f0ea491c9d0ab674$var$_statusSuccess = $f0ea491c9d0ab674$var$_interopRequireDefault((parcelRequire("lcW9s")));

var $f0ea491c9d0ab674$var$_checkCircle = $f0ea491c9d0ab674$var$_interopRequireDefault((parcelRequire("IdLwe")));
function $f0ea491c9d0ab674$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for StatusSuccessIcon.
 * This component is StatusSuccessIcon, with `UNSAFE_fallbackIcon` set to "CheckCircleIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for success statuses and messaging. Filled status icons provide higher visual contrast to draw attention to important information.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $f0ea491c9d0ab674$var$StatusSuccessIcon = (props)=>/*#__PURE__*/ $f0ea491c9d0ab674$var$_react.default.createElement($f0ea491c9d0ab674$var$_statusSuccess.default, Object.assign({
        name: "StatusSuccessIcon",
        LEGACY_fallbackIcon: $f0ea491c9d0ab674$var$_checkCircle.default
    }, props));
$f0ea491c9d0ab674$var$StatusSuccessIcon.displayName = 'StatusSuccessIconMigration';
var $f0ea491c9d0ab674$var$_default = module.exports.default = $f0ea491c9d0ab674$var$StatusSuccessIcon;

});
parcelRegister("lcW9s", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::174472a7e38932dc7a97866e0be8034a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f707d3a071331bf4$var$_react = $f707d3a071331bf4$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $f707d3a071331bf4$var$_baseNew = $f707d3a071331bf4$var$_interopRequireDefault((parcelRequire("axuVY")));
function $f707d3a071331bf4$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "StatusSuccess".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for success statuses and messaging. Filled status icons provide higher visual contrast to draw attention to important information.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $f707d3a071331bf4$var$StatusSuccessIcon = (props)=>/*#__PURE__*/ $f707d3a071331bf4$var$_react.default.createElement($f707d3a071331bf4$var$_baseNew.default, Object.assign({
        name: "StatusSuccessIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0M6.75 9.828 4.826 7.52l-1.152.96 2.5 3a.75.75 0 0 0 1.152 0l5-6-1.152-.96z" clip-rule="evenodd"/>`
    }, props));
$f707d3a071331bf4$var$StatusSuccessIcon.displayName = 'StatusSuccessIcon';
var $f707d3a071331bf4$var$_default = module.exports.default = $f707d3a071331bf4$var$StatusSuccessIcon;

});

parcelRegister("IdLwe", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $084ec9b41a711a11$var$_react = $084ec9b41a711a11$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $2SuPM = parcelRequire("2SuPM");
function $084ec9b41a711a11$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $084ec9b41a711a11$var$CheckCircleIcon = (props)=>/*#__PURE__*/ $084ec9b41a711a11$var$_react.default.createElement($2SuPM.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><circle cx="12" cy="12" r="10" fill="currentcolor"/><path fill="inherit" d="M9.707 11.293a1 1 0 1 0-1.414 1.414l2 2a1 1 0 0 0 1.414 0l4-4a1 1 0 1 0-1.414-1.414L11 12.586z"/></g></svg>`
    }, props));
$084ec9b41a711a11$var$CheckCircleIcon.displayName = 'CheckCircleIcon';
var $084ec9b41a711a11$var$_default = module.exports.default = $084ec9b41a711a11$var$CheckCircleIcon;

});


parcelRegister("k9qhj", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::715767a087f47b16ede12b841c1dd7f2>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $eab908370f514296$var$_react = $eab908370f514296$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $eab908370f514296$var$_statusWarning = $eab908370f514296$var$_interopRequireDefault((parcelRequire("lNKbd")));

var $eab908370f514296$var$_warning = $eab908370f514296$var$_interopRequireDefault((parcelRequire("k6dqf")));
function $eab908370f514296$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for StatusWarningIcon.
 * This component is StatusWarningIcon, with `UNSAFE_fallbackIcon` set to "WarningIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for warning statuses.
Filled status icons provide higher visual contrast to draw attention to important information.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $eab908370f514296$var$StatusWarningIcon = (props)=>/*#__PURE__*/ $eab908370f514296$var$_react.default.createElement($eab908370f514296$var$_statusWarning.default, Object.assign({
        name: "StatusWarningIcon",
        LEGACY_fallbackIcon: $eab908370f514296$var$_warning.default
    }, props));
$eab908370f514296$var$StatusWarningIcon.displayName = 'StatusWarningIconMigration';
var $eab908370f514296$var$_default = module.exports.default = $eab908370f514296$var$StatusWarningIcon;

});
parcelRegister("lNKbd", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2ee7b3f114c675eea0f953c33a485bcf>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $fdf1fef12078b66f$var$_react = $fdf1fef12078b66f$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $fdf1fef12078b66f$var$_baseNew = $fdf1fef12078b66f$var$_interopRequireDefault((parcelRequire("axuVY")));
function $fdf1fef12078b66f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "StatusWarning".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for warning statuses.
Filled status icons provide higher visual contrast to draw attention to important information.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $fdf1fef12078b66f$var$StatusWarningIcon = (props)=>/*#__PURE__*/ $fdf1fef12078b66f$var$_react.default.createElement($fdf1fef12078b66f$var$_baseNew.default, Object.assign({
        name: "StatusWarningIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6.242 1.168c.756-1.395 2.76-1.395 3.516 0l5.9 10.878c.723 1.333-.242 2.953-1.758 2.953H2.1C.584 15-.38 13.38.342 12.046zM8 10.75a1 1 0 1 0 0 2.001 1 1 0 0 0 0-2M7.25 4.5v5h1.5v-5z" clip-rule="evenodd"/>`
    }, props));
$fdf1fef12078b66f$var$StatusWarningIcon.displayName = 'StatusWarningIcon';
var $fdf1fef12078b66f$var$_default = module.exports.default = $fdf1fef12078b66f$var$StatusWarningIcon;

});

parcelRegister("k6dqf", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ea1ec78fff93a17f$var$_react = $ea1ec78fff93a17f$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $2SuPM = parcelRequire("2SuPM");
function $ea1ec78fff93a17f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $ea1ec78fff93a17f$var$WarningIcon = (props)=>/*#__PURE__*/ $ea1ec78fff93a17f$var$_react.default.createElement($2SuPM.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><path fill="currentcolor" d="M12.938 4.967c-.518-.978-1.36-.974-1.876 0L3.938 18.425c-.518.978-.045 1.771 1.057 1.771h14.01c1.102 0 1.573-.797 1.057-1.771z"/><path fill="inherit" d="M12 15a1 1 0 0 1-1-1V9a1 1 0 0 1 2 0v5a1 1 0 0 1-1 1m0 3a1 1 0 0 1 0-2 1 1 0 0 1 0 2"/></g></svg>`
    }, props));
$ea1ec78fff93a17f$var$WarningIcon.displayName = 'WarningIcon';
var $ea1ec78fff93a17f$var$_default = module.exports.default = $ea1ec78fff93a17f$var$WarningIcon;

});


parcelRegister("9OR81", function(module, exports) {
$parcel$export(module.exports, "R50", () => $7261febf83373c9c$export$4b84fd0e2c617bd);
$parcel$export(module.exports, "R500", () => $7261febf83373c9c$export$2837b5a1a71d5c02);
$parcel$export(module.exports, "Y50", () => $7261febf83373c9c$export$8d9596b529bbb9cf);
$parcel$export(module.exports, "Y500", () => $7261febf83373c9c$export$874739ea9e379ab6);
$parcel$export(module.exports, "G50", () => $7261febf83373c9c$export$8a6341c32b6a3ee6);
$parcel$export(module.exports, "G500", () => $7261febf83373c9c$export$6fa04827ac68a4fb);
$parcel$export(module.exports, "B50", () => $7261febf83373c9c$export$226de0355ed012f8);
$parcel$export(module.exports, "B500", () => $7261febf83373c9c$export$a6ee3d71bc067634);
$parcel$export(module.exports, "P50", () => $7261febf83373c9c$export$363e4475840015bb);
$parcel$export(module.exports, "P500", () => $7261febf83373c9c$export$147899de772240ec);
// Reds
var $7261febf83373c9c$export$4b84fd0e2c617bd = '#FFEBE6';
var $7261febf83373c9c$export$b34b069eff244586 = '#FFBDAD';
var $7261febf83373c9c$export$be802dd0d8b57f35 = '#FF8F73';
var $7261febf83373c9c$export$60847d42f9da92a6 = '#FF7452';
var $7261febf83373c9c$export$4a7404f376229999 = '#FF5630';
var $7261febf83373c9c$export$2010d0fb4295b346 = '#DE350B';
var $7261febf83373c9c$export$2837b5a1a71d5c02 = '#BF2600';
var $7261febf83373c9c$export$8d9596b529bbb9cf = '#FFFAE6';
var $7261febf83373c9c$export$41060a744ab0b7ae = '#FFF0B3';
var $7261febf83373c9c$export$1cc05bbbf340e559 = '#FFE380';
var $7261febf83373c9c$export$5aae31392d72caaa = '#FFC400';
var $7261febf83373c9c$export$c6930421db9fa514 = '#FFAB00';
var $7261febf83373c9c$export$59619663aa6500fb = '#FF991F';
var $7261febf83373c9c$export$874739ea9e379ab6 = '#FF8B00';
var $7261febf83373c9c$export$8a6341c32b6a3ee6 = '#E3FCEF';
var $7261febf83373c9c$export$69a3bf21b9686c2b = '#ABF5D1';
var $7261febf83373c9c$export$afbce1382ec95f73 = '#79F2C0';
var $7261febf83373c9c$export$747d86715d4175de = '#57D9A3';
var $7261febf83373c9c$export$940e1f69e873f202 = '#36B37E';
var $7261febf83373c9c$export$a49394138f7b8e85 = '#00875A';
var $7261febf83373c9c$export$6fa04827ac68a4fb = '#006644';
var $7261febf83373c9c$export$226de0355ed012f8 = '#DEEBFF';
var $7261febf83373c9c$export$8c13c2ee36917869 = '#B3D4FF';
var $7261febf83373c9c$export$ecfc1dff386a3e7a = '#4C9AFF';
var $7261febf83373c9c$export$215b7063051591f1 = '#2684FF';
var $7261febf83373c9c$export$e62e8919cca44969 = '#0065FF';
var $7261febf83373c9c$export$b3de0ae08da2ce64 = '#0052CC';
var $7261febf83373c9c$export$a6ee3d71bc067634 = '#0747A6';
var $7261febf83373c9c$export$67f15409e87642a1 = '#669DF1';
var $7261febf83373c9c$export$f0539dbc42dbb067 = '#8FB8F6';
var $7261febf83373c9c$export$363e4475840015bb = '#EAE6FF';
var $7261febf83373c9c$export$4b0a4417ed59760f = '#C0B6F2';
var $7261febf83373c9c$export$6011520a64d9a187 = '#998DD9';
var $7261febf83373c9c$export$a7175d4e9206bc80 = '#8777D9';
var $7261febf83373c9c$export$b48405b95304b5a1 = '#6554C0';
var $7261febf83373c9c$export$c71e4279dd54a18d = '#5243AA';
var $7261febf83373c9c$export$147899de772240ec = '#403294';
var $7261febf83373c9c$export$2cf711fe14c66f06 = '#E6FCFF';
var $7261febf83373c9c$export$7a8f4d33f6f9772c = '#B3F5FF';
var $7261febf83373c9c$export$776c9c497ef08533 = '#79E2F2';
var $7261febf83373c9c$export$69cb3ca10c1e330e = '#00C7E6';
var $7261febf83373c9c$export$9dc1ef0f3f48059b = '#00B8D9';
var $7261febf83373c9c$export$7c835c78b6fcdef8 = '#00A3BF';
var $7261febf83373c9c$export$6036577f95c3877e = '#008DA6';
var $7261febf83373c9c$export$29a4f05edc054374 = '#FFFFFF';
var $7261febf83373c9c$export$e655ef011c4aa1a2 = '#FAFBFC';
var $7261febf83373c9c$export$9fdfb749e33cdf97 = '#F4F5F7';
var $7261febf83373c9c$export$3e51e8f1440314ba = '#EBECF0';
var $7261febf83373c9c$export$1ce2d1575d444ceb = '#DFE1E6';
var $7261febf83373c9c$export$8754fc7e6d8b3000 = '#C1C7D0';
var $7261febf83373c9c$export$c2e91cbeada39b8b = '#B3BAC5';
var $7261febf83373c9c$export$5f71e19f3a7ad9de = '#A5ADBA';
var $7261febf83373c9c$export$eaa8c8a70ac22806 = '#97A0AF';
var $7261febf83373c9c$export$7c87d337fb91a97d = '#8993A4';
var $7261febf83373c9c$export$d6447c357493214f = '#7A869A';
var $7261febf83373c9c$export$f563ee71e9ee74cd = '#6B778C';
var $7261febf83373c9c$export$e2ef2124cf4024b1 = '#5E6C84';
var $7261febf83373c9c$export$eece5f492e429f08 = '#505F79';
var $7261febf83373c9c$export$c39c0fe0f26207ae = '#42526E';
var $7261febf83373c9c$export$7090862dc3038a9f = '#344563';
var $7261febf83373c9c$export$ad0bacf983b7ddaa = '#253858';
var $7261febf83373c9c$export$7d61b15e0da132af = '#172B4D';
var $7261febf83373c9c$export$fbda843f0a27fe96 = '#091E42';
var $7261febf83373c9c$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
var $7261febf83373c9c$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
var $7261febf83373c9c$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
var $7261febf83373c9c$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
var $7261febf83373c9c$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
var $7261febf83373c9c$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
var $7261febf83373c9c$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
var $7261febf83373c9c$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
var $7261febf83373c9c$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
var $7261febf83373c9c$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
var $7261febf83373c9c$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
var $7261febf83373c9c$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
var $7261febf83373c9c$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
var $7261febf83373c9c$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
var $7261febf83373c9c$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
var $7261febf83373c9c$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
var $7261febf83373c9c$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
var $7261febf83373c9c$export$2f6319cf7d736c2a = '#E6EDFA';
var $7261febf83373c9c$export$95126bc8884d6634 = '#DCE5F5';
var $7261febf83373c9c$export$8338d8c35d44ff1 = '#CED9EB';
var $7261febf83373c9c$export$5368d76ae4fbbda7 = '#B8C7E0';
var $7261febf83373c9c$export$9f0a771d16ec8d36 = '#ABBBD6';
var $7261febf83373c9c$export$abcf8c38338b4aa5 = '#9FB0CC';
var $7261febf83373c9c$export$97e81faa16a182c7 = '#8C9CB8';
var $7261febf83373c9c$export$bfe21c59123ecf33 = '#7988A3';
var $7261febf83373c9c$export$ee82aa2ea6a1558 = '#67758F';
var $7261febf83373c9c$export$682927c6ed76be02 = '#56637A';
var $7261febf83373c9c$export$91fd9994c5be9757 = '#455166';
var $7261febf83373c9c$export$d281fbfe3cff2df6 = '#3B475C';
var $7261febf83373c9c$export$3902c91d8b98a753 = '#313D52';
var $7261febf83373c9c$export$8e8133c1ba5845b5 = '#283447';
var $7261febf83373c9c$export$33ff357f6620b39 = '#202B3D';
var $7261febf83373c9c$export$633847cf062b69e0 = '#1B2638';
var $7261febf83373c9c$export$9776a6e503bdbf76 = '#121A29';
var $7261febf83373c9c$export$6c813d5160dff5db = '#0E1624';
var $7261febf83373c9c$export$3d4f271a500072a = '#0D1424';
var $7261febf83373c9c$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
var $7261febf83373c9c$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
var $7261febf83373c9c$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
var $7261febf83373c9c$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
var $7261febf83373c9c$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
var $7261febf83373c9c$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
var $7261febf83373c9c$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
var $7261febf83373c9c$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
var $7261febf83373c9c$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
var $7261febf83373c9c$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
var $7261febf83373c9c$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
var $7261febf83373c9c$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
var $7261febf83373c9c$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
var $7261febf83373c9c$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
var $7261febf83373c9c$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
var $7261febf83373c9c$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
var $7261febf83373c9c$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';
var $7261febf83373c9c$export$d2adc5dedf09fced = '#292A2E';
var $7261febf83373c9c$export$f51762073d2bb381 = '#94C748';
var $7261febf83373c9c$export$95e26d54def96891 = '#B3DF72';

});



parcelRegister("jgNUw", function(module, exports) {
$parcel$export(module.exports, "default", () => $e0763a2a29633b85$export$2e2bcd8739ae039);

var $kqp0i = parcelRequire("kqp0i");

var $iYJcE = parcelRequire("iYJcE");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");

var $eVb4V = parcelRequire("eVb4V");

var $aSOmI = parcelRequire("aSOmI");

var $8cfv1 = parcelRequire("8cfv1");

var $56aIg = parcelRequire("56aIg");

var $6R7Di = parcelRequire("6R7Di");
var $e0763a2a29633b85$var$_excluded = [
    "appearance",
    "children",
    "iconBefore",
    "iconAfter",
    "isSelected",
    "onMouseDown",
    "onMouseUp",
    "shouldFitContainer",
    "spacing"
];
var $e0763a2a29633b85$var$isFirefox = typeof navigator !== 'undefined' && navigator.userAgent.toLowerCase().indexOf('firefox') > -1;
/**
 * __Button__
 *
 * @deprecated Legacy buttons are deprecated and will be removed from `atlaskit/button` in an upcoming major release. Please use the new Button components from `@atlaskit/button/new`
 *
 * Please refer to the [migration guide](https://atlassian.design/components/button/button-legacy/migration-guide) for further details.
 *
 * A button triggers an event or action. They let users know what will happen next.
 *
 * - [Examples](https://atlassian.design/components/button/button-legacy/examples)
 * - [Code](https://atlassian.design/components/button/button-legacy/code)
 * - [Usage](https://atlassian.design/components/button/button-legacy/usage)
 */ var $e0763a2a29633b85$var$Button = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).forwardRef(function Button(_ref, ref) {
    var _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'default' : _ref$appearance, children = _ref.children, iconBefore = _ref.iconBefore, iconAfter = _ref.iconAfter, _ref$isSelected = _ref.isSelected, isSelected = _ref$isSelected === void 0 ? false : _ref$isSelected, _ref$onMouseDown = _ref.onMouseDown, providedOnMouseDown = _ref$onMouseDown === void 0 ? (0, $eVb4V.default) : _ref$onMouseDown, _ref$onMouseUp = _ref.onMouseUp, providedOnMouseUp = _ref$onMouseUp === void 0 ? (0, $eVb4V.default) : _ref$onMouseUp, _ref$shouldFitContain = _ref.shouldFitContainer, shouldFitContainer = _ref$shouldFitContain === void 0 ? false : _ref$shouldFitContain, _ref$spacing = _ref.spacing, spacing = _ref$spacing === void 0 ? 'default' : _ref$spacing, rest = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $e0763a2a29633b85$var$_excluded);
    var _useGlobalTheme = (0, $aSOmI.useGlobalTheme)(), mode = _useGlobalTheme.mode;
    var isOnlySingleIcon = (0, $6R7Di.default)({
        children: children,
        iconBefore: iconBefore,
        iconAfter: iconAfter
    });
    var _useState = (0, $5FkrB.useState)(false), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), isActive = _useState2[0], setIsActive = _useState2[1];
    // Wrap onMouseDown / onMouseUp to manually trigger active state
    //  in Firefox
    var onMouseDown = (0, $5FkrB.useCallback)(function(event) {
        providedOnMouseDown(event);
        if ($e0763a2a29633b85$var$isFirefox) setIsActive(true);
    }, [
        providedOnMouseDown,
        setIsActive
    ]);
    var onMouseUp = (0, $5FkrB.useCallback)(function(event) {
        providedOnMouseUp(event);
        if ($e0763a2a29633b85$var$isFirefox) setIsActive(false);
    }, [
        providedOnMouseUp,
        setIsActive
    ]);
    var buttonCss = (0, $5FkrB.useMemo)(function() {
        return (0, $56aIg.getCss)({
            appearance: appearance,
            spacing: spacing,
            mode: mode,
            isSelected: isSelected,
            shouldFitContainer: shouldFitContainer,
            isOnlySingleIcon: isOnlySingleIcon
        });
    }, [
        appearance,
        spacing,
        mode,
        isSelected,
        shouldFitContainer,
        isOnlySingleIcon
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $8cfv1.default), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, rest, {
        ref: ref,
        appearance: appearance,
        buttonCss: buttonCss,
        children: children,
        "data-firefox-is-active": isActive ? true : undefined,
        iconAfter: iconAfter,
        iconBefore: iconBefore,
        isSelected: isSelected,
        onMouseDown: onMouseDown,
        onMouseUp: onMouseUp,
        spacing: spacing
    }));
}));
// Tools including enzyme rely on components having a display name
$e0763a2a29633b85$var$Button.displayName = 'Button';
var $e0763a2a29633b85$export$2e2bcd8739ae039 = $e0763a2a29633b85$var$Button;

});
parcelRegister("aSOmI", function(module, exports) {
$parcel$export(module.exports, "useGlobalTheme", () => $7ec6040baad9ca1c$export$7692396083754928);
$parcel$export(module.exports, "default", () => $7ec6040baad9ca1c$export$2e2bcd8739ae039);

var $lUEkq = parcelRequire("lUEkq");
// Create default global light theme
var $7ec6040baad9ca1c$var$_createTheme = (0, $lUEkq.createTheme)(function() {
    return {
        mode: 'light'
    };
}), $7ec6040baad9ca1c$var$Provider = $7ec6040baad9ca1c$var$_createTheme.Provider, $7ec6040baad9ca1c$var$Consumer = $7ec6040baad9ca1c$var$_createTheme.Consumer, $7ec6040baad9ca1c$export$7692396083754928 = $7ec6040baad9ca1c$var$_createTheme.useTheme;
var $7ec6040baad9ca1c$var$Theme = {
    Provider: $7ec6040baad9ca1c$var$Provider,
    Consumer: $7ec6040baad9ca1c$var$Consumer
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$7ec6040baad9ca1c$export$2e2bcd8739ae039 = $7ec6040baad9ca1c$var$Theme;

});
parcelRegister("lUEkq", function(module, exports) {
$parcel$export(module.exports, "createTheme", () => $ff3e1c57b0f1e237$export$25d302a5b900a763);

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");
var $ff3e1c57b0f1e237$var$_excluded = [
    "children"
];
function $ff3e1c57b0f1e237$export$25d302a5b900a763(defaultGetTokens) {
    var emptyThemeFn = function emptyThemeFn(getTokens, props) {
        return getTokens(props);
    };
    /**
   * Internally, Theme uses React Context, with internal providers and consumers.
   * The React Context passes only a function that gets props, and turns them into tokens. This
   * function gets mixed as more Providers with their own themes are added. This mixed function
   * is ultimately picked up by Consumers, which implement a context consumer internally to fetch
   * the theme.
   */ var ThemeContext = /*#__PURE__*/ (0, $5FkrB.createContext)(defaultGetTokens);
    function useTheme(themeProps) {
        var theme = (0, $5FkrB.useContext)(ThemeContext);
        var themeFn = theme || emptyThemeFn;
        var tokens = themeFn(themeProps);
        return tokens;
    }
    // The Theme Consumer takes a function as its child - this function takes tokens, and the
    // return value is generally a set of nodes with the tokens applied appropriately.
    function Consumer(props) {
        var children = props.children, themeProps = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(props, $ff3e1c57b0f1e237$var$_excluded);
        // @ts-ignore See issue for more info: https://github.com/Microsoft/TypeScript/issues/10727
        // Argument of type 'Pick<ThemeProps & { children: (tokens: ThemeTokens) => ReactNode; }, Exclude<keyof ThemeProps, "children">>' is not assignable to parameter of type 'ThemeProps'.ts(2345)
        var tokens = useTheme(themeProps);
        // We add a fragment to ensure we don't break people upgrading.
        // Previously they may have been able to pass in undefined without things blowing up.
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).Fragment, null, children(tokens));
    }
    /**
   * The Theme Provider takes regular nodes as its children, but also takes a *theme function*
   * - The theme function takes a set of props, as well as a function (getTokens) that can turn props into tokens.
   * - The getTokens function isn't called immediately - instead the props are passed
   *    through a mix of parent theming functions
   * Children of this provider will receive this mixed theme
   */ function Provider(props) {
        var themeFn = (0, $5FkrB.useContext)(ThemeContext);
        var valueFn = props.value || emptyThemeFn;
        var mixedFn = (0, $5FkrB.useCallback)(function(themeProps) {
            return valueFn(themeFn, themeProps);
        }, [
            themeFn,
            valueFn
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(ThemeContext.Provider, {
            value: mixedFn
        }, props.children);
    }
    return {
        Consumer: Consumer,
        Provider: Provider,
        useTheme: useTheme
    };
}

});


parcelRegister("8cfv1", function(module, exports) {
$parcel$export(module.exports, "default", () => $5f7b778c870b53cc$export$2e2bcd8739ae039);

var $kqp0i = parcelRequire("kqp0i");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");

var $74Zh5 = parcelRequire("74Zh5");

var $6Oq3u = parcelRequire("6Oq3u");

var $eVb4V = parcelRequire("eVb4V");

var $gpUQB = parcelRequire("gpUQB");

var $eYQvF = parcelRequire("eYQvF");

var $eqVaP = parcelRequire("eqVaP");

var $Tr1sB = parcelRequire("Tr1sB");

var $f2dbC = parcelRequire("f2dbC");

var $56aIg = parcelRequire("56aIg");

var $kcV4s = parcelRequire("kcV4s");
var $5f7b778c870b53cc$var$_excluded = [
    "analyticsContext",
    "appearance",
    "autoFocus",
    "buttonCss",
    "children",
    "className",
    "href",
    "component",
    "iconAfter",
    "iconBefore",
    "interactionName",
    "isDisabled",
    "isSelected",
    "onBlur",
    "onClick",
    "onFocus",
    "onMouseDown",
    "overlay",
    "shouldFitContainer",
    "spacing",
    "tabIndex",
    "type",
    "testId"
];
// Disabled buttons will still publish events for nested elements in webkit.
// We are disabling pointer events on child elements so that
// the button will always be the target of events
// Note: firefox does not have this behaviour for child elements
var $5f7b778c870b53cc$var$noPointerEventsOnChildrenCss = {
    '> *': {
        pointerEvents: 'none'
    }
};
/**
 * These CSS variables consumed by the new icons, to allow them to have appropriate
 * padding inside Button while also maintaining spacing for the existing icons.
 *
 * These styles can be removed once the new icons are fully rolled out, feature flag
 * platform-visual-refresh-icons is cleaned up,
 * and we bump Button to set padding based on the new icons.
 */ var $5f7b778c870b53cc$var$iconBeforeSpacingFixStyle = (0, $74Zh5.css)({
    '--ds--button--new-icon-padding-end': "var(--ds-space-025, 2px)",
    '--ds--button--new-icon-padding-start': "var(--ds-space-050, 4px)",
    marginInlineStart: "var(--ds-space-negative-025, -2px)"
});
var $5f7b778c870b53cc$var$iconAfterSpacingFixStyle = (0, $74Zh5.css)({
    '--ds--button--new-icon-padding-end': "var(--ds-space-050, 4px)",
    '--ds--button--new-icon-padding-start': "var(--ds-space-025, 2px)",
    marginInlineEnd: "var(--ds-space-negative-025, -2px)"
});
var $5f7b778c870b53cc$var$getSpacingFix = function getSpacingFix(children, spacingStyles) {
    if (!children || (0, $kcV4s.getIfVisuallyHiddenChildren)(children)) return null;
    return spacingStyles;
};
var $5f7b778c870b53cc$var$getChildren = function getChildren(children, childrenStyles) {
    if ((0, $kcV4s.getIfVisuallyHiddenChildren)(children)) return children;
    return children ? (0, $74Zh5.jsx)("span", {
        css: childrenStyles
    }, children) : null;
};
var $5f7b778c870b53cc$var$ButtonBase = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).forwardRef(function ButtonBase(props, ref) {
    var analyticsContext = props.analyticsContext, _props$appearance = props.appearance, appearance = _props$appearance === void 0 ? 'default' : _props$appearance, _props$autoFocus = props.autoFocus, autoFocus = _props$autoFocus === void 0 ? false : _props$autoFocus, buttonCss = props.buttonCss, children = props.children, className = props.className, href = props.href, _props$component = props.component, Component = _props$component === void 0 ? href ? 'a' : 'button' : _props$component, iconAfter = props.iconAfter, iconBefore = props.iconBefore, interactionName = props.interactionName, _props$isDisabled = props.isDisabled, isDisabled = _props$isDisabled === void 0 ? false : _props$isDisabled, _props$isSelected = props.isSelected, isSelected = _props$isSelected === void 0 ? false : _props$isSelected, onBlur = props.onBlur, _props$onClick = props.onClick, providedOnClick = _props$onClick === void 0 ? (0, $eVb4V.default) : _props$onClick, onFocus = props.onFocus, _props$onMouseDown = props.onMouseDown, providedOnMouseDown = _props$onMouseDown === void 0 ? (0, $eVb4V.default) : _props$onMouseDown, overlay = props.overlay, shouldFitContainer = props.shouldFitContainer, _props$spacing = props.spacing, spacing = _props$spacing === void 0 ? 'default' : _props$spacing, _props$tabIndex = props.tabIndex, tabIndex = _props$tabIndex === void 0 ? 0 : _props$tabIndex, _props$type = props.type, type = _props$type === void 0 ? !href ? 'button' : undefined : _props$type, testId = props.testId, rest = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(props, $5f7b778c870b53cc$var$_excluded);
    var ourRef = (0, $5FkrB.useRef)();
    var setRef = (0, $5FkrB.useCallback)(function(node) {
        ourRef.current = node;
        if (ref == null) return;
        if (typeof ref === 'function') {
            ref(node);
            return;
        }
        // We can write to ref's `current` property, but Typescript does not like it.
        // @ts-ignore
        ref.current = node;
    }, [
        ourRef,
        ref
    ]);
    // Cross browser auto focusing is pretty broken, so we are doing it ourselves
    (0, $gpUQB.default)(ourRef, autoFocus);
    var interactionContext = (0, $5FkrB.useContext)((0, $eqVaP.default));
    var handleClick = (0, $5FkrB.useCallback)(function(e, analyticsEvent) {
        interactionContext && interactionContext.tracePress(interactionName, e.timeStamp);
        providedOnClick(e, analyticsEvent);
    }, [
        providedOnClick,
        interactionContext,
        interactionName
    ]);
    var onClick = (0, $6Oq3u.usePlatformLeafEventHandler)({
        fn: handleClick,
        action: 'clicked',
        componentName: 'button',
        packageName: "@atlaskit/button",
        packageVersion: "0.0.0-development",
        analyticsData: analyticsContext
    });
    // Button currently calls preventDefault, which is not standard button behaviour
    var onMouseDown = (0, $5FkrB.useCallback)(function(event) {
        event.preventDefault();
        providedOnMouseDown(event);
    }, [
        providedOnMouseDown
    ]);
    // Lose focus when becoming disabled (standard button behaviour)
    (0, $5FkrB.useEffect)(function() {
        var el = ourRef.current;
        if (isDisabled && el && el === document.activeElement) el.blur();
    }, [
        isDisabled
    ]);
    // we are 'disabling' input with a button when there is an overlay
    var hasOverlay = Boolean(overlay);
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    var fadeStyles = (0, $74Zh5.css)((0, $56aIg.getFadingCss)({
        hasOverlay: hasOverlay
    }));
    var isInteractive = !isDisabled && !hasOverlay;
    /**
   * HACK: Spinner needs to have different colours in the "new" tokens design compared to the old design.
   * For now, while we support both, these styles reach into Spinner when a theme is set, applies the right color.
   * Ticket to remove: https://product-fabric.atlassian.net/browse/DSP-2067.
   */ var spinnerHackCss = {};
    if (isSelected || isDisabled || appearance === 'warning') spinnerHackCss = {
        '[data-theme] & circle': {
            stroke: "".concat(isSelected || isDisabled ? "var(--ds-icon-subtle, ".concat((0, $Tr1sB.N500), ")") : "var(--ds-icon-warning-inverse, ".concat((0, $Tr1sB.N500), ")"), " !important")
        }
    };
    return (0, $74Zh5.jsx)((0, $eYQvF.default), null, (0, $74Zh5.jsx)(Component, (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, rest, {
        ref: setRef,
        className: className,
        css: [
            buttonCss,
            isInteractive ? null : $5f7b778c870b53cc$var$noPointerEventsOnChildrenCss
        ],
        "data-has-overlay": hasOverlay ? true : undefined,
        "data-testid": testId,
        disabled: isDisabled,
        href: isInteractive ? href : undefined,
        onBlur: onBlur,
        onClick: onClick,
        onFocus: onFocus,
        onMouseDown: onMouseDown,
        tabIndex: isDisabled ? -1 : tabIndex,
        type: type
    }, (0, $f2dbC.default)({
        isInteractive: isInteractive
    })), iconBefore ? (0, $74Zh5.jsx)("span", {
        css: [
            fadeStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $56aIg.getIconStyle)({
                spacing: spacing
            }),
            $5f7b778c870b53cc$var$getSpacingFix(children, $5f7b778c870b53cc$var$iconBeforeSpacingFixStyle)
        ]
    }, iconBefore) : null, $5f7b778c870b53cc$var$getChildren(children, [
        fadeStyles,
        (0, $56aIg.getContentStyle)({
            spacing: spacing
        })
    ]), iconAfter ? (0, $74Zh5.jsx)("span", {
        css: [
            fadeStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $56aIg.getIconStyle)({
                spacing: spacing
            }),
            $5f7b778c870b53cc$var$getSpacingFix(children, $5f7b778c870b53cc$var$iconAfterSpacingFixStyle)
        ]
    }, iconAfter) : null, overlay ? (0, $74Zh5.jsx)("span", {
        css: [
            (0, $56aIg.overlayCss),
            spinnerHackCss
        ]
    }, overlay) : null));
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$5f7b778c870b53cc$export$2e2bcd8739ae039 = $5f7b778c870b53cc$var$ButtonBase;

});
parcelRegister("f2dbC", function(module, exports) {
$parcel$export(module.exports, "default", () => $af21457669944388$export$2e2bcd8739ae039);
function $af21457669944388$var$abort(event) {
    event.preventDefault();
    event.stopPropagation();
}
var $af21457669944388$var$tabKeyCode = 9;
function $af21457669944388$var$onKey(event) {
    // Allowing tab so that a user can move focus away
    if (event.keyCode === $af21457669944388$var$tabKeyCode) return;
    $af21457669944388$var$abort(event);
}
var $af21457669944388$var$block = {
    onMouseDownCapture: $af21457669944388$var$abort,
    onMouseUpCapture: $af21457669944388$var$abort,
    // because we have tabIndex = -1 when disabled,
    // keyboard events can only occur when there is an overlay
    onKeyDownCapture: $af21457669944388$var$onKey,
    onKeyUpCapture: $af21457669944388$var$onKey,
    onTouchStartCapture: $af21457669944388$var$abort,
    onTouchEndCapture: $af21457669944388$var$abort,
    onPointerDownCapture: $af21457669944388$var$abort,
    onPointerUpCapture: $af21457669944388$var$abort,
    onClickCapture: $af21457669944388$var$abort,
    // Just smashing the existing onClick for good measure
    onClick: $af21457669944388$var$abort
};
var $af21457669944388$var$doNotBlock = {};
function $af21457669944388$export$2e2bcd8739ae039(_ref) {
    var isInteractive = _ref.isInteractive;
    return isInteractive ? $af21457669944388$var$doNotBlock : $af21457669944388$var$block;
}

});

parcelRegister("56aIg", function(module, exports) {
$parcel$export(module.exports, "getCss", () => $3b65d2a4fe6a7488$export$955358618f994a11);
$parcel$export(module.exports, "getIconStyle", () => $3b65d2a4fe6a7488$export$864eea3f4ec3368f);
$parcel$export(module.exports, "getContentStyle", () => $3b65d2a4fe6a7488$export$7ad0316cc0dd65a);
$parcel$export(module.exports, "getFadingCss", () => $3b65d2a4fe6a7488$export$1b5827d324e945b1);
$parcel$export(module.exports, "overlayCss", () => $3b65d2a4fe6a7488$export$1a9fe1b84c876bb5);

var $25nEq = parcelRequire("25nEq");

var $74Zh5 = parcelRequire("74Zh5");
function $3b65d2a4fe6a7488$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $3b65d2a4fe6a7488$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $3b65d2a4fe6a7488$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $3b65d2a4fe6a7488$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $3b65d2a4fe6a7488$var$gridSize = 8;
var $3b65d2a4fe6a7488$var$HAS_DISABLED_BACKGROUND = [
    'default',
    'primary',
    'danger',
    'warning'
];
// ## Button layout
//
// /------------------------------------------------------------------------------------------------------------------\
// |       →  |  ←      |          |      →  |  ←      |           |      →  |  ←      |         |      →  |  ←       |
// |  10px →  |  ← 2px  |   icon   |  2px →  |  ← 2px  |           |  2px →  |  ← 2px  |  icon   |  2px →  |  ← 10px  |
// |  padding |  margin |  before  |  margin |  margin |  content  |  margin |  margin |  after  |  margin |  padding |
// |    (12px total)    |          |    (4px total)    |           |    (4px total)    |         |    (12px total)    |
// |       →  |  ←      |          |      →  |  ←      |           |      →  |  ←      |         |      →  |  ←       |
// \------------------------------------------------------------------------------------------------------------------/
//                                           ↑                               ↑
//                                        Margins don't collapse with inline-flex
//
var $3b65d2a4fe6a7488$var$heights = {
    default: "".concat(32 / 14, "em"),
    // 32px
    compact: "".concat(24 / 14, "em"),
    none: 'auto'
};
var $3b65d2a4fe6a7488$var$lineHeights = {
    default: $3b65d2a4fe6a7488$var$heights.default,
    compact: $3b65d2a4fe6a7488$var$heights.compact,
    none: 'inherit'
};
var $3b65d2a4fe6a7488$var$padding = {
    // 10px gutter
    default: "0 ".concat($3b65d2a4fe6a7488$var$gridSize + $3b65d2a4fe6a7488$var$gridSize / 4, "px"),
    compact: "0 ".concat($3b65d2a4fe6a7488$var$gridSize + $3b65d2a4fe6a7488$var$gridSize / 4, "px"),
    none: '0'
};
var $3b65d2a4fe6a7488$var$singleIconPadding = {
    // 2px gutter
    compact: "0 ".concat($3b65d2a4fe6a7488$var$gridSize / 4, "px"),
    default: "0 ".concat($3b65d2a4fe6a7488$var$gridSize / 4, "px"),
    none: '0'
};
var $3b65d2a4fe6a7488$var$verticalAlign = {
    default: 'middle',
    compact: 'middle',
    none: 'baseline'
};
var $3b65d2a4fe6a7488$var$innerMargin = {
    content: "0 ".concat($3b65d2a4fe6a7488$var$gridSize / 4, "px"),
    icon: "0 ".concat($3b65d2a4fe6a7488$var$gridSize / 4, "px")
};
var $3b65d2a4fe6a7488$var$defaultAfterStyles = {
    borderRadius: 'inherit',
    inset: "var(--ds-space-0, 0px)",
    borderStyle: 'solid',
    borderWidth: "var(--ds-border-width, 1px)",
    pointerEvents: 'none',
    position: 'absolute'
};
var $3b65d2a4fe6a7488$var$defaultStyles = {
    background: "var(--ds-background-neutral-subtle, #00000000)",
    color: "var(--ds-text, #292A2E)",
    '&::after': $3b65d2a4fe6a7488$var$_objectSpread($3b65d2a4fe6a7488$var$_objectSpread({}, $3b65d2a4fe6a7488$var$defaultAfterStyles), {}, {
        content: '""',
        borderColor: "var(--ds-border, #0B120E24)"
    }),
    '&:hover': {
        background: "var(--ds-background-neutral-hovered, #0B120E24)"
    },
    '&:active': {
        background: "var(--ds-background-neutral-pressed, #080F214A)"
    },
    '&[data-has-overlay="true"]:not([disabled]):hover': {
        background: "var(--ds-background-neutral-subtle, #00000000)"
    },
    '&:disabled[disabled]': {
        background: "var(--ds-background-neutral-subtle, #00000000)"
    },
    '&:disabled[disabled]:hover': {
        background: "var(--ds-background-neutral-subtle, #00000000)"
    },
    '&:disabled[disabled]:active': {
        background: "var(--ds-background-neutral-subtle, #00000000)"
    }
};
var $3b65d2a4fe6a7488$var$primaryStyles = {
    background: "var(--ds-background-brand-bold, #1868DB)",
    color: "var(--ds-text-inverse, #FFFFFF)",
    '&:hover': {
        background: "var(--ds-background-brand-bold-hovered, #1558BC)"
    },
    '&:active': {
        background: "var(--ds-background-brand-bold-pressed, #144794)"
    },
    '&[data-has-overlay="true"]:not([disabled]):hover': {
        background: "var(--ds-background-brand-bold, #1868DB)"
    }
};
var $3b65d2a4fe6a7488$var$linkStyles = {
    background: 'transparent',
    color: "var(--ds-link, #1868DB)",
    '&:hover': {
        color: "var(--ds-link, #1868DB)",
        textDecoration: 'underline'
    },
    '&:active': {
        color: "var(--ds-link-pressed, #1558BC)",
        textDecoration: 'underline'
    }
};
var $3b65d2a4fe6a7488$var$subtleStyles = {
    background: 'transparent',
    color: "var(--ds-text-subtle, #505258)",
    '&:hover': {
        background: "var(--ds-background-neutral-subtle-hovered, #0515240F)"
    },
    '&:active': {
        background: "var(--ds-background-neutral-subtle-pressed, #0B120E24)"
    },
    '&[data-has-overlay="true"]:not([disabled]):hover': {
        background: 'transparent'
    }
};
var $3b65d2a4fe6a7488$var$subtleLinkStyles = {
    background: 'transparent',
    color: "var(--ds-text-subtle, #505258)",
    '&:hover': {
        background: 'transparent',
        color: "var(--ds-text-subtle, #505258)",
        textDecoration: 'underline'
    },
    '&:active': {
        background: 'transparent',
        color: "var(--ds-text, #292A2E)",
        textDecoration: 'underline'
    }
};
var $3b65d2a4fe6a7488$var$warningStyles = {
    background: "var(--ds-background-warning-bold, #FBC828)",
    color: "var(--ds-text-warning-inverse, #292A2E)",
    '&:hover': {
        background: "var(--ds-background-warning-bold-hovered, #FCA700)"
    },
    '&:active': {
        background: "var(--ds-background-warning-bold-pressed, #F68909)"
    },
    '&[data-has-overlay="true"]:not([disabled]):hover': {
        background: "var(--ds-background-warning-bold, #FBC828)"
    }
};
var $3b65d2a4fe6a7488$var$dangerStyles = {
    background: "var(--ds-background-danger-bold, #C9372C)",
    color: "var(--ds-text-inverse, #FFFFFF)",
    '&:hover': {
        background: "var(--ds-background-danger-bold-hovered, #AE2E24)"
    },
    '&:active': {
        background: "var(--ds-background-danger-bold-pressed, #872821)"
    },
    '&[data-has-overlay="true"]:not([disabled]):hover': {
        background: "var(--ds-background-danger-bold, #C9372C)"
    }
};
var $3b65d2a4fe6a7488$var$selectedStyles = {
    background: "var(--ds-background-selected, #E9F2FE)",
    color: "var(--ds-text-selected, #1868DB)",
    '&:not([disabled])::after': $3b65d2a4fe6a7488$var$_objectSpread($3b65d2a4fe6a7488$var$_objectSpread({}, $3b65d2a4fe6a7488$var$defaultAfterStyles), {}, {
        content: '""',
        borderColor: "var(--ds-border-selected, #1868DB)"
    })
};
var $3b65d2a4fe6a7488$var$hasOverlayStyles = {
    '&[data-has-overlay="true"]': {
        cursor: 'default',
        textDecoration: 'none'
    }
};
function $3b65d2a4fe6a7488$export$955358618f994a11(_ref) {
    var appearance = _ref.appearance, spacing = _ref.spacing, isSelected = _ref.isSelected, shouldFitContainer = _ref.shouldFitContainer, isOnlySingleIcon = _ref.isOnlySingleIcon;
    return $3b65d2a4fe6a7488$var$_objectSpread($3b65d2a4fe6a7488$var$_objectSpread({
        // 0px margin added to css-reset
        alignItems: 'baseline',
        borderWidth: 0,
        borderRadius: "var(--ds-radius-small, 3px)",
        boxSizing: 'border-box',
        display: 'inline-flex',
        fontSize: 'inherit',
        fontStyle: 'normal',
        // Chrome recently changed button so that they use 'arial' as the font family
        fontFamily: 'inherit',
        fontWeight: "var(--ds-font-weight-medium, 500)",
        // margin for button has been applied to css reset
        maxWidth: '100%',
        // Needed to position overlay
        position: 'relative',
        textAlign: 'center',
        textDecoration: 'none',
        transition: 'background 0.1s ease-out, box-shadow 0.15s cubic-bezier(0.47, 0.03, 0.49, 1.38)',
        whiteSpace: 'nowrap',
        cursor: 'pointer',
        height: $3b65d2a4fe6a7488$var$heights[spacing],
        lineHeight: $3b65d2a4fe6a7488$var$lineHeights[spacing],
        padding: isOnlySingleIcon ? $3b65d2a4fe6a7488$var$singleIconPadding[spacing] : $3b65d2a4fe6a7488$var$padding[spacing],
        verticalAlign: $3b65d2a4fe6a7488$var$verticalAlign[spacing],
        width: shouldFitContainer ? '100%' : 'auto',
        // justifyContent required for shouldFitContainer buttons with an icon inside
        justifyContent: 'center'
    }, isSelected ? $3b65d2a4fe6a7488$var$selectedStyles : $3b65d2a4fe6a7488$var$_objectSpread($3b65d2a4fe6a7488$var$_objectSpread($3b65d2a4fe6a7488$var$_objectSpread($3b65d2a4fe6a7488$var$_objectSpread($3b65d2a4fe6a7488$var$_objectSpread($3b65d2a4fe6a7488$var$_objectSpread($3b65d2a4fe6a7488$var$_objectSpread($3b65d2a4fe6a7488$var$_objectSpread({}, appearance === 'default' && $3b65d2a4fe6a7488$var$defaultStyles), appearance === 'primary' && $3b65d2a4fe6a7488$var$primaryStyles), appearance === 'link' && $3b65d2a4fe6a7488$var$linkStyles), appearance === 'subtle' && $3b65d2a4fe6a7488$var$subtleStyles), appearance === 'subtle-link' && $3b65d2a4fe6a7488$var$subtleLinkStyles), appearance === 'warning' && $3b65d2a4fe6a7488$var$warningStyles), appearance === 'danger' && $3b65d2a4fe6a7488$var$dangerStyles), {}, {
        '&[disabled]': {
            color: "var(--ds-text-disabled, #080F214A)",
            backgroundColor: $3b65d2a4fe6a7488$var$HAS_DISABLED_BACKGROUND.includes(appearance) ? "var(--ds-background-disabled, #17171708)" : 'transparent',
            cursor: 'not-allowed',
            textDecoration: 'none',
            '&:hovered': {
                backgroundColor: $3b65d2a4fe6a7488$var$HAS_DISABLED_BACKGROUND.includes(appearance) ? "var(--ds-background-disabled, #17171708)" : 'transparent'
            },
            '&:active': {
                backgroundColor: $3b65d2a4fe6a7488$var$HAS_DISABLED_BACKGROUND.includes(appearance) ? "var(--ds-background-disabled, #17171708)" : 'transparent'
            }
        }
    }, $3b65d2a4fe6a7488$var$hasOverlayStyles)), {}, {
        '&::-moz-focus-inner': {
            border: 0,
            margin: 0,
            padding: 0
        }
    });
}
function $3b65d2a4fe6a7488$export$864eea3f4ec3368f(_ref2) {
    var spacing = _ref2.spacing;
    return (0, $74Zh5.css)({
        display: 'flex',
        // icon size cannot grow and shrink
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        margin: spacing === 'none' ? 0 : $3b65d2a4fe6a7488$var$innerMargin.icon,
        flexGrow: 0,
        flexShrink: 0,
        alignSelf: 'center',
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        fontSize: 0,
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        lineHeight: 0,
        userSelect: 'none'
    });
}
function $3b65d2a4fe6a7488$export$7ad0316cc0dd65a(_ref3) {
    var spacing = _ref3.spacing;
    return (0, $74Zh5.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        margin: spacing === 'none' ? 0 : $3b65d2a4fe6a7488$var$innerMargin.content,
        // content can grow and shrink
        flexGrow: 1,
        flexShrink: 1,
        // ellipsis for overflow text
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap'
    });
}
function $3b65d2a4fe6a7488$export$1b5827d324e945b1(_ref4) {
    var hasOverlay = _ref4.hasOverlay;
    return (0, $74Zh5.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        opacity: hasOverlay ? 0 : 1,
        transition: 'opacity 0.3s'
    });
}
var $3b65d2a4fe6a7488$export$1a9fe1b84c876bb5 = {
    // stretching to full width / height of button
    // this is important as we need it to still block
    // event if clicking in the button's own padding
    position: 'absolute',
    left: 0,
    top: 0,
    right: 0,
    bottom: 0,
    // Putting all children in the center
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
};

});

parcelRegister("kcV4s", function(module, exports) {
$parcel$export(module.exports, "getIfVisuallyHiddenChildren", () => $eb6132b48d587eca$export$20bbd2efb0d734c4);

var $5FkrB = parcelRequire("5FkrB");

var $e8kqY = parcelRequire("e8kqY");
var $eb6132b48d587eca$export$20bbd2efb0d734c4 = function getIfVisuallyHiddenChildren(children) {
    return children && /*#__PURE__*/ (0, $5FkrB.isValidElement)(children) && children.type === (0, $e8kqY.default);
};

});


parcelRegister("6R7Di", function(module, exports) {
$parcel$export(module.exports, "default", () => $4fdd9d09d2bfaab9$export$2e2bcd8739ae039);

var $kcV4s = parcelRequire("kcV4s");
function $4fdd9d09d2bfaab9$export$2e2bcd8739ae039(_ref) {
    var children = _ref.children, iconBefore = _ref.iconBefore, iconAfter = _ref.iconAfter;
    if ((0, $kcV4s.getIfVisuallyHiddenChildren)(children)) return true;
    if (children) return false;
    if (iconBefore && !iconAfter) return true;
    if (!iconBefore && iconAfter) return true;
    return false;
}

});


parcelRegister("3UCXU", function(module, exports) {
$parcel$export(module.exports, "AdminIcon", () => $2d94d3bb9b62d159$export$ef8e5f836dd989d3);
$parcel$export(module.exports, "AdminLogo", () => $2d94d3bb9b62d159$export$ebcd30672e67406);
$parcel$export(module.exports, "AnalyticsIcon", () => $2d94d3bb9b62d159$export$af3460f51ce3602a);
$parcel$export(module.exports, "AnalyticsLogo", () => $2d94d3bb9b62d159$export$c8415b6abe4a8587);
$parcel$export(module.exports, "AssetsIcon", () => $2d94d3bb9b62d159$export$d89497e7f33ca6f5);
$parcel$export(module.exports, "AssetsLogo", () => $2d94d3bb9b62d159$export$48ca930f3071e3e4);
$parcel$export(module.exports, "ChatIcon", () => $2d94d3bb9b62d159$export$52cd484a7ef4f2b9);
$parcel$export(module.exports, "ChatLogo", () => $2d94d3bb9b62d159$export$9ca9881809919df8);
$parcel$export(module.exports, "CustomerServiceManagementIcon", () => $2d94d3bb9b62d159$export$6da5aa77c402ba0f);
$parcel$export(module.exports, "CustomerServiceManagementLogo", () => $2d94d3bb9b62d159$export$abc95e6180bb1d88);
$parcel$export(module.exports, "FeedbackIcon", () => $2d94d3bb9b62d159$export$34420f0520b19b1d);
$parcel$export(module.exports, "FeedbackLogo", () => $2d94d3bb9b62d159$export$c9696eb3c34c5a96);
$parcel$export(module.exports, "GoalsIcon", () => $2d94d3bb9b62d159$export$9eb74917ea768ed4);
$parcel$export(module.exports, "GoalsLogo", () => $2d94d3bb9b62d159$export$d2577aa28451395f);
$parcel$export(module.exports, "HomeIcon", () => $2d94d3bb9b62d159$export$92c8767b874048d);
$parcel$export(module.exports, "HomeLogo", () => $2d94d3bb9b62d159$export$d5648119d5b68e90);
$parcel$export(module.exports, "HubIcon", () => $2d94d3bb9b62d159$export$80b8b269d8b5014e);
$parcel$export(module.exports, "HubLogo", () => $2d94d3bb9b62d159$export$fc9bd6687b80fe3b);
$parcel$export(module.exports, "ProjectsIcon", () => $2d94d3bb9b62d159$export$5ed3e1bb3b04fc02);
$parcel$export(module.exports, "ProjectsLogo", () => $2d94d3bb9b62d159$export$aeefab651bcf2338);
$parcel$export(module.exports, "RovoDevIcon", () => $2d94d3bb9b62d159$export$8b784b3227531b3e);
$parcel$export(module.exports, "RovoDevLogo", () => $2d94d3bb9b62d159$export$f0750468d67c6902);
$parcel$export(module.exports, "RovoDevAgentIcon", () => $2d94d3bb9b62d159$export$813cff80931d9dbf);
$parcel$export(module.exports, "RovoDevAgentLogo", () => $2d94d3bb9b62d159$export$409b7a5b7f180eba);
$parcel$export(module.exports, "SearchIcon", () => $2d94d3bb9b62d159$export$82eafebb825fc23f);
$parcel$export(module.exports, "SearchLogo", () => $2d94d3bb9b62d159$export$e4c5487c9a8ae3b1);
$parcel$export(module.exports, "StudioIcon", () => $2d94d3bb9b62d159$export$290a0f24614cde9f);
$parcel$export(module.exports, "StudioLogo", () => $2d94d3bb9b62d159$export$8aceb78c659789b6);
$parcel$export(module.exports, "TalentIcon", () => $2d94d3bb9b62d159$export$4b05688514531169);
$parcel$export(module.exports, "TalentLogo", () => $2d94d3bb9b62d159$export$4f6453e012279f89);
$parcel$export(module.exports, "TeamsIcon", () => $2d94d3bb9b62d159$export$1bcbc9c337da86da);
$parcel$export(module.exports, "TeamsLogo", () => $2d94d3bb9b62d159$export$9b1a0a0c574cec2a);
$parcel$export(module.exports, "BambooIcon", () => $2d94d3bb9b62d159$export$e812398311cab9a3);
$parcel$export(module.exports, "BambooLogo", () => $2d94d3bb9b62d159$export$765f5afcc1a5a7e3);
$parcel$export(module.exports, "BitbucketDataCenterIcon", () => $2d94d3bb9b62d159$export$d3ab16bbf4f954ee);
$parcel$export(module.exports, "BitbucketDataCenterLogo", () => $2d94d3bb9b62d159$export$36044946916e84a0);
$parcel$export(module.exports, "ConfluenceDataCenterIcon", () => $2d94d3bb9b62d159$export$53305f1f2855d3be);
$parcel$export(module.exports, "ConfluenceDataCenterLogo", () => $2d94d3bb9b62d159$export$5e06396bce773a3);
$parcel$export(module.exports, "CrowdIcon", () => $2d94d3bb9b62d159$export$eaf73f391f7103bd);
$parcel$export(module.exports, "CrowdLogo", () => $2d94d3bb9b62d159$export$6128b385660fd3c6);
$parcel$export(module.exports, "JiraDataCenterIcon", () => $2d94d3bb9b62d159$export$f8455b5667a3ee0c);
$parcel$export(module.exports, "JiraDataCenterLogo", () => $2d94d3bb9b62d159$export$eb152ab3801b2ae3);
$parcel$export(module.exports, "JiraServiceManagementDataCenterIcon", () => $2d94d3bb9b62d159$export$65fae0eaf343f2ca);
$parcel$export(module.exports, "JiraServiceManagementDataCenterLogo", () => $2d94d3bb9b62d159$export$fffc0d480fb1ebf1);
$parcel$export(module.exports, "AtlassianAdministrationIcon", () => $2d94d3bb9b62d159$export$74517ed253186308);
$parcel$export(module.exports, "AtlassianAdministrationLogo", () => $2d94d3bb9b62d159$export$833abe6c2ce5ebfd);
$parcel$export(module.exports, "AtlassianAdminIcon", () => $2d94d3bb9b62d159$export$84109e099492cb5f);
$parcel$export(module.exports, "AtlassianAdminLogo", () => $2d94d3bb9b62d159$export$f845d9b9254f0541);
$parcel$export(module.exports, "AtlassianAnalyticsIcon", () => $2d94d3bb9b62d159$export$c42ad8a0b925c762);
$parcel$export(module.exports, "AtlassianAnalyticsLogo", () => $2d94d3bb9b62d159$export$e6470bfc39010cc4);
$parcel$export(module.exports, "BitbucketIcon", () => $2d94d3bb9b62d159$export$5fc1066e677788d4);
$parcel$export(module.exports, "BitbucketLogo", () => $2d94d3bb9b62d159$export$bd40525f5333524b);
$parcel$export(module.exports, "CompassIcon", () => $2d94d3bb9b62d159$export$f7857fe64d7161d9);
$parcel$export(module.exports, "CompassLogo", () => $2d94d3bb9b62d159$export$eb7d748e4f9c9676);
$parcel$export(module.exports, "DxIcon", () => $2d94d3bb9b62d159$export$9951d02c2d848122);
$parcel$export(module.exports, "ConfluenceIcon", () => $2d94d3bb9b62d159$export$68f3db7f6af48bcb);
$parcel$export(module.exports, "ConfluenceLogo", () => $2d94d3bb9b62d159$export$1b2e4fe6ef471556);
$parcel$export(module.exports, "AlignIcon", () => $2d94d3bb9b62d159$export$70a0c2f5862937b6);
$parcel$export(module.exports, "AlignLogo", () => $2d94d3bb9b62d159$export$1b8596b4b0ef673b);
$parcel$export(module.exports, "JiraAlignIcon", () => $2d94d3bb9b62d159$export$407687b2dd89cc68);
$parcel$export(module.exports, "JiraAlignLogo", () => $2d94d3bb9b62d159$export$ee11e928d3d045fd);
$parcel$export(module.exports, "JiraIcon", () => $2d94d3bb9b62d159$export$c4b5b1f965d8b3eb);
$parcel$export(module.exports, "JiraLogo", () => $2d94d3bb9b62d159$export$17d3acb0b4379d02);
$parcel$export(module.exports, "JiraProductDiscoveryIcon", () => $2d94d3bb9b62d159$export$21bfbeb62fdcce8d);
$parcel$export(module.exports, "JiraProductDiscoveryLogo", () => $2d94d3bb9b62d159$export$c49a2b642fe9eef4);
$parcel$export(module.exports, "JiraServiceManagementIcon", () => $2d94d3bb9b62d159$export$3c6158790f5e01c4);
$parcel$export(module.exports, "JiraServiceManagementLogo", () => $2d94d3bb9b62d159$export$dabef2be6cd28c20);
$parcel$export(module.exports, "LoomIcon", () => $2d94d3bb9b62d159$export$8d789f76fde3e05);
$parcel$export(module.exports, "LoomLogo", () => $2d94d3bb9b62d159$export$94e206806e36c2ec);
$parcel$export(module.exports, "LoomAttributionIcon", () => $2d94d3bb9b62d159$export$1bf47cdade1a9fcb);
$parcel$export(module.exports, "LoomAttributionLogo", () => $2d94d3bb9b62d159$export$6e87ce8d41eda665);
$parcel$export(module.exports, "LoomBlurpleLogo", () => $2d94d3bb9b62d159$export$e84e925618e0e5bc);
$parcel$export(module.exports, "LoomBlurpleIcon", () => $2d94d3bb9b62d159$export$1940ba72c868b663);
$parcel$export(module.exports, "OpsgenieIcon", () => $2d94d3bb9b62d159$export$eeccc49dc7a12d9f);
$parcel$export(module.exports, "OpsgenieLogo", () => $2d94d3bb9b62d159$export$a1c6484cdecc2c4b);
$parcel$export(module.exports, "StatuspageIcon", () => $2d94d3bb9b62d159$export$f3f5aa321d88adf9);
$parcel$export(module.exports, "StatuspageLogo", () => $2d94d3bb9b62d159$export$bb4ae5b41b43be04);
$parcel$export(module.exports, "TrelloIcon", () => $2d94d3bb9b62d159$export$4384da9b8b140bf4);
$parcel$export(module.exports, "TrelloLogo", () => $2d94d3bb9b62d159$export$60e26212f3b61a28);
$parcel$export(module.exports, "RovoIcon", () => $2d94d3bb9b62d159$export$e23ae35269442b4f);
$parcel$export(module.exports, "RovoLogo", () => $2d94d3bb9b62d159$export$a0f6cb8061290bbb);
$parcel$export(module.exports, "GuardIcon", () => $2d94d3bb9b62d159$export$3f95fcfdc25a741d);
$parcel$export(module.exports, "GuardLogo", () => $2d94d3bb9b62d159$export$a4a891d202775deb);
$parcel$export(module.exports, "FocusIcon", () => $2d94d3bb9b62d159$export$1e02e7298035a77c);
$parcel$export(module.exports, "FocusLogo", () => $2d94d3bb9b62d159$export$33908560ea1b226d);
$parcel$export(module.exports, "AtlasIcon", () => (parcelRequire("5CptS")).AtlasIcon);
$parcel$export(module.exports, "AtlasLogo", () => (parcelRequire("d7OBx")).AtlasLogo);
$parcel$export(module.exports, "AtlassianMarketplaceIcon", () => (parcelRequire("6ChEY")).AtlassianMarketplaceIcon);
$parcel$export(module.exports, "AtlassianMarketplaceLogo", () => (parcelRequire("1jkeE")).AtlassianMarketplaceLogo);
$parcel$export(module.exports, "AtlassianAccessIcon", () => (parcelRequire("1kQ25")).AtlassianAccessIcon);
$parcel$export(module.exports, "AtlassianAccessLogo", () => (parcelRequire("jaTZO")).AtlassianAccessLogo);
$parcel$export(module.exports, "JiraWorkManagementLogo", () => (parcelRequire("2avQD")).JiraWorkManagementLogo);
$parcel$export(module.exports, "JiraWorkManagementIcon", () => (parcelRequire("8U9hf")).JiraWorkManagementIcon);
$parcel$export(module.exports, "AtlassianIcon", () => (parcelRequire("6SaK6")).AtlassianIcon);
$parcel$export(module.exports, "AtlassianLogo", () => (parcelRequire("6an3z")).AtlassianLogo);
$parcel$export(module.exports, "JiraSoftwareIcon", () => (parcelRequire("18tda")).JiraSoftwareIcon);
$parcel$export(module.exports, "JiraSoftwareLogo", () => (parcelRequire("fH0DS")).JiraSoftwareLogo);

var $lNaat = parcelRequire("lNaat");
var $beGt5 = parcelRequire("beGt5");

var $iwCFQ = parcelRequire("iwCFQ");
var $jZ7uX = parcelRequire("jZ7uX");

var $jjKZZ = parcelRequire("jjKZZ");
var $11htg = parcelRequire("11htg");

var $FiVrT = parcelRequire("FiVrT");
var $8V4gd = parcelRequire("8V4gd");

var $3zG0O = parcelRequire("3zG0O");
var $kd0Va = parcelRequire("kd0Va");

var $7bIiV = parcelRequire("7bIiV");
var $2P88k = parcelRequire("2P88k");

var $aMzwb = parcelRequire("aMzwb");
var $cNBpl = parcelRequire("cNBpl");

var $eQTvy = parcelRequire("eQTvy");
var $ib3Rw = parcelRequire("ib3Rw");

var $6uRkc = parcelRequire("6uRkc");
var $9kRIm = parcelRequire("9kRIm");

var $gpCpU = parcelRequire("gpCpU");
var $jNs4V = parcelRequire("jNs4V");

var $1zQC4 = parcelRequire("1zQC4");
var $1YppB = parcelRequire("1YppB");

var $dEB2Z = parcelRequire("dEB2Z");
var $a1pB5 = parcelRequire("a1pB5");

var $gzMbQ = parcelRequire("gzMbQ");
var $JVOL1 = parcelRequire("JVOL1");

var $8CgoB = parcelRequire("8CgoB");

var $atXVn = parcelRequire("atXVn");
var $gEaeW = parcelRequire("gEaeW");

var $12lOh = parcelRequire("12lOh");
var $6Gyhf = parcelRequire("6Gyhf");

var $ewaPX = parcelRequire("ewaPX");
var $aLeV1 = parcelRequire("aLeV1");

var $5tXYV = parcelRequire("5tXYV");
var $87aEy = parcelRequire("87aEy");

var $jdkdw = parcelRequire("jdkdw");
var $9pivQ = parcelRequire("9pivQ");

var $2RnSC = parcelRequire("2RnSC");
var $3fC3N = parcelRequire("3fC3N");

var $aEDe1 = parcelRequire("aEDe1");
var $9sCCX = parcelRequire("9sCCX");

var $8zpHc = parcelRequire("8zpHc");
var $g0F9F = parcelRequire("g0F9F");

var $3SdKt = parcelRequire("3SdKt");
var $izl08 = parcelRequire("izl08");

var $jty2s = parcelRequire("jty2s");
var $1p7KT = parcelRequire("1p7KT");

var $awgu0 = parcelRequire("awgu0");
var $5kGHj = parcelRequire("5kGHj");

var $9Pjay = parcelRequire("9Pjay");
var $eA2xZ = parcelRequire("eA2xZ");

var $iRpxr = parcelRequire("iRpxr");

var $iKWpX = parcelRequire("iKWpX");
var $lDqIQ = parcelRequire("lDqIQ");

var $9xbYh = parcelRequire("9xbYh");
var $2NdJB = parcelRequire("2NdJB");

var $5EewE = parcelRequire("5EewE");
var $8aLuz = parcelRequire("8aLuz");

var $gyPXc = parcelRequire("gyPXc");
var $gfYST = parcelRequire("gfYST");

var $2bpv8 = parcelRequire("2bpv8");
var $72U8T = parcelRequire("72U8T");

var $6Nhmh = parcelRequire("6Nhmh");
var $lgl6y = parcelRequire("lgl6y");

var $5PyYT = parcelRequire("5PyYT");
var $7yocG = parcelRequire("7yocG");

var $1kJW6 = parcelRequire("1kJW6");
var $fw4L7 = parcelRequire("fw4L7");

var $3AOCL = parcelRequire("3AOCL");
var $6jsao = parcelRequire("6jsao");

var $ifRjy = parcelRequire("ifRjy");
var $h2gXe = parcelRequire("h2gXe");

var $aWEED = parcelRequire("aWEED");
var $2FAht = parcelRequire("2FAht");

var $dLdBg = parcelRequire("dLdBg");
var $eyiAX = parcelRequire("eyiAX");

var $bmTy7 = parcelRequire("bmTy7");
var $i8Cp2 = parcelRequire("i8Cp2");

var $2rcE7 = parcelRequire("2rcE7");
var $bjGEe = parcelRequire("bjGEe");

var $d1bks = parcelRequire("d1bks");
var $5AUhS = parcelRequire("5AUhS");

var $4tvuf = parcelRequire("4tvuf");
var $auCk2 = parcelRequire("auCk2");

var $6FLNG = parcelRequire("6FLNG");
var $iGLN6 = parcelRequire("iGLN6");

var $beTKF = parcelRequire("beTKF");
var $kikns = parcelRequire("kikns");

var $1VIl7 = parcelRequire("1VIl7");
var $cFIJ9 = parcelRequire("cFIJ9");

var $5kN3x = parcelRequire("5kN3x");
var $hh6lD = parcelRequire("hh6lD");

var $lrODD = parcelRequire("lrODD");
var $6priL = parcelRequire("6priL");

var $Y36zi = parcelRequire("Y36zi");
var $8aVKe = parcelRequire("8aVKe");

var $dMtPL = parcelRequire("dMtPL");
var $iJohS = parcelRequire("iJohS");

var $7b7qW = parcelRequire("7b7qW");
var $50GiU = parcelRequire("50GiU");

var $eHm4v = parcelRequire("eHm4v");
var $5V5je = parcelRequire("5V5je");

var $ib7qW = parcelRequire("ib7qW");
var $j9T9X = parcelRequire("j9T9X");

var $3aS7P = parcelRequire("3aS7P");
var $7iJWj = parcelRequire("7iJWj");

var $1Ecyk = parcelRequire("1Ecyk");
var $9Cz1a = parcelRequire("9Cz1a");

var $cXDs6 = parcelRequire("cXDs6");
var $cCXyV = parcelRequire("cCXyV");

var $jF9fd = parcelRequire("jF9fd");
var $dNxlG = parcelRequire("dNxlG");

var $9QwCx = parcelRequire("9QwCx");
var $aiAVF = parcelRequire("aiAVF");

var $5CptS = parcelRequire("5CptS");
var $d7OBx = parcelRequire("d7OBx");

var $6ChEY = parcelRequire("6ChEY");
var $1jkeE = parcelRequire("1jkeE");

var $1kQ25 = parcelRequire("1kQ25");
var $jaTZO = parcelRequire("jaTZO");

var $8U9hf = parcelRequire("8U9hf");
var $2avQD = parcelRequire("2avQD");

var $6SaK6 = parcelRequire("6SaK6");
var $6an3z = parcelRequire("6an3z");

var $18tda = parcelRequire("18tda");
var $fH0DS = parcelRequire("fH0DS");

var $2u9Yf = parcelRequire("2u9Yf");
/**
 * __Admin icon__
 *
 * The Admin icon without an accompanying wordmark.
 *
 * - [Examples](https://atlassian.design/components/logo/examples)
 * - [Code](https://atlassian.design/components/logo/code)
 * - [Usage](https://atlassian.design/components/logo/usage)
 */ var $2d94d3bb9b62d159$export$ef8e5f836dd989d3 = (0, $2u9Yf.tempSizeWrapper)((0, $lNaat.AdminIcon));
var $2d94d3bb9b62d159$export$ebcd30672e67406 = (0, $2u9Yf.tempSizeWrapper)((0, $beGt5.AdminLogoCS));
var $2d94d3bb9b62d159$export$af3460f51ce3602a = (0, $2u9Yf.tempSizeWrapper)((0, $jjKZZ.AnalyticsIcon));
var $2d94d3bb9b62d159$export$c8415b6abe4a8587 = (0, $2u9Yf.tempSizeWrapper)((0, $11htg.AnalyticsLogoCS));
var $2d94d3bb9b62d159$export$d89497e7f33ca6f5 = (0, $2u9Yf.tempSizeWrapper)((0, $FiVrT.AssetsIcon));
var $2d94d3bb9b62d159$export$48ca930f3071e3e4 = (0, $2u9Yf.tempSizeWrapper)((0, $8V4gd.AssetsLogoCS));
var $2d94d3bb9b62d159$export$52cd484a7ef4f2b9 = (0, $2u9Yf.tempSizeWrapper)((0, $eQTvy.ChatIcon));
var $2d94d3bb9b62d159$export$9ca9881809919df8 = (0, $2u9Yf.tempSizeWrapper)((0, $ib3Rw.ChatLogoCS));
var $2d94d3bb9b62d159$export$6da5aa77c402ba0f = (0, $2u9Yf.tempSizeWrapper)((0, $gzMbQ.CustomerServiceManagementIcon));
var $2d94d3bb9b62d159$export$abc95e6180bb1d88 = (0, $2u9Yf.tempSizeWrapper)((0, $JVOL1.CustomerServiceManagementLogoCS));
var $2d94d3bb9b62d159$export$34420f0520b19b1d = (0, $2u9Yf.tempSizeWrapper)((0, $atXVn.FeedbackIcon));
var $2d94d3bb9b62d159$export$c9696eb3c34c5a96 = (0, $2u9Yf.tempSizeWrapper)((0, $gEaeW.FeedbackLogoCS));
var $2d94d3bb9b62d159$export$9eb74917ea768ed4 = (0, $2u9Yf.tempSizeWrapper)((0, $ewaPX.GoalsIcon));
var $2d94d3bb9b62d159$export$d2577aa28451395f = (0, $2u9Yf.tempSizeWrapper)((0, $aLeV1.GoalsLogoCS));
var $2d94d3bb9b62d159$export$92c8767b874048d = (0, $2u9Yf.tempSizeWrapper)((0, $jdkdw.HomeIcon));
var $2d94d3bb9b62d159$export$d5648119d5b68e90 = (0, $2u9Yf.tempSizeWrapper)((0, $9pivQ.HomeLogoCS));
var $2d94d3bb9b62d159$export$80b8b269d8b5014e = (0, $2u9Yf.tempSizeWrapper)((0, $2RnSC.HubIcon));
var $2d94d3bb9b62d159$export$fc9bd6687b80fe3b = (0, $2u9Yf.tempSizeWrapper)((0, $3fC3N.HubLogoCS));
var $2d94d3bb9b62d159$export$5ed3e1bb3b04fc02 = (0, $2u9Yf.tempSizeWrapper)((0, $5EewE.ProjectsIcon));
var $2d94d3bb9b62d159$export$aeefab651bcf2338 = (0, $2u9Yf.tempSizeWrapper)((0, $8aLuz.ProjectsLogoCS));
var $2d94d3bb9b62d159$export$8b784b3227531b3e = (0, $2u9Yf.tempSizeWrapper)((0, $2bpv8.RovoDevIcon));
var $2d94d3bb9b62d159$export$f0750468d67c6902 = (0, $2u9Yf.tempSizeWrapper)((0, $72U8T.RovoDevLogoCS));
var $2d94d3bb9b62d159$export$813cff80931d9dbf = (0, $2u9Yf.tempSizeWrapper)((0, $6Nhmh.RovoDevAgentIcon));
var $2d94d3bb9b62d159$export$409b7a5b7f180eba = (0, $2u9Yf.tempSizeWrapper)((0, $lgl6y.RovoDevAgentLogoCS));
var $2d94d3bb9b62d159$export$82eafebb825fc23f = (0, $2u9Yf.tempSizeWrapper)((0, $1kJW6.SearchIcon));
var $2d94d3bb9b62d159$export$e4c5487c9a8ae3b1 = (0, $2u9Yf.tempSizeWrapper)((0, $fw4L7.SearchLogoCS));
var $2d94d3bb9b62d159$export$290a0f24614cde9f = (0, $2u9Yf.tempSizeWrapper)((0, $ifRjy.StudioIcon));
var $2d94d3bb9b62d159$export$8aceb78c659789b6 = (0, $2u9Yf.tempSizeWrapper)((0, $h2gXe.StudioLogoCS));
var $2d94d3bb9b62d159$export$4b05688514531169 = (0, $2u9Yf.tempSizeWrapper)((0, $aWEED.TalentIcon));
var $2d94d3bb9b62d159$export$4f6453e012279f89 = (0, $2u9Yf.tempSizeWrapper)((0, $2FAht.TalentLogoCS));
var $2d94d3bb9b62d159$export$1bcbc9c337da86da = (0, $2u9Yf.tempSizeWrapper)((0, $dLdBg.TeamsIcon));
var $2d94d3bb9b62d159$export$9b1a0a0c574cec2a = (0, $2u9Yf.tempSizeWrapper)((0, $eyiAX.TeamsLogoCS));
var $2d94d3bb9b62d159$export$e812398311cab9a3 = (0, $2u9Yf.tempSizeWrapper)((0, $3zG0O.BambooIcon));
var $2d94d3bb9b62d159$export$765f5afcc1a5a7e3 = (0, $2u9Yf.tempSizeWrapper)((0, $kd0Va.BambooLogoCS));
var $2d94d3bb9b62d159$export$d3ab16bbf4f954ee = (0, $2u9Yf.tempSizeWrapper)((0, $aMzwb.BitbucketDataCenterIcon));
var $2d94d3bb9b62d159$export$36044946916e84a0 = (0, $2u9Yf.tempSizeWrapper)((0, $cNBpl.BitbucketDataCenterLogoCS));
var $2d94d3bb9b62d159$export$53305f1f2855d3be = (0, $2u9Yf.tempSizeWrapper)((0, $1zQC4.ConfluenceDataCenterIcon));
var $2d94d3bb9b62d159$export$5e06396bce773a3 = (0, $2u9Yf.tempSizeWrapper)((0, $1YppB.ConfluenceDataCenterLogoCS));
var $2d94d3bb9b62d159$export$eaf73f391f7103bd = (0, $2u9Yf.tempSizeWrapper)((0, $dEB2Z.CrowdIcon));
var $2d94d3bb9b62d159$export$6128b385660fd3c6 = (0, $2u9Yf.tempSizeWrapper)((0, $a1pB5.CrowdLogoCS));
var $2d94d3bb9b62d159$export$f8455b5667a3ee0c = (0, $2u9Yf.tempSizeWrapper)((0, $8zpHc.JiraDataCenterIcon));
var $2d94d3bb9b62d159$export$eb152ab3801b2ae3 = (0, $2u9Yf.tempSizeWrapper)((0, $g0F9F.JiraDataCenterLogoCS));
var $2d94d3bb9b62d159$export$65fae0eaf343f2ca = (0, $2u9Yf.tempSizeWrapper)((0, $awgu0.JiraServiceManagementDataCenterIcon));
var $2d94d3bb9b62d159$export$fffc0d480fb1ebf1 = (0, $2u9Yf.tempSizeWrapper)((0, $5kGHj.JiraServiceManagementDataCenterLogoCS));
var $2d94d3bb9b62d159$export$74517ed253186308 = (0, $2u9Yf.createFeatureFlaggedComponent)((0, $d1bks.AtlassianAdministrationIcon), (0, $lNaat.AdminIcon));
var $2d94d3bb9b62d159$export$833abe6c2ce5ebfd = (0, $2u9Yf.createFeatureFlaggedComponent)((0, $5AUhS.AtlassianAdministrationLogo), (0, $beGt5.AdminLogoCS));
var $2d94d3bb9b62d159$export$84109e099492cb5f = (0, $2u9Yf.createFeatureFlaggedComponent)((0, $2rcE7.AtlassianAdminIcon), (0, $lNaat.AdminIcon));
var $2d94d3bb9b62d159$export$f845d9b9254f0541 = (0, $2u9Yf.createFeatureFlaggedComponent)((0, $bjGEe.AtlassianAdminLogo), (0, $beGt5.AdminLogoCS));
var $2d94d3bb9b62d159$export$c42ad8a0b925c762 = (0, $2u9Yf.createFeatureFlaggedComponent)((0, $4tvuf.AtlassianAnalyticsIcon), (0, $jjKZZ.AnalyticsIcon));
var $2d94d3bb9b62d159$export$e6470bfc39010cc4 = (0, $2u9Yf.createFeatureFlaggedComponent)((0, $auCk2.AtlassianAnalyticsLogo), (0, $11htg.AnalyticsLogoCS));
var $2d94d3bb9b62d159$export$5fc1066e677788d4 = (0, $2u9Yf.createFeatureFlaggedComponent)((0, $6FLNG.BitbucketIcon), (0, $7bIiV.BitbucketIcon));
var $2d94d3bb9b62d159$export$bd40525f5333524b = (0, $2u9Yf.createFeatureFlaggedComponent)((0, $iGLN6.BitbucketLogo), (0, $2P88k.BitbucketLogoCS));
var $2d94d3bb9b62d159$export$f7857fe64d7161d9 = (0, $2u9Yf.createFeatureFlaggedComponent)((0, $beTKF.CompassIcon), (0, $6uRkc.CompassIcon));
var $2d94d3bb9b62d159$export$eb7d748e4f9c9676 = (0, $2u9Yf.createFeatureFlaggedComponent)((0, $kikns.CompassLogo), (0, $9kRIm.CompassLogoCS));
var $2d94d3bb9b62d159$export$9951d02c2d848122 = (0, $2u9Yf.tempSizeWrapper)((0, $8CgoB.DxIcon));
var $2d94d3bb9b62d159$export$68f3db7f6af48bcb = (0, $2u9Yf.createFeatureFlaggedComponent)((0, $1VIl7.ConfluenceIcon), (0, $gpCpU.ConfluenceIcon));
var $2d94d3bb9b62d159$export$1b2e4fe6ef471556 = (0, $2u9Yf.createFeatureFlaggedComponent)((0, $cFIJ9.ConfluenceLogo), (0, $jNs4V.ConfluenceLogoCS));
var $2d94d3bb9b62d159$export$70a0c2f5862937b6 = (0, $2u9Yf.tempSizeWrapper)((0, $iwCFQ.AlignIcon));
var $2d94d3bb9b62d159$export$1b8596b4b0ef673b = (0, $2u9Yf.tempSizeWrapper)((0, $jZ7uX.AlignLogoCS));
var $2d94d3bb9b62d159$export$407687b2dd89cc68 = (0, $2u9Yf.createFeatureFlaggedComponent)((0, $dMtPL.JiraAlignIcon), (0, $iwCFQ.AlignIcon));
var $2d94d3bb9b62d159$export$ee11e928d3d045fd = (0, $2u9Yf.createFeatureFlaggedComponent)((0, $iJohS.JiraAlignLogo), (0, $jZ7uX.AlignLogoCS));
var $2d94d3bb9b62d159$export$c4b5b1f965d8b3eb = (0, $2u9Yf.createFeatureFlaggedComponent)((0, $Y36zi.JiraIcon), (0, $aEDe1.JiraIcon));
var $2d94d3bb9b62d159$export$17d3acb0b4379d02 = (0, $2u9Yf.createFeatureFlaggedComponent)((0, $8aVKe.JiraLogo), (0, $9sCCX.JiraLogoCS));
var $2d94d3bb9b62d159$export$21bfbeb62fdcce8d = (0, $2u9Yf.createFeatureFlaggedComponent)((0, $7b7qW.JiraProductDiscoveryIcon), (0, $3SdKt.JiraProductDiscoveryIcon));
var $2d94d3bb9b62d159$export$c49a2b642fe9eef4 = (0, $2u9Yf.createFeatureFlaggedComponent)((0, $50GiU.JiraProductDiscoveryLogo), (0, $izl08.JiraProductDiscoveryLogoCS));
var $2d94d3bb9b62d159$export$3c6158790f5e01c4 = (0, $2u9Yf.createFeatureFlaggedServiceCollectionComponent)((0, $eHm4v.JiraServiceManagementIcon), (0, $jty2s.JiraServiceManagementIcon));
var $2d94d3bb9b62d159$export$dabef2be6cd28c20 = (0, $2u9Yf.createFeatureFlaggedServiceCollectionComponent)((0, $5V5je.JiraServiceManagementLogo), (0, $1p7KT.JiraServiceManagementLogoCS));
var $2d94d3bb9b62d159$export$8d789f76fde3e05 = (0, $2u9Yf.createFeatureFlaggedComponent)((0, $ib7qW.LoomIcon), (0, $9Pjay.LoomIcon));
var $2d94d3bb9b62d159$export$94e206806e36c2ec = (0, $2u9Yf.createFeatureFlaggedComponent)((0, $j9T9X.LoomLogo), (0, $eA2xZ.LoomLogoCS));
var $2d94d3bb9b62d159$export$1bf47cdade1a9fcb = (0, $2u9Yf.createFeatureFlaggedComponent)((0, $3aS7P.LoomAttributionIcon), (0, $9Pjay.LoomIcon));
var $2d94d3bb9b62d159$export$6e87ce8d41eda665 = (0, $2u9Yf.createFeatureFlaggedComponent)((0, $7iJWj.LoomAttributionLogo), (0, $iRpxr.LoomAttributionLogoCS));
var $2d94d3bb9b62d159$export$e84e925618e0e5bc = (0, $2u9Yf.tempSizeWrapper)((0, $lDqIQ.LoomInternalLogoCS));
var $2d94d3bb9b62d159$export$1940ba72c868b663 = (0, $2u9Yf.tempSizeWrapper)((0, $iKWpX.LoomInternalIcon));
var $2d94d3bb9b62d159$export$eeccc49dc7a12d9f = (0, $2u9Yf.createFeatureFlaggedServiceCollectionComponent)((0, $1Ecyk.OpsgenieIcon), (0, $9xbYh.OpsgenieIcon));
var $2d94d3bb9b62d159$export$a1c6484cdecc2c4b = (0, $2u9Yf.createFeatureFlaggedServiceCollectionComponent)((0, $9Cz1a.OpsgenieLogo), (0, $2NdJB.OpsgenieLogoCS));
var $2d94d3bb9b62d159$export$f3f5aa321d88adf9 = (0, $2u9Yf.createFeatureFlaggedServiceCollectionComponent)((0, $jF9fd.StatuspageIcon), (0, $3AOCL.StatuspageIcon));
var $2d94d3bb9b62d159$export$bb4ae5b41b43be04 = (0, $2u9Yf.createFeatureFlaggedServiceCollectionComponent)((0, $dNxlG.StatuspageLogo), (0, $6jsao.StatuspageLogoCS));
var $2d94d3bb9b62d159$export$4384da9b8b140bf4 = (0, $2u9Yf.createFeatureFlaggedComponent)((0, $9QwCx.TrelloIcon), (0, $bmTy7.TrelloIcon));
var $2d94d3bb9b62d159$export$60e26212f3b61a28 = (0, $2u9Yf.createFeatureFlaggedComponent)((0, $aiAVF.TrelloLogo), (0, $i8Cp2.TrelloLogoCS));
var $2d94d3bb9b62d159$export$e23ae35269442b4f = (0, $2u9Yf.createFeatureFlaggedRovoComponent)((0, $cXDs6.RovoIcon), (0, $gyPXc.RovoIcon), (0, $5PyYT.RovoHexIcon));
var $2d94d3bb9b62d159$export$a0f6cb8061290bbb = (0, $2u9Yf.createFeatureFlaggedRovoComponent)((0, $cCXyV.RovoLogo), (0, $gfYST.RovoLogoCS), (0, $7yocG.RovoHexLogoCS));
var $2d94d3bb9b62d159$export$3f95fcfdc25a741d = (0, $2u9Yf.createFeatureFlaggedComponent)((0, $lrODD.GuardIcon), (0, $5tXYV.GuardIcon));
var $2d94d3bb9b62d159$export$a4a891d202775deb = (0, $2u9Yf.createFeatureFlaggedComponent)((0, $6priL.GuardLogo), (0, $87aEy.GuardLogoCS));
var $2d94d3bb9b62d159$export$1e02e7298035a77c = (0, $2u9Yf.createFeatureFlaggedComponent)((0, $5kN3x.FocusIcon), (0, $12lOh.FocusIcon));
var $2d94d3bb9b62d159$export$33908560ea1b226d = (0, $2u9Yf.createFeatureFlaggedComponent)((0, $hh6lD.FocusLogo), (0, $6Gyhf.FocusLogoCS));

});
parcelRegister("lNaat", function(module, exports) {
$parcel$export(module.exports, "AdminIcon", () => $fdd60fb407482c20$export$ef8e5f836dd989d3);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ced2179e9e0992ccb4af61b51b4f10a3>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

var $dkXTa = parcelRequire("dkXTa");
// `height` is set to 100% to allow the SVG to scale with the parent element
var $fdd60fb407482c20$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" fill-rule=\"evenodd\" d=\"M10.444 5h3.111l.98 2.61 2.75-.457 1.555 2.694L17.07 12l1.77 2.153-1.555 2.694-2.75-.457-.979 2.61h-3.11l-.98-2.61-2.75.457-1.555-2.694L6.931 12 5.16 9.847l1.555-2.694 2.75.457zM12 14.625a2.625 2.625 0 1 0 0-5.25 2.625 2.625 0 0 0 0 5.25\" clip-rule=\"evenodd\"/>\n</svg>\n";
function $fdd60fb407482c20$export$ef8e5f836dd989d3(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Admin' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $dkXTa.IconWrapper), {
        svg: $fdd60fb407482c20$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});
parcelRegister("dkXTa", function(module, exports) {
$parcel$export(module.exports, "IconWrapper", () => $9b5b994dd561b600$export$be58b4326e23250f);
/* icon-wrapper.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $5FkrB = parcelRequire("5FkrB");

var $7J6mo = parcelRequire("7J6mo");

var $9Zzpd = parcelRequire("9Zzpd");

var $fDucD = parcelRequire("fDucD");
var $9b5b994dd561b600$var$styles = {
    root: "_1e0c1o8l",
    TEMP_assets: "_9aea1fkg"
};
/* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ var $9b5b994dd561b600$var$cloudLightAppearanceMap = {
    brand: "_1b3i18uv _9aea18uv",
    neutral: "_1b3i1e01 _9aea1fkg",
    inverse: "_1b3i5a6q _9aeau67f",
    legacy: "_1b3iu67f _9aeadoyu"
};
/* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ var $9b5b994dd561b600$var$cloudDarkAppearanceMap = {
    brand: "_1b3i18uv _9aea18uv",
    neutral: "_1b3i1gvk _9aea8hz0",
    inverse: "_1b3iu67f _9aea5a6q",
    legacy: "_1b3iu67f _9aeadoyu"
};
/* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ var $9b5b994dd561b600$var$dataCenterLightAppearanceMap = {
    brand: "_1b3idoyu _9aeau67f _3wu01fkg",
    neutral: "_1b3i1e01 _9aea1fkg _3wu01e01",
    inverse: "_1b3iu67f _9aeaqlpt _3wu0u67f",
    legacy: "_1b3idoyu _9aeau67f _3wu01fkg"
};
/* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ var $9b5b994dd561b600$var$dataCenterDarkAppearanceMap = {
    brand: "_1b3idoyu _9aeaqlpt _3wu08hz0",
    neutral: "_1b3i1gvk _9aea8hz0 _3wu01gvk",
    inverse: "_1b3i1501 _9aeau67f _3wu01501",
    legacy: "_1b3idoyu _9aeaqlpt _3wu08hz0"
};
var $9b5b994dd561b600$var$rovoDarkAppearanceMap = {
    brand: "_170318uv _1evo18uv _epb518uv _1osd18uv",
    neutral: "_17031gvk _1evo1gvk _epb51gvk _1osd1gvk",
    inverse: "_1703qlpt _1evoqlpt _epb5qlpt _1osdqlpt",
    legacy: "_1703doyu _1evodoyu _epb5doyu _1osddoyu"
};
var $9b5b994dd561b600$var$rovoLightAppearanceMap = {
    brand: "_170318uv _1evo18uv _epb518uv _1osd18uv",
    neutral: "_17031e01 _1evo1e01 _epb51e01 _1osd1e01",
    inverse: "_1703u67f _1evou67f _epb5u67f _1osdu67f",
    legacy: "_1703doyu _1evodoyu _epb5doyu _1osddoyu"
};
/* eslint-enable @atlaskit/ui-styling-standard/no-imported-style-values */ /* eslint-enable @atlaskit/ui-styling-standard/no-unsafe-values */ var $9b5b994dd561b600$var$sizeMap = {
    xxsmall: "_4t3i7vkz",
    xsmall: "_4t3igktf",
    small: "_4t3i1tcg",
    medium: "_4t3izwfg",
    large: "_4t3i1ylp",
    xlarge: "_4t3ickbl",
    '12': "_4t3i1crf",
    '16': "_4t3i7vkz",
    '20': "_4t3igktf",
    '24': "_4t3i1tcg",
    '32': "_4t3izwfg"
};
function $9b5b994dd561b600$export$be58b4326e23250f(_ref) {
    var _ref$size = _ref.size, size = _ref$size === void 0 ? '20' : _ref$size, label = _ref.label, svg = _ref.svg, customThemeSvg = _ref.customThemeSvg, userDefinedTestId = _ref.testId, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, customIconColor = _ref.iconColor, _ref$isAssets = _ref.isAssets, isAssets = _ref$isAssets === void 0 ? false : _ref$isAssets, _ref$type = _ref.type, type = _ref$type === void 0 ? 'tile' : _ref$type;
    var testId = userDefinedTestId && "".concat(userDefinedTestId, "--wrapper");
    var isCustomThemed = customThemeSvg && customIconColor;
    var _useThemeObserver = (0, $fDucD.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ $5FkrB.createElement("span", {
        "data-testid": testId,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            '--themed-icon-color': customIconColor || 'initial'
        },
        "aria-label": label ? label : undefined,
        role: label ? 'img' : undefined,
        "aria-hidden": label === '' ? true : undefined,
        dangerouslySetInnerHTML: {
            __html: isCustomThemed ? customThemeSvg : svg
        },
        className: (0, $7J6mo.default)([
            $9b5b994dd561b600$var$styles.root,
            $9b5b994dd561b600$var$sizeMap[size],
            colorMode === 'dark' ? $9b5b994dd561b600$var$dataCenterDarkAppearanceMap[appearance] : $9b5b994dd561b600$var$dataCenterLightAppearanceMap[appearance],
            type === 'rovo' ? colorMode === 'dark' ? $9b5b994dd561b600$var$rovoDarkAppearanceMap[appearance] : $9b5b994dd561b600$var$rovoLightAppearanceMap[appearance] : colorMode === 'dark' ? $9b5b994dd561b600$var$cloudDarkAppearanceMap[appearance] : $9b5b994dd561b600$var$cloudLightAppearanceMap[appearance],
            isAssets && appearance === 'brand' && (0, $9Zzpd.fg)('assets-platform-branding') && $9b5b994dd561b600$var$styles.TEMP_assets
        ])
    });
}

});
parcelRegister("7J6mo", function(module, exports) {
$parcel$export(module.exports, "default", () => $5a01ab610b4214c7$export$2e2bcd8739ae039);
/**
 * This length includes the underscore,
 * e.g. `"_1s4A"` would be a valid atomic group hash.
 */ const $5a01ab610b4214c7$var$ATOMIC_GROUP_LENGTH = 5;
function $5a01ab610b4214c7$export$2e2bcd8739ae039(classNames) {
    // Shortcut: nothing to do
    if (!classNames.length) return;
    // Shortcut: don't need to do anything if we only have a single classname
    if (classNames.length === 1 && classNames[0] && // checking to see if `classNames[0]` is a string that contains other classnames
    !classNames[0].includes(' ')) return classNames[0];
    // Using an object rather than a `Map` as it performed better in our benchmarks.
    // Would be happy to move to `Map` if it proved to be better under real conditions.
    const map = {};
    // Note: using loops to minimize iterations over the collection
    for (const value of classNames){
        // Exclude all falsy values, which leaves us with populated strings
        if (!value) continue;
        // a `value` can contain multiple classnames
        const list = value.split(' ');
        for (const className of list){
            /**
             * For atomic style classnames: the `key` is the `group`
             *
             * - Later atomic classnames with the same `group` will override earlier ones
             *   (which is what we want).
             * - Assumes atomic classnames are the only things that start with `_`
             * - Could use a regex to ensure that atomic classnames are structured how we expect,
             *   but did not add that for now as it did slow things down a bit.
             *
             * For other classnames: the `key` is the whole classname
             * - Okay to remove duplicates as doing so does not impact specificity
             *
             * */ const key = className.startsWith('_') ? className.slice(0, $5a01ab610b4214c7$var$ATOMIC_GROUP_LENGTH) : className;
            map[key] = className;
        }
    }
    /**
     * We are converting the `map` into a string.
     *
     * The simple way to do this would be `Object.values(map).join(' ')`.
     * However, the approach below performs 10%-20% better in benchmarks.
     *
     * For `ax()` it feels right to squeeze as much runtime performance out as we can.
     */ let result = '';
    for(const key in map)result += map[key] + ' ';
    // If we have an empty string, then our `map` was empty.
    if (!result) return;
    // remove last " " from the result (we added " " at the end of every value)
    return result.trimEnd();
}

});

parcelRegister("fDucD", function(module, exports) {
$parcel$export(module.exports, "default", () => $b621ed2cc6a05fa8$export$2e2bcd8739ae039);

var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");

var $esL3B = parcelRequire("esL3B");

var $cGp5R = parcelRequire("cGp5R");
/**
 * A React hook which returns the current themes and color-mode set on `<html>`.
 *
 * @example
 * ```
 * const { colorMode, dark, light, spacing, typography } = useThemeObserver();
 *
 * // Performing side effects when it changes
 * useEffect(() => {
 *   console.log(`The color mode has changed to ${theme.colorMode}`);
 * }, [theme.colorMode]);
 * ```
 */ var $b621ed2cc6a05fa8$var$useThemeObserver = function useThemeObserver() {
    var _useState = (0, $5FkrB.useState)((0, $esL3B.default)()), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), theme = _useState2[0], setTheme = _useState2[1];
    (0, $5FkrB.useEffect)(function() {
        var observer = new (0, $cGp5R.default)(function(theme) {
            return setTheme(theme);
        });
        observer.observe();
        return function() {
            return observer.disconnect();
        };
    }, []);
    return theme;
};
var $b621ed2cc6a05fa8$export$2e2bcd8739ae039 = $b621ed2cc6a05fa8$var$useThemeObserver;

});
parcelRegister("esL3B", function(module, exports) {
$parcel$export(module.exports, "default", () => $a8782ec33073b15d$export$2e2bcd8739ae039);

var $25nEq = parcelRequire("25nEq");

var $aDcyF = parcelRequire("aDcyF");

var $3Rqqi = parcelRequire("3Rqqi");

var $hxg7B = parcelRequire("hxg7B");
function $a8782ec33073b15d$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $a8782ec33073b15d$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $a8782ec33073b15d$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $a8782ec33073b15d$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $a8782ec33073b15d$var$isThemeColorMode = function isThemeColorMode(colorMode) {
    return (0, $3Rqqi.themeColorModes).find(function(mode) {
        return mode === colorMode;
    }) !== undefined;
};
var $a8782ec33073b15d$var$getGlobalTheme = function getGlobalTheme() {
    if (typeof document === 'undefined') return {};
    var element = document.documentElement;
    var colorMode = element.getAttribute((0, $aDcyF.COLOR_MODE_ATTRIBUTE)) || '';
    var theme = element.getAttribute((0, $aDcyF.THEME_DATA_ATTRIBUTE)) || '';
    return $a8782ec33073b15d$var$_objectSpread($a8782ec33073b15d$var$_objectSpread({}, (0, $hxg7B.themeStringToObject)(theme)), $a8782ec33073b15d$var$isThemeColorMode(colorMode) && {
        colorMode: colorMode
    });
};
var $a8782ec33073b15d$export$2e2bcd8739ae039 = $a8782ec33073b15d$var$getGlobalTheme;

});
parcelRegister("aDcyF", function(module, exports) {
$parcel$export(module.exports, "THEME_DATA_ATTRIBUTE", () => $7bd749b634282905$export$4ef52930e33717cd);
$parcel$export(module.exports, "COLOR_MODE_ATTRIBUTE", () => $7bd749b634282905$export$a00eac3f8684bcd0);
var $7bd749b634282905$export$4ef52930e33717cd = 'data-theme';
var $7bd749b634282905$export$cb374d25ded7f6ab = 'data-subtree-theme';
var $7bd749b634282905$export$a00eac3f8684bcd0 = 'data-color-mode';
var $7bd749b634282905$export$2112803007239c61 = 'data-contrast-mode';
var $7bd749b634282905$export$352e418ed5b6193a = 'data-custom-theme';
var $7bd749b634282905$export$6f0c6fb8c80fcc92 = 'ds';
var $7bd749b634282905$export$4d0c7bbf80185957 = [
    'opacity',
    'font',
    'space',
    'border',
    'radius'
];
var $7bd749b634282905$export$dddac1532e822863 = "--".concat($7bd749b634282905$export$6f0c6fb8c80fcc92, "-token-not-found");
var $7bd749b634282905$export$9d7b58831ae93caa = "--".concat($7bd749b634282905$export$6f0c6fb8c80fcc92, "-elevation-surface-current");

});

parcelRegister("3Rqqi", function(module, exports) {
$parcel$export(module.exports, "themeColorModes", () => $2cfad16a2607b574$export$83993de8eb66733);
$parcel$export(module.exports, "themeIds", () => $2cfad16a2607b574$export$7d43e72a58e3283f);

var $9Zzpd = parcelRequire("9Zzpd");
var $2cfad16a2607b574$export$83993de8eb66733 = [
    'light',
    'dark',
    'auto'
];
/**
 * Contrast preferences: The system contrast preference
 */ var $2cfad16a2607b574$var$themeContrastModes = [
    'more',
    'no-preference',
    'auto'
];
var $2cfad16a2607b574$export$7d43e72a58e3283f = [
    'light-increased-contrast',
    'light',
    'light-future',
    'dark',
    'dark-future',
    'dark-increased-contrast',
    'spacing',
    'shape',
    'typography',
    'motion'
];
/**
 * Theme override ids: the equivalent of themeIds for theme overrides.
 * Theme overrides are temporary and there may not be any defined at times.
 */ var $2cfad16a2607b574$var$themeOverrideIds = [];
var $2cfad16a2607b574$export$92ba366331403db2 = [].concat($2cfad16a2607b574$export$7d43e72a58e3283f, $2cfad16a2607b574$var$themeOverrideIds);
/**
 * Theme to use a base. This will create the theme as
 * an extension with all token values marked as optional
 * to allow tokens to be overridden as required.
 */ /**
 * Palettes: The set of base tokens a given theme may be populated with.
 * For example: legacy light & dark themes use the "legacyPalette" containing colors from our
 * previous color set.
 */ /**
 * ThemeConfig: the source of truth for all theme meta-data.
 * This object should be used whenever interfacing with themes.
 */ var $2cfad16a2607b574$var$themeConfig = {
    'atlassian-light': {
        id: 'light',
        displayName: 'Light Theme',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'light'
        }
    },
    'atlassian-light-future': {
        id: 'light-future',
        displayName: 'Future Light Theme',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'light'
        },
        override: 'light'
    },
    'atlassian-light-increased-contrast': {
        id: 'light-increased-contrast',
        displayName: 'Light Theme (increased contrast)',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'light'
        },
        extends: 'light',
        increasesContrastFor: 'light'
    },
    'atlassian-dark': {
        id: 'dark',
        displayName: 'Dark Theme',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'dark'
        }
    },
    'atlassian-dark-future': {
        id: 'dark-future',
        displayName: 'Future Dark Theme',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'dark'
        },
        override: 'light'
    },
    'atlassian-dark-increased-contrast': {
        id: 'dark-increased-contrast',
        displayName: 'Dark Theme (increased contrast)',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'dark'
        },
        extends: 'dark',
        increasesContrastFor: 'dark'
    },
    'atlassian-spacing': {
        id: 'spacing',
        displayName: 'Atlassian Spacing',
        palette: 'spacingScale',
        attributes: {
            type: 'spacing'
        }
    },
    'atlassian-typography': {
        id: 'typography',
        displayName: 'Atlassian Typography',
        palette: 'typographyPalette',
        attributes: {
            type: 'typography'
        }
    },
    'atlassian-shape': {
        id: 'shape',
        displayName: 'Shape',
        palette: 'shapePalette',
        attributes: {
            type: 'shape'
        }
    },
    'atlassian-motion': {
        id: 'motion',
        displayName: 'Motion',
        palette: 'motionPalette',
        attributes: {
            type: 'motion'
        }
    }
};
/**
 * ThemeOptionsSchema: additional configuration options used to customize Atlassian's themes
 */ /**
 * ThemeState: the standard representation of an app's current theme and preferences
 */ /**
 * Can't evaluate typography feature flags at the module level,
 * it will always resolve to false when server side rendered or when flags are loaded async.
 */ function $2cfad16a2607b574$var$getShapeDefault() {
    if ((0, $9Zzpd.fg)('platform-dst-shape-theme-default')) return 'shape';
    return undefined;
}
function $2cfad16a2607b574$var$getMotionDefault() {
    if ((0, $9Zzpd.fg)('platform-dst-motion-theme-default')) return 'motion';
    return undefined;
}
var $2cfad16a2607b574$export$9aedcfa7336a207 = {
    colorMode: 'auto',
    contrastMode: 'auto',
    dark: 'dark',
    light: 'light',
    shape: $2cfad16a2607b574$var$getShapeDefault,
    spacing: 'spacing',
    typography: 'typography',
    motion: $2cfad16a2607b574$var$getMotionDefault,
    UNSAFE_themeOptions: undefined
};
var /**
 * Represents theme state once mounted to the page
 * (the page doesn't have an "auto" color mode, it's either light or dark)
 */ $2cfad16a2607b574$export$2e2bcd8739ae039 = $2cfad16a2607b574$var$themeConfig;

});

parcelRegister("hxg7B", function(module, exports) {
$parcel$export(module.exports, "themeStringToObject", () => $cc42062a18ff4684$export$f19b488f7c0547ee);

var $ekGgq = parcelRequire("ekGgq");

var $iYJcE = parcelRequire("iYJcE");

var $3Rqqi = parcelRequire("3Rqqi");
var $cc42062a18ff4684$var$themeKinds = [
    'light',
    'dark',
    'spacing',
    'typography',
    'shape',
    'motion'
];
var $cc42062a18ff4684$var$customThemeOptions = 'UNSAFE_themeOptions';
var $cc42062a18ff4684$var$isThemeKind = function isThemeKind(themeKind) {
    return $cc42062a18ff4684$var$themeKinds.find(function(kind) {
        return kind === themeKind;
    }) !== undefined;
};
var $cc42062a18ff4684$var$isThemeIds = function isThemeIds(themeId) {
    return (0, $3Rqqi.themeIds).find(function(id) {
        return id === themeId;
    }) !== undefined;
};
var $cc42062a18ff4684$var$isColorMode = function isColorMode(modeId) {
    return [
        'light',
        'dark',
        'auto'
    ].includes(modeId);
};
var $cc42062a18ff4684$export$f19b488f7c0547ee = function themeStringToObject(themeState) {
    return themeState.split(' ')// @ts-ignore - TS1501 TypeScript 5.9.2 upgrade
    .map(function(theme) {
        return theme.split(/:([^]*)/);
    }).reduce(function(themeObject, _ref) {
        var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_ref, 2), kind = _ref2[0], id = _ref2[1];
        if (kind === 'colorMode' && $cc42062a18ff4684$var$isColorMode(id)) themeObject[kind] = id;
        if ($cc42062a18ff4684$var$isThemeKind(kind) && $cc42062a18ff4684$var$isThemeIds(id)) // @ts-expect-error FIXME - this is a valid ts error
        themeObject[kind] = id;
        if (kind === $cc42062a18ff4684$var$customThemeOptions) try {
            themeObject[$cc42062a18ff4684$var$customThemeOptions] = JSON.parse(id);
        } catch (_unused) {
            new Error('Invalid custom theme string');
        }
        return themeObject;
    }, {});
};
var $cc42062a18ff4684$export$62c37ab81302621a = function themeObjectToString(themeState) {
    return Object.entries(themeState).reduce(function(themeString, _ref3) {
        var _ref4 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_ref3, 2), kind = _ref4[0], id = _ref4[1];
        if (// colorMode theme state
        kind === 'colorMode' && typeof id === 'string' && $cc42062a18ff4684$var$isColorMode(id) || // custom theme state
        kind === $cc42062a18ff4684$var$customThemeOptions && (0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(id) === 'object' || // other theme states
        $cc42062a18ff4684$var$isThemeKind(kind) && typeof id === 'string' && $cc42062a18ff4684$var$isThemeIds(id)) return themeString + "".concat(themeString ? ' ' : '') + "".concat(kind, ":").concat((0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(id) === 'object' ? JSON.stringify(id) : id);
        return themeString;
    }, '');
};

});


parcelRegister("cGp5R", function(module, exports) {
$parcel$export(module.exports, "default", () => $93bcdf5970b55ff7$export$2e2bcd8739ae039);

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $25nEq = parcelRequire("25nEq");

var $aDcyF = parcelRequire("aDcyF");

var $esL3B = parcelRequire("esL3B");
/**
 * A MutationObserver which watches the `<html>` element for changes to the theme.
 *
 * In React, use the {@link useThemeObserver `useThemeObserver`} hook instead.
 *
 * @param {function} callback - A callback function which fires when the theme changes.
 *
 * @example
 * ```
 * const observer = new ThemeMutationObserver((theme) => {});
 * observer.observe();
 * ```
 */ var $93bcdf5970b55ff7$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function ThemeMutationObserver(callback) {
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, ThemeMutationObserver);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "legacyObserver", null);
        this.callback = callback;
        ThemeMutationObserver.callbacks.add(callback);
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(ThemeMutationObserver, [
        {
            key: "observe",
            value: function observe() {
                if (!ThemeMutationObserver.observer) {
                    ThemeMutationObserver.observer = new MutationObserver(function() {
                        var theme = (0, $esL3B.default)();
                        ThemeMutationObserver.callbacks.forEach(function(callback) {
                            return callback(theme);
                        });
                    });
                    // Observer only needs to be configured once
                    ThemeMutationObserver.observer.observe(document.documentElement, {
                        attributeFilter: [
                            (0, $aDcyF.THEME_DATA_ATTRIBUTE),
                            (0, $aDcyF.COLOR_MODE_ATTRIBUTE)
                        ]
                    });
                }
            }
        },
        {
            key: "disconnect",
            value: function disconnect() {
                if (this.callback) ThemeMutationObserver.callbacks.delete(this.callback);
                if (ThemeMutationObserver.callbacks.size === 0 && ThemeMutationObserver.observer) {
                    ThemeMutationObserver.observer.disconnect();
                    ThemeMutationObserver.observer = null;
                }
            }
        }
    ]);
}();
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($93bcdf5970b55ff7$export$2e2bcd8739ae039, "observer", null);
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($93bcdf5970b55ff7$export$2e2bcd8739ae039, "callbacks", new Set());

});




parcelRegister("beGt5", function(module, exports) {
$parcel$export(module.exports, "AdminLogoCS", () => $82e1f1c7094b4744$export$61afcb38c001e19);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::58c9ee3b4e44f14aa5c8a2e33c7dac51>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

var $dlBdv = parcelRequire("dlBdv");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $82e1f1c7094b4744$var$svg = "<svg height=\"100%\" viewBox=\"0 0 126 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M124.84 16.35v8.99h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.51c.98-1.81 2.79-2.82 4.85-2.82 3.53 0 5.55 2.42 5.55 6.66m-20.15-10.4c0-1.17.77-1.84 1.84-1.84s1.84.67 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-14.07-8.52v8.53h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.51c.98-1.81 2.79-2.82 4.85-2.82 2.61 0 4.39 1.32 5.15 3.74.86-2.36 2.91-3.74 5.46-3.74 3.44 0 5.34 2.33 5.34 6.66v8.99h-2.64v-8.52c0-3.16-1.1-4.72-3.62-4.72-2.45 0-4.14 1.63-4.14 4.72m-28.32.85c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V3.59h2.64v21.74zm-22.02-4.01c-1.53 0-3.1-.18-4.81-.52l-1.69 4.54h-3.1l7.94-20.15h3.5l7.94 20.15h-3.1l-1.69-4.57c-1.81.37-3.37.55-5 .55m0-2.45c1.29 0 2.61-.15 4.17-.4L49.53 7.43 45.45 18.5c1.5.25 2.76.37 3.99.37\"/>\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" fill-rule=\"evenodd\" d=\"M13.826 6.4h4.255l1.338 3.569 3.76-.626 2.128 3.684-2.422 2.945 2.421 2.943L23.18 22.6l-3.76-.626-1.338 3.57h-4.255l-1.338-3.57-3.76.625L6.6 18.915l2.421-2.943L6.6 13.028l2.127-3.685 3.76.626zm2.128 13.16a3.59 3.59 0 1 0 0-7.178 3.59 3.59 0 0 0 0 7.179\" clip-rule=\"evenodd\"/>\n</svg>\n";
function $82e1f1c7094b4744$export$61afcb38c001e19(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Admin' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $dlBdv.LogoWrapper), {
        svg: $82e1f1c7094b4744$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});
parcelRegister("dlBdv", function(module, exports) {
$parcel$export(module.exports, "LogoWrapper", () => $9b7a1b046861a04a$export$f827d3c5a9c3f644);
/* logo-wrapper.tsx generated by @compiled/babel-plugin v0.39.1 */ /* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ 
var $5FkrB = parcelRequire("5FkrB");

var $7J6mo = parcelRequire("7J6mo");

var $9Zzpd = parcelRequire("9Zzpd");

var $fDucD = parcelRequire("fDucD");
var $9b7a1b046861a04a$var$styles = {
    root: "_1e0c1o8l _vwz4idpf",
    TEMP_assets: "_9aea1fkg"
};
// These styles set the `color` property so that the child SVG can inherit the correct text color using "currentColor"
var $9b7a1b046861a04a$var$logoTextColorMap = {
    light: "_syazqlpt",
    dark: "_syazz6c6"
};
var $9b7a1b046861a04a$var$sizeMap = {
    xxsmall: "_4t3i7vkz",
    xsmall: "_4t3igktf",
    small: "_4t3i1tcg",
    medium: "_4t3izwfg",
    large: "_4t3i1ylp",
    xlarge: "_4t3ickbl"
};
/* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ var $9b7a1b046861a04a$var$textLightAppearanceMap = {
    brand: "_1wyci7uo",
    neutral: "_1wyc1e01",
    inverse: "_1wycu67f",
    legacy: "_1wycu67f"
};
/* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ var $9b7a1b046861a04a$var$textDarkAppearanceMap = {
    brand: "_1wyci7uo",
    neutral: "_1wyc1gvk",
    inverse: "_1wyc5a6q",
    legacy: "_1wycu67f"
};
/* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ var $9b7a1b046861a04a$var$cloudLightAppearanceMap = {
    brand: "_1b3i18uv _9aea18uv",
    neutral: "_1b3i1e01 _9aea1fkg",
    inverse: "_1b3i5a6q _9aeau67f",
    legacy: "_1b3iu67f _9aeadoyu"
};
/* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ var $9b7a1b046861a04a$var$cloudDarkAppearanceMap = {
    brand: "_1b3i18uv _9aea18uv",
    neutral: "_1b3i1gvk _9aea8hz0",
    inverse: "_1b3iu67f _9aea5a6q",
    legacy: "_1b3iu67f _9aeadoyu"
};
/* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ var $9b7a1b046861a04a$var$dataCenterLightAppearanceMap = {
    brand: "_1b3idoyu _9aeau67f _3wu01fkg",
    neutral: "_1b3i1e01 _9aea1fkg _3wu01e01",
    inverse: "_1b3iu67f _9aeaqlpt _3wu0u67f",
    legacy: "_1b3idoyu _9aeau67f _3wu01fkg"
};
/* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ var $9b7a1b046861a04a$var$dataCenterDarkAppearanceMap = {
    brand: "_1b3idoyu _9aeaqlpt _3wu08hz0",
    neutral: "_1b3i1gvk _9aea8hz0 _3wu01gvk",
    inverse: "_1b3i1501 _9aeau67f _3wu01501",
    legacy: "_1b3idoyu _9aeaqlpt _3wu08hz0"
};
var $9b7a1b046861a04a$var$rovoDarkAppearanceMap = {
    brand: "_1703lrxy _1evoh727 _epb51yy8 _1osdxeun",
    neutral: "_17031gvk _1evo1gvk _epb51gvk _1osd1gvk",
    inverse: "_1703qlpt _1evoqlpt _epb5qlpt _1osdqlpt",
    legacy: "_1703doyu _1evodoyu _epb5doyu _1osddoyu"
};
var $9b7a1b046861a04a$var$rovoLightAppearanceMap = {
    brand: "_170318uv _1evo18uv _epb518uv _1osd18uv",
    neutral: "_17031e01 _1evo1e01 _epb51e01 _1osd1e01",
    inverse: "_1703u67f _1evou67f _epb5u67f _1osdu67f",
    legacy: "_1703doyu _1evodoyu _epb5doyu _1osddoyu"
};
function $9b7a1b046861a04a$export$f827d3c5a9c3f644(_ref) {
    var _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$size = _ref.size, size = _ref$size === void 0 ? 'small' : _ref$size, svg = _ref.svg, customThemeSvg = _ref.customThemeSvg, label = _ref.label, userDefinedTestId = _ref.testId, customIconColor = _ref.iconColor, customTextColor = _ref.textColor, _ref$isAssets = _ref.isAssets, isAssets = _ref$isAssets === void 0 ? false : _ref$isAssets, _ref$type = _ref.type, type = _ref$type === void 0 ? 'tile' : _ref$type;
    var _useThemeObserver = (0, $fDucD.default)(), colorMode = _useThemeObserver.colorMode;
    var testId = userDefinedTestId && "".concat(userDefinedTestId, "--wrapper");
    var isCustomThemed = customThemeSvg && (customIconColor || customTextColor);
    return /*#__PURE__*/ $5FkrB.createElement("span", {
        style: {
            // Nav v3 passes in "inherit" incorrectly for iconColor, so we fall back to textColor when this happens.
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            '--themed-icon-color': customIconColor === 'inherit' ? customTextColor : customIconColor,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            '--themed-text-color': customTextColor || 'inherit'
        },
        "data-testid": testId,
        "aria-label": label ? label : undefined,
        role: label ? 'img' : undefined,
        "aria-hidden": label === '' ? true : undefined,
        dangerouslySetInnerHTML: {
            __html: isCustomThemed ? customThemeSvg : svg
        },
        className: (0, $7J6mo.default)([
            $9b7a1b046861a04a$var$styles.root,
            // Setting the color so that the SVG can inherit the correct text color using "currentColor"
            $9b7a1b046861a04a$var$logoTextColorMap[colorMode !== null && colorMode !== void 0 ? colorMode : 'light'],
            $9b7a1b046861a04a$var$sizeMap[size],
            colorMode === 'dark' ? $9b7a1b046861a04a$var$textDarkAppearanceMap[appearance] : $9b7a1b046861a04a$var$textLightAppearanceMap[appearance],
            colorMode === 'dark' ? $9b7a1b046861a04a$var$dataCenterDarkAppearanceMap[appearance] : $9b7a1b046861a04a$var$dataCenterLightAppearanceMap[appearance],
            type === 'rovo' ? colorMode === 'dark' ? $9b7a1b046861a04a$var$rovoDarkAppearanceMap[appearance] : $9b7a1b046861a04a$var$rovoLightAppearanceMap[appearance] : colorMode === 'dark' ? $9b7a1b046861a04a$var$cloudDarkAppearanceMap[appearance] : $9b7a1b046861a04a$var$cloudLightAppearanceMap[appearance],
            isAssets && appearance === 'brand' && (0, $9Zzpd.fg)('assets-platform-branding') && $9b7a1b046861a04a$var$styles.TEMP_assets
        ])
    });
}

});


parcelRegister("iwCFQ", function(module, exports) {
$parcel$export(module.exports, "AlignIcon", () => $d7c936ff53cc5c33$export$70a0c2f5862937b6);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::9c308d558bb8f01b0a6c887a98e5347d>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

var $dkXTa = parcelRequire("dkXTa");
// `height` is set to 100% to allow the SVG to scale with the parent element
var $d7c936ff53cc5c33$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#fb9700)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M18.545 18.545a4.49 4.49 0 0 0-4.48-4.48h-4.13v-3.78h-4.48v7.434c0 .576.25.826.826.826zM5.455 5.455a4.454 4.454 0 0 0 4.455 4.48h4.155v3.78h4.48V6.28q0-.825-.826-.826z\"/>\n</svg>\n";
function $d7c936ff53cc5c33$export$70a0c2f5862937b6(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Align' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $dkXTa.IconWrapper), {
        svg: $d7c936ff53cc5c33$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("jZ7uX", function(module, exports) {
$parcel$export(module.exports, "AlignLogoCS", () => $e8c987d7492ee286$export$8b5103382c06639c);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4d1c9f8765265019cd33e94ea5235515>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

var $dlBdv = parcelRequire("dlBdv");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $e8c987d7492ee286$var$svg = "<svg height=\"100%\" viewBox=\"0 0 106 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M105.76 16.35v8.99h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.63V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 3.53 0 5.55 2.42 5.55 6.66m-19.6 7.75v-1.53c-.98 2.02-2.82 3.07-5.18 3.07-4.05 0-6.07-3.46-6.07-7.97 0-4.32 2.12-7.97 6.38-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.58v13.95c0 4.51-2.12 7.54-7.61 7.54-2.58 0-3.99-.34-5.46-.83v-2.58c1.69.55 3.43.92 5.34.92 3.83 0 5.15-2.05 5.15-4.91m-8.68-6.44c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52M68.73 5.95c0-1.17.77-1.84 1.84-1.84s1.84.67 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-2.54-.03c-.21.06-.67.12-1.35.12-2.51 0-4.11-1.19-4.11-4.02V3.59h2.64V21.1c0 1.38.92 1.87 2.06 1.87.28 0 .46 0 .77-.03zM49.6 21.32c-1.53 0-3.1-.18-4.82-.52l-1.69 4.54H40l7.94-20.15h3.5l7.94 20.15h-3.1l-1.69-4.57c-1.81.37-3.37.55-5 .55m0-2.45c1.29 0 2.61-.15 4.17-.4L49.68 7.43 45.6 18.5c1.5.25 2.76.37 3.99.37\"/>\n    <path fill=\"var(--tile-color,#fb9700)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M23.735 23.735c0-2.928-2.396-5.295-5.295-5.295h-4.88v-4.466H8.265v8.785c0 .68.296.976.976.976zM8.265 8.265c0 2.928 2.337 5.295 5.265 5.295h4.91v4.466h5.295V9.241q0-.976-.976-.976z\"/>\n</svg>\n";
function $e8c987d7492ee286$export$8b5103382c06639c(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Align' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $dlBdv.LogoWrapper), {
        svg: $e8c987d7492ee286$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("jjKZZ", function(module, exports) {
$parcel$export(module.exports, "AnalyticsIcon", () => $e1043fa2303698cc$export$af3460f51ce3602a);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::5edf47443601d30b199c36fbcc7b1d7c>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

var $dkXTa = parcelRequire("dkXTa");
// `height` is set to 100% to allow the SVG to scale with the parent element
var $e1043fa2303698cc$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M14.63 5.88v9.19h3.06v-9.2zM5.88 18.13h11.81v-1.75H5.87zm0-3.07v-4.81h3.06v4.81zm4.37-6.56v6.56h3.06V8.5z\"/>\n</svg>\n";
function $e1043fa2303698cc$export$af3460f51ce3602a(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Analytics' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $dkXTa.IconWrapper), {
        svg: $e1043fa2303698cc$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("11htg", function(module, exports) {
$parcel$export(module.exports, "AnalyticsLogoCS", () => $0be36fd552dc1c99$export$f0bac2b7ac3e3504);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::843c7beab94f5191123277c61cbca79e>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

var $dlBdv = parcelRequire("dlBdv");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $0be36fd552dc1c99$var$svg = "<svg height=\"100%\" viewBox=\"0 0 161 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M160.66 21.16c0 2.55-1.66 4.48-5.76 4.48-2.3 0-4.17-.52-5.34-1.13v-2.79c1.32.77 3.53 1.5 5.46 1.5 2.02 0 3.07-.83 3.07-2.02 0-1.17-.89-1.84-3.8-2.55-3.4-.83-4.85-2.15-4.85-4.66 0-2.67 2.06-4.29 5.55-4.29 1.99 0 3.8.49 4.94 1.1v2.73c-1.84-.92-3.34-1.41-4.97-1.41-1.93 0-2.97.67-2.97 1.87 0 1.07.74 1.75 3.56 2.42 3.4.83 5.12 2.09 5.12 4.75m-13.6 1.41v2.36c-.92.49-2.33.71-3.74.71-5.46 0-8-3.31-8-8 0-4.63 2.55-7.94 8-7.94 1.38 0 2.45.18 3.65.74v2.45c-.98-.46-2.02-.74-3.47-.74-3.99 0-5.61 2.52-5.61 5.49s1.66 5.49 5.67 5.49c1.56 0 2.55-.21 3.5-.55M129.13 5.95c0-1.16.77-1.84 1.84-1.84s1.84.68 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-7.46-4.75c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55c-.46.12-.98.25-1.78.25-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zm-14.12 3.77h-1.72L100.77 10h2.82l4.91 13.13L113.41 10h2.82l-5.8 14.84c-1.72 4.39-2.7 6.66-6.59 6.66-1.32 0-2.05-.12-2.82-.43V28.8c.89.28 1.9.37 2.67.37 2.15 0 3.1-1.47 4.36-4.81m-7.8.94c-.21.06-.67.12-1.35.12-2.51 0-4.11-1.19-4.11-4.02V3.59h2.64V21.1c0 1.38.92 1.87 2.06 1.87.28 0 .46 0 .77-.03zM79.5 17.67c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.47-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zM74.1 16.35v8.99h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.63V10h2.64v2.51c.98-1.81 2.79-2.82 4.85-2.82 3.53 0 5.55 2.42 5.55 6.66m-24.66 4.97c-1.53 0-3.1-.18-4.81-.52l-1.69 4.54h-3.1l7.94-20.15h3.5l7.94 20.15h-3.1l-1.69-4.57c-1.81.37-3.37.55-5 .55m0-2.45c1.29 0 2.61-.15 4.17-.4L49.53 7.43 45.45 18.5c1.5.25 2.76.37 3.99.37\"/>\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M19.5 7.83v12.25h4.08V7.83zM7.83 24.17h15.75v-2.33H7.83zm0-4.09v-6.42h4.08v6.42zm5.84-8.75v8.75h4.08v-8.75z\"/>\n</svg>\n";
function $0be36fd552dc1c99$export$f0bac2b7ac3e3504(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Analytics' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $dlBdv.LogoWrapper), {
        svg: $0be36fd552dc1c99$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("FiVrT", function(module, exports) {
$parcel$export(module.exports, "AssetsIcon", () => $07c282adbd4b5243$export$d89497e7f33ca6f5);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6ef8f48b1d072b5b8a0869540d1f52a5>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

var $dkXTa = parcelRequire("dkXTa");
// `height` is set to 100% to allow the SVG to scale with the parent element
var $07c282adbd4b5243$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#ffc716)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" fill-rule=\"evenodd\" d=\"M8.34 11.495a3.64 3.64 0 0 0 3.155-3.154h2.3V6.523h-2.537a3.638 3.638 0 1 0-4.735 4.735v2.538H8.34zM7.887 9.25a1.364 1.364 0 1 0 0-2.727 1.364 1.364 0 0 0 0 2.727\" clip-rule=\"evenodd\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M19.25 7.43a2.27 2.27 0 1 1-4.54 0 2.27 2.27 0 0 1 4.55 0M7.43 19.25a2.27 2.27 0 1 0 0-4.54 2.27 2.27 0 0 0 0 4.55m9.55-.01a2.27 2.27 0 1 0 0-4.54 2.27 2.27 0 0 0 0 4.55m-3.18-3.19h-3.18v1.82h3.18zm2.27-5.46v3.18h1.82v-3.18z\"/>\n</svg>\n";
var $07c282adbd4b5243$var$customThemeSvg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--themed-icon-color, currentcolor)\" d=\"M18 0a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6V6a6 6 0 0 1 6-6zM7.432 14.704a2.273 2.273 0 1 0 .001 4.547 2.273 2.273 0 0 0-.001-4.547m9.545 0a2.274 2.274 0 1 0 .001 4.548 2.274 2.274 0 0 0 0-4.548m-6.364 1.364v1.819h3.183v-1.819zM7.887 4.25a3.637 3.637 0 0 0-1.365 7.009v2.537h1.819v-2.302a3.64 3.64 0 0 0 3.153-3.153h2.302V6.522h-2.537A3.64 3.64 0 0 0 7.887 4.25m8.181 6.363v3.183h1.819v-3.183zm.91-5.454a2.273 2.273 0 1 0 0 4.547 2.273 2.273 0 0 0 0-4.547M7.887 6.522a1.364 1.364 0 1 1-.002 2.729 1.364 1.364 0 0 1 .002-2.729\"/>\n</svg>\n";
function $07c282adbd4b5243$export$d89497e7f33ca6f5(_ref) {
    var iconColor = _ref.iconColor, size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Assets' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $dkXTa.IconWrapper), {
        svg: $07c282adbd4b5243$var$svg,
        customThemeSvg: $07c282adbd4b5243$var$customThemeSvg,
        iconColor: iconColor,
        label: label,
        isAssets: true,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("8V4gd", function(module, exports) {
$parcel$export(module.exports, "AssetsLogoCS", () => $67e6f3ace9444edb$export$81c47abe19675c4c);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3e04e8bc884193d0eee2f110efb35733>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

var $dlBdv = parcelRequire("dlBdv");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $67e6f3ace9444edb$var$svg = "<svg height=\"100%\" viewBox=\"0 0 126 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M125.8 21.16c0 2.55-1.66 4.48-5.76 4.48-2.3 0-4.17-.52-5.34-1.13v-2.79c1.32.77 3.53 1.5 5.46 1.5 2.02 0 3.07-.83 3.07-2.02 0-1.16-.89-1.84-3.8-2.54-3.4-.83-4.84-2.15-4.84-4.66 0-2.67 2.06-4.29 5.55-4.29 1.99 0 3.8.49 4.94 1.1v2.73c-1.84-.92-3.34-1.41-4.97-1.41-1.93 0-2.97.67-2.97 1.87 0 1.07.74 1.75 3.56 2.42 3.4.83 5.12 2.09 5.12 4.75m-17.77-.59c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55c-.46.12-.98.25-1.78.25-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zm-13.53-8.5c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.2c.37 2.61 2.05 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-15.13-3.56c0 2.55-1.66 4.48-5.77 4.48-2.3 0-4.17-.52-5.34-1.13v-2.79c1.32.77 3.53 1.5 5.46 1.5 2.02 0 3.07-.83 3.07-2.02 0-1.16-.89-1.84-3.8-2.54-3.4-.83-4.85-2.15-4.85-4.66 0-2.67 2.06-4.29 5.55-4.29 1.99 0 3.8.49 4.94 1.1v2.73c-1.84-.92-3.34-1.41-4.97-1.41-1.93 0-2.97.67-2.97 1.87 0 1.07.74 1.75 3.56 2.42 3.4.83 5.12 2.09 5.12 4.75m-13.63-.01c0 2.55-1.66 4.48-5.76 4.48-2.3 0-4.17-.52-5.34-1.13v-2.79c1.32.77 3.53 1.5 5.46 1.5 2.02 0 3.07-.83 3.07-2.02 0-1.16-.89-1.84-3.8-2.54-3.4-.83-4.84-2.15-4.84-4.66 0-2.67 2.06-4.29 5.55-4.29 1.99 0 3.8.49 4.94 1.1v2.73c-1.84-.92-3.34-1.41-4.97-1.41-1.93 0-2.97.67-2.97 1.87 0 1.07.74 1.75 3.56 2.42 3.4.83 5.12 2.09 5.12 4.75m-22.22.15c-1.53 0-3.1-.18-4.81-.52l-1.69 4.54h-3.1l7.94-20.15h3.5l7.94 20.15h-3.1l-1.69-4.57c-1.81.37-3.37.55-5 .55m0-2.45c1.29 0 2.61-.15 4.17-.4L49.53 7.43 45.45 18.5c1.5.25 2.76.37 3.99.37\"/>\n    <path fill=\"var(--tile-color,#ffc716)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" fill-rule=\"evenodd\" d=\"M11.667 15.425a4.335 4.335 0 0 0 3.758-3.758h2.742V9.5h-3.023A4.335 4.335 0 1 0 9.5 15.144v3.023h2.167zm-.542-2.675a1.625 1.625 0 1 0 0-3.25 1.625 1.625 0 0 0 0 3.25\" clip-rule=\"evenodd\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M24.67 10.58a2.71 2.71 0 1 1-5.42 0 2.71 2.71 0 0 1 5.42 0M10.58 24.67a2.71 2.71 0 1 0 0-5.42 2.71 2.71 0 0 0 0 5.42m11.38 0a2.71 2.71 0 1 0 0-5.42 2.71 2.71 0 0 0 0 5.42m-3.79-3.79h-3.79v2.17h3.79zm2.71-6.5v3.79h2.17v-3.79z\"/>\n</svg>\n";
function $67e6f3ace9444edb$export$81c47abe19675c4c(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Assets' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $dlBdv.LogoWrapper), {
        svg: $67e6f3ace9444edb$var$svg,
        label: label,
        isAssets: true,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("3zG0O", function(module, exports) {
$parcel$export(module.exports, "BambooIcon", () => $29a53ab50e0d6e2c$export$e812398311cab9a3);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::74f0ca66b8bc3995f7a9817f08a67d6f>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

var $dkXTa = parcelRequire("dkXTa");
// `height` is set to 100% to allow the SVG to scale with the parent element
var $29a53ab50e0d6e2c$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color, white)\" d=\"M6 .5h12A5.5 5.5 0 0 1 23.5 6v12a5.5 5.5 0 0 1-5.5 5.5H6A5.5 5.5 0 0 1 .5 18V6A5.5 5.5 0 0 1 6 .5\"/>\n    <path fill=\"none\" stroke=\"var(--border-color, #dddee1)\" d=\"M6 .5h12A5.5 5.5 0 0 1 23.5 6v12a5.5 5.5 0 0 1-5.5 5.5H6A5.5 5.5 0 0 1 .5 18V6A5.5 5.5 0 0 1 6 .5Z\"/>\n    <path fill=\"var(--icon-color, #1868db)\" d=\"M9.215 12.652a2.75 2.75 0 0 0 2.749 2.742v4.205a6.964 6.964 0 0 1-6.849-5.727l-.049-.317zm9.26 0a.44.44 0 0 1 .436.468c-.222 3.311-2.783 5.989-6.043 6.414l-.904-4.14a2.75 2.75 0 0 0 2.723-2.37.44.44 0 0 1 .44-.372zM11.963 9.91a2.75 2.75 0 0 0-2.748 2.742H5v-.065c.033-3.495 2.668-6.374 6.059-6.816zm0-5.972a.436.436 0 0 1 .72-.33l4.824 4.138a.436.436 0 0 1 0 .662l-4.823 4.139a.436.436 0 0 1-.72-.331z\"/>\n</svg>\n";
function $29a53ab50e0d6e2c$export$e812398311cab9a3(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Bamboo' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $dkXTa.IconWrapper), {
        svg: $29a53ab50e0d6e2c$var$svg,
        label: label,
        type: "data-center",
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("kd0Va", function(module, exports) {
$parcel$export(module.exports, "BambooLogoCS", () => $eb65bc71ea217c46$export$7c51958462d750e);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::5436ab9ea17c11b656095d6ae713006c>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

var $dlBdv = parcelRequire("dlBdv");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $eb65bc71ea217c46$var$svg = "<svg height=\"100%\" viewBox=\"0 0 154 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M146 25.64c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49m-16.68 13.49c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49m-12.07 5.52c0-3.68-1.47-5.52-4.2-5.52-2.36 0-4.48 1.5-4.48 4.91v1.23c0 3.4 1.93 4.91 4.17 4.91 2.98 0 4.51-1.96 4.51-5.52m-3.8 7.97c-2.24 0-3.96-1.01-4.88-3v2.7h-2.64V3.59h2.64v9.17c.98-2.02 2.82-3.07 5.18-3.07 4.08 0 6.13 3.47 6.13 7.97 0 4.32-2.15 7.97-6.44 7.97m-21.58-8.82v8.53h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 2.61 0 4.39 1.32 5.15 3.74.86-2.36 2.91-3.74 5.46-3.74 3.43 0 5.34 2.33 5.34 6.66v8.99h-2.64v-8.52c0-3.16-1.1-4.72-3.62-4.72-2.45 0-4.14 1.63-4.14 4.72m-28.32.84c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-20.23-9.04H45.8v6.29h6.26c2.64 0 3.83-.95 3.83-2.97 0-2.15-1.13-3.31-3.89-3.31m-.89-8.46h-5.3v6.01h5.31c2.61 0 3.68-1.2 3.68-3.13 0-1.96-1.16-2.88-3.68-2.88m-8.06 17.51V5.19h8.43c4.11 0 6.1 2.02 6.1 5.28 0 2.42-1.1 3.93-3.37 4.48 2.97.49 4.45 2.12 4.45 4.97 0 3.22-2.18 5.43-6.68 5.43z\"/>\n    <path fill=\"var(--tile-color, white)\" d=\"M8 .667h16A7.333 7.333 0 0 1 31.333 8v16A7.333 7.333 0 0 1 24 31.333H8A7.333 7.333 0 0 1 .667 24V8A7.333 7.333 0 0 1 8 .667\"/>\n    <path fill=\"none\" stroke=\"var(--border-color, #dddee1)\" stroke-width=\"1.333\" d=\"M8 .667h16A7.333 7.333 0 0 1 31.333 8v16A7.333 7.333 0 0 1 24 31.333H8A7.333 7.333 0 0 1 .667 24V8A7.333 7.333 0 0 1 8 .667Z\"/>\n    <path fill=\"var(--icon-color, #1868db)\" d=\"M12.287 16.869a3.665 3.665 0 0 0 3.665 3.656v5.607c-4.71 0-8.602-3.52-9.196-8.06zm12.347 0a.584.584 0 0 1 .581.624c-.295 4.415-3.71 7.986-8.057 8.554l-1.206-5.521a3.67 3.67 0 0 0 3.63-3.161.59.59 0 0 1 .589-.496zm-8.683-3.656a3.664 3.664 0 0 0-3.665 3.656h-5.62v-.088c.044-4.66 3.557-8.498 8.078-9.088zm0-7.964a.58.58 0 0 1 .96-.44l6.432 5.518c.27.232.27.65 0 .883l-6.431 5.517a.581.581 0 0 1-.96-.44z\"/>\n</svg>\n";
function $eb65bc71ea217c46$export$7c51958462d750e(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Bamboo' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $dlBdv.LogoWrapper), {
        svg: $eb65bc71ea217c46$var$svg,
        label: label,
        type: "data-center",
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("7bIiV", function(module, exports) {
$parcel$export(module.exports, "BitbucketIcon", () => $53bbed640c6e6632$export$5fc1066e677788d4);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::83bd991a11895fc697ec86ba4d2d82c2>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

var $dkXTa = parcelRequire("dkXTa");
// `height` is set to 100% to allow the SVG to scale with the parent element
var $53bbed640c6e6632$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#94c748)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"m17.898 11.353-.994 6.064c-.065.367-.324.583-.691.583H7.787c-.367 0-.627-.216-.691-.583L5.346 6.604C5.28 6.237 5.476 6 5.82 6h12.358c.346 0 .54.237.475.604l-.475 2.85c-.065.41-.303.582-.691.582h-7.432c-.109 0-.173.065-.152.194l.584 3.583c.021.086.086.151.172.151h2.68c.086 0 .15-.065.172-.151l.41-2.59c.044-.324.26-.453.563-.453H17.4c.432 0 .562.216.497.582\"/>\n</svg>\n";
var $53bbed640c6e6632$var$customThemeSvg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--themed-icon-color, currentcolor)\" d=\"M18 0a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6V6a6 6 0 0 1 6-6zM5.821 6c-.345 0-.54.238-.475.604l1.75 10.813c.065.367.324.583.691.583h8.426c.367 0 .627-.216.691-.583l.994-6.065c.065-.366-.065-.582-.497-.582h-2.917c-.302 0-.518.13-.561.453l-.41 2.59c-.022.086-.087.15-.173.15h-2.68c-.086 0-.151-.064-.173-.15l-.583-3.583c-.021-.129.044-.194.152-.194h7.431c.39 0 .627-.173.692-.583l.475-2.849c.065-.366-.13-.604-.475-.604z\"/>\n</svg>\n";
function $53bbed640c6e6632$export$5fc1066e677788d4(_ref) {
    var iconColor = _ref.iconColor, size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Bitbucket' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $dkXTa.IconWrapper), {
        svg: $53bbed640c6e6632$var$svg,
        customThemeSvg: $53bbed640c6e6632$var$customThemeSvg,
        iconColor: iconColor,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("2P88k", function(module, exports) {
$parcel$export(module.exports, "BitbucketLogoCS", () => $20e6a750a55a1c4a$export$f7ef5e5488e4b430);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7131ffd6f745f530e9a82fe4842b6a8c>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

var $dlBdv = parcelRequire("dlBdv");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $20e6a750a55a1c4a$var$svg = "<svg height=\"100%\" viewBox=\"0 0 166 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M161.21 20.58c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55a6.3 6.3 0 0 1-1.78.25c-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zm-13.53-8.49c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.67-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.05 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-23.83.6h-2.64V3.59h2.64v13.59l6.6-7.18h3.44l-7.21 7.54 7.51 7.79h-3.59l-6.75-7.18zm-5.64-2.76v2.36c-.92.49-2.33.71-3.74.71-5.46 0-8-3.31-8-8 0-4.63 2.55-7.94 8-7.94 1.38 0 2.45.18 3.65.74v2.45c-.98-.46-2.02-.74-3.46-.74-3.99 0-5.61 2.52-5.61 5.49s1.66 5.49 5.67 5.49c1.56 0 2.55-.21 3.5-.55m-27.86-3.59V10h2.64v9.26c0 2.76 1.1 3.99 3.62 3.99 2.45 0 4.14-1.63 4.14-4.72V10h2.64v15.33h-2.64v-2.51c-.98 1.81-2.79 2.82-4.84 2.82-3.53 0-5.55-2.42-5.55-6.65m-5.4-1.32c0-3.68-1.47-5.52-4.2-5.52-2.36 0-4.48 1.5-4.48 4.91v1.23c0 3.4 1.93 4.91 4.17 4.91 2.98 0 4.51-1.96 4.51-5.52m-3.8 7.97c-2.24 0-3.96-1.01-4.88-3v2.7h-2.64V3.59h2.64v9.17c.98-2.02 2.82-3.07 5.18-3.07 4.08 0 6.13 3.47 6.13 7.97 0 4.32-2.15 7.97-6.44 7.97m-14.96-5.05c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55c-.46.12-.98.25-1.78.25-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zM61.33 5.95c0-1.16.77-1.84 1.84-1.84s1.84.68 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-9.83-9.04H45.8v6.29h6.26c2.64 0 3.83-.95 3.83-2.97 0-2.15-1.13-3.31-3.89-3.31m-.89-8.46h-5.3v6.01h5.31c2.61 0 3.68-1.2 3.68-3.13 0-1.96-1.17-2.88-3.68-2.88m-8.06 17.51V5.19h8.43c4.11 0 6.1 2.02 6.1 5.27 0 2.42-1.1 3.93-3.37 4.48 2.97.49 4.45 2.12 4.45 4.97 0 3.22-2.18 5.43-6.69 5.43z\"/>\n    <path fill=\"var(--tile-color,#94c748)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"m23.79 15.684-1.315 8.032c-.085.486-.428.772-.914.772H10.413c-.486 0-.829-.286-.915-.772L7.183 9.396c-.086-.486.172-.8.629-.8h16.35c.457 0 .714.314.629.8l-.63 3.773c-.085.543-.4.772-.914.772h-9.833c-.143 0-.228.086-.2.257l.772 4.745c.029.114.114.2.229.2h3.544c.114 0 .2-.086.229-.2l.543-3.43c.057-.429.343-.6.743-.6h3.859c.572 0 .743.285.657.771\"/>\n</svg>\n";
function $20e6a750a55a1c4a$export$f7ef5e5488e4b430(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Bitbucket' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $dlBdv.LogoWrapper), {
        svg: $20e6a750a55a1c4a$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("aMzwb", function(module, exports) {
$parcel$export(module.exports, "BitbucketDataCenterIcon", () => $7d99f03edbd4b9cf$export$d3ab16bbf4f954ee);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::61dd349b817df11b196de45b8945fcdf>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

var $dkXTa = parcelRequire("dkXTa");
// `height` is set to 100% to allow the SVG to scale with the parent element
var $7d99f03edbd4b9cf$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color, white)\" d=\"M6 .5h12A5.5 5.5 0 0 1 23.5 6v12a5.5 5.5 0 0 1-5.5 5.5H6A5.5 5.5 0 0 1 .5 18V6A5.5 5.5 0 0 1 6 .5\"/>\n    <path fill=\"none\" stroke=\"var(--border-color, #dddee1)\" d=\"M6 .5h12A5.5 5.5 0 0 1 23.5 6v12a5.5 5.5 0 0 1-5.5 5.5H6A5.5 5.5 0 0 1 .5 18V6A5.5 5.5 0 0 1 6 .5Z\"/>\n    <path fill=\"var(--icon-color, #1868db)\" d=\"m17.843 11.763-.986 6.024c-.065.365-.322.58-.686.58H7.81c-.365 0-.622-.215-.686-.58L5.387 7.047c-.064-.364.129-.6.472-.6h12.262c.343 0 .536.236.472.6l-.472 2.83c-.064.407-.3.579-.686.579h-7.374c-.107 0-.172.064-.15.193l.579 3.558c.021.086.085.15.171.15h2.658c.086 0 .15-.064.172-.15l.407-2.572c.043-.322.257-.45.558-.45h2.894c.428 0 .557.214.493.578\"/>\n</svg>\n";
function $7d99f03edbd4b9cf$export$d3ab16bbf4f954ee(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Bitbucket Data Center' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $dkXTa.IconWrapper), {
        svg: $7d99f03edbd4b9cf$var$svg,
        label: label,
        type: "data-center",
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("cNBpl", function(module, exports) {
$parcel$export(module.exports, "BitbucketDataCenterLogoCS", () => $9517141151b4abf9$export$cc55e2a4c4b40552);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::68c2bbf4fd6874e93c78c51b9065dc7c>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

var $dlBdv = parcelRequire("dlBdv");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $9517141151b4abf9$var$svg = "<svg height=\"100%\" viewBox=\"0 0 166 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M161.21 20.58c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55c-.46.12-.98.25-1.78.25-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zm-13.53-8.49c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-23.83.6h-2.64V3.59h2.64v13.59l6.6-7.18h3.44l-7.21 7.54 7.51 7.79h-3.59l-6.75-7.18zm-5.64-2.76v2.36c-.92.49-2.33.71-3.74.71-5.46 0-8-3.31-8-8 0-4.63 2.55-7.94 8-7.94 1.38 0 2.45.18 3.65.74v2.45c-.98-.46-2.02-.74-3.47-.74-3.99 0-5.61 2.51-5.61 5.49s1.66 5.49 5.67 5.49c1.56 0 2.55-.21 3.5-.55m-27.85-3.59V10h2.64v9.26c0 2.76 1.1 3.99 3.62 3.99 2.45 0 4.14-1.62 4.14-4.72V10h2.64v15.33h-2.64v-2.51c-.98 1.81-2.79 2.82-4.85 2.82-3.53 0-5.55-2.42-5.55-6.65m-5.39-1.32c0-3.68-1.47-5.52-4.2-5.52-2.36 0-4.48 1.5-4.48 4.91v1.23c0 3.4 1.93 4.91 4.17 4.91 2.98 0 4.51-1.96 4.51-5.52m-3.8 7.97c-2.24 0-3.96-1.01-4.88-3v2.7h-2.64V3.59h2.64v9.17c.98-2.02 2.82-3.07 5.18-3.07 4.08 0 6.13 3.47 6.13 7.97 0 4.32-2.15 7.97-6.44 7.97m-14.96-5.05c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55a6.3 6.3 0 0 1-1.78.25c-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zM61.33 5.95c0-1.16.77-1.84 1.84-1.84s1.84.68 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-9.83-9.04H45.8v6.29h6.26c2.64 0 3.83-.95 3.83-2.97 0-2.15-1.13-3.31-3.89-3.31m-.89-8.46h-5.3v6.01h5.31c2.61 0 3.68-1.2 3.68-3.13 0-1.96-1.16-2.88-3.68-2.88m-8.06 17.51V5.19h8.43c4.11 0 6.1 2.02 6.1 5.28 0 2.42-1.1 3.93-3.37 4.48 2.97.49 4.45 2.12 4.45 4.97 0 3.22-2.18 5.43-6.68 5.43z\"/>\n    <path fill=\"var(--tile-color, white)\" d=\"M8 .667h16A7.333 7.333 0 0 1 31.333 8v16A7.333 7.333 0 0 1 24 31.333H8A7.333 7.333 0 0 1 .667 24V8A7.333 7.333 0 0 1 8 .667\"/>\n    <path fill=\"none\" stroke=\"var(--border-color, #dddee1)\" stroke-width=\"1.333\" d=\"M8 .667h16A7.333 7.333 0 0 1 31.333 8v16A7.333 7.333 0 0 1 24 31.333H8A7.333 7.333 0 0 1 .667 24V8A7.333 7.333 0 0 1 8 .667Z\"/>\n    <path fill=\"var(--icon-color, #1868db)\" d=\"m23.79 15.684-1.315 8.032c-.085.486-.428.772-.914.772H10.413c-.486 0-.829-.286-.915-.772L7.183 9.396c-.086-.486.172-.8.629-.8h16.35c.457 0 .714.314.629.8l-.63 3.773c-.085.543-.4.772-.914.772h-9.833c-.143 0-.228.086-.2.257l.772 4.745c.028.114.114.2.229.2h3.544c.114 0 .2-.086.229-.2l.543-3.43c.057-.429.343-.6.743-.6h3.859c.571 0 .743.285.657.771\"/>\n</svg>\n";
function $9517141151b4abf9$export$cc55e2a4c4b40552(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Bitbucket Data Center' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $dlBdv.LogoWrapper), {
        svg: $9517141151b4abf9$var$svg,
        label: label,
        type: "data-center",
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("eQTvy", function(module, exports) {
$parcel$export(module.exports, "ChatIcon", () => $ad00fac377c9e40f$export$52cd484a7ef4f2b9);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c2ff2e36e1653e53734b97e7db9892da>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

var $dkXTa = parcelRequire("dkXTa");
// `height` is set to 100% to allow the SVG to scale with the parent element
var $ad00fac377c9e40f$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" fill-rule=\"evenodd\" d=\"M18.563 16.688h-8.438L5.438 19.5V5.438h13.125zm-6.83-9.375-.255.647c-.362.92-.543 1.38-.878 1.727-.334.346-.787.543-1.694.938l-.388.17v.535l.388.17c.907.394 1.36.592 1.694.938.335.346.516.807.878 1.727l.255.648h.535l.255-.648c.362-.92.543-1.38.877-1.727.335-.346.788-.544 1.694-.939l.388-.169v-.535l-.388-.17c-.906-.395-1.36-.592-1.694-.938-.334-.347-.515-.807-.877-1.727l-.255-.647z\" clip-rule=\"evenodd\"/>\n</svg>\n";
function $ad00fac377c9e40f$export$52cd484a7ef4f2b9(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Chat' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $dkXTa.IconWrapper), {
        svg: $ad00fac377c9e40f$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("ib3Rw", function(module, exports) {
$parcel$export(module.exports, "ChatLogoCS", () => $d3bc400e03f0c58c$export$a529e78951cd6709);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::8c1cf578ed3b2b56aa2f85ac93abd2ba>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

var $dlBdv = parcelRequire("dlBdv");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $d3bc400e03f0c58c$var$svg = "<svg height=\"100%\" viewBox=\"0 0 102 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M97.51 20.58c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55c-.46.12-.98.25-1.78.25-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zm-18.94-2.91c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-14.1-8.98v8.99h-2.64v-8.52c0-3.16-1.1-4.72-3.62-4.72-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V3.59h2.64v8.95c1.01-1.81 2.85-2.85 5.06-2.85 3.44 0 5.34 2.33 5.34 6.66m-16.22 5.43v2.67c-1.26.83-3.25 1.2-5.34 1.2-6.62 0-10.36-3.99-10.36-10.33 0-6.13 3.74-10.43 10.3-10.43 1.96 0 3.93.37 5.37 1.41v2.67c-1.44-.92-3.04-1.41-5.37-1.41-4.72 0-7.54 3.13-7.54 7.76s2.91 7.7 7.7 7.7c2.12 0 3.77-.49 5.24-1.23\"/>\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" fill-rule=\"evenodd\" d=\"M24.75 22.25H13.5L7.25 26V7.25h17.5zm-9.107-12.5-.34.864c-.482 1.226-.724 1.84-1.17 2.302s-1.05.725-2.258 1.251l-.518.226v.714l.518.226c1.209.526 1.813.79 2.259 1.251.445.462.687 1.076 1.17 2.303l.34.863h.714l.34-.864c.482-1.227.724-1.84 1.17-2.302s1.049-.725 2.258-1.251l.517-.226v-.714l-.517-.226c-1.21-.526-1.813-.79-2.259-1.251-.445-.462-.687-1.075-1.17-2.302l-.34-.864z\" clip-rule=\"evenodd\"/>\n</svg>\n";
function $d3bc400e03f0c58c$export$a529e78951cd6709(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Chat' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $dlBdv.LogoWrapper), {
        svg: $d3bc400e03f0c58c$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("6uRkc", function(module, exports) {
$parcel$export(module.exports, "CompassIcon", () => $4baee89efb80cd04$export$f7857fe64d7161d9);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e5ce5248a23a237688e2341559569305>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

var $dkXTa = parcelRequire("dkXTa");
// `height` is set to 100% to allow the SVG to scale with the parent element
var $4baee89efb80cd04$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#94c748)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M12.75 7.877v-3.37l6.16-.007h.007a.59.59 0 0 1 .583.598v6.147h-3.366V7.877z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M12.75 14.615v-3.37h3.368v6.165a.59.59 0 0 1-.591.59H6.583A.59.59 0 0 1 6 17.402V8.467a.59.59 0 0 1 .591-.59h6.16v3.368H9.373v3.37z\"/>\n</svg>\n";
function $4baee89efb80cd04$export$f7857fe64d7161d9(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Compass' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $dkXTa.IconWrapper), {
        svg: $4baee89efb80cd04$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("9kRIm", function(module, exports) {
$parcel$export(module.exports, "CompassLogoCS", () => $6cbfa5dee2ec240d$export$a16f50a81d183ce);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::bbcc7f43e0a51fb6caa253b27359fb22>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

var $dlBdv = parcelRequire("dlBdv");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $6cbfa5dee2ec240d$var$svg = "<svg height=\"100%\" viewBox=\"0 0 162 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M161.79 21.16c0 2.55-1.66 4.48-5.76 4.48-2.3 0-4.17-.52-5.34-1.13v-2.79c1.32.77 3.53 1.5 5.46 1.5 2.02 0 3.07-.83 3.07-2.02 0-1.16-.89-1.84-3.8-2.55-3.4-.83-4.85-2.15-4.85-4.66 0-2.67 2.06-4.29 5.55-4.29 1.99 0 3.8.49 4.94 1.1v2.73c-1.84-.92-3.34-1.41-4.97-1.41-1.93 0-2.97.68-2.97 1.87 0 1.07.74 1.75 3.56 2.42 3.4.83 5.12 2.09 5.12 4.75m-13.63 0c0 2.55-1.66 4.48-5.76 4.48-2.3 0-4.17-.52-5.34-1.13v-2.79c1.32.77 3.53 1.5 5.46 1.5 2.02 0 3.07-.83 3.07-2.02 0-1.16-.89-1.84-3.8-2.55-3.4-.83-4.84-2.15-4.84-4.66 0-2.67 2.06-4.29 5.55-4.29 1.99 0 3.8.49 4.94 1.1v2.73c-1.84-.92-3.34-1.41-4.97-1.41-1.93 0-2.97.68-2.97 1.87 0 1.07.74 1.75 3.56 2.42 3.4.83 5.12 2.09 5.12 4.75m-25.9-3.49c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01v-2.7h2.64v15.33zm-16.09-7.66c0-3.68-1.47-5.52-4.2-5.52-2.36 0-4.48 1.5-4.48 4.91v1.23c0 3.4 1.93 4.91 4.17 4.91 2.98 0 4.51-1.96 4.51-5.52m-3.8 7.97c-2.24 0-3.96-1.01-4.88-3v8.68h-2.64V10h2.64v2.76c.98-2.02 2.82-3.07 5.18-3.07 4.08 0 6.13 3.47 6.13 7.97 0 4.32-2.15 7.97-6.44 7.97M89.5 16.81v8.53h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.51c.98-1.81 2.79-2.82 4.85-2.82 2.61 0 4.39 1.32 5.15 3.74.86-2.36 2.91-3.74 5.46-3.74 3.43 0 5.34 2.33 5.34 6.66v8.99h-2.64v-8.53c0-3.16-1.1-4.72-3.62-4.72-2.45 0-4.14 1.63-4.14 4.72m-23.34 8.83c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49m-9.23 9.63v2.67c-1.26.83-3.25 1.2-5.34 1.2-6.62 0-10.36-3.99-10.36-10.33 0-6.13 3.74-10.43 10.3-10.43 1.96 0 3.93.37 5.37 1.41v2.67c-1.44-.92-3.04-1.41-5.37-1.41-4.72 0-7.54 3.13-7.54 7.76s2.91 7.7 7.7 7.7c2.12 0 3.77-.49 5.24-1.23\"/>\n    <path fill=\"var(--tile-color,#94c748)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M16.69 15.16v4.24h-4.25v-4.24zv-4.24H8.93a.74.74 0 0 0-.74.74v11.25a.74.74 0 0 0 .74.75h11.26a.74.74 0 0 0 .75-.74v-7.76zm0-8.48v4.24h4.26v4.24h4.24V7.42a.74.74 0 0 0-.73-.75h-.01z\"/>\n</svg>\n";
function $6cbfa5dee2ec240d$export$a16f50a81d183ce(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Compass' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $dlBdv.LogoWrapper), {
        svg: $6cbfa5dee2ec240d$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("gpCpU", function(module, exports) {
$parcel$export(module.exports, "ConfluenceIcon", () => $bf2cc7f049a6186c$export$68f3db7f6af48bcb);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2264fa822c5f74cedf4229a8911c73b4>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

var $dkXTa = parcelRequire("dkXTa");
// `height` is set to 100% to allow the SVG to scale with the parent element
var $bf2cc7f049a6186c$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#1868db)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, white)\" d=\"M17.888 14.461c-4.039-1.953-5.219-2.245-6.92-2.245-1.997 0-3.699.831-5.219 3.165l-.25.382c-.204.314-.249.426-.249.561s.068.247.318.404l2.564 1.594c.136.09.25.135.363.135.136 0 .226-.068.363-.27l.408-.628c.635-.966 1.203-1.28 1.928-1.28.636 0 1.385.18 2.315.629l2.677 1.257c.272.134.567.067.704-.247l1.27-2.783c.136-.315.046-.517-.272-.674M6.112 9.545c4.039 1.953 5.219 2.245 6.92 2.245 1.997 0 3.699-.83 5.219-3.165l.25-.381c.204-.315.249-.427.249-.562 0-.134-.068-.247-.318-.404L15.87 5.685c-.137-.09-.25-.135-.364-.135-.136 0-.226.067-.363.27l-.408.628c-.635.965-1.203 1.28-1.928 1.28-.636 0-1.385-.18-2.315-.63L7.814 5.843c-.272-.135-.567-.068-.703.247L5.84 8.872c-.136.314-.045.516.272.673\"/>\n</svg>\n";
var $bf2cc7f049a6186c$var$customThemeSvg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--themed-icon-color, currentcolor)\" d=\"M18 0a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6V6a6 6 0 0 1 6-6zm-7.032 12.217c-1.997 0-3.699.83-5.219 3.165l-.249.38c-.204.315-.25.427-.25.562s.068.247.317.404l2.565 1.594c.136.09.249.135.362.135.136 0 .227-.068.363-.27l.409-.628c.635-.966 1.202-1.28 1.928-1.28.636 0 1.384.18 2.315.63l2.677 1.256c.273.134.568.067.704-.247l1.27-2.783c.136-.315.045-.517-.272-.674-4.039-1.953-5.219-2.244-6.92-2.244m4.538-6.667c-.136 0-.227.067-.363.27l-.409.628c-.635.965-1.202 1.28-1.928 1.28-.636 0-1.384-.18-2.315-.63L7.813 5.843c-.272-.135-.567-.067-.703.247L5.84 8.872c-.136.314-.045.517.272.674 4.039 1.953 5.219 2.244 6.92 2.244 1.997 0 3.699-.83 5.219-3.165l.249-.382c.204-.314.25-.426.25-.56s-.068-.248-.317-.405l-2.565-1.593c-.136-.09-.249-.135-.362-.135\"/>\n</svg>\n";
function $bf2cc7f049a6186c$export$68f3db7f6af48bcb(_ref) {
    var iconColor = _ref.iconColor, size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Confluence' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $dkXTa.IconWrapper), {
        svg: $bf2cc7f049a6186c$var$svg,
        customThemeSvg: $bf2cc7f049a6186c$var$customThemeSvg,
        iconColor: iconColor,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("jNs4V", function(module, exports) {
$parcel$export(module.exports, "ConfluenceLogoCS", () => $e6985fb29d7e75d7$export$a88b0b0da9ef63ce);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::90f8012e577da50adfff14718da1e4b3>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

var $dlBdv = parcelRequire("dlBdv");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $e6985fb29d7e75d7$var$svg = "<svg height=\"100%\" viewBox=\"0 0 188 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M181.16 12.09c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.2c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-15.1-2.16v2.36c-.92.49-2.33.71-3.74.71-5.46 0-8-3.31-8-8 0-4.63 2.55-7.94 8-7.94 1.38 0 2.45.18 3.65.74v2.45c-.98-.46-2.02-.74-3.46-.74-3.99 0-5.61 2.51-5.61 5.49s1.66 5.49 5.67 5.49c1.56 0 2.55-.21 3.5-.55m-14.51-6.23v8.99h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 3.53 0 5.55 2.42 5.55 6.66m-22.92-4.27c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-29.1-5.74V10h2.64v9.26c0 2.76 1.1 3.99 3.62 3.99 2.45 0 4.14-1.62 4.14-4.72V10h2.64v15.33h-2.64v-2.51c-.98 1.81-2.79 2.82-4.84 2.82-3.53 0-5.55-2.42-5.55-6.65m-2.24 6.31c-.21.06-.67.12-1.35.12-2.51 0-4.11-1.19-4.11-4.02V3.59h2.64V21.1c0 1.38.92 1.87 2.06 1.87.28 0 .46 0 .77-.03zM96.82 8.38V10h3.96v2.45h-3.96v12.88h-2.58V12.45h-2.48V10h2.48V8.31c0-2.85 1.59-4.78 4.88-4.78.8 0 1.32.12 1.78.25V6.2a8.7 8.7 0 0 0-1.66-.15c-1.62 0-2.42.95-2.42 2.33m-7.32 7.97v8.99h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 3.53 0 5.55 2.42 5.55 6.66m-23.34 9.28c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49m-9.23 9.63v2.67c-1.26.83-3.25 1.2-5.34 1.2-6.62 0-10.36-3.99-10.36-10.33 0-6.13 3.74-10.43 10.3-10.43 1.96 0 3.93.37 5.37 1.41v2.67c-1.44-.92-3.04-1.41-5.37-1.41-4.72 0-7.54 3.13-7.54 7.76s2.91 7.7 7.7 7.7c2.12 0 3.77-.49 5.24-1.23\"/>\n    <path fill=\"var(--tile-color,#1868db)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, white)\" d=\"M23.16 19.02c-4.938-2.387-6.38-2.744-8.461-2.744-2.442 0-4.522 1.015-6.38 3.87l-.306.466c-.25.384-.305.521-.305.686s.083.302.388.494l3.135 1.948c.167.11.305.165.444.165.166 0 .277-.082.444-.33l.5-.768c.776-1.18 1.47-1.564 2.357-1.564.777 0 1.692.22 2.83.768l3.273 1.537c.333.165.693.083.86-.302l1.553-3.403c.167-.384.056-.63-.333-.823M8.761 13.01c4.938 2.388 6.38 2.744 8.461 2.744 2.441 0 4.522-1.015 6.38-3.87l.305-.466c.25-.384.305-.521.305-.686 0-.164-.083-.302-.388-.494L20.691 8.29c-.167-.11-.306-.165-.444-.165-.167 0-.278.082-.444.33l-.5.768c-.776 1.18-1.47 1.564-2.357 1.564-.777 0-1.693-.22-2.83-.768l-3.273-1.537c-.333-.165-.694-.083-.86.302l-1.554 3.403c-.166.384-.055.63.333.823\"/>\n</svg>\n";
function $e6985fb29d7e75d7$export$a88b0b0da9ef63ce(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Confluence' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $dlBdv.LogoWrapper), {
        svg: $e6985fb29d7e75d7$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("1zQC4", function(module, exports) {
$parcel$export(module.exports, "ConfluenceDataCenterIcon", () => $1261df2be6b304e0$export$53305f1f2855d3be);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::daf8acf7c1707ab5f837689f4e92f4a5>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

var $dkXTa = parcelRequire("dkXTa");
// `height` is set to 100% to allow the SVG to scale with the parent element
var $1261df2be6b304e0$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color, white)\" d=\"M6 .5h12A5.5 5.5 0 0 1 23.5 6v12a5.5 5.5 0 0 1-5.5 5.5H6A5.5 5.5 0 0 1 .5 18V6A5.5 5.5 0 0 1 6 .5\"/>\n    <path fill=\"none\" stroke=\"var(--border-color, #dddee1)\" d=\"M6 .5h12A5.5 5.5 0 0 1 23.5 6v12a5.5 5.5 0 0 1-5.5 5.5H6A5.5 5.5 0 0 1 .5 18V6A5.5 5.5 0 0 1 6 .5Z\"/>\n    <path fill=\"var(--icon-color, #1868db)\" d=\"M17.37 14.265c-3.704-1.79-4.785-2.058-6.346-2.058-1.83 0-3.391.761-4.785 2.902l-.229.35c-.187.288-.229.39-.229.514s.063.227.292.37l2.35 1.462c.125.083.23.124.333.124.125 0 .208-.062.333-.247l.375-.577c.582-.885 1.102-1.173 1.768-1.173.583 0 1.27.165 2.122.577l2.455 1.152c.25.124.52.062.645-.226l1.165-2.552c.125-.289.042-.474-.25-.618M6.572 9.757c3.703 1.791 4.785 2.059 6.346 2.059 1.83 0 3.39-.762 4.785-2.902l.229-.35c.187-.288.228-.391.228-.515 0-.123-.062-.226-.29-.37l-2.352-1.462c-.125-.082-.229-.123-.333-.123-.125 0-.208.061-.333.247l-.374.576c-.583.885-1.103 1.173-1.769 1.173-.582 0-1.269-.164-2.122-.576L8.132 6.361c-.25-.123-.52-.061-.645.227L6.322 9.14c-.125.288-.041.473.25.617\"/>\n</svg>\n";
function $1261df2be6b304e0$export$53305f1f2855d3be(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Confluence Data Center' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $dkXTa.IconWrapper), {
        svg: $1261df2be6b304e0$var$svg,
        label: label,
        type: "data-center",
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("1YppB", function(module, exports) {
$parcel$export(module.exports, "ConfluenceDataCenterLogoCS", () => $16ff1b53fcc3594d$export$b3e508cb103e1f93);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c86f2cdcf615e24dd3ad3f9b48bca5bf>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

var $dlBdv = parcelRequire("dlBdv");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $16ff1b53fcc3594d$var$svg = "<svg height=\"100%\" viewBox=\"0 0 188 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M181.16 12.09c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.2c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-15.1-2.16v2.36c-.92.49-2.33.71-3.74.71-5.46 0-8-3.31-8-8 0-4.63 2.55-7.94 8-7.94 1.38 0 2.45.18 3.65.74v2.45c-.98-.46-2.02-.74-3.47-.74-3.99 0-5.61 2.51-5.61 5.49s1.66 5.49 5.67 5.49c1.56 0 2.55-.21 3.5-.55m-14.5-6.23v8.99h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 3.53 0 5.55 2.42 5.55 6.66m-22.92-4.27c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-29.1-5.74V10h2.64v9.26c0 2.76 1.1 3.99 3.62 3.99 2.45 0 4.14-1.62 4.14-4.72V10h2.64v15.33h-2.64v-2.51c-.98 1.81-2.79 2.82-4.85 2.82-3.53 0-5.55-2.42-5.55-6.65m-2.23 6.31c-.21.06-.67.12-1.35.12-2.51 0-4.11-1.2-4.11-4.02V3.59h2.64V21.1c0 1.38.92 1.87 2.06 1.87.28 0 .46 0 .77-.03zM96.82 8.38V10h3.96v2.45h-3.96v12.88h-2.58V12.45h-2.48V10h2.48V8.31c0-2.85 1.59-4.78 4.88-4.78.8 0 1.32.12 1.78.25V6.2a8.7 8.7 0 0 0-1.66-.15c-1.62 0-2.42.95-2.42 2.33m-7.32 7.97v8.99h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 3.53 0 5.55 2.42 5.55 6.66m-23.34 9.28c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49m-9.23 9.63v2.67c-1.26.83-3.25 1.2-5.34 1.2-6.62 0-10.36-3.99-10.36-10.33 0-6.13 3.74-10.43 10.3-10.43 1.96 0 3.93.37 5.37 1.41v2.67c-1.44-.92-3.04-1.41-5.37-1.41-4.72 0-7.54 3.13-7.54 7.76s2.91 7.7 7.7 7.7c2.12 0 3.77-.49 5.24-1.23\"/>\n    <path fill=\"var(--tile-color, white)\" d=\"M8 .667h16A7.333 7.333 0 0 1 31.333 8v16A7.333 7.333 0 0 1 24 31.333H8A7.333 7.333 0 0 1 .667 24V8A7.333 7.333 0 0 1 8 .667\"/>\n    <path fill=\"none\" stroke=\"var(--border-color, #dddee1)\" stroke-width=\"1.333\" d=\"M8 .667h16A7.333 7.333 0 0 1 31.333 8v16A7.333 7.333 0 0 1 24 31.333H8A7.333 7.333 0 0 1 .667 24V8A7.333 7.333 0 0 1 8 .667Z\"/>\n    <path fill=\"var(--icon-color, #1868db)\" d=\"M23.16 19.02c-4.938-2.387-6.38-2.744-8.461-2.744-2.441 0-4.522 1.015-6.38 3.87l-.306.466c-.25.384-.305.521-.305.686s.084.302.389.494l3.134 1.948c.167.11.306.165.444.165.167 0 .278-.082.444-.33l.5-.768c.776-1.18 1.47-1.564 2.357-1.564.777 0 1.693.22 2.83.768l3.273 1.537c.333.165.694.083.86-.302l1.554-3.403c.166-.384.055-.63-.333-.823M8.762 13.01c4.938 2.388 6.38 2.744 8.461 2.744 2.441 0 4.522-1.015 6.38-3.87l.306-.466c.25-.384.305-.521.305-.686 0-.164-.083-.302-.388-.494L20.69 8.29c-.167-.11-.305-.165-.444-.165-.166 0-.277.082-.444.33l-.5.768c-.776 1.18-1.47 1.564-2.357 1.564-.777 0-1.692-.22-2.83-.768l-3.273-1.537c-.333-.165-.694-.083-.86.302L8.43 12.187c-.167.384-.056.63.332.823\"/>\n</svg>\n";
function $16ff1b53fcc3594d$export$b3e508cb103e1f93(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Confluence Data Center' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $dlBdv.LogoWrapper), {
        svg: $16ff1b53fcc3594d$var$svg,
        label: label,
        type: "data-center",
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("dEB2Z", function(module, exports) {
$parcel$export(module.exports, "CrowdIcon", () => $9f0bbf9ab4b2a1c5$export$eaf73f391f7103bd);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::9928c9b96accda0f9234a11fc7ddaca0>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

var $dkXTa = parcelRequire("dkXTa");
// `height` is set to 100% to allow the SVG to scale with the parent element
var $9f0bbf9ab4b2a1c5$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color, white)\" d=\"M6 .5h12A5.5 5.5 0 0 1 23.5 6v12a5.5 5.5 0 0 1-5.5 5.5H6A5.5 5.5 0 0 1 .5 18V6A5.5 5.5 0 0 1 6 .5\"/>\n    <path fill=\"none\" stroke=\"var(--border-color, #dddee1)\" d=\"M6 .5h12A5.5 5.5 0 0 1 23.5 6v12a5.5 5.5 0 0 1-5.5 5.5H6A5.5 5.5 0 0 1 .5 18V6A5.5 5.5 0 0 1 6 .5Z\"/>\n    <path fill=\"var(--icon-color, #1868db)\" d=\"M18.71 7.463 12 4.993l-6.71 2.47a.44.44 0 0 0-.29.433l.14 3.807c.103 3.148 1.684 5.489 4.163 7.018a.446.446 0 0 0 .646-.204l1.445-3.412a.22.22 0 0 0-.14-.298 2.585 2.585 0 1 1 1.492 0 .22.22 0 0 0-.14.298l1.446 3.412a.446.446 0 0 0 .645.204c2.48-1.529 4.06-3.87 4.163-7.018L19 7.896a.44.44 0 0 0-.29-.433\"/>\n</svg>\n";
function $9f0bbf9ab4b2a1c5$export$eaf73f391f7103bd(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Crowd' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $dkXTa.IconWrapper), {
        svg: $9f0bbf9ab4b2a1c5$var$svg,
        label: label,
        type: "data-center",
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("a1pB5", function(module, exports) {
$parcel$export(module.exports, "CrowdLogoCS", () => $74bdda6b0a46426e$export$3c371bdbcdfcdce);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::206fa44ab9c6427ebeb6aaad7e53b58f>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

var $dlBdv = parcelRequire("dlBdv");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $74bdda6b0a46426e$var$svg = "<svg height=\"100%\" viewBox=\"0 0 126 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M113.97 17.67c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V3.59h2.64v21.74zm-17.72 0h-3.37l-2.64-7.42-1.41-4.72-1.41 4.72-2.64 7.42h-3.37L84.45 10h2.91l4.42 13 4.48-13h2.51l4.48 13 4.41-13h2.91zm-28.47.31c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49m-13.77 4.14v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.68-5.43 3.93m-5.76 5.48v2.67c-1.26.83-3.25 1.2-5.34 1.2-6.62 0-10.36-3.99-10.36-10.33 0-6.13 3.74-10.43 10.3-10.43 1.96 0 3.93.37 5.37 1.41v2.67c-1.44-.92-3.04-1.41-5.37-1.41-4.72 0-7.54 3.13-7.54 7.76s2.91 7.7 7.7 7.7c2.12 0 3.77-.49 5.24-1.23\"/>\n    <path fill=\"var(--tile-color, white)\" d=\"M8 .667h16A7.333 7.333 0 0 1 31.333 8v16A7.333 7.333 0 0 1 24 31.333H8A7.333 7.333 0 0 1 .667 24V8A7.333 7.333 0 0 1 8 .667\"/>\n    <path fill=\"none\" stroke=\"var(--border-color, #dddee1)\" stroke-width=\"1.333\" d=\"M8 .667h16A7.333 7.333 0 0 1 31.333 8v16A7.333 7.333 0 0 1 24 31.333H8A7.333 7.333 0 0 1 .667 24V8A7.333 7.333 0 0 1 8 .667Z\"/>\n    <path fill=\"var(--icon-color, #1868db)\" d=\"M24.946 9.951 16 6.657 7.054 9.95a.59.59 0 0 0-.387.577l.187 5.076c.137 4.197 2.245 7.319 5.55 9.357.31.19.719.063.86-.272l1.928-4.55a.294.294 0 0 0-.185-.396 3.447 3.447 0 1 1 1.987 0 .294.294 0 0 0-.185.397l1.927 4.549c.142.335.55.463.86.272 3.305-2.038 5.413-5.16 5.55-9.357l.187-5.076a.59.59 0 0 0-.387-.577\"/>\n</svg>\n";
function $74bdda6b0a46426e$export$3c371bdbcdfcdce(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Crowd' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $dlBdv.LogoWrapper), {
        svg: $74bdda6b0a46426e$var$svg,
        label: label,
        type: "data-center",
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("gzMbQ", function(module, exports) {
$parcel$export(module.exports, "CustomerServiceManagementIcon", () => $c1154bc2e76da5bc$export$6da5aa77c402ba0f);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2cbaafcea60527c20df8d8395e491b95>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

var $dkXTa = parcelRequire("dkXTa");
// `height` is set to 100% to allow the SVG to scale with the parent element
var $c1154bc2e76da5bc$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#ffc716)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M16.43 17.42A6.97 6.97 0 0 1 12 19H6.4v-.47l3.84-3.78a3.25 3.25 0 0 0 1.76.52c.65 0 1.25-.19 1.76-.51zm.99-.99A6.97 6.97 0 0 0 19 12a6.97 6.97 0 0 0-1.58-4.43l-2.67 2.67c.33.51.52 1.11.52 1.76s-.19 1.25-.51 1.76zm-.99-9.85-2.67 2.67A3.25 3.25 0 0 0 12 8.73c-.65 0-1.25.19-1.76.52L7.57 6.58A6.97 6.97 0 0 1 12 5c1.68 0 3.22.59 4.43 1.58m-9.85.99A6.97 6.97 0 0 0 5 12c0 1.68.59 3.22 1.58 4.43l2.67-2.67A3.25 3.25 0 0 1 8.73 12c0-.65.19-1.25.52-1.76z\"/>\n</svg>\n";
var $c1154bc2e76da5bc$var$customThemeSvg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--themed-icon-color, currentcolor)\" d=\"M18 0a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6V6a6 6 0 0 1 6-6zm-4.238 14.751a3.25 3.25 0 0 1-1.762.516 3.25 3.25 0 0 1-1.762-.515L6.4 18.533V19H12a6.97 6.97 0 0 0 4.43-1.58zM6.58 7.571A6.97 6.97 0 0 0 5 12a6.97 6.97 0 0 0 1.58 4.43l2.669-2.668A3.25 3.25 0 0 1 8.733 12c0-.649.19-1.253.516-1.762zm8.172 2.667c.326.508.515 1.113.515 1.762s-.189 1.254-.515 1.762l2.668 2.668A6.97 6.97 0 0 0 19 12a6.97 6.97 0 0 0-1.58-4.43zM12 5a6.97 6.97 0 0 0-4.43 1.58l2.668 2.668A3.25 3.25 0 0 1 12 8.733c.649 0 1.253.19 1.762.516L16.43 6.58A6.97 6.97 0 0 0 12 5\"/>\n</svg>\n";
function $c1154bc2e76da5bc$export$6da5aa77c402ba0f(_ref) {
    var iconColor = _ref.iconColor, size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Customer Service Management' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $dkXTa.IconWrapper), {
        svg: $c1154bc2e76da5bc$var$svg,
        customThemeSvg: $c1154bc2e76da5bc$var$customThemeSvg,
        iconColor: iconColor,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("JVOL1", function(module, exports) {
$parcel$export(module.exports, "CustomerServiceManagementLogoCS", () => $08a10d77ef70bbc8$export$f597f0f7fadce0b9);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7b7476897879e097648c054d2783409e>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

var $dlBdv = parcelRequire("dlBdv");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $08a10d77ef70bbc8$var$svg = "<svg height=\"100%\" viewBox=\"0 0 456 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M451.86 20.58c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55c-.46.12-.98.25-1.78.25-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zm-7.33-4.23v8.99h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 3.53 0 5.55 2.42 5.55 6.66m-22.92-4.27c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-26.16-7.92v8.53h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 2.61 0 4.39 1.32 5.15 3.74.86-2.36 2.91-3.74 5.46-3.74 3.44 0 5.34 2.33 5.34 6.66v8.99h-2.64v-8.52c0-3.16-1.1-4.72-3.62-4.72-2.45 0-4.14 1.63-4.14 4.72m-22.92-4.74c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-18.64-.62v-1.53c-.98 2.02-2.82 3.07-5.18 3.07-4.05 0-6.07-3.46-6.07-7.97 0-4.32 2.12-7.97 6.38-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.58v13.95c0 4.51-2.12 7.54-7.6 7.54-2.58 0-3.99-.34-5.46-.83v-2.58c1.69.55 3.44.92 5.34.92 3.83 0 5.15-2.05 5.15-4.91m-8.68-6.44c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m-16.96.03c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-14.08-8.98v8.99h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 3.53 0 5.55 2.42 5.55 6.66m-28.33 1.31c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-31.44-11.01-2.76-7.48v18.49h-2.76V5.19h4.78l4.57 11.56 1.87 5.55 1.87-5.55 4.6-11.56h4.45v20.15h-2.76V7.06l-2.36 7.27-4.45 11.01h-2.67zm-21.51-2.23c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-15.1-2.16v2.36c-.92.49-2.33.71-3.74.71-5.46 0-8-3.31-8-8 0-4.63 2.55-7.94 8-7.94 1.38 0 2.45.18 3.65.74v2.45c-.98-.46-2.02-.74-3.47-.74-3.99 0-5.61 2.51-5.61 5.49s1.66 5.49 5.67 5.49c1.56 0 2.55-.21 3.5-.55M234.91 5.95c0-1.16.77-1.84 1.84-1.84s1.84.68 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-8.24 0h-3.53L217.69 10h2.76l4.97 13.09L230.36 10h2.76zm-15.45-9.04v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.68-5.43 3.93m-12.46-4.21c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.05 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-15.33-4.95c0 3.5-2.08 5.86-7.08 5.86-3.89 0-5.7-.77-7.27-1.56v-2.82c1.87.98 4.75 1.69 7.42 1.69 3.04 0 4.17-1.2 4.17-2.97 0-1.78-1.1-2.73-4.94-3.65-4.54-1.1-6.56-2.67-6.56-5.98 0-3.13 2.39-5.46 7.08-5.46 2.91 0 4.78.71 6.16 1.47v2.76c-2.02-1.16-4.2-1.53-6.29-1.53-2.64 0-4.2.92-4.2 2.76 0 1.66 1.29 2.48 4.85 3.37 4.26 1.07 6.65 2.45 6.65 6.07m-26.4-3.5v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.68-5.43 3.93m-12.46-4.21c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2H146.5c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-26.15-7.92v8.53h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 2.61 0 4.39 1.32 5.15 3.74.86-2.36 2.91-3.74 5.46-3.74 3.44 0 5.34 2.33 5.34 6.66v8.99h-2.64v-8.52c0-3.16-1.1-4.72-3.62-4.72-2.45 0-4.14 1.63-4.14 4.72m-23.34 8.81c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49M94.1 20.58c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55a6.3 6.3 0 0 1-1.78.25c-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45H94.1zm-6.7.58c0 2.55-1.66 4.48-5.77 4.48-2.3 0-4.17-.52-5.34-1.13v-2.79c1.32.77 3.53 1.5 5.46 1.5 2.02 0 3.07-.83 3.07-2.02 0-1.16-.89-1.84-3.8-2.54-3.4-.83-4.84-2.15-4.84-4.66 0-2.67 2.05-4.29 5.55-4.29 1.99 0 3.8.49 4.94 1.1v2.73c-1.84-.92-3.34-1.41-4.97-1.41-1.93 0-2.97.68-2.97 1.87 0 1.07.74 1.75 3.56 2.42 3.4.83 5.12 2.09 5.12 4.75m-27.6-2.18V10h2.64v9.26c0 2.76 1.1 3.99 3.62 3.99 2.45 0 4.14-1.63 4.14-4.72V10h2.64v15.33h-2.64v-2.51c-.98 1.81-2.79 2.82-4.84 2.82-3.53 0-5.55-2.42-5.55-6.65m-2.89 2.79v2.67c-1.26.83-3.25 1.2-5.34 1.2-6.62 0-10.36-3.99-10.36-10.33 0-6.13 3.74-10.43 10.3-10.43 1.96 0 3.93.37 5.37 1.41v2.67c-1.44-.92-3.04-1.41-5.37-1.41-4.72 0-7.54 3.13-7.54 7.76s2.91 7.7 7.7 7.7c2.12 0 3.77-.49 5.24-1.23\"/>\n    <path fill=\"var(--tile-color,#ffc716)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M21.91 23.23a9.3 9.3 0 0 1-5.91 2.1H8.53v-.62l5.12-5.04a4.34 4.34 0 0 0 2.35.69c.86 0 1.67-.25 2.35-.69zm1.32-1.32a9.3 9.3 0 0 0 2.1-5.91c0-2.24-.79-4.3-2.11-5.91l-3.56 3.56c.43.68.69 1.48.69 2.35s-.25 1.67-.69 2.35zM21.91 8.77l-3.56 3.56a4.34 4.34 0 0 0-2.35-.69c-.86 0-1.67.25-2.35.69l-3.56-3.56A9.3 9.3 0 0 1 16 6.67c2.24 0 4.3.79 5.91 2.11M8.77 10.09A9.3 9.3 0 0 0 6.67 16c0 2.24.79 4.3 2.11 5.91l3.56-3.56a4.34 4.34 0 0 1-.69-2.35c0-.86.25-1.67.69-2.35z\"/>\n</svg>\n";
function $08a10d77ef70bbc8$export$f597f0f7fadce0b9(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Customer Service Management' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $dlBdv.LogoWrapper), {
        svg: $08a10d77ef70bbc8$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("8CgoB", function(module, exports) {
$parcel$export(module.exports, "DxIcon", () => $645e97300d058240$export$9951d02c2d848122);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::fe1275028f179c85adabcde30f1dc14d>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

var $dkXTa = parcelRequire("dkXTa");
// `height` is set to 100% to allow the SVG to scale with the parent element
var $645e97300d058240$var$svg = "<svg height=\"100%\" viewBox=\"0 0 48 48\">\n    <path fill=\"var(--tile-color,#94c748)\" d=\"M0 12C0 5.373 5.373 0 12 0h24c6.627 0 12 5.373 12 12v24c0 6.627-5.373 12-12 12H12C5.373 48 0 42.627 0 36z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"m36.22 26.75 4.9 7.25h-4.78c-.52-.6-1.02-1.31-1.47-1.98-.68-1.02-.68-2.41.03-3.41zm-7.3-5.5L24.02 14h4.78c.52.6 1.02 1.31 1.47 1.98.68 1.02.68 2.41-.02 3.41zm6.98-6.02c.5-.84 1.07-1.16 1.95-1.16l3.9-.07-12.68 19.27a1.46 1.46 0 0 1-1.22.67H23.6c4.07-6.25 8.37-12.37 12.31-18.7M8 33.94h6.89c6.16 0 9.92-3.88 9.92-9.94s-3.76-9.94-9.92-9.94H8l4.28 3.9h-1.76C9.13 17.96 8 19.12 8 20.55v13.38m4.41-3.9V17.96h2.46c3.52 0 5.49 2.38 5.49 6.04 0 3.65-1.97 6.04-5.46 6.04z\"/>\n</svg>\n";
function $645e97300d058240$export$9951d02c2d848122(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Dx' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $dkXTa.IconWrapper), {
        svg: $645e97300d058240$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("atXVn", function(module, exports) {
$parcel$export(module.exports, "FeedbackIcon", () => $7a1b18946ccbad19$export$34420f0520b19b1d);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::43275811237134a9433985263fbf7530>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

var $dkXTa = parcelRequire("dkXTa");
// `height` is set to 100% to allow the SVG to scale with the parent element
var $7a1b18946ccbad19$var$svg = "<svg height=\"100%\" viewBox=\"0 0 48 48\">\n    <rect width=\"48\" height=\"48\" fill=\"var(--tile-color,#c97cf4)\" rx=\"12\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M20 19h5v11h-5zm7-9h5v28h-5zm7 6h5v16h-5zm-21 0h5v16h-5zm-7 5h5v7H6z\"/>\n</svg>\n";
function $7a1b18946ccbad19$export$34420f0520b19b1d(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Feedback' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $dkXTa.IconWrapper), {
        svg: $7a1b18946ccbad19$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("gEaeW", function(module, exports) {
$parcel$export(module.exports, "FeedbackLogoCS", () => $c1e8533d1c9e7c7d$export$bbccafb125ebd50c);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::5e0dda3588cef089e80240144a089b0a>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

var $dlBdv = parcelRequire("dlBdv");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $c1e8533d1c9e7c7d$var$svg = "<svg height=\"100%\" viewBox=\"0 0 169 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M157.894 25.334h-2.638V3.59h2.638v13.585L164.487 10h3.435l-7.207 7.544 7.513 7.79h-3.588l-6.746-7.177zm-5.648-2.761v2.362c-.92.49-2.331.705-3.742.705-5.458 0-8.004-3.312-8.004-8.004 0-4.63 2.546-7.943 8.004-7.943 1.38 0 2.454.184 3.65.736v2.454c-.982-.46-2.024-.736-3.466-.736-3.986 0-5.612 2.514-5.612 5.489s1.656 5.49 5.674 5.49c1.564 0 2.545-.215 3.496-.553m-26.118-4.906c0 3.68 1.472 5.52 4.201 5.52 2.361 0 4.477-1.503 4.477-4.907v-1.227c0-3.404-1.932-4.906-4.17-4.906-2.975 0-4.508 1.962-4.508 5.52m8.678 7.666v-2.76c-.981 2.024-2.821 3.067-5.182 3.067-4.079 0-6.134-3.465-6.134-7.973 0-4.324 2.147-7.974 6.44-7.974 2.239 0 3.956 1.012 4.876 3.006V10h2.638v15.333zm-16.09-7.666c0-3.68-1.472-5.52-4.201-5.52-2.362 0-4.478 1.502-4.478 4.906v1.227c0 3.404 1.932 4.907 4.171 4.907 2.975 0 4.508-1.963 4.508-5.52m-3.803 7.973c-2.238 0-3.956-1.012-4.876-3.005v2.698H107.4V3.592h2.637v9.17c.982-2.025 2.822-3.068 5.183-3.068 4.079 0 6.133 3.466 6.133 7.974 0 4.324-2.146 7.973-6.44 7.973m-22.806-7.974c0 3.68 1.472 5.52 4.2 5.52 2.362 0 4.478-1.503 4.478-4.907v-1.227c0-3.404-1.932-4.906-4.17-4.906-2.975 0-4.508 1.963-4.508 5.52m8.678 7.666v-2.76c-.981 2.024-2.821 3.067-5.182 3.067-4.08 0-6.134-3.465-6.134-7.973 0-4.324 2.147-7.974 6.44-7.974 2.239 0 3.956 1.013 4.876 3.006V3.59h2.638v21.743zM80.502 12.085c-2.79 0-4.201 1.81-4.477 4.478h8.555c-.153-2.852-1.44-4.478-4.078-4.478M86.39 24.72c-1.258.675-3.19.92-4.754.92-5.734 0-8.249-3.312-8.249-8.004 0-4.63 2.576-7.943 7.237-7.943 4.723 0 6.625 3.282 6.625 7.943v1.196H76.055c.368 2.607 2.055 4.293 5.673 4.293 1.78 0 3.282-.337 4.662-.828zM64.42 12.085c-2.79 0-4.202 1.81-4.477 4.478h8.556c-.154-2.852-1.442-4.478-4.08-4.478m5.888 12.635c-1.258.675-3.19.92-4.754.92-5.734 0-8.249-3.312-8.249-8.004 0-4.63 2.576-7.943 7.238-7.943 4.722 0 6.623 3.282 6.623 7.943v1.196H59.974c.368 2.607 2.055 4.293 5.674 4.293 1.778 0 3.28-.337 4.66-.828zm-15.679-6.9H45.49v7.514h-2.76V5.186h12.94v2.637H45.49v7.36h9.138z\"/>\n    <rect width=\"32\" height=\"32\" fill=\"var(--tile-color,#c97cf4)\" rx=\"8\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M13.333 12.667h3.334V20h-3.334zm4.667-6h3.333v18.666H18zm4.667 4H26v10.666h-3.333zm-14 0H12v10.666H8.667zM4 14h3.333v4.666H4z\"/>\n</svg>\n";
function $c1e8533d1c9e7c7d$export$bbccafb125ebd50c(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Feedback' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $dlBdv.LogoWrapper), {
        svg: $c1e8533d1c9e7c7d$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("12lOh", function(module, exports) {
$parcel$export(module.exports, "FocusIcon", () => $0c16e5609534a2b0$export$1e02e7298035a77c);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c86bc4a90f7eb35fd36ae7c99f20011b>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

var $dkXTa = parcelRequire("dkXTa");
// `height` is set to 100% to allow the SVG to scale with the parent element
var $0c16e5609534a2b0$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#fb9700)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M20.84 12.21a4.29 4.29 0 0 0-6.05 0l-1.394 1.393c-.77.769-2.02.769-2.789 0L9.45 12.445 6.424 15.47l1.158 1.158a6.25 6.25 0 0 0 8.838 0zm-17.68-.418a4.253 4.253 0 0 0 6.034.017l1.412-1.412a1.973 1.973 0 0 1 2.788 0l1.158 1.158 3.026-3.025-1.158-1.158a6.25 6.25 0 0 0-8.838 0l-4.42 4.419z\"/>\n</svg>\n";
function $0c16e5609534a2b0$export$1e02e7298035a77c(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Focus' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $dkXTa.IconWrapper), {
        svg: $0c16e5609534a2b0$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("6Gyhf", function(module, exports) {
$parcel$export(module.exports, "FocusLogoCS", () => $4de141105e2ca493$export$3a6e8b37e069a69d);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7aca4717e5f7edbaa74141430c7d1f8d>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

var $dlBdv = parcelRequire("dlBdv");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $4de141105e2ca493$var$svg = "<svg height=\"100%\" viewBox=\"0 0 117 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M116.03 21.16c0 2.55-1.66 4.48-5.76 4.48-2.3 0-4.17-.52-5.34-1.13v-2.79c1.32.77 3.53 1.5 5.46 1.5 2.02 0 3.07-.83 3.07-2.02 0-1.16-.89-1.84-3.8-2.54-3.4-.83-4.85-2.15-4.85-4.66 0-2.67 2.06-4.29 5.55-4.29 1.99 0 3.8.49 4.94 1.1v2.73c-1.84-.92-3.34-1.41-4.97-1.41-1.93 0-2.97.68-2.97 1.87 0 1.07.74 1.75 3.56 2.42 3.4.83 5.12 2.09 5.12 4.75m-27.6-2.18V10h2.64v9.26c0 2.76 1.1 3.99 3.62 3.99 2.45 0 4.14-1.62 4.14-4.72V10h2.64v15.33h-2.64v-2.51c-.98 1.81-2.79 2.82-4.85 2.82-3.53 0-5.55-2.42-5.55-6.65m-2.71 3.58v2.36c-.92.49-2.33.71-3.74.71-5.46 0-8-3.31-8-8 0-4.63 2.55-7.94 8-7.94 1.38 0 2.45.18 3.65.74v2.45c-.98-.46-2.02-.74-3.47-.74-3.99 0-5.61 2.51-5.61 5.49s1.66 5.49 5.67 5.49c1.56 0 2.55-.21 3.5-.55M64.6 25.64c-4.6 0-7.3-3.4-7.3-8S60 9.7 64.6 9.7c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49m-9.97 5.67h-9.14v7.51h-2.76V5.19h12.94v2.64H45.49v7.36h9.14z\"/>\n    <path fill=\"var(--tile-color,#fb9700)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M27.607 16.272c-2.176-2.176-5.712-2.152-7.865 0l-1.812 1.812c-1 1-2.625 1-3.625 0L12.8 16.578l-3.933 3.934 1.505 1.505a8.126 8.126 0 0 0 11.49 0zm-22.982-.541c2.176 2.175 5.668 2.196 7.844.02l1.834-1.834c1-1 2.625-1 3.625 0l1.505 1.505 3.934-3.933-1.505-1.505a8.126 8.126 0 0 0-11.49 0l-5.745 5.745z\"/>\n</svg>\n";
function $4de141105e2ca493$export$3a6e8b37e069a69d(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Focus' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $dlBdv.LogoWrapper), {
        svg: $4de141105e2ca493$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("ewaPX", function(module, exports) {
$parcel$export(module.exports, "GoalsIcon", () => $a91c75e095c80598$export$9eb74917ea768ed4);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::691ffc068fd79d2f7585ba74e9375893>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

var $dkXTa = parcelRequire("dkXTa");
// `height` is set to 100% to allow the SVG to scale with the parent element
var $a91c75e095c80598$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M14.352 12a2.352 2.352 0 1 1-4.704 0 2.352 2.352 0 0 1 4.704 0\"/>\n    <path fill=\"var(--icon-color, #101214)\" fill-rule=\"evenodd\" d=\"M12 18.563a6.562 6.562 0 1 0 0-13.125 6.562 6.562 0 0 0 0 13.125M16.102 12a4.102 4.102 0 1 1-8.204 0 4.102 4.102 0 0 1 8.204 0\" clip-rule=\"evenodd\"/>\n</svg>\n";
function $a91c75e095c80598$export$9eb74917ea768ed4(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Goals' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $dkXTa.IconWrapper), {
        svg: $a91c75e095c80598$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("aLeV1", function(module, exports) {
$parcel$export(module.exports, "GoalsLogoCS", () => $7d59ddb7b829c48b$export$c527a545aa426db3);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4fcd237a4e74e8fc6ee2ed98ecae9d02>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

var $dlBdv = parcelRequire("dlBdv");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $7d59ddb7b829c48b$var$svg = "<svg height=\"100%\" viewBox=\"0 0 116 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M115.55 21.16c0 2.55-1.66 4.48-5.77 4.48-2.3 0-4.17-.52-5.34-1.13v-2.79c1.32.77 3.53 1.5 5.46 1.5 2.02 0 3.07-.83 3.07-2.02 0-1.16-.89-1.84-3.8-2.54-3.4-.83-4.84-2.15-4.84-4.66 0-2.67 2.05-4.29 5.55-4.29 1.99 0 3.8.49 4.94 1.1v2.73c-1.84-.92-3.34-1.41-4.97-1.41-1.93 0-2.97.68-2.97 1.87 0 1.07.74 1.75 3.56 2.42 3.4.83 5.12 2.09 5.12 4.75m-13.12 4.13c-.21.06-.67.12-1.35.12-2.51 0-4.11-1.19-4.11-4.02V3.59h2.64V21.1c0 1.38.92 1.87 2.06 1.87.28 0 .46 0 .77-.03zm-20.75-7.63c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-20.7.31c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49M58.71 24.2c-1.59.95-4.54 1.44-6.81 1.44-6.93 0-10.67-4.23-10.67-10.33 0-6.56 4.26-10.46 11.44-10.46 1.6 0 3.47.18 5.24.8v2.76c-1.53-.61-3.34-.89-5.21-.89-5.98 0-8.71 2.98-8.71 7.73 0 4.66 2.76 7.76 8.56 7.76.95 0 2.27-.09 3.4-.43v-5.61H50.8v-2.64h7.91z\"/>\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M19.36 16a3.36 3.36 0 1 1-6.72 0 3.36 3.36 0 0 1 6.72 0\"/>\n    <path fill=\"var(--icon-color, #101214)\" fill-rule=\"evenodd\" d=\"M16 25.375a9.375 9.375 0 1 0 0-18.75 9.375 9.375 0 1 0 0 18.75M21.86 16a5.86 5.86 0 1 1-11.72 0 5.86 5.86 0 0 1 11.72 0\" clip-rule=\"evenodd\"/>\n</svg>\n";
function $7d59ddb7b829c48b$export$c527a545aa426db3(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Goals' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $dlBdv.LogoWrapper), {
        svg: $7d59ddb7b829c48b$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("5tXYV", function(module, exports) {
$parcel$export(module.exports, "GuardIcon", () => $3fde30457b2fb8db$export$3f95fcfdc25a741d);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::9271fe2e99ed03180fc112676167f42e>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

var $dkXTa = parcelRequire("dkXTa");
// `height` is set to 100% to allow the SVG to scale with the parent element
var $3fde30457b2fb8db$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M5.49 10.87h13.02c.374 0 .574-.2.574-.574V5.907c0-.374-.2-.574-.574-.574h-2.744c-.374 0-.573.2-.573.574v2.22h-1.247v-2.22c0-.374-.2-.574-.574-.574h-2.743c-.374 0-.574.2-.574.574v2.22H8.807v-2.22c0-.374-.2-.574-.573-.574H5.49c-.374 0-.573.2-.573.574v4.39c0 .373.2.573.573.573m.225 3.84a8.7 8.7 0 0 1-.5-2.493c-.024-.324.126-.499.475-.499h12.62c.349 0 .498.15.498.449a8.2 8.2 0 0 1-.523 2.544c-.15.399-.375.573-.799.573H6.513c-.424 0-.649-.174-.798-.573m11.547 2.07C16.065 18.253 14.095 19.2 12 19.2s-4.116-.948-5.288-2.42c-.299-.398-.15-.648.15-.648h10.275c.3 0 .45.25.125.649\"/>\n</svg>\n";
function $3fde30457b2fb8db$export$3f95fcfdc25a741d(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Guard' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $dkXTa.IconWrapper), {
        svg: $3fde30457b2fb8db$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("87aEy", function(module, exports) {
$parcel$export(module.exports, "GuardLogoCS", () => $5e873dad6b32a772$export$2b896c4d595a4331);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::db6984f13fa8a1f65e3a27814935822a>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

var $dlBdv = parcelRequire("dlBdv");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $5e873dad6b32a772$var$svg = "<svg height=\"100%\" viewBox=\"0 0 120 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M108.4 17.67c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V3.59h2.64v21.74zm-17.8-9.04v9.05H96.7V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.67-5.43 3.93m-17.86 1.37c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-27.42-6.34V10h2.64v9.26c0 2.76 1.1 3.99 3.62 3.99 2.45 0 4.14-1.62 4.14-4.72V10h2.64v15.33h-2.64v-2.51c-.98 1.81-2.79 2.82-4.84 2.82-3.53 0-5.55-2.42-5.55-6.65m-3.98 5.21c-1.59.95-4.54 1.44-6.81 1.44-6.93 0-10.67-4.23-10.67-10.33 0-6.56 4.26-10.46 11.44-10.46 1.6 0 3.47.18 5.24.8v2.76c-1.53-.61-3.34-.89-5.21-.89-5.98 0-8.71 2.98-8.71 7.73 0 4.66 2.76 7.76 8.56 7.76.95 0 2.27-.09 3.4-.43v-5.61H50.8v-2.64h7.91z\"/>\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M8.188 14.644h15.623c.449 0 .688-.24.688-.688V8.688c0-.449-.24-.688-.688-.688h-3.292c-.45 0-.689.24-.689.688v2.664h-1.496V8.688c0-.449-.24-.688-.688-.688h-3.293c-.448 0-.688.24-.688.688v2.664H12.17V8.688c0-.449-.24-.688-.689-.688H8.188c-.449 0-.688.24-.688.688v5.268c0 .449.24.688.688.688m.27 4.609a10.4 10.4 0 0 1-.599-2.993c-.03-.389.15-.598.569-.598H23.57c.42 0 .599.18.599.538q-.09 1.662-.629 3.053c-.18.479-.448.688-.957.688H9.415c-.508 0-.778-.21-.957-.688m13.856 2.484c-1.436 1.766-3.8 2.903-6.314 2.903s-4.939-1.137-6.345-2.903c-.36-.479-.18-.778.18-.778h12.33c.359 0 .538.3.15.778\"/>\n</svg>\n";
function $5e873dad6b32a772$export$2b896c4d595a4331(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Guard' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $dlBdv.LogoWrapper), {
        svg: $5e873dad6b32a772$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("jdkdw", function(module, exports) {
$parcel$export(module.exports, "HomeIcon", () => $dfcee9eb5660984d$export$92c8767b874048d);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2dae141e789f6f860676eab772d48c16>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

var $dkXTa = parcelRequire("dkXTa");
// `height` is set to 100% to allow the SVG to scale with the parent element
var $dfcee9eb5660984d$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M5.875 10.688v7.437h4.375V13.75h3.5v4.375h4.375v-7.437L12 5z\"/>\n</svg>\n";
function $dfcee9eb5660984d$export$92c8767b874048d(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Home' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $dkXTa.IconWrapper), {
        svg: $dfcee9eb5660984d$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("9pivQ", function(module, exports) {
$parcel$export(module.exports, "HomeLogoCS", () => $6d94cf131d4d8744$export$8b6b7f1b1b2367d3);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f61715fd61f2481e52a0f7c7611f421f>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

var $dlBdv = parcelRequire("dlBdv");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $6d94cf131d4d8744$var$svg = "<svg height=\"100%\" viewBox=\"0 0 121 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M113.57 12.09c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zM93.3 16.81v8.53h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 2.61 0 4.39 1.32 5.15 3.74.86-2.36 2.91-3.74 5.46-3.74 3.43 0 5.34 2.33 5.34 6.66v8.99h-2.64v-8.52c0-3.16-1.1-4.72-3.62-4.72-2.45 0-4.14 1.63-4.14 4.72m-23.33 8.81c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49M56.41 5.19h2.76v20.15h-2.76v-8.71H45.8v8.71h-2.76V5.19h2.76v8.8h10.61z\"/>\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M7.25 14.125V24.75h6.25V18.5h5v6.25h6.25V14.125L16 6z\"/>\n</svg>\n";
function $6d94cf131d4d8744$export$8b6b7f1b1b2367d3(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Home' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $dlBdv.LogoWrapper), {
        svg: $6d94cf131d4d8744$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("2RnSC", function(module, exports) {
$parcel$export(module.exports, "HubIcon", () => $21530e0c9bf76790$export$80b8b269d8b5014e);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::459e9cba95b1e0b094b9b0a89db30ecd>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

var $dkXTa = parcelRequire("dkXTa");
// `height` is set to 100% to allow the SVG to scale with the parent element
var $21530e0c9bf76790$var$svg = "<svg height=\"100%\" viewBox=\"0 0 32 32\">\n    <g clip-path=\"url(#clip0_95164_16219)\">\n        <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n        <g clip-path=\"url(#clip1_95164_16219)\">\n            <path fill=\"var(--icon-color, #101214)\" fill-rule=\"evenodd\" d=\"M9 25.333V6.667h14v18.666h-5.25V21.25h-3.5v4.083zm3.5-14.583h2.333V9H12.5zm4.667 0H19.5V9h-2.333zm-2.334 4.083H12.5v-1.75h2.333zM12.5 18.916h2.333v-1.75H12.5zm7-4.083h-2.333v-1.75H19.5zm-2.333 4.083H19.5v-1.75h-2.333z\" clip-rule=\"evenodd\"/>\n        </g>\n    </g>\n    <defs>\n        <clipPath id=\"clip0_95164_16219\">\n            <path fill=\"var(--icon-color, white)\" d=\"M0 0h32v32H0z\"/>\n        </clipPath>\n        <clipPath id=\"clip1_95164_16219\">\n            <path fill=\"var(--icon-color, white)\" d=\"M2 2h28v28H2z\"/>\n        </clipPath>\n    </defs>\n</svg>\n";
function $21530e0c9bf76790$export$80b8b269d8b5014e(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Hub' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $dkXTa.IconWrapper), {
        svg: $21530e0c9bf76790$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("3fC3N", function(module, exports) {
$parcel$export(module.exports, "HubLogoCS", () => $25e04bc358978974$export$7a38180641471460);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::edd23980285704c09d78f5241a37a99c>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

var $dlBdv = parcelRequire("dlBdv");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $25e04bc358978974$var$svg = "<svg height=\"100%\" viewBox=\"0 0 95 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M91.61 17.67c0-3.68-1.47-5.52-4.2-5.52-2.36 0-4.48 1.5-4.48 4.91v1.23c0 3.4 1.93 4.91 4.17 4.91 2.98 0 4.51-1.96 4.51-5.52m-3.8 7.97c-2.24 0-3.96-1.01-4.88-3v2.7h-2.64V3.59h2.64v9.17c.98-2.02 2.82-3.07 5.18-3.07 4.08 0 6.13 3.47 6.13 7.97 0 4.32-2.15 7.97-6.44 7.97m-24.52-6.64V10h2.64v9.26c0 2.76 1.1 3.99 3.62 3.99 2.45 0 4.14-1.62 4.14-4.72V10h2.64v15.33h-2.64v-2.51c-.98 1.81-2.79 2.82-4.84 2.82-3.53 0-5.55-2.42-5.55-6.65M56.4 5.19h2.76v20.15H56.4v-8.71H45.79v8.71h-2.76V5.19h2.76v8.8H56.4z\"/>\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" fill-rule=\"evenodd\" d=\"M9 25.333V6.667h14v18.666h-5.25V21.25h-3.5v4.083zm3.5-14.583h2.333V9H12.5zm4.667 0H19.5V9h-2.333zm-2.334 4.083H12.5v-1.75h2.333zM12.5 18.916h2.333v-1.75H12.5zm7-4.083h-2.333v-1.75H19.5zm-2.333 4.083H19.5v-1.75h-2.333z\" clip-rule=\"evenodd\"/>\n</svg>\n";
function $25e04bc358978974$export$7a38180641471460(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Hub' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $dlBdv.LogoWrapper), {
        svg: $25e04bc358978974$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("aEDe1", function(module, exports) {
$parcel$export(module.exports, "JiraIcon", () => $7c1c11195d413b75$export$c4b5b1f965d8b3eb);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b225283860ba91a6c228b8f4fa0e1d39>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

var $dkXTa = parcelRequire("dkXTa");
// `height` is set to 100% to allow the SVG to scale with the parent element
var $7c1c11195d413b75$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#1868db)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, white)\" d=\"M9.051 15.434H7.734c-1.988 0-3.413-1.218-3.413-3h7.085c.367 0 .605.26.605.63v7.13c-1.772 0-2.96-1.435-2.96-3.434zm3.5-3.543h-1.318c-1.987 0-3.413-1.196-3.413-2.978h7.085c.367 0 .627.239.627.608v7.13c-1.772 0-2.981-1.435-2.981-3.434zm3.52-3.522h-1.317c-1.987 0-3.413-1.217-3.413-3h7.085c.367 0 .605.262.605.61v7.129c-1.771 0-2.96-1.435-2.96-3.434z\"/>\n</svg>\n";
var $7c1c11195d413b75$var$customThemeSvg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--themed-icon-color, currentcolor)\" d=\"M18 0a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6V6a6 6 0 0 1 6-6zM4.321 12.434c0 1.782 1.425 3 3.412 3h1.319v1.326c0 2 1.188 3.433 2.959 3.433v-7.129c0-.369-.238-.63-.605-.63zm3.5-3.52c0 1.781 1.425 2.977 3.412 2.977h1.318v1.326c0 2 1.21 3.433 2.98 3.433V9.521c0-.369-.259-.608-.626-.608zm3.52-3.544c0 1.782 1.426 3 3.413 3h1.317v1.304c0 2 1.188 3.433 2.96 3.433V5.98c0-.348-.238-.609-.605-.609z\"/>\n</svg>\n";
function $7c1c11195d413b75$export$c4b5b1f965d8b3eb(_ref) {
    var iconColor = _ref.iconColor, size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Jira' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $dkXTa.IconWrapper), {
        svg: $7c1c11195d413b75$var$svg,
        customThemeSvg: $7c1c11195d413b75$var$customThemeSvg,
        iconColor: iconColor,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("9sCCX", function(module, exports) {
$parcel$export(module.exports, "JiraLogoCS", () => $6e34b13172a5b29b$export$bf4c5f97b468e8d6);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3ed7d2f84cfdfe8bfef2a295bafed6da>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

var $dlBdv = parcelRequire("dlBdv");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $6e34b13172a5b29b$var$svg = "<svg height=\"100%\" viewBox=\"0 0 83 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M71.02 17.67c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.98 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-17.79-9.04v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.67-5.43 3.93M52.22 5.95c0-1.17.77-1.84 1.84-1.84s1.84.67 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-6.42-5.95V5.19h2.76V19.2c0 3.71-1.63 6.26-5.43 6.26-1.44 0-2.55-.25-3.31-.52v-2.67c.83.34 1.84.52 2.85.52 2.33 0 3.13-1.41 3.13-3.4\"/>\n    <path fill=\"var(--tile-color,#1868db)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, white)\" d=\"M11.965 20.698h-1.803c-2.72 0-4.67-1.666-4.67-4.105h9.695c.502 0 .827.357.827.863v9.756c-2.423 0-4.05-1.963-4.05-4.7zm4.788-4.848H14.95c-2.72 0-4.67-1.636-4.67-4.075h9.695c.503 0 .857.327.857.832v9.756c-2.424 0-4.079-1.963-4.079-4.7zm4.818-4.82h-1.803c-2.72 0-4.67-1.665-4.67-4.104h9.695c.503 0 .828.357.828.833v9.756c-2.424 0-4.05-1.963-4.05-4.7z\"/>\n</svg>\n";
function $6e34b13172a5b29b$export$bf4c5f97b468e8d6(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Jira' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $dlBdv.LogoWrapper), {
        svg: $6e34b13172a5b29b$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("8zpHc", function(module, exports) {
$parcel$export(module.exports, "JiraDataCenterIcon", () => $63d5863d2ed13516$export$f8455b5667a3ee0c);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::61edfa3e375524991498620530471e0e>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

var $dkXTa = parcelRequire("dkXTa");
// `height` is set to 100% to allow the SVG to scale with the parent element
var $63d5863d2ed13516$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color, white)\" d=\"M6 .5h12A5.5 5.5 0 0 1 23.5 6v12a5.5 5.5 0 0 1-5.5 5.5H6A5.5 5.5 0 0 1 .5 18V6A5.5 5.5 0 0 1 6 .5\"/>\n    <path fill=\"none\" stroke=\"var(--border-color, #dddee1)\" d=\"M6 .5h12A5.5 5.5 0 0 1 23.5 6v12a5.5 5.5 0 0 1-5.5 5.5H6A5.5 5.5 0 0 1 .5 18V6A5.5 5.5 0 0 1 6 .5Z\"/>\n    <path fill=\"var(--icon-color, #1868db)\" d=\"M8.974 15.523H7.62c-2.04 0-3.502-1.249-3.502-3.078h7.271c.377 0 .62.268.62.647v7.317c-1.817 0-3.036-1.472-3.036-3.525zm3.591-3.636h-1.352c-2.04 0-3.503-1.227-3.503-3.056h7.272c.376 0 .642.245.642.625v7.317c-1.817 0-3.059-1.473-3.059-3.525zm3.614-3.614h-1.353c-2.04 0-3.502-1.249-3.502-3.078h7.271c.377 0 .62.268.62.624v7.318c-1.817 0-3.036-1.473-3.036-3.525z\"/>\n</svg>\n";
function $63d5863d2ed13516$export$f8455b5667a3ee0c(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Jira Data Center' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $dkXTa.IconWrapper), {
        svg: $63d5863d2ed13516$var$svg,
        label: label,
        type: "data-center",
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("g0F9F", function(module, exports) {
$parcel$export(module.exports, "JiraDataCenterLogoCS", () => $ba7c91ea510df47c$export$3224b07bc93ef23e);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::193cafbd0d66aed78a8eae06654a150d>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

var $dlBdv = parcelRequire("dlBdv");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $ba7c91ea510df47c$var$svg = "<svg height=\"100%\" viewBox=\"0 0 83 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M71.02 17.67c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.98 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.47-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-17.79-9.04v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.67-5.43 3.93M52.22 5.95c0-1.17.77-1.84 1.84-1.84s1.84.67 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-6.42-5.95V5.19h2.76V19.2c0 3.71-1.63 6.26-5.43 6.26-1.44 0-2.55-.24-3.31-.52v-2.67c.83.34 1.84.52 2.85.52 2.33 0 3.13-1.41 3.13-3.4\"/>\n    <path fill=\"var(--tile-color, white)\" d=\"M8 .667h16A7.333 7.333 0 0 1 31.333 8v16A7.333 7.333 0 0 1 24 31.333H8A7.333 7.333 0 0 1 .667 24V8A7.333 7.333 0 0 1 8 .667\"/>\n    <path fill=\"none\" stroke=\"var(--border-color, #dddee1)\" stroke-width=\"1.333\" d=\"M8 .667h16A7.333 7.333 0 0 1 31.333 8v16A7.333 7.333 0 0 1 24 31.333H8A7.333 7.333 0 0 1 .667 24V8A7.333 7.333 0 0 1 8 .667Z\"/>\n    <path fill=\"var(--icon-color, #1868db)\" d=\"M11.965 20.699h-1.803c-2.72 0-4.67-1.666-4.67-4.105h9.695c.502 0 .827.357.827.863v9.756c-2.424 0-4.05-1.963-4.05-4.7zm4.788-4.848H14.95c-2.72 0-4.67-1.636-4.67-4.075h9.695c.502 0 .857.327.857.832v9.756c-2.424 0-4.079-1.963-4.079-4.699zm4.818-4.819h-1.803c-2.72 0-4.67-1.666-4.67-4.105h9.695c.503 0 .828.357.828.833v9.756c-2.424 0-4.05-1.963-4.05-4.7z\"/>\n</svg>\n";
function $ba7c91ea510df47c$export$3224b07bc93ef23e(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Jira Data Center' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $dlBdv.LogoWrapper), {
        svg: $ba7c91ea510df47c$var$svg,
        label: label,
        type: "data-center",
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("3SdKt", function(module, exports) {
$parcel$export(module.exports, "JiraProductDiscoveryIcon", () => $2d211468a13d2fb7$export$21bfbeb62fdcce8d);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3b3ec3c590ed89c431e0f979daa3e25e>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

var $dkXTa = parcelRequire("dkXTa");
// `height` is set to 100% to allow the SVG to scale with the parent element
var $2d211468a13d2fb7$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#c97cf4)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M13.467 4.882a9.47 9.47 0 0 0 5.422 0c.159-.035.265.07.23.229-.513 1.85-.513 3.558 0 5.408.035.14-.072.264-.23.211a10.1 10.1 0 0 0-5.422 0c-.142.053-.265-.07-.212-.211.476-1.85.476-3.559 0-5.408-.053-.159.07-.264.212-.23m.724 6.553v.3c0 1.39-.972 2.412-2.173 2.412a2.153 2.153 0 0 1-2.154-2.166c0-1.198.971-2.15 2.331-2.15h.353V5.62c-.176-.017-.353-.017-.53-.017a6.387 6.387 0 0 0-6.393 6.394 6.37 6.37 0 0 0 6.393 6.377c3.533 0 6.411-2.854 6.411-6.377v-.563z\"/>\n</svg>\n";
var $2d211468a13d2fb7$var$customThemeSvg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--themed-icon-color, currentcolor)\" d=\"M18 0a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6V6a6 6 0 0 1 6-6zm-5.981 5.604a6.387 6.387 0 0 0-6.394 6.394 6.373 6.373 0 0 0 6.394 6.377c3.532 0 6.41-2.854 6.41-6.377v-.563H14.19v.3c0 1.39-.97 2.412-2.171 2.413a2.154 2.154 0 0 1-2.156-2.168c0-1.197.973-2.148 2.332-2.148h.353v-4.21c-.177-.018-.353-.018-.53-.018m6.87-.722a9.47 9.47 0 0 1-5.422 0c-.141-.035-.265.07-.212.228.477 1.85.477 3.559 0 5.409-.053.14.07.264.212.211a10.1 10.1 0 0 1 5.422 0c.159.053.265-.07.23-.211-.513-1.85-.513-3.56 0-5.409.034-.158-.072-.263-.23-.228\"/>\n</svg>\n";
function $2d211468a13d2fb7$export$21bfbeb62fdcce8d(_ref) {
    var iconColor = _ref.iconColor, size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Jira Product Discovery' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $dkXTa.IconWrapper), {
        svg: $2d211468a13d2fb7$var$svg,
        customThemeSvg: $2d211468a13d2fb7$var$customThemeSvg,
        iconColor: iconColor,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("izl08", function(module, exports) {
$parcel$export(module.exports, "JiraProductDiscoveryLogoCS", () => $d84bc94694df07a6$export$602140a6a10b02bf);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c8e2d27dec964efc37c6ed5782c3fe57>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

var $dlBdv = parcelRequire("dlBdv");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $d84bc94694df07a6$var$svg = "<svg height=\"100%\" viewBox=\"0 0 327 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M317.88 24.35h-1.72L310.62 10h2.82l4.91 13.13 4.9-13.13h2.82l-5.8 14.84c-1.72 4.39-2.7 6.65-6.59 6.65-1.32 0-2.06-.12-2.82-.43v-2.27c.89.28 1.9.37 2.67.37 2.15 0 3.1-1.47 4.36-4.82m-13.25-8.05v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.67-5.43 3.93m-12.47-4.21c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-19.72.6h-3.53L268.87 10h2.76l4.97 13.1 4.93-13.1h2.76zm-17.46.31c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49m-9.39 10.42v2.36c-.92.49-2.33.71-3.74.71-5.46 0-8-3.31-8-8 0-4.63 2.55-7.94 8-7.94 1.38 0 2.45.18 3.65.74v2.45c-.98-.46-2.02-.74-3.46-.74-3.99 0-5.61 2.51-5.61 5.49s1.66 5.49 5.67 5.49c1.56 0 2.55-.21 3.5-.55m-13.88-1.42c0 2.55-1.66 4.48-5.76 4.48-2.3 0-4.17-.52-5.34-1.13v-2.79c1.32.77 3.53 1.5 5.46 1.5 2.02 0 3.07-.83 3.07-2.02 0-1.16-.89-1.84-3.8-2.54-3.4-.83-4.85-2.15-4.85-4.66 0-2.67 2.06-4.29 5.55-4.29 1.99 0 3.8.49 4.94 1.1v2.73c-1.84-.92-3.34-1.41-4.97-1.41-1.93 0-2.97.68-2.97 1.87 0 1.07.74 1.75 3.56 2.42 3.4.83 5.12 2.09 5.12 4.75m-17.7-15.22c0-1.16.77-1.84 1.84-1.84s1.84.68 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zM207.68 7.82h-4.54v14.87h4.69c4.6 0 6.9-2.42 6.9-7.3 0-4.91-2.18-7.57-7.05-7.57m-7.3 17.51V5.19h7.42c6.53 0 9.69 4.08 9.69 10.12 0 6.1-3.19 10.03-9.69 10.03zm-13.41-4.75c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55c-.46.12-.98.25-1.78.25-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zm-6.66 1.99v2.36c-.92.49-2.33.71-3.74.71-5.46 0-8-3.31-8-8 0-4.63 2.55-7.94 8-7.94 1.38 0 2.45.18 3.65.74v2.45c-.98-.46-2.02-.74-3.46-.74-3.99 0-5.61 2.51-5.61 5.49s1.66 5.49 5.67 5.49c1.56 0 2.55-.21 3.5-.55m-27.86-3.59V10h2.64v9.26c0 2.76 1.1 3.99 3.62 3.99 2.45 0 4.14-1.62 4.14-4.72V10h2.64v15.33h-2.64v-2.51c-.98 1.81-2.79 2.82-4.84 2.82-3.53 0-5.55-2.42-5.55-6.65m-14.99-1.32c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V3.59h2.64v21.74zm-20.7.31c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49m-13.78 4.14v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.67-5.43 3.93m-5-4.4c0 4.39-2.45 6.84-7.48 6.84h-4.02v6.59h-2.76V5.19h6.78c5.03 0 7.48 2.58 7.48 6.72m-7.79 4.2c3.56.12 4.94-1.56 4.94-4.14 0-2.45-1.38-4.14-4.94-4.14h-3.71v8.28zm-27.87 1.56c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.98 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-17.79-9.04v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.67-5.43 3.93M52.22 5.95c0-1.16.77-1.84 1.84-1.84s1.84.68 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-6.42-5.95V5.19h2.76V19.2c0 3.71-1.63 6.26-5.43 6.26-1.44 0-2.55-.24-3.31-.52v-2.67c.83.34 1.84.52 2.85.52 2.33 0 3.13-1.41 3.13-3.4\"/>\n    <path fill=\"var(--tile-color,#c97cf4)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M17.448 6.967c2.544.746 5.113.746 7.656 0 .225-.05.375.1.325.323-.724 2.612-.724 5.025 0 7.637.05.199-.1.373-.325.298a14.3 14.3 0 0 0-7.656 0c-.2.075-.374-.1-.3-.298.674-2.612.674-5.025 0-7.637-.074-.223.1-.373.3-.323m1.023 9.253v.423c0 1.965-1.372 3.408-3.068 3.408a3.04 3.04 0 0 1-3.043-3.06c0-1.691 1.372-3.034 3.292-3.034h.5V8.012c-.25-.025-.5-.025-.749-.025a9.02 9.02 0 0 0-9.028 9.03c0 4.999 4.04 9.004 9.028 9.004s9.053-4.03 9.053-9.005v-.796z\"/>\n</svg>\n";
function $d84bc94694df07a6$export$602140a6a10b02bf(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Jira Product Discovery' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $dlBdv.LogoWrapper), {
        svg: $d84bc94694df07a6$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("jty2s", function(module, exports) {
$parcel$export(module.exports, "JiraServiceManagementIcon", () => $e2db2120f58c7778$export$3c6158790f5e01c4);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::cedb5d68059644a06a093aa74d8e3cc5>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

var $dkXTa = parcelRequire("dkXTa");
// `height` is set to 100% to allow the SVG to scale with the parent element
var $e2db2120f58c7778$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#ffc716)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M13.744 10.156h4.578c.688 0 .922.654.503 1.174l-7.16 8.837c-2.314-1.845-2.096-4.763-.402-6.892zm-3.538 3.521H5.63c-.688 0-.923-.654-.504-1.173l7.16-8.837c2.315 1.844 2.063 4.728.386 6.875z\"/>\n</svg>\n";
var $e2db2120f58c7778$var$customThemeSvg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--themed-icon-color, currentcolor)\" d=\"M18 0a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6V6a6 6 0 0 1 6-6zm-4.256 10.156-2.481 3.12c-1.694 2.129-1.912 5.047.402 6.891l7.16-8.837c.42-.52.185-1.174-.503-1.174zm-8.619 2.348c-.419.52-.183 1.174.504 1.174h4.577l2.465-3.136c1.677-2.146 1.928-5.03-.386-6.875z\"/>\n</svg>\n";
function $e2db2120f58c7778$export$3c6158790f5e01c4(_ref) {
    var iconColor = _ref.iconColor, size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Jira Service Management' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $dkXTa.IconWrapper), {
        svg: $e2db2120f58c7778$var$svg,
        customThemeSvg: $e2db2120f58c7778$var$customThemeSvg,
        iconColor: iconColor,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("1p7KT", function(module, exports) {
$parcel$export(module.exports, "JiraServiceManagementLogoCS", () => $105e244f4782482d$export$de148263c75d2bc1);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::bcf1b6bc0c0712320d6fbdb868500ebb>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

var $dlBdv = parcelRequire("dlBdv");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $105e244f4782482d$var$svg = "<svg height=\"100%\" viewBox=\"0 0 372 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M367.07 20.58c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55a6.3 6.3 0 0 1-1.78.25c-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zm-7.32-4.23v8.99h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 3.53 0 5.55 2.42 5.55 6.66m-22.92-4.27c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-26.16-7.92v8.53h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 2.61 0 4.39 1.32 5.15 3.74.86-2.36 2.91-3.74 5.46-3.74 3.43 0 5.34 2.33 5.34 6.66v8.99h-2.64v-8.52c0-3.16-1.1-4.72-3.62-4.72-2.45 0-4.14 1.63-4.14 4.72m-22.92-4.74c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2H289.2c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-18.64-.62v-1.53c-.98 2.02-2.82 3.07-5.18 3.07-4.05 0-6.07-3.46-6.07-7.97 0-4.32 2.12-7.97 6.38-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.58v13.95c0 4.51-2.12 7.54-7.6 7.54-2.58 0-3.99-.34-5.46-.83v-2.58c1.69.55 3.44.92 5.34.92 3.83 0 5.15-2.05 5.15-4.91m-8.68-6.44c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m-16.97.03c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-14.07-8.98v8.99h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 3.53 0 5.55 2.42 5.55 6.66m-28.33 1.31c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-31.44-11.01-2.76-7.48v18.49h-2.76V5.19h4.78l4.57 11.56 1.87 5.55 1.87-5.55 4.6-11.56h4.45v20.15h-2.76V7.06l-2.36 7.27-4.45 11.01h-2.67zm-21.52-2.23c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.05 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-15.09-2.16v2.36c-.92.49-2.33.71-3.74.71-5.46 0-8-3.31-8-8 0-4.63 2.55-7.94 8-7.94 1.38 0 2.45.18 3.65.74v2.45c-.98-.46-2.02-.74-3.46-.74-3.99 0-5.61 2.51-5.61 5.49s1.66 5.49 5.67 5.49c1.56 0 2.55-.21 3.5-.55M150.12 5.95c0-1.17.77-1.84 1.84-1.84s1.84.67 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-8.23 0h-3.53L132.91 10h2.76l4.97 13.1 4.93-13.1h2.76zm-15.45-9.04v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.67-5.43 3.93m-12.47-4.21c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-15.33-4.95c0 3.5-2.08 5.86-7.08 5.86-3.89 0-5.7-.77-7.27-1.56v-2.82c1.87.98 4.75 1.69 7.42 1.69 3.04 0 4.17-1.2 4.17-2.97 0-1.78-1.1-2.73-4.94-3.65-4.54-1.1-6.56-2.67-6.56-5.98 0-3.13 2.39-5.46 7.08-5.46 2.91 0 4.78.71 6.16 1.47v2.76c-2.02-1.16-4.2-1.53-6.29-1.53-2.64 0-4.2.92-4.2 2.76 0 1.66 1.29 2.48 4.84 3.37 4.26 1.07 6.66 2.45 6.66 6.07m-33.99-2.12c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.98 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-17.79-9.04v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.67-5.43 3.93M52.22 5.95c0-1.17.77-1.84 1.84-1.84s1.84.67 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-6.42-5.95V5.19h2.76V19.2c0 3.71-1.63 6.26-5.43 6.26-1.44 0-2.55-.25-3.31-.52v-2.67c.83.34 1.84.52 2.85.52 2.33 0 3.13-1.41 3.13-3.4\"/>\n    <path fill=\"var(--tile-color,#ffc716)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M18.268 13.604h5.951c.894 0 1.199.85.654 1.526l-9.308 11.487c-3.008-2.397-2.725-6.19-.523-8.959zm-4.6 4.577h-5.95c-.894 0-1.2-.85-.655-1.526l9.308-11.488c3.009 2.398 2.682 6.148.502 8.938z\"/>\n</svg>\n";
function $105e244f4782482d$export$de148263c75d2bc1(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Jira Service Management' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $dlBdv.LogoWrapper), {
        svg: $105e244f4782482d$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("awgu0", function(module, exports) {
$parcel$export(module.exports, "JiraServiceManagementDataCenterIcon", () => $7a89adb1474ccf1d$export$65fae0eaf343f2ca);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::5b3684e2355c28ec62827d09d362b6cf>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

var $dkXTa = parcelRequire("dkXTa");
// `height` is set to 100% to allow the SVG to scale with the parent element
var $7a89adb1474ccf1d$var$svg = "<svg height=\"100%\" viewBox=\"0 0 25 24\">\n    <path fill=\"var(--tile-color, white)\" d=\"M6.417.5h12a5.5 5.5 0 0 1 5.5 5.5v12a5.5 5.5 0 0 1-5.5 5.5h-12a5.5 5.5 0 0 1-5.5-5.5V6a5.5 5.5 0 0 1 5.5-5.5\"/>\n    <path fill=\"none\" stroke=\"var(--border-color, #dddee1)\" d=\"M6.417.5h12a5.5 5.5 0 0 1 5.5 5.5v12a5.5 5.5 0 0 1-5.5 5.5h-12a5.5 5.5 0 0 1-5.5-5.5V6a5.5 5.5 0 0 1 5.5-5.5Z\"/>\n    <path fill=\"var(--icon-color, #1868db)\" d=\"M14.117 10.203h4.464c.67 0 .899.637.49 1.144l-6.98 8.616c-2.257-1.798-2.044-4.643-.393-6.72zm-3.45 3.433H6.205c-.67 0-.899-.638-.49-1.144l6.981-8.617c2.256 1.799 2.011 4.61.376 6.704z\"/>\n</svg>\n";
function $7a89adb1474ccf1d$export$65fae0eaf343f2ca(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Jira Service Management Data Center' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $dkXTa.IconWrapper), {
        svg: $7a89adb1474ccf1d$var$svg,
        label: label,
        type: "data-center",
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("5kGHj", function(module, exports) {
$parcel$export(module.exports, "JiraServiceManagementDataCenterLogoCS", () => $3e1ff0d7c502f7bb$export$f64bc7a7f04428d0);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d19396c378541211d8225aae490bcbcf>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

var $dlBdv = parcelRequire("dlBdv");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $3e1ff0d7c502f7bb$var$svg = "<svg height=\"100%\" viewBox=\"0 0 372 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M367.07 20.58c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55c-.46.12-.98.25-1.78.25-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zm-7.32-4.23v8.99h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 3.53 0 5.55 2.42 5.55 6.66m-22.92-4.27c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-26.16-7.92v8.53h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 2.61 0 4.39 1.32 5.15 3.74.86-2.36 2.91-3.74 5.46-3.74 3.43 0 5.34 2.33 5.34 6.66v8.99h-2.64v-8.52c0-3.16-1.1-4.72-3.62-4.72-2.45 0-4.14 1.63-4.14 4.72m-22.92-4.74c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2H289.2c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-18.64-.62v-1.53c-.98 2.02-2.82 3.07-5.18 3.07-4.05 0-6.07-3.46-6.07-7.97 0-4.32 2.12-7.97 6.38-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.58v13.95c0 4.51-2.12 7.54-7.6 7.54-2.58 0-3.99-.34-5.46-.83v-2.58c1.69.55 3.44.92 5.34.92 3.83 0 5.15-2.05 5.15-4.91m-8.68-6.44c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m-16.97.03c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-14.07-8.98v8.99h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 3.53 0 5.55 2.42 5.55 6.66m-28.33 1.31c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-31.44-11.01-2.76-7.48v18.49h-2.76V5.19h4.78l4.57 11.56 1.87 5.55 1.87-5.55 4.6-11.56h4.45v20.15h-2.76V7.06l-2.36 7.27-4.45 11.01h-2.67zm-21.52-2.23c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.05 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-15.09-2.16v2.36c-.92.49-2.33.71-3.74.71-5.46 0-8-3.31-8-8 0-4.63 2.55-7.94 8-7.94 1.38 0 2.45.18 3.65.74v2.45c-.98-.46-2.02-.74-3.46-.74-3.99 0-5.61 2.51-5.61 5.49s1.66 5.49 5.67 5.49c1.56 0 2.55-.21 3.5-.55M150.12 5.95c0-1.16.77-1.84 1.84-1.84s1.84.68 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-8.23 0h-3.53L132.91 10h2.76l4.97 13.1 4.93-13.1h2.76zm-15.45-9.04v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.68-5.43 3.93m-12.47-4.21c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-15.33-4.95c0 3.5-2.08 5.86-7.08 5.86-3.89 0-5.7-.77-7.27-1.56v-2.82c1.87.98 4.75 1.69 7.42 1.69 3.04 0 4.17-1.2 4.17-2.97s-1.1-2.73-4.94-3.65c-4.54-1.1-6.56-2.67-6.56-5.98 0-3.13 2.39-5.46 7.08-5.46 2.91 0 4.78.71 6.16 1.47v2.76c-2.02-1.17-4.2-1.53-6.29-1.53-2.64 0-4.2.92-4.2 2.76 0 1.66 1.29 2.48 4.84 3.37 4.26 1.07 6.66 2.45 6.66 6.07m-33.99-2.12c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-17.79-9.04v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.68-5.43 3.93M52.22 5.95c0-1.16.77-1.84 1.84-1.84s1.84.68 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-6.42-5.95V5.19h2.76V19.2c0 3.71-1.63 6.26-5.43 6.26-1.44 0-2.55-.24-3.31-.52v-2.67c.83.34 1.84.52 2.85.52 2.33 0 3.13-1.41 3.13-3.4\"/>\n    <path fill=\"var(--tile-color, white)\" d=\"M8 .667h16A7.333 7.333 0 0 1 31.333 8v16A7.333 7.333 0 0 1 24 31.333H8A7.333 7.333 0 0 1 .667 24V8A7.333 7.333 0 0 1 8 .667\"/>\n    <path fill=\"none\" stroke=\"var(--border-color, #dddee1)\" stroke-width=\"1.333\" d=\"M8 .667h16A7.333 7.333 0 0 1 31.333 8v16A7.333 7.333 0 0 1 24 31.333H8A7.333 7.333 0 0 1 .667 24V8A7.333 7.333 0 0 1 8 .667Z\"/>\n    <path fill=\"var(--icon-color, #1868db)\" d=\"M18.268 13.604h5.95c.895 0 1.2.85.655 1.526l-9.308 11.487c-3.008-2.397-2.725-6.19-.524-8.959zm-4.6 4.577h-5.95c-.895 0-1.2-.85-.655-1.526l9.308-11.488c3.009 2.398 2.682 6.148.502 8.938z\"/>\n</svg>\n";
function $3e1ff0d7c502f7bb$export$f64bc7a7f04428d0(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Jira Service Management Data Center' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $dlBdv.LogoWrapper), {
        svg: $3e1ff0d7c502f7bb$var$svg,
        label: label,
        type: "data-center",
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("9Pjay", function(module, exports) {
$parcel$export(module.exports, "LoomIcon", () => $7277bf1ab856c9fb$export$8d789f76fde3e05);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::568f663154fd35333110385dd0c22e41>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

var $dkXTa = parcelRequire("dkXTa");
// `height` is set to 100% to allow the SVG to scale with the parent element
var $7277bf1ab856c9fb$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#1868db)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, white)\" d=\"M19.083 11.212h-4.142l3.588-2.071-.788-1.365-3.588 2.071 2.07-3.587-1.364-.788-2.071 3.587V4.917h-1.576v4.142L9.141 5.472l-1.365.787 2.071 3.588L6.26 7.776 5.472 9.14l3.587 2.07H4.917v1.577h4.142l-3.587 2.071.788 1.365 3.587-2.07-2.071 3.587 1.365.787 2.07-3.587v4.142h1.577V14.94l2.07 3.587 1.365-.787-2.07-3.588 3.587 2.071.788-1.365-3.587-2.07h4.142zM12 14.143a2.151 2.151 0 1 1 0-4.302 2.151 2.151 0 0 1 0 4.302\"/>\n</svg>\n";
function $7277bf1ab856c9fb$export$8d789f76fde3e05(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Loom' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $dkXTa.IconWrapper), {
        svg: $7277bf1ab856c9fb$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("eA2xZ", function(module, exports) {
$parcel$export(module.exports, "LoomLogoCS", () => $a9d66750d87e778d$export$78c0b4d8be34c9b2);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2d69248f39a87c063a78e83a58b63bd7>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

var $dlBdv = parcelRequire("dlBdv");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $a9d66750d87e778d$var$svg = "<svg height=\"100%\" viewBox=\"0 0 103 32\">\n    <path fill=\"var(--tile-color,#1868db)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, white)\" d=\"M25.375 15.31H19.99l4.664-2.693-1.024-1.775-4.664 2.693 2.692-4.663-1.775-1.025-2.692 4.663V7.125h-2.048v5.386l-2.694-4.664-1.774 1.024 2.693 4.664-4.664-2.693-1.024 1.774 4.664 2.693H6.959v2.049h5.384L7.68 20.05l1.024 1.774 4.663-2.692-2.692 4.664 1.774 1.024 2.693-4.664v5.385h2.049v-5.385l2.692 4.664 1.774-1.024-2.692-4.665 4.663 2.693 1.025-1.774-4.664-2.693h5.385zm-9.208 3.81a2.797 2.797 0 1 1 0-5.593 2.797 2.797 0 0 1 0 5.593\"/>\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M42.67 25.34V3.93h3.93v21.41zm37.7-14.55h3.75v1.78c.8-1.42 2.66-2.19 4.26-2.19 1.98 0 3.58.86 4.32 2.43 1.15-1.77 2.69-2.42 4.61-2.42 2.69 0 5.26 1.63 5.26 5.53v9.43h-3.81v-8.63c0-1.57-.77-2.75-2.57-2.75-1.68 0-2.69 1.3-2.69 2.87v8.52h-3.9v-8.63c0-1.57-.8-2.75-2.57-2.75-1.71 0-2.72 1.27-2.72 2.87v8.52h-3.93zM55.48 25.77c-4.43 0-7.63-3.28-7.63-7.7 0-4.34 3.2-7.7 7.64-7.7 4.46 0 7.63 3.39 7.63 7.7 0 4.38-3.21 7.7-7.63 7.7m0-11.84a4.15 4.15 0 0 0-4.14 4.14 4.15 4.15 0 0 0 4.14 4.14 4.15 4.15 0 0 0 4.14-4.14 4.15 4.15 0 0 0-4.14-4.14m16.02 11.84c-4.43 0-7.63-3.28-7.63-7.7 0-4.34 3.2-7.7 7.63-7.7 4.46 0 7.64 3.39 7.64 7.7 0 4.38-3.21 7.7-7.63 7.7m0-11.89c-2.31 0-4.19 1.88-4.19 4.19s1.88 4.19 4.19 4.19 4.19-1.88 4.19-4.19-1.88-4.19-4.19-4.19\"/>\n</svg>\n";
function $a9d66750d87e778d$export$78c0b4d8be34c9b2(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Loom' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $dlBdv.LogoWrapper), {
        svg: $a9d66750d87e778d$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("iRpxr", function(module, exports) {
$parcel$export(module.exports, "LoomAttributionLogoCS", () => $dbb0fc9f5c20d708$export$68d7391318cdef11);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::9f5d94b0d7bf822b6ab4c2ad26c21970>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

var $dlBdv = parcelRequire("dlBdv");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $dbb0fc9f5c20d708$var$svg = "<svg height=\"100%\" viewBox=\"0 0 100 32\">\n    <path fill=\"var(--icon-color, #101214)\" d=\"M66.71 5.11c0 1.08.49 1.93 2.47 2.31 1.16.26 1.41.44 1.41.82 0 .39-.26.62-1.08.62-.95 0-2.08-.33-2.83-.77v1.75c.59.28 1.36.62 2.83.62 2.06 0 2.85-.92 2.85-2.26m0 .03c0-1.28-.67-1.88-2.59-2.29-1.05-.23-1.31-.46-1.31-.8 0-.41.39-.59 1.08-.59.85 0 1.67.26 2.47.62V3.5c-.56-.28-1.41-.49-2.41-.49-1.9 0-2.88.82-2.88 2.16m26.29-2.11v7.32h1.57V4.81l.64 1.46 2.21 4.11h1.95V3.06h-1.54v4.73l-.59-1.39-1.77-3.34zm-9.91 0h-1.7v7.32h1.7zM79.45 8.2c0-1.28-.67-1.88-2.59-2.29-1.05-.23-1.31-.46-1.31-.8 0-.41.39-.59 1.08-.59.85 0 1.67.26 2.47.62V3.47c-.56-.28-1.41-.49-2.41-.49-1.9 0-2.88.82-2.88 2.16 0 1.08.49 1.93 2.47 2.31 1.16.26 1.41.44 1.41.82s-.26.62-1.08.62c-.95 0-2.08-.33-2.83-.77v1.75c.59.28 1.36.62 2.83.62 2.03 0 2.85-.92 2.85-2.29M53.5 3.06v7.32h3.49l.54-1.59h-2.34V3.06zm-6.91 0v1.57h1.88v5.75h1.72V4.63h2.03V3.06zm-2.49 0h-2.24l-2.54 7.32h1.95l.36-1.23c.44.13.9.21 1.36.21s.93-.08 1.36-.21l.36 1.23h1.95c-.03 0-2.57-7.32-2.57-7.32m-1.13 4.75c-.33 0-.64-.05-.93-.13l.93-3.19.93 3.19c-.28.08-.59.13-.92.13m20.06-4.75H60.8l-2.57 7.32h1.95l.36-1.23c.44.13.9.21 1.36.21s.93-.08 1.36-.21l.36 1.23h1.95zM61.9 7.81c-.33 0-.64-.05-.92-.13l.93-3.19.93 3.19c-.28.08-.59.13-.92.13m27.32-4.75h-2.23l-2.54 7.32h1.95l.36-1.23c.44.13.9.21 1.36.21s.93-.08 1.36-.21l.36 1.23h1.95zm-1.11 4.75c-.33 0-.64-.05-.92-.13l.93-3.19.93 3.19a3.7 3.7 0 0 1-.92.13\"/>\n    <path fill=\"var(--tile-color,#1868db)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, white)\" d=\"M25.375 15.31H19.99l4.664-2.693-1.024-1.775-4.664 2.693 2.692-4.664-1.775-1.025-2.692 4.664V7.125h-2.048v5.385l-2.694-4.664-1.774 1.025 2.693 4.663-4.664-2.692-1.024 1.774 4.664 2.693H6.958v2.048h5.385L7.68 20.05l1.024 1.775 4.663-2.693-2.692 4.664 1.774 1.024 2.693-4.664v5.386h2.049v-5.385l2.692 4.663 1.774-1.024-2.692-4.664 4.663 2.693 1.025-1.775-4.664-2.692h5.385zm-9.208 3.81a2.797 2.797 0 1 1 0-5.594 2.797 2.797 0 0 1 0 5.593\"/>\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M39.32 27.74v-13.7h2.52v13.7zm24.13-9.31h2.4v1.14c.51-.91 1.7-1.4 2.72-1.4 1.27 0 2.29.55 2.76 1.55.74-1.14 1.72-1.55 2.95-1.55 1.72 0 3.37 1.04 3.37 3.54v6.04h-2.44v-5.53c0-1-.49-1.76-1.65-1.76-1.08 0-1.72.83-1.72 1.84v5.45h-2.49v-5.53c0-1-.51-1.76-1.65-1.76-1.1 0-1.74.81-1.74 1.84v5.45h-2.52zm-15.93 9.58c-2.83 0-4.89-2.1-4.89-4.93 0-2.78 2.05-4.93 4.89-4.93 2.85 0 4.89 2.17 4.89 4.93 0 2.8-2.05 4.93-4.89 4.93m0-7.58a2.65 2.65 0 0 0-2.65 2.65 2.65 2.65 0 0 0 2.65 2.65c1.46 0 2.65-1.19 2.65-2.65a2.65 2.65 0 0 0-2.65-2.65m10.26 7.58c-2.83 0-4.89-2.1-4.89-4.93 0-2.78 2.05-4.93 4.89-4.93 2.85 0 4.89 2.17 4.89 4.93 0 2.8-2.06 4.93-4.89 4.93m0-7.61a2.69 2.69 0 0 0-2.68 2.68 2.69 2.69 0 0 0 2.68 2.68 2.69 2.69 0 0 0 2.68-2.68 2.69 2.69 0 0 0-2.68-2.68\"/>\n</svg>\n";
function $dbb0fc9f5c20d708$export$68d7391318cdef11(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Loom Attribution' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $dlBdv.LogoWrapper), {
        svg: $dbb0fc9f5c20d708$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("iKWpX", function(module, exports) {
$parcel$export(module.exports, "LoomInternalIcon", () => $da79d6616879e497$export$38c7b37a3e5e8d70);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::45c3b4b2f73587dee325566fc7978684>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

var $dkXTa = parcelRequire("dkXTa");
// `height` is set to 100% to allow the SVG to scale with the parent element
var $da79d6616879e497$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#625df5)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, white)\" d=\"M19.083 11.212h-4.142l3.588-2.071-.788-1.365-3.588 2.071 2.07-3.587-1.364-.788-2.071 3.587V4.917h-1.576v4.142L9.141 5.472l-1.365.787 2.071 3.588L6.26 7.776 5.472 9.14l3.587 2.07H4.917v1.577h4.142l-3.587 2.071.788 1.365 3.587-2.07-2.071 3.587 1.365.787 2.07-3.587v4.142h1.577V14.94l2.07 3.587 1.365-.787-2.07-3.588 3.587 2.071.788-1.365-3.587-2.07h4.142zM12 14.143a2.151 2.151 0 1 1 0-4.302 2.151 2.151 0 0 1 0 4.302\"/>\n</svg>\n";
function $da79d6616879e497$export$38c7b37a3e5e8d70(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Loom' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $dkXTa.IconWrapper), {
        svg: $da79d6616879e497$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("lDqIQ", function(module, exports) {
$parcel$export(module.exports, "LoomInternalLogoCS", () => $fc01f80024a1e9f7$export$71743a944cb62e48);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7f4fa46a3d520008396bf538a250ebef>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

var $dlBdv = parcelRequire("dlBdv");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $fc01f80024a1e9f7$var$svg = "<svg height=\"100%\" viewBox=\"0 0 103 32\">\n    <path fill=\"var(--tile-color,#625df5)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, white)\" d=\"M25.375 15.31H19.99l4.664-2.693-1.024-1.775-4.664 2.693 2.692-4.663-1.775-1.025-2.692 4.663V7.125h-2.048v5.386l-2.694-4.664-1.774 1.024 2.693 4.664-4.664-2.693-1.024 1.774 4.664 2.693H6.959v2.049h5.384L7.68 20.05l1.024 1.774 4.663-2.692-2.692 4.664 1.774 1.024 2.693-4.664v5.385h2.049v-5.385l2.692 4.664 1.774-1.024-2.692-4.665 4.663 2.693 1.025-1.774-4.664-2.693h5.385zm-9.208 3.81a2.797 2.797 0 1 1 0-5.593 2.797 2.797 0 0 1 0 5.593\"/>\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M42.67 25.34V3.93h3.93v21.41zm37.7-14.55h3.75v1.78c.8-1.42 2.66-2.19 4.26-2.19 1.98 0 3.58.86 4.32 2.43 1.15-1.77 2.69-2.42 4.61-2.42 2.69 0 5.26 1.63 5.26 5.53v9.43h-3.81v-8.63c0-1.57-.77-2.75-2.57-2.75-1.68 0-2.69 1.3-2.69 2.87v8.52h-3.9v-8.63c0-1.57-.8-2.75-2.57-2.75-1.71 0-2.72 1.27-2.72 2.87v8.52h-3.93zM55.48 25.77c-4.43 0-7.63-3.28-7.63-7.7 0-4.34 3.2-7.7 7.64-7.7 4.46 0 7.63 3.39 7.63 7.7 0 4.38-3.21 7.7-7.63 7.7m0-11.84a4.15 4.15 0 0 0-4.14 4.14 4.15 4.15 0 0 0 4.14 4.14 4.15 4.15 0 0 0 4.14-4.14 4.15 4.15 0 0 0-4.14-4.14m16.02 11.84c-4.43 0-7.63-3.28-7.63-7.7 0-4.34 3.2-7.7 7.63-7.7 4.46 0 7.64 3.39 7.64 7.7 0 4.38-3.21 7.7-7.63 7.7m0-11.89c-2.31 0-4.19 1.88-4.19 4.19s1.88 4.19 4.19 4.19 4.19-1.88 4.19-4.19-1.88-4.19-4.19-4.19\"/>\n</svg>\n";
function $fc01f80024a1e9f7$export$71743a944cb62e48(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Loom' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $dlBdv.LogoWrapper), {
        svg: $fc01f80024a1e9f7$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("9xbYh", function(module, exports) {
$parcel$export(module.exports, "OpsgenieIcon", () => $6f107b5a3cdc7c24$export$eeccc49dc7a12d9f);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2bf4732a418598faff0fcffc57f4a7b7>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

var $dkXTa = parcelRequire("dkXTa");
// `height` is set to 100% to allow the SVG to scale with the parent element
var $6f107b5a3cdc7c24$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#ffc716)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M12.696 19.45c-.49.361-.749.336-1.24-.026-2.375-1.704-4.57-3.641-6.042-5.655-.155-.207-.078-.49.155-.62l2.685-1.678q.35-.233.62.077c1.033 1.188 2.04 2.35 3.202 3.176 1.162-.826 2.17-1.988 3.202-3.176q.272-.31.62-.078l2.686 1.679c.232.13.31.413.155.62-1.472 2.014-3.667 3.95-6.043 5.68m-.62-7.411c2.118 0 3.874-1.73 3.874-3.848s-1.756-3.9-3.874-3.9c-2.117 0-3.873 1.757-3.873 3.9s1.704 3.848 3.873 3.848\"/>\n</svg>\n";
function $6f107b5a3cdc7c24$export$eeccc49dc7a12d9f(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Opsgenie' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $dkXTa.IconWrapper), {
        svg: $6f107b5a3cdc7c24$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("2NdJB", function(module, exports) {
$parcel$export(module.exports, "OpsgenieLogoCS", () => $208acfc57f03835f$export$a5b9122e89b32ad3);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::032f8fa95ed51413adb506dd076fd343>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

var $dlBdv = parcelRequire("dlBdv");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $208acfc57f03835f$var$svg = "<svg height=\"100%\" viewBox=\"0 0 164 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M156.69 12.09c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.67-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zM143.39 5.95c0-1.16.77-1.84 1.84-1.84s1.84.68 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-3.68-8.98v8.99h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.51c.98-1.81 2.79-2.82 4.85-2.82 3.53 0 5.55 2.42 5.55 6.66m-22.92-4.26c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.67-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-18.64-.62v-1.53c-.98 2.02-2.82 3.07-5.18 3.07-4.05 0-6.07-3.47-6.07-7.97 0-4.32 2.12-7.97 6.38-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.58v13.95c0 4.51-2.12 7.54-7.6 7.54-2.58 0-3.99-.34-5.46-.83v-2.58c1.69.55 3.44.92 5.34.92 3.83 0 5.15-2.06 5.15-4.91m-8.68-6.44c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m-4.72 3.52c0 2.55-1.66 4.48-5.76 4.48-2.3 0-4.17-.52-5.34-1.13v-2.79c1.32.77 3.53 1.5 5.46 1.5 2.02 0 3.07-.83 3.07-2.02 0-1.17-.89-1.84-3.8-2.55-3.4-.83-4.85-2.15-4.85-4.66 0-2.67 2.06-4.29 5.55-4.29 1.99 0 3.8.49 4.94 1.1v2.73c-1.84-.92-3.34-1.41-4.97-1.41-1.93 0-2.97.67-2.97 1.87 0 1.07.74 1.75 3.56 2.42 3.4.83 5.12 2.09 5.12 4.75m-16.29-3.49c0-3.68-1.47-5.52-4.2-5.52-2.36 0-4.48 1.5-4.48 4.91v1.23c0 3.4 1.93 4.91 4.17 4.91 2.98 0 4.51-1.96 4.51-5.52m-3.8 7.97c-2.24 0-3.96-1.01-4.88-3.01v8.68h-2.64V10h2.64v2.76c.98-2.02 2.82-3.07 5.18-3.07 4.08 0 6.13 3.47 6.13 7.97 0 4.32-2.15 7.97-6.44 7.97m-20.11.01c-6.22 0-9.72-4.29-9.72-10.43 0-6.07 3.5-10.33 9.72-10.33 6.2 0 9.69 4.26 9.69 10.34 0 6.13-3.5 10.43-9.69 10.43m0-18.12c-4.97 0-6.96 3.53-6.96 7.7 0 4.26 1.99 7.79 6.96 7.79 4.94 0 6.93-3.53 6.93-7.79 0-4.17-1.99-7.7-6.93-7.7\"/>\n    <path fill=\"var(--tile-color,#ffc716)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M16.905 25.684c-.638.47-.974.437-1.612-.033-3.088-2.216-5.942-4.734-7.855-7.352-.202-.269-.1-.638.201-.806l3.491-2.182q.454-.302.806.1c1.343 1.545 2.652 3.056 4.163 4.13 1.51-1.074 2.82-2.585 4.163-4.13q.352-.402.805-.1l3.491 2.182c.303.168.403.537.202.806-1.914 2.618-4.767 5.136-7.855 7.385m-.806-9.635c2.753 0 5.035-2.249 5.035-5.001s-2.282-5.07-5.035-5.07-5.036 2.283-5.036 5.07c0 2.786 2.216 5.001 5.036 5.001\"/>\n</svg>\n";
function $208acfc57f03835f$export$a5b9122e89b32ad3(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Opsgenie' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $dlBdv.LogoWrapper), {
        svg: $208acfc57f03835f$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("5EewE", function(module, exports) {
$parcel$export(module.exports, "ProjectsIcon", () => $41cbf4a689ed8f4f$export$5ed3e1bb3b04fc02);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6bab74cd77291828d528d124967c3552>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

var $dkXTa = parcelRequire("dkXTa");
// `height` is set to 100% to allow the SVG to scale with the parent element
var $41cbf4a689ed8f4f$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" fill-rule=\"evenodd\" d=\"m5.106 14.44 1.856-1.856-1.856-1.856L6.653 9.18h3.712l2.784-2.784h4.332v4.33l-2.785 2.785v3.712L13.15 18.77l-1.857-1.856-1.856 1.856-1.7-1.7 2.784-2.784-.928-.928-2.784 2.784zm10.209-4.331a1.094 1.094 0 1 1-1.547-1.546 1.094 1.094 0 0 1 1.547 1.546\" clip-rule=\"evenodd\"/>\n</svg>\n";
function $41cbf4a689ed8f4f$export$5ed3e1bb3b04fc02(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Projects' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $dkXTa.IconWrapper), {
        svg: $41cbf4a689ed8f4f$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("8aLuz", function(module, exports) {
$parcel$export(module.exports, "ProjectsLogoCS", () => $5f3418d4a157010d$export$e3d1678155aaab99);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::820b1edb3bac4a2b82da6f532724cb11>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

var $dlBdv = parcelRequire("dlBdv");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $5f3418d4a157010d$var$svg = "<svg height=\"100%\" viewBox=\"0 0 145 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M144.54 21.16c0 2.55-1.66 4.48-5.77 4.48-2.3 0-4.17-.52-5.34-1.13v-2.79c1.32.77 3.53 1.5 5.46 1.5 2.02 0 3.07-.83 3.07-2.02 0-1.17-.89-1.84-3.8-2.55-3.4-.83-4.84-2.15-4.84-4.66 0-2.67 2.05-4.29 5.55-4.29 1.99 0 3.8.49 4.94 1.1v2.73c-1.84-.92-3.34-1.41-4.97-1.41-1.93 0-2.97.67-2.97 1.87 0 1.07.74 1.75 3.56 2.42 3.4.83 5.12 2.09 5.12 4.75m-17.75-.58c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55c-.46.12-.98.25-1.78.25-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zm-6.66 1.99v2.36c-.92.49-2.33.71-3.74.71-5.46 0-8-3.31-8-8 0-4.63 2.55-7.94 8-7.94 1.38 0 2.45.18 3.65.74v2.45c-.98-.46-2.02-.74-3.47-.74-3.99 0-5.61 2.52-5.61 5.49s1.66 5.49 5.67 5.49c1.56 0 2.55-.21 3.5-.55M99.43 12.09c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.67-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.2c.37 2.61 2.05 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zM83.8 31.25v-2.36c.31.03.49.03.77.03 1.13 0 2.05-.49 2.05-1.87V10h2.64v17.36c0 2.82-1.59 4.02-4.11 4.02-.67 0-1.13-.06-1.35-.12m2.3-25.3c0-1.16.77-1.84 1.84-1.84s1.84.68 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84M76.07 25.64c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49M62.3 16.29v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.67-5.43 3.93m-5-4.4c0 4.39-2.45 6.84-7.48 6.84H45.8v6.59h-2.76V5.19h6.78c5.03 0 7.48 2.58 7.48 6.72m-7.79 4.2c3.56.12 4.94-1.56 4.94-4.14 0-2.45-1.38-4.14-4.94-4.14H45.8v8.28z\"/>\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" fill-rule=\"evenodd\" d=\"m6.152 19.486 2.651-2.652-2.651-2.651 2.21-2.21h5.303l3.977-3.977h6.187v6.187l-3.977 3.977v5.304l-2.21 2.21-2.652-2.652-2.651 2.651-2.429-2.428 3.978-3.978-1.326-1.325-3.978 3.977zM20.736 13.3a1.562 1.562 0 1 1-2.21-2.21 1.562 1.562 0 0 1 2.21 2.21\" clip-rule=\"evenodd\"/>\n</svg>\n";
function $5f3418d4a157010d$export$e3d1678155aaab99(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Projects' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $dlBdv.LogoWrapper), {
        svg: $5f3418d4a157010d$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("gyPXc", function(module, exports) {
$parcel$export(module.exports, "RovoIcon", () => $c0e81f450057cf06$export$e23ae35269442b4f);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c09aee6cc96e54887271dd42a7eae172>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

var $dkXTa = parcelRequire("dkXTa");
// `height` is set to 100% to allow the SVG to scale with the parent element
var $c0e81f450057cf06$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#1868db)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, white)\" d=\"M11.057 5.257a1.57 1.57 0 0 1 1.539.015l4.621 2.668c.484.279.783.797.783 1.354v5.336a1.56 1.56 0 0 1-.782 1.355l-3.474 2.005a2 2 0 0 0 .12-.691v-5.337c0-.733-.39-1.409-1.026-1.774l-2.59-1.495V6.626q.001-.246.074-.473c.117-.364.366-.68.707-.877z\"/>\n    <path fill=\"var(--icon-color, white)\" d=\"M9.881 5.94 6.408 7.945A1.56 1.56 0 0 0 5.625 9.3v5.337c0 .557.3 1.075.783 1.354l4.621 2.668c.475.274 1.06.279 1.539.015l.027-.019a1.57 1.57 0 0 0 .781-1.35v-2.067l-2.589-1.495a2.05 2.05 0 0 1-1.026-1.775V6.631a2 2 0 0 1 .12-.691\"/>\n</svg>\n";
function $c0e81f450057cf06$export$e23ae35269442b4f(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Rovo' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $dkXTa.IconWrapper), {
        svg: $c0e81f450057cf06$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("gfYST", function(module, exports) {
$parcel$export(module.exports, "RovoLogoCS", () => $bd5d466aedec2939$export$b0e15f0a1c9f4c55);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::29265478015ee48ec34dc1fd6eae4b81>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

var $dlBdv = parcelRequire("dlBdv");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $bd5d466aedec2939$var$svg = "<svg height=\"100%\" viewBox=\"0 0 106 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M98.36 25.64c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49M84.34 25.33h-3.53L74.87 10h2.76l4.97 13.1L87.53 10h2.76zm-17.46.31c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49M49.84 7.82h-4.05v7.36h4.05c3.59 0 4.69-1.38 4.69-3.68 0-2.18-1.13-3.68-4.69-3.68m7.45 3.62c0 3.04-1.29 5.09-3.96 5.95l4.94 7.94h-3.25l-4.44-7.51H45.8v7.51h-2.76V5.19h7.12c4.81 0 7.15 2.39 7.15 6.26\"/>\n    <path fill=\"var(--tile-color,#1868db)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, white)\" d=\"M15.013 6.281a2.26 2.26 0 0 1 2.222.021l6.674 3.854a2.26 2.26 0 0 1 1.131 1.956v7.707c0 .809-.43 1.553-1.13 1.956l-5.018 2.896q.017-.046.032-.093c.093-.289.142-.594.142-.906v-7.707a2.95 2.95 0 0 0-1.481-2.563l-3.74-2.158V8.258c0-.235.036-.465.105-.682.17-.527.529-.983 1.021-1.267h.002z\"/>\n    <path fill=\"var(--icon-color, white)\" d=\"m13.314 7.267-5.017 2.896a2.25 2.25 0 0 0-1.13 1.956v7.707c0 .806.432 1.553 1.13 1.956l6.675 3.854c.686.396 1.53.403 2.222.02l.04-.026c.493-.284.853-.74 1.023-1.267a2.3 2.3 0 0 0 .105-.683v-2.986l-3.74-2.158a2.96 2.96 0 0 1-1.482-2.563V8.266a3 3 0 0 1 .174-1\"/>\n</svg>\n";
function $bd5d466aedec2939$export$b0e15f0a1c9f4c55(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Rovo' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $dlBdv.LogoWrapper), {
        svg: $bd5d466aedec2939$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("2bpv8", function(module, exports) {
$parcel$export(module.exports, "RovoDevIcon", () => $197063d63daf10dc$export$8b784b3227531b3e);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::0424c604e8fb1e51fac762a4e1efa562>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

var $dkXTa = parcelRequire("dkXTa");
// `height` is set to 100% to allow the SVG to scale with the parent element
var $197063d63daf10dc$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#94c748)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M11.26 4.71a1.7 1.7 0 0 1 1.666.017l5.006 2.89c.524.302.848.863.848 1.467v5.78a1.69 1.69 0 0 1-.848 1.467l-3.763 2.172.024-.07c.07-.216.107-.445.107-.679v-5.78c0-.794-.423-1.526-1.112-1.922l-2.805-1.62V6.195q.001-.267.08-.512c.126-.395.396-.737.765-.95l.002-.001z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M9.986 5.45 6.223 7.623a1.69 1.69 0 0 0-.848 1.466v5.78c0 .605.324 1.166.848 1.468l5.006 2.89a1.7 1.7 0 0 0 1.666.016l.03-.02c.37-.214.64-.556.768-.95q.078-.247.079-.513v-2.24l-2.805-1.618a2.22 2.22 0 0 1-1.112-1.922V6.2a2.2 2.2 0 0 1 .13-.75\"/>\n</svg>\n";
function $197063d63daf10dc$export$8b784b3227531b3e(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Rovo Dev' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $dkXTa.IconWrapper), {
        svg: $197063d63daf10dc$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("72U8T", function(module, exports) {
$parcel$export(module.exports, "RovoDevLogoCS", () => $52144500e207f1b9$export$4145bd793c9ed1d0);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e0f280d200b0e27835aec655dfa5a41e>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

var $dlBdv = parcelRequire("dlBdv");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $52144500e207f1b9$var$svg = "<svg height=\"100%\" viewBox=\"0 0 165 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M158.79 25.33h-3.53L149.32 10h2.76l4.97 13.1 4.93-13.1h2.76zm-17.64-13.24c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.05 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zM121.91 7.82h-4.54v14.87h4.69c4.6 0 6.9-2.42 6.9-7.3 0-4.91-2.18-7.57-7.05-7.57m-7.3 17.51V5.19h7.42c6.53 0 9.69 4.08 9.69 10.12 0 6.1-3.19 10.03-9.69 10.03zm-16.26.31c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49M84.34 25.33h-3.53L74.86 10h2.76l4.97 13.1L87.53 10h2.76zm-17.46.31c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49M49.84 7.82h-4.05v7.36h4.05c3.59 0 4.69-1.38 4.69-3.68 0-2.18-1.13-3.68-4.69-3.68m7.45 3.62c0 3.04-1.29 5.09-3.96 5.95l4.94 7.94h-3.25l-4.44-7.51H45.8v7.51h-2.76V5.19h7.12c4.81 0 7.15 2.39 7.15 6.26\"/>\n    <path fill=\"var(--tile-color,#94c748)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M15.013 6.281a2.26 2.26 0 0 1 2.222.021l6.674 3.854a2.26 2.26 0 0 1 1.131 1.956v7.707c0 .809-.43 1.553-1.13 1.956l-5.018 2.896.032-.093c.093-.289.142-.594.142-.906v-7.707a2.95 2.95 0 0 0-1.481-2.563l-3.74-2.158V8.258c0-.235.036-.465.105-.682a2.26 2.26 0 0 1 1.021-1.267h.002z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"m13.314 7.267-5.017 2.896a2.25 2.25 0 0 0-1.13 1.956v7.707c0 .806.432 1.553 1.13 1.956l6.675 3.854c.686.396 1.53.403 2.222.02l.04-.026c.493-.284.853-.74 1.023-1.267a2.3 2.3 0 0 0 .105-.683v-2.986l-3.74-2.158a2.96 2.96 0 0 1-1.482-2.563V8.266a3 3 0 0 1 .174-1\"/>\n</svg>\n";
function $52144500e207f1b9$export$4145bd793c9ed1d0(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Rovo Dev' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $dlBdv.LogoWrapper), {
        svg: $52144500e207f1b9$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("6Nhmh", function(module, exports) {
$parcel$export(module.exports, "RovoDevAgentIcon", () => $4f24c8abb3bfcd10$export$813cff80931d9dbf);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c56e9a05bb3a4c70bfd4cbcb5fa54ba2>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

var $dkXTa = parcelRequire("dkXTa");
// `height` is set to 100% to allow the SVG to scale with the parent element
var $4f24c8abb3bfcd10$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#94c748)\" d=\"M10.7.368a2.75 2.75 0 0 1 2.748 0l8.016 4.626a2.75 2.75 0 0 1 1.375 2.38v9.252c0 .982-.524 1.889-1.375 2.38l-8.016 4.626a2.75 2.75 0 0 1-2.749 0l-8.016-4.626a2.75 2.75 0 0 1-1.374-2.38V7.374c0-.982.524-1.889 1.374-2.38z\"/>\n    <path fill=\"var(--icon-color, #101214)\" fill-rule=\"evenodd\" d=\"M10.181 6.096 6.777 8.06a1.53 1.53 0 0 0-.768 1.327v5.229c0 .547.294 1.054.768 1.327l.807.466 3.722 2.149a1.54 1.54 0 0 0 1.508.014l.027-.018a1.54 1.54 0 0 0 .766-1.323v-2.026l-1.97-1.137-.568-.327a2 2 0 0 1-1.006-1.74V6.775a2 2 0 0 1 .118-.678\" clip-rule=\"evenodd\"/>\n    <path fill=\"var(--icon-color, #101214)\" fill-rule=\"evenodd\" d=\"M12.842 5.441a1.54 1.54 0 0 0-1.508-.014l-.028.019a1.54 1.54 0 0 0-.765 1.323v2.025l1.91 1.102.628.362a2 2 0 0 1 1.006 1.74v5.228a2 2 0 0 1-.118.678l3.404-1.965c.476-.273.767-.778.767-1.327V9.383c0-.546-.293-1.054-.767-1.327l-.868-.501z\" clip-rule=\"evenodd\"/>\n</svg>\n";
function $4f24c8abb3bfcd10$export$813cff80931d9dbf(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Rovo Dev Agent' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $dkXTa.IconWrapper), {
        svg: $4f24c8abb3bfcd10$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("lgl6y", function(module, exports) {
$parcel$export(module.exports, "RovoDevAgentLogoCS", () => $f7ab768ff134333e$export$58747af448450872);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ca2d332c134816706ee434029a355d3c>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

var $dlBdv = parcelRequire("dlBdv");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $f7ab768ff134333e$var$svg = "<svg height=\"100%\" viewBox=\"0 0 160 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M153.94 25.67h-3.53l-5.95-15.33h2.76l4.97 13.1 4.94-13.09h2.76zM136.3 12.42c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.67-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.2c.37 2.61 2.05 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-25.13-16.9h-4.54v14.87h4.69c4.6 0 6.9-2.42 6.9-7.3 0-4.91-2.18-7.57-7.05-7.57m-7.3 17.51V5.52h7.42c6.53 0 9.69 4.08 9.69 10.12 0 6.1-3.19 10.03-9.69 10.03zm-16.25.31c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49M79.49 25.67h-3.53l-5.95-15.33h2.76l4.97 13.1 4.94-13.09h2.76zm-17.46.31c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49M45 8.16h-4.05v7.36H45c3.59 0 4.69-1.38 4.69-3.68 0-2.18-1.13-3.68-4.69-3.68m7.45 3.62c0 3.04-1.29 5.09-3.96 5.95l4.94 7.94h-3.25l-4.45-7.51h-4.78v7.51h-2.76V5.52h7.11c4.82 0 7.15 2.39 7.15 6.26\"/>\n    <path fill=\"var(--tile-color,#94c748)\" d=\"M12.52.49a3.67 3.67 0 0 1 3.666 0l10.688 6.17a3.66 3.66 0 0 1 1.833 3.173v12.336a3.66 3.66 0 0 1-1.833 3.173L16.186 31.51a3.67 3.67 0 0 1-3.665 0L1.833 25.341A3.66 3.66 0 0 1 0 22.168V9.832c0-1.309.7-2.519 1.833-3.173z\"/>\n    <path fill=\"var(--icon-color, #101214)\" fill-rule=\"evenodd\" d=\"m11.83 8.128-4.54 2.62a2.04 2.04 0 0 0-1.022 1.77v6.972c0 .728.39 1.405 1.023 1.77l1.076.62 4.963 2.865a2.05 2.05 0 0 0 2.01.02l.037-.025c.445-.257.771-.67.925-1.146q.094-.297.095-.619v-2.7l-2.627-1.516-.757-.436a2.67 2.67 0 0 1-1.34-2.32v-6.97a2.7 2.7 0 0 1 .157-.904\" clip-rule=\"evenodd\"/>\n    <path fill=\"var(--icon-color, #101214)\" fill-rule=\"evenodd\" d=\"M15.377 7.255a2.05 2.05 0 0 0-2.01-.019l-.038.026c-.445.257-.77.67-.924 1.145a2 2 0 0 0-.095.618v2.7l2.545 1.47.839.483a2.67 2.67 0 0 1 1.34 2.319v6.972a2.7 2.7 0 0 1-.157.903l4.54-2.62a2.04 2.04 0 0 0 1.022-1.77v-6.971c0-.729-.39-1.405-1.023-1.77l-1.157-.668z\" clip-rule=\"evenodd\"/>\n</svg>\n";
function $f7ab768ff134333e$export$58747af448450872(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Rovo Dev Agent' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $dlBdv.LogoWrapper), {
        svg: $f7ab768ff134333e$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("5PyYT", function(module, exports) {
$parcel$export(module.exports, "RovoHexIcon", () => $43ecd9ad182aa785$export$9e62346a60cfb459);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b1fdf93317430cb701429972e6c41dc4>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

var $dkXTa = parcelRequire("dkXTa");
// `height` is set to 100% to allow the SVG to scale with the parent element
var $43ecd9ad182aa785$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--rovo-blue-color, #1868db)\" fill-rule=\"evenodd\" d=\"m13.227 16.789-7.154 4.169-3.403-1.96a2.72 2.72 0 0 1-1.362-2.355V7.366c0-.973.518-1.87 1.361-2.354l6.044-3.487-.038.114a3.6 3.6 0 0 0-.172 1.088v9.278c0 1.274.68 2.45 1.786 3.085z\" clip-rule=\"evenodd\"/>\n    <path fill=\"var(--rovo-green-color, #6a9a23)\" fill-rule=\"evenodd\" d=\"m11.296 15.671-7.193 4.153 6.607 3.812a2.73 2.73 0 0 0 2.676.026l.048-.033a2.73 2.73 0 0 0 1.232-1.525 2.7 2.7 0 0 0 .127-.822v-3.594z\" clip-rule=\"evenodd\"/>\n    <path fill=\"var(--rovo-purple-color, #af59e1)\" fill-rule=\"evenodd\" d=\"m21.477 5.003-4.404-2.539-5.904 4.89 2.69 1.556a3.56 3.56 0 0 1 1.785 3.086v9.277a3.6 3.6 0 0 1-.21 1.202l6.044-3.486a2.71 2.71 0 0 0 1.362-2.355V7.357c0-.97-.521-1.87-1.363-2.354\" clip-rule=\"evenodd\"/>\n    <path fill=\"var(--rovo-yellow-color, #fca700)\" fill-rule=\"evenodd\" d=\"M12.74 8.266 9.353 6.312V2.718c0-.283.044-.56.127-.821A2.73 2.73 0 0 1 10.71.372V.37a.4.4 0 0 0 .048-.033 2.73 2.73 0 0 1 2.676.026l6.499 3.75z\" clip-rule=\"evenodd\"/>\n</svg>\n";
function $43ecd9ad182aa785$export$9e62346a60cfb459(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Rovo' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $dkXTa.IconWrapper), {
        svg: $43ecd9ad182aa785$var$svg,
        label: label,
        type: "rovo",
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("7yocG", function(module, exports) {
$parcel$export(module.exports, "RovoHexLogoCS", () => $57fe7bba8f3a8d6a$export$5e38d02efdb45577);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::0e01ef8caae93929e35d346a5091c5ef>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

var $dlBdv = parcelRequire("dlBdv");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $57fe7bba8f3a8d6a$var$svg = "<svg height=\"100%\" viewBox=\"0 0 102 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M93.5 25.97c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49M79.49 25.67h-3.53l-5.95-15.33h2.76l4.97 13.1 4.94-13.09h2.76zm-17.46.3c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49M44.99 8.16h-4.05v7.36h4.05c3.59 0 4.69-1.38 4.69-3.68 0-2.18-1.13-3.68-4.69-3.68m7.45 3.62c0 3.04-1.29 5.09-3.96 5.95l4.94 7.94h-3.25l-4.45-7.51h-4.78v7.51h-2.76V5.52h7.11c4.82 0 7.15 2.39 7.15 6.26\"/>\n    <path fill=\"var(--rovo-blue-color, #1868db)\" fill-rule=\"evenodd\" d=\"m15.892 22.385-9.538 5.559-4.538-2.613A3.63 3.63 0 0 1 0 22.19V9.821C0 8.524.69 7.33 1.816 6.682l8.058-4.649-.052.152a4.7 4.7 0 0 0-.228 1.452v12.37a4.74 4.74 0 0 0 2.38 4.113z\" clip-rule=\"evenodd\"/>\n    <path fill=\"var(--rovo-green-color, #6a9a23)\" fill-rule=\"evenodd\" d=\"m13.318 20.895-9.591 5.538 8.809 5.082a3.64 3.64 0 0 0 3.568.034l.065-.043a3.63 3.63 0 0 0 1.642-2.034c.11-.35.17-.718.17-1.096v-4.792z\" clip-rule=\"evenodd\"/>\n    <path fill=\"var(--rovo-purple-color, #af59e1)\" fill-rule=\"evenodd\" d=\"M26.893 6.67 21.02 3.285l-7.873 6.52 3.587 2.075a4.74 4.74 0 0 1 2.38 4.115v12.369a4.7 4.7 0 0 1-.28 1.603l8.058-4.649a3.62 3.62 0 0 0 1.816-3.139V9.81a3.63 3.63 0 0 0-1.816-3.139\" clip-rule=\"evenodd\"/>\n    <path fill=\"var(--rovo-yellow-color, #fca700)\" fill-rule=\"evenodd\" d=\"m15.244 11.022-4.519-2.606V3.625c0-.378.059-.747.17-1.096a3.63 3.63 0 0 1 1.64-2.033l.002-.001.064-.044a3.64 3.64 0 0 1 3.569.034l8.665 5z\" clip-rule=\"evenodd\"/>\n</svg>\n";
function $57fe7bba8f3a8d6a$export$5e38d02efdb45577(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Rovo' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $dlBdv.LogoWrapper), {
        svg: $57fe7bba8f3a8d6a$var$svg,
        label: label,
        type: "rovo",
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("1kJW6", function(module, exports) {
$parcel$export(module.exports, "SearchIcon", () => $0f8b4aaeed3bfd5f$export$82eafebb825fc23f);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::be11b64b046e775d05a59a39754fdeaf>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

var $dkXTa = parcelRequire("dkXTa");
// `height` is set to 100% to allow the SVG to scale with the parent element
var $0f8b4aaeed3bfd5f$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 6.625a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" fill-rule=\"evenodd\" d=\"M10.76 17.176a5.791 5.791 0 1 1 5.038-2.935l3.403 3.403-2.205 2.204-3.409-3.408a5.77 5.77 0 0 1-2.827.736m-.274-9.37-.242.615c-.344.874-.516 1.312-.833 1.64-.318.33-.749.518-1.61.893l-.37.16v.51l.37.16c.861.376 1.292.563 1.61.893.317.329.49.766.833 1.64l.242.616h.51l.242-.616c.344-.874.516-1.311.834-1.64.317-.33.748-.517 1.61-.893l.368-.16v-.51l-.369-.16c-.861-.375-1.292-.563-1.61-.892-.317-.33-.489-.766-.833-1.64l-.242-.616z\" clip-rule=\"evenodd\"/>\n</svg>\n";
function $0f8b4aaeed3bfd5f$export$82eafebb825fc23f(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Search' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $dkXTa.IconWrapper), {
        svg: $0f8b4aaeed3bfd5f$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("fw4L7", function(module, exports) {
$parcel$export(module.exports, "SearchLogoCS", () => $b4bd8937bad3fd8c$export$fa08cbfe393f2a68);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::151d3b961b465b2b1ef70ce5cd1da70c>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

var $dlBdv = parcelRequire("dlBdv");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $b4bd8937bad3fd8c$var$svg = "<svg height=\"100%\" viewBox=\"0 0 130 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M128.82 16.35v8.99h-2.64v-8.52c0-3.16-1.1-4.72-3.62-4.72-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V3.59h2.64v8.96c1.01-1.81 2.85-2.85 5.06-2.85 3.44 0 5.34 2.33 5.34 6.66m-16.05 6.21v2.36c-.92.49-2.33.71-3.74.71-5.46 0-8-3.31-8-8 0-4.63 2.55-7.94 8-7.94 1.38 0 2.45.18 3.65.74v2.45c-.98-.46-2.02-.74-3.46-.74-3.99 0-5.61 2.52-5.61 5.49s1.66 5.49 5.67 5.49c1.56 0 2.55-.21 3.5-.55m-18.23-6.29v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.67-5.43 3.93m-17.87 1.37c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.47-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zM65.08 12.09c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.67-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.2c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-15.33-4.95c0 3.5-2.08 5.86-7.08 5.86-3.89 0-5.7-.77-7.27-1.56v-2.82c1.87.98 4.75 1.69 7.42 1.69 3.04 0 4.17-1.2 4.17-2.97s-1.1-2.73-4.94-3.65c-4.54-1.1-6.56-2.67-6.56-5.98 0-3.13 2.39-5.46 7.08-5.46 2.91 0 4.78.71 6.16 1.47v2.76c-2.02-1.16-4.2-1.53-6.29-1.53-2.64 0-4.2.92-4.2 2.76 0 1.66 1.29 2.48 4.85 3.37 4.26 1.07 6.66 2.45 6.66 6.07\"/>\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" fill-rule=\"evenodd\" d=\"M14.346 22.068a7.721 7.721 0 1 1 6.718-3.913l4.537 4.536-2.94 2.94-4.545-4.545a7.7 7.7 0 0 1-3.77.982m-.364-12.494-.323.82c-.459 1.167-.688 1.75-1.112 2.188-.423.44-.997.69-2.146 1.19l-.492.214v.68l.492.213c1.149.5 1.723.75 2.146 1.19.424.439.653 1.022 1.112 2.188l.323.82h.679l.323-.82c.459-1.166.688-1.75 1.111-2.188.424-.44.998-.69 2.147-1.19l.491-.214v-.679l-.491-.214c-1.149-.5-1.723-.75-2.147-1.19-.423-.438-.652-1.021-1.111-2.187l-.323-.82z\" clip-rule=\"evenodd\"/>\n</svg>\n";
function $b4bd8937bad3fd8c$export$fa08cbfe393f2a68(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Search' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $dlBdv.LogoWrapper), {
        svg: $b4bd8937bad3fd8c$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("3AOCL", function(module, exports) {
$parcel$export(module.exports, "StatuspageIcon", () => $29dc00d3e852c298$export$f3f5aa321d88adf9);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::37c59c3ee979ff8acaf7525e576da094>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

var $dkXTa = parcelRequire("dkXTa");
// `height` is set to 100% to allow the SVG to scale with the parent element
var $29dc00d3e852c298$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#ffc716)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M12 9.796c-1.924 0-3.796.832-5.324 2.118q-.238.227-.475.227c-.132 0-.263-.076-.369-.202L3.908 9.771c-.105-.126-.158-.252-.158-.353 0-.151.08-.277.237-.429C6.307 7.023 9.127 5.914 12 5.914s5.693 1.109 8.013 3.075c.158.152.237.278.237.429 0 .1-.053.227-.158.353l-1.924 2.168c-.106.126-.238.202-.37.202q-.236 0-.474-.227c-1.529-1.286-3.4-2.118-5.324-2.118m0 8.118c-2.135 0-3.875-1.664-3.875-3.68 0-2.018 1.74-3.682 3.875-3.682s3.875 1.64 3.875 3.681-1.74 3.68-3.875 3.68\"/>\n</svg>\n";
function $29dc00d3e852c298$export$f3f5aa321d88adf9(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Statuspage' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $dkXTa.IconWrapper), {
        svg: $29dc00d3e852c298$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("6jsao", function(module, exports) {
$parcel$export(module.exports, "StatuspageLogoCS", () => $498a5dc059f68f6e$export$2bc88a281410ffa7);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4e31a509778b74933bf91345a74560c5>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

var $dlBdv = parcelRequire("dlBdv");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $498a5dc059f68f6e$var$svg = "<svg height=\"100%\" viewBox=\"0 0 192 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M184.96 12.09c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.05 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-18.64-.62v-1.53c-.98 2.02-2.82 3.07-5.18 3.07-4.05 0-6.07-3.46-6.07-7.97 0-4.32 2.12-7.97 6.38-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.58v13.95c0 4.51-2.12 7.54-7.61 7.54-2.58 0-3.99-.34-5.46-.83v-2.58c1.69.55 3.43.92 5.34.92 3.83 0 5.15-2.05 5.15-4.91m-8.68-6.44c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m-16.96.03c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-16.09-7.66c0-3.68-1.47-5.52-4.2-5.52-2.36 0-4.48 1.5-4.48 4.91v1.23c0 3.4 1.93 4.91 4.17 4.91 2.98 0 4.51-1.96 4.51-5.52m-3.8 7.97c-2.24 0-3.96-1.01-4.88-3v8.68h-2.64V10h2.64v2.76c.98-2.02 2.82-3.07 5.18-3.07 4.08 0 6.13 3.47 6.13 7.97 0 4.32-2.15 7.97-6.44 7.97m-10.55-4.47c0 2.55-1.66 4.48-5.77 4.48-2.3 0-4.17-.52-5.34-1.13v-2.79c1.32.77 3.53 1.5 5.46 1.5 2.02 0 3.07-.83 3.07-2.02 0-1.16-.89-1.84-3.8-2.54-3.4-.83-4.84-2.15-4.84-4.66 0-2.67 2.05-4.29 5.55-4.29 1.99 0 3.8.49 4.94 1.1v2.73c-1.84-.92-3.34-1.41-4.97-1.41-1.93 0-2.97.68-2.97 1.87 0 1.07.74 1.75 3.56 2.42 3.4.83 5.12 2.09 5.12 4.75m-27.61-2.18V10h2.64v9.26c0 2.76 1.1 3.99 3.62 3.99 2.45 0 4.14-1.62 4.14-4.72V10h2.64v15.33h-2.64v-2.51c-.98 1.81-2.79 2.82-4.84 2.82-3.53 0-5.55-2.42-5.55-6.65m-7.16 1.59c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55c-.46.12-.98.25-1.78.25-3.28 0-4.88-1.93-4.88-4.78v-8.19H85V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zm-18.95-2.91c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-17.26-4.75c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55c-.46.12-.98.25-1.78.25-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zm-6.89-.8c0 3.5-2.08 5.86-7.08 5.86-3.89 0-5.7-.77-7.27-1.56v-2.82c1.87.98 4.75 1.69 7.42 1.69 3.04 0 4.17-1.2 4.17-2.97s-1.1-2.73-4.94-3.65c-4.54-1.1-6.56-2.67-6.56-5.98 0-3.13 2.39-5.46 7.08-5.46 2.91 0 4.78.71 6.16 1.47v2.76c-2.02-1.16-4.2-1.53-6.29-1.53-2.64 0-4.2.92-4.2 2.76 0 1.66 1.29 2.48 4.84 3.37 4.26 1.07 6.66 2.45 6.66 6.07\"/>\n    <path fill=\"var(--tile-color,#ffc716)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M15.896 13.196c-2.464 0-4.86 1.114-6.817 2.835q-.303.304-.607.304c-.169 0-.338-.102-.473-.27l-2.463-2.902c-.135-.17-.202-.338-.202-.473 0-.202.1-.371.303-.573C8.607 9.484 12.217 8 15.896 8c3.678 0 7.29 1.484 10.259 4.117.202.202.303.37.303.573 0 .135-.067.304-.202.473l-2.463 2.902c-.135.168-.304.27-.473.27q-.303 0-.607-.304c-1.958-1.721-4.353-2.835-6.817-2.835m0 10.867c-2.733 0-4.96-2.228-4.96-4.927 0-2.7 2.227-4.927 4.96-4.927s4.96 2.193 4.96 4.927-2.227 4.927-4.96 4.927\"/>\n</svg>\n";
function $498a5dc059f68f6e$export$2bc88a281410ffa7(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Statuspage' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $dlBdv.LogoWrapper), {
        svg: $498a5dc059f68f6e$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("ifRjy", function(module, exports) {
$parcel$export(module.exports, "StudioIcon", () => $d4a2fbda144b1191$export$290a0f24614cde9f);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ab3266b216390c79d8a1dc3be47de23d>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

var $dkXTa = parcelRequire("dkXTa");
// `height` is set to 100% to allow the SVG to scale with the parent element
var $d4a2fbda144b1191$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" fill-rule=\"evenodd\" d=\"M10.594 18.563v-7.97h7.969v7.97zm3.808-6.488-.163.429c-.235.615-.352.922-.572 1.155s-.52.368-1.12.638l-.222.1v.357l.222.099c.6.27.9.405 1.12.638s.337.54.572 1.156l.163.428h.347l.163-.429c.235-.615.352-.922.572-1.155s.52-.368 1.12-.638l.221-.1v-.357l-.22-.1c-.601-.269-.901-.404-1.121-.637s-.337-.54-.572-1.155l-.164-.429z\" clip-rule=\"evenodd\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M14.813 7.195 10.125 4.5 5.438 7.195v5.39l3.75 2.157V9.187h5.625z\"/>\n</svg>\n";
function $d4a2fbda144b1191$export$290a0f24614cde9f(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Studio' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $dkXTa.IconWrapper), {
        svg: $d4a2fbda144b1191$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("h2gXe", function(module, exports) {
$parcel$export(module.exports, "StudioLogoCS", () => $c66fc654b038e593$export$273fd56580e523ae);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f3562c122e709e76d7d20dd81b620288>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

var $dlBdv = parcelRequire("dlBdv");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $c66fc654b038e593$var$svg = "<svg height=\"100%\" viewBox=\"0 0 124 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M116.71 25.64c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49m-13.48-6.2c0-1.17.77-1.84 1.84-1.84s1.84.67 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-15.3-7.66c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.47-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V3.59h2.64v21.74zm-27.41-6.34V10h2.64v9.26c0 2.76 1.1 3.99 3.62 3.99 2.45 0 4.14-1.63 4.14-4.72V10h2.64v15.33h-2.64v-2.51c-.98 1.81-2.79 2.82-4.85 2.82-3.53 0-5.55-2.42-5.55-6.65m-7.16 1.59c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55a6.3 6.3 0 0 1-1.78.25c-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zm-6.89-.8c0 3.5-2.08 5.86-7.08 5.86-3.89 0-5.7-.77-7.27-1.56v-2.82c1.87.98 4.75 1.69 7.42 1.69 3.04 0 4.17-1.2 4.17-2.97s-1.1-2.73-4.94-3.65c-4.54-1.1-6.56-2.67-6.56-5.98 0-3.13 2.39-5.46 7.08-5.46 2.91 0 4.78.71 6.16 1.47v2.76c-2.02-1.16-4.2-1.53-6.29-1.53-2.64 0-4.2.92-4.2 2.76 0 1.66 1.29 2.48 4.85 3.37 4.26 1.07 6.66 2.45 6.66 6.07\"/>\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" fill-rule=\"evenodd\" d=\"M14.125 24.75V14.125H24.75V24.75zm5.078-8.65-.218.571c-.312.82-.469 1.23-.762 1.541s-.694.49-1.494.85l-.295.133v.476l.295.133c.8.36 1.2.54 1.494.85.293.311.45.721.762 1.541l.218.572h.462l.218-.572c.313-.82.469-1.23.762-1.54s.694-.491 1.494-.851l.295-.133v-.476l-.295-.132c-.8-.36-1.2-.54-1.494-.85-.293-.312-.45-.722-.762-1.542l-.218-.571z\" clip-rule=\"evenodd\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M19.75 9.594 13.5 6 7.25 9.594v7.187l5 2.875V12.25h7.5z\"/>\n</svg>\n";
function $c66fc654b038e593$export$273fd56580e523ae(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Studio' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $dlBdv.LogoWrapper), {
        svg: $c66fc654b038e593$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("aWEED", function(module, exports) {
$parcel$export(module.exports, "TalentIcon", () => $7f7edb4e357e2b13$export$4b05688514531169);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f1d8fa09e3a068fb57474a844fe5ab56>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

var $dkXTa = parcelRequire("dkXTa");
// `height` is set to 100% to allow the SVG to scale with the parent element
var $7f7edb4e357e2b13$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#fb9700)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" fill-rule=\"evenodd\" d=\"m9.297 8.753 2.277-5.073h.858l2.277 5.073 5.529.598.265.816-4.121 3.734 1.14 5.442-.695.505-4.824-2.766-4.824 2.766-.695-.505 1.14-5.442-4.121-3.733.265-.817zm.777 6.415v-.678a1.857 1.857 0 0 1 3.715 0v.613a3.6 3.6 0 0 1-1.886.548h-.053a3.6 3.6 0 0 1-1.776-.483m1.858-3.134a1.393 1.393 0 1 0 0-2.786 1.393 1.393 0 0 0 0 2.786\" clip-rule=\"evenodd\"/>\n</svg>\n";
function $7f7edb4e357e2b13$export$4b05688514531169(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Talent' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $dkXTa.IconWrapper), {
        svg: $7f7edb4e357e2b13$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("2FAht", function(module, exports) {
$parcel$export(module.exports, "TalentLogoCS", () => $1f1b8db51b42626f$export$1b3979d995ebbc6e);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4af27131cfc453f0f255c3cbe65f158e>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

var $dlBdv = parcelRequire("dlBdv");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $1f1b8db51b42626f$var$svg = "<svg height=\"100%\" viewBox=\"0 0 122 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M117.1 20.58c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55c-.46.12-.98.25-1.78.25-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zm-7.33-4.23v8.99h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.51c.98-1.81 2.79-2.82 4.85-2.82 3.53 0 5.55 2.42 5.55 6.66m-22.92-4.26c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.67-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2H82.4c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-14.47.57c-.21.06-.67.12-1.35.12-2.51 0-4.11-1.19-4.11-4.02V3.59h2.64V21.1c0 1.38.92 1.87 2.06 1.87.28 0 .46 0 .77-.03zm-20.75-7.63c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.47-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zM40.28 5.19h15.09v2.64H49.2v17.51h-2.76V7.82h-6.16z\"/>\n    <path fill=\"var(--tile-color,#fb9700)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"m16.577 4.907 3.035 6.763 7.372.797.354 1.09-5.495 4.977 1.52 7.257-.927.672-6.431-3.687-6.433 3.687-.926-.672 1.52-7.257-5.495-4.978.353-1.089 7.372-.797 3.035-6.763zm-.668 11.936a2.476 2.476 0 0 0-2.476 2.477v.904a4.8 4.8 0 0 0 2.369.644h.07a4.8 4.8 0 0 0 2.514-.73v-.818a2.477 2.477 0 0 0-2.477-2.477m0-4.511a1.857 1.857 0 1 0 0 3.714 1.857 1.857 0 0 0 0-3.714\"/>\n</svg>\n";
function $1f1b8db51b42626f$export$1b3979d995ebbc6e(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Talent' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $dlBdv.LogoWrapper), {
        svg: $1f1b8db51b42626f$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("dLdBg", function(module, exports) {
$parcel$export(module.exports, "TeamsIcon", () => $a04a36d44116debe$export$1bcbc9c337da86da);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7cfe9311dc5f8070530ce9772b12f3fc>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

var $dkXTa = parcelRequire("dkXTa");
// `height` is set to 100% to allow the SVG to scale with the parent element
var $a04a36d44116debe$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M8.06 11.25a2.63 2.63 0 1 0 0-5.25 2.63 2.63 0 0 0 0 5.25m7.88 0a2.63 2.63 0 1 0 0-5.25 2.63 2.63 0 0 0 0 5.25m.17 1.31a2.89 2.89 0 0 1 2.89 2.9V18h-7.22l1.66-3.67a2.89 2.89 0 0 1 2.67-1.77M5 15.63V18h4.81l1.31-2.81a2.63 2.63 0 0 0-2.62-2.63h-.44A3.06 3.06 0 0 0 5 15.63\"/>\n</svg>\n";
function $a04a36d44116debe$export$1bcbc9c337da86da(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Teams' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $dkXTa.IconWrapper), {
        svg: $a04a36d44116debe$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("eyiAX", function(module, exports) {
$parcel$export(module.exports, "TeamsLogoCS", () => $a982aa43c10022ed$export$bfd8d1c4da84ce71);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a9a7a0d4583e5a9f22d08a0d2f6ac1f1>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

var $dlBdv = parcelRequire("dlBdv");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $a982aa43c10022ed$var$svg = "<svg height=\"100%\" viewBox=\"0 0 127 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M126.58 21.16c0 2.55-1.66 4.48-5.77 4.48-2.3 0-4.17-.52-5.34-1.13v-2.79c1.32.77 3.53 1.5 5.46 1.5 2.02 0 3.07-.83 3.07-2.02 0-1.16-.89-1.84-3.8-2.54-3.4-.83-4.84-2.15-4.84-4.66 0-2.67 2.05-4.29 5.55-4.29 1.99 0 3.8.49 4.94 1.1v2.73c-1.84-.92-3.34-1.41-4.97-1.41-1.93 0-2.97.67-2.97 1.87 0 1.07.74 1.75 3.56 2.42 3.4.83 5.12 2.09 5.12 4.75m-24.66-4.36v8.53h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 2.61 0 4.39 1.32 5.15 3.74.86-2.36 2.91-3.74 5.46-3.74 3.44 0 5.34 2.33 5.34 6.66v8.99h-2.64v-8.52c0-3.16-1.1-4.72-3.62-4.72-2.45 0-4.14 1.63-4.14 4.72m-28.33.84c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zM61.99 12.08c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2H57.55c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zM40.28 5.19h15.09v2.64H49.2v17.51h-2.76V7.82h-6.16z\"/>\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M10.75 14.83a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7m10.5 0a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7m.23 1.75a3.86 3.86 0 0 1 3.86 3.86v3.72h-9.62l2.21-5.23a3.86 3.86 0 0 1 3.55-2.35M6.67 20.67v3.5h6.42l1.75-4.08a3.5 3.5 0 0 0-3.5-3.5h-.58a4.08 4.08 0 0 0-4.08 4.08\"/>\n</svg>\n";
function $a982aa43c10022ed$export$bfd8d1c4da84ce71(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Teams' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $dlBdv.LogoWrapper), {
        svg: $a982aa43c10022ed$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("bmTy7", function(module, exports) {
$parcel$export(module.exports, "TrelloIcon", () => $846cd6bc1530edeb$export$4384da9b8b140bf4);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2fc7b25031952cd94704eefaa85d7de4>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

var $dkXTa = parcelRequire("dkXTa");
// `height` is set to 100% to allow the SVG to scale with the parent element
var $846cd6bc1530edeb$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#1558bc)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, white)\" d=\"M9.39 18.23a.95.95 0 0 0 .95-.95V5.38a.95.95 0 0 0-.95-.95H5.38a.95.95 0 0 0-.95.95v11.91c0 .52.42.95.95.95zm9.23-5.46a.95.95 0 0 0 .95-.95V5.38a.95.95 0 0 0-.95-.95h-4.01a.95.95 0 0 0-.95.95v6.44c0 .52.42.95.95.95z\"/>\n</svg>\n";
var $846cd6bc1530edeb$var$customThemeSvg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--themed-icon-color, currentcolor)\" d=\"M18 0a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6V6a6 6 0 0 1 6-6zM5.379 4.43a.95.95 0 0 0-.948.949v11.907c0 .523.424.948.948.948H9.39a.95.95 0 0 0 .947-.948V5.38a.95.95 0 0 0-.947-.948zm9.23 0a.95.95 0 0 0-.947.949v6.44c0 .523.423.948.947.949h4.012a.95.95 0 0 0 .948-.949V5.38a.95.95 0 0 0-.948-.948z\"/>\n</svg>\n";
function $846cd6bc1530edeb$export$4384da9b8b140bf4(_ref) {
    var iconColor = _ref.iconColor, size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Trello' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $dkXTa.IconWrapper), {
        svg: $846cd6bc1530edeb$var$svg,
        customThemeSvg: $846cd6bc1530edeb$var$customThemeSvg,
        iconColor: iconColor,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("i8Cp2", function(module, exports) {
$parcel$export(module.exports, "TrelloLogoCS", () => $d346c3580de5e974$export$1b13139dfc0336af);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b73a20da143650f747e32cb182c99798>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

var $dlBdv = parcelRequire("dlBdv");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $d346c3580de5e974$var$svg = "<svg height=\"100%\" viewBox=\"0 0 113 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M104.97 25.64c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49M96.21 25.3c-.21.06-.67.12-1.35.12-2.51 0-4.11-1.19-4.11-4.02V3.59h2.64V21.1c0 1.38.92 1.87 2.06 1.87.28 0 .46 0 .77-.03zm-8 0c-.21.06-.67.12-1.35.12-2.51 0-4.11-1.19-4.11-4.02V3.59h2.64V21.1c0 1.38.92 1.87 2.06 1.87.28 0 .46 0 .77-.03zM72.86 12.09c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.67-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2H68.42c.37 2.61 2.05 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-19.48-8.44v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.67-5.43 3.93M40.28 5.19h15.09v2.64H49.2v17.51h-2.76V7.82h-6.16z\"/>\n    <path fill=\"var(--tile-color,#1558bc)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, white)\" d=\"M12.9 24c.62 0 1.13-.49 1.13-1.1V9.1c0-.61-.5-1.1-1.13-1.1H8.13C7.51 8 7 8.49 7 9.1v13.8c0 .61.5 1.1 1.13 1.1zm10.97-6.34c.62 0 1.13-.49 1.13-1.1V9.1c0-.61-.5-1.1-1.13-1.1H19.1c-.62 0-1.13.49-1.13 1.1v7.47c0 .61.5 1.1 1.13 1.1z\"/>\n</svg>\n";
function $d346c3580de5e974$export$1b13139dfc0336af(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Trello' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $dlBdv.LogoWrapper), {
        svg: $d346c3580de5e974$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("2rcE7", function(module, exports) {
$parcel$export(module.exports, "AtlassianAdminIcon", () => $1c67e9a6f1bb1a6f$export$84109e099492cb5f);

var $5FkrB = parcelRequire("5FkrB");

var $fDucD = parcelRequire("fDucD");

var $8onqJ = parcelRequire("8onqJ");

var $cVyt1 = parcelRequire("cVyt1");

var $8oKXf = parcelRequire("8oKXf");
var $1c67e9a6f1bb1a6f$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor;
    var colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $8oKXf.getColorsFromAppearance)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" focusable=\"false\" aria-hidden=\"true\">\n      <path\n        d=\"M27.545 24.378 16.96 3.208c-.208-.458-.417-.541-.667-.541-.208 0-.458.083-.708.5-1.5 2.375-2.167 5.125-2.167 8 0 4.001 2.042 7.752 5.042 13.794.334.667.584.792 1.167.792h7.335c.541 0 .833-.208.833-.625 0-.208-.042-.333-.25-.75M12.168 14.377c-.834-1.25-1.084-1.334-1.292-1.334s-.333.083-.708.834L4.875 24.46c-.167.334-.208.459-.208.625 0 .334.291.667.916.667h7.46c.5 0 .875-.416 1.083-1.208.25-1 .334-1.876.334-2.917 0-2.917-1.292-5.751-2.292-7.251z\"\n        fill=\"".concat(colors.iconColor, "\"\n      />\n    </svg>");
};
var $1c67e9a6f1bb1a6f$export$84109e099492cb5f = function AtlassianAdminIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Atlassian Admin' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $8onqJ.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $8onqJ.defaultLogoParams).textColor : _ref2$textColor, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $8onqJ.defaultLogoParams).iconColor : _ref2$iconColor;
    var _useThemeObserver = (0, $fDucD.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $cVyt1.default), {
        appearance: appearance,
        svg: $1c67e9a6f1bb1a6f$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        label: label,
        size: size,
        testId: testId,
        textColor: textColor
    });
};

});
parcelRegister("8onqJ", function(module, exports) {
$parcel$export(module.exports, "defaultLogoParams", () => $61c2bd5f28c47c3c$export$438460117ae6b7ee);
$parcel$export(module.exports, "legacyDefaultLogoParams", () => $61c2bd5f28c47c3c$export$793fba32aed8942a);
/**
 * These are the default parameters for LogoProps if the user does not specify values.
 */ var $61c2bd5f28c47c3c$export$438460117ae6b7ee = {
    iconColor: 'inherit',
    label: '',
    size: 'medium',
    textColor: 'currentColor'
};
var $61c2bd5f28c47c3c$export$793fba32aed8942a = {
    iconGradientStart: 'inherit',
    iconGradientStop: 'inherit'
}; /**
 * The props for the <Wrapper /> that takes the svg and turns it into a component.
 */ 

});

parcelRegister("cVyt1", function(module, exports) {
$parcel$export(module.exports, "default", () => $96958b5ae3603ec3$export$2e2bcd8739ae039);
/* wrapper.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $kqp0i = parcelRequire("kqp0i");

var $25nEq = parcelRequire("25nEq");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");

var $7J6mo = parcelRequire("7J6mo");
var $96958b5ae3603ec3$var$_excluded = [
    "label",
    "svg",
    "size",
    "appearance",
    "iconColor",
    "textColor",
    "testId"
];
var $96958b5ae3603ec3$var$CSS_VAR_COLOR = '--logo-color';
var $96958b5ae3603ec3$var$CSS_VAR_FILL = '--logo-fill';
var $96958b5ae3603ec3$var$styles = {
    root: "_1e0c1o8l _kqswh2mm _syaz1vry _lswu1xf6 _vwz4kb7n _uiztglyw _o5724jg8 _zbji1osq _3se11kw7",
    stop: "_vc881r31",
    xxsmall: "_4t3i7vkz",
    xsmall: "_4t3igktf",
    small: "_4t3i1tcg",
    medium: "_4t3izwfg",
    large: "_4t3i1ylp",
    xlarge: "_4t3ickbl"
};
/**
 * __Wrapper__
 *
 * An internal component used by `@atlaskit/logo` to render logo SVGs with correct styles.
 */ var $96958b5ae3603ec3$var$Wrapper = function Wrapper(_ref) {
    var label = _ref.label, svg = _ref.svg, size = _ref.size, appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor, userDefinedTestId = _ref.testId, rest = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $96958b5ae3603ec3$var$_excluded);
    // Only required for old logos with gradients, which set gradient values to `inherit` when no appearance is provided
    var shouldApplyStopColor = appearance === undefined;
    var testId = userDefinedTestId && "".concat(userDefinedTestId, "--wrapper");
    return /*#__PURE__*/ $5FkrB.createElement("span", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        "data-testid": testId,
        style: (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, $96958b5ae3603ec3$var$CSS_VAR_COLOR, iconColor), $96958b5ae3603ec3$var$CSS_VAR_FILL, textColor),
        "aria-label": label ? label : undefined,
        role: label ? 'img' : undefined,
        dangerouslySetInnerHTML: {
            __html: svg
        }
    }, rest, {
        className: (0, $7J6mo.default)([
            $96958b5ae3603ec3$var$styles.root,
            shouldApplyStopColor && $96958b5ae3603ec3$var$styles.stop,
            size && $96958b5ae3603ec3$var$styles[size]
        ])
    }));
};
var $96958b5ae3603ec3$export$2e2bcd8739ae039 = $96958b5ae3603ec3$var$Wrapper;

});

parcelRegister("8oKXf", function(module, exports) {
$parcel$export(module.exports, "getColorsFromAppearanceOldLogos", () => $61d4fcd56468b2fe$export$362a25f017e2bc8a);
$parcel$export(module.exports, "getColorsFromAppearance", () => $61d4fcd56468b2fe$export$bbacc3980e0f3029);
$parcel$export(module.exports, "getColorsForLoom", () => $61d4fcd56468b2fe$export$7818df200941dbbf);

var $jBqEv = parcelRequire("jBqEv");
var $61d4fcd56468b2fe$export$362a25f017e2bc8a = function getColorsFromAppearanceOldLogos(appearance, colorMode) {
    var iconGradientStart, iconGradientStop, iconColor, textColor, atlassianLogoTextColor;
    switch(appearance){
        case 'brand':
            iconGradientStart = (0, $jBqEv.B400);
            iconGradientStop = (0, $jBqEv.B200);
            iconColor = (0, $jBqEv.B200);
            textColor = "var(--ds-text, #292A2E)";
            // This is only used for the top level Atlassian wordmark (see AtlassianLogo
            // or AtlassianStartLogo for example), and is only different for the Brand
            // appearance - a bold brand color. For other appearances,
            // atlassianLogoTextColor is the same as textColor.
            atlassianLogoTextColor = (0, $jBqEv.B400);
            break;
        case 'neutral':
            iconGradientStart = (0, $jBqEv.N600);
            iconGradientStop = (0, $jBqEv.N100);
            iconColor = (0, $jBqEv.N100);
            textColor = (0, $jBqEv.N400);
            atlassianLogoTextColor = (0, $jBqEv.N400);
            break;
        case 'inverse':
            iconGradientStart = '#FFFFFF66';
            iconGradientStop = '#FFFFFF';
            iconColor = '#FFFFFF';
            textColor = '#FFFFFF';
            atlassianLogoTextColor = '#FFFFFF';
            break;
    }
    if (colorMode === 'dark' && appearance === 'inverse') {
        iconGradientStart = '#161A1D66';
        iconGradientStop = '#161A1D';
        iconColor = '#161A1D';
        textColor = '#161A1D';
        atlassianLogoTextColor = '#161A1D';
    }
    return {
        iconGradientStart: iconGradientStart,
        iconGradientStop: iconGradientStop,
        iconColor: iconColor,
        textColor: textColor,
        atlassianLogoTextColor: atlassianLogoTextColor
    };
};
var $61d4fcd56468b2fe$export$bbacc3980e0f3029 = function getColorsFromAppearance(appearance, colorMode) {
    var iconColor, textColor, atlassianLogoTextColor;
    if (colorMode === 'dark') switch(appearance){
        case 'brand':
            iconColor = '#357DE8';
            textColor = '#E2E3E4';
            atlassianLogoTextColor = '#357DE8';
            break;
        case 'neutral':
            iconColor = '#96999E';
            textColor = '#BFC1C4';
            atlassianLogoTextColor = '#96999E';
            break;
        case 'inverse':
            iconColor = '#101214';
            textColor = '#101214';
            atlassianLogoTextColor = '#101214';
            break;
    }
    else switch(appearance){
        case 'brand':
            iconColor = '#1868DB';
            textColor = '#101214';
            atlassianLogoTextColor = '#1868DB';
            break;
        case 'neutral':
            iconColor = '#6C6F77';
            textColor = '#3B3D42';
            atlassianLogoTextColor = '#6C6F77';
            break;
        case 'inverse':
            iconColor = (0, $jBqEv.N0);
            textColor = (0, $jBqEv.N0);
            atlassianLogoTextColor = (0, $jBqEv.N0);
            break;
    }
    return {
        iconColor: iconColor,
        textColor: textColor,
        atlassianLogoTextColor: atlassianLogoTextColor
    };
};
var $61d4fcd56468b2fe$export$7818df200941dbbf = function getColorsForLoom(appearance, colorMode) {
    var iconColor = $61d4fcd56468b2fe$export$bbacc3980e0f3029(appearance, colorMode).iconColor;
    var textColor = $61d4fcd56468b2fe$export$bbacc3980e0f3029(appearance, colorMode).textColor;
    if (colorMode === 'dark') switch(appearance){
        case 'brand':
            iconColor = '#625DF5';
            textColor = '#EFF0FF';
            break;
    }
    else switch(appearance){
        case 'brand':
            iconColor = '#625DF5';
            textColor = '#252434';
            break;
    }
    return {
        iconColor: iconColor,
        textColor: textColor
    };
};

});
parcelRegister("jBqEv", function(module, exports) {
$parcel$export(module.exports, "B200", () => $e456259d9c3b1005$export$215b7063051591f1);
$parcel$export(module.exports, "B400", () => $e456259d9c3b1005$export$b3de0ae08da2ce64);
$parcel$export(module.exports, "N0", () => $e456259d9c3b1005$export$29a4f05edc054374);
$parcel$export(module.exports, "N100", () => $e456259d9c3b1005$export$d6447c357493214f);
$parcel$export(module.exports, "N400", () => $e456259d9c3b1005$export$eece5f492e429f08);
$parcel$export(module.exports, "N600", () => $e456259d9c3b1005$export$7090862dc3038a9f);
// Reds
var $e456259d9c3b1005$export$4b84fd0e2c617bd = '#FFEBE6';
var $e456259d9c3b1005$export$b34b069eff244586 = '#FFBDAD';
var $e456259d9c3b1005$export$be802dd0d8b57f35 = '#FF8F73';
var $e456259d9c3b1005$export$60847d42f9da92a6 = '#FF7452';
var $e456259d9c3b1005$export$4a7404f376229999 = '#FF5630';
var $e456259d9c3b1005$export$2010d0fb4295b346 = '#DE350B';
var $e456259d9c3b1005$export$2837b5a1a71d5c02 = '#BF2600';
var $e456259d9c3b1005$export$8d9596b529bbb9cf = '#FFFAE6';
var $e456259d9c3b1005$export$41060a744ab0b7ae = '#FFF0B3';
var $e456259d9c3b1005$export$1cc05bbbf340e559 = '#FFE380';
var $e456259d9c3b1005$export$5aae31392d72caaa = '#FFC400';
var $e456259d9c3b1005$export$c6930421db9fa514 = '#FFAB00';
var $e456259d9c3b1005$export$59619663aa6500fb = '#FF991F';
var $e456259d9c3b1005$export$874739ea9e379ab6 = '#FF8B00';
var $e456259d9c3b1005$export$8a6341c32b6a3ee6 = '#E3FCEF';
var $e456259d9c3b1005$export$69a3bf21b9686c2b = '#ABF5D1';
var $e456259d9c3b1005$export$afbce1382ec95f73 = '#79F2C0';
var $e456259d9c3b1005$export$747d86715d4175de = '#57D9A3';
var $e456259d9c3b1005$export$940e1f69e873f202 = '#36B37E';
var $e456259d9c3b1005$export$a49394138f7b8e85 = '#00875A';
var $e456259d9c3b1005$export$6fa04827ac68a4fb = '#006644';
var $e456259d9c3b1005$export$226de0355ed012f8 = '#DEEBFF';
var $e456259d9c3b1005$export$8c13c2ee36917869 = '#B3D4FF';
var $e456259d9c3b1005$export$ecfc1dff386a3e7a = '#4C9AFF';
var $e456259d9c3b1005$export$215b7063051591f1 = '#2684FF';
var $e456259d9c3b1005$export$e62e8919cca44969 = '#0065FF';
var $e456259d9c3b1005$export$b3de0ae08da2ce64 = '#0052CC';
var $e456259d9c3b1005$export$a6ee3d71bc067634 = '#0747A6';
var $e456259d9c3b1005$export$67f15409e87642a1 = '#669DF1';
var $e456259d9c3b1005$export$f0539dbc42dbb067 = '#8FB8F6';
var $e456259d9c3b1005$export$363e4475840015bb = '#EAE6FF';
var $e456259d9c3b1005$export$4b0a4417ed59760f = '#C0B6F2';
var $e456259d9c3b1005$export$6011520a64d9a187 = '#998DD9';
var $e456259d9c3b1005$export$a7175d4e9206bc80 = '#8777D9';
var $e456259d9c3b1005$export$b48405b95304b5a1 = '#6554C0';
var $e456259d9c3b1005$export$c71e4279dd54a18d = '#5243AA';
var $e456259d9c3b1005$export$147899de772240ec = '#403294';
var $e456259d9c3b1005$export$2cf711fe14c66f06 = '#E6FCFF';
var $e456259d9c3b1005$export$7a8f4d33f6f9772c = '#B3F5FF';
var $e456259d9c3b1005$export$776c9c497ef08533 = '#79E2F2';
var $e456259d9c3b1005$export$69cb3ca10c1e330e = '#00C7E6';
var $e456259d9c3b1005$export$9dc1ef0f3f48059b = '#00B8D9';
var $e456259d9c3b1005$export$7c835c78b6fcdef8 = '#00A3BF';
var $e456259d9c3b1005$export$6036577f95c3877e = '#008DA6';
var $e456259d9c3b1005$export$29a4f05edc054374 = '#FFFFFF';
var $e456259d9c3b1005$export$e655ef011c4aa1a2 = '#FAFBFC';
var $e456259d9c3b1005$export$9fdfb749e33cdf97 = '#F4F5F7';
var $e456259d9c3b1005$export$3e51e8f1440314ba = '#EBECF0';
var $e456259d9c3b1005$export$1ce2d1575d444ceb = '#DFE1E6';
var $e456259d9c3b1005$export$8754fc7e6d8b3000 = '#C1C7D0';
var $e456259d9c3b1005$export$c2e91cbeada39b8b = '#B3BAC5';
var $e456259d9c3b1005$export$5f71e19f3a7ad9de = '#A5ADBA';
var $e456259d9c3b1005$export$eaa8c8a70ac22806 = '#97A0AF';
var $e456259d9c3b1005$export$7c87d337fb91a97d = '#8993A4';
var $e456259d9c3b1005$export$d6447c357493214f = '#7A869A';
var $e456259d9c3b1005$export$f563ee71e9ee74cd = '#6B778C';
var $e456259d9c3b1005$export$e2ef2124cf4024b1 = '#5E6C84';
var $e456259d9c3b1005$export$eece5f492e429f08 = '#505F79';
var $e456259d9c3b1005$export$c39c0fe0f26207ae = '#42526E';
var $e456259d9c3b1005$export$7090862dc3038a9f = '#344563';
var $e456259d9c3b1005$export$ad0bacf983b7ddaa = '#253858';
var $e456259d9c3b1005$export$7d61b15e0da132af = '#172B4D';
var $e456259d9c3b1005$export$fbda843f0a27fe96 = '#091E42';
var $e456259d9c3b1005$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
var $e456259d9c3b1005$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
var $e456259d9c3b1005$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
var $e456259d9c3b1005$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
var $e456259d9c3b1005$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
var $e456259d9c3b1005$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
var $e456259d9c3b1005$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
var $e456259d9c3b1005$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
var $e456259d9c3b1005$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
var $e456259d9c3b1005$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
var $e456259d9c3b1005$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
var $e456259d9c3b1005$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
var $e456259d9c3b1005$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
var $e456259d9c3b1005$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
var $e456259d9c3b1005$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
var $e456259d9c3b1005$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
var $e456259d9c3b1005$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
var $e456259d9c3b1005$export$2f6319cf7d736c2a = '#E6EDFA';
var $e456259d9c3b1005$export$95126bc8884d6634 = '#DCE5F5';
var $e456259d9c3b1005$export$8338d8c35d44ff1 = '#CED9EB';
var $e456259d9c3b1005$export$5368d76ae4fbbda7 = '#B8C7E0';
var $e456259d9c3b1005$export$9f0a771d16ec8d36 = '#ABBBD6';
var $e456259d9c3b1005$export$abcf8c38338b4aa5 = '#9FB0CC';
var $e456259d9c3b1005$export$97e81faa16a182c7 = '#8C9CB8';
var $e456259d9c3b1005$export$bfe21c59123ecf33 = '#7988A3';
var $e456259d9c3b1005$export$ee82aa2ea6a1558 = '#67758F';
var $e456259d9c3b1005$export$682927c6ed76be02 = '#56637A';
var $e456259d9c3b1005$export$91fd9994c5be9757 = '#455166';
var $e456259d9c3b1005$export$d281fbfe3cff2df6 = '#3B475C';
var $e456259d9c3b1005$export$3902c91d8b98a753 = '#313D52';
var $e456259d9c3b1005$export$8e8133c1ba5845b5 = '#283447';
var $e456259d9c3b1005$export$33ff357f6620b39 = '#202B3D';
var $e456259d9c3b1005$export$633847cf062b69e0 = '#1B2638';
var $e456259d9c3b1005$export$9776a6e503bdbf76 = '#121A29';
var $e456259d9c3b1005$export$6c813d5160dff5db = '#0E1624';
var $e456259d9c3b1005$export$3d4f271a500072a = '#0D1424';
var $e456259d9c3b1005$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
var $e456259d9c3b1005$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
var $e456259d9c3b1005$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
var $e456259d9c3b1005$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
var $e456259d9c3b1005$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
var $e456259d9c3b1005$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
var $e456259d9c3b1005$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
var $e456259d9c3b1005$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
var $e456259d9c3b1005$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
var $e456259d9c3b1005$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
var $e456259d9c3b1005$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
var $e456259d9c3b1005$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
var $e456259d9c3b1005$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
var $e456259d9c3b1005$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
var $e456259d9c3b1005$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
var $e456259d9c3b1005$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
var $e456259d9c3b1005$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';
var $e456259d9c3b1005$export$d2adc5dedf09fced = '#292A2E';
var $e456259d9c3b1005$export$f51762073d2bb381 = '#94C748';
var $e456259d9c3b1005$export$95e26d54def96891 = '#B3DF72';

});



parcelRegister("bjGEe", function(module, exports) {
$parcel$export(module.exports, "AtlassianAdminLogo", () => $02204c990345b447$export$f845d9b9254f0541);

var $5FkrB = parcelRequire("5FkrB");

var $fDucD = parcelRequire("fDucD");

var $8onqJ = parcelRequire("8onqJ");

var $cVyt1 = parcelRequire("cVyt1");

var $8oKXf = parcelRequire("8oKXf");
var $02204c990345b447$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $8oKXf.getColorsFromAppearance)(appearance, colorMode);
    return "<svg\n      fill=\"none\"\n      height=\"32\"\n      xmlns=\"http://www.w3.org/2000/svg\"\n      viewBox=\"0 0 295 32\"\n      focusable=\"false\"\n      aria-hidden=\"true\"\n    >\n      <path\n        d=\"M294.31 16.348v8.985h-2.637v-9.261c0-2.76-1.104-3.987-3.619-3.987-2.453 0-4.14 1.626-4.14 4.723v8.525h-2.637V10h2.637v2.515c.982-1.81 2.791-2.822 4.846-2.822 3.526 0 5.55 2.423 5.55 6.655M274.168 5.952c0-1.165.766-1.84 1.84-1.84 1.073 0 1.84.675 1.84 1.84s-.767 1.84-1.84 1.84c-1.074 0-1.84-.675-1.84-1.84m.49 19.381V10h2.638v15.333zm-14.069-8.525v8.525h-2.637v-9.261c0-2.76-1.104-3.987-3.619-3.987-2.453 0-4.14 1.626-4.14 4.723v8.525h-2.637V10h2.637v2.515c.981-1.81 2.791-2.822 4.845-2.822 2.607 0 4.386 1.319 5.152 3.742.859-2.362 2.914-3.742 5.459-3.742 3.435 0 5.336 2.331 5.336 6.655v8.985h-2.637v-8.525c0-3.159-1.104-4.723-3.619-4.723-2.453 0-4.14 1.626-4.14 4.723m-28.327.859c0 3.68 1.472 5.52 4.202 5.52 2.361 0 4.477-1.503 4.477-4.907v-1.227c0-3.404-1.932-4.906-4.171-4.906-2.974 0-4.508 1.962-4.508 5.52m8.679 7.666v-2.76c-.981 2.024-2.821 3.067-5.183 3.067-4.078 0-6.133-3.465-6.133-7.973 0-4.324 2.147-7.974 6.44-7.974 2.239 0 3.956 1.012 4.876 3.006V3.59h2.637v21.742zm-22.021-4.017c-1.533 0-3.097-.184-4.814-.521l-1.687 4.538h-3.097l7.942-20.148h3.496l7.943 20.148h-3.097l-1.687-4.569c-1.809.368-3.373.552-4.999.552m0-2.453c1.288 0 2.607-.154 4.171-.399l-4.079-11.04-4.078 11.07c1.502.246 2.76.369 3.986.369\"\n        fill=\"".concat(colors.textColor, "\"\n      />\n      <path\n        d=\"M107.447 10.828c0 2.972 1.345 5.308 6.795 6.37 3.185.707 3.893 1.203 3.893 2.264 0 1.062-.708 1.699-2.973 1.699-2.619 0-5.733-.92-7.785-2.123v4.812c1.627.779 3.751 1.699 7.785 1.699 5.662 0 7.856-2.548 7.856-6.228m0 .07c0-3.538-1.84-5.166-7.148-6.299-2.902-.637-3.61-1.274-3.61-2.194 0-1.132 1.062-1.628 2.973-1.628 2.335 0 4.6.708 6.794 1.7V6.368c-1.557-.779-3.892-1.345-6.653-1.345-5.237 0-7.927 2.265-7.927 5.945m72.475-5.803v20.172h4.318V9.978l1.769 4.034 6.087 11.325h5.379V5.165h-4.247v13.023l-1.628-3.822-4.883-9.2zm-27.319 0h-4.671v20.172h4.671zm-10.05 14.155c0-3.538-1.841-5.166-7.149-6.298-2.902-.637-3.609-1.274-3.609-2.194 0-1.133 1.061-1.628 2.972-1.628 2.336 0 4.601.707 6.795 1.698v-4.6c-1.557-.779-3.893-1.345-6.653-1.345-5.238 0-7.927 2.265-7.927 5.945 0 2.973 1.345 5.309 6.794 6.37 3.185.708 3.893 1.203 3.893 2.265s-.708 1.699-2.973 1.699c-2.618 0-5.733-.92-7.785-2.124v4.813c1.628.779 3.751 1.699 7.785 1.699 5.592 0 7.857-2.548 7.857-6.3M71.069 5.165v20.172h9.625l1.486-4.389h-6.44V5.165zm-19.039 0v4.318h5.167v15.854h4.741V9.483h5.592V5.165zm-6.866 0h-6.157L32 25.336h5.379l.99-3.397c1.204.354 2.478.566 3.752.566s2.548-.212 3.751-.566l.991 3.397h5.379c-.07 0-7.078-20.17-7.078-20.17zM42.05 18.26c-.92 0-1.77-.142-2.548-.354L42.05 9.13l2.548 8.776a9.6 9.6 0 0 1-2.548.354M97.326 5.165H91.17l-7.08 20.171h5.38l.99-3.397c1.203.354 2.477.566 3.751.566s2.548-.212 3.751-.566l.991 3.397h5.379zM94.212 18.26c-.92 0-1.77-.142-2.548-.354l2.548-8.776 2.548 8.776a9.6 9.6 0 0 1-2.548.354m75.306-13.095h-6.157l-7.007 20.171h5.379l.991-3.397c1.203.354 2.477.566 3.751.566s2.548-.212 3.751-.566l.991 3.397h5.379zm-3.043 13.094c-.92 0-1.77-.142-2.548-.354l2.548-8.776 2.548 8.776a10 10 0 0 1-2.548.354M22.878 24.378 12.293 3.208c-.208-.458-.416-.541-.666-.541-.209 0-.459.083-.709.5-1.5 2.375-2.167 5.125-2.167 8 0 4.001 2.042 7.752 5.043 13.794.333.667.583.792 1.166.792h7.335c.542 0 .833-.208.833-.625 0-.208-.041-.333-.25-.75M7.501 14.377c-.833-1.25-1.083-1.334-1.292-1.334s-.333.083-.708.834L.208 24.46c-.166.334-.208.459-.208.625 0 .334.292.667.917.667h7.46c.5 0 .874-.416 1.083-1.208.25-1 .333-1.876.333-2.917 0-2.917-1.292-5.751-2.292-7.251z\"\n        fill=\"").concat(colors.iconColor, "\"\n      />\n    </svg>");
};
var $02204c990345b447$export$f845d9b9254f0541 = function AtlassianAdminLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Atlassian Admin' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $8onqJ.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $8onqJ.defaultLogoParams).textColor : _ref2$textColor, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $8onqJ.defaultLogoParams).iconColor : _ref2$iconColor;
    var _useThemeObserver = (0, $fDucD.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $cVyt1.default), {
        appearance: appearance,
        iconColor: iconColor,
        label: label,
        size: size,
        svg: $02204c990345b447$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("d1bks", function(module, exports) {
$parcel$export(module.exports, "AtlassianAdministrationIcon", () => $97a4280f75f7a22e$export$74517ed253186308);

var $5FkrB = parcelRequire("5FkrB");

var $fDucD = parcelRequire("fDucD");

var $8onqJ = parcelRequire("8onqJ");

var $cVyt1 = parcelRequire("cVyt1");

var $8oKXf = parcelRequire("8oKXf");
var $97a4280f75f7a22e$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor;
    var colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $8oKXf.getColorsFromAppearance)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" focusable=\"false\" aria-hidden=\"true\">\n      <path\n        d=\"M27.545 24.378 16.96 3.208c-.208-.458-.417-.541-.667-.541-.208 0-.458.083-.708.5-1.5 2.375-2.167 5.125-2.167 8 0 4.001 2.042 7.752 5.042 13.794.334.667.584.792 1.167.792h7.335c.541 0 .833-.208.833-.625 0-.208-.042-.333-.25-.75M12.168 14.377c-.834-1.25-1.084-1.334-1.292-1.334s-.333.083-.708.834L4.875 24.46c-.167.334-.208.459-.208.625 0 .334.291.667.916.667h7.46c.5 0 .875-.416 1.083-1.208.25-1 .334-1.876.334-2.917 0-2.917-1.292-5.751-2.292-7.251z\"\n        fill=\"".concat(colors.iconColor, "\"\n      />\n    </svg>");
};
var $97a4280f75f7a22e$export$74517ed253186308 = function AtlassianAdministrationIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Atlassian Administration' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $8onqJ.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $8onqJ.defaultLogoParams).textColor : _ref2$textColor, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $8onqJ.defaultLogoParams).iconColor : _ref2$iconColor;
    var _useThemeObserver = (0, $fDucD.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $cVyt1.default), {
        appearance: appearance,
        svg: $97a4280f75f7a22e$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        label: label,
        size: size,
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("5AUhS", function(module, exports) {
$parcel$export(module.exports, "AtlassianAdministrationLogo", () => $412bfa0d5894b3c6$export$833abe6c2ce5ebfd);

var $5FkrB = parcelRequire("5FkrB");

var $fDucD = parcelRequire("fDucD");

var $8onqJ = parcelRequire("8onqJ");

var $cVyt1 = parcelRequire("cVyt1");

var $8oKXf = parcelRequire("8oKXf");
var $412bfa0d5894b3c6$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $8oKXf.getColorsFromAppearance)(appearance, colorMode);
    return "<svg\n      fill=\"none\"\n      height=\"32\"\n      xmlns=\"http://www.w3.org/2000/svg\"\n      viewBox=\"0 0 404 32\"\n      focusable=\"false\"\n      aria-hidden=\"true\"\n    >\n      <path\n        d=\"M403.77 16.348v8.985h-2.637v-9.261c0-2.76-1.104-3.987-3.619-3.987-2.453 0-4.14 1.626-4.14 4.723v8.525h-2.637V10h2.637v2.515c.981-1.81 2.791-2.822 4.845-2.822 3.527 0 5.551 2.423 5.551 6.655m-23.336 9.292c-4.6 0-7.299-3.404-7.299-8.004s2.699-7.943 7.299-7.943c4.57 0 7.237 3.343 7.237 7.943s-2.667 8.004-7.237 8.004m0-13.493c-3.281 0-4.723 2.576-4.723 5.489s1.442 5.55 4.723 5.55c3.251 0 4.661-2.637 4.661-5.55s-1.41-5.49-4.661-5.49zm-13.488-6.195c0-1.165.767-1.84 1.84-1.84 1.074 0 1.84.675 1.84 1.84s-.766 1.84-1.84 1.84c-1.073 0-1.84-.675-1.84-1.84m.491 19.381V10h2.637v15.333zm-7.461-4.753c0 1.35.797 2.27 2.422 2.27.614 0 1.196-.123 1.656-.215v2.545a6.3 6.3 0 0 1-1.778.245c-3.282 0-4.876-1.932-4.876-4.784v-8.188h-2.484V10h2.484V6.75h2.576V10h4.078v2.453h-4.078zm-18.943-2.913c0 3.68 1.472 5.52 4.202 5.52 2.361 0 4.477-1.503 4.477-4.907v-1.227c0-3.404-1.932-4.906-4.171-4.906-2.974 0-4.508 1.962-4.508 5.52m8.679 7.666v-2.76c-.981 2.024-2.821 3.067-5.183 3.067-4.078 0-6.133-3.465-6.133-7.973 0-4.324 2.147-7.974 6.44-7.974 2.239 0 3.956 1.012 4.876 3.006V10h2.637v15.333zm-17.793-9.046v9.046h-2.576V10h2.576v2.699c.89-1.81 2.423-3.098 5.428-2.914v2.576c-3.373-.337-5.428.675-5.428 3.926m-10.037 4.293c0 1.35.797 2.27 2.423 2.27.613 0 1.196-.123 1.656-.215v2.545c-.46.123-.982.245-1.779.245-3.281 0-4.876-1.932-4.876-4.784v-8.188h-2.484V10h2.484V6.75h2.576V10h4.079v2.453h-4.079zm-6.696.583c0 2.545-1.656 4.477-5.765 4.477-2.3 0-4.171-.521-5.336-1.135v-2.79c1.319.766 3.527 1.502 5.459 1.502 2.024 0 3.066-.828 3.066-2.024 0-1.165-.889-1.84-3.802-2.545-3.404-.828-4.846-2.147-4.846-4.661 0-2.668 2.055-4.294 5.551-4.294 1.993 0 3.803.491 4.937 1.104v2.73c-1.84-.92-3.342-1.411-4.968-1.411-1.932 0-2.974.675-2.974 1.87 0 1.074.736 1.749 3.557 2.423 3.404.828 5.121 2.086 5.121 4.754M297.497 5.952c0-1.165.767-1.84 1.84-1.84 1.074 0 1.84.675 1.84 1.84s-.766 1.84-1.84 1.84c-1.073 0-1.84-.675-1.84-1.84m.491 19.381V10h2.637v15.333zm-3.678-8.985v8.985h-2.637v-9.261c0-2.76-1.104-3.987-3.619-3.987-2.453 0-4.14 1.626-4.14 4.723v8.525h-2.637V10h2.637v2.515c.982-1.81 2.791-2.822 4.846-2.822 3.526 0 5.55 2.423 5.55 6.655M274.168 5.952c0-1.165.766-1.84 1.84-1.84 1.073 0 1.84.675 1.84 1.84s-.767 1.84-1.84 1.84c-1.074 0-1.84-.675-1.84-1.84m.49 19.381V10h2.638v15.333zm-14.069-8.525v8.525h-2.637v-9.261c0-2.76-1.104-3.987-3.619-3.987-2.453 0-4.14 1.626-4.14 4.723v8.525h-2.637V10h2.637v2.515c.981-1.81 2.791-2.822 4.845-2.822 2.607 0 4.386 1.319 5.152 3.742.859-2.362 2.914-3.742 5.459-3.742 3.435 0 5.336 2.331 5.336 6.655v8.985h-2.637v-8.525c0-3.159-1.104-4.723-3.619-4.723-2.453 0-4.14 1.626-4.14 4.723m-28.327.859c0 3.68 1.472 5.52 4.202 5.52 2.361 0 4.477-1.503 4.477-4.907v-1.227c0-3.404-1.932-4.906-4.171-4.906-2.974 0-4.508 1.962-4.508 5.52m8.679 7.666v-2.76c-.981 2.024-2.821 3.067-5.183 3.067-4.078 0-6.133-3.465-6.133-7.973 0-4.324 2.147-7.974 6.44-7.974 2.239 0 3.956 1.012 4.876 3.006V3.59h2.637v21.742zm-22.021-4.017c-1.533 0-3.097-.184-4.814-.521l-1.687 4.538h-3.097l7.942-20.148h3.496l7.943 20.148h-3.097l-1.687-4.569c-1.809.368-3.373.552-4.999.552m0-2.453c1.288 0 2.607-.154 4.171-.399l-4.079-11.04-4.078 11.07c1.502.246 2.76.369 3.986.369\"\n        fill=\"".concat(colors.textColor, "\"\n      />\n      <path\n        d=\"M107.447 10.828c0 2.972 1.345 5.308 6.795 6.37 3.185.707 3.893 1.203 3.893 2.264 0 1.062-.708 1.699-2.973 1.699-2.619 0-5.733-.92-7.785-2.123v4.812c1.627.779 3.751 1.699 7.785 1.699 5.662 0 7.856-2.548 7.856-6.228m0 .07c0-3.538-1.84-5.166-7.148-6.299-2.902-.637-3.61-1.274-3.61-2.194 0-1.132 1.062-1.628 2.973-1.628 2.335 0 4.6.708 6.794 1.7V6.368c-1.557-.779-3.892-1.345-6.653-1.345-5.237 0-7.927 2.265-7.927 5.945m72.475-5.803v20.172h4.318V9.978l1.769 4.034 6.087 11.325h5.379V5.165h-4.247v13.023l-1.628-3.822-4.883-9.2zm-27.319 0h-4.671v20.172h4.671zm-10.05 14.155c0-3.538-1.841-5.166-7.149-6.298-2.902-.637-3.609-1.274-3.609-2.194 0-1.133 1.061-1.628 2.972-1.628 2.336 0 4.601.707 6.795 1.698v-4.6c-1.557-.779-3.893-1.345-6.653-1.345-5.238 0-7.927 2.265-7.927 5.945 0 2.973 1.345 5.309 6.794 6.37 3.185.708 3.893 1.203 3.893 2.265s-.708 1.699-2.973 1.699c-2.618 0-5.733-.92-7.785-2.124v4.813c1.628.779 3.751 1.699 7.785 1.699 5.592 0 7.857-2.548 7.857-6.3M71.069 5.165v20.172h9.625l1.486-4.389h-6.44V5.165zm-19.039 0v4.318h5.167v15.854h4.741V9.483h5.592V5.165zm-6.866 0h-6.157L32 25.336h5.379l.99-3.397c1.204.354 2.478.566 3.752.566s2.548-.212 3.751-.566l.991 3.397h5.379c-.07 0-7.078-20.17-7.078-20.17zM42.05 18.26c-.92 0-1.77-.142-2.548-.354L42.05 9.13l2.548 8.776a9.6 9.6 0 0 1-2.548.354M97.326 5.165H91.17l-7.08 20.171h5.38l.99-3.397c1.203.354 2.477.566 3.751.566s2.548-.212 3.751-.566l.991 3.397h5.379zM94.212 18.26c-.92 0-1.77-.142-2.548-.354l2.548-8.776 2.548 8.776a9.6 9.6 0 0 1-2.548.354m75.306-13.095h-6.157l-7.007 20.171h5.379l.991-3.397c1.203.354 2.477.566 3.751.566s2.548-.212 3.751-.566l.991 3.397h5.379zm-3.043 13.094c-.92 0-1.77-.142-2.548-.354l2.548-8.776 2.548 8.776a10 10 0 0 1-2.548.354M22.878 24.378 12.293 3.208c-.208-.458-.416-.541-.666-.541-.209 0-.459.083-.709.5-1.5 2.375-2.167 5.125-2.167 8 0 4.001 2.042 7.752 5.043 13.794.333.667.583.792 1.166.792h7.335c.542 0 .833-.208.833-.625 0-.208-.041-.333-.25-.75M7.501 14.377c-.833-1.25-1.083-1.334-1.292-1.334s-.333.083-.708.834L.208 24.46c-.166.334-.208.459-.208.625 0 .334.292.667.917.667h7.46c.5 0 .874-.416 1.083-1.208.25-1 .333-1.876.333-2.917 0-2.917-1.292-5.751-2.292-7.251z\"\n        fill=\"").concat(colors.iconColor, "\"\n      />\n    </svg>");
};
var $412bfa0d5894b3c6$export$833abe6c2ce5ebfd = function AtlassianAdministrationLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Atlassian Administration' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $8onqJ.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $8onqJ.defaultLogoParams).textColor : _ref2$textColor, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $8onqJ.defaultLogoParams).iconColor : _ref2$iconColor;
    var _useThemeObserver = (0, $fDucD.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $cVyt1.default), {
        appearance: appearance,
        iconColor: iconColor,
        label: label,
        size: size,
        svg: $412bfa0d5894b3c6$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("4tvuf", function(module, exports) {
$parcel$export(module.exports, "AtlassianAnalyticsIcon", () => $34224b7af8484c42$export$c42ad8a0b925c762);

var $5FkrB = parcelRequire("5FkrB");

var $7bQJE = parcelRequire("7bQJE");

var $fDucD = parcelRequire("fDucD");

var $8onqJ = parcelRequire("8onqJ");

var $cVyt1 = parcelRequire("cVyt1");

var $8oKXf = parcelRequire("8oKXf");
var $34224b7af8484c42$var$svg = function svg(_ref, colorMode, id) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor;
    var colors = {
        iconGradientStart: iconColor,
        iconGradientStop: iconColor,
        iconColor: iconColor
    };
    if (appearance) colors = (0, $8oKXf.getColorsFromAppearanceOldLogos)(appearance, colorMode);
    return "<svg height=\"32\" viewBox=\"0 0 48 48\" xmlns=\"http://www.w3.org/2000/svg\">\n  <defs>\n    <linearGradient id=\"".concat(id, "-a\" x1=\"12.595\" x2=\"12.595\" y1=\"40\" y2=\"30\" gradientUnits=\"userSpaceOnUse\">\n      <stop offset=\"0\" stop-color=\"").concat(colors.iconGradientStart, "\"/>\n      <stop offset=\"1\" stop-color=\"").concat(colors.iconGradientStop, "\"/>\n    </linearGradient>\n    <linearGradient id=\"").concat(id, "-b\" x1=\"28.595\" x2=\"28.595\" y1=\"40\" y2=\"27\" gradientUnits=\"userSpaceOnUse\">\n      <stop offset=\"0\" stop-color=\"").concat(colors.iconGradientStart, "\"/>\n      <stop offset=\"1\" stop-color=\"").concat(colors.iconGradientStop, "\"/>\n    </linearGradient>\n    <linearGradient xlink:href=\"#").concat(id, "-b\" id=\"").concat(id, "-c\" x1=\"20.595\" x2=\"20.595\" y2=\"22\"/>\n    <linearGradient xlink:href=\"#").concat(id, "-b\" id=\"").concat(id, "-d\" x1=\"36.595\" x2=\"36.595\" y2=\"20\"/>\n  </defs>\n  <path d=\"M10.595 30h4v10h-4z\" fill=\"url(#").concat(id, "-a)\"/>\n  <path d=\"M26.595 27h4v13h-4z\" fill=\"url(#").concat(id, "-b)\"/>\n  <path d=\"M18.595 22h4v18h-4z\" fill=\"url(#").concat(id, "-c)\"/>\n  <path d=\"M34.595 20h4v20h-4z\" fill=\"url(#").concat(id, "-d)\"/>\n  <path fill=\"").concat(colors.iconColor, "\" d=\"m9.009 25.414-2.828-2.828 10.127-10.128a5 5 0 0 1 6.605-.411l4.471 3.477a1.5 1.5 0 0 0 1.982-.123l9.815-9.815 2.828 2.828-10.127 10.128a5 5 0 0 1-6.605.411l-4.471-3.477a1.5 1.5 0 0 0-1.982.123l-9.815 9.815Z\" />\n</svg>");
};
var $34224b7af8484c42$export$c42ad8a0b925c762 = function AtlassianAnalyticsIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Atlassian Analytics' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $8onqJ.defaultLogoParams).size : _ref2$size, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $8onqJ.defaultLogoParams).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $8onqJ.defaultLogoParams).textColor : _ref2$textColor, testId = _ref2.testId;
    var _useThemeObserver = (0, $fDucD.default)(), colorMode = _useThemeObserver.colorMode;
    var id = (0, $7bQJE.useId)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $cVyt1.default), {
        appearance: appearance,
        label: label,
        svg: $34224b7af8484c42$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode, id),
        iconColor: iconColor,
        textColor: textColor,
        size: size,
        testId: testId
    });
};

});
parcelRegister("7bQJE", function(module, exports) {
$parcel$export(module.exports, "useId", () => $53c27799446f3b75$export$f680877a34711e37);

var $5FkrB = parcelRequire("5FkrB");
function $53c27799446f3b75$export$f680877a34711e37() {
    // React uses `:` or `«»` in selectors which breaks `document.querySelector(…)`.
    // Replace with `_` to match future React 19 functionality.
    return (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).useId().replace(/[:«»]/g, '_');
}

});


parcelRegister("auCk2", function(module, exports) {
$parcel$export(module.exports, "AtlassianAnalyticsLogo", () => $7a3a6eb3b1e795cf$export$e6470bfc39010cc4);

var $5FkrB = parcelRequire("5FkrB");

var $7bQJE = parcelRequire("7bQJE");

var $fDucD = parcelRequire("fDucD");

var $8onqJ = parcelRequire("8onqJ");

var $cVyt1 = parcelRequire("cVyt1");

var $8oKXf = parcelRequire("8oKXf");
var $7a3a6eb3b1e795cf$var$svg = function svg(_ref, colorMode, id) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconGradientStart: iconColor,
        iconGradientStop: iconColor,
        textColor: textColor,
        iconColor: iconColor,
        // We treat the word "Atlassian" differently to normal app logos, it has a bold brand look
        atlassianLogoTextColor: textColor
    };
    if (appearance) colors = (0, $8oKXf.getColorsFromAppearanceOldLogos)(appearance, colorMode);
    return "\n  <svg height=\"32\" viewBox=\"0 0 477 48\" xmlns=\"http://www.w3.org/2000/svg\">\n  <defs>\n    <linearGradient id=\"".concat(id, "-a\" x1=\"447.285\" x2=\"447.285\" y1=\"40\" y2=\"30\" gradientUnits=\"userSpaceOnUse\">\n      <stop offset=\"0\" stop-color=\"").concat(colors.iconGradientStart, "\"/>\n      <stop offset=\"1\" stop-color=\"").concat(colors.iconGradientStop, "\"/>\n    </linearGradient>\n    <linearGradient xlink:href=\"#").concat(id, "-a\" id=\"").concat(id, "-b\" x1=\"463.285\" x2=\"463.285\" y2=\"27\"/>\n    <linearGradient xlink:href=\"#").concat(id, "-a\" id=\"").concat(id, "-c\" x1=\"455.285\" x2=\"455.285\" y2=\"22\"/>\n    <linearGradient xlink:href=\"#").concat(id, "-a\" id=\"").concat(id, "-d\" x1=\"471.285\" x2=\"471.285\" y2=\"20\"/>\n  </defs>\n  <g fill=\"").concat(colors.atlassianLogoTextColor, "\">\n    <path d=\"M106.72 18.359c0 4.201 1.949 7.536 9.572 9.008 4.548.953 5.5 1.689 5.5 3.205 0 1.473-.953 2.425-4.158 2.425-3.725 0-8.142-1.256-11.044-2.988v6.843c2.295 1.126 5.327 2.382 10.957 2.382 7.969 0 11.131-3.551 11.131-8.835m0 0c0-4.981-2.642-7.319-10.091-8.922-4.114-.91-5.111-1.819-5.111-3.118 0-1.646 1.473-2.339 4.201-2.339 3.292 0 6.54.996 9.615 2.382v-6.54c-2.166-1.083-5.5-1.949-9.398-1.949-7.363 0-11.174 3.205-11.174 8.445M209.1 10.346v28.455h6.063V17.103l2.556 5.76 8.575 15.938h7.623V10.346h-6.064V28.71l-2.295-5.327-6.886-13.037H209.1zM163.909 10.346h6.626v28.455h-6.626zM156.263 30.399c0-4.981-2.642-7.319-10.091-8.922-4.114-.91-5.111-1.819-5.111-3.118 0-1.646 1.473-2.339 4.201-2.339 3.292 0 6.54.996 9.615 2.382v-6.54c-2.166-1.083-5.5-1.949-9.398-1.949-7.363 0-11.174 3.205-11.174 8.445 0 4.201 1.949 7.536 9.572 9.008 4.548.953 5.5 1.689 5.5 3.205 0 1.473-.953 2.425-4.158 2.425-3.725 0-8.142-1.256-11.044-2.988v6.843c2.295 1.126 5.327 2.382 10.957 2.382 7.969 0 11.131-3.551 11.131-8.835M55.243 10.346v28.455h13.62l2.145-6.15h-9.095V10.346h-6.67zM28.334 10.346v6.15h7.363v22.305h6.67V16.496h7.882v-6.15H28.334zM18.663 10.346h-8.74L0 38.801h7.579l1.407-4.792a18.852 18.852 0 0 0 10.612 0l1.407 4.792h7.579l-9.922-28.455Zm-4.37 18.533c-1.267 0-2.49-.185-3.647-.524l3.647-12.422 3.647 12.422c-1.157.339-2.38.524-3.647.524ZM92.344 10.346h-8.74l-9.922 28.455h7.579l1.407-4.792a18.852 18.852 0 0 0 10.612 0l1.407 4.792h7.579l-9.922-28.455Zm-4.37 18.533c-1.267 0-2.49-.185-3.647-.524l3.647-12.422 3.647 12.422c-1.157.339-2.38.524-3.647.524ZM194.414 10.346h-8.74l-9.922 28.455h7.579l1.407-4.792a18.852 18.852 0 0 0 10.612 0l1.407 4.792h7.579l-9.922-28.455Zm-4.37 18.533c-1.267 0-2.49-.185-3.647-.524l3.647-12.422 3.647 12.422c-1.157.339-2.38.524-3.647.524Z\"/>\n  </g>\n  <g fill=\"").concat(colors.textColor, "\">\n    <path d=\"m254.776 31.987-2.53 6.809H247.6l11.916-30.225h5.244l11.916 30.225h-4.646l-2.53-6.855c-2.714.552-5.061.828-7.499.828-2.3 0-4.646-.276-7.223-.782Zm13.479-3.496-6.119-16.562-6.119 16.608c2.254.368 4.141.552 5.98.552 1.933 0 3.911-.23 6.257-.598ZM298.984 38.796h-3.957V24.902c0-4.141-1.656-5.981-5.428-5.981-3.681 0-6.211 2.438-6.211 7.085v12.79h-3.957V15.794h3.957v3.772c1.472-2.715 4.187-4.232 7.269-4.232 5.291 0 8.327 3.634 8.327 9.983v13.479ZM320.097 34.656c-1.472 3.036-4.232 4.6-7.775 4.6-6.119 0-9.201-5.199-9.201-11.961 0-6.486 3.22-11.961 9.661-11.961 3.358 0 5.935 1.518 7.314 4.508v-4.048h3.957v23.002h-3.957v-4.14Zm-6.717.92c3.542 0 6.717-2.254 6.717-7.361v-1.84c0-5.106-2.898-7.361-6.256-7.361-4.463 0-6.763 2.944-6.763 8.281 0 5.521 2.208 8.281 6.303 8.281ZM336.196 38.935c-3.772 0-6.165-1.794-6.165-6.027V6.179h3.957v26.269c0 2.07 1.38 2.806 3.083 2.806.414 0 .69 0 1.15-.046v3.542c-.322.092-1.012.184-2.024.184ZM347.328 37.324l-8.327-21.53h4.232l7.361 19.69 7.361-19.69h4.232l-8.695 22.267c-2.576 6.579-4.048 9.983-9.891 9.983-1.979 0-3.083-.184-4.232-.644v-3.404c1.334.414 2.852.552 4.002.552 3.22 0 4.646-2.208 6.533-7.223h-2.576ZM374.698 35.07c.92 0 1.794-.185 2.484-.322v3.818c-.69.184-1.472.368-2.668.368-4.923 0-7.315-2.898-7.315-7.177V19.473h-3.727v-3.68h3.727v-4.877h3.864v4.877h6.119v3.68h-6.119v12.191c0 2.024 1.196 3.405 3.635 3.405ZM384.265 6.961c1.61 0 2.76 1.012 2.76 2.76s-1.15 2.76-2.76 2.76-2.76-1.012-2.76-2.76 1.15-2.76 2.76-2.76Zm-2.024 8.833h3.957v23.002h-3.957V15.794ZM408.416 38.198c-1.38.736-3.496 1.058-5.612 1.058-8.189 0-12.007-4.968-12.007-12.007 0-6.947 3.818-11.915 12.007-11.915 2.07 0 3.68.276 5.475 1.104v3.681c-1.472-.69-3.037-1.104-5.199-1.104-5.98 0-8.419 3.772-8.419 8.235s2.484 8.235 8.511 8.235c2.346 0 3.818-.322 5.244-.828v3.542ZM420.144 39.256c-3.451 0-6.257-.782-8.005-1.702v-4.187c1.978 1.15 5.291 2.254 8.188 2.254 3.037 0 4.601-1.242 4.601-3.036 0-1.749-1.334-2.761-5.705-3.818-5.106-1.242-7.269-3.221-7.269-6.993 0-4.002 3.082-6.44 8.327-6.44 2.99 0 5.705.736 7.407 1.656v4.094c-2.76-1.38-5.014-2.117-7.453-2.117-2.898 0-4.462 1.013-4.462 2.807 0 1.61 1.104 2.622 5.336 3.635 5.106 1.242 7.683 3.128 7.683 7.13 0 3.819-2.484 6.717-8.649 6.717Z\"/>\n  </g>\n  <path fill=\"url(#").concat(id, "-a)\" d=\"M445.285 30h4v10h-4z\"/>\n  <path fill=\"url(#").concat(id, "-b)\" d=\"M461.285 27h4v13h-4z\"/>\n  <path fill=\"url(#").concat(id, "-c)\" d=\"M453.285 22h4v18h-4z\"/>\n  <path fill=\"url(#").concat(id, "-d)\" d=\"M469.285 20h4v20h-4z\"/>\n  <path fill=\"").concat(colors.iconColor, "\" d=\"m443.699 25.414-2.828-2.828 10.127-10.128a5 5 0 0 1 6.605-.411l4.471 3.477a1.5 1.5 0 0 0 1.982-.123l9.815-9.815 2.828 2.828-10.127 10.128a5 5 0 0 1-6.605.411l-4.471-3.477a1.5 1.5 0 0 0-1.982.123l-9.815 9.815Z\"/>\n</svg>");
};
var $7a3a6eb3b1e795cf$export$e6470bfc39010cc4 = function AtlassianAnalyticsLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Atlassian Analytics' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $8onqJ.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $8onqJ.defaultLogoParams).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $8onqJ.defaultLogoParams).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $fDucD.default)(), colorMode = _useThemeObserver.colorMode;
    var id = (0, $7bQJE.useId)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $cVyt1.default), {
        appearance: appearance,
        label: label,
        size: size,
        iconColor: iconColor,
        svg: $7a3a6eb3b1e795cf$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode, id),
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("6FLNG", function(module, exports) {
$parcel$export(module.exports, "BitbucketIcon", () => $4dbba68b0e2d177f$export$5fc1066e677788d4);

var $5FkrB = parcelRequire("5FkrB");

var $fDucD = parcelRequire("fDucD");

var $8onqJ = parcelRequire("8onqJ");

var $cVyt1 = parcelRequire("cVyt1");

var $8oKXf = parcelRequire("8oKXf");
var $4dbba68b0e2d177f$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor;
    var colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $8oKXf.getColorsFromAppearance)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" viewBox=\"0 0 32 32\" focusable=\"false\" aria-hidden=\"true\" xmlns=\"http://www.w3.org/2000/svg\">\n      <path fill=".concat(colors.iconColor, " d=\"m25.586 15.819-1.618 9.885c-.106.598-.528.95-1.126.95H9.122c-.598 0-1.02-.352-1.126-.95L5.146 8.08c-.105-.598.212-.985.775-.985h20.123c.562 0 .88.387.773.985l-.773 4.644c-.106.668-.493.95-1.126.95H12.816c-.176 0-.282.105-.246.316l.95 5.84c.035.14.14.246.281.246h4.362c.141 0 .246-.105.282-.246l.668-4.222c.07-.527.422-.738.915-.738h4.75c.703 0 .914.351.808.95\"/>\n    </svg>");
};
var $4dbba68b0e2d177f$export$5fc1066e677788d4 = function BitbucketIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Bitbucket' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $8onqJ.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $8onqJ.defaultLogoParams).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $8onqJ.defaultLogoParams).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $fDucD.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $cVyt1.default), {
        appearance: appearance,
        label: label,
        svg: $4dbba68b0e2d177f$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("iGLN6", function(module, exports) {
$parcel$export(module.exports, "BitbucketLogo", () => $d9b1388a5ad29f00$export$bd40525f5333524b);

var $5FkrB = parcelRequire("5FkrB");

var $fDucD = parcelRequire("fDucD");

var $8onqJ = parcelRequire("8onqJ");

var $cVyt1 = parcelRequire("cVyt1");

var $8oKXf = parcelRequire("8oKXf");
var $d9b1388a5ad29f00$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $8oKXf.getColorsFromAppearance)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" viewBox=\"0 0 158 32\" focusable=\"false\" aria-hidden=\"true\" xmlns=\"http://www.w3.org/2000/svg\">\n        <path fill=".concat(colors.iconColor, " d=\"m20.46 15.152-1.619 9.885c-.105.598-.527.95-1.125.95H3.996c-.599 0-1.02-.352-1.126-.95L.02 7.412c-.105-.598.211-.985.774-.985h20.123c.563 0 .88.387.774.985l-.774 4.644c-.106.668-.493.95-1.126.95H7.69c-.176 0-.281.105-.246.316l.95 5.84c.035.141.14.247.281.247h4.363c.14 0 .246-.106.281-.247l.668-4.221c.07-.528.423-.739.915-.739h4.75c.703 0 .914.352.809.95\"/>\n        <path fill=").concat(colors.textColor, " d=\"M153.212 20.787c0 1.35.797 2.27 2.422 2.27.614 0 1.196-.123 1.656-.215v2.545c-.46.123-.981.245-1.778.245-3.282 0-4.876-1.932-4.876-4.784v-8.187h-2.484v-2.454h2.484v-3.25h2.576v3.25h4.078v2.453h-4.078zm-13.537-8.494c-2.791 0-4.201 1.809-4.477 4.477h8.556c-.154-2.852-1.442-4.477-4.079-4.477m5.888 12.634c-1.257.675-3.189.92-4.753.92-5.735 0-8.25-3.312-8.25-8.004 0-4.63 2.576-7.942 7.238-7.942 4.722 0 6.624 3.281 6.624 7.942v1.196h-11.194c.368 2.607 2.055 4.294 5.674 4.294 1.778 0 3.281-.338 4.661-.828zm-23.82.613h-2.638V3.799h2.638v13.585l6.593-7.176h3.435l-7.207 7.544 7.513 7.79h-3.588l-6.746-7.176zm-5.648-2.76v2.362c-.92.49-2.331.705-3.742.705-5.458 0-8.004-3.312-8.004-8.004 0-4.63 2.546-7.942 8.004-7.942 1.38 0 2.454.184 3.65.736v2.453c-.982-.46-2.024-.736-3.466-.736-3.986 0-5.612 2.515-5.612 5.49s1.656 5.489 5.674 5.489c1.564 0 2.545-.215 3.496-.552m-27.843-3.588v-8.986h2.637v9.262c0 2.76 1.104 3.986 3.619 3.986 2.453 0 4.14-1.625 4.14-4.722v-8.526h2.637v15.334h-2.637v-2.515c-.982 1.81-2.79 2.821-4.846 2.821-3.526 0-5.55-2.422-5.55-6.654m-5.388-1.319c0-3.68-1.472-5.52-4.201-5.52-2.362 0-4.478 1.503-4.478 4.907v1.226c0 3.404 1.932 4.907 4.171 4.907 2.975 0 4.508-1.963 4.508-5.52m-3.803 7.973c-2.238 0-3.956-1.012-4.876-3.005v2.699h-2.637V3.798h2.637v9.17c.982-2.025 2.822-3.067 5.183-3.067 4.079 0 6.133 3.465 6.133 7.973 0 4.324-2.146 7.973-6.44 7.973m-14.974-5.06c0 1.35.797 2.27 2.422 2.27.614 0 1.196-.123 1.656-.215v2.545a6.3 6.3 0 0 1-1.778.245c-3.282 0-4.876-1.932-4.876-4.784v-8.187h-2.484v-2.454h2.484v-3.25h2.576v3.25h4.078v2.453h-4.078zM53.328 6.16c0-1.166.767-1.84 1.84-1.84s1.84.674 1.84 1.84S56.242 8 55.168 8s-1.84-.676-1.84-1.84m.49 19.38V10.207h2.638V25.54zm-9.828-9.046h-6.194v6.287h6.256c2.637 0 3.833-.951 3.833-2.975 0-2.147-1.134-3.312-3.894-3.312m-.889-8.464h-5.305v6.01h5.305c2.607 0 3.68-1.195 3.68-3.127 0-1.963-1.165-2.883-3.68-2.883m-8.065 17.51V5.394h8.433c4.11 0 6.103 2.024 6.103 5.274 0 2.423-1.104 3.926-3.373 4.478 2.974.49 4.446 2.116 4.446 4.968 0 3.22-2.177 5.428-6.685 5.428z\"/>\n      </svg>");
};
var $d9b1388a5ad29f00$export$bd40525f5333524b = function BitbucketLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Bitbucket' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $8onqJ.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $8onqJ.defaultLogoParams).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $8onqJ.defaultLogoParams).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $fDucD.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $cVyt1.default), {
        appearance: appearance,
        label: label,
        iconColor: iconColor,
        size: size,
        svg: $d9b1388a5ad29f00$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("beTKF", function(module, exports) {
$parcel$export(module.exports, "CompassIcon", () => $82ec3faa3f0368a6$export$f7857fe64d7161d9);

var $5FkrB = parcelRequire("5FkrB");

var $fDucD = parcelRequire("fDucD");

var $8onqJ = parcelRequire("8onqJ");

var $cVyt1 = parcelRequire("cVyt1");

var $8oKXf = parcelRequire("8oKXf");
var $82ec3faa3f0368a6$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor;
    var colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $8oKXf.getColorsFromAppearance)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" viewBox=\"0 0 32 32\" focusable=\"false\" aria-hidden=\"true\" xmlns=\"http://www.w3.org/2000/svg\">\n      <path fill=\"".concat(colors.iconColor, "\" d=\"M15.667 15.66v5.942H9.713V15.66zV9.722H4.807c-.58.004-1.047.47-1.043 1.04v15.755a1.04 1.04 0 0 0 1.028 1.054h15.771a1.04 1.04 0 0 0 1.042-1.04V15.66zm0-11.88v5.942h5.967v5.938h5.935V4.82a1.04 1.04 0 0 0-1.028-1.053h-.014z\"/>\n      </svg>\n    ");
};
var $82ec3faa3f0368a6$export$f7857fe64d7161d9 = function CompassIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Compass' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $8onqJ.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $8onqJ.defaultLogoParams).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $8onqJ.defaultLogoParams).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $fDucD.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $cVyt1.default), {
        appearance: appearance,
        label: label,
        svg: $82ec3faa3f0368a6$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("kikns", function(module, exports) {
$parcel$export(module.exports, "CompassLogo", () => $ec654b9e2387dfd0$export$eb7d748e4f9c9676);

var $5FkrB = parcelRequire("5FkrB");

var $fDucD = parcelRequire("fDucD");

var $8onqJ = parcelRequire("8onqJ");

var $cVyt1 = parcelRequire("cVyt1");

var $8oKXf = parcelRequire("8oKXf");
var $ec654b9e2387dfd0$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $8oKXf.getColorsFromAppearance)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" viewBox=\"0 0 155 32\" focusable=\"false\" aria-hidden=\"true\" xmlns=\"http://www.w3.org/2000/svg\">\n    <path fill=".concat(colors.iconColor, " d=\"M11.903 14.993v5.942H5.95v-5.942zV9.055H1.043c-.58.004-1.047.47-1.043 1.04v15.756a1.04 1.04 0 0 0 1.028 1.054H16.8a1.04 1.04 0 0 0 1.043-1.04V14.993zm0-11.879v5.941h5.967v5.938h5.936V4.153A1.04 1.04 0 0 0 22.778 3.1h-.015z\"/>\n    <path fill=\"").concat(colors.textColor, "\" d=\"M154.46 21.37c0 2.545-1.656 4.477-5.765 4.477-2.3 0-4.171-.521-5.336-1.134v-2.791c1.318.767 3.526 1.503 5.458 1.503 2.024 0 3.067-.828 3.067-2.024 0-1.166-.889-1.84-3.803-2.546-3.404-.828-4.845-2.146-4.845-4.661 0-2.668 2.055-4.293 5.551-4.293 1.993 0 3.802.49 4.937 1.104v2.729c-1.84-.92-3.343-1.41-4.968-1.41-1.932 0-2.975.674-2.975 1.87 0 1.073.736 1.748 3.558 2.423 3.404.828 5.121 2.085 5.121 4.753m-13.626 0c0 2.545-1.656 4.477-5.766 4.477-2.3 0-4.17-.521-5.336-1.134v-2.791c1.319.767 3.527 1.503 5.459 1.503 2.024 0 3.067-.828 3.067-2.024 0-1.166-.89-1.84-3.803-2.546-3.404-.828-4.845-2.146-4.845-4.661 0-2.668 2.054-4.293 5.55-4.293 1.994 0 3.803.49 4.938 1.104v2.729c-1.84-.92-3.343-1.41-4.968-1.41-1.932 0-2.975.674-2.975 1.87 0 1.073.736 1.748 3.557 2.423 3.404.828 5.122 2.085 5.122 4.753m-25.873-3.496c0 3.68 1.472 5.52 4.201 5.52 2.361 0 4.477-1.503 4.477-4.907v-1.226c0-3.404-1.932-4.907-4.17-4.907-2.975 0-4.508 1.963-4.508 5.52m8.678 7.667v-2.76c-.981 2.024-2.821 3.066-5.182 3.066-4.079 0-6.134-3.465-6.134-7.973 0-4.324 2.147-7.973 6.44-7.973 2.239 0 3.956 1.012 4.876 3.005v-2.699h2.638v15.334zm-16.09-7.667c0-3.68-1.472-5.52-4.201-5.52-2.362 0-4.478 1.503-4.478 4.907v1.226c0 3.404 1.932 4.907 4.171 4.907 2.975 0 4.508-1.963 4.508-5.52m-3.803 7.973c-2.238 0-3.956-1.012-4.876-3.005v8.679h-2.637V10.207h2.637v2.76c.982-2.024 2.822-3.066 5.183-3.066 4.079 0 6.133 3.465 6.133 7.973 0 4.324-2.146 7.973-6.44 7.973m-21.583-8.832v8.526h-2.637v-9.262c0-2.76-1.104-3.986-3.619-3.986-2.453 0-4.14 1.625-4.14 4.722v8.526H69.13V10.207h2.637v2.515c.982-1.81 2.791-2.821 4.846-2.821 2.606 0 4.385 1.318 5.152 3.741.858-2.361 2.913-3.741 5.458-3.741 3.435 0 5.336 2.33 5.336 6.654v8.986h-2.637v-8.526c0-3.158-1.104-4.722-3.619-4.722-2.453 0-4.14 1.625-4.14 4.722m-23.335 8.832c-4.6 0-7.299-3.404-7.299-8.004s2.699-7.942 7.299-7.942c4.57 0 7.237 3.342 7.237 7.942s-2.668 8.004-7.237 8.004m0-13.493c-3.282 0-4.723 2.576-4.723 5.49s1.441 5.55 4.723 5.55c3.25 0 4.661-2.637 4.661-5.55s-1.41-5.49-4.661-5.49m-9.233 9.629v2.668c-1.258.828-3.251 1.196-5.336 1.196-6.624 0-10.366-3.986-10.366-10.334 0-6.134 3.742-10.427 10.304-10.427 1.963 0 3.926.368 5.367 1.41v2.669c-1.441-.92-3.036-1.411-5.367-1.411-4.722 0-7.544 3.128-7.544 7.759s2.914 7.697 7.698 7.697c2.116 0 3.772-.49 5.244-1.227\"/>\n  </svg>");
};
var $ec654b9e2387dfd0$export$eb7d748e4f9c9676 = function CompassLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Compass' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $8onqJ.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $8onqJ.defaultLogoParams).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $8onqJ.defaultLogoParams).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $fDucD.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $cVyt1.default), {
        appearance: appearance,
        label: label,
        iconColor: iconColor,
        size: size,
        svg: $ec654b9e2387dfd0$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("1VIl7", function(module, exports) {
$parcel$export(module.exports, "ConfluenceIcon", () => $167d8239415b0009$export$68f3db7f6af48bcb);

var $5FkrB = parcelRequire("5FkrB");

var $fDucD = parcelRequire("fDucD");

var $8onqJ = parcelRequire("8onqJ");

var $cVyt1 = parcelRequire("cVyt1");

var $8oKXf = parcelRequire("8oKXf");
var $167d8239415b0009$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor;
    var colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $8oKXf.getColorsFromAppearance)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" viewBox=\"0 0 32 32\" focusable=\"false\" aria-hidden=\"true\" xmlns=\"http://www.w3.org/2000/svg\">\n      <path fill=\"".concat(colors.iconColor, "\" d=\"M25.769 20.234c-6.584-3.183-8.507-3.66-11.282-3.66-3.254 0-6.028 1.355-8.507 5.16l-.406.622c-.333.513-.407.696-.407.915s.11.403.517.659l4.18 2.598c.222.146.407.22.592.22.222 0 .37-.11.592-.44l.665-1.024c1.036-1.574 1.96-2.086 3.144-2.086 1.036 0 2.257.293 3.773 1.025l4.365 2.049c.443.22.924.11 1.146-.403l2.071-4.537c.222-.512.074-.842-.444-1.098M6.572 12.22c6.584 3.184 8.507 3.66 11.281 3.66 3.255 0 6.03-1.354 8.507-5.16l.407-.622c.333-.512.407-.695.407-.915s-.11-.402-.518-.658l-4.18-2.598c-.221-.147-.406-.22-.591-.22-.222 0-.37.11-.592.44l-.666 1.024c-1.035 1.573-1.96 2.086-3.144 2.086-1.035 0-2.256-.293-3.772-1.025L9.346 6.183c-.444-.22-.924-.11-1.146.402l-2.072 4.538c-.222.512-.074.841.444 1.098\"/>\n    </svg>");
};
var $167d8239415b0009$export$68f3db7f6af48bcb = function ConfluenceIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Confluence' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $8onqJ.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $8onqJ.defaultLogoParams).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $8onqJ.defaultLogoParams).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $fDucD.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $cVyt1.default), {
        appearance: appearance,
        label: label,
        svg: $167d8239415b0009$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("cFIJ9", function(module, exports) {
$parcel$export(module.exports, "ConfluenceLogo", () => $939c0243cabcce21$export$1b2e4fe6ef471556);

var $5FkrB = parcelRequire("5FkrB");

var $fDucD = parcelRequire("fDucD");

var $8onqJ = parcelRequire("8onqJ");

var $cVyt1 = parcelRequire("cVyt1");

var $8oKXf = parcelRequire("8oKXf");
var $939c0243cabcce21$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $8oKXf.getColorsFromAppearance)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" viewBox=\"0 0 180 32\" focusable=\"false\" aria-hidden=\"true\" xmlns=\"http://www.w3.org/2000/svg\">\n      <path fill=\"".concat(colors.iconColor, "\" d=\"M20.602 20.234c-6.584-3.183-8.507-3.66-11.281-3.66-3.255 0-6.03 1.355-8.507 5.16l-.407.622c-.333.513-.407.696-.407.915s.111.403.518.659l4.18 2.598c.221.146.406.22.591.22.222 0 .37-.11.592-.44l.666-1.024c1.035-1.574 1.96-2.086 3.144-2.086 1.035 0 2.256.293 3.772 1.025l4.365 2.049c.444.22.925.11 1.146-.403l2.072-4.537c.222-.512.074-.842-.444-1.098M1.406 12.22c6.583 3.184 8.507 3.66 11.28 3.66 3.256 0 6.03-1.354 8.508-5.16l.407-.622c.332-.512.406-.695.406-.915s-.11-.402-.518-.658L17.31 5.927c-.222-.147-.407-.22-.592-.22-.222 0-.37.11-.592.44l-.665 1.024c-1.036 1.573-1.96 2.086-3.144 2.086-1.036 0-2.257-.293-3.773-1.025L4.18 6.183c-.444-.22-.925-.11-1.147.402L.962 11.123c-.222.512-.074.841.444 1.098\"/>\n      <path fill=\"").concat(colors.textColor, "\" d=\"M172.49 12.293c-2.791 0-4.201 1.809-4.477 4.477h8.556c-.154-2.852-1.442-4.477-4.079-4.477m5.888 12.634c-1.257.675-3.189.92-4.753.92-5.735 0-8.25-3.312-8.25-8.004 0-4.63 2.576-7.942 7.238-7.942 4.722 0 6.624 3.281 6.624 7.942v1.196h-11.194c.368 2.607 2.055 4.294 5.674 4.294 1.778 0 3.281-.338 4.661-.828zm-15.093-2.147v2.362c-.92.49-2.331.705-3.742.705-5.458 0-8.004-3.312-8.004-8.004 0-4.63 2.546-7.942 8.004-7.942 1.38 0 2.454.184 3.65.736v2.453c-.982-.46-2.024-.736-3.466-.736-3.986 0-5.612 2.515-5.612 5.49s1.656 5.489 5.674 5.489c1.564 0 2.545-.215 3.496-.552m-14.503-6.226v8.986h-2.637v-9.262c0-2.76-1.104-3.986-3.619-3.986-2.453 0-4.14 1.625-4.14 4.722v8.526h-2.637V10.207h2.637v2.515c.981-1.81 2.791-2.821 4.845-2.821 3.527 0 5.551 2.422 5.551 6.654m-22.921-4.262c-2.79 0-4.201 1.809-4.477 4.477h8.556c-.154-2.852-1.441-4.477-4.079-4.477m5.888 12.634c-1.257.675-3.189.92-4.753.92-5.735 0-8.249-3.312-8.249-8.004 0-4.63 2.576-7.942 7.237-7.942 4.723 0 6.624 3.281 6.624 7.942v1.196h-11.193c.368 2.607 2.054 4.294 5.673 4.294 1.778 0 3.281-.338 4.661-.828zm-29.1-5.734v-8.986h2.637v9.262c0 2.76 1.104 3.986 3.619 3.986 2.453 0 4.14-1.625 4.14-4.722v-8.526h2.637v15.334h-2.637v-2.515c-.981 1.81-2.791 2.821-4.845 2.821-3.527 0-5.551-2.422-5.551-6.654m-2.231 6.317c-.215.061-.674.122-1.35.122-2.514 0-4.108-1.196-4.108-4.017V3.798h2.637v17.51c0 1.38.92 1.871 2.055 1.871.275 0 .459 0 .766-.03zM88.157 8.582v1.625h3.956v2.454h-3.956v12.88h-2.576V12.66h-2.484v-2.454h2.484V8.521c0-2.852 1.595-4.784 4.876-4.784a6.3 6.3 0 0 1 1.779.245v2.423a8.7 8.7 0 0 0-1.656-.154c-1.626 0-2.423.95-2.423 2.33m-7.327 7.974v8.986h-2.637v-9.262c0-2.76-1.104-3.986-3.619-3.986-2.453 0-4.14 1.625-4.14 4.722v8.526h-2.637V10.207h2.637v2.515c.981-1.81 2.79-2.821 4.845-2.821 3.527 0 5.551 2.422 5.551 6.654m-23.336 9.292c-4.6 0-7.298-3.404-7.298-8.004s2.698-7.942 7.298-7.942c4.57 0 7.238 3.342 7.238 7.942s-2.668 8.004-7.238 8.004m0-13.493c-3.28 0-4.722 2.576-4.722 5.49s1.441 5.55 4.722 5.55c3.251 0 4.662-2.637 4.662-5.55s-1.41-5.49-4.662-5.49m-9.233 9.629v2.668c-1.257.828-3.25 1.196-5.336 1.196-6.624 0-10.365-3.986-10.365-10.334 0-6.134 3.741-10.427 10.304-10.427 1.963 0 3.925.368 5.367 1.41v2.669c-1.442-.92-3.036-1.411-5.367-1.411-4.723 0-7.544 3.128-7.544 7.759s2.913 7.697 7.697 7.697c2.116 0 3.772-.49 5.244-1.227\"/>\n    </svg>\n    ");
};
var $939c0243cabcce21$export$1b2e4fe6ef471556 = function ConfluenceLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Confluence' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $8onqJ.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $8onqJ.defaultLogoParams).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $8onqJ.defaultLogoParams).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $fDucD.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $cVyt1.default), {
        appearance: appearance,
        label: label,
        iconColor: iconColor,
        size: size,
        svg: $939c0243cabcce21$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("5kN3x", function(module, exports) {
$parcel$export(module.exports, "FocusIcon", () => $3e24df8349650905$export$1e02e7298035a77c);

var $5FkrB = parcelRequire("5FkrB");

var $fDucD = parcelRequire("fDucD");

var $8onqJ = parcelRequire("8onqJ");

var $cVyt1 = parcelRequire("cVyt1");

var $8oKXf = parcelRequire("8oKXf");
var $3e24df8349650905$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor;
    var colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $8oKXf.getColorsFromAppearance)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" viewBox=\"0 0 48 48\" focusable=\"false\" aria-hidden=\"true\" xmlns=\"http://www.w3.org/2000/svg\">\n\t\t<path fill=\"".concat(colors.iconColor, "\" d=\"M45.4277 24.5018C41.4108 20.4849 34.8821 20.5276 30.908 24.5018L27.5636 27.8462C25.717 29.6927 22.7177 29.6927 20.8712 27.8462L18.0925 25.0675L10.8309 32.3291L13.6096 35.1078C19.4658 40.9641 28.9654 40.9641 34.8216 35.1078L45.4277 24.5018ZM3 23.5018C7.01684 27.5186 13.4637 27.5578 17.4805 23.5409L20.8676 20.1538C22.7142 18.3073 25.7135 18.3073 27.56 20.1538L30.3387 22.9325L37.6003 15.6709L34.8216 12.8922C28.9654 7.03593 19.4658 7.03593 13.6096 12.8922L3.00356 23.4982L3 23.5018Z\"/>\n\t\t</svg>\n\t\t");
};
var $3e24df8349650905$export$1e02e7298035a77c = function FocusIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Focus' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $8onqJ.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $8onqJ.defaultLogoParams).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $8onqJ.defaultLogoParams).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $fDucD.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $cVyt1.default), {
        appearance: appearance,
        label: label,
        svg: $3e24df8349650905$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("hh6lD", function(module, exports) {
$parcel$export(module.exports, "FocusLogo", () => $c938f2c9202f2b9d$export$33908560ea1b226d);

var $5FkrB = parcelRequire("5FkrB");

var $fDucD = parcelRequire("fDucD");

var $8onqJ = parcelRequire("8onqJ");

var $cVyt1 = parcelRequire("cVyt1");

var $8oKXf = parcelRequire("8oKXf");
var $c938f2c9202f2b9d$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $8oKXf.getColorsFromAppearance)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" viewBox=\"0 0 168 48\" focusable=\"false\" aria-hidden=\"true\" xmlns=\"http://www.w3.org/2000/svg\">\n\t\t<path fill=\"".concat(colors.iconColor, "\" d=\"M42.4277 24.5018C38.4108 20.4849 31.8821 20.5276 27.908 24.5018L24.5636 27.8462C22.717 29.6927 19.7177 29.6927 17.8712 27.8462L15.0925 25.0675L7.83088 32.3291L10.6096 35.1078C16.4658 40.9641 25.9654 40.9641 31.8216 35.1078L42.4277 24.5018ZM0 23.5018C4.01684 27.5186 10.4637 27.5578 14.4805 23.5409L17.8676 20.1538C19.7142 18.3073 22.7135 18.3073 24.56 20.1538L27.3387 22.9325L34.6003 15.6709L31.8216 12.8922C25.9654 7.03593 16.4658 7.03593 10.6096 12.8922L0.00355592 23.4982L0 23.5018Z\"/>\n\t\t<path fill=\"").concat(colors.textColor, "\" d=\"M167.405 31.746C167.405 35.564 164.921 38.462 158.757 38.462C155.307 38.462 152.501 37.68 150.753 36.76V32.574C152.731 33.724 156.043 34.828 158.941 34.828C161.977 34.828 163.541 33.586 163.541 31.792C163.541 30.044 162.207 29.032 157.837 27.974C152.731 26.732 150.569 24.754 150.569 20.982C150.569 16.98 153.651 14.542 158.895 14.542C161.885 14.542 164.599 15.278 166.301 16.198V20.292C163.541 18.912 161.287 18.176 158.849 18.176C155.951 18.176 154.387 19.188 154.387 20.982C154.387 22.592 155.491 23.604 159.723 24.616C164.829 25.858 167.405 27.744 167.405 31.746Z\"/>\n\t\t<path fill=\"").concat(colors.textColor, "\" d=\"M126.009 28.48V15.002H129.965V28.894C129.965 33.034 131.621 34.874 135.393 34.874C139.073 34.874 141.603 32.436 141.603 27.79V15.002H145.559V38.002H141.603V34.23C140.131 36.944 137.417 38.462 134.335 38.462C129.045 38.462 126.009 34.828 126.009 28.48Z\"/>\n\t\t<path fill=\"").concat(colors.textColor, "\" d=\"M121.953 33.862V37.404C120.573 38.14 118.457 38.462 116.341 38.462C108.153 38.462 104.335 33.494 104.335 26.456C104.335 19.51 108.153 14.542 116.341 14.542C118.411 14.542 120.021 14.818 121.815 15.646V19.326C120.343 18.636 118.779 18.222 116.617 18.222C110.637 18.222 108.199 21.994 108.199 26.456C108.199 30.918 110.683 34.69 116.709 34.69C119.055 34.69 120.527 34.368 121.953 33.862Z\"/>\n\t\t<path fill=\"").concat(colors.textColor, "\" d=\"M90.2616 38.462C83.3616 38.462 79.3136 33.356 79.3136 26.456C79.3136 19.556 83.3616 14.542 90.2616 14.542C97.1156 14.542 101.118 19.556 101.118 26.456C101.118 33.356 97.1156 38.462 90.2616 38.462ZM90.2616 18.222C85.3396 18.222 83.1776 22.086 83.1776 26.456C83.1776 30.826 85.3396 34.782 90.2616 34.782C95.1376 34.782 97.2536 30.826 97.2536 26.456C97.2536 22.086 95.1376 18.222 90.2616 18.222Z\"/>\n\t\t<path fill=\"").concat(colors.textColor, "\" d=\"M75.298 26.732H61.59V38.002H57.45V7.78003H76.862V11.736H61.59V22.776H75.298V26.732Z\"/>\n\t\t</svg>\n\t\t");
};
var $c938f2c9202f2b9d$export$33908560ea1b226d = function FocusLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Focus' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $8onqJ.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $8onqJ.defaultLogoParams).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $8onqJ.defaultLogoParams).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $fDucD.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $cVyt1.default), {
        appearance: appearance,
        label: label,
        iconColor: iconColor,
        size: size,
        svg: $c938f2c9202f2b9d$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("lrODD", function(module, exports) {
$parcel$export(module.exports, "GuardIcon", () => $f9d366510db8d846$export$3f95fcfdc25a741d);

var $5FkrB = parcelRequire("5FkrB");

var $fDucD = parcelRequire("fDucD");

var $8onqJ = parcelRequire("8onqJ");

var $cVyt1 = parcelRequire("cVyt1");

var $8oKXf = parcelRequire("8oKXf");
var $f9d366510db8d846$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor;
    var colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $8oKXf.getColorsFromAppearance)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" focusable=\"false\" aria-hidden=\"true\">\n      <path\n        d=\"M5.584 14.4h20.83c.599 0 .918-.32.918-.918V6.459c0-.599-.319-.918-.918-.918h-4.39c-.598 0-.917.32-.917.918v3.551h-1.995V6.46c0-.599-.32-.918-.918-.918h-4.39c-.598 0-.917.32-.917.918v3.551h-1.995V6.46c0-.599-.32-.918-.918-.918h-4.39c-.598 0-.917.32-.917.918v7.023c0 .599.319.918.917.918zm.36 6.145a13.9 13.9 0 0 1-.798-3.99c-.04-.52.199-.799.758-.799h20.191c.559 0 .798.24.798.719q-.12 2.214-.838 4.07c-.24.638-.598.918-1.277.918H7.221c-.679 0-1.038-.28-1.277-.918m18.475 3.312c-1.915 2.354-5.068 3.87-8.42 3.87s-6.584-1.516-8.46-3.87c-.478-.638-.239-1.038.24-1.038h16.44c.48 0 .719.4.2 1.038\"\n        fill=\"".concat(colors.iconColor, "\"\n      />\n    </svg>");
};
var $f9d366510db8d846$export$3f95fcfdc25a741d = function GuardIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Guard' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $8onqJ.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $8onqJ.defaultLogoParams).textColor : _ref2$textColor, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $8onqJ.defaultLogoParams).iconColor : _ref2$iconColor;
    var _useThemeObserver = (0, $fDucD.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $cVyt1.default), {
        appearance: appearance,
        svg: $f9d366510db8d846$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        label: label,
        size: size,
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("6priL", function(module, exports) {
$parcel$export(module.exports, "GuardLogo", () => $4aaa416bcb06d11e$export$a4a891d202775deb);

var $5FkrB = parcelRequire("5FkrB");

var $fDucD = parcelRequire("fDucD");

var $8onqJ = parcelRequire("8onqJ");

var $cVyt1 = parcelRequire("cVyt1");

var $8oKXf = parcelRequire("8oKXf");
var $4aaa416bcb06d11e$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $8oKXf.getColorsFromAppearance)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 114 32\" focusable=\"false\" aria-hidden=\"true\">\n      <path\n        d=\"M.918 13.733h20.83c.598 0 .918-.32.918-.918V5.792c0-.599-.32-.918-.918-.918h-4.39c-.598 0-.918.32-.918.918v3.551h-1.995V5.792c0-.599-.319-.918-.918-.918H9.139c-.599 0-.918.32-.918.918v3.551H6.225V5.792c0-.599-.32-.918-.918-.918H.917c-.598 0-.917.32-.917.918v7.023c0 .599.32.918.918.918m.359 6.145a13.9 13.9 0 0 1-.798-3.99c-.04-.52.2-.799.758-.799h20.191c.56 0 .799.24.799.719q-.12 2.214-.838 4.07c-.24.638-.599.918-1.277.918H2.554c-.679 0-1.038-.28-1.277-.918m18.476 3.312c-1.916 2.354-5.068 3.87-8.42 3.87s-6.584-1.516-8.46-3.87c-.479-.638-.24-1.038.24-1.038h16.44c.479 0 .718.4.2 1.038\"\n        fill=\"".concat(colors.iconColor, "\"\n      />\n      <path\n        d=\"M102.398 17.874c0 3.68 1.472 5.52 4.202 5.52 2.361 0 4.477-1.502 4.477-4.906V17.26c0-3.404-1.932-4.907-4.171-4.907-2.974 0-4.508 1.963-4.508 5.52zm8.679 7.667v-2.76c-.982 2.024-2.822 3.067-5.183 3.067-4.079 0-6.133-3.466-6.133-7.974 0-4.324 2.146-7.973 6.44-7.973 2.238 0 3.956 1.012 4.876 3.005V3.798h2.637v21.743zm-17.793-9.047v9.047h-2.576V10.208h2.576v2.698c.89-1.809 2.423-3.097 5.428-2.913v2.576c-3.373-.337-5.428.675-5.428 3.925m-17.869 1.381c0 3.68 1.472 5.52 4.201 5.52 2.362 0 4.478-1.503 4.478-4.907v-1.227c0-3.404-1.932-4.906-4.17-4.906-2.976 0-4.509 1.962-4.509 5.52m8.679 7.666v-2.76c-.982 2.024-2.822 3.067-5.183 3.067-4.079 0-6.133-3.465-6.133-7.973 0-4.324 2.146-7.974 6.44-7.974 2.238 0 3.956 1.012 4.876 3.006v-2.699h2.637v15.333zM56.68 19.193v-8.985h2.637v9.261c0 2.76 1.105 3.987 3.62 3.987 2.453 0 4.14-1.625 4.14-4.723v-8.525h2.637v15.333h-2.638v-2.514c-.981 1.809-2.79 2.821-4.845 2.821-3.527 0-5.55-2.423-5.55-6.655zm-3.973 5.213c-1.595.951-4.539 1.442-6.808 1.442-6.931 0-10.672-4.232-10.672-10.335 0-6.563 4.262-10.457 11.438-10.457 1.595 0 3.466.184 5.244.797v2.76c-1.533-.613-3.342-.89-5.213-.89-5.98 0-8.71 2.975-8.71 7.729 0 4.661 2.76 7.758 8.557 7.758.95 0 2.269-.092 3.404-.429v-5.612h-5.152v-2.637h7.912z\"\n        fill=\"").concat(colors.textColor, "\"\n      />\n    </svg>");
};
var $4aaa416bcb06d11e$export$a4a891d202775deb = function GuardLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Guard' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $8onqJ.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $8onqJ.defaultLogoParams).textColor : _ref2$textColor, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $8onqJ.defaultLogoParams).iconColor : _ref2$iconColor;
    var _useThemeObserver = (0, $fDucD.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $cVyt1.default), {
        appearance: appearance,
        iconColor: iconColor,
        label: label,
        size: size,
        svg: $4aaa416bcb06d11e$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("Y36zi", function(module, exports) {
$parcel$export(module.exports, "JiraIcon", () => $0b480349a5d37260$export$c4b5b1f965d8b3eb);

var $5FkrB = parcelRequire("5FkrB");

var $fDucD = parcelRequire("fDucD");

var $8onqJ = parcelRequire("8onqJ");

var $cVyt1 = parcelRequire("cVyt1");

var $8oKXf = parcelRequire("8oKXf");
var $0b480349a5d37260$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor;
    var colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $8oKXf.getColorsFromAppearance)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" viewBox=\"0 0 32 32\" focusable=\"false\" aria-hidden=\"true\" xmlns=\"http://www.w3.org/2000/svg\">\n      <path fill=\"".concat(colors.iconColor, "\" d=\"M11.034 21.99h-2.22c-3.346 0-5.747-2.05-5.747-5.052h11.932c.619 0 1.019.44 1.019 1.062v12.007c-2.983 0-4.984-2.416-4.984-5.784zm5.893-5.967h-2.219c-3.347 0-5.748-2.013-5.748-5.015h11.933c.618 0 1.055.402 1.055 1.025V24.04c-2.983 0-5.02-2.416-5.02-5.784zm5.93-5.93h-2.219c-3.347 0-5.748-2.05-5.748-5.052h11.933c.618 0 1.018.439 1.018 1.025v12.007c-2.983 0-4.984-2.416-4.984-5.784z\"/>\n    </svg>");
};
var $0b480349a5d37260$export$c4b5b1f965d8b3eb = function JiraIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Jira' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $8onqJ.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $8onqJ.defaultLogoParams).textColor : _ref2$textColor, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $8onqJ.defaultLogoParams).iconColor : _ref2$iconColor;
    var _useThemeObserver = (0, $fDucD.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $cVyt1.default), {
        appearance: appearance,
        label: label,
        svg: $0b480349a5d37260$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("8aVKe", function(module, exports) {
$parcel$export(module.exports, "JiraLogo", () => $5f3c0cc4476ee39f$export$17d3acb0b4379d02);

var $5FkrB = parcelRequire("5FkrB");

var $fDucD = parcelRequire("fDucD");

var $8onqJ = parcelRequire("8onqJ");

var $cVyt1 = parcelRequire("cVyt1");

var $8oKXf = parcelRequire("8oKXf");
var $5f3c0cc4476ee39f$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $8oKXf.getColorsFromAppearance)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" viewBox=\"0 0 77 32\" focusable=\"false\" aria-hidden=\"true\" xmlns=\"http://www.w3.org/2000/svg\">\n      <path fill=\"".concat(colors.iconColor, "\" d=\"M7.967 21.323H5.748C2.401 21.323 0 19.273 0 16.271h11.933c.618 0 1.018.44 1.018 1.062V29.34c-2.983 0-4.984-2.416-4.984-5.784zm5.894-5.967h-2.22c-3.346 0-5.747-2.013-5.747-5.015h11.932c.618 0 1.055.402 1.055 1.025v12.007c-2.983 0-5.02-2.416-5.02-5.784zm5.93-5.93h-2.22c-3.347 0-5.748-2.05-5.748-5.052h11.933c.618 0 1.019.439 1.019 1.025v12.007c-2.983 0-4.984-2.416-4.984-5.784z\"/>\n      <path fill=\"").concat(colors.textColor, "\" d=\"M65.023 17.874c0 3.68 1.472 5.52 4.202 5.52 2.36 0 4.477-1.503 4.477-4.907V17.26c0-3.404-1.932-4.906-4.17-4.906-2.975 0-4.509 1.962-4.509 5.52m8.679 7.666v-2.76c-.981 2.024-2.821 3.067-5.183 3.067-4.078 0-6.133-3.465-6.133-7.973 0-4.324 2.147-7.974 6.44-7.974 2.239 0 3.956 1.012 4.876 3.006v-2.699h2.637V25.54zM55.91 16.493v9.047h-2.577V10.207h2.576v2.698c.89-1.809 2.423-3.097 5.428-2.913v2.576c-3.373-.337-5.428.675-5.428 3.925M46.224 6.159c0-1.165.767-1.84 1.84-1.84s1.84.675 1.84 1.84-.767 1.84-1.84 1.84-1.84-.675-1.84-1.84m.49 19.381V10.207h2.638V25.54zm-6.427-5.95V5.393h2.76v14.015c0 3.71-1.626 6.256-5.428 6.256-1.442 0-2.546-.246-3.312-.522v-2.668c.828.338 1.84.522 2.852.522 2.33 0 3.128-1.41 3.128-3.404\"/>\n    </svg>");
};
var $5f3c0cc4476ee39f$export$17d3acb0b4379d02 = function JiraLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Jira' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $8onqJ.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $8onqJ.defaultLogoParams).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $8onqJ.defaultLogoParams).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $fDucD.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $cVyt1.default), {
        appearance: appearance,
        label: label,
        iconColor: iconColor,
        size: size,
        svg: $5f3c0cc4476ee39f$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("dMtPL", function(module, exports) {
$parcel$export(module.exports, "JiraAlignIcon", () => $a086e675d50d99f5$export$407687b2dd89cc68);

var $5FkrB = parcelRequire("5FkrB");

var $fDucD = parcelRequire("fDucD");

var $8onqJ = parcelRequire("8onqJ");

var $cVyt1 = parcelRequire("cVyt1");

var $8oKXf = parcelRequire("8oKXf");
var $a086e675d50d99f5$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor;
    var colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $8oKXf.getColorsFromAppearance)(appearance, colorMode);
    return "<svg viewBox=\"0 0 32 32\" focusable=\"false\" aria-hidden=\"true\" height=\"32\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n    <path\n      fill=\"".concat(colors.iconColor, "\"\n      d=\"M25.52 25.727c0-3.604-2.949-6.517-6.517-6.517h-6.007v-5.497H6.48v10.813c0 .837.364 1.201 1.201 1.201zM6.48 6.687c0 3.604 2.876 6.517 6.48 6.517h6.043V18.7h6.517V7.888q0-1.2-1.201-1.201z\"\n    />\n  </svg>");
};
var $a086e675d50d99f5$export$407687b2dd89cc68 = function JiraAlignIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Jira Align' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $8onqJ.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $8onqJ.defaultLogoParams).textColor : _ref2$textColor, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $8onqJ.defaultLogoParams).iconColor : _ref2$iconColor;
    var _useThemeObserver = (0, $fDucD.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $cVyt1.default), {
        appearance: appearance,
        label: label,
        svg: $a086e675d50d99f5$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("iJohS", function(module, exports) {
$parcel$export(module.exports, "JiraAlignLogo", () => $0384e43546c82587$export$ee11e928d3d045fd);

var $5FkrB = parcelRequire("5FkrB");

var $fDucD = parcelRequire("fDucD");

var $8onqJ = parcelRequire("8onqJ");

var $cVyt1 = parcelRequire("cVyt1");

var $8oKXf = parcelRequire("8oKXf");
var $0384e43546c82587$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $8oKXf.getColorsFromAppearance)(appearance, colorMode);
    return "<svg viewBox=\"0 0 146 32\" focusable=\"false\" aria-hidden=\"true\" height=\"32\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n      <path d=\"M19.04 25.727c0-3.604-2.949-6.517-6.517-6.517H6.517v-5.497H0v10.813c0 .837.364 1.201 1.201 1.201zM0 6.687c0 3.604 2.876 6.517 6.48 6.517h6.043V18.7h6.517V7.888q0-1.2-1.201-1.201z\" fill=\"".concat(colors.iconColor, "\"/>\n      <path d=\"M144.993 16.555v8.985h-2.638v-9.26c0-2.76-1.104-3.988-3.618-3.988-2.454 0-4.14 1.626-4.14 4.723v8.525h-2.638V10.207h2.638v2.515c.981-1.81 2.79-2.822 4.845-2.822 3.527 0 5.551 2.423 5.551 6.655m-19.589 7.759V22.78c-.982 2.024-2.822 3.067-5.183 3.067-4.048 0-6.072-3.465-6.072-7.973 0-4.324 2.116-7.974 6.379-7.974 2.238 0 3.956 1.012 4.876 3.006v-2.699h2.576V24.16c0 4.508-2.116 7.544-7.606 7.544-2.576 0-3.986-.337-5.458-.828V28.3c1.686.552 3.434.92 5.336.92 3.833 0 5.152-2.054 5.152-4.906m-8.679-6.44c0 3.68 1.472 5.52 4.201 5.52 2.362 0 4.478-1.503 4.478-4.907V17.26c0-3.404-1.932-4.906-4.171-4.906-2.975 0-4.508 1.962-4.508 5.52M107.96 6.16c0-1.166.766-1.84 1.84-1.84 1.073 0 1.84.674 1.84 1.84S110.873 8 109.8 8c-1.074 0-1.84-.675-1.84-1.84m.49 19.38V10.208h2.638v15.334h-2.638Zm-2.537-.03c-.215.061-.675.122-1.349.122-2.515 0-4.11-1.196-4.11-4.017V3.798h2.638v17.51c0 1.38.92 1.871 2.054 1.871.276 0 .46 0 .767-.03v2.36ZM88.83 21.523c-1.534 0-3.098-.184-4.815-.521l-1.687 4.539h-3.097l7.942-20.148h3.496l7.943 20.148h-3.097l-1.687-4.57c-1.81.368-3.373.552-4.999.552Zm0-2.453c1.287 0 2.606-.153 4.17-.399l-4.079-11.04-4.078 11.07c1.502.246 2.76.369 3.986.369Zm-27.807-1.196c0 3.68 1.472 5.52 4.202 5.52 2.36 0 4.477-1.503 4.477-4.907V17.26c0-3.404-1.932-4.906-4.17-4.906-2.975 0-4.509 1.962-4.509 5.52m8.679 7.666v-2.76c-.981 2.024-2.822 3.067-5.183 3.067-4.079 0-6.133-3.465-6.133-7.973 0-4.324 2.146-7.974 6.44-7.974 2.239 0 3.956 1.012 4.876 3.006v-2.699h2.637V25.54zM51.91 16.494v9.047h-2.577V10.207h2.576v2.699c.89-1.81 2.423-3.097 5.428-2.913v2.576c-3.373-.338-5.428.674-5.428 3.925ZM42.224 6.16c0-1.166.767-1.84 1.84-1.84s1.84.674 1.84 1.84S45.137 8 44.064 8s-1.84-.675-1.84-1.84m.49 19.38V10.208h2.638v15.334h-2.637Zm-6.427-5.949V5.393h2.76v14.014c0 3.71-1.626 6.256-5.428 6.256-1.442 0-2.546-.245-3.312-.521v-2.668c.828.337 1.84.521 2.852.521 2.33 0 3.128-1.41 3.128-3.404\" fill=\"").concat(colors.textColor, "\"/>\n    </svg>\n  ");
};
var $0384e43546c82587$export$ee11e928d3d045fd = function JiraAlignLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Jira Align' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $8onqJ.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $8onqJ.defaultLogoParams).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $8onqJ.defaultLogoParams).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $fDucD.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $cVyt1.default), {
        appearance: appearance,
        label: label,
        iconColor: iconColor,
        size: size,
        svg: $0384e43546c82587$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("7b7qW", function(module, exports) {
$parcel$export(module.exports, "JiraProductDiscoveryIcon", () => $539f53a33632dfac$export$21bfbeb62fdcce8d);

var $5FkrB = parcelRequire("5FkrB");

var $fDucD = parcelRequire("fDucD");

var $8onqJ = parcelRequire("8onqJ");

var $cVyt1 = parcelRequire("cVyt1");

var $8oKXf = parcelRequire("8oKXf");
var $539f53a33632dfac$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor;
    var colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $8oKXf.getColorsFromAppearance)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" viewBox=\"0 0 32 32\" focusable=\"false\" aria-hidden=\"true\" xmlns=\"http://www.w3.org/2000/svg\">\n      <path fill=\"".concat(colors.iconColor, "\" d=\"M17.655 5.884a15.3 15.3 0 0 0 8.75 0c.257-.056.428.114.37.37-.826 2.985-.826 5.742 0 8.727.058.228-.113.427-.37.342a16.33 16.33 0 0 0-8.75 0c-.228.085-.428-.114-.342-.342.77-2.985.77-5.742 0-8.727-.086-.256.114-.426.342-.37m1.169 10.576v.483c0 2.246-1.568 3.894-3.506 3.894a3.474 3.474 0 0 1-3.477-3.496c0-1.933 1.567-3.468 3.762-3.468h.57V7.078c-.285-.028-.57-.028-.855-.028C9.618 7.05 5 11.655 5 17.37c0 5.713 4.617 10.29 10.318 10.29s10.346-4.605 10.346-10.29v-.91z\"/>\n    </svg>");
};
var $539f53a33632dfac$export$21bfbeb62fdcce8d = function JiraProductDiscoveryIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Jira Product Discovery' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $8onqJ.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $8onqJ.defaultLogoParams).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $8onqJ.defaultLogoParams).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $fDucD.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $cVyt1.default), {
        appearance: appearance,
        label: label,
        svg: $539f53a33632dfac$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("50GiU", function(module, exports) {
$parcel$export(module.exports, "JiraProductDiscoveryLogo", () => $3a5dc488d65304f9$export$c49a2b642fe9eef4);

var $5FkrB = parcelRequire("5FkrB");

var $fDucD = parcelRequire("fDucD");

var $8onqJ = parcelRequire("8onqJ");

var $cVyt1 = parcelRequire("cVyt1");

var $8oKXf = parcelRequire("8oKXf");
var $3a5dc488d65304f9$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $8oKXf.getColorsFromAppearance)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" viewBox=\"0 0 318 32\" focusable=\"false\" aria-hidden=\"true\" xmlns=\"http://www.w3.org/2000/svg\">\n      <path fill=\"".concat(colors.iconColor, "\" d=\"M12.655 5.218a15.3 15.3 0 0 0 8.75 0c.257-.057.428.114.37.37-.826 2.984-.826 5.742 0 8.727.058.227-.113.426-.37.341a16.33 16.33 0 0 0-8.75 0c-.228.085-.428-.114-.342-.341.77-2.985.77-5.743 0-8.727-.086-.256.114-.427.342-.37m1.169 10.575v.483c0 2.246-1.568 3.895-3.506 3.895a3.474 3.474 0 0 1-3.478-3.497c0-1.933 1.568-3.468 3.763-3.468h.57V6.412c-.285-.028-.57-.028-.855-.028C4.618 6.384 0 10.989 0 16.703s4.617 10.29 10.318 10.29 10.346-4.605 10.346-10.29v-.91z\" />\n      <path fill=\"").concat(colors.textColor, "\" d=\"M308.551 24.559h-1.718l-5.55-14.352h2.821l4.907 13.125 4.906-13.125h2.822l-5.796 14.843c-1.718 4.385-2.699 6.654-6.594 6.654-1.318 0-2.054-.122-2.821-.429v-2.27c.889.277 1.901.369 2.668.369 2.147 0 3.097-1.472 4.355-4.815m-13.247-8.065v9.047h-2.576V10.207h2.576v2.699c.889-1.81 2.422-3.097 5.428-2.913v2.576c-3.374-.338-5.428.674-5.428 3.925m-12.464-4.202c-2.79 0-4.201 1.81-4.477 4.478h8.556c-.153-2.852-1.441-4.478-4.079-4.478m5.888 12.635c-1.257.675-3.189.92-4.753.92-5.735 0-8.249-3.312-8.249-8.004 0-4.63 2.576-7.943 7.237-7.943 4.723 0 6.624 3.282 6.624 7.943v1.196h-11.193c.368 2.607 2.054 4.293 5.673 4.293 1.779 0 3.281-.337 4.661-.828zm-19.717.613h-3.527l-5.949-15.333h2.76l4.968 13.095 4.937-13.095h2.76zm-17.462.307c-4.6 0-7.299-3.404-7.299-8.004s2.699-7.943 7.299-7.943c4.569 0 7.237 3.343 7.237 7.943s-2.668 8.004-7.237 8.004m0-13.493c-3.281 0-4.723 2.576-4.723 5.49 0 2.912 1.442 5.55 4.723 5.55 3.251 0 4.661-2.638 4.661-5.55 0-2.914-1.41-5.49-4.661-5.49M242.16 22.78v2.362c-.92.49-2.331.705-3.742.705-5.458 0-8.004-3.312-8.004-8.004 0-4.63 2.546-7.943 8.004-7.943 1.38 0 2.454.184 3.65.736v2.454c-.982-.46-2.024-.736-3.466-.736-3.986 0-5.612 2.514-5.612 5.49 0 2.974 1.656 5.488 5.674 5.488 1.564 0 2.545-.214 3.496-.552m-13.872-1.41c0 2.545-1.656 4.477-5.765 4.477-2.3 0-4.171-.521-5.336-1.135v-2.79c1.319.766 3.527 1.502 5.459 1.502 2.024 0 3.066-.828 3.066-2.024 0-1.165-.889-1.84-3.802-2.545-3.404-.828-4.846-2.147-4.846-4.661 0-2.668 2.055-4.294 5.551-4.294 1.993 0 3.803.491 4.937 1.104v2.73c-1.84-.92-3.342-1.41-4.968-1.41-1.932 0-2.974.674-2.974 1.87 0 1.073.736 1.748 3.557 2.422 3.404.828 5.121 2.086 5.121 4.754M210.599 6.16c0-1.166.767-1.84 1.84-1.84s1.84.674 1.84 1.84-.767 1.84-1.84 1.84-1.84-.675-1.84-1.84m.491 19.38V10.208h2.637v15.334zM198.344 8.03h-4.539v14.873h4.692c4.6 0 6.9-2.422 6.9-7.298 0-4.907-2.177-7.575-7.053-7.575m-7.299 17.51V5.394h7.422c6.532 0 9.69 4.078 9.69 10.12 0 6.102-3.189 10.028-9.69 10.028zm-13.411-4.753c0 1.35.797 2.27 2.422 2.27.614 0 1.196-.123 1.656-.215v2.545c-.46.123-.981.245-1.778.245-3.282 0-4.876-1.932-4.876-4.784v-8.187h-2.484v-2.454h2.484v-3.25h2.576v3.25h4.078v2.453h-4.078zm-6.66 1.993v2.362c-.92.49-2.331.705-3.742.705-5.458 0-8.004-3.312-8.004-8.004 0-4.63 2.546-7.943 8.004-7.943 1.38 0 2.454.184 3.65.736v2.454c-.982-.46-2.024-.736-3.466-.736-3.986 0-5.612 2.514-5.612 5.49 0 2.974 1.656 5.488 5.674 5.488 1.564 0 2.545-.214 3.496-.552m-27.843-3.588v-8.985h2.637v9.261c0 2.76 1.104 3.987 3.619 3.987 2.453 0 4.14-1.625 4.14-4.723v-8.525h2.637V25.54h-2.637v-2.514c-.982 1.809-2.791 2.821-4.846 2.821-3.526 0-5.55-2.423-5.55-6.655m-14.987-1.318c0 3.68 1.472 5.52 4.202 5.52 2.361 0 4.477-1.503 4.477-4.907V17.26c0-3.404-1.932-4.906-4.171-4.906-2.974 0-4.508 1.962-4.508 5.52m8.679 7.667v-2.76c-.981 2.023-2.821 3.066-5.183 3.066-4.078 0-6.133-3.465-6.133-7.973 0-4.324 2.147-7.973 6.44-7.973 2.239 0 3.956 1.012 4.876 3.005V3.798h2.637V25.54zm-20.698.306c-4.6 0-7.299-3.404-7.299-8.004s2.699-7.943 7.299-7.943c4.569 0 7.237 3.343 7.237 7.943s-2.668 8.004-7.237 8.004m0-13.493c-3.282 0-4.723 2.576-4.723 5.49 0 2.912 1.441 5.55 4.723 5.55 3.25 0 4.661-2.638 4.661-5.55 0-2.914-1.411-5.49-4.661-5.49m-13.776 4.14v9.047h-2.576V10.207h2.576v2.699c.89-1.81 2.423-3.097 5.428-2.913v2.576c-3.373-.338-5.428.674-5.428 3.925m-5.002-4.385c0 4.385-2.454 6.838-7.483 6.838h-4.017v6.594h-2.76V5.393h6.777c5.03 0 7.483 2.576 7.483 6.716m-7.79 4.2c3.558.124 4.938-1.563 4.938-4.14 0-2.452-1.38-4.14-4.938-4.14h-3.71v8.28zM61.69 17.874c0 3.68 1.472 5.52 4.201 5.52 2.361 0 4.477-1.503 4.477-4.907V17.26c0-3.404-1.931-4.906-4.17-4.906-2.975 0-4.508 1.962-4.508 5.52m8.679 7.666v-2.76c-.982 2.024-2.822 3.067-5.183 3.067-4.079 0-6.134-3.465-6.134-7.973 0-4.324 2.147-7.974 6.44-7.974 2.24 0 3.957 1.012 4.877 3.006v-2.699h2.637V25.54zm-17.793-9.046v9.047H50V10.207h2.576v2.699c.89-1.81 2.423-3.097 5.428-2.913v2.576c-3.373-.338-5.428.674-5.428 3.925M42.89 6.16c0-1.166.767-1.84 1.84-1.84s1.84.674 1.84 1.84S45.805 8 44.73 8s-1.84-.675-1.84-1.84m.491 19.38V10.208h2.638v15.334zm-6.428-5.949V5.393h2.76v14.014c0 3.71-1.625 6.256-5.428 6.256-1.441 0-2.545-.245-3.312-.521v-2.668c.828.337 1.84.521 2.852.521 2.331 0 3.128-1.41 3.128-3.404\" />\n    </svg>");
};
var $3a5dc488d65304f9$export$c49a2b642fe9eef4 = function JiraProductDiscoveryLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Jira Product Discovery' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $8onqJ.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $8onqJ.defaultLogoParams).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $8onqJ.defaultLogoParams).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $fDucD.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $cVyt1.default), {
        appearance: appearance,
        label: label,
        iconColor: iconColor,
        size: size,
        svg: $3a5dc488d65304f9$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("eHm4v", function(module, exports) {
$parcel$export(module.exports, "JiraServiceManagementIcon", () => $ab3633d671879ebc$export$3c6158790f5e01c4);

var $5FkrB = parcelRequire("5FkrB");

var $fDucD = parcelRequire("fDucD");

var $8onqJ = parcelRequire("8onqJ");

var $cVyt1 = parcelRequire("cVyt1");

var $8oKXf = parcelRequire("8oKXf");
var $ab3633d671879ebc$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor;
    var colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $8oKXf.getColorsFromAppearance)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" viewBox=\"0 0 32 32\" focusable=\"false\" aria-hidden=\"true\" xmlns=\"http://www.w3.org/2000/svg\">\n      <path fill=".concat(colors.iconColor, " d=\"M18.79 13.257h7.325c1.1 0 1.476 1.046.805 1.878L15.464 29.274c-3.702-2.951-3.353-7.62-.644-11.027zm-5.66 5.634H5.806c-1.1 0-1.476-1.046-.805-1.878L16.457 2.874c3.702 2.951 3.3 7.566.617 11z\"/>\n    </svg>");
};
var $ab3633d671879ebc$export$3c6158790f5e01c4 = function JiraServiceManagementIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Jira Service Management' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $8onqJ.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $8onqJ.defaultLogoParams).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $8onqJ.defaultLogoParams).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $fDucD.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $cVyt1.default), {
        appearance: appearance,
        label: label,
        svg: $ab3633d671879ebc$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("5V5je", function(module, exports) {
$parcel$export(module.exports, "JiraServiceManagementLogo", () => $44f664ec6684700a$export$dabef2be6cd28c20);

var $5FkrB = parcelRequire("5FkrB");

var $fDucD = parcelRequire("fDucD");

var $8onqJ = parcelRequire("8onqJ");

var $cVyt1 = parcelRequire("cVyt1");

var $8oKXf = parcelRequire("8oKXf");
var $44f664ec6684700a$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $8oKXf.getColorsFromAppearance)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" viewBox=\"0 0 362 32\" focusable=\"false\" aria-hidden=\"true\" xmlns=\"http://www.w3.org/2000/svg\">\n      <path fill=".concat(colors.iconColor, " d=\"M14.124 13.257h7.325c1.1 0 1.475 1.046.804 1.878L10.798 29.274c-3.702-2.951-3.353-7.62-.644-11.027zm-5.66 5.634H1.138c-1.1 0-1.476-1.046-.805-1.878L11.79 2.874c3.703 2.951 3.3 7.566.617 11z\" />\n      <path fill=").concat(colors.textColor, " d=\"M357.074 20.787c0 1.35.797 2.27 2.422 2.27.614 0 1.196-.123 1.656-.215v2.545c-.46.123-.981.245-1.778.245-3.282 0-4.876-1.932-4.876-4.784v-8.187h-2.484v-2.454h2.484v-3.25h2.576v3.25h4.078v2.453h-4.078zm-7.327-4.231v8.985h-2.638V16.28c0-2.76-1.104-3.987-3.618-3.987-2.454 0-4.14 1.625-4.14 4.723v8.525h-2.638V10.208h2.638v2.514c.981-1.81 2.79-2.821 4.845-2.821 3.527 0 5.551 2.423 5.551 6.655m-22.921-4.263c-2.791 0-4.201 1.81-4.477 4.477h8.556c-.154-2.852-1.442-4.477-4.079-4.477m5.888 12.635c-1.257.674-3.189.92-4.753.92-5.735 0-8.25-3.312-8.25-8.004 0-4.631 2.576-7.943 7.238-7.943 4.722 0 6.624 3.281 6.624 7.943v1.196h-11.194c.368 2.606 2.055 4.293 5.674 4.293 1.778 0 3.281-.337 4.661-.828zm-26.152-7.912v8.525h-2.637V16.28c0-2.76-1.104-3.987-3.619-3.987-2.453 0-4.14 1.625-4.14 4.723v8.525h-2.637V10.208h2.637v2.514c.981-1.81 2.79-2.821 4.845-2.821 2.607 0 4.385 1.319 5.152 3.741.859-2.361 2.913-3.741 5.459-3.741 3.434 0 5.336 2.33 5.336 6.655v8.985h-2.638v-8.525c0-3.16-1.104-4.723-3.618-4.723-2.454 0-4.14 1.625-4.14 4.723m-22.921-4.723c-2.79 0-4.201 1.81-4.477 4.477h8.556c-.153-2.852-1.441-4.477-4.079-4.477m5.888 12.635c-1.257.674-3.189.92-4.753.92-5.735 0-8.25-3.312-8.25-8.004 0-4.631 2.577-7.943 7.238-7.943 4.723 0 6.624 3.281 6.624 7.943v1.196h-11.193c.368 2.606 2.054 4.293 5.673 4.293 1.779 0 3.281-.337 4.661-.828zm-18.638-.614v-1.533c-.982 2.024-2.822 3.067-5.183 3.067-4.048 0-6.072-3.466-6.072-7.974 0-4.324 2.116-7.973 6.379-7.973 2.238 0 3.956 1.012 4.876 3.005v-2.698h2.576V24.16c0 4.508-2.116 7.544-7.606 7.544-2.576 0-3.986-.337-5.458-.828V28.3c1.686.552 3.434.92 5.336.92 3.833 0 5.152-2.055 5.152-4.907m-8.679-6.44c0 3.68 1.472 5.52 4.201 5.52 2.362 0 4.478-1.503 4.478-4.906V17.26c0-3.404-1.932-4.907-4.171-4.907-2.975 0-4.508 1.963-4.508 5.52m-16.949.001c0 3.68 1.472 5.52 4.201 5.52 2.361 0 4.477-1.503 4.477-4.906V17.26c0-3.404-1.932-4.907-4.17-4.907-2.975 0-4.508 1.963-4.508 5.52m8.678 7.667v-2.76c-.981 2.024-2.821 3.066-5.182 3.066-4.079 0-6.134-3.465-6.134-7.973 0-4.324 2.147-7.973 6.44-7.973 2.239 0 3.956 1.012 4.876 3.005v-2.699h2.638V25.54zm-14.073-8.984v8.985h-2.638V16.28c0-2.76-1.104-3.987-3.618-3.987-2.454 0-4.14 1.625-4.14 4.723v8.525h-2.638V10.208h2.638v2.514c.981-1.81 2.79-2.821 4.845-2.821 3.527 0 5.551 2.423 5.551 6.655m-28.327 1.318c0 3.68 1.472 5.52 4.202 5.52 2.361 0 4.477-1.503 4.477-4.906V17.26c0-3.404-1.932-4.907-4.171-4.907-2.974 0-4.508 1.963-4.508 5.52m8.679 7.667v-2.76c-.981 2.024-2.821 3.066-5.183 3.066-4.078 0-6.133-3.465-6.133-7.973 0-4.324 2.147-7.973 6.44-7.973 2.239 0 3.956 1.012 4.876 3.005v-2.699h2.637V25.54zm-31.445-11.009-2.76-7.482V25.54h-2.76V5.393h4.784l4.569 11.56 1.871 5.552 1.87-5.551 4.6-11.561h4.447V25.54h-2.76V7.263l-2.361 7.268-4.447 11.01h-2.668zm-21.511-2.238c-2.791 0-4.202 1.81-4.478 4.477h8.556c-.153-2.852-1.441-4.477-4.078-4.477m5.888 12.635c-1.258.674-3.19.92-4.754.92-5.734 0-8.249-3.312-8.249-8.004 0-4.631 2.576-7.943 7.237-7.943 4.723 0 6.624 3.281 6.624 7.943v1.196h-11.193c.368 2.606 2.055 4.293 5.673 4.293 1.779 0 3.282-.337 4.662-.828zm-15.094-2.148v2.362c-.92.49-2.33.705-3.741.705-5.459 0-8.004-3.312-8.004-8.004 0-4.63 2.545-7.942 8.004-7.942 1.38 0 2.453.184 3.649.736v2.453c-.981-.46-2.024-.736-3.465-.736-3.987 0-5.612 2.515-5.612 5.49s1.656 5.489 5.673 5.489c1.564 0 2.546-.215 3.496-.552M140.124 6.16c0-1.166.766-1.84 1.84-1.84 1.073 0 1.84.674 1.84 1.84S143.037 8 141.964 8c-1.074 0-1.84-.675-1.84-1.84m.49 19.38V10.208h2.638v15.334zm-8.233 0h-3.527l-5.949-15.332h2.76l4.968 13.094 4.937-13.094h2.76zm-15.455-9.046v9.047h-2.576V10.207h2.576v2.699c.889-1.81 2.423-3.097 5.428-2.913v2.576c-3.373-.338-5.428.674-5.428 3.925m-12.463-4.201c-2.791 0-4.202 1.81-4.478 4.477h8.556c-.153-2.852-1.441-4.477-4.078-4.477m5.888 12.635c-1.258.674-3.19.92-4.754.92-5.734 0-8.249-3.312-8.249-8.004 0-4.631 2.576-7.943 7.237-7.943 4.723 0 6.624 3.281 6.624 7.943v1.196h-11.193c.368 2.606 2.055 4.293 5.673 4.293 1.779 0 3.282-.337 4.662-.828zM95.024 19.99c0 3.496-2.085 5.857-7.084 5.857-3.894 0-5.704-.766-7.268-1.564v-2.821c1.87.981 4.754 1.687 7.422 1.687 3.036 0 4.17-1.196 4.17-2.975s-1.104-2.73-4.937-3.65c-4.539-1.103-6.563-2.667-6.563-5.98 0-3.127 2.392-5.458 7.084-5.458 2.914 0 4.784.705 6.164 1.472v2.76c-2.024-1.165-4.201-1.533-6.286-1.533-2.638 0-4.202.92-4.202 2.76 0 1.656 1.288 2.484 4.845 3.373 4.263 1.073 6.655 2.453 6.655 6.072m-34.001-2.116c0 3.68 1.472 5.52 4.201 5.52 2.362 0 4.478-1.503 4.478-4.906V17.26c0-3.404-1.932-4.907-4.17-4.907-2.975 0-4.509 1.963-4.509 5.52m8.679 7.667v-2.76c-.981 2.024-2.821 3.066-5.183 3.066-4.078 0-6.133-3.465-6.133-7.973 0-4.324 2.147-7.973 6.44-7.973 2.239 0 3.956 1.012 4.876 3.005v-2.699h2.637V25.54zM51.91 16.494v9.047h-2.577V10.207h2.576v2.699c.89-1.81 2.423-3.097 5.428-2.913v2.576c-3.373-.338-5.428.674-5.428 3.925M42.224 6.16c0-1.166.767-1.84 1.84-1.84s1.84.674 1.84 1.84S45.137 8 44.064 8s-1.84-.675-1.84-1.84m.49 19.38V10.208h2.638v15.334zm-6.427-5.949V5.393h2.76v14.014c0 3.71-1.626 6.256-5.428 6.256-1.442 0-2.546-.245-3.312-.521v-2.668c.828.337 1.84.521 2.852.521 2.33 0 3.128-1.41 3.128-3.404\" />\n    </svg>");
};
var $44f664ec6684700a$export$dabef2be6cd28c20 = function JiraServiceManagementLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Jira Service Management' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $8onqJ.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $8onqJ.defaultLogoParams).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $8onqJ.defaultLogoParams).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $fDucD.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $cVyt1.default), {
        appearance: appearance,
        label: label,
        iconColor: iconColor,
        size: size,
        svg: $44f664ec6684700a$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("ib7qW", function(module, exports) {
$parcel$export(module.exports, "LoomIcon", () => $d3bf053d58aecb39$export$8d789f76fde3e05);

var $5FkrB = parcelRequire("5FkrB");

var $fDucD = parcelRequire("fDucD");

var $8onqJ = parcelRequire("8onqJ");

var $cVyt1 = parcelRequire("cVyt1");

var $8oKXf = parcelRequire("8oKXf");
var $d3bf053d58aecb39$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor;
    var colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $8oKXf.getColorsForLoom)(appearance, colorMode);
    return "<svg\n    fill=\"none\"\n    height=\"32\"\n    viewBox=\"0 0 32 32\"\n    xmlns=\"http://www.w3.org/2000/svg\"\n    focusable=\"false\"\n    aria-hidden=\"true\"\n  >\n    <path\n      d=\"M27.333 15.508h-6.628l5.74-3.315-1.26-2.184-5.74 3.314 3.313-5.74-2.184-1.26-3.313 5.74V5.434h-2.522v6.628l-3.314-5.74-2.184 1.26 3.314 5.74-5.74-3.314-1.26 2.184 5.74 3.314H4.667v2.521h6.627l-5.74 3.314 1.261 2.184 5.74-3.313-3.314 5.74 2.184 1.26 3.314-5.74V28.1h2.521v-6.627l3.313 5.74 2.184-1.261-3.314-5.74 5.74 3.313 1.261-2.184-5.74-3.313h6.628zM16 20.198a3.442 3.442 0 1 1 0-6.885 3.442 3.442 0 0 1 0 6.884\"\n      fill=\"".concat(colors.iconColor, "\"\n    />\n  </svg>");
};
var $d3bf053d58aecb39$export$8d789f76fde3e05 = function LoomIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Loom' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $8onqJ.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $8onqJ.defaultLogoParams).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $8onqJ.defaultLogoParams).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $fDucD.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $cVyt1.default), {
        appearance: appearance,
        label: label,
        svg: $d3bf053d58aecb39$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("j9T9X", function(module, exports) {
$parcel$export(module.exports, "LoomLogo", () => $df29a5258322e53f$export$94e206806e36c2ec);

var $5FkrB = parcelRequire("5FkrB");

var $fDucD = parcelRequire("fDucD");

var $8onqJ = parcelRequire("8onqJ");

var $cVyt1 = parcelRequire("cVyt1");

var $8oKXf = parcelRequire("8oKXf");
var $df29a5258322e53f$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $8oKXf.getColorsForLoom)(appearance, colorMode);
    return "<svg\n      fill=\"none\"\n      height=\"32\"\n      xmlns=\"http://www.w3.org/2000/svg\"\n      viewBox=\"0 0 98 32\"\n      focusable=\"false\"\n      aria-hidden=\"true\"\n    >\n      <path\n        d=\"M29.657 13.659h-8.672l7.51-4.337-1.649-2.857-7.51 4.336 4.335-7.51-2.857-1.65-4.336 7.51V.479H13.18v8.672l-4.337-7.51-2.856 1.65 4.336 7.51-7.51-4.336-1.65 2.857 7.51 4.336H0v3.299h8.671l-7.51 4.336 1.65 2.858 7.51-4.336-4.336 7.51 2.857 1.65 4.336-7.511v8.672h3.3v-8.671l4.335 7.51 2.857-1.65-4.336-7.51 7.51 4.336 1.65-2.858-7.51-4.335h8.672v-3.3zM14.83 19.794a4.503 4.503 0 1 1 0-9.006 4.503 4.503 0 0 1 0 9.006\"\n        fill=\"".concat(colors.iconColor, "\"\n      />\n      <path\n        d=\"M37.303 26.155V4.459h3.983v21.696zm38.204-14.743h3.803v1.798c.808-1.438 2.696-2.218 4.313-2.218 2.007 0 3.624.87 4.373 2.457 1.167-1.798 2.726-2.457 4.673-2.457 2.725 0 5.33 1.648 5.33 5.604v9.559h-3.862v-8.75c0-1.588-.78-2.786-2.607-2.786-1.707 0-2.726 1.318-2.726 2.907v8.63H84.85v-8.75c0-1.59-.808-2.787-2.606-2.787-1.738 0-2.757 1.288-2.757 2.907v8.63h-3.981zm-25.219 15.17c-4.487 0-7.737-3.328-7.737-7.798 0-4.4 3.24-7.806 7.737-7.806 4.52 0 7.737 3.439 7.737 7.806 0 4.438-3.251 7.798-7.737 7.798m0-11.996a4.2 4.2 0 0 0-4.197 4.199c0 2.315 1.883 4.199 4.197 4.199s4.196-1.884 4.196-4.2a4.2 4.2 0 0 0-4.196-4.198m16.245 11.996c-4.487 0-7.737-3.328-7.737-7.798 0-4.4 3.24-7.806 7.737-7.806 4.52 0 7.737 3.439 7.737 7.806 0 4.438-3.253 7.798-7.737 7.798m0-12.046c-2.34 0-4.245 1.906-4.245 4.247s1.904 4.247 4.245 4.247a4.25 4.25 0 0 0 4.245-4.247 4.25 4.25 0 0 0-4.245-4.247\"\n        fill=\"").concat(colors.textColor, "\"\n      />\n    </svg>");
};
var $df29a5258322e53f$export$94e206806e36c2ec = function LoomLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Loom' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $8onqJ.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $8onqJ.defaultLogoParams).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $8onqJ.defaultLogoParams).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $fDucD.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $cVyt1.default), {
        appearance: appearance,
        label: label,
        iconColor: iconColor,
        size: size,
        svg: $df29a5258322e53f$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("3aS7P", function(module, exports) {
$parcel$export(module.exports, "LoomAttributionIcon", () => $24fc4a6d140006a0$export$1bf47cdade1a9fcb);

var $5FkrB = parcelRequire("5FkrB");

var $8onqJ = parcelRequire("8onqJ");

var $ib7qW = parcelRequire("ib7qW");
var $24fc4a6d140006a0$export$1bf47cdade1a9fcb = function LoomAttributionIcon(_ref) {
    var appearance = _ref.appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Loom Attribution' : _ref$label, _ref$size = _ref.size, size = _ref$size === void 0 ? (0, $8onqJ.defaultLogoParams).size : _ref$size, testId = _ref.testId, _ref$iconColor = _ref.iconColor, iconColor = _ref$iconColor === void 0 ? (0, $8onqJ.defaultLogoParams).iconColor : _ref$iconColor, _ref$textColor = _ref.textColor, textColor = _ref$textColor === void 0 ? (0, $8onqJ.defaultLogoParams).textColor : _ref$textColor;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $ib7qW.LoomIcon), {
        appearance: appearance,
        label: label,
        size: size,
        testId: testId,
        iconColor: iconColor,
        textColor: textColor
    });
};

});

parcelRegister("7iJWj", function(module, exports) {
$parcel$export(module.exports, "LoomAttributionLogo", () => $550dd97c2a7853ef$export$6e87ce8d41eda665);

var $5FkrB = parcelRequire("5FkrB");

var $fDucD = parcelRequire("fDucD");

var $8onqJ = parcelRequire("8onqJ");

var $cVyt1 = parcelRequire("cVyt1");

var $8oKXf = parcelRequire("8oKXf");
var $550dd97c2a7853ef$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $8oKXf.getColorsForLoom)(appearance, colorMode);
    return "<svg\n\t\tfill=\"none\"\n\t\theight=\"32\"\n\t\txmlns=\"http://www.w3.org/2000/svg\"\n\t\tfocusable=\"false\"\n\t\taria-hidden=\"true\"\n\t\tviewBox=\"0 0 88 32\"\n\t>\n\t\t<path\n\t\t\td=\"M29.488 12.765h-8.983l7.78-4.344-1.544-2.585-7.78 4.344 4.492-7.523-2.674-1.493-4.491 7.522V0H13.2v8.687L8.71 1.164 6.035 2.657l4.49 7.522-7.778-4.343L1.204 8.42l7.779 4.344H0v2.986h8.982l-7.778 4.343 1.543 2.585 7.78-4.342-4.492 7.522 2.674 1.493L13.2 19.83v8.687h3.087v-8.873l4.574 7.663 2.507-1.4-4.575-7.663 7.946 4.437 1.544-2.586-7.779-4.343h8.982v-2.986h.001Zm-14.744 5.552c-2.318 0-4.197-1.817-4.197-4.059s1.88-4.059 4.197-4.059 4.198 1.817 4.198 4.06c0 2.24-1.88 4.058-4.198 4.058\"\n\t\t\tfill=\"".concat(colors.iconColor, "\"\n\t\t/>\n\t\t<path\n\t\t\td=\"M38.379 26.847V10.094h3.18v16.753zm30.503-11.79h3.036v1.438c.646-1.15 2.153-1.773 3.444-1.773 1.602 0 2.893.695 3.49 1.964.932-1.438 2.177-1.964 3.731-1.964 2.175 0 4.256 1.318 4.256 4.48v7.642h-3.084V19.85c0-1.27-.623-2.228-2.081-2.228-1.363 0-2.177 1.054-2.177 2.324v6.9h-3.155V19.85c0-1.27-.646-2.228-2.081-2.228-1.387 0-2.2 1.03-2.2 2.324v6.9h-3.18V15.057Zm-20.134 12.13c-3.582 0-6.176-2.66-6.176-6.234 0-3.517 2.585-6.242 6.176-6.242 3.609 0 6.177 2.75 6.177 6.242 0 3.547-2.596 6.234-6.177 6.234m0-9.59a3.357 3.357 0 0 0 0 6.713 3.357 3.357 0 0 0 0-6.713m12.966 9.59c-3.583 0-6.177-2.66-6.177-6.234 0-3.517 2.586-6.242 6.177-6.242 3.608 0 6.176 2.75 6.176 6.242 0 3.547-2.597 6.234-6.176 6.234m0-9.63a3.397 3.397 0 0 0-3.39 3.395 3.397 3.397 0 0 0 3.39 3.395 3.396 3.396 0 0 0 0-6.79M64.933 5.63c0-1.102-.697-1.522-1.983-1.837-.803-.21-1.018-.368-1.018-.63q0-.473.804-.473c.643 0 1.286.21 1.93.473V1.798a4.5 4.5 0 0 0-1.876-.42c-1.447 0-2.25.682-2.25 1.785 0 1.05.696 1.575 1.928 1.838.804.157 1.072.315 1.072.682 0 .263-.215.473-.804.473a4.46 4.46 0 0 1-2.197-.63v1.417c.483.263 1.233.473 2.197.473 1.5.052 2.197-.683 2.197-1.785Zm16.662-4.067v5.988h1.3V3.007l.542 1.23 1.841 3.368h1.626V1.563h-1.3v3.85l-.488-1.123-1.463-2.727zm-8.056 0h-1.465v6.042h1.465zm-23.981 0v6.042h2.863l.432-1.295h-1.945V1.563zm-5.671 0v1.295h1.604v4.747h1.44V2.858h1.715V1.563zm-2.177 0h-1.802l-2.066 6.042h1.59l.317-1.025a4 4 0 0 0 1.113.162q.556 0 1.113-.162l.318 1.025h1.59zm-.9 3.938a3 3 0 0 1-.743-.108l.742-2.643.742 2.643c-.265.054-.477.108-.742.108Zm16.577-3.938H55.53L53.4 7.605h1.638l.328-1.025q.573.162 1.146.162.574 0 1.147-.162l.328 1.025h1.638l-2.24-6.042Zm-.928 3.938c-.273 0-.546-.054-.765-.108l.765-2.643.764 2.643a3.3 3.3 0 0 1-.764.108m21.98-3.938h-1.857l-2.13 6.042h1.638l.328-1.025q.574.162 1.147.162c.573 0 .764-.054 1.146-.162l.328 1.025h1.638zm-.93 3.938c-.272 0-.545-.054-.763-.108l.764-2.643.765 2.643a3.3 3.3 0 0 1-.765.108Zm-6.894.129c0-1.102-.697-1.522-1.983-1.837-.803-.21-1.018-.368-1.018-.63q0-.473.804-.473c.643 0 1.286.21 1.93.473V1.798a4.5 4.5 0 0 0-1.876-.42c-1.447 0-2.25.682-2.25 1.785 0 1.05.696 1.575 1.928 1.838.804.157 1.072.315 1.072.682 0 .263-.215.473-.804.473-.75 0-1.608-.263-2.197-.63v1.417c.482.263 1.233.473 2.197.473 1.447.052 2.197-.683 2.197-1.785Z\"\n\t\t\tfill=\"").concat(colors.textColor, "\"\n\t\t/>\n\t</svg>");
};
var $550dd97c2a7853ef$export$6e87ce8d41eda665 = function LoomAttributionLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Loom Attribution' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $8onqJ.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $8onqJ.defaultLogoParams).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $8onqJ.defaultLogoParams).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $fDucD.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $cVyt1.default), {
        appearance: appearance,
        label: label,
        iconColor: iconColor,
        size: size,
        svg: $550dd97c2a7853ef$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("1Ecyk", function(module, exports) {
$parcel$export(module.exports, "OpsgenieIcon", () => $133343937fec1563$export$eeccc49dc7a12d9f);

var $5FkrB = parcelRequire("5FkrB");

var $fDucD = parcelRequire("fDucD");

var $8onqJ = parcelRequire("8onqJ");

var $cVyt1 = parcelRequire("cVyt1");

var $8oKXf = parcelRequire("8oKXf");
var $133343937fec1563$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor;
    var colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $8oKXf.getColorsFromAppearance)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" viewBox=\"0 0 32 32\" focusable=\"false\" aria-hidden=\"true\" xmlns=\"http://www.w3.org/2000/svg\">\n      <path fill=\"".concat(colors.iconColor, "\" d=\"M17.114 28.127c-.785.578-1.199.537-1.984-.041-3.8-2.727-7.313-5.826-9.668-9.049-.248-.33-.124-.785.248-.991l4.297-2.686q.558-.372.992.124c1.652 1.9 3.264 3.76 5.123 5.082 1.86-1.322 3.47-3.181 5.123-5.082q.434-.495.992-.124l4.297 2.686c.372.206.496.66.248.991-2.355 3.223-5.867 6.322-9.668 9.09m-.992-11.858c3.388 0 6.198-2.768 6.198-6.156s-2.81-6.239-6.198-6.239-6.198 2.81-6.198 6.239c0 3.43 2.727 6.156 6.198 6.156\"/>\n    </svg>");
};
var $133343937fec1563$export$eeccc49dc7a12d9f = function OpsgenieIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Opsgenie' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $8onqJ.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $8onqJ.defaultLogoParams).textColor : _ref2$textColor, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $8onqJ.defaultLogoParams).iconColor : _ref2$iconColor;
    var _useThemeObserver = (0, $fDucD.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $cVyt1.default), {
        appearance: appearance,
        svg: $133343937fec1563$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        label: label,
        size: size,
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("9Cz1a", function(module, exports) {
$parcel$export(module.exports, "OpsgenieLogo", () => $7012d37ccd20defe$export$a1c6484cdecc2c4b);

var $5FkrB = parcelRequire("5FkrB");

var $fDucD = parcelRequire("fDucD");

var $8onqJ = parcelRequire("8onqJ");

var $cVyt1 = parcelRequire("cVyt1");

var $8oKXf = parcelRequire("8oKXf");
var $7012d37ccd20defe$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $8oKXf.getColorsFromAppearance)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" viewBox=\"0 0 154 32\" focusable=\"false\" aria-hidden=\"true\" xmlns=\"http://www.w3.org/2000/svg\">\n      <path fill=\"".concat(colors.iconColor, "\" d=\"M11.78 28.127c-.785.578-1.198.537-1.983-.041-3.801-2.727-7.313-5.826-9.668-9.049-.248-.33-.124-.785.248-.991l4.297-2.686q.558-.372.991.124c1.653 1.9 3.264 3.76 5.124 5.082 1.859-1.322 3.47-3.181 5.123-5.082q.435-.495.992-.124l4.297 2.686c.371.206.495.66.247.991-2.355 3.223-5.867 6.322-9.668 9.09m-.99-11.857c3.388 0 6.197-2.768 6.197-6.156s-2.81-6.239-6.197-6.239-6.198 2.81-6.198 6.239c0 3.43 2.727 6.156 6.198 6.156\"/>\n      <path fill=\"").concat(colors.textColor, "\" d=\"M146.689 12.293c-2.79 0-4.201 1.81-4.477 4.477h8.556c-.153-2.852-1.441-4.477-4.079-4.477m5.888 12.635c-1.257.674-3.189.92-4.753.92-5.735 0-8.249-3.312-8.249-8.004 0-4.631 2.576-7.943 7.237-7.943 4.723 0 6.624 3.281 6.624 7.943v1.196h-11.193c.368 2.606 2.054 4.293 5.673 4.293 1.779 0 3.281-.337 4.661-.828zM133.385 6.16c0-1.166.767-1.84 1.841-1.84s1.84.674 1.84 1.84-.767 1.84-1.84 1.84c-1.074 0-1.841-.675-1.841-1.84m.491 19.38V10.208h2.638v15.334zm-3.677-8.984v8.985h-2.638V16.28c0-2.76-1.104-3.987-3.618-3.987-2.454 0-4.14 1.625-4.14 4.723v8.525h-2.638V10.208h2.638v2.514c.981-1.81 2.79-2.821 4.845-2.821 3.527 0 5.551 2.423 5.551 6.655m-22.921-4.263c-2.791 0-4.201 1.81-4.477 4.477h8.556c-.154-2.852-1.442-4.477-4.079-4.477m5.888 12.635c-1.257.674-3.189.92-4.753.92-5.735 0-8.25-3.312-8.25-8.004 0-4.631 2.576-7.943 7.238-7.943 4.722 0 6.624 3.281 6.624 7.943v1.196h-11.194c.368 2.606 2.055 4.293 5.674 4.293 1.778 0 3.281-.337 4.661-.828zm-18.639-.614v-1.533c-.981 2.024-2.821 3.067-5.182 3.067-4.048 0-6.072-3.466-6.072-7.974 0-4.324 2.116-7.973 6.378-7.973 2.239 0 3.956 1.012 4.876 3.005v-2.698h2.576V24.16c0 4.508-2.116 7.544-7.605 7.544-2.576 0-3.987-.337-5.459-.828V28.3c1.687.552 3.435.92 5.336.92 3.834 0 5.152-2.055 5.152-4.907m-8.678-6.44c0 3.68 1.472 5.52 4.2 5.52 2.362 0 4.478-1.503 4.478-4.906V17.26c0-3.404-1.932-4.907-4.17-4.907-2.975 0-4.508 1.963-4.508 5.52m-4.703 3.497c0 2.545-1.656 4.477-5.765 4.477-2.3 0-4.17-.52-5.336-1.134v-2.79c1.319.766 3.527 1.502 5.459 1.502 2.024 0 3.066-.828 3.066-2.024 0-1.165-.89-1.84-3.802-2.545-3.404-.829-4.846-2.147-4.846-4.662 0-2.668 2.055-4.293 5.55-4.293 1.994 0 3.804.49 4.938 1.104v2.73c-1.84-.92-3.342-1.411-4.968-1.411-1.932 0-2.974.674-2.974 1.87 0 1.073.736 1.748 3.557 2.423 3.404.828 5.121 2.085 5.121 4.753m-16.274-3.496c0-3.68-1.472-5.52-4.202-5.52-2.36 0-4.477 1.503-4.477 4.907v1.227c0 3.404 1.932 4.906 4.17 4.906 2.975 0 4.509-1.962 4.509-5.52m-3.803 7.974c-2.239 0-3.956-1.013-4.876-3.006v8.679h-2.637V10.207h2.637v2.76c.981-2.024 2.821-3.066 5.183-3.066 4.079 0 6.133 3.465 6.133 7.973 0 4.324-2.147 7.973-6.44 7.973m-20.121 0c-6.225 0-9.721-4.293-9.721-10.426 0-6.072 3.496-10.335 9.721-10.335 6.195 0 9.69 4.263 9.69 10.335 0 6.133-3.495 10.426-9.69 10.426m0-18.124c-4.968 0-6.961 3.527-6.961 7.698 0 4.262 1.993 7.789 6.961 7.789 4.937 0 6.93-3.527 6.93-7.79 0-4.17-1.993-7.697-6.93-7.697\" />\n    </svg>");
};
var $7012d37ccd20defe$export$a1c6484cdecc2c4b = function OpsgenieLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Opsgenie' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $8onqJ.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $8onqJ.defaultLogoParams).textColor : _ref2$textColor, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $8onqJ.defaultLogoParams).iconColor : _ref2$iconColor;
    var _useThemeObserver = (0, $fDucD.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $cVyt1.default), {
        appearance: appearance,
        iconColor: iconColor,
        label: label,
        size: size,
        svg: $7012d37ccd20defe$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("cXDs6", function(module, exports) {
$parcel$export(module.exports, "RovoIcon", () => $96f99918f881107b$export$e23ae35269442b4f);

var $5FkrB = parcelRequire("5FkrB");

var $fDucD = parcelRequire("fDucD");

var $8onqJ = parcelRequire("8onqJ");

var $cVyt1 = parcelRequire("cVyt1");

var $8oKXf = parcelRequire("8oKXf");
var $96f99918f881107b$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor;
    var colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $8oKXf.getColorsFromAppearance)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" focusable=\"false\" aria-hidden=\"true\">\n    <g fill=\"".concat(colors.iconColor, "\" fill-rule=\"evenodd\">\n      <path d=\"M17.06 4.246a2.79 2.79 0 0 0-2.736-.026l-.049.033-.002.001c-.605.35-1.048.91-1.256 1.558-.085.268-.13.552-.13.842v3.675l4.603 2.656a3.64 3.64 0 0 1 1.824 3.155v9.487a3.6 3.6 0 0 1-.214 1.23l6.175-3.566a2.77 2.77 0 0 0 1.392-2.407v-9.487c0-.991-.532-1.912-1.392-2.408z\"/>\n      <path d=\"m6.058 9 6.176-3.566a3.7 3.7 0 0 0-.214 1.23v9.486c0 1.303.693 2.505 1.823 3.155l4.604 2.657v3.674c0 .29-.045.575-.13.843a2.8 2.8 0 0 1-1.258 1.558.4.4 0 0 0-.05.033c-.851.47-1.89.461-2.735-.026L6.06 23.301a2.78 2.78 0 0 1-1.392-2.408v-9.486c0-.996.529-1.912 1.391-2.408z\"/>\n    </g>\n  </svg>");
};
var $96f99918f881107b$export$e23ae35269442b4f = function RovoIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Rovo' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $8onqJ.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $8onqJ.defaultLogoParams).textColor : _ref2$textColor, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $8onqJ.defaultLogoParams).iconColor : _ref2$iconColor;
    var _useThemeObserver = (0, $fDucD.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $cVyt1.default), {
        appearance: appearance,
        svg: $96f99918f881107b$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        label: label,
        size: size,
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("cCXyV", function(module, exports) {
$parcel$export(module.exports, "RovoLogo", () => $93173c7c8bd4c45d$export$a0f6cb8061290bbb);

var $5FkrB = parcelRequire("5FkrB");

var $fDucD = parcelRequire("fDucD");

var $8onqJ = parcelRequire("8onqJ");

var $cVyt1 = parcelRequire("cVyt1");

var $8oKXf = parcelRequire("8oKXf");
var $93173c7c8bd4c45d$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $8oKXf.getColorsFromAppearance)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" viewBox=\"0 0 100 32\" focusable=\"false\" aria-hidden=\"true\" xmlns=\"http://www.w3.org/2000/svg\">\n      <path\n        d=\"M12.393 4.246a2.79 2.79 0 0 0-2.735-.026.4.4 0 0 1-.05.033l-.001.001c-.606.35-1.048.91-1.257 1.558q-.129.404-.13.842v3.675l4.603 2.656a3.64 3.64 0 0 1 1.824 3.155v9.487a3.6 3.6 0 0 1-.214 1.23l6.175-3.566A2.77 2.77 0 0 0 22 20.884v-9.487c0-.991-.532-1.912-1.392-2.408z\"\n        fill=\"".concat(colors.iconColor, "\"\n        fillRule=\"evenodd\"\n      />\n      <path\n        d=\"m1.391 9 6.176-3.566a3.6 3.6 0 0 0-.214 1.23v9.486c0 1.303.693 2.505 1.823 3.155h.001l4.603 2.657v3.674c0 .29-.045.575-.13.843a2.8 2.8 0 0 1-1.258 1.558.4.4 0 0 0-.05.033c-.85.47-1.89.461-2.734-.026l-8.216-4.743A2.78 2.78 0 0 1 0 20.893v-9.486c0-.996.529-1.912 1.391-2.408z\"\n        fill=\"").concat(colors.iconColor, "\"\n        fillRule=\"evenodd\"\n      />\n      <path\n        d=\"M91.688 25.848c-4.6 0-7.298-3.404-7.298-8.004S87.088 9.9 91.688 9.9c4.57 0 7.238 3.342 7.238 7.942s-2.668 8.004-7.238 8.004zm0-13.494c-3.28 0-4.722 2.576-4.722 5.49 0 2.913 1.441 5.55 4.722 5.55 3.251 0 4.662-2.637 4.662-5.55 0-2.914-1.41-5.49-4.662-5.49M77.675 25.54H74.15L68.2 10.208h2.76l4.968 13.094 4.938-13.095h2.76zm-17.462.308c-4.6 0-7.299-3.404-7.299-8.004s2.7-7.943 7.3-7.943c4.568 0 7.236 3.342 7.236 7.942s-2.668 8.004-7.237 8.004zm0-13.494c-3.281 0-4.723 2.576-4.723 5.49 0 2.913 1.442 5.55 4.723 5.55 3.25 0 4.661-2.637 4.661-5.55 0-2.914-1.41-5.49-4.66-5.49zM43.177 8.03H39.13v7.36h4.048c3.588 0 4.692-1.38 4.692-3.68 0-2.177-1.134-3.68-4.692-3.68zm7.452 3.619c0 3.036-1.288 5.09-3.956 5.949l4.938 7.943H48.36l-4.447-7.514H39.13v7.514h-2.76V5.393h7.115c4.815 0 7.145 2.392 7.145 6.256z\"\n        fill=\"").concat(colors.textColor, "\"\n      />\n    </svg>");
};
var $93173c7c8bd4c45d$export$a0f6cb8061290bbb = function RovoLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Rovo' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $8onqJ.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $8onqJ.defaultLogoParams).textColor : _ref2$textColor, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $8onqJ.defaultLogoParams).iconColor : _ref2$iconColor;
    var _useThemeObserver = (0, $fDucD.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $cVyt1.default), {
        appearance: appearance,
        iconColor: iconColor,
        label: label,
        size: size,
        svg: $93173c7c8bd4c45d$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("jF9fd", function(module, exports) {
$parcel$export(module.exports, "StatuspageIcon", () => $e5090466625d94f8$export$f3f5aa321d88adf9);

var $5FkrB = parcelRequire("5FkrB");

var $fDucD = parcelRequire("fDucD");

var $8onqJ = parcelRequire("8onqJ");

var $cVyt1 = parcelRequire("cVyt1");

var $8oKXf = parcelRequire("8oKXf");
var $e5090466625d94f8$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor;
    var colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $8oKXf.getColorsFromAppearance)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" viewBox=\"0 0 32 32\" focusable=\"false\" aria-hidden=\"true\" xmlns=\"http://www.w3.org/2000/svg\">\n      <path fill=\"".concat(colors.iconColor, "\" d=\"M16 12.604c-3.033 0-5.981 1.37-8.39 3.489q-.375.373-.748.373c-.208 0-.415-.124-.581-.332l-3.032-3.572c-.166-.207-.25-.415-.25-.581 0-.25.125-.457.374-.706 3.655-3.24 8.1-5.067 12.627-5.067s8.97 1.827 12.626 5.067c.249.249.374.457.374.706 0 .166-.084.374-.25.581l-3.032 3.572c-.166.208-.373.332-.581.332q-.374 0-.748-.374c-2.409-2.118-5.358-3.488-8.39-3.488m0 13.374c-3.365 0-6.106-2.742-6.106-6.064S12.635 13.85 16 13.85s6.106 2.7 6.106 6.064-2.741 6.063-6.105 6.063\"/>\n    </svg>");
};
var $e5090466625d94f8$export$f3f5aa321d88adf9 = function StatuspageIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Statuspage' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $8onqJ.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $8onqJ.defaultLogoParams).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $8onqJ.defaultLogoParams).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $fDucD.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $cVyt1.default), {
        appearance: appearance,
        label: label,
        svg: $e5090466625d94f8$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("dNxlG", function(module, exports) {
$parcel$export(module.exports, "StatuspageLogo", () => $a0b9b85073824ba8$export$bb4ae5b41b43be04);

var $5FkrB = parcelRequire("5FkrB");

var $fDucD = parcelRequire("fDucD");

var $8onqJ = parcelRequire("8onqJ");

var $cVyt1 = parcelRequire("cVyt1");

var $8oKXf = parcelRequire("8oKXf");
var $a0b9b85073824ba8$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $8oKXf.getColorsFromAppearance)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" viewBox=\"0 0 188 32\" focusable=\"false\" aria-hidden=\"true\" xmlns=\"http://www.w3.org/2000/svg\">\n      <path fill=\"".concat(colors.iconColor, "\" d=\"M13 12.604c-3.032 0-5.98 1.37-8.39 3.489q-.373.373-.747.373c-.208 0-.416-.124-.582-.332L.25 12.562c-.167-.207-.25-.415-.25-.581 0-.25.125-.457.374-.706C4.029 8.035 8.473 6.208 13 6.208s8.971 1.827 12.626 5.067c.25.249.374.457.374.706 0 .166-.083.374-.25.581l-3.031 3.572c-.166.208-.374.332-.582.332q-.373 0-.747-.374c-2.41-2.118-5.358-3.488-8.39-3.488m0 13.374c-3.364 0-6.105-2.742-6.105-6.064S9.635 13.85 13 13.85c3.364 0 6.105 2.7 6.105 6.064s-2.74 6.063-6.105 6.063\" />\n      <path fill=\"").concat(colors.textColor, "\" d=\"M180.293 12.293c-2.79 0-4.201 1.81-4.477 4.477h8.556c-.153-2.852-1.441-4.477-4.079-4.477m5.888 12.635c-1.257.674-3.189.92-4.753.92-5.735 0-8.249-3.312-8.249-8.004 0-4.631 2.576-7.943 7.237-7.943 4.723 0 6.624 3.281 6.624 7.943v1.196h-11.193c.368 2.606 2.054 4.293 5.673 4.293 1.779 0 3.281-.337 4.661-.828zm-18.638-.614v-1.533c-.981 2.024-2.821 3.067-5.183 3.067-4.048 0-6.072-3.466-6.072-7.974 0-4.324 2.116-7.973 6.379-7.973 2.239 0 3.956 1.012 4.876 3.005v-2.698h2.576V24.16c0 4.508-2.116 7.544-7.605 7.544-2.576 0-3.987-.337-5.459-.828V28.3c1.687.552 3.435.92 5.336.92 3.833 0 5.152-2.055 5.152-4.907m-8.679-6.44c0 3.68 1.472 5.52 4.202 5.52 2.361 0 4.477-1.503 4.477-4.906V17.26c0-3.404-1.932-4.907-4.171-4.907-2.974 0-4.508 1.963-4.508 5.52m-16.949.001c0 3.68 1.472 5.52 4.201 5.52 2.362 0 4.478-1.503 4.478-4.906V17.26c0-3.404-1.932-4.907-4.171-4.907-2.975 0-4.508 1.963-4.508 5.52m8.679 7.667v-2.76c-.982 2.024-2.822 3.066-5.183 3.066-4.079 0-6.133-3.465-6.133-7.973 0-4.324 2.146-7.973 6.44-7.973 2.238 0 3.956 1.012 4.876 3.005v-2.699h2.637V25.54zm-16.091-7.666c0-3.68-1.472-5.52-4.201-5.52-2.361 0-4.477 1.503-4.477 4.907v1.227c0 3.404 1.932 4.906 4.17 4.906 2.975 0 4.508-1.962 4.508-5.52m-3.802 7.974c-2.239 0-3.956-1.013-4.876-3.006v8.679h-2.638V10.207h2.638v2.76c.981-2.024 2.821-3.066 5.182-3.066 4.079 0 6.134 3.465 6.134 7.973 0 4.324-2.147 7.973-6.44 7.973m-10.56-4.477c0 2.545-1.656 4.477-5.765 4.477-2.3 0-4.171-.52-5.336-1.134v-2.79c1.318.766 3.526 1.502 5.458 1.502 2.024 0 3.067-.828 3.067-2.024 0-1.165-.889-1.84-3.803-2.545-3.404-.829-4.845-2.147-4.845-4.662 0-2.668 2.055-4.293 5.551-4.293 1.993 0 3.802.49 4.937 1.104v2.73c-1.84-.92-3.343-1.411-4.968-1.411-1.932 0-2.975.674-2.975 1.87 0 1.073.736 1.748 3.558 2.423 3.404.828 5.121 2.085 5.121 4.753m-27.598-2.177v-8.985h2.638v9.26c0 2.76 1.104 3.988 3.618 3.988 2.454 0 4.14-1.626 4.14-4.723v-8.525h2.638V25.54h-2.638v-2.515c-.981 1.81-2.79 2.821-4.845 2.821-3.527 0-5.55-2.422-5.55-6.654m-7.155 1.596c0 1.349.797 2.269 2.422 2.269.614 0 1.196-.123 1.656-.215v2.546a6.3 6.3 0 0 1-1.778.245c-3.282 0-4.876-1.932-4.876-4.784v-8.188h-2.484v-2.453h2.484V6.957h2.576v3.25h4.078v2.454H85.39zm-18.943-2.914c0 3.68 1.472 5.52 4.202 5.52 2.361 0 4.477-1.503 4.477-4.906V17.26c0-3.404-1.932-4.907-4.17-4.907-2.975 0-4.509 1.963-4.509 5.52m8.679 7.667v-2.76c-.981 2.024-2.821 3.066-5.183 3.066-4.078 0-6.133-3.465-6.133-7.973 0-4.324 2.147-7.973 6.44-7.973 2.239 0 3.956 1.012 4.876 3.005v-2.699h2.637V25.54zm-17.258-4.752c0 1.349.797 2.269 2.422 2.269.614 0 1.196-.123 1.656-.215v2.546a6.3 6.3 0 0 1-1.778.245c-3.282 0-4.876-1.932-4.876-4.784v-8.188h-2.484v-2.453h2.484V6.957h2.576v3.25h4.078v2.454h-4.078zm-6.894-.798c0 3.496-2.085 5.858-7.084 5.858-3.894 0-5.704-.767-7.268-1.564v-2.822c1.871.982 4.754 1.687 7.422 1.687 3.036 0 4.17-1.196 4.17-2.975 0-1.778-1.104-2.729-4.937-3.649-4.539-1.104-6.563-2.668-6.563-5.98 0-3.128 2.392-5.459 7.084-5.459 2.914 0 4.784.706 6.164 1.472v2.76c-2.024-1.165-4.201-1.533-6.286-1.533-2.638 0-4.202.92-4.202 2.76 0 1.656 1.288 2.484 4.846 3.373 4.262 1.074 6.654 2.454 6.654 6.072\" />\n    </svg>");
};
var $a0b9b85073824ba8$export$bb4ae5b41b43be04 = function StatuspageLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Statuspage' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $8onqJ.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $8onqJ.defaultLogoParams).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $8onqJ.defaultLogoParams).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $fDucD.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $cVyt1.default), {
        appearance: appearance,
        label: label,
        iconColor: iconColor,
        size: size,
        svg: $a0b9b85073824ba8$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("9QwCx", function(module, exports) {
$parcel$export(module.exports, "TrelloIcon", () => $72b24621895b039d$export$4384da9b8b140bf4);

var $5FkrB = parcelRequire("5FkrB");

var $fDucD = parcelRequire("fDucD");

var $8onqJ = parcelRequire("8onqJ");

var $cVyt1 = parcelRequire("cVyt1");

var $8oKXf = parcelRequire("8oKXf");
var $72b24621895b039d$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor;
    var colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $8oKXf.getColorsFromAppearance)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" viewBox=\"0 0 32 32\" focusable=\"false\" aria-hidden=\"true\" xmlns=\"http://www.w3.org/2000/svg\">\n      <path fill=".concat(colors.iconColor, " clip-rule=\"evenodd\" d=\"M24.286 5.337H7.714a2.585 2.585 0 0 0-2.585 2.585v16.572a2.585 2.585 0 0 0 2.585 2.584h16.572a2.585 2.585 0 0 0 2.585-2.584V7.922a2.585 2.585 0 0 0-2.585-2.585m-9.791 15.66a.86.86 0 0 1-.859.858h-3.634a.86.86 0 0 1-.859-.859V10.21a.86.86 0 0 1 .859-.86h3.634a.86.86 0 0 1 .859.86zm8.362-4.953a.86.86 0 0 1-.859.859h-3.634a.86.86 0 0 1-.859-.859V10.21a.86.86 0 0 1 .859-.86h3.634a.86.86 0 0 1 .859.86z\" fill-rule=\"evenodd\"/>\n    </svg>");
};
var $72b24621895b039d$export$4384da9b8b140bf4 = function TrelloIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Trello' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $8onqJ.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $8onqJ.defaultLogoParams).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $8onqJ.defaultLogoParams).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $fDucD.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $cVyt1.default), {
        appearance: appearance,
        label: label,
        svg: $72b24621895b039d$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("aiAVF", function(module, exports) {
$parcel$export(module.exports, "TrelloLogo", () => $77f83b2a64e78b50$export$60e26212f3b61a28);

var $5FkrB = parcelRequire("5FkrB");

var $fDucD = parcelRequire("fDucD");

var $8onqJ = parcelRequire("8onqJ");

var $cVyt1 = parcelRequire("cVyt1");

var $8oKXf = parcelRequire("8oKXf");
var $77f83b2a64e78b50$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $8oKXf.getColorsFromAppearance)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" viewBox=\"0 0 106 32\" focusable=\"false\" aria-hidden=\"true\" xmlns=\"http://www.w3.org/2000/svg\">\n      <path fill=\"".concat(colors.iconColor, "\" clip-rule=\"evenodd\" d=\"M19.157 4.67H2.585A2.585 2.585 0 0 0 0 7.255v16.572a2.585 2.585 0 0 0 2.585 2.585h16.572a2.585 2.585 0 0 0 2.584-2.585V7.255a2.585 2.585 0 0 0-2.584-2.585M9.365 20.33a.86.86 0 0 1-.858.858H4.873a.86.86 0 0 1-.859-.858V9.543c0-.475.385-.859.859-.859h3.634c.474 0 .858.385.858.86zm8.362-4.952a.86.86 0 0 1-.858.858h-3.634a.86.86 0 0 1-.859-.858V9.543c0-.475.385-.859.859-.859h3.634c.474 0 .858.385.858.86z\" fill-rule=\"evenodd\"/>\n      <path fill=\"").concat(colors.textColor, "\" d=\"M97.64 25.848c-4.6 0-7.298-3.404-7.298-8.004S93.04 9.9 97.64 9.9c4.57 0 7.238 3.342 7.238 7.942s-2.668 8.004-7.238 8.004m0-13.494c-3.281 0-4.722 2.576-4.722 5.49 0 2.913 1.44 5.55 4.722 5.55 3.251 0 4.662-2.637 4.662-5.55 0-2.914-1.411-5.49-4.662-5.49M88.874 25.51c-.215.062-.675.123-1.35.123-2.514 0-4.109-1.196-4.109-4.017V3.798h2.637V21.31c0 1.38.92 1.87 2.055 1.87.276 0 .46 0 .767-.03zm-7.996 0c-.215.062-.675.123-1.35.123-2.514 0-4.109-1.196-4.109-4.017V3.798h2.637V21.31c0 1.38.92 1.87 2.055 1.87.276 0 .46 0 .767-.03zM65.532 12.293c-2.79 0-4.202 1.81-4.478 4.477h8.556c-.153-2.852-1.44-4.477-4.078-4.477m5.888 12.635c-1.258.674-3.19.92-4.754.92-5.734 0-8.249-3.312-8.249-8.004 0-4.631 2.576-7.943 7.237-7.943 4.723 0 6.624 3.281 6.624 7.943v1.196H61.085c.368 2.606 2.055 4.293 5.673 4.293 1.78 0 3.282-.337 4.662-.828zm-19.48-8.434v9.047h-2.576V10.208h2.576v2.698c.89-1.809 2.423-3.097 5.428-2.913v2.576c-3.373-.337-5.428.675-5.428 3.925M32.943 5.393H48.03V8.03h-6.164v17.511h-2.76V8.031h-6.164z\"/>\n    </svg>");
};
var $77f83b2a64e78b50$export$60e26212f3b61a28 = function TrelloLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Trello' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $8onqJ.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $8onqJ.defaultLogoParams).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $8onqJ.defaultLogoParams).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $fDucD.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $cVyt1.default), {
        appearance: appearance,
        label: label,
        iconColor: iconColor,
        size: size,
        svg: $77f83b2a64e78b50$var$svg({
            appearance: appearance,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("5CptS", function(module, exports) {
$parcel$export(module.exports, "AtlasIcon", () => $4174445314181c05$export$9d0b19639662f94b);

var $5FkrB = parcelRequire("5FkrB");

var $fDucD = parcelRequire("fDucD");

var $8onqJ = parcelRequire("8onqJ");

var $cVyt1 = parcelRequire("cVyt1");

var $8oKXf = parcelRequire("8oKXf");
var $4174445314181c05$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance;
    var colors = (0, $8oKXf.getColorsFromAppearance)(appearance ? appearance : 'brand', colorMode);
    return "<svg viewBox=\"0 0 32 32\" focusable=\"false\" aria-hidden=\"true\" height=\"32\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n    <g fill=\"".concat(colors.iconColor, "\">\n      <path d=\"M16 28.532c-6.656 0-12.068-5.412-12.068-12.068S9.344 4.396 16 4.396v1.921c-5.597 0-10.146 4.549-10.146 10.146S10.403 26.609 16 26.609zm0 0v-1.921c5.597 0 10.146-4.549 10.146-10.146h1.921c0 6.656-5.412 12.068-12.068 12.068zm12.068-12.068h-1.921c0-5.597-4.549-10.146-10.146-10.146V4.397c6.656 0 12.068 5.412 12.068 12.068zm-6.928 3.695c-1.28-.251-2.292-.706-3.973-1.467-.464-.204-.974-.436-1.559-.696a59 59 0 0 0-1.003-.436c-2.534-1.123-3.926-1.736-5.634-1.736-1.198 0-2.098.325-2.6.937a1.72 1.72 0 0 0-.38 1.448l-1.885.362a3.67 3.67 0 0 1 .78-3.035c.613-.743 1.82-1.634 4.085-1.634 2.116 0 3.824.761 6.414 1.903.316.14.641.288.994.436.594.26 1.114.492 1.578.706 1.606.724 2.488 1.123 3.555 1.327l-.371 1.885Zm1.877.185c-.64 0-1.253-.056-1.875-.185l.371-1.885c.502.102.994.149 1.504.149 1.188 0 2.089-.298 2.609-.864s.539-1.253.51-1.615l1.913-.167c.102 1.169-.251 2.265-1.003 3.082-.622.677-1.82 1.485-4.029 1.485M16 28.532v-1.921c2.757 0 4.4-2.813 4.4-7.52s-1.67-8.652-5.096-12.3l1.402-1.318c3.778 4.02 5.616 8.476 5.616 13.618 0 5.821-2.423 9.441-6.322 9.441m-.001 0c-4.15 0-6.526-3.379-6.526-9.273 0-6.879 3.008-10.722 5.82-13.776l1.412 1.299c-3.277 3.565-5.31 6.888-5.31 12.476 0 6.08 2.506 7.352 4.604 7.352z\"/>\n      <path d=\"M10.857 17.467a2.247 2.247 0 1 0 0-4.494 2.247 2.247 0 0 0 0 4.494m10.385 3.871a2.247 2.247 0 1 0 0-4.494 2.247 2.247 0 0 0 0 4.494M15.998 7.96a2.247 2.247 0 1 0 0-4.493 2.247 2.247 0 0 0 0 4.494Z\"/>\n    </g>\n  </svg>");
};
var $4174445314181c05$export$9d0b19639662f94b = function AtlasIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Atlas' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $8onqJ.defaultLogoParams).size : _ref2$size, testId = _ref2.testId;
    var _useThemeObserver = (0, $fDucD.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $cVyt1.default), {
        appearance: appearance,
        label: label,
        svg: $4174445314181c05$var$svg({
            appearance: appearance
        }, colorMode),
        size: size,
        testId: testId
    });
};

});

parcelRegister("d7OBx", function(module, exports) {
$parcel$export(module.exports, "AtlasLogo", () => $98e32ec83d30e263$export$e388b783bff06f6c);

var $5FkrB = parcelRequire("5FkrB");

var $fDucD = parcelRequire("fDucD");

var $8onqJ = parcelRequire("8onqJ");

var $cVyt1 = parcelRequire("cVyt1");

var $8oKXf = parcelRequire("8oKXf");
var $98e32ec83d30e263$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance;
    var colors = (0, $8oKXf.getColorsFromAppearance)(appearance ? appearance : 'brand', colorMode);
    return "<svg viewBox=\"0 0 102 32\" focusable=\"false\" aria-hidden=\"true\" height=\"32\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n    <path d=\"M12.068 27.865C5.412 27.865 0 22.453 0 15.797S5.412 3.73 12.068 3.73v1.922c-5.597 0-10.146 4.548-10.146 10.146 0 5.597 4.549 10.145 10.146 10.145z M12.068 27.865v-1.92c5.597 0 10.146-4.55 10.146-10.147h1.921c0 6.656-5.412 12.068-12.068 12.068h.001Zm12.068-12.068h-1.921c0-5.597-4.549-10.146-10.146-10.146V3.73c6.656 0 12.068 5.412 12.068 12.068zm-6.927 3.695c-1.282-.25-2.293-.705-3.974-1.466-.464-.204-.974-.436-1.559-.696a58 58 0 0 0-1.003-.436C8.14 15.77 6.747 15.158 5.04 15.158c-1.198 0-2.098.324-2.6.937a1.72 1.72 0 0 0-.38 1.448l-1.885.362a3.67 3.67 0 0 1 .78-3.035c.613-.743 1.82-1.634 4.085-1.634 2.116 0 3.824.761 6.414 1.903.316.14.641.288.994.436.594.26 1.114.492 1.578.705 1.606.724 2.488 1.124 3.555 1.328l-.371 1.884Z M19.085 19.677c-.64 0-1.253-.056-1.875-.185l.371-1.885c.502.102.994.15 1.504.15 1.188 0 2.089-.298 2.609-.864s.539-1.254.51-1.616l1.913-.167c.102 1.17-.251 2.265-1.003 3.082-.622.677-1.82 1.485-4.029 1.485 M12.068 27.865v-1.92c2.757 0 4.4-2.814 4.4-7.52 0-4.707-1.67-8.652-5.096-12.3l1.402-1.318c3.778 4.02 5.616 8.475 5.616 13.618 0 5.82-2.423 9.44-6.322 9.44 M12.067 27.866c-4.15 0-6.526-3.379-6.526-9.274 0-6.878 3.008-10.722 5.82-13.776l1.412 1.3c-3.277 3.564-5.31 6.888-5.31 12.476 0 6.08 2.506 7.352 4.604 7.352v1.921Z\" fill=\"".concat(colors.iconColor, "\"/>\n    <path d=\"M6.925 16.8a2.247 2.247 0 1 0 0-4.494 2.247 2.247 0 0 0 0 4.494m10.385 3.872a2.247 2.247 0 1 0 0-4.494 2.247 2.247 0 0 0 0 4.494M12.066 7.294a2.247 2.247 0 1 0 0-4.494 2.247 2.247 0 0 0 0 4.494\" fill=\"").concat(colors.iconColor, "\"/>\n    <path d=\"M101.019 21.163c0 2.545-1.656 4.477-5.766 4.477-2.3 0-4.17-.521-5.336-1.135v-2.79c1.319.766 3.527 1.502 5.459 1.502 2.024 0 3.067-.828 3.067-2.024 0-1.165-.89-1.84-3.803-2.545-3.404-.828-4.845-2.147-4.845-4.661 0-2.668 2.054-4.294 5.55-4.294 1.994 0 3.803.491 4.938 1.104v2.73c-1.84-.92-3.343-1.411-4.968-1.411-1.932 0-2.975.675-2.975 1.87 0 1.074.736 1.749 3.557 2.423 3.404.828 5.122 2.086 5.122 4.754m-25.873-3.496c0 3.68 1.472 5.52 4.2 5.52 2.362 0 4.478-1.503 4.478-4.907v-1.227c0-3.404-1.932-4.906-4.17-4.906-2.975 0-4.508 1.962-4.508 5.52m8.678 7.666v-2.76c-.981 2.024-2.821 3.067-5.182 3.067-4.08 0-6.134-3.465-6.134-7.973 0-4.324 2.147-7.974 6.44-7.974 2.239 0 3.956 1.012 4.876 3.006V10h2.638v15.333zm-12.784-.03c-.214.061-.674.122-1.349.122-2.514 0-4.11-1.196-4.11-4.017V3.591h2.638V21.1c0 1.38.92 1.871 2.055 1.871.276 0 .46 0 .767-.03v2.36ZM58.12 20.58c0 1.35.798 2.27 2.423 2.27.614 0 1.196-.123 1.656-.215v2.545a6.3 6.3 0 0 1-1.779.245c-3.28 0-4.876-1.932-4.876-4.784v-8.188h-2.483V10h2.483V6.75h2.577V10h4.078v2.453h-4.078v8.127Zm-14.675.736c-1.533 0-3.097-.184-4.814-.521l-1.687 4.538h-3.097l7.942-20.148h3.496l7.943 20.148h-3.097l-1.687-4.569c-1.81.368-3.373.552-4.999.552m0-2.453c1.288 0 2.607-.154 4.171-.399l-4.079-11.04-4.078 11.07c1.502.246 2.76.369 3.986.369\" fill=\"").concat(colors.textColor, "\"/>\n  </svg>");
};
var $98e32ec83d30e263$export$e388b783bff06f6c = function AtlasLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Atlas' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $8onqJ.defaultLogoParams).size : _ref2$size, testId = _ref2.testId;
    var _useThemeObserver = (0, $fDucD.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $cVyt1.default), {
        appearance: appearance,
        label: label,
        size: size,
        svg: $98e32ec83d30e263$var$svg({
            appearance: appearance
        }, colorMode),
        testId: testId
    });
};

});

parcelRegister("6ChEY", function(module, exports) {
$parcel$export(module.exports, "AtlassianMarketplaceIcon", () => $4d13fd8db0387c2f$export$94c87d39a54a1894);

var $5FkrB = parcelRequire("5FkrB");

var $fDucD = parcelRequire("fDucD");

var $8onqJ = parcelRequire("8onqJ");

var $cVyt1 = parcelRequire("cVyt1");

var $8oKXf = parcelRequire("8oKXf");
var $4d13fd8db0387c2f$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor;
    var colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $8oKXf.getColorsFromAppearance)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" focusable=\"false\" aria-hidden=\"true\">\n    <path fill=\"".concat(colors.iconColor, "\" d=\"M27.545 24.817 16.96 3.647c-.208-.458-.417-.541-.667-.541-.208 0-.458.083-.708.5-1.5 2.375-2.167 5.126-2.167 8 0 4.002 2.042 7.752 5.042 13.795.334.666.584.791 1.167.791h7.335c.541 0 .833-.208.833-.625 0-.208-.042-.333-.25-.75M12.168 14.816c-.834-1.25-1.084-1.334-1.292-1.334s-.333.084-.708.834L4.875 24.9c-.167.334-.208.459-.208.626 0 .333.291.666.916.666h7.46c.5 0 .875-.416 1.083-1.208.25-1 .334-1.875.334-2.917 0-2.917-1.292-5.751-2.292-7.251\"/>\n  </svg>\n  ");
};
var $4d13fd8db0387c2f$export$94c87d39a54a1894 = function AtlassianMarketplaceIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Atlassian Marketplace' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $8onqJ.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $8onqJ.defaultLogoParams).textColor : _ref2$textColor, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $8onqJ.defaultLogoParams).iconColor : _ref2$iconColor;
    var _useThemeObserver = (0, $fDucD.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $cVyt1.default), {
        appearance: appearance,
        svg: $4d13fd8db0387c2f$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        label: label,
        size: size,
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("1jkeE", function(module, exports) {
$parcel$export(module.exports, "AtlassianMarketplaceLogo", () => $0f47431498944ba2$export$32e7eace0c9d6a57);

var $5FkrB = parcelRequire("5FkrB");

var $fDucD = parcelRequire("fDucD");

var $8onqJ = parcelRequire("8onqJ");

var $cVyt1 = parcelRequire("cVyt1");

var $8oKXf = parcelRequire("8oKXf");
var $0f47431498944ba2$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $8oKXf.getColorsFromAppearance)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 377 32\" focusable=\"false\" aria-hidden=\"true\">\n      <path\n        d=\"M369.828 12.524c-2.79 0-4.201 1.81-4.477 4.478h8.556c-.153-2.852-1.441-4.478-4.079-4.478m5.888 12.635c-1.257.675-3.189.92-4.753.92-5.735 0-8.249-3.312-8.249-8.004 0-4.63 2.576-7.943 7.237-7.943 4.723 0 6.624 3.282 6.624 7.943v1.196h-11.193c.368 2.607 2.054 4.293 5.673 4.293 1.779 0 3.281-.337 4.661-.828zm-15.093-2.147v2.362c-.92.49-2.331.705-3.741.705-5.459 0-8.004-3.312-8.004-8.004 0-4.63 2.545-7.943 8.004-7.943 1.38 0 2.453.184 3.649.736v2.454c-.981-.46-2.024-.736-3.465-.736-3.987 0-5.612 2.514-5.612 5.489s1.656 5.49 5.673 5.49c1.564 0 2.545-.215 3.496-.553m-26.118-4.906c0 3.68 1.472 5.52 4.201 5.52 2.361 0 4.477-1.503 4.477-4.907v-1.227c0-3.404-1.932-4.906-4.17-4.906-2.975 0-4.508 1.962-4.508 5.52m8.678 7.666v-2.76c-.981 2.024-2.821 3.067-5.182 3.067-4.079 0-6.134-3.465-6.134-7.973 0-4.324 2.147-7.974 6.44-7.974 2.239 0 3.956 1.012 4.876 3.006v-2.699h2.638v15.333zm-12.783-.031c-.215.062-.675.123-1.35.123-2.514 0-4.109-1.196-4.109-4.017V4.03h2.637v17.51c0 1.38.92 1.87 2.055 1.87.276 0 .46 0 .767-.03zm-11.153-7.635c0-3.68-1.472-5.52-4.202-5.52-2.361 0-4.477 1.502-4.477 4.906v1.227c0 3.404 1.932 4.907 4.171 4.907 2.974 0 4.508-1.963 4.508-5.52m-3.803 7.973c-2.239 0-3.956-1.012-4.876-3.005v8.678h-2.637V10.44h2.637v2.76c.981-2.024 2.821-3.067 5.183-3.067 4.078 0 6.133 3.466 6.133 7.974 0 4.324-2.147 7.973-6.44 7.973zm-14.975-5.06c0 1.35.798 2.27 2.423 2.27.613 0 1.196-.123 1.656-.215v2.545a6.3 6.3 0 0 1-1.779.245c-3.281 0-4.876-1.932-4.876-4.784v-8.188h-2.484V10.44h2.484V7.19h2.576v3.25h4.079v2.453h-4.079zm-13.537-8.495c-2.79 0-4.201 1.81-4.477 4.478h8.556c-.153-2.852-1.441-4.478-4.079-4.478m5.888 12.635c-1.257.675-3.189.92-4.753.92-5.735 0-8.249-3.312-8.249-8.004 0-4.63 2.576-7.943 7.237-7.943 4.723 0 6.624 3.282 6.624 7.943v1.196h-11.193c.368 2.607 2.054 4.293 5.673 4.293 1.779 0 3.281-.337 4.661-.828zm-23.82.613h-2.637V4.03H269v13.585l6.593-7.176h3.435l-7.207 7.544 7.514 7.79h-3.588L269 18.595zm-10.333-9.046v9.046h-2.576V10.44h2.576v2.699c.889-1.81 2.422-3.098 5.428-2.914V12.8c-3.374-.337-5.428.675-5.428 3.926m-17.869 1.38c0 3.68 1.472 5.52 4.201 5.52 2.361 0 4.477-1.503 4.477-4.907v-1.227c0-3.404-1.932-4.906-4.17-4.906-2.975 0-4.508 1.962-4.508 5.52m8.678 7.666v-2.76c-.981 2.024-2.821 3.067-5.182 3.067-4.079 0-6.134-3.465-6.134-7.973 0-4.324 2.147-7.974 6.44-7.974 2.239 0 3.956 1.012 4.876 3.006v-2.699h2.638v15.333zm-31.445-11.009-2.76-7.483v18.492h-2.76V5.624h4.784l4.569 11.562 1.871 5.55 1.871-5.55 4.6-11.562h4.446v20.148h-2.76V7.495l-2.361 7.268-4.447 11.01h-2.668z\"\n        fill=\"".concat(colors.textColor, "\"\n      />\n      <path\n        d=\"M107.447 11.267c0 2.972 1.345 5.308 6.795 6.37 3.185.707 3.893 1.203 3.893 2.264 0 1.062-.708 1.699-2.973 1.699-2.619 0-5.733-.92-7.785-2.123v4.812c1.627.779 3.751 1.699 7.785 1.699 5.662 0 7.856-2.548 7.856-6.228m0 .07c0-3.538-1.84-5.166-7.148-6.299-2.902-.637-3.61-1.274-3.61-2.194 0-1.132 1.062-1.628 2.973-1.628 2.335 0 4.6.708 6.794 1.7V6.807c-1.557-.779-3.892-1.345-6.653-1.345-5.237 0-7.927 2.265-7.927 5.945m72.475-5.803v20.172h4.318V10.417l1.769 4.034 6.087 11.325h5.379V5.604h-4.247v13.023l-1.628-3.822-4.883-9.2zm-27.319 0h-4.671v20.172h4.671zm-10.05 14.156c0-3.54-1.841-5.167-7.149-6.3-2.902-.636-3.609-1.273-3.609-2.194 0-1.132 1.061-1.627 2.972-1.627 2.336 0 4.601.707 6.795 1.698v-4.6c-1.557-.779-3.893-1.345-6.653-1.345-5.238 0-7.927 2.265-7.927 5.945 0 2.973 1.345 5.308 6.794 6.37 3.185.708 3.893 1.203 3.893 2.265s-.708 1.699-2.973 1.699c-2.618 0-5.733-.92-7.785-2.124v4.813c1.628.779 3.751 1.699 7.785 1.699 5.592 0 7.857-2.548 7.857-6.3zM71.069 5.604v20.172h9.625l1.486-4.389h-6.44V5.604zm-19.039 0v4.318h5.167v15.854h4.741V9.922h5.592V5.604zm-6.866 0h-6.157L32 25.776h5.379l.99-3.398c1.204.354 2.478.566 3.752.566s2.548-.212 3.751-.566l.991 3.397h5.379c-.07 0-7.078-20.17-7.078-20.17zM42.05 18.698c-.92 0-1.77-.142-2.548-.354l2.548-8.776 2.548 8.776a9.6 9.6 0 0 1-2.548.354M97.326 5.604H91.17l-7.08 20.172h5.38l.99-3.398c1.203.354 2.477.566 3.751.566s2.548-.212 3.751-.566l.991 3.397h5.379zm-3.114 13.094c-.92 0-1.77-.142-2.548-.354l2.548-8.776 2.548 8.776a9.6 9.6 0 0 1-2.548.354m75.306-13.094h-6.157l-7.007 20.172h5.379l.991-3.398c1.203.354 2.477.566 3.751.566s2.548-.212 3.751-.566l.991 3.397h5.379zm-3.043 13.094c-.92 0-1.77-.142-2.548-.354l2.548-8.776 2.548 8.776a10 10 0 0 1-2.548.354M22.878 24.817 12.293 3.647c-.208-.458-.416-.541-.666-.541-.209 0-.459.083-.709.5-1.5 2.375-2.167 5.126-2.167 8 0 4.002 2.042 7.752 5.043 13.795.333.666.583.791 1.166.791h7.335c.542 0 .833-.208.833-.625 0-.208-.041-.333-.25-.75M7.501 14.816c-.833-1.25-1.083-1.334-1.292-1.334s-.333.084-.708.834L.208 24.9c-.166.334-.208.459-.208.626 0 .333.292.666.917.666h7.46c.5 0 .874-.416 1.083-1.208.25-1 .333-1.875.333-2.917 0-2.917-1.292-5.751-2.292-7.251\"\n        fill=\"").concat(colors.iconColor, "\"\n      />\n    </svg>");
};
var $0f47431498944ba2$export$32e7eace0c9d6a57 = function AtlassianMarketplaceLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Atlassian Marketplace' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $8onqJ.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $8onqJ.defaultLogoParams).textColor : _ref2$textColor, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $8onqJ.defaultLogoParams).iconColor : _ref2$iconColor;
    var _useThemeObserver = (0, $fDucD.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $cVyt1.default), {
        appearance: appearance,
        iconColor: iconColor,
        label: label,
        size: size,
        svg: $0f47431498944ba2$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("1kQ25", function(module, exports) {
$parcel$export(module.exports, "AtlassianAccessIcon", () => $0f9005534e6d00b4$export$a825993f361832f7);

var $5FkrB = parcelRequire("5FkrB");

var $fDucD = parcelRequire("fDucD");

var $8onqJ = parcelRequire("8onqJ");

var $cVyt1 = parcelRequire("cVyt1");

var $8oKXf = parcelRequire("8oKXf");
var $0f9005534e6d00b4$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor;
    var colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $8oKXf.getColorsFromAppearance)(appearance, colorMode);
    return "<svg\n      fill=\"none\"\n      height=\"32\"\n      xmlns=\"http://www.w3.org/2000/svg\"\n      viewBox=\"0 0 32 32\"\n      focusable=\"false\"\n      aria-hidden=\"true\"\n    >\n      <path\n        d=\"M27.545 24.378 16.96 3.208c-.208-.458-.417-.541-.667-.541-.208 0-.458.083-.708.5-1.5 2.375-2.167 5.126-2.167 8.001 0 4 2.042 7.751 5.042 13.794.334.666.584.791 1.167.791h7.335c.541 0 .833-.208.833-.625 0-.208-.042-.333-.25-.75M12.168 14.377c-.834-1.25-1.084-1.334-1.292-1.334s-.333.084-.708.834L4.875 24.462c-.167.333-.208.458-.208.625 0 .333.291.666.916.666h7.46c.5 0 .875-.416 1.083-1.208.25-1 .334-1.875.334-2.917 0-2.917-1.292-5.751-2.292-7.251\"\n        fill=\"".concat(colors.iconColor, "\"\n      />\n    </svg>");
};
var $0f9005534e6d00b4$export$a825993f361832f7 = function AtlassianAccessIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Atlassian Access' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $8onqJ.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $8onqJ.defaultLogoParams).textColor : _ref2$textColor, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $8onqJ.defaultLogoParams).iconColor : _ref2$iconColor;
    var _useThemeObserver = (0, $fDucD.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $cVyt1.default), {
        appearance: appearance,
        svg: $0f9005534e6d00b4$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        label: label,
        size: size,
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("jaTZO", function(module, exports) {
$parcel$export(module.exports, "AtlassianAccessLogo", () => $df5a6323ac020c2a$export$5aa23cd4d8596f56);

var $5FkrB = parcelRequire("5FkrB");

var $fDucD = parcelRequire("fDucD");

var $8onqJ = parcelRequire("8onqJ");

var $cVyt1 = parcelRequire("cVyt1");

var $8oKXf = parcelRequire("8oKXf");
var $df5a6323ac020c2a$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $8oKXf.getColorsFromAppearance)(appearance, colorMode);
    return "<svg\n      fill=\"none\"\n      height=\"32\"\n      xmlns=\"http://www.w3.org/2000/svg\"\n      viewBox=\"0 0 299 32\"\n      focusable=\"false\"\n      aria-hidden=\"true\"\n    >\n      <path\n        d=\"M298.505 21.163c0 2.545-1.656 4.477-5.765 4.477-2.3 0-4.171-.521-5.336-1.135v-2.79c1.319.766 3.527 1.502 5.459 1.502 2.024 0 3.066-.828 3.066-2.024 0-1.165-.889-1.84-3.802-2.545-3.404-.828-4.846-2.147-4.846-4.661 0-2.668 2.055-4.294 5.551-4.294 1.993 0 3.803.491 4.937 1.104v2.73c-1.84-.92-3.342-1.411-4.968-1.411-1.932 0-2.974.675-2.974 1.87 0 1.074.736 1.749 3.557 2.423 3.404.828 5.121 2.086 5.121 4.754m-13.626 0c0 2.545-1.656 4.477-5.765 4.477-2.3 0-4.171-.521-5.336-1.135v-2.79c1.318.766 3.526 1.502 5.458 1.502 2.024 0 3.067-.828 3.067-2.024 0-1.165-.889-1.84-3.803-2.545-3.404-.828-4.845-2.147-4.845-4.661 0-2.668 2.055-4.294 5.551-4.294 1.993 0 3.802.491 4.937 1.104v2.73c-1.84-.92-3.343-1.411-4.968-1.411-1.932 0-2.975.675-2.975 1.87 0 1.074.736 1.749 3.558 2.423 3.404.828 5.121 2.086 5.121 4.754m-20.467-9.078c-2.791 0-4.202 1.81-4.478 4.478h8.556c-.153-2.852-1.441-4.478-4.078-4.478M270.3 24.72c-1.258.675-3.19.92-4.754.92-5.734 0-8.249-3.312-8.249-8.004 0-4.63 2.576-7.943 7.237-7.943 4.723 0 6.624 3.282 6.624 7.943v1.196h-11.193c.368 2.607 2.055 4.293 5.673 4.293 1.779 0 3.282-.337 4.662-.828zm-15.094-2.147v2.362c-.92.49-2.33.705-3.741.705-5.459 0-8.004-3.312-8.004-8.004 0-4.63 2.545-7.943 8.004-7.943 1.38 0 2.453.184 3.649.736v2.454c-.981-.46-2.024-.736-3.465-.736-3.987 0-5.612 2.514-5.612 5.489s1.656 5.49 5.673 5.49c1.564 0 2.546-.215 3.496-.553m-13.836 0v2.362c-.92.49-2.33.705-3.741.705-5.459 0-8.004-3.312-8.004-8.004 0-4.63 2.545-7.943 8.004-7.943 1.38 0 2.453.184 3.649.736v2.454c-.981-.46-2.024-.736-3.465-.736-3.987 0-5.612 2.514-5.612 5.489s1.656 5.49 5.673 5.49c1.564 0 2.546-.215 3.496-.553m-22.45-1.257c-1.533 0-3.097-.184-4.814-.521l-1.687 4.538h-3.097l7.942-20.148h3.496l7.943 20.148h-3.097l-1.687-4.569c-1.809.368-3.373.552-4.999.552m0-2.453c1.288 0 2.607-.154 4.171-.399l-4.079-11.04-4.078 11.07c1.502.246 2.76.369 3.986.369\"\n        fill=\"".concat(colors.textColor, "\"\n      />\n      <path\n        d=\"M107.447 10.828c0 2.972 1.345 5.308 6.795 6.37 3.185.707 3.893 1.203 3.893 2.264 0 1.062-.708 1.699-2.973 1.699-2.619 0-5.733-.92-7.785-2.123v4.812c1.627.779 3.751 1.699 7.785 1.699 5.662 0 7.856-2.548 7.856-6.228m0 .07c0-3.538-1.84-5.166-7.148-6.299-2.902-.637-3.61-1.274-3.61-2.194 0-1.132 1.062-1.628 2.973-1.628 2.335 0 4.6.708 6.794 1.7V6.368c-1.557-.779-3.892-1.345-6.653-1.345-5.237 0-7.927 2.265-7.927 5.945m72.475-5.803v20.172h4.318V9.978l1.769 4.034 6.087 11.324h5.379V5.166h-4.247v13.022l-1.628-3.822-4.883-9.2zm-27.319 0h-4.671v20.172h4.671zm-10.05 14.155c0-3.538-1.841-5.166-7.149-6.298-2.902-.637-3.609-1.274-3.609-2.194 0-1.133 1.061-1.628 2.972-1.628 2.336 0 4.601.707 6.795 1.698v-4.6c-1.557-.779-3.893-1.345-6.653-1.345-5.238 0-7.927 2.265-7.927 5.945 0 2.973 1.345 5.309 6.794 6.37 3.185.708 3.893 1.203 3.893 2.265s-.708 1.699-2.973 1.699c-2.618 0-5.733-.92-7.785-2.124v4.813c1.628.779 3.751 1.699 7.785 1.699 5.592 0 7.857-2.548 7.857-6.3M71.069 5.165v20.172h9.625l1.486-4.389h-6.44V5.165zm-19.039 0v4.318h5.167v15.854h4.741V9.483h5.592V5.165zm-6.866 0h-6.157L32 25.337h5.379l.99-3.398c1.204.354 2.478.566 3.752.566s2.548-.212 3.751-.566l.991 3.397h5.379c-.07 0-7.078-20.17-7.078-20.17zM42.05 18.26c-.92 0-1.77-.142-2.548-.354L42.05 9.13l2.548 8.776a9.6 9.6 0 0 1-2.548.354M97.326 5.165H91.17l-7.08 20.172h5.38l.99-3.398c1.203.354 2.477.566 3.751.566s2.548-.212 3.751-.566l.991 3.397h5.379zM94.212 18.26c-.92 0-1.77-.142-2.548-.354l2.548-8.776 2.548 8.776a9.6 9.6 0 0 1-2.548.354m75.306-13.095h-6.157l-7.007 20.172h5.379l.991-3.398c1.203.354 2.477.566 3.751.566s2.548-.212 3.751-.566l.991 3.397h5.379zm-3.043 13.094c-.92 0-1.77-.142-2.548-.354l2.548-8.776 2.548 8.776a10 10 0 0 1-2.548.354M22.878 24.378 12.293 3.208c-.208-.458-.416-.541-.666-.541-.209 0-.459.083-.709.5-1.5 2.375-2.167 5.126-2.167 8.001 0 4 2.042 7.751 5.043 13.794.333.666.583.791 1.166.791h7.335c.542 0 .833-.208.833-.625 0-.208-.041-.333-.25-.75M7.501 14.377c-.833-1.25-1.083-1.334-1.292-1.334s-.333.084-.708.834L.208 24.462c-.166.333-.208.458-.208.625 0 .333.292.666.917.666h7.46c.5 0 .874-.416 1.083-1.208.25-1 .333-1.875.333-2.917 0-2.917-1.292-5.751-2.292-7.251\"\n        fill=\"").concat(colors.iconColor, "\"\n      />\n    </svg>");
};
var $df5a6323ac020c2a$export$5aa23cd4d8596f56 = function AtlassianAccessLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Atlassian Access' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $8onqJ.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $8onqJ.defaultLogoParams).textColor : _ref2$textColor, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $8onqJ.defaultLogoParams).iconColor : _ref2$iconColor;
    var _useThemeObserver = (0, $fDucD.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $cVyt1.default), {
        appearance: appearance,
        iconColor: iconColor,
        label: label,
        size: size,
        svg: $df5a6323ac020c2a$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("8U9hf", function(module, exports) {
$parcel$export(module.exports, "JiraWorkManagementIcon", () => $67babfef1c42b04b$export$7330b9fc5718fd30);

var $5FkrB = parcelRequire("5FkrB");

var $7bQJE = parcelRequire("7bQJE");

var $fDucD = parcelRequire("fDucD");

var $8onqJ = parcelRequire("8onqJ");

var $cVyt1 = parcelRequire("cVyt1");

var $8oKXf = parcelRequire("8oKXf");
var $67babfef1c42b04b$var$svg = function svg(_ref, colorMode, id) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor;
    var colors = {
        iconGradientStart: (0, $8onqJ.legacyDefaultLogoParams).iconGradientStart,
        iconGradientStop: (0, $8onqJ.legacyDefaultLogoParams).iconGradientStart,
        iconColor: iconColor
    };
    if (appearance) colors = (0, $8oKXf.getColorsFromAppearanceOldLogos)(appearance, colorMode);
    return "\n    <svg\n      fill=\"none\"\n      height=\"32\"\n      viewBox=\"0 0 32 32\"\n      xmlns=\"http://www.w3.org/2000/svg\"\n    >\n      <linearGradient\n        id=\"".concat(id, "\"\n        gradientUnits=\"userSpaceOnUse\"\n        x1=\"13.9485\"\n        x2=\"20.7792\"\n        y1=\"20.2388\"\n        y2=\"11.8277\"\n      >\n        <stop offset=\"0\" stop-color=\"").concat(colors.iconGradientStart, "\" ").concat(colors.iconGradientStart === 'inherit' ? 'stop-opacity="0.4"' : '', " />\n        <stop offset=\"100%\" stop-color=\"").concat(colors.iconGradientStop, "\" />\n      </linearGradient>\n      <path\n        d=\"m18.3893 7-3.4257 13.1867c4.3592 1.2052 7.8383-.3558 9.1709-5.4802l1.9988-7.6973z\"\n        fill=\"url(#").concat(id, ")\"\n      />\n      <path\n      fill=\"").concat(colors.iconColor, "\"\n      d=\"m13.7566 24.8265 3.4257-13.1866c-4.3623-1.196-7.8383.3649-9.17087 5.4985l-2.01143 7.6881z\"\n      />\n    </svg>");
};
var $67babfef1c42b04b$export$7330b9fc5718fd30 = function JiraWorkManagementIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Jira Work Management' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $8onqJ.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $8onqJ.defaultLogoParams).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $8onqJ.defaultLogoParams).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $fDucD.default)(), colorMode = _useThemeObserver.colorMode;
    var id = (0, $7bQJE.useId)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $cVyt1.default), {
        appearance: appearance,
        label: label,
        svg: $67babfef1c42b04b$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode, id),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("2avQD", function(module, exports) {
$parcel$export(module.exports, "JiraWorkManagementLogo", () => $1945384bec13664b$export$56cadce97cc7cc);

var $5FkrB = parcelRequire("5FkrB");

var $7bQJE = parcelRequire("7bQJE");

var $fDucD = parcelRequire("fDucD");

var $8onqJ = parcelRequire("8onqJ");

var $cVyt1 = parcelRequire("cVyt1");

var $8oKXf = parcelRequire("8oKXf");
var $1945384bec13664b$var$svg = function svg(_ref, colorMode, id) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconGradientStart: (0, $8onqJ.legacyDefaultLogoParams).iconGradientStart,
        iconGradientStop: (0, $8onqJ.legacyDefaultLogoParams).iconGradientStart,
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $8oKXf.getColorsFromAppearanceOldLogos)(appearance, colorMode);
    return "\n  <svg\n  fill=\"none\"\n  height=\"32\"\n  viewBox=\"0 0 303 32\"\n  xmlns=\"http://www.w3.org/2000/svg\"\n>\n  <linearGradient\n    id=\"".concat(id, "\"\n    gradientUnits=\"userSpaceOnUse\"\n    x1=\"7.94848\"\n    x2=\"14.7792\"\n    y1=\"19.536\"\n    y2=\"11.1249\"\n  >\n    <stop offset=\"0\" stop-color=\"").concat(colors.iconGradientStart, "\" ").concat(colors.iconGradientStart === 'inherit' ? 'stop-opacity="0.4"' : '', " />\n    <stop offset=\"100%\" stop-color=\"").concat(colors.iconGradientStop, "\" />\n  </linearGradient>\n  <path\n    d=\"m12.3893 6.29721-3.42568 13.18669c4.35918 1.2052 7.83828-.3558 9.17088-5.4802l1.9988-7.69729z\"\n    fill=\"url(#").concat(id, ")\"\n  />\n  <path fill=\"").concat(colors.iconColor, "\" d=\"m7.75657 24.1237 3.42573-13.1866c-4.3623-1.19602-7.8383.3649-9.17087 5.4985l-2.01143 7.6881z\" />\n  <g fill=\"").concat(colors.textColor, "\">\n    <path\n      clip-rule=\"evenodd\"\n      d=\"m122.757 5v19.1237h2.379v-6.305l6.085 6.305h3.234l-6.776-6.8448 6.499-6.6485h-3.095l-5.947 6.3296v-11.96zm-84.0053.55058c-.2088-.0757-.4319-.1066-.654-.09058-.222-.0155-.4448.01575-.6533.09164-.2086.07589-.398.19465-.5553.34821-.1574.15356-.2791.33835-.3569.54183s-.1098.4209-.0939.63752c0 .42944.1748.84129.486 1.14495s.7333.47425 1.1734.47425.8622-.17059 1.1734-.47425.4861-.71551.4861-1.14495c.0164-.21674-.0153-.43438-.0929-.6381s-.1993-.38872-.3568-.5424c-.1574-.15367-.347-.27241-.5558-.34812zm.5089 5.07982h-2.3792v13.4933h2.3792zm-5.6979-4.22587h-2.4891l.0094 12.49357c0 1.7695-.726 2.9962-2.8286 2.9962-.88.0065-1.7534-.1496-2.574-.46v2.349c.9621.3182 1.9731.4727 2.9889.457 3.4288 0 4.8934-2.2387 4.8934-5.5047zm11.6158 17.71917h-2.3225v-13.4933h2.3225v2.3736c.8015-1.5916 2.1843-2.7232 4.8966-2.5637v2.2693c-3.0423-.3067-4.8966.5919-4.8966 3.4531zm11.3678.2791c2.1309 0 3.7903-.9169 4.6734-2.6987l.0032 2.4196h2.3791v-13.4933h-2.3791v2.3828c-.8329-1.7541-2.3823-2.6435-4.4-2.6435-3.872 0-5.808 3.2108-5.808 7.0166 0 3.9682 1.8543 7.0165 5.5314 7.0165zm4.6734-6.4768c0 2.9961-1.9077 4.3179-4.0385 4.3179-2.4609 0-3.7872-1.6192-3.7966-4.8576 0-3.1311 1.3829-4.8576 4.0637-4.8576 2.0303 0 3.7714 1.3217 3.7714 4.3178zm8.6023-11.52147h2.5709l4.7143 15.43457 5.1731-15.43457h2.9291l5.1732 15.43457 4.73-15.43457h2.4891l-5.7105 17.71917h-3.1806l-5.0286-15.1401-5.0285 15.1401h-3.0989zm34.376 3.96517c-4.148 0-6.5808 2.941-6.5808 6.989s2.4608 7.0533 6.5808 7.0533c4.121 0 6.528-3.0053 6.528-7.0533s-2.379-6.989-6.528-6.989zm0 11.8742c-2.957 0-4.2582-2.3215-4.2582-4.8852h.0031c0-2.5638 1.3231-4.83 4.2551-4.83 2.933 0 4.205 2.2662 4.205 4.83 0 2.5637-1.247 4.8852-4.205 4.8852zm11.617 1.8798h-2.323v-13.4933h2.323v2.3736c.801-1.5916 2.184-2.7232 4.896-2.5637v2.2693c-3.042-.3067-4.896.5919-4.896 3.4531zm28.734-16.2533v16.2533h-2.492v-17.71917h4.315l4.121 10.17217 1.687 4.8852 1.688-4.8852 4.149-10.17217h4.01v17.71917h-2.489v-16.07543l-2.131 6.39703-4.007 9.6784h-2.408l-3.953-9.6784zm26.165 16.5324c2.131 0 3.79-.9169 4.673-2.6987l.003 2.4196h2.38v-13.4933h-2.38v2.3828c-.833-1.7541-2.382-2.6435-4.4-2.6435-3.872 0-5.808 3.2108-5.808 7.0166 0 3.9682 1.855 7.0165 5.532 7.0165zm4.673-6.4768c0 2.9961-1.907 4.3179-4.038 4.3179-2.461 0-3.787-1.6192-3.797-4.8576 0-3.1311 1.383-4.8576 4.064-4.8576 2.03 0 3.771 1.3217 3.771 4.3178zm17.729 6.1977h-2.379v-8.142c0-2.4288-.996-3.5082-3.262-3.5082-2.2 0-3.734 1.4321-3.734 4.1584v7.4918h-2.379v-13.4933h2.379v2.2141c.423-.7665 1.055-1.4041 1.826-1.8424s1.651-.6603 2.543-.6416c3.18 0 5.006 2.1467 5.006 5.8574zm8.021.2791c2.131 0 3.79-.9169 4.673-2.6987l.003 2.4196h2.379v-13.4933h-2.379v2.3828c-.833-1.7541-2.382-2.6435-4.4-2.6435-3.872 0-5.808 3.2108-5.808 7.0166 0 3.9682 1.855 7.0165 5.532 7.0165zm4.673-6.4768c0 2.9961-1.908 4.3179-4.038 4.3179-2.461 0-3.772-1.6192-3.772-4.8668 0-3.1219 1.367-4.8484 4.039-4.8484 2.03 0 3.771 1.3217 3.771 4.3178zm15.293 3.7781c-.883 1.7818-2.542 2.6987-4.673 2.6987-3.658 0-5.475-3.0391-5.475-7.0257 0-3.8058 1.908-7.0166 5.752-7.0166 2.02 0 3.567.8894 4.4 2.6435v-2.3736h2.325v12.2667c0 3.9682-1.911 6.6393-6.861 6.6393-1.672.0477-3.339-.1995-4.921-.7299v-2.2294c1.549.5193 3.173.7927 4.811.8096 3.458 0 4.646-1.8094 4.646-4.3179zm-4.035.5398c2.128 0 4.035-1.3218 4.035-4.3179v-1.0795c0-2.9961-1.741-4.3178-3.771-4.3178-2.684 0-4.067 1.7265-4.067 4.8576.013 3.2384 1.339 4.8576 3.803 4.8576zm9.127-4.8944c0 4.14 2.266 7.0533 7.439 7.0533 1.411 0 3.152-.2147 4.281-.7943v-2.1466c-1.346.477-2.767.7199-4.199.7176-3.263 0-4.784-1.4843-5.117-3.7782h10.092v-1.0518c0-4.1002-1.71-6.989-5.972-6.989-4.202 0-6.524 2.9134-6.524 6.989zm10.095-.92h-7.719v-.0154c.251-2.346 1.521-3.9437 4.038-3.9437 2.38 0 3.542 1.4352 3.681 3.9591zm16.98 7.6942h-2.379v-8.142c0-2.4288-.996-3.5082-3.265-3.5082-2.2 0-3.731 1.4321-3.731 4.1584v7.4918h-2.379v-13.4933h2.37v2.2141c.423-.7667 1.054-1.4045 1.825-1.8428.771-.4384 1.651-.6603 2.543-.6412 2.351 0 3.954 1.1592 4.646 3.2936.776-2.0792 2.627-3.2936 4.924-3.2936 3.096 0 4.812 2.0516 4.812 5.8574v7.9058h-2.379v-7.4918c.009-2.7815-.971-4.1615-3.253-4.1615-2.2 0-3.734 1.4321-3.734 4.1584zm11.865-6.7742c0 4.14 2.266 7.0533 7.439 7.0533 1.411 0 3.152-.2147 4.287-.8035v-2.1466c-1.347.4808-2.771.7269-4.205.7268-3.263 0-4.784-1.4843-5.117-3.7782h10.095v-1.0518c0-4.1002-1.713-6.989-5.972-6.989-4.205 0-6.527 2.9134-6.527 6.989zm10.095-.92h-7.716v-.0154c.258-2.346 1.515-3.9437 4.029-3.9437 2.385 0 3.548 1.4352 3.687 3.9591zm16.98 7.6942h-2.379v-8.142c0-2.4288-1.002-3.5113-3.262-3.5113-2.2 0-3.734 1.4321-3.734 4.1584v7.4949h-2.379v-13.4933h2.379v2.2141c.423-.7667 1.055-1.4045 1.826-1.8428.771-.4384 1.651-.6603 2.543-.6412 3.18 0 5.006 2.1467 5.006 5.8574zm10.287-2.3644c-.49.1102-.99.1728-1.493.1871-1.464 0-2.184-.8096-2.187-1.9964v-7.1729h3.677v-2.1467h-3.677v-2.852h-2.323v2.852h-2.241v2.1681h2.241v7.2067c0 2.5085 1.44 4.2075 4.4 4.2075.542.0028 1.082-.0695 1.603-.2147z\"\n      fill-rule=\"evenodd\"\n    />\n  </g>\n</svg>");
};
var $1945384bec13664b$export$56cadce97cc7cc = function JiraWorkManagementLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Jira Work Management' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $8onqJ.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $8onqJ.defaultLogoParams).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $8onqJ.defaultLogoParams).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $fDucD.default)(), colorMode = _useThemeObserver.colorMode;
    var id = (0, $7bQJE.useId)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $cVyt1.default), {
        appearance: appearance,
        label: label,
        iconColor: iconColor,
        size: size,
        svg: $1945384bec13664b$var$svg({
            appearance: appearance,
            size: size,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode, id),
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("6SaK6", function(module, exports) {
$parcel$export(module.exports, "AtlassianIcon", () => $50101e7733a6b1d7$export$8a485e2e7ed91e8f);

var $5FkrB = parcelRequire("5FkrB");

var $fDucD = parcelRequire("fDucD");

var $8onqJ = parcelRequire("8onqJ");

var $cVyt1 = parcelRequire("cVyt1");

var $8oKXf = parcelRequire("8oKXf");
var $50101e7733a6b1d7$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor;
    var colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $8oKXf.getColorsFromAppearance)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" viewBox=\"0 0 32 32\" focusable=\"false\" aria-hidden=\"true\" xmlns=\"http://www.w3.org/2000/svg\">\n      <path fill=\"".concat(colors.iconColor, "\" d=\"M27.545 24.378 16.96 3.208c-.208-.458-.417-.541-.667-.541-.208 0-.458.083-.708.5-1.5 2.375-2.167 5.125-2.167 8 0 4.001 2.042 7.752 5.042 13.795.334.666.584.791 1.167.791h7.335c.541 0 .833-.208.833-.625 0-.208-.042-.333-.25-.75M12.168 14.377c-.834-1.25-1.084-1.334-1.292-1.334s-.333.083-.708.834L4.875 24.46c-.167.334-.208.459-.208.625 0 .334.291.667.916.667h7.46c.5 0 .875-.416 1.083-1.208.25-1 .334-1.876.334-2.917 0-2.917-1.292-5.751-2.292-7.251\"/>\n    </svg>");
};
var $50101e7733a6b1d7$export$8a485e2e7ed91e8f = function AtlassianIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Atlassian' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $8onqJ.defaultLogoParams).size : _ref2$size, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $8onqJ.defaultLogoParams).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $8onqJ.defaultLogoParams).textColor : _ref2$textColor, testId = _ref2.testId;
    var _useThemeObserver = (0, $fDucD.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $cVyt1.default), {
        appearance: appearance,
        label: label,
        svg: $50101e7733a6b1d7$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        textColor: textColor,
        size: size,
        testId: testId
    });
};

});

parcelRegister("6an3z", function(module, exports) {
$parcel$export(module.exports, "AtlassianLogo", () => $47d58fd2ef4b1aac$export$765cacec8b0843f3);

var $5FkrB = parcelRequire("5FkrB");

var $fDucD = parcelRequire("fDucD");

var $8onqJ = parcelRequire("8onqJ");

var $cVyt1 = parcelRequire("cVyt1");

var $8oKXf = parcelRequire("8oKXf");
var $47d58fd2ef4b1aac$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconColor: iconColor,
        textColor: textColor,
        // We treat the word "Atlassian" differently to normal app logos, it has a bold brand look
        atlassianLogoTextColor: textColor
    };
    if (appearance) colors = (0, $8oKXf.getColorsFromAppearance)(appearance, colorMode);
    return "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 198 32\" focusable=\"false\" aria-hidden=\"true\" height=\"32\" fill=\"none\">\n      <path fill=".concat(colors.iconColor, " d=\"M22.878 24.378 12.293 3.208c-.208-.458-.416-.541-.666-.541-.209 0-.459.083-.709.5-1.5 2.375-2.167 5.125-2.167 8 0 4.001 2.042 7.752 5.043 13.794.333.667.583.792 1.166.792h7.335c.542 0 .833-.208.833-.625 0-.208-.041-.333-.25-.75M7.501 14.377c-.833-1.25-1.083-1.334-1.292-1.334s-.333.083-.708.834L.208 24.46c-.166.334-.208.459-.208.625 0 .334.292.667.917.667h7.46c.5 0 .874-.416 1.083-1.208.25-1 .333-1.876.333-2.917 0-2.917-1.292-5.751-2.292-7.251z\"/>\n      <path fill=").concat(colors.atlassianLogoTextColor, " d=\"M107.447 10.828c0 2.972 1.345 5.308 6.795 6.37 3.185.707 3.893 1.203 3.893 2.265 0 1.061-.708 1.698-2.973 1.698-2.619 0-5.733-.92-7.785-2.123v4.813c1.627.778 3.751 1.698 7.785 1.698 5.662 0 7.856-2.548 7.856-6.228m0 .07c0-3.538-1.84-5.166-7.148-6.298-2.902-.637-3.61-1.274-3.61-2.194 0-1.133 1.062-1.628 2.973-1.628 2.335 0 4.6.708 6.794 1.698v-4.6c-1.557-.779-3.892-1.345-6.653-1.345-5.237 0-7.927 2.265-7.927 5.945m72.475-5.803v20.17h4.318V9.979l1.769 4.035 6.087 11.324h5.379V5.166h-4.247v13.022l-1.628-3.821-4.883-9.201zm-27.319 0h-4.671v20.17h4.671zm-10.05 14.154c0-3.538-1.841-5.166-7.149-6.298-2.902-.637-3.609-1.274-3.609-2.194 0-1.133 1.061-1.628 2.972-1.628 2.336 0 4.601.708 6.795 1.699v-4.6c-1.557-.78-3.893-1.346-6.653-1.346-5.238 0-7.927 2.265-7.927 5.946 0 2.972 1.344 5.308 6.794 6.37 3.185.707 3.893 1.203 3.893 2.264 0 1.062-.708 1.699-2.973 1.699-2.618 0-5.733-.92-7.785-2.123v4.812c1.628.779 3.751 1.699 7.785 1.699 5.592 0 7.857-2.548 7.857-6.3M71.069 5.166v20.17h9.625l1.486-4.387h-6.44V5.166zm-19.039 0v4.317h5.167v15.854h4.741V9.483h5.592V5.166zm-6.866 0h-6.157L32 25.336h5.379l.99-3.396c1.204.353 2.478.566 3.752.566s2.548-.213 3.751-.567l.991 3.398h5.379c-.07 0-7.078-20.171-7.078-20.171M42.05 18.259c-.92 0-1.77-.141-2.548-.354L42.05 9.13l2.548 8.776a9.6 9.6 0 0 1-2.548.354zM97.326 5.166H91.17l-7.078 20.17h5.38l.99-3.396c1.203.353 2.477.566 3.751.566s2.548-.213 3.751-.567l.991 3.398h5.379zm-3.114 13.093c-.92 0-1.77-.141-2.548-.354l2.548-8.776 2.548 8.776a9.6 9.6 0 0 1-2.548.354m75.306-13.093h-6.157l-7.007 20.17h5.379l.991-3.396c1.203.353 2.477.566 3.751.566s2.548-.213 3.751-.567l.991 3.398h5.379zm-3.043 13.093c-.92 0-1.77-.141-2.548-.354l2.548-8.776 2.548 8.776a10 10 0 0 1-2.548.354\"/>\n    </svg>");
};
var $47d58fd2ef4b1aac$export$765cacec8b0843f3 = function AtlassianLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Atlassian' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $8onqJ.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $8onqJ.defaultLogoParams).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $8onqJ.defaultLogoParams).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $fDucD.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $cVyt1.default), {
        appearance: appearance,
        label: label,
        svg: $47d58fd2ef4b1aac$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("18tda", function(module, exports) {
$parcel$export(module.exports, "JiraSoftwareIcon", () => $0d3d329829351edb$export$c3835feba2a66e67);

var $5FkrB = parcelRequire("5FkrB");

var $7bQJE = parcelRequire("7bQJE");

var $fDucD = parcelRequire("fDucD");

var $8onqJ = parcelRequire("8onqJ");

var $cVyt1 = parcelRequire("cVyt1");

var $8oKXf = parcelRequire("8oKXf");
var $0d3d329829351edb$var$svg = function svg(_ref, colorMode, id) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor;
    var colors = {
        iconGradientStart: (0, $8onqJ.legacyDefaultLogoParams).iconGradientStart,
        iconGradientStop: (0, $8onqJ.legacyDefaultLogoParams).iconGradientStart,
        iconColor: iconColor
    };
    if (appearance) colors = (0, $8oKXf.getColorsFromAppearanceOldLogos)(appearance, colorMode);
    return "\n  <svg viewBox=\"0 0 32 32\" height=\"32\" xmlns=\"http://www.w3.org/2000/svg\" focusable=\"false\" aria-hidden=\"true\">\n    <defs>\n      <linearGradient x1=\"108.695%\" x2=\"12.439%\" y1=\"-14.936%\" y2=\"45.215%\" id=\"".concat(id, "-1\">\n        <stop stop-color=\"").concat(colors.iconGradientStart, "\" ").concat(colors.iconGradientStart === 'inherit' ? 'stop-opacity="0.4"' : '', " offset=\"0%\"></stop>\n        <stop stop-color=\"").concat(colors.iconGradientStop, "\" offset=\"100%\"></stop>\n      </linearGradient>\n      <linearGradient x1=\"0%\" x2=\"91.029%\" y1=\"118.55%\" y2=\"63.971%\" id=\"").concat(id, "-2\">\n        <stop stop-color=\"").concat(colors.iconGradientStart, "\" ").concat(colors.iconGradientStart === 'inherit' ? 'stop-opacity="0.4"' : '', " offset=\"0%\"></stop>\n        <stop stop-color=\"").concat(colors.iconGradientStop, "\" offset=\"100%\"></stop>\n      </linearGradient>\n    </defs>\n    <g stroke=\"none\" stroke-width=\"1\" fill-rule=\"nonzero\">\n      <path fill=\"").concat(colors.iconColor, "\" d=\"M15.9669691 29.3616152C17.2195568 28.1097726 17.9233158 26.4114623 17.9233158 24.6405626 17.9233158 22.8696629 17.2195568 21.1713527 15.9669691 19.91951L7.26805808 11.2489111 3.31143376 15.2055354C2.89743442 15.6200502 2.89743442 16.291565 3.31143376 16.7060799L15.9669691 29.3616152zM28.6225045 15.2055354L15.9669691 2.55 15.9280399 2.58892922C13.3485687 5.19994003 13.3612164 9.40374108 15.9563521 11.9991833L24.6623412 20.6662432 28.6225045 16.7060799C29.0365039 16.291565 29.0365039 15.6200502 28.6225045 15.2055354z\" />\n      <path fill=\"url(#").concat(id, "-1\" d=\"M15.9669691,11.9921053 C13.3718335,9.39666304 13.3591857,5.19286199 15.938657,2.58185118 L6.91061706,11.6063521 L11.6316697,16.3274047 L15.9669691,11.9921053 Z\" />\n      <path fill=\"url(#").concat(id, "-2\" d=\"M20.2951906,15.5912886 L15.9669691,19.91951 C17.2195568,21.1713527 17.9233158,22.8696629 17.9233158,24.6405626 C17.9233158,26.4114623 17.2195568,28.1097726 15.9669691,29.3616152 L25.0162432,20.3123412 L20.2951906,15.5912886 Z\" />\n    </g>\n  </svg>");
};
var $0d3d329829351edb$export$c3835feba2a66e67 = function JiraSoftwareIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Jira Software' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $8onqJ.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $8onqJ.defaultLogoParams).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $8onqJ.defaultLogoParams).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $fDucD.default)(), colorMode = _useThemeObserver.colorMode;
    var id = (0, $7bQJE.useId)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $cVyt1.default), {
        appearance: appearance,
        label: label,
        svg: $0d3d329829351edb$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode, id),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("fH0DS", function(module, exports) {
$parcel$export(module.exports, "JiraSoftwareLogo", () => $b6cb5eaa962c21c0$export$8869c52f95591fed);

var $5FkrB = parcelRequire("5FkrB");

var $7bQJE = parcelRequire("7bQJE");

var $fDucD = parcelRequire("fDucD");

var $8onqJ = parcelRequire("8onqJ");

var $cVyt1 = parcelRequire("cVyt1");

var $8oKXf = parcelRequire("8oKXf");
var $b6cb5eaa962c21c0$var$svg = function svg(_ref, colorMode, id) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconGradientStart: (0, $8onqJ.legacyDefaultLogoParams).iconGradientStart,
        iconGradientStop: (0, $8onqJ.legacyDefaultLogoParams).iconGradientStart,
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $8oKXf.getColorsFromAppearanceOldLogos)(appearance, colorMode);
    return "\n  <svg viewBox=\"0 0 179 32\" height=\"32\" xmlns=\"http://www.w3.org/2000/svg\" focusable=\"false\" aria-hidden=\"true\">\n    <defs>\n      <linearGradient x1=\"97.6553341%\" y1=\"35.6591143%\" x2=\"37.202032%\" y2=\"75.4891864%\" id=\"".concat(id, "-1\">\n        <stop stop-color=\"").concat(colors.iconGradientStart, "\" ").concat(colors.iconGradientStart === 'inherit' ? 'stop-opacity="0.4"' : '', " offset=\"7%\"></stop>\n        <stop stop-color=\"").concat(colors.iconGradientStop, "\" offset=\"100%\"></stop>\n      </linearGradient>\n      <linearGradient x1=\"8.43371138%\" y1=\"60.1495759%\" x2=\"64.1161517%\" y2=\"23.5790285%\" id=\"").concat(id, "-2\">\n        <stop stop-color=\"").concat(colors.iconGradientStart, "\" ").concat(colors.iconGradientStart === 'inherit' ? 'stop-opacity="0.4"' : '', " offset=\"0%\"></stop>\n        <stop stop-color=\"").concat(colors.iconGradientStop, "\" offset=\"100%\"></stop>\n      </linearGradient>\n    </defs>\n    <g stroke=\"none\" stroke-width=\"1\" fill-rule=\"nonzero\">\n      <path fill=\"").concat(colors.iconColor, "\" d=\"M11.3881081,27.9242105 C12.4881804,26.8071817 13.1062496,25.2917664 13.1062496,23.7115789 C13.1062496,22.1313915 12.4881804,20.6159762 11.3881081,19.4989474 L11.3881081,19.4989474 L3.74837838,11.7621053 L0.273513514,15.2926316 C-0.0900771727,15.6625064 -0.0900771727,16.2617042 0.273513514,16.6315789 L11.3881081,27.9242105 L11.3881081,27.9242105 Z\" fill-rule=\"nonzero\"></path>\n      <path fill=\"").concat(colors.iconColor, "\" d=\"M22.5027027,15.2926316 L11.3881081,4 L11.3881081,4 L11.3539189,4.03473684 L11.3539189,4.03473684 C9.08852466,6.36456187 9.09963243,10.1156459 11.3787838,12.4315789 L19.0247297,20.1652632 L22.5027027,16.6315789 C22.8662934,16.2617042 22.8662934,15.6625064 22.5027027,15.2926316 Z\" fill-rule=\"nonzero\"></path>\n      <path d=\"M11.3881081,12.4252632 C9.10895676,10.1093301 9.09784899,6.35824608 11.3632432,4.02842105 L3.43445946,12.0810526 L7.58067568,16.2936842 L11.3881081,12.4252632 Z\" fill=\"url(#").concat(id, "-1)\" fill-rule=\"nonzero\"></path>\n      <path fill=\"url(#").concat(id, "-2)\" d=\"M15.1893243,15.6368421 L11.3881081,19.4989474 C12.4881804,20.6159762 13.1062496,22.1313915 13.1062496,23.7115789 C13.1062496,25.2917664 12.4881804,26.8071817 11.3881081,27.9242105 L19.3355405,19.8494737 L15.1893243,15.6368421 Z\" fill-rule=\"nonzero\"></path>\n      <path fill=\"").concat(colors.textColor, "\" d=\"M36.07,18.956 C36.07,20.646 35.394,21.842 33.418,21.842 C32.56,21.842 31.702,21.686 31,21.4 L31,23.662 C31.65,23.896 32.586,24.104 33.808,24.104 C37.032,24.104 38.41,21.946 38.41,18.8 L38.41,6.918 L36.07,6.918 L36.07,18.956 Z M41.894,7.568 C41.894,8.556 42.544,9.128 43.454,9.128 C44.364,9.128 45.014,8.556 45.014,7.568 C45.014,6.58 44.364,6.008 43.454,6.008 C42.544,6.008 41.894,6.58 41.894,7.568 Z M42.31,24 L44.546,24 L44.546,11 L42.31,11 L42.31,24 Z M47.926,24 L50.11,24 L50.11,16.33 C50.11,13.574 51.852,12.716 54.712,13.002 L54.712,10.818 C52.164,10.662 50.864,11.754 50.11,13.288 L50.11,11 L47.926,11 L47.926,24 Z M65.45,24 L65.45,21.66 C64.618,23.376 63.058,24.26 61.056,24.26 C57.598,24.26 55.856,21.322 55.856,17.5 C55.856,13.834 57.676,10.74 61.316,10.74 C63.214,10.74 64.67,11.598 65.45,13.288 L65.45,11 L67.686,11 L67.686,24 L65.45,24 Z M58.092,17.5 C58.092,20.62 59.34,22.18 61.654,22.18 C63.656,22.18 65.45,20.906 65.45,18.02 L65.45,16.98 C65.45,14.094 63.812,12.82 61.914,12.82 C59.392,12.82 58.092,14.484 58.092,17.5 Z M86.926,19.294 C86.926,16.226 84.898,15.056 81.284,14.146 C78.268,13.392 77.176,12.69 77.176,11.286 C77.176,9.726 78.502,8.946 80.738,8.946 C82.506,8.946 84.352,9.258 86.068,10.246 L86.068,7.906 C84.898,7.256 83.312,6.658 80.842,6.658 C76.864,6.658 74.836,8.634 74.836,11.286 C74.836,14.094 76.552,15.42 80.4,16.356 C83.65,17.136 84.586,17.942 84.586,19.45 C84.586,20.958 83.624,21.972 81.05,21.972 C78.788,21.972 76.344,21.374 74.758,20.542 L74.758,22.934 C76.084,23.61 77.618,24.26 80.92,24.26 C85.158,24.26 86.926,22.258 86.926,19.294 Z M95.09,24.26 C91.19,24.26 88.902,21.374 88.902,17.474 C88.902,13.574 91.19,10.74 95.09,10.74 C98.964,10.74 101.226,13.574 101.226,17.474 C101.226,21.374 98.964,24.26 95.09,24.26 Z M95.09,12.82 C92.308,12.82 91.086,15.004 91.086,17.474 C91.086,19.944 92.308,22.18 95.09,22.18 C97.846,22.18 99.042,19.944 99.042,17.474 C99.042,15.004 97.846,12.82 95.09,12.82 Z M106.92,9.622 C106.92,8.452 107.596,7.646 108.974,7.646 C109.494,7.646 109.988,7.698 110.378,7.776 L110.378,5.722 C109.988,5.618 109.546,5.514 108.87,5.514 C106.088,5.514 104.736,7.152 104.736,9.57 L104.736,11 L102.63,11 L102.63,13.08 L104.736,13.08 L104.736,24 L106.92,24 L106.92,13.08 L110.274,13.08 L110.274,11 L106.92,11 L106.92,9.622 Z M115.786,19.892 L115.786,13.08 L119.244,13.08 L119.244,11 L115.786,11 L115.786,8.244 L113.602,8.244 L113.602,11 L111.496,11 L111.496,13.08 L113.602,13.08 L113.602,19.944 C113.602,22.362 114.954,24 117.736,24 C118.412,24 118.854,23.896 119.244,23.792 L119.244,21.634 C118.854,21.712 118.36,21.816 117.84,21.816 C116.462,21.816 115.786,21.036 115.786,19.892 Z M125.432,24 L128.292,24 L130.528,17.708 L131.724,13.704 L132.92,17.708 L135.156,24 L138.016,24 L142.8,11 L140.33,11 L136.586,22.024 L132.79,11 L130.658,11 L126.862,22.024 L123.118,11 L120.648,11 L125.432,24 Z M153.538,24 L153.538,21.66 C152.706,23.376 151.146,24.26 149.144,24.26 C145.686,24.26 143.944,21.322 143.944,17.5 C143.944,13.834 145.764,10.74 149.404,10.74 C151.302,10.74 152.758,11.598 153.538,13.288 L153.538,11 L155.774,11 L155.774,24 L153.538,24 Z M146.18,17.5 C146.18,20.62 147.428,22.18 149.742,22.18 C151.744,22.18 153.538,20.906 153.538,18.02 L153.538,16.98 C153.538,14.094 151.9,12.82 150.002,12.82 C147.48,12.82 146.18,14.484 146.18,17.5 Z M159.154,24 L161.338,24 L161.338,16.33 C161.338,13.574 163.08,12.716 165.94,13.002 L165.94,10.818 C163.392,10.662 162.092,11.754 161.338,13.288 L161.338,11 L159.154,11 L159.154,24 Z M178.108,23.48 C177.042,24.052 175.404,24.26 174.078,24.26 C169.216,24.26 167.084,21.452 167.084,17.474 C167.084,13.548 169.268,10.74 173.22,10.74 C177.224,10.74 178.836,13.522 178.836,17.474 L178.836,18.488 L169.346,18.488 C169.658,20.698 171.088,22.128 174.156,22.128 C175.664,22.128 176.938,21.842 178.108,21.426 L178.108,23.48 Z M173.116,12.768 C170.75,12.768 169.554,14.302 169.32,16.564 L176.574,16.564 C176.444,14.146 175.352,12.768 173.116,12.768 Z\" fill-rule=\"evenodd\"></path>\n    </g>\n  </svg>");
};
var $b6cb5eaa962c21c0$export$8869c52f95591fed = function JiraSoftwareLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Jira Software' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $8onqJ.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $8onqJ.defaultLogoParams).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $8onqJ.defaultLogoParams).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $fDucD.default)(), colorMode = _useThemeObserver.colorMode;
    var id = (0, $7bQJE.useId)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $cVyt1.default), {
        appearance: appearance,
        label: label,
        iconColor: iconColor,
        size: size,
        svg: $b6cb5eaa962c21c0$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode, id),
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("2u9Yf", function(module, exports) {
$parcel$export(module.exports, "createFeatureFlaggedComponent", () => $1cf61e15150efda7$export$e30d2ddc605f6bb);
$parcel$export(module.exports, "createFeatureFlaggedServiceCollectionComponent", () => $1cf61e15150efda7$export$436fcf6e31fbacea);
$parcel$export(module.exports, "createFeatureFlaggedRovoComponent", () => $1cf61e15150efda7$export$2469203854060337);
$parcel$export(module.exports, "tempSizeWrapper", () => $1cf61e15150efda7$export$667425256e2e7296);

var $kqp0i = parcelRequire("kqp0i");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");

var $9Zzpd = parcelRequire("9Zzpd");
var $1cf61e15150efda7$var$_excluded = [
    "size",
    "shouldUseNewLogoDesign"
], $1cf61e15150efda7$var$_excluded2 = [
    "size",
    "shouldUseNewLogoDesign"
], $1cf61e15150efda7$var$_excluded3 = [
    "shouldUseHexLogo"
], $1cf61e15150efda7$var$_excluded4 = [
    "size"
];
/**
 * Creates a feature flagged component that renders the legacy logo or the new logo
 * based on the platform-logo-rebrand feature flag.
 *
 * @param LegacyComponent - The legacy logo component.
 * @param NewComponent - The new logo component.
 * @returns A feature flagged component that renders the legacy logo or the new logo.
 */ var $1cf61e15150efda7$export$e30d2ddc605f6bb = function createFeatureFlaggedComponent(LegacyComponent, NewComponent) {
    // Note: textColor and iconColor aren't supported on all new logos
    // These props will be deprecated in the future
    return function(_ref) {
        var size = _ref.size, shouldUseNewLogoDesign = _ref.shouldUseNewLogoDesign, props = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $1cf61e15150efda7$var$_excluded);
        if ((0, $9Zzpd.fg)('platform-logo-rebrand') || shouldUseNewLogoDesign) // Size defaults need to be set, as the temp library had different defaults
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(NewComponent, (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
            size: size || 'medium'
        }, props));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(LegacyComponent, (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
            size: size
        }, props));
    };
};
var $1cf61e15150efda7$export$436fcf6e31fbacea = function createFeatureFlaggedServiceCollectionComponent(LegacyComponent, NewComponent) {
    // Note: textColor and iconColor aren't supported on all new logos
    // These props will be deprecated in the future
    return function(_ref2) {
        var size = _ref2.size, shouldUseNewLogoDesign = _ref2.shouldUseNewLogoDesign, props = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref2, $1cf61e15150efda7$var$_excluded2);
        if ((0, $9Zzpd.fg)('platform-logo-rebrand') || shouldUseNewLogoDesign) // Size defaults need to be set, as the temp library had different defaults
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(NewComponent, (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
            size: size || 'medium'
        }, props));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(LegacyComponent, (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
            size: size
        }, props));
    };
};
var $1cf61e15150efda7$export$2469203854060337 = function createFeatureFlaggedRovoComponent(LegacyComponent, NewComponent, NewHexComponent) {
    var RovoHexWrapped = $1cf61e15150efda7$export$667425256e2e7296(NewHexComponent);
    var RovoServiceCollectionWrapped = $1cf61e15150efda7$export$436fcf6e31fbacea(LegacyComponent, NewComponent);
    return function(_ref3) {
        var shouldUseHexLogo = _ref3.shouldUseHexLogo, props = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref3, $1cf61e15150efda7$var$_excluded3);
        // Return hex logo if feature flag enabled. Otherwise revert to old set of components
        if ((0, $9Zzpd.fg)('platform-logo-rebrand-rovo-hex') || shouldUseHexLogo) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(RovoHexWrapped, props);
        else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(RovoServiceCollectionWrapped, props);
    };
};
var $1cf61e15150efda7$export$667425256e2e7296 = function tempSizeWrapper(NewComponent) {
    return function(_ref4) {
        var size = _ref4.size, props = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref4, $1cf61e15150efda7$var$_excluded4);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(NewComponent, (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
            size: size || 'medium'
        }, props));
    };
};
var $1cf61e15150efda7$export$172fd793eb6ecac4 = [
    // Program logos
    {
        name: 'atlassian',
        type: 'legacy',
        category: 'program'
    },
    {
        name: 'atlassian-access',
        type: 'legacy',
        category: 'program'
    },
    {
        name: 'atlassian-marketplace',
        type: 'legacy',
        category: 'program'
    },
    // Home collection
    {
        name: 'home',
        type: 'new',
        category: 'app'
    },
    {
        name: 'hub',
        type: 'new',
        category: 'app'
    },
    // Teamwork collection
    {
        name: 'confluence',
        type: 'migration',
        category: 'app'
    },
    {
        name: 'jira',
        type: 'migration',
        category: 'app'
    },
    {
        name: 'loom',
        type: 'migration',
        category: 'app'
    },
    {
        name: 'loom-blurple',
        type: 'new',
        category: 'app',
        skipExample: true
    },
    {
        name: 'loom-attribution',
        type: 'migration',
        category: 'app'
    },
    {
        name: 'rovo',
        type: 'rovo-hex',
        category: 'app'
    },
    // Strategy collection
    {
        name: 'align',
        type: 'new',
        category: 'app'
    },
    {
        name: 'focus',
        type: 'migration',
        category: 'app'
    },
    {
        name: 'talent',
        type: 'new',
        category: 'app'
    },
    // App collection
    {
        name: 'jira-product-discovery',
        type: 'migration',
        category: 'app'
    },
    // Dev collection
    {
        name: 'bitbucket',
        type: 'migration',
        category: 'app'
    },
    {
        name: 'compass',
        type: 'migration',
        category: 'app'
    },
    {
        name: 'dx',
        type: 'new',
        category: 'app',
        skipLogo: true
    },
    {
        name: 'rovo-dev',
        type: 'new',
        category: 'app'
    },
    {
        name: 'rovo-dev-agent',
        type: 'new',
        category: 'agent'
    },
    // Customer collection
    {
        name: 'jira-service-management',
        type: 'migration',
        category: 'app'
    },
    {
        name: 'assets',
        type: 'new',
        category: 'app'
    },
    {
        name: 'customer-service-management',
        type: 'new',
        category: 'app'
    },
    {
        name: 'opsgenie',
        type: 'migration',
        category: 'app'
    },
    {
        name: 'statuspage',
        type: 'migration',
        category: 'app'
    },
    {
        name: 'trello',
        type: 'migration',
        category: 'app'
    },
    // Platform Collection
    {
        name: 'admin',
        type: 'new',
        category: 'app'
    },
    {
        name: 'analytics',
        type: 'new',
        category: 'app'
    },
    {
        name: 'chat',
        type: 'new',
        category: 'app'
    },
    {
        name: 'feedback',
        type: 'new',
        category: 'app'
    },
    {
        name: 'goals',
        type: 'new',
        category: 'app'
    },
    {
        name: 'guard',
        type: 'migration',
        category: 'app'
    },
    {
        name: 'projects',
        type: 'new',
        category: 'app'
    },
    {
        name: 'search',
        type: 'new',
        category: 'app'
    },
    {
        name: 'studio',
        type: 'new',
        category: 'app'
    },
    {
        name: 'teams',
        type: 'new',
        category: 'app'
    },
    // Data Center
    {
        name: 'jira-data-center',
        type: 'new',
        category: 'app'
    },
    {
        name: 'jira-service-management-data-center',
        type: 'new',
        category: 'app'
    },
    {
        name: 'confluence-data-center',
        type: 'new',
        category: 'app'
    },
    {
        name: 'bitbucket-data-center',
        type: 'new',
        category: 'app'
    },
    {
        name: 'bamboo',
        type: 'new',
        category: 'app'
    },
    {
        name: 'crowd',
        type: 'new',
        category: 'app'
    },
    // Deprecated
    {
        name: 'atlassian-administration',
        type: 'legacy',
        category: 'app',
        skipExample: true,
        deprecated: true
    },
    {
        name: 'atlassian-admin',
        type: 'legacy',
        category: 'app',
        skipExample: true,
        deprecated: true
    },
    {
        name: 'atlassian-analytics',
        type: 'legacy',
        category: 'app',
        skipExample: true,
        deprecated: true
    },
    {
        name: 'atlas',
        type: 'legacy',
        category: 'app',
        skipExample: true,
        deprecated: true
    },
    {
        name: 'jira-align',
        type: 'legacy',
        category: 'app',
        skipExample: true,
        deprecated: true
    },
    {
        name: 'jira-software',
        type: 'legacy',
        category: 'app',
        skipExample: true,
        deprecated: true
    },
    {
        name: 'jira-work-management',
        type: 'legacy',
        category: 'app',
        skipExample: true,
        deprecated: true
    }
];
var $1cf61e15150efda7$export$62e1212796a86b1b = $1cf61e15150efda7$export$172fd793eb6ecac4.filter(function(logo) {
    return logo.category === 'program' && !logo.skipExample;
}).map(function(logo) {
    return logo.name;
});
var $1cf61e15150efda7$export$e0dee4a765830f4d = $1cf61e15150efda7$export$172fd793eb6ecac4.filter(function(logo) {
    return logo.category === 'app' && !logo.skipExample;
}).map(function(logo) {
    return logo.name;
});
var $1cf61e15150efda7$export$a13ce90e90d7bfc1 = $1cf61e15150efda7$export$172fd793eb6ecac4.filter(function(logo) {
    return logo.category === 'agent' && !logo.skipExample;
}).map(function(logo) {
    return logo.name;
}) || [];
var $1cf61e15150efda7$export$516fce44c502c1d3 = $1cf61e15150efda7$export$172fd793eb6ecac4.filter(function(logo) {
    return logo.type === 'legacy';
});
var $1cf61e15150efda7$export$b805fae8e798ed39 = $1cf61e15150efda7$export$172fd793eb6ecac4.filter(function(logo) {
    return logo.type === 'migration';
});
var $1cf61e15150efda7$export$3f9abd26214cd85f = $1cf61e15150efda7$export$172fd793eb6ecac4.filter(function(logo) {
    return logo.type === 'new';
});

});


parcelRegister("328Ep", function(module, exports) {
"use strict";
var $235844d7ff90dd27$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $235844d7ff90dd27$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $235844d7ff90dd27$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Storage = module.exports.Log = module.exports.EventLogger = module.exports.Diagnostics = void 0;



Object.defineProperty(module.exports, "Diagnostics", {
    enumerable: true,
    get: function() {
        return (parcelRequire("4EJwp")).Diagnostics;
    }
});

var $dJrZC = parcelRequire("dJrZC");
Object.defineProperty(module.exports, "EventLogger", {
    enumerable: true,
    get: function() {
        return $dJrZC.EventLogger;
    }
});

Object.defineProperty(module.exports, "Log", {
    enumerable: true,
    get: function() {
        return (parcelRequire("9Qn0V")).Log;
    }
});


Object.defineProperty(module.exports, "Storage", {
    enumerable: true,
    get: function() {
        return (parcelRequire("jKkqw")).Storage;
    }
});

$235844d7ff90dd27$var$__exportStar((parcelRequire("8ZzeR")), module.exports);

$235844d7ff90dd27$var$__exportStar((parcelRequire("4KuM7")), module.exports);

$235844d7ff90dd27$var$__exportStar((parcelRequire("fivtj")), module.exports);

$235844d7ff90dd27$var$__exportStar((parcelRequire("a5r3l")), module.exports);

$235844d7ff90dd27$var$__exportStar((parcelRequire("4EJwp")), module.exports);

$235844d7ff90dd27$var$__exportStar((parcelRequire("ceicM")), module.exports);

$235844d7ff90dd27$var$__exportStar((parcelRequire("hpmwp")), module.exports);

$235844d7ff90dd27$var$__exportStar((parcelRequire("6lwLe")), module.exports);

$235844d7ff90dd27$var$__exportStar((parcelRequire("80W8k")), module.exports);

$235844d7ff90dd27$var$__exportStar((parcelRequire("doPF1")), module.exports);

$235844d7ff90dd27$var$__exportStar((parcelRequire("6vMkI")), module.exports);

$235844d7ff90dd27$var$__exportStar((parcelRequire("9Qn0V")), module.exports);

$235844d7ff90dd27$var$__exportStar((parcelRequire("4wyC3")), module.exports);

$235844d7ff90dd27$var$__exportStar((parcelRequire("3wynb")), module.exports);

$235844d7ff90dd27$var$__exportStar((parcelRequire("jCkUF")), module.exports);

$235844d7ff90dd27$var$__exportStar((parcelRequire("goCQh")), module.exports);

$235844d7ff90dd27$var$__exportStar((parcelRequire("lUQm9")), module.exports);

$235844d7ff90dd27$var$__exportStar((parcelRequire("hmoSx")), module.exports);

$235844d7ff90dd27$var$__exportStar((parcelRequire("9JrW9")), module.exports);

$235844d7ff90dd27$var$__exportStar((parcelRequire("ldhqF")), module.exports);

$235844d7ff90dd27$var$__exportStar((parcelRequire("hZIMt")), module.exports);

$235844d7ff90dd27$var$__exportStar((parcelRequire("177Kh")), module.exports);

$235844d7ff90dd27$var$__exportStar((parcelRequire("3VNWn")), module.exports);

$235844d7ff90dd27$var$__exportStar((parcelRequire("83Y6N")), module.exports);

$235844d7ff90dd27$var$__exportStar((parcelRequire("4H43E")), module.exports);

$235844d7ff90dd27$var$__exportStar((parcelRequire("gQtPt")), module.exports);

$235844d7ff90dd27$var$__exportStar((parcelRequire("kVJXW")), module.exports);

$235844d7ff90dd27$var$__exportStar((parcelRequire("baWwc")), module.exports);

$235844d7ff90dd27$var$__exportStar((parcelRequire("c3WPJ")), module.exports);

$235844d7ff90dd27$var$__exportStar((parcelRequire("li0QC")), module.exports);

$235844d7ff90dd27$var$__exportStar((parcelRequire("gGLwe")), module.exports);

$235844d7ff90dd27$var$__exportStar((parcelRequire("619VR")), module.exports);

$235844d7ff90dd27$var$__exportStar((parcelRequire("jKkqw")), module.exports);

$235844d7ff90dd27$var$__exportStar((parcelRequire("7PZBS")), module.exports);

$235844d7ff90dd27$var$__exportStar((parcelRequire("cvjEj")), module.exports);

$235844d7ff90dd27$var$__exportStar((parcelRequire("e7KD1")), module.exports);

$235844d7ff90dd27$var$__exportStar((parcelRequire("h59qk")), module.exports);

$235844d7ff90dd27$var$__exportStar((parcelRequire("gmCzl")), module.exports);

$235844d7ff90dd27$var$__exportStar((parcelRequire("kyXOf")), module.exports);

$235844d7ff90dd27$var$__exportStar((parcelRequire("8Glek")), module.exports);
Object.assign((0, (parcelRequire("8ZzeR"))._getStatsigGlobal)(), {
    Log: (parcelRequire("9Qn0V")).Log,
    SDK_VERSION: (parcelRequire("kVJXW")).SDK_VERSION
});

});
parcelRegister("8ZzeR", function(module, exports) {
"use strict";
/* eslint-disable @typescript-eslint/no-unsafe-assignment */ var $68bf5ae524b8dc6b$var$_a, $68bf5ae524b8dc6b$var$_b, $68bf5ae524b8dc6b$var$_c;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._getInstance = module.exports._getStatsigGlobalFlag = module.exports._getStatsigGlobal = void 0;

var $9Qn0V = parcelRequire("9Qn0V");
const $68bf5ae524b8dc6b$var$_getStatsigGlobal = ()=>{
    // Avoid ReferenceError, which is happening with Cloudflare pages
    try {
        return typeof __STATSIG__ !== 'undefined' ? __STATSIG__ : $68bf5ae524b8dc6b$var$statsigGlobal;
    } catch (e) {
        return $68bf5ae524b8dc6b$var$statsigGlobal;
    }
};
module.exports._getStatsigGlobal = $68bf5ae524b8dc6b$var$_getStatsigGlobal;
const $68bf5ae524b8dc6b$var$_getStatsigGlobalFlag = (flag)=>{
    return (0, module.exports._getStatsigGlobal)()[flag];
};
module.exports._getStatsigGlobalFlag = $68bf5ae524b8dc6b$var$_getStatsigGlobalFlag;
const $68bf5ae524b8dc6b$var$_getInstance = (sdkKey)=>{
    const gbl = (0, module.exports._getStatsigGlobal)();
    if (!sdkKey) {
        if (gbl.instances && Object.keys(gbl.instances).length > 1) $9Qn0V.Log.warn('Call made to Statsig global instance without an SDK key but there is more than one client instance. If you are using mulitple clients, please specify the SDK key.');
        return gbl.firstInstance;
    }
    return gbl.instances && gbl.instances[sdkKey];
};
module.exports._getInstance = $68bf5ae524b8dc6b$var$_getInstance;
const $68bf5ae524b8dc6b$var$GLOBAL_KEY = '__STATSIG__';
const $68bf5ae524b8dc6b$var$_window = typeof window !== 'undefined' ? window : {};
const $68bf5ae524b8dc6b$var$_global = typeof $parcel$global !== 'undefined' ? $parcel$global : {};
const $68bf5ae524b8dc6b$var$_globalThis = typeof globalThis !== 'undefined' ? globalThis : {};
const $68bf5ae524b8dc6b$var$statsigGlobal = ($68bf5ae524b8dc6b$var$_c = ($68bf5ae524b8dc6b$var$_b = ($68bf5ae524b8dc6b$var$_a = $68bf5ae524b8dc6b$var$_window[$68bf5ae524b8dc6b$var$GLOBAL_KEY]) !== null && $68bf5ae524b8dc6b$var$_a !== void 0 ? $68bf5ae524b8dc6b$var$_a : $68bf5ae524b8dc6b$var$_global[$68bf5ae524b8dc6b$var$GLOBAL_KEY]) !== null && $68bf5ae524b8dc6b$var$_b !== void 0 ? $68bf5ae524b8dc6b$var$_b : $68bf5ae524b8dc6b$var$_globalThis[$68bf5ae524b8dc6b$var$GLOBAL_KEY]) !== null && $68bf5ae524b8dc6b$var$_c !== void 0 ? $68bf5ae524b8dc6b$var$_c : {
    instance: module.exports._getInstance
};
$68bf5ae524b8dc6b$var$_window[$68bf5ae524b8dc6b$var$GLOBAL_KEY] = $68bf5ae524b8dc6b$var$statsigGlobal;
$68bf5ae524b8dc6b$var$_global[$68bf5ae524b8dc6b$var$GLOBAL_KEY] = $68bf5ae524b8dc6b$var$statsigGlobal;
$68bf5ae524b8dc6b$var$_globalThis[$68bf5ae524b8dc6b$var$GLOBAL_KEY] = $68bf5ae524b8dc6b$var$statsigGlobal;

});
parcelRegister("9Qn0V", function(module, exports) {
"use strict";
/* eslint-disable no-console */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Log = module.exports.LogLevel = void 0;
// intentionally spaced for formatting
const $72aad2747eb95ea5$var$DEBUG = ' DEBUG ';
const $72aad2747eb95ea5$var$_INFO = '  INFO ';
const $72aad2747eb95ea5$var$_WARN = '  WARN ';
const $72aad2747eb95ea5$var$ERROR = ' ERROR ';
function $72aad2747eb95ea5$var$addTag(args) {
    args.unshift('[Statsig]');
    return args; // ['[Statsig]', ...args];
}
module.exports.LogLevel = {
    None: 0,
    Error: 1,
    Warn: 2,
    Info: 3,
    Debug: 4
};
class $72aad2747eb95ea5$var$Log {
    static info(...args) {
        if ($72aad2747eb95ea5$var$Log.level >= module.exports.LogLevel.Info) console.info($72aad2747eb95ea5$var$_INFO, ...$72aad2747eb95ea5$var$addTag(args));
    }
    static debug(...args) {
        if ($72aad2747eb95ea5$var$Log.level >= module.exports.LogLevel.Debug) console.debug($72aad2747eb95ea5$var$DEBUG, ...$72aad2747eb95ea5$var$addTag(args));
    }
    static warn(...args) {
        if ($72aad2747eb95ea5$var$Log.level >= module.exports.LogLevel.Warn) console.warn($72aad2747eb95ea5$var$_WARN, ...$72aad2747eb95ea5$var$addTag(args));
    }
    static error(...args) {
        if ($72aad2747eb95ea5$var$Log.level >= module.exports.LogLevel.Error) console.error($72aad2747eb95ea5$var$ERROR, ...$72aad2747eb95ea5$var$addTag(args));
    }
}
module.exports.Log = $72aad2747eb95ea5$var$Log;
$72aad2747eb95ea5$var$Log.level = module.exports.LogLevel.Warn;

});


parcelRegister("4EJwp", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Diagnostics = void 0;
const $363e358232e7468f$var$MARKER_MAP = new Map();
const $363e358232e7468f$var$ACT_START = 'start';
const $363e358232e7468f$var$ACT_END = 'end';
const $363e358232e7468f$var$DIAGNOSTICS_EVENT = 'statsig::diagnostics';
module.exports.Diagnostics = {
    _getMarkers: (sdkKey)=>{
        return $363e358232e7468f$var$MARKER_MAP.get(sdkKey);
    },
    _markInitOverallStart: (sdkKey)=>{
        $363e358232e7468f$var$_addMarker(sdkKey, $363e358232e7468f$var$_createMarker({}, $363e358232e7468f$var$ACT_START, 'overall'));
    },
    _markInitOverallEnd: (sdkKey, success, evaluationDetails)=>{
        $363e358232e7468f$var$_addMarker(sdkKey, $363e358232e7468f$var$_createMarker({
            success: success,
            error: success ? undefined : {
                name: 'InitializeError',
                message: 'Failed to initialize'
            },
            evaluationDetails: evaluationDetails
        }, $363e358232e7468f$var$ACT_END, 'overall'));
    },
    _markInitNetworkReqStart: (sdkKey, data)=>{
        $363e358232e7468f$var$_addMarker(sdkKey, $363e358232e7468f$var$_createMarker(data, $363e358232e7468f$var$ACT_START, 'initialize', 'network_request'));
    },
    _markInitNetworkReqEnd: (sdkKey, data)=>{
        $363e358232e7468f$var$_addMarker(sdkKey, $363e358232e7468f$var$_createMarker(data, $363e358232e7468f$var$ACT_END, 'initialize', 'network_request'));
    },
    _markInitProcessStart: (sdkKey)=>{
        $363e358232e7468f$var$_addMarker(sdkKey, $363e358232e7468f$var$_createMarker({}, $363e358232e7468f$var$ACT_START, 'initialize', 'process'));
    },
    _markInitProcessEnd: (sdkKey, data)=>{
        $363e358232e7468f$var$_addMarker(sdkKey, $363e358232e7468f$var$_createMarker(data, $363e358232e7468f$var$ACT_END, 'initialize', 'process'));
    },
    _clearMarkers: (sdkKey)=>{
        $363e358232e7468f$var$MARKER_MAP.delete(sdkKey);
    },
    _formatError (e) {
        if (!(e && typeof e === 'object')) return;
        return {
            code: $363e358232e7468f$var$_safeGetField(e, 'code'),
            name: $363e358232e7468f$var$_safeGetField(e, 'name'),
            message: $363e358232e7468f$var$_safeGetField(e, 'message')
        };
    },
    _getDiagnosticsData (res, attempt, body, e) {
        var _a;
        return {
            success: (res === null || res === void 0 ? void 0 : res.ok) === true,
            statusCode: res === null || res === void 0 ? void 0 : res.status,
            sdkRegion: (_a = res === null || res === void 0 ? void 0 : res.headers) === null || _a === void 0 ? void 0 : _a.get('x-statsig-region'),
            isDelta: body.includes('"is_delta":true') === true ? true : undefined,
            attempt: attempt,
            error: module.exports.Diagnostics._formatError(e)
        };
    },
    _enqueueDiagnosticsEvent (user, logger, sdk, options) {
        const markers = module.exports.Diagnostics._getMarkers(sdk);
        if (markers == null || markers.length <= 0) return -1;
        const overallInitDuration = markers[markers.length - 1].timestamp - markers[0].timestamp;
        module.exports.Diagnostics._clearMarkers(sdk);
        const event = $363e358232e7468f$var$_makeDiagnosticsEvent(user, {
            context: 'initialize',
            markers: markers.slice(),
            statsigOptions: options
        });
        logger.enqueue(event);
        return overallInitDuration;
    }
};
function $363e358232e7468f$var$_createMarker(data, action, key, step) {
    return Object.assign({
        key: key,
        action: action,
        step: step,
        timestamp: Date.now()
    }, data);
}
function $363e358232e7468f$var$_makeDiagnosticsEvent(user, data) {
    const latencyEvent = {
        eventName: $363e358232e7468f$var$DIAGNOSTICS_EVENT,
        user: user,
        value: null,
        metadata: data,
        time: Date.now()
    };
    return latencyEvent;
}
function $363e358232e7468f$var$_addMarker(sdkKey, marker) {
    var _a;
    const markers = (_a = $363e358232e7468f$var$MARKER_MAP.get(sdkKey)) !== null && _a !== void 0 ? _a : [];
    markers.push(marker);
    $363e358232e7468f$var$MARKER_MAP.set(sdkKey, markers);
}
function $363e358232e7468f$var$_safeGetField(data, field) {
    if (field in data) return data[field];
    return undefined;
}

});

parcelRegister("dJrZC", function(module, exports) {
"use strict";
var $9ff5311fd4543616$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.EventLogger = void 0;

var $aQvhD = parcelRequire("aQvhD");

var $4KuM7 = parcelRequire("4KuM7");

var $5Iidh = parcelRequire("5Iidh");

var $7Boe8 = parcelRequire("7Boe8");

var $doPF1 = parcelRequire("doPF1");

var $9Qn0V = parcelRequire("9Qn0V");

var $3wynb = parcelRequire("3wynb");

var $6fgsI = parcelRequire("6fgsI");

var $hmoSx = parcelRequire("hmoSx");

var $gQtPt = parcelRequire("gQtPt");

var $baWwc = parcelRequire("baWwc");

var $jKkqw = parcelRequire("jKkqw");

var $e7KD1 = parcelRequire("e7KD1");

var $gmCzl = parcelRequire("gmCzl");
const $9ff5311fd4543616$var$MAX_DEDUPER_KEYS = 1000;
const $9ff5311fd4543616$var$DEDUPER_WINDOW_DURATION_MS = 600000;
const $9ff5311fd4543616$var$EVENT_LOGGER_MAP = {};
class $9ff5311fd4543616$var$EventLogger {
    static _safeFlushAndForget(sdkKey) {
        var _a;
        (_a = $9ff5311fd4543616$var$EVENT_LOGGER_MAP[sdkKey]) === null || _a === void 0 || _a.flush().catch(()=>{
        // noop
        });
    }
    constructor(_sdkKey, _emitter, _network, _options, _errorBoundary){
        var _a;
        this._sdkKey = _sdkKey;
        this._emitter = _emitter;
        this._network = _network;
        this._options = _options;
        this._errorBoundary = _errorBoundary;
        this._pendingEvents = null;
        this._batchQueue = null;
        this._flushCoordinator = null;
        this._lastExposureTimeMap = {};
        this._nonExposedChecks = {};
        this._isShuttingDown = false;
        this._storageKey = null;
        this._pendingCompressionMode = null;
        this._loggingEnabled = (_a = _options === null || _options === void 0 ? void 0 : _options.loggingEnabled) !== null && _a !== void 0 ? _a : (_options === null || _options === void 0 ? void 0 : _options.disableLogging) === true ? $baWwc.LoggingEnabledOption.disabled : $baWwc.LoggingEnabledOption.browserOnly;
        if ((_options === null || _options === void 0 ? void 0 : _options.loggingEnabled) && _options.disableLogging !== undefined) $9Qn0V.Log.warn('Detected both loggingEnabled and disableLogging options. loggingEnabled takes precedence - please remove disableLogging.');
        const config = _options === null || _options === void 0 ? void 0 : _options.networkConfig;
        this._logEventUrlConfig = new $e7KD1.UrlConfiguration($3wynb.Endpoint._rgstr, config === null || config === void 0 ? void 0 : config.logEventUrl, config === null || config === void 0 ? void 0 : config.api, config === null || config === void 0 ? void 0 : config.logEventFallbackUrls);
    }
    setLogEventCompressionMode(mode) {
        if (this._flushCoordinator) this._flushCoordinator.setLogEventCompressionMode(mode);
        else this._pendingCompressionMode = mode;
    }
    setLoggingEnabled(loggingEnabled) {
        const wasDisabled = this._loggingEnabled === 'disabled';
        const isNowEnabled = loggingEnabled !== 'disabled';
        this._loggingEnabled = loggingEnabled;
        if (this._flushCoordinator) this._flushCoordinator.setLoggingEnabled(loggingEnabled);
        if (wasDisabled && isNowEnabled) {
            const events = this._loadStoredEvents();
            $9Qn0V.Log.debug(`Loaded ${events.length} stored event(s) from storage`);
            if (events.length > 0) {
                events.forEach((event)=>{
                    this._initFlushCoordinator().addEvent(event);
                });
                this.flush().catch((error)=>{
                    $9Qn0V.Log.warn('Failed to flush events after enabling logging:', error);
                });
            }
        }
    }
    enqueue(event) {
        var _a;
        if (!this._shouldLogEvent(event)) return;
        const normalizedEvent = this._normalizeEvent(event);
        if (this._loggingEnabled === 'disabled') {
            this._storeEventToStorage(normalizedEvent);
            return;
        }
        this._initFlushCoordinator().addEvent(normalizedEvent);
        (_a = this._flushCoordinator) === null || _a === void 0 || _a.checkQuickFlush();
    }
    incrementNonExposureCount(name) {
        var _a;
        const current = (_a = this._nonExposedChecks[name]) !== null && _a !== void 0 ? _a : 0;
        this._nonExposedChecks[name] = current + 1;
    }
    reset() {
        // attempt to flush any remaining events
        this.flush().catch(()=>{
        // noop
        });
        this._lastExposureTimeMap = {};
    }
    start() {
        var _a;
        const isServerEnv = (0, $hmoSx._isServerEnv)();
        if (isServerEnv && ((_a = this._options) === null || _a === void 0 ? void 0 : _a.loggingEnabled) !== 'always') return;
        const flushCoordinator = this._initFlushCoordinator();
        $9ff5311fd4543616$var$EVENT_LOGGER_MAP[this._sdkKey] = this;
        if (!isServerEnv) (0, $gmCzl._subscribeToVisiblityChanged)((visibility)=>{
            if (visibility === 'background') $9ff5311fd4543616$var$EventLogger._safeFlushAndForget(this._sdkKey);
            else if (visibility === 'foreground') flushCoordinator.startScheduledFlushCycle();
        });
        flushCoordinator.loadAndRetryShutdownFailedEvents().catch((error)=>{
            $9Qn0V.Log.warn('Failed to load failed shutdown events:', error);
        });
        flushCoordinator.startScheduledFlushCycle();
    }
    stop() {
        return $9ff5311fd4543616$var$__awaiter(this, void 0, void 0, function*() {
            this._isShuttingDown = true;
            if (this._flushCoordinator) yield this._flushCoordinator.processShutdown();
            delete $9ff5311fd4543616$var$EVENT_LOGGER_MAP[this._sdkKey];
            this._flushCoordinator = null;
            this._pendingEvents = null;
            this._batchQueue = null;
        });
    }
    flush() {
        return $9ff5311fd4543616$var$__awaiter(this, void 0, void 0, function*() {
            if (!this._flushCoordinator) return;
            return this._flushCoordinator.processManualFlush();
        });
    }
    appendAndResetNonExposedChecks() {
        if (Object.keys(this._nonExposedChecks).length === 0) return;
        const checks = Object.assign({}, this._nonExposedChecks);
        this._nonExposedChecks = {};
        const event = this._normalizeEvent({
            eventName: 'statsig::non_exposed_checks',
            user: null,
            time: Date.now(),
            metadata: {
                checks: checks
            }
        });
        if (!this._flushCoordinator) return;
        this._flushCoordinator.addEvent(event);
    }
    _shouldLogEvent(event) {
        var _a;
        if (((_a = this._options) === null || _a === void 0 ? void 0 : _a.loggingEnabled) !== 'always' && (0, $hmoSx._isServerEnv)()) return false;
        if (!(0, $gQtPt._isExposureEvent)(event)) return true;
        const user = event.user ? event.user : {
            statsigEnvironment: undefined
        };
        const userKey = (0, $4KuM7._getUserStorageKey)(this._sdkKey, user);
        const metadata = event.metadata ? event.metadata : {};
        const key = [
            event.eventName,
            userKey,
            metadata['gate'],
            metadata['config'],
            metadata['ruleID'],
            metadata['allocatedExperiment'],
            metadata['parameterName'],
            String(metadata['isExplicitParameter']),
            metadata['reason']
        ].join('|');
        const previous = this._lastExposureTimeMap[key];
        const now = Date.now();
        if (previous && now - previous < $9ff5311fd4543616$var$DEDUPER_WINDOW_DURATION_MS) return false;
        if (Object.keys(this._lastExposureTimeMap).length > $9ff5311fd4543616$var$MAX_DEDUPER_KEYS) this._lastExposureTimeMap = {};
        this._lastExposureTimeMap[key] = now;
        return true;
    }
    _getCurrentPageUrl() {
        var _a;
        if (((_a = this._options) === null || _a === void 0 ? void 0 : _a.includeCurrentPageUrlWithEvents) === false) return;
        return (0, $hmoSx._getCurrentPageUrlSafe)();
    }
    _getStorageKey() {
        if (!this._storageKey) this._storageKey = `statsig.pending_events.${(0, $doPF1._DJB2)(this._sdkKey)}`;
        return this._storageKey;
    }
    _initFlushCoordinator() {
        var _a, _b;
        if (this._flushCoordinator) return this._flushCoordinator;
        const batchSize = (_b = (_a = this._options) === null || _a === void 0 ? void 0 : _a.loggingBufferMaxSize) !== null && _b !== void 0 ? _b : $5Iidh.EventRetryConstants.DEFAULT_BATCH_SIZE;
        this._pendingEvents = new $6fgsI.PendingEvents(batchSize);
        this._batchQueue = new $aQvhD.BatchQueue(batchSize);
        this._flushCoordinator = new $7Boe8.FlushCoordinator(this._batchQueue, this._pendingEvents, ()=>this.appendAndResetNonExposedChecks(), this._sdkKey, this._network, this._emitter, this._logEventUrlConfig, this._options, this._loggingEnabled, this._errorBoundary);
        if (this._pendingCompressionMode) {
            this._flushCoordinator.setLogEventCompressionMode(this._pendingCompressionMode);
            this._pendingCompressionMode = null;
        }
        return this._flushCoordinator;
    }
    _storeEventToStorage(event) {
        const storageKey = this._getStorageKey();
        try {
            let existingEvents = this._getEventsFromStorage(storageKey);
            existingEvents.push(event);
            if (existingEvents.length > $5Iidh.EventRetryConstants.MAX_LOCAL_STORAGE) existingEvents = existingEvents.slice(-$5Iidh.EventRetryConstants.MAX_LOCAL_STORAGE);
            (0, $jKkqw._setObjectInStorage)(storageKey, existingEvents);
        } catch (error) {
            $9Qn0V.Log.warn('Unable to save events to storage');
        }
    }
    _getEventsFromStorage(storageKey) {
        try {
            const events = (0, $jKkqw._getObjectFromStorage)(storageKey);
            if (Array.isArray(events)) return events;
            return [];
        } catch (_a) {
            return [];
        }
    }
    _loadStoredEvents() {
        const storageKey = this._getStorageKey();
        const events = this._getEventsFromStorage(storageKey);
        if (events.length > 0) $jKkqw.Storage.removeItem(storageKey);
        return events;
    }
    _normalizeEvent(event) {
        if (event.user) {
            event.user = Object.assign({}, event.user);
            delete event.user.privateAttributes;
        }
        const extras = {};
        const currentPage = this._getCurrentPageUrl();
        if (currentPage) extras.statsigMetadata = {
            currentPage: currentPage
        };
        return Object.assign(Object.assign({}, event), extras);
    }
}
module.exports.EventLogger = $9ff5311fd4543616$var$EventLogger;

});
parcelRegister("aQvhD", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.BatchQueue = void 0;

var $1UVsX = parcelRequire("1UVsX");

var $5Iidh = parcelRequire("5Iidh");
class $7e5706f58e8e9e50$var$BatchQueue {
    constructor(batchSize = $5Iidh.EventRetryConstants.DEFAULT_BATCH_SIZE){
        this._batches = [];
        this._batchSize = batchSize;
    }
    batchSize() {
        return this._batchSize;
    }
    requeueBatch(batch) {
        return this._enqueueBatch(batch);
    }
    hasFullBatch() {
        return this._batches.some((batch)=>batch.events.length >= this._batchSize);
    }
    takeNextBatch() {
        return this._batches.shift();
    }
    takeAllBatches() {
        const batches = this._batches;
        this._batches = [];
        return batches;
    }
    createBatches(events) {
        let i = 0;
        let droppedCount = 0;
        while(i < events.length){
            const chunk = events.slice(i, i + this._batchSize);
            droppedCount += this._enqueueBatch(new $1UVsX.EventBatch(chunk));
            i += this._batchSize;
        }
        return droppedCount;
    }
    _enqueueBatch(batch) {
        this._batches.push(batch);
        let droppedEventCount = 0;
        while(this._batches.length > $5Iidh.EventRetryConstants.MAX_PENDING_BATCHES){
            const dropped = this._batches.shift();
            if (dropped) droppedEventCount += dropped.events.length;
        }
        return droppedEventCount;
    }
}
module.exports.BatchQueue = $7e5706f58e8e9e50$var$BatchQueue;

});
parcelRegister("1UVsX", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.EventBatch = void 0;
class $165798f72bab27d0$var$EventBatch {
    constructor(events){
        this.attempts = 0;
        this.createdAt = Date.now();
        this.events = events;
    }
    incrementAttempts() {
        this.attempts++;
    }
}
module.exports.EventBatch = $165798f72bab27d0$var$EventBatch;

});

parcelRegister("5Iidh", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.EventRetryConstants = void 0;
module.exports.EventRetryConstants = {
    MAX_RETRY_ATTEMPTS: 8,
    DEFAULT_BATCH_SIZE: 100,
    MAX_PENDING_BATCHES: 40,
    TICK_INTERVAL_MS: 1000,
    QUICK_FLUSH_WINDOW_MS: 200,
    MAX_LOCAL_STORAGE: 500,
    get MAX_QUEUED_EVENTS () {
        return this.DEFAULT_BATCH_SIZE * this.MAX_PENDING_BATCHES;
    }
};

});


parcelRegister("4KuM7", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._getStorageKey = module.exports._getUserStorageKey = void 0;

var $doPF1 = parcelRequire("doPF1");
function $3753549ef8303d40$var$_getUserStorageKey(sdkKey, user, customKeyGenerator) {
    var _a;
    if (customKeyGenerator) return customKeyGenerator(sdkKey, user);
    const cids = user && user.customIDs ? user.customIDs : {};
    const parts = [
        `uid:${(_a = user === null || user === void 0 ? void 0 : user.userID) !== null && _a !== void 0 ? _a : ''}`,
        `cids:${Object.keys(cids).sort((leftKey, rightKey)=>leftKey.localeCompare(rightKey)).map((key)=>`${key}-${cids[key]}`).join(',')}`,
        `k:${sdkKey}`
    ];
    return (0, $doPF1._DJB2)(parts.join('|'));
}
module.exports._getUserStorageKey = $3753549ef8303d40$var$_getUserStorageKey;
function $3753549ef8303d40$var$_getStorageKey(sdkKey, user, customKeyGenerator) {
    if (user) return $3753549ef8303d40$var$_getUserStorageKey(sdkKey, user, customKeyGenerator);
    return (0, $doPF1._DJB2)(`k:${sdkKey}`);
}
module.exports._getStorageKey = $3753549ef8303d40$var$_getStorageKey;

});
parcelRegister("doPF1", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._getSortedObject = module.exports._DJB2Object = module.exports._DJB2 = void 0;

var $cvjEj = parcelRequire("cvjEj");
const $9c1596f7cf1506ee$var$_DJB2 = (value)=>{
    let hash = 0;
    for(let i = 0; i < value.length; i++){
        const character = value.charCodeAt(i);
        hash = (hash << 5) - hash + character;
        hash = hash & hash; // Convert to 32bit integer
    }
    return String(hash >>> 0);
};
module.exports._DJB2 = $9c1596f7cf1506ee$var$_DJB2;
const $9c1596f7cf1506ee$var$_DJB2Object = (value, maxLevels)=>{
    return (0, module.exports._DJB2)(JSON.stringify((0, module.exports._getSortedObject)(value, maxLevels)));
};
module.exports._DJB2Object = $9c1596f7cf1506ee$var$_DJB2Object;
const $9c1596f7cf1506ee$var$_getSortedObject = (object, maxDepth)=>{
    if (object == null) return null;
    const keys = Object.keys(object).sort();
    const sortedObject = {};
    keys.forEach((key)=>{
        const value = object[key];
        if (maxDepth === 0 || (0, $cvjEj._typeOf)(value) !== 'object') {
            sortedObject[key] = value;
            return;
        }
        sortedObject[key] = (0, module.exports._getSortedObject)(value, maxDepth != null ? maxDepth - 1 : maxDepth);
    });
    return sortedObject;
};
module.exports._getSortedObject = $9c1596f7cf1506ee$var$_getSortedObject;

});
parcelRegister("cvjEj", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._isTypeMatch = module.exports._typeOf = void 0;
function $91a79f34841955f8$var$_typeOf(input) {
    return Array.isArray(input) ? 'array' : typeof input;
}
module.exports._typeOf = $91a79f34841955f8$var$_typeOf;
function $91a79f34841955f8$var$_isTypeMatch(a, b) {
    const typeOf = (x)=>Array.isArray(x) ? 'array' : x === null ? 'null' : typeof x;
    return typeOf(a) === typeOf(b);
}
module.exports._isTypeMatch = $91a79f34841955f8$var$_isTypeMatch;

});



parcelRegister("7Boe8", function(module, exports) {
"use strict";
var $588ec813c7f5a347$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.FlushCoordinator = void 0;

var $5Iidh = parcelRequire("5Iidh");

var $1ls7U = parcelRequire("1ls7U");

var $4Pl5d = parcelRequire("4Pl5d");

var $h8kEr = parcelRequire("h8kEr");

var $doPF1 = parcelRequire("doPF1");

var $9Qn0V = parcelRequire("9Qn0V");

var $jCkUF = parcelRequire("jCkUF");

var $hmoSx = parcelRequire("hmoSx");

var $ldhqF = parcelRequire("ldhqF");

var $baWwc = parcelRequire("baWwc");

var $jKkqw = parcelRequire("jKkqw");
const $588ec813c7f5a347$var$RETRYABLE_NO_RESPONSE_FAILURE_PATHS = new Set([
    'network_request_timed_out_no_response',
    'network_request_exception_no_response',
    'event_sender_post_returned_null',
    'event_sender_post_returned_undefined',
    'event_sender_post_exception'
]);
class $588ec813c7f5a347$var$FlushCoordinator {
    constructor(batchQueue, pendingEvents, onPrepareFlush, // For Event Sender
    sdkKey, network, emitter, logEventUrlConfig, options, loggingEnabled, errorBoundary){
        this._cooldownTimer = null;
        this._maxIntervalTimer = null;
        this._hasRunQuickFlush = false;
        this._currentFlushPromise = null;
        this._creationTime = Date.now();
        this._isShuttingDown = false;
        this._storageKey = null;
        this._flushInterval = new $4Pl5d.FlushInterval();
        this._batchQueue = batchQueue;
        this._pendingEvents = pendingEvents;
        this._onPrepareFlush = onPrepareFlush;
        this._errorBoundary = errorBoundary;
        this._sdkKey = sdkKey;
        this._loggingEnabled = loggingEnabled;
        this._eventSender = new $1ls7U.EventSender(sdkKey, network, emitter, logEventUrlConfig, options);
    }
    setLoggingEnabled(loggingEnabled) {
        this._loggingEnabled = loggingEnabled;
    }
    setLogEventCompressionMode(mode) {
        this._eventSender.setLogEventCompressionMode(mode);
    }
    startScheduledFlushCycle() {
        this._scheduleNextFlush();
    }
    stopScheduledFlushCycle() {
        this._clearAllTimers();
    }
    addEvent(event) {
        this._pendingEvents.addToPendingEventsQueue(event);
        if (this._currentFlushPromise) return;
        if (this._pendingEvents.hasEventsForFullBatch()) this.processLimitFlush();
    }
    processManualFlush() {
        return $588ec813c7f5a347$var$__awaiter(this, void 0, void 0, function*() {
            if (this._currentFlushPromise) yield this._currentFlushPromise;
            this._currentFlushPromise = this._executeFlush($h8kEr.FlushTypeValues.Manual).finally(()=>{
                this._currentFlushPromise = null;
                this._scheduleNextFlush();
            });
            return this._currentFlushPromise;
        });
    }
    processShutdown() {
        return $588ec813c7f5a347$var$__awaiter(this, void 0, void 0, function*() {
            this._isShuttingDown = true;
            this._clearAllTimers();
            if (this._currentFlushPromise) yield this._currentFlushPromise;
            this._currentFlushPromise = this._executeFlush($h8kEr.FlushTypeValues.Shutdown).catch((error)=>{
                $9Qn0V.Log.error(`Error during shutdown flush: ${error}`);
            }).finally(()=>{
                this._currentFlushPromise = null;
            });
            return this._currentFlushPromise;
        });
    }
    _executeFlush(flushType) {
        return $588ec813c7f5a347$var$__awaiter(this, void 0, void 0, function*() {
            this._clearAllTimers();
            try {
                this._prepareQueueForFlush(flushType);
                const batches = this._batchQueue.takeAllBatches();
                if (batches.length === 0) return;
                yield Promise.all(batches.map((batch)=>this._processOneBatch(batch, flushType)));
            } finally{
                if (!this._isShuttingDown) this._scheduleNextFlush();
            }
        });
    }
    checkQuickFlush() {
        if (this._hasRunQuickFlush) return;
        if (Date.now() - this._creationTime > $5Iidh.EventRetryConstants.QUICK_FLUSH_WINDOW_MS) return;
        this._hasRunQuickFlush = true;
        setTimeout(()=>{
            this.processManualFlush().catch((error)=>{
                $9Qn0V.Log.warn('Quick flush failed:', error);
            });
        }, $5Iidh.EventRetryConstants.QUICK_FLUSH_WINDOW_MS);
    }
    _attemptScheduledFlush() {
        if (this._currentFlushPromise) {
            this._scheduleNextFlush();
            return;
        }
        const shouldFlushBySize = this.containsAtLeastOneFullBatch();
        const shouldFlushByTime = this._flushInterval.hasReachedMaxInterval();
        if (!shouldFlushBySize && !shouldFlushByTime) {
            this._scheduleNoopPollTick();
            return;
        }
        this._flushInterval.markFlushAttempt();
        let flushType;
        if (shouldFlushBySize) flushType = $h8kEr.FlushTypeValues.ScheduledFullBatch;
        else flushType = $h8kEr.FlushTypeValues.ScheduledMaxTime;
        this._currentFlushPromise = this._processNextBatch(flushType).then(()=>{
        //This discards boolean result. Main goal here is to track completion
        }).catch((error)=>{
            $9Qn0V.Log.error('Error during scheduled flush:', error);
        }).finally(()=>{
            this._currentFlushPromise = null;
            this._scheduleNextFlush();
        });
    }
    processLimitFlush() {
        if (!this._flushInterval.hasCompletelyRecoveredFromBackoff()) return;
        if (this._currentFlushPromise) return;
        this._currentFlushPromise = this._processLimitFlushInternal().catch((error)=>{
            $9Qn0V.Log.error(`Error during limit flush`, error);
        }).finally(()=>{
            this._currentFlushPromise = null;
            this._scheduleNextFlush();
        });
    }
    _processLimitFlushInternal() {
        return $588ec813c7f5a347$var$__awaiter(this, void 0, void 0, function*() {
            const success = yield this._processNextBatch($h8kEr.FlushTypeValues.Limit);
            if (!success) return;
            while(this._flushInterval.hasCompletelyRecoveredFromBackoff() && this.containsAtLeastOneFullBatch()){
                const success = yield this._processNextBatch($h8kEr.FlushTypeValues.Limit);
                if (!success) break;
            }
        });
    }
    _scheduleNextFlush() {
        this._clearAllTimers();
        if (this._isShuttingDown) return;
        const cooldownDelay = Math.max(0, this._flushInterval.getTimeUntilNextFlush());
        this._cooldownTimer = setTimeout(()=>{
            this._cooldownTimer = null;
            $ldhqF.StatsigSession.checkForIdleSession(this._sdkKey);
            this._attemptScheduledFlush();
        }, cooldownDelay);
        const maxIntervalDelay = Math.max(0, this._flushInterval.getTimeTillMaxInterval());
        this._maxIntervalTimer = setTimeout(()=>{
            this._maxIntervalTimer = null;
            $ldhqF.StatsigSession.checkForIdleSession(this._sdkKey);
            this._attemptScheduledFlush();
        }, maxIntervalDelay);
    }
    _clearAllTimers() {
        if (this._cooldownTimer !== null) {
            clearTimeout(this._cooldownTimer);
            this._cooldownTimer = null;
        }
        if (this._maxIntervalTimer !== null) {
            clearTimeout(this._maxIntervalTimer);
            this._maxIntervalTimer = null;
        }
    }
    _scheduleNoopPollTick() {
        this._clearAllTimers();
        if (this._isShuttingDown) return;
        this._cooldownTimer = setTimeout(()=>{
            this._cooldownTimer = null;
            $ldhqF.StatsigSession.checkForIdleSession(this._sdkKey);
            this._attemptScheduledFlush();
        }, $5Iidh.EventRetryConstants.TICK_INTERVAL_MS);
        const maxIntervalDelay = Math.max(0, this._flushInterval.getTimeTillMaxInterval());
        this._maxIntervalTimer = setTimeout(()=>{
            this._maxIntervalTimer = null;
            $ldhqF.StatsigSession.checkForIdleSession(this._sdkKey);
            this._attemptScheduledFlush();
        }, maxIntervalDelay);
    }
    _processNextBatch(flushType) {
        return $588ec813c7f5a347$var$__awaiter(this, void 0, void 0, function*() {
            this._prepareQueueForFlush(flushType);
            const batch = this._batchQueue.takeNextBatch();
            if (!batch) return false;
            return this._processOneBatch(batch, flushType);
        });
    }
    _processOneBatch(batch, flushType) {
        return $588ec813c7f5a347$var$__awaiter(this, void 0, void 0, function*() {
            if (this._loggingEnabled !== $baWwc.LoggingEnabledOption.always && (0, $hmoSx._isServerEnv)()) {
                this._flushInterval.adjustForSuccess();
                return true;
            }
            const result = yield this._eventSender.sendBatch(batch);
            if (result.success) {
                this._flushInterval.adjustForSuccess();
                return true;
            }
            this._flushInterval.adjustForFailure();
            this._handleFailure(batch, flushType, result.statusCode, result.failurePath, result.failureErrorMessage, result.failureDiagnosticBucket, result.failureDiagnosticMetadata);
            return false;
        });
    }
    _prepareQueueForFlush(flushType) {
        this._onPrepareFlush();
        const droppedCount = this.convertPendingEventsToBatches();
        if (droppedCount > 0) {
            $9Qn0V.Log.warn(`Dropped ${droppedCount} events`);
            this._errorBoundary.logDroppedEvents(droppedCount, `Batch queue limit reached during batching`, {
                loggingInterval: this._flushInterval.getCurrentIntervalMs(),
                batchSize: this._batchQueue.batchSize(),
                maxPendingBatches: $5Iidh.EventRetryConstants.MAX_PENDING_BATCHES,
                flushType: flushType,
                retries: 'dropped before batching'
            });
        }
    }
    containsAtLeastOneFullBatch() {
        return this._pendingEvents.hasEventsForFullBatch() || this._batchQueue.hasFullBatch();
    }
    convertPendingEventsToBatches() {
        if (this._pendingEvents.isEmpty()) return 0;
        const allEvents = this._pendingEvents.takeAll();
        return this._batchQueue.createBatches(allEvents);
    }
    _isRetryableBatch(statusCode, failurePath) {
        if ($jCkUF.RETRYABLE_CODES.has(statusCode)) return true;
        if (statusCode === -1 && failurePath && $588ec813c7f5a347$var$RETRYABLE_NO_RESPONSE_FAILURE_PATHS.has(failurePath)) return true;
        return false;
    }
    _handleFailure(batch, flushType, statusCode, failurePath, failureErrorMessage, failureDiagnosticBucket, failureDiagnosticMetadata) {
        if (flushType === $h8kEr.FlushTypeValues.Shutdown) {
            $9Qn0V.Log.warn(`${flushType} flush failed during shutdown. ` + `${batch.events.length} event(s) will be saved to storage for retry in next session.`);
            this._saveShutdownFailedEventsToStorage(batch.events);
            return;
        }
        if (!this._isRetryableBatch(statusCode, failurePath)) {
            const reason = `non-retryable error`;
            $9Qn0V.Log.warn(`${flushType} flush failed after ${batch.attempts} attempt(s). ` + `${batch.events.length} event(s) will be dropped. Non-retryable error: ${statusCode}`);
            this._errorBoundary.logEventRequestFailure(batch.events.length, reason, flushType, statusCode, batch.attempts, failurePath, failureErrorMessage, failureDiagnosticBucket, failureDiagnosticMetadata);
            return;
        }
        if (batch.attempts >= $5Iidh.EventRetryConstants.MAX_RETRY_ATTEMPTS) {
            const reason = `max retry attempts exceeded`;
            $9Qn0V.Log.warn(`${flushType} flush failed after ${batch.attempts} attempt(s). ` + `${batch.events.length} event(s) will be dropped.`);
            this._errorBoundary.logEventRequestFailure(batch.events.length, reason, flushType, statusCode, batch.attempts, failurePath, failureErrorMessage, failureDiagnosticBucket, failureDiagnosticMetadata);
            return;
        }
        batch.incrementAttempts();
        const droppedCount = this._batchQueue.requeueBatch(batch);
        if (droppedCount > 0) {
            $9Qn0V.Log.warn(`Failed to requeue batch : dropped ${droppedCount} events due to full queue`);
            this._errorBoundary.logDroppedEvents(droppedCount, `Batch queue limit reached during requeue`, {
                loggingInterval: this._flushInterval.getCurrentIntervalMs(),
                batchSize: this._batchQueue.batchSize(),
                maxPendingBatches: $5Iidh.EventRetryConstants.MAX_PENDING_BATCHES,
                flushType: flushType,
                retries: batch.attempts
            });
        }
    }
    loadAndRetryShutdownFailedEvents() {
        return $588ec813c7f5a347$var$__awaiter(this, void 0, void 0, function*() {
            const storageKey = this._getStorageKey();
            try {
                if (!$jKkqw.Storage.isReady()) yield $jKkqw.Storage.isReadyResolver();
                const events = this._getShutdownFailedEventsFromStorage(storageKey);
                if (events.length === 0) return;
                $9Qn0V.Log.debug(`Loading ${events.length} failed shutdown event(s) from storage for retry`);
                $jKkqw.Storage.removeItem(storageKey);
                events.forEach((event)=>{
                    this.addEvent(event);
                });
                yield this.processManualFlush();
            } catch (error) {
                $9Qn0V.Log.warn('Failed to load and retry failed shutdown events:', error);
            }
        });
    }
    _getStorageKey() {
        if (!this._storageKey) this._storageKey = `statsig.failed_shutdown_events.${(0, $doPF1._DJB2)(this._sdkKey)}`;
        return this._storageKey;
    }
    _saveShutdownFailedEventsToStorage(events) {
        const storageKey = this._getStorageKey();
        try {
            const existingEvents = this._getShutdownFailedEventsFromStorage(storageKey);
            let allEvents = [
                ...existingEvents,
                ...events
            ];
            if (allEvents.length > $5Iidh.EventRetryConstants.MAX_LOCAL_STORAGE) allEvents = allEvents.slice(-$5Iidh.EventRetryConstants.MAX_LOCAL_STORAGE);
            (0, $jKkqw._setObjectInStorage)(storageKey, allEvents);
            $9Qn0V.Log.debug(`Saved ${events.length} failed shutdown event(s) to storage (total stored: ${allEvents.length})`);
        } catch (error) {
            $9Qn0V.Log.warn('Unable to save failed shutdown events to storage:', error);
        }
    }
    _getShutdownFailedEventsFromStorage(storageKey) {
        try {
            const events = (0, $jKkqw._getObjectFromStorage)(storageKey);
            if (Array.isArray(events)) return events;
            return [];
        } catch (_a) {
            return [];
        }
    }
}
module.exports.FlushCoordinator = $588ec813c7f5a347$var$FlushCoordinator;

});
parcelRegister("1ls7U", function(module, exports) {
"use strict";
var $0fad91fb62a2b5df$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.EventSender = void 0;

var $9Qn0V = parcelRequire("9Qn0V");

var $3wynb = parcelRequire("3wynb");

var $9JrW9 = parcelRequire("9JrW9");

var $kVJXW = parcelRequire("kVJXW");

var $gmCzl = parcelRequire("gmCzl");
class $0fad91fb62a2b5df$var$EventSender {
    constructor(sdkKey, network, emitter, logEventUrlConfig, options){
        this._sdkKey = sdkKey;
        this._network = network;
        this._emitter = emitter;
        this._options = options;
        this._logEventUrlConfig = logEventUrlConfig;
    }
    setLogEventCompressionMode(mode) {
        this._network.setLogEventCompressionMode(mode);
    }
    sendBatch(batch) {
        return $0fad91fb62a2b5df$var$__awaiter(this, void 0, void 0, function*() {
            var _a, _b, _c;
            let failurePath = 'event_sender_unexpected_exception';
            const transportFailure = {};
            try {
                const isClosing = (0, $gmCzl._isUnloading)();
                const shouldUseBeacon = isClosing && this._network.isBeaconSupported() && ((_b = (_a = this._options) === null || _a === void 0 ? void 0 : _a.networkConfig) === null || _b === void 0 ? void 0 : _b.networkOverrideFunc) == null;
                failurePath = 'event_sender_pre_logs_flushed_emitter_exception';
                this._emitter({
                    name: 'pre_logs_flushed',
                    events: batch.events
                });
                failurePath = shouldUseBeacon ? 'event_sender_unexpected_exception' : 'event_sender_post_exception';
                const response = shouldUseBeacon ? this._sendEventsViaBeacon(batch, transportFailure) : yield this._sendEventsViaPost(batch, transportFailure);
                if (response.success) {
                    failurePath = 'event_sender_logs_flushed_emitter_exception';
                    this._emitter({
                        name: 'logs_flushed',
                        events: batch.events
                    });
                    return response;
                }
                return Object.assign(Object.assign(Object.assign({
                    success: false,
                    statusCode: response.statusCode,
                    failurePath: response.failurePath
                }, response.failureErrorMessage ? {
                    failureErrorMessage: response.failureErrorMessage
                } : {}), response.failureDiagnosticBucket ? {
                    failureDiagnosticBucket: response.failureDiagnosticBucket
                } : {}), response.failureDiagnosticMetadata ? {
                    failureDiagnosticMetadata: response.failureDiagnosticMetadata
                } : {});
            } catch (error) {
                $9Qn0V.Log.warn('Failed to send batch:', error);
                return Object.assign(Object.assign(Object.assign({
                    success: false,
                    statusCode: -1,
                    failurePath: (_c = transportFailure.path) !== null && _c !== void 0 ? _c : failurePath
                }, transportFailure.errorMessage ? {
                    failureErrorMessage: transportFailure.errorMessage
                } : {}), transportFailure.diagnosticBucket ? {
                    failureDiagnosticBucket: transportFailure.diagnosticBucket
                } : {}), transportFailure.diagnosticMetadata ? {
                    failureDiagnosticMetadata: transportFailure.diagnosticMetadata
                } : {});
            }
        });
    }
    _sendEventsViaPost(batch, failureInfo) {
        return $0fad91fb62a2b5df$var$__awaiter(this, void 0, void 0, function*() {
            var _a, _b;
            const result = yield this._network.post(this._getRequestData(batch), failureInfo);
            const code = (_a = result === null || result === void 0 ? void 0 : result.code) !== null && _a !== void 0 ? _a : -1;
            if (code === -1) return Object.assign(Object.assign(Object.assign({
                success: false,
                statusCode: -1,
                failurePath: (_b = failureInfo.path) !== null && _b !== void 0 ? _b : result === undefined ? 'event_sender_post_returned_undefined' : 'event_sender_post_returned_null'
            }, failureInfo.errorMessage ? {
                failureErrorMessage: failureInfo.errorMessage
            } : {}), failureInfo.diagnosticBucket ? {
                failureDiagnosticBucket: failureInfo.diagnosticBucket
            } : {}), failureInfo.diagnosticMetadata ? {
                failureDiagnosticMetadata: failureInfo.diagnosticMetadata
            } : {});
            return {
                success: code >= 200 && code < 300,
                statusCode: code
            };
        });
    }
    _sendEventsViaBeacon(batch, failureInfo) {
        var _a;
        const success = this._network.beacon(this._getRequestData(batch), failureInfo);
        return Object.assign(Object.assign(Object.assign({
            success: success,
            statusCode: success ? 200 : -1,
            failurePath: success ? undefined : (_a = failureInfo.path) !== null && _a !== void 0 ? _a : 'beacon_send_false'
        }, !success && failureInfo.errorMessage ? {
            failureErrorMessage: failureInfo.errorMessage
        } : {}), !success && failureInfo.diagnosticBucket ? {
            failureDiagnosticBucket: failureInfo.diagnosticBucket
        } : {}), !success && failureInfo.diagnosticMetadata ? {
            failureDiagnosticMetadata: failureInfo.diagnosticMetadata
        } : {});
    }
    _getRequestData(batch) {
        return {
            sdkKey: this._sdkKey,
            data: {
                events: batch.events
            },
            urlConfig: this._logEventUrlConfig,
            retries: 3,
            preserveFailedStatusCode: true,
            isCompressable: true,
            params: {
                [$3wynb.NetworkParam.EventCount]: String(batch.events.length)
            },
            headers: {
                'statsig-event-count': String(batch.events.length),
                'statsig-retry-count': String(batch.attempts),
                'statsig-sdk-type': $9JrW9.SDKType._get(this._sdkKey),
                'statsig-sdk-version': $kVJXW.SDK_VERSION
            },
            credentials: 'same-origin'
        };
    }
}
module.exports.EventSender = $0fad91fb62a2b5df$var$EventSender;

});
parcelRegister("3wynb", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.NetworkParam = module.exports.NetworkDefault = module.exports.Endpoint = void 0;
module.exports.Endpoint = {
    _initialize: 'initialize',
    _rgstr: 'rgstr',
    _download_config_specs: 'download_config_specs'
};
module.exports.NetworkDefault = {
    [module.exports.Endpoint._rgstr]: 'https://prodregistryv2.org/v1',
    [module.exports.Endpoint._initialize]: 'https://featureassets.org/v1',
    [module.exports.Endpoint._download_config_specs]: 'https://api.statsigcdn.com/v1'
};
module.exports.NetworkParam = {
    EventCount: 'ec',
    SdkKey: 'k',
    SdkType: 'st',
    SdkVersion: 'sv',
    Time: 't',
    SessionID: 'sid',
    StatsigEncoded: 'se',
    IsGzipped: 'gz'
};

});

parcelRegister("9JrW9", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SDKType = void 0;
const $715dfcb364c2ee2f$var$SDK_CLIENT = {};
let $715dfcb364c2ee2f$var$suffix;
module.exports.SDKType = {
    _get: (sdkKey)=>{
        var _a;
        return ((_a = $715dfcb364c2ee2f$var$SDK_CLIENT[sdkKey]) !== null && _a !== void 0 ? _a : 'js-mono') + ($715dfcb364c2ee2f$var$suffix !== null && $715dfcb364c2ee2f$var$suffix !== void 0 ? $715dfcb364c2ee2f$var$suffix : '');
    },
    _setClientType (sdkKey, client) {
        $715dfcb364c2ee2f$var$SDK_CLIENT[sdkKey] = client;
    },
    _setBindingType (binding) {
        if (!$715dfcb364c2ee2f$var$suffix || $715dfcb364c2ee2f$var$suffix === '-react') $715dfcb364c2ee2f$var$suffix = '-' + binding;
    }
};

});

parcelRegister("kVJXW", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.StatsigMetadataProvider = module.exports.SDK_VERSION = void 0;
module.exports.SDK_VERSION = '3.33.2';
let $f3ccc959e0f12c92$var$metadata = {
    sdkVersion: module.exports.SDK_VERSION,
    sdkType: 'js-mono'
};
module.exports.StatsigMetadataProvider = {
    get: ()=>$f3ccc959e0f12c92$var$metadata,
    add: (additions)=>{
        $f3ccc959e0f12c92$var$metadata = Object.assign(Object.assign({}, $f3ccc959e0f12c92$var$metadata), additions);
    }
};

});

parcelRegister("gmCzl", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._notifyVisibilityChanged = module.exports._subscribeToVisiblityChanged = module.exports._isUnloading = module.exports._isCurrentlyVisible = void 0;

var $hmoSx = parcelRequire("hmoSx");
const $be9c9e6ef52ef65a$var$FOREGROUND = 'foreground';
const $be9c9e6ef52ef65a$var$BACKGROUND = 'background';
const $be9c9e6ef52ef65a$var$LISTENERS = [];
let $be9c9e6ef52ef65a$var$current = $be9c9e6ef52ef65a$var$FOREGROUND;
let $be9c9e6ef52ef65a$var$isUnloading = false;
const $be9c9e6ef52ef65a$var$_isCurrentlyVisible = ()=>{
    return $be9c9e6ef52ef65a$var$current === $be9c9e6ef52ef65a$var$FOREGROUND;
};
module.exports._isCurrentlyVisible = $be9c9e6ef52ef65a$var$_isCurrentlyVisible;
const $be9c9e6ef52ef65a$var$_isUnloading = ()=>$be9c9e6ef52ef65a$var$isUnloading;
module.exports._isUnloading = $be9c9e6ef52ef65a$var$_isUnloading;
const $be9c9e6ef52ef65a$var$_subscribeToVisiblityChanged = (listener)=>{
    $be9c9e6ef52ef65a$var$LISTENERS.unshift(listener);
};
module.exports._subscribeToVisiblityChanged = $be9c9e6ef52ef65a$var$_subscribeToVisiblityChanged;
const $be9c9e6ef52ef65a$var$_notifyVisibilityChanged = (visibility)=>{
    if (visibility === $be9c9e6ef52ef65a$var$current) return;
    $be9c9e6ef52ef65a$var$current = visibility;
    $be9c9e6ef52ef65a$var$LISTENERS.forEach((l)=>l(visibility));
};
module.exports._notifyVisibilityChanged = $be9c9e6ef52ef65a$var$_notifyVisibilityChanged;
(0, $hmoSx._addWindowEventListenerSafe)('focus', ()=>{
    $be9c9e6ef52ef65a$var$isUnloading = false;
    (0, module.exports._notifyVisibilityChanged)($be9c9e6ef52ef65a$var$FOREGROUND);
});
(0, $hmoSx._addWindowEventListenerSafe)('blur', ()=>(0, module.exports._notifyVisibilityChanged)($be9c9e6ef52ef65a$var$BACKGROUND));
(0, $hmoSx._addDocumentEventListenerSafe)('visibilitychange', ()=>{
    (0, module.exports._notifyVisibilityChanged)(document.visibilityState === 'visible' ? $be9c9e6ef52ef65a$var$FOREGROUND : $be9c9e6ef52ef65a$var$BACKGROUND);
});
(0, $hmoSx._addWindowEventListenerSafe)((0, $hmoSx._getUnloadEvent)(), ()=>{
    $be9c9e6ef52ef65a$var$isUnloading = true;
    (0, module.exports._notifyVisibilityChanged)($be9c9e6ef52ef65a$var$BACKGROUND);
});

});
parcelRegister("hmoSx", function(module, exports) {

var $3ZMUU = parcelRequire("3ZMUU");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._cloneObject = module.exports._getUnloadEvent = module.exports._getCurrentPageUrlSafe = module.exports._addDocumentEventListenerSafe = module.exports._addWindowEventListenerSafe = module.exports._isServerEnv = module.exports._getDocumentSafe = module.exports._getWindowSafe = void 0;

var $9Qn0V = parcelRequire("9Qn0V");
const $ca37ca24bb1bb692$var$_getWindowSafe = ()=>{
    return typeof window !== 'undefined' ? window : null;
};
module.exports._getWindowSafe = $ca37ca24bb1bb692$var$_getWindowSafe;
const $ca37ca24bb1bb692$var$_getDocumentSafe = ()=>{
    var _a;
    const win = (0, module.exports._getWindowSafe)();
    return (_a = win === null || win === void 0 ? void 0 : win.document) !== null && _a !== void 0 ? _a : null;
};
module.exports._getDocumentSafe = $ca37ca24bb1bb692$var$_getDocumentSafe;
const $ca37ca24bb1bb692$var$_isServerEnv = ()=>{
    if ((0, module.exports._getDocumentSafe)() !== null) return false;
    const isNode = typeof $3ZMUU !== 'undefined' && $3ZMUU.versions != null && $3ZMUU.versions.node != null;
    const isVercel = typeof EdgeRuntime === 'string';
    return isVercel || isNode;
};
module.exports._isServerEnv = $ca37ca24bb1bb692$var$_isServerEnv;
const $ca37ca24bb1bb692$var$_addWindowEventListenerSafe = (key, listener)=>{
    const win = (0, module.exports._getWindowSafe)();
    if (typeof (win === null || win === void 0 ? void 0 : win.addEventListener) === 'function') win.addEventListener(key, listener);
};
module.exports._addWindowEventListenerSafe = $ca37ca24bb1bb692$var$_addWindowEventListenerSafe;
const $ca37ca24bb1bb692$var$_addDocumentEventListenerSafe = (key, listener)=>{
    const doc = (0, module.exports._getDocumentSafe)();
    if (typeof (doc === null || doc === void 0 ? void 0 : doc.addEventListener) === 'function') doc.addEventListener(key, listener);
};
module.exports._addDocumentEventListenerSafe = $ca37ca24bb1bb692$var$_addDocumentEventListenerSafe;
const $ca37ca24bb1bb692$var$_getCurrentPageUrlSafe = ()=>{
    var _a;
    try {
        return (_a = (0, module.exports._getWindowSafe)()) === null || _a === void 0 ? void 0 : _a.location.href.split(/[?#]/)[0];
    } catch (_b) {
        return;
    }
};
module.exports._getCurrentPageUrlSafe = $ca37ca24bb1bb692$var$_getCurrentPageUrlSafe;
const $ca37ca24bb1bb692$var$_getUnloadEvent = ()=>{
    const win = (0, module.exports._getWindowSafe)();
    if (!win) return 'beforeunload';
    const eventType = 'onpagehide' in win ? 'pagehide' : 'beforeunload';
    return eventType;
};
module.exports._getUnloadEvent = $ca37ca24bb1bb692$var$_getUnloadEvent;
const $ca37ca24bb1bb692$var$_cloneObject = (tag, obj)=>{
    try {
        return JSON.parse(JSON.stringify(obj));
    } catch (error) {
        $9Qn0V.Log.error(`Failed to clone object ${tag}`);
        return null;
    }
};
module.exports._cloneObject = $ca37ca24bb1bb692$var$_cloneObject;

});



parcelRegister("4Pl5d", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.FlushInterval = void 0;
const $383c47899c0e101b$var$MIN_FLUSH_INTERVAL_MS = 1000;
const $383c47899c0e101b$var$MAX_FLUSH_INTERVAL_MS = 60000;
class $383c47899c0e101b$var$FlushInterval {
    constructor(){
        this._currentIntervalMs = $383c47899c0e101b$var$MIN_FLUSH_INTERVAL_MS;
        this._lastFlushAttemptTime = Date.now();
    }
    getCurrentIntervalMs() {
        return this._currentIntervalMs;
    }
    markFlushAttempt() {
        this._lastFlushAttemptTime = Date.now();
    }
    getTimeSinceLastAttempt() {
        return Date.now() - this._lastFlushAttemptTime;
    }
    hasReachedMaxInterval() {
        return this.getTimeSinceLastAttempt() >= $383c47899c0e101b$var$MAX_FLUSH_INTERVAL_MS;
    }
    getTimeTillMaxInterval() {
        return $383c47899c0e101b$var$MAX_FLUSH_INTERVAL_MS - this.getTimeSinceLastAttempt();
    }
    hasCompletelyRecoveredFromBackoff() {
        return this._currentIntervalMs <= $383c47899c0e101b$var$MIN_FLUSH_INTERVAL_MS;
    }
    adjustForSuccess() {
        const current = this._currentIntervalMs;
        if (current === $383c47899c0e101b$var$MIN_FLUSH_INTERVAL_MS) return;
        this._currentIntervalMs = Math.max($383c47899c0e101b$var$MIN_FLUSH_INTERVAL_MS, Math.floor(current / 2));
    }
    adjustForFailure() {
        const current = this._currentIntervalMs;
        this._currentIntervalMs = Math.min($383c47899c0e101b$var$MAX_FLUSH_INTERVAL_MS, current * 2);
    }
    getTimeUntilNextFlush() {
        return this.getCurrentIntervalMs() - this.getTimeSinceLastAttempt();
    }
}
module.exports.FlushInterval = $383c47899c0e101b$var$FlushInterval;

});

parcelRegister("h8kEr", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.FlushTypeValues = void 0;
module.exports.FlushTypeValues = {
    ScheduledMaxTime: 'scheduled:max_time',
    ScheduledFullBatch: 'scheduled:full_batch',
    Limit: 'limit',
    Manual: 'manual',
    Shutdown: 'shutdown'
};

});

parcelRegister("jCkUF", function(module, exports) {
"use strict";
var $e481c9d6519761a4$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.NetworkCore = module.exports.RETRYABLE_CODES = void 0;

var $8ZzeR = parcelRequire("8ZzeR");

var $8ZzeR = parcelRequire("8ZzeR");

var $4EJwp = parcelRequire("4EJwp");

var $9Qn0V = parcelRequire("9Qn0V");

var $3wynb = parcelRequire("3wynb");

var $a10qE = parcelRequire("a10qE");

var $8Glek = parcelRequire("8Glek");

var $9JrW9 = parcelRequire("9JrW9");

var $hmoSx = parcelRequire("hmoSx");

var $ldhqF = parcelRequire("ldhqF");

var $177Kh = parcelRequire("177Kh");

var $83Y6N = parcelRequire("83Y6N");

var $kVJXW = parcelRequire("kVJXW");

var $baWwc = parcelRequire("baWwc");

var $gmCzl = parcelRequire("gmCzl");
const $e481c9d6519761a4$var$DEFAULT_TIMEOUT_MS = 10000;
const $e481c9d6519761a4$var$BACKOFF_BASE_MS = 500;
const $e481c9d6519761a4$var$BACKOFF_MAX_MS = 30000;
const $e481c9d6519761a4$var$RATE_LIMIT_WINDOW_MS = 1000;
const $e481c9d6519761a4$var$RATE_LIMIT_MAX_REQ_COUNT = 50;
const $e481c9d6519761a4$var$LEAK_RATE = $e481c9d6519761a4$var$RATE_LIMIT_MAX_REQ_COUNT / $e481c9d6519761a4$var$RATE_LIMIT_WINDOW_MS;
module.exports.RETRYABLE_CODES = new Set([
    408,
    500,
    502,
    503,
    504,
    522,
    524,
    599
]);
class $e481c9d6519761a4$var$NetworkCore {
    constructor(options, _emitter){
        this._emitter = _emitter;
        this._errorBoundary = null;
        this._timeout = $e481c9d6519761a4$var$DEFAULT_TIMEOUT_MS;
        this._netConfig = {};
        this._options = {};
        this._leakyBucket = {};
        this._lastUsedInitUrl = null;
        if (options) this._options = options;
        if (this._options.networkConfig) this._netConfig = this._options.networkConfig;
        if (this._netConfig.networkTimeoutMs) this._timeout = this._netConfig.networkTimeoutMs;
        this._fallbackResolver = new $a10qE.NetworkFallbackResolver(this._options);
        this.setLogEventCompressionMode(this._getLogEventCompressionMode(options));
    }
    setLogEventCompressionMode(mode) {
        this._options.logEventCompressionMode = mode;
    }
    setErrorBoundary(errorBoundary) {
        this._errorBoundary = errorBoundary;
        this._errorBoundary.wrap(this);
        this._errorBoundary.wrap(this._fallbackResolver);
        this._fallbackResolver.setErrorBoundary(errorBoundary);
    }
    isBeaconSupported() {
        return typeof navigator !== 'undefined' && typeof navigator.sendBeacon === 'function';
    }
    getLastUsedInitUrlAndReset() {
        const tempUrl = this._lastUsedInitUrl;
        this._lastUsedInitUrl = null;
        return tempUrl;
    }
    beacon(args, failureInfo) {
        if (!$e481c9d6519761a4$var$_ensureValidSdkKey(args)) {
            if (failureInfo) failureInfo.path = 'beacon_invalid_sdk_key';
            return false;
        }
        const argsInternal = this._getInternalRequestArgs('POST', args);
        const url = this._getPopulatedURL(argsInternal);
        const nav = navigator;
        try {
            const success = nav.sendBeacon.bind(nav)(url, argsInternal.body);
            if (!success) {
                if (failureInfo) failureInfo.path = 'beacon_send_false';
            }
            return success;
        } catch (error) {
            if (failureInfo) failureInfo.path = 'beacon_send_exception';
            throw error;
        }
    }
    post(args, failureInfo) {
        return $e481c9d6519761a4$var$__awaiter(this, void 0, void 0, function*() {
            const argsInternal = this._getInternalRequestArgs('POST', args);
            this._tryEncodeBody(argsInternal);
            yield this._tryToCompressBody(argsInternal);
            return this._sendRequest(argsInternal, failureInfo);
        });
    }
    get(args) {
        const argsInternal = this._getInternalRequestArgs('GET', args);
        return this._sendRequest(argsInternal);
    }
    _sendRequest(args, failureInfo) {
        return $e481c9d6519761a4$var$__awaiter(this, void 0, void 0, function*() {
            var _a, _b, _c, _d;
            if (!$e481c9d6519761a4$var$_ensureValidSdkKey(args)) {
                if (failureInfo) failureInfo.path = 'network_invalid_sdk_key';
                return null;
            }
            if (this._netConfig.preventAllNetworkTraffic) {
                if (failureInfo) failureInfo.path = 'network_prevent_all_network_traffic';
                return null;
            }
            const { method: method, body: body, retries: retries, attempt: attempt } = args;
            const endpoint = args.urlConfig.endpoint;
            if (this._isRateLimited(endpoint)) {
                $9Qn0V.Log.warn(`Request to ${endpoint} was blocked because you are making requests too frequently.`);
                if (failureInfo) failureInfo.path = 'network_rate_limited';
                return null;
            }
            const currentAttempt = attempt !== null && attempt !== void 0 ? attempt : 1;
            let reqTimedOut = false;
            const populatedUrl = this._getPopulatedURL(args);
            const startTime = Date.now();
            let response = null;
            const keepalive = (0, $gmCzl._isUnloading)();
            try {
                const config = {
                    method: method,
                    body: body,
                    headers: Object.assign({}, args.headers),
                    priority: args.priority,
                    keepalive: keepalive
                };
                $e481c9d6519761a4$var$_tryMarkInitStart(args, currentAttempt);
                const bucket = this._leakyBucket[endpoint];
                if (bucket) {
                    bucket.lastRequestTime = Date.now();
                    this._leakyBucket[endpoint] = bucket;
                }
                const func = (_a = this._netConfig.networkOverrideFunc) !== null && _a !== void 0 ? _a : fetch;
                let timeoutId;
                response = yield Promise.race([
                    func(populatedUrl, config).finally(()=>clearTimeout(timeoutId)),
                    new Promise((_, reject)=>{
                        timeoutId = setTimeout(()=>{
                            reqTimedOut = true;
                            reject(new Error(`Timeout of ${this._timeout}ms expired.`));
                        }, this._timeout);
                    })
                ]);
                if (!response.ok) {
                    const text = yield response.text().catch(()=>'No Text');
                    const err = new Error(`NetworkError: ${populatedUrl} ${text}`);
                    err.name = 'NetworkError';
                    throw err;
                }
                const text = yield response.text();
                $e481c9d6519761a4$var$_tryMarkInitEnd(args, response, currentAttempt, text);
                this._fallbackResolver.tryBumpExpiryTime(args.sdkKey, args.urlConfig);
                return {
                    body: text,
                    code: response.status
                };
            } catch (error) {
                const errorMessage = $e481c9d6519761a4$var$_getErrorMessage(error);
                const timedOut = $e481c9d6519761a4$var$_didTimeout(errorMessage !== null && errorMessage !== void 0 ? errorMessage : '', reqTimedOut);
                $e481c9d6519761a4$var$_tryMarkInitEnd(args, response, currentAttempt, '', error);
                const fallbackUpdated = yield this._fallbackResolver.tryFetchUpdatedFallbackInfo(args.sdkKey, args.urlConfig, errorMessage, timedOut);
                if (fallbackUpdated) args.fallbackUrl = this._fallbackResolver.getActiveFallbackUrl(args.sdkKey, args.urlConfig);
                if (!retries || currentAttempt > retries || !module.exports.RETRYABLE_CODES.has((_b = response === null || response === void 0 ? void 0 : response.status) !== null && _b !== void 0 ? _b : 500)) {
                    (_c = this._emitter) === null || _c === void 0 || _c.call(this, {
                        name: 'error',
                        error: error,
                        tag: $83Y6N.ErrorTag.NetworkError,
                        requestArgs: args
                    });
                    const formattedErrorMsg = `A networking error occurred during ${method} request to ${populatedUrl}.`;
                    $9Qn0V.Log.error(formattedErrorMsg, errorMessage, error);
                    (_d = this._errorBoundary) === null || _d === void 0 || _d.attachErrorIfNoneExists(formattedErrorMsg);
                    if (args.preserveFailedStatusCode && response != null) return {
                        body: null,
                        code: response.status
                    };
                    if (response == null) {
                        if (failureInfo) {
                            failureInfo.path = timedOut ? 'network_request_timed_out_no_response' : 'network_request_exception_no_response';
                            if (errorMessage) failureInfo.errorMessage = errorMessage;
                            try {
                                const diagnostics = $e481c9d6519761a4$var$_getNoResponseDiagnostics(args, populatedUrl, timedOut, Date.now() - startTime);
                                failureInfo.diagnosticBucket = diagnostics.bucket;
                                failureInfo.diagnosticMetadata = diagnostics.metadata;
                            } catch (_e) {
                            // Diagnostics should not affect request failure handling.
                            }
                        }
                    }
                    return null;
                }
                yield $e481c9d6519761a4$var$_exponentialBackoff(currentAttempt);
                return this._sendRequest(Object.assign(Object.assign({}, args), {
                    retries: retries,
                    attempt: currentAttempt + 1
                }), failureInfo);
            }
        });
    }
    _getLogEventCompressionMode(options) {
        // Handle backward compatibility for deprecated disableCompression flag
        let compressionMode = options === null || options === void 0 ? void 0 : options.logEventCompressionMode;
        if (!compressionMode && (options === null || options === void 0 ? void 0 : options.disableCompression) === true) compressionMode = $baWwc.LogEventCompressionMode.Disabled;
        // Default to enabled if unset
        if (!compressionMode) compressionMode = $baWwc.LogEventCompressionMode.Enabled;
        return compressionMode;
    }
    _isRateLimited(endpoint) {
        var _a;
        const now = Date.now();
        const bucket = (_a = this._leakyBucket[endpoint]) !== null && _a !== void 0 ? _a : {
            count: 0,
            lastRequestTime: now
        };
        const elapsed = now - bucket.lastRequestTime;
        const leakedRequests = Math.floor(elapsed * $e481c9d6519761a4$var$LEAK_RATE);
        bucket.count = Math.max(0, bucket.count - leakedRequests);
        if (bucket.count >= $e481c9d6519761a4$var$RATE_LIMIT_MAX_REQ_COUNT) return true;
        bucket.count += 1;
        bucket.lastRequestTime = now;
        this._leakyBucket[endpoint] = bucket;
        return false;
    }
    _getPopulatedURL(args) {
        var _a;
        const url = (_a = args.fallbackUrl) !== null && _a !== void 0 ? _a : args.urlConfig.getUrl();
        if (args.urlConfig.endpoint === $3wynb.Endpoint._initialize || args.urlConfig.endpoint === $3wynb.Endpoint._download_config_specs) this._lastUsedInitUrl = url;
        const params = Object.assign({
            [$3wynb.NetworkParam.SdkKey]: args.sdkKey,
            [$3wynb.NetworkParam.SdkType]: $9JrW9.SDKType._get(args.sdkKey),
            [$3wynb.NetworkParam.SdkVersion]: $kVJXW.SDK_VERSION,
            [$3wynb.NetworkParam.Time]: String(Date.now()),
            [$3wynb.NetworkParam.SessionID]: $ldhqF.SessionID.get(args.sdkKey)
        }, args.params);
        const query = Object.keys(params).map((key)=>{
            return `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`;
        }).join('&');
        return `${url}${query ? `?${query}` : ''}`;
    }
    _tryEncodeBody(args) {
        var _a;
        const win = (0, $hmoSx._getWindowSafe)();
        const body = args.body;
        if (!args.isStatsigEncodable || this._options.disableStatsigEncoding || typeof body !== 'string' || (0, $8ZzeR._getStatsigGlobalFlag)('no-encode') != null || !(win === null || win === void 0 ? void 0 : win.btoa)) return;
        try {
            args.body = win.btoa(body).split('').reverse().join('');
            args.params = Object.assign(Object.assign({}, (_a = args.params) !== null && _a !== void 0 ? _a : {}), {
                [$3wynb.NetworkParam.StatsigEncoded]: '1'
            });
        } catch (e) {
            $9Qn0V.Log.warn(`Request encoding failed for ${args.urlConfig.getUrl()}`, e);
        }
    }
    _tryToCompressBody(args) {
        return $e481c9d6519761a4$var$__awaiter(this, void 0, void 0, function*() {
            var _a;
            const body = args.body;
            if (typeof body !== 'string' || !$e481c9d6519761a4$var$_allowCompression(args, this._options)) return;
            try {
                const bytes = new TextEncoder().encode(body);
                const stream = new CompressionStream('gzip');
                const writer = stream.writable.getWriter();
                writer.write(bytes).catch($9Qn0V.Log.error);
                writer.close().catch($9Qn0V.Log.error);
                const reader = stream.readable.getReader();
                const chunks = [];
                let result;
                // eslint-disable-next-line no-await-in-loop
                while(!(result = yield reader.read()).done)chunks.push(result.value);
                const totalLength = chunks.reduce((acc, chunk)=>acc + chunk.length, 0);
                const combined = new Uint8Array(totalLength);
                let offset = 0;
                for (const chunk of chunks){
                    combined.set(chunk, offset);
                    offset += chunk.length;
                }
                args.body = combined;
                args.params = Object.assign(Object.assign({}, (_a = args.params) !== null && _a !== void 0 ? _a : {}), {
                    [$3wynb.NetworkParam.IsGzipped]: '1'
                });
            } catch (e) {
                $9Qn0V.Log.warn(`Request compression failed for ${args.urlConfig.getUrl()}`, e);
            }
        });
    }
    _getInternalRequestArgs(method, args) {
        const fallbackUrl = this._fallbackResolver.getActiveFallbackUrl(args.sdkKey, args.urlConfig);
        const result = Object.assign(Object.assign({}, args), {
            method: method,
            fallbackUrl: fallbackUrl
        });
        if ('data' in args) $e481c9d6519761a4$var$_populateRequestBody(result, args.data);
        return result;
    }
}
module.exports.NetworkCore = $e481c9d6519761a4$var$NetworkCore;
const $e481c9d6519761a4$var$_ensureValidSdkKey = (args)=>{
    if (!args.sdkKey) {
        $9Qn0V.Log.warn('Unable to make request without an SDK key');
        return false;
    }
    return true;
};
const $e481c9d6519761a4$var$_populateRequestBody = (args, data)=>{
    const { sdkKey: sdkKey, fallbackUrl: fallbackUrl } = args;
    const stableID = $177Kh.StableID.get(sdkKey);
    const sessionID = $ldhqF.SessionID.get(sdkKey);
    const sdkType = $9JrW9.SDKType._get(sdkKey);
    args.body = JSON.stringify(Object.assign(Object.assign({}, data), {
        statsigMetadata: Object.assign(Object.assign({}, $kVJXW.StatsigMetadataProvider.get()), {
            stableID: stableID,
            sessionID: sessionID,
            sdkType: sdkType,
            fallbackUrl: fallbackUrl
        })
    }));
};
function $e481c9d6519761a4$var$_allowCompression(args, options) {
    if (!args.isCompressable) return false;
    // Never compress if 'no-compress' is set globally or required APIs are unavailable
    if ((0, $8ZzeR._getStatsigGlobalFlag)('no-compress') != null || typeof CompressionStream === 'undefined' || typeof TextEncoder === 'undefined') return false;
    const isProxy = args.urlConfig.customUrl != null || args.urlConfig.fallbackUrls != null;
    const flagEnabled = $8Glek.SDKFlags.get(args.sdkKey, 'enable_log_event_compression') === true;
    switch(options.logEventCompressionMode){
        case $baWwc.LogEventCompressionMode.Disabled:
            return false;
        case $baWwc.LogEventCompressionMode.Enabled:
            // Only compress through proxy if flag is explicitly on
            if (isProxy && !flagEnabled) return false;
            return true;
        case $baWwc.LogEventCompressionMode.Forced:
            return true;
        default:
            return false;
    }
}
function $e481c9d6519761a4$var$_getErrorMessage(error) {
    if (typeof error === 'string') return error;
    if (error instanceof Error) return `${error.name}: ${error.message}`;
    return 'Unknown Error';
}
function $e481c9d6519761a4$var$_didTimeout(errorMsg, abortedByTimeout) {
    const timeout = errorMsg.includes('Timeout'); // probably not needed but just in case
    return timeout || abortedByTimeout;
}
function $e481c9d6519761a4$var$_getNoResponseDiagnostics(args, populatedUrl, timedOut, elapsedMs) {
    var _a, _b, _c;
    const win = (0, $hmoSx._getWindowSafe)();
    const doc = win === null || win === void 0 ? void 0 : win.document;
    const nav = typeof navigator !== 'undefined' ? navigator : null;
    const isUnloading = (0, $gmCzl._isUnloading)();
    const online = nav && typeof nav.onLine === 'boolean' ? String(nav.onLine) : 'unknown';
    const visibilityState = (_a = doc === null || doc === void 0 ? void 0 : doc.visibilityState) !== null && _a !== void 0 ? _a : 'unknown';
    const hasCustomHeaders = Object.keys((_b = args.headers) !== null && _b !== void 0 ? _b : {}).length > 0;
    const crossOrigin = $e481c9d6519761a4$var$_isCrossOrigin(populatedUrl, (_c = win === null || win === void 0 ? void 0 : win.location) === null || _c === void 0 ? void 0 : _c.origin);
    const hasCustomUrl = args.urlConfig.customUrl != null;
    const hasFallbackUrl = args.fallbackUrl != null;
    const elapsedMsBucket = $e481c9d6519761a4$var$_bucketNumber(elapsedMs, [
        250,
        1000,
        5000,
        10000
    ]);
    const bodySizeBucket = $e481c9d6519761a4$var$_bucketNumber($e481c9d6519761a4$var$_getBodySize(args.body), [
        16384,
        65536,
        262144,
        1048576
    ]);
    let bucket = 'unknown_no_response';
    if (timedOut) bucket = 'timeout';
    else if (online === 'false') bucket = 'browser_offline';
    else if (isUnloading) bucket = 'page_unloading';
    else if (visibilityState === 'hidden') bucket = 'page_hidden';
    else if (crossOrigin && hasCustomHeaders) bucket = 'cross_origin_custom_headers_preflight_risk';
    else if (hasCustomUrl || hasFallbackUrl) bucket = 'custom_url_no_response';
    else if (elapsedMs < 250) bucket = 'immediate_network_rejection';
    return {
        bucket: bucket,
        metadata: {
            elapsedMsBucket: elapsedMsBucket,
            bodySizeBucket: bodySizeBucket,
            online: online,
            visibilityState: visibilityState,
            isUnloading: String(isUnloading),
            crossOrigin: String(crossOrigin),
            hasCustomUrl: String(hasCustomUrl)
        }
    };
}
function $e481c9d6519761a4$var$_isCrossOrigin(url, currentOrigin) {
    if (!currentOrigin) return true;
    return !url.startsWith(`${currentOrigin}/`) && !url.startsWith(`${currentOrigin}?`) && url !== currentOrigin;
}
function $e481c9d6519761a4$var$_getBodySize(body) {
    if (body == null) return 0;
    if (typeof body === 'string') return body.length;
    if (body instanceof Uint8Array) return body.byteLength;
    if (typeof Blob !== 'undefined' && body instanceof Blob) return body.size;
    return -1;
}
function $e481c9d6519761a4$var$_bucketNumber(value, thresholds) {
    if (value < 0) return 'unknown';
    for (const threshold of thresholds){
        if (value < threshold) return `<${threshold}`;
    }
    return `>=${thresholds[thresholds.length - 1]}`;
}
function $e481c9d6519761a4$var$_tryMarkInitStart(args, attempt) {
    if (args.urlConfig.endpoint !== $3wynb.Endpoint._initialize) return;
    $4EJwp.Diagnostics._markInitNetworkReqStart(args.sdkKey, {
        attempt: attempt
    });
}
function $e481c9d6519761a4$var$_tryMarkInitEnd(args, response, attempt, body, err) {
    if (args.urlConfig.endpoint !== $3wynb.Endpoint._initialize) return;
    $4EJwp.Diagnostics._markInitNetworkReqEnd(args.sdkKey, $4EJwp.Diagnostics._getDiagnosticsData(response, attempt, body, err));
}
function $e481c9d6519761a4$var$_exponentialBackoff(attempt) {
    return $e481c9d6519761a4$var$__awaiter(this, void 0, void 0, function*() {
        // 1*1*1000 1s
        // 2*2*1000 4s
        // 3*3*1000 9s
        // 4*4*1000 16s
        // 5*5*1000 25s
        yield new Promise((r)=>setTimeout(r, Math.min($e481c9d6519761a4$var$BACKOFF_BASE_MS * (attempt * attempt), $e481c9d6519761a4$var$BACKOFF_MAX_MS)));
    });
}

});
parcelRegister("a10qE", function(module, exports) {
"use strict";
var $74aa5485be603eda$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._isDomainFailure = module.exports.NetworkFallbackResolver = void 0;

var $bSP3T = parcelRequire("bSP3T");

var $doPF1 = parcelRequire("doPF1");

var $9Qn0V = parcelRequire("9Qn0V");

var $jKkqw = parcelRequire("jKkqw");
const $74aa5485be603eda$var$DEFAULT_TTL_MS = 604800000; // 7 days
const $74aa5485be603eda$var$COOLDOWN_TIME_MS = 14400000; // 4 hours
class $74aa5485be603eda$var$NetworkFallbackResolver {
    constructor(options){
        var _a;
        this._fallbackInfo = null;
        this._errorBoundary = null;
        this._dnsQueryCooldowns = {};
        this._networkOverrideFunc = (_a = options.networkConfig) === null || _a === void 0 ? void 0 : _a.networkOverrideFunc;
    }
    setErrorBoundary(errorBoundary) {
        this._errorBoundary = errorBoundary;
    }
    tryBumpExpiryTime(sdkKey, urlConfig) {
        var _a;
        const info = (_a = this._fallbackInfo) === null || _a === void 0 ? void 0 : _a[urlConfig.endpoint];
        if (!info) return;
        info.expiryTime = Date.now() + $74aa5485be603eda$var$DEFAULT_TTL_MS;
        $74aa5485be603eda$var$_tryWriteFallbackInfoToCache(sdkKey, Object.assign(Object.assign({}, this._fallbackInfo), {
            [urlConfig.endpoint]: info
        }));
    }
    getActiveFallbackUrl(sdkKey, urlConfig) {
        var _a, _b;
        if (urlConfig.customUrl != null && urlConfig.fallbackUrls != null) return null;
        let info = this._fallbackInfo;
        if (info == null) {
            info = (_a = $74aa5485be603eda$var$_readFallbackInfoFromCache(sdkKey)) !== null && _a !== void 0 ? _a : {};
            this._fallbackInfo = info;
        }
        const entry = info[urlConfig.endpoint];
        if (!entry || Date.now() > ((_b = entry.expiryTime) !== null && _b !== void 0 ? _b : 0) || urlConfig.getChecksum() !== entry.urlConfigChecksum) {
            delete info[urlConfig.endpoint];
            this._fallbackInfo = info;
            $74aa5485be603eda$var$_tryWriteFallbackInfoToCache(sdkKey, this._fallbackInfo);
            return null;
        }
        if (entry.url) return entry.url;
        return null;
    }
    tryFetchUpdatedFallbackInfo(sdkKey, urlConfig, errorMessage, timedOut) {
        return $74aa5485be603eda$var$__awaiter(this, void 0, void 0, function*() {
            var _a, _b;
            try {
                if (!$74aa5485be603eda$var$_isDomainFailure(errorMessage, timedOut)) return false;
                const canUseNetworkFallbacks = urlConfig.customUrl == null && urlConfig.fallbackUrls == null;
                const urls = canUseNetworkFallbacks ? yield this._tryFetchFallbackUrlsFromNetwork(urlConfig) : urlConfig.fallbackUrls;
                const newUrl = this._pickNewFallbackUrl((_a = this._fallbackInfo) === null || _a === void 0 ? void 0 : _a[urlConfig.endpoint], urls);
                if (!newUrl) return false;
                this._updateFallbackInfoWithNewUrl(sdkKey, urlConfig, newUrl);
                return true;
            } catch (error) {
                (_b = this._errorBoundary) === null || _b === void 0 || _b.logError('tryFetchUpdatedFallbackInfo', error);
                return false;
            }
        });
    }
    _updateFallbackInfoWithNewUrl(sdkKey, urlConfig, newUrl) {
        var _a, _b, _c;
        const newFallbackInfo = {
            urlConfigChecksum: urlConfig.getChecksum(),
            url: newUrl,
            expiryTime: Date.now() + $74aa5485be603eda$var$DEFAULT_TTL_MS,
            previous: []
        };
        const endpoint = urlConfig.endpoint;
        const previousInfo = (_a = this._fallbackInfo) === null || _a === void 0 ? void 0 : _a[endpoint];
        if (previousInfo) newFallbackInfo.previous.push(...previousInfo.previous);
        if (newFallbackInfo.previous.length > 10) newFallbackInfo.previous = [];
        const previousUrl = (_c = (_b = this._fallbackInfo) === null || _b === void 0 ? void 0 : _b[endpoint]) === null || _c === void 0 ? void 0 : _c.url;
        if (previousUrl != null) newFallbackInfo.previous.push(previousUrl);
        this._fallbackInfo = Object.assign(Object.assign({}, this._fallbackInfo), {
            [endpoint]: newFallbackInfo
        });
        $74aa5485be603eda$var$_tryWriteFallbackInfoToCache(sdkKey, this._fallbackInfo);
    }
    _tryFetchFallbackUrlsFromNetwork(urlConfig) {
        return $74aa5485be603eda$var$__awaiter(this, void 0, void 0, function*() {
            var _a;
            const cooldown = this._dnsQueryCooldowns[urlConfig.endpoint];
            if (cooldown && Date.now() < cooldown) return null;
            this._dnsQueryCooldowns[urlConfig.endpoint] = Date.now() + $74aa5485be603eda$var$COOLDOWN_TIME_MS;
            const result = [];
            const records = yield (0, $bSP3T._fetchTxtRecords)((_a = this._networkOverrideFunc) !== null && _a !== void 0 ? _a : fetch);
            const path = $74aa5485be603eda$var$_extractPathFromUrl(urlConfig.defaultUrl);
            for (const record of records){
                if (!record.startsWith(urlConfig.endpointDnsKey + '=')) continue;
                const parts = record.split('=');
                if (parts.length > 1) {
                    let baseUrl = parts[1];
                    if (baseUrl.endsWith('/')) baseUrl = baseUrl.slice(0, -1);
                    result.push(`https://${baseUrl}${path}`);
                }
            }
            return result;
        });
    }
    _pickNewFallbackUrl(currentFallbackInfo, urls) {
        var _a;
        if (urls == null) return null;
        const previouslyUsed = new Set((_a = currentFallbackInfo === null || currentFallbackInfo === void 0 ? void 0 : currentFallbackInfo.previous) !== null && _a !== void 0 ? _a : []);
        const currentFallbackUrl = currentFallbackInfo === null || currentFallbackInfo === void 0 ? void 0 : currentFallbackInfo.url;
        let found = null;
        for (const loopUrl of urls){
            const url = loopUrl.endsWith('/') ? loopUrl.slice(0, -1) : loopUrl;
            if (!previouslyUsed.has(loopUrl) && url !== currentFallbackUrl) {
                found = url;
                break;
            }
        }
        return found;
    }
}
module.exports.NetworkFallbackResolver = $74aa5485be603eda$var$NetworkFallbackResolver;
function $74aa5485be603eda$var$_isDomainFailure(errorMsg, timedOut) {
    var _a;
    const lowerErrorMsg = (_a = errorMsg === null || errorMsg === void 0 ? void 0 : errorMsg.toLowerCase()) !== null && _a !== void 0 ? _a : '';
    return timedOut || lowerErrorMsg.includes('uncaught exception') || lowerErrorMsg.includes('failed to fetch') || lowerErrorMsg.includes('networkerror when attempting to fetch resource');
}
module.exports._isDomainFailure = $74aa5485be603eda$var$_isDomainFailure;
function $74aa5485be603eda$var$_getFallbackInfoStorageKey(sdkKey) {
    return `statsig.network_fallback.${(0, $doPF1._DJB2)(sdkKey)}`;
}
function $74aa5485be603eda$var$_tryWriteFallbackInfoToCache(sdkKey, info) {
    const hashKey = $74aa5485be603eda$var$_getFallbackInfoStorageKey(sdkKey);
    if (!info || Object.keys(info).length === 0) {
        $jKkqw.Storage.removeItem(hashKey);
        return;
    }
    $jKkqw.Storage.setItem(hashKey, JSON.stringify(info));
}
function $74aa5485be603eda$var$_readFallbackInfoFromCache(sdkKey) {
    const hashKey = $74aa5485be603eda$var$_getFallbackInfoStorageKey(sdkKey);
    const data = $jKkqw.Storage.getItem(hashKey);
    if (!data) return null;
    try {
        return JSON.parse(data);
    } catch (_a) {
        $9Qn0V.Log.error('Failed to parse FallbackInfo');
        return null;
    }
}
function $74aa5485be603eda$var$_extractPathFromUrl(urlString) {
    try {
        const url = new URL(urlString);
        return url.pathname;
    } catch (error) {
        return null;
    }
}

});
parcelRegister("bSP3T", function(module, exports) {
"use strict";
var $8a6c58a7750079be$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._fetchTxtRecords = void 0;
// See example: https://github.com/statsig-io/private-js-client-monorepo/pull/340
const $8a6c58a7750079be$var$FEATURE_ASSETS_DNS_QUERY = new Uint8Array([
    0x00,
    0x00,
    0x01,
    0x00,
    0x00,
    0x01,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x0d,
    0x66,
    0x65,
    0x61,
    0x74,
    0x75,
    0x72,
    0x65,
    0x61,
    0x73,
    0x73,
    0x65,
    0x74,
    0x73,
    0x03,
    0x6f,
    0x72,
    0x67,
    0x00,
    0x00,
    0x10,
    0x00,
    0x01
]);
const $8a6c58a7750079be$var$DNS_QUERY_ENDPOINT = 'https://cloudflare-dns.com/dns-query';
const $8a6c58a7750079be$var$DOMAIN_CHARS = [
    'i',
    'e',
    'd'
];
const $8a6c58a7750079be$var$MAX_START_LOOKUP = 200;
function $8a6c58a7750079be$var$_fetchTxtRecords(networkFunc) {
    return $8a6c58a7750079be$var$__awaiter(this, void 0, void 0, function*() {
        const response = yield networkFunc($8a6c58a7750079be$var$DNS_QUERY_ENDPOINT, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/dns-message',
                Accept: 'application/dns-message'
            },
            body: $8a6c58a7750079be$var$FEATURE_ASSETS_DNS_QUERY
        });
        if (!response.ok) {
            const err = new Error('Failed to fetch TXT records from DNS');
            err.name = 'DnsTxtFetchError';
            throw err;
        }
        const data = yield response.arrayBuffer();
        const bytes = new Uint8Array(data);
        return $8a6c58a7750079be$var$_parseDnsResponse(bytes);
    });
}
module.exports._fetchTxtRecords = $8a6c58a7750079be$var$_fetchTxtRecords;
function $8a6c58a7750079be$var$_parseDnsResponse(input) {
    // loop until we find the first valid domain char. One of [i=, e=, d=]
    const start = input.findIndex((byte, index)=>index < $8a6c58a7750079be$var$MAX_START_LOOKUP && String.fromCharCode(byte) === '=' && $8a6c58a7750079be$var$DOMAIN_CHARS.includes(String.fromCharCode(input[index - 1])));
    if (start === -1) {
        const err = new Error('Failed to parse TXT records from DNS');
        err.name = 'DnsTxtParseError';
        throw err;
    }
    // decode the remaining bytes as a string
    let result = '';
    for(let i = start - 1; i < input.length; i++)result += String.fromCharCode(input[i]);
    return result.split(',');
}

});

parcelRegister("jKkqw", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._setObjectInStorage = module.exports._getObjectFromStorage = module.exports.Storage = void 0;

var $9Qn0V = parcelRequire("9Qn0V");

var $hmoSx = parcelRequire("hmoSx");
const $e602288a720ce5c1$var$inMemoryStore = {};
const $e602288a720ce5c1$var$_inMemoryProvider = {
    isReady: ()=>true,
    isReadyResolver: ()=>null,
    getProviderName: ()=>'InMemory',
    getItem: (key)=>$e602288a720ce5c1$var$inMemoryStore[key] ? $e602288a720ce5c1$var$inMemoryStore[key] : null,
    setItem: (key, value)=>{
        $e602288a720ce5c1$var$inMemoryStore[key] = value;
    },
    removeItem: (key)=>{
        delete $e602288a720ce5c1$var$inMemoryStore[key];
    },
    getAllKeys: ()=>Object.keys($e602288a720ce5c1$var$inMemoryStore)
};
let $e602288a720ce5c1$var$_localStorageProvider = null;
try {
    const win = (0, $hmoSx._getWindowSafe)();
    if (win && win.localStorage && typeof win.localStorage.getItem === 'function') $e602288a720ce5c1$var$_localStorageProvider = {
        isReady: ()=>true,
        isReadyResolver: ()=>null,
        getProviderName: ()=>'LocalStorage',
        getItem: (key)=>win.localStorage.getItem(key),
        setItem: (key, value)=>win.localStorage.setItem(key, value),
        removeItem: (key)=>win.localStorage.removeItem(key),
        getAllKeys: ()=>Object.keys(win.localStorage)
    };
} catch (error) {
    $9Qn0V.Log.warn('Failed to setup localStorageProvider.');
}
let $e602288a720ce5c1$var$_main = $e602288a720ce5c1$var$_localStorageProvider !== null && $e602288a720ce5c1$var$_localStorageProvider !== void 0 ? $e602288a720ce5c1$var$_localStorageProvider : $e602288a720ce5c1$var$_inMemoryProvider;
let $e602288a720ce5c1$var$_current = $e602288a720ce5c1$var$_main;
function $e602288a720ce5c1$var$_inMemoryBreaker(action) {
    try {
        return action();
    } catch (error) {
        if (error instanceof Error && error.name === 'SecurityError') {
            module.exports.Storage._setProvider($e602288a720ce5c1$var$_inMemoryProvider);
            return null;
        }
        throw error;
    }
}
module.exports.Storage = {
    isReady: ()=>$e602288a720ce5c1$var$_current.isReady(),
    isReadyResolver: ()=>$e602288a720ce5c1$var$_current.isReadyResolver(),
    getProviderName: ()=>$e602288a720ce5c1$var$_current.getProviderName(),
    getItem: (key)=>$e602288a720ce5c1$var$_inMemoryBreaker(()=>$e602288a720ce5c1$var$_current.getItem(key)),
    setItem: (key, value)=>$e602288a720ce5c1$var$_inMemoryBreaker(()=>$e602288a720ce5c1$var$_current.setItem(key, value)),
    removeItem: (key)=>$e602288a720ce5c1$var$_current.removeItem(key),
    getAllKeys: ()=>$e602288a720ce5c1$var$_current.getAllKeys(),
    // StorageProviderManagment
    _setProvider: (newProvider)=>{
        $e602288a720ce5c1$var$_main = newProvider;
        $e602288a720ce5c1$var$_current = newProvider;
    },
    _setDisabled: (isDisabled)=>{
        if (isDisabled) $e602288a720ce5c1$var$_current = $e602288a720ce5c1$var$_inMemoryProvider;
        else $e602288a720ce5c1$var$_current = $e602288a720ce5c1$var$_main;
    }
};
function $e602288a720ce5c1$var$_getObjectFromStorage(key) {
    const value = module.exports.Storage.getItem(key);
    try {
        return JSON.parse(value !== null && value !== void 0 ? value : 'null');
    } catch (e) {
        $9Qn0V.Log.error(`Failed to parse value for key "${key}"`);
        return null;
    }
}
module.exports._getObjectFromStorage = $e602288a720ce5c1$var$_getObjectFromStorage;
function $e602288a720ce5c1$var$_setObjectInStorage(key, obj) {
    module.exports.Storage.setItem(key, JSON.stringify(obj));
}
module.exports._setObjectInStorage = $e602288a720ce5c1$var$_setObjectInStorage;

});


parcelRegister("8Glek", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SDKFlags = void 0;
const $6522b6cedbd90136$var$FLAGMAP = {};
module.exports.SDKFlags = {
    setFlags: (sdkKey, flags)=>{
        $6522b6cedbd90136$var$FLAGMAP[sdkKey] = flags;
    },
    get: (sdkKey, flagKey)=>{
        var _a, _b;
        return (_b = (_a = $6522b6cedbd90136$var$FLAGMAP[sdkKey]) === null || _a === void 0 ? void 0 : _a[flagKey]) !== null && _b !== void 0 ? _b : false;
    }
};

});

parcelRegister("ldhqF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.StatsigSession = module.exports.SessionID = void 0;

var $4KuM7 = parcelRequire("4KuM7");

var $9Qn0V = parcelRequire("9Qn0V");

var $jKkqw = parcelRequire("jKkqw");

var $h59qk = parcelRequire("h59qk");

var $gmCzl = parcelRequire("gmCzl");
const $f71854f025bff3f7$var$MAX_SESSION_IDLE_TIME = 1800000; // 30 minutes
const $f71854f025bff3f7$var$MAX_SESSION_AGE = 14400000; // 4 hours
const $f71854f025bff3f7$var$PERSIST_THROTTLE_MS = 15000;
const $f71854f025bff3f7$var$SESSION_MAP = {};
(0, $gmCzl._subscribeToVisiblityChanged)((visibility)=>{
    if (visibility === 'background') Object.values($f71854f025bff3f7$var$SESSION_MAP).forEach((session)=>$f71854f025bff3f7$var$_persistNow(session));
});
module.exports.SessionID = {
    get: (sdkKey)=>{
        return module.exports.StatsigSession.get(sdkKey).data.sessionID;
    }
};
module.exports.StatsigSession = {
    get: (sdkKey, bumpSession = true)=>{
        if ($f71854f025bff3f7$var$SESSION_MAP[sdkKey] == null) $f71854f025bff3f7$var$SESSION_MAP[sdkKey] = $f71854f025bff3f7$var$_loadOrCreateSharedSession(sdkKey);
        const session = $f71854f025bff3f7$var$SESSION_MAP[sdkKey];
        return $f71854f025bff3f7$var$_maybeBumpSession(session, bumpSession);
    },
    overrideInitialSessionID: (override, sdkKey)=>{
        const now = Date.now();
        const session = {
            data: {
                sessionID: override,
                startTime: now,
                lastUpdate: now
            },
            sdkKey: sdkKey,
            lastPersistedAt: Date.now(),
            storageKey: $f71854f025bff3f7$var$_getSessionIDStorageKey(sdkKey)
        };
        $f71854f025bff3f7$var$_persistNow(session);
        $f71854f025bff3f7$var$SESSION_MAP[sdkKey] = session;
    },
    checkForIdleSession: (sdkKey)=>{
        const session = $f71854f025bff3f7$var$SESSION_MAP[sdkKey];
        if (!session) return;
        const sessionExpired = $f71854f025bff3f7$var$_checkForExpiredSession(session);
        if (sessionExpired) $f71854f025bff3f7$var$_persistNow(session);
    }
};
function $f71854f025bff3f7$var$_maybeBumpSession(session, allowSessionBump) {
    const now = Date.now();
    const sessionExpired = $f71854f025bff3f7$var$_checkForExpiredSession(session);
    if (sessionExpired) $f71854f025bff3f7$var$_persistNow(session);
    else if (allowSessionBump) {
        session.data.lastUpdate = now;
        $f71854f025bff3f7$var$_persistThrottled(session);
    }
    return session;
}
function $f71854f025bff3f7$var$_checkForExpiredSession(session) {
    var _a;
    const data = session.data;
    const sessionExpired = $f71854f025bff3f7$var$_isIdle(data) || $f71854f025bff3f7$var$_hasRunTooLong(data);
    if (sessionExpired) {
        session.data = $f71854f025bff3f7$var$_newSessionData();
        (_a = __STATSIG__ === null || __STATSIG__ === void 0 ? void 0 : __STATSIG__.instance(session.sdkKey)) === null || _a === void 0 || _a.$emt({
            name: 'session_expired'
        });
    }
    return sessionExpired;
}
function $f71854f025bff3f7$var$_isIdle({ lastUpdate: lastUpdate }) {
    return Date.now() - lastUpdate > $f71854f025bff3f7$var$MAX_SESSION_IDLE_TIME;
}
function $f71854f025bff3f7$var$_hasRunTooLong({ startTime: startTime }) {
    return Date.now() - startTime > $f71854f025bff3f7$var$MAX_SESSION_AGE;
}
function $f71854f025bff3f7$var$_getSessionIDStorageKey(sdkKey) {
    return `statsig.session_id.${(0, $4KuM7._getStorageKey)(sdkKey)}`;
}
function $f71854f025bff3f7$var$_persistNow(session) {
    try {
        (0, $jKkqw._setObjectInStorage)(session.storageKey, session.data);
        session.lastPersistedAt = Date.now();
    } catch (e) {
        $9Qn0V.Log.warn('Failed to save SessionID');
    }
}
function $f71854f025bff3f7$var$_persistThrottled(session) {
    const now = Date.now();
    if (now - session.lastPersistedAt > $f71854f025bff3f7$var$PERSIST_THROTTLE_MS) $f71854f025bff3f7$var$_persistNow(session);
}
function $f71854f025bff3f7$var$_loadSessionFromStorage(storageKey) {
    const data = (0, $jKkqw._getObjectFromStorage)(storageKey);
    return data;
}
function $f71854f025bff3f7$var$_loadOrCreateSharedSession(sdkKey) {
    const storageKey = $f71854f025bff3f7$var$_getSessionIDStorageKey(sdkKey);
    const existing = $f71854f025bff3f7$var$_loadSessionFromStorage(storageKey);
    if (existing && existing.sessionID && existing.startTime && existing.lastUpdate) return {
        data: existing,
        sdkKey: sdkKey,
        lastPersistedAt: 0,
        storageKey: storageKey
    };
    return {
        data: $f71854f025bff3f7$var$_newSessionData(),
        sdkKey: sdkKey,
        lastPersistedAt: 0,
        storageKey: storageKey
    };
}
function $f71854f025bff3f7$var$_newSessionData() {
    return {
        sessionID: (0, $h59qk.getUUID)(),
        startTime: Date.now(),
        lastUpdate: Date.now()
    };
}

});
parcelRegister("h59qk", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getUUID = void 0;
function $c6fa36a4b16a38ad$var$getUUID() {
    if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') return crypto.randomUUID();
    let d = new Date().getTime();
    let d2 = typeof performance !== 'undefined' && performance.now && performance.now() * 1000 || 0;
    const y = '89ab'[Math.floor(Math.random() * 4)];
    return `xxxxxxxx-xxxx-4xxx-${y}xxx-xxxxxxxxxxxx`.replace(/[xy]/g, (c)=>{
        let r = Math.random() * 16;
        if (d > 0) {
            r = (d + r) % 16 | 0;
            d = Math.floor(d / 16);
        } else {
            r = (d2 + r) % 16 | 0;
            d2 = Math.floor(d2 / 16);
        }
        return (c === 'x' ? r : r & 0x7 | 0x8).toString(16);
    });
}
module.exports.getUUID = $c6fa36a4b16a38ad$var$getUUID;

});


parcelRegister("177Kh", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getCookieName = module.exports.StableID = void 0;

var $4KuM7 = parcelRequire("4KuM7");

var $9Qn0V = parcelRequire("9Qn0V");

var $hmoSx = parcelRequire("hmoSx");

var $jKkqw = parcelRequire("jKkqw");

var $h59qk = parcelRequire("h59qk");
const $0cfc73fcc033286b$var$PROMISE_MAP = {};
const $0cfc73fcc033286b$var$COOKIE_ENABLED_MAP = {};
const $0cfc73fcc033286b$var$DISABLED_MAP = {};
module.exports.StableID = {
    cookiesEnabled: false,
    randomID: Math.random().toString(36),
    get: (sdkKey)=>{
        if ($0cfc73fcc033286b$var$DISABLED_MAP[sdkKey]) return null;
        if ($0cfc73fcc033286b$var$PROMISE_MAP[sdkKey] != null) return $0cfc73fcc033286b$var$PROMISE_MAP[sdkKey];
        let stableID = null;
        stableID = $0cfc73fcc033286b$var$_loadFromCookie(sdkKey);
        if (stableID != null) {
            $0cfc73fcc033286b$var$PROMISE_MAP[sdkKey] = stableID;
            $0cfc73fcc033286b$var$_persistToStorage(stableID, sdkKey);
            return stableID;
        }
        stableID = $0cfc73fcc033286b$var$_loadFromStorage(sdkKey);
        if (stableID == null) stableID = (0, $h59qk.getUUID)();
        $0cfc73fcc033286b$var$_persistToStorage(stableID, sdkKey);
        $0cfc73fcc033286b$var$_persistToCookie(stableID, sdkKey);
        $0cfc73fcc033286b$var$PROMISE_MAP[sdkKey] = stableID;
        return stableID;
    },
    setOverride: (override, sdkKey)=>{
        $0cfc73fcc033286b$var$PROMISE_MAP[sdkKey] = override;
        $0cfc73fcc033286b$var$_persistToStorage(override, sdkKey);
        $0cfc73fcc033286b$var$_persistToCookie(override, sdkKey);
    },
    _setCookiesEnabled: (sdkKey, cookiesEnabled)=>{
        $0cfc73fcc033286b$var$COOKIE_ENABLED_MAP[sdkKey] = cookiesEnabled;
    },
    _setDisabled: (sdkKey, disabled)=>{
        $0cfc73fcc033286b$var$DISABLED_MAP[sdkKey] = disabled;
    }
};
function $0cfc73fcc033286b$var$_getStableIDStorageKey(sdkKey) {
    return `statsig.stable_id.${(0, $4KuM7._getStorageKey)(sdkKey)}`;
}
function $0cfc73fcc033286b$var$_persistToStorage(stableID, sdkKey) {
    const storageKey = $0cfc73fcc033286b$var$_getStableIDStorageKey(sdkKey);
    try {
        (0, $jKkqw._setObjectInStorage)(storageKey, stableID);
    } catch (e) {
        $9Qn0V.Log.warn('Failed to save StableID to storage');
    }
}
function $0cfc73fcc033286b$var$_loadFromStorage(sdkKey) {
    const storageKey = $0cfc73fcc033286b$var$_getStableIDStorageKey(sdkKey);
    return (0, $jKkqw._getObjectFromStorage)(storageKey);
}
function $0cfc73fcc033286b$var$_loadFromCookie(sdkKey) {
    if (!$0cfc73fcc033286b$var$COOKIE_ENABLED_MAP[sdkKey] || (0, $hmoSx._getDocumentSafe)() == null) return null;
    const cookies = document.cookie.split(';');
    for (const cookie of cookies){
        const [key, value] = cookie.trim().split('=');
        if (key === $0cfc73fcc033286b$var$getCookieName(sdkKey)) return decodeURIComponent(value);
    }
    return null;
}
function $0cfc73fcc033286b$var$_persistToCookie(stableID, sdkKey) {
    if (!$0cfc73fcc033286b$var$COOKIE_ENABLED_MAP[sdkKey] || (0, $hmoSx._getDocumentSafe)() == null) return;
    const expiryDate = new Date();
    expiryDate.setFullYear(expiryDate.getFullYear() + 1);
    document.cookie = `${$0cfc73fcc033286b$var$getCookieName(sdkKey)}=${encodeURIComponent(stableID)}; expires=${expiryDate.toUTCString()}; path=/`;
}
function $0cfc73fcc033286b$var$getCookieName(sdkKey) {
    return `statsig.stable_id.${(0, $4KuM7._getStorageKey)(sdkKey)}`;
}
module.exports.getCookieName = $0cfc73fcc033286b$var$getCookieName;

});

parcelRegister("83Y6N", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ErrorTag = void 0;
module.exports.ErrorTag = {
    NetworkError: 'NetworkError'
};

});

parcelRegister("baWwc", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LoggingEnabledOption = module.exports.LogEventCompressionMode = void 0;
module.exports.LogEventCompressionMode = {
    /** Do not compress request bodies */ Disabled: 'd',
    /** Compress request bodies unless a network proxy is configured */ Enabled: 'e',
    /** Always compress request bodies, even when a proxy is configured */ Forced: 'f'
};
module.exports.LoggingEnabledOption = {
    disabled: 'disabled',
    browserOnly: 'browser-only',
    always: 'always'
};

});



parcelRegister("6fgsI", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PendingEvents = void 0;

var $9Qn0V = parcelRequire("9Qn0V");
class $48c0e9d164ed8ef5$var$PendingEvents {
    constructor(batchSize){
        this._pendingEvents = [];
        this._batchSize = batchSize;
    }
    addToPendingEventsQueue(event) {
        this._pendingEvents.push(event);
        $9Qn0V.Log.debug('Enqueued Event:', event);
    }
    hasEventsForFullBatch() {
        return this._pendingEvents.length >= this._batchSize;
    }
    takeAll() {
        const events = this._pendingEvents;
        this._pendingEvents = [];
        return events;
    }
    isEmpty() {
        return this._pendingEvents.length === 0;
    }
}
module.exports.PendingEvents = $48c0e9d164ed8ef5$var$PendingEvents;

});

parcelRegister("gQtPt", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._createLayerParameterExposure = module.exports._createConfigExposure = module.exports._mapExposures = module.exports._createGateExposure = module.exports._isExposureEvent = void 0;
const $c438a41d8ab9430d$var$CONFIG_EXPOSURE_NAME = 'statsig::config_exposure';
const $c438a41d8ab9430d$var$GATE_EXPOSURE_NAME = 'statsig::gate_exposure';
const $c438a41d8ab9430d$var$LAYER_EXPOSURE_NAME = 'statsig::layer_exposure';
const $c438a41d8ab9430d$var$_createExposure = (eventName, user, details, metadata, secondaryExposures)=>{
    if (details.bootstrapMetadata) metadata['bootstrapMetadata'] = details.bootstrapMetadata;
    return {
        eventName: eventName,
        user: user,
        value: null,
        metadata: $c438a41d8ab9430d$var$_addEvaluationDetailsToMetadata(details, metadata),
        secondaryExposures: secondaryExposures,
        time: Date.now()
    };
};
const $c438a41d8ab9430d$var$_isExposureEvent = ({ eventName: eventName })=>{
    return eventName === $c438a41d8ab9430d$var$GATE_EXPOSURE_NAME || eventName === $c438a41d8ab9430d$var$CONFIG_EXPOSURE_NAME || eventName === $c438a41d8ab9430d$var$LAYER_EXPOSURE_NAME;
};
module.exports._isExposureEvent = $c438a41d8ab9430d$var$_isExposureEvent;
const $c438a41d8ab9430d$var$_createGateExposure = (user, gate, exposureMapping)=>{
    var _a, _b, _c;
    const metadata = {
        gate: gate.name,
        gateValue: String(gate.value),
        ruleID: gate.ruleID
    };
    if (((_a = gate.__evaluation) === null || _a === void 0 ? void 0 : _a.version) != null) metadata['configVersion'] = gate.__evaluation.version;
    return $c438a41d8ab9430d$var$_createExposure($c438a41d8ab9430d$var$GATE_EXPOSURE_NAME, user, gate.details, metadata, $c438a41d8ab9430d$var$_mapExposures((_c = (_b = gate.__evaluation) === null || _b === void 0 ? void 0 : _b.secondary_exposures) !== null && _c !== void 0 ? _c : [], exposureMapping));
};
module.exports._createGateExposure = $c438a41d8ab9430d$var$_createGateExposure;
function $c438a41d8ab9430d$var$_mapExposures(exposures, exposureMapping) {
    return exposures.map((exposure)=>{
        if (typeof exposure === 'string') return (exposureMapping !== null && exposureMapping !== void 0 ? exposureMapping : {})[exposure];
        return exposure;
    }).filter((exposure)=>exposure != null);
}
module.exports._mapExposures = $c438a41d8ab9430d$var$_mapExposures;
const $c438a41d8ab9430d$var$_createConfigExposure = (user, config, exposureMapping)=>{
    var _a, _b, _c, _d;
    const metadata = {
        config: config.name,
        ruleID: config.ruleID
    };
    if (((_a = config.__evaluation) === null || _a === void 0 ? void 0 : _a.version) != null) metadata['configVersion'] = config.__evaluation.version;
    if (((_b = config.__evaluation) === null || _b === void 0 ? void 0 : _b.passed) != null) metadata['rulePassed'] = String(config.__evaluation.passed);
    return $c438a41d8ab9430d$var$_createExposure($c438a41d8ab9430d$var$CONFIG_EXPOSURE_NAME, user, config.details, metadata, $c438a41d8ab9430d$var$_mapExposures((_d = (_c = config.__evaluation) === null || _c === void 0 ? void 0 : _c.secondary_exposures) !== null && _d !== void 0 ? _d : [], exposureMapping));
};
module.exports._createConfigExposure = $c438a41d8ab9430d$var$_createConfigExposure;
const $c438a41d8ab9430d$var$_createLayerParameterExposure = (user, layer, parameterName, exposureMapping)=>{
    var _a, _b, _c, _d, _e, _f, _g;
    const evaluation = layer.__evaluation;
    const isExplicit = ((_a = evaluation === null || evaluation === void 0 ? void 0 : evaluation.explicit_parameters) === null || _a === void 0 ? void 0 : _a.includes(parameterName)) === true;
    let allocatedExperiment = '';
    let secondaryExposures = (_b = evaluation === null || evaluation === void 0 ? void 0 : evaluation.undelegated_secondary_exposures) !== null && _b !== void 0 ? _b : [];
    if (isExplicit) {
        allocatedExperiment = (_c = evaluation.allocated_experiment_name) !== null && _c !== void 0 ? _c : '';
        secondaryExposures = (_d = evaluation.secondary_exposures) !== null && _d !== void 0 ? _d : [];
    }
    const parameterRuleIDs = (_e = layer.__evaluation) === null || _e === void 0 ? void 0 : _e.parameter_rule_ids;
    const metadata = {
        config: layer.name,
        parameterName: parameterName,
        ruleID: (_f = parameterRuleIDs === null || parameterRuleIDs === void 0 ? void 0 : parameterRuleIDs[parameterName]) !== null && _f !== void 0 ? _f : layer.ruleID,
        allocatedExperiment: allocatedExperiment,
        isExplicitParameter: String(isExplicit)
    };
    if (((_g = layer.__evaluation) === null || _g === void 0 ? void 0 : _g.version) != null) metadata['configVersion'] = layer.__evaluation.version;
    return $c438a41d8ab9430d$var$_createExposure($c438a41d8ab9430d$var$LAYER_EXPOSURE_NAME, user, layer.details, metadata, $c438a41d8ab9430d$var$_mapExposures(secondaryExposures, exposureMapping));
};
module.exports._createLayerParameterExposure = $c438a41d8ab9430d$var$_createLayerParameterExposure;
const $c438a41d8ab9430d$var$_addEvaluationDetailsToMetadata = (details, metadata)=>{
    metadata['reason'] = details.reason;
    if (details.lcut) metadata['lcut'] = String(details.lcut);
    if (details.receivedAt) metadata['receivedAt'] = String(details.receivedAt);
    return metadata;
};

});

parcelRegister("e7KD1", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.UrlConfiguration = void 0;

var $doPF1 = parcelRequire("doPF1");

var $3wynb = parcelRequire("3wynb");
const $a485e38c64def78d$var$ENDPOINT_DNS_KEY_MAP = {
    [$3wynb.Endpoint._initialize]: 'i',
    [$3wynb.Endpoint._rgstr]: 'e',
    [$3wynb.Endpoint._download_config_specs]: 'd'
};
class $a485e38c64def78d$var$UrlConfiguration {
    constructor(endpoint, customUrl, customApi, fallbackUrls){
        this.customUrl = null;
        this.fallbackUrls = null;
        this.endpoint = endpoint;
        this.endpointDnsKey = $a485e38c64def78d$var$ENDPOINT_DNS_KEY_MAP[endpoint];
        if (customUrl) this.customUrl = customUrl;
        if (!customUrl && customApi) this.customUrl = customApi.endsWith('/') ? `${customApi}${endpoint}` : `${customApi}/${endpoint}`;
        if (fallbackUrls) this.fallbackUrls = fallbackUrls;
        const defaultApi = $3wynb.NetworkDefault[endpoint];
        this.defaultUrl = `${defaultApi}/${endpoint}`;
    }
    getUrl() {
        var _a;
        return (_a = this.customUrl) !== null && _a !== void 0 ? _a : this.defaultUrl;
    }
    getChecksum() {
        var _a;
        const fallbacks = ((_a = this.fallbackUrls) !== null && _a !== void 0 ? _a : []).sort().join(',');
        return (0, $doPF1._DJB2)(this.customUrl + fallbacks);
    }
}
module.exports.UrlConfiguration = $a485e38c64def78d$var$UrlConfiguration;

});


parcelRegister("fivtj", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PrecomputedEvaluationsContextHandle = void 0;

var $9Qn0V = parcelRequire("9Qn0V");

var $hmoSx = parcelRequire("hmoSx");

var $ldhqF = parcelRequire("ldhqF");

var $177Kh = parcelRequire("177Kh");
/**
 * A handle to the PrecomputedEvaluationsContext that computes fields lazily on access.
 * This avoids unnecessary computation (e.g., cloning the user) when only certain fields are needed.
 * The handle is created once and reused; individual getters fetch current values on each access.
 */ class $b230f31a9c98e018$var$PrecomputedEvaluationsContextHandle {
    constructor(sdkKey, getOptions, getErrorBoundary, getValues, getUser, getSdkInstanceID){
        this._sdkKey = sdkKey;
        this._getOptions = getOptions;
        this._getErrorBoundary = getErrorBoundary;
        this._getValues = getValues;
        this._getUser = getUser;
        this._getSdkInstanceID = getSdkInstanceID;
    }
    get sdkKey() {
        return this._sdkKey;
    }
    get options() {
        return this._getOptions();
    }
    get errorBoundary() {
        return this._getErrorBoundary();
    }
    get values() {
        return this._getValues();
    }
    get user() {
        let user = (0, $hmoSx._cloneObject)('StatsigUser', this._getUser());
        if (user == null) {
            $9Qn0V.Log.error('Failed to clone user');
            user = {};
        }
        return user;
    }
    /**
     * Gets the current session.
     * @param {boolean} [bumpSession=true] - Whether to bump/update the session timing. Set to false to read without affecting session state.
     */ getSession(bumpSession = true) {
        return $ldhqF.StatsigSession.get(this._sdkKey, bumpSession);
    }
    get stableID() {
        return $177Kh.StableID.get(this._sdkKey);
    }
    get sdkInstanceID() {
        return this._getSdkInstanceID();
    }
    /**
     * Returns the full PrecomputedEvaluationsContext object.
     * Use this when you need all fields at once.
     * @param {boolean} [bumpSession=true] - Whether to bump the session when building the context.
     */ toContext(bumpSession = true) {
        return {
            sdkKey: this.sdkKey,
            options: this.options,
            values: this.values,
            user: this.user,
            errorBoundary: this.errorBoundary,
            session: this.getSession(bumpSession),
            stableID: this.stableID,
            sdkInstanceID: this.sdkInstanceID
        };
    }
}
module.exports.PrecomputedEvaluationsContextHandle = $b230f31a9c98e018$var$PrecomputedEvaluationsContextHandle;

});

parcelRegister("a5r3l", function(module, exports) {
"use strict";
var $757f5b23eb01ac78$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._makeDataAdapterResult = module.exports.DataAdapterCore = void 0;

var $9Qn0V = parcelRequire("9Qn0V");

var $177Kh = parcelRequire("177Kh");

var $619VR = parcelRequire("619VR");

var $jKkqw = parcelRequire("jKkqw");

var $7PZBS = parcelRequire("7PZBS");
const $757f5b23eb01ac78$var$CACHE_LIMIT = 10;
const $757f5b23eb01ac78$var$MAX_CACHE_WRITE_ATTEMPTS = 8;
class $757f5b23eb01ac78$var$DataAdapterCore {
    constructor(_adapterName, _cacheSuffix){
        this._adapterName = _adapterName;
        this._cacheSuffix = _cacheSuffix;
        this._options = null;
        this._sdkKey = null;
        this._cacheLimit = $757f5b23eb01ac78$var$CACHE_LIMIT;
        this._lastModifiedStoreKey = `statsig.last_modified_time.${_cacheSuffix}`;
        this._inMemoryCache = new $757f5b23eb01ac78$var$InMemoryCache();
    }
    attach(sdkKey, options, _network) {
        this._sdkKey = sdkKey;
        this._options = options;
    }
    getDataSync(user) {
        const normalized = user && (0, $619VR._normalizeUser)(user, this._options);
        const cacheKey = this._getCacheKey(normalized);
        const inMem = this._inMemoryCache.get(cacheKey, normalized);
        if (inMem && this._getIsCacheValueValid(inMem)) return inMem;
        const cache = this._loadFromCache(cacheKey);
        if (cache && this._getIsCacheValueValid(cache)) {
            this._inMemoryCache.add(cacheKey, cache, this._cacheLimit);
            return this._inMemoryCache.get(cacheKey, normalized);
        }
        return null;
    }
    setData(data, user) {
        const normalized = user && (0, $619VR._normalizeUser)(user, this._options);
        const cacheKey = this._getCacheKey(normalized);
        this._inMemoryCache.add(cacheKey, $757f5b23eb01ac78$var$_makeDataAdapterResult('Bootstrap', data, null, normalized), this._cacheLimit);
    }
    _getIsCacheValueValid(current) {
        return current.stableID == null || current.stableID === $177Kh.StableID.get(this._getSdkKey());
    }
    _getDataAsyncImpl(current, user, options) {
        return $757f5b23eb01ac78$var$__awaiter(this, void 0, void 0, function*() {
            if (!$jKkqw.Storage.isReady()) yield $jKkqw.Storage.isReadyResolver();
            const cache = current !== null && current !== void 0 ? current : this.getDataSync(user);
            const ops = [
                this._fetchAndPrepFromNetwork(cache, user, options)
            ];
            if (options === null || options === void 0 ? void 0 : options.timeoutMs) ops.push(new Promise((r)=>setTimeout(r, options.timeoutMs)).then(()=>{
                $9Qn0V.Log.debug('Fetching latest value timed out');
                return null;
            }));
            return yield Promise.race(ops);
        });
    }
    _prefetchDataImpl(user, options) {
        return $757f5b23eb01ac78$var$__awaiter(this, void 0, void 0, function*() {
            const normalized = user && (0, $619VR._normalizeUser)(user, this._options);
            const cacheKey = this._getCacheKey(normalized);
            const result = yield this._getDataAsyncImpl(null, normalized, options);
            if (result) this._inMemoryCache.add(cacheKey, Object.assign(Object.assign({}, result), {
                source: 'Prefetch'
            }), this._cacheLimit);
        });
    }
    _fetchAndPrepFromNetwork(cachedResult, user, options) {
        return $757f5b23eb01ac78$var$__awaiter(this, void 0, void 0, function*() {
            var _a;
            const cachedData = (_a = cachedResult === null || cachedResult === void 0 ? void 0 : cachedResult.data) !== null && _a !== void 0 ? _a : null;
            const isCacheValidFor204 = cachedResult != null && this._isCachedResultValidFor204(cachedResult, user);
            const latest = yield this._fetchFromNetwork(cachedData, user, options, isCacheValidFor204);
            if (!latest) {
                $9Qn0V.Log.debug('No response returned for latest value');
                return null;
            }
            const response = (0, $7PZBS._typedJsonParse)(latest, 'has_updates', 'Response');
            const sdkKey = this._getSdkKey();
            const stableID = $177Kh.StableID.get(sdkKey);
            let result = null;
            if ((response === null || response === void 0 ? void 0 : response.has_updates) === true) result = $757f5b23eb01ac78$var$_makeDataAdapterResult('Network', latest, stableID, user);
            else if (cachedData && (response === null || response === void 0 ? void 0 : response.has_updates) === false) result = $757f5b23eb01ac78$var$_makeDataAdapterResult('NetworkNotModified', cachedData, stableID, user);
            else return null;
            const cacheKey = this._getCacheKey(user);
            this._inMemoryCache.add(cacheKey, result, this._cacheLimit);
            this._writeToCache(cacheKey, result);
            return result;
        });
    }
    _getSdkKey() {
        if (this._sdkKey != null) return this._sdkKey;
        $9Qn0V.Log.error(`${this._adapterName} is not attached to a Client`);
        return '';
    }
    _loadFromCache(cacheKey) {
        var _a;
        const cache = (_a = $jKkqw.Storage.getItem) === null || _a === void 0 ? void 0 : _a.call($jKkqw.Storage, cacheKey);
        if (cache == null) return null;
        const result = (0, $7PZBS._typedJsonParse)(cache, 'source', 'Cached Result');
        return result ? Object.assign(Object.assign({}, result), {
            source: 'Cache'
        }) : null;
    }
    _writeToCache(cacheKey, result) {
        const resultString = JSON.stringify(result);
        for(let i = 0; i < $757f5b23eb01ac78$var$MAX_CACHE_WRITE_ATTEMPTS; i++)try {
            $jKkqw.Storage.setItem(cacheKey, resultString);
            break;
        } catch (error) {
            if (!(error instanceof Error) || !(error.toString().includes('QuotaExceededError') || error.toString().includes('QUOTA_EXCEEDED_ERR')) || this._cacheLimit <= 1) throw error;
            this._cacheLimit = Math.ceil(this._cacheLimit / 2);
            this._runLocalStorageCacheEviction(cacheKey, this._cacheLimit - 1);
        }
        this._runLocalStorageCacheEviction(cacheKey);
    }
    _runLocalStorageCacheEviction(cacheKey, cacheLimit = this._cacheLimit) {
        var _a;
        const lastModifiedTimeMap = (_a = (0, $jKkqw._getObjectFromStorage)(this._lastModifiedStoreKey)) !== null && _a !== void 0 ? _a : {};
        lastModifiedTimeMap[cacheKey] = Date.now();
        const evictableKeys = $757f5b23eb01ac78$var$_getEvictableKeys(lastModifiedTimeMap, cacheLimit);
        for (const evictable of evictableKeys){
            delete lastModifiedTimeMap[evictable];
            $jKkqw.Storage.removeItem(evictable);
        }
        (0, $jKkqw._setObjectInStorage)(this._lastModifiedStoreKey, lastModifiedTimeMap);
    }
}
module.exports.DataAdapterCore = $757f5b23eb01ac78$var$DataAdapterCore;
function $757f5b23eb01ac78$var$_makeDataAdapterResult(source, data, stableID, user) {
    return {
        source: source,
        data: data,
        receivedAt: Date.now(),
        stableID: stableID,
        fullUserHash: (0, $619VR._getFullUserHash)(user)
    };
}
module.exports._makeDataAdapterResult = $757f5b23eb01ac78$var$_makeDataAdapterResult;
class $757f5b23eb01ac78$var$InMemoryCache {
    constructor(){
        this._data = {};
    }
    get(cacheKey, user) {
        var _a;
        const result = this._data[cacheKey];
        const cached = result === null || result === void 0 ? void 0 : result.stableID;
        const provided = (_a = user === null || user === void 0 ? void 0 : user.customIDs) === null || _a === void 0 ? void 0 : _a.stableID;
        if (provided && cached && provided !== cached) {
            $9Qn0V.Log.warn("'StatsigUser.customIDs.stableID' mismatch");
            return null;
        }
        return result;
    }
    add(cacheKey, value, cacheLimit) {
        const evictableKeys = $757f5b23eb01ac78$var$_getEvictableKeys(this._data, cacheLimit - 1);
        for (const evictable of evictableKeys)delete this._data[evictable];
        this._data[cacheKey] = value;
    }
    merge(values) {
        this._data = Object.assign(Object.assign({}, this._data), values);
    }
}
function $757f5b23eb01ac78$var$_getEvictableKeys(data, limit) {
    const keys = Object.keys(data);
    if (keys.length <= limit) return [];
    if (limit === 0) return keys;
    return keys.sort((keyA, keyB)=>{
        const valueA = data[keyA];
        const valueB = data[keyB];
        if (typeof valueA === 'object' && typeof valueB === 'object') return valueA.receivedAt - valueB.receivedAt;
        return valueA - valueB;
    }).slice(0, keys.length - limit);
}

});
parcelRegister("619VR", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._getUnitIDFromUser = module.exports._getFullUserHash = module.exports._normalizeUser = void 0;

var $doPF1 = parcelRequire("doPF1");

var $9Qn0V = parcelRequire("9Qn0V");

var $hmoSx = parcelRequire("hmoSx");
function $461a8a630e6a2b6d$var$_normalizeUser(original, options, fallbackEnvironment) {
    const copy = (0, $hmoSx._cloneObject)('StatsigUser', original);
    if (copy == null) {
        $9Qn0V.Log.error('Failed to clone user');
        return {
            statsigEnvironment: undefined
        };
    }
    if (options != null && options.environment != null) copy.statsigEnvironment = options.environment;
    else if (fallbackEnvironment != null) copy.statsigEnvironment = {
        tier: fallbackEnvironment
    };
    return copy;
}
module.exports._normalizeUser = $461a8a630e6a2b6d$var$_normalizeUser;
function $461a8a630e6a2b6d$var$_getFullUserHash(user) {
    return user ? (0, $doPF1._DJB2Object)(user) : null;
}
module.exports._getFullUserHash = $461a8a630e6a2b6d$var$_getFullUserHash;
function $461a8a630e6a2b6d$var$_getUnitIDFromUser(user, idType) {
    var _a, _b, _c;
    if (typeof idType !== 'string') return user.userID;
    const lowered = idType.toLowerCase();
    if (lowered !== 'userid') return (_b = (_a = user.customIDs) === null || _a === void 0 ? void 0 : _a[idType]) !== null && _b !== void 0 ? _b : (_c = user.customIDs) === null || _c === void 0 ? void 0 : _c[lowered];
    return user.userID;
}
module.exports._getUnitIDFromUser = $461a8a630e6a2b6d$var$_getUnitIDFromUser;

});

parcelRegister("7PZBS", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._typedJsonParse = void 0;

var $9Qn0V = parcelRequire("9Qn0V");
/**
 *
 * @param {string} data The values to parse into T
 * @param {string} guard A field that must exists on the parsed object for the parse to be valid
 * @param {string} error An error to print via Log.error() when parsing fails
 * @returns {T | null} The parse object T or null if it failed
 */ function $5b4d1642b922e1ea$var$_typedJsonParse(data, guard, typeName) {
    try {
        const result = JSON.parse(data);
        if (result && typeof result === 'object' && guard in result) return result;
    } catch (_a) {
    // noop
    }
    $9Qn0V.Log.error(`Failed to parse ${typeName}`);
    return null;
}
module.exports._typedJsonParse = $5b4d1642b922e1ea$var$_typedJsonParse;

});


parcelRegister("ceicM", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("hpmwp", function(module, exports) {
"use strict";
var $cac63dca052a47f5$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ErrorBoundary = module.exports.EXCEPTION_ENDPOINT = void 0;

var $9Qn0V = parcelRequire("9Qn0V");

var $9JrW9 = parcelRequire("9JrW9");

var $kVJXW = parcelRequire("kVJXW");
module.exports.EXCEPTION_ENDPOINT = 'https://statsigapi.net/v1/sdk_exception';
const $cac63dca052a47f5$var$UNKNOWN_ERROR = '[Statsig] UnknownError';
class $cac63dca052a47f5$var$ErrorBoundary {
    constructor(_sdkKey, _options, _emitter, _lastSeenError){
        this._sdkKey = _sdkKey;
        this._options = _options;
        this._emitter = _emitter;
        this._lastSeenError = _lastSeenError;
        this._seen = new Set();
    }
    wrap(instance, namePrefix) {
        try {
            const obj = instance;
            $cac63dca052a47f5$var$_getAllInstanceMethodNames(obj).forEach((name)=>{
                const original = obj[name];
                if ('$EB' in original) return;
                obj[name] = (...args)=>{
                    return this._capture(namePrefix ? `${namePrefix}:${name}` : name, ()=>original.apply(instance, args));
                };
                obj[name].$EB = true;
            });
        } catch (err) {
            this._onError('eb:wrap', err);
        }
    }
    logError(tag, error) {
        this._onError(tag, error);
    }
    logDroppedEvents(count, reason, metadata) {
        const extra = {
            eventCount: String(count),
            reason: reason
        };
        if (metadata) Object.keys(metadata).forEach((key)=>{
            extra[key] = String(metadata[key]);
        });
        this._onError(`statsig::log_event_dropped_event_count`, new Error(reason), true, extra);
    }
    logEventRequestFailure(count, reason, flushType, statusCode, retries, failurePath, failureErrorMessage, failureDiagnosticBucket, failureDiagnosticMetadata) {
        const extra = {
            eventCount: String(count),
            flushType: flushType,
            statusCode: String(statusCode),
            reason: reason,
            retries: String(retries)
        };
        if (failurePath) extra['failurePath'] = failurePath;
        if (typeof failureErrorMessage === 'string' && failureErrorMessage.length > 0) extra['failureErrorMessage'] = failureErrorMessage;
        if (typeof failureDiagnosticBucket === 'string' && failureDiagnosticBucket.length > 0) extra['failureDiagnosticBucket'] = failureDiagnosticBucket;
        if (failureDiagnosticMetadata) Object.keys(failureDiagnosticMetadata).forEach((key)=>{
            const value = failureDiagnosticMetadata[key];
            if (value.length > 0) extra[`failureDiagnostic_${key}`] = value;
        });
        this._onError(`statsig::log_event_failed`, new Error(reason), true, extra);
    }
    getLastSeenErrorAndReset() {
        const tempError = this._lastSeenError;
        this._lastSeenError = undefined;
        return tempError !== null && tempError !== void 0 ? tempError : null;
    }
    attachErrorIfNoneExists(error) {
        if (this._lastSeenError) return;
        this._lastSeenError = $cac63dca052a47f5$var$_resolveError(error);
    }
    _capture(tag, task) {
        try {
            const res = task();
            if (res && res instanceof Promise) return res.catch((err)=>this._onError(tag, err));
            return res;
        } catch (error) {
            this._onError(tag, error);
            return null;
        }
    }
    _onError(tag, error, bypassDedupe = false, extra) {
        try {
            $9Qn0V.Log.warn(`Caught error in ${tag}`, {
                error: error
            });
            const impl = ()=>$cac63dca052a47f5$var$__awaiter(this, void 0, void 0, function*() {
                    var _a, _b, _c, _d, _e, _f, _g;
                    const unwrapped = error ? error : Error($cac63dca052a47f5$var$UNKNOWN_ERROR);
                    const isError = unwrapped instanceof Error;
                    const name = isError ? unwrapped.name : 'No Name';
                    const resolvedError = $cac63dca052a47f5$var$_resolveError(unwrapped);
                    this._lastSeenError = resolvedError;
                    if (!bypassDedupe && this._seen.has(name)) return;
                    this._seen.add(name);
                    if ((_b = (_a = this._options) === null || _a === void 0 ? void 0 : _a.networkConfig) === null || _b === void 0 ? void 0 : _b.preventAllNetworkTraffic) {
                        (_c = this._emitter) === null || _c === void 0 || _c.call(this, {
                            name: 'error',
                            error: error,
                            tag: tag
                        });
                        return;
                    }
                    const sdkType = $9JrW9.SDKType._get(this._sdkKey);
                    const statsigMetadata = $kVJXW.StatsigMetadataProvider.get();
                    const info = isError ? unwrapped.stack : $cac63dca052a47f5$var$_getDescription(unwrapped);
                    const body = Object.assign(Object.assign({
                        tag: tag,
                        exception: name,
                        info: info,
                        statsigOptions: $cac63dca052a47f5$var$_getStatsigOptionLoggingCopy(this._options)
                    }, Object.assign(Object.assign({}, statsigMetadata), {
                        sdkType: sdkType
                    })), extra !== null && extra !== void 0 ? extra : {});
                    const networkConfig = (_d = this._options) === null || _d === void 0 ? void 0 : _d.networkConfig;
                    const func = (_e = networkConfig === null || networkConfig === void 0 ? void 0 : networkConfig.networkOverrideFunc) !== null && _e !== void 0 ? _e : fetch;
                    yield func((_f = networkConfig === null || networkConfig === void 0 ? void 0 : networkConfig.sdkExceptionUrl) !== null && _f !== void 0 ? _f : module.exports.EXCEPTION_ENDPOINT, {
                        method: 'POST',
                        headers: {
                            'STATSIG-API-KEY': this._sdkKey,
                            'STATSIG-SDK-TYPE': String(sdkType),
                            'STATSIG-SDK-VERSION': String(statsigMetadata.sdkVersion),
                            'Content-Type': 'application/json'
                        },
                        body: JSON.stringify(body)
                    });
                    (_g = this._emitter) === null || _g === void 0 || _g.call(this, {
                        name: 'error',
                        error: error,
                        tag: tag
                    });
                });
            impl().then(()=>{
            /* noop */ }).catch(()=>{
            /* noop */ });
        } catch (_error) {
        /* noop */ }
    }
}
module.exports.ErrorBoundary = $cac63dca052a47f5$var$ErrorBoundary;
function $cac63dca052a47f5$var$_resolveError(error) {
    if (error instanceof Error) return error;
    else if (typeof error === 'string') return new Error(error);
    else return new Error('An unknown error occurred.');
}
function $cac63dca052a47f5$var$_getDescription(obj) {
    try {
        return JSON.stringify(obj);
    } catch (_a) {
        return $cac63dca052a47f5$var$UNKNOWN_ERROR;
    }
}
function $cac63dca052a47f5$var$_getAllInstanceMethodNames(instance) {
    const names = new Set();
    let proto = Object.getPrototypeOf(instance);
    while(proto && proto !== Object.prototype){
        Object.getOwnPropertyNames(proto).filter((prop)=>typeof (proto === null || proto === void 0 ? void 0 : proto[prop]) === 'function').forEach((name)=>names.add(name));
        proto = Object.getPrototypeOf(proto);
    }
    return Array.from(names);
}
function $cac63dca052a47f5$var$_getStatsigOptionLoggingCopy(options) {
    if (!options) return {};
    const loggingCopy = {};
    Object.keys(options).forEach((key)=>{
        const option = key;
        const value = options[option];
        const valueType = typeof value;
        switch(valueType){
            case 'number':
            case 'bigint':
            case 'boolean':
                loggingCopy[String(option)] = value;
                break;
            case 'string':
                if (value.length < 50) loggingCopy[String(option)] = value;
                else loggingCopy[String(option)] = 'set';
                break;
            case 'object':
                if (option === 'environment') loggingCopy['environment'] = value;
                else if (option === 'networkConfig') loggingCopy['networkConfig'] = value;
                else loggingCopy[String(option)] = value != null ? 'set' : 'unset';
                break;
            default:
        }
    });
    return loggingCopy;
}

});

parcelRegister("6lwLe", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("80W8k", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("6vMkI", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("4wyC3", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.createMemoKey = module.exports.MemoPrefix = void 0;
module.exports.MemoPrefix = {
    _gate: 'g',
    _dynamicConfig: 'c',
    _experiment: 'e',
    _configList: 'cl',
    _layer: 'l',
    _paramStore: 'p'
};
const $34b4fff33a7d988e$var$EXIST_KEYS = new Set([]);
const $34b4fff33a7d988e$var$DO_NOT_MEMO_KEYS = new Set([
    // Add keys that if exist, should not be memoized
    'userPersistedValues'
]);
function $34b4fff33a7d988e$var$createMemoKey(prefix, name, options) {
    let cacheKey = `${prefix}|${name}`;
    if (!options) return cacheKey;
    for (const key of Object.keys(options)){
        if ($34b4fff33a7d988e$var$DO_NOT_MEMO_KEYS.has(key)) return undefined;
        if ($34b4fff33a7d988e$var$EXIST_KEYS.has(key)) cacheKey += `|${key}=true`;
        else cacheKey += `|${key}=${options[key]}`;
    }
    return cacheKey;
}
module.exports.createMemoKey = $34b4fff33a7d988e$var$createMemoKey;

});

parcelRegister("goCQh", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("lUQm9", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("hZIMt", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._fastApproxSizeOf = void 0;
const $d19adeb366b08cf8$var$CURLY_AND_SQUARE_BRACKET_SIZE = 2; // [] for array, {} for object
const $d19adeb366b08cf8$var$APPROX_ADDITIONAL_SIZE = 1; // additional size for comma and stuff
const $d19adeb366b08cf8$var$_fastApproxSizeOf = (obj, max)=>{
    let size = 0;
    const keys = Object.keys(obj);
    for(let i = 0; i < keys.length; i++){
        const key = keys[i];
        const value = obj[key];
        size += key.length;
        if (typeof value === 'object' && value !== null) size += (0, module.exports._fastApproxSizeOf)(value, max) + $d19adeb366b08cf8$var$CURLY_AND_SQUARE_BRACKET_SIZE;
        else size += String(value).length + $d19adeb366b08cf8$var$APPROX_ADDITIONAL_SIZE;
        if (size >= max) // exit early if we've exceeded the max
        return size;
    }
    return size;
};
module.exports._fastApproxSizeOf = $d19adeb366b08cf8$var$_fastApproxSizeOf;

});

parcelRegister("3VNWn", function(module, exports) {
"use strict";
var $2dcd6f2005c48552$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.StatsigClientBase = void 0;

var $8ZzeR = parcelRequire("8ZzeR");

var $8ZzeR = parcelRequire("8ZzeR");

var $hpmwp = parcelRequire("hpmwp");

var $dJrZC = parcelRequire("dJrZC");

var $9Qn0V = parcelRequire("9Qn0V");

var $4wyC3 = parcelRequire("4wyC3");

var $hmoSx = parcelRequire("hmoSx");

var $ldhqF = parcelRequire("ldhqF");

var $177Kh = parcelRequire("177Kh");

var $baWwc = parcelRequire("baWwc");

var $jKkqw = parcelRequire("jKkqw");
const $2dcd6f2005c48552$var$MAX_MEMO_CACHE_SIZE = 3000;
class $2dcd6f2005c48552$var$StatsigClientBase {
    constructor(sdkKey, adapter, network, options){
        var _a, _b, _c, _d;
        this.loadingStatus = 'Uninitialized';
        this._initializePromise = null;
        this._listeners = {};
        const emitter = this.$emt.bind(this);
        (options === null || options === void 0 ? void 0 : options.logLevel) != null && ($9Qn0V.Log.level = options.logLevel);
        (options === null || options === void 0 ? void 0 : options.disableStorage) && $jKkqw.Storage._setDisabled(true);
        (options === null || options === void 0 ? void 0 : options.initialSessionID) && $ldhqF.StatsigSession.overrideInitialSessionID(options.initialSessionID, sdkKey);
        (options === null || options === void 0 ? void 0 : options.storageProvider) && $jKkqw.Storage._setProvider(options.storageProvider);
        (options === null || options === void 0 ? void 0 : options.enableCookies) && $177Kh.StableID._setCookiesEnabled(sdkKey, options.enableCookies);
        (options === null || options === void 0 ? void 0 : options.disableStableID) && $177Kh.StableID._setDisabled(sdkKey, true);
        this._sdkKey = sdkKey;
        this._options = options !== null && options !== void 0 ? options : {};
        this._memoCache = {};
        this.overrideAdapter = (_a = options === null || options === void 0 ? void 0 : options.overrideAdapter) !== null && _a !== void 0 ? _a : null;
        this._errorBoundary = new $hpmwp.ErrorBoundary(sdkKey, options, emitter);
        this._logger = new $dJrZC.EventLogger(sdkKey, emitter, network, options, this._errorBoundary);
        this._errorBoundary.wrap(this);
        this._errorBoundary.wrap(adapter);
        this._errorBoundary.wrap(this._logger);
        network.setErrorBoundary(this._errorBoundary);
        this.dataAdapter = adapter;
        this.dataAdapter.attach(sdkKey, options, network);
        this.storageProvider = $jKkqw.Storage;
        (_d = (_c = (_b = this.overrideAdapter) === null || _b === void 0 ? void 0 : _b.loadFromStorage) === null || _c === void 0 ? void 0 : _c.call(_b)) === null || _d === void 0 || _d.catch((e)=>this._errorBoundary.logError('OA::loadFromStorage', e));
        this._primeReadyRipcord();
        $2dcd6f2005c48552$var$_assignGlobalInstance(sdkKey, this);
    }
    /**
     * Updates runtime configuration options for the SDK, allowing toggling of certain behaviors such as logging and storage to comply with user preferences or regulations such as GDPR.
     *
     * @param {StatsigRuntimeMutableOptions} options - The configuration options that dictate the runtime behavior of the SDK.
     */ updateRuntimeOptions(options) {
        if (options.loggingEnabled) {
            this._options.loggingEnabled = options.loggingEnabled;
            this._logger.setLoggingEnabled(options.loggingEnabled);
        } else if (options.disableLogging != null) {
            this._options.disableLogging = options.disableLogging;
            this._logger.setLoggingEnabled(options.disableLogging ? 'disabled' : 'browser-only');
        }
        if (options.disableStorage != null) {
            this._options.disableStorage = options.disableStorage;
            $jKkqw.Storage._setDisabled(options.disableStorage);
        }
        if (options.enableCookies != null) {
            this._options.enableCookies = options.enableCookies;
            $177Kh.StableID._setCookiesEnabled(this._sdkKey, options.enableCookies);
        }
        if (options.logEventCompressionMode) this._logger.setLogEventCompressionMode(options.logEventCompressionMode);
        else if (options.disableCompression) this._logger.setLogEventCompressionMode($baWwc.LogEventCompressionMode.Disabled);
    }
    /**
     * Flushes any currently queued events.
     */ flush() {
        return this._logger.flush();
    }
    /**
     * Gracefully shuts down the SDK, ensuring that all pending events are send before the SDK stops.
     * This function emits a 'pre_shutdown' event and then waits for the logger to complete its shutdown process.
     *
     * @returns {Promise<void>} A promise that resolves when all shutdown procedures, including logging shutdown, have been completed.
     */ shutdown() {
        return $2dcd6f2005c48552$var$__awaiter(this, void 0, void 0, function*() {
            this.$emt({
                name: 'pre_shutdown'
            });
            this._setStatus('Uninitialized', null);
            this._initializePromise = null;
            yield this._logger.stop();
        });
    }
    /**
     * Subscribes a callback function to a specific {@link StatsigClientEvent} or all StatsigClientEvents if the wildcard '*' is used.
     * Once subscribed, the listener callback will be invoked whenever the specified event is emitted.
     *
     * @param {StatsigClientEventName} event - The name of the event to subscribe to, or '*' to subscribe to all events.
     * @param {StatsigClientEventCallback<T>} listener - The callback function to execute when the event occurs. The function receives event-specific data as its parameter.
     * @see {@link off} for unsubscribing from events.
     */ on(event, listener) {
        if (!this._listeners[event]) this._listeners[event] = [];
        this._listeners[event].push(listener);
    }
    /**
     * Unsubscribes a previously registered callback function from a specific {@link StatsigClientEvent} or all StatsigClientEvents if the wildcard '*' is used.
     *
     * @param {StatsigClientEventName} event - The name of the event from which to unsubscribe, or '*' to unsubscribe from all events.
     * @param {StatsigClientEventCallback<T>} listener - The callback function to remove from the event's notification list.
     * @see {@link on} for subscribing to events.
     */ off(event, listener) {
        if (this._listeners[event]) {
            const index = this._listeners[event].indexOf(listener);
            if (index !== -1) this._listeners[event].splice(index, 1);
        }
    }
    $on(event, listener) {
        listener.__isInternal = true;
        this.on(event, listener);
    }
    $emt(event) {
        var _a;
        const barrier = (listener)=>{
            try {
                listener(event);
            } catch (error) {
                if (listener.__isInternal === true) {
                    this._errorBoundary.logError(`__emit:${event.name}`, error);
                    return;
                }
                $9Qn0V.Log.error(`An error occurred in a StatsigClientEvent listener. This is not an issue with Statsig.`, event);
            }
        };
        if (this._listeners[event.name]) this._listeners[event.name].forEach((l)=>barrier(l));
        (_a = this._listeners['*']) === null || _a === void 0 || _a.forEach(barrier);
    }
    _setStatus(newStatus, values) {
        this.loadingStatus = newStatus;
        this._memoCache = {};
        this.$emt({
            name: 'values_updated',
            status: newStatus,
            values: values
        });
    }
    _enqueueExposure(name, exposure, options) {
        if ((options === null || options === void 0 ? void 0 : options.disableExposureLog) === true) {
            this._logger.incrementNonExposureCount(name);
            return;
        }
        this._logger.enqueue(exposure);
    }
    _memoize(prefix, fn) {
        return (name, options)=>{
            if (this._options.disableEvaluationMemoization) return fn(name, options);
            const memoKey = (0, $4wyC3.createMemoKey)(prefix, name, options);
            if (!memoKey) return fn(name, options);
            if (!(memoKey in this._memoCache)) {
                if (Object.keys(this._memoCache).length >= $2dcd6f2005c48552$var$MAX_MEMO_CACHE_SIZE) this._memoCache = {};
                this._memoCache[memoKey] = fn(name, options);
            }
            return this._memoCache[memoKey];
        };
    }
}
module.exports.StatsigClientBase = $2dcd6f2005c48552$var$StatsigClientBase;
function $2dcd6f2005c48552$var$_assignGlobalInstance(sdkKey, client) {
    var _a;
    if ((0, $hmoSx._isServerEnv)()) return;
    const statsigGlobal = (0, $8ZzeR._getStatsigGlobal)();
    const instances = (_a = statsigGlobal.instances) !== null && _a !== void 0 ? _a : {};
    const inst = client;
    if (instances[sdkKey] != null) $9Qn0V.Log.warn('Creating multiple Statsig clients with the same SDK key can lead to unexpected behavior. Multi-instance support requires different SDK keys.');
    instances[sdkKey] = inst;
    if (!statsigGlobal.firstInstance) statsigGlobal.firstInstance = inst;
    statsigGlobal.instances = instances;
    __STATSIG__ = statsigGlobal;
}

});

parcelRegister("4H43E", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DataAdapterCachePrefix = void 0;
module.exports.DataAdapterCachePrefix = 'statsig.cached';

});

parcelRegister("c3WPJ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("li0QC", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._makeTypedGet = module.exports._mergeOverride = module.exports._makeLayer = module.exports._makeExperiment = module.exports._makeDynamicConfig = module.exports._makeFeatureGate = void 0;

var $9Qn0V = parcelRequire("9Qn0V");

var $cvjEj = parcelRequire("cvjEj");
function $f7fbefbf171b454f$var$_makeEvaluation(name, details, evaluation, value) {
    var _a;
    return {
        name: name,
        details: details,
        ruleID: (_a = evaluation === null || evaluation === void 0 ? void 0 : evaluation.rule_id) !== null && _a !== void 0 ? _a : '',
        __evaluation: evaluation,
        value: value
    };
}
function $f7fbefbf171b454f$var$_makeFeatureGate(name, details, evaluation) {
    var _a;
    return Object.assign(Object.assign({}, $f7fbefbf171b454f$var$_makeEvaluation(name, details, evaluation, (evaluation === null || evaluation === void 0 ? void 0 : evaluation.value) === true)), {
        idType: (_a = evaluation === null || evaluation === void 0 ? void 0 : evaluation.id_type) !== null && _a !== void 0 ? _a : null
    });
}
module.exports._makeFeatureGate = $f7fbefbf171b454f$var$_makeFeatureGate;
function $f7fbefbf171b454f$var$_makeDynamicConfig(name, details, evaluation) {
    var _a, _b;
    const value = (_a = evaluation === null || evaluation === void 0 ? void 0 : evaluation.value) !== null && _a !== void 0 ? _a : {};
    return Object.assign(Object.assign({}, $f7fbefbf171b454f$var$_makeEvaluation(name, details, evaluation, value)), {
        idType: (_b = evaluation === null || evaluation === void 0 ? void 0 : evaluation.id_type) !== null && _b !== void 0 ? _b : null,
        get: $f7fbefbf171b454f$var$_makeTypedGet(name, evaluation === null || evaluation === void 0 ? void 0 : evaluation.value)
    });
}
module.exports._makeDynamicConfig = $f7fbefbf171b454f$var$_makeDynamicConfig;
function $f7fbefbf171b454f$var$_makeExperiment(name, details, evaluation) {
    var _a;
    const result = $f7fbefbf171b454f$var$_makeDynamicConfig(name, details, evaluation);
    return Object.assign(Object.assign({}, result), {
        groupName: (_a = evaluation === null || evaluation === void 0 ? void 0 : evaluation.group_name) !== null && _a !== void 0 ? _a : null
    });
}
module.exports._makeExperiment = $f7fbefbf171b454f$var$_makeExperiment;
function $f7fbefbf171b454f$var$_makeLayer(name, details, evaluation, exposeFunc) {
    var _a, _b;
    return Object.assign(Object.assign({}, $f7fbefbf171b454f$var$_makeEvaluation(name, details, evaluation, undefined)), {
        get: $f7fbefbf171b454f$var$_makeTypedGet(name, evaluation === null || evaluation === void 0 ? void 0 : evaluation.value, exposeFunc),
        groupName: (_a = evaluation === null || evaluation === void 0 ? void 0 : evaluation.group_name) !== null && _a !== void 0 ? _a : null,
        __value: (_b = evaluation === null || evaluation === void 0 ? void 0 : evaluation.value) !== null && _b !== void 0 ? _b : {}
    });
}
module.exports._makeLayer = $f7fbefbf171b454f$var$_makeLayer;
function $f7fbefbf171b454f$var$_mergeOverride(original, overridden, value, exposeFunc) {
    return Object.assign(Object.assign(Object.assign({}, original), overridden), {
        get: $f7fbefbf171b454f$var$_makeTypedGet(original.name, value, exposeFunc)
    });
}
module.exports._mergeOverride = $f7fbefbf171b454f$var$_mergeOverride;
function $f7fbefbf171b454f$var$_makeTypedGet(name, value, exposeFunc) {
    return (param, fallback)=>{
        var _a;
        const found = (_a = value === null || value === void 0 ? void 0 : value[param]) !== null && _a !== void 0 ? _a : null;
        if (found == null) return fallback !== null && fallback !== void 0 ? fallback : null;
        if (fallback != null && !(0, $cvjEj._isTypeMatch)(found, fallback)) {
            $9Qn0V.Log.warn(`Parameter type mismatch. '${name}.${param}' was found to be type '${typeof found}' but fallback/return type is '${typeof fallback}'. See https://docs.statsig.com/client/javascript-sdk/#typed-getters`);
            return fallback !== null && fallback !== void 0 ? fallback : null;
        }
        exposeFunc === null || exposeFunc === void 0 || exposeFunc(param);
        return found;
    };
}
module.exports._makeTypedGet = $f7fbefbf171b454f$var$_makeTypedGet;

});

parcelRegister("gGLwe", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("kyXOf", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.UPDATE_DETAIL_ERROR_MESSAGES = module.exports.createUpdateDetails = void 0;
const $ef85608773efd0e6$var$createUpdateDetails = (success, source, initDuration, error, sourceUrl, warnings)=>{
    return {
        duration: initDuration,
        source: source,
        success: success,
        error: error,
        sourceUrl: sourceUrl,
        warnings: warnings
    };
};
module.exports.createUpdateDetails = $ef85608773efd0e6$var$createUpdateDetails;
module.exports.UPDATE_DETAIL_ERROR_MESSAGES = {
    NO_NETWORK_DATA: 'No data was returned from the network. This may be due to a network timeout if a timeout value was specified in the options or ad blocker error.'
};

});


parcelRegister("hUbY6", function(module, exports) {
$parcel$export(module.exports, "default", () => $d090f353cc560141$export$2e2bcd8739ae039);
/**
 * This length includes the underscore,
 * e.g. `"_1s4A"` would be a valid atomic group hash.
 */ const $d090f353cc560141$var$ATOMIC_GROUP_LENGTH = 5;
function $d090f353cc560141$export$2e2bcd8739ae039(classNames) {
    // Shortcut: nothing to do
    if (!classNames.length) return;
    // Shortcut: don't need to do anything if we only have a single classname
    if (classNames.length === 1 && classNames[0] && // checking to see if `classNames[0]` is a string that contains other classnames
    !classNames[0].includes(' ')) return classNames[0];
    // Using an object rather than a `Map` as it performed better in our benchmarks.
    // Would be happy to move to `Map` if it proved to be better under real conditions.
    const map = {};
    // Note: using loops to minimize iterations over the collection
    for (const value of classNames){
        // Exclude all falsy values, which leaves us with populated strings
        if (!value) continue;
        // a `value` can contain multiple classnames
        const list = value.split(' ');
        for (const className of list){
            /**
             * For atomic style classnames: the `key` is the `group`
             *
             * - Later atomic classnames with the same `group` will override earlier ones
             *   (which is what we want).
             * - Assumes atomic classnames are the only things that start with `_`
             * - Could use a regex to ensure that atomic classnames are structured how we expect,
             *   but did not add that for now as it did slow things down a bit.
             *
             * For other classnames: the `key` is the whole classname
             * - Okay to remove duplicates as doing so does not impact specificity
             *
             * */ const key = className.startsWith('_') ? className.slice(0, $d090f353cc560141$var$ATOMIC_GROUP_LENGTH) : className;
            map[key] = className;
        }
    }
    /**
     * We are converting the `map` into a string.
     *
     * The simple way to do this would be `Object.values(map).join(' ')`.
     * However, the approach below performs 10%-20% better in benchmarks.
     *
     * For `ax()` it feels right to squeeze as much runtime performance out as we can.
     */ let result = '';
    for(const key in map)result += map[key] + ' ';
    // If we have an empty string, then our `map` was empty.
    if (!result) return;
    // remove last " " from the result (we added " " at the end of every value)
    return result.trimEnd();
}

});

parcelRegister("6o2jv", function(module, exports) {
$parcel$export(module.exports, "THEME_DATA_ATTRIBUTE", () => $4a66c7671722008d$export$4ef52930e33717cd);
$parcel$export(module.exports, "SUBTREE_THEME_ATTRIBUTE", () => $4a66c7671722008d$export$cb374d25ded7f6ab);
$parcel$export(module.exports, "COLOR_MODE_ATTRIBUTE", () => $4a66c7671722008d$export$a00eac3f8684bcd0);
$parcel$export(module.exports, "CONTRAST_MODE_ATTRIBUTE", () => $4a66c7671722008d$export$2112803007239c61);
$parcel$export(module.exports, "CUSTOM_THEME_ATTRIBUTE", () => $4a66c7671722008d$export$352e418ed5b6193a);
var $4a66c7671722008d$export$4ef52930e33717cd = 'data-theme';
var $4a66c7671722008d$export$cb374d25ded7f6ab = 'data-subtree-theme';
var $4a66c7671722008d$export$a00eac3f8684bcd0 = 'data-color-mode';
var $4a66c7671722008d$export$2112803007239c61 = 'data-contrast-mode';
var $4a66c7671722008d$export$352e418ed5b6193a = 'data-custom-theme';
var $4a66c7671722008d$export$6f0c6fb8c80fcc92 = 'ds';
var $4a66c7671722008d$export$4d0c7bbf80185957 = [
    'opacity',
    'font',
    'space',
    'border',
    'radius'
];
var $4a66c7671722008d$export$dddac1532e822863 = "--".concat($4a66c7671722008d$export$6f0c6fb8c80fcc92, "-token-not-found");
var $4a66c7671722008d$export$9d7b58831ae93caa = "--".concat($4a66c7671722008d$export$6f0c6fb8c80fcc92, "-elevation-surface-current");

});

parcelRegister("ltcA1", function(module, exports) {
$parcel$export(module.exports, "themeStateDefaults", () => $fa16108669e2223b$export$9aedcfa7336a207);

var $780Jk = parcelRequire("780Jk");
/**
 * Can't evaluate typography feature flags at the module level,
 * it will always resolve to false when server side rendered or when flags are loaded async.
 */ function $fa16108669e2223b$var$getShapeDefault() {
    if ((0, $780Jk.fg)('platform-dst-shape-theme-default')) return 'shape';
    return undefined;
}
function $fa16108669e2223b$var$getMotionDefault() {
    if ((0, $780Jk.fg)('platform-dst-motion-theme-default')) return 'motion';
    return undefined;
}
var $fa16108669e2223b$export$9aedcfa7336a207 = {
    colorMode: 'auto',
    contrastMode: 'auto',
    dark: 'dark',
    light: 'light',
    shape: $fa16108669e2223b$var$getShapeDefault,
    spacing: 'spacing',
    typography: 'typography',
    motion: $fa16108669e2223b$var$getMotionDefault,
    UNSAFE_themeOptions: undefined
};

});
parcelRegister("780Jk", function(module, exports) {
$parcel$export(module.exports, "fg", () => $5309d8b899e5199a$export$b40ec24ac8275656);

var $ajSjs = parcelRequire("ajSjs");
function $5309d8b899e5199a$export$ba05d765b8392e5e(flagResolver) {
    (0, $ajSjs.setBooleanResolver)(flagResolver);
}
function $5309d8b899e5199a$export$470e5c2be1411c89(name) {
    return (0, $ajSjs.resolveBooleanFlag)(name);
}
function $5309d8b899e5199a$export$b40ec24ac8275656(name) {
    return (0, $ajSjs.resolveBooleanFlag)(name);
}

});
parcelRegister("ajSjs", function(module, exports) {
$parcel$export(module.exports, "setBooleanResolver", () => $7835cf1f4816dbe6$export$f2b591175b3e424c);
$parcel$export(module.exports, "resolveBooleanFlag", () => $7835cf1f4816dbe6$export$6333b6aff9fc6275);

var $ISKn7 = parcelRequire("ISKn7");

var $BQskI = parcelRequire("BQskI");

var $3ZMUU = parcelRequire("3ZMUU");
var $7835cf1f4816dbe6$var$pkgName = '@atlaskit/platform-feature-flags';
var $7835cf1f4816dbe6$export$7e41b1b2bdee3f98 = '__PLATFORM_FEATURE_FLAGS__';
var $7835cf1f4816dbe6$var$hasProcessEnv = typeof $3ZMUU !== 'undefined' && typeof $3ZMUU.env !== 'undefined';
// FF global overrides can be configured by test runners or Storybook
var $7835cf1f4816dbe6$var$ENV_ENABLE_PLATFORM_FF = $7835cf1f4816dbe6$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
// STORYBOOK_ENABLE_PLATFORM_FF is included as storybook only allows env vars prefixed with STORYBOOK
// https://github.com/storybookjs/storybook/issues/12270
var $7835cf1f4816dbe6$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF = $7835cf1f4816dbe6$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
var $7835cf1f4816dbe6$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE = $7835cf1f4816dbe6$var$ENV_ENABLE_PLATFORM_FF || $7835cf1f4816dbe6$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF;
var $7835cf1f4816dbe6$var$DEFAULT_PFF_GLOBAL = {
    booleanResolver: undefined
};
var $7835cf1f4816dbe6$var$globalVar = typeof window !== 'undefined' ? window : globalThis;
$7835cf1f4816dbe6$var$globalVar[$7835cf1f4816dbe6$export$7e41b1b2bdee3f98] = $7835cf1f4816dbe6$var$globalVar[$7835cf1f4816dbe6$export$7e41b1b2bdee3f98] || $7835cf1f4816dbe6$var$DEFAULT_PFF_GLOBAL;
function $7835cf1f4816dbe6$export$f2b591175b3e424c(resolver) {
    $7835cf1f4816dbe6$var$globalVar[$7835cf1f4816dbe6$export$7e41b1b2bdee3f98].booleanResolver = resolver;
}
function $7835cf1f4816dbe6$export$6333b6aff9fc6275(flagKey) {
    if ($7835cf1f4816dbe6$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE) {
        (0, $BQskI.debug)('[%s]: The feature flags were enabled while running tests. The flag "%s" will be always enabled.', $7835cf1f4816dbe6$var$pkgName, flagKey);
        return true;
    }
    try {
        var _globalVar$PFF_GLOBAL, _globalVar$PFF_GLOBAL2, _globalVar$PFF_GLOBAL3;
        // booleanResolver will be empty for products like Trello, Elevate, Recruit etc.
        // Currently only Confluence, Jira and Bitbucket has set it.
        if (((_globalVar$PFF_GLOBAL = $7835cf1f4816dbe6$var$globalVar[$7835cf1f4816dbe6$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL === void 0 ? void 0 : _globalVar$PFF_GLOBAL.booleanResolver) === undefined || ((_globalVar$PFF_GLOBAL2 = $7835cf1f4816dbe6$var$globalVar[$7835cf1f4816dbe6$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL2 === void 0 ? void 0 : _globalVar$PFF_GLOBAL2.booleanResolver) === null) // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
        return (0, $ISKn7.default).checkGate(flagKey);
        var result = (_globalVar$PFF_GLOBAL3 = $7835cf1f4816dbe6$var$globalVar[$7835cf1f4816dbe6$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL3 === void 0 ? void 0 : _globalVar$PFF_GLOBAL3.booleanResolver(flagKey);
        if (typeof result !== 'boolean') {
            // eslint-disable-next-line no-console
            console.warn("".concat(flagKey, " resolved to a non-boolean value, returning false for safety"));
            return false;
        }
        return result;
    } catch (e) {
        return false;
    }
}

});
parcelRegister("ISKn7", function(module, exports) {
$parcel$export(module.exports, "default", () => $086e93c69a5d1ec0$export$2e2bcd8739ae039);
$parcel$export(module.exports, "CLIENT_VERSION", () => (parcelRequire("7HOhT")).CLIENT_VERSION);

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $25nEq = parcelRequire("25nEq");

var $5rlAb = parcelRequire("5rlAb");

var $7HOhT = parcelRequire("7HOhT");



var $hiARP = parcelRequire("hiARP");
var $086e93c69a5d1ec0$var$_FeatureGates;
/**
 * Access the FeatureGates object via the default export.
 * ```ts
 * import FeatureGates from '@atlaskit/feature-gate-js-client';
 * ```
 */ var $086e93c69a5d1ec0$var$FeatureGates = /*#__PURE__*/ function() {
    function FeatureGates() {
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, FeatureGates);
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(FeatureGates, null, [
        {
            key: "isGateExists",
            value: function isGateExists(gateName) {
                return this.client.isGateExist(gateName);
            }
        },
        {
            key: "isExperimentExists",
            value: function isExperimentExists(experimentName) {
                return this.client.isExperimentExist(experimentName);
            }
        }
    ]);
}();
$086e93c69a5d1ec0$var$_FeatureGates = $086e93c69a5d1ec0$var$FeatureGates;
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($086e93c69a5d1ec0$var$FeatureGates, "client", new (0, $5rlAb.Client)());
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($086e93c69a5d1ec0$var$FeatureGates, "hasCheckGateErrorOccurred", false);
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($086e93c69a5d1ec0$var$FeatureGates, "hasGetExperimentValueErrorOccurred", false);
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($086e93c69a5d1ec0$var$FeatureGates, "checkGate", function(gateName, options) {
    try {
        // Check if the CRITERION override mechanism is available
        if (typeof window !== 'undefined' && window.__CRITERION__ && typeof window.__CRITERION__.getFeatureFlagOverride === 'function') {
            // Attempt to retrieve an override value for the feature gate
            var overrideValue = window.__CRITERION__.getFeatureFlagOverride(gateName);
            // If an override value is found, return it immediately
            if (overrideValue !== undefined) return overrideValue;
        }
    } catch (error) {
        // Log the first occurrence of the error
        if (!$086e93c69a5d1ec0$var$_FeatureGates.hasCheckGateErrorOccurred) {
            // eslint-disable-next-line no-console
            console.warn({
                msg: 'An error has occurred checking the feature gate from criterion override. Only the first occurrence of this error is logged.',
                gateName: gateName,
                error: error
            });
            $086e93c69a5d1ec0$var$_FeatureGates.hasCheckGateErrorOccurred = true;
        }
    }
    // Proceed with the main logic if no override is found
    return $086e93c69a5d1ec0$var$_FeatureGates.client.checkGate(gateName, options);
});
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($086e93c69a5d1ec0$var$FeatureGates, "getExperimentValue", function(experimentName, parameterName, defaultValue, options) {
    try {
        // Check if the CRITERION override mechanism is available
        if (typeof window !== 'undefined' && window.__CRITERION__ && typeof window.__CRITERION__.getExperimentValueOverride === 'function') {
            var overrideValue = window.__CRITERION__.getExperimentValueOverride(experimentName, parameterName);
            if (overrideValue !== undefined && overrideValue !== null) return overrideValue;
        }
    } catch (error) {
        // Log the first occurrence of the error
        if (!$086e93c69a5d1ec0$var$_FeatureGates.hasGetExperimentValueErrorOccurred) {
            // eslint-disable-next-line no-console
            console.warn({
                msg: 'An error has occurred getting the experiment value from criterion override. Only the first occurrence of this error is logged.',
                experimentName: experimentName,
                defaultValue: defaultValue,
                options: options,
                error: error
            });
            $086e93c69a5d1ec0$var$_FeatureGates.hasGetExperimentValueErrorOccurred = true;
        }
        return defaultValue;
    }
    // Proceed with the main logic if no override is found
    return $086e93c69a5d1ec0$var$_FeatureGates.client.getExperimentValue(experimentName, parameterName, defaultValue, options);
});
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($086e93c69a5d1ec0$var$FeatureGates, "initializeCalled", $086e93c69a5d1ec0$var$_FeatureGates.client.initializeCalled.bind($086e93c69a5d1ec0$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($086e93c69a5d1ec0$var$FeatureGates, "initializeCompleted", $086e93c69a5d1ec0$var$_FeatureGates.client.initializeCompleted.bind($086e93c69a5d1ec0$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($086e93c69a5d1ec0$var$FeatureGates, "waitUntilInitializeCompleted", $086e93c69a5d1ec0$var$_FeatureGates.client.waitUntilInitializeCompleted.bind($086e93c69a5d1ec0$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($086e93c69a5d1ec0$var$FeatureGates, "initialize", $086e93c69a5d1ec0$var$_FeatureGates.client.initialize.bind($086e93c69a5d1ec0$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($086e93c69a5d1ec0$var$FeatureGates, "initializeWithProvider", $086e93c69a5d1ec0$var$_FeatureGates.client.initializeWithProvider.bind($086e93c69a5d1ec0$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($086e93c69a5d1ec0$var$FeatureGates, "initializeFromValues", $086e93c69a5d1ec0$var$_FeatureGates.client.initializeFromValues.bind($086e93c69a5d1ec0$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($086e93c69a5d1ec0$var$FeatureGates, "manuallyLogGateExposure", $086e93c69a5d1ec0$var$_FeatureGates.client.manuallyLogGateExposure.bind($086e93c69a5d1ec0$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($086e93c69a5d1ec0$var$FeatureGates, "getExperiment", $086e93c69a5d1ec0$var$_FeatureGates.client.getExperiment.bind($086e93c69a5d1ec0$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($086e93c69a5d1ec0$var$FeatureGates, "manuallyLogExperimentExposure", $086e93c69a5d1ec0$var$_FeatureGates.client.manuallyLogExperimentExposure.bind($086e93c69a5d1ec0$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($086e93c69a5d1ec0$var$FeatureGates, "manuallyLogLayerExposure", $086e93c69a5d1ec0$var$_FeatureGates.client.manuallyLogLayerExposure.bind($086e93c69a5d1ec0$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($086e93c69a5d1ec0$var$FeatureGates, "shutdownStatsig", $086e93c69a5d1ec0$var$_FeatureGates.client.shutdownStatsig.bind($086e93c69a5d1ec0$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($086e93c69a5d1ec0$var$FeatureGates, "overrideGate", $086e93c69a5d1ec0$var$_FeatureGates.client.overrideGate.bind($086e93c69a5d1ec0$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($086e93c69a5d1ec0$var$FeatureGates, "clearGateOverride", $086e93c69a5d1ec0$var$_FeatureGates.client.clearGateOverride.bind($086e93c69a5d1ec0$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($086e93c69a5d1ec0$var$FeatureGates, "overrideConfig", $086e93c69a5d1ec0$var$_FeatureGates.client.overrideConfig.bind($086e93c69a5d1ec0$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($086e93c69a5d1ec0$var$FeatureGates, "clearConfigOverride", $086e93c69a5d1ec0$var$_FeatureGates.client.clearConfigOverride.bind($086e93c69a5d1ec0$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($086e93c69a5d1ec0$var$FeatureGates, "setOverrides", $086e93c69a5d1ec0$var$_FeatureGates.client.setOverrides.bind($086e93c69a5d1ec0$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($086e93c69a5d1ec0$var$FeatureGates, "getOverrides", $086e93c69a5d1ec0$var$_FeatureGates.client.getOverrides.bind($086e93c69a5d1ec0$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($086e93c69a5d1ec0$var$FeatureGates, "clearAllOverrides", $086e93c69a5d1ec0$var$_FeatureGates.client.clearAllOverrides.bind($086e93c69a5d1ec0$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($086e93c69a5d1ec0$var$FeatureGates, "isCurrentUser", $086e93c69a5d1ec0$var$_FeatureGates.client.isCurrentUser.bind($086e93c69a5d1ec0$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($086e93c69a5d1ec0$var$FeatureGates, "onGateUpdated", $086e93c69a5d1ec0$var$_FeatureGates.client.onGateUpdated.bind($086e93c69a5d1ec0$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($086e93c69a5d1ec0$var$FeatureGates, "onExperimentValueUpdated", $086e93c69a5d1ec0$var$_FeatureGates.client.onExperimentValueUpdated.bind($086e93c69a5d1ec0$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($086e93c69a5d1ec0$var$FeatureGates, "onAnyUpdated", $086e93c69a5d1ec0$var$_FeatureGates.client.onAnyUpdated.bind($086e93c69a5d1ec0$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($086e93c69a5d1ec0$var$FeatureGates, "updateUser", $086e93c69a5d1ec0$var$_FeatureGates.client.updateUser.bind($086e93c69a5d1ec0$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($086e93c69a5d1ec0$var$FeatureGates, "updateUserWithProvider", $086e93c69a5d1ec0$var$_FeatureGates.client.updateUserWithProvider.bind($086e93c69a5d1ec0$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($086e93c69a5d1ec0$var$FeatureGates, "updateUserWithValues", $086e93c69a5d1ec0$var$_FeatureGates.client.updateUserWithValues.bind($086e93c69a5d1ec0$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($086e93c69a5d1ec0$var$FeatureGates, "getPackageVersion", $086e93c69a5d1ec0$var$_FeatureGates.client.getPackageVersion.bind($086e93c69a5d1ec0$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($086e93c69a5d1ec0$var$FeatureGates, "getTargetApp", $086e93c69a5d1ec0$var$_FeatureGates.client.getTargetApp.bind($086e93c69a5d1ec0$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($086e93c69a5d1ec0$var$FeatureGates, "getLayer", $086e93c69a5d1ec0$var$_FeatureGates.client.getLayer.bind($086e93c69a5d1ec0$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($086e93c69a5d1ec0$var$FeatureGates, "getLayerValue", $086e93c69a5d1ec0$var$_FeatureGates.client.getLayerValue.bind($086e93c69a5d1ec0$var$_FeatureGates.client));
var $086e93c69a5d1ec0$var$boundFGJS = $086e93c69a5d1ec0$var$FeatureGates;
// This makes it possible to get a reference to the FeatureGates client at runtime.
// This is important for overriding values in Cypress tests, as there needs to be a
// way to get the exact instance for a window in order to mock some of its methods.
if (typeof window !== 'undefined') {
    if (window.__FEATUREGATES_JS__ === undefined) window.__FEATUREGATES_JS__ = $086e93c69a5d1ec0$var$FeatureGates;
    else {
        var $086e93c69a5d1ec0$var$_boundFGJS, $086e93c69a5d1ec0$var$_boundFGJS$getPackage;
        $086e93c69a5d1ec0$var$boundFGJS = window.__FEATUREGATES_JS__;
        var $086e93c69a5d1ec0$var$boundVersion = (($086e93c69a5d1ec0$var$_boundFGJS = $086e93c69a5d1ec0$var$boundFGJS) === null || $086e93c69a5d1ec0$var$_boundFGJS === void 0 || ($086e93c69a5d1ec0$var$_boundFGJS$getPackage = $086e93c69a5d1ec0$var$_boundFGJS.getPackageVersion) === null || $086e93c69a5d1ec0$var$_boundFGJS$getPackage === void 0 ? void 0 : $086e93c69a5d1ec0$var$_boundFGJS$getPackage.call($086e93c69a5d1ec0$var$_boundFGJS)) || '4.10.0 or earlier';
        if ($086e93c69a5d1ec0$var$boundVersion !== (0, $7HOhT.CLIENT_VERSION)) {
            var $086e93c69a5d1ec0$var$message = "Multiple versions of FeatureGateClients found on the current page.\n      The currently bound version is ".concat($086e93c69a5d1ec0$var$boundVersion, " when module version ").concat((0, $7HOhT.CLIENT_VERSION), " was loading.");
            // eslint-disable-next-line no-console
            console.warn($086e93c69a5d1ec0$var$message);
        }
    }
}
var /**
 * @property {FeatureGates} FeatureGate default export
 */ $086e93c69a5d1ec0$export$2e2bcd8739ae039 = $086e93c69a5d1ec0$var$boundFGJS;

});
parcelRegister("5rlAb", function(module, exports) {
$parcel$export(module.exports, "Client", () => $3f603739ccb347dd$export$1f2bb630327ac4b6);

var $1Vcia = parcelRequire("1Vcia");

var $iYJcE = parcelRequire("iYJcE");

var $fL8KA = parcelRequire("fL8KA");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $25nEq = parcelRequire("25nEq");

var $6HG4S = parcelRequire("6HG4S");

var $a0vkc = parcelRequire("a0vkc");

var $5sFjq = parcelRequire("5sFjq");

var $kkQZA = parcelRequire("kkQZA");

var $eVlof = parcelRequire("eVlof");

var $48eYA = parcelRequire("48eYA");

var $hzt3R = parcelRequire("hzt3R");

var $2usPa = parcelRequire("2usPa");

var $j3SRh = parcelRequire("j3SRh");

var $hiARP = parcelRequire("hiARP");

var $gIeKg = parcelRequire("gIeKg");

var $7HOhT = parcelRequire("7HOhT");
var $3f603739ccb347dd$var$_excluded = [
    "sdkKey",
    "environment",
    "updateUserCompletionCallback",
    "perimeter"
];
function $3f603739ccb347dd$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $3f603739ccb347dd$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $3f603739ccb347dd$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $3f603739ccb347dd$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $3f603739ccb347dd$var$DEFAULT_CLIENT_KEY = 'client-default-key';
// default event logging api is Atlassian proxy rather than Statsig's domain, to avoid ad blockers
var $3f603739ccb347dd$var$DEFAULT_EVENT_LOGGING_API = 'https://xp.atlassian.com/v1/rgstr';
var $3f603739ccb347dd$export$1f2bb630327ac4b6 = /*#__PURE__*/ function() {
    function Client() {
        var _this = this;
        var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, _ref$localStorageKey = _ref.localStorageKey, localStorageKey = _ref$localStorageKey === void 0 ? (0, $j3SRh.LOCAL_STORAGE_KEY) : _ref$localStorageKey, overrideAdapter = _ref.overrideAdapter;
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, Client);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "initPromise", null);
        /** True if an initialize method was called and completed successfully. */ (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "initCompleted", false);
        /**
     * True if an initialize method was called and completed, meaning the client is now usable.
     * However if there was an error during initialization it may have initialized with default
     * values. Use {@link initCompleted} to check for this.
     */ (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "initWithDefaults", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "hasCheckGateErrorOccurred", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "hasGetExperimentErrorOccurred", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "hasGetExperimentValueErrorOccurred", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "hasGetLayerErrorOccurred", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "hasGetLayerValueErrorOccurred", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "subscriptions", new (0, $5sFjq.default)());
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "dataAdapter", new (0, $2usPa.NoFetchDataAdapter)());
        /**
     * Call this if modifying the values being served by the Statsig library since it has its own
     * memoization cache which will not be updated if the values are changed outside of the library.
     */ (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "statsigValuesUpdated", function() {
            if (_this.user) // Trigger a reset of the memoize cache
            _this.statsigClient.updateUserSync(_this.user, {
                disableBackgroundCacheRefresh: true
            });
            _this.subscriptions.anyUpdated();
        });
        this.overrideAdapter = overrideAdapter || new (0, $j3SRh.PersistentOverrideAdapter)(localStorageKey);
    }
    /**
   * @description
   * This method initializes the client using a network call to fetch the bootstrap values.
   * If the client is inialized with an `analyticsWebClient`, it will send an operational event
   * to GASv3 with the following attributes:
   * - targetApp: the target app of the client
   * - clientVersion: the version of the client
   * - success: whether the initialization was successful
   * - startTime: the time when the initialization started
   * - totalTime: the total time it took to initialize the client
   * - apiKey: the api key used to initialize the client
   * @param clientOptions {ClientOptions}
   * @param identifiers {Identifiers}
   * @param customAttributes {CustomAttributes}
   * @returns {Promise<void>}
   */ return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(Client, [
        {
            key: "initialize",
            value: function() {
                var _initialize = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee(clientOptions, identifiers, customAttributes) {
                    var _this2 = this;
                    var clientOptionsWithDefaults, startTime;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                clientOptionsWithDefaults = (0, $gIeKg.getOptionsWithDefaults)(clientOptions);
                                if (!this.initPromise) {
                                    _context.next = 1;
                                    break;
                                }
                                if (!(0, $gIeKg.shallowEquals)(clientOptionsWithDefaults, this.initOptions)) // eslint-disable-next-line no-console
                                console.warn('Feature Gates client already initialized with different options. New options were not applied.');
                                return _context.abrupt("return", this.initPromise);
                            case 1:
                                startTime = performance.now();
                                this.initOptions = clientOptionsWithDefaults;
                                this.initPromise = this.init(clientOptionsWithDefaults, identifiers, customAttributes).then(function() {
                                    _this2.initCompleted = true;
                                    _this2.initWithDefaults = true;
                                }).finally(function() {
                                    var endTime = performance.now();
                                    var totalTime = endTime - startTime;
                                    _this2.fireClientEvent(startTime, totalTime, 'initialize', _this2.initCompleted, clientOptionsWithDefaults.apiKey);
                                });
                                return _context.abrupt("return", this.initPromise);
                            case 2:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee, this);
                }));
                function initialize(_x, _x2, _x3) {
                    return _initialize.apply(this, arguments);
                }
                return initialize;
            }()
        },
        {
            key: "initializeWithProvider",
            value: function() {
                var _initializeWithProvider = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee2(clientOptions, provider, identifiers, customAttributes) {
                    var _this3 = this;
                    var clientOptionsWithDefaults, startTime;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                clientOptionsWithDefaults = (0, $gIeKg.getOptionsWithDefaults)(clientOptions);
                                if (!this.initPromise) {
                                    _context2.next = 1;
                                    break;
                                }
                                if (!(0, $gIeKg.shallowEquals)(clientOptionsWithDefaults, this.initOptions)) // eslint-disable-next-line no-console
                                console.warn('Feature Gates client already initialized with different options. New options were not applied.');
                                return _context2.abrupt("return", this.initPromise);
                            case 1:
                                startTime = performance.now();
                                this.initOptions = clientOptionsWithDefaults;
                                this.provider = provider;
                                this.provider.setClientVersion((0, $7HOhT.CLIENT_VERSION));
                                if (this.provider.setApplyUpdateCallback) this.provider.setApplyUpdateCallback(this.applyUpdateCallback.bind(this));
                                this.initPromise = this.initWithProvider(clientOptionsWithDefaults, provider, identifiers, customAttributes).then(function() {
                                    _this3.initCompleted = true;
                                    _this3.initWithDefaults = true;
                                }).finally(function() {
                                    var endTime = performance.now();
                                    var totalTime = endTime - startTime;
                                    _this3.fireClientEvent(startTime, totalTime, 'initializeWithProvider', _this3.initCompleted, provider.getApiKey ? provider.getApiKey() : undefined);
                                });
                                return _context2.abrupt("return", this.initPromise);
                            case 2:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2, this);
                }));
                function initializeWithProvider(_x4, _x5, _x6, _x7) {
                    return _initializeWithProvider.apply(this, arguments);
                }
                return initializeWithProvider;
            }()
        },
        {
            key: "applyUpdateCallback",
            value: function applyUpdateCallback(experimentsResult) {
                try {
                    if (this.initCompleted || this.initWithDefaults) {
                        this.assertInitialized(this.statsigClient);
                        this.dataAdapter.setBootstrapData(experimentsResult.experimentValues);
                        this.dataAdapter.setData(JSON.stringify(experimentsResult.experimentValues));
                        this.statsigValuesUpdated();
                    }
                } catch (error) {
                    // eslint-disable-next-line no-console
                    console.warn('Error when attempting to apply update', error);
                }
            }
        },
        {
            key: "fireClientEvent",
            value: function fireClientEvent(startTime, totalTime, action, success) {
                var _analyticsWebClient, _this4 = this;
                var apiKey = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
                (_analyticsWebClient = this.initOptions.analyticsWebClient) === null || _analyticsWebClient === void 0 || _analyticsWebClient.then(function(analyticsWebClient) {
                    var attributes = $3f603739ccb347dd$var$_objectSpread({
                        targetApp: _this4.initOptions.targetApp,
                        clientVersion: (0, $7HOhT.CLIENT_VERSION),
                        success: success,
                        startTime: startTime,
                        totalTime: totalTime
                    }, apiKey && {
                        apiKey: apiKey
                    });
                    analyticsWebClient.sendOperationalEvent({
                        action: action,
                        actionSubject: 'featureGatesClient',
                        attributes: attributes,
                        tags: [
                            'measurement'
                        ],
                        source: '@atlaskit/feature-gate-js-client'
                    });
                }).catch(function(err) {
                    if (_this4.initOptions.environment !== (0, $hiARP.FeatureGateEnvironment).Production) // eslint-disable-next-line no-console
                    console.error('Analytics web client promise did not resolve', err);
                });
            }
        },
        {
            key: "initializeFromValues",
            value: function() {
                var _initializeFromValues = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee3(clientOptions, identifiers, customAttributes) {
                    var _this5 = this;
                    var initializeValues, clientOptionsWithDefaults, startTime, _args3 = arguments;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context3) {
                        while(true)switch(_context3.prev = _context3.next){
                            case 0:
                                initializeValues = _args3.length > 3 && _args3[3] !== undefined ? _args3[3] : {};
                                clientOptionsWithDefaults = (0, $gIeKg.getOptionsWithDefaults)(clientOptions);
                                if (!this.initPromise) {
                                    _context3.next = 1;
                                    break;
                                }
                                if (!(0, $gIeKg.shallowEquals)(clientOptionsWithDefaults, this.initOptions)) // eslint-disable-next-line no-console
                                console.warn('Feature Gates client already initialized with different options. New options were not applied.');
                                return _context3.abrupt("return", this.initPromise);
                            case 1:
                                // This makes sure the new Statsig client behaves like the old when bootstrap data is
                                // passed, and `has_updates` isn't specified (which happens a lot in product integration tests).
                                if (!Object.prototype.hasOwnProperty.call(initializeValues, 'has_updates')) initializeValues['has_updates'] = true;
                                startTime = performance.now();
                                this.initOptions = clientOptionsWithDefaults;
                                this.initPromise = this.initFromValues(clientOptionsWithDefaults, identifiers, customAttributes, initializeValues).then(function() {
                                    _this5.initCompleted = true;
                                    _this5.initWithDefaults = true;
                                }).finally(function() {
                                    var endTime = performance.now();
                                    var totalTime = endTime - startTime;
                                    _this5.fireClientEvent(startTime, totalTime, 'initializeFromValues', _this5.initCompleted);
                                });
                                return _context3.abrupt("return", this.initPromise);
                            case 2:
                            case "end":
                                return _context3.stop();
                        }
                    }, _callee3, this);
                }));
                function initializeFromValues(_x8, _x9, _x0) {
                    return _initializeFromValues.apply(this, arguments);
                }
                return initializeFromValues;
            }()
        },
        {
            key: "assertInitialized",
            value: function assertInitialized(statsigClient) {
                if (!statsigClient) throw new Error('Client must be initialized before using this method');
            }
        },
        {
            key: "updateUser",
            value: function() {
                var _updateUser = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee4(fetchOptions, identifiers, customAttributes) {
                    var fetchOptionsWithDefaults, initializeValuesProducer;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context4) {
                        while(true)switch(_context4.prev = _context4.next){
                            case 0:
                                this.assertInitialized(this.statsigClient);
                                fetchOptionsWithDefaults = (0, $gIeKg.getOptionsWithDefaults)(fetchOptions);
                                initializeValuesProducer = function initializeValuesProducer() {
                                    return (0, $hzt3R.default).fetchExperimentValues(fetchOptionsWithDefaults, identifiers, customAttributes).then(function(_ref2) {
                                        var experimentValues = _ref2.experimentValues, customAttributes = _ref2.customAttributes;
                                        return {
                                            experimentValues: experimentValues,
                                            customAttributesFromFetch: customAttributes
                                        };
                                    });
                                };
                                _context4.next = 1;
                                return this.updateUserUsingInitializeValuesProducer(initializeValuesProducer, identifiers, customAttributes);
                            case 1:
                            case "end":
                                return _context4.stop();
                        }
                    }, _callee4, this);
                }));
                function updateUser(_x1, _x10, _x11) {
                    return _updateUser.apply(this, arguments);
                }
                return updateUser;
            }()
        },
        {
            key: "updateUserWithProvider",
            value: function() {
                var _updateUserWithProvider = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee5(identifiers, customAttributes) {
                    var _this6 = this;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context5) {
                        while(true)switch(_context5.prev = _context5.next){
                            case 0:
                                this.assertInitialized(this.statsigClient);
                                if (this.provider) {
                                    _context5.next = 1;
                                    break;
                                }
                                throw new Error('Cannot update user using provider as the client was not initialised with a provider');
                            case 1:
                                _context5.next = 2;
                                return this.provider.setProfile(this.initOptions, identifiers, customAttributes);
                            case 2:
                                _context5.next = 3;
                                return this.updateUserUsingInitializeValuesProducer(function() {
                                    return _this6.provider.getExperimentValues();
                                }, identifiers, customAttributes);
                            case 3:
                            case "end":
                                return _context5.stop();
                        }
                    }, _callee5, this);
                }));
                function updateUserWithProvider(_x12, _x13) {
                    return _updateUserWithProvider.apply(this, arguments);
                }
                return updateUserWithProvider;
            }()
        },
        {
            key: "updateUserWithValues",
            value: function() {
                var _updateUserWithValues = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee6(identifiers, customAttributes) {
                    var initializeValues, initializeValuesProducer, _args6 = arguments;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context6) {
                        while(true)switch(_context6.prev = _context6.next){
                            case 0:
                                initializeValues = _args6.length > 2 && _args6[2] !== undefined ? _args6[2] : {};
                                this.assertInitialized(this.statsigClient);
                                initializeValuesProducer = function initializeValuesProducer() {
                                    return Promise.resolve({
                                        experimentValues: initializeValues,
                                        customAttributesFromFetch: customAttributes
                                    });
                                };
                                _context6.next = 1;
                                return this.updateUserUsingInitializeValuesProducer(initializeValuesProducer, identifiers, customAttributes);
                            case 1:
                            case "end":
                                return _context6.stop();
                        }
                    }, _callee6, this);
                }));
                function updateUserWithValues(_x14, _x15) {
                    return _updateUserWithValues.apply(this, arguments);
                }
                return updateUserWithValues;
            }()
        },
        {
            key: "initializeCalled",
            value: function initializeCalled() {
                return this.initPromise != null;
            }
        },
        {
            key: "initializeCompleted",
            value: function initializeCompleted() {
                return this.initCompleted;
            }
        },
        {
            key: "waitUntilInitializeCompleted",
            value: function() {
                var _waitUntilInitializeCompleted = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee7() {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context7) {
                        while(true)switch(_context7.prev = _context7.next){
                            case 0:
                                if (this.initPromise) {
                                    _context7.next = 1;
                                    break;
                                }
                                throw new Error('The client must be initialized before you can wait until initialized.');
                            case 1:
                                if (!this.initCompleted) {
                                    _context7.next = 2;
                                    break;
                                }
                                return _context7.abrupt("return");
                            case 2:
                                _context7.next = 3;
                                return this.initPromise;
                            case 3:
                            case "end":
                                return _context7.stop();
                        }
                    }, _callee7, this);
                }));
                function waitUntilInitializeCompleted() {
                    return _waitUntilInitializeCompleted.apply(this, arguments);
                }
                return waitUntilInitializeCompleted;
            }()
        },
        {
            key: "checkGate",
            value: function checkGate(gateName) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                try {
                    this.assertInitialized(this.statsigClient);
                    var _options$fireGateExpo = options.fireGateExposure, fireGateExposure = _options$fireGateExpo === void 0 ? true : _options$fireGateExpo;
                    return this.statsigClient.checkGate(gateName, {
                        disableExposureLog: !fireGateExposure
                    });
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!this.hasCheckGateErrorOccurred) {
                        // eslint-disable-next-line no-console
                        console.warn({
                            msg: 'An error has occurred checking the feature gate. Only the first occurrence of this error is logged.',
                            gateName: gateName,
                            error: error
                        });
                        this.hasCheckGateErrorOccurred = true;
                    }
                    return false;
                }
            }
        },
        {
            key: "isGateExist",
            value: function isGateExist(gateName) {
                try {
                    this.assertInitialized(this.statsigClient);
                    var gate = this.statsigClient.getFeatureGate(gateName, {
                        disableExposureLog: true
                    });
                    return !gate.details.reason.includes('Unrecognized');
                } catch (error) {
                    // eslint-disable-next-line no-console
                    console.error("Error occurred when trying to check FeatureGate: ".concat(error));
                    // in case of error report true to avoid false positives.
                    return true;
                }
            }
        },
        {
            key: "isExperimentExist",
            value: function isExperimentExist(experimentName) {
                try {
                    this.assertInitialized(this.statsigClient);
                    var config = this.statsigClient.getExperiment(experimentName, {
                        disableExposureLog: true
                    });
                    return !config.details.reason.includes('Unrecognized');
                } catch (error) {
                    // eslint-disable-next-line no-console
                    console.error("Error occurred when trying to check Experiment: ".concat(error));
                    // in case of error report true to avoid false positives.
                    return true;
                }
            }
        },
        {
            key: "manuallyLogGateExposure",
            value: function manuallyLogGateExposure(gateName) {
                this.assertInitialized(this.statsigClient);
                // This is the approach recommended in the docs
                // https://docs.statsig.com/client/javascript-sdk/#manual-exposures-
                this.statsigClient.checkGate(gateName);
            }
        },
        {
            key: "getExperiment",
            value: function getExperiment(experimentName) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                try {
                    this.assertInitialized(this.statsigClient);
                    var _options$fireExperime = options.fireExperimentExposure, fireExperimentExposure = _options$fireExperime === void 0 ? true : _options$fireExperime;
                    return (0, $kkQZA.DynamicConfig).fromExperiment(this.statsigClient.getExperiment(experimentName, {
                        disableExposureLog: !fireExperimentExposure
                    }));
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!this.hasGetExperimentErrorOccurred) {
                        // eslint-disable-next-line no-console
                        console.warn({
                            msg: 'An error has occurred getting the experiment. Only the first occurrence of this error is logged.',
                            experimentName: experimentName,
                            error: error
                        });
                        this.hasGetExperimentErrorOccurred = true;
                    }
                    // Return a default value
                    return new (0, $kkQZA.DynamicConfig)(experimentName, {}, '', {
                        time: Date.now(),
                        reason: (0, $48eYA.EvaluationReason).Error
                    });
                }
            }
        },
        {
            key: "getExperimentValue",
            value: function getExperimentValue(experimentName, parameterName, defaultValue) {
                var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var experiment = this.getExperiment(experimentName, options);
                try {
                    var typeGuard = options.typeGuard;
                    return experiment.get(parameterName, defaultValue, typeGuard);
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!this.hasGetExperimentValueErrorOccurred) {
                        // eslint-disable-next-line no-console
                        console.warn({
                            msg: 'An error has occurred getting the experiment value. Only the first occurrence of this error is logged.',
                            experimentName: experimentName,
                            defaultValue: defaultValue,
                            options: options,
                            error: error
                        });
                        this.hasGetExperimentValueErrorOccurred = true;
                    }
                    return defaultValue;
                }
            }
        },
        {
            key: "manuallyLogExperimentExposure",
            value: function manuallyLogExperimentExposure(experimentName) {
                this.assertInitialized(this.statsigClient);
                // This is the approach recommended in the docs
                // https://docs.statsig.com/client/javascript-sdk/#manual-exposures-
                this.statsigClient.getExperiment(experimentName);
            }
        },
        {
            key: "manuallyLogLayerExposure",
            value: function manuallyLogLayerExposure(layerName, parameterName) {
                var _this$statsigClient$g;
                this.assertInitialized(this.statsigClient);
                // This is the approach recommended in the docs
                // https://docs.statsig.com/client/javascript-sdk/#manual-exposures-
                (_this$statsigClient$g = this.statsigClient.getLayer(layerName)) === null || _this$statsigClient$g === void 0 || _this$statsigClient$g.get(parameterName);
            }
        },
        {
            key: "shutdownStatsig",
            value: function shutdownStatsig() {
                this.assertInitialized(this.statsigClient);
                this.statsigClient.shutdown();
            }
        },
        {
            key: "overrideGate",
            value: function overrideGate(gateName, value) {
                this.overrideAdapter.overrideGate(gateName, value);
                // Trigger a reset of the memoized gate value
                if (this.user) {
                    var _this$statsigClient;
                    (_this$statsigClient = this.statsigClient) === null || _this$statsigClient === void 0 || _this$statsigClient.updateUserSync(this.user, {
                        disableBackgroundCacheRefresh: true
                    });
                }
                this.statsigValuesUpdated();
            }
        },
        {
            key: "clearGateOverride",
            value: function clearGateOverride(gateName) {
                this.overrideAdapter.removeGateOverride(gateName);
                this.statsigValuesUpdated();
            }
        },
        {
            key: "overrideConfig",
            value: function overrideConfig(experimentName, values) {
                this.overrideAdapter.overrideDynamicConfig(experimentName, values);
                this.statsigValuesUpdated();
            }
        },
        {
            key: "clearConfigOverride",
            value: function clearConfigOverride(experimentName) {
                this.overrideAdapter.removeDynamicConfigOverride(experimentName);
                this.statsigValuesUpdated();
            }
        },
        {
            key: "setOverrides",
            value: function setOverrides(overrides) {
                this.overrideAdapter.setOverrides(overrides);
                this.statsigValuesUpdated();
            }
        },
        {
            key: "getOverrides",
            value: function getOverrides() {
                return this.overrideAdapter.getOverrides();
            }
        },
        {
            key: "clearAllOverrides",
            value: function clearAllOverrides() {
                this.overrideAdapter.removeAllOverrides();
                this.statsigValuesUpdated();
            }
        },
        {
            key: "isCurrentUser",
            value: function isCurrentUser(identifiers, customAttributes) {
                return (0, $gIeKg.shallowEquals)(this.currentIdentifiers, identifiers) && (0, $gIeKg.shallowEquals)(this.currentAttributes, customAttributes);
            }
        },
        {
            key: "onGateUpdated",
            value: function onGateUpdated(gateName, callback) {
                var _this7 = this;
                var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var wrapCallback = function wrapCallback(value) {
                    var _options$fireGateExpo2 = options.fireGateExposure, fireGateExposure = _options$fireGateExpo2 === void 0 ? true : _options$fireGateExpo2;
                    if (fireGateExposure) _this7.manuallyLogGateExposure(gateName);
                    try {
                        callback(value);
                    } catch (error) {
                        // eslint-disable-next-line no-console
                        console.warn("Error calling callback for gate ".concat(gateName, " with value ").concat(value), error);
                    }
                };
                return this.subscriptions.onGateUpdated(gateName, wrapCallback, this.checkGate.bind(this), options);
            }
        },
        {
            key: "onExperimentValueUpdated",
            value: function onExperimentValueUpdated(experimentName, parameterName, defaultValue, callback) {
                var _this8 = this;
                var options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
                var wrapCallback = function wrapCallback(value) {
                    var _options$fireExperime2 = options.fireExperimentExposure, fireExperimentExposure = _options$fireExperime2 === void 0 ? true : _options$fireExperime2;
                    if (fireExperimentExposure) _this8.manuallyLogExperimentExposure(experimentName);
                    try {
                        callback(value);
                    } catch (error) {
                        // eslint-disable-next-line no-console
                        console.warn("Error calling callback for experiment ".concat(experimentName, " with value ").concat(value), error);
                    }
                };
                return this.subscriptions.onExperimentValueUpdated(experimentName, parameterName, defaultValue, wrapCallback, this.getExperimentValue.bind(this), options);
            }
        },
        {
            key: "onAnyUpdated",
            value: function onAnyUpdated(callback) {
                return this.subscriptions.onAnyUpdated(callback);
            }
        },
        {
            key: "init",
            value: function() {
                var _init = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee8(clientOptions, identifiers, customAttributes) {
                    var fromValuesClientOptions, experimentValues, customAttributesFromResult, clientSdkKeyPromise, experimentValuesPromise, _yield$Promise$all, _yield$Promise$all2, experimentValuesResult, _t;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context8) {
                        while(true)switch(_context8.prev = _context8.next){
                            case 0:
                                fromValuesClientOptions = $3f603739ccb347dd$var$_objectSpread({}, clientOptions);
                                if (!clientOptions.localMode) {
                                    _context8.next = 2;
                                    break;
                                }
                                _context8.next = 1;
                                return this.initFromValues(fromValuesClientOptions, identifiers, customAttributes);
                            case 1:
                                return _context8.abrupt("return");
                            case 2:
                                _context8.prev = 2;
                                // If client sdk key fetch fails, an error would be thrown and handled instead of waiting for
                                // the experiment values request to be settled, and it will fall back to use default values.
                                clientSdkKeyPromise = (0, $hzt3R.default).fetchClientSdk(clientOptions).then(function(value) {
                                    return fromValuesClientOptions.sdkKey = value.clientSdkKey;
                                });
                                experimentValuesPromise = (0, $hzt3R.default).fetchExperimentValues(clientOptions, identifiers, customAttributes); // Only wait for the experiment values request to finish and try to initialise the client
                                // with experiment values if both requests are successful. Else an error would be thrown and
                                // handled by the catch
                                _context8.next = 3;
                                return Promise.all([
                                    clientSdkKeyPromise,
                                    experimentValuesPromise
                                ]);
                            case 3:
                                _yield$Promise$all = _context8.sent;
                                _yield$Promise$all2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_yield$Promise$all, 2);
                                experimentValuesResult = _yield$Promise$all2[1];
                                experimentValues = experimentValuesResult.experimentValues;
                                customAttributesFromResult = experimentValuesResult.customAttributes;
                                _context8.next = 6;
                                break;
                            case 4:
                                _context8.prev = 4;
                                _t = _context8["catch"](2);
                                if (_t instanceof Error) // eslint-disable-next-line no-console
                                console.error("Error occurred when trying to fetch the Feature Gates client values, error: ".concat(_t === null || _t === void 0 ? void 0 : _t.message));
                                // eslint-disable-next-line no-console
                                console.warn("Initialising Statsig client without values");
                                _context8.next = 5;
                                return this.initFromValues(fromValuesClientOptions, identifiers, customAttributes);
                            case 5:
                                throw _t;
                            case 6:
                                return _context8.abrupt("return", this.initFromValues(fromValuesClientOptions, identifiers, customAttributesFromResult, experimentValues));
                            case 7:
                            case "end":
                                return _context8.stop();
                        }
                    }, _callee8, this, [
                        [
                            2,
                            4
                        ]
                    ]);
                }));
                function init(_x16, _x17, _x18) {
                    return _init.apply(this, arguments);
                }
                return init;
            }()
        },
        {
            key: "initWithProvider",
            value: function() {
                var _initWithProvider = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee9(baseClientOptions, provider, identifiers, customAttributes) {
                    var fromValuesClientOptions, experimentValues, customAttributesFromResult, clientSdkKeyPromise, experimentValuesPromise, _yield$Promise$all3, _yield$Promise$all4, experimentValuesResult, _t2;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context9) {
                        while(true)switch(_context9.prev = _context9.next){
                            case 0:
                                fromValuesClientOptions = $3f603739ccb347dd$var$_objectSpread($3f603739ccb347dd$var$_objectSpread({}, baseClientOptions), {}, {
                                    disableCurrentPageLogging: true
                                });
                                _context9.prev = 1;
                                _context9.next = 2;
                                return provider.setProfile(baseClientOptions, identifiers, customAttributes);
                            case 2:
                                // If client sdk key fetch fails, an error would be thrown and handled instead of waiting for
                                // the experiment values request to be settled, and it will fall back to use default values.
                                clientSdkKeyPromise = provider.getClientSdkKey().then(function(value) {
                                    return fromValuesClientOptions.sdkKey = value;
                                });
                                experimentValuesPromise = provider.getExperimentValues(); // Only wait for the experiment values request to finish and try to initialise the client
                                // with experiment values if both requests are successful. Else an error would be thrown and
                                // handled by the catch
                                _context9.next = 3;
                                return Promise.all([
                                    clientSdkKeyPromise,
                                    experimentValuesPromise
                                ]);
                            case 3:
                                _yield$Promise$all3 = _context9.sent;
                                _yield$Promise$all4 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_yield$Promise$all3, 2);
                                experimentValuesResult = _yield$Promise$all4[1];
                                experimentValues = experimentValuesResult.experimentValues;
                                customAttributesFromResult = experimentValuesResult.customAttributesFromFetch;
                                _context9.next = 6;
                                break;
                            case 4:
                                _context9.prev = 4;
                                _t2 = _context9["catch"](1);
                                if (_t2 instanceof Error) // eslint-disable-next-line no-console
                                console.error("Error occurred when trying to fetch the Feature Gates client values, error: ".concat(_t2 === null || _t2 === void 0 ? void 0 : _t2.message));
                                // eslint-disable-next-line no-console
                                console.warn("Initialising Statsig client without values");
                                _context9.next = 5;
                                return this.initFromValues(fromValuesClientOptions, identifiers, customAttributes);
                            case 5:
                                throw _t2;
                            case 6:
                                return _context9.abrupt("return", this.initFromValues(fromValuesClientOptions, identifiers, customAttributesFromResult, experimentValues));
                            case 7:
                            case "end":
                                return _context9.stop();
                        }
                    }, _callee9, this, [
                        [
                            1,
                            4
                        ]
                    ]);
                }));
                function initWithProvider(_x19, _x20, _x21, _x22) {
                    return _initWithProvider.apply(this, arguments);
                }
                return initWithProvider;
            }()
        },
        {
            key: "initFromValues",
            value: function() {
                var _initFromValues = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee0(clientOptions, identifiers, customAttributes) {
                    var _newClientOptions$net;
                    var initializeValues, newClientOptions, sdkKey, environment, _updateUserCompletionCallback, _perimeter, restClientOptions, frontendUser, statsigOptions, _args0 = arguments, _t3;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context0) {
                        while(true)switch(_context0.prev = _context0.next){
                            case 0:
                                initializeValues = _args0.length > 3 && _args0[3] !== undefined ? _args0[3] : {};
                                this.overrideAdapter.initFromStoredOverrides();
                                this.currentIdentifiers = identifiers;
                                this.currentAttributes = customAttributes;
                                newClientOptions = (0, $gIeKg.migrateInitializationOptions)(clientOptions);
                                if (!newClientOptions.sdkKey) newClientOptions.sdkKey = $3f603739ccb347dd$var$DEFAULT_CLIENT_KEY;
                                if (!((_newClientOptions$net = newClientOptions.networkConfig) !== null && _newClientOptions$net !== void 0 && _newClientOptions$net.logEventUrl)) newClientOptions.networkConfig = $3f603739ccb347dd$var$_objectSpread($3f603739ccb347dd$var$_objectSpread({}, newClientOptions.networkConfig), {}, {
                                    logEventUrl: $3f603739ccb347dd$var$DEFAULT_EVENT_LOGGING_API
                                });
                                if (newClientOptions.perimeter === (0, $hiARP.PerimeterType).FEDRAMP_MODERATE) // disable all logging in FedRAMP to prevent egress of sensitive data
                                newClientOptions.disableLogging = true;
                                sdkKey = newClientOptions.sdkKey, environment = newClientOptions.environment, _updateUserCompletionCallback = newClientOptions.updateUserCompletionCallback, _perimeter = newClientOptions.perimeter, restClientOptions = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(newClientOptions, $3f603739ccb347dd$var$_excluded);
                                frontendUser = (0, $gIeKg.toStatsigUser)(identifiers, customAttributes);
                                this.user = (0, $gIeKg.deepAssign)({}, initializeValues.user, frontendUser);
                                statsigOptions = $3f603739ccb347dd$var$_objectSpread($3f603739ccb347dd$var$_objectSpread({}, restClientOptions), {}, {
                                    environment: {
                                        tier: environment
                                    },
                                    includeCurrentPageUrlWithEvents: false,
                                    dataAdapter: this.dataAdapter,
                                    overrideAdapter: this.overrideAdapter,
                                    logEventCompressionMode: (0, $a0vkc.LogEventCompressionMode).Forced
                                }); // Statsig validates the provided stableId against their own cookie, so we either need
                                // to update the cookie to match, or disable the validation completely.
                                if (identifiers.stableId) (0, $a0vkc.StableID).setOverride(identifiers.stableId, sdkKey);
                                else statsigOptions.disableStableID = true;
                                _context0.prev = 1;
                                this.statsigClient = new (0, $a0vkc.StatsigClient)(sdkKey, this.user, statsigOptions);
                                this.dataAdapter.setBootstrapData(initializeValues);
                                _context0.next = 2;
                                return this.statsigClient.initializeAsync();
                            case 2:
                                _context0.next = 5;
                                break;
                            case 3:
                                _context0.prev = 3;
                                _t3 = _context0["catch"](1);
                                if (_t3 instanceof Error) // eslint-disable-next-line no-console
                                console.error("Error occurred when trying to initialise the Statsig client, error: ".concat(_t3 === null || _t3 === void 0 ? void 0 : _t3.message));
                                // eslint-disable-next-line no-console
                                console.warn("Initialising Statsig client with default sdk key and without values");
                                this.statsigClient = new (0, $a0vkc.StatsigClient)($3f603739ccb347dd$var$DEFAULT_CLIENT_KEY, this.user, statsigOptions);
                                this.dataAdapter.setBootstrapData();
                                _context0.next = 4;
                                return this.statsigClient.initializeAsync();
                            case 4:
                                this.initWithDefaults = true;
                                throw _t3;
                            case 5:
                            case "end":
                                return _context0.stop();
                        }
                    }, _callee0, this, [
                        [
                            1,
                            3
                        ]
                    ]);
                }));
                function initFromValues(_x23, _x24, _x25) {
                    return _initFromValues.apply(this, arguments);
                }
                return initFromValues;
            }()
        },
        {
            key: "updateUserUsingInitializeValuesProducer",
            value: function() {
                var _updateUserUsingInitializeValuesProducer = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee10(getInitializeValues, identifiers, customAttributes) {
                    var _this9 = this;
                    var originalInitPromise, initializeValuesPromise, updateUserPromise, _t4;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context10) {
                        while(true)switch(_context10.prev = _context10.next){
                            case 0:
                                this.assertInitialized(this.statsigClient);
                                if (this.initPromise) {
                                    _context10.next = 1;
                                    break;
                                }
                                throw new Error('The client must be initialized before you can update the user.');
                            case 1:
                                if (!this.isCurrentUser(identifiers, customAttributes)) {
                                    _context10.next = 2;
                                    break;
                                }
                                return _context10.abrupt("return", this.initPromise);
                            case 2:
                                // Wait for the current initialize/update to finish
                                originalInitPromise = this.initPromise;
                                _context10.prev = 3;
                                _context10.next = 4;
                                return this.initPromise;
                            case 4:
                                _context10.next = 6;
                                break;
                            case 5:
                                _context10.prev = 5;
                                _t4 = _context10["catch"](3);
                            case 6:
                                initializeValuesPromise = getInitializeValues();
                                updateUserPromise = this.updateStatsigClientUser(initializeValuesPromise, identifiers, customAttributes); // We replace the init promise here since we are essentially re-initializing the client at this
                                // point. Any subsequent calls to await client.initialize() or client.updateUser()
                                // will now also await this user update.
                                this.initPromise = updateUserPromise.catch(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee1() {
                                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context1) {
                                        while(true)switch(_context1.prev = _context1.next){
                                            case 0:
                                                // If the update failed then it changed nothing, so revert back to the original promise.
                                                _this9.initPromise = originalInitPromise;
                                                // Set the user profile again to revert back to the current user
                                                if (!_this9.provider) {
                                                    _context1.next = 1;
                                                    break;
                                                }
                                                _context1.next = 1;
                                                return _this9.provider.setProfile(_this9.initOptions, _this9.currentIdentifiers, _this9.currentAttributes);
                                            case 1:
                                            case "end":
                                                return _context1.stop();
                                        }
                                    }, _callee1);
                                })));
                                return _context10.abrupt("return", updateUserPromise);
                            case 7:
                            case "end":
                                return _context10.stop();
                        }
                    }, _callee10, this, [
                        [
                            3,
                            5
                        ]
                    ]);
                }));
                function updateUserUsingInitializeValuesProducer(_x26, _x27, _x28) {
                    return _updateUserUsingInitializeValuesProducer.apply(this, arguments);
                }
                return updateUserUsingInitializeValuesProducer;
            }()
        },
        {
            key: "updateStatsigClientUser",
            value: function() {
                var _updateStatsigClientUser = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee11(initializeValuesPromise, identifiers, customAttributes) {
                    var _this$initOptions, _this$initOptions$upd;
                    var initializeValues, user, frontendUser, _updateUserCompletion, _ref4, errMsg, success, errorMessage, _t5, _t6;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context11) {
                        while(true)switch(_context11.prev = _context11.next){
                            case 0:
                                this.assertInitialized(this.statsigClient);
                                _context11.prev = 1;
                                _context11.next = 2;
                                return initializeValuesPromise;
                            case 2:
                                initializeValues = _context11.sent;
                                frontendUser = (0, $gIeKg.toStatsigUser)(identifiers, initializeValues.customAttributesFromFetch);
                                user = (0, $gIeKg.deepAssign)({}, initializeValues.experimentValues.user, frontendUser);
                                _context11.next = 4;
                                break;
                            case 3:
                                _context11.prev = 3;
                                _t5 = _context11["catch"](1);
                                // Make sure the updateUserCompletionCallback is called for any errors in our custom code.
                                // This is not necessary for the updateUserWithValues call, because the Statsig client will
                                // already invoke the callback itself.
                                errMsg = _t5 instanceof Error ? _t5.message : JSON.stringify(_t5);
                                (_updateUserCompletion = (_ref4 = this.initOptions).updateUserCompletionCallback) === null || _updateUserCompletion === void 0 || _updateUserCompletion.call(_ref4, false, errMsg);
                                throw _t5;
                            case 4:
                                success = true;
                                errorMessage = null;
                                _context11.prev = 5;
                                this.dataAdapter.setBootstrapData(initializeValues.experimentValues);
                                this.user = user;
                                if (!this.user) {
                                    _context11.next = 6;
                                    break;
                                }
                                _context11.next = 6;
                                return this.statsigClient.updateUserAsync(this.user);
                            case 6:
                                _context11.next = 8;
                                break;
                            case 7:
                                _context11.prev = 7;
                                _t6 = _context11["catch"](5);
                                success = false;
                                errorMessage = String(_t6);
                            case 8:
                                (_this$initOptions = this.initOptions) === null || _this$initOptions === void 0 || (_this$initOptions$upd = _this$initOptions.updateUserCompletionCallback) === null || _this$initOptions$upd === void 0 || _this$initOptions$upd.call(_this$initOptions, success, errorMessage);
                                if (!success) {
                                    _context11.next = 9;
                                    break;
                                }
                                this.currentIdentifiers = identifiers;
                                this.currentAttributes = customAttributes;
                                this.subscriptions.anyUpdated();
                                _context11.next = 10;
                                break;
                            case 9:
                                throw new Error('Failed to update user. An unexpected error occured.');
                            case 10:
                            case "end":
                                return _context11.stop();
                        }
                    }, _callee11, this, [
                        [
                            1,
                            3
                        ],
                        [
                            5,
                            7
                        ]
                    ]);
                }));
                function updateStatsigClientUser(_x29, _x30, _x31) {
                    return _updateStatsigClientUser.apply(this, arguments);
                }
                return updateStatsigClientUser;
            }()
        },
        {
            key: "getPackageVersion",
            value: /**
     * @returns string version of the current package in semver style.
     */ function getPackageVersion() {
                return 0, $7HOhT.CLIENT_VERSION;
            }
        },
        {
            key: "getTargetApp",
            value: function getTargetApp() {
                var _this$initOptions2;
                return (_this$initOptions2 = this.initOptions) === null || _this$initOptions2 === void 0 ? void 0 : _this$initOptions2.targetApp;
            }
        },
        {
            key: "getLayer",
            value: function getLayer(/** The name of the layer */ layerName) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                try {
                    this.assertInitialized(this.statsigClient);
                    var _options$fireLayerExp = options.fireLayerExposure, fireLayerExposure = _options$fireLayerExp === void 0 ? true : _options$fireLayerExp;
                    return (0, $eVlof.Layer).fromLayer(this.statsigClient.getLayer(layerName, {
                        disableExposureLog: !fireLayerExposure
                    }));
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!this.hasGetLayerErrorOccurred) {
                        // eslint-disable-next-line no-console
                        console.warn({
                            msg: 'An error has occurred getting the layer. Only the first occurrence of this error is logged.',
                            layerName: layerName,
                            error: error
                        });
                        this.hasGetLayerErrorOccurred = true;
                    }
                    // Return a default value
                    return (0, $eVlof.Layer).fromLayer((0, $a0vkc._makeLayer)(layerName, {
                        reason: 'Error'
                    }, null));
                }
            }
        },
        {
            key: "getLayerValue",
            value: function getLayerValue(layerName, parameterName, defaultValue) {
                var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var layer = this.getLayer(layerName, options);
                try {
                    var typeGuard = options.typeGuard;
                    return layer.get(parameterName, defaultValue, typeGuard);
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!this.hasGetLayerValueErrorOccurred) {
                        // eslint-disable-next-line no-console
                        console.warn({
                            msg: 'An error has occurred getting the layer value. Only the first occurrence of this error is logged.',
                            layerName: layerName,
                            defaultValue: defaultValue,
                            options: options,
                            error: error
                        });
                        this.hasGetLayerValueErrorOccurred = true;
                    }
                    return defaultValue;
                }
            }
        }
    ]);
}();

});
parcelRegister("a0vkc", function(module, exports) {
"use strict";
var $749233e9e979ea20$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $749233e9e979ea20$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $749233e9e979ea20$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.StatsigClient = void 0;


var $lu3xa = parcelRequire("lu3xa");
module.exports.StatsigClient = $lu3xa.default;

$749233e9e979ea20$var$__exportStar((parcelRequire("328Ep")), module.exports);
const $749233e9e979ea20$var$__STATSIG__ = Object.assign((0, (parcelRequire("328Ep"))._getStatsigGlobal)(), {
    StatsigClient: $lu3xa.default
});
module.exports.default = $749233e9e979ea20$var$__STATSIG__;

});
parcelRegister("lu3xa", function(module, exports) {
"use strict";
var $fa3f2418ee7c081d$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $328Ep = parcelRequire("328Ep");

var $fuXzR = parcelRequire("fuXzR");

var $hxRpg = parcelRequire("hxRpg");

var $kFTAR = parcelRequire("kFTAR");

var $5Mu2S = parcelRequire("5Mu2S");
class $fa3f2418ee7c081d$var$StatsigClient extends $328Ep.StatsigClientBase {
    /**
     * Retrieves an instance of the StatsigClient based on the provided SDK key.
     *  If no SDK key is provided, the method returns the most recently created instance of the StatsigClient.
     *  The method ensures that each unique SDK key corresponds to a single instance of StatsigClient, effectively implementing a singleton pattern for each key.
     *  If no instance exists for the given SDK key, a new StatsigClient instance will be created and returned.
     *
     * @param {string} [sdkKey] - Optional. The SDK key used to identify a specific instance of the StatsigClient. If omitted, the method returns the last created instance.
     * @returns {StatsigClient} Returns the StatsigClient instance associated with the given SDK key, creating a new one if needed.
     */ static instance(sdkKey) {
        const instance = (0, $328Ep._getStatsigGlobal)().instance(sdkKey);
        if (instance instanceof $fa3f2418ee7c081d$var$StatsigClient) return instance;
        $328Ep.Log.warn((0, $328Ep._isServerEnv)() ? 'StatsigClient.instance is not supported in server environments' : 'Unable to find StatsigClient instance');
        return new $fa3f2418ee7c081d$var$StatsigClient(sdkKey !== null && sdkKey !== void 0 ? sdkKey : '', {});
    }
    /**
     * StatsigClient constructor
     *
     * @param {string} sdkKey A Statsig client SDK key. eg "client-xyz123..."
     * @param {StatsigUser} user StatsigUser object containing various attributes related to a user.
     * @param {StatsigOptions | null} options StatsigOptions, used to customize the behavior of the SDK.
     */ constructor(sdkKey, user, options = null){
        var _a, _b;
        $328Ep.SDKType._setClientType(sdkKey, 'javascript-client');
        const network = new $hxRpg.default(options, (e)=>{
            this.$emt(e);
        });
        super(sdkKey, (_a = options === null || options === void 0 ? void 0 : options.dataAdapter) !== null && _a !== void 0 ? _a : new $5Mu2S.StatsigEvaluationsDataAdapter(), network, options);
        this._possibleFirstTouchMetadata = {};
        /**
         * Retrieves the value of a feature gate for the current user, represented as a {@link FeatureGate} object.
         *
         * @param {string} name - The name of the feature gate to retrieve.
         * @param {FeatureGateEvaluationOptions} [options] - Optional. Additional options to customize the method call.
         * @returns {FeatureGate} - The {@link FeatureGate} object representing the gate's current evaluation results for the user.
         */ this.getFeatureGate = this._memoize($328Ep.MemoPrefix._gate, this._getFeatureGateImpl.bind(this));
        /**
         * Retrieves the value of a dynamic config for the current user.
         *
         * @param {string} name The name of the dynamic config to get.
         * @param {DynamicConfigEvaluationOptions} [options] - Optional. Additional options to customize the method call.
         * @returns {DynamicConfig} - The {@link DynamicConfig} object representing the dynamic configs's current evaluation results for the user.
         */ this.getDynamicConfig = this._memoize($328Ep.MemoPrefix._dynamicConfig, this._getDynamicConfigImpl.bind(this));
        /**
         * Retrieves the value of a experiment for the current user.
         *
         * @param {string} name The name of the experiment to get.
         * @param {ExperimentEvaluationOptions} [options] - Optional. Additional options to customize the method call.
         * @returns {Experiment} - The {@link Experiment} object representing the experiments's current evaluation results for the user.
         */ this.getExperiment = this._memoize($328Ep.MemoPrefix._experiment, this._getExperimentImpl.bind(this));
        /**
         * Retrieves the list of all Dynamic Configs and Experiments for the current user.
         *
         * @returns {string[]} The list of all Dynamic Config and Experiment names for the current user. Note - these will be hashed unless you've disabled hashing.
         * This is intended to be used for debugging.
         */ this.getConfigList = this._memoize($328Ep.MemoPrefix._configList, this._getConfigListImpl.bind(this));
        /**
         * Retrieves the value of a layer for the current user.
         *
         * @param {string} name The name of the layer to get.
         * @param {LayerEvaluationOptions} [options] - Optional. Additional options to customize the method call.
         * @returns {Layer} - The {@link Layer} object representing the layers's current evaluation results for the user.
         */ this.getLayer = this._memoize($328Ep.MemoPrefix._layer, this._getLayerImpl.bind(this));
        /**
         * Retrieves the value of a parameter store for the current user.
         *
         * @param {string} name The name of the parameter store to get.
         * @param {ParameterStoreEvaluationOptions} [options] - Optional. Additional options to customize the method call.
         * @returns {ParameterStore} - The {@link ParameterStore} object representing the parameter store's current mappings for the user.
         */ this.getParameterStore = this._memoize($328Ep.MemoPrefix._paramStore, this._getParameterStoreImpl.bind(this));
        this._store = new $fuXzR.default(sdkKey, options !== null && options !== void 0 ? options : null);
        this._network = network;
        this._user = this._configureUser(user, options);
        this._sdkInstanceID = (0, $328Ep.getUUID)();
        this._contextHandle = new $328Ep.PrecomputedEvaluationsContextHandle(sdkKey, ()=>this._options, ()=>this._errorBoundary, ()=>this._store.getValues(), ()=>this._user, ()=>this._sdkInstanceID);
        const plugins = (_b = options === null || options === void 0 ? void 0 : options.plugins) !== null && _b !== void 0 ? _b : [];
        for (const plugin of plugins)plugin.bind(this);
    }
    /**
     * Initializes the StatsigClient using cached values. This method sets up the client synchronously by utilizing previously cached values.
     * After initialization, cache values are updated in the background for future use, either in subsequent sessions or when `updateUser` is called.
     * This is useful for quickly starting with the last-known-good configurations while refreshing data to keep settings up-to-date.
     *
     * @see {@link initializeAsync} for the asynchronous version of this method.
     */ initializeSync(options) {
        var _a;
        if (this.loadingStatus !== 'Uninitialized') return (0, $328Ep.createUpdateDetails)(true, this._store.getSource(), -1, null, null, [
            'MultipleInitializations',
            ...(_a = this._store.getWarnings()) !== null && _a !== void 0 ? _a : []
        ]);
        this._logger.start();
        return this.updateUserSync(this._user, options);
    }
    /**
     * Initializes the StatsigClient asynchronously by first using cached values and then updating to the latest values from the network.
     * Once the network values are fetched, they replace the existing cached values. If this method's promise is not awaited,
     * there might be a transition from cached to network values during the session, which can affect consistency.
     * This method is useful when it's acceptable to begin with potentially stale data and switch to the latest configuration as it becomes available.
     *
     * @param {AsyncUpdateOptions} [options] - Optional. Additional options to customize the method call.
     * @returns {Promise<void>} A promise that resolves once the client is fully initialized with the latest values from the network or a timeout (if set) is hit.
     * @see {@link initializeSync} for the synchronous version of this method.
     */ initializeAsync(options) {
        return $fa3f2418ee7c081d$var$__awaiter(this, void 0, void 0, function*() {
            if (this._initializePromise) return this._initializePromise;
            this._initializePromise = this._initializeAsyncImpl(options);
            return this._initializePromise;
        });
    }
    /**
     * Synchronously updates the user in the Statsig client and switches the internal state to use cached values for the newly specified user.
     * After the initial switch to cached values, this method updates these values in the background, preparing them for future sessions or subsequent calls to updateUser.
     * This method ensures the client is quickly ready with available data.
     *
     * @param {StatsigUser} user - The new StatsigUser for which the client should update its internal state.
     * @see {@link updateUserAsync} for the asynchronous version of this method.
     */ updateUserSync(user, options) {
        const startTime = performance.now();
        try {
            return this._updateUserSyncImpl(user, options, startTime);
        } catch (e) {
            const err = e instanceof Error ? e : new Error(String(e));
            return this._createErrorUpdateDetails(err, startTime);
        }
    }
    _updateUserSyncImpl(user, options, startTime) {
        var _a;
        const warnings = [
            ...(_a = this._store.getWarnings()) !== null && _a !== void 0 ? _a : []
        ];
        this._resetForUser(user);
        const result = this.dataAdapter.getDataSync(this._user);
        if (result == null) warnings.push('NoCachedValues');
        this._store.setValues(result, this._user);
        this._finalizeUpdate(result);
        const disable = options === null || options === void 0 ? void 0 : options.disableBackgroundCacheRefresh;
        if (disable === true || disable == null && (result === null || result === void 0 ? void 0 : result.source) === 'Bootstrap') return (0, $328Ep.createUpdateDetails)(true, this._store.getSource(), performance.now() - startTime, this._errorBoundary.getLastSeenErrorAndReset(), this._network.getLastUsedInitUrlAndReset(), warnings);
        this._runPostUpdate(result !== null && result !== void 0 ? result : null, this._user);
        return (0, $328Ep.createUpdateDetails)(true, this._store.getSource(), performance.now() - startTime, this._errorBoundary.getLastSeenErrorAndReset(), this._network.getLastUsedInitUrlAndReset(), warnings);
    }
    /**
     * Asynchronously updates the user in the Statsig client by initially using cached values and then fetching the latest values from the network.
     * When the latest values are fetched, they replace the cached values. If the promise returned by this method is not awaited,
     * the client's state may shift from cached to updated network values during the session, potentially affecting consistency.
     * This method is best used in scenarios where up-to-date configuration is critical and initial delays are acceptable.
     *
     * @param {StatsigUser} user - The new StatsigUser for which the client should update its internal state.
     * @param {AsyncUpdateOptions} [options] - Optional. Additional options to customize the method call.
     * @returns {Promise<void>} A promise that resolves once the client is fully updated with the latest values from the network or a timeout (if set) is hit.
     * @see {@link updateUserSync} for the synchronous version of this method.
     */ updateUserAsync(user, options) {
        return $fa3f2418ee7c081d$var$__awaiter(this, void 0, void 0, function*() {
            const startTime = performance.now();
            try {
                return yield this._updateUserAsyncImpl(user, options);
            } catch (e) {
                const err = e instanceof Error ? e : new Error(String(e));
                return this._createErrorUpdateDetails(err, startTime);
            }
        });
    }
    _updateUserAsyncImpl(user, options) {
        return $fa3f2418ee7c081d$var$__awaiter(this, void 0, void 0, function*() {
            this._resetForUser(user);
            const initiator = this._user;
            $328Ep.Diagnostics._markInitOverallStart(this._sdkKey);
            let result = this.dataAdapter.getDataSync(initiator);
            this._store.setValues(result, this._user);
            this._setStatus('Loading', result);
            result = yield this.dataAdapter.getDataAsync(result, initiator, options);
            // ensure the user hasn't changed while we were waiting
            if (initiator !== this._user) return (0, $328Ep.createUpdateDetails)(false, this._store.getSource(), -1, new Error('User changed during update'), this._network.getLastUsedInitUrlAndReset());
            let isUsingNetworkValues = false;
            if (result != null) {
                $328Ep.Diagnostics._markInitProcessStart(this._sdkKey);
                isUsingNetworkValues = this._store.setValues(result, this._user);
                $328Ep.Diagnostics._markInitProcessEnd(this._sdkKey, {
                    success: isUsingNetworkValues
                });
            }
            this._finalizeUpdate(result);
            if (!isUsingNetworkValues) {
                this._errorBoundary.attachErrorIfNoneExists($328Ep.UPDATE_DETAIL_ERROR_MESSAGES.NO_NETWORK_DATA);
                this.$emt({
                    name: 'initialization_failure'
                });
            }
            $328Ep.Diagnostics._markInitOverallEnd(this._sdkKey, isUsingNetworkValues, this._store.getCurrentSourceDetails());
            const initDuration = $328Ep.Diagnostics._enqueueDiagnosticsEvent(this._user, this._logger, this._sdkKey, this._options);
            return (0, $328Ep.createUpdateDetails)(isUsingNetworkValues, this._store.getSource(), initDuration, this._errorBoundary.getLastSeenErrorAndReset(), this._network.getLastUsedInitUrlAndReset(), this._store.getWarnings());
        });
    }
    /**
     * Retrieves a synchronous context containing data currently being used by the SDK. Represented as a {@link PrecomputedEvaluationsContext} object.
     *
     * @returns {PrecomputedEvaluationsContext} The current synchronous context for the this StatsigClient instance.
     */ getContext() {
        let user = (0, $328Ep._cloneObject)('StatsigUser', this._user);
        if (user == null) {
            $328Ep.Log.error('Failed to clone user');
            user = {};
        }
        return {
            sdkKey: this._sdkKey,
            options: this._options,
            values: this._store.getValues(),
            user: user,
            errorBoundary: this._errorBoundary,
            session: $328Ep.StatsigSession.get(this._sdkKey),
            stableID: $328Ep.StableID.get(this._sdkKey),
            sdkInstanceID: this._sdkInstanceID
        };
    }
    /**
     * Retrieves a context handle that computes fields lazily on access.
     * This is more efficient than getContext() when you only need certain fields,
     *
     * @returns {PrecomputedEvaluationsContextHandle} A handle with lazy getters for context fields.
     */ getContextHandle() {
        return this._contextHandle;
    }
    /**
     * Retrieves the value of a feature gate for the current user, represented as a simple boolean.
     *
     * @param {string} name - The name of the feature gate to retrieve.
     * @param {FeatureGateEvaluationOptions} [options] - Optional. Additional options to customize the method call.
     * @returns {boolean} - The boolean value representing the gate's current evaluation results for the user.
     */ checkGate(name, options) {
        return this.getFeatureGate(name, options).value;
    }
    /**
     * Logs an event to the internal logging system. This function allows logging by either passing a fully formed event object or by specifying the event name with optional value and metadata.
     *
     * @param {StatsigEvent|string} eventOrName - The event object conforming to the StatsigEvent interface, or the name of the event as a string.
     * @param {string|number} value - Optional. The value associated with the event, which can be a string or a number. This parameter is ignored if the first parameter is a StatsigEvent object.
     * @param {Record<string, string>} metadata - Optional. A key-value record containing metadata about the event. This is also ignored if the first parameter is an event object.
     */ logEvent(eventOrName, value, metadata) {
        const event = typeof eventOrName === 'string' ? {
            eventName: eventOrName,
            value: value,
            metadata: metadata
        } : eventOrName;
        this.$emt({
            name: 'log_event_called',
            event: event
        });
        this._logger.enqueue(Object.assign(Object.assign({}, event), {
            user: this._user,
            time: Date.now()
        }));
    }
    /**
     * Updates the user with analytics only metadata. This will override any existing analytics only metadata.
     *
     * @param {Record<string, string | number | boolean>} metadata - The metadata to add to the user.
     */ updateUserWithAnalyticsOnlyMetadata(metadata) {
        this._user = this._configureUser(Object.assign(Object.assign({}, this._user), {
            analyticsOnlyMetadata: metadata
        }), this._options);
    }
    _primeReadyRipcord() {
        this.$on('error', ()=>{
            this.loadingStatus === 'Loading' && this._finalizeUpdate(null);
        });
    }
    _initializeAsyncImpl(options) {
        return $fa3f2418ee7c081d$var$__awaiter(this, void 0, void 0, function*() {
            if (!$328Ep.Storage.isReady()) yield $328Ep.Storage.isReadyResolver();
            this._logger.start();
            return this.updateUserAsync(this._user, options);
        });
    }
    _createErrorUpdateDetails(error, startTime) {
        var _a;
        return (0, $328Ep.createUpdateDetails)(false, this._store.getSource(), performance.now() - startTime, error, null, [
            ...(_a = this._store.getWarnings()) !== null && _a !== void 0 ? _a : []
        ]);
    }
    _finalizeUpdate(values) {
        this._store.finalize();
        this._setStatus('Ready', values);
    }
    _runPostUpdate(current, user) {
        this.dataAdapter.getDataAsync(current, user, {
            priority: 'low'
        }).catch((err)=>{
            $328Ep.Log.error('An error occurred after update.', err);
        });
    }
    _resetForUser(user) {
        this._logger.reset();
        this._store.reset();
        this._user = this._configureUser(user, this._options);
    }
    _configureUser(originalUser, options) {
        var _a, _b, _c;
        const user = (0, $328Ep._normalizeUser)(originalUser, options);
        const stableIdOverride = (_a = user.customIDs) === null || _a === void 0 ? void 0 : _a.stableID;
        if (stableIdOverride) {
            const readyPromise = (_c = (_b = this.storageProvider).isReadyResolver) === null || _c === void 0 ? void 0 : _c.call(_b);
            if (readyPromise) readyPromise.then(()=>$328Ep.StableID.setOverride(stableIdOverride, this._sdkKey), ()=>$328Ep.StableID.setOverride(stableIdOverride, this._sdkKey));
            else $328Ep.StableID.setOverride(stableIdOverride, this._sdkKey);
        }
        // Only attach first touch metadata if it's not empty
        if (Object.keys(this._possibleFirstTouchMetadata).length > 0) user.analyticsOnlyMetadata = Object.assign(Object.assign({}, user.analyticsOnlyMetadata), this._possibleFirstTouchMetadata);
        return user;
    }
    _getFeatureGateImpl(name, options) {
        var _a, _b;
        const { result: evaluation, details: details } = this._store.getGate(name);
        this._checkUserHasIdForEvaluation(evaluation === null || evaluation === void 0 ? void 0 : evaluation.id_type, name, 'Gate');
        this._checkInitializationStatus(details.reason);
        const gate = (0, $328Ep._makeFeatureGate)(name, details, evaluation);
        const overridden = (_b = (_a = this.overrideAdapter) === null || _a === void 0 ? void 0 : _a.getGateOverride) === null || _b === void 0 ? void 0 : _b.call(_a, gate, this._user, options);
        const result = overridden !== null && overridden !== void 0 ? overridden : gate;
        this._enqueueExposure(name, (0, $328Ep._createGateExposure)(this._user, result, this._store.getExposureMapping()), options);
        this.$emt({
            name: 'gate_evaluation',
            gate: result
        });
        return result;
    }
    _getDynamicConfigImpl(name, options) {
        var _a, _b;
        const { result: evaluation, details: details } = this._store.getConfig(name);
        this._checkUserHasIdForEvaluation(evaluation === null || evaluation === void 0 ? void 0 : evaluation.id_type, name, 'Dynamic config');
        this._checkInitializationStatus(details.reason);
        const config = (0, $328Ep._makeDynamicConfig)(name, details, evaluation);
        const overridden = (_b = (_a = this.overrideAdapter) === null || _a === void 0 ? void 0 : _a.getDynamicConfigOverride) === null || _b === void 0 ? void 0 : _b.call(_a, config, this._user, options);
        const result = overridden !== null && overridden !== void 0 ? overridden : config;
        this._enqueueExposure(name, (0, $328Ep._createConfigExposure)(this._user, result, this._store.getExposureMapping()), options);
        this.$emt({
            name: 'dynamic_config_evaluation',
            dynamicConfig: result
        });
        return result;
    }
    _getExperimentImpl(name, options) {
        var _a, _b, _c, _d;
        const { result: evaluation, details: details } = this._store.getConfig(name);
        this._checkUserHasIdForEvaluation(evaluation === null || evaluation === void 0 ? void 0 : evaluation.id_type, name, 'Experiment');
        this._checkInitializationStatus(details.reason);
        const experiment = (0, $328Ep._makeExperiment)(name, details, evaluation);
        if (experiment.__evaluation != null) experiment.__evaluation.secondary_exposures = (0, $328Ep._mapExposures)((_b = (_a = experiment.__evaluation) === null || _a === void 0 ? void 0 : _a.secondary_exposures) !== null && _b !== void 0 ? _b : [], this._store.getExposureMapping());
        const overridden = (_d = (_c = this.overrideAdapter) === null || _c === void 0 ? void 0 : _c.getExperimentOverride) === null || _d === void 0 ? void 0 : _d.call(_c, experiment, this._user, options);
        const result = overridden !== null && overridden !== void 0 ? overridden : experiment;
        this._enqueueExposure(name, (0, $328Ep._createConfigExposure)(this._user, result, this._store.getExposureMapping()), options);
        this.$emt({
            name: 'experiment_evaluation',
            experiment: result
        });
        return result;
    }
    _getConfigListImpl() {
        return this._store.getConfigList();
    }
    _getLayerImpl(name, options) {
        var _a, _b, _c;
        const { result: evaluation, details: details } = this._store.getLayer(name);
        const layer = (0, $328Ep._makeLayer)(name, details, evaluation);
        const overridden = (_b = (_a = this.overrideAdapter) === null || _a === void 0 ? void 0 : _a.getLayerOverride) === null || _b === void 0 ? void 0 : _b.call(_a, layer, this._user, options);
        if (options === null || options === void 0 ? void 0 : options.disableExposureLog) this._logger.incrementNonExposureCount(name);
        const result = (0, $328Ep._mergeOverride)(layer, overridden, (_c = overridden === null || overridden === void 0 ? void 0 : overridden.__value) !== null && _c !== void 0 ? _c : layer.__value, (param)=>{
            if (options === null || options === void 0 ? void 0 : options.disableExposureLog) return;
            this._enqueueExposure(name, (0, $328Ep._createLayerParameterExposure)(this._user, result, param, this._store.getExposureMapping()), options);
        });
        this.$emt({
            name: 'layer_evaluation',
            layer: result
        });
        return result;
    }
    _getParameterStoreImpl(name, options) {
        var _a, _b;
        const { result: configuration, details: details } = this._store.getParamStore(name);
        this._logger.incrementNonExposureCount(name);
        const paramStore = {
            name: name,
            details: details,
            __configuration: configuration,
            get: (0, $kFTAR._makeParamStoreGetter)(this, configuration, options)
        };
        const overridden = (_b = (_a = this.overrideAdapter) === null || _a === void 0 ? void 0 : _a.getParamStoreOverride) === null || _b === void 0 ? void 0 : _b.call(_a, paramStore, options);
        if (overridden != null) {
            paramStore.__configuration = overridden.config;
            paramStore.details = overridden.details;
            paramStore.get = (0, $kFTAR._makeParamStoreGetter)(this, overridden.config, options);
        }
        return paramStore;
    }
    _checkUserHasIdForEvaluation(idType, name, type) {
        if (!idType) return;
        if (!(0, $328Ep._getUnitIDFromUser)(this._user, idType)) $328Ep.Log.warn(`The user does not have the required id_type "${idType}" for ${type} "${name}"`);
    }
    _checkInitializationStatus(reason) {
        if (reason === 'Uninitialized' || reason.startsWith('Loading')) $328Ep.Log.warn(`SDK initialization has not completed. Reason: ${reason}`);
    }
}
module.exports.default = $fa3f2418ee7c081d$var$StatsigClient;

});
parcelRegister("fuXzR", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $328Ep = parcelRequire("328Ep");

var $kPXiO = parcelRequire("kPXiO");

var $9Vohm = parcelRequire("9Vohm");
class $b487df3073f2a376$var$EvaluationStore {
    constructor(_sdkKey, _options){
        this._sdkKey = _sdkKey;
        this._options = _options;
        this._valuesForExternalUse = null;
        this._values = null;
        this._source = 'Uninitialized';
        this._lcut = 0;
        this._receivedAt = 0;
        this._bootstrapMetadata = null;
        this._warnings = new Set();
    }
    reset() {
        this._values = null;
        this._valuesForExternalUse = null;
        this._source = 'Loading';
        this._lcut = 0;
        this._receivedAt = 0;
        this._bootstrapMetadata = null;
        this._warnings.clear();
    }
    finalize() {
        if (this._values) return;
        this._source = 'NoValues';
    }
    getValues() {
        // we do not give out the actual _values object to avoid mutating it
        return this._valuesForExternalUse;
    }
    setValues(result, user) {
        var _a, _b;
        if (!result) return false;
        const values = (0, $328Ep._typedJsonParse)(result.data, 'has_updates', 'EvaluationResponse');
        if (values == null) return false;
        this._source = result.source;
        if ((values === null || values === void 0 ? void 0 : values.has_updates) !== true) return true;
        const updatedLcut = (_a = values.time) !== null && _a !== void 0 ? _a : 0;
        if (updatedLcut < this._lcut) return true;
        this._valuesForExternalUse = (0, $328Ep._typedJsonParse)(result.data, 'has_updates', 'EvaluationResponse');
        this._lcut = values.time;
        this._receivedAt = result.receivedAt;
        if (values.response_format === 'init-v2') this._values = new $9Vohm.V2InitializeContainer(values);
        else this._values = new $kPXiO.V1InitializeContainer(values);
        this._bootstrapMetadata = this._extractBootstrapMetadata(result.source, values);
        if (result.source && values.user) this._setWarningState(user, values);
        $328Ep.SDKFlags.setFlags(this._sdkKey, (_b = values.sdk_flags) !== null && _b !== void 0 ? _b : {});
        return true;
    }
    getWarnings() {
        if (this._warnings.size === 0) return undefined;
        return Array.from(this._warnings);
    }
    getGate(name) {
        const res = this._values ? this._values.getGate(name) : null;
        return this._getDetailedStoreResult(res);
    }
    getConfig(name) {
        const res = this._values ? this._values.getConfig(name) : null;
        return this._getDetailedStoreResult(res);
    }
    getConfigList() {
        if (!this._values) return [];
        return this._values.getConfigList();
    }
    getLayer(name) {
        const res = this._values ? this._values.getLayer(name) : null;
        return this._getDetailedStoreResult(res);
    }
    getParamStore(name) {
        const res = this._values ? this._values.getParamStore(name) : null;
        return this._getDetailedStoreResult(res);
    }
    getSource() {
        return this._source;
    }
    getExposureMapping() {
        var _a;
        return (_a = this._values) === null || _a === void 0 ? void 0 : _a.getExposureMapping();
    }
    _extractBootstrapMetadata(source, values) {
        if (source !== 'Bootstrap') return null;
        const bootstrapMetadata = {};
        if (values.user) bootstrapMetadata.user = values.user;
        if (values.sdkInfo) bootstrapMetadata.generatorSDKInfo = values.sdkInfo;
        bootstrapMetadata.lcut = values.time;
        return bootstrapMetadata;
    }
    _getDetailedStoreResult(result) {
        return {
            result: result,
            details: this._getDetails(result == null)
        };
    }
    _setWarningState(user, values) {
        var _a, _b, _c;
        const stableID = $328Ep.StableID.get(this._sdkKey);
        if (((_a = user.customIDs) === null || _a === void 0 ? void 0 : _a.stableID) !== stableID && // don't throw if they're both undefined
        (((_b = user.customIDs) === null || _b === void 0 ? void 0 : _b.stableID) || stableID)) {
            this._warnings.add('StableIDMismatch');
            return;
        }
        if ('user' in values) {
            let bootstrapUser = values['user'];
            let userForComparison = Object.assign(Object.assign({}, user), {
                analyticsOnlyMetadata: undefined,
                privateAttributes: undefined
            });
            if ((_c = this._options) === null || _c === void 0 ? void 0 : _c.disableStableID) {
                userForComparison = Object.assign(Object.assign({}, userForComparison), {
                    customIDs: Object.assign(Object.assign({}, userForComparison.customIDs), {
                        stableID: undefined
                    })
                });
                bootstrapUser = Object.assign(Object.assign({}, bootstrapUser), {
                    customIDs: Object.assign(Object.assign({}, bootstrapUser.customIDs), {
                        stableID: undefined
                    })
                });
            }
            if ((0, $328Ep._getFullUserHash)(userForComparison) !== (0, $328Ep._getFullUserHash)(bootstrapUser)) this._warnings.add('PartialUserMatch');
        }
    }
    getCurrentSourceDetails() {
        if (this._source === 'Uninitialized' || this._source === 'NoValues') return {
            reason: this._source
        };
        const sourceDetails = {
            reason: this._source,
            lcut: this._lcut,
            receivedAt: this._receivedAt
        };
        if (this._warnings.size > 0) sourceDetails.warnings = Array.from(this._warnings);
        return sourceDetails;
    }
    _getDetails(isUnrecognized) {
        var _a, _b;
        const sourceDetails = this.getCurrentSourceDetails();
        let reason = sourceDetails.reason;
        const warnings = (_a = sourceDetails.warnings) !== null && _a !== void 0 ? _a : [];
        if (this._source === 'Bootstrap' && warnings.length > 0) reason = reason + warnings[0];
        if (reason !== 'Uninitialized' && reason !== 'NoValues') {
            const subreason = isUnrecognized ? 'Unrecognized' : 'Recognized';
            reason = `${reason}:${subreason}`;
        }
        const bootstrapMetadata = this._source === 'Bootstrap' ? (_b = this._bootstrapMetadata) !== null && _b !== void 0 ? _b : undefined : undefined;
        if (bootstrapMetadata) sourceDetails.bootstrapMetadata = bootstrapMetadata;
        return Object.assign(Object.assign({}, sourceDetails), {
            reason: reason
        });
    }
}
module.exports.default = $b487df3073f2a376$var$EvaluationStore;

});
parcelRegister("kPXiO", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.V1InitializeContainer = void 0;

var $328Ep = parcelRequire("328Ep");
class $f2b6924ffe6e62a7$var$V1InitializeContainer {
    constructor(_values){
        this._values = _values;
    }
    getGate(name) {
        return this._getResultFromLookup(this._values.feature_gates, name);
    }
    getConfig(name) {
        return this._getResultFromLookup(this._values.dynamic_configs, name);
    }
    getLayer(name) {
        return this._getResultFromLookup(this._values.layer_configs, name);
    }
    getParamStore(name) {
        return this._getResultFromLookup(this._values.param_stores, name);
    }
    getConfigList() {
        return Object.keys(this._values.dynamic_configs);
    }
    getExposureMapping() {
        return this._values.exposures;
    }
    _getResultFromLookup(lookup, name) {
        var _a, _b;
        if (!lookup) return null;
        return (_b = (_a = lookup[name]) !== null && _a !== void 0 ? _a : lookup[(0, $328Ep._DJB2)(name)]) !== null && _b !== void 0 ? _b : null;
    }
}
module.exports.V1InitializeContainer = $f2b6924ffe6e62a7$var$V1InitializeContainer;

});

parcelRegister("9Vohm", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.V2InitializeContainer = void 0;

var $328Ep = parcelRequire("328Ep");
class $739c453cf4e8d3b8$var$V2InitializeContainer {
    constructor(_values){
        this._values = _values;
    }
    getGate(name) {
        var _a, _b, _c;
        const evalV2 = this._getResultFromLookup(this._values.feature_gates, name);
        if (!evalV2) return null;
        return {
            name: name,
            value: evalV2.v === true,
            rule_id: (_a = evalV2.r) !== null && _a !== void 0 ? _a : 'default',
            secondary_exposures: (_b = evalV2.s) !== null && _b !== void 0 ? _b : [],
            id_type: (_c = evalV2.i) !== null && _c !== void 0 ? _c : ''
        };
    }
    getConfig(name) {
        var _a, _b, _c, _d;
        const evalV2 = this._getResultFromLookup(this._values.dynamic_configs, name);
        if (!evalV2) return null;
        return {
            name: name,
            value: (_a = this._values.values[evalV2.v]) !== null && _a !== void 0 ? _a : {},
            rule_id: evalV2.r,
            secondary_exposures: (_b = evalV2.s) !== null && _b !== void 0 ? _b : [],
            id_type: (_c = evalV2.i) !== null && _c !== void 0 ? _c : '',
            is_user_in_experiment: evalV2.ue === true ? true : false,
            passed: evalV2.p === true,
            group_name: (_d = evalV2.gn) !== null && _d !== void 0 ? _d : undefined,
            is_experiment_active: evalV2.ea === true ? true : false,
            group: evalV2.r,
            is_device_based: evalV2.i === 'stableID'
        };
    }
    getLayer(name) {
        var _a, _b, _c, _d, _e, _f;
        const evalV2 = this._getResultFromLookup(this._values.layer_configs, name);
        if (!evalV2) return null;
        return {
            name: name,
            value: (_a = this._values.values[evalV2.v]) !== null && _a !== void 0 ? _a : {},
            rule_id: evalV2.r,
            secondary_exposures: (_b = evalV2.s) !== null && _b !== void 0 ? _b : [],
            is_user_in_experiment: evalV2.ue === true ? true : false,
            group_name: (_c = evalV2.gn) !== null && _c !== void 0 ? _c : undefined,
            is_experiment_active: evalV2.ea === true ? true : false,
            group: evalV2.r,
            is_device_based: evalV2.i === 'stableID',
            allocated_experiment_name: (_d = evalV2.ae) !== null && _d !== void 0 ? _d : '',
            explicit_parameters: (_e = evalV2.ep) !== null && _e !== void 0 ? _e : [],
            undelegated_secondary_exposures: (_f = evalV2.us) !== null && _f !== void 0 ? _f : [],
            parameter_rule_ids: evalV2.pr
        };
    }
    getParamStore(name) {
        return this._getResultFromLookup(this._values.param_stores, name);
    }
    getConfigList() {
        return Object.keys(this._values.dynamic_configs);
    }
    getExposureMapping() {
        return this._values.exposures;
    }
    _getResultFromLookup(lookup, name) {
        var _a, _b;
        if (!lookup) return null;
        return (_b = (_a = lookup[name]) !== null && _a !== void 0 ? _a : lookup[(0, $328Ep._DJB2)(name)]) !== null && _b !== void 0 ? _b : null;
    }
}
module.exports.V2InitializeContainer = $739c453cf4e8d3b8$var$V2InitializeContainer;

});


parcelRegister("hxRpg", function(module, exports) {
"use strict";
var $cc5ef2283efe5fdd$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $328Ep = parcelRequire("328Ep");

var $aberb = parcelRequire("aberb");
class $cc5ef2283efe5fdd$var$StatsigNetwork extends $328Ep.NetworkCore {
    constructor(options, emitter){
        super(options, emitter);
        const config = options === null || options === void 0 ? void 0 : options.networkConfig;
        this._option = options;
        this._initializeUrlConfig = new $328Ep.UrlConfiguration($328Ep.Endpoint._initialize, config === null || config === void 0 ? void 0 : config.initializeUrl, config === null || config === void 0 ? void 0 : config.api, config === null || config === void 0 ? void 0 : config.initializeFallbackUrls);
    }
    fetchEvaluations(sdkKey, current, priority, user, isCacheValidFor204) {
        return $cc5ef2283efe5fdd$var$__awaiter(this, void 0, void 0, function*() {
            var _a, _b, _c, _d, _e, _f;
            const cache = current ? (0, $328Ep._typedJsonParse)(current, 'has_updates', 'InitializeResponse') : null;
            let data = {
                user: user,
                hash: (_c = (_b = (_a = this._option) === null || _a === void 0 ? void 0 : _a.networkConfig) === null || _b === void 0 ? void 0 : _b.initializeHashAlgorithm) !== null && _c !== void 0 ? _c : 'djb2',
                deltasResponseRequested: false,
                full_checksum: null
            };
            if (cache === null || cache === void 0 ? void 0 : cache.has_updates) {
                const hasHashChanged = (cache === null || cache === void 0 ? void 0 : cache.hash_used) !== ((_f = (_e = (_d = this._option) === null || _d === void 0 ? void 0 : _d.networkConfig) === null || _e === void 0 ? void 0 : _e.initializeHashAlgorithm) !== null && _f !== void 0 ? _f : 'djb2');
                data = Object.assign(Object.assign({}, data), {
                    sinceTime: isCacheValidFor204 && !hasHashChanged ? cache.time : 0,
                    previousDerivedFields: 'derived_fields' in cache && isCacheValidFor204 ? cache.derived_fields : {},
                    deltasResponseRequested: true,
                    full_checksum: cache.full_checksum,
                    partialUserMatchSinceTime: !hasHashChanged ? cache.time : 0
                });
            }
            return this._fetchEvaluations(sdkKey, cache, data, priority);
        });
    }
    _fetchEvaluations(sdkKey, cache, data, priority) {
        return $cc5ef2283efe5fdd$var$__awaiter(this, void 0, void 0, function*() {
            var _a, _b;
            const response = yield this.post({
                sdkKey: sdkKey,
                urlConfig: this._initializeUrlConfig,
                data: data,
                retries: 2,
                isStatsigEncodable: true,
                priority: priority
            });
            if ((response === null || response === void 0 ? void 0 : response.code) === 204) return '{"has_updates": false}';
            if ((response === null || response === void 0 ? void 0 : response.code) !== 200) return (_a = response === null || response === void 0 ? void 0 : response.body) !== null && _a !== void 0 ? _a : null;
            if ((cache === null || cache === void 0 ? void 0 : cache.has_updates) !== true || ((_b = response.body) === null || _b === void 0 ? void 0 : _b.includes('"is_delta":true')) !== true || data.deltasResponseRequested !== true) return response.body;
            const result = (0, $aberb._resolveDeltasResponse)(cache, response.body);
            if (typeof result === 'string') return result;
            // retry without deltas
            return this._fetchEvaluations(sdkKey, cache, Object.assign(Object.assign(Object.assign({}, data), result), {
                deltasResponseRequested: false
            }), priority);
        });
    }
}
module.exports.default = $cc5ef2283efe5fdd$var$StatsigNetwork;

});
parcelRegister("aberb", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._resolveDeltasResponse = void 0;

var $328Ep = parcelRequire("328Ep");
const $76962169f2d7409a$var$MAX_DELTAS_SORT_DEPTH = 2;
function $76962169f2d7409a$var$_resolveDeltasResponse(cache, deltasString) {
    const deltas = (0, $328Ep._typedJsonParse)(deltasString, 'checksum', 'DeltasEvaluationResponse');
    if (!deltas) return {
        hadBadDeltaChecksum: true
    };
    const merged = $76962169f2d7409a$var$_mergeDeltasIntoCache(cache, deltas);
    const resolved = $76962169f2d7409a$var$_handleDeletedEntries(merged);
    const actualChecksum = (0, $328Ep._DJB2Object)({
        feature_gates: resolved.feature_gates,
        dynamic_configs: resolved.dynamic_configs,
        layer_configs: resolved.layer_configs
    }, $76962169f2d7409a$var$MAX_DELTAS_SORT_DEPTH);
    const isMatch = actualChecksum === deltas.checksumV2;
    if (!isMatch) return {
        hadBadDeltaChecksum: true,
        badChecksum: actualChecksum,
        badMergedConfigs: resolved,
        badFullResponse: deltas.deltas_full_response
    };
    return JSON.stringify(resolved);
}
module.exports._resolveDeltasResponse = $76962169f2d7409a$var$_resolveDeltasResponse;
function $76962169f2d7409a$var$_mergeDeltasIntoCache(cache, deltas) {
    return Object.assign(Object.assign(Object.assign({}, cache), deltas), {
        feature_gates: Object.assign(Object.assign({}, cache.feature_gates), deltas.feature_gates),
        layer_configs: Object.assign(Object.assign({}, cache.layer_configs), deltas.layer_configs),
        dynamic_configs: Object.assign(Object.assign({}, cache.dynamic_configs), deltas.dynamic_configs)
    });
}
function $76962169f2d7409a$var$_handleDeletedEntries(deltas) {
    const result = deltas;
    $76962169f2d7409a$var$_deleteEntriesInRecord(deltas.deleted_gates, result.feature_gates);
    delete result.deleted_gates;
    $76962169f2d7409a$var$_deleteEntriesInRecord(deltas.deleted_configs, result.dynamic_configs);
    delete result.deleted_configs;
    $76962169f2d7409a$var$_deleteEntriesInRecord(deltas.deleted_layers, result.layer_configs);
    delete result.deleted_layers;
    return result;
}
function $76962169f2d7409a$var$_deleteEntriesInRecord(keys, values) {
    keys === null || keys === void 0 || keys.forEach((key)=>{
        delete values[key];
    });
}

});


parcelRegister("kFTAR", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._makeParamStoreGetter = void 0;

var $328Ep = parcelRequire("328Ep");
const $f0d2c2b84e993347$var$NO_EXPOSURE_OPT = {
    disableExposureLog: true
};
function $f0d2c2b84e993347$var$_shouldLogExposure(options) {
    return options == null || options.disableExposureLog === false;
}
function $f0d2c2b84e993347$var$_shouldReturnFallback(value, fallback) {
    return fallback != null && !(0, $328Ep._isTypeMatch)(value, fallback);
}
function $f0d2c2b84e993347$var$_getMappedStaticValue(param, _options) {
    return param.value;
}
function $f0d2c2b84e993347$var$_getMappedGateValue(client, param, options) {
    const gate = client.getFeatureGate(param.gate_name, $f0d2c2b84e993347$var$_shouldLogExposure(options) ? undefined : $f0d2c2b84e993347$var$NO_EXPOSURE_OPT);
    if (gate.value) return param.pass_value;
    return param.fail_value;
}
function $f0d2c2b84e993347$var$_getMappedDynamicConfigValue(client, param, fallback, options) {
    const config = client.getDynamicConfig(param.config_name, $f0d2c2b84e993347$var$_shouldLogExposure(options) ? undefined : $f0d2c2b84e993347$var$NO_EXPOSURE_OPT);
    const value = config.get(param.param_name);
    if ($f0d2c2b84e993347$var$_shouldReturnFallback(value, fallback)) return fallback;
    return value;
}
function $f0d2c2b84e993347$var$_getMappedExperimentValue(client, param, fallback, options) {
    const experiment = client.getExperiment(param.experiment_name, $f0d2c2b84e993347$var$_shouldLogExposure(options) ? undefined : $f0d2c2b84e993347$var$NO_EXPOSURE_OPT);
    const value = experiment.get(param.param_name);
    if ($f0d2c2b84e993347$var$_shouldReturnFallback(value, fallback)) return fallback;
    return value;
}
function $f0d2c2b84e993347$var$_getMappedLayerValue(client, param, fallback, options) {
    const layer = client.getLayer(param.layer_name, $f0d2c2b84e993347$var$_shouldLogExposure(options) ? undefined : $f0d2c2b84e993347$var$NO_EXPOSURE_OPT);
    const value = layer.get(param.param_name);
    if ($f0d2c2b84e993347$var$_shouldReturnFallback(value, fallback)) return fallback;
    return value;
}
function $f0d2c2b84e993347$var$_makeParamStoreGetter(client, config, options) {
    return (paramName, fallback)=>{
        if (config == null) return fallback;
        const param = config[paramName];
        if (param == null || fallback != null && (0, $328Ep._typeOf)(fallback) !== param.param_type) return fallback;
        switch(param.ref_type){
            case 'static':
                return $f0d2c2b84e993347$var$_getMappedStaticValue(param, options);
            case 'gate':
                return $f0d2c2b84e993347$var$_getMappedGateValue(client, param, options);
            case 'dynamic_config':
                return $f0d2c2b84e993347$var$_getMappedDynamicConfigValue(client, param, fallback, options);
            case 'experiment':
                return $f0d2c2b84e993347$var$_getMappedExperimentValue(client, param, fallback, options);
            case 'layer':
                return $f0d2c2b84e993347$var$_getMappedLayerValue(client, param, fallback, options);
            default:
                return fallback;
        }
    };
}
module.exports._makeParamStoreGetter = $f0d2c2b84e993347$var$_makeParamStoreGetter;

});

parcelRegister("5Mu2S", function(module, exports) {
"use strict";
var $4358bdd71218f80e$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.StatsigEvaluationsDataAdapter = void 0;

var $328Ep = parcelRequire("328Ep");

var $hxRpg = parcelRequire("hxRpg");
class $4358bdd71218f80e$var$StatsigEvaluationsDataAdapter extends $328Ep.DataAdapterCore {
    constructor(){
        super('EvaluationsDataAdapter', 'evaluations');
        this._network = null;
        this._options = null;
    }
    attach(sdkKey, options, network) {
        super.attach(sdkKey, options, network);
        if (network !== null && network instanceof $hxRpg.default) this._network = network;
        else this._network = new $hxRpg.default(options !== null && options !== void 0 ? options : {});
    }
    getDataAsync(current, user, options) {
        return this._getDataAsyncImpl(current, (0, $328Ep._normalizeUser)(user, this._options), options);
    }
    prefetchData(user, options) {
        return this._prefetchDataImpl(user, options);
    }
    setData(data) {
        const values = (0, $328Ep._typedJsonParse)(data, 'has_updates', 'data');
        if (values && 'user' in values) super.setData(data, values.user);
        else $328Ep.Log.error('StatsigUser not found. You may be using an older server SDK version. Please upgrade your SDK or use setDataLegacy.');
    }
    setDataLegacy(data, user) {
        super.setData(data, user);
    }
    _fetchFromNetwork(current, user, options, isCacheValidFor204) {
        return $4358bdd71218f80e$var$__awaiter(this, void 0, void 0, function*() {
            var _a;
            const result = yield (_a = this._network) === null || _a === void 0 ? void 0 : _a.fetchEvaluations(this._getSdkKey(), current, options === null || options === void 0 ? void 0 : options.priority, user, isCacheValidFor204);
            return result !== null && result !== void 0 ? result : null;
        });
    }
    _getCacheKey(user) {
        var _a;
        const key = (0, $328Ep._getStorageKey)(this._getSdkKey(), user, (_a = this._options) === null || _a === void 0 ? void 0 : _a.customUserCacheKeyFunc);
        return `${$328Ep.DataAdapterCachePrefix}.${this._cacheSuffix}.${key}`;
    }
    _isCachedResultValidFor204(result, user) {
        return result.fullUserHash != null && result.fullUserHash === (0, $328Ep._getFullUserHash)(user);
    }
}
module.exports.StatsigEvaluationsDataAdapter = $4358bdd71218f80e$var$StatsigEvaluationsDataAdapter;

});



parcelRegister("5sFjq", function(module, exports) {
$parcel$export(module.exports, "default", () => $3f9f9d0f283704a1$export$2e2bcd8739ae039);

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $25nEq = parcelRequire("25nEq");

var $hLfKH = parcelRequire("hLfKH");
function $3f9f9d0f283704a1$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $3f9f9d0f283704a1$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $3f9f9d0f283704a1$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $3f9f9d0f283704a1$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $3f9f9d0f283704a1$export$a66cbd9b2289cd78 = '@all-features';
var $3f9f9d0f283704a1$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function Subscriptions() {
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, Subscriptions);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "eventToValue", new Map());
        this.emitter = new (0, (/*@__PURE__*/$parcel$interopDefault($hLfKH)))();
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(Subscriptions, [
        {
            key: "onGateUpdated",
            value: function onGateUpdated(gateName, callback, checkGate, options) {
                var _this = this;
                var value = checkGate(gateName, $3f9f9d0f283704a1$var$_objectSpread($3f9f9d0f283704a1$var$_objectSpread({}, options), {}, {
                    fireGateExposure: false
                }));
                if (this.eventToValue.get(callback) === undefined) this.eventToValue.set(callback, value);
                var wrapCallback = function wrapCallback() {
                    var value = checkGate(gateName, $3f9f9d0f283704a1$var$_objectSpread($3f9f9d0f283704a1$var$_objectSpread({}, options), {}, {
                        fireGateExposure: false
                    }));
                    var existingValue = _this.eventToValue.get(callback);
                    if (existingValue !== value) {
                        _this.eventToValue.set(callback, value);
                        callback(value);
                    }
                };
                this.emitter.on(gateName, wrapCallback);
                return function() {
                    _this.emitter.off(gateName, wrapCallback);
                };
            }
        },
        {
            key: "onExperimentValueUpdated",
            value: function onExperimentValueUpdated(experimentName, parameterName, defaultValue, callback, getExperimentValue, options) {
                var _this2 = this;
                var experimentEventName = "".concat(experimentName, ".").concat(parameterName);
                var value = getExperimentValue(experimentName, parameterName, defaultValue, $3f9f9d0f283704a1$var$_objectSpread($3f9f9d0f283704a1$var$_objectSpread({}, options), {}, {
                    fireExperimentExposure: false
                }));
                if (this.eventToValue.get(callback) === undefined) this.eventToValue.set(callback, value);
                var wrapCallback = function wrapCallback() {
                    var value = getExperimentValue(experimentName, parameterName, defaultValue, $3f9f9d0f283704a1$var$_objectSpread($3f9f9d0f283704a1$var$_objectSpread({}, options), {}, {
                        fireExperimentExposure: false
                    }));
                    var existingValue = _this2.eventToValue.get(callback);
                    if (existingValue !== value) {
                        _this2.eventToValue.set(callback, value);
                        callback(value);
                    }
                };
                this.emitter.on(experimentEventName, wrapCallback);
                return function() {
                    _this2.emitter.off(experimentEventName, wrapCallback);
                };
            }
        },
        {
            key: "onAnyUpdated",
            value: function onAnyUpdated(callback) {
                var _this3 = this;
                this.emitter.on($3f9f9d0f283704a1$export$a66cbd9b2289cd78, callback);
                return function() {
                    _this3.emitter.off($3f9f9d0f283704a1$export$a66cbd9b2289cd78, callback);
                };
            }
        },
        {
            key: "anyUpdated",
            value: function anyUpdated() {
                var _this4 = this;
                this.emitter.emit($3f9f9d0f283704a1$export$a66cbd9b2289cd78);
                this.emitter.eventNames().filter(function(name) {
                    return name !== $3f9f9d0f283704a1$export$a66cbd9b2289cd78;
                }).forEach(function(event) {
                    _this4.emitter.emit(event);
                });
            }
        }
    ]);
}();

});

parcelRegister("kkQZA", function(module, exports) {
$parcel$export(module.exports, "DynamicConfig", () => $ecdec8188da1c9fe$export$6dc24881a3d96325);

var $ekGgq = parcelRequire("ekGgq");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $gIeKg = parcelRequire("gIeKg");
var $ecdec8188da1c9fe$export$6dc24881a3d96325 = /*#__PURE__*/ function() {
    function DynamicConfig(configName, configValue, ruleID, evaluationDetails) {
        var secondaryExposures = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : [];
        var allocatedExperimentName = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : '';
        var onDefaultValueFallback = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : null;
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, DynamicConfig);
        this.value = configValue;
        this._name = configName;
        this._ruleID = ruleID;
        this._secondaryExposures = secondaryExposures;
        this._allocatedExperimentName = allocatedExperimentName;
        this._evaluationDetails = evaluationDetails;
        this._onDefaultValueFallback = onDefaultValueFallback;
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(DynamicConfig, [
        {
            key: "get",
            value: function get(key, defaultValue, typeGuard) {
                var _this$_onDefaultValue2;
                var val = this.getValue(key, defaultValue);
                if (val == null) return defaultValue;
                var expectedType = Array.isArray(defaultValue) ? 'array' : (0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(defaultValue);
                var actualType = Array.isArray(val) ? 'array' : (0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(val);
                if (typeGuard) {
                    var _this$_onDefaultValue;
                    if (typeGuard(val)) {
                        this.fireExposure(key);
                        return val;
                    }
                    (_this$_onDefaultValue = this._onDefaultValueFallback) === null || _this$_onDefaultValue === void 0 || _this$_onDefaultValue.call(this, this, key, expectedType, actualType);
                    return defaultValue;
                }
                if (defaultValue == null || expectedType === actualType) {
                    this.fireExposure(key);
                    return val;
                }
                (_this$_onDefaultValue2 = this._onDefaultValueFallback) === null || _this$_onDefaultValue2 === void 0 || _this$_onDefaultValue2.call(this, this, key, expectedType, actualType);
                return defaultValue;
            }
        },
        {
            key: "getValue",
            value: function getValue(key, defaultValue) {
                if (key == null) return this.value;
                if (defaultValue == null) defaultValue = null;
                if (this.value[key] == null) return defaultValue;
                this.fireExposure(key);
                return this.value[key];
            }
        },
        {
            key: "fireExposure",
            value: function fireExposure(key) {
                // Call the wrapped experiment's get method to fire exposure
                if (this.experiment) this.experiment.get(key);
            }
        }
    ], [
        {
            key: "fromExperiment",
            value: function fromExperiment(experiment) {
                var _experiment$__evaluat, _experiment$__evaluat2, _experiment$groupName;
                var config = new DynamicConfig(experiment.name, experiment.value, experiment.ruleID, (0, $gIeKg.migrateEvaluationDetails)(experiment.details), (0, $gIeKg.migrateSecondaryExposures)((_experiment$__evaluat = (_experiment$__evaluat2 = experiment.__evaluation) === null || _experiment$__evaluat2 === void 0 ? void 0 : _experiment$__evaluat2.secondary_exposures) !== null && _experiment$__evaluat !== void 0 ? _experiment$__evaluat : []), (_experiment$groupName = experiment.groupName) !== null && _experiment$groupName !== void 0 ? _experiment$groupName : undefined);
                config.experiment = experiment;
                return config;
            }
        }
    ]);
}();

});
parcelRegister("gIeKg", function(module, exports) {
$parcel$export(module.exports, "getOptionsWithDefaults", () => $c2ac317f102b507f$export$d119b37e5f788b43);
$parcel$export(module.exports, "shallowEquals", () => $c2ac317f102b507f$export$fa1c2bbf4100b8bc);
$parcel$export(module.exports, "toStatsigUser", () => $c2ac317f102b507f$export$3dad1db244472f32);
$parcel$export(module.exports, "deepAssign", () => $c2ac317f102b507f$export$1148cb79ceecd5fa);
$parcel$export(module.exports, "migrateInitializationOptions", () => $c2ac317f102b507f$export$202946b690d26d22);
$parcel$export(module.exports, "migrateEvaluationDetails", () => $c2ac317f102b507f$export$18ad168d3dbac899);
$parcel$export(module.exports, "migrateSecondaryExposures", () => $c2ac317f102b507f$export$55fd683752d01e67);

var $ekGgq = parcelRequire("ekGgq");

var $fC8ib = parcelRequire("fC8ib");

var $1Vcia = parcelRequire("1Vcia");

var $iYJcE = parcelRequire("iYJcE");

var $25nEq = parcelRequire("25nEq");

var $c2e6M = parcelRequire("c2e6M");

var $48eYA = parcelRequire("48eYA");

var $hiARP = parcelRequire("hiARP");
var $c2ac317f102b507f$var$_excluded = [
    "stableId"
], $c2ac317f102b507f$var$_excluded2 = [
    "api",
    "disableCurrentPageLogging",
    "loggingIntervalMillis",
    "loggingBufferMaxSize",
    "localMode",
    "eventLoggingApi",
    "eventLoggingApiForRetries",
    "disableLocalStorage",
    "ignoreWindowUndefined",
    "disableAllLogging",
    "initTimeoutMs",
    "disableNetworkKeepalive",
    "overrideStableID",
    "disableErrorLogging",
    "disableAutoMetricsLogging"
];
function $c2ac317f102b507f$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $c2ac317f102b507f$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $c2ac317f102b507f$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $c2ac317f102b507f$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $c2ac317f102b507f$export$d119b37e5f788b43 = function getOptionsWithDefaults(options) {
    return $c2ac317f102b507f$var$_objectSpread({
        /**
     * If more federal PerimeterTypes are added in the future, this should be updated so
     * that isFedRamp() === true always returns the strictest perimeter.
     */ perimeter: (0, $c2e6M.isFedRamp)() ? (0, $hiARP.PerimeterType).FEDRAMP_MODERATE : (0, $hiARP.PerimeterType).COMMERCIAL
    }, options);
};
var $c2ac317f102b507f$export$fa1c2bbf4100b8bc = function shallowEquals(objectA, objectB) {
    if (!objectA && !objectB) return true;
    if (!objectA || !objectB) return false;
    var aEntries = Object.entries(objectA);
    var bEntries = Object.entries(objectB);
    if (aEntries.length !== bEntries.length) return false;
    var ascendingKeyOrder = function ascendingKeyOrder(_ref, _ref2) {
        var _ref3 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_ref, 1), key1 = _ref3[0];
        var _ref4 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_ref2, 1), key2 = _ref4[0];
        return key1.localeCompare(key2);
    };
    aEntries.sort(ascendingKeyOrder);
    bEntries.sort(ascendingKeyOrder);
    for(var i = 0; i < aEntries.length; i++){
        var _aEntries$i = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(aEntries[i], 2), aValue = _aEntries$i[1];
        var _bEntries$i = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(bEntries[i], 2), bValue = _bEntries$i[1];
        if (aValue !== bValue) return false;
    }
    return true;
};
var $c2ac317f102b507f$export$3dad1db244472f32 = function toStatsigUser(identifiers, customAttributes) {
    // Re-map `stableId` to `stableID` to match Statsig's native type.
    var stableId = identifiers.stableId, otherIdentifiers = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(identifiers, $c2ac317f102b507f$var$_excluded);
    var user = {
        customIDs: $c2ac317f102b507f$var$_objectSpread($c2ac317f102b507f$var$_objectSpread({}, otherIdentifiers), stableId !== undefined ? {
            stableID: stableId
        } : {}),
        custom: customAttributes
    };
    if (identifiers.atlassianAccountId) user.userID = identifiers.atlassianAccountId;
    return user;
};
function $c2ac317f102b507f$export$1148cb79ceecd5fa(target) {
    for(var _len = arguments.length, sources = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)sources[_key - 1] = arguments[_key];
    if (!sources.length) return target;
    var source = sources.shift();
    if (source === undefined || source === null) return $c2ac317f102b507f$export$1148cb79ceecd5fa.apply(void 0, [
        target
    ].concat((0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(sources)));
    for(var _i = 0, _Object$entries = Object.entries(source); _i < _Object$entries.length; _i++){
        var _Object$entries$_i = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_Object$entries[_i], 2), key = _Object$entries$_i[0], src = _Object$entries$_i[1];
        var dst = target[key];
        var srcIsObj = src && (0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(src) === 'object' && !Array.isArray(src);
        var dstIsObj = dst && (0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(dst) === 'object' && !Array.isArray(dst);
        if (srcIsObj && dstIsObj) target[key] = $c2ac317f102b507f$export$1148cb79ceecd5fa(dst, src);
        else target[key] = src;
    }
    return $c2ac317f102b507f$export$1148cb79ceecd5fa.apply(void 0, [
        target
    ].concat((0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(sources)));
}
var $c2ac317f102b507f$export$202946b690d26d22 = function migrateInitializationOptions(options) {
    var api = options.api, disableCurrentPageLogging = options.disableCurrentPageLogging, loggingIntervalMillis = options.loggingIntervalMillis, loggingBufferMaxSize = options.loggingBufferMaxSize, localMode = options.localMode, eventLoggingApi = options.eventLoggingApi, eventLoggingApiForRetries = options.eventLoggingApiForRetries, disableLocalStorage = options.disableLocalStorage, ignoreWindowUndefined = options.ignoreWindowUndefined, disableAllLogging = options.disableAllLogging, _initTimeoutMs = options.initTimeoutMs, _disableNetworkKeepalive = options.disableNetworkKeepalive, _overrideStableID = options.overrideStableID, _disableErrorLogging = options.disableErrorLogging, _disableAutoMetricsLogging = options.disableAutoMetricsLogging, rest = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(options, $c2ac317f102b507f$var$_excluded2);
    return $c2ac317f102b507f$var$_objectSpread($c2ac317f102b507f$var$_objectSpread({}, rest), {}, {
        networkConfig: {
            api: api,
            logEventUrl: eventLoggingApi ? eventLoggingApi + 'rgstr' : undefined,
            logEventFallbackUrls: eventLoggingApiForRetries ? [
                eventLoggingApiForRetries
            ] : undefined,
            preventAllNetworkTraffic: localMode || !ignoreWindowUndefined && typeof window === 'undefined'
        },
        includeCurrentPageUrlWithEvents: !disableCurrentPageLogging,
        loggingIntervalMs: loggingIntervalMillis,
        loggingBufferMaxSize: loggingBufferMaxSize,
        disableStorage: disableLocalStorage === undefined ? localMode : disableLocalStorage,
        disableLogging: disableAllLogging === undefined ? localMode : disableAllLogging
    });
};
var $c2ac317f102b507f$var$evaluationReasonMappings = Object.entries((0, $48eYA.EvaluationReason)).map(function(_ref5) {
    var _ref6 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_ref5, 2), key = _ref6[0], value = _ref6[1];
    return [
        key.toLowerCase(),
        value
    ];
});
var $c2ac317f102b507f$export$18ad168d3dbac899 = function migrateEvaluationDetails(details) {
    var _evaluationReasonMapp, _evaluationReasonMapp2, _details$receivedAt;
    var reasonLower = details.reason.toLowerCase();
    return {
        reason: (_evaluationReasonMapp = (_evaluationReasonMapp2 = $c2ac317f102b507f$var$evaluationReasonMappings.find(function(_ref7) {
            var _ref8 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_ref7, 1), key = _ref8[0];
            return reasonLower.includes(key);
        })) === null || _evaluationReasonMapp2 === void 0 ? void 0 : _evaluationReasonMapp2[1]) !== null && _evaluationReasonMapp !== void 0 ? _evaluationReasonMapp : (0, $48eYA.EvaluationReason).Unknown,
        time: (_details$receivedAt = details.receivedAt) !== null && _details$receivedAt !== void 0 ? _details$receivedAt : Date.now()
    };
};
var $c2ac317f102b507f$export$55fd683752d01e67 = function migrateSecondaryExposures(secondaryExposures) {
    return secondaryExposures.map(function(exposure) {
        if (typeof exposure === 'string') // This should ideally have gateValue and ruleID fields too, but it's not possible for us
        // to determine the correct values for these.
        return {
            gate: exposure
        };
        return exposure;
    });
};

});
parcelRegister("c2e6M", function(module, exports) {
$parcel$export(module.exports, "isFedRamp", () => $8c309d9222a86dd8$export$64d6499adf9b2e51);

var $km6mj = parcelRequire("km6mj");
function $8c309d9222a86dd8$export$64d6499adf9b2e51() {
    var _global$location;
    var global = globalThis;
    // MICROS_PERIMETER is already used by few products, so we need to keep it for backward compatibility
    var env = global.MICROS_PERIMETER || global.UNSAFE_ATL_CONTEXT_BOUNDARY;
    if (env) return env === (0, $km6mj.FEDRAMP_MODERATE);
    var matches = (_global$location = global.location) === null || _global$location === void 0 || (_global$location = _global$location.hostname) === null || _global$location === void 0 ? void 0 : _global$location.match(/atlassian-us-gov-mod\.(com|net)|atlassian-us-gov\.(com|net)|atlassian-fex\.(com|net)|atlassian-stg-fedm\.(com|net)/);
    return matches ? matches.length > 0 : false;
}

});
parcelRegister("km6mj", function(module, exports) {
$parcel$export(module.exports, "FEDRAMP_MODERATE", () => $ed1acb7014ed705c$export$ce553301d55c2fd8);
var $ed1acb7014ed705c$export$ce553301d55c2fd8 = 'fedramp-moderate';
var $ed1acb7014ed705c$export$f005e2e9f707cb5f = 'commercial';
var $ed1acb7014ed705c$export$bd6b5a7802d76127 = 'fedramp-fedex';
var $ed1acb7014ed705c$export$a739cd5aac835909 = 'stg';
var $ed1acb7014ed705c$export$42dd0cdd351a4a9 = 'prod';
var $ed1acb7014ed705c$export$404582bc18fe4d9e = 'dev';

});


parcelRegister("48eYA", function(module, exports) {
$parcel$export(module.exports, "EvaluationReason", () => $302386bafd9817fa$export$c62558b199e46828);
// Reference: https://github.com/statsig-io/js-lite/blob/main/src/StatsigStore.ts
var $302386bafd9817fa$export$c62558b199e46828 = {
    // Order is important since the logic for migrating from a new client reason to an old one
    // returns the first which is a substring of the new client reason
    Error: 'Error',
    LocalOverride: 'LocalOverride',
    Unrecognized: 'Unrecognized',
    Uninitialized: 'Uninitialized',
    NetworkNotModified: 'NetworkNotModified',
    Network: 'Network',
    InvalidBootstrap: 'InvalidBootstrap',
    Bootstrap: 'Bootstrap',
    Cache: 'Cache',
    // For when we could not migrate the reason from the new client
    Unknown: 'Unknown'
}; // Reference: https://github.com/statsig-io/js-lite/blob/main/src/StatsigSDKOptions.ts

});

parcelRegister("hiARP", function(module, exports) {
$parcel$export(module.exports, "FeatureGateEnvironment", () => $c980b728ce393d17$export$479e7351a733299);
$parcel$export(module.exports, "PerimeterType", () => $c980b728ce393d17$export$c42b7bbc5e7ba555);
/**
 * The identifiers for the user. Options are restricted to the set that is currently supported.
 */ /**
 * Base client options. Does not include any options specific to providers
 * @interface BaseClientOptions
 * @property {FeatureGateEnvironment} environment - The environment for the client.
 * @property {string} targetApp - The target app for the client.
 * @property {AnalyticsWebClient} analyticsWebClient - The analytics web client.
 * @property {PerimeterType} perimeter - The perimeter for the client.
 */ /**
 * The options for the client.
 * @interface ClientOptions
 * @extends {BaseClientOptions}
 * @property {string} apiKey - The API key for the client.
 * @property {fetchTimeoutMs} fetchTimeoutMs - The timeout for the fetch request in milliseconds. Defaults to 5000.
 * @property {boolean} useGatewayURL - Whether to use the gateway URL. Defaults to false.
 */ /**
 * The custom attributes for the user.
 */ var $c980b728ce393d17$export$479e7351a733299 = {
    Development: 'development',
    Staging: 'staging',
    Production: 'production'
};
var $c980b728ce393d17$export$c42b7bbc5e7ba555 = {
    COMMERCIAL: 'commercial',
    FEDRAMP_MODERATE: 'fedramp-moderate'
};
var $c980b728ce393d17$export$42f4885608027d0c = 'non_boolean'; // Type magic to get the JSDoc comments from the Client class methods to appear on the static
 // methods in FeatureGates where the property name and function type are identical

});



parcelRegister("eVlof", function(module, exports) {
$parcel$export(module.exports, "Layer", () => $add6fb2e41b0a16b$export$936d0764594b6eb3);

var $ekGgq = parcelRequire("ekGgq");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $gIeKg = parcelRequire("gIeKg");
var $add6fb2e41b0a16b$export$936d0764594b6eb3 = /*#__PURE__*/ function() {
    function Layer(name, layerValue, ruleID, evaluationDetails) {
        var logParameterFunction = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
        var secondaryExposures = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : [];
        var undelegatedSecondaryExposures = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : [];
        var allocatedExperimentName = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : '';
        var explicitParameters = arguments.length > 8 && arguments[8] !== undefined ? arguments[8] : [];
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, Layer);
        this._logParameterFunction = logParameterFunction;
        this._name = name;
        this._value = JSON.parse(JSON.stringify(layerValue !== null && layerValue !== void 0 ? layerValue : {}));
        this._ruleID = ruleID !== null && ruleID !== void 0 ? ruleID : '';
        this._evaluationDetails = evaluationDetails;
        this._secondaryExposures = secondaryExposures;
        this._undelegatedSecondaryExposures = undelegatedSecondaryExposures;
        this._allocatedExperimentName = allocatedExperimentName;
        this._explicitParameters = explicitParameters;
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(Layer, [
        {
            key: "get",
            value: function get(key, defaultValue, typeGuard) {
                var _this = this;
                var val = this._value[key];
                if (val == null) return defaultValue;
                var logAndReturn = function logAndReturn() {
                    _this._logLayerParameterExposure(key);
                    return val;
                };
                if (typeGuard) return typeGuard(val) ? logAndReturn() : defaultValue;
                if (defaultValue == null) return logAndReturn();
                if ((0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(val) === (0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(defaultValue) && Array.isArray(defaultValue) === Array.isArray(val)) return logAndReturn();
                return defaultValue;
            }
        },
        {
            key: "getValue",
            value: function getValue(key, defaultValue) {
                // eslint-disable-next-line eqeqeq
                if (defaultValue == undefined) defaultValue = null;
                var val = this._value[key];
                if (val != null) this._logLayerParameterExposure(key);
                return val !== null && val !== void 0 ? val : defaultValue;
            }
        },
        {
            key: "_logLayerParameterExposure",
            value: function _logLayerParameterExposure(parameterName) {
                var _this$_logParameterFu;
                (_this$_logParameterFu = this._logParameterFunction) === null || _this$_logParameterFu === void 0 || _this$_logParameterFu.call(this, this, parameterName);
            }
        }
    ], [
        {
            key: "fromLayer",
            value: function fromLayer(layer) {
                var _layer$__evaluation$s, _layer$__evaluation, _layer$__evaluation$u, _layer$__evaluation2, _layer$__evaluation3, _layer$__evaluation4;
                var value = new Layer(layer.name, layer.__value, layer.ruleID, (0, $gIeKg.migrateEvaluationDetails)(layer.details), function(_layer, parameterName) {
                    return layer.get(parameterName);
                }, (0, $gIeKg.migrateSecondaryExposures)((_layer$__evaluation$s = (_layer$__evaluation = layer.__evaluation) === null || _layer$__evaluation === void 0 ? void 0 : _layer$__evaluation.secondary_exposures) !== null && _layer$__evaluation$s !== void 0 ? _layer$__evaluation$s : []), (0, $gIeKg.migrateSecondaryExposures)((_layer$__evaluation$u = (_layer$__evaluation2 = layer.__evaluation) === null || _layer$__evaluation2 === void 0 ? void 0 : _layer$__evaluation2.undelegated_secondary_exposures) !== null && _layer$__evaluation$u !== void 0 ? _layer$__evaluation$u : []), (_layer$__evaluation3 = layer.__evaluation) === null || _layer$__evaluation3 === void 0 ? void 0 : _layer$__evaluation3.allocated_experiment_name, (_layer$__evaluation4 = layer.__evaluation) === null || _layer$__evaluation4 === void 0 ? void 0 : _layer$__evaluation4.explicit_parameters);
                return value;
            }
        }
    ]);
}();

});

parcelRegister("hzt3R", function(module, exports) {
$parcel$export(module.exports, "default", () => $ccac3f82e336f7d5$export$2e2bcd8739ae039);

var $25nEq = parcelRequire("25nEq");

var $fL8KA = parcelRequire("fL8KA");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $6HG4S = parcelRequire("6HG4S");

var $hiARP = parcelRequire("hiARP");

var $7HOhT = parcelRequire("7HOhT");

var $iIEZa = parcelRequire("iIEZa");
function $ccac3f82e336f7d5$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $ccac3f82e336f7d5$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $ccac3f82e336f7d5$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $ccac3f82e336f7d5$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $ccac3f82e336f7d5$var$DEFAULT_REQUEST_TIMEOUT_MS = 5000;
var $ccac3f82e336f7d5$export$250a58ecde616daa = 'https://api.atlassian.com/flags';
var $ccac3f82e336f7d5$export$942ba04389b0d5a2 = 'https://api.stg.atlassian.com/flags';
var $ccac3f82e336f7d5$export$f058dbf75c3bc647 = 'https://api.dev.atlassian.com/flags';
var $ccac3f82e336f7d5$export$1a401a0da8da3565 = 'https://api.stg.atlassian-us-gov-mod.com/flags';
var $ccac3f82e336f7d5$export$18c93900db9358a4 = 'https://api.atlassian-us-gov-mod.com/flags';
var $ccac3f82e336f7d5$export$4e8a0415edbfa1f7 = 'https://atlassian-statsig-proxy-archetype.atl-paas.%s.atl-ic.net';
var $ccac3f82e336f7d5$export$cb3cd156f70d7e94 = 'oasis-stg.com/flags';
var $ccac3f82e336f7d5$export$921fbc6cdfd4eee0 = 'atlassian-isolated.net/flags';
var $ccac3f82e336f7d5$export$450bd8fb2a6d7ace = '/gateway/api/flags';
var $ccac3f82e336f7d5$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function Fetcher() {
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, Fetcher);
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(Fetcher, null, [
        {
            key: "fetchClientSdk",
            value: function() {
                var _fetchClientSdk = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee(fetcherOptions) {
                    var targetApp, url, _t;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                targetApp = fetcherOptions.targetApp;
                                url = "/api/v2/frontend/clientSdkKey/".concat(targetApp);
                                _context.prev = 1;
                                _context.next = 2;
                                return this.fetchRequest(url, 'GET', fetcherOptions);
                            case 2:
                                return _context.abrupt("return", _context.sent);
                            case 3:
                                _context.prev = 3;
                                _t = _context["catch"](1);
                                if (!(_t instanceof Error)) {
                                    _context.next = 4;
                                    break;
                                }
                                throw _t;
                            case 4:
                                throw Error('Failed to retrieve client sdk key');
                            case 5:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee, this, [
                        [
                            1,
                            3
                        ]
                    ]);
                }));
                function fetchClientSdk(_x) {
                    return _fetchClientSdk.apply(this, arguments);
                }
                return fetchClientSdk;
            }()
        },
        {
            key: "fetchExperimentValues",
            value: function() {
                var _fetchExperimentValues = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee2(fetcherOptions, identifiers, customAttributes) {
                    var requestBody, _t2;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                requestBody = {
                                    identifiers: identifiers,
                                    customAttributes: customAttributes,
                                    targetApp: fetcherOptions.targetApp
                                };
                                _context2.prev = 1;
                                _context2.next = 2;
                                return this.fetchRequest('/api/v2/frontend/experimentValues', 'POST', fetcherOptions, requestBody);
                            case 2:
                                return _context2.abrupt("return", _context2.sent);
                            case 3:
                                _context2.prev = 3;
                                _t2 = _context2["catch"](1);
                                if (!(_t2 instanceof Error)) {
                                    _context2.next = 4;
                                    break;
                                }
                                throw _t2;
                            case 4:
                                throw Error('Failed to retrieve experiment values');
                            case 5:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2, this, [
                        [
                            1,
                            3
                        ]
                    ]);
                }));
                function fetchExperimentValues(_x2, _x3, _x4) {
                    return _fetchExperimentValues.apply(this, arguments);
                }
                return fetchExperimentValues;
            }()
        },
        {
            key: "handleResponseError",
            value: function() {
                var _handleResponseError = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee3(response) {
                    var body;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context3) {
                        while(true)switch(_context3.prev = _context3.next){
                            case 0:
                                if (response.ok) {
                                    _context3.next = 2;
                                    break;
                                }
                                _context3.next = 1;
                                return response.text();
                            case 1:
                                body = _context3.sent;
                                throw new (0, $iIEZa.ResponseError)("Non 2xx response status received, status: ".concat(response.status, ", body: ").concat(JSON.stringify(body)));
                            case 2:
                                if (!(response.status === 204)) {
                                    _context3.next = 3;
                                    break;
                                }
                                throw new (0, $iIEZa.ResponseError)('Unexpected 204 response');
                            case 3:
                            case "end":
                                return _context3.stop();
                        }
                    }, _callee3);
                }));
                function handleResponseError(_x5) {
                    return _handleResponseError.apply(this, arguments);
                }
                return handleResponseError;
            }()
        },
        {
            key: "extractResponseBody",
            value: function() {
                var _extractResponseBody = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee4(response) {
                    var value;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context4) {
                        while(true)switch(_context4.prev = _context4.next){
                            case 0:
                                _context4.next = 1;
                                return response.text();
                            case 1:
                                value = _context4.sent;
                                return _context4.abrupt("return", JSON.parse(value));
                            case 2:
                            case "end":
                                return _context4.stop();
                        }
                    }, _callee4);
                }));
                function extractResponseBody(_x6) {
                    return _extractResponseBody.apply(this, arguments);
                }
                return extractResponseBody;
            }()
        },
        {
            key: "getBaseUrl",
            value: function getBaseUrl(serviceEnv) {
                var useGatewayUrl = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
                var perimeter = arguments.length > 2 ? arguments[2] : undefined;
                var isolationContextId = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
                if (useGatewayUrl) return $ccac3f82e336f7d5$export$450bd8fb2a6d7ace;
                if (perimeter === (0, $hiARP.PerimeterType).FEDRAMP_MODERATE) switch(serviceEnv){
                    case (0, $hiARP.FeatureGateEnvironment).Production:
                        return $ccac3f82e336f7d5$export$18c93900db9358a4;
                    case (0, $hiARP.FeatureGateEnvironment).Staging:
                        return $ccac3f82e336f7d5$export$1a401a0da8da3565;
                    default:
                        throw new Error("Invalid environment \"".concat(serviceEnv, "\" for \"").concat(perimeter, "\" perimeter"));
                }
                else if (perimeter === (0, $hiARP.PerimeterType).COMMERCIAL) switch(serviceEnv){
                    case (0, $hiARP.FeatureGateEnvironment).Development:
                        return $ccac3f82e336f7d5$export$f058dbf75c3bc647;
                    case (0, $hiARP.FeatureGateEnvironment).Staging:
                        var apiUrl = this.getApiUrl(isolationContextId);
                        if (apiUrl !== null) return apiUrl;
                        return $ccac3f82e336f7d5$export$942ba04389b0d5a2;
                    default:
                        var prodApiUrl = this.getApiUrl(isolationContextId);
                        if (prodApiUrl !== null) return prodApiUrl;
                        return $ccac3f82e336f7d5$export$250a58ecde616daa;
                }
                else throw new Error("Invalid perimeter \"".concat(perimeter, "\""));
            }
        },
        {
            key: "fetchRequest",
            value: function() {
                var _fetchRequest = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee5(path, method, fetcherOptions, body) {
                    var baseUrl, fetchTimeout, abortSignal, abortController, response;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context5) {
                        while(true)switch(_context5.prev = _context5.next){
                            case 0:
                                baseUrl = Fetcher.getBaseUrl(fetcherOptions.environment, fetcherOptions.useGatewayURL, fetcherOptions.perimeter, fetcherOptions.isolationContextId);
                                fetchTimeout = fetcherOptions.fetchTimeoutMs || $ccac3f82e336f7d5$var$DEFAULT_REQUEST_TIMEOUT_MS;
                                if (AbortSignal.timeout) abortSignal = AbortSignal.timeout(fetchTimeout);
                                else if (AbortController) {
                                    abortController = new AbortController();
                                    abortSignal = abortController.signal;
                                    setTimeout(function() {
                                        return abortController.abort();
                                    }, fetchTimeout);
                                }
                                _context5.next = 1;
                                return fetch("".concat(baseUrl).concat(path), $ccac3f82e336f7d5$var$_objectSpread({
                                    method: method,
                                    headers: {
                                        'Content-Type': 'application/json',
                                        'X-Client-Name': 'feature-gate-js-client',
                                        'X-Client-Version': (0, $7HOhT.CLIENT_VERSION),
                                        'X-API-KEY': fetcherOptions.apiKey
                                    },
                                    signal: abortSignal
                                }, body && {
                                    body: JSON.stringify(body)
                                }));
                            case 1:
                                response = _context5.sent;
                                _context5.next = 2;
                                return this.handleResponseError(response);
                            case 2:
                                _context5.next = 3;
                                return this.extractResponseBody(response);
                            case 3:
                                return _context5.abrupt("return", _context5.sent);
                            case 4:
                            case "end":
                                return _context5.stop();
                        }
                    }, _callee5, this);
                }));
                function fetchRequest(_x7, _x8, _x9, _x0) {
                    return _fetchRequest.apply(this, arguments);
                }
                return fetchRequest;
            }()
        },
        {
            key: "getApiUrl",
            value: function getApiUrl(isolationContextId) {
                var window1 = this.getWindowLocation();
                if (window1 === undefined) {
                    //this is needed when this SDK is used for SSR or plugin use cases where secret keys not available to use backend SDKs
                    if (!isolationContextId) return null;
                    return $ccac3f82e336f7d5$export$4e8a0415edbfa1f7.replace('%s', isolationContextId);
                }
                var protocol = window1.protocol, hostname = window1.hostname;
                // Match last subdomain fragment before oasis-stg.com
                var oasisMatch = hostname.match(/([^.]+)\.oasis-stg\.com$/);
                if (oasisMatch) return "".concat(protocol, "//api.").concat(oasisMatch[1], ".").concat($ccac3f82e336f7d5$export$cb3cd156f70d7e94);
                // Match last subdomain fragment before atlassian-isolated.net
                var isolatedMatch = hostname.match(/([^.]+)\.atlassian-isolated\.net$/);
                if (isolatedMatch) return "".concat(protocol, "//api.").concat(isolatedMatch[1], ".").concat($ccac3f82e336f7d5$export$921fbc6cdfd4eee0);
                return null;
            }
        },
        {
            key: "getWindowLocation",
            value: function getWindowLocation() {
                if (typeof window !== 'undefined' && window.location) return window.location;
                return undefined;
            }
        }
    ]);
}();

});
parcelRegister("7HOhT", function(module, exports) {
$parcel$export(module.exports, "CLIENT_VERSION", () => $59c38ea379168cf9$export$a59f8d67326bd1cb);
/// <reference types="node" />
var $59c38ea379168cf9$export$a59f8d67326bd1cb = "5.8.0";

});

parcelRegister("iIEZa", function(module, exports) {
$parcel$export(module.exports, "ResponseError", () => $da0c20ebcdf51855$export$286baf652d0b1206);

var $arMYe = parcelRequire("arMYe");

var $9P61R = parcelRequire("9P61R");

var $kIXpt = parcelRequire("kIXpt");

var $cYPzS = parcelRequire("cYPzS");

var $eyuDe = parcelRequire("eyuDe");

var $c7s0H = parcelRequire("c7s0H");
function $da0c20ebcdf51855$var$_callSuper(t, o, e) {
    return o = (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(o), (0, (/*@__PURE__*/$parcel$interopDefault($kIXpt)))(t, $da0c20ebcdf51855$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(t).constructor) : o.apply(t, e));
}
function $da0c20ebcdf51855$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($da0c20ebcdf51855$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $da0c20ebcdf51855$export$286baf652d0b1206 = /*#__PURE__*/ function(_Error) {
    function ResponseError(message) {
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, ResponseError);
        return $da0c20ebcdf51855$var$_callSuper(this, ResponseError, [
            message
        ]);
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($eyuDe)))(ResponseError, _Error);
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(ResponseError);
}(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($c7s0H)))(Error));

});


parcelRegister("2usPa", function(module, exports) {
$parcel$export(module.exports, "NoFetchDataAdapter", () => $1d04be09211aff82$export$55fffef3474104af);

var $fL8KA = parcelRequire("fL8KA");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $kIXpt = parcelRequire("kIXpt");

var $cYPzS = parcelRequire("cYPzS");

var $lwlXp = parcelRequire("lwlXp");

var $eyuDe = parcelRequire("eyuDe");

var $25nEq = parcelRequire("25nEq");

var $6HG4S = parcelRequire("6HG4S");

var $a0vkc = parcelRequire("a0vkc");
function $1d04be09211aff82$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $1d04be09211aff82$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $1d04be09211aff82$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $1d04be09211aff82$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $1d04be09211aff82$var$_callSuper(t, o, e) {
    return o = (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(o), (0, (/*@__PURE__*/$parcel$interopDefault($kIXpt)))(t, $1d04be09211aff82$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(t).constructor) : o.apply(t, e));
}
function $1d04be09211aff82$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($1d04be09211aff82$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $1d04be09211aff82$var$_superPropGet(t, o, e, r) {
    var p = (0, (/*@__PURE__*/$parcel$interopDefault($lwlXp)))((0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(1 & r ? t.prototype : t), o, e);
    return 2 & r && "function" == typeof p ? function(t) {
        return p.apply(e, t);
    } : p;
}
var $1d04be09211aff82$export$55fffef3474104af = /*#__PURE__*/ function(_DataAdapterCore) {
    function NoFetchDataAdapter() {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, NoFetchDataAdapter);
        _this = $1d04be09211aff82$var$_callSuper(this, NoFetchDataAdapter, [
            'NoFetchDataAdapter',
            'nofetch'
        ]);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "bootstrapResult", null);
        return _this;
    }
    /**
   * Make sure to call this **before** calling `initializeAsync` or `updateUserAsync` but
   * after the Statsig client has been created!
   */ (0, (/*@__PURE__*/$parcel$interopDefault($eyuDe)))(NoFetchDataAdapter, _DataAdapterCore);
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(NoFetchDataAdapter, [
        {
            key: "setBootstrapData",
            value: function setBootstrapData(data) {
                this.bootstrapResult = data ? {
                    source: 'Bootstrap',
                    data: JSON.stringify(data),
                    receivedAt: Date.now(),
                    stableID: (0, $a0vkc.StableID).get(this._getSdkKey()),
                    fullUserHash: null
                } : null;
            }
        },
        {
            key: "prefetchData",
            value: function() {
                var _prefetchData = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee(_user, _options) {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee);
                }));
                function prefetchData(_x, _x2) {
                    return _prefetchData.apply(this, arguments);
                }
                return prefetchData;
            }()
        },
        {
            key: "getDataAsync",
            value: function() {
                var _getDataAsync = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee2(_current, user, _options) {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                return _context2.abrupt("return", this.bootstrapResult && $1d04be09211aff82$var$_objectSpread($1d04be09211aff82$var$_objectSpread({}, this.bootstrapResult), {}, {
                                    fullUserHash: (0, $a0vkc._getFullUserHash)(user)
                                }));
                            case 1:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2, this);
                }));
                function getDataAsync(_x3, _x4, _x5) {
                    return _getDataAsync.apply(this, arguments);
                }
                return getDataAsync;
            }()
        },
        {
            key: "getDataSync",
            value: function getDataSync(user) {
                return this.bootstrapResult && $1d04be09211aff82$var$_objectSpread($1d04be09211aff82$var$_objectSpread({}, this.bootstrapResult), {}, {
                    fullUserHash: (0, $a0vkc._getFullUserHash)(user)
                });
            }
        },
        {
            key: "_fetchFromNetwork",
            value: function() {
                var _fetchFromNetwork2 = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee3(_current, _user, _options) {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context3) {
                        while(true)switch(_context3.prev = _context3.next){
                            case 0:
                                return _context3.abrupt("return", null);
                            case 1:
                            case "end":
                                return _context3.stop();
                        }
                    }, _callee3);
                }));
                function _fetchFromNetwork(_x6, _x7, _x8) {
                    return _fetchFromNetwork2.apply(this, arguments);
                }
                return _fetchFromNetwork;
            }()
        },
        {
            key: "_getCacheKey",
            value: function _getCacheKey(user) {
                // Same logic as default data adapter
                // https://github.com/statsig-io/js-client-monorepo/blob/main/packages/js-client/src/StatsigEvaluationsDataAdapter.ts
                var key = (0, $a0vkc._getStorageKey)(this._getSdkKey(), user);
                return "".concat((0, $a0vkc.DataAdapterCachePrefix), ".").concat(this._cacheSuffix, ".").concat(key);
            }
        },
        {
            key: "_isCachedResultValidFor204",
            value: function _isCachedResultValidFor204(_result, _user) {
                return false;
            }
        },
        {
            key: "setDataLegacy",
            value: function setDataLegacy(data, user) {
                $1d04be09211aff82$var$_superPropGet(NoFetchDataAdapter, "setData", this, 3)([
                    data,
                    user
                ]);
            }
        },
        {
            key: "toJSON",
            value: function toJSON() {
                var result = $1d04be09211aff82$var$_objectSpread({}, this);
                delete result._options;
                delete result._inMemoryCache;
                delete result.bootstrapResult;
                return result;
            }
        }
    ]);
}((0, $a0vkc.DataAdapterCore));

});

parcelRegister("j3SRh", function(module, exports) {
$parcel$export(module.exports, "LOCAL_STORAGE_KEY", () => $de08d9d5ed18ea05$export$d8474cff104280f3);
$parcel$export(module.exports, "PersistentOverrideAdapter", () => $de08d9d5ed18ea05$export$bcb28fbac1def494);

var $25nEq = parcelRequire("25nEq");

var $iYJcE = parcelRequire("iYJcE");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $328Ep = parcelRequire("328Ep");
function $de08d9d5ed18ea05$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $de08d9d5ed18ea05$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $de08d9d5ed18ea05$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $de08d9d5ed18ea05$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $de08d9d5ed18ea05$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $de08d9d5ed18ea05$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $de08d9d5ed18ea05$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $de08d9d5ed18ea05$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $de08d9d5ed18ea05$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $de08d9d5ed18ea05$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
var $de08d9d5ed18ea05$var$LOCAL_OVERRIDE_REASON = 'LocalOverride:Recognized';
var $de08d9d5ed18ea05$export$d8474cff104280f3 = 'STATSIG_OVERRIDES';
var $de08d9d5ed18ea05$var$LEGACY_LOCAL_STORAGE_KEY = 'STATSIG_JS_LITE_LOCAL_OVERRIDES';
var $de08d9d5ed18ea05$var$makeEmptyStore = function makeEmptyStore() {
    return {
        gates: {},
        configs: {},
        layers: {}
    };
};
var $de08d9d5ed18ea05$var$djb2MapKey = function djb2MapKey(hash, kind) {
    return kind + ':' + hash;
};
var $de08d9d5ed18ea05$export$bcb28fbac1def494 = /*#__PURE__*/ function() {
    function PersistentOverrideAdapter(localStorageKey) {
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, PersistentOverrideAdapter);
        this._overrides = $de08d9d5ed18ea05$var$makeEmptyStore();
        this._djb2Map = new Map();
        this._localStorageKey = localStorageKey;
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(PersistentOverrideAdapter, [
        {
            key: "parseStoredOverrides",
            value: function parseStoredOverrides(localStorageKey) {
                try {
                    var json = window.localStorage.getItem(localStorageKey);
                    if (!json) return $de08d9d5ed18ea05$var$makeEmptyStore();
                    return JSON.parse(json);
                } catch (_unused) {
                    return $de08d9d5ed18ea05$var$makeEmptyStore();
                }
            }
        },
        {
            key: "mergeOverrides",
            value: function mergeOverrides() {
                var merged = $de08d9d5ed18ea05$var$makeEmptyStore();
                for(var _len = arguments.length, allOverrides = new Array(_len), _key = 0; _key < _len; _key++)allOverrides[_key] = arguments[_key];
                for(var _i = 0, _allOverrides = allOverrides; _i < _allOverrides.length; _i++){
                    var overrides = _allOverrides[_i];
                    for(var _i2 = 0, _Object$entries = Object.entries((_overrides$gates = overrides.gates) !== null && _overrides$gates !== void 0 ? _overrides$gates : {}); _i2 < _Object$entries.length; _i2++){
                        var _overrides$gates;
                        var _Object$entries$_i = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_Object$entries[_i2], 2), name = _Object$entries$_i[0], value = _Object$entries$_i[1];
                        merged.gates[name] = value;
                    }
                    for(var _i3 = 0, _Object$entries2 = Object.entries((_overrides$configs = overrides.configs) !== null && _overrides$configs !== void 0 ? _overrides$configs : {}); _i3 < _Object$entries2.length; _i3++){
                        var _overrides$configs;
                        var _Object$entries2$_i = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_Object$entries2[_i3], 2), _name = _Object$entries2$_i[0], _value = _Object$entries2$_i[1];
                        merged.configs[_name] = _value;
                    }
                    for(var _i4 = 0, _Object$entries3 = Object.entries((_overrides$layers = overrides.layers) !== null && _overrides$layers !== void 0 ? _overrides$layers : {}); _i4 < _Object$entries3.length; _i4++){
                        var _overrides$layers;
                        var _Object$entries3$_i = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_Object$entries3[_i4], 2), _name2 = _Object$entries3$_i[0], _value2 = _Object$entries3$_i[1];
                        merged.layers[_name2] = _value2;
                    }
                }
                return merged;
            }
        },
        {
            key: "initFromStoredOverrides",
            value: function initFromStoredOverrides() {
                var storedOverrides = this.mergeOverrides(this._overrides, this.parseStoredOverrides($de08d9d5ed18ea05$var$LEGACY_LOCAL_STORAGE_KEY), this.parseStoredOverrides(this._localStorageKey));
                // Clear data from legacy local storage key now we've read from it.
                // This prevents things being stuck in there that are always read but never written to.
                try {
                    window.localStorage.removeItem($de08d9d5ed18ea05$var$LEGACY_LOCAL_STORAGE_KEY);
                } catch (_unused2) {
                // ignored - window is not defined in non-browser environments, and we don't save things there
                // (things like SSR, etc)
                }
                // In version 4.24.0 we introduced hashes in this override adapter, but had a bug which would cause
                // multiple hashes to continue being created. This code here removes these hashes since we've moved
                // to using a more reliable and easier to maintain map in `_djb2Map`.
                for(var _i5 = 0, _Object$values = Object.values(storedOverrides); _i5 < _Object$values.length; _i5++){
                    var container = _Object$values[_i5];
                    var allKeys = new Set(Object.keys(container));
                    var _iterator = $de08d9d5ed18ea05$var$_createForOfIteratorHelper(allKeys), _step;
                    try {
                        for(_iterator.s(); !(_step = _iterator.n()).done;){
                            var name = _step.value;
                            var hash = (0, $328Ep._DJB2)(name);
                            if (allKeys.has(hash)) delete container[hash];
                        }
                    } catch (err) {
                        _iterator.e(err);
                    } finally{
                        _iterator.f();
                    }
                }
                this.applyOverrides(storedOverrides);
            }
        },
        {
            key: "saveOverrides",
            value: function saveOverrides() {
                try {
                    window.localStorage.setItem(this._localStorageKey, JSON.stringify(this._overrides));
                } catch (_unused3) {
                // ignored - window is not defined in non-browser environments, and we don't save things there
                // (things like SSR, etc)
                }
            }
        },
        {
            key: "getOverrides",
            value: function getOverrides() {
                return this.mergeOverrides(this._overrides);
            }
        },
        {
            key: "applyOverrides",
            value: function applyOverrides(overrides) {
                var newOverrides = $de08d9d5ed18ea05$var$_objectSpread($de08d9d5ed18ea05$var$_objectSpread({}, $de08d9d5ed18ea05$var$makeEmptyStore()), overrides);
                this._djb2Map.clear();
                for(var _i6 = 0, _Object$entries4 = Object.entries(newOverrides); _i6 < _Object$entries4.length; _i6++){
                    var _Object$entries4$_i = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_Object$entries4[_i6], 2), containerName = _Object$entries4$_i[0], container = _Object$entries4$_i[1];
                    for(var _i7 = 0, _Object$entries5 = Object.entries(container); _i7 < _Object$entries5.length; _i7++){
                        var _Object$entries5$_i = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_Object$entries5[_i7], 2), name = _Object$entries5$_i[0], value = _Object$entries5$_i[1];
                        this._djb2Map.set($de08d9d5ed18ea05$var$djb2MapKey((0, $328Ep._DJB2)(name), containerName), value);
                    }
                }
                this._overrides = newOverrides;
            }
        },
        {
            key: "setOverrides",
            value: function setOverrides(overrides) {
                this.applyOverrides(overrides);
                this.saveOverrides();
            }
        },
        {
            key: "overrideGate",
            value: function overrideGate(name, value) {
                this._overrides.gates[name] = value;
                this._djb2Map.set($de08d9d5ed18ea05$var$djb2MapKey((0, $328Ep._DJB2)(name), 'gates'), value);
                this.saveOverrides();
            }
        },
        {
            key: "removeGateOverride",
            value: function removeGateOverride(name) {
                delete this._overrides.gates[name];
                this._djb2Map.delete($de08d9d5ed18ea05$var$djb2MapKey((0, $328Ep._DJB2)(name), 'gates'));
                this.saveOverrides();
            }
        },
        {
            key: "getGateOverride",
            value: function getGateOverride(current, _user) {
                var _this$_overrides$gate;
                var overridden = (_this$_overrides$gate = this._overrides.gates[current.name]) !== null && _this$_overrides$gate !== void 0 ? _this$_overrides$gate : this._djb2Map.get($de08d9d5ed18ea05$var$djb2MapKey(current.name, 'gates'));
                if (overridden == null) return null;
                return $de08d9d5ed18ea05$var$_objectSpread($de08d9d5ed18ea05$var$_objectSpread({}, current), {}, {
                    value: overridden,
                    details: $de08d9d5ed18ea05$var$_objectSpread($de08d9d5ed18ea05$var$_objectSpread({}, current.details), {}, {
                        reason: $de08d9d5ed18ea05$var$LOCAL_OVERRIDE_REASON
                    })
                });
            }
        },
        {
            key: "overrideDynamicConfig",
            value: function overrideDynamicConfig(name, value) {
                this._overrides.configs[name] = value;
                this._djb2Map.set($de08d9d5ed18ea05$var$djb2MapKey((0, $328Ep._DJB2)(name), 'configs'), value);
                this.saveOverrides();
            }
        },
        {
            key: "removeDynamicConfigOverride",
            value: function removeDynamicConfigOverride(name) {
                delete this._overrides.configs[name];
                this._djb2Map.delete($de08d9d5ed18ea05$var$djb2MapKey((0, $328Ep._DJB2)(name), 'configs'));
                this.saveOverrides();
            }
        },
        {
            key: "getDynamicConfigOverride",
            value: function getDynamicConfigOverride(current, _user) {
                return this._getConfigOverride(current, this._overrides.configs);
            }
        },
        {
            key: "overrideExperiment",
            value: function overrideExperiment(name, value) {
                this._overrides.configs[name] = value;
                this._djb2Map.set($de08d9d5ed18ea05$var$djb2MapKey((0, $328Ep._DJB2)(name), 'configs'), value);
                this.saveOverrides();
            }
        },
        {
            key: "removeExperimentOverride",
            value: function removeExperimentOverride(name) {
                delete this._overrides.configs[name];
                this._djb2Map.delete($de08d9d5ed18ea05$var$djb2MapKey((0, $328Ep._DJB2)(name), 'configs'));
                this.saveOverrides();
            }
        },
        {
            key: "getExperimentOverride",
            value: function getExperimentOverride(current, _user) {
                return this._getConfigOverride(current, this._overrides.configs);
            }
        },
        {
            key: "overrideLayer",
            value: function overrideLayer(name, value) {
                this._overrides.layers[name] = value;
                this._djb2Map.set($de08d9d5ed18ea05$var$djb2MapKey((0, $328Ep._DJB2)(name), 'layers'), value);
                this.saveOverrides();
            }
        },
        {
            key: "removeLayerOverride",
            value: function removeLayerOverride(name) {
                delete this._overrides.layers[name];
                this._djb2Map.delete($de08d9d5ed18ea05$var$djb2MapKey((0, $328Ep._DJB2)(name), 'layers'));
                this.saveOverrides();
            }
        },
        {
            key: "removeAllOverrides",
            value: function removeAllOverrides() {
                this._overrides = $de08d9d5ed18ea05$var$makeEmptyStore();
                try {
                    window.localStorage.removeItem(this._localStorageKey);
                } catch (_unused4) {
                // ignored - window is not defined in non-browser environments, and we don't save things there
                // (things like SSR, etc)
                }
            }
        },
        {
            key: "getLayerOverride",
            value: function getLayerOverride(current, _user) {
                var _this$_overrides$laye;
                var overridden = (_this$_overrides$laye = this._overrides.layers[current.name]) !== null && _this$_overrides$laye !== void 0 ? _this$_overrides$laye : this._djb2Map.get($de08d9d5ed18ea05$var$djb2MapKey(current.name, 'layers'));
                if (overridden == null) return null;
                return $de08d9d5ed18ea05$var$_objectSpread($de08d9d5ed18ea05$var$_objectSpread({}, current), {}, {
                    __value: overridden,
                    get: (0, $328Ep._makeTypedGet)(current.name, overridden),
                    details: $de08d9d5ed18ea05$var$_objectSpread($de08d9d5ed18ea05$var$_objectSpread({}, current.details), {}, {
                        reason: $de08d9d5ed18ea05$var$LOCAL_OVERRIDE_REASON
                    })
                });
            }
        },
        {
            key: "_getConfigOverride",
            value: function _getConfigOverride(current, lookup) {
                var _lookup$current$name;
                var overridden = (_lookup$current$name = lookup[current.name]) !== null && _lookup$current$name !== void 0 ? _lookup$current$name : this._djb2Map.get($de08d9d5ed18ea05$var$djb2MapKey(current.name, 'configs'));
                if (overridden == null) return null;
                return $de08d9d5ed18ea05$var$_objectSpread($de08d9d5ed18ea05$var$_objectSpread({}, current), {}, {
                    value: overridden,
                    get: (0, $328Ep._makeTypedGet)(current.name, overridden),
                    details: $de08d9d5ed18ea05$var$_objectSpread($de08d9d5ed18ea05$var$_objectSpread({}, current.details), {}, {
                        reason: $de08d9d5ed18ea05$var$LOCAL_OVERRIDE_REASON
                    })
                });
            }
        }
    ]);
}();

});



parcelRegister("BQskI", function(module, exports) {
$parcel$export(module.exports, "debug", () => $071c257b67cf75ad$export$1c9f709888824e05);
var $071c257b67cf75ad$var$_process, $071c257b67cf75ad$var$_process2;
// We can't rely on NODE_ENV === 'test' if its value is already configured by the consumer to some other value, so better to use JEST_WORKER_ID
// https://jestjs.io/docs/environment-variables#jest_worker_id
var $071c257b67cf75ad$var$TESTS_MODE = (globalThis === null || globalThis === void 0 || ($071c257b67cf75ad$var$_process = globalThis.process) === null || $071c257b67cf75ad$var$_process === void 0 || ($071c257b67cf75ad$var$_process = $071c257b67cf75ad$var$_process.env) === null || $071c257b67cf75ad$var$_process === void 0 ? void 0 : $071c257b67cf75ad$var$_process.JEST_WORKER_ID) !== undefined;
var $071c257b67cf75ad$var$DEBUG_MODE = !$071c257b67cf75ad$var$TESTS_MODE && (globalThis === null || globalThis === void 0 || ($071c257b67cf75ad$var$_process2 = globalThis.process) === null || $071c257b67cf75ad$var$_process2 === void 0 || ($071c257b67cf75ad$var$_process2 = $071c257b67cf75ad$var$_process2.env) === null || $071c257b67cf75ad$var$_process2 === void 0 ? void 0 : $071c257b67cf75ad$var$_process2.NODE_ENV) !== 'production';
var $071c257b67cf75ad$export$1c9f709888824e05 = function debug() {
    var _console;
    if (!$071c257b67cf75ad$var$DEBUG_MODE) return;
    // eslint-disable-next-line no-console
    (_console = console).debug.apply(_console, arguments);
};

});




parcelRegister("7lZkr", function(module, exports) {
$parcel$export(module.exports, "hash", () => $55aa1127ddfd7edb$export$d6af199866bfb566);
var $55aa1127ddfd7edb$export$d6af199866bfb566 = function hash(str) {
    var hash = 0;
    for(var i = 0; i < str.length; i++){
        var char = str.charCodeAt(i);
        hash = (hash << 5) - hash + char;
        hash &= hash; // Convert to 32bit integer
    }
    return new Uint32Array([
        hash
    ])[0].toString(36);
};

});

parcelRegister("gFy4Z", function(module, exports) {

var $iKwew = parcelRequire("iKwew");
module.exports = $iKwew("5I07s").then(()=>parcelRequire('7uI3K'));

});

parcelRegister("6hxgO", function(module, exports) {

var $iKwew = parcelRequire("iKwew");
module.exports = $iKwew("gwmb8").then(()=>parcelRequire('aMQqP'));

});

parcelRegister("kGGQc", function(module, exports) {

var $iKwew = parcelRequire("iKwew");
module.exports = $iKwew("fYnd9").then(()=>parcelRequire('cEGNn'));

});

parcelRegister("1Px1h", function(module, exports) {

var $iKwew = parcelRequire("iKwew");
module.exports = $iKwew("fSFTN").then(()=>parcelRequire('a6sSM'));

});

parcelRegister("4zl6X", function(module, exports) {

var $iKwew = parcelRequire("iKwew");
module.exports = $iKwew("dqkBw").then(()=>parcelRequire('aVWut'));

});

parcelRegister("g5BOX", function(module, exports) {

var $iKwew = parcelRequire("iKwew");
module.exports = $iKwew("lDlyF").then(()=>parcelRequire('zeVCj'));

});

parcelRegister("7rzwA", function(module, exports) {

var $iKwew = parcelRequire("iKwew");
module.exports = $iKwew("bhV0H").then(()=>parcelRequire('2Z4VQ'));

});

parcelRegister("exeGs", function(module, exports) {

var $iKwew = parcelRequire("iKwew");
module.exports = $iKwew("1jw2B").then(()=>parcelRequire('fOXJq'));

});

parcelRegister("aC2aM", function(module, exports) {

var $iKwew = parcelRequire("iKwew");
module.exports = $iKwew("cljyZ").then(()=>parcelRequire('6t7Hp'));

});

parcelRegister("cQyB6", function(module, exports) {

var $iKwew = parcelRequire("iKwew");
module.exports = $iKwew("h2PDi").then(()=>parcelRequire('iOTci'));

});

parcelRegister("hQcOh", function(module, exports) {

var $iKwew = parcelRequire("iKwew");
module.exports = $iKwew("gJRGR").then(()=>parcelRequire('AnDvQ'));

});

parcelRegister("kZC4L", function(module, exports) {
$parcel$export(module.exports, "default", () => $f4870a32dff15461$export$2e2bcd8739ae039);

var $kqp0i = parcelRequire("kqp0i");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");

var $74Zh5 = parcelRequire("74Zh5");

var $312sH = parcelRequire("312sH");

var $d33Jn = parcelRequire("d33Jn");

var $7Cqku = parcelRequire("7Cqku");
var $f4870a32dff15461$var$_excluded = [
    "as",
    "children",
    "backgroundColor",
    "padding",
    "paddingBlock",
    "paddingBlockStart",
    "paddingBlockEnd",
    "paddingInline",
    "paddingInlineStart",
    "paddingInlineEnd",
    "style",
    "testId",
    "xcss"
], $f4870a32dff15461$var$_excluded2 = [
    "className"
];
var $f4870a32dff15461$export$e71c4d32a2263218 = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? 'div' : _ref$as, children = _ref.children, backgroundColor = _ref.backgroundColor, padding = _ref.padding, paddingBlock = _ref.paddingBlock, paddingBlockStart = _ref.paddingBlockStart, paddingBlockEnd = _ref.paddingBlockEnd, paddingInline = _ref.paddingInline, paddingInlineStart = _ref.paddingInlineStart, paddingInlineEnd = _ref.paddingInlineEnd, style = _ref.style, testId = _ref.testId, xcss = _ref.xcss, htmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $f4870a32dff15461$var$_excluded);
    // This is to remove className from safeHtmlAttributes
    // @ts-ignore -- not using expect since it causes issues with help-center local consumption - className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(htmlAttributes, $f4870a32dff15461$var$_excluded2);
    var resolvedStyles = (0, $7Cqku.parseXcss)(xcss);
    var node = // @ts-expect-error Expression produces a union type that is too complex to represent. I think this is unavoidable
    (0, $74Zh5.jsx)(Component, (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        style: style,
        ref: ref,
        className: resolvedStyles.static
    }, safeHtmlAttributes, {
        css: [
            $f4870a32dff15461$var$baseStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            backgroundColor && (0, $d33Jn.backgroundColorStylesMap)[backgroundColor],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $d33Jn.isSurfaceColorToken)(backgroundColor) && (0, $d33Jn.surfaceColorStylesMap)[backgroundColor],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            padding && (0, $d33Jn.paddingStylesMap).padding[padding],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlock && (0, $d33Jn.paddingStylesMap).paddingBlock[paddingBlock],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlockStart && (0, $d33Jn.paddingStylesMap).paddingBlockStart[paddingBlockStart],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlockEnd && (0, $d33Jn.paddingStylesMap).paddingBlockEnd[paddingBlockEnd],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInline && (0, $d33Jn.paddingStylesMap).paddingInline[paddingInline],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInlineStart && (0, $d33Jn.paddingStylesMap).paddingInlineStart[paddingInlineStart],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInlineEnd && (0, $d33Jn.paddingStylesMap).paddingInlineEnd[paddingInlineEnd],
            resolvedStyles.emotion
        ],
        "data-testid": testId
    }), children);
    return backgroundColor ? (0, $74Zh5.jsx)((0, $312sH.SurfaceContext).Provider, {
        value: backgroundColor
    }, node) : node;
});
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$f4870a32dff15461$export$2e2bcd8739ae039 = $f4870a32dff15461$export$e71c4d32a2263218;
var $f4870a32dff15461$var$baseStyles = (0, $74Zh5.css)({
    boxSizing: 'border-box',
    appearance: 'none',
    border: 'none'
});

});
parcelRegister("312sH", function(module, exports) {
$parcel$export(module.exports, "SurfaceContext", () => $23235ffba20e01a6$export$1ca2a26fecb070ae);

var $5FkrB = parcelRequire("5FkrB");
var $23235ffba20e01a6$export$1ca2a26fecb070ae = /*#__PURE__*/ (0, $5FkrB.createContext)('elevation.surface');

});

parcelRegister("d33Jn", function(module, exports) {
$parcel$export(module.exports, "dimensionMap", () => $97fe730b5fff63db$export$6ccdbebca2ee545f);
$parcel$export(module.exports, "positiveSpaceMap", () => $97fe730b5fff63db$export$958d0ae7f2977ae4);
$parcel$export(module.exports, "allSpaceMap", () => $97fe730b5fff63db$export$632685d741f3dbbf);
$parcel$export(module.exports, "opacityMap", () => $97fe730b5fff63db$export$daf94a976c798b4f);
$parcel$export(module.exports, "shadowMap", () => $97fe730b5fff63db$export$7aff6e7ba39bb774);
$parcel$export(module.exports, "borderColorMap", () => $97fe730b5fff63db$export$1531ad5bb3fbedac);
$parcel$export(module.exports, "backgroundColorMap", () => $97fe730b5fff63db$export$d1d79bf68ac056bd);
$parcel$export(module.exports, "textColorMap", () => $97fe730b5fff63db$export$8473307aa00d6ea1);
$parcel$export(module.exports, "layerMap", () => $97fe730b5fff63db$export$b5f31a7e431d2eab);
$parcel$export(module.exports, "borderWidthMap", () => $97fe730b5fff63db$export$e1b83c5210c471b8);
$parcel$export(module.exports, "borderRadiusMap", () => $97fe730b5fff63db$export$3c0a6c3e64bb180d);
$parcel$export(module.exports, "fontMap", () => $97fe730b5fff63db$export$6ffa317d5e70375);
$parcel$export(module.exports, "fontWeightMap", () => $97fe730b5fff63db$export$303e322c6b1ed114);
$parcel$export(module.exports, "fontFamilyMap", () => $97fe730b5fff63db$export$3c7e9587132614b4);
$parcel$export(module.exports, "paddingStylesMap", () => $97fe730b5fff63db$export$e615f061ca585a6c);
$parcel$export(module.exports, "spaceStylesMap", () => $97fe730b5fff63db$export$bf46c3f9eeafc71f);
$parcel$export(module.exports, "backgroundColorStylesMap", () => $97fe730b5fff63db$export$e7af83bafe7f9e63);
$parcel$export(module.exports, "surfaceColorStylesMap", () => $97fe730b5fff63db$export$ff257d957d48c421);
$parcel$export(module.exports, "isSurfaceColorToken", () => $97fe730b5fff63db$export$5e65a44e5b6ecadb);

var $25nEq = parcelRequire("25nEq");

var $74Zh5 = parcelRequire("74Zh5");

var $heDc8 = parcelRequire("heDc8");
function $97fe730b5fff63db$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $97fe730b5fff63db$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $97fe730b5fff63db$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $97fe730b5fff63db$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $97fe730b5fff63db$export$6ccdbebca2ee545f = {
    '100%': '100%',
    'size.100': '1rem',
    'size.200': '1.5rem',
    'size.300': '2rem',
    'size.400': '2.5rem',
    'size.500': '3rem',
    'size.600': '6rem',
    'size.1000': '12rem'
};
var $97fe730b5fff63db$export$958d0ae7f2977ae4 = {
    'space.0': "var(--ds-space-0, 0px)",
    'space.025': "var(--ds-space-025, 2px)",
    'space.050': "var(--ds-space-050, 4px)",
    'space.075': "var(--ds-space-075, 6px)",
    'space.100': "var(--ds-space-100, 8px)",
    'space.150': "var(--ds-space-150, 12px)",
    'space.200': "var(--ds-space-200, 16px)",
    'space.250': "var(--ds-space-250, 20px)",
    'space.300': "var(--ds-space-300, 24px)",
    'space.400': "var(--ds-space-400, 32px)",
    'space.500': "var(--ds-space-500, 40px)",
    'space.600': "var(--ds-space-600, 48px)",
    'space.800': "var(--ds-space-800, 64px)",
    'space.1000': "var(--ds-space-1000, 80px)"
};
var $97fe730b5fff63db$export$d2dc61f58390201c = {
    'space.negative.025': "var(--ds-space-negative-025, -2px)",
    'space.negative.050': "var(--ds-space-negative-050, -4px)",
    'space.negative.075': "var(--ds-space-negative-075, -6px)",
    'space.negative.100': "var(--ds-space-negative-100, -8px)",
    'space.negative.150': "var(--ds-space-negative-150, -12px)",
    'space.negative.200': "var(--ds-space-negative-200, -16px)",
    'space.negative.250': "var(--ds-space-negative-250, -20px)",
    'space.negative.300': "var(--ds-space-negative-300, -24px)",
    'space.negative.400': "var(--ds-space-negative-400, -32px)"
};
var $97fe730b5fff63db$export$632685d741f3dbbf = $97fe730b5fff63db$var$_objectSpread($97fe730b5fff63db$var$_objectSpread({}, $97fe730b5fff63db$export$958d0ae7f2977ae4), $97fe730b5fff63db$export$d2dc61f58390201c);
var $97fe730b5fff63db$export$2185ce37f9bdd963 = {
    'color.background.neutral.bold': 'color.text.inverse',
    'color.background.neutral.bold.hovered': 'color.text.inverse',
    'color.background.neutral.bold.pressed': 'color.text.inverse',
    'color.background.selected.bold': 'color.text.inverse',
    'color.background.selected.bold.hovered': 'color.text.inverse',
    'color.background.selected.bold.pressed': 'color.text.inverse',
    'color.background.brand.bold': 'color.text.inverse',
    'color.background.brand.bold.hovered': 'color.text.inverse',
    'color.background.brand.bold.pressed': 'color.text.inverse',
    'color.background.brand.boldest': 'color.text.inverse',
    'color.background.brand.boldest.hovered': 'color.text.inverse',
    'color.background.brand.boldest.pressed': 'color.text.inverse',
    'color.background.danger.bold': 'color.text.inverse',
    'color.background.danger.bold.hovered': 'color.text.inverse',
    'color.background.danger.bold.pressed': 'color.text.inverse',
    'color.background.warning.bold': 'color.text.warning.inverse',
    'color.background.warning.bold.hovered': 'color.text.warning.inverse',
    'color.background.warning.bold.pressed': 'color.text.warning.inverse',
    'color.background.success.bold': 'color.text.inverse',
    'color.background.success.bold.hovered': 'color.text.inverse',
    'color.background.success.bold.pressed': 'color.text.inverse',
    'color.background.discovery.bold': 'color.text.inverse',
    'color.background.discovery.bold.hovered': 'color.text.inverse',
    'color.background.discovery.bold.pressed': 'color.text.inverse',
    'color.background.information.bold': 'color.text.inverse',
    'color.background.information.bold.hovered': 'color.text.inverse',
    'color.background.information.bold.pressed': 'color.text.inverse',
    'color.rovo.background.brand.bold': 'color.text.inverse',
    'color.rovo.background.brand.bold.hovered': 'color.text.inverse',
    'color.rovo.background.brand.bold.pressed': 'color.text.inverse'
};
var $97fe730b5fff63db$export$daf94a976c798b4f = {
    'opacity.disabled': "var(--ds-opacity-disabled, 0.4)",
    'opacity.loading': "var(--ds-opacity-loading, 0.2)"
};
var $97fe730b5fff63db$export$7aff6e7ba39bb774 = {
    'elevation.shadow.overflow': "var(--ds-shadow-overflow, 0px 0px 8px #1E1F21, 0px 0px 1px #1E1F21)",
    'elevation.shadow.overflow.perimeter': "var(--ds-shadow-overflow-perimeter, #1E1F211f)",
    'elevation.shadow.overflow.spread': "var(--ds-shadow-overflow-spread, #1E1F2129)",
    'elevation.shadow.overlay': "var(--ds-shadow-overlay, 0px 8px 12px #1E1F21, 0px 0px 1px #1E1F21)",
    'elevation.shadow.raised': "var(--ds-shadow-raised, 0px 1px 1px #1E1F21, 0px 0px 1px #1E1F21)"
};
var $97fe730b5fff63db$export$41a358c9c2356760 = {
    'elevation.surface': "var(--ds-surface, #FFFFFF)",
    'elevation.surface.hovered': "var(--ds-surface-hovered, #F0F1F2)",
    'elevation.surface.pressed': "var(--ds-surface-pressed, #DDDEE1)",
    'elevation.surface.container': "var(--ds-surface-container, #F0F1F2)",
    'elevation.surface.overlay': "var(--ds-surface-overlay, #FFFFFF)",
    'elevation.surface.overlay.hovered': "var(--ds-surface-overlay-hovered, #F0F1F2)",
    'elevation.surface.overlay.pressed': "var(--ds-surface-overlay-pressed, #DDDEE1)",
    'elevation.surface.raised': "var(--ds-surface-raised, #FFFFFF)",
    'elevation.surface.raised.hovered': "var(--ds-surface-raised-hovered, #F0F1F2)",
    'elevation.surface.raised.pressed': "var(--ds-surface-raised-pressed, #DDDEE1)",
    'elevation.surface.sunken': "var(--ds-surface-sunken, #F8F8F8)"
};
var $97fe730b5fff63db$export$1531ad5bb3fbedac = {
    'color.border': "var(--ds-border, #0B120E24)",
    'color.border.accent.lime': "var(--ds-border-accent-lime, #6A9A23)",
    'color.border.accent.lime.subtle': "var(--ds-border-accent-lime-subtle, #B3DF72)",
    'color.border.accent.red': "var(--ds-border-accent-red, #E2483D)",
    'color.border.accent.red.subtle': "var(--ds-border-accent-red-subtle, #FD9891)",
    'color.border.accent.orange': "var(--ds-border-accent-orange, #E06C00)",
    'color.border.accent.orange.subtle': "var(--ds-border-accent-orange-subtle, #FBC828)",
    'color.border.accent.yellow': "var(--ds-border-accent-yellow, #B38600)",
    'color.border.accent.yellow.subtle': "var(--ds-border-accent-yellow-subtle, #EED12B)",
    'color.border.accent.green': "var(--ds-border-accent-green, #22A06B)",
    'color.border.accent.green.subtle': "var(--ds-border-accent-green-subtle, #7EE2B8)",
    'color.border.accent.teal': "var(--ds-border-accent-teal, #2898BD)",
    'color.border.accent.teal.subtle': "var(--ds-border-accent-teal-subtle, #9DD9EE)",
    'color.border.accent.blue': "var(--ds-border-accent-blue, #357DE8)",
    'color.border.accent.blue.subtle': "var(--ds-border-accent-blue-subtle, #8FB8F6)",
    'color.border.accent.purple': "var(--ds-border-accent-purple, #AF59E1)",
    'color.border.accent.purple.subtle': "var(--ds-border-accent-purple-subtle, #D8A0F7)",
    'color.border.accent.magenta': "var(--ds-border-accent-magenta, #CD519D)",
    'color.border.accent.magenta.subtle': "var(--ds-border-accent-magenta-subtle, #F797D2)",
    'color.border.accent.gray': "var(--ds-border-accent-gray, #7D818A)",
    'color.border.accent.gray.subtle': "var(--ds-border-accent-gray-subtle, #B7B9BE)",
    'color.border.disabled': "var(--ds-border-disabled, #0515240F)",
    'color.border.focused': "var(--ds-border-focused, #4688EC)",
    'color.border.input': "var(--ds-border-input, #8C8F97)",
    'color.border.inverse': "var(--ds-border-inverse, #FFFFFF)",
    'color.border.selected': "var(--ds-border-selected, #1868DB)",
    'color.border.brand': "var(--ds-border-brand, #1868DB)",
    'color.border.danger': "var(--ds-border-danger, #E2483D)",
    'color.border.danger.subtle': "var(--ds-border-danger-subtle, #FD9891)",
    'color.border.warning': "var(--ds-border-warning, #E06C00)",
    'color.border.warning.subtle': "var(--ds-border-warning-subtle, #FBC828)",
    'color.border.success': "var(--ds-border-success, #6A9A23)",
    'color.border.success.subtle': "var(--ds-border-success-subtle, #B3DF72)",
    'color.border.discovery': "var(--ds-border-discovery, #AF59E1)",
    'color.border.discovery.subtle': "var(--ds-border-discovery-subtle, #D8A0F7)",
    'color.border.information': "var(--ds-border-information, #357DE8)",
    'color.border.information.subtle': "var(--ds-border-information-subtle, #8FB8F6)",
    'color.border.bold': "var(--ds-border-bold, #7D818A)"
};
var $97fe730b5fff63db$export$d1d79bf68ac056bd = {
    'color.background.accent.lime.subtlest': "var(--ds-background-accent-lime-subtlest, #EFFFD6)",
    'color.background.accent.lime.subtlest.hovered': "var(--ds-background-accent-lime-subtlest-hovered, #D3F1A7)",
    'color.background.accent.lime.subtlest.pressed': "var(--ds-background-accent-lime-subtlest-pressed, #BDE97C)",
    'color.background.accent.lime.subtler': "var(--ds-background-accent-lime-subtler, #D3F1A7)",
    'color.background.accent.lime.subtler.hovered': "var(--ds-background-accent-lime-subtler-hovered, #BDE97C)",
    'color.background.accent.lime.subtler.pressed': "var(--ds-background-accent-lime-subtler-pressed, #B3DF72)",
    'color.background.accent.lime.subtle': "var(--ds-background-accent-lime-subtle, #94C748)",
    'color.background.accent.lime.subtle.hovered': "var(--ds-background-accent-lime-subtle-hovered, #B3DF72)",
    'color.background.accent.lime.subtle.pressed': "var(--ds-background-accent-lime-subtle-pressed, #BDE97C)",
    'color.background.accent.lime.bolder': "var(--ds-background-accent-lime-bolder, #5B7F24)",
    'color.background.accent.lime.bolder.hovered': "var(--ds-background-accent-lime-bolder-hovered, #4C6B1F)",
    'color.background.accent.lime.bolder.pressed': "var(--ds-background-accent-lime-bolder-pressed, #3F5224)",
    'color.background.accent.red.subtlest': "var(--ds-background-accent-red-subtlest, #FFECEB)",
    'color.background.accent.red.subtlest.hovered': "var(--ds-background-accent-red-subtlest-hovered, #FFD5D2)",
    'color.background.accent.red.subtlest.pressed': "var(--ds-background-accent-red-subtlest-pressed, #FFB8B2)",
    'color.background.accent.red.subtler': "var(--ds-background-accent-red-subtler, #FFD5D2)",
    'color.background.accent.red.subtler.hovered': "var(--ds-background-accent-red-subtler-hovered, #FFB8B2)",
    'color.background.accent.red.subtler.pressed': "var(--ds-background-accent-red-subtler-pressed, #FD9891)",
    'color.background.accent.red.subtle': "var(--ds-background-accent-red-subtle, #F87168)",
    'color.background.accent.red.subtle.hovered': "var(--ds-background-accent-red-subtle-hovered, #FD9891)",
    'color.background.accent.red.subtle.pressed': "var(--ds-background-accent-red-subtle-pressed, #FFB8B2)",
    'color.background.accent.red.bolder': "var(--ds-background-accent-red-bolder, #C9372C)",
    'color.background.accent.red.bolder.hovered': "var(--ds-background-accent-red-bolder-hovered, #AE2E24)",
    'color.background.accent.red.bolder.pressed': "var(--ds-background-accent-red-bolder-pressed, #872821)",
    'color.background.accent.orange.subtlest': "var(--ds-background-accent-orange-subtlest, #FFF5DB)",
    'color.background.accent.orange.subtlest.hovered': "var(--ds-background-accent-orange-subtlest-hovered, #FCE4A6)",
    'color.background.accent.orange.subtlest.pressed': "var(--ds-background-accent-orange-subtlest-pressed, #FBD779)",
    'color.background.accent.orange.subtler': "var(--ds-background-accent-orange-subtler, #FCE4A6)",
    'color.background.accent.orange.subtler.hovered': "var(--ds-background-accent-orange-subtler-hovered, #FBD779)",
    'color.background.accent.orange.subtler.pressed': "var(--ds-background-accent-orange-subtler-pressed, #FBC828)",
    'color.background.accent.orange.subtle': "var(--ds-background-accent-orange-subtle, #FCA700)",
    'color.background.accent.orange.subtle.hovered': "var(--ds-background-accent-orange-subtle-hovered, #FBC828)",
    'color.background.accent.orange.subtle.pressed': "var(--ds-background-accent-orange-subtle-pressed, #FBD779)",
    'color.background.accent.orange.bolder': "var(--ds-background-accent-orange-bolder, #BD5B00)",
    'color.background.accent.orange.bolder.hovered': "var(--ds-background-accent-orange-bolder-hovered, #9E4C00)",
    'color.background.accent.orange.bolder.pressed': "var(--ds-background-accent-orange-bolder-pressed, #7A3B00)",
    'color.background.accent.yellow.subtlest': "var(--ds-background-accent-yellow-subtlest, #FEF7C8)",
    'color.background.accent.yellow.subtlest.hovered': "var(--ds-background-accent-yellow-subtlest-hovered, #F5E989)",
    'color.background.accent.yellow.subtlest.pressed': "var(--ds-background-accent-yellow-subtlest-pressed, #EFDD4E)",
    'color.background.accent.yellow.subtler': "var(--ds-background-accent-yellow-subtler, #F5E989)",
    'color.background.accent.yellow.subtler.hovered': "var(--ds-background-accent-yellow-subtler-hovered, #EFDD4E)",
    'color.background.accent.yellow.subtler.pressed': "var(--ds-background-accent-yellow-subtler-pressed, #EED12B)",
    'color.background.accent.yellow.subtle': "var(--ds-background-accent-yellow-subtle, #EED12B)",
    'color.background.accent.yellow.subtle.hovered': "var(--ds-background-accent-yellow-subtle-hovered, #DDB30E)",
    'color.background.accent.yellow.subtle.pressed': "var(--ds-background-accent-yellow-subtle-pressed, #EFDD4E)",
    'color.background.accent.yellow.bolder': "var(--ds-background-accent-yellow-bolder, #946F00)",
    'color.background.accent.yellow.bolder.hovered': "var(--ds-background-accent-yellow-bolder-hovered, #7F5F01)",
    'color.background.accent.yellow.bolder.pressed': "var(--ds-background-accent-yellow-bolder-pressed, #614A05)",
    'color.background.accent.green.subtlest': "var(--ds-background-accent-green-subtlest, #DCFFF1)",
    'color.background.accent.green.subtlest.hovered': "var(--ds-background-accent-green-subtlest-hovered, #BAF3DB)",
    'color.background.accent.green.subtlest.pressed': "var(--ds-background-accent-green-subtlest-pressed, #97EDC9)",
    'color.background.accent.green.subtler': "var(--ds-background-accent-green-subtler, #BAF3DB)",
    'color.background.accent.green.subtler.hovered': "var(--ds-background-accent-green-subtler-hovered, #97EDC9)",
    'color.background.accent.green.subtler.pressed': "var(--ds-background-accent-green-subtler-pressed, #7EE2B8)",
    'color.background.accent.green.subtle': "var(--ds-background-accent-green-subtle, #4BCE97)",
    'color.background.accent.green.subtle.hovered': "var(--ds-background-accent-green-subtle-hovered, #7EE2B8)",
    'color.background.accent.green.subtle.pressed': "var(--ds-background-accent-green-subtle-pressed, #97EDC9)",
    'color.background.accent.green.bolder': "var(--ds-background-accent-green-bolder, #1F845A)",
    'color.background.accent.green.bolder.hovered': "var(--ds-background-accent-green-bolder-hovered, #216E4E)",
    'color.background.accent.green.bolder.pressed': "var(--ds-background-accent-green-bolder-pressed, #19573D)",
    'color.background.accent.teal.subtlest': "var(--ds-background-accent-teal-subtlest, #E7F9FF)",
    'color.background.accent.teal.subtlest.hovered': "var(--ds-background-accent-teal-subtlest-hovered, #C6EDFB)",
    'color.background.accent.teal.subtlest.pressed': "var(--ds-background-accent-teal-subtlest-pressed, #B1E4F7)",
    'color.background.accent.teal.subtler': "var(--ds-background-accent-teal-subtler, #C6EDFB)",
    'color.background.accent.teal.subtler.hovered': "var(--ds-background-accent-teal-subtler-hovered, #B1E4F7)",
    'color.background.accent.teal.subtler.pressed': "var(--ds-background-accent-teal-subtler-pressed, #9DD9EE)",
    'color.background.accent.teal.subtle': "var(--ds-background-accent-teal-subtle, #6CC3E0)",
    'color.background.accent.teal.subtle.hovered': "var(--ds-background-accent-teal-subtle-hovered, #9DD9EE)",
    'color.background.accent.teal.subtle.pressed': "var(--ds-background-accent-teal-subtle-pressed, #B1E4F7)",
    'color.background.accent.teal.bolder': "var(--ds-background-accent-teal-bolder, #227D9B)",
    'color.background.accent.teal.bolder.hovered': "var(--ds-background-accent-teal-bolder-hovered, #206A83)",
    'color.background.accent.teal.bolder.pressed': "var(--ds-background-accent-teal-bolder-pressed, #1A5265)",
    'color.background.accent.blue.subtlest': "var(--ds-background-accent-blue-subtlest, #E9F2FE)",
    'color.background.accent.blue.subtlest.hovered': "var(--ds-background-accent-blue-subtlest-hovered, #CFE1FD)",
    'color.background.accent.blue.subtlest.pressed': "var(--ds-background-accent-blue-subtlest-pressed, #ADCBFB)",
    'color.background.accent.blue.subtler': "var(--ds-background-accent-blue-subtler, #CFE1FD)",
    'color.background.accent.blue.subtler.hovered': "var(--ds-background-accent-blue-subtler-hovered, #ADCBFB)",
    'color.background.accent.blue.subtler.pressed': "var(--ds-background-accent-blue-subtler-pressed, #8FB8F6)",
    'color.background.accent.blue.subtle': "var(--ds-background-accent-blue-subtle, #669DF1)",
    'color.background.accent.blue.subtle.hovered': "var(--ds-background-accent-blue-subtle-hovered, #8FB8F6)",
    'color.background.accent.blue.subtle.pressed': "var(--ds-background-accent-blue-subtle-pressed, #ADCBFB)",
    'color.background.accent.blue.bolder': "var(--ds-background-accent-blue-bolder, #1868DB)",
    'color.background.accent.blue.bolder.hovered': "var(--ds-background-accent-blue-bolder-hovered, #1558BC)",
    'color.background.accent.blue.bolder.pressed': "var(--ds-background-accent-blue-bolder-pressed, #144794)",
    'color.background.accent.purple.subtlest': "var(--ds-background-accent-purple-subtlest, #F8EEFE)",
    'color.background.accent.purple.subtlest.hovered': "var(--ds-background-accent-purple-subtlest-hovered, #EED7FC)",
    'color.background.accent.purple.subtlest.pressed': "var(--ds-background-accent-purple-subtlest-pressed, #E3BDFA)",
    'color.background.accent.purple.subtler': "var(--ds-background-accent-purple-subtler, #EED7FC)",
    'color.background.accent.purple.subtler.hovered': "var(--ds-background-accent-purple-subtler-hovered, #E3BDFA)",
    'color.background.accent.purple.subtler.pressed': "var(--ds-background-accent-purple-subtler-pressed, #D8A0F7)",
    'color.background.accent.purple.subtle': "var(--ds-background-accent-purple-subtle, #C97CF4)",
    'color.background.accent.purple.subtle.hovered': "var(--ds-background-accent-purple-subtle-hovered, #D8A0F7)",
    'color.background.accent.purple.subtle.pressed': "var(--ds-background-accent-purple-subtle-pressed, #E3BDFA)",
    'color.background.accent.purple.bolder': "var(--ds-background-accent-purple-bolder, #964AC0)",
    'color.background.accent.purple.bolder.hovered': "var(--ds-background-accent-purple-bolder-hovered, #803FA5)",
    'color.background.accent.purple.bolder.pressed': "var(--ds-background-accent-purple-bolder-pressed, #673286)",
    'color.background.accent.magenta.subtlest': "var(--ds-background-accent-magenta-subtlest, #FFECF8)",
    'color.background.accent.magenta.subtlest.hovered': "var(--ds-background-accent-magenta-subtlest-hovered, #FDD0EC)",
    'color.background.accent.magenta.subtlest.pressed': "var(--ds-background-accent-magenta-subtlest-pressed, #FCB6E1)",
    'color.background.accent.magenta.subtler': "var(--ds-background-accent-magenta-subtler, #FDD0EC)",
    'color.background.accent.magenta.subtler.hovered': "var(--ds-background-accent-magenta-subtler-hovered, #FCB6E1)",
    'color.background.accent.magenta.subtler.pressed': "var(--ds-background-accent-magenta-subtler-pressed, #F797D2)",
    'color.background.accent.magenta.subtle': "var(--ds-background-accent-magenta-subtle, #E774BB)",
    'color.background.accent.magenta.subtle.hovered': "var(--ds-background-accent-magenta-subtle-hovered, #F797D2)",
    'color.background.accent.magenta.subtle.pressed': "var(--ds-background-accent-magenta-subtle-pressed, #FCB6E1)",
    'color.background.accent.magenta.bolder': "var(--ds-background-accent-magenta-bolder, #AE4787)",
    'color.background.accent.magenta.bolder.hovered': "var(--ds-background-accent-magenta-bolder-hovered, #943D73)",
    'color.background.accent.magenta.bolder.pressed': "var(--ds-background-accent-magenta-bolder-pressed, #77325B)",
    'color.background.accent.gray.subtlest': "var(--ds-background-accent-gray-subtlest, #F0F1F2)",
    'color.background.accent.gray.subtlest.hovered': "var(--ds-background-accent-gray-subtlest-hovered, #DDDEE1)",
    'color.background.accent.gray.subtlest.pressed': "var(--ds-background-accent-gray-subtlest-pressed, #B7B9BE)",
    'color.background.accent.gray.subtler': "var(--ds-background-accent-gray-subtler, #DDDEE1)",
    'color.background.accent.gray.subtler.hovered': "var(--ds-background-accent-gray-subtler-hovered, #B7B9BE)",
    'color.background.accent.gray.subtler.pressed': "var(--ds-background-accent-gray-subtler-pressed, #8C8F97)",
    'color.background.accent.gray.subtle': "var(--ds-background-accent-gray-subtle, #8C8F97)",
    'color.background.accent.gray.subtle.hovered': "var(--ds-background-accent-gray-subtle-hovered, #B7B9BE)",
    'color.background.accent.gray.subtle.pressed': "var(--ds-background-accent-gray-subtle-pressed, #DDDEE1)",
    'color.background.accent.gray.bolder': "var(--ds-background-accent-gray-bolder, #6B6E76)",
    'color.background.accent.gray.bolder.hovered': "var(--ds-background-accent-gray-bolder-hovered, #505258)",
    'color.background.accent.gray.bolder.pressed': "var(--ds-background-accent-gray-bolder-pressed, #3B3D42)",
    'color.background.disabled': "var(--ds-background-disabled, #0515240F)",
    'color.background.input': "var(--ds-background-input, #FFFFFF)",
    'color.background.input.hovered': "var(--ds-background-input-hovered, #F8F8F8)",
    'color.background.input.pressed': "var(--ds-background-input-pressed, #FFFFFF)",
    'color.background.inverse.subtle': "var(--ds-background-inverse-subtle, #00000029)",
    'color.background.inverse.subtle.hovered': "var(--ds-background-inverse-subtle-hovered, #0000003D)",
    'color.background.inverse.subtle.pressed': "var(--ds-background-inverse-subtle-pressed, #00000052)",
    'color.background.neutral': "var(--ds-background-neutral, #0515240F)",
    'color.background.neutral.hovered': "var(--ds-background-neutral-hovered, #0B120E24)",
    'color.background.neutral.pressed': "var(--ds-background-neutral-pressed, #080F214A)",
    'color.background.neutral.subtle': "var(--ds-background-neutral-subtle, #00000000)",
    'color.background.neutral.subtle.hovered': "var(--ds-background-neutral-subtle-hovered, #0515240F)",
    'color.background.neutral.subtle.pressed': "var(--ds-background-neutral-subtle-pressed, #0B120E24)",
    'color.background.neutral.bold': "var(--ds-background-neutral-bold, #292A2E)",
    'color.background.neutral.bold.hovered': "var(--ds-background-neutral-bold-hovered, #3B3D42)",
    'color.background.neutral.bold.pressed': "var(--ds-background-neutral-bold-pressed, #505258)",
    'color.background.selected': "var(--ds-background-selected, #E9F2FE)",
    'color.background.selected.hovered': "var(--ds-background-selected-hovered, #CFE1FD)",
    'color.background.selected.pressed': "var(--ds-background-selected-pressed, #8FB8F6)",
    'color.background.selected.bold': "var(--ds-background-selected-bold, #1868DB)",
    'color.background.selected.bold.hovered': "var(--ds-background-selected-bold-hovered, #1558BC)",
    'color.background.selected.bold.pressed': "var(--ds-background-selected-bold-pressed, #123263)",
    'color.background.brand.subtlest': "var(--ds-background-brand-subtlest, #E9F2FE)",
    'color.background.brand.subtlest.hovered': "var(--ds-background-brand-subtlest-hovered, #CFE1FD)",
    'color.background.brand.subtlest.pressed': "var(--ds-background-brand-subtlest-pressed, #ADCBFB)",
    'color.background.brand.bold': "var(--ds-background-brand-bold, #1868DB)",
    'color.background.brand.bold.hovered': "var(--ds-background-brand-bold-hovered, #1558BC)",
    'color.background.brand.bold.pressed': "var(--ds-background-brand-bold-pressed, #144794)",
    'color.background.brand.boldest': "var(--ds-background-brand-boldest, #1C2B42)",
    'color.background.brand.boldest.hovered': "var(--ds-background-brand-boldest-hovered, #123263)",
    'color.background.brand.boldest.pressed': "var(--ds-background-brand-boldest-pressed, #144794)",
    'color.background.danger': "var(--ds-background-danger, #FFECEB)",
    'color.background.danger.hovered': "var(--ds-background-danger-hovered, #FFD5D2)",
    'color.background.danger.pressed': "var(--ds-background-danger-pressed, #FFB8B2)",
    'color.background.danger.subtler': "var(--ds-background-danger-subtler, #FFD5D2)",
    'color.background.danger.subtler.hovered': "var(--ds-background-danger-subtler-hovered, #FFB8B2)",
    'color.background.danger.subtler.pressed': "var(--ds-background-danger-subtler-pressed, #FD9891)",
    'color.background.danger.subtle': "var(--ds-background-danger-subtle, #FD9891)",
    'color.background.danger.bold': "var(--ds-background-danger-bold, #C9372C)",
    'color.background.danger.bold.hovered': "var(--ds-background-danger-bold-hovered, #AE2E24)",
    'color.background.danger.bold.pressed': "var(--ds-background-danger-bold-pressed, #872821)",
    'color.background.warning': "var(--ds-background-warning, #FFF5DB)",
    'color.background.warning.hovered': "var(--ds-background-warning-hovered, #FCE4A6)",
    'color.background.warning.pressed': "var(--ds-background-warning-pressed, #FBD779)",
    'color.background.warning.subtler': "var(--ds-background-warning-subtler, #FCE4A6)",
    'color.background.warning.subtler.hovered': "var(--ds-background-warning-subtler-hovered, #FBD779)",
    'color.background.warning.subtler.pressed': "var(--ds-background-warning-subtler-pressed, #FBC828)",
    'color.background.warning.subtle': "var(--ds-background-warning-subtle, #FBD779)",
    'color.background.warning.bold': "var(--ds-background-warning-bold, #FBC828)",
    'color.background.warning.bold.hovered': "var(--ds-background-warning-bold-hovered, #FCA700)",
    'color.background.warning.bold.pressed': "var(--ds-background-warning-bold-pressed, #F68909)",
    'color.background.success': "var(--ds-background-success, #EFFFD6)",
    'color.background.success.hovered': "var(--ds-background-success-hovered, #D3F1A7)",
    'color.background.success.pressed': "var(--ds-background-success-pressed, #BDE97C)",
    'color.background.success.subtler': "var(--ds-background-success-subtler, #D3F1A7)",
    'color.background.success.subtler.hovered': "var(--ds-background-success-subtler-hovered, #BDE97C)",
    'color.background.success.subtler.pressed': "var(--ds-background-success-subtler-pressed, #B3DF72)",
    'color.background.success.subtle': "var(--ds-background-success-subtle, #B3DF72)",
    'color.background.success.bold': "var(--ds-background-success-bold, #5B7F24)",
    'color.background.success.bold.hovered': "var(--ds-background-success-bold-hovered, #4C6B1F)",
    'color.background.success.bold.pressed': "var(--ds-background-success-bold-pressed, #3F5224)",
    'color.background.discovery': "var(--ds-background-discovery, #F8EEFE)",
    'color.background.discovery.hovered': "var(--ds-background-discovery-hovered, #EED7FC)",
    'color.background.discovery.pressed': "var(--ds-background-discovery-pressed, #E3BDFA)",
    'color.background.discovery.subtler': "var(--ds-background-discovery-subtler, #EED7FC)",
    'color.background.discovery.subtler.hovered': "var(--ds-background-discovery-subtler-hovered, #E3BDFA)",
    'color.background.discovery.subtler.pressed': "var(--ds-background-discovery-subtler-pressed, #D8A0F7)",
    'color.background.discovery.subtle': "var(--ds-background-discovery-subtle, #D8A0F7)",
    'color.background.discovery.bold': "var(--ds-background-discovery-bold, #964AC0)",
    'color.background.discovery.bold.hovered': "var(--ds-background-discovery-bold-hovered, #803FA5)",
    'color.background.discovery.bold.pressed': "var(--ds-background-discovery-bold-pressed, #673286)",
    'color.background.information': "var(--ds-background-information, #E9F2FE)",
    'color.background.information.hovered': "var(--ds-background-information-hovered, #CFE1FD)",
    'color.background.information.pressed': "var(--ds-background-information-pressed, #ADCBFB)",
    'color.background.information.subtler': "var(--ds-background-information-subtler, #CFE1FD)",
    'color.background.information.subtler.hovered': "var(--ds-background-information-subtler-hovered, #ADCBFB)",
    'color.background.information.subtler.pressed': "var(--ds-background-information-subtler-pressed, #8FB8F6)",
    'color.background.information.subtle': "var(--ds-background-information-subtle, #8FB8F6)",
    'color.background.information.bold': "var(--ds-background-information-bold, #1868DB)",
    'color.background.information.bold.hovered': "var(--ds-background-information-bold-hovered, #1558BC)",
    'color.background.information.bold.pressed': "var(--ds-background-information-bold-pressed, #144794)",
    'color.skeleton': "var(--ds-skeleton, #0515240F)",
    'color.skeleton.subtle': "var(--ds-skeleton-subtle, #17171708)",
    'color.blanket': "var(--ds-blanket, #050C1F75)",
    'color.blanket.selected': "var(--ds-blanket-selected, #388BFF14)",
    'color.blanket.danger': "var(--ds-blanket-danger, #EF5C4814)",
    'color.rovo.background.brand.bold': "var(--ds-rovo-background-brand-bold, #000000)",
    'color.rovo.background.brand.bold.hovered': "var(--ds-rovo-background-brand-bold-hovered, #1E1F21)",
    'color.rovo.background.brand.bold.pressed': "var(--ds-rovo-background-brand-bold-pressed, #292A2E)",
    'elevation.surface': "var(--ds-surface, #FFFFFF)",
    'elevation.surface.hovered': "var(--ds-surface-hovered, #F0F1F2)",
    'elevation.surface.pressed': "var(--ds-surface-pressed, #DDDEE1)",
    'elevation.surface.container': "var(--ds-surface-container, #F0F1F2)",
    'elevation.surface.overlay': "var(--ds-surface-overlay, #FFFFFF)",
    'elevation.surface.overlay.hovered': "var(--ds-surface-overlay-hovered, #F0F1F2)",
    'elevation.surface.overlay.pressed': "var(--ds-surface-overlay-pressed, #DDDEE1)",
    'elevation.surface.raised': "var(--ds-surface-raised, #FFFFFF)",
    'elevation.surface.raised.hovered': "var(--ds-surface-raised-hovered, #F0F1F2)",
    'elevation.surface.raised.pressed': "var(--ds-surface-raised-pressed, #DDDEE1)",
    'elevation.surface.sunken': "var(--ds-surface-sunken, #F8F8F8)",
    'utility.elevation.surface.current': "var(--ds-elevation-surface-current, #FFFFFF)"
};
var $97fe730b5fff63db$export$8473307aa00d6ea1 = {
    'color.text': "var(--ds-text, #292A2E)",
    'color.text.accent.lime': "var(--ds-text-accent-lime, #4C6B1F)",
    'color.text.accent.lime.bolder': "var(--ds-text-accent-lime-bolder, #37471F)",
    'color.text.accent.red': "var(--ds-text-accent-red, #AE2E24)",
    'color.text.accent.red.bolder': "var(--ds-text-accent-red-bolder, #5D1F1A)",
    'color.text.accent.orange': "var(--ds-text-accent-orange, #9E4C00)",
    'color.text.accent.orange.bolder': "var(--ds-text-accent-orange-bolder, #693200)",
    'color.text.accent.yellow': "var(--ds-text-accent-yellow, #7F5F01)",
    'color.text.accent.yellow.bolder': "var(--ds-text-accent-yellow-bolder, #533F04)",
    'color.text.accent.green': "var(--ds-text-accent-green, #216E4E)",
    'color.text.accent.green.bolder': "var(--ds-text-accent-green-bolder, #164B35)",
    'color.text.accent.teal': "var(--ds-text-accent-teal, #206A83)",
    'color.text.accent.teal.bolder': "var(--ds-text-accent-teal-bolder, #164555)",
    'color.text.accent.blue': "var(--ds-text-accent-blue, #1558BC)",
    'color.text.accent.blue.bolder': "var(--ds-text-accent-blue-bolder, #123263)",
    'color.text.accent.purple': "var(--ds-text-accent-purple, #803FA5)",
    'color.text.accent.purple.bolder': "var(--ds-text-accent-purple-bolder, #48245D)",
    'color.text.accent.magenta': "var(--ds-text-accent-magenta, #943D73)",
    'color.text.accent.magenta.bolder': "var(--ds-text-accent-magenta-bolder, #50253F)",
    'color.text.accent.gray': "var(--ds-text-accent-gray, #505258)",
    'color.text.accent.gray.bolder': "var(--ds-text-accent-gray-bolder, #1E1F21)",
    'color.text.disabled': "var(--ds-text-disabled, #080F214A)",
    'color.text.inverse': "var(--ds-text-inverse, #FFFFFF)",
    'color.text.selected': "var(--ds-text-selected, #1868DB)",
    'color.text.brand': "var(--ds-text-brand, #1868DB)",
    'color.text.danger': "var(--ds-text-danger, #AE2E24)",
    'color.text.danger.bolder': "var(--ds-text-danger-bolder, #5D1F1A)",
    'color.text.warning': "var(--ds-text-warning, #9E4C00)",
    'color.text.warning.inverse': "var(--ds-text-warning-inverse, #292A2E)",
    'color.text.warning.bolder': "var(--ds-text-warning-bolder, #693200)",
    'color.text.success': "var(--ds-text-success, #4C6B1F)",
    'color.text.success.bolder': "var(--ds-text-success-bolder, #37471F)",
    'color.text.discovery': "var(--ds-text-discovery, #803FA5)",
    'color.text.discovery.bolder': "var(--ds-text-discovery-bolder, #48245D)",
    'color.text.information': "var(--ds-text-information, #1558BC)",
    'color.text.information.bolder': "var(--ds-text-information-bolder, #123263)",
    'color.text.subtlest': "var(--ds-text-subtlest, #6B6E76)",
    'color.text.subtle': "var(--ds-text-subtle, #505258)",
    'color.link': "var(--ds-link, #1868DB)",
    'color.link.pressed': "var(--ds-link-pressed, #1558BC)",
    'color.link.visited': "var(--ds-link-visited, #803FA5)",
    'color.link.visited.pressed': "var(--ds-link-visited-pressed, #48245D)"
};
var $97fe730b5fff63db$export$498780f74be9af68 = {
    'color.icon': "var(--ds-icon, #292A2E)",
    'color.icon.accent.lime': "var(--ds-icon-accent-lime, #6A9A23)",
    'color.icon.accent.red': "var(--ds-icon-accent-red, #C9372C)",
    'color.icon.accent.orange': "var(--ds-icon-accent-orange, #E06C00)",
    'color.icon.accent.yellow': "var(--ds-icon-accent-yellow, #B38600)",
    'color.icon.accent.green': "var(--ds-icon-accent-green, #22A06B)",
    'color.icon.accent.teal': "var(--ds-icon-accent-teal, #2898BD)",
    'color.icon.accent.blue': "var(--ds-icon-accent-blue, #357DE8)",
    'color.icon.accent.purple': "var(--ds-icon-accent-purple, #AF59E1)",
    'color.icon.accent.magenta': "var(--ds-icon-accent-magenta, #CD519D)",
    'color.icon.accent.gray': "var(--ds-icon-accent-gray, #7D818A)",
    'color.icon.disabled': "var(--ds-icon-disabled, #080F214A)",
    'color.icon.inverse': "var(--ds-icon-inverse, #FFFFFF)",
    'color.icon.selected': "var(--ds-icon-selected, #1868DB)",
    'color.icon.brand': "var(--ds-icon-brand, #1868DB)",
    'color.icon.danger': "var(--ds-icon-danger, #C9372C)",
    'color.icon.warning': "var(--ds-icon-warning, #E06C00)",
    'color.icon.warning.inverse': "var(--ds-icon-warning-inverse, #292A2E)",
    'color.icon.success': "var(--ds-icon-success, #6A9A23)",
    'color.icon.discovery': "var(--ds-icon-discovery, #AF59E1)",
    'color.icon.information': "var(--ds-icon-information, #357DE8)",
    'color.icon.subtlest': "var(--ds-icon-subtlest, #6B6E76)",
    'color.icon.subtle': "var(--ds-icon-subtle, #505258)"
};
var $97fe730b5fff63db$export$b5f31a7e431d2eab = {
    '1': 1,
    card: 100,
    navigation: 200,
    dialog: 300,
    layer: 400,
    blanket: 500,
    modal: 510,
    flag: 600,
    spotlight: 700,
    tooltip: 800
};
var $97fe730b5fff63db$export$e1b83c5210c471b8 = {
    'border.width': "var(--ds-border-width, 1px)",
    'border.width.selected': "var(--ds-border-width-selected, 2px)",
    'border.width.focused': "var(--ds-border-width-focused, 2px)"
};
var $97fe730b5fff63db$export$3c0a6c3e64bb180d = {
    'radius.xsmall': "var(--ds-radius-xsmall, 2px)",
    'radius.small': "var(--ds-radius-small, 3px)",
    'radius.medium': "var(--ds-radius-medium, 6px)",
    'radius.large': "var(--ds-radius-large, 8px)",
    'radius.xlarge': "var(--ds-radius-xlarge, 12px)",
    'radius.xxlarge': "var(--ds-radius-xxlarge, 16px)",
    'radius.full': "var(--ds-radius-full, 9999px)",
    'radius.tile': "var(--ds-radius-tile, 25%)"
};
var $97fe730b5fff63db$export$6ffa317d5e70375 = {
    'font.body': "var(--ds-font-body, normal 400 14px/20px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.body.large': "var(--ds-font-body-large, normal 400 16px/24px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.body.small': "var(--ds-font-body-small, normal 400 12px/16px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.code': "var(--ds-font-code, normal 400 0.875em/1 \"Atlassian Mono\", ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)",
    'font.heading.large': "var(--ds-font-heading-large, normal 653 24px/28px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.heading.medium': "var(--ds-font-heading-medium, normal 653 20px/24px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.heading.small': "var(--ds-font-heading-small, normal 653 16px/20px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.heading.xlarge': "var(--ds-font-heading-xlarge, normal 653 28px/32px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.heading.xsmall': "var(--ds-font-heading-xsmall, normal 653 14px/20px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.heading.xxlarge': "var(--ds-font-heading-xxlarge, normal 653 32px/36px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.heading.xxsmall': "var(--ds-font-heading-xxsmall, normal 653 12px/16px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.metric.large': "var(--ds-font-metric-large, normal 653 28px/32px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.metric.medium': "var(--ds-font-metric-medium, normal 653 24px/28px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.metric.small': "var(--ds-font-metric-small, normal 653 16px/20px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
};
var $97fe730b5fff63db$export$303e322c6b1ed114 = {
    'font.weight.bold': "var(--ds-font-weight-bold, 653)",
    'font.weight.medium': "var(--ds-font-weight-medium, 500)",
    'font.weight.regular': "var(--ds-font-weight-regular, 400)",
    'font.weight.semibold': "var(--ds-font-weight-semibold, 600)"
};
var $97fe730b5fff63db$export$3c7e9587132614b4 = {
    'font.family.body': "var(--ds-font-family-body, \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.family.brand.body': "var(--ds-font-family-brand-body, \"Charlie Text\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.family.brand.heading': "var(--ds-font-family-brand-heading, \"Charlie Display\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.family.code': "var(--ds-font-family-code, \"Atlassian Mono\", ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)",
    'font.family.heading': "var(--ds-font-family-heading, \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
};
var $97fe730b5fff63db$export$236bfe3a33ef1292 = {
    medium: "var(--ds-font-body, normal 400 14px/20px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    large: "var(--ds-font-body-large, normal 400 16px/24px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    small: "var(--ds-font-body-small, normal 400 12px/16px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
};
var $97fe730b5fff63db$export$855cfd311192d666 = {
    bold: "var(--ds-font-weight-bold, 653)",
    medium: "var(--ds-font-weight-medium, 500)",
    regular: "var(--ds-font-weight-regular, 400)",
    semibold: "var(--ds-font-weight-semibold, 600)"
};
var $97fe730b5fff63db$export$b805719bc8cb376 = {
    large: "var(--ds-font-metric-large, normal 653 28px/32px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    medium: "var(--ds-font-metric-medium, normal 653 24px/28px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    small: "var(--ds-font-metric-small, normal 653 16px/20px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
};
/**
 * @codegenEnd
 */ // Margin needs some bespoke types: https://atlassian.slack.com/archives/CKRHB23K8/p1712623192772909
/**
 * Token functions are currently allowed for borderRadius in xcss to ease migration.
 * Because 'radius.small' defaults to 3px, we need a mechanism to allow for 4px values to be provided:
 * This is done by calling the token function - token('radius.small')
 *
 * TODO: Remove once shape them is rolled out and fg platform-dst-shape-theme-default removed
 */ // Generate maps for Box props. backgroundColor, padding, etc
var $97fe730b5fff63db$var$spacingProperties = [
    // Used by Box
    'padding',
    'paddingBlock',
    'paddingBlockStart',
    'paddingBlockEnd',
    'paddingInline',
    'paddingInlineStart',
    'paddingInlineEnd',
    // Used by Inline and Stack
    'gap',
    'rowGap',
    'columnGap'
];
var $97fe730b5fff63db$export$ca0f9c2de39ffed7 = function getSerializedStylesMap(cssProperty, tokenMap) {
    return Object.keys(tokenMap).reduce(function(emotionSpacingMap, token) {
        // eslint-disable-next-line @repo/internal/styles/no-exported-styles
        emotionSpacingMap[token] = (0, $74Zh5.css)((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, cssProperty, tokenMap[token]));
        return emotionSpacingMap;
    }, {});
};
var $97fe730b5fff63db$export$e615f061ca585a6c = $97fe730b5fff63db$var$spacingProperties.reduce(function(styleMap, spacingProperty) {
    styleMap[spacingProperty] = $97fe730b5fff63db$export$ca0f9c2de39ffed7(spacingProperty, $97fe730b5fff63db$export$958d0ae7f2977ae4);
    return styleMap;
}, {});
var $97fe730b5fff63db$export$bf46c3f9eeafc71f = $97fe730b5fff63db$var$spacingProperties.reduce(function(styleMap, spacingProperty) {
    styleMap[spacingProperty] = $97fe730b5fff63db$export$ca0f9c2de39ffed7(spacingProperty, $97fe730b5fff63db$export$958d0ae7f2977ae4);
    return styleMap;
}, {});
var $97fe730b5fff63db$export$e7af83bafe7f9e63 = $97fe730b5fff63db$export$ca0f9c2de39ffed7('backgroundColor', $97fe730b5fff63db$export$d1d79bf68ac056bd);
var $97fe730b5fff63db$export$3a1bcba60b23d7f0 = $97fe730b5fff63db$export$ca0f9c2de39ffed7('color', $97fe730b5fff63db$export$8473307aa00d6ea1);
var $97fe730b5fff63db$export$45f3f4fe16f9f7d5 = $97fe730b5fff63db$export$ca0f9c2de39ffed7('fontWeight', $97fe730b5fff63db$export$303e322c6b1ed114);
var $97fe730b5fff63db$export$68cc305da27dbaa4 = $97fe730b5fff63db$export$ca0f9c2de39ffed7('fontFamily', $97fe730b5fff63db$export$3c7e9587132614b4);
var $97fe730b5fff63db$export$128f10c238242f83 = $97fe730b5fff63db$export$ca0f9c2de39ffed7('font', $97fe730b5fff63db$export$6ffa317d5e70375);
var $97fe730b5fff63db$export$219d364c0da35ae4 = $97fe730b5fff63db$export$ca0f9c2de39ffed7('font', $97fe730b5fff63db$export$236bfe3a33ef1292);
var $97fe730b5fff63db$export$38845ca010b93505 = $97fe730b5fff63db$export$ca0f9c2de39ffed7('fontWeight', $97fe730b5fff63db$export$855cfd311192d666);
var $97fe730b5fff63db$export$ff257d957d48c421 = $97fe730b5fff63db$export$ca0f9c2de39ffed7((0, $heDc8.CURRENT_SURFACE_CSS_VAR), $97fe730b5fff63db$export$41a358c9c2356760);
var $97fe730b5fff63db$export$5e65a44e5b6ecadb = function isSurfaceColorToken(color) {
    return $97fe730b5fff63db$export$41a358c9c2356760[color] !== undefined;
};
var $97fe730b5fff63db$export$7001ce64d9ff7c7f = $97fe730b5fff63db$export$ca0f9c2de39ffed7('font', $97fe730b5fff63db$export$b805719bc8cb376);

});
parcelRegister("heDc8", function(module, exports) {
$parcel$export(module.exports, "CURRENT_SURFACE_CSS_VAR", () => $c8c225bfc7a9110f$export$9d7b58831ae93caa);
var $c8c225bfc7a9110f$export$4ef52930e33717cd = 'data-theme';
var $c8c225bfc7a9110f$export$cb374d25ded7f6ab = 'data-subtree-theme';
var $c8c225bfc7a9110f$export$a00eac3f8684bcd0 = 'data-color-mode';
var $c8c225bfc7a9110f$export$2112803007239c61 = 'data-contrast-mode';
var $c8c225bfc7a9110f$export$352e418ed5b6193a = 'data-custom-theme';
var $c8c225bfc7a9110f$export$6f0c6fb8c80fcc92 = 'ds';
var $c8c225bfc7a9110f$export$4d0c7bbf80185957 = [
    'opacity',
    'font',
    'space',
    'border',
    'radius'
];
var $c8c225bfc7a9110f$export$dddac1532e822863 = "--".concat($c8c225bfc7a9110f$export$6f0c6fb8c80fcc92, "-token-not-found");
var $c8c225bfc7a9110f$export$9d7b58831ae93caa = "--".concat($c8c225bfc7a9110f$export$6f0c6fb8c80fcc92, "-elevation-surface-current");

});


parcelRegister("7Cqku", function(module, exports) {
$parcel$export(module.exports, "parseXcss", () => $58c081823c4f255d$export$a9c84988c8f81f2d);
$parcel$export(module.exports, "xcss", () => $58c081823c4f255d$export$f6c783d06584602c);

var $fC8ib = parcelRequire("fC8ib");

var $25nEq = parcelRequire("25nEq");

var $iYJcE = parcelRequire("iYJcE");

var $ekGgq = parcelRequire("ekGgq");

var $74Zh5 = parcelRequire("74Zh5");

var $d33Jn = parcelRequire("d33Jn");

var $3ZMUU = parcelRequire("3ZMUU");
function $58c081823c4f255d$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $58c081823c4f255d$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $58c081823c4f255d$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $58c081823c4f255d$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $58c081823c4f255d$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $58c081823c4f255d$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
var $58c081823c4f255d$export$9a199fbafee0014e = {
    backgroundColor: (0, $d33Jn.backgroundColorMap),
    blockSize: (0, $d33Jn.dimensionMap),
    borderBlockColor: (0, $d33Jn.borderColorMap),
    borderBlockEndColor: (0, $d33Jn.borderColorMap),
    borderBlockEndWidth: (0, $d33Jn.borderWidthMap),
    borderBlockStartColor: (0, $d33Jn.borderColorMap),
    borderBlockStartWidth: (0, $d33Jn.borderWidthMap),
    borderBlockWidth: (0, $d33Jn.borderWidthMap),
    borderBottomColor: (0, $d33Jn.borderColorMap),
    borderBottomLeftRadius: (0, $d33Jn.borderRadiusMap),
    borderBottomRightRadius: (0, $d33Jn.borderRadiusMap),
    borderBottomWidth: (0, $d33Jn.borderWidthMap),
    borderColor: (0, $d33Jn.borderColorMap),
    borderEndEndRadius: (0, $d33Jn.borderRadiusMap),
    borderEndStartRadius: (0, $d33Jn.borderRadiusMap),
    borderInlineColor: (0, $d33Jn.borderColorMap),
    borderInlineEndColor: (0, $d33Jn.borderColorMap),
    borderInlineEndWidth: (0, $d33Jn.borderWidthMap),
    borderInlineStartColor: (0, $d33Jn.borderColorMap),
    borderInlineStartWidth: (0, $d33Jn.borderWidthMap),
    borderInlineWidth: (0, $d33Jn.borderWidthMap),
    borderLeftColor: (0, $d33Jn.borderColorMap),
    borderLeftWidth: (0, $d33Jn.borderWidthMap),
    borderRadius: (0, $d33Jn.borderRadiusMap),
    borderRightColor: (0, $d33Jn.borderColorMap),
    borderRightWidth: (0, $d33Jn.borderWidthMap),
    borderStartEndRadius: (0, $d33Jn.borderRadiusMap),
    borderStartStartRadius: (0, $d33Jn.borderRadiusMap),
    borderTopColor: (0, $d33Jn.borderColorMap),
    borderTopLeftRadius: (0, $d33Jn.borderRadiusMap),
    borderTopRightRadius: (0, $d33Jn.borderRadiusMap),
    borderTopWidth: (0, $d33Jn.borderWidthMap),
    borderWidth: (0, $d33Jn.borderWidthMap),
    bottom: (0, $d33Jn.allSpaceMap),
    boxShadow: (0, $d33Jn.shadowMap),
    color: (0, $d33Jn.textColorMap),
    columnGap: (0, $d33Jn.positiveSpaceMap),
    font: (0, $d33Jn.fontMap),
    fontFamily: (0, $d33Jn.fontFamilyMap),
    fontWeight: (0, $d33Jn.fontWeightMap),
    gap: (0, $d33Jn.positiveSpaceMap),
    height: (0, $d33Jn.dimensionMap),
    inlineSize: (0, $d33Jn.dimensionMap),
    inset: (0, $d33Jn.allSpaceMap),
    insetBlock: (0, $d33Jn.allSpaceMap),
    insetBlockEnd: (0, $d33Jn.allSpaceMap),
    insetBlockStart: (0, $d33Jn.allSpaceMap),
    insetInline: (0, $d33Jn.allSpaceMap),
    insetInlineEnd: (0, $d33Jn.allSpaceMap),
    insetInlineStart: (0, $d33Jn.allSpaceMap),
    left: (0, $d33Jn.allSpaceMap),
    margin: (0, $d33Jn.allSpaceMap),
    marginBlock: (0, $d33Jn.allSpaceMap),
    marginBlockEnd: (0, $d33Jn.allSpaceMap),
    marginBlockStart: (0, $d33Jn.allSpaceMap),
    marginBottom: (0, $d33Jn.allSpaceMap),
    marginInline: (0, $d33Jn.allSpaceMap),
    marginInlineEnd: (0, $d33Jn.allSpaceMap),
    marginInlineStart: (0, $d33Jn.allSpaceMap),
    marginLeft: (0, $d33Jn.allSpaceMap),
    marginRight: (0, $d33Jn.allSpaceMap),
    marginTop: (0, $d33Jn.allSpaceMap),
    maxBlockSize: (0, $d33Jn.dimensionMap),
    maxHeight: (0, $d33Jn.dimensionMap),
    maxInlineSize: (0, $d33Jn.dimensionMap),
    maxWidth: (0, $d33Jn.dimensionMap),
    minBlockSize: (0, $d33Jn.dimensionMap),
    minHeight: (0, $d33Jn.dimensionMap),
    minInlineSize: (0, $d33Jn.dimensionMap),
    minWidth: (0, $d33Jn.dimensionMap),
    opacity: (0, $d33Jn.opacityMap),
    outlineColor: (0, $d33Jn.borderColorMap),
    outlineOffset: (0, $d33Jn.allSpaceMap),
    outlineWidth: (0, $d33Jn.borderWidthMap),
    padding: (0, $d33Jn.positiveSpaceMap),
    paddingBlock: (0, $d33Jn.positiveSpaceMap),
    paddingBlockEnd: (0, $d33Jn.positiveSpaceMap),
    paddingBlockStart: (0, $d33Jn.positiveSpaceMap),
    paddingBottom: (0, $d33Jn.positiveSpaceMap),
    paddingInline: (0, $d33Jn.positiveSpaceMap),
    paddingInlineEnd: (0, $d33Jn.positiveSpaceMap),
    paddingInlineStart: (0, $d33Jn.positiveSpaceMap),
    paddingLeft: (0, $d33Jn.positiveSpaceMap),
    paddingRight: (0, $d33Jn.positiveSpaceMap),
    paddingTop: (0, $d33Jn.positiveSpaceMap),
    right: (0, $d33Jn.allSpaceMap),
    rowGap: (0, $d33Jn.positiveSpaceMap),
    top: (0, $d33Jn.allSpaceMap),
    width: (0, $d33Jn.dimensionMap),
    zIndex: (0, $d33Jn.layerMap)
};
var $58c081823c4f255d$var$uniqueSymbol = Symbol('UNSAFE_INTERNAL_styles');
var $58c081823c4f255d$var$isSafeEnvToThrow = function isSafeEnvToThrow() {
    return (typeof $3ZMUU === "undefined" ? "undefined" : (0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))($3ZMUU)) === 'object' && (0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))($3ZMUU.env) === 'object' && false;
};
var $58c081823c4f255d$var$reNestedSelectors = /(\.|\s|&+|\*\>|#|\[.*\])/;
var $58c081823c4f255d$var$safeSelectors = /^@media .*$|^::?.*$|^@supports .*$/;
var $58c081823c4f255d$var$_transformStyles = function transformStyles(styleObj) {
    if (!styleObj || (0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(styleObj) !== 'object') return styleObj;
    // If styles are defined as a CSSObject[], recursively call on each element until we reach CSSObject
    if (Array.isArray(styleObj)) return styleObj.map($58c081823c4f255d$var$_transformStyles);
    // Modifies styleObj in place. Be careful.
    Object.entries(styleObj).forEach(function(_ref) {
        var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_ref, 2), key = _ref2[0], value = _ref2[1];
        // If key is a pseudo class or a pseudo element, then value should be an object.
        // So, call transformStyles on the value
        if ((0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(value) === 'object' && $58c081823c4f255d$var$safeSelectors.test(key)) {
            styleObj[key] = $58c081823c4f255d$var$_transformStyles(value);
            return;
        }
        if ($58c081823c4f255d$var$isSafeEnvToThrow()) {
            // We don't support `.class`, `[data-testid]`, `> *`, `#some-id`
            if ($58c081823c4f255d$var$reNestedSelectors.test(key)) throw new Error("Styles not supported for key '".concat(key, "'."));
        }
        // We have now dealt with all the special cases, so,
        // check whether what remains is a style property
        // that can be transformed.
        if (!(key in $58c081823c4f255d$export$9a199fbafee0014e)) return;
        var tokenValue = $58c081823c4f255d$export$9a199fbafee0014e[key][value];
        styleObj[key] = tokenValue !== null && tokenValue !== void 0 ? tokenValue : value;
    });
    return styleObj;
};
var $58c081823c4f255d$var$baseXcss = function baseXcss(style) {
    var transformedStyles = $58c081823c4f255d$var$_transformStyles(style);
    return (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, $58c081823c4f255d$var$uniqueSymbol, (0, $74Zh5.css)(transformedStyles));
};
/**
 * Picks out runtime XCSS objects and build-time XCSS strings. This is needed
 * to supported both Emotion and Compiled styles until we've fully migrated
 * to Compiled.
 *
 * @private
 * @deprecated
 */ // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
var $58c081823c4f255d$export$a9c84988c8f81f2d = function parseXcss(args) {
    if (Array.isArray(args)) {
        var emotion = [];
        var staticArr = [];
        var _iterator = $58c081823c4f255d$var$_createForOfIteratorHelper(args), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var arg = _step.value;
                var result = $58c081823c4f255d$export$a9c84988c8f81f2d(arg);
                if (result.emotion) emotion.push.apply(emotion, (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(result.emotion));
                if (result.static) staticArr.push(result.static);
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
        return {
            emotion: emotion,
            static: staticArr.join(' ')
        };
    }
    var objArgs = args;
    var _ref4 = objArgs || {}, styles = _ref4[$58c081823c4f255d$var$uniqueSymbol];
    if (styles) return {
        emotion: [
            styles
        ]
    };
    if (args) {
        // We use string interpolation here instead of .toString() just
        // in case the resulting object doesn't have the method available.
        var stringifiedArgs = "".concat(args);
        if (stringifiedArgs) return {
            static: stringifiedArgs
        };
    }
    return {};
};
function $58c081823c4f255d$export$f6c783d06584602c(style) {
    return $58c081823c4f255d$var$baseXcss(style);
}

});


parcelRegister("xN3u9", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => (parcelRequire("81AN5")).default);
$parcel$export(module.exports, "Icon", () => (parcelRequire("81AN5")).Icon);

var $81AN5 = parcelRequire("81AN5");

});
parcelRegister("81AN5", function(module, exports) {
$parcel$export(module.exports, "Icon", () => $5d7af493b240e7b6$export$f04a61298a47a40f);
$parcel$export(module.exports, "default", () => $5d7af493b240e7b6$export$2e2bcd8739ae039);
/* icon-new.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $5FkrB = parcelRequire("5FkrB");

var $hUbY6 = parcelRequire("hUbY6");
/**
 * We are hiding this props from consumers as it's reserved for use by Icon Tile.
 */ var $5d7af493b240e7b6$var$svgStyles = null;
var $5d7af493b240e7b6$var$iconStyles = null;
var $5d7af493b240e7b6$var$smallIconStyles = null;
var $5d7af493b240e7b6$var$scaleStyles = null;
/**
 * For windows high contrast mode
 */ var $5d7af493b240e7b6$var$baseHcmStyles = null;
var $5d7af493b240e7b6$var$scaleSize = null;
var $5d7af493b240e7b6$var$coreSizeMedium = {
    none: "_1bsbpxbi _4t3ipxbi",
    compact: "_1bsb1ejb _4t3i1ejb",
    spacious: "_1bsb1ejb _4t3i1ejb"
};
var $5d7af493b240e7b6$var$coreSizeSmall = {
    none: "_1bsbutpp _4t3iutpp",
    compact: "_1bsbpxbi _4t3ipxbi",
    spacious: "_1bsb1ejb _4t3i1ejb"
};
var $5d7af493b240e7b6$var$paddingMap = {
    medium: {
        none: 0,
        compact: 4,
        spacious: 4
    },
    small: {
        none: 0,
        compact: 2.66,
        spacious: 8
    }
};
var $5d7af493b240e7b6$export$f04a61298a47a40f = /*#__PURE__*/ (0, $5FkrB.memo)(function Icon(props) {
    var _ref = props, _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, testId = _ref.testId, label = _ref.label, dangerouslySetGlyph = _ref.dangerouslySetGlyph, shouldScale = _ref.shouldScale, _ref$spacing = _ref.spacing, spacing = _ref$spacing === void 0 ? 'none' : _ref$spacing, name = _ref.name;
    var dangerouslySetInnerHTML = dangerouslySetGlyph ? {
        __html: dangerouslySetGlyph
    } : undefined;
    var size = 'medium';
    if ('size' in props && props.size !== undefined) {
        if (typeof props.size === 'string') size = props.size === 'small' || props.size === 'medium' ? props.size : size;
        else if (name) {
            var newSize = props.size(name);
            size = newSize === 'small' || newSize === 'medium' ? newSize : size;
        }
    }
    var baseSize = 16;
    var viewBoxPadding = $5d7af493b240e7b6$var$paddingMap[size][spacing];
    var viewBoxSize = baseSize + 2 * viewBoxPadding;
    return /*#__PURE__*/ $5FkrB.createElement("span", {
        "data-testid": testId,
        role: label ? 'img' : undefined,
        "aria-label": label ? label : undefined,
        "aria-hidden": label ? undefined : true,
        style: {
            color: color
        },
        className: (0, $hUbY6.default)([
            "_1e0c1o8l _vchhusvi _1o9zidpf _vwz4kb7n _y4ti1igz _bozg1mb9",
            "_12va1onz _jcxd1r8n",
            shouldScale && "_1bsb1kw7 _4t3i1kw7",
            size === 'small' && "_vwz4utpp"
        ])
    }, /*#__PURE__*/ $5FkrB.createElement("svg", {
        fill: "none",
        viewBox: "".concat(0 - viewBoxPadding, " ").concat(0 - viewBoxPadding, " ").concat(viewBoxSize, " ").concat(viewBoxSize),
        role: "presentation",
        dangerouslySetInnerHTML: dangerouslySetInnerHTML,
        className: (0, $hUbY6.default)([
            "_1reo15vq _18m915vq _syaz1r31 _lcxvglyw _s7n4yfq0 _vc881r31",
            shouldScale ? "_1bsb1kw7 _4t3i1kw7" : size === 'small' ? $5d7af493b240e7b6$var$coreSizeSmall[spacing] : $5d7af493b240e7b6$var$coreSizeMedium[spacing]
        ])
    }));
});
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$5d7af493b240e7b6$export$2e2bcd8739ae039 = $5d7af493b240e7b6$export$f04a61298a47a40f;

});


parcelRegister("4oEEp", function(module, exports) {
$parcel$export(module.exports, "HeadCell", () => $3338efb071a4b472$export$4e8024263ace498b);

var $kqp0i = parcelRequire("kqp0i");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");

var $7Cqku = parcelRequire("7Cqku");

var $kL1TB = parcelRequire("kL1TB");

var $9TAkY = parcelRequire("9TAkY");
var $3338efb071a4b472$var$_excluded = [
    "children",
    "align",
    "testId",
    "backgroundColor",
    "xcss",
    "scope",
    "tableType"
];
var $3338efb071a4b472$var$InputHeadStyle = (0, $7Cqku.xcss)({
    borderBlockWidth: 'border.width',
    borderBlockStyle: 'solid',
    borderInlineEndWidth: 'border.width',
    borderInlineEndStyle: 'solid',
    borderColor: 'color.border',
    backgroundColor: 'elevation.surface.sunken'
});
var $3338efb071a4b472$var$InventoryHeadStyle = (0, $7Cqku.xcss)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    ':last-of-type': {
        borderInlineEndWidth: 'border.width',
        borderInlineEndStyle: 'solid',
        borderColor: 'color.border'
    },
    backgroundColor: 'elevation.surface',
    height: '48px',
    borderBlockStartWidth: 'border.width',
    borderBlockStartStyle: 'solid',
    borderBlockEndWidth: 'border.width.selected',
    borderBlockEndStyle: 'solid',
    borderColor: 'color.border'
});
var $3338efb071a4b472$var$HeadCellStyle = (0, $7Cqku.xcss)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    ':first-of-type': {
        borderInlineStartWidth: 'border.width',
        borderInlineStartStyle: 'solid',
        borderColor: 'color.border',
        borderTopLeftRadius: 'radius.large'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    ':last-of-type': {
        paddingInline: 'space.100',
        borderColor: 'color.border',
        borderTopRightRadius: 'radius.large'
    },
    position: 'sticky',
    borderColor: 'color.border',
    whiteSpace: 'nowrap',
    verticalAlign: 'middle',
    color: 'color.text.subtlest',
    textAlign: 'left',
    top: 'space.0',
    // @ts-expect-error-next-line - none of the zIndex ADS tokens equate to 2
    zIndex: 2,
    paddingInline: 'space.100'
});
var $3338efb071a4b472$export$4e8024263ace498b = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function(_ref, ref) {
    var children = _ref.children, align = _ref.align, testId = _ref.testId, backgroundColor = _ref.backgroundColor, customXcss = _ref.xcss, _ref$scope = _ref.scope, scope = _ref$scope === void 0 ? 'col' : _ref$scope, _ref$tableType = _ref.tableType, tableType = _ref$tableType === void 0 ? (0, $9TAkY.TableType).input : _ref$tableType, props = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $3338efb071a4b472$var$_excluded);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $kL1TB.TH), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, props, {
        scope: scope,
        align: align,
        testId: testId,
        ref: ref,
        xcss: [
            $3338efb071a4b472$var$HeadCellStyle,
            tableType === (0, $9TAkY.TableType).inventory && $3338efb071a4b472$var$InventoryHeadStyle,
            tableType === (0, $9TAkY.TableType).input && $3338efb071a4b472$var$InputHeadStyle,
            // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- this is inline with what atlaskit primitives do.
            customXcss
        ],
        backgroundColor: backgroundColor
    }), children);
});

});
parcelRegister("kL1TB", function(module, exports) {
$parcel$export(module.exports, "TH", () => $f1c9aaead5037b92$export$2b39a3648955dd09);

var $kqp0i = parcelRequire("kqp0i");

var $5FkrB = parcelRequire("5FkrB");

var $gtBt8 = parcelRequire("gtBt8");
var $f1c9aaead5037b92$export$2b39a3648955dd09 = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $gtBt8.BaseCell), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        as: "th",
        ref: ref
    }, props));
});

});
parcelRegister("gtBt8", function(module, exports) {
$parcel$export(module.exports, "BaseCell", () => $bfec6b539f2289ce$export$41ad0bbfa4755cac);

var $5FkrB = parcelRequire("5FkrB");

var $kZC4L = parcelRequire("kZC4L");
var $7Cqku = parcelRequire("7Cqku");
/**
 * https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/Attributes/aria-sort
 */ var $bfec6b539f2289ce$var$alignLeftStyles = (0, $7Cqku.xcss)({
    textAlign: 'left'
});
var $bfec6b539f2289ce$var$alignCenterStyles = (0, $7Cqku.xcss)({
    textAlign: 'center'
});
var $bfec6b539f2289ce$var$alignRightStyles = (0, $7Cqku.xcss)({
    textAlign: 'right'
});
var $bfec6b539f2289ce$var$focusOutline = (0, $7Cqku.xcss)({
    ':focus-visible': {
        //@ts-expect-error This is a hack to get better focus styles
        boxShadow: "0 0 0 2px ".concat("var(--ds-border-focused, #4688EC)", " inset"),
        outline: 'none'
    },
    ':focus': {
        //@ts-expect-error This is a hack to get better focus styles
        boxShadow: "0 0 0 2px ".concat("var(--ds-border-focused, #4688EC)", " inset")
    }
});
var $bfec6b539f2289ce$var$alignMap = {
    text: $bfec6b539f2289ce$var$alignLeftStyles,
    number: $bfec6b539f2289ce$var$alignRightStyles,
    icon: $bfec6b539f2289ce$var$alignCenterStyles
};
var $bfec6b539f2289ce$export$41ad0bbfa4755cac = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function(_ref, ref) {
    var testId = _ref.testId, as = _ref.as, customXcss = _ref.xcss, children = _ref.children, _ref$align = _ref.align, align = _ref$align === void 0 ? 'text' : _ref$align, display = _ref.display, _ref$paddingBlock = _ref.paddingBlock, paddingBlock = _ref$paddingBlock === void 0 ? 'space.100' : _ref$paddingBlock, _ref$paddingInline = _ref.paddingInline, paddingInline = _ref$paddingInline === void 0 ? 'space.100' : _ref$paddingInline, backgroundColor = _ref.backgroundColor, scope = _ref.scope, width = _ref.width, sortDirection = _ref.sortDirection, colSpan = _ref.colSpan, onMouseEnter = _ref.onMouseEnter, onMouseLeave = _ref.onMouseLeave, tabIndex = _ref.tabIndex, onKeyDown = _ref.onKeyDown;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $kZC4L.default), {
        ref: ref,
        scope: scope,
        xcss: [
            $bfec6b539f2289ce$var$alignMap[align],
            // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $7Cqku.xcss)({
                width: width
            }),
            tabIndex === 0 && $bfec6b539f2289ce$var$focusOutline,
            customXcss
        ],
        backgroundColor: backgroundColor,
        paddingBlock: paddingBlock,
        paddingInline: paddingInline,
        as: as,
        display: display !== null && display !== void 0 ? display : 'unset',
        testId: testId,
        "aria-sort": sortDirection,
        colSpan: colSpan,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        tabIndex: tabIndex,
        onKeyDown: onKeyDown
    }, children);
});

});


parcelRegister("9TAkY", function(module, exports) {
$parcel$export(module.exports, "TableState", () => $73456febbcc7b492$export$3d6dc94c3b008646);
$parcel$export(module.exports, "TableType", () => $73456febbcc7b492$export$ec659152c0ce3638);
$parcel$export(module.exports, "CharlieTable", () => $73456febbcc7b492$export$653047d99c89ec70);

var $25nEq = parcelRequire("25nEq");

var $fC8ib = parcelRequire("fC8ib");

var $kqp0i = parcelRequire("kqp0i");

var $iYJcE = parcelRequire("iYJcE");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");

var $kGO2D = parcelRequire("kGO2D");

var $382YZ = parcelRequire("382YZ");
var $j0MtN = parcelRequire("j0MtN");

var $fLEvx = parcelRequire("fLEvx");

var $kZC4L = parcelRequire("kZC4L");
var $8YAYC = parcelRequire("8YAYC");
var $3JBzg = parcelRequire("3JBzg");
var $7Cqku = parcelRequire("7Cqku");

var $21uJw = parcelRequire("21uJw");

var $ceYG2 = parcelRequire("ceYG2");

var $cYEG6 = parcelRequire("cYEG6");

var $hZrFa = parcelRequire("hZrFa");

var $86aoj = parcelRequire("86aoj");

var $aQxuW = parcelRequire("aQxuW");

var $cMkZu = parcelRequire("cMkZu");

var $f20te = parcelRequire("f20te");

var $5THOi = parcelRequire("5THOi");

var $iRBPG = parcelRequire("iRBPG");

var $cvf3Z = parcelRequire("cvf3Z");

var $bF0W9 = parcelRequire("bF0W9");

var $a36et = parcelRequire("a36et");

var $iQ45V = parcelRequire("iQ45V");

var $eYe65 = parcelRequire("eYe65");

var $4Aklk = parcelRequire("4Aklk");
var $73456febbcc7b492$var$_excluded = [
    "labels",
    "manualSorting",
    "manualPagination",
    "enableResizing",
    "tableType",
    "tableState",
    "rowSpacing",
    "xcssOverrides",
    "enableKeyboardNavigation"
], $73456febbcc7b492$var$_excluded2 = [
    "charlieTableState",
    "tableRef"
], $73456febbcc7b492$var$_excluded3 = [
    "charlieTableState"
];
function $73456febbcc7b492$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $73456febbcc7b492$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $73456febbcc7b492$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $73456febbcc7b492$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $73456febbcc7b492$export$3d6dc94c3b008646 = {
    loaded: 'LOADED',
    loading: 'LOADING',
    error: 'ERROR'
};
var $73456febbcc7b492$export$ec659152c0ce3638 = {
    inventory: 'INVENTORY',
    input: 'INPUT'
};
/**
 * CharlieTableStyles
 */ var $73456febbcc7b492$var$ExpandableRowCellPadding = (0, $7Cqku.xcss)({
    paddingInlineStart: 'space.100'
});
var $73456febbcc7b492$var$RowCursorPointer = (0, $7Cqku.xcss)({
    cursor: 'pointer'
});
var $73456febbcc7b492$var$TDExtraStyle = (0, $7Cqku.xcss)({
    borderBottomWidth: 'border.width',
    borderBottomStyle: 'solid',
    borderInlineEndWidth: 'border.width',
    borderInlineEndStyle: 'solid',
    borderColor: 'color.border'
});
var $73456febbcc7b492$var$OverflowHiddenStyle = (0, $7Cqku.xcss)({
    overflow: 'hidden',
    textOverflow: 'ellipsis'
});
var $73456febbcc7b492$var$LoadMoreWrapperStyle = (0, $7Cqku.xcss)({
    marginBlockStart: 'space.100'
});
var $73456febbcc7b492$var$CheckboxWrapperStyle = (0, $7Cqku.xcss)({
    width: 'fit-content',
    marginInlineStart: 'space.negative.100'
});
var $73456febbcc7b492$var$SubRowButtonWrapperStyle = (0, $7Cqku.xcss)({
    marginInlineEnd: 'space.050'
});
var $73456febbcc7b492$var$SubRowExpandableStyle = (0, $7Cqku.xcss)({
    // @ts-expect-error - this saves us from rerendering all the cells
    position: 'var(--col-group-position)',
    left: '0',
    whiteSpace: 'nowrap',
    borderBottomWidth: 'border.width',
    borderBottomStyle: 'solid',
    borderInlineStartWidth: 'border.width',
    borderInlineStartStyle: 'solid',
    borderColor: 'color.border',
    zIndex: '1'
});
var $73456febbcc7b492$var$LoadingTableStyle = (0, $7Cqku.xcss)({
    opacity: 0.7,
    pointerEvents: 'none'
});
var $73456febbcc7b492$var$TableWrapperStyle = (0, $7Cqku.xcss)({
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
    height: '100%',
    overflow: 'auto',
    borderTopLeftRadius: 'radius.large',
    borderTopRightRadius: 'radius.large'
});
var $73456febbcc7b492$var$FooterStyles = (0, $7Cqku.xcss)({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'sticky',
    left: 'space.0'
});
var $73456febbcc7b492$var$FooterDividerStyles = (0, $7Cqku.xcss)({
    border: 'none',
    borderBottom: "var(--ds-border-width-selected, 2px)".concat(" solid ", "var(--ds-border, #0B120E24)"),
    marginTop: 'space.250',
    width: '10%'
});
var $73456febbcc7b492$var$LoadingOverlayStyle = (0, $7Cqku.xcss)({
    position: 'absolute',
    justifyContent: 'center',
    alignItems: 'center',
    pointerEvents: 'none',
    top: 'space.0',
    left: 'space.0',
    right: 'space.0',
    bottom: 'space.0'
});

var $73456febbcc7b492$export$653047d99c89ec70 = function CharlieTable(_ref) {
    var _props$refs, _props$state2, _props$initialState2, _props$state5, _props$state6, _props$initialState5, _props$initialState6, _props$state9, _props$initialState9, _props$refs2, _table$getState$colum, _props$refs3;
    var _ref$labels = _ref.labels, labels = _ref$labels === void 0 ? {
        sortButton: 'Column sort button',
        selectAllRows: 'Select all rows',
        selectRow: 'Select row',
        expandRow: 'Expand row',
        loadMore: 'Load more'
    } : _ref$labels, _ref$manualSorting = _ref.manualSorting, manualSorting = _ref$manualSorting === void 0 ? true : _ref$manualSorting, _ref$manualPagination = _ref.manualPagination, manualPagination = _ref$manualPagination === void 0 ? true : _ref$manualPagination, _ref$enableResizing = _ref.enableResizing, enableResizing = _ref$enableResizing === void 0 ? false : _ref$enableResizing, _ref$tableType = _ref.tableType, tableType = _ref$tableType === void 0 ? $73456febbcc7b492$export$ec659152c0ce3638.input : _ref$tableType, _ref$tableState = _ref.tableState, tableState = _ref$tableState === void 0 ? $73456febbcc7b492$export$3d6dc94c3b008646.loaded : _ref$tableState, _ref$rowSpacing = _ref.rowSpacing, rowSpacing = _ref$rowSpacing === void 0 ? 'default' : _ref$rowSpacing, xcssOverrides = _ref.xcssOverrides, _ref$enableKeyboardNa = _ref.enableKeyboardNavigation, enableKeyboardNavigation = _ref$enableKeyboardNa === void 0 ? false : _ref$enableKeyboardNa, props = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $73456febbcc7b492$var$_excluded);
    var _useState = (0, $5FkrB.useState)(0), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), parentSize = _useState2[0], setParentSize = _useState2[1];
    var tableRef = (0, $5FkrB.useRef)(null);
    (0, $5FkrB.useImperativeHandle)((_props$refs = props.refs) === null || _props$refs === void 0 ? void 0 : _props$refs.tableRef, function() {
        return tableRef.current;
    });
    var _useKeyboardNavigatio = (0, $hZrFa.useKeyboardNavigation)(), tableNavigationControllers = _useKeyboardNavigatio.tableNavigationControllers;
    var infiniteScrollRef = (0, $cYEG6.useInfiniteScroll)({
        onScrollTo: function onScrollTo() {
            var _props$onLoadNext;
            (_props$onLoadNext = props.onLoadNext) === null || _props$onLoadNext === void 0 || _props$onLoadNext.call(props);
        }
    });
    var CharlieTableDndWrapper = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).lazy(function() {
        return (parcelRequire("7vnkj")).then(function(module) {
            return {
                default: module.CharlieTableDndWrapper
            };
        });
    });
    var CharlieWrapper = (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).useMemo(function() {
        if (props.enableColumnReorder || enableResizing) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).forwardRef(function(_ref2, ref) {
            var charlieTableState = _ref2.charlieTableState, tableRef = _ref2.tableRef, props = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref2, $73456febbcc7b492$var$_excluded2);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).Suspense, {
                fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $kZC4L.default), props)
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(CharlieTableDndWrapper, (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
                ref: ref,
                charlieTableState: charlieTableState
            }, props, {
                tableRef: tableRef
            })));
        });
        else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).forwardRef(function(_ref3, ref) {
            var charlieTableState = _ref3.charlieTableState, props = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref3, $73456febbcc7b492$var$_excluded3);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $kZC4L.default), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
                ref: ref
            }, props));
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        props.enableColumnReorder,
        enableResizing
    ]);
    var dummyId = 'charlie-table-reserved-checkbox';
    var oldModifiedColumns = (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).useMemo(function() {
        var _props$columns;
        if (props.columnDefs) return undefined;
        var dummyCheckboxOldColumn = {
            content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $kZC4L.default), null),
            key: dummyId,
            width: 44,
            minWidth: 44,
            isSortable: false,
            cell: {
                render: function render() {
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $kZC4L.default), null);
                }
            }
        };
        return props.enableRowSelection ? [
            dummyCheckboxOldColumn
        ].concat((0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))((_props$columns = props.columns) !== null && _props$columns !== void 0 ? _props$columns : [])) : props.columns;
    }, [
        props.columns,
        props.enableRowSelection,
        props.columnDefs
    ]);
    var tanModifiedColumns = (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).useMemo(function() {
        if (!props.columnDefs) return undefined;
        var dummyCheckboxTanColumn = {
            header: function header() {
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $kZC4L.default), null);
            },
            id: dummyId,
            size: 44,
            minSize: 44,
            enableSorting: false,
            cell: function cell() {
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $kZC4L.default), null);
            }
        };
        return props.enableRowSelection ? [
            dummyCheckboxTanColumn
        ].concat((0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(props.columnDefs)) : props.columnDefs;
    }, [
        props.columnDefs,
        props.enableRowSelection
    ]);
    var appendDummyCheckboxToList = (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).useCallback(function(list) {
        return props.enableRowSelection && list ? [
            dummyId
        ].concat((0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(list !== null && list !== void 0 ? list : [])) : list;
    }, [
        props.enableRowSelection
    ]);
    var modifiedColumnOrder = (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).useMemo(function() {
        var _props$state;
        return appendDummyCheckboxToList((_props$state = props.state) === null || _props$state === void 0 ? void 0 : _props$state.columnOrder);
    }, [
        appendDummyCheckboxToList,
        (_props$state2 = props.state) === null || _props$state2 === void 0 ? void 0 : _props$state2.columnOrder
    ]);
    var modifiedInitialColumnOrder = (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).useMemo(function() {
        var _props$initialState;
        return appendDummyCheckboxToList((_props$initialState = props.initialState) === null || _props$initialState === void 0 ? void 0 : _props$initialState.columnOrder);
    }, [
        appendDummyCheckboxToList,
        (_props$initialState2 = props.initialState) === null || _props$initialState2 === void 0 ? void 0 : _props$initialState2.columnOrder
    ]);
    var modifiedColumnPinningStart = (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).useMemo(function() {
        var _props$state$columnPi, _props$state3, _props$state4;
        return appendDummyCheckboxToList((_props$state$columnPi = (_props$state3 = props.state) === null || _props$state3 === void 0 || (_props$state3 = _props$state3.columnPinning) === null || _props$state3 === void 0 ? void 0 : _props$state3.start) !== null && _props$state$columnPi !== void 0 ? _props$state$columnPi : (_props$state4 = props.state) === null || _props$state4 === void 0 || (_props$state4 = _props$state4.columnPinning) === null || _props$state4 === void 0 ? void 0 : _props$state4.left);
    }, [
        appendDummyCheckboxToList,
        (_props$state5 = props.state) === null || _props$state5 === void 0 || (_props$state5 = _props$state5.columnPinning) === null || _props$state5 === void 0 ? void 0 : _props$state5.start,
        (_props$state6 = props.state) === null || _props$state6 === void 0 || (_props$state6 = _props$state6.columnPinning) === null || _props$state6 === void 0 ? void 0 : _props$state6.left
    ]);
    var modifiedInitialColumnPinningStart = (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).useMemo(function() {
        var _props$initialState$c, _props$initialState3, _props$initialState4;
        return appendDummyCheckboxToList((_props$initialState$c = (_props$initialState3 = props.initialState) === null || _props$initialState3 === void 0 || (_props$initialState3 = _props$initialState3.columnPinning) === null || _props$initialState3 === void 0 ? void 0 : _props$initialState3.start) !== null && _props$initialState$c !== void 0 ? _props$initialState$c : (_props$initialState4 = props.initialState) === null || _props$initialState4 === void 0 || (_props$initialState4 = _props$initialState4.columnPinning) === null || _props$initialState4 === void 0 ? void 0 : _props$initialState4.left);
    }, [
        appendDummyCheckboxToList,
        (_props$initialState5 = props.initialState) === null || _props$initialState5 === void 0 || (_props$initialState5 = _props$initialState5.columnPinning) === null || _props$initialState5 === void 0 ? void 0 : _props$initialState5.start,
        (_props$initialState6 = props.initialState) === null || _props$initialState6 === void 0 || (_props$initialState6 = _props$initialState6.columnPinning) === null || _props$initialState6 === void 0 ? void 0 : _props$initialState6.left
    ]);
    var modifiedColumnPinning = (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).useMemo(function() {
        var _props$state7, _props$state8;
        return modifiedColumnPinningStart ? $73456febbcc7b492$var$_objectSpread($73456febbcc7b492$var$_objectSpread({}, (_props$state7 = props.state) === null || _props$state7 === void 0 ? void 0 : _props$state7.columnPinning), {}, {
            start: modifiedColumnPinningStart
        }) : (_props$state8 = props.state) === null || _props$state8 === void 0 ? void 0 : _props$state8.columnPinning;
    }, [
        modifiedColumnPinningStart,
        (_props$state9 = props.state) === null || _props$state9 === void 0 ? void 0 : _props$state9.columnPinning
    ]);
    var modifiedInitialColumnPinning = (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).useMemo(function() {
        var _props$initialState7, _props$initialState8;
        return modifiedInitialColumnPinningStart ? $73456febbcc7b492$var$_objectSpread($73456febbcc7b492$var$_objectSpread({}, (_props$initialState7 = props.initialState) === null || _props$initialState7 === void 0 ? void 0 : _props$initialState7.columnPinning), {}, {
            start: modifiedInitialColumnPinningStart
        }) : (_props$initialState8 = props.initialState) === null || _props$initialState8 === void 0 ? void 0 : _props$initialState8.columnPinning;
    }, [
        modifiedInitialColumnPinningStart,
        (_props$initialState9 = props.initialState) === null || _props$initialState9 === void 0 ? void 0 : _props$initialState9.columnPinning
    ]);
    var convertedCharles = (0, $4Aklk.useConvertCharlieTableToTanStack)($73456febbcc7b492$var$_objectSpread($73456febbcc7b492$var$_objectSpread({}, props), {}, {
        columnDefs: tanModifiedColumns,
        columns: oldModifiedColumns,
        manualPagination: manualPagination,
        manualSorting: manualSorting,
        state: $73456febbcc7b492$var$_objectSpread($73456febbcc7b492$var$_objectSpread({}, props.state), {}, {
            columnPinning: modifiedColumnPinning,
            columnOrder: modifiedColumnOrder
        }),
        initialState: $73456febbcc7b492$var$_objectSpread($73456febbcc7b492$var$_objectSpread({}, props.initialState), {}, {
            columnPinning: modifiedInitialColumnPinning,
            columnOrder: modifiedInitialColumnOrder
        })
    }));
    var columns = (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).useMemo(function() {
        return convertedCharles.columns;
    }, [
        convertedCharles.columns
    ]);
    var data = (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).useMemo(function() {
        return convertedCharles.data;
    }, [
        convertedCharles.data
    ]);
    var table = (0, $kGO2D.useReactTable)($73456febbcc7b492$var$_objectSpread($73456febbcc7b492$var$_objectSpread({}, convertedCharles), {}, {
        columns: columns,
        data: data,
        autoResetExpanded: props.autoResetExpanded
    }));
    (0, $5FkrB.useImperativeHandle)((_props$refs2 = props.refs) === null || _props$refs2 === void 0 ? void 0 : _props$refs2.internalTableRef, function() {
        return table;
    }, [
        table
    ]);
    var hasWidths = (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(Object.keys((_table$getState$colum = table.getState().columnSizing) !== null && _table$getState$colum !== void 0 ? _table$getState$colum : {})).length > 0 || enableResizing;
    var totalTableWidth = table.getTotalSize();
    var columnCssVars = (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).useMemo(function() {
        var _table$getState;
        var cols = table.getAllLeafColumns();
        var colCss = {};
        cols.forEach(function(col) {
            var isPinned = col.getIsPinned();
            if (!isPinned || !col) return;
            var colKeyPrefix = "--col-".concat(col.id);
            colCss["".concat(colKeyPrefix, "-left")] = isPinned === 'left' ? "".concat(col.getStart('left'), "px") : undefined;
            colCss["".concat(colKeyPrefix, "-right")] = isPinned === 'right' ? "".concat(col.getAfter('right'), "px") : undefined;
            // @ts-expect-error-next-line - none of the zIndex ADS tokens equate to 1
            colCss["".concat(colKeyPrefix, "-zIndex")] = 1;
            colCss["".concat(colKeyPrefix, "-position")] = 'sticky';
        });
        if (table !== null && table !== void 0 && (_table$getState = table.getState()) !== null && _table$getState !== void 0 && (_table$getState = _table$getState.columnPinning) !== null && _table$getState !== void 0 && _table$getState.left && table.getState().columnPinning.left.length > 0) colCss["--col-group-position"] = 'sticky';
        return colCss;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        table.options.state
    ]);
    var isEmptyState = table.options.data.length === 0 && tableState === $73456febbcc7b492$export$3d6dc94c3b008646.loaded;
    return(/*#__PURE__*/ //normally you shouldn't do this, but was having trouble passing the generic with the lazy loaded component
    //@ts-expect-error lazy loading isses
    (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(CharlieWrapper, (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        xcss: $73456febbcc7b492$var$TableWrapperStyle,
        ref: (_props$refs3 = props.refs) === null || _props$refs3 === void 0 ? void 0 : _props$refs3.tableContainerRef
    }, (props.enableColumnReorder || enableResizing) && {
        charlieTableState: table,
        tableRef: tableRef
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $ceYG2.default), {
        setWidth: setParentSize
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $iQ45V.Table), {
        testId: props.testId,
        ref: tableRef,
        xcss: [
            props.isLoading || tableState === $73456febbcc7b492$export$3d6dc94c3b008646.loading ? $73456febbcc7b492$var$LoadingTableStyle : false,
            (0, $7Cqku.xcss)($73456febbcc7b492$var$_objectSpread($73456febbcc7b492$var$_objectSpread({}, columnCssVars), {}, {
                borderCollapse: 'separate',
                borderSpacing: '0px',
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
                tableLayout: hasWidths ? 'fixed' : 'auto',
                width: '100%',
                overflow: 'auto',
                margin: 'space.0'
            }))
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $aQxuW.Colgroup), null, table.getHeaderGroups().map(function(headerGroup) {
        return headerGroup.headers.map(function(header) {
            if ((header === null || header === void 0 ? void 0 : header.column) == null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $5FkrB.Fragment), null);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $86aoj.Col), {
                key: header.id,
                xcss: (0, $7Cqku.xcss)({
                    width: // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
                    (!header.column.getIsLastColumn() || parentSize && parentSize < totalTableWidth) && enableResizing ? "".concat(header.column.getSize(), "px") : undefined,
                    overflow: 'hidden',
                    textOverflow: 'ellipsis'
                })
            });
        });
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $eYe65.THead), null, table.getHeaderGroups().map(function(headerGroup) {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $5THOi.TR), {
            key: headerGroup.id
        }, headerGroup.headers.map(function(header, idx) {
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $iRBPG.CharlieTableHeader), {
                key: header.id,
                labels: labels,
                charlieTableColumn: header,
                index: idx,
                enableResizing: enableResizing && header.column.getCanResize(),
                charlieTableState: table,
                tableType: tableType,
                enableColumnReorder: props.enableColumnReorder,
                enableRowSelection: props.enableRowSelection,
                hasWidths: hasWidths,
                xcss: typeof (xcssOverrides === null || xcssOverrides === void 0 ? void 0 : xcssOverrides.headerCell) === 'function' ? xcssOverrides.headerCell(header, table.getState()) : undefined
            });
        }));
    })), (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).useMemo(function() {
        var _props$refs4;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $cvf3Z.TBody), {
            ref: (_props$refs4 = props.refs) === null || _props$refs4 === void 0 ? void 0 : _props$refs4.tableBodyRef
        }, table.getRowModel().rows ? table.getRowModel().rows.map(function(row, index) {
            var _row$original, _props$renderOptions, _props$renderOptions2, _props$renderOptions3, _table$getRowModel$ro, _table$getRowModel$ro2;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $5FkrB.Fragment), {
                key: row.id
            }, (_row$original = row.original) !== null && _row$original !== void 0 && _row$original.overrideRender || row.getIsGrouped() && (_props$renderOptions = props.renderOptions) !== null && _props$renderOptions !== void 0 && _props$renderOptions.groupingRow ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $5FkrB.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $bF0W9.Row), {
                spacing: rowSpacing,
                onClick: function onClick(e) {
                    var _props$onRowClick;
                    // @ts-expect-error Prevent row click if a link was clicked
                    if (e.target.closest('a')) return;
                    (_props$onRowClick = props.onRowClick) === null || _props$onRowClick === void 0 || _props$onRowClick.call(props, row);
                },
                xcss: props.onRowClick && $73456febbcc7b492$var$RowCursorPointer
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $f20te.TD), {
                xcss: [
                    $73456febbcc7b492$var$SubRowExpandableStyle,
                    typeof (xcssOverrides === null || xcssOverrides === void 0 ? void 0 : xcssOverrides.rowCell) === 'function' ? xcssOverrides.rowCell(row.getVisibleCells()[0], table.getState()) : undefined
                ]
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $8YAYC.default), {
                alignItems: "center"
            }, (props.renderChildComponent || ((_props$renderOptions2 = props.renderOptions) === null || _props$renderOptions2 === void 0 ? void 0 : _props$renderOptions2.groupingRow)) && row.getCanExpand() && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $kZC4L.default), {
                xcss: [
                    $73456febbcc7b492$var$SubRowButtonWrapperStyle,
                    (0, $7Cqku.xcss)({
                        // @ts-expect-error - needed for nested styles
                        // eslint-disable-next-line @compiled/no-suppress-xcss
                        paddingInlineStart: // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
                        row.getCanExpand() ? "".concat((row.depth + 1) * 8, "px") : "".concat(32 + (row.depth + 1) * 8, "px")
                    })
                ]
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $j0MtN.default), {
                spacing: "compact",
                testId: "expand-row-button",
                appearance: "subtle",
                interactionName: props.interactionName,
                analyticsContext: $73456febbcc7b492$var$_objectSpread({
                    componentName: 'charlieTableExpandRowButton'
                }, props.analyticsContext),
                "aria-pressed": row.getIsExpanded(),
                label: labels.expandRow,
                icon: function icon(iconProps) {
                    var _row$getIsExpanded;
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $cMkZu.ExpandIcon), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
                        isExpanded: (_row$getIsExpanded = row.getIsExpanded()) !== null && _row$getIsExpanded !== void 0 ? _row$getIsExpanded : false
                    }, iconProps));
                },
                onClick: function onClick(e) {
                    e.stopPropagation();
                    row.toggleExpanded();
                }
            })), row.original.overrideRender && row.original.overrideRender(row.original), ((_props$renderOptions3 = props.renderOptions) === null || _props$renderOptions3 === void 0 ? void 0 : _props$renderOptions3.groupingRow) && props.renderOptions.groupingRow(row.original, table.getState()))), row.getVisibleCells().length > 1 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $f20te.TD), {
                colSpan: row.getVisibleCells().length - 1,
                xcss: [
                    $73456febbcc7b492$var$TDExtraStyle,
                    typeof (xcssOverrides === null || xcssOverrides === void 0 ? void 0 : xcssOverrides.rowCell) === 'function' ? xcssOverrides.rowCell(row.getVisibleCells()[1], table.getState()) : undefined
                ]
            }))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $bF0W9.Row), {
                key: row.id,
                spacing: rowSpacing,
                onClick: function onClick(e) {
                    var _props$onRowClick2;
                    // @ts-expect-error Prevent row click if a link was clicked
                    if (e.target.closest('a')) return;
                    (_props$onRowClick2 = props.onRowClick) === null || _props$onRowClick2 === void 0 || _props$onRowClick2.call(props, row);
                },
                xcss: props.onRowClick && $73456febbcc7b492$var$RowCursorPointer
            }, row.getVisibleCells().map(function(cell, index) {
                var _row$getParentRow;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $a36et.RowCell), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
                    tableType: tableType
                }, enableKeyboardNavigation && {
                    tabIndex: 0,
                    onKeyDown: tableNavigationControllers
                }, {
                    xcss: [
                        $73456febbcc7b492$var$OverflowHiddenStyle,
                        cell.row.getCanExpand() && (props.enableRowSelection && index === 1 || !props.enableRowSelection && index === 0) && $73456febbcc7b492$var$ExpandableRowCellPadding,
                        cell.column.getIsPinned() && (0, $7Cqku.xcss)({
                            // @ts-expect-error - this saves us from rerendering all the cells
                            // eslint-disable-next-line @compiled/no-suppress-xcss, @atlaskit/ui-styling-standard/no-unsafe-values
                            zIndex: "var(--col-".concat(cell.column.id, "-zIndex)"),
                            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
                            left: "var(--col-".concat(cell.column.id, "-left)"),
                            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
                            right: "var(--col-".concat(cell.column.id, "-right)"),
                            // @ts-expect-error - this saves us from rerendering all the cells
                            // eslint-disable-next-line @compiled/no-suppress-xcss, @atlaskit/ui-styling-standard/no-unsafe-values
                            position: "var(--col-".concat(cell.column.id, "-position)")
                        }),
                        typeof (xcssOverrides === null || xcssOverrides === void 0 ? void 0 : xcssOverrides.rowCell) === 'function' ? xcssOverrides.rowCell(cell, table.getState()) : undefined
                    ],
                    key: cell.id
                }), index === 0 && props.enableRowSelection ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $kZC4L.default), {
                    xcss: $73456febbcc7b492$var$CheckboxWrapperStyle
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $fLEvx.default), {
                    analyticsContext: $73456febbcc7b492$var$_objectSpread({
                        componentName: 'charlieTableExpandRowButton'
                    }, props.analyticsContext),
                    "aria-label": labels.selectRow,
                    isDisabled: !row.getCanSelect(),
                    isChecked: row.getIsSelected(),
                    onClick: function onClick(e) {
                        e.stopPropagation();
                        row.toggleSelected();
                    }
                })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $8YAYC.default), {
                    alignItems: "center",
                    xcss: [
                        $73456febbcc7b492$var$OverflowHiddenStyle,
                        (props.enableRowSelection && index === 1 || !props.enableRowSelection && index === 0) && !((_row$getParentRow = row.getParentRow()) !== null && _row$getParentRow !== void 0 && _row$getParentRow.getIsGrouped()) && (0, $7Cqku.xcss)({
                            //@ts-expect-error needed for logic
                            // eslint-disable-next-line @compiled/no-suppress-xcss
                            paddingInlineStart: "".concat(row.depth * 8, "px")
                        })
                    ]
                }, row.getCanExpand() && (props.enableRowSelection && index === 1 || !props.enableRowSelection && index === 0) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $kZC4L.default), {
                    xcss: $73456febbcc7b492$var$SubRowButtonWrapperStyle
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $j0MtN.default), {
                    spacing: "compact",
                    testId: "expand-row-button",
                    interactionName: props.interactionName,
                    analyticsContext: $73456febbcc7b492$var$_objectSpread({
                        componentName: 'charlieTableExpandRowButton'
                    }, props.analyticsContext),
                    appearance: "subtle",
                    "aria-pressed": row.getIsExpanded(),
                    label: labels.expandRow,
                    icon: function icon(iconProps) {
                        var _row$getIsExpanded2;
                        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $cMkZu.ExpandIcon), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
                            isExpanded: (_row$getIsExpanded2 = row.getIsExpanded()) !== null && _row$getIsExpanded2 !== void 0 ? _row$getIsExpanded2 : false
                        }, iconProps));
                    },
                    onClick: function onClick(e) {
                        e.stopPropagation();
                        row.toggleExpanded();
                    }
                })), (0, $kGO2D.flexRender)(cell.column.columnDef.cell, cell.getContext())));
            })), row.getIsExpanded() && props.renderChildComponent && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $5FkrB.Fragment), null, props === null || props === void 0 ? void 0 : props.renderChildComponent({
                rowData: row,
                tableState: table.getState()
            })), props.hasNext && //we pagination with child components is not supported yet
            !props.renderChildComponent && index === Math.floor(((_table$getRowModel$ro = (_table$getRowModel$ro2 = table.getRowModel().rows) === null || _table$getRowModel$ro2 === void 0 ? void 0 : _table$getRowModel$ro2.length) !== null && _table$getRowModel$ro !== void 0 ? _table$getRowModel$ro : 0) * 0.92) && /*#__PURE__*/ // if user is 92% through the table, load more rows
            (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("tr", {
                key: 'loadMoreTrigger',
                ref: infiniteScrollRef
            }));
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $5FkrB.Fragment), null));
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        rowSpacing,
        table.options.state.rowSelection,
        table.options.state.sorting,
        table.options.state.expanded,
        table.options.state.columnOrder,
        table.options.state.grouping,
        table.options.state.columnVisibility,
        table.options.data
    ])), (props.hasNext != null && props.onLoadNext != null || props.isLoading != null) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $3JBzg.default), {
        xcss: $73456febbcc7b492$var$FooterStyles
    }, props.hasNext && props.onLoadNext ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $kZC4L.default), {
        xcss: $73456febbcc7b492$var$LoadMoreWrapperStyle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $382YZ.default), {
        testId: "prev-page-test-id",
        isLoading: props.isLoading || tableState === $73456febbcc7b492$export$3d6dc94c3b008646.loading,
        onClick: function onClick() {
            var _props$onLoadNext2;
            (_props$onLoadNext2 = props.onLoadNext) === null || _props$onLoadNext2 === void 0 || _props$onLoadNext2.call(props);
        },
        "aria-label": labels.loadMoreLabel,
        spacing: "compact"
    }, labels.loadMore)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $5FkrB.Fragment), null, !(isEmptyState || tableState === $73456febbcc7b492$export$3d6dc94c3b008646.error || props.hidePaginationEndIndicator) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $kZC4L.default), {
        as: "hr",
        testId: "table-footer-divider",
        xcss: $73456febbcc7b492$var$FooterDividerStyles,
        role: "presentation"
    }))), (props.isLoading || tableState === $73456febbcc7b492$export$3d6dc94c3b008646.loading) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $8YAYC.default), {
        xcss: $73456febbcc7b492$var$LoadingOverlayStyle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $21uJw.default), {
        size: "large",
        testId: "common-table-spinner"
    })), tableState === $73456febbcc7b492$export$3d6dc94c3b008646.error && props.errorView, isEmptyState && props.emptyTableView));
};

});
parcelRegister("kGO2D", function(module, exports) {
$parcel$export(module.exports, "createColumnHelper", () => (parcelRequire("e6OxX")).createColumnHelper);
$parcel$export(module.exports, "createRow", () => (parcelRequire("e6OxX")).createRow);
$parcel$export(module.exports, "createTable", () => (parcelRequire("e6OxX")).createTable);
$parcel$export(module.exports, "flattenBy", () => (parcelRequire("e6OxX")).flattenBy);
$parcel$export(module.exports, "functionalUpdate", () => (parcelRequire("e6OxX")).functionalUpdate);
$parcel$export(module.exports, "getCoreRowModel", () => (parcelRequire("e6OxX")).getCoreRowModel);
$parcel$export(module.exports, "getExpandedRowModel", () => (parcelRequire("e6OxX")).getExpandedRowModel);
$parcel$export(module.exports, "getGroupedRowModel", () => (parcelRequire("e6OxX")).getGroupedRowModel);
$parcel$export(module.exports, "getMemoOptions", () => (parcelRequire("e6OxX")).getMemoOptions);
$parcel$export(module.exports, "getSortedRowModel", () => (parcelRequire("e6OxX")).getSortedRowModel);
$parcel$export(module.exports, "memo", () => (parcelRequire("e6OxX")).memo);
$parcel$export(module.exports, "flexRender", () => $f0fe8c1560dd2b1d$export$f2385bb6e3ac4b4f);
$parcel$export(module.exports, "useReactTable", () => $f0fe8c1560dd2b1d$export$25eaeb3743e6b31f);
/**
   * react-table
   *
   * Copyright (c) TanStack
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE.md file in the root directory of this source tree.
   *
   * @license MIT
   */ 
var $5FkrB = parcelRequire("5FkrB");

var $e6OxX = parcelRequire("e6OxX");
//
/**
 * If rendering headers, cells, or footers with custom markup, use flexRender instead of `cell.getValue()` or `cell.renderValue()`.
 */ function $f0fe8c1560dd2b1d$export$f2385bb6e3ac4b4f(Comp, props) {
    return !Comp ? null : $f0fe8c1560dd2b1d$var$isReactComponent(Comp) ? /*#__PURE__*/ $5FkrB.createElement(Comp, props) : Comp;
}
function $f0fe8c1560dd2b1d$var$isReactComponent(component) {
    return $f0fe8c1560dd2b1d$var$isClassComponent(component) || typeof component === 'function' || $f0fe8c1560dd2b1d$var$isExoticComponent(component);
}
function $f0fe8c1560dd2b1d$var$isClassComponent(component) {
    return typeof component === 'function' && (()=>{
        const proto = Object.getPrototypeOf(component);
        return proto.prototype && proto.prototype.isReactComponent;
    })();
}
function $f0fe8c1560dd2b1d$var$isExoticComponent(component) {
    return typeof component === 'object' && typeof component.$$typeof === 'symbol' && [
        'react.memo',
        'react.forward_ref'
    ].includes(component.$$typeof.description);
}
function $f0fe8c1560dd2b1d$export$25eaeb3743e6b31f(options) {
    // Compose in the generic options to the user options
    const resolvedOptions = {
        state: {},
        // Dummy state
        onStateChange: ()=>{},
        // noop
        renderFallbackValue: null,
        ...options
    };
    // Create a new table and store it in state
    const [tableRef] = $5FkrB.useState(()=>({
            current: (0, $e6OxX.createTable)(resolvedOptions)
        }));
    // By default, manage table state here using the table's initial state
    const [state, setState] = $5FkrB.useState(()=>tableRef.current.initialState);
    // Compose the default state above with any user state. This will allow the user
    // to only control a subset of the state if desired.
    tableRef.current.setOptions((prev)=>({
            ...prev,
            ...options,
            state: {
                ...state,
                ...options.state
            },
            // Similarly, we'll maintain both our internal state and any user-provided
            // state.
            onStateChange: (updater)=>{
                setState(updater);
                options.onStateChange == null || options.onStateChange(updater);
            }
        }));
    return tableRef.current;
}

});
parcelRegister("e6OxX", function(module, exports) {
$parcel$export(module.exports, "createColumnHelper", () => $a458d5bea2d12b69$export$4b44a5cb9651fe5e);
$parcel$export(module.exports, "functionalUpdate", () => $a458d5bea2d12b69$export$7f095f455ad5af3f);
$parcel$export(module.exports, "flattenBy", () => $a458d5bea2d12b69$export$bf4548421d1b2c8);
$parcel$export(module.exports, "memo", () => $a458d5bea2d12b69$export$7c73462e0d25e514);
$parcel$export(module.exports, "getMemoOptions", () => $a458d5bea2d12b69$export$b1f82222dc43996c);
$parcel$export(module.exports, "createRow", () => $a458d5bea2d12b69$export$3442c5d213434705);
$parcel$export(module.exports, "createTable", () => $a458d5bea2d12b69$export$33bbb3ec7652e187);
$parcel$export(module.exports, "getCoreRowModel", () => $a458d5bea2d12b69$export$32d0bc001e828250);
$parcel$export(module.exports, "getExpandedRowModel", () => $a458d5bea2d12b69$export$53cfec7b1b8d1fcd);
$parcel$export(module.exports, "getGroupedRowModel", () => $a458d5bea2d12b69$export$2b7f4b57ce71b81);
$parcel$export(module.exports, "getSortedRowModel", () => $a458d5bea2d12b69$export$4ca93ca80835d8c1);
/**
   * table-core
   *
   * Copyright (c) TanStack
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE.md file in the root directory of this source tree.
   *
   * @license MIT
   */ // type Person = {
//   firstName: string
//   lastName: string
//   age: number
//   visits: number
//   status: string
//   progress: number
//   createdAt: Date
//   nested: {
//     foo: [
//       {
//         bar: 'bar'
//       }
//     ]
//     bar: { subBar: boolean }[]
//     baz: {
//       foo: 'foo'
//       bar: {
//         baz: 'baz'
//       }
//     }
//   }
// }
// const test: DeepKeys<Person> = 'nested.foo.0.bar'
// const test2: DeepKeys<Person> = 'nested.bar'
// const helper = createColumnHelper<Person>()
// helper.accessor('nested.foo', {
//   cell: info => info.getValue(),
// })
// helper.accessor('nested.foo.0.bar', {
//   cell: info => info.getValue(),
// })
// helper.accessor('nested.bar', {
//   cell: info => info.getValue(),
// })
function $a458d5bea2d12b69$export$4b44a5cb9651fe5e() {
    return {
        accessor: (accessor, column)=>{
            return typeof accessor === 'function' ? {
                ...column,
                accessorFn: accessor
            } : {
                ...column,
                accessorKey: accessor
            };
        },
        display: (column)=>column,
        group: (column)=>column
    };
}
// Is this type a tuple?
// If this type is a tuple, what indices are allowed?
///
function $a458d5bea2d12b69$export$7f095f455ad5af3f(updater, input) {
    return typeof updater === 'function' ? updater(input) : updater;
}
function $a458d5bea2d12b69$export$8793edee2d425525() {
//
}
function $a458d5bea2d12b69$export$2b5605d8069324bd(key, instance) {
    return (updater)=>{
        instance.setState((old)=>{
            return {
                ...old,
                [key]: $a458d5bea2d12b69$export$7f095f455ad5af3f(updater, old[key])
            };
        });
    };
}
function $a458d5bea2d12b69$export$f6e2535fb5126e54(d) {
    return d instanceof Function;
}
function $a458d5bea2d12b69$export$5cd576d1827d40c8(d) {
    return Array.isArray(d) && d.every((val)=>typeof val === 'number');
}
function $a458d5bea2d12b69$export$bf4548421d1b2c8(arr, getChildren) {
    const flat = [];
    const recurse = (subArr)=>{
        subArr.forEach((item)=>{
            flat.push(item);
            const children = getChildren(item);
            if (children != null && children.length) recurse(children);
        });
    };
    recurse(arr);
    return flat;
}
function $a458d5bea2d12b69$export$7c73462e0d25e514(getDeps, fn, opts) {
    let deps = [];
    let result;
    return (depArgs)=>{
        let depTime;
        if (opts.key && opts.debug) depTime = Date.now();
        const newDeps = getDeps(depArgs);
        const depsChanged = newDeps.length !== deps.length || newDeps.some((dep, index)=>deps[index] !== dep);
        if (!depsChanged) return result;
        deps = newDeps;
        let resultTime;
        if (opts.key && opts.debug) resultTime = Date.now();
        result = fn(...newDeps);
        opts == null || opts.onChange == null || opts.onChange(result);
        if (opts.key && opts.debug) {
            if (opts != null && opts.debug()) {
                const depEndTime = Math.round((Date.now() - depTime) * 100) / 100;
                const resultEndTime = Math.round((Date.now() - resultTime) * 100) / 100;
                const resultFpsPercentage = resultEndTime / 16;
                const pad = (str, num)=>{
                    str = String(str);
                    while(str.length < num)str = ' ' + str;
                    return str;
                };
                console.info(`%c\u{23F1} ${pad(resultEndTime, 5)} /${pad(depEndTime, 5)} ms`, `
            font-size: .6rem;
            font-weight: bold;
            color: hsl(${Math.max(0, Math.min(120 - 120 * resultFpsPercentage, 120))}deg 100% 31%);`, opts == null ? void 0 : opts.key);
            }
        }
        return result;
    };
}
function $a458d5bea2d12b69$export$b1f82222dc43996c(tableOptions, debugLevel, key, onChange) {
    return {
        debug: ()=>{
            var _tableOptions$debugAl;
            return (_tableOptions$debugAl = tableOptions == null ? void 0 : tableOptions.debugAll) != null ? _tableOptions$debugAl : tableOptions[debugLevel];
        },
        key: false,
        onChange: onChange
    };
}
function $a458d5bea2d12b69$export$3cb21b6b1233300e(table, row, column, columnId) {
    const getRenderValue = ()=>{
        var _cell$getValue;
        return (_cell$getValue = cell.getValue()) != null ? _cell$getValue : table.options.renderFallbackValue;
    };
    const cell = {
        id: `${row.id}_${column.id}`,
        row: row,
        column: column,
        getValue: ()=>row.getValue(columnId),
        renderValue: getRenderValue,
        getContext: $a458d5bea2d12b69$export$7c73462e0d25e514(()=>[
                table,
                column,
                row,
                cell
            ], (table, column, row, cell)=>({
                table: table,
                column: column,
                row: row,
                cell: cell,
                getValue: cell.getValue,
                renderValue: cell.renderValue
            }), $a458d5bea2d12b69$export$b1f82222dc43996c(table.options, 'debugCells', 'cell.getContext'))
    };
    table._features.forEach((feature)=>{
        feature.createCell == null || feature.createCell(cell, column, row, table);
    }, {});
    return cell;
}
function $a458d5bea2d12b69$export$1bfa986e9c92c0b5(table, columnDef, depth, parent) {
    var _ref, _resolvedColumnDef$id;
    const defaultColumn = table._getDefaultColumnDef();
    const resolvedColumnDef = {
        ...defaultColumn,
        ...columnDef
    };
    const accessorKey = resolvedColumnDef.accessorKey;
    let id = (_ref = (_resolvedColumnDef$id = resolvedColumnDef.id) != null ? _resolvedColumnDef$id : accessorKey ? typeof String.prototype.replaceAll === 'function' ? accessorKey.replaceAll('.', '_') : accessorKey.replace(/\./g, '_') : undefined) != null ? _ref : typeof resolvedColumnDef.header === 'string' ? resolvedColumnDef.header : undefined;
    let accessorFn;
    if (resolvedColumnDef.accessorFn) accessorFn = resolvedColumnDef.accessorFn;
    else if (accessorKey) {
        // Support deep accessor keys
        if (accessorKey.includes('.')) accessorFn = (originalRow)=>{
            let result = originalRow;
            for (const key of accessorKey.split('.')){
                var _result;
                result = (_result = result) == null ? void 0 : _result[key];
            }
            return result;
        };
        else accessorFn = (originalRow)=>originalRow[resolvedColumnDef.accessorKey];
    }
    if (!id) throw new Error();
    let column = {
        id: `${String(id)}`,
        accessorFn: accessorFn,
        parent: parent,
        depth: depth,
        columnDef: resolvedColumnDef,
        columns: [],
        getFlatColumns: $a458d5bea2d12b69$export$7c73462e0d25e514(()=>[
                true
            ], ()=>{
            var _column$columns;
            return [
                column,
                ...(_column$columns = column.columns) == null ? void 0 : _column$columns.flatMap((d)=>d.getFlatColumns())
            ];
        }, $a458d5bea2d12b69$export$b1f82222dc43996c(table.options, 'debugColumns', 'column.getFlatColumns')),
        getLeafColumns: $a458d5bea2d12b69$export$7c73462e0d25e514(()=>[
                table._getOrderColumnsFn()
            ], (orderColumns)=>{
            var _column$columns2;
            if ((_column$columns2 = column.columns) != null && _column$columns2.length) {
                let leafColumns = column.columns.flatMap((column)=>column.getLeafColumns());
                return orderColumns(leafColumns);
            }
            return [
                column
            ];
        }, $a458d5bea2d12b69$export$b1f82222dc43996c(table.options, 'debugColumns', 'column.getLeafColumns'))
    };
    for (const feature of table._features)feature.createColumn == null || feature.createColumn(column, table);
    // Yes, we have to convert table to unknown, because we know more than the compiler here.
    return column;
}
const $a458d5bea2d12b69$var$debug = 'debugHeaders';
//
function $a458d5bea2d12b69$var$createHeader(table, column, options) {
    var _options$id;
    const id = (_options$id = options.id) != null ? _options$id : column.id;
    let header = {
        id: id,
        column: column,
        index: options.index,
        isPlaceholder: !!options.isPlaceholder,
        placeholderId: options.placeholderId,
        depth: options.depth,
        subHeaders: [],
        colSpan: 0,
        rowSpan: 0,
        headerGroup: null,
        getLeafHeaders: ()=>{
            const leafHeaders = [];
            const recurseHeader = (h)=>{
                if (h.subHeaders && h.subHeaders.length) h.subHeaders.map(recurseHeader);
                leafHeaders.push(h);
            };
            recurseHeader(header);
            return leafHeaders;
        },
        getContext: ()=>({
                table: table,
                header: header,
                column: column
            })
    };
    table._features.forEach((feature)=>{
        feature.createHeader == null || feature.createHeader(header, table);
    });
    return header;
}
const $a458d5bea2d12b69$export$79b704688b15c0f4 = {
    createTable: (table)=>{
        // Header Groups
        table.getHeaderGroups = $a458d5bea2d12b69$export$7c73462e0d25e514(()=>[
                table.getAllColumns(),
                table.getVisibleLeafColumns(),
                table.getState().columnPinning.left,
                table.getState().columnPinning.right
            ], (allColumns, leafColumns, left, right)=>{
            var _left$map$filter, _right$map$filter;
            const leftColumns = (_left$map$filter = left == null ? void 0 : left.map((columnId)=>leafColumns.find((d)=>d.id === columnId)).filter(Boolean)) != null ? _left$map$filter : [];
            const rightColumns = (_right$map$filter = right == null ? void 0 : right.map((columnId)=>leafColumns.find((d)=>d.id === columnId)).filter(Boolean)) != null ? _right$map$filter : [];
            const centerColumns = leafColumns.filter((column)=>!(left != null && left.includes(column.id)) && !(right != null && right.includes(column.id)));
            const headerGroups = $a458d5bea2d12b69$export$d8c3a8af36458fc3(allColumns, [
                ...leftColumns,
                ...centerColumns,
                ...rightColumns
            ], table);
            return headerGroups;
        }, $a458d5bea2d12b69$export$b1f82222dc43996c(table.options, $a458d5bea2d12b69$var$debug, 'getHeaderGroups'));
        table.getCenterHeaderGroups = $a458d5bea2d12b69$export$7c73462e0d25e514(()=>[
                table.getAllColumns(),
                table.getVisibleLeafColumns(),
                table.getState().columnPinning.left,
                table.getState().columnPinning.right
            ], (allColumns, leafColumns, left, right)=>{
            leafColumns = leafColumns.filter((column)=>!(left != null && left.includes(column.id)) && !(right != null && right.includes(column.id)));
            return $a458d5bea2d12b69$export$d8c3a8af36458fc3(allColumns, leafColumns, table, 'center');
        }, $a458d5bea2d12b69$export$b1f82222dc43996c(table.options, $a458d5bea2d12b69$var$debug, 'getCenterHeaderGroups'));
        table.getLeftHeaderGroups = $a458d5bea2d12b69$export$7c73462e0d25e514(()=>[
                table.getAllColumns(),
                table.getVisibleLeafColumns(),
                table.getState().columnPinning.left
            ], (allColumns, leafColumns, left)=>{
            var _left$map$filter2;
            const orderedLeafColumns = (_left$map$filter2 = left == null ? void 0 : left.map((columnId)=>leafColumns.find((d)=>d.id === columnId)).filter(Boolean)) != null ? _left$map$filter2 : [];
            return $a458d5bea2d12b69$export$d8c3a8af36458fc3(allColumns, orderedLeafColumns, table, 'left');
        }, $a458d5bea2d12b69$export$b1f82222dc43996c(table.options, $a458d5bea2d12b69$var$debug, 'getLeftHeaderGroups'));
        table.getRightHeaderGroups = $a458d5bea2d12b69$export$7c73462e0d25e514(()=>[
                table.getAllColumns(),
                table.getVisibleLeafColumns(),
                table.getState().columnPinning.right
            ], (allColumns, leafColumns, right)=>{
            var _right$map$filter2;
            const orderedLeafColumns = (_right$map$filter2 = right == null ? void 0 : right.map((columnId)=>leafColumns.find((d)=>d.id === columnId)).filter(Boolean)) != null ? _right$map$filter2 : [];
            return $a458d5bea2d12b69$export$d8c3a8af36458fc3(allColumns, orderedLeafColumns, table, 'right');
        }, $a458d5bea2d12b69$export$b1f82222dc43996c(table.options, $a458d5bea2d12b69$var$debug, 'getRightHeaderGroups'));
        // Footer Groups
        table.getFooterGroups = $a458d5bea2d12b69$export$7c73462e0d25e514(()=>[
                table.getHeaderGroups()
            ], (headerGroups)=>{
            return [
                ...headerGroups
            ].reverse();
        }, $a458d5bea2d12b69$export$b1f82222dc43996c(table.options, $a458d5bea2d12b69$var$debug, 'getFooterGroups'));
        table.getLeftFooterGroups = $a458d5bea2d12b69$export$7c73462e0d25e514(()=>[
                table.getLeftHeaderGroups()
            ], (headerGroups)=>{
            return [
                ...headerGroups
            ].reverse();
        }, $a458d5bea2d12b69$export$b1f82222dc43996c(table.options, $a458d5bea2d12b69$var$debug, 'getLeftFooterGroups'));
        table.getCenterFooterGroups = $a458d5bea2d12b69$export$7c73462e0d25e514(()=>[
                table.getCenterHeaderGroups()
            ], (headerGroups)=>{
            return [
                ...headerGroups
            ].reverse();
        }, $a458d5bea2d12b69$export$b1f82222dc43996c(table.options, $a458d5bea2d12b69$var$debug, 'getCenterFooterGroups'));
        table.getRightFooterGroups = $a458d5bea2d12b69$export$7c73462e0d25e514(()=>[
                table.getRightHeaderGroups()
            ], (headerGroups)=>{
            return [
                ...headerGroups
            ].reverse();
        }, $a458d5bea2d12b69$export$b1f82222dc43996c(table.options, $a458d5bea2d12b69$var$debug, 'getRightFooterGroups'));
        // Flat Headers
        table.getFlatHeaders = $a458d5bea2d12b69$export$7c73462e0d25e514(()=>[
                table.getHeaderGroups()
            ], (headerGroups)=>{
            return headerGroups.map((headerGroup)=>{
                return headerGroup.headers;
            }).flat();
        }, $a458d5bea2d12b69$export$b1f82222dc43996c(table.options, $a458d5bea2d12b69$var$debug, 'getFlatHeaders'));
        table.getLeftFlatHeaders = $a458d5bea2d12b69$export$7c73462e0d25e514(()=>[
                table.getLeftHeaderGroups()
            ], (left)=>{
            return left.map((headerGroup)=>{
                return headerGroup.headers;
            }).flat();
        }, $a458d5bea2d12b69$export$b1f82222dc43996c(table.options, $a458d5bea2d12b69$var$debug, 'getLeftFlatHeaders'));
        table.getCenterFlatHeaders = $a458d5bea2d12b69$export$7c73462e0d25e514(()=>[
                table.getCenterHeaderGroups()
            ], (left)=>{
            return left.map((headerGroup)=>{
                return headerGroup.headers;
            }).flat();
        }, $a458d5bea2d12b69$export$b1f82222dc43996c(table.options, $a458d5bea2d12b69$var$debug, 'getCenterFlatHeaders'));
        table.getRightFlatHeaders = $a458d5bea2d12b69$export$7c73462e0d25e514(()=>[
                table.getRightHeaderGroups()
            ], (left)=>{
            return left.map((headerGroup)=>{
                return headerGroup.headers;
            }).flat();
        }, $a458d5bea2d12b69$export$b1f82222dc43996c(table.options, $a458d5bea2d12b69$var$debug, 'getRightFlatHeaders'));
        // Leaf Headers
        table.getCenterLeafHeaders = $a458d5bea2d12b69$export$7c73462e0d25e514(()=>[
                table.getCenterFlatHeaders()
            ], (flatHeaders)=>{
            return flatHeaders.filter((header)=>{
                var _header$subHeaders;
                return !((_header$subHeaders = header.subHeaders) != null && _header$subHeaders.length);
            });
        }, $a458d5bea2d12b69$export$b1f82222dc43996c(table.options, $a458d5bea2d12b69$var$debug, 'getCenterLeafHeaders'));
        table.getLeftLeafHeaders = $a458d5bea2d12b69$export$7c73462e0d25e514(()=>[
                table.getLeftFlatHeaders()
            ], (flatHeaders)=>{
            return flatHeaders.filter((header)=>{
                var _header$subHeaders2;
                return !((_header$subHeaders2 = header.subHeaders) != null && _header$subHeaders2.length);
            });
        }, $a458d5bea2d12b69$export$b1f82222dc43996c(table.options, $a458d5bea2d12b69$var$debug, 'getLeftLeafHeaders'));
        table.getRightLeafHeaders = $a458d5bea2d12b69$export$7c73462e0d25e514(()=>[
                table.getRightFlatHeaders()
            ], (flatHeaders)=>{
            return flatHeaders.filter((header)=>{
                var _header$subHeaders3;
                return !((_header$subHeaders3 = header.subHeaders) != null && _header$subHeaders3.length);
            });
        }, $a458d5bea2d12b69$export$b1f82222dc43996c(table.options, $a458d5bea2d12b69$var$debug, 'getRightLeafHeaders'));
        table.getLeafHeaders = $a458d5bea2d12b69$export$7c73462e0d25e514(()=>[
                table.getLeftHeaderGroups(),
                table.getCenterHeaderGroups(),
                table.getRightHeaderGroups()
            ], (left, center, right)=>{
            var _left$0$headers, _left$, _center$0$headers, _center$, _right$0$headers, _right$;
            return [
                ...(_left$0$headers = (_left$ = left[0]) == null ? void 0 : _left$.headers) != null ? _left$0$headers : [],
                ...(_center$0$headers = (_center$ = center[0]) == null ? void 0 : _center$.headers) != null ? _center$0$headers : [],
                ...(_right$0$headers = (_right$ = right[0]) == null ? void 0 : _right$.headers) != null ? _right$0$headers : []
            ].map((header)=>{
                return header.getLeafHeaders();
            }).flat();
        }, $a458d5bea2d12b69$export$b1f82222dc43996c(table.options, $a458d5bea2d12b69$var$debug, 'getLeafHeaders'));
    }
};
function $a458d5bea2d12b69$export$d8c3a8af36458fc3(allColumns, columnsToGroup, table, headerFamily) {
    var _headerGroups$0$heade, _headerGroups$;
    // Find the max depth of the columns:
    // build the leaf column row
    // build each buffer row going up
    //    placeholder for non-existent level
    //    real column for existing level
    let maxDepth = 0;
    const findMaxDepth = function(columns, depth) {
        if (depth === void 0) depth = 1;
        maxDepth = Math.max(maxDepth, depth);
        columns.filter((column)=>column.getIsVisible()).forEach((column)=>{
            var _column$columns;
            if ((_column$columns = column.columns) != null && _column$columns.length) findMaxDepth(column.columns, depth + 1);
        }, 0);
    };
    findMaxDepth(allColumns);
    let headerGroups = [];
    const createHeaderGroup = (headersToGroup, depth)=>{
        // The header group we are creating
        const headerGroup = {
            depth: depth,
            id: [
                headerFamily,
                `${depth}`
            ].filter(Boolean).join('_'),
            headers: []
        };
        // The parent columns we're going to scan next
        const pendingParentHeaders = [];
        // Scan each column for parents
        headersToGroup.forEach((headerToGroup)=>{
            // What is the latest (last) parent column?
            const latestPendingParentHeader = [
                ...pendingParentHeaders
            ].reverse()[0];
            const isLeafHeader = headerToGroup.column.depth === headerGroup.depth;
            let column;
            let isPlaceholder = false;
            if (isLeafHeader && headerToGroup.column.parent) // The parent header is new
            column = headerToGroup.column.parent;
            else {
                // The parent header is repeated
                column = headerToGroup.column;
                isPlaceholder = true;
            }
            if (latestPendingParentHeader && (latestPendingParentHeader == null ? void 0 : latestPendingParentHeader.column) === column) // This column is repeated. Add it as a sub header to the next batch
            latestPendingParentHeader.subHeaders.push(headerToGroup);
            else {
                // This is a new header. Let's create it
                const header = $a458d5bea2d12b69$var$createHeader(table, column, {
                    id: [
                        headerFamily,
                        depth,
                        column.id,
                        headerToGroup == null ? void 0 : headerToGroup.id
                    ].filter(Boolean).join('_'),
                    isPlaceholder: isPlaceholder,
                    placeholderId: isPlaceholder ? `${pendingParentHeaders.filter((d)=>d.column === column).length}` : undefined,
                    depth: depth,
                    index: pendingParentHeaders.length
                });
                // Add the headerToGroup as a subHeader of the new header
                header.subHeaders.push(headerToGroup);
                // Add the new header to the pendingParentHeaders to get grouped
                // in the next batch
                pendingParentHeaders.push(header);
            }
            headerGroup.headers.push(headerToGroup);
            headerToGroup.headerGroup = headerGroup;
        });
        headerGroups.push(headerGroup);
        if (depth > 0) createHeaderGroup(pendingParentHeaders, depth - 1);
    };
    const bottomHeaders = columnsToGroup.map((column, index)=>$a458d5bea2d12b69$var$createHeader(table, column, {
            depth: maxDepth,
            index: index
        }));
    createHeaderGroup(bottomHeaders, maxDepth - 1);
    headerGroups.reverse();
    // headerGroups = headerGroups.filter(headerGroup => {
    //   return !headerGroup.headers.every(header => header.isPlaceholder)
    // })
    const recurseHeadersForSpans = (headers)=>{
        const filteredHeaders = headers.filter((header)=>header.column.getIsVisible());
        return filteredHeaders.map((header)=>{
            let colSpan = 0;
            let rowSpan = 0;
            let childRowSpans = [
                0
            ];
            if (header.subHeaders && header.subHeaders.length) {
                childRowSpans = [];
                recurseHeadersForSpans(header.subHeaders).forEach((_ref)=>{
                    let { colSpan: childColSpan, rowSpan: childRowSpan } = _ref;
                    colSpan += childColSpan;
                    childRowSpans.push(childRowSpan);
                });
            } else colSpan = 1;
            const minChildRowSpan = Math.min(...childRowSpans);
            rowSpan = rowSpan + minChildRowSpan;
            header.colSpan = colSpan;
            header.rowSpan = rowSpan;
            return {
                colSpan: colSpan,
                rowSpan: rowSpan
            };
        });
    };
    recurseHeadersForSpans((_headerGroups$0$heade = (_headerGroups$ = headerGroups[0]) == null ? void 0 : _headerGroups$.headers) != null ? _headerGroups$0$heade : []);
    return headerGroups;
}
const $a458d5bea2d12b69$export$3442c5d213434705 = (table, id, original, rowIndex, depth, subRows, parentId)=>{
    let row = {
        id: id,
        index: rowIndex,
        original: original,
        depth: depth,
        parentId: parentId,
        _valuesCache: {},
        _uniqueValuesCache: {},
        getValue: (columnId)=>{
            if (row._valuesCache.hasOwnProperty(columnId)) return row._valuesCache[columnId];
            const column = table.getColumn(columnId);
            if (!(column != null && column.accessorFn)) return undefined;
            row._valuesCache[columnId] = column.accessorFn(row.original, rowIndex);
            return row._valuesCache[columnId];
        },
        getUniqueValues: (columnId)=>{
            if (row._uniqueValuesCache.hasOwnProperty(columnId)) return row._uniqueValuesCache[columnId];
            const column = table.getColumn(columnId);
            if (!(column != null && column.accessorFn)) return undefined;
            if (!column.columnDef.getUniqueValues) {
                row._uniqueValuesCache[columnId] = [
                    row.getValue(columnId)
                ];
                return row._uniqueValuesCache[columnId];
            }
            row._uniqueValuesCache[columnId] = column.columnDef.getUniqueValues(row.original, rowIndex);
            return row._uniqueValuesCache[columnId];
        },
        renderValue: (columnId)=>{
            var _row$getValue;
            return (_row$getValue = row.getValue(columnId)) != null ? _row$getValue : table.options.renderFallbackValue;
        },
        subRows: subRows != null ? subRows : [],
        getLeafRows: ()=>$a458d5bea2d12b69$export$bf4548421d1b2c8(row.subRows, (d)=>d.subRows),
        getParentRow: ()=>row.parentId ? table.getRow(row.parentId, true) : undefined,
        getParentRows: ()=>{
            let parentRows = [];
            let currentRow = row;
            while(true){
                const parentRow = currentRow.getParentRow();
                if (!parentRow) break;
                parentRows.push(parentRow);
                currentRow = parentRow;
            }
            return parentRows.reverse();
        },
        getAllCells: $a458d5bea2d12b69$export$7c73462e0d25e514(()=>[
                table.getAllLeafColumns()
            ], (leafColumns)=>{
            return leafColumns.map((column)=>{
                return $a458d5bea2d12b69$export$3cb21b6b1233300e(table, row, column, column.id);
            });
        }, $a458d5bea2d12b69$export$b1f82222dc43996c(table.options, 'debugRows', 'getAllCells')),
        _getAllCellsByColumnId: $a458d5bea2d12b69$export$7c73462e0d25e514(()=>[
                row.getAllCells()
            ], (allCells)=>{
            return allCells.reduce((acc, cell)=>{
                acc[cell.column.id] = cell;
                return acc;
            }, {});
        }, $a458d5bea2d12b69$export$b1f82222dc43996c(table.options, 'debugRows', 'getAllCellsByColumnId'))
    };
    for(let i = 0; i < table._features.length; i++){
        const feature = table._features[i];
        feature == null || feature.createRow == null || feature.createRow(row, table);
    }
    return row;
};
//
const $a458d5bea2d12b69$export$1f746e6a9cd841b1 = {
    createColumn: (column, table)=>{
        column._getFacetedRowModel = table.options.getFacetedRowModel && table.options.getFacetedRowModel(table, column.id);
        column.getFacetedRowModel = ()=>{
            if (!column._getFacetedRowModel) return table.getPreFilteredRowModel();
            return column._getFacetedRowModel();
        };
        column._getFacetedUniqueValues = table.options.getFacetedUniqueValues && table.options.getFacetedUniqueValues(table, column.id);
        column.getFacetedUniqueValues = ()=>{
            if (!column._getFacetedUniqueValues) return new Map();
            return column._getFacetedUniqueValues();
        };
        column._getFacetedMinMaxValues = table.options.getFacetedMinMaxValues && table.options.getFacetedMinMaxValues(table, column.id);
        column.getFacetedMinMaxValues = ()=>{
            if (!column._getFacetedMinMaxValues) return undefined;
            return column._getFacetedMinMaxValues();
        };
    }
};
const $a458d5bea2d12b69$var$includesString = (row, columnId, filterValue)=>{
    var _filterValue$toString, _row$getValue;
    const search = filterValue == null || (_filterValue$toString = filterValue.toString()) == null ? void 0 : _filterValue$toString.toLowerCase();
    return Boolean((_row$getValue = row.getValue(columnId)) == null || (_row$getValue = _row$getValue.toString()) == null || (_row$getValue = _row$getValue.toLowerCase()) == null ? void 0 : _row$getValue.includes(search));
};
$a458d5bea2d12b69$var$includesString.autoRemove = (val)=>$a458d5bea2d12b69$var$testFalsey(val);
const $a458d5bea2d12b69$var$includesStringSensitive = (row, columnId, filterValue)=>{
    var _row$getValue2;
    return Boolean((_row$getValue2 = row.getValue(columnId)) == null || (_row$getValue2 = _row$getValue2.toString()) == null ? void 0 : _row$getValue2.includes(filterValue));
};
$a458d5bea2d12b69$var$includesStringSensitive.autoRemove = (val)=>$a458d5bea2d12b69$var$testFalsey(val);
const $a458d5bea2d12b69$var$equalsString = (row, columnId, filterValue)=>{
    var _row$getValue3;
    return ((_row$getValue3 = row.getValue(columnId)) == null || (_row$getValue3 = _row$getValue3.toString()) == null ? void 0 : _row$getValue3.toLowerCase()) === (filterValue == null ? void 0 : filterValue.toLowerCase());
};
$a458d5bea2d12b69$var$equalsString.autoRemove = (val)=>$a458d5bea2d12b69$var$testFalsey(val);
const $a458d5bea2d12b69$var$arrIncludes = (row, columnId, filterValue)=>{
    var _row$getValue4;
    return (_row$getValue4 = row.getValue(columnId)) == null ? void 0 : _row$getValue4.includes(filterValue);
};
$a458d5bea2d12b69$var$arrIncludes.autoRemove = (val)=>$a458d5bea2d12b69$var$testFalsey(val);
const $a458d5bea2d12b69$var$arrIncludesAll = (row, columnId, filterValue)=>{
    return !filterValue.some((val)=>{
        var _row$getValue5;
        return !((_row$getValue5 = row.getValue(columnId)) != null && _row$getValue5.includes(val));
    });
};
$a458d5bea2d12b69$var$arrIncludesAll.autoRemove = (val)=>$a458d5bea2d12b69$var$testFalsey(val) || !(val != null && val.length);
const $a458d5bea2d12b69$var$arrIncludesSome = (row, columnId, filterValue)=>{
    return filterValue.some((val)=>{
        var _row$getValue6;
        return (_row$getValue6 = row.getValue(columnId)) == null ? void 0 : _row$getValue6.includes(val);
    });
};
$a458d5bea2d12b69$var$arrIncludesSome.autoRemove = (val)=>$a458d5bea2d12b69$var$testFalsey(val) || !(val != null && val.length);
const $a458d5bea2d12b69$var$equals = (row, columnId, filterValue)=>{
    return row.getValue(columnId) === filterValue;
};
$a458d5bea2d12b69$var$equals.autoRemove = (val)=>$a458d5bea2d12b69$var$testFalsey(val);
const $a458d5bea2d12b69$var$weakEquals = (row, columnId, filterValue)=>{
    return row.getValue(columnId) == filterValue;
};
$a458d5bea2d12b69$var$weakEquals.autoRemove = (val)=>$a458d5bea2d12b69$var$testFalsey(val);
const $a458d5bea2d12b69$var$inNumberRange = (row, columnId, filterValue)=>{
    let [min, max] = filterValue;
    const rowValue = row.getValue(columnId);
    return rowValue >= min && rowValue <= max;
};
$a458d5bea2d12b69$var$inNumberRange.resolveFilterValue = (val)=>{
    let [unsafeMin, unsafeMax] = val;
    let parsedMin = typeof unsafeMin !== 'number' ? parseFloat(unsafeMin) : unsafeMin;
    let parsedMax = typeof unsafeMax !== 'number' ? parseFloat(unsafeMax) : unsafeMax;
    let min = unsafeMin === null || Number.isNaN(parsedMin) ? -Infinity : parsedMin;
    let max = unsafeMax === null || Number.isNaN(parsedMax) ? Infinity : parsedMax;
    if (min > max) {
        const temp = min;
        min = max;
        max = temp;
    }
    return [
        min,
        max
    ];
};
$a458d5bea2d12b69$var$inNumberRange.autoRemove = (val)=>$a458d5bea2d12b69$var$testFalsey(val) || $a458d5bea2d12b69$var$testFalsey(val[0]) && $a458d5bea2d12b69$var$testFalsey(val[1]);
// Export
const $a458d5bea2d12b69$export$6ad8312e296ec316 = {
    includesString: $a458d5bea2d12b69$var$includesString,
    includesStringSensitive: $a458d5bea2d12b69$var$includesStringSensitive,
    equalsString: $a458d5bea2d12b69$var$equalsString,
    arrIncludes: $a458d5bea2d12b69$var$arrIncludes,
    arrIncludesAll: $a458d5bea2d12b69$var$arrIncludesAll,
    arrIncludesSome: $a458d5bea2d12b69$var$arrIncludesSome,
    equals: $a458d5bea2d12b69$var$equals,
    weakEquals: $a458d5bea2d12b69$var$weakEquals,
    inNumberRange: $a458d5bea2d12b69$var$inNumberRange
};
// Utils
function $a458d5bea2d12b69$var$testFalsey(val) {
    return val === undefined || val === null || val === '';
}
//
const $a458d5bea2d12b69$export$f1d67534a0c5e9d3 = {
    getDefaultColumnDef: ()=>{
        return {
            filterFn: 'auto'
        };
    },
    getInitialState: (state)=>{
        return {
            columnFilters: [],
            ...state
        };
    },
    getDefaultOptions: (table)=>{
        return {
            onColumnFiltersChange: $a458d5bea2d12b69$export$2b5605d8069324bd('columnFilters', table),
            filterFromLeafRows: false,
            maxLeafRowFilterDepth: 100
        };
    },
    createColumn: (column, table)=>{
        column.getAutoFilterFn = ()=>{
            const firstRow = table.getCoreRowModel().flatRows[0];
            const value = firstRow == null ? void 0 : firstRow.getValue(column.id);
            if (typeof value === 'string') return $a458d5bea2d12b69$export$6ad8312e296ec316.includesString;
            if (typeof value === 'number') return $a458d5bea2d12b69$export$6ad8312e296ec316.inNumberRange;
            if (typeof value === 'boolean') return $a458d5bea2d12b69$export$6ad8312e296ec316.equals;
            if (value !== null && typeof value === 'object') return $a458d5bea2d12b69$export$6ad8312e296ec316.equals;
            if (Array.isArray(value)) return $a458d5bea2d12b69$export$6ad8312e296ec316.arrIncludes;
            return $a458d5bea2d12b69$export$6ad8312e296ec316.weakEquals;
        };
        column.getFilterFn = ()=>{
            var _table$options$filter, _table$options$filter2;
            return $a458d5bea2d12b69$export$f6e2535fb5126e54(column.columnDef.filterFn) ? column.columnDef.filterFn : column.columnDef.filterFn === 'auto' ? column.getAutoFilterFn() : (_table$options$filter = (_table$options$filter2 = table.options.filterFns) == null ? void 0 : _table$options$filter2[column.columnDef.filterFn]) != null ? _table$options$filter : $a458d5bea2d12b69$export$6ad8312e296ec316[column.columnDef.filterFn];
        };
        column.getCanFilter = ()=>{
            var _column$columnDef$ena, _table$options$enable, _table$options$enable2;
            return ((_column$columnDef$ena = column.columnDef.enableColumnFilter) != null ? _column$columnDef$ena : true) && ((_table$options$enable = table.options.enableColumnFilters) != null ? _table$options$enable : true) && ((_table$options$enable2 = table.options.enableFilters) != null ? _table$options$enable2 : true) && !!column.accessorFn;
        };
        column.getIsFiltered = ()=>column.getFilterIndex() > -1;
        column.getFilterValue = ()=>{
            var _table$getState$colum;
            return (_table$getState$colum = table.getState().columnFilters) == null || (_table$getState$colum = _table$getState$colum.find((d)=>d.id === column.id)) == null ? void 0 : _table$getState$colum.value;
        };
        column.getFilterIndex = ()=>{
            var _table$getState$colum2, _table$getState$colum3;
            return (_table$getState$colum2 = (_table$getState$colum3 = table.getState().columnFilters) == null ? void 0 : _table$getState$colum3.findIndex((d)=>d.id === column.id)) != null ? _table$getState$colum2 : -1;
        };
        column.setFilterValue = (value)=>{
            table.setColumnFilters((old)=>{
                const filterFn = column.getFilterFn();
                const previousFilter = old == null ? void 0 : old.find((d)=>d.id === column.id);
                const newFilter = $a458d5bea2d12b69$export$7f095f455ad5af3f(value, previousFilter ? previousFilter.value : undefined);
                //
                if ($a458d5bea2d12b69$export$5b01eb94d7ce58a8(filterFn, newFilter, column)) {
                    var _old$filter;
                    return (_old$filter = old == null ? void 0 : old.filter((d)=>d.id !== column.id)) != null ? _old$filter : [];
                }
                const newFilterObj = {
                    id: column.id,
                    value: newFilter
                };
                if (previousFilter) {
                    var _old$map;
                    return (_old$map = old == null ? void 0 : old.map((d)=>{
                        if (d.id === column.id) return newFilterObj;
                        return d;
                    })) != null ? _old$map : [];
                }
                if (old != null && old.length) return [
                    ...old,
                    newFilterObj
                ];
                return [
                    newFilterObj
                ];
            });
        };
    },
    createRow: (row, _table)=>{
        row.columnFilters = {};
        row.columnFiltersMeta = {};
    },
    createTable: (table)=>{
        table.setColumnFilters = (updater)=>{
            const leafColumns = table.getAllLeafColumns();
            const updateFn = (old)=>{
                var _functionalUpdate;
                return (_functionalUpdate = $a458d5bea2d12b69$export$7f095f455ad5af3f(updater, old)) == null ? void 0 : _functionalUpdate.filter((filter)=>{
                    const column = leafColumns.find((d)=>d.id === filter.id);
                    if (column) {
                        const filterFn = column.getFilterFn();
                        if ($a458d5bea2d12b69$export$5b01eb94d7ce58a8(filterFn, filter.value, column)) return false;
                    }
                    return true;
                });
            };
            table.options.onColumnFiltersChange == null || table.options.onColumnFiltersChange(updateFn);
        };
        table.resetColumnFilters = (defaultState)=>{
            var _table$initialState$c, _table$initialState;
            table.setColumnFilters(defaultState ? [] : (_table$initialState$c = (_table$initialState = table.initialState) == null ? void 0 : _table$initialState.columnFilters) != null ? _table$initialState$c : []);
        };
        table.getPreFilteredRowModel = ()=>table.getCoreRowModel();
        table.getFilteredRowModel = ()=>{
            if (!table._getFilteredRowModel && table.options.getFilteredRowModel) table._getFilteredRowModel = table.options.getFilteredRowModel(table);
            if (table.options.manualFiltering || !table._getFilteredRowModel) return table.getPreFilteredRowModel();
            return table._getFilteredRowModel();
        };
    }
};
function $a458d5bea2d12b69$export$5b01eb94d7ce58a8(filterFn, value, column) {
    return (filterFn && filterFn.autoRemove ? filterFn.autoRemove(value, column) : false) || typeof value === 'undefined' || typeof value === 'string' && !value;
}
const $a458d5bea2d12b69$var$sum = (columnId, _leafRows, childRows)=>{
    // It's faster to just add the aggregations together instead of
    // process leaf nodes individually
    return childRows.reduce((sum, next)=>{
        const nextValue = next.getValue(columnId);
        return sum + (typeof nextValue === 'number' ? nextValue : 0);
    }, 0);
};
const $a458d5bea2d12b69$var$min = (columnId, _leafRows, childRows)=>{
    let min;
    childRows.forEach((row)=>{
        const value = row.getValue(columnId);
        if (value != null && (min > value || min === undefined && value >= value)) min = value;
    });
    return min;
};
const $a458d5bea2d12b69$var$max = (columnId, _leafRows, childRows)=>{
    let max;
    childRows.forEach((row)=>{
        const value = row.getValue(columnId);
        if (value != null && (max < value || max === undefined && value >= value)) max = value;
    });
    return max;
};
const $a458d5bea2d12b69$var$extent = (columnId, _leafRows, childRows)=>{
    let min;
    let max;
    childRows.forEach((row)=>{
        const value = row.getValue(columnId);
        if (value != null) {
            if (min === undefined) {
                if (value >= value) min = max = value;
            } else {
                if (min > value) min = value;
                if (max < value) max = value;
            }
        }
    });
    return [
        min,
        max
    ];
};
const $a458d5bea2d12b69$var$mean = (columnId, leafRows)=>{
    let count = 0;
    let sum = 0;
    leafRows.forEach((row)=>{
        let value = row.getValue(columnId);
        if (value != null && (value = +value) >= value) ++count, sum += value;
    });
    if (count) return sum / count;
    return;
};
const $a458d5bea2d12b69$var$median = (columnId, leafRows)=>{
    if (!leafRows.length) return;
    const values = leafRows.map((row)=>row.getValue(columnId));
    if (!$a458d5bea2d12b69$export$5cd576d1827d40c8(values)) return;
    if (values.length === 1) return values[0];
    const mid = Math.floor(values.length / 2);
    const nums = values.sort((a, b)=>a - b);
    return values.length % 2 !== 0 ? nums[mid] : (nums[mid - 1] + nums[mid]) / 2;
};
const $a458d5bea2d12b69$var$unique = (columnId, leafRows)=>{
    return Array.from(new Set(leafRows.map((d)=>d.getValue(columnId))).values());
};
const $a458d5bea2d12b69$var$uniqueCount = (columnId, leafRows)=>{
    return new Set(leafRows.map((d)=>d.getValue(columnId))).size;
};
const $a458d5bea2d12b69$var$count = (_columnId, leafRows)=>{
    return leafRows.length;
};
const $a458d5bea2d12b69$export$3aa4339120b8b25b = {
    sum: $a458d5bea2d12b69$var$sum,
    min: $a458d5bea2d12b69$var$min,
    max: $a458d5bea2d12b69$var$max,
    extent: $a458d5bea2d12b69$var$extent,
    mean: $a458d5bea2d12b69$var$mean,
    median: $a458d5bea2d12b69$var$median,
    unique: $a458d5bea2d12b69$var$unique,
    uniqueCount: $a458d5bea2d12b69$var$uniqueCount,
    count: $a458d5bea2d12b69$var$count
};
//
const $a458d5bea2d12b69$export$9c9247c655f92e74 = {
    getDefaultColumnDef: ()=>{
        return {
            aggregatedCell: (props)=>{
                var _toString, _props$getValue;
                return (_toString = (_props$getValue = props.getValue()) == null || _props$getValue.toString == null ? void 0 : _props$getValue.toString()) != null ? _toString : null;
            },
            aggregationFn: 'auto'
        };
    },
    getInitialState: (state)=>{
        return {
            grouping: [],
            ...state
        };
    },
    getDefaultOptions: (table)=>{
        return {
            onGroupingChange: $a458d5bea2d12b69$export$2b5605d8069324bd('grouping', table),
            groupedColumnMode: 'reorder'
        };
    },
    createColumn: (column, table)=>{
        column.toggleGrouping = ()=>{
            table.setGrouping((old)=>{
                // Find any existing grouping for this column
                if (old != null && old.includes(column.id)) return old.filter((d)=>d !== column.id);
                return [
                    ...old != null ? old : [],
                    column.id
                ];
            });
        };
        column.getCanGroup = ()=>{
            var _column$columnDef$ena, _table$options$enable;
            return ((_column$columnDef$ena = column.columnDef.enableGrouping) != null ? _column$columnDef$ena : true) && ((_table$options$enable = table.options.enableGrouping) != null ? _table$options$enable : true) && (!!column.accessorFn || !!column.columnDef.getGroupingValue);
        };
        column.getIsGrouped = ()=>{
            var _table$getState$group;
            return (_table$getState$group = table.getState().grouping) == null ? void 0 : _table$getState$group.includes(column.id);
        };
        column.getGroupedIndex = ()=>{
            var _table$getState$group2;
            return (_table$getState$group2 = table.getState().grouping) == null ? void 0 : _table$getState$group2.indexOf(column.id);
        };
        column.getToggleGroupingHandler = ()=>{
            const canGroup = column.getCanGroup();
            return ()=>{
                if (!canGroup) return;
                column.toggleGrouping();
            };
        };
        column.getAutoAggregationFn = ()=>{
            const firstRow = table.getCoreRowModel().flatRows[0];
            const value = firstRow == null ? void 0 : firstRow.getValue(column.id);
            if (typeof value === 'number') return $a458d5bea2d12b69$export$3aa4339120b8b25b.sum;
            if (Object.prototype.toString.call(value) === '[object Date]') return $a458d5bea2d12b69$export$3aa4339120b8b25b.extent;
        };
        column.getAggregationFn = ()=>{
            var _table$options$aggreg, _table$options$aggreg2;
            if (!column) throw new Error();
            return $a458d5bea2d12b69$export$f6e2535fb5126e54(column.columnDef.aggregationFn) ? column.columnDef.aggregationFn : column.columnDef.aggregationFn === 'auto' ? column.getAutoAggregationFn() : (_table$options$aggreg = (_table$options$aggreg2 = table.options.aggregationFns) == null ? void 0 : _table$options$aggreg2[column.columnDef.aggregationFn]) != null ? _table$options$aggreg : $a458d5bea2d12b69$export$3aa4339120b8b25b[column.columnDef.aggregationFn];
        };
    },
    createTable: (table)=>{
        table.setGrouping = (updater)=>table.options.onGroupingChange == null ? void 0 : table.options.onGroupingChange(updater);
        table.resetGrouping = (defaultState)=>{
            var _table$initialState$g, _table$initialState;
            table.setGrouping(defaultState ? [] : (_table$initialState$g = (_table$initialState = table.initialState) == null ? void 0 : _table$initialState.grouping) != null ? _table$initialState$g : []);
        };
        table.getPreGroupedRowModel = ()=>table.getFilteredRowModel();
        table.getGroupedRowModel = ()=>{
            if (!table._getGroupedRowModel && table.options.getGroupedRowModel) table._getGroupedRowModel = table.options.getGroupedRowModel(table);
            if (table.options.manualGrouping || !table._getGroupedRowModel) return table.getPreGroupedRowModel();
            return table._getGroupedRowModel();
        };
    },
    createRow: (row, table)=>{
        row.getIsGrouped = ()=>!!row.groupingColumnId;
        row.getGroupingValue = (columnId)=>{
            if (row._groupingValuesCache.hasOwnProperty(columnId)) return row._groupingValuesCache[columnId];
            const column = table.getColumn(columnId);
            if (!(column != null && column.columnDef.getGroupingValue)) return row.getValue(columnId);
            row._groupingValuesCache[columnId] = column.columnDef.getGroupingValue(row.original);
            return row._groupingValuesCache[columnId];
        };
        row._groupingValuesCache = {};
    },
    createCell: (cell, column, row, table)=>{
        cell.getIsGrouped = ()=>column.getIsGrouped() && column.id === row.groupingColumnId;
        cell.getIsPlaceholder = ()=>!cell.getIsGrouped() && column.getIsGrouped();
        cell.getIsAggregated = ()=>{
            var _row$subRows;
            return !cell.getIsGrouped() && !cell.getIsPlaceholder() && !!((_row$subRows = row.subRows) != null && _row$subRows.length);
        };
    }
};
function $a458d5bea2d12b69$export$ac763d2b0470e663(leafColumns, grouping, groupedColumnMode) {
    if (!(grouping != null && grouping.length) || !groupedColumnMode) return leafColumns;
    const nonGroupingColumns = leafColumns.filter((col)=>!grouping.includes(col.id));
    if (groupedColumnMode === 'remove') return nonGroupingColumns;
    const groupingColumns = grouping.map((g)=>leafColumns.find((col)=>col.id === g)).filter(Boolean);
    return [
        ...groupingColumns,
        ...nonGroupingColumns
    ];
}
//
const $a458d5bea2d12b69$export$fec9c66cd0275c2c = {
    getInitialState: (state)=>{
        return {
            columnOrder: [],
            ...state
        };
    },
    getDefaultOptions: (table)=>{
        return {
            onColumnOrderChange: $a458d5bea2d12b69$export$2b5605d8069324bd('columnOrder', table)
        };
    },
    createColumn: (column, table)=>{
        column.getIndex = $a458d5bea2d12b69$export$7c73462e0d25e514((position)=>[
                $a458d5bea2d12b69$export$1d7c103713892a11(table, position)
            ], (columns)=>columns.findIndex((d)=>d.id === column.id), $a458d5bea2d12b69$export$b1f82222dc43996c(table.options, 'debugColumns', 'getIndex'));
        column.getIsFirstColumn = (position)=>{
            var _columns$;
            const columns = $a458d5bea2d12b69$export$1d7c103713892a11(table, position);
            return ((_columns$ = columns[0]) == null ? void 0 : _columns$.id) === column.id;
        };
        column.getIsLastColumn = (position)=>{
            var _columns;
            const columns = $a458d5bea2d12b69$export$1d7c103713892a11(table, position);
            return ((_columns = columns[columns.length - 1]) == null ? void 0 : _columns.id) === column.id;
        };
    },
    createTable: (table)=>{
        table.setColumnOrder = (updater)=>table.options.onColumnOrderChange == null ? void 0 : table.options.onColumnOrderChange(updater);
        table.resetColumnOrder = (defaultState)=>{
            var _table$initialState$c;
            table.setColumnOrder(defaultState ? [] : (_table$initialState$c = table.initialState.columnOrder) != null ? _table$initialState$c : []);
        };
        table._getOrderColumnsFn = $a458d5bea2d12b69$export$7c73462e0d25e514(()=>[
                table.getState().columnOrder,
                table.getState().grouping,
                table.options.groupedColumnMode
            ], (columnOrder, grouping, groupedColumnMode)=>(columns)=>{
                // Sort grouped columns to the start of the column list
                // before the headers are built
                let orderedColumns = [];
                // If there is no order, return the normal columns
                if (!(columnOrder != null && columnOrder.length)) orderedColumns = columns;
                else {
                    const columnOrderCopy = [
                        ...columnOrder
                    ];
                    // If there is an order, make a copy of the columns
                    const columnsCopy = [
                        ...columns
                    ];
                    // And make a new ordered array of the columns
                    // Loop over the columns and place them in order into the new array
                    while(columnsCopy.length && columnOrderCopy.length){
                        const targetColumnId = columnOrderCopy.shift();
                        const foundIndex = columnsCopy.findIndex((d)=>d.id === targetColumnId);
                        if (foundIndex > -1) orderedColumns.push(columnsCopy.splice(foundIndex, 1)[0]);
                    }
                    // If there are any columns left, add them to the end
                    orderedColumns = [
                        ...orderedColumns,
                        ...columnsCopy
                    ];
                }
                return $a458d5bea2d12b69$export$ac763d2b0470e663(orderedColumns, grouping, groupedColumnMode);
            }, $a458d5bea2d12b69$export$b1f82222dc43996c(table.options, 'debugTable', '_getOrderColumnsFn'));
    }
};
//
const $a458d5bea2d12b69$var$getDefaultColumnPinningState = ()=>({
        left: [],
        right: []
    });
const $a458d5bea2d12b69$export$3563275ce70c4813 = {
    getInitialState: (state)=>{
        return {
            columnPinning: $a458d5bea2d12b69$var$getDefaultColumnPinningState(),
            ...state
        };
    },
    getDefaultOptions: (table)=>{
        return {
            onColumnPinningChange: $a458d5bea2d12b69$export$2b5605d8069324bd('columnPinning', table)
        };
    },
    createColumn: (column, table)=>{
        column.pin = (position)=>{
            const columnIds = column.getLeafColumns().map((d)=>d.id).filter(Boolean);
            table.setColumnPinning((old)=>{
                var _old$left3, _old$right3;
                if (position === 'right') {
                    var _old$left, _old$right;
                    return {
                        left: ((_old$left = old == null ? void 0 : old.left) != null ? _old$left : []).filter((d)=>!(columnIds != null && columnIds.includes(d))),
                        right: [
                            ...((_old$right = old == null ? void 0 : old.right) != null ? _old$right : []).filter((d)=>!(columnIds != null && columnIds.includes(d))),
                            ...columnIds
                        ]
                    };
                }
                if (position === 'left') {
                    var _old$left2, _old$right2;
                    return {
                        left: [
                            ...((_old$left2 = old == null ? void 0 : old.left) != null ? _old$left2 : []).filter((d)=>!(columnIds != null && columnIds.includes(d))),
                            ...columnIds
                        ],
                        right: ((_old$right2 = old == null ? void 0 : old.right) != null ? _old$right2 : []).filter((d)=>!(columnIds != null && columnIds.includes(d)))
                    };
                }
                return {
                    left: ((_old$left3 = old == null ? void 0 : old.left) != null ? _old$left3 : []).filter((d)=>!(columnIds != null && columnIds.includes(d))),
                    right: ((_old$right3 = old == null ? void 0 : old.right) != null ? _old$right3 : []).filter((d)=>!(columnIds != null && columnIds.includes(d)))
                };
            });
        };
        column.getCanPin = ()=>{
            const leafColumns = column.getLeafColumns();
            return leafColumns.some((d)=>{
                var _d$columnDef$enablePi, _ref, _table$options$enable;
                return ((_d$columnDef$enablePi = d.columnDef.enablePinning) != null ? _d$columnDef$enablePi : true) && ((_ref = (_table$options$enable = table.options.enableColumnPinning) != null ? _table$options$enable : table.options.enablePinning) != null ? _ref : true);
            });
        };
        column.getIsPinned = ()=>{
            const leafColumnIds = column.getLeafColumns().map((d)=>d.id);
            const { left: left, right: right } = table.getState().columnPinning;
            const isLeft = leafColumnIds.some((d)=>left == null ? void 0 : left.includes(d));
            const isRight = leafColumnIds.some((d)=>right == null ? void 0 : right.includes(d));
            return isLeft ? 'left' : isRight ? 'right' : false;
        };
        column.getPinnedIndex = ()=>{
            var _table$getState$colum, _table$getState$colum2;
            const position = column.getIsPinned();
            return position ? (_table$getState$colum = (_table$getState$colum2 = table.getState().columnPinning) == null || (_table$getState$colum2 = _table$getState$colum2[position]) == null ? void 0 : _table$getState$colum2.indexOf(column.id)) != null ? _table$getState$colum : -1 : 0;
        };
    },
    createRow: (row, table)=>{
        row.getCenterVisibleCells = $a458d5bea2d12b69$export$7c73462e0d25e514(()=>[
                row._getAllVisibleCells(),
                table.getState().columnPinning.left,
                table.getState().columnPinning.right
            ], (allCells, left, right)=>{
            const leftAndRight = [
                ...left != null ? left : [],
                ...right != null ? right : []
            ];
            return allCells.filter((d)=>!leftAndRight.includes(d.column.id));
        }, $a458d5bea2d12b69$export$b1f82222dc43996c(table.options, 'debugRows', 'getCenterVisibleCells'));
        row.getLeftVisibleCells = $a458d5bea2d12b69$export$7c73462e0d25e514(()=>[
                row._getAllVisibleCells(),
                table.getState().columnPinning.left
            ], (allCells, left)=>{
            const cells = (left != null ? left : []).map((columnId)=>allCells.find((cell)=>cell.column.id === columnId)).filter(Boolean).map((d)=>({
                    ...d,
                    position: 'left'
                }));
            return cells;
        }, $a458d5bea2d12b69$export$b1f82222dc43996c(table.options, 'debugRows', 'getLeftVisibleCells'));
        row.getRightVisibleCells = $a458d5bea2d12b69$export$7c73462e0d25e514(()=>[
                row._getAllVisibleCells(),
                table.getState().columnPinning.right
            ], (allCells, right)=>{
            const cells = (right != null ? right : []).map((columnId)=>allCells.find((cell)=>cell.column.id === columnId)).filter(Boolean).map((d)=>({
                    ...d,
                    position: 'right'
                }));
            return cells;
        }, $a458d5bea2d12b69$export$b1f82222dc43996c(table.options, 'debugRows', 'getRightVisibleCells'));
    },
    createTable: (table)=>{
        table.setColumnPinning = (updater)=>table.options.onColumnPinningChange == null ? void 0 : table.options.onColumnPinningChange(updater);
        table.resetColumnPinning = (defaultState)=>{
            var _table$initialState$c, _table$initialState;
            return table.setColumnPinning(defaultState ? $a458d5bea2d12b69$var$getDefaultColumnPinningState() : (_table$initialState$c = (_table$initialState = table.initialState) == null ? void 0 : _table$initialState.columnPinning) != null ? _table$initialState$c : $a458d5bea2d12b69$var$getDefaultColumnPinningState());
        };
        table.getIsSomeColumnsPinned = (position)=>{
            var _pinningState$positio;
            const pinningState = table.getState().columnPinning;
            if (!position) {
                var _pinningState$left, _pinningState$right;
                return Boolean(((_pinningState$left = pinningState.left) == null ? void 0 : _pinningState$left.length) || ((_pinningState$right = pinningState.right) == null ? void 0 : _pinningState$right.length));
            }
            return Boolean((_pinningState$positio = pinningState[position]) == null ? void 0 : _pinningState$positio.length);
        };
        table.getLeftLeafColumns = $a458d5bea2d12b69$export$7c73462e0d25e514(()=>[
                table.getAllLeafColumns(),
                table.getState().columnPinning.left
            ], (allColumns, left)=>{
            return (left != null ? left : []).map((columnId)=>allColumns.find((column)=>column.id === columnId)).filter(Boolean);
        }, $a458d5bea2d12b69$export$b1f82222dc43996c(table.options, 'debugColumns', 'getLeftLeafColumns'));
        table.getRightLeafColumns = $a458d5bea2d12b69$export$7c73462e0d25e514(()=>[
                table.getAllLeafColumns(),
                table.getState().columnPinning.right
            ], (allColumns, right)=>{
            return (right != null ? right : []).map((columnId)=>allColumns.find((column)=>column.id === columnId)).filter(Boolean);
        }, $a458d5bea2d12b69$export$b1f82222dc43996c(table.options, 'debugColumns', 'getRightLeafColumns'));
        table.getCenterLeafColumns = $a458d5bea2d12b69$export$7c73462e0d25e514(()=>[
                table.getAllLeafColumns(),
                table.getState().columnPinning.left,
                table.getState().columnPinning.right
            ], (allColumns, left, right)=>{
            const leftAndRight = [
                ...left != null ? left : [],
                ...right != null ? right : []
            ];
            return allColumns.filter((d)=>!leftAndRight.includes(d.id));
        }, $a458d5bea2d12b69$export$b1f82222dc43996c(table.options, 'debugColumns', 'getCenterLeafColumns'));
    }
};
function $a458d5bea2d12b69$var$safelyAccessDocument(_document) {
    return _document || (typeof document !== 'undefined' ? document : null);
}
//
//
const $a458d5bea2d12b69$export$2f660993f4eb1f29 = {
    size: 150,
    minSize: 20,
    maxSize: Number.MAX_SAFE_INTEGER
};
const $a458d5bea2d12b69$var$getDefaultColumnSizingInfoState = ()=>({
        startOffset: null,
        startSize: null,
        deltaOffset: null,
        deltaPercentage: null,
        isResizingColumn: false,
        columnSizingStart: []
    });
const $a458d5bea2d12b69$export$9916c85814812d4a = {
    getDefaultColumnDef: ()=>{
        return $a458d5bea2d12b69$export$2f660993f4eb1f29;
    },
    getInitialState: (state)=>{
        return {
            columnSizing: {},
            columnSizingInfo: $a458d5bea2d12b69$var$getDefaultColumnSizingInfoState(),
            ...state
        };
    },
    getDefaultOptions: (table)=>{
        return {
            columnResizeMode: 'onEnd',
            columnResizeDirection: 'ltr',
            onColumnSizingChange: $a458d5bea2d12b69$export$2b5605d8069324bd('columnSizing', table),
            onColumnSizingInfoChange: $a458d5bea2d12b69$export$2b5605d8069324bd('columnSizingInfo', table)
        };
    },
    createColumn: (column, table)=>{
        column.getSize = ()=>{
            var _column$columnDef$min, _ref, _column$columnDef$max;
            const columnSize = table.getState().columnSizing[column.id];
            return Math.min(Math.max((_column$columnDef$min = column.columnDef.minSize) != null ? _column$columnDef$min : $a458d5bea2d12b69$export$2f660993f4eb1f29.minSize, (_ref = columnSize != null ? columnSize : column.columnDef.size) != null ? _ref : $a458d5bea2d12b69$export$2f660993f4eb1f29.size), (_column$columnDef$max = column.columnDef.maxSize) != null ? _column$columnDef$max : $a458d5bea2d12b69$export$2f660993f4eb1f29.maxSize);
        };
        column.getStart = $a458d5bea2d12b69$export$7c73462e0d25e514((position)=>[
                position,
                $a458d5bea2d12b69$export$1d7c103713892a11(table, position),
                table.getState().columnSizing
            ], (position, columns)=>columns.slice(0, column.getIndex(position)).reduce((sum, column)=>sum + column.getSize(), 0), $a458d5bea2d12b69$export$b1f82222dc43996c(table.options, 'debugColumns', 'getStart'));
        column.getAfter = $a458d5bea2d12b69$export$7c73462e0d25e514((position)=>[
                position,
                $a458d5bea2d12b69$export$1d7c103713892a11(table, position),
                table.getState().columnSizing
            ], (position, columns)=>columns.slice(column.getIndex(position) + 1).reduce((sum, column)=>sum + column.getSize(), 0), $a458d5bea2d12b69$export$b1f82222dc43996c(table.options, 'debugColumns', 'getAfter'));
        column.resetSize = ()=>{
            table.setColumnSizing((_ref2)=>{
                let { [column.id]: _, ...rest } = _ref2;
                return rest;
            });
        };
        column.getCanResize = ()=>{
            var _column$columnDef$ena, _table$options$enable;
            return ((_column$columnDef$ena = column.columnDef.enableResizing) != null ? _column$columnDef$ena : true) && ((_table$options$enable = table.options.enableColumnResizing) != null ? _table$options$enable : true);
        };
        column.getIsResizing = ()=>{
            return table.getState().columnSizingInfo.isResizingColumn === column.id;
        };
    },
    createHeader: (header, table)=>{
        header.getSize = ()=>{
            let sum = 0;
            const recurse = (header)=>{
                if (header.subHeaders.length) header.subHeaders.forEach(recurse);
                else {
                    var _header$column$getSiz;
                    sum += (_header$column$getSiz = header.column.getSize()) != null ? _header$column$getSiz : 0;
                }
            };
            recurse(header);
            return sum;
        };
        header.getStart = ()=>{
            if (header.index > 0) {
                const prevSiblingHeader = header.headerGroup.headers[header.index - 1];
                return prevSiblingHeader.getStart() + prevSiblingHeader.getSize();
            }
            return 0;
        };
        header.getResizeHandler = (_contextDocument)=>{
            const column = table.getColumn(header.column.id);
            const canResize = column == null ? void 0 : column.getCanResize();
            return (e)=>{
                if (!column || !canResize) return;
                e.persist == null || e.persist();
                if ($a458d5bea2d12b69$var$isTouchStartEvent(e)) {
                    // lets not respond to multiple touches (e.g. 2 or 3 fingers)
                    if (e.touches && e.touches.length > 1) return;
                }
                const startSize = header.getSize();
                const columnSizingStart = header ? header.getLeafHeaders().map((d)=>[
                        d.column.id,
                        d.column.getSize()
                    ]) : [
                    [
                        column.id,
                        column.getSize()
                    ]
                ];
                const clientX = $a458d5bea2d12b69$var$isTouchStartEvent(e) ? Math.round(e.touches[0].clientX) : e.clientX;
                const newColumnSizing = {};
                const updateOffset = (eventType, clientXPos)=>{
                    if (typeof clientXPos !== 'number') return;
                    table.setColumnSizingInfo((old)=>{
                        var _old$startOffset, _old$startSize;
                        const deltaDirection = table.options.columnResizeDirection === 'rtl' ? -1 : 1;
                        const deltaOffset = (clientXPos - ((_old$startOffset = old == null ? void 0 : old.startOffset) != null ? _old$startOffset : 0)) * deltaDirection;
                        const deltaPercentage = Math.max(deltaOffset / ((_old$startSize = old == null ? void 0 : old.startSize) != null ? _old$startSize : 0), -0.999999);
                        old.columnSizingStart.forEach((_ref3)=>{
                            let [columnId, headerSize] = _ref3;
                            newColumnSizing[columnId] = Math.round(Math.max(headerSize + headerSize * deltaPercentage, 0) * 100) / 100;
                        });
                        return {
                            ...old,
                            deltaOffset: deltaOffset,
                            deltaPercentage: deltaPercentage
                        };
                    });
                    if (table.options.columnResizeMode === 'onChange' || eventType === 'end') table.setColumnSizing((old)=>({
                            ...old,
                            ...newColumnSizing
                        }));
                };
                const onMove = (clientXPos)=>updateOffset('move', clientXPos);
                const onEnd = (clientXPos)=>{
                    updateOffset('end', clientXPos);
                    table.setColumnSizingInfo((old)=>({
                            ...old,
                            isResizingColumn: false,
                            startOffset: null,
                            startSize: null,
                            deltaOffset: null,
                            deltaPercentage: null,
                            columnSizingStart: []
                        }));
                };
                const contextDocument = $a458d5bea2d12b69$var$safelyAccessDocument(_contextDocument);
                const mouseEvents = {
                    moveHandler: (e)=>onMove(e.clientX),
                    upHandler: (e)=>{
                        contextDocument == null || contextDocument.removeEventListener('mousemove', mouseEvents.moveHandler);
                        contextDocument == null || contextDocument.removeEventListener('mouseup', mouseEvents.upHandler);
                        onEnd(e.clientX);
                    }
                };
                const touchEvents = {
                    moveHandler: (e)=>{
                        if (e.cancelable) {
                            e.preventDefault();
                            e.stopPropagation();
                        }
                        onMove(e.touches[0].clientX);
                        return false;
                    },
                    upHandler: (e)=>{
                        var _e$touches$;
                        contextDocument == null || contextDocument.removeEventListener('touchmove', touchEvents.moveHandler);
                        contextDocument == null || contextDocument.removeEventListener('touchend', touchEvents.upHandler);
                        if (e.cancelable) {
                            e.preventDefault();
                            e.stopPropagation();
                        }
                        onEnd((_e$touches$ = e.touches[0]) == null ? void 0 : _e$touches$.clientX);
                    }
                };
                const passiveIfSupported = $a458d5bea2d12b69$export$4927b5943c7c0b4() ? {
                    passive: false
                } : false;
                if ($a458d5bea2d12b69$var$isTouchStartEvent(e)) {
                    contextDocument == null || contextDocument.addEventListener('touchmove', touchEvents.moveHandler, passiveIfSupported);
                    contextDocument == null || contextDocument.addEventListener('touchend', touchEvents.upHandler, passiveIfSupported);
                } else {
                    contextDocument == null || contextDocument.addEventListener('mousemove', mouseEvents.moveHandler, passiveIfSupported);
                    contextDocument == null || contextDocument.addEventListener('mouseup', mouseEvents.upHandler, passiveIfSupported);
                }
                table.setColumnSizingInfo((old)=>({
                        ...old,
                        startOffset: clientX,
                        startSize: startSize,
                        deltaOffset: 0,
                        deltaPercentage: 0,
                        columnSizingStart: columnSizingStart,
                        isResizingColumn: column.id
                    }));
            };
        };
    },
    createTable: (table)=>{
        table.setColumnSizing = (updater)=>table.options.onColumnSizingChange == null ? void 0 : table.options.onColumnSizingChange(updater);
        table.setColumnSizingInfo = (updater)=>table.options.onColumnSizingInfoChange == null ? void 0 : table.options.onColumnSizingInfoChange(updater);
        table.resetColumnSizing = (defaultState)=>{
            var _table$initialState$c;
            table.setColumnSizing(defaultState ? {} : (_table$initialState$c = table.initialState.columnSizing) != null ? _table$initialState$c : {});
        };
        table.resetHeaderSizeInfo = (defaultState)=>{
            var _table$initialState$c2;
            table.setColumnSizingInfo(defaultState ? $a458d5bea2d12b69$var$getDefaultColumnSizingInfoState() : (_table$initialState$c2 = table.initialState.columnSizingInfo) != null ? _table$initialState$c2 : $a458d5bea2d12b69$var$getDefaultColumnSizingInfoState());
        };
        table.getTotalSize = ()=>{
            var _table$getHeaderGroup, _table$getHeaderGroup2;
            return (_table$getHeaderGroup = (_table$getHeaderGroup2 = table.getHeaderGroups()[0]) == null ? void 0 : _table$getHeaderGroup2.headers.reduce((sum, header)=>{
                return sum + header.getSize();
            }, 0)) != null ? _table$getHeaderGroup : 0;
        };
        table.getLeftTotalSize = ()=>{
            var _table$getLeftHeaderG, _table$getLeftHeaderG2;
            return (_table$getLeftHeaderG = (_table$getLeftHeaderG2 = table.getLeftHeaderGroups()[0]) == null ? void 0 : _table$getLeftHeaderG2.headers.reduce((sum, header)=>{
                return sum + header.getSize();
            }, 0)) != null ? _table$getLeftHeaderG : 0;
        };
        table.getCenterTotalSize = ()=>{
            var _table$getCenterHeade, _table$getCenterHeade2;
            return (_table$getCenterHeade = (_table$getCenterHeade2 = table.getCenterHeaderGroups()[0]) == null ? void 0 : _table$getCenterHeade2.headers.reduce((sum, header)=>{
                return sum + header.getSize();
            }, 0)) != null ? _table$getCenterHeade : 0;
        };
        table.getRightTotalSize = ()=>{
            var _table$getRightHeader, _table$getRightHeader2;
            return (_table$getRightHeader = (_table$getRightHeader2 = table.getRightHeaderGroups()[0]) == null ? void 0 : _table$getRightHeader2.headers.reduce((sum, header)=>{
                return sum + header.getSize();
            }, 0)) != null ? _table$getRightHeader : 0;
        };
    }
};
let $a458d5bea2d12b69$var$passiveSupported = null;
function $a458d5bea2d12b69$export$4927b5943c7c0b4() {
    if (typeof $a458d5bea2d12b69$var$passiveSupported === 'boolean') return $a458d5bea2d12b69$var$passiveSupported;
    let supported = false;
    try {
        const options = {
            get passive () {
                supported = true;
                return false;
            }
        };
        const noop = ()=>{};
        window.addEventListener('test', noop, options);
        window.removeEventListener('test', noop);
    } catch (err) {
        supported = false;
    }
    $a458d5bea2d12b69$var$passiveSupported = supported;
    return $a458d5bea2d12b69$var$passiveSupported;
}
function $a458d5bea2d12b69$var$isTouchStartEvent(e) {
    return e.type === 'touchstart';
}
//
const $a458d5bea2d12b69$export$be5545a32e20d889 = {
    getInitialState: (state)=>{
        return {
            columnVisibility: {},
            ...state
        };
    },
    getDefaultOptions: (table)=>{
        return {
            onColumnVisibilityChange: $a458d5bea2d12b69$export$2b5605d8069324bd('columnVisibility', table)
        };
    },
    createColumn: (column, table)=>{
        column.toggleVisibility = (value)=>{
            if (column.getCanHide()) table.setColumnVisibility((old)=>({
                    ...old,
                    [column.id]: value != null ? value : !column.getIsVisible()
                }));
        };
        column.getIsVisible = ()=>{
            var _ref, _table$getState$colum;
            const childColumns = column.columns;
            return (_ref = childColumns.length ? childColumns.some((c)=>c.getIsVisible()) : (_table$getState$colum = table.getState().columnVisibility) == null ? void 0 : _table$getState$colum[column.id]) != null ? _ref : true;
        };
        column.getCanHide = ()=>{
            var _column$columnDef$ena, _table$options$enable;
            return ((_column$columnDef$ena = column.columnDef.enableHiding) != null ? _column$columnDef$ena : true) && ((_table$options$enable = table.options.enableHiding) != null ? _table$options$enable : true);
        };
        column.getToggleVisibilityHandler = ()=>{
            return (e)=>{
                column.toggleVisibility == null || column.toggleVisibility(e.target.checked);
            };
        };
    },
    createRow: (row, table)=>{
        row._getAllVisibleCells = $a458d5bea2d12b69$export$7c73462e0d25e514(()=>[
                row.getAllCells(),
                table.getState().columnVisibility
            ], (cells)=>{
            return cells.filter((cell)=>cell.column.getIsVisible());
        }, $a458d5bea2d12b69$export$b1f82222dc43996c(table.options, 'debugRows', '_getAllVisibleCells'));
        row.getVisibleCells = $a458d5bea2d12b69$export$7c73462e0d25e514(()=>[
                row.getLeftVisibleCells(),
                row.getCenterVisibleCells(),
                row.getRightVisibleCells()
            ], (left, center, right)=>[
                ...left,
                ...center,
                ...right
            ], $a458d5bea2d12b69$export$b1f82222dc43996c(table.options, 'debugRows', 'getVisibleCells'));
    },
    createTable: (table)=>{
        const makeVisibleColumnsMethod = (key, getColumns)=>{
            return $a458d5bea2d12b69$export$7c73462e0d25e514(()=>[
                    getColumns(),
                    getColumns().filter((d)=>d.getIsVisible()).map((d)=>d.id).join('_')
                ], (columns)=>{
                return columns.filter((d)=>d.getIsVisible == null ? void 0 : d.getIsVisible());
            }, $a458d5bea2d12b69$export$b1f82222dc43996c(table.options, 'debugColumns', key));
        };
        table.getVisibleFlatColumns = makeVisibleColumnsMethod('getVisibleFlatColumns', ()=>table.getAllFlatColumns());
        table.getVisibleLeafColumns = makeVisibleColumnsMethod('getVisibleLeafColumns', ()=>table.getAllLeafColumns());
        table.getLeftVisibleLeafColumns = makeVisibleColumnsMethod('getLeftVisibleLeafColumns', ()=>table.getLeftLeafColumns());
        table.getRightVisibleLeafColumns = makeVisibleColumnsMethod('getRightVisibleLeafColumns', ()=>table.getRightLeafColumns());
        table.getCenterVisibleLeafColumns = makeVisibleColumnsMethod('getCenterVisibleLeafColumns', ()=>table.getCenterLeafColumns());
        table.setColumnVisibility = (updater)=>table.options.onColumnVisibilityChange == null ? void 0 : table.options.onColumnVisibilityChange(updater);
        table.resetColumnVisibility = (defaultState)=>{
            var _table$initialState$c;
            table.setColumnVisibility(defaultState ? {} : (_table$initialState$c = table.initialState.columnVisibility) != null ? _table$initialState$c : {});
        };
        table.toggleAllColumnsVisible = (value)=>{
            var _value;
            value = (_value = value) != null ? _value : !table.getIsAllColumnsVisible();
            table.setColumnVisibility(table.getAllLeafColumns().reduce((obj, column)=>({
                    ...obj,
                    [column.id]: !value ? !(column.getCanHide != null && column.getCanHide()) : value
                }), {}));
        };
        table.getIsAllColumnsVisible = ()=>!table.getAllLeafColumns().some((column)=>!(column.getIsVisible != null && column.getIsVisible()));
        table.getIsSomeColumnsVisible = ()=>table.getAllLeafColumns().some((column)=>column.getIsVisible == null ? void 0 : column.getIsVisible());
        table.getToggleAllColumnsVisibilityHandler = ()=>{
            return (e)=>{
                var _target;
                table.toggleAllColumnsVisible((_target = e.target) == null ? void 0 : _target.checked);
            };
        };
    }
};
function $a458d5bea2d12b69$export$1d7c103713892a11(table, position) {
    return !position ? table.getVisibleLeafColumns() : position === 'center' ? table.getCenterVisibleLeafColumns() : position === 'left' ? table.getLeftVisibleLeafColumns() : table.getRightVisibleLeafColumns();
}
//
const $a458d5bea2d12b69$export$4b37edcdc7ad2fe1 = {
    createTable: (table)=>{
        table._getGlobalFacetedRowModel = table.options.getFacetedRowModel && table.options.getFacetedRowModel(table, '__global__');
        table.getGlobalFacetedRowModel = ()=>{
            if (table.options.manualFiltering || !table._getGlobalFacetedRowModel) return table.getPreFilteredRowModel();
            return table._getGlobalFacetedRowModel();
        };
        table._getGlobalFacetedUniqueValues = table.options.getFacetedUniqueValues && table.options.getFacetedUniqueValues(table, '__global__');
        table.getGlobalFacetedUniqueValues = ()=>{
            if (!table._getGlobalFacetedUniqueValues) return new Map();
            return table._getGlobalFacetedUniqueValues();
        };
        table._getGlobalFacetedMinMaxValues = table.options.getFacetedMinMaxValues && table.options.getFacetedMinMaxValues(table, '__global__');
        table.getGlobalFacetedMinMaxValues = ()=>{
            if (!table._getGlobalFacetedMinMaxValues) return;
            return table._getGlobalFacetedMinMaxValues();
        };
    }
};
//
const $a458d5bea2d12b69$export$61e9e0661ff79b1c = {
    getInitialState: (state)=>{
        return {
            globalFilter: undefined,
            ...state
        };
    },
    getDefaultOptions: (table)=>{
        return {
            onGlobalFilterChange: $a458d5bea2d12b69$export$2b5605d8069324bd('globalFilter', table),
            globalFilterFn: 'auto',
            getColumnCanGlobalFilter: (column)=>{
                var _table$getCoreRowMode;
                const value = (_table$getCoreRowMode = table.getCoreRowModel().flatRows[0]) == null || (_table$getCoreRowMode = _table$getCoreRowMode._getAllCellsByColumnId()[column.id]) == null ? void 0 : _table$getCoreRowMode.getValue();
                return typeof value === 'string' || typeof value === 'number';
            }
        };
    },
    createColumn: (column, table)=>{
        column.getCanGlobalFilter = ()=>{
            var _column$columnDef$ena, _table$options$enable, _table$options$enable2, _table$options$getCol;
            return ((_column$columnDef$ena = column.columnDef.enableGlobalFilter) != null ? _column$columnDef$ena : true) && ((_table$options$enable = table.options.enableGlobalFilter) != null ? _table$options$enable : true) && ((_table$options$enable2 = table.options.enableFilters) != null ? _table$options$enable2 : true) && ((_table$options$getCol = table.options.getColumnCanGlobalFilter == null ? void 0 : table.options.getColumnCanGlobalFilter(column)) != null ? _table$options$getCol : true) && !!column.accessorFn;
        };
    },
    createTable: (table)=>{
        table.getGlobalAutoFilterFn = ()=>{
            return $a458d5bea2d12b69$export$6ad8312e296ec316.includesString;
        };
        table.getGlobalFilterFn = ()=>{
            var _table$options$filter, _table$options$filter2;
            const { globalFilterFn: globalFilterFn } = table.options;
            return $a458d5bea2d12b69$export$f6e2535fb5126e54(globalFilterFn) ? globalFilterFn : globalFilterFn === 'auto' ? table.getGlobalAutoFilterFn() : (_table$options$filter = (_table$options$filter2 = table.options.filterFns) == null ? void 0 : _table$options$filter2[globalFilterFn]) != null ? _table$options$filter : $a458d5bea2d12b69$export$6ad8312e296ec316[globalFilterFn];
        };
        table.setGlobalFilter = (updater)=>{
            table.options.onGlobalFilterChange == null || table.options.onGlobalFilterChange(updater);
        };
        table.resetGlobalFilter = (defaultState)=>{
            table.setGlobalFilter(defaultState ? undefined : table.initialState.globalFilter);
        };
    }
};
//
const $a458d5bea2d12b69$export$fed54e0d64c17fb2 = {
    getInitialState: (state)=>{
        return {
            expanded: {},
            ...state
        };
    },
    getDefaultOptions: (table)=>{
        return {
            onExpandedChange: $a458d5bea2d12b69$export$2b5605d8069324bd('expanded', table),
            paginateExpandedRows: true
        };
    },
    createTable: (table)=>{
        let registered = false;
        let queued = false;
        table._autoResetExpanded = ()=>{
            var _ref, _table$options$autoRe;
            if (!registered) {
                table._queue(()=>{
                    registered = true;
                });
                return;
            }
            if ((_ref = (_table$options$autoRe = table.options.autoResetAll) != null ? _table$options$autoRe : table.options.autoResetExpanded) != null ? _ref : !table.options.manualExpanding) {
                if (queued) return;
                queued = true;
                table._queue(()=>{
                    table.resetExpanded();
                    queued = false;
                });
            }
        };
        table.setExpanded = (updater)=>table.options.onExpandedChange == null ? void 0 : table.options.onExpandedChange(updater);
        table.toggleAllRowsExpanded = (expanded)=>{
            if (expanded != null ? expanded : !table.getIsAllRowsExpanded()) table.setExpanded(true);
            else table.setExpanded({});
        };
        table.resetExpanded = (defaultState)=>{
            var _table$initialState$e, _table$initialState;
            table.setExpanded(defaultState ? {} : (_table$initialState$e = (_table$initialState = table.initialState) == null ? void 0 : _table$initialState.expanded) != null ? _table$initialState$e : {});
        };
        table.getCanSomeRowsExpand = ()=>{
            return table.getPrePaginationRowModel().flatRows.some((row)=>row.getCanExpand());
        };
        table.getToggleAllRowsExpandedHandler = ()=>{
            return (e)=>{
                e.persist == null || e.persist();
                table.toggleAllRowsExpanded();
            };
        };
        table.getIsSomeRowsExpanded = ()=>{
            const expanded = table.getState().expanded;
            return expanded === true || Object.values(expanded).some(Boolean);
        };
        table.getIsAllRowsExpanded = ()=>{
            const expanded = table.getState().expanded;
            // If expanded is true, save some cycles and return true
            if (typeof expanded === 'boolean') return expanded === true;
            if (!Object.keys(expanded).length) return false;
            // If any row is not expanded, return false
            if (table.getRowModel().flatRows.some((row)=>!row.getIsExpanded())) return false;
            // They must all be expanded :shrug:
            return true;
        };
        table.getExpandedDepth = ()=>{
            let maxDepth = 0;
            const rowIds = table.getState().expanded === true ? Object.keys(table.getRowModel().rowsById) : Object.keys(table.getState().expanded);
            rowIds.forEach((id)=>{
                const splitId = id.split('.');
                maxDepth = Math.max(maxDepth, splitId.length);
            });
            return maxDepth;
        };
        table.getPreExpandedRowModel = ()=>table.getSortedRowModel();
        table.getExpandedRowModel = ()=>{
            if (!table._getExpandedRowModel && table.options.getExpandedRowModel) table._getExpandedRowModel = table.options.getExpandedRowModel(table);
            if (table.options.manualExpanding || !table._getExpandedRowModel) return table.getPreExpandedRowModel();
            return table._getExpandedRowModel();
        };
    },
    createRow: (row, table)=>{
        row.toggleExpanded = (expanded)=>{
            table.setExpanded((old)=>{
                var _expanded;
                const exists = old === true ? true : !!(old != null && old[row.id]);
                let oldExpanded = {};
                if (old === true) Object.keys(table.getRowModel().rowsById).forEach((rowId)=>{
                    oldExpanded[rowId] = true;
                });
                else oldExpanded = old;
                expanded = (_expanded = expanded) != null ? _expanded : !exists;
                if (!exists && expanded) return {
                    ...oldExpanded,
                    [row.id]: true
                };
                if (exists && !expanded) {
                    const { [row.id]: _, ...rest } = oldExpanded;
                    return rest;
                }
                return old;
            });
        };
        row.getIsExpanded = ()=>{
            var _table$options$getIsR;
            const expanded = table.getState().expanded;
            return !!((_table$options$getIsR = table.options.getIsRowExpanded == null ? void 0 : table.options.getIsRowExpanded(row)) != null ? _table$options$getIsR : expanded === true || (expanded == null ? void 0 : expanded[row.id]));
        };
        row.getCanExpand = ()=>{
            var _table$options$getRow, _table$options$enable, _row$subRows;
            return (_table$options$getRow = table.options.getRowCanExpand == null ? void 0 : table.options.getRowCanExpand(row)) != null ? _table$options$getRow : ((_table$options$enable = table.options.enableExpanding) != null ? _table$options$enable : true) && !!((_row$subRows = row.subRows) != null && _row$subRows.length);
        };
        row.getIsAllParentsExpanded = ()=>{
            let isFullyExpanded = true;
            let currentRow = row;
            while(isFullyExpanded && currentRow.parentId){
                currentRow = table.getRow(currentRow.parentId, true);
                isFullyExpanded = currentRow.getIsExpanded();
            }
            return isFullyExpanded;
        };
        row.getToggleExpandedHandler = ()=>{
            const canExpand = row.getCanExpand();
            return ()=>{
                if (!canExpand) return;
                row.toggleExpanded();
            };
        };
    }
};
//
const $a458d5bea2d12b69$var$defaultPageIndex = 0;
const $a458d5bea2d12b69$var$defaultPageSize = 10;
const $a458d5bea2d12b69$var$getDefaultPaginationState = ()=>({
        pageIndex: $a458d5bea2d12b69$var$defaultPageIndex,
        pageSize: $a458d5bea2d12b69$var$defaultPageSize
    });
const $a458d5bea2d12b69$export$bce540641752d22b = {
    getInitialState: (state)=>{
        return {
            ...state,
            pagination: {
                ...$a458d5bea2d12b69$var$getDefaultPaginationState(),
                ...state == null ? void 0 : state.pagination
            }
        };
    },
    getDefaultOptions: (table)=>{
        return {
            onPaginationChange: $a458d5bea2d12b69$export$2b5605d8069324bd('pagination', table)
        };
    },
    createTable: (table)=>{
        let registered = false;
        let queued = false;
        table._autoResetPageIndex = ()=>{
            var _ref, _table$options$autoRe;
            if (!registered) {
                table._queue(()=>{
                    registered = true;
                });
                return;
            }
            if ((_ref = (_table$options$autoRe = table.options.autoResetAll) != null ? _table$options$autoRe : table.options.autoResetPageIndex) != null ? _ref : !table.options.manualPagination) {
                if (queued) return;
                queued = true;
                table._queue(()=>{
                    table.resetPageIndex();
                    queued = false;
                });
            }
        };
        table.setPagination = (updater)=>{
            const safeUpdater = (old)=>{
                let newState = $a458d5bea2d12b69$export$7f095f455ad5af3f(updater, old);
                return newState;
            };
            return table.options.onPaginationChange == null ? void 0 : table.options.onPaginationChange(safeUpdater);
        };
        table.resetPagination = (defaultState)=>{
            var _table$initialState$p;
            table.setPagination(defaultState ? $a458d5bea2d12b69$var$getDefaultPaginationState() : (_table$initialState$p = table.initialState.pagination) != null ? _table$initialState$p : $a458d5bea2d12b69$var$getDefaultPaginationState());
        };
        table.setPageIndex = (updater)=>{
            table.setPagination((old)=>{
                let pageIndex = $a458d5bea2d12b69$export$7f095f455ad5af3f(updater, old.pageIndex);
                const maxPageIndex = typeof table.options.pageCount === 'undefined' || table.options.pageCount === -1 ? Number.MAX_SAFE_INTEGER : table.options.pageCount - 1;
                pageIndex = Math.max(0, Math.min(pageIndex, maxPageIndex));
                return {
                    ...old,
                    pageIndex: pageIndex
                };
            });
        };
        table.resetPageIndex = (defaultState)=>{
            var _table$initialState$p2, _table$initialState;
            table.setPageIndex(defaultState ? $a458d5bea2d12b69$var$defaultPageIndex : (_table$initialState$p2 = (_table$initialState = table.initialState) == null || (_table$initialState = _table$initialState.pagination) == null ? void 0 : _table$initialState.pageIndex) != null ? _table$initialState$p2 : $a458d5bea2d12b69$var$defaultPageIndex);
        };
        table.resetPageSize = (defaultState)=>{
            var _table$initialState$p3, _table$initialState2;
            table.setPageSize(defaultState ? $a458d5bea2d12b69$var$defaultPageSize : (_table$initialState$p3 = (_table$initialState2 = table.initialState) == null || (_table$initialState2 = _table$initialState2.pagination) == null ? void 0 : _table$initialState2.pageSize) != null ? _table$initialState$p3 : $a458d5bea2d12b69$var$defaultPageSize);
        };
        table.setPageSize = (updater)=>{
            table.setPagination((old)=>{
                const pageSize = Math.max(1, $a458d5bea2d12b69$export$7f095f455ad5af3f(updater, old.pageSize));
                const topRowIndex = old.pageSize * old.pageIndex;
                const pageIndex = Math.floor(topRowIndex / pageSize);
                return {
                    ...old,
                    pageIndex: pageIndex,
                    pageSize: pageSize
                };
            });
        };
        //deprecated
        table.setPageCount = (updater)=>table.setPagination((old)=>{
                var _table$options$pageCo;
                let newPageCount = $a458d5bea2d12b69$export$7f095f455ad5af3f(updater, (_table$options$pageCo = table.options.pageCount) != null ? _table$options$pageCo : -1);
                if (typeof newPageCount === 'number') newPageCount = Math.max(-1, newPageCount);
                return {
                    ...old,
                    pageCount: newPageCount
                };
            });
        table.getPageOptions = $a458d5bea2d12b69$export$7c73462e0d25e514(()=>[
                table.getPageCount()
            ], (pageCount)=>{
            let pageOptions = [];
            if (pageCount && pageCount > 0) pageOptions = [
                ...new Array(pageCount)
            ].fill(null).map((_, i)=>i);
            return pageOptions;
        }, $a458d5bea2d12b69$export$b1f82222dc43996c(table.options, 'debugTable', 'getPageOptions'));
        table.getCanPreviousPage = ()=>table.getState().pagination.pageIndex > 0;
        table.getCanNextPage = ()=>{
            const { pageIndex: pageIndex } = table.getState().pagination;
            const pageCount = table.getPageCount();
            if (pageCount === -1) return true;
            if (pageCount === 0) return false;
            return pageIndex < pageCount - 1;
        };
        table.previousPage = ()=>{
            return table.setPageIndex((old)=>old - 1);
        };
        table.nextPage = ()=>{
            return table.setPageIndex((old)=>{
                return old + 1;
            });
        };
        table.firstPage = ()=>{
            return table.setPageIndex(0);
        };
        table.lastPage = ()=>{
            return table.setPageIndex(table.getPageCount() - 1);
        };
        table.getPrePaginationRowModel = ()=>table.getExpandedRowModel();
        table.getPaginationRowModel = ()=>{
            if (!table._getPaginationRowModel && table.options.getPaginationRowModel) table._getPaginationRowModel = table.options.getPaginationRowModel(table);
            if (table.options.manualPagination || !table._getPaginationRowModel) return table.getPrePaginationRowModel();
            return table._getPaginationRowModel();
        };
        table.getPageCount = ()=>{
            var _table$options$pageCo2;
            return (_table$options$pageCo2 = table.options.pageCount) != null ? _table$options$pageCo2 : Math.ceil(table.getRowCount() / table.getState().pagination.pageSize);
        };
        table.getRowCount = ()=>{
            var _table$options$rowCou;
            return (_table$options$rowCou = table.options.rowCount) != null ? _table$options$rowCou : table.getPrePaginationRowModel().rows.length;
        };
    }
};
//
const $a458d5bea2d12b69$var$getDefaultRowPinningState = ()=>({
        top: [],
        bottom: []
    });
const $a458d5bea2d12b69$export$213d72cb2ac7d440 = {
    getInitialState: (state)=>{
        return {
            rowPinning: $a458d5bea2d12b69$var$getDefaultRowPinningState(),
            ...state
        };
    },
    getDefaultOptions: (table)=>{
        return {
            onRowPinningChange: $a458d5bea2d12b69$export$2b5605d8069324bd('rowPinning', table)
        };
    },
    createRow: (row, table)=>{
        row.pin = (position, includeLeafRows, includeParentRows)=>{
            const leafRowIds = includeLeafRows ? row.getLeafRows().map((_ref)=>{
                let { id: id } = _ref;
                return id;
            }) : [];
            const parentRowIds = includeParentRows ? row.getParentRows().map((_ref2)=>{
                let { id: id } = _ref2;
                return id;
            }) : [];
            const rowIds = new Set([
                ...parentRowIds,
                row.id,
                ...leafRowIds
            ]);
            table.setRowPinning((old)=>{
                var _old$top3, _old$bottom3;
                if (position === 'bottom') {
                    var _old$top, _old$bottom;
                    return {
                        top: ((_old$top = old == null ? void 0 : old.top) != null ? _old$top : []).filter((d)=>!(rowIds != null && rowIds.has(d))),
                        bottom: [
                            ...((_old$bottom = old == null ? void 0 : old.bottom) != null ? _old$bottom : []).filter((d)=>!(rowIds != null && rowIds.has(d))),
                            ...Array.from(rowIds)
                        ]
                    };
                }
                if (position === 'top') {
                    var _old$top2, _old$bottom2;
                    return {
                        top: [
                            ...((_old$top2 = old == null ? void 0 : old.top) != null ? _old$top2 : []).filter((d)=>!(rowIds != null && rowIds.has(d))),
                            ...Array.from(rowIds)
                        ],
                        bottom: ((_old$bottom2 = old == null ? void 0 : old.bottom) != null ? _old$bottom2 : []).filter((d)=>!(rowIds != null && rowIds.has(d)))
                    };
                }
                return {
                    top: ((_old$top3 = old == null ? void 0 : old.top) != null ? _old$top3 : []).filter((d)=>!(rowIds != null && rowIds.has(d))),
                    bottom: ((_old$bottom3 = old == null ? void 0 : old.bottom) != null ? _old$bottom3 : []).filter((d)=>!(rowIds != null && rowIds.has(d)))
                };
            });
        };
        row.getCanPin = ()=>{
            var _ref3;
            const { enableRowPinning: enableRowPinning, enablePinning: enablePinning } = table.options;
            if (typeof enableRowPinning === 'function') return enableRowPinning(row);
            return (_ref3 = enableRowPinning != null ? enableRowPinning : enablePinning) != null ? _ref3 : true;
        };
        row.getIsPinned = ()=>{
            const rowIds = [
                row.id
            ];
            const { top: top, bottom: bottom } = table.getState().rowPinning;
            const isTop = rowIds.some((d)=>top == null ? void 0 : top.includes(d));
            const isBottom = rowIds.some((d)=>bottom == null ? void 0 : bottom.includes(d));
            return isTop ? 'top' : isBottom ? 'bottom' : false;
        };
        row.getPinnedIndex = ()=>{
            var _ref4, _visiblePinnedRowIds$;
            const position = row.getIsPinned();
            if (!position) return -1;
            const visiblePinnedRowIds = (_ref4 = position === 'top' ? table.getTopRows() : table.getBottomRows()) == null ? void 0 : _ref4.map((_ref5)=>{
                let { id: id } = _ref5;
                return id;
            });
            return (_visiblePinnedRowIds$ = visiblePinnedRowIds == null ? void 0 : visiblePinnedRowIds.indexOf(row.id)) != null ? _visiblePinnedRowIds$ : -1;
        };
    },
    createTable: (table)=>{
        table.setRowPinning = (updater)=>table.options.onRowPinningChange == null ? void 0 : table.options.onRowPinningChange(updater);
        table.resetRowPinning = (defaultState)=>{
            var _table$initialState$r, _table$initialState;
            return table.setRowPinning(defaultState ? $a458d5bea2d12b69$var$getDefaultRowPinningState() : (_table$initialState$r = (_table$initialState = table.initialState) == null ? void 0 : _table$initialState.rowPinning) != null ? _table$initialState$r : $a458d5bea2d12b69$var$getDefaultRowPinningState());
        };
        table.getIsSomeRowsPinned = (position)=>{
            var _pinningState$positio;
            const pinningState = table.getState().rowPinning;
            if (!position) {
                var _pinningState$top, _pinningState$bottom;
                return Boolean(((_pinningState$top = pinningState.top) == null ? void 0 : _pinningState$top.length) || ((_pinningState$bottom = pinningState.bottom) == null ? void 0 : _pinningState$bottom.length));
            }
            return Boolean((_pinningState$positio = pinningState[position]) == null ? void 0 : _pinningState$positio.length);
        };
        table._getPinnedRows = (visibleRows, pinnedRowIds, position)=>{
            var _table$options$keepPi;
            const rows = ((_table$options$keepPi = table.options.keepPinnedRows) != null ? _table$options$keepPi : true) ? //get all rows that are pinned even if they would not be otherwise visible
            //account for expanded parent rows, but not pagination or filtering
            (pinnedRowIds != null ? pinnedRowIds : []).map((rowId)=>{
                const row = table.getRow(rowId, true);
                return row.getIsAllParentsExpanded() ? row : null;
            }) : //else get only visible rows that are pinned
            (pinnedRowIds != null ? pinnedRowIds : []).map((rowId)=>visibleRows.find((row)=>row.id === rowId));
            return rows.filter(Boolean).map((d)=>({
                    ...d,
                    position: position
                }));
        };
        table.getTopRows = $a458d5bea2d12b69$export$7c73462e0d25e514(()=>[
                table.getRowModel().rows,
                table.getState().rowPinning.top
            ], (allRows, topPinnedRowIds)=>table._getPinnedRows(allRows, topPinnedRowIds, 'top'), $a458d5bea2d12b69$export$b1f82222dc43996c(table.options, 'debugRows', 'getTopRows'));
        table.getBottomRows = $a458d5bea2d12b69$export$7c73462e0d25e514(()=>[
                table.getRowModel().rows,
                table.getState().rowPinning.bottom
            ], (allRows, bottomPinnedRowIds)=>table._getPinnedRows(allRows, bottomPinnedRowIds, 'bottom'), $a458d5bea2d12b69$export$b1f82222dc43996c(table.options, 'debugRows', 'getBottomRows'));
        table.getCenterRows = $a458d5bea2d12b69$export$7c73462e0d25e514(()=>[
                table.getRowModel().rows,
                table.getState().rowPinning.top,
                table.getState().rowPinning.bottom
            ], (allRows, top, bottom)=>{
            const topAndBottom = new Set([
                ...top != null ? top : [],
                ...bottom != null ? bottom : []
            ]);
            return allRows.filter((d)=>!topAndBottom.has(d.id));
        }, $a458d5bea2d12b69$export$b1f82222dc43996c(table.options, 'debugRows', 'getCenterRows'));
    }
};
//
const $a458d5bea2d12b69$export$e8905133e7bf3121 = {
    getInitialState: (state)=>{
        return {
            rowSelection: {},
            ...state
        };
    },
    getDefaultOptions: (table)=>{
        return {
            onRowSelectionChange: $a458d5bea2d12b69$export$2b5605d8069324bd('rowSelection', table),
            enableRowSelection: true,
            enableMultiRowSelection: true,
            enableSubRowSelection: true
        };
    },
    createTable: (table)=>{
        table.setRowSelection = (updater)=>table.options.onRowSelectionChange == null ? void 0 : table.options.onRowSelectionChange(updater);
        table.resetRowSelection = (defaultState)=>{
            var _table$initialState$r;
            return table.setRowSelection(defaultState ? {} : (_table$initialState$r = table.initialState.rowSelection) != null ? _table$initialState$r : {});
        };
        table.toggleAllRowsSelected = (value)=>{
            table.setRowSelection((old)=>{
                value = typeof value !== 'undefined' ? value : !table.getIsAllRowsSelected();
                const rowSelection = {
                    ...old
                };
                const preGroupedFlatRows = table.getPreGroupedRowModel().flatRows;
                // We don't use `mutateRowIsSelected` here for performance reasons.
                // All of the rows are flat already, so it wouldn't be worth it
                if (value) preGroupedFlatRows.forEach((row)=>{
                    if (!row.getCanSelect()) return;
                    rowSelection[row.id] = true;
                });
                else preGroupedFlatRows.forEach((row)=>{
                    delete rowSelection[row.id];
                });
                return rowSelection;
            });
        };
        table.toggleAllPageRowsSelected = (value)=>table.setRowSelection((old)=>{
                const resolvedValue = typeof value !== 'undefined' ? value : !table.getIsAllPageRowsSelected();
                const rowSelection = {
                    ...old
                };
                table.getRowModel().rows.forEach((row)=>{
                    $a458d5bea2d12b69$var$mutateRowIsSelected(rowSelection, row.id, resolvedValue, true, table);
                });
                return rowSelection;
            });
        // addRowSelectionRange: rowId => {
        //   const {
        //     rows,
        //     rowsById,
        //     options: { selectGroupingRows, selectSubRows },
        //   } = table
        //   const findSelectedRow = (rows: Row[]) => {
        //     let found
        //     rows.find(d => {
        //       if (d.getIsSelected()) {
        //         found = d
        //         return true
        //       }
        //       const subFound = findSelectedRow(d.subRows || [])
        //       if (subFound) {
        //         found = subFound
        //         return true
        //       }
        //       return false
        //     })
        //     return found
        //   }
        //   const firstRow = findSelectedRow(rows) || rows[0]
        //   const lastRow = rowsById[rowId]
        //   let include = false
        //   const selectedRowIds = {}
        //   const addRow = (row: Row) => {
        //     mutateRowIsSelected(selectedRowIds, row.id, true, {
        //       rowsById,
        //       selectGroupingRows: selectGroupingRows!,
        //       selectSubRows: selectSubRows!,
        //     })
        //   }
        //   table.rows.forEach(row => {
        //     const isFirstRow = row.id === firstRow.id
        //     const isLastRow = row.id === lastRow.id
        //     if (isFirstRow || isLastRow) {
        //       if (!include) {
        //         include = true
        //       } else if (include) {
        //         addRow(row)
        //         include = false
        //       }
        //     }
        //     if (include) {
        //       addRow(row)
        //     }
        //   })
        //   table.setRowSelection(selectedRowIds)
        // },
        table.getPreSelectedRowModel = ()=>table.getCoreRowModel();
        table.getSelectedRowModel = $a458d5bea2d12b69$export$7c73462e0d25e514(()=>[
                table.getState().rowSelection,
                table.getCoreRowModel()
            ], (rowSelection, rowModel)=>{
            if (!Object.keys(rowSelection).length) return {
                rows: [],
                flatRows: [],
                rowsById: {}
            };
            return $a458d5bea2d12b69$export$f150e72530556b0b(table, rowModel);
        }, $a458d5bea2d12b69$export$b1f82222dc43996c(table.options, 'debugTable', 'getSelectedRowModel'));
        table.getFilteredSelectedRowModel = $a458d5bea2d12b69$export$7c73462e0d25e514(()=>[
                table.getState().rowSelection,
                table.getFilteredRowModel()
            ], (rowSelection, rowModel)=>{
            if (!Object.keys(rowSelection).length) return {
                rows: [],
                flatRows: [],
                rowsById: {}
            };
            return $a458d5bea2d12b69$export$f150e72530556b0b(table, rowModel);
        }, $a458d5bea2d12b69$export$b1f82222dc43996c(table.options, 'debugTable', 'getFilteredSelectedRowModel'));
        table.getGroupedSelectedRowModel = $a458d5bea2d12b69$export$7c73462e0d25e514(()=>[
                table.getState().rowSelection,
                table.getSortedRowModel()
            ], (rowSelection, rowModel)=>{
            if (!Object.keys(rowSelection).length) return {
                rows: [],
                flatRows: [],
                rowsById: {}
            };
            return $a458d5bea2d12b69$export$f150e72530556b0b(table, rowModel);
        }, $a458d5bea2d12b69$export$b1f82222dc43996c(table.options, 'debugTable', 'getGroupedSelectedRowModel'));
        ///
        // getGroupingRowCanSelect: rowId => {
        //   const row = table.getRow(rowId)
        //   if (!row) {
        //     throw new Error()
        //   }
        //   if (typeof table.options.enableGroupingRowSelection === 'function') {
        //     return table.options.enableGroupingRowSelection(row)
        //   }
        //   return table.options.enableGroupingRowSelection ?? false
        // },
        table.getIsAllRowsSelected = ()=>{
            const preGroupedFlatRows = table.getFilteredRowModel().flatRows;
            const { rowSelection: rowSelection } = table.getState();
            let isAllRowsSelected = Boolean(preGroupedFlatRows.length && Object.keys(rowSelection).length);
            if (isAllRowsSelected) {
                if (preGroupedFlatRows.some((row)=>row.getCanSelect() && !rowSelection[row.id])) isAllRowsSelected = false;
            }
            return isAllRowsSelected;
        };
        table.getIsAllPageRowsSelected = ()=>{
            const paginationFlatRows = table.getPaginationRowModel().flatRows.filter((row)=>row.getCanSelect());
            const { rowSelection: rowSelection } = table.getState();
            let isAllPageRowsSelected = !!paginationFlatRows.length;
            if (isAllPageRowsSelected && paginationFlatRows.some((row)=>!rowSelection[row.id])) isAllPageRowsSelected = false;
            return isAllPageRowsSelected;
        };
        table.getIsSomeRowsSelected = ()=>{
            var _table$getState$rowSe;
            const totalSelected = Object.keys((_table$getState$rowSe = table.getState().rowSelection) != null ? _table$getState$rowSe : {}).length;
            return totalSelected > 0 && totalSelected < table.getFilteredRowModel().flatRows.length;
        };
        table.getIsSomePageRowsSelected = ()=>{
            const paginationFlatRows = table.getPaginationRowModel().flatRows;
            return table.getIsAllPageRowsSelected() ? false : paginationFlatRows.filter((row)=>row.getCanSelect()).some((d)=>d.getIsSelected() || d.getIsSomeSelected());
        };
        table.getToggleAllRowsSelectedHandler = ()=>{
            return (e)=>{
                table.toggleAllRowsSelected(e.target.checked);
            };
        };
        table.getToggleAllPageRowsSelectedHandler = ()=>{
            return (e)=>{
                table.toggleAllPageRowsSelected(e.target.checked);
            };
        };
    },
    createRow: (row, table)=>{
        row.toggleSelected = (value, opts)=>{
            const isSelected = row.getIsSelected();
            table.setRowSelection((old)=>{
                var _opts$selectChildren;
                value = typeof value !== 'undefined' ? value : !isSelected;
                if (row.getCanSelect() && isSelected === value) return old;
                const selectedRowIds = {
                    ...old
                };
                $a458d5bea2d12b69$var$mutateRowIsSelected(selectedRowIds, row.id, value, (_opts$selectChildren = opts == null ? void 0 : opts.selectChildren) != null ? _opts$selectChildren : true, table);
                return selectedRowIds;
            });
        };
        row.getIsSelected = ()=>{
            const { rowSelection: rowSelection } = table.getState();
            return $a458d5bea2d12b69$export$710e11cf672b86c(row, rowSelection);
        };
        row.getIsSomeSelected = ()=>{
            const { rowSelection: rowSelection } = table.getState();
            return $a458d5bea2d12b69$export$8f4c46e5d7907334(row, rowSelection) === 'some';
        };
        row.getIsAllSubRowsSelected = ()=>{
            const { rowSelection: rowSelection } = table.getState();
            return $a458d5bea2d12b69$export$8f4c46e5d7907334(row, rowSelection) === 'all';
        };
        row.getCanSelect = ()=>{
            var _table$options$enable;
            if (typeof table.options.enableRowSelection === 'function') return table.options.enableRowSelection(row);
            return (_table$options$enable = table.options.enableRowSelection) != null ? _table$options$enable : true;
        };
        row.getCanSelectSubRows = ()=>{
            var _table$options$enable2;
            if (typeof table.options.enableSubRowSelection === 'function') return table.options.enableSubRowSelection(row);
            return (_table$options$enable2 = table.options.enableSubRowSelection) != null ? _table$options$enable2 : true;
        };
        row.getCanMultiSelect = ()=>{
            var _table$options$enable3;
            if (typeof table.options.enableMultiRowSelection === 'function') return table.options.enableMultiRowSelection(row);
            return (_table$options$enable3 = table.options.enableMultiRowSelection) != null ? _table$options$enable3 : true;
        };
        row.getToggleSelectedHandler = ()=>{
            const canSelect = row.getCanSelect();
            return (e)=>{
                var _target;
                if (!canSelect) return;
                row.toggleSelected((_target = e.target) == null ? void 0 : _target.checked);
            };
        };
    }
};
const $a458d5bea2d12b69$var$mutateRowIsSelected = (selectedRowIds, id, value, includeChildren, table)=>{
    var _row$subRows;
    const row = table.getRow(id, true);
    // const isGrouped = row.getIsGrouped()
    // if ( // TODO: enforce grouping row selection rules
    //   !isGrouped ||
    //   (isGrouped && table.options.enableGroupingRowSelection)
    // ) {
    if (value) {
        if (!row.getCanMultiSelect()) Object.keys(selectedRowIds).forEach((key)=>delete selectedRowIds[key]);
        if (row.getCanSelect()) selectedRowIds[id] = true;
    } else delete selectedRowIds[id];
    // }
    if (includeChildren && (_row$subRows = row.subRows) != null && _row$subRows.length && row.getCanSelectSubRows()) row.subRows.forEach((row)=>$a458d5bea2d12b69$var$mutateRowIsSelected(selectedRowIds, row.id, value, includeChildren, table));
};
function $a458d5bea2d12b69$export$f150e72530556b0b(table, rowModel) {
    const rowSelection = table.getState().rowSelection;
    const newSelectedFlatRows = [];
    const newSelectedRowsById = {};
    // Filters top level and nested rows
    const recurseRows = function(rows, depth) {
        return rows.map((row)=>{
            var _row$subRows2;
            const isSelected = $a458d5bea2d12b69$export$710e11cf672b86c(row, rowSelection);
            if (isSelected) {
                newSelectedFlatRows.push(row);
                newSelectedRowsById[row.id] = row;
            }
            if ((_row$subRows2 = row.subRows) != null && _row$subRows2.length) row = {
                ...row,
                subRows: recurseRows(row.subRows)
            };
            if (isSelected) return row;
        }).filter(Boolean);
    };
    return {
        rows: recurseRows(rowModel.rows),
        flatRows: newSelectedFlatRows,
        rowsById: newSelectedRowsById
    };
}
function $a458d5bea2d12b69$export$710e11cf672b86c(row, selection) {
    var _selection$row$id;
    return (_selection$row$id = selection[row.id]) != null ? _selection$row$id : false;
}
function $a458d5bea2d12b69$export$8f4c46e5d7907334(row, selection, table) {
    var _row$subRows3;
    if (!((_row$subRows3 = row.subRows) != null && _row$subRows3.length)) return false;
    let allChildrenSelected = true;
    let someSelected = false;
    row.subRows.forEach((subRow)=>{
        // Bail out early if we know both of these
        if (someSelected && !allChildrenSelected) return;
        if (subRow.getCanSelect()) {
            if ($a458d5bea2d12b69$export$710e11cf672b86c(subRow, selection)) someSelected = true;
            else allChildrenSelected = false;
        }
        // Check row selection of nested subrows
        if (subRow.subRows && subRow.subRows.length) {
            const subRowChildrenSelected = $a458d5bea2d12b69$export$8f4c46e5d7907334(subRow, selection);
            if (subRowChildrenSelected === 'all') someSelected = true;
            else if (subRowChildrenSelected === 'some') {
                someSelected = true;
                allChildrenSelected = false;
            } else allChildrenSelected = false;
        }
    });
    return allChildrenSelected ? 'all' : someSelected ? 'some' : false;
}
const $a458d5bea2d12b69$export$8758689f50bddb9f = /([0-9]+)/gm;
const $a458d5bea2d12b69$var$alphanumeric = (rowA, rowB, columnId)=>{
    return $a458d5bea2d12b69$var$compareAlphanumeric($a458d5bea2d12b69$var$toString(rowA.getValue(columnId)).toLowerCase(), $a458d5bea2d12b69$var$toString(rowB.getValue(columnId)).toLowerCase());
};
const $a458d5bea2d12b69$var$alphanumericCaseSensitive = (rowA, rowB, columnId)=>{
    return $a458d5bea2d12b69$var$compareAlphanumeric($a458d5bea2d12b69$var$toString(rowA.getValue(columnId)), $a458d5bea2d12b69$var$toString(rowB.getValue(columnId)));
};
// The text filter is more basic (less numeric support)
// but is much faster
const $a458d5bea2d12b69$var$text = (rowA, rowB, columnId)=>{
    return $a458d5bea2d12b69$var$compareBasic($a458d5bea2d12b69$var$toString(rowA.getValue(columnId)).toLowerCase(), $a458d5bea2d12b69$var$toString(rowB.getValue(columnId)).toLowerCase());
};
// The text filter is more basic (less numeric support)
// but is much faster
const $a458d5bea2d12b69$var$textCaseSensitive = (rowA, rowB, columnId)=>{
    return $a458d5bea2d12b69$var$compareBasic($a458d5bea2d12b69$var$toString(rowA.getValue(columnId)), $a458d5bea2d12b69$var$toString(rowB.getValue(columnId)));
};
const $a458d5bea2d12b69$var$datetime = (rowA, rowB, columnId)=>{
    const a = rowA.getValue(columnId);
    const b = rowB.getValue(columnId);
    // Can handle nullish values
    // Use > and < because == (and ===) doesn't work with
    // Date objects (would require calling getTime()).
    return a > b ? 1 : a < b ? -1 : 0;
};
const $a458d5bea2d12b69$var$basic = (rowA, rowB, columnId)=>{
    return $a458d5bea2d12b69$var$compareBasic(rowA.getValue(columnId), rowB.getValue(columnId));
};
// Utils
function $a458d5bea2d12b69$var$compareBasic(a, b) {
    return a === b ? 0 : a > b ? 1 : -1;
}
function $a458d5bea2d12b69$var$toString(a) {
    if (typeof a === 'number') {
        if (isNaN(a) || a === Infinity || a === -Infinity) return '';
        return String(a);
    }
    if (typeof a === 'string') return a;
    return '';
}
// Mixed sorting is slow, but very inclusive of many edge cases.
// It handles numbers, mixed alphanumeric combinations, and even
// null, undefined, and Infinity
function $a458d5bea2d12b69$var$compareAlphanumeric(aStr, bStr) {
    // Split on number groups, but keep the delimiter
    // Then remove falsey split values
    const a = aStr.split($a458d5bea2d12b69$export$8758689f50bddb9f).filter(Boolean);
    const b = bStr.split($a458d5bea2d12b69$export$8758689f50bddb9f).filter(Boolean);
    // While
    while(a.length && b.length){
        const aa = a.shift();
        const bb = b.shift();
        const an = parseInt(aa, 10);
        const bn = parseInt(bb, 10);
        const combo = [
            an,
            bn
        ].sort();
        // Both are string
        if (isNaN(combo[0])) {
            if (aa > bb) return 1;
            if (bb > aa) return -1;
            continue;
        }
        // One is a string, one is a number
        if (isNaN(combo[1])) return isNaN(an) ? -1 : 1;
        // Both are numbers
        if (an > bn) return 1;
        if (bn > an) return -1;
    }
    return a.length - b.length;
}
// Exports
const $a458d5bea2d12b69$export$47423a4cd813a815 = {
    alphanumeric: $a458d5bea2d12b69$var$alphanumeric,
    alphanumericCaseSensitive: $a458d5bea2d12b69$var$alphanumericCaseSensitive,
    text: $a458d5bea2d12b69$var$text,
    textCaseSensitive: $a458d5bea2d12b69$var$textCaseSensitive,
    datetime: $a458d5bea2d12b69$var$datetime,
    basic: $a458d5bea2d12b69$var$basic
};
//
const $a458d5bea2d12b69$export$c7de5ec16c5efba8 = {
    getInitialState: (state)=>{
        return {
            sorting: [],
            ...state
        };
    },
    getDefaultColumnDef: ()=>{
        return {
            sortingFn: 'auto',
            sortUndefined: 1
        };
    },
    getDefaultOptions: (table)=>{
        return {
            onSortingChange: $a458d5bea2d12b69$export$2b5605d8069324bd('sorting', table),
            isMultiSortEvent: (e)=>{
                return e.shiftKey;
            }
        };
    },
    createColumn: (column, table)=>{
        column.getAutoSortingFn = ()=>{
            const firstRows = table.getFilteredRowModel().flatRows.slice(10);
            let isString = false;
            for (const row of firstRows){
                const value = row == null ? void 0 : row.getValue(column.id);
                if (Object.prototype.toString.call(value) === '[object Date]') return $a458d5bea2d12b69$export$47423a4cd813a815.datetime;
                if (typeof value === 'string') {
                    isString = true;
                    if (value.split($a458d5bea2d12b69$export$8758689f50bddb9f).length > 1) return $a458d5bea2d12b69$export$47423a4cd813a815.alphanumeric;
                }
            }
            if (isString) return $a458d5bea2d12b69$export$47423a4cd813a815.text;
            return $a458d5bea2d12b69$export$47423a4cd813a815.basic;
        };
        column.getAutoSortDir = ()=>{
            const firstRow = table.getFilteredRowModel().flatRows[0];
            const value = firstRow == null ? void 0 : firstRow.getValue(column.id);
            if (typeof value === 'string') return 'asc';
            return 'desc';
        };
        column.getSortingFn = ()=>{
            var _table$options$sortin, _table$options$sortin2;
            if (!column) throw new Error();
            return $a458d5bea2d12b69$export$f6e2535fb5126e54(column.columnDef.sortingFn) ? column.columnDef.sortingFn : column.columnDef.sortingFn === 'auto' ? column.getAutoSortingFn() : (_table$options$sortin = (_table$options$sortin2 = table.options.sortingFns) == null ? void 0 : _table$options$sortin2[column.columnDef.sortingFn]) != null ? _table$options$sortin : $a458d5bea2d12b69$export$47423a4cd813a815[column.columnDef.sortingFn];
        };
        column.toggleSorting = (desc, multi)=>{
            // if (column.columns.length) {
            //   column.columns.forEach((c, i) => {
            //     if (c.id) {
            //       table.toggleColumnSorting(c.id, undefined, multi || !!i)
            //     }
            //   })
            //   return
            // }
            // this needs to be outside of table.setSorting to be in sync with rerender
            const nextSortingOrder = column.getNextSortingOrder();
            const hasManualValue = typeof desc !== 'undefined' && desc !== null;
            table.setSorting((old)=>{
                // Find any existing sorting for this column
                const existingSorting = old == null ? void 0 : old.find((d)=>d.id === column.id);
                const existingIndex = old == null ? void 0 : old.findIndex((d)=>d.id === column.id);
                let newSorting = [];
                // What should we do with this sort action?
                let sortAction;
                let nextDesc = hasManualValue ? desc : nextSortingOrder === 'desc';
                // Multi-mode
                if (old != null && old.length && column.getCanMultiSort() && multi) {
                    if (existingSorting) sortAction = 'toggle';
                    else sortAction = 'add';
                } else {
                    // Normal mode
                    if (old != null && old.length && existingIndex !== old.length - 1) sortAction = 'replace';
                    else if (existingSorting) sortAction = 'toggle';
                    else sortAction = 'replace';
                }
                // Handle toggle states that will remove the sorting
                if (sortAction === 'toggle') {
                    // If we are "actually" toggling (not a manual set value), should we remove the sorting?
                    if (!hasManualValue) // Is our intention to remove?
                    {
                        if (!nextSortingOrder) sortAction = 'remove';
                    }
                }
                if (sortAction === 'add') {
                    var _table$options$maxMul;
                    newSorting = [
                        ...old,
                        {
                            id: column.id,
                            desc: nextDesc
                        }
                    ];
                    // Take latest n columns
                    newSorting.splice(0, newSorting.length - ((_table$options$maxMul = table.options.maxMultiSortColCount) != null ? _table$options$maxMul : Number.MAX_SAFE_INTEGER));
                } else if (sortAction === 'toggle') // This flips (or sets) the
                newSorting = old.map((d)=>{
                    if (d.id === column.id) return {
                        ...d,
                        desc: nextDesc
                    };
                    return d;
                });
                else if (sortAction === 'remove') newSorting = old.filter((d)=>d.id !== column.id);
                else newSorting = [
                    {
                        id: column.id,
                        desc: nextDesc
                    }
                ];
                return newSorting;
            });
        };
        column.getFirstSortDir = ()=>{
            var _ref, _column$columnDef$sor;
            const sortDescFirst = (_ref = (_column$columnDef$sor = column.columnDef.sortDescFirst) != null ? _column$columnDef$sor : table.options.sortDescFirst) != null ? _ref : column.getAutoSortDir() === 'desc';
            return sortDescFirst ? 'desc' : 'asc';
        };
        column.getNextSortingOrder = (multi)=>{
            var _table$options$enable, _table$options$enable2;
            const firstSortDirection = column.getFirstSortDir();
            const isSorted = column.getIsSorted();
            if (!isSorted) return firstSortDirection;
            if (isSorted !== firstSortDirection && ((_table$options$enable = table.options.enableSortingRemoval) != null ? _table$options$enable : true) && // If enableSortRemove, enable in general
            (multi ? (_table$options$enable2 = table.options.enableMultiRemove) != null ? _table$options$enable2 : true : true // If multi, don't allow if enableMultiRemove))
            )) return false;
            return isSorted === 'desc' ? 'asc' : 'desc';
        };
        column.getCanSort = ()=>{
            var _column$columnDef$ena, _table$options$enable3;
            return ((_column$columnDef$ena = column.columnDef.enableSorting) != null ? _column$columnDef$ena : true) && ((_table$options$enable3 = table.options.enableSorting) != null ? _table$options$enable3 : true) && !!column.accessorFn;
        };
        column.getCanMultiSort = ()=>{
            var _ref2, _column$columnDef$ena2;
            return (_ref2 = (_column$columnDef$ena2 = column.columnDef.enableMultiSort) != null ? _column$columnDef$ena2 : table.options.enableMultiSort) != null ? _ref2 : !!column.accessorFn;
        };
        column.getIsSorted = ()=>{
            var _table$getState$sorti;
            const columnSort = (_table$getState$sorti = table.getState().sorting) == null ? void 0 : _table$getState$sorti.find((d)=>d.id === column.id);
            return !columnSort ? false : columnSort.desc ? 'desc' : 'asc';
        };
        column.getSortIndex = ()=>{
            var _table$getState$sorti2, _table$getState$sorti3;
            return (_table$getState$sorti2 = (_table$getState$sorti3 = table.getState().sorting) == null ? void 0 : _table$getState$sorti3.findIndex((d)=>d.id === column.id)) != null ? _table$getState$sorti2 : -1;
        };
        column.clearSorting = ()=>{
            //clear sorting for just 1 column
            table.setSorting((old)=>old != null && old.length ? old.filter((d)=>d.id !== column.id) : []);
        };
        column.getToggleSortingHandler = ()=>{
            const canSort = column.getCanSort();
            return (e)=>{
                if (!canSort) return;
                e.persist == null || e.persist();
                column.toggleSorting == null || column.toggleSorting(undefined, column.getCanMultiSort() ? table.options.isMultiSortEvent == null ? void 0 : table.options.isMultiSortEvent(e) : false);
            };
        };
    },
    createTable: (table)=>{
        table.setSorting = (updater)=>table.options.onSortingChange == null ? void 0 : table.options.onSortingChange(updater);
        table.resetSorting = (defaultState)=>{
            var _table$initialState$s, _table$initialState;
            table.setSorting(defaultState ? [] : (_table$initialState$s = (_table$initialState = table.initialState) == null ? void 0 : _table$initialState.sorting) != null ? _table$initialState$s : []);
        };
        table.getPreSortedRowModel = ()=>table.getGroupedRowModel();
        table.getSortedRowModel = ()=>{
            if (!table._getSortedRowModel && table.options.getSortedRowModel) table._getSortedRowModel = table.options.getSortedRowModel(table);
            if (table.options.manualSorting || !table._getSortedRowModel) return table.getPreSortedRowModel();
            return table._getSortedRowModel();
        };
    }
};
const $a458d5bea2d12b69$var$builtInFeatures = [
    $a458d5bea2d12b69$export$79b704688b15c0f4,
    $a458d5bea2d12b69$export$be5545a32e20d889,
    $a458d5bea2d12b69$export$fec9c66cd0275c2c,
    $a458d5bea2d12b69$export$3563275ce70c4813,
    $a458d5bea2d12b69$export$1f746e6a9cd841b1,
    $a458d5bea2d12b69$export$f1d67534a0c5e9d3,
    $a458d5bea2d12b69$export$4b37edcdc7ad2fe1,
    //depends on ColumnFaceting
    $a458d5bea2d12b69$export$61e9e0661ff79b1c,
    //depends on ColumnFiltering
    $a458d5bea2d12b69$export$c7de5ec16c5efba8,
    $a458d5bea2d12b69$export$9c9247c655f92e74,
    //depends on RowSorting
    $a458d5bea2d12b69$export$fed54e0d64c17fb2,
    $a458d5bea2d12b69$export$bce540641752d22b,
    $a458d5bea2d12b69$export$213d72cb2ac7d440,
    $a458d5bea2d12b69$export$e8905133e7bf3121,
    $a458d5bea2d12b69$export$9916c85814812d4a
];
//
function $a458d5bea2d12b69$export$33bbb3ec7652e187(options) {
    var _options$_features, _options$initialState;
    const _features = [
        ...$a458d5bea2d12b69$var$builtInFeatures,
        ...(_options$_features = options._features) != null ? _options$_features : []
    ];
    let table = {
        _features: _features
    };
    const defaultOptions = table._features.reduce((obj, feature)=>{
        return Object.assign(obj, feature.getDefaultOptions == null ? void 0 : feature.getDefaultOptions(table));
    }, {});
    const mergeOptions = (options)=>{
        if (table.options.mergeOptions) return table.options.mergeOptions(defaultOptions, options);
        return {
            ...defaultOptions,
            ...options
        };
    };
    const coreInitialState = {};
    let initialState = {
        ...coreInitialState,
        ...(_options$initialState = options.initialState) != null ? _options$initialState : {}
    };
    table._features.forEach((feature)=>{
        var _feature$getInitialSt;
        initialState = (_feature$getInitialSt = feature.getInitialState == null ? void 0 : feature.getInitialState(initialState)) != null ? _feature$getInitialSt : initialState;
    });
    const queued = [];
    let queuedTimeout = false;
    const coreInstance = {
        _features: _features,
        options: {
            ...defaultOptions,
            ...options
        },
        initialState: initialState,
        _queue: (cb)=>{
            queued.push(cb);
            if (!queuedTimeout) {
                queuedTimeout = true;
                // Schedule a microtask to run the queued callbacks after
                // the current call stack (render, etc) has finished.
                Promise.resolve().then(()=>{
                    while(queued.length)queued.shift()();
                    queuedTimeout = false;
                }).catch((error)=>setTimeout(()=>{
                        throw error;
                    }));
            }
        },
        reset: ()=>{
            table.setState(table.initialState);
        },
        setOptions: (updater)=>{
            const newOptions = $a458d5bea2d12b69$export$7f095f455ad5af3f(updater, table.options);
            table.options = mergeOptions(newOptions);
        },
        getState: ()=>{
            return table.options.state;
        },
        setState: (updater)=>{
            table.options.onStateChange == null || table.options.onStateChange(updater);
        },
        _getRowId: (row, index, parent)=>{
            var _table$options$getRow;
            return (_table$options$getRow = table.options.getRowId == null ? void 0 : table.options.getRowId(row, index, parent)) != null ? _table$options$getRow : `${parent ? [
                parent.id,
                index
            ].join('.') : index}`;
        },
        getCoreRowModel: ()=>{
            if (!table._getCoreRowModel) table._getCoreRowModel = table.options.getCoreRowModel(table);
            return table._getCoreRowModel();
        },
        // The final calls start at the bottom of the model,
        // expanded rows, which then work their way up
        getRowModel: ()=>{
            return table.getPaginationRowModel();
        },
        //in next version, we should just pass in the row model as the optional 2nd arg
        getRow: (id, searchAll)=>{
            let row = (searchAll ? table.getPrePaginationRowModel() : table.getRowModel()).rowsById[id];
            if (!row) {
                row = table.getCoreRowModel().rowsById[id];
                if (!row) throw new Error();
            }
            return row;
        },
        _getDefaultColumnDef: $a458d5bea2d12b69$export$7c73462e0d25e514(()=>[
                table.options.defaultColumn
            ], (defaultColumn)=>{
            var _defaultColumn;
            defaultColumn = (_defaultColumn = defaultColumn) != null ? _defaultColumn : {};
            return {
                header: (props)=>{
                    const resolvedColumnDef = props.header.column.columnDef;
                    if (resolvedColumnDef.accessorKey) return resolvedColumnDef.accessorKey;
                    if (resolvedColumnDef.accessorFn) return resolvedColumnDef.id;
                    return null;
                },
                // footer: props => props.header.column.id,
                cell: (props)=>{
                    var _props$renderValue$to, _props$renderValue;
                    return (_props$renderValue$to = (_props$renderValue = props.renderValue()) == null || _props$renderValue.toString == null ? void 0 : _props$renderValue.toString()) != null ? _props$renderValue$to : null;
                },
                ...table._features.reduce((obj, feature)=>{
                    return Object.assign(obj, feature.getDefaultColumnDef == null ? void 0 : feature.getDefaultColumnDef());
                }, {}),
                ...defaultColumn
            };
        }, $a458d5bea2d12b69$export$b1f82222dc43996c(options, 'debugColumns', '_getDefaultColumnDef')),
        _getColumnDefs: ()=>table.options.columns,
        getAllColumns: $a458d5bea2d12b69$export$7c73462e0d25e514(()=>[
                table._getColumnDefs()
            ], (columnDefs)=>{
            const recurseColumns = function(columnDefs, parent, depth) {
                if (depth === void 0) depth = 0;
                return columnDefs.map((columnDef)=>{
                    const column = $a458d5bea2d12b69$export$1bfa986e9c92c0b5(table, columnDef, depth, parent);
                    const groupingColumnDef = columnDef;
                    column.columns = groupingColumnDef.columns ? recurseColumns(groupingColumnDef.columns, column, depth + 1) : [];
                    return column;
                });
            };
            return recurseColumns(columnDefs);
        }, $a458d5bea2d12b69$export$b1f82222dc43996c(options, 'debugColumns', 'getAllColumns')),
        getAllFlatColumns: $a458d5bea2d12b69$export$7c73462e0d25e514(()=>[
                table.getAllColumns()
            ], (allColumns)=>{
            return allColumns.flatMap((column)=>{
                return column.getFlatColumns();
            });
        }, $a458d5bea2d12b69$export$b1f82222dc43996c(options, 'debugColumns', 'getAllFlatColumns')),
        _getAllFlatColumnsById: $a458d5bea2d12b69$export$7c73462e0d25e514(()=>[
                table.getAllFlatColumns()
            ], (flatColumns)=>{
            return flatColumns.reduce((acc, column)=>{
                acc[column.id] = column;
                return acc;
            }, {});
        }, $a458d5bea2d12b69$export$b1f82222dc43996c(options, 'debugColumns', 'getAllFlatColumnsById')),
        getAllLeafColumns: $a458d5bea2d12b69$export$7c73462e0d25e514(()=>[
                table.getAllColumns(),
                table._getOrderColumnsFn()
            ], (allColumns, orderColumns)=>{
            let leafColumns = allColumns.flatMap((column)=>column.getLeafColumns());
            return orderColumns(leafColumns);
        }, $a458d5bea2d12b69$export$b1f82222dc43996c(options, 'debugColumns', 'getAllLeafColumns')),
        getColumn: (columnId)=>{
            const column = table._getAllFlatColumnsById()[columnId];
            return column;
        }
    };
    Object.assign(table, coreInstance);
    for(let index = 0; index < table._features.length; index++){
        const feature = table._features[index];
        feature == null || feature.createTable == null || feature.createTable(table);
    }
    return table;
}
function $a458d5bea2d12b69$export$32d0bc001e828250() {
    return (table)=>$a458d5bea2d12b69$export$7c73462e0d25e514(()=>[
                table.options.data
            ], (data)=>{
            const rowModel = {
                rows: [],
                flatRows: [],
                rowsById: {}
            };
            const accessRows = function(originalRows, depth, parentRow) {
                if (depth === void 0) depth = 0;
                const rows = [];
                for(let i = 0; i < originalRows.length; i++){
                    // This could be an expensive check at scale, so we should move it somewhere else, but where?
                    // if (!id) {
                    //   if (process.env.NODE_ENV !== 'production') {
                    //     throw new Error(`getRowId expected an ID, but got ${id}`)
                    //   }
                    // }
                    // Make the row
                    const row = $a458d5bea2d12b69$export$3442c5d213434705(table, table._getRowId(originalRows[i], i, parentRow), originalRows[i], i, depth, undefined, parentRow == null ? void 0 : parentRow.id);
                    // Keep track of every row in a flat array
                    rowModel.flatRows.push(row);
                    // Also keep track of every row by its ID
                    rowModel.rowsById[row.id] = row;
                    // Push table row into parent
                    rows.push(row);
                    // Get the original subrows
                    if (table.options.getSubRows) {
                        var _row$originalSubRows;
                        row.originalSubRows = table.options.getSubRows(originalRows[i], i);
                        // Then recursively access them
                        if ((_row$originalSubRows = row.originalSubRows) != null && _row$originalSubRows.length) row.subRows = accessRows(row.originalSubRows, depth + 1, row);
                    }
                }
                return rows;
            };
            rowModel.rows = accessRows(data);
            return rowModel;
        }, $a458d5bea2d12b69$export$b1f82222dc43996c(table.options, 'debugTable', 'getRowModel', ()=>table._autoResetPageIndex()));
}
function $a458d5bea2d12b69$export$53cfec7b1b8d1fcd() {
    return (table)=>$a458d5bea2d12b69$export$7c73462e0d25e514(()=>[
                table.getState().expanded,
                table.getPreExpandedRowModel(),
                table.options.paginateExpandedRows
            ], (expanded, rowModel, paginateExpandedRows)=>{
            if (!rowModel.rows.length || expanded !== true && !Object.keys(expanded != null ? expanded : {}).length) return rowModel;
            if (!paginateExpandedRows) // Only expand rows at this point if they are being paginated
            return rowModel;
            return $a458d5bea2d12b69$export$1293f966cdb38633(rowModel);
        }, $a458d5bea2d12b69$export$b1f82222dc43996c(table.options, 'debugTable', 'getExpandedRowModel'));
}
function $a458d5bea2d12b69$export$1293f966cdb38633(rowModel) {
    const expandedRows = [];
    const handleRow = (row)=>{
        var _row$subRows;
        expandedRows.push(row);
        if ((_row$subRows = row.subRows) != null && _row$subRows.length && row.getIsExpanded()) row.subRows.forEach(handleRow);
    };
    rowModel.rows.forEach(handleRow);
    return {
        rows: expandedRows,
        flatRows: rowModel.flatRows,
        rowsById: rowModel.rowsById
    };
}
function $a458d5bea2d12b69$export$d17dd32c9eab9fc7() {
    return (table, columnId)=>$a458d5bea2d12b69$export$7c73462e0d25e514(()=>{
            var _table$getColumn;
            return [
                (_table$getColumn = table.getColumn(columnId)) == null ? void 0 : _table$getColumn.getFacetedRowModel()
            ];
        }, (facetedRowModel)=>{
            if (!facetedRowModel) return undefined;
            const uniqueValues = facetedRowModel.flatRows.flatMap((flatRow)=>{
                var _flatRow$getUniqueVal;
                return (_flatRow$getUniqueVal = flatRow.getUniqueValues(columnId)) != null ? _flatRow$getUniqueVal : [];
            }).map(Number).filter((value)=>!Number.isNaN(value));
            if (!uniqueValues.length) return;
            let facetedMinValue = uniqueValues[0];
            let facetedMaxValue = uniqueValues[uniqueValues.length - 1];
            for (const value of uniqueValues){
                if (value < facetedMinValue) facetedMinValue = value;
                else if (value > facetedMaxValue) facetedMaxValue = value;
            }
            return [
                facetedMinValue,
                facetedMaxValue
            ];
        }, $a458d5bea2d12b69$export$b1f82222dc43996c(table.options, 'debugTable', 'getFacetedMinMaxValues'));
}
function $a458d5bea2d12b69$var$filterRows(rows, filterRowImpl, table) {
    if (table.options.filterFromLeafRows) return $a458d5bea2d12b69$var$filterRowModelFromLeafs(rows, filterRowImpl, table);
    return $a458d5bea2d12b69$var$filterRowModelFromRoot(rows, filterRowImpl, table);
}
function $a458d5bea2d12b69$var$filterRowModelFromLeafs(rowsToFilter, filterRow, table) {
    var _table$options$maxLea;
    const newFilteredFlatRows = [];
    const newFilteredRowsById = {};
    const maxDepth = (_table$options$maxLea = table.options.maxLeafRowFilterDepth) != null ? _table$options$maxLea : 100;
    const recurseFilterRows = function(rowsToFilter, depth) {
        if (depth === void 0) depth = 0;
        const rows = [];
        // Filter from children up first
        for(let i = 0; i < rowsToFilter.length; i++){
            var _row$subRows;
            let row = rowsToFilter[i];
            const newRow = $a458d5bea2d12b69$export$3442c5d213434705(table, row.id, row.original, row.index, row.depth, undefined, row.parentId);
            newRow.columnFilters = row.columnFilters;
            if ((_row$subRows = row.subRows) != null && _row$subRows.length && depth < maxDepth) {
                newRow.subRows = recurseFilterRows(row.subRows, depth + 1);
                row = newRow;
                if (filterRow(row) && !newRow.subRows.length) {
                    rows.push(row);
                    newFilteredRowsById[row.id] = row;
                    newFilteredFlatRows.push(row);
                    continue;
                }
                if (filterRow(row) || newRow.subRows.length) {
                    rows.push(row);
                    newFilteredRowsById[row.id] = row;
                    newFilteredFlatRows.push(row);
                    continue;
                }
            } else {
                row = newRow;
                if (filterRow(row)) {
                    rows.push(row);
                    newFilteredRowsById[row.id] = row;
                    newFilteredFlatRows.push(row);
                }
            }
        }
        return rows;
    };
    return {
        rows: recurseFilterRows(rowsToFilter),
        flatRows: newFilteredFlatRows,
        rowsById: newFilteredRowsById
    };
}
function $a458d5bea2d12b69$var$filterRowModelFromRoot(rowsToFilter, filterRow, table) {
    var _table$options$maxLea2;
    const newFilteredFlatRows = [];
    const newFilteredRowsById = {};
    const maxDepth = (_table$options$maxLea2 = table.options.maxLeafRowFilterDepth) != null ? _table$options$maxLea2 : 100;
    // Filters top level and nested rows
    const recurseFilterRows = function(rowsToFilter, depth) {
        if (depth === void 0) depth = 0;
        // Filter from parents downward first
        const rows = [];
        // Apply the filter to any subRows
        for(let i = 0; i < rowsToFilter.length; i++){
            let row = rowsToFilter[i];
            const pass = filterRow(row);
            if (pass) {
                var _row$subRows2;
                if ((_row$subRows2 = row.subRows) != null && _row$subRows2.length && depth < maxDepth) {
                    const newRow = $a458d5bea2d12b69$export$3442c5d213434705(table, row.id, row.original, row.index, row.depth, undefined, row.parentId);
                    newRow.subRows = recurseFilterRows(row.subRows, depth + 1);
                    row = newRow;
                }
                rows.push(row);
                newFilteredFlatRows.push(row);
                newFilteredRowsById[row.id] = row;
            }
        }
        return rows;
    };
    return {
        rows: recurseFilterRows(rowsToFilter),
        flatRows: newFilteredFlatRows,
        rowsById: newFilteredRowsById
    };
}
function $a458d5bea2d12b69$export$3519aa0e35dc33b4() {
    return (table, columnId)=>$a458d5bea2d12b69$export$7c73462e0d25e514(()=>[
                table.getPreFilteredRowModel(),
                table.getState().columnFilters,
                table.getState().globalFilter,
                table.getFilteredRowModel()
            ], (preRowModel, columnFilters, globalFilter)=>{
            if (!preRowModel.rows.length || !(columnFilters != null && columnFilters.length) && !globalFilter) return preRowModel;
            const filterableIds = [
                ...columnFilters.map((d)=>d.id).filter((d)=>d !== columnId),
                globalFilter ? '__global__' : undefined
            ].filter(Boolean);
            const filterRowsImpl = (row)=>{
                // Horizontally filter rows through each column
                for(let i = 0; i < filterableIds.length; i++){
                    if (row.columnFilters[filterableIds[i]] === false) return false;
                }
                return true;
            };
            return $a458d5bea2d12b69$var$filterRows(preRowModel.rows, filterRowsImpl, table);
        }, $a458d5bea2d12b69$export$b1f82222dc43996c(table.options, 'debugTable', 'getFacetedRowModel'));
}
function $a458d5bea2d12b69$export$1fb5d0c1edc37de2() {
    return (table, columnId)=>$a458d5bea2d12b69$export$7c73462e0d25e514(()=>{
            var _table$getColumn;
            return [
                (_table$getColumn = table.getColumn(columnId)) == null ? void 0 : _table$getColumn.getFacetedRowModel()
            ];
        }, (facetedRowModel)=>{
            if (!facetedRowModel) return new Map();
            let facetedUniqueValues = new Map();
            for(let i = 0; i < facetedRowModel.flatRows.length; i++){
                const values = facetedRowModel.flatRows[i].getUniqueValues(columnId);
                for(let j = 0; j < values.length; j++){
                    const value = values[j];
                    if (facetedUniqueValues.has(value)) {
                        var _facetedUniqueValues$;
                        facetedUniqueValues.set(value, ((_facetedUniqueValues$ = facetedUniqueValues.get(value)) != null ? _facetedUniqueValues$ : 0) + 1);
                    } else facetedUniqueValues.set(value, 1);
                }
            }
            return facetedUniqueValues;
        }, $a458d5bea2d12b69$export$b1f82222dc43996c(table.options, 'debugTable', `getFacetedUniqueValues_${columnId}`));
}
function $a458d5bea2d12b69$export$26f255a2756e1638() {
    return (table)=>$a458d5bea2d12b69$export$7c73462e0d25e514(()=>[
                table.getPreFilteredRowModel(),
                table.getState().columnFilters,
                table.getState().globalFilter
            ], (rowModel, columnFilters, globalFilter)=>{
            if (!rowModel.rows.length || !(columnFilters != null && columnFilters.length) && !globalFilter) {
                for(let i = 0; i < rowModel.flatRows.length; i++){
                    rowModel.flatRows[i].columnFilters = {};
                    rowModel.flatRows[i].columnFiltersMeta = {};
                }
                return rowModel;
            }
            const resolvedColumnFilters = [];
            const resolvedGlobalFilters = [];
            (columnFilters != null ? columnFilters : []).forEach((d)=>{
                var _filterFn$resolveFilt;
                const column = table.getColumn(d.id);
                if (!column) return;
                const filterFn = column.getFilterFn();
                if (!filterFn) return;
                resolvedColumnFilters.push({
                    id: d.id,
                    filterFn: filterFn,
                    resolvedValue: (_filterFn$resolveFilt = filterFn.resolveFilterValue == null ? void 0 : filterFn.resolveFilterValue(d.value)) != null ? _filterFn$resolveFilt : d.value
                });
            });
            const filterableIds = (columnFilters != null ? columnFilters : []).map((d)=>d.id);
            const globalFilterFn = table.getGlobalFilterFn();
            const globallyFilterableColumns = table.getAllLeafColumns().filter((column)=>column.getCanGlobalFilter());
            if (globalFilter && globalFilterFn && globallyFilterableColumns.length) {
                filterableIds.push('__global__');
                globallyFilterableColumns.forEach((column)=>{
                    var _globalFilterFn$resol;
                    resolvedGlobalFilters.push({
                        id: column.id,
                        filterFn: globalFilterFn,
                        resolvedValue: (_globalFilterFn$resol = globalFilterFn.resolveFilterValue == null ? void 0 : globalFilterFn.resolveFilterValue(globalFilter)) != null ? _globalFilterFn$resol : globalFilter
                    });
                });
            }
            let currentColumnFilter;
            let currentGlobalFilter;
            // Flag the prefiltered row model with each filter state
            for(let j = 0; j < rowModel.flatRows.length; j++){
                const row = rowModel.flatRows[j];
                row.columnFilters = {};
                if (resolvedColumnFilters.length) for(let i = 0; i < resolvedColumnFilters.length; i++){
                    currentColumnFilter = resolvedColumnFilters[i];
                    const id = currentColumnFilter.id;
                    // Tag the row with the column filter state
                    row.columnFilters[id] = currentColumnFilter.filterFn(row, id, currentColumnFilter.resolvedValue, (filterMeta)=>{
                        row.columnFiltersMeta[id] = filterMeta;
                    });
                }
                if (resolvedGlobalFilters.length) {
                    for(let i = 0; i < resolvedGlobalFilters.length; i++){
                        currentGlobalFilter = resolvedGlobalFilters[i];
                        const id = currentGlobalFilter.id;
                        // Tag the row with the first truthy global filter state
                        if (currentGlobalFilter.filterFn(row, id, currentGlobalFilter.resolvedValue, (filterMeta)=>{
                            row.columnFiltersMeta[id] = filterMeta;
                        })) {
                            row.columnFilters.__global__ = true;
                            break;
                        }
                    }
                    if (row.columnFilters.__global__ !== true) row.columnFilters.__global__ = false;
                }
            }
            const filterRowsImpl = (row)=>{
                // Horizontally filter rows through each column
                for(let i = 0; i < filterableIds.length; i++){
                    if (row.columnFilters[filterableIds[i]] === false) return false;
                }
                return true;
            };
            // Filter final rows using all of the active filters
            return $a458d5bea2d12b69$var$filterRows(rowModel.rows, filterRowsImpl, table);
        }, $a458d5bea2d12b69$export$b1f82222dc43996c(table.options, 'debugTable', 'getFilteredRowModel', ()=>table._autoResetPageIndex()));
}
function $a458d5bea2d12b69$export$2b7f4b57ce71b81() {
    return (table)=>$a458d5bea2d12b69$export$7c73462e0d25e514(()=>[
                table.getState().grouping,
                table.getPreGroupedRowModel()
            ], (grouping, rowModel)=>{
            if (!rowModel.rows.length || !grouping.length) {
                rowModel.rows.forEach((row)=>{
                    row.depth = 0;
                    row.parentId = undefined;
                });
                return rowModel;
            }
            // Filter the grouping list down to columns that exist
            const existingGrouping = grouping.filter((columnId)=>table.getColumn(columnId));
            const groupedFlatRows = [];
            const groupedRowsById = {};
            // const onlyGroupedFlatRows: Row[] = [];
            // const onlyGroupedRowsById: Record<RowId, Row> = {};
            // const nonGroupedFlatRows: Row[] = [];
            // const nonGroupedRowsById: Record<RowId, Row> = {};
            // Recursively group the data
            const groupUpRecursively = function(rows, depth, parentId) {
                if (depth === void 0) depth = 0;
                // Grouping depth has been been met
                // Stop grouping and simply rewrite thd depth and row relationships
                if (depth >= existingGrouping.length) return rows.map((row)=>{
                    row.depth = depth;
                    groupedFlatRows.push(row);
                    groupedRowsById[row.id] = row;
                    if (row.subRows) row.subRows = groupUpRecursively(row.subRows, depth + 1, row.id);
                    return row;
                });
                const columnId = existingGrouping[depth];
                // Group the rows together for this level
                const rowGroupsMap = $a458d5bea2d12b69$var$groupBy(rows, columnId);
                // Perform aggregations for each group
                const aggregatedGroupedRows = Array.from(rowGroupsMap.entries()).map((_ref, index)=>{
                    let [groupingValue, groupedRows] = _ref;
                    let id = `${columnId}:${groupingValue}`;
                    id = parentId ? `${parentId}>${id}` : id;
                    // First, Recurse to group sub rows before aggregation
                    const subRows = groupUpRecursively(groupedRows, depth + 1, id);
                    subRows.forEach((subRow)=>{
                        subRow.parentId = id;
                    });
                    // Flatten the leaf rows of the rows in this group
                    const leafRows = depth ? $a458d5bea2d12b69$export$bf4548421d1b2c8(groupedRows, (row)=>row.subRows) : groupedRows;
                    const row = $a458d5bea2d12b69$export$3442c5d213434705(table, id, leafRows[0].original, index, depth, undefined, parentId);
                    Object.assign(row, {
                        groupingColumnId: columnId,
                        groupingValue: groupingValue,
                        subRows: subRows,
                        leafRows: leafRows,
                        getValue: (columnId)=>{
                            // Don't aggregate columns that are in the grouping
                            if (existingGrouping.includes(columnId)) {
                                if (row._valuesCache.hasOwnProperty(columnId)) return row._valuesCache[columnId];
                                if (groupedRows[0]) {
                                    var _groupedRows$0$getVal;
                                    row._valuesCache[columnId] = (_groupedRows$0$getVal = groupedRows[0].getValue(columnId)) != null ? _groupedRows$0$getVal : undefined;
                                }
                                return row._valuesCache[columnId];
                            }
                            if (row._groupingValuesCache.hasOwnProperty(columnId)) return row._groupingValuesCache[columnId];
                            // Aggregate the values
                            const column = table.getColumn(columnId);
                            const aggregateFn = column == null ? void 0 : column.getAggregationFn();
                            if (aggregateFn) {
                                row._groupingValuesCache[columnId] = aggregateFn(columnId, leafRows, groupedRows);
                                return row._groupingValuesCache[columnId];
                            }
                        }
                    });
                    subRows.forEach((subRow)=>{
                        groupedFlatRows.push(subRow);
                        groupedRowsById[subRow.id] = subRow;
                    // if (subRow.getIsGrouped?.()) {
                    //   onlyGroupedFlatRows.push(subRow);
                    //   onlyGroupedRowsById[subRow.id] = subRow;
                    // } else {
                    //   nonGroupedFlatRows.push(subRow);
                    //   nonGroupedRowsById[subRow.id] = subRow;
                    // }
                    });
                    return row;
                });
                return aggregatedGroupedRows;
            };
            const groupedRows = groupUpRecursively(rowModel.rows, 0);
            groupedRows.forEach((subRow)=>{
                groupedFlatRows.push(subRow);
                groupedRowsById[subRow.id] = subRow;
            // if (subRow.getIsGrouped?.()) {
            //   onlyGroupedFlatRows.push(subRow);
            //   onlyGroupedRowsById[subRow.id] = subRow;
            // } else {
            //   nonGroupedFlatRows.push(subRow);
            //   nonGroupedRowsById[subRow.id] = subRow;
            // }
            });
            return {
                rows: groupedRows,
                flatRows: groupedFlatRows,
                rowsById: groupedRowsById
            };
        }, $a458d5bea2d12b69$export$b1f82222dc43996c(table.options, 'debugTable', 'getGroupedRowModel', ()=>{
            table._queue(()=>{
                table._autoResetExpanded();
                table._autoResetPageIndex();
            });
        }));
}
function $a458d5bea2d12b69$var$groupBy(rows, columnId) {
    const groupMap = new Map();
    return rows.reduce((map, row)=>{
        const resKey = `${row.getGroupingValue(columnId)}`;
        const previous = map.get(resKey);
        if (!previous) map.set(resKey, [
            row
        ]);
        else previous.push(row);
        return map;
    }, groupMap);
}
function $a458d5bea2d12b69$export$ddfd3662e196c265(opts) {
    return (table)=>$a458d5bea2d12b69$export$7c73462e0d25e514(()=>[
                table.getState().pagination,
                table.getPrePaginationRowModel(),
                table.options.paginateExpandedRows ? undefined : table.getState().expanded
            ], (pagination, rowModel)=>{
            if (!rowModel.rows.length) return rowModel;
            const { pageSize: pageSize, pageIndex: pageIndex } = pagination;
            let { rows: rows, flatRows: flatRows, rowsById: rowsById } = rowModel;
            const pageStart = pageSize * pageIndex;
            const pageEnd = pageStart + pageSize;
            rows = rows.slice(pageStart, pageEnd);
            let paginatedRowModel;
            if (!table.options.paginateExpandedRows) paginatedRowModel = $a458d5bea2d12b69$export$1293f966cdb38633({
                rows: rows,
                flatRows: flatRows,
                rowsById: rowsById
            });
            else paginatedRowModel = {
                rows: rows,
                flatRows: flatRows,
                rowsById: rowsById
            };
            paginatedRowModel.flatRows = [];
            const handleRow = (row)=>{
                paginatedRowModel.flatRows.push(row);
                if (row.subRows.length) row.subRows.forEach(handleRow);
            };
            paginatedRowModel.rows.forEach(handleRow);
            return paginatedRowModel;
        }, $a458d5bea2d12b69$export$b1f82222dc43996c(table.options, 'debugTable', 'getPaginationRowModel'));
}
function $a458d5bea2d12b69$export$4ca93ca80835d8c1() {
    return (table)=>$a458d5bea2d12b69$export$7c73462e0d25e514(()=>[
                table.getState().sorting,
                table.getPreSortedRowModel()
            ], (sorting, rowModel)=>{
            if (!rowModel.rows.length || !(sorting != null && sorting.length)) return rowModel;
            const sortingState = table.getState().sorting;
            const sortedFlatRows = [];
            // Filter out sortings that correspond to non existing columns
            const availableSorting = sortingState.filter((sort)=>{
                var _table$getColumn;
                return (_table$getColumn = table.getColumn(sort.id)) == null ? void 0 : _table$getColumn.getCanSort();
            });
            const columnInfoById = {};
            availableSorting.forEach((sortEntry)=>{
                const column = table.getColumn(sortEntry.id);
                if (!column) return;
                columnInfoById[sortEntry.id] = {
                    sortUndefined: column.columnDef.sortUndefined,
                    invertSorting: column.columnDef.invertSorting,
                    sortingFn: column.getSortingFn()
                };
            });
            const sortData = (rows)=>{
                // This will also perform a stable sorting using the row index
                // if needed.
                const sortedData = rows.map((row)=>({
                        ...row
                    }));
                sortedData.sort((rowA, rowB)=>{
                    for(let i = 0; i < availableSorting.length; i += 1){
                        var _sortEntry$desc;
                        const sortEntry = availableSorting[i];
                        const columnInfo = columnInfoById[sortEntry.id];
                        const sortUndefined = columnInfo.sortUndefined;
                        const isDesc = (_sortEntry$desc = sortEntry == null ? void 0 : sortEntry.desc) != null ? _sortEntry$desc : false;
                        let sortInt = 0;
                        // All sorting ints should always return in ascending order
                        if (sortUndefined) {
                            const aValue = rowA.getValue(sortEntry.id);
                            const bValue = rowB.getValue(sortEntry.id);
                            const aUndefined = aValue === undefined;
                            const bUndefined = bValue === undefined;
                            if (aUndefined || bUndefined) {
                                if (sortUndefined === 'first') return aUndefined ? -1 : 1;
                                if (sortUndefined === 'last') return aUndefined ? 1 : -1;
                                sortInt = aUndefined && bUndefined ? 0 : aUndefined ? sortUndefined : -sortUndefined;
                            }
                        }
                        if (sortInt === 0) sortInt = columnInfo.sortingFn(rowA, rowB, sortEntry.id);
                        // If sorting is non-zero, take care of desc and inversion
                        if (sortInt !== 0) {
                            if (isDesc) sortInt *= -1;
                            if (columnInfo.invertSorting) sortInt *= -1;
                            return sortInt;
                        }
                    }
                    return rowA.index - rowB.index;
                });
                // If there are sub-rows, sort them
                sortedData.forEach((row)=>{
                    var _row$subRows;
                    sortedFlatRows.push(row);
                    if ((_row$subRows = row.subRows) != null && _row$subRows.length) row.subRows = sortData(row.subRows);
                });
                return sortedData;
            };
            return {
                rows: sortData(rowModel.rows),
                flatRows: sortedFlatRows,
                rowsById: rowModel.rowsById
            };
        }, $a458d5bea2d12b69$export$b1f82222dc43996c(table.options, 'debugTable', 'getSortedRowModel', ()=>table._autoResetPageIndex()));
}

});


parcelRegister("382YZ", function(module, exports) {
$parcel$export(module.exports, "default", () => $24746ec16a40581d$export$2e2bcd8739ae039);

var $kqp0i = parcelRequire("kqp0i");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");

var $gkiBY = parcelRequire("gkiBY");

var $dA5ju = parcelRequire("dA5ju");

var $kFoY0 = parcelRequire("kFoY0");
var $24746ec16a40581d$var$_excluded = [
    "analyticsContext",
    "appearance",
    "aria-label",
    "aria-labelledby",
    "autoFocus",
    "children",
    "iconAfter",
    "iconBefore",
    "interactionName",
    "isDisabled",
    "isLoading",
    "isSelected",
    "onClick",
    "onClickCapture",
    "onKeyDownCapture",
    "onKeyUpCapture",
    "onMouseDownCapture",
    "onMouseUpCapture",
    "onPointerDownCapture",
    "onPointerUpCapture",
    "onTouchEndCapture",
    "onTouchStartCapture",
    "shouldFitContainer",
    "spacing",
    "testId",
    "type"
], $24746ec16a40581d$var$_excluded2 = [
    "className",
    "css",
    "as",
    "style"
];
/**
 * __Button__
 *
 * A button triggers an event or action.
 *
 * - [Examples](https://atlassian.design/components/button/examples)
 * - [Code](https://atlassian.design/components/button/code)
 * - [Usage](https://atlassian.design/components/button/usage)
 */ var $24746ec16a40581d$var$Button = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).forwardRef(function Button(_ref, ref) {
    var analyticsContext = _ref.analyticsContext, appearance = _ref.appearance, ariaLabel = _ref['aria-label'], ariaLabelledBy = _ref['aria-labelledby'], autoFocus = _ref.autoFocus, children = _ref.children, iconAfter = _ref.iconAfter, iconBefore = _ref.iconBefore, interactionName = _ref.interactionName, isDisabled = _ref.isDisabled, _ref$isLoading = _ref.isLoading, isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading, isSelected = _ref.isSelected, onClick = _ref.onClick, onClickCapture = _ref.onClickCapture, onKeyDownCapture = _ref.onKeyDownCapture, onKeyUpCapture = _ref.onKeyUpCapture, onMouseDownCapture = _ref.onMouseDownCapture, onMouseUpCapture = _ref.onMouseUpCapture, onPointerDownCapture = _ref.onPointerDownCapture, onPointerUpCapture = _ref.onPointerUpCapture, onTouchEndCapture = _ref.onTouchEndCapture, onTouchStartCapture = _ref.onTouchStartCapture, shouldFitContainer = _ref.shouldFitContainer, spacing = _ref.spacing, testId = _ref.testId, _ref$type = _ref.type, type = _ref$type === void 0 ? 'button' : _ref$type, unsafeRest = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $24746ec16a40581d$var$_excluded);
    // @ts-expect-error
    var _className = unsafeRest.className, _css = unsafeRest.css, _as = unsafeRest.as, _style = unsafeRest.style, saferRest = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(unsafeRest, $24746ec16a40581d$var$_excluded2);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $gkiBY.default), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        analyticsContext: analyticsContext,
        ref: ref,
        appearance: appearance,
        autoFocus: autoFocus,
        isDisabled: isDisabled,
        isLoading: isLoading,
        isSelected: isSelected,
        hasIconBefore: Boolean(iconBefore),
        hasIconAfter: Boolean(iconAfter),
        shouldFitContainer: shouldFitContainer,
        spacing: spacing,
        ariaLabel: ariaLabel,
        ariaLabelledBy: ariaLabelledBy,
        onClick: onClick,
        onClickCapture: onClickCapture,
        onKeyDownCapture: onKeyDownCapture,
        onKeyUpCapture: onKeyUpCapture,
        onMouseDownCapture: onMouseDownCapture,
        onMouseUpCapture: onMouseUpCapture,
        onPointerDownCapture: onPointerDownCapture,
        onPointerUpCapture: onPointerUpCapture,
        onTouchStartCapture: onTouchStartCapture,
        onTouchEndCapture: onTouchEndCapture,
        testId: testId,
        componentName: "Button",
        type: type,
        interactionName: interactionName
    }, saferRest), iconBefore && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $dA5ju.default), {
        type: "icon",
        position: "before",
        isLoading: isLoading
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $kFoY0.default), {
        icon: iconBefore
    })), children && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $dA5ju.default), {
        isLoading: isLoading
    }, children), iconAfter && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $dA5ju.default), {
        type: "icon",
        position: "after",
        isLoading: isLoading
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $kFoY0.default), {
        icon: iconAfter
    })));
}));
$24746ec16a40581d$var$Button.displayName = 'Button';
var $24746ec16a40581d$export$2e2bcd8739ae039 = $24746ec16a40581d$var$Button;

});
parcelRegister("gkiBY", function(module, exports) {
$parcel$export(module.exports, "default", () => $be2cf37359aba078$export$2e2bcd8739ae039);
/* button-base.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $kqp0i = parcelRequire("kqp0i");

var $1Vcia = parcelRequire("1Vcia");

var $hUbY6 = parcelRequire("hUbY6");

var $5FkrB = parcelRequire("5FkrB");

var $hRJ5R = parcelRequire("hRJ5R");

var $kPZLD = parcelRequire("kPZLD");

var $ex2NY = parcelRequire("ex2NY");

var $iZD2p = parcelRequire("iZD2p");

var $5VFxW = parcelRequire("5VFxW");

var $i7OzP = parcelRequire("i7OzP");

var $cd86S = parcelRequire("cd86S");

var $i7AhG = parcelRequire("i7AhG");

var $gghZe = parcelRequire("gghZe");

var $41VGH = parcelRequire("41VGH");

var $dPyVN = parcelRequire("dPyVN");
var $be2cf37359aba078$var$_excluded = [
    "appearance",
    "autoFocus",
    "isDisabled",
    "isLoading",
    "isSelected",
    "isIconButton",
    "isCircle",
    "hasIconBefore",
    "hasIconAfter",
    "shouldFitContainer",
    "spacing",
    "ariaLabel",
    "ariaLabelledBy",
    "children",
    "interactionName",
    "onClick",
    "onMouseDown",
    "onMouseDownCapture",
    "onMouseUp",
    "onMouseUpCapture",
    "onKeyDown",
    "onKeyDownCapture",
    "onKeyUp",
    "onKeyUpCapture",
    "onTouchStart",
    "onTouchStartCapture",
    "onTouchEnd",
    "onTouchEndCapture",
    "onPointerDown",
    "onPointerDownCapture",
    "onPointerUp",
    "onPointerUpCapture",
    "onClickCapture",
    "testId",
    "analyticsContext",
    "componentName",
    "role",
    "onMouseOver",
    "onMouseOut",
    "onFocus",
    "onBlur",
    "onMouseMove",
    "type"
], $be2cf37359aba078$var$_excluded2 = [
    "className",
    "css",
    "as",
    "style"
];
var $be2cf37359aba078$var$LOADING_LABEL = ', Loading';
var $be2cf37359aba078$var$styles = {
    base: "_2rkofajl _11c8fhey _v5649dqc _189eidpf _1rjc12x7 _1e0c116y _vchhusvi _1bsb1wug _p12f1osq _kqswh2mm _4cvr1q9y _1bah1h6o _gy1p1b66 _1o9zidpf _4t3iviql _k48p1wq8 _y4tiutpp _bozgutpp _y3gn1h6o _s7n4nkob _14mj1kw7 _9v7aze3t _1tv3nqa1 _39yqe4h9 _11fnglyw _18postnw",
    baseT26Shape: "_2rko1qi0",
    linkDecorationUnset: "_4bfu1r31 _1hmsglyw _ajmmnqa1 _1a3b1r31 _4fprglyw _5goinqa1 _9oik1r31 _1bnxglyw _jf4cnqa1 _1nrm1r31 _c2waglyw _1iohnqa1",
    disabled: "_80om13gf _syaz1gmx _30l31gmx _9h8h1gmx",
    sharedDisabled: "_bfhk187o _irr3187o _1di6187o",
    spacingCompact: "_1rjcv77o _gy1p1b66 _4t3i1k8s _y4tiutpp _bozgutpp _s7n4nkob",
    spacingCompactT26Shape: "_2rko12b0",
    circle: "_2rko1rr0",
    fullWidth: "_1bsb1osq",
    loading: "_80om15jw",
    iconButton: "_4t3iviql _1bsbviql _y4tize3t _bozgze3t",
    iconButtonCompact: "_4t3i1k8s _1bsb1k8s",
    buttonIconBefore: "_bozgutpp _gy1p12x7",
    buttonIconAfter: "_y4tiutpp _gy1p12x7",
    splitButton: "_g0pbb4wl",
    loadingOverlay: "_1reo15vq _18m915vq _1e0c1txw _kqswstnw _4cvr1h6o _1bah1h6o _u7coze3t _152tze3t _rjxpze3t _1e02ze3t",
    navigationSplitButton: "_1bsb1tcg _bfhksm61 _y4ti12x7 _bozg12x7"
};
var $be2cf37359aba078$var$defaultStyles = {
    root: "_bfhksm61 _syazazsu _8l3m1l7x _aetrb3bt _1053azsu _f8pjazsu _30l3azsu _9h8hazsu",
    interactive: "_irr31dpa _30l3azsu _1di6fcek _9h8hazsu",
    disabled: "_bfhk1j28 _8l3mbk0g _irr31j28 _1di61j28"
};
var $be2cf37359aba078$var$primaryStyles = {
    root: "_bfhk1856 _syaz15cr _105315cr _f8pj15cr _30l315cr _9h8h15cr",
    interactive: "_30l315cr _irr3hf2y _9h8h15cr _1di6g6ey"
};
var $be2cf37359aba078$var$rovoStyles = {
    root: "_bfhklqh9 _syaz15cr _105315cr _f8pj15cr _30l315cr _9h8h15cr",
    interactive: "_30l315cr _irr31afz _9h8h15cr _1di61kru"
};
var $be2cf37359aba078$var$warningStyles = {
    root: "_bfhk1kmu _syaz1yd3 _10531yd3 _f8pj1yd3 _30l31yd3 _9h8h1yd3",
    interactive: "_30l31yd3 _irr31spp _9h8h1yd3 _1di64m4m"
};
var $be2cf37359aba078$var$dangerStyles = {
    root: "_bfhkybec _syaz15cr _105315cr _f8pj15cr _30l315cr _9h8h15cr",
    interactive: "_30l315cr _irr3s9hg _9h8h15cr _1di613a9"
};
var $be2cf37359aba078$var$discoveryStyles = {
    root: "_bfhku5tj _syaz15cr _105315cr _f8pj15cr _30l315cr _9h8h15cr",
    interactive: "_30l315cr _irr3fqeg _9h8h15cr _1di61f1m"
};
var $be2cf37359aba078$var$subtleStyles = {
    root: "_bfhksm61 _syazazsu _1053azsu _f8pjazsu _30l3azsu _9h8hazsu",
    interactive: "_irr31dpa _30l3azsu _1di6fcek _9h8hazsu",
    disabled: "_bfhk1j28 _8l3mbk0g _irr31j28 _1di61j28"
};
var $be2cf37359aba078$var$selectedStyles = {
    root: "_bfhk15s3 _syaz6x5g _8l3mq98m _aetrb3bt _10536x5g _f8pj6x5g _30l36x5g _9h8h6x5g",
    insideSplitButton: "_1pbycs5v",
    interactive: "_irr3ufnl _30l36x5g _1di6nozp _9h8h6x5g",
    warning: "_bfhk15s3 _syaz6x5g _30l36x5g _irr315s3 _9h8h6x5g _1di615s3",
    danger: "_bfhk15s3 _syaz6x5g _30l36x5g _irr315s3 _9h8h6x5g _1di615s3",
    discovery: "_bfhk15s3 _syaz6x5g _30l36x5g _irr315s3 _9h8h6x5g _1di615s3"
};
/**
 * __button base__
 *
 * - Implements auto focus when enabled.
 * - Appends the `onClick` event with UFO analytics tracking.
 *
 * @private
 */ var $be2cf37359aba078$var$ButtonBase = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).forwardRef(// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore: to unblock React 18.2.0 -> 18.3.1 version bump in Jira
function(_ref, ref) {
    var propAppearance = _ref.appearance, _ref$autoFocus = _ref.autoFocus, autoFocus = _ref$autoFocus === void 0 ? false : _ref$autoFocus, _ref$isDisabled = _ref.isDisabled, propIsDisabled = _ref$isDisabled === void 0 ? false : _ref$isDisabled, _ref$isLoading = _ref.isLoading, isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading, _ref$isSelected = _ref.isSelected, propIsSelected = _ref$isSelected === void 0 ? false : _ref$isSelected, _ref$isIconButton = _ref.isIconButton, isIconButton = _ref$isIconButton === void 0 ? false : _ref$isIconButton, _ref$isCircle = _ref.isCircle, isCircle = _ref$isCircle === void 0 ? false : _ref$isCircle, _ref$hasIconBefore = _ref.hasIconBefore, hasIconBefore = _ref$hasIconBefore === void 0 ? false : _ref$hasIconBefore, _ref$hasIconAfter = _ref.hasIconAfter, hasIconAfter = _ref$hasIconAfter === void 0 ? false : _ref$hasIconAfter, _ref$shouldFitContain = _ref.shouldFitContainer, shouldFitContainer = _ref$shouldFitContain === void 0 ? false : _ref$shouldFitContain, _ref$spacing = _ref.spacing, propSpacing = _ref$spacing === void 0 ? 'default' : _ref$spacing, ariaLabel = _ref.ariaLabel, ariaLabelledBy = _ref.ariaLabelledBy, children = _ref.children, interactionName = _ref.interactionName, onClick = _ref.onClick, onMouseDown = _ref.onMouseDown, onMouseDownCapture = _ref.onMouseDownCapture, onMouseUp = _ref.onMouseUp, onMouseUpCapture = _ref.onMouseUpCapture, onKeyDown = _ref.onKeyDown, onKeyDownCapture = _ref.onKeyDownCapture, onKeyUp = _ref.onKeyUp, onKeyUpCapture = _ref.onKeyUpCapture, onTouchStart = _ref.onTouchStart, onTouchStartCapture = _ref.onTouchStartCapture, onTouchEnd = _ref.onTouchEnd, onTouchEndCapture = _ref.onTouchEndCapture, onPointerDown = _ref.onPointerDown, onPointerDownCapture = _ref.onPointerDownCapture, onPointerUp = _ref.onPointerUp, onPointerUpCapture = _ref.onPointerUpCapture, onClickCapture = _ref.onClickCapture, testId = _ref.testId, analyticsContext = _ref.analyticsContext, componentName = _ref.componentName, role = _ref.role, onMouseOver = _ref.onMouseOver, onMouseOut = _ref.onMouseOut, onFocus = _ref.onFocus, onBlur = _ref.onBlur, onMouseMove = _ref.onMouseMove, type = _ref.type, unsafeRest = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $be2cf37359aba078$var$_excluded);
    var localRef = (0, $5FkrB.useRef)(null);
    var splitButtonContext = (0, $gghZe.useSplitButtonContext)();
    var loadingLabelId = (0, $iZD2p.useId)();
    var isSplitButton = Boolean(splitButtonContext);
    var isNavigationSplitButton = (splitButtonContext === null || splitButtonContext === void 0 ? void 0 : splitButtonContext.isNavigationSplitButton) || false;
    var isDefaultAppearanceSplitButton = (splitButtonContext === null || splitButtonContext === void 0 ? void 0 : splitButtonContext.appearance) === 'default';
    var appearance = isDefaultAppearanceSplitButton ? 'subtle' : propAppearance || (splitButtonContext === null || splitButtonContext === void 0 ? void 0 : splitButtonContext.appearance) || 'default';
    var spacing = (splitButtonContext === null || splitButtonContext === void 0 ? void 0 : splitButtonContext.spacing) || propSpacing;
    var isDisabled = (splitButtonContext === null || splitButtonContext === void 0 ? void 0 : splitButtonContext.isDisabled) || propIsDisabled;
    var isInteractive = !isDisabled && !isLoading;
    // Also treat loading buttons as disabled
    var isEffectivelyDisabled = isDisabled || isLoading;
    var isSelected = propIsSelected && !isDisabled;
    (0, $ex2NY.default)(localRef, autoFocus);
    // @ts-expect-error
    var _className = unsafeRest.className, _css = unsafeRest.css, _as = unsafeRest.as, _style = unsafeRest.style, saferRest = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(unsafeRest, $be2cf37359aba078$var$_excluded2);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $i7OzP.default), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, saferRest, {
        componentName: componentName || 'button',
        analyticsContext: analyticsContext,
        role: role,
        ref: (0, $kPZLD.default)([
            localRef,
            ref
        ]),
        xcss: (0, $hRJ5R.cx)($be2cf37359aba078$var$styles.base, (0, $5VFxW.fg)('platform-dst-shape-theme-default') && $be2cf37359aba078$var$styles.baseT26Shape, appearance === 'default' && $be2cf37359aba078$var$defaultStyles.root, appearance === 'default' && isInteractive && $be2cf37359aba078$var$defaultStyles.interactive, appearance === 'primary' && $be2cf37359aba078$var$primaryStyles.root, appearance === 'primary' && isInteractive && $be2cf37359aba078$var$primaryStyles.interactive, appearance === 'rovo' && $be2cf37359aba078$var$rovoStyles.root, appearance === 'rovo' && isInteractive && $be2cf37359aba078$var$rovoStyles.interactive, appearance === 'warning' && $be2cf37359aba078$var$warningStyles.root, appearance === 'warning' && isInteractive && $be2cf37359aba078$var$warningStyles.interactive, appearance === 'danger' && $be2cf37359aba078$var$dangerStyles.root, appearance === 'danger' && isInteractive && $be2cf37359aba078$var$dangerStyles.interactive, appearance === 'discovery' && $be2cf37359aba078$var$discoveryStyles.root, appearance === 'discovery' && isInteractive && $be2cf37359aba078$var$discoveryStyles.interactive, appearance === 'subtle' && $be2cf37359aba078$var$subtleStyles.root, appearance === 'subtle' && isInteractive && $be2cf37359aba078$var$subtleStyles.interactive, $be2cf37359aba078$var$styles.linkDecorationUnset, isSelected && $be2cf37359aba078$var$selectedStyles.root, isSelected && isSplitButton && $be2cf37359aba078$var$selectedStyles.insideSplitButton, isSelected && isInteractive && $be2cf37359aba078$var$selectedStyles.interactive, // TODO: remove me once we kill color fallbacks
        isSelected && appearance === 'danger' && $be2cf37359aba078$var$selectedStyles.danger, // TODO: remove me once we kill color fallbacks
        isSelected && appearance === 'warning' && $be2cf37359aba078$var$selectedStyles.warning, // TODO: remove me once we kill color fallbacks
        isSelected && appearance === 'discovery' && $be2cf37359aba078$var$selectedStyles.discovery, isDisabled && $be2cf37359aba078$var$styles.disabled, isDisabled && appearance !== 'default' && appearance !== 'subtle' && $be2cf37359aba078$var$styles.sharedDisabled, isDisabled && appearance === 'default' && $be2cf37359aba078$var$defaultStyles.disabled, spacing === 'compact' && $be2cf37359aba078$var$styles.spacingCompact, spacing === 'compact' && (0, $5VFxW.fg)('platform-dst-shape-theme-default') && $be2cf37359aba078$var$styles.spacingCompactT26Shape, // This must come after spacing compact styling as it overrides the border radius
        isCircle && !isSplitButton && $be2cf37359aba078$var$styles.circle, shouldFitContainer && $be2cf37359aba078$var$styles.fullWidth, hasIconBefore && $be2cf37359aba078$var$styles.buttonIconBefore, hasIconAfter && $be2cf37359aba078$var$styles.buttonIconAfter, isIconButton && $be2cf37359aba078$var$styles.iconButton, isIconButton && spacing === 'compact' && $be2cf37359aba078$var$styles.iconButtonCompact, isLoading && $be2cf37359aba078$var$styles.loading, isSplitButton && $be2cf37359aba078$var$styles.splitButton, isNavigationSplitButton && $be2cf37359aba078$var$styles.navigationSplitButton),
        isDisabled: (0, $5VFxW.fg)('platform-dst_fix_not_focusable_loading_button') ? isDisabled : isEffectivelyDisabled
    }, (0, $5VFxW.fg)('platform-dst_fix_not_focusable_loading_button') && {
        'aria-live': 'polite'
    }, isLoading && (0, $5VFxW.fg)('platform-dst_fix_not_focusable_loading_button') && {
        'aria-disabled': true
    }, {
        "aria-label": isLoading && ariaLabel && !ariaLabelledBy ? "".concat(ariaLabel, " ").concat($be2cf37359aba078$var$LOADING_LABEL) : ariaLabel,
        "aria-labelledby": isLoading && ariaLabelledBy ? "".concat(ariaLabelledBy, " ").concat(loadingLabelId) : ariaLabelledBy,
        onClick: onClick
    }, (0, $41VGH.default)(isEffectivelyDisabled, {
        onMouseDownCapture: onMouseDownCapture,
        onMouseUpCapture: onMouseUpCapture,
        onKeyDownCapture: onKeyDownCapture,
        onKeyUpCapture: onKeyUpCapture,
        onTouchStartCapture: onTouchStartCapture,
        onTouchEndCapture: onTouchEndCapture,
        onPointerDownCapture: onPointerDownCapture,
        onPointerUpCapture: onPointerUpCapture,
        onClickCapture: onClickCapture
    }), {
        testId: testId,
        onMouseOver: onMouseOver,
        onFocus: onFocus,
        onMouseMove: onMouseMove,
        onBlur: onBlur,
        type: type,
        interactionName: interactionName,
        onMouseDown: onMouseDown,
        onMouseUp: onMouseUp,
        onKeyDown: onKeyDown,
        onMouseOut: onMouseOut,
        onKeyUp: onKeyUp,
        onTouchStart: onTouchStart,
        onTouchEnd: onTouchEnd,
        onPointerDown: onPointerDown,
        onPointerUp: onPointerUp
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $i7AhG.SplitButtonContext).Provider, {
        value: undefined
    }, children, isLoading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("span", {
        className: (0, $hUbY6.default)([
            $be2cf37359aba078$var$styles.loadingOverlay
        ])
    }, (0, $dPyVN.default)({
        spacing: spacing,
        appearance: appearance,
        isDisabled: isDisabled,
        isSelected: isSelected,
        testId: testId
    })), isLoading && (ariaLabelledBy || !ariaLabel) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $cd86S.default), {
        id: loadingLabelId
    }, $be2cf37359aba078$var$LOADING_LABEL)));
});
var $be2cf37359aba078$export$2e2bcd8739ae039 = $be2cf37359aba078$var$ButtonBase;

});
parcelRegister("hRJ5R", function(module, exports) {
$parcel$export(module.exports, "cx", () => $d01a5d8bb96c5a7e$export$a274e22fb40f762e);
/* index.tsx generated by @compiled/babel-plugin v0.39.1 */ parcelRequire("5FkrB");


var $aRY7O = parcelRequire("aRY7O");
var $d01a5d8bb96c5a7e$var$strictApi = (0, $aRY7O.createStrictAPI)();
var $d01a5d8bb96c5a7e$export$dbf350e5966cf602 = $d01a5d8bb96c5a7e$var$strictApi.css;
var $d01a5d8bb96c5a7e$export$eb1ecd84a24ee424 = $d01a5d8bb96c5a7e$var$strictApi.cssMap;
$d01a5d8bb96c5a7e$var$strictApi.cssMap;
var $d01a5d8bb96c5a7e$export$a274e22fb40f762e = $d01a5d8bb96c5a7e$var$strictApi.cx;
var $d01a5d8bb96c5a7e$var$XCSSProp = $d01a5d8bb96c5a7e$var$strictApi.XCSSProp; // This is to mitigate local TS error TS2315: Type 'StrictXCSSProp' is not generic.
 // Currently for some reason tsc is generating malformed .d.ts in local dev environment, below change fixes it
 /**
 * ## StrictXCSSProp
 *
 * Declare styles your component takes with all other styles marked as violations
 * by the TypeScript compiler. There are two primary use cases for xcss prop:
 *
 * - safe style overrides
 * - inverting style declarations
 *
 * Interverting style declarations is interesting for platform teams as
 * it means apps only pay for styles they use as they're now the ones who declare
 * the styles!
 *
 * The {@link StrictXCSSProp} type has generics two of which must be defined — use to explicitly
 * set what you want to maintain as API. Use {@link XCSSAllProperties} and {@link XCSSAllPseudos}
 * to enable all properties and pseudos.
 *
 * The third generic is used to declare what properties and pseudos should be required.
 *
 * ```tsx
 * interface MyComponentProps {
 *   // Color is accepted, all other properties / pseudos are considered violations.
 *   xcss?: StrictXCSSProp<'color', never>;
 *
 *   // Only background color and hover pseudo are accepted.
 *   xcss?: StrictXCSSProp<'backgroundColor', '&:hover'>;
 *
 *   // All properties are accepted, all pseudos are considered violations.
 *   xcss?: StrictXCSSProp<XCSSAllProperties, never>;
 *
 *   // All properties are accepted, only the hover pseudo is accepted.
 *   xcss?: StrictXCSSProp<XCSSAllProperties, '&:hover'>;
 *
 *   // The xcss prop is required as well as the color property. No pseudos are required.
 *   xcss: StrictXCSSProp<
 *     XCSSAllProperties,
 *     '&:hover',
 *     { requiredProperties: 'color', requiredPseudos: never }
 *   >;
 * }
 *
 * function MyComponent({ xcss }: MyComponentProps) {
 *   return <div css={{ color: 'var(--ds-text-danger)' }} className={xcss} />
 * }
 * ```
 *
 * The xcss prop works with static inline objects and the [cssMap](https://compiledcssinjs.com/docs/api-cssmap) API.
 *
 * ```jsx
 * // Declared as an inline object
 * <Component xcss={{ color: 'var(--ds-text)' }} />
 *
 * // Declared with the cssMap API
 * const styles = cssMap({ text: { color: 'var(--ds-text)' } });
 * <Component xcss={styles.text} />
 * ```
 *
 * To concatenate and conditonally apply styles use the {@link cssMap} and {@link cx} functions.
 */ 

});
parcelRegister("aRY7O", function(module, exports) {
$parcel$export(module.exports, "createStrictAPI", () => $7e9d7e34cc35a4c9$export$39716b4af53f4ad);

var $egZCV = parcelRequire("egZCV");

var $bEJv0 = parcelRequire("bEJv0");
function $7e9d7e34cc35a4c9$export$39716b4af53f4ad() {
    return {
        css () {
            throw (0, $egZCV.createStrictSetupError)();
        },
        cssMap () {
            throw (0, $egZCV.createStrictSetupError)();
        },
        cx: $bEJv0.cx,
        XCSSProp () {
            throw (0, $egZCV.createStrictSetupError)();
        }
    };
}

});
parcelRegister("egZCV", function(module, exports) {
$parcel$export(module.exports, "createStrictSetupError", () => $a6425d180ce59a8d$export$c4df1cb0c2b4d77c);
const $a6425d180ce59a8d$export$6c9a87045746941d = ()=>{
    return new Error(`
 \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2557}   \u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2557}     \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}
\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}
\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}   \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}  \u{2588}\u{2588}\u{2551}  \u{2588}\u{2588}\u{2551}
\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}   \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}\u{255A}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{255D} \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{255D}  \u{2588}\u{2588}\u{2551}  \u{2588}\u{2588}\u{2551}
\u{255A}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{255A}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551} \u{255A}\u{2550}\u{255D} \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}
 \u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D} \u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D} \u{255A}\u{2550}\u{255D}     \u{255A}\u{2550}\u{255D}\u{255A}\u{2550}\u{255D}     \u{255A}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}

  @compiled/react

  Code was executed when it shouldn't have. This could have happened because:

  1. You haven't configured a transformer yet. Visit https://compiledcssinjs.com/docs/installation and follow the instructions.
  2. You have duplicate versions of React and hooks are blowing up. You need to de-duplicate your dependencies.

  Good luck!
`);
};
const $a6425d180ce59a8d$export$c4df1cb0c2b4d77c = ()=>{
    return new Error(`
 \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2557}   \u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2557}     \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}
\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}
\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}   \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}  \u{2588}\u{2588}\u{2551}  \u{2588}\u{2588}\u{2551}
\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}   \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}\u{255A}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{255D} \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{255D}  \u{2588}\u{2588}\u{2551}  \u{2588}\u{2588}\u{2551}
\u{255A}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{255A}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551} \u{255A}\u{2550}\u{255D} \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}
 \u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D} \u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D} \u{255A}\u{2550}\u{255D}     \u{255A}\u{2550}\u{255D}\u{255A}\u{2550}\u{255D}     \u{255A}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}

  @compiled/react

  Code was executed when it shouldn't have. To resolve make sure to:

  1. Set up Compiled.
  2. Configure importSources in your Compiled config to point to the module that exports the output of createStrictAPI().

  For more information visit https://compiledcssinjs.com/docs/installation and follow the instructions.
`);
};

});

parcelRegister("bEJv0", function(module, exports) {
$parcel$export(module.exports, "cx", () => $87c6b9559fbe227d$export$a274e22fb40f762e);

var $euvZ0 = parcelRequire("euvZ0");
const $87c6b9559fbe227d$export$a274e22fb40f762e = (...styles)=>{
    // At runtime TStyles is resolved down to strings, but not at compile time.
    // We circumvent the type system here because of that.
    const actualStyles = styles;
    // The output should be a union type of passed in styles. This ensures the call
    // site of xcss prop can raise violations when disallowed styles have been passed.
    return (0, $euvZ0.default)(actualStyles);
};

});
parcelRegister("euvZ0", function(module, exports) {
$parcel$export(module.exports, "default", () => $a8ccad2bfc9852c3$export$2e2bcd8739ae039);
/**
 * This length includes the underscore,
 * e.g. `"_1s4A"` would be a valid atomic group hash.
 */ const $a8ccad2bfc9852c3$var$ATOMIC_GROUP_LENGTH = 5;
function $a8ccad2bfc9852c3$export$2e2bcd8739ae039(classNames) {
    // Shortcut: nothing to do
    if (!classNames.length) return;
    // Shortcut: don't need to do anything if we only have a single classname
    if (classNames.length === 1 && classNames[0] && // checking to see if `classNames[0]` is a string that contains other classnames
    !classNames[0].includes(' ')) return classNames[0];
    // Using an object rather than a `Map` as it performed better in our benchmarks.
    // Would be happy to move to `Map` if it proved to be better under real conditions.
    const map = {};
    // Note: using loops to minimize iterations over the collection
    for (const value of classNames){
        // Exclude all falsy values, which leaves us with populated strings
        if (!value) continue;
        // a `value` can contain multiple classnames
        const list = value.split(' ');
        for (const className of list){
            /**
             * For atomic style classnames: the `key` is the `group`
             *
             * - Later atomic classnames with the same `group` will override earlier ones
             *   (which is what we want).
             * - Assumes atomic classnames are the only things that start with `_`
             * - Could use a regex to ensure that atomic classnames are structured how we expect,
             *   but did not add that for now as it did slow things down a bit.
             *
             * For other classnames: the `key` is the whole classname
             * - Okay to remove duplicates as doing so does not impact specificity
             *
             * */ const key = className.startsWith('_') ? className.slice(0, $a8ccad2bfc9852c3$var$ATOMIC_GROUP_LENGTH) : className;
            map[key] = className;
        }
    }
    /**
     * We are converting the `map` into a string.
     *
     * The simple way to do this would be `Object.values(map).join(' ')`.
     * However, the approach below performs 10%-20% better in benchmarks.
     *
     * For `ax()` it feels right to squeeze as much runtime performance out as we can.
     */ let result = '';
    for(const key in map)result += map[key] + ' ';
    // If we have an empty string, then our `map` was empty.
    if (!result) return;
    // remove last " " from the result (we added " " at the end of every value)
    return result.trimEnd();
}

});




parcelRegister("kPZLD", function(module, exports) {
$parcel$export(module.exports, "default", () => $f2b87bc47662a18f$export$2e2bcd8739ae039);

var $ekGgq = parcelRequire("ekGgq");
function $f2b87bc47662a18f$export$2e2bcd8739ae039(refs) {
    return function(value) {
        refs.forEach(function(ref) {
            if (typeof ref === 'function') ref(value);
            else if (ref !== null && (0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(ref) === 'object') ref.current = value;
        });
    };
}

});

parcelRegister("ex2NY", function(module, exports) {
$parcel$export(module.exports, "default", () => $a94652c3703c0329$export$2e2bcd8739ae039);

var $5FkrB = parcelRequire("5FkrB");
function $a94652c3703c0329$export$2e2bcd8739ae039(ref, autoFocus) {
    var initialMount = (0, $5FkrB.useRef)(true);
    (0, $5FkrB.useEffect)(function() {
        if (ref && initialMount.current && autoFocus && ref.current) ref.current.focus();
        initialMount.current = false;
    }, [
        autoFocus,
        ref
    ]);
}

});

parcelRegister("iZD2p", function(module, exports) {
$parcel$export(module.exports, "useId", () => $03917cb81c0553de$export$f680877a34711e37);

var $5FkrB = parcelRequire("5FkrB");
function $03917cb81c0553de$export$f680877a34711e37() {
    // React uses `:` or `«»` in selectors which breaks `document.querySelector(…)`.
    // Replace with `_` to match future React 19 functionality.
    return (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).useId().replace(/[:«»]/g, '_');
}

});

parcelRegister("5VFxW", function(module, exports) {
$parcel$export(module.exports, "fg", () => $451280e2886f519c$export$b40ec24ac8275656);

var $7ijGz = parcelRequire("7ijGz");
function $451280e2886f519c$export$ba05d765b8392e5e(flagResolver) {
    (0, $7ijGz.setBooleanResolver)(flagResolver);
}
function $451280e2886f519c$export$470e5c2be1411c89(name) {
    return (0, $7ijGz.resolveBooleanFlag)(name);
}
function $451280e2886f519c$export$b40ec24ac8275656(name) {
    return (0, $7ijGz.resolveBooleanFlag)(name);
}

});
parcelRegister("7ijGz", function(module, exports) {
$parcel$export(module.exports, "setBooleanResolver", () => $54f97bfdc6a77562$export$f2b591175b3e424c);
$parcel$export(module.exports, "resolveBooleanFlag", () => $54f97bfdc6a77562$export$6333b6aff9fc6275);

var $ISKn7 = parcelRequire("ISKn7");

var $581T2 = parcelRequire("581T2");

var $3ZMUU = parcelRequire("3ZMUU");
var $54f97bfdc6a77562$var$pkgName = '@atlaskit/platform-feature-flags';
var $54f97bfdc6a77562$export$7e41b1b2bdee3f98 = '__PLATFORM_FEATURE_FLAGS__';
var $54f97bfdc6a77562$var$hasProcessEnv = typeof $3ZMUU !== 'undefined' && typeof $3ZMUU.env !== 'undefined';
// FF global overrides can be configured by test runners or Storybook
var $54f97bfdc6a77562$var$ENV_ENABLE_PLATFORM_FF = $54f97bfdc6a77562$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
// STORYBOOK_ENABLE_PLATFORM_FF is included as storybook only allows env vars prefixed with STORYBOOK
// https://github.com/storybookjs/storybook/issues/12270
var $54f97bfdc6a77562$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF = $54f97bfdc6a77562$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
var $54f97bfdc6a77562$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE = $54f97bfdc6a77562$var$ENV_ENABLE_PLATFORM_FF || $54f97bfdc6a77562$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF;
var $54f97bfdc6a77562$var$DEFAULT_PFF_GLOBAL = {
    booleanResolver: undefined
};
var $54f97bfdc6a77562$var$globalVar = typeof window !== 'undefined' ? window : globalThis;
$54f97bfdc6a77562$var$globalVar[$54f97bfdc6a77562$export$7e41b1b2bdee3f98] = $54f97bfdc6a77562$var$globalVar[$54f97bfdc6a77562$export$7e41b1b2bdee3f98] || $54f97bfdc6a77562$var$DEFAULT_PFF_GLOBAL;
function $54f97bfdc6a77562$export$f2b591175b3e424c(resolver) {
    $54f97bfdc6a77562$var$globalVar[$54f97bfdc6a77562$export$7e41b1b2bdee3f98].booleanResolver = resolver;
}
function $54f97bfdc6a77562$export$6333b6aff9fc6275(flagKey) {
    if ($54f97bfdc6a77562$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE) {
        (0, $581T2.debug)('[%s]: The feature flags were enabled while running tests. The flag "%s" will be always enabled.', $54f97bfdc6a77562$var$pkgName, flagKey);
        return true;
    }
    try {
        var _globalVar$PFF_GLOBAL, _globalVar$PFF_GLOBAL2, _globalVar$PFF_GLOBAL3;
        // booleanResolver will be empty for products like Trello, Elevate, Recruit etc.
        // Currently only Confluence, Jira and Bitbucket has set it.
        if (((_globalVar$PFF_GLOBAL = $54f97bfdc6a77562$var$globalVar[$54f97bfdc6a77562$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL === void 0 ? void 0 : _globalVar$PFF_GLOBAL.booleanResolver) === undefined || ((_globalVar$PFF_GLOBAL2 = $54f97bfdc6a77562$var$globalVar[$54f97bfdc6a77562$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL2 === void 0 ? void 0 : _globalVar$PFF_GLOBAL2.booleanResolver) === null) // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
        return (0, $ISKn7.default).checkGate(flagKey);
        var result = (_globalVar$PFF_GLOBAL3 = $54f97bfdc6a77562$var$globalVar[$54f97bfdc6a77562$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL3 === void 0 ? void 0 : _globalVar$PFF_GLOBAL3.booleanResolver(flagKey);
        if (typeof result !== 'boolean') {
            // eslint-disable-next-line no-console
            console.warn("".concat(flagKey, " resolved to a non-boolean value, returning false for safety"));
            return false;
        }
        return result;
    } catch (e) {
        return false;
    }
}

});
parcelRegister("581T2", function(module, exports) {
$parcel$export(module.exports, "debug", () => $3bbf29c565014acf$export$1c9f709888824e05);
var $3bbf29c565014acf$var$_process, $3bbf29c565014acf$var$_process2;
// We can't rely on NODE_ENV === 'test' if its value is already configured by the consumer to some other value, so better to use JEST_WORKER_ID
// https://jestjs.io/docs/environment-variables#jest_worker_id
var $3bbf29c565014acf$var$TESTS_MODE = (globalThis === null || globalThis === void 0 || ($3bbf29c565014acf$var$_process = globalThis.process) === null || $3bbf29c565014acf$var$_process === void 0 || ($3bbf29c565014acf$var$_process = $3bbf29c565014acf$var$_process.env) === null || $3bbf29c565014acf$var$_process === void 0 ? void 0 : $3bbf29c565014acf$var$_process.JEST_WORKER_ID) !== undefined;
var $3bbf29c565014acf$var$DEBUG_MODE = !$3bbf29c565014acf$var$TESTS_MODE && (globalThis === null || globalThis === void 0 || ($3bbf29c565014acf$var$_process2 = globalThis.process) === null || $3bbf29c565014acf$var$_process2 === void 0 || ($3bbf29c565014acf$var$_process2 = $3bbf29c565014acf$var$_process2.env) === null || $3bbf29c565014acf$var$_process2 === void 0 ? void 0 : $3bbf29c565014acf$var$_process2.NODE_ENV) !== 'production';
var $3bbf29c565014acf$export$1c9f709888824e05 = function debug() {
    var _console;
    if (!$3bbf29c565014acf$var$DEBUG_MODE) return;
    // eslint-disable-next-line no-console
    (_console = console).debug.apply(_console, arguments);
};

});



parcelRegister("i7OzP", function(module, exports) {
$parcel$export(module.exports, "default", () => $d3201cf5776e547b$export$2e2bcd8739ae039);
/* pressable.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $kqp0i = parcelRequire("kqp0i");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");


var $aSjKL = parcelRequire("aSjKL");

var $aLEtb = parcelRequire("aLEtb");

var $agHcJ = parcelRequire("agHcJ");

var $4NddD = parcelRequire("4NddD");

var $1thDS = parcelRequire("1thDS");

var $bprqj = parcelRequire("bprqj");
var $d3201cf5776e547b$var$_excluded = [
    "children",
    "isDisabled",
    "type",
    "onClick",
    "interactionName",
    "componentName",
    "analyticsContext",
    "style",
    "testId",
    "xcss",
    "tabIndex"
], $d3201cf5776e547b$var$_excluded2 = [
    "className"
];
var $d3201cf5776e547b$var$styles = {
    root: "_19itglyw _vchhusvi _r06hglyw _80omtlke",
    disabled: "_80om13gf"
};
/**
 * __Pressable__
 *
 * A primitive for building custom buttons.
 *
 * - [Examples](https://atlassian.design/components/primitives/pressable/examples)
 * - [Code](https://atlassian.design/components/primitives/pressable/code)
 * - [Usage](https://atlassian.design/components/primitives/pressable/usage)
 */ var $d3201cf5776e547b$var$Pressable = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function(_ref, ref) {
    var children = _ref.children, isDisabled = _ref.isDisabled, _ref$type = _ref.type, type = _ref$type === void 0 ? 'button' : _ref$type, _ref$onClick = _ref.onClick, providedOnClick = _ref$onClick === void 0 ? (0, $4NddD.default) : _ref$onClick, interactionName = _ref.interactionName, componentName = _ref.componentName, analyticsContext = _ref.analyticsContext, style = _ref.style, testId = _ref.testId, xcss = _ref.xcss, tabIndex = _ref.tabIndex, htmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $d3201cf5776e547b$var$_excluded);
    var interactionContext = (0, $5FkrB.useContext)((0, $1thDS.default));
    var handleClick = (0, $5FkrB.useCallback)(function(e, analyticsEvent) {
        interactionContext && interactionContext.tracePress(interactionName, e.timeStamp);
        providedOnClick(e, analyticsEvent);
    }, [
        providedOnClick,
        interactionContext,
        interactionName
    ]);
    var onClick = (0, $aLEtb.usePlatformLeafEventHandler)({
        fn: handleClick,
        action: 'clicked',
        componentName: componentName || 'Pressable',
        packageName: "@atlaskit/primitives",
        packageVersion: "19.0.2",
        analyticsData: analyticsContext,
        actionSubject: 'button'
    });
    // This is to remove className from safeHtmlAttributes
    // @ts-expect-error className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(htmlAttributes, $d3201cf5776e547b$var$_excluded2);
    return /*#__PURE__*/ $5FkrB.createElement((0, $bprqj.default), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        as: "button",
        tabIndex: tabIndex !== null && tabIndex !== void 0 ? tabIndex : (0, $agHcJ.isSafari)() && !isDisabled ? 0 : undefined,
        style: style
    }, safeHtmlAttributes, {
        type: type,
        onClick: onClick,
        disabled: isDisabled,
        xcss: (0, $aSjKL.cx)($d3201cf5776e547b$var$styles.root, isDisabled && $d3201cf5776e547b$var$styles.disabled, xcss),
        testId: testId,
        ref: ref
    }), children);
});
var $d3201cf5776e547b$export$2e2bcd8739ae039 = $d3201cf5776e547b$var$Pressable;

});
parcelRegister("aSjKL", function(module, exports) {
$parcel$export(module.exports, "cx", () => $7eae4518380c9412$export$a274e22fb40f762e);

var $hUbY6 = parcelRequire("hUbY6");
const $7eae4518380c9412$export$a274e22fb40f762e = (...styles)=>{
    // At runtime TStyles is resolved down to strings, but not at compile time.
    // We circumvent the type system here because of that.
    const actualStyles = styles;
    // The output should be a union type of passed in styles. This ensures the call
    // site of xcss prop can raise violations when disallowed styles have been passed.
    return (0, $hUbY6.default)(actualStyles);
};

});

parcelRegister("aLEtb", function(module, exports) {
$parcel$export(module.exports, "usePlatformLeafEventHandler", () => $7d6daf9bcf6c0b57$export$a4687b0234b40e28);

var $25nEq = parcelRequire("25nEq");

var $5FkrB = parcelRequire("5FkrB");

var $bDUuG = parcelRequire("bDUuG");

var $cqQpq = parcelRequire("cqQpq");
function $7d6daf9bcf6c0b57$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $7d6daf9bcf6c0b57$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $7d6daf9bcf6c0b57$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $7d6daf9bcf6c0b57$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $7d6daf9bcf6c0b57$export$a4687b0234b40e28(_ref) {
    var fn = _ref.fn, action = _ref.action, componentName = _ref.componentName, actionSubject = _ref.actionSubject, packageName = _ref.packageName, packageVersion = _ref.packageVersion, analyticsData = _ref.analyticsData;
    var _useAnalyticsEvents = (0, $bDUuG.useAnalyticsEvents)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
    // We put analyticsData and fn in a ref so that we don't need to break
    // memoization.
    // Generally these could be defined by consumers inline
    // and so we do this to avoid breaking memoization of useCallback
    var dataRef = (0, $cqQpq.useTrackedRef)(analyticsData);
    var fnRef = (0, $cqQpq.useTrackedRef)(fn);
    var handler = (0, $5FkrB.useCallback)(function(value) {
        var analyticsEvent = createAnalyticsEvent({
            action: action,
            actionSubject: actionSubject || componentName,
            attributes: {
                componentName: componentName,
                packageName: packageName,
                packageVersion: packageVersion
            }
        });
        // To avoid wrapping this component in AnalyticsContext we manually
        // push the parent context's meta data into the context.
        // Note: this new 'context'
        var context = $7d6daf9bcf6c0b57$var$_objectSpread({
            componentName: componentName,
            packageName: packageName,
            packageVersion: packageVersion
        }, dataRef.current);
        analyticsEvent.context.push(context);
        // fire an event on the atlaskit channel
        var clone = analyticsEvent.clone();
        if (clone) clone.fire('atlaskit');
        fnRef.current(value, analyticsEvent);
    }, [
        // These are strings and won't change
        action,
        componentName,
        actionSubject,
        packageName,
        packageVersion,
        // This function is memoized in the context
        createAnalyticsEvent,
        // these are a stable ref because of the useTrackedRef hook
        dataRef,
        fnRef
    ]);
    return handler;
}

});
parcelRegister("bDUuG", function(module, exports) {
$parcel$export(module.exports, "useAnalyticsEvents", () => $879f28ba40c47674$export$5bf35293e545f20c);

var $dLGML = parcelRequire("dLGML");

var $TNyZj = parcelRequire("TNyZj");

var $509QN = parcelRequire("509QN");
function $879f28ba40c47674$export$5bf35293e545f20c() {
    var analyticsContext = (0, $509QN.useAnalyticsContext)();
    var createAnalyticsEvent = (0, $dLGML.useCallbackOne)(function(payload) {
        return new (0, $TNyZj.default)({
            context: analyticsContext.getAtlaskitAnalyticsContext(),
            handlers: analyticsContext.getAtlaskitAnalyticsEventHandlers(),
            payload: payload
        });
    }, [
        analyticsContext
    ]);
    return {
        createAnalyticsEvent: createAnalyticsEvent
    };
}

});
parcelRegister("TNyZj", function(module, exports) {
$parcel$export(module.exports, "default", () => $0a7b95699500e142$export$2e2bcd8739ae039);

var $fC8ib = parcelRequire("fC8ib");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $kIXpt = parcelRequire("kIXpt");

var $cYPzS = parcelRequire("cYPzS");

var $lwlXp = parcelRequire("lwlXp");

var $eyuDe = parcelRequire("eyuDe");

var $25nEq = parcelRequire("25nEq");

var $b9YAn = parcelRequire("b9YAn");
function $0a7b95699500e142$var$_callSuper(t, o, e) {
    return o = (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(o), (0, (/*@__PURE__*/$parcel$interopDefault($kIXpt)))(t, $0a7b95699500e142$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(t).constructor) : o.apply(t, e));
}
function $0a7b95699500e142$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($0a7b95699500e142$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $0a7b95699500e142$var$_superPropGet(t, o, e, r) {
    var p = (0, (/*@__PURE__*/$parcel$interopDefault($lwlXp)))((0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(1 & r ? t.prototype : t), o, e);
    return 2 & r && "function" == typeof p ? function(t) {
        return p.apply(e, t);
    } : p;
}
var $0a7b95699500e142$export$35f8383928ba8d7 = function isUIAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $0a7b95699500e142$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isUIAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === 'UIAnalyticsEvent';
};
var $0a7b95699500e142$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_AnalyticsEvent) {
    function UIAnalyticsEvent(props) {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, UIAnalyticsEvent);
        _this = $0a7b95699500e142$var$_callSuper(this, UIAnalyticsEvent, [
            props
        ]);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "_isUIAnalyticsEvent", true);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "clone", function() {
            if (_this.hasFired) return null;
            var context = (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(_this.context);
            var handlers = (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(_this.handlers);
            /**
       * A hacky "deep clone" of the object. This is limited in that it wont
       * support functions, regexs, Maps, Sets, etc, but none of those need to
       * be represented in our payload.
       */ var payload = JSON.parse(JSON.stringify(_this.payload));
            return new UIAnalyticsEvent({
                context: context,
                handlers: handlers,
                payload: payload
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "fire", function(channel) {
            if (_this.hasFired) return;
            _this.handlers.forEach(function(handler) {
                try {
                    handler(_this, channel);
                } catch (e) {}
            });
            _this.hasFired = true;
        });
        _this.context = props.context || [];
        _this.handlers = props.handlers || [];
        _this.hasFired = false;
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($eyuDe)))(UIAnalyticsEvent, _AnalyticsEvent);
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(UIAnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (this.hasFired) return this;
                return $0a7b95699500e142$var$_superPropGet(UIAnalyticsEvent, "update", this, 3)([
                    updater
                ]);
            }
        }
    ]);
}((0, $b9YAn.default));

});
parcelRegister("b9YAn", function(module, exports) {
$parcel$export(module.exports, "default", () => $81ff880d8cb76a60$export$2e2bcd8739ae039);

var $ekGgq = parcelRequire("ekGgq");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $25nEq = parcelRequire("25nEq");
function $81ff880d8cb76a60$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $81ff880d8cb76a60$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $81ff880d8cb76a60$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $81ff880d8cb76a60$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $81ff880d8cb76a60$export$ad4be5c2ec28cecf = function isAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $81ff880d8cb76a60$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === 'AnalyticsEvent';
};
var $81ff880d8cb76a60$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function AnalyticsEvent(props) {
        var _this = this;
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, AnalyticsEvent);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "_isAnalyticsEvent", true);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "clone", function() {
            // just a shallow clone, don't change sub refs unless you want to
            // affect the original's too
            var payload = $81ff880d8cb76a60$var$_objectSpread({}, _this.payload);
            return new AnalyticsEvent({
                payload: payload
            });
        });
        this.payload = props.payload;
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(AnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (typeof updater === 'function') this.payload = updater(this.payload);
                if ((0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(updater) === 'object') this.payload = $81ff880d8cb76a60$var$_objectSpread($81ff880d8cb76a60$var$_objectSpread({}, this.payload), updater);
                return this;
            }
        }
    ]);
}();

});


parcelRegister("509QN", function(module, exports) {
$parcel$export(module.exports, "useAnalyticsContext", () => $3a4497eea280292e$export$d1f587f82ad51c4);

var $5FkrB = parcelRequire("5FkrB");

var $iyyOp = parcelRequire("iyyOp");
var $3a4497eea280292e$export$d1f587f82ad51c4 = function useAnalyticsContext() {
    return (0, $5FkrB.useContext)((0, $iyyOp.default));
};

});


parcelRegister("cqQpq", function(module, exports) {
$parcel$export(module.exports, "useTrackedRef", () => $90d091140a6cc984$export$1d27a74659855e44);

var $5FkrB = parcelRequire("5FkrB");
var $90d091140a6cc984$export$1d27a74659855e44 = function useTrackedRef(value) {
    var ref = (0, $5FkrB.useRef)(value);
    ref.current = value;
    return ref;
};

});


parcelRegister("agHcJ", function(module, exports) {
$parcel$export(module.exports, "isSafari", () => $779ce982da0ea6fe$export$95df08bae54cb4df);
function $779ce982da0ea6fe$export$95df08bae54cb4df() {
    if (typeof window !== 'undefined' && window.navigator != null) {
        var _window$navigator$use;
        var ua = (_window$navigator$use = window.navigator.userAgent) === null || _window$navigator$use === void 0 ? void 0 : _window$navigator$use.toLowerCase();
        return ua ? ua.includes('safari') && !ua.includes('chrome') : false;
    }
    return false;
}

});

parcelRegister("4NddD", function(module, exports) {
$parcel$export(module.exports, "default", () => $37d5fe06ef692496$export$2e2bcd8739ae039);
/**
 * An empty function which does nothing.
 */ function $37d5fe06ef692496$export$2e2bcd8739ae039() {}

});

parcelRegister("1thDS", function(module, exports) {
$parcel$export(module.exports, "default", () => $11262f402699be05$export$2e2bcd8739ae039);

var $5FkrB = parcelRequire("5FkrB");
var $11262f402699be05$var$interactionContext = /*#__PURE__*/ (0, $5FkrB.createContext)(null);
var $11262f402699be05$export$2e2bcd8739ae039 = $11262f402699be05$var$interactionContext;

});

parcelRegister("bprqj", function(module, exports) {
$parcel$export(module.exports, "default", () => $84e74d390599c16f$export$2e2bcd8739ae039);
/* focusable.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $kqp0i = parcelRequire("kqp0i");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");

var $hUbY6 = parcelRequire("hUbY6");
var $84e74d390599c16f$var$_excluded = [
    "as",
    "children",
    "isInset",
    "testId",
    "style",
    "xcss"
], $84e74d390599c16f$var$_excluded2 = [
    "className"
];
var $84e74d390599c16f$var$focusRingStyles = null;
var $84e74d390599c16f$var$insetFocusRingStyles = null;
/**
 * __Focus ring__
 *
 * A focus ring visually indicates the currently focused item.
 *
 */ var $84e74d390599c16f$var$Focusable = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? 'button' : _ref$as, children = _ref.children, isInset = _ref.isInset, testId = _ref.testId, style = _ref.style, xcss = _ref.xcss, htmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $84e74d390599c16f$var$_excluded);
    // This is to remove className from safeHtmlAttributes
    // @ts-ignore -- not using expect since it causes issues with help-center local consumption - className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(htmlAttributes, $84e74d390599c16f$var$_excluded2);
    return /*#__PURE__*/ $5FkrB.createElement(Component, (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, safeHtmlAttributes, {
        // @ts-ignore Expression produces a union type that is too complex to represent. We may be able to narrow the type here but unsure.
        ref: ref,
        className: (0, $hUbY6.default)([
            "_ymio1r31 _ypr0glyw _zcxs1o36 _mizu194a _1ah3dkaa _ra3xnqa1 _128mdkaa _1cvmnqa1 _4davt94y",
            isInset && "_1ah31gjf _2mwq1gjf",
            xcss
        ]),
        style: style,
        "data-testid": testId
    }), children);
});
var $84e74d390599c16f$export$2e2bcd8739ae039 = $84e74d390599c16f$var$Focusable;

});


parcelRegister("cd86S", function(module, exports) {
$parcel$export(module.exports, "default", () => $8e3cfd607f3880af$export$2e2bcd8739ae039);
/* visually-hidden.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $5FkrB = parcelRequire("5FkrB");

var $hUbY6 = parcelRequire("hUbY6");
var $8e3cfd607f3880af$var$visuallyHiddenStyles = null;
/**
 * __Visually hidden__
 *
 * A composable element to apply a visually hidden effect to children.
 * Useful for accessibility compliance.
 *
 * @example
 * ```jsx
 * import VisuallyHidden from '@atlaskit/visually-hidden';
 *
 * export default () => (
 *   <div style={{ border: '1px solid black' }}>
 *      There is text hidden between the brackets [
 *      <VisuallyHidden>Can't see me!</VisuallyHidden>]
 *   </div>
 * );
 * ```
 */ var $8e3cfd607f3880af$var$VisuallyHidden = function VisuallyHidden(_ref) {
    var children = _ref.children, testId = _ref.testId, role = _ref.role, id = _ref.id;
    return /*#__PURE__*/ $5FkrB.createElement("span", {
        id: id,
        "data-testid": testId,
        role: role,
        className: (0, $hUbY6.default)([
            "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19itidpf _1reo15vq _18m915vq _1bsbt94y _4t3it94y _kqswstnw _ogto7mnp _uiztglyw _o5721q9c"
        ])
    }, children);
};
$8e3cfd607f3880af$var$VisuallyHidden.displayName = 'VisuallyHidden';
var $8e3cfd607f3880af$export$2e2bcd8739ae039 = $8e3cfd607f3880af$var$VisuallyHidden;

});

parcelRegister("i7AhG", function(module, exports) {
$parcel$export(module.exports, "SplitButtonContext", () => $d31506bed00c6aec$export$4b86304b2c0d7e71);
/* eslint-disable @repo/internal/react/require-jsdoc */ 
var $5FkrB = parcelRequire("5FkrB");
var $d31506bed00c6aec$export$4b86304b2c0d7e71 = /*#__PURE__*/ (0, $5FkrB.createContext)(undefined);

});

parcelRegister("gghZe", function(module, exports) {
$parcel$export(module.exports, "useSplitButtonContext", () => $bd6c17b97b1812f8$export$47e2c6fdb142d947);

var $5FkrB = parcelRequire("5FkrB");

var $i7AhG = parcelRequire("i7AhG");
var $bd6c17b97b1812f8$export$47e2c6fdb142d947 = function useSplitButtonContext() {
    var context = (0, $5FkrB.useContext)((0, $i7AhG.SplitButtonContext));
    if (!context) return undefined;
    if (context.appearance === 'navigation') {
        var newContext = {
            spacing: 'default',
            appearance: 'subtle',
            isDisabled: false,
            isActiveOverSelected: false,
            isNavigationSplitButton: true,
            isHighlighted: context.isHighlighted
        };
        return newContext;
    }
    var splitButtonContext = {
        spacing: context.spacing,
        appearance: context.appearance,
        isDisabled: context.isDisabled,
        isActiveOverSelected: true,
        isNavigationSplitButton: false,
        isHighlighted: false
    };
    return splitButtonContext;
};

});

parcelRegister("41VGH", function(module, exports) {
$parcel$export(module.exports, "default", () => $2ef400f9db25a66d$export$2e2bcd8739ae039);
function $2ef400f9db25a66d$var$abort(event) {
    event.preventDefault();
    event.stopPropagation();
}
var $2ef400f9db25a66d$var$tabKeyCode = 9;
function $2ef400f9db25a66d$var$onKey(event) {
    // Allowing tab so that a user can move focus away
    if (event.keyCode === $2ef400f9db25a66d$var$tabKeyCode) return;
    $2ef400f9db25a66d$var$abort(event);
}
function $2ef400f9db25a66d$export$2e2bcd8739ae039(shouldBlockEvents, events) {
    return shouldBlockEvents ? {
        onMouseDownCapture: $2ef400f9db25a66d$var$abort,
        onMouseUpCapture: $2ef400f9db25a66d$var$abort,
        onKeyDownCapture: $2ef400f9db25a66d$var$onKey,
        onKeyUpCapture: $2ef400f9db25a66d$var$onKey,
        onTouchStartCapture: $2ef400f9db25a66d$var$abort,
        onTouchEndCapture: $2ef400f9db25a66d$var$abort,
        onPointerDownCapture: $2ef400f9db25a66d$var$abort,
        onPointerUpCapture: $2ef400f9db25a66d$var$abort,
        onClickCapture: $2ef400f9db25a66d$var$abort,
        // Just smashing the existing onClick for good measure
        onClick: $2ef400f9db25a66d$var$abort
    } : events;
}

});

parcelRegister("dPyVN", function(module, exports) {
$parcel$export(module.exports, "default", () => $a11b2268785d8bde$export$2e2bcd8739ae039);

var $5FkrB = parcelRequire("5FkrB");

var $21uJw = parcelRequire("21uJw");
function $a11b2268785d8bde$var$getIconSpacing(spacing) {
    switch(spacing){
        case 'compact':
            return 'small';
        default:
            return 'medium';
    }
}
function $a11b2268785d8bde$var$getSpinnerAppearance(_ref) {
    var appearance = _ref.appearance, isDisabled = _ref.isDisabled, isSelected = _ref.isSelected;
    if (isDisabled || isSelected) return 'inherit';
    if (appearance === 'primary' || appearance === 'rovo' || appearance === 'danger' || appearance === 'discovery') return 'invert';
    return 'inherit';
}
function $a11b2268785d8bde$export$2e2bcd8739ae039(_ref2) {
    var appearance = _ref2.appearance, spacing = _ref2.spacing, isDisabled = _ref2.isDisabled, isSelected = _ref2.isSelected, testId = _ref2.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $21uJw.default), {
        size: $a11b2268785d8bde$var$getIconSpacing(spacing),
        appearance: $a11b2268785d8bde$var$getSpinnerAppearance({
            appearance: appearance,
            isDisabled: isDisabled,
            isSelected: isSelected
        }),
        testId: testId ? "".concat(testId, "--loading-spinner") : undefined
    });
}

});
parcelRegister("21uJw", function(module, exports) {
$parcel$export(module.exports, "default", () => $179383c4479cf8b7$export$2e2bcd8739ae039);
/* spinner.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $hUbY6 = parcelRequire("hUbY6");

var $5FkrB = parcelRequire("5FkrB");

var $1thDS = parcelRequire("1thDS");

var $2USpa = parcelRequire("2USpa");
/**
 * Returns the appropriate circle stroke color.
 */ function $179383c4479cf8b7$var$getStrokeColor(appearance) {
    return appearance === 'inherit' ? "var(--ds-icon-subtle, #505258)" : "var(--ds-icon-inverse, #FFFFFF)";
}
var $179383c4479cf8b7$var$rotate = null;
/**
 * There are three parts to the load in animation:
 * 1. Accelerated spin
 * 2. Stretch the spinner line
 */ var $179383c4479cf8b7$var$loadIn = null;
var $179383c4479cf8b7$var$styles = {
    rotateStyles: "_j7hqsf8s _5sag12kz _tip812c5 _1pgl2qsq _8hrz1h6o",
    loadInStyles: "_j7hq1ky6 _5sag9cwz _1pgl1ytf _1o51q7pw",
    wrapperStyles: "_1e0c116y _s7n4nkob",
    circleStyles: "_lswuglyw _7ljx1dhp _1snbbs82 _jcxd7g3v _1tjm1onz"
};
/**
 * `useLayoutEffect` is being used in SSR safe form. On the server, this work doesn’t need to run.
 * `useEffect` is used in-place, because `useEffect` is not run on the server and it matches types
 * which makes things simpler than doing an `isServer` check or a `null` check.
 *
 * @see https://hello.atlassian.net/wiki/spaces/DST/pages/2081696628/DSTDACI-010+-+Interaction+Tracing+hooks+in+DS+components
 */ var $179383c4479cf8b7$var$useLayoutEffect = typeof window === 'undefined' ? (0, $5FkrB.useEffect) : (0, $5FkrB.useLayoutEffect);
/**
 * __Spinner__
 *
 * A spinner is an animated spinning icon that lets users know content is being loaded.
 *
 * - [Examples](https://atlassian.design/components/spinner/examples)
 * - [Code](https://atlassian.design/components/spinner/code)
 * - [Usage](https://atlassian.design/components/spinner/usage)
 */ var $179383c4479cf8b7$var$Spinner = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).forwardRef(function Spinner(_ref, ref) {
    var _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'inherit' : _ref$appearance, _ref$delay = _ref.delay, delay = _ref$delay === void 0 ? 0 : _ref$delay, interactionName = _ref.interactionName, label = _ref.label, _ref$size = _ref.size, providedSize = _ref$size === void 0 ? 'medium' : _ref$size, testId = _ref.testId;
    var size = typeof providedSize === 'number' ? providedSize : (0, $2USpa.presetSizes)[providedSize];
    var animationDelay = "".concat(delay, "ms");
    var stroke = $179383c4479cf8b7$var$getStrokeColor(appearance);
    var context = (0, $5FkrB.useContext)((0, $1thDS.default));
    $179383c4479cf8b7$var$useLayoutEffect(function() {
        if (context != null) return context.hold(interactionName);
    }, [
        context,
        interactionName
    ]);
    /**
   * The Spinner animation uses a combination of two
   * css animations on two separate elements.
   */ return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("span", {
        "data-testid": testId ? "".concat(testId, "-wrapper") : 'spinner-wrapper',
        style: {
            animationDelay: animationDelay,
            width: size,
            height: size
        },
        className: (0, $hUbY6.default)([
            $179383c4479cf8b7$var$styles.wrapperStyles,
            $179383c4479cf8b7$var$styles.rotateStyles
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("svg", {
        height: size,
        width: size,
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg",
        "data-testid": testId,
        ref: ref,
        "aria-label": label || undefined,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            animationDelay: animationDelay
        },
        role: label ? 'img' : 'none',
        className: (0, $hUbY6.default)([
            $179383c4479cf8b7$var$styles.loadInStyles
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("circle", {
        cx: "8",
        cy: "8",
        r: "7",
        style: {
            stroke: stroke
        },
        className: (0, $hUbY6.default)([
            $179383c4479cf8b7$var$styles.circleStyles
        ])
    })));
}));
var $179383c4479cf8b7$export$2e2bcd8739ae039 = $179383c4479cf8b7$var$Spinner;

});
parcelRegister("2USpa", function(module, exports) {
$parcel$export(module.exports, "presetSizes", () => $21fb0369f79ce62a$export$4e9f1640bbe7a1a8);
var $21fb0369f79ce62a$export$4e9f1640bbe7a1a8 = {
    xsmall: 12,
    small: 16,
    medium: 24,
    large: 48,
    xlarge: 96
};

});




parcelRegister("dA5ju", function(module, exports) {
$parcel$export(module.exports, "default", () => $9e32c243100ce286$export$2e2bcd8739ae039);
/* content.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $hUbY6 = parcelRequire("hUbY6");

var $5FkrB = parcelRequire("5FkrB");
var $9e32c243100ce286$var$styles = {
    text: "_1reo15vq _18m915vq _16jlkb7n _1o9zkb7n _1bto1l2s _o5721q9c",
    icon: "_1e0c1txw _16jlidpf _1o9zidpf _1wpz1h6o _1wybidpf _vwz4idpf _uiztglyw",
    common: "_v564g17y",
    fade: "_tzy4idpf"
};
/**
 * __Content__
 *
 * Used for slots within a Button, including icons and text content.
 */ var $9e32c243100ce286$var$Content = function Content(_ref) {
    var children = _ref.children, _ref$type = _ref.type, type = _ref$type === void 0 ? 'text' : _ref$type, isLoading = _ref.isLoading;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("span", {
        className: (0, $hUbY6.default)([
            $9e32c243100ce286$var$styles.common,
            type === 'text' && $9e32c243100ce286$var$styles.text,
            type === 'icon' && $9e32c243100ce286$var$styles.icon,
            isLoading && $9e32c243100ce286$var$styles.fade
        ])
    }, children);
};
var $9e32c243100ce286$export$2e2bcd8739ae039 = $9e32c243100ce286$var$Content;

});

parcelRegister("kFoY0", function(module, exports) {
$parcel$export(module.exports, "default", () => $f0bb00e0f8b82ec3$export$2e2bcd8739ae039);

var $5FkrB = parcelRequire("5FkrB");

var $5VFxW = parcelRequire("5VFxW");
function $f0bb00e0f8b82ec3$var$isIconRenderProp(func) {
    return !func.displayName && // most function components and class components have a displayName, negate them
    !func.render && // forwardRef doesn't require a display name, however it does include a render function, negate them
    typeof func === 'function' // at the very least we need to be a function
    ;
}
/**
 * __Icon renderer__
 *
 * Used to support render props with icons.
 *
 */ var $f0bb00e0f8b82ec3$var$IconRenderer = function IconRenderer(_ref) {
    var Icon = _ref.icon;
    var isRenderProp = $f0bb00e0f8b82ec3$var$isIconRenderProp(Icon);
    var iconProps = {
        label: '',
        color: 'currentColor',
        size: (0, $5VFxW.fg)('platform_dst_button_chevron_sizing') ? function(iconName) {
            return iconName.startsWith('Chevron') ? 'small' : 'medium';
        } : undefined
    };
    // @ts-ignore - TS2322 TypeScript 5.9.2 upgrade
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).Fragment, null, isRenderProp ? Icon(iconProps) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(Icon, iconProps));
};
var $f0bb00e0f8b82ec3$export$2e2bcd8739ae039 = $f0bb00e0f8b82ec3$var$IconRenderer;

});


parcelRegister("j0MtN", function(module, exports) {
$parcel$export(module.exports, "default", () => $dd739f70abea303d$export$2e2bcd8739ae039);

var $kqp0i = parcelRequire("kqp0i");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");

var $kPZLD = parcelRequire("kPZLD");

var $a6Lix = parcelRequire("a6Lix");

var $cd86S = parcelRequire("cd86S");

var $gkiBY = parcelRequire("gkiBY");

var $dA5ju = parcelRequire("dA5ju");

var $kFoY0 = parcelRequire("kFoY0");
var $dd739f70abea303d$var$_excluded = [
    "aria-label",
    "aria-labelledby",
    "analyticsContext",
    "appearance",
    "autoFocus",
    "icon",
    "interactionName",
    "isDisabled",
    "isLoading",
    "isSelected",
    "isTooltipDisabled",
    "label",
    "onClick",
    "onClickCapture",
    "onKeyDownCapture",
    "onKeyUpCapture",
    "onMouseDownCapture",
    "onMouseUpCapture",
    "onPointerDownCapture",
    "onPointerUpCapture",
    "onTouchEndCapture",
    "onTouchStartCapture",
    "shape",
    "spacing",
    "testId",
    "tooltip",
    "type"
], $dd739f70abea303d$var$_excluded2 = [
    "className",
    "css",
    "as",
    "style"
];
/**
 * __Icon Button__
 *
 * Renders an icon-only button lets people take a common and recognizable action where space is limited.
 *
 * - [Examples](https://atlassian.design/components/button/icon-button/examples)
 * - [Code](https://atlassian.design/components/button/icon-button/code)
 * - [Usage](https://atlassian.design/components/button/icon-button/usage)
 */ var $dd739f70abea303d$var$IconButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).forwardRef(function Button(_ref, ref) {
    var _tooltip$content;
    var preventedAriaLabel = _ref['aria-label'], ariaLabelledBy = _ref['aria-labelledby'], analyticsContext = _ref.analyticsContext, appearance = _ref.appearance, autoFocus = _ref.autoFocus, icon = _ref.icon, interactionName = _ref.interactionName, isDisabled = _ref.isDisabled, _ref$isLoading = _ref.isLoading, isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading, isSelected = _ref.isSelected, _ref$isTooltipDisable = _ref.isTooltipDisabled, isTooltipDisabled = _ref$isTooltipDisable === void 0 ? true : _ref$isTooltipDisable, label = _ref.label, _onClick = _ref.onClick, onClickCapture = _ref.onClickCapture, onKeyDownCapture = _ref.onKeyDownCapture, onKeyUpCapture = _ref.onKeyUpCapture, onMouseDownCapture = _ref.onMouseDownCapture, onMouseUpCapture = _ref.onMouseUpCapture, onPointerDownCapture = _ref.onPointerDownCapture, onPointerUpCapture = _ref.onPointerUpCapture, onTouchEndCapture = _ref.onTouchEndCapture, onTouchStartCapture = _ref.onTouchStartCapture, shape = _ref.shape, spacing = _ref.spacing, testId = _ref.testId, tooltip = _ref.tooltip, _ref$type = _ref.type, type = _ref$type === void 0 ? 'button' : _ref$type, unsafeRest = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $dd739f70abea303d$var$_excluded);
    // @ts-expect-error
    var _className = unsafeRest.className, _css = unsafeRest.css, _as = unsafeRest.as, _style = unsafeRest.style, saferRest = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(unsafeRest, $dd739f70abea303d$var$_excluded2);
    if (isTooltipDisabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $gkiBY.default), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, saferRest, {
        ref: ref,
        appearance: appearance,
        autoFocus: autoFocus,
        isDisabled: isDisabled,
        isLoading: isLoading,
        isSelected: isSelected,
        isIconButton: true,
        isCircle: shape === 'circle',
        hasIconBefore: !!icon,
        spacing: spacing,
        ariaLabelledBy: ariaLabelledBy,
        onClick: _onClick,
        onClickCapture: onClickCapture,
        onKeyDownCapture: onKeyDownCapture,
        onKeyUpCapture: onKeyUpCapture,
        onMouseDownCapture: onMouseDownCapture,
        onMouseUpCapture: onMouseUpCapture,
        onPointerDownCapture: onPointerDownCapture,
        onPointerUpCapture: onPointerUpCapture,
        onTouchStartCapture: onTouchStartCapture,
        onTouchEndCapture: onTouchEndCapture,
        testId: testId,
        componentName: "IconButton",
        analyticsContext: analyticsContext,
        type: type,
        interactionName: interactionName
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $dA5ju.default), {
        type: "icon",
        isLoading: isLoading
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $kFoY0.default), {
        icon: icon
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $cd86S.default), null, label)));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $a6Lix.default), {
        content: (_tooltip$content = tooltip === null || tooltip === void 0 ? void 0 : tooltip.content) !== null && _tooltip$content !== void 0 ? _tooltip$content : label,
        testId: tooltip === null || tooltip === void 0 ? void 0 : tooltip.testId,
        position: tooltip === null || tooltip === void 0 ? void 0 : tooltip.position,
        delay: tooltip === null || tooltip === void 0 ? void 0 : tooltip.delay,
        onShow: tooltip === null || tooltip === void 0 ? void 0 : tooltip.onShow,
        onHide: tooltip === null || tooltip === void 0 ? void 0 : tooltip.onHide,
        mousePosition: tooltip === null || tooltip === void 0 ? void 0 : tooltip.mousePosition,
        analyticsContext: tooltip === null || tooltip === void 0 ? void 0 : tooltip.analyticsContext,
        strategy: tooltip === null || tooltip === void 0 ? void 0 : tooltip.strategy,
        tag: tooltip === null || tooltip === void 0 ? void 0 : tooltip.tag,
        truncate: tooltip === null || tooltip === void 0 ? void 0 : tooltip.truncate,
        component: tooltip === null || tooltip === void 0 ? void 0 : tooltip.component,
        hideTooltipOnClick: tooltip === null || tooltip === void 0 ? void 0 : tooltip.hideTooltipOnClick,
        hideTooltipOnMouseDown: tooltip === null || tooltip === void 0 ? void 0 : tooltip.hideTooltipOnMouseDown,
        ignoreTooltipPointerEvents: tooltip === null || tooltip === void 0 ? void 0 : tooltip.ignoreTooltipPointerEvents,
        shortcut: tooltip === null || tooltip === void 0 ? void 0 : tooltip.shortcut
    }, function(triggerProps) {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $gkiBY.default), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, saferRest, {
            appearance: appearance,
            autoFocus: autoFocus,
            isDisabled: isDisabled,
            isLoading: isLoading,
            isSelected: isSelected,
            isIconButton: true,
            isCircle: shape === 'circle',
            hasIconBefore: false,
            spacing: spacing,
            ariaLabelledBy: ariaLabelledBy,
            onClick: function onClick(e, analyticsEvent) {
                var _triggerProps$onClick;
                _onClick === null || _onClick === void 0 || _onClick(e, analyticsEvent);
                (_triggerProps$onClick = triggerProps.onClick) === null || _triggerProps$onClick === void 0 || _triggerProps$onClick.call(triggerProps, e);
            },
            onMouseOver: function onMouseOver(e) {
                var _triggerProps$onMouse, _saferRest$onMouseOve;
                (_triggerProps$onMouse = triggerProps.onMouseOver) === null || _triggerProps$onMouse === void 0 || _triggerProps$onMouse.call(triggerProps, e);
                (_saferRest$onMouseOve = saferRest.onMouseOver) === null || _saferRest$onMouseOve === void 0 || _saferRest$onMouseOve.call(saferRest, e);
            },
            onMouseOut: function onMouseOut(e) {
                var _triggerProps$onMouse2, _saferRest$onMouseOut;
                (_triggerProps$onMouse2 = triggerProps.onMouseOut) === null || _triggerProps$onMouse2 === void 0 || _triggerProps$onMouse2.call(triggerProps, e);
                (_saferRest$onMouseOut = saferRest.onMouseOut) === null || _saferRest$onMouseOut === void 0 || _saferRest$onMouseOut.call(saferRest, e);
            },
            onMouseMove: function onMouseMove(e) {
                var _triggerProps$onMouse3, _saferRest$onMouseMov;
                (_triggerProps$onMouse3 = triggerProps.onMouseMove) === null || _triggerProps$onMouse3 === void 0 || _triggerProps$onMouse3.call(triggerProps, e);
                (_saferRest$onMouseMov = saferRest.onMouseMove) === null || _saferRest$onMouseMov === void 0 || _saferRest$onMouseMov.call(saferRest, e);
            },
            onMouseDown: function onMouseDown(e) {
                var _triggerProps$onMouse4, _saferRest$onMouseDow;
                (_triggerProps$onMouse4 = triggerProps.onMouseDown) === null || _triggerProps$onMouse4 === void 0 || _triggerProps$onMouse4.call(triggerProps, e);
                (_saferRest$onMouseDow = saferRest.onMouseDown) === null || _saferRest$onMouseDow === void 0 || _saferRest$onMouseDow.call(saferRest, e);
            },
            onFocus: function onFocus(e) {
                var _triggerProps$onFocus, _saferRest$onFocus;
                (_triggerProps$onFocus = triggerProps.onFocus) === null || _triggerProps$onFocus === void 0 || _triggerProps$onFocus.call(triggerProps, e);
                (_saferRest$onFocus = saferRest.onFocus) === null || _saferRest$onFocus === void 0 || _saferRest$onFocus.call(saferRest, e);
            },
            onBlur: function onBlur(e) {
                var _triggerProps$onBlur, _saferRest$onBlur;
                (_triggerProps$onBlur = triggerProps.onBlur) === null || _triggerProps$onBlur === void 0 || _triggerProps$onBlur.call(triggerProps, e);
                (_saferRest$onBlur = saferRest.onBlur) === null || _saferRest$onBlur === void 0 || _saferRest$onBlur.call(saferRest, e);
            },
            ref: (0, $kPZLD.default)([
                ref,
                triggerProps === null || triggerProps === void 0 ? void 0 : triggerProps.ref
            ].filter(Boolean)),
            onMouseDownCapture: onMouseDownCapture,
            onMouseUpCapture: onMouseUpCapture,
            onKeyDownCapture: onKeyDownCapture,
            onKeyUpCapture: onKeyUpCapture,
            onTouchStartCapture: onTouchStartCapture,
            onTouchEndCapture: onTouchEndCapture,
            onPointerDownCapture: onPointerDownCapture,
            onPointerUpCapture: onPointerUpCapture,
            onClickCapture: onClickCapture,
            type: type,
            testId: testId,
            analyticsContext: analyticsContext,
            interactionName: interactionName,
            componentName: "IconButton"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $dA5ju.default), {
            type: "icon",
            isLoading: isLoading
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $kFoY0.default), {
            icon: icon
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $cd86S.default), null, label)));
    });
}));
$dd739f70abea303d$var$IconButton.displayName = 'IconButton';
var $dd739f70abea303d$export$2e2bcd8739ae039 = $dd739f70abea303d$var$IconButton;

});
parcelRegister("a6Lix", function(module, exports) {
$parcel$export(module.exports, "default", () => $75bf2756bb005ec2$export$2e2bcd8739ae039);

var $kqp0i = parcelRequire("kqp0i");

var $iYJcE = parcelRequire("iYJcE");

var $25nEq = parcelRequire("25nEq");

var $5FkrB = parcelRequire("5FkrB");

var $7QpUe = parcelRequire("7QpUe");

var $3wzaG = parcelRequire("3wzaG");

var $4NddD = parcelRequire("4NddD");

var $8kG8K = parcelRequire("8kG8K");

var $9JB2y = parcelRequire("9JB2y");

var $lyDlF = parcelRequire("lyDlF");

var $fk4sb = parcelRequire("fk4sb");
var $5dRmO = parcelRequire("5dRmO");

var $5VFxW = parcelRequire("5VFxW");

var $fKwEs = parcelRequire("fKwEs");

var $gpRYR = parcelRequire("gpRYR");

var $9iHrw = parcelRequire("9iHrw");

var $6wqXN = parcelRequire("6wqXN");

var $35Y3G = parcelRequire("35Y3G");

var $j70BV = parcelRequire("j70BV");

var $cmaFv = parcelRequire("cmaFv");

var $fE53w = parcelRequire("fE53w");

var $6xj5M = parcelRequire("6xj5M");

var $a8GFF = parcelRequire("a8GFF");

var $1K0Sz = parcelRequire("1K0Sz");

var $9mour = parcelRequire("9mour");

var $gsBlJ = parcelRequire("gsBlJ");

var $i3oYb = parcelRequire("i3oYb");
function $75bf2756bb005ec2$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $75bf2756bb005ec2$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $75bf2756bb005ec2$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $75bf2756bb005ec2$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $75bf2756bb005ec2$var$tooltipZIndex = (0, $9iHrw.layers).tooltip();
var $75bf2756bb005ec2$var$analyticsAttributes = {
    componentName: 'tooltip',
    packageName: "@atlaskit/tooltip",
    packageVersion: "22.6.5"
};
// Inverts motion direction
var $75bf2756bb005ec2$var$invertedDirection = {
    top: 'bottom',
    bottom: 'top',
    left: 'right',
    right: 'left'
};
/**
 * Converts a Popper placement to it's general direction.
 *
 * @param placement - Popper Placement value, e.g. 'top-start'
 * @returns Popper Direction, e.g. 'top'
 */ var $75bf2756bb005ec2$var$getDirectionFromPlacement = function getDirectionFromPlacement(placement) {
    return placement.split('-')[0];
};
/**
 * __Tooltip__
 *
 * A tooltip is a floating, non-actionable label used to explain a user interface element or feature.
 */ function $75bf2756bb005ec2$var$Tooltip(_ref) {
    var children = _ref.children, _ref$position = _ref.position, position = _ref$position === void 0 ? 'bottom' : _ref$position, _ref$mousePosition = _ref.mousePosition, mousePosition = _ref$mousePosition === void 0 ? 'bottom' : _ref$mousePosition, content = _ref.content, _ref$truncate = _ref.truncate, truncate = _ref$truncate === void 0 ? false : _ref$truncate, _ref$component = _ref.component, Container = _ref$component === void 0 ? (0, $i3oYb.default) : _ref$component, _ref$tag = _ref.tag, TargetContainer = _ref$tag === void 0 ? 'div' : _ref$tag, testId = _ref.testId, _ref$delay = _ref.delay, delay = _ref$delay === void 0 ? 300 : _ref$delay, _ref$onShow = _ref.onShow, onShow = _ref$onShow === void 0 ? (0, $4NddD.default) : _ref$onShow, _ref$onHide = _ref.onHide, onHide = _ref$onHide === void 0 ? (0, $4NddD.default) : _ref$onHide, canAppear = _ref.canAppear, _ref$hideTooltipOnCli = _ref.hideTooltipOnClick, hideTooltipOnClick = _ref$hideTooltipOnCli === void 0 ? false : _ref$hideTooltipOnCli, _ref$hideTooltipOnMou = _ref.hideTooltipOnMouseDown, hideTooltipOnMouseDown = _ref$hideTooltipOnMou === void 0 ? false : _ref$hideTooltipOnMou, analyticsContext = _ref.analyticsContext, _ref$strategy = _ref.strategy, strategy = _ref$strategy === void 0 ? 'fixed' : _ref$strategy, _ref$ignoreTooltipPoi = _ref.ignoreTooltipPointerEvents, ignoreTooltipPointerEvents = _ref$ignoreTooltipPoi === void 0 ? false : _ref$ignoreTooltipPoi, _ref$isScreenReaderAn = _ref.isScreenReaderAnnouncementDisabled, isScreenReaderAnnouncementDisabled = _ref$isScreenReaderAn === void 0 ? false : _ref$isScreenReaderAn, shortcut = _ref.shortcut, _ref$shouldAlwaysFade = _ref.shouldAlwaysFadeIn, shouldAlwaysFadeIn = _ref$shouldAlwaysFade === void 0 ? false : _ref$shouldAlwaysFade, _ref$shouldRenderToPa = _ref.shouldRenderToParent, shouldRenderToParent = _ref$shouldRenderToPa === void 0 ? false : _ref$shouldRenderToPa;
    // Not using a gate for this check. When the gate is disabled `mouse-y` and `mouse-x` are treated as `mouse`.
    var isMousePosition = position === 'mouse' || position === 'mouse-y' || position === 'mouse-x';
    var tooltipPosition = isMousePosition ? mousePosition : position;
    var onShowHandler = (0, $3wzaG.usePlatformLeafSyntheticEventHandler)($75bf2756bb005ec2$var$_objectSpread({
        fn: onShow,
        action: 'displayed',
        analyticsData: analyticsContext
    }, $75bf2756bb005ec2$var$analyticsAttributes));
    var onHideHandler = (0, $3wzaG.usePlatformLeafSyntheticEventHandler)($75bf2756bb005ec2$var$_objectSpread({
        fn: onHide,
        action: 'hidden',
        analyticsData: analyticsContext
    }, $75bf2756bb005ec2$var$analyticsAttributes));
    var apiRef = (0, $5FkrB.useRef)(null);
    var _useState = (0, $5FkrB.useState)('hide'), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), state = _useState2[0], setState = _useState2[1];
    var targetRef = (0, $5FkrB.useRef)(null);
    var containerRef = (0, $5FkrB.useRef)(null);
    // This function is deliberately _not_ memoized as it needs to re-run every render
    // to pick up any child ref changes. If you use render props you don't have this issue.
    var setImplicitRefFromChildren = function setImplicitRefFromChildren(node) {
        containerRef.current = node;
        targetRef.current = node ? node.firstElementChild : null;
    };
    // This is memoized and passed into the render props callback.
    var setDirectRef = (0, $5FkrB.useCallback)(function(node) {
        targetRef.current = node;
    }, []);
    // Putting a few things into refs so that we don't have to break memoization
    var stableState = (0, $9JB2y.default)(state);
    // These props are placed in separate refs instead of a single object to reduce memory usage.
    // Placing them in the same object previously caused an increase in the number of JavaScript event listeners
    // before garbage collection.
    var onShowHandlerStable = (0, $9JB2y.default)(onShowHandler);
    var onHideHandlerStable = (0, $9JB2y.default)(onHideHandler);
    var delayStable = (0, $9JB2y.default)(delay);
    var canAppearStable = (0, $9JB2y.default)(canAppear);
    var hasCalledShowHandler = (0, $5FkrB.useRef)(false);
    var shouldAlwaysFadeInStable = (0, $9JB2y.default)(shouldAlwaysFadeIn);
    var start = (0, $5FkrB.useCallback)(function(api) {
        apiRef.current = api;
        hasCalledShowHandler.current = false;
    }, []);
    var done = (0, $5FkrB.useCallback)(function() {
        if (!apiRef.current) return;
        // Only call onHideHandler if we have called onShowHandler
        if (hasCalledShowHandler.current) onHideHandlerStable.current();
        apiRef.current = null;
        hasCalledShowHandler.current = false;
        // just in case
        setState('hide');
    }, [
        onHideHandlerStable
    ]);
    var abort = (0, $5FkrB.useCallback)(function() {
        if (!apiRef.current) return;
        apiRef.current.abort();
        // Only call onHideHandler if we have called onShowHandler
        if (hasCalledShowHandler.current) onHideHandlerStable.current();
        apiRef.current = null;
    }, [
        onHideHandlerStable
    ]);
    (0, $5FkrB.useEffect)(function mount() {
        return function unmount() {
            if (apiRef.current) abort();
        };
    }, [
        abort
    ]);
    var isDraggingRef = (0, $5FkrB.useRef)(false);
    (0, $5FkrB.useEffect)(function() {
        return (0, $6xj5M.register)({
            onRegister: function onRegister(_ref2) {
                var isDragging = _ref2.isDragging;
                isDraggingRef.current = isDragging;
            },
            onDragStart: function onDragStart() {
                var _apiRef$current;
                /**
         * Hiding any visible tooltips when a drag starts because otherwise it
         * looks janky (disappears and reappears), and is not required.
         */ (_apiRef$current = apiRef.current) === null || _apiRef$current === void 0 || _apiRef$current.requestHide({
                    isImmediate: true
                });
                isDraggingRef.current = true;
            },
            onDragEnd: function onDragEnd() {
                isDraggingRef.current = false;
            }
        });
    }, []);
    var tryShowTooltip = (0, $5FkrB.useCallback)(function(source) {
        var _canAppearStable$curr;
        /**
     * Prevent tooltips from being shown during a drag. This can occur with
     * the native drag and drop API, where some pointer events can fire
     * when they should not and lead to jank with tooltips.
     */ if (isDraggingRef.current) return;
        // Another tooltip is has been active but we still have the old `api`
        // around. We need to finish up the last usage.
        // Note: just being safe - this should not happen
        if (apiRef.current && !apiRef.current.isActive()) abort();
        // This tooltip is already active, we can exit
        if (apiRef.current && apiRef.current.isActive()) {
            apiRef.current.keep();
            return;
        }
        /**
     * Check if tooltip is allowed to show.
     *
     * Once a tooltip has started, or has scheduled to start
     * we won't be checking `canAppear` again.
     *
     * - We don't want tooltips to disappear once they are shown
     * - For consistency, we start after a single positive `canAppear`.
     *   Otherwise the amount of times we ask consumers would depend on
     *   how many times we get a "mousemove", which _could_ lead to situations
     *   where moving the mouse could result in a different outcome to if
     *   the mouse was not moved.
     */ if (canAppearStable.current && !((_canAppearStable$curr = canAppearStable.current) !== null && _canAppearStable$curr !== void 0 && _canAppearStable$curr.call(canAppearStable))) return;
        var entry = {
            source: source,
            delay: delayStable.current,
            show: function show(_ref3) {
                var isImmediate = _ref3.isImmediate;
                // Call the onShow handler if it hasn't been called yet
                if (!hasCalledShowHandler.current) {
                    hasCalledShowHandler.current = true;
                    onShowHandlerStable.current();
                }
                setState(!isImmediate ? 'fade-in' : 'show-immediate');
            },
            hide: function hide(_ref4) {
                var isImmediate = _ref4.isImmediate;
                if (isImmediate) setState('hide');
                else if ((0, $5VFxW.fg)('platform-dst-top-layer')) // Top-layer path: set state to 'top-layer-exit'. The component
                // stays mounted and Popover's isOpen prop transitions to
                // false, triggering the CSS exit animation internally.
                // finishHideAnimation is called after a brief delay matching
                // the CSS exit animation duration.
                setState('top-layer-exit');
                else setState('before-fade-out');
            },
            done: done,
            shouldAlwaysFadeIn: shouldAlwaysFadeInStable.current
        };
        var api = (0, $9mour.show)(entry);
        start(api);
    }, [
        canAppearStable,
        delayStable,
        done,
        start,
        abort,
        onShowHandlerStable,
        shouldAlwaysFadeInStable
    ]);
    var hideTooltipOnEsc = (0, $5FkrB.useCallback)(function() {
        var _apiRef$current2;
        (_apiRef$current2 = apiRef.current) === null || _apiRef$current2 === void 0 || _apiRef$current2.requestHide({
            isImmediate: true
        });
    }, [
        apiRef
    ]);
    // When using top-layer, popover="auto" handles Escape natively
    (0, $8kG8K.default)({
        onClose: hideTooltipOnEsc,
        isDisabled: state === 'hide' || state === 'fade-out' || state === 'top-layer-exit' || (0, $5VFxW.fg)('platform-dst-top-layer')
    });
    // ── Top-layer exit animation lifecycle ──
    // When state is 'top-layer-exit', Popover's isOpen transitions to false and
    // the CSS exit animation plays. The Popover's built-in `transitionend`
    // detection (with timeout fallback) calls `onExitFinish` when the exit
    // animation completes, which triggers the tooltip-manager lifecycle
    // (finishHideAnimation → done → onHide, setState('hide'), cleanup).
    var handleExitFinish = (0, $5FkrB.useCallback)(function() {
        var _apiRef$current3;
        (_apiRef$current3 = apiRef.current) === null || _apiRef$current3 === void 0 || _apiRef$current3.finishHideAnimation();
    }, []);
    (0, $5FkrB.useEffect)(function() {
        if (state === 'hide') return 0, $4NddD.default;
        if (state === 'before-fade-out') setState('fade-out');
        var unbind = (0, $7QpUe.bind)(window, {
            type: 'scroll',
            listener: function listener() {
                if (apiRef.current) apiRef.current.requestHide({
                    isImmediate: true
                });
            },
            options: {
                capture: true,
                passive: true,
                once: true
            }
        });
        return unbind;
    }, [
        state
    ]);
    var onMouseDown = (0, $5FkrB.useCallback)(function() {
        if (hideTooltipOnMouseDown && apiRef.current) apiRef.current.requestHide({
            isImmediate: true
        });
    }, [
        hideTooltipOnMouseDown
    ]);
    var onClick = (0, $5FkrB.useCallback)(function() {
        if (hideTooltipOnClick && apiRef.current) apiRef.current.requestHide({
            isImmediate: true
        });
    }, [
        hideTooltipOnClick
    ]);
    // Ideally we would be using onMouseEnter here, but
    // because we are binding the event to the target parent
    // we need to listen for the mouseover of all sub elements
    // This means when moving along a tooltip we are quickly toggling
    // between api.requestHide and api.keep. This it not ideal
    var onMouseOver = (0, $5FkrB.useCallback)(function(event) {
        // Ignoring events from the container ref
        if (containerRef.current && event.target === containerRef.current) return;
        // Using prevent default as a signal that parent tooltips
        if (event.defaultPrevented) return;
        event.preventDefault();
        var source = isMousePosition ? {
            type: 'mouse',
            clientX: event.clientX,
            clientY: event.clientY
        } : {
            type: 'keyboard'
        };
        tryShowTooltip(source);
    }, [
        isMousePosition,
        tryShowTooltip
    ]);
    // Ideally we would be using onMouseEnter here, but
    // because we are binding the event to the target parent
    // we need to listen for the mouseout of all sub elements
    // This means when moving along a tooltip we are quickly toggling
    // between api.requestHide and api.keep. This it not ideal
    var onMouseOut = (0, $5FkrB.useCallback)(function(event) {
        // Ignoring events from the container ref
        if (containerRef.current && event.target === containerRef.current) return;
        // Using prevent default as a signal that parent tooltips
        if (event.defaultPrevented) return;
        event.preventDefault();
        if (apiRef.current) apiRef.current.requestHide({
            isImmediate: false
        });
    }, []);
    var onMouseMove = isMousePosition ? function(event) {
        var _apiRef$current4;
        if ((_apiRef$current4 = apiRef.current) !== null && _apiRef$current4 !== void 0 && _apiRef$current4.isActive()) apiRef.current.mousePos = {
            clientX: event.clientX,
            clientY: event.clientY
        };
    } : undefined;
    var onMouseOverTooltip = (0, $5FkrB.useCallback)(function() {
        if (apiRef.current && apiRef.current.isActive()) {
            apiRef.current.keep();
            return;
        }
    }, []);
    var onFocus = (0, $5FkrB.useCallback)(function(e) {
        // Check if focus-visible
        // Prevents tooltips from showing when focus is not visible,
        // i.e., when focus is moved onto tooltip trigger inside a popup on open
        try {
            if (!e.target.matches(':focus-visible')) return;
        } catch (_unused) {
        // Ignore errors from environments that don't support :focus-visible
        }
        // TODO: this does not play well with `hideTooltipOnMouseDown`
        // as "focus" will occur after the "mousedown".
        tryShowTooltip({
            type: 'keyboard'
        });
    }, [
        tryShowTooltip
    ]);
    var onBlur = (0, $5FkrB.useCallback)(function() {
        if (apiRef.current) apiRef.current.requestHide({
            isImmediate: false
        });
    }, []);
    var onAnimationFinished = (0, $5FkrB.useCallback)(function(transition) {
        // Using lastState here because motion is not picking up the latest value
        if (transition === 'exiting' && stableState.current === 'fade-out' && apiRef.current) apiRef.current.finishHideAnimation();
    }, [
        stableState
    ]);
    // Doing a cast because typescript is struggling to narrow the type
    var CastTargetContainer = TargetContainer;
    var shouldRenderTooltipPopup = state !== 'hide' && Boolean(content);
    var shouldRenderHiddenContent = !isScreenReaderAnnouncementDisabled && shouldRenderTooltipPopup;
    var shouldRenderTooltipChildren = state !== 'hide' && state !== 'fade-out' && state !== 'top-layer-exit';
    var handleOpenLayerObserverCloseSignal = (0, $5FkrB.useCallback)(function() {
        var _apiRef$current5;
        (_apiRef$current5 = apiRef.current) === null || _apiRef$current5 === void 0 || _apiRef$current5.requestHide({
            isImmediate: true
        });
    }, []);
    // On the top-layer path, the Popover primitive (used by TopLayerTooltipPopup)
    // registers with the observer directly, so we skip registration here to
    // avoid double-counting.
    // Safe conditional hook: feature flags are resolved once at startup.
    if (!(0, $5VFxW.fg)('platform-dst-top-layer')) // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $lyDlF.useNotifyOpenLayerObserver)({
        // Layer is only visually open if both the tooltip popup (container) and children are rendered.
        isOpen: shouldRenderTooltipPopup && shouldRenderTooltipChildren,
        /**
       * We don't strictly need to provide an onClose callback at this time, as there is
       * already code that handles hiding the tooltip when a drag is started (and the only
       * usage right now is closing all layers when the user resizes the side nav).
       *
       * However, for future-proofing and semantic reasons, it makes sense to close the tooltip
       * whenever the open layer observer requests a close.
       */ onClose: handleOpenLayerObserverCloseSignal
    });
    var getReferenceElement = function getReferenceElement() {
        var _apiRef$current6;
        if (isMousePosition && (_apiRef$current6 = apiRef.current) !== null && _apiRef$current6 !== void 0 && _apiRef$current6.mousePos && targetRef.current) return (0, $1K0Sz.getVirtualElementFromMousePos)(apiRef.current.mousePos, {
            targetElement: targetRef.current,
            tooltipPosition: position
        });
        return targetRef.current || undefined;
    };
    var tooltipIdForHiddenContent = (0, $gsBlJ.default)('tooltip', shouldRenderHiddenContent);
    var tooltipTriggerProps = {
        onMouseOver: onMouseOver,
        onMouseOut: onMouseOut,
        onMouseMove: onMouseMove,
        onMouseDown: onMouseDown,
        onClick: onClick,
        onFocus: onFocus,
        onBlur: onBlur
    };
    // This useEffect is purely for managing the aria attribute when using the
    // wrapped children approach.
    var isChildrenAFunction = typeof children === 'function';
    (0, $5FkrB.useEffect)(function() {
        if (isChildrenAFunction) return;
        // If `children` is _not_ a function, we are stepping outside of the public
        // API to add a `aria-describedby` attribute.
        var target = targetRef.current;
        if (!target || !tooltipIdForHiddenContent) return;
        target.setAttribute('aria-describedby', tooltipIdForHiddenContent);
        return function() {
            return target.removeAttribute('aria-describedby');
        };
    }, [
        isChildrenAFunction,
        tooltipIdForHiddenContent
    ]);
    var hiddenContent = shouldRenderHiddenContent ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("span", {
        "data-testid": testId ? "".concat(testId, "-hidden") : undefined,
        hidden: true,
        id: tooltipIdForHiddenContent
    }, typeof content === 'function' ? content({}) : content) : null;
    var PopperWrapper = shouldRenderToParent ? (0, $5FkrB.Fragment) : $75bf2756bb005ec2$var$TooltipPortal;
    var trigger = typeof children === 'function' ? /*#__PURE__*/ // once we deprecate the wrapped approach, we can put the aria
    // attribute back into the tooltipTriggerProps and make it required
    // instead of optional in `types`
    (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).Fragment, null, children($75bf2756bb005ec2$var$_objectSpread($75bf2756bb005ec2$var$_objectSpread($75bf2756bb005ec2$var$_objectSpread({}, tooltipTriggerProps), testId ? {
        testId: "".concat(testId, "--container")
    } : {}), {}, {
        'aria-describedby': tooltipIdForHiddenContent,
        ref: setDirectRef
    })), hiddenContent) : /*#__PURE__*/ // @ts-ignore
    (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(CastTargetContainer, (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, tooltipTriggerProps, testId ? {
        'data-testid': "".concat(testId, "--container")
    } : undefined, {
        ref: setImplicitRefFromChildren,
        role: "presentation"
    }), children, hiddenContent);
    if ((0, $5VFxW.fg)('platform-dst-top-layer')) {
        var _apiRef$current$mouse, _apiRef$current7;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).Fragment, null, trigger, shouldRenderTooltipPopup ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement($75bf2756bb005ec2$var$TopLayerTooltipPopup, {
            targetRef: targetRef,
            tooltipPosition: tooltipPosition,
            mousePos: (_apiRef$current$mouse = (_apiRef$current7 = apiRef.current) === null || _apiRef$current7 === void 0 ? void 0 : _apiRef$current7.mousePos) !== null && _apiRef$current$mouse !== void 0 ? _apiRef$current$mouse : undefined,
            position: position,
            onMouseOut: onMouseOut,
            onMouseOverTooltip: onMouseOverTooltip,
            ignoreTooltipPointerEvents: ignoreTooltipPointerEvents,
            truncate: truncate,
            testId: testId,
            shortcut: shortcut,
            content: content,
            Container: Container,
            onClose: function onClose() {
                var _apiRef$current8;
                return (_apiRef$current8 = apiRef.current) === null || _apiRef$current8 === void 0 ? void 0 : _apiRef$current8.requestHide({
                    isImmediate: true
                });
            },
            onExitFinish: handleExitFinish,
            isOpen: state !== 'hide' && state !== 'top-layer-exit'
        }) : null);
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).Fragment, null, trigger, shouldRenderTooltipPopup ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(PopperWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $fKwEs.Popper), {
        placement: tooltipPosition,
        referenceElement: getReferenceElement(),
        strategy: strategy
    }, function(_ref5) {
        var ref = _ref5.ref, style = _ref5.style, update = _ref5.update, placement = _ref5.placement;
        var direction = isMousePosition ? undefined : $75bf2756bb005ec2$var$invertedDirection[$75bf2756bb005ec2$var$getDirectionFromPlacement(placement)];
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $fk4sb.default), {
            appear: true
        }, shouldRenderTooltipChildren && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $5dRmO.default), {
            distance: "constant",
            entranceDirection: direction,
            exitDirection: direction,
            onFinish: onAnimationFinished,
            duration: state !== 'show-immediate' ? 'medium' : 'none'
        }, function(_ref6) {
            var className = _ref6.className;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(Container, {
                ref: ref,
                className: "Tooltip ".concat(className),
                style: $75bf2756bb005ec2$var$_objectSpread($75bf2756bb005ec2$var$_objectSpread({}, style), ignoreTooltipPointerEvents && {
                    pointerEvents: 'none'
                }),
                truncate: truncate,
                placement: tooltipPosition,
                testId: getReferenceElement() ? testId : testId && "".concat(testId, "--unresolved"),
                onMouseOut: onMouseOut,
                onMouseOver: onMouseOverTooltip,
                shortcut: shortcut
            }, typeof content === 'function' ? content({
                update: update
            }) : content);
        }));
    })) : null);
}
var $75bf2756bb005ec2$export$2e2bcd8739ae039 = $75bf2756bb005ec2$var$Tooltip;
var $75bf2756bb005ec2$var$TooltipPortal = function TooltipPortal(_ref7) {
    var children = _ref7.children;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $gpRYR.default), {
        zIndex: $75bf2756bb005ec2$var$tooltipZIndex
    }, children);
};
// Module-level preset instance, stable reference, no re-allocation per render.
// Non-mouse tooltips slide in from the direction of the trigger — slide + fade.
var $75bf2756bb005ec2$var$tooltipAnimation = (0, $6wqXN.slideAndFade)();
// Mouse-position tooltips follow the cursor and have no fixed direction — fade only.
var $75bf2756bb005ec2$var$tooltipMouseAnimation = (0, $6wqXN.fade)();
/**
 * Top-layer tooltip popup component.
 *
 * Composes `Popover` (top-layer visibility + animation) with one of two
 * positioning hooks:
 *
 *   - `useAnchorPositionAtPoint` — for cursor-tracking positions
 *     (`mouse`, `mouse-x`, `mouse-y`) when a cursor position is
 *     available (i.e. the popup was activated by a pointer). Positions
 *     the popover relative to a hidden synthetic anchor that follows
 *     the cursor according to the `position` / `mousePosition`
 *     semantics. The synthetic anchor element is rendered as a sibling
 *     of the popover.
 *   - `useAnchorPosition` directly — for non-cursor positions, AND
 *     for cursor positions activated via keyboard focus (where there
 *     is no cursor to track). Anchoring directly to the trigger keeps
 *     keyboard-activated tooltips correctly placed next to the target
 *     instead of rendering in the top-left of the viewport.
 *
 * Exactly one positioning strategy is active at a time: `useAnchorPosition`
 * is wired to the trigger only when the mouse strategy is inactive, and
 * `useAnchorPositionAtPoint` is told `isActive: false` when the direct
 * anchor strategy is active. The other hook is still called (Rules of
 * Hooks) but does no work.
 *
 * Exit animation is handled by `Popover`'s `isOpen` prop. When `isOpen`
 * transitions to `false`, the primitive calls `hidePopover()` internally and
 * the CSS exit animation plays via `allow-discrete`. No glue code needed.
 */ function $75bf2756bb005ec2$var$TopLayerTooltipPopup(_ref8) {
    var targetRef = _ref8.targetRef, tooltipPosition = _ref8.tooltipPosition, mousePos = _ref8.mousePos, position = _ref8.position, onMouseOut = _ref8.onMouseOut, onMouseOverTooltip = _ref8.onMouseOverTooltip, ignoreTooltipPointerEvents = _ref8.ignoreTooltipPointerEvents, truncate = _ref8.truncate, testId = _ref8.testId, shortcut = _ref8.shortcut, content = _ref8.content, Container = _ref8.Container, onClose = _ref8.onClose, onExitFinish = _ref8.onExitFinish, isOpen = _ref8.isOpen;
    var popoverRef = (0, $5FkrB.useRef)(null);
    // Translate the legacy Popper-style placement string ("right",
    // "bottom-start", etc.) once and pass the same object to both hooks.
    var placement = (0, $35Y3G.fromLegacyPlacement)({
        legacy: tooltipPosition
    });
    var isMousePosition = position === 'mouse' || position === 'mouse-x' || position === 'mouse-y';
    var isMouseStrategyActive = isMousePosition && Boolean(mousePos);
    // Direct anchor strategy: anchors to the trigger element.
    // Disabled when the mouse strategy is active — both hooks writing
    // to the same popover would fight for positioning ownership.
    (0, $cmaFv.useAnchorPosition)({
        anchorRef: targetRef,
        popoverRef: popoverRef,
        placement: placement,
        isEnabled: !isMouseStrategyActive,
        isOpen: isOpen
    });
    // Mouse anchor strategy: the hook calls `getPoint()` exactly once
    // per activation and latches the resulting coordinate. The latch is
    // per-show because `TopLayerTooltipPopup` mounts fresh on every
    // show.
    //
    // `getPoint()` returns `null` for keyboard-activated shows (where
    // `mousePos` is undefined) or before the trigger has mounted —
    // leaving the direct strategy above to own positioning.
    //
    // SSR note: `getBoundingClientRect()` is only called here because
    // `TopLayerTooltipPopup` is gated behind client-only state
    // transitions.
    (0, $fE53w.useAnchorPositionAtPoint)({
        popoverRef: popoverRef,
        placement: placement,
        isEnabled: isMouseStrategyActive,
        isOpen: isOpen,
        getPoint: function getPoint() {
            if (!mousePos || !targetRef.current || !isMousePosition) return null;
            return (0, $a8GFF.getAnchorPoint)({
                cursor: mousePos,
                triggerRect: targetRef.current.getBoundingClientRect(),
                tooltipPosition: position,
                placement: placement
            });
        }
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $j70BV.Popover), {
        ref: popoverRef,
        role: "tooltip",
        mode: "hint",
        isOpen: isOpen,
        onClose: onClose,
        onExitFinish: onExitFinish,
        testId: testId ? "".concat(testId, "--popover") : undefined,
        animate: isMouseStrategyActive ? $75bf2756bb005ec2$var$tooltipMouseAnimation : $75bf2756bb005ec2$var$tooltipAnimation,
        placement: placement
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(Container, {
        className: "Tooltip",
        style: ignoreTooltipPointerEvents ? {
            pointerEvents: 'none'
        } : undefined,
        truncate: truncate,
        placement: tooltipPosition,
        testId: testId,
        onMouseOut: onMouseOut,
        onMouseOver: onMouseOverTooltip,
        shortcut: shortcut,
        role: "presentation"
    }, typeof content === 'function' ? content({
        update: (0, $4NddD.default)
    }) : content));
}

});
parcelRegister("3wzaG", function(module, exports) {
$parcel$export(module.exports, "usePlatformLeafSyntheticEventHandler", () => $290fa485630d1395$export$1a04351537078b55);

var $25nEq = parcelRequire("25nEq");

var $5FkrB = parcelRequire("5FkrB");

var $bDUuG = parcelRequire("bDUuG");

var $cqQpq = parcelRequire("cqQpq");
function $290fa485630d1395$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $290fa485630d1395$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $290fa485630d1395$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $290fa485630d1395$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $290fa485630d1395$export$1a04351537078b55(_ref) {
    var fn = _ref.fn, action = _ref.action, componentName = _ref.componentName, packageName = _ref.packageName, packageVersion = _ref.packageVersion, analyticsData = _ref.analyticsData;
    var _useAnalyticsEvents = (0, $bDUuG.useAnalyticsEvents)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
    // We put analyticsData and fn in a ref so that we don't need to break
    // memoization.
    // Generally these could be defined by consumers inline
    // and so we do this to avoid breaking memoization of useCallback
    var dataRef = (0, $cqQpq.useTrackedRef)(analyticsData);
    var fnRef = (0, $cqQpq.useTrackedRef)(fn);
    var handler = (0, $5FkrB.useCallback)(function() {
        var analyticsEvent = createAnalyticsEvent({
            action: action,
            actionSubject: componentName,
            attributes: {
                componentName: componentName,
                packageName: packageName,
                packageVersion: packageVersion
            }
        });
        // To avoid wrapping this component in AnalyticsContext we manually
        // push the parent context's meta data into the context.
        // Note: this new 'context'
        var context = $290fa485630d1395$var$_objectSpread({
            componentName: componentName,
            packageName: packageName,
            packageVersion: packageVersion
        }, dataRef.current);
        analyticsEvent.context.push(context);
        // fire an event on the atlaskit channel
        var clone = analyticsEvent.clone();
        if (clone) clone.fire('atlaskit');
        fnRef.current(analyticsEvent);
    }, [
        // These are strings and won't change
        action,
        componentName,
        packageName,
        packageVersion,
        // This function is memoized in the context
        createAnalyticsEvent,
        // these are a stable ref because of the useTrackedRef hook
        dataRef,
        fnRef
    ]);
    return handler;
}

});

parcelRegister("8kG8K", function(module, exports) {
$parcel$export(module.exports, "default", () => $6110e12723fdf490$export$2e2bcd8739ae039);

var $5FkrB = parcelRequire("5FkrB");

var $7QpUe = parcelRequire("7QpUe");

var $3eVR6 = parcelRequire("3eVR6");
function $6110e12723fdf490$export$2e2bcd8739ae039(_ref) {
    var onClose = _ref.onClose, isDisabled = _ref.isDisabled;
    var escapePressed = (0, $5FkrB.useRef)(false);
    var onKeyDown = (0, $5FkrB.useCallback)(function(e) {
        if (isDisabled || escapePressed.current || e.key !== (0, $3eVR6.ESCAPE)) // We're either already handling the key down event or it's not escape.
        // Bail early!
        return;
        escapePressed.current = true;
        onClose(e);
    }, [
        onClose,
        isDisabled
    ]);
    var onKeyUp = (0, $5FkrB.useCallback)(function() {
        escapePressed.current = false;
    }, []);
    (0, $5FkrB.useEffect)(function() {
        // Don't attach document event listeners if the hook is disabled
        if (isDisabled) return;
        return (0, $7QpUe.bindAll)(document, [
            {
                type: 'keydown',
                listener: onKeyDown
            },
            {
                type: 'keyup',
                listener: onKeyUp
            }
        ], {
            capture: false
        });
    }, [
        onKeyDown,
        onKeyUp,
        isDisabled
    ]);
}

});
parcelRegister("3eVR6", function(module, exports) {
$parcel$export(module.exports, "ESCAPE", () => $25bf8ec88c292c73$export$2bb790b9008907b4);
/**
 * Character key codes which can be used in keyboard events.
 */ var $25bf8ec88c292c73$export$390330c10ff2b9a1 = 'ArrowUp';
var $25bf8ec88c292c73$export$a80636c6f41931fe = 'ArrowDown';
var $25bf8ec88c292c73$export$fc4577f2a2af0ae3 = 'ArrowLeft';
var $25bf8ec88c292c73$export$c40f9845adc73fb5 = 'ArrowRight';
var $25bf8ec88c292c73$export$4af703091671bc = 'Home';
var $25bf8ec88c292c73$export$e2bc30913faa5db7 = 'End';
var $25bf8ec88c292c73$export$10f6869ed0a7d75b = 'Tab';
var $25bf8ec88c292c73$export$8152f929a25a0ff4 = 'Enter';
var $25bf8ec88c292c73$export$e51a3576c045c8d5 = 'Space';
var $25bf8ec88c292c73$export$2bb790b9008907b4 = 'Escape';

});


parcelRegister("9JB2y", function(module, exports) {
$parcel$export(module.exports, "default", () => $71650c7368f550ba$export$2e2bcd8739ae039);

var $5FkrB = parcelRequire("5FkrB");
function $71650c7368f550ba$export$2e2bcd8739ae039(value) {
    var ref = (0, $5FkrB.useRef)(value);
    (0, $5FkrB.useEffect)(function() {
        ref.current = value;
    }, [
        value
    ]);
    return ref;
}

});

parcelRegister("lyDlF", function(module, exports) {
$parcel$export(module.exports, "useNotifyOpenLayerObserver", () => $fb1b4bbc790dc164$export$469bb693f11edc7f);

var $5FkrB = parcelRequire("5FkrB");

var $cG7ih = parcelRequire("cG7ih");

var $eipTf = parcelRequire("eipTf");
function $fb1b4bbc790dc164$export$469bb693f11edc7f(_ref) {
    var isOpen = _ref.isOpen, type = _ref.type, onClose = _ref.onClose;
    var context = (0, $5FkrB.useContext)((0, $cG7ih.OpenLayerObserverContext));
    var namespace = (0, $eipTf.useOpenLayerObserverNamespace)();
    (0, $5FkrB.useEffect)(function() {
        /**
     * Registers the `onClose` callback with the OpenLayerObserver.
     */ if (context === null) return;
        if (!isOpen) /**
       * If the layer is not open, we are not registering the `onClose` callback.
       * This is important to prevent the `onClose` from being called for layers that
       * are not open.
       *
       * Some consumers mistakenly pass "toggle" functions to `onClose` callbacks for
       * layer components, as Popup, e.g. `onClose={() => setIsOpen(!isOpen)}`.
       */ return;
        return context.onClose(onClose, {
            namespace: namespace,
            type: type
        });
    }, [
        context,
        isOpen,
        namespace,
        onClose,
        type
    ]);
}

});
parcelRegister("cG7ih", function(module, exports) {
$parcel$export(module.exports, "OpenLayerObserverContext", () => $93af10a91715ee9c$export$5fbf4d7fae6cdc00);

var $5FkrB = parcelRequire("5FkrB");
var $93af10a91715ee9c$export$5fbf4d7fae6cdc00 = /*#__PURE__*/ (0, $5FkrB.createContext)(null);

});

parcelRegister("eipTf", function(module, exports) {
$parcel$export(module.exports, "useOpenLayerObserverNamespace", () => $a686d461071054e2$export$1d57e79091cc3046);

var $5FkrB = parcelRequire("5FkrB");

var $6uxAr = parcelRequire("6uxAr");
function $a686d461071054e2$export$1d57e79091cc3046() {
    var namespace = (0, $5FkrB.useContext)((0, $6uxAr.OpenLayerObserverNamespaceContext));
    return namespace;
}

});
parcelRegister("6uxAr", function(module, exports) {
$parcel$export(module.exports, "OpenLayerObserverNamespaceContext", () => $4b9f990ba3d72dc8$export$644a49f3b8c50fcd);

var $5FkrB = parcelRequire("5FkrB");
var $4b9f990ba3d72dc8$export$644a49f3b8c50fcd = /*#__PURE__*/ (0, $5FkrB.createContext)(null);

});



parcelRegister("fk4sb", function(module, exports) {
$parcel$export(module.exports, "useExitingPersistence", () => $b27c2dab216bdaec$export$3b6f38abbdcbd000);
$parcel$export(module.exports, "default", () => $b27c2dab216bdaec$export$2e2bcd8739ae039);

var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");

var $5VFxW = parcelRequire("5VFxW");
/**
 * Internally we will be playing with an element that will always have a key defined.
 */ /**
 * Internal data passed to child motions.
 */ // We define empty context here so the object doesn't change.
var $b27c2dab216bdaec$var$emptyContext = {
    // Motions will always appear if not inside a exiting persistence component.
    appear: true,
    isExiting: false
};
/**
 * __Exiting context__
 *
 * An exiting context.
 */ var $b27c2dab216bdaec$var$ExitingContext = /*#__PURE__*/ (0, $5FkrB.createContext)($b27c2dab216bdaec$var$emptyContext);
/**
 * This method will wrap any React element with a context provider. We're using context (instead of
 * cloneElement) so we can communicate between multiple elements without the need of prop drilling
 * (results in a better API for consumers).
 */ var $b27c2dab216bdaec$var$wrapChildWithContextProvider = function wrapChildWithContextProvider(child) {
    var value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $b27c2dab216bdaec$var$emptyContext;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement($b27c2dab216bdaec$var$ExitingContext.Provider, {
        key: "".concat(child.key, "-provider"),
        value: value
    }, child);
};
/**
 * This function will convert all children types to an array while also filtering out non-valid React elements.
 */ var $b27c2dab216bdaec$var$childrenToArray = function childrenToArray(children) {
    var childrenAsArray = [];
    // We convert children to an array using this helper method as it will add keys to children that do not
    // have them, such as when we have hardcoded children that are conditionally rendered.
    (0, $5FkrB.Children).toArray(children).forEach(function(child) {
        // We ignore any boolean children to make our code a little more simple later on,
        // and also filter out any falsies (empty strings, nulls, and undefined).
        if (typeof child !== 'boolean' && Boolean(child)) // Children WILL have a key after being forced into an array using the React.Children helper.
        childrenAsArray.push(child);
    });
    return childrenAsArray;
};
var $b27c2dab216bdaec$var$spliceNewElementsIntoPrevious = function spliceNewElementsIntoPrevious(current, previous) {
    var splicedChildren = previous.concat([]);
    var previousMap = $b27c2dab216bdaec$var$childrenToObj(previous);
    for(var i = 0; i < current.length; i++){
        var child = current[i];
        var childIsNew = !previousMap[child.key];
        if (childIsNew) // This will insert the new element after the previous element.
        splicedChildren.splice(i + 1, 0, child);
    }
    return splicedChildren;
};
var $b27c2dab216bdaec$var$childrenToObj = function childrenToObj(children) {
    return children.reduce(function(acc, child) {
        acc[child.key] = child;
        return acc;
    }, {});
};
var $b27c2dab216bdaec$var$getMissingKeys = function getMissingKeys(current, previous) {
    var currentMapKeys = new Set(current.map(function(child) {
        return child.key;
    }));
    var missing = new Set();
    for(var i = 0; i < previous.length; i++){
        var element = previous[i];
        var _key = element.key;
        if (!currentMapKeys.has(_key)) missing.add(_key);
    }
    return missing;
};
/**
 * How does this component work?
 *
 * It looks at changes in its children to see what is removed.
 *
 * If a child is removed it clones it and wraps it with context providing an `onFinish` callback.
 *
 * The cloned child will call the `onFinish` when it finishes its exit animation,
 * which lets `ExitingPersistence` know to stop rendering it.
 */ /**
 * __ExitingPersistence__
 *
 * Useful for enabling elements to persist and animate away when they are removed from the DOM.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/motion/docs/entering-motion)
 */ var $b27c2dab216bdaec$var$ExitingPersistence = /*#__PURE__*/ (0, $5FkrB.memo)(function(_ref) {
    var _ref$appear = _ref.appear, appear = _ref$appear === void 0 ? false : _ref$appear, children = _ref.children, exitThenEnter = _ref.exitThenEnter;
    var _useState = (0, $5FkrB.useState)([
        null,
        children
    ]), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), stateChildren = _useState2[0], setChildren = _useState2[1];
    var _useState3 = (0, $5FkrB.useState)([]), _useState4 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState3, 2), exitingChildren = _useState4[0], setExitingChildren = _useState4[1];
    var _useState5 = (0, $5FkrB.useState)(function() {
        return {
            appear: appear,
            isExiting: false
        };
    }), _useState6 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState5, 2), defaultContext = _useState6[0], setDefaultContext = _useState6[1];
    (0, $5FkrB.useEffect)(function() {
        if (!defaultContext.appear) setDefaultContext({
            appear: true,
            isExiting: false
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    /**
   * NOTE: This is a workaround for the test case written in Jira where the stateChildren is a boolean value because
   * useState is mocked to return a boolean value.
   */ if (typeof stateChildren === 'boolean') return children;
    var _stateChildren = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(stateChildren, 2), previousChildren = _stateChildren[0], currentChildren = _stateChildren[1];
    var previous = $b27c2dab216bdaec$var$childrenToArray(previousChildren);
    var current = $b27c2dab216bdaec$var$childrenToArray(currentChildren);
    if (currentChildren !== children) setChildren([
        currentChildren,
        children
    ]);
    var nextChildren = currentChildren !== children ? $b27c2dab216bdaec$var$childrenToArray(children) : current;
    var missingKeys = $b27c2dab216bdaec$var$getMissingKeys(nextChildren, previous);
    var isSomeChildRemoved = !!missingKeys.size;
    var visibleChildren = !isSomeChildRemoved && currentChildren !== children ? nextChildren : current;
    if (isSomeChildRemoved) visibleChildren = $b27c2dab216bdaec$var$spliceNewElementsIntoPrevious(current, previous);
    if (exitThenEnter) {
        if (exitingChildren.length) visibleChildren = (0, $5VFxW.fg)('platform-dst-motion-uplift') ? previous : exitingChildren;
        else {
            var nextExitingChildren = visibleChildren.filter(function(child) {
                return missingKeys.has(child.key);
            });
            if (nextExitingChildren.length) setExitingChildren(nextExitingChildren);
        }
    }
    if (missingKeys.size) visibleChildren = visibleChildren.map(function(child) {
        var isExiting = missingKeys.has(child.key);
        return $b27c2dab216bdaec$var$wrapChildWithContextProvider(child, {
            appear: true,
            isExiting: isExiting,
            onFinish: isExiting ? function() {
                missingKeys.delete(child.key);
                if (missingKeys.size === 0) {
                    setChildren([
                        null,
                        children
                    ]);
                    setExitingChildren([]);
                }
            } : undefined
        });
    });
    else visibleChildren = visibleChildren.map(function(child) {
        return $b27c2dab216bdaec$var$wrapChildWithContextProvider(child, defaultContext);
    });
    return visibleChildren;
});
var $b27c2dab216bdaec$export$3b6f38abbdcbd000 = function useExitingPersistence() {
    return (0, $5FkrB.useContext)($b27c2dab216bdaec$var$ExitingContext);
};
$b27c2dab216bdaec$var$ExitingPersistence.displayName = 'ExitingPersistence';
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$b27c2dab216bdaec$export$2e2bcd8739ae039 = $b27c2dab216bdaec$var$ExitingPersistence;

});

parcelRegister("5dRmO", function(module, exports) {
$parcel$export(module.exports, "default", () => $3cd7903b63e7db45$export$2e2bcd8739ae039);

var $5FkrB = parcelRequire("5FkrB");

var $9WN2i = parcelRequire("9WN2i");
var $3cd7903b63e7db45$var$invertedDirection = {
    top: 'bottom',
    bottom: 'top',
    left: 'right',
    right: 'left'
};
/**
 * Props for controlling the behavior of the FadeIn animation
 */ /**
 * __FadeIn__
 *
 * Useful for fading in one or more elements.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/motion/docs/entering-motion)
 */ var $3cd7903b63e7db45$var$FadeIn = function FadeIn(_ref) {
    var children = _ref.children, _ref$duration = _ref.duration, duration = _ref$duration === void 0 ? 'large' : _ref$duration, entranceDirection = _ref.entranceDirection, exitDirection = _ref.exitDirection, _ref$distance = _ref.distance, distance = _ref$distance === void 0 ? 'proportional' : _ref$distance, onFinish = _ref.onFinish, isPaused = _ref.isPaused;
    var invertedEntranceDirection = entranceDirection !== undefined ? $3cd7903b63e7db45$var$invertedDirection[entranceDirection] : undefined;
    var isExitDirect = Boolean(exitDirection || invertedEntranceDirection) ? "fade-out-from-".concat(exitDirection || invertedEntranceDirection).concat(distance === 'proportional' ? '' : '-constant') : 'fade-out';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $9WN2i.default), {
        duration: duration,
        enteringAnimation: entranceDirection ? "fade-in-from-".concat(entranceDirection).concat(distance === 'proportional' ? '' : '-constant') : 'fade-in',
        exitingAnimation: isExitDirect,
        animationTimingFunction: "ease-in-out",
        onFinish: onFinish,
        isPaused: isPaused
    }, children);
};
var $3cd7903b63e7db45$export$2e2bcd8739ae039 = $3cd7903b63e7db45$var$FadeIn;

});
parcelRegister("9WN2i", function(module, exports) {
$parcel$export(module.exports, "default", () => $73df915ab798b295$export$2e2bcd8739ae039);
/* keyframes-motion.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");

var $hUbY6 = parcelRequire("hUbY6");

var $3OcVm = parcelRequire("3OcVm");

var $iyKTS = parcelRequire("iyKTS");

var $goQmH = parcelRequire("goQmH");

var $cpUWc = parcelRequire("cpUWc");

var $fk4sb = parcelRequire("fk4sb");

var $dOcZq = parcelRequire("dOcZq");
var $73df915ab798b295$var$zoomIn = null;
var $73df915ab798b295$var$zoomOut = null;
var $73df915ab798b295$var$fadeIn = null;
var $73df915ab798b295$var$fadeOut = null;
var $73df915ab798b295$var$fadeInFromTop = null;
var $73df915ab798b295$var$fadeOutFromTop = null;
var $73df915ab798b295$var$fadeInFromLeft = null;
var $73df915ab798b295$var$fadeOutFromLeft = null;
var $73df915ab798b295$var$fadeInFromBottom = null;
var $73df915ab798b295$var$fadeOutFromBottom = null;
var $73df915ab798b295$var$fadeInFromRight = null;
var $73df915ab798b295$var$fadeOutFromRight = null;
var $73df915ab798b295$var$fadeInFromTopConstant = null;
var $73df915ab798b295$var$fadeOutFromTopConstant = null;
var $73df915ab798b295$var$fadeInFromLeftConstant = null;
var $73df915ab798b295$var$fadeOutFromLeftConstant = null;
var $73df915ab798b295$var$fadeInFromBottomConstant = null;
var $73df915ab798b295$var$fadeOutFromBottomConstant = null;
var $73df915ab798b295$var$fadeInFromRightConstant = null;
var $73df915ab798b295$var$fadeOutFromRightConstant = null;
var $73df915ab798b295$var$slideInFromTop = null;
var $73df915ab798b295$var$slideOutFromTop = null;
var $73df915ab798b295$var$slideInFromRight = null;
var $73df915ab798b295$var$slideOutFromRight = null;
var $73df915ab798b295$var$slideInFromBottom = null;
var $73df915ab798b295$var$slideOutFromBottom = null;
var $73df915ab798b295$var$slideInFromLeft = null;
var $73df915ab798b295$var$slideOutFromLeft = null;
/**
 * These are props that motions should use as their external props for consumers.
 * See [FadeIn](packages/helpers/motion/src/entering/fade-in.tsx) for an example usage.
 */ /**
 * This is the base INTERNAL component used for all other entering motions.
 * This does not need Javascript to execute on the client so it will run immediately
 * for any SSR rendered React apps before the JS has executed.
 */ var $73df915ab798b295$var$EnteringMotion = function EnteringMotion(_ref) {
    var children = _ref.children, animationTimingFunction = _ref.animationTimingFunction, _ref$animationTimingF = _ref.animationTimingFunctionExiting, animationTimingFunctionExiting = _ref$animationTimingF === void 0 ? animationTimingFunction : _ref$animationTimingF, enteringAnimation = _ref.enteringAnimation, _ref$exitingAnimation = _ref.exitingAnimation, exitingAnimation = _ref$exitingAnimation === void 0 ? enteringAnimation : _ref$exitingAnimation, isPaused = _ref.isPaused, onFinishMotion = _ref.onFinish, _ref$duration = _ref.duration, duration = _ref$duration === void 0 ? 'large' : _ref$duration;
    var staggered = (0, $dOcZq.useStaggeredEntrance)();
    var _useExitingPersistenc = (0, $fk4sb.useExitingPersistence)(), isExiting = _useExitingPersistenc.isExiting, onExitFinished = _useExitingPersistenc.onFinish, appear = _useExitingPersistenc.appear;
    var setTimeout = (0, $cpUWc.useSetTimeout)();
    var paused = isPaused || !staggered.isReady;
    var delay = isExiting ? 0 : staggered.delay;
    var state = isExiting ? 'exiting' : 'entering';
    var _useState = (0, $5FkrB.useState)(appear), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), hasAnimationStyles = _useState2[0], setHasAnimationStyles = _useState2[1];
    (0, $5FkrB.useEffect)(function() {
        // Tracking this to prevent changing state on an unmounted component
        var isCancelled = false;
        if (paused) return;
        // On initial mount if elements aren't set to animate on appear, we return early and callback
        if (!appear) {
            onFinishMotion && onFinishMotion(state);
            return;
        }
        /**
     * Updates relevant state.
     * Called when the animation is finished, or immediately with reduced motion.
     */ var onAnimationEnd = function onAnimationEnd() {
            if (state === 'exiting') // Updates the `ExitingPersistence` to remove this child
            onExitFinished === null || onExitFinished === void 0 || onExitFinished();
            if (!isCancelled) setHasAnimationStyles(false);
            onFinishMotion === null || onFinishMotion === void 0 || onFinishMotion(state);
        };
        if ((0, $goQmH.isReducedMotion)()) {
            // If there is reduced motion there is no exit animation, so call this immediately
            onAnimationEnd();
            return;
        }
        // Elements may need animation styles back after initial mount (they could animate out)
        setHasAnimationStyles(true);
        // Queue `onAnimationEnd` for after the animation has finished
        setTimeout(onAnimationEnd, isExiting ? (0, $iyKTS.exitingDurations)[duration] : (0, $3OcVm.durations)[duration] + delay);
        return function() {
            isCancelled = true;
        };
    // We ignore this for onFinishMotion as consumers could potentially inline the function
    // which would then trigger this effect every re-render.
    // We want to make it easier for consumers so we go down this path unfortunately.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        onExitFinished,
        state,
        isExiting,
        duration,
        delay,
        paused,
        setTimeout
    ]);
    return children({
        ref: staggered.ref,
        // @ts-expect-error: `ax` is not typed correctly
        className: hasAnimationStyles ? (0, $hUbY6.default)([
            (0, $hUbY6.default)([
                "_1o51eoah _1y0co91m _1bumglyw _sedtglyw"
            ]),
            paused && (0, $hUbY6.default)([
                "_1y0ctrqk"
            ]),
            duration === 'small' && (0, $hUbY6.default)([
                "_5sag1yx9"
            ]),
            duration === 'medium' && (0, $hUbY6.default)([
                "_5sag1ttt"
            ]),
            duration === 'large' && (0, $hUbY6.default)([
                "_5sagpwmj"
            ]),
            isExiting && duration === 'small' && (0, $hUbY6.default)([
                "_5sag14ed"
            ]),
            isExiting && duration === 'medium' && (0, $hUbY6.default)([
                "_5sagluct"
            ]),
            isExiting && duration === 'large' && (0, $hUbY6.default)([
                "_5sag1ttt"
            ]),
            isExiting && (0, $hUbY6.default)([
                "_ju255cps _1o51q7pw"
            ]),
            !isExiting && animationTimingFunction === 'linear' && (0, $hUbY6.default)([
                "_1pglp3kn"
            ]),
            !isExiting && animationTimingFunction === 'ease-out' && (0, $hUbY6.default)([
                "_1pgldkwg"
            ]),
            !isExiting && animationTimingFunction === 'ease-in' && (0, $hUbY6.default)([
                "_1pgl1nzg"
            ]),
            !isExiting && animationTimingFunction === 'ease-in-40-out' && (0, $hUbY6.default)([
                "_1pgl5y64"
            ]),
            !isExiting && animationTimingFunction === 'ease-in-60-out' && (0, $hUbY6.default)([
                "_1pgl1ddy"
            ]),
            !isExiting && animationTimingFunction === 'ease-in-80-out' && (0, $hUbY6.default)([
                "_1pglannl"
            ]),
            !isExiting && animationTimingFunction === 'ease-in-out' && (0, $hUbY6.default)([
                "_1pgl1fu8"
            ]),
            isExiting && animationTimingFunction === 'linear' && (0, $hUbY6.default)([
                "_1pglp3kn"
            ]),
            isExiting && animationTimingFunctionExiting === 'ease-out' && (0, $hUbY6.default)([
                "_1pgldkwg"
            ]),
            isExiting && animationTimingFunctionExiting === 'ease-in' && (0, $hUbY6.default)([
                "_1pgl1nzg"
            ]),
            isExiting && animationTimingFunctionExiting === 'ease-in-40-out' && (0, $hUbY6.default)([
                "_1pgl5y64"
            ]),
            isExiting && animationTimingFunctionExiting === 'ease-in-60-out' && (0, $hUbY6.default)([
                "_1pgl1ddy"
            ]),
            isExiting && animationTimingFunctionExiting === 'ease-in-80-out' && (0, $hUbY6.default)([
                "_1pglannl"
            ]),
            isExiting && animationTimingFunctionExiting === 'ease-in-out' && (0, $hUbY6.default)([
                "_1pgl1fu8"
            ]),
            (!isExiting && enteringAnimation === 'fade-in' || isExiting && exitingAnimation === 'fade-in') && (0, $hUbY6.default)([
                "_j7hq1cgr"
            ]),
            (!isExiting && enteringAnimation === 'fade-out' || isExiting && exitingAnimation === 'fade-out') && (0, $hUbY6.default)([
                "_j7hq1lln"
            ]),
            (!isExiting && enteringAnimation === 'zoom-in' || isExiting && exitingAnimation === 'zoom-in') && (0, $hUbY6.default)([
                "_j7hqe8p0"
            ]),
            (!isExiting && enteringAnimation === 'zoom-out' || isExiting && exitingAnimation === 'zoom-out') && (0, $hUbY6.default)([
                "_j7hqy6ql"
            ]),
            (!isExiting && enteringAnimation === 'slide-in-from-top' || isExiting && exitingAnimation === 'slide-in-from-top') && (0, $hUbY6.default)([
                "_j7hqqshu"
            ]),
            (!isExiting && enteringAnimation === 'slide-out-from-top' || isExiting && exitingAnimation === 'slide-out-from-top') && (0, $hUbY6.default)([
                "_j7hq7ri4"
            ]),
            (!isExiting && enteringAnimation === 'slide-in-from-right' || isExiting && exitingAnimation === 'slide-in-from-right') && (0, $hUbY6.default)([
                "_j7hqdfjr"
            ]),
            (!isExiting && enteringAnimation === 'slide-out-from-right' || isExiting && exitingAnimation === 'slide-out-from-right') && (0, $hUbY6.default)([
                "_j7hqonfj"
            ]),
            (!isExiting && enteringAnimation === 'slide-in-from-bottom' || isExiting && exitingAnimation === 'slide-in-from-bottom') && (0, $hUbY6.default)([
                "_j7hq1liq"
            ]),
            (!isExiting && enteringAnimation === 'slide-out-from-bottom' || isExiting && exitingAnimation === 'slide-out-from-bottom') && (0, $hUbY6.default)([
                "_j7hqhnf1"
            ]),
            (!isExiting && enteringAnimation === 'slide-in-from-left' || isExiting && exitingAnimation === 'slide-in-from-left') && (0, $hUbY6.default)([
                "_j7hq1bh1"
            ]),
            (!isExiting && enteringAnimation === 'slide-out-from-left' || isExiting && exitingAnimation === 'slide-out-from-left') && (0, $hUbY6.default)([
                "_j7hqj08w"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-top' || isExiting && exitingAnimation === 'fade-in-from-top') && (0, $hUbY6.default)([
                "_j7hq2iua"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-top' || isExiting && exitingAnimation === 'fade-out-from-top') && (0, $hUbY6.default)([
                "_j7hq39va"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-left' || isExiting && exitingAnimation === 'fade-in-from-left') && (0, $hUbY6.default)([
                "_j7hq15m2"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-left' || isExiting && exitingAnimation === 'fade-out-from-left') && (0, $hUbY6.default)([
                "_j7hq1yiv"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-bottom' || isExiting && exitingAnimation === 'fade-in-from-bottom') && (0, $hUbY6.default)([
                "_j7hq1w00"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-bottom' || isExiting && exitingAnimation === 'fade-out-from-bottom') && (0, $hUbY6.default)([
                "_j7hqzy3z"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-right' || isExiting && exitingAnimation === 'fade-in-from-right') && (0, $hUbY6.default)([
                "_j7hqpqak"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-right' || isExiting && exitingAnimation === 'fade-out-from-right') && (0, $hUbY6.default)([
                "_j7hq1ebg"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-top-constant' || isExiting && exitingAnimation === 'fade-in-from-top-constant') && (0, $hUbY6.default)([
                "_j7hqm2e2"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-top-constant' || isExiting && exitingAnimation === 'fade-out-from-top-constant') && (0, $hUbY6.default)([
                "_j7hq97jn"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-left-constant' || isExiting && exitingAnimation === 'fade-in-from-left-constant') && (0, $hUbY6.default)([
                "_j7hqovgq"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-left-constant' || isExiting && exitingAnimation === 'fade-out-from-left-constant') && (0, $hUbY6.default)([
                "_j7hq15do"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-bottom-constant' || isExiting && exitingAnimation === 'fade-in-from-bottom-constant') && (0, $hUbY6.default)([
                "_j7hq797a"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-bottom-constant' || isExiting && exitingAnimation === 'fade-out-from-bottom-constant') && (0, $hUbY6.default)([
                "_j7hqwo7r"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-right-constant' || isExiting && exitingAnimation === 'fade-in-from-right-constant') && (0, $hUbY6.default)([
                "_j7hqt8u5"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-right-constant' || isExiting && exitingAnimation === 'fade-out-from-right-constant') && (0, $hUbY6.default)([
                "_j7hq1pgp"
            ])
        ]) : '',
        style: {
            animationDelay: "".concat(delay, "ms")
        }
    }, state);
};
var $73df915ab798b295$export$2e2bcd8739ae039 = $73df915ab798b295$var$EnteringMotion;

});
parcelRegister("3OcVm", function(module, exports) {
$parcel$export(module.exports, "durations", () => $2c601115b8ebafb2$export$38b928a7167ce124);
/**
 * Think of this as the motion equivalent of the @atlaskit/theme `grid()`.
 */ var $2c601115b8ebafb2$export$368bacef0dacbe05 = 25;
var $2c601115b8ebafb2$export$38b928a7167ce124 = {
    none: 0,
    small: 100,
    medium: 350,
    large: 700
};

});

parcelRegister("iyKTS", function(module, exports) {
$parcel$export(module.exports, "exitingDurations", () => $d82fc86192235ee8$export$30fa1a2e62ae150c);

var $3OcVm = parcelRequire("3OcVm");
/**
 * Used to multiply the initial duration for exiting motions.
 */ var $d82fc86192235ee8$var$EXITING_MOTION_MULTIPLIER = 0.5;
var $d82fc86192235ee8$export$30fa1a2e62ae150c = {
    none: (0, $3OcVm.durations).none,
    small: (0, $3OcVm.durations).small * $d82fc86192235ee8$var$EXITING_MOTION_MULTIPLIER,
    medium: (0, $3OcVm.durations).medium * $d82fc86192235ee8$var$EXITING_MOTION_MULTIPLIER,
    large: (0, $3OcVm.durations).large * $d82fc86192235ee8$var$EXITING_MOTION_MULTIPLIER
};

});

parcelRegister("goQmH", function(module, exports) {
$parcel$export(module.exports, "isReducedMotion", () => $bf0781deb46a3b44$export$b7baf7667a68d87c);

var $lHWh4 = parcelRequire("lHWh4");
var $bf0781deb46a3b44$export$b7baf7667a68d87c = function isReducedMotion() {
    if (!(0, $lHWh4.isMatchMediaAvailable)()) return false;
    var _window$matchMedia = window.matchMedia('(prefers-reduced-motion: reduce)'), matches = _window$matchMedia.matches;
    return matches;
};

});
parcelRegister("lHWh4", function(module, exports) {
$parcel$export(module.exports, "isMatchMediaAvailable", () => $fcdad12c5cbe7652$export$c5406bd59b374abd);
var $fcdad12c5cbe7652$export$c5406bd59b374abd = function isMatchMediaAvailable() {
    return typeof window !== 'undefined' && 'matchMedia' in window;
};

});


parcelRegister("cpUWc", function(module, exports) {
$parcel$export(module.exports, "useSetTimeout", () => $90a3fc7fb32680dc$export$4f34107a2b00f39c);

var $5FkrB = parcelRequire("5FkrB");
// Handle both browser and Node.js environments
var $90a3fc7fb32680dc$var$getHookDeps = function getHookDeps(opts) {
    switch(opts.cleanup){
        case 'next-effect':
            return undefined;
        case 'unmount':
        default:
            return [];
    }
};
var $90a3fc7fb32680dc$export$4f34107a2b00f39c = function useSetTimeout() {
    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        cleanup: 'unmount'
    };
    var timeouts = (0, $5FkrB.useRef)([]);
    (0, $5FkrB.useEffect)(function() {
        return function() {
            if (timeouts.current.length) {
                timeouts.current.forEach(function(id) {
                    return clearTimeout(id);
                });
                timeouts.current = [];
            }
        };
    // We dynamically set this so we either clean up on the next effect - or on unmount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, $90a3fc7fb32680dc$var$getHookDeps(opts));
    return (0, $5FkrB.useCallback)(function(handler, timeout) {
        for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)args[_key - 2] = arguments[_key];
        var id = setTimeout.apply(void 0, [
            function() {
                timeouts.current = timeouts.current.filter(function(timeoutId) {
                    return timeoutId !== id;
                });
                handler();
            },
            timeout
        ].concat(args));
        timeouts.current.push(id);
    }, []);
};

});

parcelRegister("dOcZq", function(module, exports) {
$parcel$export(module.exports, "useStaggeredEntrance", () => $a0da055882eb927b$export$25c7213fc07ec080);

var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");

var $4NddD = parcelRequire("4NddD");

var $48OUL = parcelRequire("48OUL");

var $6iVsC = parcelRequire("6iVsC");
var $a0da055882eb927b$var$StaggeredEntranceContext = /*#__PURE__*/ (0, $5FkrB.createContext)(function() {
    return {
        isReady: true,
        delay: 0,
        ref: (0, $4NddD.default)
    };
});
var $a0da055882eb927b$export$25c7213fc07ec080 = function useStaggeredEntrance() {
    var indentifier = (0, $6iVsC.useUniqueId)();
    var context = (0, $5FkrB.useContext)($a0da055882eb927b$var$StaggeredEntranceContext);
    return context(indentifier);
};
/**
 * For a list of elements that need to animate in,
 * this should be used in conjunction with entering components.
 * This does not need Javascript to execute so it will run immediately for any SSR rendered React apps before the JS has executed.
 *
 * Will dynamically add delay to each child entering component.
 * Unfortunately all entering components _NEED_ to be a direct descendant.
 */ var $a0da055882eb927b$var$StaggeredEntrance = function StaggeredEntrance(_ref) {
    var children = _ref.children, column = _ref.column, _ref$columns = _ref.columns, columns = _ref$columns === void 0 ? 'responsive' : _ref$columns, _ref$delayStep = _ref.delayStep, delayStep = _ref$delayStep === void 0 ? 50 : _ref$delayStep;
    var elementRefs = (0, $5FkrB.useRef)([]);
    var indexes = [];
    var _useState = (0, $5FkrB.useState)(function() {
        if (typeof columns === 'number') // A hardcoded columns is set so bail out and set it to that!
        return columns;
        if (typeof column === 'number') // A hardcoded column is set so we will set actualColumns to be 1.
        return 1;
        // We are in "responsive" mode.
        // So we will be calculating when the Javascript executes on the client how many columns there will be.
        return 0;
    }), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), actualColumns = _useState2[0], setActualColumns = _useState2[1];
    (0, $48OUL.useLayoutEffect)(function() {
        // We want to only run this code when we are in "responsive" mode.
        // It is assumed we are in responsive mode if `columns` is "responsive",
        // we have children element refs ready to be read (i.e. if there are no children this won't run as well)
        // and finally that `actualColumns` is `0` - this is because for the first render cycle `actualColumns` will be `0` (set above)
        // and then after this layout effect runs the value for `actualColumns` will then be calculated and set.
        if (columns === 'responsive' && elementRefs.current.length && actualColumns === 0) {
            var currentTop = 0;
            var numberColumns = 0;
            if (elementRefs.current.length <= 1) {
                setActualColumns(1);
                return;
            }
            // We set the current top to the first elements.
            // We will be comparing this and incrementing the column count
            // until we hit an element that has a different offset top (or we run out of elements).
            currentTop = elementRefs.current[0] ? elementRefs.current[0].offsetTop : 0;
            for(var i = 0; i < elementRefs.current.length; i++){
                var child = elementRefs.current[i];
                if (!child) break;
                if (currentTop === child.offsetTop) {
                    numberColumns += 1;
                    if (elementRefs.current.length - 1 === i) setActualColumns(numberColumns);
                    continue;
                }
                setActualColumns(numberColumns);
                break;
            }
        }
    // We only want this effect to run once - on initial mount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement($a0da055882eb927b$var$StaggeredEntranceContext.Provider, {
        value: function value(id) {
            if (!indexes.includes(id)) indexes.push(id);
            var isReady = actualColumns > 0;
            var index = indexes.indexOf(id);
            var currentColumn = column || index % actualColumns;
            var currentRow = Math.floor(index / actualColumns);
            var distanceFromTopLeftElement = currentRow + currentColumn;
            // We don't want loads of elements to have the same staggered delay as it ends up looking slow for users.
            // To get around that we calculate the logarithm using `distanceFromTopLeftElement` which ends making
            // elements appear faster the further away from the top left element.
            var delay = Math.ceil(Math.log(distanceFromTopLeftElement + 1) * delayStep * 1.5) || 0;
            return {
                delay: delay,
                isReady: isReady,
                ref: function ref(element) {
                    return elementRefs.current[index] = element;
                }
            };
        }
    }, children);
};
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$a0da055882eb927b$export$2e2bcd8739ae039 = $a0da055882eb927b$var$StaggeredEntrance;

});
parcelRegister("48OUL", function(module, exports) {
$parcel$export(module.exports, "useLayoutEffect", () => $303f67566f648a2a$export$e5c5a5f917a5871c);

var $5FkrB = parcelRequire("5FkrB");
var $303f67566f648a2a$export$e5c5a5f917a5871c = typeof window === 'undefined' ? (0, $5FkrB.useEffect) : (0, $5FkrB.useLayoutEffect);

});

parcelRegister("6iVsC", function(module, exports) {
$parcel$export(module.exports, "useUniqueId", () => $4970fefdc35dfd6b$export$c485849f2e393253);
/* eslint-disable @repo/internal/react/disallow-unstable-values */ 
var $5FkrB = parcelRequire("5FkrB");
function $4970fefdc35dfd6b$export$c485849f2e393253() {
    var identifier = (0, $5FkrB.useRef)('');
    if (!identifier.current) identifier.current = '_' + (Number(String(Math.random()).slice(2)) + Date.now() + Math.round(performance.now())).toString(36);
    return identifier.current;
}

});




parcelRegister("fKwEs", function(module, exports) {
$parcel$export(module.exports, "Popper", () => $b7747ad0215747df$export$badac9ada3a0bdf9);

var $fC8ib = parcelRequire("fC8ib");

var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");

var $lsgol = parcelRequire("lsgol");

var $k2Okn = parcelRequire("k2Okn");

// Export types from PopperJS / React Popper
var $b7747ad0215747df$var$viewportPadding = 5;
var $b7747ad0215747df$var$constantModifiers = [
    {
        name: 'flip',
        options: {
            flipVariations: false,
            padding: $b7747ad0215747df$var$viewportPadding,
            boundary: 'clippingParents',
            rootBoundary: 'viewport'
        }
    }
];
function $b7747ad0215747df$var$defaultChildrenFn() {
    return null;
}
var $b7747ad0215747df$var$defaultOffset = [
    0,
    8
];
function $b7747ad0215747df$export$badac9ada3a0bdf9(_ref) {
    var _ref$children = _ref.children, children = _ref$children === void 0 ? $b7747ad0215747df$var$defaultChildrenFn : _ref$children, _ref$offset = _ref.offset, offset = _ref$offset === void 0 ? $b7747ad0215747df$var$defaultOffset : _ref$offset, _ref$placement = _ref.placement, placement = _ref$placement === void 0 ? 'bottom-start' : _ref$placement, _ref$referenceElement = _ref.referenceElement, referenceElement = _ref$referenceElement === void 0 ? undefined : _ref$referenceElement, modifiers = _ref.modifiers, _ref$strategy = _ref.strategy, strategy = _ref$strategy === void 0 ? 'fixed' : _ref$strategy, _ref$shouldFitViewpor = _ref.shouldFitViewport, shouldFitViewport = _ref$shouldFitViewpor === void 0 ? false : _ref$shouldFitViewpor;
    var _offset = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(offset, 2), offsetX = _offset[0], offsetY = _offset[1];
    var internalModifiers = (0, $5FkrB.useMemo)(function() {
        var preventOverflowModifier = {
            name: 'preventOverflow',
            options: {
                padding: $b7747ad0215747df$var$viewportPadding,
                rootBoundary: shouldFitViewport ? 'viewport' : 'document'
            }
        };
        var offsetModifier = {
            name: 'offset',
            options: {
                offset: [
                    offsetX,
                    offsetY
                ]
            }
        };
        var maxSizeModifiers = shouldFitViewport ? (0, $k2Okn.getMaxSizeModifiers)({
            viewportPadding: $b7747ad0215747df$var$viewportPadding
        }) : [];
        // @ts-ignore Type errors from incompatible @popperjs/core versions between Jira and AFM Platform... we are using ts-ignore here because ts-expect-error will cause an "Unused '@ts-expect-error' directive." error
        return [].concat($b7747ad0215747df$var$constantModifiers, [
            preventOverflowModifier,
            offsetModifier
        ], (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(maxSizeModifiers));
    }, [
        offsetX,
        offsetY,
        shouldFitViewport
    ]);
    // Merge custom props and memoize
    var mergedModifiers = (0, $5FkrB.useMemo)(function() {
        if (modifiers == null) return internalModifiers;
        return [].concat((0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(internalModifiers), (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(modifiers));
    }, [
        internalModifiers,
        modifiers
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $lsgol.Popper), {
        modifiers: mergedModifiers,
        placement: placement,
        strategy: strategy,
        referenceElement: referenceElement
    }, children);
}

});
parcelRegister("k2Okn", function(module, exports) {
$parcel$export(module.exports, "getMaxSizeModifiers", () => $e97b0897db6ae2ef$export$6d8c2b45c99d6e3f);

var $iYJcE = parcelRequire("iYJcE");
function $e97b0897db6ae2ef$export$6d8c2b45c99d6e3f(_ref) {
    var viewportPadding = _ref.viewportPadding;
    return [
        {
            /**
     * Performing DOM measurements in the 'read' phase,
     * which is the convention for popper modifiers
     */ name: 'maxSizeData',
            enabled: true,
            phase: 'read',
            fn: function fn(_ref2) {
                var state = _ref2.state, name = _ref2.name;
                if (!window.visualViewport) return;
                state.modifiersData[name] = {
                    viewport: {
                        width: window.visualViewport.width,
                        height: window.visualViewport.height
                    }
                };
            }
        },
        {
            /**
     * Applying max size CSS
     */ name: 'maxSize',
            enabled: true,
            phase: 'beforeWrite',
            requiresIfExists: [
                'offset',
                'preventOverflow',
                'flip'
            ],
            fn: function fn(_ref3) {
                var _data$viewport, _data$viewport2, _state$modifiersData$2, _state$modifiersData;
                var state = _ref3.state;
                var data = state.modifiersData.maxSizeData;
                if (typeof (data === null || data === void 0 || (_data$viewport = data.viewport) === null || _data$viewport === void 0 ? void 0 : _data$viewport.width) !== 'number' || typeof (data === null || data === void 0 || (_data$viewport2 = data.viewport) === null || _data$viewport2 === void 0 ? void 0 : _data$viewport2.height) !== 'number') // This shouldn't occur in a real browser but might in non-browser test environments
                return;
                var viewport = data.viewport;
                var _state$modifiersData$ = state.modifiersData.popperOffsets, popperOffsets = _state$modifiersData$ === void 0 ? {
                    x: 0,
                    y: 0
                } : _state$modifiersData$;
                var _state$placement$spli = state.placement.split('-'), _state$placement$spli2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_state$placement$spli, 1), basePlacement = _state$placement$spli2[0];
                var placementOffset = (_state$modifiersData$2 = (_state$modifiersData = state.modifiersData) === null || _state$modifiersData === void 0 || (_state$modifiersData = _state$modifiersData.offset) === null || _state$modifiersData === void 0 ? void 0 : _state$modifiersData[state.placement]) !== null && _state$modifiersData$2 !== void 0 ? _state$modifiersData$2 : {
                    x: 0,
                    y: 0
                };
                // By default we set these to the entire viewport (minus padding)
                // Each placement direction will overwrite one of these
                var maxWidth = viewport.width - 2 * viewportPadding;
                var maxHeight = viewport.height - 2 * viewportPadding;
                if (basePlacement === 'top') maxHeight = state.rects.reference.y + // Viewport-relative position of reference element
                placementOffset.y - // Space between popper and reference
                viewportPadding;
                if (basePlacement === 'bottom') maxHeight = viewport.height - popperOffsets.y - // Viewport-relative position of popper
                viewportPadding;
                if (basePlacement === 'left') maxWidth = state.rects.reference.x + // Viewport-relative position of reference element
                placementOffset.x - // Space between popper and reference
                viewportPadding;
                if (basePlacement === 'right') maxWidth = viewport.width - popperOffsets.x - // Viewport-relative position of popper
                viewportPadding;
                state.styles.popper.maxWidth = "".concat(maxWidth, "px");
                state.styles.popper.maxHeight = "".concat(maxHeight, "px");
            }
        }
    ];
}

});


parcelRegister("gpRYR", function(module, exports) {
$parcel$export(module.exports, "default", () => $bf38da8ef7454e3e$export$2e2bcd8739ae039);

var $5FkrB = parcelRequire("5FkrB");

var $5VFxW = parcelRequire("5VFxW");

var $iGKew = parcelRequire("iGKew");

var $9gATZ = parcelRequire("9gATZ");

var $2VTO8 = parcelRequire("2VTO8");

var $cZbNm = parcelRequire("cZbNm");
function $bf38da8ef7454e3e$export$2e2bcd8739ae039(_ref) {
    var _ref$zIndex = _ref.zIndex, zIndex = _ref$zIndex === void 0 ? 0 : _ref$zIndex, children = _ref.children, _ref$mountStrategy = _ref.mountStrategy, mountStrategy = _ref$mountStrategy === void 0 ? 'effect' : _ref$mountStrategy, _ref$isClosed = _ref.isClosed, isClosed = _ref$isClosed === void 0 ? false : _ref$isClosed;
    var isSubsequentRender = (0, $2VTO8.default)(mountStrategy);
    (0, $cZbNm.default)(zIndex);
    return !(0, $5VFxW.fg)('platform_design_system_team_portal_logic_r18_fix') ? isSubsequentRender ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $iGKew.default), {
        zIndex: zIndex,
        isClosed: isClosed
    }, children) : null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $9gATZ.default), {
        zIndex: zIndex,
        isClosed: isClosed
    }, children);
}

});
parcelRegister("iGKew", function(module, exports) {
$parcel$export(module.exports, "default", () => $d9b0033567edd3c7$export$2e2bcd8739ae039);

var $5FkrB = parcelRequire("5FkrB");

var $aLeHs = parcelRequire("aLeHs");

var $5nOvn = parcelRequire("5nOvn");
var $8LRuV = parcelRequire("8LRuV");

var $SGOeg = parcelRequire("SGOeg");

var $5VFxW = parcelRequire("5VFxW");

var $ilj8P = parcelRequire("ilj8P");

var $fTWYt = parcelRequire("fTWYt");

var $gdurP = parcelRequire("gdurP");
function $d9b0033567edd3c7$export$2e2bcd8739ae039(props) {
    var zIndex = props.zIndex, children = props.children, _props$isClosed = props.isClosed, isClosed = _props$isClosed === void 0 ? false : _props$isClosed;
    var container = (0, $5FkrB.useMemo)(function() {
        return (0, $fTWYt.createContainer)(zIndex);
    }, [
        zIndex
    ]);
    var colorMode = (0, $8LRuV.useColorMode)();
    var isInsideThemeProvider = (0, $SGOeg.useIsInsideThemeProvider)();
    // This is in the render method instead of useEffect so that
    // the portal will be added to the DOM before the children render.
    // For any further changes, ensure that the container does not have a
    // parent besides the portal parent.
    (0, $ilj8P.appendPortalContainerIfNotAppended)(container);
    (0, $5FkrB.useEffect)(function() {
        if ((0, $5VFxW.fg)('import_into_jsm_in_template_gallery_killswitch')) {
            if (isClosed) (0, $gdurP.removePortalContainer)(container);
        }
    }, [
        isClosed,
        container
    ]);
    (0, $5FkrB.useEffect)(function() {
        return function() {
            (0, $gdurP.removePortalContainer)(container);
        };
    }, [
        container
    ]);
    return /*#__PURE__*/ (0, $aLeHs.createPortal)(isInsideThemeProvider ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $5nOvn.default), {
        defaultColorMode: colorMode
    }, children) : children, container);
}

});
parcelRegister("5nOvn", function(module, exports) {
$parcel$export(module.exports, "default", () => $3eb646f90832f30b$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $kqp0i = parcelRequire("kqp0i");

var $fL8KA = parcelRequire("fL8KA");

var $25nEq = parcelRequire("25nEq");

var $iYJcE = parcelRequire("iYJcE");

var $970q7 = parcelRequire("970q7");

var $6HG4S = parcelRequire("6HG4S");

var $5FkrB = parcelRequire("5FkrB");

var $7QpUe = parcelRequire("7QpUe");

var $2Xia0 = parcelRequire("2Xia0");
var $jT0AC = parcelRequire("jT0AC");
var $6o2jv = parcelRequire("6o2jv");

var $fYEbK = parcelRequire("fYEbK");

var $dLBZC = parcelRequire("dLBZC");

var $buC9l = parcelRequire("buC9l");

var $bhsSk = parcelRequire("bhsSk");

var $0J1ha = parcelRequire("0J1ha");

var $gfmgU = parcelRequire("gfmgU");

var $SGOeg = parcelRequire("SGOeg");

var $10rn6 = parcelRequire("10rn6");
function $3eb646f90832f30b$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $3eb646f90832f30b$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $3eb646f90832f30b$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $3eb646f90832f30b$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $3eb646f90832f30b$var$defaultThemeSettings = {
    dark: 'dark',
    light: 'light',
    spacing: 'spacing',
    typography: 'typography'
};
var $3eb646f90832f30b$var$isMatchMediaAvailable = typeof window !== 'undefined' && 'matchMedia' in window;
var $3eb646f90832f30b$var$prefersDarkModeMql = $3eb646f90832f30b$var$isMatchMediaAvailable ? window.matchMedia('(prefers-color-scheme: dark)') : undefined;
// TODO: currently 'auto' color mode will always return 'light' in SSR.
// Additional work required: https://product-fabric.atlassian.net/browse/DSP-9781
function $3eb646f90832f30b$var$getReconciledColorMode(colorMode) {
    if (colorMode === 'auto') return $3eb646f90832f30b$var$prefersDarkModeMql !== null && $3eb646f90832f30b$var$prefersDarkModeMql !== void 0 && $3eb646f90832f30b$var$prefersDarkModeMql.matches ? 'dark' : 'light';
    return colorMode;
}
var $3eb646f90832f30b$var$contentStyles = {
    body: "_1e0c1bgi"
};
/**
 * __Theme provider__
 *
 * Provides global theming configuration.
 */ function $3eb646f90832f30b$var$ThemeProvider(_ref) {
    var children = _ref.children, _ref$defaultColorMode = _ref.defaultColorMode, defaultColorMode = _ref$defaultColorMode === void 0 ? 'auto' : _ref$defaultColorMode, defaultTheme = _ref.defaultTheme;
    var _useState = (0, $5FkrB.useState)(defaultColorMode), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), chosenColorMode = _useState2[0], setChosenColorMode = _useState2[1];
    var _useState3 = (0, $5FkrB.useState)($3eb646f90832f30b$var$getReconciledColorMode(defaultColorMode)), _useState4 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState3, 2), reconciledColorMode = _useState4[0], setReconciledColorMode = _useState4[1];
    var _useState5 = (0, $5FkrB.useState)(function() {
        return $3eb646f90832f30b$var$_objectSpread($3eb646f90832f30b$var$_objectSpread({}, $3eb646f90832f30b$var$defaultThemeSettings), defaultTheme);
    }), _useState6 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState5, 2), theme = _useState6[0], setTheme = _useState6[1];
    var setColorMode = (0, $5FkrB.useCallback)(function(colorMode) {
        setChosenColorMode(colorMode);
        setReconciledColorMode($3eb646f90832f30b$var$getReconciledColorMode(colorMode));
    }, []);
    var setPartialTheme = (0, $5FkrB.useCallback)(function(nextTheme) {
        setTheme(function(theme) {
            return $3eb646f90832f30b$var$_objectSpread($3eb646f90832f30b$var$_objectSpread({}, theme), nextTheme);
        });
    }, []);
    var lastSetGlobalThemePromiseRef = (0, $5FkrB.useRef)(null);
    var isInsideAppProvider = (0, $dLBZC.useIsInsideAppProvider)();
    var isAppProviderThemingEnabled = (0, $fYEbK.useIsAppProviderThemingEnabled)();
    var isInsideThemeProvider = (0, $SGOeg.useIsInsideThemeProvider)();
    /**
   * A top-level ThemeProvider is detected by being the first ThemeProvider inside an AppProvider.
   *
   * This will not use sub-tree theming but instead set the global theme state using the
   * `@atlaskit/tokens` APIs, as it's required for styling root `html` and `body` elements
   * for compatibility with `@atlaskit/css-reset`.
   *
   * In the future we could consider moving away from DOM mutations and require AppProvider to wrap
   * `html` in order to apply global theme state, which would allow a more consistent approach to
   * theme loading.
   */ var isRootThemeProvider = isInsideAppProvider && !isInsideThemeProvider && isAppProviderThemingEnabled;
    (0, $5FkrB.useEffect)(function() {
        if (isRootThemeProvider) {
            /**
       * We need to wait for any previous `setGlobalTheme` calls to finish before calling it again.
       * This is to prevent race conditions as `setGlobalTheme` is async and mutates the DOM (e.g. sets the
       * `data-color-mode` attribute on the root element).
       *
       * Since we can't safely abort the `setGlobalTheme` execution, we need to wait for it to properly finish before
       * applying the new theme.
       *
       * Without this, we can end up in the following scenario:
       * 1. app loads with the default 'light' theme, kicking off `setGlobalTheme`
       * 2. app switches to 'dark' theme after retrieving value persisted in local storage, calling `setGlobalTheme` again
       * 3. `setGlobalTheme` function execution for `dark` finishes before the initial `light` execution
       * 4. `setGlobalTheme` function execution for `light` then finishes, resulting in the 'light' theme being applied.
       */ var cleanupLastFnCall = /*#__PURE__*/ function() {
                var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee() {
                    var unbindFn;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                if (!lastSetGlobalThemePromiseRef.current) {
                                    _context.next = 2;
                                    break;
                                }
                                _context.next = 1;
                                return lastSetGlobalThemePromiseRef.current;
                            case 1:
                                unbindFn = _context.sent;
                                unbindFn();
                                lastSetGlobalThemePromiseRef.current = null;
                            case 2:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee);
                }));
                return function cleanupLastFnCall() {
                    return _ref2.apply(this, arguments);
                };
            }();
            var safelySetGlobalTheme = /*#__PURE__*/ function() {
                var _ref3 = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee2() {
                    var promise;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                _context2.next = 1;
                                return cleanupLastFnCall();
                            case 1:
                                promise = (0, $jT0AC.default)($3eb646f90832f30b$var$_objectSpread($3eb646f90832f30b$var$_objectSpread({}, theme), {}, {
                                    colorMode: reconciledColorMode
                                }));
                                lastSetGlobalThemePromiseRef.current = promise;
                            case 2:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2);
                }));
                return function safelySetGlobalTheme() {
                    return _ref3.apply(this, arguments);
                };
            }();
            safelySetGlobalTheme();
            return function cleanup() {
                cleanupLastFnCall();
            };
        } else // For other theme providers (whether outside AppProvider or nested inside a ThemeProvider),
        // we treat them as sub-tree themes that do not load global theme state.
        (0, $10rn6.loadAndMountThemes)(theme);
    }, [
        isInsideAppProvider,
        isInsideThemeProvider,
        isRootThemeProvider,
        reconciledColorMode,
        theme
    ]);
    (0, $5FkrB.useEffect)(function() {
        if (!$3eb646f90832f30b$var$prefersDarkModeMql) return;
        var unbindListener = (0, $7QpUe.bind)($3eb646f90832f30b$var$prefersDarkModeMql, {
            type: 'change',
            listener: function listener(event) {
                if (chosenColorMode === 'auto') setReconciledColorMode(event.matches ? 'dark' : 'light');
            }
        });
        return unbindListener;
    }, [
        chosenColorMode
    ]);
    var attrs = $3eb646f90832f30b$var$_objectSpread($3eb646f90832f30b$var$_objectSpread({}, (0, $2Xia0.default)($3eb646f90832f30b$var$_objectSpread($3eb646f90832f30b$var$_objectSpread({}, theme), {}, {
        colorMode: reconciledColorMode
    }))), {}, (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, (0, $6o2jv.SUBTREE_THEME_ATTRIBUTE), true));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $bhsSk.InsideThemeProviderContext).Provider, {
        value: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $buC9l.ColorModeContext).Provider, {
        value: reconciledColorMode
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $0J1ha.SetColorModeContext).Provider, {
        value: setColorMode
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $gfmgU.ThemeContext).Provider, {
        value: theme
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $gfmgU.SetThemeContext).Provider, {
        value: setPartialTheme
    }, !isRootThemeProvider ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, attrs, {
        className: (0, $970q7.default)([
            $3eb646f90832f30b$var$contentStyles.body
        ])
    }), children) : children)))));
}
var $3eb646f90832f30b$export$2e2bcd8739ae039 = $3eb646f90832f30b$var$ThemeProvider;

});
parcelRegister("2Xia0", function(module, exports) {
$parcel$export(module.exports, "default", () => $226f2dc102fc9bfc$export$2e2bcd8739ae039);

var $25nEq = parcelRequire("25nEq");

var $780Jk = parcelRequire("780Jk");

var $6o2jv = parcelRequire("6o2jv");

var $ltcA1 = parcelRequire("ltcA1");

var $4aRcc = parcelRequire("4aRcc");

var $7lZkr = parcelRequire("7lZkr");

var $a53P9 = parcelRequire("a53P9");
function $226f2dc102fc9bfc$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $226f2dc102fc9bfc$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $226f2dc102fc9bfc$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $226f2dc102fc9bfc$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $226f2dc102fc9bfc$var$defaultColorMode = 'light';
var $226f2dc102fc9bfc$var$defaultContrastMode = 'no-preference';
/**
 * Server-side rendering utility. Generates the valid HTML attributes for a given theme.
 * Note: this utility does not handle automatic theme switching.
 *
 * @param {Object<string, string>} themeOptions - Theme options object
 * @param {string} themeState.colorMode Determines which color theme is applied. If set to `auto`, the theme applied will be determined by the OS setting.
 * @param {string} themeState.dark The color theme to be applied when the color mode resolves to 'dark'.
 * @param {string} themeState.light The color theme to be applied when the color mode resolves to 'light'.
 * @param {string} themeState.motion The motion theme to be applied.
 * @param {string} themeState.spacing The spacing theme to be applied.
 * @param {string} themeState.typography The typography theme to be applied.
 * @param {Object} themeState.UNSAFE_themeOptions The custom branding options to be used for custom theme generation
 *
 * @returns {Object} Object of HTML attributes to be applied to the document root
 */ var $226f2dc102fc9bfc$var$getThemeHtmlAttrs = function getThemeHtmlAttrs() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, _ref$colorMode = _ref.colorMode, colorMode = _ref$colorMode === void 0 ? (0, $ltcA1.themeStateDefaults)['colorMode'] : _ref$colorMode, _ref$dark = _ref.dark, dark = _ref$dark === void 0 ? (0, $ltcA1.themeStateDefaults)['dark'] : _ref$dark, _ref$light = _ref.light, light = _ref$light === void 0 ? (0, $ltcA1.themeStateDefaults)['light'] : _ref$light, _ref$contrastMode = _ref.contrastMode, contrastMode = _ref$contrastMode === void 0 ? (0, $ltcA1.themeStateDefaults)['contrastMode'] : _ref$contrastMode, _ref$motion = _ref.motion, motion = _ref$motion === void 0 ? (0, $ltcA1.themeStateDefaults)['motion']() : _ref$motion, _ref$shape = _ref.shape, shape = _ref$shape === void 0 ? (0, $ltcA1.themeStateDefaults)['shape']() : _ref$shape, _ref$spacing = _ref.spacing, spacing = _ref$spacing === void 0 ? (0, $ltcA1.themeStateDefaults)['spacing'] : _ref$spacing, _ref$typography = _ref.typography, typography = _ref$typography === void 0 ? (0, $ltcA1.themeStateDefaults)['typography'] : _ref$typography, _ref$UNSAFE_themeOpti = _ref.UNSAFE_themeOptions, UNSAFE_themeOptions = _ref$UNSAFE_themeOpti === void 0 ? (0, $ltcA1.themeStateDefaults)['UNSAFE_themeOptions'] : _ref$UNSAFE_themeOpti;
    var themeAttribute = (0, $4aRcc.themeObjectToString)({
        dark: dark,
        light: light,
        motion: motion,
        shape: shape,
        spacing: spacing,
        typography: typography
    });
    var result = (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, (0, $6o2jv.THEME_DATA_ATTRIBUTE), themeAttribute), (0, $6o2jv.COLOR_MODE_ATTRIBUTE), colorMode === 'auto' ? $226f2dc102fc9bfc$var$defaultColorMode : colorMode);
    if ((0, $780Jk.fg)('platform_increased-contrast-themes')) result = $226f2dc102fc9bfc$var$_objectSpread($226f2dc102fc9bfc$var$_objectSpread({}, result), {}, (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, (0, $6o2jv.CONTRAST_MODE_ATTRIBUTE), contrastMode === 'auto' ? $226f2dc102fc9bfc$var$defaultContrastMode : contrastMode));
    if (UNSAFE_themeOptions && (0, $a53P9.isValidBrandHex)(UNSAFE_themeOptions.brandColor)) {
        var optionString = JSON.stringify(UNSAFE_themeOptions);
        var uniqueId = (0, $7lZkr.hash)(optionString);
        result[0, $6o2jv.CUSTOM_THEME_ATTRIBUTE] = uniqueId;
    }
    return result;
};
var $226f2dc102fc9bfc$export$2e2bcd8739ae039 = $226f2dc102fc9bfc$var$getThemeHtmlAttrs;

});
parcelRegister("4aRcc", function(module, exports) {
$parcel$export(module.exports, "themeObjectToString", () => $30a15c2a67071489$export$62c37ab81302621a);

var $ekGgq = parcelRequire("ekGgq");

var $iYJcE = parcelRequire("iYJcE");

var $aC0RE = parcelRequire("aC0RE");

var $4zxpk = parcelRequire("4zxpk");

var $e9flS = parcelRequire("e9flS");
var $30a15c2a67071489$var$customThemeOptions = 'UNSAFE_themeOptions';
var $30a15c2a67071489$export$62c37ab81302621a = function themeObjectToString(themeState) {
    return Object.entries(themeState).reduce(function(themeString, _ref) {
        var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_ref, 2), kind = _ref2[0], id = _ref2[1];
        if (// colorMode theme state
        kind === 'colorMode' && typeof id === 'string' && (0, $aC0RE.isColorMode)(id) || // custom theme state
        kind === $30a15c2a67071489$var$customThemeOptions && (0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(id) === 'object' || // other theme states
        (0, $e9flS.isThemeKind)(kind) && typeof id === 'string' && (0, $4zxpk.isThemeIds)(id)) return themeString + "".concat(themeString ? ' ' : '') + "".concat(kind, ":").concat((0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(id) === 'object' ? JSON.stringify(id) : id);
        return themeString;
    }, '');
};

});
parcelRegister("aC0RE", function(module, exports) {
$parcel$export(module.exports, "isColorMode", () => $7b9e1f9ebff48659$export$4a14e169b1de4ee7);
var $7b9e1f9ebff48659$export$4a14e169b1de4ee7 = function isColorMode(modeId) {
    return [
        'light',
        'dark',
        'auto'
    ].includes(modeId);
};

});

parcelRegister("4zxpk", function(module, exports) {
$parcel$export(module.exports, "isThemeIds", () => $35445857f88932d4$export$ea35b8958c39dd07);

var $hCl4F = parcelRequire("hCl4F");
var $35445857f88932d4$export$ea35b8958c39dd07 = function isThemeIds(themeId) {
    return (0, $hCl4F.themeIds).find(function(id) {
        return id === themeId;
    }) !== undefined;
};

});
parcelRegister("hCl4F", function(module, exports) {
$parcel$export(module.exports, "themeIds", () => $cd36553759507965$export$7d43e72a58e3283f);
/**
 * Theme ids: The value that will be mounted to the DOM as a data attr
 * For example: `data-theme="light:light dark:dark spacing:spacing"
 *
 * These ids must be kebab case
 */ var $cd36553759507965$export$7d43e72a58e3283f = [
    'light-increased-contrast',
    'light',
    'light-future',
    'dark',
    'dark-future',
    'dark-increased-contrast',
    'spacing',
    'shape',
    'typography',
    'motion'
];

});


parcelRegister("e9flS", function(module, exports) {
$parcel$export(module.exports, "isThemeKind", () => $a4cdd07e7afdbd92$export$958fa026be3a263e);
var $a4cdd07e7afdbd92$var$themeKinds = [
    'light',
    'dark',
    'spacing',
    'typography',
    'shape',
    'motion'
];
var $a4cdd07e7afdbd92$export$958fa026be3a263e = function isThemeKind(themeKind) {
    return $a4cdd07e7afdbd92$var$themeKinds.find(function(kind) {
        return kind === themeKind;
    }) !== undefined;
};

});


parcelRegister("a53P9", function(module, exports) {
$parcel$export(module.exports, "isValidBrandHex", () => $756d56646abc14e3$export$53031ac1ecb71f44);
var $756d56646abc14e3$export$53031ac1ecb71f44 = function isValidBrandHex(hex) {
    return /^#[0-9A-F]{6}$/i.test(hex);
};

});


parcelRegister("jT0AC", function(module, exports) {
$parcel$export(module.exports, "default", () => $e7a39c73da64aa79$export$2e2bcd8739ae039);

var $25nEq = parcelRequire("25nEq");

var $fL8KA = parcelRequire("fL8KA");

var $6HG4S = parcelRequire("6HG4S");

var $780Jk = parcelRequire("780Jk");

var $fsnJ0 = parcelRequire("fsnJ0");

var $ltcA1 = parcelRequire("ltcA1");

var $dALJo = parcelRequire("dALJo");

var $cO85j = parcelRequire("cO85j");

var $d5tkr = parcelRequire("d5tkr");

var $gjOVV = parcelRequire("gjOVV");

var $a53P9 = parcelRequire("a53P9");

var $1PVvE = parcelRequire("1PVvE");
function $e7a39c73da64aa79$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $e7a39c73da64aa79$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $e7a39c73da64aa79$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $e7a39c73da64aa79$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $e7a39c73da64aa79$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $e7a39c73da64aa79$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $e7a39c73da64aa79$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $e7a39c73da64aa79$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $e7a39c73da64aa79$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $e7a39c73da64aa79$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}

/**
 * Sets the theme globally at runtime. This updates the `data-theme` and `data-color-mode` attributes on your page's <html> tag.
 *
 * @param {Object<string, string>} themeState The themes and color mode that should be applied.
 * @param {string} themeState.colorMode Determines which color theme is applied. If set to `auto`, the theme applied will be determined by the OS setting.
 * @param {string} themeState.contrastMode The contrast mode theme to be applied. If set to `auto`, the theme applied will be determined by the OS setting.set to `auto`, the theme applied will be determined by the OS setting.
 * @param {string} themeState.dark The color theme to be applied when the color mode resolves to 'dark'.
 * @param {string} themeState.light The color theme to be applied when the color mode resolves to 'light'.
 * @param {string} themeState.motion The motion theme to be applied.
 * @param {string} themeState.shape The shape theme to be applied.
 * @param {string} themeState.spacing The spacing theme to be applied.
 * @param {string} themeState.typography The typography theme to be applied.
 * @param {Object} themeState.UNSAFE_themeOptions The custom branding options to be used for custom theme generation
 * @param {function} themeLoader Callback function used to override the default theme loading functionality.
 *
 * @returns A Promise of an unbind function, that can be used to stop listening for changes to system theme.
 *
 * @example
 * ```
 * setGlobalTheme({colorMode: 'auto', light: 'light', dark: 'dark', spacing: 'spacing'});
 * ```
 */ var $e7a39c73da64aa79$var$setGlobalTheme = /*#__PURE__*/ function() {
    var _ref = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee3() {
        var nextThemeState, themeLoader, _ref2, _ref2$colorMode, colorMode, _ref2$contrastMode, contrastMode, _ref2$dark, dark, _ref2$light, light, _ref2$shape, shape, _ref2$spacing, spacing, _ref2$typography, typography, _ref2$motion, motion, _ref2$UNSAFE_themeOpt, UNSAFE_themeOptions, themeState, themePreferences, loadingStrategy, loadingTasks, mode, attrOfMissingCustomStyles, themeOverridePreferences, _iterator, _step, themeId, autoUnbind, _args3 = arguments, _t;
        return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context3) {
            while(true)switch(_context3.prev = _context3.next){
                case 0:
                    nextThemeState = _args3.length > 0 && _args3[0] !== undefined ? _args3[0] : {};
                    themeLoader = _args3.length > 1 ? _args3[1] : undefined;
                    _ref2 = typeof nextThemeState === 'function' ? nextThemeState($e7a39c73da64aa79$var$_objectSpread($e7a39c73da64aa79$var$_objectSpread({}, (0, $ltcA1.themeStateDefaults)), {}, {
                        typography: (0, $ltcA1.themeStateDefaults)['typography'],
                        shape: (0, $ltcA1.themeStateDefaults)['shape'](),
                        motion: (0, $ltcA1.themeStateDefaults)['motion']()
                    }, (0, $fsnJ0.default)())) : nextThemeState, _ref2$colorMode = _ref2.colorMode, colorMode = _ref2$colorMode === void 0 ? (0, $ltcA1.themeStateDefaults)['colorMode'] : _ref2$colorMode, _ref2$contrastMode = _ref2.contrastMode, contrastMode = _ref2$contrastMode === void 0 ? (0, $ltcA1.themeStateDefaults)['contrastMode'] : _ref2$contrastMode, _ref2$dark = _ref2.dark, dark = _ref2$dark === void 0 ? (0, $ltcA1.themeStateDefaults)['dark'] : _ref2$dark, _ref2$light = _ref2.light, light = _ref2$light === void 0 ? (0, $ltcA1.themeStateDefaults)['light'] : _ref2$light, _ref2$shape = _ref2.shape, shape = _ref2$shape === void 0 ? (0, $ltcA1.themeStateDefaults)['shape']() : _ref2$shape, _ref2$spacing = _ref2.spacing, spacing = _ref2$spacing === void 0 ? (0, $ltcA1.themeStateDefaults)['spacing'] : _ref2$spacing, _ref2$typography = _ref2.typography, typography = _ref2$typography === void 0 ? (0, $ltcA1.themeStateDefaults)['typography'] : _ref2$typography, _ref2$motion = _ref2.motion, motion = _ref2$motion === void 0 ? (0, $ltcA1.themeStateDefaults)['motion']() : _ref2$motion, _ref2$UNSAFE_themeOpt = _ref2.UNSAFE_themeOptions, UNSAFE_themeOptions = _ref2$UNSAFE_themeOpt === void 0 ? (0, $ltcA1.themeStateDefaults)['UNSAFE_themeOptions'] : _ref2$UNSAFE_themeOpt; // CLEANUP: Remove. This blocks application of increased contrast themes
                    // without the feature flag enabled.
                    if (!(0, $780Jk.fg)('platform_increased-contrast-themes')) {
                        if (light === 'light-increased-contrast') light = 'light';
                        if (dark === 'dark-increased-contrast') dark = 'dark';
                    }
                    themeState = {
                        colorMode: colorMode,
                        contrastMode: contrastMode,
                        dark: dark,
                        light: light,
                        shape: shape,
                        spacing: spacing,
                        typography: typography,
                        motion: motion,
                        UNSAFE_themeOptions: themeLoader ? undefined : UNSAFE_themeOptions
                    }; // Determine what to load and loading strategy
                    themePreferences = (0, $gjOVV.getThemePreferences)(themeState);
                    loadingStrategy = themeLoader ? themeLoader : (0, $1PVvE.loadAndAppendThemeCss); // Load standard themes
                    loadingTasks = themePreferences.map(/*#__PURE__*/ function() {
                        var _ref3 = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee(themeId) {
                            return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context) {
                                while(true)switch(_context.prev = _context.next){
                                    case 0:
                                        _context.next = 1;
                                        return loadingStrategy(themeId);
                                    case 1:
                                        return _context.abrupt("return", _context.sent);
                                    case 2:
                                    case "end":
                                        return _context.stop();
                                }
                            }, _callee);
                        }));
                        return function(_x) {
                            return _ref3.apply(this, arguments);
                        };
                    }()); // Load custom themes if needed
                    if (!themeLoader && UNSAFE_themeOptions && (0, $a53P9.isValidBrandHex)(UNSAFE_themeOptions === null || UNSAFE_themeOptions === void 0 ? void 0 : UNSAFE_themeOptions.brandColor)) {
                        mode = colorMode || (0, $ltcA1.themeStateDefaults)['colorMode'];
                        attrOfMissingCustomStyles = (0, $cO85j.findMissingCustomStyleElements)(UNSAFE_themeOptions, mode);
                        if (attrOfMissingCustomStyles.length > 0) // Load custom theme styles
                        loadingTasks.push((0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee2() {
                            var _yield$import, loadAndAppendCustomThemeCss;
                            return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context2) {
                                while(true)switch(_context2.prev = _context2.next){
                                    case 0:
                                        _context2.next = 1;
                                        return (parcelRequire("hQcOh"));
                                    case 1:
                                        _yield$import = _context2.sent;
                                        loadAndAppendCustomThemeCss = _yield$import.loadAndAppendCustomThemeCss;
                                        loadAndAppendCustomThemeCss({
                                            colorMode: attrOfMissingCustomStyles.length === 2 ? 'auto' : // only load the missing custom theme styles
                                            attrOfMissingCustomStyles[0],
                                            UNSAFE_themeOptions: UNSAFE_themeOptions
                                        });
                                    case 2:
                                    case "end":
                                        return _context2.stop();
                                }
                            }, _callee2);
                        }))());
                    }
                    _context3.next = 1;
                    return Promise.all(loadingTasks);
                case 1:
                    // Load override themes after standard themes
                    themeOverridePreferences = (0, $d5tkr.getThemeOverridePreferences)(themeState);
                    _iterator = $e7a39c73da64aa79$var$_createForOfIteratorHelper(themeOverridePreferences);
                    _context3.prev = 2;
                    _iterator.s();
                case 3:
                    if ((_step = _iterator.n()).done) {
                        _context3.next = 5;
                        break;
                    }
                    themeId = _step.value;
                    _context3.next = 4;
                    return loadingStrategy(themeId);
                case 4:
                    _context3.next = 3;
                    break;
                case 5:
                    _context3.next = 7;
                    break;
                case 6:
                    _context3.prev = 6;
                    _t = _context3["catch"](2);
                    _iterator.e(_t);
                case 7:
                    _context3.prev = 7;
                    _iterator.f();
                    return _context3.finish(7);
                case 8:
                    autoUnbind = (0, $dALJo.default)(themeState);
                    return _context3.abrupt("return", autoUnbind);
                case 9:
                case "end":
                    return _context3.stop();
            }
        }, _callee3, null, [
            [
                2,
                6,
                7,
                8
            ]
        ]);
    }));
    return function setGlobalTheme() {
        return _ref.apply(this, arguments);
    };
}();
var $e7a39c73da64aa79$export$2e2bcd8739ae039 = $e7a39c73da64aa79$var$setGlobalTheme;

});
parcelRegister("fsnJ0", function(module, exports) {
$parcel$export(module.exports, "default", () => $b40bdfcf4a616ca8$export$2e2bcd8739ae039);

var $25nEq = parcelRequire("25nEq");

var $6o2jv = parcelRequire("6o2jv");

var $4McAs = parcelRequire("4McAs");

var $9Fabt = parcelRequire("9Fabt");
function $b40bdfcf4a616ca8$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $b40bdfcf4a616ca8$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $b40bdfcf4a616ca8$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $b40bdfcf4a616ca8$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $b40bdfcf4a616ca8$var$isThemeColorMode = function isThemeColorMode(colorMode) {
    return (0, $4McAs.themeColorModes).find(function(mode) {
        return mode === colorMode;
    }) !== undefined;
};
var $b40bdfcf4a616ca8$var$getGlobalTheme = function getGlobalTheme() {
    if (typeof document === 'undefined') return {};
    var element = document.documentElement;
    var colorMode = element.getAttribute((0, $6o2jv.COLOR_MODE_ATTRIBUTE)) || '';
    var theme = element.getAttribute((0, $6o2jv.THEME_DATA_ATTRIBUTE)) || '';
    return $b40bdfcf4a616ca8$var$_objectSpread($b40bdfcf4a616ca8$var$_objectSpread({}, (0, $9Fabt.themeStringToObject)(theme)), $b40bdfcf4a616ca8$var$isThemeColorMode(colorMode) && {
        colorMode: colorMode
    });
};
var $b40bdfcf4a616ca8$export$2e2bcd8739ae039 = $b40bdfcf4a616ca8$var$getGlobalTheme;

});
parcelRegister("4McAs", function(module, exports) {
$parcel$export(module.exports, "themeColorModes", () => $37a568a16cbd2d13$export$83993de8eb66733);
/**
 * Theme modes: The general purpose of a theme.
 * This attr is used to apply the appropriate system-preference option
 * It may also be used as a selector for mode-specific overrides such as light/dark images.
 * The idea is there may exist many color themes, but every theme must either fit into light or dark.
 */ var $37a568a16cbd2d13$export$83993de8eb66733 = [
    'light',
    'dark',
    'auto'
];

});

parcelRegister("9Fabt", function(module, exports) {
$parcel$export(module.exports, "themeStringToObject", () => $708fd7ba98fd6157$export$f19b488f7c0547ee);

var $iYJcE = parcelRequire("iYJcE");

var $aC0RE = parcelRequire("aC0RE");

var $4zxpk = parcelRequire("4zxpk");

var $e9flS = parcelRequire("e9flS");
var $708fd7ba98fd6157$var$customThemeOptions = 'UNSAFE_themeOptions';
var $708fd7ba98fd6157$export$f19b488f7c0547ee = function themeStringToObject(themeState) {
    return themeState.split(' ')// @ts-ignore - TS1501 TypeScript 5.9.2 upgrade
    .map(function(theme) {
        return theme.split(/:([^]*)/);
    }).reduce(function(themeObject, _ref) {
        var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_ref, 2), kind = _ref2[0], id = _ref2[1];
        if (kind === 'colorMode' && (0, $aC0RE.isColorMode)(id)) themeObject[kind] = id;
        if ((0, $e9flS.isThemeKind)(kind) && (0, $4zxpk.isThemeIds)(id)) // @ts-expect-error FIXME - this is a valid ts error
        themeObject[kind] = id;
        if (kind === $708fd7ba98fd6157$var$customThemeOptions) try {
            themeObject[$708fd7ba98fd6157$var$customThemeOptions] = JSON.parse(id);
        } catch (_unused) {
            new Error('Invalid custom theme string');
        }
        return themeObject;
    }, {});
};

});


parcelRegister("dALJo", function(module, exports) {
$parcel$export(module.exports, "default", () => $9e53a9907c3b882c$export$2e2bcd8739ae039);

var $iYJcE = parcelRequire("iYJcE");

var $780Jk = parcelRequire("780Jk");

var $2Xia0 = parcelRequire("2Xia0");

var $1GN5u = parcelRequire("1GN5u");

var $4exKQ = parcelRequire("4exKQ");
function $9e53a9907c3b882c$export$2e2bcd8739ae039(themeState) {
    if (themeState.colorMode === 'auto') {
        // Set colorMode based on the user preference
        themeState.colorMode = (0, $1GN5u.default).getColorMode();
        // Bind a listener (if one doesn't already exist) to keep colorMode updated
        (0, $1GN5u.default).bind();
    } else (0, $1GN5u.default).unbind();
    if ((0, $780Jk.fg)('platform_increased-contrast-themes')) {
        if (themeState.contrastMode === 'auto') {
            // Set contrastMode based on the user preference
            themeState.contrastMode = (0, $4exKQ.default).getContrastMode();
            // Bind a listener (if one doesn't already exist) to keep contrastMode updated
            (0, $4exKQ.default).bind();
        } else (0, $4exKQ.default).unbind();
    }
    var themeAttributes = (0, $2Xia0.default)(themeState);
    Object.entries(themeAttributes).forEach(function(_ref) {
        var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_ref, 2), key = _ref2[0], value = _ref2[1];
        document.documentElement.setAttribute(key, value);
    });
    return function() {
        (0, $1GN5u.default).unbind();
        if ((0, $780Jk.fg)('platform_increased-contrast-themes')) (0, $4exKQ.default).unbind();
    };
}

});
parcelRegister("1GN5u", function(module, exports) {
$parcel$export(module.exports, "default", () => $13afca741df4945b$export$2e2bcd8739ae039);

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $25nEq = parcelRequire("25nEq");

var $7QpUe = parcelRequire("7QpUe");

var $6o2jv = parcelRequire("6o2jv");

var $1PVvE = parcelRequire("1PVvE");
var $13afca741df4945b$var$isMatchMediaAvailable = typeof window !== 'undefined' && 'matchMedia' in window;
/**
 * Updates the current theme when the system theme changes. Should be bound
 * to an event listener listening on the '(prefers-color-scheme: dark)' query
 * @param e The event representing a change in system theme.
 */ function $13afca741df4945b$var$checkNativeListener(e) {
    var element = document.documentElement;
    element.setAttribute((0, $6o2jv.COLOR_MODE_ATTRIBUTE), e.matches ? 'dark' : 'light');
}
var $13afca741df4945b$var$darkModeMql = $13afca741df4945b$var$isMatchMediaAvailable && window.matchMedia((0, $1PVvE.darkModeMediaQuery));
var $13afca741df4945b$var$ColorModeObserver = /*#__PURE__*/ function() {
    function ColorModeObserver() {
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, ColorModeObserver);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "unbindThemeChangeListener", null);
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(ColorModeObserver, [
        {
            key: "getColorMode",
            value: function getColorMode() {
                if (!$13afca741df4945b$var$darkModeMql) return 'light';
                return $13afca741df4945b$var$darkModeMql !== null && $13afca741df4945b$var$darkModeMql !== void 0 && $13afca741df4945b$var$darkModeMql.matches ? 'dark' : 'light';
            }
        },
        {
            key: "bind",
            value: function bind() {
                if ($13afca741df4945b$var$darkModeMql && this.unbindThemeChangeListener === null) this.unbindThemeChangeListener = (0, $7QpUe.bind)($13afca741df4945b$var$darkModeMql, {
                    type: 'change',
                    listener: $13afca741df4945b$var$checkNativeListener
                });
            }
        },
        {
            key: "unbind",
            value: function unbind() {
                if (this.unbindThemeChangeListener) {
                    this.unbindThemeChangeListener();
                    this.unbindThemeChangeListener = null;
                }
            }
        }
    ]);
}();
/**
 * A singleton color mode observer - binds "auto" switching logic to a single `mediaQueryList` listener
 * that can be unbound by any consumer when no longer needed.
 */ var $13afca741df4945b$var$SingletonColorModeObserver = new $13afca741df4945b$var$ColorModeObserver();
var $13afca741df4945b$export$2e2bcd8739ae039 = $13afca741df4945b$var$SingletonColorModeObserver;

});
parcelRegister("1PVvE", function(module, exports) {
$parcel$export(module.exports, "loadAndAppendThemeCss", () => $15672a0d1f51b1ab$export$26cd7ae85c7144e5);
$parcel$export(module.exports, "darkModeMediaQuery", () => $15672a0d1f51b1ab$export$bb1e815119d30f8b);
$parcel$export(module.exports, "moreContrastMediaQuery", () => $15672a0d1f51b1ab$export$8662df6937d86fcb);

var $fL8KA = parcelRequire("fL8KA");

var $6HG4S = parcelRequire("6HG4S");

var $6o2jv = parcelRequire("6o2jv");

var $5oA3u = parcelRequire("5oA3u");
var $15672a0d1f51b1ab$export$26cd7ae85c7144e5 = /*#__PURE__*/ function() {
    var _ref = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee(themeId) {
        var themeCss, style;
        return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context) {
            while(true)switch(_context.prev = _context.next){
                case 0:
                    if (!document.head.querySelector("style[".concat((0, $6o2jv.THEME_DATA_ATTRIBUTE), "=\"").concat(themeId, "\"]:not([").concat((0, $6o2jv.CUSTOM_THEME_ATTRIBUTE), "])"))) {
                        _context.next = 1;
                        break;
                    }
                    return _context.abrupt("return");
                case 1:
                    if (themeId) {
                        _context.next = 2;
                        break;
                    }
                    return _context.abrupt("return");
                case 2:
                    _context.next = 3;
                    return (0, $5oA3u.loadThemeCss)(themeId);
                case 3:
                    themeCss = _context.sent;
                    style = document.createElement('style');
                    style.textContent = themeCss;
                    style.dataset.theme = themeId;
                    document.head.appendChild(style);
                case 4:
                case "end":
                    return _context.stop();
            }
        }, _callee);
    }));
    return function loadAndAppendThemeCss(_x) {
        return _ref.apply(this, arguments);
    };
}();
var $15672a0d1f51b1ab$export$bb1e815119d30f8b = '(prefers-color-scheme: dark)';
var $15672a0d1f51b1ab$export$8662df6937d86fcb = '(prefers-contrast: more)';

});
parcelRegister("5oA3u", function(module, exports) {
$parcel$export(module.exports, "loadThemeCss", () => $3edb2978b32cdce7$export$8a48286ed7df6720);

var $fL8KA = parcelRequire("fL8KA");

var $6HG4S = parcelRequire("6HG4S");

var $9tsqy = parcelRequire("9tsqy");
var $3edb2978b32cdce7$export$8a48286ed7df6720 = /*#__PURE__*/ function() {
    var _ref = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee(themeId) {
        var _yield$themeImportMap, themeCss;
        return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context) {
            while(true)switch(_context.prev = _context.next){
                case 0:
                    _context.next = 1;
                    return (0, $9tsqy.default)[themeId]();
                case 1:
                    _yield$themeImportMap = _context.sent;
                    themeCss = _yield$themeImportMap.default;
                    return _context.abrupt("return", themeCss);
                case 2:
                case "end":
                    return _context.stop();
            }
        }, _callee);
    }));
    return function loadThemeCss(_x) {
        return _ref.apply(this, arguments);
    };
}();

});
parcelRegister("9tsqy", function(module, exports) {
$parcel$export(module.exports, "default", () => $6e5cdf912c2de5d7$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 *
 * This file contains a dynamic import for each theme this package exports.
 * Themes are loaded asynchronously at runtime to minimise the amount of CSS we send to the client.
 * This allows users to compose their themes and only use the tokens that are requested.
 * When a new theme is created, the import should automatically be added to the map
 *
 * @codegen <<SignedSource::a20c72d683b08b594c5be4160eec5f78>>
 * @codegenCommand yarn build tokens
 */ 









var $6e5cdf912c2de5d7$var$themeImportsMap = {
    'light': function light() {
        return (parcelRequire("gFy4Z"));
    },
    'light-future': function lightFuture() {
        return (parcelRequire("6hxgO"));
    },
    'light-increased-contrast': function lightIncreasedContrast() {
        return (parcelRequire("kGGQc"));
    },
    'dark': function dark() {
        return (parcelRequire("1Px1h"));
    },
    'dark-future': function darkFuture() {
        return (parcelRequire("4zl6X"));
    },
    'dark-increased-contrast': function darkIncreasedContrast() {
        return (parcelRequire("g5BOX"));
    },
    'spacing': function spacing() {
        return (parcelRequire("7rzwA"));
    },
    'typography': function typography() {
        return (parcelRequire("exeGs"));
    },
    'shape': function shape() {
        return (parcelRequire("aC2aM"));
    },
    'motion': function motion() {
        return (parcelRequire("cQyB6"));
    }
};
var $6e5cdf912c2de5d7$export$2e2bcd8739ae039 = $6e5cdf912c2de5d7$var$themeImportsMap;

});




parcelRegister("4exKQ", function(module, exports) {
$parcel$export(module.exports, "default", () => $3152a7309816bc10$export$2e2bcd8739ae039);

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $25nEq = parcelRequire("25nEq");

var $7QpUe = parcelRequire("7QpUe");

var $6o2jv = parcelRequire("6o2jv");

var $1PVvE = parcelRequire("1PVvE");
var $3152a7309816bc10$var$isMatchMediaAvailable = typeof window !== 'undefined' && 'matchMedia' in window;
/**
 * Updates the current theme when the system contrast preference changes. Should be bound
 * to an event listener listening on the '(prefers-contrast: more)' query
 * @param e The event representing a change in system theme.
 */ function $3152a7309816bc10$var$checkNativeListener(e) {
    var element = document.documentElement;
    element.setAttribute((0, $6o2jv.CONTRAST_MODE_ATTRIBUTE), e.matches ? 'more' : 'no-preference');
}
var $3152a7309816bc10$var$contrastModeMql = $3152a7309816bc10$var$isMatchMediaAvailable && window.matchMedia((0, $1PVvE.moreContrastMediaQuery));
var $3152a7309816bc10$var$ContrastModeObserver = /*#__PURE__*/ function() {
    function ContrastModeObserver() {
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, ContrastModeObserver);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "unbindContrastChangeListener", null);
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(ContrastModeObserver, [
        {
            key: "getContrastMode",
            value: function getContrastMode() {
                if (!$3152a7309816bc10$var$contrastModeMql) return 'no-preference';
                return $3152a7309816bc10$var$contrastModeMql !== null && $3152a7309816bc10$var$contrastModeMql !== void 0 && $3152a7309816bc10$var$contrastModeMql.matches ? 'more' : 'no-preference';
            }
        },
        {
            key: "bind",
            value: function bind() {
                if ($3152a7309816bc10$var$contrastModeMql && this.unbindContrastChangeListener === null) this.unbindContrastChangeListener = (0, $7QpUe.bind)($3152a7309816bc10$var$contrastModeMql, {
                    type: 'change',
                    listener: $3152a7309816bc10$var$checkNativeListener
                });
            }
        },
        {
            key: "unbind",
            value: function unbind() {
                if (this.unbindContrastChangeListener) {
                    this.unbindContrastChangeListener();
                    this.unbindContrastChangeListener = null;
                }
            }
        }
    ]);
}();
/**
 * A singleton contrast mode observer - binds "auto" switching logic to a single `mediaQueryList` listener
 * that can be unbound by any consumer when no longer needed.
 */ var $3152a7309816bc10$var$SingletonContrastModeObserver = new $3152a7309816bc10$var$ContrastModeObserver();
var $3152a7309816bc10$export$2e2bcd8739ae039 = $3152a7309816bc10$var$SingletonContrastModeObserver;

});


parcelRegister("cO85j", function(module, exports) {
$parcel$export(module.exports, "findMissingCustomStyleElements", () => $95306d003f19db75$export$bd1ac9300b0e885a);

var $6o2jv = parcelRequire("6o2jv");

var $7lZkr = parcelRequire("7lZkr");
function $95306d003f19db75$export$bd1ac9300b0e885a(UNSAFE_themeOptions, mode) {
    var optionString = JSON.stringify(UNSAFE_themeOptions);
    var uniqueId = (0, $7lZkr.hash)(optionString);
    var attrOfMissingCustomStyles = [];
    (mode === 'auto' ? [
        'light',
        'dark'
    ] : [
        mode
    ]).forEach(function(themeId) {
        var element = document.head.querySelector("style[".concat((0, $6o2jv.CUSTOM_THEME_ATTRIBUTE), "=\"").concat(uniqueId, "\"][").concat((0, $6o2jv.THEME_DATA_ATTRIBUTE), "=\"").concat(themeId, "\"]"));
        if (element) // Append the existing custom styles to take precedence over others
        document.head.appendChild(element);
        else attrOfMissingCustomStyles.push(themeId);
    });
    return attrOfMissingCustomStyles;
}

});

parcelRegister("d5tkr", function(module, exports) {
$parcel$export(module.exports, "getThemeOverridePreferences", () => $98727e147b429fef$export$5d76d7014f4a5d08);

var $fC8ib = parcelRequire("fC8ib");
var $98727e147b429fef$export$5d76d7014f4a5d08 = function getThemeOverridePreferences(_themeState) {
    var themeOverridePreferences = [];
    return (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(new Set(themeOverridePreferences));
};

});

parcelRegister("gjOVV", function(module, exports) {
$parcel$export(module.exports, "getThemePreferences", () => $be15edfa1fe1c10f$export$dd6aeb7c823fc03d);

var $fC8ib = parcelRequire("fC8ib");

var $780Jk = parcelRequire("780Jk");

var $7hyHe = parcelRequire("7hyHe");

var $be15edfa1fe1c10f$export$dd6aeb7c823fc03d = function getThemePreferences(themeState) {
    var colorMode = themeState.colorMode, contrastMode = themeState.contrastMode, dark = themeState.dark, light = themeState.light, shape = themeState.shape, spacing = themeState.spacing, typography = themeState.typography, motion = themeState.motion;
    var autoColorModeThemes = [
        light,
        dark
    ];
    var themePreferences = [];
    if (colorMode === 'auto') {
        if (contrastMode !== 'no-preference' && (0, $780Jk.fg)('platform_increased-contrast-themes')) autoColorModeThemes.forEach(function(normalTheme) {
            var increasedContrastTheme = (0, $7hyHe.default)(normalTheme);
            if (increasedContrastTheme) autoColorModeThemes.push(increasedContrastTheme);
        });
        themePreferences.push.apply(themePreferences, autoColorModeThemes);
    } else {
        themePreferences.push(themeState[colorMode]);
        if (contrastMode !== 'no-preference' && (0, $780Jk.fg)('platform_increased-contrast-themes')) {
            var increasedContrastTheme = (0, $7hyHe.default)(themeState[colorMode]);
            if (increasedContrastTheme) themePreferences.push(increasedContrastTheme);
        }
    }
    [
        shape,
        spacing,
        typography,
        motion
    ].forEach(function(themeId) {
        if (themeId) themePreferences.push(themeId);
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(new Set(themePreferences));
};

});
parcelRegister("7hyHe", function(module, exports) {
$parcel$export(module.exports, "default", () => $54d508e0dda84ae7$export$2e2bcd8739ae039);

var $iYJcE = parcelRequire("iYJcE");

var $aSBrE = parcelRequire("aSBrE");
function $54d508e0dda84ae7$export$2e2bcd8739ae039(themeId) {
    var _Object$entries$find;
    return (_Object$entries$find = Object.entries((0, $aSBrE.default)).find(function(_ref) {
        var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_ref, 2), increasesContrastFor = _ref2[1].increasesContrastFor;
        return increasesContrastFor === themeId;
    })) === null || _Object$entries$find === void 0 ? void 0 : _Object$entries$find[1].id;
}

});
parcelRegister("aSBrE", function(module, exports) {
$parcel$export(module.exports, "default", () => $7ebbfe53da90c6ed$export$2e2bcd8739ae039);

var $fC8ib = parcelRequire("fC8ib");

var $hCl4F = parcelRequire("hCl4F");


var $ltcA1 = parcelRequire("ltcA1");
/**
 * Themes: The internal identifier of a theme.
 * These ids are what the actual theme files/folders are called.
 * style-dictionary will attempt to locate these in the file-system.
 */ /**
 * ThemeOverrides: The internal identifier of a theme override. Which are themes that contain
 * a subset of tokens intended to override an existing theme. These ids are what the actual
 * theme files/folders are called. style-dictionary will attempt to locate these in the file-system.
 * Theme overrides are temporary and there may not be any defined at times.
 */ /**
 * Theme kinds: The type of theme.
 * Some themes are entirely focused on Color, whilst others are purely focused on spacing.
 * In the future other types may be introduced such as typography.
 */ /**
 * Contrast preferences: The system contrast preference
 */ var $7ebbfe53da90c6ed$var$themeContrastModes = [
    'more',
    'no-preference',
    'auto'
];
/**
 * Theme override ids: the equivalent of themeIds for theme overrides.
 * Theme overrides are temporary and there may not be any defined at times.
 */ var $7ebbfe53da90c6ed$var$themeOverrideIds = [];
var $7ebbfe53da90c6ed$export$92ba366331403db2 = [].concat((0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))((0, $hCl4F.themeIds)), $7ebbfe53da90c6ed$var$themeOverrideIds);
/**
 * Theme to use a base. This will create the theme as
 * an extension with all token values marked as optional
 * to allow tokens to be overridden as required.
 */ /**
 * Palettes: The set of base tokens a given theme may be populated with.
 * For example: legacy light & dark themes use the "legacyPalette" containing colors from our
 * previous color set.
 */ /**
 * ThemeConfig: the source of truth for all theme meta-data.
 * This object should be used whenever interfacing with themes.
 */ var $7ebbfe53da90c6ed$var$themeConfig = {
    'atlassian-light': {
        id: 'light',
        displayName: 'Light Theme',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'light'
        }
    },
    'atlassian-light-future': {
        id: 'light-future',
        displayName: 'Future Light Theme',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'light'
        },
        override: 'light'
    },
    'atlassian-light-increased-contrast': {
        id: 'light-increased-contrast',
        displayName: 'Light Theme (increased contrast)',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'light'
        },
        extends: 'light',
        increasesContrastFor: 'light'
    },
    'atlassian-dark': {
        id: 'dark',
        displayName: 'Dark Theme',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'dark'
        }
    },
    'atlassian-dark-future': {
        id: 'dark-future',
        displayName: 'Future Dark Theme',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'dark'
        },
        override: 'light'
    },
    'atlassian-dark-increased-contrast': {
        id: 'dark-increased-contrast',
        displayName: 'Dark Theme (increased contrast)',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'dark'
        },
        extends: 'dark',
        increasesContrastFor: 'dark'
    },
    'atlassian-spacing': {
        id: 'spacing',
        displayName: 'Atlassian Spacing',
        palette: 'spacingScale',
        attributes: {
            type: 'spacing'
        }
    },
    'atlassian-typography': {
        id: 'typography',
        displayName: 'Atlassian Typography',
        palette: 'typographyPalette',
        attributes: {
            type: 'typography'
        }
    },
    'atlassian-shape': {
        id: 'shape',
        displayName: 'Shape',
        palette: 'shapePalette',
        attributes: {
            type: 'shape'
        }
    },
    'atlassian-motion': {
        id: 'motion',
        displayName: 'Motion',
        palette: 'motionPalette',
        attributes: {
            type: 'motion'
        }
    }
};
var /**
 * Represents theme state once mounted to the page
 * (the page doesn't have an "auto" color mode, it's either light or dark)
 */ // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$7ebbfe53da90c6ed$export$2e2bcd8739ae039 = $7ebbfe53da90c6ed$var$themeConfig;

});




parcelRegister("fYEbK", function(module, exports) {
$parcel$export(module.exports, "useIsAppProviderThemingEnabled", () => $ba1ba235bf65b49c$export$a782702263f77544);

var $5FkrB = parcelRequire("5FkrB");

var $lGlxg = parcelRequire("lGlxg");
var $ba1ba235bf65b49c$export$a782702263f77544 = function useIsAppProviderThemingEnabled() {
    return (0, $5FkrB.useContext)((0, $lGlxg.AppProviderThemingEnabledContext));
};

});
parcelRegister("lGlxg", function(module, exports) {
$parcel$export(module.exports, "AppProviderThemingEnabledContext", () => $fc8e39bf58b08a3f$export$d2def9838ca456c0);

var $5FkrB = parcelRequire("5FkrB");
var $fc8e39bf58b08a3f$export$d2def9838ca456c0 = /*#__PURE__*/ (0, $5FkrB.createContext)(false);

});


parcelRegister("dLBZC", function(module, exports) {
$parcel$export(module.exports, "useIsInsideAppProvider", () => $a05d22bc685d9de7$export$26aa23367bfbab0e);

var $5FkrB = parcelRequire("5FkrB");

var $8klkn = parcelRequire("8klkn");
var $a05d22bc685d9de7$export$26aa23367bfbab0e = function useIsInsideAppProvider() {
    return (0, $5FkrB.useContext)((0, $8klkn.InsideAppProviderContext));
};

});
parcelRegister("8klkn", function(module, exports) {
$parcel$export(module.exports, "InsideAppProviderContext", () => $6100bc3bbf0b7ac9$export$7981b2444296e410);

var $5FkrB = parcelRequire("5FkrB");
var $6100bc3bbf0b7ac9$export$7981b2444296e410 = /*#__PURE__*/ (0, $5FkrB.createContext)(false);

});


parcelRegister("buC9l", function(module, exports) {
$parcel$export(module.exports, "ColorModeContext", () => $85e016ca147353cc$export$49ddd74a6729fdb0);

var $5FkrB = parcelRequire("5FkrB");
var $85e016ca147353cc$export$49ddd74a6729fdb0 = /*#__PURE__*/ (0, $5FkrB.createContext)(undefined);

});

parcelRegister("bhsSk", function(module, exports) {
$parcel$export(module.exports, "InsideThemeProviderContext", () => $021e9353b06d2882$export$332347eeb335453c);

var $5FkrB = parcelRequire("5FkrB");
var $021e9353b06d2882$export$332347eeb335453c = /*#__PURE__*/ (0, $5FkrB.createContext)(false);

});

parcelRegister("0J1ha", function(module, exports) {
$parcel$export(module.exports, "SetColorModeContext", () => $0022ec27217363ed$export$b06130bad0bbc70f);

var $5FkrB = parcelRequire("5FkrB");
var $0022ec27217363ed$export$b06130bad0bbc70f = /*#__PURE__*/ (0, $5FkrB.createContext)(undefined);

});

parcelRegister("gfmgU", function(module, exports) {
$parcel$export(module.exports, "ThemeContext", () => $bd3f52c2e3d4f330$export$2c657da244d00bd6);
$parcel$export(module.exports, "SetThemeContext", () => $bd3f52c2e3d4f330$export$f7a97b47760e2a13);

var $5FkrB = parcelRequire("5FkrB");
var $bd3f52c2e3d4f330$export$2c657da244d00bd6 = /*#__PURE__*/ (0, $5FkrB.createContext)(undefined);
var $bd3f52c2e3d4f330$export$f7a97b47760e2a13 = /*#__PURE__*/ (0, $5FkrB.createContext)(undefined);

});

parcelRegister("SGOeg", function(module, exports) {
$parcel$export(module.exports, "useIsInsideThemeProvider", () => $0a464043c5ac532b$export$7ca11437599d653d);

var $5FkrB = parcelRequire("5FkrB");

var $bhsSk = parcelRequire("bhsSk");
var $0a464043c5ac532b$export$7ca11437599d653d = function useIsInsideThemeProvider() {
    var _useContext;
    return (_useContext = (0, $5FkrB.useContext)((0, $bhsSk.InsideThemeProviderContext))) !== null && _useContext !== void 0 ? _useContext : false;
};

});

parcelRegister("10rn6", function(module, exports) {
$parcel$export(module.exports, "loadAndMountThemes", () => $0bbb05f64441d8b4$export$7d4a7e812d176b24);

var $fL8KA = parcelRequire("fL8KA");

var $6HG4S = parcelRequire("6HG4S");

var $8kzzf = parcelRequire("8kzzf");

var $9tsqy = parcelRequire("9tsqy");

var $8bvU3 = parcelRequire("8bvU3");
var $0bbb05f64441d8b4$var$loadThemeCss = /*#__PURE__*/ function() {
    var _ref = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee(themeId) {
        var _yield$themeImportMap, themeCss;
        return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context) {
            while(true)switch(_context.prev = _context.next){
                case 0:
                    if (!(0, $8bvU3.isThemeMounted)(themeId)) {
                        _context.next = 1;
                        break;
                    }
                    return _context.abrupt("return");
                case 1:
                    if (themeId) {
                        _context.next = 2;
                        break;
                    }
                    return _context.abrupt("return");
                case 2:
                    _context.next = 3;
                    return (0, $9tsqy.default)[themeId]();
                case 3:
                    _yield$themeImportMap = _context.sent;
                    themeCss = _yield$themeImportMap.default;
                    return _context.abrupt("return", themeCss);
                case 4:
                case "end":
                    return _context.stop();
            }
        }, _callee);
    }));
    return function loadThemeCss(_x) {
        return _ref.apply(this, arguments);
    };
}();
var $0bbb05f64441d8b4$var$mountThemeCss = /*#__PURE__*/ function() {
    var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee2(css, themeId) {
        var doc, style;
        return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context2) {
            while(true)switch(_context2.prev = _context2.next){
                case 0:
                    // SSR-safe: Only mount on client side
                    doc = (0, $8kzzf.getDocument)();
                    if (doc) {
                        _context2.next = 1;
                        break;
                    }
                    return _context2.abrupt("return");
                case 1:
                    style = doc.createElement('style');
                    style.textContent = css;
                    style.dataset.theme = themeId;
                    // Prevent duplicate mounting of themes.
                    // It's possible the theme was already being loaded elsewhere.
                    if (!(0, $8bvU3.isThemeMounted)(themeId)) {
                        _context2.next = 2;
                        break;
                    }
                    return _context2.abrupt("return");
                case 2:
                    doc.head.appendChild(style);
                case 3:
                case "end":
                    return _context2.stop();
            }
        }, _callee2);
    }));
    return function mountThemeCss(_x2, _x3) {
        return _ref2.apply(this, arguments);
    };
}();
var $0bbb05f64441d8b4$var$loadAndMountThemeCss = /*#__PURE__*/ function() {
    var _ref3 = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee3(themeId) {
        var themeCss;
        return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context3) {
            while(true)switch(_context3.prev = _context3.next){
                case 0:
                    _context3.next = 1;
                    return $0bbb05f64441d8b4$var$loadThemeCss(themeId);
                case 1:
                    themeCss = _context3.sent;
                    if (themeCss) {
                        _context3.next = 2;
                        break;
                    }
                    return _context3.abrupt("return");
                case 2:
                    $0bbb05f64441d8b4$var$mountThemeCss(themeCss, themeId);
                case 3:
                case "end":
                    return _context3.stop();
            }
        }, _callee3);
    }));
    return function loadAndMountThemeCss(_x4) {
        return _ref3.apply(this, arguments);
    };
}();
var $0bbb05f64441d8b4$export$7d4a7e812d176b24 = /*#__PURE__*/ function() {
    var _ref4 = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee4(theme) {
        var themesToLoad;
        return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function(_context4) {
            while(true)switch(_context4.prev = _context4.next){
                case 0:
                    themesToLoad = Object.values(theme).filter(function(themeId) {
                        return !!themeId;
                    });
                    themesToLoad.forEach($0bbb05f64441d8b4$var$loadAndMountThemeCss);
                case 1:
                case "end":
                    return _context4.stop();
            }
        }, _callee4);
    }));
    return function loadAndMountThemes(_x5) {
        return _ref4.apply(this, arguments);
    };
}();

});
parcelRegister("8kzzf", function(module, exports) {
$parcel$export(module.exports, "getDocument", () => $610bc7efdfcf7784$export$f65ca476c09acec0);
var $610bc7efdfcf7784$export$f65ca476c09acec0 = function getDocument() {
    if (typeof document !== 'undefined') return document;
    return null;
};

});

parcelRegister("8bvU3", function(module, exports) {
$parcel$export(module.exports, "isThemeMounted", () => $5f58191f17fbe680$export$835a0dc855d02822);

var $8kzzf = parcelRequire("8kzzf");

var $6o2jv = parcelRequire("6o2jv");
function $5f58191f17fbe680$export$835a0dc855d02822(themeId) {
    var doc = (0, $8kzzf.getDocument)();
    if (!doc) return false;
    return doc.head.querySelector("style[".concat((0, $6o2jv.THEME_DATA_ATTRIBUTE), "=\"").concat(themeId, "\"]"));
}

});



parcelRegister("8LRuV", function(module, exports) {
$parcel$export(module.exports, "useColorMode", () => $662c360a0b5c0d7a$export$20f3076712c8dfa);

var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");

var $fsnJ0 = parcelRequire("fsnJ0");
var $l3XDg = parcelRequire("l3XDg");

var $buC9l = parcelRequire("buC9l");
function $662c360a0b5c0d7a$export$20f3076712c8dfa() {
    var value = (0, $5FkrB.useContext)((0, $buC9l.ColorModeContext));
    // TODO: This will only return 'light' or 'dark' but never 'auto', which in some cases
    // may be desirable. We should consider returning both the reconciled color mode (e.g. 'light' or 'dark') and the selected color mode ("auto").
    var theme = (0, $fsnJ0.default)();
    var _useState = (0, $5FkrB.useState)((theme === null || theme === void 0 ? void 0 : theme.colorMode) || 'light'), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), resolvedColorMode = _useState2[0], setResolvedColorMode = _useState2[1];
    (0, $5FkrB.useEffect)(function() {
        // We are using theme from context so no need to reference the DOM
        if (value) return;
        var observer = new (0, $l3XDg.default)(function(theme) {
            setResolvedColorMode((theme === null || theme === void 0 ? void 0 : theme.colorMode) || 'light');
        });
        observer.observe();
        return function() {
            return observer.disconnect();
        };
    }, [
        value
    ]);
    return value ? value : resolvedColorMode;
}

});
parcelRegister("l3XDg", function(module, exports) {
$parcel$export(module.exports, "default", () => $f5582289386e0665$export$2e2bcd8739ae039);

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $25nEq = parcelRequire("25nEq");

var $6o2jv = parcelRequire("6o2jv");

var $fsnJ0 = parcelRequire("fsnJ0");
/**
 * A MutationObserver which watches the `<html>` element for changes to the theme.
 *
 * In React, use the {@link useThemeObserver `useThemeObserver`} hook instead.
 *
 * @param {function} callback - A callback function which fires when the theme changes.
 *
 * @example
 * ```
 * const observer = new ThemeMutationObserver((theme) => {});
 * observer.observe();
 * ```
 */ var $f5582289386e0665$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function ThemeMutationObserver(callback) {
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, ThemeMutationObserver);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "legacyObserver", null);
        this.callback = callback;
        ThemeMutationObserver.callbacks.add(callback);
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(ThemeMutationObserver, [
        {
            key: "observe",
            value: function observe() {
                if (!ThemeMutationObserver.observer) {
                    ThemeMutationObserver.observer = new MutationObserver(function() {
                        var theme = (0, $fsnJ0.default)();
                        ThemeMutationObserver.callbacks.forEach(function(callback) {
                            return callback(theme);
                        });
                    });
                    // Observer only needs to be configured once
                    ThemeMutationObserver.observer.observe(document.documentElement, {
                        attributeFilter: [
                            (0, $6o2jv.THEME_DATA_ATTRIBUTE),
                            (0, $6o2jv.COLOR_MODE_ATTRIBUTE)
                        ]
                    });
                }
            }
        },
        {
            key: "disconnect",
            value: function disconnect() {
                if (this.callback) ThemeMutationObserver.callbacks.delete(this.callback);
                if (ThemeMutationObserver.callbacks.size === 0 && ThemeMutationObserver.observer) {
                    ThemeMutationObserver.observer.disconnect();
                    ThemeMutationObserver.observer = null;
                }
            }
        }
    ]);
}();
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($f5582289386e0665$export$2e2bcd8739ae039, "observer", null);
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($f5582289386e0665$export$2e2bcd8739ae039, "callbacks", new Set());

});


parcelRegister("ilj8P", function(module, exports) {
$parcel$export(module.exports, "appendPortalContainerIfNotAppended", () => $d5a9094145ec3604$export$c582005add11e141);

var $kSj2e = parcelRequire("kSj2e");

var $hyOhc = parcelRequire("hyOhc");
var $d5a9094145ec3604$var$getPortalParent = function getPortalParent() {
    var parentElement = document.querySelector((0, $kSj2e.portalParentSelector));
    if (!parentElement) {
        var _getBody;
        var parent = document.createElement('div');
        parent.className = (0, $kSj2e.portalParentClassName);
        // we are setting display to flex because we want each portal to create a new stacking context
        // See https://developer.mozilla.org/en-US/docs/Web/CSS/CSS_Positioning/Understanding_z_index/The_stacking_context
        parent.style.display = 'flex';
        (_getBody = (0, $hyOhc.getBody)()) === null || _getBody === void 0 || _getBody.appendChild(parent);
        return parent;
    }
    return parentElement;
};
var $d5a9094145ec3604$export$c582005add11e141 = function appendPortalContainerIfNotAppended(container) {
    if (!container.parentElement) $d5a9094145ec3604$var$getPortalParent().appendChild(container);
};

});
parcelRegister("kSj2e", function(module, exports) {
$parcel$export(module.exports, "portalParentClassName", () => $f3279dc54ac6bb64$export$e4c79eb95c23a0da);
$parcel$export(module.exports, "portalParentSelector", () => $f3279dc54ac6bb64$export$72f415121273627e);
$parcel$export(module.exports, "portalClassName", () => $f3279dc54ac6bb64$export$13f57c02915787b3);
var $f3279dc54ac6bb64$export$e4c79eb95c23a0da = 'atlaskit-portal-container';
var $f3279dc54ac6bb64$export$72f415121273627e = 'body > .atlaskit-portal-container';
var $f3279dc54ac6bb64$export$13f57c02915787b3 = 'atlaskit-portal';

});

parcelRegister("hyOhc", function(module, exports) {
$parcel$export(module.exports, "getBody", () => $cc8c9c7d77a7940c$export$135b49d4bc2964c6);
/**
 * Returns document body element
 * @return {number} - The document body element
 */ var $cc8c9c7d77a7940c$export$135b49d4bc2964c6 = function getBody() {
    return document.body;
};

});


parcelRegister("fTWYt", function(module, exports) {
$parcel$export(module.exports, "createContainer", () => $b939bd22a2ec2c08$export$26ae5ca175b4ec5a);

var $kSj2e = parcelRequire("kSj2e");
var $b939bd22a2ec2c08$export$26ae5ca175b4ec5a = function createContainer(zIndex) {
    var container = document.createElement('div');
    container.className = (0, $kSj2e.portalClassName);
    container.style.zIndex = "".concat(zIndex);
    return container;
};

});

parcelRegister("gdurP", function(module, exports) {
$parcel$export(module.exports, "removePortalContainer", () => $bce57a8e3870915b$export$da99f98bf3fe55b3);

var $kSj2e = parcelRequire("kSj2e");

var $hyOhc = parcelRequire("hyOhc");
var $bce57a8e3870915b$var$getPortalParent = function getPortalParent() {
    var parentElement = document.querySelector((0, $kSj2e.portalParentSelector));
    if (!parentElement) {
        var _getBody;
        var parent = document.createElement('div');
        parent.className = (0, $kSj2e.portalParentClassName);
        // we are setting display to flex because we want each portal to create a new stacking context
        // See https://developer.mozilla.org/en-US/docs/Web/CSS/CSS_Positioning/Understanding_z_index/The_stacking_context
        parent.style.display = 'flex';
        (_getBody = (0, $hyOhc.getBody)()) === null || _getBody === void 0 || _getBody.appendChild(parent);
        return parent;
    }
    return parentElement;
};
var $bce57a8e3870915b$export$da99f98bf3fe55b3 = function removePortalContainer(container) {
    var parent = $bce57a8e3870915b$var$getPortalParent();
    if (parent.contains(container)) parent.removeChild(container);
};

});


parcelRegister("9gATZ", function(module, exports) {
$parcel$export(module.exports, "default", () => $6bf23baf28fd9dfb$export$2e2bcd8739ae039);

var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");

var $aLeHs = parcelRequire("aLeHs");

var $5nOvn = parcelRequire("5nOvn");
var $8LRuV = parcelRequire("8LRuV");

var $SGOeg = parcelRequire("SGOeg");

var $5VFxW = parcelRequire("5VFxW");

var $cgCBg = parcelRequire("cgCBg");

var $gpKeI = parcelRequire("gpKeI");

var $1srnP = parcelRequire("1srnP");

var $gWYSK = parcelRequire("gWYSK");
function $6bf23baf28fd9dfb$export$2e2bcd8739ae039(props) {
    var zIndex = props.zIndex, children = props.children, isClosed = props.isClosed;
    var _useState = (0, $5FkrB.useState)(null), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), atlaskitPortal = _useState2[0], setAtlaskitPortal = _useState2[1];
    var colorMode = (0, $8LRuV.useColorMode)();
    var isInsideThemeProvider = (0, $SGOeg.useIsInsideThemeProvider)();
    (0, $cgCBg.useIsomorphicLayoutEffect)(function() {
        if ((0, $5VFxW.fg)('import_into_jsm_in_template_gallery_killswitch')) {
            if (!isClosed) {
                var tempPortalContainer = (0, $gpKeI.createAtlaskitPortal)(zIndex);
                setAtlaskitPortal(tempPortalContainer);
                var portalParent = (0, $1srnP.createPortalParent)();
                if (!tempPortalContainer || !portalParent) return;
                portalParent.appendChild(tempPortalContainer);
                return function() {
                    if (portalParent) {
                        portalParent.removeChild(tempPortalContainer);
                        !portalParent.hasChildNodes() && (0, $gWYSK.removePortalParent)(portalParent);
                    }
                    setAtlaskitPortal(null);
                };
            }
        } else {
            var _tempPortalContainer = (0, $gpKeI.createAtlaskitPortal)(zIndex);
            setAtlaskitPortal(_tempPortalContainer);
            var _portalParent = (0, $1srnP.createPortalParent)();
            if (!_tempPortalContainer || !_portalParent) return;
            _portalParent.appendChild(_tempPortalContainer);
            return function() {
                if (_tempPortalContainer) _portalParent.removeChild(_tempPortalContainer);
                setAtlaskitPortal(null);
            };
        }
    }, [
        zIndex,
        isClosed,
        (0, $5VFxW.fg)
    ]);
    /**
   * We wrap portal children with a Suspense boundary because in React 18 concurrent,
   * if you suspend from _within_ a portal to a Suspense boundary _outside_ the portal,
   * our portal gets in an infinite loop of rendering.
   */ var suspendedChildren = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $5FkrB.Suspense), {
        fallback: null
    }, isInsideThemeProvider ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $5nOvn.default), {
        defaultColorMode: colorMode
    }, children) : children);
    return atlaskitPortal ? /*#__PURE__*/ (0, $aLeHs.createPortal)(suspendedChildren, atlaskitPortal) : null;
}

});
parcelRegister("cgCBg", function(module, exports) {
$parcel$export(module.exports, "useIsomorphicLayoutEffect", () => $8ee4ebd270ef5d62$export$700979bc83e7db82);

var $5FkrB = parcelRequire("5FkrB");
var $8ee4ebd270ef5d62$export$700979bc83e7db82 = typeof window !== 'undefined' ? (0, $5FkrB.useLayoutEffect) : (0, $5FkrB.useEffect);

});

parcelRegister("gpKeI", function(module, exports) {
$parcel$export(module.exports, "createAtlaskitPortal", () => $bf32d8b4fe3e5bf3$export$fef014d7cef9e543);

var $kSj2e = parcelRequire("kSj2e");
var $bf32d8b4fe3e5bf3$var$isDocumentDefined = function isDocumentDefined() {
    return document !== undefined;
};
var $bf32d8b4fe3e5bf3$export$fef014d7cef9e543 = function createAtlaskitPortal(zIndex) {
    //atlaskit-portal div
    if ($bf32d8b4fe3e5bf3$var$isDocumentDefined()) {
        var atlaskitportal = document.createElement('div');
        atlaskitportal.className = (0, $kSj2e.portalClassName);
        atlaskitportal.style.zIndex = "".concat(zIndex);
        return atlaskitportal;
    }
    return;
};

});

parcelRegister("1srnP", function(module, exports) {
$parcel$export(module.exports, "createPortalParent", () => $10fda5b69f8c9484$export$95029ca7aca2989e);

var $kSj2e = parcelRequire("kSj2e");

var $hyOhc = parcelRequire("hyOhc");
var $10fda5b69f8c9484$var$isDocumentDefined = function isDocumentDefined() {
    return document !== undefined;
};
var $10fda5b69f8c9484$export$95029ca7aca2989e = function createPortalParent() {
    //atlaskit-portal-container div
    if ($10fda5b69f8c9484$var$isDocumentDefined()) {
        var parentElement = document.querySelector((0, $kSj2e.portalParentSelector));
        if (!parentElement) {
            var _getBody;
            var parent = document.createElement('div');
            parent.className = (0, $kSj2e.portalParentClassName);
            parent.style.display = 'flex';
            (_getBody = (0, $hyOhc.getBody)()) === null || _getBody === void 0 || _getBody.appendChild(parent);
            return parent;
        }
        return parentElement;
    }
    return;
};

});

parcelRegister("gWYSK", function(module, exports) {
$parcel$export(module.exports, "removePortalParent", () => $c57149fff227d40f$export$7b20876b2769b301);

var $hyOhc = parcelRequire("hyOhc");
var $c57149fff227d40f$var$isDocumentDefined = function isDocumentDefined() {
    return document !== undefined;
};
var $c57149fff227d40f$export$7b20876b2769b301 = function removePortalParent(parentElement) {
    if ($c57149fff227d40f$var$isDocumentDefined()) {
        if (parentElement) {
            var _getBody;
            (_getBody = (0, $hyOhc.getBody)()) === null || _getBody === void 0 || _getBody.removeChild(parentElement);
        }
    }
};

});


parcelRegister("2VTO8", function(module, exports) {
$parcel$export(module.exports, "default", () => $222c31e5f640bfb8$export$2e2bcd8739ae039);

var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");

var $cgCBg = parcelRequire("cgCBg");
var $222c31e5f640bfb8$var$useIsSubsequentRender = function useIsSubsequentRender(mountStrategy) {
    var _useState = (0, $5FkrB.useState)(false), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), isSubsequentRender = _useState2[0], setIsSubsequentRender = _useState2[1];
    var _useState3 = (0, $5FkrB.useState)(function() {
        return mountStrategy === 'layoutEffect' ? (0, $cgCBg.useIsomorphicLayoutEffect) : (0, $5FkrB.useEffect);
    }), _useState4 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState3, 1), useMountEffect = _useState4[0];
    useMountEffect(function() {
        setIsSubsequentRender(true);
    }, []);
    return isSubsequentRender;
};
var $222c31e5f640bfb8$export$2e2bcd8739ae039 = $222c31e5f640bfb8$var$useIsSubsequentRender;

});

parcelRegister("cZbNm", function(module, exports) {
$parcel$export(module.exports, "default", () => $974454d0c0358663$export$2e2bcd8739ae039);

var $5FkrB = parcelRequire("5FkrB");

var $kUt4p = parcelRequire("kUt4p");

var $hX5gs = parcelRequire("hX5gs");
var $974454d0c0358663$var$useFirePortalEvent = function useFirePortalEvent(zIndex) {
    var zIndexNumber = Number(zIndex);
    (0, $5FkrB.useEffect)(function() {
        (0, $hX5gs.default)((0, $kUt4p.PORTAL_MOUNT_EVENT), zIndexNumber);
        return function() {
            (0, $hX5gs.default)((0, $kUt4p.PORTAL_UNMOUNT_EVENT), zIndexNumber);
        };
    }, [
        zIndexNumber
    ]);
};
var $974454d0c0358663$export$2e2bcd8739ae039 = $974454d0c0358663$var$useFirePortalEvent;

});
parcelRegister("kUt4p", function(module, exports) {
$parcel$export(module.exports, "PORTAL_MOUNT_EVENT", () => $f38f964ea10bd2e2$export$ed5835cc67e87f72);
$parcel$export(module.exports, "PORTAL_UNMOUNT_EVENT", () => $f38f964ea10bd2e2$export$80816bd900e5bd00);
var $f38f964ea10bd2e2$export$ed5835cc67e87f72 = 'akPortalMount';
var $f38f964ea10bd2e2$export$80816bd900e5bd00 = 'akPortalUnmount';

});

parcelRegister("hX5gs", function(module, exports) {
$parcel$export(module.exports, "default", () => $d11c07c569476c9c$export$2e2bcd8739ae039);
var $d11c07c569476c9c$var$zIndexToName = {
    100: 'card',
    200: 'navigation',
    300: 'dialog',
    400: 'layer',
    500: 'blanket',
    510: 'modal',
    600: 'flag',
    700: 'spotlight',
    9999: 'tooltip'
};
/**
 * return layer name in Atlassian design system corresponding to given z-index
 * @param {number} zIndex - z-index value for which layer name is needed
 * @returns {LayerName | null} - The layer name for given z-index. If layer name is not found then null is returned
 */ var $d11c07c569476c9c$var$getLayerName = function getLayerName(zIndex) {
    return $d11c07c569476c9c$var$zIndexToName.hasOwnProperty(zIndex) ? $d11c07c569476c9c$var$zIndexToName[zIndex] : null;
};
/**
 * Creates a PortalEvent object with given eventName, given zIndex and corresponding layer
 * @param {string} eventName - either of Mount or Unmount event name
 * @param {number} zIndex - z-index value which will be included in the event to be dispatched
 * @returns {PortalEvent} - The newly created PortalEvent object
 */ var $d11c07c569476c9c$var$getEvent = function getEvent(eventName, zIndex) {
    var detail = {
        layer: $d11c07c569476c9c$var$getLayerName(Number(zIndex)),
        zIndex: zIndex
    };
    return new CustomEvent(eventName, {
        detail: detail
    });
};
function $d11c07c569476c9c$export$2e2bcd8739ae039(eventName, zIndex) {
    var event = $d11c07c569476c9c$var$getEvent(eventName, zIndex);
    window.dispatchEvent(event);
}

});



parcelRegister("9iHrw", function(module, exports) {
$parcel$export(module.exports, "layers", () => $6c577e609442b187$export$7be255094ccdc533);
/* eslint-disable @atlaskit/volt-strict-mode/no-multiple-exports */ 
var $7mIXb = parcelRequire("7mIXb");
var $6c577e609442b187$export$44ffba16bd48dac6 = '__ATLASKIT_THEME__';
var $6c577e609442b187$export$c93026a968943f95 = 'light';
var $6c577e609442b187$export$6ba72c8346b4c57e = [
    'light',
    'dark'
];
var $6c577e609442b187$export$8e24544ddba725ee = function focusRing() {
    var color = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "var(--ds-border-focused, #4688EC)";
    var outlineWidth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
    (0, $7mIXb.default)('@atlaskit/theme', 'focus ring mixin', 'Please use `@atlaskit/focus-ring` instead.');
    return "\n  &:focus {\n    outline: none;\n    box-shadow: 0px 0px 0px ".concat(outlineWidth, "px ").concat(color, ";\n  }\n");
};
var $6c577e609442b187$export$c0dd343266bc3261 = function noFocusRing() {
    return "\n  box-shadow: none;\n";
};
var $6c577e609442b187$export$7be255094ccdc533 = {
    card: function card() {
        return 100;
    },
    navigation: function navigation() {
        return 200;
    },
    dialog: function dialog() {
        return 300;
    },
    layer: function layer() {
        return 400;
    },
    blanket: function blanket() {
        return 500;
    },
    modal: function modal() {
        return 510;
    },
    flag: function flag() {
        return 600;
    },
    spotlight: function spotlight() {
        return 700;
    },
    tooltip: function tooltip() {
        return 9999;
    }
};
var $6c577e609442b187$export$a1b3edb637fb4f35 = function visuallyHidden() {
    (0, $7mIXb.default)('@atlaskit/theme', 'visually hidden mixin', 'Please use `@atlaskit/visually-hidden` instead.');
    return {
        border: '0 !important',
        clip: 'rect(1px, 1px, 1px, 1px) !important',
        height: '1px !important',
        overflow: 'hidden !important',
        padding: '0 !important',
        position: 'absolute !important',
        width: '1px !important',
        whiteSpace: 'nowrap !important'
    };
};
var $6c577e609442b187$export$ba1d834b86d72a09 = $6c577e609442b187$export$a1b3edb637fb4f35;

});
parcelRegister("7mIXb", function(module, exports) {
$parcel$export(module.exports, "default", () => $55cd75548050dd61$export$2e2bcd8739ae039);

var $lcbNu = parcelRequire("lcbNu");
function $55cd75548050dd61$export$2e2bcd8739ae039(packageName, api, additionalMessage) {
    (0, $lcbNu.default)("[".concat(packageName, "]: The ").concat(api, " is deprecated.").concat(additionalMessage && " ".concat(additionalMessage)));
}

});
parcelRegister("lcbNu", function(module, exports) {
$parcel$export(module.exports, "default", () => $f6e3dea897c3e069$export$2e2bcd8739ae039);
/* eslint-disable no-console */ var $f6e3dea897c3e069$var$printed = {};
function $f6e3dea897c3e069$export$2e2bcd8739ae039(message) {
    if ($f6e3dea897c3e069$var$printed[message]) return;
    $f6e3dea897c3e069$var$printed[message] = true;
    if (typeof window !== 'undefined') console.warn(message);
}

});



parcelRegister("6wqXN", function(module, exports) {
$parcel$export(module.exports, "slideAndFade", () => $0139b8595bf81e08$export$635cc6747ac6ffe0);
$parcel$export(module.exports, "fade", () => $0139b8595bf81e08$export$cbea29d068a2e18f);

var $8Ll9B = parcelRequire("8Ll9B");
// ══════════════════════════════════════════════════════════════════════════════
// Popover presets
// ══════════════════════════════════════════════════════════════════════════════
// ── popupMotion ──
var $0139b8595bf81e08$var$POPUP_MOTION_CSS = "\n  [data-ds-popover-popup-motion] {\n    animation: var(--ds-popover-motion-exit);\n    animation-fill-mode: forwards;\n    transition:\n      overlay 150ms allow-discrete,\n      display 150ms allow-discrete;\n  }\n\n  [data-ds-popover-popup-motion]:popover-open {\n    animation: var(--ds-popover-motion-enter);\n    animation-fill-mode: backwards;\n  }\n\n  @media (prefers-reduced-motion: reduce) {\n    [data-ds-popover-popup-motion],\n    [data-ds-popover-popup-motion]:popover-open {\n      animation: none;\n      transition-duration: 0s;\n    }\n  }\n";
function $0139b8595bf81e08$var$getPopupMotionProperties(_ref) {
    var placement = _ref.placement;
    var _getPlacement = (0, $8Ll9B.getPlacement)({
        placement: placement
    }), axis = _getPlacement.axis, edge = _getPlacement.edge;
    if (axis === 'block' && edge === 'start') return {
        '--ds-popover-motion-enter': "var(--ds-popup-enter-top, 150ms cubic-bezier(0.4, 1, 0.6, 1) SlideInTop8px, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)",
        '--ds-popover-motion-exit': "var(--ds-popup-exit-top, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOutTop8px, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)"
    };
    if (axis === 'inline' && edge === 'start') return {
        '--ds-popover-motion-enter': "var(--ds-popup-enter-left, 150ms cubic-bezier(0.4, 1, 0.6, 1) SlideInLeft8px, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)",
        '--ds-popover-motion-exit': "var(--ds-popup-exit-left, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOutLeft8px, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)"
    };
    if (axis === 'inline' && edge === 'end') return {
        '--ds-popover-motion-enter': "var(--ds-popup-enter-right, 150ms cubic-bezier(0.4, 1, 0.6, 1) SlideInRight8px, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)",
        '--ds-popover-motion-exit': "var(--ds-popup-exit-right, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOutRight8px, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)"
    };
    // Default: block/end (popover below trigger)
    return {
        '--ds-popover-motion-enter': "var(--ds-popup-enter-bottom, 150ms cubic-bezier(0.4, 1, 0.6, 1) SlideInBottom8px, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)",
        '--ds-popover-motion-exit': "var(--ds-popup-exit-bottom, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOutBottom8px, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)"
    };
}
function $0139b8595bf81e08$export$da1762badbfc80a0() {
    return {
        name: 'popup-motion',
        css: $0139b8595bf81e08$var$POPUP_MOTION_CSS,
        enterDurationMs: 150,
        exitDurationMs: 100,
        getProperties: function getProperties(_ref2) {
            var placement = _ref2.placement;
            return $0139b8595bf81e08$var$getPopupMotionProperties({
                placement: placement
            });
        }
    };
}
// ── slideAndFade ──
function $0139b8595bf81e08$var$getSlideAndFadeProperties(_ref3) {
    var placement = _ref3.placement, distance = _ref3.distance;
    var pos = "".concat(distance, "px");
    var neg = "-".concat(distance, "px");
    var _getPlacement2 = (0, $8Ll9B.getPlacement)({
        placement: placement
    }), axis = _getPlacement2.axis, edge = _getPlacement2.edge;
    if (axis === 'block' && edge === 'start') return {
        '--ds-popover-tx': '0',
        '--ds-popover-ty': pos
    };
    if (axis === 'block' && edge === 'end') return {
        '--ds-popover-tx': '0',
        '--ds-popover-ty': neg
    };
    if (axis === 'inline' && edge === 'start') return {
        '--ds-popover-tx': pos,
        '--ds-popover-ty': '0'
    };
    if (axis === 'inline' && edge === 'end') return {
        '--ds-popover-tx': neg,
        '--ds-popover-ty': '0'
    };
    return {
        '--ds-popover-tx': '0',
        '--ds-popover-ty': neg
    };
}
// ℹ️ Note: The `transform` x value is flipped in right-to-left mode using the `[dir='rtl']` selector.
var $0139b8595bf81e08$var$SLIDE_AND_FADE_CSS = "\n[data-ds-popover-slide-and-fade] {\n  opacity: 0;\n  transform: translate(var(--ds-popover-tx, 0), var(--ds-popover-ty, 0));\n  transition:\n    opacity 175ms cubic-bezier(0.15, 1, 0.3, 1),\n    transform 175ms cubic-bezier(0.15, 1, 0.3, 1),\n    overlay 175ms allow-discrete,\n    display 175ms allow-discrete;\n}\n\n[dir='rtl'] [data-ds-popover-slide-and-fade] {\n  transform: translate(calc(-1 * var(--ds-popover-tx, 0)), var(--ds-popover-ty, 0));\n}\n\n[data-ds-popover-slide-and-fade]:popover-open {\n  opacity: 1;\n  transform: none;\n  transition-duration: 350ms;\n}\n\n@starting-style {\n  [data-ds-popover-slide-and-fade]:popover-open {\n    opacity: 0;\n    transform: translate(var(--ds-popover-tx, 0), var(--ds-popover-ty, 0));\n  }\n}\n\n@starting-style {\n  [dir='rtl'] [data-ds-popover-slide-and-fade]:popover-open {\n    transform: translate(calc(-1 * var(--ds-popover-tx, 0)), var(--ds-popover-ty, 0));\n  }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  [data-ds-popover-slide-and-fade],\n  [data-ds-popover-slide-and-fade]:popover-open {\n    transition-duration: 0s;\n  }\n}\n";
function $0139b8595bf81e08$export$635cc6747ac6ffe0(options) {
    var _options$distance;
    var distance = (_options$distance = options === null || options === void 0 ? void 0 : options.distance) !== null && _options$distance !== void 0 ? _options$distance : 4;
    return {
        name: 'slide-and-fade',
        css: $0139b8595bf81e08$var$SLIDE_AND_FADE_CSS,
        getProperties: function getProperties(_ref4) {
            var placement = _ref4.placement;
            return $0139b8595bf81e08$var$getSlideAndFadeProperties({
                placement: placement,
                distance: distance
            });
        },
        enterDurationMs: 350,
        exitDurationMs: 175
    };
}
// fade
var $0139b8595bf81e08$var$FADE_CSS = "\n[data-ds-popover-fade] {\n  opacity: 0;\n  transition:\n    opacity 175ms cubic-bezier(0.15, 1, 0.3, 1),\n    overlay 175ms allow-discrete,\n    display 175ms allow-discrete;\n}\n\n[data-ds-popover-fade]:popover-open {\n  opacity: 1;\n  transition-duration: 350ms;\n}\n\n@starting-style {\n  [data-ds-popover-fade]:popover-open {\n    opacity: 0;\n  }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  [data-ds-popover-fade],\n  [data-ds-popover-fade]:popover-open {\n    transition-duration: 0s;\n  }\n}\n";
function $0139b8595bf81e08$export$cbea29d068a2e18f() {
    return {
        name: 'fade',
        css: $0139b8595bf81e08$var$FADE_CSS,
        enterDurationMs: 350,
        exitDurationMs: 175
    };
}
// scaleAndFade
var $0139b8595bf81e08$var$SCALE_AND_FADE_CSS = "\n[data-ds-popover-scale-and-fade] {\n  opacity: 0;\n  transform: scale(0.95);\n  transition:\n    opacity 175ms cubic-bezier(0.15, 1, 0.3, 1),\n    transform 175ms cubic-bezier(0.15, 1, 0.3, 1),\n    overlay 175ms allow-discrete,\n    display 175ms allow-discrete;\n}\n\n[data-ds-popover-scale-and-fade]:popover-open {\n  opacity: 1;\n  transform: none;\n  transition-duration: 350ms;\n}\n\n@starting-style {\n  [data-ds-popover-scale-and-fade]:popover-open {\n    opacity: 0;\n    transform: scale(0.95);\n  }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  [data-ds-popover-scale-and-fade],\n  [data-ds-popover-scale-and-fade]:popover-open {\n    transition-duration: 0s;\n  }\n}\n";
function $0139b8595bf81e08$export$d506ab6b7532b83c() {
    return {
        name: 'scale-and-fade',
        css: $0139b8595bf81e08$var$SCALE_AND_FADE_CSS,
        enterDurationMs: 350,
        exitDurationMs: 175
    };
}
// ══════════════════════════════════════════════════════════════════════════════
// Dialog presets
// ══════════════════════════════════════════════════════════════════════════════
// ── dialogMotion ──
var $0139b8595bf81e08$var$DIALOG_MOTION_CSS = "\n  [data-ds-dialog-motion] {\n    animation: ".concat("var(--ds-modal-exit, 200ms cubic-bezier(0.6, 0, 0.8, 0.6) ScaleOut100to95)", ";\n    animation-fill-mode: forwards;\n    transition:\n      overlay 200ms allow-discrete,\n      display 200ms allow-discrete;\n  }\n\n  [data-ds-dialog-motion][open] {\n    animation: ", "var(--ds-modal-enter, 250ms cubic-bezier(0.4, 0, 0, 1) ScaleIn95to100)", ";\n    animation-fill-mode: backwards;\n  }\n\n  [data-ds-dialog-motion]::backdrop {\n    animation: ", "var(--ds-blanket-exit, 200ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)", ";\n    animation-fill-mode: forwards;\n    background-color: var(--ds-blanket, #050C1F75);\n    transition:\n      overlay 200ms allow-discrete,\n      display 200ms allow-discrete;\n  }\n\n  [data-ds-dialog-motion][open]::backdrop {\n    animation: ", "var(--ds-blanket-enter, 250ms cubic-bezier(0.4, 0, 0, 1) FadeIn0to100)", ";\n    animation-fill-mode: backwards;\n  }\n\n  @media (prefers-reduced-motion: reduce) {\n    [data-ds-dialog-motion],\n    [data-ds-dialog-motion][open],\n    [data-ds-dialog-motion]::backdrop,\n    [data-ds-dialog-motion][open]::backdrop {\n      animation: none;\n      transition-duration: 0s;\n    }\n  }\n");
function $0139b8595bf81e08$export$cbf542c04ce9dc36() {
    // Bare preset name; `Dialog` prefixes it via `data-ds-dialog-{name}`.
    return {
        name: 'motion',
        css: $0139b8595bf81e08$var$DIALOG_MOTION_CSS,
        enterDurationMs: 250,
        exitDurationMs: 200
    };
}
// ── dialogSlideUpAndFade ──
var $0139b8595bf81e08$var$DIALOG_SLIDE_UP_AND_FADE_CSS = "\n[data-ds-dialog-slide-up-and-fade] {\n  opacity: 0;\n  transform: translateY(calc(-1 * var(--ds-dialog-ty, 12px)));\n  transition:\n    opacity 175ms cubic-bezier(0.15, 1, 0.3, 1),\n    transform 175ms cubic-bezier(0.15, 1, 0.3, 1),\n    overlay 175ms allow-discrete,\n    display 175ms allow-discrete;\n}\n\n[data-ds-dialog-slide-up-and-fade][open] {\n  opacity: 1;\n  transform: none;\n  transition-duration: 350ms;\n}\n\n@starting-style {\n  [data-ds-dialog-slide-up-and-fade][open] {\n    opacity: 0;\n    transform: translateY(var(--ds-dialog-ty, 12px));\n  }\n}\n\n[data-ds-dialog-slide-up-and-fade]::backdrop {\n  background-color: transparent;\n  transition:\n    background-color 175ms cubic-bezier(0.15, 1, 0.3, 1),\n    overlay 175ms allow-discrete,\n    display 175ms allow-discrete;\n}\n\n[data-ds-dialog-slide-up-and-fade][open]::backdrop {\n  background-color: var(--ds-blanket, #050C1F75);\n  transition-duration: 350ms;\n}\n\n@starting-style {\n  [data-ds-dialog-slide-up-and-fade][open]::backdrop {\n    background-color: transparent;\n  }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  [data-ds-dialog-slide-up-and-fade],\n  [data-ds-dialog-slide-up-and-fade][open],\n  [data-ds-dialog-slide-up-and-fade]::backdrop,\n  [data-ds-dialog-slide-up-and-fade][open]::backdrop {\n    transition-duration: 0s;\n  }\n}\n";
function $0139b8595bf81e08$export$97a5dd1c12355679(options) {
    var _options$distance2;
    var distance = (_options$distance2 = options === null || options === void 0 ? void 0 : options.distance) !== null && _options$distance2 !== void 0 ? _options$distance2 : 12;
    // Bare preset name; `Dialog` prefixes it via `data-ds-dialog-{name}`.
    return {
        name: distance === 12 ? 'slide-up-and-fade' : "slide-up-and-fade-".concat(distance),
        css: distance === 12 ? $0139b8595bf81e08$var$DIALOG_SLIDE_UP_AND_FADE_CSS : $0139b8595bf81e08$var$DIALOG_SLIDE_UP_AND_FADE_CSS.replace(/12px/g, "".concat(distance, "px")),
        enterDurationMs: 350,
        exitDurationMs: 175
    };
}
// dialogFade
var $0139b8595bf81e08$var$DIALOG_FADE_CSS = "\n[data-ds-dialog-fade] {\n  opacity: 0;\n  transition:\n    opacity 175ms cubic-bezier(0.15, 1, 0.3, 1),\n    overlay 175ms allow-discrete,\n    display 175ms allow-discrete;\n}\n\n[data-ds-dialog-fade][open] {\n  opacity: 1;\n  transition-duration: 350ms;\n}\n\n@starting-style {\n  [data-ds-dialog-fade][open] {\n    opacity: 0;\n  }\n}\n\n[data-ds-dialog-fade]::backdrop {\n  background-color: transparent;\n  transition:\n    background-color 175ms cubic-bezier(0.15, 1, 0.3, 1),\n    overlay 175ms allow-discrete,\n    display 175ms allow-discrete;\n}\n\n[data-ds-dialog-fade][open]::backdrop {\n  background-color: var(--ds-blanket, #050C1F75);\n  transition-duration: 350ms;\n}\n\n@starting-style {\n  [data-ds-dialog-fade][open]::backdrop {\n    background-color: transparent;\n  }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  [data-ds-dialog-fade],\n  [data-ds-dialog-fade][open],\n  [data-ds-dialog-fade]::backdrop,\n  [data-ds-dialog-fade][open]::backdrop {\n    transition-duration: 0s;\n  }\n}\n";
function $0139b8595bf81e08$export$bef0e169dcd0522a() {
    // Bare preset name; `Dialog` prefixes it via `data-ds-dialog-{name}`.
    return {
        name: 'fade',
        css: $0139b8595bf81e08$var$DIALOG_FADE_CSS,
        enterDurationMs: 350,
        exitDurationMs: 175
    };
}

});
parcelRegister("8Ll9B", function(module, exports) {
$parcel$export(module.exports, "getPlacement", () => $66131f37dcb21560$export$a9fe23cfa43a7b55);

var $6WDWN = parcelRequire("6WDWN");
/**
 * Default gap between trigger and popover. Resolves to a design
 * token (`space.100`) so the value follows the design system's spacing
 * scale. Used when `placement.offset.gap` is not provided.
 */ var $66131f37dcb21560$var$DEFAULT_GAP = "var(--ds-space-100, 8px)";
function $66131f37dcb21560$export$a9fe23cfa43a7b55(_ref) {
    var _placement$offset, _placement$axis, _placement$edge, _placement$align, _placement$offset$cro, _placement$offset2, _placement$offset$cro2, _placement$offset3;
    var placement = _ref.placement;
    var consumerGap = (_placement$offset = placement.offset) === null || _placement$offset === void 0 ? void 0 : _placement$offset.gap;
    return {
        axis: (_placement$axis = placement.axis) !== null && _placement$axis !== void 0 ? _placement$axis : 'block',
        edge: (_placement$edge = placement.edge) !== null && _placement$edge !== void 0 ? _placement$edge : 'end',
        align: (_placement$align = placement.align) !== null && _placement$align !== void 0 ? _placement$align : 'center',
        offset: {
            gap: consumerGap === undefined ? $66131f37dcb21560$var$DEFAULT_GAP : (0, $6WDWN.toCssLengthString)({
                value: consumerGap
            }),
            crossAxisShift: {
                value: (0, $6WDWN.toCssLengthString)({
                    value: (_placement$offset$cro = (_placement$offset2 = placement.offset) === null || _placement$offset2 === void 0 || (_placement$offset2 = _placement$offset2.crossAxisShift) === null || _placement$offset2 === void 0 ? void 0 : _placement$offset2.value) !== null && _placement$offset$cro !== void 0 ? _placement$offset$cro : 0
                }),
                direction: (_placement$offset$cro2 = (_placement$offset3 = placement.offset) === null || _placement$offset3 === void 0 || (_placement$offset3 = _placement$offset3.crossAxisShift) === null || _placement$offset3 === void 0 ? void 0 : _placement$offset3.direction) !== null && _placement$offset$cro2 !== void 0 ? _placement$offset$cro2 : 'forwards'
            }
        }
    };
}

});
parcelRegister("6WDWN", function(module, exports) {
$parcel$export(module.exports, "toCssLengthString", () => $50e7259512485526$export$63b6b0ff65d84d47);
/**
 * Normalizes an offset to a CSS length string. Numbers become `${n}px`;
 * strings pass through. Apply at the API boundary so internal code only
 * deals with strings.
 */ function $50e7259512485526$export$63b6b0ff65d84d47(_ref) {
    var value = _ref.value;
    if (typeof value === 'number') return "".concat(value, "px");
    return value;
}

});



parcelRegister("35Y3G", function(module, exports) {
$parcel$export(module.exports, "fromLegacyPlacement", () => $24106d0f087b94c6$export$69e99ed50b2534c9);

var $25nEq = parcelRequire("25nEq");

var $iYJcE = parcelRequire("iYJcE");

var $5NUEW = parcelRequire("5NUEW");
function $24106d0f087b94c6$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $24106d0f087b94c6$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $24106d0f087b94c6$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $24106d0f087b94c6$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $24106d0f087b94c6$export$69e99ed50b2534c9(_ref) {
    var legacy = _ref.legacy, offset = _ref.offset;
    var basePlacement = (0, $5NUEW.placementMapping)[legacy];
    if (!offset) return basePlacement;
    var _offset = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(offset, 2), along = _offset[0], away = _offset[1];
    return $24106d0f087b94c6$var$_objectSpread($24106d0f087b94c6$var$_objectSpread({}, basePlacement), {}, {
        offset: {
            gap: away,
            crossAxisShift: {
                // Sign is captured in `direction`; `value` is the magnitude.
                value: Math.abs(along),
                direction: along >= 0 ? 'forwards' : 'backwards'
            }
        }
    });
}

});
parcelRegister("5NUEW", function(module, exports) {
$parcel$export(module.exports, "placementMapping", () => $439d7ab6a16f951e$export$27df359c528b7120);
/**
 * The full mapping record. Internal - use `fromLegacyPlacement` from the
 * public entry-point so the offset-tuple translation is applied consistently.
 *
 * Note: `auto`, `auto-start`, `auto-end` map to `block-end` placements. This
 * is a reduction in expressiveness vs Popper.js (which picked the best
 * placement at runtime). CSS `position-try-fallbacks` flips at the edge but
 * the initial placement is fixed. Migration consumers who relied on Popper's
 * dynamic auto-flip should pick an explicit placement instead.
 */ var $439d7ab6a16f951e$export$27df359c528b7120 = {
    top: {
        axis: 'block',
        edge: 'start',
        align: 'center'
    },
    'top-start': {
        axis: 'block',
        edge: 'start',
        align: 'start'
    },
    'top-center': {
        axis: 'block',
        edge: 'start',
        align: 'center'
    },
    'top-end': {
        axis: 'block',
        edge: 'start',
        align: 'end'
    },
    bottom: {
        axis: 'block',
        edge: 'end',
        align: 'center'
    },
    'bottom-start': {
        axis: 'block',
        edge: 'end',
        align: 'start'
    },
    'bottom-center': {
        axis: 'block',
        edge: 'end',
        align: 'center'
    },
    'bottom-end': {
        axis: 'block',
        edge: 'end',
        align: 'end'
    },
    right: {
        axis: 'inline',
        edge: 'end',
        align: 'center'
    },
    'right-start': {
        axis: 'inline',
        edge: 'end',
        align: 'start'
    },
    'right-end': {
        axis: 'inline',
        edge: 'end',
        align: 'end'
    },
    left: {
        axis: 'inline',
        edge: 'start',
        align: 'center'
    },
    'left-start': {
        axis: 'inline',
        edge: 'start',
        align: 'start'
    },
    'left-end': {
        axis: 'inline',
        edge: 'start',
        align: 'end'
    },
    auto: {
        axis: 'block',
        edge: 'end',
        align: 'center'
    },
    'auto-start': {
        axis: 'block',
        edge: 'end',
        align: 'start'
    },
    'auto-end': {
        axis: 'block',
        edge: 'end',
        align: 'end'
    }
};

});


parcelRegister("j70BV", function(module, exports) {
$parcel$export(module.exports, "Popover", () => $de9f2509a7500615$export$5b6b19405a83ff9d);
/* popover.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $kqp0i = parcelRequire("kqp0i");

var $25nEq = parcelRequire("25nEq");

var $iYJcE = parcelRequire("iYJcE");

var $hUbY6 = parcelRequire("hUbY6");

var $5FkrB = parcelRequire("5FkrB");

var $7QpUe = parcelRequire("7QpUe");

var $kPZLD = parcelRequire("kPZLD");

var $gaDKB = parcelRequire("gaDKB");

var $lyDlF = parcelRequire("lyDlF");

var $eP9JJ = parcelRequire("eP9JJ");

var $ai0oE = parcelRequire("ai0oE");

var $luv9g = parcelRequire("luv9g");

var $9cO7a = parcelRequire("9cO7a");
/**
 * Detects `popover="hint"` support via DOM reflection. SSR-safe, cached.
 */ var $de9f2509a7500615$var$supportsPopoverHint = (0, $gaDKB.default)(function() {
    if (typeof document === 'undefined') return false;
    // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage -- feature detection
    var element = document.createElement('div');
    element.setAttribute('popover', 'hint');
    return element.popover === 'hint';
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- popover UA reset requires values not in cssMap's type union
var $de9f2509a7500615$var$styles = {
    root: "_19itglyw _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19pkidpf _2hwxidpf _otyridpf _18u0idpf _1r041wug _1reoewfl _18m9ewfl _bfhk1j28"
};
/**
 * Roles registered with the open layer observer as `popup`, so `closeLayers()`
 * dismisses them. `modal` comes from Dialog only; other layer types are unused.
 */ var $de9f2509a7500615$var$POPUP_ROLES = new Set([
    'menu',
    'listbox',
    'dialog',
    'alertdialog',
    'tree',
    'grid'
]);
var $de9f2509a7500615$export$5b6b19405a83ff9d = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function Popover(_ref, ref) {
    var children = _ref.children, _ref$mode = _ref.mode, modeProp = _ref$mode === void 0 ? 'auto' : _ref$mode, onClose = _ref.onClose, onOpenChange = _ref.onOpenChange, onEnterFinish = _ref.onEnterFinish, onExitFinish = _ref.onExitFinish, animate = _ref.animate, placement = _ref.placement, testId = _ref.testId, isOpen = _ref.isOpen, xcssFromProps = _ref.xcss, role = _ref.role, label = _ref.label, labelledBy = _ref.labelledBy, idProp = _ref.id;
    var autoId = (0, $5FkrB.useId)();
    var ownRef = (0, $5FkrB.useRef)(null);
    var combinedRef = (0, $kPZLD.default)([
        ownRef,
        ref
    ].filter(Boolean));
    // `useId()` colons are invalid in CSS selectors and popover target attributes.
    var popoverId = idProp !== null && idProp !== void 0 ? idProp : "popover-".concat(autoId.replace(/:/g, ''));
    var _useAnimatedVisibilit = (0, $ai0oE.useAnimatedVisibility)({
        isOpen: isOpen,
        animate: animate,
        elementRef: ownRef,
        onEnterFinish: onEnterFinish,
        onExitFinish: onExitFinish
    }), phase = _useAnimatedVisibilit.phase, preset = _useAnimatedVisibilit.preset;
    // True while the host element is mounted (any phase except `closed`).
    // Used as a dep so listener-rebind effects re-attach after a remount.
    var isVisible = phase !== 'closed';
    // Focus management: initial focus on entry (role-dependent), Tab cycling
    // for dialog roles. Restoration is native for outermost popovers; nested
    // focus-capturing roles are handled below via the `beforetoggle` snapshot.
    // Passing `phase` keeps `useFocusWrap` attached through the animated-exit
    // window (WCAG 2.4.3 guard). See notes/architecture/focus-restoration.md.
    (0, $luv9g.useFocusWrap)({
        elementRef: ownRef,
        role: role,
        phase: phase
    });
    (0, $9cO7a.useInitialFocus)({
        elementRef: ownRef,
        phase: phase,
        role: role
    });
    // Register with open layer observer so `closeLayers()` and open-count
    // subscriptions work. Only popup-like roles register as `popup`; passive
    // roles (tooltip, status, etc.) leave `type` undefined.
    var handleObserverClose = (0, $5FkrB.useCallback)(function() {
        onClose === null || onClose === void 0 || onClose({
            reason: 'programmatic'
        });
    }, [
        onClose
    ]);
    (0, $lyDlF.useNotifyOpenLayerObserver)({
        type: role && $de9f2509a7500615$var$POPUP_ROLES.has(role) ? 'popup' : undefined,
        isOpen: isOpen,
        onClose: handleObserverClose
    });
    // `hint` falls back to `auto` when unsupported: closest behavior (light
    // dismiss works), but `auto` participates in the auto-dismiss stack so it
    // will close other `auto` popovers when opened. Acceptable trade-off given
    // shrinking browser set without `hint` support.
    var mode = modeProp === 'hint' && !$de9f2509a7500615$var$supportsPopoverHint() ? 'auto' : modeProp;
    // Prevents toggle handler from calling onClose for our own hidePopover() calls.
    var programmaticCloseRef = (0, $5FkrB.useRef)(false);
    // Set in capture-phase keydown so the toggle handler knows close reason.
    var closeReasonRef = (0, $5FkrB.useRef)('light-dismiss');
    // Snapshot of pre-open focus, used to restore focus for nested popovers
    // with focus-capturing roles (browser only restores the outermost).
    var previouslyFocusedElementRef = (0, $5FkrB.useRef)(null);
    var handleBeforeToggle = (0, $5FkrB.useCallback)(function(event) {
        if (event.newState !== 'open') return;
        // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage -- need active element snapshot
        var active = document.activeElement;
        previouslyFocusedElementRef.current = active instanceof HTMLElement ? active : null;
    }, []);
    var handleToggle = (0, $5FkrB.useCallback)(function(event) {
        var element = ownRef.current;
        if (event.newState === 'open') {
            if (element) onOpenChange === null || onOpenChange === void 0 || onOpenChange({
                isOpen: true,
                element: element
            });
            return;
        }
        if (event.newState === 'closed') {
            if (element) {
                onOpenChange === null || onOpenChange === void 0 || onOpenChange({
                    isOpen: false,
                    element: element
                });
                // Nested-popover focus restoration fallback (browser only
                // restores outermost; Firefox skips nested entirely).
                // Restore only when the role moved focus in on open AND the
                // close was Escape/programmatic. For light dismiss, the
                // click target keeps focus per HTML spec
                // (`focusPreviousElement=false`).
                var previouslyFocused = previouslyFocusedElementRef.current;
                var _reason = closeReasonRef.current;
                var isProgrammatic = programmaticCloseRef.current;
                var shouldRestore = previouslyFocused !== null && previouslyFocused.isConnected && (0, $eP9JJ.shouldFocusIntoPopover)({
                    role: role
                }) && (_reason === 'escape' || isProgrammatic);
                if (shouldRestore && previouslyFocused) previouslyFocused.focus({
                    preventScroll: true
                });
                previouslyFocusedElementRef.current = null;
            }
            // Programmatic close: consumer already knows.
            if (programmaticCloseRef.current) {
                // Reset reason so a stale 'escape' from a race with Escape keydown
                // does not corrupt the next browser-dismiss cycle.
                closeReasonRef.current = 'light-dismiss';
                return;
            }
            // Browser dismiss (Escape/click-outside).
            var reason = closeReasonRef.current;
            closeReasonRef.current = 'light-dismiss';
            // Optional: `manual` mode has no `onClose` in the forwarded type.
            onClose === null || onClose === void 0 || onClose({
                reason: reason
            });
        }
    }, [
        onClose,
        onOpenChange,
        role
    ]);
    // Bind via `useLayoutEffect`, and BEFORE the show/hide layout effect
    // below, so listeners are attached when `showPopover()` synchronously
    // dispatches `beforetoggle`. A regular `useEffect` would miss that
    // first dispatch, dropping the `previouslyFocusedElementRef` snapshot
    // and breaking nested-popover focus restoration on close. React runs
    // layout effects in source order on the same commit.
    (0, $5FkrB.useLayoutEffect)(function() {
        var element = ownRef.current;
        if (!element) return;
        // Tag Escape before the browser processes light dismiss.
        var unbindEscape = (0, $7QpUe.bind)(element, {
            type: 'keydown',
            listener: function listener(event) {
                if (event.key === 'Escape') closeReasonRef.current = 'escape';
            },
            options: {
                capture: true
            }
        });
        var unbindToggle = (0, $7QpUe.bind)(element, {
            type: 'toggle',
            listener: handleToggle
        });
        // Snapshot `document.activeElement` before `useInitialFocus` moves it.
        var unbindBeforeToggle = (0, $7QpUe.bind)(element, {
            type: 'beforetoggle',
            listener: handleBeforeToggle
        });
        return function() {
            unbindEscape();
            unbindToggle();
            unbindBeforeToggle();
        };
    }, [
        handleToggle,
        handleBeforeToggle,
        isVisible
    ]);
    // Placement-dependent animation CSS vars. Kept separate from show/hide
    // so preset reference changes do not re-trigger visibility.
    (0, $5FkrB.useLayoutEffect)(function() {
        var element = ownRef.current;
        if (!element || !(preset !== null && preset !== void 0 && preset.getProperties) || !placement) return;
        var props = preset.getProperties({
            placement: placement
        });
        Object.entries(props).forEach(function(_ref2) {
            var _ref3 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_ref2, 2), key = _ref3[0], value = _ref3[1];
            element.style.setProperty(key, String(value));
        });
    }, [
        preset,
        placement,
        isVisible
    ]);
    // Show/hide based on isOpen. `showPopover`/`hidePopover` are no-ops when
    // already in the target state. Try/catch guards `InvalidStateError` on
    // disconnected elements (StrictMode/concurrent/unmount edge cases).
    (0, $5FkrB.useLayoutEffect)(function() {
        var element = ownRef.current;
        if (!element) return;
        if (isOpen) {
            programmaticCloseRef.current = false;
            // Clear stale 'escape' from a prior cycle: the ref outlives
            // the host element, and the no-animation path unmounts before
            // `handleToggle` can reset it.
            closeReasonRef.current = 'light-dismiss';
            try {
                element.showPopover();
            } catch (_unused) {}
            return function() {
                programmaticCloseRef.current = true;
                try {
                    element.hidePopover();
                } catch (_unused2) {}
            };
        }
        programmaticCloseRef.current = true;
        try {
            element.hidePopover();
        } catch (_unused3) {}
    }, [
        isOpen
    ]);
    // Unmount the host once exit completes so it does not leave an empty
    // `role`/`popover` element in the accessibility tree. The element
    // remounts on the next open; the `popoverId` is stable across opens.
    if (!isVisible) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        ref: combinedRef,
        id: popoverId,
        popover: mode,
        role: role,
        "aria-label": label,
        "aria-labelledby": labelledBy,
        "data-testid": testId
    }, preset ? (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, "data-ds-popover-".concat(preset.name), '') : undefined, {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- xcss prop passes compiled atomic class names
        className: (0, $hUbY6.default)([
            $de9f2509a7500615$var$styles.root,
            xcssFromProps
        ])
    }), children);
});

});
parcelRegister("gaDKB", function(module, exports) {
$parcel$export(module.exports, "default", () => $bc5c6a30bcd8d399$export$2e2bcd8739ae039);
/**
 * Creates a new function that will cache the result of it's first call.
 *
 * ```ts
 * function sayHello(name: string): string {
 *   return `Hello ${name}`;
 * }
 * const cached = once(sayHello);
 *
 * cached('Alex'); // returns "Hello Alex"
 * cached('Sam'); // returns "Hello Alex" (underlying `sayHello` function not called)
 * ```
 *
 * **Notes**
 *
 * - If the `onced` function throws, then the return value of the function is not cached
 * - Respects call site context (`this`) when executing the onced function
 */ function $bc5c6a30bcd8d399$export$2e2bcd8739ae039(fn) {
    var cache = null;
    return function result() {
        if (!cache) {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            cache = {
                value: fn.call.apply(fn, [
                    this
                ].concat(args))
            };
        }
        /**
     * Intentionally not adding `.clear()` function property
     *
     * - We currently have no need for it
     * - We don't want to add a `.clear()` to functions that should never be called twice,
     *   for example: `cleanup` functions.
     * - We can add a `onceWithCleanup` variant as a separate export from ds-lib if the
     *   need arises 🧘
     */ return cache.value;
    };
}

});

parcelRegister("eP9JJ", function(module, exports) {
$parcel$export(module.exports, "shouldFocusIntoPopover", () => $acad61999f7430ed$export$b12adccf56228c71);
/**
 * Valid values for the `aria-haspopup` attribute.
 *
 * Derived from the HTML spec - maps popover roles to what the trigger
 * announces. `undefined` means the attribute is omitted entirely (used for
 * non-popup roles like `tooltip`/`status`/`alert`/`note`/`log` where
 * `aria-haspopup` would be misleading).
 *
 * `true` is intentionally NOT in the union - the runtime only ever produces
 * the explicit string forms, so widening the type would invite consumers to
 * pass `true` and get an `aria-haspopup="true"` serialisation that the
 * runtime no longer emits.
 */ /**
 * Roles that require an accessible name (`label` or `labelledBy`) per WCAG 4.1.2.
 * Without a name, assistive technology cannot identify these landmarks.
 */ /**
 * Roles where the accessible name is derived from content or provided externally
 * (e.g. a combobox labels its listbox, tooltip content IS the accessible name).
 */ // Shared ARIA role discrimination types
//
// These encode the WCAG 4.1.2 constraint: roles like `dialog`, `alertdialog`,
// and `menu` MUST have an accessible name (either `label` or `labelledBy`).
// TypeScript enforces this at compile time via discriminated unions.
/**
 * ARIA role props where a role is always required.
 *
 * Used by `TPopupContentProps`. Popup content must always declare
 * its role so assistive technology can identify the layer.
 */ /**
 * ARIA role props where a role is optional.
 *
 * Used by `TPopoverProps`. The low-level primitive allows omitting
 * the role for cases where it is set externally or not needed.
 */ var $acad61999f7430ed$var$rolesThatMoveFocus = new Set([
    'dialog',
    'alertdialog',
    'menu',
    'listbox',
    'tree',
    'grid'
]);
function $acad61999f7430ed$export$b12adccf56228c71(_ref) {
    var role = _ref.role;
    if (!role) return false;
    return $acad61999f7430ed$var$rolesThatMoveFocus.has(role);
}

});

parcelRegister("ai0oE", function(module, exports) {
$parcel$export(module.exports, "useAnimatedVisibility", () => $77dbe498dc9c6977$export$1bccb45daf07907f);

var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");

var $7QpUe = parcelRequire("7QpUe");

var $jjyaX = parcelRequire("jjyaX");

var $4Z9IF = parcelRequire("4Z9IF");
/**
 * Fires `onSettled` once when `transitionend` fires on `element`, or after
 * `safetyNetMs` if the event is swallowed (mid-transition unmount, CSS
 * mismatch, browser quirks). Returns a cleanup that cancels both paths.
 */ function $77dbe498dc9c6977$var$runOnTransitionEndOrTimeout(_ref) {
    var element = _ref.element, safetyNetMs = _ref.safetyNetMs, onSettled = _ref.onSettled;
    var state = {
        isSettled: false
    };
    function teardown() {
        state.isSettled = true;
        clearTimeout(safetyNetId);
        unbind();
    }
    function settle() {
        if (state.isSettled) return;
        teardown();
        onSettled();
    }
    var unbind = (0, $7QpUe.bind)(element, {
        type: 'transitionend',
        listener: settle,
        options: {
            once: true
        }
    });
    var safetyNetId = setTimeout(settle, safetyNetMs);
    return teardown;
}
function $77dbe498dc9c6977$export$1bccb45daf07907f(_ref2) {
    var isOpen = _ref2.isOpen, animate = _ref2.animate, elementRef = _ref2.elementRef, onEnterFinish = _ref2.onEnterFinish, onExitFinish = _ref2.onExitFinish;
    var preset = (0, $4Z9IF.usePresetStyles)({
        preset: animate
    });
    // False when there is no preset or `prefers-reduced-motion` is set.
    var willAnimate = Boolean(animate) && !(0, $jjyaX.prefersReducedMotion)();
    // Promote `closed → entering`/`closed → open` synchronously during
    // render so the host element mounts in the same commit as the open
    // intent. All other transitions are driven by phase-specific effects.
    var _useState = (0, $5FkrB.useState)(function() {
        if (!isOpen) return 'closed';
        return willAnimate ? 'entering' : 'open';
    }), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), phase = _useState2[0], setPhase = _useState2[1];
    if (isOpen && phase === 'closed') setPhase(willAnimate ? 'entering' : 'open');
    if (!isOpen && (phase === 'open' || phase === 'entering')) // Close intent. Move to `exiting` to gate the unmount on either
    // the exit transition (animated) or the toggle/close event
    // (non-animated). Includes interrupted entry (`entering → exiting`).
    setPhase('exiting');
    if (isOpen && phase === 'exiting') // Reopen mid-exit. With animation, jump back to `entering` and let
    // the entry transition restart from current visual state. Without
    // animation, jump straight to `open` (the handshake we were waiting
    // for is no longer relevant; the consumer wants the host visible
    // again synchronously).
    setPhase(willAnimate ? 'entering' : 'open');
    // Keep stable refs to the latest callbacks so effects and timeout closures
    // always call the current callback without needing them in dependency arrays.
    var onEnterFinishRef = (0, $5FkrB.useRef)(onEnterFinish);
    onEnterFinishRef.current = onEnterFinish;
    var onExitFinishRef = (0, $5FkrB.useRef)(onExitFinish);
    onExitFinishRef.current = onExitFinish;
    // Animated entry: wait for `transitionend` (or a safety-net timeout) and
    // move to `open`. The fallback guarantees settle on swallowed events
    // (zero-duration, browser quirk, mid-transition unmount).
    (0, $5FkrB.useEffect)(function() {
        var _preset$enterDuration;
        if (phase !== 'entering') return;
        var element = elementRef.current;
        if (!element) return;
        return $77dbe498dc9c6977$var$runOnTransitionEndOrTimeout({
            element: element,
            safetyNetMs: ((_preset$enterDuration = preset === null || preset === void 0 ? void 0 : preset.enterDurationMs) !== null && _preset$enterDuration !== void 0 ? _preset$enterDuration : 0) + 50,
            onSettled: function onSettled() {
                var _onEnterFinishRef$cur;
                // Fire the consumer callback before transitioning phase so any
                // state the consumer reads (refs, DOM nodes) is still attached
                // in the same synchronous tick, regardless of React batching
                // semantics.
                (_onEnterFinishRef$cur = onEnterFinishRef.current) === null || _onEnterFinishRef$cur === void 0 || _onEnterFinishRef$cur.call(onEnterFinishRef);
                setPhase(function(current) {
                    return current === 'entering' ? 'open' : current;
                });
            }
        });
    }, [
        phase,
        preset === null || preset === void 0 ? void 0 : preset.enterDurationMs,
        elementRef
    ]);
    // Non-animated entry callback. The lifecycle goes `closed → open`
    // directly with no `entering` phase; fire `onEnterFinish` on that jump.
    // A previous-phase ref avoids double-firing on the animated path.
    var prevPhaseForEntryRef = (0, $5FkrB.useRef)('closed');
    (0, $5FkrB.useEffect)(function() {
        var prevPhase = prevPhaseForEntryRef.current;
        prevPhaseForEntryRef.current = phase;
        // Animated entry settle goes through `entering` and already fired
        // onEnterFinish above; only handle the non-animated direct jumps.
        if (prevPhase !== 'open' && phase === 'open' && prevPhase !== 'entering') {
            var _onEnterFinishRef$cur2;
            (_onEnterFinishRef$cur2 = onEnterFinishRef.current) === null || _onEnterFinishRef$cur2 === void 0 || _onEnterFinishRef$cur2.call(onEnterFinishRef);
        }
    }, [
        phase
    ]);
    // Animated exit: wait for `transitionend` (or a safety-net timeout),
    // fire `onExitFinish`, then move to `closed` to unmount the host.
    (0, $5FkrB.useEffect)(function() {
        var _preset$exitDurationM;
        if (phase !== 'exiting' || !willAnimate) return;
        var element = elementRef.current;
        if (!element) return;
        return $77dbe498dc9c6977$var$runOnTransitionEndOrTimeout({
            element: element,
            safetyNetMs: ((_preset$exitDurationM = preset === null || preset === void 0 ? void 0 : preset.exitDurationMs) !== null && _preset$exitDurationM !== void 0 ? _preset$exitDurationM : 0) + 50,
            onSettled: function onSettled() {
                var _onExitFinishRef$curr;
                // Fire the consumer callback before transitioning phase to
                // `closed`. The phase change drives the host element unmount,
                // and consumers expect to be able to read the element (or a
                // forwarded ref to it) inside `onExitFinish`. Doing this in
                // the safe order avoids relying on React's automatic batching
                // to keep the element attached across the callback.
                (_onExitFinishRef$curr = onExitFinishRef.current) === null || _onExitFinishRef$curr === void 0 || _onExitFinishRef$curr.call(onExitFinishRef);
                setPhase(function(current) {
                    return current === 'exiting' ? 'closed' : current;
                });
            }
        });
    }, [
        phase,
        willAnimate,
        preset === null || preset === void 0 ? void 0 : preset.exitDurationMs,
        elementRef
    ]);
    // Non-animated exit: wait for the browser's `toggle` (closed) or
    // `close` event before unmounting, so the consumer's listener (close
    // reason, nested focus restoration, `onClose`) and the browser's
    // native focus restoration both run against the still-attached
    // element. A naive `setTimeout(0)` occasionally beats the `toggle`
    // task in Chromium and drops focus restoration.
    //
    // `useLayoutEffect` so the listener binds in the same commit as the
    // show/hide layout effect that calls `hidePopover()` / `dialog.close()`.
    // The toggle/close event is queued as a task and cannot run until the
    // frame completes. SSR-safe: `phase` starts at `'closed'`.
    //
    // `onExitFinish` is fired separately (see effect below) so consumers
    // observe it the moment `isOpen` flips to `false`.
    (0, $5FkrB.useLayoutEffect)(function() {
        if (phase !== 'exiting' || willAnimate) return;
        var element = elementRef.current;
        if (!element) return;
        function unmount() {
            setPhase(function(current) {
                return current === 'exiting' ? 'closed' : current;
            });
        }
        return (0, $7QpUe.bindAll)(element, [
            {
                type: 'toggle',
                listener: function listener(event) {
                    if (event.newState === 'closed') unmount();
                }
            },
            {
                type: 'close',
                listener: unmount
            }
        ]);
    }, [
        phase,
        willAnimate,
        elementRef
    ]);
    // Non-animated exit callback. No `transitionend` to wait for, so fire
    // `onExitFinish` on the transition into `exiting` (the unmount itself
    // is gated by the toggle/close handshake above).
    var prevPhaseForExitRef = (0, $5FkrB.useRef)('closed');
    (0, $5FkrB.useEffect)(function() {
        var prevPhase = prevPhaseForExitRef.current;
        prevPhaseForExitRef.current = phase;
        // Only fire on the non-animated transition into `exiting`. The
        // animated path's `exiting → closed` settle already fires
        // `onExitFinish` from `runOnTransitionEndOrTimeout`.
        if (prevPhase !== 'exiting' && phase === 'exiting' && !willAnimate) {
            var _onExitFinishRef$curr2;
            (_onExitFinishRef$curr2 = onExitFinishRef.current) === null || _onExitFinishRef$curr2 === void 0 || _onExitFinishRef$curr2.call(onExitFinishRef);
        }
    }, [
        phase,
        willAnimate
    ]);
    return {
        phase: phase,
        preset: preset
    };
}

});
parcelRegister("jjyaX", function(module, exports) {
$parcel$export(module.exports, "prefersReducedMotion", () => $e0fa4d4522b5641d$export$ff7706047246b98b);

var $gaDKB = parcelRequire("gaDKB");
var $e0fa4d4522b5641d$export$ff7706047246b98b = (0, $gaDKB.default)(function() {
    if (typeof window === 'undefined' || !('matchMedia' in window)) return false;
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
});

});

parcelRegister("4Z9IF", function(module, exports) {
$parcel$export(module.exports, "usePresetStyles", () => $3a1465fc782952f3$export$f09337c691384fe1);

var $5FkrB = parcelRequire("5FkrB");

var $7OFKT = parcelRequire("7OFKT");
function $3a1465fc782952f3$export$f09337c691384fe1(_ref) {
    var preset = _ref.preset;
    var resolved = preset != null && preset !== false ? preset : null;
    (0, $5FkrB.useInsertionEffect)(function() {
        if (resolved) (0, $7OFKT.ensurePresetStyles)({
            preset: resolved
        });
    }, [
        resolved
    ]);
    return resolved;
}

});
parcelRegister("7OFKT", function(module, exports) {
$parcel$export(module.exports, "ensurePresetStyles", () => $5b0d97ad2401618d$export$9515fe8c2ae33fb5);
/**
 * Per-preset CSS injection.
 *
 * Each preset's CSS is injected at most once into `<head>`.
 * Shared by both PopoverContent and DialogContent.
 *
 * Note: injected `<style>` elements and the tracking Set are append-only -
 * they are never removed. This is intentional: the number of distinct
 * presets is bounded (handful of animation presets), so the
 * memory footprint is negligible. Removing styles would risk breaking
 * other instances of the same preset that are still mounted.
 *
 * Decision (2026-03-17 audit): Accepted as a non-issue. The bounded
 * preset count (~5 presets) makes cleanup unnecessary. We plan to move
 * to a Compiled-based solution which will handle style injection and
 * deduplication natively.
 */ var $5b0d97ad2401618d$var$injectedPresets = new Set();
function $5b0d97ad2401618d$export$9515fe8c2ae33fb5(_ref) {
    var preset = _ref.preset;
    if ($5b0d97ad2401618d$var$injectedPresets.has(preset.name) || typeof document === 'undefined') return;
    $5b0d97ad2401618d$var$injectedPresets.add(preset.name);
    var style = document.createElement('style');
    style.textContent = preset.css;
    document.head.appendChild(style);
}

});



parcelRegister("luv9g", function(module, exports) {
$parcel$export(module.exports, "useFocusWrap", () => $fa548fbdf3df879f$export$4f6462e86a70abe5);

var $5FkrB = parcelRequire("5FkrB");

var $7QpUe = parcelRequire("7QpUe");

var $bkEWs = parcelRequire("bkEWs");

var $cHwDF = parcelRequire("cHwDF");

var $gvjiJ = parcelRequire("gvjiJ");

var $jAbmW = parcelRequire("jAbmW");
/**
 * Roles that require focus wrapping per WAI-ARIA APG.
 *
 * - `dialog`: https://www.w3.org/WAI/ARIA/apg/patterns/dialog-modal/
 * - `alertdialog`: same keyboard pattern as dialog
 *
 * `menu` is intentionally excluded. Menus are composite widgets
 * (https://www.w3.org/WAI/ARIA/apg/practices/keyboard-interface/#kbd_general_within)
 * that manage their own internal keyboard navigation via arrow keys,
 * not Tab. Tab/Shift+Tab should move focus OUT of a menu entirely.
 *
 * Menu keyboard behavior (arrow keys, Home/End, type-ahead, Enter/Space)
 * is context-dependent. It varies by orientation, nesting depth, item
 * type, and control pattern (menu button vs menubar). This makes it
 * impossible to implement generically here. The consumer component
 * (e.g. `dropdown-menu`) owns all menu keyboard navigation.
 *
 * See: notes/outputs/menu-keyboard-decision.md
 */ function $fa548fbdf3df879f$var$roleRequiresFocusWrap(role) {
    return role === 'dialog' || role === 'alertdialog';
}
function $fa548fbdf3df879f$export$4f6462e86a70abe5(_ref) {
    var elementRef = _ref.elementRef, role = _ref.role, phase = _ref.phase;
    var isVisible = phase !== 'closed';
    (0, $5FkrB.useEffect)(function() {
        var element = elementRef.current;
        if (!element || !$fa548fbdf3df879f$var$roleRequiresFocusWrap(role) || !isVisible) return;
        var unbind = (0, $7QpUe.bind)(element, {
            type: 'keydown',
            listener: function listener(event) {
                if (event.key !== 'Tab') return;
                // If focus is already in a nested layer, then
                // we continue to let that nested layer own focus
                if ((0, $jAbmW.isNestedLayerFocused)({
                    container: element
                })) return;
                // Prevent the browser giving focus to where it wants to
                // (we will be handling it, including with wrapping)
                event.preventDefault();
                var direction = event.shiftKey ? 'backwards' : 'forwards';
                // Try to move to the next/previous focusable element relative
                // to the currently focused element within the container.
                var next = (0, $gvjiJ.getNextFocusable)({
                    container: element,
                    direction: direction
                });
                if (next) {
                    next.focus();
                    return;
                }
                // Nothing is currently focused inside the container (or the
                // focused element is not in the focusable list). Fall back to
                // the first or last focusable element depending on direction.
                var fallback = direction === 'forwards' ? (0, $bkEWs.getFirstFocusable)({
                    container: element
                }) : (0, $cHwDF.getLastFocusable)({
                    container: element
                });
                if (fallback) fallback.focus();
            },
            options: {
                capture: true
            }
        });
        return unbind;
    }, [
        elementRef,
        role,
        isVisible
    ]);
}

});
parcelRegister("bkEWs", function(module, exports) {
$parcel$export(module.exports, "getFirstFocusable", () => $84015224cc2418f4$export$748138f04a69bf21);

var $gWvdN = parcelRequire("gWvdN");
function $84015224cc2418f4$export$748138f04a69bf21(_ref) {
    var container = _ref.container, filter = _ref.filter;
    var items = (0, $gWvdN.getFocusables)({
        container: container,
        filter: filter
    });
    return items.length > 0 ? items[0] : null;
}

});
parcelRegister("gWvdN", function(module, exports) {
$parcel$export(module.exports, "getFocusables", () => $c55a480f8f9c8bb2$export$f6768025e418420e);

var $lmE6S = parcelRequire("lmE6S");

var $dACWh = parcelRequire("dACWh");
function $c55a480f8f9c8bb2$export$f6768025e418420e(_ref) {
    var container = _ref.container, filter = _ref.filter;
    return Array.from(container.querySelectorAll((0, $dACWh.selectors).focusable)).filter(function(element) {
        return element instanceof HTMLElement;
    }).filter(function(element) {
        return (0, $lmE6S.isInSameLayer)({
            element: element,
            container: container
        });
    }).filter(function(element) {
        return !filter || filter(element, container);
    });
}

});
parcelRegister("lmE6S", function(module, exports) {
$parcel$export(module.exports, "isInSameLayer", () => $f8dac407f92679a8$export$df8c72c64edc7260);
var $f8dac407f92679a8$var$topLayerSelector = '[popover], dialog, [role="dialog"], [role="alertdialog"]';
function $f8dac407f92679a8$export$df8c72c64edc7260(_ref) {
    var element = _ref.element, container = _ref.container;
    var elementLayer = element.closest($f8dac407f92679a8$var$topLayerSelector);
    var containerLayer = container.closest($f8dac407f92679a8$var$topLayerSelector);
    // Both elements are in the "document" layer
    if (!elementLayer && !containerLayer) return true;
    return elementLayer === containerLayer;
}

});

parcelRegister("dACWh", function(module, exports) {
$parcel$export(module.exports, "selectors", () => $9e4cd79f21e2cc09$export$e1252723db1c541);
var $9e4cd79f21e2cc09$export$e1252723db1c541 = function() {
    // Common exclusion filter applied to every selector.
    var not = ':not([tabindex="-1"]):not([aria-disabled="true"]):not([aria-hidden="true"])';
    var notDisabled = ":not([disabled])".concat(not);
    var focusable = [
        "a[href]".concat(not),
        "area[href]".concat(not),
        "input".concat(notDisabled, ":not([type=\"hidden\"])"),
        "select".concat(notDisabled),
        "textarea".concat(notDisabled),
        "button".concat(notDisabled),
        "iframe".concat(not),
        "audio[controls]".concat(not),
        "video[controls]".concat(not),
        "[contenteditable]:not([contenteditable=\"false\"])".concat(not),
        "[tabindex]".concat(notDisabled).concat(not)
    ];
    return {
        focusable: focusable.join(','),
        // Build the `:focus` selector
        focused: focusable.map(function(selector) {
            return "".concat(selector, ":focus");
        }).join(',')
    };
}();

});



parcelRegister("cHwDF", function(module, exports) {
$parcel$export(module.exports, "getLastFocusable", () => $93f2d197d328cf0a$export$73e81fa65335a75b);

var $gWvdN = parcelRequire("gWvdN");
function $93f2d197d328cf0a$export$73e81fa65335a75b(_ref) {
    var container = _ref.container, filter = _ref.filter;
    var items = (0, $gWvdN.getFocusables)({
        container: container,
        filter: filter
    });
    return items.length > 0 ? items[items.length - 1] : null;
}

});

parcelRegister("gvjiJ", function(module, exports) {
$parcel$export(module.exports, "getNextFocusable", () => $c03e8368ac5d5231$export$a7db88e6d491b450);
/**
 * Returns the next focusable element in the given direction relative to the
 * currently focused element within the container. Wraps around at both ends.
 *
 * Returns `null` if there is no focused element within the container or if
 * the focused element is not in the list of focusable elements.
 */ 
var $gWvdN = parcelRequire("gWvdN");

var $dACWh = parcelRequire("dACWh");
function $c03e8368ac5d5231$export$a7db88e6d491b450(_ref) {
    var _all$nextIndex;
    var container = _ref.container, direction = _ref.direction, filter = _ref.filter;
    var all = (0, $gWvdN.getFocusables)({
        container: container,
        filter: filter
    });
    var current = container.querySelector((0, $dACWh.selectors).focused);
    if (!(current instanceof HTMLElement)) return null;
    var index = all.indexOf(current);
    if (index === -1) return null;
    var nextIndex = function() {
        if (direction === 'forwards') return (index + 1) % all.length;
        var proposed = index - 1;
        // if going into negative numbers, loop back to the last item
        return proposed < 0 ? all.length - 1 : proposed;
    }();
    return (_all$nextIndex = all[nextIndex]) !== null && _all$nextIndex !== void 0 ? _all$nextIndex : null;
}

});

parcelRegister("jAbmW", function(module, exports) {
$parcel$export(module.exports, "isNestedLayerFocused", () => $e41a32c83424d6ea$export$b9590fdfeb5f722f);

var $88gY4 = parcelRequire("88gY4");

var $lmE6S = parcelRequire("lmE6S");
function $e41a32c83424d6ea$export$b9590fdfeb5f722f(_ref) {
    var _getDocument;
    var container = _ref.container;
    var focused = (_getDocument = (0, $88gY4.getDocument)()) === null || _getDocument === void 0 ? void 0 : _getDocument.activeElement;
    if (!(focused instanceof HTMLElement)) return false;
    // Cannot be in a nested layer if it is not in the container
    if (!container.contains(focused)) return false;
    // If not in the same layer, must be in a nested layer
    return !(0, $lmE6S.isInSameLayer)({
        element: focused,
        container: container
    });
}

});
parcelRegister("88gY4", function(module, exports) {
$parcel$export(module.exports, "getDocument", () => $5ebc3b8fd688ff75$export$f65ca476c09acec0);
var $5ebc3b8fd688ff75$export$f65ca476c09acec0 = function getDocument() {
    if (typeof document !== 'undefined') return document;
    return null;
};

});



parcelRegister("9cO7a", function(module, exports) {
$parcel$export(module.exports, "useInitialFocus", () => $6b3c1bc0436883f2$export$e992c40175757a22);

var $5FkrB = parcelRequire("5FkrB");

var $bkEWs = parcelRequire("bkEWs");
/**
 * Determines the correct element to receive initial focus within a popover,
 * based on its ARIA role.
 *
 * Focus rules by role (per WAI-ARIA APG):
 * - `dialog` / `alertdialog`: first element with `[autofocus]`, or first focusable element
 * - `menu`: first menu item (`[role="menuitem|menuitemcheckbox|menuitemradio"]`)
 * - `listbox`: first selected option (`[aria-selected="true"]`), or first option (`[role="option"]`)
 * - `tooltip`: no focus movement (tooltips are informational)
 * - no role / other roles: no focus movement
 *
 * Note: React 18's `autoFocus` JSX prop does NOT set the HTML `autofocus`
 * attribute - it only calls `.focus()` imperatively during commit, which
 * has no effect on hidden popover content. Consumers must set the native
 * attribute via a ref callback (e.g. `node.setAttribute('autofocus', '')`).
 * React 19+ reflects the JSX prop as the HTML attribute automatically.
 *
 * Combobox pattern exception: if the popup is controlled by a focused
 * combobox-like trigger (its `aria-controls` references this popup),
 * focus stays on the textbox regardless of role. See
 * `isComboboxControllingPopup`.
 */ /**
 * WAI-ARIA APG Combobox Pattern: when a combobox controls a popup (listbox,
 * grid, tree, or menu), DOM focus must remain on the textbox. Subsequent
 * navigation through popup items uses `aria-activedescendant` (or proxied
 * keyboard events), never DOM focus movement.
 *
 * Detects both variants in a single pass:
 * - In-popup combobox: the textbox lives inside the popup `container`
 *   (the popup is rendered as a child of the combobox wrapper).
 * - External combobox: the textbox is rendered OUTSIDE the popup
 *   (`react-select` pattern, where the listbox is portalled separately
 *   from the textbox).
 *
 * Acceptance criteria for the active element:
 * - Role / element-type filter: `role="combobox"`, `role="textbox"`,
 *   `TEXTAREA`, `contentEditable`, or `INPUT` of text-like type
 *   (`text`, `search`, `email`, `url`, `tel`, `password`, or
 *   unspecified). Non-text input types (`button`, `checkbox`, etc.)
 *   are rejected.
 * - Reference filter: `aria-controls` (or legacy `aria-owns`) IDREFS
 *   must resolve to an element that IS or CONTAINS the popup container.
 *
 * See: https://www.w3.org/WAI/ARIA/apg/patterns/combobox/
 */ // `<input>` types treated as text-like for combobox detection.
// Non-text input types (`button`, `checkbox`, `submit`, etc.) are rejected.
// A missing `type` attribute defaults to `text` per the HTML spec, so we
// normalize that case before lookup rather than including an empty string here.
var $6b3c1bc0436883f2$var$TEXT_LIKE_INPUT_TYPES = new Set([
    'text',
    'search',
    'email',
    'url',
    'tel',
    'password'
]);
function $6b3c1bc0436883f2$var$isTextboxLikeElement(element) {
    var role = element.getAttribute('role');
    if (role === 'combobox' || role === 'textbox') return true;
    // `tagName` is uppercase for HTML elements but can be mixed-case for
    // XML/SVG. Normalize once so downstream comparisons stay lowercase.
    var tag = element.tagName.toLowerCase();
    if (tag === 'textarea') return true;
    if (element.isContentEditable) return true;
    if (tag === 'input') {
        var _element$getAttribute;
        var type = ((_element$getAttribute = element.getAttribute('type')) !== null && _element$getAttribute !== void 0 ? _element$getAttribute : 'text').toLowerCase();
        return $6b3c1bc0436883f2$var$TEXT_LIKE_INPUT_TYPES.has(type);
    }
    return false;
}
function $6b3c1bc0436883f2$var$isComboboxControllingPopup(_ref) {
    var _active$getAttribute;
    var container = _ref.container;
    var ownerDocument = container.ownerDocument;
    var active = ownerDocument.activeElement;
    if (!(active instanceof HTMLElement)) return false;
    if (!$6b3c1bc0436883f2$var$isTextboxLikeElement(active)) return false;
    // Accept legacy `aria-owns` in addition to `aria-controls`.
    // `aria-controls` / `aria-owns` are IDREFS (space-separated list of IDs)
    // per the WAI-ARIA spec, so we must split and check membership rather
    // than comparing with strict equality. A combobox that controls both
    // this popup and another element (e.g. a results status region) must
    // still be recognised as controlling this popup.
    var idRefs = (_active$getAttribute = active.getAttribute('aria-controls')) !== null && _active$getAttribute !== void 0 ? _active$getAttribute : active.getAttribute('aria-owns');
    if (!idRefs) return false;
    // Match if any referenced element IS, CONTAINS, or IS CONTAINED BY the
    // popup container. The "contained by" case covers wrapper-style adopters
    // like react-select, where the combobox input's `aria-controls` points at
    // a listbox element that is a descendant of the Popover host (the
    // listbox role lives on a child the wrapped library owns, not on the
    // host we render).
    var referencedIds = idRefs.split(/\s+/).filter(function(id) {
        return id !== '';
    });
    return referencedIds.some(function(id) {
        var referenced = ownerDocument.getElementById(id);
        if (!referenced) return false;
        return referenced === container || referenced.contains(container) || container.contains(referenced);
    });
}
function $6b3c1bc0436883f2$var$getInitialFocusTarget(_ref2) {
    var container = _ref2.container, role = _ref2.role;
    if (role === 'dialog' || role === 'alertdialog') {
        // Prefer element with the native HTML autofocus attribute.
        var autofocusEl = container.querySelector('[autofocus]');
        if (autofocusEl) return autofocusEl;
        // Fall back to first focusable element
        return (0, $bkEWs.getFirstFocusable)({
            container: container
        });
    }
    // The combobox carve-out is kept role-specific (menu / listbox) rather
    // than hoisted. Hoisting it over-matched on dialog popups that contain
    // a nested combobox (e.g. datetime-picker's dialog hosts a react-select),
    // where the active combobox's `aria-controls` falsely matched the
    // container and suppressed the dialog's own focus contract.
    if (role === 'menu') {
        if ($6b3c1bc0436883f2$var$isComboboxControllingPopup({
            container: container
        })) return null;
        // Initial focus placement is the extent of what top-layer provides
        // for menus. All subsequent keyboard navigation (arrow keys, Home/End,
        // type-ahead, Enter/Space, submenu coordination) is the responsibility
        // of the consumer component (e.g. dropdown-menu), because menu keyboard
        // behavior varies by context (orientation, nesting, item type, control
        // pattern). See: notes/outputs/menu-keyboard-decision.md
        return (0, $bkEWs.getFirstFocusable)({
            container: container
        });
    }
    if (role === 'listbox') {
        // ARIA Combobox Pattern: if a combobox-like textbox owns the popup
        // (in-popup or external e.g. react-select), leave focus on the
        // textbox - navigation is proxied through it.
        if ($6b3c1bc0436883f2$var$isComboboxControllingPopup({
            container: container
        })) return null;
        // Prefer the selected option, then fall back to the first option.
        // We intentionally match by `[role="option"]` rather than by
        // `getFirstFocusable`. The standard WAI-ARIA APG listbox pattern
        // renders options with `tabindex="-1"` (managed via roving
        // tabindex); `getFirstFocusable` excludes `tabindex="-1"` elements
        // and would silently lose initial focus for spec-conformant
        // listboxes. Options remain programmatically focusable.
        var selectedOption = container.querySelector('[role="option"][aria-selected="true"]');
        if (selectedOption) return selectedOption;
        var firstOption = container.querySelector('[role="option"]');
        if (firstOption) return firstOption;
        // Last resort for non-standard listboxes that render no options
        // but do contain a focusable element (e.g. an empty-state action).
        return (0, $bkEWs.getFirstFocusable)({
            container: container
        });
    }
    // tooltip, no role, or other roles: no focus movement
    return null;
}
function $6b3c1bc0436883f2$export$e992c40175757a22(_ref3) {
    var elementRef = _ref3.elementRef, phase = _ref3.phase, role = _ref3.role;
    // Track the previous phase so we only focus on transitions into a
    // visible phase from either `'closed'` (fresh mount) or `'exiting'`
    // (mid-exit reopen where the browser has already restored focus to
    // the trigger). Pure `entering → exiting → entering` stutters where
    // the consumer toggles in the same frame are still collapsed.
    var prevPhaseRef = (0, $5FkrB.useRef)('closed');
    (0, $5FkrB.useEffect)(function() {
        var _getInitialFocusTarge;
        var prevPhase = prevPhaseRef.current;
        prevPhaseRef.current = phase;
        // Only focus on transitions into a visible phase from `'closed'`
        // (fresh open) or `'exiting'` (mid-exit reopen).
        if (phase === 'closed') return;
        if (prevPhase !== 'closed' && prevPhase !== 'exiting') return;
        var element = elementRef.current;
        if (!element) return;
        (_getInitialFocusTarge = $6b3c1bc0436883f2$var$getInitialFocusTarget({
            container: element,
            role: role
        })) === null || _getInitialFocusTarge === void 0 || _getInitialFocusTarge.focus();
    }, [
        elementRef,
        phase,
        role
    ]);
}

});


parcelRegister("cmaFv", function(module, exports) {
$parcel$export(module.exports, "useAnchorPosition", () => $8fefd0a803d3f5dc$export$56b02a1e583f953c);

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $5FkrB = parcelRequire("5FkrB");

var $7QpUe = parcelRequire("7QpUe");

var $45Zis = parcelRequire("45Zis");

var $gaDKB = parcelRequire("gaDKB");

var $aZV5N = parcelRequire("aZV5N");

var $760r0 = parcelRequire("760r0");

var $hjsf4 = parcelRequire("hjsf4");

var $bI2XF = parcelRequire("bI2XF");

var $fQ9bO = parcelRequire("fQ9bO");

var $8Ll9B = parcelRequire("8Ll9B");

var $3kH89 = parcelRequire("3kH89");
// `getPlacement` is intentionally NOT re-exported here - import it directly
// from `./resolve-placement` so search-and-jump lands at the source of truth.
/**
 * Module-scope no-op `ResizeObserver` used in non-DOM jest environments where
 * `ResizeObserver` is `undefined`. Hoisted out of the effect to avoid
 * allocating a new class declaration on every run.
 */ var $8fefd0a803d3f5dc$var$NoopResizeObserver = /*#__PURE__*/ function() {
    function NoopResizeObserver() {
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, NoopResizeObserver);
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(NoopResizeObserver, [
        {
            key: "observe",
            value: function observe() {}
        },
        {
            key: "unobserve",
            value: function unobserve() {}
        },
        {
            key: "disconnect",
            value: function disconnect() {}
        }
    ]);
}();
/**
 * Returns true when the popover is currently open. Wrapped because the
 * `:popover-open` pseudo-class is not implemented in some test environments
 * (e.g. jsdom), where `matches` throws on unknown selectors.
 */ function $8fefd0a803d3f5dc$var$isPopoverOpen(popover) {
    try {
        return popover.matches(':popover-open');
    } catch (_unused) {
        return false;
    }
}
/**
 * Detects whether the browser supports CSS Anchor Positioning.
 * Uses `once()` for lazy evaluation: safe for SSR and avoids hydration mismatches.
 */ var $8fefd0a803d3f5dc$var$supportsAnchorPositioning = (0, $gaDKB.default)(function() {
    if (typeof window === 'undefined' || typeof CSS === 'undefined' || typeof CSS.supports !== 'function') return false;
    return CSS.supports('anchor-name', '--a');
});
/**
 * Returns the CSS margin declaration that creates a gap between the
 * popover and its trigger on the side facing the anchor.
 *
 * For example, a `block-end` placement (popover below) gets
 * `margin-block-start: 8px` to push it away from the trigger's bottom edge.
 */ function $8fefd0a803d3f5dc$var$edgeMargin(_ref) {
    var placement = _ref.placement, offset = _ref.offset;
    var axis = placement.axis, edge = placement.edge;
    var value = offset;
    if (axis === 'block' && edge === 'end') return {
        property: 'margin-block-start',
        value: value
    };
    if (axis === 'block' && edge === 'start') return {
        property: 'margin-block-end',
        value: value
    };
    if (axis === 'inline' && edge === 'end') return {
        property: 'margin-inline-start',
        value: value
    };
    if (axis === 'inline' && edge === 'start') return {
        property: 'margin-inline-end',
        value: value
    };
    return {
        property: 'margin-block-start',
        value: value
    };
}
/**
 * Cross-axis shift margin. Margin side matches the popover's anchored
 * cross-axis edge: `align: 'start'` uses the START margin, `align: 'end'`
 * uses the END margin with the sign inverted (so `forwards` is always
 * positive), `align: 'center'` uses START. Margin on the un-anchored side
 * has no effect under CSS Anchor Positioning.
 */ function $8fefd0a803d3f5dc$var$crossAxisShiftMargin(_ref2) {
    var placement = _ref2.placement, crossAxisShiftCssValue = _ref2.crossAxisShiftCssValue, direction = _ref2.direction;
    var axis = placement.axis, align = placement.align;
    var directionSign = direction === 'forwards' ? 1 : -1;
    var crossAxis = axis === 'block' ? 'inline' : 'block';
    var useEndSide = align === 'end';
    var side = useEndSide ? 'end' : 'start';
    var sideSign = useEndSide ? -1 : 1;
    var finalSign = directionSign * sideSign;
    // Wrap any string in calc() with the sign factor. CSS handles the math.
    var value = finalSign === 1 ? crossAxisShiftCssValue : "calc(-1 * ".concat(crossAxisShiftCssValue, ")");
    return {
        property: "margin-".concat(crossAxis, "-").concat(side),
        value: value
    };
}
/**
 * Returns a referentially-stable, fully-resolved `TPlacement`. The memo is
 * keyed on the resolved primitive fields so a fresh inline `placement` object
 * (or undefined fields vs explicit defaults) does not produce a fresh result.
 */ function $8fefd0a803d3f5dc$var$useStablePlacement(placement) {
    var resolved = (0, $8Ll9B.getPlacement)({
        placement: placement
    });
    var axis = resolved.axis;
    var edge = resolved.edge;
    var align = resolved.align;
    var gap = resolved.offset.gap;
    var shiftValue = resolved.offset.crossAxisShift.value;
    var shiftDirection = resolved.offset.crossAxisShift.direction;
    // Rebuild inside the memo from primitive deps so the factory does not
    // close over the outer `resolved` reference and exhaustive-deps can verify.
    return (0, $5FkrB.useMemo)(function() {
        return {
            axis: axis,
            edge: edge,
            align: align,
            offset: {
                gap: gap,
                crossAxisShift: {
                    value: shiftValue,
                    direction: shiftDirection
                }
            }
        };
    }, [
        axis,
        edge,
        align,
        gap,
        shiftValue,
        shiftDirection
    ]);
}
function $8fefd0a803d3f5dc$export$56b02a1e583f953c(_ref3) {
    var anchorRef = _ref3.anchorRef, popoverRef = _ref3.popoverRef, _ref3$placement = _ref3.placement, placement = _ref3$placement === void 0 ? {} : _ref3$placement, _ref3$forceFallbackPo = _ref3.forceFallbackPositioning, forceFallbackPositioning = _ref3$forceFallbackPo === void 0 ? false : _ref3$forceFallbackPo, _ref3$isEnabled = _ref3.isEnabled, isEnabled = _ref3$isEnabled === void 0 ? true : _ref3$isEnabled, isOpen = _ref3.isOpen;
    var id = (0, $5FkrB.useId)();
    var stablePlacement = $8fefd0a803d3f5dc$var$useStablePlacement(placement);
    (0, $5FkrB.useLayoutEffect)(function() {
        if (!isEnabled) return;
        var trigger = anchorRef.current;
        var popover = popoverRef.current;
        if (!trigger || !popover) return;
        var gapCssValue = stablePlacement.offset.gap;
        var crossAxisShiftCssValue = stablePlacement.offset.crossAxisShift.value;
        var shouldForceFallback = Boolean(forceFallbackPositioning);
        if ($8fefd0a803d3f5dc$var$supportsAnchorPositioning() && !shouldForceFallback) {
            // Reuse an existing `anchor-name` if the element already has one.
            // Another popover might already be anchored to the old name.
            var anchorName = trigger.style.getPropertyValue('anchor-name') || "--anchor-".concat(id.replace(/:/g, ''));
            var gap = $8fefd0a803d3f5dc$var$edgeMargin({
                placement: stablePlacement,
                offset: gapCssValue
            });
            // Computed once; reused below to populate the active
            // `--ds-cross-axis-shift-margin-*` custom property for the
            // named arrow @position-try rules.
            var crossAxisShift = $8fefd0a803d3f5dc$var$crossAxisShiftMargin({
                placement: stablePlacement,
                crossAxisShiftCssValue: crossAxisShiftCssValue,
                direction: stablePlacement.offset.crossAxisShift.direction
            });
            var popoverStyles = [
                {
                    property: 'position-anchor',
                    value: anchorName
                },
                {
                    property: 'position-area',
                    value: (0, $hjsf4.placementToPositionArea)({
                        placement: stablePlacement
                    })
                },
                {
                    property: 'position-try-fallbacks',
                    value: (0, $bI2XF.placementToTryFallbacks)({
                        placement: stablePlacement
                    })
                },
                // Reset browser default popover positioning that conflicts
                // with anchor positioning (UA: `inset: 0; margin: auto;`)
                {
                    property: 'margin',
                    value: '0'
                },
                {
                    property: 'inset',
                    value: 'auto'
                },
                {
                    property: gap.property,
                    value: gap.value
                },
                {
                    property: crossAxisShift.property,
                    value: crossAxisShift.value
                }
            ];
            // Expose the active cross-axis shift via custom properties so each
            // named arrow @position-try rule can re-apply it after a flip.
            // One of the four (cross-axis, side) properties is non-zero at a time.
            popoverStyles.push({
                property: '--ds-cross-axis-shift-margin-start',
                value: '0px'
            });
            popoverStyles.push({
                property: '--ds-cross-axis-shift-margin-end',
                value: '0px'
            });
            popoverStyles.push({
                property: '--ds-cross-axis-shift-margin-block-start',
                value: '0px'
            });
            popoverStyles.push({
                property: '--ds-cross-axis-shift-margin-block-end',
                value: '0px'
            });
            // `crossAxisShift` IS the active margin; reuse instead of recomputing.
            var crossAxisShiftActive = crossAxisShift;
            var customPropertyByMarginProperty = {
                'margin-inline-start': '--ds-cross-axis-shift-margin-start',
                'margin-inline-end': '--ds-cross-axis-shift-margin-end',
                'margin-block-start': '--ds-cross-axis-shift-margin-block-start',
                'margin-block-end': '--ds-cross-axis-shift-margin-block-end'
            };
            var crossAxisShiftCustomProperty = customPropertyByMarginProperty[crossAxisShiftActive.property];
            if (crossAxisShiftCustomProperty) popoverStyles.push({
                property: crossAxisShiftCustomProperty,
                value: crossAxisShiftActive.value
            });
            /**
       * **We are never cleaning up anchor names**
       *
       * _Rationale_
       *
       * - Multiple popovers can share the same anchor element.
       * - Sometimes the `useAnchorPosition` hook and `Popover`
       *   are not in the same component.
       * - There can be times when, even with reference counting, we
       *   could remove the anchor-name while it is still being used
       *   by something else - especially with async react updates
       *   which can cause tearing
       *
       * _More_
       *
       * See `notes/decisions/anchor-name-lifetime.md`
       */ trigger.style.setProperty('anchor-name', anchorName);
            var _undoPositioning = (0, $760r0.combine)((0, $3kH89.setStyle)({
                element: popover,
                styles: popoverStyles
            }));
            return _undoPositioning;
        }
        // JS fallback. The popover is already in the top layer via
        // popover="auto", so we only reset UA defaults and set top/left
        // based on measurements.
        var cleanupBaseStyles = (0, $3kH89.setStyle)({
            element: popover,
            styles: [
                {
                    property: 'margin',
                    value: '0'
                },
                {
                    property: 'inset',
                    value: 'auto'
                }
            ]
        });
        function update() {
            if (!trigger || !popover) return;
            var triggerRect = trigger.getBoundingClientRect();
            var viewport = {
                width: window.innerWidth,
                height: window.innerHeight
            };
            // Resolve consumer-supplied CSS length strings (tokens, calc, var,
            // px, rem, etc) to pixels. The probe is mounted INSIDE the popover
            // itself so the resolved length matches the scope a token would
            // resolve against from inside the popover content. (The popover
            // lives in the top layer, not the trigger's DOM tree, so probing
            // at `popover.parentElement` would resolve in a different scope
            // than the consumer's token authoring expects.)
            var gapPx = (0, $fQ9bO.resolveCssLengthToPixels)({
                value: gapCssValue,
                container: popover
            });
            var crossAxisShiftPx = (0, $fQ9bO.resolveCssLengthToPixels)({
                value: crossAxisShiftCssValue,
                container: popover
            });
            var _computeFallbackPosit = (0, $aZV5N.computeFallbackPosition)({
                triggerRect: triggerRect,
                popoverEl: popover,
                placement: stablePlacement,
                viewport: viewport,
                gap: gapPx,
                crossAxisShift: {
                    value: crossAxisShiftPx,
                    direction: stablePlacement.offset.crossAxisShift.direction
                }
            }), top = _computeFallbackPosit.top, left = _computeFallbackPosit.left;
            popover.style.setProperty('top', "".concat(top, "px"));
            popover.style.setProperty('left', "".concat(left, "px"));
            // Reveal the popover only after it has been positioned.
            // See the toggle listener below for why we hide on open.
            popover.style.removeProperty('opacity');
        }
        // Throttle scroll/resize updates to one per animation frame
        var scheduledUpdate = (0, $45Zis.default)(update);
        // Wait for the FIRST valid layout before measuring: the popover
        // is `display: none` until `showPopover()`, and some browsers
        // fire `toggle` before layout, so RAF-after-toggle is unreliable.
        // ResizeObserver fires once the browser has real dimensions.
        // Self-disconnects after one valid measurement; ongoing
        // scroll/resize is handled by the window listeners below.
        // `ResizeObserver` is missing in some non-DOM jest environments
        // (e.g. post-office's `node` environment). Fall back to a no-op
        // observer there. The scroll/resize listeners below still keep
        // the popover positioned in the rare case the consumer also
        // polyfilled `showPopover` but not `ResizeObserver`. Real
        // browsers always have it. The `NoopResizeObserver` class is
        // hoisted to module scope (see top of file) so we do not allocate
        // a new constructor on every effect run.
        var ResizeObserverImpl = typeof ResizeObserver !== 'undefined' ? ResizeObserver : $8fefd0a803d3f5dc$var$NoopResizeObserver;
        var resizeObserver = new ResizeObserverImpl(function() {
            if (popover.offsetWidth > 0 && popover.offsetHeight > 0) {
                update();
                resizeObserver.disconnect();
            }
        });
        // If the popover is already open by the time this effect runs (for
        // example, the parent `useAnchorPosition` effect runs after the child
        // `Popover` effect that called `showPopover()`), the initial `toggle`
        // event has already fired and our listener below would miss it. Start
        // observing immediately so the first measurement still happens.
        if ($8fefd0a803d3f5dc$var$isPopoverOpen(popover)) {
            popover.style.setProperty('opacity', '0');
            resizeObserver.observe(popover);
        }
        var undoPositioning = (0, $760r0.combine)(cleanupBaseStyles, // On every open: hide synchronously so the user never sees
        // the UA-default position, then re-observe for a fresh
        // measurement. We use `opacity: 0` rather than
        // `visibility: hidden` because Firefox skips visibility-hidden
        // elements during `<dialog>` initial-focus traversal. See
        // `form-in-popup.spec.tsx` on `desktop-firefox`.
        (0, $7QpUe.bind)(popover, {
            type: 'toggle',
            listener: function listener(event) {
                var toggleEvent = event;
                if (toggleEvent.newState === 'open') {
                    popover.style.setProperty('opacity', '0');
                    resizeObserver.observe(popover);
                }
            }
        }), function() {
            return resizeObserver.disconnect();
        }, (0, $7QpUe.bind)(window, {
            type: 'scroll',
            listener: scheduledUpdate,
            options: {
                capture: true,
                passive: true
            }
        }), (0, $7QpUe.bind)(window, {
            type: 'resize',
            listener: scheduledUpdate,
            options: {
                passive: true
            }
        }), function() {
            scheduledUpdate.cancel();
            popover.style.removeProperty('top');
            popover.style.removeProperty('left');
            popover.style.removeProperty('opacity');
        });
        return undoPositioning;
    }, [
        anchorRef,
        popoverRef,
        stablePlacement,
        forceFallbackPositioning,
        isEnabled,
        id,
        isOpen
    ]);
}

});
parcelRegister("aZV5N", function(module, exports) {
$parcel$export(module.exports, "computeFallbackPosition", () => $801be345dbc0474e$export$d5ef1dac02135664);

var $25nEq = parcelRequire("25nEq");
function $801be345dbc0474e$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $801be345dbc0474e$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $801be345dbc0474e$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $801be345dbc0474e$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
/**
 * JS fallback positioning math. Used only when the browser does not
 * support CSS Anchor Positioning (less than 6% of users).
 *
 * Consumer-supplied `offset.gap` and `offset.crossAxisShift` are
 * honored: the caller (`useAnchorPosition`) resolves CSS length strings
 * (tokens, calc, var, etc) to pixels via a DOM probe before passing them
 * in. The caller also keeps the popover hidden (`opacity: 0`) until the
 * first measurement completes, so the popover never paints at the wrong
 * position.
 */ /**
 * Computes the base {top, left} position based on the primary edge,
 * flipping to the opposite side when there is not enough space.
 *
 * `gap` is applied along the main axis between trigger and popover.
 */ function $801be345dbc0474e$var$computeEdgePosition(_ref) {
    var axis = _ref.axis, edge = _ref.edge, triggerRect = _ref.triggerRect, popoverWidth = _ref.popoverWidth, popoverHeight = _ref.popoverHeight, viewport = _ref.viewport, gap = _ref.gap;
    if (axis === 'block' && edge === 'end') {
        // Below trigger
        var spaceBelow = viewport.height - triggerRect.bottom;
        var spaceAbove = triggerRect.top;
        var fitsBelow = spaceBelow >= popoverHeight + gap;
        var useBelow = fitsBelow || spaceBelow >= spaceAbove;
        return {
            top: useBelow ? triggerRect.bottom + gap : triggerRect.top - popoverHeight - gap,
            left: triggerRect.left + triggerRect.width / 2 - popoverWidth / 2
        };
    }
    if (axis === 'block' && edge === 'start') {
        // Above trigger
        var _spaceAbove = triggerRect.top;
        var _spaceBelow = viewport.height - triggerRect.bottom;
        var fitsAbove = _spaceAbove >= popoverHeight + gap;
        var useAbove = fitsAbove || _spaceAbove >= _spaceBelow;
        return {
            top: useAbove ? triggerRect.top - popoverHeight - gap : triggerRect.bottom + gap,
            left: triggerRect.left + triggerRect.width / 2 - popoverWidth / 2
        };
    }
    if (axis === 'inline' && edge === 'end') {
        // Right of trigger
        var spaceRight = viewport.width - triggerRect.right;
        var spaceLeft = triggerRect.left;
        var fitsRight = spaceRight >= popoverWidth + gap;
        var useRight = fitsRight || spaceRight >= spaceLeft;
        return {
            top: triggerRect.top + triggerRect.height / 2 - popoverHeight / 2,
            left: useRight ? triggerRect.right + gap : triggerRect.left - popoverWidth - gap
        };
    }
    if (axis === 'inline' && edge === 'start') {
        // Left of trigger
        var _spaceLeft = triggerRect.left;
        var _spaceRight = viewport.width - triggerRect.right;
        var fitsLeft = _spaceLeft >= popoverWidth + gap;
        var useLeft = fitsLeft || _spaceLeft >= _spaceRight;
        return {
            top: triggerRect.top + triggerRect.height / 2 - popoverHeight / 2,
            left: useLeft ? triggerRect.left - popoverWidth - gap : triggerRect.right + gap
        };
    }
    // Unreachable for valid placements; defaults to below trigger
    return {
        top: triggerRect.bottom + gap,
        left: triggerRect.left + triggerRect.width / 2 - popoverWidth / 2
    };
}
/**
 * Adjusts the base (centered) position for non-center alignments.
 *
 * `align: 'start'` → popover start edge at trigger start edge
 * `align: 'end'`   → popover end edge at trigger end edge
 */ function $801be345dbc0474e$var$applyAlignment(_ref2) {
    var position = _ref2.position, axis = _ref2.axis, align = _ref2.align, triggerRect = _ref2.triggerRect, popoverWidth = _ref2.popoverWidth, popoverHeight = _ref2.popoverHeight;
    if (align === 'center') return position;
    if (axis === 'block') {
        // Block-axis placement → cross-axis is inline (left/right)
        if (align === 'start') return $801be345dbc0474e$var$_objectSpread($801be345dbc0474e$var$_objectSpread({}, position), {}, {
            left: triggerRect.left
        });
        // align === 'end'
        return $801be345dbc0474e$var$_objectSpread($801be345dbc0474e$var$_objectSpread({}, position), {}, {
            left: triggerRect.right - popoverWidth
        });
    }
    // Inline-axis placement → cross-axis is block (top/bottom)
    if (align === 'start') return $801be345dbc0474e$var$_objectSpread($801be345dbc0474e$var$_objectSpread({}, position), {}, {
        top: triggerRect.top
    });
    // align === 'end'
    return $801be345dbc0474e$var$_objectSpread($801be345dbc0474e$var$_objectSpread({}, position), {}, {
        top: triggerRect.bottom - popoverHeight
    });
}
/**
 * Applies the cross-axis shift offset.
 *
 * The sign mirrors the CSS path (see `crossAxisShiftMargin` in
 * `use-anchor-position.tsx`):
 *   - `align: 'start' | 'center'` + `forwards`  → push toward end (positive)
 *   - `align: 'end'`              + `forwards`  → push toward start (negative)
 *   - `backwards` flips the sign in both cases.
 */ function $801be345dbc0474e$var$applyCrossAxisShift(_ref3) {
    var position = _ref3.position, axis = _ref3.axis, align = _ref3.align, crossAxisShift = _ref3.crossAxisShift;
    if (crossAxisShift.value === 0) return position;
    var directionSign = crossAxisShift.direction === 'forwards' ? 1 : -1;
    var sideSign = align === 'end' ? -1 : 1;
    var delta = crossAxisShift.value * directionSign * sideSign;
    // Cross-axis is the OPPOSITE of the placement axis.
    if (axis === 'block') return $801be345dbc0474e$var$_objectSpread($801be345dbc0474e$var$_objectSpread({}, position), {}, {
        left: position.left + delta
    });
    return $801be345dbc0474e$var$_objectSpread($801be345dbc0474e$var$_objectSpread({}, position), {}, {
        top: position.top + delta
    });
}
function $801be345dbc0474e$export$d5ef1dac02135664(_ref4) {
    var triggerRect = _ref4.triggerRect, popoverEl = _ref4.popoverEl, placement = _ref4.placement, viewport = _ref4.viewport, gap = _ref4.gap, crossAxisShift = _ref4.crossAxisShift;
    var axis = placement.axis, edge = placement.edge, align = placement.align;
    // Measure popover dimensions. Callers must ensure the popover has
    // laid out before calling this (it should not be `display: none`).
    var popoverWidth = popoverEl.offsetWidth;
    var popoverHeight = popoverEl.offsetHeight;
    var basePosition = $801be345dbc0474e$var$computeEdgePosition({
        axis: axis,
        edge: edge,
        triggerRect: triggerRect,
        popoverWidth: popoverWidth,
        popoverHeight: popoverHeight,
        viewport: viewport,
        gap: gap
    });
    var alignedPosition = $801be345dbc0474e$var$applyAlignment({
        position: basePosition,
        axis: axis,
        align: align,
        triggerRect: triggerRect,
        popoverWidth: popoverWidth,
        popoverHeight: popoverHeight
    });
    var shiftedPosition = $801be345dbc0474e$var$applyCrossAxisShift({
        position: alignedPosition,
        axis: axis,
        align: align,
        crossAxisShift: crossAxisShift
    });
    // Clamp to viewport so the popover is never offscreen
    return {
        top: Math.max(0, Math.min(shiftedPosition.top, viewport.height - popoverHeight)),
        left: Math.max(0, Math.min(shiftedPosition.left, viewport.width - popoverWidth))
    };
}

});

parcelRegister("760r0", function(module, exports) {
$parcel$export(module.exports, "combine", () => $52a96e3e879c9dbf$export$1be1fc439b849fdf);
/**
 * Combine multiple cleanup functions into a single cleanup function.
 *
 * @example
 * ```ts
 * useEffect(() => {
 *   return combine(
 *     bind(window, { type: 'resize', listener: onResize }),
 *     bind(window, { type: 'scroll', listener: onScroll, options: { capture: true } }),
 *   );
 * }, []);
 * ```
 */ function $52a96e3e879c9dbf$export$1be1fc439b849fdf() {
    for(var _len = arguments.length, cleanupFns = new Array(_len), _key = 0; _key < _len; _key++)cleanupFns[_key] = arguments[_key];
    return function cleanup() {
        cleanupFns.forEach(function(callback) {
            return callback === null || callback === void 0 ? void 0 : callback();
        });
    };
}

});

parcelRegister("hjsf4", function(module, exports) {
$parcel$export(module.exports, "placementToPositionArea", () => $c9aa1e4f69c87803$export$de49b61f233ddeb9);

var $8Ll9B = parcelRequire("8Ll9B");
function $c9aa1e4f69c87803$export$de49b61f233ddeb9(_ref) {
    var placement = _ref.placement;
    var _getPlacement = (0, $8Ll9B.getPlacement)({
        placement: placement
    }), axis = _getPlacement.axis, edge = _getPlacement.edge, align = _getPlacement.align;
    var edgeValue = "".concat(axis, "-").concat(edge);
    if (align === 'center') return edgeValue;
    // Cross-axis name: block ↔ inline
    var crossAxis = axis === 'block' ? 'inline' : 'block';
    // Invert align → CSS span direction: visual 'start' → span toward 'end'
    var spanDir = align === 'start' ? 'end' : 'start';
    return "".concat(edgeValue, " span-").concat(crossAxis, "-").concat(spanDir);
}

});

parcelRegister("bI2XF", function(module, exports) {
$parcel$export(module.exports, "placementToTryFallbacks", () => $886619db15954d15$export$c4e16947a95d61f1);

var $fC8ib = parcelRequire("fC8ib");

var $8Ll9B = parcelRequire("8Ll9B");
function $886619db15954d15$export$c4e16947a95d61f1(_ref) {
    var placement = _ref.placement;
    var _getPlacement = (0, $8Ll9B.getPlacement)({
        placement: placement
    }), axis = _getPlacement.axis, edge = _getPlacement.edge, align = _getPlacement.align;
    var crossAxis = axis === 'block' ? 'inline' : 'block';
    var flippedEdge = edge === 'start' ? 'end' : 'start';
    var sameEdge = "".concat(axis, "-").concat(edge);
    var oppositeEdge = "".concat(axis, "-").concat(flippedEdge);
    var flipKeyword = axis === 'block' ? 'flip-block' : 'flip-inline';
    var flipCrossKeyword = axis === 'block' ? 'flip-inline' : 'flip-block';
    // Single algorithm: produce the shift list against any base alignment.
    // For `align: 'start'` the "near" shift expands toward `end`; for
    // `align: 'end'` it expands toward `start`; for `align: 'center'`
    // either order is symmetric (we use end-then-start to match the
    // historical fallback list).
    function shifts(baseAlign, edgeKey) {
        if (baseAlign === 'center') return [
            "".concat(edgeKey, " span-").concat(crossAxis, "-end"),
            "".concat(edgeKey, " span-").concat(crossAxis, "-start")
        ];
        var near = baseAlign === 'start' ? 'end' : 'start';
        var far = baseAlign === 'start' ? 'start' : 'end';
        return [
            "".concat(edgeKey, " span-").concat(crossAxis, "-").concat(near),
            edgeKey,
            "".concat(edgeKey, " span-").concat(crossAxis, "-").concat(far)
        ];
    }
    if (align !== 'center') // Aligned (start/end): try same-edge shifts, then single-axis flip,
    // then diagonal flip for corner overflow, then opposite-edge shifts.
    // Legacy Popper fallback ordering for e.g. bottom-start:
    // [bottom, bottom-end, top-start, top, top-end, auto].
    return [].concat((0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(shifts(align, sameEdge)), [
        flipKeyword,
        "".concat(flipKeyword, " ").concat(flipCrossKeyword)
    ], (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(shifts(align, oppositeEdge))).join(', ');
    // Centered: same-edge shifts, single-axis flip, opposite-edge shifts.
    // Diagonal flip is unnecessary because centered placements expand
    // equally in both cross-axis directions.
    return [].concat((0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(shifts('center', sameEdge)), [
        flipKeyword
    ], (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(shifts('center', oppositeEdge))).join(', ');
}

});

parcelRegister("fQ9bO", function(module, exports) {
$parcel$export(module.exports, "resolveCssLengthToPixels", () => $b882d72a80a1cccf$export$98721546d2816d9e);
var $b882d72a80a1cccf$var$elementCaches = new WeakMap();
function $b882d72a80a1cccf$var$canCacheResolvedLength(value) {
    // Custom-property values can be retargeted by inline overrides on the
    // consumer's wrapper, so we cannot prove a cached pixel value is still valid.
    return !value.includes('var(');
}
function $b882d72a80a1cccf$var$getCachedResolvedLength(_ref) {
    var _cacheForElement$get;
    var element = _ref.element, value = _ref.value;
    if (!$b882d72a80a1cccf$var$canCacheResolvedLength(value)) return null;
    var cacheForElement = $b882d72a80a1cccf$var$elementCaches.get(element);
    return (_cacheForElement$get = cacheForElement === null || cacheForElement === void 0 ? void 0 : cacheForElement.get(value)) !== null && _cacheForElement$get !== void 0 ? _cacheForElement$get : null;
}
function $b882d72a80a1cccf$var$cacheResolvedLength(_ref2) {
    var _elementCaches$get;
    var element = _ref2.element, value = _ref2.value, result = _ref2.result;
    if (!$b882d72a80a1cccf$var$canCacheResolvedLength(value)) return;
    var cacheForElement = (_elementCaches$get = $b882d72a80a1cccf$var$elementCaches.get(element)) !== null && _elementCaches$get !== void 0 ? _elementCaches$get : new Map();
    cacheForElement.set(value, result);
    $b882d72a80a1cccf$var$elementCaches.set(element, cacheForElement);
}
function $b882d72a80a1cccf$export$98721546d2816d9e(_ref3) {
    var value = _ref3.value, container = _ref3.container;
    if (typeof value === 'number') return value;
    // Fast path: unitless zero is universally zero pixels - accept `'0'` and
    // `'-0'` without a probe. (Consumers occasionally pass `'0'` instead of
    // the number `0`.)
    if (value === '0' || value === '-0') return 0;
    // Fast path: bare `${n}px` strings come from the consumer normalisation
    // in `getPlacement`. Avoid a reflow when we can.
    var pxMatch = value.match(/^(-?\d+(?:\.\d+)?)px$/);
    if (pxMatch) return Number(pxMatch[1]);
    var cached = $b882d72a80a1cccf$var$getCachedResolvedLength({
        element: container,
        value: value
    });
    if (cached !== null) return cached;
    var probe = container.ownerDocument.createElement('div');
    probe.style.position = 'absolute';
    probe.style.visibility = 'hidden';
    probe.style.pointerEvents = 'none';
    probe.style.height = '0';
    probe.style.padding = '0';
    probe.style.border = '0';
    // `width` clamps negatives to 0; use `margin-left` instead so signs are
    // preserved. `getComputedStyle` returns the resolved pixel value for
    // margin-* properties even when the source was a token / calc / var.
    probe.style.marginLeft = value;
    // Hide the probe from assistive tech and event targeting; defensive
    // against `getElementsByTagName('div')` walks in consumer code.
    probe.setAttribute('aria-hidden', 'true');
    probe.setAttribute('inert', '');
    container.appendChild(probe);
    var resolved = parseFloat(getComputedStyle(probe).marginLeft);
    container.removeChild(probe);
    var result = Number.isFinite(resolved) ? resolved : 0;
    $b882d72a80a1cccf$var$cacheResolvedLength({
        element: container,
        value: value,
        result: result
    });
    return result;
}

});

parcelRegister("3kH89", function(module, exports) {
$parcel$export(module.exports, "setStyle", () => $26d4b22ab88ea11b$export$37a5fde709c1db82);
/**
 * Sets inline styles on an element and returns a cleanup function that
 * restores the prior inline values (so we do not stomp consumer styles).
 */ function $26d4b22ab88ea11b$export$37a5fde709c1db82(_ref) {
    var element = _ref.element, styles = _ref.styles;
    // Snapshot the prior inline value (NOT the computed style - we only want
    // to restore values that the consumer/our previous run inlined). An empty
    // string means "no inline value", in which case cleanup uses removeProperty.
    var priorValues = styles.map(function(_ref2) {
        var property = _ref2.property;
        return {
            property: property,
            value: element.style.getPropertyValue(property)
        };
    });
    styles.forEach(function(_ref3) {
        var property = _ref3.property, value = _ref3.value;
        element.style.setProperty(property, value);
    });
    return function cleanup() {
        priorValues.forEach(function(_ref4) {
            var property = _ref4.property, value = _ref4.value;
            if (value === '') {
                element.style.removeProperty(property);
                return;
            }
            element.style.setProperty(property, value);
        });
    };
}

});


parcelRegister("fE53w", function(module, exports) {
$parcel$export(module.exports, "useAnchorPositionAtPoint", () => $b63e836d4b11b35e$export$6f230729189a5b8a);

var $5FkrB = parcelRequire("5FkrB");

var $cmaFv = parcelRequire("cmaFv");
/**
 * A point in viewport coordinates (CSS pixels) at which the synthetic
 * anchor should be placed.
 *
 * Axis-named (`x`/`y`) rather than edge-named (`left`/`top`) so the
 * shape is unambiguous in RTL writing modes - there is no ambiguity
 * about whether a coordinate is logical (`inline-start`/`block-start`)
 * or physical (`left`/`top`). Viewport coordinates are always
 * physical, so we name them with the physical axis labels.
 */ /**
 * Styles the synthetic anchor as an invisible, zero-size point.
 * Dynamic `inset-*` overrides are written by the positioning effect.
 *
 * Uses `Object.assign` rather than Compiled CSS (element is outside the React tree)
 * or the internal `setStyle` helper (we own this element entirely - it is created
 * and removed by this hook - so the snapshot/restore semantics `setStyle`
 * provides for caller-owned elements would be dead work here).
 */ function $b63e836d4b11b35e$var$applyStaticAnchorStyles(element) {
    Object.assign(element.style, {
        position: 'fixed',
        // `top`/`left` rather than `inset-block-start`/`inset-inline-start`
        // for consistency with the dynamic positioning effect below, which
        // uses physical properties (see comment there for the rationale).
        top: '0',
        left: '0',
        // Zero size - placement decides which side the popover sits on.
        width: '0',
        height: '0',
        // Prevent the overlay from intercepting pointer events.
        pointerEvents: 'none'
    });
}
function $b63e836d4b11b35e$export$6f230729189a5b8a(_ref) {
    var popoverRef = _ref.popoverRef, placement = _ref.placement, getPoint = _ref.getPoint, _ref$isEnabled = _ref.isEnabled, isEnabled = _ref$isEnabled === void 0 ? true : _ref$isEnabled, isOpen = _ref.isOpen;
    var syntheticAnchorRef = (0, $5FkrB.useRef)(null);
    // `getPoint` is kept in a ref so the layout effect can call the
    // latest version without listing it as a dep - that would re-fire
    // on every render and re-latch the point.
    var getPointRef = (0, $5FkrB.useRef)(getPoint);
    getPointRef.current = getPoint;
    // Lazy element creation: the `<div>` is only created when both
    // `isEnabled` is true AND `getPoint()` returns a non-null point.
    // `useLayoutEffect` ensures the element exists before the inner
    // `useAnchorPosition` (also a layout effect) reads the ref.
    (0, $5FkrB.useLayoutEffect)(function() {
        if (!isEnabled) return;
        var point = getPointRef.current();
        if (!point) return;
        var anchor = document.createElement('div');
        anchor.setAttribute('aria-hidden', 'true');
        $b63e836d4b11b35e$var$applyStaticAnchorStyles(anchor);
        // `point.x`/`y` are physical viewport coordinates (from
        // `MouseEvent.clientX/Y`), so map directly onto physical
        // `left`/`top`. This is RTL-safe: `position: fixed` + physical
        // insets is direction-independent. Using logical
        // `inset-inline-start` would need `viewportWidth - point.x` in
        // RTL to land at the same physical pixel.
        anchor.style.top = "".concat(point.y, "px");
        anchor.style.left = "".concat(point.x, "px");
        document.body.appendChild(anchor);
        syntheticAnchorRef.current = anchor;
        return function cleanup() {
            anchor.remove();
            syntheticAnchorRef.current = null;
        };
    }, [
        isEnabled
    ]);
    // Mirror `isEnabled` so both hooks stay in sync - when disabled,
    // neither this hook nor the inner one touches the popover, leaving
    // any other positioning the consumer has set up free to take effect.
    (0, $cmaFv.useAnchorPosition)({
        anchorRef: syntheticAnchorRef,
        popoverRef: popoverRef,
        placement: placement,
        isEnabled: isEnabled,
        isOpen: isOpen
    });
}

});

parcelRegister("6xj5M", function(module, exports) {
$parcel$export(module.exports, "register", () => $4c24a27222f36266$export$6503ec6e8aabbaf);
/* eslint-disable @atlaskit/design-system/no-direct-use-of-web-platform-drag-and-drop */ /**
 * We are listening directly to drag events instead of using a monitor from
 * `@atlaskit/pragmatic-drag-and-drop` to avoid the bundle size cost, as it
 * would affect almost every view in every app.
 *
 * We can reconsider this choice in the future.
 */ 
var $7QpUe = parcelRequire("7QpUe");
var $4c24a27222f36266$var$registrations = new Set();
var $4c24a27222f36266$var$cleanupEndEventListeners = null;
function $4c24a27222f36266$var$onDragStart() {
    if ($4c24a27222f36266$var$cleanupEndEventListeners) // If the cleanup function exists then we've already run this
    return;
    $4c24a27222f36266$var$cleanupEndEventListeners = (0, $7QpUe.bindAll)(window, [
        {
            type: 'dragend',
            listener: $4c24a27222f36266$var$onDragEnd
        },
        {
            type: 'pointerdown',
            listener: $4c24a27222f36266$var$onDragEnd
        },
        {
            type: 'pointermove',
            listener: function() {
                var callCount = 0;
                return function listener() {
                    // Using 20 as it is far bigger than the most observed (3)
                    if (callCount < 20) {
                        callCount++;
                        return;
                    }
                    $4c24a27222f36266$var$onDragEnd();
                };
            }()
        }
    ]);
    var clone = Array.from($4c24a27222f36266$var$registrations);
    clone.forEach(function(subscriber) {
        subscriber.onDragStart();
    });
}
function $4c24a27222f36266$var$onDragEnd() {
    var _cleanupEndEventListe;
    (_cleanupEndEventListe = $4c24a27222f36266$var$cleanupEndEventListeners) === null || _cleanupEndEventListe === void 0 || _cleanupEndEventListe();
    $4c24a27222f36266$var$cleanupEndEventListeners = null;
    var clone = Array.from($4c24a27222f36266$var$registrations);
    clone.forEach(function(subscriber) {
        subscriber.onDragEnd();
    });
}
function $4c24a27222f36266$var$bindStartEvents() {
    return (0, $7QpUe.bindAll)(window, [
        {
            type: 'dragstart',
            listener: $4c24a27222f36266$var$onDragStart
        },
        {
            type: 'dragenter',
            listener: $4c24a27222f36266$var$onDragStart
        }
    ]);
}
var $4c24a27222f36266$var$cleanupStartEventListeners = null;
function $4c24a27222f36266$export$6503ec6e8aabbaf(registration) {
    // if first registration, bind event listeners
    if (!$4c24a27222f36266$var$cleanupStartEventListeners) // note: currently never unbinding these event listeners
    $4c24a27222f36266$var$cleanupStartEventListeners = $4c24a27222f36266$var$bindStartEvents();
    $4c24a27222f36266$var$registrations.add(registration);
    /**
   * The reasoning for this behavior is so that if a tooltip mounts during
   * a drag it can still be suppressed.
   *
   * We use a separate callback instead of onDragStart to avoid infinite loops.
   */ registration.onRegister({
        isDragging: $4c24a27222f36266$var$cleanupEndEventListeners !== null
    });
    return function unregister() {
        $4c24a27222f36266$var$registrations.delete(registration);
        if ($4c24a27222f36266$var$registrations.size === 0) {
            var _cleanupStartEventLis;
            (_cleanupStartEventLis = $4c24a27222f36266$var$cleanupStartEventListeners) === null || _cleanupStartEventLis === void 0 || _cleanupStartEventLis();
            $4c24a27222f36266$var$cleanupStartEventListeners = null;
        }
    };
}

});

parcelRegister("a8GFF", function(module, exports) {
$parcel$export(module.exports, "getAnchorPoint", () => $761bc04fa8aa8ee7$export$d26fd3d066ede49);
/**
 * Returns the trigger's X edge for inline-axis placements, or the
 * trigger's horizontal center for block-axis placements.
 *
 * Note: does not account for RTL writing modes.
 */ function $761bc04fa8aa8ee7$var$getTriggerEdgeX(_ref) {
    var triggerRect = _ref.triggerRect, placement = _ref.placement;
    if (placement.axis === 'inline') return placement.edge === 'start' ? triggerRect.left : triggerRect.right;
    return triggerRect.left + triggerRect.width / 2;
}
/**
 * Returns the trigger's Y edge for block-axis placements, or the
 * trigger's vertical center for inline-axis placements.
 */ function $761bc04fa8aa8ee7$var$getTriggerEdgeY(_ref2) {
    var triggerRect = _ref2.triggerRect, placement = _ref2.placement;
    if (placement.axis === 'block') return placement.edge === 'start' ? triggerRect.top : triggerRect.bottom;
    return triggerRect.top + triggerRect.height / 2;
}
function $761bc04fa8aa8ee7$export$d26fd3d066ede49(_ref3) {
    var cursor = _ref3.cursor, triggerRect = _ref3.triggerRect, tooltipPosition = _ref3.tooltipPosition, placement = _ref3.placement;
    if (tooltipPosition === 'mouse-y') return {
        x: $761bc04fa8aa8ee7$var$getTriggerEdgeX({
            triggerRect: triggerRect,
            placement: placement
        }),
        y: cursor.clientY
    };
    if (tooltipPosition === 'mouse-x') return {
        x: cursor.clientX,
        y: $761bc04fa8aa8ee7$var$getTriggerEdgeY({
            triggerRect: triggerRect,
            placement: placement
        })
    };
    // tooltipPosition === 'mouse'
    return {
        x: cursor.clientX,
        y: cursor.clientY
    };
}

});

parcelRegister("1K0Sz", function(module, exports) {
$parcel$export(module.exports, "getVirtualElementFromMousePos", () => $144ac4eddd063e96$export$2e68479e0a5d8746);
function $144ac4eddd063e96$export$2e68479e0a5d8746(mousePos, _ref) {
    var targetElement = _ref.targetElement, tooltipPosition = _ref.tooltipPosition;
    if (tooltipPosition === 'mouse') return {
        getBoundingClientRect: function getBoundingClientRect() {
            return DOMRect.fromRect({
                x: mousePos.clientX,
                y: mousePos.clientY,
                width: 0,
                height: 0
            });
        }
    };
    var targetRect = targetElement.getBoundingClientRect();
    if (tooltipPosition === 'mouse-x') return {
        getBoundingClientRect: function getBoundingClientRect() {
            return DOMRect.fromRect({
                x: mousePos.clientX,
                y: targetRect.top,
                width: 0,
                height: targetRect.height
            });
        }
    };
    if (tooltipPosition === 'mouse-y') return {
        getBoundingClientRect: function getBoundingClientRect() {
            return DOMRect.fromRect({
                x: targetRect.left,
                y: mousePos.clientY,
                width: targetRect.width,
                height: 0
            });
        }
    };
    throw new Error("Invalid tooltip position for virtual element: ".concat(tooltipPosition));
}

});

parcelRegister("9mour", function(module, exports) {
$parcel$export(module.exports, "show", () => $6d092a50186d81d6$export$57bf213be019eeb0);

var $5VFxW = parcelRequire("5VFxW");
var $6d092a50186d81d6$var$delayId = null;
function $6d092a50186d81d6$var$clearScheduled() {
    if ($6d092a50186d81d6$var$delayId != null) {
        window.clearTimeout($6d092a50186d81d6$var$delayId);
        $6d092a50186d81d6$var$delayId = null;
    }
}
function $6d092a50186d81d6$var$scheduleTimeout(fn, delay) {
    $6d092a50186d81d6$var$clearScheduled();
    $6d092a50186d81d6$var$delayId = window.setTimeout(function() {
        $6d092a50186d81d6$var$delayId = null;
        fn();
    }, delay);
}
// This file is a singleton for managing tooltips.
//
// Once we roll out top-layer and remove the legacy path, this manager can be simplified:
// - Singleton: Can be removed; the platform (popover="auto" or popover="hint") already enforces
//   only one tooltip open at a time.
// - Phase machine: Can be simplified; drop hide-animating and finishHideAnimation (legacy fade-out).
//   Use e.g. pending-show | visible | pending-hide with immediate hide.
// - API: Can drop or simplify mousePosition/mousePos if no longer needed; keep delay scheduling,
//   keep(), requestHide, abort, and minimal lifecycle.
var $6d092a50186d81d6$var$active = null;
function $6d092a50186d81d6$export$57bf213be019eeb0(entry) {
    var phase = 'waiting-to-show';
    function isActive() {
        return Boolean($6d092a50186d81d6$var$active && $6d092a50186d81d6$var$active.entry === entry);
    }
    function cleanup() {
        if (isActive()) {
            $6d092a50186d81d6$var$clearScheduled();
            $6d092a50186d81d6$var$active = null;
        }
    }
    function done() {
        if (isActive()) entry.done();
        phase = 'done';
        cleanup();
    }
    function immediatelyHideAndDone() {
        if (isActive()) entry.hide({
            isImmediate: true
        });
        done();
    }
    function keep() {
        if (!isActive()) return;
        // aborting a wait to hide
        if (phase === 'waiting-to-hide') {
            phase = 'shown';
            $6d092a50186d81d6$var$clearScheduled();
            return;
        }
        // aborting hide animation
        if (phase === 'hide-animating') {
            phase = 'shown';
            $6d092a50186d81d6$var$clearScheduled();
            entry.show({
                isImmediate: false
            });
            return;
        }
    }
    function requestHide(_ref) {
        var isImmediate = _ref.isImmediate;
        if (!isActive()) return;
        // If we were not showing yet anyway; finish straight away
        if (phase === 'waiting-to-show') {
            immediatelyHideAndDone();
            return;
        }
        // already waiting to hide
        // Bug in legacy path: isImmediate hide requests are ignored during waiting-to-hide,
        // meaning Escape/scroll won't instantly dismiss a tooltip that's already fading out.
        // Gated fix: only apply the immediate-hide behavior under the top-layer flag for now.
        if (phase === 'waiting-to-hide') {
            if (isImmediate && (0, $5VFxW.fg)('platform-dst-top-layer')) immediatelyHideAndDone();
            return;
        }
        if (isImmediate) {
            immediatelyHideAndDone();
            return;
        }
        phase = 'waiting-to-hide';
        $6d092a50186d81d6$var$scheduleTimeout(function() {
            phase = 'hide-animating';
            entry.hide({
                isImmediate: false
            });
        }, entry.delay);
    }
    function finishHideAnimation() {
        if (isActive() && phase === 'hide-animating') done();
    }
    function isVisible() {
        return phase === 'shown' || phase === 'waiting-to-hide' || phase === 'hide-animating';
    }
    function start() {
        var shouldAlwaysFadeIn = entry.shouldAlwaysFadeIn;
        var showImmediately = Boolean($6d092a50186d81d6$var$active && $6d092a50186d81d6$var$active.isVisible()) && !shouldAlwaysFadeIn;
        // If there was an active tooltip; we tell it to remove itself at once!
        if ($6d092a50186d81d6$var$active) {
            $6d092a50186d81d6$var$clearScheduled();
            $6d092a50186d81d6$var$active.entry.hide({
                isImmediate: true
            });
            $6d092a50186d81d6$var$active.entry.done();
            $6d092a50186d81d6$var$active = null;
        }
        // this tooltip is now the active tooltip
        $6d092a50186d81d6$var$active = {
            entry: entry,
            isVisible: isVisible
        };
        function show() {
            phase = 'shown';
            entry.show({
                isImmediate: showImmediately
            });
        }
        if (showImmediately) {
            show();
            return;
        }
        phase = 'waiting-to-show';
        $6d092a50186d81d6$var$scheduleTimeout(show, entry.delay);
    }
    // let's get started!
    start();
    var result = {
        keep: keep,
        abort: cleanup,
        isActive: isActive,
        requestHide: requestHide,
        finishHideAnimation: finishHideAnimation,
        mousePos: entry.source.type === 'mouse' ? {
            clientX: entry.source.clientX,
            clientY: entry.source.clientY
        } : null
    };
    return result;
}

});

parcelRegister("gsBlJ", function(module, exports) {
$parcel$export(module.exports, "default", () => $bfbc3bb6093cf625$export$2e2bcd8739ae039);

var $1fy6e = parcelRequire("1fy6e");
function $bfbc3bb6093cf625$export$2e2bcd8739ae039(prefix, shouldRenderId) {
    var seed = (0, $1fy6e.useIdSeed)();
    return shouldRenderId ? "".concat(seed(prefix)) : undefined;
}

});
parcelRegister("1fy6e", function(module, exports) {
$parcel$export(module.exports, "useIdSeed", () => $0e91a4991ca80af7$export$6ee17796e3d70de2);

var $iZD2p = parcelRequire("iZD2p");
function $0e91a4991ca80af7$export$6ee17796e3d70de2() {
    var uid = (0, $iZD2p.useId)();
    return function(id) {
        return "".concat(uid, "-").concat(id.toString());
    };
}

});


parcelRegister("i3oYb", function(module, exports) {
$parcel$export(module.exports, "default", () => $d24be044689039b0$export$2e2bcd8739ae039);
/* tooltip-container.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $5FkrB = parcelRequire("5FkrB");

var $hUbY6 = parcelRequire("hUbY6");

var $6hCeH = parcelRequire("6hCeH");
var $d24be044689039b0$var$styles = {
    base: "_2rkofajl _11c8wadc _vchhusvi _p12fp3fh _bfhk1aqn _syaz15cr _152tze3t _1e02ze3t _1i4q1hna _1q511b66 _85i51b66 _y4ti12x7 _bozg12x7 _slp31hna",
    truncate: "_1reo15vq _18m915vq _p12f1pna _1bto1l2s _o5721q9c"
};
/**
 * Used as the default tooltip container component for the exported `Tooltip` component.
 * Adds some styles to the tooltip primitive.
 */ var $d24be044689039b0$var$TooltipContainer = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function TooltipContainer(_ref, ref) {
    var style = _ref.style, className = _ref.className, children = _ref.children, truncate = _ref.truncate, placement = _ref.placement, testId = _ref.testId, onMouseOut = _ref.onMouseOut, onMouseOver = _ref.onMouseOver, id = _ref.id, shortcut = _ref.shortcut, role = _ref.role;
    return /*#__PURE__*/ $5FkrB.createElement((0, $6hCeH.default), {
        ref: ref,
        style: style,
        className: (0, $hUbY6.default)([
            $d24be044689039b0$var$styles.base,
            truncate && $d24be044689039b0$var$styles.truncate,
            className
        ]),
        placement: placement,
        testId: testId,
        id: id,
        onMouseOut: onMouseOut,
        onMouseOver: onMouseOver,
        shortcut: shortcut,
        role: role
    }, children);
});
$d24be044689039b0$var$TooltipContainer.displayName = 'TooltipContainer';
var $d24be044689039b0$export$2e2bcd8739ae039 = $d24be044689039b0$var$TooltipContainer;

});
parcelRegister("6hCeH", function(module, exports) {
$parcel$export(module.exports, "default", () => $4931fd8589b827f2$export$2e2bcd8739ae039);
/* tooltip-primitive.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $5FkrB = parcelRequire("5FkrB");

var $hUbY6 = parcelRequire("hUbY6");

var $7Knhf = parcelRequire("7Knhf");
var $4931fd8589b827f2$var$primitiveStyles = null;
/**
 * The lower level component for rendering a tooltip.
 */ var $4931fd8589b827f2$var$TooltipPrimitive = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function TooltipPrimitive(_ref, ref) {
    var style = _ref.style, className = _ref.className, children = _ref.children, placement = _ref.placement, testId = _ref.testId, onMouseOut = _ref.onMouseOut, onMouseOver = _ref.onMouseOver, id = _ref.id, shortcut = _ref.shortcut, _ref$role = _ref.role, role = _ref$role === void 0 ? 'tooltip' : _ref$role;
    return /*#__PURE__*/ $5FkrB.createElement("div", {
        ref: ref,
        style: style,
        "data-testid": testId ? "".concat(testId, "--wrapper") : undefined
    }, /*#__PURE__*/ $5FkrB.createElement("div", {
        role: role,
        className: (0, $hUbY6.default)([
            "_80om73ad",
            className
        ]),
        onMouseOut: onMouseOut,
        onMouseOver: onMouseOver,
        "data-placement": placement,
        "data-testid": testId,
        id: id
    }, children, shortcut && /*#__PURE__*/ $5FkrB.createElement((0, $7Knhf.TooltipShortcut), {
        shortcut: shortcut
    })));
});
$4931fd8589b827f2$var$TooltipPrimitive.displayName = 'TooltipPrimitive';
var $4931fd8589b827f2$export$2e2bcd8739ae039 = $4931fd8589b827f2$var$TooltipPrimitive;

});
parcelRegister("7Knhf", function(module, exports) {
$parcel$export(module.exports, "TooltipShortcut", () => $5a3ee2a2fac7d2b1$export$5bcbc43c84236222);
/* tooltip-shortcut.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $5FkrB = parcelRequire("5FkrB");

var $hUbY6 = parcelRequire("hUbY6");
var $5a3ee2a2fac7d2b1$var$styles = {
    shortcutSegmentsContainer: "_zulpv77o _1e0c1txw _1q511b66 _85i5v77o",
    shortcutSegment: "_11c8wadc _2rkolb4i _1dqonqa1 _189ee4h9 _1h6d1ihb _1e0c1txw _4cvr1h6o _4t3i1k92 _vchhusvi _1q51v77o _85i5v77o _bozg12x7 _y4ti12x7 _16qsn7od _1254n7od _cgnln7od _syazn7od _ahbqn7od _12l2n7od _1pfhn7od _6rthn7od _1ul9n7od _w19jn7od _bfhk261p"
};
var $5a3ee2a2fac7d2b1$export$5bcbc43c84236222 = function TooltipShortcut(_ref) {
    var shortcut = _ref.shortcut;
    return /*#__PURE__*/ $5FkrB.createElement("div", {
        className: (0, $hUbY6.default)([
            $5a3ee2a2fac7d2b1$var$styles.shortcutSegmentsContainer
        ])
    }, shortcut.map(function(segment, index) {
        return /*#__PURE__*/ $5FkrB.createElement("kbd", {
            key: "".concat(segment, "-").concat(index),
            className: (0, $hUbY6.default)([
                $5a3ee2a2fac7d2b1$var$styles.shortcutSegment
            ])
        }, segment);
    }));
};

});





parcelRegister("fLEvx", function(module, exports) {
$parcel$export(module.exports, "default", () => $b7aaaaca22905908$export$2e2bcd8739ae039);
/* checkbox.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $kqp0i = parcelRequire("kqp0i");

var $iYJcE = parcelRequire("iYJcE");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");

var $hUbY6 = parcelRequire("hUbY6");

var $aLEtb = parcelRequire("aLEtb");

var $kPZLD = parcelRequire("kPZLD");

var $8i1lz = parcelRequire("8i1lz");

var $amsHS = parcelRequire("amsHS");

var $4k9Sf = parcelRequire("4k9Sf");

var $5ytqR = parcelRequire("5ytqR");
var $b7aaaaca22905908$var$_excluded = [
    "isChecked",
    "isDisabled",
    "isInvalid",
    "defaultChecked",
    "isIndeterminate",
    "onChange",
    "analyticsContext",
    "label",
    "name",
    "value",
    "isRequired",
    "testId",
    "xcss",
    "className"
];
/**
 * The input is visually hidden but remains in the DOM for accessibility.
 * State-based styling is handled by the Label component using CSS custom properties
 * that cascade to the CheckboxIcon, avoiding nested sibling selectors.
 */ var $b7aaaaca22905908$var$checkboxStyles = {
    root: "_19itglyw _nd5lfibj _12ji1r31 _1qu2glyw _12y31o36 _1bsb1osq _4t3i1osq _r06hglyw _6rthze3t _1pfhze3t _12l2ze3t _ahbqze3t _tzy4idpf"
};
/**
 * __Checkbox__
 *
 * A checkbox an input control that allows a user to select one or more options from a number of choices.
 *
 * - [Examples](https://atlassian.design/components/checkbox/examples)
 * - [Code](https://atlassian.design/components/checkbox/code)
 * - [Usage](https://atlassian.design/components/checkbox/usage)
 */ var $b7aaaaca22905908$var$Checkbox = /*#__PURE__*/ (0, $5FkrB.memo)(/*#__PURE__*/ (0, $5FkrB.forwardRef)(function Checkbox(_ref, ref) {
    var isCheckedProp = _ref.isChecked, _ref$isDisabled = _ref.isDisabled, isDisabled = _ref$isDisabled === void 0 ? false : _ref$isDisabled, _ref$isInvalid = _ref.isInvalid, isInvalid = _ref$isInvalid === void 0 ? false : _ref$isInvalid, _ref$defaultChecked = _ref.defaultChecked, defaultChecked = _ref$defaultChecked === void 0 ? false : _ref$defaultChecked, _ref$isIndeterminate = _ref.isIndeterminate, isIndeterminate = _ref$isIndeterminate === void 0 ? false : _ref$isIndeterminate, onChangeProps = _ref.onChange, analyticsContext = _ref.analyticsContext, label = _ref.label, name = _ref.name, value = _ref.value, isRequired = _ref.isRequired, testId = _ref.testId, xcss = _ref.xcss, className = _ref.className, rest = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $b7aaaaca22905908$var$_excluded);
    var _useState = (0, $5FkrB.useState)(isCheckedProp !== undefined ? isCheckedProp : defaultChecked), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), isCheckedState = _useState2[0], setIsCheckedState = _useState2[1];
    var onChange = (0, $5FkrB.useCallback)(function(e, analyticsEvent) {
        setIsCheckedState(e.target.checked);
        if (onChangeProps) onChangeProps(e, analyticsEvent);
    }, [
        onChangeProps
    ]);
    var onChangeAnalytics = (0, $aLEtb.usePlatformLeafEventHandler)({
        fn: onChange,
        action: 'changed',
        analyticsData: analyticsContext,
        componentName: 'checkbox',
        packageName: "@atlaskit/checkbox",
        packageVersion: "17.3.12"
    });
    var internalRef = (0, $5FkrB.useRef)(null);
    var mergedRefs = (0, $kPZLD.default)([
        internalRef,
        ref
    ]);
    // Use isChecked from the state if it is controlled
    var isChecked = isCheckedProp === undefined ? isCheckedState : isCheckedProp;
    (0, $5FkrB.useEffect)(function() {
        if (internalRef.current) internalRef.current.indeterminate = isIndeterminate;
    }, [
        isIndeterminate
    ]);
    return /*#__PURE__*/ $5FkrB.createElement((0, $amsHS.default), {
        isDisabled: isDisabled,
        isChecked: isChecked,
        isIndeterminate: isIndeterminate,
        isInvalid: isInvalid,
        label: label,
        id: rest.id ? "".concat(rest.id, "-label") : undefined,
        testId: testId && "".concat(testId, "--checkbox-label"),
        xcss: xcss
    }, /*#__PURE__*/ $5FkrB.createElement("input", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        // It is necessary only for Safari. It allows to render focus styles.
        tabIndex: 0
    }, rest, {
        type: "checkbox",
        ref: mergedRefs,
        disabled: isDisabled,
        checked: isChecked,
        value: value,
        name: name,
        required: isRequired,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $hUbY6.default)([
            $b7aaaaca22905908$var$checkboxStyles.root,
            className
        ]),
        onChange: onChangeAnalytics,
        "aria-invalid": isInvalid ? 'true' : undefined,
        "data-testid": testId && "".concat(testId, "--hidden-checkbox"),
        "data-invalid": isInvalid ? 'true' : undefined
    })), /*#__PURE__*/ $5FkrB.createElement((0, $8i1lz.default), {
        isIndeterminate: isIndeterminate,
        isChecked: isChecked
    }), label && /*#__PURE__*/ $5FkrB.createElement((0, $4k9Sf.default), null, label, isRequired && /*#__PURE__*/ $5FkrB.createElement((0, $5ytqR.default), null)));
}));
$b7aaaaca22905908$var$Checkbox.displayName = 'Checkbox';
var $b7aaaaca22905908$export$2e2bcd8739ae039 = $b7aaaaca22905908$var$Checkbox;

});
parcelRegister("8i1lz", function(module, exports) {
$parcel$export(module.exports, "default", () => $60910ca366a4b8c8$export$2e2bcd8739ae039);
/* checkbox-icon.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $5FkrB = parcelRequire("5FkrB");

var $hUbY6 = parcelRequire("hUbY6");
/**
 * Styles for the checkbox icon.
 * CSS custom properties for colors are set by the parent Label element
 * and consumed directly in these styles.
 */ var $60910ca366a4b8c8$var$svgStyles = {
    root: "_nd5lfibj _1reo15vq _18m915vq _v5641mn3 _2rko12b0 _1a3742bt _lcxvglyw _syazmov0 _lswu1kgh _1cwg1i6y",
    rect: "_v56411so _1snbe4h9 _1s17hteq"
};
function $60910ca366a4b8c8$var$getIcon(isIndeterminate, isChecked) {
    if (isIndeterminate) return /*#__PURE__*/ $5FkrB.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M7.75 12.75H16.25V11.25H7.75V12.75Z",
        fill: "inherit"
    });
    if (isChecked) return /*#__PURE__*/ $5FkrB.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M16.3262 9.48011L15.1738 8.51984L10.75 13.8284L8.82616 11.5198L7.67383 12.4801L10.1738 15.4801C10.3163 15.6511 10.5274 15.75 10.75 15.75C10.9726 15.75 11.1837 15.6511 11.3262 15.4801L16.3262 9.48011Z",
        fill: "inherit"
    });
    // No icon
    return null;
}
/**
 * __Checkbox icon__
 *
 * A checkbox icon is the visual representation of checkbox state,
 * which is shown instead of the native input.
 *
 * @internal
 */ var $60910ca366a4b8c8$var$CheckboxIcon = /*#__PURE__*/ (0, $5FkrB.memo)(function(_ref) {
    var isIndeterminate = _ref.isIndeterminate, isChecked = _ref.isChecked;
    var icon = (0, $5FkrB.useMemo)(function() {
        return $60910ca366a4b8c8$var$getIcon(isIndeterminate, isChecked);
    }, [
        isIndeterminate,
        isChecked
    ]);
    return /*#__PURE__*/ $5FkrB.createElement("svg", {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        role: "presentation",
        className: (0, $hUbY6.default)([
            $60910ca366a4b8c8$var$svgStyles.root
        ])
    }, /*#__PURE__*/ $5FkrB.createElement("g", {
        fillRule: "evenodd"
    }, /*#__PURE__*/ $5FkrB.createElement("rect", {
        fill: "currentColor",
        x: "5.5",
        y: "5.5",
        width: "13",
        height: "13",
        rx: "1.5",
        className: (0, $hUbY6.default)([
            $60910ca366a4b8c8$var$svgStyles.rect
        ])
    }), icon));
});
var $60910ca366a4b8c8$export$2e2bcd8739ae039 = $60910ca366a4b8c8$var$CheckboxIcon;

});

parcelRegister("amsHS", function(module, exports) {
$parcel$export(module.exports, "default", () => $78b23a06d65a427b$export$2e2bcd8739ae039);
/* label.tsx generated by @compiled/babel-plugin v0.39.1 */ /**
 * Base state styles with CSS custom properties.
 * Pseudo-selectors (:hover, :focus-within, :active) on the label element
 * update CSS variables that cascade to the CheckboxIcon.
 * This avoids nested sibling selectors.
 *
 * Uses `css` over `cssMap` to work around a bug in Compiled types when
 * using CSS variables in pseudo-selectors.
 */ 
var $5FkrB = parcelRequire("5FkrB");

var $hUbY6 = parcelRequire("hUbY6");
var $78b23a06d65a427b$var$baseStyles = null;
var $78b23a06d65a427b$var$textLabelLayoutStyles = null;
// Checked/Indeterminate state
var $78b23a06d65a427b$var$checkedStyles = null;
// Invalid state - must override hover/active to maintain red border
var $78b23a06d65a427b$var$invalidStyles = null;
// Disabled state - must override hover/active to maintain disabled appearance
var $78b23a06d65a427b$var$disabledStyles = null;
// Disabled + Checked/Indeterminate
var $78b23a06d65a427b$var$disabledCheckedStyles = null;
function $78b23a06d65a427b$export$2e2bcd8739ae039(_ref) {
    var children = _ref.children, isDisabled = _ref.isDisabled, isChecked = _ref.isChecked, isIndeterminate = _ref.isIndeterminate, isInvalid = _ref.isInvalid, testId = _ref.testId, label = _ref.label, id = _ref.id, xcss = _ref.xcss;
    return /*#__PURE__*/ $5FkrB.createElement("label", {
        className: (0, $hUbY6.default)([
            "_11c8fhey _1e0c11p5 _1ejihkll _umai184x _1qwn1j9a _f0grrsbi _1c53glyw _1e9d1j28 _syazi7uo _80om73ad _ljcgdfik _1vj5l4ek _dh4gr01l _cz1u1l7x _jom5wc43 _1s071onz _106f1onz",
            label && "_zulp1nu5 _yv0ey09t",
            (isChecked || isIndeterminate) && "_1qwnjmqp _f0grjmqp _1e9d5w2r _1vj51q28 _q29q1q28 _dh4gr01l _cz1u1l7x _zoo95w2r _jom5wc43 _1s071onz _106f1onz",
            isInvalid && "_f0gr1bqt _q29q1bqt _cz1u1bqt _1s07gir2",
            isDisabled && "_1qwn187o _f0gr187o _syaz1gmx _80om13gf _1vj5187o _q29q187o _dh4g187o _cz1u187o _jom5wc43 _1s0718qt _106f18qt",
            isDisabled && (isChecked || isIndeterminate) && "_1e9d2sac _9js12sac _zoo92sac",
            xcss
        ]),
        "data-testid": testId,
        "data-disabled": isDisabled || undefined,
        id: id
    }, children);
}

});

parcelRegister("4k9Sf", function(module, exports) {
$parcel$export(module.exports, "default", () => $3260b077d62137df$export$2e2bcd8739ae039);
/* label-text.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $5FkrB = parcelRequire("5FkrB");

var $hUbY6 = parcelRequire("hUbY6");
var $3260b077d62137df$var$labelTextStyles = null;
function $3260b077d62137df$export$2e2bcd8739ae039(_ref) {
    var children = _ref.children;
    return /*#__PURE__*/ $5FkrB.createElement("span", {
        className: (0, $hUbY6.default)([
            "_nd5l11ig _1wpz1h6o"
        ])
    }, children);
}

});

parcelRegister("5ytqR", function(module, exports) {
$parcel$export(module.exports, "default", () => $40b6f55df7224f6d$export$2e2bcd8739ae039);
/* required-indicator.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $5FkrB = parcelRequire("5FkrB");

var $hUbY6 = parcelRequire("hUbY6");
var $40b6f55df7224f6d$var$requiredIndicatorStyles = null;
function $40b6f55df7224f6d$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ $5FkrB.createElement("span", {
        "aria-hidden": true,
        className: (0, $hUbY6.default)([
            "_syaz1tmw _bozgv77o"
        ])
    }, "*");
}

});


parcelRegister("8YAYC", function(module, exports) {
$parcel$export(module.exports, "default", () => $68909c2285129576$export$2e2bcd8739ae039);

var $fC8ib = parcelRequire("fC8ib");

var $5FkrB = parcelRequire("5FkrB");

var $74Zh5 = parcelRequire("74Zh5");

var $d33Jn = parcelRequire("d33Jn");

var $7Cqku = parcelRequire("7Cqku");
var $68909c2285129576$var$justifyContentMap = {
    start: (0, $74Zh5.css)({
        justifyContent: 'start'
    }),
    center: (0, $74Zh5.css)({
        justifyContent: 'center'
    }),
    end: (0, $74Zh5.css)({
        justifyContent: 'end'
    }),
    'space-between': (0, $74Zh5.css)({
        justifyContent: 'space-between'
    }),
    'space-around': (0, $74Zh5.css)({
        justifyContent: 'space-around'
    }),
    'space-evenly': (0, $74Zh5.css)({
        justifyContent: 'space-evenly'
    }),
    stretch: (0, $74Zh5.css)({
        justifyContent: 'stretch'
    })
};
var $68909c2285129576$var$flexDirectionMap = {
    column: (0, $74Zh5.css)({
        flexDirection: 'column'
    }),
    row: (0, $74Zh5.css)({
        flexDirection: 'row'
    })
};
var $68909c2285129576$var$flexWrapMap = {
    wrap: (0, $74Zh5.css)({
        flexWrap: 'wrap'
    }),
    nowrap: (0, $74Zh5.css)({
        flexWrap: 'nowrap'
    })
};
var $68909c2285129576$var$alignItemsMap = {
    start: (0, $74Zh5.css)({
        alignItems: 'start'
    }),
    center: (0, $74Zh5.css)({
        alignItems: 'center'
    }),
    baseline: (0, $74Zh5.css)({
        alignItems: 'baseline'
    }),
    end: (0, $74Zh5.css)({
        alignItems: 'end'
    }),
    stretch: (0, $74Zh5.css)({
        alignItems: 'stretch'
    })
};
var $68909c2285129576$var$baseStyles = (0, $74Zh5.css)({
    display: 'flex',
    boxSizing: 'border-box'
});
/**
 * __Flex__
 *
 * `Flex` is a primitive component that implements the CSS Flexbox API.
 *
 * - [Examples](https://atlassian.design/components/primitives/flex/examples)
 * - [Code](https://atlassian.design/components/primitives/flex/code)
 *
 * @example
 * ```tsx
 * // eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
 * import { Flex, Box } from '@atlaskit/primitives'
 *
 * const Component = () => (
 *   <Flex direction="column">
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *   </Flex>
 * )
 * ```
 */ var $68909c2285129576$var$Flex = /*#__PURE__*/ (0, $5FkrB.memo)(/*#__PURE__*/ (0, $5FkrB.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? 'div' : _ref$as, role = _ref.role, alignItems = _ref.alignItems, justifyContent = _ref.justifyContent, gap = _ref.gap, columnGap = _ref.columnGap, rowGap = _ref.rowGap, children = _ref.children, testId = _ref.testId, direction = _ref.direction, wrap = _ref.wrap, xcss = _ref.xcss, id = _ref.id;
    var resolvedStyles = (0, $7Cqku.parseXcss)(xcss);
    return (0, $74Zh5.jsx)(Component, {
        id: id,
        role: role,
        className: resolvedStyles.static,
        css: [
            $68909c2285129576$var$baseStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            gap && (0, $d33Jn.spaceStylesMap).gap[gap],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            columnGap && (0, $d33Jn.spaceStylesMap).columnGap[columnGap],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            rowGap && (0, $d33Jn.spaceStylesMap).rowGap[rowGap],
            alignItems && $68909c2285129576$var$alignItemsMap[alignItems],
            direction && $68909c2285129576$var$flexDirectionMap[direction],
            justifyContent && $68909c2285129576$var$justifyContentMap[justifyContent],
            wrap && $68909c2285129576$var$flexWrapMap[wrap]
        ].concat((0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(resolvedStyles.emotion || [])),
        "data-testid": testId,
        ref: ref
    }, children);
}));
$68909c2285129576$var$Flex.displayName = 'Flex';
var $68909c2285129576$export$2e2bcd8739ae039 = $68909c2285129576$var$Flex;

});

parcelRegister("3JBzg", function(module, exports) {
$parcel$export(module.exports, "default", () => $2b82b738b89d914e$export$2e2bcd8739ae039);

var $fC8ib = parcelRequire("fC8ib");

var $5FkrB = parcelRequire("5FkrB");

var $74Zh5 = parcelRequire("74Zh5");

var $7Cqku = parcelRequire("7Cqku");

var $8YAYC = parcelRequire("8YAYC");
var $2b82b738b89d914e$var$flexGrowMap = {
    hug: (0, $7Cqku.xcss)({
        flexGrow: 0
    }),
    fill: (0, $7Cqku.xcss)({
        width: '100%',
        flexGrow: 1
    })
};
var $2b82b738b89d914e$var$separatorStyles = (0, $74Zh5.css)({
    color: "var(--ds-text-subtle, #42526E)",
    marginBlock: "var(--ds-space-0, 0px)",
    marginInline: "var(--ds-space-negative-025, -2px)",
    pointerEvents: 'none',
    userSelect: 'none'
});
var $2b82b738b89d914e$var$Separator = function Separator(_ref) {
    var children = _ref.children;
    return (0, $74Zh5.jsx)("span", {
        css: $2b82b738b89d914e$var$separatorStyles
    }, children);
};
/**
 * __Inline__
 *
 * Inline is a primitive component based on CSS Flexbox that manages the horizontal layout of direct children.
 *
 * @example
 * ```tsx
 *  <Inline>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *  </Inline>
 * ```
 *
 */ var $2b82b738b89d914e$var$Inline = /*#__PURE__*/ (0, $5FkrB.memo)(/*#__PURE__*/ (0, $5FkrB.forwardRef)(function(_ref2, ref) {
    var as = _ref2.as, alignInline = _ref2.alignInline, _ref2$alignBlock = _ref2.alignBlock, alignItems = _ref2$alignBlock === void 0 ? 'start' : _ref2$alignBlock, _ref2$shouldWrap = _ref2.shouldWrap, shouldWrap = _ref2$shouldWrap === void 0 ? false : _ref2$shouldWrap, spread = _ref2.spread, grow = _ref2.grow, space = _ref2.space, rowSpace = _ref2.rowSpace, separator = _ref2.separator, xcss = _ref2.xcss, testId = _ref2.testId, role = _ref2.role, id = _ref2.id, rawChildren = _ref2.children;
    var separatorComponent = typeof separator === 'string' ? (0, $74Zh5.jsx)($2b82b738b89d914e$var$Separator, null, separator) : separator;
    var children = separatorComponent ? (0, $5FkrB.Children).toArray(rawChildren).filter(Boolean).map(function(child, index) {
        return (0, $74Zh5.jsx)((0, $5FkrB.Fragment), {
            key: index
        }, separator && index > 0 ? separatorComponent : null, child);
    }) : rawChildren;
    var justifyContent = spread || alignInline;
    // We're type coercing this as Compiled styles in an array isn't supported by the types
    // But the runtime accepts it none-the-wiser. We can remove this entire block and replace
    // it with cx(defaultStyles, focusRingStyles, xcssStyles) when we've moved away from Emotion.
    var styles = grow ? [
        $2b82b738b89d914e$var$flexGrowMap[grow]
    ].concat((0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(Array.isArray(xcss) ? xcss : [
        xcss
    ])) : xcss;
    return (0, $74Zh5.jsx)((0, $8YAYC.default), {
        id: id,
        as: as,
        role: role,
        alignItems: alignItems,
        justifyContent: justifyContent,
        direction: "row",
        gap: space,
        rowGap: rowSpace,
        wrap: shouldWrap ? 'wrap' : undefined,
        xcss: styles,
        testId: testId,
        ref: ref
    }, children);
}));
$2b82b738b89d914e$var$Inline.displayName = 'Inline';
var $2b82b738b89d914e$export$2e2bcd8739ae039 = $2b82b738b89d914e$var$Inline;

});

parcelRegister("ceYG2", function(module, exports) {
$parcel$export(module.exports, "default", () => $8e95dc0ab81c2035$export$2e2bcd8739ae039);

var $5FkrB = parcelRequire("5FkrB");

var $c2tWV = parcelRequire("c2tWV");
/**
 * This component will observer the current width,
 * and it will call the `setWidth` callback every time this changes.
 *
 * The only required is the parent HTMLElement should have `position: relative`
 * because this is an absolute element.
 */ var $8e95dc0ab81c2035$var$WidthObserver = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).memo(function(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $c2tWV.WidthDetectorObserver), {
        setWidth: props.setWidth,
        offscreen: props.offscreen
    });
});
var $8e95dc0ab81c2035$export$2e2bcd8739ae039 = $8e95dc0ab81c2035$var$WidthObserver;

});
parcelRegister("c2tWV", function(module, exports) {
$parcel$export(module.exports, "WidthDetectorObserver", () => $8c3ce74437157517$export$ff983d2a2b6112ea);

var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");

var $dMu94 = parcelRequire("dMu94");
var $8c3ce74437157517$export$ff983d2a2b6112ea = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).memo(function(_ref) {
    var setWidth = _ref.setWidth, offscreen = _ref.offscreen;
    var _useInView = (0, $dMu94.useInView)({
        /* Optional options */ threshold: 0
    }), _useInView2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useInView, 3), inViewRef = _useInView2[0], inView = _useInView2[1], target = _useInView2[2];
    var observer = (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).useRef(function() {
        if (typeof window === 'undefined') return null;
        // https://github.com/DefinitelyTyped/DefinitelyTyped/pull/40909
        // @ts-ignore
        return new ResizeObserver(function(entries) {
            if (!Array.isArray(entries) || !entries.length) return;
            var width = entries[0].contentRect.width;
            setWidth(Math.round(width));
        });
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).useEffect(function() {
        var currentObserver = observer.current;
        var resizeObserver = currentObserver();
        if (resizeObserver === null) return;
        if (target) {
            if (inView || offscreen) resizeObserver.observe(target);
            else resizeObserver.unobserve(target);
        }
        return function() {
            resizeObserver.disconnect();
        };
    }, [
        target,
        inView,
        offscreen
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("div", {
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            display: 'block',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            width: '100%',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            position: 'absolute'
        },
        ref: inViewRef
    });
});

});
parcelRegister("dMu94", function(module, exports) {
$parcel$export(module.exports, "useInView", () => $a087244c0470b557$export$2f62ee6831462844);

var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");
function $a087244c0470b557$export$2f62ee6831462844() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var ref = (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).useRef();
    var observerInstance = (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).useRef();
    var _React$useState = (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).useState({
        inView: false,
        entry: undefined,
        target: undefined
    }), _React$useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_React$useState, 2), state = _React$useState2[0], setState = _React$useState2[1];
    var threshold = options.threshold, root = options.root, rootMargin = options.rootMargin;
    var setRef = (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).useCallback(function(node) {
        observerInstance.current = new IntersectionObserver(function(entries) {
            if (entries && entries.length) {
                var intersection = entries[0];
                var isIntersecting = intersection.isIntersecting, intersectionRatio = intersection.intersectionRatio;
                if (intersectionRatio >= 0) {
                    // Note: `0` will be used here when an array of numbers is passed as the threshold, which doesn't feel right
                    var numericThreshold = typeof threshold === 'number' ? threshold : 0;
                    var inView = intersectionRatio >= numericThreshold;
                    if (isIntersecting !== undefined) inView = inView && isIntersecting;
                    setState({
                        inView: inView,
                        entry: intersection,
                        target: node
                    });
                }
            }
        }, {
            threshold: threshold,
            root: root,
            rootMargin: rootMargin
        });
        if (ref.current) observerInstance.current.unobserve(ref.current);
        if (node) observerInstance.current.observe(node);
        // Store a reference to the node
        ref.current = node;
    }, [
        threshold,
        root,
        rootMargin
    ]);
    /**
   * Unsubscribe IntersectionObserver before unmounting a component.
   */ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).useEffect(function() {
        return function() {
            if (observerInstance.current && ref.current) observerInstance.current.unobserve(ref.current);
        };
    }, []);
    return [
        setRef,
        state.inView,
        state.target,
        state.entry
    ];
}

});



parcelRegister("cYEG6", function(module, exports) {
$parcel$export(module.exports, "useInfiniteScroll", () => $972aa47356a2f862$export$a973cef5093a8d22);

var $5FkrB = parcelRequire("5FkrB");
function $972aa47356a2f862$export$a973cef5093a8d22(_ref) {
    var onScrollTo = _ref.onScrollTo;
    var loadMoreRef = (0, $5FkrB.useRef)(null);
    // This function is called by the IntersectionObserver API when "loaderTarget" UI element
    // changes visibility.  If it has become visible (typically by user scrolling), call our
    // scroll handler and the parent will attempt to load more data
    var fetchMoreCallback = (0, $5FkrB.useCallback)(function(loadMoreEntry) {
        // Sometimes based on an unknown render race condition, the previous IntersectionObserver is not
        // properly cleared before the next one is observed, which causes the 0th indexed IntersectionObserver
        // to never be intersecting, which causes the onScrollTo callback to not be called when it should be.
        // To fix this just get rid of the old observer if it is not properly cleaned up.
        if (loadMoreEntry.length > 1) loadMoreEntry.shift();
        if (loadMoreEntry !== null && loadMoreEntry !== void 0 && loadMoreEntry[0].isIntersecting) onScrollTo();
    }, [
        onScrollTo
    ]);
    (0, $5FkrB.useEffect)(function() {
        var intersectionObserver = new IntersectionObserver(fetchMoreCallback);
        var loadMoreRefCurrent = loadMoreRef.current;
        if (loadMoreRef.current) intersectionObserver.observe(loadMoreRef.current);
        return function() {
            if (loadMoreRefCurrent) intersectionObserver.unobserve(loadMoreRefCurrent);
            intersectionObserver.disconnect();
        };
    }, [
        loadMoreRef,
        fetchMoreCallback
    ]);
    return loadMoreRef;
}

});

parcelRegister("hZrFa", function(module, exports) {
$parcel$export(module.exports, "useKeyboardNavigation", () => $d18d9776d06d6aa4$export$4da28cf324280418);
/**
 * Allows for tables to use keyboard arrow
 * keys (up, down, left, right) to navigate the table.
 *
 * The hook also includes meta + c to copy the content. Since the
 * table is not ADF, this only copies text content and not the
 * full experience like images / status lozenge.
 */ var $d18d9776d06d6aa4$export$4da28cf324280418 = function useKeyboardNavigation() {
    var tableNavigationControllers = function tableNavigationControllers(event) {
        var key = event.key;
        var target = event.currentTarget;
        if (key === 'ArrowDown' || key === 'ArrowUp' || key === 'ArrowLeft' || key === 'ArrowRight' || key === 'Enter' || key === 'c' && event.metaKey) event.preventDefault();
        else return;
        if (key === 'Enter') {
            var focusableSelector = 'a[href], input, select, textarea, button, [tabindex]:not([tabindex="-1"])';
            var focusableChild = target.querySelector(focusableSelector);
            if (focusableChild) {
                focusableChild.click();
                // For editable children (inputs, selects, textareas) focus moves into them
                // intentionally so the user can type — leave focus alone.
                // For buttons, clicking triggers the action; focus the button itself so the
                // user gets proper keyboard feedback without breaking subsequent navigation.
                // For links and other focusable elements, re-focus the cell so arrow-key
                // navigation continues to work.
                if (focusableChild.matches('button')) focusableChild.focus();
                else if (!focusableChild.matches('input, select, textarea')) target.focus();
            } else target.click();
            return;
        }
        var nextElement;
        switch(key){
            case 'ArrowDown':
                var _target$parentElement;
                nextElement = (_target$parentElement = target.parentElement) === null || _target$parentElement === void 0 || (_target$parentElement = _target$parentElement.nextElementSibling) === null || _target$parentElement === void 0 ? void 0 : _target$parentElement.children[target.cellIndex];
                break;
            case 'ArrowUp':
                var _target$parentElement2;
                nextElement = (_target$parentElement2 = target.parentElement) === null || _target$parentElement2 === void 0 || (_target$parentElement2 = _target$parentElement2.previousElementSibling) === null || _target$parentElement2 === void 0 ? void 0 : _target$parentElement2.children[target.cellIndex];
                break;
            case 'ArrowLeft':
                nextElement = target.previousElementSibling;
                break;
            case 'ArrowRight':
                nextElement = target.nextElementSibling;
                break;
            case 'c':
                if (event.metaKey) target.textContent && navigator.clipboard.writeText(target.textContent);
                break;
        }
        if (nextElement instanceof HTMLElement) {
            nextElement.scrollIntoView({
                behavior: 'smooth',
                block: 'center'
            });
            // Focus interactive children directly so the user can interact
            // immediately (e.g. type in an input, activate a button).
            // Arrow-key events from focused children still bubble up to the <td>
            // where onKeyDown is attached, so grid navigation continues to work.
            var _focusableChild = nextElement.querySelector('input, select, textarea, button, [tabindex]:not([tabindex="-1"])');
            if (_focusableChild) _focusableChild.focus();
            else nextElement.focus();
        }
    };
    return {
        tableNavigationControllers: tableNavigationControllers
    };
};

});

parcelRegister("86aoj", function(module, exports) {
$parcel$export(module.exports, "Col", () => $5e56f1b89dbed8cd$export$963a4b2511a4b70c);

var $kqp0i = parcelRequire("kqp0i");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");

var $kZC4L = parcelRequire("kZC4L");
var $5e56f1b89dbed8cd$var$_excluded = [
    "children"
];
var $5e56f1b89dbed8cd$export$963a4b2511a4b70c = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function(_ref, ref) {
    var children = _ref.children, props = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $5e56f1b89dbed8cd$var$_excluded);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $kZC4L.default), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        as: "col",
        ref: ref
    }, props), children);
});

});

parcelRegister("aQxuW", function(module, exports) {
$parcel$export(module.exports, "Colgroup", () => $7e58beb48fc933e3$export$89efc2d0ceeaa030);

var $kqp0i = parcelRequire("kqp0i");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");

var $1JA0K = parcelRequire("1JA0K");
var $7e58beb48fc933e3$var$_excluded = [
    "children"
];
var $7e58beb48fc933e3$export$89efc2d0ceeaa030 = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function(_ref, ref) {
    var children = _ref.children, props = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $7e58beb48fc933e3$var$_excluded);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $1JA0K.default), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        as: "colgroup",
        ref: ref
    }, props), children);
});

});
parcelRegister("1JA0K", function(module, exports) {
$parcel$export(module.exports, "default", () => $1435ed7bd06cd43c$export$2e2bcd8739ae039);
/* box.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $kqp0i = parcelRequire("kqp0i");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");

var $hUbY6 = parcelRequire("hUbY6");

var $312sH = parcelRequire("312sH");
var $1435ed7bd06cd43c$var$_excluded = [
    "as",
    "children",
    "backgroundColor",
    "padding",
    "paddingBlock",
    "paddingBlockStart",
    "paddingBlockEnd",
    "paddingInline",
    "paddingInlineStart",
    "paddingInlineEnd",
    "style",
    "testId",
    "xcss"
], $1435ed7bd06cd43c$var$_excluded2 = [
    "className"
];
// Can either Exclude or Extract - here we're excluding all SVG-related elements, <button> elements (handled by Pressable), and <a> elements (handled by Anchor)
// Basically just ElementType but without ComponentType, it makes sense to keep the "Type" suffix
// eslint-disable-next-line @repo/internal/react/consistent-types-definitions
var $1435ed7bd06cd43c$var$baseStyles = null;
var $1435ed7bd06cd43c$var$backgroundColorMap = {
    'color.background.accent.lime.subtlest': "_bfhkm890",
    'color.background.accent.lime.subtlest.hovered': "_bfhkd4y8",
    'color.background.accent.lime.subtlest.pressed': "_bfhkkuup",
    'color.background.accent.lime.subtler': "_bfhkz2ec",
    'color.background.accent.lime.subtler.hovered': "_bfhk1gf0",
    'color.background.accent.lime.subtler.pressed': "_bfhk2kxc",
    'color.background.accent.lime.subtle': "_bfhkbq5w",
    'color.background.accent.lime.subtle.hovered': "_bfhkfoww",
    'color.background.accent.lime.subtle.pressed': "_bfhk1jbd",
    'color.background.accent.lime.bolder': "_bfhktde4",
    'color.background.accent.lime.bolder.hovered': "_bfhknzpa",
    'color.background.accent.lime.bolder.pressed': "_bfhkh0j0",
    'color.background.accent.red.subtlest': "_bfhk1vk5",
    'color.background.accent.red.subtlest.hovered': "_bfhk1i6i",
    'color.background.accent.red.subtlest.pressed': "_bfhknbir",
    'color.background.accent.red.subtler': "_bfhk1rtt",
    'color.background.accent.red.subtler.hovered': "_bfhkaffd",
    'color.background.accent.red.subtler.pressed': "_bfhk1j5a",
    'color.background.accent.red.subtle': "_bfhkkrt9",
    'color.background.accent.red.subtle.hovered': "_bfhk1sou",
    'color.background.accent.red.subtle.pressed': "_bfhk1fnn",
    'color.background.accent.red.bolder': "_bfhkuibq",
    'color.background.accent.red.bolder.hovered': "_bfhk100f",
    'color.background.accent.red.bolder.pressed': "_bfhk1cl6",
    'color.background.accent.orange.subtlest': "_bfhkf5uh",
    'color.background.accent.orange.subtlest.hovered': "_bfhk19yr",
    'color.background.accent.orange.subtlest.pressed': "_bfhkf90x",
    'color.background.accent.orange.subtler': "_bfhk165s",
    'color.background.accent.orange.subtler.hovered': "_bfhk1ei0",
    'color.background.accent.orange.subtler.pressed': "_bfhkdpo3",
    'color.background.accent.orange.subtle': "_bfhk1kkj",
    'color.background.accent.orange.subtle.hovered': "_bfhk9mfs",
    'color.background.accent.orange.subtle.pressed': "_bfhkaxpp",
    'color.background.accent.orange.bolder': "_bfhk1qg1",
    'color.background.accent.orange.bolder.hovered': "_bfhk12qo",
    'color.background.accent.orange.bolder.pressed': "_bfhk1fyq",
    'color.background.accent.yellow.subtlest': "_bfhkibhp",
    'color.background.accent.yellow.subtlest.hovered': "_bfhkaetg",
    'color.background.accent.yellow.subtlest.pressed': "_bfhk1o1l",
    'color.background.accent.yellow.subtler': "_bfhk1773",
    'color.background.accent.yellow.subtler.hovered': "_bfhk1uw7",
    'color.background.accent.yellow.subtler.pressed': "_bfhk1r9w",
    'color.background.accent.yellow.subtle': "_bfhk8y3s",
    'color.background.accent.yellow.subtle.hovered': "_bfhk819w",
    'color.background.accent.yellow.subtle.pressed': "_bfhk1jx0",
    'color.background.accent.yellow.bolder': "_bfhk1vop",
    'color.background.accent.yellow.bolder.hovered': "_bfhkkjqf",
    'color.background.accent.yellow.bolder.pressed': "_bfhk1okt",
    'color.background.accent.green.subtlest': "_bfhkn729",
    'color.background.accent.green.subtlest.hovered': "_bfhk3utz",
    'color.background.accent.green.subtlest.pressed': "_bfhkyfny",
    'color.background.accent.green.subtler': "_bfhk1wnw",
    'color.background.accent.green.subtler.hovered': "_bfhk1e2h",
    'color.background.accent.green.subtler.pressed': "_bfhkybhx",
    'color.background.accent.green.subtle': "_bfhk1rsu",
    'color.background.accent.green.subtle.hovered': "_bfhk12e3",
    'color.background.accent.green.subtle.pressed': "_bfhk1g86",
    'color.background.accent.green.bolder': "_bfhk1e5c",
    'color.background.accent.green.bolder.hovered': "_bfhka5yi",
    'color.background.accent.green.bolder.pressed': "_bfhk1j68",
    'color.background.accent.teal.subtlest': "_bfhk7xuz",
    'color.background.accent.teal.subtlest.hovered': "_bfhk108c",
    'color.background.accent.teal.subtlest.pressed': "_bfhk1cxp",
    'color.background.accent.teal.subtler': "_bfhk1a17",
    'color.background.accent.teal.subtler.hovered': "_bfhkkwwr",
    'color.background.accent.teal.subtler.pressed': "_bfhk1jb0",
    'color.background.accent.teal.subtle': "_bfhktdv8",
    'color.background.accent.teal.subtle.hovered': "_bfhkzh8h",
    'color.background.accent.teal.subtle.pressed': "_bfhk16zl",
    'color.background.accent.teal.bolder': "_bfhk2c8p",
    'color.background.accent.teal.bolder.hovered': "_bfhkl3ve",
    'color.background.accent.teal.bolder.pressed': "_bfhktor0",
    'color.background.accent.blue.subtlest': "_bfhk1s93",
    'color.background.accent.blue.subtlest.hovered': "_bfhkdaj9",
    'color.background.accent.blue.subtlest.pressed': "_bfhkxm0g",
    'color.background.accent.blue.subtler': "_bfhk1dy8",
    'color.background.accent.blue.subtler.hovered': "_bfhk815t",
    'color.background.accent.blue.subtler.pressed': "_bfhkrwxf",
    'color.background.accent.blue.subtle': "_bfhk115i",
    'color.background.accent.blue.subtle.hovered': "_bfhk9pr4",
    'color.background.accent.blue.subtle.pressed': "_bfhknpx7",
    'color.background.accent.blue.bolder': "_bfhk16e3",
    'color.background.accent.blue.bolder.hovered': "_bfhk1vbm",
    'color.background.accent.blue.bolder.pressed': "_bfhk1xwi",
    'color.background.accent.purple.subtlest': "_bfhkp2ly",
    'color.background.accent.purple.subtlest.hovered': "_bfhkkca2",
    'color.background.accent.purple.subtlest.pressed': "_bfhk1jbm",
    'color.background.accent.purple.subtler': "_bfhk1nm4",
    'color.background.accent.purple.subtler.hovered': "_bfhkattl",
    'color.background.accent.purple.subtler.pressed': "_bfhk3nfk",
    'color.background.accent.purple.subtle': "_bfhk18ah",
    'color.background.accent.purple.subtle.hovered': "_bfhk8bp1",
    'color.background.accent.purple.subtle.pressed': "_bfhk1cd2",
    'color.background.accent.purple.bolder': "_bfhkya33",
    'color.background.accent.purple.bolder.hovered': "_bfhk1af5",
    'color.background.accent.purple.bolder.pressed': "_bfhk6cze",
    'color.background.accent.magenta.subtlest': "_bfhk8tvm",
    'color.background.accent.magenta.subtlest.hovered': "_bfhkr3zd",
    'color.background.accent.magenta.subtlest.pressed': "_bfhk1ckf",
    'color.background.accent.magenta.subtler': "_bfhkv9ra",
    'color.background.accent.magenta.subtler.hovered': "_bfhk1axx",
    'color.background.accent.magenta.subtler.pressed': "_bfhk42ri",
    'color.background.accent.magenta.subtle': "_bfhk1mi6",
    'color.background.accent.magenta.subtle.hovered': "_bfhkrwyz",
    'color.background.accent.magenta.subtle.pressed': "_bfhk6c15",
    'color.background.accent.magenta.bolder': "_bfhkc3uk",
    'color.background.accent.magenta.bolder.hovered': "_bfhk1ok8",
    'color.background.accent.magenta.bolder.pressed': "_bfhkeawv",
    'color.background.accent.gray.subtlest': "_bfhkysee",
    'color.background.accent.gray.subtlest.hovered': "_bfhkwejn",
    'color.background.accent.gray.subtlest.pressed': "_bfhk18ut",
    'color.background.accent.gray.subtler': "_bfhk7qp0",
    'color.background.accent.gray.subtler.hovered': "_bfhk10ef",
    'color.background.accent.gray.subtler.pressed': "_bfhk1rk9",
    'color.background.accent.gray.subtle': "_bfhk18j9",
    'color.background.accent.gray.subtle.hovered': "_bfhk1nv3",
    'color.background.accent.gray.subtle.pressed': "_bfhkq9tj",
    'color.background.accent.gray.bolder': "_bfhk1i45",
    'color.background.accent.gray.bolder.hovered': "_bfhkbyip",
    'color.background.accent.gray.bolder.pressed': "_bfhk1van",
    'color.background.disabled': "_bfhk187o",
    'color.background.input': "_bfhk1j9a",
    'color.background.input.hovered': "_bfhkl4ek",
    'color.background.input.pressed': "_bfhkr01l",
    'color.background.inverse.subtle': "_bfhk1vck",
    'color.background.inverse.subtle.hovered': "_bfhkmpja",
    'color.background.inverse.subtle.pressed': "_bfhk1gii",
    'color.background.neutral': "_bfhki8nm",
    'color.background.neutral.hovered': "_bfhkplhp",
    'color.background.neutral.pressed': "_bfhk1gdz",
    'color.background.neutral.subtle': "_bfhksm61",
    'color.background.neutral.subtle.hovered': "_bfhk1dpa",
    'color.background.neutral.subtle.pressed': "_bfhkfcek",
    'color.background.neutral.bold': "_bfhk1aqn",
    'color.background.neutral.bold.hovered': "_bfhk1ibz",
    'color.background.neutral.bold.pressed': "_bfhkof27",
    'color.background.selected': "_bfhk15s3",
    'color.background.selected.hovered': "_bfhkufnl",
    'color.background.selected.pressed': "_bfhknozp",
    'color.background.selected.bold': "_bfhkjmqp",
    'color.background.selected.bold.hovered': "_bfhk1q28",
    'color.background.selected.bold.pressed': "_bfhk12kk",
    'color.background.brand.subtlest': "_bfhk1gmr",
    'color.background.brand.subtlest.hovered': "_bfhk3v15",
    'color.background.brand.subtlest.pressed': "_bfhku02c",
    'color.background.brand.bold': "_bfhk1856",
    'color.background.brand.bold.hovered': "_bfhkhf2y",
    'color.background.brand.bold.pressed': "_bfhkg6ey",
    'color.background.brand.boldest': "_bfhk1o4i",
    'color.background.brand.boldest.hovered': "_bfhklefx",
    'color.background.brand.boldest.pressed': "_bfhk16k6",
    'color.background.danger': "_bfhk1gly",
    'color.background.danger.hovered': "_bfhk1yvi",
    'color.background.danger.pressed': "_bfhk1r4b",
    'color.background.danger.bold': "_bfhkybec",
    'color.background.danger.bold.hovered': "_bfhks9hg",
    'color.background.danger.bold.pressed': "_bfhk13a9",
    'color.background.warning': "_bfhk1917",
    'color.background.warning.hovered': "_bfhk19zu",
    'color.background.warning.pressed': "_bfhkzr32",
    'color.background.warning.bold': "_bfhk1kmu",
    'color.background.warning.bold.hovered': "_bfhk1spp",
    'color.background.warning.bold.pressed': "_bfhk4m4m",
    'color.background.success': "_bfhk1y9u",
    'color.background.success.hovered': "_bfhk1vfx",
    'color.background.success.pressed': "_bfhk1wl5",
    'color.background.success.bold': "_bfhkkcmj",
    'color.background.success.bold.hovered': "_bfhky7x8",
    'color.background.success.bold.pressed': "_bfhkwcbh",
    'color.background.discovery': "_bfhk6vm6",
    'color.background.discovery.hovered': "_bfhk12eq",
    'color.background.discovery.pressed': "_bfhk18vq",
    'color.background.discovery.bold': "_bfhku5tj",
    'color.background.discovery.bold.hovered': "_bfhkfqeg",
    'color.background.discovery.bold.pressed': "_bfhk1f1m",
    'color.background.information': "_bfhk19ip",
    'color.background.information.hovered': "_bfhk86z5",
    'color.background.information.pressed': "_bfhk1c1j",
    'color.background.information.bold': "_bfhkx4w0",
    'color.background.information.bold.hovered': "_bfhkq2ii",
    'color.background.information.bold.pressed': "_bfhkf89v",
    'color.blanket': "_bfhk1i5c",
    'color.blanket.selected': "_bfhk7wq0",
    'color.blanket.danger': "_bfhkrprw",
    'color.skeleton': "_bfhkizff",
    'color.skeleton.subtle': "_bfhkvkf5",
    'elevation.surface': "_bfhkvuon",
    'elevation.surface.hovered': "_bfhk19i6",
    'elevation.surface.pressed': "_bfhk13ro",
    'elevation.surface.overlay': "_bfhk1bhr",
    'elevation.surface.overlay.hovered': "_bfhk6o2t",
    'elevation.surface.overlay.pressed': "_bfhkm8nx",
    'elevation.surface.raised': "_bfhkhp5a",
    'elevation.surface.raised.hovered': "_bfhk116u",
    'elevation.surface.raised.pressed': "_bfhk14aj",
    'elevation.surface.sunken': "_bfhkhfxm",
    'utility.elevation.surface.current': "_bfhkchd4"
};
var $1435ed7bd06cd43c$var$CURRENT_SURFACE_CSS_VAR = "--ds-elevation-surface-current";
var $1435ed7bd06cd43c$var$setSurfaceTokenMap = {
    'elevation.surface': "_1q1lvuon",
    'elevation.surface.hovered': "_1q1l19i6",
    'elevation.surface.pressed': "_1q1l13ro",
    'elevation.surface.overlay': "_1q1l1bhr",
    'elevation.surface.overlay.hovered': "_1q1l6o2t",
    'elevation.surface.overlay.pressed': "_1q1lm8nx",
    'elevation.surface.raised': "_1q1lhp5a",
    'elevation.surface.raised.hovered': "_1q1l116u",
    'elevation.surface.raised.pressed': "_1q1l14aj",
    'elevation.surface.sunken': "_1q1lhfxm"
};
var $1435ed7bd06cd43c$var$paddingBlockStartMap = {
    'space.0': "_1q51ze3t",
    'space.025': "_1q51v77o",
    'space.050': "_1q511b66",
    'space.075': "_1q5112x7",
    'space.100': "_1q51u2gc",
    'space.150': "_1q51utpp",
    'space.200': "_1q51pxbi",
    'space.250': "_1q51v47k",
    'space.300': "_1q511ejb",
    'space.400': "_1q51xy5q",
    'space.500': "_1q511jfw",
    'space.600': "_1q51oahv",
    'space.800': "_1q51xncg",
    'space.1000': "_1q511epz"
};
var $1435ed7bd06cd43c$var$paddingBlockEndMap = {
    'space.0': "_85i5ze3t",
    'space.025': "_85i5v77o",
    'space.050': "_85i51b66",
    'space.075': "_85i512x7",
    'space.100': "_85i5u2gc",
    'space.150': "_85i5utpp",
    'space.200': "_85i5pxbi",
    'space.250': "_85i5v47k",
    'space.300': "_85i51ejb",
    'space.400': "_85i5xy5q",
    'space.500': "_85i51jfw",
    'space.600': "_85i5oahv",
    'space.800': "_85i5xncg",
    'space.1000': "_85i51epz"
};
var $1435ed7bd06cd43c$var$paddingInlineStartMap = {
    'space.0': "_bozgze3t",
    'space.025': "_bozgv77o",
    'space.050': "_bozg1b66",
    'space.075': "_bozg12x7",
    'space.100': "_bozgu2gc",
    'space.150': "_bozgutpp",
    'space.200': "_bozgpxbi",
    'space.250': "_bozgv47k",
    'space.300': "_bozg1ejb",
    'space.400': "_bozgxy5q",
    'space.500': "_bozg1jfw",
    'space.600': "_bozgoahv",
    'space.800': "_bozgxncg",
    'space.1000': "_bozg1epz"
};
var $1435ed7bd06cd43c$var$paddingInlineEndMap = {
    'space.0': "_y4tize3t",
    'space.025': "_y4tiv77o",
    'space.050': "_y4ti1b66",
    'space.075': "_y4ti12x7",
    'space.100': "_y4tiu2gc",
    'space.150': "_y4tiutpp",
    'space.200': "_y4tipxbi",
    'space.250': "_y4tiv47k",
    'space.300': "_y4ti1ejb",
    'space.400': "_y4tixy5q",
    'space.500': "_y4ti1jfw",
    'space.600': "_y4tioahv",
    'space.800': "_y4tixncg",
    'space.1000': "_y4ti1epz"
};
/**
 * __Box__
 *
 * A Box is a primitive component that has the design decisions of the Atlassian Design System baked in.
 * Renders a `div` by default.
 *
 * - [Examples](https://atlassian.design/components/primitives/box/examples)
 * - [Code](https://atlassian.design/components/primitives/box/code)
 * - [Usage](https://atlassian.design/components/primitives/box/usage)
 */ var $1435ed7bd06cd43c$var$Box = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? 'div' : _ref$as, children = _ref.children, backgroundColor = _ref.backgroundColor, padding = _ref.padding, _ref$paddingBlock = _ref.paddingBlock, paddingBlock = _ref$paddingBlock === void 0 ? padding : _ref$paddingBlock, _ref$paddingBlockStar = _ref.paddingBlockStart, paddingBlockStart = _ref$paddingBlockStar === void 0 ? paddingBlock : _ref$paddingBlockStar, _ref$paddingBlockEnd = _ref.paddingBlockEnd, paddingBlockEnd = _ref$paddingBlockEnd === void 0 ? paddingBlock : _ref$paddingBlockEnd, _ref$paddingInline = _ref.paddingInline, paddingInline = _ref$paddingInline === void 0 ? padding : _ref$paddingInline, _ref$paddingInlineSta = _ref.paddingInlineStart, paddingInlineStart = _ref$paddingInlineSta === void 0 ? paddingInline : _ref$paddingInlineSta, _ref$paddingInlineEnd = _ref.paddingInlineEnd, paddingInlineEnd = _ref$paddingInlineEnd === void 0 ? paddingInline : _ref$paddingInlineEnd, style = _ref.style, testId = _ref.testId, xcss = _ref.xcss, htmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $1435ed7bd06cd43c$var$_excluded);
    // This is to remove className from safeHtmlAttributes
    // @ts-ignore -- not using expect since it causes issues with help-center local consumption - className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(htmlAttributes, $1435ed7bd06cd43c$var$_excluded2);
    var node = /*#__PURE__*/ $5FkrB.createElement(Component, (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        style: style,
        ref: ref,
        className: (0, $hUbY6.default)([
            "_19itglyw _vchhusvi _r06hglyw",
            backgroundColor && $1435ed7bd06cd43c$var$backgroundColorMap[backgroundColor],
            backgroundColor && $1435ed7bd06cd43c$var$isSurfaceToken(backgroundColor) && $1435ed7bd06cd43c$var$setSurfaceTokenMap[backgroundColor],
            paddingBlockStart && $1435ed7bd06cd43c$var$paddingBlockStartMap[paddingBlockStart],
            paddingBlockEnd && $1435ed7bd06cd43c$var$paddingBlockEndMap[paddingBlockEnd],
            paddingInlineStart && $1435ed7bd06cd43c$var$paddingInlineStartMap[paddingInlineStart],
            paddingInlineEnd && $1435ed7bd06cd43c$var$paddingInlineEndMap[paddingInlineEnd],
            xcss
        ])
    }, safeHtmlAttributes, {
        "data-testid": testId
    }), children);
    if (backgroundColor) return /*#__PURE__*/ $5FkrB.createElement((0, $312sH.SurfaceContext).Provider, {
        value: backgroundColor
    }, node);
    return node;
});
var $1435ed7bd06cd43c$export$2e2bcd8739ae039 = $1435ed7bd06cd43c$var$Box;
function $1435ed7bd06cd43c$var$isSurfaceToken(backgroundColor) {
    return backgroundColor in $1435ed7bd06cd43c$var$setSurfaceTokenMap;
}

});


parcelRegister("cMkZu", function(module, exports) {
$parcel$export(module.exports, "ExpandIcon", () => $94da4010313f3aaa$export$fcdb0af0473ee9e4);
// TODO: Using HipChat icons as the standard icon set is missing large
// versions of `chevron-up` and `chevron-down`, despite already including
// `chevron-left-large` and `chevron-right-large`...

var $5FkrB = parcelRequire("5FkrB");

var $03Ypo = parcelRequire("03Ypo");

var $elnf7 = parcelRequire("elnf7");
var $94da4010313f3aaa$export$fcdb0af0473ee9e4 = /*#__PURE__*/ (0, $5FkrB.memo)(function(_ref) {
    var isExpanded = _ref.isExpanded;
    switch(isExpanded){
        case false:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($elnf7))), {
                spacing: "compact",
                label: "",
                color: "currentColor",
                size: "small"
            });
        case true:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($03Ypo))), {
                spacing: "compact",
                label: "",
                color: "currentColor",
                size: "small"
            });
    }
});

});
parcelRegister("03Ypo", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d56e8662eb8a8d2462ec3a39ff3aa40b>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $00bf23d52c692552$var$_react = $00bf23d52c692552$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $00bf23d52c692552$var$_baseNew = $00bf23d52c692552$var$_interopRequireDefault((parcelRequire("xN3u9")));
function $00bf23d52c692552$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ChevronDown".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Do not use 16px chevrons within buttons, icon buttons, or dropdowns to maintain visual cohesion with ADS which uses 12px chevrons.
Known uses: Open dropdown menu, expanded tree item, collapse tree item
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $00bf23d52c692552$var$ChevronDownIcon = (props)=>/*#__PURE__*/ $00bf23d52c692552$var$_react.default.createElement($00bf23d52c692552$var$_baseNew.default, Object.assign({
        name: "ChevronDownIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="m14.53 6.03-6 6a.75.75 0 0 1-1.004.052l-.056-.052-6-6 1.06-1.06L8 10.44l5.47-5.47z"/>`
    }, props));
$00bf23d52c692552$var$ChevronDownIcon.displayName = 'ChevronDownIcon';
var $00bf23d52c692552$var$_default = module.exports.default = $00bf23d52c692552$var$ChevronDownIcon;

});

parcelRegister("elnf7", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::fbc9eb298cfdac722b50cf5246108693>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a7150e6b70124930$var$_react = $a7150e6b70124930$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $a7150e6b70124930$var$_baseNew = $a7150e6b70124930$var$_interopRequireDefault((parcelRequire("xN3u9")));
function $a7150e6b70124930$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ChevronRight".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Do not use 16px chevrons within buttons, icon buttons, or dropdowns to maintain visual cohesion with ADS which uses 12px chevrons.
Known uses: Next page of pagination results, collapsed tree item, expand tree item
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a7150e6b70124930$var$ChevronRightIcon = (props)=>/*#__PURE__*/ $a7150e6b70124930$var$_react.default.createElement($a7150e6b70124930$var$_baseNew.default, Object.assign({
        name: "ChevronRightIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="m6.03 1.47 6 6a.75.75 0 0 1 .052 1.004l-.052.056-6 6-1.06-1.06L10.44 8 4.97 2.53z"/>`
    }, props));
$a7150e6b70124930$var$ChevronRightIcon.displayName = 'ChevronRightIcon';
var $a7150e6b70124930$var$_default = module.exports.default = $a7150e6b70124930$var$ChevronRightIcon;

});


parcelRegister("f20te", function(module, exports) {
$parcel$export(module.exports, "TD", () => $af176858f7845e77$export$9cf5b401f969f5e3);

var $kqp0i = parcelRequire("kqp0i");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");

var $gtBt8 = parcelRequire("gtBt8");
var $af176858f7845e77$var$_excluded = [
    "testId"
];
var $af176858f7845e77$export$9cf5b401f969f5e3 = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function(_ref, ref) {
    var testId = _ref.testId, props = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $af176858f7845e77$var$_excluded);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $gtBt8.BaseCell), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        as: "td",
        testId: testId
    }, props, {
        ref: ref
    }));
});

});

parcelRegister("5THOi", function(module, exports) {
$parcel$export(module.exports, "TR", () => $44b4129522b3eb56$export$5582bd7183a5e873);

var $kqp0i = parcelRequire("kqp0i");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");

var $kZC4L = parcelRequire("kZC4L");
var $44b4129522b3eb56$var$_excluded = [
    "isSelected"
];
var $44b4129522b3eb56$export$5582bd7183a5e873 = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function(_ref, ref) {
    var isSelected = _ref.isSelected, props = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $44b4129522b3eb56$var$_excluded);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $kZC4L.default), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        as: "tr",
        tabIndex: -1,
        "aria-selected": isSelected,
        ref: ref
    }, props));
});

});

parcelRegister("iRBPG", function(module, exports) {
$parcel$export(module.exports, "CharlieTableHeader", () => $dbba8600637d245b$export$dfa60aeb2051f459);

var $kqp0i = parcelRequire("kqp0i");

var $1Vcia = parcelRequire("1Vcia");

var $25nEq = parcelRequire("25nEq");

var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");

var $74Zh5 = parcelRequire("74Zh5");

var $kGO2D = parcelRequire("kGO2D");

var $3HqRa = parcelRequire("3HqRa");

var $fLEvx = parcelRequire("fLEvx");

var $hO72L = parcelRequire("hO72L");

var $kZC4L = parcelRequire("kZC4L");
var $8YAYC = parcelRequire("8YAYC");
var $3JBzg = parcelRequire("3JBzg");
var $7Cqku = parcelRequire("7Cqku");

var $a6Lix = parcelRequire("a6Lix");
var $6hCeH = parcelRequire("6hCeH");

var $4oEEp = parcelRequire("4oEEp");

var $d90PQ = parcelRequire("d90PQ");
var $dbba8600637d245b$var$_excluded = [
    "children"
];
function $dbba8600637d245b$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $dbba8600637d245b$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $dbba8600637d245b$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $dbba8600637d245b$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $dbba8600637d245b$var$HeaderDescriptionStyles = (0, $7Cqku.xcss)({
    background: "var(--ds-surface-overlay, #FFFFFF)",
    boxSizing: 'content-box',
    maxHeight: '500px',
    maxWidth: '300px',
    //TODO: move this to the children of the tooltip, not as styling for the tooltip
    //@ts-expect-error styling is applying but property does not exist for SafeCSSObject
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/design-system/no-nested-styles
    ul: {
        paddingLeft: "var(--ds-space-250, 20px)"
    },
    boxShadow: 'elevation.shadow.overlay',
    color: 'color.text',
    padding: 'space.300',
    borderRadius: 'radius.xsmall',
    margin: 'space.050'
});
var $dbba8600637d245b$var$checkboxWrapperStyle = (0, $7Cqku.xcss)({
    paddingInlineStart: 'space.100'
});
var $dbba8600637d245b$var$NotReorderingPaddingStyle = (0, $7Cqku.xcss)({
    paddingInlineStart: 'space.100',
    alignItems: 'center'
});
var $dbba8600637d245b$var$overflowInlineStyle = (0, $7Cqku.xcss)({
    overflow: 'hidden',
    alignItems: 'center'
});
var $dbba8600637d245b$var$ButtonFontStyles = (0, $7Cqku.xcss)({
    overflow: 'hidden',
    flex: 1,
    textOverflow: 'ellipsis',
    color: 'color.text.subtlest',
    textAlign: 'left',
    fontWeight: 'font.weight.bold'
});
var $dbba8600637d245b$var$ButtonFontCurrentSortStyles = (0, $7Cqku.xcss)({
    color: 'color.text.brand'
});
var $dbba8600637d245b$var$SortButtonStyle = (0, $74Zh5.css)({
    width: 'fit-content',
    paddingInline: "var(--ds-space-050, 4px)",
    height: '100%',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
    fill: "var(--ds-text-subtlest, #6B6E76)".concat(" !important")
});
var $dbba8600637d245b$var$SortButtonCurrentSortStyle = (0, $74Zh5.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
    fill: "var(--ds-text-brand, #1868DB)".concat(" !important"),
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/design-system/no-nested-styles
    '.sortable-icon': {
        opacity: 1,
        transitionDelay: '150ms'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/design-system/no-nested-styles
    'svg, path, g': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
        fill: "var(--ds-text-brand, #1868DB)".concat(" !important")
    }
});
var $dbba8600637d245b$var$DragHandlerIconContainerStyle = (0, $7Cqku.xcss)({
    alignItems: 'center',
    justifyContent: 'center',
    height: '100%',
    width: 'size.100'
});

var $dbba8600637d245b$export$dfa60aeb2051f459 = function CharlieTableHeader(_ref) {
    var _charlieTableColumn$c, _charlieTableColumn$c2;
    var labels = _ref.labels, tableType = _ref.tableType, charlieTableColumn = _ref.charlieTableColumn, charlieTableState = _ref.charlieTableState, index = _ref.index, _ref$enableResizing = _ref.enableResizing, enableResizing = _ref$enableResizing === void 0 ? false : _ref$enableResizing, enableColumnReorder = _ref.enableColumnReorder, enableRowSelection = _ref.enableRowSelection, hasWidths = _ref.hasWidths, customXcss = _ref.xcss, analyticsContext = _ref.analyticsContext, interactionName = _ref.interactionName;
    var _React$useState = (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).useState(false), _React$useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_React$useState, 2), showIcons = _React$useState2[0], setShowIcons = _React$useState2[1];
    var PragmaticHeadCellLazy = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).lazy(function() {
        return (parcelRequire("ltx6p")).then(function(module) {
            return {
                default: module.PragmaticHeadCell
            };
        });
    });
    var Header = (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).useMemo(function() {
        if (enableResizing || enableColumnReorder) return function(props) {
            return (0, $74Zh5.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).Suspense, {
                fallback: (0, $74Zh5.jsx)((0, $4oEEp.HeadCell), props)
            }, (0, $74Zh5.jsx)(PragmaticHeadCellLazy, props));
        };
        else return 0, $4oEEp.HeadCell;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        enableResizing,
        enableColumnReorder
    ]);
    if (enableRowSelection && index === 0) return (0, $74Zh5.jsx)((0, $4oEEp.HeadCell), {
        tableType: tableType,
        xcss: [
            // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $7Cqku.xcss)({
                // @ts-expect-error-next-line - none of the zIndex ADS tokens equate to 1
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
                zIndex: charlieTableColumn.column.getIsPinned() ? 3 : undefined,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
                left: "var(--col-".concat(charlieTableColumn.id, "-left)"),
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
                right: "var(--col-".concat(charlieTableColumn.id, "-right)"),
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
                position: charlieTableColumn.column.getIsPinned() ? 'sticky' : 'relative',
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
                paddingInlineStart: 'space.100'
            }),
            customXcss
        ],
        width: hasWidths ? "".concat(charlieTableColumn.getSize(), "px") : undefined,
        key: charlieTableColumn.id
    }, (0, $74Zh5.jsx)((0, $kZC4L.default), {
        xcss: $dbba8600637d245b$var$checkboxWrapperStyle
    }, (0, $74Zh5.jsx)((0, $fLEvx.default), {
        analyticsContext: $dbba8600637d245b$var$_objectSpread({
            componentName: 'charlieTableSortColumnButton'
        }, analyticsContext),
        "aria-label": labels === null || labels === void 0 ? void 0 : labels.selectAllRows,
        isIndeterminate: charlieTableState.getIsSomeRowsSelected(),
        isChecked: charlieTableState.getIsAllRowsSelected(),
        onClick: function onClick() {
            return charlieTableState.toggleAllRowsSelected();
        }
    })));
    var sortDirection = charlieTableColumn.column.getIsSorted();
    return (0, $74Zh5.jsx)(Header, (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        tableType: tableType,
        xcss: [
            // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $7Cqku.xcss)($dbba8600637d245b$var$_objectSpread({
                // @ts-expect-error-next-line - none of the zIndex ADS tokens equate to 1
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
                zIndex: charlieTableColumn.column.getIsPinned() ? 3 : undefined,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
                left: "var(--col-".concat(charlieTableColumn.id, "-left)"),
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
                right: "var(--col-".concat(charlieTableColumn.id, "-right)"),
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
                position: charlieTableColumn.column.getIsPinned() ? 'sticky' : 'relative'
            }, enableColumnReorder ? {
                paddingInlineStart: 'space.0',
                cursor: 'grab'
            } : {
                //overriding dom default of space.0 for first-of-type
                ':first-of-type': {
                    paddingInlineStart: 'space.100'
                }
            })),
            customXcss
        ],
        onWidthChange: function onWidthChange(width) {
            charlieTableState.setColumnSizing(function(old) {
                return $dbba8600637d245b$var$_objectSpread($dbba8600637d245b$var$_objectSpread({}, old), {}, (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, charlieTableColumn.id, width));
            });
        }
    }, sortDirection && {
        sortDirection: sortDirection === 'asc' ? 'ascending' : 'descending'
    }, {
        enableColumnReorder: enableColumnReorder,
        enableResizing: enableResizing,
        width: hasWidths ? "".concat(charlieTableColumn.getSize(), "px") : undefined,
        key: charlieTableColumn.id,
        id: charlieTableColumn.id,
        onMouseEnter: function onMouseEnter() {
            return setShowIcons(true);
        },
        onMouseLeave: function onMouseLeave() {
            return setShowIcons(false);
        }
    }), (0, $74Zh5.jsx)((0, $a6Lix.default), {
        component: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).forwardRef(function(props, ref) {
            var children = props.children, rest = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(props, $dbba8600637d245b$var$_excluded);
            if (ref == null) return null;
            return (0, $74Zh5.jsx)((0, $6hCeH.default), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, rest, {
                ref: ref
            }), (0, $74Zh5.jsx)((0, $kZC4L.default), {
                xcss: $dbba8600637d245b$var$HeaderDescriptionStyles
            }, children));
        }),
        content: ((_charlieTableColumn$c = charlieTableColumn.column.columnDef.meta) === null || _charlieTableColumn$c === void 0 ? void 0 : _charlieTableColumn$c.description) && (0, $74Zh5.jsx)((0, $kZC4L.default), null, (0, $74Zh5.jsx)("b", null, (0, $kGO2D.flexRender)(charlieTableColumn.column.columnDef.header, charlieTableColumn.getContext())), (_charlieTableColumn$c2 = charlieTableColumn.column.columnDef.meta) === null || _charlieTableColumn$c2 === void 0 ? void 0 : _charlieTableColumn$c2.description),
        position: "bottom"
    }, function(tooltipProps) {
        var _charlieTableColumn$c3, _charlieTableColumn$c4, _charlieTableColumn$c5;
        return charlieTableColumn.column.getCanSort() ? (0, $74Zh5.jsx)((0, $kZC4L.default), tooltipProps, (0, $74Zh5.jsx)((0, $3JBzg.default), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
            xcss: enableColumnReorder ? $dbba8600637d245b$var$overflowInlineStyle : $dbba8600637d245b$var$NotReorderingPaddingStyle,
            spread: "space-between"
        }, tooltipProps), (0, $74Zh5.jsx)((0, $3JBzg.default), {
            xcss: $dbba8600637d245b$var$overflowInlineStyle
        }, enableColumnReorder && (0, $74Zh5.jsx)((0, $8YAYC.default), {
            xcss: $dbba8600637d245b$var$DragHandlerIconContainerStyle
        }, showIcons && (0, $74Zh5.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($hO72L))), {
            label: "Drag list item",
            color: "var(--ds-icon, #292A2E)",
            size: "small"
        })), (0, $74Zh5.jsx)((0, $kZC4L.default), {
            xcss: [
                $dbba8600637d245b$var$ButtonFontStyles,
                sortDirection && $dbba8600637d245b$var$ButtonFontCurrentSortStyles
            ]
        }, (0, $kGO2D.flexRender)(charlieTableColumn.column.columnDef.header, charlieTableColumn.getContext()))), (0, $74Zh5.jsx)((0, $3HqRa.default), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
            testId: "".concat(charlieTableColumn.id, "-sort-button"),
            spacing: "none",
            appearance: "subtle"
        }, tooltipProps, {
            onClick: function onClick() {
                return charlieTableColumn.column.toggleSorting();
            },
            "aria-label": "".concat(charlieTableColumn.id, " column sort button"),
            interactionName: interactionName,
            analyticsContext: $dbba8600637d245b$var$_objectSpread({
                componentName: 'charlieTableSortColumnButton'
            }, analyticsContext),
            css: [
                $dbba8600637d245b$var$SortButtonStyle,
                sortDirection && $dbba8600637d245b$var$SortButtonCurrentSortStyle
            ]
        }), (0, $74Zh5.jsx)((0, $8YAYC.default), {
            xcss: $dbba8600637d245b$var$DragHandlerIconContainerStyle
        }, (_charlieTableColumn$c3 = charlieTableColumn.column.columnDef.meta) !== null && _charlieTableColumn$c3 !== void 0 && _charlieTableColumn$c3.sortDescription ? (0, $74Zh5.jsx)((0, $a6Lix.default), {
            testId: "sort-tooltip",
            content: "".concat(sortDirection === 'asc' ? (_charlieTableColumn$c4 = charlieTableColumn.column.columnDef.meta) === null || _charlieTableColumn$c4 === void 0 ? void 0 : _charlieTableColumn$c4.sortDescription.asc : (_charlieTableColumn$c5 = charlieTableColumn.column.columnDef.meta) === null || _charlieTableColumn$c5 === void 0 ? void 0 : _charlieTableColumn$c5.sortDescription.desc)
        }, (showIcons || sortDirection) && (0, $74Zh5.jsx)((0, $d90PQ.SortIcon), {
            sortDirection: sortDirection !== null && sortDirection !== void 0 ? sortDirection : 'asc',
            isCurrentSort: sortDirection ? true : false
        })) : (0, $74Zh5.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).Fragment, null, (showIcons || sortDirection) && (0, $74Zh5.jsx)((0, $d90PQ.SortIcon), {
            sortDirection: sortDirection !== null && sortDirection !== void 0 ? sortDirection : 'asc',
            isCurrentSort: sortDirection ? true : false
        })))))) : (0, $74Zh5.jsx)((0, $kZC4L.default), tooltipProps, (0, $74Zh5.jsx)((0, $3JBzg.default), {
            xcss: enableColumnReorder ? $dbba8600637d245b$var$overflowInlineStyle : $dbba8600637d245b$var$NotReorderingPaddingStyle
        }, enableColumnReorder && (0, $74Zh5.jsx)((0, $8YAYC.default), {
            xcss: $dbba8600637d245b$var$DragHandlerIconContainerStyle
        }, showIcons && (0, $74Zh5.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($hO72L))), {
            label: "Drag list item",
            color: "var(--ds-icon, #292A2E)",
            size: "small"
        })), (0, $74Zh5.jsx)((0, $kZC4L.default), {
            xcss: $dbba8600637d245b$var$ButtonFontStyles
        }, (0, $kGO2D.flexRender)(charlieTableColumn.column.columnDef.header, charlieTableColumn.getContext()))));
    }));
};

});
parcelRegister("3HqRa", function(module, exports) {
$parcel$export(module.exports, "default", () => $2b1a3868dc41c202$export$2e2bcd8739ae039);

var $kqp0i = parcelRequire("kqp0i");

var $iYJcE = parcelRequire("iYJcE");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");

var $4NddD = parcelRequire("4NddD");

var $3frnZ = parcelRequire("3frnZ");

var $lqalz = parcelRequire("lqalz");

var $8BW8f = parcelRequire("8BW8f");
var $2b1a3868dc41c202$var$_excluded = [
    "appearance",
    "children",
    "iconBefore",
    "iconAfter",
    "isSelected",
    "onMouseDown",
    "onMouseUp",
    "shouldFitContainer",
    "spacing"
];
var $2b1a3868dc41c202$var$isFirefox = typeof navigator !== 'undefined' && navigator.userAgent.toLowerCase().indexOf('firefox') > -1;
/**
 * __Button__
 *
 * @deprecated Legacy buttons are deprecated and will be removed from `atlaskit/button` in an upcoming major release. Please use the new Button components from `@atlaskit/button/new`
 *
 * Please refer to the [migration guide](https://atlassian.design/components/button/button-legacy/migration-guide) for further details.
 *
 * A button triggers an event or action. They let users know what will happen next.
 *
 * - [Examples](https://atlassian.design/components/button/button-legacy/examples)
 * - [Code](https://atlassian.design/components/button/button-legacy/code)
 * - [Usage](https://atlassian.design/components/button/button-legacy/usage)
 */ var $2b1a3868dc41c202$var$Button = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).forwardRef(function Button(_ref, ref) {
    var _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'default' : _ref$appearance, children = _ref.children, iconBefore = _ref.iconBefore, iconAfter = _ref.iconAfter, _ref$isSelected = _ref.isSelected, isSelected = _ref$isSelected === void 0 ? false : _ref$isSelected, _ref$onMouseDown = _ref.onMouseDown, providedOnMouseDown = _ref$onMouseDown === void 0 ? (0, $4NddD.default) : _ref$onMouseDown, _ref$onMouseUp = _ref.onMouseUp, providedOnMouseUp = _ref$onMouseUp === void 0 ? (0, $4NddD.default) : _ref$onMouseUp, _ref$shouldFitContain = _ref.shouldFitContainer, shouldFitContainer = _ref$shouldFitContain === void 0 ? false : _ref$shouldFitContain, _ref$spacing = _ref.spacing, spacing = _ref$spacing === void 0 ? 'default' : _ref$spacing, rest = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $2b1a3868dc41c202$var$_excluded);
    var isOnlySingleIcon = (0, $8BW8f.default)({
        children: children,
        iconBefore: iconBefore,
        iconAfter: iconAfter
    });
    var _useState = (0, $5FkrB.useState)(false), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), isActive = _useState2[0], setIsActive = _useState2[1];
    // Wrap onMouseDown / onMouseUp to manually trigger active state
    // in Firefox
    var onMouseDown = (0, $5FkrB.useCallback)(function(event) {
        providedOnMouseDown(event);
        if ($2b1a3868dc41c202$var$isFirefox) setIsActive(true);
    }, [
        providedOnMouseDown,
        setIsActive
    ]);
    var onMouseUp = (0, $5FkrB.useCallback)(function(event) {
        providedOnMouseUp(event);
        if ($2b1a3868dc41c202$var$isFirefox) setIsActive(false);
    }, [
        providedOnMouseUp,
        setIsActive
    ]);
    var buttonCss = (0, $5FkrB.useMemo)(function() {
        return (0, $lqalz.getCss)({
            appearance: appearance,
            spacing: spacing,
            isSelected: isSelected,
            shouldFitContainer: shouldFitContainer,
            isOnlySingleIcon: isOnlySingleIcon
        });
    }, [
        appearance,
        spacing,
        isSelected,
        shouldFitContainer,
        isOnlySingleIcon
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $3frnZ.default), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, rest, {
        ref: ref,
        appearance: appearance,
        buttonCss: buttonCss,
        children: children,
        "data-firefox-is-active": isActive ? true : undefined,
        iconAfter: iconAfter,
        iconBefore: iconBefore,
        isSelected: isSelected,
        onMouseDown: onMouseDown,
        onMouseUp: onMouseUp,
        spacing: spacing
    }));
}));
// Tools including enzyme rely on components having a display name
$2b1a3868dc41c202$var$Button.displayName = 'Button';
var $2b1a3868dc41c202$export$2e2bcd8739ae039 = $2b1a3868dc41c202$var$Button;

});
parcelRegister("3frnZ", function(module, exports) {
$parcel$export(module.exports, "default", () => $25d8041c54b4c909$export$2e2bcd8739ae039);

var $kqp0i = parcelRequire("kqp0i");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");

var $74Zh5 = parcelRequire("74Zh5");

var $aLEtb = parcelRequire("aLEtb");

var $4NddD = parcelRequire("4NddD");

var $ex2NY = parcelRequire("ex2NY");

var $25czp = parcelRequire("25czp");

var $1thDS = parcelRequire("1thDS");

var $eWWVY = parcelRequire("eWWVY");

var $fMQHy = parcelRequire("fMQHy");

var $lJaij = parcelRequire("lJaij");

var $4Vagz = parcelRequire("4Vagz");

var $i5DCW = parcelRequire("i5DCW");

var $2ires = parcelRequire("2ires");
var $25d8041c54b4c909$var$_excluded = [
    "analyticsContext",
    "appearance",
    "autoFocus",
    "buttonCss",
    "children",
    "className",
    "href",
    "component",
    "iconAfter",
    "iconBefore",
    "interactionName",
    "isDisabled",
    "isSelected",
    "onBlur",
    "onClick",
    "onFocus",
    "onMouseDown",
    "overlay",
    "shouldFitContainer",
    "spacing",
    "tabIndex",
    "type",
    "testId"
];
// Disabled buttons will still publish events for nested elements in webkit.
// We are disabling pointer events on child elements so that
// the button will always be the target of events
// Note: firefox does not have this behaviour for child elements
var $25d8041c54b4c909$var$noPointerEventsOnChildrenCss = {
    '> *': {
        pointerEvents: 'none'
    }
};
/**
 * These CSS variables consumed by the new icons, to allow them to have appropriate
 * padding inside Button while also maintaining spacing for the existing icons.
 *
 * These styles can be removed once the new icons are fully rolled out, feature flag
 * platform-visual-refresh-icons is cleaned up,
 * and we bump Button to set padding based on the new icons.
 */ var $25d8041c54b4c909$var$iconBeforeSpacingFixStyle = (0, $74Zh5.css)({
    '--ds--button--new-icon-padding-end': "var(--ds-space-025, 2px)",
    '--ds--button--new-icon-padding-start': "var(--ds-space-050, 4px)",
    marginInlineStart: "var(--ds-space-negative-025, -2px)"
});
var $25d8041c54b4c909$var$iconAfterSpacingFixStyle = (0, $74Zh5.css)({
    '--ds--button--new-icon-padding-end': "var(--ds-space-050, 4px)",
    '--ds--button--new-icon-padding-start': "var(--ds-space-025, 2px)",
    marginInlineEnd: "var(--ds-space-negative-025, -2px)"
});
var $25d8041c54b4c909$var$getSpacingFix = function getSpacingFix(children, spacingStyles) {
    if (!children || (0, $i5DCW.getIfVisuallyHiddenChildren)(children)) return null;
    return spacingStyles;
};
var $25d8041c54b4c909$var$getChildren = function getChildren(children, childrenStyles) {
    if ((0, $i5DCW.getIfVisuallyHiddenChildren)(children)) return children;
    return children ? (0, $74Zh5.jsx)("span", {
        css: childrenStyles
    }, children) : null;
};
var $25d8041c54b4c909$var$ButtonBase = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).forwardRef(function ButtonBase(props, ref) {
    var analyticsContext = props.analyticsContext, _props$appearance = props.appearance, appearance = _props$appearance === void 0 ? 'default' : _props$appearance, _props$autoFocus = props.autoFocus, autoFocus = _props$autoFocus === void 0 ? false : _props$autoFocus, buttonCss = props.buttonCss, children = props.children, className = props.className, href = props.href, _props$component = props.component, Component = _props$component === void 0 ? href ? 'a' : 'button' : _props$component, iconAfter = props.iconAfter, iconBefore = props.iconBefore, interactionName = props.interactionName, _props$isDisabled = props.isDisabled, isDisabled = _props$isDisabled === void 0 ? false : _props$isDisabled, _props$isSelected = props.isSelected, isSelected = _props$isSelected === void 0 ? false : _props$isSelected, onBlur = props.onBlur, _props$onClick = props.onClick, providedOnClick = _props$onClick === void 0 ? (0, $4NddD.default) : _props$onClick, onFocus = props.onFocus, _props$onMouseDown = props.onMouseDown, providedOnMouseDown = _props$onMouseDown === void 0 ? (0, $4NddD.default) : _props$onMouseDown, overlay = props.overlay, shouldFitContainer = props.shouldFitContainer, _props$spacing = props.spacing, spacing = _props$spacing === void 0 ? 'default' : _props$spacing, _props$tabIndex = props.tabIndex, tabIndex = _props$tabIndex === void 0 ? 0 : _props$tabIndex, _props$type = props.type, type = _props$type === void 0 ? !href ? 'button' : undefined : _props$type, testId = props.testId, rest = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(props, $25d8041c54b4c909$var$_excluded);
    var ourRef = (0, $5FkrB.useRef)();
    var setRef = (0, $5FkrB.useCallback)(function(node) {
        ourRef.current = node;
        if (ref == null) return;
        if (typeof ref === 'function') {
            ref(node);
            return;
        }
        // We can write to ref's `current` property, but Typescript does not like it.
        // @ts-ignore
        ref.current = node;
    }, [
        ourRef,
        ref
    ]);
    // Cross browser auto focusing is pretty broken, so we are doing it ourselves
    (0, $ex2NY.default)(ourRef, autoFocus);
    var interactionContext = (0, $5FkrB.useContext)((0, $1thDS.default));
    var handleClick = (0, $5FkrB.useCallback)(function(e, analyticsEvent) {
        interactionContext && interactionContext.tracePress(interactionName, e.timeStamp);
        providedOnClick(e, analyticsEvent);
    }, [
        providedOnClick,
        interactionContext,
        interactionName
    ]);
    var onClick = (0, $aLEtb.usePlatformLeafEventHandler)({
        fn: handleClick,
        action: 'clicked',
        componentName: 'button',
        packageName: "@atlaskit/button",
        packageVersion: "24.0.0",
        analyticsData: analyticsContext
    });
    // Button currently calls preventDefault, which is not standard button behaviour
    var onMouseDown = (0, $5FkrB.useCallback)(function(event) {
        event.preventDefault();
        providedOnMouseDown(event);
    }, [
        providedOnMouseDown
    ]);
    // Lose focus when becoming disabled (standard button behaviour)
    (0, $5FkrB.useEffect)(function() {
        var el = ourRef.current;
        if (isDisabled && el && el === document.activeElement) el.blur();
    }, [
        isDisabled
    ]);
    // we are 'disabling' input with a button when there is an overlay
    var hasOverlay = Boolean(overlay);
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    var fadeStyles = (0, $74Zh5.css)((0, $lJaij.getFadingCss)({
        hasOverlay: hasOverlay
    }));
    var isInteractive = !isDisabled && !hasOverlay;
    /**
   * HACK: Spinner needs to have different colours in the "new" tokens design compared to the old design.
   * For now, while we support both, these styles reach into Spinner when a theme is set, applies the right color.
   * Ticket to remove: https://product-fabric.atlassian.net/browse/DSP-2067.
   */ var spinnerHackCss = {};
    if (isSelected || isDisabled || appearance === 'warning') spinnerHackCss = {
        '[data-theme] & circle': {
            stroke: "".concat(isSelected || isDisabled ? "var(--ds-icon-subtle, #505258)" : "var(--ds-icon-warning-inverse, #292A2E)", " !important")
        }
    };
    return (0, $74Zh5.jsx)((0, $25czp.default), null, (0, $74Zh5.jsx)(Component, (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, rest, {
        ref: setRef,
        className: className,
        css: [
            buttonCss,
            isInteractive ? null : $25d8041c54b4c909$var$noPointerEventsOnChildrenCss
        ],
        "data-has-overlay": hasOverlay ? true : undefined,
        "data-testid": testId,
        disabled: isDisabled,
        href: isInteractive ? href : undefined,
        onBlur: onBlur,
        onClick: onClick,
        onFocus: onFocus,
        onMouseDown: onMouseDown,
        tabIndex: isDisabled ? -1 : tabIndex,
        type: type
    }, (0, $eWWVY.default)({
        isInteractive: isInteractive
    })), iconBefore ? (0, $74Zh5.jsx)("span", {
        css: [
            fadeStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $4Vagz.getIconStyle)({
                spacing: spacing
            }),
            $25d8041c54b4c909$var$getSpacingFix(children, $25d8041c54b4c909$var$iconBeforeSpacingFixStyle)
        ]
    }, iconBefore) : null, $25d8041c54b4c909$var$getChildren(children, [
        fadeStyles,
        (0, $fMQHy.getContentStyle)({
            spacing: spacing
        })
    ]), iconAfter ? (0, $74Zh5.jsx)("span", {
        css: [
            fadeStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $4Vagz.getIconStyle)({
                spacing: spacing
            }),
            $25d8041c54b4c909$var$getSpacingFix(children, $25d8041c54b4c909$var$iconAfterSpacingFixStyle)
        ]
    }, iconAfter) : null, overlay ? (0, $74Zh5.jsx)("span", {
        css: [
            (0, $2ires.overlayCss),
            spinnerHackCss
        ]
    }, overlay) : null));
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$25d8041c54b4c909$export$2e2bcd8739ae039 = $25d8041c54b4c909$var$ButtonBase;

});
parcelRegister("25czp", function(module, exports) {
$parcel$export(module.exports, "default", () => $1845cc8c422c6a83$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5FkrB = parcelRequire("5FkrB");

var $74Zh5 = parcelRequire("74Zh5");
var $1845cc8c422c6a83$var$BORDER_WIDTH = 2;
var $1845cc8c422c6a83$var$baseFocusOutsideStyles = (0, $74Zh5.css)({
    outline: "var(--ds-border-width-focused, 2px)".concat(" solid ", "var(--ds-border-focused, #4688EC)"),
    outlineOffset: $1845cc8c422c6a83$var$BORDER_WIDTH
});
var $1845cc8c422c6a83$var$baseInsetStyles = (0, $74Zh5.css)({
    outlineColor: "var(--ds-border-focused, #4688EC)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    outlineOffset: -$1845cc8c422c6a83$var$BORDER_WIDTH,
    outlineStyle: 'solid',
    outlineWidth: "var(--ds-border-width-focused, 2px)"
});
var $1845cc8c422c6a83$var$focusRingStyles = (0, $74Zh5.css)({
    // Focus styles used when :focus-visible isn't supported
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
    '&:focus': $1845cc8c422c6a83$var$baseFocusOutsideStyles,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
    '&:focus-visible': $1845cc8c422c6a83$var$baseFocusOutsideStyles,
    // Remove default focus styles for mouse interactions if :focus-visible is supported
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
    '&:focus:not(:focus-visible)': {
        outline: 'none'
    },
    '@media screen and (forced-colors: active), screen and (-ms-high-contrast: active)': {
        '&:focus-visible': {
            outline: "var(--ds-border-width, 1px)".concat(" solid")
        }
    }
});
var $1845cc8c422c6a83$var$insetFocusRingStyles = (0, $74Zh5.css)({
    // Focus styles used when :focus-visible isn't supported
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
    '&:focus': $1845cc8c422c6a83$var$baseInsetStyles,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
    '&:focus-visible': $1845cc8c422c6a83$var$baseInsetStyles,
    // Remove default focus styles for mouse interactions if :focus-visible is supported
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
    '&:focus:not(:focus-visible)': {
        outline: 'none'
    },
    '@media screen and (forced-colors: active), screen and (-ms-high-contrast: active)': {
        '&:focus-visible': {
            outline: "var(--ds-border-width, 1px)".concat(" solid"),
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
            outlineOffset: '-1px'
        }
    }
});
/**
 * __Focus ring__
 *
 * A focus ring visually indicates the currently focused item.
 *
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/focus-ring)
 *
 * @example
 * ```jsx
 * import FocusRing from '@atlaskit/focus-ring';
 *
 * const InteractiveComponent = () => (
 *   <FocusRing>
 *     <button type="button">Hello</button>
 *   </FocusRing>
 * )
 * ```
 */ var $1845cc8c422c6a83$var$FocusRing = /*#__PURE__*/ (0, $5FkrB.memo)(function(_ref) {
    var children = _ref.children, isInset = _ref.isInset, focus = _ref.focus;
    var controlledStyles = isInset ? $1845cc8c422c6a83$var$baseInsetStyles : $1845cc8c422c6a83$var$baseFocusOutsideStyles;
    var uncontrolledStyles = isInset ? $1845cc8c422c6a83$var$insetFocusRingStyles : $1845cc8c422c6a83$var$focusRingStyles;
    var focusCls = typeof focus === 'undefined' ? uncontrolledStyles : focus === 'on' && controlledStyles;
    return (0, $74Zh5.jsx)((0, $74Zh5.ClassNames), null, function(_ref2) {
        var css = _ref2.css, cx = _ref2.cx;
        return (0, $5FkrB.Children).only(// This may look unwieldy but means we skip applying styles / cloning if no className is applicable
        focusCls ? /*#__PURE__*/ // eslint-disable-next-line @repo/internal/react/no-clone-element
        (0, $5FkrB.cloneElement)(children, {
            className: cx([
                css(focusCls),
                children.props.className
            ])
        }) : children);
    });
});
$1845cc8c422c6a83$var$FocusRing.displayName = 'FocusRing';
var $1845cc8c422c6a83$export$2e2bcd8739ae039 = $1845cc8c422c6a83$var$FocusRing;

});

parcelRegister("eWWVY", function(module, exports) {
$parcel$export(module.exports, "default", () => $ae24328b820f957a$export$2e2bcd8739ae039);
function $ae24328b820f957a$var$abort(event) {
    event.preventDefault();
    event.stopPropagation();
}
var $ae24328b820f957a$var$tabKeyCode = 9;
function $ae24328b820f957a$var$onKey(event) {
    // Allowing tab so that a user can move focus away
    if (event.keyCode === $ae24328b820f957a$var$tabKeyCode) return;
    $ae24328b820f957a$var$abort(event);
}
var $ae24328b820f957a$var$block = {
    onMouseDownCapture: $ae24328b820f957a$var$abort,
    onMouseUpCapture: $ae24328b820f957a$var$abort,
    // because we have tabIndex = -1 when disabled,
    // keyboard events can only occur when there is an overlay
    onKeyDownCapture: $ae24328b820f957a$var$onKey,
    onKeyUpCapture: $ae24328b820f957a$var$onKey,
    onTouchStartCapture: $ae24328b820f957a$var$abort,
    onTouchEndCapture: $ae24328b820f957a$var$abort,
    onPointerDownCapture: $ae24328b820f957a$var$abort,
    onPointerUpCapture: $ae24328b820f957a$var$abort,
    onClickCapture: $ae24328b820f957a$var$abort,
    // Just smashing the existing onClick for good measure
    onClick: $ae24328b820f957a$var$abort
};
var $ae24328b820f957a$var$doNotBlock = {};
function $ae24328b820f957a$export$2e2bcd8739ae039(_ref) {
    var isInteractive = _ref.isInteractive;
    return isInteractive ? $ae24328b820f957a$var$doNotBlock : $ae24328b820f957a$var$block;
}

});

parcelRegister("fMQHy", function(module, exports) {
$parcel$export(module.exports, "getContentStyle", () => $b7e4382131063548$export$7ad0316cc0dd65a);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $74Zh5 = parcelRequire("74Zh5");
function $b7e4382131063548$export$7ad0316cc0dd65a(_ref) {
    var spacing = _ref.spacing;
    return (0, $74Zh5.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        margin: spacing === 'none' ? 0 : '0 2px',
        // content can grow and shrink
        flexGrow: 1,
        flexShrink: 1,
        // ellipsis for overflow text
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap'
    });
}

});

parcelRegister("lJaij", function(module, exports) {
$parcel$export(module.exports, "getFadingCss", () => $fd15c92c8729cdb0$export$1b5827d324e945b1);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $74Zh5 = parcelRequire("74Zh5");
function $fd15c92c8729cdb0$export$1b5827d324e945b1(_ref) {
    var hasOverlay = _ref.hasOverlay;
    return (0, $74Zh5.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        opacity: hasOverlay ? 0 : 1,
        transition: 'opacity 0.3s'
    });
}

});

parcelRegister("4Vagz", function(module, exports) {
$parcel$export(module.exports, "getIconStyle", () => $395472f300854bad$export$864eea3f4ec3368f);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $74Zh5 = parcelRequire("74Zh5");
function $395472f300854bad$export$864eea3f4ec3368f(_ref) {
    var spacing = _ref.spacing;
    return (0, $74Zh5.css)({
        display: 'flex',
        // icon size cannot grow and shrink
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        margin: spacing === 'none' ? 0 : "0 2px",
        flexGrow: 0,
        flexShrink: 0,
        alignSelf: 'center',
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        fontSize: 0,
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        lineHeight: 0,
        userSelect: 'none'
    });
}

});

parcelRegister("i5DCW", function(module, exports) {
$parcel$export(module.exports, "getIfVisuallyHiddenChildren", () => $d2b76eb6926150cf$export$20bbd2efb0d734c4);

var $5FkrB = parcelRequire("5FkrB");

var $cd86S = parcelRequire("cd86S");
var $d2b76eb6926150cf$export$20bbd2efb0d734c4 = function getIfVisuallyHiddenChildren(children) {
    return children && /*#__PURE__*/ (0, $5FkrB.isValidElement)(children) && children.type === (0, $cd86S.default);
};

});

parcelRegister("2ires", function(module, exports) {
$parcel$export(module.exports, "overlayCss", () => $1ac262f2dddd0eff$export$1a9fe1b84c876bb5);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
var $1ac262f2dddd0eff$export$1a9fe1b84c876bb5 = {
    // stretching to full width / height of button
    // this is important as we need it to still block
    // event if clicking in the button's own padding
    position: 'absolute',
    left: 0,
    top: 0,
    right: 0,
    bottom: 0,
    // Putting all children in the center
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
};

});


parcelRegister("lqalz", function(module, exports) {
$parcel$export(module.exports, "getCss", () => $f9840d606ffe3e0e$export$955358618f994a11);

var $25nEq = parcelRequire("25nEq");

var $5VFxW = parcelRequire("5VFxW");
function $f9840d606ffe3e0e$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $f9840d606ffe3e0e$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $f9840d606ffe3e0e$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $f9840d606ffe3e0e$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $f9840d606ffe3e0e$var$gridSize = 8;
var $f9840d606ffe3e0e$var$HAS_DISABLED_BACKGROUND = [
    'default',
    'primary',
    'danger',
    'warning'
];
var $f9840d606ffe3e0e$var$heights = {
    default: "".concat(32 / 14, "em"),
    // 32px
    compact: "".concat(24 / 14, "em"),
    none: 'auto'
};
var $f9840d606ffe3e0e$var$lineHeights = {
    default: $f9840d606ffe3e0e$var$heights.default,
    compact: $f9840d606ffe3e0e$var$heights.compact,
    none: 'inherit'
};
var $f9840d606ffe3e0e$var$padding = {
    // 10px gutter
    default: "0 ".concat($f9840d606ffe3e0e$var$gridSize + $f9840d606ffe3e0e$var$gridSize / 4, "px"),
    compact: "0 ".concat($f9840d606ffe3e0e$var$gridSize + $f9840d606ffe3e0e$var$gridSize / 4, "px"),
    none: '0'
};
var $f9840d606ffe3e0e$var$singleIconPadding = {
    // 2px gutter
    compact: "0 ".concat($f9840d606ffe3e0e$var$gridSize / 4, "px"),
    default: "0 ".concat($f9840d606ffe3e0e$var$gridSize / 4, "px"),
    none: '0'
};
var $f9840d606ffe3e0e$var$verticalAlign = {
    default: 'middle',
    compact: 'middle',
    none: 'baseline'
};
var $f9840d606ffe3e0e$var$defaultAfterStyles = {
    borderRadius: 'inherit',
    inset: "var(--ds-space-0, 0px)",
    borderStyle: 'solid',
    borderWidth: "var(--ds-border-width, 1px)",
    pointerEvents: 'none',
    position: 'absolute'
};
var $f9840d606ffe3e0e$var$defaultStyles = {
    background: "var(--ds-background-neutral-subtle, #00000000)",
    color: "var(--ds-text, #292A2E)",
    '&::after': $f9840d606ffe3e0e$var$_objectSpread($f9840d606ffe3e0e$var$_objectSpread({}, $f9840d606ffe3e0e$var$defaultAfterStyles), {}, {
        content: '""',
        borderColor: "var(--ds-border, #0B120E24)"
    }),
    '&:hover': {
        background: "var(--ds-background-neutral-hovered, #0B120E24)"
    },
    '&:active': {
        background: "var(--ds-background-neutral-pressed, #080F214A)"
    },
    '&[data-has-overlay="true"]:not([disabled]):hover': {
        background: "var(--ds-background-neutral-subtle, #00000000)"
    },
    '&:disabled[disabled]': {
        background: "var(--ds-background-neutral-subtle, #00000000)"
    },
    '&:disabled[disabled]:hover': {
        background: "var(--ds-background-neutral-subtle, #00000000)"
    },
    '&:disabled[disabled]:active': {
        background: "var(--ds-background-neutral-subtle, #00000000)"
    }
};
var $f9840d606ffe3e0e$var$primaryStyles = {
    background: "var(--ds-background-brand-bold, #1868DB)",
    color: "var(--ds-text-inverse, #FFFFFF)",
    '&:hover': {
        background: "var(--ds-background-brand-bold-hovered, #1558BC)"
    },
    '&:active': {
        background: "var(--ds-background-brand-bold-pressed, #144794)"
    },
    '&[data-has-overlay="true"]:not([disabled]):hover': {
        background: "var(--ds-background-brand-bold, #1868DB)"
    }
};
var $f9840d606ffe3e0e$var$linkStyles = {
    background: 'transparent',
    color: "var(--ds-link, #1868DB)",
    '&:hover': {
        color: "var(--ds-link, #1868DB)",
        textDecoration: 'underline'
    },
    '&:active': {
        color: "var(--ds-link-pressed, #1558BC)",
        textDecoration: 'underline'
    }
};
var $f9840d606ffe3e0e$var$subtleStyles = {
    background: 'transparent',
    color: "var(--ds-text-subtle, #505258)",
    '&:hover': {
        background: "var(--ds-background-neutral-subtle-hovered, #0515240F)"
    },
    '&:active': {
        background: "var(--ds-background-neutral-subtle-pressed, #0B120E24)"
    },
    '&[data-has-overlay="true"]:not([disabled]):hover': {
        background: 'transparent'
    }
};
var $f9840d606ffe3e0e$var$subtleLinkStyles = {
    background: 'transparent',
    color: "var(--ds-text-subtle, #505258)",
    '&:hover': {
        background: 'transparent',
        color: "var(--ds-text-subtle, #505258)",
        textDecoration: 'underline'
    },
    '&:active': {
        background: 'transparent',
        color: "var(--ds-text, #292A2E)",
        textDecoration: 'underline'
    }
};
var $f9840d606ffe3e0e$var$warningStyles = {
    background: "var(--ds-background-warning-bold, #FBC828)",
    color: "var(--ds-text-warning-inverse, #292A2E)",
    '&:hover': {
        background: "var(--ds-background-warning-bold-hovered, #FCA700)"
    },
    '&:active': {
        background: "var(--ds-background-warning-bold-pressed, #F68909)"
    },
    '&[data-has-overlay="true"]:not([disabled]):hover': {
        background: "var(--ds-background-warning-bold, #FBC828)"
    }
};
var $f9840d606ffe3e0e$var$dangerStyles = {
    background: "var(--ds-background-danger-bold, #C9372C)",
    color: "var(--ds-text-inverse, #FFFFFF)",
    '&:hover': {
        background: "var(--ds-background-danger-bold-hovered, #AE2E24)"
    },
    '&:active': {
        background: "var(--ds-background-danger-bold-pressed, #872821)"
    },
    '&[data-has-overlay="true"]:not([disabled]):hover': {
        background: "var(--ds-background-danger-bold, #C9372C)"
    }
};
var $f9840d606ffe3e0e$var$selectedStyles = {
    background: "var(--ds-background-selected, #E9F2FE)",
    color: "var(--ds-text-selected, #1868DB)",
    '&:not([disabled])::after': $f9840d606ffe3e0e$var$_objectSpread($f9840d606ffe3e0e$var$_objectSpread({}, $f9840d606ffe3e0e$var$defaultAfterStyles), {}, {
        content: '""',
        borderColor: "var(--ds-border-selected, #1868DB)"
    })
};
var $f9840d606ffe3e0e$var$hasOverlayStyles = {
    '&[data-has-overlay="true"]': {
        cursor: 'default',
        textDecoration: 'none'
    }
};
function $f9840d606ffe3e0e$export$955358618f994a11(_ref) {
    var appearance = _ref.appearance, spacing = _ref.spacing, isSelected = _ref.isSelected, shouldFitContainer = _ref.shouldFitContainer, isOnlySingleIcon = _ref.isOnlySingleIcon;
    return $f9840d606ffe3e0e$var$_objectSpread($f9840d606ffe3e0e$var$_objectSpread({
        // 0px margin added to css-reset
        alignItems: 'baseline',
        borderWidth: 0,
        borderRadius: (0, $5VFxW.fg)('platform-dst-shape-theme-default') ? "var(--ds-radius-medium, 6px)" : "var(--ds-radius-small, 3px)",
        boxSizing: 'border-box',
        display: 'inline-flex',
        fontSize: 'inherit',
        fontStyle: 'normal',
        // Chrome recently changed button so that they use 'arial' as the font family
        fontFamily: 'inherit',
        fontWeight: "var(--ds-font-weight-medium, 500)",
        // margin for button has been applied to css reset
        maxWidth: '100%',
        // Needed to position overlay
        position: 'relative',
        textAlign: 'center',
        textDecoration: 'none',
        transition: 'background 0.1s ease-out, box-shadow 0.15s cubic-bezier(0.47, 0.03, 0.49, 1.38)',
        whiteSpace: 'nowrap',
        cursor: 'pointer',
        height: $f9840d606ffe3e0e$var$heights[spacing],
        lineHeight: $f9840d606ffe3e0e$var$lineHeights[spacing],
        padding: isOnlySingleIcon ? $f9840d606ffe3e0e$var$singleIconPadding[spacing] : $f9840d606ffe3e0e$var$padding[spacing],
        verticalAlign: $f9840d606ffe3e0e$var$verticalAlign[spacing],
        width: shouldFitContainer ? '100%' : 'auto',
        // justifyContent required for shouldFitContainer buttons with an icon inside
        justifyContent: 'center'
    }, isSelected ? $f9840d606ffe3e0e$var$selectedStyles : $f9840d606ffe3e0e$var$_objectSpread($f9840d606ffe3e0e$var$_objectSpread($f9840d606ffe3e0e$var$_objectSpread($f9840d606ffe3e0e$var$_objectSpread($f9840d606ffe3e0e$var$_objectSpread($f9840d606ffe3e0e$var$_objectSpread($f9840d606ffe3e0e$var$_objectSpread($f9840d606ffe3e0e$var$_objectSpread({}, appearance === 'default' && $f9840d606ffe3e0e$var$defaultStyles), appearance === 'primary' && $f9840d606ffe3e0e$var$primaryStyles), appearance === 'link' && $f9840d606ffe3e0e$var$linkStyles), appearance === 'subtle' && $f9840d606ffe3e0e$var$subtleStyles), appearance === 'subtle-link' && $f9840d606ffe3e0e$var$subtleLinkStyles), appearance === 'warning' && $f9840d606ffe3e0e$var$warningStyles), appearance === 'danger' && $f9840d606ffe3e0e$var$dangerStyles), {}, {
        '&[disabled]': {
            color: "var(--ds-text-disabled, #080F214A)",
            backgroundColor: $f9840d606ffe3e0e$var$HAS_DISABLED_BACKGROUND.includes(appearance) ? "var(--ds-background-disabled, #0515240F)" : 'transparent',
            cursor: 'not-allowed',
            textDecoration: 'none',
            '&:hovered': {
                backgroundColor: $f9840d606ffe3e0e$var$HAS_DISABLED_BACKGROUND.includes(appearance) ? "var(--ds-background-disabled, #0515240F)" : 'transparent'
            },
            '&:active': {
                backgroundColor: $f9840d606ffe3e0e$var$HAS_DISABLED_BACKGROUND.includes(appearance) ? "var(--ds-background-disabled, #0515240F)" : 'transparent'
            }
        }
    }, $f9840d606ffe3e0e$var$hasOverlayStyles)), {}, {
        '&::-moz-focus-inner': {
            border: 0,
            margin: 0,
            padding: 0
        }
    });
}

});

parcelRegister("8BW8f", function(module, exports) {
$parcel$export(module.exports, "default", () => $644edf4202b30e7b$export$2e2bcd8739ae039);

var $i5DCW = parcelRequire("i5DCW");
function $644edf4202b30e7b$export$2e2bcd8739ae039(_ref) {
    var children = _ref.children, iconBefore = _ref.iconBefore, iconAfter = _ref.iconAfter;
    if ((0, $i5DCW.getIfVisuallyHiddenChildren)(children)) return true;
    if (children) return false;
    if (iconBefore && !iconAfter) return true;
    if (!iconBefore && iconAfter) return true;
    return false;
}

});


parcelRegister("hO72L", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::976c79b56a8fa85b795a69d54376c6cc>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $cf6c91e93b76cf43$var$_react = $cf6c91e93b76cf43$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $cf6c91e93b76cf43$var$_baseNew = $cf6c91e93b76cf43$var$_interopRequireDefault((parcelRequire("xN3u9")));
function $cf6c91e93b76cf43$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "DragHandleVertical".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for dragging elements along a vertical axis.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $cf6c91e93b76cf43$var$DragHandleVerticalIcon = (props)=>/*#__PURE__*/ $cf6c91e93b76cf43$var$_react.default.createElement($cf6c91e93b76cf43$var$_baseNew.default, Object.assign({
        name: "DragHandleVerticalIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M7 2.75a1.75 1.75 0 1 1-3.5 0 1.75 1.75 0 0 1 3.5 0m5.5 0a1.75 1.75 0 1 1-3.5 0 1.75 1.75 0 0 1 3.5 0M7 8a1.75 1.75 0 1 1-3.5 0A1.75 1.75 0 0 1 7 8m5.5 0A1.75 1.75 0 1 1 9 8a1.75 1.75 0 0 1 3.5 0M7 13.25a1.75 1.75 0 1 1-3.5 0 1.75 1.75 0 0 1 3.5 0m5.5 0a1.75 1.75 0 1 1-3.5 0 1.75 1.75 0 0 1 3.5 0"/>`
    }, props));
$cf6c91e93b76cf43$var$DragHandleVerticalIcon.displayName = 'DragHandleVerticalIcon';
var $cf6c91e93b76cf43$var$_default = module.exports.default = $cf6c91e93b76cf43$var$DragHandleVerticalIcon;

});

parcelRegister("d90PQ", function(module, exports) {
$parcel$export(module.exports, "SortIcon", () => $991cc3793dda819b$export$72820c4f313d7b94);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5FkrB = parcelRequire("5FkrB");

var $74Zh5 = parcelRequire("74Zh5");

var $40CRM = parcelRequire("40CRM");

var $6Xw9w = parcelRequire("6Xw9w");
var $991cc3793dda819b$var$styles = (0, $74Zh5.css)({
    display: 'flex',
    alignSelf: 'center',
    opacity: 1,
    transition: 'opacity 100ms ease-in-out'
});
var $991cc3793dda819b$var$SortableIconClassName = 'sortable-icon';
var $991cc3793dda819b$export$72820c4f313d7b94 = /*#__PURE__*/ (0, $5FkrB.memo)(function(_ref) {
    var sortDirection = _ref.sortDirection, isCurrentSort = _ref.isCurrentSort;
    var primaryColor = isCurrentSort ? "var(--ds-icon-brand, #1868DB)" : "var(--ds-text-disabled, #080F214A)";
    var showSortUp = !isCurrentSort || isCurrentSort && sortDirection === 'asc';
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    (0, $74Zh5.jsx)("span", {
        css: $991cc3793dda819b$var$styles,
        className: $991cc3793dda819b$var$SortableIconClassName
    }, showSortUp ? (0, $74Zh5.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6Xw9w))), {
        label: "ascending",
        color: primaryColor,
        spacing: "compact",
        size: "small"
    }) : (0, $74Zh5.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($40CRM))), {
        label: "descending",
        color: primaryColor,
        spacing: "compact",
        size: "small"
    })));
});

});
parcelRegister("40CRM", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::fcfd9fc2877ad309c8a5d6e5d6ea9482>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2eb54f9733098b02$var$_react = $2eb54f9733098b02$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $2eb54f9733098b02$var$_baseNew = $2eb54f9733098b02$var$_interopRequireDefault((parcelRequire("xN3u9")));
function $2eb54f9733098b02$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ArrowDown".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Know uses: sorting table headers or Bitbucket code difference.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $2eb54f9733098b02$var$ArrowDownIcon = (props)=>/*#__PURE__*/ $2eb54f9733098b02$var$_react.default.createElement($2eb54f9733098b02$var$_baseNew.default, Object.assign({
        name: "ArrowDownIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8.75 1v11.44l3.72-3.72 1.06 1.06-5 5a.75.75 0 0 1-1.06 0l-5-5 1.06-1.06 3.72 3.72V1z" clip-rule="evenodd"/>`
    }, props));
$2eb54f9733098b02$var$ArrowDownIcon.displayName = 'ArrowDownIcon';
var $2eb54f9733098b02$var$_default = module.exports.default = $2eb54f9733098b02$var$ArrowDownIcon;

});

parcelRegister("6Xw9w", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::be13ec6c7b346b13ffda97746cc85c67>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $51113197a450847f$var$_react = $51113197a450847f$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $51113197a450847f$var$_baseNew = $51113197a450847f$var$_interopRequireDefault((parcelRequire("xN3u9")));
function $51113197a450847f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ArrowUp".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: back to top.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $51113197a450847f$var$ArrowUpIcon = (props)=>/*#__PURE__*/ $51113197a450847f$var$_react.default.createElement($51113197a450847f$var$_baseNew.default, Object.assign({
        name: "ArrowUpIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8.75 15V3.56l3.72 3.72 1.06-1.06-5-5a.75.75 0 0 0-1.06 0l-5 5 1.06 1.06 3.72-3.72V15z" clip-rule="evenodd"/>`
    }, props));
$51113197a450847f$var$ArrowUpIcon.displayName = 'ArrowUpIcon';
var $51113197a450847f$var$_default = module.exports.default = $51113197a450847f$var$ArrowUpIcon;

});


parcelRegister("ltx6p", function(module, exports) {

var $iKwew = parcelRequire("iKwew");
module.exports = Promise.all([
    $iKwew("4xOaE"),
    $iKwew("abGR0")
]).then(()=>parcelRequire('jG848'));

});


parcelRegister("cvf3Z", function(module, exports) {
$parcel$export(module.exports, "TBody", () => $91a4108fe41094fe$export$7005b8a93a167348);
/* body.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $kqp0i = parcelRequire("kqp0i");

var $1Vcia = parcelRequire("1Vcia");


var $5FkrB = parcelRequire("5FkrB");

var $hRJ5R = parcelRequire("hRJ5R");

var $ioSmZ = parcelRequire("ioSmZ");
var $91a4108fe41094fe$var$_excluded = [
    "children",
    "xcss"
];
var $91a4108fe41094fe$var$bodyStyles = {
    root: "_19itglyw _kqswh2mm"
};
var $91a4108fe41094fe$export$7005b8a93a167348 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).forwardRef(function(_ref, ref) {
    var children = _ref.children, customXcss = _ref.xcss, props = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $91a4108fe41094fe$var$_excluded);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $ioSmZ.TBody), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        xcss: (0, $hRJ5R.cx)($91a4108fe41094fe$var$bodyStyles.root, customXcss),
        ref: ref
    }, props), children);
});

});
parcelRegister("ioSmZ", function(module, exports) {
$parcel$export(module.exports, "TBody", () => $d654a495d42662e1$export$7005b8a93a167348);

var $kqp0i = parcelRequire("kqp0i");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");

var $1JA0K = parcelRequire("1JA0K");
var $d654a495d42662e1$var$_excluded = [
    "children"
];
var $d654a495d42662e1$export$7005b8a93a167348 = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function(_ref, ref) {
    var children = _ref.children, props = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $d654a495d42662e1$var$_excluded);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $1JA0K.default), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        as: "tbody"
    }, props, {
        ref: ref
    }), children);
});

});


parcelRegister("bF0W9", function(module, exports) {
$parcel$export(module.exports, "Row", () => $87d440196703d7b8$export$b59bdbef9ce70de2);

var $kqp0i = parcelRequire("kqp0i");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");

var $7Cqku = parcelRequire("7Cqku");

var $5THOi = parcelRequire("5THOi");
var $87d440196703d7b8$var$_excluded = [
    "children",
    "testId",
    "spacing",
    "xcss",
    "isSelected"
];
var $87d440196703d7b8$var$bodyRowStyles = (0, $7Cqku.xcss)({
    height: '44px',
    ':hover': {
        backgroundColor: 'elevation.surface.raised.hovered'
    },
    ':focus-visible::after': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
        boxShadow: undefined
    },
    position: 'relative',
    border: 'none',
    borderImageWidth: 0,
    borderSpacing: 0,
    backgroundColor: 'elevation.surface'
});
var $87d440196703d7b8$var$compactRow = (0, $7Cqku.xcss)({
    height: '36px' //replace with size tokens when released
});
var $87d440196703d7b8$export$b59bdbef9ce70de2 = /*#__PURE__*/ (0, $5FkrB.memo)(/*#__PURE__*/ (0, $5FkrB.forwardRef)(function(_ref, ref) {
    var children = _ref.children, testId = _ref.testId, spacing = _ref.spacing, customXcss = _ref.xcss, isSelected = _ref.isSelected, props = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $87d440196703d7b8$var$_excluded);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $5THOi.TR), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        ref: ref,
        isSelected: isSelected,
        testId: testId,
        xcss: [
            $87d440196703d7b8$var$bodyRowStyles,
            spacing === 'compact' && $87d440196703d7b8$var$compactRow,
            customXcss
        ]
    }, props), children);
}));

});

parcelRegister("a36et", function(module, exports) {
$parcel$export(module.exports, "RowCell", () => $750f04d256cf0537$export$502da2b9cfd708e5);

var $kqp0i = parcelRequire("kqp0i");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");

var $7Cqku = parcelRequire("7Cqku");

var $f20te = parcelRequire("f20te");

var $9TAkY = parcelRequire("9TAkY");
var $750f04d256cf0537$var$_excluded = [
    "children",
    "testId",
    "xcss",
    "tableType"
];
var $750f04d256cf0537$var$InputCellStyle = (0, $7Cqku.xcss)({
    borderInlineEndWidth: 'border.width',
    borderInlineEndStyle: 'solid',
    borderColor: 'color.border'
});
var $750f04d256cf0537$var$InventoryCellStyle = (0, $7Cqku.xcss)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    ':last-of-type': {
        borderInlineEndWidth: 'border.width',
        borderInlineEndStyle: 'solid',
        borderColor: 'color.border'
    }
});
var $750f04d256cf0537$var$RowCellStyle = (0, $7Cqku.xcss)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    ':first-of-type': {
        paddingInlineStart: 'space.200',
        borderInlineStartWidth: 'border.width',
        borderInlineStartStyle: 'solid',
        borderColor: 'color.border',
        paddingBlock: 'space.0'
    },
    paddingInlineStart: 'space.200',
    borderBlockEndWidth: 'border.width',
    borderBlockEndStyle: 'solid',
    paddingBlock: 'space.0',
    borderColor: 'color.border',
    whiteSpace: 'nowrap',
    background: 'inherit'
});
var $750f04d256cf0537$export$502da2b9cfd708e5 = /*#__PURE__*/ (0, $5FkrB.memo)(/*#__PURE__*/ (0, $5FkrB.forwardRef)(function(_ref, ref) {
    var children = _ref.children, testId = _ref.testId, customXcss = _ref.xcss, _ref$tableType = _ref.tableType, tableType = _ref$tableType === void 0 ? (0, $9TAkY.TableType).input : _ref$tableType, props = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $750f04d256cf0537$var$_excluded);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $f20te.TD), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        testId: testId,
        xcss: [
            $750f04d256cf0537$var$RowCellStyle,
            tableType === (0, $9TAkY.TableType).inventory && $750f04d256cf0537$var$InventoryCellStyle,
            tableType === (0, $9TAkY.TableType).input && $750f04d256cf0537$var$InputCellStyle,
            // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- this is inline with what atlaskit primitives do.
            customXcss
        ],
        ref: ref
    }, props), children);
}));

});

parcelRegister("iQ45V", function(module, exports) {
$parcel$export(module.exports, "Table", () => $db7042690b9df762$export$54ec01a60f47d33d);

var $kqp0i = parcelRequire("kqp0i");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");

var $ifySV = parcelRequire("ifySV");
var $db7042690b9df762$var$_excluded = [
    "children",
    "testId",
    "xcss"
];
var $db7042690b9df762$export$54ec01a60f47d33d = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function(_ref, ref) {
    var children = _ref.children, testId = _ref.testId, customXcss = _ref.xcss, props = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $db7042690b9df762$var$_excluded);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $ifySV.Table), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        testId: testId,
        xcss: customXcss,
        ref: ref
    }, props), children);
});

});
parcelRegister("ifySV", function(module, exports) {
$parcel$export(module.exports, "Table", () => $d494b022b6210e7c$export$54ec01a60f47d33d);

var $kqp0i = parcelRequire("kqp0i");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");

var $kZC4L = parcelRequire("kZC4L");
var $d494b022b6210e7c$var$_excluded = [
    "children",
    "testId"
];
var $d494b022b6210e7c$export$54ec01a60f47d33d = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function(_ref, ref) {
    var children = _ref.children, testId = _ref.testId, props = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $d494b022b6210e7c$var$_excluded);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $kZC4L.default), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        as: "table",
        testId: testId,
        ref: ref
    }, props), children);
});

});


parcelRegister("eYe65", function(module, exports) {
$parcel$export(module.exports, "THead", () => $ae619ab5cc17c151$export$c4c2bc57f2e82919);

var $kqp0i = parcelRequire("kqp0i");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");

var $7Cqku = parcelRequire("7Cqku");

var $35qld = parcelRequire("35qld");
var $ae619ab5cc17c151$var$_excluded = [
    "children",
    "xcss"
];
var $ae619ab5cc17c151$var$THeadBaseStyles = (0, $7Cqku.xcss)({
    position: 'sticky',
    //@ts-expect-error suggested options do not have value equivalent to 2
    zIndex: 2,
    inset: 'space.0',
    border: 'none',
    backgroundColor: 'color.background.input.hovered',
    borderTopLeftRadius: 'radius.large',
    borderTopRightRadius: 'radius.large',
    overflow: 'hidden',
    '::before': {
        content: '""',
        position: 'absolute',
        top: 'space.0',
        left: 'space.0',
        backgroundColor: 'color.background.neutral'
    }
});
var $ae619ab5cc17c151$export$c4c2bc57f2e82919 = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function(_ref, ref) {
    var children = _ref.children, customXcss = _ref.xcss, props = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $ae619ab5cc17c151$var$_excluded);
    return(/*#__PURE__*/ // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- this is inline with what atlaskit primitives do.
    (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $35qld.THead), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        xcss: [
            $ae619ab5cc17c151$var$THeadBaseStyles,
            customXcss
        ],
        ref: ref
    }, props), children));
});

});
parcelRegister("35qld", function(module, exports) {
$parcel$export(module.exports, "THead", () => $23f645897ffb54bf$export$c4c2bc57f2e82919);

var $kqp0i = parcelRequire("kqp0i");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");

var $kZC4L = parcelRequire("kZC4L");
var $23f645897ffb54bf$var$_excluded = [
    "children"
];
var $23f645897ffb54bf$export$c4c2bc57f2e82919 = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function(_ref, ref) {
    var children = _ref.children, props = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $23f645897ffb54bf$var$_excluded);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $kZC4L.default), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        as: "thead"
    }, props, {
        ref: ref
    }), children);
});

});


parcelRegister("4Aklk", function(module, exports) {
$parcel$export(module.exports, "useConvertCharlieTableToTanStack", () => $356a4de9cad863bf$export$c430cf84aab272ac);

var $25nEq = parcelRequire("25nEq");

var $5FkrB = parcelRequire("5FkrB");

var $e6OxX = parcelRequire("e6OxX");

var $ekACv = parcelRequire("ekACv");
function $356a4de9cad863bf$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $356a4de9cad863bf$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $356a4de9cad863bf$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $356a4de9cad863bf$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $356a4de9cad863bf$export$c430cf84aab272ac = function useConvertCharlieTableToTanStack(options) {
    var _options$initialState, _options$initialState2, _options$initialState3, _options$initialState4, _options$initialState5, _options$initialState6, _options$initialState7, _options$initialState8, _options$initialState9, _options$initialState0, _options$initialState1, _options$initialState10, _options$initialState11, _options$initialState12, _options$initialState13, _options$initialState14, _options$state2, _options$state3, _options$state$column, _options$state5, _options$state6, _options$state7, _options$state8, _options$state9, _options$state0, _options$state1, _options$state10, _options$state11, _options$state12, _options$state13, _options$state14, _options$state15, _options$state16, _options$state17, _options$defaultColum, _options$defaultColum2, _options$defaultColum3, _options$enableSortin;
    var columnHelper = (0, $e6OxX.createColumnHelper)();
    var stableEmptyTanArray = (0, $5FkrB.useMemo)(function() {
        return [];
    }, []);
    var stableEmptyCharlesArray = (0, $5FkrB.useMemo)(function() {
        return [];
    }, []);
    var mapRowsToData = (0, $5FkrB.useCallback)(function(rows) {
        return rows.map(function(row) {
            return $356a4de9cad863bf$var$_objectSpread($356a4de9cad863bf$var$_objectSpread({}, row.data), {}, {
                isExpandable: row.isExpandable,
                isDefaultExpanded: row.isDefaultExpanded,
                isDisabled: row.isDisabled,
                isHidden: row.isHidden,
                groupKey: row.groupKey,
                groupValue: row.groupValue,
                overrideRender: row.overrideRender,
                subRows: row.subRows ? mapRowsToData(row.subRows) : undefined
            });
        });
    }, []);
    var mappedRowToData = (0, $5FkrB.useMemo)(function() {
        var _options$rows;
        return mapRowsToData((_options$rows = options.rows) !== null && _options$rows !== void 0 ? _options$rows : stableEmptyCharlesArray);
    }, [
        mapRowsToData,
        options.rows,
        stableEmptyCharlesArray
    ]);
    // Memoize columns
    var memoizedColumns = (0, $5FkrB.useMemo)(function() {
        var _options$columnDefs, _options$columns;
        return (_options$columnDefs = options.columnDefs) !== null && _options$columnDefs !== void 0 ? _options$columnDefs : (_options$columns = options.columns) === null || _options$columns === void 0 ? void 0 : _options$columns.map(function(oldColumn) {
            if ($356a4de9cad863bf$var$isCharlieTableColumn(oldColumn)) return columnHelper.accessor(function(row) {
                return row;
            }, {
                id: oldColumn.key,
                enableSorting: oldColumn.isSortable,
                header: function header() {
                    return oldColumn.content;
                },
                minSize: oldColumn.minWidth,
                size: oldColumn.width,
                maxSize: oldColumn.maxWidth,
                cell: function cell(props) {
                    return oldColumn.cell.render(props.getValue());
                },
                meta: {
                    description: oldColumn.description,
                    sortDescription: oldColumn.sortDescription
                }
            });
            return oldColumn;
        });
    }, [
        columnHelper,
        options.columns,
        options.columnDefs
    ]);
    var data = (0, $5FkrB.useMemo)(function() {
        var _options$data;
        return $356a4de9cad863bf$var$hasCharlieParam(options, 'rows') ? mappedRowToData : (_options$data = options.data) !== null && _options$data !== void 0 ? _options$data : stableEmptyTanArray;
    }, [
        options,
        mappedRowToData,
        stableEmptyTanArray
    ]);
    var sortingOption = $356a4de9cad863bf$var$hasTanstackParam(options, 'onSortingChange') ? {
        onSortingChange: options.onSortingChange
    } : $356a4de9cad863bf$var$hasCharlieParam(options, 'onSortChange') ? {
        onSortingChange: $356a4de9cad863bf$var$handleSortChange(options)
    } : {};
    // Convert CharlieTableHook options to TanStack TableOptions
    // @ts-expect-error have to translate between types. will be deleted
    var tanStackOptions = $356a4de9cad863bf$var$_objectSpread($356a4de9cad863bf$var$_objectSpread($356a4de9cad863bf$var$_objectSpread($356a4de9cad863bf$var$_objectSpread($356a4de9cad863bf$var$_objectSpread($356a4de9cad863bf$var$_objectSpread($356a4de9cad863bf$var$_objectSpread($356a4de9cad863bf$var$_objectSpread($356a4de9cad863bf$var$_objectSpread($356a4de9cad863bf$var$_objectSpread($356a4de9cad863bf$var$_objectSpread($356a4de9cad863bf$var$_objectSpread($356a4de9cad863bf$var$_objectSpread($356a4de9cad863bf$var$_objectSpread($356a4de9cad863bf$var$_objectSpread($356a4de9cad863bf$var$_objectSpread($356a4de9cad863bf$var$_objectSpread($356a4de9cad863bf$var$_objectSpread($356a4de9cad863bf$var$_objectSpread({}, options), {}, {
        columns: memoizedColumns !== null && memoizedColumns !== void 0 ? memoizedColumns : [],
        //move this to its own function for memo
        data: data,
        //move this to its own function for memo
        initialState: $356a4de9cad863bf$var$_objectSpread($356a4de9cad863bf$var$_objectSpread($356a4de9cad863bf$var$_objectSpread($356a4de9cad863bf$var$_objectSpread($356a4de9cad863bf$var$_objectSpread($356a4de9cad863bf$var$_objectSpread($356a4de9cad863bf$var$_objectSpread($356a4de9cad863bf$var$_objectSpread({}, ((_options$initialState = options.initialState) === null || _options$initialState === void 0 ? void 0 : _options$initialState.columnOrder) && {
            columnOrder: (_options$initialState2 = options.initialState) === null || _options$initialState2 === void 0 ? void 0 : _options$initialState2.columnOrder,
            columnVisibility: (_options$initialState3 = options.initialState.columnVisibility) !== null && _options$initialState3 !== void 0 ? _options$initialState3 : memoizedColumns === null || memoizedColumns === void 0 ? void 0 : memoizedColumns.reduce(function(acc, col) {
                if (col.id) {
                    var _options$state;
                    if ((_options$state = options.state) !== null && _options$state !== void 0 && (_options$state = _options$state.columnOrder) !== null && _options$state !== void 0 && _options$state.includes(col.id)) acc[col.id] = true; // Set all columns to visible by default
                    else acc[col.id] = false;
                }
                return acc;
            }, {})
        }), ((_options$initialState4 = options.initialState) === null || _options$initialState4 === void 0 ? void 0 : _options$initialState4.columnVisibility) && {
            columnVisibility: options.initialState.columnVisibility
        }), ((_options$initialState5 = options.initialState) === null || _options$initialState5 === void 0 ? void 0 : _options$initialState5.sorting) && {
            sorting: $356a4de9cad863bf$var$convertToSortingState((_options$initialState6 = options.initialState) === null || _options$initialState6 === void 0 ? void 0 : _options$initialState6.sorting)
        }), ((_options$initialState7 = options.initialState) === null || _options$initialState7 === void 0 ? void 0 : _options$initialState7.expanded) && {
            expanded: (_options$initialState8 = options.initialState) === null || _options$initialState8 === void 0 ? void 0 : _options$initialState8.expanded
        }), ((_options$initialState9 = options.initialState) === null || _options$initialState9 === void 0 ? void 0 : _options$initialState9.rowSelection) && {
            rowSelection: (_options$initialState0 = options.initialState) === null || _options$initialState0 === void 0 ? void 0 : _options$initialState0.rowSelection
        }), ((_options$initialState1 = options.initialState) === null || _options$initialState1 === void 0 ? void 0 : _options$initialState1.columnWidths) && {
            columnSizing: (_options$initialState10 = options.initialState) === null || _options$initialState10 === void 0 ? void 0 : _options$initialState10.columnWidths
        }), ((_options$initialState11 = options.initialState) === null || _options$initialState11 === void 0 ? void 0 : _options$initialState11.columnSizing) && {
            columnSizing: (_options$initialState12 = options.initialState) === null || _options$initialState12 === void 0 ? void 0 : _options$initialState12.columnSizing
        }), ((_options$initialState13 = options.initialState) === null || _options$initialState13 === void 0 ? void 0 : _options$initialState13.columnPinning) && {
            columnPinning: $356a4de9cad863bf$var$convertToColumnPinningState((_options$initialState14 = options.initialState) === null || _options$initialState14 === void 0 ? void 0 : _options$initialState14.columnPinning)
        }),
        state: $356a4de9cad863bf$var$_objectSpread($356a4de9cad863bf$var$_objectSpread($356a4de9cad863bf$var$_objectSpread($356a4de9cad863bf$var$_objectSpread($356a4de9cad863bf$var$_objectSpread($356a4de9cad863bf$var$_objectSpread($356a4de9cad863bf$var$_objectSpread($356a4de9cad863bf$var$_objectSpread($356a4de9cad863bf$var$_objectSpread($356a4de9cad863bf$var$_objectSpread({}, ((_options$state2 = options.state) === null || _options$state2 === void 0 ? void 0 : _options$state2.columnOrder) && {
            columnOrder: (_options$state3 = options.state) === null || _options$state3 === void 0 ? void 0 : _options$state3.columnOrder,
            columnVisibility: (_options$state$column = options.state.columnVisibility) !== null && _options$state$column !== void 0 ? _options$state$column : memoizedColumns === null || memoizedColumns === void 0 ? void 0 : memoizedColumns.reduce(function(acc, col) {
                if (col.id) {
                    var _options$state4;
                    if ((_options$state4 = options.state) !== null && _options$state4 !== void 0 && (_options$state4 = _options$state4.columnOrder) !== null && _options$state4 !== void 0 && _options$state4.includes(col.id)) acc[col.id] = true; // Set all columns to visible by default
                    else acc[col.id] = false;
                }
                return acc;
            }, {})
        }), ((_options$state5 = options.state) === null || _options$state5 === void 0 ? void 0 : _options$state5.columnVisibility) && {
            columnVisibility: options.state.columnVisibility
        }), ((_options$state6 = options.state) === null || _options$state6 === void 0 ? void 0 : _options$state6.sorting) && {
            sorting: $356a4de9cad863bf$var$convertToSortingState((_options$state7 = options.state) === null || _options$state7 === void 0 ? void 0 : _options$state7.sorting)
        }), ((_options$state8 = options.state) === null || _options$state8 === void 0 ? void 0 : _options$state8.expanded) && {
            expanded: (_options$state9 = options.state) === null || _options$state9 === void 0 ? void 0 : _options$state9.expanded
        }), ((_options$state0 = options.state) === null || _options$state0 === void 0 ? void 0 : _options$state0.rowSelection) && {
            rowSelection: (_options$state1 = options.state) === null || _options$state1 === void 0 ? void 0 : _options$state1.rowSelection
        }), ((_options$state10 = options.state) === null || _options$state10 === void 0 ? void 0 : _options$state10.columnWidths) && {
            columnSizing: (_options$state11 = options.state) === null || _options$state11 === void 0 ? void 0 : _options$state11.columnWidths
        }), ((_options$state12 = options.state) === null || _options$state12 === void 0 ? void 0 : _options$state12.columnSizing) && {
            columnSizing: (_options$state13 = options.state) === null || _options$state13 === void 0 ? void 0 : _options$state13.columnSizing
        }), ((_options$state14 = options.state) === null || _options$state14 === void 0 ? void 0 : _options$state14.grouping) && {
            grouping: options.state.grouping
        }), ((_options$state15 = options.state) === null || _options$state15 === void 0 ? void 0 : _options$state15.columnPinning) && {
            columnPinning: $356a4de9cad863bf$var$convertToColumnPinningState((_options$state16 = options.state) === null || _options$state16 === void 0 ? void 0 : _options$state16.columnPinning)
        }), ((_options$state17 = options.state) === null || _options$state17 === void 0 ? void 0 : _options$state17.columnVisibility) && {
            columnVisibility: options.state.columnVisibility
        })
    }, options.onColumnOrderChange && {
        onColumnOrderChange: options.onColumnOrderChange
    }), sortingOption), $356a4de9cad863bf$var$hasCharlieParam(options, 'defaultColumnWidths') && {
        defaultColumn: {
            size: (_options$defaultColum = options.defaultColumnWidths) === null || _options$defaultColum === void 0 ? void 0 : _options$defaultColum.width,
            maxSize: (_options$defaultColum2 = options.defaultColumnWidths) === null || _options$defaultColum2 === void 0 ? void 0 : _options$defaultColum2.maxWidth,
            minSize: (_options$defaultColum3 = options.defaultColumnWidths) === null || _options$defaultColum3 === void 0 ? void 0 : _options$defaultColum3.minWidth
        }
    }), $356a4de9cad863bf$var$hasCharlieParam(options, 'onSelectionChange') && {
        onRowSelectionChange: options.onSelectionChange
    }), $356a4de9cad863bf$var$hasCharlieParam(options, 'onColumnWidthsChange') && {
        onColumnSizingChange: options.onColumnWidthsChange
    }), $356a4de9cad863bf$var$hasCharlieParam(options, 'rows') && $356a4de9cad863bf$var$hasCharlieParam(options, 'getRowId') && {
        // @ts-expect-error deleting once charliehook is deprecated
        getRowId: function getRowId(row, index) {
            return options.getRowId({
                row: {
                    data: row
                },
                index: index
            });
        }
    }), $356a4de9cad863bf$var$hasCharlieParam(options, 'rows') && {
        getSubRows: function getSubRows(row) {
            return row.subRows;
        }
    }), $356a4de9cad863bf$var$hasCharlieParam(options, 'onExpandChange') && {
        onExpandedChange: options.onExpandChange
    }), $356a4de9cad863bf$var$hasCharlieParam(options, 'rows') && {
        //@ts-expect-error deleting once charliehook is deprecated
        getRowCanExpand: function getRowCanExpand(row) {
            return row.original.isExpandable === true;
        }
    }), $356a4de9cad863bf$var$hasTanstackParam(options, 'onRowSelectionChange') && {
        onRowSelectionChange: options.onRowSelectionChange
    }), $356a4de9cad863bf$var$hasTanstackParam(options, 'onColumnSizingChange') && {
        onColumnSizingChange: options.onColumnSizingChange
    }), $356a4de9cad863bf$var$hasTanstackParam(options, 'getSubRows') && !$356a4de9cad863bf$var$hasCharlieParam(options, 'rows') && {
        getSubRows: options.getSubRows
    }), $356a4de9cad863bf$var$hasTanstackParam(options, 'defaultColumn') && {
        defaultColumn: options.defaultColumn
    }), $356a4de9cad863bf$var$hasTanstackParam(options, 'onExpandedChange') && {
        onExpandedChange: options.onExpandedChange
    }), !$356a4de9cad863bf$var$hasCharlieParam(options, 'rows') && $356a4de9cad863bf$var$hasTanstackParam(options, 'getRowId') && {
        getRowId: options.getRowId
    }), !$356a4de9cad863bf$var$hasCharlieParam(options, 'rows') && $356a4de9cad863bf$var$hasTanstackParam(options, 'getSubRows') && {
        getSubRows: options.getSubRows
    }), $356a4de9cad863bf$var$hasTanstackParam(options, 'getRowCanExpand') && {
        getRowCanExpand: options.getRowCanExpand
    }), {}, {
        enableSortingRemoval: (_options$enableSortin = options.enableSortingRemoval) !== null && _options$enableSortin !== void 0 ? _options$enableSortin : false,
        enableRowSelection: options.enableRowSelection,
        getCoreRowModel: (0, $e6OxX.getCoreRowModel)(),
        getExpandedRowModel: (0, $e6OxX.getExpandedRowModel)(),
        getGroupedRowModel: options.enableServerSideGrouping ? (0, $ekACv.manualGroupedRowModel)() : (0, $e6OxX.getGroupedRowModel)(),
        getSortedRowModel: (0, $e6OxX.getSortedRowModel)()
    });
    return tanStackOptions;
};
function $356a4de9cad863bf$var$isCharlieTableColumn(column) {
    return column && column.key != null && column.content != null && column.cell && typeof column.cell.render === 'function';
}
var $356a4de9cad863bf$var$convertToColumnPinningState = function convertToColumnPinningState(pinning) {
    if (!pinning) return {
        left: [],
        right: []
    };
    if ('start' in pinning || 'end' in pinning) {
        var _pinning$start, _pinning$end;
        return {
            left: (_pinning$start = pinning.start) !== null && _pinning$start !== void 0 ? _pinning$start : [],
            right: (_pinning$end = pinning.end) !== null && _pinning$end !== void 0 ? _pinning$end : []
        };
    }
    return pinning;
};
var $356a4de9cad863bf$var$convertToSortingState = function convertToSortingState(sorting) {
    if (Array.isArray(sorting)) return sorting;
    else if (sorting !== null && sorting !== void 0 && sorting.field) return [
        {
            id: sorting.field,
            desc: sorting.direction === 'desc'
        }
    ];
    // If sorting is undefined, return an empty array.
    return [];
};
function $356a4de9cad863bf$var$hasCharlieParam(options, parameter) {
    var isUsingCharles = parameter in options;
    return isUsingCharles;
}
function $356a4de9cad863bf$var$hasTanstackParam(options, parameter) {
    return parameter in options;
}
var $356a4de9cad863bf$var$handleSortChange = function handleSortChange(options) {
    return function(sortUpdator) {
        if ($356a4de9cad863bf$var$hasCharlieParam(options, 'onSortChange') && options.onSortChange) {
            var _options$state18;
            // Convert Tanstack sorting to original format
            var sortingValue = (0, $e6OxX.functionalUpdate)(sortUpdator, $356a4de9cad863bf$var$convertToSortingState((_options$state18 = options.state) === null || _options$state18 === void 0 ? void 0 : _options$state18.sorting));
            var convertedSort = sortingValue && sortingValue.length > 0 ? {
                field: sortingValue[0].id,
                direction: sortingValue[0].desc ? 'desc' : 'asc'
            } : undefined;
            options.onSortChange(convertedSort);
        }
        return undefined;
    };
};

});
parcelRegister("ekACv", function(module, exports) {
$parcel$export(module.exports, "manualGroupedRowModel", () => $a6ef56e94c8be78c$export$bfec7ec94303aa98);

var $e6OxX = parcelRequire("e6OxX");
function $a6ef56e94c8be78c$export$bfec7ec94303aa98() {
    return function(table) {
        return (0, $e6OxX.memo)(function() {
            return [
                table.getState().grouping,
                table.getPreGroupedRowModel()
            ];
        }, function(grouping, rowModel) {
            try {
                if (!rowModel.rows.length || !grouping.length) return rowModel;
                // Filter the grouping list down to columns that exist
                var existingGrouping = grouping.filter(function(columnId) {
                    return table.getColumn(columnId);
                });
                var groupedFlatRows = [];
                var groupedRowsById = {};
                // Recursively group the data
                var _groupUpRecursively = function groupUpRecursively(rows) {
                    var depth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
                    var parentId = arguments.length > 2 ? arguments[2] : undefined;
                    // Grouping depth has been been met
                    // Stop grouping and simply rewrite thd depth and row relationships
                    if (depth >= existingGrouping.length) return rows.map(function(row) {
                        row.depth = depth;
                        groupedFlatRows.push(row);
                        groupedRowsById[row.id] = row;
                        if (row.subRows.length) row.subRows = _groupUpRecursively(row.subRows, depth + 1, row.id);
                        return row;
                    });
                    var columnId = existingGrouping[depth];
                    if (!columnId) throw new Error('Column not found');
                    return rows.map(function(row) {
                        var groupingValue = row.getGroupingValue(columnId);
                        var id = row.id;
                        var subRows = _groupUpRecursively(row.subRows, depth + 1, id);
                        var leafRows = depth ? (0, $e6OxX.flattenBy)(row.subRows, function(row) {
                            return row.subRows;
                        }) : row.subRows;
                        var groupedRow = (0, $e6OxX.createRow)(table, id, row.original, 0, depth, undefined, parentId);
                        return Object.assign(groupedRow, {
                            groupingColumnId: columnId,
                            groupingValue: groupingValue,
                            subRows: subRows,
                            leafRows: leafRows
                        });
                    });
                };
                var groupedRows = _groupUpRecursively(rowModel.rows, 0);
                groupedRows.forEach(function(subRow) {
                    groupedFlatRows.push(subRow);
                    groupedRowsById[subRow.id] = subRow;
                });
                return {
                    rows: groupedRows,
                    flatRows: groupedFlatRows,
                    rowsById: groupedRowsById
                };
            } catch (error) {
                return rowModel;
            }
        }, (0, $e6OxX.getMemoOptions)(table.options, 'debugTable', 'getGroupedRowModel', function() {
            table._queue(function() {
                table._autoResetExpanded();
                table._autoResetPageIndex();
            });
        }));
    };
}

});


parcelRegister("7vnkj", function(module, exports) {

var $iKwew = parcelRequire("iKwew");
module.exports = $iKwew("4xOaE").then(()=>parcelRequire('2NRa8'));

});



parcelRegister("dUWEU", function(module, exports) {
$parcel$export(module.exports, "default", () => $a21e01c03a9c4d94$export$2e2bcd8739ae039);

var $kqp0i = parcelRequire("kqp0i");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");

var $abSTK = parcelRequire("abSTK");

var $ccBRl = parcelRequire("ccBRl");

var $goIky = parcelRequire("goIky");
var $a21e01c03a9c4d94$var$_excluded = [
    "analyticsContext",
    "appearance",
    "aria-label",
    "aria-labelledby",
    "autoFocus",
    "children",
    "iconAfter",
    "iconBefore",
    "interactionName",
    "isDisabled",
    "isLoading",
    "isSelected",
    "onClick",
    "onClickCapture",
    "onKeyDownCapture",
    "onKeyUpCapture",
    "onMouseDownCapture",
    "onMouseUpCapture",
    "onPointerDownCapture",
    "onPointerUpCapture",
    "onTouchEndCapture",
    "onTouchStartCapture",
    "shouldFitContainer",
    "spacing",
    "testId",
    "type"
], $a21e01c03a9c4d94$var$_excluded2 = [
    "className",
    "css",
    "as",
    "style"
];
/**
 * __Button__
 *
 * A button triggers an event or action.
 *
 * - [Examples](https://atlassian.design/components/button/examples)
 * - [Code](https://atlassian.design/components/button/code)
 * - [Usage](https://atlassian.design/components/button/usage)
 */ var $a21e01c03a9c4d94$var$Button = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).forwardRef(function Button(_ref, ref) {
    var analyticsContext = _ref.analyticsContext, appearance = _ref.appearance, ariaLabel = _ref['aria-label'], ariaLabelledBy = _ref['aria-labelledby'], autoFocus = _ref.autoFocus, children = _ref.children, iconAfter = _ref.iconAfter, iconBefore = _ref.iconBefore, interactionName = _ref.interactionName, isDisabled = _ref.isDisabled, _ref$isLoading = _ref.isLoading, isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading, isSelected = _ref.isSelected, onClick = _ref.onClick, onClickCapture = _ref.onClickCapture, onKeyDownCapture = _ref.onKeyDownCapture, onKeyUpCapture = _ref.onKeyUpCapture, onMouseDownCapture = _ref.onMouseDownCapture, onMouseUpCapture = _ref.onMouseUpCapture, onPointerDownCapture = _ref.onPointerDownCapture, onPointerUpCapture = _ref.onPointerUpCapture, onTouchEndCapture = _ref.onTouchEndCapture, onTouchStartCapture = _ref.onTouchStartCapture, shouldFitContainer = _ref.shouldFitContainer, spacing = _ref.spacing, testId = _ref.testId, _ref$type = _ref.type, type = _ref$type === void 0 ? 'button' : _ref$type, unsafeRest = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $a21e01c03a9c4d94$var$_excluded);
    // @ts-expect-error
    var _className = unsafeRest.className, _css = unsafeRest.css, _as = unsafeRest.as, _style = unsafeRest.style, saferRest = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(unsafeRest, $a21e01c03a9c4d94$var$_excluded2);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $abSTK.default), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        analyticsContext: analyticsContext,
        ref: ref,
        appearance: appearance,
        autoFocus: autoFocus,
        isDisabled: isDisabled,
        isLoading: isLoading,
        isSelected: isSelected,
        hasIconBefore: Boolean(iconBefore),
        hasIconAfter: Boolean(iconAfter),
        shouldFitContainer: shouldFitContainer,
        spacing: spacing,
        ariaLabel: ariaLabel,
        ariaLabelledBy: ariaLabelledBy,
        onClick: onClick,
        onClickCapture: onClickCapture,
        onKeyDownCapture: onKeyDownCapture,
        onKeyUpCapture: onKeyUpCapture,
        onMouseDownCapture: onMouseDownCapture,
        onMouseUpCapture: onMouseUpCapture,
        onPointerDownCapture: onPointerDownCapture,
        onPointerUpCapture: onPointerUpCapture,
        onTouchStartCapture: onTouchStartCapture,
        onTouchEndCapture: onTouchEndCapture,
        testId: testId,
        componentName: "Button",
        type: type,
        interactionName: interactionName
    }, saferRest), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $5FkrB.Fragment), null, iconBefore && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $ccBRl.default), {
        type: "icon",
        position: "before",
        isLoading: isLoading
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $goIky.default), {
        icon: iconBefore
    })), children && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $ccBRl.default), {
        isLoading: isLoading
    }, children), iconAfter && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $ccBRl.default), {
        type: "icon",
        position: "after",
        isLoading: isLoading
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $goIky.default), {
        icon: iconAfter
    }))));
}));
$a21e01c03a9c4d94$var$Button.displayName = 'Button';
var $a21e01c03a9c4d94$export$2e2bcd8739ae039 = $a21e01c03a9c4d94$var$Button;

});

parcelRegister("2oF7I", function(module, exports) {
$parcel$export(module.exports, "default", () => $1bedb8eb38a3e847$export$2e2bcd8739ae039);

var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");
function $1bedb8eb38a3e847$export$2e2bcd8739ae039(propValue) {
    var getDefaultPropValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function() {
        return propValue;
    };
    var isControlled = propValue !== undefined;
    var _useState = (0, $5FkrB.useState)(getDefaultPropValue), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), valueState = _useState2[0], setValue = _useState2[1];
    var isControlledRef = (0, $5FkrB.useRef)(isControlled);
    (0, $5FkrB.useEffect)(function() {
        isControlledRef.current = isControlled;
    }, [
        isControlled
    ]);
    var value = isControlled ? propValue : valueState;
    var setValueIfUncontrolled = (0, $5FkrB.useCallback)(function(newValue) {
        if (!isControlledRef.current) setValue(newValue);
    }, []);
    return [
        value,
        setValueIfUncontrolled
    ];
}

});

parcelRegister("h7zHk", function(module, exports) {
$parcel$export(module.exports, "default", () => $c76ec7f1ca125947$export$2e2bcd8739ae039);

var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");
function $c76ec7f1ca125947$export$2e2bcd8739ae039() {
    var _useState = (0, $5FkrB.useState)(false), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), isFocused = _useState2[0], setIsFocused = _useState2[1];
    // ensure bindFocus has a stable ref
    var bindFocus = (0, $5FkrB.useRef)({
        onFocus: function onFocus() {
            return setIsFocused(true);
        },
        onBlur: function onBlur() {
            return setIsFocused(false);
        }
    });
    (0, $5FkrB.useEffect)(function() {
        // handle the case where a component might
        // unmount while being focused.
        return function() {
            return setIsFocused(false);
        };
    }, []);
    return {
        isFocused: isFocused,
        bindFocus: bindFocus.current
    };
}

});

parcelRegister("8KvTb", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d03862cd3f81bd2eb2145cf11d082237>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $65eb5b21bab64046$var$_react = $65eb5b21bab64046$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $65eb5b21bab64046$var$_chevronDown = $65eb5b21bab64046$var$_interopRequireDefault((parcelRequire("h19KG")));

var $65eb5b21bab64046$var$_chevronDown2 = $65eb5b21bab64046$var$_interopRequireDefault((parcelRequire("j2BNC")));
function $65eb5b21bab64046$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for ChevronDownIcon.
 * This component is ChevronDownIcon, with `UNSAFE_fallbackIcon` set to "ChevronDownIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Do not use 16px chevrons within buttons, icon buttons, or dropdowns to maintain visual cohesion with ADS which uses 12px chevrons.
Known uses: Open dropdown menu, expanded tree item, collapse tree item
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $65eb5b21bab64046$var$ChevronDownIcon = (props)=>/*#__PURE__*/ $65eb5b21bab64046$var$_react.default.createElement($65eb5b21bab64046$var$_chevronDown.default, Object.assign({
        name: "ChevronDownIcon",
        LEGACY_fallbackIcon: $65eb5b21bab64046$var$_chevronDown2.default
    }, props));
$65eb5b21bab64046$var$ChevronDownIcon.displayName = 'ChevronDownIconMigration';
var $65eb5b21bab64046$var$_default = module.exports.default = $65eb5b21bab64046$var$ChevronDownIcon;

});
parcelRegister("h19KG", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d56e8662eb8a8d2462ec3a39ff3aa40b>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c63a1832a2581897$var$_react = $c63a1832a2581897$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $c63a1832a2581897$var$_baseNew = $c63a1832a2581897$var$_interopRequireDefault((parcelRequire("axuVY")));
function $c63a1832a2581897$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ChevronDown".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Do not use 16px chevrons within buttons, icon buttons, or dropdowns to maintain visual cohesion with ADS which uses 12px chevrons.
Known uses: Open dropdown menu, expanded tree item, collapse tree item
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c63a1832a2581897$var$ChevronDownIcon = (props)=>/*#__PURE__*/ $c63a1832a2581897$var$_react.default.createElement($c63a1832a2581897$var$_baseNew.default, Object.assign({
        name: "ChevronDownIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="m14.53 6.03-6 6a.75.75 0 0 1-1.004.052l-.056-.052-6-6 1.06-1.06L8 10.44l5.47-5.47z"/>`
    }, props));
$c63a1832a2581897$var$ChevronDownIcon.displayName = 'ChevronDownIcon';
var $c63a1832a2581897$var$_default = module.exports.default = $c63a1832a2581897$var$ChevronDownIcon;

});

parcelRegister("j2BNC", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ddcb8665769ee06e$var$_react = $ddcb8665769ee06e$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $2SuPM = parcelRequire("2SuPM");
function $ddcb8665769ee06e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $ddcb8665769ee06e$var$ChevronDownIcon = (props)=>/*#__PURE__*/ $ddcb8665769ee06e$var$_react.default.createElement($2SuPM.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M8.292 10.293a1.01 1.01 0 0 0 0 1.419l2.939 2.965c.218.215.5.322.779.322s.556-.107.769-.322l2.93-2.955a1.01 1.01 0 0 0 0-1.419.987.987 0 0 0-1.406 0l-2.298 2.317-2.307-2.327a.99.99 0 0 0-1.406 0"/></svg>`
    }, props));
$ddcb8665769ee06e$var$ChevronDownIcon.displayName = 'ChevronDownIcon';
var $ddcb8665769ee06e$var$_default = module.exports.default = $ddcb8665769ee06e$var$ChevronDownIcon;

});


parcelRegister("jnGKX", function(module, exports) {
$parcel$export(module.exports, "default", () => $e1c154d3dc3a0528$export$2e2bcd8739ae039);

var $dY97G = parcelRequire("dY97G");
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$e1c154d3dc3a0528$export$2e2bcd8739ae039 = (0, $dY97G.Popup);

});
parcelRegister("dY97G", function(module, exports) {
$parcel$export(module.exports, "Popup", () => $a2b7f495199a9de5$export$129a32eedafa97c5);
/* popup.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");


var $h8qvJ = parcelRequire("h8qvJ");

var $7pP4U = parcelRequire("7pP4U");

var $4vQ4O = parcelRequire("4vQ4O");

var $9Zzpd = parcelRequire("9Zzpd");

var $hvYLl = parcelRequire("hvYLl");
var $agyC9 = parcelRequire("agyC9");

var $ifxBL = parcelRequire("ifxBL");

var $loUpR = parcelRequire("loUpR");

var $9Z4Uz = parcelRequire("9Z4Uz");

var $516xU = parcelRequire("516xU");

var $jH5Jd = parcelRequire("jH5Jd");

var $2PE7x = parcelRequire("2PE7x");
var $a2b7f495199a9de5$var$defaultLayer = 400;
var $a2b7f495199a9de5$var$wrapperStyles = {
    root: "_kqswh2mm"
};
var $a2b7f495199a9de5$export$129a32eedafa97c5 = /*#__PURE__*/ (0, $5FkrB.memo)(function(_ref) {
    var xcss = _ref.xcss, _ref$appearance = _ref.appearance, inAppearance = _ref$appearance === void 0 ? 'default' : _ref$appearance, isOpen = _ref.isOpen, providedId = _ref.id, offset = _ref.offset, testId = _ref.testId, trigger = _ref.trigger, content = _ref.content, onClose = _ref.onClose, boundary = _ref.boundary, _ref$rootBoundary = _ref.rootBoundary, rootBoundary = _ref$rootBoundary === void 0 ? 'viewport' : _ref$rootBoundary, _ref$shouldFlip = _ref.shouldFlip, shouldFlip = _ref$shouldFlip === void 0 ? true : _ref$shouldFlip, _ref$placement = _ref.placement, placement = _ref$placement === void 0 ? 'auto' : _ref$placement, fallbackPlacements = _ref.fallbackPlacements, PopupContainer = _ref.popupComponent, _ref$autoFocus = _ref.autoFocus, autoFocus = _ref$autoFocus === void 0 ? true : _ref$autoFocus, _ref$zIndex = _ref.zIndex, zIndex = _ref$zIndex === void 0 ? $a2b7f495199a9de5$var$defaultLayer : _ref$zIndex, _ref$shouldUseCapture = _ref.shouldUseCaptureOnOutsideClick, shouldUseCaptureOnOutsideClick = _ref$shouldUseCapture === void 0 ? false : _ref$shouldUseCapture, _ref$shouldRenderToPa = _ref.shouldRenderToParent, inShouldRenderToParent = _ref$shouldRenderToPa === void 0 ? false : _ref$shouldRenderToPa, _ref$shouldFitContain = _ref.shouldFitContainer, shouldFitContainer = _ref$shouldFitContain === void 0 ? false : _ref$shouldFitContain, _ref$shouldDisableFoc = _ref.shouldDisableFocusLock, shouldDisableFocusLock = _ref$shouldDisableFoc === void 0 ? false : _ref$shouldDisableFoc, _ref$shouldReturnFocu = _ref.shouldReturnFocus, shouldReturnFocus = _ref$shouldReturnFocu === void 0 ? true : _ref$shouldReturnFocu, strategy = _ref.strategy, role = _ref.role, label = _ref.label, titleId = _ref.titleId, modifiers = _ref.modifiers, shouldFitViewport = _ref.shouldFitViewport;
    var _useState = (0, $5FkrB.useState)(null), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), triggerRef = _useState2[0], setTriggerRef = _useState2[1];
    var getMergedTriggerRef = (0, $jH5Jd.useGetMemoizedMergedTriggerRef)();
    var getMergedTriggerRefNew = (0, $2PE7x.useGetMemoizedMergedTriggerRefNew)();
    var generatedId = (0, $h8qvJ.useId)();
    var _usePopupAppearance = (0, $516xU.usePopupAppearance)({
        appearance: inAppearance,
        shouldRenderToParent: inShouldRenderToParent
    }), appearance = _usePopupAppearance.appearance, shouldRenderToParent = _usePopupAppearance.shouldRenderToParent;
    var id = providedId || generatedId;
    var handleOpenLayerObserverCloseSignal = (0, $5FkrB.useCallback)(function() {
        onClose === null || onClose === void 0 || onClose(null);
    }, [
        onClose
    ]);
    (0, $4vQ4O.useNotifyOpenLayerObserver)({
        isOpen: isOpen,
        onClose: handleOpenLayerObserverCloseSignal
    });
    var renderPopperWrapper = /*#__PURE__*/ $5FkrB.createElement((0, $7pP4U.Layering), {
        isDisabled: false
    }, /*#__PURE__*/ $5FkrB.createElement((0, $9Z4Uz.default), {
        xcss: xcss,
        appearance: appearance,
        content: content,
        isOpen: isOpen,
        placement: placement,
        fallbackPlacements: fallbackPlacements,
        boundary: boundary,
        rootBoundary: rootBoundary,
        shouldFlip: shouldFlip,
        offset: offset,
        popupComponent: PopupContainer,
        id: id,
        testId: testId,
        onClose: onClose,
        autoFocus: autoFocus,
        shouldUseCaptureOnOutsideClick: shouldUseCaptureOnOutsideClick,
        shouldRenderToParent: shouldRenderToParent || shouldFitContainer,
        shouldFitContainer: shouldFitContainer,
        shouldDisableFocusLock: shouldDisableFocusLock,
        shouldReturnFocus: shouldReturnFocus,
        triggerRef: triggerRef,
        strategy: shouldFitContainer ? 'absolute' : strategy,
        role: role,
        label: label,
        titleId: titleId,
        modifiers: modifiers,
        shouldFitViewport: shouldFitViewport
    }));
    var popupContent = /*#__PURE__*/ $5FkrB.createElement((0, $hvYLl.Manager), null, /*#__PURE__*/ $5FkrB.createElement((0, $agyC9.Reference), null, function(_ref2) {
        var ref = _ref2.ref;
        return trigger({
            ref: !(0, $9Zzpd.fg)('platform-design-system-popup-ref') ? getMergedTriggerRef(ref, setTriggerRef, isOpen) : getMergedTriggerRefNew(ref, setTriggerRef),
            'aria-controls': isOpen ? id : undefined,
            'aria-expanded': isOpen,
            'aria-haspopup': role === 'dialog' && (0, $9Zzpd.fg)('platform_dst_popup-disable-focuslock') ? 'dialog' : true
        });
    }), isOpen && (shouldRenderToParent || shouldFitContainer ? renderPopperWrapper : /*#__PURE__*/ $5FkrB.createElement((0, $ifxBL.default), {
        zIndex: zIndex
    }, renderPopperWrapper)));
    if (shouldFitContainer) return /*#__PURE__*/ $5FkrB.createElement((0, $loUpR.default), {
        xcss: $a2b7f495199a9de5$var$wrapperStyles.root
    }, popupContent);
    return popupContent;
});

});
parcelRegister("7pP4U", function(module, exports) {
$parcel$export(module.exports, "LevelContext", () => $56627d3d806ebfd2$export$650d12d3c2ddb8fc);
$parcel$export(module.exports, "LevelNodeContext", () => $56627d3d806ebfd2$export$18f4d8b5b3a77f59);
$parcel$export(module.exports, "RootNodeContext", () => $56627d3d806ebfd2$export$fa973f110e8f6ca8);
$parcel$export(module.exports, "Layering", () => $56627d3d806ebfd2$export$7c885f891c940977);

var $5FkrB = parcelRequire("5FkrB");

var $5mAI1 = parcelRequire("5mAI1");
var $56627d3d806ebfd2$export$650d12d3c2ddb8fc = /*#__PURE__*/ (0, $5FkrB.createContext)(0);
var $56627d3d806ebfd2$export$18f4d8b5b3a77f59 = /*#__PURE__*/ (0, $5FkrB.createContext)({
    current: null
});
var $56627d3d806ebfd2$export$fa973f110e8f6ca8 = /*#__PURE__*/ (0, $5FkrB.createContext)({
    current: null
});
/**
 *
 *  @internal
 * Context Provider Component which provider the current level of nested layers
 * It handles level management when it mounts and unmounts
 *
 */ var $56627d3d806ebfd2$var$LevelProvider = function LevelProvider(_ref) {
    var children = _ref.children, currentLevel = _ref.currentLevel, levelNode = _ref.node;
    (0, $5FkrB.useEffect)(function() {
        var levelNodeSafe = levelNode.current;
        var parentNode = levelNodeSafe.parent;
        parentNode === null || parentNode === void 0 || parentNode.addChild(levelNodeSafe);
        return function() {
            parentNode === null || parentNode === void 0 || parentNode.removeChild(levelNodeSafe);
        };
    }, [
        levelNode
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement($56627d3d806ebfd2$export$650d12d3c2ddb8fc.Provider, {
        value: currentLevel
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement($56627d3d806ebfd2$export$18f4d8b5b3a77f59.Provider, {
        value: levelNode
    }, children));
};
var $56627d3d806ebfd2$export$7c885f891c940977 = function Layering(_ref2) {
    var children = _ref2.children, _ref2$isDisabled = _ref2.isDisabled, isDisabled = _ref2$isDisabled === void 0 ? true : _ref2$isDisabled;
    var currentLevel = (0, $5FkrB.useContext)($56627d3d806ebfd2$export$650d12d3c2ddb8fc);
    var parentNode = (0, $5FkrB.useContext)($56627d3d806ebfd2$export$18f4d8b5b3a77f59);
    // eslint-disable-next-line  @repo/internal/react/disallow-unstable-values
    var newNode = (0, $5FkrB.useRef)(new (0, $5mAI1.LayerNode)(Math.random().toString(36), parentNode.current));
    if (isDisabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).Fragment, null, children);
    var isNested = currentLevel > 0;
    var content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement($56627d3d806ebfd2$var$LevelProvider, {
        currentLevel: currentLevel + 1,
        node: newNode
    }, children);
    return isNested ? content : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement($56627d3d806ebfd2$export$fa973f110e8f6ca8.Provider, {
        value: newNode
    }, content);
};

});
parcelRegister("5mAI1", function(module, exports) {
$parcel$export(module.exports, "LayerNode", () => $3e7b7b7e247540e1$export$da4f61fd78d35243);

var $fC8ib = parcelRequire("fC8ib");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");
var $3e7b7b7e247540e1$export$da4f61fd78d35243 = /*#__PURE__*/ function() {
    function LayerNode(id, parent) {
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, LayerNode);
        this.id = id;
        this.childNodes = [];
        this.parent = parent;
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(LayerNode, [
        {
            key: "addChild",
            value: function addChild(node) {
                this.childNodes.push(node);
            }
        },
        {
            key: "removeChild",
            value: function removeChild(node) {
                this.childNodes = this.childNodes.filter(function(child) {
                    return child.id !== node.id;
                });
            }
        },
        {
            key: "getLevel",
            value: function getLevel() {
                if (!this.parent) return 1;
                return this.parent.getLevel() + 1;
            }
        },
        {
            key: "getHeight",
            value: function getHeight() {
                if (this.childNodes.length === 0) return 1;
                return Math.max.apply(Math, (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(this.childNodes.map(function(child) {
                    return child.getHeight();
                }))) + 1;
            }
        }
    ]);
}();

});


parcelRegister("4vQ4O", function(module, exports) {
$parcel$export(module.exports, "useNotifyOpenLayerObserver", () => $349273fcca90db7b$export$469bb693f11edc7f);

var $5FkrB = parcelRequire("5FkrB");

var $bOCxP = parcelRequire("bOCxP");

var $iNgJd = parcelRequire("iNgJd");
function $349273fcca90db7b$export$469bb693f11edc7f(_ref) {
    var isOpen = _ref.isOpen, type = _ref.type, onClose = _ref.onClose;
    var context = (0, $5FkrB.useContext)((0, $bOCxP.OpenLayerObserverContext));
    var namespace = (0, $iNgJd.useOpenLayerObserverNamespace)();
    (0, $5FkrB.useEffect)(function() {
        /**
     * Registers the `onClose` callback with the OpenLayerObserver.
     */ if (context === null) return;
        if (!isOpen) /**
       * If the layer is not open, we are not registering the `onClose` callback.
       * This is important to prevent the `onClose` from being called for layers that
       * are not open.
       *
       * Some consumers mistakenly pass "toggle" functions to `onClose` callbacks for
       * layer components, as Popup, e.g. `onClose={() => setIsOpen(!isOpen)}`.
       */ return;
        return context.onClose(onClose, {
            namespace: namespace,
            type: type
        });
    }, [
        context,
        isOpen,
        namespace,
        onClose,
        type
    ]);
}

});
parcelRegister("bOCxP", function(module, exports) {
$parcel$export(module.exports, "OpenLayerObserverContext", () => $89a24362b6906df0$export$5fbf4d7fae6cdc00);

var $5FkrB = parcelRequire("5FkrB");
var $89a24362b6906df0$export$5fbf4d7fae6cdc00 = /*#__PURE__*/ (0, $5FkrB.createContext)(null);

});

parcelRegister("iNgJd", function(module, exports) {
$parcel$export(module.exports, "useOpenLayerObserverNamespace", () => $dae9c780565b4fc3$export$1d57e79091cc3046);

var $5FkrB = parcelRequire("5FkrB");

var $b9ST5 = parcelRequire("b9ST5");
function $dae9c780565b4fc3$export$1d57e79091cc3046() {
    var namespace = (0, $5FkrB.useContext)((0, $b9ST5.OpenLayerObserverNamespaceContext));
    return namespace;
}

});
parcelRegister("b9ST5", function(module, exports) {
$parcel$export(module.exports, "OpenLayerObserverNamespaceContext", () => $81fb1c781106bf8c$export$644a49f3b8c50fcd);

var $5FkrB = parcelRequire("5FkrB");
var $81fb1c781106bf8c$export$644a49f3b8c50fcd = /*#__PURE__*/ (0, $5FkrB.createContext)(null);

});



parcelRegister("ifxBL", function(module, exports) {
$parcel$export(module.exports, "default", () => $d493b292959785c6$export$2e2bcd8739ae039);

var $5FkrB = parcelRequire("5FkrB");

var $9Zzpd = parcelRequire("9Zzpd");

var $esSmE = parcelRequire("esSmE");

var $a4Pqx = parcelRequire("a4Pqx");

var $4nFjz = parcelRequire("4nFjz");

var $10OAm = parcelRequire("10OAm");
function $d493b292959785c6$export$2e2bcd8739ae039(_ref) {
    var _ref$zIndex = _ref.zIndex, zIndex = _ref$zIndex === void 0 ? 0 : _ref$zIndex, children = _ref.children, _ref$mountStrategy = _ref.mountStrategy, mountStrategy = _ref$mountStrategy === void 0 ? 'effect' : _ref$mountStrategy;
    var isSubsequentRender = (0, $4nFjz.default)(mountStrategy);
    (0, $10OAm.default)(zIndex);
    return !(0, $9Zzpd.fg)('platform_design_system_team_portal_logic_r18_fix') ? isSubsequentRender ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $esSmE.default), {
        zIndex: zIndex
    }, children) : null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $a4Pqx.default), {
        zIndex: zIndex
    }, children);
}

});
parcelRegister("esSmE", function(module, exports) {
$parcel$export(module.exports, "default", () => $a87dd9d243efb7fa$export$2e2bcd8739ae039);

var $5FkrB = parcelRequire("5FkrB");

var $aLeHs = parcelRequire("aLeHs");

var $ezRcU = parcelRequire("ezRcU");
function $a87dd9d243efb7fa$export$2e2bcd8739ae039(props) {
    var zIndex = props.zIndex, children = props.children;
    var container = (0, $5FkrB.useMemo)(function() {
        return (0, $ezRcU.createContainer)(zIndex);
    }, [
        zIndex
    ]);
    // This is in the render method instead of useEffect so that
    // the portal will be added to the DOM before the children render.
    // For any further changes, ensure that the container does not have a
    // parent besides the portal parent.
    (0, $ezRcU.appendPortalContainerIfNotAppended)(container);
    (0, $5FkrB.useEffect)(function() {
        return function() {
            (0, $ezRcU.removePortalContainer)(container);
        };
    }, [
        container
    ]);
    return /*#__PURE__*/ (0, $aLeHs.createPortal)(children, container);
}

});
parcelRegister("ezRcU", function(module, exports) {
$parcel$export(module.exports, "createContainer", () => $a9cd9b67e01a895f$export$26ae5ca175b4ec5a);
$parcel$export(module.exports, "removePortalContainer", () => $a9cd9b67e01a895f$export$da99f98bf3fe55b3);
$parcel$export(module.exports, "appendPortalContainerIfNotAppended", () => $a9cd9b67e01a895f$export$c582005add11e141);
$parcel$export(module.exports, "createAtlaskitPortal", () => $a9cd9b67e01a895f$export$fef014d7cef9e543);
$parcel$export(module.exports, "createPortalParent", () => $a9cd9b67e01a895f$export$95029ca7aca2989e);

var $5iTBs = parcelRequire("5iTBs");
var $a9cd9b67e01a895f$export$26ae5ca175b4ec5a = function createContainer(zIndex) {
    var container = document.createElement('div');
    container.className = (0, $5iTBs.portalClassName);
    container.style.zIndex = "".concat(zIndex);
    return container;
};
/**
 * Returns document body element
 * @return {number} - The document body element
 */ var $a9cd9b67e01a895f$var$getBody = function getBody() {
    return document.body;
};
/**
 * Returns portal parent container. If no container exists already then it creates a new container with class name 'atlaskit-portal-container'
 * @return {Element} - The portal parent container div element
 */ var $a9cd9b67e01a895f$var$getPortalParent = function getPortalParent() {
    var parentElement = document.querySelector((0, $5iTBs.portalParentSelector));
    if (!parentElement) {
        var _getBody;
        var parent = document.createElement('div');
        parent.className = (0, $5iTBs.portalParentClassName);
        // we are setting display to flex because we want each portal to create a new stacking context
        // See https://developer.mozilla.org/en-US/docs/Web/CSS/CSS_Positioning/Understanding_z_index/The_stacking_context
        parent.style.display = 'flex';
        (_getBody = $a9cd9b67e01a895f$var$getBody()) === null || _getBody === void 0 || _getBody.appendChild(parent);
        return parent;
    }
    return parentElement;
};
var $a9cd9b67e01a895f$export$da99f98bf3fe55b3 = function removePortalContainer(container) {
    $a9cd9b67e01a895f$var$getPortalParent().removeChild(container);
};
var $a9cd9b67e01a895f$export$c582005add11e141 = function appendPortalContainerIfNotAppended(container) {
    if (!container.parentElement) $a9cd9b67e01a895f$var$getPortalParent().appendChild(container);
};
var $a9cd9b67e01a895f$var$isDocumentDefined = function isDocumentDefined() {
    return document !== undefined;
};
var $a9cd9b67e01a895f$export$fef014d7cef9e543 = function createAtlaskitPortal(zIndex) {
    //atlaskit-portal div
    if ($a9cd9b67e01a895f$var$isDocumentDefined()) {
        var atlaskitportal = document.createElement('div');
        atlaskitportal.className = (0, $5iTBs.portalClassName);
        atlaskitportal.style.zIndex = "".concat(zIndex);
        return atlaskitportal;
    }
    return;
};
var $a9cd9b67e01a895f$export$95029ca7aca2989e = function createPortalParent() {
    //atlaskit-portal-container div
    if ($a9cd9b67e01a895f$var$isDocumentDefined()) {
        var parentElement = document.querySelector((0, $5iTBs.portalParentSelector));
        if (!parentElement) {
            var _getBody2;
            var parent = document.createElement('div');
            parent.className = (0, $5iTBs.portalParentClassName);
            parent.style.display = 'flex';
            (_getBody2 = $a9cd9b67e01a895f$var$getBody()) === null || _getBody2 === void 0 || _getBody2.appendChild(parent);
            return parent;
        }
        return parentElement;
    }
    return;
};

});
parcelRegister("5iTBs", function(module, exports) {
$parcel$export(module.exports, "portalParentClassName", () => $3dc9c3d4ceeb5d40$export$e4c79eb95c23a0da);
$parcel$export(module.exports, "portalParentSelector", () => $3dc9c3d4ceeb5d40$export$72f415121273627e);
$parcel$export(module.exports, "portalClassName", () => $3dc9c3d4ceeb5d40$export$13f57c02915787b3);
var $3dc9c3d4ceeb5d40$export$e4c79eb95c23a0da = 'atlaskit-portal-container';
var $3dc9c3d4ceeb5d40$export$72f415121273627e = 'body > .atlaskit-portal-container';
var $3dc9c3d4ceeb5d40$export$13f57c02915787b3 = 'atlaskit-portal';

});



parcelRegister("a4Pqx", function(module, exports) {
$parcel$export(module.exports, "default", () => $75622b6c481e0aa9$export$2e2bcd8739ae039);

var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");

var $aLeHs = parcelRequire("aLeHs");

var $lKmD0 = parcelRequire("lKmD0");

var $ezRcU = parcelRequire("ezRcU");
function $75622b6c481e0aa9$export$2e2bcd8739ae039(props) {
    var zIndex = props.zIndex, children = props.children;
    var _useState = (0, $5FkrB.useState)(null), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), atlaskitPortal = _useState2[0], setAtlaskitPortal = _useState2[1];
    (0, $lKmD0.useIsomorphicLayoutEffect)(function() {
        var tempPortalContainer = (0, $ezRcU.createAtlaskitPortal)(zIndex);
        setAtlaskitPortal(tempPortalContainer);
        var portalParent = (0, $ezRcU.createPortalParent)();
        if (!tempPortalContainer || !portalParent) return;
        portalParent.appendChild(tempPortalContainer);
        return function() {
            if (tempPortalContainer) portalParent.removeChild(tempPortalContainer);
            setAtlaskitPortal(null);
        };
    }, [
        zIndex
    ]);
    /**
   * We wrap portal children with a Suspense boundary because in React 18 concurrent,
   * if you suspend from _within_ a portal to a Suspense boundary _outside_ the portal,
   * our portal gets in an infinite loop of rendering.
   */ var suspendedChildren = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $5FkrB.Suspense), {
        fallback: null
    }, children);
    return atlaskitPortal ? /*#__PURE__*/ (0, $aLeHs.createPortal)(suspendedChildren, atlaskitPortal) : null;
}

});
parcelRegister("lKmD0", function(module, exports) {
$parcel$export(module.exports, "useIsomorphicLayoutEffect", () => $fd4f724da6faa6bf$export$700979bc83e7db82);

var $5FkrB = parcelRequire("5FkrB");
var $fd4f724da6faa6bf$export$700979bc83e7db82 = typeof window !== 'undefined' ? (0, $5FkrB.useLayoutEffect) : (0, $5FkrB.useEffect);

});


parcelRegister("4nFjz", function(module, exports) {
$parcel$export(module.exports, "default", () => $33095b9ed4f48e91$export$2e2bcd8739ae039);

var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");

var $lKmD0 = parcelRequire("lKmD0");
var $33095b9ed4f48e91$var$useIsSubsequentRender = function useIsSubsequentRender(mountStrategy) {
    var _useState = (0, $5FkrB.useState)(false), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), isSubsequentRender = _useState2[0], setIsSubsequentRender = _useState2[1];
    var _useState3 = (0, $5FkrB.useState)(function() {
        return mountStrategy === 'layoutEffect' ? (0, $lKmD0.useIsomorphicLayoutEffect) : (0, $5FkrB.useEffect);
    }), _useState4 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState3, 1), useMountEffect = _useState4[0];
    useMountEffect(function() {
        setIsSubsequentRender(true);
    }, []);
    return isSubsequentRender;
};
var $33095b9ed4f48e91$export$2e2bcd8739ae039 = $33095b9ed4f48e91$var$useIsSubsequentRender;

});

parcelRegister("10OAm", function(module, exports) {
$parcel$export(module.exports, "default", () => $0bcd07c30199461b$export$2e2bcd8739ae039);

var $5FkrB = parcelRequire("5FkrB");

var $7N7OQ = parcelRequire("7N7OQ");

var $8vJ6V = parcelRequire("8vJ6V");
var $0bcd07c30199461b$var$useFirePortalEvent = function useFirePortalEvent(zIndex) {
    var zIndexNumber = Number(zIndex);
    (0, $5FkrB.useEffect)(function() {
        (0, $8vJ6V.default)((0, $7N7OQ.PORTAL_MOUNT_EVENT), zIndexNumber);
        return function() {
            (0, $8vJ6V.default)((0, $7N7OQ.PORTAL_UNMOUNT_EVENT), zIndexNumber);
        };
    }, [
        zIndexNumber
    ]);
};
var $0bcd07c30199461b$export$2e2bcd8739ae039 = $0bcd07c30199461b$var$useFirePortalEvent;

});
parcelRegister("7N7OQ", function(module, exports) {
$parcel$export(module.exports, "PORTAL_MOUNT_EVENT", () => $5ac32cb3b23fd55e$export$ed5835cc67e87f72);
$parcel$export(module.exports, "PORTAL_UNMOUNT_EVENT", () => $5ac32cb3b23fd55e$export$80816bd900e5bd00);
var $5ac32cb3b23fd55e$export$ed5835cc67e87f72 = 'akPortalMount';
var $5ac32cb3b23fd55e$export$80816bd900e5bd00 = 'akPortalUnmount';

});

parcelRegister("8vJ6V", function(module, exports) {
$parcel$export(module.exports, "default", () => $632436041c87004b$export$2e2bcd8739ae039);
var $632436041c87004b$var$zIndexToName = {
    100: 'card',
    200: 'navigation',
    300: 'dialog',
    400: 'layer',
    500: 'blanket',
    510: 'modal',
    600: 'flag',
    700: 'spotlight',
    9999: 'tooltip'
};
/**
 * return layer name in Atlassian design system corresponding to given z-index
 * @param {number} zIndex - z-index value for which layer name is needed
 * @returns {LayerName | null} - The layer name for given z-index. If layer name is not found then null is returned
 */ var $632436041c87004b$var$getLayerName = function getLayerName(zIndex) {
    return $632436041c87004b$var$zIndexToName.hasOwnProperty(zIndex) ? $632436041c87004b$var$zIndexToName[zIndex] : null;
};
/**
 * Creates a PortalEvent object with given eventName, given zIndex and corresponding layer
 * @param {string} eventName - either of Mount or Unmount event name
 * @param {number} zIndex - z-index value which will be included in the event to be dispatched
 * @returns {PortalEvent} - The newly created PortalEvent object
 */ var $632436041c87004b$var$getEvent = function getEvent(eventName, zIndex) {
    var detail = {
        layer: $632436041c87004b$var$getLayerName(Number(zIndex)),
        zIndex: zIndex
    };
    return new CustomEvent(eventName, {
        detail: detail
    });
};
function $632436041c87004b$export$2e2bcd8739ae039(eventName, zIndex) {
    var event = $632436041c87004b$var$getEvent(eventName, zIndex);
    window.dispatchEvent(event);
}

});



parcelRegister("loUpR", function(module, exports) {
$parcel$export(module.exports, "default", () => $f94799f1f0791692$export$2e2bcd8739ae039);
/* box.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $kqp0i = parcelRequire("kqp0i");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");

var $86pDX = parcelRequire("86pDX");
var $f94799f1f0791692$var$_excluded = [
    "as",
    "children",
    "backgroundColor",
    "padding",
    "paddingBlock",
    "paddingBlockStart",
    "paddingBlockEnd",
    "paddingInline",
    "paddingInlineStart",
    "paddingInlineEnd",
    "style",
    "testId",
    "xcss"
], $f94799f1f0791692$var$_excluded2 = [
    "className"
];
// Can either Exclude or Extract - here we're excluding all SVG-related elements, <button> elements (handled by Pressable), and <a> elements (handled by Anchor)
// Basically just ElementType but without ComponentType, it makes sense to keep the "Type" suffix
// eslint-disable-next-line @repo/internal/react/consistent-types-definitions
var $f94799f1f0791692$var$baseStyles = null;
var $f94799f1f0791692$var$backgroundColorMap = {
    'color.background.accent.lime.subtlest': "_bfhkm890",
    'color.background.accent.lime.subtlest.hovered': "_bfhkd4y8",
    'color.background.accent.lime.subtlest.pressed': "_bfhkkuup",
    'color.background.accent.lime.subtler': "_bfhkz2ec",
    'color.background.accent.lime.subtler.hovered': "_bfhk1gf0",
    'color.background.accent.lime.subtler.pressed': "_bfhk2kxc",
    'color.background.accent.lime.subtle': "_bfhkbq5w",
    'color.background.accent.lime.subtle.hovered': "_bfhkfoww",
    'color.background.accent.lime.subtle.pressed': "_bfhk1jbd",
    'color.background.accent.lime.bolder': "_bfhktde4",
    'color.background.accent.lime.bolder.hovered': "_bfhknzpa",
    'color.background.accent.lime.bolder.pressed': "_bfhkh0j0",
    'color.background.accent.red.subtlest': "_bfhk1vk5",
    'color.background.accent.red.subtlest.hovered': "_bfhk1i6i",
    'color.background.accent.red.subtlest.pressed': "_bfhknbir",
    'color.background.accent.red.subtler': "_bfhk1rtt",
    'color.background.accent.red.subtler.hovered': "_bfhkaffd",
    'color.background.accent.red.subtler.pressed': "_bfhk1j5a",
    'color.background.accent.red.subtle': "_bfhkkrt9",
    'color.background.accent.red.subtle.hovered': "_bfhk1sou",
    'color.background.accent.red.subtle.pressed': "_bfhk1fnn",
    'color.background.accent.red.bolder': "_bfhkuibq",
    'color.background.accent.red.bolder.hovered': "_bfhk100f",
    'color.background.accent.red.bolder.pressed': "_bfhk1cl6",
    'color.background.accent.orange.subtlest': "_bfhkf5uh",
    'color.background.accent.orange.subtlest.hovered': "_bfhk19yr",
    'color.background.accent.orange.subtlest.pressed': "_bfhkf90x",
    'color.background.accent.orange.subtler': "_bfhk165s",
    'color.background.accent.orange.subtler.hovered': "_bfhk1ei0",
    'color.background.accent.orange.subtler.pressed': "_bfhkdpo3",
    'color.background.accent.orange.subtle': "_bfhk1kkj",
    'color.background.accent.orange.subtle.hovered': "_bfhk9mfs",
    'color.background.accent.orange.subtle.pressed': "_bfhkaxpp",
    'color.background.accent.orange.bolder': "_bfhk1qg1",
    'color.background.accent.orange.bolder.hovered': "_bfhk12qo",
    'color.background.accent.orange.bolder.pressed': "_bfhk1fyq",
    'color.background.accent.yellow.subtlest': "_bfhkibhp",
    'color.background.accent.yellow.subtlest.hovered': "_bfhkaetg",
    'color.background.accent.yellow.subtlest.pressed': "_bfhk1o1l",
    'color.background.accent.yellow.subtler': "_bfhk1773",
    'color.background.accent.yellow.subtler.hovered': "_bfhk1uw7",
    'color.background.accent.yellow.subtler.pressed': "_bfhk1r9w",
    'color.background.accent.yellow.subtle': "_bfhk8y3s",
    'color.background.accent.yellow.subtle.hovered': "_bfhk819w",
    'color.background.accent.yellow.subtle.pressed': "_bfhk1jx0",
    'color.background.accent.yellow.bolder': "_bfhk1vop",
    'color.background.accent.yellow.bolder.hovered': "_bfhkkjqf",
    'color.background.accent.yellow.bolder.pressed': "_bfhk1okt",
    'color.background.accent.green.subtlest': "_bfhkn729",
    'color.background.accent.green.subtlest.hovered': "_bfhk3utz",
    'color.background.accent.green.subtlest.pressed': "_bfhkyfny",
    'color.background.accent.green.subtler': "_bfhk1wnw",
    'color.background.accent.green.subtler.hovered': "_bfhk1e2h",
    'color.background.accent.green.subtler.pressed': "_bfhkybhx",
    'color.background.accent.green.subtle': "_bfhk1rsu",
    'color.background.accent.green.subtle.hovered': "_bfhk12e3",
    'color.background.accent.green.subtle.pressed': "_bfhk1g86",
    'color.background.accent.green.bolder': "_bfhk1e5c",
    'color.background.accent.green.bolder.hovered': "_bfhka5yi",
    'color.background.accent.green.bolder.pressed': "_bfhk1j68",
    'color.background.accent.teal.subtlest': "_bfhk7xuz",
    'color.background.accent.teal.subtlest.hovered': "_bfhk108c",
    'color.background.accent.teal.subtlest.pressed': "_bfhk1cxp",
    'color.background.accent.teal.subtler': "_bfhk1a17",
    'color.background.accent.teal.subtler.hovered': "_bfhkkwwr",
    'color.background.accent.teal.subtler.pressed': "_bfhk1jb0",
    'color.background.accent.teal.subtle': "_bfhktdv8",
    'color.background.accent.teal.subtle.hovered': "_bfhkzh8h",
    'color.background.accent.teal.subtle.pressed': "_bfhk16zl",
    'color.background.accent.teal.bolder': "_bfhk2c8p",
    'color.background.accent.teal.bolder.hovered': "_bfhkl3ve",
    'color.background.accent.teal.bolder.pressed': "_bfhktor0",
    'color.background.accent.blue.subtlest': "_bfhk1s93",
    'color.background.accent.blue.subtlest.hovered': "_bfhkdaj9",
    'color.background.accent.blue.subtlest.pressed': "_bfhkxm0g",
    'color.background.accent.blue.subtler': "_bfhk1dy8",
    'color.background.accent.blue.subtler.hovered': "_bfhk815t",
    'color.background.accent.blue.subtler.pressed': "_bfhkrwxf",
    'color.background.accent.blue.subtle': "_bfhk115i",
    'color.background.accent.blue.subtle.hovered': "_bfhk9pr4",
    'color.background.accent.blue.subtle.pressed': "_bfhknpx7",
    'color.background.accent.blue.bolder': "_bfhk16e3",
    'color.background.accent.blue.bolder.hovered': "_bfhk1vbm",
    'color.background.accent.blue.bolder.pressed': "_bfhk1xwi",
    'color.background.accent.purple.subtlest': "_bfhkp2ly",
    'color.background.accent.purple.subtlest.hovered': "_bfhkkca2",
    'color.background.accent.purple.subtlest.pressed': "_bfhk1jbm",
    'color.background.accent.purple.subtler': "_bfhk1nm4",
    'color.background.accent.purple.subtler.hovered': "_bfhkattl",
    'color.background.accent.purple.subtler.pressed': "_bfhk3nfk",
    'color.background.accent.purple.subtle': "_bfhk18ah",
    'color.background.accent.purple.subtle.hovered': "_bfhk8bp1",
    'color.background.accent.purple.subtle.pressed': "_bfhk1cd2",
    'color.background.accent.purple.bolder': "_bfhkya33",
    'color.background.accent.purple.bolder.hovered': "_bfhk1af5",
    'color.background.accent.purple.bolder.pressed': "_bfhk6cze",
    'color.background.accent.magenta.subtlest': "_bfhk8tvm",
    'color.background.accent.magenta.subtlest.hovered': "_bfhkr3zd",
    'color.background.accent.magenta.subtlest.pressed': "_bfhk1ckf",
    'color.background.accent.magenta.subtler': "_bfhkv9ra",
    'color.background.accent.magenta.subtler.hovered': "_bfhk1axx",
    'color.background.accent.magenta.subtler.pressed': "_bfhk42ri",
    'color.background.accent.magenta.subtle': "_bfhk1mi6",
    'color.background.accent.magenta.subtle.hovered': "_bfhkrwyz",
    'color.background.accent.magenta.subtle.pressed': "_bfhk6c15",
    'color.background.accent.magenta.bolder': "_bfhkc3uk",
    'color.background.accent.magenta.bolder.hovered': "_bfhk1ok8",
    'color.background.accent.magenta.bolder.pressed': "_bfhkeawv",
    'color.background.accent.gray.subtlest': "_bfhkysee",
    'color.background.accent.gray.subtlest.hovered': "_bfhkwejn",
    'color.background.accent.gray.subtlest.pressed': "_bfhk18ut",
    'color.background.accent.gray.subtler': "_bfhk7qp0",
    'color.background.accent.gray.subtler.hovered': "_bfhk10ef",
    'color.background.accent.gray.subtler.pressed': "_bfhk1rk9",
    'color.background.accent.gray.subtle': "_bfhk18j9",
    'color.background.accent.gray.subtle.hovered': "_bfhk1nv3",
    'color.background.accent.gray.subtle.pressed': "_bfhkq9tj",
    'color.background.accent.gray.bolder': "_bfhk1i45",
    'color.background.accent.gray.bolder.hovered': "_bfhkbyip",
    'color.background.accent.gray.bolder.pressed': "_bfhk1van",
    'color.background.disabled': "_bfhkby5v",
    'color.background.input': "_bfhk1j9a",
    'color.background.input.hovered': "_bfhkl4ek",
    'color.background.input.pressed': "_bfhkr01l",
    'color.background.inverse.subtle': "_bfhk1vck",
    'color.background.inverse.subtle.hovered': "_bfhkmpja",
    'color.background.inverse.subtle.pressed': "_bfhk1gii",
    'color.background.neutral': "_bfhki8nm",
    'color.background.neutral.hovered': "_bfhkplhp",
    'color.background.neutral.pressed': "_bfhk1gdz",
    'color.background.neutral.subtle': "_bfhksm61",
    'color.background.neutral.subtle.hovered': "_bfhk1dpa",
    'color.background.neutral.subtle.pressed': "_bfhkfcek",
    'color.background.neutral.bold': "_bfhk1aqn",
    'color.background.neutral.bold.hovered': "_bfhk1ibz",
    'color.background.neutral.bold.pressed': "_bfhkof27",
    'color.background.selected': "_bfhk15s3",
    'color.background.selected.hovered': "_bfhkufnl",
    'color.background.selected.pressed': "_bfhknozp",
    'color.background.selected.bold': "_bfhkjmqp",
    'color.background.selected.bold.hovered': "_bfhk1q28",
    'color.background.selected.bold.pressed': "_bfhk12kk",
    'color.background.brand.subtlest': "_bfhk1gmr",
    'color.background.brand.subtlest.hovered': "_bfhk3v15",
    'color.background.brand.subtlest.pressed': "_bfhku02c",
    'color.background.brand.bold': "_bfhk1856",
    'color.background.brand.bold.hovered': "_bfhkhf2y",
    'color.background.brand.bold.pressed': "_bfhkg6ey",
    'color.background.brand.boldest': "_bfhk1o4i",
    'color.background.brand.boldest.hovered': "_bfhklefx",
    'color.background.brand.boldest.pressed': "_bfhk16k6",
    'color.background.danger': "_bfhk1gly",
    'color.background.danger.hovered': "_bfhk1yvi",
    'color.background.danger.pressed': "_bfhk1r4b",
    'color.background.danger.bold': "_bfhkybec",
    'color.background.danger.bold.hovered': "_bfhks9hg",
    'color.background.danger.bold.pressed': "_bfhk13a9",
    'color.background.warning': "_bfhk1917",
    'color.background.warning.hovered': "_bfhk19zu",
    'color.background.warning.pressed': "_bfhkzr32",
    'color.background.warning.bold': "_bfhk1kmu",
    'color.background.warning.bold.hovered': "_bfhk1spp",
    'color.background.warning.bold.pressed': "_bfhk4m4m",
    'color.background.success': "_bfhk1y9u",
    'color.background.success.hovered': "_bfhk1vfx",
    'color.background.success.pressed': "_bfhk1wl5",
    'color.background.success.bold': "_bfhkkcmj",
    'color.background.success.bold.hovered': "_bfhky7x8",
    'color.background.success.bold.pressed': "_bfhkwcbh",
    'color.background.discovery': "_bfhk6vm6",
    'color.background.discovery.hovered': "_bfhk12eq",
    'color.background.discovery.pressed': "_bfhk18vq",
    'color.background.discovery.bold': "_bfhku5tj",
    'color.background.discovery.bold.hovered': "_bfhkfqeg",
    'color.background.discovery.bold.pressed': "_bfhk1f1m",
    'color.background.information': "_bfhk19ip",
    'color.background.information.hovered': "_bfhk86z5",
    'color.background.information.pressed': "_bfhk1c1j",
    'color.background.information.bold': "_bfhkx4w0",
    'color.background.information.bold.hovered': "_bfhkq2ii",
    'color.background.information.bold.pressed': "_bfhkf89v",
    'color.blanket': "_bfhk1i5c",
    'color.blanket.selected': "_bfhk7wq0",
    'color.blanket.danger': "_bfhkrprw",
    'color.skeleton': "_bfhkizff",
    'color.skeleton.subtle': "_bfhkvkf5",
    'elevation.surface': "_bfhkvuon",
    'elevation.surface.hovered': "_bfhk19i6",
    'elevation.surface.pressed': "_bfhk13ro",
    'elevation.surface.overlay': "_bfhk1bhr",
    'elevation.surface.overlay.hovered': "_bfhk6o2t",
    'elevation.surface.overlay.pressed': "_bfhkm8nx",
    'elevation.surface.raised': "_bfhkhp5a",
    'elevation.surface.raised.hovered': "_bfhk116u",
    'elevation.surface.raised.pressed': "_bfhk14aj",
    'elevation.surface.sunken': "_bfhkhfxm",
    'utility.elevation.surface.current': "_bfhkchd4"
};
var $f94799f1f0791692$var$CURRENT_SURFACE_CSS_VAR = "--ds-elevation-surface-current";
var $f94799f1f0791692$var$setSurfaceTokenMap = {
    'elevation.surface': "_1q1lvuon",
    'elevation.surface.hovered': "_1q1l19i6",
    'elevation.surface.pressed': "_1q1l13ro",
    'elevation.surface.overlay': "_1q1l1bhr",
    'elevation.surface.overlay.hovered': "_1q1l6o2t",
    'elevation.surface.overlay.pressed': "_1q1lm8nx",
    'elevation.surface.raised': "_1q1lhp5a",
    'elevation.surface.raised.hovered': "_1q1l116u",
    'elevation.surface.raised.pressed': "_1q1l14aj",
    'elevation.surface.sunken': "_1q1lhfxm"
};
var $f94799f1f0791692$var$paddingBlockStartMap = {
    'space.0': "_1q51ze3t",
    'space.025': "_1q51v77o",
    'space.050': "_1q511b66",
    'space.075': "_1q5112x7",
    'space.100': "_1q51u2gc",
    'space.150': "_1q51utpp",
    'space.200': "_1q51pxbi",
    'space.250': "_1q51v47k",
    'space.300': "_1q511ejb",
    'space.400': "_1q51xy5q",
    'space.500': "_1q511jfw",
    'space.600': "_1q51oahv",
    'space.800': "_1q51xncg",
    'space.1000': "_1q511epz"
};
var $f94799f1f0791692$var$paddingBlockEndMap = {
    'space.0': "_85i5ze3t",
    'space.025': "_85i5v77o",
    'space.050': "_85i51b66",
    'space.075': "_85i512x7",
    'space.100': "_85i5u2gc",
    'space.150': "_85i5utpp",
    'space.200': "_85i5pxbi",
    'space.250': "_85i5v47k",
    'space.300': "_85i51ejb",
    'space.400': "_85i5xy5q",
    'space.500': "_85i51jfw",
    'space.600': "_85i5oahv",
    'space.800': "_85i5xncg",
    'space.1000': "_85i51epz"
};
var $f94799f1f0791692$var$paddingInlineStartMap = {
    'space.0': "_bozgze3t",
    'space.025': "_bozgv77o",
    'space.050': "_bozg1b66",
    'space.075': "_bozg12x7",
    'space.100': "_bozgu2gc",
    'space.150': "_bozgutpp",
    'space.200': "_bozgpxbi",
    'space.250': "_bozgv47k",
    'space.300': "_bozg1ejb",
    'space.400': "_bozgxy5q",
    'space.500': "_bozg1jfw",
    'space.600': "_bozgoahv",
    'space.800': "_bozgxncg",
    'space.1000': "_bozg1epz"
};
var $f94799f1f0791692$var$paddingInlineEndMap = {
    'space.0': "_y4tize3t",
    'space.025': "_y4tiv77o",
    'space.050': "_y4ti1b66",
    'space.075': "_y4ti12x7",
    'space.100': "_y4tiu2gc",
    'space.150': "_y4tiutpp",
    'space.200': "_y4tipxbi",
    'space.250': "_y4tiv47k",
    'space.300': "_y4ti1ejb",
    'space.400': "_y4tixy5q",
    'space.500': "_y4ti1jfw",
    'space.600': "_y4tioahv",
    'space.800': "_y4tixncg",
    'space.1000': "_y4ti1epz"
};
/**
 * __Box__
 *
 * A Box is a primitive component that has the design decisions of the Atlassian Design System baked in.
 * Renders a `div` by default.
 *
 * - [Examples](https://atlassian.design/components/primitives/box/examples)
 * - [Code](https://atlassian.design/components/primitives/box/code)
 * - [Usage](https://atlassian.design/components/primitives/box/usage)
 */ var $f94799f1f0791692$var$Box = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? 'div' : _ref$as, children = _ref.children, backgroundColor = _ref.backgroundColor, padding = _ref.padding, _ref$paddingBlock = _ref.paddingBlock, paddingBlock = _ref$paddingBlock === void 0 ? padding : _ref$paddingBlock, _ref$paddingBlockStar = _ref.paddingBlockStart, paddingBlockStart = _ref$paddingBlockStar === void 0 ? paddingBlock : _ref$paddingBlockStar, _ref$paddingBlockEnd = _ref.paddingBlockEnd, paddingBlockEnd = _ref$paddingBlockEnd === void 0 ? paddingBlock : _ref$paddingBlockEnd, _ref$paddingInline = _ref.paddingInline, paddingInline = _ref$paddingInline === void 0 ? padding : _ref$paddingInline, _ref$paddingInlineSta = _ref.paddingInlineStart, paddingInlineStart = _ref$paddingInlineSta === void 0 ? paddingInline : _ref$paddingInlineSta, _ref$paddingInlineEnd = _ref.paddingInlineEnd, paddingInlineEnd = _ref$paddingInlineEnd === void 0 ? paddingInline : _ref$paddingInlineEnd, style = _ref.style, testId = _ref.testId, xcss = _ref.xcss, htmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $f94799f1f0791692$var$_excluded);
    // This is to remove className from safeHtmlAttributes
    // @ts-ignore -- not using expect since it causes issues with help-center local consumption - className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(htmlAttributes, $f94799f1f0791692$var$_excluded2);
    var node = /*#__PURE__*/ $5FkrB.createElement(Component, (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        style: style,
        ref: ref,
        className: (0, $970q7.default)([
            "_19itglyw _vchhusvi _r06hglyw",
            backgroundColor && $f94799f1f0791692$var$backgroundColorMap[backgroundColor],
            backgroundColor && $f94799f1f0791692$var$isSurfaceToken(backgroundColor) && $f94799f1f0791692$var$setSurfaceTokenMap[backgroundColor],
            paddingBlockStart && $f94799f1f0791692$var$paddingBlockStartMap[paddingBlockStart],
            paddingBlockEnd && $f94799f1f0791692$var$paddingBlockEndMap[paddingBlockEnd],
            paddingInlineStart && $f94799f1f0791692$var$paddingInlineStartMap[paddingInlineStart],
            paddingInlineEnd && $f94799f1f0791692$var$paddingInlineEndMap[paddingInlineEnd],
            xcss
        ])
    }, safeHtmlAttributes, {
        "data-testid": testId
    }), children);
    if (backgroundColor) return /*#__PURE__*/ $5FkrB.createElement((0, $86pDX.SurfaceContext).Provider, {
        value: backgroundColor
    }, node);
    return node;
});
var $f94799f1f0791692$export$2e2bcd8739ae039 = $f94799f1f0791692$var$Box;
function $f94799f1f0791692$var$isSurfaceToken(backgroundColor) {
    return backgroundColor in $f94799f1f0791692$var$setSurfaceTokenMap;
}

});
parcelRegister("86pDX", function(module, exports) {
$parcel$export(module.exports, "SurfaceContext", () => $5e62c687f408e450$export$1ca2a26fecb070ae);

var $5FkrB = parcelRequire("5FkrB");
var $5e62c687f408e450$export$1ca2a26fecb070ae = /*#__PURE__*/ (0, $5FkrB.createContext)('elevation.surface');
var $5e62c687f408e450$export$1aeb4f6b93c4540d = function useSurface() {
    return (0, $5FkrB.useContext)($5e62c687f408e450$export$1ca2a26fecb070ae);
};
$5e62c687f408e450$export$1ca2a26fecb070ae.displayName = 'SurfaceProvider';

});


parcelRegister("9Z4Uz", function(module, exports) {
$parcel$export(module.exports, "default", () => $01e0383d73d1296a$export$2e2bcd8739ae039);
/* popper-wrapper.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $fC8ib = parcelRequire("fC8ib");

var $iYJcE = parcelRequire("iYJcE");

var $kqp0i = parcelRequire("kqp0i");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");

var $kBtpk = parcelRequire("kBtpk");

var $9Zzpd = parcelRequire("9Zzpd");

var $5K5L9 = parcelRequire("5K5L9");

var $epSvB = parcelRequire("epSvB");

var $ka0H5 = parcelRequire("ka0H5");

var $d4EwR = parcelRequire("d4EwR");
var $01e0383d73d1296a$var$_excluded = [
    "shouldRenderToParent",
    "shouldFitContainer",
    "children",
    "appearance",
    "className",
    "isReferenceHidden"
];
var $01e0383d73d1296a$var$LOCAL_CURRENT_SURFACE_CSS_VAR = '--ds-elevation-surface-current';
var $01e0383d73d1296a$var$fullWidthStyles = null;
var $01e0383d73d1296a$var$wrapperStyles = {
    root: "_2rko12b0 _1e0c1ule _vchhusvi _1pby1nn1 _bfhk1bhr _16qs130s _syazi7uo _1q1l1bhr _nt751r31 _49pcglyw _1hvw1o36"
};
var $01e0383d73d1296a$var$scrollableStyles = null;
var $01e0383d73d1296a$var$blanketStyles = null;
var $01e0383d73d1296a$var$modalStyles = null;
var $01e0383d73d1296a$var$focusRingStyles = {
    root: "_mizu194a _1ah3dkaa _ra3xnqa1 _128mdkaa _1cvmnqa1 _4davt94y"
};
var $01e0383d73d1296a$var$DefaultPopupComponent = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function(props, ref) {
    var shouldRenderToParent = props.shouldRenderToParent, shouldFitContainer = props.shouldFitContainer, children = props.children, appearance = props.appearance, className = props.className, isReferenceHidden = props.isReferenceHidden, htmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(props, $01e0383d73d1296a$var$_excluded);
    return /*#__PURE__*/ $5FkrB.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $970q7.default)([
            $01e0383d73d1296a$var$wrapperStyles.root,
            appearance === 'UNSAFE_modal-below-sm' && "_dk5d1b66 _c71ldtre _kqsw1n9t _152t1b66",
            !shouldRenderToParent && "_1reo1wug _18m91wug",
            shouldFitContainer && "_1bsb1osq",
            className
        ])
    }, htmlAttributes, {
        ref: ref
    }), children);
});
function $01e0383d73d1296a$var$PopperWrapper(_ref) {
    var xcss = _ref.xcss, isOpen = _ref.isOpen, id = _ref.id, offset = _ref.offset, testId = _ref.testId, content = _ref.content, fallbackPlacements = _ref.fallbackPlacements, onClose = _ref.onClose, boundary = _ref.boundary, rootBoundary = _ref.rootBoundary, shouldFlip = _ref.shouldFlip, _ref$placement = _ref.placement, placement = _ref$placement === void 0 ? 'auto' : _ref$placement, _ref$popupComponent = _ref.popupComponent, PopupContainer = _ref$popupComponent === void 0 ? $01e0383d73d1296a$var$DefaultPopupComponent : _ref$popupComponent, _ref$autoFocus = _ref.autoFocus, autoFocus = _ref$autoFocus === void 0 ? true : _ref$autoFocus, triggerRef = _ref.triggerRef, shouldUseCaptureOnOutsideClick = _ref.shouldUseCaptureOnOutsideClick, shouldRenderToParent = _ref.shouldRenderToParent, shouldFitContainer = _ref.shouldFitContainer, shouldDisableFocusLock = _ref.shouldDisableFocusLock, _ref$shouldReturnFocu = _ref.shouldReturnFocus, shouldReturnFocus = _ref$shouldReturnFocu === void 0 ? true : _ref$shouldReturnFocu, strategy = _ref.strategy, role = _ref.role, label = _ref.label, titleId = _ref.titleId, modifiers = _ref.modifiers, shouldFitViewport = _ref.shouldFitViewport, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'default' : _ref$appearance;
    var _useState = (0, $5FkrB.useState)(null), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), popupRef = _useState2[0], setPopupRef = _useState2[1];
    var _useState3 = (0, $5FkrB.useState)(null), _useState4 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState3, 2), initialFocusRef = _useState4[0], setInitialFocusRef = _useState4[1];
    // We have cases where we need to close the Popup on Tab press, e.g. DropdownMenu
    var shouldCloseOnTab = shouldRenderToParent && shouldDisableFocusLock;
    var shouldDisableFocusTrap = role !== 'dialog';
    (0, $d4EwR.useFocusManager)({
        initialFocusRef: initialFocusRef,
        popupRef: popupRef,
        shouldCloseOnTab: shouldCloseOnTab,
        triggerRef: triggerRef,
        autoFocus: autoFocus,
        shouldDisableFocusTrap: shouldDisableFocusTrap,
        shouldReturnFocus: shouldReturnFocus
    });
    (0, $ka0H5.useCloseManager)({
        isOpen: isOpen,
        onClose: onClose,
        popupRef: popupRef,
        triggerRef: triggerRef,
        shouldUseCaptureOnOutsideClick: shouldUseCaptureOnOutsideClick,
        shouldCloseOnTab: shouldCloseOnTab,
        autoFocus: autoFocus,
        shouldDisableFocusTrap: shouldDisableFocusTrap,
        shouldRenderToParent: shouldRenderToParent
    });
    var _useLayering = (0, $kBtpk.useLayering)(), currentLevel = _useLayering.currentLevel;
    var mergedModifiers = (0, $5FkrB.useMemo)(function() {
        return [
            {
                name: 'flip',
                enabled: shouldFlip,
                options: {
                    rootBoundary: rootBoundary,
                    boundary: boundary,
                    fallbackPlacements: fallbackPlacements
                }
            }
        ].concat((0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(modifiers || []));
    }, [
        shouldFlip,
        rootBoundary,
        boundary,
        fallbackPlacements,
        modifiers
    ]);
    return /*#__PURE__*/ $5FkrB.createElement((0, $5K5L9.Popper), {
        placement: placement,
        offset: offset,
        modifiers: mergedModifiers,
        strategy: strategy,
        shouldFitViewport: shouldFitViewport
    }, function(_ref2) {
        var _ref3 = _ref2.ref, style = _ref2.style, placement = _ref2.placement, update = _ref2.update, isReferenceHidden = _ref2.isReferenceHidden;
        var popupContainer = /*#__PURE__*/ $5FkrB.createElement(PopupContainer, {
            className: (0, $970q7.default)([
                xcss,
                // @ts-expect-error: `ax` is not typed correctly
                !initialFocusRef && (0, $9Zzpd.fg)('platform-design-system-apply-popup-wrapper-focus') && $01e0383d73d1296a$var$focusRingStyles.root
            ]),
            appearance: appearance,
            id: id,
            "data-ds--level": currentLevel,
            "data-placement": placement,
            "data-testid": testId,
            role: role,
            "aria-label": label,
            "aria-labelledby": titleId,
            ref: function ref(node) {
                if (node) {
                    if (typeof _ref3 === 'function') _ref3(node);
                    else _ref3.current = node;
                    setPopupRef(node);
                }
            },
            style: appearance === 'UNSAFE_modal-below-sm' ? {} : style,
            tabIndex: autoFocus ? 0 : undefined,
            shouldRenderToParent: shouldRenderToParent,
            shouldFitContainer: shouldFitContainer,
            isReferenceHidden: isReferenceHidden
        }, /*#__PURE__*/ $5FkrB.createElement((0, $epSvB.RepositionOnUpdate), {
            update: update
        }, content({
            update: update,
            isOpen: isOpen,
            onClose: onClose,
            setInitialFocusRef: setInitialFocusRef
        })));
        return /*#__PURE__*/ $5FkrB.createElement((0, $5FkrB.Fragment), null, popupContainer, appearance === 'UNSAFE_modal-below-sm' && /*#__PURE__*/ $5FkrB.createElement("div", {
            className: (0, $970q7.default)([
                "_1r04idpf _kqsw1n9t _bfhk1i5c"
            ])
        }));
    });
}
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$01e0383d73d1296a$export$2e2bcd8739ae039 = $01e0383d73d1296a$var$PopperWrapper;

});
parcelRegister("kBtpk", function(module, exports) {
$parcel$export(module.exports, "useLayering", () => $effe13157809510b$export$c8b4d54e03dee6ed);

var $5FkrB = parcelRequire("5FkrB");

var $7QpUe = parcelRequire("7QpUe");

var $7pP4U = parcelRequire("7pP4U");
var $effe13157809510b$var$ESCAPE = 'Escape';
function $effe13157809510b$export$4a4bf067ea9e7886(_ref) {
    var onClose = _ref.onClose, isDisabled = _ref.isDisabled;
    var escapePressed = (0, $5FkrB.useRef)(false);
    var _useLayering = $effe13157809510b$export$c8b4d54e03dee6ed(), isLayerDisabled = _useLayering.isLayerDisabled;
    var onKeyDown = (0, $5FkrB.useCallback)(function(e) {
        var isDisabledLayer = isLayerDisabled();
        if (isDisabled || escapePressed.current || e.key !== $effe13157809510b$var$ESCAPE || isDisabledLayer) // We're either already handling the key down event or it's not escape or disabled.
        // Bail early!
        return;
        escapePressed.current = true;
        onClose(e);
    }, [
        onClose,
        isDisabled,
        isLayerDisabled
    ]);
    var onKeyUp = (0, $5FkrB.useCallback)(function() {
        escapePressed.current = false;
    }, []);
    (0, $5FkrB.useEffect)(function() {
        return (0, $7QpUe.bindAll)(window, [
            {
                type: 'keydown',
                listener: onKeyDown
            },
            {
                type: 'keyup',
                listener: onKeyUp
            }
        ], {
            capture: false
        });
    }, [
        onKeyDown,
        onKeyUp
    ]);
}
function $effe13157809510b$export$c8b4d54e03dee6ed() {
    var currentLevel = (0, $5FkrB.useContext)((0, $7pP4U.LevelContext));
    var layerNode = (0, $5FkrB.useContext)((0, $7pP4U.LevelNodeContext));
    var rootNode = (0, $5FkrB.useContext)((0, $7pP4U.RootNodeContext));
    var isLayerDisabled = (0, $5FkrB.useCallback)(function() {
        // This is an impossible case, added for type safety
        if (!(layerNode !== null && layerNode !== void 0 && layerNode.current) || !(rootNode !== null && rootNode !== void 0 && rootNode.current)) return false;
        return layerNode.current.getLevel() < rootNode.current.getHeight();
    }, [
        layerNode,
        rootNode
    ]);
    var getTopLevel = (0, $5FkrB.useCallback)(function() {
        return rootNode !== null && rootNode !== void 0 && rootNode.current ? rootNode.current.getHeight() : null;
    }, [
        rootNode
    ]);
    return {
        currentLevel: currentLevel,
        isLayerDisabled: isLayerDisabled,
        getTopLevel: getTopLevel
    };
}

});

parcelRegister("epSvB", function(module, exports) {
$parcel$export(module.exports, "RepositionOnUpdate", () => $a7edaecb351c1789$export$51eddd7655ca235a);

var $5FkrB = parcelRequire("5FkrB");
var $a7edaecb351c1789$export$51eddd7655ca235a = function RepositionOnUpdate(_ref) {
    var children = _ref.children, update = _ref.update;
    // Ref used here to skip update on first render (when refs haven't been set)
    var isFirstRenderRef = (0, $5FkrB.useRef)(true);
    (0, $5FkrB.useLayoutEffect)(function() {
        if (isFirstRenderRef.current) {
            isFirstRenderRef.current = false;
            return;
        }
        // callback function from popper that repositions pop-up on content Update
        update();
    }, [
        update
    ]);
    // wrapping in fragment to make TS happy (known issue with FC returning children)
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $5FkrB.Fragment), null, children);
};

});

parcelRegister("ka0H5", function(module, exports) {
$parcel$export(module.exports, "useCloseManager", () => $ead5479bf2690ca1$export$92dae2778ae88f9d);
// eslint-disable-next-line no-duplicate-imports

var $5FkrB = parcelRequire("5FkrB");

var $7QpUe = parcelRequire("7QpUe");

var $eVb4V = parcelRequire("eVb4V");

var $kBtpk = parcelRequire("kBtpk");

var $9Zzpd = parcelRequire("9Zzpd");

var $bwSz6 = parcelRequire("bwSz6");

var $3vy2m = parcelRequire("3vy2m");
var $ead5479bf2690ca1$export$92dae2778ae88f9d = function useCloseManager(_ref) {
    var isOpen = _ref.isOpen, onClose = _ref.onClose, popupRef = _ref.popupRef, triggerRef = _ref.triggerRef, autoFocus = _ref.autoFocus, shouldDisableFocusTrap = _ref.shouldDisableFocusTrap, capture = _ref.shouldUseCaptureOnOutsideClick, shouldCloseOnTab = _ref.shouldCloseOnTab, shouldRenderToParent = _ref.shouldRenderToParent;
    var _useLayering = (0, $kBtpk.useLayering)(), isLayerDisabled = _useLayering.isLayerDisabled, currentLevel = _useLayering.currentLevel;
    var _useAnimationFrame = (0, $3vy2m.useAnimationFrame)(), requestFrame = _useAnimationFrame.requestFrame, cancelAllFrames = _useAnimationFrame.cancelAllFrames;
    var mouseDownTarget = (0, $5FkrB.useRef)(null);
    (0, $5FkrB.useEffect)(function() {
        if (!isOpen || !popupRef) return 0, $eVb4V.default;
        var inIframe = window && window.self !== window.top && (0, $9Zzpd.fg)('fix-dropdown-close-outside-iframe');
        var closePopup = function closePopup(event) {
            if (onClose) {
                var _currentLevel = null;
                if (event.target instanceof HTMLElement) {
                    var _event$target$closest, _event$target$closest2;
                    _currentLevel = (_event$target$closest = (_event$target$closest2 = event.target.closest("[data-ds--level]")) === null || _event$target$closest2 === void 0 ? void 0 : _event$target$closest2.getAttribute('data-ds--level')) !== null && _event$target$closest !== void 0 ? _event$target$closest : null;
                }
                _currentLevel ? onClose(event, Number(_currentLevel)) : onClose(event);
            }
            if (shouldDisableFocusTrap && (0, $9Zzpd.fg)('platform_dst_popup-disable-focuslock')) // Restoring the normal focus order for trigger.
            requestFrame(function() {
                triggerRef === null || triggerRef === void 0 || triggerRef.setAttribute('tabindex', '0');
                if (popupRef && autoFocus) popupRef.setAttribute('tabindex', '0');
            });
        };
        // This check is required for cases where components like
        // Select or DDM are placed inside a Popup. A click
        // on a MenuItem or Option would close the Popup, without registering
        // a click on DDM/Select.
        // Users would have to call `onClose` manually to close the Popup in these cases.
        // You can see the bug in action here:
        // https://codesandbox.io/s/atlaskitpopup-default-forked-2eb87?file=/example.tsx:0-1788
        var onClick = function onClick(event) {
            var target = event.target;
            var doesDomNodeExist = document.body.contains(target);
            if (!doesDomNodeExist && !inIframe) return;
            if (isLayerDisabled()) {
                if (target instanceof HTMLElement) {
                    var _target$closest;
                    var layeredElement = (_target$closest = target.closest) === null || _target$closest === void 0 ? void 0 : _target$closest.call(target, "[data-ds--level]");
                    if (layeredElement) {
                        var closeType = layeredElement.getAttribute('[data-ds--close--type]');
                        if (closeType === 'single') // if the close type is single, we won't close other disabled layers when clicking outside
                        return;
                        var levelOfClickedLayer = layeredElement.getAttribute('data-ds--level');
                        if (levelOfClickedLayer && Number(levelOfClickedLayer) > currentLevel) // won't trigger onClick event when we click in a higher layer.
                        return;
                    }
                }
            }
            var isClickOnPopup = popupRef && popupRef.contains(target);
            var isClickOnTrigger = triggerRef && triggerRef.contains(target);
            var didClickStartInsidePopup = popupRef && mouseDownTarget.current instanceof Node && popupRef.contains(mouseDownTarget.current);
            if (!isClickOnPopup && !isClickOnTrigger && !didClickStartInsidePopup) {
                closePopup(event);
                // If there was an outside click on a non-interactive element, the focus should be on the trigger.
                if (document.activeElement && !(0, $bwSz6.isInteractiveElement)(document.activeElement) && (0, $9Zzpd.fg)('platform_dst_popup-disable-focuslock')) triggerRef === null || triggerRef === void 0 || triggerRef.focus();
            }
        };
        var onMouseDown = function onMouseDown(event) {
            /**
       * Tracking the target of the mouse down event.
       * This is used to prevent the popup from closing when the user mouses down inside the popup, but then
       * moves the mouse outside the popup before releasing the mouse button.
       *
       * This is a common user interaction - users may have mistakenly clicked on something, or changed their mind,
       * so they try to cancel their click by moving their mouse away from what they had moused down on.
       *
       * Blanket uses the same technique.
       */ mouseDownTarget.current = event.target;
        };
        var onKeyDown = function onKeyDown(event) {
            if ((0, $9Zzpd.fg)('platform_dst_popup-disable-focuslock')) {
                var key = event.key, shiftKey = event.shiftKey;
                if (shiftKey && key === 'Tab' && !shouldRenderToParent) {
                    if (isLayerDisabled()) return;
                    // We need to move the focus to the popup trigger when the popup is displayed in React.Portal.
                    requestFrame(function() {
                        var isPopupFocusOut = popupRef && !popupRef.contains(document.activeElement);
                        if (isPopupFocusOut) {
                            closePopup(event);
                            if (currentLevel === 1) triggerRef === null || triggerRef === void 0 || triggerRef.focus();
                        }
                    });
                    return;
                }
                if (key === 'Tab') {
                    var _document$activeEleme;
                    // We have cases where we need to close the Popup on Tab press.
                    // Example: DropdownMenu
                    if (shouldCloseOnTab) {
                        if (isLayerDisabled()) return;
                        closePopup(event);
                        return;
                    }
                    if (isLayerDisabled() && (_document$activeEleme = document.activeElement) !== null && _document$activeEleme !== void 0 && _document$activeEleme.closest('[aria-modal]')) return;
                    if (shouldDisableFocusTrap) {
                        if (shouldRenderToParent) // We need to move the focus to the previous interactive element before popup trigger
                        requestFrame(function() {
                            var isPopupFocusOut = popupRef && !popupRef.contains(document.activeElement);
                            if (isPopupFocusOut) closePopup(event);
                        });
                        else requestFrame(function() {
                            if (!document.hasFocus()) closePopup(event);
                        });
                        return;
                    }
                }
                if (isLayerDisabled()) return;
                if (key === 'Escape' || key === 'Esc') {
                    if (triggerRef && autoFocus) triggerRef.focus();
                    closePopup(event);
                }
            } else {
                if (isLayerDisabled()) return;
                var _key = event.key;
                if (_key === 'Escape' || _key === 'Esc' || shouldCloseOnTab && _key === 'Tab') closePopup(event);
            }
        };
        var parentUnbind;
        // if the popup is inside iframe, we want to listen to click events outside iframe,
        // to close the popup correctly in the iframe.
        if (inIframe && isOpen) parentUnbind = (0, $7QpUe.bind)(window.parent.window, {
            type: 'click',
            listener: onClick,
            options: {
                capture: capture
            }
        });
        var unbind = (0, $eVb4V.default);
        if ((0, $9Zzpd.fg)('popup-onclose-fix')) setTimeout(function() {
            unbind = (0, $7QpUe.bindAll)(window, [
                {
                    type: 'click',
                    listener: onClick,
                    options: {
                        capture: capture
                    }
                },
                {
                    type: 'keydown',
                    listener: onKeyDown
                },
                {
                    type: 'mousedown',
                    listener: onMouseDown
                }
            ]);
        }, 0);
        else unbind = (0, $7QpUe.bindAll)(window, [
            {
                type: 'click',
                listener: onClick,
                options: {
                    capture: capture
                }
            },
            {
                type: 'keydown',
                listener: onKeyDown
            },
            {
                type: 'mousedown',
                listener: onMouseDown
            }
        ]);
        // bind onBlur event listener to fix popup not close when clicking on iframe outside
        var unbindBlur = (0, $eVb4V.default);
        unbindBlur = (0, $7QpUe.bind)(window, {
            type: 'blur',
            listener: function onBlur(e) {
                if (isLayerDisabled() || !(document.activeElement instanceof HTMLIFrameElement)) return;
                closePopup(e);
            }
        });
        return function() {
            var _parentUnbind;
            if ((0, $9Zzpd.fg)('popup-onclose-fix')) setTimeout(function() {
                unbind();
            }, 0);
            else unbind();
            cancelAllFrames();
            (_parentUnbind = parentUnbind) === null || _parentUnbind === void 0 || _parentUnbind();
            unbindBlur();
        };
    }, [
        isOpen,
        onClose,
        popupRef,
        triggerRef,
        autoFocus,
        shouldDisableFocusTrap,
        capture,
        isLayerDisabled,
        shouldCloseOnTab,
        currentLevel,
        shouldRenderToParent,
        requestFrame,
        cancelAllFrames
    ]);
};

});
parcelRegister("bwSz6", function(module, exports) {
$parcel$export(module.exports, "isInteractiveElement", () => $864d026677cce2dd$export$3dee5e4542c672d9);
var $864d026677cce2dd$var$interactiveTags = [
    'button',
    'a',
    'input',
    'select',
    'textarea'
];
var $864d026677cce2dd$export$3dee5e4542c672d9 = function isInteractiveElement(element) {
    if ($864d026677cce2dd$var$interactiveTags.includes(element.tagName.toLowerCase())) return true;
    if (element.getAttribute('tabindex') !== null || element.hasAttribute('contenteditable')) return true;
    return false;
};

});

parcelRegister("3vy2m", function(module, exports) {
$parcel$export(module.exports, "useAnimationFrame", () => $28deab68320ef15f$export$641fa9c94086b46e);

var $5FkrB = parcelRequire("5FkrB");
var $28deab68320ef15f$export$641fa9c94086b46e = function useAnimationFrame() {
    var animationsRef = (0, $5FkrB.useRef)([]);
    var requestFrame = (0, $5FkrB.useCallback)(function(callback) {
        var id = requestAnimationFrame(callback);
        animationsRef.current.push(id);
        return id;
    }, []);
    var cancelFrame = (0, $5FkrB.useCallback)(function(id) {
        cancelAnimationFrame(id);
        animationsRef.current = animationsRef.current.filter(function(frameId) {
            return frameId !== id;
        });
    }, []);
    var cancelAllFrames = (0, $5FkrB.useCallback)(function() {
        animationsRef.current.forEach(function(id) {
            return cancelAnimationFrame(id);
        });
        animationsRef.current = [];
    }, []);
    return {
        requestFrame: requestFrame,
        cancelFrame: cancelFrame,
        cancelAllFrames: cancelAllFrames
    };
};

});


parcelRegister("d4EwR", function(module, exports) {
$parcel$export(module.exports, "useFocusManager", () => $984b16538a2886c6$export$10c5169755ce7bd7);

var $5FkrB = parcelRequire("5FkrB");

var $b6Hjk = parcelRequire("b6Hjk");

var $eVb4V = parcelRequire("eVb4V");

var $kBtpk = parcelRequire("kBtpk");

var $9Zzpd = parcelRequire("9Zzpd");

var $3vy2m = parcelRequire("3vy2m");
var $984b16538a2886c6$export$10c5169755ce7bd7 = function useFocusManager(_ref) {
    var initialFocusRef = _ref.initialFocusRef, popupRef = _ref.popupRef, triggerRef = _ref.triggerRef, autoFocus = _ref.autoFocus, shouldCloseOnTab = _ref.shouldCloseOnTab, shouldDisableFocusTrap = _ref.shouldDisableFocusTrap, shouldReturnFocus = _ref.shouldReturnFocus, shouldRenderToParent = _ref.shouldRenderToParent;
    var _useAnimationFrame = (0, $3vy2m.useAnimationFrame)(), requestFrame = _useAnimationFrame.requestFrame, cancelAllFrames = _useAnimationFrame.cancelAllFrames;
    var _useLayering = (0, $kBtpk.useLayering)(), currentLevel = _useLayering.currentLevel;
    (0, $5FkrB.useEffect)(function() {
        if (!popupRef || shouldCloseOnTab) return 0, $eVb4V.default;
        if (shouldDisableFocusTrap && (0, $9Zzpd.fg)('platform_dst_popup-disable-focuslock')) {
            var isDropdown = popupRef.matches('[id^=ds--dropdown--]');
            var popups = document.querySelectorAll("[data-ds--level=\"".concat(currentLevel - 1, "\"]"));
            if (!(popups[popups.length - 1] && !shouldRenderToParent && isDropdown)) {
                // Plucking trigger & popup content container from the tab order so that
                // when we Shift+Tab, the focus moves to the element before trigger
                requestFrame(function() {
                    triggerRef === null || triggerRef === void 0 || triggerRef.setAttribute('tabindex', '-1');
                    if (popupRef && autoFocus) popupRef.setAttribute('tabindex', '-1');
                    (initialFocusRef || popupRef).focus();
                });
                return 0, $eVb4V.default;
            }
        }
        var trapConfig = {
            clickOutsideDeactivates: true,
            escapeDeactivates: true,
            initialFocus: initialFocusRef || popupRef,
            fallbackFocus: popupRef,
            returnFocusOnDeactivate: shouldReturnFocus
        };
        var focusTrap = (0, (/*@__PURE__*/$parcel$interopDefault($b6Hjk)))(popupRef, trapConfig);
        // Wait for the popup to reposition itself before we focus
        requestFrame(function() {
            focusTrap.activate();
        });
        return function() {
            cancelAllFrames();
            focusTrap.deactivate();
        };
    }, [
        popupRef,
        triggerRef,
        autoFocus,
        initialFocusRef,
        shouldCloseOnTab,
        shouldDisableFocusTrap,
        requestFrame,
        cancelAllFrames,
        shouldReturnFocus,
        shouldRenderToParent,
        currentLevel
    ]);
};

});


parcelRegister("516xU", function(module, exports) {
$parcel$export(module.exports, "usePopupAppearance", () => $3a721fa318d8ecb3$export$4065aef1d79a5730);

var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");

var $i7XGO = parcelRequire("i7XGO");
function $3a721fa318d8ecb3$export$4065aef1d79a5730(_ref) {
    var _appearance = _ref.appearance, _shouldRenderToParent = _ref.shouldRenderToParent;
    var mq = (0, $i7XGO.UNSAFE_useMediaQuery)('below.sm', function(e) {
        setIsSmallViewport(!!e.matches);
    });
    var _useState = (0, $5FkrB.useState)(!!(mq !== null && mq !== void 0 && mq.matches)), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), isSmallViewport = _useState2[0], setIsSmallViewport = _useState2[1];
    var appearance = _appearance === 'UNSAFE_modal-below-sm' && isSmallViewport ? 'UNSAFE_modal-below-sm' : 'default';
    var shouldRenderToParent = _shouldRenderToParent && appearance === 'default';
    return {
        appearance: appearance,
        shouldRenderToParent: shouldRenderToParent
    };
}

});
parcelRegister("i7XGO", function(module, exports) {
$parcel$export(module.exports, "UNSAFE_useMediaQuery", () => $d3272e86c8b032f7$export$49e55ae2c03d6045);

var $5FkrB = parcelRequire("5FkrB");

var $7QpUe = parcelRequire("7QpUe");

var $fy6hB = parcelRequire("fy6hB");
var $d3272e86c8b032f7$var$_window, $d3272e86c8b032f7$var$_window$matchMedia, $d3272e86c8b032f7$var$_window2, $d3272e86c8b032f7$var$_window2$matchMedia, $d3272e86c8b032f7$var$_window3, $d3272e86c8b032f7$var$_window3$matchMedia, $d3272e86c8b032f7$var$_window4, $d3272e86c8b032f7$var$_window4$matchMedia, $d3272e86c8b032f7$var$_window5, $d3272e86c8b032f7$var$_window5$matchMedia, $d3272e86c8b032f7$var$_window6, $d3272e86c8b032f7$var$_window6$matchMedia, $d3272e86c8b032f7$var$_window7, $d3272e86c8b032f7$var$_window7$matchMedia, $d3272e86c8b032f7$var$_window8, $d3272e86c8b032f7$var$_window8$matchMedia, $d3272e86c8b032f7$var$_window9, $d3272e86c8b032f7$var$_window9$matchMedia, $d3272e86c8b032f7$var$_window0, $d3272e86c8b032f7$var$_window0$matchMedia, $d3272e86c8b032f7$var$_window1, $d3272e86c8b032f7$var$_window1$matchMedia;
var $d3272e86c8b032f7$var$queries = {
    'above.xxs': typeof window === 'undefined' ? undefined : ($d3272e86c8b032f7$var$_window = window) === null || $d3272e86c8b032f7$var$_window === void 0 || ($d3272e86c8b032f7$var$_window$matchMedia = $d3272e86c8b032f7$var$_window.matchMedia) === null || $d3272e86c8b032f7$var$_window$matchMedia === void 0 ? void 0 : $d3272e86c8b032f7$var$_window$matchMedia.call($d3272e86c8b032f7$var$_window, (0, $fy6hB.media).above.xxs.replace('@media ', '').trim()),
    'above.xs': typeof window === 'undefined' ? undefined : ($d3272e86c8b032f7$var$_window2 = window) === null || $d3272e86c8b032f7$var$_window2 === void 0 || ($d3272e86c8b032f7$var$_window2$matchMedia = $d3272e86c8b032f7$var$_window2.matchMedia) === null || $d3272e86c8b032f7$var$_window2$matchMedia === void 0 ? void 0 : $d3272e86c8b032f7$var$_window2$matchMedia.call($d3272e86c8b032f7$var$_window2, (0, $fy6hB.media).above.xs.replace('@media ', '').trim()),
    'above.sm': typeof window === 'undefined' ? undefined : ($d3272e86c8b032f7$var$_window3 = window) === null || $d3272e86c8b032f7$var$_window3 === void 0 || ($d3272e86c8b032f7$var$_window3$matchMedia = $d3272e86c8b032f7$var$_window3.matchMedia) === null || $d3272e86c8b032f7$var$_window3$matchMedia === void 0 ? void 0 : $d3272e86c8b032f7$var$_window3$matchMedia.call($d3272e86c8b032f7$var$_window3, (0, $fy6hB.media).above.sm.replace('@media ', '').trim()),
    'above.md': typeof window === 'undefined' ? undefined : ($d3272e86c8b032f7$var$_window4 = window) === null || $d3272e86c8b032f7$var$_window4 === void 0 || ($d3272e86c8b032f7$var$_window4$matchMedia = $d3272e86c8b032f7$var$_window4.matchMedia) === null || $d3272e86c8b032f7$var$_window4$matchMedia === void 0 ? void 0 : $d3272e86c8b032f7$var$_window4$matchMedia.call($d3272e86c8b032f7$var$_window4, (0, $fy6hB.media).above.md.replace('@media ', '').trim()),
    'above.lg': typeof window === 'undefined' ? undefined : ($d3272e86c8b032f7$var$_window5 = window) === null || $d3272e86c8b032f7$var$_window5 === void 0 || ($d3272e86c8b032f7$var$_window5$matchMedia = $d3272e86c8b032f7$var$_window5.matchMedia) === null || $d3272e86c8b032f7$var$_window5$matchMedia === void 0 ? void 0 : $d3272e86c8b032f7$var$_window5$matchMedia.call($d3272e86c8b032f7$var$_window5, (0, $fy6hB.media).above.lg.replace('@media ', '').trim()),
    'above.xl': typeof window === 'undefined' ? undefined : ($d3272e86c8b032f7$var$_window6 = window) === null || $d3272e86c8b032f7$var$_window6 === void 0 || ($d3272e86c8b032f7$var$_window6$matchMedia = $d3272e86c8b032f7$var$_window6.matchMedia) === null || $d3272e86c8b032f7$var$_window6$matchMedia === void 0 ? void 0 : $d3272e86c8b032f7$var$_window6$matchMedia.call($d3272e86c8b032f7$var$_window6, (0, $fy6hB.media).above.xl.replace('@media ', '').trim()),
    'below.xs': typeof window === 'undefined' ? undefined : ($d3272e86c8b032f7$var$_window7 = window) === null || $d3272e86c8b032f7$var$_window7 === void 0 || ($d3272e86c8b032f7$var$_window7$matchMedia = $d3272e86c8b032f7$var$_window7.matchMedia) === null || $d3272e86c8b032f7$var$_window7$matchMedia === void 0 ? void 0 : $d3272e86c8b032f7$var$_window7$matchMedia.call($d3272e86c8b032f7$var$_window7, (0, $fy6hB.media).below.xs.replace('@media ', '').trim()),
    'below.sm': typeof window === 'undefined' ? undefined : ($d3272e86c8b032f7$var$_window8 = window) === null || $d3272e86c8b032f7$var$_window8 === void 0 || ($d3272e86c8b032f7$var$_window8$matchMedia = $d3272e86c8b032f7$var$_window8.matchMedia) === null || $d3272e86c8b032f7$var$_window8$matchMedia === void 0 ? void 0 : $d3272e86c8b032f7$var$_window8$matchMedia.call($d3272e86c8b032f7$var$_window8, (0, $fy6hB.media).below.sm.replace('@media ', '').trim()),
    'below.md': typeof window === 'undefined' ? undefined : ($d3272e86c8b032f7$var$_window9 = window) === null || $d3272e86c8b032f7$var$_window9 === void 0 || ($d3272e86c8b032f7$var$_window9$matchMedia = $d3272e86c8b032f7$var$_window9.matchMedia) === null || $d3272e86c8b032f7$var$_window9$matchMedia === void 0 ? void 0 : $d3272e86c8b032f7$var$_window9$matchMedia.call($d3272e86c8b032f7$var$_window9, (0, $fy6hB.media).below.md.replace('@media ', '').trim()),
    'below.lg': typeof window === 'undefined' ? undefined : ($d3272e86c8b032f7$var$_window0 = window) === null || $d3272e86c8b032f7$var$_window0 === void 0 || ($d3272e86c8b032f7$var$_window0$matchMedia = $d3272e86c8b032f7$var$_window0.matchMedia) === null || $d3272e86c8b032f7$var$_window0$matchMedia === void 0 ? void 0 : $d3272e86c8b032f7$var$_window0$matchMedia.call($d3272e86c8b032f7$var$_window0, (0, $fy6hB.media).below.lg.replace('@media ', '').trim()),
    'below.xl': typeof window === 'undefined' ? undefined : ($d3272e86c8b032f7$var$_window1 = window) === null || $d3272e86c8b032f7$var$_window1 === void 0 || ($d3272e86c8b032f7$var$_window1$matchMedia = $d3272e86c8b032f7$var$_window1.matchMedia) === null || $d3272e86c8b032f7$var$_window1$matchMedia === void 0 ? void 0 : $d3272e86c8b032f7$var$_window1$matchMedia.call($d3272e86c8b032f7$var$_window1, (0, $fy6hB.media).below.xl.replace('@media ', '').trim())
};
var $d3272e86c8b032f7$export$49e55ae2c03d6045 = function UNSAFE_useMediaQuery(queryString, listener) {
    var listenerRef = (0, $5FkrB.useRef)(listener);
    (0, $5FkrB.useEffect)(function() {
        // Bind the listener if changed so it's called on the next change event; no guarantee on timing.
        listenerRef.current = listener;
    }, [
        listener
    ]);
    /**
   * We explicitly only react to boolean changes for binding our listener
   * Changes to the functional reference are ignored.
   */ var hasListener = !!listener;
    /**
   * The `matchMedia(…)` return value for our breakpoint query.
   */ var mq = $d3272e86c8b032f7$var$queries[queryString];
    (0, $5FkrB.useLayoutEffect)(function() {
        listenerRef.current = listener; // Bind the listener now in case the `useEffect` hasn't fired above yet
        if (!mq || !hasListener || !listenerRef.current) return;
        return (0, $7QpUe.bind)(mq, {
            type: 'change',
            listener: function listener(event) {
                // We explicitly call the current version of the function
                return listenerRef.current(event);
            }
        });
    }, // eslint-disable-next-line react-hooks/exhaustive-deps -- explicitly do not trigger the effect on `listener` reference change, only on a boolean representation of it.
    [
        mq,
        hasListener
    ]);
    return mq || null;
};

});
parcelRegister("fy6hB", function(module, exports) {
$parcel$export(module.exports, "media", () => $b51ee7a8e0a77756$export$987d49ffe1b0900f);
/**
 * This is an object of usable media query helpers using our internal breakpoints configuration.
 *
 * When using Compiled CSS-in-JS, please ensure that only a single declaration can take effect at a time.
 * This means that you should avoid multiple breakpoints taking effect at the same time,
 * eg. ```{ [media.above.xs]: { color: 'red' }, [media.above.sm]: { color: 'green' }}```.
 * Instead, make sure that only one breakpoint can take effect at a time,
 * e.g, ```{ [media.only.xs]: { color: 'red' }, [media.above.sm]: { color: 'green' }}```.
 * For more details, please see <https://compiledcssinjs.com/docs/atomic-css#selector-specificity>.
 */ var $b51ee7a8e0a77756$export$987d49ffe1b0900f = {
    above: {
        // TODO: Should this even exist, we don't want `css({ [media.above.xxs]: { … } })` because that just adds duplicates styles!
        xxs: '@media all',
        xs: '@media (min-width: 30rem)',
        sm: '@media (min-width: 48rem)',
        md: '@media (min-width: 64rem)',
        lg: '@media (min-width: 90rem)',
        xl: '@media (min-width: 110.5rem)'
    },
    only: {
        xxs: '@media (min-width: 0rem) and (max-width: 29.99rem)',
        xs: '@media (min-width: 30rem) and (max-width: 47.99rem)',
        sm: '@media (min-width: 48rem) and (max-width: 63.99rem)',
        md: '@media (min-width: 64rem) and (max-width: 89.99rem)',
        lg: '@media (min-width: 90rem) and (max-width: 110.49rem)',
        xl: '@media (min-width: 110.5rem)'
    },
    below: {
        xs: '@media not all and (min-width: 30rem)',
        sm: '@media not all and (min-width: 48rem)',
        md: '@media not all and (min-width: 64rem)',
        lg: '@media not all and (min-width: 90rem)',
        xl: '@media not all and (min-width: 110.5rem)'
    }
};

});



parcelRegister("jH5Jd", function(module, exports) {
$parcel$export(module.exports, "useGetMemoizedMergedTriggerRef", () => $e56679fddd3bf8a0$export$7cc5c058dd769dff);

var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");

var $cvlyC = parcelRequire("cvlyC");
var $e56679fddd3bf8a0$export$7cc5c058dd769dff = function useGetMemoizedMergedTriggerRef() {
    var _useState = (0, $5FkrB.useState)(function() {
        return (0, $cvlyC.default)(function(ref, setTriggerRef, isOpen) {
            return function(node) {
                if (node && isOpen) {
                    if (typeof ref === 'function') ref(node);
                    else if (ref) ref.current = node;
                    setTriggerRef(node);
                }
            };
        });
    }), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 1), getMemoizedMergedTriggerRef = _useState2[0];
    return getMemoizedMergedTriggerRef;
};

});

parcelRegister("2PE7x", function(module, exports) {
$parcel$export(module.exports, "useGetMemoizedMergedTriggerRefNew", () => $20ff774fe0ee677f$export$5d3a2de79e07b376);

var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");

var $cvlyC = parcelRequire("cvlyC");
var $20ff774fe0ee677f$export$5d3a2de79e07b376 = function useGetMemoizedMergedTriggerRefNew() {
    var _useState = (0, $5FkrB.useState)(function() {
        return (0, $cvlyC.default)(function(ref, setTriggerRef) {
            return function(node) {
                if (node) {
                    if (typeof ref === 'function') ref(node);
                    else if (ref) ref.current = node;
                    setTriggerRef(node);
                }
            };
        });
    }), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 1), getMemoizedMergedTriggerRefNew = _useState2[0];
    return getMemoizedMergedTriggerRefNew;
};

});



parcelRegister("deSpz", function(module, exports) {
$parcel$export(module.exports, "default", () => $9a36ca20549b38c9$export$2e2bcd8739ae039);
/* menu-group.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $kqp0i = parcelRequire("kqp0i");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");

var $iW5R0 = parcelRequire("iW5R0");

var $8lsbk = parcelRequire("8lsbk");
var $9a36ca20549b38c9$var$_excluded = [
    "isLoading",
    "maxWidth",
    "minWidth",
    "minHeight",
    "maxHeight",
    "testId",
    "role",
    "spacing",
    "menuLabel",
    "className"
];
var $9a36ca20549b38c9$var$baseStyles = null;
/**
 * __Menu group__
 *
 * A menu group includes all the actions or items in a menu.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/menu/docs/menu-group)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/menu)
 */ var $9a36ca20549b38c9$var$MenuGroup = function MenuGroup(_ref) {
    var isLoading = _ref.isLoading, maxWidth = _ref.maxWidth, minWidth = _ref.minWidth, minHeight = _ref.minHeight, maxHeight = _ref.maxHeight, testId = _ref.testId, role = _ref.role, _ref$spacing = _ref.spacing, spacing = _ref$spacing === void 0 ? 'cozy' : _ref$spacing, menuLabel = _ref.menuLabel, UNSAFE_className = _ref.className, rest = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $9a36ca20549b38c9$var$_excluded);
    return /*#__PURE__*/ $5FkrB.createElement((0, $8lsbk.SpacingContext).Provider, {
        value: spacing
    }, /*#__PURE__*/ $5FkrB.createElement((0, $8lsbk.SELECTION_STYLE_CONTEXT_DO_NOT_USE).Provider, {
        value: "border"
    }, /*#__PURE__*/ $5FkrB.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        "aria-busy": isLoading,
        style: {
            minWidth: minWidth,
            maxWidth: maxWidth,
            minHeight: minHeight,
            maxHeight: maxHeight
        },
        "data-testid": testId,
        role: role,
        className: (0, $iW5R0.default)([
            "_1reo1wug _18m91wug _1e0c1txw _kqswpfqs _2lx21bp4",
            UNSAFE_className
        ]),
        "aria-label": menuLabel
    }, rest))));
};
var $9a36ca20549b38c9$export$2e2bcd8739ae039 = $9a36ca20549b38c9$var$MenuGroup;

});
parcelRegister("iW5R0", function(module, exports) {
$parcel$export(module.exports, "default", () => $dc922f40ff1ed424$export$2e2bcd8739ae039);
/**
 * This length includes the underscore,
 * e.g. `"_1s4A"` would be a valid atomic group hash.
 */ const $dc922f40ff1ed424$var$ATOMIC_GROUP_LENGTH = 5;
function $dc922f40ff1ed424$export$2e2bcd8739ae039(classNames) {
    // Shortcut: nothing to do
    if (!classNames.length) return;
    // Shortcut: don't need to do anything if we only have a single classname
    if (classNames.length === 1 && classNames[0] && // checking to see if `classNames[0]` is a string that contains other classnames
    !classNames[0].includes(' ')) return classNames[0];
    // Using an object rather than a `Map` as it performed better in our benchmarks.
    // Would be happy to move to `Map` if it proved to be better under real conditions.
    const map = {};
    // Note: using loops to minimize iterations over the collection
    for (const value of classNames){
        // Exclude all falsy values, which leaves us with populated strings
        if (!value) continue;
        // a `value` can contain multiple classnames
        const list = value.split(' ');
        for (const className of list){
            /**
             * For atomic style classnames: the `key` is the `group`
             *
             * - Later atomic classnames with the same `group` will override earlier ones
             *   (which is what we want).
             * - Assumes atomic classnames are the only things that start with `_`
             * - Could use a regex to ensure that atomic classnames are structured how we expect,
             *   but did not add that for now as it did slow things down a bit.
             *
             * For other classnames: the `key` is the whole classname
             * - Okay to remove duplicates as doing so does not impact specificity
             *
             * */ const key = className.startsWith('_') ? className.slice(0, $dc922f40ff1ed424$var$ATOMIC_GROUP_LENGTH) : className;
            map[key] = className;
        }
    }
    /**
     * We are converting the `map` into a string.
     *
     * The simple way to do this would be `Object.values(map).join(' ')`.
     * However, the approach below performs 10%-20% better in benchmarks.
     *
     * For `ax()` it feels right to squeeze as much runtime performance out as we can.
     */ let result = '';
    for(const key in map)result += map[key] + ' ';
    // If we have an empty string, then our `map` was empty.
    if (!result) return;
    // remove last " " from the result (we added " " at the end of every value)
    return result.trimEnd();
}

});

parcelRegister("8lsbk", function(module, exports) {
$parcel$export(module.exports, "SpacingContext", () => $61362536e8dadc38$export$443076ec7ebce042);
$parcel$export(module.exports, "SELECTION_STYLE_CONTEXT_DO_NOT_USE", () => $61362536e8dadc38$export$9ca534b70725964d);

var $5FkrB = parcelRequire("5FkrB");
var $61362536e8dadc38$export$443076ec7ebce042 = /*#__PURE__*/ (0, $5FkrB.createContext)('cozy');
var $61362536e8dadc38$export$9ca534b70725964d = /*#__PURE__*/ (0, $5FkrB.createContext)('border');

});


parcelRegister("9vsww", function(module, exports) {
$parcel$export(module.exports, "default", () => $6ebd2283cf241b1e$export$2e2bcd8739ae039);
/* button-item.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $kqp0i = parcelRequire("kqp0i");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");


var $eqVaP = parcelRequire("eqVaP");

var $jYq96 = parcelRequire("jYq96");
var $6ebd2283cf241b1e$var$_excluded = [
    "children",
    "description",
    "iconAfter",
    "iconBefore",
    "isDisabled",
    "isSelected",
    "onClick",
    "testId",
    "onMouseDown",
    "shouldTitleWrap",
    "shouldDescriptionWrap",
    "className",
    "interactionName"
];
/**
 * __Button item__
 *
 * A button item is used to populate a menu with items that are buttons.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/menu/docs/button-item)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/menu)
 */ var $6ebd2283cf241b1e$var$ButtonItem = /*#__PURE__*/ (0, $5FkrB.memo)(/*#__PURE__*/ (0, $5FkrB.forwardRef)(function(props, ref) {
    var children = props.children, description = props.description, iconAfter = props.iconAfter, iconBefore = props.iconBefore, _props$isDisabled = props.isDisabled, isDisabled = _props$isDisabled === void 0 ? false : _props$isDisabled, _props$isSelected = props.isSelected, isSelected = _props$isSelected === void 0 ? false : _props$isSelected, onClick = props.onClick, testId = props.testId, onMouseDown = props.onMouseDown, shouldTitleWrap = props.shouldTitleWrap, shouldDescriptionWrap = props.shouldDescriptionWrap, UNSAFE_className = props.className, interactionName = props.interactionName, rest = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(props, $6ebd2283cf241b1e$var$_excluded);
    var onMouseDownHandler = onMouseDown;
    var interactionContext = (0, $5FkrB.useContext)((0, $eqVaP.default));
    var handleClick = (0, $5FkrB.useCallback)(function(e) {
        interactionContext === null || interactionContext === void 0 || interactionContext.tracePress(interactionName, e.timeStamp);
        onClick === null || onClick === void 0 || onClick(e);
    }, [
        onClick,
        interactionContext,
        interactionName
    ]);
    if (!children) return null;
    return /*#__PURE__*/ $5FkrB.createElement((0, $jYq96.default), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        className: UNSAFE_className
    }, rest, {
        iconBefore: iconBefore,
        iconAfter: iconAfter,
        isDisabled: isDisabled,
        isSelected: isSelected,
        isTitleHeading: false,
        description: description,
        title: children,
        shouldTitleWrap: shouldTitleWrap,
        shouldDescriptionWrap: shouldDescriptionWrap,
        testId: testId && "".concat(testId, "--primitive")
    }), function(_ref) {
        var children = _ref.children, className = _ref.className;
        return /*#__PURE__*/ $5FkrB.createElement("button", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
            "data-testid": testId,
            "aria-current": isSelected ? 'true' : undefined
        }, rest, {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: className,
            ref: ref,
            disabled: isDisabled,
            onClick: handleClick,
            onMouseDown: onMouseDownHandler,
            type: "button"
        }), children);
    });
}));
var $6ebd2283cf241b1e$export$2e2bcd8739ae039 = $6ebd2283cf241b1e$var$ButtonItem;

});
parcelRegister("jYq96", function(module, exports) {
$parcel$export(module.exports, "default", () => $e8a7e6f1169b9266$export$2e2bcd8739ae039);
/* menu-item-primitive.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $5FkrB = parcelRequire("5FkrB");

var $iW5R0 = parcelRequire("iW5R0");

var $4wE63 = parcelRequire("4wE63");

var $8lsbk = parcelRequire("8lsbk");
var $e8a7e6f1169b9266$var$renderTitle = function renderTitle(Component, props) {
    return(/*#__PURE__*/ // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    $5FkrB.createElement(Component, props));
};
var $e8a7e6f1169b9266$var$styles = {
    root: "_19itidpf _12ji1r31 _1qu2glyw _12y3idpf _4bfu1r31 _1hmsglyw _ajmmnqa1 _kqswh2mm _1e0c1txw _vchhusvi _1bsb1osq _1tke1ylp _1pfhze3t _12l2ze3t _6rthze3t _ahbqze3t _4cvr1h6o _uiztglyw _80omtlke _ymio1r31 _ypr0glyw _zcxs1o36 _nt751v1w _mizu1v1w _1bg41gjf _1ah31gjf _49pcnqa1 _ra3xnqa1 _1hvwdkaa _128mdkaa _9oik1r31 _1bnxglyw _jf4cnqa1 _1cvmnqa1 _4davt94y",
    beforeAfterElement: "_1e0c1txw _1ul91tcg _1tke1tcg _4cvr1h6o _1bah1h6o _1o9zidpf",
    content: "_12ji1r31 _1qu2glyw _12y31o36 _1reo15vq _18m915vq _1e0c1txw _2lx21bp4 _1bah1h6o _16jlkb7n _y3gn1e5h",
    truncate: "_1reo15vq _18m915vq _1e0c1ule _1bto1l2s _o5721q9c",
    title: "_11c8fhey",
    wordBreak: "_1nmz1hna",
    description: "_11c8wadc _syaz1rpy",
    disabledDescription: "_syaz1gmx",
    unselected: "_bfhksm61 _syaz1r31 _10531r31 _irr31dpa _30l31r31 _1di61dpa _9h8h1r31",
    disabled: "_80om13gf _bfhksm61 _syaz1gmx _irr3sm61 _30l31gmx _1di6sm61 _9h8h1gmx",
    selectedBorder: "_1mp4yh40 _1cs8stnw _1rusq98m _1kt9b3bt _1fkrze3t _iajmze3t _z5wtze3t",
    selectedNotch: "_rfx3bx74 _1mp41y44 _1cs8stnw _1rusq98m _1kt9b3bt _1fkrutpp _iajmutpp _z5wtze3t",
    selected: "_bfhk15s3 _syaz6x5g _10536x5g _irr3ufnl _30l316jw _1di6nozp _9h8h6x5g",
    selectedOld: "_30l36x5g"
};
var $e8a7e6f1169b9266$var$spacingMapStyles = {
    cozy: "_1rjcu2gc _18zrpxbi",
    compact: "_1rjc1b66 _18zrutpp _1tkezwfg"
};
var $e8a7e6f1169b9266$var$gapMap = {
    compact: 'space.100',
    cozy: 'space.150'
};
/**
 * __Menu item primitive__
 *
 * Menu item primitive contains all the styles for menu items,
 * including support for selected, disabled, and interaction states.
 *
 * Using children as function prop you wire up this to your own host element.
 *
 * ```jsx
 * <MenuItemPrimitive>
 *   {({ children, ...props }) => <button {...props}>{children}</button>}
 * </MenuItemPrimitive>
 * ```
 */ var $e8a7e6f1169b9266$var$MenuItemPrimitive = function MenuItemPrimitive(_ref) {
    var children = _ref.children, title = _ref.title, description = _ref.description, iconAfter = _ref.iconAfter, iconBefore = _ref.iconBefore, UNSAFE_externalClassName = _ref.className, _ref$shouldTitleWrap = _ref.shouldTitleWrap, shouldTitleWrap = _ref$shouldTitleWrap === void 0 ? false : _ref$shouldTitleWrap, _ref$shouldDescriptio = _ref.shouldDescriptionWrap, shouldDescriptionWrap = _ref$shouldDescriptio === void 0 ? false : _ref$shouldDescriptio, _ref$isDisabled = _ref.isDisabled, isDisabled = _ref$isDisabled === void 0 ? false : _ref$isDisabled, _ref$isSelected = _ref.isSelected, isSelected = _ref$isSelected === void 0 ? false : _ref$isSelected, _ref$isTitleHeading = _ref.isTitleHeading, isTitleHeading = _ref$isTitleHeading === void 0 ? false : _ref$isTitleHeading, testId = _ref.testId;
    var spacing = (0, $5FkrB.useContext)((0, $8lsbk.SpacingContext));
    var selectionStyle = (0, $5FkrB.useContext)((0, $8lsbk.SELECTION_STYLE_CONTEXT_DO_NOT_USE));
    var UNSAFE_className = UNSAFE_externalClassName;
    return function() {
        return children({
            className: (0, $iW5R0.default)([
                (0, $iW5R0.default)([
                    $e8a7e6f1169b9266$var$styles.root,
                    $e8a7e6f1169b9266$var$spacingMapStyles[spacing],
                    !isDisabled && !isSelected && $e8a7e6f1169b9266$var$styles.unselected,
                    !isDisabled && isSelected && $e8a7e6f1169b9266$var$styles.selected,
                    !isDisabled && isSelected && $e8a7e6f1169b9266$var$styles.selectedOld,
                    !isDisabled && isSelected && selectionStyle === 'border' && $e8a7e6f1169b9266$var$styles.selectedBorder,
                    !isDisabled && isSelected && selectionStyle === 'notch' && $e8a7e6f1169b9266$var$styles.selectedNotch,
                    isDisabled && $e8a7e6f1169b9266$var$styles.disabled
                ]),
                UNSAFE_className
            ]),
            children: /*#__PURE__*/ $5FkrB.createElement((0, $4wE63.default), {
                as: "span",
                spread: "space-between",
                alignBlock: "center",
                space: $e8a7e6f1169b9266$var$gapMap[spacing],
                grow: "fill",
                testId: testId && "".concat(testId, "--container")
            }, iconBefore && /*#__PURE__*/ $5FkrB.createElement("span", {
                "data-item-elem-before": true,
                "data-testid": testId && "".concat(testId, "--icon-before"),
                className: (0, $iW5R0.default)([
                    $e8a7e6f1169b9266$var$styles.beforeAfterElement
                ])
            }, iconBefore), title && /*#__PURE__*/ $5FkrB.createElement("div", {
                className: (0, $iW5R0.default)([
                    $e8a7e6f1169b9266$var$styles.content
                ])
            }, $e8a7e6f1169b9266$var$renderTitle(isTitleHeading ? 'h2' : 'span', {
                children: title,
                className: (0, $iW5R0.default)([
                    $e8a7e6f1169b9266$var$styles.title,
                    shouldTitleWrap ? $e8a7e6f1169b9266$var$styles.wordBreak : $e8a7e6f1169b9266$var$styles.truncate
                ]),
                'data-item-title': true
            }), description && /*#__PURE__*/ $5FkrB.createElement("span", {
                "data-item-description": true,
                className: (0, $iW5R0.default)([
                    $e8a7e6f1169b9266$var$styles.description,
                    isDisabled && $e8a7e6f1169b9266$var$styles.disabledDescription,
                    shouldDescriptionWrap && $e8a7e6f1169b9266$var$styles.wordBreak,
                    !shouldDescriptionWrap && $e8a7e6f1169b9266$var$styles.truncate
                ])
            }, description)), iconAfter && /*#__PURE__*/ $5FkrB.createElement("span", {
                "data-item-elem-after": true,
                "data-testid": testId && "".concat(testId, "--icon-after"),
                className: (0, $iW5R0.default)([
                    $e8a7e6f1169b9266$var$styles.beforeAfterElement
                ])
            }, iconAfter))
        });
    }();
};
var $e8a7e6f1169b9266$export$2e2bcd8739ae039 = $e8a7e6f1169b9266$var$MenuItemPrimitive;

});
parcelRegister("4wE63", function(module, exports) {
$parcel$export(module.exports, "default", () => $34b940f448e1b4cb$export$2e2bcd8739ae039);
/* inline.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $kqp0i = parcelRequire("kqp0i");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");

var $iW5R0 = parcelRequire("iW5R0");

var $2JGJF = parcelRequire("2JGJF");

var $glEeU = parcelRequire("glEeU");
var $34b940f448e1b4cb$var$_excluded = [
    "as",
    "alignInline",
    "alignBlock",
    "shouldWrap",
    "spread",
    "grow",
    "space",
    "rowSpace",
    "separator",
    "xcss",
    "testId",
    "role",
    "children"
];
var $34b940f448e1b4cb$var$styles = {
    separator: "_1mouze3t _195g1i6y _syazjjyb _lcxvglyw _uiztglyw",
    hug: "_16jlidpf",
    fill: "_1bsb1osq _16jlkb7n"
};
var $34b940f448e1b4cb$var$Separator = function Separator(_ref) {
    var children = _ref.children;
    return /*#__PURE__*/ $5FkrB.createElement("span", {
        className: (0, $iW5R0.default)([
            $34b940f448e1b4cb$var$styles.separator
        ])
    }, children);
};
/**
 * __Inline__
 *
 * Inline is a primitive component based on CSS Flexbox that manages the horizontal layout of direct children.
 *
 * @example
 * ```tsx
 *  <Inline>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *  </Inline>
 * ```
 *
 */ var $34b940f448e1b4cb$var$Inline = /*#__PURE__*/ (0, $5FkrB.memo)(/*#__PURE__*/ (0, $5FkrB.forwardRef)(function(_ref2, ref) {
    var as = _ref2.as, alignInline = _ref2.alignInline, _ref2$alignBlock = _ref2.alignBlock, alignItems = _ref2$alignBlock === void 0 ? 'start' : _ref2$alignBlock, _ref2$shouldWrap = _ref2.shouldWrap, shouldWrap = _ref2$shouldWrap === void 0 ? false : _ref2$shouldWrap, spread = _ref2.spread, grow = _ref2.grow, space = _ref2.space, rowSpace = _ref2.rowSpace, separator = _ref2.separator, xcss = _ref2.xcss, testId = _ref2.testId, role = _ref2.role, rawChildren = _ref2.children, ariaAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref2, $34b940f448e1b4cb$var$_excluded);
    var separatorComponent = typeof separator === 'string' ? /*#__PURE__*/ $5FkrB.createElement($34b940f448e1b4cb$var$Separator, null, separator) : separator;
    var children = separatorComponent ? (0, $5FkrB.Children).toArray(rawChildren).filter(Boolean).map(function(child, index) {
        return /*#__PURE__*/ $5FkrB.createElement((0, $5FkrB.Fragment), {
            key: index
        }, separator && index > 0 ? separatorComponent : null, child);
    }) : rawChildren;
    return /*#__PURE__*/ $5FkrB.createElement((0, $glEeU.default), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, ariaAttributes, {
        as: as,
        role: role,
        alignItems: alignItems,
        justifyContent: spread || alignInline,
        direction: "row",
        gap: space,
        rowGap: rowSpace,
        wrap: shouldWrap ? 'wrap' : undefined,
        xcss: (0, $2JGJF.cx)(grow === 'hug' && $34b940f448e1b4cb$var$styles.hug, grow === 'fill' && $34b940f448e1b4cb$var$styles.fill, xcss),
        testId: testId,
        ref: ref
    }), children);
}));
$34b940f448e1b4cb$var$Inline.displayName = 'Inline';
var $34b940f448e1b4cb$export$2e2bcd8739ae039 = $34b940f448e1b4cb$var$Inline;

});
parcelRegister("2JGJF", function(module, exports) {
$parcel$export(module.exports, "cx", () => $1fe0ef23eecfb6d8$export$a274e22fb40f762e);
/* index.tsx generated by @compiled/babel-plugin v0.38.1 */ parcelRequire("5FkrB");


var $2ZxNY = parcelRequire("2ZxNY");
var $1fe0ef23eecfb6d8$var$strictApi = (0, $2ZxNY.createStrictAPI)();
var $1fe0ef23eecfb6d8$export$dbf350e5966cf602 = $1fe0ef23eecfb6d8$var$strictApi.css;
var $1fe0ef23eecfb6d8$export$eb1ecd84a24ee424 = $1fe0ef23eecfb6d8$var$strictApi.cssMap;
$1fe0ef23eecfb6d8$var$strictApi.cssMap;
var $1fe0ef23eecfb6d8$export$a274e22fb40f762e = $1fe0ef23eecfb6d8$var$strictApi.cx;
var $1fe0ef23eecfb6d8$var$XCSSProp = $1fe0ef23eecfb6d8$var$strictApi.XCSSProp; // This is to mitigate local TS error TS2315: Type 'StrictXCSSProp' is not generic.
 // Currently for some reason tsc is generating malformed .d.ts in local dev environment, below change fixes it
 /**
 * ## StrictXCSSProp
 *
 * Declare styles your component takes with all other styles marked as violations
 * by the TypeScript compiler. There are two primary use cases for xcss prop:
 *
 * - safe style overrides
 * - inverting style declarations
 *
 * Interverting style declarations is interesting for platform teams as
 * it means apps only pay for styles they use as they're now the ones who declare
 * the styles!
 *
 * The {@link StrictXCSSProp} type has generics two of which must be defined — use to explicitly
 * set what you want to maintain as API. Use {@link XCSSAllProperties} and {@link XCSSAllPseudos}
 * to enable all properties and pseudos.
 *
 * The third generic is used to declare what properties and pseudos should be required.
 *
 * ```tsx
 * interface MyComponentProps {
 *   // Color is accepted, all other properties / pseudos are considered violations.
 *   xcss?: StrictXCSSProp<'color', never>;
 *
 *   // Only background color and hover pseudo are accepted.
 *   xcss?: StrictXCSSProp<'backgroundColor', '&:hover'>;
 *
 *   // All properties are accepted, all pseudos are considered violations.
 *   xcss?: StrictXCSSProp<XCSSAllProperties, never>;
 *
 *   // All properties are accepted, only the hover pseudo is accepted.
 *   xcss?: StrictXCSSProp<XCSSAllProperties, '&:hover'>;
 *
 *   // The xcss prop is required as well as the color property. No pseudos are required.
 *   xcss: StrictXCSSProp<
 *     XCSSAllProperties,
 *     '&:hover',
 *     { requiredProperties: 'color', requiredPseudos: never }
 *   >;
 * }
 *
 * function MyComponent({ xcss }: MyComponentProps) {
 *   return <div css={{ color: 'var(--ds-text-danger)' }} className={xcss} />
 * }
 * ```
 *
 * The xcss prop works with static inline objects and the [cssMap](https://compiledcssinjs.com/docs/api-cssmap) API.
 *
 * ```jsx
 * // Declared as an inline object
 * <Component xcss={{ color: 'var(--ds-text)' }} />
 *
 * // Declared with the cssMap API
 * const styles = cssMap({ text: { color: 'var(--ds-text)' } });
 * <Component xcss={styles.text} />
 * ```
 *
 * To concatenate and conditonally apply styles use the {@link cssMap} and {@link cx} functions.
 */ 

});
parcelRegister("2ZxNY", function(module, exports) {
$parcel$export(module.exports, "createStrictAPI", () => $22db8044f9875d4d$export$39716b4af53f4ad);

var $nzsFK = parcelRequire("nzsFK");

var $gBPHU = parcelRequire("gBPHU");
function $22db8044f9875d4d$export$39716b4af53f4ad() {
    return {
        css () {
            throw (0, $nzsFK.createStrictSetupError)();
        },
        cssMap () {
            throw (0, $nzsFK.createStrictSetupError)();
        },
        cx: $gBPHU.cx,
        XCSSProp () {
            throw (0, $nzsFK.createStrictSetupError)();
        }
    };
}

});
parcelRegister("nzsFK", function(module, exports) {
$parcel$export(module.exports, "createStrictSetupError", () => $046da80108cc4f42$export$c4df1cb0c2b4d77c);
const $046da80108cc4f42$export$6c9a87045746941d = ()=>{
    return new Error(`
 \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2557}   \u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2557}     \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}
\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}
\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}   \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}  \u{2588}\u{2588}\u{2551}  \u{2588}\u{2588}\u{2551}
\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}   \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}\u{255A}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{255D} \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{255D}  \u{2588}\u{2588}\u{2551}  \u{2588}\u{2588}\u{2551}
\u{255A}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{255A}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551} \u{255A}\u{2550}\u{255D} \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}
 \u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D} \u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D} \u{255A}\u{2550}\u{255D}     \u{255A}\u{2550}\u{255D}\u{255A}\u{2550}\u{255D}     \u{255A}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}

  @compiled/react

  Code was executed when it shouldn't have. This could have happened because:

  1. You haven't configured a transformer yet. Visit https://compiledcssinjs.com/docs/installation and follow the instructions.
  2. You have duplicate versions of React and hooks are blowing up. You need to de-duplicate your dependencies.

  Good luck!
`);
};
const $046da80108cc4f42$export$c4df1cb0c2b4d77c = ()=>{
    return new Error(`
 \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2557}   \u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2557}     \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}
\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}
\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}   \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}  \u{2588}\u{2588}\u{2551}  \u{2588}\u{2588}\u{2551}
\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}   \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}\u{255A}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{255D} \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{255D}  \u{2588}\u{2588}\u{2551}  \u{2588}\u{2588}\u{2551}
\u{255A}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{255A}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551} \u{255A}\u{2550}\u{255D} \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}
 \u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D} \u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D} \u{255A}\u{2550}\u{255D}     \u{255A}\u{2550}\u{255D}\u{255A}\u{2550}\u{255D}     \u{255A}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}

  @compiled/react

  Code was executed when it shouldn't have. To resolve make sure to:

  1. Set up Compiled.
  2. Configure importSources in your Compiled config to point to the module that exports the output of createStrictAPI().

  For more information visit https://compiledcssinjs.com/docs/installation and follow the instructions.
`);
};

});

parcelRegister("gBPHU", function(module, exports) {
$parcel$export(module.exports, "cx", () => $c17836091b387076$export$a274e22fb40f762e);

var $lUuzY = parcelRequire("lUuzY");
const $c17836091b387076$export$a274e22fb40f762e = (...styles)=>{
    // At runtime TStyles is resolved down to strings, but not at compile time.
    // We circumvent the type system here because of that.
    const actualStyles = styles;
    // The output should be a union type of passed in styles. This ensures the call
    // site of xcss prop can raise violations when disallowed styles have been passed.
    return (0, $lUuzY.default)(actualStyles);
};

});
parcelRegister("lUuzY", function(module, exports) {
$parcel$export(module.exports, "default", () => $ff368c5ac6ab165b$export$2e2bcd8739ae039);
/**
 * This length includes the underscore,
 * e.g. `"_1s4A"` would be a valid atomic group hash.
 */ const $ff368c5ac6ab165b$var$ATOMIC_GROUP_LENGTH = 5;
function $ff368c5ac6ab165b$export$2e2bcd8739ae039(classNames) {
    // Shortcut: nothing to do
    if (!classNames.length) return;
    // Shortcut: don't need to do anything if we only have a single classname
    if (classNames.length === 1 && classNames[0] && // checking to see if `classNames[0]` is a string that contains other classnames
    !classNames[0].includes(' ')) return classNames[0];
    // Using an object rather than a `Map` as it performed better in our benchmarks.
    // Would be happy to move to `Map` if it proved to be better under real conditions.
    const map = {};
    // Note: using loops to minimize iterations over the collection
    for (const value of classNames){
        // Exclude all falsy values, which leaves us with populated strings
        if (!value) continue;
        // a `value` can contain multiple classnames
        const list = value.split(' ');
        for (const className of list){
            /**
             * For atomic style classnames: the `key` is the `group`
             *
             * - Later atomic classnames with the same `group` will override earlier ones
             *   (which is what we want).
             * - Assumes atomic classnames are the only things that start with `_`
             * - Could use a regex to ensure that atomic classnames are structured how we expect,
             *   but did not add that for now as it did slow things down a bit.
             *
             * For other classnames: the `key` is the whole classname
             * - Okay to remove duplicates as doing so does not impact specificity
             *
             * */ const key = className.startsWith('_') ? className.slice(0, $ff368c5ac6ab165b$var$ATOMIC_GROUP_LENGTH) : className;
            map[key] = className;
        }
    }
    /**
     * We are converting the `map` into a string.
     *
     * The simple way to do this would be `Object.values(map).join(' ')`.
     * However, the approach below performs 10%-20% better in benchmarks.
     *
     * For `ax()` it feels right to squeeze as much runtime performance out as we can.
     */ let result = '';
    for(const key in map)result += map[key] + ' ';
    // If we have an empty string, then our `map` was empty.
    if (!result) return;
    // remove last " " from the result (we added " " at the end of every value)
    return result.trimEnd();
}

});




parcelRegister("glEeU", function(module, exports) {
$parcel$export(module.exports, "default", () => $be6dd23e6fde68c9$export$2e2bcd8739ae039);
/* flex.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $kqp0i = parcelRequire("kqp0i");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");

var $iW5R0 = parcelRequire("iW5R0");
var $be6dd23e6fde68c9$var$_excluded = [
    "as",
    "role",
    "alignItems",
    "justifyContent",
    "gap",
    "columnGap",
    "rowGap",
    "children",
    "testId",
    "direction",
    "wrap",
    "xcss"
];
var $be6dd23e6fde68c9$var$rowGapMap = {
    'space.0': "_1p57ze3t",
    'space.025': "_1p57v77o",
    'space.050': "_1p571b66",
    'space.075': "_1p5712x7",
    'space.100': "_1p57u2gc",
    'space.150': "_1p57utpp",
    'space.200': "_1p57pxbi",
    'space.250': "_1p57v47k",
    'space.300': "_1p571ejb",
    'space.400': "_1p57xy5q",
    'space.500': "_1p571jfw",
    'space.600': "_1p57oahv",
    'space.800': "_1p57xncg",
    'space.1000': "_1p571epz"
};
var $be6dd23e6fde68c9$var$columnGapMap = {
    'space.0': "_gy1pze3t",
    'space.025': "_gy1pv77o",
    'space.050': "_gy1p1b66",
    'space.075': "_gy1p12x7",
    'space.100': "_gy1pu2gc",
    'space.150': "_gy1putpp",
    'space.200': "_gy1ppxbi",
    'space.250': "_gy1pv47k",
    'space.300': "_gy1p1ejb",
    'space.400': "_gy1pxy5q",
    'space.500': "_gy1p1jfw",
    'space.600': "_gy1poahv",
    'space.800': "_gy1pxncg",
    'space.1000': "_gy1p1epz"
};
var $be6dd23e6fde68c9$var$justifyContentMap = {
    start: "_1bahv2br",
    center: "_1bah1h6o",
    end: "_1bahh9n0",
    'space-between': "_1bah1yb4",
    'space-around': "_1bah1b1v",
    'space-evenly': "_1bahitcz",
    stretch: "_1bah1fhb"
};
var $be6dd23e6fde68c9$var$flexDirectionMap = {
    column: "_2lx21bp4",
    row: "_2lx2vrvc"
};
var $be6dd23e6fde68c9$var$flexWrapMap = {
    wrap: "_1n261g80",
    nowrap: "_1n261q9c"
};
var $be6dd23e6fde68c9$var$alignItemsMap = {
    start: "_4cvrv2br",
    center: "_4cvr1h6o",
    baseline: "_4cvr1q9y",
    end: "_4cvrh9n0",
    stretch: "_4cvr1fhb"
};
var $be6dd23e6fde68c9$var$styles = {
    root: "_1e0c1txw _vchhusvi"
};
/**
 * __Flex__
 *
 * `Flex` is a primitive component that implements the CSS Flexbox API.
 *
 * - [Examples](https://atlassian.design/components/primitives/flex/examples)
 * - [Code](https://atlassian.design/components/primitives/flex/code)
 *
 * @example
 * ```tsx
 * // eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
 * import { Flex, Box } from '@atlaskit/primitives'
 *
 * const Component = () => (
 *   <Flex direction="column">
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *   </Flex>
 * )
 * ```
 */ var $be6dd23e6fde68c9$var$Flex = /*#__PURE__*/ (0, $5FkrB.memo)(/*#__PURE__*/ (0, $5FkrB.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? 'div' : _ref$as, role = _ref.role, alignItems = _ref.alignItems, justifyContent = _ref.justifyContent, gap = _ref.gap, columnGap = _ref.columnGap, rowGap = _ref.rowGap, children = _ref.children, testId = _ref.testId, direction = _ref.direction, wrap = _ref.wrap, xcss = _ref.xcss, ariaAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $be6dd23e6fde68c9$var$_excluded);
    return /*#__PURE__*/ $5FkrB.createElement(Component, (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, ariaAttributes, {
        role: role,
        className: (0, $iW5R0.default)([
            $be6dd23e6fde68c9$var$styles.root,
            gap && $be6dd23e6fde68c9$var$columnGapMap[gap],
            columnGap && $be6dd23e6fde68c9$var$columnGapMap[columnGap],
            gap && $be6dd23e6fde68c9$var$rowGapMap[gap],
            rowGap && $be6dd23e6fde68c9$var$rowGapMap[rowGap],
            alignItems && $be6dd23e6fde68c9$var$alignItemsMap[alignItems],
            direction && $be6dd23e6fde68c9$var$flexDirectionMap[direction],
            justifyContent && $be6dd23e6fde68c9$var$justifyContentMap[justifyContent],
            wrap && $be6dd23e6fde68c9$var$flexWrapMap[wrap],
            xcss
        ]),
        "data-testid": testId,
        ref: ref
    }), children);
}));
$be6dd23e6fde68c9$var$Flex.displayName = 'Flex';
var $be6dd23e6fde68c9$export$2e2bcd8739ae039 = $be6dd23e6fde68c9$var$Flex;

});




parcelRegister("iB6Kj", function(module, exports) {
$parcel$export(module.exports, "default", () => $d8a0ea5404889157$export$2e2bcd8739ae039);
/* custom-item.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $kqp0i = parcelRequire("kqp0i");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");


var $eqVaP = parcelRequire("eqVaP");

var $jYq96 = parcelRequire("jYq96");
var $d8a0ea5404889157$var$_excluded = [
    "component",
    "isDisabled",
    "isSelected",
    "isTitleHeading",
    "onClick",
    "testId",
    "children",
    "description",
    "iconAfter",
    "iconBefore",
    "onMouseDown",
    "shouldTitleWrap",
    "shouldDescriptionWrap",
    "className",
    "UNSAFE_isDraggable",
    "interactionName"
];
var $d8a0ea5404889157$var$preventEvent = function preventEvent(e) {
    e.preventDefault();
};
// Dirty hack to get generics working with forward ref [1/2]
/**
 * __Custom item__
 *
 * A custom item is used to populate a menu with items that can be any element.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/menu/docs/custom-item)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/menu)
 */ var $d8a0ea5404889157$var$CustomItem = /*#__PURE__*/ (0, $5FkrB.memo)(/*#__PURE__*/ (0, $5FkrB.forwardRef)(function(_ref, ref) {
    var Component = _ref.component, _ref$isDisabled = _ref.isDisabled, isDisabled = _ref$isDisabled === void 0 ? false : _ref$isDisabled, _ref$isSelected = _ref.isSelected, isSelected = _ref$isSelected === void 0 ? false : _ref$isSelected, _ref$isTitleHeading = _ref.isTitleHeading, isTitleHeading = _ref$isTitleHeading === void 0 ? false : _ref$isTitleHeading, onClick = _ref.onClick, testId = _ref.testId, children = _ref.children, description = _ref.description, iconAfter = _ref.iconAfter, iconBefore = _ref.iconBefore, onMouseDown = _ref.onMouseDown, shouldTitleWrap = _ref.shouldTitleWrap, shouldDescriptionWrap = _ref.shouldDescriptionWrap, UNSAFE_className = _ref.className, UNSAFE_isDraggable = _ref.UNSAFE_isDraggable, interactionName = _ref.interactionName, rest = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $d8a0ea5404889157$var$_excluded);
    var onMouseDownHandler = onMouseDown;
    var interactionContext = (0, $5FkrB.useContext)((0, $eqVaP.default));
    var handleClick = (0, $5FkrB.useCallback)(function(e) {
        interactionContext === null || interactionContext === void 0 || interactionContext.tracePress(interactionName, e.timeStamp);
        onClick === null || onClick === void 0 || onClick(e);
    }, [
        onClick,
        interactionContext,
        interactionName
    ]);
    if (!Component) return null;
    return /*#__PURE__*/ $5FkrB.createElement((0, $jYq96.default), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        className: UNSAFE_className
    }, rest, {
        description: description,
        iconAfter: iconAfter,
        title: children,
        iconBefore: iconBefore,
        isSelected: isSelected,
        isDisabled: isDisabled,
        isTitleHeading: isTitleHeading,
        shouldTitleWrap: shouldTitleWrap,
        shouldDescriptionWrap: shouldDescriptionWrap,
        testId: testId && "".concat(testId, "--primitive")
    }), function(_ref2) {
        var children = _ref2.children, className = _ref2.className;
        return /*#__PURE__*/ $5FkrB.createElement(Component, (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
            "data-testid": testId
        }, rest, {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: className,
            ref: ref
        }, UNSAFE_isDraggable ? {} : {
            draggable: false,
            onDragStart: $d8a0ea5404889157$var$preventEvent
        }, {
            onMouseDown: isDisabled ? $d8a0ea5404889157$var$preventEvent : onMouseDownHandler,
            onClick: isDisabled ? $d8a0ea5404889157$var$preventEvent : handleClick,
            tabIndex: isDisabled ? -1 : undefined,
            "aria-disabled": isDisabled
        }), children);
    });
}));
var $d8a0ea5404889157$export$2e2bcd8739ae039 = $d8a0ea5404889157$var$CustomItem;

});

parcelRegister("9oB2j", function(module, exports) {
$parcel$export(module.exports, "default", () => $6d73159b7210a631$export$2e2bcd8739ae039);
/* link-item.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $kqp0i = parcelRequire("kqp0i");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");


var $3oiAV = parcelRequire("3oiAV");

var $eqVaP = parcelRequire("eqVaP");

var $jYq96 = parcelRequire("jYq96");
var $6d73159b7210a631$var$_excluded = [
    "children",
    "href",
    "description",
    "iconAfter",
    "iconBefore",
    "isDisabled",
    "isSelected",
    "onClick",
    "testId",
    "onMouseDown",
    "shouldTitleWrap",
    "shouldDescriptionWrap",
    "className",
    "UNSAFE_shouldDisableRouterLink",
    "UNSAFE_isDraggable",
    "interactionName"
];
var $6d73159b7210a631$var$IS_EXTERNAL_LINK_REGEX = /^(?:(http|https):\/\/)/;
var $6d73159b7210a631$var$IS_NON_HTTP_BASED = /^(((mailto|tel|sms):)|(#))/;
var $6d73159b7210a631$var$preventEvent = function preventEvent(e) {
    e.preventDefault();
};
/**
 * __Link item__
 *
 * A link item is used to populate a menu with items that are links.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/menu/docs/link-item)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/menu)
 */ var $6d73159b7210a631$var$LinkItem = /*#__PURE__*/ (0, $5FkrB.memo)(/*#__PURE__*/ (0, $5FkrB.forwardRef)(function(props, ref) {
    var children = props.children, href = props.href, description = props.description, iconAfter = props.iconAfter, iconBefore = props.iconBefore, _props$isDisabled = props.isDisabled, isDisabled = _props$isDisabled === void 0 ? false : _props$isDisabled, _props$isSelected = props.isSelected, isSelected = _props$isSelected === void 0 ? false : _props$isSelected, onClick = props.onClick, testId = props.testId, onMouseDown = props.onMouseDown, shouldTitleWrap = props.shouldTitleWrap, shouldDescriptionWrap = props.shouldDescriptionWrap, UNSAFE_className = props.className, UNSAFE_shouldDisableRouterLink = props.UNSAFE_shouldDisableRouterLink, UNSAFE_isDraggable = props.UNSAFE_isDraggable, interactionName = props.interactionName, rest = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(props, $6d73159b7210a631$var$_excluded);
    var onMouseDownHandler = onMouseDown;
    var RouterLink = (0, $3oiAV.default)();
    var interactionContext = (0, $5FkrB.useContext)((0, $eqVaP.default));
    var handleClick = (0, $5FkrB.useCallback)(function(e) {
        interactionContext === null || interactionContext === void 0 || interactionContext.tracePress(interactionName, e.timeStamp);
        onClick === null || onClick === void 0 || onClick(e);
    }, [
        onClick,
        interactionContext,
        interactionName
    ]);
    if (!children) return null;
    var isExternal = typeof href === 'string' && $6d73159b7210a631$var$IS_EXTERNAL_LINK_REGEX.test(href);
    var isNonHttpBased = typeof href === 'string' && $6d73159b7210a631$var$IS_NON_HTTP_BASED.test(href);
    var isEmptyHref = href == null || href === '';
    /**
   * Renders a router link if:
   *
   * - a link component is set in the app provider
   * - it's not an external link (starting with `http://` or `https://`)
   * - it's not a non-HTTP-based link (e.g. emails, phone numbers, hash links etc.)
   * - it doesn't have an empty href (e.g. href="" or href={undefined})
   */ var isRouterLink = !UNSAFE_shouldDisableRouterLink && RouterLink && !isExternal && !isNonHttpBased && !isEmptyHref;
    var Component = isRouterLink ? RouterLink : 'a';
    return /*#__PURE__*/ $5FkrB.createElement((0, $jYq96.default), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, rest, {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: UNSAFE_className,
        iconBefore: iconBefore,
        iconAfter: iconAfter,
        isSelected: isSelected,
        isDisabled: isDisabled,
        isTitleHeading: false,
        description: description,
        shouldTitleWrap: shouldTitleWrap,
        shouldDescriptionWrap: shouldDescriptionWrap,
        title: children,
        testId: testId && "".concat(testId, "--primitive")
    }), function(_ref) {
        var children = _ref.children, className = _ref.className;
        return /*#__PURE__*/ $5FkrB.createElement(Component, (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
            "data-testid": testId,
            "data-is-router-link": testId ? isRouterLink ? 'true' : 'false' : undefined,
            "data-vc": "link-item"
        }, rest, {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: className,
            href: isDisabled ? undefined : href
        }, UNSAFE_isDraggable ? {} : {
            draggable: false,
            onDragStart: $6d73159b7210a631$var$preventEvent
        }, {
            onMouseDown: isDisabled ? $6d73159b7210a631$var$preventEvent : onMouseDownHandler,
            onClick: isDisabled ? $6d73159b7210a631$var$preventEvent : handleClick,
            "aria-current": isSelected ? 'page' : undefined,
            "aria-disabled": isDisabled,
            ref: ref
        }), children);
    });
}));
var $6d73159b7210a631$export$2e2bcd8739ae039 = $6d73159b7210a631$var$LinkItem;

});
parcelRegister("3oiAV", function(module, exports) {
$parcel$export(module.exports, "default", () => $2782097c22271dd5$export$2e2bcd8739ae039);

var $5FkrB = parcelRequire("5FkrB");

var $eyA1C = parcelRequire("eyA1C");
/**
 * __useRouterLink()__
 *
 * Hook: Returns app-configured router link component.
 *
 * A generic can be passed to define advanced link configuration:
 * ```
 * type MyRouterLinkConfig = {
 *  to: string;
 *  replace?: boolean;
 * }
 *
 * const RouterLink = useRouterLink<MyRouterLinkConfig>();
 * ```
 */ var $2782097c22271dd5$var$useRouterLink = function useRouterLink() {
    var _useContext = (0, $5FkrB.useContext)((0, $eyA1C.RouterLinkProviderContext)), routerLinkComponent = _useContext.routerLinkComponent;
    if (routerLinkComponent) return routerLinkComponent;
    return;
};
var $2782097c22271dd5$export$2e2bcd8739ae039 = $2782097c22271dd5$var$useRouterLink;

});
parcelRegister("eyA1C", function(module, exports) {
$parcel$export(module.exports, "RouterLinkProviderContext", () => $a9902f7f00429889$export$2931e0ee690eee88);

var $5FkrB = parcelRequire("5FkrB");
var $a9902f7f00429889$export$2931e0ee690eee88 = /*#__PURE__*/ (0, $5FkrB.createContext)({});
/**
 * __RouterLinkProvider__
 *
 * Provides a configured router link component for use
 * within Design System components.
 */ var $a9902f7f00429889$var$RouterLinkProvider = function RouterLinkProvider(_ref) {
    var routerLinkComponent = _ref.routerLinkComponent, children = _ref.children;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement($a9902f7f00429889$export$2931e0ee690eee88.Provider, {
        value: {
            routerLinkComponent: routerLinkComponent
        }
    }, children);
};
var $a9902f7f00429889$export$2e2bcd8739ae039 = $a9902f7f00429889$var$RouterLinkProvider;

});



parcelRegister("dP4A1", function(module, exports) {
$parcel$export(module.exports, "default", () => $a1039742673729c1$export$2e2bcd8739ae039);
/* section.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $kqp0i = parcelRequire("kqp0i");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");

var $iW5R0 = parcelRequire("iW5R0");

var $64sIK = parcelRequire("64sIK");
var $a1039742673729c1$var$_excluded = [
    "children",
    "title",
    "titleId",
    "testId",
    "isScrollable",
    "hasSeparator",
    "id",
    "isList",
    "isSideNavSection",
    "label",
    "className"
];
var $a1039742673729c1$var$itemHeadingTopMargin = 20;
var $a1039742673729c1$var$itemHeadingBottomMargin = 6;
// Skeleton content is slightly shorter than the real content.
// Because of that we slightly increase the top margin to offset this so the
// containing size both real and skeleton always equal approx 30px.
var $a1039742673729c1$var$itemHeadingContentHeight = 16; // Originally headingSizes.h100.lineHeight from '@atlaskit/theme/typography'
var $a1039742673729c1$var$skeletonHeadingHeight = 8;
var $a1039742673729c1$var$skeletonHeadingMarginOffset = 3;
var $a1039742673729c1$var$skeletonHeadingTopMargin = $a1039742673729c1$var$itemHeadingTopMargin + ($a1039742673729c1$var$itemHeadingContentHeight - $a1039742673729c1$var$skeletonHeadingHeight) - $a1039742673729c1$var$skeletonHeadingMarginOffset;
var $a1039742673729c1$var$sectionPaddingTopBottom = 6;
var $a1039742673729c1$var$styles = {
    root: "_1ywu1ule _cfu11ule _1qdgi2wt _kfgti2wt _aetrb3bt _1kt9b3bt _1p3hi2wt _1l6bgktf _osbldlk8 _auo4rdoj _hp2110yn _1mfv8jkm _1bg41n1a",
    scrollable: "_1reo1wug _18m91wug _1o9zkb7n",
    unscrollable: "_1o9zidpf",
    thinSeparator: "_mqm2lllh",
    noSeparator: "_n7cnyjp0",
    sideNavSectionHeading: "_18zru2gc"
};
/**
 * __Section__
 *
 * A section includes related actions or items in a menu.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/menu/docs/section)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/menu)
 */ var $a1039742673729c1$var$Section = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function(_ref, ref) {
    var children = _ref.children, title = _ref.title, titleId = _ref.titleId, testId = _ref.testId, isScrollable = _ref.isScrollable, hasSeparator = _ref.hasSeparator, id = _ref.id, _ref$isList = _ref.isList, isList = _ref$isList === void 0 ? false : _ref$isList, _ref$isSideNavSection = _ref.isSideNavSection, isSideNavSection = _ref$isSideNavSection === void 0 ? false : _ref$isSideNavSection, label = _ref.label, UNSAFE_className = _ref.className, rest = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $a1039742673729c1$var$_excluded);
    var content = isList ? /*#__PURE__*/ $5FkrB.createElement("ul", {
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            margin: 0,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            padding: 0
        }
    }, (0, $5FkrB.Children).map((0, $5FkrB.Children).toArray(children), function(child, index) {
        return /*#__PURE__*/ $5FkrB.createElement("li", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            style: {
                listStyleType: 'none',
                margin: 0,
                padding: 0
            },
            key: index
        }, child);
    })) : children;
    var childrenMarkup = title !== undefined ? /*#__PURE__*/ $5FkrB.createElement((0, $5FkrB.Fragment), null, /*#__PURE__*/ $5FkrB.createElement((0, $64sIK.default), {
        testId: testId && "".concat(testId, "--heading"),
        "aria-hidden": true,
        className: (0, $iW5R0.default)([
            isSideNavSection && $a1039742673729c1$var$styles.sideNavSectionHeading
        ])
    }, title), content) : /*#__PURE__*/ $5FkrB.createElement((0, $5FkrB.Fragment), null, content);
    return /*#__PURE__*/ $5FkrB.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, rest, {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $iW5R0.default)([
            $a1039742673729c1$var$styles.root,
            isScrollable ? $a1039742673729c1$var$styles.scrollable : $a1039742673729c1$var$styles.unscrollable,
            hasSeparator ? $a1039742673729c1$var$styles.thinSeparator : $a1039742673729c1$var$styles.noSeparator,
            UNSAFE_className
        ]),
        id: id,
        "aria-label": title || label,
        "aria-labelledby": titleId,
        "data-testid": testId,
        role: "group",
        "data-section": true,
        ref: ref
    }), childrenMarkup);
});
var $a1039742673729c1$export$2e2bcd8739ae039 = $a1039742673729c1$var$Section;

});
parcelRegister("64sIK", function(module, exports) {
$parcel$export(module.exports, "default", () => $46b965266d32e6bc$export$2e2bcd8739ae039);
/* heading-item.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $kqp0i = parcelRequire("kqp0i");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");

var $iW5R0 = parcelRequire("iW5R0");
var $46b965266d32e6bc$var$_excluded = [
    "children",
    "testId",
    "headingLevel",
    "id",
    "className"
];
var $46b965266d32e6bc$var$headingStyles = null;
/**
 * __Heading item__
 *
 * A heading item is used to describe sibling menu items.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/menu/docs/heading-item)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/menu)
 */ var $46b965266d32e6bc$var$HeadingItem = /*#__PURE__*/ (0, $5FkrB.memo)(function(_ref) {
    var children = _ref.children, testId = _ref.testId, _ref$headingLevel = _ref.headingLevel, headingLevel = _ref$headingLevel === void 0 ? 2 : _ref$headingLevel, id = _ref.id, UNSAFE_className = _ref.className, rest = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $46b965266d32e6bc$var$_excluded);
    return /*#__PURE__*/ $5FkrB.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        role: "heading",
        "aria-level": headingLevel,
        "data-testid": testId,
        "data-ds--menu--heading-item": true,
        id: id,
        className: (0, $iW5R0.default)([
            "_11c8i4vh _1rjcze3t _18zrpxbi _syazazsu",
            UNSAFE_className
        ])
    }, rest), children);
});
var $46b965266d32e6bc$export$2e2bcd8739ae039 = $46b965266d32e6bc$var$HeadingItem;

});


parcelRegister("4r3Kr", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::8ee9ad5072a30451ff7ca2ddc0961d03>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $33ac9753a867fbba$var$_react = $33ac9753a867fbba$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $33ac9753a867fbba$var$_baseNew = $33ac9753a867fbba$var$_interopRequireDefault((parcelRequire("axuVY")));
function $33ac9753a867fbba$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ChevronLeft".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Do not use 16px chevrons within buttons, icon buttons, or dropdowns to maintain visual cohesion with ADS which uses 12px chevrons.
Known uses: Navigate back, show previous page of pagination results
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $33ac9753a867fbba$var$ChevronLeftIcon = (props)=>/*#__PURE__*/ $33ac9753a867fbba$var$_react.default.createElement($33ac9753a867fbba$var$_baseNew.default, Object.assign({
        name: "ChevronLeftIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="m9.97 1.47-6 6a.75.75 0 0 0-.052 1.004l.052.056 6 6 1.06-1.06L5.56 8l5.47-5.47z"/>`
    }, props));
$33ac9753a867fbba$var$ChevronLeftIcon.displayName = 'ChevronLeftIcon';
var $33ac9753a867fbba$var$_default = module.exports.default = $33ac9753a867fbba$var$ChevronLeftIcon;

});

parcelRegister("5FzFD", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $420c7388e43244fe$var$_react = $420c7388e43244fe$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $2SuPM = parcelRequire("2SuPM");
function $420c7388e43244fe$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $420c7388e43244fe$var$ChevronLeftIcon = (props)=>/*#__PURE__*/ $420c7388e43244fe$var$_react.default.createElement($2SuPM.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M13.706 9.698a.99.99 0 0 0 0-1.407 1.01 1.01 0 0 0-1.419 0l-2.965 2.94a1.09 1.09 0 0 0 0 1.548l2.955 2.93a1.01 1.01 0 0 0 1.42 0 .99.99 0 0 0 0-1.407l-2.318-2.297z"/></svg>`
    }, props));
$420c7388e43244fe$var$ChevronLeftIcon.displayName = 'ChevronLeftIcon';
var $420c7388e43244fe$var$_default = module.exports.default = $420c7388e43244fe$var$ChevronLeftIcon;

});

parcelRegister("aMiKe", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::fbc9eb298cfdac722b50cf5246108693>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7d8ced6060a88250$var$_react = $7d8ced6060a88250$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $7d8ced6060a88250$var$_baseNew = $7d8ced6060a88250$var$_interopRequireDefault((parcelRequire("axuVY")));
function $7d8ced6060a88250$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ChevronRight".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Do not use 16px chevrons within buttons, icon buttons, or dropdowns to maintain visual cohesion with ADS which uses 12px chevrons.
Known uses: Next page of pagination results, collapsed tree item, expand tree item
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $7d8ced6060a88250$var$ChevronRightIcon = (props)=>/*#__PURE__*/ $7d8ced6060a88250$var$_react.default.createElement($7d8ced6060a88250$var$_baseNew.default, Object.assign({
        name: "ChevronRightIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="m6.03 1.47 6 6a.75.75 0 0 1 .052 1.004l-.052.056-6 6-1.06-1.06L10.44 8 4.97 2.53z"/>`
    }, props));
$7d8ced6060a88250$var$ChevronRightIcon.displayName = 'ChevronRightIcon';
var $7d8ced6060a88250$var$_default = module.exports.default = $7d8ced6060a88250$var$ChevronRightIcon;

});

parcelRegister("APOYr", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $06eb8f829a476466$var$_react = $06eb8f829a476466$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $2SuPM = parcelRequire("2SuPM");
function $06eb8f829a476466$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $06eb8f829a476466$var$ChevronRightIcon = (props)=>/*#__PURE__*/ $06eb8f829a476466$var$_react.default.createElement($2SuPM.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M10.294 9.698a.99.99 0 0 1 0-1.407 1.01 1.01 0 0 1 1.419 0l2.965 2.94a1.09 1.09 0 0 1 0 1.548l-2.955 2.93a1.01 1.01 0 0 1-1.42 0 .99.99 0 0 1 0-1.407l2.318-2.297z"/></svg>`
    }, props));
$06eb8f829a476466$var$ChevronRightIcon.displayName = 'ChevronRightIcon';
var $06eb8f829a476466$var$_default = module.exports.default = $06eb8f829a476466$var$ChevronRightIcon;

});

parcelRegister("5tQm9", function(module, exports) {
$parcel$export(module.exports, "default", () => $3fd84610385902f8$export$2e2bcd8739ae039);

var $25nEq = parcelRequire("25nEq");

var $5FkrB = parcelRequire("5FkrB");

var $2DGGf = parcelRequire("2DGGf");

var $elG2K = parcelRequire("elG2K");

var $klKsD = parcelRequire("klKsD");
function $3fd84610385902f8$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $3fd84610385902f8$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $3fd84610385902f8$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $3fd84610385902f8$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $3fd84610385902f8$export$2e2bcd8739ae039(_ref) {
    var loaderFn = _ref.loaderFn, children = _ref.children, defaultMessages = _ref.defaultMessages;
    var intl = (0, $klKsD.useSafeIntl)();
    var messages = (0, $elG2K.useMessages)(intl.locale, loaderFn);
    /**
   * IntlProvider does not inherit from upstream IntlProviders,
   * we lookup messages in the context and pass them downstream
   * This prevents the missing messages error
   */ var mergedMessages = (0, $5FkrB.useMemo)(function() {
        return $3fd84610385902f8$var$_objectSpread($3fd84610385902f8$var$_objectSpread($3fd84610385902f8$var$_objectSpread({}, defaultMessages), intl.messages), messages);
    }, [
        intl,
        messages,
        defaultMessages
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $2DGGf.default), {
        defaultLocale: "en",
        locale: intl.locale,
        onError: intl.onError,
        messages: mergedMessages
    }, children);
}

});
parcelRegister("elG2K", function(module, exports) {
$parcel$export(module.exports, "useMessages", () => $a723a3ce07aeaf5d$export$4d17e2d9c5348842);

var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");

var $8FEOs = parcelRequire("8FEOs");
var $a723a3ce07aeaf5d$export$4d17e2d9c5348842 = function useMessages(locale, loaderFn) {
    var _useState = (0, $5FkrB.useState)((0, $8FEOs.DEFAULT_LOCALE_STATE)), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), localeState = _useState2[0], setLocaleState = _useState2[1];
    (0, $5FkrB.useEffect)(function() {
        if (!localeState.messages || locale !== localeState.locale) {
            var current = true;
            loaderFn(locale).then(function(messages) {
                if (current) setLocaleState({
                    locale: locale,
                    messages: messages !== null && messages !== void 0 ? messages : {}
                });
            });
            return function() {
                current = false;
            };
        }
    }, [
        loaderFn,
        locale,
        localeState
    ]);
    return localeState.messages;
};

});
parcelRegister("8FEOs", function(module, exports) {
$parcel$export(module.exports, "DEFAULT_LOCALE_STATE", () => $6501cfa6d304229b$export$79618bef82c02d4c);
var $6501cfa6d304229b$export$79618bef82c02d4c = {
    locale: 'en',
    messages: {}
};

});


parcelRegister("klKsD", function(module, exports) {
$parcel$export(module.exports, "useSafeIntl", () => $ed09cef97ff629d0$export$f752ac21ea3960a5);

var $5FkrB = parcelRequire("5FkrB");

var $2DGGf = parcelRequire("2DGGf");
var $ftB2S = parcelRequire("ftB2S");
var $3IjMA = parcelRequire("3IjMA");

var $8FEOs = parcelRequire("8FEOs");
// Prevents memory leaks
var $ed09cef97ff629d0$var$cache = (0, $ftB2S.createIntlCache)();
var $ed09cef97ff629d0$export$f752ac21ea3960a5 = function useSafeIntl() {
    var context = (0, $5FkrB.useContext)((0, $3IjMA.Context));
    if (!context) return (0, $2DGGf.createIntl)((0, $8FEOs.DEFAULT_LOCALE_STATE), $ed09cef97ff629d0$var$cache);
    return context;
};

});


parcelRegister("i2C5U", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $d225f6a1c2f7387a$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //
var $d225f6a1c2f7387a$export$2e2bcd8739ae039 = {
    'admin-hub-pagination.next.page.button': 'Next',
    'admin-hub-pagination.page.range': '{itemsStart} to {itemsEnd} results',
    'admin-hub-pagination.page.range.with.total': '{itemsStart} to {itemsEnd} of {totalCount, plural, one {# result} other {# results}}',
    'admin-hub-pagination.previous.page.button': 'Previous',
    'admin-hub-pagination.refresh.count.current': 'Showing {currentCount, plural, one {# result} other {# results}} out of {totalCount} {label}',
    'admin-hub-pagination.refresh.count.total': 'Showing {totalCount} {label}',
    'admin-hub-pagination.refresh.item.default.label': '{totalCount, plural, one {Item} other {Items}}',
    'admin-hub-pagination.refresh.label': 'Refresh',
    'admin-hub-pagination.refresh.loading': 'Checking for updates',
    'admin-hub-pagination.result.per.page': 'Results per page:'
};

});

parcelRegister("7BOim", function(module, exports) {

var $iKwew = parcelRequire("iKwew");
module.exports = $iKwew("ecpS4").then(()=>parcelRequire('cBDH5'));

});

parcelRegister("lBZGT", function(module, exports) {

var $iKwew = parcelRequire("iKwew");
module.exports = $iKwew("dF9jh").then(()=>parcelRequire('bxiND'));

});

parcelRegister("bGn3J", function(module, exports) {

var $iKwew = parcelRequire("iKwew");
module.exports = $iKwew("g0gY2").then(()=>parcelRequire('45lp9'));

});

parcelRegister("kbs14", function(module, exports) {

var $iKwew = parcelRequire("iKwew");
module.exports = $iKwew("leOE2").then(()=>parcelRequire('drZZD'));

});

parcelRegister("he924", function(module, exports) {

var $iKwew = parcelRequire("iKwew");
module.exports = $iKwew("2SeHx").then(()=>parcelRequire('3AVeU'));

});

parcelRegister("6n0tt", function(module, exports) {

var $iKwew = parcelRequire("iKwew");
module.exports = $iKwew("zCgEk").then(()=>parcelRequire('3VY9x'));

});

parcelRegister("jpANc", function(module, exports) {

var $iKwew = parcelRequire("iKwew");
module.exports = $iKwew("fBQVT").then(()=>parcelRequire('2Xttc'));

});

parcelRegister("a0R1n", function(module, exports) {

var $iKwew = parcelRequire("iKwew");
module.exports = $iKwew("bsAI3").then(()=>parcelRequire('kprYx'));

});

parcelRegister("8oykS", function(module, exports) {

var $iKwew = parcelRequire("iKwew");
module.exports = $iKwew("lVjdg").then(()=>parcelRequire('eL7Qk'));

});

parcelRegister("4GjoG", function(module, exports) {

var $iKwew = parcelRequire("iKwew");
module.exports = $iKwew("iYq5l").then(()=>parcelRequire('l98DB'));

});

parcelRegister("inXrq", function(module, exports) {

var $iKwew = parcelRequire("iKwew");
module.exports = $iKwew("8ucTx").then(()=>parcelRequire('aCvFC'));

});

parcelRegister("ix375", function(module, exports) {

var $iKwew = parcelRequire("iKwew");
module.exports = $iKwew("eQ9ej").then(()=>parcelRequire('bxogB'));

});

parcelRegister("8NjuC", function(module, exports) {

var $iKwew = parcelRequire("iKwew");
module.exports = $iKwew("7TvKW").then(()=>parcelRequire('cLG0i'));

});

parcelRegister("5kzPX", function(module, exports) {

var $iKwew = parcelRequire("iKwew");
module.exports = $iKwew("bVq9q").then(()=>parcelRequire('ja1CQ'));

});

parcelRegister("7jwnm", function(module, exports) {

var $iKwew = parcelRequire("iKwew");
module.exports = $iKwew("eOaQO").then(()=>parcelRequire('5pB62'));

});

parcelRegister("73JLl", function(module, exports) {

var $iKwew = parcelRequire("iKwew");
module.exports = $iKwew("7Kmqe").then(()=>parcelRequire('gR32c'));

});

parcelRegister("01W4K", function(module, exports) {

var $iKwew = parcelRequire("iKwew");
module.exports = $iKwew("jnig0").then(()=>parcelRequire('hvq8N'));

});

parcelRegister("hGuAk", function(module, exports) {

var $iKwew = parcelRequire("iKwew");
module.exports = $iKwew("agclC").then(()=>parcelRequire('bnAcp'));

});

parcelRegister("e2uAj", function(module, exports) {

var $iKwew = parcelRequire("iKwew");
module.exports = $iKwew("aoRLF").then(()=>parcelRequire('iNlfw'));

});

parcelRegister("b9qm9", function(module, exports) {

var $iKwew = parcelRequire("iKwew");
module.exports = $iKwew("ceIx6").then(()=>parcelRequire('jhqka'));

});

parcelRegister("hk4dg", function(module, exports) {

var $iKwew = parcelRequire("iKwew");
module.exports = $iKwew("gwgSb").then(()=>parcelRequire('gpe45'));

});

parcelRegister("Jx3pr", function(module, exports) {

var $iKwew = parcelRequire("iKwew");
module.exports = $iKwew("9VMXq").then(()=>parcelRequire('3M7Lu'));

});

parcelRegister("cFvPh", function(module, exports) {

var $iKwew = parcelRequire("iKwew");
module.exports = $iKwew("c2QZs").then(()=>parcelRequire('kQvT3'));

});

parcelRegister("hwI6q", function(module, exports) {

var $iKwew = parcelRequire("iKwew");
module.exports = $iKwew("efLrJ").then(()=>parcelRequire('li3kc'));

});

parcelRegister("7WAD0", function(module, exports) {
/**
 * This method returns `undefined`.
 *
 * @static
 * @memberOf _
 * @since 2.3.0
 * @category Util
 * @example
 *
 * _.times(2, _.noop);
 * // => [undefined, undefined]
 */ function $5c8a5cc9c3b8635c$var$noop() {
// No operation performed.
}
module.exports = $5c8a5cc9c3b8635c$var$noop;

});

parcelRegister("8IltX", function(module, exports) {
$parcel$export(module.exports, "LevelContext", () => $658318ae57c6ed29$export$650d12d3c2ddb8fc);
$parcel$export(module.exports, "LevelNodeContext", () => $658318ae57c6ed29$export$18f4d8b5b3a77f59);
$parcel$export(module.exports, "RootNodeContext", () => $658318ae57c6ed29$export$fa973f110e8f6ca8);
$parcel$export(module.exports, "Layering", () => $658318ae57c6ed29$export$7c885f891c940977);

var $5FkrB = parcelRequire("5FkrB");

var $bITpv = parcelRequire("bITpv");
var $658318ae57c6ed29$export$650d12d3c2ddb8fc = /*#__PURE__*/ (0, $5FkrB.createContext)(0);
var $658318ae57c6ed29$export$18f4d8b5b3a77f59 = /*#__PURE__*/ (0, $5FkrB.createContext)({
    current: null
});
var $658318ae57c6ed29$export$fa973f110e8f6ca8 = /*#__PURE__*/ (0, $5FkrB.createContext)({
    current: null
});
/**
 *
 *  @internal
 * Context Provider Component which provider the current level of nested layers
 * It handles level management when it mounts and unmounts
 *
 */ var $658318ae57c6ed29$var$LevelProvider = function LevelProvider(_ref) {
    var children = _ref.children, currentLevel = _ref.currentLevel, levelNode = _ref.node;
    (0, $5FkrB.useEffect)(function() {
        var levelNodeSafe = levelNode.current;
        var parentNode = levelNodeSafe.parent;
        parentNode === null || parentNode === void 0 || parentNode.addChild(levelNodeSafe);
        return function() {
            parentNode === null || parentNode === void 0 || parentNode.removeChild(levelNodeSafe);
        };
    }, [
        levelNode
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement($658318ae57c6ed29$export$650d12d3c2ddb8fc.Provider, {
        value: currentLevel
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement($658318ae57c6ed29$export$18f4d8b5b3a77f59.Provider, {
        value: levelNode
    }, children));
};
var $658318ae57c6ed29$export$7c885f891c940977 = function Layering(_ref2) {
    var children = _ref2.children, _ref2$isDisabled = _ref2.isDisabled, isDisabled = _ref2$isDisabled === void 0 ? true : _ref2$isDisabled;
    var currentLevel = (0, $5FkrB.useContext)($658318ae57c6ed29$export$650d12d3c2ddb8fc);
    var parentNode = (0, $5FkrB.useContext)($658318ae57c6ed29$export$18f4d8b5b3a77f59);
    // eslint-disable-next-line  @repo/internal/react/disallow-unstable-values
    var newNode = (0, $5FkrB.useRef)(new (0, $bITpv.LayerNode)(Math.random().toString(36), parentNode.current));
    if (isDisabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).Fragment, null, children);
    var isNested = currentLevel > 0;
    var content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement($658318ae57c6ed29$var$LevelProvider, {
        currentLevel: currentLevel + 1,
        node: newNode
    }, children);
    return isNested ? content : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement($658318ae57c6ed29$export$fa973f110e8f6ca8.Provider, {
        value: newNode
    }, content);
};

});
parcelRegister("bITpv", function(module, exports) {
$parcel$export(module.exports, "LayerNode", () => $888ec9232a0c31a2$export$da4f61fd78d35243);

var $fC8ib = parcelRequire("fC8ib");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");
var $888ec9232a0c31a2$export$da4f61fd78d35243 = /*#__PURE__*/ function() {
    function LayerNode(id, parent) {
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, LayerNode);
        this.id = id;
        this.childNodes = [];
        this.parent = parent;
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(LayerNode, [
        {
            key: "addChild",
            value: function addChild(node) {
                this.childNodes.push(node);
            }
        },
        {
            key: "removeChild",
            value: function removeChild(node) {
                this.childNodes = this.childNodes.filter(function(child) {
                    return child.id !== node.id;
                });
            }
        },
        {
            key: "getLevel",
            value: function getLevel() {
                if (!this.parent) return 1;
                return this.parent.getLevel() + 1;
            }
        },
        {
            key: "getHeight",
            value: function getHeight() {
                if (this.childNodes.length === 0) return 1;
                return Math.max.apply(Math, (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(this.childNodes.map(function(child) {
                    return child.getHeight();
                }))) + 1;
            }
        }
    ]);
}();

});


parcelRegister("iy6kx", function(module, exports) {
$parcel$export(module.exports, "THEME_DATA_ATTRIBUTE", () => $d8105008396b7efa$export$4ef52930e33717cd);
$parcel$export(module.exports, "SUBTREE_THEME_ATTRIBUTE", () => $d8105008396b7efa$export$cb374d25ded7f6ab);
$parcel$export(module.exports, "COLOR_MODE_ATTRIBUTE", () => $d8105008396b7efa$export$a00eac3f8684bcd0);
$parcel$export(module.exports, "CONTRAST_MODE_ATTRIBUTE", () => $d8105008396b7efa$export$2112803007239c61);
$parcel$export(module.exports, "CUSTOM_THEME_ATTRIBUTE", () => $d8105008396b7efa$export$352e418ed5b6193a);
$parcel$export(module.exports, "CURRENT_SURFACE_CSS_VAR", () => $d8105008396b7efa$export$9d7b58831ae93caa);
var $d8105008396b7efa$export$4ef52930e33717cd = 'data-theme';
var $d8105008396b7efa$export$cb374d25ded7f6ab = 'data-subtree-theme';
var $d8105008396b7efa$export$a00eac3f8684bcd0 = 'data-color-mode';
var $d8105008396b7efa$export$2112803007239c61 = 'data-contrast-mode';
var $d8105008396b7efa$export$352e418ed5b6193a = 'data-custom-theme';
var $d8105008396b7efa$export$6f0c6fb8c80fcc92 = 'ds';
var $d8105008396b7efa$export$4d0c7bbf80185957 = [
    'opacity',
    'font',
    'space',
    'border',
    'radius'
];
var $d8105008396b7efa$export$dddac1532e822863 = "--".concat($d8105008396b7efa$export$6f0c6fb8c80fcc92, "-token-not-found");
var $d8105008396b7efa$export$9d7b58831ae93caa = "--".concat($d8105008396b7efa$export$6f0c6fb8c80fcc92, "-elevation-surface-current");

});

parcelRegister("4ZYyc", function(module, exports) {
$parcel$export(module.exports, "themeColorModes", () => $3a3bd409ef739542$export$83993de8eb66733);
$parcel$export(module.exports, "themeIds", () => $3a3bd409ef739542$export$7d43e72a58e3283f);
$parcel$export(module.exports, "themeStateDefaults", () => $3a3bd409ef739542$export$9aedcfa7336a207);
$parcel$export(module.exports, "default", () => $3a3bd409ef739542$export$2e2bcd8739ae039);

var $9Zzpd = parcelRequire("9Zzpd");
var $3a3bd409ef739542$export$83993de8eb66733 = [
    'light',
    'dark',
    'auto'
];
/**
 * Contrast preferences: The system contrast preference
 */ var $3a3bd409ef739542$var$themeContrastModes = [
    'more',
    'no-preference',
    'auto'
];
var $3a3bd409ef739542$export$7d43e72a58e3283f = [
    'light-increased-contrast',
    'light',
    'light-future',
    'dark',
    'dark-future',
    'dark-increased-contrast',
    'legacy-light',
    'legacy-dark',
    'spacing',
    'shape',
    'typography'
];
/**
 * Theme override ids: the equivalent of themeIds for theme overrides.
 * Theme overrides are temporary and there may not be any defined at times.
 */ var $3a3bd409ef739542$var$themeOverrideIds = [];
var $3a3bd409ef739542$export$92ba366331403db2 = [].concat($3a3bd409ef739542$export$7d43e72a58e3283f, $3a3bd409ef739542$var$themeOverrideIds);
/**
 * Theme to use a base. This will create the theme as
 * an extension with all token values marked as optional
 * to allow tokens to be overridden as required.
 */ /**
 * Palettes: The set of base tokens a given theme may be populated with.
 * For example: legacy light & dark themes use the "legacyPalette" containing colors from our
 * previous color set.
 */ /**
 * ThemeConfig: the source of truth for all theme meta-data.
 * This object should be used whenever interfacing with themes.
 */ var $3a3bd409ef739542$var$themeConfig = {
    'atlassian-light': {
        id: 'light',
        displayName: 'Light Theme',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'light'
        }
    },
    'atlassian-light-future': {
        id: 'light-future',
        displayName: 'Future Light Theme',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'light'
        },
        override: 'light'
    },
    'atlassian-light-increased-contrast': {
        id: 'light-increased-contrast',
        displayName: 'Light Theme (increased contrast)',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'light'
        },
        extends: 'light',
        increasesContrastFor: 'light'
    },
    'atlassian-dark': {
        id: 'dark',
        displayName: 'Dark Theme',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'dark'
        }
    },
    'atlassian-dark-future': {
        id: 'dark-future',
        displayName: 'Future Dark Theme',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'dark'
        },
        override: 'light'
    },
    'atlassian-dark-increased-contrast': {
        id: 'dark-increased-contrast',
        displayName: 'Dark Theme (increased contrast)',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'dark'
        },
        extends: 'dark',
        increasesContrastFor: 'dark'
    },
    'atlassian-legacy-light': {
        id: 'legacy-light',
        displayName: 'Light Theme (legacy)',
        palette: 'legacyPalette',
        attributes: {
            type: 'color',
            mode: 'light'
        }
    },
    'atlassian-legacy-dark': {
        id: 'legacy-dark',
        displayName: 'Dark Theme (legacy)',
        palette: 'legacyPalette',
        attributes: {
            type: 'color',
            mode: 'dark'
        }
    },
    'atlassian-spacing': {
        id: 'spacing',
        displayName: 'Atlassian Spacing',
        palette: 'spacingScale',
        attributes: {
            type: 'spacing'
        }
    },
    'atlassian-typography': {
        id: 'typography',
        displayName: 'Atlassian Typography',
        palette: 'typographyPalette',
        attributes: {
            type: 'typography'
        }
    },
    'atlassian-shape': {
        id: 'shape',
        displayName: 'Shape',
        palette: 'shapePalette',
        attributes: {
            type: 'shape'
        }
    }
};
var $3a3bd409ef739542$export$9aedcfa7336a207 = {
    colorMode: 'auto',
    contrastMode: 'auto',
    dark: 'dark',
    light: 'light',
    shape: function shape() {
        if ((0, $9Zzpd.fg)('platform-dst-shape-theme-default')) return 'shape';
        return undefined;
    },
    spacing: 'spacing',
    typography: 'typography',
    UNSAFE_themeOptions: undefined
};
var /**
 * Represents theme state once mounted to the page
 * (the page doesn't have an "auto" color mode, it's either light or dark)
 */ $3a3bd409ef739542$export$2e2bcd8739ae039 = $3a3bd409ef739542$var$themeConfig;

});

parcelRegister("cp9Zt", function(module, exports) {
$parcel$export(module.exports, "isValidBrandHex", () => $907f91ba27237a90$export$53031ac1ecb71f44);
$parcel$export(module.exports, "rgbToHex", () => $907f91ba27237a90$export$34d09c4a771c46ef);
$parcel$export(module.exports, "hexToRgbA", () => $907f91ba27237a90$export$b36dbdb4f463f05c);
$parcel$export(module.exports, "hexToRgb", () => $907f91ba27237a90$export$5a544e13ad4e1fa5);
$parcel$export(module.exports, "hexToHSL", () => $907f91ba27237a90$export$47ea145a83f50dc0);
$parcel$export(module.exports, "HSLToRGB", () => $907f91ba27237a90$export$1ff93e992dd58bec);
$parcel$export(module.exports, "relativeLuminanceW3C", () => $907f91ba27237a90$export$e770b01b744f3745);
$parcel$export(module.exports, "getContrastRatio", () => $907f91ba27237a90$export$d061e26956a60b0a);
$parcel$export(module.exports, "deltaE", () => $907f91ba27237a90$export$e8ddad763b4bebf9);
// valid hex color with 6 digits
var $907f91ba27237a90$export$53031ac1ecb71f44 = function isValidBrandHex(hex) {
    return /^#[0-9A-F]{6}$/i.test(hex);
};
// valid hex color with 4, 6 or 8 digits
var $907f91ba27237a90$var$isValidHex = function isValidHex(hex) {
    return /^#([A-Fa-f0-9]{3,4}){1,2}$/.test(hex);
};
function $907f91ba27237a90$export$34d09c4a771c46ef(r, g, b) {
    return '#' + (16777216 + (r << 16) + (g << 8) + b).toString(16).slice(1);
}
function $907f91ba27237a90$export$1212645cf40ebf71(hex) {
    if (hex.length === 9) {
        var int = parseInt(hex.slice(7, 9), 16) / 255;
        return Number(parseFloat(int.toString()).toFixed(2));
    }
    return 1;
}
function $907f91ba27237a90$export$b36dbdb4f463f05c(hex) {
    if (!$907f91ba27237a90$var$isValidHex(hex)) throw new Error('Invalid HEX');
    var c;
    c = hex.substring(1).split('');
    if (c.length === 3) c = [
        c[0],
        c[0],
        c[1],
        c[1],
        c[2],
        c[2]
    ];
    c = '0x' + c.join('');
    return [
        c >> 16 & 255,
        c >> 8 & 255,
        c & 255,
        $907f91ba27237a90$export$1212645cf40ebf71(hex)
    ];
}
function $907f91ba27237a90$export$5a544e13ad4e1fa5(hex) {
    if (!$907f91ba27237a90$var$isValidHex(hex)) throw new Error('Invalid HEX');
    var c;
    c = hex.substring(1).split('');
    if (c.length === 3) c = [
        c[0],
        c[0],
        c[1],
        c[1],
        c[2],
        c[2]
    ];
    c = '0x' + c.join('');
    return [
        c >> 16 & 255,
        c >> 8 & 255,
        c & 255
    ];
}
function $907f91ba27237a90$export$47ea145a83f50dc0(hex) {
    if (!$907f91ba27237a90$var$isValidHex(hex)) throw new Error('Invalid HEX');
    var r = 0, g = 0, b = 0;
    if (hex.length === 4) {
        r = '0x' + hex[1] + hex[1];
        g = '0x' + hex[2] + hex[2];
        b = '0x' + hex[3] + hex[3];
    } else if (hex.length === 7) {
        r = '0x' + hex[1] + hex[2];
        g = '0x' + hex[3] + hex[4];
        b = '0x' + hex[5] + hex[6];
    }
    // Then to HSL
    r /= 255;
    g /= 255;
    b /= 255;
    var cmin = Math.min(r, g, b), cmax = Math.max(r, g, b), delta = cmax - cmin, h = 0, s = 0, l = 0;
    if (delta === 0) h = 0;
    else if (cmax === r) h = (g - b) / delta % 6;
    else if (cmax === g) h = (b - r) / delta + 2;
    else h = (r - g) / delta + 4;
    h = Math.round(h * 60);
    if (h < 0) h += 360;
    l = (cmax + cmin) / 2;
    s = delta === 0 ? 0 : delta / (1 - Math.abs(2 * l - 1));
    s = +(s * 100).toFixed(1);
    l = +(l * 100).toFixed(1);
    return [
        h,
        s,
        l
    ];
}
function $907f91ba27237a90$export$1ff93e992dd58bec(h, s, l) {
    s /= 100;
    l /= 100;
    var k = function k(n) {
        return (n + h / 30) % 12;
    };
    var a = s * Math.min(l, 1 - l);
    var f = function f(n) {
        return l - a * Math.max(-1, Math.min(k(n) - 3, Math.min(9 - k(n), 1)));
    };
    return [
        255 * f(0),
        255 * f(8),
        255 * f(4)
    ];
}
function $907f91ba27237a90$export$e770b01b744f3745(r, g, b) {
    var RsRGB = r / 255;
    var GsRGB = g / 255;
    var BsRGB = b / 255;
    var R = RsRGB <= 0.03928 ? RsRGB / 12.92 : Math.pow((RsRGB + 0.055) / 1.055, 2.4);
    var G = GsRGB <= 0.03928 ? GsRGB / 12.92 : Math.pow((GsRGB + 0.055) / 1.055, 2.4);
    var B = BsRGB <= 0.03928 ? BsRGB / 12.92 : Math.pow((BsRGB + 0.055) / 1.055, 2.4);
    // For the sRGB colorspace, the relative luminance of a color is defined as:
    var L = 0.2126 * R + 0.7152 * G + 0.0722 * B;
    return L;
}
function $907f91ba27237a90$export$d061e26956a60b0a(foreground, background) {
    if (!$907f91ba27237a90$var$isValidHex(foreground) || !$907f91ba27237a90$var$isValidHex(background)) throw new Error('Invalid HEX');
    var foregroundRgb = $907f91ba27237a90$export$5a544e13ad4e1fa5(foreground);
    var backgroundRgb = $907f91ba27237a90$export$5a544e13ad4e1fa5(background);
    var foregroundLuminance = $907f91ba27237a90$export$e770b01b744f3745(foregroundRgb[0], foregroundRgb[1], foregroundRgb[2]);
    var backgroundLuminance = $907f91ba27237a90$export$e770b01b744f3745(backgroundRgb[0], backgroundRgb[1], backgroundRgb[2]);
    // calculate the color contrast ratio
    var brightest = Math.max(foregroundLuminance, backgroundLuminance);
    var darkest = Math.min(foregroundLuminance, backgroundLuminance);
    return (brightest + 0.05) / (darkest + 0.05);
}
function $907f91ba27237a90$export$e8ddad763b4bebf9(rgbA, rgbB) {
    var labA = $907f91ba27237a90$var$rgbToLab(rgbA);
    var labB = $907f91ba27237a90$var$rgbToLab(rgbB);
    var deltaL = labA[0] - labB[0];
    var deltaA = labA[1] - labB[1];
    var deltaB = labA[2] - labB[2];
    var c1 = Math.sqrt(labA[1] * labA[1] + labA[2] * labA[2]);
    var c2 = Math.sqrt(labB[1] * labB[1] + labB[2] * labB[2]);
    var deltaC = c1 - c2;
    var deltaH = deltaA * deltaA + deltaB * deltaB - deltaC * deltaC;
    deltaH = deltaH < 0 ? 0 : Math.sqrt(deltaH);
    var sc = 1.0 + 0.045 * c1;
    var sh = 1.0 + 0.015 * c1;
    var deltaLKlsl = deltaL / 1.0;
    var deltaCkcsc = deltaC / sc;
    var deltaHkhsh = deltaH / sh;
    var i = deltaLKlsl * deltaLKlsl + deltaCkcsc * deltaCkcsc + deltaHkhsh * deltaHkhsh;
    return i < 0 ? 0 : Math.sqrt(i);
}
function $907f91ba27237a90$var$rgbToLab(rgb) {
    var r = rgb[0] / 255, g = rgb[1] / 255, b = rgb[2] / 255, x, y, z;
    r = r > 0.04045 ? Math.pow((r + 0.055) / 1.055, 2.4) : r / 12.92;
    g = g > 0.04045 ? Math.pow((g + 0.055) / 1.055, 2.4) : g / 12.92;
    b = b > 0.04045 ? Math.pow((b + 0.055) / 1.055, 2.4) : b / 12.92;
    x = (r * 0.4124 + g * 0.3576 + b * 0.1805) / 0.95047;
    y = (r * 0.2126 + g * 0.7152 + b * 0.0722) / 1.0;
    z = (r * 0.0193 + g * 0.1192 + b * 0.9505) / 1.08883;
    x = x > 0.008856 ? Math.pow(x, 1 / 3) : 7.787 * x + 16 / 116;
    y = y > 0.008856 ? Math.pow(y, 1 / 3) : 7.787 * y + 16 / 116;
    z = z > 0.008856 ? Math.pow(z, 1 / 3) : 7.787 * z + 16 / 116;
    return [
        116 * y - 16,
        500 * (x - y),
        200 * (y - z)
    ];
}

});

parcelRegister("8jjS7", function(module, exports) {
$parcel$export(module.exports, "hash", () => $60cf8336f4d2132b$export$d6af199866bfb566);
var $60cf8336f4d2132b$export$d6af199866bfb566 = function hash(str) {
    var hash = 0;
    for(var i = 0; i < str.length; i++){
        var char = str.charCodeAt(i);
        hash = (hash << 5) - hash + char;
        hash &= hash; // Convert to 32bit integer
    }
    return new Uint32Array([
        hash
    ])[0].toString(36);
};

});

parcelRegister("c2YxD", function(module, exports) {

var $iKwew = parcelRequire("iKwew");
module.exports = $iKwew("2w4HT").then(()=>parcelRequire('fa2bP'));

});

parcelRegister("71lDz", function(module, exports) {

var $iKwew = parcelRequire("iKwew");
module.exports = $iKwew("aTAst").then(()=>parcelRequire('94GsY'));

});

parcelRegister("gID4c", function(module, exports) {

var $iKwew = parcelRequire("iKwew");
module.exports = $iKwew("7a79l").then(()=>parcelRequire('gxdow'));

});

parcelRegister("e9VLP", function(module, exports) {

var $iKwew = parcelRequire("iKwew");
module.exports = $iKwew("igOtB").then(()=>parcelRequire('7JN0a'));

});

parcelRegister("80flm", function(module, exports) {

var $iKwew = parcelRequire("iKwew");
module.exports = $iKwew("gT7qx").then(()=>parcelRequire('13Osq'));

});

parcelRegister("kp4iJ", function(module, exports) {

var $iKwew = parcelRequire("iKwew");
module.exports = $iKwew("i2MfV").then(()=>parcelRequire('jKZ66'));

});

parcelRegister("2ttq9", function(module, exports) {

var $iKwew = parcelRequire("iKwew");
module.exports = $iKwew("9pgcI").then(()=>parcelRequire('5wnxX'));

});

parcelRegister("l0jav", function(module, exports) {

var $iKwew = parcelRequire("iKwew");
module.exports = $iKwew("fStU9").then(()=>parcelRequire('dIEu1'));

});

parcelRegister("dwO5k", function(module, exports) {

var $iKwew = parcelRequire("iKwew");
module.exports = $iKwew("aribW").then(()=>parcelRequire('1Cupc'));

});

parcelRegister("01DTH", function(module, exports) {

var $iKwew = parcelRequire("iKwew");
module.exports = $iKwew("bXnrU").then(()=>parcelRequire('lswv2'));

});

parcelRegister("4enTl", function(module, exports) {

var $iKwew = parcelRequire("iKwew");
module.exports = $iKwew("960f5").then(()=>parcelRequire('i2CrI'));

});

parcelRegister("4LdXN", function(module, exports) {
$parcel$export(module.exports, "findMissingCustomStyleElements", () => $37766211d6e75732$export$bd1ac9300b0e885a);
$parcel$export(module.exports, "limitSizeOfCustomStyleElements", () => $37766211d6e75732$export$e7ae172320e03461);
$parcel$export(module.exports, "reduceTokenMap", () => $37766211d6e75732$export$e673f367da2ff23e);

var $iYJcE = parcelRequire("iYJcE");

var $fC8ib = parcelRequire("fC8ib");

var $9zFB7 = parcelRequire("9zFB7");

var $iy6kx = parcelRequire("iy6kx");

var $8jjS7 = parcelRequire("8jjS7");
function $37766211d6e75732$export$bd1ac9300b0e885a(UNSAFE_themeOptions, mode) {
    var optionString = JSON.stringify(UNSAFE_themeOptions);
    var uniqueId = (0, $8jjS7.hash)(optionString);
    var attrOfMissingCustomStyles = [];
    (mode === 'auto' ? [
        'light',
        'dark'
    ] : [
        mode
    ]).forEach(function(themeId) {
        var element = document.head.querySelector("style[".concat((0, $iy6kx.CUSTOM_THEME_ATTRIBUTE), "=\"").concat(uniqueId, "\"][").concat((0, $iy6kx.THEME_DATA_ATTRIBUTE), "=\"").concat(themeId, "\"]"));
        if (element) // Append the existing custom styles to take precedence over others
        document.head.appendChild(element);
        else attrOfMissingCustomStyles.push(themeId);
    });
    return attrOfMissingCustomStyles;
}
function $37766211d6e75732$export$e7ae172320e03461(sizeThreshold) {
    var styleTags = (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(Array.from(document.head.querySelectorAll("style[".concat((0, $iy6kx.CUSTOM_THEME_ATTRIBUTE), "][").concat((0, $iy6kx.THEME_DATA_ATTRIBUTE), "]"))));
    if (styleTags.length < sizeThreshold) return;
    styleTags.slice(0, styleTags.length - (sizeThreshold - 1)).forEach(function(element) {
        return element.remove();
    });
}
function $37766211d6e75732$export$e673f367da2ff23e(tokenMap, themeRamp) {
    return Object.entries(tokenMap).reduce(function(acc, _ref) {
        var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_ref, 2), key = _ref2[0], value = _ref2[1];
        var cssVar = (0, $9zFB7.default)[key];
        return cssVar ? "".concat(acc, "\n  ").concat(cssVar, ": ").concat(typeof value === 'string' ? value : themeRamp[value], ";") : acc;
    }, '');
}

});
parcelRegister("9zFB7", function(module, exports) {
$parcel$export(module.exports, "default", () => $6f87a6626ab803ba$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::71ab6af4453c6807be4d4249ca7614bc>>
 * @codegenCommand yarn build tokens
 */ var $6f87a6626ab803ba$var$tokens = {
    'color.text': '--ds-text',
    'color.text.accent.lime': '--ds-text-accent-lime',
    'color.text.accent.lime.bolder': '--ds-text-accent-lime-bolder',
    'color.text.accent.red': '--ds-text-accent-red',
    'color.text.accent.red.bolder': '--ds-text-accent-red-bolder',
    'color.text.accent.orange': '--ds-text-accent-orange',
    'color.text.accent.orange.bolder': '--ds-text-accent-orange-bolder',
    'color.text.accent.yellow': '--ds-text-accent-yellow',
    'color.text.accent.yellow.bolder': '--ds-text-accent-yellow-bolder',
    'color.text.accent.green': '--ds-text-accent-green',
    'color.text.accent.green.bolder': '--ds-text-accent-green-bolder',
    'color.text.accent.teal': '--ds-text-accent-teal',
    'color.text.accent.teal.bolder': '--ds-text-accent-teal-bolder',
    'color.text.accent.blue': '--ds-text-accent-blue',
    'color.text.accent.blue.bolder': '--ds-text-accent-blue-bolder',
    'color.text.accent.purple': '--ds-text-accent-purple',
    'color.text.accent.purple.bolder': '--ds-text-accent-purple-bolder',
    'color.text.accent.magenta': '--ds-text-accent-magenta',
    'color.text.accent.magenta.bolder': '--ds-text-accent-magenta-bolder',
    'color.text.accent.gray': '--ds-text-accent-gray',
    'color.text.accent.gray.bolder': '--ds-text-accent-gray-bolder',
    'color.text.disabled': '--ds-text-disabled',
    'color.text.inverse': '--ds-text-inverse',
    'color.text.selected': '--ds-text-selected',
    'color.text.brand': '--ds-text-brand',
    'color.text.danger': '--ds-text-danger',
    'color.text.danger.bolder': '--ds-text-danger-bolder',
    'color.text.warning': '--ds-text-warning',
    'color.text.warning.inverse': '--ds-text-warning-inverse',
    'color.text.warning.bolder': '--ds-text-warning-bolder',
    'color.text.success': '--ds-text-success',
    'color.text.success.bolder': '--ds-text-success-bolder',
    'color.text.discovery': '--ds-text-discovery',
    'color.text.discovery.bolder': '--ds-text-discovery-bolder',
    'color.text.information': '--ds-text-information',
    'color.text.information.bolder': '--ds-text-information-bolder',
    'color.text.subtlest': '--ds-text-subtlest',
    'color.text.subtle': '--ds-text-subtle',
    'color.link': '--ds-link',
    'color.link.pressed': '--ds-link-pressed',
    'color.link.visited': '--ds-link-visited',
    'color.link.visited.pressed': '--ds-link-visited-pressed',
    'color.icon': '--ds-icon',
    'color.icon.accent.lime': '--ds-icon-accent-lime',
    'color.icon.accent.red': '--ds-icon-accent-red',
    'color.icon.accent.orange': '--ds-icon-accent-orange',
    'color.icon.accent.yellow': '--ds-icon-accent-yellow',
    'color.icon.accent.green': '--ds-icon-accent-green',
    'color.icon.accent.teal': '--ds-icon-accent-teal',
    'color.icon.accent.blue': '--ds-icon-accent-blue',
    'color.icon.accent.purple': '--ds-icon-accent-purple',
    'color.icon.accent.magenta': '--ds-icon-accent-magenta',
    'color.icon.accent.gray': '--ds-icon-accent-gray',
    'color.icon.disabled': '--ds-icon-disabled',
    'color.icon.inverse': '--ds-icon-inverse',
    'color.icon.selected': '--ds-icon-selected',
    'color.icon.brand': '--ds-icon-brand',
    'color.icon.danger': '--ds-icon-danger',
    'color.icon.warning': '--ds-icon-warning',
    'color.icon.warning.inverse': '--ds-icon-warning-inverse',
    'color.icon.success': '--ds-icon-success',
    'color.icon.discovery': '--ds-icon-discovery',
    'color.icon.information': '--ds-icon-information',
    'color.icon.subtlest': '--ds-icon-subtlest',
    'color.icon.subtle': '--ds-icon-subtle',
    'color.border': '--ds-border',
    'color.border.accent.lime': '--ds-border-accent-lime',
    'color.border.accent.red': '--ds-border-accent-red',
    'color.border.accent.orange': '--ds-border-accent-orange',
    'color.border.accent.yellow': '--ds-border-accent-yellow',
    'color.border.accent.green': '--ds-border-accent-green',
    'color.border.accent.teal': '--ds-border-accent-teal',
    'color.border.accent.blue': '--ds-border-accent-blue',
    'color.border.accent.purple': '--ds-border-accent-purple',
    'color.border.accent.magenta': '--ds-border-accent-magenta',
    'color.border.accent.gray': '--ds-border-accent-gray',
    'color.border.disabled': '--ds-border-disabled',
    'color.border.focused': '--ds-border-focused',
    'color.border.input': '--ds-border-input',
    'color.border.inverse': '--ds-border-inverse',
    'color.border.selected': '--ds-border-selected',
    'color.border.brand': '--ds-border-brand',
    'color.border.danger': '--ds-border-danger',
    'color.border.warning': '--ds-border-warning',
    'color.border.success': '--ds-border-success',
    'color.border.discovery': '--ds-border-discovery',
    'color.border.information': '--ds-border-information',
    'color.border.bold': '--ds-border-bold',
    'color.background.accent.lime.subtlest': '--ds-background-accent-lime-subtlest',
    'color.background.accent.lime.subtlest.hovered': '--ds-background-accent-lime-subtlest-hovered',
    'color.background.accent.lime.subtlest.pressed': '--ds-background-accent-lime-subtlest-pressed',
    'color.background.accent.lime.subtler': '--ds-background-accent-lime-subtler',
    'color.background.accent.lime.subtler.hovered': '--ds-background-accent-lime-subtler-hovered',
    'color.background.accent.lime.subtler.pressed': '--ds-background-accent-lime-subtler-pressed',
    'color.background.accent.lime.subtle': '--ds-background-accent-lime-subtle',
    'color.background.accent.lime.subtle.hovered': '--ds-background-accent-lime-subtle-hovered',
    'color.background.accent.lime.subtle.pressed': '--ds-background-accent-lime-subtle-pressed',
    'color.background.accent.lime.bolder': '--ds-background-accent-lime-bolder',
    'color.background.accent.lime.bolder.hovered': '--ds-background-accent-lime-bolder-hovered',
    'color.background.accent.lime.bolder.pressed': '--ds-background-accent-lime-bolder-pressed',
    'color.background.accent.red.subtlest': '--ds-background-accent-red-subtlest',
    'color.background.accent.red.subtlest.hovered': '--ds-background-accent-red-subtlest-hovered',
    'color.background.accent.red.subtlest.pressed': '--ds-background-accent-red-subtlest-pressed',
    'color.background.accent.red.subtler': '--ds-background-accent-red-subtler',
    'color.background.accent.red.subtler.hovered': '--ds-background-accent-red-subtler-hovered',
    'color.background.accent.red.subtler.pressed': '--ds-background-accent-red-subtler-pressed',
    'color.background.accent.red.subtle': '--ds-background-accent-red-subtle',
    'color.background.accent.red.subtle.hovered': '--ds-background-accent-red-subtle-hovered',
    'color.background.accent.red.subtle.pressed': '--ds-background-accent-red-subtle-pressed',
    'color.background.accent.red.bolder': '--ds-background-accent-red-bolder',
    'color.background.accent.red.bolder.hovered': '--ds-background-accent-red-bolder-hovered',
    'color.background.accent.red.bolder.pressed': '--ds-background-accent-red-bolder-pressed',
    'color.background.accent.orange.subtlest': '--ds-background-accent-orange-subtlest',
    'color.background.accent.orange.subtlest.hovered': '--ds-background-accent-orange-subtlest-hovered',
    'color.background.accent.orange.subtlest.pressed': '--ds-background-accent-orange-subtlest-pressed',
    'color.background.accent.orange.subtler': '--ds-background-accent-orange-subtler',
    'color.background.accent.orange.subtler.hovered': '--ds-background-accent-orange-subtler-hovered',
    'color.background.accent.orange.subtler.pressed': '--ds-background-accent-orange-subtler-pressed',
    'color.background.accent.orange.subtle': '--ds-background-accent-orange-subtle',
    'color.background.accent.orange.subtle.hovered': '--ds-background-accent-orange-subtle-hovered',
    'color.background.accent.orange.subtle.pressed': '--ds-background-accent-orange-subtle-pressed',
    'color.background.accent.orange.bolder': '--ds-background-accent-orange-bolder',
    'color.background.accent.orange.bolder.hovered': '--ds-background-accent-orange-bolder-hovered',
    'color.background.accent.orange.bolder.pressed': '--ds-background-accent-orange-bolder-pressed',
    'color.background.accent.yellow.subtlest': '--ds-background-accent-yellow-subtlest',
    'color.background.accent.yellow.subtlest.hovered': '--ds-background-accent-yellow-subtlest-hovered',
    'color.background.accent.yellow.subtlest.pressed': '--ds-background-accent-yellow-subtlest-pressed',
    'color.background.accent.yellow.subtler': '--ds-background-accent-yellow-subtler',
    'color.background.accent.yellow.subtler.hovered': '--ds-background-accent-yellow-subtler-hovered',
    'color.background.accent.yellow.subtler.pressed': '--ds-background-accent-yellow-subtler-pressed',
    'color.background.accent.yellow.subtle': '--ds-background-accent-yellow-subtle',
    'color.background.accent.yellow.subtle.hovered': '--ds-background-accent-yellow-subtle-hovered',
    'color.background.accent.yellow.subtle.pressed': '--ds-background-accent-yellow-subtle-pressed',
    'color.background.accent.yellow.bolder': '--ds-background-accent-yellow-bolder',
    'color.background.accent.yellow.bolder.hovered': '--ds-background-accent-yellow-bolder-hovered',
    'color.background.accent.yellow.bolder.pressed': '--ds-background-accent-yellow-bolder-pressed',
    'color.background.accent.green.subtlest': '--ds-background-accent-green-subtlest',
    'color.background.accent.green.subtlest.hovered': '--ds-background-accent-green-subtlest-hovered',
    'color.background.accent.green.subtlest.pressed': '--ds-background-accent-green-subtlest-pressed',
    'color.background.accent.green.subtler': '--ds-background-accent-green-subtler',
    'color.background.accent.green.subtler.hovered': '--ds-background-accent-green-subtler-hovered',
    'color.background.accent.green.subtler.pressed': '--ds-background-accent-green-subtler-pressed',
    'color.background.accent.green.subtle': '--ds-background-accent-green-subtle',
    'color.background.accent.green.subtle.hovered': '--ds-background-accent-green-subtle-hovered',
    'color.background.accent.green.subtle.pressed': '--ds-background-accent-green-subtle-pressed',
    'color.background.accent.green.bolder': '--ds-background-accent-green-bolder',
    'color.background.accent.green.bolder.hovered': '--ds-background-accent-green-bolder-hovered',
    'color.background.accent.green.bolder.pressed': '--ds-background-accent-green-bolder-pressed',
    'color.background.accent.teal.subtlest': '--ds-background-accent-teal-subtlest',
    'color.background.accent.teal.subtlest.hovered': '--ds-background-accent-teal-subtlest-hovered',
    'color.background.accent.teal.subtlest.pressed': '--ds-background-accent-teal-subtlest-pressed',
    'color.background.accent.teal.subtler': '--ds-background-accent-teal-subtler',
    'color.background.accent.teal.subtler.hovered': '--ds-background-accent-teal-subtler-hovered',
    'color.background.accent.teal.subtler.pressed': '--ds-background-accent-teal-subtler-pressed',
    'color.background.accent.teal.subtle': '--ds-background-accent-teal-subtle',
    'color.background.accent.teal.subtle.hovered': '--ds-background-accent-teal-subtle-hovered',
    'color.background.accent.teal.subtle.pressed': '--ds-background-accent-teal-subtle-pressed',
    'color.background.accent.teal.bolder': '--ds-background-accent-teal-bolder',
    'color.background.accent.teal.bolder.hovered': '--ds-background-accent-teal-bolder-hovered',
    'color.background.accent.teal.bolder.pressed': '--ds-background-accent-teal-bolder-pressed',
    'color.background.accent.blue.subtlest': '--ds-background-accent-blue-subtlest',
    'color.background.accent.blue.subtlest.hovered': '--ds-background-accent-blue-subtlest-hovered',
    'color.background.accent.blue.subtlest.pressed': '--ds-background-accent-blue-subtlest-pressed',
    'color.background.accent.blue.subtler': '--ds-background-accent-blue-subtler',
    'color.background.accent.blue.subtler.hovered': '--ds-background-accent-blue-subtler-hovered',
    'color.background.accent.blue.subtler.pressed': '--ds-background-accent-blue-subtler-pressed',
    'color.background.accent.blue.subtle': '--ds-background-accent-blue-subtle',
    'color.background.accent.blue.subtle.hovered': '--ds-background-accent-blue-subtle-hovered',
    'color.background.accent.blue.subtle.pressed': '--ds-background-accent-blue-subtle-pressed',
    'color.background.accent.blue.bolder': '--ds-background-accent-blue-bolder',
    'color.background.accent.blue.bolder.hovered': '--ds-background-accent-blue-bolder-hovered',
    'color.background.accent.blue.bolder.pressed': '--ds-background-accent-blue-bolder-pressed',
    'color.background.accent.purple.subtlest': '--ds-background-accent-purple-subtlest',
    'color.background.accent.purple.subtlest.hovered': '--ds-background-accent-purple-subtlest-hovered',
    'color.background.accent.purple.subtlest.pressed': '--ds-background-accent-purple-subtlest-pressed',
    'color.background.accent.purple.subtler': '--ds-background-accent-purple-subtler',
    'color.background.accent.purple.subtler.hovered': '--ds-background-accent-purple-subtler-hovered',
    'color.background.accent.purple.subtler.pressed': '--ds-background-accent-purple-subtler-pressed',
    'color.background.accent.purple.subtle': '--ds-background-accent-purple-subtle',
    'color.background.accent.purple.subtle.hovered': '--ds-background-accent-purple-subtle-hovered',
    'color.background.accent.purple.subtle.pressed': '--ds-background-accent-purple-subtle-pressed',
    'color.background.accent.purple.bolder': '--ds-background-accent-purple-bolder',
    'color.background.accent.purple.bolder.hovered': '--ds-background-accent-purple-bolder-hovered',
    'color.background.accent.purple.bolder.pressed': '--ds-background-accent-purple-bolder-pressed',
    'color.background.accent.magenta.subtlest': '--ds-background-accent-magenta-subtlest',
    'color.background.accent.magenta.subtlest.hovered': '--ds-background-accent-magenta-subtlest-hovered',
    'color.background.accent.magenta.subtlest.pressed': '--ds-background-accent-magenta-subtlest-pressed',
    'color.background.accent.magenta.subtler': '--ds-background-accent-magenta-subtler',
    'color.background.accent.magenta.subtler.hovered': '--ds-background-accent-magenta-subtler-hovered',
    'color.background.accent.magenta.subtler.pressed': '--ds-background-accent-magenta-subtler-pressed',
    'color.background.accent.magenta.subtle': '--ds-background-accent-magenta-subtle',
    'color.background.accent.magenta.subtle.hovered': '--ds-background-accent-magenta-subtle-hovered',
    'color.background.accent.magenta.subtle.pressed': '--ds-background-accent-magenta-subtle-pressed',
    'color.background.accent.magenta.bolder': '--ds-background-accent-magenta-bolder',
    'color.background.accent.magenta.bolder.hovered': '--ds-background-accent-magenta-bolder-hovered',
    'color.background.accent.magenta.bolder.pressed': '--ds-background-accent-magenta-bolder-pressed',
    'color.background.accent.gray.subtlest': '--ds-background-accent-gray-subtlest',
    'color.background.accent.gray.subtlest.hovered': '--ds-background-accent-gray-subtlest-hovered',
    'color.background.accent.gray.subtlest.pressed': '--ds-background-accent-gray-subtlest-pressed',
    'color.background.accent.gray.subtler': '--ds-background-accent-gray-subtler',
    'color.background.accent.gray.subtler.hovered': '--ds-background-accent-gray-subtler-hovered',
    'color.background.accent.gray.subtler.pressed': '--ds-background-accent-gray-subtler-pressed',
    'color.background.accent.gray.subtle': '--ds-background-accent-gray-subtle',
    'color.background.accent.gray.subtle.hovered': '--ds-background-accent-gray-subtle-hovered',
    'color.background.accent.gray.subtle.pressed': '--ds-background-accent-gray-subtle-pressed',
    'color.background.accent.gray.bolder': '--ds-background-accent-gray-bolder',
    'color.background.accent.gray.bolder.hovered': '--ds-background-accent-gray-bolder-hovered',
    'color.background.accent.gray.bolder.pressed': '--ds-background-accent-gray-bolder-pressed',
    'color.background.disabled': '--ds-background-disabled',
    'color.background.input': '--ds-background-input',
    'color.background.input.hovered': '--ds-background-input-hovered',
    'color.background.input.pressed': '--ds-background-input-pressed',
    'color.background.inverse.subtle': '--ds-background-inverse-subtle',
    'color.background.inverse.subtle.hovered': '--ds-background-inverse-subtle-hovered',
    'color.background.inverse.subtle.pressed': '--ds-background-inverse-subtle-pressed',
    'color.background.neutral': '--ds-background-neutral',
    'color.background.neutral.hovered': '--ds-background-neutral-hovered',
    'color.background.neutral.pressed': '--ds-background-neutral-pressed',
    'color.background.neutral.subtle': '--ds-background-neutral-subtle',
    'color.background.neutral.subtle.hovered': '--ds-background-neutral-subtle-hovered',
    'color.background.neutral.subtle.pressed': '--ds-background-neutral-subtle-pressed',
    'color.background.neutral.bold': '--ds-background-neutral-bold',
    'color.background.neutral.bold.hovered': '--ds-background-neutral-bold-hovered',
    'color.background.neutral.bold.pressed': '--ds-background-neutral-bold-pressed',
    'color.background.selected': '--ds-background-selected',
    'color.background.selected.hovered': '--ds-background-selected-hovered',
    'color.background.selected.pressed': '--ds-background-selected-pressed',
    'color.background.selected.bold': '--ds-background-selected-bold',
    'color.background.selected.bold.hovered': '--ds-background-selected-bold-hovered',
    'color.background.selected.bold.pressed': '--ds-background-selected-bold-pressed',
    'color.background.brand.subtlest': '--ds-background-brand-subtlest',
    'color.background.brand.subtlest.hovered': '--ds-background-brand-subtlest-hovered',
    'color.background.brand.subtlest.pressed': '--ds-background-brand-subtlest-pressed',
    'color.background.brand.bold': '--ds-background-brand-bold',
    'color.background.brand.bold.hovered': '--ds-background-brand-bold-hovered',
    'color.background.brand.bold.pressed': '--ds-background-brand-bold-pressed',
    'color.background.brand.boldest': '--ds-background-brand-boldest',
    'color.background.brand.boldest.hovered': '--ds-background-brand-boldest-hovered',
    'color.background.brand.boldest.pressed': '--ds-background-brand-boldest-pressed',
    'color.background.danger': '--ds-background-danger',
    'color.background.danger.hovered': '--ds-background-danger-hovered',
    'color.background.danger.pressed': '--ds-background-danger-pressed',
    'color.background.danger.subtler': '--ds-background-danger-subtler',
    'color.background.danger.subtler.hovered': '--ds-background-danger-subtler-hovered',
    'color.background.danger.subtler.pressed': '--ds-background-danger-subtler-pressed',
    'color.background.danger.bold': '--ds-background-danger-bold',
    'color.background.danger.bold.hovered': '--ds-background-danger-bold-hovered',
    'color.background.danger.bold.pressed': '--ds-background-danger-bold-pressed',
    'color.background.warning': '--ds-background-warning',
    'color.background.warning.hovered': '--ds-background-warning-hovered',
    'color.background.warning.pressed': '--ds-background-warning-pressed',
    'color.background.warning.subtler': '--ds-background-warning-subtler',
    'color.background.warning.subtler.hovered': '--ds-background-warning-subtler-hovered',
    'color.background.warning.subtler.pressed': '--ds-background-warning-subtler-pressed',
    'color.background.warning.bold': '--ds-background-warning-bold',
    'color.background.warning.bold.hovered': '--ds-background-warning-bold-hovered',
    'color.background.warning.bold.pressed': '--ds-background-warning-bold-pressed',
    'color.background.success': '--ds-background-success',
    'color.background.success.hovered': '--ds-background-success-hovered',
    'color.background.success.pressed': '--ds-background-success-pressed',
    'color.background.success.subtler': '--ds-background-success-subtler',
    'color.background.success.subtler.hovered': '--ds-background-success-subtler-hovered',
    'color.background.success.subtler.pressed': '--ds-background-success-subtler-pressed',
    'color.background.success.bold': '--ds-background-success-bold',
    'color.background.success.bold.hovered': '--ds-background-success-bold-hovered',
    'color.background.success.bold.pressed': '--ds-background-success-bold-pressed',
    'color.background.discovery': '--ds-background-discovery',
    'color.background.discovery.hovered': '--ds-background-discovery-hovered',
    'color.background.discovery.pressed': '--ds-background-discovery-pressed',
    'color.background.discovery.subtler': '--ds-background-discovery-subtler',
    'color.background.discovery.subtler.hovered': '--ds-background-discovery-subtler-hovered',
    'color.background.discovery.subtler.pressed': '--ds-background-discovery-subtler-pressed',
    'color.background.discovery.bold': '--ds-background-discovery-bold',
    'color.background.discovery.bold.hovered': '--ds-background-discovery-bold-hovered',
    'color.background.discovery.bold.pressed': '--ds-background-discovery-bold-pressed',
    'color.background.information': '--ds-background-information',
    'color.background.information.hovered': '--ds-background-information-hovered',
    'color.background.information.pressed': '--ds-background-information-pressed',
    'color.background.information.subtler': '--ds-background-information-subtler',
    'color.background.information.subtler.hovered': '--ds-background-information-subtler-hovered',
    'color.background.information.subtler.pressed': '--ds-background-information-subtler-pressed',
    'color.background.information.bold': '--ds-background-information-bold',
    'color.background.information.bold.hovered': '--ds-background-information-bold-hovered',
    'color.background.information.bold.pressed': '--ds-background-information-bold-pressed',
    'color.blanket': '--ds-blanket',
    'color.blanket.selected': '--ds-blanket-selected',
    'color.blanket.danger': '--ds-blanket-danger',
    'color.interaction.hovered': '--ds-interaction-hovered',
    'color.interaction.pressed': '--ds-interaction-pressed',
    'color.skeleton': '--ds-skeleton',
    'color.skeleton.subtle': '--ds-skeleton-subtle',
    'color.chart.categorical.1': '--ds-chart-categorical-1',
    'color.chart.categorical.1.hovered': '--ds-chart-categorical-1-hovered',
    'color.chart.categorical.2': '--ds-chart-categorical-2',
    'color.chart.categorical.2.hovered': '--ds-chart-categorical-2-hovered',
    'color.chart.categorical.3': '--ds-chart-categorical-3',
    'color.chart.categorical.3.hovered': '--ds-chart-categorical-3-hovered',
    'color.chart.categorical.4': '--ds-chart-categorical-4',
    'color.chart.categorical.4.hovered': '--ds-chart-categorical-4-hovered',
    'color.chart.categorical.5': '--ds-chart-categorical-5',
    'color.chart.categorical.5.hovered': '--ds-chart-categorical-5-hovered',
    'color.chart.categorical.6': '--ds-chart-categorical-6',
    'color.chart.categorical.6.hovered': '--ds-chart-categorical-6-hovered',
    'color.chart.categorical.7': '--ds-chart-categorical-7',
    'color.chart.categorical.7.hovered': '--ds-chart-categorical-7-hovered',
    'color.chart.categorical.8': '--ds-chart-categorical-8',
    'color.chart.categorical.8.hovered': '--ds-chart-categorical-8-hovered',
    'color.chart.lime.bold': '--ds-chart-lime-bold',
    'color.chart.lime.bold.hovered': '--ds-chart-lime-bold-hovered',
    'color.chart.lime.bolder': '--ds-chart-lime-bolder',
    'color.chart.lime.bolder.hovered': '--ds-chart-lime-bolder-hovered',
    'color.chart.lime.boldest': '--ds-chart-lime-boldest',
    'color.chart.lime.boldest.hovered': '--ds-chart-lime-boldest-hovered',
    'color.chart.neutral': '--ds-chart-neutral',
    'color.chart.neutral.hovered': '--ds-chart-neutral-hovered',
    'color.chart.red.bold': '--ds-chart-red-bold',
    'color.chart.red.bold.hovered': '--ds-chart-red-bold-hovered',
    'color.chart.red.bolder': '--ds-chart-red-bolder',
    'color.chart.red.bolder.hovered': '--ds-chart-red-bolder-hovered',
    'color.chart.red.boldest': '--ds-chart-red-boldest',
    'color.chart.red.boldest.hovered': '--ds-chart-red-boldest-hovered',
    'color.chart.orange.bold': '--ds-chart-orange-bold',
    'color.chart.orange.bold.hovered': '--ds-chart-orange-bold-hovered',
    'color.chart.orange.bolder': '--ds-chart-orange-bolder',
    'color.chart.orange.bolder.hovered': '--ds-chart-orange-bolder-hovered',
    'color.chart.orange.boldest': '--ds-chart-orange-boldest',
    'color.chart.orange.boldest.hovered': '--ds-chart-orange-boldest-hovered',
    'color.chart.yellow.bold': '--ds-chart-yellow-bold',
    'color.chart.yellow.bold.hovered': '--ds-chart-yellow-bold-hovered',
    'color.chart.yellow.bolder': '--ds-chart-yellow-bolder',
    'color.chart.yellow.bolder.hovered': '--ds-chart-yellow-bolder-hovered',
    'color.chart.yellow.boldest': '--ds-chart-yellow-boldest',
    'color.chart.yellow.boldest.hovered': '--ds-chart-yellow-boldest-hovered',
    'color.chart.green.bold': '--ds-chart-green-bold',
    'color.chart.green.bold.hovered': '--ds-chart-green-bold-hovered',
    'color.chart.green.bolder': '--ds-chart-green-bolder',
    'color.chart.green.bolder.hovered': '--ds-chart-green-bolder-hovered',
    'color.chart.green.boldest': '--ds-chart-green-boldest',
    'color.chart.green.boldest.hovered': '--ds-chart-green-boldest-hovered',
    'color.chart.teal.bold': '--ds-chart-teal-bold',
    'color.chart.teal.bold.hovered': '--ds-chart-teal-bold-hovered',
    'color.chart.teal.bolder': '--ds-chart-teal-bolder',
    'color.chart.teal.bolder.hovered': '--ds-chart-teal-bolder-hovered',
    'color.chart.teal.boldest': '--ds-chart-teal-boldest',
    'color.chart.teal.boldest.hovered': '--ds-chart-teal-boldest-hovered',
    'color.chart.blue.bold': '--ds-chart-blue-bold',
    'color.chart.blue.bold.hovered': '--ds-chart-blue-bold-hovered',
    'color.chart.blue.bolder': '--ds-chart-blue-bolder',
    'color.chart.blue.bolder.hovered': '--ds-chart-blue-bolder-hovered',
    'color.chart.blue.boldest': '--ds-chart-blue-boldest',
    'color.chart.blue.boldest.hovered': '--ds-chart-blue-boldest-hovered',
    'color.chart.purple.bold': '--ds-chart-purple-bold',
    'color.chart.purple.bold.hovered': '--ds-chart-purple-bold-hovered',
    'color.chart.purple.bolder': '--ds-chart-purple-bolder',
    'color.chart.purple.bolder.hovered': '--ds-chart-purple-bolder-hovered',
    'color.chart.purple.boldest': '--ds-chart-purple-boldest',
    'color.chart.purple.boldest.hovered': '--ds-chart-purple-boldest-hovered',
    'color.chart.magenta.bold': '--ds-chart-magenta-bold',
    'color.chart.magenta.bold.hovered': '--ds-chart-magenta-bold-hovered',
    'color.chart.magenta.bolder': '--ds-chart-magenta-bolder',
    'color.chart.magenta.bolder.hovered': '--ds-chart-magenta-bolder-hovered',
    'color.chart.magenta.boldest': '--ds-chart-magenta-boldest',
    'color.chart.magenta.boldest.hovered': '--ds-chart-magenta-boldest-hovered',
    'color.chart.gray.bold': '--ds-chart-gray-bold',
    'color.chart.gray.bold.hovered': '--ds-chart-gray-bold-hovered',
    'color.chart.gray.bolder': '--ds-chart-gray-bolder',
    'color.chart.gray.bolder.hovered': '--ds-chart-gray-bolder-hovered',
    'color.chart.gray.boldest': '--ds-chart-gray-boldest',
    'color.chart.gray.boldest.hovered': '--ds-chart-gray-boldest-hovered',
    'color.chart.brand': '--ds-chart-brand',
    'color.chart.brand.hovered': '--ds-chart-brand-hovered',
    'color.chart.danger': '--ds-chart-danger',
    'color.chart.danger.hovered': '--ds-chart-danger-hovered',
    'color.chart.danger.bold': '--ds-chart-danger-bold',
    'color.chart.danger.bold.hovered': '--ds-chart-danger-bold-hovered',
    'color.chart.warning': '--ds-chart-warning',
    'color.chart.warning.hovered': '--ds-chart-warning-hovered',
    'color.chart.warning.bold': '--ds-chart-warning-bold',
    'color.chart.warning.bold.hovered': '--ds-chart-warning-bold-hovered',
    'color.chart.success': '--ds-chart-success',
    'color.chart.success.hovered': '--ds-chart-success-hovered',
    'color.chart.success.bold': '--ds-chart-success-bold',
    'color.chart.success.bold.hovered': '--ds-chart-success-bold-hovered',
    'color.chart.discovery': '--ds-chart-discovery',
    'color.chart.discovery.hovered': '--ds-chart-discovery-hovered',
    'color.chart.discovery.bold': '--ds-chart-discovery-bold',
    'color.chart.discovery.bold.hovered': '--ds-chart-discovery-bold-hovered',
    'color.chart.information': '--ds-chart-information',
    'color.chart.information.hovered': '--ds-chart-information-hovered',
    'color.chart.information.bold': '--ds-chart-information-bold',
    'color.chart.information.bold.hovered': '--ds-chart-information-bold-hovered',
    'elevation.surface': '--ds-surface',
    'elevation.surface.hovered': '--ds-surface-hovered',
    'elevation.surface.pressed': '--ds-surface-pressed',
    'elevation.surface.overlay': '--ds-surface-overlay',
    'elevation.surface.overlay.hovered': '--ds-surface-overlay-hovered',
    'elevation.surface.overlay.pressed': '--ds-surface-overlay-pressed',
    'elevation.surface.raised': '--ds-surface-raised',
    'elevation.surface.raised.hovered': '--ds-surface-raised-hovered',
    'elevation.surface.raised.pressed': '--ds-surface-raised-pressed',
    'elevation.surface.sunken': '--ds-surface-sunken',
    'elevation.shadow.overflow': '--ds-shadow-overflow',
    'elevation.shadow.overflow.perimeter': '--ds-shadow-overflow-perimeter',
    'elevation.shadow.overflow.spread': '--ds-shadow-overflow-spread',
    'elevation.shadow.overlay': '--ds-shadow-overlay',
    'elevation.shadow.raised': '--ds-shadow-raised',
    'opacity.disabled': '--ds-opacity-disabled',
    'opacity.loading': '--ds-opacity-loading',
    'utility.UNSAFE.transparent': '--ds-UNSAFE-transparent',
    'utility.elevation.surface.current': '--ds-elevation-surface-current',
    'space.0': '--ds-space-0',
    'space.025': '--ds-space-025',
    'space.050': '--ds-space-050',
    'space.075': '--ds-space-075',
    'space.100': '--ds-space-100',
    'space.150': '--ds-space-150',
    'space.200': '--ds-space-200',
    'space.250': '--ds-space-250',
    'space.300': '--ds-space-300',
    'space.400': '--ds-space-400',
    'space.500': '--ds-space-500',
    'space.600': '--ds-space-600',
    'space.800': '--ds-space-800',
    'space.1000': '--ds-space-1000',
    'space.negative.025': '--ds-space-negative-025',
    'space.negative.050': '--ds-space-negative-050',
    'space.negative.075': '--ds-space-negative-075',
    'space.negative.100': '--ds-space-negative-100',
    'space.negative.150': '--ds-space-negative-150',
    'space.negative.200': '--ds-space-negative-200',
    'space.negative.250': '--ds-space-negative-250',
    'space.negative.300': '--ds-space-negative-300',
    'space.negative.400': '--ds-space-negative-400',
    'font.heading.xxlarge': '--ds-font-heading-xxlarge',
    'font.heading.xlarge': '--ds-font-heading-xlarge',
    'font.heading.large': '--ds-font-heading-large',
    'font.heading.medium': '--ds-font-heading-medium',
    'font.heading.small': '--ds-font-heading-small',
    'font.heading.xsmall': '--ds-font-heading-xsmall',
    'font.heading.xxsmall': '--ds-font-heading-xxsmall',
    'font.body.large': '--ds-font-body-large',
    'font.body': '--ds-font-body',
    'font.body.small': '--ds-font-body-small',
    'font.body.UNSAFE_small': '--ds-font-body-UNSAFE_small',
    'font.metric.large': '--ds-font-metric-large',
    'font.metric.medium': '--ds-font-metric-medium',
    'font.metric.small': '--ds-font-metric-small',
    'font.code': '--ds-font-code',
    'font.weight.regular': '--ds-font-weight-regular',
    'font.weight.medium': '--ds-font-weight-medium',
    'font.weight.semibold': '--ds-font-weight-semibold',
    'font.weight.bold': '--ds-font-weight-bold',
    'font.family.heading': '--ds-font-family-heading',
    'font.family.body': '--ds-font-family-body',
    'font.family.code': '--ds-font-family-code',
    'font.family.brand.heading': '--ds-font-family-brand-heading',
    'font.family.brand.body': '--ds-font-family-brand-body',
    'radius.xsmall': '--ds-radius-xsmall',
    'radius.small': '--ds-radius-small',
    'radius.medium': '--ds-radius-medium',
    'radius.large': '--ds-radius-large',
    'radius.xlarge': '--ds-radius-xlarge',
    'radius.xxlarge': '--ds-radius-xxlarge',
    'radius.full': '--ds-radius-full',
    'radius.tile': '--ds-radius-tile',
    'border.width': '--ds-border-width',
    'border.width.selected': '--ds-border-width-selected',
    'border.width.focused': '--ds-border-width-focused'
};
var $6f87a6626ab803ba$export$2e2bcd8739ae039 = $6f87a6626ab803ba$var$tokens;

});


parcelRegister("gLJAe", function(module, exports) {

var $iKwew = parcelRequire("iKwew");
module.exports = $iKwew("kfSKx").then(()=>parcelRequire('6fzTn'));

});

parcelRegister("d0sVE", function(module, exports) {
$parcel$export(module.exports, "useCloseOnEscapePress", () => $9781b722f37843eb$export$4a4bf067ea9e7886);
$parcel$export(module.exports, "useLayering", () => $9781b722f37843eb$export$c8b4d54e03dee6ed);

var $5FkrB = parcelRequire("5FkrB");

var $7QpUe = parcelRequire("7QpUe");

var $8IltX = parcelRequire("8IltX");
var $9781b722f37843eb$var$ESCAPE = 'Escape';
function $9781b722f37843eb$export$4a4bf067ea9e7886(_ref) {
    var onClose = _ref.onClose, isDisabled = _ref.isDisabled;
    var escapePressed = (0, $5FkrB.useRef)(false);
    var _useLayering = $9781b722f37843eb$export$c8b4d54e03dee6ed(), isLayerDisabled = _useLayering.isLayerDisabled;
    var onKeyDown = (0, $5FkrB.useCallback)(function(e) {
        var isDisabledLayer = isLayerDisabled();
        if (isDisabled || escapePressed.current || e.key !== $9781b722f37843eb$var$ESCAPE || isDisabledLayer) // We're either already handling the key down event or it's not escape or disabled.
        // Bail early!
        return;
        escapePressed.current = true;
        onClose(e);
    }, [
        onClose,
        isDisabled,
        isLayerDisabled
    ]);
    var onKeyUp = (0, $5FkrB.useCallback)(function() {
        escapePressed.current = false;
    }, []);
    (0, $5FkrB.useEffect)(function() {
        return (0, $7QpUe.bindAll)(window, [
            {
                type: 'keydown',
                listener: onKeyDown
            },
            {
                type: 'keyup',
                listener: onKeyUp
            }
        ], {
            capture: false
        });
    }, [
        onKeyDown,
        onKeyUp
    ]);
}
function $9781b722f37843eb$export$c8b4d54e03dee6ed() {
    var currentLevel = (0, $5FkrB.useContext)((0, $8IltX.LevelContext));
    var layerNode = (0, $5FkrB.useContext)((0, $8IltX.LevelNodeContext));
    var rootNode = (0, $5FkrB.useContext)((0, $8IltX.RootNodeContext));
    var isLayerDisabled = (0, $5FkrB.useCallback)(function() {
        // This is an impossible case, added for type safety
        if (!(layerNode !== null && layerNode !== void 0 && layerNode.current) || !(rootNode !== null && rootNode !== void 0 && rootNode.current)) return false;
        return layerNode.current.getLevel() < rootNode.current.getHeight();
    }, [
        layerNode,
        rootNode
    ]);
    var getTopLevel = (0, $5FkrB.useCallback)(function() {
        return rootNode !== null && rootNode !== void 0 && rootNode.current ? rootNode.current.getHeight() : null;
    }, [
        rootNode
    ]);
    return {
        currentLevel: currentLevel,
        isLayerDisabled: isLayerDisabled,
        getTopLevel: getTopLevel
    };
}

});

parcelRegister("rM88w", function(module, exports) {

var $kqGi7 = parcelRequire("kqGi7");

var $3PGbS = parcelRequire("3PGbS");

var $4XdzH = parcelRequire("4XdzH");

var $4vMNO = parcelRequire("4vMNO");

var $llxyP = parcelRequire("llxyP");
/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */ function $0537db6479d58bdd$var$baseIteratee(value) {
    // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
    // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
    if (typeof value == 'function') return value;
    if (value == null) return $4XdzH;
    if (typeof value == 'object') return $4vMNO(value) ? $3PGbS(value[0], value[1]) : $kqGi7(value);
    return $llxyP(value);
}
module.exports = $0537db6479d58bdd$var$baseIteratee;

});
parcelRegister("kqGi7", function(module, exports) {

var $cu7Wi = parcelRequire("cu7Wi");

var $gCoRb = parcelRequire("gCoRb");

var $ksIMb = parcelRequire("ksIMb");
/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */ function $edf70a82707a5c74$var$baseMatches(source) {
    var matchData = $gCoRb(source);
    if (matchData.length == 1 && matchData[0][2]) return $ksIMb(matchData[0][0], matchData[0][1]);
    return function(object) {
        return object === source || $cu7Wi(object, source, matchData);
    };
}
module.exports = $edf70a82707a5c74$var$baseMatches;

});
parcelRegister("cu7Wi", function(module, exports) {

var $7kqkb = parcelRequire("7kqkb");

var $ca8FL = parcelRequire("ca8FL");
/** Used to compose bitmasks for value comparisons. */ var $916e71f2ad42bc0c$var$COMPARE_PARTIAL_FLAG = 1, $916e71f2ad42bc0c$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */ function $916e71f2ad42bc0c$var$baseIsMatch(object, source, matchData, customizer) {
    var index = matchData.length, length = index, noCustomizer = !customizer;
    if (object == null) return !length;
    object = Object(object);
    while(index--){
        var data = matchData[index];
        if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) return false;
    }
    while(++index < length){
        data = matchData[index];
        var key = data[0], objValue = object[key], srcValue = data[1];
        if (noCustomizer && data[2]) {
            if (objValue === undefined && !(key in object)) return false;
        } else {
            var stack = new $7kqkb;
            if (customizer) var result = customizer(objValue, srcValue, key, object, source, stack);
            if (!(result === undefined ? $ca8FL(srcValue, objValue, $916e71f2ad42bc0c$var$COMPARE_PARTIAL_FLAG | $916e71f2ad42bc0c$var$COMPARE_UNORDERED_FLAG, customizer, stack) : result)) return false;
        }
    }
    return true;
}
module.exports = $916e71f2ad42bc0c$var$baseIsMatch;

});
parcelRegister("7kqkb", function(module, exports) {

var $jcImH = parcelRequire("jcImH");

var $djPNA = parcelRequire("djPNA");

var $hylOX = parcelRequire("hylOX");

var $jO3zu = parcelRequire("jO3zu");

var $bxqxo = parcelRequire("bxqxo");

var $esD6S = parcelRequire("esD6S");
/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $555ed227043693dd$var$Stack(entries) {
    var data = this.__data__ = new $jcImH(entries);
    this.size = data.size;
}
// Add methods to `Stack`.
$555ed227043693dd$var$Stack.prototype.clear = $djPNA;
$555ed227043693dd$var$Stack.prototype['delete'] = $hylOX;
$555ed227043693dd$var$Stack.prototype.get = $jO3zu;
$555ed227043693dd$var$Stack.prototype.has = $bxqxo;
$555ed227043693dd$var$Stack.prototype.set = $esD6S;
module.exports = $555ed227043693dd$var$Stack;

});
parcelRegister("djPNA", function(module, exports) {

var $jcImH = parcelRequire("jcImH");
/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */ function $9b253ae18ed66763$var$stackClear() {
    this.__data__ = new $jcImH;
    this.size = 0;
}
module.exports = $9b253ae18ed66763$var$stackClear;

});

parcelRegister("hylOX", function(module, exports) {
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $cc7689cecebf80d4$var$stackDelete(key) {
    var data = this.__data__, result = data['delete'](key);
    this.size = data.size;
    return result;
}
module.exports = $cc7689cecebf80d4$var$stackDelete;

});

parcelRegister("jO3zu", function(module, exports) {
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $e6b57505e61dbbd6$var$stackGet(key) {
    return this.__data__.get(key);
}
module.exports = $e6b57505e61dbbd6$var$stackGet;

});

parcelRegister("bxqxo", function(module, exports) {
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $86675c97e12c435a$var$stackHas(key) {
    return this.__data__.has(key);
}
module.exports = $86675c97e12c435a$var$stackHas;

});

parcelRegister("esD6S", function(module, exports) {

var $jcImH = parcelRequire("jcImH");

var $45eKn = parcelRequire("45eKn");

var $fbj5d = parcelRequire("fbj5d");
/** Used as the size to enable large array optimizations. */ var $a87204a1a5016597$var$LARGE_ARRAY_SIZE = 200;
/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */ function $a87204a1a5016597$var$stackSet(key, value) {
    var data = this.__data__;
    if (data instanceof $jcImH) {
        var pairs = data.__data__;
        if (!$45eKn || pairs.length < $a87204a1a5016597$var$LARGE_ARRAY_SIZE - 1) {
            pairs.push([
                key,
                value
            ]);
            this.size = ++data.size;
            return this;
        }
        data = this.__data__ = new $fbj5d(pairs);
    }
    data.set(key, value);
    this.size = data.size;
    return this;
}
module.exports = $a87204a1a5016597$var$stackSet;

});


parcelRegister("ca8FL", function(module, exports) {

var $9b9bC = parcelRequire("9b9bC");

var $9Msco = parcelRequire("9Msco");
/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */ function $8dad2568c75ac63f$var$baseIsEqual(value, other, bitmask, customizer, stack) {
    if (value === other) return true;
    if (value == null || other == null || !$9Msco(value) && !$9Msco(other)) return value !== value && other !== other;
    return $9b9bC(value, other, bitmask, customizer, $8dad2568c75ac63f$var$baseIsEqual, stack);
}
module.exports = $8dad2568c75ac63f$var$baseIsEqual;

});
parcelRegister("9b9bC", function(module, exports) {

var $7kqkb = parcelRequire("7kqkb");

var $63dty = parcelRequire("63dty");

var $hmXdW = parcelRequire("hmXdW");

var $9UVG3 = parcelRequire("9UVG3");

var $eYfpN = parcelRequire("eYfpN");

var $4vMNO = parcelRequire("4vMNO");

var $hKJGr = parcelRequire("hKJGr");

var $35WaP = parcelRequire("35WaP");
/** Used to compose bitmasks for value comparisons. */ var $6aec445ee44e62ff$var$COMPARE_PARTIAL_FLAG = 1;
/** `Object#toString` result references. */ var $6aec445ee44e62ff$var$argsTag = '[object Arguments]', $6aec445ee44e62ff$var$arrayTag = '[object Array]', $6aec445ee44e62ff$var$objectTag = '[object Object]';
/** Used for built-in method references. */ var $6aec445ee44e62ff$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $6aec445ee44e62ff$var$hasOwnProperty = $6aec445ee44e62ff$var$objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $6aec445ee44e62ff$var$baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
    var objIsArr = $4vMNO(object), othIsArr = $4vMNO(other), objTag = objIsArr ? $6aec445ee44e62ff$var$arrayTag : $eYfpN(object), othTag = othIsArr ? $6aec445ee44e62ff$var$arrayTag : $eYfpN(other);
    objTag = objTag == $6aec445ee44e62ff$var$argsTag ? $6aec445ee44e62ff$var$objectTag : objTag;
    othTag = othTag == $6aec445ee44e62ff$var$argsTag ? $6aec445ee44e62ff$var$objectTag : othTag;
    var objIsObj = objTag == $6aec445ee44e62ff$var$objectTag, othIsObj = othTag == $6aec445ee44e62ff$var$objectTag, isSameTag = objTag == othTag;
    if (isSameTag && $hKJGr(object)) {
        if (!$hKJGr(other)) return false;
        objIsArr = true;
        objIsObj = false;
    }
    if (isSameTag && !objIsObj) {
        stack || (stack = new $7kqkb);
        return objIsArr || $35WaP(object) ? $63dty(object, other, bitmask, customizer, equalFunc, stack) : $hmXdW(object, other, objTag, bitmask, customizer, equalFunc, stack);
    }
    if (!(bitmask & $6aec445ee44e62ff$var$COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && $6aec445ee44e62ff$var$hasOwnProperty.call(object, '__wrapped__'), othIsWrapped = othIsObj && $6aec445ee44e62ff$var$hasOwnProperty.call(other, '__wrapped__');
        if (objIsWrapped || othIsWrapped) {
            var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
            stack || (stack = new $7kqkb);
            return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
    }
    if (!isSameTag) return false;
    stack || (stack = new $7kqkb);
    return $9UVG3(object, other, bitmask, customizer, equalFunc, stack);
}
module.exports = $6aec445ee44e62ff$var$baseIsEqualDeep;

});
parcelRegister("63dty", function(module, exports) {

var $lRqBv = parcelRequire("lRqBv");

var $nxDZH = parcelRequire("nxDZH");

var $lNWRT = parcelRequire("lNWRT");
/** Used to compose bitmasks for value comparisons. */ var $467d79e7a0dc3223$var$COMPARE_PARTIAL_FLAG = 1, $467d79e7a0dc3223$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */ function $467d79e7a0dc3223$var$equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & $467d79e7a0dc3223$var$COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
    if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
    // Check that cyclic values are equal.
    var arrStacked = stack.get(array);
    var othStacked = stack.get(other);
    if (arrStacked && othStacked) return arrStacked == other && othStacked == array;
    var index = -1, result = true, seen = bitmask & $467d79e7a0dc3223$var$COMPARE_UNORDERED_FLAG ? new $lRqBv : undefined;
    stack.set(array, other);
    stack.set(other, array);
    // Ignore non-index properties.
    while(++index < arrLength){
        var arrValue = array[index], othValue = other[index];
        if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
        if (compared !== undefined) {
            if (compared) continue;
            result = false;
            break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
            if (!$nxDZH(other, function(othValue, othIndex) {
                if (!$lNWRT(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
            })) {
                result = false;
                break;
            }
        } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
            result = false;
            break;
        }
    }
    stack['delete'](array);
    stack['delete'](other);
    return result;
}
module.exports = $467d79e7a0dc3223$var$equalArrays;

});
parcelRegister("lRqBv", function(module, exports) {

var $fbj5d = parcelRequire("fbj5d");

var $jZbnn = parcelRequire("jZbnn");

var $watpw = parcelRequire("watpw");
/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */ function $fea32f338652af47$var$SetCache(values) {
    var index = -1, length = values == null ? 0 : values.length;
    this.__data__ = new $fbj5d;
    while(++index < length)this.add(values[index]);
}
// Add methods to `SetCache`.
$fea32f338652af47$var$SetCache.prototype.add = $fea32f338652af47$var$SetCache.prototype.push = $jZbnn;
$fea32f338652af47$var$SetCache.prototype.has = $watpw;
module.exports = $fea32f338652af47$var$SetCache;

});
parcelRegister("jZbnn", function(module, exports) {
/** Used to stand-in for `undefined` hash values. */ var $03c13c07b846ee4b$var$HASH_UNDEFINED = '__lodash_hash_undefined__';
/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */ function $03c13c07b846ee4b$var$setCacheAdd(value) {
    this.__data__.set(value, $03c13c07b846ee4b$var$HASH_UNDEFINED);
    return this;
}
module.exports = $03c13c07b846ee4b$var$setCacheAdd;

});

parcelRegister("watpw", function(module, exports) {
/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {boolean} Returns `true` if `value` is found, else `false`.
 */ function $060b1d10c0941294$var$setCacheHas(value) {
    return this.__data__.has(value);
}
module.exports = $060b1d10c0941294$var$setCacheHas;

});


parcelRegister("nxDZH", function(module, exports) {
/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */ function $046c3f1b97584d32$var$arraySome(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (predicate(array[index], index, array)) return true;
    }
    return false;
}
module.exports = $046c3f1b97584d32$var$arraySome;

});

parcelRegister("lNWRT", function(module, exports) {
/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $fdfbd692a8a03f6b$var$cacheHas(cache, key) {
    return cache.has(key);
}
module.exports = $fdfbd692a8a03f6b$var$cacheHas;

});


parcelRegister("hmXdW", function(module, exports) {

var $fb7PP = parcelRequire("fb7PP");

var $e4K2f = parcelRequire("e4K2f");

var $grAle = parcelRequire("grAle");

var $63dty = parcelRequire("63dty");

var $f98N5 = parcelRequire("f98N5");

var $p1poT = parcelRequire("p1poT");
/** Used to compose bitmasks for value comparisons. */ var $ca526e59406bed21$var$COMPARE_PARTIAL_FLAG = 1, $ca526e59406bed21$var$COMPARE_UNORDERED_FLAG = 2;
/** `Object#toString` result references. */ var $ca526e59406bed21$var$boolTag = '[object Boolean]', $ca526e59406bed21$var$dateTag = '[object Date]', $ca526e59406bed21$var$errorTag = '[object Error]', $ca526e59406bed21$var$mapTag = '[object Map]', $ca526e59406bed21$var$numberTag = '[object Number]', $ca526e59406bed21$var$regexpTag = '[object RegExp]', $ca526e59406bed21$var$setTag = '[object Set]', $ca526e59406bed21$var$stringTag = '[object String]', $ca526e59406bed21$var$symbolTag = '[object Symbol]';
var $ca526e59406bed21$var$arrayBufferTag = '[object ArrayBuffer]', $ca526e59406bed21$var$dataViewTag = '[object DataView]';
/** Used to convert symbols to primitives and strings. */ var $ca526e59406bed21$var$symbolProto = $fb7PP ? $fb7PP.prototype : undefined, $ca526e59406bed21$var$symbolValueOf = $ca526e59406bed21$var$symbolProto ? $ca526e59406bed21$var$symbolProto.valueOf : undefined;
/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $ca526e59406bed21$var$equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
    switch(tag){
        case $ca526e59406bed21$var$dataViewTag:
            if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
            object = object.buffer;
            other = other.buffer;
        case $ca526e59406bed21$var$arrayBufferTag:
            if (object.byteLength != other.byteLength || !equalFunc(new $e4K2f(object), new $e4K2f(other))) return false;
            return true;
        case $ca526e59406bed21$var$boolTag:
        case $ca526e59406bed21$var$dateTag:
        case $ca526e59406bed21$var$numberTag:
            // Coerce booleans to `1` or `0` and dates to milliseconds.
            // Invalid dates are coerced to `NaN`.
            return $grAle(+object, +other);
        case $ca526e59406bed21$var$errorTag:
            return object.name == other.name && object.message == other.message;
        case $ca526e59406bed21$var$regexpTag:
        case $ca526e59406bed21$var$stringTag:
            // Coerce regexes to strings and treat strings, primitives and objects,
            // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
            // for more details.
            return object == other + '';
        case $ca526e59406bed21$var$mapTag:
            var convert = $f98N5;
        case $ca526e59406bed21$var$setTag:
            var isPartial = bitmask & $ca526e59406bed21$var$COMPARE_PARTIAL_FLAG;
            convert || (convert = $p1poT);
            if (object.size != other.size && !isPartial) return false;
            // Assume cyclic values are equal.
            var stacked = stack.get(object);
            if (stacked) return stacked == other;
            bitmask |= $ca526e59406bed21$var$COMPARE_UNORDERED_FLAG;
            // Recursively compare objects (susceptible to call stack limits).
            stack.set(object, other);
            var result = $63dty(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
            stack['delete'](object);
            return result;
        case $ca526e59406bed21$var$symbolTag:
            if ($ca526e59406bed21$var$symbolValueOf) return $ca526e59406bed21$var$symbolValueOf.call(object) == $ca526e59406bed21$var$symbolValueOf.call(other);
    }
    return false;
}
module.exports = $ca526e59406bed21$var$equalByTag;

});
parcelRegister("e4K2f", function(module, exports) {

var $iXqsg = parcelRequire("iXqsg");
/** Built-in value references. */ var $a3f526090b0d03d9$var$Uint8Array = $iXqsg.Uint8Array;
module.exports = $a3f526090b0d03d9$var$Uint8Array;

});

parcelRegister("f98N5", function(module, exports) {
/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */ function $b06e83ec105b03f5$var$mapToArray(map) {
    var index = -1, result = Array(map.size);
    map.forEach(function(value, key) {
        result[++index] = [
            key,
            value
        ];
    });
    return result;
}
module.exports = $b06e83ec105b03f5$var$mapToArray;

});

parcelRegister("p1poT", function(module, exports) {
/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */ function $04b36da66dc85ac6$var$setToArray(set) {
    var index = -1, result = Array(set.size);
    set.forEach(function(value) {
        result[++index] = value;
    });
    return result;
}
module.exports = $04b36da66dc85ac6$var$setToArray;

});


parcelRegister("9UVG3", function(module, exports) {

var $cLnAZ = parcelRequire("cLnAZ");
/** Used to compose bitmasks for value comparisons. */ var $738615844c0356e3$var$COMPARE_PARTIAL_FLAG = 1;
/** Used for built-in method references. */ var $738615844c0356e3$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $738615844c0356e3$var$hasOwnProperty = $738615844c0356e3$var$objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $738615844c0356e3$var$equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & $738615844c0356e3$var$COMPARE_PARTIAL_FLAG, objProps = $cLnAZ(object), objLength = objProps.length, othProps = $cLnAZ(other), othLength = othProps.length;
    if (objLength != othLength && !isPartial) return false;
    var index = objLength;
    while(index--){
        var key = objProps[index];
        if (!(isPartial ? key in other : $738615844c0356e3$var$hasOwnProperty.call(other, key))) return false;
    }
    // Check that cyclic values are equal.
    var objStacked = stack.get(object);
    var othStacked = stack.get(other);
    if (objStacked && othStacked) return objStacked == other && othStacked == object;
    var result = true;
    stack.set(object, other);
    stack.set(other, object);
    var skipCtor = isPartial;
    while(++index < objLength){
        key = objProps[index];
        var objValue = object[key], othValue = other[key];
        if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
            result = false;
            break;
        }
        skipCtor || (skipCtor = key == 'constructor');
    }
    if (result && !skipCtor) {
        var objCtor = object.constructor, othCtor = other.constructor;
        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor && 'constructor' in object && 'constructor' in other && !(typeof objCtor == 'function' && objCtor instanceof objCtor && typeof othCtor == 'function' && othCtor instanceof othCtor)) result = false;
    }
    stack['delete'](object);
    stack['delete'](other);
    return result;
}
module.exports = $738615844c0356e3$var$equalObjects;

});
parcelRegister("cLnAZ", function(module, exports) {

var $3rhCx = parcelRequire("3rhCx");

var $1QI3J = parcelRequire("1QI3J");

var $8XuRV = parcelRequire("8XuRV");
/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $94ac2d67f2b0179c$var$getAllKeys(object) {
    return $3rhCx(object, $8XuRV, $1QI3J);
}
module.exports = $94ac2d67f2b0179c$var$getAllKeys;

});
parcelRegister("3rhCx", function(module, exports) {

var $fj32b = parcelRequire("fj32b");

var $4vMNO = parcelRequire("4vMNO");
/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $28118fcaf071ff15$var$baseGetAllKeys(object, keysFunc, symbolsFunc) {
    var result = keysFunc(object);
    return $4vMNO(object) ? result : $fj32b(result, symbolsFunc(object));
}
module.exports = $28118fcaf071ff15$var$baseGetAllKeys;

});
parcelRegister("fj32b", function(module, exports) {
/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */ function $b24afbe2c8091864$var$arrayPush(array, values) {
    var index = -1, length = values.length, offset = array.length;
    while(++index < length)array[offset + index] = values[index];
    return array;
}
module.exports = $b24afbe2c8091864$var$arrayPush;

});


parcelRegister("1QI3J", function(module, exports) {

var $cjaaB = parcelRequire("cjaaB");

var $3EIHX = parcelRequire("3EIHX");
/** Used for built-in method references. */ var $158cd2fdded140ac$var$objectProto = Object.prototype;
/** Built-in value references. */ var $158cd2fdded140ac$var$propertyIsEnumerable = $158cd2fdded140ac$var$objectProto.propertyIsEnumerable;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $158cd2fdded140ac$var$nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var $158cd2fdded140ac$var$getSymbols = !$158cd2fdded140ac$var$nativeGetSymbols ? $3EIHX : function(object) {
    if (object == null) return [];
    object = Object(object);
    return $cjaaB($158cd2fdded140ac$var$nativeGetSymbols(object), function(symbol) {
        return $158cd2fdded140ac$var$propertyIsEnumerable.call(object, symbol);
    });
};
module.exports = $158cd2fdded140ac$var$getSymbols;

});
parcelRegister("cjaaB", function(module, exports) {
/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */ function $8f5f25ebc211fb67$var$arrayFilter(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
    while(++index < length){
        var value = array[index];
        if (predicate(value, index, array)) result[resIndex++] = value;
    }
    return result;
}
module.exports = $8f5f25ebc211fb67$var$arrayFilter;

});

parcelRegister("3EIHX", function(module, exports) {
/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */ function $2a97c993b4c74802$var$stubArray() {
    return [];
}
module.exports = $2a97c993b4c74802$var$stubArray;

});


parcelRegister("8XuRV", function(module, exports) {

var $5WR7T = parcelRequire("5WR7T");

var $83XOu = parcelRequire("83XOu");

var $8Ak9r = parcelRequire("8Ak9r");
/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */ function $685bc755b0ff08ca$var$keys(object) {
    return $8Ak9r(object) ? $5WR7T(object) : $83XOu(object);
}
module.exports = $685bc755b0ff08ca$var$keys;

});
parcelRegister("5WR7T", function(module, exports) {

var $64Uwy = parcelRequire("64Uwy");

var $bB85C = parcelRequire("bB85C");

var $4vMNO = parcelRequire("4vMNO");

var $hKJGr = parcelRequire("hKJGr");

var $kgLdF = parcelRequire("kgLdF");

var $35WaP = parcelRequire("35WaP");
/** Used for built-in method references. */ var $454b945364a48147$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $454b945364a48147$var$hasOwnProperty = $454b945364a48147$var$objectProto.hasOwnProperty;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function $454b945364a48147$var$arrayLikeKeys(value, inherited) {
    var isArr = $4vMNO(value), isArg = !isArr && $bB85C(value), isBuff = !isArr && !isArg && $hKJGr(value), isType = !isArr && !isArg && !isBuff && $35WaP(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? $64Uwy(value.length, String) : [], length = result.length;
    for(var key in value)if ((inherited || $454b945364a48147$var$hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
    (key == 'length' || // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key == 'offset' || key == 'parent') || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset') || // Skip index properties.
    $kgLdF(key, length)))) result.push(key);
    return result;
}
module.exports = $454b945364a48147$var$arrayLikeKeys;

});
parcelRegister("64Uwy", function(module, exports) {
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ function $46cef64ec31e2299$var$baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
module.exports = $46cef64ec31e2299$var$baseTimes;

});

parcelRegister("bB85C", function(module, exports) {

var $jvIOd = parcelRequire("jvIOd");

var $9Msco = parcelRequire("9Msco");
/** Used for built-in method references. */ var $87196cdc2acd682b$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $87196cdc2acd682b$var$hasOwnProperty = $87196cdc2acd682b$var$objectProto.hasOwnProperty;
/** Built-in value references. */ var $87196cdc2acd682b$var$propertyIsEnumerable = $87196cdc2acd682b$var$objectProto.propertyIsEnumerable;
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ var $87196cdc2acd682b$var$isArguments = $jvIOd(function() {
    return arguments;
}()) ? $jvIOd : function(value) {
    return $9Msco(value) && $87196cdc2acd682b$var$hasOwnProperty.call(value, 'callee') && !$87196cdc2acd682b$var$propertyIsEnumerable.call(value, 'callee');
};
module.exports = $87196cdc2acd682b$var$isArguments;

});
parcelRegister("jvIOd", function(module, exports) {

var $7Vpf7 = parcelRequire("7Vpf7");

var $9Msco = parcelRequire("9Msco");
/** `Object#toString` result references. */ var $e343abb5076d96d4$var$argsTag = '[object Arguments]';
/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */ function $e343abb5076d96d4$var$baseIsArguments(value) {
    return $9Msco(value) && $7Vpf7(value) == $e343abb5076d96d4$var$argsTag;
}
module.exports = $e343abb5076d96d4$var$baseIsArguments;

});


parcelRegister("hKJGr", function(module, exports) {

var $iXqsg = parcelRequire("iXqsg");

var $fBnUd = parcelRequire("fBnUd");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? $iXqsg.Buffer : undefined;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */ var isBuffer = nativeIsBuffer || $fBnUd;
module.exports = isBuffer;

});
parcelRegister("fBnUd", function(module, exports) {
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */ function $b5bcdade5c765129$var$stubFalse() {
    return false;
}
module.exports = $b5bcdade5c765129$var$stubFalse;

});


parcelRegister("35WaP", function(module, exports) {

var $hCJUZ = parcelRequire("hCJUZ");

var $2K3WO = parcelRequire("2K3WO");

var $6hpGa = parcelRequire("6hpGa");
/* Node.js helper references. */ var $240ef6cdb9617e20$var$nodeIsTypedArray = $6hpGa && $6hpGa.isTypedArray;
/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */ var $240ef6cdb9617e20$var$isTypedArray = $240ef6cdb9617e20$var$nodeIsTypedArray ? $2K3WO($240ef6cdb9617e20$var$nodeIsTypedArray) : $hCJUZ;
module.exports = $240ef6cdb9617e20$var$isTypedArray;

});
parcelRegister("hCJUZ", function(module, exports) {

var $7Vpf7 = parcelRequire("7Vpf7");

var $1NwxS = parcelRequire("1NwxS");

var $9Msco = parcelRequire("9Msco");
/** `Object#toString` result references. */ var $cd499aac81060e71$var$argsTag = '[object Arguments]', $cd499aac81060e71$var$arrayTag = '[object Array]', $cd499aac81060e71$var$boolTag = '[object Boolean]', $cd499aac81060e71$var$dateTag = '[object Date]', $cd499aac81060e71$var$errorTag = '[object Error]', $cd499aac81060e71$var$funcTag = '[object Function]', $cd499aac81060e71$var$mapTag = '[object Map]', $cd499aac81060e71$var$numberTag = '[object Number]', $cd499aac81060e71$var$objectTag = '[object Object]', $cd499aac81060e71$var$regexpTag = '[object RegExp]', $cd499aac81060e71$var$setTag = '[object Set]', $cd499aac81060e71$var$stringTag = '[object String]', $cd499aac81060e71$var$weakMapTag = '[object WeakMap]';
var $cd499aac81060e71$var$arrayBufferTag = '[object ArrayBuffer]', $cd499aac81060e71$var$dataViewTag = '[object DataView]', $cd499aac81060e71$var$float32Tag = '[object Float32Array]', $cd499aac81060e71$var$float64Tag = '[object Float64Array]', $cd499aac81060e71$var$int8Tag = '[object Int8Array]', $cd499aac81060e71$var$int16Tag = '[object Int16Array]', $cd499aac81060e71$var$int32Tag = '[object Int32Array]', $cd499aac81060e71$var$uint8Tag = '[object Uint8Array]', $cd499aac81060e71$var$uint8ClampedTag = '[object Uint8ClampedArray]', $cd499aac81060e71$var$uint16Tag = '[object Uint16Array]', $cd499aac81060e71$var$uint32Tag = '[object Uint32Array]';
/** Used to identify `toStringTag` values of typed arrays. */ var $cd499aac81060e71$var$typedArrayTags = {};
$cd499aac81060e71$var$typedArrayTags[$cd499aac81060e71$var$float32Tag] = $cd499aac81060e71$var$typedArrayTags[$cd499aac81060e71$var$float64Tag] = $cd499aac81060e71$var$typedArrayTags[$cd499aac81060e71$var$int8Tag] = $cd499aac81060e71$var$typedArrayTags[$cd499aac81060e71$var$int16Tag] = $cd499aac81060e71$var$typedArrayTags[$cd499aac81060e71$var$int32Tag] = $cd499aac81060e71$var$typedArrayTags[$cd499aac81060e71$var$uint8Tag] = $cd499aac81060e71$var$typedArrayTags[$cd499aac81060e71$var$uint8ClampedTag] = $cd499aac81060e71$var$typedArrayTags[$cd499aac81060e71$var$uint16Tag] = $cd499aac81060e71$var$typedArrayTags[$cd499aac81060e71$var$uint32Tag] = true;
$cd499aac81060e71$var$typedArrayTags[$cd499aac81060e71$var$argsTag] = $cd499aac81060e71$var$typedArrayTags[$cd499aac81060e71$var$arrayTag] = $cd499aac81060e71$var$typedArrayTags[$cd499aac81060e71$var$arrayBufferTag] = $cd499aac81060e71$var$typedArrayTags[$cd499aac81060e71$var$boolTag] = $cd499aac81060e71$var$typedArrayTags[$cd499aac81060e71$var$dataViewTag] = $cd499aac81060e71$var$typedArrayTags[$cd499aac81060e71$var$dateTag] = $cd499aac81060e71$var$typedArrayTags[$cd499aac81060e71$var$errorTag] = $cd499aac81060e71$var$typedArrayTags[$cd499aac81060e71$var$funcTag] = $cd499aac81060e71$var$typedArrayTags[$cd499aac81060e71$var$mapTag] = $cd499aac81060e71$var$typedArrayTags[$cd499aac81060e71$var$numberTag] = $cd499aac81060e71$var$typedArrayTags[$cd499aac81060e71$var$objectTag] = $cd499aac81060e71$var$typedArrayTags[$cd499aac81060e71$var$regexpTag] = $cd499aac81060e71$var$typedArrayTags[$cd499aac81060e71$var$setTag] = $cd499aac81060e71$var$typedArrayTags[$cd499aac81060e71$var$stringTag] = $cd499aac81060e71$var$typedArrayTags[$cd499aac81060e71$var$weakMapTag] = false;
/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */ function $cd499aac81060e71$var$baseIsTypedArray(value) {
    return $9Msco(value) && $1NwxS(value.length) && !!$cd499aac81060e71$var$typedArrayTags[$7Vpf7(value)];
}
module.exports = $cd499aac81060e71$var$baseIsTypedArray;

});
parcelRegister("1NwxS", function(module, exports) {
/** Used as references for various `Number` constants. */ var $14f39ce873328624$var$MAX_SAFE_INTEGER = 9007199254740991;
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function $14f39ce873328624$var$isLength(value) {
    return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= $14f39ce873328624$var$MAX_SAFE_INTEGER;
}
module.exports = $14f39ce873328624$var$isLength;

});


parcelRegister("2K3WO", function(module, exports) {
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */ function $1ff2f08eeb6e8b52$var$baseUnary(func) {
    return function(value) {
        return func(value);
    };
}
module.exports = $1ff2f08eeb6e8b52$var$baseUnary;

});

parcelRegister("6hpGa", function(module, exports) {

var $2eo3w = parcelRequire("2eo3w");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && $2eo3w.process;
/** Used to access faster Node.js helpers. */ var nodeUtil = function() {
    try {
        // Use `util.types` for Node.js 10+.
        var types = freeModule && freeModule.require && freeModule.require('util').types;
        if (types) return types;
        // Legacy `process.binding('util')` for Node.js < 10.
        return freeProcess && freeProcess.binding && freeProcess.binding('util');
    } catch (e) {}
}();
module.exports = nodeUtil;

});



parcelRegister("83XOu", function(module, exports) {

var $8wFaN = parcelRequire("8wFaN");

var $6Rv5K = parcelRequire("6Rv5K");
/** Used for built-in method references. */ var $5ded003d0f731881$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $5ded003d0f731881$var$hasOwnProperty = $5ded003d0f731881$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $5ded003d0f731881$var$baseKeys(object) {
    if (!$8wFaN(object)) return $6Rv5K(object);
    var result = [];
    for(var key in Object(object))if ($5ded003d0f731881$var$hasOwnProperty.call(object, key) && key != 'constructor') result.push(key);
    return result;
}
module.exports = $5ded003d0f731881$var$baseKeys;

});
parcelRegister("8wFaN", function(module, exports) {
/** Used for built-in method references. */ var $63514008f87d0c8b$var$objectProto = Object.prototype;
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function $63514008f87d0c8b$var$isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == 'function' && Ctor.prototype || $63514008f87d0c8b$var$objectProto;
    return value === proto;
}
module.exports = $63514008f87d0c8b$var$isPrototype;

});

parcelRegister("6Rv5K", function(module, exports) {

var $gFyuD = parcelRequire("gFyuD");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $4fefcf7f8e97df7b$var$nativeKeys = $gFyuD(Object.keys, Object);
module.exports = $4fefcf7f8e97df7b$var$nativeKeys;

});
parcelRegister("gFyuD", function(module, exports) {
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function $c22b3b500d8fe60a$var$overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
module.exports = $c22b3b500d8fe60a$var$overArg;

});



parcelRegister("8Ak9r", function(module, exports) {

var $78AO6 = parcelRequire("78AO6");

var $1NwxS = parcelRequire("1NwxS");
/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function $64015129b62b03be$var$isArrayLike(value) {
    return value != null && $1NwxS(value.length) && !$78AO6(value);
}
module.exports = $64015129b62b03be$var$isArrayLike;

});




parcelRegister("eYfpN", function(module, exports) {

var $2EgYc = parcelRequire("2EgYc");

var $45eKn = parcelRequire("45eKn");

var $2bW4y = parcelRequire("2bW4y");

var $cvnnV = parcelRequire("cvnnV");

var $2XKpH = parcelRequire("2XKpH");

var $7Vpf7 = parcelRequire("7Vpf7");

var $1DbD2 = parcelRequire("1DbD2");
/** `Object#toString` result references. */ var $ae62a06bd7777973$var$mapTag = '[object Map]', $ae62a06bd7777973$var$objectTag = '[object Object]', $ae62a06bd7777973$var$promiseTag = '[object Promise]', $ae62a06bd7777973$var$setTag = '[object Set]', $ae62a06bd7777973$var$weakMapTag = '[object WeakMap]';
var $ae62a06bd7777973$var$dataViewTag = '[object DataView]';
/** Used to detect maps, sets, and weakmaps. */ var $ae62a06bd7777973$var$dataViewCtorString = $1DbD2($2EgYc), $ae62a06bd7777973$var$mapCtorString = $1DbD2($45eKn), $ae62a06bd7777973$var$promiseCtorString = $1DbD2($2bW4y), $ae62a06bd7777973$var$setCtorString = $1DbD2($cvnnV), $ae62a06bd7777973$var$weakMapCtorString = $1DbD2($2XKpH);
/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ var $ae62a06bd7777973$var$getTag = $7Vpf7;
// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ($2EgYc && $ae62a06bd7777973$var$getTag(new $2EgYc(new ArrayBuffer(1))) != $ae62a06bd7777973$var$dataViewTag || $45eKn && $ae62a06bd7777973$var$getTag(new $45eKn) != $ae62a06bd7777973$var$mapTag || $2bW4y && $ae62a06bd7777973$var$getTag($2bW4y.resolve()) != $ae62a06bd7777973$var$promiseTag || $cvnnV && $ae62a06bd7777973$var$getTag(new $cvnnV) != $ae62a06bd7777973$var$setTag || $2XKpH && $ae62a06bd7777973$var$getTag(new $2XKpH) != $ae62a06bd7777973$var$weakMapTag) $ae62a06bd7777973$var$getTag = function(value) {
    var result = $7Vpf7(value), Ctor = result == $ae62a06bd7777973$var$objectTag ? value.constructor : undefined, ctorString = Ctor ? $1DbD2(Ctor) : '';
    if (ctorString) switch(ctorString){
        case $ae62a06bd7777973$var$dataViewCtorString:
            return $ae62a06bd7777973$var$dataViewTag;
        case $ae62a06bd7777973$var$mapCtorString:
            return $ae62a06bd7777973$var$mapTag;
        case $ae62a06bd7777973$var$promiseCtorString:
            return $ae62a06bd7777973$var$promiseTag;
        case $ae62a06bd7777973$var$setCtorString:
            return $ae62a06bd7777973$var$setTag;
        case $ae62a06bd7777973$var$weakMapCtorString:
            return $ae62a06bd7777973$var$weakMapTag;
    }
    return result;
};
module.exports = $ae62a06bd7777973$var$getTag;

});
parcelRegister("2EgYc", function(module, exports) {

var $76YAf = parcelRequire("76YAf");

var $iXqsg = parcelRequire("iXqsg");
/* Built-in method references that are verified to be native. */ var $1edc7b1251ee37af$var$DataView = $76YAf($iXqsg, 'DataView');
module.exports = $1edc7b1251ee37af$var$DataView;

});

parcelRegister("2bW4y", function(module, exports) {

var $76YAf = parcelRequire("76YAf");

var $iXqsg = parcelRequire("iXqsg");
/* Built-in method references that are verified to be native. */ var $1989a7d3b4a7eed0$var$Promise = $76YAf($iXqsg, 'Promise');
module.exports = $1989a7d3b4a7eed0$var$Promise;

});

parcelRegister("cvnnV", function(module, exports) {

var $76YAf = parcelRequire("76YAf");

var $iXqsg = parcelRequire("iXqsg");
/* Built-in method references that are verified to be native. */ var $91aa850b36ee58fd$var$Set = $76YAf($iXqsg, 'Set');
module.exports = $91aa850b36ee58fd$var$Set;

});

parcelRegister("2XKpH", function(module, exports) {

var $76YAf = parcelRequire("76YAf");

var $iXqsg = parcelRequire("iXqsg");
/* Built-in method references that are verified to be native. */ var $2285183bc7b4f19f$var$WeakMap = $76YAf($iXqsg, 'WeakMap');
module.exports = $2285183bc7b4f19f$var$WeakMap;

});





parcelRegister("gCoRb", function(module, exports) {

var $1RmrW = parcelRequire("1RmrW");

var $8XuRV = parcelRequire("8XuRV");
/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */ function $c19379f9bb80f646$var$getMatchData(object) {
    var result = $8XuRV(object), length = result.length;
    while(length--){
        var key = result[length], value = object[key];
        result[length] = [
            key,
            value,
            $1RmrW(value)
        ];
    }
    return result;
}
module.exports = $c19379f9bb80f646$var$getMatchData;

});
parcelRegister("1RmrW", function(module, exports) {

var $lIhLB = parcelRequire("lIhLB");
/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */ function $15ac27ba16e67add$var$isStrictComparable(value) {
    return value === value && !$lIhLB(value);
}
module.exports = $15ac27ba16e67add$var$isStrictComparable;

});


parcelRegister("ksIMb", function(module, exports) {
/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ function $ee5927c36e3a084b$var$matchesStrictComparable(key, srcValue) {
    return function(object) {
        if (object == null) return false;
        return object[key] === srcValue && (srcValue !== undefined || key in Object(object));
    };
}
module.exports = $ee5927c36e3a084b$var$matchesStrictComparable;

});


parcelRegister("3PGbS", function(module, exports) {

var $ca8FL = parcelRequire("ca8FL");

var $fe1Wm = parcelRequire("fe1Wm");

var $hCkFK = parcelRequire("hCkFK");

var $agaje = parcelRequire("agaje");

var $1RmrW = parcelRequire("1RmrW");

var $ksIMb = parcelRequire("ksIMb");

var $WbaOC = parcelRequire("WbaOC");
/** Used to compose bitmasks for value comparisons. */ var $2ca6dcb21d828bb2$var$COMPARE_PARTIAL_FLAG = 1, $2ca6dcb21d828bb2$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ function $2ca6dcb21d828bb2$var$baseMatchesProperty(path, srcValue) {
    if ($agaje(path) && $1RmrW(srcValue)) return $ksIMb($WbaOC(path), srcValue);
    return function(object) {
        var objValue = $fe1Wm(object, path);
        return objValue === undefined && objValue === srcValue ? $hCkFK(object, path) : $ca8FL(srcValue, objValue, $2ca6dcb21d828bb2$var$COMPARE_PARTIAL_FLAG | $2ca6dcb21d828bb2$var$COMPARE_UNORDERED_FLAG);
    };
}
module.exports = $2ca6dcb21d828bb2$var$baseMatchesProperty;

});
parcelRegister("fe1Wm", function(module, exports) {

var $7khqM = parcelRequire("7khqM");
/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */ function $b159ab20ff56cd31$var$get(object, path, defaultValue) {
    var result = object == null ? undefined : $7khqM(object, path);
    return result === undefined ? defaultValue : result;
}
module.exports = $b159ab20ff56cd31$var$get;

});
parcelRegister("7khqM", function(module, exports) {

var $33EWK = parcelRequire("33EWK");

var $WbaOC = parcelRequire("WbaOC");
/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */ function $5557ec177d5378fb$var$baseGet(object, path) {
    path = $33EWK(path, object);
    var index = 0, length = path.length;
    while(object != null && index < length)object = object[$WbaOC(path[index++])];
    return index && index == length ? object : undefined;
}
module.exports = $5557ec177d5378fb$var$baseGet;

});


parcelRegister("hCkFK", function(module, exports) {

var $9Ulc4 = parcelRequire("9Ulc4");

var $1nYFI = parcelRequire("1nYFI");
/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */ function $cd3605666d66c3fb$var$hasIn(object, path) {
    return object != null && $1nYFI(object, path, $9Ulc4);
}
module.exports = $cd3605666d66c3fb$var$hasIn;

});
parcelRegister("9Ulc4", function(module, exports) {
/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */ function $7369c8a0346a73dc$var$baseHasIn(object, key) {
    return object != null && key in Object(object);
}
module.exports = $7369c8a0346a73dc$var$baseHasIn;

});

parcelRegister("1nYFI", function(module, exports) {

var $33EWK = parcelRequire("33EWK");

var $bB85C = parcelRequire("bB85C");

var $4vMNO = parcelRequire("4vMNO");

var $kgLdF = parcelRequire("kgLdF");

var $1NwxS = parcelRequire("1NwxS");

var $WbaOC = parcelRequire("WbaOC");
/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */ function $102700946ffbe2b3$var$hasPath(object, path, hasFunc) {
    path = $33EWK(path, object);
    var index = -1, length = path.length, result = false;
    while(++index < length){
        var key = $WbaOC(path[index]);
        if (!(result = object != null && hasFunc(object, key))) break;
        object = object[key];
    }
    if (result || ++index != length) return result;
    length = object == null ? 0 : object.length;
    return !!length && $1NwxS(length) && $kgLdF(key, length) && ($4vMNO(object) || $bB85C(object));
}
module.exports = $102700946ffbe2b3$var$hasPath;

});



parcelRegister("4XdzH", function(module, exports) {
/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */ function $39b733c8f22468c0$var$identity(value) {
    return value;
}
module.exports = $39b733c8f22468c0$var$identity;

});

parcelRegister("llxyP", function(module, exports) {

var $ctAP5 = parcelRequire("ctAP5");

var $dvjkq = parcelRequire("dvjkq");

var $agaje = parcelRequire("agaje");

var $WbaOC = parcelRequire("WbaOC");
/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */ function $f8a5979d7e51b6a2$var$property(path) {
    return $agaje(path) ? $ctAP5($WbaOC(path)) : $dvjkq(path);
}
module.exports = $f8a5979d7e51b6a2$var$property;

});
parcelRegister("ctAP5", function(module, exports) {
/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ function $9154c1b8898a4a95$var$baseProperty(key) {
    return function(object) {
        return object == null ? undefined : object[key];
    };
}
module.exports = $9154c1b8898a4a95$var$baseProperty;

});

parcelRegister("dvjkq", function(module, exports) {

var $7khqM = parcelRequire("7khqM");
/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ function $9d4d29d60f770ac8$var$basePropertyDeep(path) {
    return function(object) {
        return $7khqM(object, path);
    };
}
module.exports = $9d4d29d60f770ac8$var$basePropertyDeep;

});



parcelRegister("ll6bk", function(module, exports) {

var $d7fGq = parcelRequire("d7fGq");
/**
 * Converts `value` to an integer.
 *
 * **Note:** This method is loosely based on
 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted integer.
 * @example
 *
 * _.toInteger(3.2);
 * // => 3
 *
 * _.toInteger(Number.MIN_VALUE);
 * // => 0
 *
 * _.toInteger(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toInteger('3.2');
 * // => 3
 */ function $f8905ab289a7a2b1$var$toInteger(value) {
    var result = $d7fGq(value), remainder = result % 1;
    return result === result ? remainder ? result - remainder : result : 0;
}
module.exports = $f8905ab289a7a2b1$var$toInteger;

});
parcelRegister("d7fGq", function(module, exports) {

var $bSUt0 = parcelRequire("bSUt0");
/** Used as references for various `Number` constants. */ var $98c818320fa2d95c$var$INFINITY = 1 / 0, $98c818320fa2d95c$var$MAX_INTEGER = 1.7976931348623157e+308;
/**
 * Converts `value` to a finite number.
 *
 * @static
 * @memberOf _
 * @since 4.12.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted number.
 * @example
 *
 * _.toFinite(3.2);
 * // => 3.2
 *
 * _.toFinite(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toFinite(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toFinite('3.2');
 * // => 3.2
 */ function $98c818320fa2d95c$var$toFinite(value) {
    if (!value) return value === 0 ? value : 0;
    value = $bSUt0(value);
    if (value === $98c818320fa2d95c$var$INFINITY || value === -$98c818320fa2d95c$var$INFINITY) {
        var sign = value < 0 ? -1 : 1;
        return sign * $98c818320fa2d95c$var$MAX_INTEGER;
    }
    return value === value ? value : 0;
}
module.exports = $98c818320fa2d95c$var$toFinite;

});
parcelRegister("bSUt0", function(module, exports) {

var $2UuW5 = parcelRequire("2UuW5");

var $lIhLB = parcelRequire("lIhLB");

var $3sIvm = parcelRequire("3sIvm");
/** Used as references for various `Number` constants. */ var $8a7089fbe4706c31$var$NAN = 0 / 0;
/** Used to detect bad signed hexadecimal string values. */ var $8a7089fbe4706c31$var$reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
/** Used to detect binary string values. */ var $8a7089fbe4706c31$var$reIsBinary = /^0b[01]+$/i;
/** Used to detect octal string values. */ var $8a7089fbe4706c31$var$reIsOctal = /^0o[0-7]+$/i;
/** Built-in method references without a dependency on `root`. */ var $8a7089fbe4706c31$var$freeParseInt = parseInt;
/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */ function $8a7089fbe4706c31$var$toNumber(value) {
    if (typeof value == 'number') return value;
    if ($3sIvm(value)) return $8a7089fbe4706c31$var$NAN;
    if ($lIhLB(value)) {
        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
        value = $lIhLB(other) ? other + '' : other;
    }
    if (typeof value != 'string') return value === 0 ? value : +value;
    value = $2UuW5(value);
    var isBinary = $8a7089fbe4706c31$var$reIsBinary.test(value);
    return isBinary || $8a7089fbe4706c31$var$reIsOctal.test(value) ? $8a7089fbe4706c31$var$freeParseInt(value.slice(2), isBinary ? 2 : 8) : $8a7089fbe4706c31$var$reIsBadHex.test(value) ? $8a7089fbe4706c31$var$NAN : +value;
}
module.exports = $8a7089fbe4706c31$var$toNumber;

});
parcelRegister("2UuW5", function(module, exports) {

var $joR0V = parcelRequire("joR0V");
/** Used to match leading whitespace. */ var $21e8cef54ead7066$var$reTrimStart = /^\s+/;
/**
 * The base implementation of `_.trim`.
 *
 * @private
 * @param {string} string The string to trim.
 * @returns {string} Returns the trimmed string.
 */ function $21e8cef54ead7066$var$baseTrim(string) {
    return string ? string.slice(0, $joR0V(string) + 1).replace($21e8cef54ead7066$var$reTrimStart, '') : string;
}
module.exports = $21e8cef54ead7066$var$baseTrim;

});
parcelRegister("joR0V", function(module, exports) {
/** Used to match a single whitespace character. */ var $e1f961ac832bfec6$var$reWhitespace = /\s/;
/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
 * character of `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the index of the last non-whitespace character.
 */ function $e1f961ac832bfec6$var$trimmedEndIndex(string) {
    var index = string.length;
    while(index-- && $e1f961ac832bfec6$var$reWhitespace.test(string.charAt(index)));
    return index;
}
module.exports = $e1f961ac832bfec6$var$trimmedEndIndex;

});





parcelRegister("eRJCC", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => (parcelRequire("9LgmS")).default);
$parcel$export(module.exports, "Icon", () => (parcelRequire("9LgmS")).Icon);

var $9LgmS = parcelRequire("9LgmS");

});
parcelRegister("9LgmS", function(module, exports) {
$parcel$export(module.exports, "Icon", () => $71b5332a95a4c42e$export$f04a61298a47a40f);
$parcel$export(module.exports, "default", () => $71b5332a95a4c42e$export$2e2bcd8739ae039);
/* icon-new.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");
/**
 * We are hiding this props from consumers as it's reserved
 * for use by Icon Tile.
 */ var $71b5332a95a4c42e$var$svgStyles = null;
var $71b5332a95a4c42e$var$iconStyles = null;
var $71b5332a95a4c42e$var$smallIconStyles = null;
var $71b5332a95a4c42e$var$scaleStyles = null;
/**
 * For windows high contrast mode
 */ var $71b5332a95a4c42e$var$baseHcmStyles = null;
var $71b5332a95a4c42e$var$scaleSize = null;
var $71b5332a95a4c42e$var$coreSizeMedium = {
    none: "_1bsbpxbi _4t3ipxbi",
    compact: "_1bsb1ejb _4t3i1ejb",
    spacious: "_1bsb1ejb _4t3i1ejb"
};
var $71b5332a95a4c42e$var$coreSizeSmall = {
    none: "_1bsbutpp _4t3iutpp",
    compact: "_1bsbpxbi _4t3ipxbi",
    spacious: "_1bsb1ejb _4t3i1ejb"
};
var $71b5332a95a4c42e$var$paddingMap = {
    medium: {
        none: 0,
        compact: 4,
        spacious: 4
    },
    small: {
        none: 0,
        compact: 2.66,
        spacious: 8
    }
};
var $71b5332a95a4c42e$export$f04a61298a47a40f = /*#__PURE__*/ (0, $5FkrB.memo)(function Icon(props) {
    var _ref = props, _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, testId = _ref.testId, label = _ref.label, dangerouslySetGlyph = _ref.dangerouslySetGlyph, shouldScale = _ref.shouldScale, _ref$spacing = _ref.spacing, spacing = _ref$spacing === void 0 ? 'none' : _ref$spacing, name = _ref.name;
    var dangerouslySetInnerHTML = dangerouslySetGlyph ? {
        __html: dangerouslySetGlyph
    } : undefined;
    var size = 'medium';
    if ('size' in props && props.size !== undefined) {
        if (typeof props.size === 'string') size = props.size === 'small' || props.size === 'medium' ? props.size : size;
        else if (name) {
            var newSize = props.size(name);
            size = newSize === 'small' || newSize === 'medium' ? newSize : size;
        }
    }
    var baseSize = 16;
    var viewBoxPadding = $71b5332a95a4c42e$var$paddingMap[size][spacing];
    var viewBoxSize = baseSize + 2 * viewBoxPadding;
    return /*#__PURE__*/ $5FkrB.createElement("span", {
        "data-testid": testId,
        role: label ? 'img' : undefined,
        "aria-label": label ? label : undefined,
        "aria-hidden": label ? undefined : true,
        style: {
            color: color
        },
        className: (0, $970q7.default)([
            "_1e0c1o8l _vchhusvi _1o9zidpf _vwz4kb7n _y4ti1igz _bozg1mb9",
            "_12va1onz _jcxd1r8n",
            shouldScale && "_1bsb1kw7 _4t3i1kw7",
            size === 'small' && "_vwz4utpp"
        ])
    }, /*#__PURE__*/ $5FkrB.createElement("svg", {
        fill: "none",
        viewBox: "".concat(0 - viewBoxPadding, " ").concat(0 - viewBoxPadding, " ").concat(viewBoxSize, " ").concat(viewBoxSize),
        role: "presentation",
        dangerouslySetInnerHTML: dangerouslySetInnerHTML,
        className: (0, $970q7.default)([
            "_1reo15vq _18m915vq _syaz1r31 _lcxvglyw _s7n4yfq0 _vc881r31",
            shouldScale ? "_1bsb1kw7 _4t3i1kw7" : size === 'small' ? $71b5332a95a4c42e$var$coreSizeSmall[spacing] : $71b5332a95a4c42e$var$coreSizeMedium[spacing]
        ])
    }));
});
var $71b5332a95a4c42e$export$2e2bcd8739ae039 = $71b5332a95a4c42e$export$f04a61298a47a40f;

});


parcelRegister("6Qk7v", function(module, exports) {
$parcel$export(module.exports, "default", () => $4fb734d833f2f5f7$export$2e2bcd8739ae039);

var $3NKAv = parcelRequire("3NKAv");
parcelRequire("kqp0i");

parcelRequire("ckRFu");
parcelRequire("5qnXH");
parcelRequire("eP8dQ");
parcelRequire("5FkrB");
parcelRequire("7t6hN");
var $4fb734d833f2f5f7$var$tags = [
    'a',
    'abbr',
    'address',
    'area',
    'article',
    'aside',
    'audio',
    'b',
    'base',
    'bdi',
    'bdo',
    'big',
    'blockquote',
    'body',
    'br',
    'button',
    'canvas',
    'caption',
    'cite',
    'code',
    'col',
    'colgroup',
    'data',
    'datalist',
    'dd',
    'del',
    'details',
    'dfn',
    'dialog',
    'div',
    'dl',
    'dt',
    'em',
    'embed',
    'fieldset',
    'figcaption',
    'figure',
    'footer',
    'form',
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'h6',
    'head',
    'header',
    'hgroup',
    'hr',
    'html',
    'i',
    'iframe',
    'img',
    'input',
    'ins',
    'kbd',
    'keygen',
    'label',
    'legend',
    'li',
    'link',
    'main',
    'map',
    'mark',
    'marquee',
    'menu',
    'menuitem',
    'meta',
    'meter',
    'nav',
    'noscript',
    'object',
    'ol',
    'optgroup',
    'option',
    'output',
    'p',
    'param',
    'picture',
    'pre',
    'progress',
    'q',
    'rp',
    'rt',
    'ruby',
    's',
    'samp',
    'script',
    'section',
    'select',
    'small',
    'source',
    'span',
    'strong',
    'style',
    'sub',
    'summary',
    'sup',
    'table',
    'tbody',
    'td',
    'textarea',
    'tfoot',
    'th',
    'thead',
    'time',
    'title',
    'tr',
    'track',
    'u',
    'ul',
    'var',
    'video',
    'wbr',
    'circle',
    'clipPath',
    'defs',
    'ellipse',
    'foreignObject',
    'g',
    'image',
    'line',
    'linearGradient',
    'mask',
    'path',
    'pattern',
    'polygon',
    'polyline',
    'radialGradient',
    'rect',
    'stop',
    'svg',
    'text',
    'tspan'
];
// bind it to avoid mutating the original function
var $4fb734d833f2f5f7$export$2e2bcd8739ae039 = (0, $3NKAv.default).bind(null);
$4fb734d833f2f5f7$var$tags.forEach(function(tagName) {
    $4fb734d833f2f5f7$export$2e2bcd8739ae039[tagName] = $4fb734d833f2f5f7$export$2e2bcd8739ae039(tagName);
});

});
parcelRegister("3NKAv", function(module, exports) {
$parcel$export(module.exports, "default", () => $2c4a161278714118$export$2e2bcd8739ae039);

var $d1G9Q = parcelRequire("d1G9Q");
parcelRequire("74Zh5");
var $rxpl9 = parcelRequire("rxpl9");

var $ckRFu = parcelRequire("ckRFu");

var $5qnXH = parcelRequire("5qnXH");

var $eP8dQ = parcelRequire("eP8dQ");

var $5FkrB = parcelRequire("5FkrB");

var $7t6hN = parcelRequire("7t6hN");
var $2c4a161278714118$var$isBrowser = typeof document !== 'undefined';
var $2c4a161278714118$var$isDevelopment = false;
var $2c4a161278714118$var$testOmitPropsOnStringTag = (0, $7t6hN.default);
var $2c4a161278714118$var$testOmitPropsOnComponent = function testOmitPropsOnComponent(key) {
    return key !== 'theme';
};
var $2c4a161278714118$var$getDefaultShouldForwardProp = function getDefaultShouldForwardProp(tag) {
    return typeof tag === 'string' && // 96 is one less than the char code
    // for "a" so this is checking that
    // it's a lowercase character
    tag.charCodeAt(0) > 96 ? $2c4a161278714118$var$testOmitPropsOnStringTag : $2c4a161278714118$var$testOmitPropsOnComponent;
};
var $2c4a161278714118$var$composeShouldForwardProps = function composeShouldForwardProps(tag, options, isReal) {
    var shouldForwardProp;
    if (options) {
        var optionsShouldForwardProp = options.shouldForwardProp;
        shouldForwardProp = tag.__emotion_forwardProp && optionsShouldForwardProp ? function(propName) {
            return tag.__emotion_forwardProp(propName) && optionsShouldForwardProp(propName);
        } : optionsShouldForwardProp;
    }
    if (typeof shouldForwardProp !== 'function' && isReal) shouldForwardProp = tag.__emotion_forwardProp;
    return shouldForwardProp;
};
var $2c4a161278714118$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serialized = _ref.serialized, isStringTag = _ref.isStringTag;
    (0, $eP8dQ.registerStyles)(cache, serialized, isStringTag);
    var rules = (0, $5qnXH.useInsertionEffectAlwaysWithSyncFallback)(function() {
        return (0, $eP8dQ.insertStyles)(cache, serialized, isStringTag);
    });
    if (!$2c4a161278714118$var$isBrowser && rules !== undefined) {
        var _ref2;
        var serializedNames = serialized.name;
        var next = serialized.next;
        while(next !== undefined){
            serializedNames += ' ' + next.name;
            next = next.next;
        }
        return /*#__PURE__*/ $5FkrB.createElement("style", (_ref2 = {}, _ref2["data-emotion"] = cache.key + " " + serializedNames, _ref2.dangerouslySetInnerHTML = {
            __html: rules
        }, _ref2.nonce = cache.sheet.nonce, _ref2));
    }
    return null;
};
var $2c4a161278714118$export$2e2bcd8739ae039 = function createStyled(tag, options) {
    var isReal = tag.__emotion_real === tag;
    var baseTag = isReal && tag.__emotion_base || tag;
    var identifierName;
    var targetClassName;
    if (options !== undefined) {
        identifierName = options.label;
        targetClassName = options.target;
    }
    var shouldForwardProp = $2c4a161278714118$var$composeShouldForwardProps(tag, options, isReal);
    var defaultShouldForwardProp = shouldForwardProp || $2c4a161278714118$var$getDefaultShouldForwardProp(baseTag);
    var shouldUseAs = !defaultShouldForwardProp('as');
    return function() {
        // eslint-disable-next-line prefer-rest-params
        var args = arguments;
        var styles = isReal && tag.__emotion_styles !== undefined ? tag.__emotion_styles.slice(0) : [];
        if (identifierName !== undefined) styles.push("label:" + identifierName + ";");
        if (args[0] == null || args[0].raw === undefined) // eslint-disable-next-line prefer-spread
        styles.push.apply(styles, args);
        else {
            var templateStringsArr = args[0];
            styles.push(templateStringsArr[0]);
            var len = args.length;
            var i = 1;
            for(; i < len; i++)styles.push(args[i], templateStringsArr[i]);
        }
        var Styled = (0, $rxpl9.w)(function(props, cache, ref) {
            var FinalTag = shouldUseAs && props.as || baseTag;
            var className = '';
            var classInterpolations = [];
            var mergedProps = props;
            if (props.theme == null) {
                mergedProps = {};
                for(var key in props)mergedProps[key] = props[key];
                mergedProps.theme = $5FkrB.useContext((0, $rxpl9.T));
            }
            if (typeof props.className === 'string') className = (0, $eP8dQ.getRegisteredStyles)(cache.registered, classInterpolations, props.className);
            else if (props.className != null) className = props.className + " ";
            var serialized = (0, $ckRFu.serializeStyles)(styles.concat(classInterpolations), cache.registered, mergedProps);
            className += cache.key + "-" + serialized.name;
            if (targetClassName !== undefined) className += " " + targetClassName;
            var finalShouldForwardProp = shouldUseAs && shouldForwardProp === undefined ? $2c4a161278714118$var$getDefaultShouldForwardProp(FinalTag) : defaultShouldForwardProp;
            var newProps = {};
            for(var _key in props){
                if (shouldUseAs && _key === 'as') continue;
                if (finalShouldForwardProp(_key)) newProps[_key] = props[_key];
            }
            newProps.className = className;
            if (ref) newProps.ref = ref;
            return /*#__PURE__*/ $5FkrB.createElement($5FkrB.Fragment, null, /*#__PURE__*/ $5FkrB.createElement($2c4a161278714118$var$Insertion, {
                cache: cache,
                serialized: serialized,
                isStringTag: typeof FinalTag === 'string'
            }), /*#__PURE__*/ $5FkrB.createElement(FinalTag, newProps));
        });
        Styled.displayName = identifierName !== undefined ? identifierName : "Styled(" + (typeof baseTag === 'string' ? baseTag : baseTag.displayName || baseTag.name || 'Component') + ")";
        Styled.defaultProps = tag.defaultProps;
        Styled.__emotion_real = Styled;
        Styled.__emotion_base = baseTag;
        Styled.__emotion_styles = styles;
        Styled.__emotion_forwardProp = shouldForwardProp;
        Object.defineProperty(Styled, 'toString', {
            value: function value() {
                if (targetClassName === undefined && $2c4a161278714118$var$isDevelopment) return 'NO_COMPONENT_SELECTOR';
                return "." + targetClassName;
            }
        });
        Styled.withComponent = function(nextTag, nextOptions) {
            var newStyled = createStyled(nextTag, (0, $d1G9Q.default)({}, options, nextOptions, {
                shouldForwardProp: $2c4a161278714118$var$composeShouldForwardProps(Styled, nextOptions, true)
            }));
            return newStyled.apply(void 0, styles);
        };
        return Styled;
    };
};

});
parcelRegister("7t6hN", function(module, exports) {
$parcel$export(module.exports, "default", () => $57001e228c890016$export$2e2bcd8739ae039);

var $7VhhO = parcelRequire("7VhhO");
// eslint-disable-next-line no-undef
var $57001e228c890016$var$reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|disableRemotePlayback|download|draggable|encType|enterKeyHint|fetchpriority|fetchPriority|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|popover|popoverTarget|popoverTargetAction|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23
var $57001e228c890016$export$2e2bcd8739ae039 = /* #__PURE__ */ (0, $7VhhO.default)(function(prop) {
    return $57001e228c890016$var$reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111 && prop.charCodeAt(1) === 110 && prop.charCodeAt(2) < 91;
});

});



parcelRegister("KItDh", function(module, exports) {
$parcel$export(module.exports, "isIsolatedCloud", () => $08c6cc2ffac0d9dc$export$9186ccba8effc5de);
$parcel$export(module.exports, "isFedrampModerate", () => $08c6cc2ffac0d9dc$export$104cb891a6e90b3a);

var $lkh54 = parcelRequire("lkh54");

var $kN4Zn = parcelRequire("kN4Zn");
function $08c6cc2ffac0d9dc$export$9186ccba8effc5de() {
    if (typeof document === 'undefined') // @ts-ignore
    return globalThis.ssrContext.isInIC;
    var atlCtxCookieValues = (0, $kN4Zn.parseAtlCtxCookies)();
    if (!atlCtxCookieValues) // If the cookies are not set, the current perimeter is non-isolated commercial
    return false;
    // The icDomain check is needed for when federal perimeters are eventually added to Isolated Cloud as well
    return (0, $lkh54.ISOLATED_CLOUD_PERIMETERS).includes(atlCtxCookieValues.perimeter) && atlCtxCookieValues.icDomain !== undefined;
}
function $08c6cc2ffac0d9dc$export$104cb891a6e90b3a() {
    if (typeof document === 'undefined') // @ts-ignore
    return globalThis.ssrContext.isInFedramp;
    var atlCtxCookieValues = (0, $kN4Zn.parseAtlCtxCookies)();
    if (!atlCtxCookieValues) // If the cookies are not set, the current perimeter is non-isolated commercial
    return false;
    return atlCtxCookieValues.perimeter === (0, $lkh54.FEDRAMP_MODERATE);
}
function $08c6cc2ffac0d9dc$export$80638ee198476daf() {
    if (typeof document === 'undefined') return globalThis.location.hostname;
    var atlCtxCookieValues = (0, $kN4Zn.parseAtlCtxCookies)();
    return atlCtxCookieValues === null || atlCtxCookieValues === void 0 ? void 0 : atlCtxCookieValues.icDomain;
}
function $08c6cc2ffac0d9dc$export$839b022803d38d4d() {
    if (typeof document === 'undefined') // @ts-ignore
    return $08c6cc2ffac0d9dc$export$9186ccba8effc5de() ? globalThis.ssrContext.icName : undefined;
    var atlCtxCookieValues = (0, $kN4Zn.parseAtlCtxCookies)();
    return atlCtxCookieValues === null || atlCtxCookieValues === void 0 ? void 0 : atlCtxCookieValues.icId;
}
function $08c6cc2ffac0d9dc$export$9e04105551ffc5c4() {
    if (typeof document === 'undefined') return $08c6cc2ffac0d9dc$var$cloudEnvironmentSsrLookup();
    return $08c6cc2ffac0d9dc$var$cloudEnvironmentCookieLookup();
}
function $08c6cc2ffac0d9dc$var$cloudEnvironmentSsrLookup() {
    // @ts-ignore
    if (globalThis.ssrContext.isInIC === true) return {
        type: 'isolated-cloud',
        perimeter: (0, $lkh54.COMMERCIAL)
    };
    // @ts-ignore
    if (globalThis.ssrContext.isInFedramp === true) return {
        type: 'non-isolated-cloud',
        perimeter: (0, $lkh54.FEDRAMP_MODERATE)
    };
    return {
        type: 'non-isolated-cloud',
        perimeter: (0, $lkh54.COMMERCIAL)
    };
}
function $08c6cc2ffac0d9dc$var$cloudEnvironmentCookieLookup() {
    // Avoid calling isFedrampModerate() and isIsolatedCloud() here to avoid repeated cookie parsing
    var atlCtxCookieValues = (0, $kN4Zn.parseAtlCtxCookies)();
    if (!atlCtxCookieValues) // If the cookies are not set, the current perimeter is non-isolated commercial
    return {
        type: 'non-isolated-cloud',
        perimeter: (0, $lkh54.COMMERCIAL)
    };
    var isIc = (0, $lkh54.ISOLATED_CLOUD_PERIMETERS).includes(atlCtxCookieValues.perimeter) && atlCtxCookieValues.icDomain !== undefined;
    if (isIc) return {
        type: 'isolated-cloud',
        perimeter: (0, $lkh54.COMMERCIAL)
    };
    if (atlCtxCookieValues.perimeter === (0, $lkh54.FEDRAMP_MODERATE)) return {
        type: 'non-isolated-cloud',
        perimeter: (0, $lkh54.FEDRAMP_MODERATE)
    };
    // If a new cloud environment has been created but not added to this library, return undefined
    return undefined;
}

});
parcelRegister("lkh54", function(module, exports) {
$parcel$export(module.exports, "FEDRAMP_MODERATE", () => $f868b71fb379c306$export$ce553301d55c2fd8);
$parcel$export(module.exports, "COMMERCIAL", () => $f868b71fb379c306$export$f005e2e9f707cb5f);
$parcel$export(module.exports, "ISOLATED_CLOUD_PERIMETERS", () => $f868b71fb379c306$export$d8347b4aae768c2d);
$parcel$export(module.exports, "ATL_CTX_PERIMETER", () => $f868b71fb379c306$export$87285944378c596);
$parcel$export(module.exports, "ATL_CTX_ISOLATION_CONTEXT_DOMAIN", () => $f868b71fb379c306$export$715603e81922c3ec);
$parcel$export(module.exports, "ATL_CTX_ISOLATION_CONTEXT_ID", () => $f868b71fb379c306$export$a0ffa0598c95dfb7);
var $f868b71fb379c306$export$ce553301d55c2fd8 = 'fedramp-moderate';
var $f868b71fb379c306$export$f005e2e9f707cb5f = 'commercial';
var $f868b71fb379c306$export$a739cd5aac835909 = 'staging';
var $f868b71fb379c306$export$42dd0cdd351a4a9 = 'prod';
var $f868b71fb379c306$export$404582bc18fe4d9e = 'dev';
var $f868b71fb379c306$export$d8347b4aae768c2d = [
    $f868b71fb379c306$export$f005e2e9f707cb5f
];
var $f868b71fb379c306$export$b1b1ccc8f3e7f954 = [
    $f868b71fb379c306$export$f005e2e9f707cb5f,
    $f868b71fb379c306$export$ce553301d55c2fd8
];
var $f868b71fb379c306$export$87285944378c596 = 'Atl-Ctx-Perimeter';
var $f868b71fb379c306$export$715603e81922c3ec = 'Atl-Ctx-Isolation-Context-Domain';
var $f868b71fb379c306$export$a0ffa0598c95dfb7 = 'Atl-Ctx-Isolation-Context-Id';

});

parcelRegister("kN4Zn", function(module, exports) {
$parcel$export(module.exports, "parseAtlCtxCookies", () => $f22c40ef15d7672e$export$3fa7b7af96286cc9);

var $iYJcE = parcelRequire("iYJcE");

var $lkh54 = parcelRequire("lkh54");
function $f22c40ef15d7672e$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $f22c40ef15d7672e$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $f22c40ef15d7672e$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $f22c40ef15d7672e$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $f22c40ef15d7672e$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $f22c40ef15d7672e$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
/**
 * Internal helper function used to parse cookie values and extract value of provided cookie name
 * @param {AtlCtxCookieName} cookieName - The name of the cookie to extract
 * @param {string} cookieString - The full cookie string
 * @returns {string | undefined} - The cookie value if present, undefined otherwise
 */ function $f22c40ef15d7672e$var$getRawCookieValue(cookieName, cookieString) {
    if (!cookieString) return undefined;
    var cookies = cookieString.split(';');
    var _iterator = $f22c40ef15d7672e$var$_createForOfIteratorHelper(cookies), _step;
    try {
        for(_iterator.s(); !(_step = _iterator.n()).done;){
            var cookie = _step.value;
            var _cookie$trim$split = cookie.trim().split('='), _cookie$trim$split2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_cookie$trim$split, 2), name = _cookie$trim$split2[0], value = _cookie$trim$split2[1];
            if (name === cookieName) return value;
        }
    } catch (err) {
        _iterator.e(err);
    } finally{
        _iterator.f();
    }
    return undefined;
}
function $f22c40ef15d7672e$export$3fa7b7af96286cc9() {
    var global = globalThis;
    try {
        // HOT-118791: the code below doesn't work on the server, and creates log spam in the catch block - "Cannot read properties of undefined (reading 'cookie')"
        if (typeof globalThis.document === 'undefined') return undefined;
        var cookies = global.document.cookie;
        var perimeter = $f22c40ef15d7672e$var$getRawCookieValue((0, $lkh54.ATL_CTX_PERIMETER), cookies);
        if (!perimeter) // Indicative of non-isolated commercial perimeter
        return undefined;
        var icDomain = $f22c40ef15d7672e$var$getRawCookieValue((0, $lkh54.ATL_CTX_ISOLATION_CONTEXT_DOMAIN), cookies);
        var icId = $f22c40ef15d7672e$var$getRawCookieValue((0, $lkh54.ATL_CTX_ISOLATION_CONTEXT_ID), cookies);
        // The IC Domain and IC Id cookie values are empty strings for non Isolated Cloud
        var emptyIcDomain = !icDomain || icDomain.length === 0;
        var emptyIcId = !icId || icId.length === 0;
        return {
            perimeter: perimeter,
            icDomain: emptyIcDomain ? undefined : icDomain,
            icId: emptyIcId ? undefined : icId
        };
    } catch (e) {
        console.warn('Failed to parse atl-ctx cookies:', e);
        return undefined;
    }
}

});


parcelRegister("6fyuV", function(module, exports) {
$parcel$export(module.exports, "default", () => $48cee75820d7c027$export$2e2bcd8739ae039);
/* text-field.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $kqp0i = parcelRequire("kqp0i");

var $ekGgq = parcelRequire("ekGgq");

var $25nEq = parcelRequire("25nEq");

var $1Vcia = parcelRequire("1Vcia");

var $970q7 = parcelRequire("970q7");

var $5FkrB = parcelRequire("5FkrB");

var $a3tZx = parcelRequire("a3tZx");
var $48cee75820d7c027$var$_excluded = [
    "appearance",
    "className",
    "elemAfterInput",
    "elemBeforeInput",
    "isCompact",
    "isDisabled",
    "isInvalid",
    "isMonospaced",
    "isReadOnly",
    "isRequired",
    "name",
    "onBlur",
    "onChange",
    "onFocus",
    "onMouseDown",
    "placeholder",
    "testId",
    "width"
];
function $48cee75820d7c027$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $48cee75820d7c027$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $48cee75820d7c027$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $48cee75820d7c027$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $48cee75820d7c027$var$containerMedia = {
    invalid: "_msj6gir2",
    disabled: "_6up518qt"
};
var $48cee75820d7c027$var$inputMediaDisabled = null;
var $48cee75820d7c027$var$analyticsParams = {
    componentName: 'textField',
    packageName: "@atlaskit/textfield",
    packageVersion: "8.0.15"
};
var $48cee75820d7c027$var$disabledStyle = {
    standard: "_1h6dby5v _bfhkby5v _syaz1gmx _80om13gf",
    subtle: "_1h6d1j28 _bfhk1j28 _syaz1gmx _80om13gf",
    none: "_1h6d1j28 _bfhk1j28 _syaz1gmx _80om13gf"
};
var $48cee75820d7c027$var$invalidStyle = null;
var $48cee75820d7c027$var$focusWithinStyle = {
    standard: "_1p9x1v1w _qao9r01l _q433vyy1",
    subtle: "_1p9x1v1w _qao9r01l _q433vyy1",
    none: "_1p9x1j28 _qao91j28 _q4333sij"
};
var $48cee75820d7c027$var$hoverStyle = {
    standard: "_4cvxrsbi _irr3l4ek",
    subtle: "_4cvxrsbi _irr3l4ek",
    none: "_4cvx1j28 _irr31j28"
};
var $48cee75820d7c027$var$getContainerTextBgAndBorderColor = {
    standard: "_1h6drsbi _1dqonqa1 _syazi7uo _80om1kdv _bfhk1j9a _msj6gir2",
    subtle: "_1h6d1j28 _1dqonqa1 _syazi7uo _80om1kdv _16hg1j28 _msj6gir2",
    none: "_1h6d1j28 _1dqoglyw _syazi7uo _80om1kdv _16hg1j28 _msj6gir2"
};
var $48cee75820d7c027$var$widthMap = {
    xsmall: 80,
    small: 160,
    medium: 240,
    large: 320,
    xlarge: 480
};
var $48cee75820d7c027$var$getMaxWidth = function getMaxWidth(width) {
    return !width ? "100%" : width in $48cee75820d7c027$var$widthMap ? "".concat($48cee75820d7c027$var$widthMap[width], "px") : "".concat(+width, "px");
};
var $48cee75820d7c027$var$containerStyleAppearance = {
    standard: "_1dqonqa1 _1q51e4h9 _85i5e4h9 _bozgidpf _y4tiidpf",
    subtle: "_1dqonqa1 _1q51e4h9 _85i5e4h9 _bozgidpf _y4tiidpf",
    none: "_1dqoglyw"
};
var $48cee75820d7c027$var$containerStyles = null;
var $48cee75820d7c027$var$inputDisabledStyle = null;
var $48cee75820d7c027$var$inputCompactStyle = null;
var $48cee75820d7c027$var$inputMonospacedStyle = null;
// iOS Safari automatically zooms into form inputs on focus when the font size is less than 16px.
// To prevent this zoom behaviour on mobile devices, the textfield uses font.body.large (16px) by default,
// then switches to the smaller font.body on screens wider than 30rem (desktop).
// @see: https://medium.com/@rares.popescu/2-ways-to-avoid-the-automatic-zoom-in-on-input-fields-8a71479e542e
var $48cee75820d7c027$var$inputStyle = null;
/**
 * __Textfield__
 *
 * A text field is an input that allows a user to write or edit text.
 *
 * - [Examples](https://atlassian.design/components/textfield/examples)
 * - [Code](https://atlassian.design/components/textfield/code)
 * - [Usage](https://atlassian.design/components/textfield/usage)
 */ var $48cee75820d7c027$var$Textfield = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function(props, ref) {
    var _props$appearance = props.appearance, appearance = _props$appearance === void 0 ? 'standard' : _props$appearance, className = props.className, elemAfterInput = props.elemAfterInput, elemBeforeInput = props.elemBeforeInput, _props$isCompact = props.isCompact, isCompact = _props$isCompact === void 0 ? false : _props$isCompact, _props$isDisabled = props.isDisabled, isDisabled = _props$isDisabled === void 0 ? false : _props$isDisabled, _props$isInvalid = props.isInvalid, isInvalid = _props$isInvalid === void 0 ? false : _props$isInvalid, _props$isMonospaced = props.isMonospaced, isMonospaced = _props$isMonospaced === void 0 ? false : _props$isMonospaced, _props$isReadOnly = props.isReadOnly, isReadOnly = _props$isReadOnly === void 0 ? false : _props$isReadOnly, _props$isRequired = props.isRequired, isRequired = _props$isRequired === void 0 ? false : _props$isRequired, name = props.name, onBlur = props.onBlur, onChange = props.onChange, onFocus = props.onFocus, onMouseDown = props.onMouseDown, placeholder = props.placeholder, testId = props.testId, width = props.width, spreadProps = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(props, $48cee75820d7c027$var$_excluded);
    var inputRef = (0, $5FkrB.useRef)(null);
    var handleOnFocus = (0, $a3tZx.usePlatformLeafEventHandler)($48cee75820d7c027$var$_objectSpread({
        fn: function fn(event) {
            onFocus && onFocus(event);
        },
        action: 'focused'
    }, $48cee75820d7c027$var$analyticsParams));
    var handleOnBlur = (0, $a3tZx.usePlatformLeafEventHandler)($48cee75820d7c027$var$_objectSpread({
        fn: function fn(event) {
            onBlur && onBlur(event);
        },
        action: 'blurred'
    }, $48cee75820d7c027$var$analyticsParams));
    var handleOnMouseDown = (0, $5FkrB.useCallback)(function(event) {
        // Running e.preventDefault() on the INPUT prevents double click behaviour
        // Sadly we needed this cast as the target type is being correctly set
        var target = event.target;
        if (target.tagName !== 'INPUT') event.preventDefault();
        if (inputRef && inputRef.current && !isDisabled && document.activeElement !== inputRef.current) inputRef.current.focus();
        onMouseDown && onMouseDown(event);
    }, [
        onMouseDown,
        isDisabled
    ]);
    var setInputRef = (0, $5FkrB.useCallback)(function(inputElement) {
        inputRef.current = inputElement;
        if (!ref) return;
        if ((0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(ref) === 'object') ref.current = inputElement;
        if (typeof ref === 'function') ref(inputElement);
    }, [
        ref
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("div", {
        role: "presentation",
        "data-disabled": isDisabled ? isDisabled : undefined,
        "data-invalid": isInvalid ? isInvalid : undefined,
        "data-ds--text-field--container": true,
        "data-testid": testId && "".concat(testId, "-container"),
        onMouseDown: handleOnMouseDown,
        style: {
            maxWidth: "".concat($48cee75820d7c027$var$getMaxWidth(width))
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $970q7.default)([
            "_16jlkb7n _1o9zkb7n _i0dl1osq _11c82smr _1reo15vq _18m915vq _v564r5cv _189ee4h9 _1e0c1txw _vchhusvi _4cvr1h6o _1bah1yb4 _lcxv1wug _s7n4jp4b _slp31hna _1tnqfajl",
            $48cee75820d7c027$var$getContainerTextBgAndBorderColor[appearance],
            $48cee75820d7c027$var$containerStyleAppearance[appearance],
            !isDisabled && $48cee75820d7c027$var$focusWithinStyle[appearance],
            !isDisabled && $48cee75820d7c027$var$hoverStyle[appearance],
            isDisabled && $48cee75820d7c027$var$containerMedia.disabled,
            isDisabled && $48cee75820d7c027$var$disabledStyle[appearance],
            isInvalid && $48cee75820d7c027$var$containerMedia.invalid,
            isInvalid && "_1h6d1bqt _4cvx1bqt _16qsizbr _1dbzizbr _uk1sr01l",
            className
        ])
    }, elemBeforeInput, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("input", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, spreadProps, {
        "aria-invalid": isInvalid ? isInvalid : undefined,
        "data-compact": isCompact ? isCompact : undefined,
        "data-ds--text-field--input": true,
        "data-monospaced": isMonospaced ? isMonospaced : undefined,
        "data-testid": testId,
        disabled: isDisabled,
        name: name,
        onBlur: handleOnBlur,
        onChange: onChange,
        onFocus: handleOnFocus,
        placeholder: placeholder,
        readOnly: isReadOnly,
        ref: setInputRef,
        required: isRequired,
        className: (0, $970q7.default)([
            "_19itidpf _11c81ixg _12ji1r31 _1qu2glyw _12y31o36 _vchhusvi _1bsb1osq _1ul9idpf _bfhk1j28 _syaz1kw7 _80om1kw7 _14ji12x7 _olc612x7 _1kod12x7 _7ba012x7 _1goxglyw _13xeglyw _1n7e1l2s _1idr1rpy _1tn22smr _l9oiu2gc _549yu2gc _1h5w12x7 _124212x7",
            isMonospaced && "_ect41odn _14md1odn",
            isCompact && "_11zpv77o _1l02v77o _daj712x7 _141f12x7 _1srd1b66 _oi9h1b66 _1e3012x7 _1txv12x7",
            isDisabled && "_syaz1gmx _1idr1gmx",
            isDisabled && "_1fnx18qt"
        ])
    })), elemAfterInput);
});
var $48cee75820d7c027$export$2e2bcd8739ae039 = $48cee75820d7c027$var$Textfield;

});
parcelRegister("a3tZx", function(module, exports) {
$parcel$export(module.exports, "usePlatformLeafEventHandler", () => $752172e1950ec355$export$a4687b0234b40e28);

var $25nEq = parcelRequire("25nEq");

var $5FkrB = parcelRequire("5FkrB");

var $hkXTs = parcelRequire("hkXTs");

var $hYekS = parcelRequire("hYekS");
function $752172e1950ec355$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $752172e1950ec355$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $752172e1950ec355$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $752172e1950ec355$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $752172e1950ec355$export$a4687b0234b40e28(_ref) {
    var fn = _ref.fn, action = _ref.action, componentName = _ref.componentName, actionSubject = _ref.actionSubject, packageName = _ref.packageName, packageVersion = _ref.packageVersion, analyticsData = _ref.analyticsData;
    var _useAnalyticsEvents = (0, $hkXTs.useAnalyticsEvents)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
    // We put analyticsData and fn in a ref so that we don't need to break
    // memoization.
    // Generally these could be defined by consumers inline
    // and so we do this to avoid breaking memoization of useCallback
    var dataRef = (0, $hYekS.useTrackedRef)(analyticsData);
    var fnRef = (0, $hYekS.useTrackedRef)(fn);
    var handler = (0, $5FkrB.useCallback)(function(value) {
        var analyticsEvent = createAnalyticsEvent({
            action: action,
            actionSubject: actionSubject || componentName,
            attributes: {
                componentName: componentName,
                packageName: packageName,
                packageVersion: packageVersion
            }
        });
        // To avoid wrapping this component in AnalyticsContext we manually
        // push the parent context's meta data into the context.
        // Note: this new 'context'
        var context = $752172e1950ec355$var$_objectSpread({
            componentName: componentName,
            packageName: packageName,
            packageVersion: packageVersion
        }, dataRef.current);
        analyticsEvent.context.push(context);
        // fire an event on the atlaskit channel
        var clone = analyticsEvent.clone();
        if (clone) clone.fire('atlaskit');
        fnRef.current(value, analyticsEvent);
    }, [
        // These are strings and won't change
        action,
        componentName,
        actionSubject,
        packageName,
        packageVersion,
        // This function is memoized in the context
        createAnalyticsEvent,
        // these are a stable ref because of the useTrackedRef hook
        dataRef,
        fnRef
    ]);
    return handler;
}

});
parcelRegister("hkXTs", function(module, exports) {
$parcel$export(module.exports, "useAnalyticsEvents", () => $c9f2c388ce7b206c$export$5bf35293e545f20c);

var $dLGML = parcelRequire("dLGML");

var $aTNTo = parcelRequire("aTNTo");

var $2M6Kk = parcelRequire("2M6Kk");
function $c9f2c388ce7b206c$export$5bf35293e545f20c() {
    var analyticsContext = (0, $2M6Kk.useAnalyticsContext)();
    var createAnalyticsEvent = (0, $dLGML.useCallbackOne)(function(payload) {
        return new (0, $aTNTo.default)({
            context: analyticsContext.getAtlaskitAnalyticsContext(),
            handlers: analyticsContext.getAtlaskitAnalyticsEventHandlers(),
            payload: payload
        });
    }, [
        analyticsContext
    ]);
    return {
        createAnalyticsEvent: createAnalyticsEvent
    };
}

});
parcelRegister("aTNTo", function(module, exports) {
$parcel$export(module.exports, "default", () => $7ef5be08a0516080$export$2e2bcd8739ae039);

var $fC8ib = parcelRequire("fC8ib");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $kIXpt = parcelRequire("kIXpt");

var $cYPzS = parcelRequire("cYPzS");

var $lwlXp = parcelRequire("lwlXp");

var $eyuDe = parcelRequire("eyuDe");

var $25nEq = parcelRequire("25nEq");

var $4p0q5 = parcelRequire("4p0q5");
function $7ef5be08a0516080$var$_callSuper(t, o, e) {
    return o = (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(o), (0, (/*@__PURE__*/$parcel$interopDefault($kIXpt)))(t, $7ef5be08a0516080$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(t).constructor) : o.apply(t, e));
}
function $7ef5be08a0516080$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($7ef5be08a0516080$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $7ef5be08a0516080$var$_superPropGet(t, o, e, r) {
    var p = (0, (/*@__PURE__*/$parcel$interopDefault($lwlXp)))((0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(1 & r ? t.prototype : t), o, e);
    return 2 & r && "function" == typeof p ? function(t) {
        return p.apply(e, t);
    } : p;
}
var $7ef5be08a0516080$export$35f8383928ba8d7 = function isUIAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $7ef5be08a0516080$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isUIAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === 'UIAnalyticsEvent';
};
var $7ef5be08a0516080$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_AnalyticsEvent) {
    function UIAnalyticsEvent(props) {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, UIAnalyticsEvent);
        _this = $7ef5be08a0516080$var$_callSuper(this, UIAnalyticsEvent, [
            props
        ]);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "_isUIAnalyticsEvent", true);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "clone", function() {
            if (_this.hasFired) return null;
            var context = (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(_this.context);
            var handlers = (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(_this.handlers);
            /**
       * A hacky "deep clone" of the object. This is limited in that it wont
       * support functions, regexs, Maps, Sets, etc, but none of those need to
       * be represented in our payload.
       */ var payload = JSON.parse(JSON.stringify(_this.payload));
            return new UIAnalyticsEvent({
                context: context,
                handlers: handlers,
                payload: payload
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "fire", function(channel) {
            if (_this.hasFired) return;
            _this.handlers.forEach(function(handler) {
                return handler(_this, channel);
            });
            _this.hasFired = true;
        });
        _this.context = props.context || [];
        _this.handlers = props.handlers || [];
        _this.hasFired = false;
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($eyuDe)))(UIAnalyticsEvent, _AnalyticsEvent);
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(UIAnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (this.hasFired) return this;
                return $7ef5be08a0516080$var$_superPropGet(UIAnalyticsEvent, "update", this, 3)([
                    updater
                ]);
            }
        }
    ]);
}((0, $4p0q5.default));

});
parcelRegister("4p0q5", function(module, exports) {
$parcel$export(module.exports, "default", () => $3349d29a26f0924f$export$2e2bcd8739ae039);

var $ekGgq = parcelRequire("ekGgq");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $25nEq = parcelRequire("25nEq");
function $3349d29a26f0924f$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $3349d29a26f0924f$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $3349d29a26f0924f$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $3349d29a26f0924f$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $3349d29a26f0924f$export$ad4be5c2ec28cecf = function isAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $3349d29a26f0924f$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === 'AnalyticsEvent';
};
var $3349d29a26f0924f$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function AnalyticsEvent(props) {
        var _this = this;
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, AnalyticsEvent);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "_isAnalyticsEvent", true);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "clone", function() {
            // just a shallow clone, don't change sub refs unless you want to
            // affect the original's too
            var payload = $3349d29a26f0924f$var$_objectSpread({}, _this.payload);
            return new AnalyticsEvent({
                payload: payload
            });
        });
        this.payload = props.payload;
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(AnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (typeof updater === 'function') this.payload = updater(this.payload);
                if ((0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(updater) === 'object') this.payload = $3349d29a26f0924f$var$_objectSpread($3349d29a26f0924f$var$_objectSpread({}, this.payload), updater);
                return this;
            }
        }
    ]);
}();

});


parcelRegister("2M6Kk", function(module, exports) {
$parcel$export(module.exports, "useAnalyticsContext", () => $20554c1a81fb2c22$export$d1f587f82ad51c4);

var $5FkrB = parcelRequire("5FkrB");

var $iyyOp = parcelRequire("iyyOp");
var $20554c1a81fb2c22$export$d1f587f82ad51c4 = function useAnalyticsContext() {
    return (0, $5FkrB.useContext)((0, $iyyOp.default));
};

});


parcelRegister("hYekS", function(module, exports) {
$parcel$export(module.exports, "useTrackedRef", () => $d153290c0c5e3777$export$1d27a74659855e44);

var $5FkrB = parcelRequire("5FkrB");
var $d153290c0c5e3777$export$1d27a74659855e44 = function useTrackedRef(value) {
    var ref = (0, $5FkrB.useRef)(value);
    ref.current = value;
    return ref;
};

});



parcelRegister("5U7m7", function(module, exports) {
$parcel$export(module.exports, "default", () => $44c7e3688115c778$export$2e2bcd8739ae039);

var $jxtxv = parcelRequire("jxtxv");

var $KJlqb = parcelRequire("KJlqb");

var $k0voR = parcelRequire("k0voR");

var $1HIxa = parcelRequire("1HIxa");

var $l6DxK = parcelRequire("l6DxK");

var $9jQRB = parcelRequire("9jQRB");

var $jz58p = parcelRequire("jz58p");

var $hOr8a = parcelRequire("hOr8a");

var $aCKXn = parcelRequire("aCKXn");

var $hBm5q = parcelRequire("hBm5q");

var $9G5I4 = parcelRequire("9G5I4");
// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps
var $44c7e3688115c778$var$formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;
// This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`
var $44c7e3688115c778$var$longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
var $44c7e3688115c778$var$escapedStringRegExp = /^'([^]*?)'?$/;
var $44c7e3688115c778$var$doubleQuoteRegExp = /''/g;
var $44c7e3688115c778$var$unescapedLatinCharacterRegExp = /[a-zA-Z]/;
function $44c7e3688115c778$export$2e2bcd8739ae039(dirtyDate, dirtyFormatStr, options) {
    var _ref, _options$locale, _ref2, _ref3, _ref4, _options$firstWeekCon, _options$locale2, _options$locale2$opti, _defaultOptions$local, _defaultOptions$local2, _ref5, _ref6, _ref7, _options$weekStartsOn, _options$locale3, _options$locale3$opti, _defaultOptions$local3, _defaultOptions$local4;
    (0, $aCKXn.default)(2, arguments);
    var formatStr = String(dirtyFormatStr);
    var defaultOptions = (0, $hBm5q.getDefaultOptions)();
    var locale = (_ref = (_options$locale = options === null || options === void 0 ? void 0 : options.locale) !== null && _options$locale !== void 0 ? _options$locale : defaultOptions.locale) !== null && _ref !== void 0 ? _ref : (0, $9G5I4.default);
    var firstWeekContainsDate = (0, $hOr8a.default)((_ref2 = (_ref3 = (_ref4 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale2 = options.locale) === null || _options$locale2 === void 0 ? void 0 : (_options$locale2$opti = _options$locale2.options) === null || _options$locale2$opti === void 0 ? void 0 : _options$locale2$opti.firstWeekContainsDate) !== null && _ref4 !== void 0 ? _ref4 : defaultOptions.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : 1);
    // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
    if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
    var weekStartsOn = (0, $hOr8a.default)((_ref5 = (_ref6 = (_ref7 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale3 = options.locale) === null || _options$locale3 === void 0 ? void 0 : (_options$locale3$opti = _options$locale3.options) === null || _options$locale3$opti === void 0 ? void 0 : _options$locale3$opti.weekStartsOn) !== null && _ref7 !== void 0 ? _ref7 : defaultOptions.weekStartsOn) !== null && _ref6 !== void 0 ? _ref6 : (_defaultOptions$local3 = defaultOptions.locale) === null || _defaultOptions$local3 === void 0 ? void 0 : (_defaultOptions$local4 = _defaultOptions$local3.options) === null || _defaultOptions$local4 === void 0 ? void 0 : _defaultOptions$local4.weekStartsOn) !== null && _ref5 !== void 0 ? _ref5 : 0);
    // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
    if (!locale.localize) throw new RangeError('locale must contain localize property');
    if (!locale.formatLong) throw new RangeError('locale must contain formatLong property');
    var originalDate = (0, $k0voR.default)(dirtyDate);
    if (!(0, $jxtxv.default)(originalDate)) throw new RangeError('Invalid time value');
    // Convert the date in system timezone to the same date in UTC+00:00 timezone.
    // This ensures that when UTC functions will be implemented, locales will be compatible with them.
    // See an issue about UTC functions: https://github.com/date-fns/date-fns/issues/376
    var timezoneOffset = (0, $9jQRB.default)(originalDate);
    var utcDate = (0, $KJlqb.default)(originalDate, timezoneOffset);
    var formatterOptions = {
        firstWeekContainsDate: firstWeekContainsDate,
        weekStartsOn: weekStartsOn,
        locale: locale,
        _originalDate: originalDate
    };
    var result = formatStr.match($44c7e3688115c778$var$longFormattingTokensRegExp).map(function(substring) {
        var firstCharacter = substring[0];
        if (firstCharacter === 'p' || firstCharacter === 'P') {
            var longFormatter = (0, $l6DxK.default)[firstCharacter];
            return longFormatter(substring, locale.formatLong);
        }
        return substring;
    }).join('').match($44c7e3688115c778$var$formattingTokensRegExp).map(function(substring) {
        // Replace two single quote characters with one single quote character
        if (substring === "''") return "'";
        var firstCharacter = substring[0];
        if (firstCharacter === "'") return $44c7e3688115c778$var$cleanEscapedString(substring);
        var formatter = (0, $1HIxa.default)[firstCharacter];
        if (formatter) {
            if (!(options !== null && options !== void 0 && options.useAdditionalWeekYearTokens) && (0, $jz58p.isProtectedWeekYearToken)(substring)) (0, $jz58p.throwProtectedError)(substring, dirtyFormatStr, String(dirtyDate));
            if (!(options !== null && options !== void 0 && options.useAdditionalDayOfYearTokens) && (0, $jz58p.isProtectedDayOfYearToken)(substring)) (0, $jz58p.throwProtectedError)(substring, dirtyFormatStr, String(dirtyDate));
            return formatter(utcDate, substring, locale.localize, formatterOptions);
        }
        if (firstCharacter.match($44c7e3688115c778$var$unescapedLatinCharacterRegExp)) throw new RangeError('Format string contains an unescaped latin alphabet character `' + firstCharacter + '`');
        return substring;
    }).join('');
    return result;
}
function $44c7e3688115c778$var$cleanEscapedString(input) {
    var matched = input.match($44c7e3688115c778$var$escapedStringRegExp);
    if (!matched) return input;
    return matched[1].replace($44c7e3688115c778$var$doubleQuoteRegExp, "'");
}

});
parcelRegister("jxtxv", function(module, exports) {
$parcel$export(module.exports, "default", () => $e3980351834995ab$export$2e2bcd8739ae039);

var $1nfEQ = parcelRequire("1nfEQ");

var $k0voR = parcelRequire("k0voR");

var $aCKXn = parcelRequire("aCKXn");
function $e3980351834995ab$export$2e2bcd8739ae039(dirtyDate) {
    (0, $aCKXn.default)(1, arguments);
    if (!(0, $1nfEQ.default)(dirtyDate) && typeof dirtyDate !== 'number') return false;
    var date = (0, $k0voR.default)(dirtyDate);
    return !isNaN(Number(date));
}

});
parcelRegister("1nfEQ", function(module, exports) {
$parcel$export(module.exports, "default", () => $100415c0e06ad7d1$export$2e2bcd8739ae039);

var $4bFFZ = parcelRequire("4bFFZ");

var $aCKXn = parcelRequire("aCKXn");
function $100415c0e06ad7d1$export$2e2bcd8739ae039(value) {
    (0, $aCKXn.default)(1, arguments);
    return value instanceof Date || (0, $4bFFZ.default)(value) === 'object' && Object.prototype.toString.call(value) === '[object Date]';
}

});


parcelRegister("KJlqb", function(module, exports) {
$parcel$export(module.exports, "default", () => $08c7787764a59511$export$2e2bcd8739ae039);

var $3eZy9 = parcelRequire("3eZy9");

var $aCKXn = parcelRequire("aCKXn");

var $hOr8a = parcelRequire("hOr8a");
function $08c7787764a59511$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $aCKXn.default)(2, arguments);
    var amount = (0, $hOr8a.default)(dirtyAmount);
    return (0, $3eZy9.default)(dirtyDate, -amount);
}

});
parcelRegister("3eZy9", function(module, exports) {
$parcel$export(module.exports, "default", () => $25c26c65a9a3f401$export$2e2bcd8739ae039);

var $hOr8a = parcelRequire("hOr8a");

var $k0voR = parcelRequire("k0voR");

var $aCKXn = parcelRequire("aCKXn");
function $25c26c65a9a3f401$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $aCKXn.default)(2, arguments);
    var timestamp = (0, $k0voR.default)(dirtyDate).getTime();
    var amount = (0, $hOr8a.default)(dirtyAmount);
    return new Date(timestamp + amount);
}

});
parcelRegister("hOr8a", function(module, exports) {
$parcel$export(module.exports, "default", () => $cf7c26c2a4a26bc1$export$2e2bcd8739ae039);
function $cf7c26c2a4a26bc1$export$2e2bcd8739ae039(dirtyNumber) {
    if (dirtyNumber === null || dirtyNumber === true || dirtyNumber === false) return NaN;
    var number = Number(dirtyNumber);
    if (isNaN(number)) return number;
    return number < 0 ? Math.ceil(number) : Math.floor(number);
}

});



parcelRegister("1HIxa", function(module, exports) {
$parcel$export(module.exports, "default", () => $13dc5a1b4d49c370$export$2e2bcd8739ae039);

var $iOr5M = parcelRequire("iOr5M");

var $6Tgvh = parcelRequire("6Tgvh");

var $3ePtK = parcelRequire("3ePtK");

var $1zfYD = parcelRequire("1zfYD");

var $iM3rn = parcelRequire("iM3rn");

var $buuft = parcelRequire("buuft");

var $diW5c = parcelRequire("diW5c");
var $13dc5a1b4d49c370$var$dayPeriodEnum = {
    am: 'am',
    pm: 'pm',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'morning',
    afternoon: 'afternoon',
    evening: 'evening',
    night: 'night'
};
/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* | Milliseconds in day            |
 * |  b  | AM, PM, noon, midnight         |  B  | Flexible day period            |
 * |  c  | Stand-alone local day of week  |  C* | Localized hour w/ day period   |
 * |  d  | Day of month                   |  D  | Day of year                    |
 * |  e  | Local day of week              |  E  | Day of week                    |
 * |  f  |                                |  F* | Day of week in month           |
 * |  g* | Modified Julian day            |  G  | Era                            |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  i! | ISO day of week                |  I! | ISO week of year               |
 * |  j* | Localized hour w/ day period   |  J* | Localized hour w/o day period  |
 * |  k  | Hour [1-24]                    |  K  | Hour [0-11]                    |
 * |  l* | (deprecated)                   |  L  | Stand-alone month              |
 * |  m  | Minute                         |  M  | Month                          |
 * |  n  |                                |  N  |                                |
 * |  o! | Ordinal number modifier        |  O  | Timezone (GMT)                 |
 * |  p! | Long localized time            |  P! | Long localized date            |
 * |  q  | Stand-alone quarter            |  Q  | Quarter                        |
 * |  r* | Related Gregorian year         |  R! | ISO week-numbering year        |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  t! | Seconds timestamp              |  T! | Milliseconds timestamp         |
 * |  u  | Extended year                  |  U* | Cyclic year                    |
 * |  v* | Timezone (generic non-locat.)  |  V* | Timezone (location)            |
 * |  w  | Local week of year             |  W* | Week of month                  |
 * |  x  | Timezone (ISO-8601 w/o Z)      |  X  | Timezone (ISO-8601)            |
 * |  y  | Year (abs)                     |  Y  | Local week-numbering year      |
 * |  z  | Timezone (specific non-locat.) |  Z* | Timezone (aliases)             |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 *
 * Letters marked by ! are non-standard, but implemented by date-fns:
 * - `o` modifies the previous token to turn it into an ordinal (see `format` docs)
 * - `i` is ISO day of week. For `i` and `ii` is returns numeric ISO week days,
 *   i.e. 7 for Sunday, 1 for Monday, etc.
 * - `I` is ISO week of year, as opposed to `w` which is local week of year.
 * - `R` is ISO week-numbering year, as opposed to `Y` which is local week-numbering year.
 *   `R` is supposed to be used in conjunction with `I` and `i`
 *   for universal ISO week-numbering date, whereas
 *   `Y` is supposed to be used in conjunction with `w` and `e`
 *   for week-numbering date specific to the locale.
 * - `P` is long localized date format
 * - `p` is long localized time format
 */ var $13dc5a1b4d49c370$var$formatters = {
    // Era
    G: function G(date, token, localize) {
        var era = date.getUTCFullYear() > 0 ? 1 : 0;
        switch(token){
            // AD, BC
            case 'G':
            case 'GG':
            case 'GGG':
                return localize.era(era, {
                    width: 'abbreviated'
                });
            // A, B
            case 'GGGGG':
                return localize.era(era, {
                    width: 'narrow'
                });
            // Anno Domini, Before Christ
            case 'GGGG':
            default:
                return localize.era(era, {
                    width: 'wide'
                });
        }
    },
    // Year
    y: function y(date, token, localize) {
        // Ordinal number
        if (token === 'yo') {
            var signedYear = date.getUTCFullYear();
            // Returns 1 for 1 BC (which is year 0 in JavaScript)
            var year = signedYear > 0 ? signedYear : 1 - signedYear;
            return localize.ordinalNumber(year, {
                unit: 'year'
            });
        }
        return (0, $diW5c.default).y(date, token);
    },
    // Local week-numbering year
    Y: function Y(date, token, localize, options) {
        var signedWeekYear = (0, $iM3rn.default)(date, options);
        // Returns 1 for 1 BC (which is year 0 in JavaScript)
        var weekYear = signedWeekYear > 0 ? signedWeekYear : 1 - signedWeekYear;
        // Two digit year
        if (token === 'YY') {
            var twoDigitYear = weekYear % 100;
            return (0, $buuft.default)(twoDigitYear, 2);
        }
        // Ordinal number
        if (token === 'Yo') return localize.ordinalNumber(weekYear, {
            unit: 'year'
        });
        // Padding
        return (0, $buuft.default)(weekYear, token.length);
    },
    // ISO week-numbering year
    R: function R(date, token) {
        var isoWeekYear = (0, $3ePtK.default)(date);
        // Padding
        return (0, $buuft.default)(isoWeekYear, token.length);
    },
    // Extended year. This is a single number designating the year of this calendar system.
    // The main difference between `y` and `u` localizers are B.C. years:
    // | Year | `y` | `u` |
    // |------|-----|-----|
    // | AC 1 |   1 |   1 |
    // | BC 1 |   1 |   0 |
    // | BC 2 |   2 |  -1 |
    // Also `yy` always returns the last two digits of a year,
    // while `uu` pads single digit years to 2 characters and returns other years unchanged.
    u: function u(date, token) {
        var year = date.getUTCFullYear();
        return (0, $buuft.default)(year, token.length);
    },
    // Quarter
    Q: function Q(date, token, localize) {
        var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
        switch(token){
            // 1, 2, 3, 4
            case 'Q':
                return String(quarter);
            // 01, 02, 03, 04
            case 'QQ':
                return (0, $buuft.default)(quarter, 2);
            // 1st, 2nd, 3rd, 4th
            case 'Qo':
                return localize.ordinalNumber(quarter, {
                    unit: 'quarter'
                });
            // Q1, Q2, Q3, Q4
            case 'QQQ':
                return localize.quarter(quarter, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case 'QQQQQ':
                return localize.quarter(quarter, {
                    width: 'narrow',
                    context: 'formatting'
                });
            // 1st quarter, 2nd quarter, ...
            case 'QQQQ':
            default:
                return localize.quarter(quarter, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // Stand-alone quarter
    q: function q(date, token, localize) {
        var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
        switch(token){
            // 1, 2, 3, 4
            case 'q':
                return String(quarter);
            // 01, 02, 03, 04
            case 'qq':
                return (0, $buuft.default)(quarter, 2);
            // 1st, 2nd, 3rd, 4th
            case 'qo':
                return localize.ordinalNumber(quarter, {
                    unit: 'quarter'
                });
            // Q1, Q2, Q3, Q4
            case 'qqq':
                return localize.quarter(quarter, {
                    width: 'abbreviated',
                    context: 'standalone'
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case 'qqqqq':
                return localize.quarter(quarter, {
                    width: 'narrow',
                    context: 'standalone'
                });
            // 1st quarter, 2nd quarter, ...
            case 'qqqq':
            default:
                return localize.quarter(quarter, {
                    width: 'wide',
                    context: 'standalone'
                });
        }
    },
    // Month
    M: function M(date, token, localize) {
        var month = date.getUTCMonth();
        switch(token){
            case 'M':
            case 'MM':
                return (0, $diW5c.default).M(date, token);
            // 1st, 2nd, ..., 12th
            case 'Mo':
                return localize.ordinalNumber(month + 1, {
                    unit: 'month'
                });
            // Jan, Feb, ..., Dec
            case 'MMM':
                return localize.month(month, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            // J, F, ..., D
            case 'MMMMM':
                return localize.month(month, {
                    width: 'narrow',
                    context: 'formatting'
                });
            // January, February, ..., December
            case 'MMMM':
            default:
                return localize.month(month, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // Stand-alone month
    L: function L(date, token, localize) {
        var month = date.getUTCMonth();
        switch(token){
            // 1, 2, ..., 12
            case 'L':
                return String(month + 1);
            // 01, 02, ..., 12
            case 'LL':
                return (0, $buuft.default)(month + 1, 2);
            // 1st, 2nd, ..., 12th
            case 'Lo':
                return localize.ordinalNumber(month + 1, {
                    unit: 'month'
                });
            // Jan, Feb, ..., Dec
            case 'LLL':
                return localize.month(month, {
                    width: 'abbreviated',
                    context: 'standalone'
                });
            // J, F, ..., D
            case 'LLLLL':
                return localize.month(month, {
                    width: 'narrow',
                    context: 'standalone'
                });
            // January, February, ..., December
            case 'LLLL':
            default:
                return localize.month(month, {
                    width: 'wide',
                    context: 'standalone'
                });
        }
    },
    // Local week of year
    w: function w(date, token, localize, options) {
        var week = (0, $1zfYD.default)(date, options);
        if (token === 'wo') return localize.ordinalNumber(week, {
            unit: 'week'
        });
        return (0, $buuft.default)(week, token.length);
    },
    // ISO week of year
    I: function I(date, token, localize) {
        var isoWeek = (0, $6Tgvh.default)(date);
        if (token === 'Io') return localize.ordinalNumber(isoWeek, {
            unit: 'week'
        });
        return (0, $buuft.default)(isoWeek, token.length);
    },
    // Day of the month
    d: function d(date, token, localize) {
        if (token === 'do') return localize.ordinalNumber(date.getUTCDate(), {
            unit: 'date'
        });
        return (0, $diW5c.default).d(date, token);
    },
    // Day of year
    D: function D(date, token, localize) {
        var dayOfYear = (0, $iOr5M.default)(date);
        if (token === 'Do') return localize.ordinalNumber(dayOfYear, {
            unit: 'dayOfYear'
        });
        return (0, $buuft.default)(dayOfYear, token.length);
    },
    // Day of week
    E: function E(date, token, localize) {
        var dayOfWeek = date.getUTCDay();
        switch(token){
            // Tue
            case 'E':
            case 'EE':
            case 'EEE':
                return localize.day(dayOfWeek, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            // T
            case 'EEEEE':
                return localize.day(dayOfWeek, {
                    width: 'narrow',
                    context: 'formatting'
                });
            // Tu
            case 'EEEEEE':
                return localize.day(dayOfWeek, {
                    width: 'short',
                    context: 'formatting'
                });
            // Tuesday
            case 'EEEE':
            default:
                return localize.day(dayOfWeek, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // Local day of week
    e: function e(date, token, localize, options) {
        var dayOfWeek = date.getUTCDay();
        var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
        switch(token){
            // Numerical value (Nth day of week with current locale or weekStartsOn)
            case 'e':
                return String(localDayOfWeek);
            // Padded numerical value
            case 'ee':
                return (0, $buuft.default)(localDayOfWeek, 2);
            // 1st, 2nd, ..., 7th
            case 'eo':
                return localize.ordinalNumber(localDayOfWeek, {
                    unit: 'day'
                });
            case 'eee':
                return localize.day(dayOfWeek, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            // T
            case 'eeeee':
                return localize.day(dayOfWeek, {
                    width: 'narrow',
                    context: 'formatting'
                });
            // Tu
            case 'eeeeee':
                return localize.day(dayOfWeek, {
                    width: 'short',
                    context: 'formatting'
                });
            // Tuesday
            case 'eeee':
            default:
                return localize.day(dayOfWeek, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // Stand-alone local day of week
    c: function c(date, token, localize, options) {
        var dayOfWeek = date.getUTCDay();
        var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
        switch(token){
            // Numerical value (same as in `e`)
            case 'c':
                return String(localDayOfWeek);
            // Padded numerical value
            case 'cc':
                return (0, $buuft.default)(localDayOfWeek, token.length);
            // 1st, 2nd, ..., 7th
            case 'co':
                return localize.ordinalNumber(localDayOfWeek, {
                    unit: 'day'
                });
            case 'ccc':
                return localize.day(dayOfWeek, {
                    width: 'abbreviated',
                    context: 'standalone'
                });
            // T
            case 'ccccc':
                return localize.day(dayOfWeek, {
                    width: 'narrow',
                    context: 'standalone'
                });
            // Tu
            case 'cccccc':
                return localize.day(dayOfWeek, {
                    width: 'short',
                    context: 'standalone'
                });
            // Tuesday
            case 'cccc':
            default:
                return localize.day(dayOfWeek, {
                    width: 'wide',
                    context: 'standalone'
                });
        }
    },
    // ISO day of week
    i: function i(date, token, localize) {
        var dayOfWeek = date.getUTCDay();
        var isoDayOfWeek = dayOfWeek === 0 ? 7 : dayOfWeek;
        switch(token){
            // 2
            case 'i':
                return String(isoDayOfWeek);
            // 02
            case 'ii':
                return (0, $buuft.default)(isoDayOfWeek, token.length);
            // 2nd
            case 'io':
                return localize.ordinalNumber(isoDayOfWeek, {
                    unit: 'day'
                });
            // Tue
            case 'iii':
                return localize.day(dayOfWeek, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            // T
            case 'iiiii':
                return localize.day(dayOfWeek, {
                    width: 'narrow',
                    context: 'formatting'
                });
            // Tu
            case 'iiiiii':
                return localize.day(dayOfWeek, {
                    width: 'short',
                    context: 'formatting'
                });
            // Tuesday
            case 'iiii':
            default:
                return localize.day(dayOfWeek, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // AM or PM
    a: function a(date, token, localize) {
        var hours = date.getUTCHours();
        var dayPeriodEnumValue = hours / 12 >= 1 ? 'pm' : 'am';
        switch(token){
            case 'a':
            case 'aa':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            case 'aaa':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'abbreviated',
                    context: 'formatting'
                }).toLowerCase();
            case 'aaaaa':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'narrow',
                    context: 'formatting'
                });
            case 'aaaa':
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // AM, PM, midnight, noon
    b: function b(date, token, localize) {
        var hours = date.getUTCHours();
        var dayPeriodEnumValue;
        if (hours === 12) dayPeriodEnumValue = $13dc5a1b4d49c370$var$dayPeriodEnum.noon;
        else if (hours === 0) dayPeriodEnumValue = $13dc5a1b4d49c370$var$dayPeriodEnum.midnight;
        else dayPeriodEnumValue = hours / 12 >= 1 ? 'pm' : 'am';
        switch(token){
            case 'b':
            case 'bb':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            case 'bbb':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'abbreviated',
                    context: 'formatting'
                }).toLowerCase();
            case 'bbbbb':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'narrow',
                    context: 'formatting'
                });
            case 'bbbb':
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // in the morning, in the afternoon, in the evening, at night
    B: function B(date, token, localize) {
        var hours = date.getUTCHours();
        var dayPeriodEnumValue;
        if (hours >= 17) dayPeriodEnumValue = $13dc5a1b4d49c370$var$dayPeriodEnum.evening;
        else if (hours >= 12) dayPeriodEnumValue = $13dc5a1b4d49c370$var$dayPeriodEnum.afternoon;
        else if (hours >= 4) dayPeriodEnumValue = $13dc5a1b4d49c370$var$dayPeriodEnum.morning;
        else dayPeriodEnumValue = $13dc5a1b4d49c370$var$dayPeriodEnum.night;
        switch(token){
            case 'B':
            case 'BB':
            case 'BBB':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            case 'BBBBB':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'narrow',
                    context: 'formatting'
                });
            case 'BBBB':
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // Hour [1-12]
    h: function h(date, token, localize) {
        if (token === 'ho') {
            var hours = date.getUTCHours() % 12;
            if (hours === 0) hours = 12;
            return localize.ordinalNumber(hours, {
                unit: 'hour'
            });
        }
        return (0, $diW5c.default).h(date, token);
    },
    // Hour [0-23]
    H: function H(date, token, localize) {
        if (token === 'Ho') return localize.ordinalNumber(date.getUTCHours(), {
            unit: 'hour'
        });
        return (0, $diW5c.default).H(date, token);
    },
    // Hour [0-11]
    K: function K(date, token, localize) {
        var hours = date.getUTCHours() % 12;
        if (token === 'Ko') return localize.ordinalNumber(hours, {
            unit: 'hour'
        });
        return (0, $buuft.default)(hours, token.length);
    },
    // Hour [1-24]
    k: function k(date, token, localize) {
        var hours = date.getUTCHours();
        if (hours === 0) hours = 24;
        if (token === 'ko') return localize.ordinalNumber(hours, {
            unit: 'hour'
        });
        return (0, $buuft.default)(hours, token.length);
    },
    // Minute
    m: function m(date, token, localize) {
        if (token === 'mo') return localize.ordinalNumber(date.getUTCMinutes(), {
            unit: 'minute'
        });
        return (0, $diW5c.default).m(date, token);
    },
    // Second
    s: function s(date, token, localize) {
        if (token === 'so') return localize.ordinalNumber(date.getUTCSeconds(), {
            unit: 'second'
        });
        return (0, $diW5c.default).s(date, token);
    },
    // Fraction of second
    S: function S(date, token) {
        return (0, $diW5c.default).S(date, token);
    },
    // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
    X: function X(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        if (timezoneOffset === 0) return 'Z';
        switch(token){
            // Hours and optional minutes
            case 'X':
                return $13dc5a1b4d49c370$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XX`
            case 'XXXX':
            case 'XX':
                // Hours and minutes without `:` delimiter
                return $13dc5a1b4d49c370$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XXX`
            case 'XXXXX':
            case 'XXX':
            default:
                return $13dc5a1b4d49c370$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
    x: function x(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        switch(token){
            // Hours and optional minutes
            case 'x':
                return $13dc5a1b4d49c370$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xx`
            case 'xxxx':
            case 'xx':
                // Hours and minutes without `:` delimiter
                return $13dc5a1b4d49c370$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xxx`
            case 'xxxxx':
            case 'xxx':
            default:
                return $13dc5a1b4d49c370$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (GMT)
    O: function O(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        switch(token){
            // Short
            case 'O':
            case 'OO':
            case 'OOO':
                return 'GMT' + $13dc5a1b4d49c370$var$formatTimezoneShort(timezoneOffset, ':');
            // Long
            case 'OOOO':
            default:
                return 'GMT' + $13dc5a1b4d49c370$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (specific non-location)
    z: function z(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        switch(token){
            // Short
            case 'z':
            case 'zz':
            case 'zzz':
                return 'GMT' + $13dc5a1b4d49c370$var$formatTimezoneShort(timezoneOffset, ':');
            // Long
            case 'zzzz':
            default:
                return 'GMT' + $13dc5a1b4d49c370$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Seconds timestamp
    t: function t(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timestamp = Math.floor(originalDate.getTime() / 1000);
        return (0, $buuft.default)(timestamp, token.length);
    },
    // Milliseconds timestamp
    T: function T(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timestamp = originalDate.getTime();
        return (0, $buuft.default)(timestamp, token.length);
    }
};
function $13dc5a1b4d49c370$var$formatTimezoneShort(offset, dirtyDelimiter) {
    var sign = offset > 0 ? '-' : '+';
    var absOffset = Math.abs(offset);
    var hours = Math.floor(absOffset / 60);
    var minutes = absOffset % 60;
    if (minutes === 0) return sign + String(hours);
    var delimiter = dirtyDelimiter || '';
    return sign + String(hours) + delimiter + (0, $buuft.default)(minutes, 2);
}
function $13dc5a1b4d49c370$var$formatTimezoneWithOptionalMinutes(offset, dirtyDelimiter) {
    if (offset % 60 === 0) {
        var sign = offset > 0 ? '-' : '+';
        return sign + (0, $buuft.default)(Math.abs(offset) / 60, 2);
    }
    return $13dc5a1b4d49c370$var$formatTimezone(offset, dirtyDelimiter);
}
function $13dc5a1b4d49c370$var$formatTimezone(offset, dirtyDelimiter) {
    var delimiter = dirtyDelimiter || '';
    var sign = offset > 0 ? '-' : '+';
    var absOffset = Math.abs(offset);
    var hours = (0, $buuft.default)(Math.floor(absOffset / 60), 2);
    var minutes = (0, $buuft.default)(absOffset % 60, 2);
    return sign + hours + delimiter + minutes;
}
var $13dc5a1b4d49c370$export$2e2bcd8739ae039 = $13dc5a1b4d49c370$var$formatters;

});
parcelRegister("iOr5M", function(module, exports) {
$parcel$export(module.exports, "default", () => $db21e9710b6447ab$export$2e2bcd8739ae039);

var $k0voR = parcelRequire("k0voR");

var $aCKXn = parcelRequire("aCKXn");
var $db21e9710b6447ab$var$MILLISECONDS_IN_DAY = 86400000;
function $db21e9710b6447ab$export$2e2bcd8739ae039(dirtyDate) {
    (0, $aCKXn.default)(1, arguments);
    var date = (0, $k0voR.default)(dirtyDate);
    var timestamp = date.getTime();
    date.setUTCMonth(0, 1);
    date.setUTCHours(0, 0, 0, 0);
    var startOfYearTimestamp = date.getTime();
    var difference = timestamp - startOfYearTimestamp;
    return Math.floor(difference / $db21e9710b6447ab$var$MILLISECONDS_IN_DAY) + 1;
}

});

parcelRegister("6Tgvh", function(module, exports) {
$parcel$export(module.exports, "default", () => $5044ae646457eb42$export$2e2bcd8739ae039);

var $k0voR = parcelRequire("k0voR");

var $7gPem = parcelRequire("7gPem");

var $dtUgx = parcelRequire("dtUgx");

var $aCKXn = parcelRequire("aCKXn");
var $5044ae646457eb42$var$MILLISECONDS_IN_WEEK = 604800000;
function $5044ae646457eb42$export$2e2bcd8739ae039(dirtyDate) {
    (0, $aCKXn.default)(1, arguments);
    var date = (0, $k0voR.default)(dirtyDate);
    var diff = (0, $7gPem.default)(date).getTime() - (0, $dtUgx.default)(date).getTime();
    // Round the number of days to the nearest integer
    // because the number of milliseconds in a week is not constant
    // (e.g. it's different in the week of the daylight saving time clock shift)
    return Math.round(diff / $5044ae646457eb42$var$MILLISECONDS_IN_WEEK) + 1;
}

});
parcelRegister("7gPem", function(module, exports) {
$parcel$export(module.exports, "default", () => $54b1c45c5c767fee$export$2e2bcd8739ae039);

var $k0voR = parcelRequire("k0voR");

var $aCKXn = parcelRequire("aCKXn");
function $54b1c45c5c767fee$export$2e2bcd8739ae039(dirtyDate) {
    (0, $aCKXn.default)(1, arguments);
    var weekStartsOn = 1;
    var date = (0, $k0voR.default)(dirtyDate);
    var day = date.getUTCDay();
    var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    date.setUTCDate(date.getUTCDate() - diff);
    date.setUTCHours(0, 0, 0, 0);
    return date;
}

});

parcelRegister("dtUgx", function(module, exports) {
$parcel$export(module.exports, "default", () => $9d09a0fec5957b21$export$2e2bcd8739ae039);

var $3ePtK = parcelRequire("3ePtK");

var $7gPem = parcelRequire("7gPem");

var $aCKXn = parcelRequire("aCKXn");
function $9d09a0fec5957b21$export$2e2bcd8739ae039(dirtyDate) {
    (0, $aCKXn.default)(1, arguments);
    var year = (0, $3ePtK.default)(dirtyDate);
    var fourthOfJanuary = new Date(0);
    fourthOfJanuary.setUTCFullYear(year, 0, 4);
    fourthOfJanuary.setUTCHours(0, 0, 0, 0);
    var date = (0, $7gPem.default)(fourthOfJanuary);
    return date;
}

});
parcelRegister("3ePtK", function(module, exports) {
$parcel$export(module.exports, "default", () => $25ba9c83d5d9930e$export$2e2bcd8739ae039);

var $k0voR = parcelRequire("k0voR");

var $aCKXn = parcelRequire("aCKXn");

var $7gPem = parcelRequire("7gPem");
function $25ba9c83d5d9930e$export$2e2bcd8739ae039(dirtyDate) {
    (0, $aCKXn.default)(1, arguments);
    var date = (0, $k0voR.default)(dirtyDate);
    var year = date.getUTCFullYear();
    var fourthOfJanuaryOfNextYear = new Date(0);
    fourthOfJanuaryOfNextYear.setUTCFullYear(year + 1, 0, 4);
    fourthOfJanuaryOfNextYear.setUTCHours(0, 0, 0, 0);
    var startOfNextYear = (0, $7gPem.default)(fourthOfJanuaryOfNextYear);
    var fourthOfJanuaryOfThisYear = new Date(0);
    fourthOfJanuaryOfThisYear.setUTCFullYear(year, 0, 4);
    fourthOfJanuaryOfThisYear.setUTCHours(0, 0, 0, 0);
    var startOfThisYear = (0, $7gPem.default)(fourthOfJanuaryOfThisYear);
    if (date.getTime() >= startOfNextYear.getTime()) return year + 1;
    else if (date.getTime() >= startOfThisYear.getTime()) return year;
    else return year - 1;
}

});



parcelRegister("1zfYD", function(module, exports) {
$parcel$export(module.exports, "default", () => $1245740a01367970$export$2e2bcd8739ae039);

var $k0voR = parcelRequire("k0voR");

var $dFI5Q = parcelRequire("dFI5Q");

var $8tgSL = parcelRequire("8tgSL");

var $aCKXn = parcelRequire("aCKXn");
var $1245740a01367970$var$MILLISECONDS_IN_WEEK = 604800000;
function $1245740a01367970$export$2e2bcd8739ae039(dirtyDate, options) {
    (0, $aCKXn.default)(1, arguments);
    var date = (0, $k0voR.default)(dirtyDate);
    var diff = (0, $dFI5Q.default)(date, options).getTime() - (0, $8tgSL.default)(date, options).getTime();
    // Round the number of days to the nearest integer
    // because the number of milliseconds in a week is not constant
    // (e.g. it's different in the week of the daylight saving time clock shift)
    return Math.round(diff / $1245740a01367970$var$MILLISECONDS_IN_WEEK) + 1;
}

});
parcelRegister("dFI5Q", function(module, exports) {
$parcel$export(module.exports, "default", () => $9f414eb4a3d1e79f$export$2e2bcd8739ae039);

var $k0voR = parcelRequire("k0voR");

var $aCKXn = parcelRequire("aCKXn");

var $hOr8a = parcelRequire("hOr8a");

var $hBm5q = parcelRequire("hBm5q");
function $9f414eb4a3d1e79f$export$2e2bcd8739ae039(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, $aCKXn.default)(1, arguments);
    var defaultOptions = (0, $hBm5q.getDefaultOptions)();
    var weekStartsOn = (0, $hOr8a.default)((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0);
    // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
    var date = (0, $k0voR.default)(dirtyDate);
    var day = date.getUTCDay();
    var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    date.setUTCDate(date.getUTCDate() - diff);
    date.setUTCHours(0, 0, 0, 0);
    return date;
}

});
parcelRegister("hBm5q", function(module, exports) {
$parcel$export(module.exports, "getDefaultOptions", () => $cd0706491e5a086b$export$430a3269e24b912e);
var $cd0706491e5a086b$var$defaultOptions = {};
function $cd0706491e5a086b$export$430a3269e24b912e() {
    return $cd0706491e5a086b$var$defaultOptions;
}
function $cd0706491e5a086b$export$95365be1b0704abc(newOptions) {
    $cd0706491e5a086b$var$defaultOptions = newOptions;
}

});


parcelRegister("8tgSL", function(module, exports) {
$parcel$export(module.exports, "default", () => $62ae20a17aa15d33$export$2e2bcd8739ae039);

var $iM3rn = parcelRequire("iM3rn");

var $aCKXn = parcelRequire("aCKXn");

var $dFI5Q = parcelRequire("dFI5Q");

var $hOr8a = parcelRequire("hOr8a");

var $hBm5q = parcelRequire("hBm5q");
function $62ae20a17aa15d33$export$2e2bcd8739ae039(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, $aCKXn.default)(1, arguments);
    var defaultOptions = (0, $hBm5q.getDefaultOptions)();
    var firstWeekContainsDate = (0, $hOr8a.default)((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1);
    var year = (0, $iM3rn.default)(dirtyDate, options);
    var firstWeek = new Date(0);
    firstWeek.setUTCFullYear(year, 0, firstWeekContainsDate);
    firstWeek.setUTCHours(0, 0, 0, 0);
    var date = (0, $dFI5Q.default)(firstWeek, options);
    return date;
}

});
parcelRegister("iM3rn", function(module, exports) {
$parcel$export(module.exports, "default", () => $daaf60e6a1beaa3e$export$2e2bcd8739ae039);

var $k0voR = parcelRequire("k0voR");

var $aCKXn = parcelRequire("aCKXn");

var $dFI5Q = parcelRequire("dFI5Q");

var $hOr8a = parcelRequire("hOr8a");

var $hBm5q = parcelRequire("hBm5q");
function $daaf60e6a1beaa3e$export$2e2bcd8739ae039(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, $aCKXn.default)(1, arguments);
    var date = (0, $k0voR.default)(dirtyDate);
    var year = date.getUTCFullYear();
    var defaultOptions = (0, $hBm5q.getDefaultOptions)();
    var firstWeekContainsDate = (0, $hOr8a.default)((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1);
    // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
    if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
    var firstWeekOfNextYear = new Date(0);
    firstWeekOfNextYear.setUTCFullYear(year + 1, 0, firstWeekContainsDate);
    firstWeekOfNextYear.setUTCHours(0, 0, 0, 0);
    var startOfNextYear = (0, $dFI5Q.default)(firstWeekOfNextYear, options);
    var firstWeekOfThisYear = new Date(0);
    firstWeekOfThisYear.setUTCFullYear(year, 0, firstWeekContainsDate);
    firstWeekOfThisYear.setUTCHours(0, 0, 0, 0);
    var startOfThisYear = (0, $dFI5Q.default)(firstWeekOfThisYear, options);
    if (date.getTime() >= startOfNextYear.getTime()) return year + 1;
    else if (date.getTime() >= startOfThisYear.getTime()) return year;
    else return year - 1;
}

});



parcelRegister("buuft", function(module, exports) {
$parcel$export(module.exports, "default", () => $85d9f5c973b27c2e$export$2e2bcd8739ae039);
function $85d9f5c973b27c2e$export$2e2bcd8739ae039(number, targetLength) {
    var sign = number < 0 ? '-' : '';
    var output = Math.abs(number).toString();
    while(output.length < targetLength)output = '0' + output;
    return sign + output;
}

});

parcelRegister("diW5c", function(module, exports) {
$parcel$export(module.exports, "default", () => $9afa02df71799f78$export$2e2bcd8739ae039);

var $buuft = parcelRequire("buuft");
/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* |                                |
 * |  d  | Day of month                   |  D  |                                |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  m  | Minute                         |  M  | Month                          |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  y  | Year (abs)                     |  Y  |                                |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 */ var $9afa02df71799f78$var$formatters = {
    // Year
    y: function y(date, token) {
        // From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_tokens
        // | Year     |     y | yy |   yyy |  yyyy | yyyyy |
        // |----------|-------|----|-------|-------|-------|
        // | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
        // | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
        // | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
        // | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
        // | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |
        var signedYear = date.getUTCFullYear();
        // Returns 1 for 1 BC (which is year 0 in JavaScript)
        var year = signedYear > 0 ? signedYear : 1 - signedYear;
        return (0, $buuft.default)(token === 'yy' ? year % 100 : year, token.length);
    },
    // Month
    M: function M(date, token) {
        var month = date.getUTCMonth();
        return token === 'M' ? String(month + 1) : (0, $buuft.default)(month + 1, 2);
    },
    // Day of the month
    d: function d(date, token) {
        return (0, $buuft.default)(date.getUTCDate(), token.length);
    },
    // AM or PM
    a: function a(date, token) {
        var dayPeriodEnumValue = date.getUTCHours() / 12 >= 1 ? 'pm' : 'am';
        switch(token){
            case 'a':
            case 'aa':
                return dayPeriodEnumValue.toUpperCase();
            case 'aaa':
                return dayPeriodEnumValue;
            case 'aaaaa':
                return dayPeriodEnumValue[0];
            case 'aaaa':
            default:
                return dayPeriodEnumValue === 'am' ? 'a.m.' : 'p.m.';
        }
    },
    // Hour [1-12]
    h: function h(date, token) {
        return (0, $buuft.default)(date.getUTCHours() % 12 || 12, token.length);
    },
    // Hour [0-23]
    H: function H(date, token) {
        return (0, $buuft.default)(date.getUTCHours(), token.length);
    },
    // Minute
    m: function m(date, token) {
        return (0, $buuft.default)(date.getUTCMinutes(), token.length);
    },
    // Second
    s: function s(date, token) {
        return (0, $buuft.default)(date.getUTCSeconds(), token.length);
    },
    // Fraction of second
    S: function S(date, token) {
        var numberOfDigits = token.length;
        var milliseconds = date.getUTCMilliseconds();
        var fractionalSeconds = Math.floor(milliseconds * Math.pow(10, numberOfDigits - 3));
        return (0, $buuft.default)(fractionalSeconds, token.length);
    }
};
var $9afa02df71799f78$export$2e2bcd8739ae039 = $9afa02df71799f78$var$formatters;

});


parcelRegister("l6DxK", function(module, exports) {
$parcel$export(module.exports, "default", () => $f5d8d50377ba9542$export$2e2bcd8739ae039);
var $f5d8d50377ba9542$var$dateLongFormatter = function dateLongFormatter(pattern, formatLong) {
    switch(pattern){
        case 'P':
            return formatLong.date({
                width: 'short'
            });
        case 'PP':
            return formatLong.date({
                width: 'medium'
            });
        case 'PPP':
            return formatLong.date({
                width: 'long'
            });
        case 'PPPP':
        default:
            return formatLong.date({
                width: 'full'
            });
    }
};
var $f5d8d50377ba9542$var$timeLongFormatter = function timeLongFormatter(pattern, formatLong) {
    switch(pattern){
        case 'p':
            return formatLong.time({
                width: 'short'
            });
        case 'pp':
            return formatLong.time({
                width: 'medium'
            });
        case 'ppp':
            return formatLong.time({
                width: 'long'
            });
        case 'pppp':
        default:
            return formatLong.time({
                width: 'full'
            });
    }
};
var $f5d8d50377ba9542$var$dateTimeLongFormatter = function dateTimeLongFormatter(pattern, formatLong) {
    var matchResult = pattern.match(/(P+)(p+)?/) || [];
    var datePattern = matchResult[1];
    var timePattern = matchResult[2];
    if (!timePattern) return $f5d8d50377ba9542$var$dateLongFormatter(pattern, formatLong);
    var dateTimeFormat;
    switch(datePattern){
        case 'P':
            dateTimeFormat = formatLong.dateTime({
                width: 'short'
            });
            break;
        case 'PP':
            dateTimeFormat = formatLong.dateTime({
                width: 'medium'
            });
            break;
        case 'PPP':
            dateTimeFormat = formatLong.dateTime({
                width: 'long'
            });
            break;
        case 'PPPP':
        default:
            dateTimeFormat = formatLong.dateTime({
                width: 'full'
            });
            break;
    }
    return dateTimeFormat.replace('{{date}}', $f5d8d50377ba9542$var$dateLongFormatter(datePattern, formatLong)).replace('{{time}}', $f5d8d50377ba9542$var$timeLongFormatter(timePattern, formatLong));
};
var $f5d8d50377ba9542$var$longFormatters = {
    p: $f5d8d50377ba9542$var$timeLongFormatter,
    P: $f5d8d50377ba9542$var$dateTimeLongFormatter
};
var $f5d8d50377ba9542$export$2e2bcd8739ae039 = $f5d8d50377ba9542$var$longFormatters;

});

parcelRegister("jz58p", function(module, exports) {
$parcel$export(module.exports, "isProtectedDayOfYearToken", () => $e3e544d7b5730862$export$c6cc36aa33304772);
$parcel$export(module.exports, "isProtectedWeekYearToken", () => $e3e544d7b5730862$export$c6b49d6dceb604a1);
$parcel$export(module.exports, "throwProtectedError", () => $e3e544d7b5730862$export$8073c1ae88f0e727);
var $e3e544d7b5730862$var$protectedDayOfYearTokens = [
    'D',
    'DD'
];
var $e3e544d7b5730862$var$protectedWeekYearTokens = [
    'YY',
    'YYYY'
];
function $e3e544d7b5730862$export$c6cc36aa33304772(token) {
    return $e3e544d7b5730862$var$protectedDayOfYearTokens.indexOf(token) !== -1;
}
function $e3e544d7b5730862$export$c6b49d6dceb604a1(token) {
    return $e3e544d7b5730862$var$protectedWeekYearTokens.indexOf(token) !== -1;
}
function $e3e544d7b5730862$export$8073c1ae88f0e727(token, format, input) {
    if (token === 'YYYY') throw new RangeError("Use `yyyy` instead of `YYYY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
    else if (token === 'YY') throw new RangeError("Use `yy` instead of `YY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
    else if (token === 'D') throw new RangeError("Use `d` instead of `D` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
    else if (token === 'DD') throw new RangeError("Use `dd` instead of `DD` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
}

});

parcelRegister("9G5I4", function(module, exports) {
$parcel$export(module.exports, "default", () => $70bc7726fc2c2e32$export$2e2bcd8739ae039);

var $kUUoK = parcelRequire("kUUoK");
var $70bc7726fc2c2e32$export$2e2bcd8739ae039 = (0, $kUUoK.default);

});
parcelRegister("kUUoK", function(module, exports) {
$parcel$export(module.exports, "default", () => $f3a4c91f3a0a21d4$export$2e2bcd8739ae039);

var $4KFsb = parcelRequire("4KFsb");

var $ahNJv = parcelRequire("ahNJv");

var $gDIZM = parcelRequire("gDIZM");

var $7FeVe = parcelRequire("7FeVe");

var $lnVAk = parcelRequire("lnVAk");
/**
 * @type {Locale}
 * @category Locales
 * @summary English locale (United States).
 * @language English
 * @iso-639-2 eng
 * @author Sasha Koss [@kossnocorp]{@link https://github.com/kossnocorp}
 * @author Lesha Koss [@leshakoss]{@link https://github.com/leshakoss}
 */ var $f3a4c91f3a0a21d4$var$locale = {
    code: 'en-US',
    formatDistance: (0, $4KFsb.default),
    formatLong: (0, $ahNJv.default),
    formatRelative: (0, $gDIZM.default),
    localize: (0, $7FeVe.default),
    match: (0, $lnVAk.default),
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};
var $f3a4c91f3a0a21d4$export$2e2bcd8739ae039 = $f3a4c91f3a0a21d4$var$locale;

});
parcelRegister("4KFsb", function(module, exports) {
$parcel$export(module.exports, "default", () => $375b9d1d4795a02a$export$2e2bcd8739ae039);
var $375b9d1d4795a02a$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: 'less than a second',
        other: 'less than {{count}} seconds'
    },
    xSeconds: {
        one: '1 second',
        other: '{{count}} seconds'
    },
    halfAMinute: 'half a minute',
    lessThanXMinutes: {
        one: 'less than a minute',
        other: 'less than {{count}} minutes'
    },
    xMinutes: {
        one: '1 minute',
        other: '{{count}} minutes'
    },
    aboutXHours: {
        one: 'about 1 hour',
        other: 'about {{count}} hours'
    },
    xHours: {
        one: '1 hour',
        other: '{{count}} hours'
    },
    xDays: {
        one: '1 day',
        other: '{{count}} days'
    },
    aboutXWeeks: {
        one: 'about 1 week',
        other: 'about {{count}} weeks'
    },
    xWeeks: {
        one: '1 week',
        other: '{{count}} weeks'
    },
    aboutXMonths: {
        one: 'about 1 month',
        other: 'about {{count}} months'
    },
    xMonths: {
        one: '1 month',
        other: '{{count}} months'
    },
    aboutXYears: {
        one: 'about 1 year',
        other: 'about {{count}} years'
    },
    xYears: {
        one: '1 year',
        other: '{{count}} years'
    },
    overXYears: {
        one: 'over 1 year',
        other: 'over {{count}} years'
    },
    almostXYears: {
        one: 'almost 1 year',
        other: 'almost {{count}} years'
    }
};
var $375b9d1d4795a02a$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $375b9d1d4795a02a$var$formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', count.toString());
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return 'in ' + result;
        else return result + ' ago';
    }
    return result;
};
var $375b9d1d4795a02a$export$2e2bcd8739ae039 = $375b9d1d4795a02a$var$formatDistance;

});

parcelRegister("ahNJv", function(module, exports) {
$parcel$export(module.exports, "default", () => $77d211d5584a5fe4$export$2e2bcd8739ae039);

var $gRTN2 = parcelRequire("gRTN2");
var $77d211d5584a5fe4$var$dateFormats = {
    full: 'EEEE, MMMM do, y',
    long: 'MMMM do, y',
    medium: 'MMM d, y',
    short: 'MM/dd/yyyy'
};
var $77d211d5584a5fe4$var$timeFormats = {
    full: 'h:mm:ss a zzzz',
    long: 'h:mm:ss a z',
    medium: 'h:mm:ss a',
    short: 'h:mm a'
};
var $77d211d5584a5fe4$var$dateTimeFormats = {
    full: "{{date}} 'at' {{time}}",
    long: "{{date}} 'at' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var $77d211d5584a5fe4$var$formatLong = {
    date: (0, $gRTN2.default)({
        formats: $77d211d5584a5fe4$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $gRTN2.default)({
        formats: $77d211d5584a5fe4$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $gRTN2.default)({
        formats: $77d211d5584a5fe4$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $77d211d5584a5fe4$export$2e2bcd8739ae039 = $77d211d5584a5fe4$var$formatLong;

});
parcelRegister("gRTN2", function(module, exports) {
$parcel$export(module.exports, "default", () => $c47cdf46143cf257$export$2e2bcd8739ae039);
function $c47cdf46143cf257$export$2e2bcd8739ae039(args) {
    return function() {
        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        // TODO: Remove String()
        var width = options.width ? String(options.width) : args.defaultWidth;
        var format = args.formats[width] || args.formats[args.defaultWidth];
        return format;
    };
}

});


parcelRegister("gDIZM", function(module, exports) {
$parcel$export(module.exports, "default", () => $c1d3310b86293409$export$2e2bcd8739ae039);
var $c1d3310b86293409$var$formatRelativeLocale = {
    lastWeek: "'last' eeee 'at' p",
    yesterday: "'yesterday at' p",
    today: "'today at' p",
    tomorrow: "'tomorrow at' p",
    nextWeek: "eeee 'at' p",
    other: 'P'
};
var $c1d3310b86293409$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $c1d3310b86293409$var$formatRelativeLocale[token];
};
var $c1d3310b86293409$export$2e2bcd8739ae039 = $c1d3310b86293409$var$formatRelative;

});

parcelRegister("7FeVe", function(module, exports) {
$parcel$export(module.exports, "default", () => $5947eff4b1161ed6$export$2e2bcd8739ae039);

var $83k1i = parcelRequire("83k1i");
var $5947eff4b1161ed6$var$eraValues = {
    narrow: [
        'B',
        'A'
    ],
    abbreviated: [
        'BC',
        'AD'
    ],
    wide: [
        'Before Christ',
        'Anno Domini'
    ]
};
var $5947eff4b1161ed6$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'Q1',
        'Q2',
        'Q3',
        'Q4'
    ],
    wide: [
        '1st quarter',
        '2nd quarter',
        '3rd quarter',
        '4th quarter'
    ]
};
// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
var $5947eff4b1161ed6$var$monthValues = {
    narrow: [
        'J',
        'F',
        'M',
        'A',
        'M',
        'J',
        'J',
        'A',
        'S',
        'O',
        'N',
        'D'
    ],
    abbreviated: [
        'Jan',
        'Feb',
        'Mar',
        'Apr',
        'May',
        'Jun',
        'Jul',
        'Aug',
        'Sep',
        'Oct',
        'Nov',
        'Dec'
    ],
    wide: [
        'January',
        'February',
        'March',
        'April',
        'May',
        'June',
        'July',
        'August',
        'September',
        'October',
        'November',
        'December'
    ]
};
var $5947eff4b1161ed6$var$dayValues = {
    narrow: [
        'S',
        'M',
        'T',
        'W',
        'T',
        'F',
        'S'
    ],
    short: [
        'Su',
        'Mo',
        'Tu',
        'We',
        'Th',
        'Fr',
        'Sa'
    ],
    abbreviated: [
        'Sun',
        'Mon',
        'Tue',
        'Wed',
        'Thu',
        'Fri',
        'Sat'
    ],
    wide: [
        'Sunday',
        'Monday',
        'Tuesday',
        'Wednesday',
        'Thursday',
        'Friday',
        'Saturday'
    ]
};
var $5947eff4b1161ed6$var$dayPeriodValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: 'mi',
        noon: 'n',
        morning: 'morning',
        afternoon: 'afternoon',
        evening: 'evening',
        night: 'night'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'midnight',
        noon: 'noon',
        morning: 'morning',
        afternoon: 'afternoon',
        evening: 'evening',
        night: 'night'
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: 'midnight',
        noon: 'noon',
        morning: 'morning',
        afternoon: 'afternoon',
        evening: 'evening',
        night: 'night'
    }
};
var $5947eff4b1161ed6$var$formattingDayPeriodValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: 'mi',
        noon: 'n',
        morning: 'in the morning',
        afternoon: 'in the afternoon',
        evening: 'in the evening',
        night: 'at night'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'midnight',
        noon: 'noon',
        morning: 'in the morning',
        afternoon: 'in the afternoon',
        evening: 'in the evening',
        night: 'at night'
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: 'midnight',
        noon: 'noon',
        morning: 'in the morning',
        afternoon: 'in the afternoon',
        evening: 'in the evening',
        night: 'at night'
    }
};
var $5947eff4b1161ed6$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    // If ordinal numbers depend on context, for example,
    // if they are different for different grammatical genders,
    // use `options.unit`.
    //
    // `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
    // 'day', 'hour', 'minute', 'second'.
    var rem100 = number % 100;
    if (rem100 > 20 || rem100 < 10) switch(rem100 % 10){
        case 1:
            return number + 'st';
        case 2:
            return number + 'nd';
        case 3:
            return number + 'rd';
    }
    return number + 'th';
};
var $5947eff4b1161ed6$var$localize = {
    ordinalNumber: $5947eff4b1161ed6$var$ordinalNumber,
    era: (0, $83k1i.default)({
        values: $5947eff4b1161ed6$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $83k1i.default)({
        values: $5947eff4b1161ed6$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $83k1i.default)({
        values: $5947eff4b1161ed6$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $83k1i.default)({
        values: $5947eff4b1161ed6$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $83k1i.default)({
        values: $5947eff4b1161ed6$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $5947eff4b1161ed6$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $5947eff4b1161ed6$export$2e2bcd8739ae039 = $5947eff4b1161ed6$var$localize;

});
parcelRegister("83k1i", function(module, exports) {
$parcel$export(module.exports, "default", () => $5dce2210a76ca40b$export$2e2bcd8739ae039);
function $5dce2210a76ca40b$export$2e2bcd8739ae039(args) {
    return function(dirtyIndex, options) {
        var context = options !== null && options !== void 0 && options.context ? String(options.context) : 'standalone';
        var valuesArray;
        if (context === 'formatting' && args.formattingValues) {
            var defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
            var width = options !== null && options !== void 0 && options.width ? String(options.width) : defaultWidth;
            valuesArray = args.formattingValues[width] || args.formattingValues[defaultWidth];
        } else {
            var _defaultWidth = args.defaultWidth;
            var _width = options !== null && options !== void 0 && options.width ? String(options.width) : args.defaultWidth;
            valuesArray = args.values[_width] || args.values[_defaultWidth];
        }
        var index = args.argumentCallback ? args.argumentCallback(dirtyIndex) : dirtyIndex;
        // @ts-ignore: For some reason TypeScript just don't want to match it, no matter how hard we try. I challenge you to try to remove it!
        return valuesArray[index];
    };
}

});


parcelRegister("lnVAk", function(module, exports) {
$parcel$export(module.exports, "default", () => $f9186a1db6e5c4a1$export$2e2bcd8739ae039);

var $ccU9y = parcelRequire("ccU9y");

var $cK9IB = parcelRequire("cK9IB");
var $f9186a1db6e5c4a1$var$matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
var $f9186a1db6e5c4a1$var$parseOrdinalNumberPattern = /\d+/i;
var $f9186a1db6e5c4a1$var$matchEraPatterns = {
    narrow: /^(b|a)/i,
    abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
    wide: /^(before christ|before common era|anno domini|common era)/i
};
var $f9186a1db6e5c4a1$var$parseEraPatterns = {
    any: [
        /^b/i,
        /^(a|c)/i
    ]
};
var $f9186a1db6e5c4a1$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234](th|st|nd|rd)? quarter/i
};
var $f9186a1db6e5c4a1$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $f9186a1db6e5c4a1$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
    wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
};
var $f9186a1db6e5c4a1$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^may/i,
        /^jun/i,
        /^jul/i,
        /^au/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var $f9186a1db6e5c4a1$var$matchDayPatterns = {
    narrow: /^[smtwf]/i,
    short: /^(su|mo|tu|we|th|fr|sa)/i,
    abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
    wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
};
var $f9186a1db6e5c4a1$var$parseDayPatterns = {
    narrow: [
        /^s/i,
        /^m/i,
        /^t/i,
        /^w/i,
        /^t/i,
        /^f/i,
        /^s/i
    ],
    any: [
        /^su/i,
        /^m/i,
        /^tu/i,
        /^w/i,
        /^th/i,
        /^f/i,
        /^sa/i
    ]
};
var $f9186a1db6e5c4a1$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
    any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
};
var $f9186a1db6e5c4a1$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^mi/i,
        noon: /^no/i,
        morning: /morning/i,
        afternoon: /afternoon/i,
        evening: /evening/i,
        night: /night/i
    }
};
var $f9186a1db6e5c4a1$var$match = {
    ordinalNumber: (0, $cK9IB.default)({
        matchPattern: $f9186a1db6e5c4a1$var$matchOrdinalNumberPattern,
        parsePattern: $f9186a1db6e5c4a1$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $ccU9y.default)({
        matchPatterns: $f9186a1db6e5c4a1$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $f9186a1db6e5c4a1$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $ccU9y.default)({
        matchPatterns: $f9186a1db6e5c4a1$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $f9186a1db6e5c4a1$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $ccU9y.default)({
        matchPatterns: $f9186a1db6e5c4a1$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $f9186a1db6e5c4a1$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $ccU9y.default)({
        matchPatterns: $f9186a1db6e5c4a1$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $f9186a1db6e5c4a1$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $ccU9y.default)({
        matchPatterns: $f9186a1db6e5c4a1$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $f9186a1db6e5c4a1$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $f9186a1db6e5c4a1$export$2e2bcd8739ae039 = $f9186a1db6e5c4a1$var$match;

});
parcelRegister("ccU9y", function(module, exports) {
$parcel$export(module.exports, "default", () => $8e3229d5e3730694$export$2e2bcd8739ae039);
function $8e3229d5e3730694$export$2e2bcd8739ae039(args) {
    return function(string) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var width = options.width;
        var matchPattern = width && args.matchPatterns[width] || args.matchPatterns[args.defaultMatchWidth];
        var matchResult = string.match(matchPattern);
        if (!matchResult) return null;
        var matchedString = matchResult[0];
        var parsePatterns = width && args.parsePatterns[width] || args.parsePatterns[args.defaultParseWidth];
        var key = Array.isArray(parsePatterns) ? $8e3229d5e3730694$var$findIndex(parsePatterns, function(pattern) {
            return pattern.test(matchedString);
        }) : $8e3229d5e3730694$var$findKey(parsePatterns, function(pattern) {
            return pattern.test(matchedString);
        });
        var value;
        value = args.valueCallback ? args.valueCallback(key) : key;
        value = options.valueCallback ? options.valueCallback(value) : value;
        var rest = string.slice(matchedString.length);
        return {
            value: value,
            rest: rest
        };
    };
}
function $8e3229d5e3730694$var$findKey(object, predicate) {
    for(var key in object){
        if (object.hasOwnProperty(key) && predicate(object[key])) return key;
    }
    return undefined;
}
function $8e3229d5e3730694$var$findIndex(array, predicate) {
    for(var key = 0; key < array.length; key++){
        if (predicate(array[key])) return key;
    }
    return undefined;
}

});

parcelRegister("cK9IB", function(module, exports) {
$parcel$export(module.exports, "default", () => $947151ce158834f0$export$2e2bcd8739ae039);
function $947151ce158834f0$export$2e2bcd8739ae039(args) {
    return function(string) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var matchResult = string.match(args.matchPattern);
        if (!matchResult) return null;
        var matchedString = matchResult[0];
        var parseResult = string.match(args.parsePattern);
        if (!parseResult) return null;
        var value = args.valueCallback ? args.valueCallback(parseResult[0]) : parseResult[0];
        value = options.valueCallback ? options.valueCallback(value) : value;
        var rest = string.slice(matchedString.length);
        return {
            value: value,
            rest: rest
        };
    };
}

});





parcelRegister("jFSmD", function(module, exports) {
$parcel$export(module.exports, "default", () => $e52c043a8c37f173$export$2e2bcd8739ae039);

var $k0voR = parcelRequire("k0voR");

var $6VRvY = parcelRequire("6VRvY");

var $f1PiG = parcelRequire("f1PiG");

var $aCKXn = parcelRequire("aCKXn");

var $kxaUN = parcelRequire("kxaUN");
function $e52c043a8c37f173$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $aCKXn.default)(2, arguments);
    var dateLeft = (0, $k0voR.default)(dirtyDateLeft);
    var dateRight = (0, $k0voR.default)(dirtyDateRight);
    var sign = (0, $f1PiG.default)(dateLeft, dateRight);
    var difference = Math.abs((0, $6VRvY.default)(dateLeft, dateRight));
    var result;
    // Check for the difference of less than month
    if (difference < 1) result = 0;
    else {
        if (dateLeft.getMonth() === 1 && dateLeft.getDate() > 27) // This will check if the date is end of Feb and assign a higher end of month date
        // to compare it with Jan
        dateLeft.setDate(30);
        dateLeft.setMonth(dateLeft.getMonth() - sign * difference);
        // Math.abs(diff in full months - diff in calendar months) === 1 if last calendar month is not full
        // If so, result must be decreased by 1 in absolute value
        var isLastMonthNotFull = (0, $f1PiG.default)(dateLeft, dateRight) === -sign;
        // Check for cases of one full calendar month
        if ((0, $kxaUN.default)((0, $k0voR.default)(dirtyDateLeft)) && difference === 1 && (0, $f1PiG.default)(dirtyDateLeft, dateRight) === 1) isLastMonthNotFull = false;
        result = sign * (difference - Number(isLastMonthNotFull));
    }
    // Prevent negative zero
    return result === 0 ? 0 : result;
}

});
parcelRegister("6VRvY", function(module, exports) {
$parcel$export(module.exports, "default", () => $50c193dba9e9d232$export$2e2bcd8739ae039);

var $k0voR = parcelRequire("k0voR");

var $aCKXn = parcelRequire("aCKXn");
function $50c193dba9e9d232$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $aCKXn.default)(2, arguments);
    var dateLeft = (0, $k0voR.default)(dirtyDateLeft);
    var dateRight = (0, $k0voR.default)(dirtyDateRight);
    var yearDiff = dateLeft.getFullYear() - dateRight.getFullYear();
    var monthDiff = dateLeft.getMonth() - dateRight.getMonth();
    return yearDiff * 12 + monthDiff;
}

});

parcelRegister("f1PiG", function(module, exports) {
$parcel$export(module.exports, "default", () => $af0ebe31987a3d84$export$2e2bcd8739ae039);

var $k0voR = parcelRequire("k0voR");

var $aCKXn = parcelRequire("aCKXn");
function $af0ebe31987a3d84$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $aCKXn.default)(2, arguments);
    var dateLeft = (0, $k0voR.default)(dirtyDateLeft);
    var dateRight = (0, $k0voR.default)(dirtyDateRight);
    var diff = dateLeft.getTime() - dateRight.getTime();
    if (diff < 0) return -1;
    else if (diff > 0) return 1;
    else return diff;
}

});

parcelRegister("kxaUN", function(module, exports) {
$parcel$export(module.exports, "default", () => $ef2f5b3ead9ab5f6$export$2e2bcd8739ae039);

var $k0voR = parcelRequire("k0voR");

var $irIjK = parcelRequire("irIjK");

var $8lyaI = parcelRequire("8lyaI");

var $aCKXn = parcelRequire("aCKXn");
function $ef2f5b3ead9ab5f6$export$2e2bcd8739ae039(dirtyDate) {
    (0, $aCKXn.default)(1, arguments);
    var date = (0, $k0voR.default)(dirtyDate);
    return (0, $irIjK.default)(date).getTime() === (0, $8lyaI.default)(date).getTime();
}

});
parcelRegister("irIjK", function(module, exports) {
$parcel$export(module.exports, "default", () => $d6dd202322c3020b$export$2e2bcd8739ae039);

var $k0voR = parcelRequire("k0voR");

var $aCKXn = parcelRequire("aCKXn");
function $d6dd202322c3020b$export$2e2bcd8739ae039(dirtyDate) {
    (0, $aCKXn.default)(1, arguments);
    var date = (0, $k0voR.default)(dirtyDate);
    date.setHours(23, 59, 59, 999);
    return date;
}

});

parcelRegister("8lyaI", function(module, exports) {
$parcel$export(module.exports, "default", () => $613acab57adee5b1$export$2e2bcd8739ae039);

var $k0voR = parcelRequire("k0voR");

var $aCKXn = parcelRequire("aCKXn");
function $613acab57adee5b1$export$2e2bcd8739ae039(dirtyDate) {
    (0, $aCKXn.default)(1, arguments);
    var date = (0, $k0voR.default)(dirtyDate);
    var month = date.getMonth();
    date.setFullYear(date.getFullYear(), month + 1, 0);
    date.setHours(23, 59, 59, 999);
    return date;
}

});



parcelRegister("4kNYI", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => (parcelRequire("ivhAr")).default);
$parcel$export(module.exports, "Icon", () => (parcelRequire("ivhAr")).Icon);

var $ivhAr = parcelRequire("ivhAr");

});
parcelRegister("ivhAr", function(module, exports) {
$parcel$export(module.exports, "Icon", () => $d788c39db3f7fcff$export$f04a61298a47a40f);
$parcel$export(module.exports, "default", () => $d788c39db3f7fcff$export$2e2bcd8739ae039);
/* icon-new.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $5FkrB = parcelRequire("5FkrB");

var $jHdWv = parcelRequire("jHdWv");
/**
 * We are hiding this props from consumers as it's reserved for use by Icon Tile.
 */ var $d788c39db3f7fcff$var$svgStyles = null;
var $d788c39db3f7fcff$var$iconStyles = null;
var $d788c39db3f7fcff$var$smallIconStyles = null;
var $d788c39db3f7fcff$var$scaleStyles = null;
/**
 * For windows high contrast mode
 */ var $d788c39db3f7fcff$var$baseHcmStyles = null;
var $d788c39db3f7fcff$var$scaleSize = null;
var $d788c39db3f7fcff$var$coreSizeMedium = {
    none: "_1bsbpxbi _4t3ipxbi",
    compact: "_1bsb1ejb _4t3i1ejb",
    spacious: "_1bsb1ejb _4t3i1ejb"
};
var $d788c39db3f7fcff$var$coreSizeSmall = {
    none: "_1bsbutpp _4t3iutpp",
    compact: "_1bsbpxbi _4t3ipxbi",
    spacious: "_1bsb1ejb _4t3i1ejb"
};
var $d788c39db3f7fcff$var$paddingMap = {
    medium: {
        none: 0,
        compact: 4,
        spacious: 4
    },
    small: {
        none: 0,
        compact: 2.66,
        spacious: 8
    }
};
var $d788c39db3f7fcff$export$f04a61298a47a40f = /*#__PURE__*/ (0, $5FkrB.memo)(function Icon(props) {
    var _ref = props, _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, testId = _ref.testId, label = _ref.label, dangerouslySetGlyph = _ref.dangerouslySetGlyph, shouldScale = _ref.shouldScale, _ref$spacing = _ref.spacing, spacing = _ref$spacing === void 0 ? 'none' : _ref$spacing, name = _ref.name;
    var dangerouslySetInnerHTML = dangerouslySetGlyph ? {
        __html: dangerouslySetGlyph
    } : undefined;
    var size = 'medium';
    if ('size' in props && props.size !== undefined) {
        if (typeof props.size === 'string') size = props.size === 'small' || props.size === 'medium' ? props.size : size;
        else if (name) {
            var newSize = props.size(name);
            size = newSize === 'small' || newSize === 'medium' ? newSize : size;
        }
    }
    var baseSize = 16;
    var viewBoxPadding = $d788c39db3f7fcff$var$paddingMap[size][spacing];
    var viewBoxSize = baseSize + 2 * viewBoxPadding;
    return /*#__PURE__*/ $5FkrB.createElement("span", {
        "data-testid": testId,
        role: label ? 'img' : undefined,
        "aria-label": label ? label : undefined,
        "aria-hidden": label ? undefined : true,
        style: {
            color: color
        },
        className: (0, $jHdWv.default)([
            "_1e0c1o8l _vchhusvi _1o9zidpf _vwz4kb7n _y4ti1igz _bozg1mb9",
            "_12va1onz _jcxd1r8n",
            shouldScale && "_1bsb1kw7 _4t3i1kw7",
            size === 'small' && "_vwz4utpp"
        ])
    }, /*#__PURE__*/ $5FkrB.createElement("svg", {
        fill: "none",
        viewBox: "".concat(0 - viewBoxPadding, " ").concat(0 - viewBoxPadding, " ").concat(viewBoxSize, " ").concat(viewBoxSize),
        role: "presentation",
        dangerouslySetInnerHTML: dangerouslySetInnerHTML,
        className: (0, $jHdWv.default)([
            "_1reo15vq _18m915vq _syaz1r31 _lcxvglyw _s7n4yfq0 _vc881r31",
            shouldScale ? "_1bsb1kw7 _4t3i1kw7" : size === 'small' ? $d788c39db3f7fcff$var$coreSizeSmall[spacing] : $d788c39db3f7fcff$var$coreSizeMedium[spacing]
        ])
    }));
});
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$d788c39db3f7fcff$export$2e2bcd8739ae039 = $d788c39db3f7fcff$export$f04a61298a47a40f;

});
parcelRegister("jHdWv", function(module, exports) {
$parcel$export(module.exports, "default", () => $e56cd93679199227$export$2e2bcd8739ae039);
/**
 * This length includes the underscore,
 * e.g. `"_1s4A"` would be a valid atomic group hash.
 */ const $e56cd93679199227$var$ATOMIC_GROUP_LENGTH = 5;
function $e56cd93679199227$export$2e2bcd8739ae039(classNames) {
    // Shortcut: nothing to do
    if (!classNames.length) return;
    // Shortcut: don't need to do anything if we only have a single classname
    if (classNames.length === 1 && classNames[0] && // checking to see if `classNames[0]` is a string that contains other classnames
    !classNames[0].includes(' ')) return classNames[0];
    // Using an object rather than a `Map` as it performed better in our benchmarks.
    // Would be happy to move to `Map` if it proved to be better under real conditions.
    const map = {};
    // Note: using loops to minimize iterations over the collection
    for (const value of classNames){
        // Exclude all falsy values, which leaves us with populated strings
        if (!value) continue;
        // a `value` can contain multiple classnames
        const list = value.split(' ');
        for (const className of list){
            /**
             * For atomic style classnames: the `key` is the `group`
             *
             * - Later atomic classnames with the same `group` will override earlier ones
             *   (which is what we want).
             * - Assumes atomic classnames are the only things that start with `_`
             * - Could use a regex to ensure that atomic classnames are structured how we expect,
             *   but did not add that for now as it did slow things down a bit.
             *
             * For other classnames: the `key` is the whole classname
             * - Okay to remove duplicates as doing so does not impact specificity
             *
             * */ const key = className.startsWith('_') ? className.slice(0, $e56cd93679199227$var$ATOMIC_GROUP_LENGTH) : className;
            map[key] = className;
        }
    }
    /**
     * We are converting the `map` into a string.
     *
     * The simple way to do this would be `Object.values(map).join(' ')`.
     * However, the approach below performs 10%-20% better in benchmarks.
     *
     * For `ax()` it feels right to squeeze as much runtime performance out as we can.
     */ let result = '';
    for(const key in map)result += map[key] + ' ';
    // If we have an empty string, then our `map` was empty.
    if (!result) return;
    // remove last " " from the result (we added " " at the end of every value)
    return result.trimEnd();
}

});



parcelRegister("288ej", function(module, exports) {
$parcel$export(module.exports, "default", () => $18d2b661453c9380$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $25nEq = parcelRequire("25nEq");

var $kqp0i = parcelRequire("kqp0i");

var $iYJcE = parcelRequire("iYJcE");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");

var $kJ5MV = parcelRequire("kJ5MV");

var $aEyq6 = parcelRequire("aEyq6");

var $j3kOz = parcelRequire("j3kOz");

var $7wsxK = parcelRequire("7wsxK");

var $dn7kA = parcelRequire("dn7kA");

var $aNF62 = parcelRequire("aNF62");
var $kctvn = parcelRequire("kctvn");

var $9Zzpd = parcelRequire("9Zzpd");

var $1XWyn = parcelRequire("1XWyn");

var $dIJOH = parcelRequire("dIJOH");

var $jHNrb = parcelRequire("jHNrb");

var $dXxxV = parcelRequire("dXxxV");

var $796iz = parcelRequire("796iz");

var $5U0GO = parcelRequire("5U0GO");
var $18d2b661453c9380$var$_excluded = [
    "appearance",
    "elemBefore",
    "isRemovable",
    "text",
    "color",
    "href",
    "removeButtonLabel",
    "testId",
    "onBeforeRemoveAction",
    "onAfterRemoveAction",
    "linkComponent",
    "migration_fallback",
    "maxWidth"
];
var $18d2b661453c9380$var$textLinkCssVar = '--ds-ctl';
var $18d2b661453c9380$var$textDefaultCssVar = '--ds-ct';
var $18d2b661453c9380$var$textActiveCssVar = '--ds-ctp';
var $18d2b661453c9380$var$backgroundHoverCssVar = '--ds-cbh';
var $18d2b661453c9380$var$backgroundActiveCssVar = '--ds-cba';
var $18d2b661453c9380$var$TagStatus = /*#__PURE__*/ function(TagStatus) {
    TagStatus["Showing"] = "showing";
    TagStatus["Removing"] = "removing";
    TagStatus["Removed"] = "removed";
    return TagStatus;
}($18d2b661453c9380$var$TagStatus || {});
var $18d2b661453c9380$var$packageName = "@atlaskit/tag";
var $18d2b661453c9380$var$packageVersion = "0.0.0-development";
var $18d2b661453c9380$var$defaultBeforeRemoveAction = function defaultBeforeRemoveAction() {
    return true;
};
/**
 * These hide the focus ring for the tag when its remove button is focused,
 * preventing a double focus ring.
 */ var $18d2b661453c9380$var$removingStyles = null;
var $18d2b661453c9380$var$RemovableTagComponent = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function(_ref, ref) {
    var appearance = _ref.appearance, _ref$elemBefore = _ref.elemBefore, elemBefore = _ref$elemBefore === void 0 ? null : _ref$elemBefore, _ref$isRemovable = _ref.isRemovable, isRemovable = _ref$isRemovable === void 0 ? true : _ref$isRemovable, _ref$text = _ref.text, text = _ref$text === void 0 ? '' : _ref$text, _ref$color = _ref.color, color = _ref$color === void 0 ? 'standard' : _ref$color, href = _ref.href, removeButtonLabel = _ref.removeButtonLabel, testId = _ref.testId, _ref$onBeforeRemoveAc = _ref.onBeforeRemoveAction, onBeforeRemoveAction = _ref$onBeforeRemoveAc === void 0 ? $18d2b661453c9380$var$defaultBeforeRemoveAction : _ref$onBeforeRemoveAc, _ref$onAfterRemoveAct = _ref.onAfterRemoveAction, onAfterRemoveAction = _ref$onAfterRemoveAct === void 0 ? (0, $7wsxK.default) : _ref$onAfterRemoveAct, linkComponent = _ref.linkComponent, migration_fallback = _ref.migration_fallback, maxWidth = _ref.maxWidth, rest = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $18d2b661453c9380$var$_excluded);
    var _useState = (0, $5FkrB.useState)($18d2b661453c9380$var$TagStatus.Showing), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), status = _useState2[0], setStatus = _useState2[1];
    var _useState3 = (0, $5FkrB.useState)(false), _useState4 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState3, 2), isHoverCloseButton = _useState4[0], setIsHoverCloseButton = _useState4[1];
    var onAfterRemoveActionWithAnalytics = (0, $aEyq6.useCallbackWithAnalytics)(onAfterRemoveAction, {
        action: 'removed',
        actionSubject: 'tag',
        attributes: {
            componentName: 'tag',
            packageName: $18d2b661453c9380$var$packageName,
            packageVersion: $18d2b661453c9380$var$packageVersion
        }
    }, 'atlaskit');
    var handleRemoveComplete = (0, $5FkrB.useCallback)(function() {
        onAfterRemoveActionWithAnalytics(text);
        setStatus($18d2b661453c9380$var$TagStatus.Removed);
    }, [
        onAfterRemoveActionWithAnalytics,
        text
    ]);
    var handleRemoveRequest = (0, $5FkrB.useCallback)(function() {
        if (onBeforeRemoveAction && onBeforeRemoveAction()) handleRemoveComplete();
    }, [
        handleRemoveComplete,
        onBeforeRemoveAction
    ]);
    var onKeyPress = (0, $5FkrB.useCallback)(function(e) {
        var spacebarOrEnter = e.key === ' ' || e.key === 'Enter';
        if (spacebarOrEnter) {
            e.stopPropagation();
            handleRemoveRequest();
        }
    }, [
        handleRemoveRequest
    ]);
    var removingTag = (0, $5FkrB.useCallback)(function() {
        return setStatus($18d2b661453c9380$var$TagStatus.Removing);
    }, []);
    var showingTag = (0, $5FkrB.useCallback)(function() {
        return setStatus($18d2b661453c9380$var$TagStatus.Showing);
    }, []);
    var handleMouseOver = (0, $5FkrB.useCallback)(function() {
        return setIsHoverCloseButton(true);
    }, []);
    var handleMouseOut = (0, $5FkrB.useCallback)(function() {
        return setIsHoverCloseButton(false);
    }, []);
    var removeButton = isRemovable ? /*#__PURE__*/ $5FkrB.createElement((0, $5U0GO.default), {
        "aria-label": "".concat(removeButtonLabel || 'Remove', " ").concat(text),
        onClick: handleRemoveRequest,
        onFocus: removingTag,
        onBlur: showingTag,
        onKeyPress: onKeyPress,
        onMouseOver: handleMouseOver,
        onMouseOut: handleMouseOut,
        testId: "close-button-".concat(testId)
    }) : undefined;
    // Handle migration_fallback: render Lozenge when flag is off and migration_fallback is 'lozenge'
    if (migration_fallback === 'lozenge' && !(0, $9Zzpd.fg)('platform-dst-lozenge-tag-badge-visual-uplifts')) {
        var lozengeAppearance = (0, $dXxxV.getLozengeAppearance)(color);
        return /*#__PURE__*/ $5FkrB.createElement((0, $dn7kA.default), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
            appearance: lozengeAppearance,
            isBold: false,
            testId: testId
        }, rest), text);
    }
    // Use new TagNew component behind feature flag
    if ((0, $9Zzpd.fg)('platform-dst-lozenge-tag-badge-visual-uplifts')) {
        var newColor = (0, $1XWyn.colorMapping)[color || 'standard'];
        return /*#__PURE__*/ $5FkrB.createElement((0, $1XWyn.default), {
            ref: ref,
            color: newColor,
            text: text,
            elemBefore: elemBefore,
            href: href,
            testId: testId,
            isRemovable: isRemovable,
            removeButtonLabel: removeButtonLabel,
            onBeforeRemoveAction: onBeforeRemoveAction,
            onAfterRemoveAction: onAfterRemoveAction,
            maxWidth: maxWidth
        });
    }
    // Original implementation
    var content = /*#__PURE__*/ $5FkrB.createElement((0, $796iz.default), {
        elemBefore: elemBefore,
        isRemovable: isRemovable,
        text: text,
        color: color,
        href: href,
        linkComponent: linkComponent
    });
    var hoverCloseButtonColors = (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({
        backgroundColor: "var(--ds-background-neutral-subtle, #00000000)"
    }, $18d2b661453c9380$var$backgroundHoverCssVar, undefined), $18d2b661453c9380$var$backgroundActiveCssVar, undefined), $18d2b661453c9380$var$textDefaultCssVar, undefined), $18d2b661453c9380$var$textActiveCssVar, undefined), $18d2b661453c9380$var$textLinkCssVar, undefined);
    return /*#__PURE__*/ $5FkrB.createElement((0, $aNF62.default), null, !(status === $18d2b661453c9380$var$TagStatus.Removed) && /*#__PURE__*/ $5FkrB.createElement((0, $kctvn.default), null, function(motion) {
        return /*#__PURE__*/ $5FkrB.createElement((0, $dIJOH.default), {
            ref: (0, $j3kOz.default)([
                motion.ref,
                ref
            ]),
            appearance: appearance,
            color: color,
            testId: testId,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            style: isHoverCloseButton ? hoverCloseButtonColors : undefined,
            "data-removable": true,
            "data-removing": status === $18d2b661453c9380$var$TagStatus.Removing,
            "data-ishoverclosebutton": isHoverCloseButton,
            href: href,
            before: /*#__PURE__*/ $5FkrB.createElement((0, $jHNrb.default), {
                elemBefore: elemBefore
            }),
            contentElement: content,
            after: removeButton,
            className: (0, $kJ5MV.default)([
                status === $18d2b661453c9380$var$TagStatus.Removing && "_z30c1r31 _twwiglyw _1pka1o36 _bqhtfiwo"
            ])
        });
    }));
});
/**
 * __Removable tag__
 *
 * A tag labels UI objects for quick recognition and navigation.
 *
 * Once a tag has been removed, it cannot be re-rendered. Removable tags are visible in "edit" mode or in multi-select controls.
 *
 */ var $18d2b661453c9380$var$RemovableTag = /*#__PURE__*/ (0, $5FkrB.memo)($18d2b661453c9380$var$RemovableTagComponent);
var $18d2b661453c9380$export$2e2bcd8739ae039 = $18d2b661453c9380$var$RemovableTag;

});
parcelRegister("kJ5MV", function(module, exports) {
$parcel$export(module.exports, "default", () => $f16c8005d87cd023$export$2e2bcd8739ae039);
/**
 * This length includes the underscore,
 * e.g. `"_1s4A"` would be a valid atomic group hash.
 */ const $f16c8005d87cd023$var$ATOMIC_GROUP_LENGTH = 5;
function $f16c8005d87cd023$export$2e2bcd8739ae039(classNames) {
    // Shortcut: nothing to do
    if (!classNames.length) return;
    // Shortcut: don't need to do anything if we only have a single classname
    if (classNames.length === 1 && classNames[0] && // checking to see if `classNames[0]` is a string that contains other classnames
    !classNames[0].includes(' ')) return classNames[0];
    // Using an object rather than a `Map` as it performed better in our benchmarks.
    // Would be happy to move to `Map` if it proved to be better under real conditions.
    const map = {};
    // Note: using loops to minimize iterations over the collection
    for (const value of classNames){
        // Exclude all falsy values, which leaves us with populated strings
        if (!value) continue;
        // a `value` can contain multiple classnames
        const list = value.split(' ');
        for (const className of list){
            /**
             * For atomic style classnames: the `key` is the `group`
             *
             * - Later atomic classnames with the same `group` will override earlier ones
             *   (which is what we want).
             * - Assumes atomic classnames are the only things that start with `_`
             * - Could use a regex to ensure that atomic classnames are structured how we expect,
             *   but did not add that for now as it did slow things down a bit.
             *
             * For other classnames: the `key` is the whole classname
             * - Okay to remove duplicates as doing so does not impact specificity
             *
             * */ const key = className.startsWith('_') ? className.slice(0, $f16c8005d87cd023$var$ATOMIC_GROUP_LENGTH) : className;
            map[key] = className;
        }
    }
    /**
     * We are converting the `map` into a string.
     *
     * The simple way to do this would be `Object.values(map).join(' ')`.
     * However, the approach below performs 10%-20% better in benchmarks.
     *
     * For `ax()` it feels right to squeeze as much runtime performance out as we can.
     */ let result = '';
    for(const key in map)result += map[key] + ' ';
    // If we have an empty string, then our `map` was empty.
    if (!result) return;
    // remove last " " from the result (we added " " at the end of every value)
    return result.trimEnd();
}

});

parcelRegister("aEyq6", function(module, exports) {
$parcel$export(module.exports, "useCallbackWithAnalytics", () => $7c1856e1f951263e$export$53c2b9c37c40e0d8);

var $5FkrB = parcelRequire("5FkrB");

var $7r7im = parcelRequire("7r7im");

var $jkTFo = parcelRequire("jkTFo");
var $7c1856e1f951263e$export$53c2b9c37c40e0d8 = function useCallbackWithAnalytics(method, payload, channel) {
    var _useAnalyticsEvents = (0, $7r7im.useAnalyticsEvents)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
    var methodRef = (0, $jkTFo.useTrackedRef)(method);
    var payloadRef = (0, $jkTFo.useTrackedRef)(payload);
    return (0, $5FkrB.useCallback)(function() {
        var pload = typeof payloadRef.current === 'function' ? payloadRef.current.apply(payloadRef, arguments) : payloadRef.current;
        createAnalyticsEvent(pload).fire(channel);
        methodRef.current.apply(methodRef, arguments);
    }, [
        createAnalyticsEvent,
        methodRef,
        payloadRef,
        channel
    ]);
};

});
parcelRegister("7r7im", function(module, exports) {
$parcel$export(module.exports, "useAnalyticsEvents", () => $56a0b6ad5e593ea4$export$5bf35293e545f20c);

var $dLGML = parcelRequire("dLGML");

var $hCX14 = parcelRequire("hCX14");

var $kdrD0 = parcelRequire("kdrD0");
function $56a0b6ad5e593ea4$export$5bf35293e545f20c() {
    var analyticsContext = (0, $kdrD0.useAnalyticsContext)();
    var createAnalyticsEvent = (0, $dLGML.useCallbackOne)(function(payload) {
        return new (0, $hCX14.default)({
            context: analyticsContext.getAtlaskitAnalyticsContext(),
            handlers: analyticsContext.getAtlaskitAnalyticsEventHandlers(),
            payload: payload
        });
    }, [
        analyticsContext
    ]);
    return {
        createAnalyticsEvent: createAnalyticsEvent
    };
}

});
parcelRegister("hCX14", function(module, exports) {
$parcel$export(module.exports, "default", () => $cd53c3aa63416708$export$2e2bcd8739ae039);

var $fC8ib = parcelRequire("fC8ib");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $kIXpt = parcelRequire("kIXpt");

var $cYPzS = parcelRequire("cYPzS");

var $lwlXp = parcelRequire("lwlXp");

var $eyuDe = parcelRequire("eyuDe");

var $25nEq = parcelRequire("25nEq");

var $4CFLo = parcelRequire("4CFLo");
function $cd53c3aa63416708$var$_callSuper(t, o, e) {
    return o = (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(o), (0, (/*@__PURE__*/$parcel$interopDefault($kIXpt)))(t, $cd53c3aa63416708$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(t).constructor) : o.apply(t, e));
}
function $cd53c3aa63416708$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($cd53c3aa63416708$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $cd53c3aa63416708$var$_superPropGet(t, o, e, r) {
    var p = (0, (/*@__PURE__*/$parcel$interopDefault($lwlXp)))((0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(1 & r ? t.prototype : t), o, e);
    return 2 & r && "function" == typeof p ? function(t) {
        return p.apply(e, t);
    } : p;
}
var $cd53c3aa63416708$export$35f8383928ba8d7 = function isUIAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $cd53c3aa63416708$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isUIAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === 'UIAnalyticsEvent';
};
var $cd53c3aa63416708$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_AnalyticsEvent) {
    function UIAnalyticsEvent(props) {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, UIAnalyticsEvent);
        _this = $cd53c3aa63416708$var$_callSuper(this, UIAnalyticsEvent, [
            props
        ]);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "_isUIAnalyticsEvent", true);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "clone", function() {
            if (_this.hasFired) return null;
            var context = (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(_this.context);
            var handlers = (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(_this.handlers);
            /**
       * A hacky "deep clone" of the object. This is limited in that it wont
       * support functions, regexs, Maps, Sets, etc, but none of those need to
       * be represented in our payload.
       */ var payload = JSON.parse(JSON.stringify(_this.payload));
            return new UIAnalyticsEvent({
                context: context,
                handlers: handlers,
                payload: payload
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "fire", function(channel) {
            if (_this.hasFired) return;
            _this.handlers.forEach(function(handler) {
                return handler(_this, channel);
            });
            _this.hasFired = true;
        });
        _this.context = props.context || [];
        _this.handlers = props.handlers || [];
        _this.hasFired = false;
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($eyuDe)))(UIAnalyticsEvent, _AnalyticsEvent);
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(UIAnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (this.hasFired) return this;
                return $cd53c3aa63416708$var$_superPropGet(UIAnalyticsEvent, "update", this, 3)([
                    updater
                ]);
            }
        }
    ]);
}((0, $4CFLo.default));

});
parcelRegister("4CFLo", function(module, exports) {
$parcel$export(module.exports, "default", () => $35db1b5c114e5901$export$2e2bcd8739ae039);

var $ekGgq = parcelRequire("ekGgq");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $25nEq = parcelRequire("25nEq");
function $35db1b5c114e5901$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $35db1b5c114e5901$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $35db1b5c114e5901$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $35db1b5c114e5901$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $35db1b5c114e5901$export$ad4be5c2ec28cecf = function isAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $35db1b5c114e5901$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === 'AnalyticsEvent';
};
var $35db1b5c114e5901$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function AnalyticsEvent(props) {
        var _this = this;
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, AnalyticsEvent);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "_isAnalyticsEvent", true);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "clone", function() {
            // just a shallow clone, don't change sub refs unless you want to
            // affect the original's too
            var payload = $35db1b5c114e5901$var$_objectSpread({}, _this.payload);
            return new AnalyticsEvent({
                payload: payload
            });
        });
        this.payload = props.payload;
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(AnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (typeof updater === 'function') this.payload = updater(this.payload);
                if ((0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(updater) === 'object') this.payload = $35db1b5c114e5901$var$_objectSpread($35db1b5c114e5901$var$_objectSpread({}, this.payload), updater);
                return this;
            }
        }
    ]);
}();

});


parcelRegister("kdrD0", function(module, exports) {
$parcel$export(module.exports, "useAnalyticsContext", () => $eb7a73e97b56eca6$export$d1f587f82ad51c4);

var $5FkrB = parcelRequire("5FkrB");

var $iyyOp = parcelRequire("iyyOp");
var $eb7a73e97b56eca6$export$d1f587f82ad51c4 = function useAnalyticsContext() {
    return (0, $5FkrB.useContext)((0, $iyyOp.default));
};

});


parcelRegister("jkTFo", function(module, exports) {
$parcel$export(module.exports, "useTrackedRef", () => $e13b10ce18d01343$export$1d27a74659855e44);

var $5FkrB = parcelRequire("5FkrB");
var $e13b10ce18d01343$export$1d27a74659855e44 = function useTrackedRef(value) {
    var ref = (0, $5FkrB.useRef)(value);
    ref.current = value;
    return ref;
};

});


parcelRegister("j3kOz", function(module, exports) {
$parcel$export(module.exports, "default", () => $ddee717897e0a3cd$export$2e2bcd8739ae039);

var $ekGgq = parcelRequire("ekGgq");
function $ddee717897e0a3cd$export$2e2bcd8739ae039(refs) {
    return function(value) {
        refs.forEach(function(ref) {
            if (typeof ref === 'function') ref(value);
            else if (ref !== null && (0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(ref) === 'object') ref.current = value;
        });
    };
}

});

parcelRegister("7wsxK", function(module, exports) {
$parcel$export(module.exports, "default", () => $57a1a9add194ba96$export$2e2bcd8739ae039);
/**
 * An empty function which does nothing.
 */ function $57a1a9add194ba96$export$2e2bcd8739ae039() {}

});

parcelRegister("dn7kA", function(module, exports) {
$parcel$export(module.exports, "default", () => $9bc31c28cfd17976$export$2e2bcd8739ae039);
/* lozenge.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $5FkrB = parcelRequire("5FkrB");

var $kJ5MV = parcelRequire("kJ5MV");

var $9Zzpd = parcelRequire("9Zzpd");

var $Z4guE = parcelRequire("Z4guE");
/**
 * TODO: We should be using our bounded `cssMap` here, but most of
 * these styles from the visual refresh are not in the Design System.
 */ var $9bc31c28cfd17976$var$styles = {
    container: "_2rkofajl _1reo15vq _18m915vq _1e0c116y _vchhusvi _kqswpfqs _1kz6184x _bozg1b66 _y4ti1b66",
    containerSubtle: "_1cwg1n1a",
    text: "_1reo15vq _18m915vq _ect4ttxp _1wyb1skh _zg8l4jg8 _k48pwu06 _vwz47vkz _1bto1l2s _1p1dangw _o5721q9c",
    customLetterspacing: "_1dyz9vsi",
    'bg.bold.default': "_bfhk1fkg",
    'bg.bold.inprogress': "_bfhk1ymo",
    'bg.bold.moved': "_bfhkxmjf",
    'bg.bold.new': "_bfhkshej",
    'bg.bold.removed': "_bfhk1366",
    'bg.bold.success': "_bfhk3uhp",
    'bg.subtle.default': "_bfhksm61",
    'bg.subtle.inprogress': "_bfhksm61",
    'bg.subtle.moved': "_bfhksm61",
    'bg.subtle.new': "_bfhksm61",
    'bg.subtle.removed': "_bfhksm61",
    'bg.subtle.success': "_bfhksm61",
    'outline.subtle.default': "_12ji14je _1qu2nqa1 _12y3t94y",
    'outline.subtle.inprogress': "_12jiuisw _1qu2nqa1 _12y3t94y",
    'outline.subtle.moved': "_12jih727 _1qu2nqa1 _12y3t94y",
    'outline.subtle.new': "_12ji157s _1qu2nqa1 _12y3t94y",
    'outline.subtle.removed': "_12jia2c0 _1qu2nqa1 _12y3t94y",
    'outline.subtle.success': "_12jin0nx _1qu2nqa1 _12y3t94y",
    'text.subtle': "_syazi7uo",
    'text.bold': "_syazwwip"
};
var $9bc31c28cfd17976$var$appearanceTypes = [
    'default',
    'inprogress',
    'moved',
    'new',
    'removed'
];
var $9bc31c28cfd17976$var$newSemanticColors = [
    'success',
    'discovery',
    'warning',
    'danger',
    'information',
    'neutral'
];
var $9bc31c28cfd17976$var$appearanceMapping = {
    neutral: 'default',
    default: 'default',
    information: 'inprogress',
    inprogress: 'inprogress',
    warning: 'moved',
    moved: 'moved',
    removed: 'removed',
    danger: 'removed',
    success: 'success',
    discovery: 'new',
    new: 'new'
};
/**
 * __Lozenge__
 *
 * A lozenge is a visual indicator used to highlight an item's status for quick recognition.
 *
 * - [Examples](https://atlassian.design/components/lozenge/examples)
 * - [Code](https://atlassian.design/components/lozenge/code)
 * - [Usage](https://atlassian.design/components/lozenge/usage)
 */ var $9bc31c28cfd17976$var$LegacyLozenge = /*#__PURE__*/ (0, $5FkrB.memo)(function(_ref) {
    var children = _ref.children, testId = _ref.testId, _ref$isBold = _ref.isBold, isBold = _ref$isBold === void 0 ? false : _ref$isBold, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'default' : _ref$appearance, _ref$maxWidth = _ref.maxWidth, maxWidth = _ref$maxWidth === void 0 ? 200 : _ref$maxWidth, style = _ref.style;
    var appearanceStyle = isBold ? 'bold' : 'subtle';
    var appearanceType = (0, $5FkrB.useMemo)(function() {
        return $9bc31c28cfd17976$var$appearanceTypes.includes(appearance) || $9bc31c28cfd17976$var$newSemanticColors.includes(appearance) ? $9bc31c28cfd17976$var$appearanceMapping[appearance] : 'default';
    }, [
        appearance
    ]);
    var maxWidthValue = typeof maxWidth === 'string' ? maxWidth : "".concat(maxWidth, "px");
    var maxWidthIsPc = typeof maxWidth === 'string' && /%$/.test(maxWidth);
    return /*#__PURE__*/ $5FkrB.createElement("span", {
        style: {
            backgroundColor: style === null || style === void 0 ? void 0 : style.backgroundColor,
            maxWidth: maxWidthIsPc ? maxWidth : '100%'
        },
        "data-testid": testId,
        className: (0, $kJ5MV.default)([
            $9bc31c28cfd17976$var$styles.container,
            $9bc31c28cfd17976$var$styles["bg.".concat(appearanceStyle, ".").concat(appearanceType)],
            appearanceStyle === 'subtle' && $9bc31c28cfd17976$var$styles["outline.subtle.".concat(appearanceType)],
            appearanceStyle === 'subtle' && $9bc31c28cfd17976$var$styles.containerSubtle
        ])
    }, /*#__PURE__*/ $5FkrB.createElement("span", {
        style: {
            color: style === null || style === void 0 ? void 0 : style.color,
            // to negate paddingInline specified on Box above
            maxWidth: maxWidthIsPc ? '100%' : "calc(".concat(maxWidthValue, " - ", "var(--ds-space-100, 8px)", ")")
        },
        "data-testid": testId && "".concat(testId, "--text"),
        className: (0, $kJ5MV.default)([
            $9bc31c28cfd17976$var$styles.text,
            (0, $9Zzpd.fg)('platform-lozenge-custom-letterspacing') && $9bc31c28cfd17976$var$styles.customLetterspacing,
            $9bc31c28cfd17976$var$styles["text.".concat(appearanceStyle)]
        ])
    }, children));
});
$9bc31c28cfd17976$var$LegacyLozenge.displayName = 'Lozenge';
/**
 * Wrapper component that switches between old and new Lozenge based on feature flag
 */ var $9bc31c28cfd17976$var$LozengeWrapper = /*#__PURE__*/ (0, $5FkrB.memo)(function(props) {
    if ((0, $9Zzpd.fg)('platform-dst-lozenge-tag-badge-visual-uplifts')) return /*#__PURE__*/ $5FkrB.createElement((0, $Z4guE.default), props);
    return /*#__PURE__*/ $5FkrB.createElement($9bc31c28cfd17976$var$LegacyLozenge, props);
});
$9bc31c28cfd17976$var$LozengeWrapper.displayName = 'Lozenge';
var $9bc31c28cfd17976$export$2e2bcd8739ae039 = $9bc31c28cfd17976$var$LozengeWrapper;

});
parcelRegister("Z4guE", function(module, exports) {
$parcel$export(module.exports, "default", () => $0b790190769ec95b$export$2e2bcd8739ae039);
/* lozenge.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $5FkrB = parcelRequire("5FkrB");


var $4aD98 = parcelRequire("4aD98");
/**
 * __Lozenge__
 *
 * A lozenge is a visual indicator used to highlight an item's status for quick recognition.
 *
 * - [Examples](https://atlassian.design/components/lozenge/examples)
 * - [Code](https://atlassian.design/components/lozenge/code)
 * - [Usage](https://atlassian.design/components/lozenge/usage)
 */ var $0b790190769ec95b$var$Lozenge = function Lozenge(_ref) {
    var _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'neutral' : _ref$appearance, _ref$spacing = _ref.spacing, spacing = _ref$spacing === void 0 ? 'default' : _ref$spacing, _ref$maxWidth = _ref.maxWidth, maxWidth = _ref$maxWidth === void 0 ? 200 : _ref$maxWidth, style = _ref.style, testId = _ref.testId, children = _ref.children, iconBefore = _ref.iconBefore, trailingMetric = _ref.trailingMetric, trailingMetricAppearance = _ref.trailingMetricAppearance;
    var baseProps = {
        appearance: appearance,
        spacing: spacing,
        iconBefore: iconBefore,
        trailingMetric: trailingMetric,
        trailingMetricAppearance: trailingMetricAppearance,
        maxWidth: maxWidth,
        style: style,
        testId: testId,
        children: children
    };
    return /*#__PURE__*/ $5FkrB.createElement((0, $4aD98.default), baseProps, children);
};
$0b790190769ec95b$var$Lozenge.displayName = 'Lozenge';
var $0b790190769ec95b$export$2e2bcd8739ae039 = $0b790190769ec95b$var$Lozenge;

});
parcelRegister("4aD98", function(module, exports) {
$parcel$export(module.exports, "default", () => $3096763f14d07b64$export$2e2bcd8739ae039);
/* lozenge-base.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $25nEq = parcelRequire("25nEq");

var $kqp0i = parcelRequire("kqp0i");

var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");

var $kJ5MV = parcelRequire("kJ5MV");

var $9xyyh = parcelRequire("9xyyh");

var $25cv8 = parcelRequire("25cv8");

var $fufde = parcelRequire("fufde");

var $kaW1s = parcelRequire("kaW1s");

var $9Zzpd = parcelRequire("9Zzpd");

var $83B1Q = parcelRequire("83B1Q");

var $c0EaG = parcelRequire("c0EaG");

var $5lq33 = parcelRequire("5lq33");

var $cDbLf = parcelRequire("cDbLf");
function $3096763f14d07b64$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $3096763f14d07b64$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $3096763f14d07b64$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $3096763f14d07b64$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
// Get the pressed background color for the selected lozenge dropdown trigger
var $3096763f14d07b64$var$pressedBackgroundMapping = {
    success: "var(--ds-background-success-subtler-pressed, #B3DF72)",
    warning: "var(--ds-background-warning-subtler-pressed, #FBC828)",
    danger: "var(--ds-background-danger-subtler-pressed, #FD9891)",
    information: "var(--ds-background-information-subtler-pressed, #8FB8F6)",
    neutral: "var(--ds-background-neutral-pressed, #080F214A)",
    discovery: "var(--ds-background-discovery-subtler-pressed, #D8A0F7)",
    'accent-red': "var(--ds-background-accent-red-subtler-pressed, #FD9891)",
    'accent-orange': "var(--ds-background-accent-orange-subtler-pressed, #FBC828)",
    'accent-yellow': "var(--ds-background-accent-yellow-subtler-pressed, #EED12B)",
    'accent-lime': "var(--ds-background-accent-lime-subtler-pressed, #B3DF72)",
    'accent-green': "var(--ds-background-accent-green-subtler-pressed, #7EE2B8)",
    'accent-teal': "var(--ds-background-accent-teal-subtler-pressed, #9DD9EE)",
    'accent-blue': "var(--ds-background-accent-blue-subtler-pressed, #8FB8F6)",
    'accent-purple': "var(--ds-background-accent-purple-subtler-pressed, #D8A0F7)",
    'accent-magenta': "var(--ds-background-accent-magenta-subtler-pressed, #F797D2)",
    'accent-gray': "var(--ds-background-accent-gray-subtlest-pressed, #B7B9BE)"
};
var $3096763f14d07b64$var$styles = {
    container: "_2rko12b0 _1reo15vq _18m915vq _189ee4h9 _1dqonqa1 _1h6d1j28 _kqswh2mm _1e0c116y _4cvr1h6o _vchhusvi _4t3i1k92 _1q51v77o _85i5v77o _bozg1b66 _y4ti1b66",
    motionContainer: "_k8m01rje _1oeci9qs _6fl41d08",
    containerSpacious: "_2rko1qi0 _1tkeviql _1q511b66 _85i51b66 _bozgutpp _y4tiutpp",
    containerBadgePadding: "_y4ti303w",
    text: "_11c8wadc _1reo15vq _18m915vq _o5721q9c _1bto1l2s",
    textResizing: "_1btozryt",
    textSpacious: "_11c8fhey _k48p1wq8",
    textSelected: "_syaz6x5g",
    loadingOverlay: "_1reo15vq _18m915vq _1e0c1txw _kqswstnw _4cvr1h6o _1bah1h6o _u7coze3t _152tze3t _rjxpze3t _1e02ze3t _lcxvglyw",
    metricBadgeWrapper: "_1e0c1txw",
    'metric.semantic.success': "_1bn8d6jc _4ayg1wl5",
    'metric.semantic.warning': "_1bn8bkku _4aygzr32",
    'metric.semantic.danger': "_1bn8jkmi _4ayg1r4b",
    'metric.semantic.information': "_1bn8ar1y _4ayg1c1j",
    'metric.semantic.neutral': "_1bn814je _4ayg1fkg _iymy8hz0 _16burnys",
    'metric.semantic.discovery': "_1bn85usi _4ayg18vq",
    'metric.inverse': "_1bn8vuon _4aygvuon",
    'semantic.success': "_1b3i4pcx _3wu01mps _bfhk14j0 _syaz1p1e",
    'semantic.warning': "_1b3iervl _3wu01xiv _bfhk10f4 _syazmgs1",
    'semantic.danger': "_1b3is4qr _3wu01bqt _bfhk18wg _syaz1blx",
    'semantic.information': "_1b3iyhbg _3wu0vbh5 _bfhk8lbg _syaz1qd9",
    'semantic.neutral': "_1b3i1cv2 _3wu01ihb _bfhki8nm _syazi7uo",
    'semantic.discovery': "_1b3iqm1h _3wu0v30g _bfhke670 _syaz1g72",
    'accent.red': "_1b3inbxb _3wu016y8 _bfhk1rtt _syazhwvp",
    'accent.orange': "_1b3i1j6y _3wu01b2s _bfhk165s _syaz7i1p",
    'accent.yellow': "_1b3i1oqg _3wu0feiv _bfhk1773 _syazekll",
    'accent.lime': "_1b3i8645 _3wu0nf89 _bfhkz2ec _syaz1ik3",
    'accent.green': "_1b3i17hp _3wu01crs _bfhk1wnw _syaz1y78",
    'accent.teal': "_1b3i8uof _3wu01h3o _bfhk1a17 _syaz12v7",
    'accent.blue': "_1b3i6txe _3wu01w55 _bfhk1dy8 _syaz1kyx",
    'accent.purple': "_1b3iuq3u _3wu01hqq _bfhk1nm4 _syaz1mn1",
    'accent.magenta': "_1b3iv8hk _3wu0uwd0 _bfhkv9ra _syaz1qur",
    'accent.gray': "_1b3i1diz _3wu08yml _bfhkysee _syaz1tmo",
    'interactive.semantic.success': "_irr31r82 _1di6d6jc",
    'interactive.semantic.warning': "_irr31yx4 _1di6bkku",
    'interactive.semantic.danger': "_irr370oi _1di6jkmi",
    'interactive.semantic.information': "_irr315aw _1di6ar1y",
    'interactive.semantic.neutral': "_irr3plhp _1di61gdz",
    'interactive.semantic.discovery': "_irr3rumk _1di65usi",
    'interactive.accent.red': "_irr3affd _1di61j5a",
    'interactive.accent.orange': "_irr31ei0 _1di6dpo3",
    'interactive.accent.yellow': "_irr31uw7 _1di61r9w",
    'interactive.accent.lime': "_irr31gf0 _1di62kxc",
    'interactive.accent.green': "_irr31e2h _1di6ybhx",
    'interactive.accent.teal': "_irr3kwwr _1di61jb0",
    'interactive.accent.blue': "_irr3815t _1di6rwxf",
    'interactive.accent.purple': "_irr3attl _1di63nfk",
    'interactive.accent.magenta': "_irr31axx _1di642ri",
    'interactive.accent.gray': "_irr3wejn _1di618ut",
    iconBorderFilter: "_1h6dzs9d _4uq11yqs _1k671038 _m71tr3uz _13muu67f _168qx19p _oe6mmko7 _189qkb7n _u8p61h4e _1t75u67f _hg5mr3uz _1f28f1ug _1xe213rw _1easxmrh _1r9r1ss3",
    iconBorderInteractiveFilter: "_1iel6xdd _111i1h4e _18dicjiy _hyog26zw _fdt01r5k _46v5hwvj _ylgq1r5k _bg3q9by0 _196p1btq _18mn783i _l0666xdd _pclnn8xv _ockq1r5k _aewt1n8h _4cvx7ddx _1cp21w66 _q4zt1csi _1gqs1mvc _75gv2l9f _1lh71sfd _ui3h1ct7 _11o31cha",
    containerSelected: "_1xe213kw",
    content: "_zulp1b66 _1e0c116y _4cvr1h6o",
    contentSpacious: "_zulp12x7",
    loadingContent: "_tzy4idpf",
    containerBadge: "_1ftrbpke",
    containerBadgeInteractive: "_1axm1bqy"
};
/**
 * __New Lozenge__
 *
 * A lozenge is a visual indicator used to highlight an item's status for quick recognition.
 * This is the updated version with the new North Star visual language.
 */ var $3096763f14d07b64$var$LozengeBase = /*#__PURE__*/ (0, $5FkrB.memo)(/*#__PURE__*/ (0, $5FkrB.forwardRef)(function(_ref, ref) {
    var children = _ref.children, testId = _ref.testId, appearance = _ref.appearance, iconBefore = _ref.iconBefore, trailingMetric = _ref.trailingMetric, trailingMetricAppearance = _ref.trailingMetricAppearance, _ref$maxWidth = _ref.maxWidth, maxWidth = _ref$maxWidth === void 0 ? 200 : _ref$maxWidth, _ref$spacing = _ref.spacing, spacing = _ref$spacing === void 0 ? 'default' : _ref$spacing, isSelected = _ref.isSelected, _ref$isLoading = _ref.isLoading, isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading, onClick = _ref.onClick, style = _ref.style, analyticsContext = _ref.analyticsContext, interactionName = _ref.interactionName, ariaControls = _ref['aria-controls'], ariaExpanded = _ref['aria-expanded'], ariaHaspopup = _ref['aria-haspopup'], ariaLabel = _ref['aria-label'];
    var _useState = (0, $5FkrB.useState)(false), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), resizing = _useState2[0], setResizing = _useState2[1];
    var onFinishMotion = function onFinishMotion() {
        return setResizing(false);
    };
    var resizingWidth = (0, $kaW1s.useResizingWidth)({
        duration: "var(--ds-duration-medium, 200ms)",
        easing: "var(--ds-easing-inout-bold, cubic-bezier(0.4, 0, 0, 1))",
        onFinishMotion: onFinishMotion
    });
    var isInitialRender = (0, $5FkrB.useRef)(true);
    var isInteractive = typeof onClick === 'function';
    // Determine the effective color, with fallback logic for legacy appearances
    var resolvedColor = (0, $cDbLf.resolveLozengeColor)(appearance) || 'neutral';
    var _getThemeStyles = (0, $cDbLf.getThemeStyles)(resolvedColor), category = _getThemeStyles.category, key = _getThemeStyles.key;
    var colorStyleKey = "".concat(category, ".").concat(key);
    var interactiveStyleKey = "interactive.".concat(category, ".").concat(key);
    var maxWidthValue = typeof maxWidth === 'string' ? maxWidth : "".concat(maxWidth, "px");
    var maxWidthIsPc = typeof maxWidth === 'string' && /%$/.test(maxWidth);
    var resolvedTrailingMetricAppearance = trailingMetricAppearance ? trailingMetricAppearance === 'inverse' ? 'inverse' : (0, $cDbLf.resolveLozengeColor)(trailingMetricAppearance) : resolvedColor;
    var metricBadgeAppearance = resolvedTrailingMetricAppearance === 'inverse' ? 'inverse' : resolvedTrailingMetricAppearance != null && resolvedTrailingMetricAppearance.startsWith('accent-') ? 'neutral' : resolvedTrailingMetricAppearance !== null && resolvedTrailingMetricAppearance !== void 0 ? resolvedTrailingMetricAppearance : 'neutral';
    var metricStyleKey = resolvedTrailingMetricAppearance === 'inverse' ? 'metric.inverse' : resolvedTrailingMetricAppearance != null && !resolvedTrailingMetricAppearance.startsWith('accent-') ? "metric.semantic.".concat((0, $cDbLf.getThemeStyles)(resolvedTrailingMetricAppearance).key) : 'metric.semantic.neutral';
    var commonStyleOverrides = {
        backgroundColor: style === null || style === void 0 ? void 0 : style.backgroundColor,
        maxWidth: maxWidthIsPc ? maxWidth : '100%'
    };
    var hasTrailingMetric = trailingMetric != null && trailingMetric !== '';
    var childrenKey = typeof children === 'string' ? children : undefined;
    (0, $5FkrB.useLayoutEffect)(function() {
        // Ignore initial render
        if (isInitialRender.current) {
            isInitialRender.current = false;
            return;
        }
        if ((0, $9Zzpd.fg)('platform-dst-motion-uplift')) setResizing(true);
    }, [
        childrenKey
    ]);
    var innerContent = /*#__PURE__*/ $5FkrB.createElement("span", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        style: {
            // When maxWidth is a percentage, constrain the content wrapper
            // so text truncation works correctly within the flex layout
            maxWidth: maxWidthIsPc ? '100%' : undefined
        }
    }, (0, $9Zzpd.fg)('platform-dst-motion-uplift') ? resizingWidth : undefined, {
        className: (0, $kJ5MV.default)([
            $3096763f14d07b64$var$styles.content,
            spacing === 'spacious' && $3096763f14d07b64$var$styles.contentSpacious,
            isLoading && $3096763f14d07b64$var$styles.loadingContent
        ])
    }), iconBefore && /*#__PURE__*/ $5FkrB.createElement((0, $5lq33.default), {
        size: spacing === 'spacious' ? 'medium' : 'small',
        icon: iconBefore,
        color: resolvedColor,
        testId: testId && "".concat(testId, "--icon")
    }), /*#__PURE__*/ $5FkrB.createElement("span", {
        style: {
            maxWidth: maxWidthIsPc ? undefined : "calc(".concat(maxWidthValue, " - ", "var(--ds-space-100, 8px)", ")"),
            color: style === null || style === void 0 ? void 0 : style.color
        },
        "data-testid": testId && "".concat(testId, "--text"),
        className: (0, $kJ5MV.default)([
            $3096763f14d07b64$var$styles.text,
            resizing && $3096763f14d07b64$var$styles.textResizing,
            spacing === 'spacious' && $3096763f14d07b64$var$styles.textSpacious
        ])
    }, children), hasTrailingMetric && !resolvedColor.startsWith('accent-') && /*#__PURE__*/ $5FkrB.createElement("span", {
        "data-lozenge-metric-wrapper": true,
        "data-testid": testId && "".concat(testId, "--metric"),
        className: (0, $kJ5MV.default)([
            $3096763f14d07b64$var$styles.metricBadgeWrapper
        ])
    }, /*#__PURE__*/ $5FkrB.createElement((0, $9xyyh.default), {
        appearance: metricBadgeAppearance
    }, trailingMetric)), isInteractive && /*#__PURE__*/ $5FkrB.createElement((0, (/*@__PURE__*/$parcel$interopDefault($fufde))), {
        label: "",
        size: "small",
        color: 'currentColor',
        testId: testId && "".concat(testId, "--chevron")
    }));
    if (isInteractive) return /*#__PURE__*/ $5FkrB.createElement((0, $83B1Q.default), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        ref: ref,
        xcss: (0, $25cv8.cx)($3096763f14d07b64$var$styles.container, (0, $9Zzpd.fg)('platform-dst-motion-uplift') && $3096763f14d07b64$var$styles.motionContainer, spacing === 'spacious' && $3096763f14d07b64$var$styles.containerSpacious, !isSelected && $3096763f14d07b64$var$styles.iconBorderFilter, !isLoading && $3096763f14d07b64$var$styles.iconBorderInteractiveFilter, $3096763f14d07b64$var$styles[colorStyleKey], !isLoading && $3096763f14d07b64$var$styles[interactiveStyleKey], isSelected && $3096763f14d07b64$var$styles.containerSelected, hasTrailingMetric && $3096763f14d07b64$var$styles.containerBadge, hasTrailingMetric && $3096763f14d07b64$var$styles.containerBadgeInteractive, hasTrailingMetric && $3096763f14d07b64$var$styles[metricStyleKey])
    }, isLoading && {
        'aria-busy': true,
        'aria-disabled': true,
        isDisabled: true
    }, {
        "aria-label": isLoading ? 'Loading' : ariaLabel,
        "aria-controls": ariaControls,
        "aria-expanded": ariaExpanded,
        "aria-haspopup": ariaHaspopup,
        onClick: isLoading ? undefined : onClick,
        style: $3096763f14d07b64$var$_objectSpread($3096763f14d07b64$var$_objectSpread({}, commonStyleOverrides), {}, {
            // Specified because Pressable has a default border:none which overrides the border specified on the container
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            border: "solid ".concat("var(--ds-border-width, 1px)", " ", isSelected ? 'oklch(from var(--border-color) calc(l * var(--border-pressed-l-factor)) c h) !important' : 'transparent'),
            backgroundColor: isSelected ? $3096763f14d07b64$var$pressedBackgroundMapping[resolvedColor] : undefined,
            cursor: isLoading ? 'progress' : 'pointer'
        }),
        testId: testId,
        analyticsContext: analyticsContext,
        interactionName: interactionName,
        componentName: "LozengeDropdownTrigger"
    }), innerContent, isLoading && /*#__PURE__*/ $5FkrB.createElement("span", {
        className: (0, $kJ5MV.default)([
            $3096763f14d07b64$var$styles.loadingOverlay
        ])
    }, /*#__PURE__*/ $5FkrB.createElement((0, $c0EaG.default), {
        size: spacing === 'spacious' ? 'small' : 'xsmall',
        label: ", Loading",
        testId: testId ? "".concat(testId, "--loading-spinner") : undefined
    })));
    return /*#__PURE__*/ $5FkrB.createElement("span", {
        ref: ref,
        style: commonStyleOverrides,
        "data-testid": testId,
        className: (0, $kJ5MV.default)([
            $3096763f14d07b64$var$styles.container,
            spacing === 'spacious' && $3096763f14d07b64$var$styles.containerSpacious,
            spacing !== 'spacious' && hasTrailingMetric && $3096763f14d07b64$var$styles.containerBadgePadding,
            $3096763f14d07b64$var$styles[colorStyleKey],
            hasTrailingMetric && $3096763f14d07b64$var$styles[metricStyleKey],
            $3096763f14d07b64$var$styles.iconBorderFilter,
            $3096763f14d07b64$var$styles.containerBadge
        ])
    }, innerContent);
}));
var $3096763f14d07b64$export$2e2bcd8739ae039 = $3096763f14d07b64$var$LozengeBase;

});
parcelRegister("9xyyh", function(module, exports) {
$parcel$export(module.exports, "default", () => $6f21ff64c7c9c1b8$export$2e2bcd8739ae039);
/* badge.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $5FkrB = parcelRequire("5FkrB");

var $kJ5MV = parcelRequire("kJ5MV");

var $9Zzpd = parcelRequire("9Zzpd");

var $ci1vI = parcelRequire("ci1vI");

var $HEYe2 = parcelRequire("HEYe2");

var $daL1V = parcelRequire("daL1V");
/**
 * Visual refresh colors.
 * Hardcoded hex colors are used as the they will be updated in the labelling system work and we want to avoid frequent UI changes.\
 *
 * Using separate variables as opposed to an object, to comply with UI styling standard
 * https://atlassian.design/components/eslint-plugin-ui-styling-standard/no-unsafe-values/usage#object-access
 */ var $6f21ff64c7c9c1b8$var$neutral300 = '#DDDEE1';
var $6f21ff64c7c9c1b8$var$red300 = '#FD9891';
var $6f21ff64c7c9c1b8$var$blue300 = '#8FB8F6';
var $6f21ff64c7c9c1b8$var$neutral1000 = '#292A2E';
var $6f21ff64c7c9c1b8$var$styles = {
    root: "_2rkolb4i _18zr1b66 _1e0c116y _vchhusvi _1ul91ejb _1bah1h6o _1o9zidpf _1kz6184x",
    added: "_bfhk1y9u _syazi7uo",
    default: "_bfhk1fkg _syazwwip",
    important: "_bfhk1366 _syazwwip",
    primary: "_bfhk1ymo _syazwwip",
    primaryInverted: "_bfhkvuon _syaz1oa5",
    removed: "_bfhk1gly _syazi7uo"
};
var $6f21ff64c7c9c1b8$var$badgeValueWithNegativeNumberSupported = function badgeValueWithNegativeNumberSupported(children, max) {
    return typeof children === 'number' && typeof max === 'number' ? (0, $daL1V.formatValueWithNegativeSupport)(children, max) : children;
};
/**
 * __Badge__
 *
 * This component gives you the full badge functionality and automatically formats the number you provide in \`children\`.
 *
 * - [Examples](https://atlassian.design/components/badge/examples)
 * - [Code](https://atlassian.design/components/badge/code)
 * - [Usage](https://atlassian.design/components/badge/usage)
 */ var $6f21ff64c7c9c1b8$var$Badge = /*#__PURE__*/ (0, $5FkrB.memo)(function Badge(_ref) {
    var _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'default' : _ref$appearance, _ref$children = _ref.children, children = _ref$children === void 0 ? 0 : _ref$children, _ref$max = _ref.max, max = _ref$max === void 0 ? 99 : _ref$max, style = _ref.style, testId = _ref.testId;
    if ((0, $9Zzpd.fg)('platform-dst-lozenge-tag-badge-visual-uplifts')) {
        // Map old appearance names to new ones
        var newAppearance = (0, $HEYe2.appearanceMapping)[appearance];
        return /*#__PURE__*/ $5FkrB.createElement((0, $HEYe2.default), {
            appearance: newAppearance,
            max: max,
            style: style,
            testId: testId
        }, children);
    }
    var oldAppearance = (0, $HEYe2.appearanceMappingToOld)[appearance];
    return /*#__PURE__*/ $5FkrB.createElement("span", {
        "data-testid": testId,
        style: {
            background: style === null || style === void 0 ? void 0 : style.backgroundColor,
            color: style === null || style === void 0 ? void 0 : style.color
        },
        className: (0, $kJ5MV.default)([
            $6f21ff64c7c9c1b8$var$styles.root,
            $6f21ff64c7c9c1b8$var$styles[oldAppearance]
        ])
    }, /*#__PURE__*/ $5FkrB.createElement((0, $ci1vI.default), {
        size: "small",
        align: "center",
        color: "inherit"
    }, $6f21ff64c7c9c1b8$var$badgeValueWithNegativeNumberSupported(children, max)));
});
var $6f21ff64c7c9c1b8$export$2e2bcd8739ae039 = $6f21ff64c7c9c1b8$var$Badge;

});
parcelRegister("ci1vI", function(module, exports) {
$parcel$export(module.exports, "default", () => $8f28566a9ab4b99f$export$2e2bcd8739ae039);
/* text.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $5FkrB = parcelRequire("5FkrB");

var $kJ5MV = parcelRequire("kJ5MV");

var $afMOk = parcelRequire("afMOk");

var $iasOX = parcelRequire("iasOX");

var $3C8nX = parcelRequire("3C8nX");
var $8f28566a9ab4b99f$var$asAllowlist = [
    'span',
    'p',
    'strong',
    'em'
];
/**
 * Custom hook designed to abstract the parsing of the color props and make it clearer in the future how color is reconciled between themes and tokens.
 */ var $8f28566a9ab4b99f$var$useColor = function useColor(colorProp, hasTextAncestor) {
    var surface = (0, $3C8nX.useSurface)();
    if (colorProp === 'inherit') return undefined;
    if (colorProp) return colorProp;
    if (hasTextAncestor) return undefined;
    if ($8f28566a9ab4b99f$export$2185ce37f9bdd963.hasOwnProperty(surface)) return $8f28566a9ab4b99f$export$2185ce37f9bdd963[surface];
    return 'color.text';
};
var $8f28566a9ab4b99f$var$styles = {
    root: "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _1i4qfg65",
    'as.strong': "_k48pwu06",
    'as.em': "_zg8l1m30",
    'textAlign.center': "_y3gn1h6o",
    'textAlign.end': "_y3gnh9n0",
    'textAlign.start': "_y3gnv2br",
    truncation: "_1reo15vq _18m915vq _1e0ccj1k _sudp1e54",
    breakAll: "_1nmz9jpi"
};
var $8f28566a9ab4b99f$var$fontSizeMap = {
    medium: "_11c8fhey",
    UNSAFE_small: "_11c8rymc",
    large: "_11c81d4k",
    small: "_11c8wadc"
};
var $8f28566a9ab4b99f$var$fontWeightMap = {
    bold: "_k48pwu06",
    medium: "_k48p1wq8",
    regular: "_k48pi7a9",
    semibold: "_k48p1pd9"
};
var $8f28566a9ab4b99f$var$textColorMap = {
    'color.text': "_syazi7uo",
    'color.text.accent.lime': "_syaz1tco",
    'color.text.accent.lime.bolder': "_syaz1ik3",
    'color.text.accent.red': "_syaz9lu1",
    'color.text.accent.red.bolder': "_syazhwvp",
    'color.text.accent.orange': "_syazp1lv",
    'color.text.accent.orange.bolder': "_syaz7i1p",
    'color.text.accent.yellow': "_syazfb2s",
    'color.text.accent.yellow.bolder': "_syazekll",
    'color.text.accent.green': "_syazh55r",
    'color.text.accent.green.bolder': "_syaz1y78",
    'color.text.accent.teal': "_syaz17qg",
    'color.text.accent.teal.bolder': "_syaz12v7",
    'color.text.accent.blue': "_syaz16jw",
    'color.text.accent.blue.bolder': "_syaz1kyx",
    'color.text.accent.purple': "_syazqmo9",
    'color.text.accent.purple.bolder': "_syaz1mn1",
    'color.text.accent.magenta': "_syaz1s8m",
    'color.text.accent.magenta.bolder': "_syaz1qur",
    'color.text.accent.gray': "_syaz1sqi",
    'color.text.accent.gray.bolder': "_syaz1tmo",
    'color.text.disabled': "_syaz1gmx",
    'color.text.inverse': "_syaz15cr",
    'color.text.selected': "_syaz6x5g",
    'color.text.brand': "_syaz1oa5",
    'color.text.danger': "_syaz1tmw",
    'color.text.warning': "_syaz1xn9",
    'color.text.warning.inverse': "_syaz1yd3",
    'color.text.success': "_syazgsak",
    'color.text.discovery': "_syazdv2p",
    'color.text.information': "_syazu3tg",
    'color.text.subtlest': "_syaz1rpy",
    'color.text.subtle': "_syazazsu",
    'color.link': "_syaz13af",
    'color.link.pressed': "_syaz12zz",
    'color.link.visited': "_syaz1ra0",
    'color.link.visited.pressed': "_syaz17z1"
};
var $8f28566a9ab4b99f$export$2185ce37f9bdd963 = {
    'color.background.neutral.bold': 'color.text.inverse',
    'color.background.neutral.bold.hovered': 'color.text.inverse',
    'color.background.neutral.bold.pressed': 'color.text.inverse',
    'color.background.selected.bold': 'color.text.inverse',
    'color.background.selected.bold.hovered': 'color.text.inverse',
    'color.background.selected.bold.pressed': 'color.text.inverse',
    'color.background.brand.bold': 'color.text.inverse',
    'color.background.brand.bold.hovered': 'color.text.inverse',
    'color.background.brand.bold.pressed': 'color.text.inverse',
    'color.background.brand.boldest': 'color.text.inverse',
    'color.background.brand.boldest.hovered': 'color.text.inverse',
    'color.background.brand.boldest.pressed': 'color.text.inverse',
    'color.background.danger.bold': 'color.text.inverse',
    'color.background.danger.bold.hovered': 'color.text.inverse',
    'color.background.danger.bold.pressed': 'color.text.inverse',
    'color.background.warning.bold': 'color.text.warning.inverse',
    'color.background.warning.bold.hovered': 'color.text.warning.inverse',
    'color.background.warning.bold.pressed': 'color.text.warning.inverse',
    'color.background.success.bold': 'color.text.inverse',
    'color.background.success.bold.hovered': 'color.text.inverse',
    'color.background.success.bold.pressed': 'color.text.inverse',
    'color.background.discovery.bold': 'color.text.inverse',
    'color.background.discovery.bold.hovered': 'color.text.inverse',
    'color.background.discovery.bold.pressed': 'color.text.inverse',
    'color.background.information.bold': 'color.text.inverse',
    'color.background.information.bold.hovered': 'color.text.inverse',
    'color.background.information.bold.pressed': 'color.text.inverse'
};
/**
 * __Text__
 *
 * Text is a primitive component that has the Atlassian Design System's design guidelines baked in.
 * This includes considerations for text attributes such as color, font size, font weight, and line height.
 * It renders a `span` by default.
 *
 * @internal
 */ var $8f28566a9ab4b99f$var$Text = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? 'span' : _ref$as, colorProp = _ref.color, align = _ref.align, testId = _ref.testId, id = _ref.id, size = _ref.size, weight = _ref.weight, maxLines = _ref.maxLines, xcss = _ref.xcss, children = _ref.children;
    (0, $afMOk.default)($8f28566a9ab4b99f$var$asAllowlist.includes(Component), "@atlaskit/primitives: Text received an invalid \"as\" value of \"".concat(Component, "\""));
    var hasTextAncestor = (0, $iasOX.useHasTextAncestor)();
    var color = $8f28566a9ab4b99f$var$useColor(colorProp, hasTextAncestor);
    if (!size && !hasTextAncestor) size = 'medium';
    var component = /*#__PURE__*/ $5FkrB.createElement(Component, {
        id: id,
        className: (0, $kJ5MV.default)([
            $8f28566a9ab4b99f$var$styles.root,
            size && $8f28566a9ab4b99f$var$fontSizeMap[size],
            color && $8f28566a9ab4b99f$var$textColorMap[color],
            maxLines && $8f28566a9ab4b99f$var$styles.truncation,
            maxLines === 1 && $8f28566a9ab4b99f$var$styles.breakAll,
            align && $8f28566a9ab4b99f$var$styles["textAlign.".concat(align)],
            weight && $8f28566a9ab4b99f$var$fontWeightMap[weight],
            Component === 'em' && $8f28566a9ab4b99f$var$styles['as.em'],
            Component === 'strong' && $8f28566a9ab4b99f$var$styles['as.strong'],
            xcss
        ]),
        style: {
            WebkitLineClamp: maxLines
        },
        "data-testid": testId,
        ref: ref
    }, children);
    if (hasTextAncestor) // no need to re-apply context if the text is already wrapped
    return component;
    return /*#__PURE__*/ $5FkrB.createElement((0, $iasOX.HasTextAncestorProvider), {
        value: true
    }, component);
});
var $8f28566a9ab4b99f$export$2e2bcd8739ae039 = $8f28566a9ab4b99f$var$Text;

});
parcelRegister("iasOX", function(module, exports) {
$parcel$export(module.exports, "useHasTextAncestor", () => $d39f8466225b64ea$export$9322276ec105d055);
$parcel$export(module.exports, "HasTextAncestorProvider", () => $d39f8466225b64ea$export$ae933c6cbe5643ad);

var $5FkrB = parcelRequire("5FkrB");
var $d39f8466225b64ea$var$HasTextAncestorContext = /*#__PURE__*/ (0, $5FkrB.createContext)(false);
var $d39f8466225b64ea$export$9322276ec105d055 = function useHasTextAncestor() {
    return (0, $5FkrB.useContext)($d39f8466225b64ea$var$HasTextAncestorContext);
};
var $d39f8466225b64ea$export$ae933c6cbe5643ad = $d39f8466225b64ea$var$HasTextAncestorContext.Provider;

});

parcelRegister("3C8nX", function(module, exports) {
$parcel$export(module.exports, "SurfaceContext", () => $2a1b6cdb9988b743$export$1ca2a26fecb070ae);
$parcel$export(module.exports, "useSurface", () => $2a1b6cdb9988b743$export$1aeb4f6b93c4540d);

var $5FkrB = parcelRequire("5FkrB");
var $2a1b6cdb9988b743$export$1ca2a26fecb070ae = /*#__PURE__*/ (0, $5FkrB.createContext)('elevation.surface');
var $2a1b6cdb9988b743$export$1aeb4f6b93c4540d = function useSurface() {
    return (0, $5FkrB.useContext)($2a1b6cdb9988b743$export$1ca2a26fecb070ae);
};
$2a1b6cdb9988b743$export$1ca2a26fecb070ae.displayName = 'SurfaceProvider';

});


parcelRegister("HEYe2", function(module, exports) {
$parcel$export(module.exports, "appearanceMapping", () => $0833cc217cf36684$export$d21bba0569254935);
$parcel$export(module.exports, "appearanceMappingToOld", () => $0833cc217cf36684$export$16f8cc7ac3541e83);
$parcel$export(module.exports, "default", () => $0833cc217cf36684$export$2e2bcd8739ae039);
/* badge-new.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $5FkrB = parcelRequire("5FkrB");

var $kJ5MV = parcelRequire("kJ5MV");

var $ci1vI = parcelRequire("ci1vI");

var $daL1V = parcelRequire("daL1V");
var $0833cc217cf36684$export$d21bba0569254935 = {
    added: 'success',
    removed: 'danger',
    default: 'neutral',
    primary: 'information',
    primaryInverted: 'inverse',
    important: 'danger',
    warning: 'warning',
    discovery: 'discovery',
    danger: 'danger',
    success: 'success',
    information: 'information',
    inverse: 'inverse',
    neutral: 'neutral'
};
var $0833cc217cf36684$export$16f8cc7ac3541e83 = {
    added: 'added',
    removed: 'removed',
    default: 'default',
    primary: 'primary',
    primaryInverted: 'primaryInverted',
    important: 'important',
    danger: 'removed',
    success: 'added',
    information: 'primary',
    inverse: 'primaryInverted',
    neutral: 'default',
    warning: 'default',
    discovery: 'default'
};
/* eslint-disable @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors */ // Nested selectors with data attributes are required for theme switching
var $0833cc217cf36684$var$stylesNew = {
    root: "_2rkolb4i _18zr1b66 _1rjcidpf _1e0c116y _vchhusvi _1ul91ejb _1bah1h6o _1o9zidpf _1kz6184x",
    success: "_syaz1p1e _bfhk14j0",
    danger: "_syaz1blx _bfhk18wg",
    warning: "_syazmgs1 _bfhk10f4",
    information: "_syaz1qd9 _bfhk8lbg",
    discovery: "_syaz1g72 _bfhke670",
    neutral: "_syazi7uo _bfhk7qp0",
    inverse: "_bfhkvuon _syazi7uo"
};
/* eslint-enable @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors */ var $0833cc217cf36684$var$badgeValueWithNegativeNumberSupported = function badgeValueWithNegativeNumberSupported(children, max) {
    return typeof children === 'number' && max ? (0, $daL1V.formatValue)(children, max) : children;
};
/**
 * __BadgeNew__
 *
 * New visual refresh implementation of Badge component for the labelling system.
 * This component is used when the 'platform-dst-lozenge-tag-badge-visual-uplifts' feature flag is enabled.
 *
 * Uses new appearance naming convention:
 * - success (green)
 * - danger (red)
 * - neutral (gray)
 * - information (blue)
 * - inverse (inverted colors)
 * - warning (orange/yellow)
 * - discovery (purple)
 */ var $0833cc217cf36684$var$BadgeNew = /*#__PURE__*/ (0, $5FkrB.memo)(function BadgeNew(_ref) {
    var _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'neutral' : _ref$appearance, _ref$children = _ref.children, children = _ref$children === void 0 ? 0 : _ref$children, _ref$max = _ref.max, max = _ref$max === void 0 ? 99 : _ref$max, style = _ref.style, testId = _ref.testId;
    return /*#__PURE__*/ $5FkrB.createElement("span", {
        "data-testid": testId,
        style: {
            background: style === null || style === void 0 ? void 0 : style.backgroundColor,
            color: style === null || style === void 0 ? void 0 : style.color
        },
        className: (0, $kJ5MV.default)([
            $0833cc217cf36684$var$stylesNew.root,
            $0833cc217cf36684$var$stylesNew[appearance]
        ])
    }, /*#__PURE__*/ $5FkrB.createElement((0, $ci1vI.default), {
        size: "small",
        align: "center",
        color: "inherit"
    }, $0833cc217cf36684$var$badgeValueWithNegativeNumberSupported(children, max)));
});
var $0833cc217cf36684$export$2e2bcd8739ae039 = $0833cc217cf36684$var$BadgeNew;

});
parcelRegister("daL1V", function(module, exports) {
$parcel$export(module.exports, "formatValueWithNegativeSupport", () => $9970b0b596e659c3$export$4b844743568d5983);
$parcel$export(module.exports, "formatValue", () => $9970b0b596e659c3$export$7c4d25c0c3217d8c);
function $9970b0b596e659c3$var$getSafeValueWithNegativeSupport() {
    var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    var numericValue = +value;
    // NOTE: Changing below code as this causes custom fields -ve number to show up as zero in activity timeline.
    // This will ensure it renders correctly if it is a number otherwise renders 0
    // If the value is NaN, return it as is (assuming it's a non-numeric string)
    if (isNaN(numericValue)) return value;
    // Return the numeric value, allowing negative numbers
    return numericValue;
}
function $9970b0b596e659c3$export$4b844743568d5983(value, max) {
    var safeValue = $9970b0b596e659c3$var$getSafeValueWithNegativeSupport(value);
    var safeMax = $9970b0b596e659c3$var$getSafeValueWithNegativeSupport(max);
    var hasSafeMaxValue = false;
    if (max !== undefined) hasSafeMaxValue = true;
    if (safeMax === Infinity && safeValue === Infinity) return "\u221E";
    if (hasSafeMaxValue && safeMax < safeValue) return "".concat(safeMax, "+");
    if (safeValue === Infinity) return "\u221E";
    return safeValue.toString();
}
function $9970b0b596e659c3$var$getSafeValue() {
    var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    var numericValue = +value;
    if (numericValue < 0) return 0;
    return value;
}
function $9970b0b596e659c3$export$7c4d25c0c3217d8c(value, max) {
    var safeValue = $9970b0b596e659c3$var$getSafeValue(value);
    var safeMax = $9970b0b596e659c3$var$getSafeValue(max);
    if (safeMax && safeMax < safeValue) return "".concat(safeMax, "+");
    if (safeValue === Infinity) return "\u221E";
    return safeValue.toString();
}

});



parcelRegister("25cv8", function(module, exports) {
$parcel$export(module.exports, "cx", () => $1845bee1a1da9181$export$a274e22fb40f762e);
/* index.tsx generated by @compiled/babel-plugin v0.38.1 */ parcelRequire("5FkrB");


var $cx4kN = parcelRequire("cx4kN");
var $1845bee1a1da9181$var$strictApi = (0, $cx4kN.createStrictAPI)();
var $1845bee1a1da9181$export$dbf350e5966cf602 = $1845bee1a1da9181$var$strictApi.css;
var $1845bee1a1da9181$export$eb1ecd84a24ee424 = $1845bee1a1da9181$var$strictApi.cssMap;
$1845bee1a1da9181$var$strictApi.cssMap;
var $1845bee1a1da9181$export$a274e22fb40f762e = $1845bee1a1da9181$var$strictApi.cx;
var $1845bee1a1da9181$var$XCSSProp = $1845bee1a1da9181$var$strictApi.XCSSProp; // This is to mitigate local TS error TS2315: Type 'StrictXCSSProp' is not generic.
 // Currently for some reason tsc is generating malformed .d.ts in local dev environment, below change fixes it
 /**
 * ## StrictXCSSProp
 *
 * Declare styles your component takes with all other styles marked as violations
 * by the TypeScript compiler. There are two primary use cases for xcss prop:
 *
 * - safe style overrides
 * - inverting style declarations
 *
 * Interverting style declarations is interesting for platform teams as
 * it means apps only pay for styles they use as they're now the ones who declare
 * the styles!
 *
 * The {@link StrictXCSSProp} type has generics two of which must be defined — use to explicitly
 * set what you want to maintain as API. Use {@link XCSSAllProperties} and {@link XCSSAllPseudos}
 * to enable all properties and pseudos.
 *
 * The third generic is used to declare what properties and pseudos should be required.
 *
 * ```tsx
 * interface MyComponentProps {
 *   // Color is accepted, all other properties / pseudos are considered violations.
 *   xcss?: StrictXCSSProp<'color', never>;
 *
 *   // Only background color and hover pseudo are accepted.
 *   xcss?: StrictXCSSProp<'backgroundColor', '&:hover'>;
 *
 *   // All properties are accepted, all pseudos are considered violations.
 *   xcss?: StrictXCSSProp<XCSSAllProperties, never>;
 *
 *   // All properties are accepted, only the hover pseudo is accepted.
 *   xcss?: StrictXCSSProp<XCSSAllProperties, '&:hover'>;
 *
 *   // The xcss prop is required as well as the color property. No pseudos are required.
 *   xcss: StrictXCSSProp<
 *     XCSSAllProperties,
 *     '&:hover',
 *     { requiredProperties: 'color', requiredPseudos: never }
 *   >;
 * }
 *
 * function MyComponent({ xcss }: MyComponentProps) {
 *   return <div css={{ color: 'var(--ds-text-danger)' }} className={xcss} />
 * }
 * ```
 *
 * The xcss prop works with static inline objects and the [cssMap](https://compiledcssinjs.com/docs/api-cssmap) API.
 *
 * ```jsx
 * // Declared as an inline object
 * <Component xcss={{ color: 'var(--ds-text)' }} />
 *
 * // Declared with the cssMap API
 * const styles = cssMap({ text: { color: 'var(--ds-text)' } });
 * <Component xcss={styles.text} />
 * ```
 *
 * To concatenate and conditonally apply styles use the {@link cssMap} and {@link cx} functions.
 */ 

});
parcelRegister("cx4kN", function(module, exports) {
$parcel$export(module.exports, "createStrictAPI", () => $91fbedd05d4d9259$export$39716b4af53f4ad);

var $4vCtZ = parcelRequire("4vCtZ");

var $h9yz2 = parcelRequire("h9yz2");
function $91fbedd05d4d9259$export$39716b4af53f4ad() {
    return {
        css () {
            throw (0, $4vCtZ.createStrictSetupError)();
        },
        cssMap () {
            throw (0, $4vCtZ.createStrictSetupError)();
        },
        cx: $h9yz2.cx,
        XCSSProp () {
            throw (0, $4vCtZ.createStrictSetupError)();
        }
    };
}

});
parcelRegister("4vCtZ", function(module, exports) {
$parcel$export(module.exports, "createStrictSetupError", () => $3487e88628f9f452$export$c4df1cb0c2b4d77c);
const $3487e88628f9f452$export$6c9a87045746941d = ()=>{
    return new Error(`
 \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2557}   \u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2557}     \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}
\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}
\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}   \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}  \u{2588}\u{2588}\u{2551}  \u{2588}\u{2588}\u{2551}
\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}   \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}\u{255A}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{255D} \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{255D}  \u{2588}\u{2588}\u{2551}  \u{2588}\u{2588}\u{2551}
\u{255A}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{255A}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551} \u{255A}\u{2550}\u{255D} \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}
 \u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D} \u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D} \u{255A}\u{2550}\u{255D}     \u{255A}\u{2550}\u{255D}\u{255A}\u{2550}\u{255D}     \u{255A}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}

  @compiled/react

  Code was executed when it shouldn't have. This could have happened because:

  1. You haven't configured a transformer yet. Visit https://compiledcssinjs.com/docs/installation and follow the instructions.
  2. You have duplicate versions of React and hooks are blowing up. You need to de-duplicate your dependencies.

  Good luck!
`);
};
const $3487e88628f9f452$export$c4df1cb0c2b4d77c = ()=>{
    return new Error(`
 \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2557}   \u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2557}     \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}
\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}
\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}   \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}  \u{2588}\u{2588}\u{2551}  \u{2588}\u{2588}\u{2551}
\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}   \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}\u{255A}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{255D} \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{255D}  \u{2588}\u{2588}\u{2551}  \u{2588}\u{2588}\u{2551}
\u{255A}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{255A}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551} \u{255A}\u{2550}\u{255D} \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}
 \u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D} \u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D} \u{255A}\u{2550}\u{255D}     \u{255A}\u{2550}\u{255D}\u{255A}\u{2550}\u{255D}     \u{255A}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}

  @compiled/react

  Code was executed when it shouldn't have. To resolve make sure to:

  1. Set up Compiled.
  2. Configure importSources in your Compiled config to point to the module that exports the output of createStrictAPI().

  For more information visit https://compiledcssinjs.com/docs/installation and follow the instructions.
`);
};

});

parcelRegister("h9yz2", function(module, exports) {
$parcel$export(module.exports, "cx", () => $c7ce16a3abaee16f$export$a274e22fb40f762e);

var $8kjDp = parcelRequire("8kjDp");
const $c7ce16a3abaee16f$export$a274e22fb40f762e = (...styles)=>{
    // At runtime TStyles is resolved down to strings, but not at compile time.
    // We circumvent the type system here because of that.
    const actualStyles = styles;
    // The output should be a union type of passed in styles. This ensures the call
    // site of xcss prop can raise violations when disallowed styles have been passed.
    return (0, $8kjDp.default)(actualStyles);
};

});
parcelRegister("8kjDp", function(module, exports) {
$parcel$export(module.exports, "default", () => $60ff6c00cea277aa$export$2e2bcd8739ae039);
/**
 * This length includes the underscore,
 * e.g. `"_1s4A"` would be a valid atomic group hash.
 */ const $60ff6c00cea277aa$var$ATOMIC_GROUP_LENGTH = 5;
function $60ff6c00cea277aa$export$2e2bcd8739ae039(classNames) {
    // Shortcut: nothing to do
    if (!classNames.length) return;
    // Shortcut: don't need to do anything if we only have a single classname
    if (classNames.length === 1 && classNames[0] && // checking to see if `classNames[0]` is a string that contains other classnames
    !classNames[0].includes(' ')) return classNames[0];
    // Using an object rather than a `Map` as it performed better in our benchmarks.
    // Would be happy to move to `Map` if it proved to be better under real conditions.
    const map = {};
    // Note: using loops to minimize iterations over the collection
    for (const value of classNames){
        // Exclude all falsy values, which leaves us with populated strings
        if (!value) continue;
        // a `value` can contain multiple classnames
        const list = value.split(' ');
        for (const className of list){
            /**
             * For atomic style classnames: the `key` is the `group`
             *
             * - Later atomic classnames with the same `group` will override earlier ones
             *   (which is what we want).
             * - Assumes atomic classnames are the only things that start with `_`
             * - Could use a regex to ensure that atomic classnames are structured how we expect,
             *   but did not add that for now as it did slow things down a bit.
             *
             * For other classnames: the `key` is the whole classname
             * - Okay to remove duplicates as doing so does not impact specificity
             *
             * */ const key = className.startsWith('_') ? className.slice(0, $60ff6c00cea277aa$var$ATOMIC_GROUP_LENGTH) : className;
            map[key] = className;
        }
    }
    /**
     * We are converting the `map` into a string.
     *
     * The simple way to do this would be `Object.values(map).join(' ')`.
     * However, the approach below performs 10%-20% better in benchmarks.
     *
     * For `ax()` it feels right to squeeze as much runtime performance out as we can.
     */ let result = '';
    for(const key in map)result += map[key] + ' ';
    // If we have an empty string, then our `map` was empty.
    if (!result) return;
    // remove last " " from the result (we added " " at the end of every value)
    return result.trimEnd();
}

});




parcelRegister("fufde", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d56e8662eb8a8d2462ec3a39ff3aa40b>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b465753bb15ee4c1$var$_react = $b465753bb15ee4c1$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $b465753bb15ee4c1$var$_baseNew = $b465753bb15ee4c1$var$_interopRequireDefault((parcelRequire("f28qG")));
function $b465753bb15ee4c1$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ChevronDown".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Do not use 16px chevrons within buttons, icon buttons, or dropdowns to maintain visual cohesion with ADS which uses 12px chevrons.
Known uses: Open dropdown menu, expanded tree item, collapse tree item
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $b465753bb15ee4c1$var$ChevronDownIcon = (props)=>/*#__PURE__*/ $b465753bb15ee4c1$var$_react.default.createElement($b465753bb15ee4c1$var$_baseNew.default, Object.assign({
        name: "ChevronDownIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="m14.53 6.03-6 6a.75.75 0 0 1-1.004.052l-.056-.052-6-6 1.06-1.06L8 10.44l5.47-5.47z"/>`
    }, props));
$b465753bb15ee4c1$var$ChevronDownIcon.displayName = 'ChevronDownIcon';
var $b465753bb15ee4c1$var$_default = module.exports.default = $b465753bb15ee4c1$var$ChevronDownIcon;

});
parcelRegister("f28qG", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => (parcelRequire("cgSLx")).default);
$parcel$export(module.exports, "Icon", () => (parcelRequire("cgSLx")).Icon);

var $cgSLx = parcelRequire("cgSLx");

});
parcelRegister("cgSLx", function(module, exports) {
$parcel$export(module.exports, "Icon", () => $8ef175fbb66f6c06$export$f04a61298a47a40f);
$parcel$export(module.exports, "default", () => $8ef175fbb66f6c06$export$2e2bcd8739ae039);
/* icon-new.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $5FkrB = parcelRequire("5FkrB");

var $kJ5MV = parcelRequire("kJ5MV");
/**
 * We are hiding this props from consumers as it's reserved for use by Icon Tile.
 */ var $8ef175fbb66f6c06$var$svgStyles = null;
var $8ef175fbb66f6c06$var$iconStyles = null;
var $8ef175fbb66f6c06$var$smallIconStyles = null;
var $8ef175fbb66f6c06$var$scaleStyles = null;
/**
 * For windows high contrast mode
 */ var $8ef175fbb66f6c06$var$baseHcmStyles = null;
var $8ef175fbb66f6c06$var$scaleSize = null;
var $8ef175fbb66f6c06$var$coreSizeMedium = {
    none: "_1bsbpxbi _4t3ipxbi",
    compact: "_1bsb1ejb _4t3i1ejb",
    spacious: "_1bsb1ejb _4t3i1ejb"
};
var $8ef175fbb66f6c06$var$coreSizeSmall = {
    none: "_1bsbutpp _4t3iutpp",
    compact: "_1bsbpxbi _4t3ipxbi",
    spacious: "_1bsb1ejb _4t3i1ejb"
};
var $8ef175fbb66f6c06$var$paddingMap = {
    medium: {
        none: 0,
        compact: 4,
        spacious: 4
    },
    small: {
        none: 0,
        compact: 2.66,
        spacious: 8
    }
};
var $8ef175fbb66f6c06$export$f04a61298a47a40f = /*#__PURE__*/ (0, $5FkrB.memo)(function Icon(props) {
    var _ref = props, _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, testId = _ref.testId, label = _ref.label, dangerouslySetGlyph = _ref.dangerouslySetGlyph, shouldScale = _ref.shouldScale, _ref$spacing = _ref.spacing, spacing = _ref$spacing === void 0 ? 'none' : _ref$spacing, name = _ref.name;
    var dangerouslySetInnerHTML = dangerouslySetGlyph ? {
        __html: dangerouslySetGlyph
    } : undefined;
    var size = 'medium';
    if ('size' in props && props.size !== undefined) {
        if (typeof props.size === 'string') size = props.size === 'small' || props.size === 'medium' ? props.size : size;
        else if (name) {
            var newSize = props.size(name);
            size = newSize === 'small' || newSize === 'medium' ? newSize : size;
        }
    }
    var baseSize = 16;
    var viewBoxPadding = $8ef175fbb66f6c06$var$paddingMap[size][spacing];
    var viewBoxSize = baseSize + 2 * viewBoxPadding;
    return /*#__PURE__*/ $5FkrB.createElement("span", {
        "data-testid": testId,
        role: label ? 'img' : undefined,
        "aria-label": label ? label : undefined,
        "aria-hidden": label ? undefined : true,
        style: {
            color: color
        },
        className: (0, $kJ5MV.default)([
            "_1e0c1o8l _vchhusvi _1o9zidpf _vwz4kb7n _y4ti1igz _bozg1mb9",
            "_12va1onz _jcxd1r8n",
            shouldScale && "_1bsb1kw7 _4t3i1kw7",
            size === 'small' && "_vwz4utpp"
        ])
    }, /*#__PURE__*/ $5FkrB.createElement("svg", {
        fill: "none",
        viewBox: "".concat(0 - viewBoxPadding, " ").concat(0 - viewBoxPadding, " ").concat(viewBoxSize, " ").concat(viewBoxSize),
        role: "presentation",
        dangerouslySetInnerHTML: dangerouslySetInnerHTML,
        className: (0, $kJ5MV.default)([
            "_1reo15vq _18m915vq _syaz1r31 _lcxvglyw _s7n4yfq0 _vc881r31",
            shouldScale ? "_1bsb1kw7 _4t3i1kw7" : size === 'small' ? $8ef175fbb66f6c06$var$coreSizeSmall[spacing] : $8ef175fbb66f6c06$var$coreSizeMedium[spacing]
        ])
    }));
});
var $8ef175fbb66f6c06$export$2e2bcd8739ae039 = $8ef175fbb66f6c06$export$f04a61298a47a40f;

});



parcelRegister("kaW1s", function(module, exports) {
$parcel$export(module.exports, "useResizingWidth", () => $eb01bfe6092aa328$export$84c726b6114f53f8);

var $1Vcia = parcelRequire("1Vcia");

var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");

var $ajfMB = parcelRequire("ajfMB");

var $l0j8n = parcelRequire("l0j8n");

var $kD9XE = parcelRequire("kD9XE");

var $dimES = parcelRequire("dimES");

var $ikyP9 = parcelRequire("ikyP9");
var $eb01bfe6092aa328$var$_excluded = [
    "children"
];
/**
 * Parses a CSS time value (e.g. `"0.2s"` or `"200ms"`) and returns milliseconds.
 * Falls back to 0 if the value cannot be parsed.
 */ function $eb01bfe6092aa328$var$parseCSSTimeToMs(value) {
    var parsed = parseFloat(value);
    if (Number.isNaN(parsed)) return 0;
    if (value.endsWith('ms')) return parsed;
    return parsed * 1000;
}
var $eb01bfe6092aa328$export$84c726b6114f53f8 = function useResizingWidth(_ref) {
    var duration = _ref.duration, easing = _ref.easing, onFinishMotion = _ref.onFinishMotion;
    var prevDimensions = (0, $5FkrB.useRef)();
    var _useElementRef = (0, $kD9XE.useElementRef)(), _useElementRef2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useElementRef, 2), element = _useElementRef2[0], setElementRef = _useElementRef2[1];
    var setTimeout = (0, $l0j8n.useSetTimeout)({
        cleanup: 'next-effect'
    });
    var requestAnimationFrame = (0, $l0j8n.useRequestAnimationFrame)();
    (0, $ikyP9.useSnapshotBeforeUpdate)(function() {
        if ((0, $ajfMB.isReducedMotion)() || !element) return;
        prevDimensions.current = element.getBoundingClientRect();
    });
    (0, $dimES.useLayoutEffect)(function() {
        if ((0, $ajfMB.isReducedMotion)() || !element || !prevDimensions.current) return;
        // We might already be animating.
        // Because of that we need to expand to the destination width first.
        element.setAttribute('style', '');
        var nextDimensions = element.getBoundingClientRect();
        if (nextDimensions.width === prevDimensions.current.width) {
            onFinishMotion === null || onFinishMotion === void 0 || onFinishMotion();
            return;
        }
        var newStyles = {
            width: "".concat(prevDimensions.current.width, "px"),
            willChange: 'width',
            transitionProperty: 'width',
            transitionDuration: duration,
            boxSizing: 'border-box',
            transitionTimingFunction: easing
        };
        Object.assign(element.style, newStyles);
        var resolvedDuration = $eb01bfe6092aa328$var$parseCSSTimeToMs(getComputedStyle(element).transitionDuration);
        // We split this over two animation frames so the DOM has enough time to flush the changes.
        // We are deliberately not skipping this frame if another render happens - if we do the motion doesn't finish properly.
        requestAnimationFrame(function() {
            requestAnimationFrame(function() {
                if (!element) return;
                element.style.width = "".concat(nextDimensions.width, "px");
                setTimeout(function() {
                    if (!element) return;
                    element.setAttribute('style', '');
                    onFinishMotion === null || onFinishMotion === void 0 || onFinishMotion();
                }, resolvedDuration);
            });
        });
    });
    return {
        ref: setElementRef
    };
};
var $eb01bfe6092aa328$export$5146a620d339842f = function ResizingWidth(_ref2) {
    var children = _ref2.children, props = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref2, $eb01bfe6092aa328$var$_excluded);
    var resizing = $eb01bfe6092aa328$export$84c726b6114f53f8(props);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).Fragment, null, children(resizing));
};

});
parcelRegister("ajfMB", function(module, exports) {
$parcel$export(module.exports, "isReducedMotion", () => $7817ebdf5e0785bc$export$b7baf7667a68d87c);

var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");

var $7QpUe = parcelRequire("7QpUe");
var $7817ebdf5e0785bc$var$isMatchMediaAvailable = function isMatchMediaAvailable() {
    return typeof window !== 'undefined' && 'matchMedia' in window;
};
var $7817ebdf5e0785bc$export$b7baf7667a68d87c = function isReducedMotion() {
    if (!$7817ebdf5e0785bc$var$isMatchMediaAvailable()) return false;
    var _window$matchMedia = window.matchMedia('(prefers-reduced-motion: reduce)'), matches = _window$matchMedia.matches;
    return matches;
};
var $7817ebdf5e0785bc$export$c537e63161742ce3 = function useIsReducedMotion() {
    var _useState = (0, $5FkrB.useState)($7817ebdf5e0785bc$export$b7baf7667a68d87c), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), prefersReducedMotion = _useState2[0], setPrefersReducedMotion = _useState2[1];
    (0, $5FkrB.useEffect)(function() {
        if (!$7817ebdf5e0785bc$var$isMatchMediaAvailable()) return;
        var mediaQueryList = window.matchMedia('(prefers-reduced-motion: reduce)');
        var onChange = function onChange(event) {
            return setPrefersReducedMotion(event.matches);
        };
        return (0, $7QpUe.bind)(mediaQueryList, {
            type: 'change',
            listener: onChange
        });
    }, []);
    return prefersReducedMotion;
};
var $7817ebdf5e0785bc$export$f0f789643ba5a83c = {
    '@media (prefers-reduced-motion: reduce)': {
        animation: 'none',
        transition: 'none'
    }
};
var $7817ebdf5e0785bc$export$ff7706047246b98b = function prefersReducedMotion() {
    return $7817ebdf5e0785bc$export$f0f789643ba5a83c;
};

});

parcelRegister("l0j8n", function(module, exports) {
$parcel$export(module.exports, "useRequestAnimationFrame", () => $f4a870b3ad7467aa$export$1775f27e7c8051ca);
$parcel$export(module.exports, "useSetTimeout", () => $f4a870b3ad7467aa$export$4f34107a2b00f39c);

var $5FkrB = parcelRequire("5FkrB");
// Handle both browser and Node.js environments
var $f4a870b3ad7467aa$var$getHookDeps = function getHookDeps(opts) {
    switch(opts.cleanup){
        case 'next-effect':
            return undefined;
        case 'unmount':
        default:
            return [];
    }
};
var $f4a870b3ad7467aa$export$1775f27e7c8051ca = function useRequestAnimationFrame() {
    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        cleanup: 'unmount'
    };
    var frames = (0, $5FkrB.useRef)([]);
    (0, $5FkrB.useEffect)(function() {
        return function() {
            if (frames.current.length) {
                frames.current.forEach(function(id) {
                    return cancelAnimationFrame(id);
                });
                frames.current = [];
            }
        };
    // We dynamically set this so we either clean up on the next effect - or on unmount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, $f4a870b3ad7467aa$var$getHookDeps(opts));
    return (0, $5FkrB.useCallback)(function(handler) {
        var id = requestAnimationFrame(function(time) {
            frames.current = frames.current.filter(function(frameId) {
                return frameId !== id;
            });
            handler(time);
        });
        frames.current.push(id);
    }, []);
};
var $f4a870b3ad7467aa$export$4f34107a2b00f39c = function useSetTimeout() {
    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        cleanup: 'unmount'
    };
    var timeouts = (0, $5FkrB.useRef)([]);
    (0, $5FkrB.useEffect)(function() {
        return function() {
            if (timeouts.current.length) {
                timeouts.current.forEach(function(id) {
                    return clearTimeout(id);
                });
                timeouts.current = [];
            }
        };
    // We dynamically set this so we either clean up on the next effect - or on unmount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, $f4a870b3ad7467aa$var$getHookDeps(opts));
    return (0, $5FkrB.useCallback)(function(handler, timeout) {
        for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)args[_key - 2] = arguments[_key];
        var id = setTimeout.apply(void 0, [
            function() {
                timeouts.current = timeouts.current.filter(function(timeoutId) {
                    return timeoutId !== id;
                });
                handler();
            },
            timeout
        ].concat(args));
        timeouts.current.push(id);
    }, []);
};

});

parcelRegister("kD9XE", function(module, exports) {
$parcel$export(module.exports, "useElementRef", () => $f04f2d4082e905bd$export$ff879f35a69d56b7);

var $5FkrB = parcelRequire("5FkrB");
var $f04f2d4082e905bd$export$ff879f35a69d56b7 = function useElementRef() {
    var elementRef = (0, $5FkrB.useRef)(null);
    var setRef = (0, $5FkrB.useCallback)(function(ref) {
        elementRef.current = ref;
    }, []);
    return [
        elementRef.current,
        setRef
    ];
};

});

parcelRegister("dimES", function(module, exports) {
$parcel$export(module.exports, "useLayoutEffect", () => $9ade884945f123bd$export$e5c5a5f917a5871c);

var $5FkrB = parcelRequire("5FkrB");
var $9ade884945f123bd$export$e5c5a5f917a5871c = typeof window === 'undefined' ? (0, $5FkrB.useEffect) : (0, $5FkrB.useLayoutEffect);

});

parcelRegister("ikyP9", function(module, exports) {
$parcel$export(module.exports, "useSnapshotBeforeUpdate", () => $d5851b8ce753a7bf$export$9e95200239cd148b);

var $5FkrB = parcelRequire("5FkrB");

var $dimES = parcelRequire("dimES");
var $d5851b8ce753a7bf$export$9e95200239cd148b = function useSnapshotBeforeUpdate(cb) {
    var isFirstRender = (0, $5FkrB.useRef)(true);
    if (!isFirstRender.current) cb();
    (0, $dimES.useLayoutEffect)(function() {
        isFirstRender.current = false;
    }, []);
};

});


parcelRegister("83B1Q", function(module, exports) {
$parcel$export(module.exports, "default", () => $5ddb53aa2f521636$export$2e2bcd8739ae039);

var $kqp0i = parcelRequire("kqp0i");

var $fC8ib = parcelRequire("fC8ib");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");

var $74Zh5 = parcelRequire("74Zh5");

var $TIb0j = parcelRequire("TIb0j");

var $3baOr = parcelRequire("3baOr");

var $eqVaP = parcelRequire("eqVaP");

var $4rnTn = parcelRequire("4rnTn");

var $iV0gU = parcelRequire("iV0gU");
var $5ddb53aa2f521636$var$_excluded = [
    "children",
    "backgroundColor",
    "padding",
    "paddingBlock",
    "paddingBlockStart",
    "paddingBlockEnd",
    "paddingInline",
    "paddingInlineStart",
    "paddingInlineEnd",
    "isDisabled",
    "type",
    "onClick",
    "interactionName",
    "componentName",
    "analyticsContext",
    "style",
    "testId",
    "xcss"
], $5ddb53aa2f521636$var$_excluded2 = [
    "className"
];
// This duplicates FocusRing styles from `@atlaskit/focus-ring`.
var $5ddb53aa2f521636$var$focusRingStyles = (0, $74Zh5.css)({
    '&:focus, &:focus-visible': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        outlineColor: (0, $4rnTn.borderColorMap)['color.border.focused'],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        outlineOffset: (0, $4rnTn.positiveSpaceMap)['space.025'],
        outlineStyle: 'solid',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        outlineWidth: (0, $4rnTn.borderWidthMap)['border.width.focused']
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
    '&:focus:not(:focus-visible)': {
        outline: 'none'
    },
    '@media screen and (forced-colors: active), screen and (-ms-high-contrast: active)': {
        '&:focus-visible': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
            outline: "".concat((0, $4rnTn.borderWidthMap)['border.width'], " solid")
        }
    }
});
var $5ddb53aa2f521636$var$baseStyles = (0, $74Zh5.css)({
    boxSizing: 'border-box',
    appearance: 'none',
    border: 'none'
});
var $5ddb53aa2f521636$var$enabledStyles = (0, $74Zh5.css)({
    cursor: 'pointer'
});
var $5ddb53aa2f521636$var$disabledStyles = (0, $74Zh5.css)({
    cursor: 'not-allowed'
});
/**
 * __Pressable__
 *
 * A primitive for building custom buttons.
 *
 * - [Examples](https://atlassian.design/components/primitives/pressable/examples)
 * - [Code](https://atlassian.design/components/primitives/pressable/code)
 * - [Usage](https://atlassian.design/components/primitives/pressable/usage)
 */ var $5ddb53aa2f521636$var$Pressable = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function(_ref, ref) {
    var children = _ref.children, backgroundColor = _ref.backgroundColor, padding = _ref.padding, paddingBlock = _ref.paddingBlock, paddingBlockStart = _ref.paddingBlockStart, paddingBlockEnd = _ref.paddingBlockEnd, paddingInline = _ref.paddingInline, paddingInlineStart = _ref.paddingInlineStart, paddingInlineEnd = _ref.paddingInlineEnd, isDisabled = _ref.isDisabled, _ref$type = _ref.type, type = _ref$type === void 0 ? 'button' : _ref$type, _ref$onClick = _ref.onClick, providedOnClick = _ref$onClick === void 0 ? (0, $3baOr.default) : _ref$onClick, interactionName = _ref.interactionName, componentName = _ref.componentName, analyticsContext = _ref.analyticsContext, style = _ref.style, testId = _ref.testId, xcss = _ref.xcss, htmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $5ddb53aa2f521636$var$_excluded);
    var interactionContext = (0, $5FkrB.useContext)((0, $eqVaP.default));
    var handleClick = (0, $5FkrB.useCallback)(function(e, analyticsEvent) {
        interactionContext && interactionContext.tracePress(interactionName, e.timeStamp);
        providedOnClick(e, analyticsEvent);
    }, [
        providedOnClick,
        interactionContext,
        interactionName
    ]);
    var onClick = (0, $TIb0j.usePlatformLeafEventHandler)({
        fn: handleClick,
        action: 'clicked',
        componentName: componentName || 'Pressable',
        packageName: "@atlaskit/primitives",
        packageVersion: "0.0.0-development",
        analyticsData: analyticsContext,
        actionSubject: 'button'
    });
    // This is to remove className from safeHtmlAttributes
    // @ts-expect-error className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(htmlAttributes, $5ddb53aa2f521636$var$_excluded2);
    var resolvedStyles = (0, $iV0gU.parseXcss)(xcss);
    return (0, $74Zh5.jsx)("button", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        style: style,
        ref: ref,
        className: resolvedStyles.static
    }, safeHtmlAttributes, {
        // eslint-disable-next-line react/button-has-type
        type: type,
        onClick: onClick,
        disabled: isDisabled,
        css: [
            $5ddb53aa2f521636$var$baseStyles,
            $5ddb53aa2f521636$var$focusRingStyles,
            isDisabled ? $5ddb53aa2f521636$var$disabledStyles : $5ddb53aa2f521636$var$enabledStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            backgroundColor && (0, $4rnTn.backgroundColorStylesMap)[backgroundColor],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            padding && (0, $4rnTn.paddingStylesMap).padding[padding],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlock && (0, $4rnTn.paddingStylesMap).paddingBlock[paddingBlock],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlockStart && (0, $4rnTn.paddingStylesMap).paddingBlockStart[paddingBlockStart],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlockEnd && (0, $4rnTn.paddingStylesMap).paddingBlockEnd[paddingBlockEnd],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInline && (0, $4rnTn.paddingStylesMap).paddingInline[paddingInline],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInlineStart && (0, $4rnTn.paddingStylesMap).paddingInlineStart[paddingInlineStart],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInlineEnd && (0, $4rnTn.paddingStylesMap).paddingInlineEnd[paddingInlineEnd]
        ].concat((0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(resolvedStyles.emotion || [])),
        "data-testid": testId
    }), children);
});
var $5ddb53aa2f521636$export$2e2bcd8739ae039 = $5ddb53aa2f521636$var$Pressable;

});
parcelRegister("TIb0j", function(module, exports) {
$parcel$export(module.exports, "usePlatformLeafEventHandler", () => $0a7767b2db2f25f5$export$a4687b0234b40e28);

var $25nEq = parcelRequire("25nEq");

var $5FkrB = parcelRequire("5FkrB");

var $7r7im = parcelRequire("7r7im");

var $jkTFo = parcelRequire("jkTFo");
function $0a7767b2db2f25f5$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $0a7767b2db2f25f5$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $0a7767b2db2f25f5$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $0a7767b2db2f25f5$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $0a7767b2db2f25f5$export$a4687b0234b40e28(_ref) {
    var fn = _ref.fn, action = _ref.action, componentName = _ref.componentName, actionSubject = _ref.actionSubject, packageName = _ref.packageName, packageVersion = _ref.packageVersion, analyticsData = _ref.analyticsData;
    var _useAnalyticsEvents = (0, $7r7im.useAnalyticsEvents)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
    // We put analyticsData and fn in a ref so that we don't need to break
    // memoization.
    // Generally these could be defined by consumers inline
    // and so we do this to avoid breaking memoization of useCallback
    var dataRef = (0, $jkTFo.useTrackedRef)(analyticsData);
    var fnRef = (0, $jkTFo.useTrackedRef)(fn);
    var handler = (0, $5FkrB.useCallback)(function(value) {
        var analyticsEvent = createAnalyticsEvent({
            action: action,
            actionSubject: actionSubject || componentName,
            attributes: {
                componentName: componentName,
                packageName: packageName,
                packageVersion: packageVersion
            }
        });
        // To avoid wrapping this component in AnalyticsContext we manually
        // push the parent context's meta data into the context.
        // Note: this new 'context'
        var context = $0a7767b2db2f25f5$var$_objectSpread({
            componentName: componentName,
            packageName: packageName,
            packageVersion: packageVersion
        }, dataRef.current);
        analyticsEvent.context.push(context);
        // fire an event on the atlaskit channel
        var clone = analyticsEvent.clone();
        if (clone) clone.fire('atlaskit');
        fnRef.current(value, analyticsEvent);
    }, [
        // These are strings and won't change
        action,
        componentName,
        actionSubject,
        packageName,
        packageVersion,
        // This function is memoized in the context
        createAnalyticsEvent,
        // these are a stable ref because of the useTrackedRef hook
        dataRef,
        fnRef
    ]);
    return handler;
}

});

parcelRegister("3baOr", function(module, exports) {
$parcel$export(module.exports, "default", () => $250ac950ba134333$export$2e2bcd8739ae039);
/**
 * An empty function which does nothing.
 */ function $250ac950ba134333$export$2e2bcd8739ae039() {}

});

parcelRegister("4rnTn", function(module, exports) {
$parcel$export(module.exports, "dimensionMap", () => $33bc378cd2ea8f75$export$6ccdbebca2ee545f);
$parcel$export(module.exports, "positiveSpaceMap", () => $33bc378cd2ea8f75$export$958d0ae7f2977ae4);
$parcel$export(module.exports, "allSpaceMap", () => $33bc378cd2ea8f75$export$632685d741f3dbbf);
$parcel$export(module.exports, "opacityMap", () => $33bc378cd2ea8f75$export$daf94a976c798b4f);
$parcel$export(module.exports, "shadowMap", () => $33bc378cd2ea8f75$export$7aff6e7ba39bb774);
$parcel$export(module.exports, "borderColorMap", () => $33bc378cd2ea8f75$export$1531ad5bb3fbedac);
$parcel$export(module.exports, "backgroundColorMap", () => $33bc378cd2ea8f75$export$d1d79bf68ac056bd);
$parcel$export(module.exports, "textColorMap", () => $33bc378cd2ea8f75$export$8473307aa00d6ea1);
$parcel$export(module.exports, "layerMap", () => $33bc378cd2ea8f75$export$b5f31a7e431d2eab);
$parcel$export(module.exports, "borderWidthMap", () => $33bc378cd2ea8f75$export$e1b83c5210c471b8);
$parcel$export(module.exports, "borderRadiusMap", () => $33bc378cd2ea8f75$export$3c0a6c3e64bb180d);
$parcel$export(module.exports, "fontMap", () => $33bc378cd2ea8f75$export$6ffa317d5e70375);
$parcel$export(module.exports, "fontWeightMap", () => $33bc378cd2ea8f75$export$303e322c6b1ed114);
$parcel$export(module.exports, "fontFamilyMap", () => $33bc378cd2ea8f75$export$3c7e9587132614b4);
$parcel$export(module.exports, "paddingStylesMap", () => $33bc378cd2ea8f75$export$e615f061ca585a6c);
$parcel$export(module.exports, "backgroundColorStylesMap", () => $33bc378cd2ea8f75$export$e7af83bafe7f9e63);

var $25nEq = parcelRequire("25nEq");

var $74Zh5 = parcelRequire("74Zh5");

var $ho3jH = parcelRequire("ho3jH");
function $33bc378cd2ea8f75$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $33bc378cd2ea8f75$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $33bc378cd2ea8f75$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $33bc378cd2ea8f75$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $33bc378cd2ea8f75$export$6ccdbebca2ee545f = {
    '100%': '100%',
    'size.100': '1rem',
    'size.200': '1.5rem',
    'size.300': '2rem',
    'size.400': '2.5rem',
    'size.500': '3rem',
    'size.600': '6rem',
    'size.1000': '12rem'
};
var $33bc378cd2ea8f75$export$958d0ae7f2977ae4 = {
    'space.0': "var(--ds-space-0, 0px)",
    'space.025': "var(--ds-space-025, 2px)",
    'space.050': "var(--ds-space-050, 4px)",
    'space.075': "var(--ds-space-075, 6px)",
    'space.100': "var(--ds-space-100, 8px)",
    'space.150': "var(--ds-space-150, 12px)",
    'space.200': "var(--ds-space-200, 16px)",
    'space.250': "var(--ds-space-250, 20px)",
    'space.300': "var(--ds-space-300, 24px)",
    'space.400': "var(--ds-space-400, 32px)",
    'space.500': "var(--ds-space-500, 40px)",
    'space.600': "var(--ds-space-600, 48px)",
    'space.800': "var(--ds-space-800, 64px)",
    'space.1000': "var(--ds-space-1000, 80px)"
};
var $33bc378cd2ea8f75$export$d2dc61f58390201c = {
    'space.negative.025': "var(--ds-space-negative-025, -2px)",
    'space.negative.050': "var(--ds-space-negative-050, -4px)",
    'space.negative.075': "var(--ds-space-negative-075, -6px)",
    'space.negative.100': "var(--ds-space-negative-100, -8px)",
    'space.negative.150': "var(--ds-space-negative-150, -12px)",
    'space.negative.200': "var(--ds-space-negative-200, -16px)",
    'space.negative.250': "var(--ds-space-negative-250, -20px)",
    'space.negative.300': "var(--ds-space-negative-300, -24px)",
    'space.negative.400': "var(--ds-space-negative-400, -32px)"
};
var $33bc378cd2ea8f75$export$632685d741f3dbbf = $33bc378cd2ea8f75$var$_objectSpread($33bc378cd2ea8f75$var$_objectSpread({}, $33bc378cd2ea8f75$export$958d0ae7f2977ae4), $33bc378cd2ea8f75$export$d2dc61f58390201c);
var $33bc378cd2ea8f75$export$2185ce37f9bdd963 = {
    'color.background.neutral.bold': 'color.text.inverse',
    'color.background.neutral.bold.hovered': 'color.text.inverse',
    'color.background.neutral.bold.pressed': 'color.text.inverse',
    'color.background.selected.bold': 'color.text.inverse',
    'color.background.selected.bold.hovered': 'color.text.inverse',
    'color.background.selected.bold.pressed': 'color.text.inverse',
    'color.background.brand.bold': 'color.text.inverse',
    'color.background.brand.bold.hovered': 'color.text.inverse',
    'color.background.brand.bold.pressed': 'color.text.inverse',
    'color.background.brand.boldest': 'color.text.inverse',
    'color.background.brand.boldest.hovered': 'color.text.inverse',
    'color.background.brand.boldest.pressed': 'color.text.inverse',
    'color.background.danger.bold': 'color.text.inverse',
    'color.background.danger.bold.hovered': 'color.text.inverse',
    'color.background.danger.bold.pressed': 'color.text.inverse',
    'color.background.warning.bold': 'color.text.warning.inverse',
    'color.background.warning.bold.hovered': 'color.text.warning.inverse',
    'color.background.warning.bold.pressed': 'color.text.warning.inverse',
    'color.background.success.bold': 'color.text.inverse',
    'color.background.success.bold.hovered': 'color.text.inverse',
    'color.background.success.bold.pressed': 'color.text.inverse',
    'color.background.discovery.bold': 'color.text.inverse',
    'color.background.discovery.bold.hovered': 'color.text.inverse',
    'color.background.discovery.bold.pressed': 'color.text.inverse',
    'color.background.information.bold': 'color.text.inverse',
    'color.background.information.bold.hovered': 'color.text.inverse',
    'color.background.information.bold.pressed': 'color.text.inverse'
};
var $33bc378cd2ea8f75$export$daf94a976c798b4f = {
    'opacity.disabled': "var(--ds-opacity-disabled, 0.4)",
    'opacity.loading': "var(--ds-opacity-loading, 0.2)"
};
var $33bc378cd2ea8f75$export$7aff6e7ba39bb774 = {
    'elevation.shadow.overflow': "var(--ds-shadow-overflow, 0px 0px 8px #1E1F21, 0px 0px 1px #1E1F21)",
    'elevation.shadow.overflow.perimeter': "var(--ds-shadow-overflow-perimeter, #1E1F211f)",
    'elevation.shadow.overflow.spread': "var(--ds-shadow-overflow-spread, #1E1F2129)",
    'elevation.shadow.overlay': "var(--ds-shadow-overlay, 0px 8px 12px #1E1F21, 0px 0px 1px #1E1F21)",
    'elevation.shadow.raised': "var(--ds-shadow-raised, 0px 1px 1px #1E1F21, 0px 0px 1px #1E1F21)"
};
var $33bc378cd2ea8f75$export$41a358c9c2356760 = {
    'elevation.surface': "var(--ds-surface, #FFFFFF)",
    'elevation.surface.hovered': "var(--ds-surface-hovered, #F0F1F2)",
    'elevation.surface.pressed': "var(--ds-surface-pressed, #DDDEE1)",
    'elevation.surface.overlay': "var(--ds-surface-overlay, #FFFFFF)",
    'elevation.surface.overlay.hovered': "var(--ds-surface-overlay-hovered, #F0F1F2)",
    'elevation.surface.overlay.pressed': "var(--ds-surface-overlay-pressed, #DDDEE1)",
    'elevation.surface.raised': "var(--ds-surface-raised, #FFFFFF)",
    'elevation.surface.raised.hovered': "var(--ds-surface-raised-hovered, #F0F1F2)",
    'elevation.surface.raised.pressed': "var(--ds-surface-raised-pressed, #DDDEE1)",
    'elevation.surface.sunken': "var(--ds-surface-sunken, #F8F8F8)"
};
var $33bc378cd2ea8f75$export$1531ad5bb3fbedac = {
    'color.border': "var(--ds-border, #0B120E24)",
    'color.border.accent.lime': "var(--ds-border-accent-lime, #6A9A23)",
    'color.border.accent.red': "var(--ds-border-accent-red, #E2483D)",
    'color.border.accent.orange': "var(--ds-border-accent-orange, #E06C00)",
    'color.border.accent.yellow': "var(--ds-border-accent-yellow, #B38600)",
    'color.border.accent.green': "var(--ds-border-accent-green, #22A06B)",
    'color.border.accent.teal': "var(--ds-border-accent-teal, #2898BD)",
    'color.border.accent.blue': "var(--ds-border-accent-blue, #357DE8)",
    'color.border.accent.purple': "var(--ds-border-accent-purple, #AF59E1)",
    'color.border.accent.magenta': "var(--ds-border-accent-magenta, #CD519D)",
    'color.border.accent.gray': "var(--ds-border-accent-gray, #7D818A)",
    'color.border.disabled': "var(--ds-border-disabled, #0515240F)",
    'color.border.focused': "var(--ds-border-focused, #4688EC)",
    'color.border.input': "var(--ds-border-input, #8C8F97)",
    'color.border.inverse': "var(--ds-border-inverse, #FFFFFF)",
    'color.border.selected': "var(--ds-border-selected, #1868DB)",
    'color.border.brand': "var(--ds-border-brand, #1868DB)",
    'color.border.danger': "var(--ds-border-danger, #E2483D)",
    'color.border.warning': "var(--ds-border-warning, #E06C00)",
    'color.border.success': "var(--ds-border-success, #6A9A23)",
    'color.border.discovery': "var(--ds-border-discovery, #AF59E1)",
    'color.border.information': "var(--ds-border-information, #357DE8)",
    'color.border.bold': "var(--ds-border-bold, #7D818A)"
};
var $33bc378cd2ea8f75$export$d1d79bf68ac056bd = {
    'color.background.accent.lime.subtlest': "var(--ds-background-accent-lime-subtlest, #EFFFD6)",
    'color.background.accent.lime.subtlest.hovered': "var(--ds-background-accent-lime-subtlest-hovered, #D3F1A7)",
    'color.background.accent.lime.subtlest.pressed': "var(--ds-background-accent-lime-subtlest-pressed, #BDE97C)",
    'color.background.accent.lime.subtler': "var(--ds-background-accent-lime-subtler, #D3F1A7)",
    'color.background.accent.lime.subtler.hovered': "var(--ds-background-accent-lime-subtler-hovered, #BDE97C)",
    'color.background.accent.lime.subtler.pressed': "var(--ds-background-accent-lime-subtler-pressed, #B3DF72)",
    'color.background.accent.lime.subtle': "var(--ds-background-accent-lime-subtle, #94C748)",
    'color.background.accent.lime.subtle.hovered': "var(--ds-background-accent-lime-subtle-hovered, #B3DF72)",
    'color.background.accent.lime.subtle.pressed': "var(--ds-background-accent-lime-subtle-pressed, #BDE97C)",
    'color.background.accent.lime.bolder': "var(--ds-background-accent-lime-bolder, #5B7F24)",
    'color.background.accent.lime.bolder.hovered': "var(--ds-background-accent-lime-bolder-hovered, #4C6B1F)",
    'color.background.accent.lime.bolder.pressed': "var(--ds-background-accent-lime-bolder-pressed, #3F5224)",
    'color.background.accent.red.subtlest': "var(--ds-background-accent-red-subtlest, #FFECEB)",
    'color.background.accent.red.subtlest.hovered': "var(--ds-background-accent-red-subtlest-hovered, #FFD5D2)",
    'color.background.accent.red.subtlest.pressed': "var(--ds-background-accent-red-subtlest-pressed, #FFB8B2)",
    'color.background.accent.red.subtler': "var(--ds-background-accent-red-subtler, #FFD5D2)",
    'color.background.accent.red.subtler.hovered': "var(--ds-background-accent-red-subtler-hovered, #FFB8B2)",
    'color.background.accent.red.subtler.pressed': "var(--ds-background-accent-red-subtler-pressed, #FD9891)",
    'color.background.accent.red.subtle': "var(--ds-background-accent-red-subtle, #F87168)",
    'color.background.accent.red.subtle.hovered': "var(--ds-background-accent-red-subtle-hovered, #FD9891)",
    'color.background.accent.red.subtle.pressed': "var(--ds-background-accent-red-subtle-pressed, #FFB8B2)",
    'color.background.accent.red.bolder': "var(--ds-background-accent-red-bolder, #C9372C)",
    'color.background.accent.red.bolder.hovered': "var(--ds-background-accent-red-bolder-hovered, #AE2E24)",
    'color.background.accent.red.bolder.pressed': "var(--ds-background-accent-red-bolder-pressed, #872821)",
    'color.background.accent.orange.subtlest': "var(--ds-background-accent-orange-subtlest, #FFF5DB)",
    'color.background.accent.orange.subtlest.hovered': "var(--ds-background-accent-orange-subtlest-hovered, #FCE4A6)",
    'color.background.accent.orange.subtlest.pressed': "var(--ds-background-accent-orange-subtlest-pressed, #FBD779)",
    'color.background.accent.orange.subtler': "var(--ds-background-accent-orange-subtler, #FCE4A6)",
    'color.background.accent.orange.subtler.hovered': "var(--ds-background-accent-orange-subtler-hovered, #FBD779)",
    'color.background.accent.orange.subtler.pressed': "var(--ds-background-accent-orange-subtler-pressed, #FBC828)",
    'color.background.accent.orange.subtle': "var(--ds-background-accent-orange-subtle, #FCA700)",
    'color.background.accent.orange.subtle.hovered': "var(--ds-background-accent-orange-subtle-hovered, #FBC828)",
    'color.background.accent.orange.subtle.pressed': "var(--ds-background-accent-orange-subtle-pressed, #FBD779)",
    'color.background.accent.orange.bolder': "var(--ds-background-accent-orange-bolder, #BD5B00)",
    'color.background.accent.orange.bolder.hovered': "var(--ds-background-accent-orange-bolder-hovered, #9E4C00)",
    'color.background.accent.orange.bolder.pressed': "var(--ds-background-accent-orange-bolder-pressed, #7A3B00)",
    'color.background.accent.yellow.subtlest': "var(--ds-background-accent-yellow-subtlest, #FEF7C8)",
    'color.background.accent.yellow.subtlest.hovered': "var(--ds-background-accent-yellow-subtlest-hovered, #F5E989)",
    'color.background.accent.yellow.subtlest.pressed': "var(--ds-background-accent-yellow-subtlest-pressed, #EFDD4E)",
    'color.background.accent.yellow.subtler': "var(--ds-background-accent-yellow-subtler, #F5E989)",
    'color.background.accent.yellow.subtler.hovered': "var(--ds-background-accent-yellow-subtler-hovered, #EFDD4E)",
    'color.background.accent.yellow.subtler.pressed': "var(--ds-background-accent-yellow-subtler-pressed, #EED12B)",
    'color.background.accent.yellow.subtle': "var(--ds-background-accent-yellow-subtle, #EED12B)",
    'color.background.accent.yellow.subtle.hovered': "var(--ds-background-accent-yellow-subtle-hovered, #DDB30E)",
    'color.background.accent.yellow.subtle.pressed': "var(--ds-background-accent-yellow-subtle-pressed, #EFDD4E)",
    'color.background.accent.yellow.bolder': "var(--ds-background-accent-yellow-bolder, #946F00)",
    'color.background.accent.yellow.bolder.hovered': "var(--ds-background-accent-yellow-bolder-hovered, #7F5F01)",
    'color.background.accent.yellow.bolder.pressed': "var(--ds-background-accent-yellow-bolder-pressed, #614A05)",
    'color.background.accent.green.subtlest': "var(--ds-background-accent-green-subtlest, #DCFFF1)",
    'color.background.accent.green.subtlest.hovered': "var(--ds-background-accent-green-subtlest-hovered, #BAF3DB)",
    'color.background.accent.green.subtlest.pressed': "var(--ds-background-accent-green-subtlest-pressed, #97EDC9)",
    'color.background.accent.green.subtler': "var(--ds-background-accent-green-subtler, #BAF3DB)",
    'color.background.accent.green.subtler.hovered': "var(--ds-background-accent-green-subtler-hovered, #97EDC9)",
    'color.background.accent.green.subtler.pressed': "var(--ds-background-accent-green-subtler-pressed, #7EE2B8)",
    'color.background.accent.green.subtle': "var(--ds-background-accent-green-subtle, #4BCE97)",
    'color.background.accent.green.subtle.hovered': "var(--ds-background-accent-green-subtle-hovered, #7EE2B8)",
    'color.background.accent.green.subtle.pressed': "var(--ds-background-accent-green-subtle-pressed, #97EDC9)",
    'color.background.accent.green.bolder': "var(--ds-background-accent-green-bolder, #1F845A)",
    'color.background.accent.green.bolder.hovered': "var(--ds-background-accent-green-bolder-hovered, #216E4E)",
    'color.background.accent.green.bolder.pressed': "var(--ds-background-accent-green-bolder-pressed, #19573D)",
    'color.background.accent.teal.subtlest': "var(--ds-background-accent-teal-subtlest, #E7F9FF)",
    'color.background.accent.teal.subtlest.hovered': "var(--ds-background-accent-teal-subtlest-hovered, #C6EDFB)",
    'color.background.accent.teal.subtlest.pressed': "var(--ds-background-accent-teal-subtlest-pressed, #B1E4F7)",
    'color.background.accent.teal.subtler': "var(--ds-background-accent-teal-subtler, #C6EDFB)",
    'color.background.accent.teal.subtler.hovered': "var(--ds-background-accent-teal-subtler-hovered, #B1E4F7)",
    'color.background.accent.teal.subtler.pressed': "var(--ds-background-accent-teal-subtler-pressed, #9DD9EE)",
    'color.background.accent.teal.subtle': "var(--ds-background-accent-teal-subtle, #6CC3E0)",
    'color.background.accent.teal.subtle.hovered': "var(--ds-background-accent-teal-subtle-hovered, #9DD9EE)",
    'color.background.accent.teal.subtle.pressed': "var(--ds-background-accent-teal-subtle-pressed, #B1E4F7)",
    'color.background.accent.teal.bolder': "var(--ds-background-accent-teal-bolder, #227D9B)",
    'color.background.accent.teal.bolder.hovered': "var(--ds-background-accent-teal-bolder-hovered, #206A83)",
    'color.background.accent.teal.bolder.pressed': "var(--ds-background-accent-teal-bolder-pressed, #1A5265)",
    'color.background.accent.blue.subtlest': "var(--ds-background-accent-blue-subtlest, #E9F2FE)",
    'color.background.accent.blue.subtlest.hovered': "var(--ds-background-accent-blue-subtlest-hovered, #CFE1FD)",
    'color.background.accent.blue.subtlest.pressed': "var(--ds-background-accent-blue-subtlest-pressed, #ADCBFB)",
    'color.background.accent.blue.subtler': "var(--ds-background-accent-blue-subtler, #CFE1FD)",
    'color.background.accent.blue.subtler.hovered': "var(--ds-background-accent-blue-subtler-hovered, #ADCBFB)",
    'color.background.accent.blue.subtler.pressed': "var(--ds-background-accent-blue-subtler-pressed, #8FB8F6)",
    'color.background.accent.blue.subtle': "var(--ds-background-accent-blue-subtle, #669DF1)",
    'color.background.accent.blue.subtle.hovered': "var(--ds-background-accent-blue-subtle-hovered, #8FB8F6)",
    'color.background.accent.blue.subtle.pressed': "var(--ds-background-accent-blue-subtle-pressed, #ADCBFB)",
    'color.background.accent.blue.bolder': "var(--ds-background-accent-blue-bolder, #1868DB)",
    'color.background.accent.blue.bolder.hovered': "var(--ds-background-accent-blue-bolder-hovered, #1558BC)",
    'color.background.accent.blue.bolder.pressed': "var(--ds-background-accent-blue-bolder-pressed, #144794)",
    'color.background.accent.purple.subtlest': "var(--ds-background-accent-purple-subtlest, #F8EEFE)",
    'color.background.accent.purple.subtlest.hovered': "var(--ds-background-accent-purple-subtlest-hovered, #EED7FC)",
    'color.background.accent.purple.subtlest.pressed': "var(--ds-background-accent-purple-subtlest-pressed, #E3BDFA)",
    'color.background.accent.purple.subtler': "var(--ds-background-accent-purple-subtler, #EED7FC)",
    'color.background.accent.purple.subtler.hovered': "var(--ds-background-accent-purple-subtler-hovered, #E3BDFA)",
    'color.background.accent.purple.subtler.pressed': "var(--ds-background-accent-purple-subtler-pressed, #D8A0F7)",
    'color.background.accent.purple.subtle': "var(--ds-background-accent-purple-subtle, #C97CF4)",
    'color.background.accent.purple.subtle.hovered': "var(--ds-background-accent-purple-subtle-hovered, #D8A0F7)",
    'color.background.accent.purple.subtle.pressed': "var(--ds-background-accent-purple-subtle-pressed, #E3BDFA)",
    'color.background.accent.purple.bolder': "var(--ds-background-accent-purple-bolder, #964AC0)",
    'color.background.accent.purple.bolder.hovered': "var(--ds-background-accent-purple-bolder-hovered, #803FA5)",
    'color.background.accent.purple.bolder.pressed': "var(--ds-background-accent-purple-bolder-pressed, #673286)",
    'color.background.accent.magenta.subtlest': "var(--ds-background-accent-magenta-subtlest, #FFECF8)",
    'color.background.accent.magenta.subtlest.hovered': "var(--ds-background-accent-magenta-subtlest-hovered, #FDD0EC)",
    'color.background.accent.magenta.subtlest.pressed': "var(--ds-background-accent-magenta-subtlest-pressed, #FCB6E1)",
    'color.background.accent.magenta.subtler': "var(--ds-background-accent-magenta-subtler, #FDD0EC)",
    'color.background.accent.magenta.subtler.hovered': "var(--ds-background-accent-magenta-subtler-hovered, #FCB6E1)",
    'color.background.accent.magenta.subtler.pressed': "var(--ds-background-accent-magenta-subtler-pressed, #F797D2)",
    'color.background.accent.magenta.subtle': "var(--ds-background-accent-magenta-subtle, #E774BB)",
    'color.background.accent.magenta.subtle.hovered': "var(--ds-background-accent-magenta-subtle-hovered, #F797D2)",
    'color.background.accent.magenta.subtle.pressed': "var(--ds-background-accent-magenta-subtle-pressed, #FCB6E1)",
    'color.background.accent.magenta.bolder': "var(--ds-background-accent-magenta-bolder, #AE4787)",
    'color.background.accent.magenta.bolder.hovered': "var(--ds-background-accent-magenta-bolder-hovered, #943D73)",
    'color.background.accent.magenta.bolder.pressed': "var(--ds-background-accent-magenta-bolder-pressed, #77325B)",
    'color.background.accent.gray.subtlest': "var(--ds-background-accent-gray-subtlest, #F0F1F2)",
    'color.background.accent.gray.subtlest.hovered': "var(--ds-background-accent-gray-subtlest-hovered, #DDDEE1)",
    'color.background.accent.gray.subtlest.pressed': "var(--ds-background-accent-gray-subtlest-pressed, #B7B9BE)",
    'color.background.accent.gray.subtler': "var(--ds-background-accent-gray-subtler, #DDDEE1)",
    'color.background.accent.gray.subtler.hovered': "var(--ds-background-accent-gray-subtler-hovered, #B7B9BE)",
    'color.background.accent.gray.subtler.pressed': "var(--ds-background-accent-gray-subtler-pressed, #8C8F97)",
    'color.background.accent.gray.subtle': "var(--ds-background-accent-gray-subtle, #8C8F97)",
    'color.background.accent.gray.subtle.hovered': "var(--ds-background-accent-gray-subtle-hovered, #B7B9BE)",
    'color.background.accent.gray.subtle.pressed': "var(--ds-background-accent-gray-subtle-pressed, #DDDEE1)",
    'color.background.accent.gray.bolder': "var(--ds-background-accent-gray-bolder, #6B6E76)",
    'color.background.accent.gray.bolder.hovered': "var(--ds-background-accent-gray-bolder-hovered, #505258)",
    'color.background.accent.gray.bolder.pressed': "var(--ds-background-accent-gray-bolder-pressed, #3B3D42)",
    'color.background.disabled': "var(--ds-background-disabled, #17171708)",
    'color.background.input': "var(--ds-background-input, #FFFFFF)",
    'color.background.input.hovered': "var(--ds-background-input-hovered, #F8F8F8)",
    'color.background.input.pressed': "var(--ds-background-input-pressed, #FFFFFF)",
    'color.background.inverse.subtle': "var(--ds-background-inverse-subtle, #00000029)",
    'color.background.inverse.subtle.hovered': "var(--ds-background-inverse-subtle-hovered, #0000003D)",
    'color.background.inverse.subtle.pressed': "var(--ds-background-inverse-subtle-pressed, #00000052)",
    'color.background.neutral': "var(--ds-background-neutral, #0515240F)",
    'color.background.neutral.hovered': "var(--ds-background-neutral-hovered, #0B120E24)",
    'color.background.neutral.pressed': "var(--ds-background-neutral-pressed, #080F214A)",
    'color.background.neutral.subtle': "var(--ds-background-neutral-subtle, #00000000)",
    'color.background.neutral.subtle.hovered': "var(--ds-background-neutral-subtle-hovered, #0515240F)",
    'color.background.neutral.subtle.pressed': "var(--ds-background-neutral-subtle-pressed, #0B120E24)",
    'color.background.neutral.bold': "var(--ds-background-neutral-bold, #292A2E)",
    'color.background.neutral.bold.hovered': "var(--ds-background-neutral-bold-hovered, #3B3D42)",
    'color.background.neutral.bold.pressed': "var(--ds-background-neutral-bold-pressed, #505258)",
    'color.background.selected': "var(--ds-background-selected, #E9F2FE)",
    'color.background.selected.hovered': "var(--ds-background-selected-hovered, #CFE1FD)",
    'color.background.selected.pressed': "var(--ds-background-selected-pressed, #8FB8F6)",
    'color.background.selected.bold': "var(--ds-background-selected-bold, #1868DB)",
    'color.background.selected.bold.hovered': "var(--ds-background-selected-bold-hovered, #1558BC)",
    'color.background.selected.bold.pressed': "var(--ds-background-selected-bold-pressed, #123263)",
    'color.background.brand.subtlest': "var(--ds-background-brand-subtlest, #E9F2FE)",
    'color.background.brand.subtlest.hovered': "var(--ds-background-brand-subtlest-hovered, #CFE1FD)",
    'color.background.brand.subtlest.pressed': "var(--ds-background-brand-subtlest-pressed, #ADCBFB)",
    'color.background.brand.bold': "var(--ds-background-brand-bold, #1868DB)",
    'color.background.brand.bold.hovered': "var(--ds-background-brand-bold-hovered, #1558BC)",
    'color.background.brand.bold.pressed': "var(--ds-background-brand-bold-pressed, #144794)",
    'color.background.brand.boldest': "var(--ds-background-brand-boldest, #1C2B42)",
    'color.background.brand.boldest.hovered': "var(--ds-background-brand-boldest-hovered, #123263)",
    'color.background.brand.boldest.pressed': "var(--ds-background-brand-boldest-pressed, #144794)",
    'color.background.danger': "var(--ds-background-danger, #FFECEB)",
    'color.background.danger.hovered': "var(--ds-background-danger-hovered, #FFD5D2)",
    'color.background.danger.pressed': "var(--ds-background-danger-pressed, #FFB8B2)",
    'color.background.danger.subtler': "var(--ds-background-danger-subtler, #FFD5D2)",
    'color.background.danger.subtler.hovered': "var(--ds-background-danger-subtler-hovered, #FFB8B2)",
    'color.background.danger.subtler.pressed': "var(--ds-background-danger-subtler-pressed, #FD9891)",
    'color.background.danger.bold': "var(--ds-background-danger-bold, #C9372C)",
    'color.background.danger.bold.hovered': "var(--ds-background-danger-bold-hovered, #AE2E24)",
    'color.background.danger.bold.pressed': "var(--ds-background-danger-bold-pressed, #872821)",
    'color.background.warning': "var(--ds-background-warning, #FFF5DB)",
    'color.background.warning.hovered': "var(--ds-background-warning-hovered, #FCE4A6)",
    'color.background.warning.pressed': "var(--ds-background-warning-pressed, #FBD779)",
    'color.background.warning.subtler': "var(--ds-background-warning-subtler, #FCE4A6)",
    'color.background.warning.subtler.hovered': "var(--ds-background-warning-subtler-hovered, #FBD779)",
    'color.background.warning.subtler.pressed': "var(--ds-background-warning-subtler-pressed, #FBC828)",
    'color.background.warning.bold': "var(--ds-background-warning-bold, #FBC828)",
    'color.background.warning.bold.hovered': "var(--ds-background-warning-bold-hovered, #FCA700)",
    'color.background.warning.bold.pressed': "var(--ds-background-warning-bold-pressed, #F68909)",
    'color.background.success': "var(--ds-background-success, #EFFFD6)",
    'color.background.success.hovered': "var(--ds-background-success-hovered, #D3F1A7)",
    'color.background.success.pressed': "var(--ds-background-success-pressed, #BDE97C)",
    'color.background.success.subtler': "var(--ds-background-success-subtler, #D3F1A7)",
    'color.background.success.subtler.hovered': "var(--ds-background-success-subtler-hovered, #BDE97C)",
    'color.background.success.subtler.pressed': "var(--ds-background-success-subtler-pressed, #B3DF72)",
    'color.background.success.bold': "var(--ds-background-success-bold, #5B7F24)",
    'color.background.success.bold.hovered': "var(--ds-background-success-bold-hovered, #4C6B1F)",
    'color.background.success.bold.pressed': "var(--ds-background-success-bold-pressed, #3F5224)",
    'color.background.discovery': "var(--ds-background-discovery, #F8EEFE)",
    'color.background.discovery.hovered': "var(--ds-background-discovery-hovered, #EED7FC)",
    'color.background.discovery.pressed': "var(--ds-background-discovery-pressed, #E3BDFA)",
    'color.background.discovery.subtler': "var(--ds-background-discovery-subtler, #EED7FC)",
    'color.background.discovery.subtler.hovered': "var(--ds-background-discovery-subtler-hovered, #E3BDFA)",
    'color.background.discovery.subtler.pressed': "var(--ds-background-discovery-subtler-pressed, #D8A0F7)",
    'color.background.discovery.bold': "var(--ds-background-discovery-bold, #964AC0)",
    'color.background.discovery.bold.hovered': "var(--ds-background-discovery-bold-hovered, #803FA5)",
    'color.background.discovery.bold.pressed': "var(--ds-background-discovery-bold-pressed, #673286)",
    'color.background.information': "var(--ds-background-information, #E9F2FE)",
    'color.background.information.hovered': "var(--ds-background-information-hovered, #CFE1FD)",
    'color.background.information.pressed': "var(--ds-background-information-pressed, #ADCBFB)",
    'color.background.information.subtler': "var(--ds-background-information-subtler, #CFE1FD)",
    'color.background.information.subtler.hovered': "var(--ds-background-information-subtler-hovered, #ADCBFB)",
    'color.background.information.subtler.pressed': "var(--ds-background-information-subtler-pressed, #8FB8F6)",
    'color.background.information.bold': "var(--ds-background-information-bold, #1868DB)",
    'color.background.information.bold.hovered': "var(--ds-background-information-bold-hovered, #1558BC)",
    'color.background.information.bold.pressed': "var(--ds-background-information-bold-pressed, #144794)",
    'color.blanket': "var(--ds-blanket, #050C1F75)",
    'color.blanket.selected': "var(--ds-blanket-selected, #388BFF14)",
    'color.blanket.danger': "var(--ds-blanket-danger, #EF5C4814)",
    'color.skeleton': "var(--ds-skeleton, #0515240F)",
    'color.skeleton.subtle': "var(--ds-skeleton-subtle, #17171708)",
    'elevation.surface': "var(--ds-surface, #FFFFFF)",
    'elevation.surface.hovered': "var(--ds-surface-hovered, #F0F1F2)",
    'elevation.surface.pressed': "var(--ds-surface-pressed, #DDDEE1)",
    'elevation.surface.overlay': "var(--ds-surface-overlay, #FFFFFF)",
    'elevation.surface.overlay.hovered': "var(--ds-surface-overlay-hovered, #F0F1F2)",
    'elevation.surface.overlay.pressed': "var(--ds-surface-overlay-pressed, #DDDEE1)",
    'elevation.surface.raised': "var(--ds-surface-raised, #FFFFFF)",
    'elevation.surface.raised.hovered': "var(--ds-surface-raised-hovered, #F0F1F2)",
    'elevation.surface.raised.pressed': "var(--ds-surface-raised-pressed, #DDDEE1)",
    'elevation.surface.sunken': "var(--ds-surface-sunken, #F8F8F8)",
    'utility.elevation.surface.current': "var(--ds-elevation-surface-current, #FFFFFF)"
};
var $33bc378cd2ea8f75$export$8473307aa00d6ea1 = {
    'color.text': "var(--ds-text, #292A2E)",
    'color.text.accent.lime': "var(--ds-text-accent-lime, #4C6B1F)",
    'color.text.accent.lime.bolder': "var(--ds-text-accent-lime-bolder, #37471F)",
    'color.text.accent.red': "var(--ds-text-accent-red, #AE2E24)",
    'color.text.accent.red.bolder': "var(--ds-text-accent-red-bolder, #5D1F1A)",
    'color.text.accent.orange': "var(--ds-text-accent-orange, #9E4C00)",
    'color.text.accent.orange.bolder': "var(--ds-text-accent-orange-bolder, #693200)",
    'color.text.accent.yellow': "var(--ds-text-accent-yellow, #7F5F01)",
    'color.text.accent.yellow.bolder': "var(--ds-text-accent-yellow-bolder, #533F04)",
    'color.text.accent.green': "var(--ds-text-accent-green, #216E4E)",
    'color.text.accent.green.bolder': "var(--ds-text-accent-green-bolder, #164B35)",
    'color.text.accent.teal': "var(--ds-text-accent-teal, #206A83)",
    'color.text.accent.teal.bolder': "var(--ds-text-accent-teal-bolder, #164555)",
    'color.text.accent.blue': "var(--ds-text-accent-blue, #1558BC)",
    'color.text.accent.blue.bolder': "var(--ds-text-accent-blue-bolder, #123263)",
    'color.text.accent.purple': "var(--ds-text-accent-purple, #803FA5)",
    'color.text.accent.purple.bolder': "var(--ds-text-accent-purple-bolder, #48245D)",
    'color.text.accent.magenta': "var(--ds-text-accent-magenta, #943D73)",
    'color.text.accent.magenta.bolder': "var(--ds-text-accent-magenta-bolder, #50253F)",
    'color.text.accent.gray': "var(--ds-text-accent-gray, #505258)",
    'color.text.accent.gray.bolder': "var(--ds-text-accent-gray-bolder, #1E1F21)",
    'color.text.disabled': "var(--ds-text-disabled, #080F214A)",
    'color.text.inverse': "var(--ds-text-inverse, #FFFFFF)",
    'color.text.selected': "var(--ds-text-selected, #1868DB)",
    'color.text.brand': "var(--ds-text-brand, #1868DB)",
    'color.text.danger': "var(--ds-text-danger, #AE2E24)",
    'color.text.danger.bolder': "var(--ds-text-danger-bolder, #5D1F1A)",
    'color.text.warning': "var(--ds-text-warning, #9E4C00)",
    'color.text.warning.inverse': "var(--ds-text-warning-inverse, #292A2E)",
    'color.text.warning.bolder': "var(--ds-text-warning-bolder, #693200)",
    'color.text.success': "var(--ds-text-success, #4C6B1F)",
    'color.text.success.bolder': "var(--ds-text-success-bolder, #37471F)",
    'color.text.discovery': "var(--ds-text-discovery, #803FA5)",
    'color.text.discovery.bolder': "var(--ds-text-discovery-bolder, #48245D)",
    'color.text.information': "var(--ds-text-information, #1558BC)",
    'color.text.information.bolder': "var(--ds-text-information-bolder, #123263)",
    'color.text.subtlest': "var(--ds-text-subtlest, #6B6E76)",
    'color.text.subtle': "var(--ds-text-subtle, #505258)",
    'color.link': "var(--ds-link, #1868DB)",
    'color.link.pressed': "var(--ds-link-pressed, #1558BC)",
    'color.link.visited': "var(--ds-link-visited, #803FA5)",
    'color.link.visited.pressed': "var(--ds-link-visited-pressed, #48245D)"
};
var $33bc378cd2ea8f75$export$498780f74be9af68 = {
    'color.icon': "var(--ds-icon, #292A2E)",
    'color.icon.accent.lime': "var(--ds-icon-accent-lime, #6A9A23)",
    'color.icon.accent.red': "var(--ds-icon-accent-red, #C9372C)",
    'color.icon.accent.orange': "var(--ds-icon-accent-orange, #E06C00)",
    'color.icon.accent.yellow': "var(--ds-icon-accent-yellow, #B38600)",
    'color.icon.accent.green': "var(--ds-icon-accent-green, #22A06B)",
    'color.icon.accent.teal': "var(--ds-icon-accent-teal, #2898BD)",
    'color.icon.accent.blue': "var(--ds-icon-accent-blue, #357DE8)",
    'color.icon.accent.purple': "var(--ds-icon-accent-purple, #AF59E1)",
    'color.icon.accent.magenta': "var(--ds-icon-accent-magenta, #CD519D)",
    'color.icon.accent.gray': "var(--ds-icon-accent-gray, #7D818A)",
    'color.icon.disabled': "var(--ds-icon-disabled, #080F214A)",
    'color.icon.inverse': "var(--ds-icon-inverse, #FFFFFF)",
    'color.icon.selected': "var(--ds-icon-selected, #1868DB)",
    'color.icon.brand': "var(--ds-icon-brand, #1868DB)",
    'color.icon.danger': "var(--ds-icon-danger, #C9372C)",
    'color.icon.warning': "var(--ds-icon-warning, #E06C00)",
    'color.icon.warning.inverse': "var(--ds-icon-warning-inverse, #292A2E)",
    'color.icon.success': "var(--ds-icon-success, #6A9A23)",
    'color.icon.discovery': "var(--ds-icon-discovery, #AF59E1)",
    'color.icon.information': "var(--ds-icon-information, #357DE8)",
    'color.icon.subtlest': "var(--ds-icon-subtlest, #6B6E76)",
    'color.icon.subtle': "var(--ds-icon-subtle, #505258)"
};
var $33bc378cd2ea8f75$export$b5f31a7e431d2eab = {
    '1': 1,
    card: 100,
    navigation: 200,
    dialog: 300,
    layer: 400,
    blanket: 500,
    modal: 510,
    flag: 600,
    spotlight: 700,
    tooltip: 800
};
var $33bc378cd2ea8f75$export$e1b83c5210c471b8 = {
    'border.width': "var(--ds-border-width, 1px)",
    'border.width.selected': "var(--ds-border-width-selected, 2px)",
    'border.width.focused': "var(--ds-border-width-focused, 2px)"
};
var $33bc378cd2ea8f75$export$3c0a6c3e64bb180d = {
    'radius.xsmall': "var(--ds-radius-xsmall, 2px)",
    'radius.small': "var(--ds-radius-small, 3px)",
    'radius.medium': "var(--ds-radius-medium, 6px)",
    'radius.large': "var(--ds-radius-large, 8px)",
    'radius.xlarge': "var(--ds-radius-xlarge, 12px)",
    'radius.xxlarge': "var(--ds-radius-xxlarge, 16px)",
    'radius.full': "var(--ds-radius-full, 9999px)",
    'radius.tile': "var(--ds-radius-tile, 25%)"
};
var $33bc378cd2ea8f75$export$6ffa317d5e70375 = {
    'font.body': "var(--ds-font-body, normal 400 14px/20px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    // @deprecated
    'font.body.UNSAFE_small': "var(--ds-font-body-UNSAFE_small, normal 400 12px/16px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.body.large': "var(--ds-font-body-large, normal 400 16px/24px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.body.small': "var(--ds-font-body-small, normal 400 12px/16px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.code': "var(--ds-font-code, normal 400 0.875em/1 \"Atlassian Mono\", ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)",
    'font.heading.large': "var(--ds-font-heading-large, normal 653 24px/28px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.heading.medium': "var(--ds-font-heading-medium, normal 653 20px/24px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.heading.small': "var(--ds-font-heading-small, normal 653 16px/20px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.heading.xlarge': "var(--ds-font-heading-xlarge, normal 653 28px/32px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.heading.xsmall': "var(--ds-font-heading-xsmall, normal 653 14px/20px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.heading.xxlarge': "var(--ds-font-heading-xxlarge, normal 653 32px/36px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.heading.xxsmall': "var(--ds-font-heading-xxsmall, normal 653 12px/16px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.metric.large': "var(--ds-font-metric-large, normal 653 28px/32px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.metric.medium': "var(--ds-font-metric-medium, normal 653 24px/28px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.metric.small': "var(--ds-font-metric-small, normal 653 16px/20px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
};
var $33bc378cd2ea8f75$export$303e322c6b1ed114 = {
    'font.weight.bold': "var(--ds-font-weight-bold, 653)",
    'font.weight.medium': "var(--ds-font-weight-medium, 500)",
    'font.weight.regular': "var(--ds-font-weight-regular, 400)",
    'font.weight.semibold': "var(--ds-font-weight-semibold, 600)"
};
var $33bc378cd2ea8f75$export$3c7e9587132614b4 = {
    'font.family.body': "var(--ds-font-family-body, \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.family.brand.body': "var(--ds-font-family-brand-body, \"Charlie Text\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.family.brand.heading': "var(--ds-font-family-brand-heading, \"Charlie Display\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.family.code': "var(--ds-font-family-code, \"Atlassian Mono\", ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)",
    'font.family.heading': "var(--ds-font-family-heading, \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
};
var $33bc378cd2ea8f75$export$236bfe3a33ef1292 = {
    medium: "var(--ds-font-body, normal 400 14px/20px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    UNSAFE_small: "var(--ds-font-body-UNSAFE_small, normal 400 12px/16px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    large: "var(--ds-font-body-large, normal 400 16px/24px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    small: "var(--ds-font-body-small, normal 400 12px/16px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
};
var $33bc378cd2ea8f75$export$855cfd311192d666 = {
    bold: "var(--ds-font-weight-bold, 653)",
    medium: "var(--ds-font-weight-medium, 500)",
    regular: "var(--ds-font-weight-regular, 400)",
    semibold: "var(--ds-font-weight-semibold, 600)"
};
var $33bc378cd2ea8f75$export$b805719bc8cb376 = {
    large: "var(--ds-font-metric-large, normal 653 28px/32px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    medium: "var(--ds-font-metric-medium, normal 653 24px/28px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    small: "var(--ds-font-metric-small, normal 653 16px/20px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
};
/**
 * @codegenEnd
 */ // Margin needs some bespoke types: https://atlassian.slack.com/archives/CKRHB23K8/p1712623192772909
/**
 * Token functions are currently allowed for borderRadius in xcss to ease migration.
 * Because 'radius.small' defaults to 3px, we need a mechanism to allow for 4px values to be provided:
 * This is done by calling the token function - token('radius.small')
 *
 * TODO: Remove once shape them is rolled out and fg platform-dst-shape-theme-default removed
 */ // Generate maps for Box props. backgroundColor, padding, etc
var $33bc378cd2ea8f75$var$spacingProperties = [
    // Used by Box
    'padding',
    'paddingBlock',
    'paddingBlockStart',
    'paddingBlockEnd',
    'paddingInline',
    'paddingInlineStart',
    'paddingInlineEnd',
    // Used by Inline and Stack
    'gap',
    'rowGap',
    'columnGap'
];
var $33bc378cd2ea8f75$export$ca0f9c2de39ffed7 = function getSerializedStylesMap(cssProperty, tokenMap) {
    return Object.keys(tokenMap).reduce(function(emotionSpacingMap, token) {
        // eslint-disable-next-line @repo/internal/styles/no-exported-styles
        emotionSpacingMap[token] = (0, $74Zh5.css)((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, cssProperty, tokenMap[token]));
        return emotionSpacingMap;
    }, {});
};
var $33bc378cd2ea8f75$export$e615f061ca585a6c = $33bc378cd2ea8f75$var$spacingProperties.reduce(function(styleMap, spacingProperty) {
    styleMap[spacingProperty] = $33bc378cd2ea8f75$export$ca0f9c2de39ffed7(spacingProperty, $33bc378cd2ea8f75$export$958d0ae7f2977ae4);
    return styleMap;
}, {});
var $33bc378cd2ea8f75$export$bf46c3f9eeafc71f = $33bc378cd2ea8f75$var$spacingProperties.reduce(function(styleMap, spacingProperty) {
    styleMap[spacingProperty] = $33bc378cd2ea8f75$export$ca0f9c2de39ffed7(spacingProperty, $33bc378cd2ea8f75$export$958d0ae7f2977ae4);
    return styleMap;
}, {});
var $33bc378cd2ea8f75$export$e7af83bafe7f9e63 = $33bc378cd2ea8f75$export$ca0f9c2de39ffed7('backgroundColor', $33bc378cd2ea8f75$export$d1d79bf68ac056bd);
var $33bc378cd2ea8f75$export$3a1bcba60b23d7f0 = $33bc378cd2ea8f75$export$ca0f9c2de39ffed7('color', $33bc378cd2ea8f75$export$8473307aa00d6ea1);
var $33bc378cd2ea8f75$export$45f3f4fe16f9f7d5 = $33bc378cd2ea8f75$export$ca0f9c2de39ffed7('fontWeight', $33bc378cd2ea8f75$export$303e322c6b1ed114);
var $33bc378cd2ea8f75$export$68cc305da27dbaa4 = $33bc378cd2ea8f75$export$ca0f9c2de39ffed7('fontFamily', $33bc378cd2ea8f75$export$3c7e9587132614b4);
var $33bc378cd2ea8f75$export$128f10c238242f83 = $33bc378cd2ea8f75$export$ca0f9c2de39ffed7('font', $33bc378cd2ea8f75$export$6ffa317d5e70375);
var $33bc378cd2ea8f75$export$219d364c0da35ae4 = $33bc378cd2ea8f75$export$ca0f9c2de39ffed7('font', $33bc378cd2ea8f75$export$236bfe3a33ef1292);
var $33bc378cd2ea8f75$export$38845ca010b93505 = $33bc378cd2ea8f75$export$ca0f9c2de39ffed7('fontWeight', $33bc378cd2ea8f75$export$855cfd311192d666);
var $33bc378cd2ea8f75$export$ff257d957d48c421 = $33bc378cd2ea8f75$export$ca0f9c2de39ffed7((0, $ho3jH.CURRENT_SURFACE_CSS_VAR), $33bc378cd2ea8f75$export$41a358c9c2356760);
var $33bc378cd2ea8f75$export$5e65a44e5b6ecadb = function isSurfaceColorToken(color) {
    return $33bc378cd2ea8f75$export$41a358c9c2356760[color] !== undefined;
};
var $33bc378cd2ea8f75$export$7001ce64d9ff7c7f = $33bc378cd2ea8f75$export$ca0f9c2de39ffed7('font', $33bc378cd2ea8f75$export$b805719bc8cb376);

});
parcelRegister("ho3jH", function(module, exports) {
$parcel$export(module.exports, "CURRENT_SURFACE_CSS_VAR", () => $ca874037ae495773$export$9d7b58831ae93caa);
var $ca874037ae495773$export$4ef52930e33717cd = 'data-theme';
var $ca874037ae495773$export$cb374d25ded7f6ab = 'data-subtree-theme';
var $ca874037ae495773$export$a00eac3f8684bcd0 = 'data-color-mode';
var $ca874037ae495773$export$2112803007239c61 = 'data-contrast-mode';
var $ca874037ae495773$export$352e418ed5b6193a = 'data-custom-theme';
var $ca874037ae495773$export$6f0c6fb8c80fcc92 = 'ds';
var $ca874037ae495773$export$4d0c7bbf80185957 = [
    'opacity',
    'font',
    'space',
    'border',
    'radius'
];
var $ca874037ae495773$export$dddac1532e822863 = "--".concat($ca874037ae495773$export$6f0c6fb8c80fcc92, "-token-not-found");
var $ca874037ae495773$export$9d7b58831ae93caa = "--".concat($ca874037ae495773$export$6f0c6fb8c80fcc92, "-elevation-surface-current");

});


parcelRegister("iV0gU", function(module, exports) {
$parcel$export(module.exports, "parseXcss", () => $dc5dc2d6aef18230$export$a9c84988c8f81f2d);

var $fC8ib = parcelRequire("fC8ib");

var $25nEq = parcelRequire("25nEq");

var $iYJcE = parcelRequire("iYJcE");

var $ekGgq = parcelRequire("ekGgq");

var $74Zh5 = parcelRequire("74Zh5");

var $4rnTn = parcelRequire("4rnTn");

var $3ZMUU = parcelRequire("3ZMUU");
function $dc5dc2d6aef18230$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $dc5dc2d6aef18230$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $dc5dc2d6aef18230$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $dc5dc2d6aef18230$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $dc5dc2d6aef18230$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $dc5dc2d6aef18230$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
var $dc5dc2d6aef18230$export$9a199fbafee0014e = {
    backgroundColor: (0, $4rnTn.backgroundColorMap),
    blockSize: (0, $4rnTn.dimensionMap),
    borderBlockColor: (0, $4rnTn.borderColorMap),
    borderBlockEndColor: (0, $4rnTn.borderColorMap),
    borderBlockEndWidth: (0, $4rnTn.borderWidthMap),
    borderBlockStartColor: (0, $4rnTn.borderColorMap),
    borderBlockStartWidth: (0, $4rnTn.borderWidthMap),
    borderBlockWidth: (0, $4rnTn.borderWidthMap),
    borderBottomColor: (0, $4rnTn.borderColorMap),
    borderBottomLeftRadius: (0, $4rnTn.borderRadiusMap),
    borderBottomRightRadius: (0, $4rnTn.borderRadiusMap),
    borderBottomWidth: (0, $4rnTn.borderWidthMap),
    borderColor: (0, $4rnTn.borderColorMap),
    borderEndEndRadius: (0, $4rnTn.borderRadiusMap),
    borderEndStartRadius: (0, $4rnTn.borderRadiusMap),
    borderInlineColor: (0, $4rnTn.borderColorMap),
    borderInlineEndColor: (0, $4rnTn.borderColorMap),
    borderInlineEndWidth: (0, $4rnTn.borderWidthMap),
    borderInlineStartColor: (0, $4rnTn.borderColorMap),
    borderInlineStartWidth: (0, $4rnTn.borderWidthMap),
    borderInlineWidth: (0, $4rnTn.borderWidthMap),
    borderLeftColor: (0, $4rnTn.borderColorMap),
    borderLeftWidth: (0, $4rnTn.borderWidthMap),
    borderRadius: (0, $4rnTn.borderRadiusMap),
    borderRightColor: (0, $4rnTn.borderColorMap),
    borderRightWidth: (0, $4rnTn.borderWidthMap),
    borderStartEndRadius: (0, $4rnTn.borderRadiusMap),
    borderStartStartRadius: (0, $4rnTn.borderRadiusMap),
    borderTopColor: (0, $4rnTn.borderColorMap),
    borderTopLeftRadius: (0, $4rnTn.borderRadiusMap),
    borderTopRightRadius: (0, $4rnTn.borderRadiusMap),
    borderTopWidth: (0, $4rnTn.borderWidthMap),
    borderWidth: (0, $4rnTn.borderWidthMap),
    bottom: (0, $4rnTn.allSpaceMap),
    boxShadow: (0, $4rnTn.shadowMap),
    color: (0, $4rnTn.textColorMap),
    columnGap: (0, $4rnTn.positiveSpaceMap),
    font: (0, $4rnTn.fontMap),
    fontFamily: (0, $4rnTn.fontFamilyMap),
    fontWeight: (0, $4rnTn.fontWeightMap),
    gap: (0, $4rnTn.positiveSpaceMap),
    height: (0, $4rnTn.dimensionMap),
    inlineSize: (0, $4rnTn.dimensionMap),
    inset: (0, $4rnTn.allSpaceMap),
    insetBlock: (0, $4rnTn.allSpaceMap),
    insetBlockEnd: (0, $4rnTn.allSpaceMap),
    insetBlockStart: (0, $4rnTn.allSpaceMap),
    insetInline: (0, $4rnTn.allSpaceMap),
    insetInlineEnd: (0, $4rnTn.allSpaceMap),
    insetInlineStart: (0, $4rnTn.allSpaceMap),
    left: (0, $4rnTn.allSpaceMap),
    margin: (0, $4rnTn.allSpaceMap),
    marginBlock: (0, $4rnTn.allSpaceMap),
    marginBlockEnd: (0, $4rnTn.allSpaceMap),
    marginBlockStart: (0, $4rnTn.allSpaceMap),
    marginBottom: (0, $4rnTn.allSpaceMap),
    marginInline: (0, $4rnTn.allSpaceMap),
    marginInlineEnd: (0, $4rnTn.allSpaceMap),
    marginInlineStart: (0, $4rnTn.allSpaceMap),
    marginLeft: (0, $4rnTn.allSpaceMap),
    marginRight: (0, $4rnTn.allSpaceMap),
    marginTop: (0, $4rnTn.allSpaceMap),
    maxBlockSize: (0, $4rnTn.dimensionMap),
    maxHeight: (0, $4rnTn.dimensionMap),
    maxInlineSize: (0, $4rnTn.dimensionMap),
    maxWidth: (0, $4rnTn.dimensionMap),
    minBlockSize: (0, $4rnTn.dimensionMap),
    minHeight: (0, $4rnTn.dimensionMap),
    minInlineSize: (0, $4rnTn.dimensionMap),
    minWidth: (0, $4rnTn.dimensionMap),
    opacity: (0, $4rnTn.opacityMap),
    outlineColor: (0, $4rnTn.borderColorMap),
    outlineOffset: (0, $4rnTn.allSpaceMap),
    outlineWidth: (0, $4rnTn.borderWidthMap),
    padding: (0, $4rnTn.positiveSpaceMap),
    paddingBlock: (0, $4rnTn.positiveSpaceMap),
    paddingBlockEnd: (0, $4rnTn.positiveSpaceMap),
    paddingBlockStart: (0, $4rnTn.positiveSpaceMap),
    paddingBottom: (0, $4rnTn.positiveSpaceMap),
    paddingInline: (0, $4rnTn.positiveSpaceMap),
    paddingInlineEnd: (0, $4rnTn.positiveSpaceMap),
    paddingInlineStart: (0, $4rnTn.positiveSpaceMap),
    paddingLeft: (0, $4rnTn.positiveSpaceMap),
    paddingRight: (0, $4rnTn.positiveSpaceMap),
    paddingTop: (0, $4rnTn.positiveSpaceMap),
    right: (0, $4rnTn.allSpaceMap),
    rowGap: (0, $4rnTn.positiveSpaceMap),
    top: (0, $4rnTn.allSpaceMap),
    width: (0, $4rnTn.dimensionMap),
    zIndex: (0, $4rnTn.layerMap)
};
var $dc5dc2d6aef18230$var$uniqueSymbol = Symbol('UNSAFE_INTERNAL_styles');
var $dc5dc2d6aef18230$var$isSafeEnvToThrow = function isSafeEnvToThrow() {
    return (typeof $3ZMUU === "undefined" ? "undefined" : (0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))($3ZMUU)) === 'object' && (0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))($3ZMUU.env) === 'object' && false;
};
var $dc5dc2d6aef18230$var$reNestedSelectors = /(\.|\s|&+|\*\>|#|\[.*\])/;
var $dc5dc2d6aef18230$var$safeSelectors = /^@media .*$|^::?.*$|^@supports .*$/;
var $dc5dc2d6aef18230$var$_transformStyles = function transformStyles(styleObj) {
    if (!styleObj || (0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(styleObj) !== 'object') return styleObj;
    // If styles are defined as a CSSObject[], recursively call on each element until we reach CSSObject
    if (Array.isArray(styleObj)) return styleObj.map($dc5dc2d6aef18230$var$_transformStyles);
    // Modifies styleObj in place. Be careful.
    Object.entries(styleObj).forEach(function(_ref) {
        var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_ref, 2), key = _ref2[0], value = _ref2[1];
        // If key is a pseudo class or a pseudo element, then value should be an object.
        // So, call transformStyles on the value
        if ((0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(value) === 'object' && $dc5dc2d6aef18230$var$safeSelectors.test(key)) {
            styleObj[key] = $dc5dc2d6aef18230$var$_transformStyles(value);
            return;
        }
        if ($dc5dc2d6aef18230$var$isSafeEnvToThrow()) {
            // We don't support `.class`, `[data-testid]`, `> *`, `#some-id`
            if ($dc5dc2d6aef18230$var$reNestedSelectors.test(key)) throw new Error("Styles not supported for key '".concat(key, "'."));
        }
        // We have now dealt with all the special cases, so,
        // check whether what remains is a style property
        // that can be transformed.
        if (!(key in $dc5dc2d6aef18230$export$9a199fbafee0014e)) return;
        var tokenValue = $dc5dc2d6aef18230$export$9a199fbafee0014e[key][value];
        styleObj[key] = tokenValue !== null && tokenValue !== void 0 ? tokenValue : value;
    });
    return styleObj;
};
var $dc5dc2d6aef18230$var$baseXcss = function baseXcss(style) {
    var transformedStyles = $dc5dc2d6aef18230$var$_transformStyles(style);
    return (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, $dc5dc2d6aef18230$var$uniqueSymbol, (0, $74Zh5.css)(transformedStyles));
};
/**
 * Picks out runtime XCSS objects and build-time XCSS strings. This is needed
 * to supported both Emotion and Compiled styles until we've fully migrated
 * to Compiled.
 *
 * @private
 * @deprecated
 */ var $dc5dc2d6aef18230$export$a9c84988c8f81f2d = function parseXcss(args) {
    if (Array.isArray(args)) {
        var emotion = [];
        var staticArr = [];
        var _iterator = $dc5dc2d6aef18230$var$_createForOfIteratorHelper(args), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var arg = _step.value;
                var result = $dc5dc2d6aef18230$export$a9c84988c8f81f2d(arg);
                if (result.emotion) emotion.push.apply(emotion, (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(result.emotion));
                if (result.static) staticArr.push(result.static);
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
        return {
            emotion: emotion,
            static: staticArr.join(' ')
        };
    }
    var objArgs = args;
    var _ref4 = objArgs || {}, styles = _ref4[$dc5dc2d6aef18230$var$uniqueSymbol];
    if (styles) return {
        emotion: [
            styles
        ]
    };
    if (args) {
        // We use string interpolation here instead of .toString() just
        // in case the resulting object doesn't have the method available.
        var stringifiedArgs = "".concat(args);
        if (stringifiedArgs) return {
            static: stringifiedArgs
        };
    }
    return {};
};
function $dc5dc2d6aef18230$export$f6c783d06584602c(style) {
    return $dc5dc2d6aef18230$var$baseXcss(style);
}

});


parcelRegister("c0EaG", function(module, exports) {
$parcel$export(module.exports, "default", () => $8be4a5516f741779$export$2e2bcd8739ae039);
/* spinner.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $kJ5MV = parcelRequire("kJ5MV");

var $5FkrB = parcelRequire("5FkrB");

var $eqVaP = parcelRequire("eqVaP");

var $6qCLx = parcelRequire("6qCLx");
/**
 * Returns the appropriate circle stroke color.
 */ function $8be4a5516f741779$var$getStrokeColor(appearance) {
    return appearance === 'inherit' ? "var(--ds-icon-subtle, #505258)" : "var(--ds-icon-inverse, #FFFFFF)";
}
var $8be4a5516f741779$var$rotate = null;
/**
 * There are three parts to the load in animation:
 * 1. Accelerated spin
 * 2. Stretch the spinner line
 */ var $8be4a5516f741779$var$loadIn = null;
var $8be4a5516f741779$var$styles = {
    rotateStyles: "_j7hqsf8s _5sag12kz _tip812c5 _1pgl2qsq _8hrz1h6o",
    loadInStyles: "_j7hq1ky6 _5sag9cwz _1pgl1ytf _1o51q7pw",
    wrapperStyles: "_1e0c116y _s7n4nkob",
    circleStyles: "_lswuglyw _7ljx1dhp _1snbbs82 _jcxd7g3v _1tjm1onz"
};
/**
 * `useLayoutEffect` is being used in SSR safe form. On the server, this work doesn’t need to run.
 * `useEffect` is used in-place, because `useEffect` is not run on the server and it matches types
 * which makes things simpler than doing an `isServer` check or a `null` check.
 *
 * @see https://hello.atlassian.net/wiki/spaces/DST/pages/2081696628/DSTDACI-010+-+Interaction+Tracing+hooks+in+DS+components
 */ var $8be4a5516f741779$var$useLayoutEffect = typeof window === 'undefined' ? (0, $5FkrB.useEffect) : (0, $5FkrB.useLayoutEffect);
/**
 * __Spinner__
 *
 * A spinner is an animated spinning icon that lets users know content is being loaded.
 *
 * - [Examples](https://atlassian.design/components/spinner/examples)
 * - [Code](https://atlassian.design/components/spinner/code)
 * - [Usage](https://atlassian.design/components/spinner/usage)
 */ var $8be4a5516f741779$var$Spinner = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).forwardRef(function Spinner(_ref, ref) {
    var _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'inherit' : _ref$appearance, _ref$delay = _ref.delay, delay = _ref$delay === void 0 ? 0 : _ref$delay, interactionName = _ref.interactionName, label = _ref.label, _ref$size = _ref.size, providedSize = _ref$size === void 0 ? 'medium' : _ref$size, testId = _ref.testId;
    var size = typeof providedSize === 'number' ? providedSize : (0, $6qCLx.presetSizes)[providedSize];
    var animationDelay = "".concat(delay, "ms");
    var stroke = $8be4a5516f741779$var$getStrokeColor(appearance);
    var context = (0, $5FkrB.useContext)((0, $eqVaP.default));
    $8be4a5516f741779$var$useLayoutEffect(function() {
        if (context != null) return context.hold(interactionName);
    }, [
        context,
        interactionName
    ]);
    /**
   * The Spinner animation uses a combination of two
   * css animations on two separate elements.
   */ return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("span", {
        "data-testid": testId ? "".concat(testId, "-wrapper") : 'spinner-wrapper',
        style: {
            animationDelay: animationDelay,
            width: size,
            height: size
        },
        className: (0, $kJ5MV.default)([
            $8be4a5516f741779$var$styles.wrapperStyles,
            $8be4a5516f741779$var$styles.rotateStyles
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("svg", {
        height: size,
        width: size,
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg",
        "data-testid": testId,
        ref: ref,
        "aria-label": label || undefined,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            animationDelay: animationDelay
        },
        role: label ? 'img' : 'none',
        className: (0, $kJ5MV.default)([
            $8be4a5516f741779$var$styles.loadInStyles
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("circle", {
        cx: "8",
        cy: "8",
        r: "7",
        style: {
            stroke: stroke
        },
        className: (0, $kJ5MV.default)([
            $8be4a5516f741779$var$styles.circleStyles
        ])
    })));
}));
var $8be4a5516f741779$export$2e2bcd8739ae039 = $8be4a5516f741779$var$Spinner;

});
parcelRegister("6qCLx", function(module, exports) {
$parcel$export(module.exports, "presetSizes", () => $4ae33ddd337f5582$export$4e9f1640bbe7a1a8);
var $4ae33ddd337f5582$export$4e9f1640bbe7a1a8 = {
    xsmall: 12,
    small: 16,
    medium: 24,
    large: 48,
    xlarge: 96
};

});


parcelRegister("5lq33", function(module, exports) {
$parcel$export(module.exports, "default", () => $3e431e88adee9cc3$export$2e2bcd8739ae039);
/* icon-renderer.tsx generated by @compiled/babel-plugin v0.39.1 */ 

var $5FkrB = parcelRequire("5FkrB");

var $9Zzpd = parcelRequire("9Zzpd");

var $5KP8M = parcelRequire("5KP8M");
// Map lozenge colors to appropriate icon colors
var $3e431e88adee9cc3$var$getIconColor = function getIconColor(color) {
    // For semantic colors, use corresponding semantic icon colors
    switch(color){
        case 'success':
            return "var(--ds-icon-success, #6A9A23)";
        case 'warning':
            return "var(--ds-icon-warning, #E06C00)";
        case 'danger':
            return "var(--ds-icon-danger, #C9372C)";
        case 'information':
            return "var(--ds-icon-information, #357DE8)";
        case 'neutral':
            return "var(--ds-icon-subtlest, #6B6E76)";
        case 'discovery':
            return "var(--ds-icon-discovery, #AF59E1)";
        // For accent colors, use corresponding accent icon colors
        case 'accent-red':
            return "var(--ds-icon-accent-red, #C9372C)";
        case 'accent-orange':
            return "var(--ds-icon-accent-orange, #E06C00)";
        case 'accent-yellow':
            return "var(--ds-icon-accent-yellow, #B38600)";
        case 'accent-lime':
            return "var(--ds-icon-accent-lime, #6A9A23)";
        case 'accent-green':
            return "var(--ds-icon-accent-green, #22A06B)";
        case 'accent-teal':
            return "var(--ds-icon-accent-teal, #2898BD)";
        case 'accent-blue':
            return "var(--ds-icon-accent-blue, #357DE8)";
        case 'accent-purple':
            return "var(--ds-icon-accent-purple, #AF59E1)";
        case 'accent-magenta':
            return "var(--ds-icon-accent-magenta, #CD519D)";
        case 'accent-gray':
            return "var(--ds-icon-accent-gray, #7D818A)";
        default:
            return "var(--ds-icon-subtlest, #6B6E76)";
    }
};
var $3e431e88adee9cc3$var$styles = {
    motion: "_k8m01ylx _1oeci9qs _6fl41d08"
};
var $3e431e88adee9cc3$export$32ff197eed95e568 = function IconRenderer(_ref) {
    var Icon = _ref.icon, color = _ref.color, testId = _ref.testId, size = _ref.size;
    var iconColor = $3e431e88adee9cc3$var$getIconColor(color);
    return (0, $9Zzpd.fg)('platform-dst-motion-uplift') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $5KP8M.default), {
        xcss: $3e431e88adee9cc3$var$styles.motion,
        style: {
            color: iconColor
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(Icon, {
        label: "",
        size: size,
        testId: testId
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(Icon, {
        color: iconColor,
        label: "",
        size: size,
        testId: testId
    });
};
var $3e431e88adee9cc3$export$2e2bcd8739ae039 = $3e431e88adee9cc3$export$32ff197eed95e568;

});
parcelRegister("5KP8M", function(module, exports) {
$parcel$export(module.exports, "default", () => $4308eb16285ed11e$export$2e2bcd8739ae039);
/* box.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $kqp0i = parcelRequire("kqp0i");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");

var $kJ5MV = parcelRequire("kJ5MV");

var $3C8nX = parcelRequire("3C8nX");
var $4308eb16285ed11e$var$_excluded = [
    "as",
    "children",
    "backgroundColor",
    "padding",
    "paddingBlock",
    "paddingBlockStart",
    "paddingBlockEnd",
    "paddingInline",
    "paddingInlineStart",
    "paddingInlineEnd",
    "style",
    "testId",
    "xcss"
], $4308eb16285ed11e$var$_excluded2 = [
    "className"
];
// Can either Exclude or Extract - here we're excluding all SVG-related elements, <button> elements (handled by Pressable), and <a> elements (handled by Anchor)
// Basically just ElementType but without ComponentType, it makes sense to keep the "Type" suffix
// eslint-disable-next-line @repo/internal/react/consistent-types-definitions
var $4308eb16285ed11e$var$baseStyles = null;
var $4308eb16285ed11e$var$backgroundColorMap = {
    'color.background.accent.lime.subtlest': "_bfhkm890",
    'color.background.accent.lime.subtlest.hovered': "_bfhkd4y8",
    'color.background.accent.lime.subtlest.pressed': "_bfhkkuup",
    'color.background.accent.lime.subtler': "_bfhkz2ec",
    'color.background.accent.lime.subtler.hovered': "_bfhk1gf0",
    'color.background.accent.lime.subtler.pressed': "_bfhk2kxc",
    'color.background.accent.lime.subtle': "_bfhkbq5w",
    'color.background.accent.lime.subtle.hovered': "_bfhkfoww",
    'color.background.accent.lime.subtle.pressed': "_bfhk1jbd",
    'color.background.accent.lime.bolder': "_bfhktde4",
    'color.background.accent.lime.bolder.hovered': "_bfhknzpa",
    'color.background.accent.lime.bolder.pressed': "_bfhkh0j0",
    'color.background.accent.red.subtlest': "_bfhk1vk5",
    'color.background.accent.red.subtlest.hovered': "_bfhk1i6i",
    'color.background.accent.red.subtlest.pressed': "_bfhknbir",
    'color.background.accent.red.subtler': "_bfhk1rtt",
    'color.background.accent.red.subtler.hovered': "_bfhkaffd",
    'color.background.accent.red.subtler.pressed': "_bfhk1j5a",
    'color.background.accent.red.subtle': "_bfhkkrt9",
    'color.background.accent.red.subtle.hovered': "_bfhk1sou",
    'color.background.accent.red.subtle.pressed': "_bfhk1fnn",
    'color.background.accent.red.bolder': "_bfhkuibq",
    'color.background.accent.red.bolder.hovered': "_bfhk100f",
    'color.background.accent.red.bolder.pressed': "_bfhk1cl6",
    'color.background.accent.orange.subtlest': "_bfhkf5uh",
    'color.background.accent.orange.subtlest.hovered': "_bfhk19yr",
    'color.background.accent.orange.subtlest.pressed': "_bfhkf90x",
    'color.background.accent.orange.subtler': "_bfhk165s",
    'color.background.accent.orange.subtler.hovered': "_bfhk1ei0",
    'color.background.accent.orange.subtler.pressed': "_bfhkdpo3",
    'color.background.accent.orange.subtle': "_bfhk1kkj",
    'color.background.accent.orange.subtle.hovered': "_bfhk9mfs",
    'color.background.accent.orange.subtle.pressed': "_bfhkaxpp",
    'color.background.accent.orange.bolder': "_bfhk1qg1",
    'color.background.accent.orange.bolder.hovered': "_bfhk12qo",
    'color.background.accent.orange.bolder.pressed': "_bfhk1fyq",
    'color.background.accent.yellow.subtlest': "_bfhkibhp",
    'color.background.accent.yellow.subtlest.hovered': "_bfhkaetg",
    'color.background.accent.yellow.subtlest.pressed': "_bfhk1o1l",
    'color.background.accent.yellow.subtler': "_bfhk1773",
    'color.background.accent.yellow.subtler.hovered': "_bfhk1uw7",
    'color.background.accent.yellow.subtler.pressed': "_bfhk1r9w",
    'color.background.accent.yellow.subtle': "_bfhk8y3s",
    'color.background.accent.yellow.subtle.hovered': "_bfhk819w",
    'color.background.accent.yellow.subtle.pressed': "_bfhk1jx0",
    'color.background.accent.yellow.bolder': "_bfhk1vop",
    'color.background.accent.yellow.bolder.hovered': "_bfhkkjqf",
    'color.background.accent.yellow.bolder.pressed': "_bfhk1okt",
    'color.background.accent.green.subtlest': "_bfhkn729",
    'color.background.accent.green.subtlest.hovered': "_bfhk3utz",
    'color.background.accent.green.subtlest.pressed': "_bfhkyfny",
    'color.background.accent.green.subtler': "_bfhk1wnw",
    'color.background.accent.green.subtler.hovered': "_bfhk1e2h",
    'color.background.accent.green.subtler.pressed': "_bfhkybhx",
    'color.background.accent.green.subtle': "_bfhk1rsu",
    'color.background.accent.green.subtle.hovered': "_bfhk12e3",
    'color.background.accent.green.subtle.pressed': "_bfhk1g86",
    'color.background.accent.green.bolder': "_bfhk1e5c",
    'color.background.accent.green.bolder.hovered': "_bfhka5yi",
    'color.background.accent.green.bolder.pressed': "_bfhk1j68",
    'color.background.accent.teal.subtlest': "_bfhk7xuz",
    'color.background.accent.teal.subtlest.hovered': "_bfhk108c",
    'color.background.accent.teal.subtlest.pressed': "_bfhk1cxp",
    'color.background.accent.teal.subtler': "_bfhk1a17",
    'color.background.accent.teal.subtler.hovered': "_bfhkkwwr",
    'color.background.accent.teal.subtler.pressed': "_bfhk1jb0",
    'color.background.accent.teal.subtle': "_bfhktdv8",
    'color.background.accent.teal.subtle.hovered': "_bfhkzh8h",
    'color.background.accent.teal.subtle.pressed': "_bfhk16zl",
    'color.background.accent.teal.bolder': "_bfhk2c8p",
    'color.background.accent.teal.bolder.hovered': "_bfhkl3ve",
    'color.background.accent.teal.bolder.pressed': "_bfhktor0",
    'color.background.accent.blue.subtlest': "_bfhk1s93",
    'color.background.accent.blue.subtlest.hovered': "_bfhkdaj9",
    'color.background.accent.blue.subtlest.pressed': "_bfhkxm0g",
    'color.background.accent.blue.subtler': "_bfhk1dy8",
    'color.background.accent.blue.subtler.hovered': "_bfhk815t",
    'color.background.accent.blue.subtler.pressed': "_bfhkrwxf",
    'color.background.accent.blue.subtle': "_bfhk115i",
    'color.background.accent.blue.subtle.hovered': "_bfhk9pr4",
    'color.background.accent.blue.subtle.pressed': "_bfhknpx7",
    'color.background.accent.blue.bolder': "_bfhk16e3",
    'color.background.accent.blue.bolder.hovered': "_bfhk1vbm",
    'color.background.accent.blue.bolder.pressed': "_bfhk1xwi",
    'color.background.accent.purple.subtlest': "_bfhkp2ly",
    'color.background.accent.purple.subtlest.hovered': "_bfhkkca2",
    'color.background.accent.purple.subtlest.pressed': "_bfhk1jbm",
    'color.background.accent.purple.subtler': "_bfhk1nm4",
    'color.background.accent.purple.subtler.hovered': "_bfhkattl",
    'color.background.accent.purple.subtler.pressed': "_bfhk3nfk",
    'color.background.accent.purple.subtle': "_bfhk18ah",
    'color.background.accent.purple.subtle.hovered': "_bfhk8bp1",
    'color.background.accent.purple.subtle.pressed': "_bfhk1cd2",
    'color.background.accent.purple.bolder': "_bfhkya33",
    'color.background.accent.purple.bolder.hovered': "_bfhk1af5",
    'color.background.accent.purple.bolder.pressed': "_bfhk6cze",
    'color.background.accent.magenta.subtlest': "_bfhk8tvm",
    'color.background.accent.magenta.subtlest.hovered': "_bfhkr3zd",
    'color.background.accent.magenta.subtlest.pressed': "_bfhk1ckf",
    'color.background.accent.magenta.subtler': "_bfhkv9ra",
    'color.background.accent.magenta.subtler.hovered': "_bfhk1axx",
    'color.background.accent.magenta.subtler.pressed': "_bfhk42ri",
    'color.background.accent.magenta.subtle': "_bfhk1mi6",
    'color.background.accent.magenta.subtle.hovered': "_bfhkrwyz",
    'color.background.accent.magenta.subtle.pressed': "_bfhk6c15",
    'color.background.accent.magenta.bolder': "_bfhkc3uk",
    'color.background.accent.magenta.bolder.hovered': "_bfhk1ok8",
    'color.background.accent.magenta.bolder.pressed': "_bfhkeawv",
    'color.background.accent.gray.subtlest': "_bfhkysee",
    'color.background.accent.gray.subtlest.hovered': "_bfhkwejn",
    'color.background.accent.gray.subtlest.pressed': "_bfhk18ut",
    'color.background.accent.gray.subtler': "_bfhk7qp0",
    'color.background.accent.gray.subtler.hovered': "_bfhk10ef",
    'color.background.accent.gray.subtler.pressed': "_bfhk1rk9",
    'color.background.accent.gray.subtle': "_bfhk18j9",
    'color.background.accent.gray.subtle.hovered': "_bfhk1nv3",
    'color.background.accent.gray.subtle.pressed': "_bfhkq9tj",
    'color.background.accent.gray.bolder': "_bfhk1i45",
    'color.background.accent.gray.bolder.hovered': "_bfhkbyip",
    'color.background.accent.gray.bolder.pressed': "_bfhk1van",
    'color.background.disabled': "_bfhkby5v",
    'color.background.input': "_bfhk1j9a",
    'color.background.input.hovered': "_bfhkl4ek",
    'color.background.input.pressed': "_bfhkr01l",
    'color.background.inverse.subtle': "_bfhk1vck",
    'color.background.inverse.subtle.hovered': "_bfhkmpja",
    'color.background.inverse.subtle.pressed': "_bfhk1gii",
    'color.background.neutral': "_bfhki8nm",
    'color.background.neutral.hovered': "_bfhkplhp",
    'color.background.neutral.pressed': "_bfhk1gdz",
    'color.background.neutral.subtle': "_bfhksm61",
    'color.background.neutral.subtle.hovered': "_bfhk1dpa",
    'color.background.neutral.subtle.pressed': "_bfhkfcek",
    'color.background.neutral.bold': "_bfhk1aqn",
    'color.background.neutral.bold.hovered': "_bfhk1ibz",
    'color.background.neutral.bold.pressed': "_bfhkof27",
    'color.background.selected': "_bfhk15s3",
    'color.background.selected.hovered': "_bfhkufnl",
    'color.background.selected.pressed': "_bfhknozp",
    'color.background.selected.bold': "_bfhkjmqp",
    'color.background.selected.bold.hovered': "_bfhk1q28",
    'color.background.selected.bold.pressed': "_bfhk12kk",
    'color.background.brand.subtlest': "_bfhk1gmr",
    'color.background.brand.subtlest.hovered': "_bfhk3v15",
    'color.background.brand.subtlest.pressed': "_bfhku02c",
    'color.background.brand.bold': "_bfhk1856",
    'color.background.brand.bold.hovered': "_bfhkhf2y",
    'color.background.brand.bold.pressed': "_bfhkg6ey",
    'color.background.brand.boldest': "_bfhk1o4i",
    'color.background.brand.boldest.hovered': "_bfhklefx",
    'color.background.brand.boldest.pressed': "_bfhk16k6",
    'color.background.danger': "_bfhk1gly",
    'color.background.danger.hovered': "_bfhk1yvi",
    'color.background.danger.pressed': "_bfhk1r4b",
    'color.background.danger.bold': "_bfhkybec",
    'color.background.danger.bold.hovered': "_bfhks9hg",
    'color.background.danger.bold.pressed': "_bfhk13a9",
    'color.background.warning': "_bfhk1917",
    'color.background.warning.hovered': "_bfhk19zu",
    'color.background.warning.pressed': "_bfhkzr32",
    'color.background.warning.bold': "_bfhk1kmu",
    'color.background.warning.bold.hovered': "_bfhk1spp",
    'color.background.warning.bold.pressed': "_bfhk4m4m",
    'color.background.success': "_bfhk1y9u",
    'color.background.success.hovered': "_bfhk1vfx",
    'color.background.success.pressed': "_bfhk1wl5",
    'color.background.success.bold': "_bfhkkcmj",
    'color.background.success.bold.hovered': "_bfhky7x8",
    'color.background.success.bold.pressed': "_bfhkwcbh",
    'color.background.discovery': "_bfhk6vm6",
    'color.background.discovery.hovered': "_bfhk12eq",
    'color.background.discovery.pressed': "_bfhk18vq",
    'color.background.discovery.bold': "_bfhku5tj",
    'color.background.discovery.bold.hovered': "_bfhkfqeg",
    'color.background.discovery.bold.pressed': "_bfhk1f1m",
    'color.background.information': "_bfhk19ip",
    'color.background.information.hovered': "_bfhk86z5",
    'color.background.information.pressed': "_bfhk1c1j",
    'color.background.information.bold': "_bfhkx4w0",
    'color.background.information.bold.hovered': "_bfhkq2ii",
    'color.background.information.bold.pressed': "_bfhkf89v",
    'color.blanket': "_bfhk1i5c",
    'color.blanket.selected': "_bfhk7wq0",
    'color.blanket.danger': "_bfhkrprw",
    'color.skeleton': "_bfhkizff",
    'color.skeleton.subtle': "_bfhkvkf5",
    'elevation.surface': "_bfhkvuon",
    'elevation.surface.hovered': "_bfhk19i6",
    'elevation.surface.pressed': "_bfhk13ro",
    'elevation.surface.overlay': "_bfhk1bhr",
    'elevation.surface.overlay.hovered': "_bfhk6o2t",
    'elevation.surface.overlay.pressed': "_bfhkm8nx",
    'elevation.surface.raised': "_bfhkhp5a",
    'elevation.surface.raised.hovered': "_bfhk116u",
    'elevation.surface.raised.pressed': "_bfhk14aj",
    'elevation.surface.sunken': "_bfhkhfxm",
    'utility.elevation.surface.current': "_bfhkchd4"
};
var $4308eb16285ed11e$var$CURRENT_SURFACE_CSS_VAR = "--ds-elevation-surface-current";
var $4308eb16285ed11e$var$setSurfaceTokenMap = {
    'elevation.surface': "_1q1lvuon",
    'elevation.surface.hovered': "_1q1l19i6",
    'elevation.surface.pressed': "_1q1l13ro",
    'elevation.surface.overlay': "_1q1l1bhr",
    'elevation.surface.overlay.hovered': "_1q1l6o2t",
    'elevation.surface.overlay.pressed': "_1q1lm8nx",
    'elevation.surface.raised': "_1q1lhp5a",
    'elevation.surface.raised.hovered': "_1q1l116u",
    'elevation.surface.raised.pressed': "_1q1l14aj",
    'elevation.surface.sunken': "_1q1lhfxm"
};
var $4308eb16285ed11e$var$paddingBlockStartMap = {
    'space.0': "_1q51ze3t",
    'space.025': "_1q51v77o",
    'space.050': "_1q511b66",
    'space.075': "_1q5112x7",
    'space.100': "_1q51u2gc",
    'space.150': "_1q51utpp",
    'space.200': "_1q51pxbi",
    'space.250': "_1q51v47k",
    'space.300': "_1q511ejb",
    'space.400': "_1q51xy5q",
    'space.500': "_1q511jfw",
    'space.600': "_1q51oahv",
    'space.800': "_1q51xncg",
    'space.1000': "_1q511epz"
};
var $4308eb16285ed11e$var$paddingBlockEndMap = {
    'space.0': "_85i5ze3t",
    'space.025': "_85i5v77o",
    'space.050': "_85i51b66",
    'space.075': "_85i512x7",
    'space.100': "_85i5u2gc",
    'space.150': "_85i5utpp",
    'space.200': "_85i5pxbi",
    'space.250': "_85i5v47k",
    'space.300': "_85i51ejb",
    'space.400': "_85i5xy5q",
    'space.500': "_85i51jfw",
    'space.600': "_85i5oahv",
    'space.800': "_85i5xncg",
    'space.1000': "_85i51epz"
};
var $4308eb16285ed11e$var$paddingInlineStartMap = {
    'space.0': "_bozgze3t",
    'space.025': "_bozgv77o",
    'space.050': "_bozg1b66",
    'space.075': "_bozg12x7",
    'space.100': "_bozgu2gc",
    'space.150': "_bozgutpp",
    'space.200': "_bozgpxbi",
    'space.250': "_bozgv47k",
    'space.300': "_bozg1ejb",
    'space.400': "_bozgxy5q",
    'space.500': "_bozg1jfw",
    'space.600': "_bozgoahv",
    'space.800': "_bozgxncg",
    'space.1000': "_bozg1epz"
};
var $4308eb16285ed11e$var$paddingInlineEndMap = {
    'space.0': "_y4tize3t",
    'space.025': "_y4tiv77o",
    'space.050': "_y4ti1b66",
    'space.075': "_y4ti12x7",
    'space.100': "_y4tiu2gc",
    'space.150': "_y4tiutpp",
    'space.200': "_y4tipxbi",
    'space.250': "_y4tiv47k",
    'space.300': "_y4ti1ejb",
    'space.400': "_y4tixy5q",
    'space.500': "_y4ti1jfw",
    'space.600': "_y4tioahv",
    'space.800': "_y4tixncg",
    'space.1000': "_y4ti1epz"
};
/**
 * __Box__
 *
 * A Box is a primitive component that has the design decisions of the Atlassian Design System baked in.
 * Renders a `div` by default.
 *
 * - [Examples](https://atlassian.design/components/primitives/box/examples)
 * - [Code](https://atlassian.design/components/primitives/box/code)
 * - [Usage](https://atlassian.design/components/primitives/box/usage)
 */ var $4308eb16285ed11e$var$Box = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? 'div' : _ref$as, children = _ref.children, backgroundColor = _ref.backgroundColor, padding = _ref.padding, _ref$paddingBlock = _ref.paddingBlock, paddingBlock = _ref$paddingBlock === void 0 ? padding : _ref$paddingBlock, _ref$paddingBlockStar = _ref.paddingBlockStart, paddingBlockStart = _ref$paddingBlockStar === void 0 ? paddingBlock : _ref$paddingBlockStar, _ref$paddingBlockEnd = _ref.paddingBlockEnd, paddingBlockEnd = _ref$paddingBlockEnd === void 0 ? paddingBlock : _ref$paddingBlockEnd, _ref$paddingInline = _ref.paddingInline, paddingInline = _ref$paddingInline === void 0 ? padding : _ref$paddingInline, _ref$paddingInlineSta = _ref.paddingInlineStart, paddingInlineStart = _ref$paddingInlineSta === void 0 ? paddingInline : _ref$paddingInlineSta, _ref$paddingInlineEnd = _ref.paddingInlineEnd, paddingInlineEnd = _ref$paddingInlineEnd === void 0 ? paddingInline : _ref$paddingInlineEnd, style = _ref.style, testId = _ref.testId, xcss = _ref.xcss, htmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $4308eb16285ed11e$var$_excluded);
    // This is to remove className from safeHtmlAttributes
    // @ts-ignore -- not using expect since it causes issues with help-center local consumption - className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(htmlAttributes, $4308eb16285ed11e$var$_excluded2);
    var node = /*#__PURE__*/ $5FkrB.createElement(Component, (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        style: style,
        ref: ref,
        className: (0, $kJ5MV.default)([
            "_19itglyw _vchhusvi _r06hglyw",
            backgroundColor && $4308eb16285ed11e$var$backgroundColorMap[backgroundColor],
            backgroundColor && $4308eb16285ed11e$var$isSurfaceToken(backgroundColor) && $4308eb16285ed11e$var$setSurfaceTokenMap[backgroundColor],
            paddingBlockStart && $4308eb16285ed11e$var$paddingBlockStartMap[paddingBlockStart],
            paddingBlockEnd && $4308eb16285ed11e$var$paddingBlockEndMap[paddingBlockEnd],
            paddingInlineStart && $4308eb16285ed11e$var$paddingInlineStartMap[paddingInlineStart],
            paddingInlineEnd && $4308eb16285ed11e$var$paddingInlineEndMap[paddingInlineEnd],
            xcss
        ])
    }, safeHtmlAttributes, {
        "data-testid": testId
    }), children);
    if (backgroundColor) return /*#__PURE__*/ $5FkrB.createElement((0, $3C8nX.SurfaceContext).Provider, {
        value: backgroundColor
    }, node);
    return node;
});
var $4308eb16285ed11e$export$2e2bcd8739ae039 = $4308eb16285ed11e$var$Box;
function $4308eb16285ed11e$var$isSurfaceToken(backgroundColor) {
    return backgroundColor in $4308eb16285ed11e$var$setSurfaceTokenMap;
}

});


parcelRegister("cDbLf", function(module, exports) {
$parcel$export(module.exports, "resolveLozengeColor", () => $9322400e5d578b4d$export$acf5d2b7dc999bda);
$parcel$export(module.exports, "getThemeStyles", () => $9322400e5d578b4d$export$a3fc04b8551e006a);
// Map legacy appearance to new color values
var $9322400e5d578b4d$var$legacyAppearanceMap = {
    default: 'neutral',
    removed: 'danger',
    inprogress: 'information',
    new: 'discovery',
    moved: 'warning'
};
var $9322400e5d578b4d$export$acf5d2b7dc999bda = function resolveLozengeColor() {
    var _legacyAppearanceMap$;
    var appearance = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'neutral';
    if (appearance.startsWith('accent-')) return appearance;
    return (_legacyAppearanceMap$ = $9322400e5d578b4d$var$legacyAppearanceMap[appearance]) !== null && _legacyAppearanceMap$ !== void 0 ? _legacyAppearanceMap$ : appearance;
};
var $9322400e5d578b4d$export$a3fc04b8551e006a = function getThemeStyles(resolvedColor) {
    var isAccent = resolvedColor.startsWith('accent-');
    var category = isAccent ? 'accent' : 'semantic';
    var key = isAccent ? resolvedColor.replace('accent-', '') : resolvedColor;
    return {
        category: category,
        key: key
    };
};

});




parcelRegister("aNF62", function(module, exports) {
$parcel$export(module.exports, "useExitingPersistence", () => $7dce5bdaf433551a$export$3b6f38abbdcbd000);
$parcel$export(module.exports, "default", () => $7dce5bdaf433551a$export$2e2bcd8739ae039);

var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");

var $9Zzpd = parcelRequire("9Zzpd");
/**
 * Internally we will be playing with an element that will always have a key defined.
 */ /**
 * Internal data passed to child motions.
 */ // We define empty context here so the object doesn't change.
var $7dce5bdaf433551a$var$emptyContext = {
    // Motions will always appear if not inside a exiting persistence component.
    appear: true,
    isExiting: false
};
/**
 * __Exiting context__
 *
 * An exiting context.
 */ var $7dce5bdaf433551a$var$ExitingContext = /*#__PURE__*/ (0, $5FkrB.createContext)($7dce5bdaf433551a$var$emptyContext);
/**
 * This method will wrap any React element with a context provider. We're using context (instead of
 * cloneElement) so we can communicate between multiple elements without the need of prop drilling
 * (results in a better API for consumers).
 */ var $7dce5bdaf433551a$var$wrapChildWithContextProvider = function wrapChildWithContextProvider(child) {
    var value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $7dce5bdaf433551a$var$emptyContext;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement($7dce5bdaf433551a$var$ExitingContext.Provider, {
        key: "".concat(child.key, "-provider"),
        value: value
    }, child);
};
/**
 * This function will convert all children types to an array while also filtering out non-valid React elements.
 */ var $7dce5bdaf433551a$var$childrenToArray = function childrenToArray(children) {
    var childrenAsArray = [];
    // We convert children to an array using this helper method as it will add keys to children that do not
    // have them, such as when we have hardcoded children that are conditionally rendered.
    (0, $5FkrB.Children).toArray(children).forEach(function(child) {
        // We ignore any boolean children to make our code a little more simple later on,
        // and also filter out any falsies (empty strings, nulls, and undefined).
        if (typeof child !== 'boolean' && Boolean(child)) // Children WILL have a key after being forced into an array using the React.Children helper.
        childrenAsArray.push(child);
    });
    return childrenAsArray;
};
var $7dce5bdaf433551a$var$spliceNewElementsIntoPrevious = function spliceNewElementsIntoPrevious(current, previous) {
    var splicedChildren = previous.concat([]);
    var previousMap = $7dce5bdaf433551a$var$childrenToObj(previous);
    for(var i = 0; i < current.length; i++){
        var child = current[i];
        var childIsNew = !previousMap[child.key];
        if (childIsNew) // This will insert the new element after the previous element.
        splicedChildren.splice(i + 1, 0, child);
    }
    return splicedChildren;
};
var $7dce5bdaf433551a$var$childrenToObj = function childrenToObj(children) {
    return children.reduce(function(acc, child) {
        acc[child.key] = child;
        return acc;
    }, {});
};
var $7dce5bdaf433551a$var$getMissingKeys = function getMissingKeys(current, previous) {
    var currentMapKeys = new Set(current.map(function(child) {
        return child.key;
    }));
    var missing = new Set();
    for(var i = 0; i < previous.length; i++){
        var element = previous[i];
        var _key = element.key;
        if (!currentMapKeys.has(_key)) missing.add(_key);
    }
    return missing;
};
/**
 * How does this component work?
 *
 * It looks at changes in its children to see what is removed.
 *
 * If a child is removed it clones it and wraps it with context providing an `onFinish` callback.
 *
 * The cloned child will call the `onFinish` when it finishes its exit animation,
 * which lets `ExitingPersistence` know to stop rendering it.
 */ /**
 * __ExitingPersistence__
 *
 * Useful for enabling elements to persist and animate away when they are removed from the DOM.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/motion/docs/entering-motions)
 */ var $7dce5bdaf433551a$var$ExitingPersistence = /*#__PURE__*/ (0, $5FkrB.memo)(function(_ref) {
    var _ref$appear = _ref.appear, appear = _ref$appear === void 0 ? false : _ref$appear, children = _ref.children, exitThenEnter = _ref.exitThenEnter;
    var _useState = (0, $5FkrB.useState)([
        null,
        children
    ]), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), stateChildren = _useState2[0], setChildren = _useState2[1];
    var _useState3 = (0, $5FkrB.useState)([]), _useState4 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState3, 2), exitingChildren = _useState4[0], setExitingChildren = _useState4[1];
    var _useState5 = (0, $5FkrB.useState)(function() {
        return {
            appear: appear,
            isExiting: false
        };
    }), _useState6 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState5, 2), defaultContext = _useState6[0], setDefaultContext = _useState6[1];
    (0, $5FkrB.useEffect)(function() {
        if (!defaultContext.appear) setDefaultContext({
            appear: true,
            isExiting: false
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    /**
   * NOTE: This is a workaround for the test case written in Jira where the stateChildren is a boolean value because
   * useState is mocked to return a boolean value.
   */ if (typeof stateChildren === 'boolean') return children;
    var _stateChildren = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(stateChildren, 2), previousChildren = _stateChildren[0], currentChildren = _stateChildren[1];
    var previous = $7dce5bdaf433551a$var$childrenToArray(previousChildren);
    var current = $7dce5bdaf433551a$var$childrenToArray(currentChildren);
    if (currentChildren !== children) setChildren([
        currentChildren,
        children
    ]);
    var missingKeys = $7dce5bdaf433551a$var$getMissingKeys(current, previous);
    var isSomeChildRemoved = !!missingKeys.size;
    var visibleChildren = current;
    if (isSomeChildRemoved) visibleChildren = $7dce5bdaf433551a$var$spliceNewElementsIntoPrevious(current, previous);
    if (exitThenEnter) {
        if (exitingChildren.length) visibleChildren = (0, $9Zzpd.fg)('platform-dst-motion-uplift') ? previous : exitingChildren;
        else {
            var nextExitingChildren = visibleChildren.filter(function(child) {
                return missingKeys.has(child.key);
            });
            if (nextExitingChildren.length) setExitingChildren(nextExitingChildren);
        }
    }
    if (missingKeys.size) visibleChildren = visibleChildren.map(function(child) {
        var isExiting = missingKeys.has(child.key);
        return $7dce5bdaf433551a$var$wrapChildWithContextProvider(child, {
            appear: true,
            isExiting: isExiting,
            onFinish: isExiting ? function() {
                missingKeys.delete(child.key);
                if (missingKeys.size === 0) {
                    setChildren([
                        null,
                        children
                    ]);
                    setExitingChildren([]);
                }
            } : undefined
        });
    });
    else visibleChildren = visibleChildren.map(function(child) {
        return $7dce5bdaf433551a$var$wrapChildWithContextProvider(child, defaultContext);
    });
    return visibleChildren;
});
var $7dce5bdaf433551a$export$3b6f38abbdcbd000 = function useExitingPersistence() {
    return (0, $5FkrB.useContext)($7dce5bdaf433551a$var$ExitingContext);
};
$7dce5bdaf433551a$var$ExitingPersistence.displayName = 'ExitingPersistence';
var $7dce5bdaf433551a$export$2e2bcd8739ae039 = $7dce5bdaf433551a$var$ExitingPersistence;

});

parcelRegister("kctvn", function(module, exports) {
$parcel$export(module.exports, "default", () => $eb4bd0b7398aac21$export$2e2bcd8739ae039);

var $iYJcE = parcelRequire("iYJcE");

var $eqAKy = parcelRequire("eqAKy");

var $3CquG = parcelRequire("3CquG");

var $eVsTj = parcelRequire("eVsTj");

var $4uuz6 = parcelRequire("4uuz6");

var $aNF62 = parcelRequire("aNF62");
/**
 * __ShrinkOut__
 *
 * Will shrink an element down to nothing when exiting.
 * Works best with flex children as collapsing margins can come with undesired behaviour.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/motion/docs/entering-motions)
 */ var $eb4bd0b7398aac21$var$ShrinkOut = function ShrinkOut(_ref) {
    var children = _ref.children, _ref$duration = _ref.duration, duration = _ref$duration === void 0 ? 'small' : _ref$duration, onFinish = _ref.onFinish;
    var _useElementRef = (0, $eVsTj.useElementRef)(), _useElementRef2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useElementRef, 2), element = _useElementRef2[0], setElementRef = _useElementRef2[1];
    var exiting = (0, $aNF62.useExitingPersistence)();
    var requestAnimationFrame = (0, $3CquG.useRequestAnimationFrame)();
    var setTimeout = (0, $3CquG.useSetTimeout)();
    var direction = exiting.isExiting ? 'exiting' : 'entering';
    (0, $4uuz6.useLayoutEffect)(function() {
        if (exiting.isExiting && element) {
            var newStyles = {
                // We fix both width and height because when changing box sizing to border-box.
                width: "".concat(element.offsetWidth, "px"),
                height: "".concat(element.offsetHeight, "px"),
                boxSizing: 'border-box',
                willChange: 'width,margin'
            };
            Object.assign(element.style, newStyles);
            requestAnimationFrame(function() {
                requestAnimationFrame(function() {
                    var newStyles = {
                        width: '0px',
                        margin: '0px',
                        // We animate margin down to zero so it doesn't take any space.
                        transitionTimingFunction: 'cubic-bezier(0.8,0,0,0.8)',
                        transitionDuration: (0, $eqAKy.durations)[duration] + 'ms',
                        transitionProperty: 'width,margin'
                    };
                    Object.assign(element.style, newStyles);
                    setTimeout(function() {
                        exiting.onFinish && exiting.onFinish();
                        onFinish && onFinish('exiting');
                    }, (0, $eqAKy.durations)[duration]);
                });
            });
        }
    });
    return children({
        ref: setElementRef
    }, direction);
};
var $eb4bd0b7398aac21$export$2e2bcd8739ae039 = $eb4bd0b7398aac21$var$ShrinkOut;

});
parcelRegister("eqAKy", function(module, exports) {
$parcel$export(module.exports, "durations", () => $a81000281e311a76$export$38b928a7167ce124);
$parcel$export(module.exports, "exitingDurations", () => $a81000281e311a76$export$30fa1a2e62ae150c);
/**
 * Think of this as the motion equivalent of the @atlaskit/theme `grid()`.
 */ var $a81000281e311a76$export$368bacef0dacbe05 = 25;
var $a81000281e311a76$export$38b928a7167ce124 = {
    none: 0,
    small: 100,
    medium: 350,
    large: 700
};
/**
 * Used to multiply the initial duration for exiting motions.
 */ var $a81000281e311a76$var$EXITING_MOTION_MULTIPLIER = 0.5;
var $a81000281e311a76$export$30fa1a2e62ae150c = {
    none: $a81000281e311a76$export$38b928a7167ce124.none,
    small: $a81000281e311a76$export$38b928a7167ce124.small * $a81000281e311a76$var$EXITING_MOTION_MULTIPLIER,
    medium: $a81000281e311a76$export$38b928a7167ce124.medium * $a81000281e311a76$var$EXITING_MOTION_MULTIPLIER,
    large: $a81000281e311a76$export$38b928a7167ce124.large * $a81000281e311a76$var$EXITING_MOTION_MULTIPLIER
};

});

parcelRegister("3CquG", function(module, exports) {
$parcel$export(module.exports, "useRequestAnimationFrame", () => $2a2978d9adc4a4d3$export$1775f27e7c8051ca);
$parcel$export(module.exports, "useSetTimeout", () => $2a2978d9adc4a4d3$export$4f34107a2b00f39c);

var $5FkrB = parcelRequire("5FkrB");
// Handle both browser and Node.js environments
var $2a2978d9adc4a4d3$var$getHookDeps = function getHookDeps(opts) {
    switch(opts.cleanup){
        case 'next-effect':
            return undefined;
        case 'unmount':
        default:
            return [];
    }
};
var $2a2978d9adc4a4d3$export$1775f27e7c8051ca = function useRequestAnimationFrame() {
    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        cleanup: 'unmount'
    };
    var frames = (0, $5FkrB.useRef)([]);
    (0, $5FkrB.useEffect)(function() {
        return function() {
            if (frames.current.length) {
                frames.current.forEach(function(id) {
                    return cancelAnimationFrame(id);
                });
                frames.current = [];
            }
        };
    // We dynamically set this so we either clean up on the next effect - or on unmount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, $2a2978d9adc4a4d3$var$getHookDeps(opts));
    return (0, $5FkrB.useCallback)(function(handler) {
        var id = requestAnimationFrame(function(time) {
            frames.current = frames.current.filter(function(frameId) {
                return frameId !== id;
            });
            handler(time);
        });
        frames.current.push(id);
    }, []);
};
var $2a2978d9adc4a4d3$export$4f34107a2b00f39c = function useSetTimeout() {
    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        cleanup: 'unmount'
    };
    var timeouts = (0, $5FkrB.useRef)([]);
    (0, $5FkrB.useEffect)(function() {
        return function() {
            if (timeouts.current.length) {
                timeouts.current.forEach(function(id) {
                    return clearTimeout(id);
                });
                timeouts.current = [];
            }
        };
    // We dynamically set this so we either clean up on the next effect - or on unmount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, $2a2978d9adc4a4d3$var$getHookDeps(opts));
    return (0, $5FkrB.useCallback)(function(handler, timeout) {
        for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)args[_key - 2] = arguments[_key];
        var id = setTimeout.apply(void 0, [
            function() {
                timeouts.current = timeouts.current.filter(function(timeoutId) {
                    return timeoutId !== id;
                });
                handler();
            },
            timeout
        ].concat(args));
        timeouts.current.push(id);
    }, []);
};

});

parcelRegister("eVsTj", function(module, exports) {
$parcel$export(module.exports, "useElementRef", () => $addcccba53dac043$export$ff879f35a69d56b7);

var $5FkrB = parcelRequire("5FkrB");
var $addcccba53dac043$export$ff879f35a69d56b7 = function useElementRef() {
    var elementRef = (0, $5FkrB.useRef)(null);
    var setRef = (0, $5FkrB.useCallback)(function(ref) {
        elementRef.current = ref;
    }, []);
    return [
        elementRef.current,
        setRef
    ];
};

});

parcelRegister("4uuz6", function(module, exports) {
$parcel$export(module.exports, "useLayoutEffect", () => $3451ac6466de4e7e$export$e5c5a5f917a5871c);

var $5FkrB = parcelRequire("5FkrB");
var $3451ac6466de4e7e$export$e5c5a5f917a5871c = typeof window === 'undefined' ? (0, $5FkrB.useEffect) : (0, $5FkrB.useLayoutEffect);

});


parcelRegister("1XWyn", function(module, exports) {
$parcel$export(module.exports, "colorMapping", () => $16e8b8a7d33ff93c$export$3351a8d90bcc13aa);
$parcel$export(module.exports, "default", () => $16e8b8a7d33ff93c$export$2e2bcd8739ae039);
/* tag-new.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $kqp0i = parcelRequire("kqp0i");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");

var $kJ5MV = parcelRequire("kJ5MV");

var $ccsyC = parcelRequire("ccsyC");

var $fufde = parcelRequire("fufde");

var $h1qTB = parcelRequire("h1qTB");

var $c0EaG = parcelRequire("c0EaG");

var $l9PZq = parcelRequire("l9PZq");

var $ho5mL = parcelRequire("ho5mL");
var $16e8b8a7d33ff93c$var$_excluded = [
    "color",
    "text",
    "elemBefore",
    "href",
    "linkComponent",
    "isRemovable",
    "removeButtonLabel",
    "onBeforeRemoveAction",
    "onAfterRemoveAction",
    "testId",
    "maxWidth",
    "onClick",
    "swatchBefore"
], $16e8b8a7d33ff93c$var$_excluded2 = [
    "color",
    "text",
    "elemBefore",
    "testId",
    "maxWidth",
    "onClick",
    "isSelected",
    "isLoading",
    "analyticsContext",
    "hasChevron",
    "swatchBefore"
];
// CSS variable name for icon color - must be used as literal string in cssMap due to Compiled CSS static analysis
var $16e8b8a7d33ff93c$var$iconColorVar = '--ds-tag-icon';
var $16e8b8a7d33ff93c$export$3351a8d90bcc13aa = {
    standard: 'gray',
    grey: 'gray',
    blue: 'blue',
    green: 'green',
    red: 'red',
    yellow: 'yellow',
    purple: 'purple',
    lime: 'lime',
    magenta: 'magenta',
    orange: 'orange',
    teal: 'teal',
    // Light variants map to same as their non-light counterparts
    greyLight: 'gray',
    blueLight: 'blue',
    greenLight: 'green',
    redLight: 'red',
    yellowLight: 'yellow',
    purpleLight: 'purple',
    limeLight: 'lime',
    magentaLight: 'magenta',
    orangeLight: 'orange',
    tealLight: 'teal'
};
var $16e8b8a7d33ff93c$var$styles = {
    baseStyles: "_zulp1b66 _2rko12b0 _11c8wadc _1dqonqa1 _189ee4h9 _1mou1b66 _195g1b66 _1rjcv77o _18zr1mie _1e0c116y _vchhusvi _1ul9idpf _p12ff6dh _4t3i1k92 _kqswh2mm _4cvr1h6o _80om73ad _bfhksm61",
    removableStyles: "_zulp1b66",
    beforeStyles: "_4bfu1snc _1hmsagmp _ajmmvv82 _1e0c116y _4cvr1h6o _1o9zidpf _syaz125o",
    beforeStylesSelected: "_syazxl6c",
    textStyles: "_1reo15vq _18m915vq _1bto1l2s _o5721q9c _16jlkb7n _1ul9idpf _syazi7uo",
    textStylesSelected: "_syaz6x5g",
    afterStyles: "_1e0c1txw _4cvr1h6o _1o9zidpf _lcxv1wug _kqswh2mm",
    focusRingStyles: "_1ygbdfik _1ah3v77o",
    childFocusRingStyles: "_1a37dfik _1cwgv77o",
    interactiveBaseStyles: "_80omtlke _1all1b66 _qsdj1r31 _17ncglyw _15hpnqa1 _1rg815vq _1yoo15vq _j8j91snc _1afaagmp _gdbt10yn _h5vp116y _1qxz1h6o _8zx0idpf _1km4jdj5 _wc1fagmp _9408jdj5 _usew1snc _ebtnagmp _uvk910yn _10nj1r31 _1xq0glyw _18x1nqa1 _2mpsagmp",
    interactiveHoverStyles: "_17501r31 _qrsc8stv _1wodnqa1 _irr31dpa _rlyhjdj5 _1di6fcek"
};
// Border and icon color styles - each color sets CSS variables for its token values
var $16e8b8a7d33ff93c$var$colorStyles = {
    gray: "_119b8yml _1ib21diz",
    blue: "_119b1w55 _1ib26txe",
    green: "_119b1crs _1ib217hp",
    red: "_119b16y8 _1ib2nbxb",
    yellow: "_119bfeiv _1ib21oqg",
    purple: "_119b1hqq _1ib2uq3u",
    lime: "_119bnf89 _1ib28645",
    magenta: "_119buwd0 _1ib2v8hk",
    orange: "_119b1b2s _1ib21j6y",
    teal: "_119b1h3o _1ib28uof"
};
/* eslint-disable @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-important-styles, @atlaskit/ui-styling-standard/no-unsafe-values */ // Border + icon filter styles - base state
var $16e8b8a7d33ff93c$var$borderIconFilterStyles = {
    root: "_1h6dpryq _1k671038 _13muu67f _oe6mmko7 _m71tr3uz _168qx19p _wi6h1o1e _4uq11yqs _u8p61h4e _hg5mr3uz _1t75u67f _1f28f1ug _189qkb7n _1easrqqc _1knhjbtf"
};
// Border + icon filter styles - interactive states (hover/pressed)
var $16e8b8a7d33ff93c$var$borderIconInteractiveFilterStyles = {
    root: "_18dicjiy _hyog26zw _ylgq1r5k _bg3q9by0 _fdt01r5k _46v5hwvj _1iel6xdd _111i1h4e _l0666xdd _pclnn8xv _ockq1r5k _aewt1n8h _196p1btq _18mn783i _4cvxpc7y _zqoikzix _q4zt1ij0 _ba351r2o _75gvn2k3 _kgu3swso _ui3h1vs5 _1r84p7hp"
};
/* eslint-enable @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-important-styles, @atlaskit/ui-styling-standard/no-unsafe-values */ var $16e8b8a7d33ff93c$var$dropdownStyles = {
    interactive: "_irr31dpa _1di6fcek",
    selected: "_1h6dq98m _syaz6x5g _bfhk15s3 _irr3ufnl _1di6nozp",
    content: "_zulp1b66 _1reo15vq _18m915vq _1e0c116y _4cvr1h6o _16jlkb7n _1o9zkb7n _1ul9idpf",
    loadingContent: "_tzy4idpf",
    loadingOverlay: "_1reo15vq _18m915vq _1e0c1txw _kqswstnw _4cvr1h6o _1bah1h6o _u7coze3t _152tze3t _rjxpze3t _1e02ze3t _lcxvglyw"
};
/* eslint-enable @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-important-styles, @atlaskit/ui-styling-standard/no-unsafe-values */ /**
 * __TagNew__
 *
 * TagNew is the visual uplift implementation of Tag
 */ var $16e8b8a7d33ff93c$var$TagNewComponent = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function TagNew(_ref, ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'gray' : _ref$color, text = _ref.text, elemBefore = _ref.elemBefore, href = _ref.href, linkComponent = _ref.linkComponent, _ref$isRemovable = _ref.isRemovable, isRemovable = _ref$isRemovable === void 0 ? true : _ref$isRemovable, removeButtonLabel = _ref.removeButtonLabel, onBeforeRemoveAction = _ref.onBeforeRemoveAction, onAfterRemoveAction = _ref.onAfterRemoveAction, testId = _ref.testId, maxWidth = _ref.maxWidth, onClick = _ref.onClick, swatchBefore = _ref.swatchBefore, other = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $16e8b8a7d33ff93c$var$_excluded);
    var _useTagRemoval = (0, $l9PZq.useTagRemoval)(text, onBeforeRemoveAction, onAfterRemoveAction), status = _useTagRemoval.status, handleRemoveRequest = _useTagRemoval.handleRemoveRequest, onKeyPress = _useTagRemoval.onKeyPress, removingTag = _useTagRemoval.removingTag, showingTag = _useTagRemoval.showingTag;
    var _useLink = (0, $l9PZq.useLink)(href, linkComponent), isLink = _useLink.isLink, LinkComponent = _useLink.LinkComponent;
    var _useButtonInteraction = (0, $l9PZq.useButtonInteraction)(), isLinkHovered = _useButtonInteraction.isLinkHovered, isOverButton = _useButtonInteraction.isOverButton, isButtonFocused = _useButtonInteraction.isButtonFocused, isLinkFocused = _useButtonInteraction.isLinkFocused, buttonHandlers = _useButtonInteraction.buttonHandlers, linkHandlers = _useButtonInteraction.linkHandlers;
    var removeButton = (0, $l9PZq.useRemoveButton)({
        isRemovable: isRemovable,
        tagText: text,
        removeButtonLabel: removeButtonLabel,
        testId: testId,
        handleRemoveRequest: handleRemoveRequest,
        removingTag: removingTag,
        showingTag: showingTag,
        onKeyPress: onKeyPress,
        buttonHandlers: buttonHandlers
    });
    var tagContent = /*#__PURE__*/ $5FkrB.createElement("span", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, other, {
        ref: ref,
        "data-testid": testId,
        style: maxWidth !== undefined ? {
            maxWidth: maxWidth
        } : undefined,
        className: (0, $kJ5MV.default)([
            $16e8b8a7d33ff93c$var$styles.baseStyles,
            $16e8b8a7d33ff93c$var$colorStyles[color],
            $16e8b8a7d33ff93c$var$borderIconFilterStyles.root,
            isLink && $16e8b8a7d33ff93c$var$styles.interactiveBaseStyles,
            isLink && $16e8b8a7d33ff93c$var$styles.focusRingStyles,
            isLink && isLinkHovered && !isOverButton && $16e8b8a7d33ff93c$var$borderIconInteractiveFilterStyles.root,
            isLink && isLinkHovered && !isOverButton && $16e8b8a7d33ff93c$var$styles.interactiveHoverStyles,
            isRemovable && $16e8b8a7d33ff93c$var$styles.removableStyles,
            isLinkFocused && !isButtonFocused && $16e8b8a7d33ff93c$var$styles.childFocusRingStyles
        ])
    }), /*#__PURE__*/ $5FkrB.createElement((0, $l9PZq.LinkWrapper), {
        isLink: isLink,
        href: href,
        LinkComponent: LinkComponent,
        testId: testId,
        linkHandlers: linkHandlers,
        onClick: onClick
    }, /*#__PURE__*/ $5FkrB.createElement((0, $ho5mL.default), {
        colorKey: color,
        swatchBefore: swatchBefore
    }), elemBefore && /*#__PURE__*/ $5FkrB.createElement("span", {
        className: (0, $kJ5MV.default)([
            $16e8b8a7d33ff93c$var$styles.beforeStyles
        ])
    }, elemBefore), /*#__PURE__*/ $5FkrB.createElement("span", {
        "data-tag-text": true,
        className: (0, $kJ5MV.default)([
            $16e8b8a7d33ff93c$var$styles.textStyles
        ])
    }, text)), removeButton && /*#__PURE__*/ $5FkrB.createElement("span", {
        className: (0, $kJ5MV.default)([
            $16e8b8a7d33ff93c$var$styles.afterStyles
        ])
    }, removeButton));
    return /*#__PURE__*/ $5FkrB.createElement((0, $l9PZq.RemovableWrapper), {
        isRemovable: isRemovable,
        status: status
    }, tagContent);
});
var $16e8b8a7d33ff93c$export$aba6bd1190e79361 = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function TagDropdownTrigger(_ref2, ref) {
    var _ref2$color = _ref2.color, color = _ref2$color === void 0 ? 'gray' : _ref2$color, text = _ref2.text, elemBefore = _ref2.elemBefore, testId = _ref2.testId, maxWidth = _ref2.maxWidth, onClick = _ref2.onClick, _ref2$isSelected = _ref2.isSelected, isSelected = _ref2$isSelected === void 0 ? false : _ref2$isSelected, _ref2$isLoading = _ref2.isLoading, isLoading = _ref2$isLoading === void 0 ? false : _ref2$isLoading, _analyticsContext = _ref2.analyticsContext, _ref2$hasChevron = _ref2.hasChevron, hasChevron = _ref2$hasChevron === void 0 ? true : _ref2$hasChevron, swatchBefore = _ref2.swatchBefore, other = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref2, $16e8b8a7d33ff93c$var$_excluded2);
    var resolvedColor = $16e8b8a7d33ff93c$export$3351a8d90bcc13aa[color] || 'gray';
    return /*#__PURE__*/ $5FkrB.createElement((0, $h1qTB.default), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        ref: ref,
        xcss: (0, $ccsyC.cx)($16e8b8a7d33ff93c$var$styles.baseStyles, $16e8b8a7d33ff93c$var$colorStyles[resolvedColor], $16e8b8a7d33ff93c$var$dropdownStyles.interactive, $16e8b8a7d33ff93c$var$styles.focusRingStyles, $16e8b8a7d33ff93c$var$borderIconFilterStyles.root, $16e8b8a7d33ff93c$var$borderIconInteractiveFilterStyles.root, isSelected && $16e8b8a7d33ff93c$var$dropdownStyles.selected),
        onClick: isLoading ? undefined : onClick,
        style: {
            borderColor: isSelected ? "var(--ds-border-selected, #1868DB)" : undefined,
            cursor: isLoading ? 'progress' : 'pointer',
            maxWidth: maxWidth !== undefined ? maxWidth : undefined
        }
    }, isLoading && {
        'aria-busy': true,
        'aria-disabled': true,
        isDisabled: true
    }, {
        "data-testid": testId
    }, other), /*#__PURE__*/ $5FkrB.createElement("span", {
        className: (0, $kJ5MV.default)([
            $16e8b8a7d33ff93c$var$dropdownStyles.content,
            isLoading && $16e8b8a7d33ff93c$var$dropdownStyles.loadingContent
        ])
    }, /*#__PURE__*/ $5FkrB.createElement((0, $ho5mL.default), {
        colorKey: resolvedColor,
        swatchBefore: swatchBefore
    }), elemBefore && /*#__PURE__*/ $5FkrB.createElement("span", {
        className: (0, $kJ5MV.default)([
            $16e8b8a7d33ff93c$var$styles.beforeStyles,
            isSelected && $16e8b8a7d33ff93c$var$styles.beforeStylesSelected
        ])
    }, elemBefore), /*#__PURE__*/ $5FkrB.createElement("span", {
        "data-tag-text": true,
        className: (0, $kJ5MV.default)([
            $16e8b8a7d33ff93c$var$styles.textStyles,
            isSelected && $16e8b8a7d33ff93c$var$styles.textStylesSelected
        ])
    }, text), hasChevron && /*#__PURE__*/ $5FkrB.createElement((0, (/*@__PURE__*/$parcel$interopDefault($fufde))), {
        label: "",
        size: "small",
        color: 'currentColor',
        testId: testId && "".concat(testId, "--chevron")
    })), isLoading && /*#__PURE__*/ $5FkrB.createElement("span", {
        className: (0, $kJ5MV.default)([
            $16e8b8a7d33ff93c$var$dropdownStyles.loadingOverlay
        ])
    }, /*#__PURE__*/ $5FkrB.createElement((0, $c0EaG.default), {
        size: 'xsmall',
        label: ", Loading",
        testId: testId ? "".concat(testId, "--loading-spinner") : undefined
    })));
});
/**
 * __Tag new__
 */ var $16e8b8a7d33ff93c$var$TagNew = /*#__PURE__*/ (0, $5FkrB.memo)($16e8b8a7d33ff93c$var$TagNewComponent);
var $16e8b8a7d33ff93c$export$2e2bcd8739ae039 = $16e8b8a7d33ff93c$var$TagNew;

});
parcelRegister("ccsyC", function(module, exports) {
$parcel$export(module.exports, "cx", () => $8e1cc1ec7d59d8ed$export$a274e22fb40f762e);

var $kJ5MV = parcelRequire("kJ5MV");
const $8e1cc1ec7d59d8ed$export$a274e22fb40f762e = (...styles)=>{
    // At runtime TStyles is resolved down to strings, but not at compile time.
    // We circumvent the type system here because of that.
    const actualStyles = styles;
    // The output should be a union type of passed in styles. This ensures the call
    // site of xcss prop can raise violations when disallowed styles have been passed.
    return (0, $kJ5MV.default)(actualStyles);
};

});

parcelRegister("h1qTB", function(module, exports) {
$parcel$export(module.exports, "default", () => $c647649c3ca5bb9c$export$2e2bcd8739ae039);
/* pressable.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $kqp0i = parcelRequire("kqp0i");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");


var $ccsyC = parcelRequire("ccsyC");

var $TIb0j = parcelRequire("TIb0j");

var $bP0hC = parcelRequire("bP0hC");

var $3baOr = parcelRequire("3baOr");

var $eqVaP = parcelRequire("eqVaP");

var $b1eWp = parcelRequire("b1eWp");
var $c647649c3ca5bb9c$var$_excluded = [
    "children",
    "isDisabled",
    "type",
    "onClick",
    "interactionName",
    "componentName",
    "analyticsContext",
    "style",
    "testId",
    "xcss",
    "tabIndex"
], $c647649c3ca5bb9c$var$_excluded2 = [
    "className"
];
var $c647649c3ca5bb9c$var$styles = {
    root: "_19itglyw _vchhusvi _r06hglyw _80omtlke",
    disabled: "_80om13gf"
};
/**
 * __Pressable__
 *
 * A primitive for building custom buttons.
 *
 * - [Examples](https://atlassian.design/components/primitives/pressable/examples)
 * - [Code](https://atlassian.design/components/primitives/pressable/code)
 * - [Usage](https://atlassian.design/components/primitives/pressable/usage)
 */ var $c647649c3ca5bb9c$var$Pressable = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function(_ref, ref) {
    var children = _ref.children, isDisabled = _ref.isDisabled, _ref$type = _ref.type, type = _ref$type === void 0 ? 'button' : _ref$type, _ref$onClick = _ref.onClick, providedOnClick = _ref$onClick === void 0 ? (0, $3baOr.default) : _ref$onClick, interactionName = _ref.interactionName, componentName = _ref.componentName, analyticsContext = _ref.analyticsContext, style = _ref.style, testId = _ref.testId, xcss = _ref.xcss, tabIndex = _ref.tabIndex, htmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $c647649c3ca5bb9c$var$_excluded);
    var interactionContext = (0, $5FkrB.useContext)((0, $eqVaP.default));
    var handleClick = (0, $5FkrB.useCallback)(function(e, analyticsEvent) {
        interactionContext && interactionContext.tracePress(interactionName, e.timeStamp);
        providedOnClick(e, analyticsEvent);
    }, [
        providedOnClick,
        interactionContext,
        interactionName
    ]);
    var onClick = (0, $TIb0j.usePlatformLeafEventHandler)({
        fn: handleClick,
        action: 'clicked',
        componentName: componentName || 'Pressable',
        packageName: "@atlaskit/primitives",
        packageVersion: "0.0.0-development",
        analyticsData: analyticsContext,
        actionSubject: 'button'
    });
    // This is to remove className from safeHtmlAttributes
    // @ts-expect-error className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(htmlAttributes, $c647649c3ca5bb9c$var$_excluded2);
    return /*#__PURE__*/ $5FkrB.createElement((0, $b1eWp.default), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        as: "button",
        tabIndex: tabIndex !== null && tabIndex !== void 0 ? tabIndex : (0, $bP0hC.isSafari)() && !isDisabled ? 0 : undefined,
        style: style
    }, safeHtmlAttributes, {
        type: type,
        onClick: onClick,
        disabled: isDisabled,
        xcss: (0, $ccsyC.cx)($c647649c3ca5bb9c$var$styles.root, isDisabled && $c647649c3ca5bb9c$var$styles.disabled, xcss),
        testId: testId,
        ref: ref
    }), children);
});
var $c647649c3ca5bb9c$export$2e2bcd8739ae039 = $c647649c3ca5bb9c$var$Pressable;

});
parcelRegister("bP0hC", function(module, exports) {
$parcel$export(module.exports, "isSafari", () => $89b4ad612e36c2ca$export$95df08bae54cb4df);
function $89b4ad612e36c2ca$var$testPlatform(re) {
    var _userAgentData;
    return typeof window !== 'undefined' && window.navigator != null ? re.test(((_userAgentData = window.navigator['userAgentData']) === null || _userAgentData === void 0 ? void 0 : _userAgentData.platform) || window.navigator.platform) : false;
}
function $89b4ad612e36c2ca$var$isIPhone() {
    return $89b4ad612e36c2ca$var$testPlatform(/^iPhone/i);
}
function $89b4ad612e36c2ca$var$isMac() {
    return $89b4ad612e36c2ca$var$testPlatform(/^Mac/i);
}
function $89b4ad612e36c2ca$var$isIPad() {
    return $89b4ad612e36c2ca$var$testPlatform(/^iPad/i) || // iPadOS 13 lies and says it's a Mac, but we can distinguish by detecting touch support.
    $89b4ad612e36c2ca$var$isMac() && navigator.maxTouchPoints > 1;
}
function $89b4ad612e36c2ca$var$isIOS() {
    return $89b4ad612e36c2ca$var$isIPhone() || $89b4ad612e36c2ca$var$isIPad();
}
function $89b4ad612e36c2ca$export$95df08bae54cb4df() {
    if (typeof window !== 'undefined' && window.navigator != null) {
        var _window$navigator$use;
        var ua = (_window$navigator$use = window.navigator.userAgent) === null || _window$navigator$use === void 0 ? void 0 : _window$navigator$use.toLowerCase();
        return ua ? ua.includes('safari') && !ua.includes('chrome') : false;
    }
    return false;
}
function $89b4ad612e36c2ca$export$e1865c3bedcd822b() {
    return $89b4ad612e36c2ca$var$isMac() || $89b4ad612e36c2ca$var$isIOS();
}

});

parcelRegister("b1eWp", function(module, exports) {
$parcel$export(module.exports, "default", () => $805b60b1041c0ec3$export$2e2bcd8739ae039);
/* focusable.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $kqp0i = parcelRequire("kqp0i");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");

var $kJ5MV = parcelRequire("kJ5MV");
var $805b60b1041c0ec3$var$_excluded = [
    "as",
    "children",
    "isInset",
    "testId",
    "style",
    "xcss"
], $805b60b1041c0ec3$var$_excluded2 = [
    "className"
];
var $805b60b1041c0ec3$var$focusRingStyles = null;
var $805b60b1041c0ec3$var$insetFocusRingStyles = null;
/**
 * __Focus ring__
 *
 * A focus ring visually indicates the currently focused item.
 *
 */ var $805b60b1041c0ec3$var$Focusable = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? 'button' : _ref$as, children = _ref.children, isInset = _ref.isInset, testId = _ref.testId, style = _ref.style, xcss = _ref.xcss, htmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $805b60b1041c0ec3$var$_excluded);
    // This is to remove className from safeHtmlAttributes
    // @ts-ignore -- not using expect since it causes issues with help-center local consumption - className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(htmlAttributes, $805b60b1041c0ec3$var$_excluded2);
    return /*#__PURE__*/ $5FkrB.createElement(Component, (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, safeHtmlAttributes, {
        // @ts-ignore Expression produces a union type that is too complex to represent. We may be able to narrow the type here but unsure.
        ref: ref,
        className: (0, $kJ5MV.default)([
            "_ymio1r31 _ypr0glyw _zcxs1o36 _mizu194a _1ah3dkaa _ra3xnqa1 _128mdkaa _1cvmnqa1 _4davt94y",
            isInset && "_1ah31gjf _2mwq1gjf",
            xcss
        ]),
        style: style,
        "data-testid": testId
    }), children);
});
var $805b60b1041c0ec3$export$2e2bcd8739ae039 = $805b60b1041c0ec3$var$Focusable;

});


parcelRegister("l9PZq", function(module, exports) {
$parcel$export(module.exports, "useTagRemoval", () => $f672c44de32ac010$export$f26019543e9f862f);
$parcel$export(module.exports, "useLink", () => $f672c44de32ac010$export$dcf14c9974fe2767);
$parcel$export(module.exports, "useButtonInteraction", () => $f672c44de32ac010$export$84acd183858d8235);
$parcel$export(module.exports, "useRemoveButton", () => $f672c44de32ac010$export$97d8be09cd53869b);
$parcel$export(module.exports, "RemovableWrapper", () => $f672c44de32ac010$export$898a500849bb5cf4);
$parcel$export(module.exports, "LinkWrapper", () => $f672c44de32ac010$export$ce4b6a469c26f53f);
/* shared.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");


var $7wsxK = parcelRequire("7wsxK");

var $1PcVd = parcelRequire("1PcVd");

var $aNF62 = parcelRequire("aNF62");
var $kctvn = parcelRequire("kctvn");

var $5U0GO = parcelRequire("5U0GO");
var $f672c44de32ac010$export$203775b632e10448 = '--ds-tag-icon';
var $f672c44de32ac010$export$7d6deb4aa4b5840e = '--tag-border-token';
var $f672c44de32ac010$export$df7ff9c2f76bffcd = '--tag-icon-token';
var $f672c44de32ac010$export$74452314b63acabc = /*#__PURE__*/ function(TagStatus) {
    TagStatus["Showing"] = "showing";
    TagStatus["Removing"] = "removing";
    TagStatus["Removed"] = "removed";
    return TagStatus;
}({});
var $f672c44de32ac010$export$279e7025ed114474 = function defaultBeforeRemoveAction() {
    return true;
};
var $f672c44de32ac010$export$8793edee2d425525 = (0, $7wsxK.default);
function $f672c44de32ac010$export$f26019543e9f862f(text, onBeforeRemoveAction, onAfterRemoveAction) {
    var _useState = (0, $5FkrB.useState)($f672c44de32ac010$export$74452314b63acabc.Showing), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), status = _useState2[0], setStatus = _useState2[1];
    var handleRemoveComplete = (0, $5FkrB.useCallback)(function() {
        (onAfterRemoveAction !== null && onAfterRemoveAction !== void 0 ? onAfterRemoveAction : $f672c44de32ac010$export$8793edee2d425525)(text);
        setStatus($f672c44de32ac010$export$74452314b63acabc.Removed);
    }, [
        onAfterRemoveAction,
        text
    ]);
    var handleRemoveRequest = (0, $5FkrB.useCallback)(function() {
        var beforeAction = onBeforeRemoveAction !== null && onBeforeRemoveAction !== void 0 ? onBeforeRemoveAction : $f672c44de32ac010$export$279e7025ed114474;
        if (beforeAction()) handleRemoveComplete();
    }, [
        handleRemoveComplete,
        onBeforeRemoveAction
    ]);
    var onKeyPress = (0, $5FkrB.useCallback)(function(e) {
        var spacebarOrEnter = e.key === ' ' || e.key === 'Enter';
        if (spacebarOrEnter) {
            e.stopPropagation();
            handleRemoveRequest();
        }
    }, [
        handleRemoveRequest
    ]);
    var removingTag = (0, $5FkrB.useCallback)(function() {
        return setStatus($f672c44de32ac010$export$74452314b63acabc.Removing);
    }, []);
    var showingTag = (0, $5FkrB.useCallback)(function() {
        return setStatus($f672c44de32ac010$export$74452314b63acabc.Showing);
    }, []);
    return {
        status: status,
        handleRemoveRequest: handleRemoveRequest,
        onKeyPress: onKeyPress,
        removingTag: removingTag,
        showingTag: showingTag
    };
}
function $f672c44de32ac010$export$dcf14c9974fe2767(href, linkComponent) {
    var isLink = Boolean(href);
    var LinkComponent = linkComponent !== null && linkComponent !== void 0 ? linkComponent : (0, $1PcVd.default);
    return {
        isLink: isLink,
        LinkComponent: LinkComponent
    };
}
function $f672c44de32ac010$export$84acd183858d8235() {
    var _useState3 = (0, $5FkrB.useState)(false), _useState4 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState3, 2), isLinkHovered = _useState4[0], setIsLinkHovered = _useState4[1];
    var _useState5 = (0, $5FkrB.useState)(false), _useState6 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState5, 2), isOverButton = _useState6[0], setIsOverButton = _useState6[1];
    var _useState7 = (0, $5FkrB.useState)(false), _useState8 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState7, 2), isButtonFocused = _useState8[0], setIsButtonFocused = _useState8[1];
    var _useState9 = (0, $5FkrB.useState)(false), _useState0 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState9, 2), isLinkFocused = _useState0[0], setIsLinkFocused = _useState0[1];
    // Track if last interaction was via mouse (to determine keyboard vs mouse focus)
    var hadMouseDownRef = (0, $5FkrB.useRef)(false);
    // Button handlers
    var buttonHandlers = (0, $5FkrB.useMemo)(function() {
        return {
            onMouseEnter: function onMouseEnter() {
                return setIsOverButton(true);
            },
            onMouseLeave: function onMouseLeave() {
                return setIsOverButton(false);
            },
            onMouseDown: function onMouseDown(e) {
                // Prevent the browser from moving focus to the remove button on mousedown.
                // Without this, parent composite widgets (e.g. Select) lose input focus when
                // the user clicks remove, triggering unwanted blur side-effects.
                e === null || e === void 0 || e.preventDefault();
                hadMouseDownRef.current = true;
            },
            onFocus: function onFocus() {
                // Only track keyboard focus for focus ring styles
                // If mousedown happened just before focus, it's mouse focus (not keyboard)
                if (!hadMouseDownRef.current) setIsButtonFocused(true);
                hadMouseDownRef.current = false;
            },
            onBlur: function onBlur() {
                return setIsButtonFocused(false);
            }
        };
    }, []);
    // Link handlers - includes hover tracking
    var linkHandlers = (0, $5FkrB.useMemo)(function() {
        return {
            onMouseEnter: function onMouseEnter() {
                return setIsLinkHovered(true);
            },
            onMouseLeave: function onMouseLeave() {
                return setIsLinkHovered(false);
            },
            onMouseDown: function onMouseDown() {
                hadMouseDownRef.current = true;
            },
            onFocus: function onFocus() {
                // Only track keyboard focus for focus ring styles
                // If mousedown happened just before focus, it's mouse focus (not keyboard)
                if (!hadMouseDownRef.current) setIsLinkFocused(true);
                hadMouseDownRef.current = false;
            },
            onBlur: function onBlur() {
                return setIsLinkFocused(false);
            }
        };
    }, []);
    return {
        isLinkHovered: isLinkHovered,
        isOverButton: isOverButton,
        isButtonFocused: isButtonFocused,
        isLinkFocused: isLinkFocused,
        buttonHandlers: buttonHandlers,
        linkHandlers: linkHandlers
    };
}
function $f672c44de32ac010$export$97d8be09cd53869b(_ref) {
    var isRemovable = _ref.isRemovable, tagText = _ref.tagText, removeButtonLabel = _ref.removeButtonLabel, testId = _ref.testId, handleRemoveRequest = _ref.handleRemoveRequest, removingTag = _ref.removingTag, showingTag = _ref.showingTag, onKeyPress = _ref.onKeyPress, _ref$shape = _ref.shape, shape = _ref$shape === void 0 ? 'default' : _ref$shape, buttonHandlers = _ref.buttonHandlers;
    var handleFocus = (0, $5FkrB.useCallback)(function() {
        removingTag();
        buttonHandlers === null || buttonHandlers === void 0 || buttonHandlers.onFocus();
    }, [
        removingTag,
        buttonHandlers
    ]);
    var handleBlur = (0, $5FkrB.useCallback)(function() {
        showingTag();
        buttonHandlers === null || buttonHandlers === void 0 || buttonHandlers.onBlur();
    }, [
        showingTag,
        buttonHandlers
    ]);
    return (0, $5FkrB.useMemo)(function() {
        if (!isRemovable) return undefined;
        return /*#__PURE__*/ $5FkrB.createElement((0, $5U0GO.default), {
            "aria-label": "".concat(removeButtonLabel || 'Remove', " ").concat(tagText),
            onClick: handleRemoveRequest,
            onFocus: handleFocus,
            onBlur: handleBlur,
            onKeyPress: onKeyPress,
            onMouseEnter: buttonHandlers === null || buttonHandlers === void 0 ? void 0 : buttonHandlers.onMouseEnter,
            onMouseLeave: buttonHandlers === null || buttonHandlers === void 0 ? void 0 : buttonHandlers.onMouseLeave,
            onMouseDown: buttonHandlers === null || buttonHandlers === void 0 ? void 0 : buttonHandlers.onMouseDown,
            testId: testId ? "close-button-".concat(testId) : undefined,
            shape: shape
        });
    }, [
        isRemovable,
        removeButtonLabel,
        tagText,
        handleRemoveRequest,
        handleFocus,
        handleBlur,
        onKeyPress,
        buttonHandlers,
        testId,
        shape
    ]);
}
function $f672c44de32ac010$export$898a500849bb5cf4(_ref2) {
    var isRemovable = _ref2.isRemovable, status = _ref2.status, children = _ref2.children;
    if (isRemovable) return /*#__PURE__*/ $5FkrB.createElement((0, $aNF62.default), null, !(status === $f672c44de32ac010$export$74452314b63acabc.Removed) && /*#__PURE__*/ $5FkrB.createElement((0, $kctvn.default), null, function(motion) {
        return /*#__PURE__*/ $5FkrB.createElement("span", {
            ref: motion.ref
        }, children);
    }));
    return children;
}
function $f672c44de32ac010$export$ce4b6a469c26f53f(_ref3) {
    var isLink = _ref3.isLink, href = _ref3.href, LinkComponent = _ref3.LinkComponent, testId = _ref3.testId, children = _ref3.children, onClick = _ref3.onClick, linkHandlers = _ref3.linkHandlers;
    if (isLink && href) return /*#__PURE__*/ $5FkrB.createElement(LinkComponent, {
        href: href,
        testId: testId ? "".concat(testId, "--link") : undefined,
        onClick: onClick,
        onMouseEnter: linkHandlers === null || linkHandlers === void 0 ? void 0 : linkHandlers.onMouseEnter,
        onMouseLeave: linkHandlers === null || linkHandlers === void 0 ? void 0 : linkHandlers.onMouseLeave,
        onMouseDown: linkHandlers === null || linkHandlers === void 0 ? void 0 : linkHandlers.onMouseDown,
        onFocus: linkHandlers === null || linkHandlers === void 0 ? void 0 : linkHandlers.onFocus,
        onBlur: linkHandlers === null || linkHandlers === void 0 ? void 0 : linkHandlers.onBlur
    }, children);
    return /*#__PURE__*/ $5FkrB.createElement((0, $5FkrB.Fragment), null, children);
}

});
parcelRegister("1PcVd", function(module, exports) {
$parcel$export(module.exports, "default", () => $154493e39bc37a2e$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $kqp0i = parcelRequire("kqp0i");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");

var $kJ5MV = parcelRequire("kJ5MV");

var $25cv8 = parcelRequire("25cv8");

var $9Zzpd = parcelRequire("9Zzpd");

var $136Wy = parcelRequire("136Wy");
var $5KP8M = parcelRequire("5KP8M");
var $154493e39bc37a2e$var$_excluded = [
    "children",
    "testId",
    "appearance",
    "newWindowLabel",
    "target",
    "className",
    "style"
];
var $154493e39bc37a2e$var$styles = {
    base: "_ect4ttxp",
    baseT26Shape: "_2rkolb4i",
    visitedLink: "_10531ra0 _1ien1ra0 _n0fx1ra0 _1vhv17z1",
    defaultAppearance: "_4bfu1r31 _1hms8stv _ajmmnqa1 _syaz13af _1a3b1r31 _4fpr8stv _5goinqa1 _f8pj13af _9oik1r31 _1bnxglyw _jf4cnqa1 _30l313af _1nrm1r31 _c2waglyw _1iohnqa1 _9h8h12zz",
    subtleAppearance: "_4bfu1r31 _1hmsglyw _ajmmnqa1 _syazazsu _1a3b1r31 _4fprglyw _5goinqa1 _f8pjazsu _9oik1r31 _1bnx8stv _jf4cnqa1 _30l3azsu _1nrm1r31 _c2wa8stv _1iohnqa1 _9h8hi7uo",
    inverseAppearance: "_4bfu1r31 _1hms8stv _ajmmnqa1 _syaz15cr _105315cr _1a3b1r31 _4fpr8stv _5goinqa1 _f8pj15cr _9oik1r31 _1bnxglyw _jf4cnqa1 _30l315cr _1nrm1r31 _c2waglyw _1iohnqa1 _9h8h15cr",
    iconWrapper: "_1e0c1nu9 _o5721q9c _s7n41q9y _kqswh2mm _152ttb3r"
};
var $154493e39bc37a2e$var$iconStyles = null;
var $154493e39bc37a2e$var$LinkWithoutRef = function LinkWithoutRef(_ref, ref) {
    var children = _ref.children, testId = _ref.testId, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'default' : _ref$appearance, newWindowLabel = _ref.newWindowLabel, target = _ref.target, _preventedClassName = _ref.className, _preventedStyle = _ref.style, htmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $154493e39bc37a2e$var$_excluded);
    return /*#__PURE__*/ $5FkrB.createElement((0, $136Wy.default), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, htmlAttributes, {
        target: target,
        ref: ref,
        xcss: (0, $25cv8.cx)($154493e39bc37a2e$var$styles.base, (0, $9Zzpd.fg)('platform-dst-shape-theme-default') && $154493e39bc37a2e$var$styles.baseT26Shape, appearance === 'default' && $154493e39bc37a2e$var$styles.defaultAppearance, appearance === 'subtle' && $154493e39bc37a2e$var$styles.subtleAppearance, appearance === 'inverse' && $154493e39bc37a2e$var$styles.inverseAppearance, // Visited styles are not supported for inverse links due to contrast issues
        appearance !== 'inverse' && $154493e39bc37a2e$var$styles.visitedLink),
        testId: testId,
        componentName: "Link",
        newWindowLabel: newWindowLabel
    }), children, target === '_blank' && /*#__PURE__*/ $5FkrB.createElement((0, $5KP8M.default), {
        as: "span",
        xcss: $154493e39bc37a2e$var$styles.iconWrapper,
        testId: testId && "".concat(testId, "__icon")
    }, "\uFEFF", /*#__PURE__*/ $5FkrB.createElement("svg", {
        width: "12",
        height: "12",
        viewBox: "0 0 12 12",
        fill: "none",
        className: (0, $kJ5MV.default)([
            "_1bsbgm0b _4t3igm0b _ahbqzjw7"
        ])
    }, /*#__PURE__*/ $5FkrB.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M0 1.82609C0 0.817938 0.817938 0 1.82609 0H3.91304V1.04348H1.82609C1.39424 1.04348 1.04348 1.39424 1.04348 1.82609V10.1739C1.04348 10.6058 1.39424 10.9565 1.82609 10.9565H10.1739C10.6058 10.9565 10.9565 10.6058 10.9565 10.1739V8.08696H12V10.1739C12 11.1821 11.1821 12 10.1739 12H1.82609C0.817938 12 0 11.1821 0 10.1739V1.82609ZM7.04348 0H12V4.95652H10.9565V1.78133L6.36893 6.36893L5.63107 5.63107L10.2187 1.04348H7.04348V0Z",
        fill: "currentColor"
    }))));
};
// Workarounds to support generic types with forwardRef
/**
 * __Link__
 *
 * A link is an inline text element that navigates to a new location when clicked.
 *
 * - [Examples](https://atlassian.design/components/primitives/link/examples)
 * - [Code](https://atlassian.design/components/primitives/link/code)
 * - [Usage](https://atlassian.design/components/primitives/link/usage)
 */ var $154493e39bc37a2e$var$Link = /*#__PURE__*/ (0, $5FkrB.forwardRef)($154493e39bc37a2e$var$LinkWithoutRef);
var $154493e39bc37a2e$export$2e2bcd8739ae039 = $154493e39bc37a2e$var$Link;

});
parcelRegister("136Wy", function(module, exports) {
$parcel$export(module.exports, "default", () => $0c3b75184e24ecd5$export$2e2bcd8739ae039);
/* anchor.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $kqp0i = parcelRequire("kqp0i");

var $ekGgq = parcelRequire("ekGgq");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");


var $ccsyC = parcelRequire("ccsyC");

var $afMOk = parcelRequire("afMOk");

var $TIb0j = parcelRequire("TIb0j");

var $j2ZVh = parcelRequire("j2ZVh");

var $3baOr = parcelRequire("3baOr");

var $9Hz0l = parcelRequire("9Hz0l");

var $eqVaP = parcelRequire("eqVaP");

var $e8kqY = parcelRequire("e8kqY");

var $b1eWp = parcelRequire("b1eWp");
var $0c3b75184e24ecd5$var$_excluded = [
    "href",
    "children",
    "onClick",
    "interactionName",
    "componentName",
    "analyticsContext",
    "aria-label",
    "aria-labelledby",
    "style",
    "target",
    "testId",
    "xcss",
    "newWindowLabel"
], $0c3b75184e24ecd5$var$_excluded2 = [
    "className"
];
var $0c3b75184e24ecd5$var$styles = {
    root: "_4bfu1r31 _1hms8stv _ajmmnqa1 _vchhusvi",
    position: "_kqswh2mm"
};
var $0c3b75184e24ecd5$var$IS_EXTERNAL_LINK_REGEX = /^(?:(http|https):\/\/)/;
var $0c3b75184e24ecd5$var$IS_NON_HTTP_BASED = /^(((mailto|tel|sms|blob):)|(#))/;
/**
 * __Anchor__
 *
 * A primitive for building custom anchor links.
 *
 * - [Examples](https://atlassian.design/components/primitives/anchor/examples)
 * - [Code](https://atlassian.design/components/primitives/anchor/code)
 * - [Usage](https://atlassian.design/components/primitives/anchor/usage)
 */ var $0c3b75184e24ecd5$var$AnchorNoRef = function AnchorNoRef(_ref, ref) {
    var href = _ref.href, children = _ref.children, _ref$onClick = _ref.onClick, providedOnClick = _ref$onClick === void 0 ? (0, $3baOr.default) : _ref$onClick, interactionName = _ref.interactionName, componentName = _ref.componentName, analyticsContext = _ref.analyticsContext, ariaLabel = _ref['aria-label'], ariaLabelledBy = _ref['aria-labelledby'], style = _ref.style, target = _ref.target, testId = _ref.testId, xcss = _ref.xcss, _ref$newWindowLabel = _ref.newWindowLabel, newWindowLabel = _ref$newWindowLabel === void 0 ? '(opens new window)' : _ref$newWindowLabel, htmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $0c3b75184e24ecd5$var$_excluded);
    var interactionContext = (0, $5FkrB.useContext)((0, $eqVaP.default));
    var handleClick = (0, $5FkrB.useCallback)(function(e, analyticsEvent) {
        interactionContext && interactionContext.tracePress(interactionName, e.timeStamp);
        providedOnClick(e, analyticsEvent);
    }, [
        providedOnClick,
        interactionContext,
        interactionName
    ]);
    var opensNewWindowLabelId = (0, $9Hz0l.useId)();
    var onClick = (0, $TIb0j.usePlatformLeafEventHandler)({
        fn: handleClick,
        action: 'clicked',
        componentName: componentName || 'Anchor',
        packageName: "@atlaskit/primitives",
        packageVersion: "0.0.0-development",
        analyticsData: analyticsContext,
        actionSubject: 'link'
    });
    // This is to remove className from safeHtmlAttributes
    // @ts-expect-error className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(htmlAttributes, $0c3b75184e24ecd5$var$_excluded2);
    var RouterLink = (0, $j2ZVh.default)();
    var isExternal = typeof href === 'string' && $0c3b75184e24ecd5$var$IS_EXTERNAL_LINK_REGEX.test(href);
    var isNonHttpBased = typeof href === 'string' && $0c3b75184e24ecd5$var$IS_NON_HTTP_BASED.test(href);
    /**
   * Renders a router link if:
   *
   * - a link component is set in the app provider
   * - it's not an external link (starting with `http://` or `https://`)
   * - it's not a non-HTTP-based link (e.g. emails, phone numbers, hash links etc.).
   */ var isRouterLink = RouterLink && !isExternal && !isNonHttpBased;
    var hrefObjectUsedWithoutRouterLink = RouterLink === undefined && (0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(href) === 'object';
    (0, $afMOk.default)(!hrefObjectUsedWithoutRouterLink, "@atlaskit/primitives: Anchor primitive cannot pass an object to 'href' unless a router link is configured in the AppProvider");
    var Component = isRouterLink ? RouterLink : 'a';
    return /*#__PURE__*/ $5FkrB.createElement((0, $b1eWp.default), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        as: Component,
        className: xcss,
        style: style,
        ref: ref
    }, safeHtmlAttributes, {
        href: !isRouterLink && typeof href !== 'string' ? undefined : href,
        target: target,
        onClick: onClick,
        "aria-label": ariaLabel && target === '_blank' && !ariaLabelledBy ? "".concat(ariaLabel, " , ").concat(newWindowLabel) : ariaLabel,
        "aria-labelledby": ariaLabelledBy && target === '_blank' ? "".concat(ariaLabelledBy, " ").concat(opensNewWindowLabelId) : ariaLabelledBy,
        xcss: (0, $ccsyC.cx)($0c3b75184e24ecd5$var$styles.root, $0c3b75184e24ecd5$var$styles.position, xcss),
        testId: testId,
        "data-is-router-link": testId ? isRouterLink ? 'true' : 'false' : undefined
    }), children, target === '_blank' && (children && !ariaLabel && !ariaLabelledBy || ariaLabelledBy) && /*#__PURE__*/ $5FkrB.createElement((0, $e8kqY.default), {
        id: opensNewWindowLabelId
    }, ", ".concat(newWindowLabel)));
};
// Workarounds to support generic types with forwardRef
/**
 * __Anchor__
 *
 * Anchor is a primitive for building custom anchor links. It's a wrapper around the HTML `<a>` element that provides a consistent API for handling client-side routing and Atlassian Design System styling.
 *
 * - [Examples](https://atlassian.design/components/primitives/anchor/examples)
 * - [Code](https://atlassian.design/components/primitives/anchor/code)
 * - [Usage](https://atlassian.design/components/primitives/anchor/usage)
 */ var $0c3b75184e24ecd5$var$Anchor = /*#__PURE__*/ (0, $5FkrB.forwardRef)($0c3b75184e24ecd5$var$AnchorNoRef);
var $0c3b75184e24ecd5$export$2e2bcd8739ae039 = $0c3b75184e24ecd5$var$Anchor;

});
parcelRegister("j2ZVh", function(module, exports) {
$parcel$export(module.exports, "default", () => $ddde3cd35b57741d$export$2e2bcd8739ae039);

var $5FkrB = parcelRequire("5FkrB");

var $1ihDG = parcelRequire("1ihDG");
/**
 * __useRouterLink()__
 *
 * Hook: Returns app-configured router link component.
 *
 * A generic can be passed to define advanced link configuration:
 * ```
 * type MyRouterLinkConfig = {
 *  to: string;
 *  replace?: boolean;
 * }
 *
 * const RouterLink = useRouterLink<MyRouterLinkConfig>();
 * ```
 */ var $ddde3cd35b57741d$var$useRouterLink = function useRouterLink() {
    var _useContext = (0, $5FkrB.useContext)((0, $1ihDG.RouterLinkProviderContext)), routerLinkComponent = _useContext.routerLinkComponent;
    if (routerLinkComponent) return routerLinkComponent;
    return;
};
var $ddde3cd35b57741d$export$2e2bcd8739ae039 = $ddde3cd35b57741d$var$useRouterLink;

});
parcelRegister("1ihDG", function(module, exports) {
$parcel$export(module.exports, "RouterLinkProviderContext", () => $0f1527a14ab207d8$export$2931e0ee690eee88);

var $5FkrB = parcelRequire("5FkrB");
var $0f1527a14ab207d8$export$2931e0ee690eee88 = /*#__PURE__*/ (0, $5FkrB.createContext)({});
/**
 * __RouterLinkProvider__
 *
 * Provides a configured router link component for use
 * within Design System components.
 */ var $0f1527a14ab207d8$var$RouterLinkProvider = function RouterLinkProvider(_ref) {
    var routerLinkComponent = _ref.routerLinkComponent, children = _ref.children;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement($0f1527a14ab207d8$export$2931e0ee690eee88.Provider, {
        value: {
            routerLinkComponent: routerLinkComponent
        }
    }, children);
};
var $0f1527a14ab207d8$export$2e2bcd8739ae039 = $0f1527a14ab207d8$var$RouterLinkProvider;

});


parcelRegister("9Hz0l", function(module, exports) {
$parcel$export(module.exports, "useId", () => $710348687f489770$export$f680877a34711e37);

var $ekGgq = parcelRequire("ekGgq");

var $5FkrB = parcelRequire("5FkrB");
function $710348687f489770$export$f680877a34711e37() {
    // React uses `:` or `«»` in selectors which breaks `document.querySelector(…)`.
    // Replace with `_` to match future React 19 functionality.
    return (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).useId().replace(/[:«»]/g, '_');
}
var $710348687f489770$export$6be90bcb437e928f = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function(_ref, ref) {
    var children = _ref.children, _ref$postfix = _ref.postfix, postfix = _ref$postfix === void 0 ? '' : _ref$postfix, _ref$prefix = _ref.prefix, prefix = _ref$prefix === void 0 ? '' : _ref$prefix;
    var id = "".concat(prefix).concat($710348687f489770$export$f680877a34711e37()).concat(postfix);
    (0, $5FkrB.useEffect)(function() {
        if (!ref) return;
        switch((0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(ref)){
            case 'function':
                ref(id);
                break;
            case 'object':
                ref.current = id;
                break;
            default:
                throw new Error("Unreachable case for unsupported type of ref \"".concat((0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(ref), "\""));
        }
    }, [
        id,
        ref
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).Fragment, null, typeof children === 'function' ? children({
        id: id
    }) : children);
});
function $710348687f489770$export$6ee17796e3d70de2() {
    var uid = $710348687f489770$export$f680877a34711e37();
    return function(id) {
        return "".concat(uid, "-").concat(id.toString());
    };
}

});



parcelRegister("5U0GO", function(module, exports) {
$parcel$export(module.exports, "default", () => $44c2b79ffdcb7cdd$export$2e2bcd8739ae039);
/* remove-button.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $5FkrB = parcelRequire("5FkrB");


var $25cv8 = parcelRequire("25cv8");

var $1Va8N = parcelRequire("1Va8N");

var $h1qTB = parcelRequire("h1qTB");
var $44c2b79ffdcb7cdd$var$removeButtonStyles = {
    root: "_19itglyw _2rkolb4i _195gze3t _1mouze3t _18zrze3t _1rjcze3t _1e0c1txw _4t3i1j6v _1bsb1j6v _rjxpze3t _4cvr1h6o _1bah1h6o _1wpz1h6o _r06hglyw _bfhksm61 _syazi7uo _80omtlke _lcxv1wug _ahbq1i6y _12l21i6y _1ah3idpf _irr31dpa _1di6fcek",
    circle: "_2rko1rr0 _1ah3idpf"
};
var $44c2b79ffdcb7cdd$var$removeButtonStylesNewIcon = {
    root: "_rjxpv77o"
};
var $44c2b79ffdcb7cdd$var$RemoveButton = function RemoveButton(_ref) {
    var ariaLabel = _ref['aria-label'], onClick = _ref.onClick, onFocus = _ref.onFocus, onBlur = _ref.onBlur, onKeyPress = _ref.onKeyPress, onMouseOver = _ref.onMouseOver, onMouseOut = _ref.onMouseOut, onMouseDown = _ref.onMouseDown, onMouseUp = _ref.onMouseUp, onMouseEnter = _ref.onMouseEnter, onMouseLeave = _ref.onMouseLeave, testId = _ref.testId, _ref$shape = _ref.shape, shape = _ref$shape === void 0 ? 'default' : _ref$shape;
    return /*#__PURE__*/ $5FkrB.createElement((0, $h1qTB.default), {
        xcss: (0, $25cv8.cx)($44c2b79ffdcb7cdd$var$removeButtonStyles.root, shape === 'circle' && $44c2b79ffdcb7cdd$var$removeButtonStyles.circle, $44c2b79ffdcb7cdd$var$removeButtonStylesNewIcon.root),
        "aria-label": ariaLabel,
        onClick: onClick,
        onFocus: onFocus,
        onBlur: onBlur,
        onKeyPress: onKeyPress,
        onMouseOver: onMouseOver,
        onMouseOut: onMouseOut,
        onMouseDown: onMouseDown,
        onMouseUp: onMouseUp,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        testId: testId
    }, /*#__PURE__*/ $5FkrB.createElement((0, (/*@__PURE__*/$parcel$interopDefault($1Va8N))), {
        color: "currentColor",
        label: "",
        size: "small"
    }));
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$44c2b79ffdcb7cdd$export$2e2bcd8739ae039 = $44c2b79ffdcb7cdd$var$RemoveButton;

});
parcelRegister("1Va8N", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::13080645a1b889dca339823c8ecd9929>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1662fb12050f0961$var$_react = $1662fb12050f0961$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $1662fb12050f0961$var$_baseNew = $1662fb12050f0961$var$_interopRequireDefault((parcelRequire("f28qG")));
function $1662fb12050f0961$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Cross".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Known uses: closing modals, panels, and transient views; removing tags
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $1662fb12050f0961$var$CrossIcon = (props)=>/*#__PURE__*/ $1662fb12050f0961$var$_react.default.createElement($1662fb12050f0961$var$_baseNew.default, Object.assign({
        name: "CrossIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M14.03 3.03 9.06 8l4.97 4.97-1.06 1.06L8 9.06l-4.97 4.97-1.06-1.06L6.94 8 1.97 3.03l1.06-1.06L8 6.94l4.97-4.97z"/>`
    }, props));
$1662fb12050f0961$var$CrossIcon.displayName = 'CrossIcon';
var $1662fb12050f0961$var$_default = module.exports.default = $1662fb12050f0961$var$CrossIcon;

});



parcelRegister("ho5mL", function(module, exports) {
$parcel$export(module.exports, "default", () => $ca88d72440d2ac25$export$2e2bcd8739ae039);
/* swatch-before.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $5FkrB = parcelRequire("5FkrB");

var $kJ5MV = parcelRequire("kJ5MV");
var $ca88d72440d2ac25$var$tagSwatchBeforeStyles = {
    swatch: "_2rkolb4i _1bsboqnp _4t3ioqnp _1o9zidpf"
};
var $ca88d72440d2ac25$var$tagSwatchBeforeColorStyles = {
    gray: "_bfhk18j9",
    blue: "_bfhk115i",
    green: "_bfhk1rsu",
    red: "_bfhkkrt9",
    yellow: "_bfhk8y3s",
    purple: "_bfhk18ah",
    lime: "_bfhkbq5w",
    magenta: "_bfhk1mi6",
    orange: "_bfhk1kkj",
    teal: "_bfhktdv8"
};
function $ca88d72440d2ac25$export$2e2bcd8739ae039(_ref) {
    var colorKey = _ref.colorKey, swatchBefore = _ref.swatchBefore;
    if (swatchBefore === undefined || swatchBefore === false) return null;
    if (swatchBefore === true) return /*#__PURE__*/ $5FkrB.createElement("span", {
        className: (0, $kJ5MV.default)([
            $ca88d72440d2ac25$var$tagSwatchBeforeStyles.swatch,
            $ca88d72440d2ac25$var$tagSwatchBeforeColorStyles[colorKey]
        ])
    });
    return /*#__PURE__*/ $5FkrB.createElement("span", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: {
            backgroundColor: swatchBefore
        },
        className: (0, $kJ5MV.default)([
            $ca88d72440d2ac25$var$tagSwatchBeforeStyles.swatch
        ])
    });
}

});


parcelRegister("dIJOH", function(module, exports) {
$parcel$export(module.exports, "default", () => $9fd2ecaefbff0e86$export$2e2bcd8739ae039);
/* base.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $kqp0i = parcelRequire("kqp0i");

var $25nEq = parcelRequire("25nEq");

var $1Vcia = parcelRequire("1Vcia");

var $kJ5MV = parcelRequire("kJ5MV");

var $5FkrB = parcelRequire("5FkrB");
var $9fd2ecaefbff0e86$var$_excluded = [
    "before",
    "contentElement",
    "after",
    "testId",
    "style",
    "color",
    "href",
    "className"
];
function $9fd2ecaefbff0e86$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $9fd2ecaefbff0e86$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $9fd2ecaefbff0e86$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $9fd2ecaefbff0e86$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
// Border colors - Hardcoded for Visual Refresh - to be removed with labelling system work
var $9fd2ecaefbff0e86$var$borderColors = {
    standard: "_1h6d14je",
    blue: "_1h6duisw",
    red: "_1h6da2c0",
    yellow: "_1h6deh2r",
    green: "_1h6d18uw",
    teal: "_1h6d1ug6",
    purple: "_1h6d157s",
    lime: "_1h6dn0nx",
    magenta: "_1h6d1lf6",
    orange: "_1h6dh727",
    grey: "_1h6d14je",
    standardLink: "_1h6d14je",
    blueLight: "_1h6duisw",
    redLight: "_1h6da2c0",
    yellowLight: "_1h6deh2r",
    greenLight: "_1h6d18uw",
    tealLight: "_1h6d1ug6",
    purpleLight: "_1h6d157s",
    limeLight: "_1h6dn0nx",
    magentaLight: "_1h6d1lf6",
    orangeLight: "_1h6dh727",
    greyLight: "_1h6d14je"
};
var $9fd2ecaefbff0e86$var$baseStyles = null;
var $9fd2ecaefbff0e86$var$interactiveStyles = null;
var $9fd2ecaefbff0e86$var$focusRingStyles = null;
var $9fd2ecaefbff0e86$var$BaseTag = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).forwardRef(function BaseTag(_ref, ref) {
    var before = _ref.before, contentElement = _ref.contentElement, after = _ref.after, testId = _ref.testId, style = _ref.style, _ref$color = _ref.color, color = _ref$color === void 0 ? 'standard' : _ref$color, href = _ref.href, className = _ref.className, other = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $9fd2ecaefbff0e86$var$_excluded);
    var isLink = Boolean(href);
    var isRemovable = Boolean(after);
    var isInteractive = isLink || isRemovable;
    if (color === 'gray') // internally we use 'grey' for gray color so that we can make migration easier behind the ff (gray will work with and without ff now)
    color = 'grey';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("span", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, other, {
        ref: ref,
        style: $9fd2ecaefbff0e86$var$_objectSpread({}, style),
        className: (0, $kJ5MV.default)([
            "_zulp1b66 _2rko12b0 _1dqonqa1 _189ee4h9 _1mou1b66 _195g1b66 _18zr1b66 _1e0c116y _vchhusvi _1ul9idpf _4t3i1k92 _kqswh2mm _4cvr1h6o _bfhksm61 _syazi7uo _80om73ad",
            isInteractive && "_1e38dfik _7glxv77o",
            isLink && "_irr31dpa _1di6fcek",
            $9fd2ecaefbff0e86$var$borderColors[color],
            className
        ]),
        "data-testid": testId
    }), before, contentElement, after);
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$9fd2ecaefbff0e86$export$2e2bcd8739ae039 = $9fd2ecaefbff0e86$var$BaseTag;

});

parcelRegister("jHNrb", function(module, exports) {
$parcel$export(module.exports, "default", () => $e58861bcba118e44$export$2e2bcd8739ae039);
/* before.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $5FkrB = parcelRequire("5FkrB");

var $kJ5MV = parcelRequire("kJ5MV");
var $e58861bcba118e44$var$beforeElementStyles = null;
var $e58861bcba118e44$var$Before = function Before(_ref) {
    var elemBefore = _ref.elemBefore;
    return elemBefore ? /*#__PURE__*/ $5FkrB.createElement("span", {
        className: (0, $kJ5MV.default)([
            "_1e0c1txw _4t3i1j6v _4cvr1h6o _1bah1h6o _152tze3t"
        ])
    }, elemBefore) : null;
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$e58861bcba118e44$export$2e2bcd8739ae039 = $e58861bcba118e44$var$Before;

});

parcelRegister("dXxxV", function(module, exports) {
$parcel$export(module.exports, "getLozengeAppearance", () => $a29acea54d1807e2$export$4d9e331cafeacb9d);
/**
 * Maps Tag color values to Lozenge appearance values.
 * Used for migration_fallback rendering when feature flag is off.
 */ var $a29acea54d1807e2$var$colorToLozengeAppearanceMap = {
    gray: 'default',
    grey: 'default',
    lime: 'success',
    green: 'success',
    blue: 'inprogress',
    red: 'removed',
    purple: 'new',
    yellow: 'moved',
    orange: 'moved',
    magenta: 'new',
    teal: 'inprogress',
    grayLight: 'default',
    greyLight: 'default',
    limeLight: 'success',
    greenLight: 'success',
    blueLight: 'inprogress',
    redLight: 'removed',
    purpleLight: 'new',
    yellowLight: 'moved',
    orangeLight: 'moved',
    magentaLight: 'new',
    tealLight: 'inprogress'
};
function $a29acea54d1807e2$export$4d9e331cafeacb9d(color) {
    return $a29acea54d1807e2$var$colorToLozengeAppearanceMap[color || 'gray'] || 'default';
}

});

parcelRegister("796iz", function(module, exports) {
$parcel$export(module.exports, "default", () => $533e426ee598fc71$export$2e2bcd8739ae039);
/* content.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $5FkrB = parcelRequire("5FkrB");

var $kJ5MV = parcelRequire("kJ5MV");
var $533e426ee598fc71$var$baseStyles = null;
var $533e426ee598fc71$var$linkStyles = null;
var $533e426ee598fc71$var$hasAfterStyles = null;
var $533e426ee598fc71$var$Content = function Content(_ref) {
    var _ref$isRemovable = _ref.isRemovable, isRemovable = _ref$isRemovable === void 0 ? true : _ref$isRemovable, _ref$text = _ref.text, text = _ref$text === void 0 ? '' : _ref$text, _ref$color = _ref.color, color = _ref$color === void 0 ? 'standard' : _ref$color, href = _ref.href, linkComponent = _ref.linkComponent, testId = _ref.testId;
    var Link = linkComponent !== null && linkComponent !== void 0 ? linkComponent : 'a';
    if (href) return /*#__PURE__*/ $5FkrB.createElement(Link, {
        href: href,
        "data-color": color,
        "data-testid": testId ? "".concat(testId, "--link") : undefined,
        className: (0, $kJ5MV.default)([
            "_11c8fhey _1reo15vq _18m915vq _p12ff6dh _1bto1l2s _o5721q9c",
            "_4bfu1r31 _1hmsglyw _ajmmnqa1 _syazi7uo _lcxv1wug _nt751r31 _49pcglyw _1hvw1o36 _9oik1r31 _1bnx8stv _jf4cnqa1 _30l3i7uo _1nrm1r31 _c2wa8stv _1iohnqa1 _9h8hi7uo",
            isRemovable && "_p12f1lit"
        ])
    }, text);
    else return /*#__PURE__*/ $5FkrB.createElement("span", {
        className: (0, $kJ5MV.default)([
            "_11c8fhey _1reo15vq _18m915vq _p12ff6dh _1bto1l2s _o5721q9c",
            isRemovable && "_p12f1lit"
        ])
    }, text);
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$533e426ee598fc71$export$2e2bcd8739ae039 = $533e426ee598fc71$var$Content;

});


parcelRegister("fV8Mu", function(module, exports) {
$parcel$export(module.exports, "default", () => $b972fda2d5cd73a8$export$2e2bcd8739ae039);

var $5FkrB = parcelRequire("5FkrB");

var $9Zzpd = parcelRequire("9Zzpd");

var $5xfKc = parcelRequire("5xfKc");

var $3xP8x = parcelRequire("3xP8x");

var $bjDXH = parcelRequire("bjDXH");

var $jsLZg = parcelRequire("jsLZg");
function $b972fda2d5cd73a8$export$2e2bcd8739ae039(_ref) {
    var _ref$zIndex = _ref.zIndex, zIndex = _ref$zIndex === void 0 ? 0 : _ref$zIndex, children = _ref.children, _ref$mountStrategy = _ref.mountStrategy, mountStrategy = _ref$mountStrategy === void 0 ? 'effect' : _ref$mountStrategy, _ref$isClosed = _ref.isClosed, isClosed = _ref$isClosed === void 0 ? false : _ref$isClosed;
    var isSubsequentRender = (0, $bjDXH.default)(mountStrategy);
    (0, $jsLZg.default)(zIndex);
    return !(0, $9Zzpd.fg)('platform_design_system_team_portal_logic_r18_fix') ? isSubsequentRender ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $5xfKc.default), {
        zIndex: zIndex,
        isClosed: isClosed
    }, children) : null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $3xP8x.default), {
        zIndex: zIndex,
        isClosed: isClosed
    }, children);
}

});
parcelRegister("5xfKc", function(module, exports) {
$parcel$export(module.exports, "default", () => $407c3f4d80e747f9$export$2e2bcd8739ae039);

var $5FkrB = parcelRequire("5FkrB");

var $aLeHs = parcelRequire("aLeHs");

var $3dDx0 = parcelRequire("3dDx0");
var $j3TF2 = parcelRequire("j3TF2");

var $9Zzpd = parcelRequire("9Zzpd");

var $ak4Kv = parcelRequire("ak4Kv");
function $407c3f4d80e747f9$export$2e2bcd8739ae039(props) {
    var zIndex = props.zIndex, children = props.children, _props$isClosed = props.isClosed, isClosed = _props$isClosed === void 0 ? false : _props$isClosed;
    var container = (0, $5FkrB.useMemo)(function() {
        return (0, $ak4Kv.createContainer)(zIndex);
    }, [
        zIndex
    ]);
    var colorMode = (0, $j3TF2.useColorMode)();
    // This is in the render method instead of useEffect so that
    // the portal will be added to the DOM before the children render.
    // For any further changes, ensure that the container does not have a
    // parent besides the portal parent.
    (0, $ak4Kv.appendPortalContainerIfNotAppended)(container);
    (0, $5FkrB.useEffect)(function() {
        if ((0, $9Zzpd.fg)('import_into_jsm_in_template_gallery_killswitch')) {
            if (isClosed) (0, $ak4Kv.removePortalContainer)(container);
        }
    }, [
        isClosed,
        container
    ]);
    (0, $5FkrB.useEffect)(function() {
        return function() {
            (0, $ak4Kv.removePortalContainer)(container);
        };
    }, [
        container
    ]);
    return /*#__PURE__*/ (0, $aLeHs.createPortal)(colorMode ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $3dDx0.default), {
        defaultColorMode: colorMode
    }, children) : children, container);
}

});
parcelRegister("3dDx0", function(module, exports) {
$parcel$export(module.exports, "default", () => $25814015d0f58e72$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $kqp0i = parcelRequire("kqp0i");

var $fL8KA = parcelRequire("fL8KA");

var $25nEq = parcelRequire("25nEq");

var $iYJcE = parcelRequire("iYJcE");

var $970q7 = parcelRequire("970q7");

var $6HG4S = parcelRequire("6HG4S");

var $5FkrB = parcelRequire("5FkrB");

var $7QpUe = parcelRequire("7QpUe");

var $9XHvc = parcelRequire("9XHvc");
var $dDp8W = parcelRequire("dDp8W");
var $m5DAZ = parcelRequire("m5DAZ");

var $9LIjQ = parcelRequire("9LIjQ");

var $d929M = parcelRequire("d929M");

var $CYAnS = parcelRequire("CYAnS");

var $aUdZm = parcelRequire("aUdZm");

var $kLT90 = parcelRequire("kLT90");

var $bmHXx = parcelRequire("bmHXx");
function $25814015d0f58e72$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $25814015d0f58e72$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $25814015d0f58e72$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $25814015d0f58e72$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $25814015d0f58e72$var$defaultThemeSettings = {
    dark: 'dark',
    light: 'light',
    spacing: 'spacing',
    typography: 'typography'
};
var $25814015d0f58e72$var$isMatchMediaAvailable = typeof window !== 'undefined' && 'matchMedia' in window;
var $25814015d0f58e72$var$prefersDarkModeMql = $25814015d0f58e72$var$isMatchMediaAvailable ? window.matchMedia('(prefers-color-scheme: dark)') : undefined;
// TODO: currently 'auto' color mode will always return 'light' in SSR.
// Additional work required: https://product-fabric.atlassian.net/browse/DSP-9781
function $25814015d0f58e72$var$getReconciledColorMode(colorMode) {
    if (colorMode === 'auto') return $25814015d0f58e72$var$prefersDarkModeMql !== null && $25814015d0f58e72$var$prefersDarkModeMql !== void 0 && $25814015d0f58e72$var$prefersDarkModeMql.matches ? 'dark' : 'light';
    return colorMode;
}
var $25814015d0f58e72$var$contentStyles = {
    body: "_1e0c1bgi"
};
/**
 * __Theme provider__
 *
 * Provides global theming configuration.
 */ function $25814015d0f58e72$var$ThemeProvider(_ref) {
    var children = _ref.children, _ref$defaultColorMode = _ref.defaultColorMode, defaultColorMode = _ref$defaultColorMode === void 0 ? 'auto' : _ref$defaultColorMode, defaultTheme = _ref.defaultTheme;
    var _useState = (0, $5FkrB.useState)(defaultColorMode), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), chosenColorMode = _useState2[0], setChosenColorMode = _useState2[1];
    var _useState3 = (0, $5FkrB.useState)($25814015d0f58e72$var$getReconciledColorMode(defaultColorMode)), _useState4 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState3, 2), reconciledColorMode = _useState4[0], setReconciledColorMode = _useState4[1];
    var _useState5 = (0, $5FkrB.useState)(function() {
        return $25814015d0f58e72$var$_objectSpread($25814015d0f58e72$var$_objectSpread({}, $25814015d0f58e72$var$defaultThemeSettings), defaultTheme);
    }), _useState6 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState5, 2), theme = _useState6[0], setTheme = _useState6[1];
    var setColorMode = (0, $5FkrB.useCallback)(function(colorMode) {
        setChosenColorMode(colorMode);
        setReconciledColorMode($25814015d0f58e72$var$getReconciledColorMode(colorMode));
    }, []);
    var setPartialTheme = (0, $5FkrB.useCallback)(function(nextTheme) {
        setTheme(function(theme) {
            return $25814015d0f58e72$var$_objectSpread($25814015d0f58e72$var$_objectSpread({}, theme), nextTheme);
        });
    }, []);
    var lastSetGlobalThemePromiseRef = (0, $5FkrB.useRef)(null);
    var isInsideAppProvider = (0, $9LIjQ.useIsInsideAppProvider)();
    var isAppProviderThemingEnabled = (0, $9LIjQ.useIsAppProviderThemingEnabled)();
    var isInsideThemeProvider = (0, $kLT90.useIsInsideThemeProvider)();
    /**
   * A top-level ThemeProvider is detected by being the first ThemeProvider inside an AppProvider.
   *
   * This will not use sub-tree theming but instead set the global theme state using the
   * `@atlaskit/tokens` APIs, as it's required for styling root `html` and `body` elements
   * for compatibility with `@atlaskit/css-reset`.
   *
   * In the future we could consider moving away from DOM mutations and require AppProvider to wrap
   * `html` in order to apply global theme state, which would allow a more consistent approach to
   * theme loading.
   */ var isRootThemeProvider = isInsideAppProvider && !isInsideThemeProvider && isAppProviderThemingEnabled;
    (0, $5FkrB.useEffect)(function() {
        if (isRootThemeProvider) {
            /**
       * We need to wait for any previous `setGlobalTheme` calls to finish before calling it again.
       * This is to prevent race conditions as `setGlobalTheme` is async and mutates the DOM (e.g. sets the
       * `data-color-mode` attribute on the root element).
       *
       * Since we can't safely abort the `setGlobalTheme` execution, we need to wait for it to properly finish before
       * applying the new theme.
       *
       * Without this, we can end up in the following scenario:
       * 1. app loads with the default 'light' theme, kicking off `setGlobalTheme`
       * 2. app switches to 'dark' theme after retrieving value persisted in local storage, calling `setGlobalTheme` again
       * 3. `setGlobalTheme` function execution for `dark` finishes before the initial `light` execution
       * 4. `setGlobalTheme` function execution for `light` then finishes, resulting in the 'light' theme being applied.
       */ var cleanupLastFnCall = /*#__PURE__*/ function() {
                var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee() {
                    var unbindFn;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee$(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                if (!lastSetGlobalThemePromiseRef.current) {
                                    _context.next = 6;
                                    break;
                                }
                                _context.next = 3;
                                return lastSetGlobalThemePromiseRef.current;
                            case 3:
                                unbindFn = _context.sent;
                                unbindFn();
                                lastSetGlobalThemePromiseRef.current = null;
                            case 6:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee);
                }));
                return function cleanupLastFnCall() {
                    return _ref2.apply(this, arguments);
                };
            }();
            var safelySetGlobalTheme = /*#__PURE__*/ function() {
                var _ref3 = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee2() {
                    var promise;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee2$(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                _context2.next = 2;
                                return cleanupLastFnCall();
                            case 2:
                                promise = (0, $dDp8W.default)($25814015d0f58e72$var$_objectSpread($25814015d0f58e72$var$_objectSpread({}, theme), {}, {
                                    colorMode: reconciledColorMode
                                }));
                                lastSetGlobalThemePromiseRef.current = promise;
                            case 4:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2);
                }));
                return function safelySetGlobalTheme() {
                    return _ref3.apply(this, arguments);
                };
            }();
            safelySetGlobalTheme();
            return function cleanup() {
                cleanupLastFnCall();
            };
        } else // For other theme providers (whether outside AppProvider or nested inside a ThemeProvider),
        // we treat them as sub-tree themes that do not load global theme state.
        (0, $bmHXx.loadAndMountThemes)(theme);
    }, [
        isInsideAppProvider,
        isInsideThemeProvider,
        isRootThemeProvider,
        reconciledColorMode,
        theme
    ]);
    (0, $5FkrB.useEffect)(function() {
        if (!$25814015d0f58e72$var$prefersDarkModeMql) return;
        var unbindListener = (0, $7QpUe.bind)($25814015d0f58e72$var$prefersDarkModeMql, {
            type: 'change',
            listener: function listener(event) {
                if (chosenColorMode === 'auto') setReconciledColorMode(event.matches ? 'dark' : 'light');
            }
        });
        return unbindListener;
    }, [
        chosenColorMode
    ]);
    var attrs = $25814015d0f58e72$var$_objectSpread($25814015d0f58e72$var$_objectSpread({}, (0, $9XHvc.default)($25814015d0f58e72$var$_objectSpread($25814015d0f58e72$var$_objectSpread({}, theme), {}, {
        colorMode: reconciledColorMode
    }))), {}, (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, (0, $m5DAZ.SUBTREE_THEME_ATTRIBUTE), true));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $CYAnS.InsideThemeProviderContext).Provider, {
        value: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $d929M.ColorModeContext).Provider, {
        value: reconciledColorMode
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $d929M.SetColorModeContext).Provider, {
        value: setColorMode
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $aUdZm.ThemeContext).Provider, {
        value: theme
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $aUdZm.SetThemeContext).Provider, {
        value: setPartialTheme
    }, !isRootThemeProvider ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, attrs, {
        className: (0, $970q7.default)([
            $25814015d0f58e72$var$contentStyles.body
        ])
    }), children) : children)))));
}
var $25814015d0f58e72$export$2e2bcd8739ae039 = $25814015d0f58e72$var$ThemeProvider;

});
parcelRegister("9XHvc", function(module, exports) {
$parcel$export(module.exports, "default", () => $740b5e5f38facfa9$export$2e2bcd8739ae039);

var $25nEq = parcelRequire("25nEq");

var $9Zzpd = parcelRequire("9Zzpd");

var $m5DAZ = parcelRequire("m5DAZ");

var $j03Wu = parcelRequire("j03Wu");

var $3gdkK = parcelRequire("3gdkK");

var $eP92L = parcelRequire("eP92L");

var $41qbW = parcelRequire("41qbW");
function $740b5e5f38facfa9$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $740b5e5f38facfa9$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $740b5e5f38facfa9$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $740b5e5f38facfa9$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $740b5e5f38facfa9$var$defaultColorMode = 'light';
var $740b5e5f38facfa9$var$defaultContrastMode = 'no-preference';
/**
 * Server-side rendering utility. Generates the valid HTML attributes for a given theme.
 * Note: this utility does not handle automatic theme switching.
 *
 * @param {Object<string, string>} themeOptions - Theme options object
 * @param {string} themeState.colorMode Determines which color theme is applied. If set to `auto`, the theme applied will be determined by the OS setting.
 * @param {string} themeState.dark The color theme to be applied when the color mode resolves to 'dark'.
 * @param {string} themeState.light The color theme to be applied when the color mode resolves to 'light'.
 * @param {string} themeState.motion The motion theme to be applied.
 * @param {string} themeState.spacing The spacing theme to be applied.
 * @param {string} themeState.typography The typography theme to be applied.
 * @param {Object} themeState.UNSAFE_themeOptions The custom branding options to be used for custom theme generation
 *
 * @returns {Object} Object of HTML attributes to be applied to the document root
 */ var $740b5e5f38facfa9$var$getThemeHtmlAttrs = function getThemeHtmlAttrs() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, _ref$colorMode = _ref.colorMode, colorMode = _ref$colorMode === void 0 ? (0, $j03Wu.themeStateDefaults)['colorMode'] : _ref$colorMode, _ref$dark = _ref.dark, dark = _ref$dark === void 0 ? (0, $j03Wu.themeStateDefaults)['dark'] : _ref$dark, _ref$light = _ref.light, light = _ref$light === void 0 ? (0, $j03Wu.themeStateDefaults)['light'] : _ref$light, _ref$contrastMode = _ref.contrastMode, contrastMode = _ref$contrastMode === void 0 ? (0, $j03Wu.themeStateDefaults)['contrastMode'] : _ref$contrastMode, _ref$motion = _ref.motion, motion = _ref$motion === void 0 ? (0, $j03Wu.themeStateDefaults)['motion']() : _ref$motion, _ref$shape = _ref.shape, shape = _ref$shape === void 0 ? (0, $j03Wu.themeStateDefaults)['shape']() : _ref$shape, _ref$spacing = _ref.spacing, spacing = _ref$spacing === void 0 ? (0, $j03Wu.themeStateDefaults)['spacing'] : _ref$spacing, _ref$typography = _ref.typography, typography = _ref$typography === void 0 ? (0, $j03Wu.themeStateDefaults)['typography'] : _ref$typography, _ref$UNSAFE_themeOpti = _ref.UNSAFE_themeOptions, UNSAFE_themeOptions = _ref$UNSAFE_themeOpti === void 0 ? (0, $j03Wu.themeStateDefaults)['UNSAFE_themeOptions'] : _ref$UNSAFE_themeOpti;
    var themeAttribute = (0, $3gdkK.themeObjectToString)({
        dark: dark,
        light: light,
        motion: motion,
        shape: shape,
        spacing: spacing,
        typography: typography
    });
    var result = (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, (0, $m5DAZ.THEME_DATA_ATTRIBUTE), themeAttribute), (0, $m5DAZ.COLOR_MODE_ATTRIBUTE), colorMode === 'auto' ? $740b5e5f38facfa9$var$defaultColorMode : colorMode);
    if ((0, $9Zzpd.fg)('platform_increased-contrast-themes')) result = $740b5e5f38facfa9$var$_objectSpread($740b5e5f38facfa9$var$_objectSpread({}, result), {}, (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, (0, $m5DAZ.CONTRAST_MODE_ATTRIBUTE), contrastMode === 'auto' ? $740b5e5f38facfa9$var$defaultContrastMode : contrastMode));
    if (UNSAFE_themeOptions && (0, $eP92L.isValidBrandHex)(UNSAFE_themeOptions.brandColor)) {
        var optionString = JSON.stringify(UNSAFE_themeOptions);
        var uniqueId = (0, $41qbW.hash)(optionString);
        result[0, $m5DAZ.CUSTOM_THEME_ATTRIBUTE] = uniqueId;
    }
    return result;
};
var $740b5e5f38facfa9$export$2e2bcd8739ae039 = $740b5e5f38facfa9$var$getThemeHtmlAttrs;

});
parcelRegister("m5DAZ", function(module, exports) {
$parcel$export(module.exports, "THEME_DATA_ATTRIBUTE", () => $04266db4c8ef7402$export$4ef52930e33717cd);
$parcel$export(module.exports, "SUBTREE_THEME_ATTRIBUTE", () => $04266db4c8ef7402$export$cb374d25ded7f6ab);
$parcel$export(module.exports, "COLOR_MODE_ATTRIBUTE", () => $04266db4c8ef7402$export$a00eac3f8684bcd0);
$parcel$export(module.exports, "CONTRAST_MODE_ATTRIBUTE", () => $04266db4c8ef7402$export$2112803007239c61);
$parcel$export(module.exports, "CUSTOM_THEME_ATTRIBUTE", () => $04266db4c8ef7402$export$352e418ed5b6193a);
var $04266db4c8ef7402$export$4ef52930e33717cd = 'data-theme';
var $04266db4c8ef7402$export$cb374d25ded7f6ab = 'data-subtree-theme';
var $04266db4c8ef7402$export$a00eac3f8684bcd0 = 'data-color-mode';
var $04266db4c8ef7402$export$2112803007239c61 = 'data-contrast-mode';
var $04266db4c8ef7402$export$352e418ed5b6193a = 'data-custom-theme';
var $04266db4c8ef7402$export$6f0c6fb8c80fcc92 = 'ds';
var $04266db4c8ef7402$export$4d0c7bbf80185957 = [
    'opacity',
    'font',
    'space',
    'border',
    'radius'
];
var $04266db4c8ef7402$export$dddac1532e822863 = "--".concat($04266db4c8ef7402$export$6f0c6fb8c80fcc92, "-token-not-found");
var $04266db4c8ef7402$export$9d7b58831ae93caa = "--".concat($04266db4c8ef7402$export$6f0c6fb8c80fcc92, "-elevation-surface-current");

});

parcelRegister("j03Wu", function(module, exports) {
$parcel$export(module.exports, "themeColorModes", () => $dd51134801463d84$export$83993de8eb66733);
$parcel$export(module.exports, "themeIds", () => $dd51134801463d84$export$7d43e72a58e3283f);
$parcel$export(module.exports, "themeStateDefaults", () => $dd51134801463d84$export$9aedcfa7336a207);
$parcel$export(module.exports, "default", () => $dd51134801463d84$export$2e2bcd8739ae039);

var $9Zzpd = parcelRequire("9Zzpd");
var $dd51134801463d84$export$83993de8eb66733 = [
    'light',
    'dark',
    'auto'
];
/**
 * Contrast preferences: The system contrast preference
 */ var $dd51134801463d84$var$themeContrastModes = [
    'more',
    'no-preference',
    'auto'
];
var $dd51134801463d84$export$7d43e72a58e3283f = [
    'light-increased-contrast',
    'light',
    'light-future',
    'dark',
    'dark-future',
    'dark-increased-contrast',
    'spacing',
    'shape',
    'typography',
    'motion'
];
/**
 * Theme override ids: the equivalent of themeIds for theme overrides.
 * Theme overrides are temporary and there may not be any defined at times.
 */ var $dd51134801463d84$var$themeOverrideIds = [];
var $dd51134801463d84$export$92ba366331403db2 = [].concat($dd51134801463d84$export$7d43e72a58e3283f, $dd51134801463d84$var$themeOverrideIds);
/**
 * Theme to use a base. This will create the theme as
 * an extension with all token values marked as optional
 * to allow tokens to be overridden as required.
 */ /**
 * Palettes: The set of base tokens a given theme may be populated with.
 * For example: legacy light & dark themes use the "legacyPalette" containing colors from our
 * previous color set.
 */ /**
 * ThemeConfig: the source of truth for all theme meta-data.
 * This object should be used whenever interfacing with themes.
 */ var $dd51134801463d84$var$themeConfig = {
    'atlassian-light': {
        id: 'light',
        displayName: 'Light Theme',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'light'
        }
    },
    'atlassian-light-future': {
        id: 'light-future',
        displayName: 'Future Light Theme',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'light'
        },
        override: 'light'
    },
    'atlassian-light-increased-contrast': {
        id: 'light-increased-contrast',
        displayName: 'Light Theme (increased contrast)',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'light'
        },
        extends: 'light',
        increasesContrastFor: 'light'
    },
    'atlassian-dark': {
        id: 'dark',
        displayName: 'Dark Theme',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'dark'
        }
    },
    'atlassian-dark-future': {
        id: 'dark-future',
        displayName: 'Future Dark Theme',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'dark'
        },
        override: 'light'
    },
    'atlassian-dark-increased-contrast': {
        id: 'dark-increased-contrast',
        displayName: 'Dark Theme (increased contrast)',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'dark'
        },
        extends: 'dark',
        increasesContrastFor: 'dark'
    },
    'atlassian-spacing': {
        id: 'spacing',
        displayName: 'Atlassian Spacing',
        palette: 'spacingScale',
        attributes: {
            type: 'spacing'
        }
    },
    'atlassian-typography': {
        id: 'typography',
        displayName: 'Atlassian Typography',
        palette: 'typographyPalette',
        attributes: {
            type: 'typography'
        }
    },
    'atlassian-shape': {
        id: 'shape',
        displayName: 'Shape',
        palette: 'shapePalette',
        attributes: {
            type: 'shape'
        }
    },
    'atlassian-motion': {
        id: 'motion',
        displayName: 'Motion',
        palette: 'motionPalette',
        attributes: {
            type: 'motion'
        }
    }
};
var $dd51134801463d84$export$9aedcfa7336a207 = {
    colorMode: 'auto',
    contrastMode: 'auto',
    dark: 'dark',
    light: 'light',
    shape: function shape() {
        if ((0, $9Zzpd.fg)('platform-dst-shape-theme-default')) return 'shape';
        return undefined;
    },
    spacing: 'spacing',
    typography: 'typography',
    motion: function motion() {
        if ((0, $9Zzpd.fg)('platform-dst-motion-theme-default')) return 'motion';
        return undefined;
    },
    UNSAFE_themeOptions: undefined
};
var /**
 * Represents theme state once mounted to the page
 * (the page doesn't have an "auto" color mode, it's either light or dark)
 */ $dd51134801463d84$export$2e2bcd8739ae039 = $dd51134801463d84$var$themeConfig;

});

parcelRegister("3gdkK", function(module, exports) {
$parcel$export(module.exports, "themeStringToObject", () => $25fd3584c29722a8$export$f19b488f7c0547ee);
$parcel$export(module.exports, "themeObjectToString", () => $25fd3584c29722a8$export$62c37ab81302621a);

var $ekGgq = parcelRequire("ekGgq");

var $iYJcE = parcelRequire("iYJcE");

var $j03Wu = parcelRequire("j03Wu");
var $25fd3584c29722a8$var$themeKinds = [
    'light',
    'dark',
    'spacing',
    'typography',
    'shape',
    'motion'
];
var $25fd3584c29722a8$var$customThemeOptions = 'UNSAFE_themeOptions';
var $25fd3584c29722a8$var$isThemeKind = function isThemeKind(themeKind) {
    return $25fd3584c29722a8$var$themeKinds.find(function(kind) {
        return kind === themeKind;
    }) !== undefined;
};
var $25fd3584c29722a8$var$isThemeIds = function isThemeIds(themeId) {
    return (0, $j03Wu.themeIds).find(function(id) {
        return id === themeId;
    }) !== undefined;
};
var $25fd3584c29722a8$var$isColorMode = function isColorMode(modeId) {
    return [
        'light',
        'dark',
        'auto'
    ].includes(modeId);
};
var $25fd3584c29722a8$export$f19b488f7c0547ee = function themeStringToObject(themeState) {
    return themeState.split(' ')// @ts-ignore - TS1501 TypeScript 5.9.2 upgrade
    .map(function(theme) {
        return theme.split(/:([^]*)/);
    }).reduce(function(themeObject, _ref) {
        var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_ref, 2), kind = _ref2[0], id = _ref2[1];
        if (kind === 'colorMode' && $25fd3584c29722a8$var$isColorMode(id)) themeObject[kind] = id;
        if ($25fd3584c29722a8$var$isThemeKind(kind) && $25fd3584c29722a8$var$isThemeIds(id)) // @ts-expect-error FIXME - this is a valid ts error
        themeObject[kind] = id;
        if (kind === $25fd3584c29722a8$var$customThemeOptions) try {
            themeObject[$25fd3584c29722a8$var$customThemeOptions] = JSON.parse(id);
        } catch (_unused) {
            new Error('Invalid custom theme string');
        }
        return themeObject;
    }, {});
};
var $25fd3584c29722a8$export$62c37ab81302621a = function themeObjectToString(themeState) {
    return Object.entries(themeState).reduce(function(themeString, _ref3) {
        var _ref4 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_ref3, 2), kind = _ref4[0], id = _ref4[1];
        if (// colorMode theme state
        kind === 'colorMode' && typeof id === 'string' && $25fd3584c29722a8$var$isColorMode(id) || // custom theme state
        kind === $25fd3584c29722a8$var$customThemeOptions && (0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(id) === 'object' || // other theme states
        $25fd3584c29722a8$var$isThemeKind(kind) && typeof id === 'string' && $25fd3584c29722a8$var$isThemeIds(id)) return themeString + "".concat(themeString ? ' ' : '') + "".concat(kind, ":").concat((0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(id) === 'object' ? JSON.stringify(id) : id);
        return themeString;
    }, '');
};

});

parcelRegister("eP92L", function(module, exports) {
$parcel$export(module.exports, "isValidBrandHex", () => $acacd7f4637ae6d2$export$53031ac1ecb71f44);
$parcel$export(module.exports, "rgbToHex", () => $acacd7f4637ae6d2$export$34d09c4a771c46ef);
$parcel$export(module.exports, "hexToRgbA", () => $acacd7f4637ae6d2$export$b36dbdb4f463f05c);
$parcel$export(module.exports, "hexToRgb", () => $acacd7f4637ae6d2$export$5a544e13ad4e1fa5);
$parcel$export(module.exports, "hexToHSL", () => $acacd7f4637ae6d2$export$47ea145a83f50dc0);
$parcel$export(module.exports, "HSLToRGB", () => $acacd7f4637ae6d2$export$1ff93e992dd58bec);
$parcel$export(module.exports, "relativeLuminanceW3C", () => $acacd7f4637ae6d2$export$e770b01b744f3745);
$parcel$export(module.exports, "getContrastRatio", () => $acacd7f4637ae6d2$export$d061e26956a60b0a);
$parcel$export(module.exports, "deltaE", () => $acacd7f4637ae6d2$export$e8ddad763b4bebf9);
// valid hex color with 6 digits
var $acacd7f4637ae6d2$export$53031ac1ecb71f44 = function isValidBrandHex(hex) {
    return /^#[0-9A-F]{6}$/i.test(hex);
};
// valid hex color with 4, 6 or 8 digits
var $acacd7f4637ae6d2$var$isValidHex = function isValidHex(hex) {
    return /^#([A-Fa-f0-9]{3,4}){1,2}$/.test(hex);
};
function $acacd7f4637ae6d2$export$34d09c4a771c46ef(r, g, b) {
    return '#' + (16777216 + (r << 16) + (g << 8) + b).toString(16).slice(1);
}
function $acacd7f4637ae6d2$export$1212645cf40ebf71(hex) {
    if (hex.length === 9) {
        var int = parseInt(hex.slice(7, 9), 16) / 255;
        return Number(parseFloat(int.toString()).toFixed(2));
    }
    return 1;
}
function $acacd7f4637ae6d2$export$b36dbdb4f463f05c(hex) {
    if (!$acacd7f4637ae6d2$var$isValidHex(hex)) throw new Error('Invalid HEX');
    var c;
    c = hex.substring(1).split('');
    if (c.length === 3) c = [
        c[0],
        c[0],
        c[1],
        c[1],
        c[2],
        c[2]
    ];
    c = '0x' + c.join('');
    return [
        c >> 16 & 255,
        c >> 8 & 255,
        c & 255,
        $acacd7f4637ae6d2$export$1212645cf40ebf71(hex)
    ];
}
function $acacd7f4637ae6d2$export$5a544e13ad4e1fa5(hex) {
    if (!$acacd7f4637ae6d2$var$isValidHex(hex)) throw new Error('Invalid HEX');
    var c;
    c = hex.substring(1).split('');
    if (c.length === 3) c = [
        c[0],
        c[0],
        c[1],
        c[1],
        c[2],
        c[2]
    ];
    c = '0x' + c.join('');
    return [
        c >> 16 & 255,
        c >> 8 & 255,
        c & 255
    ];
}
function $acacd7f4637ae6d2$export$47ea145a83f50dc0(hex) {
    if (!$acacd7f4637ae6d2$var$isValidHex(hex)) throw new Error('Invalid HEX');
    var r = 0, g = 0, b = 0;
    if (hex.length === 4) {
        r = '0x' + hex[1] + hex[1];
        g = '0x' + hex[2] + hex[2];
        b = '0x' + hex[3] + hex[3];
    } else if (hex.length === 7) {
        r = '0x' + hex[1] + hex[2];
        g = '0x' + hex[3] + hex[4];
        b = '0x' + hex[5] + hex[6];
    }
    // Then to HSL
    r /= 255;
    g /= 255;
    b /= 255;
    var cmin = Math.min(r, g, b), cmax = Math.max(r, g, b), delta = cmax - cmin, h = 0, s = 0, l = 0;
    if (delta === 0) h = 0;
    else if (cmax === r) h = (g - b) / delta % 6;
    else if (cmax === g) h = (b - r) / delta + 2;
    else h = (r - g) / delta + 4;
    h = Math.round(h * 60);
    if (h < 0) h += 360;
    l = (cmax + cmin) / 2;
    s = delta === 0 ? 0 : delta / (1 - Math.abs(2 * l - 1));
    s = +(s * 100).toFixed(1);
    l = +(l * 100).toFixed(1);
    return [
        h,
        s,
        l
    ];
}
function $acacd7f4637ae6d2$export$1ff93e992dd58bec(h, s, l) {
    s /= 100;
    l /= 100;
    var k = function k(n) {
        return (n + h / 30) % 12;
    };
    var a = s * Math.min(l, 1 - l);
    var f = function f(n) {
        return l - a * Math.max(-1, Math.min(k(n) - 3, Math.min(9 - k(n), 1)));
    };
    return [
        255 * f(0),
        255 * f(8),
        255 * f(4)
    ];
}
function $acacd7f4637ae6d2$export$e770b01b744f3745(r, g, b) {
    var RsRGB = r / 255;
    var GsRGB = g / 255;
    var BsRGB = b / 255;
    var R = RsRGB <= 0.03928 ? RsRGB / 12.92 : Math.pow((RsRGB + 0.055) / 1.055, 2.4);
    var G = GsRGB <= 0.03928 ? GsRGB / 12.92 : Math.pow((GsRGB + 0.055) / 1.055, 2.4);
    var B = BsRGB <= 0.03928 ? BsRGB / 12.92 : Math.pow((BsRGB + 0.055) / 1.055, 2.4);
    // For the sRGB colorspace, the relative luminance of a color is defined as:
    var L = 0.2126 * R + 0.7152 * G + 0.0722 * B;
    return L;
}
function $acacd7f4637ae6d2$export$d061e26956a60b0a(foreground, background) {
    if (!$acacd7f4637ae6d2$var$isValidHex(foreground) || !$acacd7f4637ae6d2$var$isValidHex(background)) throw new Error('Invalid HEX');
    var foregroundRgb = $acacd7f4637ae6d2$export$5a544e13ad4e1fa5(foreground);
    var backgroundRgb = $acacd7f4637ae6d2$export$5a544e13ad4e1fa5(background);
    var foregroundLuminance = $acacd7f4637ae6d2$export$e770b01b744f3745(foregroundRgb[0], foregroundRgb[1], foregroundRgb[2]);
    var backgroundLuminance = $acacd7f4637ae6d2$export$e770b01b744f3745(backgroundRgb[0], backgroundRgb[1], backgroundRgb[2]);
    // calculate the color contrast ratio
    var brightest = Math.max(foregroundLuminance, backgroundLuminance);
    var darkest = Math.min(foregroundLuminance, backgroundLuminance);
    return (brightest + 0.05) / (darkest + 0.05);
}
function $acacd7f4637ae6d2$export$e8ddad763b4bebf9(rgbA, rgbB) {
    var labA = $acacd7f4637ae6d2$var$rgbToLab(rgbA);
    var labB = $acacd7f4637ae6d2$var$rgbToLab(rgbB);
    var deltaL = labA[0] - labB[0];
    var deltaA = labA[1] - labB[1];
    var deltaB = labA[2] - labB[2];
    var c1 = Math.sqrt(labA[1] * labA[1] + labA[2] * labA[2]);
    var c2 = Math.sqrt(labB[1] * labB[1] + labB[2] * labB[2]);
    var deltaC = c1 - c2;
    var deltaH = deltaA * deltaA + deltaB * deltaB - deltaC * deltaC;
    deltaH = deltaH < 0 ? 0 : Math.sqrt(deltaH);
    var sc = 1.0 + 0.045 * c1;
    var sh = 1.0 + 0.015 * c1;
    var deltaLKlsl = deltaL / 1.0;
    var deltaCkcsc = deltaC / sc;
    var deltaHkhsh = deltaH / sh;
    var i = deltaLKlsl * deltaLKlsl + deltaCkcsc * deltaCkcsc + deltaHkhsh * deltaHkhsh;
    return i < 0 ? 0 : Math.sqrt(i);
}
function $acacd7f4637ae6d2$var$rgbToLab(rgb) {
    var r = rgb[0] / 255, g = rgb[1] / 255, b = rgb[2] / 255, x, y, z;
    r = r > 0.04045 ? Math.pow((r + 0.055) / 1.055, 2.4) : r / 12.92;
    g = g > 0.04045 ? Math.pow((g + 0.055) / 1.055, 2.4) : g / 12.92;
    b = b > 0.04045 ? Math.pow((b + 0.055) / 1.055, 2.4) : b / 12.92;
    x = (r * 0.4124 + g * 0.3576 + b * 0.1805) / 0.95047;
    y = (r * 0.2126 + g * 0.7152 + b * 0.0722) / 1.0;
    z = (r * 0.0193 + g * 0.1192 + b * 0.9505) / 1.08883;
    x = x > 0.008856 ? Math.pow(x, 1 / 3) : 7.787 * x + 16 / 116;
    y = y > 0.008856 ? Math.pow(y, 1 / 3) : 7.787 * y + 16 / 116;
    z = z > 0.008856 ? Math.pow(z, 1 / 3) : 7.787 * z + 16 / 116;
    return [
        116 * y - 16,
        500 * (x - y),
        200 * (y - z)
    ];
}

});

parcelRegister("41qbW", function(module, exports) {
$parcel$export(module.exports, "hash", () => $2edb9288a0bd3a46$export$d6af199866bfb566);
var $2edb9288a0bd3a46$export$d6af199866bfb566 = function hash(str) {
    var hash = 0;
    for(var i = 0; i < str.length; i++){
        var char = str.charCodeAt(i);
        hash = (hash << 5) - hash + char;
        hash &= hash; // Convert to 32bit integer
    }
    return new Uint32Array([
        hash
    ])[0].toString(36);
};

});


parcelRegister("dDp8W", function(module, exports) {
$parcel$export(module.exports, "default", () => $028fc7eea1dbc5a2$export$2e2bcd8739ae039);

var $25nEq = parcelRequire("25nEq");

var $fL8KA = parcelRequire("fL8KA");

var $6HG4S = parcelRequire("6HG4S");

var $9Zzpd = parcelRequire("9Zzpd");

var $1xA3v = parcelRequire("1xA3v");

var $j03Wu = parcelRequire("j03Wu");

var $eP92L = parcelRequire("eP92L");

var $e4peT = parcelRequire("e4peT");

var $i78o7 = parcelRequire("i78o7");

var $dmkl6 = parcelRequire("dmkl6");

var $kg8yF = parcelRequire("kg8yF");
function $028fc7eea1dbc5a2$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $028fc7eea1dbc5a2$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $028fc7eea1dbc5a2$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $028fc7eea1dbc5a2$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $028fc7eea1dbc5a2$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $028fc7eea1dbc5a2$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $028fc7eea1dbc5a2$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $028fc7eea1dbc5a2$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $028fc7eea1dbc5a2$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $028fc7eea1dbc5a2$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}

/**
 * Sets the theme globally at runtime. This updates the `data-theme` and `data-color-mode` attributes on your page's <html> tag.
 *
 * @param {Object<string, string>} themeState The themes and color mode that should be applied.
 * @param {string} themeState.colorMode Determines which color theme is applied. If set to `auto`, the theme applied will be determined by the OS setting.
 * @param {string} themeState.contrastMode The contrast mode theme to be applied. If set to `auto`, the theme applied will be determined by the OS setting.set to `auto`, the theme applied will be determined by the OS setting.
 * @param {string} themeState.dark The color theme to be applied when the color mode resolves to 'dark'.
 * @param {string} themeState.light The color theme to be applied when the color mode resolves to 'light'.
 * @param {string} themeState.motion The motion theme to be applied.
 * @param {string} themeState.shape The shape theme to be applied.
 * @param {string} themeState.spacing The spacing theme to be applied.
 * @param {string} themeState.typography The typography theme to be applied.
 * @param {Object} themeState.UNSAFE_themeOptions The custom branding options to be used for custom theme generation
 * @param {function} themeLoader Callback function used to override the default theme loading functionality.
 *
 * @returns A Promise of an unbind function, that can be used to stop listening for changes to system theme.
 *
 * @example
 * ```
 * setGlobalTheme({colorMode: 'auto', light: 'light', dark: 'dark', spacing: 'spacing'});
 * ```
 */ var $028fc7eea1dbc5a2$var$setGlobalTheme = /*#__PURE__*/ function() {
    var _ref = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee3() {
        var nextThemeState, themeLoader, _ref2, _ref2$colorMode, colorMode, _ref2$contrastMode, contrastMode, _ref2$dark, dark, _ref2$light, light, _ref2$shape, shape, _ref2$spacing, spacing, _ref2$typography, typography, _ref2$motion, motion, _ref2$UNSAFE_themeOpt, UNSAFE_themeOptions, themeState, themePreferences, loadingStrategy, loadingTasks, mode, attrOfMissingCustomStyles, themeOverridePreferences, _iterator, _step, themeId, autoUnbind, _args3 = arguments;
        return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee3$(_context3) {
            while(true)switch(_context3.prev = _context3.next){
                case 0:
                    nextThemeState = _args3.length > 0 && _args3[0] !== undefined ? _args3[0] : {};
                    themeLoader = _args3.length > 1 ? _args3[1] : undefined;
                    _ref2 = typeof nextThemeState === 'function' ? nextThemeState($028fc7eea1dbc5a2$var$_objectSpread($028fc7eea1dbc5a2$var$_objectSpread({}, (0, $j03Wu.themeStateDefaults)), {}, {
                        typography: (0, $j03Wu.themeStateDefaults)['typography'],
                        shape: (0, $j03Wu.themeStateDefaults)['shape'](),
                        motion: (0, $j03Wu.themeStateDefaults)['motion']()
                    }, (0, $1xA3v.default)())) : nextThemeState, _ref2$colorMode = _ref2.colorMode, colorMode = _ref2$colorMode === void 0 ? (0, $j03Wu.themeStateDefaults)['colorMode'] : _ref2$colorMode, _ref2$contrastMode = _ref2.contrastMode, contrastMode = _ref2$contrastMode === void 0 ? (0, $j03Wu.themeStateDefaults)['contrastMode'] : _ref2$contrastMode, _ref2$dark = _ref2.dark, dark = _ref2$dark === void 0 ? (0, $j03Wu.themeStateDefaults)['dark'] : _ref2$dark, _ref2$light = _ref2.light, light = _ref2$light === void 0 ? (0, $j03Wu.themeStateDefaults)['light'] : _ref2$light, _ref2$shape = _ref2.shape, shape = _ref2$shape === void 0 ? (0, $j03Wu.themeStateDefaults)['shape']() : _ref2$shape, _ref2$spacing = _ref2.spacing, spacing = _ref2$spacing === void 0 ? (0, $j03Wu.themeStateDefaults)['spacing'] : _ref2$spacing, _ref2$typography = _ref2.typography, typography = _ref2$typography === void 0 ? (0, $j03Wu.themeStateDefaults)['typography'] : _ref2$typography, _ref2$motion = _ref2.motion, motion = _ref2$motion === void 0 ? (0, $j03Wu.themeStateDefaults)['motion']() : _ref2$motion, _ref2$UNSAFE_themeOpt = _ref2.UNSAFE_themeOptions, UNSAFE_themeOptions = _ref2$UNSAFE_themeOpt === void 0 ? (0, $j03Wu.themeStateDefaults)['UNSAFE_themeOptions'] : _ref2$UNSAFE_themeOpt; // CLEANUP: Remove. This blocks application of increased contrast themes
                    // without the feature flag enabled.
                    if (!(0, $9Zzpd.fg)('platform_increased-contrast-themes')) {
                        if (light === 'light-increased-contrast') light = 'light';
                        if (dark === 'dark-increased-contrast') dark = 'dark';
                    }
                    themeState = {
                        colorMode: colorMode,
                        contrastMode: contrastMode,
                        dark: dark,
                        light: light,
                        shape: shape,
                        spacing: spacing,
                        typography: typography,
                        motion: motion,
                        UNSAFE_themeOptions: themeLoader ? undefined : UNSAFE_themeOptions
                    }; // Determine what to load and loading strategy
                    themePreferences = (0, $dmkl6.getThemePreferences)(themeState);
                    loadingStrategy = themeLoader ? themeLoader : (0, $kg8yF.loadAndAppendThemeCss); // Load standard themes
                    loadingTasks = themePreferences.map(/*#__PURE__*/ function() {
                        var _ref3 = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee(themeId) {
                            return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee$(_context) {
                                while(true)switch(_context.prev = _context.next){
                                    case 0:
                                        _context.next = 2;
                                        return loadingStrategy(themeId);
                                    case 2:
                                        return _context.abrupt("return", _context.sent);
                                    case 3:
                                    case "end":
                                        return _context.stop();
                                }
                            }, _callee);
                        }));
                        return function(_x) {
                            return _ref3.apply(this, arguments);
                        };
                    }()); // Load custom themes if needed
                    if (!themeLoader && UNSAFE_themeOptions && (0, $eP92L.isValidBrandHex)(UNSAFE_themeOptions === null || UNSAFE_themeOptions === void 0 ? void 0 : UNSAFE_themeOptions.brandColor)) {
                        mode = colorMode || (0, $j03Wu.themeStateDefaults)['colorMode'];
                        attrOfMissingCustomStyles = (0, $i78o7.findMissingCustomStyleElements)(UNSAFE_themeOptions, mode);
                        if (attrOfMissingCustomStyles.length > 0) // Load custom theme styles
                        loadingTasks.push((0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee2() {
                            var _yield$import, loadAndAppendCustomThemeCss;
                            return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee2$(_context2) {
                                while(true)switch(_context2.prev = _context2.next){
                                    case 0:
                                        _context2.next = 2;
                                        return (parcelRequire("iXY1L"));
                                    case 2:
                                        _yield$import = _context2.sent;
                                        loadAndAppendCustomThemeCss = _yield$import.loadAndAppendCustomThemeCss;
                                        loadAndAppendCustomThemeCss({
                                            colorMode: attrOfMissingCustomStyles.length === 2 ? 'auto' : // only load the missing custom theme styles
                                            attrOfMissingCustomStyles[0],
                                            UNSAFE_themeOptions: UNSAFE_themeOptions
                                        });
                                    case 5:
                                    case "end":
                                        return _context2.stop();
                                }
                            }, _callee2);
                        }))());
                    }
                    _context3.next = 11;
                    return Promise.all(loadingTasks);
                case 11:
                    // Load override themes after standard themes
                    themeOverridePreferences = (0, $dmkl6.getThemeOverridePreferences)(themeState);
                    _iterator = $028fc7eea1dbc5a2$var$_createForOfIteratorHelper(themeOverridePreferences);
                    _context3.prev = 13;
                    _iterator.s();
                case 15:
                    if ((_step = _iterator.n()).done) {
                        _context3.next = 21;
                        break;
                    }
                    themeId = _step.value;
                    _context3.next = 19;
                    return loadingStrategy(themeId);
                case 19:
                    _context3.next = 15;
                    break;
                case 21:
                    _context3.next = 26;
                    break;
                case 23:
                    _context3.prev = 23;
                    _context3.t0 = _context3["catch"](13);
                    _iterator.e(_context3.t0);
                case 26:
                    _context3.prev = 26;
                    _iterator.f();
                    return _context3.finish(26);
                case 29:
                    autoUnbind = (0, $e4peT.default)(themeState);
                    return _context3.abrupt("return", autoUnbind);
                case 31:
                case "end":
                    return _context3.stop();
            }
        }, _callee3, null, [
            [
                13,
                23,
                26,
                29
            ]
        ]);
    }));
    return function setGlobalTheme() {
        return _ref.apply(this, arguments);
    };
}();
var $028fc7eea1dbc5a2$export$2e2bcd8739ae039 = $028fc7eea1dbc5a2$var$setGlobalTheme;

});
parcelRegister("1xA3v", function(module, exports) {
$parcel$export(module.exports, "default", () => $11f4d765d3920263$export$2e2bcd8739ae039);

var $25nEq = parcelRequire("25nEq");

var $m5DAZ = parcelRequire("m5DAZ");

var $j03Wu = parcelRequire("j03Wu");

var $3gdkK = parcelRequire("3gdkK");
function $11f4d765d3920263$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $11f4d765d3920263$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $11f4d765d3920263$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $11f4d765d3920263$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $11f4d765d3920263$var$isThemeColorMode = function isThemeColorMode(colorMode) {
    return (0, $j03Wu.themeColorModes).find(function(mode) {
        return mode === colorMode;
    }) !== undefined;
};
var $11f4d765d3920263$var$getGlobalTheme = function getGlobalTheme() {
    if (typeof document === 'undefined') return {};
    var element = document.documentElement;
    var colorMode = element.getAttribute((0, $m5DAZ.COLOR_MODE_ATTRIBUTE)) || '';
    var theme = element.getAttribute((0, $m5DAZ.THEME_DATA_ATTRIBUTE)) || '';
    return $11f4d765d3920263$var$_objectSpread($11f4d765d3920263$var$_objectSpread({}, (0, $3gdkK.themeStringToObject)(theme)), $11f4d765d3920263$var$isThemeColorMode(colorMode) && {
        colorMode: colorMode
    });
};
var $11f4d765d3920263$export$2e2bcd8739ae039 = $11f4d765d3920263$var$getGlobalTheme;

});

parcelRegister("e4peT", function(module, exports) {
$parcel$export(module.exports, "default", () => $a3e5045eb0e75440$export$2e2bcd8739ae039);

var $iYJcE = parcelRequire("iYJcE");

var $9Zzpd = parcelRequire("9Zzpd");

var $9XHvc = parcelRequire("9XHvc");

var $7BBte = parcelRequire("7BBte");

var $8Ioeg = parcelRequire("8Ioeg");
function $a3e5045eb0e75440$export$2e2bcd8739ae039(themeState) {
    if (themeState.colorMode === 'auto') {
        // Set colorMode based on the user preference
        themeState.colorMode = (0, $7BBte.default).getColorMode();
        // Bind a listener (if one doesn't already exist) to keep colorMode updated
        (0, $7BBte.default).bind();
    } else (0, $7BBte.default).unbind();
    if ((0, $9Zzpd.fg)('platform_increased-contrast-themes')) {
        if (themeState.contrastMode === 'auto') {
            // Set contrastMode based on the user preference
            themeState.contrastMode = (0, $8Ioeg.default).getContrastMode();
            // Bind a listener (if one doesn't already exist) to keep contrastMode updated
            (0, $8Ioeg.default).bind();
        } else (0, $8Ioeg.default).unbind();
    }
    var themeAttributes = (0, $9XHvc.default)(themeState);
    Object.entries(themeAttributes).forEach(function(_ref) {
        var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_ref, 2), key = _ref2[0], value = _ref2[1];
        document.documentElement.setAttribute(key, value);
    });
    return function() {
        (0, $7BBte.default).unbind();
        if ((0, $9Zzpd.fg)('platform_increased-contrast-themes')) (0, $8Ioeg.default).unbind();
    };
}

});
parcelRegister("7BBte", function(module, exports) {
$parcel$export(module.exports, "default", () => $58990df37db7544e$export$2e2bcd8739ae039);

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $25nEq = parcelRequire("25nEq");

var $7QpUe = parcelRequire("7QpUe");

var $m5DAZ = parcelRequire("m5DAZ");

var $kg8yF = parcelRequire("kg8yF");
var $58990df37db7544e$var$isMatchMediaAvailable = typeof window !== 'undefined' && 'matchMedia' in window;
/**
 * Updates the current theme when the system theme changes. Should be bound
 * to an event listener listening on the '(prefers-color-scheme: dark)' query
 * @param e The event representing a change in system theme.
 */ function $58990df37db7544e$var$checkNativeListener(e) {
    var element = document.documentElement;
    element.setAttribute((0, $m5DAZ.COLOR_MODE_ATTRIBUTE), e.matches ? 'dark' : 'light');
}
var $58990df37db7544e$var$darkModeMql = $58990df37db7544e$var$isMatchMediaAvailable && window.matchMedia((0, $kg8yF.darkModeMediaQuery));
var $58990df37db7544e$var$ColorModeObserver = /*#__PURE__*/ function() {
    function ColorModeObserver() {
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, ColorModeObserver);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "unbindThemeChangeListener", null);
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(ColorModeObserver, [
        {
            key: "getColorMode",
            value: function getColorMode() {
                if (!$58990df37db7544e$var$darkModeMql) return 'light';
                return $58990df37db7544e$var$darkModeMql !== null && $58990df37db7544e$var$darkModeMql !== void 0 && $58990df37db7544e$var$darkModeMql.matches ? 'dark' : 'light';
            }
        },
        {
            key: "bind",
            value: function bind() {
                if ($58990df37db7544e$var$darkModeMql && this.unbindThemeChangeListener === null) this.unbindThemeChangeListener = (0, $7QpUe.bind)($58990df37db7544e$var$darkModeMql, {
                    type: 'change',
                    listener: $58990df37db7544e$var$checkNativeListener
                });
            }
        },
        {
            key: "unbind",
            value: function unbind() {
                if (this.unbindThemeChangeListener) {
                    this.unbindThemeChangeListener();
                    this.unbindThemeChangeListener = null;
                }
            }
        }
    ]);
}();
/**
 * A singleton color mode observer - binds "auto" switching logic to a single `mediaQueryList` listener
 * that can be unbound by any consumer when no longer needed.
 */ var $58990df37db7544e$var$SingletonColorModeObserver = new $58990df37db7544e$var$ColorModeObserver();
var $58990df37db7544e$export$2e2bcd8739ae039 = $58990df37db7544e$var$SingletonColorModeObserver;

});
parcelRegister("kg8yF", function(module, exports) {
$parcel$export(module.exports, "loadAndAppendThemeCss", () => $ebfbf0bfb90e90b7$export$26cd7ae85c7144e5);
$parcel$export(module.exports, "darkModeMediaQuery", () => $ebfbf0bfb90e90b7$export$bb1e815119d30f8b);
$parcel$export(module.exports, "moreContrastMediaQuery", () => $ebfbf0bfb90e90b7$export$8662df6937d86fcb);

var $fL8KA = parcelRequire("fL8KA");

var $6HG4S = parcelRequire("6HG4S");

var $jxmFQ = parcelRequire("jxmFQ");

var $m5DAZ = parcelRequire("m5DAZ");
var $ebfbf0bfb90e90b7$export$26cd7ae85c7144e5 = /*#__PURE__*/ function() {
    var _ref = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee(themeId) {
        var themeCss, style;
        return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee$(_context) {
            while(true)switch(_context.prev = _context.next){
                case 0:
                    if (!document.head.querySelector("style[".concat((0, $m5DAZ.THEME_DATA_ATTRIBUTE), "=\"").concat(themeId, "\"]:not([").concat((0, $m5DAZ.CUSTOM_THEME_ATTRIBUTE), "])"))) {
                        _context.next = 2;
                        break;
                    }
                    return _context.abrupt("return");
                case 2:
                    if (themeId) {
                        _context.next = 4;
                        break;
                    }
                    return _context.abrupt("return");
                case 4:
                    _context.next = 6;
                    return $ebfbf0bfb90e90b7$export$8a48286ed7df6720(themeId);
                case 6:
                    themeCss = _context.sent;
                    style = document.createElement('style');
                    style.textContent = themeCss;
                    style.dataset.theme = themeId;
                    document.head.appendChild(style);
                case 11:
                case "end":
                    return _context.stop();
            }
        }, _callee);
    }));
    return function loadAndAppendThemeCss(_x) {
        return _ref.apply(this, arguments);
    };
}();
var $ebfbf0bfb90e90b7$export$8a48286ed7df6720 = /*#__PURE__*/ function() {
    var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee2(themeId) {
        var _yield$themeImportMap, themeCss;
        return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee2$(_context2) {
            while(true)switch(_context2.prev = _context2.next){
                case 0:
                    _context2.next = 2;
                    return (0, $jxmFQ.default)[themeId]();
                case 2:
                    _yield$themeImportMap = _context2.sent;
                    themeCss = _yield$themeImportMap.default;
                    return _context2.abrupt("return", themeCss);
                case 5:
                case "end":
                    return _context2.stop();
            }
        }, _callee2);
    }));
    return function loadThemeCss(_x2) {
        return _ref2.apply(this, arguments);
    };
}();
var $ebfbf0bfb90e90b7$export$bb1e815119d30f8b = '(prefers-color-scheme: dark)';
var $ebfbf0bfb90e90b7$export$8662df6937d86fcb = '(prefers-contrast: more)';

});
parcelRegister("jxmFQ", function(module, exports) {
$parcel$export(module.exports, "default", () => $e392aff1953abd53$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 *
 * This file contains a dynamic import for each theme this package exports.
 * Themes are loaded asynchronously at runtime to minimise the amount of CSS we send to the client.
 * This allows users to compose their themes and only use the tokens that are requested.
 * When a new theme is created, the import should automatically be added to the map
 *
 * @codegen <<SignedSource::a20c72d683b08b594c5be4160eec5f78>>
 * @codegenCommand yarn build tokens
 */ 









var $e392aff1953abd53$var$themeImportsMap = {
    'light': function light() {
        return (parcelRequire("9WLX2"));
    },
    'light-future': function lightFuture() {
        return (parcelRequire("2ZsC5"));
    },
    'light-increased-contrast': function lightIncreasedContrast() {
        return (parcelRequire("kV9zT"));
    },
    'dark': function dark() {
        return (parcelRequire("eprJf"));
    },
    'dark-future': function darkFuture() {
        return (parcelRequire("345Mq"));
    },
    'dark-increased-contrast': function darkIncreasedContrast() {
        return (parcelRequire("6BOId"));
    },
    'spacing': function spacing() {
        return (parcelRequire("fHY4o"));
    },
    'typography': function typography() {
        return (parcelRequire("6JTaX"));
    },
    'shape': function shape() {
        return (parcelRequire("3aFsJ"));
    },
    'motion': function motion() {
        return (parcelRequire("dSZUi"));
    }
};
var $e392aff1953abd53$export$2e2bcd8739ae039 = $e392aff1953abd53$var$themeImportsMap;

});
parcelRegister("9WLX2", function(module, exports) {

var $iKwew = parcelRequire("iKwew");
module.exports = $iKwew("i9qjW").then(()=>parcelRequire('bEBd3'));

});

parcelRegister("2ZsC5", function(module, exports) {

var $iKwew = parcelRequire("iKwew");
module.exports = $iKwew("9EWty").then(()=>parcelRequire('9Enqw'));

});

parcelRegister("kV9zT", function(module, exports) {

var $iKwew = parcelRequire("iKwew");
module.exports = $iKwew("d3A4J").then(()=>parcelRequire('ia0QX'));

});

parcelRegister("eprJf", function(module, exports) {

var $iKwew = parcelRequire("iKwew");
module.exports = $iKwew("jD3qZ").then(()=>parcelRequire('5NLBO'));

});

parcelRegister("345Mq", function(module, exports) {

var $iKwew = parcelRequire("iKwew");
module.exports = $iKwew("9XpHe").then(()=>parcelRequire('L5vkl'));

});

parcelRegister("6BOId", function(module, exports) {

var $iKwew = parcelRequire("iKwew");
module.exports = $iKwew("jUGEG").then(()=>parcelRequire('4Eu8C'));

});

parcelRegister("fHY4o", function(module, exports) {

var $iKwew = parcelRequire("iKwew");
module.exports = $iKwew("jUwRB").then(()=>parcelRequire('iX4ji'));

});

parcelRegister("6JTaX", function(module, exports) {

var $iKwew = parcelRequire("iKwew");
module.exports = $iKwew("j3RFh").then(()=>parcelRequire('hZqxq'));

});

parcelRegister("3aFsJ", function(module, exports) {

var $iKwew = parcelRequire("iKwew");
module.exports = $iKwew("7JgwL").then(()=>parcelRequire('Ql9jD'));

});

parcelRegister("dSZUi", function(module, exports) {

var $iKwew = parcelRequire("iKwew");
module.exports = $iKwew("fKHdI").then(()=>parcelRequire('kqIIz'));

});




parcelRegister("8Ioeg", function(module, exports) {
$parcel$export(module.exports, "default", () => $65853a31955eae4e$export$2e2bcd8739ae039);

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $25nEq = parcelRequire("25nEq");

var $7QpUe = parcelRequire("7QpUe");

var $m5DAZ = parcelRequire("m5DAZ");

var $kg8yF = parcelRequire("kg8yF");
var $65853a31955eae4e$var$isMatchMediaAvailable = typeof window !== 'undefined' && 'matchMedia' in window;
/**
 * Updates the current theme when the system contrast preference changes. Should be bound
 * to an event listener listening on the '(prefers-contrast: more)' query
 * @param e The event representing a change in system theme.
 */ function $65853a31955eae4e$var$checkNativeListener(e) {
    var element = document.documentElement;
    element.setAttribute((0, $m5DAZ.CONTRAST_MODE_ATTRIBUTE), e.matches ? 'more' : 'no-preference');
}
var $65853a31955eae4e$var$contrastModeMql = $65853a31955eae4e$var$isMatchMediaAvailable && window.matchMedia((0, $kg8yF.moreContrastMediaQuery));
var $65853a31955eae4e$var$ContrastModeObserver = /*#__PURE__*/ function() {
    function ContrastModeObserver() {
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, ContrastModeObserver);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "unbindContrastChangeListener", null);
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(ContrastModeObserver, [
        {
            key: "getContrastMode",
            value: function getContrastMode() {
                if (!$65853a31955eae4e$var$contrastModeMql) return 'no-preference';
                return $65853a31955eae4e$var$contrastModeMql !== null && $65853a31955eae4e$var$contrastModeMql !== void 0 && $65853a31955eae4e$var$contrastModeMql.matches ? 'more' : 'no-preference';
            }
        },
        {
            key: "bind",
            value: function bind() {
                if ($65853a31955eae4e$var$contrastModeMql && this.unbindContrastChangeListener === null) this.unbindContrastChangeListener = (0, $7QpUe.bind)($65853a31955eae4e$var$contrastModeMql, {
                    type: 'change',
                    listener: $65853a31955eae4e$var$checkNativeListener
                });
            }
        },
        {
            key: "unbind",
            value: function unbind() {
                if (this.unbindContrastChangeListener) {
                    this.unbindContrastChangeListener();
                    this.unbindContrastChangeListener = null;
                }
            }
        }
    ]);
}();
/**
 * A singleton contrast mode observer - binds "auto" switching logic to a single `mediaQueryList` listener
 * that can be unbound by any consumer when no longer needed.
 */ var $65853a31955eae4e$var$SingletonContrastModeObserver = new $65853a31955eae4e$var$ContrastModeObserver();
var $65853a31955eae4e$export$2e2bcd8739ae039 = $65853a31955eae4e$var$SingletonContrastModeObserver;

});


parcelRegister("i78o7", function(module, exports) {
$parcel$export(module.exports, "findMissingCustomStyleElements", () => $d2ff63265a11a740$export$bd1ac9300b0e885a);
$parcel$export(module.exports, "limitSizeOfCustomStyleElements", () => $d2ff63265a11a740$export$e7ae172320e03461);
$parcel$export(module.exports, "reduceTokenMap", () => $d2ff63265a11a740$export$e673f367da2ff23e);

var $iYJcE = parcelRequire("iYJcE");

var $fC8ib = parcelRequire("fC8ib");

var $gtYn5 = parcelRequire("gtYn5");

var $m5DAZ = parcelRequire("m5DAZ");

var $41qbW = parcelRequire("41qbW");
function $d2ff63265a11a740$export$bd1ac9300b0e885a(UNSAFE_themeOptions, mode) {
    var optionString = JSON.stringify(UNSAFE_themeOptions);
    var uniqueId = (0, $41qbW.hash)(optionString);
    var attrOfMissingCustomStyles = [];
    (mode === 'auto' ? [
        'light',
        'dark'
    ] : [
        mode
    ]).forEach(function(themeId) {
        var element = document.head.querySelector("style[".concat((0, $m5DAZ.CUSTOM_THEME_ATTRIBUTE), "=\"").concat(uniqueId, "\"][").concat((0, $m5DAZ.THEME_DATA_ATTRIBUTE), "=\"").concat(themeId, "\"]"));
        if (element) // Append the existing custom styles to take precedence over others
        document.head.appendChild(element);
        else attrOfMissingCustomStyles.push(themeId);
    });
    return attrOfMissingCustomStyles;
}
function $d2ff63265a11a740$export$e7ae172320e03461(sizeThreshold) {
    var styleTags = (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(Array.from(document.head.querySelectorAll("style[".concat((0, $m5DAZ.CUSTOM_THEME_ATTRIBUTE), "][").concat((0, $m5DAZ.THEME_DATA_ATTRIBUTE), "]"))));
    if (styleTags.length < sizeThreshold) return;
    styleTags.slice(0, styleTags.length - (sizeThreshold - 1)).forEach(function(element) {
        return element.remove();
    });
}
function $d2ff63265a11a740$export$e673f367da2ff23e(tokenMap, themeRamp) {
    return Object.entries(tokenMap).reduce(function(acc, _ref) {
        var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_ref, 2), key = _ref2[0], value = _ref2[1];
        var cssVar = (0, $gtYn5.default)[key];
        return cssVar ? "".concat(acc, "\n  ").concat(cssVar, ": ").concat(typeof value === 'string' ? value : themeRamp[value], ";") : acc;
    }, '');
}

});
parcelRegister("gtYn5", function(module, exports) {
$parcel$export(module.exports, "default", () => $bffe2f419c6e11a6$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::921c184d9a6e3b52bd2ab053939ce9ad>>
 * @codegenCommand yarn build tokens
 */ var $bffe2f419c6e11a6$var$tokens = {
    'motion.avatar.enter': '--ds-avatar-enter',
    'motion.avatar.exit': '--ds-avatar-exit',
    'motion.avatar.hovered': '--ds-avatar-hovered',
    'motion.content.enter.long': '--ds-content-enter-long',
    'motion.content.enter.medium': '--ds-content-enter-medium',
    'motion.content.enter.short': '--ds-content-enter-short',
    'motion.content.exit.long': '--ds-content-exit-long',
    'motion.content.exit.medium': '--ds-content-exit-medium',
    'motion.content.exit.short': '--ds-content-exit-short',
    'motion.flag.enter': '--ds-flag-enter',
    'motion.flag.exit': '--ds-flag-exit',
    'motion.flag.reposition': '--ds-flag-reposition',
    'motion.modal.enter': '--ds-modal-enter',
    'motion.modal.exit': '--ds-modal-exit',
    'motion.popup.enter.bottom': '--ds-popup-enter-bottom',
    'motion.popup.enter.left': '--ds-popup-enter-left',
    'motion.popup.enter.right': '--ds-popup-enter-right',
    'motion.popup.enter.top': '--ds-popup-enter-top',
    'motion.popup.exit.bottom': '--ds-popup-exit-bottom',
    'motion.popup.exit.left': '--ds-popup-exit-left',
    'motion.popup.exit.right': '--ds-popup-exit-right',
    'motion.popup.exit.top': '--ds-popup-exit-top',
    'motion.spotlight.enter': '--ds-spotlight-enter',
    'motion.spotlight.exit': '--ds-spotlight-exit',
    'color.text': '--ds-text',
    'color.text.accent.lime': '--ds-text-accent-lime',
    'color.text.accent.lime.bolder': '--ds-text-accent-lime-bolder',
    'color.text.accent.red': '--ds-text-accent-red',
    'color.text.accent.red.bolder': '--ds-text-accent-red-bolder',
    'color.text.accent.orange': '--ds-text-accent-orange',
    'color.text.accent.orange.bolder': '--ds-text-accent-orange-bolder',
    'color.text.accent.yellow': '--ds-text-accent-yellow',
    'color.text.accent.yellow.bolder': '--ds-text-accent-yellow-bolder',
    'color.text.accent.green': '--ds-text-accent-green',
    'color.text.accent.green.bolder': '--ds-text-accent-green-bolder',
    'color.text.accent.teal': '--ds-text-accent-teal',
    'color.text.accent.teal.bolder': '--ds-text-accent-teal-bolder',
    'color.text.accent.blue': '--ds-text-accent-blue',
    'color.text.accent.blue.bolder': '--ds-text-accent-blue-bolder',
    'color.text.accent.purple': '--ds-text-accent-purple',
    'color.text.accent.purple.bolder': '--ds-text-accent-purple-bolder',
    'color.text.accent.magenta': '--ds-text-accent-magenta',
    'color.text.accent.magenta.bolder': '--ds-text-accent-magenta-bolder',
    'color.text.accent.gray': '--ds-text-accent-gray',
    'color.text.accent.gray.bolder': '--ds-text-accent-gray-bolder',
    'color.text.disabled': '--ds-text-disabled',
    'color.text.inverse': '--ds-text-inverse',
    'color.text.selected': '--ds-text-selected',
    'color.text.brand': '--ds-text-brand',
    'color.text.danger': '--ds-text-danger',
    'color.text.danger.bolder': '--ds-text-danger-bolder',
    'color.text.warning': '--ds-text-warning',
    'color.text.warning.inverse': '--ds-text-warning-inverse',
    'color.text.warning.bolder': '--ds-text-warning-bolder',
    'color.text.success': '--ds-text-success',
    'color.text.success.bolder': '--ds-text-success-bolder',
    'color.text.discovery': '--ds-text-discovery',
    'color.text.discovery.bolder': '--ds-text-discovery-bolder',
    'color.text.information': '--ds-text-information',
    'color.text.information.bolder': '--ds-text-information-bolder',
    'color.text.subtlest': '--ds-text-subtlest',
    'color.text.subtle': '--ds-text-subtle',
    'color.link': '--ds-link',
    'color.link.pressed': '--ds-link-pressed',
    'color.link.visited': '--ds-link-visited',
    'color.link.visited.pressed': '--ds-link-visited-pressed',
    'color.icon': '--ds-icon',
    'color.icon.accent.lime': '--ds-icon-accent-lime',
    'color.icon.accent.red': '--ds-icon-accent-red',
    'color.icon.accent.orange': '--ds-icon-accent-orange',
    'color.icon.accent.yellow': '--ds-icon-accent-yellow',
    'color.icon.accent.green': '--ds-icon-accent-green',
    'color.icon.accent.teal': '--ds-icon-accent-teal',
    'color.icon.accent.blue': '--ds-icon-accent-blue',
    'color.icon.accent.purple': '--ds-icon-accent-purple',
    'color.icon.accent.magenta': '--ds-icon-accent-magenta',
    'color.icon.accent.gray': '--ds-icon-accent-gray',
    'color.icon.disabled': '--ds-icon-disabled',
    'color.icon.inverse': '--ds-icon-inverse',
    'color.icon.selected': '--ds-icon-selected',
    'color.icon.brand': '--ds-icon-brand',
    'color.icon.danger': '--ds-icon-danger',
    'color.icon.warning': '--ds-icon-warning',
    'color.icon.warning.inverse': '--ds-icon-warning-inverse',
    'color.icon.success': '--ds-icon-success',
    'color.icon.discovery': '--ds-icon-discovery',
    'color.icon.information': '--ds-icon-information',
    'color.icon.subtlest': '--ds-icon-subtlest',
    'color.icon.subtle': '--ds-icon-subtle',
    'color.border': '--ds-border',
    'color.border.accent.lime': '--ds-border-accent-lime',
    'color.border.accent.red': '--ds-border-accent-red',
    'color.border.accent.orange': '--ds-border-accent-orange',
    'color.border.accent.yellow': '--ds-border-accent-yellow',
    'color.border.accent.green': '--ds-border-accent-green',
    'color.border.accent.teal': '--ds-border-accent-teal',
    'color.border.accent.blue': '--ds-border-accent-blue',
    'color.border.accent.purple': '--ds-border-accent-purple',
    'color.border.accent.magenta': '--ds-border-accent-magenta',
    'color.border.accent.gray': '--ds-border-accent-gray',
    'color.border.disabled': '--ds-border-disabled',
    'color.border.focused': '--ds-border-focused',
    'color.border.input': '--ds-border-input',
    'color.border.inverse': '--ds-border-inverse',
    'color.border.selected': '--ds-border-selected',
    'color.border.brand': '--ds-border-brand',
    'color.border.danger': '--ds-border-danger',
    'color.border.warning': '--ds-border-warning',
    'color.border.success': '--ds-border-success',
    'color.border.discovery': '--ds-border-discovery',
    'color.border.information': '--ds-border-information',
    'color.border.bold': '--ds-border-bold',
    'color.background.accent.lime.subtlest': '--ds-background-accent-lime-subtlest',
    'color.background.accent.lime.subtlest.hovered': '--ds-background-accent-lime-subtlest-hovered',
    'color.background.accent.lime.subtlest.pressed': '--ds-background-accent-lime-subtlest-pressed',
    'color.background.accent.lime.subtler': '--ds-background-accent-lime-subtler',
    'color.background.accent.lime.subtler.hovered': '--ds-background-accent-lime-subtler-hovered',
    'color.background.accent.lime.subtler.pressed': '--ds-background-accent-lime-subtler-pressed',
    'color.background.accent.lime.subtle': '--ds-background-accent-lime-subtle',
    'color.background.accent.lime.subtle.hovered': '--ds-background-accent-lime-subtle-hovered',
    'color.background.accent.lime.subtle.pressed': '--ds-background-accent-lime-subtle-pressed',
    'color.background.accent.lime.bolder': '--ds-background-accent-lime-bolder',
    'color.background.accent.lime.bolder.hovered': '--ds-background-accent-lime-bolder-hovered',
    'color.background.accent.lime.bolder.pressed': '--ds-background-accent-lime-bolder-pressed',
    'color.background.accent.red.subtlest': '--ds-background-accent-red-subtlest',
    'color.background.accent.red.subtlest.hovered': '--ds-background-accent-red-subtlest-hovered',
    'color.background.accent.red.subtlest.pressed': '--ds-background-accent-red-subtlest-pressed',
    'color.background.accent.red.subtler': '--ds-background-accent-red-subtler',
    'color.background.accent.red.subtler.hovered': '--ds-background-accent-red-subtler-hovered',
    'color.background.accent.red.subtler.pressed': '--ds-background-accent-red-subtler-pressed',
    'color.background.accent.red.subtle': '--ds-background-accent-red-subtle',
    'color.background.accent.red.subtle.hovered': '--ds-background-accent-red-subtle-hovered',
    'color.background.accent.red.subtle.pressed': '--ds-background-accent-red-subtle-pressed',
    'color.background.accent.red.bolder': '--ds-background-accent-red-bolder',
    'color.background.accent.red.bolder.hovered': '--ds-background-accent-red-bolder-hovered',
    'color.background.accent.red.bolder.pressed': '--ds-background-accent-red-bolder-pressed',
    'color.background.accent.orange.subtlest': '--ds-background-accent-orange-subtlest',
    'color.background.accent.orange.subtlest.hovered': '--ds-background-accent-orange-subtlest-hovered',
    'color.background.accent.orange.subtlest.pressed': '--ds-background-accent-orange-subtlest-pressed',
    'color.background.accent.orange.subtler': '--ds-background-accent-orange-subtler',
    'color.background.accent.orange.subtler.hovered': '--ds-background-accent-orange-subtler-hovered',
    'color.background.accent.orange.subtler.pressed': '--ds-background-accent-orange-subtler-pressed',
    'color.background.accent.orange.subtle': '--ds-background-accent-orange-subtle',
    'color.background.accent.orange.subtle.hovered': '--ds-background-accent-orange-subtle-hovered',
    'color.background.accent.orange.subtle.pressed': '--ds-background-accent-orange-subtle-pressed',
    'color.background.accent.orange.bolder': '--ds-background-accent-orange-bolder',
    'color.background.accent.orange.bolder.hovered': '--ds-background-accent-orange-bolder-hovered',
    'color.background.accent.orange.bolder.pressed': '--ds-background-accent-orange-bolder-pressed',
    'color.background.accent.yellow.subtlest': '--ds-background-accent-yellow-subtlest',
    'color.background.accent.yellow.subtlest.hovered': '--ds-background-accent-yellow-subtlest-hovered',
    'color.background.accent.yellow.subtlest.pressed': '--ds-background-accent-yellow-subtlest-pressed',
    'color.background.accent.yellow.subtler': '--ds-background-accent-yellow-subtler',
    'color.background.accent.yellow.subtler.hovered': '--ds-background-accent-yellow-subtler-hovered',
    'color.background.accent.yellow.subtler.pressed': '--ds-background-accent-yellow-subtler-pressed',
    'color.background.accent.yellow.subtle': '--ds-background-accent-yellow-subtle',
    'color.background.accent.yellow.subtle.hovered': '--ds-background-accent-yellow-subtle-hovered',
    'color.background.accent.yellow.subtle.pressed': '--ds-background-accent-yellow-subtle-pressed',
    'color.background.accent.yellow.bolder': '--ds-background-accent-yellow-bolder',
    'color.background.accent.yellow.bolder.hovered': '--ds-background-accent-yellow-bolder-hovered',
    'color.background.accent.yellow.bolder.pressed': '--ds-background-accent-yellow-bolder-pressed',
    'color.background.accent.green.subtlest': '--ds-background-accent-green-subtlest',
    'color.background.accent.green.subtlest.hovered': '--ds-background-accent-green-subtlest-hovered',
    'color.background.accent.green.subtlest.pressed': '--ds-background-accent-green-subtlest-pressed',
    'color.background.accent.green.subtler': '--ds-background-accent-green-subtler',
    'color.background.accent.green.subtler.hovered': '--ds-background-accent-green-subtler-hovered',
    'color.background.accent.green.subtler.pressed': '--ds-background-accent-green-subtler-pressed',
    'color.background.accent.green.subtle': '--ds-background-accent-green-subtle',
    'color.background.accent.green.subtle.hovered': '--ds-background-accent-green-subtle-hovered',
    'color.background.accent.green.subtle.pressed': '--ds-background-accent-green-subtle-pressed',
    'color.background.accent.green.bolder': '--ds-background-accent-green-bolder',
    'color.background.accent.green.bolder.hovered': '--ds-background-accent-green-bolder-hovered',
    'color.background.accent.green.bolder.pressed': '--ds-background-accent-green-bolder-pressed',
    'color.background.accent.teal.subtlest': '--ds-background-accent-teal-subtlest',
    'color.background.accent.teal.subtlest.hovered': '--ds-background-accent-teal-subtlest-hovered',
    'color.background.accent.teal.subtlest.pressed': '--ds-background-accent-teal-subtlest-pressed',
    'color.background.accent.teal.subtler': '--ds-background-accent-teal-subtler',
    'color.background.accent.teal.subtler.hovered': '--ds-background-accent-teal-subtler-hovered',
    'color.background.accent.teal.subtler.pressed': '--ds-background-accent-teal-subtler-pressed',
    'color.background.accent.teal.subtle': '--ds-background-accent-teal-subtle',
    'color.background.accent.teal.subtle.hovered': '--ds-background-accent-teal-subtle-hovered',
    'color.background.accent.teal.subtle.pressed': '--ds-background-accent-teal-subtle-pressed',
    'color.background.accent.teal.bolder': '--ds-background-accent-teal-bolder',
    'color.background.accent.teal.bolder.hovered': '--ds-background-accent-teal-bolder-hovered',
    'color.background.accent.teal.bolder.pressed': '--ds-background-accent-teal-bolder-pressed',
    'color.background.accent.blue.subtlest': '--ds-background-accent-blue-subtlest',
    'color.background.accent.blue.subtlest.hovered': '--ds-background-accent-blue-subtlest-hovered',
    'color.background.accent.blue.subtlest.pressed': '--ds-background-accent-blue-subtlest-pressed',
    'color.background.accent.blue.subtler': '--ds-background-accent-blue-subtler',
    'color.background.accent.blue.subtler.hovered': '--ds-background-accent-blue-subtler-hovered',
    'color.background.accent.blue.subtler.pressed': '--ds-background-accent-blue-subtler-pressed',
    'color.background.accent.blue.subtle': '--ds-background-accent-blue-subtle',
    'color.background.accent.blue.subtle.hovered': '--ds-background-accent-blue-subtle-hovered',
    'color.background.accent.blue.subtle.pressed': '--ds-background-accent-blue-subtle-pressed',
    'color.background.accent.blue.bolder': '--ds-background-accent-blue-bolder',
    'color.background.accent.blue.bolder.hovered': '--ds-background-accent-blue-bolder-hovered',
    'color.background.accent.blue.bolder.pressed': '--ds-background-accent-blue-bolder-pressed',
    'color.background.accent.purple.subtlest': '--ds-background-accent-purple-subtlest',
    'color.background.accent.purple.subtlest.hovered': '--ds-background-accent-purple-subtlest-hovered',
    'color.background.accent.purple.subtlest.pressed': '--ds-background-accent-purple-subtlest-pressed',
    'color.background.accent.purple.subtler': '--ds-background-accent-purple-subtler',
    'color.background.accent.purple.subtler.hovered': '--ds-background-accent-purple-subtler-hovered',
    'color.background.accent.purple.subtler.pressed': '--ds-background-accent-purple-subtler-pressed',
    'color.background.accent.purple.subtle': '--ds-background-accent-purple-subtle',
    'color.background.accent.purple.subtle.hovered': '--ds-background-accent-purple-subtle-hovered',
    'color.background.accent.purple.subtle.pressed': '--ds-background-accent-purple-subtle-pressed',
    'color.background.accent.purple.bolder': '--ds-background-accent-purple-bolder',
    'color.background.accent.purple.bolder.hovered': '--ds-background-accent-purple-bolder-hovered',
    'color.background.accent.purple.bolder.pressed': '--ds-background-accent-purple-bolder-pressed',
    'color.background.accent.magenta.subtlest': '--ds-background-accent-magenta-subtlest',
    'color.background.accent.magenta.subtlest.hovered': '--ds-background-accent-magenta-subtlest-hovered',
    'color.background.accent.magenta.subtlest.pressed': '--ds-background-accent-magenta-subtlest-pressed',
    'color.background.accent.magenta.subtler': '--ds-background-accent-magenta-subtler',
    'color.background.accent.magenta.subtler.hovered': '--ds-background-accent-magenta-subtler-hovered',
    'color.background.accent.magenta.subtler.pressed': '--ds-background-accent-magenta-subtler-pressed',
    'color.background.accent.magenta.subtle': '--ds-background-accent-magenta-subtle',
    'color.background.accent.magenta.subtle.hovered': '--ds-background-accent-magenta-subtle-hovered',
    'color.background.accent.magenta.subtle.pressed': '--ds-background-accent-magenta-subtle-pressed',
    'color.background.accent.magenta.bolder': '--ds-background-accent-magenta-bolder',
    'color.background.accent.magenta.bolder.hovered': '--ds-background-accent-magenta-bolder-hovered',
    'color.background.accent.magenta.bolder.pressed': '--ds-background-accent-magenta-bolder-pressed',
    'color.background.accent.gray.subtlest': '--ds-background-accent-gray-subtlest',
    'color.background.accent.gray.subtlest.hovered': '--ds-background-accent-gray-subtlest-hovered',
    'color.background.accent.gray.subtlest.pressed': '--ds-background-accent-gray-subtlest-pressed',
    'color.background.accent.gray.subtler': '--ds-background-accent-gray-subtler',
    'color.background.accent.gray.subtler.hovered': '--ds-background-accent-gray-subtler-hovered',
    'color.background.accent.gray.subtler.pressed': '--ds-background-accent-gray-subtler-pressed',
    'color.background.accent.gray.subtle': '--ds-background-accent-gray-subtle',
    'color.background.accent.gray.subtle.hovered': '--ds-background-accent-gray-subtle-hovered',
    'color.background.accent.gray.subtle.pressed': '--ds-background-accent-gray-subtle-pressed',
    'color.background.accent.gray.bolder': '--ds-background-accent-gray-bolder',
    'color.background.accent.gray.bolder.hovered': '--ds-background-accent-gray-bolder-hovered',
    'color.background.accent.gray.bolder.pressed': '--ds-background-accent-gray-bolder-pressed',
    'color.background.disabled': '--ds-background-disabled',
    'color.background.input': '--ds-background-input',
    'color.background.input.hovered': '--ds-background-input-hovered',
    'color.background.input.pressed': '--ds-background-input-pressed',
    'color.background.inverse.subtle': '--ds-background-inverse-subtle',
    'color.background.inverse.subtle.hovered': '--ds-background-inverse-subtle-hovered',
    'color.background.inverse.subtle.pressed': '--ds-background-inverse-subtle-pressed',
    'color.background.neutral': '--ds-background-neutral',
    'color.background.neutral.hovered': '--ds-background-neutral-hovered',
    'color.background.neutral.pressed': '--ds-background-neutral-pressed',
    'color.background.neutral.subtle': '--ds-background-neutral-subtle',
    'color.background.neutral.subtle.hovered': '--ds-background-neutral-subtle-hovered',
    'color.background.neutral.subtle.pressed': '--ds-background-neutral-subtle-pressed',
    'color.background.neutral.bold': '--ds-background-neutral-bold',
    'color.background.neutral.bold.hovered': '--ds-background-neutral-bold-hovered',
    'color.background.neutral.bold.pressed': '--ds-background-neutral-bold-pressed',
    'color.background.selected': '--ds-background-selected',
    'color.background.selected.hovered': '--ds-background-selected-hovered',
    'color.background.selected.pressed': '--ds-background-selected-pressed',
    'color.background.selected.bold': '--ds-background-selected-bold',
    'color.background.selected.bold.hovered': '--ds-background-selected-bold-hovered',
    'color.background.selected.bold.pressed': '--ds-background-selected-bold-pressed',
    'color.background.brand.subtlest': '--ds-background-brand-subtlest',
    'color.background.brand.subtlest.hovered': '--ds-background-brand-subtlest-hovered',
    'color.background.brand.subtlest.pressed': '--ds-background-brand-subtlest-pressed',
    'color.background.brand.bold': '--ds-background-brand-bold',
    'color.background.brand.bold.hovered': '--ds-background-brand-bold-hovered',
    'color.background.brand.bold.pressed': '--ds-background-brand-bold-pressed',
    'color.background.brand.boldest': '--ds-background-brand-boldest',
    'color.background.brand.boldest.hovered': '--ds-background-brand-boldest-hovered',
    'color.background.brand.boldest.pressed': '--ds-background-brand-boldest-pressed',
    'color.background.danger': '--ds-background-danger',
    'color.background.danger.hovered': '--ds-background-danger-hovered',
    'color.background.danger.pressed': '--ds-background-danger-pressed',
    'color.background.danger.subtler': '--ds-background-danger-subtler',
    'color.background.danger.subtler.hovered': '--ds-background-danger-subtler-hovered',
    'color.background.danger.subtler.pressed': '--ds-background-danger-subtler-pressed',
    'color.background.danger.bold': '--ds-background-danger-bold',
    'color.background.danger.bold.hovered': '--ds-background-danger-bold-hovered',
    'color.background.danger.bold.pressed': '--ds-background-danger-bold-pressed',
    'color.background.warning': '--ds-background-warning',
    'color.background.warning.hovered': '--ds-background-warning-hovered',
    'color.background.warning.pressed': '--ds-background-warning-pressed',
    'color.background.warning.subtler': '--ds-background-warning-subtler',
    'color.background.warning.subtler.hovered': '--ds-background-warning-subtler-hovered',
    'color.background.warning.subtler.pressed': '--ds-background-warning-subtler-pressed',
    'color.background.warning.bold': '--ds-background-warning-bold',
    'color.background.warning.bold.hovered': '--ds-background-warning-bold-hovered',
    'color.background.warning.bold.pressed': '--ds-background-warning-bold-pressed',
    'color.background.success': '--ds-background-success',
    'color.background.success.hovered': '--ds-background-success-hovered',
    'color.background.success.pressed': '--ds-background-success-pressed',
    'color.background.success.subtler': '--ds-background-success-subtler',
    'color.background.success.subtler.hovered': '--ds-background-success-subtler-hovered',
    'color.background.success.subtler.pressed': '--ds-background-success-subtler-pressed',
    'color.background.success.bold': '--ds-background-success-bold',
    'color.background.success.bold.hovered': '--ds-background-success-bold-hovered',
    'color.background.success.bold.pressed': '--ds-background-success-bold-pressed',
    'color.background.discovery': '--ds-background-discovery',
    'color.background.discovery.hovered': '--ds-background-discovery-hovered',
    'color.background.discovery.pressed': '--ds-background-discovery-pressed',
    'color.background.discovery.subtler': '--ds-background-discovery-subtler',
    'color.background.discovery.subtler.hovered': '--ds-background-discovery-subtler-hovered',
    'color.background.discovery.subtler.pressed': '--ds-background-discovery-subtler-pressed',
    'color.background.discovery.bold': '--ds-background-discovery-bold',
    'color.background.discovery.bold.hovered': '--ds-background-discovery-bold-hovered',
    'color.background.discovery.bold.pressed': '--ds-background-discovery-bold-pressed',
    'color.background.information': '--ds-background-information',
    'color.background.information.hovered': '--ds-background-information-hovered',
    'color.background.information.pressed': '--ds-background-information-pressed',
    'color.background.information.subtler': '--ds-background-information-subtler',
    'color.background.information.subtler.hovered': '--ds-background-information-subtler-hovered',
    'color.background.information.subtler.pressed': '--ds-background-information-subtler-pressed',
    'color.background.information.bold': '--ds-background-information-bold',
    'color.background.information.bold.hovered': '--ds-background-information-bold-hovered',
    'color.background.information.bold.pressed': '--ds-background-information-bold-pressed',
    'color.blanket': '--ds-blanket',
    'color.blanket.selected': '--ds-blanket-selected',
    'color.blanket.danger': '--ds-blanket-danger',
    'color.interaction.hovered': '--ds-interaction-hovered',
    'color.interaction.pressed': '--ds-interaction-pressed',
    'color.skeleton': '--ds-skeleton',
    'color.skeleton.subtle': '--ds-skeleton-subtle',
    'color.chart.categorical.1': '--ds-chart-categorical-1',
    'color.chart.categorical.1.hovered': '--ds-chart-categorical-1-hovered',
    'color.chart.categorical.2': '--ds-chart-categorical-2',
    'color.chart.categorical.2.hovered': '--ds-chart-categorical-2-hovered',
    'color.chart.categorical.3': '--ds-chart-categorical-3',
    'color.chart.categorical.3.hovered': '--ds-chart-categorical-3-hovered',
    'color.chart.categorical.4': '--ds-chart-categorical-4',
    'color.chart.categorical.4.hovered': '--ds-chart-categorical-4-hovered',
    'color.chart.categorical.5': '--ds-chart-categorical-5',
    'color.chart.categorical.5.hovered': '--ds-chart-categorical-5-hovered',
    'color.chart.categorical.6': '--ds-chart-categorical-6',
    'color.chart.categorical.6.hovered': '--ds-chart-categorical-6-hovered',
    'color.chart.categorical.7': '--ds-chart-categorical-7',
    'color.chart.categorical.7.hovered': '--ds-chart-categorical-7-hovered',
    'color.chart.categorical.8': '--ds-chart-categorical-8',
    'color.chart.categorical.8.hovered': '--ds-chart-categorical-8-hovered',
    'color.chart.lime.bold': '--ds-chart-lime-bold',
    'color.chart.lime.bold.hovered': '--ds-chart-lime-bold-hovered',
    'color.chart.lime.bolder': '--ds-chart-lime-bolder',
    'color.chart.lime.bolder.hovered': '--ds-chart-lime-bolder-hovered',
    'color.chart.lime.boldest': '--ds-chart-lime-boldest',
    'color.chart.lime.boldest.hovered': '--ds-chart-lime-boldest-hovered',
    'color.chart.neutral': '--ds-chart-neutral',
    'color.chart.neutral.hovered': '--ds-chart-neutral-hovered',
    'color.chart.red.bold': '--ds-chart-red-bold',
    'color.chart.red.bold.hovered': '--ds-chart-red-bold-hovered',
    'color.chart.red.bolder': '--ds-chart-red-bolder',
    'color.chart.red.bolder.hovered': '--ds-chart-red-bolder-hovered',
    'color.chart.red.boldest': '--ds-chart-red-boldest',
    'color.chart.red.boldest.hovered': '--ds-chart-red-boldest-hovered',
    'color.chart.orange.bold': '--ds-chart-orange-bold',
    'color.chart.orange.bold.hovered': '--ds-chart-orange-bold-hovered',
    'color.chart.orange.bolder': '--ds-chart-orange-bolder',
    'color.chart.orange.bolder.hovered': '--ds-chart-orange-bolder-hovered',
    'color.chart.orange.boldest': '--ds-chart-orange-boldest',
    'color.chart.orange.boldest.hovered': '--ds-chart-orange-boldest-hovered',
    'color.chart.yellow.bold': '--ds-chart-yellow-bold',
    'color.chart.yellow.bold.hovered': '--ds-chart-yellow-bold-hovered',
    'color.chart.yellow.bolder': '--ds-chart-yellow-bolder',
    'color.chart.yellow.bolder.hovered': '--ds-chart-yellow-bolder-hovered',
    'color.chart.yellow.boldest': '--ds-chart-yellow-boldest',
    'color.chart.yellow.boldest.hovered': '--ds-chart-yellow-boldest-hovered',
    'color.chart.green.bold': '--ds-chart-green-bold',
    'color.chart.green.bold.hovered': '--ds-chart-green-bold-hovered',
    'color.chart.green.bolder': '--ds-chart-green-bolder',
    'color.chart.green.bolder.hovered': '--ds-chart-green-bolder-hovered',
    'color.chart.green.boldest': '--ds-chart-green-boldest',
    'color.chart.green.boldest.hovered': '--ds-chart-green-boldest-hovered',
    'color.chart.teal.bold': '--ds-chart-teal-bold',
    'color.chart.teal.bold.hovered': '--ds-chart-teal-bold-hovered',
    'color.chart.teal.bolder': '--ds-chart-teal-bolder',
    'color.chart.teal.bolder.hovered': '--ds-chart-teal-bolder-hovered',
    'color.chart.teal.boldest': '--ds-chart-teal-boldest',
    'color.chart.teal.boldest.hovered': '--ds-chart-teal-boldest-hovered',
    'color.chart.blue.bold': '--ds-chart-blue-bold',
    'color.chart.blue.bold.hovered': '--ds-chart-blue-bold-hovered',
    'color.chart.blue.bolder': '--ds-chart-blue-bolder',
    'color.chart.blue.bolder.hovered': '--ds-chart-blue-bolder-hovered',
    'color.chart.blue.boldest': '--ds-chart-blue-boldest',
    'color.chart.blue.boldest.hovered': '--ds-chart-blue-boldest-hovered',
    'color.chart.purple.bold': '--ds-chart-purple-bold',
    'color.chart.purple.bold.hovered': '--ds-chart-purple-bold-hovered',
    'color.chart.purple.bolder': '--ds-chart-purple-bolder',
    'color.chart.purple.bolder.hovered': '--ds-chart-purple-bolder-hovered',
    'color.chart.purple.boldest': '--ds-chart-purple-boldest',
    'color.chart.purple.boldest.hovered': '--ds-chart-purple-boldest-hovered',
    'color.chart.magenta.bold': '--ds-chart-magenta-bold',
    'color.chart.magenta.bold.hovered': '--ds-chart-magenta-bold-hovered',
    'color.chart.magenta.bolder': '--ds-chart-magenta-bolder',
    'color.chart.magenta.bolder.hovered': '--ds-chart-magenta-bolder-hovered',
    'color.chart.magenta.boldest': '--ds-chart-magenta-boldest',
    'color.chart.magenta.boldest.hovered': '--ds-chart-magenta-boldest-hovered',
    'color.chart.gray.bold': '--ds-chart-gray-bold',
    'color.chart.gray.bold.hovered': '--ds-chart-gray-bold-hovered',
    'color.chart.gray.bolder': '--ds-chart-gray-bolder',
    'color.chart.gray.bolder.hovered': '--ds-chart-gray-bolder-hovered',
    'color.chart.gray.boldest': '--ds-chart-gray-boldest',
    'color.chart.gray.boldest.hovered': '--ds-chart-gray-boldest-hovered',
    'color.chart.brand': '--ds-chart-brand',
    'color.chart.brand.hovered': '--ds-chart-brand-hovered',
    'color.chart.danger': '--ds-chart-danger',
    'color.chart.danger.hovered': '--ds-chart-danger-hovered',
    'color.chart.danger.bold': '--ds-chart-danger-bold',
    'color.chart.danger.bold.hovered': '--ds-chart-danger-bold-hovered',
    'color.chart.warning': '--ds-chart-warning',
    'color.chart.warning.hovered': '--ds-chart-warning-hovered',
    'color.chart.warning.bold': '--ds-chart-warning-bold',
    'color.chart.warning.bold.hovered': '--ds-chart-warning-bold-hovered',
    'color.chart.success': '--ds-chart-success',
    'color.chart.success.hovered': '--ds-chart-success-hovered',
    'color.chart.success.bold': '--ds-chart-success-bold',
    'color.chart.success.bold.hovered': '--ds-chart-success-bold-hovered',
    'color.chart.discovery': '--ds-chart-discovery',
    'color.chart.discovery.hovered': '--ds-chart-discovery-hovered',
    'color.chart.discovery.bold': '--ds-chart-discovery-bold',
    'color.chart.discovery.bold.hovered': '--ds-chart-discovery-bold-hovered',
    'color.chart.information': '--ds-chart-information',
    'color.chart.information.hovered': '--ds-chart-information-hovered',
    'color.chart.information.bold': '--ds-chart-information-bold',
    'color.chart.information.bold.hovered': '--ds-chart-information-bold-hovered',
    'elevation.surface': '--ds-surface',
    'elevation.surface.hovered': '--ds-surface-hovered',
    'elevation.surface.pressed': '--ds-surface-pressed',
    'elevation.surface.overlay': '--ds-surface-overlay',
    'elevation.surface.overlay.hovered': '--ds-surface-overlay-hovered',
    'elevation.surface.overlay.pressed': '--ds-surface-overlay-pressed',
    'elevation.surface.raised': '--ds-surface-raised',
    'elevation.surface.raised.hovered': '--ds-surface-raised-hovered',
    'elevation.surface.raised.pressed': '--ds-surface-raised-pressed',
    'elevation.surface.sunken': '--ds-surface-sunken',
    'elevation.shadow.overflow': '--ds-shadow-overflow',
    'elevation.shadow.overflow.perimeter': '--ds-shadow-overflow-perimeter',
    'elevation.shadow.overflow.spread': '--ds-shadow-overflow-spread',
    'elevation.shadow.overlay': '--ds-shadow-overlay',
    'elevation.shadow.raised': '--ds-shadow-raised',
    'opacity.disabled': '--ds-opacity-disabled',
    'opacity.loading': '--ds-opacity-loading',
    'utility.UNSAFE.transparent': '--ds-UNSAFE-transparent',
    'utility.elevation.surface.current': '--ds-elevation-surface-current',
    'space.0': '--ds-space-0',
    'space.025': '--ds-space-025',
    'space.050': '--ds-space-050',
    'space.075': '--ds-space-075',
    'space.100': '--ds-space-100',
    'space.150': '--ds-space-150',
    'space.200': '--ds-space-200',
    'space.250': '--ds-space-250',
    'space.300': '--ds-space-300',
    'space.400': '--ds-space-400',
    'space.500': '--ds-space-500',
    'space.600': '--ds-space-600',
    'space.800': '--ds-space-800',
    'space.1000': '--ds-space-1000',
    'space.negative.025': '--ds-space-negative-025',
    'space.negative.050': '--ds-space-negative-050',
    'space.negative.075': '--ds-space-negative-075',
    'space.negative.100': '--ds-space-negative-100',
    'space.negative.150': '--ds-space-negative-150',
    'space.negative.200': '--ds-space-negative-200',
    'space.negative.250': '--ds-space-negative-250',
    'space.negative.300': '--ds-space-negative-300',
    'space.negative.400': '--ds-space-negative-400',
    'font.heading.xxlarge': '--ds-font-heading-xxlarge',
    'font.heading.xlarge': '--ds-font-heading-xlarge',
    'font.heading.large': '--ds-font-heading-large',
    'font.heading.medium': '--ds-font-heading-medium',
    'font.heading.small': '--ds-font-heading-small',
    'font.heading.xsmall': '--ds-font-heading-xsmall',
    'font.heading.xxsmall': '--ds-font-heading-xxsmall',
    'font.body.large': '--ds-font-body-large',
    'font.body': '--ds-font-body',
    'font.body.small': '--ds-font-body-small',
    'font.body.UNSAFE_small': '--ds-font-body-UNSAFE_small',
    'font.metric.large': '--ds-font-metric-large',
    'font.metric.medium': '--ds-font-metric-medium',
    'font.metric.small': '--ds-font-metric-small',
    'font.code': '--ds-font-code',
    'font.weight.regular': '--ds-font-weight-regular',
    'font.weight.medium': '--ds-font-weight-medium',
    'font.weight.semibold': '--ds-font-weight-semibold',
    'font.weight.bold': '--ds-font-weight-bold',
    'font.family.heading': '--ds-font-family-heading',
    'font.family.body': '--ds-font-family-body',
    'font.family.code': '--ds-font-family-code',
    'font.family.brand.heading': '--ds-font-family-brand-heading',
    'font.family.brand.body': '--ds-font-family-brand-body',
    'radius.xsmall': '--ds-radius-xsmall',
    'radius.small': '--ds-radius-small',
    'radius.medium': '--ds-radius-medium',
    'radius.large': '--ds-radius-large',
    'radius.xlarge': '--ds-radius-xlarge',
    'radius.xxlarge': '--ds-radius-xxlarge',
    'radius.full': '--ds-radius-full',
    'radius.tile': '--ds-radius-tile',
    'border.width': '--ds-border-width',
    'border.width.selected': '--ds-border-width-selected',
    'border.width.focused': '--ds-border-width-focused'
};
var $bffe2f419c6e11a6$export$2e2bcd8739ae039 = $bffe2f419c6e11a6$var$tokens;

});


parcelRegister("dmkl6", function(module, exports) {
$parcel$export(module.exports, "getThemePreferences", () => $9b9d1b649089818c$export$dd6aeb7c823fc03d);
$parcel$export(module.exports, "getThemeOverridePreferences", () => $9b9d1b649089818c$export$5d76d7014f4a5d08);

var $fC8ib = parcelRequire("fC8ib");

var $9Zzpd = parcelRequire("9Zzpd");

var $hsJoC = parcelRequire("hsJoC");
var $9b9d1b649089818c$export$dd6aeb7c823fc03d = function getThemePreferences(themeState) {
    var colorMode = themeState.colorMode, contrastMode = themeState.contrastMode, dark = themeState.dark, light = themeState.light, shape = themeState.shape, spacing = themeState.spacing, typography = themeState.typography, motion = themeState.motion;
    var autoColorModeThemes = [
        light,
        dark
    ];
    var themePreferences = [];
    if (colorMode === 'auto') {
        if (contrastMode !== 'no-preference' && (0, $9Zzpd.fg)('platform_increased-contrast-themes')) autoColorModeThemes.forEach(function(normalTheme) {
            var increasedContrastTheme = (0, $hsJoC.default)(normalTheme);
            if (increasedContrastTheme) autoColorModeThemes.push(increasedContrastTheme);
        });
        themePreferences.push.apply(themePreferences, autoColorModeThemes);
    } else {
        themePreferences.push(themeState[colorMode]);
        if (contrastMode !== 'no-preference' && (0, $9Zzpd.fg)('platform_increased-contrast-themes')) {
            var increasedContrastTheme = (0, $hsJoC.default)(themeState[colorMode]);
            if (increasedContrastTheme) themePreferences.push(increasedContrastTheme);
        }
    }
    [
        shape,
        spacing,
        typography,
        motion
    ].forEach(function(themeId) {
        if (themeId) themePreferences.push(themeId);
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(new Set(themePreferences));
};
var $9b9d1b649089818c$export$5d76d7014f4a5d08 = function getThemeOverridePreferences(_themeState) {
    var themeOverridePreferences = [];
    return (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(new Set(themeOverridePreferences));
};

});
parcelRegister("hsJoC", function(module, exports) {
$parcel$export(module.exports, "default", () => $cb6843e708e2f910$export$2e2bcd8739ae039);

var $iYJcE = parcelRequire("iYJcE");

var $j03Wu = parcelRequire("j03Wu");
function $cb6843e708e2f910$export$2e2bcd8739ae039(themeId) {
    var _Object$entries$find;
    return (_Object$entries$find = Object.entries((0, $j03Wu.default)).find(function(_ref) {
        var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_ref, 2), increasesContrastFor = _ref2[1].increasesContrastFor;
        return increasesContrastFor === themeId;
    })) === null || _Object$entries$find === void 0 ? void 0 : _Object$entries$find[1].id;
}

});


parcelRegister("iXY1L", function(module, exports) {

var $iKwew = parcelRequire("iKwew");
module.exports = $iKwew("hZw16").then(()=>parcelRequire('glZBJ'));

});


parcelRegister("9LIjQ", function(module, exports) {
$parcel$export(module.exports, "useIsInsideAppProvider", () => $71cae1b5827ee12c$export$26aa23367bfbab0e);
$parcel$export(module.exports, "useIsAppProviderThemingEnabled", () => $71cae1b5827ee12c$export$a782702263f77544);

var $5FkrB = parcelRequire("5FkrB");
var $71cae1b5827ee12c$export$7981b2444296e410 = /*#__PURE__*/ (0, $5FkrB.createContext)(false);
var $71cae1b5827ee12c$export$26aa23367bfbab0e = function useIsInsideAppProvider() {
    return (0, $5FkrB.useContext)($71cae1b5827ee12c$export$7981b2444296e410);
};
var $71cae1b5827ee12c$export$d2def9838ca456c0 = /*#__PURE__*/ (0, $5FkrB.createContext)(false);
var $71cae1b5827ee12c$export$a782702263f77544 = function useIsAppProviderThemingEnabled() {
    return (0, $5FkrB.useContext)($71cae1b5827ee12c$export$d2def9838ca456c0);
};

});

parcelRegister("d929M", function(module, exports) {
$parcel$export(module.exports, "ColorModeContext", () => $991dc9ea3d5fd714$export$49ddd74a6729fdb0);
$parcel$export(module.exports, "SetColorModeContext", () => $991dc9ea3d5fd714$export$b06130bad0bbc70f);

var $5FkrB = parcelRequire("5FkrB");
var $991dc9ea3d5fd714$export$49ddd74a6729fdb0 = /*#__PURE__*/ (0, $5FkrB.createContext)(undefined);
var $991dc9ea3d5fd714$export$b06130bad0bbc70f = /*#__PURE__*/ (0, $5FkrB.createContext)(undefined);

});

parcelRegister("CYAnS", function(module, exports) {
$parcel$export(module.exports, "InsideThemeProviderContext", () => $07528bcf6a7ac857$export$332347eeb335453c);

var $5FkrB = parcelRequire("5FkrB");
var $07528bcf6a7ac857$export$332347eeb335453c = /*#__PURE__*/ (0, $5FkrB.createContext)(false);

});

parcelRegister("aUdZm", function(module, exports) {
$parcel$export(module.exports, "ThemeContext", () => $7f09fc3a90ec7963$export$2c657da244d00bd6);
$parcel$export(module.exports, "SetThemeContext", () => $7f09fc3a90ec7963$export$f7a97b47760e2a13);

var $5FkrB = parcelRequire("5FkrB");
var $7f09fc3a90ec7963$export$2c657da244d00bd6 = /*#__PURE__*/ (0, $5FkrB.createContext)(undefined);
var $7f09fc3a90ec7963$export$f7a97b47760e2a13 = /*#__PURE__*/ (0, $5FkrB.createContext)(undefined);

});

parcelRegister("kLT90", function(module, exports) {
$parcel$export(module.exports, "useIsInsideThemeProvider", () => $f1f2f8f2bd404af2$export$7ca11437599d653d);

var $5FkrB = parcelRequire("5FkrB");

var $CYAnS = parcelRequire("CYAnS");
var $f1f2f8f2bd404af2$export$7ca11437599d653d = function useIsInsideThemeProvider() {
    var _useContext;
    return (_useContext = (0, $5FkrB.useContext)((0, $CYAnS.InsideThemeProviderContext))) !== null && _useContext !== void 0 ? _useContext : false;
};

});

parcelRegister("bmHXx", function(module, exports) {
$parcel$export(module.exports, "loadAndMountThemes", () => $8463d92e1839e024$export$7d4a7e812d176b24);

var $fL8KA = parcelRequire("fL8KA");

var $6HG4S = parcelRequire("6HG4S");

var $hBCYb = parcelRequire("hBCYb");

var $jxmFQ = parcelRequire("jxmFQ");

var $lvkWb = parcelRequire("lvkWb");
var $8463d92e1839e024$var$loadThemeCss = /*#__PURE__*/ function() {
    var _ref = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee(themeId) {
        var _yield$themeImportMap, themeCss;
        return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee$(_context) {
            while(true)switch(_context.prev = _context.next){
                case 0:
                    if (!(0, $lvkWb.isThemeMounted)(themeId)) {
                        _context.next = 2;
                        break;
                    }
                    return _context.abrupt("return");
                case 2:
                    if (themeId) {
                        _context.next = 4;
                        break;
                    }
                    return _context.abrupt("return");
                case 4:
                    _context.next = 6;
                    return (0, $jxmFQ.default)[themeId]();
                case 6:
                    _yield$themeImportMap = _context.sent;
                    themeCss = _yield$themeImportMap.default;
                    return _context.abrupt("return", themeCss);
                case 9:
                case "end":
                    return _context.stop();
            }
        }, _callee);
    }));
    return function loadThemeCss(_x) {
        return _ref.apply(this, arguments);
    };
}();
var $8463d92e1839e024$var$mountThemeCss = /*#__PURE__*/ function() {
    var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee2(css, themeId) {
        var doc, style;
        return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee2$(_context2) {
            while(true)switch(_context2.prev = _context2.next){
                case 0:
                    // SSR-safe: Only mount on client side
                    doc = (0, $hBCYb.getDocument)();
                    if (doc) {
                        _context2.next = 3;
                        break;
                    }
                    return _context2.abrupt("return");
                case 3:
                    style = doc.createElement('style');
                    style.textContent = css;
                    style.dataset.theme = themeId;
                    // Prevent duplicate mounting of themes.
                    // It's possible the theme was already being loaded elsewhere.
                    if (!(0, $lvkWb.isThemeMounted)(themeId)) {
                        _context2.next = 8;
                        break;
                    }
                    return _context2.abrupt("return");
                case 8:
                    doc.head.appendChild(style);
                case 9:
                case "end":
                    return _context2.stop();
            }
        }, _callee2);
    }));
    return function mountThemeCss(_x2, _x3) {
        return _ref2.apply(this, arguments);
    };
}();
var $8463d92e1839e024$var$loadAndMountThemeCss = /*#__PURE__*/ function() {
    var _ref3 = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee3(themeId) {
        var themeCss;
        return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee3$(_context3) {
            while(true)switch(_context3.prev = _context3.next){
                case 0:
                    _context3.next = 2;
                    return $8463d92e1839e024$var$loadThemeCss(themeId);
                case 2:
                    themeCss = _context3.sent;
                    if (themeCss) {
                        _context3.next = 5;
                        break;
                    }
                    return _context3.abrupt("return");
                case 5:
                    $8463d92e1839e024$var$mountThemeCss(themeCss, themeId);
                case 6:
                case "end":
                    return _context3.stop();
            }
        }, _callee3);
    }));
    return function loadAndMountThemeCss(_x4) {
        return _ref3.apply(this, arguments);
    };
}();
var $8463d92e1839e024$export$7d4a7e812d176b24 = /*#__PURE__*/ function() {
    var _ref4 = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee4(theme) {
        var themesToLoad;
        return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee4$(_context4) {
            while(true)switch(_context4.prev = _context4.next){
                case 0:
                    themesToLoad = Object.values(theme).filter(function(themeId) {
                        return !!themeId;
                    });
                    themesToLoad.forEach($8463d92e1839e024$var$loadAndMountThemeCss);
                case 2:
                case "end":
                    return _context4.stop();
            }
        }, _callee4);
    }));
    return function loadAndMountThemes(_x5) {
        return _ref4.apply(this, arguments);
    };
}();

});
parcelRegister("lvkWb", function(module, exports) {
$parcel$export(module.exports, "isThemeMounted", () => $fa7cbbfc8d8a5370$export$835a0dc855d02822);

var $hBCYb = parcelRequire("hBCYb");

var $m5DAZ = parcelRequire("m5DAZ");
function $fa7cbbfc8d8a5370$export$835a0dc855d02822(themeId) {
    var doc = (0, $hBCYb.getDocument)();
    if (!doc) return false;
    return doc.head.querySelector("style[".concat((0, $m5DAZ.THEME_DATA_ATTRIBUTE), "=\"").concat(themeId, "\"]"));
}

});



parcelRegister("j3TF2", function(module, exports) {
$parcel$export(module.exports, "useColorMode", () => $de0979404ca42ba8$export$20f3076712c8dfa);

var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");

var $1xA3v = parcelRequire("1xA3v");
var $hG0kK = parcelRequire("hG0kK");

var $d929M = parcelRequire("d929M");
function $de0979404ca42ba8$export$20f3076712c8dfa() {
    var value = (0, $5FkrB.useContext)((0, $d929M.ColorModeContext));
    // TODO: This will only return 'light' or 'dark' but never 'auto', which in some cases
    // may be desirable. We should consider returning both the reconciled color mode (e.g. 'light' or 'dark') and the selected color mode ("auto").
    var theme = (0, $1xA3v.default)();
    var _useState = (0, $5FkrB.useState)((theme === null || theme === void 0 ? void 0 : theme.colorMode) || 'light'), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), resolvedColorMode = _useState2[0], setResolvedColorMode = _useState2[1];
    (0, $5FkrB.useEffect)(function() {
        // We are using theme from context so no need to reference the DOM
        if (value) return;
        var observer = new (0, $hG0kK.default)(function(theme) {
            setResolvedColorMode((theme === null || theme === void 0 ? void 0 : theme.colorMode) || 'light');
        });
        observer.observe();
        return function() {
            return observer.disconnect();
        };
    }, [
        value
    ]);
    return value ? value : resolvedColorMode;
}

});
parcelRegister("hG0kK", function(module, exports) {
$parcel$export(module.exports, "default", () => $cde69e268c2d5ad2$export$2e2bcd8739ae039);

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $25nEq = parcelRequire("25nEq");

var $m5DAZ = parcelRequire("m5DAZ");

var $1xA3v = parcelRequire("1xA3v");
/**
 * A MutationObserver which watches the `<html>` element for changes to the theme.
 *
 * In React, use the {@link useThemeObserver `useThemeObserver`} hook instead.
 *
 * @param {function} callback - A callback function which fires when the theme changes.
 *
 * @example
 * ```
 * const observer = new ThemeMutationObserver((theme) => {});
 * observer.observe();
 * ```
 */ var $cde69e268c2d5ad2$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function ThemeMutationObserver(callback) {
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, ThemeMutationObserver);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "legacyObserver", null);
        this.callback = callback;
        ThemeMutationObserver.callbacks.add(callback);
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(ThemeMutationObserver, [
        {
            key: "observe",
            value: function observe() {
                if (!ThemeMutationObserver.observer) {
                    ThemeMutationObserver.observer = new MutationObserver(function() {
                        var theme = (0, $1xA3v.default)();
                        ThemeMutationObserver.callbacks.forEach(function(callback) {
                            return callback(theme);
                        });
                    });
                    // Observer only needs to be configured once
                    ThemeMutationObserver.observer.observe(document.documentElement, {
                        attributeFilter: [
                            (0, $m5DAZ.THEME_DATA_ATTRIBUTE),
                            (0, $m5DAZ.COLOR_MODE_ATTRIBUTE)
                        ]
                    });
                }
            }
        },
        {
            key: "disconnect",
            value: function disconnect() {
                if (this.callback) ThemeMutationObserver.callbacks.delete(this.callback);
                if (ThemeMutationObserver.callbacks.size === 0 && ThemeMutationObserver.observer) {
                    ThemeMutationObserver.observer.disconnect();
                    ThemeMutationObserver.observer = null;
                }
            }
        }
    ]);
}();
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($cde69e268c2d5ad2$export$2e2bcd8739ae039, "observer", null);
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($cde69e268c2d5ad2$export$2e2bcd8739ae039, "callbacks", new Set());

});


parcelRegister("ak4Kv", function(module, exports) {
$parcel$export(module.exports, "createContainer", () => $783f74b8edf7ca7b$export$26ae5ca175b4ec5a);
$parcel$export(module.exports, "removePortalContainer", () => $783f74b8edf7ca7b$export$da99f98bf3fe55b3);
$parcel$export(module.exports, "appendPortalContainerIfNotAppended", () => $783f74b8edf7ca7b$export$c582005add11e141);
$parcel$export(module.exports, "createAtlaskitPortal", () => $783f74b8edf7ca7b$export$fef014d7cef9e543);
$parcel$export(module.exports, "createPortalParent", () => $783f74b8edf7ca7b$export$95029ca7aca2989e);
$parcel$export(module.exports, "removePortalParent", () => $783f74b8edf7ca7b$export$7b20876b2769b301);

var $hHDX8 = parcelRequire("hHDX8");
var $783f74b8edf7ca7b$export$26ae5ca175b4ec5a = function createContainer(zIndex) {
    var container = document.createElement('div');
    container.className = (0, $hHDX8.portalClassName);
    container.style.zIndex = "".concat(zIndex);
    return container;
};
/**
 * Returns document body element
 * @return {number} - The document body element
 */ var $783f74b8edf7ca7b$var$getBody = function getBody() {
    return document.body;
};
/**
 * Returns portal parent container. If no container exists already then it creates a new container with class name 'atlaskit-portal-container'
 * @return {Element} - The portal parent container div element
 */ var $783f74b8edf7ca7b$var$getPortalParent = function getPortalParent() {
    var parentElement = document.querySelector((0, $hHDX8.portalParentSelector));
    if (!parentElement) {
        var _getBody;
        var parent = document.createElement('div');
        parent.className = (0, $hHDX8.portalParentClassName);
        // we are setting display to flex because we want each portal to create a new stacking context
        // See https://developer.mozilla.org/en-US/docs/Web/CSS/CSS_Positioning/Understanding_z_index/The_stacking_context
        parent.style.display = 'flex';
        (_getBody = $783f74b8edf7ca7b$var$getBody()) === null || _getBody === void 0 || _getBody.appendChild(parent);
        return parent;
    }
    return parentElement;
};
var $783f74b8edf7ca7b$export$da99f98bf3fe55b3 = function removePortalContainer(container) {
    var parent = $783f74b8edf7ca7b$var$getPortalParent();
    if (parent.contains(container)) parent.removeChild(container);
};
var $783f74b8edf7ca7b$export$c582005add11e141 = function appendPortalContainerIfNotAppended(container) {
    if (!container.parentElement) $783f74b8edf7ca7b$var$getPortalParent().appendChild(container);
};
var $783f74b8edf7ca7b$var$isDocumentDefined = function isDocumentDefined() {
    return document !== undefined;
};
var $783f74b8edf7ca7b$export$fef014d7cef9e543 = function createAtlaskitPortal(zIndex) {
    //atlaskit-portal div
    if ($783f74b8edf7ca7b$var$isDocumentDefined()) {
        var atlaskitportal = document.createElement('div');
        atlaskitportal.className = (0, $hHDX8.portalClassName);
        atlaskitportal.style.zIndex = "".concat(zIndex);
        return atlaskitportal;
    }
    return;
};
var $783f74b8edf7ca7b$export$95029ca7aca2989e = function createPortalParent() {
    //atlaskit-portal-container div
    if ($783f74b8edf7ca7b$var$isDocumentDefined()) {
        var parentElement = document.querySelector((0, $hHDX8.portalParentSelector));
        if (!parentElement) {
            var _getBody2;
            var parent = document.createElement('div');
            parent.className = (0, $hHDX8.portalParentClassName);
            parent.style.display = 'flex';
            (_getBody2 = $783f74b8edf7ca7b$var$getBody()) === null || _getBody2 === void 0 || _getBody2.appendChild(parent);
            return parent;
        }
        return parentElement;
    }
    return;
};
var $783f74b8edf7ca7b$export$7b20876b2769b301 = function removePortalParent(parentElement) {
    if ($783f74b8edf7ca7b$var$isDocumentDefined()) {
        if (parentElement) {
            var _getBody3;
            (_getBody3 = $783f74b8edf7ca7b$var$getBody()) === null || _getBody3 === void 0 || _getBody3.removeChild(parentElement);
        }
    }
};

});
parcelRegister("hHDX8", function(module, exports) {
$parcel$export(module.exports, "portalParentClassName", () => $ce35719b8fe24aa7$export$e4c79eb95c23a0da);
$parcel$export(module.exports, "portalParentSelector", () => $ce35719b8fe24aa7$export$72f415121273627e);
$parcel$export(module.exports, "portalClassName", () => $ce35719b8fe24aa7$export$13f57c02915787b3);
var $ce35719b8fe24aa7$export$e4c79eb95c23a0da = 'atlaskit-portal-container';
var $ce35719b8fe24aa7$export$72f415121273627e = 'body > .atlaskit-portal-container';
var $ce35719b8fe24aa7$export$13f57c02915787b3 = 'atlaskit-portal';

});



parcelRegister("3xP8x", function(module, exports) {
$parcel$export(module.exports, "default", () => $294c1ed9b98aa8bc$export$2e2bcd8739ae039);

var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");

var $aLeHs = parcelRequire("aLeHs");

var $3dDx0 = parcelRequire("3dDx0");
var $j3TF2 = parcelRequire("j3TF2");

var $9Zzpd = parcelRequire("9Zzpd");

var $ePOyQ = parcelRequire("ePOyQ");

var $ak4Kv = parcelRequire("ak4Kv");
function $294c1ed9b98aa8bc$export$2e2bcd8739ae039(props) {
    var zIndex = props.zIndex, children = props.children, isClosed = props.isClosed;
    var _useState = (0, $5FkrB.useState)(null), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), atlaskitPortal = _useState2[0], setAtlaskitPortal = _useState2[1];
    var colorMode = (0, $j3TF2.useColorMode)();
    (0, $ePOyQ.useIsomorphicLayoutEffect)(function() {
        if ((0, $9Zzpd.fg)('import_into_jsm_in_template_gallery_killswitch')) {
            if (!isClosed) {
                var tempPortalContainer = (0, $ak4Kv.createAtlaskitPortal)(zIndex);
                setAtlaskitPortal(tempPortalContainer);
                var portalParent = (0, $ak4Kv.createPortalParent)();
                if (!tempPortalContainer || !portalParent) return;
                portalParent.appendChild(tempPortalContainer);
                return function() {
                    if (portalParent) {
                        portalParent.removeChild(tempPortalContainer);
                        !portalParent.hasChildNodes() && (0, $ak4Kv.removePortalParent)(portalParent);
                    }
                    setAtlaskitPortal(null);
                };
            }
        } else {
            var _tempPortalContainer = (0, $ak4Kv.createAtlaskitPortal)(zIndex);
            setAtlaskitPortal(_tempPortalContainer);
            var _portalParent = (0, $ak4Kv.createPortalParent)();
            if (!_tempPortalContainer || !_portalParent) return;
            _portalParent.appendChild(_tempPortalContainer);
            return function() {
                if (_tempPortalContainer) _portalParent.removeChild(_tempPortalContainer);
                setAtlaskitPortal(null);
            };
        }
    }, [
        zIndex,
        isClosed,
        (0, $9Zzpd.fg)
    ]);
    /**
   * We wrap portal children with a Suspense boundary because in React 18 concurrent,
   * if you suspend from _within_ a portal to a Suspense boundary _outside_ the portal,
   * our portal gets in an infinite loop of rendering.
   */ var suspendedChildren = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $5FkrB.Suspense), {
        fallback: null
    }, colorMode ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $3dDx0.default), {
        defaultColorMode: colorMode
    }, children) : children);
    return atlaskitPortal ? /*#__PURE__*/ (0, $aLeHs.createPortal)(suspendedChildren, atlaskitPortal) : null;
}

});
parcelRegister("ePOyQ", function(module, exports) {
$parcel$export(module.exports, "useIsomorphicLayoutEffect", () => $accd0c7719cc05e3$export$700979bc83e7db82);

var $5FkrB = parcelRequire("5FkrB");
var $accd0c7719cc05e3$export$700979bc83e7db82 = typeof window !== 'undefined' ? (0, $5FkrB.useLayoutEffect) : (0, $5FkrB.useEffect);

});


parcelRegister("bjDXH", function(module, exports) {
$parcel$export(module.exports, "default", () => $83d077a9d4e5feff$export$2e2bcd8739ae039);

var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");

var $ePOyQ = parcelRequire("ePOyQ");
var $83d077a9d4e5feff$var$useIsSubsequentRender = function useIsSubsequentRender(mountStrategy) {
    var _useState = (0, $5FkrB.useState)(false), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), isSubsequentRender = _useState2[0], setIsSubsequentRender = _useState2[1];
    var _useState3 = (0, $5FkrB.useState)(function() {
        return mountStrategy === 'layoutEffect' ? (0, $ePOyQ.useIsomorphicLayoutEffect) : (0, $5FkrB.useEffect);
    }), _useState4 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState3, 1), useMountEffect = _useState4[0];
    useMountEffect(function() {
        setIsSubsequentRender(true);
    }, []);
    return isSubsequentRender;
};
var $83d077a9d4e5feff$export$2e2bcd8739ae039 = $83d077a9d4e5feff$var$useIsSubsequentRender;

});

parcelRegister("jsLZg", function(module, exports) {
$parcel$export(module.exports, "default", () => $e2b5db1d8b3115ec$export$2e2bcd8739ae039);

var $5FkrB = parcelRequire("5FkrB");

var $84KKZ = parcelRequire("84KKZ");

var $1HDR8 = parcelRequire("1HDR8");
var $e2b5db1d8b3115ec$var$useFirePortalEvent = function useFirePortalEvent(zIndex) {
    var zIndexNumber = Number(zIndex);
    (0, $5FkrB.useEffect)(function() {
        (0, $1HDR8.default)((0, $84KKZ.PORTAL_MOUNT_EVENT), zIndexNumber);
        return function() {
            (0, $1HDR8.default)((0, $84KKZ.PORTAL_UNMOUNT_EVENT), zIndexNumber);
        };
    }, [
        zIndexNumber
    ]);
};
var $e2b5db1d8b3115ec$export$2e2bcd8739ae039 = $e2b5db1d8b3115ec$var$useFirePortalEvent;

});
parcelRegister("84KKZ", function(module, exports) {
$parcel$export(module.exports, "PORTAL_MOUNT_EVENT", () => $5e12f7691be82ebc$export$ed5835cc67e87f72);
$parcel$export(module.exports, "PORTAL_UNMOUNT_EVENT", () => $5e12f7691be82ebc$export$80816bd900e5bd00);
var $5e12f7691be82ebc$export$ed5835cc67e87f72 = 'akPortalMount';
var $5e12f7691be82ebc$export$80816bd900e5bd00 = 'akPortalUnmount';

});

parcelRegister("1HDR8", function(module, exports) {
$parcel$export(module.exports, "default", () => $13d8b9306358618f$export$2e2bcd8739ae039);
var $13d8b9306358618f$var$zIndexToName = {
    100: 'card',
    200: 'navigation',
    300: 'dialog',
    400: 'layer',
    500: 'blanket',
    510: 'modal',
    600: 'flag',
    700: 'spotlight',
    9999: 'tooltip'
};
/**
 * return layer name in Atlassian design system corresponding to given z-index
 * @param {number} zIndex - z-index value for which layer name is needed
 * @returns {LayerName | null} - The layer name for given z-index. If layer name is not found then null is returned
 */ var $13d8b9306358618f$var$getLayerName = function getLayerName(zIndex) {
    return $13d8b9306358618f$var$zIndexToName.hasOwnProperty(zIndex) ? $13d8b9306358618f$var$zIndexToName[zIndex] : null;
};
/**
 * Creates a PortalEvent object with given eventName, given zIndex and corresponding layer
 * @param {string} eventName - either of Mount or Unmount event name
 * @param {number} zIndex - z-index value which will be included in the event to be dispatched
 * @returns {PortalEvent} - The newly created PortalEvent object
 */ var $13d8b9306358618f$var$getEvent = function getEvent(eventName, zIndex) {
    var detail = {
        layer: $13d8b9306358618f$var$getLayerName(Number(zIndex)),
        zIndex: zIndex
    };
    return new CustomEvent(eventName, {
        detail: detail
    });
};
function $13d8b9306358618f$export$2e2bcd8739ae039(eventName, zIndex) {
    var event = $13d8b9306358618f$var$getEvent(eventName, zIndex);
    window.dispatchEvent(event);
}

});



parcelRegister("bNmp1", function(module, exports) {
$parcel$export(module.exports, "default", () => $8965a5fc1a5cfd30$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a1de8a9439d40392e3e4945ecf9d9214>>
 * @codegenCommand yarn build tokens
 */ var $8965a5fc1a5cfd30$var$tokens = {
    'motion.avatar.enter': '--ds-avatar-enter',
    'motion.avatar.exit': '--ds-avatar-exit',
    'motion.avatar.hovered': '--ds-avatar-hovered',
    'motion.blanket.enter': '--ds-blanket-enter',
    'motion.blanket.exit': '--ds-blanket-exit',
    'motion.duration.instant': '--ds-duration-instant',
    'motion.duration.long': '--ds-duration-long',
    'motion.duration.medium': '--ds-duration-medium',
    'motion.duration.short': '--ds-duration-short',
    'motion.duration.xlong': '--ds-duration-xlong',
    'motion.duration.xshort': '--ds-duration-xshort',
    'motion.duration.xxlong': '--ds-duration-xxlong',
    'motion.duration.xxshort': '--ds-duration-xxshort',
    'motion.easing.in.practical': '--ds-easing-in-practical',
    'motion.easing.inout.bold': '--ds-easing-inout-bold',
    'motion.easing.out.practical': '--ds-easing-out-practical',
    'motion.easing.out.bold': '--ds-easing-out-bold',
    'motion.easing.spring': '--ds-easing-spring',
    'motion.flag.enter': '--ds-flag-enter',
    'motion.flag.exit': '--ds-flag-exit',
    'motion.flag.reposition': '--ds-flag-reposition',
    'motion.keyframe.fade.in': '--ds-keyframe-fade-in',
    'motion.keyframe.fade.out': '--ds-keyframe-fade-out',
    'motion.keyframe.scale.in.medium': '--ds-keyframe-scale-in-medium',
    'motion.keyframe.scale.in.small': '--ds-keyframe-scale-in-small',
    'motion.keyframe.scale.out.medium': '--ds-keyframe-scale-out-medium',
    'motion.keyframe.scale.out.small': '--ds-keyframe-scale-out-small',
    'motion.keyframe.slide.in.bottom.short': '--ds-keyframe-slide-in-bottom-short',
    'motion.keyframe.slide.in.left.half': '--ds-keyframe-slide-in-left-half',
    'motion.keyframe.slide.in.left.short': '--ds-keyframe-slide-in-left-short',
    'motion.keyframe.slide.in.right.short': '--ds-keyframe-slide-in-right-short',
    'motion.keyframe.slide.in.top.short': '--ds-keyframe-slide-in-top-short',
    'motion.keyframe.slide.out.bottom.short': '--ds-keyframe-slide-out-bottom-short',
    'motion.keyframe.slide.out.left.half': '--ds-keyframe-slide-out-left-half',
    'motion.keyframe.slide.out.left.short': '--ds-keyframe-slide-out-left-short',
    'motion.keyframe.slide.out.right.short': '--ds-keyframe-slide-out-right-short',
    'motion.keyframe.slide.out.top.short': '--ds-keyframe-slide-out-top-short',
    'motion.modal.enter': '--ds-modal-enter',
    'motion.modal.exit': '--ds-modal-exit',
    'motion.popup.enter.bottom': '--ds-popup-enter-bottom',
    'motion.popup.enter.left': '--ds-popup-enter-left',
    'motion.popup.enter.right': '--ds-popup-enter-right',
    'motion.popup.enter.top': '--ds-popup-enter-top',
    'motion.popup.exit.bottom': '--ds-popup-exit-bottom',
    'motion.popup.exit.left': '--ds-popup-exit-left',
    'motion.popup.exit.right': '--ds-popup-exit-right',
    'motion.popup.exit.top': '--ds-popup-exit-top',
    'motion.spotlight.enter': '--ds-spotlight-enter',
    'motion.spotlight.exit': '--ds-spotlight-exit',
    'color.text': '--ds-text',
    'color.text.accent.lime': '--ds-text-accent-lime',
    'color.text.accent.lime.bolder': '--ds-text-accent-lime-bolder',
    'color.text.accent.red': '--ds-text-accent-red',
    'color.text.accent.red.bolder': '--ds-text-accent-red-bolder',
    'color.text.accent.orange': '--ds-text-accent-orange',
    'color.text.accent.orange.bolder': '--ds-text-accent-orange-bolder',
    'color.text.accent.yellow': '--ds-text-accent-yellow',
    'color.text.accent.yellow.bolder': '--ds-text-accent-yellow-bolder',
    'color.text.accent.green': '--ds-text-accent-green',
    'color.text.accent.green.bolder': '--ds-text-accent-green-bolder',
    'color.text.accent.teal': '--ds-text-accent-teal',
    'color.text.accent.teal.bolder': '--ds-text-accent-teal-bolder',
    'color.text.accent.blue': '--ds-text-accent-blue',
    'color.text.accent.blue.bolder': '--ds-text-accent-blue-bolder',
    'color.text.accent.purple': '--ds-text-accent-purple',
    'color.text.accent.purple.bolder': '--ds-text-accent-purple-bolder',
    'color.text.accent.magenta': '--ds-text-accent-magenta',
    'color.text.accent.magenta.bolder': '--ds-text-accent-magenta-bolder',
    'color.text.accent.gray': '--ds-text-accent-gray',
    'color.text.accent.gray.bolder': '--ds-text-accent-gray-bolder',
    'color.text.disabled': '--ds-text-disabled',
    'color.text.inverse': '--ds-text-inverse',
    'color.text.selected': '--ds-text-selected',
    'color.text.brand': '--ds-text-brand',
    'color.text.danger': '--ds-text-danger',
    'color.text.danger.bolder': '--ds-text-danger-bolder',
    'color.text.warning': '--ds-text-warning',
    'color.text.warning.inverse': '--ds-text-warning-inverse',
    'color.text.warning.bolder': '--ds-text-warning-bolder',
    'color.text.success': '--ds-text-success',
    'color.text.success.bolder': '--ds-text-success-bolder',
    'color.text.discovery': '--ds-text-discovery',
    'color.text.discovery.bolder': '--ds-text-discovery-bolder',
    'color.text.information': '--ds-text-information',
    'color.text.information.bolder': '--ds-text-information-bolder',
    'color.text.subtlest': '--ds-text-subtlest',
    'color.text.subtle': '--ds-text-subtle',
    'color.link': '--ds-link',
    'color.link.pressed': '--ds-link-pressed',
    'color.link.visited': '--ds-link-visited',
    'color.link.visited.pressed': '--ds-link-visited-pressed',
    'color.icon': '--ds-icon',
    'color.icon.accent.lime': '--ds-icon-accent-lime',
    'color.icon.accent.red': '--ds-icon-accent-red',
    'color.icon.accent.orange': '--ds-icon-accent-orange',
    'color.icon.accent.yellow': '--ds-icon-accent-yellow',
    'color.icon.accent.green': '--ds-icon-accent-green',
    'color.icon.accent.teal': '--ds-icon-accent-teal',
    'color.icon.accent.blue': '--ds-icon-accent-blue',
    'color.icon.accent.purple': '--ds-icon-accent-purple',
    'color.icon.accent.magenta': '--ds-icon-accent-magenta',
    'color.icon.accent.gray': '--ds-icon-accent-gray',
    'color.icon.disabled': '--ds-icon-disabled',
    'color.icon.inverse': '--ds-icon-inverse',
    'color.icon.selected': '--ds-icon-selected',
    'color.icon.brand': '--ds-icon-brand',
    'color.icon.danger': '--ds-icon-danger',
    'color.icon.warning': '--ds-icon-warning',
    'color.icon.warning.inverse': '--ds-icon-warning-inverse',
    'color.icon.success': '--ds-icon-success',
    'color.icon.discovery': '--ds-icon-discovery',
    'color.icon.information': '--ds-icon-information',
    'color.icon.subtlest': '--ds-icon-subtlest',
    'color.icon.subtle': '--ds-icon-subtle',
    'color.border': '--ds-border',
    'color.border.accent.lime': '--ds-border-accent-lime',
    'color.border.accent.red': '--ds-border-accent-red',
    'color.border.accent.orange': '--ds-border-accent-orange',
    'color.border.accent.yellow': '--ds-border-accent-yellow',
    'color.border.accent.green': '--ds-border-accent-green',
    'color.border.accent.teal': '--ds-border-accent-teal',
    'color.border.accent.blue': '--ds-border-accent-blue',
    'color.border.accent.purple': '--ds-border-accent-purple',
    'color.border.accent.magenta': '--ds-border-accent-magenta',
    'color.border.accent.gray': '--ds-border-accent-gray',
    'color.border.disabled': '--ds-border-disabled',
    'color.border.focused': '--ds-border-focused',
    'color.border.input': '--ds-border-input',
    'color.border.inverse': '--ds-border-inverse',
    'color.border.selected': '--ds-border-selected',
    'color.border.brand': '--ds-border-brand',
    'color.border.danger': '--ds-border-danger',
    'color.border.warning': '--ds-border-warning',
    'color.border.success': '--ds-border-success',
    'color.border.discovery': '--ds-border-discovery',
    'color.border.information': '--ds-border-information',
    'color.border.bold': '--ds-border-bold',
    'color.background.accent.lime.subtlest': '--ds-background-accent-lime-subtlest',
    'color.background.accent.lime.subtlest.hovered': '--ds-background-accent-lime-subtlest-hovered',
    'color.background.accent.lime.subtlest.pressed': '--ds-background-accent-lime-subtlest-pressed',
    'color.background.accent.lime.subtler': '--ds-background-accent-lime-subtler',
    'color.background.accent.lime.subtler.hovered': '--ds-background-accent-lime-subtler-hovered',
    'color.background.accent.lime.subtler.pressed': '--ds-background-accent-lime-subtler-pressed',
    'color.background.accent.lime.subtle': '--ds-background-accent-lime-subtle',
    'color.background.accent.lime.subtle.hovered': '--ds-background-accent-lime-subtle-hovered',
    'color.background.accent.lime.subtle.pressed': '--ds-background-accent-lime-subtle-pressed',
    'color.background.accent.lime.bolder': '--ds-background-accent-lime-bolder',
    'color.background.accent.lime.bolder.hovered': '--ds-background-accent-lime-bolder-hovered',
    'color.background.accent.lime.bolder.pressed': '--ds-background-accent-lime-bolder-pressed',
    'color.background.accent.red.subtlest': '--ds-background-accent-red-subtlest',
    'color.background.accent.red.subtlest.hovered': '--ds-background-accent-red-subtlest-hovered',
    'color.background.accent.red.subtlest.pressed': '--ds-background-accent-red-subtlest-pressed',
    'color.background.accent.red.subtler': '--ds-background-accent-red-subtler',
    'color.background.accent.red.subtler.hovered': '--ds-background-accent-red-subtler-hovered',
    'color.background.accent.red.subtler.pressed': '--ds-background-accent-red-subtler-pressed',
    'color.background.accent.red.subtle': '--ds-background-accent-red-subtle',
    'color.background.accent.red.subtle.hovered': '--ds-background-accent-red-subtle-hovered',
    'color.background.accent.red.subtle.pressed': '--ds-background-accent-red-subtle-pressed',
    'color.background.accent.red.bolder': '--ds-background-accent-red-bolder',
    'color.background.accent.red.bolder.hovered': '--ds-background-accent-red-bolder-hovered',
    'color.background.accent.red.bolder.pressed': '--ds-background-accent-red-bolder-pressed',
    'color.background.accent.orange.subtlest': '--ds-background-accent-orange-subtlest',
    'color.background.accent.orange.subtlest.hovered': '--ds-background-accent-orange-subtlest-hovered',
    'color.background.accent.orange.subtlest.pressed': '--ds-background-accent-orange-subtlest-pressed',
    'color.background.accent.orange.subtler': '--ds-background-accent-orange-subtler',
    'color.background.accent.orange.subtler.hovered': '--ds-background-accent-orange-subtler-hovered',
    'color.background.accent.orange.subtler.pressed': '--ds-background-accent-orange-subtler-pressed',
    'color.background.accent.orange.subtle': '--ds-background-accent-orange-subtle',
    'color.background.accent.orange.subtle.hovered': '--ds-background-accent-orange-subtle-hovered',
    'color.background.accent.orange.subtle.pressed': '--ds-background-accent-orange-subtle-pressed',
    'color.background.accent.orange.bolder': '--ds-background-accent-orange-bolder',
    'color.background.accent.orange.bolder.hovered': '--ds-background-accent-orange-bolder-hovered',
    'color.background.accent.orange.bolder.pressed': '--ds-background-accent-orange-bolder-pressed',
    'color.background.accent.yellow.subtlest': '--ds-background-accent-yellow-subtlest',
    'color.background.accent.yellow.subtlest.hovered': '--ds-background-accent-yellow-subtlest-hovered',
    'color.background.accent.yellow.subtlest.pressed': '--ds-background-accent-yellow-subtlest-pressed',
    'color.background.accent.yellow.subtler': '--ds-background-accent-yellow-subtler',
    'color.background.accent.yellow.subtler.hovered': '--ds-background-accent-yellow-subtler-hovered',
    'color.background.accent.yellow.subtler.pressed': '--ds-background-accent-yellow-subtler-pressed',
    'color.background.accent.yellow.subtle': '--ds-background-accent-yellow-subtle',
    'color.background.accent.yellow.subtle.hovered': '--ds-background-accent-yellow-subtle-hovered',
    'color.background.accent.yellow.subtle.pressed': '--ds-background-accent-yellow-subtle-pressed',
    'color.background.accent.yellow.bolder': '--ds-background-accent-yellow-bolder',
    'color.background.accent.yellow.bolder.hovered': '--ds-background-accent-yellow-bolder-hovered',
    'color.background.accent.yellow.bolder.pressed': '--ds-background-accent-yellow-bolder-pressed',
    'color.background.accent.green.subtlest': '--ds-background-accent-green-subtlest',
    'color.background.accent.green.subtlest.hovered': '--ds-background-accent-green-subtlest-hovered',
    'color.background.accent.green.subtlest.pressed': '--ds-background-accent-green-subtlest-pressed',
    'color.background.accent.green.subtler': '--ds-background-accent-green-subtler',
    'color.background.accent.green.subtler.hovered': '--ds-background-accent-green-subtler-hovered',
    'color.background.accent.green.subtler.pressed': '--ds-background-accent-green-subtler-pressed',
    'color.background.accent.green.subtle': '--ds-background-accent-green-subtle',
    'color.background.accent.green.subtle.hovered': '--ds-background-accent-green-subtle-hovered',
    'color.background.accent.green.subtle.pressed': '--ds-background-accent-green-subtle-pressed',
    'color.background.accent.green.bolder': '--ds-background-accent-green-bolder',
    'color.background.accent.green.bolder.hovered': '--ds-background-accent-green-bolder-hovered',
    'color.background.accent.green.bolder.pressed': '--ds-background-accent-green-bolder-pressed',
    'color.background.accent.teal.subtlest': '--ds-background-accent-teal-subtlest',
    'color.background.accent.teal.subtlest.hovered': '--ds-background-accent-teal-subtlest-hovered',
    'color.background.accent.teal.subtlest.pressed': '--ds-background-accent-teal-subtlest-pressed',
    'color.background.accent.teal.subtler': '--ds-background-accent-teal-subtler',
    'color.background.accent.teal.subtler.hovered': '--ds-background-accent-teal-subtler-hovered',
    'color.background.accent.teal.subtler.pressed': '--ds-background-accent-teal-subtler-pressed',
    'color.background.accent.teal.subtle': '--ds-background-accent-teal-subtle',
    'color.background.accent.teal.subtle.hovered': '--ds-background-accent-teal-subtle-hovered',
    'color.background.accent.teal.subtle.pressed': '--ds-background-accent-teal-subtle-pressed',
    'color.background.accent.teal.bolder': '--ds-background-accent-teal-bolder',
    'color.background.accent.teal.bolder.hovered': '--ds-background-accent-teal-bolder-hovered',
    'color.background.accent.teal.bolder.pressed': '--ds-background-accent-teal-bolder-pressed',
    'color.background.accent.blue.subtlest': '--ds-background-accent-blue-subtlest',
    'color.background.accent.blue.subtlest.hovered': '--ds-background-accent-blue-subtlest-hovered',
    'color.background.accent.blue.subtlest.pressed': '--ds-background-accent-blue-subtlest-pressed',
    'color.background.accent.blue.subtler': '--ds-background-accent-blue-subtler',
    'color.background.accent.blue.subtler.hovered': '--ds-background-accent-blue-subtler-hovered',
    'color.background.accent.blue.subtler.pressed': '--ds-background-accent-blue-subtler-pressed',
    'color.background.accent.blue.subtle': '--ds-background-accent-blue-subtle',
    'color.background.accent.blue.subtle.hovered': '--ds-background-accent-blue-subtle-hovered',
    'color.background.accent.blue.subtle.pressed': '--ds-background-accent-blue-subtle-pressed',
    'color.background.accent.blue.bolder': '--ds-background-accent-blue-bolder',
    'color.background.accent.blue.bolder.hovered': '--ds-background-accent-blue-bolder-hovered',
    'color.background.accent.blue.bolder.pressed': '--ds-background-accent-blue-bolder-pressed',
    'color.background.accent.purple.subtlest': '--ds-background-accent-purple-subtlest',
    'color.background.accent.purple.subtlest.hovered': '--ds-background-accent-purple-subtlest-hovered',
    'color.background.accent.purple.subtlest.pressed': '--ds-background-accent-purple-subtlest-pressed',
    'color.background.accent.purple.subtler': '--ds-background-accent-purple-subtler',
    'color.background.accent.purple.subtler.hovered': '--ds-background-accent-purple-subtler-hovered',
    'color.background.accent.purple.subtler.pressed': '--ds-background-accent-purple-subtler-pressed',
    'color.background.accent.purple.subtle': '--ds-background-accent-purple-subtle',
    'color.background.accent.purple.subtle.hovered': '--ds-background-accent-purple-subtle-hovered',
    'color.background.accent.purple.subtle.pressed': '--ds-background-accent-purple-subtle-pressed',
    'color.background.accent.purple.bolder': '--ds-background-accent-purple-bolder',
    'color.background.accent.purple.bolder.hovered': '--ds-background-accent-purple-bolder-hovered',
    'color.background.accent.purple.bolder.pressed': '--ds-background-accent-purple-bolder-pressed',
    'color.background.accent.magenta.subtlest': '--ds-background-accent-magenta-subtlest',
    'color.background.accent.magenta.subtlest.hovered': '--ds-background-accent-magenta-subtlest-hovered',
    'color.background.accent.magenta.subtlest.pressed': '--ds-background-accent-magenta-subtlest-pressed',
    'color.background.accent.magenta.subtler': '--ds-background-accent-magenta-subtler',
    'color.background.accent.magenta.subtler.hovered': '--ds-background-accent-magenta-subtler-hovered',
    'color.background.accent.magenta.subtler.pressed': '--ds-background-accent-magenta-subtler-pressed',
    'color.background.accent.magenta.subtle': '--ds-background-accent-magenta-subtle',
    'color.background.accent.magenta.subtle.hovered': '--ds-background-accent-magenta-subtle-hovered',
    'color.background.accent.magenta.subtle.pressed': '--ds-background-accent-magenta-subtle-pressed',
    'color.background.accent.magenta.bolder': '--ds-background-accent-magenta-bolder',
    'color.background.accent.magenta.bolder.hovered': '--ds-background-accent-magenta-bolder-hovered',
    'color.background.accent.magenta.bolder.pressed': '--ds-background-accent-magenta-bolder-pressed',
    'color.background.accent.gray.subtlest': '--ds-background-accent-gray-subtlest',
    'color.background.accent.gray.subtlest.hovered': '--ds-background-accent-gray-subtlest-hovered',
    'color.background.accent.gray.subtlest.pressed': '--ds-background-accent-gray-subtlest-pressed',
    'color.background.accent.gray.subtler': '--ds-background-accent-gray-subtler',
    'color.background.accent.gray.subtler.hovered': '--ds-background-accent-gray-subtler-hovered',
    'color.background.accent.gray.subtler.pressed': '--ds-background-accent-gray-subtler-pressed',
    'color.background.accent.gray.subtle': '--ds-background-accent-gray-subtle',
    'color.background.accent.gray.subtle.hovered': '--ds-background-accent-gray-subtle-hovered',
    'color.background.accent.gray.subtle.pressed': '--ds-background-accent-gray-subtle-pressed',
    'color.background.accent.gray.bolder': '--ds-background-accent-gray-bolder',
    'color.background.accent.gray.bolder.hovered': '--ds-background-accent-gray-bolder-hovered',
    'color.background.accent.gray.bolder.pressed': '--ds-background-accent-gray-bolder-pressed',
    'color.background.disabled': '--ds-background-disabled',
    'color.background.input': '--ds-background-input',
    'color.background.input.hovered': '--ds-background-input-hovered',
    'color.background.input.pressed': '--ds-background-input-pressed',
    'color.background.inverse.subtle': '--ds-background-inverse-subtle',
    'color.background.inverse.subtle.hovered': '--ds-background-inverse-subtle-hovered',
    'color.background.inverse.subtle.pressed': '--ds-background-inverse-subtle-pressed',
    'color.background.neutral': '--ds-background-neutral',
    'color.background.neutral.hovered': '--ds-background-neutral-hovered',
    'color.background.neutral.pressed': '--ds-background-neutral-pressed',
    'color.background.neutral.subtle': '--ds-background-neutral-subtle',
    'color.background.neutral.subtle.hovered': '--ds-background-neutral-subtle-hovered',
    'color.background.neutral.subtle.pressed': '--ds-background-neutral-subtle-pressed',
    'color.background.neutral.bold': '--ds-background-neutral-bold',
    'color.background.neutral.bold.hovered': '--ds-background-neutral-bold-hovered',
    'color.background.neutral.bold.pressed': '--ds-background-neutral-bold-pressed',
    'color.background.selected': '--ds-background-selected',
    'color.background.selected.hovered': '--ds-background-selected-hovered',
    'color.background.selected.pressed': '--ds-background-selected-pressed',
    'color.background.selected.bold': '--ds-background-selected-bold',
    'color.background.selected.bold.hovered': '--ds-background-selected-bold-hovered',
    'color.background.selected.bold.pressed': '--ds-background-selected-bold-pressed',
    'color.background.brand.subtlest': '--ds-background-brand-subtlest',
    'color.background.brand.subtlest.hovered': '--ds-background-brand-subtlest-hovered',
    'color.background.brand.subtlest.pressed': '--ds-background-brand-subtlest-pressed',
    'color.background.brand.bold': '--ds-background-brand-bold',
    'color.background.brand.bold.hovered': '--ds-background-brand-bold-hovered',
    'color.background.brand.bold.pressed': '--ds-background-brand-bold-pressed',
    'color.background.brand.boldest': '--ds-background-brand-boldest',
    'color.background.brand.boldest.hovered': '--ds-background-brand-boldest-hovered',
    'color.background.brand.boldest.pressed': '--ds-background-brand-boldest-pressed',
    'color.background.danger': '--ds-background-danger',
    'color.background.danger.hovered': '--ds-background-danger-hovered',
    'color.background.danger.pressed': '--ds-background-danger-pressed',
    'color.background.danger.subtler': '--ds-background-danger-subtler',
    'color.background.danger.subtler.hovered': '--ds-background-danger-subtler-hovered',
    'color.background.danger.subtler.pressed': '--ds-background-danger-subtler-pressed',
    'color.background.danger.bold': '--ds-background-danger-bold',
    'color.background.danger.bold.hovered': '--ds-background-danger-bold-hovered',
    'color.background.danger.bold.pressed': '--ds-background-danger-bold-pressed',
    'color.background.warning': '--ds-background-warning',
    'color.background.warning.hovered': '--ds-background-warning-hovered',
    'color.background.warning.pressed': '--ds-background-warning-pressed',
    'color.background.warning.subtler': '--ds-background-warning-subtler',
    'color.background.warning.subtler.hovered': '--ds-background-warning-subtler-hovered',
    'color.background.warning.subtler.pressed': '--ds-background-warning-subtler-pressed',
    'color.background.warning.bold': '--ds-background-warning-bold',
    'color.background.warning.bold.hovered': '--ds-background-warning-bold-hovered',
    'color.background.warning.bold.pressed': '--ds-background-warning-bold-pressed',
    'color.background.success': '--ds-background-success',
    'color.background.success.hovered': '--ds-background-success-hovered',
    'color.background.success.pressed': '--ds-background-success-pressed',
    'color.background.success.subtler': '--ds-background-success-subtler',
    'color.background.success.subtler.hovered': '--ds-background-success-subtler-hovered',
    'color.background.success.subtler.pressed': '--ds-background-success-subtler-pressed',
    'color.background.success.bold': '--ds-background-success-bold',
    'color.background.success.bold.hovered': '--ds-background-success-bold-hovered',
    'color.background.success.bold.pressed': '--ds-background-success-bold-pressed',
    'color.background.discovery': '--ds-background-discovery',
    'color.background.discovery.hovered': '--ds-background-discovery-hovered',
    'color.background.discovery.pressed': '--ds-background-discovery-pressed',
    'color.background.discovery.subtler': '--ds-background-discovery-subtler',
    'color.background.discovery.subtler.hovered': '--ds-background-discovery-subtler-hovered',
    'color.background.discovery.subtler.pressed': '--ds-background-discovery-subtler-pressed',
    'color.background.discovery.bold': '--ds-background-discovery-bold',
    'color.background.discovery.bold.hovered': '--ds-background-discovery-bold-hovered',
    'color.background.discovery.bold.pressed': '--ds-background-discovery-bold-pressed',
    'color.background.information': '--ds-background-information',
    'color.background.information.hovered': '--ds-background-information-hovered',
    'color.background.information.pressed': '--ds-background-information-pressed',
    'color.background.information.subtler': '--ds-background-information-subtler',
    'color.background.information.subtler.hovered': '--ds-background-information-subtler-hovered',
    'color.background.information.subtler.pressed': '--ds-background-information-subtler-pressed',
    'color.background.information.bold': '--ds-background-information-bold',
    'color.background.information.bold.hovered': '--ds-background-information-bold-hovered',
    'color.background.information.bold.pressed': '--ds-background-information-bold-pressed',
    'color.blanket': '--ds-blanket',
    'color.blanket.selected': '--ds-blanket-selected',
    'color.blanket.danger': '--ds-blanket-danger',
    'color.interaction.hovered': '--ds-interaction-hovered',
    'color.interaction.pressed': '--ds-interaction-pressed',
    'color.skeleton': '--ds-skeleton',
    'color.skeleton.subtle': '--ds-skeleton-subtle',
    'color.chart.categorical.1': '--ds-chart-categorical-1',
    'color.chart.categorical.1.hovered': '--ds-chart-categorical-1-hovered',
    'color.chart.categorical.2': '--ds-chart-categorical-2',
    'color.chart.categorical.2.hovered': '--ds-chart-categorical-2-hovered',
    'color.chart.categorical.3': '--ds-chart-categorical-3',
    'color.chart.categorical.3.hovered': '--ds-chart-categorical-3-hovered',
    'color.chart.categorical.4': '--ds-chart-categorical-4',
    'color.chart.categorical.4.hovered': '--ds-chart-categorical-4-hovered',
    'color.chart.categorical.5': '--ds-chart-categorical-5',
    'color.chart.categorical.5.hovered': '--ds-chart-categorical-5-hovered',
    'color.chart.categorical.6': '--ds-chart-categorical-6',
    'color.chart.categorical.6.hovered': '--ds-chart-categorical-6-hovered',
    'color.chart.categorical.7': '--ds-chart-categorical-7',
    'color.chart.categorical.7.hovered': '--ds-chart-categorical-7-hovered',
    'color.chart.categorical.8': '--ds-chart-categorical-8',
    'color.chart.categorical.8.hovered': '--ds-chart-categorical-8-hovered',
    'color.chart.lime.bold': '--ds-chart-lime-bold',
    'color.chart.lime.bold.hovered': '--ds-chart-lime-bold-hovered',
    'color.chart.lime.bolder': '--ds-chart-lime-bolder',
    'color.chart.lime.bolder.hovered': '--ds-chart-lime-bolder-hovered',
    'color.chart.lime.boldest': '--ds-chart-lime-boldest',
    'color.chart.lime.boldest.hovered': '--ds-chart-lime-boldest-hovered',
    'color.chart.neutral': '--ds-chart-neutral',
    'color.chart.neutral.hovered': '--ds-chart-neutral-hovered',
    'color.chart.red.bold': '--ds-chart-red-bold',
    'color.chart.red.bold.hovered': '--ds-chart-red-bold-hovered',
    'color.chart.red.bolder': '--ds-chart-red-bolder',
    'color.chart.red.bolder.hovered': '--ds-chart-red-bolder-hovered',
    'color.chart.red.boldest': '--ds-chart-red-boldest',
    'color.chart.red.boldest.hovered': '--ds-chart-red-boldest-hovered',
    'color.chart.orange.bold': '--ds-chart-orange-bold',
    'color.chart.orange.bold.hovered': '--ds-chart-orange-bold-hovered',
    'color.chart.orange.bolder': '--ds-chart-orange-bolder',
    'color.chart.orange.bolder.hovered': '--ds-chart-orange-bolder-hovered',
    'color.chart.orange.boldest': '--ds-chart-orange-boldest',
    'color.chart.orange.boldest.hovered': '--ds-chart-orange-boldest-hovered',
    'color.chart.yellow.bold': '--ds-chart-yellow-bold',
    'color.chart.yellow.bold.hovered': '--ds-chart-yellow-bold-hovered',
    'color.chart.yellow.bolder': '--ds-chart-yellow-bolder',
    'color.chart.yellow.bolder.hovered': '--ds-chart-yellow-bolder-hovered',
    'color.chart.yellow.boldest': '--ds-chart-yellow-boldest',
    'color.chart.yellow.boldest.hovered': '--ds-chart-yellow-boldest-hovered',
    'color.chart.green.bold': '--ds-chart-green-bold',
    'color.chart.green.bold.hovered': '--ds-chart-green-bold-hovered',
    'color.chart.green.bolder': '--ds-chart-green-bolder',
    'color.chart.green.bolder.hovered': '--ds-chart-green-bolder-hovered',
    'color.chart.green.boldest': '--ds-chart-green-boldest',
    'color.chart.green.boldest.hovered': '--ds-chart-green-boldest-hovered',
    'color.chart.teal.bold': '--ds-chart-teal-bold',
    'color.chart.teal.bold.hovered': '--ds-chart-teal-bold-hovered',
    'color.chart.teal.bolder': '--ds-chart-teal-bolder',
    'color.chart.teal.bolder.hovered': '--ds-chart-teal-bolder-hovered',
    'color.chart.teal.boldest': '--ds-chart-teal-boldest',
    'color.chart.teal.boldest.hovered': '--ds-chart-teal-boldest-hovered',
    'color.chart.blue.bold': '--ds-chart-blue-bold',
    'color.chart.blue.bold.hovered': '--ds-chart-blue-bold-hovered',
    'color.chart.blue.bolder': '--ds-chart-blue-bolder',
    'color.chart.blue.bolder.hovered': '--ds-chart-blue-bolder-hovered',
    'color.chart.blue.boldest': '--ds-chart-blue-boldest',
    'color.chart.blue.boldest.hovered': '--ds-chart-blue-boldest-hovered',
    'color.chart.purple.bold': '--ds-chart-purple-bold',
    'color.chart.purple.bold.hovered': '--ds-chart-purple-bold-hovered',
    'color.chart.purple.bolder': '--ds-chart-purple-bolder',
    'color.chart.purple.bolder.hovered': '--ds-chart-purple-bolder-hovered',
    'color.chart.purple.boldest': '--ds-chart-purple-boldest',
    'color.chart.purple.boldest.hovered': '--ds-chart-purple-boldest-hovered',
    'color.chart.magenta.bold': '--ds-chart-magenta-bold',
    'color.chart.magenta.bold.hovered': '--ds-chart-magenta-bold-hovered',
    'color.chart.magenta.bolder': '--ds-chart-magenta-bolder',
    'color.chart.magenta.bolder.hovered': '--ds-chart-magenta-bolder-hovered',
    'color.chart.magenta.boldest': '--ds-chart-magenta-boldest',
    'color.chart.magenta.boldest.hovered': '--ds-chart-magenta-boldest-hovered',
    'color.chart.gray.bold': '--ds-chart-gray-bold',
    'color.chart.gray.bold.hovered': '--ds-chart-gray-bold-hovered',
    'color.chart.gray.bolder': '--ds-chart-gray-bolder',
    'color.chart.gray.bolder.hovered': '--ds-chart-gray-bolder-hovered',
    'color.chart.gray.boldest': '--ds-chart-gray-boldest',
    'color.chart.gray.boldest.hovered': '--ds-chart-gray-boldest-hovered',
    'color.chart.brand': '--ds-chart-brand',
    'color.chart.brand.hovered': '--ds-chart-brand-hovered',
    'color.chart.danger': '--ds-chart-danger',
    'color.chart.danger.hovered': '--ds-chart-danger-hovered',
    'color.chart.danger.bold': '--ds-chart-danger-bold',
    'color.chart.danger.bold.hovered': '--ds-chart-danger-bold-hovered',
    'color.chart.warning': '--ds-chart-warning',
    'color.chart.warning.hovered': '--ds-chart-warning-hovered',
    'color.chart.warning.bold': '--ds-chart-warning-bold',
    'color.chart.warning.bold.hovered': '--ds-chart-warning-bold-hovered',
    'color.chart.success': '--ds-chart-success',
    'color.chart.success.hovered': '--ds-chart-success-hovered',
    'color.chart.success.bold': '--ds-chart-success-bold',
    'color.chart.success.bold.hovered': '--ds-chart-success-bold-hovered',
    'color.chart.discovery': '--ds-chart-discovery',
    'color.chart.discovery.hovered': '--ds-chart-discovery-hovered',
    'color.chart.discovery.bold': '--ds-chart-discovery-bold',
    'color.chart.discovery.bold.hovered': '--ds-chart-discovery-bold-hovered',
    'color.chart.information': '--ds-chart-information',
    'color.chart.information.hovered': '--ds-chart-information-hovered',
    'color.chart.information.bold': '--ds-chart-information-bold',
    'color.chart.information.bold.hovered': '--ds-chart-information-bold-hovered',
    'elevation.surface': '--ds-surface',
    'elevation.surface.hovered': '--ds-surface-hovered',
    'elevation.surface.pressed': '--ds-surface-pressed',
    'elevation.surface.overlay': '--ds-surface-overlay',
    'elevation.surface.overlay.hovered': '--ds-surface-overlay-hovered',
    'elevation.surface.overlay.pressed': '--ds-surface-overlay-pressed',
    'elevation.surface.raised': '--ds-surface-raised',
    'elevation.surface.raised.hovered': '--ds-surface-raised-hovered',
    'elevation.surface.raised.pressed': '--ds-surface-raised-pressed',
    'elevation.surface.sunken': '--ds-surface-sunken',
    'elevation.shadow.overflow': '--ds-shadow-overflow',
    'elevation.shadow.overflow.perimeter': '--ds-shadow-overflow-perimeter',
    'elevation.shadow.overflow.spread': '--ds-shadow-overflow-spread',
    'elevation.shadow.overlay': '--ds-shadow-overlay',
    'elevation.shadow.raised': '--ds-shadow-raised',
    'opacity.disabled': '--ds-opacity-disabled',
    'opacity.loading': '--ds-opacity-loading',
    'utility.UNSAFE.transparent': '--ds-UNSAFE-transparent',
    'utility.elevation.surface.current': '--ds-elevation-surface-current',
    'space.0': '--ds-space-0',
    'space.025': '--ds-space-025',
    'space.050': '--ds-space-050',
    'space.075': '--ds-space-075',
    'space.100': '--ds-space-100',
    'space.150': '--ds-space-150',
    'space.200': '--ds-space-200',
    'space.250': '--ds-space-250',
    'space.300': '--ds-space-300',
    'space.400': '--ds-space-400',
    'space.500': '--ds-space-500',
    'space.600': '--ds-space-600',
    'space.800': '--ds-space-800',
    'space.1000': '--ds-space-1000',
    'space.negative.025': '--ds-space-negative-025',
    'space.negative.050': '--ds-space-negative-050',
    'space.negative.075': '--ds-space-negative-075',
    'space.negative.100': '--ds-space-negative-100',
    'space.negative.150': '--ds-space-negative-150',
    'space.negative.200': '--ds-space-negative-200',
    'space.negative.250': '--ds-space-negative-250',
    'space.negative.300': '--ds-space-negative-300',
    'space.negative.400': '--ds-space-negative-400',
    'font.heading.xxlarge': '--ds-font-heading-xxlarge',
    'font.heading.xlarge': '--ds-font-heading-xlarge',
    'font.heading.large': '--ds-font-heading-large',
    'font.heading.medium': '--ds-font-heading-medium',
    'font.heading.small': '--ds-font-heading-small',
    'font.heading.xsmall': '--ds-font-heading-xsmall',
    'font.heading.xxsmall': '--ds-font-heading-xxsmall',
    'font.body.large': '--ds-font-body-large',
    'font.body': '--ds-font-body',
    'font.body.small': '--ds-font-body-small',
    'font.metric.large': '--ds-font-metric-large',
    'font.metric.medium': '--ds-font-metric-medium',
    'font.metric.small': '--ds-font-metric-small',
    'font.code': '--ds-font-code',
    'font.weight.regular': '--ds-font-weight-regular',
    'font.weight.medium': '--ds-font-weight-medium',
    'font.weight.semibold': '--ds-font-weight-semibold',
    'font.weight.bold': '--ds-font-weight-bold',
    'font.family.heading': '--ds-font-family-heading',
    'font.family.body': '--ds-font-family-body',
    'font.family.code': '--ds-font-family-code',
    'font.family.brand.heading': '--ds-font-family-brand-heading',
    'font.family.brand.body': '--ds-font-family-brand-body',
    'radius.xsmall': '--ds-radius-xsmall',
    'radius.small': '--ds-radius-small',
    'radius.medium': '--ds-radius-medium',
    'radius.large': '--ds-radius-large',
    'radius.xlarge': '--ds-radius-xlarge',
    'radius.xxlarge': '--ds-radius-xxlarge',
    'radius.full': '--ds-radius-full',
    'radius.tile': '--ds-radius-tile',
    'border.width': '--ds-border-width',
    'border.width.selected': '--ds-border-width-selected',
    'border.width.focused': '--ds-border-width-focused'
};
var $8965a5fc1a5cfd30$export$2e2bcd8739ae039 = $8965a5fc1a5cfd30$var$tokens;

});

parcelRegister("hvJbm", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a2cff70d9276c693dca9eb8c1c54a9e2>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $cbf86129106492cc$var$_react = $cbf86129106492cc$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $cbf86129106492cc$var$_baseNew = $cbf86129106492cc$var$_interopRequireDefault((parcelRequire("axuVY")));
function $cbf86129106492cc$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "AtlassianIntelligence".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for Atlassian Intelligence apps or experiences.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $cbf86129106492cc$var$AtlassianIntelligenceIcon = (props)=>/*#__PURE__*/ $cbf86129106492cc$var$_react.default.createElement($cbf86129106492cc$var$_baseNew.default, Object.assign({
        name: "AtlassianIntelligenceIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M8.75 12v3h-1.5v-3zm-2.22-1.47-4 4-1.06-1.06 4-4zm8 2.94-1.06 1.06-4-4 1.06-1.06zM4 7.25v1.5H1v-1.5zm11 0v1.5h-3v-1.5zM6.53 5.47 5.47 6.53l-4-4 1.06-1.06zm8-2.94-4 4-1.06-1.06 4-4zM8.75 1v3h-1.5V1z"/>`
    }, props));
$cbf86129106492cc$var$AtlassianIntelligenceIcon.displayName = 'AtlassianIntelligenceIcon';
var $cbf86129106492cc$var$_default = module.exports.default = $cbf86129106492cc$var$AtlassianIntelligenceIcon;

});

parcelRegister("k7fIB", function(module, exports) {
$parcel$export(module.exports, "default", () => $ea50a775eb92d9fc$export$2e2bcd8739ae039);

var $4NT9w = parcelRequire("4NT9w");
var $ea50a775eb92d9fc$export$2e2bcd8739ae039 = (0, $4NT9w.default);

});
parcelRegister("4NT9w", function(module, exports) {
$parcel$export(module.exports, "default", () => $37f6852fd30fbfb0$export$2e2bcd8739ae039);

var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");

var $bLIMX = parcelRequire("bLIMX");

var $gITbN = parcelRequire("gITbN");
var $37f6852fd30fbfb0$var$useLayoutEffectSAFE = typeof window === 'undefined' ? (0, $5FkrB.useEffect) : (0, $5FkrB.useLayoutEffect);
/**
 * Custom hook to track changes to the interaction ID.
 * Uses a subscription system to automatically update when the interaction ID changes.
 */ function $37f6852fd30fbfb0$var$useInteractionIdValue() {
    var interactionId = (0, $5FkrB.useContext)((0, $gITbN.default));
    var _useState = (0, $5FkrB.useState)((interactionId === null || interactionId === void 0 ? void 0 : interactionId.current) || null), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), currentId = _useState2[0], setCurrentId = _useState2[1];
    $37f6852fd30fbfb0$var$useLayoutEffectSAFE(function() {
        setCurrentId((interactionId === null || interactionId === void 0 ? void 0 : interactionId.current) || null);
        var unsubscribe = (0, $gITbN.subscribeToInteractionIdChanges)(function(newId) {
            setCurrentId(newId);
        });
        return unsubscribe;
    }, [
        interactionId
    ]);
    return currentId;
}
function $37f6852fd30fbfb0$export$2e2bcd8739ae039(_ref) {
    var children = _ref.children, name = _ref.name, _ref$hold = _ref.hold, hold = _ref$hold === void 0 ? true : _ref$hold, _ref$experimental = _ref.experimental, experimental = _ref$experimental === void 0 ? false : _ref$experimental;
    var currentInteractionId = $37f6852fd30fbfb0$var$useInteractionIdValue();
    // react-18: useId instead
    var context = (0, $5FkrB.useContext)((0, $bLIMX.default));
    $37f6852fd30fbfb0$var$useLayoutEffectSAFE(function() {
        if (hold && context != null) {
            if (experimental && context.holdExperimental) return context.holdExperimental(name);
            return context.hold(name);
        }
    }, [
        hold,
        context,
        name,
        currentInteractionId
    ]);
    // react-18: can return children directly
    return children != null ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).Fragment, null, children) : null;
}

});
parcelRegister("bLIMX", function(module, exports) {
$parcel$export(module.exports, "default", () => $8916d3957d190d4e$export$2e2bcd8739ae039);
$parcel$export(module.exports, "useInteractionContext", () => $8916d3957d190d4e$export$11bcb6e9af2aca35);

var $5FkrB = parcelRequire("5FkrB");

var $eqVaP = parcelRequire("eqVaP");
var $8916d3957d190d4e$export$2e2bcd8739ae039 = (0, $eqVaP.default);
function $8916d3957d190d4e$export$11bcb6e9af2aca35() {
    return (0, $5FkrB.useContext)((0, $eqVaP.default));
}

});

parcelRegister("gITbN", function(module, exports) {
$parcel$export(module.exports, "DefaultInteractionID", () => $c2cb90d222c902dc$export$3109542b68df9ba1);
$parcel$export(module.exports, "subscribeToInteractionIdChanges", () => $c2cb90d222c902dc$export$3e0c3023952f6774);
$parcel$export(module.exports, "default", () => $c2cb90d222c902dc$export$2e2bcd8739ae039);
$parcel$export(module.exports, "getInteractionId", () => $c2cb90d222c902dc$export$37bca3107733ac1e);

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $25nEq = parcelRequire("25nEq");

var $5FkrB = parcelRequire("5FkrB");
// Same structure as react's useRef.
// This allows modals to use a ref to scope their value
// const id = useRef(null);
// <InteractionIDContext.Provider value={id}>...<
// Subscription system for interaction ID changes
var $c2cb90d222c902dc$var$listeners = new Set();
// Observable interaction ID implementation
var $c2cb90d222c902dc$var$ObservableInteractionID = /*#__PURE__*/ function() {
    function ObservableInteractionID() {
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, ObservableInteractionID);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "_current", null);
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(ObservableInteractionID, [
        {
            key: "current",
            get: function get() {
                return this._current;
            },
            set: function set(newId) {
                var oldId = this._current;
                this._current = newId;
                // Notify all listeners if the ID actually changed
                if (oldId !== newId) $c2cb90d222c902dc$var$listeners.forEach(function(listener) {
                    return listener(newId);
                });
            }
        }
    ]);
}(); // Type declaration for globalThis extension
// Ensures a single DefaultInteractionID instance exists across the entire application,
// even when the module is loaded multiple times in different contexts
var $c2cb90d222c902dc$var$initializeGlobalDefaultInteractionID = function initializeGlobalDefaultInteractionID() {
    // Return existing instance if already initialized
    if (globalThis.__UFO_DEFAULT_INTERACTION_ID__) return globalThis.__UFO_DEFAULT_INTERACTION_ID__;
    // Create and store new instance globally
    var instance = new $c2cb90d222c902dc$var$ObservableInteractionID();
    globalThis.__UFO_DEFAULT_INTERACTION_ID__ = instance;
    return instance;
};
var $c2cb90d222c902dc$export$3109542b68df9ba1 = $c2cb90d222c902dc$var$initializeGlobalDefaultInteractionID();
var $c2cb90d222c902dc$export$3e0c3023952f6774 = function subscribeToInteractionIdChanges(listener) {
    $c2cb90d222c902dc$var$listeners.add(listener);
    return function() {
        $c2cb90d222c902dc$var$listeners.delete(listener);
    };
};
// We use a context to allow modals to have their own lifecycle
var $c2cb90d222c902dc$var$_default_1 = /*#__PURE__*/ (0, $5FkrB.createContext)($c2cb90d222c902dc$export$3109542b68df9ba1);
var $c2cb90d222c902dc$export$2e2bcd8739ae039 = $c2cb90d222c902dc$var$_default_1;
var $c2cb90d222c902dc$export$37bca3107733ac1e = function getInteractionId() {
    return $c2cb90d222c902dc$export$3109542b68df9ba1;
};
var $c2cb90d222c902dc$export$9f6000531b78127e = function useInteractionId() {
    return $c2cb90d222c902dc$export$3109542b68df9ba1;
};

});



parcelRegister("Un5hy", function(module, exports) {
$parcel$export(module.exports, "default", () => $0a97231e197d3e09$export$2e2bcd8739ae039);

var $aTpvL = parcelRequire("aTpvL");

var $0a97231e197d3e09$export$2e2bcd8739ae039 = (0, $aTpvL.default);

});
parcelRegister("aTpvL", function(module, exports) {
$parcel$export(module.exports, "default", () => $7ee2d474f4b84c7a$export$2e2bcd8739ae039);

var $25nEq = parcelRequire("25nEq");

var $fC8ib = parcelRequire("fC8ib");

var $5FkrB = parcelRequire("5FkrB");

var $3hvsM = parcelRequire("3hvsM");

var $6JfQX = parcelRequire("6JfQX");

var $9Zzpd = parcelRequire("9Zzpd");

var $4iVTn = parcelRequire("4iVTn");

var $DtLwq = parcelRequire("DtLwq");

var $6K0Mp = parcelRequire("6K0Mp");

var $bLIMX = parcelRequire("bLIMX");

var $gITbN = parcelRequire("gITbN");

var $iGolp = parcelRequire("iGolp");

var $6SIfU = parcelRequire("6SIfU");

var $1F1of = parcelRequire("1F1of");

var $3JJ0b = parcelRequire("3JJ0b");

var $3DeKi = parcelRequire("3DeKi");
function $7ee2d474f4b84c7a$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $7ee2d474f4b84c7a$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $7ee2d474f4b84c7a$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $7ee2d474f4b84c7a$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $7ee2d474f4b84c7a$var$tryCompleteHandle;
var $7ee2d474f4b84c7a$var$hasMarkedFirstSegmentLoad = false;
function $7ee2d474f4b84c7a$export$2e2bcd8739ae039(_ref) {
    var segmentName = _ref.name, children = _ref.children, _ref$mode = _ref.mode, mode = _ref$mode === void 0 ? 'single' : _ref$mode, _ref$type = _ref.type, type = _ref$type === void 0 ? 'first-party' : _ref$type;
    var parentContext = (0, $5FkrB.useContext)((0, $bLIMX.default));
    var segmentIdMap = (0, $5FkrB.useMemo)(function() {
        if (!(parentContext !== null && parentContext !== void 0 && parentContext.segmentIdMap)) return new Map();
        return parentContext.segmentIdMap;
    }, [
        parentContext
    ]);
    var segmentId = (0, $5FkrB.useMemo)(function() {
        if (mode === 'single') return (0, $1F1of.default)();
        if (segmentIdMap.has(segmentName)) return segmentIdMap.get(segmentName);
        var newSegmentId = (0, $1F1of.default)();
        segmentIdMap.set(segmentName, newSegmentId);
        return newSegmentId;
    }, [
        mode,
        segmentName,
        segmentIdMap
    ]);
    var labelStack = (0, $5FkrB.useMemo)(function() {
        return parentContext !== null && parentContext !== void 0 && parentContext.labelStack ? [].concat((0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(parentContext.labelStack), [
            $7ee2d474f4b84c7a$var$_objectSpread({
                name: segmentName,
                segmentId: segmentId
            }, type !== 'first-party' ? {
                type: type
            } : {}) // Only pass non-default types (not 'first-party') in payload to reduce size
        ]) : [
            $7ee2d474f4b84c7a$var$_objectSpread({
                name: segmentName,
                segmentId: segmentId
            }, type !== 'first-party' ? {
                type: type
            } : {})
        ];
    }, [
        parentContext,
        segmentName,
        segmentId,
        type
    ]);
    var interactionId = (0, $5FkrB.useContext)((0, $gITbN.default));
    if (interactionId.current != null && !$7ee2d474f4b84c7a$var$hasMarkedFirstSegmentLoad) {
        (0, $iGolp.markFirstSegmentLoad)(interactionId.current, labelStack, performance.now());
        $7ee2d474f4b84c7a$var$hasMarkedFirstSegmentLoad = true;
    }
    var interactionContext = (0, $5FkrB.useMemo)(function() {
        var lastCompleteEndTime = 0;
        function complete() {
            var endTime = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : performance.now();
            if (interactionId.current) {
                if (parentContext) parentContext.complete();
                else {
                    var capturedInteractionId = interactionId.current;
                    if (endTime > lastCompleteEndTime) lastCompleteEndTime = endTime;
                    if ($7ee2d474f4b84c7a$var$tryCompleteHandle) {
                        var _cancelAnimationFrame;
                        (_cancelAnimationFrame = cancelAnimationFrame) === null || _cancelAnimationFrame === void 0 || _cancelAnimationFrame($7ee2d474f4b84c7a$var$tryCompleteHandle);
                    }
                    var onComplete = function onComplete() {
                        if (capturedInteractionId === interactionId.current) {
                            var _globalThis$document;
                            var isPageVisible = (globalThis === null || globalThis === void 0 || (_globalThis$document = globalThis.document) === null || _globalThis$document === void 0 ? void 0 : _globalThis$document.visibilityState) === 'visible';
                            var canDoRAF = typeof requestAnimationFrame !== 'undefined';
                            if (isPageVisible && canDoRAF) $7ee2d474f4b84c7a$var$tryCompleteHandle = requestAnimationFrame(function() {
                                $7ee2d474f4b84c7a$var$tryCompleteHandle = requestAnimationFrame(function() {
                                    if (capturedInteractionId === interactionId.current) (0, $iGolp.tryComplete)(interactionId.current, lastCompleteEndTime);
                                });
                            });
                            else (0, $iGolp.tryComplete)(interactionId.current, lastCompleteEndTime);
                        }
                    };
                    (0, $3hvsM.unstable_scheduleCallback)((0, $3hvsM.unstable_NormalPriority), onComplete);
                }
            }
        }
        function _internalHold(labelStack, name) {
            var experimental = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
            if (interactionId.current != null) {
                if (parentContext) return parentContext._internalHold(labelStack, name, experimental);
                else {
                    var capturedInteractionId = interactionId.current;
                    var disposeHold = (0, $iGolp.addHold)(interactionId.current, labelStack, name, experimental);
                    return function() {
                        if (capturedInteractionId === interactionId.current) disposeHold();
                    };
                }
            }
        }
        function _internalHoldByID(labelStack, id, name, remove) {
            if (interactionId.current != null) {
                if (parentContext) {
                    parentContext._internalHoldByID(labelStack, name, id, remove);
                    return;
                }
                if (!remove) (0, $iGolp.addHoldByID)(interactionId.current, labelStack, name, id);
                else (0, $iGolp.removeHoldByID)(interactionId.current, id);
            }
        }
        if (parentContext) return $7ee2d474f4b84c7a$var$_objectSpread($7ee2d474f4b84c7a$var$_objectSpread({}, parentContext), {}, {
            labelStack: labelStack,
            complete: complete
        });
        return {
            labelStack: labelStack,
            segmentIdMap: segmentIdMap,
            hold: function hold() {
                var name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'unknown';
                return this._internalHold(this.labelStack, name);
            },
            holdExperimental: function holdExperimental() {
                var name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'unknown';
                return this._internalHold(this.labelStack, name, true);
            },
            addHoldByID: function addHoldByID(labelStack, id) {
                var name = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'unknown';
                this._internalHoldByID(labelStack, id, name, false);
            },
            removeHoldByID: function removeHoldByID(labelStack, id) {
                var name = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'unknown';
                this._internalHoldByID(labelStack, id, name, true);
            },
            tracePress: function tracePress() {
                var _getDoNotAbortActiveP, _getMinorInteractions;
                var name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'unknown';
                var timestamp = arguments.length > 1 ? arguments[1] : undefined;
                var minorInteractions = [].concat((0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))((_getDoNotAbortActiveP = (0, $DtLwq.getDoNotAbortActivePressInteraction)()) !== null && _getDoNotAbortActiveP !== void 0 ? _getDoNotAbortActiveP : []), (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))((_getMinorInteractions = (0, $DtLwq.getMinorInteractions)()) !== null && _getMinorInteractions !== void 0 ? _getMinorInteractions : []));
                if (minorInteractions.includes(name)) {
                    var _activeInteraction$mi;
                    var activeInteraction = (0, $iGolp.getActiveInteraction)();
                    activeInteraction === null || activeInteraction === void 0 || (_activeInteraction$mi = activeInteraction.minorInteractions) === null || _activeInteraction$mi === void 0 || _activeInteraction$mi.push({
                        name: name,
                        startTime: timestamp !== null && timestamp !== void 0 ? timestamp : performance.now()
                    });
                    return;
                } else if (interactionId.current != null) (0, $iGolp.abortByNewInteraction)(interactionId.current, name);
                var rate = (0, $DtLwq.getInteractionRate)(name, 'press');
                if ((0, $4iVTn.default)(rate)) {
                    var startTimestamp = timestamp !== null && timestamp !== void 0 ? timestamp : performance.now();
                    // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
                    var newId = (0, $6JfQX.default)();
                    interactionId.current = newId;
                    // covered experiences with tracing instrumentation:
                    // inline-result.global-issue.create-modal.submit
                    // inline-result.global-issue.create-modal-subsequent
                    (0, $6K0Mp.setInteractionActiveTrace)(newId, 'press');
                    (0, $iGolp.addNewInteraction)(newId, name, 'press', startTimestamp, rate, this.labelStack, (0, $6SIfU.default).current, (0, $6K0Mp.getActiveTrace)());
                }
            },
            retainQuery: function retainQuery(info) {
                if (interactionId.current != null) (0, $iGolp.addRequestInfo)(interactionId.current, this.labelStack, info);
            },
            addPreload: function addPreload(moduleId, timestamp) {
                if (interactionId.current != null) (0, $iGolp.addMark)(interactionId.current, 'bundle_preload', moduleId, this.labelStack, timestamp);
            },
            addLoad: function addLoad(identifier, start, end) {
                if (interactionId.current != null) {
                    var _this$labelStack = this.labelStack, _labelStack = _this$labelStack === void 0 ? [] : _this$labelStack;
                    (0, $iGolp.addSpan)(interactionId.current, 'bundle_load', identifier, _labelStack, start, end);
                }
            },
            addMark: function addMark(name, timestamp) {
                if (interactionId.current != null) {
                    var time = timestamp !== null && timestamp !== void 0 ? timestamp : performance.now();
                    (0, $iGolp.addMark)(interactionId.current, 'custom', name, this.labelStack, time);
                }
            },
            addCustomData: function addCustomData(customData) {
                if (interactionId.current != null) (0, $iGolp.addCustomData)(interactionId.current, this.labelStack, customData);
            },
            addCustomTimings: function addCustomTimings(customTimings) {
                if (interactionId.current != null) (0, $iGolp.addCustomTiming)(interactionId.current, this.labelStack, customTimings);
            },
            addApdex: function addApdex(apdexInfo) {
                if (interactionId.current != null) {
                    var key = apdexInfo.key, stopTime = apdexInfo.stopTime, startTime = apdexInfo.startTime;
                    (0, $iGolp.addApdex)(interactionId.current, {
                        key: key,
                        stopTime: stopTime,
                        startTime: startTime,
                        labelStack: this.labelStack
                    });
                }
            },
            onRender: function onRender(phase, actualDuration, baseDuration, startTime, commitTime) {
                var _this = this;
                if (interactionId.current !== null) {
                    (0, $iGolp.addProfilerTimings)(interactionId.current, this.labelStack, phase, actualDuration, baseDuration, startTime, commitTime);
                    (0, $3JJ0b.default)(function() {
                        var paintedTime = performance.now();
                        _this.complete(paintedTime);
                    });
                }
            },
            _internalHold: _internalHold,
            _internalHoldByID: _internalHoldByID,
            complete: complete
        };
    }, [
        parentContext,
        labelStack,
        segmentIdMap,
        interactionId
    ]);
    var hasMounted = (0, $5FkrB.useRef)(false);
    var onRender = (0, $5FkrB.useCallback)(function(_id, phase, actualDuration, baseDuration, startTime, commitTime) {
        var _getConfig;
        // Manually keep track of mount-phase, and ensure that every segment is always mounted at least once
        if ((_getConfig = (0, $DtLwq.getConfig)()) !== null && _getConfig !== void 0 && _getConfig.manuallyTrackReactProfilerMounts && !hasMounted.current) {
            interactionContext.onRender('mount', actualDuration, baseDuration, startTime, commitTime);
            hasMounted.current = true;
        } else interactionContext.onRender(phase, actualDuration, baseDuration, startTime, commitTime);
    }, [
        interactionContext
    ]);
    (0, $5FkrB.useEffect)(function() {
        (0, $iGolp.addSegment)(labelStack);
        return function() {
            (0, $iGolp.removeSegment)(labelStack);
        };
    }, [
        interactionId,
        parentContext,
        interactionContext,
        labelStack
    ]);
    var reactProfilerId = (0, $5FkrB.useMemo)(function() {
        return labelStack.map(function(l) {
            return l.name;
        }).join('/');
    }, [
        labelStack
    ]);
    var ufoSegment = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $bLIMX.default).Provider, {
        value: interactionContext
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $5FkrB.Profiler), {
        id: reactProfilerId,
        onRender: onRender
    }, children));
    if ((0, $9Zzpd.fg)('platform_ufo_ssr_render_profiler')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $3DeKi.default), {
        labelStack: labelStack,
        onRender: interactionContext.onRender
    }, ufoSegment);
    return ufoSegment;
}
$7ee2d474f4b84c7a$export$2e2bcd8739ae039.displayName = 'UFOSegment';

});
parcelRegister("4iVTn", function(module, exports) {
$parcel$export(module.exports, "default", () => $3225c00b9febbfdb$export$2e2bcd8739ae039);
/**
 * A random function that passes one in rate times.
 * E.g. coinflip(2) is the same as if you flipped a coin.
 * It will pass 50% of the time
 * @param rate The change that it will pass (1 in <rate> times)
 * @returns bool, if it passes or not
 */ function $3225c00b9febbfdb$var$coinflip(rate) {
    if (rate === 0) return false;
    else if (rate === 1) return true;
    else return Math.random() * rate <= 1;
}
var $3225c00b9febbfdb$export$2e2bcd8739ae039 = $3225c00b9febbfdb$var$coinflip;

});

parcelRegister("DtLwq", function(module, exports) {
$parcel$export(module.exports, "DEFAULT_TTVC_REVISION", () => $076abb7020acfb8b$export$f9bb3bb330fb9609);
$parcel$export(module.exports, "setUFOConfig", () => $076abb7020acfb8b$export$10d6139a8fb42158);
$parcel$export(module.exports, "getConfig", () => $076abb7020acfb8b$export$44487a86467333c3);
$parcel$export(module.exports, "isVCRevisionEnabled", () => $076abb7020acfb8b$export$4babcefc81a3ef0b);
$parcel$export(module.exports, "getMostRecentVCRevision", () => $076abb7020acfb8b$export$70184d6e2c753893);
$parcel$export(module.exports, "getReactHydrationStats", () => $076abb7020acfb8b$export$2d8f8d64dc343d7b);
$parcel$export(module.exports, "getInteractionRate", () => $076abb7020acfb8b$export$9466a8f085fa7d4e);
$parcel$export(module.exports, "getExperimentalInteractionRate", () => $076abb7020acfb8b$export$563f73272328c0d);
$parcel$export(module.exports, "getVCRawDataInteractionRate", () => $076abb7020acfb8b$export$48f4e0d964030a96);
$parcel$export(module.exports, "getPostInteractionRate", () => $076abb7020acfb8b$export$1d459f020c06ae34);
$parcel$export(module.exports, "getCapabilityRate", () => $076abb7020acfb8b$export$29b9ffb14861a1d);
$parcel$export(module.exports, "getExtraInteractionRate", () => $076abb7020acfb8b$export$203bd06a99c66a0d);
$parcel$export(module.exports, "getAwaitBM3TTIList", () => $076abb7020acfb8b$export$2d311b3fd18dcab1);
$parcel$export(module.exports, "getUfoNameOverrides", () => $076abb7020acfb8b$export$4f4649ef27b6f5d6);
$parcel$export(module.exports, "getMinorInteractions", () => $076abb7020acfb8b$export$b150ddad71c80d77);
$parcel$export(module.exports, "getDoNotAbortActivePressInteraction", () => $076abb7020acfb8b$export$3c170167645a0eff);
$parcel$export(module.exports, "getDoNotAbortActivePressInteractionOnTransition", () => $076abb7020acfb8b$export$d6dc9444bd15f70f);
$parcel$export(module.exports, "getFinishInteractionOnTransition", () => $076abb7020acfb8b$export$20e8108b8ccdd0bd);
$parcel$export(module.exports, "getInteractionTimeout", () => $076abb7020acfb8b$export$c681731847989445);

var $fC8ib = parcelRequire("fC8ib");

var $25nEq = parcelRequire("25nEq");

var $ekGgq = parcelRequire("ekGgq");

var $9Zzpd = parcelRequire("9Zzpd");
function $076abb7020acfb8b$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $076abb7020acfb8b$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $076abb7020acfb8b$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $076abb7020acfb8b$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $076abb7020acfb8b$var$config;
var $076abb7020acfb8b$export$f9bb3bb330fb9609 = 'fy25.03';
var $076abb7020acfb8b$export$d50dacda7fe6392b = 1000;
function $076abb7020acfb8b$export$10d6139a8fb42158(newConfig) {
    var _newConfig$vc;
    // Handle edge cases with `enabledVCRevisions`
    var _ref = (_newConfig$vc = newConfig === null || newConfig === void 0 ? void 0 : newConfig.vc) !== null && _newConfig$vc !== void 0 ? _newConfig$vc : {}, enabledVCRevisions = _ref.enabledVCRevisions;
    if ((0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(enabledVCRevisions === null || enabledVCRevisions === void 0 ? void 0 : enabledVCRevisions.byExperience) === 'object') $076abb7020acfb8b$var$config = $076abb7020acfb8b$var$_objectSpread($076abb7020acfb8b$var$_objectSpread({}, newConfig), {}, {
        vc: $076abb7020acfb8b$var$_objectSpread($076abb7020acfb8b$var$_objectSpread({}, newConfig.vc), {}, {
            enabledVCRevisions: {
                // enforce axiom about `enabledVCRevisions.all` config
                all: Array.from(new Set([
                    $076abb7020acfb8b$export$f9bb3bb330fb9609
                ].concat((0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(enabledVCRevisions === null || enabledVCRevisions === void 0 ? void 0 : enabledVCRevisions.all), (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(Object.values(enabledVCRevisions === null || enabledVCRevisions === void 0 ? void 0 : enabledVCRevisions.byExperience).flat())))),
                byExperience: $076abb7020acfb8b$var$_objectSpread({}, enabledVCRevisions === null || enabledVCRevisions === void 0 ? void 0 : enabledVCRevisions.byExperience)
            }
        })
    });
    else $076abb7020acfb8b$var$config = newConfig;
}
function $076abb7020acfb8b$export$44487a86467333c3() {
    return $076abb7020acfb8b$var$config;
}
var $076abb7020acfb8b$var$isValidConfigArray = function isValidConfigArray(array) {
    return Array.isArray(array) && array.length > 0;
};
function $076abb7020acfb8b$export$87fbc8e01b137811() {
    var experienceKey = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    try {
        var _config$vc;
        if (!$076abb7020acfb8b$var$config) return [];
        if ((_config$vc = $076abb7020acfb8b$var$config.vc) !== null && _config$vc !== void 0 && _config$vc.enabled) {
            var _config$vc2, _enabledVCRevisions$b;
            var _ref2 = (_config$vc2 = $076abb7020acfb8b$var$config.vc) !== null && _config$vc2 !== void 0 ? _config$vc2 : {}, enabledVCRevisions = _ref2.enabledVCRevisions;
            if ($076abb7020acfb8b$var$isValidConfigArray(enabledVCRevisions === null || enabledVCRevisions === void 0 || (_enabledVCRevisions$b = enabledVCRevisions.byExperience) === null || _enabledVCRevisions$b === void 0 ? void 0 : _enabledVCRevisions$b[experienceKey])) {
                var _enabledVCRevisions$b2;
                return (_enabledVCRevisions$b2 = enabledVCRevisions.byExperience) === null || _enabledVCRevisions$b2 === void 0 ? void 0 : _enabledVCRevisions$b2[experienceKey];
            }
            if ($076abb7020acfb8b$var$isValidConfigArray(enabledVCRevisions === null || enabledVCRevisions === void 0 ? void 0 : enabledVCRevisions.all)) return enabledVCRevisions.all;
            return [
                $076abb7020acfb8b$export$f9bb3bb330fb9609
            ];
        }
        return [];
    } catch (_unused) {
        return [];
    }
}
function $076abb7020acfb8b$export$4babcefc81a3ef0b(revision, experienceKey) {
    return $076abb7020acfb8b$export$87fbc8e01b137811(experienceKey).includes(revision);
}
function $076abb7020acfb8b$export$70184d6e2c753893() {
    var experienceKey = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    var enabledVCRevisions = $076abb7020acfb8b$export$87fbc8e01b137811(experienceKey);
    return enabledVCRevisions[enabledVCRevisions.length - 1];
}
function $076abb7020acfb8b$export$2d8f8d64dc343d7b() {
    if (!$076abb7020acfb8b$var$config) return undefined;
    try {
        var _config, _config$getReactHydra;
        var stats = (_config = $076abb7020acfb8b$var$config) === null || _config === void 0 || (_config$getReactHydra = _config.getReactHydrationStats) === null || _config$getReactHydra === void 0 ? void 0 : _config$getReactHydra.call(_config);
        return stats !== null && stats !== void 0 ? stats : undefined;
    } catch (e) {
        // eslint-disable-next-line no-console
        console.error('getReactHydrationStats threw an error: ', e);
        return undefined;
    }
}
function $076abb7020acfb8b$export$9466a8f085fa7d4e(name, interactionKind) {
    try {
        if (!$076abb7020acfb8b$var$config) return 0;
        var _config2 = $076abb7020acfb8b$var$config, killswitch = _config2.killswitch, rates = _config2.rates, rules = _config2.rules, kind = _config2.kind, autoGeneratedRate = _config2.autoGeneratedRate;
        if (killswitch != null) {
            // Specifically kill certain events
            if (killswitch.includes(name)) return 0;
        }
        var isUnknown = name === 'unknown';
        if (isUnknown) {
            if ((rates === null || rates === void 0 ? void 0 : rates[name]) != null) return rates[name];
            // Return default rate for unknown events when no explicit rate is configured
            return $076abb7020acfb8b$export$d50dacda7fe6392b;
        }
        if (rates != null) {
            // Decide the rate explicitly
            if (rates[name] != null) return rates[name];
        }
        if (rules != null) for(var i = 0; i < rules.length; i++){
            var rule = rules[i];
            var test = rule.test, rate = rule.rate;
            if (test != null && rate != null) {
                var regexp = new RegExp(test, 'ig');
                if (regexp.test(name)) return rate;
            }
        }
        var isAutogenerated = name === null || name === void 0 ? void 0 : name.startsWith('auto-generated');
        if (isAutogenerated) {
            var _rate = autoGeneratedRate;
            if (_rate != null) return _rate;
        }
        if (kind != null) {
            var _rate2 = kind[interactionKind];
            if (_rate2 != null) return _rate2;
        }
        return 0;
    } catch (e) {
        // Fallback
        return 0;
    }
}
function $076abb7020acfb8b$export$563f73272328c0d(name, interactionType) {
    try {
        if (!$076abb7020acfb8b$var$config) return 0;
        var _config3 = $076abb7020acfb8b$var$config, experimentalInteractionMetrics = _config3.experimentalInteractionMetrics;
        if (!(experimentalInteractionMetrics !== null && experimentalInteractionMetrics !== void 0 && experimentalInteractionMetrics.enabled)) return 0;
        if (experimentalInteractionMetrics.rates && typeof experimentalInteractionMetrics.rates[name] === 'number') return experimentalInteractionMetrics.rates[name];
        if (experimentalInteractionMetrics.kind && typeof experimentalInteractionMetrics.kind[interactionType] === 'number') return experimentalInteractionMetrics.kind[interactionType];
        return 0;
    } catch (e) {
        return 0;
    }
}
function $076abb7020acfb8b$export$48f4e0d964030a96(name, interactionType) {
    return $076abb7020acfb8b$var$getConfigRate(name, interactionType, 'enableVCRawDataRates');
}
function $076abb7020acfb8b$export$1d459f020c06ae34(name, interactionType) {
    return $076abb7020acfb8b$var$getConfigRate(name, interactionType, 'postInteractionLog');
}
function $076abb7020acfb8b$export$29b9ffb14861a1d(capability) {
    if ((0, $9Zzpd.fg)('platform_ufo_remove_deprecated_config_fields')) return 1;
    try {
        if (!$076abb7020acfb8b$var$config) return 0;
        var _config4 = $076abb7020acfb8b$var$config, capabilityRate = _config4.capability;
        if (capabilityRate != null) {
            var rate = capabilityRate[capability];
            if (rate != null) return rate;
        }
        return 0;
    } catch (_unused2) {
        return 0;
    }
}
function $076abb7020acfb8b$var$getConfigRate(name, interactionType, configName) {
    try {
        if (!$076abb7020acfb8b$var$config) return 0;
        var gotConfig = $076abb7020acfb8b$var$config[configName];
        if (!(gotConfig !== null && gotConfig !== void 0 && gotConfig.enabled)) return 0;
        if (interactionType !== 'page_load' && interactionType !== 'transition') return 0;
        if (gotConfig.rates && typeof gotConfig.rates[name] === 'number') return gotConfig.rates[name];
        if ('kind' in gotConfig && gotConfig.kind && typeof gotConfig.kind[interactionType] === 'number') return gotConfig.kind[interactionType];
        return 0;
    } catch (e) {
        return 0;
    }
}
function $076abb7020acfb8b$export$203bd06a99c66a0d(name, interactionType) {
    return $076abb7020acfb8b$var$getConfigRate(name, interactionType, 'extraInteractionMetrics');
}
var $076abb7020acfb8b$var$validTypingMethods = [
    'timeout',
    'timeoutNoAlloc',
    'mutationObserver'
];
function $076abb7020acfb8b$export$7e32aae12bf9b50f() {
    var defaultMethod = 'timeout';
    try {
        if (!$076abb7020acfb8b$var$config) return defaultMethod;
        var _config5 = $076abb7020acfb8b$var$config, typingMethod = _config5.typingMethod;
        if (typingMethod != null && $076abb7020acfb8b$var$validTypingMethods.find(function(m) {
            return m === typingMethod;
        })) return typingMethod;
        else return defaultMethod;
    } catch (e) {
        return defaultMethod;
    }
}
function $076abb7020acfb8b$export$2d311b3fd18dcab1() {
    try {
        if (!$076abb7020acfb8b$var$config) return [];
        var _config6 = $076abb7020acfb8b$var$config, awaitBM3TTI = _config6.awaitBM3TTI;
        if (awaitBM3TTI != null) return awaitBM3TTI;
        else return [];
    } catch (e) {
        return [];
    }
}
function $076abb7020acfb8b$export$4f4649ef27b6f5d6() {
    try {
        if (!$076abb7020acfb8b$var$config) return undefined;
        var _config7 = $076abb7020acfb8b$var$config, ufoNameOverrides = _config7.ufoNameOverrides;
        if (ufoNameOverrides != null) return ufoNameOverrides;
        return undefined;
    } catch (e) {
        return undefined;
    }
}
function $076abb7020acfb8b$export$b150ddad71c80d77() {
    try {
        if (!$076abb7020acfb8b$var$config) return undefined;
        var _config8 = $076abb7020acfb8b$var$config, minorInteractions = _config8.minorInteractions;
        return minorInteractions;
    } catch (e) {
        return undefined;
    }
}
function $076abb7020acfb8b$export$3c170167645a0eff() {
    try {
        if (!$076abb7020acfb8b$var$config) return undefined;
        var _config9 = $076abb7020acfb8b$var$config, doNotAbortActivePressInteraction = _config9.doNotAbortActivePressInteraction;
        return doNotAbortActivePressInteraction;
    } catch (e) {
        return undefined;
    }
}
function $076abb7020acfb8b$export$d6dc9444bd15f70f() {
    try {
        if (!$076abb7020acfb8b$var$config) return undefined;
        var _config0 = $076abb7020acfb8b$var$config, doNotAbortActivePressInteractionOnTransition = _config0.doNotAbortActivePressInteractionOnTransition;
        return doNotAbortActivePressInteractionOnTransition;
    } catch (e) {
        return undefined;
    }
}
function $076abb7020acfb8b$export$20e8108b8ccdd0bd() {
    try {
        if (!$076abb7020acfb8b$var$config) return undefined;
        var _config1 = $076abb7020acfb8b$var$config, finishInteractionOnTransition = _config1.finishInteractionOnTransition;
        return finishInteractionOnTransition;
    } catch (e) {
        return undefined;
    }
}
var $076abb7020acfb8b$export$2a8604960d7d23d9 = 60000;
function $076abb7020acfb8b$export$c681731847989445(ufoName) {
    try {
        if (!$076abb7020acfb8b$var$config) return $076abb7020acfb8b$export$2a8604960d7d23d9;
        var _config10 = $076abb7020acfb8b$var$config, interactionTimeout = _config10.interactionTimeout;
        if (interactionTimeout != null && interactionTimeout[ufoName] != null) return interactionTimeout[ufoName];
        if (interactionTimeout != null && interactionTimeout.__globalInteractionTimeout != null) return interactionTimeout.__globalInteractionTimeout;
        else return $076abb7020acfb8b$export$2a8604960d7d23d9;
    } catch (e) {
        return $076abb7020acfb8b$export$2a8604960d7d23d9;
    }
}

});

parcelRegister("6K0Mp", function(module, exports) {
$parcel$export(module.exports, "setInteractionActiveTrace", () => $4e87a4d3cda276e6$export$f2e521e495a88544);
$parcel$export(module.exports, "setActiveTrace", () => $4e87a4d3cda276e6$export$a1002be327997103);
$parcel$export(module.exports, "getActiveTrace", () => $4e87a4d3cda276e6$export$b6ac780db3a3cc77);
$parcel$export(module.exports, "clearActiveTrace", () => $4e87a4d3cda276e6$export$17ab21d7be720b);
$parcel$export(module.exports, "getActiveTraceHttpRequestHeaders", () => $4e87a4d3cda276e6$export$6e17cce6446848f9);

var $1mvl8 = parcelRequire("1mvl8");
var $4e87a4d3cda276e6$var$state = {
    context: null
};
function $4e87a4d3cda276e6$export$295213bc4d0c54ad() {
    return Array.from(new Array(16), function() {
        return Math.floor(Math.random() * 16).toString(16);
    }).join('');
}
function $4e87a4d3cda276e6$export$f2e521e495a88544(interactionId, experienceType) {
    $4e87a4d3cda276e6$export$a1002be327997103(interactionId.replace(/-/g, ''), $4e87a4d3cda276e6$export$295213bc4d0c54ad(), experienceType);
}
function $4e87a4d3cda276e6$export$a1002be327997103(traceId, spanId, type) {
    $4e87a4d3cda276e6$var$state.context = {
        traceId: traceId,
        spanId: spanId,
        type: type
    };
}
function $4e87a4d3cda276e6$export$b6ac780db3a3cc77() {
    return $4e87a4d3cda276e6$var$state.context || undefined;
}
function $4e87a4d3cda276e6$export$17ab21d7be720b() {
    $4e87a4d3cda276e6$var$state.context = null;
}
function $4e87a4d3cda276e6$export$6e17cce6446848f9(_url) {
    if ($4e87a4d3cda276e6$var$state.context === null) return null;
    var _state$context = $4e87a4d3cda276e6$var$state.context, traceId = _state$context.traceId, spanId = _state$context.spanId;
    return (0, $1mvl8.makeTraceHttpRequestHeaders)(traceId, spanId);
}
function $4e87a4d3cda276e6$export$a1e7396778592551(_url) {
    var traceHeaders = $4e87a4d3cda276e6$export$6e17cce6446848f9();
    return traceHeaders ? new URLSearchParams(traceHeaders).toString().toLowerCase() : null;
}

});
parcelRegister("1mvl8", function(module, exports) {
$parcel$export(module.exports, "makeTraceHttpRequestHeaders", () => $0fe027fe1abbcfa5$export$1115c5277eb10d5e);
function $0fe027fe1abbcfa5$export$1115c5277eb10d5e(traceId, spanId) {
    return {
        'X-B3-TraceId': traceId,
        'X-B3-SpanId': spanId
    };
}

});


parcelRegister("iGolp", function(module, exports) {
$parcel$export(module.exports, "postInteractionLog", () => $d99f08815d91a46e$export$d8f52e8f804021e8);
$parcel$export(module.exports, "interactionExtraMetrics", () => $d99f08815d91a46e$export$481f88116dc8b7ad);
$parcel$export(module.exports, "segmentUnmountCache", () => $d99f08815d91a46e$export$a2b14406ded37d60);
$parcel$export(module.exports, "getActiveInteraction", () => $d99f08815d91a46e$export$2b3954d2e8509985);
$parcel$export(module.exports, "remove", () => $d99f08815d91a46e$export$cd7f480d6b8286c3);
$parcel$export(module.exports, "updatePageLoadInteractionName", () => $d99f08815d91a46e$export$f6f1cf5bedf83c71);
$parcel$export(module.exports, "addCustomData", () => $d99f08815d91a46e$export$e4380431c2bdabee);
$parcel$export(module.exports, "addCustomTiming", () => $d99f08815d91a46e$export$27cacb7d7f3fe20a);
$parcel$export(module.exports, "addMark", () => $d99f08815d91a46e$export$728e28c22a0fba4);
$parcel$export(module.exports, "markFirstSegmentLoad", () => $d99f08815d91a46e$export$85d1eb835f669bf);
$parcel$export(module.exports, "addSpan", () => $d99f08815d91a46e$export$2c1d6e17cfa9bbc7);
$parcel$export(module.exports, "addHold", () => $d99f08815d91a46e$export$7606887303596f82);
$parcel$export(module.exports, "addHoldByID", () => $d99f08815d91a46e$export$10582acd678c213);
$parcel$export(module.exports, "removeHoldByID", () => $d99f08815d91a46e$export$4983dfbbb996f7ae);
$parcel$export(module.exports, "getCurrentInteractionType", () => $d99f08815d91a46e$export$2df109852219d16e);
$parcel$export(module.exports, "addProfilerTimings", () => $d99f08815d91a46e$export$53d6f611de951a13);
$parcel$export(module.exports, "sinkInteractionHandler", () => $d99f08815d91a46e$export$9e614a29a1ac213e);
$parcel$export(module.exports, "sinkPostInteractionLogHandler", () => $d99f08815d91a46e$export$8a1ba7bef607358a);
$parcel$export(module.exports, "tryComplete", () => $d99f08815d91a46e$export$673be905888f8839);
$parcel$export(module.exports, "abort", () => $d99f08815d91a46e$export$5def58af4fd46132);
$parcel$export(module.exports, "abortByNewInteraction", () => $d99f08815d91a46e$export$c4a545284f55edf2);
$parcel$export(module.exports, "abortAll", () => $d99f08815d91a46e$export$614a7af2affc5dff);
$parcel$export(module.exports, "addOnCancelCallback", () => $d99f08815d91a46e$export$7b9261a96cfe427b);
$parcel$export(module.exports, "addNewInteraction", () => $d99f08815d91a46e$export$1a1ed1e1fdb2006b);
$parcel$export(module.exports, "addApdex", () => $d99f08815d91a46e$export$35220fd6cdd1b731);
$parcel$export(module.exports, "addRequestInfo", () => $d99f08815d91a46e$export$57d55b4569823d8f);
$parcel$export(module.exports, "addSegment", () => $d99f08815d91a46e$export$1c43f9ac826b6462);
$parcel$export(module.exports, "removeSegment", () => $d99f08815d91a46e$export$d0365e48b58231c3);
$parcel$export(module.exports, "interactionSpans", () => $d99f08815d91a46e$export$6ce04c7ca6810a7e);
$parcel$export(module.exports, "addCustomSpans", () => $d99f08815d91a46e$export$5342dcad19138a1c);

var $fL8KA = parcelRequire("fL8KA");

var $iYJcE = parcelRequire("iYJcE");

var $25nEq = parcelRequire("25nEq");

var $fC8ib = parcelRequire("fC8ib");

var $6HG4S = parcelRequire("6HG4S");

var $6JfQX = parcelRequire("6JfQX");

var $9Zzpd = parcelRequire("9Zzpd");

var $4iVTn = parcelRequire("4iVTn");

var $DtLwq = parcelRequire("DtLwq");

var $eEwI0 = parcelRequire("eEwI0");

var $az8pZ = parcelRequire("az8pZ");

var $e8igD = parcelRequire("e8igD");

var $6K0Mp = parcelRequire("6K0Mp");

var $8qy01 = parcelRequire("8qy01");

var $gITbN = parcelRequire("gITbN");

var $avBPK = parcelRequire("avBPK");

var $aNUZN = parcelRequire("aNUZN");

var $ltzs9 = parcelRequire("ltzs9");

var $78Mn6 = parcelRequire("78Mn6");
function $d99f08815d91a46e$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $d99f08815d91a46e$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $d99f08815d91a46e$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $d99f08815d91a46e$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $d99f08815d91a46e$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $d99f08815d91a46e$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $d99f08815d91a46e$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $d99f08815d91a46e$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $d99f08815d91a46e$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $d99f08815d91a46e$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
var $d99f08815d91a46e$var$PreviousInteractionLog = {
    name: undefined,
    isAborted: undefined
};
var $d99f08815d91a46e$export$d8f52e8f804021e8 = new (0, $78Mn6.default)();
var $d99f08815d91a46e$export$481f88116dc8b7ad = new (0, $ltzs9.default)();
var $d99f08815d91a46e$var$interactionQueue = [];
var $d99f08815d91a46e$var$segmentCache = new Map();
var $d99f08815d91a46e$export$a2b14406ded37d60 = new Map(); // Temporarily store segment unmount counts
var $d99f08815d91a46e$var$firstSegmentLoadMarked = false;
var $d99f08815d91a46e$var$segmentObservers = [];
function $d99f08815d91a46e$export$2b3954d2e8509985() {
    var interactionId = (0, $gITbN.getInteractionId)();
    if (!interactionId.current) return;
    return (0, $aNUZN.interactions).get(interactionId.current);
}
function $d99f08815d91a46e$var$isPerformanceTracingEnabled() {
    var _getConfig;
    return ((_getConfig = (0, $DtLwq.getConfig)()) === null || _getConfig === void 0 ? void 0 : _getConfig.enableAdditionalPerformanceMarks) || window.__REACT_UFO_ENABLE_PERF_TRACING || false;
}
var $d99f08815d91a46e$var$performanceEventObserver;
var $d99f08815d91a46e$export$17afbba0f16b4b19 = function getPerformanceObserver() {
    $d99f08815d91a46e$var$performanceEventObserver = $d99f08815d91a46e$var$performanceEventObserver || new PerformanceObserver(function(entries) {
        var list = entries.getEntries();
        var _iterator = $d99f08815d91a46e$var$_createForOfIteratorHelper(list), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var entry = _step.value;
                if (entry.name === 'click') $d99f08815d91a46e$export$e6be05b411ce21a6(entry);
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
    });
    return $d99f08815d91a46e$var$performanceEventObserver;
};
var $d99f08815d91a46e$export$e6be05b411ce21a6 = function setInteractionPerformanceEvent(entry) {
    var interaction = $d99f08815d91a46e$export$2b3954d2e8509985();
    if ((interaction === null || interaction === void 0 ? void 0 : interaction.type) === 'press') {
        var responsiveness = interaction.responsiveness || {};
        // if happens there is another event interaction that has started after
        // the initial one, we don't want to replace the values if they have already
        // been set up
        responsiveness.experimentalInputToNextPaint = responsiveness.experimentalInputToNextPaint || entry.duration;
        responsiveness.inputDelay = responsiveness.experimentalInputToNextPaint || entry.processingStart - entry.startTime;
        interaction.responsiveness = responsiveness;
        // if the entry start time is lower than the one in the interaction
        // it means the interaction start time is not accurate, we assign
        // this value which will match the timestamp in the event
        if (entry.startTime < interaction.start) interaction.start = entry.startTime;
    }
};
function $d99f08815d91a46e$var$labelStackToString(labelStack, name) {
    var _stack$map;
    var stack = (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(labelStack !== null && labelStack !== void 0 ? labelStack : []);
    if (name) stack.push({
        name: name
    });
    return (_stack$map = stack.map(function(l) {
        return l.name;
    })) === null || _stack$map === void 0 ? void 0 : _stack$map.join('/');
}
function $d99f08815d91a46e$var$labelStackToIdString(labelStack) {
    var _labelStack$map;
    return labelStack === null || labelStack === void 0 || (_labelStack$map = labelStack.map(function(l) {
        return 'segmentId' in l ? "".concat(l.name, ":").concat(l.segmentId) : "".concat(l.name);
    })) === null || _labelStack$map === void 0 ? void 0 : _labelStack$map.join('/');
}
function $d99f08815d91a46e$var$addSegmentObserver(observer) {
    $d99f08815d91a46e$var$segmentObservers.push(observer);
    var _iterator2 = $d99f08815d91a46e$var$_createForOfIteratorHelper($d99f08815d91a46e$var$segmentCache.values()), _step2;
    try {
        for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
            var segmentInfo = _step2.value;
            observer.onAdd(segmentInfo);
        }
    } catch (err) {
        _iterator2.e(err);
    } finally{
        _iterator2.f();
    }
}
function $d99f08815d91a46e$var$removeSegmentObserver(observer) {
    var index = $d99f08815d91a46e$var$segmentObservers.findIndex(function(obs) {
        return obs === observer;
    });
    if (index !== -1) $d99f08815d91a46e$var$segmentObservers.splice(index, 1);
}
function $d99f08815d91a46e$export$cd7f480d6b8286c3(interactionId) {
    (0, $aNUZN.interactions).delete(interactionId);
}
function $d99f08815d91a46e$export$f6f1cf5bedf83c71(ufoName) {
    var routeName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ufoName;
    var interaction = $d99f08815d91a46e$export$2b3954d2e8509985();
    if (!interaction || interaction.type !== 'page_load' && interaction.type !== 'transition') return;
    interaction.ufoName = ufoName;
    interaction.routeName = routeName;
}
function $d99f08815d91a46e$export$12f2b6cb85d59904(interactionId, data) {
    var interaction = (0, $aNUZN.interactions).get(interactionId);
    if (interaction != null) Object.keys(data).forEach(function(key) {
        interaction.metaData[key] = data[key];
    });
}
function $d99f08815d91a46e$export$e4380431c2bdabee(interactionId, labelStack, data) {
    var interaction = (0, $aNUZN.interactions).get(interactionId);
    if (interaction != null) Object.keys(data).forEach(function(i) {
        interaction.customData.push({
            labelStack: labelStack,
            data: (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, i, data[i])
        });
    });
}
function $d99f08815d91a46e$export$20265b12c6625451(interactionId, key, value) {
    var interaction = (0, $aNUZN.interactions).get(interactionId);
    if (interaction == null) return;
    // Allow null and undefined values
    if (value === null || value === undefined) {
        interaction.cohortingCustomData.set(key, value);
        return;
    }
    // Validate that the value is a primitive (number, boolean, or string)
    if (typeof value !== 'number' && typeof value !== 'boolean' && typeof value !== 'string') return;
    // Validate string length (max 50 characters)
    if (typeof value === 'string' && value.length > 50) return;
    interaction.cohortingCustomData.set(key, value);
}
function $d99f08815d91a46e$export$27cacb7d7f3fe20a(interactionId, labelStack, data) {
    var interaction = (0, $aNUZN.interactions).get(interactionId);
    if (interaction != null) {
        interaction.customTimings.push({
            labelStack: labelStack,
            data: data
        });
        if ($d99f08815d91a46e$var$isPerformanceTracingEnabled()) for(var _i = 0, _Object$entries = Object.entries(data); _i < _Object$entries.length; _i++){
            var _Object$entries$_i = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_Object$entries[_i], 2), key = _Object$entries$_i[0], timingData = _Object$entries$_i[1];
            var startTime = timingData.startTime, endTime = timingData.endTime;
            try {
                // for Firefox 102 and older
                performance.measure("\uD83D\uDEF8 ".concat($d99f08815d91a46e$var$labelStackToString(labelStack, key), " [custom_timing]"), {
                    start: startTime,
                    end: endTime,
                    detail: {
                        devtools: {
                            track: "\uD83D\uDEF8 reactUFO detailed timings",
                            color: 'tertiary-light'
                        }
                    }
                });
            } catch (e) {
            // do nothing
            }
        }
    }
}
function $d99f08815d91a46e$export$728e28c22a0fba4(interactionId, type, name, labelStack) {
    var time = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : performance.now();
    var interaction = (0, $aNUZN.interactions).get(interactionId);
    if (interaction != null) interaction.marks.push({
        type: type,
        name: name,
        labelStack: labelStack,
        time: time
    });
    if ($d99f08815d91a46e$var$isPerformanceTracingEnabled()) performance.mark("\uD83D\uDEF8 ".concat($d99f08815d91a46e$var$labelStackToString(labelStack, name), " [").concat(type, "]"), {
        startTime: time
    });
}
function $d99f08815d91a46e$export$85d1eb835f669bf(interactionId, labelStack) {
    var time = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : performance.now();
    if (!(0, $9Zzpd.fg)('platform_mark_ufo_segment_first_load')) return;
    var interaction = (0, $aNUZN.interactions).get(interactionId);
    if (interaction != null && !$d99f08815d91a46e$var$firstSegmentLoadMarked) {
        $d99f08815d91a46e$var$firstSegmentLoadMarked = true;
        interaction.marks.push({
            type: 'first_segment_load',
            name: 'first_segment_load',
            labelStack: labelStack,
            time: time
        });
    }
}
function $d99f08815d91a46e$export$c4b23cc624bd2fb(type, name, labelStack) {
    var time = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : performance.now();
    (0, $aNUZN.interactions).forEach(function(interaction) {
        interaction.marks.push({
            type: type,
            name: name,
            labelStack: labelStack,
            time: time
        });
    });
    if ($d99f08815d91a46e$var$isPerformanceTracingEnabled()) performance.mark("\uD83D\uDEF8 ".concat($d99f08815d91a46e$var$labelStackToString(labelStack, name), " [").concat(type, "]"), {
        startTime: time
    });
}
function $d99f08815d91a46e$export$2c1d6e17cfa9bbc7(interactionId, type, name, labelStack, start) {
    var end = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : performance.now();
    var size = arguments.length > 6 ? arguments[6] : undefined;
    var interaction = (0, $aNUZN.interactions).get(interactionId);
    if (interaction != null) {
        interaction.spans.push({
            type: type,
            name: name,
            labelStack: labelStack,
            start: start,
            end: end,
            size: size
        });
        if ($d99f08815d91a46e$var$isPerformanceTracingEnabled()) try {
            // for Firefox 102 and older
            performance.measure("\uD83D\uDEF8 ".concat($d99f08815d91a46e$var$labelStackToString(labelStack, name), " [").concat(type, "]"), {
                start: start,
                end: end,
                detail: {
                    devtools: {
                        track: "\uD83D\uDEF8 reactUFO detailed timings",
                        color: 'secondary'
                    }
                }
            });
        } catch (e) {
        // do nothing
        }
    }
}
function $d99f08815d91a46e$export$943a8b2b5d6b1809(type, name, labelStack, start) {
    var end = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : performance.now();
    var size = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 0;
    (0, $aNUZN.interactions).forEach(function(interaction) {
        interaction.spans.push({
            type: type,
            name: name,
            labelStack: labelStack,
            start: start,
            end: end,
            size: size
        });
    });
    if ($d99f08815d91a46e$var$isPerformanceTracingEnabled()) try {
        // for Firefox 102 and older
        performance.measure("\uD83D\uDEF8 ".concat($d99f08815d91a46e$var$labelStackToString(labelStack, name), " [").concat(type, "]"), {
            start: start,
            end: end,
            detail: {
                devtools: {
                    track: "\uD83D\uDEF8 reactUFO detailed timings",
                    color: 'secondary'
                }
            }
        });
    } catch (e) {
    // do nothing
    }
}
function $d99f08815d91a46e$export$9e04fe1a58571ec(moduleId, timestamp) {
    $d99f08815d91a46e$export$c4b23cc624bd2fb('bundle_preload', moduleId, null, timestamp);
}
function $d99f08815d91a46e$export$6f228d1fdc911d7(identifier, start, end) {
    $d99f08815d91a46e$export$943a8b2b5d6b1809('bundle_load', identifier, null, start, end - start);
}
var $d99f08815d91a46e$var$moduleLoadingRequests = {};
function $d99f08815d91a46e$export$f5a8f10de74904da(input) {
    var result = input !== null && input !== void 0 ? input : '';
    result = result.replace(/^\.\/src\/packages\//, '');
    result = result.replace(/^\.\/node_modules\//, '');
    result = result.replace(/(\/src)?\/(index|main)\.(tsx|ts|js|jsx)$/, '');
    return result;
}
function $d99f08815d91a46e$var$addHoldCriterion(id, labelStack, name, startTime) {
    var _window$__CRITERION__;
    if (!((_window$__CRITERION__ = window.__CRITERION__) !== null && _window$__CRITERION__ !== void 0 && _window$__CRITERION__.addUFOHold)) return;
    window.__CRITERION__.addUFOHold(id, $d99f08815d91a46e$var$labelStackToString(labelStack), name, startTime);
}
function $d99f08815d91a46e$var$removeHoldCriterion(id) {
    var _window$__CRITERION__2;
    if (!((_window$__CRITERION__2 = window.__CRITERION__) !== null && _window$__CRITERION__2 !== void 0 && _window$__CRITERION__2.removeUFOHold)) return;
    window.__CRITERION__.removeUFOHold(id);
}
function $d99f08815d91a46e$export$7606887303596f82(interactionId, labelStack, name, experimental) {
    var interaction = (0, $aNUZN.interactions).get(interactionId);
    // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
    var id = (0, $6JfQX.default)();
    if (!interaction && (0, $9Zzpd.fg)('platform_ufo_enable_late_holds_post_interaction')) // add hold timestamp to post interaction log if interaction is complete
    $d99f08815d91a46e$export$d8f52e8f804021e8.addHoldInfo(labelStack, name, performance.now());
    if (interaction != null) {
        var start = performance.now();
        var holdActive = {
            labelStack: labelStack,
            name: name,
            start: start
        };
        if ((0, $9Zzpd.fg)('platform_ufo_enable_ttai_with_3p')) {
            var is3pHold = labelStack.some(function(l) {
                return 'type' in l && l.type === 'third-party';
            });
            if (is3pHold) {
                if (!interaction.hold3pActive) interaction.hold3pActive = new Map();
                interaction.hold3pActive.set(id, $d99f08815d91a46e$var$_objectSpread($d99f08815d91a46e$var$_objectSpread({}, holdActive), {}, {
                    start: start
                }));
            } else {
                interaction.holdActive.set(id, $d99f08815d91a46e$var$_objectSpread($d99f08815d91a46e$var$_objectSpread({}, holdActive), {}, {
                    start: start
                }));
                $d99f08815d91a46e$var$addHoldCriterion(id, labelStack, name, start);
            }
        } else {
            var _getConfig2;
            if ((_getConfig2 = (0, $DtLwq.getConfig)()) !== null && _getConfig2 !== void 0 && (_getConfig2 = _getConfig2.experimentalInteractionMetrics) !== null && _getConfig2 !== void 0 && _getConfig2.enabled && experimental) interaction.holdExpActive.set(id, $d99f08815d91a46e$var$_objectSpread($d99f08815d91a46e$var$_objectSpread({}, holdActive), {}, {
                start: start
            }));
            if (!experimental) interaction.holdActive.set(id, $d99f08815d91a46e$var$_objectSpread($d99f08815d91a46e$var$_objectSpread({}, holdActive), {}, {
                start: start
            }));
            $d99f08815d91a46e$var$addHoldCriterion(id, labelStack, name, start);
        }
        return function() {
            var end = performance.now();
            if ($d99f08815d91a46e$var$isPerformanceTracingEnabled()) try {
                // for Firefox 102 and older
                performance.measure("\uD83D\uDEF8 ".concat($d99f08815d91a46e$var$labelStackToString(labelStack, name), " [hold]"), {
                    start: start,
                    end: end,
                    detail: {
                        devtools: {
                            track: "\uD83D\uDEF8 reactUFO detailed timings",
                            color: 'secondary-light'
                        }
                    }
                });
            } catch (e) {
            // do nothing
            }
            $d99f08815d91a46e$var$removeHoldCriterion(id);
            var currentInteraction = (0, $aNUZN.interactions).get(interactionId);
            var currentHold = interaction.holdActive.get(id);
            var expHold = interaction.holdExpActive.get(id);
            if (currentInteraction != null) {
                if (currentHold != null) {
                    currentInteraction.holdInfo.push($d99f08815d91a46e$var$_objectSpread($d99f08815d91a46e$var$_objectSpread({}, currentHold), {}, {
                        end: end
                    }));
                    interaction.holdActive.delete(id);
                }
                if (expHold != null) {
                    currentInteraction.holdExpInfo.push($d99f08815d91a46e$var$_objectSpread($d99f08815d91a46e$var$_objectSpread({}, expHold), {}, {
                        end: end
                    }));
                    interaction.holdExpActive.delete(id);
                }
                if ((0, $9Zzpd.fg)('platform_ufo_enable_ttai_with_3p')) {
                    if (interaction.hold3pActive) {
                        var current3pHold = interaction.hold3pActive.get(id);
                        if (current3pHold != null) {
                            if (!currentInteraction.hold3pInfo) currentInteraction.hold3pInfo = [];
                            currentInteraction.hold3pInfo.push($d99f08815d91a46e$var$_objectSpread($d99f08815d91a46e$var$_objectSpread({}, current3pHold), {}, {
                                end: end
                            }));
                            interaction.hold3pActive.delete(id);
                        }
                    }
                }
            }
        };
    }
    return function() {};
}
function $d99f08815d91a46e$export$10582acd678c213(interactionId, labelStack, name, id, ignoreOnSubmit) {
    var interaction = (0, $aNUZN.interactions).get(interactionId);
    if (interaction != null) {
        var start = performance.now();
        if ((0, $9Zzpd.fg)('platform_ufo_enable_ttai_with_3p')) {
            var is3pHold = labelStack.some(function(l) {
                return 'type' in l && l.type === 'third-party';
            });
            if (is3pHold) {
                if (!interaction.hold3pActive) interaction.hold3pActive = new Map();
                interaction.hold3pActive.set(id, {
                    labelStack: labelStack,
                    name: name,
                    start: start,
                    ignoreOnSubmit: ignoreOnSubmit
                });
            } else {
                interaction.holdActive.set(id, {
                    labelStack: labelStack,
                    name: name,
                    start: start,
                    ignoreOnSubmit: ignoreOnSubmit
                });
                $d99f08815d91a46e$var$addHoldCriterion(id, labelStack, name, start);
            }
        } else {
            interaction.holdActive.set(id, {
                labelStack: labelStack,
                name: name,
                start: start,
                ignoreOnSubmit: ignoreOnSubmit
            });
            $d99f08815d91a46e$var$addHoldCriterion(id, labelStack, name, start);
        }
    }
    return function() {};
}
function $d99f08815d91a46e$export$4983dfbbb996f7ae(interactionId, id) {
    var interaction = (0, $aNUZN.interactions).get(interactionId);
    if (interaction != null) {
        var end = performance.now();
        var currentInteraction = (0, $aNUZN.interactions).get(interactionId);
        var currentHold = interaction.holdActive.get(id);
        if (currentInteraction != null && currentHold != null) {
            currentInteraction.holdInfo.push($d99f08815d91a46e$var$_objectSpread($d99f08815d91a46e$var$_objectSpread({}, currentHold), {}, {
                end: end
            }));
            interaction.holdActive.delete(id);
            $d99f08815d91a46e$var$removeHoldCriterion(id);
        }
        if ((0, $9Zzpd.fg)('platform_ufo_enable_ttai_with_3p')) {
            if (interaction.hold3pActive) {
                var current3pHold = interaction.hold3pActive.get(id);
                if (currentInteraction != null && current3pHold != null) {
                    if (!currentInteraction.hold3pInfo) currentInteraction.hold3pInfo = [];
                    currentInteraction.hold3pInfo.push($d99f08815d91a46e$var$_objectSpread($d99f08815d91a46e$var$_objectSpread({}, current3pHold), {}, {
                        end: end
                    }));
                    interaction.hold3pActive.delete(id);
                }
            }
        }
    }
}
function $d99f08815d91a46e$export$2df109852219d16e(interactionId) {
    var interaction = (0, $aNUZN.interactions).get(interactionId);
    if (interaction) return interaction.type;
    return null;
}
var $d99f08815d91a46e$export$9591b52b33ccc510 = {
    onPreload: function onPreload(moduleId, _priority) {
        $d99f08815d91a46e$export$9e04fe1a58571ec($d99f08815d91a46e$export$f5a8f10de74904da(moduleId), performance.now());
    },
    onLoadStart: function onLoadStart(info) {
        var timeoutId = setTimeout(function() {
            delete $d99f08815d91a46e$var$moduleLoadingRequests[info.identifier];
        }, 30000);
        var request = {
            start: performance.now(),
            timeoutId: timeoutId
        };
        $d99f08815d91a46e$var$moduleLoadingRequests[info.identifier] = request;
    },
    onLoadComplete: function onLoadComplete(info) {
        var request = $d99f08815d91a46e$var$moduleLoadingRequests[info.identifier];
        if (request) {
            clearTimeout(request.timeoutId);
            delete $d99f08815d91a46e$var$moduleLoadingRequests[info.identifier];
            $d99f08815d91a46e$export$6f228d1fdc911d7($d99f08815d91a46e$export$f5a8f10de74904da(info.identifier), request.start, performance.now());
        }
    },
    placeholderFallBackMounted: function placeholderFallBackMounted(id, moduleId) {
        var interactionId = (0, $gITbN.getInteractionId)();
        var currentInteractionId = interactionId.current;
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        $d99f08815d91a46e$export$10582acd678c213(currentInteractionId, [], moduleId, id);
    },
    placeholderFallBackUnmounted: function placeholderFallBackUnmounted(id) {
        var interactionId = (0, $gITbN.getInteractionId)();
        var currentInteractionId = interactionId.current;
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        $d99f08815d91a46e$export$4983dfbbb996f7ae(currentInteractionId, id);
    }
};
function $d99f08815d91a46e$export$239c33984d9b1367(interactionId, name, labelStack, errorType, errorMessage, errorStack, forcedError, errorHash, errorStatusCode) {
    var interaction = (0, $aNUZN.interactions).get(interactionId);
    if (interaction != null) interaction.errors.push({
        name: name,
        labelStack: labelStack,
        errorType: errorType,
        errorMessage: errorMessage,
        errorStack: errorStack,
        forcedError: forcedError,
        errorHash: errorHash,
        errorStatusCode: errorStatusCode
    });
}
function $d99f08815d91a46e$export$7379c15afd3840fa(name, labelStack, errorType, errorMessage, errorStack, errorHash, errorStatusCode) {
    (0, $aNUZN.interactions).forEach(function(interaction) {
        interaction.errors.push({
            name: name,
            labelStack: labelStack,
            errorType: errorType,
            errorMessage: errorMessage,
            errorStack: errorStack,
            errorHash: errorHash,
            errorStatusCode: errorStatusCode
        });
    });
}
function $d99f08815d91a46e$export$53d6f611de951a13(interactionId, labelStack, type, actualDuration, baseDuration, startTime, commitTime) {
    var _getConfig3;
    if ($d99f08815d91a46e$var$isPerformanceTracingEnabled()) try {
        // for Firefox 102 and older
        performance.measure("\uD83D\uDEF8 ".concat($d99f08815d91a46e$var$labelStackToString(labelStack), " [react-profiler] ").concat(type), {
            start: startTime,
            duration: actualDuration,
            detail: {
                devtools: {
                    track: "\uD83D\uDEF8 reactUFO detailed timings",
                    color: 'secondary-dark'
                }
            }
        });
    } catch (e) {
    // do nothing
    }
    var interaction = (0, $aNUZN.interactions).get(interactionId);
    if (interaction != null) interaction.reactProfilerTimings.push({
        labelStack: labelStack,
        type: type,
        actualDuration: actualDuration,
        baseDuration: baseDuration,
        startTime: startTime,
        commitTime: commitTime
    });
    else if ((_getConfig3 = (0, $DtLwq.getConfig)()) !== null && _getConfig3 !== void 0 && (_getConfig3 = _getConfig3.postInteractionLog) !== null && _getConfig3 !== void 0 && _getConfig3.enabled) $d99f08815d91a46e$export$d8f52e8f804021e8.addProfilerTimings(labelStack, type, actualDuration, baseDuration, startTime, commitTime);
}
function $d99f08815d91a46e$var$pushToQueue(id, data) {
    $d99f08815d91a46e$var$interactionQueue.push({
        id: id,
        data: data
    });
}
var $d99f08815d91a46e$var$handleInteraction = $d99f08815d91a46e$var$pushToQueue;
function $d99f08815d91a46e$var$callCleanUpCallbacks(interaction) {
    interaction.cleanupCallbacks.reverse().forEach(function(cleanUpCallback) {
        cleanUpCallback();
    });
}
function $d99f08815d91a46e$var$finishInteraction(id, data) {
    var _getConfig4;
    var endTime = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : performance.now();
    data.end = endTime;
    try {
        // for Firefox 102 and older
        performance.measure("\uD83D\uDEF8 [".concat(data.type, "] ").concat(data.ufoName, " [ttai]"), {
            start: data.start,
            end: data.end,
            detail: {
                devtools: {
                    track: 'main metrics',
                    trackGroup: "\uD83D\uDEF8 reactUFO metrics",
                    color: 'tertiary'
                }
            }
        });
        performance.mark("TTAI", {
            startTime: data.end,
            detail: {
                devtools: {
                    dataType: 'marker'
                }
            }
        });
    } catch (e) {
    // do nothing
    }
    if (data.featureFlags) data.featureFlags.during = Object.fromEntries((0, $8qy01.currentFeatureFlagsAccessed));
    (0, $6K0Mp.clearActiveTrace)();
    $d99f08815d91a46e$var$callCleanUpCallbacks(data);
    if ((_getConfig4 = (0, $DtLwq.getConfig)()) !== null && _getConfig4 !== void 0 && (_getConfig4 = _getConfig4.vc) !== null && _getConfig4 !== void 0 && _getConfig4.stopVCAtInteractionFinish) {
        // Use per-interaction VC observer if available, otherwise fall back to global
        var observer = data.vcObserver;
        if (observer) data.vc = observer.getVCRawData();
    }
    if (data.type === 'page_load') data.hydration = (0, $DtLwq.getReactHydrationStats)();
    // By this time, stop the post interaction log observer if coinflip rate is 0
    var sanitisedUfoName = (0, $e8igD.sanitizeUfoName)(data.ufoName);
    if (!(0, $4iVTn.default)((0, $DtLwq.getPostInteractionRate)(sanitisedUfoName, data.type))) $d99f08815d91a46e$export$d8f52e8f804021e8.stopVCObserver();
    if ((0, $9Zzpd.fg)('platform_ufo_enable_ttai_with_3p')) {
        var _sanitisedUfoName = (0, $e8igD.sanitizeUfoName)(data.ufoName);
        if (!(0, $4iVTn.default)((0, $DtLwq.getExtraInteractionRate)(_sanitisedUfoName, data.type))) $d99f08815d91a46e$export$481f88116dc8b7ad.stopAll(id);
        else if (!data.hold3pActive || data.hold3pActive.size === 0) {
            var _getConfig5;
            if (!((_getConfig5 = (0, $DtLwq.getConfig)()) !== null && _getConfig5 !== void 0 && (_getConfig5 = _getConfig5.experimentalInteractionMetrics) !== null && _getConfig5 !== void 0 && _getConfig5.enabled)) $d99f08815d91a46e$export$cd7f480d6b8286c3(id);
        }
    } else {
        var _getConfig6;
        if (!((_getConfig6 = (0, $DtLwq.getConfig)()) !== null && _getConfig6 !== void 0 && (_getConfig6 = _getConfig6.experimentalInteractionMetrics) !== null && _getConfig6 !== void 0 && _getConfig6.enabled)) $d99f08815d91a46e$export$cd7f480d6b8286c3(id);
    }
    $d99f08815d91a46e$var$PreviousInteractionLog.name = data.ufoName || 'unknown';
    $d99f08815d91a46e$var$PreviousInteractionLog.isAborted = data.abortReason != null;
    if (data.ufoName) {
        if ((0, $9Zzpd.fg)('platform_ufo_enable_ttai_with_3p')) {
            var _interactionExtraMetr;
            if (((_interactionExtraMetr = $d99f08815d91a46e$export$481f88116dc8b7ad.finishedInteraction) === null || _interactionExtraMetr === void 0 ? void 0 : _interactionExtraMetr.id) !== id) // If this same interaction was not already handled, handle it
            $d99f08815d91a46e$var$handleInteraction(id, data);
        } else $d99f08815d91a46e$var$handleInteraction(id, data);
    }
    if ($d99f08815d91a46e$var$isPerformanceTracingEnabled()) {
        var profilerTimingMap = new Map();
        data.reactProfilerTimings.forEach(function(profilerTiming) {
            var labelStackId = $d99f08815d91a46e$var$labelStackToIdString(profilerTiming.labelStack);
            if (labelStackId) {
                var _profilerTimingMap$ge, _timing$start, _timing$end;
                var timing = (_profilerTimingMap$ge = profilerTimingMap.get(labelStackId)) !== null && _profilerTimingMap$ge !== void 0 ? _profilerTimingMap$ge : {
                    labelStack: profilerTiming.labelStack
                };
                timing.start = profilerTiming.startTime < ((_timing$start = timing.start) !== null && _timing$start !== void 0 ? _timing$start : Number.MAX_SAFE_INTEGER) ? profilerTiming.startTime : timing.start;
                timing.end = profilerTiming.commitTime > ((_timing$end = timing.end) !== null && _timing$end !== void 0 ? _timing$end : Number.MIN_SAFE_INTEGER) ? profilerTiming.commitTime : timing.end;
                profilerTimingMap.set(labelStackId, timing);
            }
        });
        try {
            // for Firefox 102 and older
            var _iterator3 = $d99f08815d91a46e$var$_createForOfIteratorHelper(profilerTimingMap.entries()), _step3;
            try {
                for(_iterator3.s(); !(_step3 = _iterator3.n()).done;){
                    var _step3$value = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_step3.value, 2), _step3$value$ = _step3$value[1], labelStack = _step3$value$.labelStack, start = _step3$value$.start, end = _step3$value$.end;
                    performance.measure("\uD83D\uDEF8 ".concat($d99f08815d91a46e$var$labelStackToString(labelStack), " [segment_ttai]"), {
                        start: start,
                        end: end,
                        detail: {
                            devtools: {
                                track: "\uD83D\uDEF8 reactUFO detailed timings",
                                color: 'secondary-dark'
                            }
                        }
                    });
                }
            } catch (err) {
                _iterator3.e(err);
            } finally{
                _iterator3.f();
            }
        } catch (e) {
        // do nothing
        }
    }
    try {
        // dispatch a global window event to notify the measure is completed
        window.dispatchEvent(new CustomEvent('UFO_FINISH_INTERACTION', {
            detail: data
        }));
    } catch (error) {
    // do nothing
    }
}
function $d99f08815d91a46e$export$9e614a29a1ac213e(sinkFn) {
    if ($d99f08815d91a46e$var$handleInteraction === $d99f08815d91a46e$var$pushToQueue) {
        $d99f08815d91a46e$var$handleInteraction = sinkFn;
        $d99f08815d91a46e$var$interactionQueue.forEach(function(interaction) {
            sinkFn(interaction.id, interaction.data);
        });
        $d99f08815d91a46e$var$interactionQueue.length = 0;
    }
}
function $d99f08815d91a46e$export$8a1ba7bef607358a(sinkFn) {
    $d99f08815d91a46e$export$d8f52e8f804021e8.sinkHandler(sinkFn);
}
// a flag to prevent multiple submitting
var $d99f08815d91a46e$var$activeSubmitted = false;
function $d99f08815d91a46e$export$673be905888f8839(interactionId, endTime) {
    var interaction = (0, $aNUZN.interactions).get(interactionId);
    if (interaction != null) {
        var noMoreActiveHolds = interaction.holdActive.size === 0;
        var noMoreExpHolds = interaction.holdExpActive.size === 0;
        var postInteraction = /*#__PURE__*/ function() {
            var _ref = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee() {
                var _getConfig7;
                var _getConfig8, experimentalVC90, experimentalTTAI, _yield$getExperimenta, start, end, _interactionExtraMetr2, _getConfig9, _getConfig0;
                return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee$(_context) {
                    while(true)switch(_context.prev = _context.next){
                        case 0:
                            if (!((_getConfig7 = (0, $DtLwq.getConfig)()) !== null && _getConfig7 !== void 0 && (_getConfig7 = _getConfig7.postInteractionLog) !== null && _getConfig7 !== void 0 && _getConfig7.enabled)) {
                                _context.next = 17;
                                break;
                            }
                            if (!((_getConfig8 = (0, $DtLwq.getConfig)()) !== null && _getConfig8 !== void 0 && (_getConfig8 = _getConfig8.experimentalInteractionMetrics) !== null && _getConfig8 !== void 0 && _getConfig8.enabled)) {
                                _context.next = 16;
                                break;
                            }
                            _context.next = 4;
                            return (0, $eEwI0.getExperimentalVCMetrics)(interaction);
                        case 4:
                            _context.t1 = _yield$getExperimenta = _context.sent;
                            _context.t0 = _context.t1 === null;
                            if (_context.t0) {
                                _context.next = 8;
                                break;
                            }
                            _context.t0 = _yield$getExperimenta === void 0;
                        case 8:
                            if (!_context.t0) {
                                _context.next = 12;
                                break;
                            }
                            _context.t2 = void 0;
                            _context.next = 13;
                            break;
                        case 12:
                            _context.t2 = _yield$getExperimenta['metric:experimental:vc90'];
                        case 13:
                            experimentalVC90 = _context.t2;
                            start = interaction.start, end = interaction.end;
                            experimentalTTAI = !interaction.abortReason ? Math.round(end - start) : undefined;
                        case 16:
                            $d99f08815d91a46e$export$d8f52e8f804021e8.onInteractionComplete($d99f08815d91a46e$var$_objectSpread($d99f08815d91a46e$var$_objectSpread({}, interaction), {}, {
                                experimentalTTAI: experimentalTTAI,
                                experimentalVC90: experimentalVC90
                            }));
                        case 17:
                            if ((0, $9Zzpd.fg)('platform_ufo_enable_ttai_with_3p')) {
                                if (((_interactionExtraMetr2 = $d99f08815d91a46e$export$481f88116dc8b7ad.finishedInteraction) === null || _interactionExtraMetr2 === void 0 ? void 0 : _interactionExtraMetr2.id) !== interactionId) // If interactionExtraMetrics is not waiting for measuring this interaction
                                {
                                    if ((_getConfig9 = (0, $DtLwq.getConfig)()) !== null && _getConfig9 !== void 0 && (_getConfig9 = _getConfig9.experimentalInteractionMetrics) !== null && _getConfig9 !== void 0 && _getConfig9.enabled) $d99f08815d91a46e$export$cd7f480d6b8286c3(interactionId);
                                }
                            } else if ((_getConfig0 = (0, $DtLwq.getConfig)()) !== null && _getConfig0 !== void 0 && (_getConfig0 = _getConfig0.experimentalInteractionMetrics) !== null && _getConfig0 !== void 0 && _getConfig0.enabled) $d99f08815d91a46e$export$cd7f480d6b8286c3(interactionId);
                            $d99f08815d91a46e$var$activeSubmitted = false;
                        case 19:
                        case "end":
                            return _context.stop();
                    }
                }, _callee);
            }));
            return function postInteraction() {
                return _ref.apply(this, arguments);
            };
        }();
        if ((0, $9Zzpd.fg)('platform_ufo_enable_ttai_with_3p')) {
            var _interaction$hold3pAc, _interactionExtraMetr3;
            var noMoreActive3pHolds = ((_interaction$hold3pAc = interaction.hold3pActive) === null || _interaction$hold3pAc === void 0 ? void 0 : _interaction$hold3pAc.size) === 0 || interaction.hold3pActive === undefined;
            if (noMoreActiveHolds && ((_interactionExtraMetr3 = $d99f08815d91a46e$export$481f88116dc8b7ad.finishedInteraction) === null || _interactionExtraMetr3 === void 0 ? void 0 : _interactionExtraMetr3.id) !== interactionId) {
                // If it's not waiting for extra metrics to complete, finish the interaction as normal
                if (!$d99f08815d91a46e$var$activeSubmitted) {
                    var _getConfig1, _getConfig10, _getConfig11;
                    $d99f08815d91a46e$var$finishInteraction(interactionId, interaction, endTime);
                    if ((_getConfig1 = (0, $DtLwq.getConfig)()) !== null && _getConfig1 !== void 0 && (_getConfig1 = _getConfig1.extraInteractionMetrics) !== null && _getConfig1 !== void 0 && _getConfig1.enabled) $d99f08815d91a46e$export$481f88116dc8b7ad.updateFinishedInteraction(interaction);
                    if ((_getConfig10 = (0, $DtLwq.getConfig)()) !== null && _getConfig10 !== void 0 && (_getConfig10 = _getConfig10.extraSearchPageInteraction) !== null && _getConfig10 !== void 0 && _getConfig10.enabled && interaction.ufoName === ((_getConfig11 = (0, $DtLwq.getConfig)()) === null || _getConfig11 === void 0 || (_getConfig11 = _getConfig11.extraSearchPageInteraction) === null || _getConfig11 === void 0 ? void 0 : _getConfig11.searchPageMetricName)) (0, $az8pZ.onSearchPageInteractionComplete)(interactionId, interaction);
                    $d99f08815d91a46e$var$activeSubmitted = true;
                }
                if (noMoreExpHolds) {
                    var _getConfig12;
                    if ((_getConfig12 = (0, $DtLwq.getConfig)()) !== null && _getConfig12 !== void 0 && (_getConfig12 = _getConfig12.experimentalInteractionMetrics) !== null && _getConfig12 !== void 0 && _getConfig12.enabled) (0, $eEwI0.onExperimentalInteractionComplete)(interactionId, interaction, endTime);
                    postInteraction();
                }
            }
            if (noMoreActiveHolds && noMoreActive3pHolds) {
                var data = $d99f08815d91a46e$var$_objectSpread($d99f08815d91a46e$var$_objectSpread({}, interaction), {}, {
                    end: endTime
                });
                $d99f08815d91a46e$export$481f88116dc8b7ad.onInteractionComplete(interactionId, data);
            }
        } else if (noMoreActiveHolds) {
            if (!$d99f08815d91a46e$var$activeSubmitted) {
                var _getConfig13, _getConfig14;
                $d99f08815d91a46e$var$finishInteraction(interactionId, interaction, endTime);
                if ((_getConfig13 = (0, $DtLwq.getConfig)()) !== null && _getConfig13 !== void 0 && (_getConfig13 = _getConfig13.extraSearchPageInteraction) !== null && _getConfig13 !== void 0 && _getConfig13.enabled && interaction.ufoName === ((_getConfig14 = (0, $DtLwq.getConfig)()) === null || _getConfig14 === void 0 || (_getConfig14 = _getConfig14.extraSearchPageInteraction) === null || _getConfig14 === void 0 ? void 0 : _getConfig14.searchPageMetricName)) (0, $az8pZ.onSearchPageInteractionComplete)(interactionId, interaction);
                $d99f08815d91a46e$var$activeSubmitted = true;
            }
            if (noMoreExpHolds) {
                var _getConfig15;
                if ((_getConfig15 = (0, $DtLwq.getConfig)()) !== null && _getConfig15 !== void 0 && (_getConfig15 = _getConfig15.experimentalInteractionMetrics) !== null && _getConfig15 !== void 0 && _getConfig15.enabled) (0, $eEwI0.onExperimentalInteractionComplete)(interactionId, interaction, endTime);
                postInteraction();
            }
        }
    }
}
function $d99f08815d91a46e$var$callCancelCallbacks(interaction) {
    interaction.cancelCallbacks.reverse().forEach(function(cancelCallback) {
        cancelCallback();
    });
}
function $d99f08815d91a46e$export$5def58af4fd46132(interactionId, abortReason) {
    var interaction = (0, $aNUZN.interactions).get(interactionId);
    if (interaction != null) {
        $d99f08815d91a46e$var$callCancelCallbacks(interaction);
        interaction.abortReason = abortReason;
        $d99f08815d91a46e$var$finishInteraction(interactionId, interaction);
        $d99f08815d91a46e$export$d8f52e8f804021e8.reset();
        $d99f08815d91a46e$export$d8f52e8f804021e8.stopVCObserver();
        if ((0, $9Zzpd.fg)('platform_ufo_enable_ttai_with_3p')) $d99f08815d91a46e$export$481f88116dc8b7ad.stopAll(interactionId);
        if ((0, $4iVTn.default)((0, $DtLwq.getExperimentalInteractionRate)(interaction.ufoName, interaction.type))) {
            (0, $eEwI0.onExperimentalInteractionComplete)(interactionId, interaction);
            $d99f08815d91a46e$export$cd7f480d6b8286c3(interactionId);
        }
    }
}
function $d99f08815d91a46e$export$c4a545284f55edf2(interactionId, interactionName) {
    var interaction = (0, $aNUZN.interactions).get(interactionId);
    if (interaction != null) {
        $d99f08815d91a46e$var$callCancelCallbacks(interaction);
        interaction.abortReason = 'new_interaction';
        interaction.abortedByInteractionName = interactionName;
        $d99f08815d91a46e$var$finishInteraction(interactionId, interaction);
        $d99f08815d91a46e$export$d8f52e8f804021e8.reset();
        $d99f08815d91a46e$export$d8f52e8f804021e8.stopVCObserver();
        if ((0, $9Zzpd.fg)('platform_ufo_enable_ttai_with_3p')) $d99f08815d91a46e$export$481f88116dc8b7ad.stopAll(interactionId);
        if ((0, $4iVTn.default)((0, $DtLwq.getExperimentalInteractionRate)(interaction.ufoName, interaction.type))) {
            (0, $eEwI0.onExperimentalInteractionComplete)(interactionId, interaction);
            $d99f08815d91a46e$export$cd7f480d6b8286c3(interactionId);
        }
    }
}
function $d99f08815d91a46e$export$614a7af2affc5dff(abortReason, abortedByInteractionName) {
    var activeInteraction = $d99f08815d91a46e$export$2b3954d2e8509985();
    var finishInteractions = (0, $DtLwq.getFinishInteractionOnTransition)();
    (0, $aNUZN.interactions).forEach(function(interaction, interactionId) {
        var isActiveInteraction = activeInteraction === interaction;
        var hasFinished = interaction.holdActive.size === 0;
        if (isActiveInteraction && abortReason === 'transition' && interaction.type === 'press' && finishInteractions !== null && finishInteractions !== void 0 && finishInteractions.includes(interaction.ufoName) && (0, $9Zzpd.fg)('platform_ufo_enable_finish_interaction_transition')) hasFinished = true;
        if (!hasFinished) {
            $d99f08815d91a46e$var$callCancelCallbacks(interaction);
            interaction.abortReason = abortReason;
            if (abortedByInteractionName != null) interaction.abortedByInteractionName = abortedByInteractionName;
        }
        $d99f08815d91a46e$var$finishInteraction(interactionId, interaction);
        $d99f08815d91a46e$export$d8f52e8f804021e8.reset();
        $d99f08815d91a46e$export$d8f52e8f804021e8.stopVCObserver();
        if ((0, $9Zzpd.fg)('platform_ufo_enable_ttai_with_3p')) $d99f08815d91a46e$export$481f88116dc8b7ad.stopAll(interactionId);
        if ((0, $4iVTn.default)((0, $DtLwq.getExperimentalInteractionRate)(interaction.ufoName, interaction.type))) {
            (0, $eEwI0.onExperimentalInteractionComplete)(interactionId, interaction);
            $d99f08815d91a46e$export$cd7f480d6b8286c3(interactionId);
        }
    });
}
function $d99f08815d91a46e$export$7b9261a96cfe427b(id, cancelCallback) {
    var interaction = (0, $aNUZN.interactions).get(id);
    interaction === null || interaction === void 0 || interaction.cancelCallbacks.push(cancelCallback);
}
function $d99f08815d91a46e$export$1a1ed1e1fdb2006b(interactionId, ufoName, type, startTime, rate, labelStack, routeName) {
    var trace = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : null;
    $d99f08815d91a46e$export$481f88116dc8b7ad.reset();
    $d99f08815d91a46e$export$d8f52e8f804021e8.reset();
    var vcObserver;
    var previousTime = startTime;
    var timeoutTime = (0, $DtLwq.getInteractionTimeout)(ufoName);
    var timerID = setTimeout(function() {
        $d99f08815d91a46e$export$5def58af4fd46132(interactionId, 'timeout');
    }, timeoutTime);
    function changeTimeout(newTime) {
        // we compare if the time left is lower than the new time to no
        // extend the timeout beyond the initial waiting time
        var currentTime = performance.now();
        var timeLeft = timeoutTime - (currentTime - previousTime);
        if (timeLeft < newTime) return;
        clearTimeout(this.timerID);
        var newTimerID = setTimeout(function() {
            $d99f08815d91a46e$export$5def58af4fd46132(interactionId, 'timeout');
        }, newTime);
        timeoutTime = newTime;
        previousTime = currentTime;
        this.timerID = newTimerID;
    }
    var addFeatureFlagsToInteraction = (0, $4iVTn.default)((0, $DtLwq.getCapabilityRate)('feature_flag_access'));
    var config = (0, $DtLwq.getConfig)();
    if (config && config.vc) {
        var vcOptions = {
            heatmapSize: config.vc.heatmapSize,
            oldDomUpdates: config.vc.oldDomUpdates,
            devToolsEnabled: config.vc.devToolsEnabled,
            selectorConfig: config.vc.selectorConfig,
            ssrEnablePageLayoutPlaceholder: config.vc.ssrEnablePageLayoutPlaceholder
        };
        vcObserver = (0, $avBPK.newVCObserver)(vcOptions);
    }
    var priorAccessedFg = type === 'press' && (0, $9Zzpd.fg)('platform_ufo_drop_prior_fg_interactions') ? {} : Object.fromEntries((0, $8qy01.allFeatureFlagsAccessed));
    var metrics = {
        id: interactionId,
        start: startTime,
        end: 0,
        ufoName: ufoName,
        type: type,
        previousInteractionName: $d99f08815d91a46e$var$PreviousInteractionLog.name,
        isPreviousInteractionAborted: $d99f08815d91a46e$var$PreviousInteractionLog.isAborted === true,
        marks: [],
        customData: [],
        cohortingCustomData: new Map(),
        customTimings: [],
        spans: [],
        requestInfo: [],
        reactProfilerTimings: [],
        holdInfo: [],
        holdExpInfo: [],
        holdActive: new Map(),
        holdExpActive: new Map(),
        // measure when we execute this code
        // from this, we can measure the input delay -
        // how long the browser took to hand execution back to JS)
        measureStart: performance.now(),
        rate: rate,
        cancelCallbacks: [],
        metaData: {},
        errors: [],
        apdex: [],
        labelStack: labelStack,
        routeName: routeName !== null && routeName !== void 0 ? routeName : ufoName,
        featureFlags: addFeatureFlagsToInteraction ? {
            prior: priorAccessedFg,
            during: {}
        } : undefined,
        knownSegments: [],
        cleanupCallbacks: [],
        awaitReactProfilerCount: 0,
        redirects: [],
        timerID: timerID,
        changeTimeout: changeTimeout,
        trace: trace,
        vcObserver: vcObserver,
        hold3pActive: new Map(),
        hold3pInfo: [],
        minorInteractions: []
    };
    if (addFeatureFlagsToInteraction) (0, $8qy01.currentFeatureFlagsAccessed).clear();
    (0, $aNUZN.interactions).set(interactionId, metrics);
    var segmentObserver = {
        onAdd: function onAdd(segment) {
            metrics.knownSegments.push(segment);
        },
        onRemove: function onRemove() {}
    };
    $d99f08815d91a46e$var$addSegmentObserver(segmentObserver);
    metrics.cleanupCallbacks.push(function() {
        $d99f08815d91a46e$var$removeSegmentObserver(segmentObserver);
    });
    metrics.cleanupCallbacks.push(function() {
        clearTimeout(metrics.timerID);
    });
    // Add cleanup for per-interaction VC observer
    if (vcObserver) metrics.cleanupCallbacks.push(function() {
        vcObserver.stop(ufoName);
    });
    var awaitBM3TTIList = (0, $DtLwq.getAwaitBM3TTIList)();
    if (awaitBM3TTIList.includes(ufoName)) $d99f08815d91a46e$export$10582acd678c213(interactionId, [], ufoName, ufoName, true);
    if (type === 'transition' || type === 'page_load') {
        var _getConfig16, _config$extraInteract;
        // Use per-interaction VC observer if available, otherwise fall back to global
        var observer = vcObserver;
        if (observer) observer.start({
            startTime: startTime,
            experienceKey: ufoName
        });
        // Start post interaction observer for all if config is enabled
        // in case ufoName is updated at later time
        if ((_getConfig16 = (0, $DtLwq.getConfig)()) !== null && _getConfig16 !== void 0 && (_getConfig16 = _getConfig16.postInteractionLog) !== null && _getConfig16 !== void 0 && _getConfig16.enabled) $d99f08815d91a46e$export$d8f52e8f804021e8.startVCObserver({
            startTime: startTime
        });
        if ((0, $4iVTn.default)((0, $DtLwq.getExperimentalInteractionRate)(ufoName, type))) (0, $eEwI0.experimentalVC).start({
            startTime: startTime
        });
        if (config !== null && config !== void 0 && (_config$extraInteract = config.extraInteractionMetrics) !== null && _config$extraInteract !== void 0 && _config$extraInteract.enabled && (0, $9Zzpd.fg)('platform_ufo_enable_ttai_with_3p')) $d99f08815d91a46e$export$481f88116dc8b7ad.startVCObserver({
            startTime: startTime
        }, interactionId);
    }
    if (type === 'press') {
        // Use per-interaction VC observer if available, otherwise fall back to global
        var _observer = vcObserver;
        if (_observer) _observer.start({
            startTime: startTime,
            experienceKey: ufoName
        });
    }
}
function $d99f08815d91a46e$export$4a759336b50e86e3(event) {
    var interaction = $d99f08815d91a46e$export$2b3954d2e8509985();
    if (interaction) {
        var _event$config;
        interaction.legacyMetrics = interaction.legacyMetrics || [];
        interaction.legacyMetrics.push(event);
        if ((interaction.type === 'page_load' || interaction.type === 'transition') && ((_event$config = event.config) === null || _event$config === void 0 ? void 0 : _event$config.type) === 'PAGE_LOAD') $d99f08815d91a46e$export$4983dfbbb996f7ae(interaction.id, interaction.ufoName);
    }
}
function $d99f08815d91a46e$export$ad216cc25852d44b(apdex) {
    (0, $aNUZN.interactions).forEach(function(interaction, key) {
        interaction.apdex.push(apdex);
        try {
            var _apdex$startTime;
            // for Firefox 102 and older
            performance.measure("\uD83D\uDEF8 ".concat(apdex.key, " [bm3_tti]"), {
                start: (_apdex$startTime = apdex.startTime) !== null && _apdex$startTime !== void 0 ? _apdex$startTime : interaction.start,
                end: apdex.stopTime,
                detail: {
                    devtools: {
                        track: 'main metrics',
                        trackGroup: "\uD83D\uDEF8 reactUFO metrics",
                        color: 'primary-dark'
                    }
                }
            });
            performance.mark("[bm3] TTI", {
                startTime: apdex.stopTime,
                detail: {
                    devtools: {
                        dataType: 'marker'
                    }
                }
            });
        } catch (e) {
        // do nothing
        }
        if (interaction.type === 'page_load' || interaction.type === 'transition') $d99f08815d91a46e$export$4983dfbbb996f7ae(key, interaction.ufoName);
    });
}
function $d99f08815d91a46e$export$35220fd6cdd1b731(interactionId, apdexInfo) {
    var interaction = (0, $aNUZN.interactions).get(interactionId);
    if (interaction != null) {
        interaction.apdex.push(apdexInfo);
        try {
            var _apdexInfo$startTime;
            // for Firefox 102 and older
            performance.measure("\uD83D\uDEF8 ".concat(apdexInfo.key, " [bm3_tti]"), {
                start: (_apdexInfo$startTime = apdexInfo.startTime) !== null && _apdexInfo$startTime !== void 0 ? _apdexInfo$startTime : interaction.start,
                end: apdexInfo.stopTime,
                detail: {
                    devtools: {
                        track: 'main metrics',
                        trackGroup: "\uD83D\uDEF8 reactUFO metrics",
                        color: 'primary-dark'
                    }
                }
            });
            performance.mark("[bm3] TTI", {
                startTime: apdexInfo.stopTime,
                detail: {
                    devtools: {
                        dataType: 'marker'
                    }
                }
            });
        } catch (e) {
        // do nothing
        }
        if (interaction.type === 'page_load' || interaction.type === 'transition') $d99f08815d91a46e$export$4983dfbbb996f7ae(interactionId, interaction.ufoName);
    }
}
function $d99f08815d91a46e$export$57d55b4569823d8f(interactionId, labelStack, requestInfo) {
    var interaction = (0, $aNUZN.interactions).get(interactionId);
    if (interaction != null) interaction.requestInfo.push($d99f08815d91a46e$var$_objectSpread({
        labelStack: labelStack
    }, requestInfo));
}
function $d99f08815d91a46e$var$isSegmentLabel(obj) {
    return obj && typeof obj.name === 'string' && typeof obj.segmentId === 'string';
}
function $d99f08815d91a46e$var$getSegmentCacheKey(labelStack) {
    return labelStack.map(function(l) {
        if ($d99f08815d91a46e$var$isSegmentLabel(l)) return "".concat(l.name, "_").concat(l.segmentId);
        return l.name;
    }).join('|');
}
function $d99f08815d91a46e$export$1c43f9ac826b6462(labelStack) {
    var key = $d99f08815d91a46e$var$getSegmentCacheKey(labelStack);
    var existingSegment = $d99f08815d91a46e$var$segmentCache.get(key);
    if (!existingSegment) {
        var segmentInfo = {
            labelStack: labelStack
        };
        $d99f08815d91a46e$var$segmentCache.set(key, segmentInfo);
        $d99f08815d91a46e$var$segmentObservers.forEach(function(observer) {
            observer.onAdd(segmentInfo);
        });
    }
}
function $d99f08815d91a46e$export$d0365e48b58231c3(labelStack) {
    var key = $d99f08815d91a46e$var$getSegmentCacheKey(labelStack);
    var segmentInfo = $d99f08815d91a46e$var$segmentCache.get(key);
    if (segmentInfo) {
        $d99f08815d91a46e$var$segmentCache.delete(JSON.stringify(labelStack));
        if ((0, $9Zzpd.fg)('platform_ufo_segment_unmount_count')) {
            var cacheKey = (0, $e8igD.stringifyLabelStackFully)(labelStack);
            $d99f08815d91a46e$export$a2b14406ded37d60.set(cacheKey, ($d99f08815d91a46e$export$a2b14406ded37d60.get(cacheKey) || 0) + 1);
        }
        $d99f08815d91a46e$var$segmentObservers.forEach(function(observer) {
            observer.onRemove(segmentInfo);
        });
    }
}
function $d99f08815d91a46e$export$bbf14d79614d9818(interactionId, fromUfoName, nextUfoName, nextRouteName, time) {
    var interaction = (0, $aNUZN.interactions).get(interactionId);
    if (interaction != null) {
        interaction.ufoName = nextUfoName;
        interaction.routeName = nextRouteName;
        interaction.redirects.push({
            fromInteractionName: fromUfoName,
            time: time
        });
        if ($d99f08815d91a46e$var$isPerformanceTracingEnabled()) {
            var prevRedirect = interaction.redirects.at(-2);
            try {
                var _prevRedirect$time;
                // for Firefox 102 and older
                performance.measure("\uD83D\uDEF8 ".concat(nextUfoName, " [redirect]"), {
                    start: (_prevRedirect$time = prevRedirect === null || prevRedirect === void 0 ? void 0 : prevRedirect.time) !== null && _prevRedirect$time !== void 0 ? _prevRedirect$time : interaction.start,
                    end: time,
                    detail: {
                        devtools: {
                            track: "\uD83D\uDEF8 reactUFO detailed timings",
                            color: 'tertiary'
                        }
                    }
                });
            } catch (e) {
            // do nothing
            }
        }
    }
}
var $d99f08815d91a46e$export$6ce04c7ca6810a7e = [];
var $d99f08815d91a46e$var$defaultLabelStack = [
    {
        name: 'custom'
    }
];
function $d99f08815d91a46e$export$5342dcad19138a1c(name, start) {
    var end = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : performance.now();
    var size = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
    var labelStack = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : $d99f08815d91a46e$var$defaultLabelStack;
    var customSpan = {
        type: 'custom',
        name: name,
        start: start,
        end: end,
        labelStack: labelStack,
        size: size
    };
    $d99f08815d91a46e$export$6ce04c7ca6810a7e.push(customSpan);
}

});
parcelRegister("eEwI0", function(module, exports) {
$parcel$export(module.exports, "sinkExperimentalHandler", () => $aaae2c65b71b60db$export$7aa99c40634ac65f);
$parcel$export(module.exports, "onExperimentalInteractionComplete", () => $aaae2c65b71b60db$export$1aed449484dedf63);
$parcel$export(module.exports, "experimentalVC", () => $aaae2c65b71b60db$export$81b28dca2587ec47);
$parcel$export(module.exports, "getExperimentalVCMetrics", () => $aaae2c65b71b60db$export$d17d2b5c5e8d732e);

var $fL8KA = parcelRequire("fL8KA");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $25nEq = parcelRequire("25nEq");

var $6HG4S = parcelRequire("6HG4S");

var $h9fNq = parcelRequire("h9fNq");

var $29WXY = parcelRequire("29WXY");
function $aaae2c65b71b60db$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $aaae2c65b71b60db$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $aaae2c65b71b60db$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $aaae2c65b71b60db$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $aaae2c65b71b60db$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $aaae2c65b71b60db$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $aaae2c65b71b60db$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $aaae2c65b71b60db$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $aaae2c65b71b60db$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $aaae2c65b71b60db$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
var $aaae2c65b71b60db$var$interactionBuffer = [];
var $aaae2c65b71b60db$var$bufferInteractionData = function bufferInteractionData(interactionId, data) {
    $aaae2c65b71b60db$var$interactionBuffer.push({
        interactionId: interactionId,
        data: data
    });
};
function $aaae2c65b71b60db$var$clearInteractionBuffer() {
    $aaae2c65b71b60db$var$interactionBuffer.length = 0;
}
function $aaae2c65b71b60db$var$appendInteractionData(interactionId, data) {
    $aaae2c65b71b60db$var$bufferInteractionData(interactionId, data);
}
function $aaae2c65b71b60db$export$c8a9e17ae62a073d(handler) {
    var _iterator = $aaae2c65b71b60db$var$_createForOfIteratorHelper($aaae2c65b71b60db$var$interactionBuffer), _step;
    try {
        for(_iterator.s(); !(_step = _iterator.n()).done;){
            var _step$value = _step.value, _interactionId = _step$value.interactionId, data = _step$value.data;
            handler(_interactionId, data);
        }
    } catch (err) {
        _iterator.e(err);
    } finally{
        _iterator.f();
    }
    $aaae2c65b71b60db$var$clearInteractionBuffer();
    $aaae2c65b71b60db$var$bufferInteractionData = handler;
}
function $aaae2c65b71b60db$export$7aa99c40634ac65f(sinkFn) {
    $aaae2c65b71b60db$export$c8a9e17ae62a073d(sinkFn);
}
function $aaae2c65b71b60db$export$1aed449484dedf63(interactionId, data) {
    var endTime = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : performance.now();
    if (data.ufoName) {
        data.end = endTime;
        $aaae2c65b71b60db$var$appendInteractionData(interactionId, data);
        $aaae2c65b71b60db$var$clearInteractionBuffer();
    }
}
var $aaae2c65b71b60db$export$f9a59f57e0282541 = /*#__PURE__*/ function() {
    function ExperimentalVCMetrics() {
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, ExperimentalVCMetrics);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "vcObserver", null);
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(ExperimentalVCMetrics, [
        {
            key: "initialize",
            value: function initialize(options) {
                if (this.vcObserver === null) this.vcObserver = new (0, $29WXY.VCObserver)($aaae2c65b71b60db$var$_objectSpread($aaae2c65b71b60db$var$_objectSpread({}, options), {}, {
                    isPostInteraction: true
                }));
                return this;
            }
        },
        {
            key: "start",
            value: function start(_ref) {
                var _this$vcObserver;
                var startTime = _ref.startTime;
                (_this$vcObserver = this.vcObserver) === null || _this$vcObserver === void 0 || _this$vcObserver.start({
                    startTime: startTime
                });
            }
        }
    ]);
}();
var $aaae2c65b71b60db$export$81b28dca2587ec47 = new $aaae2c65b71b60db$export$f9a59f57e0282541();
function $aaae2c65b71b60db$export$d17d2b5c5e8d732e(_x) {
    return $aaae2c65b71b60db$var$_getExperimentalVCMetrics.apply(this, arguments);
}
function $aaae2c65b71b60db$var$_getExperimentalVCMetrics() {
    $aaae2c65b71b60db$var$_getExperimentalVCMetrics = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee(interaction) {
        var vcObserver, pageVisibilityUpToTTAI, _interaction$apdex, prefix, result, VC;
        return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee$(_context) {
            while(true)switch(_context.prev = _context.next){
                case 0:
                    // Use per-interaction VC observer if available, otherwise fall back to global experimentalVC
                    vcObserver = interaction.experimentalVCObserver || $aaae2c65b71b60db$export$81b28dca2587ec47.vcObserver;
                    pageVisibilityUpToTTAI = (0, $h9fNq.getPageVisibilityState)(interaction.start, interaction.end);
                    if (!vcObserver) {
                        _context.next = 13;
                        break;
                    }
                    prefix = 'ufo-experimental';
                    _context.next = 6;
                    return vcObserver.getVCResult({
                        start: interaction.start,
                        stop: interaction.end,
                        tti: (_interaction$apdex = interaction.apdex) === null || _interaction$apdex === void 0 || (_interaction$apdex = _interaction$apdex[0]) === null || _interaction$apdex === void 0 ? void 0 : _interaction$apdex.stopTime,
                        isEventAborted: !!interaction.abortReason,
                        prefix: prefix,
                        vc: interaction.vc,
                        experienceKey: interaction.ufoName,
                        interactionId: interaction.id,
                        interactionType: interaction.type,
                        isPageVisible: pageVisibilityUpToTTAI === 'visible',
                        interactionAbortReason: interaction.abortReason
                    });
                case 6:
                    result = _context.sent;
                    VC = result === null || result === void 0 ? void 0 : result['metrics:vc'];
                    if (!(!VC || !(result !== null && result !== void 0 && result["".concat(prefix, ":vc:clean")]))) {
                        _context.next = 10;
                        break;
                    }
                    return _context.abrupt("return", result);
                case 10:
                    if (!(interaction.abortReason || pageVisibilityUpToTTAI !== 'visible')) {
                        _context.next = 12;
                        break;
                    }
                    return _context.abrupt("return", result);
                case 12:
                    return _context.abrupt("return", $aaae2c65b71b60db$var$_objectSpread($aaae2c65b71b60db$var$_objectSpread({}, result), {}, {
                        'metric:experimental:vc90': VC['90']
                    }));
                case 13:
                    return _context.abrupt("return", null);
                case 14:
                case "end":
                    return _context.stop();
            }
        }, _callee);
    }));
    return $aaae2c65b71b60db$var$_getExperimentalVCMetrics.apply(this, arguments);
}

});
parcelRegister("h9fNq", function(module, exports) {
$parcel$export(module.exports, "setupHiddenTimingCapture", () => $c7bf87bfb769b3be$export$554cefe0f0373da4);
$parcel$export(module.exports, "getPageVisibilityState", () => $c7bf87bfb769b3be$export$768b2008623433e1);

var $7QpUe = parcelRequire("7QpUe");
var $c7bf87bfb769b3be$var$timings = [];
var $c7bf87bfb769b3be$var$wasHiddenFlag;
var $c7bf87bfb769b3be$var$setupFlag = false;
function $c7bf87bfb769b3be$var$isPageHidden() {
    if ('visibilityState' in document) return document.visibilityState === 'hidden';
    else // @ts-expect-error - Property 'hidden' does not exist on type 'never'.
    return document.hidden;
}
var $c7bf87bfb769b3be$var$SIZE = 50;
var $c7bf87bfb769b3be$var$insertIndex = 0;
function $c7bf87bfb769b3be$var$pushHidden(isPageHiddenFlag, time) {
    $c7bf87bfb769b3be$var$timings[$c7bf87bfb769b3be$var$insertIndex] = {
        time: time !== null && time !== void 0 ? time : performance.now(),
        hidden: isPageHiddenFlag
    };
    $c7bf87bfb769b3be$var$insertIndex = ($c7bf87bfb769b3be$var$insertIndex + 1) % $c7bf87bfb769b3be$var$SIZE;
    $c7bf87bfb769b3be$var$wasHiddenFlag = isPageHiddenFlag;
}
function $c7bf87bfb769b3be$var$handleChange() {
    var isPageHiddenFlag = $c7bf87bfb769b3be$var$isPageHidden();
    if (isPageHiddenFlag) {
        if (!$c7bf87bfb769b3be$var$wasHiddenFlag) $c7bf87bfb769b3be$var$pushHidden(isPageHiddenFlag);
        $c7bf87bfb769b3be$var$wasHiddenFlag = true;
    } else {
        if ($c7bf87bfb769b3be$var$wasHiddenFlag) $c7bf87bfb769b3be$var$pushHidden(isPageHiddenFlag);
        $c7bf87bfb769b3be$var$wasHiddenFlag = false;
    }
}
function $c7bf87bfb769b3be$var$setup() {
    (0, $7QpUe.bind)(window, {
        type: 'pageshow',
        listener: $c7bf87bfb769b3be$var$handleChange
    });
    (0, $7QpUe.bind)(window, {
        type: 'pagehide',
        listener: $c7bf87bfb769b3be$var$handleChange
    });
    (0, $7QpUe.bind)(document, {
        type: 'visibilitychange',
        listener: $c7bf87bfb769b3be$var$handleChange
    });
}
function $c7bf87bfb769b3be$export$554cefe0f0373da4() {
    if (!$c7bf87bfb769b3be$var$setupFlag) {
        var isPageHiddenFlag = $c7bf87bfb769b3be$var$isPageHidden();
        $c7bf87bfb769b3be$var$pushHidden(isPageHiddenFlag, 0);
        $c7bf87bfb769b3be$var$setup();
        $c7bf87bfb769b3be$var$setupFlag = true;
    }
}
function $c7bf87bfb769b3be$export$768b2008623433e1(start, end) {
    // Input validation - return default for invalid inputs
    if (!Number.isFinite(start) || !Number.isFinite(end)) return 'visible';
    // Desirable default value is visible
    if ($c7bf87bfb769b3be$var$timings.length === 0) return 'visible';
    var currentSize = $c7bf87bfb769b3be$var$timings.length;
    var hiddenState = 'mixed';
    var startIdx = $c7bf87bfb769b3be$var$insertIndex;
    var endIdx = $c7bf87bfb769b3be$var$insertIndex;
    // currentSize is capped at SIZE.
    for(var i = 0; i < currentSize; i++){
        var tmpIdx = ($c7bf87bfb769b3be$var$insertIndex + i) % currentSize;
        // Add bounds checking before accessing array element
        if ($c7bf87bfb769b3be$var$timings[tmpIdx] && $c7bf87bfb769b3be$var$timings[tmpIdx].time <= end) {
            endIdx = tmpIdx;
            if ($c7bf87bfb769b3be$var$timings[tmpIdx].time <= start) startIdx = tmpIdx;
        }
    }
    // Add bounds checking before accessing timings array
    if (endIdx - startIdx === 0 && $c7bf87bfb769b3be$var$timings[startIdx]) hiddenState = $c7bf87bfb769b3be$var$timings[startIdx].hidden ? 'hidden' : 'visible';
    return hiddenState;
}

});

parcelRegister("29WXY", function(module, exports) {
$parcel$export(module.exports, "VCObserver", () => $192a297dec8b876e$export$1f70d263701b1d01);

var $fC8ib = parcelRequire("fC8ib");

var $fL8KA = parcelRequire("fL8KA");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $25nEq = parcelRequire("25nEq");

var $1Vcia = parcelRequire("1Vcia");

var $iYJcE = parcelRequire("iYJcE");

var $6HG4S = parcelRequire("6HG4S");

var $DtLwq = parcelRequire("DtLwq");

var $iGolp = parcelRequire("iGolp");

var $aTuIj = parcelRequire("aTuIj");

var $fUErN = parcelRequire("fUErN");

var $01Gqw = parcelRequire("01Gqw");

var $8B1Gy = parcelRequire("8B1Gy");

var $3H0iK = parcelRequire("3H0iK");
var $192a297dec8b876e$var$_excluded = [
    "__debug__element"
];
function $192a297dec8b876e$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $192a297dec8b876e$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $192a297dec8b876e$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $192a297dec8b876e$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $192a297dec8b876e$var$abortReason = {
    scroll: 'scroll',
    keypress: 'keypress',
    resize: 'resize',
    error: 'error'
};
var $192a297dec8b876e$var$UNUSED_SECTOR = 0;
function $192a297dec8b876e$var$filterComponentsLog(log) {
    return Object.fromEntries(Object.entries(log).map(function(_ref) {
        var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_ref, 2), timestamp = _ref2[0], entries = _ref2[1];
        return [
            Number(timestamp),
            entries.map(function(entry) {
                var __debug__element = entry.__debug__element, rest = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(entry, $192a297dec8b876e$var$_excluded);
                return rest;
            })
        ];
    }));
}
var $192a297dec8b876e$export$1f70d263701b1d01 = /*#__PURE__*/ function() {
    function VCObserver(options) {
        var _this = this;
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, VCObserver);
        /* abort logic */ (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "abortReason", {
            reason: null,
            info: '',
            timestamp: -1,
            blocking: false
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "outOfBoundaryInfo", '');
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "viewport", {
            w: 0,
            h: 0
        });
        /* heatmap */ (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "arraySize", 0);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "componentsLog", {});
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "vcRatios", {});
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "active", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "totalTime", 0);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "startTime", 0);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "_startMeasureTimestamp", -1);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "ssr", {
            reactRendered: -1
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "unbind", []);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "getAbortReasonInfo", function() {
            if (_this.abortReason.reason === null) return null;
            var info = _this.abortReason.info !== '' ? " ".concat(_this.abortReason.info) : '';
            return "".concat(_this.abortReason.reason).concat(info);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "getVCRawData", function() {
            _this.measureStart();
            if (!_this.active) {
                _this.measureStop();
                return null;
            }
            _this.stop();
            var abortReasonInfo = _this.getAbortReasonInfo();
            _this.measureStop();
            return {
                abortReasonInfo: abortReasonInfo,
                abortReason: $192a297dec8b876e$var$_objectSpread({}, _this.abortReason),
                heatmap: _this.heatmap,
                heatmapNext: _this.heatmapNext,
                outOfBoundaryInfo: _this.outOfBoundaryInfo,
                totalTime: Math.round(_this.totalTime + _this.observers.getTotalTime()),
                componentsLog: $192a297dec8b876e$var$_objectSpread({}, _this.componentsLog),
                viewport: $192a297dec8b876e$var$_objectSpread({}, _this.viewport),
                oldDomUpdatesEnabled: _this.oldDomUpdatesEnabled,
                devToolsEnabled: _this.devToolsEnabled,
                ratios: _this.vcRatios
            };
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "getVCResult", /*#__PURE__*/ function() {
            var _ref4 = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee(_ref3) {
                var start, stop, tti, prefix, ssr, vc, isEventAborted, experienceKey, interactionId, includeSSRRatio, startTime, fullPrefix, rawData, abortReason, abortReasonInfo, heatmap, heatmapNext, outOfBoundaryInfo, totalTime, componentsLog, viewport, devToolsEnabled, ratios, isTTVCv1Disabled, vcAbortedResultWithRevisions, ttvcV1Result, VC, VCBox, VCEntries, totalPainted, _componentsLog, vcNext, outOfBoundary, stopTime, ttvcV1DevToolInfo, ttvcV2DevToolInfo, shouldCreateDebugDetails, v1RevisionDebugDetails, v2RevisionDebugDetails, _window$__ufo_devtool2, _window2, _window$__ufo_devtool, _window, _window$__on_ufo_vc_d2, _window4, _window$__on_ufo_vc_d, _window3, isVCClean, revisionsData, speedIndex, SSRRatio, SSRRatioNext, SSRRatioPayload, isTTVCv3Enabled;
                return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee$(_context) {
                    while(true)switch(_context.prev = _context.next){
                        case 0:
                            start = _ref3.start, stop = _ref3.stop, tti = _ref3.tti, prefix = _ref3.prefix, ssr = _ref3.ssr, vc = _ref3.vc, isEventAborted = _ref3.isEventAborted, experienceKey = _ref3.experienceKey, interactionId = _ref3.interactionId, includeSSRRatio = _ref3.includeSSRRatio;
                            startTime = performance.now(); // add local measurement
                            fullPrefix = prefix !== undefined && prefix !== '' ? "".concat(prefix, ":") : '';
                            rawData = vc !== undefined ? vc : _this.getVCRawData();
                            if (!(rawData === null)) {
                                _context.next = 6;
                                break;
                            }
                            return _context.abrupt("return", {});
                        case 6:
                            abortReason = rawData.abortReason, abortReasonInfo = rawData.abortReasonInfo, heatmap = rawData.heatmap, heatmapNext = rawData.heatmapNext, outOfBoundaryInfo = rawData.outOfBoundaryInfo, totalTime = rawData.totalTime, componentsLog = rawData.componentsLog, viewport = rawData.viewport, devToolsEnabled = rawData.devToolsEnabled, ratios = rawData.ratios;
                            isTTVCv1Disabled = !(0, $DtLwq.isVCRevisionEnabled)('fy25.01', experienceKey);
                            if (!(abortReasonInfo !== null)) {
                                _context.next = 13;
                                break;
                            }
                            // exposing data to devtools
                            try {
                                if (devToolsEnabled && !_this.isPostInteraction) window.__vcNotAvailableReason = abortReasonInfo;
                            } catch (_unused) {}
                            vcAbortedResultWithRevisions = (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, "".concat(fullPrefix, "vc:rev"), [
                                {
                                    revision: 'fy25.02',
                                    clean: false,
                                    'metric:vc90': null,
                                    abortReason: abortReason.reason,
                                    abortTimestamp: Math.round(abortReason.timestamp)
                                }
                            ]);
                            if (!isTTVCv1Disabled) vcAbortedResultWithRevisions["".concat(fullPrefix, "vc:rev")].push({
                                revision: 'fy25.01',
                                clean: false,
                                'metric:vc90': null,
                                abortReason: abortReason.reason,
                                abortTimestamp: Math.round(abortReason.timestamp)
                            });
                            return _context.abrupt("return", vcAbortedResultWithRevisions);
                        case 13:
                            ttvcV1Result = isTTVCv1Disabled ? {
                                VC: {},
                                VCBox: {},
                                VCEntries: {
                                    abs: [],
                                    rel: [],
                                    speedIndex: -1
                                },
                                totalPainted: -1
                            } : VCObserver.calculateVC({
                                heatmap: heatmap,
                                ssr: ssr,
                                componentsLog: $192a297dec8b876e$var$_objectSpread({}, componentsLog),
                                viewport: viewport,
                                fixSSRAttribution: includeSSRRatio
                            });
                            VC = ttvcV1Result.VC, VCBox = ttvcV1Result.VCBox, VCEntries = ttvcV1Result.VCEntries, totalPainted = ttvcV1Result.totalPainted;
                            _componentsLog = {};
                            Object.entries(_this.componentsLog).forEach(function(_ref5) {
                                var _ref6 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_ref5, 2), _timestamp = _ref6[0], value = _ref6[1];
                                var timestamp = Number(_timestamp);
                                if (stop > timestamp) _componentsLog[timestamp] = value;
                            });
                            vcNext = VCObserver.calculateVC({
                                heatmap: heatmapNext,
                                ssr: ssr,
                                componentsLog: _componentsLog,
                                viewport: viewport,
                                fixSSRAttribution: includeSSRRatio
                            });
                            outOfBoundary = outOfBoundaryInfo ? (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, "".concat(fullPrefix, "vc:oob"), outOfBoundaryInfo) : {}; //const oldDomUpdates = oldDomUpdatesEnabled ? { [`${fullPrefix}vc:old:dom`]: vcNext.VCBox } : {};
                            stopTime = performance.now(); // exposing data to devtools
                            try {
                                if (!_this.isPostInteraction && devToolsEnabled) {
                                    ttvcV1DevToolInfo = isTTVCv1Disabled ? undefined : {
                                        entries: VCEntries.rel,
                                        log: componentsLog,
                                        metrics: {
                                            '75': VC['75'],
                                            '80': VC['80'],
                                            '85': VC['85'],
                                            '90': VC['90'],
                                            '95': VC['95'],
                                            '98': VC['98'],
                                            '99': VC['99'],
                                            tti: tti,
                                            ttai: stop - start
                                        },
                                        start: start,
                                        stop: stop,
                                        heatmap: heatmap,
                                        ratios: ratios
                                    };
                                    ttvcV2DevToolInfo = {
                                        entries: vcNext.VCEntries.rel,
                                        log: componentsLog,
                                        metrics: {
                                            '75': vcNext.VC['75'],
                                            '80': vcNext.VC['80'],
                                            '85': vcNext.VC['85'],
                                            '90': vcNext.VC['90'],
                                            '95': vcNext.VC['95'],
                                            '98': vcNext.VC['98'],
                                            '99': vcNext.VC['99'],
                                            tti: tti,
                                            ttai: stop - start
                                        },
                                        start: start,
                                        stop: stop,
                                        heatmap: heatmapNext,
                                        ratios: ratios
                                    };
                                    if (isTTVCv1Disabled) {
                                        window.__vc = ttvcV2DevToolInfo;
                                        window.__vcNext = ttvcV2DevToolInfo;
                                    } else {
                                        window.__vc = ttvcV1DevToolInfo;
                                        window.__vcNext = ttvcV2DevToolInfo;
                                    }
                                    // Emitting a custom event to make it available in the Chrome extension
                                    window.dispatchEvent(new CustomEvent('vcReady', {
                                        detail: {
                                            log: $192a297dec8b876e$var$filterComponentsLog(componentsLog),
                                            entries: isTTVCv1Disabled ? vcNext.VCEntries.rel : VCEntries.rel
                                        }
                                    }));
                                }
                                if (!_this.isPostInteraction) {
                                    // Only create revision debug details if callbacks exist
                                    shouldCreateDebugDetails = typeof window.__ufo_devtool_onVCRevisionReady__ === 'function' || typeof window.__on_ufo_vc_debug_data_ready === 'function';
                                    if (shouldCreateDebugDetails) {
                                        v1RevisionDebugDetails = (0, $fUErN.getVCRevisionDebugDetails)({
                                            revision: 'fy25.01',
                                            isClean: !abortReasonInfo,
                                            abortReason: abortReason.reason,
                                            VCEntries: VCEntries.rel,
                                            componentsLog: componentsLog,
                                            interactionId: interactionId
                                        });
                                        v2RevisionDebugDetails = (0, $fUErN.getVCRevisionDebugDetails)({
                                            revision: 'fy25.02',
                                            isClean: !abortReasonInfo,
                                            abortReason: abortReason.reason,
                                            VCEntries: vcNext.VCEntries.rel,
                                            componentsLog: componentsLog,
                                            interactionId: interactionId
                                        }); // Add devtool callback for both v1 and v2
                                        if (typeof window.__ufo_devtool_onVCRevisionReady__ === 'function') {
                                            // Handle v1 if not disabled
                                            if (!isTTVCv1Disabled) (_window$__ufo_devtool = (_window = window).__ufo_devtool_onVCRevisionReady__) === null || _window$__ufo_devtool === void 0 || _window$__ufo_devtool.call(_window, v1RevisionDebugDetails);
                                            // Handle v2
                                            (_window$__ufo_devtool2 = (_window2 = window).__ufo_devtool_onVCRevisionReady__) === null || _window$__ufo_devtool2 === void 0 || _window$__ufo_devtool2.call(_window2, v2RevisionDebugDetails);
                                        }
                                        if (typeof window.__on_ufo_vc_debug_data_ready === 'function') {
                                            if (!isTTVCv1Disabled) (_window$__on_ufo_vc_d = (_window3 = window).__on_ufo_vc_debug_data_ready) === null || _window$__on_ufo_vc_d === void 0 || _window$__on_ufo_vc_d.call(_window3, v1RevisionDebugDetails);
                                            (_window$__on_ufo_vc_d2 = (_window4 = window).__on_ufo_vc_debug_data_ready) === null || _window$__on_ufo_vc_d2 === void 0 || _window$__on_ufo_vc_d2.call(_window4, v2RevisionDebugDetails);
                                        }
                                    }
                                }
                            } catch (_unused2) {
                            /*  do nothing */ }
                            isVCClean = !abortReasonInfo;
                            revisionsData = (0, $01Gqw.getVCRevisionsData)({
                                fullPrefix: fullPrefix,
                                interaction: {
                                    start: start,
                                    end: stop
                                },
                                isVCClean: isVCClean,
                                calculatedVC: {
                                    VC: VC,
                                    VCBox: VCBox
                                },
                                calculatedVCNext: {
                                    VC: vcNext.VC,
                                    VCBox: vcNext.VCBox
                                },
                                isEventAborted: isEventAborted,
                                experienceKey: experienceKey,
                                ratios: ratios
                            });
                            speedIndex = (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, "ufo:speedIndex", isTTVCv1Disabled ? vcNext.VCEntries.speedIndex : VCEntries.speedIndex), "ufo:next:speedIndex", vcNext.VCEntries.speedIndex);
                            SSRRatio = VCObserver.getSSRRatio(VCEntries.rel, ssr);
                            SSRRatioNext = VCObserver.getSSRRatio(vcNext.VCEntries.rel, ssr);
                            SSRRatioPayload = includeSSRRatio ? (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, "".concat(fullPrefix, "vc:ssrRatio"), isTTVCv1Disabled ? SSRRatioNext : SSRRatio), "".concat(fullPrefix, "vc:next:ssrRatio"), SSRRatioNext) : {};
                            if (!isTTVCv1Disabled) {
                                _context.next = 29;
                                break;
                            }
                            return _context.abrupt("return", $192a297dec8b876e$var$_objectSpread($192a297dec8b876e$var$_objectSpread($192a297dec8b876e$var$_objectSpread($192a297dec8b876e$var$_objectSpread((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, "".concat(fullPrefix, "vc:size"), viewport), "".concat(fullPrefix, "vc:time"), Math.round(totalTime + (stopTime - startTime))), "".concat(fullPrefix, "vc:ratios"), ratios), outOfBoundary), {}, (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, "".concat(fullPrefix, "vc:ignored"), _this.getIgnoredElements(componentsLog)), SSRRatioPayload), {}, (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, "".concat(fullPrefix, "vc:ssrRatio"), SSRRatioNext), revisionsData), speedIndex));
                        case 29:
                            isTTVCv3Enabled = (0, $DtLwq.isVCRevisionEnabled)('fy25.03', experienceKey);
                            return _context.abrupt("return", $192a297dec8b876e$var$_objectSpread($192a297dec8b876e$var$_objectSpread($192a297dec8b876e$var$_objectSpread($192a297dec8b876e$var$_objectSpread((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({
                                'metrics:vc': VC
                            }, "".concat(fullPrefix, "vc:state"), true), "".concat(fullPrefix, "vc:clean"), isVCClean), "".concat(fullPrefix, "vc:dom"), VCBox), "".concat(fullPrefix, "vc:updates"), isTTVCv3Enabled ? undefined : VCEntries.rel.slice(0, 50)), "".concat(fullPrefix, "vc:size"), viewport), "".concat(fullPrefix, "vc:time"), Math.round(totalTime + (stopTime - startTime))), "".concat(fullPrefix, "vc:total"), totalPainted), "".concat(fullPrefix, "vc:ratios"), ratios), "".concat(fullPrefix, "vc:ssrRatio"), SSRRatio), outOfBoundary), {}, (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, "".concat(fullPrefix, "vc:next"), vcNext.VC), "".concat(fullPrefix, "vc:next:updates"), isTTVCv3Enabled ? undefined : vcNext.VCEntries.rel.slice(0, 50)), "".concat(fullPrefix, "vc:next:dom"), vcNext.VCBox), SSRRatioPayload), {}, (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, "".concat(fullPrefix, "vc:ignored"), _this.getIgnoredElements(componentsLog)), revisionsData), speedIndex));
                        case 31:
                        case "end":
                            return _context.stop();
                    }
                }, _callee);
            }));
            return function(_x) {
                return _ref4.apply(this, arguments);
            };
        }());
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "handleUpdate", function(rawTime, intersectionRect, targetName, element, type, ignoreReason, attributeName, oldValue, newValue) {
            if (_this.abortReason.reason === null || _this.abortReason.blocking === false) {
                var time = Math.round(rawTime - _this.startTime);
                var mappedValues = _this.mapPixelsToHeatmap(intersectionRect.left, intersectionRect.top, intersectionRect.width, intersectionRect.height);
                _this.vcRatios[targetName] = _this.getElementRatio(mappedValues);
                if (!ignoreReason) _this.applyChangesToHeatMap(mappedValues, time, _this.heatmapNext);
                var interaction = (0, $iGolp.getActiveInteraction)();
                var isTTVCv1Disabled = !(0, $DtLwq.isVCRevisionEnabled)('fy25.01', interaction === null || interaction === void 0 ? void 0 : interaction.ufoName);
                if (!isTTVCv1Disabled && (!ignoreReason || ignoreReason === 'not-visible') && type !== 'attr') _this.applyChangesToHeatMap(mappedValues, time, _this.heatmap);
                if (!_this.componentsLog[time]) _this.componentsLog[time] = [];
                _this.componentsLog[time].push({
                    __debug__element: _this.devToolsEnabled ? new WeakRef(element) : null,
                    type: type,
                    intersectionRect: intersectionRect,
                    targetName: targetName,
                    ignoreReason: ignoreReason,
                    attributeName: attributeName,
                    oldValue: oldValue,
                    newValue: newValue
                });
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "mapPixelsToHeatmap", function(left, top, width, height) {
            var _this$viewport = _this.viewport, w = _this$viewport.w, h = _this$viewport.h;
            var l = Math.floor(left / w * _this.arraySize);
            var t = Math.floor(top / h * _this.arraySize);
            var r = Math.ceil((left + width) / w * _this.arraySize);
            var b = Math.ceil((top + height) / h * _this.arraySize);
            // that info is temporary to get info why it goes over boundary
            if (_this.outOfBoundaryInfo === '') {
                var outOfBoundaryInfo = '';
                if (r > _this.arraySize) outOfBoundaryInfo += " r ".concat(r, " ! ").concat(left, " ").concat(width);
                if (b > _this.arraySize) outOfBoundaryInfo += " r ".concat(r, " ! ").concat(top, " ").concat(height);
                _this.outOfBoundaryInfo = outOfBoundaryInfo;
            }
            // correct values to min - 0, max - arraySize
            var result = {
                l: Math.max(0, l),
                t: Math.max(0, t),
                r: Math.min(_this.arraySize, r),
                b: Math.min(_this.arraySize, b)
            };
            return result;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "getElementRatio", function(mappedValues) {
            var r = mappedValues.r, l = mappedValues.l, b = mappedValues.b, t = mappedValues.t;
            return (r - l) * (b - t) / (_this.arraySize * _this.arraySize);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "abortReasonCallback", function(key, time) {
            switch(key){
                case 'wheel':
                    _this.setAbortReason($192a297dec8b876e$var$abortReason.scroll, time);
                    break;
                case 'keydown':
                    _this.setAbortReason($192a297dec8b876e$var$abortReason.keypress, time);
                    break;
                case 'resize':
                    _this.setAbortReason($192a297dec8b876e$var$abortReason.resize, time);
                    break;
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "attachAbortListeners", function() {
            var _window5;
            _this.detachAbortListeners();
            var unbinds = (0, $aTuIj.attachAbortListeners)(window, _this.viewport, _this.abortReasonCallback);
            if ((_window5 = window) !== null && _window5 !== void 0 && _window5.__SSR_ABORT_LISTENERS__) Object.entries(window.__SSR_ABORT_LISTENERS__.aborts).forEach(function(_ref9) {
                var _ref0 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_ref9, 2), key = _ref0[0], time = _ref0[1];
                if (time) _this.abortReasonCallback(key, time);
            });
            _this.unbind = unbinds;
        });
        this.arraySize = options.heatmapSize || 200;
        this.devToolsEnabled = options.devToolsEnabled || false;
        this.oldDomUpdatesEnabled = options.oldDomUpdates || false;
        var ssrEnablePageLayoutPlaceholder = options.ssrEnablePageLayoutPlaceholder, ssrPlaceholderHandler = options.ssrPlaceholderHandler;
        this.observers = new (0, $3H0iK.Observers)({
            selectorConfig: options.selectorConfig || {
                id: false,
                testId: false,
                role: false,
                className: true,
                dataVC: true
            },
            SSRConfig: {
                enablePageLayoutPlaceholder: ssrEnablePageLayoutPlaceholder || false
            },
            ssrPlaceholderHandler: ssrPlaceholderHandler
        });
        this.heatmap = !(0, $DtLwq.isVCRevisionEnabled)('fy25.01') ? [] : this.getCleanHeatmap();
        this.heatmapNext = this.getCleanHeatmap();
        this.isPostInteraction = options.isPostInteraction || false;
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(VCObserver, [
        {
            key: "start",
            value: function start(_ref1) {
                var startTime = _ref1.startTime;
                this.active = true;
                if (this.observers.isBrowserSupported()) {
                    this.setViewportSize();
                    this.resetState();
                    this.startTime = startTime;
                    this.attachAbortListeners();
                    this.observers.subscribeResults(this.handleUpdate);
                    this.observers.observe();
                } else this.setAbortReason('not-supported', startTime);
            }
        },
        {
            key: "stop",
            value: function stop() {
                this.observers.disconnect();
                this.detachAbortListeners();
            }
        },
        {
            key: "getIgnoredElements",
            value: function getIgnoredElements(componentsLog) {
                return Object.values(componentsLog).flat().filter(function(_ref10) {
                    var ignoreReason = _ref10.ignoreReason;
                    return Boolean(ignoreReason);
                }).map(function(_ref11) {
                    var targetName = _ref11.targetName, ignoreReason = _ref11.ignoreReason;
                    return {
                        targetName: targetName,
                        ignoreReason: ignoreReason
                    };
                });
            }
        },
        {
            key: "setSSRElement",
            value: function setSSRElement(element) {
                this.observers.setReactRootElement(element);
            }
        },
        {
            key: "setReactRootRenderStart",
            value: function setReactRootRenderStart() {
                var startTime = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : performance.now();
                this.observers.setReactRootRenderStart(startTime);
            }
        },
        {
            key: "setReactRootRenderStop",
            value: function setReactRootRenderStop() {
                var stopTime = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : performance.now();
                this.observers.setReactRootRenderStop(stopTime);
            }
        },
        {
            key: "collectSSRPlaceholders",
            value: function collectSSRPlaceholders() {
            // This is handled by the shared SSRPlaceholderHandlers in VCObserverWrapper
            // Individual observers don't need to implement this
            }
        },
        {
            key: "setAbortReason",
            value: function setAbortReason(abort, timestamp) {
                var info = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
                if (this.abortReason.reason === null || this.abortReason.blocking === false) {
                    this.abortReason.reason = abort;
                    this.abortReason.info = info;
                    this.abortReason.timestamp = timestamp;
                    this.abortReason.blocking = abort !== $192a297dec8b876e$var$abortReason.scroll;
                    if (this.abortReason.blocking) this.detachAbortListeners();
                }
            }
        },
        {
            key: "resetState",
            value: function resetState() {
                this.abortReason = {
                    reason: null,
                    info: '',
                    timestamp: -1,
                    blocking: false
                };
                this.detachAbortListeners();
                this.heatmap = !(0, $DtLwq.isVCRevisionEnabled)('fy25.01') ? [] : this.getCleanHeatmap();
                this.heatmapNext = this.getCleanHeatmap();
                this.totalTime = 0;
                this.componentsLog = {};
                this.vcRatios = {};
            }
        },
        {
            key: "getCleanHeatmap",
            value: function getCleanHeatmap() {
                var _this2 = this;
                return Array(this.arraySize).fill('').map(function() {
                    return Array(_this2.arraySize).fill($192a297dec8b876e$var$UNUSED_SECTOR);
                });
            }
        },
        {
            key: "setViewportSize",
            value: function setViewportSize() {
                this.viewport.w = (0, $8B1Gy.getViewportWidth)();
                this.viewport.h = (0, $8B1Gy.getViewportHeight)();
            }
        },
        {
            key: "applyChangesToHeatMap",
            value: function applyChangesToHeatMap(a, time, heatmap) {
                var l = a.l, t = a.t, r = a.r, b = a.b;
                var localHeatmap = heatmap;
                for(var row = t; row < b; row++){
                    for(var col = l; col < r; col++)if (localHeatmap[row] === undefined) {
                        try {
                            this.setAbortReason($192a297dec8b876e$var$abortReason.error, time, "index - ".concat(row));
                        } catch (_unused3) {
                            this.setAbortReason($192a297dec8b876e$var$abortReason.error, time, 'row error');
                        }
                        return;
                    } else localHeatmap[row][col] = time;
                }
            }
        },
        {
            key: "detachAbortListeners",
            value: function detachAbortListeners() {
                if (this.unbind) {
                    var unbind = this.unbind;
                    for(var i = 0; i < unbind.length; i++)unbind[i]();
                    this.unbind.length = 0;
                }
            }
        },
        {
            key: "measureStart",
            value: function measureStart() {
                this._startMeasureTimestamp = performance.now();
            }
        },
        {
            key: "measureStop",
            value: function measureStop() {
                if (this._startMeasureTimestamp === -1) return;
                this.totalTime += performance.now() - this._startMeasureTimestamp;
                this._startMeasureTimestamp = -1;
            }
        }
    ], [
        {
            key: "getSSRRatio",
            value: function getSSRRatio(entries, ssr) {
                if (ssr === undefined || entries.length === 0) return undefined;
                var maybeSSR = entries[0];
                if (maybeSSR.elements[0] === 'SSR') return maybeSSR.vc;
                return 0;
            }
        },
        {
            key: "calculateVC",
            value: function calculateVC(_ref12) {
                var heatmap = _ref12.heatmap, _ref12$ssr = _ref12.ssr, ssr = _ref12$ssr === void 0 ? $192a297dec8b876e$var$UNUSED_SECTOR : _ref12$ssr, componentsLog = _ref12.componentsLog, viewport = _ref12.viewport, fixSSRAttribution = _ref12.fixSSRAttribution;
                var lastUpdate = {};
                var totalPainted = 0;
                var ssrTime = fixSSRAttribution ? Math.floor(ssr) : ssr;
                if (ssrTime !== $192a297dec8b876e$var$UNUSED_SECTOR) {
                    var _window$document;
                    var element = {
                        __debug__element: new WeakRef((_window$document = window.document) === null || _window$document === void 0 ? void 0 : _window$document.body),
                        intersectionRect: {
                            top: 0,
                            left: 0,
                            right: 0,
                            bottom: 0,
                            x: 0,
                            y: 0,
                            width: viewport.w,
                            height: viewport.h,
                            toJSON: function toJSON() {
                                return {};
                            }
                        },
                        targetName: 'SSR'
                    };
                    if (!componentsLog[ssrTime]) componentsLog[ssrTime] = [];
                    componentsLog[ssrTime].push(element);
                }
                heatmap.forEach(function(line) {
                    line.forEach(function(entry) {
                        var rounded = Math.floor(entry === $192a297dec8b876e$var$UNUSED_SECTOR && ssrTime !== $192a297dec8b876e$var$UNUSED_SECTOR ? ssrTime : entry);
                        totalPainted += rounded !== $192a297dec8b876e$var$UNUSED_SECTOR ? 1 : 0;
                        if (rounded !== $192a297dec8b876e$var$UNUSED_SECTOR) lastUpdate[rounded] = lastUpdate[rounded] ? lastUpdate[rounded] + 1 : 1;
                    });
                });
                var entries = Object.entries(lastUpdate).map(function(a) {
                    return [
                        parseInt(a[0], 10),
                        a[1]
                    ];
                }).sort(function(a, b) {
                    return a[0] > b[0] ? 1 : -1;
                });
                var VC = VCObserver.makeVCReturnObj();
                var VCBox = VCObserver.makeVCReturnObj();
                entries.reduce(function() {
                    var acc = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
                    var v = arguments.length > 1 ? arguments[1] : undefined;
                    var currRatio = v[1] / totalPainted;
                    var VCRatio = currRatio + acc;
                    var preciseCurrRatio = Math.round(100 * (v[1] / totalPainted));
                    var preciseAccRatio = Math.round(acc * 100);
                    VCRatio = (preciseCurrRatio + preciseAccRatio) / 100;
                    var time = v[0];
                    VCObserver.VCParts.forEach(function(key) {
                        var value = parseInt(key, 10);
                        if ((VC[key] === null || VC[key] === undefined) && VCRatio >= value / 100) {
                            var _componentsLog$time;
                            VC[key] = time;
                            VCBox[key] = (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(new Set((_componentsLog$time = componentsLog[time]) === null || _componentsLog$time === void 0 ? void 0 : _componentsLog$time.filter(function(v) {
                                return !v.ignoreReason;
                            }).map(function(v) {
                                return v.targetName;
                            })));
                        }
                    });
                    return VCRatio;
                }, 0);
                var VCEntries = entries.reduce(function(acc, _ref13, i) {
                    var _acc$abs, _componentsLog$timest, _acc$rel$vc, _acc$rel;
                    var _ref14 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_ref13, 2), timestamp = _ref14[0], entryPainted = _ref14[1];
                    var currentlyPainted = entryPainted + (((_acc$abs = acc.abs[i - 1]) === null || _acc$abs === void 0 ? void 0 : _acc$abs[1]) || 0);
                    var currentlyPaintedRatio = Math.round(currentlyPainted / totalPainted * 1000) / 10;
                    var logEntry = (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(new Set((_componentsLog$timest = componentsLog[timestamp]) === null || _componentsLog$timest === void 0 ? void 0 : _componentsLog$timest.filter(function(v) {
                        return !v.ignoreReason;
                    }).map(function(v) {
                        return v.targetName;
                    })));
                    var ratioDelta = (currentlyPaintedRatio - ((_acc$rel$vc = (_acc$rel = acc.rel[i - 1]) === null || _acc$rel === void 0 ? void 0 : _acc$rel.vc) !== null && _acc$rel$vc !== void 0 ? _acc$rel$vc : 0)) / 100;
                    var speedIndex = timestamp * ratioDelta;
                    acc.speedIndex += speedIndex;
                    acc.abs.push([
                        timestamp,
                        currentlyPainted
                    ]);
                    acc.rel.push({
                        time: timestamp,
                        vc: currentlyPaintedRatio,
                        elements: logEntry
                    });
                    return acc;
                }, {
                    abs: [],
                    rel: [],
                    speedIndex: 0
                });
                VCEntries.speedIndex = Math.round(VCEntries.speedIndex);
                return {
                    VC: VC,
                    VCBox: VCBox,
                    VCEntries: VCEntries,
                    totalPainted: totalPainted
                };
            }
        },
        {
            key: "makeVCReturnObj",
            value: function makeVCReturnObj() {
                var vc = {};
                VCObserver.VCParts.forEach(function(v) {
                    vc[v] = null;
                });
                return vc;
            }
        }
    ]);
}();
/** config * */ (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($192a297dec8b876e$export$1f70d263701b1d01, "VCParts", [
    '25',
    '50',
    '75',
    '80',
    '85',
    '90',
    '95',
    '98',
    '99'
]);

});
parcelRegister("aTuIj", function(module, exports) {
$parcel$export(module.exports, "attachAbortListeners", () => $7ee6dd8fb784756d$export$9010aa71841a6887);

var $7QpUe = parcelRequire("7QpUe");

var $bIlUG = parcelRequire("bIlUG");

var $8B1Gy = parcelRequire("8B1Gy");
function $7ee6dd8fb784756d$export$9010aa71841a6887(window, initialViewPort, callback) {
    var unbindWheel = (0, $7QpUe.bind)(window, {
        type: (0, $bIlUG.AbortEvent).wheel,
        listener: function listener(e) {
            callback((0, $bIlUG.AbortEvent).wheel, e.timeStamp);
        },
        options: {
            passive: true,
            once: true
        }
    });
    var unbindKeydown = (0, $7QpUe.bind)(window, {
        type: (0, $bIlUG.AbortEvent).keydown,
        listener: function listener(e) {
            callback((0, $bIlUG.AbortEvent).keydown, e.timeStamp);
        },
        options: {
            once: true
        }
    });
    var unbindResize = (0, $7QpUe.bind)(window, {
        type: (0, $bIlUG.AbortEvent).resize,
        listener: function listener(e) {
            if ((0, $8B1Gy.getViewportWidth)() !== initialViewPort.w || (0, $8B1Gy.getViewportHeight)() !== initialViewPort.h) {
                callback((0, $bIlUG.AbortEvent).resize, e.timeStamp);
                unbindResize();
            }
        }
    });
    return [
        unbindWheel,
        unbindKeydown,
        unbindResize
    ];
}

});
parcelRegister("bIlUG", function(module, exports) {
$parcel$export(module.exports, "AbortEvent", () => $8874cd440e9e8d1b$export$199edc0307b5587f);
var $8874cd440e9e8d1b$export$199edc0307b5587f = {
    wheel: 'wheel',
    keydown: 'keydown',
    resize: 'resize'
};

});

parcelRegister("8B1Gy", function(module, exports) {
$parcel$export(module.exports, "getViewportWidth", () => $6423161848a1be2c$export$a497a1dcb4408212);
$parcel$export(module.exports, "getViewportHeight", () => $6423161848a1be2c$export$4f01c15d21ef9cc6);
function $6423161848a1be2c$export$a497a1dcb4408212() {
    var document = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window.document;
    var documentWidth;
    try {
        documentWidth = document.documentElement.clientWidth || 0;
    } catch (e) {
        documentWidth = 0;
    }
    return Math.max(documentWidth, window.innerWidth || 0);
}
function $6423161848a1be2c$export$4f01c15d21ef9cc6() {
    var document = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window.document;
    var documentHeight;
    try {
        documentHeight = document.documentElement.clientHeight || 0;
    } catch (e) {
        documentHeight = 0;
    }
    return Math.max(documentHeight, window.innerHeight || 0);
}

});


parcelRegister("fUErN", function(module, exports) {
$parcel$export(module.exports, "getVCRevisionDebugDetails", () => $b95b75f734c61ed0$export$72e6dda9d5859230);

var $iYJcE = parcelRequire("iYJcE");

var $fC8ib = parcelRequire("fC8ib");
function $b95b75f734c61ed0$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $b95b75f734c61ed0$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $b95b75f734c61ed0$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $b95b75f734c61ed0$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $b95b75f734c61ed0$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $b95b75f734c61ed0$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $b95b75f734c61ed0$export$72e6dda9d5859230(_ref) {
    var revision = _ref.revision, isClean = _ref.isClean, abortReason = _ref.abortReason, VCEntries = _ref.VCEntries, componentsLog = _ref.componentsLog, interactionId = _ref.interactionId;
    // Pre-sort VCEntries by time for efficient lookups
    var sortedVCEntries = (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(VCEntries).sort(function(a, b) {
        return a.time - b.time;
    });
    // Pre-calculate max viewport percentage up to each time for efficient lookups
    var maxViewportPercentageAtTime = new Map();
    var maxSoFar = 0;
    var _iterator = $b95b75f734c61ed0$var$_createForOfIteratorHelper(sortedVCEntries), _step;
    try {
        for(_iterator.s(); !(_step = _iterator.n()).done;){
            var entry = _step.value;
            maxSoFar = Math.max(maxSoFar, entry.vc);
            maxViewportPercentageAtTime.set(entry.time, maxSoFar);
        }
    // Helper function to find the biggest previous viewport percentage
    } catch (err) {
        _iterator.e(err);
    } finally{
        _iterator.f();
    }
    var getBiggestPreviousViewportPercentage = function getBiggestPreviousViewportPercentage(targetTime) {
        // Binary search for the largest time <= targetTime
        var left = 0;
        var right = sortedVCEntries.length - 1;
        var result = -1;
        while(left <= right){
            var mid = Math.floor((left + right) / 2);
            if (sortedVCEntries[mid].time <= targetTime) {
                result = mid;
                left = mid + 1;
            } else right = mid - 1;
        }
        return result >= 0 ? maxViewportPercentageAtTime.get(sortedVCEntries[result].time) || null : null;
    };
    var allVcLogs = [];
    // Add regular VC entries
    var _iterator2 = $b95b75f734c61ed0$var$_createForOfIteratorHelper(VCEntries), _step2;
    try {
        var _loop = function _loop() {
            var entry = _step2.value;
            var timeLogEntries = componentsLog[entry.time];
            allVcLogs.push({
                time: entry.time,
                viewportPercentage: entry.vc,
                entries: entry.elements.map(function(element) {
                    var logEntry = timeLogEntries === null || timeLogEntries === void 0 ? void 0 : timeLogEntries.find(function(log) {
                        return log.targetName === element;
                    });
                    return {
                        elementName: element,
                        type: logEntry === null || logEntry === void 0 ? void 0 : logEntry.type,
                        rect: logEntry === null || logEntry === void 0 ? void 0 : logEntry.intersectionRect,
                        visible: true,
                        attributeName: logEntry === null || logEntry === void 0 ? void 0 : logEntry.attributeName,
                        oldValue: logEntry === null || logEntry === void 0 ? void 0 : logEntry.oldValue,
                        newValue: logEntry === null || logEntry === void 0 ? void 0 : logEntry.newValue,
                        ignoreReason: logEntry === null || logEntry === void 0 ? void 0 : logEntry.ignoreReason
                    };
                })
            });
        };
        for(_iterator2.s(); !(_step2 = _iterator2.n()).done;)_loop();
    // Add ignored elements - only process timestamps that have ignored elements
    } catch (err) {
        _iterator2.e(err);
    } finally{
        _iterator2.f();
    }
    for(var _i = 0, _Object$entries = Object.entries(componentsLog); _i < _Object$entries.length; _i++){
        var _Object$entries$_i = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_Object$entries[_i], 2), timestamp = _Object$entries$_i[0], timeLogEntries = _Object$entries$_i[1];
        var ignoredElements = timeLogEntries.filter(function(log) {
            return log.ignoreReason;
        });
        if (ignoredElements.length === 0) continue;
        var time = Number(timestamp);
        var viewportPercentage = getBiggestPreviousViewportPercentage(time);
        allVcLogs.push({
            time: time,
            viewportPercentage: viewportPercentage,
            entries: ignoredElements.map(function(logEntry) {
                return {
                    elementName: logEntry.targetName,
                    type: logEntry.type,
                    rect: logEntry.intersectionRect,
                    visible: false,
                    attributeName: logEntry.attributeName,
                    oldValue: logEntry.oldValue,
                    newValue: logEntry.newValue,
                    ignoreReason: logEntry.ignoreReason
                };
            })
        });
    }
    // Sort once at the end
    allVcLogs.sort(function(a, b) {
        return a.time - b.time;
    });
    return {
        revision: revision,
        isClean: isClean,
        abortReason: abortReason,
        vcLogs: allVcLogs,
        interactionId: interactionId
    };
}

});

parcelRegister("01Gqw", function(module, exports) {
$parcel$export(module.exports, "getVCRevisionsData", () => $0051012bc08f4886$export$5c86a34c9becd6d0);

var $25nEq = parcelRequire("25nEq");

var $DtLwq = parcelRequire("DtLwq");

var $h9fNq = parcelRequire("h9fNq");
function $0051012bc08f4886$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $0051012bc08f4886$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $0051012bc08f4886$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $0051012bc08f4886$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $0051012bc08f4886$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $0051012bc08f4886$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
var $0051012bc08f4886$var$VCParts = [
    '25',
    '50',
    '75',
    '80',
    '85',
    '90',
    '95',
    '98',
    '99'
];
var $0051012bc08f4886$var$READONLY_EMPTY_ARRAY = Array.from({
    length: 0
});
// Helper function to create vcDetails object to avoid code duplication
function $0051012bc08f4886$var$createVCDetails(calculatedVC, shouldHaveVCmetric) {
    if (!shouldHaveVCmetric || !calculatedVC || !calculatedVC.VC || !calculatedVC.VCBox) return {};
    var details = {};
    var VC = calculatedVC.VC, VCBox = calculatedVC.VCBox; // Destructure once to avoid repeated property access
    var _iterator = $0051012bc08f4886$var$_createForOfIteratorHelper($0051012bc08f4886$var$VCParts), _step;
    try {
        for(_iterator.s(); !(_step = _iterator.n()).done;){
            var key = _step.value;
            details[key] = {
                t: VC[key] || -1,
                e: VCBox[key] || $0051012bc08f4886$var$READONLY_EMPTY_ARRAY
            };
        }
    } catch (err) {
        _iterator.e(err);
    } finally{
        _iterator.f();
    }
    return details;
}
function $0051012bc08f4886$export$5c86a34c9becd6d0(_ref) {
    var fullPrefix = _ref.fullPrefix, interaction = _ref.interaction, isVCClean = _ref.isVCClean, isEventAborted = _ref.isEventAborted, calculatedVC = _ref.calculatedVC, calculatedVCNext = _ref.calculatedVCNext, experienceKey = _ref.experienceKey, ratios = _ref.ratios;
    var pageVisibilityUpToTTAI = (0, $h9fNq.getPageVisibilityState)(interaction.start, interaction.end);
    var isVisiblePageVisibleUpToTTAI = pageVisibilityUpToTTAI === 'visible';
    var shouldHaveVCmetric = isVCClean && !isEventAborted && isVisiblePageVisibleUpToTTAI;
    var availableVCRevisionPayloads = [];
    if ((0, $DtLwq.isVCRevisionEnabled)('fy25.01', experienceKey)) {
        var revision = {
            revision: 'fy25.01',
            clean: isVCClean,
            'metric:vc90': shouldHaveVCmetric ? calculatedVC.VC['90'] : null,
            vcDetails: $0051012bc08f4886$var$createVCDetails(calculatedVC, shouldHaveVCmetric)
        };
        if (shouldHaveVCmetric) revision.ratios = ratios;
        availableVCRevisionPayloads.push(revision);
    }
    if ((0, $DtLwq.isVCRevisionEnabled)('fy25.02', experienceKey)) {
        var _revision = {
            revision: 'fy25.02',
            clean: isVCClean,
            'metric:vc90': shouldHaveVCmetric ? calculatedVCNext.VC['90'] : null,
            vcDetails: $0051012bc08f4886$var$createVCDetails(calculatedVCNext, shouldHaveVCmetric)
        };
        if (shouldHaveVCmetric) _revision.ratios = ratios;
        availableVCRevisionPayloads.push(_revision);
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, "".concat(fullPrefix, "vc:rev"), availableVCRevisionPayloads);
}

});

parcelRegister("3H0iK", function(module, exports) {
$parcel$export(module.exports, "Observers", () => $2b059f1e9e6b20d6$export$b65d046240060e78);

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $25nEq = parcelRequire("25nEq");

var $cDJdu = parcelRequire("cDJdu");

var $lj1OM = parcelRequire("lj1OM");

var $hakpj = parcelRequire("hakpj");

var $k6qaT = parcelRequire("k6qaT");
function $2b059f1e9e6b20d6$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $2b059f1e9e6b20d6$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $2b059f1e9e6b20d6$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $2b059f1e9e6b20d6$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $2b059f1e9e6b20d6$var$state = {
    normal: 1,
    waitingForFirstRender: 2,
    ignoring: 3
};
function $2b059f1e9e6b20d6$var$isElementVisible(target) {
    if (!target || typeof target.checkVisibility !== 'function') return true;
    var isVisible = target.checkVisibility({
        contentVisibilityAuto: true,
        opacityProperty: true,
        visibilityProperty: true
    });
    return isVisible;
}
var $2b059f1e9e6b20d6$export$b65d046240060e78 = /*#__PURE__*/ function() {
    function Observers(opts) {
        var _this = this;
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, Observers);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "observedMutations", new WeakMap());
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "elementsInView", new Set());
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "callbacks", new Set());
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "totalTime", 0);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "_startMeasureTimestamp", -1);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "ssr", {
            state: $2b059f1e9e6b20d6$var$state.normal,
            reactRootElement: null,
            renderStart: -1,
            renderStop: -1
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "selectorConfig", {
            id: false,
            testId: false,
            role: false,
            className: true,
            dataVC: true
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "subscribeResults", function(cb) {
            _this.callbacks.add(cb);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "observeElement", function(node, mutation, type, ignoreReason, attributeName) {
            var _this$intersectionObs;
            var oldValue = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : null;
            var newValue = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : null;
            (_this$intersectionObs = _this.intersectionObserver) === null || _this$intersectionObs === void 0 || _this$intersectionObs.observe(node);
            _this.observedMutations.set(node, {
                mutation: mutation,
                ignoreReason: ignoreReason,
                type: type,
                attributeName: attributeName,
                oldValue: oldValue,
                newValue: newValue
            });
        });
        this.selectorConfig = $2b059f1e9e6b20d6$var$_objectSpread($2b059f1e9e6b20d6$var$_objectSpread({}, this.selectorConfig), opts.selectorConfig);
        this.intersectionObserver = this.getIntersectionObserver();
        this.mutationObserver = this.getMutationObserver();
        // Use shared SSR placeholder handler if provided, otherwise create new one
        if (opts.ssrPlaceholderHandler) this.ssrPlaceholderHandler = opts.ssrPlaceholderHandler;
        else {
            var _opts$SSRConfig;
            this.ssrPlaceholderHandler = new (0, $k6qaT.SSRPlaceholderHandlers)({
                enablePageLayoutPlaceholder: (_opts$SSRConfig = opts.SSRConfig) === null || _opts$SSRConfig === void 0 ? void 0 : _opts$SSRConfig.enablePageLayoutPlaceholder
            });
        }
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(Observers, [
        {
            key: "isBrowserSupported",
            value: function isBrowserSupported() {
                return typeof window.IntersectionObserver === 'function' && typeof window.MutationObserver === 'function';
            }
        },
        {
            key: "observe",
            value: function observe() {
                var _this$mutationObserve;
                this.totalTime = 0;
                this.ssr = {
                    state: $2b059f1e9e6b20d6$var$state.normal,
                    reactRootElement: null,
                    renderStart: -1,
                    renderStop: -1
                };
                (_this$mutationObserve = this.mutationObserver) === null || _this$mutationObserve === void 0 || _this$mutationObserve.observe(document.body, {
                    attributeFilter: [
                        'hidden',
                        'style',
                        'src',
                        'class'
                    ],
                    attributeOldValue: true,
                    attributes: true,
                    childList: true,
                    subtree: true
                });
            }
        },
        {
            key: "disconnect",
            value: function disconnect() {
                var _this$mutationObserve2, _this$intersectionObs2;
                (_this$mutationObserve2 = this.mutationObserver) === null || _this$mutationObserve2 === void 0 || _this$mutationObserve2.disconnect();
                (_this$intersectionObs2 = this.intersectionObserver) === null || _this$intersectionObs2 === void 0 || _this$intersectionObs2.disconnect();
                this.observedMutations = new WeakMap();
                this.elementsInView.clear();
                this.callbacks.clear();
                this.ssr.reactRootElement = null;
                this.ssrPlaceholderHandler.clear();
            }
        },
        {
            key: "getTotalTime",
            value: function getTotalTime() {
                return this.totalTime;
            }
        },
        {
            key: "setReactRootElement",
            value: function setReactRootElement(element) {
                this.ssr.reactRootElement = element;
            }
        },
        {
            key: "setReactRootRenderStart",
            value: function setReactRootRenderStart() {
                var startTime = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : performance.now();
                this.ssr.renderStart = startTime;
                this.ssr.state = $2b059f1e9e6b20d6$var$state.waitingForFirstRender;
            }
        },
        {
            key: "setReactRootRenderStop",
            value: function setReactRootRenderStop() {
                var stopTime = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : performance.now();
                this.ssr.renderStop = stopTime;
            }
        },
        {
            key: "getMutationObserver",
            value: function getMutationObserver() {
                var _this2 = this;
                if (!this.isBrowserSupported()) return null;
                return new MutationObserver(function(mutations) {
                    _this2.measureStart();
                    mutations.forEach(function(mutation) {
                        // patching element if timestamp not automatically added
                        // eslint-disable-next-line no-param-reassign
                        mutation.timestamp = mutation.timestamp === undefined ? performance.now() : mutation.timestamp;
                        var ignoreReason = '';
                        if (_this2.ssr.state === $2b059f1e9e6b20d6$var$state.waitingForFirstRender && mutation.timestamp > _this2.ssr.renderStart && mutation.target === _this2.ssr.reactRootElement) {
                            _this2.ssr.state = $2b059f1e9e6b20d6$var$state.ignoring;
                            if (_this2.ssr.renderStop === -1) // arbitrary 500ms DOM update window
                            _this2.ssr.renderStop = mutation.timestamp + 500;
                            ignoreReason = 'ssr-hydration';
                        }
                        if (_this2.ssr.state === $2b059f1e9e6b20d6$var$state.ignoring && mutation.timestamp > _this2.ssr.renderStart && mutation.target === _this2.ssr.reactRootElement) {
                            if (mutation.timestamp <= _this2.ssr.renderStop) ignoreReason = 'ssr-hydration';
                            else _this2.ssr.state = $2b059f1e9e6b20d6$var$state.normal;
                        }
                        if (mutation.type === 'childList') {
                            mutation.addedNodes.forEach(function(node) {
                                if ((0, $cDJdu.isContainedWithinMediaWrapper)(node)) ignoreReason = 'image';
                                if (node instanceof HTMLElement) {
                                    if (_this2.ssrPlaceholderHandler.isPlaceholder(node) || _this2.ssrPlaceholderHandler.isPlaceholderIgnored(node)) {
                                        _this2.ssrPlaceholderHandler.checkIfExistedAndSizeMatching(node).then(function(result) {
                                            if (result === false) _this2.observeElement(node, mutation, 'html', ignoreReason);
                                        });
                                        return;
                                    }
                                    if (_this2.ssrPlaceholderHandler.isPlaceholderReplacement(node) || _this2.ssrPlaceholderHandler.isPlaceholderIgnored(node)) {
                                        _this2.ssrPlaceholderHandler.validateReactComponentMatchToPlaceholder(node).then(function(result) {
                                            if (result === false) _this2.observeElement(node, mutation, 'html', ignoreReason);
                                        });
                                        return;
                                    }
                                    _this2.observeElement(node, mutation, 'html', ignoreReason);
                                }
                                if (node instanceof Text && node.parentElement != null) _this2.observeElement(node.parentElement, mutation, 'text', ignoreReason);
                            });
                            mutation.removedNodes.forEach(function(node) {
                                if (node instanceof Element) {
                                    var _this2$intersectionOb;
                                    _this2.elementsInView.delete(node);
                                    (_this2$intersectionOb = _this2.intersectionObserver) === null || _this2$intersectionOb === void 0 || _this2$intersectionOb.unobserve(node);
                                }
                            });
                        } else if (mutation.type === 'attributes') {
                            if (mutation.target instanceof HTMLElement) {
                                var _mutation$oldValue;
                                var attributeName = mutation.attributeName;
                                /*
              	"MutationObserver was explicitly designed to work that way, but I can't now recall the reasoning.
              	I think it might have been something along the lines that for consistency every setAttribute call should create a record.
              	Conceptually there is after all a mutation: there is an old value replaced with a new one,
              	and whether or not they are the same doesn't really matter.
              	And Custom elements should work the same way as MutationObserver."
              	https://github.com/whatwg/dom/issues/520#issuecomment-336574796
              */ var oldValue = (_mutation$oldValue = mutation.oldValue) !== null && _mutation$oldValue !== void 0 ? _mutation$oldValue : undefined;
                                var newValue = attributeName ? mutation.target.getAttribute(attributeName) : undefined;
                                if (oldValue !== newValue) {
                                    if ((0, $lj1OM.default)(mutation)) ignoreReason = 'non-visual-style';
                                    if ((0, $cDJdu.isContainedWithinMediaWrapper)(mutation.target)) ignoreReason = 'image';
                                    _this2.observeElement(mutation.target, mutation, 'attr', ignoreReason, attributeName, oldValue, newValue);
                                }
                            }
                        }
                    });
                });
            }
        },
        {
            key: "getElementName",
            value: function getElementName(element) {
                try {
                    var tagName = element.localName;
                    var dataVCAttr = element.getAttribute('data-vc');
                    var dataVC = this.selectorConfig.dataVC && dataVCAttr ? "[data-vc=\"".concat(dataVCAttr, "\"]") : '';
                    var id = this.selectorConfig.id && element.id ? "#".concat(element.id) : '';
                    var testId = this.selectorConfig.testId ? element.getAttribute('data-testid') || element.getAttribute('data-test-id') : '';
                    testId = testId ? "[testid=".concat(testId, "]") : '';
                    var role = this.selectorConfig.role ? element.getAttribute('role') : '';
                    role = role ? "[role=".concat(role, "]") : '';
                    var classList = this.selectorConfig.className ? Array.from(element.classList).join('.') : '';
                    classList = classList === '' ? '' : ".".concat(classList);
                    var attrs = dataVC ? dataVC : [
                        id,
                        testId,
                        role
                    ].join('');
                    var idString = '';
                    if (attrs === '' && classList === '') {
                        var parent = element.parentElement ? this.getElementName(element.parentElement) : 'unknown';
                        idString = "".concat(parent, " > ").concat(tagName);
                    } else idString = [
                        tagName,
                        attrs || classList
                    ].join('');
                    return idString;
                } catch (e) {
                    return 'error';
                }
            }
        },
        {
            key: "getIntersectionObserver",
            value: function getIntersectionObserver() {
                var _this3 = this;
                if (!this.isBrowserSupported()) return null;
                return new IntersectionObserver(function(entries) {
                    _this3.measureStart();
                    entries.forEach(function(_ref) {
                        var isIntersecting = _ref.isIntersecting, ir = _ref.intersectionRect, target = _ref.target;
                        var data = _this3.observedMutations.get(target);
                        _this3.observedMutations.delete(target);
                        if (isIntersecting && ir.width > 0 && ir.height > 0) {
                            if (!(target instanceof HTMLElement)) return;
                            if (!(data !== null && data !== void 0 && data.mutation)) // ignore intersection report without recent mutation
                            return;
                            if (!$2b059f1e9e6b20d6$var$isElementVisible(target)) data.ignoreReason = 'not-visible';
                            if ((0, $hakpj.RLLPlaceholderHandlers).getInstance().isRLLPlaceholderHydration(ir)) data.ignoreReason = 'rll-placeholder';
                            _this3.callbacks.forEach(function(callback) {
                                var elementName;
                                try {
                                    elementName = _this3.getElementName(target);
                                } catch (e) {
                                    elementName = 'error';
                                }
                                callback(data.mutation.timestamp || performance.now(), ir, elementName, target, data.type, data.ignoreReason, data.attributeName, data.oldValue, data.newValue);
                            });
                            _this3.elementsInView.add(target);
                        } else _this3.elementsInView.delete(target);
                    });
                    _this3.measureStop();
                });
            }
        },
        {
            key: "measureStart",
            value: function measureStart() {
                this._startMeasureTimestamp = performance.now();
            }
        },
        {
            key: "measureStop",
            value: function measureStop() {
                if (this._startMeasureTimestamp === -1) return;
                this.totalTime += performance.now() - this._startMeasureTimestamp;
                this._startMeasureTimestamp = -1;
            }
        }
    ]);
}();

});
parcelRegister("cDJdu", function(module, exports) {
$parcel$export(module.exports, "isContainedWithinMediaWrapper", () => $933c33a2ef685c31$export$f61fbc3b9c4a9019);

var $d1hf4 = parcelRequire("d1hf4");
function $933c33a2ef685c31$export$f61fbc3b9c4a9019(node) {
    while(node){
        if (node instanceof Element && node.hasAttribute((0, $d1hf4.MEDIA_WRAPPER_TAG))) return true;
        node = node.parentNode;
    }
    return false;
}

});
parcelRegister("d1hf4", function(module, exports) {
$parcel$export(module.exports, "MEDIA_WRAPPER_TAG", () => $97a8be428787b42a$export$7674290405cc25b0);
$parcel$export(module.exports, "VcMediaWrapperProps", () => $97a8be428787b42a$export$7028e9efe569888c);

var $25nEq = parcelRequire("25nEq");

var $5FkrB = parcelRequire("5FkrB");
var $97a8be428787b42a$export$7674290405cc25b0 = 'data-media-vc-wrapper';
var $97a8be428787b42a$export$7028e9efe569888c = (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, $97a8be428787b42a$export$7674290405cc25b0, true);
function $97a8be428787b42a$export$2e2bcd8739ae039(_ref) {
    var children = _ref.children;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("div", $97a8be428787b42a$export$7028e9efe569888c, children);
}

});


parcelRegister("lj1OM", function(module, exports) {
$parcel$export(module.exports, "default", () => $f82cc85d99ce8b0b$export$2e2bcd8739ae039);
/**
 * Checks if a mutation record represents a non-visual style change
 * @param mutation - The mutation record to check
 * @returns boolean indicating if this is a non-visual style mutation
 *
 * A mutation is considered non-visual if:
 * - The target has data-	vc-nvs="true" attribute
 * - The changed attribute is either 'class' or 'style'
 */ function $f82cc85d99ce8b0b$var$isNonVisualStyleMutation(_ref) {
    var target = _ref.target, attributeName = _ref.attributeName;
    if (!(target instanceof Element)) return false;
    if (attributeName !== 'class' && attributeName !== 'style') return false;
    if (target.getAttribute('data-vc-nvs') !== 'true') return false;
    return true;
}
var $f82cc85d99ce8b0b$export$2e2bcd8739ae039 = $f82cc85d99ce8b0b$var$isNonVisualStyleMutation;

});

parcelRegister("hakpj", function(module, exports) {
$parcel$export(module.exports, "RLLPlaceholderHandlers", () => $c7f3334f039ee800$export$166779fc0f49d4df);

var $fC8ib = parcelRequire("fC8ib");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $25nEq = parcelRequire("25nEq");
var $c7f3334f039ee800$var$GLOBAL_RLL_HANDLERS_KEY = '__REACT_UFO_RLL_PLACEHOLDER_HANDLERS__';
var $c7f3334f039ee800$export$166779fc0f49d4df = /*#__PURE__*/ function() {
    function RLLPlaceholderHandlers() {
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, RLLPlaceholderHandlers);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "placeholders", []);
        if (typeof window !== 'undefined' && typeof document !== 'undefined' && typeof window.document !== 'undefined') this.collectRLLPlaceholders();
    }
    /**
   * Gets the global singleton instance of RLLPlaceholderHandlers.
   * Creates the instance if it doesn't exist and stores it in globalThis.
   * @returns The singleton instance of RLLPlaceholderHandlers
   */ return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(RLLPlaceholderHandlers, [
        {
            key: "reset",
            value: function reset() {
                this.placeholders = [];
            }
        },
        {
            key: "collectRLLPlaceholders",
            value: function collectRLLPlaceholders() {
                if (typeof window === 'undefined' || typeof document === 'undefined' || typeof window.document === 'undefined') return;
                var beginElements = document.querySelectorAll('input[data-lazy-begin]');
                var beginCount = beginElements.length;
                if (beginCount === 0) return;
                // Performance optimization: pre-allocate array with estimated size
                var allElements = [];
                // Performance optimization: use traditional for loop instead of forEach
                for(var i = 0; i < beginCount; i++){
                    var beginEl = beginElements[i];
                    var id = beginEl.getAttribute('data-lazy-begin');
                    if (!id) continue;
                    var elements = this.refElements(beginEl, id);
                    if (elements.length > 0) allElements.push.apply(allElements, (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(elements));
                }
                // Second pass: batch all getBoundingClientRect calls to minimize reflow cycles
                var allElementsLength = allElements.length;
                if (allElementsLength > 0) {
                    // Performance optimization: pre-allocate array with exact size
                    var intersectingRects = [];
                    var windowWidth = window.innerWidth;
                    var windowHeight = window.innerHeight;
                    for(var _i = 0; _i < allElementsLength; _i++){
                        var rect = allElements[_i].getBoundingClientRect();
                        // Performance optimization: inline intersection calculation to avoid function call overhead
                        var left = Math.max(rect.left, 0);
                        var top = Math.max(rect.top, 0);
                        var right = Math.min(rect.right, windowWidth);
                        var bottom = Math.min(rect.bottom, windowHeight);
                        // Check if there's a valid intersection with non-zero width and height
                        if (left < right && top < bottom) intersectingRects.push(new DOMRect(left, top, right - left, bottom - top));
                    }
                    this.placeholders = intersectingRects;
                }
            }
        },
        {
            key: "refElements",
            value: function refElements(fromEl, id) {
                var result = [];
                var el = fromEl.nextSibling;
                // Performance optimization: use while loop instead of recursive calls
                while(el){
                    var _el$dataset;
                    if (((_el$dataset = el.dataset) === null || _el$dataset === void 0 ? void 0 : _el$dataset.lazyEnd) === id) break;
                    if (el.nodeType === Node.ELEMENT_NODE) result.push(el);
                    el = el.nextSibling;
                }
                return result;
            }
        },
        {
            key: "getPlaceholders",
            value: function getPlaceholders() {
                return this.placeholders;
            }
        },
        {
            key: "isRLLPlaceholderHydration",
            value: function isRLLPlaceholderHydration(intersectingRect) {
                var placeholdersLength = this.placeholders.length;
                if (placeholdersLength === 0) return false;
                // Performance optimization: cache array length and use traditional for loop
                for(var i = 0; i < placeholdersLength; i++){
                    var placeholderRect = this.placeholders[i];
                    if (this.areRectsEqual(intersectingRect, placeholderRect)) return true;
                }
                return false;
            }
        },
        {
            key: "areRectsEqual",
            value: function areRectsEqual(rect1, rect2) {
                // Early exit for exact matches (most common case)
                if (rect1.left === rect2.left && rect1.top === rect2.top && rect1.right === rect2.right && rect1.bottom === rect2.bottom) return true;
                // Performance optimization: check largest differences first for early exit
                var leftDiff = rect1.left - rect2.left;
                if (leftDiff > 1 || leftDiff < -1) return false;
                var rightDiff = rect1.right - rect2.right;
                if (rightDiff > 1 || rightDiff < -1) return false;
                var topDiff = rect1.top - rect2.top;
                if (topDiff > 1 || topDiff < -1) return false;
                var bottomDiff = rect1.bottom - rect2.bottom;
                if (bottomDiff > 1 || bottomDiff < -1) return false;
                return true;
            }
        }
    ], [
        {
            key: "getInstance",
            value: function getInstance() {
                if (typeof globalThis !== 'undefined') {
                    if (!globalThis[$c7f3334f039ee800$var$GLOBAL_RLL_HANDLERS_KEY]) globalThis[$c7f3334f039ee800$var$GLOBAL_RLL_HANDLERS_KEY] = new RLLPlaceholderHandlers();
                    return globalThis[$c7f3334f039ee800$var$GLOBAL_RLL_HANDLERS_KEY];
                }
                // Fallback for environments without globalThis (should be rare)
                return new RLLPlaceholderHandlers();
            }
        }
    ]);
}();

});

parcelRegister("k6qaT", function(module, exports) {
$parcel$export(module.exports, "SSRPlaceholderHandlers", () => $ea28abe9e4080efa$export$c0102f1a1198d10f);

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $25nEq = parcelRequire("25nEq");

var $9Zzpd = parcelRequire("9Zzpd");
var $ea28abe9e4080efa$var$ANCESTOR_LOOKUP_LIMIT = 10;
var $ea28abe9e4080efa$var$PAGE_LAYOUT_ID = 'page-layout.root';
var $ea28abe9e4080efa$export$c0102f1a1198d10f = /*#__PURE__*/ function() {
    function SSRPlaceholderHandlers(_ref) {
        var _this = this;
        var _ref$enablePageLayout = _ref.enablePageLayoutPlaceholder, enablePageLayoutPlaceholder = _ref$enablePageLayout === void 0 ? false : _ref$enablePageLayout;
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, SSRPlaceholderHandlers);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "staticPlaceholders", new Map());
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "callbacks", new Map());
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "getSizeCallbacks", new Map());
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "reactValidateCallbacks", new Map());
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "EQUALITY_THRESHOLD", 1);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "getPlaceholderId", function(el) {
            var _el$dataset;
            var ssrPlaceholderId = el === null || el === void 0 || (_el$dataset = el.dataset) === null || _el$dataset === void 0 ? void 0 : _el$dataset.ssrPlaceholder;
            if (!!ssrPlaceholderId) return ssrPlaceholderId;
            if (_this.enablePageLayoutPlaceholder && (el === null || el === void 0 ? void 0 : el.dataset.testid) === $ea28abe9e4080efa$var$PAGE_LAYOUT_ID) return $ea28abe9e4080efa$var$PAGE_LAYOUT_ID;
            return '';
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "getPlaceholderReplacementId", function(el) {
            var _el$dataset2;
            var ssrPlaceholderReplaceId = el === null || el === void 0 || (_el$dataset2 = el.dataset) === null || _el$dataset2 === void 0 ? void 0 : _el$dataset2.ssrPlaceholderReplace;
            if (!!ssrPlaceholderReplaceId) return ssrPlaceholderReplaceId;
            if (_this.enablePageLayoutPlaceholder && (el === null || el === void 0 ? void 0 : el.dataset.testid) === $ea28abe9e4080efa$var$PAGE_LAYOUT_ID) return $ea28abe9e4080efa$var$PAGE_LAYOUT_ID;
            return '';
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "intersectionObserverCallback", function(_ref2) {
            var _this$intersectionObs;
            var target = _ref2.target, boundingClientRect = _ref2.boundingClientRect;
            (_this$intersectionObs = _this.intersectionObserver) === null || _this$intersectionObs === void 0 || _this$intersectionObs.unobserve(target);
            if (!(target instanceof HTMLElement)) // impossible case - keep typescript healthy
            return;
            var staticKey = _this.getPlaceholderId(target);
            if (staticKey) {
                if (_this.staticPlaceholders.has(staticKey) && _this.callbacks.has(staticKey)) {
                    // validation
                    var _resolve = _this.callbacks.get(staticKey);
                    if (!_resolve) return;
                    var rect = _this.staticPlaceholders.get(staticKey);
                    var hasSameSizePosition = _this.hasSameSizePosition(rect, boundingClientRect);
                    if (hasSameSizePosition || _this.isDummyRect(rect)) _resolve(hasSameSizePosition);
                    else requestAnimationFrame(function() {
                        var targetRect = _this.getEffectiveBoundingRect(target);
                        var hasSameSizePosition = _this.hasSameSizePosition(rect, targetRect);
                        _resolve(hasSameSizePosition);
                    });
                    _this.callbacks.delete(staticKey);
                }
            } else {
                var key = _this.getPlaceholderReplacementId(target);
                var _resolve2 = _this.reactValidateCallbacks.get(key);
                if (!_resolve2) return;
                var _rect = _this.staticPlaceholders.get(key);
                var _hasSameSizePosition = _this.hasSameSizePosition(_rect, boundingClientRect);
                if (_hasSameSizePosition || _this.isDummyRect(_rect)) _resolve2(_hasSameSizePosition);
                else requestAnimationFrame(function() {
                    var targetRect = _this.getEffectiveBoundingRect(target);
                    var hasSameSizePosition = _this.hasSameSizePosition(_rect, targetRect);
                    _resolve2(hasSameSizePosition);
                });
                _this.staticPlaceholders.delete(staticKey);
                _this.reactValidateCallbacks.delete(staticKey);
            }
        });
        if (typeof IntersectionObserver === 'function') // Only instantiate the IntersectionObserver if it's supported
        this.intersectionObserver = new IntersectionObserver(function(entries) {
            return entries.filter(function(entry) {
                return entry.intersectionRatio > 0;
            }).forEach(_this.intersectionObserverCallback);
        });
        this.enablePageLayoutPlaceholder = enablePageLayoutPlaceholder;
        if (window.document) try {
            // Collect initial placeholders using SSR dimensions
            this.collectPlaceholdersInternal();
        } catch (e) {} finally{
            delete window.__SSR_PLACEHOLDERS_DIMENSIONS__;
        }
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(SSRPlaceholderHandlers, [
        {
            key: "clear",
            value: function clear() {
                this.staticPlaceholders = new Map();
                this.callbacks = new Map();
                this.getSizeCallbacks = new Map();
                this.reactValidateCallbacks = new Map();
            }
        },
        {
            key: "collectPlaceholdersInternal",
            value: function collectPlaceholdersInternal() {
                var _this2 = this;
                var selector = this.enablePageLayoutPlaceholder ? '[data-ssr-placeholder],[data-testid="page-layout.root"]' : '[data-ssr-placeholder]';
                var existingElements = document.querySelectorAll(selector);
                existingElements.forEach(function(el) {
                    var placeholderId = el instanceof HTMLElement && _this2.getPlaceholderId(el);
                    if (placeholderId && !_this2.staticPlaceholders.has(placeholderId)) {
                        var _window$__SSR_PLACEHO, _this2$intersectionOb;
                        var width = -1;
                        var height = -1;
                        var x = -1;
                        var y = -1;
                        // Use SSR dimensions from window global if available
                        var boundingClientRect = (_window$__SSR_PLACEHO = window.__SSR_PLACEHOLDERS_DIMENSIONS__) === null || _window$__SSR_PLACEHO === void 0 ? void 0 : _window$__SSR_PLACEHO[placeholderId];
                        if (boundingClientRect) {
                            width = boundingClientRect.width;
                            height = boundingClientRect.height;
                            x = boundingClientRect.x;
                            y = boundingClientRect.y;
                        } else {
                            // Fallback to current bounding rect if SSR dimensions not available
                            var rect = el.getBoundingClientRect();
                            width = rect.width;
                            height = rect.height;
                            x = rect.x;
                            y = rect.y;
                        }
                        _this2.staticPlaceholders.set(placeholderId, {
                            width: width,
                            height: height,
                            x: x,
                            y: y
                        });
                        (_this2$intersectionOb = _this2.intersectionObserver) === null || _this2$intersectionOb === void 0 || _this2$intersectionOb.observe(el);
                    }
                });
            }
        },
        {
            key: "collectExistingPlaceholders",
            value: function collectExistingPlaceholders() {
                if (!window.document) return;
                try {
                    // Collect placeholders using SSR dimensions or fallback to live dimensions
                    this.collectPlaceholdersInternal();
                } catch (e) {
                // Silently fail if there are any issues
                } finally{
                    delete window.__SSR_PLACEHOLDERS_DIMENSIONS__;
                }
            }
        },
        {
            key: "isPlaceholder",
            value: function isPlaceholder(element) {
                return Boolean(this.getPlaceholderId(element));
            }
        },
        {
            key: "isPlaceholderReplacement",
            value: function isPlaceholderReplacement(element) {
                return Boolean(this.getPlaceholderReplacementId(element));
            }
        },
        {
            key: "isPlaceholderIgnored",
            value: function isPlaceholderIgnored(element) {
                // data-ssr-placeholder-ignored doesn't have a value.
                return 'ssrPlaceholderIgnored' in element.dataset;
            }
        },
        {
            key: "isPlaceholderV4",
            value: function isPlaceholderV4(element) {
                var currentElement = element;
                var i = 0;
                while(currentElement && i < $ea28abe9e4080efa$var$ANCESTOR_LOOKUP_LIMIT){
                    if (Boolean(this.getPlaceholderId(currentElement))) return true;
                    currentElement = currentElement.parentElement;
                    i++;
                }
                return false;
            }
        },
        {
            key: "isPlaceholderReplacementV4",
            value: function isPlaceholderReplacementV4(element) {
                var currentElement = element;
                var i = 0;
                while(currentElement && i < $ea28abe9e4080efa$var$ANCESTOR_LOOKUP_LIMIT){
                    if (Boolean(this.getPlaceholderReplacementId(currentElement))) return true;
                    currentElement = currentElement.parentElement;
                    i++;
                }
                return false;
            }
        },
        {
            key: "findNearestPlaceholderContainerIfIgnored",
            value: function findNearestPlaceholderContainerIfIgnored(element) {
                if (!this.isPlaceholderIgnored(element)) return element;
                var ancestor = element.parentElement;
                var i = 0;
                while(ancestor && i < $ea28abe9e4080efa$var$ANCESTOR_LOOKUP_LIMIT){
                    if (this.isPlaceholder(ancestor) || this.isPlaceholderReplacement(ancestor)) return ancestor;
                    ancestor = ancestor.parentElement;
                    i++;
                }
                return element;
            }
        },
        {
            key: "findNearestPlaceholderOrContainer",
            value: function findNearestPlaceholderOrContainer(element) {
                var limit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $ea28abe9e4080efa$var$ANCESTOR_LOOKUP_LIMIT;
                var ancestor = element;
                if (this.isPlaceholderIgnored(element) && element.parentElement) ancestor = element.parentElement;
                var i = 0;
                while(ancestor && i < limit){
                    if (this.isPlaceholder(ancestor) || this.isPlaceholderReplacement(ancestor)) return ancestor;
                    if (ancestor.parentElement) {
                        ancestor = ancestor.parentElement;
                        i++;
                    } else break;
                }
                return element;
            }
        },
        {
            key: "checkIfExistedAndSizeMatching",
            value: function checkIfExistedAndSizeMatching(el) {
                var _this3 = this;
                el = this.findNearestPlaceholderContainerIfIgnored(el);
                var id = this.getPlaceholderId(el);
                return new Promise(function(resolve) {
                    if (!_this3.staticPlaceholders.has(id)) {
                        resolve(false);
                        return;
                    } else {
                        var _this3$intersectionOb;
                        _this3.callbacks.set(id, resolve);
                        (_this3$intersectionOb = _this3.intersectionObserver) === null || _this3$intersectionOb === void 0 || _this3$intersectionOb.observe(el);
                    }
                });
            }
        },
        {
            key: "checkIfExistedAndSizeMatchingV3",
            value: function checkIfExistedAndSizeMatchingV3(el) {
                el = this.findNearestPlaceholderContainerIfIgnored(el);
                var id = this.getPlaceholderId(el);
                var placeholderRects = this.staticPlaceholders.get(id);
                if (!placeholderRects) return false;
                return this.hasSameSizePosition(placeholderRects, this.getEffectiveBoundingRect(el));
            }
        },
        {
            key: "getSize",
            value: function getSize(el) {
                var _this4 = this;
                return new Promise(function(resolve) {
                    var _this4$intersectionOb;
                    _this4.getSizeCallbacks.set(_this4.getPlaceholderId(el), resolve);
                    (_this4$intersectionOb = _this4.intersectionObserver) === null || _this4$intersectionOb === void 0 || _this4$intersectionOb.observe(el);
                });
            }
        },
        {
            key: "validateReactComponentMatchToPlaceholder",
            value: function validateReactComponentMatchToPlaceholder(el) {
                var _this5 = this;
                el = this.findNearestPlaceholderContainerIfIgnored(el);
                var id = this.getPlaceholderReplacementId(el);
                return new Promise(function(resolve) {
                    if (!_this5.staticPlaceholders.has(id)) {
                        resolve(false);
                        return;
                    } else {
                        var _this5$intersectionOb;
                        _this5.reactValidateCallbacks.set(id, resolve);
                        (_this5$intersectionOb = _this5.intersectionObserver) === null || _this5$intersectionOb === void 0 || _this5$intersectionOb.observe(el);
                    }
                });
            }
        },
        {
            key: "validateReactComponentMatchToPlaceholderV4",
            value: function validateReactComponentMatchToPlaceholderV4(el) {
                el = (0, $9Zzpd.fg)('platform_ufo_v4_fix_nested_ssr_placeholder') ? this.findNearestPlaceholderOrContainer(el, 2) // We are using 2 due to over-eagerness of the default, only check itself and 1 ancestor
                 : this.findNearestPlaceholderContainerIfIgnored(el);
                var id = this.getPlaceholderReplacementId(el);
                return this.staticPlaceholders.has(id);
            }
        },
        {
            key: "hasSameSizePosition",
            value: function hasSameSizePosition(rect, boundingClientRect) {
                if (!rect) return false;
                var horizontalCheck = Math.abs(rect.x - boundingClientRect.x) < this.EQUALITY_THRESHOLD && Math.abs(rect.width - boundingClientRect.width) < this.EQUALITY_THRESHOLD;
                var verticalCheck = Math.abs(rect.y - boundingClientRect.y) < this.EQUALITY_THRESHOLD && Math.abs(rect.height - boundingClientRect.height) < this.EQUALITY_THRESHOLD;
                return horizontalCheck && verticalCheck || false;
            }
        },
        {
            key: "getEffectiveBoundingRect",
            value: function getEffectiveBoundingRect(el) {
                if ((0, $9Zzpd.fg)('platform_ufo_disable_vcnext_observations')) return el.getBoundingClientRect();
                var computedStyle = window.getComputedStyle(el);
                // If element has display: contents, collect bounding rect from children
                if (computedStyle.display === 'contents') {
                    var children = Array.from(el.children);
                    if (children.length === 0) // No children, return zero rect
                    return new DOMRect(0, 0, 0, 0);
                    // Calculate union of all children's bounding rects
                    var minX = Infinity;
                    var minY = Infinity;
                    var maxX = -Infinity;
                    var maxY = -Infinity;
                    children.forEach(function(child) {
                        var childRect = child.getBoundingClientRect();
                        // Skip children with zero dimensions (likely also display: contents)
                        if (childRect.width > 0 || childRect.height > 0) {
                            minX = Math.min(minX, childRect.left);
                            minY = Math.min(minY, childRect.top);
                            maxX = Math.max(maxX, childRect.right);
                            maxY = Math.max(maxY, childRect.bottom);
                        }
                    });
                    // If no children with dimensions found, return zero rect
                    if (minX === Infinity) return new DOMRect(0, 0, 0, 0);
                    return new DOMRect(minX, minY, maxX - minX, maxY - minY);
                }
                // Normal element, return its bounding rect
                return el.getBoundingClientRect();
            }
        },
        {
            key: "isDummyRect",
            value: function isDummyRect(rect) {
                return rect && rect.width < 0 && rect.height < 0 || false;
            }
        }
    ]);
}();

});




parcelRegister("az8pZ", function(module, exports) {
$parcel$export(module.exports, "sinkExtraSearchPageInteractionHandler", () => $7b13b3f38b23e1ea$export$e6a07a94f3e112d4);
$parcel$export(module.exports, "onSearchPageInteractionComplete", () => $7b13b3f38b23e1ea$export$74b9ce7e9d206a8);
function $7b13b3f38b23e1ea$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $7b13b3f38b23e1ea$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $7b13b3f38b23e1ea$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $7b13b3f38b23e1ea$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $7b13b3f38b23e1ea$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $7b13b3f38b23e1ea$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
var $7b13b3f38b23e1ea$var$interactionBuffer = [];
var $7b13b3f38b23e1ea$var$bufferInteractionData = function bufferInteractionData(interactionId, data) {
    $7b13b3f38b23e1ea$var$interactionBuffer.push({
        interactionId: interactionId,
        data: data
    });
};
function $7b13b3f38b23e1ea$var$clearInteractionBuffer() {
    $7b13b3f38b23e1ea$var$interactionBuffer.length = 0;
}
function $7b13b3f38b23e1ea$var$appendInteractionData(interactionId, data) {
    $7b13b3f38b23e1ea$var$bufferInteractionData(interactionId, data);
}
function $7b13b3f38b23e1ea$var$installInteractionSink(handler) {
    var _iterator = $7b13b3f38b23e1ea$var$_createForOfIteratorHelper($7b13b3f38b23e1ea$var$interactionBuffer), _step;
    try {
        for(_iterator.s(); !(_step = _iterator.n()).done;){
            var _step$value = _step.value, _interactionId = _step$value.interactionId, data = _step$value.data;
            handler(_interactionId, data);
        }
    } catch (err) {
        _iterator.e(err);
    } finally{
        _iterator.f();
    }
    $7b13b3f38b23e1ea$var$clearInteractionBuffer();
    $7b13b3f38b23e1ea$var$bufferInteractionData = handler;
}
function $7b13b3f38b23e1ea$export$e6a07a94f3e112d4(sinkFn) {
    $7b13b3f38b23e1ea$var$installInteractionSink(sinkFn);
}
function $7b13b3f38b23e1ea$export$74b9ce7e9d206a8(interactionId, data) {
    if (data.ufoName) {
        $7b13b3f38b23e1ea$var$appendInteractionData(interactionId, data);
        $7b13b3f38b23e1ea$var$clearInteractionBuffer();
    }
}

});

parcelRegister("e8igD", function(module, exports) {
$parcel$export(module.exports, "sanitizeUfoName", () => $a49ffb9144c044ff$export$e08487ea3ae92adb);
$parcel$export(module.exports, "isSegmentLabel", () => $a49ffb9144c044ff$export$1adbaf5c2363e4ae);
$parcel$export(module.exports, "buildSegmentTree", () => $a49ffb9144c044ff$export$1569bc0edeecbcd8);
$parcel$export(module.exports, "stringifyLabelStackFully", () => $a49ffb9144c044ff$export$caeee352b541de1f);
$parcel$export(module.exports, "labelStackStartWith", () => $a49ffb9144c044ff$export$1787b1cd413c7e2);
$parcel$export(module.exports, "optimizeLabelStack", () => $a49ffb9144c044ff$export$a0cd72da07c76b4c);
$parcel$export(module.exports, "getOldSegmentsLabelStack", () => $a49ffb9144c044ff$export$b70bcfd92c93435e);

var $1Vcia = parcelRequire("1Vcia");

var $25nEq = parcelRequire("25nEq");

var $9Zzpd = parcelRequire("9Zzpd");

var $DtLwq = parcelRequire("DtLwq");

var $7GIrK = parcelRequire("7GIrK");
var $a49ffb9144c044ff$var$_excluded = [
    "labelStack"
], $a49ffb9144c044ff$var$_excluded2 = [
    "labelStack"
];
function $a49ffb9144c044ff$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $a49ffb9144c044ff$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $a49ffb9144c044ff$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $a49ffb9144c044ff$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $a49ffb9144c044ff$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $a49ffb9144c044ff$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $a49ffb9144c044ff$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $a49ffb9144c044ff$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $a49ffb9144c044ff$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $a49ffb9144c044ff$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $a49ffb9144c044ff$export$e08487ea3ae92adb(name) {
    return name.replace(/_/g, '-');
}
function $a49ffb9144c044ff$export$1adbaf5c2363e4ae(obj) {
    return obj && typeof obj.name === 'string' && typeof obj.segmentId === 'string';
}
function $a49ffb9144c044ff$export$1569bc0edeecbcd8(labelStacks) {
    var r = {
        n: 'segment-tree-root',
        c: {}
    };
    var config = (0, $DtLwq.getConfig)();
    var segmentThreshold = config === null || config === void 0 ? void 0 : config.segmentsThreshold;
    var addSegmentsMap = new Map();
    if ((0, $9Zzpd.fg)('platform_ufo_add_segments_count_threshold')) labelStacks.forEach(function(labelStack) {
        var stringifiedLabelStack = $a49ffb9144c044ff$export$88f21baa687271f4(labelStack);
        var currentNode = r;
        var _iterator = $a49ffb9144c044ff$var$_createForOfIteratorHelper(labelStack), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var label = _step.value;
                var isSegment = $a49ffb9144c044ff$export$1adbaf5c2363e4ae(label);
                var name = label.name;
                if (isSegment && segmentThreshold && segmentThreshold[name]) {
                    var threshold = segmentThreshold[name];
                    var count = addSegmentsMap.get(stringifiedLabelStack) || 0;
                    if (count < threshold) addSegmentsMap.set(stringifiedLabelStack, count + 1);
                    else break;
                }
                var id = isSegment ? label.segmentId : undefined;
                var key = id !== undefined ? id : name;
                var type = isSegment ? label.type : undefined;
                if (!currentNode.c) currentNode.c = {};
                if (!currentNode.c[key]) currentNode.c[key] = $a49ffb9144c044ff$var$_objectSpread({
                    n: name
                }, type ? {
                    t: type
                } : {});
                currentNode = currentNode.c[key];
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
    });
    else labelStacks.forEach(function(labelStack) {
        var currentNode = r;
        labelStack.forEach(function(label) {
            var name = label.name;
            var id = $a49ffb9144c044ff$export$1adbaf5c2363e4ae(label) ? label.segmentId : undefined;
            var key = id !== undefined ? id : name;
            var type = $a49ffb9144c044ff$export$1adbaf5c2363e4ae(label) ? label.type : undefined;
            if (!currentNode.c) currentNode.c = {};
            if (!currentNode.c[key]) currentNode.c[key] = $a49ffb9144c044ff$var$_objectSpread({
                n: name
            }, type ? {
                t: type
            } : {});
            currentNode = currentNode.c[key];
        });
    });
    return {
        r: r
    };
}
function $a49ffb9144c044ff$export$caeee352b541de1f(labelStack) {
    return labelStack.map(function(l) {
        if ($a49ffb9144c044ff$export$1adbaf5c2363e4ae(l)) return "".concat(l.name, ":").concat(l.segmentId);
        return l.name;
    }).join('/');
}
function $a49ffb9144c044ff$export$88f21baa687271f4(labelStack) {
    return labelStack.map(function(l) {
        if ($a49ffb9144c044ff$export$1adbaf5c2363e4ae(l)) return "".concat(l.name, ":segment");
        return l.name;
    }).join('/');
}
function $a49ffb9144c044ff$var$getLabelStackReference(labelStack) {
    return labelStack.map(function(l) {
        return $a49ffb9144c044ff$export$1adbaf5c2363e4ae(l) ? l.segmentId : l.name;
    }).join('/');
}
function $a49ffb9144c044ff$export$1787b1cd413c7e2(labelStack, startWith) {
    return $a49ffb9144c044ff$export$caeee352b541de1f(labelStack).startsWith($a49ffb9144c044ff$export$caeee352b541de1f(startWith));
}
function $a49ffb9144c044ff$export$a0cd72da07c76b4c(labelStack, reactUFOVersion) {
    return reactUFOVersion === '2.0.0' ? $a49ffb9144c044ff$var$getLabelStackReference(labelStack) : labelStack.map(function(ls) {
        return $a49ffb9144c044ff$var$_objectSpread($a49ffb9144c044ff$var$_objectSpread({
            n: ls.name
        }, ls.segmentId ? {
            s: ls.segmentId
        } : {}), ls.type ? {
            t: ls.type
        } : {});
    });
}
function $a49ffb9144c044ff$export$b70bcfd92c93435e(segments, interactionType) {
    if ((0, $9Zzpd.fg)('platform_ufo_add_segments_count_threshold')) {
        var config = (0, $DtLwq.getConfig)();
        var addSegmentsMap = new Map();
        var segmentThreshold = config === null || config === void 0 ? void 0 : config.segmentsThreshold;
        return segments.map(function(_ref) {
            var labelStack = _ref.labelStack, others = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $a49ffb9144c044ff$var$_excluded);
            var stringifiedLabelStack = $a49ffb9144c044ff$export$88f21baa687271f4(labelStack);
            var segmentsInfo = [];
            var _iterator2 = $a49ffb9144c044ff$var$_createForOfIteratorHelper(labelStack), _step2;
            try {
                for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                    var ls = _step2.value;
                    var isSegment = $a49ffb9144c044ff$export$1adbaf5c2363e4ae(ls);
                    if (isSegment && segmentThreshold && segmentThreshold[ls.name]) {
                        var threshold = segmentThreshold[ls.name];
                        var count = addSegmentsMap.get(stringifiedLabelStack) || 0;
                        if (count < threshold) addSegmentsMap.set(stringifiedLabelStack, count + 1);
                        else break;
                    }
                    segmentsInfo.push($a49ffb9144c044ff$var$_objectSpread($a49ffb9144c044ff$var$_objectSpread({
                        n: ls.name
                    }, ls.segmentId ? {
                        s: ls.segmentId
                    } : {}), ls.type ? {
                        t: ls.type
                    } : {}));
                }
            } catch (err) {
                _iterator2.e(err);
            } finally{
                _iterator2.f();
            }
            return $a49ffb9144c044ff$var$_objectSpread($a49ffb9144c044ff$var$_objectSpread({}, others), {}, {
                labelStack: segmentsInfo
            });
        });
    }
    return segments.map(function(_ref2) {
        var labelStack = _ref2.labelStack, others = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref2, $a49ffb9144c044ff$var$_excluded2);
        return $a49ffb9144c044ff$var$_objectSpread($a49ffb9144c044ff$var$_objectSpread({}, others), {}, {
            labelStack: $a49ffb9144c044ff$export$a0cd72da07c76b4c(labelStack, (0, $7GIrK.getReactUFOPayloadVersion)(interactionType))
        });
    });
}

});
parcelRegister("7GIrK", function(module, exports) {
$parcel$export(module.exports, "LATEST_REACT_UFO_PAYLOAD_VERSION", () => $598eeecca3bc973e$export$e919e900fc2d7fe8);
$parcel$export(module.exports, "getReactUFOPayloadVersion", () => $598eeecca3bc973e$export$159168550e7449b8);
var $598eeecca3bc973e$export$e919e900fc2d7fe8 = '2.0.0';
function $598eeecca3bc973e$export$159168550e7449b8(interactionType, isPostInteractionLog) {
    if (isPostInteractionLog) return '1.0.1';
    if (interactionType !== 'page_load' && interactionType !== 'transition') return '1.0.1';
    return $598eeecca3bc973e$export$e919e900fc2d7fe8;
}

});


parcelRegister("8qy01", function(module, exports) {
$parcel$export(module.exports, "allFeatureFlagsAccessed", () => $622b1ffdc30d3221$export$5b78c989c8db2561);
$parcel$export(module.exports, "currentFeatureFlagsAccessed", () => $622b1ffdc30d3221$export$2a5c8df26bb89760);
$parcel$export(module.exports, "addFeatureFlagAccessed", () => $622b1ffdc30d3221$export$47fade9662f71000);

var $em5gB = parcelRequire("em5gB");
var $622b1ffdc30d3221$export$5b78c989c8db2561 = new Map();
var $622b1ffdc30d3221$export$2a5c8df26bb89760 = new Map();
function $622b1ffdc30d3221$export$47fade9662f71000(featureFlagName, featureFlagValue) {
    try {
        // Inform Criterion about FF being accessed
        if (globalThis.__CRITERION__ && typeof globalThis.__CRITERION__.addFeatureFlagAccessed === 'function') globalThis.__CRITERION__.addFeatureFlagAccessed(featureFlagName, featureFlagValue);
    } catch (_e) {
    // ignore the criterion error
    }
    var value = (0, $em5gB.redactValue)(featureFlagValue);
    $622b1ffdc30d3221$export$5b78c989c8db2561.set(featureFlagName, value);
    $622b1ffdc30d3221$export$2a5c8df26bb89760.set(featureFlagName, value);
}

});
parcelRegister("em5gB", function(module, exports) {
$parcel$export(module.exports, "redactValue", () => $a737349ffb077d6f$export$fcc03ee4c944962f);

var $ekGgq = parcelRequire("ekGgq");

var $03VUm = parcelRequire("03VUm");
function $a737349ffb077d6f$var$startsAsObject(value) {
    try {
        if (value.charAt(0) === '{') return true;
    } catch (e) {
        return false;
    }
    return false;
}
function $a737349ffb077d6f$var$isObject(value) {
    return value && (0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(value) === 'object' && value.constructor === Object;
}
function $a737349ffb077d6f$var$isString(input) {
    var result;
    try {
        result = typeof input === 'string' || input instanceof String;
    } catch (err) {
        // swallow any errors
        result = false;
    }
    return result;
}
function $a737349ffb077d6f$export$7b4abba432e57989(value) {
    return $a737349ffb077d6f$var$isString(value) && $a737349ffb077d6f$var$startsAsObject(value) || $a737349ffb077d6f$var$isObject(value);
}
function $a737349ffb077d6f$export$fcc03ee4c944962f(featureFlagValue) {
    return $a737349ffb077d6f$export$7b4abba432e57989(featureFlagValue) ? (0, $03VUm.NON_BOOLEAN_VALUE) : featureFlagValue;
}

});
parcelRegister("03VUm", function(module, exports) {
$parcel$export(module.exports, "NON_BOOLEAN_VALUE", () => $00bd333ed11530f5$export$42f4885608027d0c);
var $00bd333ed11530f5$export$42f4885608027d0c = 'non_boolean';

});



parcelRegister("avBPK", function(module, exports) {
$parcel$export(module.exports, "VCObserverWrapper", () => VCObserverWrapper);
$parcel$export(module.exports, "newVCObserver", () => newVCObserver);

var $fC8ib = parcelRequire("fC8ib");

var $fL8KA = parcelRequire("fL8KA");

var $25nEq = parcelRequire("25nEq");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $6HG4S = parcelRequire("6HG4S");

var $DtLwq = parcelRequire("DtLwq");

var $iXcXg = parcelRequire("iXcXg");

var $29WXY = parcelRequire("29WXY");

var $i4OdZ = parcelRequire("i4OdZ");

var $hakpj = parcelRequire("hakpj");

var $k6qaT = parcelRequire("k6qaT");

var $3ZMUU = parcelRequire("3ZMUU");
var _process;
function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function _objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var VCObserverWrapper = /*#__PURE__*/ function() {
    function VCObserverWrapper() {
        var _opts$ssrEnablePageLa;
        var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, VCObserverWrapper);
        this.newVCObserver = null;
        this.oldVCObserver = null;
        // Initialize SSR placeholder handler once
        this.ssrPlaceholderHandler = new (0, $k6qaT.SSRPlaceholderHandlers)({
            enablePageLayoutPlaceholder: (_opts$ssrEnablePageLa = opts.ssrEnablePageLayoutPlaceholder) !== null && _opts$ssrEnablePageLa !== void 0 ? _opts$ssrEnablePageLa : false
        });
        if ((0, $DtLwq.isVCRevisionEnabled)('fy25.03') || (0, $DtLwq.isVCRevisionEnabled)('next')) {
            var _opts$ssrEnablePageLa2;
            this.newVCObserver = new (0, $i4OdZ.default)({
                selectorConfig: opts.selectorConfig,
                isPostInteraction: opts.isPostInteraction,
                SSRConfig: {
                    enablePageLayoutPlaceholder: (_opts$ssrEnablePageLa2 = opts.ssrEnablePageLayoutPlaceholder) !== null && _opts$ssrEnablePageLa2 !== void 0 ? _opts$ssrEnablePageLa2 : false
                },
                ssrPlaceholderHandler: this.ssrPlaceholderHandler
            });
        }
        if ((0, $DtLwq.isVCRevisionEnabled)('fy25.01') || (0, $DtLwq.isVCRevisionEnabled)('fy25.02')) this.oldVCObserver = new (0, $29WXY.VCObserver)(_objectSpread(_objectSpread({}, opts), {}, {
            ssrPlaceholderHandler: this.ssrPlaceholderHandler
        }));
    }
    // Helper method to process SSR abort listeners
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(VCObserverWrapper, [
        {
            key: "processSsrAbortListeners",
            value: function processSsrAbortListeners() {
                var _window;
                // Process any SSR abort listeners that remain
                if ((_window = window) !== null && _window !== void 0 && _window.__SSR_ABORT_LISTENERS__) {
                    // Clean up any event listeners that may have been registered during SSR
                    // This is centralized here so only the wrapper handles unbinding, not individual observers
                    if (window.__SSR_ABORT_LISTENERS__.unbinds && Array.isArray(window.__SSR_ABORT_LISTENERS__.unbinds)) window.__SSR_ABORT_LISTENERS__.unbinds.forEach(function(unbind) {
                        if (typeof unbind === 'function') unbind();
                    });
                    // After all observers had a chance to process abort events,
                    // we can safely delete the SSR_ABORT_LISTENERS object
                    delete window.__SSR_ABORT_LISTENERS__;
                }
            }
        },
        {
            key: "start",
            value: function start(_ref) {
                var startTime = _ref.startTime, experienceKey = _ref.experienceKey;
                if ((0, $DtLwq.isVCRevisionEnabled)('fy25.01', experienceKey) || (0, $DtLwq.isVCRevisionEnabled)('fy25.02', experienceKey)) {
                    var _this$oldVCObserver;
                    (_this$oldVCObserver = this.oldVCObserver) === null || _this$oldVCObserver === void 0 || _this$oldVCObserver.start({
                        startTime: startTime
                    });
                }
                if ((0, $DtLwq.isVCRevisionEnabled)('fy25.03', experienceKey)) {
                    var _this$newVCObserver;
                    (_this$newVCObserver = this.newVCObserver) === null || _this$newVCObserver === void 0 || _this$newVCObserver.start({
                        startTime: startTime
                    });
                }
                // Clean up any remaining SSR abort listeners after all observers have been started
                this.processSsrAbortListeners();
            }
        },
        {
            key: "stop",
            value: function stop(experienceKey) {
                if ((0, $DtLwq.isVCRevisionEnabled)('fy25.01', experienceKey) || (0, $DtLwq.isVCRevisionEnabled)('fy25.02', experienceKey)) {
                    var _this$oldVCObserver2;
                    (_this$oldVCObserver2 = this.oldVCObserver) === null || _this$oldVCObserver2 === void 0 || _this$oldVCObserver2.stop();
                }
                if ((0, $DtLwq.isVCRevisionEnabled)('fy25.03', experienceKey)) {
                    var _this$newVCObserver2;
                    (_this$newVCObserver2 = this.newVCObserver) === null || _this$newVCObserver2 === void 0 || _this$newVCObserver2.stop();
                }
                (0, $hakpj.RLLPlaceholderHandlers).getInstance().reset();
                // Clear shared SSR placeholder handler
                this.ssrPlaceholderHandler.clear();
            }
        },
        {
            key: "getVCRawData",
            value: function getVCRawData() {
                var _this$oldVCObserver$g, _this$oldVCObserver3;
                return (_this$oldVCObserver$g = (_this$oldVCObserver3 = this.oldVCObserver) === null || _this$oldVCObserver3 === void 0 ? void 0 : _this$oldVCObserver3.getVCRawData()) !== null && _this$oldVCObserver$g !== void 0 ? _this$oldVCObserver$g : null;
            }
        },
        {
            key: "getVCResult",
            value: function() {
                var _getVCResult = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee(param) {
                    var _this$oldVCObserver4, _this$newVCObserver3, _ref2;
                    var experienceKey, include3p, excludeSmartAnswersInSearch, includeSSRRatio, includeRawData, v1v2Result, v3v4Result, ssrRatio;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee$(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                experienceKey = param.experienceKey, include3p = param.include3p, excludeSmartAnswersInSearch = param.excludeSmartAnswersInSearch, includeSSRRatio = param.includeSSRRatio, includeRawData = param.includeRawData;
                                if (!((0, $DtLwq.isVCRevisionEnabled)('fy25.01', experienceKey) || (0, $DtLwq.isVCRevisionEnabled)('fy25.02', experienceKey))) {
                                    _context.next = 7;
                                    break;
                                }
                                _context.next = 4;
                                return (_this$oldVCObserver4 = this.oldVCObserver) === null || _this$oldVCObserver4 === void 0 ? void 0 : _this$oldVCObserver4.getVCResult(param);
                            case 4:
                                _context.t0 = _context.sent;
                                _context.next = 8;
                                break;
                            case 7:
                                _context.t0 = {};
                            case 8:
                                v1v2Result = _context.t0;
                                if (!(0, $DtLwq.isVCRevisionEnabled)('fy25.03', experienceKey)) {
                                    _context.next = 15;
                                    break;
                                }
                                _context.next = 12;
                                return (_this$newVCObserver3 = this.newVCObserver) === null || _this$newVCObserver3 === void 0 ? void 0 : _this$newVCObserver3.getVCResult({
                                    start: param.start,
                                    stop: param.stop,
                                    interactionId: param.interactionId,
                                    ssr: param.ssr,
                                    include3p: include3p,
                                    excludeSmartAnswersInSearch: excludeSmartAnswersInSearch,
                                    includeSSRRatio: includeSSRRatio,
                                    interactionType: param.interactionType,
                                    isPageVisible: param.isPageVisible,
                                    interactionAbortReason: param.interactionAbortReason,
                                    includeRawData: includeRawData,
                                    includeSSRInV3: param.includeSSRInV3
                                });
                            case 12:
                                _context.t1 = _context.sent;
                                _context.next = 16;
                                break;
                            case 15:
                                _context.t1 = [];
                            case 16:
                                v3v4Result = _context.t1;
                                if (v3v4Result) {
                                    _context.next = 19;
                                    break;
                                }
                                return _context.abrupt("return", v1v2Result !== null && v1v2Result !== void 0 ? v1v2Result : {});
                            case 19:
                                ssrRatio = v3v4Result[0].ssrRatio;
                                return _context.abrupt("return", _objectSpread(_objectSpread(_objectSpread({}, includeSSRRatio && ssrRatio !== undefined ? {
                                    'ufo:vc:ssrRatio': ssrRatio
                                } : {}), v1v2Result), {}, {
                                    'ufo:vc:rev': [].concat((0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))((_ref2 = v1v2Result === null || v1v2Result === void 0 ? void 0 : v1v2Result['ufo:vc:rev']) !== null && _ref2 !== void 0 ? _ref2 : []), (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(v3v4Result !== null && v3v4Result !== void 0 ? v3v4Result : []))
                                }));
                            case 21:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee, this);
                }));
                function getVCResult(_x) {
                    return _getVCResult.apply(this, arguments);
                }
                return getVCResult;
            }()
        },
        {
            key: "setSSRElement",
            value: function setSSRElement(element) {
                var _this$oldVCObserver5, _this$newVCObserver4;
                (_this$oldVCObserver5 = this.oldVCObserver) === null || _this$oldVCObserver5 === void 0 || _this$oldVCObserver5.setSSRElement(element);
                (_this$newVCObserver4 = this.newVCObserver) === null || _this$newVCObserver4 === void 0 || _this$newVCObserver4.setReactRootElement(element);
            }
        },
        {
            key: "setReactRootRenderStart",
            value: function setReactRootRenderStart(startTime) {
                var _this$oldVCObserver6, _this$newVCObserver5;
                (_this$oldVCObserver6 = this.oldVCObserver) === null || _this$oldVCObserver6 === void 0 || _this$oldVCObserver6.setReactRootRenderStart(startTime || performance.now());
                (_this$newVCObserver5 = this.newVCObserver) === null || _this$newVCObserver5 === void 0 || _this$newVCObserver5.setReactRootRenderStart(startTime || performance.now());
            }
        },
        {
            key: "setReactRootRenderStop",
            value: function setReactRootRenderStop(stopTime) {
                var _this$oldVCObserver7, _this$newVCObserver6;
                (_this$oldVCObserver7 = this.oldVCObserver) === null || _this$oldVCObserver7 === void 0 || _this$oldVCObserver7.setReactRootRenderStop(stopTime || performance.now());
                (_this$newVCObserver6 = this.newVCObserver) === null || _this$newVCObserver6 === void 0 || _this$newVCObserver6.setReactRootRenderStop(stopTime || performance.now());
            }
        },
        {
            key: "collectSSRPlaceholders",
            value: function collectSSRPlaceholders() {
                this.ssrPlaceholderHandler.collectExistingPlaceholders();
            }
        }
    ]);
}();
// Some products set this variable to indicate it is running in SSR
var isServer = Boolean(globalThis === null || globalThis === void 0 ? void 0 : globalThis.__SERVER__);
// Other products set this other variable to indicate it is running in SSR
var isReactSSR = typeof $3ZMUU !== 'undefined' && Boolean(((_process = $3ZMUU) === null || _process === void 0 || (_process = _process.env) === null || _process === void 0 ? void 0 : _process.REACT_SSR) || false);
function isEnvironmentSupported() {
    // SSR environment aren't supported
    if (isReactSSR || isServer) return false;
    // Legacy browsers that doesn't support WeakRef
    // aren't valid
    if (typeof (globalThis === null || globalThis === void 0 ? void 0 : globalThis.WeakRef) !== 'function') return false;
    if (typeof (globalThis === null || globalThis === void 0 ? void 0 : globalThis.MutationObserver) !== 'function' || typeof (globalThis === null || globalThis === void 0 ? void 0 : globalThis.IntersectionObserver) !== 'function' || typeof (globalThis === null || globalThis === void 0 ? void 0 : globalThis.PerformanceObserver) !== 'function') return false;
    return true;
}
function getVCObserver() {
    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    if (!globalThis.__vcObserver) {
        var shouldMockVCObserver = !isEnvironmentSupported();
        globalThis.__vcObserver = shouldMockVCObserver ? new (0, $iXcXg.VCObserverNOOP)() : new VCObserverWrapper(opts);
    }
    return globalThis.__vcObserver;
}
function newVCObserver() {
    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var shouldMockVCObserver = !isEnvironmentSupported();
    var observer = shouldMockVCObserver ? new (0, $iXcXg.VCObserverNOOP)() : new VCObserverWrapper(opts);
    return observer;
}

});
parcelRegister("iXcXg", function(module, exports) {
$parcel$export(module.exports, "VCObserverNOOP", () => $dcc7c939921a3c40$export$24d07287b49da906);

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");
var $dcc7c939921a3c40$export$24d07287b49da906 = /*#__PURE__*/ function() {
    function VCObserverNOOP() {
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, VCObserverNOOP);
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(VCObserverNOOP, [
        {
            key: "start",
            value: function start(_) {}
        },
        {
            key: "stop",
            value: function stop() {}
        },
        {
            key: "getVCRawData",
            value: function getVCRawData() {
                return null;
            }
        },
        {
            key: "getVCResult",
            value: function getVCResult(_) {
                return Promise.resolve({
                    'ufo:vc:noop': true
                });
            }
        },
        {
            key: "setSSRElement",
            value: function setSSRElement(_) {}
        },
        {
            key: "setReactRootRenderStart",
            value: function setReactRootRenderStart(_) {}
        },
        {
            key: "setReactRootRenderStop",
            value: function setReactRootRenderStop(_) {}
        }
    ]);
}();

});

parcelRegister("i4OdZ", function(module, exports) {
$parcel$export(module.exports, "default", () => $d28f8f4638044c49$export$2e2bcd8739ae039);

var $fL8KA = parcelRequire("fL8KA");

var $iYJcE = parcelRequire("iYJcE");

var $ekGgq = parcelRequire("ekGgq");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $25nEq = parcelRequire("25nEq");

var $6HG4S = parcelRequire("6HG4S");

var $9Zzpd = parcelRequire("9Zzpd");

var $k6qaT = parcelRequire("k6qaT");

var $lF8z4 = parcelRequire("lF8z4");

var $ePEWw = parcelRequire("ePEWw");

var $jdRKQ = parcelRequire("jdRKQ");

var $3VF6y = parcelRequire("3VF6y");

var $5X23Y = parcelRequire("5X23Y");

var $g3QRV = parcelRequire("g3QRV");

var $gOE39 = parcelRequire("gOE39");

var $frhlU = parcelRequire("frhlU");

var $i8F2n = parcelRequire("i8F2n");
var $d28f8f4638044c49$var$SSRState = {
    normal: 1,
    waitingForFirstRender: 2,
    ignoring: 3
};
var $d28f8f4638044c49$var$DEFAULT_SELECTOR_CONFIG = {
    id: false,
    testId: true,
    role: false,
    className: false,
    dataVC: true
};
var $d28f8f4638044c49$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function VCObserverNew(config) {
        var _config$isPostInterac, _config$selectorConfi, _this = this;
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, VCObserverNew);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "viewportObserver", null);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "windowEventObserver", null);
        // SSR related properties
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "ssrPlaceholderHandler", null);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "ssr", {
            state: $d28f8f4638044c49$var$SSRState.normal,
            reactRootElement: null,
            renderStart: -1,
            renderStop: -1
        });
        this.entriesTimeline = new (0, $lF8z4.default)();
        this.isPostInteraction = (_config$isPostInterac = config.isPostInteraction) !== null && _config$isPostInterac !== void 0 ? _config$isPostInterac : false;
        this.selectorConfig = (_config$selectorConfi = config.selectorConfig) !== null && _config$selectorConfi !== void 0 ? _config$selectorConfi : $d28f8f4638044c49$var$DEFAULT_SELECTOR_CONFIG;
        // Use shared SSR placeholder handler if provided, otherwise create new one if feature flag is enabled
        if (config.ssrPlaceholderHandler) this.ssrPlaceholderHandler = config.ssrPlaceholderHandler;
        else {
            var _config$SSRConfig$ena, _config$SSRConfig;
            this.ssrPlaceholderHandler = new (0, $k6qaT.SSRPlaceholderHandlers)({
                enablePageLayoutPlaceholder: (_config$SSRConfig$ena = (_config$SSRConfig = config.SSRConfig) === null || _config$SSRConfig === void 0 ? void 0 : _config$SSRConfig.enablePageLayoutPlaceholder) !== null && _config$SSRConfig$ena !== void 0 ? _config$SSRConfig$ena : false
            });
        }
        this.viewportObserver = new (0, $frhlU.default)({
            onChange: function onChange(onChangeArg) {
                var time = onChangeArg.time, type = onChangeArg.type, elementRef = onChangeArg.elementRef, visible = onChangeArg.visible, rect = onChangeArg.rect, previousRect = onChangeArg.previousRect, mutationData = onChangeArg.mutationData;
                var elementName = 'unknown';
                var element = elementRef.deref();
                if (element) elementName = _this.getElementName(element);
                var data = {
                    type: type,
                    elementName: elementName,
                    rect: rect,
                    previousRect: previousRect,
                    visible: visible,
                    attributeName: mutationData === null || mutationData === void 0 ? void 0 : mutationData.attributeName,
                    oldValue: mutationData === null || mutationData === void 0 ? void 0 : mutationData.oldValue,
                    newValue: mutationData === null || mutationData === void 0 ? void 0 : mutationData.newValue
                };
                if (element && (_this.isPostInteraction || (0, $9Zzpd.fg)('platform_ufo_add_segment_names_to_dom_offenders'))) {
                    var labelStacks = $d28f8f4638044c49$var$getLabelStacks(element);
                    if (labelStacks) Object.assign(data, {
                        labelStacks: labelStacks
                    });
                }
                _this.entriesTimeline.push({
                    time: time,
                    data: data
                });
            },
            // Pass SSR context to ViewportObserver
            getSSRState: function getSSRState() {
                return _this.getSSRState();
            },
            getSSRPlaceholderHandler: function getSSRPlaceholderHandler() {
                return _this.getSSRPlaceholderHandler();
            }
        });
        this.windowEventObserver = new (0, $i8F2n.default)({
            onEvent: function onEvent(_ref) {
                var time = _ref.time, type = _ref.type;
                _this.entriesTimeline.push({
                    time: time,
                    data: {
                        type: 'window:event',
                        eventType: type
                    }
                });
            }
        });
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(VCObserverNew, [
        {
            key: "start",
            value: function start(_) {
                var _this$viewportObserve, _window, _this2 = this, _this$windowEventObse;
                // Reset SSR state on start (matches old VCObserver behavior)
                this.ssr = {
                    state: $d28f8f4638044c49$var$SSRState.normal,
                    reactRootElement: null,
                    // Reset to null (matches old VCObserver)
                    renderStart: -1,
                    renderStop: -1
                };
                (_this$viewportObserve = this.viewportObserver) === null || _this$viewportObserve === void 0 || _this$viewportObserve.start();
                if ((_window = window) !== null && _window !== void 0 && _window.__SSR_ABORT_LISTENERS__) {
                    var abortListeners = window.__SSR_ABORT_LISTENERS__;
                    var aborts = abortListeners.aborts;
                    if (aborts && (0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(aborts) === 'object') Object.entries(aborts).forEach(function(_ref2) {
                        var _ref3 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_ref2, 2), key = _ref3[0], time = _ref3[1];
                        if (typeof time === 'number') _this2.entriesTimeline.push({
                            time: time,
                            data: {
                                type: 'window:event',
                                eventType: key
                            }
                        });
                    });
                }
                (_this$windowEventObse = this.windowEventObserver) === null || _this$windowEventObse === void 0 || _this$windowEventObse.start();
                this.entriesTimeline.clear();
            }
        },
        {
            key: "stop",
            value: function stop() {
                var _this$viewportObserve2, _this$windowEventObse2;
                (_this$viewportObserve2 = this.viewportObserver) === null || _this$viewportObserve2 === void 0 || _this$viewportObserve2.stop();
                (_this$windowEventObse2 = this.windowEventObserver) === null || _this$windowEventObse2 === void 0 || _this$windowEventObse2.stop();
                // Clear SSR state on stop (matches old VCObserver behavior)
                this.ssr.reactRootElement = null;
            }
        },
        {
            key: "setReactRootElement",
            value: function setReactRootElement(element) {
                this.ssr.reactRootElement = element;
            }
        },
        {
            key: "setReactRootRenderStart",
            value: function setReactRootRenderStart() {
                var startTime = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : performance.now();
                this.ssr.renderStart = startTime;
                this.ssr.state = $d28f8f4638044c49$var$SSRState.waitingForFirstRender;
            }
        },
        {
            key: "setReactRootRenderStop",
            value: function setReactRootRenderStop() {
                var stopTime = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : performance.now();
                this.ssr.renderStop = stopTime;
            }
        },
        {
            key: "collectSSRPlaceholders",
            value: function collectSSRPlaceholders() {
            // This is handled by the shared SSRPlaceholderHandlers in VCObserverWrapper
            // Individual observers don't need to implement this
            }
        },
        {
            key: "getSSRState",
            value: function getSSRState() {
                return this.ssr;
            }
        },
        {
            key: "getSSRPlaceholderHandler",
            value: function getSSRPlaceholderHandler() {
                return this.ssrPlaceholderHandler;
            }
        },
        {
            key: "addSSR",
            value: function addSSR(ssr) {
                this.entriesTimeline.push({
                    time: ssr,
                    data: {
                        elementName: 'SSR',
                        type: 'mutation:element',
                        rect: {
                            height: (0, $3VF6y.default)(),
                            width: (0, $5X23Y.default)(),
                            left: 0,
                            top: 0,
                            x: 0,
                            y: 0,
                            bottom: (0, $3VF6y.default)(),
                            right: (0, $5X23Y.default)(),
                            toJSON: function toJSON() {
                                return null;
                            }
                        },
                        visible: true
                    }
                });
            }
        },
        {
            key: "getVCResult",
            value: function() {
                var _getVCResult = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee(param) {
                    var start, stop, interactionId, interactionType, interactionAbortReason, isPageVisible, include3p, includeSSRRatio, excludeSmartAnswersInSearch, includeRawData, results, feVCCalculationStartTime, calculator_fy25_03, orderedEntries, fy25_03, calculator_next, vcNext, feVCCalculationEndTime, rawVCCalculationStartTime, rawHandler, raw;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee$(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                start = param.start, stop = param.stop, interactionId = param.interactionId, interactionType = param.interactionType, interactionAbortReason = param.interactionAbortReason, isPageVisible = param.isPageVisible, include3p = param.include3p, includeSSRRatio = param.includeSSRRatio, excludeSmartAnswersInSearch = param.excludeSmartAnswersInSearch, includeRawData = param.includeRawData;
                                results = [];
                                this.addStartEntry(start);
                                feVCCalculationStartTime = performance.now();
                                calculator_fy25_03 = new (0, $jdRKQ.default)();
                                if (param.includeSSRInV3 && param.ssr) this.addSSR(param.ssr);
                                orderedEntries = this.entriesTimeline.getOrderedEntries({
                                    start: start,
                                    stop: stop
                                });
                                _context.next = 9;
                                return calculator_fy25_03.calculate({
                                    orderedEntries: orderedEntries,
                                    startTime: start,
                                    stopTime: stop,
                                    interactionId: interactionId,
                                    interactionType: interactionType,
                                    isPostInteraction: this.isPostInteraction,
                                    include3p: include3p,
                                    excludeSmartAnswersInSearch: excludeSmartAnswersInSearch,
                                    includeSSRRatio: includeSSRRatio,
                                    isPageVisible: isPageVisible,
                                    interactionAbortReason: interactionAbortReason
                                });
                            case 9:
                                fy25_03 = _context.sent;
                                if (fy25_03) results.push(fy25_03);
                                // From TTVC v4 onwards, ensuring that SSR entry is always auto-added, whenever it is configured.
                                // From the next major version release (where TTVC v4 becomes the default TTVC version), the config for `includeSSRInV3` will be deprecated
                                if (param.ssr && !param.includeSSRInV3 && (0, $9Zzpd.fg)('platform_ufo_auto_add_ssr_entry_in_ttvc_v4')) this.addSSR(param.ssr);
                                // TODO on cleanup: put behind `enabledVCRevisions` config
                                calculator_next = new (0, $g3QRV.default)();
                                _context.next = 15;
                                return calculator_next.calculate({
                                    orderedEntries: orderedEntries,
                                    startTime: start,
                                    stopTime: stop,
                                    interactionId: interactionId,
                                    interactionType: interactionType,
                                    isPostInteraction: this.isPostInteraction,
                                    include3p: include3p,
                                    includeSSRRatio: includeSSRRatio,
                                    isPageVisible: isPageVisible,
                                    interactionAbortReason: interactionAbortReason
                                });
                            case 15:
                                vcNext = _context.sent;
                                if (vcNext) results.push(vcNext);
                                feVCCalculationEndTime = performance.now();
                                if (!(includeRawData && (0, $9Zzpd.fg)('platform_ufo_enable_vc_raw_data'))) {
                                    _context.next = 25;
                                    break;
                                }
                                rawVCCalculationStartTime = performance.now();
                                rawHandler = new (0, $gOE39.default)();
                                _context.next = 23;
                                return rawHandler.getRawData({
                                    entries: orderedEntries,
                                    startTime: start,
                                    stopTime: stop,
                                    isPageVisible: isPageVisible
                                });
                            case 23:
                                raw = _context.sent;
                                if (raw) {
                                    raw.rawVCTime = Number((performance.now() - rawVCCalculationStartTime).toFixed(2));
                                    raw.feVCTime = Number((feVCCalculationEndTime - feVCCalculationStartTime).toFixed(2));
                                    results.push(raw);
                                }
                            case 25:
                                return _context.abrupt("return", results);
                            case 26:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee, this);
                }));
                function getVCResult(_x) {
                    return _getVCResult.apply(this, arguments);
                }
                return getVCResult;
            }()
        },
        {
            key: "addStartEntry",
            value: function addStartEntry(startTime) {
                this.entriesTimeline.push({
                    time: startTime,
                    data: {
                        type: 'mutation:element',
                        elementName: 'START',
                        visible: true,
                        rect: {
                            x: 0,
                            y: 0,
                            width: window.innerWidth,
                            height: window.innerHeight,
                            top: 0,
                            left: 0,
                            bottom: window.innerHeight,
                            right: window.innerWidth,
                            toJSON: function toJSON() {
                                return {
                                    x: this.x,
                                    y: this.y,
                                    width: this.width,
                                    height: this.height,
                                    top: this.top,
                                    left: this.left,
                                    bottom: this.bottom,
                                    right: this.right
                                };
                            }
                        }
                    }
                });
            }
        },
        {
            key: "getElementName",
            value: function getElementName(element) {
                return (0, $ePEWw.default)(this.selectorConfig, element);
            }
        }
    ]);
}();
function $d28f8f4638044c49$var$labelStackFromFiber(fiber) {
    var _fiber$child;
    var value = fiber === null || fiber === void 0 || (_fiber$child = fiber.child) === null || _fiber$child === void 0 || (_fiber$child = _fiber$child.memoizedProps) === null || _fiber$child === void 0 ? void 0 : _fiber$child.value;
    return Array.isArray(value === null || value === void 0 ? void 0 : value.labelStack) ? value.labelStack : [];
}
function $d28f8f4638044c49$var$labelStackToString(labelStack) {
    return labelStack.map(function(label) {
        return label.name;
    }).join('/');
}
function $d28f8f4638044c49$var$labelStackToSegment(labelStack) {
    var segmentIndex = -1;
    for(var i = labelStack.length - 1; i >= 0; i--)if (labelStack[i].segmentId) {
        segmentIndex = i;
        break;
    }
    return labelStack.slice(0, segmentIndex + 1).map(function(label) {
        return label.name;
    }).join('/');
}
function $d28f8f4638044c49$var$traverseFiber(fiber) {
    var segment = 'unknown';
    var labelStackString = 'unknown';
    var currentFiber = fiber;
    while(currentFiber){
        if (currentFiber.type) {
            var componentName = currentFiber.type.displayName || currentFiber.type.name;
            if (componentName === 'UFOSegment' || componentName === 'UFOLabel') {
                var labelStack = $d28f8f4638044c49$var$labelStackFromFiber(currentFiber);
                labelStackString = $d28f8f4638044c49$var$labelStackToString(labelStack) || 'unknown';
                segment = $d28f8f4638044c49$var$labelStackToSegment(labelStack) || 'unknown';
                break;
            }
        }
        currentFiber = currentFiber.return;
    }
    return {
        segment: segment,
        labelStack: labelStackString
    };
}
function $d28f8f4638044c49$var$getLabelStacks(element) {
    var reactFiberKey = Object.keys(element).find(function(key) {
        return key.startsWith('__reactFiber$');
    });
    if (!reactFiberKey) return null;
    var fiber = element[reactFiberKey];
    return fiber ? $d28f8f4638044c49$var$traverseFiber(fiber) : null;
}

});
parcelRegister("lF8z4", function(module, exports) {
$parcel$export(module.exports, "default", () => $fc54120f907b7d53$export$2e2bcd8739ae039);

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");
var $fc54120f907b7d53$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function EntriesTimeline() {
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, EntriesTimeline);
        this.unorderedEntries = [];
        this.sortedEntriesCache = new Map();
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(EntriesTimeline, [
        {
            key: "push",
            value: function push(entry) {
                this.unorderedEntries.push(entry);
                this.sortedEntriesCache.clear();
            }
        },
        {
            key: "getCacheKey",
            value: function getCacheKey(start, stop) {
                return "".concat(start !== null && start !== void 0 ? start : 'null', "_").concat(stop !== null && stop !== void 0 ? stop : 'null');
            }
        },
        {
            key: "getOrderedEntries",
            value: function getOrderedEntries(_ref) {
                var _this$sortedEntriesCa;
                var start = _ref.start, stop = _ref.stop;
                var cacheKey = this.getCacheKey(start, stop);
                var cachedSortedEntries = (_this$sortedEntriesCa = this.sortedEntriesCache.get(cacheKey)) === null || _this$sortedEntriesCa === void 0 ? void 0 : _this$sortedEntriesCa.deref();
                if (cachedSortedEntries) return cachedSortedEntries;
                var filteredEntries = this.unorderedEntries.filter(function(e) {
                    return e.time >= (start !== null && start !== void 0 ? start : 0) && e.time <= (stop !== null && stop !== void 0 ? stop : performance.now());
                });
                var sortedEntries = filteredEntries.sort(function(a, b) {
                    return a.time - b.time;
                });
                this.sortedEntriesCache.set(cacheKey, new WeakRef(sortedEntries));
                return sortedEntries;
            }
        },
        {
            key: "clear",
            value: function clear() {
                this.unorderedEntries = [];
                this.sortedEntriesCache.clear();
            }
        }
    ]);
}();

});

parcelRegister("ePEWw", function(module, exports) {
$parcel$export(module.exports, "default", () => $acc596884d14682a$export$2e2bcd8739ae039);
var $acc596884d14682a$var$nameCache = new WeakMap();
function $acc596884d14682a$var$getElementName(selectorConfig, element) {
    if (!(element instanceof HTMLElement)) {
        var elementInstance = 'Unknown';
        // Types of elements according to LLM
        if (element instanceof Text) elementInstance = 'Text';
        else if (element instanceof DocumentFragment) elementInstance = 'DocumentFragment';
        else if (element instanceof Document) elementInstance = 'Document';
        else if (element instanceof Comment) elementInstance = 'Comment';
        else if (element instanceof ProcessingInstruction) elementInstance = 'ProcessingInstruction';
        else if (element instanceof Attr) elementInstance = 'Attr';
        else if (element instanceof CDATASection) elementInstance = 'CDATASection';
        if (element.parentElement && element.parentElement instanceof HTMLElement) {
            var parentElementSelector = $acc596884d14682a$var$getElementName(selectorConfig, element.parentElement);
            return "".concat(parentElementSelector, " > ").concat(elementInstance);
        } else return elementInstance;
    }
    var cachedName = $acc596884d14682a$var$nameCache.get(element);
    if (cachedName) return cachedName;
    // Get the tag name of the element.
    var tagName = element.localName;
    var encodeValue = function encodeValue(s) {
        if (typeof encodeURIComponent !== 'function') return '';
        try {
            return encodeURIComponent(s);
        } catch (e) {
            return 'malformed_value';
        }
    };
    // Helper function to construct attribute selectors.
    var getAttributeSelector = function getAttributeSelector(attributeName) {
        var prefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
        if (element && typeof element.getAttribute !== 'function') return '';
        var attrValue = element.getAttribute(attributeName);
        if (!attrValue) return '';
        var encondedAttrValue = encodeValue(attrValue);
        return "".concat(prefix, "[").concat(attributeName, "=\"").concat(encondedAttrValue, "\"]");
    };
    // Construct the data-vc attribute selector if specified in the config.
    var dataVC = selectorConfig.dataVC !== false ? getAttributeSelector('data-vc') : '';
    // Construct the ID selector if specified in the config and the element has an ID.
    var id = selectorConfig.id && element.id ? "#".concat(encodeValue(element.id)) : '';
    // Construct the test ID selector if specified in the config.
    var testId = selectorConfig.testId ? getAttributeSelector('data-testid') || getAttributeSelector('data-test-id') : '';
    // Construct the role selector if specified in the config.
    var role = selectorConfig.role ? getAttributeSelector('role') : '';
    var classNames = Array.from(element.classList).map(encodeValue).join('.');
    // Construct the class list selector if specified in the config.
    var classList = selectorConfig.className && classNames ? ".".concat(classNames) : '';
    // Combine primary attribute selectors (id, testId, role) into a single string.
    var primaryAttributes = [
        id,
        testId,
        role
    ].filter(Boolean).join('');
    // Use dataVC if available, otherwise use the primary attributes.
    var attributes = dataVC || primaryAttributes;
    // If no attributes or class list, recursively get the parent's name.
    if (!attributes && !classList) {
        var parentName = element.parentElement ? $acc596884d14682a$var$getElementName(selectorConfig, element.parentElement) : 'unknown';
        return "".concat(parentName, " > ").concat(tagName);
    }
    // Return the final constructed name: tagName + attributes or classList.
    var name = "".concat(tagName).concat(attributes || classList);
    $acc596884d14682a$var$nameCache.set(element, name);
    return name;
}
var $acc596884d14682a$export$2e2bcd8739ae039 = $acc596884d14682a$var$getElementName;

});

parcelRegister("jdRKQ", function(module, exports) {
$parcel$export(module.exports, "default", () => $dfe8edc4028e079e$export$2e2bcd8739ae039);

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $kIXpt = parcelRequire("kIXpt");

var $cYPzS = parcelRequire("cYPzS");

var $eyuDe = parcelRequire("eyuDe");

var $9Zzpd = parcelRequire("9Zzpd");

var $aeUxq = parcelRequire("aeUxq");

var $3ncU7 = parcelRequire("3ncU7");

var $6VzxC = parcelRequire("6VzxC");

var $horIC = parcelRequire("horIC");

var $fWZXc = parcelRequire("fWZXc");
function $dfe8edc4028e079e$var$_callSuper(t, o, e) {
    return o = (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(o), (0, (/*@__PURE__*/$parcel$interopDefault($kIXpt)))(t, $dfe8edc4028e079e$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(t).constructor) : o.apply(t, e));
}
function $dfe8edc4028e079e$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($dfe8edc4028e079e$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $dfe8edc4028e079e$var$ABORTING_WINDOW_EVENT = [
    'wheel',
    'scroll',
    'keydown',
    'resize'
];
var $dfe8edc4028e079e$var$REVISION_NO = 'fy25.03';
var $dfe8edc4028e079e$var$getConsideredEntryTypes = function getConsideredEntryTypes(include3p) {
    var entryTypes = [
        'mutation:child-element',
        'mutation:element',
        'mutation:attribute',
        'layout-shift',
        'layout-shift:same-rect',
        'window:event'
    ];
    // If not exclude 3p elements from ttvc,
    // including the tags into the ConsideredEntryTypes so that it won't be ignored for TTVC calculation
    if (!(0, $9Zzpd.fg)('platform_ufo_exclude_3p_elements_from_ttvc') || include3p) {
        entryTypes.push('mutation:third-party-element');
        entryTypes.push('mutation:third-party-attribute');
    }
    if ((0, $9Zzpd.fg)('platform_ufo_enable_media_for_ttvc_v3')) entryTypes.push('mutation:media');
    // Still included as part of TTVC v3
    if ((0, $9Zzpd.fg)('platform_ufo_ttvc_v4_exclude_input_name_mutation')) entryTypes.push('mutation:attribute:non-visual-input-name');
    return entryTypes;
};
var $dfe8edc4028e079e$export$98812f4e79596e2b = [
    'data-drop-target-for-element',
    'data-drop-target-for-external',
    'draggable',
    'data-is-observed'
];
var $dfe8edc4028e079e$export$44331555a87fcd9e = [
    'aria-label',
    'aria-labelledby',
    'aria-describedby',
    'aria-hidden',
    'aria-expanded',
    'aria-controls',
    'aria-selected',
    'aria-checked',
    'aria-disabled',
    'aria-required',
    'aria-current',
    'aria-haspopup',
    'aria-pressed',
    'aria-atomic',
    'aria-live'
];
var $dfe8edc4028e079e$export$c4351da6279bef53 = [
    'bis_skin_checked',
    'cz-shortcut-listen',
    'monica-version',
    'data-gr-ext-installed',
    'data-dashlane-rid',
    'sapling-installed',
    'data-gptw',
    // grammarly extensions
    'data-new-gr-c-s-loaded',
    'data-gr-aaa-notch-connection-id',
    'data-gr-aaa-loaded'
];
var $dfe8edc4028e079e$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_AbstractVCCalculator) {
    function VCCalculator_FY25_03(revisionNo) {
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, VCCalculator_FY25_03);
        return $dfe8edc4028e079e$var$_callSuper(this, VCCalculator_FY25_03, [
            revisionNo !== null && revisionNo !== void 0 ? revisionNo : $dfe8edc4028e079e$var$REVISION_NO
        ]);
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($eyuDe)))(VCCalculator_FY25_03, _AbstractVCCalculator);
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(VCCalculator_FY25_03, [
        {
            key: "isEntryIncluded",
            value: function isEntryIncluded(entry, include3p, excludeSmartAnswersInSearch) {
                if (!$dfe8edc4028e079e$var$getConsideredEntryTypes(include3p).includes(entry.data.type)) return false;
                if (excludeSmartAnswersInSearch && (0, $horIC.isEntrySmartAnswersInSearch)(entry)) return false;
                if (entry.data.type === 'mutation:media' && (0, $9Zzpd.fg)('media-perf-uplift-mutation-fix')) {
                    var entryData = entry.data;
                    var attributeName = entryData.attributeName;
                    if (attributeName && (/data-(test|file|context)-\S+/g.test(attributeName) || attributeName === 'data-cursor' || attributeName === 'alt' || (attributeName === 'localid' || attributeName === 'contenteditable' || attributeName === 'anchor-name') && (0, $aeUxq.expVal)('platform_editor_media_vc_fixes', 'isEnabled', false))) return false;
                    // special case for style attribute to ignore only anchor-name changes
                    if ((0, $aeUxq.expVal)('platform_editor_media_vc_fixes', 'isEnabled', false)) {
                        if ((0, $3ncU7.containsDnDMutationInStyle)({
                            attributeName: entryData.attributeName,
                            oldValue: entryData.oldValue,
                            newValue: entryData.newValue
                        })) return false;
                    }
                }
                if (entry.data.type === 'mutation:attribute') {
                    var _entryData = entry.data;
                    var _attributeName = _entryData.attributeName;
                    if (!_attributeName || $dfe8edc4028e079e$export$98812f4e79596e2b.includes(_attributeName)) return false;
                    if (_attributeName.startsWith('data-test') || _attributeName === 'data-aui-version' || _attributeName === 'data-testid' || _attributeName === 'data-vc' || _attributeName === 'data-ssr-placeholder' || _attributeName === 'data-ssr-placeholder-replace' || _attributeName === 'data-vc-nvs' || _attributeName === 'data-media-vc-wrapper' || _attributeName === 'data-renderer-start-pos' || _attributeName === 'data-table-local-id' || _attributeName === 'spellcheck' || _attributeName === 'data-auto-scrollable' || _attributeName === 'id' || _attributeName === 'tabindex' || _attributeName === 'data-is-ttvc-ready' || _attributeName === 'contenteditable' || _attributeName === 'data-has-collab-initialised' || _attributeName === 'translate' || $dfe8edc4028e079e$export$44331555a87fcd9e.includes(_attributeName) || $dfe8edc4028e079e$export$c4351da6279bef53.includes(_attributeName) && (0, $9Zzpd.fg)('platform_ufo_exclude_3p_extensions_from_ttvc')) return false;
                    return true;
                }
                if ((0, $fWZXc.default)(entry.data) && !entry.data.visible) return false;
                return true;
            }
        },
        {
            key: "getVCCleanStatus",
            value: function getVCCleanStatus(filteredEntries) {
                var dirtyReason = '';
                var abortTimestamp = -1;
                var hasAbortEvent = filteredEntries.some(function(entry) {
                    if (entry.data.type === 'window:event') {
                        var data = entry.data;
                        if ($dfe8edc4028e079e$var$ABORTING_WINDOW_EVENT.includes(data.eventType)) {
                            dirtyReason = data.eventType === 'keydown' ? 'keypress' : data.eventType;
                            abortTimestamp = Math.round(entry.time);
                            return true;
                        }
                    }
                    return false;
                });
                if (hasAbortEvent && dirtyReason) return {
                    isVCClean: false,
                    dirtyReason: dirtyReason,
                    abortTimestamp: abortTimestamp
                };
                return {
                    isVCClean: true
                };
            }
        }
    ]);
}((0, $6VzxC.default));

});
parcelRegister("aeUxq", function(module, exports) {
$parcel$export(module.exports, "expVal", () => $77471179cd56c057$export$9db1624a8af791a4);

var $h2bc4 = parcelRequire("h2bc4");

var $8qy01 = parcelRequire("8qy01");
var $77471179cd56c057$export$9db1624a8af791a4 = function expVal(experimentName, experimentParam, defaultValue) {
    // If client is not initialized, we return the default value
    if (!(0, $h2bc4.default).initializeCompleted()) return defaultValue;
    // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
    var experimentValue = (0, $h2bc4.default).getExperimentValue(experimentName, experimentParam, defaultValue);
    (0, $8qy01.addFeatureFlagAccessed)("".concat(experimentName, ":").concat(experimentParam), experimentValue);
    return experimentValue;
};

});
parcelRegister("h2bc4", function(module, exports) {
$parcel$export(module.exports, "default", () => $c66b4e6bbb9bd1b2$export$2e2bcd8739ae039);

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $25nEq = parcelRequire("25nEq");

var $20ap1 = parcelRequire("20ap1");

var $jeMGe = parcelRequire("jeMGe");



var $c66b4e6bbb9bd1b2$var$_FeatureGates;
/**
 * Access the FeatureGates object via the default export.
 * ```ts
 * import FeatureGates from '@atlaskit/feature-gate-js-client';
 * ```
 */ var $c66b4e6bbb9bd1b2$var$FeatureGates = /*#__PURE__*/ function() {
    function FeatureGates() {
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, FeatureGates);
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(FeatureGates, null, [
        {
            key: "isGateExists",
            value: function isGateExists(gateName) {
                return this.client.isGateExist(gateName);
            }
        },
        {
            key: "isExperimentExists",
            value: function isExperimentExists(experimentName) {
                return this.client.isExperimentExist(experimentName);
            }
        }
    ]);
}();
$c66b4e6bbb9bd1b2$var$_FeatureGates = $c66b4e6bbb9bd1b2$var$FeatureGates;
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($c66b4e6bbb9bd1b2$var$FeatureGates, "client", new (0, $20ap1.Client)());
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($c66b4e6bbb9bd1b2$var$FeatureGates, "hasCheckGateErrorOccurred", false);
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($c66b4e6bbb9bd1b2$var$FeatureGates, "hasGetExperimentValueErrorOccurred", false);
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($c66b4e6bbb9bd1b2$var$FeatureGates, "checkGate", function(gateName, options) {
    try {
        // Check if the CRITERION override mechanism is available
        if (typeof window !== 'undefined' && window.__CRITERION__ && typeof window.__CRITERION__.getFeatureFlagOverride === 'function') {
            // Attempt to retrieve an override value for the feature gate
            var overrideValue = window.__CRITERION__.getFeatureFlagOverride(gateName);
            // If an override value is found, return it immediately
            if (overrideValue !== undefined) return overrideValue;
        }
    } catch (error) {
        // Log the first occurrence of the error
        if (!$c66b4e6bbb9bd1b2$var$_FeatureGates.hasCheckGateErrorOccurred) {
            // eslint-disable-next-line no-console
            console.warn({
                msg: 'An error has occurred checking the feature gate from criterion override. Only the first occurrence of this error is logged.',
                gateName: gateName,
                error: error
            });
            $c66b4e6bbb9bd1b2$var$_FeatureGates.hasCheckGateErrorOccurred = true;
        }
    }
    // Proceed with the main logic if no override is found
    return $c66b4e6bbb9bd1b2$var$_FeatureGates.client.checkGate(gateName, options);
});
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($c66b4e6bbb9bd1b2$var$FeatureGates, "getExperimentValue", function(experimentName, parameterName, defaultValue, options) {
    try {
        // Check if the CRITERION override mechanism is available
        if (typeof window !== 'undefined' && window.__CRITERION__ && typeof window.__CRITERION__.getExperimentValueOverride === 'function') {
            var overrideValue = window.__CRITERION__.getExperimentValueOverride(experimentName, parameterName);
            if (overrideValue !== undefined && overrideValue !== null) return overrideValue;
        }
    } catch (error) {
        // Log the first occurrence of the error
        if (!$c66b4e6bbb9bd1b2$var$_FeatureGates.hasGetExperimentValueErrorOccurred) {
            // eslint-disable-next-line no-console
            console.warn({
                msg: 'An error has occurred getting the experiment value from criterion override. Only the first occurrence of this error is logged.',
                experimentName: experimentName,
                defaultValue: defaultValue,
                options: options,
                error: error
            });
            $c66b4e6bbb9bd1b2$var$_FeatureGates.hasGetExperimentValueErrorOccurred = true;
        }
        return defaultValue;
    }
    // Proceed with the main logic if no override is found
    return $c66b4e6bbb9bd1b2$var$_FeatureGates.client.getExperimentValue(experimentName, parameterName, defaultValue, options);
});
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($c66b4e6bbb9bd1b2$var$FeatureGates, "initializeCalled", $c66b4e6bbb9bd1b2$var$_FeatureGates.client.initializeCalled.bind($c66b4e6bbb9bd1b2$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($c66b4e6bbb9bd1b2$var$FeatureGates, "initializeCompleted", $c66b4e6bbb9bd1b2$var$_FeatureGates.client.initializeCompleted.bind($c66b4e6bbb9bd1b2$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($c66b4e6bbb9bd1b2$var$FeatureGates, "waitUntilInitializeCompleted", $c66b4e6bbb9bd1b2$var$_FeatureGates.client.waitUntilInitializeCompleted.bind($c66b4e6bbb9bd1b2$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($c66b4e6bbb9bd1b2$var$FeatureGates, "initialize", $c66b4e6bbb9bd1b2$var$_FeatureGates.client.initialize.bind($c66b4e6bbb9bd1b2$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($c66b4e6bbb9bd1b2$var$FeatureGates, "initializeWithProvider", $c66b4e6bbb9bd1b2$var$_FeatureGates.client.initializeWithProvider.bind($c66b4e6bbb9bd1b2$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($c66b4e6bbb9bd1b2$var$FeatureGates, "initializeFromValues", $c66b4e6bbb9bd1b2$var$_FeatureGates.client.initializeFromValues.bind($c66b4e6bbb9bd1b2$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($c66b4e6bbb9bd1b2$var$FeatureGates, "manuallyLogGateExposure", $c66b4e6bbb9bd1b2$var$_FeatureGates.client.manuallyLogGateExposure.bind($c66b4e6bbb9bd1b2$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($c66b4e6bbb9bd1b2$var$FeatureGates, "getExperiment", $c66b4e6bbb9bd1b2$var$_FeatureGates.client.getExperiment.bind($c66b4e6bbb9bd1b2$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($c66b4e6bbb9bd1b2$var$FeatureGates, "manuallyLogExperimentExposure", $c66b4e6bbb9bd1b2$var$_FeatureGates.client.manuallyLogExperimentExposure.bind($c66b4e6bbb9bd1b2$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($c66b4e6bbb9bd1b2$var$FeatureGates, "manuallyLogLayerExposure", $c66b4e6bbb9bd1b2$var$_FeatureGates.client.manuallyLogLayerExposure.bind($c66b4e6bbb9bd1b2$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($c66b4e6bbb9bd1b2$var$FeatureGates, "shutdownStatsig", $c66b4e6bbb9bd1b2$var$_FeatureGates.client.shutdownStatsig.bind($c66b4e6bbb9bd1b2$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($c66b4e6bbb9bd1b2$var$FeatureGates, "overrideGate", $c66b4e6bbb9bd1b2$var$_FeatureGates.client.overrideGate.bind($c66b4e6bbb9bd1b2$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($c66b4e6bbb9bd1b2$var$FeatureGates, "clearGateOverride", $c66b4e6bbb9bd1b2$var$_FeatureGates.client.clearGateOverride.bind($c66b4e6bbb9bd1b2$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($c66b4e6bbb9bd1b2$var$FeatureGates, "overrideConfig", $c66b4e6bbb9bd1b2$var$_FeatureGates.client.overrideConfig.bind($c66b4e6bbb9bd1b2$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($c66b4e6bbb9bd1b2$var$FeatureGates, "clearConfigOverride", $c66b4e6bbb9bd1b2$var$_FeatureGates.client.clearConfigOverride.bind($c66b4e6bbb9bd1b2$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($c66b4e6bbb9bd1b2$var$FeatureGates, "setOverrides", $c66b4e6bbb9bd1b2$var$_FeatureGates.client.setOverrides.bind($c66b4e6bbb9bd1b2$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($c66b4e6bbb9bd1b2$var$FeatureGates, "getOverrides", $c66b4e6bbb9bd1b2$var$_FeatureGates.client.getOverrides.bind($c66b4e6bbb9bd1b2$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($c66b4e6bbb9bd1b2$var$FeatureGates, "clearAllOverrides", $c66b4e6bbb9bd1b2$var$_FeatureGates.client.clearAllOverrides.bind($c66b4e6bbb9bd1b2$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($c66b4e6bbb9bd1b2$var$FeatureGates, "isCurrentUser", $c66b4e6bbb9bd1b2$var$_FeatureGates.client.isCurrentUser.bind($c66b4e6bbb9bd1b2$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($c66b4e6bbb9bd1b2$var$FeatureGates, "onGateUpdated", $c66b4e6bbb9bd1b2$var$_FeatureGates.client.onGateUpdated.bind($c66b4e6bbb9bd1b2$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($c66b4e6bbb9bd1b2$var$FeatureGates, "onExperimentValueUpdated", $c66b4e6bbb9bd1b2$var$_FeatureGates.client.onExperimentValueUpdated.bind($c66b4e6bbb9bd1b2$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($c66b4e6bbb9bd1b2$var$FeatureGates, "onAnyUpdated", $c66b4e6bbb9bd1b2$var$_FeatureGates.client.onAnyUpdated.bind($c66b4e6bbb9bd1b2$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($c66b4e6bbb9bd1b2$var$FeatureGates, "updateUser", $c66b4e6bbb9bd1b2$var$_FeatureGates.client.updateUser.bind($c66b4e6bbb9bd1b2$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($c66b4e6bbb9bd1b2$var$FeatureGates, "updateUserWithProvider", $c66b4e6bbb9bd1b2$var$_FeatureGates.client.updateUserWithProvider.bind($c66b4e6bbb9bd1b2$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($c66b4e6bbb9bd1b2$var$FeatureGates, "updateUserWithValues", $c66b4e6bbb9bd1b2$var$_FeatureGates.client.updateUserWithValues.bind($c66b4e6bbb9bd1b2$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($c66b4e6bbb9bd1b2$var$FeatureGates, "getPackageVersion", $c66b4e6bbb9bd1b2$var$_FeatureGates.client.getPackageVersion.bind($c66b4e6bbb9bd1b2$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($c66b4e6bbb9bd1b2$var$FeatureGates, "getLayer", $c66b4e6bbb9bd1b2$var$_FeatureGates.client.getLayer.bind($c66b4e6bbb9bd1b2$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($c66b4e6bbb9bd1b2$var$FeatureGates, "getLayerValue", $c66b4e6bbb9bd1b2$var$_FeatureGates.client.getLayerValue.bind($c66b4e6bbb9bd1b2$var$_FeatureGates.client));
var $c66b4e6bbb9bd1b2$var$boundFGJS = $c66b4e6bbb9bd1b2$var$FeatureGates;
// This makes it possible to get a reference to the FeatureGates client at runtime.
// This is important for overriding values in Cypress tests, as there needs to be a
// way to get the exact instance for a window in order to mock some of its methods.
if (typeof window !== 'undefined') {
    if (window.__FEATUREGATES_JS__ === undefined) window.__FEATUREGATES_JS__ = $c66b4e6bbb9bd1b2$var$FeatureGates;
    else {
        var $c66b4e6bbb9bd1b2$var$_boundFGJS, $c66b4e6bbb9bd1b2$var$_boundFGJS$getPackage;
        $c66b4e6bbb9bd1b2$var$boundFGJS = window.__FEATUREGATES_JS__;
        var $c66b4e6bbb9bd1b2$var$boundVersion = (($c66b4e6bbb9bd1b2$var$_boundFGJS = $c66b4e6bbb9bd1b2$var$boundFGJS) === null || $c66b4e6bbb9bd1b2$var$_boundFGJS === void 0 || ($c66b4e6bbb9bd1b2$var$_boundFGJS$getPackage = $c66b4e6bbb9bd1b2$var$_boundFGJS.getPackageVersion) === null || $c66b4e6bbb9bd1b2$var$_boundFGJS$getPackage === void 0 ? void 0 : $c66b4e6bbb9bd1b2$var$_boundFGJS$getPackage.call($c66b4e6bbb9bd1b2$var$_boundFGJS)) || '4.10.0 or earlier';
        if ($c66b4e6bbb9bd1b2$var$boundVersion !== (0, $jeMGe.CLIENT_VERSION)) {
            var $c66b4e6bbb9bd1b2$var$message = "Multiple versions of FeatureGateClients found on the current page.\n      The currently bound version is ".concat($c66b4e6bbb9bd1b2$var$boundVersion, " when module version ").concat((0, $jeMGe.CLIENT_VERSION), " was loading.");
            // eslint-disable-next-line no-console
            console.warn($c66b4e6bbb9bd1b2$var$message);
        }
    }
}
var /**
 * @property {FeatureGates} FeatureGate default export
 */ $c66b4e6bbb9bd1b2$export$2e2bcd8739ae039 = $c66b4e6bbb9bd1b2$var$boundFGJS;

});
parcelRegister("20ap1", function(module, exports) {
$parcel$export(module.exports, "Client", () => $1753a69d5666fee7$export$1f2bb630327ac4b6);

var $1Vcia = parcelRequire("1Vcia");

var $iYJcE = parcelRequire("iYJcE");

var $fL8KA = parcelRequire("fL8KA");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $25nEq = parcelRequire("25nEq");

var $6HG4S = parcelRequire("6HG4S");

var $iFR7a = parcelRequire("iFR7a");

var $7HFz2 = parcelRequire("7HFz2");

var $6bdCD = parcelRequire("6bdCD");

var $aJeNa = parcelRequire("aJeNa");

var $2lDCa = parcelRequire("2lDCa");

var $2cJWD = parcelRequire("2cJWD");

var $bfqQV = parcelRequire("bfqQV");

var $9xnxJ = parcelRequire("9xnxJ");

var $iYRGT = parcelRequire("iYRGT");

var $1fiiq = parcelRequire("1fiiq");

var $jeMGe = parcelRequire("jeMGe");
var $1753a69d5666fee7$var$_excluded = [
    "sdkKey",
    "environment",
    "updateUserCompletionCallback",
    "perimeter"
];
function $1753a69d5666fee7$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $1753a69d5666fee7$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $1753a69d5666fee7$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $1753a69d5666fee7$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $1753a69d5666fee7$var$DEFAULT_CLIENT_KEY = 'client-default-key';
// default event logging api is Atlassian proxy rather than Statsig's domain, to avoid ad blockers
var $1753a69d5666fee7$var$DEFAULT_EVENT_LOGGING_API = 'https://xp.atlassian.com/v1/rgstr';
var $1753a69d5666fee7$export$1f2bb630327ac4b6 = /*#__PURE__*/ function() {
    function Client() {
        var _this = this;
        var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, _ref$localStorageKey = _ref.localStorageKey, localStorageKey = _ref$localStorageKey === void 0 ? (0, $9xnxJ.LOCAL_STORAGE_KEY) : _ref$localStorageKey, overrideAdapter = _ref.overrideAdapter;
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, Client);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "initPromise", null);
        /** True if an initialize method was called and completed successfully. */ (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "initCompleted", false);
        /**
     * True if an initialize method was called and completed, meaning the client is now usable.
     * However if there was an error during initialization it may have initialized with default
     * values. Use {@link initCompleted} to check for this.
     */ (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "initWithDefaults", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "hasCheckGateErrorOccurred", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "hasGetExperimentErrorOccurred", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "hasGetExperimentValueErrorOccurred", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "hasGetLayerErrorOccurred", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "hasGetLayerValueErrorOccurred", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "subscriptions", new (0, $7HFz2.default)());
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "dataAdapter", new (0, $bfqQV.NoFetchDataAdapter)());
        /**
     * Call this if modifying the values being served by the Statsig library since it has its own
     * memoization cache which will not be updated if the values are changed outside of the library.
     */ (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "statsigValuesUpdated", function() {
            if (_this.user) // Trigger a reset of the memoize cache
            _this.statsigClient.updateUserSync(_this.user, {
                disableBackgroundCacheRefresh: true
            });
            _this.subscriptions.anyUpdated();
        });
        this.overrideAdapter = overrideAdapter || new (0, $9xnxJ.PersistentOverrideAdapter)(localStorageKey);
    }
    /**
   * @description
   * This method initializes the client using a network call to fetch the bootstrap values.
   * If the client is inialized with an `analyticsWebClient`, it will send an operational event
   * to GASv3 with the following attributes:
   * - targetApp: the target app of the client
   * - clientVersion: the version of the client
   * - success: whether the initialization was successful
   * - startTime: the time when the initialization started
   * - totalTime: the total time it took to initialize the client
   * - apiKey: the api key used to initialize the client
   * @param clientOptions {ClientOptions}
   * @param identifiers {Identifiers}
   * @param customAttributes {CustomAttributes}
   * @returns {Promise<void>}
   */ return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(Client, [
        {
            key: "initialize",
            value: function() {
                var _initialize = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee(clientOptions, identifiers, customAttributes) {
                    var _this2 = this;
                    var clientOptionsWithDefaults, startTime;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee$(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                clientOptionsWithDefaults = (0, $1fiiq.getOptionsWithDefaults)(clientOptions);
                                if (!this.initPromise) {
                                    _context.next = 4;
                                    break;
                                }
                                if (!(0, $1fiiq.shallowEquals)(clientOptionsWithDefaults, this.initOptions)) // eslint-disable-next-line no-console
                                console.warn('Feature Gates client already initialized with different options. New options were not applied.');
                                return _context.abrupt("return", this.initPromise);
                            case 4:
                                startTime = performance.now();
                                this.initOptions = clientOptionsWithDefaults;
                                this.initPromise = this.init(clientOptionsWithDefaults, identifiers, customAttributes).then(function() {
                                    _this2.initCompleted = true;
                                    _this2.initWithDefaults = true;
                                }).finally(function() {
                                    var endTime = performance.now();
                                    var totalTime = endTime - startTime;
                                    _this2.fireClientEvent(startTime, totalTime, 'initialize', _this2.initCompleted, clientOptionsWithDefaults.apiKey);
                                });
                                return _context.abrupt("return", this.initPromise);
                            case 8:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee, this);
                }));
                function initialize(_x, _x2, _x3) {
                    return _initialize.apply(this, arguments);
                }
                return initialize;
            }()
        },
        {
            key: "initializeWithProvider",
            value: function() {
                var _initializeWithProvider = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee2(clientOptions, provider, identifiers, customAttributes) {
                    var _this3 = this;
                    var clientOptionsWithDefaults, startTime;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee2$(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                clientOptionsWithDefaults = (0, $1fiiq.getOptionsWithDefaults)(clientOptions);
                                if (!this.initPromise) {
                                    _context2.next = 4;
                                    break;
                                }
                                if (!(0, $1fiiq.shallowEquals)(clientOptionsWithDefaults, this.initOptions)) // eslint-disable-next-line no-console
                                console.warn('Feature Gates client already initialized with different options. New options were not applied.');
                                return _context2.abrupt("return", this.initPromise);
                            case 4:
                                startTime = performance.now();
                                this.initOptions = clientOptionsWithDefaults;
                                this.provider = provider;
                                this.provider.setClientVersion((0, $jeMGe.CLIENT_VERSION));
                                if (this.provider.setApplyUpdateCallback) this.provider.setApplyUpdateCallback(this.applyUpdateCallback.bind(this));
                                this.initPromise = this.initWithProvider(clientOptionsWithDefaults, provider, identifiers, customAttributes).then(function() {
                                    _this3.initCompleted = true;
                                    _this3.initWithDefaults = true;
                                }).finally(function() {
                                    var endTime = performance.now();
                                    var totalTime = endTime - startTime;
                                    _this3.fireClientEvent(startTime, totalTime, 'initializeWithProvider', _this3.initCompleted, provider.getApiKey ? provider.getApiKey() : undefined);
                                });
                                return _context2.abrupt("return", this.initPromise);
                            case 11:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2, this);
                }));
                function initializeWithProvider(_x4, _x5, _x6, _x7) {
                    return _initializeWithProvider.apply(this, arguments);
                }
                return initializeWithProvider;
            }()
        },
        {
            key: "applyUpdateCallback",
            value: function applyUpdateCallback(experimentsResult) {
                try {
                    if (this.initCompleted || this.initWithDefaults) {
                        this.assertInitialized(this.statsigClient);
                        this.dataAdapter.setBootstrapData(experimentsResult.experimentValues);
                        this.dataAdapter.setData(JSON.stringify(experimentsResult.experimentValues));
                        this.statsigValuesUpdated();
                    }
                } catch (error) {
                    // eslint-disable-next-line no-console
                    console.warn('Error when attempting to apply update', error);
                }
            }
        },
        {
            key: "fireClientEvent",
            value: function fireClientEvent(startTime, totalTime, action, success) {
                var _analyticsWebClient, _this4 = this;
                var apiKey = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
                (_analyticsWebClient = this.initOptions.analyticsWebClient) === null || _analyticsWebClient === void 0 || _analyticsWebClient.then(function(analyticsWebClient) {
                    var attributes = $1753a69d5666fee7$var$_objectSpread({
                        targetApp: _this4.initOptions.targetApp,
                        clientVersion: (0, $jeMGe.CLIENT_VERSION),
                        success: success,
                        startTime: startTime,
                        totalTime: totalTime
                    }, apiKey && {
                        apiKey: apiKey
                    });
                    analyticsWebClient.sendOperationalEvent({
                        action: action,
                        actionSubject: 'featureGatesClient',
                        attributes: attributes,
                        tags: [
                            'measurement'
                        ],
                        source: '@atlaskit/feature-gate-js-client'
                    });
                }).catch(function(err) {
                    if (_this4.initOptions.environment !== (0, $iYRGT.FeatureGateEnvironment).Production) // eslint-disable-next-line no-console
                    console.error('Analytics web client promise did not resolve', err);
                });
            }
        },
        {
            key: "initializeFromValues",
            value: function() {
                var _initializeFromValues = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee3(clientOptions, identifiers, customAttributes) {
                    var _this5 = this;
                    var initializeValues, clientOptionsWithDefaults, startTime, _args3 = arguments;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee3$(_context3) {
                        while(true)switch(_context3.prev = _context3.next){
                            case 0:
                                initializeValues = _args3.length > 3 && _args3[3] !== undefined ? _args3[3] : {};
                                clientOptionsWithDefaults = (0, $1fiiq.getOptionsWithDefaults)(clientOptions);
                                if (!this.initPromise) {
                                    _context3.next = 5;
                                    break;
                                }
                                if (!(0, $1fiiq.shallowEquals)(clientOptionsWithDefaults, this.initOptions)) // eslint-disable-next-line no-console
                                console.warn('Feature Gates client already initialized with different options. New options were not applied.');
                                return _context3.abrupt("return", this.initPromise);
                            case 5:
                                // This makes sure the new Statsig client behaves like the old when bootstrap data is
                                // passed, and `has_updates` isn't specified (which happens a lot in product integration tests).
                                if (!Object.prototype.hasOwnProperty.call(initializeValues, 'has_updates')) initializeValues['has_updates'] = true;
                                startTime = performance.now();
                                this.initOptions = clientOptionsWithDefaults;
                                this.initPromise = this.initFromValues(clientOptionsWithDefaults, identifiers, customAttributes, initializeValues).then(function() {
                                    _this5.initCompleted = true;
                                    _this5.initWithDefaults = true;
                                }).finally(function() {
                                    var endTime = performance.now();
                                    var totalTime = endTime - startTime;
                                    _this5.fireClientEvent(startTime, totalTime, 'initializeFromValues', _this5.initCompleted);
                                });
                                return _context3.abrupt("return", this.initPromise);
                            case 10:
                            case "end":
                                return _context3.stop();
                        }
                    }, _callee3, this);
                }));
                function initializeFromValues(_x8, _x9, _x0) {
                    return _initializeFromValues.apply(this, arguments);
                }
                return initializeFromValues;
            }()
        },
        {
            key: "assertInitialized",
            value: function assertInitialized(statsigClient) {
                if (!statsigClient) throw new Error('Client must be initialized before using this method');
            }
        },
        {
            key: "updateUser",
            value: function() {
                var _updateUser = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee4(fetchOptions, identifiers, customAttributes) {
                    var fetchOptionsWithDefaults, initializeValuesProducer;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee4$(_context4) {
                        while(true)switch(_context4.prev = _context4.next){
                            case 0:
                                this.assertInitialized(this.statsigClient);
                                fetchOptionsWithDefaults = (0, $1fiiq.getOptionsWithDefaults)(fetchOptions);
                                initializeValuesProducer = function initializeValuesProducer() {
                                    return (0, $2cJWD.default).fetchExperimentValues(fetchOptionsWithDefaults, identifiers, customAttributes).then(function(_ref2) {
                                        var experimentValues = _ref2.experimentValues, customAttributes = _ref2.customAttributes;
                                        return {
                                            experimentValues: experimentValues,
                                            customAttributesFromFetch: customAttributes
                                        };
                                    });
                                };
                                _context4.next = 5;
                                return this.updateUserUsingInitializeValuesProducer(initializeValuesProducer, identifiers, customAttributes);
                            case 5:
                            case "end":
                                return _context4.stop();
                        }
                    }, _callee4, this);
                }));
                function updateUser(_x1, _x10, _x11) {
                    return _updateUser.apply(this, arguments);
                }
                return updateUser;
            }()
        },
        {
            key: "updateUserWithProvider",
            value: function() {
                var _updateUserWithProvider = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee5(identifiers, customAttributes) {
                    var _this6 = this;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee5$(_context5) {
                        while(true)switch(_context5.prev = _context5.next){
                            case 0:
                                this.assertInitialized(this.statsigClient);
                                if (this.provider) {
                                    _context5.next = 3;
                                    break;
                                }
                                throw new Error('Cannot update user using provider as the client was not initialised with a provider');
                            case 3:
                                _context5.next = 5;
                                return this.provider.setProfile(this.initOptions, identifiers, customAttributes);
                            case 5:
                                _context5.next = 7;
                                return this.updateUserUsingInitializeValuesProducer(function() {
                                    return _this6.provider.getExperimentValues();
                                }, identifiers, customAttributes);
                            case 7:
                            case "end":
                                return _context5.stop();
                        }
                    }, _callee5, this);
                }));
                function updateUserWithProvider(_x12, _x13) {
                    return _updateUserWithProvider.apply(this, arguments);
                }
                return updateUserWithProvider;
            }()
        },
        {
            key: "updateUserWithValues",
            value: function() {
                var _updateUserWithValues = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee6(identifiers, customAttributes) {
                    var initializeValues, initializeValuesProducer, _args6 = arguments;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee6$(_context6) {
                        while(true)switch(_context6.prev = _context6.next){
                            case 0:
                                initializeValues = _args6.length > 2 && _args6[2] !== undefined ? _args6[2] : {};
                                this.assertInitialized(this.statsigClient);
                                initializeValuesProducer = function initializeValuesProducer() {
                                    return Promise.resolve({
                                        experimentValues: initializeValues,
                                        customAttributesFromFetch: customAttributes
                                    });
                                };
                                _context6.next = 5;
                                return this.updateUserUsingInitializeValuesProducer(initializeValuesProducer, identifiers, customAttributes);
                            case 5:
                            case "end":
                                return _context6.stop();
                        }
                    }, _callee6, this);
                }));
                function updateUserWithValues(_x14, _x15) {
                    return _updateUserWithValues.apply(this, arguments);
                }
                return updateUserWithValues;
            }()
        },
        {
            key: "initializeCalled",
            value: function initializeCalled() {
                return this.initPromise != null;
            }
        },
        {
            key: "initializeCompleted",
            value: function initializeCompleted() {
                return this.initCompleted;
            }
        },
        {
            key: "waitUntilInitializeCompleted",
            value: function() {
                var _waitUntilInitializeCompleted = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee7() {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee7$(_context7) {
                        while(true)switch(_context7.prev = _context7.next){
                            case 0:
                                if (this.initPromise) {
                                    _context7.next = 2;
                                    break;
                                }
                                throw new Error('The client must be initialized before you can wait until initialized.');
                            case 2:
                                if (!this.initCompleted) {
                                    _context7.next = 4;
                                    break;
                                }
                                return _context7.abrupt("return");
                            case 4:
                                _context7.next = 6;
                                return this.initPromise;
                            case 6:
                            case "end":
                                return _context7.stop();
                        }
                    }, _callee7, this);
                }));
                function waitUntilInitializeCompleted() {
                    return _waitUntilInitializeCompleted.apply(this, arguments);
                }
                return waitUntilInitializeCompleted;
            }()
        },
        {
            key: "checkGate",
            value: function checkGate(gateName) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                try {
                    this.assertInitialized(this.statsigClient);
                    var _options$fireGateExpo = options.fireGateExposure, fireGateExposure = _options$fireGateExpo === void 0 ? true : _options$fireGateExpo;
                    return this.statsigClient.checkGate(gateName, {
                        disableExposureLog: !fireGateExposure
                    });
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!this.hasCheckGateErrorOccurred) {
                        // eslint-disable-next-line no-console
                        console.warn({
                            msg: 'An error has occurred checking the feature gate. Only the first occurrence of this error is logged.',
                            gateName: gateName,
                            error: error
                        });
                        this.hasCheckGateErrorOccurred = true;
                    }
                    return false;
                }
            }
        },
        {
            key: "isGateExist",
            value: function isGateExist(gateName) {
                try {
                    this.assertInitialized(this.statsigClient);
                    var gate = this.statsigClient.getFeatureGate(gateName, {
                        disableExposureLog: true
                    });
                    return !gate.details.reason.includes('Unrecognized');
                } catch (error) {
                    // eslint-disable-next-line no-console
                    console.error("Error occurred when trying to check FeatureGate: ".concat(error));
                    // in case of error report true to avoid false positives.
                    return true;
                }
            }
        },
        {
            key: "isExperimentExist",
            value: function isExperimentExist(experimentName) {
                try {
                    this.assertInitialized(this.statsigClient);
                    var config = this.statsigClient.getExperiment(experimentName, {
                        disableExposureLog: true
                    });
                    return !config.details.reason.includes('Unrecognized');
                } catch (error) {
                    // eslint-disable-next-line no-console
                    console.error("Error occurred when trying to check Experiment: ".concat(error));
                    // in case of error report true to avoid false positives.
                    return true;
                }
            }
        },
        {
            key: "manuallyLogGateExposure",
            value: function manuallyLogGateExposure(gateName) {
                this.assertInitialized(this.statsigClient);
                // This is the approach recommended in the docs
                // https://docs.statsig.com/client/javascript-sdk/#manual-exposures-
                this.statsigClient.checkGate(gateName);
            }
        },
        {
            key: "getExperiment",
            value: function getExperiment(experimentName) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                try {
                    this.assertInitialized(this.statsigClient);
                    var _options$fireExperime = options.fireExperimentExposure, fireExperimentExposure = _options$fireExperime === void 0 ? true : _options$fireExperime;
                    return (0, $6bdCD.DynamicConfig).fromExperiment(this.statsigClient.getExperiment(experimentName, {
                        disableExposureLog: !fireExperimentExposure
                    }));
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!this.hasGetExperimentErrorOccurred) {
                        // eslint-disable-next-line no-console
                        console.warn({
                            msg: 'An error has occurred getting the experiment. Only the first occurrence of this error is logged.',
                            experimentName: experimentName,
                            error: error
                        });
                        this.hasGetExperimentErrorOccurred = true;
                    }
                    // Return a default value
                    return new (0, $6bdCD.DynamicConfig)(experimentName, {}, '', {
                        time: Date.now(),
                        reason: (0, $2lDCa.EvaluationReason).Error
                    });
                }
            }
        },
        {
            key: "getExperimentValue",
            value: function getExperimentValue(experimentName, parameterName, defaultValue) {
                var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var experiment = this.getExperiment(experimentName, options);
                try {
                    var typeGuard = options.typeGuard;
                    return experiment.get(parameterName, defaultValue, typeGuard);
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!this.hasGetExperimentValueErrorOccurred) {
                        // eslint-disable-next-line no-console
                        console.warn({
                            msg: 'An error has occurred getting the experiment value. Only the first occurrence of this error is logged.',
                            experimentName: experimentName,
                            defaultValue: defaultValue,
                            options: options,
                            error: error
                        });
                        this.hasGetExperimentValueErrorOccurred = true;
                    }
                    return defaultValue;
                }
            }
        },
        {
            key: "manuallyLogExperimentExposure",
            value: function manuallyLogExperimentExposure(experimentName) {
                this.assertInitialized(this.statsigClient);
                // This is the approach recommended in the docs
                // https://docs.statsig.com/client/javascript-sdk/#manual-exposures-
                this.statsigClient.getExperiment(experimentName);
            }
        },
        {
            key: "manuallyLogLayerExposure",
            value: function manuallyLogLayerExposure(layerName, parameterName) {
                var _this$statsigClient$g;
                this.assertInitialized(this.statsigClient);
                // This is the approach recommended in the docs
                // https://docs.statsig.com/client/javascript-sdk/#manual-exposures-
                (_this$statsigClient$g = this.statsigClient.getLayer(layerName)) === null || _this$statsigClient$g === void 0 || _this$statsigClient$g.get(parameterName);
            }
        },
        {
            key: "shutdownStatsig",
            value: function shutdownStatsig() {
                this.assertInitialized(this.statsigClient);
                this.statsigClient.shutdown();
            }
        },
        {
            key: "overrideGate",
            value: function overrideGate(gateName, value) {
                this.overrideAdapter.overrideGate(gateName, value);
                // Trigger a reset of the memoized gate value
                if (this.user) {
                    var _this$statsigClient;
                    (_this$statsigClient = this.statsigClient) === null || _this$statsigClient === void 0 || _this$statsigClient.updateUserSync(this.user, {
                        disableBackgroundCacheRefresh: true
                    });
                }
                this.statsigValuesUpdated();
            }
        },
        {
            key: "clearGateOverride",
            value: function clearGateOverride(gateName) {
                this.overrideAdapter.removeGateOverride(gateName);
                this.statsigValuesUpdated();
            }
        },
        {
            key: "overrideConfig",
            value: function overrideConfig(experimentName, values) {
                this.overrideAdapter.overrideDynamicConfig(experimentName, values);
                this.statsigValuesUpdated();
            }
        },
        {
            key: "clearConfigOverride",
            value: function clearConfigOverride(experimentName) {
                this.overrideAdapter.removeDynamicConfigOverride(experimentName);
                this.statsigValuesUpdated();
            }
        },
        {
            key: "setOverrides",
            value: function setOverrides(overrides) {
                this.overrideAdapter.setOverrides(overrides);
                this.statsigValuesUpdated();
            }
        },
        {
            key: "getOverrides",
            value: function getOverrides() {
                return this.overrideAdapter.getOverrides();
            }
        },
        {
            key: "clearAllOverrides",
            value: function clearAllOverrides() {
                this.overrideAdapter.removeAllOverrides();
                this.statsigValuesUpdated();
            }
        },
        {
            key: "isCurrentUser",
            value: function isCurrentUser(identifiers, customAttributes) {
                return (0, $1fiiq.shallowEquals)(this.currentIdentifiers, identifiers) && (0, $1fiiq.shallowEquals)(this.currentAttributes, customAttributes);
            }
        },
        {
            key: "onGateUpdated",
            value: function onGateUpdated(gateName, callback) {
                var _this7 = this;
                var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var wrapCallback = function wrapCallback(value) {
                    var _options$fireGateExpo2 = options.fireGateExposure, fireGateExposure = _options$fireGateExpo2 === void 0 ? true : _options$fireGateExpo2;
                    if (fireGateExposure) _this7.manuallyLogGateExposure(gateName);
                    try {
                        callback(value);
                    } catch (error) {
                        // eslint-disable-next-line no-console
                        console.warn("Error calling callback for gate ".concat(gateName, " with value ").concat(value), error);
                    }
                };
                return this.subscriptions.onGateUpdated(gateName, wrapCallback, this.checkGate.bind(this), options);
            }
        },
        {
            key: "onExperimentValueUpdated",
            value: function onExperimentValueUpdated(experimentName, parameterName, defaultValue, callback) {
                var _this8 = this;
                var options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
                var wrapCallback = function wrapCallback(value) {
                    var _options$fireExperime2 = options.fireExperimentExposure, fireExperimentExposure = _options$fireExperime2 === void 0 ? true : _options$fireExperime2;
                    if (fireExperimentExposure) _this8.manuallyLogExperimentExposure(experimentName);
                    try {
                        callback(value);
                    } catch (error) {
                        // eslint-disable-next-line no-console
                        console.warn("Error calling callback for experiment ".concat(experimentName, " with value ").concat(value), error);
                    }
                };
                return this.subscriptions.onExperimentValueUpdated(experimentName, parameterName, defaultValue, wrapCallback, this.getExperimentValue.bind(this), options);
            }
        },
        {
            key: "onAnyUpdated",
            value: function onAnyUpdated(callback) {
                return this.subscriptions.onAnyUpdated(callback);
            }
        },
        {
            key: "init",
            value: function() {
                var _init = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee8(clientOptions, identifiers, customAttributes) {
                    var fromValuesClientOptions, experimentValues, customAttributesFromResult, clientSdkKeyPromise, experimentValuesPromise, _yield$Promise$all, _yield$Promise$all2, experimentValuesResult;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee8$(_context8) {
                        while(true)switch(_context8.prev = _context8.next){
                            case 0:
                                fromValuesClientOptions = $1753a69d5666fee7$var$_objectSpread({}, clientOptions);
                                _context8.prev = 1;
                                // If client sdk key fetch fails, an error would be thrown and handled instead of waiting for
                                // the experiment values request to be settled, and it will fall back to use default values.
                                clientSdkKeyPromise = (0, $2cJWD.default).fetchClientSdk(clientOptions).then(function(value) {
                                    return fromValuesClientOptions.sdkKey = value.clientSdkKey;
                                });
                                experimentValuesPromise = (0, $2cJWD.default).fetchExperimentValues(clientOptions, identifiers, customAttributes); // Only wait for the experiment values request to finish and try to initialise the client
                                // with experiment values if both requests are successful. Else an error would be thrown and
                                // handled by the catch
                                _context8.next = 6;
                                return Promise.all([
                                    clientSdkKeyPromise,
                                    experimentValuesPromise
                                ]);
                            case 6:
                                _yield$Promise$all = _context8.sent;
                                _yield$Promise$all2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_yield$Promise$all, 2);
                                experimentValuesResult = _yield$Promise$all2[1];
                                experimentValues = experimentValuesResult.experimentValues;
                                customAttributesFromResult = experimentValuesResult.customAttributes;
                                _context8.next = 20;
                                break;
                            case 13:
                                _context8.prev = 13;
                                _context8.t0 = _context8["catch"](1);
                                if (_context8.t0 instanceof Error) // eslint-disable-next-line no-console
                                console.error("Error occurred when trying to fetch the Feature Gates client values, error: ".concat(_context8.t0 === null || _context8.t0 === void 0 ? void 0 : _context8.t0.message));
                                // eslint-disable-next-line no-console
                                console.warn("Initialising Statsig client without values");
                                _context8.next = 19;
                                return this.initFromValues(fromValuesClientOptions, identifiers, customAttributes);
                            case 19:
                                throw _context8.t0;
                            case 20:
                                return _context8.abrupt("return", this.initFromValues(fromValuesClientOptions, identifiers, customAttributesFromResult, experimentValues));
                            case 21:
                            case "end":
                                return _context8.stop();
                        }
                    }, _callee8, this, [
                        [
                            1,
                            13
                        ]
                    ]);
                }));
                function init(_x16, _x17, _x18) {
                    return _init.apply(this, arguments);
                }
                return init;
            }()
        },
        {
            key: "initWithProvider",
            value: function() {
                var _initWithProvider = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee9(baseClientOptions, provider, identifiers, customAttributes) {
                    var fromValuesClientOptions, experimentValues, customAttributesFromResult, clientSdkKeyPromise, experimentValuesPromise, _yield$Promise$all3, _yield$Promise$all4, experimentValuesResult;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee9$(_context9) {
                        while(true)switch(_context9.prev = _context9.next){
                            case 0:
                                fromValuesClientOptions = $1753a69d5666fee7$var$_objectSpread($1753a69d5666fee7$var$_objectSpread({}, baseClientOptions), {}, {
                                    disableCurrentPageLogging: true
                                });
                                _context9.prev = 1;
                                _context9.next = 4;
                                return provider.setProfile(baseClientOptions, identifiers, customAttributes);
                            case 4:
                                // If client sdk key fetch fails, an error would be thrown and handled instead of waiting for
                                // the experiment values request to be settled, and it will fall back to use default values.
                                clientSdkKeyPromise = provider.getClientSdkKey().then(function(value) {
                                    return fromValuesClientOptions.sdkKey = value;
                                });
                                experimentValuesPromise = provider.getExperimentValues(); // Only wait for the experiment values request to finish and try to initialise the client
                                // with experiment values if both requests are successful. Else an error would be thrown and
                                // handled by the catch
                                _context9.next = 8;
                                return Promise.all([
                                    clientSdkKeyPromise,
                                    experimentValuesPromise
                                ]);
                            case 8:
                                _yield$Promise$all3 = _context9.sent;
                                _yield$Promise$all4 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_yield$Promise$all3, 2);
                                experimentValuesResult = _yield$Promise$all4[1];
                                experimentValues = experimentValuesResult.experimentValues;
                                customAttributesFromResult = experimentValuesResult.customAttributesFromFetch;
                                _context9.next = 22;
                                break;
                            case 15:
                                _context9.prev = 15;
                                _context9.t0 = _context9["catch"](1);
                                if (_context9.t0 instanceof Error) // eslint-disable-next-line no-console
                                console.error("Error occurred when trying to fetch the Feature Gates client values, error: ".concat(_context9.t0 === null || _context9.t0 === void 0 ? void 0 : _context9.t0.message));
                                // eslint-disable-next-line no-console
                                console.warn("Initialising Statsig client without values");
                                _context9.next = 21;
                                return this.initFromValues(fromValuesClientOptions, identifiers, customAttributes);
                            case 21:
                                throw _context9.t0;
                            case 22:
                                return _context9.abrupt("return", this.initFromValues(fromValuesClientOptions, identifiers, customAttributesFromResult, experimentValues));
                            case 23:
                            case "end":
                                return _context9.stop();
                        }
                    }, _callee9, this, [
                        [
                            1,
                            15
                        ]
                    ]);
                }));
                function initWithProvider(_x19, _x20, _x21, _x22) {
                    return _initWithProvider.apply(this, arguments);
                }
                return initWithProvider;
            }()
        },
        {
            key: "initFromValues",
            value: function() {
                var _initFromValues = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee0(clientOptions, identifiers, customAttributes) {
                    var _newClientOptions$net;
                    var initializeValues, newClientOptions, sdkKey, environment, _updateUserCompletionCallback, _perimeter, restClientOptions, statsigOptions, _args0 = arguments;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee0$(_context0) {
                        while(true)switch(_context0.prev = _context0.next){
                            case 0:
                                initializeValues = _args0.length > 3 && _args0[3] !== undefined ? _args0[3] : {};
                                this.overrideAdapter.initFromStoredOverrides();
                                this.currentIdentifiers = identifiers;
                                this.currentAttributes = customAttributes;
                                newClientOptions = (0, $1fiiq.migrateInitializationOptions)(clientOptions);
                                if (!newClientOptions.sdkKey) newClientOptions.sdkKey = $1753a69d5666fee7$var$DEFAULT_CLIENT_KEY;
                                if (!((_newClientOptions$net = newClientOptions.networkConfig) !== null && _newClientOptions$net !== void 0 && _newClientOptions$net.logEventUrl)) newClientOptions.networkConfig = $1753a69d5666fee7$var$_objectSpread($1753a69d5666fee7$var$_objectSpread({}, newClientOptions.networkConfig), {}, {
                                    logEventUrl: $1753a69d5666fee7$var$DEFAULT_EVENT_LOGGING_API
                                });
                                if (newClientOptions.perimeter === (0, $iYRGT.PerimeterType).FEDRAMP_MODERATE) // disable all logging in FedRAMP to prevent egress of sensitive data
                                newClientOptions.disableLogging = true;
                                sdkKey = newClientOptions.sdkKey, environment = newClientOptions.environment, _updateUserCompletionCallback = newClientOptions.updateUserCompletionCallback, _perimeter = newClientOptions.perimeter, restClientOptions = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(newClientOptions, $1753a69d5666fee7$var$_excluded);
                                this.user = (0, $1fiiq.toStatsigUser)(identifiers, customAttributes);
                                statsigOptions = $1753a69d5666fee7$var$_objectSpread($1753a69d5666fee7$var$_objectSpread({}, restClientOptions), {}, {
                                    environment: {
                                        tier: environment
                                    },
                                    includeCurrentPageUrlWithEvents: false,
                                    dataAdapter: this.dataAdapter,
                                    overrideAdapter: this.overrideAdapter,
                                    logEventCompressionMode: (0, $iFR7a.LogEventCompressionMode).Forced
                                }); // Statsig validates the provided stableId against their own cookie, so we either need
                                // to update the cookie to match, or disable the validation completely.
                                if (identifiers.stableId) (0, $iFR7a.StableID).setOverride(identifiers.stableId, sdkKey);
                                else statsigOptions.disableStableID = true;
                                _context0.prev = 12;
                                this.statsigClient = new (0, $iFR7a.StatsigClient)(sdkKey, this.user, statsigOptions);
                                this.dataAdapter.setBootstrapData(initializeValues);
                                _context0.next = 17;
                                return this.statsigClient.initializeAsync();
                            case 17:
                                _context0.next = 29;
                                break;
                            case 19:
                                _context0.prev = 19;
                                _context0.t0 = _context0["catch"](12);
                                if (_context0.t0 instanceof Error) // eslint-disable-next-line no-console
                                console.error("Error occurred when trying to initialise the Statsig client, error: ".concat(_context0.t0 === null || _context0.t0 === void 0 ? void 0 : _context0.t0.message));
                                // eslint-disable-next-line no-console
                                console.warn("Initialising Statsig client with default sdk key and without values");
                                this.statsigClient = new (0, $iFR7a.StatsigClient)($1753a69d5666fee7$var$DEFAULT_CLIENT_KEY, this.user, statsigOptions);
                                this.dataAdapter.setBootstrapData();
                                _context0.next = 27;
                                return this.statsigClient.initializeAsync();
                            case 27:
                                this.initWithDefaults = true;
                                throw _context0.t0;
                            case 29:
                            case "end":
                                return _context0.stop();
                        }
                    }, _callee0, this, [
                        [
                            12,
                            19
                        ]
                    ]);
                }));
                function initFromValues(_x23, _x24, _x25) {
                    return _initFromValues.apply(this, arguments);
                }
                return initFromValues;
            }()
        },
        {
            key: "updateUserUsingInitializeValuesProducer",
            value: function() {
                var _updateUserUsingInitializeValuesProducer = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee10(getInitializeValues, identifiers, customAttributes) {
                    var _this9 = this;
                    var originalInitPromise, initializeValuesPromise, updateUserPromise;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee10$(_context10) {
                        while(true)switch(_context10.prev = _context10.next){
                            case 0:
                                this.assertInitialized(this.statsigClient);
                                if (this.initPromise) {
                                    _context10.next = 3;
                                    break;
                                }
                                throw new Error('The client must be initialized before you can update the user.');
                            case 3:
                                if (!this.isCurrentUser(identifiers, customAttributes)) {
                                    _context10.next = 5;
                                    break;
                                }
                                return _context10.abrupt("return", this.initPromise);
                            case 5:
                                // Wait for the current initialize/update to finish
                                originalInitPromise = this.initPromise;
                                _context10.prev = 6;
                                _context10.next = 9;
                                return this.initPromise;
                            case 9:
                                _context10.next = 13;
                                break;
                            case 11:
                                _context10.prev = 11;
                                _context10.t0 = _context10["catch"](6);
                            case 13:
                                initializeValuesPromise = getInitializeValues();
                                updateUserPromise = this.updateStatsigClientUser(initializeValuesPromise, identifiers, customAttributes); // We replace the init promise here since we are essentially re-initializing the client at this
                                // point. Any subsequent calls to await client.initialize() or client.updateUser()
                                // will now also await this user update.
                                this.initPromise = updateUserPromise.catch(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee1() {
                                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee1$(_context1) {
                                        while(true)switch(_context1.prev = _context1.next){
                                            case 0:
                                                // If the update failed then it changed nothing, so revert back to the original promise.
                                                _this9.initPromise = originalInitPromise;
                                                // Set the user profile again to revert back to the current user
                                                if (!_this9.provider) {
                                                    _context1.next = 4;
                                                    break;
                                                }
                                                _context1.next = 4;
                                                return _this9.provider.setProfile(_this9.initOptions, _this9.currentIdentifiers, _this9.currentAttributes);
                                            case 4:
                                            case "end":
                                                return _context1.stop();
                                        }
                                    }, _callee1);
                                })));
                                return _context10.abrupt("return", updateUserPromise);
                            case 17:
                            case "end":
                                return _context10.stop();
                        }
                    }, _callee10, this, [
                        [
                            6,
                            11
                        ]
                    ]);
                }));
                function updateUserUsingInitializeValuesProducer(_x26, _x27, _x28) {
                    return _updateUserUsingInitializeValuesProducer.apply(this, arguments);
                }
                return updateUserUsingInitializeValuesProducer;
            }()
        },
        {
            key: "updateStatsigClientUser",
            value: function() {
                var _updateStatsigClientUser = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee11(initializeValuesPromise, identifiers, customAttributes) {
                    var _this$initOptions, _this$initOptions$upd;
                    var initializeValues, user, _updateUserCompletion, _ref4, errMsg, success, errorMessage;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee11$(_context11) {
                        while(true)switch(_context11.prev = _context11.next){
                            case 0:
                                this.assertInitialized(this.statsigClient);
                                _context11.prev = 1;
                                _context11.next = 4;
                                return initializeValuesPromise;
                            case 4:
                                initializeValues = _context11.sent;
                                user = (0, $1fiiq.toStatsigUser)(identifiers, initializeValues.customAttributesFromFetch);
                                _context11.next = 13;
                                break;
                            case 8:
                                _context11.prev = 8;
                                _context11.t0 = _context11["catch"](1);
                                // Make sure the updateUserCompletionCallback is called for any errors in our custom code.
                                // This is not necessary for the updateUserWithValues call, because the Statsig client will
                                // already invoke the callback itself.
                                errMsg = _context11.t0 instanceof Error ? _context11.t0.message : JSON.stringify(_context11.t0);
                                (_updateUserCompletion = (_ref4 = this.initOptions).updateUserCompletionCallback) === null || _updateUserCompletion === void 0 || _updateUserCompletion.call(_ref4, false, errMsg);
                                throw _context11.t0;
                            case 13:
                                success = true;
                                errorMessage = null;
                                _context11.prev = 15;
                                this.dataAdapter.setBootstrapData(initializeValues.experimentValues);
                                this.user = user;
                                if (!this.user) {
                                    _context11.next = 21;
                                    break;
                                }
                                _context11.next = 21;
                                return this.statsigClient.updateUserAsync(this.user);
                            case 21:
                                _context11.next = 27;
                                break;
                            case 23:
                                _context11.prev = 23;
                                _context11.t1 = _context11["catch"](15);
                                success = false;
                                errorMessage = String(_context11.t1);
                            case 27:
                                (_this$initOptions = this.initOptions) === null || _this$initOptions === void 0 || (_this$initOptions$upd = _this$initOptions.updateUserCompletionCallback) === null || _this$initOptions$upd === void 0 || _this$initOptions$upd.call(_this$initOptions, success, errorMessage);
                                if (!success) {
                                    _context11.next = 34;
                                    break;
                                }
                                this.currentIdentifiers = identifiers;
                                this.currentAttributes = customAttributes;
                                this.subscriptions.anyUpdated();
                                _context11.next = 35;
                                break;
                            case 34:
                                throw new Error('Failed to update user. An unexpected error occured.');
                            case 35:
                            case "end":
                                return _context11.stop();
                        }
                    }, _callee11, this, [
                        [
                            1,
                            8
                        ],
                        [
                            15,
                            23
                        ]
                    ]);
                }));
                function updateStatsigClientUser(_x29, _x30, _x31) {
                    return _updateStatsigClientUser.apply(this, arguments);
                }
                return updateStatsigClientUser;
            }()
        },
        {
            key: "getPackageVersion",
            value: /**
     * @returns string version of the current package in semver style.
     */ function getPackageVersion() {
                return 0, $jeMGe.CLIENT_VERSION;
            }
        },
        {
            key: "getLayer",
            value: function getLayer(/** The name of the layer */ layerName) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                try {
                    this.assertInitialized(this.statsigClient);
                    var _options$fireLayerExp = options.fireLayerExposure, fireLayerExposure = _options$fireLayerExp === void 0 ? true : _options$fireLayerExp;
                    return (0, $aJeNa.Layer).fromLayer(this.statsigClient.getLayer(layerName, {
                        disableExposureLog: !fireLayerExposure
                    }));
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!this.hasGetLayerErrorOccurred) {
                        // eslint-disable-next-line no-console
                        console.warn({
                            msg: 'An error has occurred getting the layer. Only the first occurrence of this error is logged.',
                            layerName: layerName,
                            error: error
                        });
                        this.hasGetLayerErrorOccurred = true;
                    }
                    // Return a default value
                    return (0, $aJeNa.Layer).fromLayer((0, $iFR7a._makeLayer)(layerName, {
                        reason: 'Error'
                    }, null));
                }
            }
        },
        {
            key: "getLayerValue",
            value: function getLayerValue(layerName, parameterName, defaultValue) {
                var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var layer = this.getLayer(layerName, options);
                try {
                    var typeGuard = options.typeGuard;
                    return layer.get(parameterName, defaultValue, typeGuard);
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!this.hasGetLayerValueErrorOccurred) {
                        // eslint-disable-next-line no-console
                        console.warn({
                            msg: 'An error has occurred getting the layer value. Only the first occurrence of this error is logged.',
                            layerName: layerName,
                            defaultValue: defaultValue,
                            options: options,
                            error: error
                        });
                        this.hasGetLayerValueErrorOccurred = true;
                    }
                    return defaultValue;
                }
            }
        }
    ]);
}();

});
parcelRegister("7HFz2", function(module, exports) {
$parcel$export(module.exports, "default", () => $59bcca5a32a3773a$export$2e2bcd8739ae039);

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $25nEq = parcelRequire("25nEq");

var $hLfKH = parcelRequire("hLfKH");
function $59bcca5a32a3773a$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $59bcca5a32a3773a$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $59bcca5a32a3773a$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $59bcca5a32a3773a$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $59bcca5a32a3773a$export$a66cbd9b2289cd78 = '@all-features';
var $59bcca5a32a3773a$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function Subscriptions() {
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, Subscriptions);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "eventToValue", new Map());
        this.emitter = new (0, (/*@__PURE__*/$parcel$interopDefault($hLfKH)))();
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(Subscriptions, [
        {
            key: "onGateUpdated",
            value: function onGateUpdated(gateName, callback, checkGate, options) {
                var _this = this;
                var value = checkGate(gateName, $59bcca5a32a3773a$var$_objectSpread($59bcca5a32a3773a$var$_objectSpread({}, options), {}, {
                    fireGateExposure: false
                }));
                if (this.eventToValue.get(callback) === undefined) this.eventToValue.set(callback, value);
                var wrapCallback = function wrapCallback() {
                    var value = checkGate(gateName, $59bcca5a32a3773a$var$_objectSpread($59bcca5a32a3773a$var$_objectSpread({}, options), {}, {
                        fireGateExposure: false
                    }));
                    var existingValue = _this.eventToValue.get(callback);
                    if (existingValue !== value) {
                        _this.eventToValue.set(callback, value);
                        callback(value);
                    }
                };
                this.emitter.on(gateName, wrapCallback);
                return function() {
                    _this.emitter.off(gateName, wrapCallback);
                };
            }
        },
        {
            key: "onExperimentValueUpdated",
            value: function onExperimentValueUpdated(experimentName, parameterName, defaultValue, callback, getExperimentValue, options) {
                var _this2 = this;
                var experimentEventName = "".concat(experimentName, ".").concat(parameterName);
                var value = getExperimentValue(experimentName, parameterName, defaultValue, $59bcca5a32a3773a$var$_objectSpread($59bcca5a32a3773a$var$_objectSpread({}, options), {}, {
                    fireExperimentExposure: false
                }));
                if (this.eventToValue.get(callback) === undefined) this.eventToValue.set(callback, value);
                var wrapCallback = function wrapCallback() {
                    var value = getExperimentValue(experimentName, parameterName, defaultValue, $59bcca5a32a3773a$var$_objectSpread($59bcca5a32a3773a$var$_objectSpread({}, options), {}, {
                        fireExperimentExposure: false
                    }));
                    var existingValue = _this2.eventToValue.get(callback);
                    if (existingValue !== value) {
                        _this2.eventToValue.set(callback, value);
                        callback(value);
                    }
                };
                this.emitter.on(experimentEventName, wrapCallback);
                return function() {
                    _this2.emitter.off(experimentEventName, wrapCallback);
                };
            }
        },
        {
            key: "onAnyUpdated",
            value: function onAnyUpdated(callback) {
                var _this3 = this;
                this.emitter.on($59bcca5a32a3773a$export$a66cbd9b2289cd78, callback);
                return function() {
                    _this3.emitter.off($59bcca5a32a3773a$export$a66cbd9b2289cd78, callback);
                };
            }
        },
        {
            key: "anyUpdated",
            value: function anyUpdated() {
                var _this4 = this;
                this.emitter.emit($59bcca5a32a3773a$export$a66cbd9b2289cd78);
                this.emitter.eventNames().filter(function(name) {
                    return name !== $59bcca5a32a3773a$export$a66cbd9b2289cd78;
                }).forEach(function(event) {
                    _this4.emitter.emit(event);
                });
            }
        }
    ]);
}();

});

parcelRegister("6bdCD", function(module, exports) {
$parcel$export(module.exports, "DynamicConfig", () => $47fe564159cc0d18$export$6dc24881a3d96325);

var $ekGgq = parcelRequire("ekGgq");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $1fiiq = parcelRequire("1fiiq");
var $47fe564159cc0d18$export$6dc24881a3d96325 = /*#__PURE__*/ function() {
    function DynamicConfig(configName, configValue, ruleID, evaluationDetails) {
        var secondaryExposures = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : [];
        var allocatedExperimentName = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : '';
        var onDefaultValueFallback = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : null;
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, DynamicConfig);
        this.value = configValue;
        this._name = configName;
        this._ruleID = ruleID;
        this._secondaryExposures = secondaryExposures;
        this._allocatedExperimentName = allocatedExperimentName;
        this._evaluationDetails = evaluationDetails;
        this._onDefaultValueFallback = onDefaultValueFallback;
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(DynamicConfig, [
        {
            key: "get",
            value: function get(key, defaultValue, typeGuard) {
                var _this$_onDefaultValue2;
                var val = this.getValue(key, defaultValue);
                if (val == null) return defaultValue;
                var expectedType = Array.isArray(defaultValue) ? 'array' : (0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(defaultValue);
                var actualType = Array.isArray(val) ? 'array' : (0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(val);
                if (typeGuard) {
                    var _this$_onDefaultValue;
                    if (typeGuard(val)) {
                        this.fireExposure(key);
                        return val;
                    }
                    (_this$_onDefaultValue = this._onDefaultValueFallback) === null || _this$_onDefaultValue === void 0 || _this$_onDefaultValue.call(this, this, key, expectedType, actualType);
                    return defaultValue;
                }
                if (defaultValue == null || expectedType === actualType) {
                    this.fireExposure(key);
                    return val;
                }
                (_this$_onDefaultValue2 = this._onDefaultValueFallback) === null || _this$_onDefaultValue2 === void 0 || _this$_onDefaultValue2.call(this, this, key, expectedType, actualType);
                return defaultValue;
            }
        },
        {
            key: "getValue",
            value: function getValue(key, defaultValue) {
                if (key == null) return this.value;
                if (defaultValue == null) defaultValue = null;
                if (this.value[key] == null) return defaultValue;
                this.fireExposure(key);
                return this.value[key];
            }
        },
        {
            key: "fireExposure",
            value: function fireExposure(key) {
                // Call the wrapped experiment's get method to fire exposure
                if (this.experiment) this.experiment.get(key);
            }
        }
    ], [
        {
            key: "fromExperiment",
            value: function fromExperiment(experiment) {
                var _experiment$__evaluat, _experiment$__evaluat2, _experiment$groupName;
                var config = new DynamicConfig(experiment.name, experiment.value, experiment.ruleID, (0, $1fiiq.migrateEvaluationDetails)(experiment.details), (0, $1fiiq.migrateSecondaryExposures)((_experiment$__evaluat = (_experiment$__evaluat2 = experiment.__evaluation) === null || _experiment$__evaluat2 === void 0 ? void 0 : _experiment$__evaluat2.secondary_exposures) !== null && _experiment$__evaluat !== void 0 ? _experiment$__evaluat : []), (_experiment$groupName = experiment.groupName) !== null && _experiment$groupName !== void 0 ? _experiment$groupName : undefined);
                config.experiment = experiment;
                return config;
            }
        }
    ]);
}();

});
parcelRegister("1fiiq", function(module, exports) {
$parcel$export(module.exports, "getOptionsWithDefaults", () => $0e85626096e38af0$export$d119b37e5f788b43);
$parcel$export(module.exports, "shallowEquals", () => $0e85626096e38af0$export$fa1c2bbf4100b8bc);
$parcel$export(module.exports, "toStatsigUser", () => $0e85626096e38af0$export$3dad1db244472f32);
$parcel$export(module.exports, "migrateInitializationOptions", () => $0e85626096e38af0$export$202946b690d26d22);
$parcel$export(module.exports, "migrateEvaluationDetails", () => $0e85626096e38af0$export$18ad168d3dbac899);
$parcel$export(module.exports, "migrateSecondaryExposures", () => $0e85626096e38af0$export$55fd683752d01e67);

var $1Vcia = parcelRequire("1Vcia");

var $iYJcE = parcelRequire("iYJcE");

var $25nEq = parcelRequire("25nEq");

var $ygbGG = parcelRequire("ygbGG");

var $2lDCa = parcelRequire("2lDCa");

var $iYRGT = parcelRequire("iYRGT");
var $0e85626096e38af0$var$_excluded = [
    "api",
    "disableCurrentPageLogging",
    "loggingIntervalMillis",
    "loggingBufferMaxSize",
    "localMode",
    "eventLoggingApi",
    "eventLoggingApiForRetries",
    "disableLocalStorage",
    "ignoreWindowUndefined",
    "disableAllLogging",
    "initTimeoutMs",
    "disableNetworkKeepalive",
    "overrideStableID",
    "disableErrorLogging",
    "disableAutoMetricsLogging"
];
function $0e85626096e38af0$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $0e85626096e38af0$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $0e85626096e38af0$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $0e85626096e38af0$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $0e85626096e38af0$export$d119b37e5f788b43 = function getOptionsWithDefaults(options) {
    return $0e85626096e38af0$var$_objectSpread({
        /**
     * If more federal PerimeterTypes are added in the future, this should be updated so
     * that isFedRamp() === true always returns the strictest perimeter.
     */ perimeter: (0, $ygbGG.isFedRamp)() ? (0, $iYRGT.PerimeterType).FEDRAMP_MODERATE : (0, $iYRGT.PerimeterType).COMMERCIAL
    }, options);
};
var $0e85626096e38af0$export$fa1c2bbf4100b8bc = function shallowEquals(objectA, objectB) {
    if (!objectA && !objectB) return true;
    if (!objectA || !objectB) return false;
    var aEntries = Object.entries(objectA);
    var bEntries = Object.entries(objectB);
    if (aEntries.length !== bEntries.length) return false;
    var ascendingKeyOrder = function ascendingKeyOrder(_ref, _ref2) {
        var _ref3 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_ref, 1), key1 = _ref3[0];
        var _ref4 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_ref2, 1), key2 = _ref4[0];
        return key1.localeCompare(key2);
    };
    aEntries.sort(ascendingKeyOrder);
    bEntries.sort(ascendingKeyOrder);
    for(var i = 0; i < aEntries.length; i++){
        var _aEntries$i = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(aEntries[i], 2), aValue = _aEntries$i[1];
        var _bEntries$i = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(bEntries[i], 2), bValue = _bEntries$i[1];
        if (aValue !== bValue) return false;
    }
    return true;
};
var $0e85626096e38af0$export$3dad1db244472f32 = function toStatsigUser(identifiers, customAttributes) {
    var user = {
        customIDs: identifiers,
        custom: customAttributes
    };
    if (identifiers.atlassianAccountId) user.userID = identifiers.atlassianAccountId;
    return user;
};
var $0e85626096e38af0$export$202946b690d26d22 = function migrateInitializationOptions(options) {
    var api = options.api, disableCurrentPageLogging = options.disableCurrentPageLogging, loggingIntervalMillis = options.loggingIntervalMillis, loggingBufferMaxSize = options.loggingBufferMaxSize, localMode = options.localMode, eventLoggingApi = options.eventLoggingApi, eventLoggingApiForRetries = options.eventLoggingApiForRetries, disableLocalStorage = options.disableLocalStorage, ignoreWindowUndefined = options.ignoreWindowUndefined, disableAllLogging = options.disableAllLogging, _initTimeoutMs = options.initTimeoutMs, _disableNetworkKeepalive = options.disableNetworkKeepalive, _overrideStableID = options.overrideStableID, _disableErrorLogging = options.disableErrorLogging, _disableAutoMetricsLogging = options.disableAutoMetricsLogging, rest = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(options, $0e85626096e38af0$var$_excluded);
    return $0e85626096e38af0$var$_objectSpread($0e85626096e38af0$var$_objectSpread({}, rest), {}, {
        networkConfig: {
            api: api,
            logEventUrl: eventLoggingApi ? eventLoggingApi + 'rgstr' : undefined,
            logEventFallbackUrls: eventLoggingApiForRetries ? [
                eventLoggingApiForRetries
            ] : undefined,
            preventAllNetworkTraffic: localMode || !ignoreWindowUndefined && typeof window === 'undefined'
        },
        includeCurrentPageUrlWithEvents: !disableCurrentPageLogging,
        loggingIntervalMs: loggingIntervalMillis,
        loggingBufferMaxSize: loggingBufferMaxSize,
        disableStorage: disableLocalStorage === undefined ? localMode : disableLocalStorage,
        disableLogging: disableAllLogging === undefined ? localMode : disableAllLogging
    });
};
var $0e85626096e38af0$var$evaluationReasonMappings = Object.entries((0, $2lDCa.EvaluationReason)).map(function(_ref5) {
    var _ref6 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_ref5, 2), key = _ref6[0], value = _ref6[1];
    return [
        key.toLowerCase(),
        value
    ];
});
var $0e85626096e38af0$export$18ad168d3dbac899 = function migrateEvaluationDetails(details) {
    var _evaluationReasonMapp, _evaluationReasonMapp2, _details$receivedAt;
    var reasonLower = details.reason.toLowerCase();
    return {
        reason: (_evaluationReasonMapp = (_evaluationReasonMapp2 = $0e85626096e38af0$var$evaluationReasonMappings.find(function(_ref7) {
            var _ref8 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_ref7, 1), key = _ref8[0];
            return reasonLower.includes(key);
        })) === null || _evaluationReasonMapp2 === void 0 ? void 0 : _evaluationReasonMapp2[1]) !== null && _evaluationReasonMapp !== void 0 ? _evaluationReasonMapp : (0, $2lDCa.EvaluationReason).Unknown,
        time: (_details$receivedAt = details.receivedAt) !== null && _details$receivedAt !== void 0 ? _details$receivedAt : Date.now()
    };
};
var $0e85626096e38af0$export$55fd683752d01e67 = function migrateSecondaryExposures(secondaryExposures) {
    return secondaryExposures.map(function(exposure) {
        if (typeof exposure === 'string') // This should ideally have gateValue and ruleID fields too, but it's not possible for us
        // to determine the correct values for these.
        return {
            gate: exposure
        };
        return exposure;
    });
};

});
parcelRegister("2lDCa", function(module, exports) {
$parcel$export(module.exports, "EvaluationReason", () => $1b5c459198dd8d8d$export$c62558b199e46828);
// Reference: https://github.com/statsig-io/js-lite/blob/main/src/StatsigStore.ts
var $1b5c459198dd8d8d$export$c62558b199e46828 = /*#__PURE__*/ function(EvaluationReason) {
    // Order is important since the logic for migrating from a new client reason to an old one
    // returns the first which is a substring of the new client reason
    EvaluationReason["Error"] = "Error";
    EvaluationReason["LocalOverride"] = "LocalOverride";
    EvaluationReason["Unrecognized"] = "Unrecognized";
    EvaluationReason["Uninitialized"] = "Uninitialized";
    EvaluationReason["NetworkNotModified"] = "NetworkNotModified";
    EvaluationReason["Network"] = "Network";
    EvaluationReason["InvalidBootstrap"] = "InvalidBootstrap";
    EvaluationReason["Bootstrap"] = "Bootstrap";
    EvaluationReason["Cache"] = "Cache";
    // For when we could not migrate the reason from the new client
    EvaluationReason["Unknown"] = "Unknown";
    return EvaluationReason;
}({}); // Reference: https://github.com/statsig-io/js-lite/blob/main/src/StatsigSDKOptions.ts

});

parcelRegister("iYRGT", function(module, exports) {
$parcel$export(module.exports, "FeatureGateEnvironment", () => $dd177a7951d29162$export$479e7351a733299);
$parcel$export(module.exports, "PerimeterType", () => $dd177a7951d29162$export$c42b7bbc5e7ba555);
/**
 * The identifiers for the user. Options are restricted to the set that is currently supported.
 */ /**
 * Base client options. Does not include any options specific to providers
 * @interface BaseClientOptions
 * @property {FeatureGateEnvironment} environment - The environment for the client.
 * @property {string} targetApp - The target app for the client.
 * @property {AnalyticsWebClient} analyticsWebClient - The analytics web client.
 * @property {PerimeterType} perimeter - The perimeter for the client.
 */ /**
 * The options for the client.
 * @interface ClientOptions
 * @extends {BaseClientOptions}
 * @property {string} apiKey - The API key for the client.
 * @property {fetchTimeoutMs} fetchTimeoutMs - The timeout for the fetch request in milliseconds. Defaults to 5000.
 * @property {boolean} useGatewayURL - Whether to use the gateway URL. Defaults to false.
 */ /**
 * The custom attributes for the user.
 */ var $dd177a7951d29162$export$479e7351a733299 = /*#__PURE__*/ function(FeatureGateEnvironment) {
    FeatureGateEnvironment["Development"] = "development";
    FeatureGateEnvironment["Staging"] = "staging";
    FeatureGateEnvironment["Production"] = "production";
    return FeatureGateEnvironment;
}({});
var $dd177a7951d29162$export$c42b7bbc5e7ba555 = /*#__PURE__*/ function(PerimeterType) {
    PerimeterType["COMMERCIAL"] = "commercial";
    PerimeterType["FEDRAMP_MODERATE"] = "fedramp-moderate";
    return PerimeterType;
}({});
var $dd177a7951d29162$export$42f4885608027d0c = 'non_boolean'; // Type magic to get the JSDoc comments from the Client class methods to appear on the static
 // methods in FeatureGates where the property name and function type are identical

});



parcelRegister("aJeNa", function(module, exports) {
$parcel$export(module.exports, "Layer", () => $7cf994b8c9dff269$export$936d0764594b6eb3);

var $ekGgq = parcelRequire("ekGgq");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $1fiiq = parcelRequire("1fiiq");
var $7cf994b8c9dff269$export$936d0764594b6eb3 = /*#__PURE__*/ function() {
    function Layer(name, layerValue, ruleID, evaluationDetails) {
        var logParameterFunction = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
        var secondaryExposures = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : [];
        var undelegatedSecondaryExposures = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : [];
        var allocatedExperimentName = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : '';
        var explicitParameters = arguments.length > 8 && arguments[8] !== undefined ? arguments[8] : [];
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, Layer);
        this._logParameterFunction = logParameterFunction;
        this._name = name;
        this._value = JSON.parse(JSON.stringify(layerValue !== null && layerValue !== void 0 ? layerValue : {}));
        this._ruleID = ruleID !== null && ruleID !== void 0 ? ruleID : '';
        this._evaluationDetails = evaluationDetails;
        this._secondaryExposures = secondaryExposures;
        this._undelegatedSecondaryExposures = undelegatedSecondaryExposures;
        this._allocatedExperimentName = allocatedExperimentName;
        this._explicitParameters = explicitParameters;
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(Layer, [
        {
            key: "get",
            value: function get(key, defaultValue, typeGuard) {
                var _this = this;
                var val = this._value[key];
                if (val == null) return defaultValue;
                var logAndReturn = function logAndReturn() {
                    _this._logLayerParameterExposure(key);
                    return val;
                };
                if (typeGuard) return typeGuard(val) ? logAndReturn() : defaultValue;
                if (defaultValue == null) return logAndReturn();
                if ((0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(val) === (0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(defaultValue) && Array.isArray(defaultValue) === Array.isArray(val)) return logAndReturn();
                return defaultValue;
            }
        },
        {
            key: "getValue",
            value: function getValue(key, defaultValue) {
                // eslint-disable-next-line eqeqeq
                if (defaultValue == undefined) defaultValue = null;
                var val = this._value[key];
                if (val != null) this._logLayerParameterExposure(key);
                return val !== null && val !== void 0 ? val : defaultValue;
            }
        },
        {
            key: "_logLayerParameterExposure",
            value: function _logLayerParameterExposure(parameterName) {
                var _this$_logParameterFu;
                (_this$_logParameterFu = this._logParameterFunction) === null || _this$_logParameterFu === void 0 || _this$_logParameterFu.call(this, this, parameterName);
            }
        }
    ], [
        {
            key: "fromLayer",
            value: function fromLayer(layer) {
                var _layer$__evaluation$s, _layer$__evaluation, _layer$__evaluation$u, _layer$__evaluation2, _layer$__evaluation3, _layer$__evaluation4;
                var value = new Layer(layer.name, layer.__value, layer.ruleID, (0, $1fiiq.migrateEvaluationDetails)(layer.details), function(_layer, parameterName) {
                    return layer.get(parameterName);
                }, (0, $1fiiq.migrateSecondaryExposures)((_layer$__evaluation$s = (_layer$__evaluation = layer.__evaluation) === null || _layer$__evaluation === void 0 ? void 0 : _layer$__evaluation.secondary_exposures) !== null && _layer$__evaluation$s !== void 0 ? _layer$__evaluation$s : []), (0, $1fiiq.migrateSecondaryExposures)((_layer$__evaluation$u = (_layer$__evaluation2 = layer.__evaluation) === null || _layer$__evaluation2 === void 0 ? void 0 : _layer$__evaluation2.undelegated_secondary_exposures) !== null && _layer$__evaluation$u !== void 0 ? _layer$__evaluation$u : []), (_layer$__evaluation3 = layer.__evaluation) === null || _layer$__evaluation3 === void 0 ? void 0 : _layer$__evaluation3.allocated_experiment_name, (_layer$__evaluation4 = layer.__evaluation) === null || _layer$__evaluation4 === void 0 ? void 0 : _layer$__evaluation4.explicit_parameters);
                return value;
            }
        }
    ]);
}();

});

parcelRegister("2cJWD", function(module, exports) {
$parcel$export(module.exports, "default", () => $19b0576e040f49f0$export$2e2bcd8739ae039);

var $25nEq = parcelRequire("25nEq");

var $fL8KA = parcelRequire("fL8KA");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $6HG4S = parcelRequire("6HG4S");

var $iYRGT = parcelRequire("iYRGT");

var $jeMGe = parcelRequire("jeMGe");

var $8fiMv = parcelRequire("8fiMv");
function $19b0576e040f49f0$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $19b0576e040f49f0$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $19b0576e040f49f0$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $19b0576e040f49f0$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $19b0576e040f49f0$var$DEFAULT_REQUEST_TIMEOUT_MS = 5000;
var $19b0576e040f49f0$export$250a58ecde616daa = 'https://api.atlassian.com/flags';
var $19b0576e040f49f0$export$942ba04389b0d5a2 = 'https://api.stg.atlassian.com/flags';
var $19b0576e040f49f0$export$f058dbf75c3bc647 = 'https://api.dev.atlassian.com/flags';
var $19b0576e040f49f0$export$1a401a0da8da3565 = 'https://api.stg.atlassian-us-gov-mod.com/flags';
var $19b0576e040f49f0$export$18c93900db9358a4 = 'https://api.atlassian-us-gov-mod.com/flags';
var $19b0576e040f49f0$export$4e8a0415edbfa1f7 = 'https://atlassian-statsig-proxy-archetype.atl-paas.%s.atl-ic.net';
var $19b0576e040f49f0$export$cb3cd156f70d7e94 = 'oasis-stg.com/flags';
var $19b0576e040f49f0$export$921fbc6cdfd4eee0 = 'atlassian-isolated.net/flags';
var $19b0576e040f49f0$export$450bd8fb2a6d7ace = '/gateway/api/flags';
var $19b0576e040f49f0$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function Fetcher() {
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, Fetcher);
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(Fetcher, null, [
        {
            key: "fetchClientSdk",
            value: function() {
                var _fetchClientSdk = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee(fetcherOptions) {
                    var targetApp, url;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee$(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                targetApp = fetcherOptions.targetApp;
                                url = "/api/v2/frontend/clientSdkKey/".concat(targetApp);
                                _context.prev = 2;
                                _context.next = 5;
                                return this.fetchRequest(url, 'GET', fetcherOptions);
                            case 5:
                                return _context.abrupt("return", _context.sent);
                            case 8:
                                _context.prev = 8;
                                _context.t0 = _context["catch"](2);
                                if (!(_context.t0 instanceof Error)) {
                                    _context.next = 12;
                                    break;
                                }
                                throw _context.t0;
                            case 12:
                                throw Error('Failed to retrieve client sdk key');
                            case 13:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee, this, [
                        [
                            2,
                            8
                        ]
                    ]);
                }));
                function fetchClientSdk(_x) {
                    return _fetchClientSdk.apply(this, arguments);
                }
                return fetchClientSdk;
            }()
        },
        {
            key: "fetchExperimentValues",
            value: function() {
                var _fetchExperimentValues = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee2(fetcherOptions, identifiers, customAttributes) {
                    var requestBody;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee2$(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                requestBody = {
                                    identifiers: identifiers,
                                    customAttributes: customAttributes,
                                    targetApp: fetcherOptions.targetApp
                                };
                                _context2.prev = 1;
                                _context2.next = 4;
                                return this.fetchRequest('/api/v2/frontend/experimentValues', 'POST', fetcherOptions, requestBody);
                            case 4:
                                return _context2.abrupt("return", _context2.sent);
                            case 7:
                                _context2.prev = 7;
                                _context2.t0 = _context2["catch"](1);
                                if (!(_context2.t0 instanceof Error)) {
                                    _context2.next = 11;
                                    break;
                                }
                                throw _context2.t0;
                            case 11:
                                throw Error('Failed to retrieve experiment values');
                            case 12:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2, this, [
                        [
                            1,
                            7
                        ]
                    ]);
                }));
                function fetchExperimentValues(_x2, _x3, _x4) {
                    return _fetchExperimentValues.apply(this, arguments);
                }
                return fetchExperimentValues;
            }()
        },
        {
            key: "handleResponseError",
            value: function() {
                var _handleResponseError = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee3(response) {
                    var body;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee3$(_context3) {
                        while(true)switch(_context3.prev = _context3.next){
                            case 0:
                                if (response.ok) {
                                    _context3.next = 5;
                                    break;
                                }
                                _context3.next = 3;
                                return response.text();
                            case 3:
                                body = _context3.sent;
                                throw new (0, $8fiMv.ResponseError)("Non 2xx response status received, status: ".concat(response.status, ", body: ").concat(JSON.stringify(body)));
                            case 5:
                                if (!(response.status === 204)) {
                                    _context3.next = 7;
                                    break;
                                }
                                throw new (0, $8fiMv.ResponseError)('Unexpected 204 response');
                            case 7:
                            case "end":
                                return _context3.stop();
                        }
                    }, _callee3);
                }));
                function handleResponseError(_x5) {
                    return _handleResponseError.apply(this, arguments);
                }
                return handleResponseError;
            }()
        },
        {
            key: "extractResponseBody",
            value: function() {
                var _extractResponseBody = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee4(response) {
                    var value;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee4$(_context4) {
                        while(true)switch(_context4.prev = _context4.next){
                            case 0:
                                _context4.next = 2;
                                return response.text();
                            case 2:
                                value = _context4.sent;
                                return _context4.abrupt("return", JSON.parse(value));
                            case 4:
                            case "end":
                                return _context4.stop();
                        }
                    }, _callee4);
                }));
                function extractResponseBody(_x6) {
                    return _extractResponseBody.apply(this, arguments);
                }
                return extractResponseBody;
            }()
        },
        {
            key: "getBaseUrl",
            value: function getBaseUrl(serviceEnv) {
                var useGatewayUrl = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
                var perimeter = arguments.length > 2 ? arguments[2] : undefined;
                var isolationContextId = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
                if (useGatewayUrl) return $19b0576e040f49f0$export$450bd8fb2a6d7ace;
                if (perimeter === (0, $iYRGT.PerimeterType).FEDRAMP_MODERATE) switch(serviceEnv){
                    case (0, $iYRGT.FeatureGateEnvironment).Production:
                        return $19b0576e040f49f0$export$18c93900db9358a4;
                    case (0, $iYRGT.FeatureGateEnvironment).Staging:
                        return $19b0576e040f49f0$export$1a401a0da8da3565;
                    default:
                        throw new Error("Invalid environment \"".concat(serviceEnv, "\" for \"").concat(perimeter, "\" perimeter"));
                }
                else if (perimeter === (0, $iYRGT.PerimeterType).COMMERCIAL) switch(serviceEnv){
                    case (0, $iYRGT.FeatureGateEnvironment).Development:
                        return $19b0576e040f49f0$export$f058dbf75c3bc647;
                    case (0, $iYRGT.FeatureGateEnvironment).Staging:
                        var apiUrl = this.getApiUrl(isolationContextId);
                        if (apiUrl !== null) return apiUrl;
                        return $19b0576e040f49f0$export$942ba04389b0d5a2;
                    default:
                        var prodApiUrl = this.getApiUrl(isolationContextId);
                        if (prodApiUrl !== null) return prodApiUrl;
                        return $19b0576e040f49f0$export$250a58ecde616daa;
                }
                else throw new Error("Invalid perimeter \"".concat(perimeter, "\""));
            }
        },
        {
            key: "fetchRequest",
            value: function() {
                var _fetchRequest = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee5(path, method, fetcherOptions, body) {
                    var baseUrl, fetchTimeout, abortSignal, abortController, response;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee5$(_context5) {
                        while(true)switch(_context5.prev = _context5.next){
                            case 0:
                                baseUrl = Fetcher.getBaseUrl(fetcherOptions.environment, fetcherOptions.useGatewayURL, fetcherOptions.perimeter, fetcherOptions.isolationContextId);
                                fetchTimeout = fetcherOptions.fetchTimeoutMs || $19b0576e040f49f0$var$DEFAULT_REQUEST_TIMEOUT_MS;
                                if (AbortSignal.timeout) abortSignal = AbortSignal.timeout(fetchTimeout);
                                else if (AbortController) {
                                    abortController = new AbortController();
                                    abortSignal = abortController.signal;
                                    setTimeout(function() {
                                        return abortController.abort();
                                    }, fetchTimeout);
                                }
                                _context5.next = 5;
                                return fetch("".concat(baseUrl).concat(path), $19b0576e040f49f0$var$_objectSpread({
                                    method: method,
                                    headers: {
                                        'Content-Type': 'application/json',
                                        'X-Client-Name': 'feature-gate-js-client',
                                        'X-Client-Version': (0, $jeMGe.CLIENT_VERSION),
                                        'X-API-KEY': fetcherOptions.apiKey
                                    },
                                    signal: abortSignal
                                }, body && {
                                    body: JSON.stringify(body)
                                }));
                            case 5:
                                response = _context5.sent;
                                _context5.next = 8;
                                return this.handleResponseError(response);
                            case 8:
                                _context5.next = 10;
                                return this.extractResponseBody(response);
                            case 10:
                                return _context5.abrupt("return", _context5.sent);
                            case 11:
                            case "end":
                                return _context5.stop();
                        }
                    }, _callee5, this);
                }));
                function fetchRequest(_x7, _x8, _x9, _x0) {
                    return _fetchRequest.apply(this, arguments);
                }
                return fetchRequest;
            }()
        },
        {
            key: "getApiUrl",
            value: function getApiUrl(isolationContextId) {
                var window1 = this.getWindowLocation();
                if (window1 === undefined) {
                    //this is needed when this SDK is used for SSR or plugin use cases where secret keys not available to use backend SDKs
                    if (!isolationContextId) return null;
                    return $19b0576e040f49f0$export$4e8a0415edbfa1f7.replace('%s', isolationContextId);
                }
                var protocol = window1.protocol, hostname = window1.hostname;
                // Match last subdomain fragment before oasis-stg.com
                var oasisMatch = hostname.match(/([^.]+)\.oasis-stg\.com$/);
                if (oasisMatch) return "".concat(protocol, "//api.").concat(oasisMatch[1], ".").concat($19b0576e040f49f0$export$cb3cd156f70d7e94);
                // Match last subdomain fragment before atlassian-isolated.net
                var isolatedMatch = hostname.match(/([^.]+)\.atlassian-isolated\.net$/);
                if (isolatedMatch) return "".concat(protocol, "//api.").concat(isolatedMatch[1], ".").concat($19b0576e040f49f0$export$921fbc6cdfd4eee0);
                return null;
            }
        },
        {
            key: "getWindowLocation",
            value: function getWindowLocation() {
                if (typeof window !== 'undefined' && window.location) return window.location;
                return undefined;
            }
        }
    ]);
}();

});
parcelRegister("jeMGe", function(module, exports) {
$parcel$export(module.exports, "CLIENT_VERSION", () => $e01515fc694d863e$export$a59f8d67326bd1cb);
/// <reference types="node" />
var $e01515fc694d863e$export$a59f8d67326bd1cb = "0.0.0-development";

});

parcelRegister("8fiMv", function(module, exports) {
$parcel$export(module.exports, "ResponseError", () => $600e4b088653d78d$export$286baf652d0b1206);

var $arMYe = parcelRequire("arMYe");

var $9P61R = parcelRequire("9P61R");

var $kIXpt = parcelRequire("kIXpt");

var $cYPzS = parcelRequire("cYPzS");

var $eyuDe = parcelRequire("eyuDe");

var $c7s0H = parcelRequire("c7s0H");
function $600e4b088653d78d$var$_callSuper(t, o, e) {
    return o = (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(o), (0, (/*@__PURE__*/$parcel$interopDefault($kIXpt)))(t, $600e4b088653d78d$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(t).constructor) : o.apply(t, e));
}
function $600e4b088653d78d$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($600e4b088653d78d$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $600e4b088653d78d$export$286baf652d0b1206 = /*#__PURE__*/ function(_Error) {
    function ResponseError(message) {
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, ResponseError);
        return $600e4b088653d78d$var$_callSuper(this, ResponseError, [
            message
        ]);
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($eyuDe)))(ResponseError, _Error);
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(ResponseError);
}(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($c7s0H)))(Error));

});


parcelRegister("bfqQV", function(module, exports) {
$parcel$export(module.exports, "NoFetchDataAdapter", () => $8305ecc7067867f1$export$55fffef3474104af);

var $fL8KA = parcelRequire("fL8KA");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $kIXpt = parcelRequire("kIXpt");

var $cYPzS = parcelRequire("cYPzS");

var $lwlXp = parcelRequire("lwlXp");

var $eyuDe = parcelRequire("eyuDe");

var $25nEq = parcelRequire("25nEq");

var $6HG4S = parcelRequire("6HG4S");

var $iFR7a = parcelRequire("iFR7a");
function $8305ecc7067867f1$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $8305ecc7067867f1$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $8305ecc7067867f1$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $8305ecc7067867f1$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $8305ecc7067867f1$var$_callSuper(t, o, e) {
    return o = (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(o), (0, (/*@__PURE__*/$parcel$interopDefault($kIXpt)))(t, $8305ecc7067867f1$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(t).constructor) : o.apply(t, e));
}
function $8305ecc7067867f1$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($8305ecc7067867f1$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $8305ecc7067867f1$var$_superPropGet(t, o, e, r) {
    var p = (0, (/*@__PURE__*/$parcel$interopDefault($lwlXp)))((0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(1 & r ? t.prototype : t), o, e);
    return 2 & r && "function" == typeof p ? function(t) {
        return p.apply(e, t);
    } : p;
}
var $8305ecc7067867f1$export$55fffef3474104af = /*#__PURE__*/ function(_DataAdapterCore) {
    function NoFetchDataAdapter() {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, NoFetchDataAdapter);
        _this = $8305ecc7067867f1$var$_callSuper(this, NoFetchDataAdapter, [
            'NoFetchDataAdapter',
            'nofetch'
        ]);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "bootstrapResult", null);
        return _this;
    }
    /**
   * Make sure to call this **before** calling `initializeAsync` or `updateUserAsync` but
   * after the Statsig client has been created!
   */ (0, (/*@__PURE__*/$parcel$interopDefault($eyuDe)))(NoFetchDataAdapter, _DataAdapterCore);
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(NoFetchDataAdapter, [
        {
            key: "setBootstrapData",
            value: function setBootstrapData(data) {
                this.bootstrapResult = data ? {
                    source: 'Bootstrap',
                    data: JSON.stringify(data),
                    receivedAt: Date.now(),
                    stableID: (0, $iFR7a.StableID).get(this._getSdkKey()),
                    fullUserHash: null
                } : null;
            }
        },
        {
            key: "prefetchData",
            value: function() {
                var _prefetchData = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee(_user, _options) {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee$(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee);
                }));
                function prefetchData(_x, _x2) {
                    return _prefetchData.apply(this, arguments);
                }
                return prefetchData;
            }()
        },
        {
            key: "getDataAsync",
            value: function() {
                var _getDataAsync = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee2(_current, user, _options) {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee2$(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                return _context2.abrupt("return", this.bootstrapResult && $8305ecc7067867f1$var$_objectSpread($8305ecc7067867f1$var$_objectSpread({}, this.bootstrapResult), {}, {
                                    fullUserHash: (0, $iFR7a._getFullUserHash)(user)
                                }));
                            case 1:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2, this);
                }));
                function getDataAsync(_x3, _x4, _x5) {
                    return _getDataAsync.apply(this, arguments);
                }
                return getDataAsync;
            }()
        },
        {
            key: "getDataSync",
            value: function getDataSync(user) {
                return this.bootstrapResult && $8305ecc7067867f1$var$_objectSpread($8305ecc7067867f1$var$_objectSpread({}, this.bootstrapResult), {}, {
                    fullUserHash: (0, $iFR7a._getFullUserHash)(user)
                });
            }
        },
        {
            key: "_fetchFromNetwork",
            value: function() {
                var _fetchFromNetwork2 = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee3(_current, _user, _options) {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee3$(_context3) {
                        while(true)switch(_context3.prev = _context3.next){
                            case 0:
                                return _context3.abrupt("return", null);
                            case 1:
                            case "end":
                                return _context3.stop();
                        }
                    }, _callee3);
                }));
                function _fetchFromNetwork(_x6, _x7, _x8) {
                    return _fetchFromNetwork2.apply(this, arguments);
                }
                return _fetchFromNetwork;
            }()
        },
        {
            key: "_getCacheKey",
            value: function _getCacheKey(user) {
                // Same logic as default data adapter
                // https://github.com/statsig-io/js-client-monorepo/blob/main/packages/js-client/src/StatsigEvaluationsDataAdapter.ts
                var key = (0, $iFR7a._getStorageKey)(this._getSdkKey(), user);
                return "".concat((0, $iFR7a.DataAdapterCachePrefix), ".").concat(this._cacheSuffix, ".").concat(key);
            }
        },
        {
            key: "_isCachedResultValidFor204",
            value: function _isCachedResultValidFor204(_result, _user) {
                return false;
            }
        },
        {
            key: "setDataLegacy",
            value: function setDataLegacy(data, user) {
                $8305ecc7067867f1$var$_superPropGet(NoFetchDataAdapter, "setData", this, 3)([
                    data,
                    user
                ]);
            }
        },
        {
            key: "toJSON",
            value: function toJSON() {
                var result = $8305ecc7067867f1$var$_objectSpread({}, this);
                delete result._options;
                delete result._inMemoryCache;
                delete result.bootstrapResult;
                return result;
            }
        }
    ]);
}((0, $iFR7a.DataAdapterCore));

});

parcelRegister("9xnxJ", function(module, exports) {
$parcel$export(module.exports, "LOCAL_STORAGE_KEY", () => $6f19754a7eb52889$export$d8474cff104280f3);
$parcel$export(module.exports, "PersistentOverrideAdapter", () => $6f19754a7eb52889$export$bcb28fbac1def494);

var $25nEq = parcelRequire("25nEq");

var $iYJcE = parcelRequire("iYJcE");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $dtn6l = parcelRequire("dtn6l");
function $6f19754a7eb52889$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $6f19754a7eb52889$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $6f19754a7eb52889$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $6f19754a7eb52889$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $6f19754a7eb52889$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $6f19754a7eb52889$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $6f19754a7eb52889$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $6f19754a7eb52889$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $6f19754a7eb52889$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $6f19754a7eb52889$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
var $6f19754a7eb52889$var$LOCAL_OVERRIDE_REASON = 'LocalOverride:Recognized';
var $6f19754a7eb52889$export$d8474cff104280f3 = 'STATSIG_OVERRIDES';
var $6f19754a7eb52889$var$LEGACY_LOCAL_STORAGE_KEY = 'STATSIG_JS_LITE_LOCAL_OVERRIDES';
var $6f19754a7eb52889$var$makeEmptyStore = function makeEmptyStore() {
    return {
        gates: {},
        configs: {},
        layers: {}
    };
};
var $6f19754a7eb52889$var$djb2MapKey = function djb2MapKey(hash, kind) {
    return kind + ':' + hash;
};
var $6f19754a7eb52889$export$bcb28fbac1def494 = /*#__PURE__*/ function() {
    function PersistentOverrideAdapter(localStorageKey) {
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, PersistentOverrideAdapter);
        this._overrides = $6f19754a7eb52889$var$makeEmptyStore();
        this._djb2Map = new Map();
        this._localStorageKey = localStorageKey;
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(PersistentOverrideAdapter, [
        {
            key: "parseStoredOverrides",
            value: function parseStoredOverrides(localStorageKey) {
                try {
                    var json = window.localStorage.getItem(localStorageKey);
                    if (!json) return $6f19754a7eb52889$var$makeEmptyStore();
                    return JSON.parse(json);
                } catch (_unused) {
                    return $6f19754a7eb52889$var$makeEmptyStore();
                }
            }
        },
        {
            key: "mergeOverrides",
            value: function mergeOverrides() {
                var merged = $6f19754a7eb52889$var$makeEmptyStore();
                for(var _len = arguments.length, allOverrides = new Array(_len), _key = 0; _key < _len; _key++)allOverrides[_key] = arguments[_key];
                for(var _i = 0, _allOverrides = allOverrides; _i < _allOverrides.length; _i++){
                    var overrides = _allOverrides[_i];
                    for(var _i2 = 0, _Object$entries = Object.entries((_overrides$gates = overrides.gates) !== null && _overrides$gates !== void 0 ? _overrides$gates : {}); _i2 < _Object$entries.length; _i2++){
                        var _overrides$gates;
                        var _Object$entries$_i = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_Object$entries[_i2], 2), name = _Object$entries$_i[0], value = _Object$entries$_i[1];
                        merged.gates[name] = value;
                    }
                    for(var _i3 = 0, _Object$entries2 = Object.entries((_overrides$configs = overrides.configs) !== null && _overrides$configs !== void 0 ? _overrides$configs : {}); _i3 < _Object$entries2.length; _i3++){
                        var _overrides$configs;
                        var _Object$entries2$_i = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_Object$entries2[_i3], 2), _name = _Object$entries2$_i[0], _value = _Object$entries2$_i[1];
                        merged.configs[_name] = _value;
                    }
                    for(var _i4 = 0, _Object$entries3 = Object.entries((_overrides$layers = overrides.layers) !== null && _overrides$layers !== void 0 ? _overrides$layers : {}); _i4 < _Object$entries3.length; _i4++){
                        var _overrides$layers;
                        var _Object$entries3$_i = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_Object$entries3[_i4], 2), _name2 = _Object$entries3$_i[0], _value2 = _Object$entries3$_i[1];
                        merged.layers[_name2] = _value2;
                    }
                }
                return merged;
            }
        },
        {
            key: "initFromStoredOverrides",
            value: function initFromStoredOverrides() {
                var storedOverrides = this.mergeOverrides(this._overrides, this.parseStoredOverrides($6f19754a7eb52889$var$LEGACY_LOCAL_STORAGE_KEY), this.parseStoredOverrides(this._localStorageKey));
                // Clear data from legacy local storage key now we've read from it.
                // This prevents things being stuck in there that are always read but never written to.
                try {
                    window.localStorage.removeItem($6f19754a7eb52889$var$LEGACY_LOCAL_STORAGE_KEY);
                } catch (_unused2) {
                // ignored - window is not defined in non-browser environments, and we don't save things there
                // (things like SSR, etc)
                }
                // In version 4.24.0 we introduced hashes in this override adapter, but had a bug which would cause
                // multiple hashes to continue being created. This code here removes these hashes since we've moved
                // to using a more reliable and easier to maintain map in `_djb2Map`.
                for(var _i5 = 0, _Object$values = Object.values(storedOverrides); _i5 < _Object$values.length; _i5++){
                    var container = _Object$values[_i5];
                    var allKeys = new Set(Object.keys(container));
                    var _iterator = $6f19754a7eb52889$var$_createForOfIteratorHelper(allKeys), _step;
                    try {
                        for(_iterator.s(); !(_step = _iterator.n()).done;){
                            var name = _step.value;
                            var hash = (0, $dtn6l._DJB2)(name);
                            if (allKeys.has(hash)) delete container[hash];
                        }
                    } catch (err) {
                        _iterator.e(err);
                    } finally{
                        _iterator.f();
                    }
                }
                this.applyOverrides(storedOverrides);
            }
        },
        {
            key: "saveOverrides",
            value: function saveOverrides() {
                try {
                    window.localStorage.setItem(this._localStorageKey, JSON.stringify(this._overrides));
                } catch (_unused3) {
                // ignored - window is not defined in non-browser environments, and we don't save things there
                // (things like SSR, etc)
                }
            }
        },
        {
            key: "getOverrides",
            value: function getOverrides() {
                return this.mergeOverrides(this._overrides);
            }
        },
        {
            key: "applyOverrides",
            value: function applyOverrides(overrides) {
                var newOverrides = $6f19754a7eb52889$var$_objectSpread($6f19754a7eb52889$var$_objectSpread({}, $6f19754a7eb52889$var$makeEmptyStore()), overrides);
                this._djb2Map.clear();
                for(var _i6 = 0, _Object$entries4 = Object.entries(newOverrides); _i6 < _Object$entries4.length; _i6++){
                    var _Object$entries4$_i = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_Object$entries4[_i6], 2), containerName = _Object$entries4$_i[0], container = _Object$entries4$_i[1];
                    for(var _i7 = 0, _Object$entries5 = Object.entries(container); _i7 < _Object$entries5.length; _i7++){
                        var _Object$entries5$_i = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_Object$entries5[_i7], 2), name = _Object$entries5$_i[0], value = _Object$entries5$_i[1];
                        this._djb2Map.set($6f19754a7eb52889$var$djb2MapKey((0, $dtn6l._DJB2)(name), containerName), value);
                    }
                }
                this._overrides = newOverrides;
            }
        },
        {
            key: "setOverrides",
            value: function setOverrides(overrides) {
                this.applyOverrides(overrides);
                this.saveOverrides();
            }
        },
        {
            key: "overrideGate",
            value: function overrideGate(name, value) {
                this._overrides.gates[name] = value;
                this._djb2Map.set($6f19754a7eb52889$var$djb2MapKey((0, $dtn6l._DJB2)(name), 'gates'), value);
                this.saveOverrides();
            }
        },
        {
            key: "removeGateOverride",
            value: function removeGateOverride(name) {
                delete this._overrides.gates[name];
                this._djb2Map.delete($6f19754a7eb52889$var$djb2MapKey((0, $dtn6l._DJB2)(name), 'gates'));
                this.saveOverrides();
            }
        },
        {
            key: "getGateOverride",
            value: function getGateOverride(current, _user) {
                var _this$_overrides$gate;
                var overridden = (_this$_overrides$gate = this._overrides.gates[current.name]) !== null && _this$_overrides$gate !== void 0 ? _this$_overrides$gate : this._djb2Map.get($6f19754a7eb52889$var$djb2MapKey(current.name, 'gates'));
                if (overridden == null) return null;
                return $6f19754a7eb52889$var$_objectSpread($6f19754a7eb52889$var$_objectSpread({}, current), {}, {
                    value: overridden,
                    details: $6f19754a7eb52889$var$_objectSpread($6f19754a7eb52889$var$_objectSpread({}, current.details), {}, {
                        reason: $6f19754a7eb52889$var$LOCAL_OVERRIDE_REASON
                    })
                });
            }
        },
        {
            key: "overrideDynamicConfig",
            value: function overrideDynamicConfig(name, value) {
                this._overrides.configs[name] = value;
                this._djb2Map.set($6f19754a7eb52889$var$djb2MapKey((0, $dtn6l._DJB2)(name), 'configs'), value);
                this.saveOverrides();
            }
        },
        {
            key: "removeDynamicConfigOverride",
            value: function removeDynamicConfigOverride(name) {
                delete this._overrides.configs[name];
                this._djb2Map.delete($6f19754a7eb52889$var$djb2MapKey((0, $dtn6l._DJB2)(name), 'configs'));
                this.saveOverrides();
            }
        },
        {
            key: "getDynamicConfigOverride",
            value: function getDynamicConfigOverride(current, _user) {
                return this._getConfigOverride(current, this._overrides.configs);
            }
        },
        {
            key: "overrideExperiment",
            value: function overrideExperiment(name, value) {
                this._overrides.configs[name] = value;
                this._djb2Map.set($6f19754a7eb52889$var$djb2MapKey((0, $dtn6l._DJB2)(name), 'configs'), value);
                this.saveOverrides();
            }
        },
        {
            key: "removeExperimentOverride",
            value: function removeExperimentOverride(name) {
                delete this._overrides.configs[name];
                this._djb2Map.delete($6f19754a7eb52889$var$djb2MapKey((0, $dtn6l._DJB2)(name), 'configs'));
                this.saveOverrides();
            }
        },
        {
            key: "getExperimentOverride",
            value: function getExperimentOverride(current, _user) {
                return this._getConfigOverride(current, this._overrides.configs);
            }
        },
        {
            key: "overrideLayer",
            value: function overrideLayer(name, value) {
                this._overrides.layers[name] = value;
                this._djb2Map.set($6f19754a7eb52889$var$djb2MapKey((0, $dtn6l._DJB2)(name), 'layers'), value);
                this.saveOverrides();
            }
        },
        {
            key: "removeLayerOverride",
            value: function removeLayerOverride(name) {
                delete this._overrides.layers[name];
                this._djb2Map.delete($6f19754a7eb52889$var$djb2MapKey((0, $dtn6l._DJB2)(name), 'layers'));
                this.saveOverrides();
            }
        },
        {
            key: "removeAllOverrides",
            value: function removeAllOverrides() {
                this._overrides = $6f19754a7eb52889$var$makeEmptyStore();
                try {
                    window.localStorage.removeItem(this._localStorageKey);
                } catch (_unused4) {
                // ignored - window is not defined in non-browser environments, and we don't save things there
                // (things like SSR, etc)
                }
            }
        },
        {
            key: "getLayerOverride",
            value: function getLayerOverride(current, _user) {
                var _this$_overrides$laye;
                var overridden = (_this$_overrides$laye = this._overrides.layers[current.name]) !== null && _this$_overrides$laye !== void 0 ? _this$_overrides$laye : this._djb2Map.get($6f19754a7eb52889$var$djb2MapKey(current.name, 'layers'));
                if (overridden == null) return null;
                return $6f19754a7eb52889$var$_objectSpread($6f19754a7eb52889$var$_objectSpread({}, current), {}, {
                    __value: overridden,
                    get: (0, $dtn6l._makeTypedGet)(current.name, overridden),
                    details: $6f19754a7eb52889$var$_objectSpread($6f19754a7eb52889$var$_objectSpread({}, current.details), {}, {
                        reason: $6f19754a7eb52889$var$LOCAL_OVERRIDE_REASON
                    })
                });
            }
        },
        {
            key: "_getConfigOverride",
            value: function _getConfigOverride(current, lookup) {
                var _lookup$current$name;
                var overridden = (_lookup$current$name = lookup[current.name]) !== null && _lookup$current$name !== void 0 ? _lookup$current$name : this._djb2Map.get($6f19754a7eb52889$var$djb2MapKey(current.name, 'configs'));
                if (overridden == null) return null;
                return $6f19754a7eb52889$var$_objectSpread($6f19754a7eb52889$var$_objectSpread({}, current), {}, {
                    value: overridden,
                    get: (0, $dtn6l._makeTypedGet)(current.name, overridden),
                    details: $6f19754a7eb52889$var$_objectSpread($6f19754a7eb52889$var$_objectSpread({}, current.details), {}, {
                        reason: $6f19754a7eb52889$var$LOCAL_OVERRIDE_REASON
                    })
                });
            }
        }
    ]);
}();

});




parcelRegister("3ncU7", function(module, exports) {
$parcel$export(module.exports, "containsDnDMutationInStyle", () => $274d87951ed545d4$export$7867ddcf372cd2bf);
$parcel$export(module.exports, "default", () => $274d87951ed545d4$export$2e2bcd8739ae039);

var $9Zzpd = parcelRequire("9Zzpd");
function $274d87951ed545d4$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $274d87951ed545d4$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $274d87951ed545d4$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $274d87951ed545d4$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $274d87951ed545d4$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $274d87951ed545d4$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
var $274d87951ed545d4$var$isDnDStyleChange = function isDnDStyleChange(style) {
    return style.startsWith('anchor-name: --node-anchor');
};
var $274d87951ed545d4$var$parseStyleSet = function parseStyleSet(style) {
    if (!style) return null;
    var set = new Set();
    var _iterator = $274d87951ed545d4$var$_createForOfIteratorHelper(style.split(';')), _step;
    try {
        for(_iterator.s(); !(_step = _iterator.n()).done;){
            var part = _step.value;
            var t = part.trim();
            if (t) set.add(t);
        }
    } catch (err) {
        _iterator.e(err);
    } finally{
        _iterator.f();
    }
    return set;
};
/**
 * Checks if a mutation record represents a style change from Editor's
 * drag and drop feature, which don't cause visual shifts.
 * This should be removed once DnD has been fixed.
 * @param mutation - The mutation record to check
 * @returns boolean indicating if this is a DnD style mutation
 */ function $274d87951ed545d4$export$e20e7bf2c822f3df(_ref) {
    var target = _ref.target, attributeName = _ref.attributeName, oldValue = _ref.oldValue, newValue = _ref.newValue;
    if (!(0, $9Zzpd.fg)('platform_editor_exclude_dnd_anchor_name_from_ttvc')) return false;
    if (!(target instanceof Element)) return false;
    return $274d87951ed545d4$export$7867ddcf372cd2bf({
        attributeName: attributeName,
        oldValue: oldValue,
        newValue: newValue
    });
}
function $274d87951ed545d4$export$7867ddcf372cd2bf(_ref2) {
    var attributeName = _ref2.attributeName, oldValue = _ref2.oldValue, newValue = _ref2.newValue;
    if (attributeName !== 'style') return false;
    var oldStyles = $274d87951ed545d4$var$parseStyleSet(oldValue);
    var newStyles = $274d87951ed545d4$var$parseStyleSet(newValue);
    var isDnDMutation = false;
    var _iterator2 = $274d87951ed545d4$var$_createForOfIteratorHelper(oldStyles !== null && oldStyles !== void 0 ? oldStyles : []), _step2;
    try {
        for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
            var s = _step2.value;
            if (!(newStyles !== null && newStyles !== void 0 && newStyles.has(s))) {
                if (!$274d87951ed545d4$var$isDnDStyleChange(s)) return false;
                isDnDMutation = true;
            }
        }
    } catch (err) {
        _iterator2.e(err);
    } finally{
        _iterator2.f();
    }
    var _iterator3 = $274d87951ed545d4$var$_createForOfIteratorHelper(newStyles !== null && newStyles !== void 0 ? newStyles : []), _step3;
    try {
        for(_iterator3.s(); !(_step3 = _iterator3.n()).done;){
            var _s = _step3.value;
            if (!(oldStyles !== null && oldStyles !== void 0 && oldStyles.has(_s))) {
                if (!$274d87951ed545d4$var$isDnDStyleChange(_s)) return false;
                isDnDMutation = true;
            }
        }
    } catch (err) {
        _iterator3.e(err);
    } finally{
        _iterator3.f();
    }
    return isDnDMutation;
}
var $274d87951ed545d4$export$2e2bcd8739ae039 = $274d87951ed545d4$export$e20e7bf2c822f3df;

});

parcelRegister("6VzxC", function(module, exports) {
$parcel$export(module.exports, "default", () => $50b3a2af63cba354$export$2e2bcd8739ae039);

var $fC8ib = parcelRequire("fC8ib");

var $25nEq = parcelRequire("25nEq");

var $fL8KA = parcelRequire("fL8KA");

var $iYJcE = parcelRequire("iYJcE");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $6HG4S = parcelRequire("6HG4S");

var $9Zzpd = parcelRequire("9Zzpd");

var $2SfpH = parcelRequire("2SfpH");

var $3VF6y = parcelRequire("3VF6y");

var $5X23Y = parcelRequire("5X23Y");
function $50b3a2af63cba354$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $50b3a2af63cba354$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $50b3a2af63cba354$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $50b3a2af63cba354$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $50b3a2af63cba354$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $50b3a2af63cba354$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $50b3a2af63cba354$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $50b3a2af63cba354$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $50b3a2af63cba354$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $50b3a2af63cba354$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
// Create comprehensive debug details including ignored entries
var $50b3a2af63cba354$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function AbstractVCCalculatorBase(revisionNo) {
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, AbstractVCCalculatorBase);
        this.revisionNo = revisionNo;
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(AbstractVCCalculatorBase, [
        {
            key: "filterViewportEntries",
            value: function filterViewportEntries(entries) {
                return entries.filter(function(entry) {
                    return 'rect' in entry.data;
                });
            }
        },
        {
            key: "calculateRatios",
            value: function calculateRatios(filteredEntries) {
                var ratios = {};
                var viewportWidth = (0, $5X23Y.default)();
                var viewportHeight = (0, $3VF6y.default)();
                var totalViewportArea = viewportWidth * viewportHeight;
                if (totalViewportArea === 0) return ratios;
                var elementRects = new Map();
                var _iterator = $50b3a2af63cba354$var$_createForOfIteratorHelper(filteredEntries), _step;
                try {
                    for(_iterator.s(); !(_step = _iterator.n()).done;){
                        var _entry = _step.value;
                        if ('rect' in _entry.data) {
                            var viewportEntry = _entry.data;
                            elementRects.set(viewportEntry.elementName, viewportEntry.rect);
                        }
                    }
                } catch (err) {
                    _iterator.e(err);
                } finally{
                    _iterator.f();
                }
                var _iterator2 = $50b3a2af63cba354$var$_createForOfIteratorHelper(elementRects), _step2;
                try {
                    for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                        var _step2$value = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_step2.value, 2), elementName = _step2$value[0], rect = _step2$value[1];
                        var elementArea = rect.width * rect.height;
                        ratios[elementName] = elementArea / totalViewportArea;
                    }
                } catch (err) {
                    _iterator2.e(err);
                } finally{
                    _iterator2.f();
                }
                return ratios;
            }
        },
        {
            key: "getLabelStacks",
            value: function getLabelStacks(filteredEntries, isPostInteraction) {
                var labelStacks = {};
                var _iterator3 = $50b3a2af63cba354$var$_createForOfIteratorHelper(filteredEntries), _step3;
                try {
                    for(_iterator3.s(); !(_step3 = _iterator3.n()).done;){
                        var _entry2 = _step3.value;
                        if ('elementName' in _entry2.data && _entry2.data.labelStacks) {
                            if (isPostInteraction) labelStacks[_entry2.data.elementName] = {
                                segment: _entry2.data.labelStacks.segment,
                                labelStack: _entry2.data.labelStacks.labelStack
                            };
                            else if ((0, $9Zzpd.fg)('platform_ufo_add_segment_names_to_dom_offenders')) labelStacks[_entry2.data.elementName] = _entry2.data.labelStacks.labelStack;
                        }
                    }
                } catch (err) {
                    _iterator3.e(err);
                } finally{
                    _iterator3.f();
                }
                return labelStacks;
            }
        },
        {
            key: "calculateWithDebugInfo",
            value: function() {
                var _calculateWithDebugInfo = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee(filteredEntries, startTime, stopTime, isPostInteraction, isVCClean, interactionType, isPageVisible, interactionId, dirtyReason, allEntries, include3p, excludeSmartAnswersInSearch, interactionAbortReason, includeSSRRatio) {
                    var _window, _window2, _window6, _window8;
                    var percentiles, viewportEntries, vcLogs, vcDetails, percentileIndex, entryDataBuffer, ssrRatio, _iterator4, _step4, _entry3, time, viewportPercentage, entries, elementNames, previousResult, i, percentile, enhancedVcLogs, shouldCalculate3p, shouldCalculateDebugDetails, _window3, _window4, _window5, sortedVcLogs, maxViewportPercentageAtTime, maxSoFar, _iterator5, _step5, log, getBiggestPreviousViewportPercentage, ignoredEntriesByTime, _iterator6, _step6, _entry4, _ignoredEntriesByTime, _viewportData$rect, _viewportData$previou, viewportData, timestamp, additionalVcLogs, _iterator7, _step7, _step7$value, _timestamp, ignoredEntries, _viewportPercentage, v3RevisionDebugDetails, _window7, _window7$__ufo_devtoo, _window9, _window9$__on_ufo_vc_;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee$(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                percentiles = [
                                    25,
                                    50,
                                    75,
                                    80,
                                    85,
                                    90,
                                    95,
                                    98,
                                    99,
                                    100
                                ];
                                viewportEntries = this.filterViewportEntries(filteredEntries);
                                _context.next = 4;
                                return (0, $2SfpH.calculateTTVCPercentilesWithDebugInfo)({
                                    viewport: {
                                        width: (0, $5X23Y.default)(),
                                        height: (0, $3VF6y.default)()
                                    },
                                    startTime: startTime,
                                    stopTime: stopTime,
                                    orderedEntries: viewportEntries
                                });
                            case 4:
                                vcLogs = _context.sent;
                                vcDetails = {};
                                percentileIndex = 0;
                                entryDataBuffer = new Set();
                                ssrRatio = -1;
                                if (!vcLogs) {
                                    _context.next = 30;
                                    break;
                                }
                                _iterator4 = $50b3a2af63cba354$var$_createForOfIteratorHelper(vcLogs);
                                _context.prev = 11;
                                _iterator4.s();
                            case 13:
                                if ((_step4 = _iterator4.n()).done) {
                                    _context.next = 22;
                                    break;
                                }
                                _entry3 = _step4.value;
                                time = _entry3.time, viewportPercentage = _entry3.viewportPercentage, entries = _entry3.entries;
                                if (includeSSRRatio && ssrRatio === -1 && entries.some(function(e) {
                                    return e.elementName === 'SSR';
                                }) && (0, $9Zzpd.fg)('vc_v3_ssr_ratio_fixed_range')) ssrRatio = viewportPercentage;
                                // Only process entries if we haven't reached all percentiles
                                if (!(percentileIndex >= percentiles.length)) {
                                    _context.next = 19;
                                    break;
                                }
                                return _context.abrupt("break", 22);
                            case 19:
                                // Check if this entry matches any checkpoint percentiles
                                if (viewportPercentage >= percentiles[percentileIndex]) {
                                    elementNames = entries.map(function(e) {
                                        return e.elementName;
                                    }); // Process all matching percentiles in one go
                                    while(percentileIndex < percentiles.length && viewportPercentage >= percentiles[percentileIndex]){
                                        vcDetails["".concat(percentiles[percentileIndex])] = {
                                            t: Math.round(time),
                                            e: elementNames
                                        };
                                        percentileIndex++;
                                    }
                                    // Clear buffer after processing all matching percentiles
                                    entryDataBuffer.clear();
                                } else // Only add to buffer if we haven't reached all percentiles
                                entries.forEach(function(e) {
                                    return entryDataBuffer.add(e);
                                });
                            case 20:
                                _context.next = 13;
                                break;
                            case 22:
                                _context.next = 27;
                                break;
                            case 24:
                                _context.prev = 24;
                                _context.t0 = _context["catch"](11);
                                _iterator4.e(_context.t0);
                            case 27:
                                _context.prev = 27;
                                _iterator4.f();
                                return _context.finish(27);
                            case 30:
                                // Fill in any missing percentiles with the last known values
                                previousResult = {
                                    t: 0,
                                    e: []
                                };
                                for(i = 0; i < percentiles.length; i++){
                                    percentile = percentiles[i];
                                    if (!(percentile in vcDetails)) vcDetails["".concat(percentile)] = previousResult;
                                    else previousResult = vcDetails["".concat(percentile)];
                                }
                                enhancedVcLogs = vcLogs ? vcLogs.map(function(log) {
                                    return $50b3a2af63cba354$var$_objectSpread($50b3a2af63cba354$var$_objectSpread({}, log), {}, {
                                        entries: log.entries.map(function(entry) {
                                            var _entry$rect, _entry$previousRect;
                                            return $50b3a2af63cba354$var$_objectSpread($50b3a2af63cba354$var$_objectSpread({}, entry), {}, {
                                                rect: (_entry$rect = entry.rect) === null || _entry$rect === void 0 ? void 0 : _entry$rect.toJSON(),
                                                previousRect: (_entry$previousRect = entry.previousRect) === null || _entry$previousRect === void 0 ? void 0 : _entry$previousRect.toJSON()
                                            });
                                        }),
                                        viewportPercentage: log.viewportPercentage
                                    });
                                }) : []; // If 3p metric enabled - calculate the debug details
                                shouldCalculate3p = include3p && (0, $9Zzpd.fg)('platform_ufo_enable_ttai_with_3p'); // Only calculate enhanced debug details if devtool callbacks exist
                                shouldCalculateDebugDetails = (!isPostInteraction || shouldCalculate3p) && (typeof ((_window = window) === null || _window === void 0 ? void 0 : _window.__ufo_devtool_onVCRevisionReady__) === 'function' || typeof ((_window2 = window) === null || _window2 === void 0 ? void 0 : _window2.__on_ufo_vc_debug_data_ready) === 'function');
                                if ((0, $9Zzpd.fg)('platform_ufo_fix_post_interaction_check_vc_debug')) shouldCalculateDebugDetails = !isPostInteraction && (typeof ((_window3 = window) === null || _window3 === void 0 ? void 0 : _window3.__ufo_devtool_onVCRevisionReady__) === 'function' || typeof ((_window4 = window) === null || _window4 === void 0 ? void 0 : _window4.__on_ufo_vc_debug_data_ready) === 'function' || typeof ((_window5 = window) === null || _window5 === void 0 ? void 0 : _window5.__ufo_devtool_vc_3p_debug_data) === 'function');
                                if (shouldCalculateDebugDetails && allEntries && vcLogs) {
                                    // Pre-sort vcLogs by time for efficient lookups
                                    sortedVcLogs = (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(vcLogs).sort(function(a, b) {
                                        return a.time - b.time;
                                    }); // Pre-calculate max viewport percentage up to each time for efficient lookups
                                    maxViewportPercentageAtTime = new Map();
                                    maxSoFar = 0;
                                    _iterator5 = $50b3a2af63cba354$var$_createForOfIteratorHelper(sortedVcLogs);
                                    try {
                                        for(_iterator5.s(); !(_step5 = _iterator5.n()).done;){
                                            log = _step5.value;
                                            if (log.viewportPercentage !== null) {
                                                maxSoFar = Math.max(maxSoFar, log.viewportPercentage);
                                                maxViewportPercentageAtTime.set(log.time, maxSoFar);
                                            }
                                        }
                                    // Helper function to find the biggest previous viewport percentage
                                    } catch (err) {
                                        _iterator5.e(err);
                                    } finally{
                                        _iterator5.f();
                                    }
                                    getBiggestPreviousViewportPercentage = function getBiggestPreviousViewportPercentage(targetTime) {
                                        // Binary search for the largest time <= targetTime
                                        var left = 0;
                                        var right = sortedVcLogs.length - 1;
                                        var result = -1;
                                        while(left <= right){
                                            var mid = Math.floor((left + right) / 2);
                                            if (sortedVcLogs[mid].time <= targetTime) {
                                                result = mid;
                                                left = mid + 1;
                                            } else right = mid - 1;
                                        }
                                        return result >= 0 ? maxViewportPercentageAtTime.get(sortedVcLogs[result].time) || null : null;
                                    }; // Group ignored entries by timestamp
                                    ignoredEntriesByTime = new Map();
                                    _iterator6 = $50b3a2af63cba354$var$_createForOfIteratorHelper(allEntries);
                                    try {
                                        for(_iterator6.s(); !(_step6 = _iterator6.n()).done;){
                                            _entry4 = _step6.value;
                                            if ('rect' in _entry4.data && !this.isEntryIncluded(_entry4, include3p, excludeSmartAnswersInSearch)) {
                                                viewportData = _entry4.data;
                                                timestamp = Math.round(_entry4.time);
                                                if (!ignoredEntriesByTime.has(timestamp)) ignoredEntriesByTime.set(timestamp, []);
                                                (_ignoredEntriesByTime = ignoredEntriesByTime.get(timestamp)) === null || _ignoredEntriesByTime === void 0 || _ignoredEntriesByTime.push($50b3a2af63cba354$var$_objectSpread($50b3a2af63cba354$var$_objectSpread({}, viewportData), {}, {
                                                    rect: (_viewportData$rect = viewportData.rect) === null || _viewportData$rect === void 0 ? void 0 : _viewportData$rect.toJSON(),
                                                    previousRect: (_viewportData$previou = viewportData.previousRect) === null || _viewportData$previou === void 0 ? void 0 : _viewportData$previou.toJSON(),
                                                    ignoreReason: viewportData.visible ? viewportData.type : 'not-visible'
                                                }));
                                            }
                                        }
                                    // Add ignored entries to vcLogs
                                    } catch (err) {
                                        _iterator6.e(err);
                                    } finally{
                                        _iterator6.f();
                                    }
                                    additionalVcLogs = [];
                                    _iterator7 = $50b3a2af63cba354$var$_createForOfIteratorHelper(ignoredEntriesByTime);
                                    try {
                                        for(_iterator7.s(); !(_step7 = _iterator7.n()).done;){
                                            _step7$value = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_step7.value, 2), _timestamp = _step7$value[0], ignoredEntries = _step7$value[1];
                                            if (ignoredEntries.length > 0) {
                                                _viewportPercentage = getBiggestPreviousViewportPercentage(_timestamp);
                                                additionalVcLogs.push({
                                                    time: _timestamp,
                                                    viewportPercentage: _viewportPercentage,
                                                    entries: ignoredEntries
                                                });
                                            }
                                        }
                                    // Combine and sort all vcLogs
                                    } catch (err) {
                                        _iterator7.e(err);
                                    } finally{
                                        _iterator7.f();
                                    }
                                    enhancedVcLogs = [].concat((0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(enhancedVcLogs), additionalVcLogs).sort(function(a, b) {
                                        return a.time - b.time;
                                    });
                                }
                                // Only create debug details if callbacks exist
                                v3RevisionDebugDetails = null;
                                if (shouldCalculateDebugDetails) v3RevisionDebugDetails = {
                                    revision: this.revisionNo,
                                    isClean: isVCClean && !interactionAbortReason && isPageVisible,
                                    abortReason: !isPageVisible ? 'browser_backgrounded' : dirtyReason !== null && dirtyReason !== void 0 ? dirtyReason : interactionAbortReason,
                                    vcLogs: enhancedVcLogs,
                                    interactionId: interactionId,
                                    interactionType: interactionType
                                };
                                // Handle devtool callback
                                if (v3RevisionDebugDetails && typeof ((_window6 = window) === null || _window6 === void 0 ? void 0 : _window6.__ufo_devtool_onVCRevisionReady__) === 'function' && !include3p) try {
                                    (_window7 = window) === null || _window7 === void 0 || (_window7$__ufo_devtoo = _window7.__ufo_devtool_onVCRevisionReady__) === null || _window7$__ufo_devtoo === void 0 || _window7$__ufo_devtoo.call(_window7, v3RevisionDebugDetails);
                                } catch (e) {
                                    // if any error communicating with devtool, we don't want to break the app
                                    // eslint-disable-next-line no-console
                                    console.error('Error in onVCRevisionReady', e);
                                }
                                if (v3RevisionDebugDetails && typeof ((_window8 = window) === null || _window8 === void 0 ? void 0 : _window8.__on_ufo_vc_debug_data_ready) === 'function' && !include3p) try {
                                    (_window9 = window) === null || _window9 === void 0 || (_window9$__on_ufo_vc_ = _window9.__on_ufo_vc_debug_data_ready) === null || _window9$__on_ufo_vc_ === void 0 || _window9$__on_ufo_vc_.call(_window9, v3RevisionDebugDetails);
                                } catch (e) {
                                    // eslint-disable-next-line no-console
                                    console.error('Error in onVCRevisionReady', e);
                                }
                                if (v3RevisionDebugDetails && shouldCalculate3p) try {
                                    // Log vc details with 3p for debugging
                                    window.__ufo_devtool_vc_3p_debug_data = v3RevisionDebugDetails;
                                } catch (e) {
                                    // eslint-disable-next-line no-console
                                    console.error('Error in 3pDebugData', e);
                                }
                                return _context.abrupt("return", {
                                    vcDetails: vcDetails,
                                    ssrRatio: ssrRatio
                                });
                            case 43:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee, this, [
                        [
                            11,
                            24,
                            27,
                            30
                        ]
                    ]);
                }));
                function calculateWithDebugInfo(_x, _x2, _x3, _x4, _x5, _x6, _x7, _x8, _x9, _x0, _x1, _x10, _x11, _x12) {
                    return _calculateWithDebugInfo.apply(this, arguments);
                }
                return calculateWithDebugInfo;
            }()
        },
        {
            key: "calculate",
            value: function() {
                var _calculate = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee2(_ref) {
                    var _this = this, _vcDetails$90$t, _vcDetails$;
                    var startTime, stopTime, orderedEntries, interactionId, isPostInteraction, include3p, excludeSmartAnswersInSearch, includeSSRRatio, interactionType, isPageVisible, interactionAbortReason, filteredEntries, isVCClean, dirtyReason, getVCCleanStatusResult, _yield$this$calculate, vcDetails, ssrRatio, result;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee2$(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                startTime = _ref.startTime, stopTime = _ref.stopTime, orderedEntries = _ref.orderedEntries, interactionId = _ref.interactionId, isPostInteraction = _ref.isPostInteraction, include3p = _ref.include3p, excludeSmartAnswersInSearch = _ref.excludeSmartAnswersInSearch, includeSSRRatio = _ref.includeSSRRatio, interactionType = _ref.interactionType, isPageVisible = _ref.isPageVisible, interactionAbortReason = _ref.interactionAbortReason;
                                filteredEntries = orderedEntries.filter(function(entry) {
                                    return _this.isEntryIncluded(entry, include3p, excludeSmartAnswersInSearch);
                                });
                                getVCCleanStatusResult = this.getVCCleanStatus(filteredEntries);
                                isVCClean = getVCCleanStatusResult.isVCClean;
                                dirtyReason = getVCCleanStatusResult.dirtyReason;
                                if (isVCClean) {
                                    _context2.next = 7;
                                    break;
                                }
                                return _context2.abrupt("return", {
                                    revision: this.revisionNo,
                                    'metric:vc90': null,
                                    clean: false,
                                    abortReason: dirtyReason,
                                    abortTimestamp: getVCCleanStatusResult.abortTimestamp
                                });
                            case 7:
                                _context2.next = 9;
                                return this.calculateWithDebugInfo(filteredEntries, startTime, stopTime, isPostInteraction, isVCClean, interactionType, isPageVisible, interactionId, dirtyReason, orderedEntries, include3p, excludeSmartAnswersInSearch, interactionAbortReason, includeSSRRatio);
                            case 9:
                                _yield$this$calculate = _context2.sent;
                                vcDetails = _yield$this$calculate.vcDetails;
                                ssrRatio = _yield$this$calculate.ssrRatio;
                                result = {
                                    revision: this.revisionNo,
                                    clean: true,
                                    'metric:vc90': (_vcDetails$90$t = vcDetails === null || vcDetails === void 0 || (_vcDetails$ = vcDetails['90']) === null || _vcDetails$ === void 0 ? void 0 : _vcDetails$.t) !== null && _vcDetails$90$t !== void 0 ? _vcDetails$90$t : null,
                                    vcDetails: vcDetails !== null && vcDetails !== void 0 ? vcDetails : undefined
                                };
                                result.ratios = this.calculateRatios(filteredEntries);
                                if (ssrRatio !== -1) result.ssrRatio = ssrRatio;
                                if (isPostInteraction || (0, $9Zzpd.fg)('platform_ufo_add_segment_names_to_dom_offenders')) result.labelStacks = this.getLabelStacks(filteredEntries, isPostInteraction);
                                return _context2.abrupt("return", result);
                            case 17:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2, this);
                }));
                function calculate(_x13) {
                    return _calculate.apply(this, arguments);
                }
                return calculate;
            }()
        }
    ]);
}();

});
parcelRegister("2SfpH", function(module, exports) {
$parcel$export(module.exports, "calculateTTVCPercentilesWithDebugInfo", () => $217c94b84d506831$export$96ea73435089b05a);

var $iYJcE = parcelRequire("iYJcE");

var $fL8KA = parcelRequire("fL8KA");

var $6HG4S = parcelRequire("6HG4S");

var $9Zzpd = parcelRequire("9Zzpd");

var $1fXBO = parcelRequire("1fXBO");
function $217c94b84d506831$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $217c94b84d506831$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $217c94b84d506831$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $217c94b84d506831$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $217c94b84d506831$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $217c94b84d506831$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $217c94b84d506831$var$calculateTTVCPercentiles(_x) {
    return $217c94b84d506831$var$_calculateTTVCPercentiles.apply(this, arguments);
}
function $217c94b84d506831$var$_calculateTTVCPercentiles() {
    $217c94b84d506831$var$_calculateTTVCPercentiles = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee(_ref) {
        var viewport, orderedEntries, percentiles, startTime, canvas, elementMap, _iterator2, _step2, entry, rect, elementName, timePixelCounts, canvasDimenstions, totalPixels;
        return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee$(_context) {
            while(true)switch(_context.prev = _context.next){
                case 0:
                    viewport = _ref.viewport, orderedEntries = _ref.orderedEntries, percentiles = _ref.percentiles, startTime = _ref.startTime;
                    canvas = new (0, $1fXBO.ViewportCanvas)(viewport, (0, $9Zzpd.fg)('platform_ufo_canvas_heatmap_full_precision') ? 1 : 0.25);
                    elementMap = new Map();
                    _iterator2 = $217c94b84d506831$var$_createForOfIteratorHelper(orderedEntries);
                    _context.prev = 4;
                    _iterator2.s();
                case 6:
                    if ((_step2 = _iterator2.n()).done) {
                        _context.next = 17;
                        break;
                    }
                    entry = _step2.value;
                    if ('rect' in entry.data) {
                        _context.next = 10;
                        break;
                    }
                    return _context.abrupt("continue", 15);
                case 10:
                    rect = entry.data.rect;
                    elementName = entry.data.elementName;
                    canvas.drawRect(rect, entry.time);
                    if (!elementMap.has(entry.time)) elementMap.set(entry.time, new Set());
                    elementMap.get(entry.time).add(elementName);
                case 15:
                    _context.next = 6;
                    break;
                case 17:
                    _context.next = 22;
                    break;
                case 19:
                    _context.prev = 19;
                    _context.t0 = _context["catch"](4);
                    _iterator2.e(_context.t0);
                case 22:
                    _context.prev = 22;
                    _iterator2.f();
                    return _context.finish(22);
                case 25:
                    _context.next = 27;
                    return canvas.getPixelCounts();
                case 27:
                    timePixelCounts = _context.sent;
                    canvasDimenstions = canvas.getScaledDimensions();
                    totalPixels = canvasDimenstions.width * canvasDimenstions.height;
                    return _context.abrupt("return", $217c94b84d506831$export$89c8da9b65eff678(timePixelCounts, elementMap, percentiles, totalPixels, startTime));
                case 31:
                case "end":
                    return _context.stop();
            }
        }, _callee, null, [
            [
                4,
                19,
                22,
                25
            ]
        ]);
    }));
    return $217c94b84d506831$var$_calculateTTVCPercentiles.apply(this, arguments);
}
function $217c94b84d506831$export$96ea73435089b05a(_x2) {
    return $217c94b84d506831$var$_calculateTTVCPercentilesWithDebugInfo.apply(this, arguments);
}
function $217c94b84d506831$var$_calculateTTVCPercentilesWithDebugInfo() {
    $217c94b84d506831$var$_calculateTTVCPercentilesWithDebugInfo = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee2(_ref2) {
        var viewport, orderedEntries, startTime, canvas, elementMap, _iterator3, _step3, entry, rect, timePixelCounts, canvasDimensions, totalPixels;
        return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee2$(_context2) {
            while(true)switch(_context2.prev = _context2.next){
                case 0:
                    viewport = _ref2.viewport, orderedEntries = _ref2.orderedEntries, startTime = _ref2.startTime;
                    canvas = new (0, $1fXBO.ViewportCanvas)(viewport, (0, $9Zzpd.fg)('platform_ufo_canvas_heatmap_full_precision') ? 1 : 0.25);
                    elementMap = new Map();
                    _iterator3 = $217c94b84d506831$var$_createForOfIteratorHelper(orderedEntries);
                    _context2.prev = 4;
                    _iterator3.s();
                case 6:
                    if ((_step3 = _iterator3.n()).done) {
                        _context2.next = 16;
                        break;
                    }
                    entry = _step3.value;
                    if ('rect' in entry.data) {
                        _context2.next = 10;
                        break;
                    }
                    return _context2.abrupt("continue", 14);
                case 10:
                    rect = entry.data.rect;
                    canvas.drawRect(rect, entry.time);
                    if (!elementMap.has(entry.time)) elementMap.set(entry.time, []);
                    elementMap.get(entry.time).push(entry.data);
                case 14:
                    _context2.next = 6;
                    break;
                case 16:
                    _context2.next = 21;
                    break;
                case 18:
                    _context2.prev = 18;
                    _context2.t0 = _context2["catch"](4);
                    _iterator3.e(_context2.t0);
                case 21:
                    _context2.prev = 21;
                    _iterator3.f();
                    return _context2.finish(21);
                case 24:
                    _context2.next = 26;
                    return canvas.getPixelCounts();
                case 26:
                    timePixelCounts = _context2.sent;
                    canvasDimensions = canvas.getScaledDimensions();
                    totalPixels = canvasDimensions.width * canvasDimensions.height;
                    return _context2.abrupt("return", $217c94b84d506831$export$a532ce01ea38d882(timePixelCounts, elementMap, totalPixels, startTime));
                case 30:
                case "end":
                    return _context2.stop();
            }
        }, _callee2, null, [
            [
                4,
                18,
                21,
                24
            ]
        ]);
    }));
    return $217c94b84d506831$var$_calculateTTVCPercentilesWithDebugInfo.apply(this, arguments);
}
var $217c94b84d506831$export$2e2bcd8739ae039 = $217c94b84d506831$var$calculateTTVCPercentiles;
function $217c94b84d506831$export$89c8da9b65eff678(timePixelCounts, elementMap, unorderedPercentiles, totalPixels, startTime) {
    var results = {};
    var cumulativePixels = 0;
    var percentiles = unorderedPercentiles.sort(function(a, b) {
        return a - b;
    });
    // Sort entries by timestamp for consistent processing
    var sortedEntries = Array.from(timePixelCounts.entries()).sort(function(_ref3, _ref4) {
        var _ref5 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_ref3, 1), timeA = _ref5[0];
        var _ref6 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_ref4, 1), timeB = _ref6[0];
        return Number(timeA) - Number(timeB);
    });
    var percentileIndex = 0;
    var domElementsBuffer = new Set();
    var _iterator = $217c94b84d506831$var$_createForOfIteratorHelper(sortedEntries), _step;
    try {
        for(_iterator.s(); !(_step = _iterator.n()).done;){
            var _step$value = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_step.value, 2), time = _step$value[0], pixelCount = _step$value[1];
            cumulativePixels += pixelCount;
            var percentCovered = cumulativePixels / totalPixels * 100;
            var elementNames = elementMap.get(time) || new Set();
            elementNames.forEach(function(elName) {
                return domElementsBuffer.add(elName);
            });
            var matchesAnyCheckpoints = false;
            while(percentileIndex < percentiles.length && percentCovered >= percentiles[percentileIndex]){
                results["".concat(percentiles[percentileIndex])] = {
                    t: Math.round(Number(time - startTime)),
                    e: Array.from(domElementsBuffer)
                };
                percentileIndex++;
                matchesAnyCheckpoints = true;
            }
            if (matchesAnyCheckpoints) domElementsBuffer.clear();
            if (percentileIndex >= percentiles.length) break;
        }
    } catch (err) {
        _iterator.e(err);
    } finally{
        _iterator.f();
    }
    var previousResult = {
        t: 0,
        e: []
    };
    for(var i = 0; i < percentiles.length; i++){
        var percentile = percentiles[i];
        if (!(percentile in results)) results["".concat(percentile)] = previousResult;
        previousResult = results["".concat(percentile)];
    }
    return results;
}
function $217c94b84d506831$export$a532ce01ea38d882(timePixelCounts, elementMap, totalPixels, startTime) {
    var results = new Array(elementMap.size);
    var cumulativePixels = 0;
    var sortedEntries = Array.from(timePixelCounts.entries()).sort(function(_ref7, _ref8) {
        var _ref9 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_ref7, 1), timeA = _ref9[0];
        var _ref0 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_ref8, 1), timeB = _ref0[0];
        return Number(timeA) - Number(timeB);
    });
    for(var i = 0; i < sortedEntries.length; i++){
        var _sortedEntries$i = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(sortedEntries[i], 2), time = _sortedEntries$i[0], pixelCount = _sortedEntries$i[1];
        cumulativePixels += pixelCount;
        var percentCovered = cumulativePixels / totalPixels * 100;
        var entryDatas = elementMap.get(time) || [];
        results[i] = {
            time: Math.round(Number(time - startTime)),
            viewportPercentage: percentCovered,
            entries: Array.from(entryDatas)
        };
    }
    return results;
}

});
parcelRegister("1fXBO", function(module, exports) {
$parcel$export(module.exports, "ViewportCanvas", () => $0ea56e3bd8c05a90$export$3e59ac9de7402fb1);

var $fL8KA = parcelRequire("fL8KA");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $6HG4S = parcelRequire("6HG4S");

var $fBnGC = parcelRequire("fBnGC");
var $0ea56e3bd8c05a90$export$3e59ac9de7402fb1 = /*#__PURE__*/ function() {
    /** The underlying Canvas instance (either OffscreenCanvas or HTMLCanvasElement) */ /** The 2D rendering context of the canvas */ /** Scale factor applied to the canvas (affects final pixel counts) */ /** Maps unique colors to their corresponding timestamps */ /** Counter used to generate unique colors */ /**
   * Creates a new ViewportCanvas instance.
   * @param viewport - The dimensions of the viewport
   * @param scaleFactor - Scale factor to apply to the canvas (default: 0.5)
   * @throws {Error} If canvas context cannot be obtained
   */ function ViewportCanvas(viewport) {
        var scaleFactor = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, ViewportCanvas);
        this.scaleFactor = scaleFactor;
        this.colorCounter = 1;
        this.colorTimeMap = new Map();
        var safeViewportWidth = Math.max(viewport.width, 1);
        var safeViewportHeight = Math.max(viewport.height, 1);
        // Calculate scaled dimensions
        this.scaledWidth = Math.max(Math.ceil(safeViewportWidth * scaleFactor), 1);
        this.scaledHeight = Math.max(Math.ceil(safeViewportHeight * scaleFactor), 1);
        this.scaleX = this.scaledWidth / safeViewportWidth;
        this.scaleY = this.scaledHeight / safeViewportHeight;
        // Initialize canvas with scaled dimensions
        this.canvas = this.createCanvas(this.scaledWidth, this.scaledHeight);
        var ctx = this.canvas.getContext('2d', {
            alpha: false,
            // Disable alpha channel for better performance
            willReadFrequently: true,
            // Optimize for frequent pixel reading
            colorSpace: 'srgb' // Use standard RGB color space
        });
        if (!ctx) throw new Error('Could not get canvas context');
        this.ctx = ctx;
        this.ctx.globalCompositeOperation = 'source-over';
        this.ctx.imageSmoothingEnabled = false; // Disable image smoothing for better performance
        this.clear();
    }
    /**
   * Creates a canvas instance, falling back to HTMLCanvasElement if OffscreenCanvas is not available
   */ return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(ViewportCanvas, [
        {
            key: "createCanvas",
            value: function createCanvas(width, height) {
                if (typeof OffscreenCanvas !== 'undefined') return new OffscreenCanvas(width, height);
                var canvas = document.createElement('canvas');
                canvas.width = width;
                canvas.height = height;
                return canvas;
            }
        },
        {
            key: "getScaledDimensions",
            value: function getScaledDimensions() {
                return {
                    width: this.scaledWidth,
                    height: this.scaledHeight
                };
            }
        },
        {
            key: "clear",
            value: function clear() {
                this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);
            }
        },
        {
            key: "generateColor",
            value: function generateColor() {
                // Wrap around at 16,777,215 (0x00FFFFFF) to stay within 24-bit color space
                var rgbColor = this.colorCounter++ % 0x00ffffff;
                return $0ea56e3bd8c05a90$export$54591583ed0b20ce(rgbColor);
            }
        },
        {
            key: "drawRect",
            value: function drawRect(rect, timestamp) {
                var color = this.generateColor();
                this.colorTimeMap.set(color, timestamp);
                this.ctx.fillStyle = color;
                if (this.scaleFactor === 1) return this.ctx.fillRect(rect.x, rect.y, rect.width, rect.height);
                var scaledX = rect.x * this.scaleX;
                var scaledY = rect.y * this.scaleY;
                var scaledWidth = rect.width * this.scaleX;
                var scaledHeight = rect.height * this.scaleY;
                this.ctx.fillRect(Math.floor(scaledX), Math.ceil(scaledY), Math.max(scaledWidth, 1), Math.max(scaledHeight, 1));
            }
        },
        {
            key: "getPixelCounts",
            value: function() {
                var _getPixelCounts = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee() {
                    var imageData, timestampsAmount, pixelCounts, timePixelCounts, i, count, color, rgbColor, timestamp;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee$(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                imageData = this.ctx.getImageData(0, 0, this.canvas.width, this.canvas.height);
                                timestampsAmount = this.colorTimeMap.size;
                                _context.next = 4;
                                return $0ea56e3bd8c05a90$export$fafc9be44839f9c8(imageData, this.scaleFactor, timestampsAmount);
                            case 4:
                                pixelCounts = _context.sent;
                                // Convert color counts to timestamp counts
                                timePixelCounts = new Map();
                                i = 0;
                            case 7:
                                if (!(i < pixelCounts.length)) {
                                    _context.next = 18;
                                    break;
                                }
                                count = pixelCounts[i];
                                if (!(typeof count !== 'number')) {
                                    _context.next = 11;
                                    break;
                                }
                                return _context.abrupt("continue", 15);
                            case 11:
                                color = i + 1;
                                rgbColor = $0ea56e3bd8c05a90$export$54591583ed0b20ce(color);
                                timestamp = this.colorTimeMap.get(rgbColor);
                                if (timestamp !== undefined) timePixelCounts.set(timestamp, (timePixelCounts.get(timestamp) || 0) + count);
                            case 15:
                                i++;
                                _context.next = 7;
                                break;
                            case 18:
                                return _context.abrupt("return", timePixelCounts);
                            case 19:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee, this);
                }));
                function getPixelCounts() {
                    return _getPixelCounts.apply(this, arguments);
                }
                return getPixelCounts;
            }()
        }
    ]);
}();
function $0ea56e3bd8c05a90$export$54591583ed0b20ce(n) {
    // Ensure the input is within the valid range for a 24-bit color
    if (n < 0 || n > 0xffffff) throw new Error('Input number must be between 0 and 16777215 (inclusive).');
    // Extract blue component (bits 0-7)
    var blue = n & 0xff;
    // Extract green component (bits 8-15)
    var green = n >> 8 & 0xff;
    // Extract red component (bits 16-23)
    var red = n >> 16 & 0xff;
    return "rgb(".concat(red, ", ").concat(green, ", ").concat(blue, ")");
}
function $0ea56e3bd8c05a90$export$fafc9be44839f9c8(_x, _x2, _x3) {
    return $0ea56e3bd8c05a90$var$_calculateDrawnPixelsRaw.apply(this, arguments);
}
function $0ea56e3bd8c05a90$var$_calculateDrawnPixelsRaw() {
    $0ea56e3bd8c05a90$var$_calculateDrawnPixelsRaw = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee2(imageData, _, arraySize) {
        var data, arr, i, color, colorIndex;
        return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee2$(_context2) {
            while(true)switch(_context2.prev = _context2.next){
                case 0:
                    data = imageData.data;
                    arr = new Uint32Array(arraySize);
                    i = 0;
                case 3:
                    if (!(i < data.length)) {
                        _context2.next = 11;
                        break;
                    }
                    // Check alpha
                    if (data[i + 3] !== 0) {
                        // Combine RGB components into a single 24-bit color value:
                        // (data[i] << 16)   - Shift red component left 16 bits   (bits 16-23)
                        // (data[i + 1] << 8) - Shift green component left 8 bits (bits 8-15)
                        // data[i + 2]       - Blue component stays as is         (bits 0-7)
                        // The | operator combines all bits together
                        color = data[i] << 16 | data[i + 1] << 8 | data[i + 2];
                        colorIndex = color - 1;
                        arr[colorIndex] = (arr[colorIndex] || 0) + 1;
                    }
                    if (!(i % 10000 === 0)) {
                        _context2.next = 8;
                        break;
                    }
                    _context2.next = 8;
                    return (0, $fBnGC.default)();
                case 8:
                    i += 4;
                    _context2.next = 3;
                    break;
                case 11:
                    return _context2.abrupt("return", arr);
                case 12:
                case "end":
                    return _context2.stop();
            }
        }, _callee2);
    }));
    return $0ea56e3bd8c05a90$var$_calculateDrawnPixelsRaw.apply(this, arguments);
}

});
parcelRegister("fBnGC", function(module, exports) {
$parcel$export(module.exports, "default", () => $b5bcaf5a62589785$export$2e2bcd8739ae039);

var $fL8KA = parcelRequire("fL8KA");

var $6HG4S = parcelRequire("6HG4S");
// See https://developer.mozilla.org/en-US/docs/Web/API/Prioritized_Task_Scheduling_API
function $b5bcaf5a62589785$var$taskYield() {
    return $b5bcaf5a62589785$var$_taskYield.apply(this, arguments);
}
function $b5bcaf5a62589785$var$_taskYield() {
    $b5bcaf5a62589785$var$_taskYield = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee() {
        var resolve, p;
        return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee$(_context) {
            while(true)switch(_context.prev = _context.next){
                case 0:
                    if (!('scheduler' in globalThis && // @ts-ignore
                    'yield' in globalThis.scheduler)) {
                        _context.next = 4;
                        break;
                    }
                    _context.next = 3;
                    return scheduler.yield();
                case 3:
                    return _context.abrupt("return");
                case 4:
                    resolve = function resolve() {};
                    p = new Promise(function(a) {
                        resolve = a;
                    });
                    setTimeout(resolve, 0);
                    _context.next = 9;
                    return p;
                case 9:
                case "end":
                    return _context.stop();
            }
        }, _callee);
    }));
    return $b5bcaf5a62589785$var$_taskYield.apply(this, arguments);
}
var $b5bcaf5a62589785$export$2e2bcd8739ae039 = $b5bcaf5a62589785$var$taskYield;

});



parcelRegister("3VF6y", function(module, exports) {
$parcel$export(module.exports, "default", () => $2dc69487c41fda63$export$2e2bcd8739ae039);
function $2dc69487c41fda63$var$getViewportHeight() {
    var document = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window.document;
    var documentHeight;
    try {
        documentHeight = document.documentElement.clientHeight || 0;
    } catch (e) {
        documentHeight = 0;
    }
    return Math.max(documentHeight, window.innerHeight || 0);
}
var $2dc69487c41fda63$export$2e2bcd8739ae039 = $2dc69487c41fda63$var$getViewportHeight;

});

parcelRegister("5X23Y", function(module, exports) {
$parcel$export(module.exports, "default", () => $45541023c89f2474$export$2e2bcd8739ae039);
function $45541023c89f2474$var$getViewportWidth() {
    var document = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window.document;
    var documentWidth;
    try {
        documentWidth = document.documentElement.clientWidth || 0;
    } catch (e) {
        documentWidth = 0;
    }
    return Math.max(documentWidth, window.innerWidth || 0);
}
var $45541023c89f2474$export$2e2bcd8739ae039 = $45541023c89f2474$var$getViewportWidth;

});


parcelRegister("horIC", function(module, exports) {
$parcel$export(module.exports, "isEntrySmartAnswersInSearch", () => $ca9a2de88b322420$export$8be86f3caab7d679);

var $hBCYb = parcelRequire("hBCYb");
function $ca9a2de88b322420$export$8be86f3caab7d679(entry) {
    var _ref = entry.data, elementName = _ref.elementName;
    if (!elementName || elementName === 'START') return false;
    var doc = (0, $hBCYb.getDocument)();
    if (!doc) return false;
    var smartAnswersElement = doc.getElementById('search-page-smart-answers');
    if (!smartAnswersElement) return false;
    var entryDOMElement = doc.querySelector(elementName);
    if (!entryDOMElement) return false;
    return smartAnswersElement.contains(entryDOMElement);
}

});

parcelRegister("fWZXc", function(module, exports) {
$parcel$export(module.exports, "default", () => $b9cc5487293cd169$export$2e2bcd8739ae039);
function $b9cc5487293cd169$var$isViewportEntryData(data) {
    if (data) {
        var hasElementName = typeof data.elementName === 'string';
        var hasRect = typeof data.rect !== 'undefined';
        if (hasRect && hasElementName) return true;
    }
    return false;
}
var $b9cc5487293cd169$export$2e2bcd8739ae039 = $b9cc5487293cd169$var$isViewportEntryData;

});


parcelRegister("g3QRV", function(module, exports) {
$parcel$export(module.exports, "default", () => $bb15efca9502bacc$export$2e2bcd8739ae039);

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $kIXpt = parcelRequire("kIXpt");

var $cYPzS = parcelRequire("cYPzS");

var $lwlXp = parcelRequire("lwlXp");

var $eyuDe = parcelRequire("eyuDe");

var $9Zzpd = parcelRequire("9Zzpd");

var $jdRKQ = parcelRequire("jdRKQ");
function $bb15efca9502bacc$var$_callSuper(t, o, e) {
    return o = (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(o), (0, (/*@__PURE__*/$parcel$interopDefault($kIXpt)))(t, $bb15efca9502bacc$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(t).constructor) : o.apply(t, e));
}
function $bb15efca9502bacc$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($bb15efca9502bacc$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $bb15efca9502bacc$var$_superPropGet(t, o, e, r) {
    var p = (0, (/*@__PURE__*/$parcel$interopDefault($lwlXp)))((0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(1 & r ? t.prototype : t), o, e);
    return 2 & r && "function" == typeof p ? function(t) {
        return p.apply(e, t);
    } : p;
}
// NOTE: `next` to be renamed `fy26.04` once stable
var $bb15efca9502bacc$var$REVISION_NO = 'next';
var $bb15efca9502bacc$var$getConsideredEntryTypes = function getConsideredEntryTypes() {
    var consideredEntryTypes = [
        'mutation:display-contents-children-element'
    ];
    if ((0, $9Zzpd.fg)('platform_ufo_remove_ssr_placeholder_in_ttvc_v4')) consideredEntryTypes.push('mutation:ssr-placeholder');
    if ((0, $9Zzpd.fg)('platform_ufo_detect_zero_dimension_rectangles')) consideredEntryTypes.push('mutation:display-contents-children-attribute');
    return consideredEntryTypes;
};
var $bb15efca9502bacc$var$getExcludedEntryTypes = function getExcludedEntryTypes() {
    var excludedEntryTypes = [
        'layout-shift:same-rect'
    ];
    if ((0, $9Zzpd.fg)('platform_ufo_ttvc_v4_exclude_input_name_mutation')) excludedEntryTypes.push('mutation:attribute:non-visual-input-name');
    return excludedEntryTypes;
};
// NOTE: `VCNext` to be renamed `FY26_04` once stable
var $bb15efca9502bacc$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_VCCalculator_FY25_) {
    function VCNextCalculator() {
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, VCNextCalculator);
        return $bb15efca9502bacc$var$_callSuper(this, VCNextCalculator, [
            $bb15efca9502bacc$var$REVISION_NO
        ]);
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($eyuDe)))(VCNextCalculator, _VCCalculator_FY25_);
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(VCNextCalculator, [
        {
            key: "isEntryIncluded",
            value: function isEntryIncluded(entry, include3p) {
                var isEntryIncludedInV3 = $bb15efca9502bacc$var$_superPropGet(VCNextCalculator, "isEntryIncluded", this, 3)([
                    entry,
                    include3p
                ]);
                if (isEntryIncludedInV3 && !$bb15efca9502bacc$var$getExcludedEntryTypes().includes(entry.data.type)) return true;
                return $bb15efca9502bacc$var$getConsideredEntryTypes().includes(entry.data.type);
            }
        }
    ]);
}((0, $jdRKQ.default));

});

parcelRegister("gOE39", function(module, exports) {
$parcel$export(module.exports, "default", () => $c3e061e51a46a203$export$2e2bcd8739ae039);

var $fC8ib = parcelRequire("fC8ib");

var $fL8KA = parcelRequire("fL8KA");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $25nEq = parcelRequire("25nEq");

var $6HG4S = parcelRequire("6HG4S");

var $3VF6y = parcelRequire("3VF6y");

var $5X23Y = parcelRequire("5X23Y");
function $c3e061e51a46a203$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $c3e061e51a46a203$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $c3e061e51a46a203$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $c3e061e51a46a203$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $c3e061e51a46a203$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $c3e061e51a46a203$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $c3e061e51a46a203$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $c3e061e51a46a203$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $c3e061e51a46a203$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $c3e061e51a46a203$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $c3e061e51a46a203$var$ABORTING_WINDOW_EVENT = [
    'wheel',
    'scroll',
    'keydown',
    'resize'
];
var $c3e061e51a46a203$var$MAX_OBSERVATIONS = 100;
var $c3e061e51a46a203$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function RawDataHandler() {
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, RawDataHandler);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "revisionNo", 'raw-handler');
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(RawDataHandler, [
        {
            key: "getVCCleanStatus",
            value: function getVCCleanStatus(filteredEntries) {
                var dirtyReason = '';
                var abortTimestamp = -1;
                var hasAbortEvent = filteredEntries.some(function(entry) {
                    if (entry.data.type === 'window:event') {
                        var data = entry.data;
                        if ($c3e061e51a46a203$var$ABORTING_WINDOW_EVENT.includes(data.eventType)) {
                            dirtyReason = data.eventType === 'keydown' ? 'keypress' : data.eventType;
                            abortTimestamp = Math.round(entry.time);
                            return true;
                        }
                    }
                    return false;
                });
                if (hasAbortEvent && dirtyReason) return {
                    isVCClean: false,
                    dirtyReason: dirtyReason,
                    abortTimestamp: abortTimestamp
                };
                return {
                    isVCClean: true
                };
            }
        },
        {
            key: "getRawData",
            value: function() {
                var _getRawData = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee(_ref) {
                    var entries, startTime, stopTime, isPageVisible, isVCClean, dirtyReason, getVCCleanStatusResult, viewportEntries, targetNameToIdMap, elementMapEntriesMap, nextElementId, typeMap, typeMapEntriesMap, nextTypeId, attributeMap, attributeEntriesMap, nextAttributeId, rawObservations, firstObservation, lastObservations, referencedEids, referencedChgs, referencedAtts, _iterator, _step, observation, _iterator2, _step2, eid, _iterator3, _step3, chg, _iterator4, _step4, att, result;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee$(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                entries = _ref.entries, startTime = _ref.startTime, stopTime = _ref.stopTime, isPageVisible = _ref.isPageVisible;
                                getVCCleanStatusResult = this.getVCCleanStatus(entries);
                                isVCClean = getVCCleanStatusResult.isVCClean;
                                dirtyReason = getVCCleanStatusResult.dirtyReason;
                                if (isPageVisible) {
                                    _context.next = 6;
                                    break;
                                }
                                return _context.abrupt("return", {
                                    revision: this.revisionNo,
                                    clean: false,
                                    'metric:vc90': null,
                                    abortReason: 'browser_backgrounded',
                                    abortTimestamp: -1,
                                    viewport: {
                                        w: (0, $5X23Y.default)(),
                                        h: (0, $3VF6y.default)()
                                    }
                                });
                            case 6:
                                viewportEntries = entries.filter(function(entry) {
                                    return entry.time >= startTime && entry.time <= stopTime && entry.data && entry.data.visible;
                                });
                                targetNameToIdMap = new Map();
                                elementMapEntriesMap = {};
                                nextElementId = 1;
                                typeMap = new Map();
                                typeMapEntriesMap = {};
                                nextTypeId = 1;
                                attributeMap = new Map();
                                attributeEntriesMap = {};
                                nextAttributeId = 1;
                                rawObservations = viewportEntries.map(function(entry) {
                                    var viewportEntry = entry.data;
                                    var targetName = viewportEntry.elementName || '';
                                    var type = viewportEntry.type || '';
                                    var rect = viewportEntry.rect;
                                    var attributeName = viewportEntry.attributeName || '';
                                    var eid = targetNameToIdMap.get(viewportEntry.elementName || '') || 0;
                                    if (eid === 0) {
                                        eid = nextElementId;
                                        nextElementId += 1;
                                        targetNameToIdMap.set(targetName, eid);
                                        elementMapEntriesMap[eid] = targetName;
                                    }
                                    var chg = typeMap.get(type || '') || 0;
                                    if (chg === 0) {
                                        chg = nextTypeId;
                                        nextTypeId += 1;
                                        typeMap.set(type, chg);
                                        typeMapEntriesMap[chg] = type;
                                    }
                                    var att = 0;
                                    if (attributeName) {
                                        att = attributeMap.get(attributeName) || 0;
                                        if (att === 0) {
                                            att = nextAttributeId;
                                            nextAttributeId += 1;
                                            attributeMap.set(attributeName, att);
                                            attributeEntriesMap[att] = attributeName;
                                        }
                                    }
                                    var observation = $c3e061e51a46a203$var$_objectSpread({
                                        t: Math.round(entry.time - startTime),
                                        r: [
                                            Math.round(rect.left * 10) / 10,
                                            Math.round(rect.top * 10) / 10,
                                            Math.round(rect.right * 10) / 10,
                                            Math.round(rect.bottom * 10) / 10
                                        ],
                                        chg: chg,
                                        eid: eid || 0
                                    }, att > 0 ? {
                                        att: att
                                    } : {});
                                    return observation;
                                }); // If the number of observations is greater than the maximum allowed, we need to trim the observations to the maximum allowed.
                                // We do this by keeping the first observation and the last MAX_OBSERVATIONS observations.
                                // We then collect the referenced IDs from the remaining observations and remove the unreferenced entries from the maps
                                if (rawObservations.length > $c3e061e51a46a203$var$MAX_OBSERVATIONS) {
                                    firstObservation = rawObservations[0];
                                    lastObservations = rawObservations.slice(-$c3e061e51a46a203$var$MAX_OBSERVATIONS);
                                    rawObservations = [
                                        firstObservation
                                    ].concat((0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(lastObservations));
                                    // Collect referenced IDs from remaining observations
                                    referencedEids = new Set();
                                    referencedChgs = new Set();
                                    referencedAtts = new Set();
                                    _iterator = $c3e061e51a46a203$var$_createForOfIteratorHelper(rawObservations);
                                    try {
                                        for(_iterator.s(); !(_step = _iterator.n()).done;){
                                            observation = _step.value;
                                            if (observation.eid > 0) referencedEids.add(observation.eid);
                                            if (typeof observation.chg === 'number' && observation.chg > 0) referencedChgs.add(observation.chg);
                                            if (observation.att !== undefined && observation.att > 0) referencedAtts.add(observation.att);
                                        }
                                    // Remove unreferenced entries from maps
                                    } catch (err) {
                                        _iterator.e(err);
                                    } finally{
                                        _iterator.f();
                                    }
                                    _iterator2 = $c3e061e51a46a203$var$_createForOfIteratorHelper(Object.keys(elementMapEntriesMap).map(Number));
                                    try {
                                        for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                                            eid = _step2.value;
                                            if (!referencedEids.has(eid)) delete elementMapEntriesMap[eid];
                                        }
                                    } catch (err) {
                                        _iterator2.e(err);
                                    } finally{
                                        _iterator2.f();
                                    }
                                    _iterator3 = $c3e061e51a46a203$var$_createForOfIteratorHelper(Object.keys(typeMapEntriesMap).map(Number));
                                    try {
                                        for(_iterator3.s(); !(_step3 = _iterator3.n()).done;){
                                            chg = _step3.value;
                                            if (!referencedChgs.has(chg)) delete typeMapEntriesMap[chg];
                                        }
                                    } catch (err) {
                                        _iterator3.e(err);
                                    } finally{
                                        _iterator3.f();
                                    }
                                    _iterator4 = $c3e061e51a46a203$var$_createForOfIteratorHelper(Object.keys(attributeEntriesMap).map(Number));
                                    try {
                                        for(_iterator4.s(); !(_step4 = _iterator4.n()).done;){
                                            att = _step4.value;
                                            if (!referencedAtts.has(att)) delete attributeEntriesMap[att];
                                        }
                                    } catch (err) {
                                        _iterator4.e(err);
                                    } finally{
                                        _iterator4.f();
                                    }
                                }
                                result = {
                                    revision: this.revisionNo,
                                    clean: isVCClean,
                                    'metric:vc90': null,
                                    rawData: {
                                        obs: rawObservations !== null && rawObservations !== void 0 ? rawObservations : undefined,
                                        eid: elementMapEntriesMap !== null && elementMapEntriesMap !== void 0 ? elementMapEntriesMap : undefined,
                                        chg: typeMapEntriesMap !== null && typeMapEntriesMap !== void 0 ? typeMapEntriesMap : undefined,
                                        att: attributeEntriesMap !== null && attributeEntriesMap !== void 0 ? attributeEntriesMap : undefined
                                    },
                                    abortReason: dirtyReason,
                                    abortTimestamp: getVCCleanStatusResult.abortTimestamp,
                                    viewport: {
                                        w: (0, $5X23Y.default)(),
                                        h: (0, $3VF6y.default)()
                                    }
                                };
                                return _context.abrupt("return", result);
                            case 20:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee, this);
                }));
                function getRawData(_x) {
                    return _getRawData.apply(this, arguments);
                }
                return getRawData;
            }()
        }
    ]);
}();

});

parcelRegister("frhlU", function(module, exports) {
$parcel$export(module.exports, "default", () => $b3d6d67691d5a6bd$export$2e2bcd8739ae039);

var $fL8KA = parcelRequire("fL8KA");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $25nEq = parcelRequire("25nEq");

var $6HG4S = parcelRequire("6HG4S");

var $9Zzpd = parcelRequire("9Zzpd");

var $cDJdu = parcelRequire("cDJdu");

var $3ncU7 = parcelRequire("3ncU7");

var $lj1OM = parcelRequire("lj1OM");

var $hakpj = parcelRequire("hakpj");

var $wFqCH = parcelRequire("wFqCH");

var $69x5n = parcelRequire("69x5n");

var $gwgRo = parcelRequire("gwgRo");

var $iMyl6 = parcelRequire("iMyl6");

var $1qNfj = parcelRequire("1qNfj");

var $5OR1d = parcelRequire("5OR1d");

var $73isn = parcelRequire("73isn");

var $2Y2S2 = parcelRequire("2Y2S2");

var $8FHmX = parcelRequire("8FHmX");

var $da3Er = parcelRequire("da3Er");
function $b3d6d67691d5a6bd$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $b3d6d67691d5a6bd$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $b3d6d67691d5a6bd$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $b3d6d67691d5a6bd$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $b3d6d67691d5a6bd$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $b3d6d67691d5a6bd$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
var $b3d6d67691d5a6bd$var$createElementMutationsWatcher = function createElementMutationsWatcher(removedNodeRects) {
    return function(_ref) {
        var target = _ref.target, rect = _ref.rect;
        var isInIgnoreLsMarker = (0, $73isn.default)(target);
        if (!isInIgnoreLsMarker) return 'mutation:element';
        var isRLLPlaceholder = (0, $hakpj.RLLPlaceholderHandlers).getInstance().isRLLPlaceholderHydration(rect);
        if (isRLLPlaceholder && isInIgnoreLsMarker) return 'mutation:rll-placeholder';
        var wasDeleted = removedNodeRects.some(function(nr) {
            return (0, $8FHmX.isSameRectDimensions)(nr, rect);
        });
        if (wasDeleted && isInIgnoreLsMarker) return 'mutation:element-replacement';
        return 'mutation:element';
    };
};
var $b3d6d67691d5a6bd$var$createElementMutationsWatcherV4 = function createElementMutationsWatcherV4(removedNodeRects, isWithinThirdPartySegment, hasSameDeletedNode, timestamp, isTargetReactRoot, getSSRState, getSSRPlaceholderHandler) {
    return function(_ref2) {
        var target = _ref2.target, rect = _ref2.rect;
        if (getSSRState) {
            var ssrState = getSSRState();
            var SSRStateEnum = {
                normal: 1,
                waitingForFirstRender: 2,
                ignoring: 3
            };
            if (ssrState.state === SSRStateEnum.waitingForFirstRender && timestamp > ssrState.renderStart && isTargetReactRoot) {
                ssrState.state = SSRStateEnum.ignoring;
                if (ssrState.renderStop === -1) // arbitrary 500ms DOM update window
                ssrState.renderStop = timestamp + 500;
                return 'ssr-hydration';
            }
            if (ssrState.state === SSRStateEnum.ignoring && timestamp > ssrState.renderStart && isTargetReactRoot) {
                if (timestamp <= ssrState.renderStop) return 'ssr-hydration';
                else ssrState.state = SSRStateEnum.normal;
            }
        }
        if (getSSRPlaceholderHandler) {
            var ssrPlaceholderHandler = getSSRPlaceholderHandler();
            if (ssrPlaceholderHandler) {
                if ((ssrPlaceholderHandler.isPlaceholderV4(target) || ssrPlaceholderHandler.isPlaceholderIgnored(target)) && ssrPlaceholderHandler.checkIfExistedAndSizeMatchingV3(target)) return 'mutation:ssr-placeholder';
                if ((ssrPlaceholderHandler.isPlaceholderReplacementV4(target) || ssrPlaceholderHandler.isPlaceholderIgnored(target)) && ssrPlaceholderHandler.validateReactComponentMatchToPlaceholderV4(target)) return 'mutation:ssr-placeholder';
            }
        }
        if (hasSameDeletedNode && (0, $73isn.default)(target)) return 'mutation:remount';
        if ((0, $cDJdu.isContainedWithinMediaWrapper)(target)) return 'mutation:media';
        if (isWithinThirdPartySegment) return 'mutation:third-party-element';
        var isInIgnoreLsMarker = (0, $73isn.default)(target);
        if (!isInIgnoreLsMarker) return 'mutation:element';
        var isRLLPlaceholder = (0, $hakpj.RLLPlaceholderHandlers).getInstance().isRLLPlaceholderHydration(rect);
        if (isRLLPlaceholder && isInIgnoreLsMarker) return 'mutation:rll-placeholder';
        var wasDeleted = removedNodeRects.some(function(nr) {
            return (0, $8FHmX.isSameRectDimensions)(nr, rect);
        });
        if (wasDeleted && isInIgnoreLsMarker) return 'mutation:element-replacement';
        return 'mutation:element';
    };
};
var $b3d6d67691d5a6bd$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    // SSR context functions
    function ViewportObserver(_ref3) {
        var _this = this;
        var onChange = _ref3.onChange, getSSRState = _ref3.getSSRState, getSSRPlaceholderHandler = _ref3.getSSRPlaceholderHandler;
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, ViewportObserver);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "handleIntersectionEntry", function(_ref4) {
            var target = _ref4.target, rect = _ref4.rect, time = _ref4.time, type = _ref4.type, mutationData = _ref4.mutationData;
            if (!target) return;
            var visible = (0, $5OR1d.isElementVisible)(target);
            var lastElementRect = _this.mapVisibleNodeRects.get(target);
            _this.mapVisibleNodeRects.set(target, rect);
            _this.onChange({
                time: time,
                type: type,
                elementRef: new WeakRef(target),
                visible: visible,
                rect: rect,
                previousRect: lastElementRect,
                mutationData: mutationData
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "handleChildListMutation", /*#__PURE__*/ function() {
            var _ref6 = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee(_ref5) {
                var target, addedNodes, removedNodes, timestamp, removedNodeRects, targetNode, _iterator, _step, _loop;
                return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee$(_context3) {
                    while(true)switch(_context3.prev = _context3.next){
                        case 0:
                            target = _ref5.target, addedNodes = _ref5.addedNodes, removedNodes = _ref5.removedNodes, timestamp = _ref5.timestamp;
                            removedNodeRects = removedNodes.map(function(ref) {
                                var n = ref.deref();
                                if (!n) return;
                                return _this.mapVisibleNodeRects.get(n);
                            });
                            targetNode = target.deref();
                            _iterator = $b3d6d67691d5a6bd$var$_createForOfIteratorHelper(addedNodes);
                            _context3.prev = 4;
                            _loop = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _loop() {
                                var addedNodeRef, addedNode, _this$getSSRState, _this$intersectionObs, hasSameDeletedNode, _checkWithinComponent, isWithinThirdPartySegment, isTargetReactRoot, _iterator2, _step2, _loop2, _ret;
                                return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _loop$(_context2) {
                                    while(true)switch(_context2.prev = _context2.next){
                                        case 0:
                                            addedNodeRef = _step.value;
                                            addedNode = addedNodeRef.deref();
                                            if (addedNode) {
                                                _context2.next = 4;
                                                break;
                                            }
                                            return _context2.abrupt("return", 1);
                                        case 4:
                                            if (!(0, $9Zzpd.fg)('platform_ufo_detect_zero_dimension_rectangles')) {
                                                _context2.next = 11;
                                                break;
                                            }
                                            hasSameDeletedNode = removedNodes.find(function(ref) {
                                                var n = ref.deref();
                                                if (!n || !addedNode) return false;
                                                return n.isEqualNode(addedNode);
                                            });
                                            _checkWithinComponent = (0, $iMyl6.default)(addedNode, 'UFOThirdPartySegment', _this.mapIs3pResult), isWithinThirdPartySegment = _checkWithinComponent.isWithin;
                                            isTargetReactRoot = targetNode === ((_this$getSSRState = _this.getSSRState) === null || _this$getSSRState === void 0 || (_this$getSSRState = _this$getSSRState.call(_this)) === null || _this$getSSRState === void 0 ? void 0 : _this$getSSRState.reactRootElement);
                                            (_this$intersectionObs = _this.intersectionObserver) === null || _this$intersectionObs === void 0 || _this$intersectionObs.watchAndTag(addedNode, $b3d6d67691d5a6bd$var$createElementMutationsWatcherV4(removedNodeRects, isWithinThirdPartySegment, !!hasSameDeletedNode, timestamp, isTargetReactRoot, _this.getSSRState, _this.getSSRPlaceholderHandler));
                                            _context2.next = 30;
                                            break;
                                        case 11:
                                            _iterator2 = $b3d6d67691d5a6bd$var$_createForOfIteratorHelper((0, $1qNfj.getMutatedElements)(addedNode));
                                            _context2.prev = 12;
                                            _loop2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _loop2() {
                                                var _step2$value, isDisplayContentsElementChildren, element, ssrState, SSRStateEnum, _this$intersectionObs2, _this$intersectionObs3, ssrPlaceholderHandler, _this$intersectionObs4, result, _this$intersectionObs5, sameDeletedNode, isInIgnoreLsMarker, _this$intersectionObs6, _this$intersectionObs7, _ref7, isWithinThirdPartySegment, _this$intersectionObs8, _this$intersectionObs9, _this$intersectionObs0;
                                                return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _loop2$(_context) {
                                                    while(true)switch(_context.prev = _context.next){
                                                        case 0:
                                                            _step2$value = _step2.value, isDisplayContentsElementChildren = _step2$value.isDisplayContentsElementChildren, element = _step2$value.element;
                                                            if (!_this.getSSRState) {
                                                                _context.next = 16;
                                                                break;
                                                            }
                                                            ssrState = _this.getSSRState();
                                                            SSRStateEnum = {
                                                                normal: 1,
                                                                waitingForFirstRender: 2,
                                                                ignoring: 3
                                                            };
                                                            if (!(ssrState.state === SSRStateEnum.waitingForFirstRender && timestamp > ssrState.renderStart && targetNode === ssrState.reactRootElement)) {
                                                                _context.next = 9;
                                                                break;
                                                            }
                                                            ssrState.state = SSRStateEnum.ignoring;
                                                            if (ssrState.renderStop === -1) // arbitrary 500ms DOM update window
                                                            ssrState.renderStop = timestamp + 500;
                                                            (_this$intersectionObs2 = _this.intersectionObserver) === null || _this$intersectionObs2 === void 0 || _this$intersectionObs2.watchAndTag(element, 'ssr-hydration');
                                                            return _context.abrupt("return", 0);
                                                        case 9:
                                                            if (!(ssrState.state === SSRStateEnum.ignoring && timestamp > ssrState.renderStart && targetNode === ssrState.reactRootElement)) {
                                                                _context.next = 16;
                                                                break;
                                                            }
                                                            if (!(timestamp <= ssrState.renderStop)) {
                                                                _context.next = 15;
                                                                break;
                                                            }
                                                            (_this$intersectionObs3 = _this.intersectionObserver) === null || _this$intersectionObs3 === void 0 || _this$intersectionObs3.watchAndTag(element, 'ssr-hydration');
                                                            return _context.abrupt("return", 0);
                                                        case 15:
                                                            ssrState.state = SSRStateEnum.normal;
                                                        case 16:
                                                            if (!_this.getSSRPlaceholderHandler) {
                                                                _context.next = 30;
                                                                break;
                                                            }
                                                            ssrPlaceholderHandler = _this.getSSRPlaceholderHandler();
                                                            if (!ssrPlaceholderHandler) {
                                                                _context.next = 30;
                                                                break;
                                                            }
                                                            if (!(ssrPlaceholderHandler.isPlaceholder(element) || ssrPlaceholderHandler.isPlaceholderIgnored(element))) {
                                                                _context.next = 23;
                                                                break;
                                                            }
                                                            if (!ssrPlaceholderHandler.checkIfExistedAndSizeMatchingV3(element)) {
                                                                _context.next = 23;
                                                                break;
                                                            }
                                                            (_this$intersectionObs4 = _this.intersectionObserver) === null || _this$intersectionObs4 === void 0 || _this$intersectionObs4.watchAndTag(element, 'mutation:ssr-placeholder');
                                                            return _context.abrupt("return", 0);
                                                        case 23:
                                                            if (!(ssrPlaceholderHandler.isPlaceholderReplacement(element) || ssrPlaceholderHandler.isPlaceholderIgnored(element))) {
                                                                _context.next = 30;
                                                                break;
                                                            }
                                                            _context.next = 26;
                                                            return ssrPlaceholderHandler.validateReactComponentMatchToPlaceholder(element);
                                                        case 26:
                                                            result = _context.sent;
                                                            if (!(result !== false)) {
                                                                _context.next = 30;
                                                                break;
                                                            }
                                                            (_this$intersectionObs5 = _this.intersectionObserver) === null || _this$intersectionObs5 === void 0 || _this$intersectionObs5.watchAndTag(element, 'mutation:ssr-placeholder');
                                                            return _context.abrupt("return", 0);
                                                        case 30:
                                                            sameDeletedNode = removedNodes.find(function(ref) {
                                                                var n = ref.deref();
                                                                if (!n || !element) return false;
                                                                return n.isEqualNode(element);
                                                            });
                                                            isInIgnoreLsMarker = element instanceof HTMLElement ? (0, $73isn.default)(element) : false;
                                                            if (!(sameDeletedNode && isInIgnoreLsMarker)) {
                                                                _context.next = 35;
                                                                break;
                                                            }
                                                            (_this$intersectionObs6 = _this.intersectionObserver) === null || _this$intersectionObs6 === void 0 || _this$intersectionObs6.watchAndTag(element, 'mutation:remount');
                                                            return _context.abrupt("return", 0);
                                                        case 35:
                                                            if (!(0, $cDJdu.isContainedWithinMediaWrapper)(element)) {
                                                                _context.next = 38;
                                                                break;
                                                            }
                                                            (_this$intersectionObs7 = _this.intersectionObserver) === null || _this$intersectionObs7 === void 0 || _this$intersectionObs7.watchAndTag(element, 'mutation:media');
                                                            return _context.abrupt("return", 0);
                                                        case 38:
                                                            _ref7 = element instanceof HTMLElement ? (0, $iMyl6.default)(element, 'UFOThirdPartySegment', _this.mapIs3pResult) : {
                                                                isWithin: false
                                                            }, isWithinThirdPartySegment = _ref7.isWithin;
                                                            if (!isWithinThirdPartySegment) {
                                                                _context.next = 42;
                                                                break;
                                                            }
                                                            (_this$intersectionObs8 = _this.intersectionObserver) === null || _this$intersectionObs8 === void 0 || _this$intersectionObs8.watchAndTag(element, 'mutation:third-party-element');
                                                            return _context.abrupt("return", 0);
                                                        case 42:
                                                            if (isDisplayContentsElementChildren) (_this$intersectionObs9 = _this.intersectionObserver) === null || _this$intersectionObs9 === void 0 || _this$intersectionObs9.watchAndTag(element, 'mutation:display-contents-children-element');
                                                            else (_this$intersectionObs0 = _this.intersectionObserver) === null || _this$intersectionObs0 === void 0 || _this$intersectionObs0.watchAndTag(element, $b3d6d67691d5a6bd$var$createElementMutationsWatcher(removedNodeRects));
                                                        case 43:
                                                        case "end":
                                                            return _context.stop();
                                                    }
                                                }, _loop2);
                                            });
                                            _iterator2.s();
                                        case 15:
                                            if ((_step2 = _iterator2.n()).done) {
                                                _context2.next = 22;
                                                break;
                                            }
                                            return _context2.delegateYield(_loop2(), "t0", 17);
                                        case 17:
                                            _ret = _context2.t0;
                                            if (!(_ret === 0)) {
                                                _context2.next = 20;
                                                break;
                                            }
                                            return _context2.abrupt("continue", 20);
                                        case 20:
                                            _context2.next = 15;
                                            break;
                                        case 22:
                                            _context2.next = 27;
                                            break;
                                        case 24:
                                            _context2.prev = 24;
                                            _context2.t1 = _context2["catch"](12);
                                            _iterator2.e(_context2.t1);
                                        case 27:
                                            _context2.prev = 27;
                                            _iterator2.f();
                                            return _context2.finish(27);
                                        case 30:
                                        case "end":
                                            return _context2.stop();
                                    }
                                }, _loop, null, [
                                    [
                                        12,
                                        24,
                                        27,
                                        30
                                    ]
                                ]);
                            });
                            _iterator.s();
                        case 7:
                            if ((_step = _iterator.n()).done) {
                                _context3.next = 13;
                                break;
                            }
                            return _context3.delegateYield(_loop(), "t0", 9);
                        case 9:
                            if (!_context3.t0) {
                                _context3.next = 11;
                                break;
                            }
                            return _context3.abrupt("continue", 11);
                        case 11:
                            _context3.next = 7;
                            break;
                        case 13:
                            _context3.next = 18;
                            break;
                        case 15:
                            _context3.prev = 15;
                            _context3.t1 = _context3["catch"](4);
                            _iterator.e(_context3.t1);
                        case 18:
                            _context3.prev = 18;
                            _iterator.f();
                            return _context3.finish(18);
                        case 21:
                        case "end":
                            return _context3.stop();
                    }
                }, _callee, null, [
                    [
                        4,
                        15,
                        18,
                        21
                    ]
                ]);
            }));
            return function(_x) {
                return _ref6.apply(this, arguments);
            };
        }());
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "handleAttributeMutation", function(_ref8) {
            var _this$intersectionObs1;
            var target = _ref8.target, attributeName = _ref8.attributeName, oldValue = _ref8.oldValue, newValue = _ref8.newValue;
            (_this$intersectionObs1 = _this.intersectionObserver) === null || _this$intersectionObs1 === void 0 || _this$intersectionObs1.watchAndTag(target, function(_ref9) {
                var target = _ref9.target, rect = _ref9.rect;
                if ((0, $cDJdu.isContainedWithinMediaWrapper)(target)) return {
                    type: 'mutation:media',
                    mutationData: {
                        attributeName: attributeName,
                        oldValue: oldValue,
                        newValue: newValue
                    }
                };
                if ((0, $9Zzpd.fg)('platform_ufo_exclude_3p_attribute_changes')) {
                    var _checkWithinComponent2 = (0, $iMyl6.default)(target, 'UFOThirdPartySegment', _this.mapIs3pResult), isWithinThirdPartySegment = _checkWithinComponent2.isWithin;
                    if (isWithinThirdPartySegment) return {
                        type: 'mutation:third-party-attribute',
                        mutationData: {
                            attributeName: attributeName,
                            oldValue: oldValue,
                            newValue: newValue
                        }
                    };
                }
                if ((0, $3ncU7.default)({
                    target: target,
                    attributeName: attributeName,
                    oldValue: oldValue,
                    newValue: newValue
                })) return {
                    type: 'mutation:attribute:non-visual-style',
                    mutationData: {
                        attributeName: attributeName,
                        oldValue: oldValue,
                        newValue: newValue
                    }
                };
                if ((0, $lj1OM.default)({
                    target: target,
                    attributeName: attributeName,
                    type: 'attributes'
                })) return {
                    type: 'mutation:attribute:non-visual-style',
                    mutationData: {
                        attributeName: attributeName,
                        oldValue: oldValue,
                        newValue: newValue
                    }
                };
                if ((0, $2Y2S2.isInputNameMutation)({
                    target: target,
                    attributeName: attributeName,
                    oldValue: oldValue,
                    newValue: newValue
                })) return {
                    type: 'mutation:attribute:non-visual-input-name',
                    mutationData: {
                        attributeName: attributeName,
                        oldValue: oldValue,
                        newValue: newValue
                    }
                };
                var isRLLPlaceholder = (0, $hakpj.RLLPlaceholderHandlers).getInstance().isRLLPlaceholderHydration(rect);
                if (isRLLPlaceholder) return {
                    type: 'mutation:rll-placeholder',
                    mutationData: {
                        attributeName: attributeName,
                        oldValue: oldValue,
                        newValue: newValue
                    }
                };
                var lastElementRect = _this.mapVisibleNodeRects.get(target);
                if (lastElementRect && (0, $da3Er.isSameRectSize)(rect, lastElementRect)) return {
                    type: 'mutation:attribute:no-layout-shift',
                    mutationData: {
                        attributeName: attributeName,
                        oldValue: oldValue,
                        newValue: newValue
                    }
                };
                return {
                    type: 'mutation:attribute',
                    mutationData: {
                        attributeName: attributeName,
                        oldValue: oldValue,
                        newValue: newValue
                    }
                };
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "handleLayoutShift", function(_ref0) {
            var time = _ref0.time, changedRects = _ref0.changedRects;
            var _iterator3 = $b3d6d67691d5a6bd$var$_createForOfIteratorHelper(changedRects), _step3;
            try {
                for(_iterator3.s(); !(_step3 = _iterator3.n()).done;){
                    var changedRect = _step3.value;
                    var target = changedRect.node;
                    if (target) {
                        var isSameCurrentAndPreviousRects = (0, $8FHmX.isSameRectDimensions)(changedRect.rect, changedRect.previousRect);
                        _this.onChange({
                            time: time,
                            elementRef: new WeakRef(target),
                            visible: true,
                            rect: changedRect.rect,
                            previousRect: changedRect.previousRect,
                            type: isSameCurrentAndPreviousRects ? 'layout-shift:same-rect' : 'layout-shift'
                        });
                    }
                }
            } catch (err) {
                _iterator3.e(err);
            } finally{
                _iterator3.f();
            }
        });
        this.mapVisibleNodeRects = new WeakMap();
        this.mapIs3pResult = new WeakMap();
        this.onChange = onChange;
        this.isStarted = false;
        this.intersectionObserver = null;
        this.mutationObserver = null;
        this.performanceObserver = null;
        // Initialize SSR context functions
        this.getSSRState = getSSRState;
        this.getSSRPlaceholderHandler = getSSRPlaceholderHandler;
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(ViewportObserver, [
        {
            key: "initializeObservers",
            value: function initializeObservers() {
                if (this.isStarted) return;
                this.intersectionObserver = (0, $wFqCH.createIntersectionObserver)({
                    onEntry: this.handleIntersectionEntry
                });
                this.mutationObserver = (0, $69x5n.default)({
                    onChildListMutation: this.handleChildListMutation,
                    onAttributeMutation: this.handleAttributeMutation
                });
                this.performanceObserver = (0, $gwgRo.default)({
                    onLayoutShift: this.handleLayoutShift
                });
            }
        },
        {
            key: "start",
            value: function start() {
                var _this$mutationObserve, _this$performanceObse;
                if (this.isStarted) return;
                this.initializeObservers();
                (_this$mutationObserve = this.mutationObserver) === null || _this$mutationObserve === void 0 || _this$mutationObserve.observe(document.body, {
                    attributeOldValue: true,
                    attributes: true,
                    childList: true,
                    subtree: true
                });
                (_this$performanceObse = this.performanceObserver) === null || _this$performanceObse === void 0 || _this$performanceObse.observe({
                    type: 'layout-shift',
                    buffered: true,
                    // @ts-ignore -error
                    durationThreshold: 30
                });
                this.isStarted = true;
            }
        },
        {
            key: "stop",
            value: function stop() {
                var _this$mutationObserve2, _this$intersectionObs10, _this$performanceObse2;
                if (!this.isStarted) return;
                (_this$mutationObserve2 = this.mutationObserver) === null || _this$mutationObserve2 === void 0 || _this$mutationObserve2.disconnect();
                (_this$intersectionObs10 = this.intersectionObserver) === null || _this$intersectionObs10 === void 0 || _this$intersectionObs10.disconnect();
                (_this$performanceObse2 = this.performanceObserver) === null || _this$performanceObse2 === void 0 || _this$performanceObse2.disconnect();
                this.isStarted = false;
                // Clean up caches when stopping
                (0, $iMyl6.cleanupCaches)(this.mapIs3pResult);
            }
        }
    ]);
}();

});
parcelRegister("wFqCH", function(module, exports) {
$parcel$export(module.exports, "createIntersectionObserver", () => $062320179c1b88d0$export$c3799d33e0ae80a5);

var $9Zzpd = parcelRequire("9Zzpd");

var $3jxjF = parcelRequire("3jxjF");
function $062320179c1b88d0$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $062320179c1b88d0$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $062320179c1b88d0$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $062320179c1b88d0$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $062320179c1b88d0$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $062320179c1b88d0$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $062320179c1b88d0$var$isValidEntry(entry) {
    return entry.isIntersecting && entry.intersectionRect.width > 0 && entry.intersectionRect.height > 0;
}
function $062320179c1b88d0$export$c3799d33e0ae80a5(_ref) {
    var onEntry = _ref.onEntry, onObserved = _ref.onObserved;
    if (!window || typeof window.IntersectionObserver !== 'function') return null;
    var callbacksPerElement = new WeakMap();
    var intersectionObserverCallback = function intersectionObserverCallback(entries) {
        var validEntries = [];
        var startTime = performance.now();
        entries.forEach(function(entry) {
            if (!(entry.target instanceof HTMLElement)) return;
            var tagOrCallback = callbacksPerElement.get(entry.target);
            if ((0, $9Zzpd.fg)('platform_ufo_detect_zero_dimension_rectangles')) {
                if ((0, $3jxjF.isZeroDimensionRectangle)(entry.intersectionRect)) {
                    var zeroDimensionRectangleTagCallback = function zeroDimensionRectangleTagCallback(props) {
                        var tagOrCallbackResult = typeof tagOrCallback === 'function' ? tagOrCallback(props) : tagOrCallback;
                        // override as display-contents mutation
                        if (tagOrCallbackResult === 'mutation:element') return 'mutation:display-contents-children-element';
                        // override as display-contents mutation
                        if (tagOrCallbackResult && typeof tagOrCallbackResult !== 'string' && tagOrCallbackResult.type === 'mutation:attribute') return {
                            type: 'mutation:display-contents-children-attribute',
                            mutationData: tagOrCallbackResult.mutationData
                        };
                        return tagOrCallbackResult;
                    };
                    var _iterator = $062320179c1b88d0$var$_createForOfIteratorHelper(entry.target.children), _step;
                    try {
                        for(_iterator.s(); !(_step = _iterator.n()).done;){
                            var child = _step.value;
                            observer.observe(child);
                            callbacksPerElement.set(child, zeroDimensionRectangleTagCallback);
                        }
                    } catch (err) {
                        _iterator.e(err);
                    } finally{
                        _iterator.f();
                    }
                    return;
                }
            }
            if (!$062320179c1b88d0$var$isValidEntry(entry)) return;
            var mutationTag = null;
            var mutationData = null;
            if (typeof tagOrCallback === 'function') {
                var tagOrCallbackResult = tagOrCallback({
                    target: entry.target,
                    rect: entry.intersectionRect
                });
                if (!tagOrCallbackResult) mutationTag = 'unknown';
                else if (typeof tagOrCallbackResult === 'string') mutationTag = tagOrCallbackResult;
                else {
                    mutationTag = tagOrCallbackResult.type;
                    mutationData = tagOrCallbackResult.mutationData;
                }
            } else if (typeof tagOrCallback === 'string') mutationTag = tagOrCallback;
            onEntry({
                target: entry.target,
                rect: entry.intersectionRect,
                time: entry.time,
                type: mutationTag !== null && mutationTag !== void 0 ? mutationTag : 'unknown',
                mutationData: mutationData
            });
            validEntries.push(new WeakRef(entry.target));
            callbacksPerElement.delete(entry.target);
            observer.unobserve(entry.target);
        });
        onObserved === null || onObserved === void 0 || onObserved({
            time: startTime,
            elements: validEntries
        });
    };
    var observer = new IntersectionObserver(intersectionObserverCallback);
    return {
        disconnect: function disconnect() {
            observer.disconnect();
        },
        unobserve: function unobserve(target) {
            observer.unobserve(target);
        },
        watchAndTag: function watchAndTag(target, tagOrCallback) {
            callbacksPerElement.set(target, tagOrCallback);
            observer.observe(target);
        }
    };
}

});
parcelRegister("3jxjF", function(module, exports) {
$parcel$export(module.exports, "isZeroDimensionRectangle", () => $269cfd5e63256d10$export$80d6b07c2266a1c6);
function $269cfd5e63256d10$export$80d6b07c2266a1c6(rect) {
    return rect.bottom === 0 && rect.top === 0 && rect.left === 0 && rect.right === 0 && rect.x === 0 && rect.y === 0 && rect.width === 0 && rect.height === 0;
}

});


parcelRegister("69x5n", function(module, exports) {
$parcel$export(module.exports, "default", () => $47ad3f7eff4dd279$export$2e2bcd8739ae039);

var $aeUxq = parcelRequire("aeUxq");
function $47ad3f7eff4dd279$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $47ad3f7eff4dd279$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $47ad3f7eff4dd279$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $47ad3f7eff4dd279$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $47ad3f7eff4dd279$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $47ad3f7eff4dd279$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
// Batched mutation data for performance optimization
function $47ad3f7eff4dd279$var$createMutationObserver(_ref) {
    var onAttributeMutation = _ref.onAttributeMutation, onChildListMutation = _ref.onChildListMutation, onMutationFinished = _ref.onMutationFinished;
    if (!window || typeof window.IntersectionObserver !== 'function') return null;
    var mutationObserverCallback = function mutationObserverCallback(mutations) {
        var targets = [];
        // Use nested Maps for O(1) batching performance
        // Short-lived Maps are safe since they're discarded after each callback
        var batchedMutations = new Map();
        var _iterator = $47ad3f7eff4dd279$var$_createForOfIteratorHelper(mutations), _step;
        try {
            var _loop = function _loop() {
                var mut = _step.value;
                if (!(mut.target instanceof HTMLElement)) return 0; // continue
                if ((0, $aeUxq.expVal)('cc_editor_vc_exclude_flags', 'isEnabled', false)) {
                    // Intended for excluding out of band mutations such as tooltips on hover, and page flags
                    // Currently being tested in Confluence
                    // Skip elements with data-vc-oob attribute
                    if (mut.target.dataset.vcOob) return {
                        v: void 0
                    };
                }
                if (mut.type === 'attributes') {
                    var _mut$oldValue;
                    /*
            			"MutationObserver was explicitly designed to work that way, but I can't now recall the reasoning.
            			I think it might have been something along the lines that for consistency every setAttribute call should create a record.
            			Conceptually there is after all a mutation: there is an old value replaced with a new one,
            			and whether or not they are the same doesn't really matter.
            			And Custom elements should work the same way as MutationObserver."
            			https://github.com/whatwg/dom/issues/520#issuecomment-336574796
            		*/ var oldValue = (_mut$oldValue = mut.oldValue) !== null && _mut$oldValue !== void 0 ? _mut$oldValue : undefined;
                    var newValue = mut.attributeName ? mut.target.getAttribute(mut.attributeName) : undefined;
                    if (oldValue !== newValue) {
                        var _mut$attributeName;
                        onAttributeMutation({
                            target: mut.target,
                            attributeName: (_mut$attributeName = mut.attributeName) !== null && _mut$attributeName !== void 0 ? _mut$attributeName : 'unknown',
                            oldValue: oldValue,
                            newValue: newValue
                        });
                    }
                    return 0; // continue
                } else if (mut.type === 'childList') {
                    var _mut$addedNodes, _mut$removedNodes;
                    // In chromium browser MutationRecord has timestamp field, which we should use.
                    var timestamp = Math.round(mut.timestamp || performance.now());
                    // Get or create timestamp bucket
                    var timestampBucket = batchedMutations.get(timestamp);
                    if (!timestampBucket) {
                        timestampBucket = new Map();
                        batchedMutations.set(timestamp, timestampBucket);
                    }
                    // Get or create target batch within timestamp bucket
                    var batch = timestampBucket.get(mut.target);
                    if (!batch) {
                        batch = {
                            target: new WeakRef(mut.target),
                            addedNodes: [],
                            removedNodes: [],
                            timestamp: timestamp
                        };
                        timestampBucket.set(mut.target, batch);
                    }
                    // Accumulate added nodes
                    ((_mut$addedNodes = mut.addedNodes) !== null && _mut$addedNodes !== void 0 ? _mut$addedNodes : []).forEach(function(node) {
                        if (node instanceof HTMLElement) batch.addedNodes.push(new WeakRef(node));
                    });
                    // Accumulate removed nodes
                    ((_mut$removedNodes = mut.removedNodes) !== null && _mut$removedNodes !== void 0 ? _mut$removedNodes : []).forEach(function(node) {
                        if (node instanceof HTMLElement) batch.removedNodes.push(new WeakRef(node));
                    });
                }
                targets.push(mut.target);
            }, _ret;
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                _ret = _loop();
                if (_ret === 0) continue;
                if (_ret) return _ret.v;
            }
        // Process all batched childList mutations
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
        var _iterator2 = $47ad3f7eff4dd279$var$_createForOfIteratorHelper(batchedMutations.values()), _step2;
        try {
            for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                var timestampBucket = _step2.value;
                var _iterator3 = $47ad3f7eff4dd279$var$_createForOfIteratorHelper(timestampBucket.values()), _step3;
                try {
                    for(_iterator3.s(); !(_step3 = _iterator3.n()).done;){
                        var batch = _step3.value;
                        onChildListMutation({
                            target: batch.target,
                            addedNodes: batch.addedNodes,
                            removedNodes: batch.removedNodes,
                            timestamp: batch.timestamp
                        });
                    }
                } catch (err) {
                    _iterator3.e(err);
                } finally{
                    _iterator3.f();
                }
            }
        } catch (err) {
            _iterator2.e(err);
        } finally{
            _iterator2.f();
        }
        onMutationFinished === null || onMutationFinished === void 0 || onMutationFinished({
            targets: targets
        });
    };
    var observer = new MutationObserver(mutationObserverCallback);
    return observer;
}
var $47ad3f7eff4dd279$export$2e2bcd8739ae039 = $47ad3f7eff4dd279$var$createMutationObserver;

});

parcelRegister("gwgRo", function(module, exports) {
$parcel$export(module.exports, "default", () => $c06cb699e1763843$export$2e2bcd8739ae039);
function $c06cb699e1763843$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $c06cb699e1763843$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $c06cb699e1763843$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $c06cb699e1763843$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $c06cb699e1763843$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $c06cb699e1763843$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $c06cb699e1763843$export$5e3f54cad8cb65e2(rect) {
    if (typeof window.devicePixelRatio !== 'number') return rect;
    if (window.devicePixelRatio === 1) return rect;
    // eslint-disable-next-line compat/compat
    return new DOMRect(rect.x / window.devicePixelRatio, rect.y / window.devicePixelRatio, rect.width / window.devicePixelRatio, rect.height / window.devicePixelRatio);
}
function $c06cb699e1763843$var$createPerformanceObserver(_ref) {
    var onLayoutShift = _ref.onLayoutShift;
    if (!window || typeof window.PerformanceObserver !== 'function') return null;
    var performanceObserverCallback = function performanceObserverCallback(entries) {
        var _iterator = $c06cb699e1763843$var$_createForOfIteratorHelper(entries.getEntries()), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var entry = _step.value;
                if (entry.entryType === 'layout-shift' && 'sources' in entry) {
                    // see https://developer.mozilla.org/en-US/docs/Web/API/LayoutShiftAttribution for more info
                    var changedRects = entry.sources.reduceRight(function(acc, attr) {
                        acc.push({
                            rect: $c06cb699e1763843$export$5e3f54cad8cb65e2(attr.currentRect),
                            previousRect: $c06cb699e1763843$export$5e3f54cad8cb65e2(attr.previousRect),
                            node: attr.node
                        });
                        return acc;
                    }, []);
                    onLayoutShift({
                        time: entry.startTime,
                        changedRects: changedRects
                    });
                }
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
    };
    var observer = new PerformanceObserver(performanceObserverCallback);
    return observer;
}
var $c06cb699e1763843$export$2e2bcd8739ae039 = $c06cb699e1763843$var$createPerformanceObserver;

});

parcelRegister("iMyl6", function(module, exports) {
$parcel$export(module.exports, "cleanupCaches", () => $dac758c866bc6ad5$export$6a35c3789c327630);
$parcel$export(module.exports, "default", () => $dac758c866bc6ad5$export$2e2bcd8739ae039);

var $4iVTn = parcelRequire("4iVTn");

var $f1VIu = parcelRequire("f1VIu");

var $iwyvF = parcelRequire("iwyvF");
var $dac758c866bc6ad5$var$DEFAULT_MAX_LEVEL = 20;
// Cache cleanup
var $dac758c866bc6ad5$var$callCount = 0;
var $dac758c866bc6ad5$var$CLEANUP_THRESHOLD = 50;
function $dac758c866bc6ad5$var$maybeCleanup(resultCache) {
    $dac758c866bc6ad5$var$callCount++;
    if ($dac758c866bc6ad5$var$callCount >= $dac758c866bc6ad5$var$CLEANUP_THRESHOLD && (0, $4iVTn.default)(0.3)) $dac758c866bc6ad5$export$6a35c3789c327630(resultCache);
}
function $dac758c866bc6ad5$export$6a35c3789c327630(resultCache) {
    resultCache = new WeakMap();
    $dac758c866bc6ad5$var$callCount = 0;
    return resultCache;
}
function $dac758c866bc6ad5$export$2e2bcd8739ae039(node, targetComponentName, resultCache) {
    $dac758c866bc6ad5$var$maybeCleanup(resultCache);
    if (resultCache.has(node)) {
        var _resultCache$get;
        return {
            isWithin: (_resultCache$get = resultCache.get(node)) !== null && _resultCache$get !== void 0 ? _resultCache$get : false
        };
    }
    var fiber = null;
    var checkedNodes = [];
    // Always use cached fiber strategy to handle non-React elements reliably
    fiber = (0, $iwyvF.default)(node, $dac758c866bc6ad5$var$DEFAULT_MAX_LEVEL, checkedNodes);
    if (!fiber) {
        checkedNodes.forEach(function(checkedNode) {
            resultCache.set(checkedNode, false);
        });
        return {
            isWithin: false
        };
    }
    var isWithin = (0, $f1VIu.default)(fiber, targetComponentName, $dac758c866bc6ad5$var$DEFAULT_MAX_LEVEL);
    checkedNodes.forEach(function(checkedNode) {
        resultCache.set(checkedNode, isWithin);
    });
    return {
        isWithin: isWithin
    };
}

});
parcelRegister("f1VIu", function(module, exports) {
$parcel$export(module.exports, "default", () => $af13b84da006a154$export$2e2bcd8739ae039);

var $dK5dy = parcelRequire("dK5dy");
function $af13b84da006a154$export$2e2bcd8739ae039(fiber, targetComponentName, maxLevel) {
    // Stop when no more levels to traverse
    if (maxLevel <= 0) return false;
    if (!fiber) return false;
    var componentName = (0, $dK5dy.default)(fiber);
    if (componentName === targetComponentName) return true;
    // Recursively traverse up the fiber tree
    return $af13b84da006a154$export$2e2bcd8739ae039(fiber.return, targetComponentName, maxLevel - 1);
}

});
parcelRegister("dK5dy", function(module, exports) {
$parcel$export(module.exports, "default", () => $a0139e5ceb777d92$export$2e2bcd8739ae039);

var $ekGgq = parcelRequire("ekGgq");
function $a0139e5ceb777d92$export$2e2bcd8739ae039(fiber) {
    var type = fiber === null || fiber === void 0 ? void 0 : fiber.type;
    if (!type) return undefined;
    if (typeof type === 'function' || (0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(type) === 'object') return type.displayName || type.name;
    return undefined;
}

});


parcelRegister("iwyvF", function(module, exports) {
$parcel$export(module.exports, "default", () => $d7c5fc0cc5e2c136$export$2e2bcd8739ae039);

var $a2zGi = parcelRequire("a2zGi");
function $d7c5fc0cc5e2c136$export$2e2bcd8739ae039(element, maxLevel, checkedNodes) {
    // Stop when no more levels to traverse
    if (maxLevel <= 0) return null;
    checkedNodes.push(element);
    var fiber = (0, $a2zGi.default)(element);
    if (fiber) return fiber;
    // Walk up the DOM tree to find the fiber
    var parent = element.parentElement;
    if (!parent) return null;
    // Recursively check parent
    return $d7c5fc0cc5e2c136$export$2e2bcd8739ae039(parent, maxLevel - 1, checkedNodes);
}

});
parcelRegister("a2zGi", function(module, exports) {
$parcel$export(module.exports, "default", () => $74f5c4d7a5b314e3$export$2e2bcd8739ae039);
// Helper function to find React fiber on an element
function $74f5c4d7a5b314e3$export$2e2bcd8739ae039(element) {
    // Use for...in loop instead of Object.keys().find() to avoid creating an array
    for(var key in element){
        if (key.startsWith('__reactFiber$') || key.startsWith('__reactInternalInstance$')) return element[key];
    }
    return null;
}

});



parcelRegister("1qNfj", function(module, exports) {
$parcel$export(module.exports, "getMutatedElements", () => $10ae6b5d19e05781$export$c9ea137b0af90c5e);

var $fC8ib = parcelRequire("fC8ib");

var $9Zzpd = parcelRequire("9Zzpd");
function $10ae6b5d19e05781$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $10ae6b5d19e05781$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $10ae6b5d19e05781$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $10ae6b5d19e05781$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $10ae6b5d19e05781$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $10ae6b5d19e05781$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $10ae6b5d19e05781$var$isElementStyledWithDisplayContents(element) {
    var _window2;
    // To minimise calling `getComputedStyle`, we are making an assumption that if an element is from the Entrypoints framework, then it will have `display: contents` styling
    // as per https://bitbucket.org/atlassian/atlassian-frontend-monorepo/src/e4ccf437262ef4c0fd3c651ffb7ad4770b15aed4/jira/src/packages/platform/entry-points/entry-point-placeholder/src/index.tsx#lines-136
    if ((0, $9Zzpd.fg)('platform_ufo_detect_entrypoint_parent')) {
        var _window;
        if (element.hasAttribute('data-ep-placeholder-id')) return true;
        return ((_window = window) === null || _window === void 0 || (_window = _window.getComputedStyle(element)) === null || _window === void 0 ? void 0 : _window.display) === 'contents';
    }
    return ((_window2 = window) === null || _window2 === void 0 || (_window2 = _window2.getComputedStyle(element)) === null || _window2 === void 0 ? void 0 : _window2.display) === 'contents';
}
var $10ae6b5d19e05781$var$MAX_NESTED_LEVELS_OF_DISPLAY_CONTENT_ELEMENTS_HANDLED = 3;
function $10ae6b5d19e05781$export$c9ea137b0af90c5e(element) {
    var depthLevel = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    if ((0, $9Zzpd.fg)('platform_ufo_disable_vcnext_observations')) return [
        {
            element: element,
            isDisplayContentsElementChildren: false
        }
    ];
    if ($10ae6b5d19e05781$var$isElementStyledWithDisplayContents(element)) {
        var mutatedElements = [];
        var nestedDisplayContentsElementChildren = [];
        var _iterator = $10ae6b5d19e05781$var$_createForOfIteratorHelper(element.children), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var child = _step.value;
                if ($10ae6b5d19e05781$var$isElementStyledWithDisplayContents(child)) nestedDisplayContentsElementChildren.push(child);
                mutatedElements.push({
                    element: child,
                    isDisplayContentsElementChildren: true
                });
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
        if (depthLevel < $10ae6b5d19e05781$var$MAX_NESTED_LEVELS_OF_DISPLAY_CONTENT_ELEMENTS_HANDLED && nestedDisplayContentsElementChildren.length > 0) return [].concat(mutatedElements, (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(nestedDisplayContentsElementChildren.map(function(element) {
            return $10ae6b5d19e05781$export$c9ea137b0af90c5e(element, depthLevel + 1);
        }).flat()));
        return mutatedElements;
    } else return [
        {
            element: element,
            isDisplayContentsElementChildren: false
        }
    ];
}

});

parcelRegister("5OR1d", function(module, exports) {
$parcel$export(module.exports, "isElementVisible", () => $43cabfa4de00742b$export$e989c0fffaa6b27a);
function $43cabfa4de00742b$export$e989c0fffaa6b27a(element) {
    if (!(element instanceof HTMLElement)) return true;
    try {
        var visible = element.checkVisibility({
            // @ts-ignore - visibilityProperty may not exist in all TS environments
            visibilityProperty: true,
            contentVisibilityAuto: true,
            opacityProperty: true
        });
        return visible;
    } catch (e) {
        // there is no support for checkVisibility
        return true;
    }
}

});

parcelRegister("73isn", function(module, exports) {
$parcel$export(module.exports, "default", () => $52272152b6de0464$export$2e2bcd8739ae039);
/**
 * Check if the element is in the VC ignore if no layout shift marker.
 * @param element - The element to check.
 * @returns True if the element has the data-vc-ignore-if-no-layout-shift attribute == 'true or its parent has it, false otherwise.
 */ function $52272152b6de0464$export$2e2bcd8739ae039(element) {
    if (!element) return false;
    return element.getAttribute('data-vc-ignore-if-no-layout-shift') === 'true' || $52272152b6de0464$export$2e2bcd8739ae039(element.parentElement);
}

});

parcelRegister("2Y2S2", function(module, exports) {
$parcel$export(module.exports, "isInputNameMutation", () => $2293696ad1b855e9$export$80a5724ceedcfd3d);

var $9Zzpd = parcelRequire("9Zzpd");
function $2293696ad1b855e9$export$80a5724ceedcfd3d(_ref) {
    var target = _ref.target, attributeName = _ref.attributeName, oldValue = _ref.oldValue, newValue = _ref.newValue;
    if (!(0, $9Zzpd.fg)('platform_ufo_ttvc_v4_exclude_input_name_mutation')) return false;
    return target instanceof HTMLInputElement && attributeName === 'name' && (oldValue === '' || newValue === '');
}

});

parcelRegister("8FHmX", function(module, exports) {
$parcel$export(module.exports, "isSameRectDimensions", () => $6503cb4e757c446d$export$fde63bc968551821);
var $6503cb4e757c446d$var$DIMENSIONS_CHECK_TOLERANCE_MARGIN_IN_PX = 1;
function $6503cb4e757c446d$export$fde63bc968551821(a, b) {
    if (!a || !b) return false;
    return Math.abs(a.width - b.width) <= $6503cb4e757c446d$var$DIMENSIONS_CHECK_TOLERANCE_MARGIN_IN_PX && Math.abs(a.height - b.height) <= $6503cb4e757c446d$var$DIMENSIONS_CHECK_TOLERANCE_MARGIN_IN_PX && Math.abs(a.x - b.x) <= $6503cb4e757c446d$var$DIMENSIONS_CHECK_TOLERANCE_MARGIN_IN_PX && Math.abs(a.y - b.y) <= $6503cb4e757c446d$var$DIMENSIONS_CHECK_TOLERANCE_MARGIN_IN_PX;
}

});

parcelRegister("da3Er", function(module, exports) {
$parcel$export(module.exports, "isSameRectSize", () => $994f0a9d66b84b63$export$597b41700f7dcd36);
var $994f0a9d66b84b63$var$SIZE_CHECK_TOLERANCE_MARGIN_IN_PX = 1;
function $994f0a9d66b84b63$export$597b41700f7dcd36(a, b) {
    if (!a || !b) return false;
    return Math.abs(a.width - b.width) <= $994f0a9d66b84b63$var$SIZE_CHECK_TOLERANCE_MARGIN_IN_PX && Math.abs(a.height - b.height) <= $994f0a9d66b84b63$var$SIZE_CHECK_TOLERANCE_MARGIN_IN_PX;
}

});


parcelRegister("i8F2n", function(module, exports) {
$parcel$export(module.exports, "default", () => $d348ce7cce98d0e4$export$2e2bcd8739ae039);

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $25nEq = parcelRequire("25nEq");

var $7QpUe = parcelRequire("7QpUe");
var $d348ce7cce98d0e4$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function WindowEventObserver(opts) {
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, WindowEventObserver);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "unbindFns", []);
        this.onEvent = opts.onEvent;
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(WindowEventObserver, [
        {
            key: "bindEvent",
            value: function bindEvent(type) {
                var _this = this;
                var unbindCallback = (0, $7QpUe.bind)(window, {
                    type: type,
                    listener: function listener(event) {
                        if (!event.isTrusted) return;
                        _this.onEvent({
                            time: event.timeStamp,
                            type: type,
                            event: event
                        });
                    },
                    options: {
                        passive: true,
                        once: true
                    }
                });
                this.unbindFns.push(unbindCallback);
            }
        },
        {
            key: "start",
            value: function start() {
                this.bindEvent('wheel');
                this.bindEvent('scroll');
                this.bindEvent('keydown');
                this.bindEvent('resize');
            }
        },
        {
            key: "stop",
            value: function stop() {
                this.unbindFns.forEach(function(cb) {
                    cb();
                });
                this.unbindFns = [];
            }
        }
    ]);
}();

});



parcelRegister("aNUZN", function(module, exports) {
$parcel$export(module.exports, "interactions", () => $7ddab1203f71ccc7$export$cc97b17ef9aeb088);
var $7ddab1203f71ccc7$export$cc97b17ef9aeb088 = new Map();

});

parcelRegister("ltzs9", function(module, exports) {
$parcel$export(module.exports, "default", () => $fa27cea523e2de43$export$2e2bcd8739ae039);

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $25nEq = parcelRequire("25nEq");

var $avBPK = parcelRequire("avBPK");

var $aNUZN = parcelRequire("aNUZN");

var $iGolp = parcelRequire("iGolp");
function $fa27cea523e2de43$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $fa27cea523e2de43$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $fa27cea523e2de43$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $fa27cea523e2de43$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $fa27cea523e2de43$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function InteractionExtraMetrics() {
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, InteractionExtraMetrics);
        // Store the finished interaction (as non-3p interaction)
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "finishedInteraction", null);
        // independent VC observer, that observes until `custom.post-interaction-logs` event is sent
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "vcObserver", null);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "sinkHandlerFn", function() {});
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(InteractionExtraMetrics, [
        {
            key: "initializeVCObserver",
            value: function initializeVCObserver(options) {
                this.vcObserver = new (0, $avBPK.VCObserverWrapper)($fa27cea523e2de43$var$_objectSpread($fa27cea523e2de43$var$_objectSpread({}, options), {}, {
                    isPostInteraction: true
                }));
            }
        },
        {
            key: "startVCObserver",
            value: function startVCObserver(_ref, interactionId) {
                var startTime = _ref.startTime;
                if (this.eligibleToMeasure(interactionId)) {
                    var _this$vcObserver;
                    (_this$vcObserver = this.vcObserver) === null || _this$vcObserver === void 0 || _this$vcObserver.start({
                        startTime: startTime
                    });
                }
            }
        },
        {
            key: "stopVCObserver",
            value: function stopVCObserver() {
                var _this$vcObserver2;
                (_this$vcObserver2 = this.vcObserver) === null || _this$vcObserver2 === void 0 || _this$vcObserver2.stop();
            }
        },
        {
            key: "eligibleToMeasure",
            value: function eligibleToMeasure(interactionId) {
                var interaction = (0, $aNUZN.interactions).get(interactionId);
                return (interaction === null || interaction === void 0 ? void 0 : interaction.type) === 'page_load' || (interaction === null || interaction === void 0 ? void 0 : interaction.type) === 'transition';
            }
        },
        {
            key: "updateFinishedInteraction",
            value: function updateFinishedInteraction(interaction) {
                if ((interaction === null || interaction === void 0 ? void 0 : interaction.type) === 'page_load' || (interaction === null || interaction === void 0 ? void 0 : interaction.type) === 'transition') this.finishedInteraction = interaction;
            }
        },
        {
            key: "setLastInteractionFinishVCResult",
            value: function setLastInteractionFinishVCResult(result) {
                this.lastInteractionFinishVCResult = result;
            }
        },
        {
            key: "sinkHandler",
            value: function sinkHandler(fn) {
                this.sinkHandlerFn = fn;
            }
        },
        {
            key: "onInteractionComplete",
            value: function onInteractionComplete(id, data) {
                if (data.ufoName) {
                    var _this$vcObserver3;
                    var updatedData = $fa27cea523e2de43$var$_objectSpread($fa27cea523e2de43$var$_objectSpread({}, data), {}, {
                        vcObserver: (_this$vcObserver3 = this.vcObserver) !== null && _this$vcObserver3 !== void 0 ? _this$vcObserver3 : undefined
                    });
                    this.sinkHandlerFn(id, updatedData, this.finishedInteraction, this.lastInteractionFinishVCResult);
                }
                this.stopVCObserver();
                (0, $iGolp.remove)(id);
                this.reset();
            }
        },
        {
            key: "reset",
            value: function reset() {
                var _this$finishedInterac;
                this.stopVCObserver();
                if ((_this$finishedInterac = this.finishedInteraction) !== null && _this$finishedInterac !== void 0 && _this$finishedInterac.id) (0, $iGolp.remove)(this.finishedInteraction.id);
                this.finishedInteraction = null;
                this.lastInteractionFinishVCResult = undefined;
            }
        },
        {
            key: "stopAll",
            value: function stopAll(id) {
                (0, $iGolp.remove)(id);
                this.reset();
            }
        }
    ]);
}();

});

parcelRegister("78Mn6", function(module, exports) {
$parcel$export(module.exports, "default", () => $532ecd5f82496f95$export$2e2bcd8739ae039);

var $fL8KA = parcelRequire("fL8KA");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $25nEq = parcelRequire("25nEq");

var $6HG4S = parcelRequire("6HG4S");

var $9Zzpd = parcelRequire("9Zzpd");

var $DtLwq = parcelRequire("DtLwq");

var $h9fNq = parcelRequire("h9fNq");

var $avBPK = parcelRequire("avBPK");
function $532ecd5f82496f95$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $532ecd5f82496f95$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $532ecd5f82496f95$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $532ecd5f82496f95$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $532ecd5f82496f95$var$POST_INTERACTION_LOG_SEND_DEFAULT_TIMEOUT = 3000;
var $532ecd5f82496f95$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function PostInteractionLog() {
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, PostInteractionLog);
        /**
     * Basic info about interaction that has just finished
     */ (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "lastInteractionFinish", null);
        /**
     * Array of observed react render timings
     */ (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "reactProfilerTimings", []);
        /**
     * Store the scheduled sink timeout Id so that it can be cancelled when needed
     */ (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "sinkTimeoutId", null);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "holdInfo", []);
        /**
     * independent VC observer, that observes until `custom.post-interaction-logs` event is sent
     */ (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "vcObserver", null);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "vcObserverSSRConfig", null);
        /**
     * Handler function to process / send the observation data
     */ (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "sinkHandlerFn", function() {});
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(PostInteractionLog, [
        {
            key: "initializeVCObserver",
            value: function initializeVCObserver(options) {
                this.vcObserver = new (0, $avBPK.VCObserverWrapper)($532ecd5f82496f95$var$_objectSpread($532ecd5f82496f95$var$_objectSpread({}, options), {}, {
                    isPostInteraction: true
                }));
            }
        },
        {
            key: "startVCObserver",
            value: function startVCObserver(_ref) {
                var _this$vcObserver;
                var startTime = _ref.startTime;
                (_this$vcObserver = this.vcObserver) === null || _this$vcObserver === void 0 || _this$vcObserver.start({
                    startTime: startTime
                });
            }
        },
        {
            key: "stopVCObserver",
            value: function stopVCObserver() {
                var _this$vcObserver2;
                (_this$vcObserver2 = this.vcObserver) === null || _this$vcObserver2 === void 0 || _this$vcObserver2.stop();
            }
        },
        {
            key: "setVCObserverSSRConfig",
            value: function setVCObserverSSRConfig(vcObserverSSRConfig) {
                this.vcObserverSSRConfig = vcObserverSSRConfig;
            }
        },
        {
            key: "setLastInteractionFinishVCResult",
            value: function setLastInteractionFinishVCResult(result) {
                this.lastInteractionFinishVCResult = result;
            }
        },
        {
            key: "sinkHandler",
            value: /**
     * Set the fn that would be invoked to process / send the observation data
     */ function sinkHandler(sinkHandlerFn) {
                this.sinkHandlerFn = sinkHandlerFn;
            }
        },
        {
            key: "reset",
            value: function reset() {
                this.lastInteractionFinish = null;
                this.reactProfilerTimings = [];
                this.holdInfo = [];
                if (this.sinkTimeoutId != null) {
                    clearTimeout(this.sinkTimeoutId);
                    this.sinkTimeoutId = null;
                }
                this.setVCObserverSSRConfig(null);
            }
        },
        {
            key: "hasData",
            value: function hasData() {
                var _this$reactProfilerTi;
                return ((_this$reactProfilerTi = this.reactProfilerTimings) === null || _this$reactProfilerTi === void 0 ? void 0 : _this$reactProfilerTi.length) > 0;
            }
        },
        {
            key: "sendPostInteractionLog",
            value: function() {
                var _sendPostInteractionLog = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee() {
                    var _this$vcObserver4, _config$vc, _config$vc2, _this$vcObserver5;
                    var _this$vcObserver3, pageVisibilityState, isPageVisible, config, postInteractionFinishVCResult;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee$(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                if (!(!this.lastInteractionFinish || !this.sinkHandlerFn || !this.hasData() && !(0, $9Zzpd.fg)('platform_ufo_always_send_post_interaction_log'))) {
                                    _context.next = 4;
                                    break;
                                }
                                this.reset();
                                (_this$vcObserver3 = this.vcObserver) === null || _this$vcObserver3 === void 0 || _this$vcObserver3.stop();
                                return _context.abrupt("return");
                            case 4:
                                pageVisibilityState = (0, $h9fNq.getPageVisibilityState)(this.lastInteractionFinish.start, this.lastInteractionFinish.end);
                                isPageVisible = pageVisibilityState === 'visible';
                                config = (0, $DtLwq.getConfig)();
                                _context.next = 9;
                                return (_this$vcObserver4 = this.vcObserver) === null || _this$vcObserver4 === void 0 ? void 0 : _this$vcObserver4.getVCResult($532ecd5f82496f95$var$_objectSpread($532ecd5f82496f95$var$_objectSpread({
                                    start: this.lastInteractionFinish.start,
                                    stop: performance.now(),
                                    tti: -1,
                                    // no need for TTI value here
                                    isEventAborted: !!this.lastInteractionFinish.abortReason,
                                    prefix: 'ufo',
                                    experienceKey: this.lastInteractionFinish.ufoName,
                                    interactionId: this.lastInteractionFinish.id,
                                    includeSSRInV3: config === null || config === void 0 || (_config$vc = config.vc) === null || _config$vc === void 0 ? void 0 : _config$vc.includeSSRInV3,
                                    includeSSRRatio: config === null || config === void 0 || (_config$vc2 = config.vc) === null || _config$vc2 === void 0 ? void 0 : _config$vc2.includeSSRRatio
                                }, this.vcObserverSSRConfig), {}, {
                                    interactionType: this.lastInteractionFinish.type,
                                    isPageVisible: isPageVisible,
                                    interactionAbortReason: this.lastInteractionFinish.abortReason
                                }));
                            case 9:
                                postInteractionFinishVCResult = _context.sent;
                                (_this$vcObserver5 = this.vcObserver) === null || _this$vcObserver5 === void 0 || _this$vcObserver5.stop();
                                this.sinkHandlerFn({
                                    lastInteractionFinish: this.lastInteractionFinish,
                                    reactProfilerTimings: this.reactProfilerTimings,
                                    postInteractionFinishVCResult: postInteractionFinishVCResult,
                                    lastInteractionFinishVCResult: this.lastInteractionFinishVCResult,
                                    postInteractionHoldInfo: this.holdInfo
                                });
                                this.reset();
                            case 13:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee, this);
                }));
                function sendPostInteractionLog() {
                    return _sendPostInteractionLog.apply(this, arguments);
                }
                return sendPostInteractionLog;
            }()
        },
        {
            key: "onInteractionComplete",
            value: function onInteractionComplete(_ref2) {
                var _getConfig, _this = this;
                var ufoName = _ref2.ufoName, start = _ref2.start, end = _ref2.end, id = _ref2.id, abortReason = _ref2.abortReason, abortedByInteractionName = _ref2.abortedByInteractionName, routeName = _ref2.routeName, type = _ref2.type, experimentalTTAI = _ref2.experimentalTTAI, experimentalVC90 = _ref2.experimentalVC90, errors = _ref2.errors;
                this.lastInteractionFinish = {
                    ufoName: ufoName,
                    start: start,
                    end: end,
                    id: id,
                    abortReason: abortReason,
                    abortedByInteractionName: abortedByInteractionName,
                    routeName: routeName,
                    type: type,
                    experimentalTTAI: experimentalTTAI,
                    experimentalVC90: experimentalVC90,
                    errors: errors
                };
                var timeout = ((_getConfig = (0, $DtLwq.getConfig)()) === null || _getConfig === void 0 ? void 0 : _getConfig.timeWindowForLateMutationsInMilliseconds) || $532ecd5f82496f95$var$POST_INTERACTION_LOG_SEND_DEFAULT_TIMEOUT;
                this.sinkTimeoutId = window.setTimeout(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee2() {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee2$(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                _context2.next = 2;
                                return _this.sendPostInteractionLog();
                            case 2:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2);
                })), timeout);
            }
        },
        {
            key: "addProfilerTimings",
            value: function addProfilerTimings(labelStack, type, actualDuration, baseDuration, startTime, commitTime) {
                if (this.lastInteractionFinish != null) this.reactProfilerTimings.push({
                    type: type,
                    actualDuration: actualDuration,
                    baseDuration: baseDuration,
                    startTime: startTime,
                    commitTime: commitTime,
                    labelStack: labelStack
                });
            }
        },
        {
            key: "addHoldInfo",
            value: function addHoldInfo(labelStack, name, start) {
                this.holdInfo.push({
                    name: name,
                    labelStack: labelStack,
                    start: start
                });
            }
        }
    ]);
}();

});


parcelRegister("6SIfU", function(module, exports) {
$parcel$export(module.exports, "default", () => $502a1d7bcb430ca7$export$2e2bcd8739ae039);
// The UFORouteName object is a global singleton
var $502a1d7bcb430ca7$var$UFORouteName = {
    current: null
};
var $502a1d7bcb430ca7$export$2e2bcd8739ae039 = $502a1d7bcb430ca7$var$UFORouteName;

});

parcelRegister("1F1of", function(module, exports) {
$parcel$export(module.exports, "default", () => $135ab2cf931f05a8$export$2e2bcd8739ae039);
function $135ab2cf931f05a8$var$generateId() {
    var length = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 7;
    var characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    var result = '';
    for(var i = 0; i < length; i++)result += characters.charAt(Math.floor(Math.random() * characters.length));
    return result;
}
var $135ab2cf931f05a8$export$2e2bcd8739ae039 = $135ab2cf931f05a8$var$generateId;

});

parcelRegister("3JJ0b", function(module, exports) {
$parcel$export(module.exports, "default", () => $2b887b82eb4e13cf$export$2e2bcd8739ae039);
function $2b887b82eb4e13cf$var$scheduleOnPaint(callback) {
    var _globalThis$document;
    if (((_globalThis$document = globalThis.document) === null || _globalThis$document === void 0 ? void 0 : _globalThis$document.visibilityState) !== 'visible') {
        // last resort fallback
        setTimeout(callback, 100);
        return;
    }
    // Check if the Scheduler API is available
    if (typeof window.scheduler !== 'undefined' && typeof window.scheduler.postTask === 'function') // Use scheduler.postTask if available
    // https://developer.mozilla.org/en-US/docs/Web/API/Prioritized_Task_Scheduling_API
    // Make sure we are scheduling this task before the browser paint the next frame
    requestAnimationFrame(function() {
        window.scheduler.postTask(callback, {
            priority: 'user-visible'
        });
    });
    else if (typeof requestAnimationFrame !== 'undefined') // Fallback to using double requestAnimationFrame
    requestAnimationFrame(function() {
        requestAnimationFrame(function() {
            callback();
        });
    });
}
var $2b887b82eb4e13cf$export$2e2bcd8739ae039 = $2b887b82eb4e13cf$var$scheduleOnPaint;

});

parcelRegister("3DeKi", function(module, exports) {
$parcel$export(module.exports, "default", () => $2a5073c8f6e4a278$export$2e2bcd8739ae039);

var $5FkrB = parcelRequire("5FkrB");

var $iGolp = parcelRequire("iGolp");

var $3ZMUU = parcelRequire("3ZMUU");
var $2a5073c8f6e4a278$var$_process;
// These are stored outside react context to be resilient to concurrent mode
// restarting the start marker from a suspense and losing the initial render
var $2a5073c8f6e4a278$var$startTimes = new Map();
// Keep track of the last interaction id and reset the start timers if it ever changes.
// This is to allow multi-step ssr to track the render timers from different "interaction"s seperately
var $2a5073c8f6e4a278$var$lastActiveInteraction;
function $2a5073c8f6e4a278$var$checkActiveInteractionAndResetStartMarksIfSet() {
    var _getActiveInteraction;
    var activeInteractionId = (_getActiveInteraction = (0, $iGolp.getActiveInteraction)()) === null || _getActiveInteraction === void 0 ? void 0 : _getActiveInteraction.id;
    if (!!$2a5073c8f6e4a278$var$lastActiveInteraction && $2a5073c8f6e4a278$var$lastActiveInteraction !== activeInteractionId) $2a5073c8f6e4a278$var$startTimes.clear();
    $2a5073c8f6e4a278$var$lastActiveInteraction = activeInteractionId;
}
var $2a5073c8f6e4a278$var$onStartRender = function onStartRender(id) {
    var _startTimes$get;
    if (!$2a5073c8f6e4a278$var$startTimes.has(id)) $2a5073c8f6e4a278$var$startTimes.set(id, []);
    (_startTimes$get = $2a5073c8f6e4a278$var$startTimes.get(id)) === null || _startTimes$get === void 0 || _startTimes$get.push(performance.now());
};
var $2a5073c8f6e4a278$var$isInSSR = Boolean(globalThis === null || globalThis === void 0 ? void 0 : globalThis.__SERVER__) || typeof $3ZMUU !== 'undefined' && Boolean((($2a5073c8f6e4a278$var$_process = $3ZMUU) === null || $2a5073c8f6e4a278$var$_process === void 0 || ($2a5073c8f6e4a278$var$_process = $2a5073c8f6e4a278$var$_process.env) === null || $2a5073c8f6e4a278$var$_process === void 0 ? void 0 : $2a5073c8f6e4a278$var$_process.REACT_SSR) || false);
var $2a5073c8f6e4a278$var$ProfilerMarker = function ProfilerMarker(_ref) {
    var onRender = _ref.onRender;
    if ($2a5073c8f6e4a278$var$isInSSR) onRender === null || onRender === void 0 || onRender();
    return null;
};
var $2a5073c8f6e4a278$export$b8bd105b650b1c1e = function SsrRenderProfilerInner(_ref2) {
    var children = _ref2.children, labelStack = _ref2.labelStack, _onRender = _ref2.onRender;
    var reactProfilerId = (0, $5FkrB.useMemo)(function() {
        return labelStack.map(function(l) {
            return l.name;
        }).join('/');
    }, [
        labelStack
    ]);
    $2a5073c8f6e4a278$var$checkActiveInteractionAndResetStartMarksIfSet();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement($2a5073c8f6e4a278$var$ProfilerMarker, {
        onRender: function onRender() {
            return $2a5073c8f6e4a278$var$onStartRender(reactProfilerId);
        }
    }), children, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement($2a5073c8f6e4a278$var$ProfilerMarker, {
        onRender: function onRender() {
            var startTimesForId = $2a5073c8f6e4a278$var$startTimes.get(reactProfilerId);
            if (startTimesForId !== null && startTimesForId !== void 0 && startTimesForId.length) {
                var endTime = performance.now();
                var firstStartTime = startTimesForId[0];
                var lastStartTime = startTimesForId[startTimesForId.length - 1];
                var baseDuration = endTime - lastStartTime;
                var actualDuration = endTime - firstStartTime;
                _onRender('mount', // this is incorrect, but on the server there is no mount phase
                actualDuration, baseDuration, firstStartTime, endTime);
            }
        }
    }));
};
var $2a5073c8f6e4a278$var$SsrRenderProfiler = function SsrRenderProfiler(props) {
    if ($2a5073c8f6e4a278$var$isInSSR) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement($2a5073c8f6e4a278$export$b8bd105b650b1c1e, props);
    // ensure structure similar to SSR implementation
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement($2a5073c8f6e4a278$var$ProfilerMarker, null), props.children);
};
var $2a5073c8f6e4a278$export$2e2bcd8739ae039 = $2a5073c8f6e4a278$var$SsrRenderProfiler;

});



parcelRegister("fiGqm", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2156d9d42c2a1cee4be11481dce76dec>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b2397203659facc5$var$_react = $b2397203659facc5$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $b2397203659facc5$var$_baseNew = $b2397203659facc5$var$_interopRequireDefault((parcelRequire("axuVY")));
function $b2397203659facc5$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ArrowLeft".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: back to previous screen, previous slide.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $b2397203659facc5$var$ArrowLeftIcon = (props)=>/*#__PURE__*/ $b2397203659facc5$var$_react.default.createElement($b2397203659facc5$var$_baseNew.default, Object.assign({
        name: "ArrowLeftIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="m1.22 7.47 5-5 1.06 1.06-3.72 3.72H15v1.5H3.56l3.72 3.72-1.06 1.06-5-5a.75.75 0 0 1 0-1.06" clip-rule="evenodd"/>`
    }, props));
$b2397203659facc5$var$ArrowLeftIcon.displayName = 'ArrowLeftIcon';
var $b2397203659facc5$var$_default = module.exports.default = $b2397203659facc5$var$ArrowLeftIcon;

});

parcelRegister("kYLlQ", function(module, exports) {
$parcel$export(module.exports, "getSchemaBasedOnStage", () => $f45e243dc5cc7973$export$fd147e7d448dea03);
$parcel$export(module.exports, "defaultSchema", () => $f45e243dc5cc7973$export$1db618b7b2275ea1);

var $cvlyC = parcelRequire("cvlyC");

var $4eHHu = parcelRequire("4eHHu");
var $5vwuc = parcelRequire("5vwuc");
var $d79nc = parcelRequire("d79nc");
var $2Ji8g = parcelRequire("2Ji8g");
var $gc8Zd = parcelRequire("gc8Zd");

var $jImCY = parcelRequire("jImCY");
var $f45e243dc5cc7973$var$getDefaultSchemaConfig = function getDefaultSchemaConfig() {
    var defaultSchemaConfig = {
        nodes: [
            'doc',
            'paragraph',
            'text',
            'bulletList',
            'orderedList',
            'listItem',
            'heading',
            'blockquote',
            'codeBlock',
            'panel',
            'rule',
            'image',
            'caption',
            'mention',
            'media',
            'mediaGroup',
            'mediaSingle',
            'mediaInline',
            'confluenceUnsupportedBlock',
            'confluenceUnsupportedInline',
            'confluenceJiraIssue',
            'expand',
            'nestedExpand',
            'extension',
            'inlineExtension',
            'bodiedExtension',
            'hardBreak',
            'emoji',
            'table',
            'tableCell',
            'tableHeader',
            'tableRow',
            'decisionList',
            'decisionItem',
            'taskList',
            'taskItem',
            'blockTaskItem',
            'unknownBlock',
            'date',
            'status',
            'placeholder',
            'layoutSection',
            'layoutColumn',
            'inlineCard',
            'blockCard',
            'embedCard',
            'syncBlock',
            'bodiedSyncBlock',
            'unsupportedBlock',
            'unsupportedInline'
        ],
        marks: [
            'link',
            'em',
            'strong',
            'strike',
            'subsup',
            'underline',
            'code',
            'textColor',
            'backgroundColor',
            'confluenceInlineComment',
            'breakout',
            'alignment',
            'indentation',
            'annotation',
            'dataConsumer',
            'border',
            'unsupportedMark',
            'unsupportedNodeAttribute',
            'typeAheadQuery',
            // https://product-fabric.atlassian.net/browse/ED-10214,
            'fragment'
        ]
    };
    return defaultSchemaConfig;
};
var $f45e243dc5cc7973$export$e4e3ac1fa64862db = $f45e243dc5cc7973$var$getDefaultSchemaConfig();
var $f45e243dc5cc7973$export$fd147e7d448dea03 = (0, $cvlyC.default)(function() {
    var stage = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'final';
    var defaultSchemaConfig = $f45e243dc5cc7973$var$getDefaultSchemaConfig();
    if (stage === 'stage0') defaultSchemaConfig.customNodeSpecs = {
        layoutSection: (0, $d79nc.layoutSectionWithSingleColumn),
        multiBodiedExtension: (0, $5vwuc.multiBodiedExtension),
        extensionFrame: (0, $5vwuc.extensionFrame),
        expand: (0, $4eHHu.expandWithNestedExpand),
        listItem: (0, $2Ji8g.listItemWithDecisionStage0),
        table: (0, $gc8Zd.tableWithNestedTable),
        tableRow: (0, $gc8Zd.tableRowWithNestedTable),
        tableCell: (0, $gc8Zd.tableCellWithNestedTable),
        tableHeader: (0, $gc8Zd.tableHeaderWithNestedTable)
    };
    return (0, $jImCY.createSchema)(defaultSchemaConfig);
});
var $f45e243dc5cc7973$export$1db618b7b2275ea1 = $f45e243dc5cc7973$export$fd147e7d448dea03();

});
parcelRegister("4eHHu", function(module, exports) {
$parcel$export(module.exports, "expandWithNestedExpand", () => $315a5e3d88924979$export$7b80cba28d10b2c1);
$parcel$export(module.exports, "toJSON", () => $315a5e3d88924979$export$54fd2c36b5cc6731);

var $25nEq = parcelRequire("25nEq");

var $2gWGi = parcelRequire("2gWGi");

var $l4823 = parcelRequire("l4823");
function $315a5e3d88924979$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $315a5e3d88924979$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $315a5e3d88924979$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $315a5e3d88924979$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
/**
 * @name expand_node
 */ /**
 * @name expand_with_no_mark_node
 */ /**
 * @name expand_root_only_node
 */ function $315a5e3d88924979$var$getExpandAttrs(domNode) {
    var dom = domNode;
    return {
        title: dom.getAttribute('data-title'),
        __expanded: true
    };
}
var $315a5e3d88924979$var$nodeSpecOptions = {
    parseDOM: [
        {
            context: 'table//',
            tag: 'div[data-node-type="expand"]',
            getAttrs: $315a5e3d88924979$var$getExpandAttrs
        },
        {
            context: 'expand//',
            tag: '[data-node-type="expand"]',
            getAttrs: $315a5e3d88924979$var$getExpandAttrs
        },
        {
            context: 'nestedExpand//',
            tag: '[data-node-type="expand"]',
            getAttrs: $315a5e3d88924979$var$getExpandAttrs
        },
        {
            tag: '[data-node-type="nestedExpand"] button',
            ignore: true
        },
        {
            tag: '[data-node-type="expand"] button',
            ignore: true
        },
        {
            tag: 'div[data-node-type="expand"]',
            getAttrs: $315a5e3d88924979$var$getExpandAttrs
        }
    ],
    toDOM: function toDOM(node) {
        var attrs = {
            'data-node-type': 'expand',
            'data-title': node.attrs.title,
            'data-expanded': node.attrs.__expanded
        };
        return [
            'div',
            attrs,
            0
        ];
    }
};
var $315a5e3d88924979$export$7b80cba28d10b2c1 = (0, $2gWGi.expand)($315a5e3d88924979$var$nodeSpecOptions);
var $315a5e3d88924979$export$2ae5e7565ff9ffa6 = (0, $2gWGi.expand)({
    parseDOM: [
        {
            context: 'table//',
            tag: 'div[data-node-type="expand"]',
            getAttrs: function getAttrs(dom) {
                var attrs = $315a5e3d88924979$var$getExpandAttrs(dom);
                return $315a5e3d88924979$var$_objectSpread($315a5e3d88924979$var$_objectSpread({}, attrs), {}, {
                    localId: (0, $l4823.uuid).generate()
                });
            }
        },
        {
            context: 'expand//',
            tag: '[data-node-type="expand"]',
            getAttrs: function getAttrs(dom) {
                var attrs = $315a5e3d88924979$var$getExpandAttrs(dom);
                return $315a5e3d88924979$var$_objectSpread($315a5e3d88924979$var$_objectSpread({}, attrs), {}, {
                    localId: (0, $l4823.uuid).generate()
                });
            }
        },
        {
            context: 'nestedExpand//',
            tag: '[data-node-type="expand"]',
            getAttrs: function getAttrs(dom) {
                var attrs = $315a5e3d88924979$var$getExpandAttrs(dom);
                return $315a5e3d88924979$var$_objectSpread($315a5e3d88924979$var$_objectSpread({}, attrs), {}, {
                    localId: (0, $l4823.uuid).generate()
                });
            }
        },
        {
            tag: '[data-node-type="nestedExpand"] button',
            ignore: true
        },
        {
            tag: '[data-node-type="expand"] button',
            ignore: true
        },
        {
            tag: 'div[data-node-type="expand"]',
            getAttrs: function getAttrs(dom) {
                var attrs = $315a5e3d88924979$var$getExpandAttrs(dom);
                return $315a5e3d88924979$var$_objectSpread($315a5e3d88924979$var$_objectSpread({}, attrs), {}, {
                    localId: (0, $l4823.uuid).generate()
                });
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node$attrs;
        var attrs = {
            'data-node-type': 'expand',
            'data-title': node.attrs.title,
            'data-expanded': node.attrs.__expanded,
            'data-local-id': (node === null || node === void 0 ? void 0 : (_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.localId) || undefined
        };
        return [
            'div',
            attrs,
            0
        ];
    }
});
var $315a5e3d88924979$export$54fd2c36b5cc6731 = function toJSON(node) {
    return {
        attrs: Object.keys(node.attrs).filter(function(key) {
            return !key.startsWith('__');
        }).reduce(function(obj, key) {
            return $315a5e3d88924979$var$_objectSpread($315a5e3d88924979$var$_objectSpread({}, obj), {}, (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, key, node.attrs[key]));
        }, {})
    };
};

});
parcelRegister("2gWGi", function(module, exports) {
$parcel$export(module.exports, "blockCard", () => $1a7a9844253df8d3$export$c4c2f833baaebdb8);
$parcel$export(module.exports, "blockquote", () => $1a7a9844253df8d3$export$67dc04e652a298ca);
$parcel$export(module.exports, "blockquoteLegacy", () => $1a7a9844253df8d3$export$199922e5af8e9a6);
$parcel$export(module.exports, "blockTaskItem", () => $1a7a9844253df8d3$export$16018c61064a18df);
$parcel$export(module.exports, "bodiedExtension", () => $1a7a9844253df8d3$export$27903d543b563e39);
$parcel$export(module.exports, "bodiedSyncBlock", () => $1a7a9844253df8d3$export$e92c7e4302dd4371);
$parcel$export(module.exports, "bulletList", () => $1a7a9844253df8d3$export$a140c94e5ea26bee);
$parcel$export(module.exports, "caption", () => $1a7a9844253df8d3$export$8e3c2dfdc4f0453d);
$parcel$export(module.exports, "codeBlock", () => $1a7a9844253df8d3$export$7bb0d5c671655cc4);
$parcel$export(module.exports, "confluenceJiraIssue", () => $1a7a9844253df8d3$export$daf889beb5092f95);
$parcel$export(module.exports, "confluenceUnsupportedBlock", () => $1a7a9844253df8d3$export$e6e4878f43c27cab);
$parcel$export(module.exports, "confluenceUnsupportedInline", () => $1a7a9844253df8d3$export$3e6d667072febc87);
$parcel$export(module.exports, "date", () => $1a7a9844253df8d3$export$324d90190a8b822a);
$parcel$export(module.exports, "decisionItem", () => $1a7a9844253df8d3$export$6959e16eeff859b4);
$parcel$export(module.exports, "decisionList", () => $1a7a9844253df8d3$export$62d45a65fb43d95e);
$parcel$export(module.exports, "doc", () => $1a7a9844253df8d3$export$2a111da947c407d2);
$parcel$export(module.exports, "embedCard", () => $1a7a9844253df8d3$export$be4283d9a1cb1ff6);
$parcel$export(module.exports, "emoji", () => $1a7a9844253df8d3$export$a19185d1233fc4b2);
$parcel$export(module.exports, "expand", () => $1a7a9844253df8d3$export$9f77e0932fb78f72);
$parcel$export(module.exports, "extension", () => $1a7a9844253df8d3$export$1b45514b112dd749);
$parcel$export(module.exports, "extensionFrameStage0", () => $1a7a9844253df8d3$export$b555be60c7703afb);
$parcel$export(module.exports, "hardBreak", () => $1a7a9844253df8d3$export$371da9dd35aba193);
$parcel$export(module.exports, "heading", () => $1a7a9844253df8d3$export$46e4a324ac90507f);
$parcel$export(module.exports, "image", () => $1a7a9844253df8d3$export$5c452ff88e35e47d);
$parcel$export(module.exports, "inlineCard", () => $1a7a9844253df8d3$export$cbf8224b64e0d942);
$parcel$export(module.exports, "inlineExtensionWithMarks", () => $1a7a9844253df8d3$export$b3b1e36c2105006d);
$parcel$export(module.exports, "layoutColumn", () => $1a7a9844253df8d3$export$ab76e7c03cd6f650);
$parcel$export(module.exports, "layoutSection", () => $1a7a9844253df8d3$export$b3b6a70a7fa4a5be);
$parcel$export(module.exports, "layoutSectionFull", () => $1a7a9844253df8d3$export$cdae19acb0a520fd);
$parcel$export(module.exports, "layoutSectionWithSingleColumnStage0", () => $1a7a9844253df8d3$export$206007566ca0aca5);
$parcel$export(module.exports, "listItem", () => $1a7a9844253df8d3$export$76c7e83ecc9cdf05);
$parcel$export(module.exports, "listItemWithNestedDecisionStage0", () => $1a7a9844253df8d3$export$df876f0305235056);
$parcel$export(module.exports, "media", () => $1a7a9844253df8d3$export$987d49ffe1b0900f);
$parcel$export(module.exports, "mediaGroup", () => $1a7a9844253df8d3$export$2855e964765eac9);
$parcel$export(module.exports, "mediaInline", () => $1a7a9844253df8d3$export$38bab695e3f720f1);
$parcel$export(module.exports, "mediaSingle", () => $1a7a9844253df8d3$export$969fe3781ca15058);
$parcel$export(module.exports, "mediaSingleCaption", () => $1a7a9844253df8d3$export$8d067f22dc2d1254);
$parcel$export(module.exports, "mediaSingleFull", () => $1a7a9844253df8d3$export$7e767666f2ce108a);
$parcel$export(module.exports, "mediaSingleWidthType", () => $1a7a9844253df8d3$export$4bd9a38995f6bf50);
$parcel$export(module.exports, "mention", () => $1a7a9844253df8d3$export$db83999c14438df4);
$parcel$export(module.exports, "multiBodiedExtensionStage0", () => $1a7a9844253df8d3$export$750e45819f66d9d0);
$parcel$export(module.exports, "nestedExpand", () => $1a7a9844253df8d3$export$63cadbf5f4296627);
$parcel$export(module.exports, "orderedList", () => $1a7a9844253df8d3$export$a5dc81035676e7a);
$parcel$export(module.exports, "panel", () => $1a7a9844253df8d3$export$21f42ab9b6679f44);
$parcel$export(module.exports, "paragraph", () => $1a7a9844253df8d3$export$9c206ddddb32a9b);
$parcel$export(module.exports, "placeholder", () => $1a7a9844253df8d3$export$c7187bbd1a7a9244);
$parcel$export(module.exports, "rule", () => $1a7a9844253df8d3$export$fbeb3a3956e8a3c7);
$parcel$export(module.exports, "status", () => $1a7a9844253df8d3$export$471f7ae5c4103ae1);
$parcel$export(module.exports, "syncBlock", () => $1a7a9844253df8d3$export$faab0ca9701d7048);
$parcel$export(module.exports, "table", () => $1a7a9844253df8d3$export$9852986a3ec5f6a0);
$parcel$export(module.exports, "tableWithNestedTable", () => $1a7a9844253df8d3$export$ce086a560a1d05f5);
$parcel$export(module.exports, "tableCell", () => $1a7a9844253df8d3$export$e1e720e5f4603e6a);
$parcel$export(module.exports, "tableCellWithNestedTable", () => $1a7a9844253df8d3$export$abf39ca178940ff3);
$parcel$export(module.exports, "tableHeader", () => $1a7a9844253df8d3$export$48884d2a5190dc73);
$parcel$export(module.exports, "tableHeaderWithNestedTable", () => $1a7a9844253df8d3$export$2a5a518232fa1a97);
$parcel$export(module.exports, "tableRow", () => $1a7a9844253df8d3$export$ce666bf02318c957);
$parcel$export(module.exports, "tableRowWithNestedTable", () => $1a7a9844253df8d3$export$7d657479499397);
$parcel$export(module.exports, "taskItem", () => $1a7a9844253df8d3$export$6d8b0ef52e2e6390);
$parcel$export(module.exports, "taskList", () => $1a7a9844253df8d3$export$375b6afcc5f4d291);
$parcel$export(module.exports, "text", () => $1a7a9844253df8d3$export$6f093cfa640b7166);
$parcel$export(module.exports, "unsupportedBlock", () => $1a7a9844253df8d3$export$44b79b0979d0f0f7);
$parcel$export(module.exports, "unsupportedInline", () => $1a7a9844253df8d3$export$310ebe0d80122e9b);
/**
 * This file was automatically generated by @atlaskit/adf-schema-generator
 * DO NOT MODIFY IT BY HAND. Instead, modify the source files in "packages/adf-schema/src/next-schema" ,
 * and run "yarn workspace @atlaskit/adf-schema build:schema:all" to regenerate this file.
 */ 
var $hGaoB = parcelRequire("hGaoB");
var $1a7a9844253df8d3$export$c4c2f833baaebdb8 = (0, $hGaoB.createPMNodeSpecFactory)({
    group: 'block',
    attrs: {
        localId: {
            default: null
        },
        url: {
            default: null
        },
        datasource: {
            default: null
        },
        width: {
            default: null
        },
        layout: {
            default: null
        },
        data: {
            default: null
        }
    },
    selectable: true,
    draggable: true
});
var $1a7a9844253df8d3$export$67dc04e652a298ca = (0, $hGaoB.createPMNodeSpecFactory)({
    content: '(paragraph | orderedList | bulletList | unsupportedBlock | codeBlock | mediaSingle | mediaGroup | extension)+',
    marks: 'unsupportedMark unsupportedNodeAttribute dataConsumer fragment',
    group: 'block',
    attrs: {
        localId: {
            default: null
        }
    },
    selectable: true,
    defining: true
});
var $1a7a9844253df8d3$export$199922e5af8e9a6 = (0, $hGaoB.createPMNodeSpecFactory)({
    content: '(paragraph | unsupportedBlock)+',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    attrs: {
        localId: {
            default: null
        }
    },
    selectable: true,
    defining: true
});
var $1a7a9844253df8d3$export$16018c61064a18df = (0, $hGaoB.createPMNodeSpecFactory)({
    content: '(paragraph | extension) (paragraph | extension)*',
    marks: 'dataConsumer fragment unsupportedMark unsupportedNodeAttribute',
    attrs: {
        localId: {
            default: ''
        },
        state: {
            default: 'TODO'
        }
    },
    selectable: false,
    defining: true
});
var $1a7a9844253df8d3$export$27903d543b563e39 = (0, $hGaoB.createPMNodeSpecFactory)({
    content: '(paragraph | panel | blockquote | orderedList | bulletList | rule | heading | codeBlock | mediaGroup | mediaSingle | decisionList | taskList | table | blockCard | embedCard | extension | unsupportedBlock)+',
    marks: 'dataConsumer fragment unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    attrs: {
        extensionKey: {
            default: ''
        },
        extensionType: {
            default: ''
        },
        parameters: {
            default: null
        },
        text: {
            default: null
        },
        layout: {
            default: 'default'
        },
        localId: {
            default: null
        }
    },
    selectable: true,
    defining: true,
    isolating: true
});
var $1a7a9844253df8d3$export$e7320d153c538837 = (0, $hGaoB.createPMNodeSpecFactory)({
    marks: 'dataConsumer fragment unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    attrs: {
        extensionKey: {
            default: ''
        },
        extensionType: {
            default: ''
        },
        parameters: {
            default: null
        },
        text: {
            default: null
        },
        layout: {
            default: 'default'
        },
        localId: {
            default: null
        }
    },
    selectable: true,
    defining: true,
    isolating: true
});
var $1a7a9844253df8d3$export$e92c7e4302dd4371 = (0, $hGaoB.createPMNodeSpecFactory)({
    content: '(paragraph | blockCard | blockquote | bulletList | codeBlock | confluenceUnsupportedBlock | decisionList | embedCard | expand | heading | layoutSection | mediaGroup | mediaSingle | orderedList | panel | rule | table | taskList | unsupportedBlock)+',
    marks: 'unsupportedMark unsupportedNodeAttribute alignment indentation breakout link fragment',
    attrs: {
        resourceId: {
            default: ''
        },
        localId: {
            default: ''
        }
    },
    selectable: true,
    isolating: true
});
var $1a7a9844253df8d3$export$a140c94e5ea26bee = (0, $hGaoB.createPMNodeSpecFactory)({
    content: 'listItem+',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    attrs: {
        localId: {
            default: null
        }
    },
    selectable: false
});
var $1a7a9844253df8d3$export$8e3c2dfdc4f0453d = (0, $hGaoB.createPMNodeSpecFactory)({
    content: '(hardBreak | mention | emoji | date | placeholder | inlineCard | status | text | unsupportedInline)*',
    marks: '_',
    attrs: {
        localId: {
            default: null
        }
    },
    selectable: false,
    isolating: true
});
var $1a7a9844253df8d3$export$7bb0d5c671655cc4 = (0, $hGaoB.createPMNodeSpecFactory)({
    content: '(text | unsupportedInline)*',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    attrs: {
        language: {
            default: null
        },
        uniqueId: {
            default: null
        },
        localId: {
            default: null
        }
    },
    code: true,
    defining: true
});
var $1a7a9844253df8d3$export$e4f1c66d84049f8b = (0, $hGaoB.createPMNodeSpecFactory)({
    content: '(text | unsupportedInline)*',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    attrs: {
        language: {
            default: null
        },
        uniqueId: {
            default: null
        },
        localId: {
            default: null
        }
    },
    code: true,
    defining: true
});
var $1a7a9844253df8d3$export$daf889beb5092f95 = (0, $hGaoB.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    atom: true,
    attrs: {
        issueKey: {
            default: ''
        },
        macroId: {
            default: null
        },
        schemaVersion: {
            default: null
        },
        server: {
            default: null
        },
        serverId: {
            default: null
        }
    }
});
var $1a7a9844253df8d3$export$e6e4878f43c27cab = (0, $hGaoB.createPMNodeSpecFactory)({
    group: 'block',
    attrs: {
        cxhtml: {
            default: null
        }
    }
});
var $1a7a9844253df8d3$export$3e6d667072febc87 = (0, $hGaoB.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    atom: true,
    attrs: {
        cxhtml: {
            default: null
        }
    }
});
var $1a7a9844253df8d3$export$324d90190a8b822a = (0, $hGaoB.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        timestamp: {
            default: ''
        },
        localId: {
            default: null
        }
    },
    selectable: true
});
var $1a7a9844253df8d3$export$47988d68fe575725 = (0, $hGaoB.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        timestamp: {
            default: ''
        },
        localId: {
            default: null
        }
    },
    selectable: true
});
var $1a7a9844253df8d3$export$6959e16eeff859b4 = (0, $hGaoB.createPMNodeSpecFactory)({
    content: 'inline*',
    marks: '_',
    attrs: {
        localId: {
            default: ''
        },
        state: {
            default: 'DECIDED'
        }
    },
    defining: true
});
var $1a7a9844253df8d3$export$62d45a65fb43d95e = (0, $hGaoB.createPMNodeSpecFactory)({
    content: '(decisionItem | unsupportedBlock)+',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    attrs: {
        localId: {
            default: ''
        }
    },
    selectable: false,
    defining: true
});
var $1a7a9844253df8d3$export$2a111da947c407d2 = (0, $hGaoB.createPMNodeSpecFactory)({
    content: '(block | codeBlock | layoutSection | blockRootOnly | expand | syncBlock | bodiedSyncBlock)+',
    marks: 'unsupportedMark unsupportedNodeAttribute alignment indentation dataConsumer fragment breakout'
});
var $1a7a9844253df8d3$export$be4283d9a1cb1ff6 = (0, $hGaoB.createPMNodeSpecFactory)({
    group: 'block',
    attrs: {
        url: {
            default: ''
        },
        layout: {
            default: 'center'
        },
        width: {
            default: 100
        },
        originalHeight: {
            default: null
        },
        originalWidth: {
            default: null
        },
        localId: {
            default: null
        }
    },
    selectable: true
});
var $1a7a9844253df8d3$export$a19185d1233fc4b2 = (0, $hGaoB.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        shortName: {
            default: ''
        },
        id: {
            default: ''
        },
        text: {
            default: ''
        },
        localId: {
            default: null
        }
    },
    selectable: true
});
var $1a7a9844253df8d3$export$f5574b5d45fc2112 = (0, $hGaoB.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        shortName: {
            default: ''
        },
        id: {
            default: ''
        },
        text: {
            default: ''
        },
        localId: {
            default: null
        }
    },
    selectable: true
});
var $1a7a9844253df8d3$export$9f77e0932fb78f72 = (0, $hGaoB.createPMNodeSpecFactory)({
    content: '(paragraph | panel | blockquote | orderedList | bulletList | rule | heading | codeBlock | mediaGroup | mediaSingle | decisionList | taskList | table | blockCard | embedCard | extension | unsupportedBlock | nestedExpand)+',
    marks: 'unsupportedMark unsupportedNodeAttribute fragment dataConsumer',
    group: 'block',
    attrs: {
        title: {
            default: ''
        },
        __expanded: {
            default: true
        },
        localId: {
            default: null
        }
    },
    selectable: true,
    isolating: true
});
var $1a7a9844253df8d3$export$7e3788972005cc72 = (0, $hGaoB.createPMNodeSpecFactory)({
    content: '(paragraph | panel | blockquote | orderedList | bulletList | rule | heading | codeBlock | mediaGroup | mediaSingle | decisionList | taskList | table | blockCard | embedCard | extension | unsupportedBlock | nestedExpand)+',
    marks: 'unsupportedMark unsupportedNodeAttribute fragment dataConsumer',
    attrs: {
        title: {
            default: ''
        },
        __expanded: {
            default: true
        },
        localId: {
            default: null
        }
    },
    selectable: true,
    isolating: true
});
var $1a7a9844253df8d3$export$1b45514b112dd749 = (0, $hGaoB.createPMNodeSpecFactory)({
    group: 'block',
    atom: true,
    attrs: {
        extensionKey: {
            default: ''
        },
        extensionType: {
            default: ''
        },
        parameters: {
            default: null
        },
        text: {
            default: null
        },
        layout: {
            default: 'default'
        },
        localId: {
            default: null
        }
    },
    selectable: true
});
var $1a7a9844253df8d3$export$a8baf338431a691 = (0, $hGaoB.createPMNodeSpecFactory)({
    group: 'block',
    atom: true,
    attrs: {
        extensionKey: {
            default: ''
        },
        extensionType: {
            default: ''
        },
        parameters: {
            default: null
        },
        text: {
            default: null
        },
        layout: {
            default: 'default'
        },
        localId: {
            default: null
        }
    },
    selectable: true
});
var $1a7a9844253df8d3$export$b555be60c7703afb = (0, $hGaoB.createPMNodeSpecFactory)({
    content: '(paragraph | panel | blockquote | orderedList | bulletList | rule | heading | codeBlock | mediaGroup | mediaSingle | decisionList | taskList | table | extension | bodiedExtension | unsupportedBlock | blockCard | embedCard)+',
    marks: 'dataConsumer fragment unsupportedMark unsupportedNodeAttribute',
    attrs: {},
    selectable: false,
    definingAsContext: false,
    definingForContent: true,
    isolating: true
});
var $1a7a9844253df8d3$export$371da9dd35aba193 = (0, $hGaoB.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        text: {
            default: '\n'
        },
        localId: {
            default: null
        }
    },
    selectable: false,
    linebreakReplacement: true
});
var $1a7a9844253df8d3$export$46e4a324ac90507f = (0, $hGaoB.createPMNodeSpecFactory)({
    content: 'inline*',
    marks: 'link em strong strike subsup underline textColor annotation backgroundColor typeAheadQuery confluenceInlineComment unsupportedNodeAttribute unsupportedMark code dataConsumer fragment border',
    group: 'block',
    attrs: {
        level: {
            default: 1
        },
        localId: {
            default: null
        }
    },
    selectable: false,
    defining: true
});
var $1a7a9844253df8d3$export$1b0c1557b234fa00 = (0, $hGaoB.createPMNodeSpecFactory)({
    group: 'block',
    attrs: {
        level: {
            default: 1
        },
        localId: {
            default: null
        }
    },
    selectable: false,
    defining: true
});
var $1a7a9844253df8d3$export$85461f751c457cc2 = (0, $hGaoB.createPMNodeSpecFactory)({
    group: 'block',
    attrs: {
        level: {
            default: 1
        },
        localId: {
            default: null
        }
    },
    selectable: false,
    defining: true
});
var $1a7a9844253df8d3$export$2b380a0f7e250af1 = (0, $hGaoB.createPMNodeSpecFactory)({
    group: 'block',
    attrs: {
        level: {
            default: 1
        },
        localId: {
            default: null
        }
    },
    selectable: false,
    defining: true
});
var $1a7a9844253df8d3$export$5c452ff88e35e47d = (0, $hGaoB.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        src: {
            default: ''
        },
        alt: {
            default: ''
        },
        title: {
            default: null
        }
    },
    draggable: true
});
var $1a7a9844253df8d3$export$cbf8224b64e0d942 = (0, $hGaoB.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        url: {
            default: null
        },
        localId: {
            default: null
        },
        data: {
            default: null
        }
    },
    selectable: true,
    draggable: true
});
var $1a7a9844253df8d3$export$2f4e72b9459914ad = (0, $hGaoB.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        url: {
            default: null
        },
        localId: {
            default: null
        },
        data: {
            default: null
        }
    },
    selectable: true,
    draggable: true
});
var $1a7a9844253df8d3$export$16b353b2649bd8d9 = (0, $hGaoB.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        extensionKey: {
            default: ''
        },
        extensionType: {
            default: ''
        },
        parameters: {
            default: null
        },
        text: {
            default: null
        },
        localId: {
            default: null
        }
    },
    selectable: true
});
var $1a7a9844253df8d3$export$b3b1e36c2105006d = (0, $hGaoB.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        extensionKey: {
            default: ''
        },
        extensionType: {
            default: ''
        },
        parameters: {
            default: null
        },
        text: {
            default: null
        },
        localId: {
            default: null
        }
    },
    selectable: true
});
var $1a7a9844253df8d3$export$ab76e7c03cd6f650 = (0, $hGaoB.createPMNodeSpecFactory)({
    content: '(block | unsupportedBlock)+',
    marks: 'unsupportedMark unsupportedNodeAttribute alignment indentation dataConsumer fragment',
    attrs: {
        width: {
            default: undefined
        },
        localId: {
            default: null
        }
    },
    selectable: false,
    isolating: true
});
var $1a7a9844253df8d3$export$b3b6a70a7fa4a5be = (0, $hGaoB.createPMNodeSpecFactory)({
    content: '(layoutColumn | unsupportedBlock){1,3} unsupportedBlock*',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    attrs: {
        localId: {
            default: null
        }
    },
    isolating: true
});
var $1a7a9844253df8d3$export$cdae19acb0a520fd = (0, $hGaoB.createPMNodeSpecFactory)({
    content: '(layoutColumn | unsupportedBlock){2,3}',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    attrs: {
        localId: {
            default: null
        }
    },
    isolating: true
});
var $1a7a9844253df8d3$export$206007566ca0aca5 = (0, $hGaoB.createPMNodeSpecFactory)({
    content: '(layoutColumn | unsupportedBlock){1,5} unsupportedBlock*',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    attrs: {
        columnRuleStyle: {
            default: null
        },
        localId: {
            default: null
        }
    },
    isolating: true
});
var $1a7a9844253df8d3$export$76c7e83ecc9cdf05 = (0, $hGaoB.createPMNodeSpecFactory)({
    content: '(paragraph | mediaSingle | codeBlock | unsupportedBlock | extension) (paragraph | bulletList | orderedList | taskList | mediaSingle | codeBlock | unsupportedBlock | extension)*',
    marks: 'dataConsumer fragment unsupportedMark unsupportedNodeAttribute',
    attrs: {
        localId: {
            default: null
        }
    },
    selectable: false,
    defining: true
});
var $1a7a9844253df8d3$export$df876f0305235056 = (0, $hGaoB.createPMNodeSpecFactory)({
    content: '(paragraph | mediaSingle | codeBlock | unsupportedBlock | decisionList | extension) (paragraph | bulletList | orderedList | taskList | mediaSingle | codeBlock | unsupportedBlock | decisionList | extension)*',
    marks: 'unsupportedMark unsupportedNodeAttribute dataConsumer fragment',
    attrs: {
        localId: {
            default: null
        }
    },
    selectable: false,
    defining: true
});
var $1a7a9844253df8d3$export$987d49ffe1b0900f = (0, $hGaoB.createPMNodeSpecFactory)({
    attrs: {
        type: {
            default: 'file'
        },
        localId: {
            default: null
        },
        id: {
            default: ''
        },
        alt: {
            default: ''
        },
        collection: {
            default: ''
        },
        height: {
            default: null
        },
        occurrenceKey: {
            default: null
        },
        width: {
            default: null
        },
        __contextId: {
            default: null
        },
        __displayType: {
            default: null
        },
        __external: {
            default: false
        },
        __fileMimeType: {
            default: null
        },
        __fileName: {
            default: null
        },
        __fileSize: {
            default: null
        },
        __mediaTraceId: {
            default: null
        },
        url: {
            default: null
        }
    },
    selectable: true
});
var $1a7a9844253df8d3$export$2855e964765eac9 = (0, $hGaoB.createPMNodeSpecFactory)({
    content: '(media | unsupportedBlock)+',
    marks: 'link annotation border unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    attrs: {},
    selectable: false
});
var $1a7a9844253df8d3$export$38bab695e3f720f1 = (0, $hGaoB.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        type: {
            default: 'file'
        },
        localId: {
            default: null
        },
        url: {
            default: null
        },
        id: {
            default: ''
        },
        alt: {
            default: ''
        },
        collection: {
            default: ''
        },
        occurrenceKey: {
            default: null
        },
        width: {
            default: null
        },
        height: {
            default: null
        },
        __fileName: {
            default: null
        },
        __fileSize: {
            default: null
        },
        __fileMimeType: {
            default: null
        },
        __displayType: {
            default: null
        },
        __contextId: {
            default: null
        },
        __mediaTraceId: {
            default: null
        },
        __external: {
            default: false
        }
    },
    selectable: true
});
var $1a7a9844253df8d3$export$969fe3781ca15058 = (0, $hGaoB.createPMNodeSpecFactory)({
    group: 'block',
    atom: true,
    attrs: {
        layout: {
            default: 'center'
        },
        width: {
            default: null
        }
    },
    selectable: true,
    content: 'media|unsupportedBlock+|media unsupportedBlock+',
    marks: 'annotation border link unsupportedMark unsupportedNodeAttribute'
});
var $1a7a9844253df8d3$export$8d067f22dc2d1254 = (0, $hGaoB.createPMNodeSpecFactory)({
    content: 'media|unsupportedBlock+|media (caption|unsupportedBlock) unsupportedBlock*',
    marks: 'link annotation border unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    atom: false,
    attrs: {
        layout: {
            default: 'center'
        },
        width: {
            default: null
        }
    },
    selectable: true
});
var $1a7a9844253df8d3$export$7e767666f2ce108a = (0, $hGaoB.createPMNodeSpecFactory)({
    content: 'media|unsupportedBlock+|media (caption|unsupportedBlock) unsupportedBlock*',
    marks: 'link annotation border unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    atom: false,
    attrs: {
        localId: {
            default: null
        },
        width: {
            default: null
        },
        layout: {
            default: 'center'
        },
        widthType: {
            default: null
        }
    },
    selectable: true
});
var $1a7a9844253df8d3$export$4bd9a38995f6bf50 = (0, $hGaoB.createPMNodeSpecFactory)({
    content: 'media|unsupportedBlock+|media unsupportedBlock+',
    marks: 'link annotation border unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    atom: true,
    attrs: {
        localId: {
            default: null
        },
        width: {
            default: null
        },
        layout: {
            default: 'center'
        },
        widthType: {
            default: null
        }
    },
    selectable: true
});
var $1a7a9844253df8d3$export$db83999c14438df4 = (0, $hGaoB.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        id: {
            default: ''
        },
        localId: {
            default: null
        },
        text: {
            default: ''
        },
        accessLevel: {
            default: ''
        },
        userType: {
            default: null
        }
    },
    selectable: true
});
var $1a7a9844253df8d3$export$46f790bd65f760d0 = (0, $hGaoB.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        id: {
            default: ''
        },
        localId: {
            default: null
        },
        text: {
            default: ''
        },
        accessLevel: {
            default: ''
        },
        userType: {
            default: null
        }
    },
    selectable: true
});
var $1a7a9844253df8d3$export$750e45819f66d9d0 = (0, $hGaoB.createPMNodeSpecFactory)({
    content: 'extensionFrame+',
    marks: 'unsupportedNodeAttribute unsupportedMark',
    group: 'blockRootOnly',
    attrs: {
        extensionKey: {
            default: ''
        },
        extensionType: {
            default: ''
        },
        parameters: {
            default: null
        },
        text: {
            default: null
        },
        layout: {
            default: 'default'
        },
        localId: {
            default: null
        }
    },
    selectable: true,
    definingAsContext: true
});
var $1a7a9844253df8d3$export$63cadbf5f4296627 = (0, $hGaoB.createPMNodeSpecFactory)({
    content: '(paragraph | heading | mediaSingle | mediaGroup | codeBlock | bulletList | orderedList | taskList | decisionList | rule | panel | blockquote | unsupportedBlock | extension)+',
    marks: 'unsupportedMark unsupportedNodeAttribute dataConsumer fragment',
    attrs: {
        title: {
            default: ''
        },
        __expanded: {
            default: true
        },
        localId: {
            default: null
        }
    },
    selectable: true,
    isolating: true
});
var $1a7a9844253df8d3$export$f03786aa6312d1e4 = (0, $hGaoB.createPMNodeSpecFactory)({
    attrs: {
        title: {
            default: ''
        },
        __expanded: {
            default: true
        },
        localId: {
            default: null
        }
    },
    selectable: true,
    isolating: true
});
var $1a7a9844253df8d3$export$a5dc81035676e7a = (0, $hGaoB.createPMNodeSpecFactory)({
    content: 'listItem+',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    attrs: {
        order: {
            default: 1
        },
        localId: {
            default: null
        }
    },
    selectable: false
});
var $1a7a9844253df8d3$export$21f42ab9b6679f44 = (0, $hGaoB.createPMNodeSpecFactory)({
    content: '(paragraph | heading | bulletList | orderedList | blockCard | mediaGroup | mediaSingle | codeBlock | taskList | rule | decisionList | unsupportedBlock | extension)+',
    marks: 'unsupportedMark unsupportedNodeAttribute dataConsumer fragment',
    group: 'block',
    attrs: {
        panelType: {
            default: 'info'
        },
        panelIcon: {
            default: null
        },
        panelIconId: {
            default: null
        },
        panelIconText: {
            default: null
        },
        panelColor: {
            default: null
        },
        localId: {
            default: null
        }
    },
    selectable: true
});
var $1a7a9844253df8d3$export$9c206ddddb32a9b = (0, $hGaoB.createPMNodeSpecFactory)({
    content: 'inline*',
    marks: 'link em strong strike subsup underline textColor annotation backgroundColor typeAheadQuery confluenceInlineComment unsupportedNodeAttribute unsupportedMark code dataConsumer fragment border',
    group: 'block',
    attrs: {
        localId: {
            default: null
        }
    },
    selectable: false
});
var $1a7a9844253df8d3$export$4f98472e6dc14293 = (0, $hGaoB.createPMNodeSpecFactory)({
    group: 'block',
    attrs: {
        localId: {
            default: null
        }
    },
    selectable: false
});
var $1a7a9844253df8d3$export$ea332b61641b0588 = (0, $hGaoB.createPMNodeSpecFactory)({
    group: 'block',
    attrs: {
        localId: {
            default: null
        }
    },
    selectable: false
});
var $1a7a9844253df8d3$export$a1f41dc4901771f8 = (0, $hGaoB.createPMNodeSpecFactory)({
    group: 'block',
    attrs: {
        localId: {
            default: null
        }
    },
    selectable: false
});
var $1a7a9844253df8d3$export$c7187bbd1a7a9244 = (0, $hGaoB.createPMNodeSpecFactory)({
    marks: '',
    group: 'inline',
    inline: true,
    attrs: {
        text: {
            default: ''
        },
        localId: {
            default: null
        }
    },
    selectable: false
});
var $1a7a9844253df8d3$export$fbeb3a3956e8a3c7 = (0, $hGaoB.createPMNodeSpecFactory)({
    group: 'block',
    attrs: {
        localId: {
            default: null
        }
    }
});
var $1a7a9844253df8d3$export$471f7ae5c4103ae1 = (0, $hGaoB.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        text: {
            default: ''
        },
        color: {
            default: ''
        },
        localId: {
            default: ''
        },
        style: {
            default: ''
        }
    },
    selectable: true
});
var $1a7a9844253df8d3$export$b6ce52be8d7a261 = (0, $hGaoB.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        text: {
            default: ''
        },
        color: {
            default: ''
        },
        localId: {
            default: ''
        },
        style: {
            default: ''
        }
    },
    selectable: true
});
var $1a7a9844253df8d3$export$faab0ca9701d7048 = (0, $hGaoB.createPMNodeSpecFactory)({
    attrs: {
        resourceId: {
            default: ''
        },
        localId: {
            default: ''
        }
    },
    selectable: true
});
var $1a7a9844253df8d3$export$9852986a3ec5f6a0 = (0, $hGaoB.createPMNodeSpecFactory)({
    content: 'tableRow+',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    attrs: {
        displayMode: {
            default: null
        },
        isNumberColumnEnabled: {
            default: false
        },
        layout: {
            default: 'default'
        },
        localId: {
            default: ''
        },
        width: {
            default: null
        },
        __autoSize: {
            default: false
        }
    },
    selectable: true,
    isolating: true,
    tableRole: 'table'
});
var $1a7a9844253df8d3$export$ce086a560a1d05f5 = (0, $hGaoB.createPMNodeSpecFactory)({
    content: 'tableRow+',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    attrs: {
        displayMode: {
            default: null
        },
        isNumberColumnEnabled: {
            default: false
        },
        layout: {
            default: 'default'
        },
        localId: {
            default: ''
        },
        width: {
            default: null
        },
        __autoSize: {
            default: false
        }
    },
    selectable: true,
    isolating: true,
    tableRole: 'table'
});
var $1a7a9844253df8d3$export$e1e720e5f4603e6a = (0, $hGaoB.createPMNodeSpecFactory)({
    content: '(paragraph | panel | blockquote | orderedList | bulletList | rule | heading | codeBlock | mediaSingle | mediaGroup | decisionList | taskList | blockCard | embedCard | extension | nestedExpand | unsupportedBlock)+',
    marks: 'alignment unsupportedMark unsupportedNodeAttribute dataConsumer fragment',
    attrs: {
        colspan: {
            default: 1
        },
        rowspan: {
            default: 1
        },
        colwidth: {
            default: null
        },
        background: {
            default: null
        },
        localId: {
            default: null
        }
    },
    selectable: false,
    isolating: true,
    tableRole: 'cell'
});
var $1a7a9844253df8d3$export$abf39ca178940ff3 = (0, $hGaoB.createPMNodeSpecFactory)({
    content: '(paragraph | panel | blockquote | orderedList | bulletList | rule | heading | codeBlock | mediaSingle | mediaGroup | decisionList | taskList | blockCard | embedCard | extension | nestedExpand | unsupportedBlock | table)+',
    marks: 'alignment unsupportedMark unsupportedNodeAttribute dataConsumer fragment',
    attrs: {
        colspan: {
            default: 1
        },
        rowspan: {
            default: 1
        },
        colwidth: {
            default: null
        },
        background: {
            default: null
        },
        localId: {
            default: null
        }
    },
    selectable: false,
    isolating: true,
    tableRole: 'cell'
});
var $1a7a9844253df8d3$export$48884d2a5190dc73 = (0, $hGaoB.createPMNodeSpecFactory)({
    content: '(paragraph | panel | blockquote | orderedList | bulletList | rule | heading | codeBlock | mediaSingle | mediaGroup | decisionList | taskList | blockCard | embedCard | extension | nestedExpand)+',
    marks: 'alignment unsupportedMark unsupportedNodeAttribute dataConsumer fragment',
    attrs: {
        colspan: {
            default: 1
        },
        rowspan: {
            default: 1
        },
        colwidth: {
            default: null
        },
        background: {
            default: null
        },
        localId: {
            default: null
        }
    },
    selectable: false,
    isolating: true,
    tableRole: 'header_cell'
});
var $1a7a9844253df8d3$export$2a5a518232fa1a97 = (0, $hGaoB.createPMNodeSpecFactory)({
    content: '(paragraph | panel | blockquote | orderedList | bulletList | rule | heading | codeBlock | mediaSingle | mediaGroup | decisionList | taskList | blockCard | embedCard | extension | nestedExpand | table)+',
    marks: 'alignment unsupportedMark unsupportedNodeAttribute dataConsumer fragment',
    attrs: {
        colspan: {
            default: 1
        },
        rowspan: {
            default: 1
        },
        colwidth: {
            default: null
        },
        background: {
            default: null
        },
        localId: {
            default: null
        }
    },
    selectable: false,
    isolating: true,
    tableRole: 'header_cell'
});
var $1a7a9844253df8d3$export$ce666bf02318c957 = (0, $hGaoB.createPMNodeSpecFactory)({
    content: '(tableCell | tableHeader)+',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    attrs: {
        localId: {
            default: null
        }
    },
    selectable: false,
    tableRole: 'row'
});
var $1a7a9844253df8d3$export$7d657479499397 = (0, $hGaoB.createPMNodeSpecFactory)({
    content: '(tableCell | tableHeader)+',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    attrs: {
        localId: {
            default: null
        }
    },
    selectable: false,
    tableRole: 'row'
});
var $1a7a9844253df8d3$export$6d8b0ef52e2e6390 = (0, $hGaoB.createPMNodeSpecFactory)({
    content: 'inline*',
    marks: '_',
    attrs: {
        localId: {
            default: ''
        },
        state: {
            default: 'TODO'
        }
    },
    selectable: false,
    defining: true
});
var $1a7a9844253df8d3$export$375b6afcc5f4d291 = (0, $hGaoB.createPMNodeSpecFactory)({
    content: '(taskItem | unsupportedBlock | blockTaskItem)+ (taskItem | taskList | unsupportedBlock | blockTaskItem)*',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    attrs: {
        localId: {
            default: ''
        }
    },
    selectable: false,
    defining: true
});
var $1a7a9844253df8d3$export$6f093cfa640b7166 = (0, $hGaoB.createPMNodeSpecFactory)({
    group: 'inline'
});
var $1a7a9844253df8d3$export$5ea06bc686c59dc2 = (0, $hGaoB.createPMNodeSpecFactory)({
    group: 'inline'
});
var $1a7a9844253df8d3$export$93256a4c17b33a82 = (0, $hGaoB.createPMNodeSpecFactory)({
    group: 'inline'
});
var $1a7a9844253df8d3$export$a12828d0f14a2762 = (0, $hGaoB.createPMNodeSpecFactory)({});
var $1a7a9844253df8d3$export$44b79b0979d0f0f7 = (0, $hGaoB.createPMNodeSpecFactory)({
    group: 'block',
    atom: true,
    attrs: {
        originalValue: {
            default: {}
        }
    },
    selectable: true
});
var $1a7a9844253df8d3$export$310ebe0d80122e9b = (0, $hGaoB.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        originalValue: {
            default: {}
        }
    },
    selectable: true
});

});
parcelRegister("hGaoB", function(module, exports) {
$parcel$export(module.exports, "createPMNodeSpecFactory", () => $cdee6c54678638fc$export$bf0a80f00e2b8ff6);
$parcel$export(module.exports, "createPMMarkSpecFactory", () => $cdee6c54678638fc$export$cf5823ed4e9f4c6f);

var $25nEq = parcelRequire("25nEq");
function $cdee6c54678638fc$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $cdee6c54678638fc$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $cdee6c54678638fc$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $cdee6c54678638fc$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $cdee6c54678638fc$export$bf0a80f00e2b8ff6 = function createPMNodeSpecFactory(nodeSpec) {
    return function(_ref) {
        var parseDOM = _ref.parseDOM, toDOM = _ref.toDOM, toDebugString = _ref.toDebugString;
        return $cdee6c54678638fc$var$_objectSpread($cdee6c54678638fc$var$_objectSpread($cdee6c54678638fc$var$_objectSpread($cdee6c54678638fc$var$_objectSpread({}, nodeSpec), parseDOM && {
            parseDOM: parseDOM
        }), toDOM && {
            toDOM: toDOM
        }), toDebugString && {
            toDebugString: toDebugString
        });
    };
};
var $cdee6c54678638fc$export$cf5823ed4e9f4c6f = function createPMMarkSpecFactory(markSpec) {
    return function(_ref2) {
        var parseDOM = _ref2.parseDOM, toDOM = _ref2.toDOM, toDebugString = _ref2.toDebugString;
        return $cdee6c54678638fc$var$_objectSpread($cdee6c54678638fc$var$_objectSpread($cdee6c54678638fc$var$_objectSpread($cdee6c54678638fc$var$_objectSpread({}, markSpec), parseDOM && {
            parseDOM: parseDOM
        }), toDOM && {
            toDOM: toDOM
        }), toDebugString && {
            toDebugString: toDebugString
        });
    };
};

});


parcelRegister("l4823", function(module, exports) {
$parcel$export(module.exports, "uuid", () => $f56033af584a611e$export$31b40729666a4ae0);
/* eslint-disable no-bitwise */ var $f56033af584a611e$export$1c3aefb711c3a4cc = function generateUuid() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
        var r = Math.random() * 16 | 0;
        return (c === 'x' ? r : r & 0x3 | 0x8).toString(16);
    });
};
/* eslint-enable no-bitwise */ var $f56033af584a611e$var$staticValue = false;
var $f56033af584a611e$export$31b40729666a4ae0 = {
    setStatic: function setStatic(value) {
        $f56033af584a611e$var$staticValue = value;
    },
    generate: function generate() {
        return $f56033af584a611e$var$staticValue || $f56033af584a611e$export$1c3aefb711c3a4cc();
    }
};

});


parcelRegister("5vwuc", function(module, exports) {
$parcel$export(module.exports, "extensionFrame", () => $40290c0d346cbba2$export$4fdcae991fd743e7);
$parcel$export(module.exports, "multiBodiedExtension", () => $40290c0d346cbba2$export$c3c04d555a8b9013);

var $ljjv5 = parcelRequire("ljjv5");

var $2gWGi = parcelRequire("2gWGi");
var $40290c0d346cbba2$export$4fdcae991fd743e7 = (0, $2gWGi.extensionFrameStage0)({
    parseDOM: [
        {
            context: 'extensionFrame//',
            tag: 'div[data-extension-frame]',
            skip: true
        },
        {
            tag: 'div[data-extension-frame]'
        }
    ],
    toDOM: function toDOM() {
        var attrs = {
            'data-extension-frame': 'true'
        };
        return [
            'div',
            attrs,
            0
        ];
    }
});
var $40290c0d346cbba2$export$c3c04d555a8b9013 = (0, $2gWGi.multiBodiedExtensionStage0)({
    parseDOM: [
        {
            context: 'multiBodiedExtension//',
            tag: '[data-node-type="multi-bodied-extension"]',
            skip: true
        },
        {
            tag: '[data-node-type="multi-bodied-extension"]',
            getAttrs: function getAttrs(domNode) {
                return (0, $ljjv5.getExtensionAttrs)(domNode);
            }
        }
    ],
    toDOM: function toDOM(node) {
        var attrs = {
            'data-node-type': 'multi-bodied-extension',
            'data-extension-type': node.attrs.extensionType,
            'data-extension-key': node.attrs.extensionKey,
            'data-text': node.attrs.text,
            'data-parameters': JSON.stringify(node.attrs.parameters),
            'data-layout': node.attrs.layout,
            'data-local-id:': node.attrs.localId
        };
        return [
            'div',
            attrs,
            0
        ];
    }
});

});
parcelRegister("ljjv5", function(module, exports) {
$parcel$export(module.exports, "getExtensionAttrs", () => $f83a7fb4c3019a98$export$1765e2758fc47004);
var $f83a7fb4c3019a98$export$d5f21755dc782a4a = function isValidLayout(name) {
    return !!name && [
        'default',
        'wide',
        'full-width'
    ].includes(name);
};
var $f83a7fb4c3019a98$export$1765e2758fc47004 = function getExtensionAttrs(dom) {
    var isInline = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var extensionType = dom.getAttribute('data-extension-type');
    var extensionKey = dom.getAttribute('data-extension-key');
    if (!extensionType || !extensionKey) return false;
    var attrs = {
        extensionType: extensionType,
        extensionKey: extensionKey,
        text: dom.getAttribute('data-text') || undefined,
        parameters: JSON.parse(dom.getAttribute('data-parameters') || '{}'),
        localId: dom.getAttribute('data-local-id') || undefined
    };
    if (!isInline) {
        var rawLayout = dom.getAttribute('data-layout');
        attrs.layout = $f83a7fb4c3019a98$export$d5f21755dc782a4a(rawLayout) ? rawLayout : 'default';
    }
    return attrs;
};

});


parcelRegister("d79nc", function(module, exports) {
$parcel$export(module.exports, "layoutSection", () => $98c3332112afa089$export$b3b6a70a7fa4a5be);
$parcel$export(module.exports, "layoutSectionWithSingleColumn", () => $98c3332112afa089$export$4f9d8f623ff17117);

var $2gWGi = parcelRequire("2gWGi");

var $l4823 = parcelRequire("l4823");
var $98c3332112afa089$export$b3b6a70a7fa4a5be = (0, $2gWGi.layoutSection)({
    parseDOM: [
        {
            context: 'layoutSection//|layoutColumn//',
            tag: 'div[data-layout-section]',
            skip: true
        },
        {
            tag: 'div[data-layout-section]'
        }
    ],
    toDOM: function toDOM() {
        var attrs = {
            'data-layout-section': 'true'
        };
        return [
            'div',
            attrs,
            0
        ];
    }
});
var $98c3332112afa089$export$cdae19acb0a520fd = (0, $2gWGi.layoutSectionFull)({
    parseDOM: [
        {
            context: 'layoutSection//|layoutColumn//',
            tag: 'div[data-layout-section]',
            skip: true
        },
        {
            tag: 'div[data-layout-section]'
        }
    ],
    toDOM: function toDOM() {
        var attrs = {
            'data-layout-section': 'true'
        };
        return [
            'div',
            attrs,
            0
        ];
    }
});
var $98c3332112afa089$export$4f9d8f623ff17117 = (0, $2gWGi.layoutSectionWithSingleColumnStage0)({
    parseDOM: [
        {
            context: 'layoutSection//|layoutColumn//',
            tag: 'div[data-layout-section]',
            skip: true
        },
        {
            tag: 'div[data-layout-section]',
            getAttrs: function getAttrs(dom) {
                var columnRuleStyle = dom.getAttribute('data-column-rule-style');
                return columnRuleStyle ? {
                    columnRuleStyle: columnRuleStyle
                } : {};
            }
        }
    ],
    toDOM: function toDOM(node) {
        var columnRuleStyle = node.attrs.columnRuleStyle;
        var attrs = {
            'data-layout-section': 'true',
            'data-column-rule-style': columnRuleStyle || undefined
        };
        return [
            'div',
            attrs,
            0
        ];
    }
});
var $98c3332112afa089$export$d9d3c69a64270b13 = (0, $2gWGi.layoutSection)({
    parseDOM: [
        {
            context: 'layoutSection//|layoutColumn//',
            tag: 'div[data-layout-section]',
            skip: true
        },
        {
            tag: 'div[data-layout-section]',
            getAttrs: function getAttrs() {
                var localId = (0, $l4823.uuid).generate();
                return {
                    localId: localId
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var localId = node.attrs.localId;
        var attrs = {
            'data-layout-section': 'true',
            'data-local-id': localId
        };
        return [
            'div',
            attrs,
            0
        ];
    }
});
var $98c3332112afa089$export$64facded20dfd85c = (0, $2gWGi.layoutSectionWithSingleColumnStage0)({
    parseDOM: [
        {
            context: 'layoutSection//|layoutColumn//',
            tag: 'div[data-layout-section]',
            skip: true
        },
        {
            tag: 'div[data-layout-section]',
            getAttrs: function getAttrs(dom) {
                var columnRuleStyle = dom.getAttribute('data-column-rule-style');
                var localId = (0, $l4823.uuid).generate();
                return columnRuleStyle ? {
                    columnRuleStyle: columnRuleStyle,
                    localId: localId
                } : {
                    localId: localId
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node$attrs;
        var columnRuleStyle = node.attrs.columnRuleStyle;
        var attrs = {
            'data-layout-section': 'true',
            'data-column-rule-style': columnRuleStyle || undefined,
            'data-local-id': (node === null || node === void 0 ? void 0 : (_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.localId) || undefined
        };
        return [
            'div',
            attrs,
            0
        ];
    }
});

});

parcelRegister("2Ji8g", function(module, exports) {
$parcel$export(module.exports, "listItem", () => $1fcdd9714dc98cbd$export$76c7e83ecc9cdf05);
$parcel$export(module.exports, "listItemWithDecisionStage0", () => $1fcdd9714dc98cbd$export$b2cd54d5ce935ddb);

var $l4823 = parcelRequire("l4823");

var $2gWGi = parcelRequire("2gWGi");
var $1fcdd9714dc98cbd$export$76c7e83ecc9cdf05 = (0, $2gWGi.listItem)({
    parseDOM: [
        {
            tag: 'li'
        }
    ],
    toDOM: function toDOM() {
        return [
            'li',
            0
        ];
    }
});
var $1fcdd9714dc98cbd$export$483d52f09158e61c = (0, $2gWGi.listItem)({
    parseDOM: [
        {
            tag: 'li',
            getAttrs: function getAttrs() {
                return {
                    localId: (0, $l4823.uuid).generate()
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node$attrs;
        return [
            'li',
            {
                'data-local-id': (node === null || node === void 0 ? void 0 : (_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.localId) || undefined
            },
            0
        ];
    }
});
var $1fcdd9714dc98cbd$export$b2cd54d5ce935ddb = (0, $2gWGi.listItemWithNestedDecisionStage0)({
    parseDOM: [
        {
            tag: 'li'
        }
    ],
    toDOM: function toDOM() {
        return [
            'li',
            0
        ];
    }
});
var $1fcdd9714dc98cbd$export$394466eb252d967a = (0, $2gWGi.listItemWithNestedDecisionStage0)({
    parseDOM: [
        {
            tag: 'li',
            getAttrs: function getAttrs() {
                return {
                    localId: (0, $l4823.uuid).generate()
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node$attrs2;
        return [
            'li',
            {
                'data-local-id': (node === null || node === void 0 ? void 0 : (_node$attrs2 = node.attrs) === null || _node$attrs2 === void 0 ? void 0 : _node$attrs2.localId) || undefined
            },
            0
        ];
    }
});

});

parcelRegister("gc8Zd", function(module, exports) {
$parcel$export(module.exports, "tableBackgroundColorPalette", () => $bca4bcd38fb8105c$export$219b7f492ad209f8);
$parcel$export(module.exports, "table", () => $bca4bcd38fb8105c$export$9852986a3ec5f6a0);
$parcel$export(module.exports, "tableToJSON", () => $bca4bcd38fb8105c$export$1f92a2f429e06fa8);
$parcel$export(module.exports, "tableRow", () => $bca4bcd38fb8105c$export$ce666bf02318c957);
$parcel$export(module.exports, "tableCell", () => $bca4bcd38fb8105c$export$e1e720e5f4603e6a);
$parcel$export(module.exports, "toJSONTableCell", () => $bca4bcd38fb8105c$export$2ac34c099660f1a8);
$parcel$export(module.exports, "tableHeader", () => $bca4bcd38fb8105c$export$48884d2a5190dc73);
$parcel$export(module.exports, "toJSONTableHeader", () => $bca4bcd38fb8105c$export$2af48797a1010bb1);
$parcel$export(module.exports, "tableWithNestedTable", () => $bca4bcd38fb8105c$export$ce086a560a1d05f5);
$parcel$export(module.exports, "tableRowWithNestedTable", () => $bca4bcd38fb8105c$export$7d657479499397);
$parcel$export(module.exports, "tableCellWithNestedTable", () => $bca4bcd38fb8105c$export$abf39ca178940ff3);
$parcel$export(module.exports, "tableHeaderWithNestedTable", () => $bca4bcd38fb8105c$export$2a5a518232fa1a97);

var $iYJcE = parcelRequire("iYJcE");

var $25nEq = parcelRequire("25nEq");

var $aE9eF = parcelRequire("aE9eF");

var $22vaF = parcelRequire("22vaF");

var $l4823 = parcelRequire("l4823");

var $gwjAb = parcelRequire("gwjAb");

var $2gWGi = parcelRequire("2gWGi");
function $bca4bcd38fb8105c$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $bca4bcd38fb8105c$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $bca4bcd38fb8105c$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $bca4bcd38fb8105c$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $bca4bcd38fb8105c$export$9cfceb893b24742a = 'pm-table';
var $bca4bcd38fb8105c$export$69cb4c3f80383763 = "".concat($bca4bcd38fb8105c$export$9cfceb893b24742a, "-cell-content-wrap");
var $bca4bcd38fb8105c$export$7b07d37d879c957f = "".concat($bca4bcd38fb8105c$export$9cfceb893b24742a, "-header-content-wrap");
var $bca4bcd38fb8105c$export$8dd42a84cd52da07 = "".concat($bca4bcd38fb8105c$export$9cfceb893b24742a, "-cell-nodeview-wrapper");
var $bca4bcd38fb8105c$export$5e26a5c19f0865d8 = "".concat($bca4bcd38fb8105c$export$9cfceb893b24742a, "-cell-nodeview-content-dom");
var $bca4bcd38fb8105c$var$DEFAULT_TABLE_HEADER_CELL_BACKGROUND = (0, $22vaF.N20).toLocaleLowerCase();
var $bca4bcd38fb8105c$export$43977bde391e007 = function getCellAttrs(dom) {
    var defaultValues = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var widthAttr = dom.getAttribute('data-colwidth');
    var width = widthAttr && /^\d+(,\d+)*$/.test(widthAttr) ? widthAttr.split(',').map(function(str) {
        return Number(str);
    }) : null;
    var colspan = Number(dom.getAttribute('colspan') || 1);
    var backgroundColor = dom.style.backgroundColor;
    /**
   * We have pivoted to store background color information in
   *  data-cell-background.
   * We will have original hex code (which we map to DST token)
   *  stored in data-cell-background, use that.
   * More details at https://product-fabric.atlassian.net/wiki/spaces/EUXQ/pages/3472556903/Tokenising+tableCell+background+colors#Update-toDom-and-parseDom-to-store-and-read-background-color-from-data-cell-background-attribute.4
   */ var dataCellBackground = dom.getAttribute('data-cell-background');
    var dataCellBackgroundHexCode = dataCellBackground && (0, $22vaF.isHex)(dataCellBackground) ? dataCellBackground : undefined;
    // ignore setting background attr if ds neutral token is detected
    if (backgroundColor.includes('--ds-background-neutral')) backgroundColor = '';
    else if (backgroundColor && (0, $22vaF.isRgb)(backgroundColor)) {
        var result = (0, $22vaF.rgbToHex)(backgroundColor);
        if (result !== null) backgroundColor = result;
    }
    var backgroundHexCode = dataCellBackgroundHexCode || (backgroundColor && backgroundColor !== defaultValues['background'] ? backgroundColor : null);
    var localId = defaultValues === null || defaultValues === void 0 ? void 0 : defaultValues.localId;
    return $bca4bcd38fb8105c$var$_objectSpread({
        colspan: colspan,
        rowspan: Number(dom.getAttribute('rowspan') || 1),
        colwidth: width && width.length === colspan ? width : null,
        background: backgroundHexCode
    }, localId && {
        localId: localId
    });
};
// these are for test only
var $bca4bcd38fb8105c$var$testGlobalTheme;
var $bca4bcd38fb8105c$export$fd7e0dd2b74807f7 = function setGlobalTheme(theme) {
    $bca4bcd38fb8105c$var$testGlobalTheme = theme;
};
// This is a minimal duplication of the method from @atlaskit/tokens
// to minimise the number of dependencies required as these changes are expected
// to be patched onto CR8.
var $bca4bcd38fb8105c$var$getGlobalTheme = function getGlobalTheme() {
    // This should only be hit during tests.
    //
    // At time of writing Jest mocks are not working in this repository.
    if ($bca4bcd38fb8105c$var$testGlobalTheme) return {
        colorMode: $bca4bcd38fb8105c$var$testGlobalTheme
    };
    var element = document.documentElement;
    var colorMode = element.getAttribute('data-color-mode') || '';
    return {
        colorMode: colorMode
    };
};
var $bca4bcd38fb8105c$var$cssVariablePattern = /^var\(--.*\)$/;
var $bca4bcd38fb8105c$export$363c8dda799bfe9c = function getCellDomAttrs(node) {
    var _node$attrs;
    var attrs = {};
    var nodeType = node.type.name;
    if (node.attrs.colspan !== 1) attrs.colspan = node.attrs.colspan;
    if (node.attrs.rowspan !== 1) attrs.rowspan = node.attrs.rowspan;
    if (node.attrs.colwidth) attrs['data-colwidth'] = node.attrs.colwidth.join(',');
    if (node.attrs.background) {
        var background = node.attrs.background;
        // to ensure that we don't overwrite product's style:
        // - it clears background color for <th> if its set to gray
        // - it clears background color for <td> if its set to white
        // - it clears background color for <th> if ds neutral token is detected
        var ignored = nodeType === 'tableHeader' && background === $bca4bcd38fb8105c$export$8cc2833b5b349a1e.get('light gray') || nodeType === 'tableCell' && background === $bca4bcd38fb8105c$export$8cc2833b5b349a1e.get('white') || nodeType === 'tableHeader' && background.includes('--ds-background-neutral');
        if (ignored) attrs.style = '';
        else {
            var color = (0, $22vaF.isRgb)(background) && (0, $22vaF.rgbToHex)(background) ? (0, $22vaF.rgbToHex)(background) : background;
            /**
       * The Editor supports users pasting content from external sources with custom table cell backgrounds and having those
       * backgrounds persisted.
       *
       * This feature predates the introduction of dark mode.
       *
       * Without the inversion logic below, tokenised content (ie. text), can be hard to read when the user loads the page in dark mode.
       *
       * This introduces inversion of the presentation of the custom background color when the user is in dark mode.
       *
       * This can be done without additional changes to account for users copying and pasting content inside the Editor, because of
       * how we detect table cell background colors copied from external editor sources. Where we load the background color from a
       * seperate attribute (data-cell-background), instead of the inline style.
       *
       * See the following document for more details on this behaviour
       * https://hello.atlassian.net/wiki/spaces/CCECO/pages/2892247168/Unsupported+custom+table+cell+background+colors+in+dark+theme+Editor+Job+Story
       */ var tokenColor = (0, $aE9eF.hexToEditorBackgroundPaletteRawValue)(color);
            if (tokenColor) attrs.style = "background-color: ".concat(tokenColor, ";");
            else if (/**
       * There was previously a bug in dark mode where we would attempt to invert
       * a design token in `getDarkModeLCHColor` causing issues.
       * If it's a design token we should return it as is.
       */ $bca4bcd38fb8105c$var$cssVariablePattern.test(color)) attrs.style = "background-color: ".concat(color, ";");
            else // if we have a custom color, we need to check if we are in dark mode
            if ($bca4bcd38fb8105c$var$getGlobalTheme().colorMode === 'dark') // if we have a custom color, we need to check if we are in dark mode
            attrs.style = "background-color: ".concat((0, $gwjAb.getDarkModeLCHColor)(color), ";");
            else // if we are in light mode, we can just set the color
            attrs.style = "background-color: ".concat(background, ";");
            /**
       * Storing hex code in data-cell-background because
       *  we want to have DST token (css variable) or
       *  DST token value (value (hex code) of css variable) in
       *  inline style to correct render table cell background
       *  based on selected theme.
       * Currently we rely on background color hex code stored in
       *  inline style.
       * Because of that when we copy and paste table, we end up
       *  having DST token or DST token value in ADF instead of
       *  original hex code which we map to DST token.
       * So, introducing data-cell-background.
       * More details at https://product-fabric.atlassian.net/wiki/spaces/EUXQ/pages/3472556903/Tokenising+tableCell+background+colors#Update-toDom-and-parseDom-to-store-and-read-background-color-from-data-cell-background-attribute.4
       */ if (color) attrs['data-cell-background'] = color;
            if (typeof color === 'string') attrs.colorname = $bca4bcd38fb8105c$export$219b7f492ad209f8.get(color.toLowerCase());
        }
    }
    if (nodeType === 'tableHeader') attrs.class = $bca4bcd38fb8105c$export$7b07d37d879c957f;
    else attrs.class = $bca4bcd38fb8105c$export$69cb4c3f80383763;
    if (node !== null && node !== void 0 && (_node$attrs = node.attrs) !== null && _node$attrs !== void 0 && _node$attrs.localId) attrs['data-local-id'] = node.attrs.localId;
    return attrs;
};
var $bca4bcd38fb8105c$export$219b7f492ad209f8 = new Map();
var $bca4bcd38fb8105c$export$95e9c925fbf01d1c = (0, $22vaF.hexToRgba)((0, $22vaF.N800), 0.12) || (0, $22vaF.N0);
var $bca4bcd38fb8105c$export$8cc2833b5b349a1e = new Map();
[
    [
        (0, $22vaF.N0),
        'White'
    ],
    [
        (0, $22vaF.B50),
        'Light blue'
    ],
    [
        (0, $22vaF.T50),
        'Light teal'
    ],
    [
        (0, $22vaF.G50),
        'Light green'
    ],
    [
        (0, $22vaF.Y50),
        'Light yellow'
    ],
    [
        (0, $22vaF.R50),
        'Light red'
    ],
    [
        (0, $22vaF.P50),
        'Light purple'
    ],
    [
        (0, $22vaF.N20),
        'Light gray'
    ],
    [
        (0, $22vaF.B75),
        'Blue'
    ],
    [
        (0, $22vaF.T75),
        'Teal'
    ],
    [
        (0, $22vaF.G75),
        'Green'
    ],
    [
        (0, $22vaF.Y75),
        'Yellow'
    ],
    [
        (0, $22vaF.R75),
        'Red'
    ],
    [
        (0, $22vaF.P75),
        'Purple'
    ],
    [
        (0, $22vaF.N60),
        'Gray'
    ],
    [
        (0, $22vaF.B100),
        'Dark blue'
    ],
    [
        (0, $22vaF.T100),
        'Dark teal'
    ],
    [
        (0, $22vaF.G200),
        'Dark green'
    ],
    [
        (0, $22vaF.Y200),
        'Dark yellow'
    ],
    [
        (0, $22vaF.R100),
        'Dark red'
    ],
    [
        (0, $22vaF.P100),
        'Dark purple'
    ]
].forEach(function(_ref) {
    var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_ref, 2), colorValue = _ref2[0], colorName = _ref2[1];
    $bca4bcd38fb8105c$export$219b7f492ad209f8.set(colorValue.toLowerCase(), colorName);
    $bca4bcd38fb8105c$export$8cc2833b5b349a1e.set(colorName.toLowerCase(), colorValue.toLowerCase());
});
/**
 * @name table_node
 */ /**
 * @name table_row_node
 */ /**
 * @name table_cell_content
 * @minItems 1
 * @allowUnsupportedBlock true
 */ /**
 * @name table_cell_node
 */ /**
 * @name table_header_node
 */ // table nodes with nested tables support
var $bca4bcd38fb8105c$var$tableNodeSpecOptions = {
    parseDOM: [
        {
            tag: 'table',
            getAttrs: function getAttrs(node) {
                var _dom$parentElement;
                var dom = node;
                var breakoutWrapper = (_dom$parentElement = dom.parentElement) === null || _dom$parentElement === void 0 ? void 0 : _dom$parentElement.parentElement;
                return {
                    isNumberColumnEnabled: dom.getAttribute('data-number-column') === 'true',
                    layout: // copying from editor
                    dom.getAttribute('data-layout') || (breakoutWrapper === null || breakoutWrapper === void 0 ? void 0 : breakoutWrapper.getAttribute('data-layout')) || 'default',
                    __autoSize: dom.getAttribute('data-autosize') === 'true',
                    localId: dom.getAttribute('data-table-local-id') || (0, $l4823.uuid).generate(),
                    width: Number(dom.getAttribute('data-table-width')) || null,
                    displayMode: dom.getAttribute('data-table-display-mode') || null
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var attrs = {
            'data-number-column': node.attrs.isNumberColumnEnabled,
            'data-layout': node.attrs.layout,
            'data-autosize': node.attrs.__autoSize,
            'data-table-local-id': node.attrs.localId,
            'data-table-width': node.attrs.width,
            'data-table-display-mode': node.attrs.displayMode
        };
        return [
            'table',
            attrs,
            [
                'tbody',
                0
            ]
        ];
    }
};
// TODO: Fix any, potential issue. ED-5048
var $bca4bcd38fb8105c$var$createTableSpec = function createTableSpec() {
    return (0, $2gWGi.table)($bca4bcd38fb8105c$var$tableNodeSpecOptions);
};
var $bca4bcd38fb8105c$export$9852986a3ec5f6a0 = $bca4bcd38fb8105c$var$createTableSpec();
var $bca4bcd38fb8105c$export$90e634fbace1f0c4 = $bca4bcd38fb8105c$var$createTableSpec();
var $bca4bcd38fb8105c$export$3862de5c8c9098cf = $bca4bcd38fb8105c$var$createTableSpec();
var $bca4bcd38fb8105c$var$shouldIncludeAttribute = function shouldIncludeAttribute(key, value) {
    return !key.startsWith('__') && (key !== 'localId' || !!value);
};
var $bca4bcd38fb8105c$export$1f92a2f429e06fa8 = function tableToJSON(node) {
    return {
        attrs: Object.keys(node.attrs).filter(function(key) {
            return $bca4bcd38fb8105c$var$shouldIncludeAttribute(key, node.attrs[key]);
        }).reduce(function(obj, key) {
            return $bca4bcd38fb8105c$var$_objectSpread($bca4bcd38fb8105c$var$_objectSpread({}, obj), {}, (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, key, node.attrs[key]));
        }, {})
    };
};
var $bca4bcd38fb8105c$var$tableRowNodeSpecOptions = {
    parseDOM: [
        {
            tag: 'tr'
        }
    ],
    toDOM: function toDOM() {
        return [
            'tr',
            0
        ];
    }
};
var $bca4bcd38fb8105c$export$ce666bf02318c957 = (0, $2gWGi.tableRow)($bca4bcd38fb8105c$var$tableRowNodeSpecOptions);
var $bca4bcd38fb8105c$var$cellAttrs = {
    colspan: {
        default: 1
    },
    rowspan: {
        default: 1
    },
    colwidth: {
        default: null
    },
    background: {
        default: null
    },
    localId: {
        default: null,
        optional: true
    }
};
var $bca4bcd38fb8105c$var$tableCellNodeSpecOptions = {
    parseDOM: [
        // Ignore number cell copied from renderer
        {
            tag: '.ak-renderer-table-number-column',
            ignore: true
        },
        {
            tag: 'td',
            getAttrs: function getAttrs(dom) {
                return $bca4bcd38fb8105c$export$43977bde391e007(dom);
            }
        }
    ],
    toDOM: function toDOM(node) {
        return [
            'td',
            $bca4bcd38fb8105c$export$363c8dda799bfe9c(node),
            0
        ];
    }
};
var $bca4bcd38fb8105c$export$e1e720e5f4603e6a = (0, $2gWGi.tableCell)($bca4bcd38fb8105c$var$tableCellNodeSpecOptions);
var $bca4bcd38fb8105c$export$2ac34c099660f1a8 = function toJSONTableCell(node) {
    return {
        attrs: Object.keys(node.attrs).reduce(function(obj, key) {
            // Only process keys that are defined in cellAttrs
            if ($bca4bcd38fb8105c$var$cellAttrs[key] && $bca4bcd38fb8105c$var$cellAttrs[key].default !== node.attrs[key]) obj[key] = node.attrs[key];
            return obj;
        }, {})
    };
};
var $bca4bcd38fb8105c$var$tableHeaderNodeSpecOptions = {
    parseDOM: [
        {
            tag: 'th',
            getAttrs: function getAttrs(dom) {
                return $bca4bcd38fb8105c$export$43977bde391e007(dom, {
                    background: $bca4bcd38fb8105c$var$DEFAULT_TABLE_HEADER_CELL_BACKGROUND
                });
            }
        }
    ],
    toDOM: function toDOM(node) {
        return [
            'th',
            $bca4bcd38fb8105c$export$363c8dda799bfe9c(node),
            0
        ];
    }
};
var $bca4bcd38fb8105c$export$48884d2a5190dc73 = (0, $2gWGi.tableHeader)($bca4bcd38fb8105c$var$tableHeaderNodeSpecOptions);
var $bca4bcd38fb8105c$export$2af48797a1010bb1 = $bca4bcd38fb8105c$export$2ac34c099660f1a8;
var $bca4bcd38fb8105c$export$ce086a560a1d05f5 = (0, $2gWGi.tableWithNestedTable)($bca4bcd38fb8105c$var$tableNodeSpecOptions);
var $bca4bcd38fb8105c$export$7d657479499397 = (0, $2gWGi.tableRowWithNestedTable)($bca4bcd38fb8105c$var$tableRowNodeSpecOptions);
var $bca4bcd38fb8105c$export$abf39ca178940ff3 = (0, $2gWGi.tableCellWithNestedTable)($bca4bcd38fb8105c$var$tableCellNodeSpecOptions);
var $bca4bcd38fb8105c$export$2a5a518232fa1a97 = (0, $2gWGi.tableHeaderWithNestedTable)($bca4bcd38fb8105c$var$tableHeaderNodeSpecOptions);
// table nodes with localId support
var $bca4bcd38fb8105c$var$tableRowNodeSpecOptionsWithLocalId = {
    parseDOM: [
        {
            tag: 'tr',
            getAttrs: function getAttrs() {
                return {
                    localId: (0, $l4823.uuid).generate()
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node$attrs2;
        return [
            'tr',
            {
                'data-local-id': (node === null || node === void 0 ? void 0 : (_node$attrs2 = node.attrs) === null || _node$attrs2 === void 0 ? void 0 : _node$attrs2.localId) || undefined
            },
            0
        ];
    }
};
var $bca4bcd38fb8105c$export$c8f0853ac97552c9 = (0, $2gWGi.tableRow)($bca4bcd38fb8105c$var$tableRowNodeSpecOptionsWithLocalId);
var $bca4bcd38fb8105c$var$tableCellNodeSpecOptionsWithLocalId = {
    parseDOM: [
        {
            tag: 'td',
            getAttrs: function getAttrs(dom) {
                return $bca4bcd38fb8105c$export$43977bde391e007(dom, {
                    localId: (0, $l4823.uuid).generate()
                });
            }
        }
    ],
    toDOM: function toDOM(node) {
        return [
            'td',
            $bca4bcd38fb8105c$export$363c8dda799bfe9c(node),
            0
        ];
    }
};
var $bca4bcd38fb8105c$export$db76cfd28a574029 = (0, $2gWGi.tableCell)($bca4bcd38fb8105c$var$tableCellNodeSpecOptionsWithLocalId);
var $bca4bcd38fb8105c$var$tableHeaderNodeSpecOptionsWithLocalId = {
    parseDOM: [
        {
            tag: 'th',
            getAttrs: function getAttrs(dom) {
                return $bca4bcd38fb8105c$export$43977bde391e007(dom, {
                    background: $bca4bcd38fb8105c$var$DEFAULT_TABLE_HEADER_CELL_BACKGROUND,
                    localId: (0, $l4823.uuid).generate()
                });
            }
        }
    ],
    toDOM: function toDOM(node) {
        return [
            'th',
            $bca4bcd38fb8105c$export$363c8dda799bfe9c(node),
            0
        ];
    }
};
var $bca4bcd38fb8105c$export$b82d2b1d8824143d = (0, $2gWGi.tableHeader)($bca4bcd38fb8105c$var$tableHeaderNodeSpecOptionsWithLocalId);
var $bca4bcd38fb8105c$export$27926e30c8a74147 = (0, $2gWGi.tableRowWithNestedTable)($bca4bcd38fb8105c$var$tableRowNodeSpecOptionsWithLocalId);
var $bca4bcd38fb8105c$export$e9fd700fafee293a = (0, $2gWGi.tableCellWithNestedTable)($bca4bcd38fb8105c$var$tableCellNodeSpecOptionsWithLocalId);
var $bca4bcd38fb8105c$export$7928c3aeb4cd2213 = (0, $2gWGi.tableHeaderWithNestedTable)($bca4bcd38fb8105c$var$tableHeaderNodeSpecOptionsWithLocalId);

});
parcelRegister("aE9eF", function(module, exports) {
$parcel$export(module.exports, "hexToEditorBorderPaletteColor", () => $7c04cdcda82d9b65$export$bad3c41dd33cb4bc);
$parcel$export(module.exports, "hexToEditorTextPaletteColor", () => $7c04cdcda82d9b65$export$9c2f408d391feb93);
$parcel$export(module.exports, "hexToEditorTextBackgroundPaletteColor", () => $7c04cdcda82d9b65$export$8b58ff1b36bb75e0);
$parcel$export(module.exports, "hexToEditorBackgroundPaletteRawValue", () => $7c04cdcda82d9b65$export$a270511a0e7fd61a);

var $fqXMt = parcelRequire("fqXMt");
function $7c04cdcda82d9b65$export$bad3c41dd33cb4bc(hexColor) {
    // Ts ignore was used to allow use of conditional return type
    // (preferencing better type on consumption over safety in implementation)
    return hexColor ? $7c04cdcda82d9b65$export$aa000893c5e2b9c2[hexColor.toUpperCase()] : undefined;
}
var $7c04cdcda82d9b65$export$aa000893c5e2b9c2 = {
    /** gray - subtle */ '#091E4224': 'var(--ds-border, #091E4224)',
    /** gray */ '#758195': 'var(--ds-border-bold, #758195)',
    /** gray - bold */ '#172B4D': 'var(--ds-text, #172B4D)'
};
function $7c04cdcda82d9b65$export$9c2f408d391feb93(hexColor) {
    // Ts ignore was used to allow use of conditional return type
    // (preferencing better type on consumption over safety in implementation)
    return hexColor ? $7c04cdcda82d9b65$export$57fa5089caad992[hexColor.toUpperCase()] : undefined;
}
var $7c04cdcda82d9b65$export$57fa5089caad992 = {
    /** blue - light */ '#B3D4FF': 'var(--ds-background-accent-blue-subtler, #B3D4FF)',
    /** blue - medium */ '#4C9AFF': 'var(--ds-icon-accent-blue, #4C9AFF)',
    /** blue - strong */ '#0747A6': 'var(--ds-text-accent-blue, #0747A6)',
    /** teal - light */ '#B3F5FF': 'var(--ds-background-accent-teal-subtler, #B3F5FF)',
    /** teal - medium */ '#00B8D9': 'var(--ds-icon-accent-teal, #00B8D9)',
    /** teal - strong */ '#008DA6': 'var(--ds-text-accent-teal, #008DA6)',
    /** green - light */ '#ABF5D1': 'var(--ds-background-accent-green-subtler, #ABF5D1)',
    /** green - medium */ '#36B37E': 'var(--ds-icon-accent-green, #36B37E)',
    /** green - strong */ '#006644': 'var(--ds-text-accent-green, #006644)',
    /** yellowOrange - light */ '#FFF0B3': 'var(--ds-background-accent-yellow-subtler, #FFF0B3)',
    /** yellowOrange - medium */ '#FFC400': 'var(--ds-background-accent-orange-subtle, #FFC400)',
    /** yellowOrange - strong */ '#FF991F': 'var(--ds-icon-accent-orange, #FF991F)',
    /** red - light */ '#FFBDAD': 'var(--ds-background-accent-red-subtler, #FFBDAD)',
    /** red - medium */ '#FF5630': 'var(--ds-icon-accent-red, #FF5630)',
    /** red - strong */ '#BF2600': 'var(--ds-text-accent-red, #BF2600)',
    /** purple - light */ '#EAE6FF': 'var(--ds-background-accent-purple-subtler, #EAE6FF)',
    /** purple - medium */ '#6554C0': 'var(--ds-icon-accent-purple, #6554C0)',
    /** purple - strong */ '#403294': 'var(--ds-text-accent-purple, #403294)',
    /** whiteGray - light */ '#FFFFFF': 'var(--ds-text-inverse, #FFFFFF)',
    /** whiteGray - medium */ '#97A0AF': 'var(--ds-icon-accent-gray, #97A0AF)',
    /** whiteGray - strong */ '#172B4D': 'var(--ds-text, #172B4D)'
};
function $7c04cdcda82d9b65$export$8b58ff1b36bb75e0(hexColor) {
    if ((0, $fqXMt.default).getExperimentValue('platform_editor_add_orange_highlight_color', 'cohort', 'control') !== 'test') $7c04cdcda82d9b65$export$12a518ff137dd389['#FEDEC8'] = 'var(--ds-background-accent-yellow-subtler, #F8E6A0)';
    // Ts ignore was used to allow use of conditional return type
    // (preferring better type on consumption over safety in implementation)
    return hexColor ? $7c04cdcda82d9b65$export$12a518ff137dd389[hexColor.toUpperCase()] : undefined;
}
var $7c04cdcda82d9b65$export$12a518ff137dd389 = {
    /** Gray - light */ '#DCDFE4': 'var(--ds-background-accent-gray-subtler, #DCDFE4)',
    /** Teal - light */ '#C6EDFB': 'var(--ds-background-accent-teal-subtler, #C6EDFB)',
    /** Lime - light */ '#D3F1A7': 'var(--ds-background-accent-lime-subtler, #D3F1A7)',
    /** Yellow - light */ '#F8E6A0': 'var(--ds-background-accent-yellow-subtler, #F8E6A0)',
    /** Orange - light */ '#FEDEC8': 'var(--ds-background-accent-orange-subtler, #FEDEC8)',
    /** Magenta - light */ '#FDD0EC': 'var(--ds-background-accent-magenta-subtler, #FDD0EC)',
    /** Purple - light */ '#DFD8FD': 'var(--ds-background-accent-purple-subtler, #DFD8FD)'
};
function $7c04cdcda82d9b65$export$a270511a0e7fd61a(hexColor) {
    // Ts ignore was used to allow use of conditional return type
    // (preferencing better type on consumption over safety in implementation)
    var tokenData = hexColor ? $7c04cdcda82d9b65$export$2462741d70e6a62f[hexColor.toUpperCase()] : undefined;
    return tokenData ? tokenData.getValue(hexColor) : undefined;
}
var $7c04cdcda82d9b65$export$2462741d70e6a62f = {
    /** blue - light */ '#DEEBFF': {
        getValue: function getValue() {
            return '#DEEBFF';
        },
        token: 'var(--ds-background-accent-blue-subtlest, #DEEBFF)'
    },
    /** blue - medium */ '#B3D4FF': {
        getValue: function getValue() {
            return '#B3D4FF';
        },
        token: 'var(--ds-background-accent-blue-subtler, #B3D4FF)'
    },
    /** blue - strong */ '#4C9AFF': {
        getValue: function getValue() {
            return '#4C9AFF';
        },
        token: 'var(--ds-background-accent-blue-subtle, #4C9AFF)'
    },
    /** teal - light */ '#E6FCFF': {
        getValue: function getValue() {
            return '#E6FCFF';
        },
        token: 'var(--ds-background-accent-teal-subtlest, #E6FCFF)'
    },
    /** teal - medium */ '#B3F5FF': {
        getValue: function getValue() {
            return '#B3F5FF';
        },
        token: 'var(--ds-background-accent-teal-subtler, #B3F5FF)'
    },
    /** teal - strong */ '#79E2F2': {
        getValue: function getValue() {
            return '#79E2F2';
        },
        token: 'var(--ds-background-accent-teal-subtle, #79E2F2)'
    },
    /** green - light */ '#E3FCEF': {
        getValue: function getValue() {
            return '#E3FCEF';
        },
        token: 'var(--ds-background-accent-green-subtlest, #E3FCEF)'
    },
    /** green - medium */ '#ABF5D1': {
        getValue: function getValue() {
            return '#ABF5D1';
        },
        token: 'var(--ds-background-accent-green-subtler, #ABF5D1)'
    },
    /** green - strong */ '#57D9A3': {
        getValue: function getValue() {
            return '#57D9A3';
        },
        token: 'var(--ds-background-accent-green-subtle, #57D9A3)'
    },
    /** yellowOrange - light */ '#FFFAE6': {
        getValue: function getValue() {
            return '#FFFAE6';
        },
        token: 'var(--ds-background-accent-yellow-subtlest, #FFFAE6)'
    },
    /** yellowOrange - medium */ '#FFF0B3': {
        getValue: function getValue() {
            return '#FFF0B3';
        },
        token: 'var(--ds-background-accent-yellow-subtler, #FFF0B3)'
    },
    /** yellowOrange - strong */ '#FFC400': {
        getValue: function getValue() {
            return '#FFC400';
        },
        token: 'var(--ds-background-accent-orange-subtle, #FFC400)'
    },
    /** red - light */ '#FFEBE6': {
        getValue: function getValue() {
            return '#FFEBE6';
        },
        token: 'var(--ds-background-accent-red-subtlest, #FFEBE6)'
    },
    /** red - medium */ '#FFBDAD': {
        getValue: function getValue() {
            return '#FFBDAD';
        },
        token: 'var(--ds-background-accent-red-subtler, #FFBDAD)'
    },
    /** red - strong */ '#FF8F73': {
        getValue: function getValue() {
            return '#FF8F73';
        },
        token: 'var(--ds-background-accent-red-subtle, #FF8F73)'
    },
    /** purple - light */ '#EAE6FF': {
        getValue: function getValue() {
            return '#EAE6FF';
        },
        token: 'var(--ds-background-accent-purple-subtlest, #EAE6FF)'
    },
    /** purple - medium */ '#C0B6F2': {
        getValue: function getValue() {
            return '#C0B6F2';
        },
        token: 'var(--ds-background-accent-purple-subtler, #C0B6F2)'
    },
    /** purple - strong */ '#998DD9': {
        getValue: function getValue() {
            return '#998DD9';
        },
        token: 'var(--ds-background-accent-purple-subtle, #998DD9)'
    },
    /** whiteGray - light */ '#FFFFFF': {
        getValue: function getValue() {
            return '#FFFFFF';
        },
        token: 'var(--ds-surface, #FFFFFF)'
    },
    /** whiteGray - medium */ '#F4F5F7': {
        getValue: function getValue() {
            return '#F4F5F7';
        },
        token: 'var(--ds-background-accent-gray-subtlest, #F4F5F7)'
    },
    /** whiteGray - strong */ '#B3BAC5': {
        getValue: function getValue() {
            return '#B3BAC5';
        },
        token: 'var(--ds-background-accent-gray-subtle, #B3BAC5)'
    }
};

});
parcelRegister("fqXMt", function(module, exports) {
$parcel$export(module.exports, "default", () => $b3c7a7f2a539583a$export$2e2bcd8739ae039);

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $25nEq = parcelRequire("25nEq");

var $aMpau = parcelRequire("aMpau");

var $22KTL = parcelRequire("22KTL");



var $b3c7a7f2a539583a$var$_FeatureGates;
/**
 * Access the FeatureGates object via the default export.
 * ```ts
 * import FeatureGates from '@atlaskit/feature-gate-js-client';
 * ```
 */ var $b3c7a7f2a539583a$var$FeatureGates = /*#__PURE__*/ function() {
    function FeatureGates() {
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, FeatureGates);
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(FeatureGates, null, [
        {
            key: "isGateExists",
            value: function isGateExists(gateName) {
                return this.client.isGateExist(gateName);
            }
        },
        {
            key: "isExperimentExists",
            value: function isExperimentExists(experimentName) {
                return this.client.isExperimentExist(experimentName);
            }
        }
    ]);
}();
$b3c7a7f2a539583a$var$_FeatureGates = $b3c7a7f2a539583a$var$FeatureGates;
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($b3c7a7f2a539583a$var$FeatureGates, "client", new (0, $aMpau.Client)());
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($b3c7a7f2a539583a$var$FeatureGates, "hasCheckGateErrorOccurred", false);
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($b3c7a7f2a539583a$var$FeatureGates, "hasGetExperimentValueErrorOccurred", false);
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($b3c7a7f2a539583a$var$FeatureGates, "checkGate", function(gateName, options) {
    try {
        // Check if the CRITERION override mechanism is available
        if (typeof window !== 'undefined' && window.__CRITERION__ && typeof window.__CRITERION__.getFeatureFlagOverride === 'function') {
            // Attempt to retrieve an override value for the feature gate
            var overrideValue = window.__CRITERION__.getFeatureFlagOverride(gateName);
            // If an override value is found, return it immediately
            if (overrideValue !== undefined) return overrideValue;
        }
    } catch (error) {
        // Log the first occurrence of the error
        if (!$b3c7a7f2a539583a$var$_FeatureGates.hasCheckGateErrorOccurred) {
            // eslint-disable-next-line no-console
            console.warn({
                msg: 'An error has occurred checking the feature gate from criterion override. Only the first occurrence of this error is logged.',
                gateName: gateName,
                error: error
            });
            $b3c7a7f2a539583a$var$_FeatureGates.hasCheckGateErrorOccurred = true;
        }
    }
    // Proceed with the main logic if no override is found
    return $b3c7a7f2a539583a$var$_FeatureGates.client.checkGate(gateName, options);
});
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($b3c7a7f2a539583a$var$FeatureGates, "getExperimentValue", function(experimentName, parameterName, defaultValue, options) {
    try {
        // Check if the CRITERION override mechanism is available
        if (typeof window !== 'undefined' && window.__CRITERION__ && typeof window.__CRITERION__.getExperimentValueOverride === 'function') {
            var overrideValue = window.__CRITERION__.getExperimentValueOverride(experimentName, parameterName);
            if (overrideValue !== undefined && overrideValue !== null) return overrideValue;
        }
    } catch (error) {
        // Log the first occurrence of the error
        if (!$b3c7a7f2a539583a$var$_FeatureGates.hasGetExperimentValueErrorOccurred) {
            // eslint-disable-next-line no-console
            console.warn({
                msg: 'An error has occurred getting the experiment value from criterion override. Only the first occurrence of this error is logged.',
                experimentName: experimentName,
                defaultValue: defaultValue,
                options: options,
                error: error
            });
            $b3c7a7f2a539583a$var$_FeatureGates.hasGetExperimentValueErrorOccurred = true;
        }
        return defaultValue;
    }
    // Proceed with the main logic if no override is found
    return $b3c7a7f2a539583a$var$_FeatureGates.client.getExperimentValue(experimentName, parameterName, defaultValue, options);
});
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($b3c7a7f2a539583a$var$FeatureGates, "initializeCalled", $b3c7a7f2a539583a$var$_FeatureGates.client.initializeCalled.bind($b3c7a7f2a539583a$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($b3c7a7f2a539583a$var$FeatureGates, "initializeCompleted", $b3c7a7f2a539583a$var$_FeatureGates.client.initializeCompleted.bind($b3c7a7f2a539583a$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($b3c7a7f2a539583a$var$FeatureGates, "initialize", $b3c7a7f2a539583a$var$_FeatureGates.client.initialize.bind($b3c7a7f2a539583a$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($b3c7a7f2a539583a$var$FeatureGates, "initializeWithProvider", $b3c7a7f2a539583a$var$_FeatureGates.client.initializeWithProvider.bind($b3c7a7f2a539583a$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($b3c7a7f2a539583a$var$FeatureGates, "initializeFromValues", $b3c7a7f2a539583a$var$_FeatureGates.client.initializeFromValues.bind($b3c7a7f2a539583a$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($b3c7a7f2a539583a$var$FeatureGates, "manuallyLogGateExposure", $b3c7a7f2a539583a$var$_FeatureGates.client.manuallyLogGateExposure.bind($b3c7a7f2a539583a$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($b3c7a7f2a539583a$var$FeatureGates, "getExperiment", $b3c7a7f2a539583a$var$_FeatureGates.client.getExperiment.bind($b3c7a7f2a539583a$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($b3c7a7f2a539583a$var$FeatureGates, "manuallyLogExperimentExposure", $b3c7a7f2a539583a$var$_FeatureGates.client.manuallyLogExperimentExposure.bind($b3c7a7f2a539583a$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($b3c7a7f2a539583a$var$FeatureGates, "manuallyLogLayerExposure", $b3c7a7f2a539583a$var$_FeatureGates.client.manuallyLogLayerExposure.bind($b3c7a7f2a539583a$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($b3c7a7f2a539583a$var$FeatureGates, "shutdownStatsig", $b3c7a7f2a539583a$var$_FeatureGates.client.shutdownStatsig.bind($b3c7a7f2a539583a$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($b3c7a7f2a539583a$var$FeatureGates, "overrideGate", $b3c7a7f2a539583a$var$_FeatureGates.client.overrideGate.bind($b3c7a7f2a539583a$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($b3c7a7f2a539583a$var$FeatureGates, "clearGateOverride", $b3c7a7f2a539583a$var$_FeatureGates.client.clearGateOverride.bind($b3c7a7f2a539583a$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($b3c7a7f2a539583a$var$FeatureGates, "overrideConfig", $b3c7a7f2a539583a$var$_FeatureGates.client.overrideConfig.bind($b3c7a7f2a539583a$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($b3c7a7f2a539583a$var$FeatureGates, "clearConfigOverride", $b3c7a7f2a539583a$var$_FeatureGates.client.clearConfigOverride.bind($b3c7a7f2a539583a$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($b3c7a7f2a539583a$var$FeatureGates, "setOverrides", $b3c7a7f2a539583a$var$_FeatureGates.client.setOverrides.bind($b3c7a7f2a539583a$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($b3c7a7f2a539583a$var$FeatureGates, "getOverrides", $b3c7a7f2a539583a$var$_FeatureGates.client.getOverrides.bind($b3c7a7f2a539583a$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($b3c7a7f2a539583a$var$FeatureGates, "clearAllOverrides", $b3c7a7f2a539583a$var$_FeatureGates.client.clearAllOverrides.bind($b3c7a7f2a539583a$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($b3c7a7f2a539583a$var$FeatureGates, "isCurrentUser", $b3c7a7f2a539583a$var$_FeatureGates.client.isCurrentUser.bind($b3c7a7f2a539583a$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($b3c7a7f2a539583a$var$FeatureGates, "onGateUpdated", $b3c7a7f2a539583a$var$_FeatureGates.client.onGateUpdated.bind($b3c7a7f2a539583a$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($b3c7a7f2a539583a$var$FeatureGates, "onExperimentValueUpdated", $b3c7a7f2a539583a$var$_FeatureGates.client.onExperimentValueUpdated.bind($b3c7a7f2a539583a$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($b3c7a7f2a539583a$var$FeatureGates, "onAnyUpdated", $b3c7a7f2a539583a$var$_FeatureGates.client.onAnyUpdated.bind($b3c7a7f2a539583a$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($b3c7a7f2a539583a$var$FeatureGates, "updateUser", $b3c7a7f2a539583a$var$_FeatureGates.client.updateUser.bind($b3c7a7f2a539583a$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($b3c7a7f2a539583a$var$FeatureGates, "updateUserWithProvider", $b3c7a7f2a539583a$var$_FeatureGates.client.updateUserWithProvider.bind($b3c7a7f2a539583a$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($b3c7a7f2a539583a$var$FeatureGates, "updateUserWithValues", $b3c7a7f2a539583a$var$_FeatureGates.client.updateUserWithValues.bind($b3c7a7f2a539583a$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($b3c7a7f2a539583a$var$FeatureGates, "getPackageVersion", $b3c7a7f2a539583a$var$_FeatureGates.client.getPackageVersion.bind($b3c7a7f2a539583a$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($b3c7a7f2a539583a$var$FeatureGates, "getLayer", $b3c7a7f2a539583a$var$_FeatureGates.client.getLayer.bind($b3c7a7f2a539583a$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($b3c7a7f2a539583a$var$FeatureGates, "getLayerValue", $b3c7a7f2a539583a$var$_FeatureGates.client.getLayerValue.bind($b3c7a7f2a539583a$var$_FeatureGates.client));
var $b3c7a7f2a539583a$var$boundFGJS = $b3c7a7f2a539583a$var$FeatureGates;
// This makes it possible to get a reference to the FeatureGates client at runtime.
// This is important for overriding values in Cypress tests, as there needs to be a
// way to get the exact instance for a window in order to mock some of its methods.
if (typeof window !== 'undefined') {
    if (window.__FEATUREGATES_JS__ === undefined) window.__FEATUREGATES_JS__ = $b3c7a7f2a539583a$var$FeatureGates;
    else {
        var $b3c7a7f2a539583a$var$_boundFGJS, $b3c7a7f2a539583a$var$_boundFGJS$getPackage;
        $b3c7a7f2a539583a$var$boundFGJS = window.__FEATUREGATES_JS__;
        var $b3c7a7f2a539583a$var$boundVersion = (($b3c7a7f2a539583a$var$_boundFGJS = $b3c7a7f2a539583a$var$boundFGJS) === null || $b3c7a7f2a539583a$var$_boundFGJS === void 0 || ($b3c7a7f2a539583a$var$_boundFGJS$getPackage = $b3c7a7f2a539583a$var$_boundFGJS.getPackageVersion) === null || $b3c7a7f2a539583a$var$_boundFGJS$getPackage === void 0 ? void 0 : $b3c7a7f2a539583a$var$_boundFGJS$getPackage.call($b3c7a7f2a539583a$var$_boundFGJS)) || '4.10.0 or earlier';
        if ($b3c7a7f2a539583a$var$boundVersion !== (0, $22KTL.CLIENT_VERSION)) {
            var $b3c7a7f2a539583a$var$message = "Multiple versions of FeatureGateClients found on the current page.\n      The currently bound version is ".concat($b3c7a7f2a539583a$var$boundVersion, " when module version ").concat((0, $22KTL.CLIENT_VERSION), " was loading.");
            // eslint-disable-next-line no-console
            console.warn($b3c7a7f2a539583a$var$message);
        }
    }
}
var /**
 * @property {FeatureGates} FeatureGate default export
 */ $b3c7a7f2a539583a$export$2e2bcd8739ae039 = $b3c7a7f2a539583a$var$boundFGJS;

});
parcelRegister("aMpau", function(module, exports) {
$parcel$export(module.exports, "Client", () => $7d91e8f8404f7e13$export$1f2bb630327ac4b6);

var $1Vcia = parcelRequire("1Vcia");

var $iYJcE = parcelRequire("iYJcE");

var $fL8KA = parcelRequire("fL8KA");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $25nEq = parcelRequire("25nEq");

var $6HG4S = parcelRequire("6HG4S");

var $iFR7a = parcelRequire("iFR7a");

var $344Sl = parcelRequire("344Sl");

var $jtLwS = parcelRequire("jtLwS");

var $213zb = parcelRequire("213zb");

var $7BkNf = parcelRequire("7BkNf");

var $d4i2e = parcelRequire("d4i2e");

var $arraH = parcelRequire("arraH");

var $4DKZE = parcelRequire("4DKZE");

var $eMunP = parcelRequire("eMunP");

var $nlPYW = parcelRequire("nlPYW");

var $22KTL = parcelRequire("22KTL");
var $7d91e8f8404f7e13$var$_excluded = [
    "sdkKey",
    "environment",
    "updateUserCompletionCallback",
    "perimeter"
];
function $7d91e8f8404f7e13$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $7d91e8f8404f7e13$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $7d91e8f8404f7e13$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $7d91e8f8404f7e13$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $7d91e8f8404f7e13$var$DEFAULT_CLIENT_KEY = 'client-default-key';
// default event logging api is Atlassian proxy rather than Statsig's domain, to avoid ad blockers
var $7d91e8f8404f7e13$var$DEFAULT_EVENT_LOGGING_API = 'https://xp.atlassian.com/v1/rgstr';
var $7d91e8f8404f7e13$export$1f2bb630327ac4b6 = /*#__PURE__*/ function() {
    function Client() {
        var _this = this;
        var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, _ref$localStorageKey = _ref.localStorageKey, localStorageKey = _ref$localStorageKey === void 0 ? (0, $4DKZE.LOCAL_STORAGE_KEY) : _ref$localStorageKey;
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, Client);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "initPromise", null);
        /** True if an initialize method was called and completed successfully. */ (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "initCompleted", false);
        /**
     * True if an initialize method was called and completed, meaning the client is now usable.
     * However if there was an error during initialization it may have initialized with default
     * values. Use {@link initCompleted} to check for this.
     */ (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "initWithDefaults", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "hasCheckGateErrorOccurred", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "hasGetExperimentErrorOccurred", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "hasGetExperimentValueErrorOccurred", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "hasGetLayerErrorOccurred", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "hasGetLayerValueErrorOccurred", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "subscriptions", new (0, $344Sl.default)());
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "dataAdapter", new (0, $arraH.NoFetchDataAdapter)());
        /**
     * Call this if modifying the values being served by the Statsig library since it has its own
     * memoization cache which will not be updated if the values are changed outside of the library.
     */ (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "statsigValuesUpdated", function() {
            if (_this.user) // Trigger a reset of the memoize cache
            _this.statsigClient.updateUserSync(_this.user, {
                disableBackgroundCacheRefresh: true
            });
            _this.subscriptions.anyUpdated();
        });
        this.overrideAdapter = new (0, $4DKZE.PersistentOverrideAdapter)(localStorageKey);
    }
    /**
   * @description
   * This method initializes the client using a network call to fetch the bootstrap values.
   * If the client is inialized with an `analyticsWebClient`, it will send an operational event
   * to GASv3 with the following attributes:
   * - targetApp: the target app of the client
   * - clientVersion: the version of the client
   * - success: whether the initialization was successful
   * - startTime: the time when the initialization started
   * - totalTime: the total time it took to initialize the client
   * - apiKey: the api key used to initialize the client
   * @param clientOptions {ClientOptions}
   * @param identifiers {Identifiers}
   * @param customAttributes {CustomAttributes}
   * @returns {Promise<void>}
   */ return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(Client, [
        {
            key: "initialize",
            value: function() {
                var _initialize = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee(clientOptions, identifiers, customAttributes) {
                    var _this2 = this;
                    var clientOptionsWithDefaults, startTime;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee$(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                clientOptionsWithDefaults = (0, $nlPYW.getOptionsWithDefaults)(clientOptions);
                                if (!this.initPromise) {
                                    _context.next = 4;
                                    break;
                                }
                                if (!(0, $nlPYW.shallowEquals)(clientOptionsWithDefaults, this.initOptions)) // eslint-disable-next-line no-console
                                console.warn('Feature Gates client already initialized with different options. New options were not applied.');
                                return _context.abrupt("return", this.initPromise);
                            case 4:
                                startTime = performance.now();
                                this.initOptions = clientOptionsWithDefaults;
                                this.initPromise = this.init(clientOptionsWithDefaults, identifiers, customAttributes).then(function() {
                                    _this2.initCompleted = true;
                                    _this2.initWithDefaults = true;
                                }).finally(function() {
                                    var endTime = performance.now();
                                    var totalTime = endTime - startTime;
                                    _this2.fireClientEvent(startTime, totalTime, 'initialize', _this2.initCompleted, clientOptionsWithDefaults.apiKey);
                                });
                                return _context.abrupt("return", this.initPromise);
                            case 8:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee, this);
                }));
                function initialize(_x, _x2, _x3) {
                    return _initialize.apply(this, arguments);
                }
                return initialize;
            }()
        },
        {
            key: "initializeWithProvider",
            value: function() {
                var _initializeWithProvider = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee2(clientOptions, provider, identifiers, customAttributes) {
                    var _this3 = this;
                    var clientOptionsWithDefaults, startTime;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee2$(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                clientOptionsWithDefaults = (0, $nlPYW.getOptionsWithDefaults)(clientOptions);
                                if (!this.initPromise) {
                                    _context2.next = 4;
                                    break;
                                }
                                if (!(0, $nlPYW.shallowEquals)(clientOptionsWithDefaults, this.initOptions)) // eslint-disable-next-line no-console
                                console.warn('Feature Gates client already initialized with different options. New options were not applied.');
                                return _context2.abrupt("return", this.initPromise);
                            case 4:
                                startTime = performance.now();
                                this.initOptions = clientOptionsWithDefaults;
                                this.provider = provider;
                                this.provider.setClientVersion((0, $22KTL.CLIENT_VERSION));
                                if (this.provider.setApplyUpdateCallback) this.provider.setApplyUpdateCallback(this.applyUpdateCallback.bind(this));
                                this.initPromise = this.initWithProvider(clientOptionsWithDefaults, provider, identifiers, customAttributes).then(function() {
                                    _this3.initCompleted = true;
                                    _this3.initWithDefaults = true;
                                }).finally(function() {
                                    var endTime = performance.now();
                                    var totalTime = endTime - startTime;
                                    _this3.fireClientEvent(startTime, totalTime, 'initializeWithProvider', _this3.initCompleted, provider.getApiKey ? provider.getApiKey() : undefined);
                                });
                                return _context2.abrupt("return", this.initPromise);
                            case 11:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2, this);
                }));
                function initializeWithProvider(_x4, _x5, _x6, _x7) {
                    return _initializeWithProvider.apply(this, arguments);
                }
                return initializeWithProvider;
            }()
        },
        {
            key: "applyUpdateCallback",
            value: function applyUpdateCallback(experimentsResult) {
                try {
                    if (this.initCompleted || this.initWithDefaults) {
                        this.assertInitialized(this.statsigClient);
                        this.dataAdapter.setBootstrapData(experimentsResult.experimentValues);
                        this.dataAdapter.setData(JSON.stringify(experimentsResult.experimentValues));
                        this.statsigValuesUpdated();
                    }
                } catch (error) {
                    // eslint-disable-next-line no-console
                    console.warn('Error when attempting to apply update', error);
                }
            }
        },
        {
            key: "fireClientEvent",
            value: function fireClientEvent(startTime, totalTime, action, success) {
                var _analyticsWebClient, _this4 = this;
                var apiKey = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
                (_analyticsWebClient = this.initOptions.analyticsWebClient) === null || _analyticsWebClient === void 0 || _analyticsWebClient.then(function(analyticsWebClient) {
                    var attributes = $7d91e8f8404f7e13$var$_objectSpread({
                        targetApp: _this4.initOptions.targetApp,
                        clientVersion: (0, $22KTL.CLIENT_VERSION),
                        success: success,
                        startTime: startTime,
                        totalTime: totalTime
                    }, apiKey && {
                        apiKey: apiKey
                    });
                    analyticsWebClient.sendOperationalEvent({
                        action: action,
                        actionSubject: 'featureGatesClient',
                        attributes: attributes,
                        tags: [
                            'measurement'
                        ],
                        source: '@atlaskit/feature-gate-js-client'
                    });
                }).catch(function(err) {
                    if (_this4.initOptions.environment !== (0, $eMunP.FeatureGateEnvironment).Production) // eslint-disable-next-line no-console
                    console.error('Analytics web client promise did not resolve', err);
                });
            }
        },
        {
            key: "initializeFromValues",
            value: function() {
                var _initializeFromValues = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee3(clientOptions, identifiers, customAttributes) {
                    var _this5 = this;
                    var initializeValues, clientOptionsWithDefaults, startTime, _args3 = arguments;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee3$(_context3) {
                        while(true)switch(_context3.prev = _context3.next){
                            case 0:
                                initializeValues = _args3.length > 3 && _args3[3] !== undefined ? _args3[3] : {};
                                clientOptionsWithDefaults = (0, $nlPYW.getOptionsWithDefaults)(clientOptions);
                                if (!this.initPromise) {
                                    _context3.next = 5;
                                    break;
                                }
                                if (!(0, $nlPYW.shallowEquals)(clientOptionsWithDefaults, this.initOptions)) // eslint-disable-next-line no-console
                                console.warn('Feature Gates client already initialized with different options. New options were not applied.');
                                return _context3.abrupt("return", this.initPromise);
                            case 5:
                                // This makes sure the new Statsig client behaves like the old when bootstrap data is
                                // passed, and `has_updates` isn't specified (which happens a lot in product integration tests).
                                if (!Object.prototype.hasOwnProperty.call(initializeValues, 'has_updates')) initializeValues['has_updates'] = true;
                                startTime = performance.now();
                                this.initOptions = clientOptionsWithDefaults;
                                this.initPromise = this.initFromValues(clientOptionsWithDefaults, identifiers, customAttributes, initializeValues).then(function() {
                                    _this5.initCompleted = true;
                                    _this5.initWithDefaults = true;
                                }).finally(function() {
                                    var endTime = performance.now();
                                    var totalTime = endTime - startTime;
                                    _this5.fireClientEvent(startTime, totalTime, 'initializeFromValues', _this5.initCompleted);
                                });
                                return _context3.abrupt("return", this.initPromise);
                            case 10:
                            case "end":
                                return _context3.stop();
                        }
                    }, _callee3, this);
                }));
                function initializeFromValues(_x8, _x9, _x10) {
                    return _initializeFromValues.apply(this, arguments);
                }
                return initializeFromValues;
            }()
        },
        {
            key: "assertInitialized",
            value: function assertInitialized(statsigClient) {
                if (!statsigClient) throw new Error('Client must be initialized before using this method');
            }
        },
        {
            key: "updateUser",
            value: function() {
                var _updateUser = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee4(fetchOptions, identifiers, customAttributes) {
                    var fetchOptionsWithDefaults, initializeValuesProducer;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee4$(_context4) {
                        while(true)switch(_context4.prev = _context4.next){
                            case 0:
                                this.assertInitialized(this.statsigClient);
                                fetchOptionsWithDefaults = (0, $nlPYW.getOptionsWithDefaults)(fetchOptions);
                                initializeValuesProducer = function initializeValuesProducer() {
                                    return (0, $d4i2e.default).fetchExperimentValues(fetchOptionsWithDefaults, identifiers, customAttributes).then(function(_ref2) {
                                        var experimentValues = _ref2.experimentValues, customAttributes = _ref2.customAttributes;
                                        return {
                                            experimentValues: experimentValues,
                                            customAttributesFromFetch: customAttributes
                                        };
                                    });
                                };
                                _context4.next = 5;
                                return this.updateUserUsingInitializeValuesProducer(initializeValuesProducer, identifiers, customAttributes);
                            case 5:
                            case "end":
                                return _context4.stop();
                        }
                    }, _callee4, this);
                }));
                function updateUser(_x11, _x12, _x13) {
                    return _updateUser.apply(this, arguments);
                }
                return updateUser;
            }()
        },
        {
            key: "updateUserWithProvider",
            value: function() {
                var _updateUserWithProvider = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee5(identifiers, customAttributes) {
                    var _this6 = this;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee5$(_context5) {
                        while(true)switch(_context5.prev = _context5.next){
                            case 0:
                                this.assertInitialized(this.statsigClient);
                                if (this.provider) {
                                    _context5.next = 3;
                                    break;
                                }
                                throw new Error('Cannot update user using provider as the client was not initialised with a provider');
                            case 3:
                                _context5.next = 5;
                                return this.provider.setProfile(this.initOptions, identifiers, customAttributes);
                            case 5:
                                _context5.next = 7;
                                return this.updateUserUsingInitializeValuesProducer(function() {
                                    return _this6.provider.getExperimentValues();
                                }, identifiers, customAttributes);
                            case 7:
                            case "end":
                                return _context5.stop();
                        }
                    }, _callee5, this);
                }));
                function updateUserWithProvider(_x14, _x15) {
                    return _updateUserWithProvider.apply(this, arguments);
                }
                return updateUserWithProvider;
            }()
        },
        {
            key: "updateUserWithValues",
            value: function() {
                var _updateUserWithValues = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee6(identifiers, customAttributes) {
                    var initializeValues, initializeValuesProducer, _args6 = arguments;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee6$(_context6) {
                        while(true)switch(_context6.prev = _context6.next){
                            case 0:
                                initializeValues = _args6.length > 2 && _args6[2] !== undefined ? _args6[2] : {};
                                this.assertInitialized(this.statsigClient);
                                initializeValuesProducer = function initializeValuesProducer() {
                                    return Promise.resolve({
                                        experimentValues: initializeValues,
                                        customAttributesFromFetch: customAttributes
                                    });
                                };
                                _context6.next = 5;
                                return this.updateUserUsingInitializeValuesProducer(initializeValuesProducer, identifiers, customAttributes);
                            case 5:
                            case "end":
                                return _context6.stop();
                        }
                    }, _callee6, this);
                }));
                function updateUserWithValues(_x16, _x17) {
                    return _updateUserWithValues.apply(this, arguments);
                }
                return updateUserWithValues;
            }()
        },
        {
            key: "initializeCalled",
            value: function initializeCalled() {
                return this.initPromise != null;
            }
        },
        {
            key: "initializeCompleted",
            value: function initializeCompleted() {
                return this.initCompleted;
            }
        },
        {
            key: "checkGate",
            value: function checkGate(gateName) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                try {
                    this.assertInitialized(this.statsigClient);
                    var _options$fireGateExpo = options.fireGateExposure, fireGateExposure = _options$fireGateExpo === void 0 ? true : _options$fireGateExpo;
                    return this.statsigClient.checkGate(gateName, {
                        disableExposureLog: !fireGateExposure
                    });
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!this.hasCheckGateErrorOccurred) {
                        // eslint-disable-next-line no-console
                        console.warn({
                            msg: 'An error has occurred checking the feature gate. Only the first occurrence of this error is logged.',
                            gateName: gateName,
                            error: error
                        });
                        this.hasCheckGateErrorOccurred = true;
                    }
                    return false;
                }
            }
        },
        {
            key: "isGateExist",
            value: function isGateExist(gateName) {
                try {
                    this.assertInitialized(this.statsigClient);
                    var gate = this.statsigClient.getFeatureGate(gateName, {
                        disableExposureLog: true
                    });
                    return !gate.details.reason.includes('Unrecognized');
                } catch (error) {
                    // eslint-disable-next-line no-console
                    console.error("Error occurred when trying to check FeatureGate: ".concat(error));
                    // in case of error report true to avoid false positives.
                    return true;
                }
            }
        },
        {
            key: "isExperimentExist",
            value: function isExperimentExist(experimentName) {
                try {
                    this.assertInitialized(this.statsigClient);
                    var config = this.statsigClient.getExperiment(experimentName, {
                        disableExposureLog: true
                    });
                    return !config.details.reason.includes('Unrecognized');
                } catch (error) {
                    // eslint-disable-next-line no-console
                    console.error("Error occurred when trying to check Experiment: ".concat(error));
                    // in case of error report true to avoid false positives.
                    return true;
                }
            }
        },
        {
            key: "manuallyLogGateExposure",
            value: function manuallyLogGateExposure(gateName) {
                this.assertInitialized(this.statsigClient);
                // This is the approach recommended in the docs
                // https://docs.statsig.com/client/javascript-sdk/#manual-exposures-
                this.statsigClient.checkGate(gateName);
            }
        },
        {
            key: "getExperiment",
            value: function getExperiment(experimentName) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                try {
                    this.assertInitialized(this.statsigClient);
                    var _options$fireExperime = options.fireExperimentExposure, fireExperimentExposure = _options$fireExperime === void 0 ? true : _options$fireExperime;
                    return (0, $jtLwS.DynamicConfig).fromExperiment(this.statsigClient.getExperiment(experimentName, {
                        disableExposureLog: !fireExperimentExposure
                    }));
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!this.hasGetExperimentErrorOccurred) {
                        // eslint-disable-next-line no-console
                        console.warn({
                            msg: 'An error has occurred getting the experiment. Only the first occurrence of this error is logged.',
                            experimentName: experimentName,
                            error: error
                        });
                        this.hasGetExperimentErrorOccurred = true;
                    }
                    // Return a default value
                    return new (0, $jtLwS.DynamicConfig)(experimentName, {}, '', {
                        time: Date.now(),
                        reason: (0, $7BkNf.EvaluationReason).Error
                    });
                }
            }
        },
        {
            key: "getExperimentValue",
            value: function getExperimentValue(experimentName, parameterName, defaultValue) {
                var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var experiment = this.getExperiment(experimentName, options);
                try {
                    var typeGuard = options.typeGuard;
                    return experiment.get(parameterName, defaultValue, typeGuard);
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!this.hasGetExperimentValueErrorOccurred) {
                        // eslint-disable-next-line no-console
                        console.warn({
                            msg: 'An error has occurred getting the experiment value. Only the first occurrence of this error is logged.',
                            experimentName: experimentName,
                            defaultValue: defaultValue,
                            options: options,
                            error: error
                        });
                        this.hasGetExperimentValueErrorOccurred = true;
                    }
                    return defaultValue;
                }
            }
        },
        {
            key: "manuallyLogExperimentExposure",
            value: function manuallyLogExperimentExposure(experimentName) {
                this.assertInitialized(this.statsigClient);
                // This is the approach recommended in the docs
                // https://docs.statsig.com/client/javascript-sdk/#manual-exposures-
                this.statsigClient.getExperiment(experimentName);
            }
        },
        {
            key: "manuallyLogLayerExposure",
            value: function manuallyLogLayerExposure(layerName, parameterName) {
                var _this$statsigClient$g;
                this.assertInitialized(this.statsigClient);
                // This is the approach recommended in the docs
                // https://docs.statsig.com/client/javascript-sdk/#manual-exposures-
                (_this$statsigClient$g = this.statsigClient.getLayer(layerName)) === null || _this$statsigClient$g === void 0 || _this$statsigClient$g.get(parameterName);
            }
        },
        {
            key: "shutdownStatsig",
            value: function shutdownStatsig() {
                this.assertInitialized(this.statsigClient);
                this.statsigClient.shutdown();
            }
        },
        {
            key: "overrideGate",
            value: function overrideGate(gateName, value) {
                this.overrideAdapter.overrideGate(gateName, value);
                // Trigger a reset of the memoized gate value
                if (this.user) {
                    var _this$statsigClient;
                    (_this$statsigClient = this.statsigClient) === null || _this$statsigClient === void 0 || _this$statsigClient.updateUserSync(this.user, {
                        disableBackgroundCacheRefresh: true
                    });
                }
                this.statsigValuesUpdated();
            }
        },
        {
            key: "clearGateOverride",
            value: function clearGateOverride(gateName) {
                this.overrideAdapter.removeGateOverride(gateName);
                this.statsigValuesUpdated();
            }
        },
        {
            key: "overrideConfig",
            value: function overrideConfig(experimentName, values) {
                this.overrideAdapter.overrideDynamicConfig(experimentName, values);
                this.statsigValuesUpdated();
            }
        },
        {
            key: "clearConfigOverride",
            value: function clearConfigOverride(experimentName) {
                this.overrideAdapter.removeDynamicConfigOverride(experimentName);
                this.statsigValuesUpdated();
            }
        },
        {
            key: "setOverrides",
            value: function setOverrides(overrides) {
                this.overrideAdapter.setOverrides(overrides);
                this.statsigValuesUpdated();
            }
        },
        {
            key: "getOverrides",
            value: function getOverrides() {
                return this.overrideAdapter.getOverrides();
            }
        },
        {
            key: "clearAllOverrides",
            value: function clearAllOverrides() {
                this.overrideAdapter.removeAllOverrides();
                this.statsigValuesUpdated();
            }
        },
        {
            key: "isCurrentUser",
            value: function isCurrentUser(identifiers, customAttributes) {
                return (0, $nlPYW.shallowEquals)(this.currentIdentifiers, identifiers) && (0, $nlPYW.shallowEquals)(this.currentAttributes, customAttributes);
            }
        },
        {
            key: "onGateUpdated",
            value: function onGateUpdated(gateName, callback) {
                var _this7 = this;
                var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var wrapCallback = function wrapCallback(value) {
                    var _options$fireGateExpo2 = options.fireGateExposure, fireGateExposure = _options$fireGateExpo2 === void 0 ? true : _options$fireGateExpo2;
                    if (fireGateExposure) _this7.manuallyLogGateExposure(gateName);
                    try {
                        callback(value);
                    } catch (error) {
                        // eslint-disable-next-line no-console
                        console.warn("Error calling callback for gate ".concat(gateName, " with value ").concat(value), error);
                    }
                };
                return this.subscriptions.onGateUpdated(gateName, wrapCallback, this.checkGate.bind(this), options);
            }
        },
        {
            key: "onExperimentValueUpdated",
            value: function onExperimentValueUpdated(experimentName, parameterName, defaultValue, callback) {
                var _this8 = this;
                var options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
                var wrapCallback = function wrapCallback(value) {
                    var _options$fireExperime2 = options.fireExperimentExposure, fireExperimentExposure = _options$fireExperime2 === void 0 ? true : _options$fireExperime2;
                    if (fireExperimentExposure) _this8.manuallyLogExperimentExposure(experimentName);
                    try {
                        callback(value);
                    } catch (error) {
                        // eslint-disable-next-line no-console
                        console.warn("Error calling callback for experiment ".concat(experimentName, " with value ").concat(value), error);
                    }
                };
                return this.subscriptions.onExperimentValueUpdated(experimentName, parameterName, defaultValue, wrapCallback, this.getExperimentValue.bind(this), options);
            }
        },
        {
            key: "onAnyUpdated",
            value: function onAnyUpdated(callback) {
                return this.subscriptions.onAnyUpdated(callback);
            }
        },
        {
            key: "init",
            value: function() {
                var _init = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee7(clientOptions, identifiers, customAttributes) {
                    var fromValuesClientOptions, experimentValues, customAttributesFromResult, clientSdkKeyPromise, experimentValuesPromise, _yield$Promise$all, _yield$Promise$all2, experimentValuesResult;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee7$(_context7) {
                        while(true)switch(_context7.prev = _context7.next){
                            case 0:
                                fromValuesClientOptions = $7d91e8f8404f7e13$var$_objectSpread({}, clientOptions);
                                _context7.prev = 1;
                                // If client sdk key fetch fails, an error would be thrown and handled instead of waiting for
                                // the experiment values request to be settled, and it will fall back to use default values.
                                clientSdkKeyPromise = (0, $d4i2e.default).fetchClientSdk(clientOptions).then(function(value) {
                                    return fromValuesClientOptions.sdkKey = value.clientSdkKey;
                                });
                                experimentValuesPromise = (0, $d4i2e.default).fetchExperimentValues(clientOptions, identifiers, customAttributes); // Only wait for the experiment values request to finish and try to initialise the client
                                // with experiment values if both requests are successful. Else an error would be thrown and
                                // handled by the catch
                                _context7.next = 6;
                                return Promise.all([
                                    clientSdkKeyPromise,
                                    experimentValuesPromise
                                ]);
                            case 6:
                                _yield$Promise$all = _context7.sent;
                                _yield$Promise$all2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_yield$Promise$all, 2);
                                experimentValuesResult = _yield$Promise$all2[1];
                                experimentValues = experimentValuesResult.experimentValues;
                                customAttributesFromResult = experimentValuesResult.customAttributes;
                                _context7.next = 20;
                                break;
                            case 13:
                                _context7.prev = 13;
                                _context7.t0 = _context7["catch"](1);
                                if (_context7.t0 instanceof Error) // eslint-disable-next-line no-console
                                console.error("Error occurred when trying to fetch the Feature Gates client values, error: ".concat(_context7.t0 === null || _context7.t0 === void 0 ? void 0 : _context7.t0.message));
                                // eslint-disable-next-line no-console
                                console.warn("Initialising Statsig client without values");
                                _context7.next = 19;
                                return this.initFromValues(fromValuesClientOptions, identifiers, customAttributes);
                            case 19:
                                throw _context7.t0;
                            case 20:
                                return _context7.abrupt("return", this.initFromValues(fromValuesClientOptions, identifiers, customAttributesFromResult, experimentValues));
                            case 21:
                            case "end":
                                return _context7.stop();
                        }
                    }, _callee7, this, [
                        [
                            1,
                            13
                        ]
                    ]);
                }));
                function init(_x18, _x19, _x20) {
                    return _init.apply(this, arguments);
                }
                return init;
            }()
        },
        {
            key: "initWithProvider",
            value: function() {
                var _initWithProvider = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee8(baseClientOptions, provider, identifiers, customAttributes) {
                    var fromValuesClientOptions, experimentValues, customAttributesFromResult, clientSdkKeyPromise, experimentValuesPromise, _yield$Promise$all3, _yield$Promise$all4, experimentValuesResult;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee8$(_context8) {
                        while(true)switch(_context8.prev = _context8.next){
                            case 0:
                                fromValuesClientOptions = $7d91e8f8404f7e13$var$_objectSpread($7d91e8f8404f7e13$var$_objectSpread({}, baseClientOptions), {}, {
                                    disableCurrentPageLogging: true
                                });
                                _context8.prev = 1;
                                _context8.next = 4;
                                return provider.setProfile(baseClientOptions, identifiers, customAttributes);
                            case 4:
                                // If client sdk key fetch fails, an error would be thrown and handled instead of waiting for
                                // the experiment values request to be settled, and it will fall back to use default values.
                                clientSdkKeyPromise = provider.getClientSdkKey().then(function(value) {
                                    return fromValuesClientOptions.sdkKey = value;
                                });
                                experimentValuesPromise = provider.getExperimentValues(); // Only wait for the experiment values request to finish and try to initialise the client
                                // with experiment values if both requests are successful. Else an error would be thrown and
                                // handled by the catch
                                _context8.next = 8;
                                return Promise.all([
                                    clientSdkKeyPromise,
                                    experimentValuesPromise
                                ]);
                            case 8:
                                _yield$Promise$all3 = _context8.sent;
                                _yield$Promise$all4 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_yield$Promise$all3, 2);
                                experimentValuesResult = _yield$Promise$all4[1];
                                experimentValues = experimentValuesResult.experimentValues;
                                customAttributesFromResult = experimentValuesResult.customAttributesFromFetch;
                                _context8.next = 22;
                                break;
                            case 15:
                                _context8.prev = 15;
                                _context8.t0 = _context8["catch"](1);
                                if (_context8.t0 instanceof Error) // eslint-disable-next-line no-console
                                console.error("Error occurred when trying to fetch the Feature Gates client values, error: ".concat(_context8.t0 === null || _context8.t0 === void 0 ? void 0 : _context8.t0.message));
                                // eslint-disable-next-line no-console
                                console.warn("Initialising Statsig client without values");
                                _context8.next = 21;
                                return this.initFromValues(fromValuesClientOptions, identifiers, customAttributes);
                            case 21:
                                throw _context8.t0;
                            case 22:
                                return _context8.abrupt("return", this.initFromValues(fromValuesClientOptions, identifiers, customAttributesFromResult, experimentValues));
                            case 23:
                            case "end":
                                return _context8.stop();
                        }
                    }, _callee8, this, [
                        [
                            1,
                            15
                        ]
                    ]);
                }));
                function initWithProvider(_x21, _x22, _x23, _x24) {
                    return _initWithProvider.apply(this, arguments);
                }
                return initWithProvider;
            }()
        },
        {
            key: "initFromValues",
            value: function() {
                var _initFromValues = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee9(clientOptions, identifiers, customAttributes) {
                    var _newClientOptions$net;
                    var initializeValues, newClientOptions, sdkKey, environment, _updateUserCompletionCallback, _perimeter, restClientOptions, statsigOptions, _args9 = arguments;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee9$(_context9) {
                        while(true)switch(_context9.prev = _context9.next){
                            case 0:
                                initializeValues = _args9.length > 3 && _args9[3] !== undefined ? _args9[3] : {};
                                this.overrideAdapter.initFromStoredOverrides();
                                this.currentIdentifiers = identifiers;
                                this.currentAttributes = customAttributes;
                                newClientOptions = (0, $nlPYW.migrateInitializationOptions)(clientOptions);
                                if (!newClientOptions.sdkKey) newClientOptions.sdkKey = $7d91e8f8404f7e13$var$DEFAULT_CLIENT_KEY;
                                if (!((_newClientOptions$net = newClientOptions.networkConfig) !== null && _newClientOptions$net !== void 0 && _newClientOptions$net.logEventUrl)) newClientOptions.networkConfig = $7d91e8f8404f7e13$var$_objectSpread($7d91e8f8404f7e13$var$_objectSpread({}, newClientOptions.networkConfig), {}, {
                                    logEventUrl: $7d91e8f8404f7e13$var$DEFAULT_EVENT_LOGGING_API
                                });
                                if (newClientOptions.perimeter === (0, $eMunP.PerimeterType).FEDRAMP_MODERATE) // disable all logging in FedRAMP to prevent egress of sensitive data
                                newClientOptions.disableLogging = true;
                                sdkKey = newClientOptions.sdkKey, environment = newClientOptions.environment, _updateUserCompletionCallback = newClientOptions.updateUserCompletionCallback, _perimeter = newClientOptions.perimeter, restClientOptions = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(newClientOptions, $7d91e8f8404f7e13$var$_excluded);
                                this.sdkKey = sdkKey;
                                this.user = (0, $nlPYW.toStatsigUser)(identifiers, customAttributes, this.sdkKey);
                                statsigOptions = $7d91e8f8404f7e13$var$_objectSpread($7d91e8f8404f7e13$var$_objectSpread({}, restClientOptions), {}, {
                                    environment: {
                                        tier: environment
                                    },
                                    includeCurrentPageUrlWithEvents: false,
                                    dataAdapter: this.dataAdapter,
                                    overrideAdapter: this.overrideAdapter
                                });
                                _context9.prev = 12;
                                this.statsigClient = new (0, $iFR7a.StatsigClient)(sdkKey, this.user, statsigOptions);
                                this.dataAdapter.setBootstrapData(initializeValues);
                                _context9.next = 17;
                                return this.statsigClient.initializeAsync();
                            case 17:
                                _context9.next = 29;
                                break;
                            case 19:
                                _context9.prev = 19;
                                _context9.t0 = _context9["catch"](12);
                                if (_context9.t0 instanceof Error) // eslint-disable-next-line no-console
                                console.error("Error occurred when trying to initialise the Statsig client, error: ".concat(_context9.t0 === null || _context9.t0 === void 0 ? void 0 : _context9.t0.message));
                                // eslint-disable-next-line no-console
                                console.warn("Initialising Statsig client with default sdk key and without values");
                                this.statsigClient = new (0, $iFR7a.StatsigClient)($7d91e8f8404f7e13$var$DEFAULT_CLIENT_KEY, this.user, statsigOptions);
                                this.dataAdapter.setBootstrapData();
                                _context9.next = 27;
                                return this.statsigClient.initializeAsync();
                            case 27:
                                this.initWithDefaults = true;
                                throw _context9.t0;
                            case 29:
                            case "end":
                                return _context9.stop();
                        }
                    }, _callee9, this, [
                        [
                            12,
                            19
                        ]
                    ]);
                }));
                function initFromValues(_x25, _x26, _x27) {
                    return _initFromValues.apply(this, arguments);
                }
                return initFromValues;
            }()
        },
        {
            key: "updateUserUsingInitializeValuesProducer",
            value: function() {
                var _updateUserUsingInitializeValuesProducer = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee11(getInitializeValues, identifiers, customAttributes) {
                    var _this9 = this;
                    var originalInitPromise, initializeValuesPromise, updateUserPromise;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee11$(_context11) {
                        while(true)switch(_context11.prev = _context11.next){
                            case 0:
                                this.assertInitialized(this.statsigClient);
                                if (this.initPromise) {
                                    _context11.next = 3;
                                    break;
                                }
                                throw new Error('The client must be initialized before you can update the user.');
                            case 3:
                                if (!this.isCurrentUser(identifiers, customAttributes)) {
                                    _context11.next = 5;
                                    break;
                                }
                                return _context11.abrupt("return", this.initPromise);
                            case 5:
                                // Wait for the current initialize/update to finish
                                originalInitPromise = this.initPromise;
                                _context11.prev = 6;
                                _context11.next = 9;
                                return this.initPromise;
                            case 9:
                                _context11.next = 13;
                                break;
                            case 11:
                                _context11.prev = 11;
                                _context11.t0 = _context11["catch"](6);
                            case 13:
                                initializeValuesPromise = getInitializeValues();
                                updateUserPromise = this.updateStatsigClientUser(initializeValuesPromise, identifiers, customAttributes); // We replace the init promise here since we are essentially re-initializing the client at this
                                // point. Any subsequent calls to await client.initialize() or client.updateUser()
                                // will now also await this user update.
                                this.initPromise = updateUserPromise.catch(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee10() {
                                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee10$(_context10) {
                                        while(true)switch(_context10.prev = _context10.next){
                                            case 0:
                                                // If the update failed then it changed nothing, so revert back to the original promise.
                                                _this9.initPromise = originalInitPromise;
                                                // Set the user profile again to revert back to the current user
                                                if (!_this9.provider) {
                                                    _context10.next = 4;
                                                    break;
                                                }
                                                _context10.next = 4;
                                                return _this9.provider.setProfile(_this9.initOptions, _this9.currentIdentifiers, _this9.currentAttributes);
                                            case 4:
                                            case "end":
                                                return _context10.stop();
                                        }
                                    }, _callee10);
                                })));
                                return _context11.abrupt("return", updateUserPromise);
                            case 17:
                            case "end":
                                return _context11.stop();
                        }
                    }, _callee11, this, [
                        [
                            6,
                            11
                        ]
                    ]);
                }));
                function updateUserUsingInitializeValuesProducer(_x28, _x29, _x30) {
                    return _updateUserUsingInitializeValuesProducer.apply(this, arguments);
                }
                return updateUserUsingInitializeValuesProducer;
            }()
        },
        {
            key: "updateStatsigClientUser",
            value: function() {
                var _updateStatsigClientUser = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee12(initializeValuesPromise, identifiers, customAttributes) {
                    var _this$initOptions, _this$initOptions$upd;
                    var initializeValues, user, _updateUserCompletion, _ref4, errMsg, success, errorMessage;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee12$(_context12) {
                        while(true)switch(_context12.prev = _context12.next){
                            case 0:
                                this.assertInitialized(this.statsigClient);
                                _context12.prev = 1;
                                _context12.next = 4;
                                return initializeValuesPromise;
                            case 4:
                                initializeValues = _context12.sent;
                                user = (0, $nlPYW.toStatsigUser)(identifiers, initializeValues.customAttributesFromFetch, this.sdkKey);
                                _context12.next = 13;
                                break;
                            case 8:
                                _context12.prev = 8;
                                _context12.t0 = _context12["catch"](1);
                                // Make sure the updateUserCompletionCallback is called for any errors in our custom code.
                                // This is not necessary for the updateUserWithValues call, because the Statsig client will
                                // already invoke the callback itself.
                                errMsg = _context12.t0 instanceof Error ? _context12.t0.message : JSON.stringify(_context12.t0);
                                (_updateUserCompletion = (_ref4 = this.initOptions).updateUserCompletionCallback) === null || _updateUserCompletion === void 0 || _updateUserCompletion.call(_ref4, false, errMsg);
                                throw _context12.t0;
                            case 13:
                                success = true;
                                errorMessage = null;
                                _context12.prev = 15;
                                this.dataAdapter.setBootstrapData(initializeValues.experimentValues);
                                this.user = user;
                                _context12.next = 20;
                                return this.statsigClient.updateUserAsync(this.user);
                            case 20:
                                _context12.next = 26;
                                break;
                            case 22:
                                _context12.prev = 22;
                                _context12.t1 = _context12["catch"](15);
                                success = false;
                                errorMessage = String(_context12.t1);
                            case 26:
                                (_this$initOptions = this.initOptions) === null || _this$initOptions === void 0 || (_this$initOptions$upd = _this$initOptions.updateUserCompletionCallback) === null || _this$initOptions$upd === void 0 || _this$initOptions$upd.call(_this$initOptions, success, errorMessage);
                                if (!success) {
                                    _context12.next = 33;
                                    break;
                                }
                                this.currentIdentifiers = identifiers;
                                this.currentAttributes = customAttributes;
                                this.subscriptions.anyUpdated();
                                _context12.next = 34;
                                break;
                            case 33:
                                throw new Error('Failed to update user. An unexpected error occured.');
                            case 34:
                            case "end":
                                return _context12.stop();
                        }
                    }, _callee12, this, [
                        [
                            1,
                            8
                        ],
                        [
                            15,
                            22
                        ]
                    ]);
                }));
                function updateStatsigClientUser(_x31, _x32, _x33) {
                    return _updateStatsigClientUser.apply(this, arguments);
                }
                return updateStatsigClientUser;
            }()
        },
        {
            key: "getPackageVersion",
            value: /**
     * @returns string version of the current package in semver style.
     */ function getPackageVersion() {
                return 0, $22KTL.CLIENT_VERSION;
            }
        },
        {
            key: "getLayer",
            value: function getLayer(/** The name of the layer */ layerName) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                try {
                    this.assertInitialized(this.statsigClient);
                    var _options$fireLayerExp = options.fireLayerExposure, fireLayerExposure = _options$fireLayerExp === void 0 ? true : _options$fireLayerExp;
                    return (0, $213zb.Layer).fromLayer(this.statsigClient.getLayer(layerName, {
                        disableExposureLog: !fireLayerExposure
                    }));
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!this.hasGetLayerErrorOccurred) {
                        // eslint-disable-next-line no-console
                        console.warn({
                            msg: 'An error has occurred getting the layer. Only the first occurrence of this error is logged.',
                            layerName: layerName,
                            error: error
                        });
                        this.hasGetLayerErrorOccurred = true;
                    }
                    // Return a default value
                    return (0, $213zb.Layer).fromLayer((0, $iFR7a._makeLayer)(layerName, {
                        reason: 'Error'
                    }, null));
                }
            }
        },
        {
            key: "getLayerValue",
            value: function getLayerValue(layerName, parameterName, defaultValue) {
                var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var layer = this.getLayer(layerName, options);
                try {
                    var typeGuard = options.typeGuard;
                    return layer.get(parameterName, defaultValue, typeGuard);
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!this.hasGetLayerValueErrorOccurred) {
                        // eslint-disable-next-line no-console
                        console.warn({
                            msg: 'An error has occurred getting the layer value. Only the first occurrence of this error is logged.',
                            layerName: layerName,
                            defaultValue: defaultValue,
                            options: options,
                            error: error
                        });
                        this.hasGetLayerValueErrorOccurred = true;
                    }
                    return defaultValue;
                }
            }
        }
    ]);
}();

});
parcelRegister("344Sl", function(module, exports) {
$parcel$export(module.exports, "default", () => $23b586fe23ee954c$export$2e2bcd8739ae039);

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $25nEq = parcelRequire("25nEq");

var $fxEK3 = parcelRequire("fxEK3");
function $23b586fe23ee954c$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $23b586fe23ee954c$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $23b586fe23ee954c$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $23b586fe23ee954c$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $23b586fe23ee954c$export$a66cbd9b2289cd78 = '@all-features';
var $23b586fe23ee954c$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function Subscriptions() {
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, Subscriptions);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "eventToValue", new Map());
        this.emitter = new (0, $fxEK3.EventEmitter2)();
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(Subscriptions, [
        {
            key: "onGateUpdated",
            value: function onGateUpdated(gateName, callback, checkGate, options) {
                var _this = this;
                var value = checkGate(gateName, $23b586fe23ee954c$var$_objectSpread($23b586fe23ee954c$var$_objectSpread({}, options), {}, {
                    fireGateExposure: false
                }));
                if (this.eventToValue.get(callback) === undefined) this.eventToValue.set(callback, value);
                var wrapCallback = function wrapCallback() {
                    var value = checkGate(gateName, $23b586fe23ee954c$var$_objectSpread($23b586fe23ee954c$var$_objectSpread({}, options), {}, {
                        fireGateExposure: false
                    }));
                    var existingValue = _this.eventToValue.get(callback);
                    if (existingValue !== value) {
                        _this.eventToValue.set(callback, value);
                        callback(value);
                    }
                };
                this.emitter.on(gateName, wrapCallback);
                return function() {
                    _this.emitter.off(gateName, wrapCallback);
                };
            }
        },
        {
            key: "onExperimentValueUpdated",
            value: function onExperimentValueUpdated(experimentName, parameterName, defaultValue, callback, getExperimentValue, options) {
                var _this2 = this;
                var experimentEventName = "".concat(experimentName, ".").concat(parameterName);
                var value = getExperimentValue(experimentName, parameterName, defaultValue, $23b586fe23ee954c$var$_objectSpread($23b586fe23ee954c$var$_objectSpread({}, options), {}, {
                    fireExperimentExposure: false
                }));
                if (this.eventToValue.get(callback) === undefined) this.eventToValue.set(callback, value);
                var wrapCallback = function wrapCallback() {
                    var value = getExperimentValue(experimentName, parameterName, defaultValue, $23b586fe23ee954c$var$_objectSpread($23b586fe23ee954c$var$_objectSpread({}, options), {}, {
                        fireExperimentExposure: false
                    }));
                    var existingValue = _this2.eventToValue.get(callback);
                    if (existingValue !== value) {
                        _this2.eventToValue.set(callback, value);
                        callback(value);
                    }
                };
                this.emitter.on(experimentEventName, wrapCallback);
                return function() {
                    _this2.emitter.off(experimentEventName, wrapCallback);
                };
            }
        },
        {
            key: "onAnyUpdated",
            value: function onAnyUpdated(callback) {
                var _this3 = this;
                this.emitter.on($23b586fe23ee954c$export$a66cbd9b2289cd78, callback);
                return function() {
                    _this3.emitter.off($23b586fe23ee954c$export$a66cbd9b2289cd78, callback);
                };
            }
        },
        {
            key: "anyUpdated",
            value: function anyUpdated() {
                var _this4 = this;
                this.emitter.emit($23b586fe23ee954c$export$a66cbd9b2289cd78);
                this.emitter.eventNames().filter(function(name) {
                    return name !== $23b586fe23ee954c$export$a66cbd9b2289cd78;
                }).forEach(function(event) {
                    _this4.emitter.emit(event);
                });
            }
        }
    ]);
}();

});
parcelRegister("fxEK3", function(module, exports) {

var $3ZMUU = parcelRequire("3ZMUU");
!function(undefined) {
    var isArray = Array.isArray ? Array.isArray : function _isArray(obj) {
        return Object.prototype.toString.call(obj) === "[object Array]";
    };
    var defaultMaxListeners = 10;
    function init() {
        this._events = {};
        if (this._conf) configure.call(this, this._conf);
    }
    function configure(conf) {
        if (conf) {
            this._conf = conf;
            conf.delimiter && (this.delimiter = conf.delimiter);
            this._maxListeners = conf.maxListeners !== undefined ? conf.maxListeners : defaultMaxListeners;
            conf.wildcard && (this.wildcard = conf.wildcard);
            conf.newListener && (this.newListener = conf.newListener);
            conf.verboseMemoryLeak && (this.verboseMemoryLeak = conf.verboseMemoryLeak);
            if (this.wildcard) this.listenerTree = {};
        } else this._maxListeners = defaultMaxListeners;
    }
    function logPossibleMemoryLeak(count, eventName) {
        var errorMsg = "(node) warning: possible EventEmitter memory leak detected. " + count + ' listeners added. ' + 'Use emitter.setMaxListeners() to increase limit.';
        if (this.verboseMemoryLeak) errorMsg += ' Event name: ' + eventName + '.';
        if (typeof $3ZMUU !== 'undefined' && $3ZMUU.emitWarning) {
            var e = new Error(errorMsg);
            e.name = 'MaxListenersExceededWarning';
            e.emitter = this;
            e.count = count;
            $3ZMUU.emitWarning(e);
        } else {
            console.error(errorMsg);
            if (console.trace) console.trace();
        }
    }
    function EventEmitter(conf) {
        this._events = {};
        this.newListener = false;
        this.verboseMemoryLeak = false;
        configure.call(this, conf);
    }
    EventEmitter.EventEmitter2 = EventEmitter; // backwards compatibility for exporting EventEmitter property
    //
    // Attention, function return type now is array, always !
    // It has zero elements if no any matches found and one or more
    // elements (leafs) if there are matches
    //
    function searchListenerTree(handlers, type, tree, i) {
        if (!tree) return [];
        var listeners = [], leaf, len, branch, xTree, xxTree, isolatedBranch, endReached, typeLength = type.length, currentType = type[i], nextType = type[i + 1];
        if (i === typeLength && tree._listeners) {
            //
            // If at the end of the event(s) list and the tree has listeners
            // invoke those listeners.
            //
            if (typeof tree._listeners === 'function') {
                handlers && handlers.push(tree._listeners);
                return [
                    tree
                ];
            } else {
                for(leaf = 0, len = tree._listeners.length; leaf < len; leaf++)handlers && handlers.push(tree._listeners[leaf]);
                return [
                    tree
                ];
            }
        }
        if (currentType === '*' || currentType === '**' || tree[currentType]) {
            //
            // If the event emitted is '*' at this part
            // or there is a concrete match at this patch
            //
            if (currentType === '*') {
                for(branch in tree)if (branch !== '_listeners' && tree.hasOwnProperty(branch)) listeners = listeners.concat(searchListenerTree(handlers, type, tree[branch], i + 1));
                return listeners;
            } else if (currentType === '**') {
                endReached = i + 1 === typeLength || i + 2 === typeLength && nextType === '*';
                if (endReached && tree._listeners) // The next element has a _listeners, add it to the handlers.
                listeners = listeners.concat(searchListenerTree(handlers, type, tree, typeLength));
                for(branch in tree)if (branch !== '_listeners' && tree.hasOwnProperty(branch)) {
                    if (branch === '*' || branch === '**') {
                        if (tree[branch]._listeners && !endReached) listeners = listeners.concat(searchListenerTree(handlers, type, tree[branch], typeLength));
                        listeners = listeners.concat(searchListenerTree(handlers, type, tree[branch], i));
                    } else if (branch === nextType) listeners = listeners.concat(searchListenerTree(handlers, type, tree[branch], i + 2));
                    else // No match on this one, shift into the tree but not in the type array.
                    listeners = listeners.concat(searchListenerTree(handlers, type, tree[branch], i));
                }
                return listeners;
            }
            listeners = listeners.concat(searchListenerTree(handlers, type, tree[currentType], i + 1));
        }
        xTree = tree['*'];
        if (xTree) //
        // If the listener tree will allow any match for this part,
        // then recursively explore all branches of the tree
        //
        searchListenerTree(handlers, type, xTree, i + 1);
        xxTree = tree['**'];
        if (xxTree) {
            if (i < typeLength) {
                if (xxTree._listeners) // If we have a listener on a '**', it will catch all, so add its handler.
                searchListenerTree(handlers, type, xxTree, typeLength);
                // Build arrays of matching next branches and others.
                for(branch in xxTree)if (branch !== '_listeners' && xxTree.hasOwnProperty(branch)) {
                    if (branch === nextType) // We know the next element will match, so jump twice.
                    searchListenerTree(handlers, type, xxTree[branch], i + 2);
                    else if (branch === currentType) // Current node matches, move into the tree.
                    searchListenerTree(handlers, type, xxTree[branch], i + 1);
                    else {
                        isolatedBranch = {};
                        isolatedBranch[branch] = xxTree[branch];
                        searchListenerTree(handlers, type, {
                            '**': isolatedBranch
                        }, i + 1);
                    }
                }
            } else if (xxTree._listeners) // We have reached the end and still on a '**'
            searchListenerTree(handlers, type, xxTree, typeLength);
            else if (xxTree['*'] && xxTree['*']._listeners) searchListenerTree(handlers, type, xxTree['*'], typeLength);
        }
        return listeners;
    }
    function growListenerTree(type, listener) {
        type = typeof type === 'string' ? type.split(this.delimiter) : type.slice();
        //
        // Looks for two consecutive '**', if so, don't add the event at all.
        //
        for(var i = 0, len = type.length; i + 1 < len; i++){
            if (type[i] === '**' && type[i + 1] === '**') return;
        }
        var tree = this.listenerTree;
        var name = type.shift();
        while(name !== undefined){
            if (!tree[name]) tree[name] = {};
            tree = tree[name];
            if (type.length === 0) {
                if (!tree._listeners) tree._listeners = listener;
                else {
                    if (typeof tree._listeners === 'function') tree._listeners = [
                        tree._listeners
                    ];
                    tree._listeners.push(listener);
                    if (!tree._listeners.warned && this._maxListeners > 0 && tree._listeners.length > this._maxListeners) {
                        tree._listeners.warned = true;
                        logPossibleMemoryLeak.call(this, tree._listeners.length, name);
                    }
                }
                return true;
            }
            name = type.shift();
        }
        return true;
    }
    // By default EventEmitters will print a warning if more than
    // 10 listeners are added to it. This is a useful default which
    // helps finding memory leaks.
    //
    // Obviously not all Emitters should be limited to 10. This function allows
    // that to be increased. Set to zero for unlimited.
    EventEmitter.prototype.delimiter = '.';
    EventEmitter.prototype.setMaxListeners = function(n) {
        if (n !== undefined) {
            this._maxListeners = n;
            if (!this._conf) this._conf = {};
            this._conf.maxListeners = n;
        }
    };
    EventEmitter.prototype.event = '';
    EventEmitter.prototype.once = function(event, fn) {
        return this._once(event, fn, false);
    };
    EventEmitter.prototype.prependOnceListener = function(event, fn) {
        return this._once(event, fn, true);
    };
    EventEmitter.prototype._once = function(event, fn, prepend) {
        this._many(event, 1, fn, prepend);
        return this;
    };
    EventEmitter.prototype.many = function(event, ttl, fn) {
        return this._many(event, ttl, fn, false);
    };
    EventEmitter.prototype.prependMany = function(event, ttl, fn) {
        return this._many(event, ttl, fn, true);
    };
    EventEmitter.prototype._many = function(event, ttl, fn, prepend) {
        var self = this;
        if (typeof fn !== 'function') throw new Error('many only accepts instances of Function');
        function listener() {
            if (--ttl === 0) self.off(event, listener);
            return fn.apply(this, arguments);
        }
        listener._origin = fn;
        this._on(event, listener, prepend);
        return self;
    };
    EventEmitter.prototype.emit = function() {
        this._events || init.call(this);
        var type = arguments[0];
        if (type === 'newListener' && !this.newListener) {
            if (!this._events.newListener) return false;
        }
        var al = arguments.length;
        var args, l, i, j;
        var handler;
        if (this._all && this._all.length) {
            handler = this._all.slice();
            if (al > 3) {
                args = new Array(al);
                for(j = 0; j < al; j++)args[j] = arguments[j];
            }
            for(i = 0, l = handler.length; i < l; i++){
                this.event = type;
                switch(al){
                    case 1:
                        handler[i].call(this, type);
                        break;
                    case 2:
                        handler[i].call(this, type, arguments[1]);
                        break;
                    case 3:
                        handler[i].call(this, type, arguments[1], arguments[2]);
                        break;
                    default:
                        handler[i].apply(this, args);
                }
            }
        }
        if (this.wildcard) {
            handler = [];
            var ns = typeof type === 'string' ? type.split(this.delimiter) : type.slice();
            searchListenerTree.call(this, handler, ns, this.listenerTree, 0);
        } else {
            handler = this._events[type];
            if (typeof handler === 'function') {
                this.event = type;
                switch(al){
                    case 1:
                        handler.call(this);
                        break;
                    case 2:
                        handler.call(this, arguments[1]);
                        break;
                    case 3:
                        handler.call(this, arguments[1], arguments[2]);
                        break;
                    default:
                        args = new Array(al - 1);
                        for(j = 1; j < al; j++)args[j - 1] = arguments[j];
                        handler.apply(this, args);
                }
                return true;
            } else if (handler) // need to make copy of handlers because list can change in the middle
            // of emit call
            handler = handler.slice();
        }
        if (handler && handler.length) {
            if (al > 3) {
                args = new Array(al - 1);
                for(j = 1; j < al; j++)args[j - 1] = arguments[j];
            }
            for(i = 0, l = handler.length; i < l; i++){
                this.event = type;
                switch(al){
                    case 1:
                        handler[i].call(this);
                        break;
                    case 2:
                        handler[i].call(this, arguments[1]);
                        break;
                    case 3:
                        handler[i].call(this, arguments[1], arguments[2]);
                        break;
                    default:
                        handler[i].apply(this, args);
                }
            }
            return true;
        } else if (!this._all && type === 'error') {
            if (arguments[1] instanceof Error) throw arguments[1]; // Unhandled 'error' event
            else throw new Error("Uncaught, unspecified 'error' event.");
            return false;
        }
        return !!this._all;
    };
    EventEmitter.prototype.emitAsync = function() {
        this._events || init.call(this);
        var type = arguments[0];
        if (type === 'newListener' && !this.newListener) {
            if (!this._events.newListener) return Promise.resolve([
                false
            ]);
        }
        var promises = [];
        var al = arguments.length;
        var args, l, i, j;
        var handler;
        if (this._all) {
            if (al > 3) {
                args = new Array(al);
                for(j = 1; j < al; j++)args[j] = arguments[j];
            }
            for(i = 0, l = this._all.length; i < l; i++){
                this.event = type;
                switch(al){
                    case 1:
                        promises.push(this._all[i].call(this, type));
                        break;
                    case 2:
                        promises.push(this._all[i].call(this, type, arguments[1]));
                        break;
                    case 3:
                        promises.push(this._all[i].call(this, type, arguments[1], arguments[2]));
                        break;
                    default:
                        promises.push(this._all[i].apply(this, args));
                }
            }
        }
        if (this.wildcard) {
            handler = [];
            var ns = typeof type === 'string' ? type.split(this.delimiter) : type.slice();
            searchListenerTree.call(this, handler, ns, this.listenerTree, 0);
        } else handler = this._events[type];
        if (typeof handler === 'function') {
            this.event = type;
            switch(al){
                case 1:
                    promises.push(handler.call(this));
                    break;
                case 2:
                    promises.push(handler.call(this, arguments[1]));
                    break;
                case 3:
                    promises.push(handler.call(this, arguments[1], arguments[2]));
                    break;
                default:
                    args = new Array(al - 1);
                    for(j = 1; j < al; j++)args[j - 1] = arguments[j];
                    promises.push(handler.apply(this, args));
            }
        } else if (handler && handler.length) {
            handler = handler.slice();
            if (al > 3) {
                args = new Array(al - 1);
                for(j = 1; j < al; j++)args[j - 1] = arguments[j];
            }
            for(i = 0, l = handler.length; i < l; i++){
                this.event = type;
                switch(al){
                    case 1:
                        promises.push(handler[i].call(this));
                        break;
                    case 2:
                        promises.push(handler[i].call(this, arguments[1]));
                        break;
                    case 3:
                        promises.push(handler[i].call(this, arguments[1], arguments[2]));
                        break;
                    default:
                        promises.push(handler[i].apply(this, args));
                }
            }
        } else if (!this._all && type === 'error') {
            if (arguments[1] instanceof Error) return Promise.reject(arguments[1]); // Unhandled 'error' event
            else return Promise.reject("Uncaught, unspecified 'error' event.");
        }
        return Promise.all(promises);
    };
    EventEmitter.prototype.on = function(type, listener) {
        return this._on(type, listener, false);
    };
    EventEmitter.prototype.prependListener = function(type, listener) {
        return this._on(type, listener, true);
    };
    EventEmitter.prototype.onAny = function(fn) {
        return this._onAny(fn, false);
    };
    EventEmitter.prototype.prependAny = function(fn) {
        return this._onAny(fn, true);
    };
    EventEmitter.prototype.addListener = EventEmitter.prototype.on;
    EventEmitter.prototype._onAny = function(fn, prepend) {
        if (typeof fn !== 'function') throw new Error('onAny only accepts instances of Function');
        if (!this._all) this._all = [];
        // Add the function to the event listener collection.
        if (prepend) this._all.unshift(fn);
        else this._all.push(fn);
        return this;
    };
    EventEmitter.prototype._on = function(type, listener, prepend) {
        if (typeof type === 'function') {
            this._onAny(type, listener);
            return this;
        }
        if (typeof listener !== 'function') throw new Error('on only accepts instances of Function');
        this._events || init.call(this);
        // To avoid recursion in the case that type == "newListeners"! Before
        // adding it to the listeners, first emit "newListeners".
        this.emit('newListener', type, listener);
        if (this.wildcard) {
            growListenerTree.call(this, type, listener);
            return this;
        }
        if (!this._events[type]) // Optimize the case of one listener. Don't need the extra array object.
        this._events[type] = listener;
        else {
            if (typeof this._events[type] === 'function') // Change to array.
            this._events[type] = [
                this._events[type]
            ];
            // If we've already got an array, just add
            if (prepend) this._events[type].unshift(listener);
            else this._events[type].push(listener);
            // Check for listener leak
            if (!this._events[type].warned && this._maxListeners > 0 && this._events[type].length > this._maxListeners) {
                this._events[type].warned = true;
                logPossibleMemoryLeak.call(this, this._events[type].length, type);
            }
        }
        return this;
    };
    EventEmitter.prototype.off = function(type, listener) {
        if (typeof listener !== 'function') throw new Error('removeListener only takes instances of Function');
        var handlers, leafs = [];
        if (this.wildcard) {
            var ns = typeof type === 'string' ? type.split(this.delimiter) : type.slice();
            leafs = searchListenerTree.call(this, null, ns, this.listenerTree, 0);
        } else {
            // does not use listeners(), so no side effect of creating _events[type]
            if (!this._events[type]) return this;
            handlers = this._events[type];
            leafs.push({
                _listeners: handlers
            });
        }
        for(var iLeaf = 0; iLeaf < leafs.length; iLeaf++){
            var leaf = leafs[iLeaf];
            handlers = leaf._listeners;
            if (isArray(handlers)) {
                var position = -1;
                for(var i = 0, length = handlers.length; i < length; i++)if (handlers[i] === listener || handlers[i].listener && handlers[i].listener === listener || handlers[i]._origin && handlers[i]._origin === listener) {
                    position = i;
                    break;
                }
                if (position < 0) continue;
                if (this.wildcard) leaf._listeners.splice(position, 1);
                else this._events[type].splice(position, 1);
                if (handlers.length === 0) {
                    if (this.wildcard) delete leaf._listeners;
                    else delete this._events[type];
                }
                this.emit("removeListener", type, listener);
                return this;
            } else if (handlers === listener || handlers.listener && handlers.listener === listener || handlers._origin && handlers._origin === listener) {
                if (this.wildcard) delete leaf._listeners;
                else delete this._events[type];
                this.emit("removeListener", type, listener);
            }
        }
        function recursivelyGarbageCollect(root) {
            if (root === undefined) return;
            var keys = Object.keys(root);
            for(var i in keys){
                var key = keys[i];
                var obj = root[key];
                if (obj instanceof Function || typeof obj !== "object" || obj === null) continue;
                if (Object.keys(obj).length > 0) recursivelyGarbageCollect(root[key]);
                if (Object.keys(obj).length === 0) delete root[key];
            }
        }
        recursivelyGarbageCollect(this.listenerTree);
        return this;
    };
    EventEmitter.prototype.offAny = function(fn) {
        var i = 0, l = 0, fns;
        if (fn && this._all && this._all.length > 0) {
            fns = this._all;
            for(i = 0, l = fns.length; i < l; i++)if (fn === fns[i]) {
                fns.splice(i, 1);
                this.emit("removeListenerAny", fn);
                return this;
            }
        } else {
            fns = this._all;
            for(i = 0, l = fns.length; i < l; i++)this.emit("removeListenerAny", fns[i]);
            this._all = [];
        }
        return this;
    };
    EventEmitter.prototype.removeListener = EventEmitter.prototype.off;
    EventEmitter.prototype.removeAllListeners = function(type) {
        if (arguments.length === 0) {
            !this._events || init.call(this);
            return this;
        }
        if (this.wildcard) {
            var ns = typeof type === 'string' ? type.split(this.delimiter) : type.slice();
            var leafs = searchListenerTree.call(this, null, ns, this.listenerTree, 0);
            for(var iLeaf = 0; iLeaf < leafs.length; iLeaf++){
                var leaf = leafs[iLeaf];
                leaf._listeners = null;
            }
        } else if (this._events) this._events[type] = null;
        return this;
    };
    EventEmitter.prototype.listeners = function(type) {
        if (this.wildcard) {
            var handlers = [];
            var ns = typeof type === 'string' ? type.split(this.delimiter) : type.slice();
            searchListenerTree.call(this, handlers, ns, this.listenerTree, 0);
            return handlers;
        }
        this._events || init.call(this);
        if (!this._events[type]) this._events[type] = [];
        if (!isArray(this._events[type])) this._events[type] = [
            this._events[type]
        ];
        return this._events[type];
    };
    EventEmitter.prototype.eventNames = function() {
        return Object.keys(this._events);
    };
    EventEmitter.prototype.listenerCount = function(type) {
        return this.listeners(type).length;
    };
    EventEmitter.prototype.listenersAny = function() {
        if (this._all) return this._all;
        else return [];
    };
    if (typeof define === 'function' && define.amd) // AMD. Register as an anonymous module.
    define(function() {
        return EventEmitter;
    });
    else // CommonJS
    module.exports = EventEmitter;
}();

});


parcelRegister("jtLwS", function(module, exports) {
$parcel$export(module.exports, "DynamicConfig", () => $e2e5980ebbc7649e$export$6dc24881a3d96325);

var $ekGgq = parcelRequire("ekGgq");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $nlPYW = parcelRequire("nlPYW");
var $e2e5980ebbc7649e$export$6dc24881a3d96325 = /*#__PURE__*/ function() {
    function DynamicConfig(configName, configValue, ruleID, evaluationDetails) {
        var secondaryExposures = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : [];
        var allocatedExperimentName = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : '';
        var onDefaultValueFallback = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : null;
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, DynamicConfig);
        this.value = configValue;
        this._name = configName;
        this._ruleID = ruleID;
        this._secondaryExposures = secondaryExposures;
        this._allocatedExperimentName = allocatedExperimentName;
        this._evaluationDetails = evaluationDetails;
        this._onDefaultValueFallback = onDefaultValueFallback;
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(DynamicConfig, [
        {
            key: "get",
            value: function get(key, defaultValue, typeGuard) {
                var _this$_onDefaultValue2;
                var val = this.getValue(key, defaultValue);
                if (val == null) return defaultValue;
                var expectedType = Array.isArray(defaultValue) ? 'array' : (0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(defaultValue);
                var actualType = Array.isArray(val) ? 'array' : (0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(val);
                if (typeGuard) {
                    var _this$_onDefaultValue;
                    if (typeGuard(val)) {
                        this.fireExposure(key);
                        return val;
                    }
                    (_this$_onDefaultValue = this._onDefaultValueFallback) === null || _this$_onDefaultValue === void 0 || _this$_onDefaultValue.call(this, this, key, expectedType, actualType);
                    return defaultValue;
                }
                if (defaultValue == null || expectedType === actualType) {
                    this.fireExposure(key);
                    return val;
                }
                (_this$_onDefaultValue2 = this._onDefaultValueFallback) === null || _this$_onDefaultValue2 === void 0 || _this$_onDefaultValue2.call(this, this, key, expectedType, actualType);
                return defaultValue;
            }
        },
        {
            key: "getValue",
            value: function getValue(key, defaultValue) {
                if (key == null) return this.value;
                if (defaultValue == null) defaultValue = null;
                if (this.value[key] == null) return defaultValue;
                this.fireExposure(key);
                return this.value[key];
            }
        },
        {
            key: "fireExposure",
            value: function fireExposure(key) {
                // Call the wrapped experiment's get method to fire exposure
                if (this.experiment) this.experiment.get(key);
            }
        }
    ], [
        {
            key: "fromExperiment",
            value: function fromExperiment(experiment) {
                var _experiment$__evaluat, _experiment$groupName;
                var config = new DynamicConfig(experiment.name, experiment.value, experiment.ruleID, (0, $nlPYW.migrateEvaluationDetails)(experiment.details), (_experiment$__evaluat = experiment.__evaluation) === null || _experiment$__evaluat === void 0 ? void 0 : _experiment$__evaluat.secondary_exposures, (_experiment$groupName = experiment.groupName) !== null && _experiment$groupName !== void 0 ? _experiment$groupName : undefined);
                config.experiment = experiment;
                return config;
            }
        }
    ]);
}();

});
parcelRegister("nlPYW", function(module, exports) {
$parcel$export(module.exports, "getOptionsWithDefaults", () => $0463168d9a3fdd97$export$d119b37e5f788b43);
$parcel$export(module.exports, "shallowEquals", () => $0463168d9a3fdd97$export$fa1c2bbf4100b8bc);
$parcel$export(module.exports, "toStatsigUser", () => $0463168d9a3fdd97$export$3dad1db244472f32);
$parcel$export(module.exports, "migrateInitializationOptions", () => $0463168d9a3fdd97$export$202946b690d26d22);
$parcel$export(module.exports, "migrateEvaluationDetails", () => $0463168d9a3fdd97$export$18ad168d3dbac899);

var $1Vcia = parcelRequire("1Vcia");

var $iYJcE = parcelRequire("iYJcE");

var $25nEq = parcelRequire("25nEq");

var $iFR7a = parcelRequire("iFR7a");

var $2bXLt = parcelRequire("2bXLt");

var $7BkNf = parcelRequire("7BkNf");

var $eMunP = parcelRequire("eMunP");
var $0463168d9a3fdd97$var$_excluded = [
    "api",
    "disableCurrentPageLogging",
    "loggingIntervalMillis",
    "loggingBufferMaxSize",
    "localMode",
    "eventLoggingApi",
    "eventLoggingApiForRetries",
    "disableLocalStorage",
    "ignoreWindowUndefined",
    "disableAllLogging",
    "initTimeoutMs",
    "disableNetworkKeepalive",
    "overrideStableID",
    "disableErrorLogging",
    "disableAutoMetricsLogging"
];
function $0463168d9a3fdd97$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $0463168d9a3fdd97$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $0463168d9a3fdd97$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $0463168d9a3fdd97$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $0463168d9a3fdd97$export$d119b37e5f788b43 = function getOptionsWithDefaults(options) {
    return $0463168d9a3fdd97$var$_objectSpread({
        /**
     * If more federal PerimeterTypes are added in the future, this should be updated so
     * that isFedRamp() === true always returns the strictest perimeter.
     */ perimeter: (0, $2bXLt.isFedRamp)() ? (0, $eMunP.PerimeterType).FEDRAMP_MODERATE : (0, $eMunP.PerimeterType).COMMERCIAL
    }, options);
};
var $0463168d9a3fdd97$export$fa1c2bbf4100b8bc = function shallowEquals(objectA, objectB) {
    if (!objectA && !objectB) return true;
    if (!objectA || !objectB) return false;
    var aEntries = Object.entries(objectA);
    var bEntries = Object.entries(objectB);
    if (aEntries.length !== bEntries.length) return false;
    var ascendingKeyOrder = function ascendingKeyOrder(_ref, _ref2) {
        var _ref3 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_ref, 1), key1 = _ref3[0];
        var _ref4 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_ref2, 1), key2 = _ref4[0];
        return key1.localeCompare(key2);
    };
    aEntries.sort(ascendingKeyOrder);
    bEntries.sort(ascendingKeyOrder);
    for(var i = 0; i < aEntries.length; i++){
        var _aEntries$i = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(aEntries[i], 2), aValue = _aEntries$i[1];
        var _bEntries$i = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(bEntries[i], 2), bValue = _bEntries$i[1];
        if (aValue !== bValue) return false;
    }
    return true;
};
var $0463168d9a3fdd97$export$3dad1db244472f32 = function toStatsigUser(identifiers, customAttributes, sdkKey) {
    var user = {
        customIDs: !(customAttributes !== null && customAttributes !== void 0 && customAttributes.stableID) && sdkKey ? $0463168d9a3fdd97$var$_objectSpread({
            stableID: (0, $iFR7a.StableID).get(sdkKey)
        }, identifiers) : identifiers,
        custom: customAttributes
    };
    if (identifiers.atlassianAccountId) user.userID = identifiers.atlassianAccountId;
    return user;
};
var $0463168d9a3fdd97$export$202946b690d26d22 = function migrateInitializationOptions(options) {
    var api = options.api, disableCurrentPageLogging = options.disableCurrentPageLogging, loggingIntervalMillis = options.loggingIntervalMillis, loggingBufferMaxSize = options.loggingBufferMaxSize, localMode = options.localMode, eventLoggingApi = options.eventLoggingApi, eventLoggingApiForRetries = options.eventLoggingApiForRetries, disableLocalStorage = options.disableLocalStorage, ignoreWindowUndefined = options.ignoreWindowUndefined, disableAllLogging = options.disableAllLogging, _initTimeoutMs = options.initTimeoutMs, _disableNetworkKeepalive = options.disableNetworkKeepalive, _overrideStableID = options.overrideStableID, _disableErrorLogging = options.disableErrorLogging, _disableAutoMetricsLogging = options.disableAutoMetricsLogging, rest = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(options, $0463168d9a3fdd97$var$_excluded);
    return $0463168d9a3fdd97$var$_objectSpread($0463168d9a3fdd97$var$_objectSpread({}, rest), {}, {
        networkConfig: {
            api: api,
            logEventUrl: eventLoggingApi ? eventLoggingApi + 'rgstr' : undefined,
            logEventFallbackUrls: eventLoggingApiForRetries ? [
                eventLoggingApiForRetries
            ] : undefined,
            preventAllNetworkTraffic: localMode || !ignoreWindowUndefined && typeof window === 'undefined'
        },
        includeCurrentPageUrlWithEvents: !disableCurrentPageLogging,
        loggingIntervalMs: loggingIntervalMillis,
        loggingBufferMaxSize: loggingBufferMaxSize,
        disableStorage: disableLocalStorage === undefined ? localMode : disableLocalStorage,
        disableLogging: disableAllLogging === undefined ? localMode : disableAllLogging
    });
};
var $0463168d9a3fdd97$var$evaluationReasonMappings = Object.entries((0, $7BkNf.EvaluationReason)).map(function(_ref5) {
    var _ref6 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_ref5, 2), key = _ref6[0], value = _ref6[1];
    return [
        key.toLowerCase(),
        value
    ];
});
var $0463168d9a3fdd97$export$18ad168d3dbac899 = function migrateEvaluationDetails(details) {
    var _evaluationReasonMapp, _evaluationReasonMapp2, _details$receivedAt;
    var reasonLower = details.reason.toLowerCase();
    return {
        reason: (_evaluationReasonMapp = (_evaluationReasonMapp2 = $0463168d9a3fdd97$var$evaluationReasonMappings.find(function(_ref7) {
            var _ref8 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_ref7, 1), key = _ref8[0];
            return reasonLower.includes(key);
        })) === null || _evaluationReasonMapp2 === void 0 ? void 0 : _evaluationReasonMapp2[1]) !== null && _evaluationReasonMapp !== void 0 ? _evaluationReasonMapp : (0, $7BkNf.EvaluationReason).Unknown,
        time: (_details$receivedAt = details.receivedAt) !== null && _details$receivedAt !== void 0 ? _details$receivedAt : Date.now()
    };
};

});
parcelRegister("2bXLt", function(module, exports) {
$parcel$export(module.exports, "isFedRamp", () => $198af7db2e8917fb$export$64d6499adf9b2e51);

var $6Pw1K = parcelRequire("6Pw1K");
function $198af7db2e8917fb$export$64d6499adf9b2e51() {
    var _global$location;
    var global = globalThis;
    // MICROS_PERIMETER is already used by few products, so we need to keep it for backward compatibility
    var env = global.MICROS_PERIMETER || global.UNSAFE_ATL_CONTEXT_BOUNDARY;
    if (env) return env === (0, $6Pw1K.FEDRAMP_MODERATE);
    var matches = (_global$location = global.location) === null || _global$location === void 0 || (_global$location = _global$location.hostname) === null || _global$location === void 0 ? void 0 : _global$location.match(/atlassian-us-gov-mod\.(com|net)|atlassian-us-gov\.(com|net)|atlassian-fex\.(com|net)|atlassian-stg-fedm\.(com|net)/);
    return matches ? matches.length > 0 : false;
}

});
parcelRegister("6Pw1K", function(module, exports) {
$parcel$export(module.exports, "FEDRAMP_MODERATE", () => $4f9059705ba73550$export$ce553301d55c2fd8);
var $4f9059705ba73550$export$ce553301d55c2fd8 = 'fedramp-moderate';
var $4f9059705ba73550$export$f005e2e9f707cb5f = 'commercial';
var $4f9059705ba73550$export$bd6b5a7802d76127 = 'fedramp-fedex';
var $4f9059705ba73550$export$a739cd5aac835909 = 'stg';
var $4f9059705ba73550$export$42dd0cdd351a4a9 = 'prod';
var $4f9059705ba73550$export$404582bc18fe4d9e = 'dev';

});


parcelRegister("7BkNf", function(module, exports) {
$parcel$export(module.exports, "EvaluationReason", () => $588c1e3b51103826$export$c62558b199e46828);
// Reference: https://github.com/statsig-io/js-lite/blob/main/src/StatsigStore.ts
var $588c1e3b51103826$export$c62558b199e46828 = /*#__PURE__*/ function(EvaluationReason) {
    EvaluationReason["Error"] = "Error";
    EvaluationReason["LocalOverride"] = "LocalOverride";
    EvaluationReason["Unrecognized"] = "Unrecognized";
    EvaluationReason["Uninitialized"] = "Uninitialized";
    EvaluationReason["NetworkNotModified"] = "NetworkNotModified";
    EvaluationReason["Network"] = "Network";
    EvaluationReason["InvalidBootstrap"] = "InvalidBootstrap";
    EvaluationReason["Bootstrap"] = "Bootstrap";
    EvaluationReason["Cache"] = "Cache";
    EvaluationReason["Unknown"] = "Unknown";
    return EvaluationReason;
}({}); // Reference: https://github.com/statsig-io/js-lite/blob/main/src/StatsigSDKOptions.ts

});

parcelRegister("eMunP", function(module, exports) {
$parcel$export(module.exports, "FeatureGateEnvironment", () => $ac2d1de1269ff12a$export$479e7351a733299);
$parcel$export(module.exports, "PerimeterType", () => $ac2d1de1269ff12a$export$c42b7bbc5e7ba555);
/**
 * The identifiers for the user. Options are restricted to the set that is currently supported.
 */ /**
 * Base client options. Does not include any options specific to providers
 * @interface BaseClientOptions
 * @property {FeatureGateEnvironment} environment - The environment for the client.
 * @property {string} targetApp - The target app for the client.
 * @property {AnalyticsWebClient} analyticsWebClient - The analytics web client.
 * @property {PerimeterType} perimeter - The perimeter for the client.
 */ /**
 * The options for the client.
 * @interface ClientOptions
 * @extends {BaseClientOptions}
 * @property {string} apiKey - The API key for the client.
 * @property {fetchTimeoutMs} fetchTimeoutMs - The timeout for the fetch request in milliseconds. Defaults to 5000.
 * @property {boolean} useGatewayURL - Whether to use the gateway URL. Defaults to false.
 */ /**
 * The custom attributes for the user.
 */ var $ac2d1de1269ff12a$export$479e7351a733299 = /*#__PURE__*/ function(FeatureGateEnvironment) {
    FeatureGateEnvironment["Development"] = "development";
    FeatureGateEnvironment["Staging"] = "staging";
    FeatureGateEnvironment["Production"] = "production";
    return FeatureGateEnvironment;
}({});
var $ac2d1de1269ff12a$export$c42b7bbc5e7ba555 = /*#__PURE__*/ function(PerimeterType) {
    PerimeterType["COMMERCIAL"] = "commercial";
    PerimeterType["FEDRAMP_MODERATE"] = "fedramp-moderate";
    return PerimeterType;
}({});
var $ac2d1de1269ff12a$export$42f4885608027d0c = 'non_boolean'; // Type magic to get the JSDoc comments from the Client class methods to appear on the static
 // methods in FeatureGates where the property name and function type are identical

});



parcelRegister("213zb", function(module, exports) {
$parcel$export(module.exports, "Layer", () => $177e70fa7a3ceaa8$export$936d0764594b6eb3);

var $ekGgq = parcelRequire("ekGgq");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $nlPYW = parcelRequire("nlPYW");
var $177e70fa7a3ceaa8$export$936d0764594b6eb3 = /*#__PURE__*/ function() {
    function Layer(name, layerValue, ruleID, evaluationDetails) {
        var logParameterFunction = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
        var secondaryExposures = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : [];
        var undelegatedSecondaryExposures = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : [];
        var allocatedExperimentName = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : '';
        var explicitParameters = arguments.length > 8 && arguments[8] !== undefined ? arguments[8] : [];
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, Layer);
        this._logParameterFunction = logParameterFunction;
        this._name = name;
        this._value = JSON.parse(JSON.stringify(layerValue !== null && layerValue !== void 0 ? layerValue : {}));
        this._ruleID = ruleID !== null && ruleID !== void 0 ? ruleID : '';
        this._evaluationDetails = evaluationDetails;
        this._secondaryExposures = secondaryExposures;
        this._undelegatedSecondaryExposures = undelegatedSecondaryExposures;
        this._allocatedExperimentName = allocatedExperimentName;
        this._explicitParameters = explicitParameters;
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(Layer, [
        {
            key: "get",
            value: function get(key, defaultValue, typeGuard) {
                var _this = this;
                var val = this._value[key];
                if (val == null) return defaultValue;
                var logAndReturn = function logAndReturn() {
                    _this._logLayerParameterExposure(key);
                    return val;
                };
                if (typeGuard) return typeGuard(val) ? logAndReturn() : defaultValue;
                if (defaultValue == null) return logAndReturn();
                if ((0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(val) === (0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(defaultValue) && Array.isArray(defaultValue) === Array.isArray(val)) return logAndReturn();
                return defaultValue;
            }
        },
        {
            key: "getValue",
            value: function getValue(key, defaultValue) {
                // eslint-disable-next-line eqeqeq
                if (defaultValue == undefined) defaultValue = null;
                var val = this._value[key];
                if (val != null) this._logLayerParameterExposure(key);
                return val !== null && val !== void 0 ? val : defaultValue;
            }
        },
        {
            key: "_logLayerParameterExposure",
            value: function _logLayerParameterExposure(parameterName) {
                var _this$_logParameterFu;
                (_this$_logParameterFu = this._logParameterFunction) === null || _this$_logParameterFu === void 0 || _this$_logParameterFu.call(this, this, parameterName);
            }
        }
    ], [
        {
            key: "fromLayer",
            value: function fromLayer(layer) {
                var _layer$__evaluation, _layer$__evaluation2, _layer$__evaluation3, _layer$__evaluation4;
                var value = new Layer(layer.name, layer.__value, layer.ruleID, (0, $nlPYW.migrateEvaluationDetails)(layer.details), function(_layer, parameterName) {
                    return layer.get(parameterName);
                }, (_layer$__evaluation = layer.__evaluation) === null || _layer$__evaluation === void 0 ? void 0 : _layer$__evaluation.secondary_exposures, (_layer$__evaluation2 = layer.__evaluation) === null || _layer$__evaluation2 === void 0 ? void 0 : _layer$__evaluation2.undelegated_secondary_exposures, (_layer$__evaluation3 = layer.__evaluation) === null || _layer$__evaluation3 === void 0 ? void 0 : _layer$__evaluation3.allocated_experiment_name, (_layer$__evaluation4 = layer.__evaluation) === null || _layer$__evaluation4 === void 0 ? void 0 : _layer$__evaluation4.explicit_parameters);
                return value;
            }
        }
    ]);
}();

});

parcelRegister("d4i2e", function(module, exports) {
$parcel$export(module.exports, "default", () => $9839a3716788087d$export$2e2bcd8739ae039);

var $25nEq = parcelRequire("25nEq");

var $fL8KA = parcelRequire("fL8KA");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $6HG4S = parcelRequire("6HG4S");

var $eMunP = parcelRequire("eMunP");

var $22KTL = parcelRequire("22KTL");

var $ebTPO = parcelRequire("ebTPO");
function $9839a3716788087d$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $9839a3716788087d$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $9839a3716788087d$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $9839a3716788087d$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $9839a3716788087d$var$DEFAULT_REQUEST_TIMEOUT_MS = 5000;
var $9839a3716788087d$export$250a58ecde616daa = 'https://api.atlassian.com/flags';
var $9839a3716788087d$export$942ba04389b0d5a2 = 'https://api.stg.atlassian.com/flags';
var $9839a3716788087d$export$f058dbf75c3bc647 = 'https://api.dev.atlassian.com/flags';
var $9839a3716788087d$export$1a401a0da8da3565 = 'https://api.stg.atlassian-us-gov-mod.com/flags';
var $9839a3716788087d$export$18c93900db9358a4 = 'https://api.atlassian-us-gov-mod.com/flags';
var $9839a3716788087d$export$450bd8fb2a6d7ace = '/gateway/api/flags';
var $9839a3716788087d$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function Fetcher() {
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, Fetcher);
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(Fetcher, null, [
        {
            key: "fetchClientSdk",
            value: function() {
                var _fetchClientSdk = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee(fetcherOptions) {
                    var targetApp, url;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee$(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                targetApp = fetcherOptions.targetApp;
                                url = "/api/v2/frontend/clientSdkKey/".concat(targetApp);
                                _context.prev = 2;
                                _context.next = 5;
                                return this.fetchRequest(url, 'GET', fetcherOptions);
                            case 5:
                                return _context.abrupt("return", _context.sent);
                            case 8:
                                _context.prev = 8;
                                _context.t0 = _context["catch"](2);
                                if (!(_context.t0 instanceof Error)) {
                                    _context.next = 12;
                                    break;
                                }
                                throw _context.t0;
                            case 12:
                                throw Error('Failed to retrieve client sdk key');
                            case 13:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee, this, [
                        [
                            2,
                            8
                        ]
                    ]);
                }));
                function fetchClientSdk(_x) {
                    return _fetchClientSdk.apply(this, arguments);
                }
                return fetchClientSdk;
            }()
        },
        {
            key: "fetchExperimentValues",
            value: function() {
                var _fetchExperimentValues = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee2(fetcherOptions, identifiers, customAttributes) {
                    var requestBody;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee2$(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                requestBody = {
                                    identifiers: identifiers,
                                    customAttributes: customAttributes,
                                    targetApp: fetcherOptions.targetApp
                                };
                                _context2.prev = 1;
                                _context2.next = 4;
                                return this.fetchRequest('/api/v2/frontend/experimentValues', 'POST', fetcherOptions, requestBody);
                            case 4:
                                return _context2.abrupt("return", _context2.sent);
                            case 7:
                                _context2.prev = 7;
                                _context2.t0 = _context2["catch"](1);
                                if (!(_context2.t0 instanceof Error)) {
                                    _context2.next = 11;
                                    break;
                                }
                                throw _context2.t0;
                            case 11:
                                throw Error('Failed to retrieve experiment values');
                            case 12:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2, this, [
                        [
                            1,
                            7
                        ]
                    ]);
                }));
                function fetchExperimentValues(_x2, _x3, _x4) {
                    return _fetchExperimentValues.apply(this, arguments);
                }
                return fetchExperimentValues;
            }()
        },
        {
            key: "handleResponseError",
            value: function() {
                var _handleResponseError = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee3(response) {
                    var body;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee3$(_context3) {
                        while(true)switch(_context3.prev = _context3.next){
                            case 0:
                                if (response.ok) {
                                    _context3.next = 5;
                                    break;
                                }
                                _context3.next = 3;
                                return response.text();
                            case 3:
                                body = _context3.sent;
                                throw new (0, $ebTPO.ResponseError)("Non 2xx response status received, status: ".concat(response.status, ", body: ").concat(JSON.stringify(body)));
                            case 5:
                                if (!(response.status === 204)) {
                                    _context3.next = 7;
                                    break;
                                }
                                throw new (0, $ebTPO.ResponseError)('Unexpected 204 response');
                            case 7:
                            case "end":
                                return _context3.stop();
                        }
                    }, _callee3);
                }));
                function handleResponseError(_x5) {
                    return _handleResponseError.apply(this, arguments);
                }
                return handleResponseError;
            }()
        },
        {
            key: "extractResponseBody",
            value: function() {
                var _extractResponseBody = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee4(response) {
                    var value;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee4$(_context4) {
                        while(true)switch(_context4.prev = _context4.next){
                            case 0:
                                _context4.next = 2;
                                return response.text();
                            case 2:
                                value = _context4.sent;
                                return _context4.abrupt("return", JSON.parse(value));
                            case 4:
                            case "end":
                                return _context4.stop();
                        }
                    }, _callee4);
                }));
                function extractResponseBody(_x6) {
                    return _extractResponseBody.apply(this, arguments);
                }
                return extractResponseBody;
            }()
        },
        {
            key: "getBaseUrl",
            value: function getBaseUrl(serviceEnv) {
                var useGatewayUrl = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
                var perimeter = arguments.length > 2 ? arguments[2] : undefined;
                if (useGatewayUrl) return $9839a3716788087d$export$450bd8fb2a6d7ace;
                if (perimeter === (0, $eMunP.PerimeterType).FEDRAMP_MODERATE) switch(serviceEnv){
                    case (0, $eMunP.FeatureGateEnvironment).Production:
                        return $9839a3716788087d$export$18c93900db9358a4;
                    case (0, $eMunP.FeatureGateEnvironment).Staging:
                        return $9839a3716788087d$export$1a401a0da8da3565;
                    default:
                        throw new Error("Invalid environment \"".concat(serviceEnv, "\" for \"").concat(perimeter, "\" perimeter"));
                }
                else if (perimeter === (0, $eMunP.PerimeterType).COMMERCIAL) switch(serviceEnv){
                    case (0, $eMunP.FeatureGateEnvironment).Development:
                        return $9839a3716788087d$export$f058dbf75c3bc647;
                    case (0, $eMunP.FeatureGateEnvironment).Staging:
                        return $9839a3716788087d$export$942ba04389b0d5a2;
                    default:
                        return $9839a3716788087d$export$250a58ecde616daa;
                }
                else throw new Error("Invalid perimeter \"".concat(perimeter, "\""));
            }
        },
        {
            key: "fetchRequest",
            value: function() {
                var _fetchRequest = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee5(path, method, fetcherOptions, body) {
                    var baseUrl, fetchTimeout, abortSignal, abortController, response;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee5$(_context5) {
                        while(true)switch(_context5.prev = _context5.next){
                            case 0:
                                baseUrl = Fetcher.getBaseUrl(fetcherOptions.environment, fetcherOptions.useGatewayURL, fetcherOptions.perimeter);
                                fetchTimeout = fetcherOptions.fetchTimeoutMs || $9839a3716788087d$var$DEFAULT_REQUEST_TIMEOUT_MS;
                                if (AbortSignal.timeout) abortSignal = AbortSignal.timeout(fetchTimeout);
                                else if (AbortController) {
                                    abortController = new AbortController();
                                    abortSignal = abortController.signal;
                                    setTimeout(function() {
                                        return abortController.abort();
                                    }, fetchTimeout);
                                }
                                _context5.next = 5;
                                return fetch("".concat(baseUrl).concat(path), $9839a3716788087d$var$_objectSpread({
                                    method: method,
                                    headers: {
                                        'Content-Type': 'application/json',
                                        'X-Client-Name': 'feature-gate-js-client',
                                        'X-Client-Version': (0, $22KTL.CLIENT_VERSION),
                                        'X-API-KEY': fetcherOptions.apiKey
                                    },
                                    signal: abortSignal
                                }, body && {
                                    body: JSON.stringify(body)
                                }));
                            case 5:
                                response = _context5.sent;
                                _context5.next = 8;
                                return this.handleResponseError(response);
                            case 8:
                                _context5.next = 10;
                                return this.extractResponseBody(response);
                            case 10:
                                return _context5.abrupt("return", _context5.sent);
                            case 11:
                            case "end":
                                return _context5.stop();
                        }
                    }, _callee5, this);
                }));
                function fetchRequest(_x7, _x8, _x9, _x10) {
                    return _fetchRequest.apply(this, arguments);
                }
                return fetchRequest;
            }()
        }
    ]);
}();

});
parcelRegister("22KTL", function(module, exports) {
$parcel$export(module.exports, "CLIENT_VERSION", () => $17d025b3b9d0326b$export$a59f8d67326bd1cb);
/// <reference types="node" />
var $17d025b3b9d0326b$export$a59f8d67326bd1cb = "4.26.5";

});

parcelRegister("ebTPO", function(module, exports) {
$parcel$export(module.exports, "ResponseError", () => $a54d6764462409b5$export$286baf652d0b1206);

var $arMYe = parcelRequire("arMYe");

var $9P61R = parcelRequire("9P61R");

var $kIXpt = parcelRequire("kIXpt");

var $cYPzS = parcelRequire("cYPzS");

var $eyuDe = parcelRequire("eyuDe");

var $c7s0H = parcelRequire("c7s0H");
function $a54d6764462409b5$var$_callSuper(t, o, e) {
    return o = (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(o), (0, (/*@__PURE__*/$parcel$interopDefault($kIXpt)))(t, $a54d6764462409b5$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(t).constructor) : o.apply(t, e));
}
function $a54d6764462409b5$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($a54d6764462409b5$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $a54d6764462409b5$export$286baf652d0b1206 = /*#__PURE__*/ function(_Error) {
    function ResponseError(message) {
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, ResponseError);
        return $a54d6764462409b5$var$_callSuper(this, ResponseError, [
            message
        ]);
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($eyuDe)))(ResponseError, _Error);
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(ResponseError);
}(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($c7s0H)))(Error));

});


parcelRegister("arraH", function(module, exports) {
$parcel$export(module.exports, "NoFetchDataAdapter", () => $79a180b0983ea59d$export$55fffef3474104af);

var $fL8KA = parcelRequire("fL8KA");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $kIXpt = parcelRequire("kIXpt");

var $cYPzS = parcelRequire("cYPzS");

var $lwlXp = parcelRequire("lwlXp");

var $eyuDe = parcelRequire("eyuDe");

var $25nEq = parcelRequire("25nEq");

var $6HG4S = parcelRequire("6HG4S");

var $iFR7a = parcelRequire("iFR7a");
function $79a180b0983ea59d$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $79a180b0983ea59d$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $79a180b0983ea59d$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $79a180b0983ea59d$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $79a180b0983ea59d$var$_callSuper(t, o, e) {
    return o = (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(o), (0, (/*@__PURE__*/$parcel$interopDefault($kIXpt)))(t, $79a180b0983ea59d$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(t).constructor) : o.apply(t, e));
}
function $79a180b0983ea59d$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($79a180b0983ea59d$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $79a180b0983ea59d$var$_superPropGet(t, o, e, r) {
    var p = (0, (/*@__PURE__*/$parcel$interopDefault($lwlXp)))((0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(1 & r ? t.prototype : t), o, e);
    return 2 & r && "function" == typeof p ? function(t) {
        return p.apply(e, t);
    } : p;
}
var $79a180b0983ea59d$export$55fffef3474104af = /*#__PURE__*/ function(_DataAdapterCore) {
    function NoFetchDataAdapter() {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, NoFetchDataAdapter);
        _this = $79a180b0983ea59d$var$_callSuper(this, NoFetchDataAdapter, [
            'NoFetchDataAdapter',
            'nofetch'
        ]);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "bootstrapResult", null);
        return _this;
    }
    /**
   * Make sure to call this **before** calling `initializeAsync` or `updateUserAsync` but
   * after the Statsig client has been created!
   */ (0, (/*@__PURE__*/$parcel$interopDefault($eyuDe)))(NoFetchDataAdapter, _DataAdapterCore);
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(NoFetchDataAdapter, [
        {
            key: "setBootstrapData",
            value: function setBootstrapData(data) {
                this.bootstrapResult = data ? {
                    source: 'Bootstrap',
                    data: JSON.stringify(data),
                    receivedAt: Date.now(),
                    stableID: (0, $iFR7a.StableID).get(this._getSdkKey()),
                    fullUserHash: null
                } : null;
            }
        },
        {
            key: "prefetchData",
            value: function() {
                var _prefetchData = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee(_user, _options) {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee$(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee);
                }));
                function prefetchData(_x, _x2) {
                    return _prefetchData.apply(this, arguments);
                }
                return prefetchData;
            }()
        },
        {
            key: "getDataAsync",
            value: function() {
                var _getDataAsync = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee2(_current, user, _options) {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee2$(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                return _context2.abrupt("return", this.bootstrapResult && $79a180b0983ea59d$var$_objectSpread($79a180b0983ea59d$var$_objectSpread({}, this.bootstrapResult), {}, {
                                    fullUserHash: (0, $iFR7a._getFullUserHash)(user)
                                }));
                            case 1:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2, this);
                }));
                function getDataAsync(_x3, _x4, _x5) {
                    return _getDataAsync.apply(this, arguments);
                }
                return getDataAsync;
            }()
        },
        {
            key: "getDataSync",
            value: function getDataSync(user) {
                return this.bootstrapResult && $79a180b0983ea59d$var$_objectSpread($79a180b0983ea59d$var$_objectSpread({}, this.bootstrapResult), {}, {
                    fullUserHash: (0, $iFR7a._getFullUserHash)(user)
                });
            }
        },
        {
            key: "_fetchFromNetwork",
            value: function() {
                var _fetchFromNetwork2 = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee3(_current, _user, _options) {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee3$(_context3) {
                        while(true)switch(_context3.prev = _context3.next){
                            case 0:
                                return _context3.abrupt("return", null);
                            case 1:
                            case "end":
                                return _context3.stop();
                        }
                    }, _callee3);
                }));
                function _fetchFromNetwork(_x6, _x7, _x8) {
                    return _fetchFromNetwork2.apply(this, arguments);
                }
                return _fetchFromNetwork;
            }()
        },
        {
            key: "_getCacheKey",
            value: function _getCacheKey(user) {
                // Same logic as default data adapter
                // https://github.com/statsig-io/js-client-monorepo/blob/main/packages/js-client/src/StatsigEvaluationsDataAdapter.ts
                var key = (0, $iFR7a._getStorageKey)(this._getSdkKey(), user);
                return "".concat((0, $iFR7a.DataAdapterCachePrefix), ".").concat(this._cacheSuffix, ".").concat(key);
            }
        },
        {
            key: "_isCachedResultValidFor204",
            value: function _isCachedResultValidFor204(_result, _user) {
                return false;
            }
        },
        {
            key: "setDataLegacy",
            value: function setDataLegacy(data, user) {
                $79a180b0983ea59d$var$_superPropGet(NoFetchDataAdapter, "setData", this, 3)([
                    data,
                    user
                ]);
            }
        },
        {
            key: "toJSON",
            value: function toJSON() {
                var result = $79a180b0983ea59d$var$_objectSpread({}, this);
                delete result._options;
                delete result._inMemoryCache;
                delete result.bootstrapResult;
                return result;
            }
        }
    ]);
}((0, $iFR7a.DataAdapterCore));

});

parcelRegister("4DKZE", function(module, exports) {
$parcel$export(module.exports, "LOCAL_STORAGE_KEY", () => $360f41ddaec7fd76$export$d8474cff104280f3);
$parcel$export(module.exports, "PersistentOverrideAdapter", () => $360f41ddaec7fd76$export$bcb28fbac1def494);

var $25nEq = parcelRequire("25nEq");

var $iYJcE = parcelRequire("iYJcE");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $dtn6l = parcelRequire("dtn6l");
function $360f41ddaec7fd76$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $360f41ddaec7fd76$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $360f41ddaec7fd76$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $360f41ddaec7fd76$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $360f41ddaec7fd76$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $360f41ddaec7fd76$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $360f41ddaec7fd76$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $360f41ddaec7fd76$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $360f41ddaec7fd76$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $360f41ddaec7fd76$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
var $360f41ddaec7fd76$var$LOCAL_OVERRIDE_REASON = 'LocalOverride:Recognized';
var $360f41ddaec7fd76$export$d8474cff104280f3 = 'STATSIG_OVERRIDES';
var $360f41ddaec7fd76$var$LEGACY_LOCAL_STORAGE_KEY = 'STATSIG_JS_LITE_LOCAL_OVERRIDES';
var $360f41ddaec7fd76$var$makeEmptyStore = function makeEmptyStore() {
    return {
        gates: {},
        configs: {},
        layers: {}
    };
};
var $360f41ddaec7fd76$var$djb2MapKey = function djb2MapKey(hash, kind) {
    return kind + ':' + hash;
};
var $360f41ddaec7fd76$export$bcb28fbac1def494 = /*#__PURE__*/ function() {
    function PersistentOverrideAdapter(localStorageKey) {
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, PersistentOverrideAdapter);
        this._overrides = $360f41ddaec7fd76$var$makeEmptyStore();
        this._djb2Map = new Map();
        this._localStorageKey = localStorageKey;
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(PersistentOverrideAdapter, [
        {
            key: "parseStoredOverrides",
            value: function parseStoredOverrides(localStorageKey) {
                try {
                    var json = window.localStorage.getItem(localStorageKey);
                    if (!json) return $360f41ddaec7fd76$var$makeEmptyStore();
                    return JSON.parse(json);
                } catch (_unused) {
                    return $360f41ddaec7fd76$var$makeEmptyStore();
                }
            }
        },
        {
            key: "mergeOverrides",
            value: function mergeOverrides() {
                var merged = $360f41ddaec7fd76$var$makeEmptyStore();
                for(var _len = arguments.length, allOverrides = new Array(_len), _key = 0; _key < _len; _key++)allOverrides[_key] = arguments[_key];
                for(var _i = 0, _allOverrides = allOverrides; _i < _allOverrides.length; _i++){
                    var overrides = _allOverrides[_i];
                    for(var _i2 = 0, _Object$entries = Object.entries((_overrides$gates = overrides.gates) !== null && _overrides$gates !== void 0 ? _overrides$gates : {}); _i2 < _Object$entries.length; _i2++){
                        var _overrides$gates;
                        var _Object$entries$_i = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_Object$entries[_i2], 2), name = _Object$entries$_i[0], value = _Object$entries$_i[1];
                        merged.gates[name] = value;
                    }
                    for(var _i3 = 0, _Object$entries2 = Object.entries((_overrides$configs = overrides.configs) !== null && _overrides$configs !== void 0 ? _overrides$configs : {}); _i3 < _Object$entries2.length; _i3++){
                        var _overrides$configs;
                        var _Object$entries2$_i = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_Object$entries2[_i3], 2), _name = _Object$entries2$_i[0], _value = _Object$entries2$_i[1];
                        merged.configs[_name] = _value;
                    }
                    for(var _i4 = 0, _Object$entries3 = Object.entries((_overrides$layers = overrides.layers) !== null && _overrides$layers !== void 0 ? _overrides$layers : {}); _i4 < _Object$entries3.length; _i4++){
                        var _overrides$layers;
                        var _Object$entries3$_i = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_Object$entries3[_i4], 2), _name2 = _Object$entries3$_i[0], _value2 = _Object$entries3$_i[1];
                        merged.layers[_name2] = _value2;
                    }
                }
                return merged;
            }
        },
        {
            key: "initFromStoredOverrides",
            value: function initFromStoredOverrides() {
                var storedOverrides = this.mergeOverrides(this._overrides, this.parseStoredOverrides($360f41ddaec7fd76$var$LEGACY_LOCAL_STORAGE_KEY), this.parseStoredOverrides(this._localStorageKey));
                // Clear data from legacy local storage key now we've read from it.
                // This prevents things being stuck in there that are always read but never written to.
                try {
                    window.localStorage.removeItem($360f41ddaec7fd76$var$LEGACY_LOCAL_STORAGE_KEY);
                } catch (_unused2) {
                // ignored - window is not defined in non-browser environments, and we don't save things there
                // (things like SSR, etc)
                }
                // In version 4.24.0 we introduced hashes in this override adapter, but had a bug which would cause
                // multiple hashes to continue being created. This code here removes these hashes since we've moved
                // to using a more reliable and easier to maintain map in `_djb2Map`.
                for(var _i5 = 0, _Object$values = Object.values(storedOverrides); _i5 < _Object$values.length; _i5++){
                    var container = _Object$values[_i5];
                    var allKeys = new Set(Object.keys(container));
                    var _iterator = $360f41ddaec7fd76$var$_createForOfIteratorHelper(allKeys), _step;
                    try {
                        for(_iterator.s(); !(_step = _iterator.n()).done;){
                            var name = _step.value;
                            var hash = (0, $dtn6l._DJB2)(name);
                            if (allKeys.has(hash)) delete container[hash];
                        }
                    } catch (err) {
                        _iterator.e(err);
                    } finally{
                        _iterator.f();
                    }
                }
                this.applyOverrides(storedOverrides);
            }
        },
        {
            key: "saveOverrides",
            value: function saveOverrides() {
                try {
                    window.localStorage.setItem(this._localStorageKey, JSON.stringify(this._overrides));
                } catch (_unused3) {
                // ignored - window is not defined in non-browser environments, and we don't save things there
                // (things like SSR, etc)
                }
            }
        },
        {
            key: "getOverrides",
            value: function getOverrides() {
                return this.mergeOverrides(this._overrides);
            }
        },
        {
            key: "applyOverrides",
            value: function applyOverrides(overrides) {
                var newOverrides = $360f41ddaec7fd76$var$_objectSpread($360f41ddaec7fd76$var$_objectSpread({}, $360f41ddaec7fd76$var$makeEmptyStore()), overrides);
                this._djb2Map.clear();
                for(var _i6 = 0, _Object$entries4 = Object.entries(newOverrides); _i6 < _Object$entries4.length; _i6++){
                    var _Object$entries4$_i = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_Object$entries4[_i6], 2), containerName = _Object$entries4$_i[0], container = _Object$entries4$_i[1];
                    for(var _i7 = 0, _Object$entries5 = Object.entries(container); _i7 < _Object$entries5.length; _i7++){
                        var _Object$entries5$_i = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_Object$entries5[_i7], 2), name = _Object$entries5$_i[0], value = _Object$entries5$_i[1];
                        this._djb2Map.set($360f41ddaec7fd76$var$djb2MapKey((0, $dtn6l._DJB2)(name), containerName), value);
                    }
                }
                this._overrides = newOverrides;
            }
        },
        {
            key: "setOverrides",
            value: function setOverrides(overrides) {
                this.applyOverrides(overrides);
                this.saveOverrides();
            }
        },
        {
            key: "overrideGate",
            value: function overrideGate(name, value) {
                this._overrides.gates[name] = value;
                this._djb2Map.set($360f41ddaec7fd76$var$djb2MapKey((0, $dtn6l._DJB2)(name), 'gates'), value);
                this.saveOverrides();
            }
        },
        {
            key: "removeGateOverride",
            value: function removeGateOverride(name) {
                delete this._overrides.gates[name];
                this._djb2Map.delete($360f41ddaec7fd76$var$djb2MapKey((0, $dtn6l._DJB2)(name), 'gates'));
                this.saveOverrides();
            }
        },
        {
            key: "getGateOverride",
            value: function getGateOverride(current, _user) {
                var _this$_overrides$gate;
                var overridden = (_this$_overrides$gate = this._overrides.gates[current.name]) !== null && _this$_overrides$gate !== void 0 ? _this$_overrides$gate : this._djb2Map.get($360f41ddaec7fd76$var$djb2MapKey(current.name, 'gates'));
                if (overridden == null) return null;
                return $360f41ddaec7fd76$var$_objectSpread($360f41ddaec7fd76$var$_objectSpread({}, current), {}, {
                    value: overridden,
                    details: $360f41ddaec7fd76$var$_objectSpread($360f41ddaec7fd76$var$_objectSpread({}, current.details), {}, {
                        reason: $360f41ddaec7fd76$var$LOCAL_OVERRIDE_REASON
                    })
                });
            }
        },
        {
            key: "overrideDynamicConfig",
            value: function overrideDynamicConfig(name, value) {
                this._overrides.configs[name] = value;
                this._djb2Map.set($360f41ddaec7fd76$var$djb2MapKey((0, $dtn6l._DJB2)(name), 'configs'), value);
                this.saveOverrides();
            }
        },
        {
            key: "removeDynamicConfigOverride",
            value: function removeDynamicConfigOverride(name) {
                delete this._overrides.configs[name];
                this._djb2Map.delete($360f41ddaec7fd76$var$djb2MapKey((0, $dtn6l._DJB2)(name), 'configs'));
                this.saveOverrides();
            }
        },
        {
            key: "getDynamicConfigOverride",
            value: function getDynamicConfigOverride(current, _user) {
                return this._getConfigOverride(current, this._overrides.configs);
            }
        },
        {
            key: "overrideExperiment",
            value: function overrideExperiment(name, value) {
                this._overrides.configs[name] = value;
                this._djb2Map.set($360f41ddaec7fd76$var$djb2MapKey((0, $dtn6l._DJB2)(name), 'configs'), value);
                this.saveOverrides();
            }
        },
        {
            key: "removeExperimentOverride",
            value: function removeExperimentOverride(name) {
                delete this._overrides.configs[name];
                this._djb2Map.delete($360f41ddaec7fd76$var$djb2MapKey((0, $dtn6l._DJB2)(name), 'configs'));
                this.saveOverrides();
            }
        },
        {
            key: "getExperimentOverride",
            value: function getExperimentOverride(current, _user) {
                return this._getConfigOverride(current, this._overrides.configs);
            }
        },
        {
            key: "overrideLayer",
            value: function overrideLayer(name, value) {
                this._overrides.layers[name] = value;
                this._djb2Map.set($360f41ddaec7fd76$var$djb2MapKey((0, $dtn6l._DJB2)(name), 'layers'), value);
                this.saveOverrides();
            }
        },
        {
            key: "removeLayerOverride",
            value: function removeLayerOverride(name) {
                delete this._overrides.layers[name];
                this._djb2Map.delete($360f41ddaec7fd76$var$djb2MapKey((0, $dtn6l._DJB2)(name), 'layers'));
                this.saveOverrides();
            }
        },
        {
            key: "removeAllOverrides",
            value: function removeAllOverrides() {
                this._overrides = $360f41ddaec7fd76$var$makeEmptyStore();
                try {
                    window.localStorage.removeItem(this._localStorageKey);
                } catch (_unused4) {
                // ignored - window is not defined in non-browser environments, and we don't save things there
                // (things like SSR, etc)
                }
            }
        },
        {
            key: "getLayerOverride",
            value: function getLayerOverride(current, _user) {
                var _this$_overrides$laye;
                var overridden = (_this$_overrides$laye = this._overrides.layers[current.name]) !== null && _this$_overrides$laye !== void 0 ? _this$_overrides$laye : this._djb2Map.get($360f41ddaec7fd76$var$djb2MapKey(current.name, 'layers'));
                if (overridden == null) return null;
                return $360f41ddaec7fd76$var$_objectSpread($360f41ddaec7fd76$var$_objectSpread({}, current), {}, {
                    __value: overridden,
                    get: (0, $dtn6l._makeTypedGet)(current.name, overridden),
                    details: $360f41ddaec7fd76$var$_objectSpread($360f41ddaec7fd76$var$_objectSpread({}, current.details), {}, {
                        reason: $360f41ddaec7fd76$var$LOCAL_OVERRIDE_REASON
                    })
                });
            }
        },
        {
            key: "_getConfigOverride",
            value: function _getConfigOverride(current, lookup) {
                var _lookup$current$name;
                var overridden = (_lookup$current$name = lookup[current.name]) !== null && _lookup$current$name !== void 0 ? _lookup$current$name : this._djb2Map.get($360f41ddaec7fd76$var$djb2MapKey(current.name, 'configs'));
                if (overridden == null) return null;
                return $360f41ddaec7fd76$var$_objectSpread($360f41ddaec7fd76$var$_objectSpread({}, current), {}, {
                    value: overridden,
                    get: (0, $dtn6l._makeTypedGet)(current.name, overridden),
                    details: $360f41ddaec7fd76$var$_objectSpread($360f41ddaec7fd76$var$_objectSpread({}, current.details), {}, {
                        reason: $360f41ddaec7fd76$var$LOCAL_OVERRIDE_REASON
                    })
                });
            }
        }
    ]);
}();

});




parcelRegister("22vaF", function(module, exports) {
$parcel$export(module.exports, "R50", () => $17c3f295c13f82d8$export$4b84fd0e2c617bd);
$parcel$export(module.exports, "R75", () => $17c3f295c13f82d8$export$b34b069eff244586);
$parcel$export(module.exports, "R100", () => $17c3f295c13f82d8$export$be802dd0d8b57f35);
$parcel$export(module.exports, "R300", () => $17c3f295c13f82d8$export$4a7404f376229999);
$parcel$export(module.exports, "R500", () => $17c3f295c13f82d8$export$2837b5a1a71d5c02);
$parcel$export(module.exports, "Y50", () => $17c3f295c13f82d8$export$8d9596b529bbb9cf);
$parcel$export(module.exports, "Y75", () => $17c3f295c13f82d8$export$41060a744ab0b7ae);
$parcel$export(module.exports, "Y200", () => $17c3f295c13f82d8$export$5aae31392d72caaa);
$parcel$export(module.exports, "Yellow200", () => $17c3f295c13f82d8$export$fc857b6f8771648a);
$parcel$export(module.exports, "Y400", () => $17c3f295c13f82d8$export$59619663aa6500fb);
$parcel$export(module.exports, "G50", () => $17c3f295c13f82d8$export$8a6341c32b6a3ee6);
$parcel$export(module.exports, "G75", () => $17c3f295c13f82d8$export$69a3bf21b9686c2b);
$parcel$export(module.exports, "G200", () => $17c3f295c13f82d8$export$747d86715d4175de);
$parcel$export(module.exports, "G300", () => $17c3f295c13f82d8$export$940e1f69e873f202);
$parcel$export(module.exports, "G500", () => $17c3f295c13f82d8$export$6fa04827ac68a4fb);
$parcel$export(module.exports, "B50", () => $17c3f295c13f82d8$export$226de0355ed012f8);
$parcel$export(module.exports, "B75", () => $17c3f295c13f82d8$export$8c13c2ee36917869);
$parcel$export(module.exports, "B100", () => $17c3f295c13f82d8$export$ecfc1dff386a3e7a);
$parcel$export(module.exports, "B400", () => $17c3f295c13f82d8$export$b3de0ae08da2ce64);
$parcel$export(module.exports, "B500", () => $17c3f295c13f82d8$export$a6ee3d71bc067634);
$parcel$export(module.exports, "L200", () => $17c3f295c13f82d8$export$f72948ef771f6f15);
$parcel$export(module.exports, "N0", () => $17c3f295c13f82d8$export$29a4f05edc054374);
$parcel$export(module.exports, "N20", () => $17c3f295c13f82d8$export$9fdfb749e33cdf97);
$parcel$export(module.exports, "N30", () => $17c3f295c13f82d8$export$3e51e8f1440314ba);
$parcel$export(module.exports, "N60", () => $17c3f295c13f82d8$export$c2e91cbeada39b8b);
$parcel$export(module.exports, "N80", () => $17c3f295c13f82d8$export$eaa8c8a70ac22806);
$parcel$export(module.exports, "Neutral300", () => $17c3f295c13f82d8$export$1ae1cebe22dcedb4);
$parcel$export(module.exports, "N300A", () => $17c3f295c13f82d8$export$13609db0e6812ab8);
$parcel$export(module.exports, "N600", () => $17c3f295c13f82d8$export$7090862dc3038a9f);
$parcel$export(module.exports, "N800", () => $17c3f295c13f82d8$export$7d61b15e0da132af);
$parcel$export(module.exports, "N1000", () => $17c3f295c13f82d8$export$f78789c8b01753cd);
$parcel$export(module.exports, "M200", () => $17c3f295c13f82d8$export$a19f0c33186f7767);
$parcel$export(module.exports, "O200", () => $17c3f295c13f82d8$export$51716a84e62e022c);
$parcel$export(module.exports, "P50", () => $17c3f295c13f82d8$export$363e4475840015bb);
$parcel$export(module.exports, "P75", () => $17c3f295c13f82d8$export$4b0a4417ed59760f);
$parcel$export(module.exports, "P100", () => $17c3f295c13f82d8$export$6011520a64d9a187);
$parcel$export(module.exports, "P200", () => $17c3f295c13f82d8$export$a7175d4e9206bc80);
$parcel$export(module.exports, "P300", () => $17c3f295c13f82d8$export$b48405b95304b5a1);
$parcel$export(module.exports, "P500", () => $17c3f295c13f82d8$export$147899de772240ec);
$parcel$export(module.exports, "T50", () => $17c3f295c13f82d8$export$2cf711fe14c66f06);
$parcel$export(module.exports, "T75", () => $17c3f295c13f82d8$export$7a8f4d33f6f9772c);
$parcel$export(module.exports, "T100", () => $17c3f295c13f82d8$export$776c9c497ef08533);
$parcel$export(module.exports, "T200", () => $17c3f295c13f82d8$export$69cb3ca10c1e330e);
$parcel$export(module.exports, "T300", () => $17c3f295c13f82d8$export$9dc1ef0f3f48059b);
$parcel$export(module.exports, "T500", () => $17c3f295c13f82d8$export$6036577f95c3877e);
$parcel$export(module.exports, "isHex", () => $17c3f295c13f82d8$export$8a9b6341a7c96bc);
$parcel$export(module.exports, "isRgb", () => $17c3f295c13f82d8$export$e698776ec826343);
$parcel$export(module.exports, "rgbToHex", () => $17c3f295c13f82d8$export$34d09c4a771c46ef);
$parcel$export(module.exports, "hexToRgba", () => $17c3f295c13f82d8$export$9665a07d9187b414);

var $iYJcE = parcelRequire("iYJcE");

var $gMcRf = parcelRequire("gMcRf");
var $17c3f295c13f82d8$export$4b84fd0e2c617bd = '#FFEBE6';
var $17c3f295c13f82d8$export$b34b069eff244586 = '#FFBDAD';
var $17c3f295c13f82d8$export$be802dd0d8b57f35 = '#FF8F73';
var $17c3f295c13f82d8$export$4a7404f376229999 = '#FF5630';
var $17c3f295c13f82d8$export$2010d0fb4295b346 = '#DE350B';
var $17c3f295c13f82d8$export$2837b5a1a71d5c02 = '#BF2600';
var $17c3f295c13f82d8$export$8d9596b529bbb9cf = '#FFFAE6';
var $17c3f295c13f82d8$export$41060a744ab0b7ae = '#FFF0B3';
var $17c3f295c13f82d8$export$5aae31392d72caaa = '#FFC400';
var $17c3f295c13f82d8$export$fc857b6f8771648a = '#F8E6A0';
var $17c3f295c13f82d8$export$59619663aa6500fb = '#FF991F';
var $17c3f295c13f82d8$export$874739ea9e379ab6 = '#FF8B00';
var $17c3f295c13f82d8$export$8a6341c32b6a3ee6 = '#E3FCEF';
var $17c3f295c13f82d8$export$69a3bf21b9686c2b = '#ABF5D1';
var $17c3f295c13f82d8$export$747d86715d4175de = '#57D9A3';
var $17c3f295c13f82d8$export$940e1f69e873f202 = '#36B37E';
var $17c3f295c13f82d8$export$a49394138f7b8e85 = '#00875A';
var $17c3f295c13f82d8$export$6fa04827ac68a4fb = '#006644';
var $17c3f295c13f82d8$export$226de0355ed012f8 = '#DEEBFF';
var $17c3f295c13f82d8$export$8c13c2ee36917869 = '#B3D4FF';
var $17c3f295c13f82d8$export$ecfc1dff386a3e7a = '#4C9AFF';
var $17c3f295c13f82d8$export$b3de0ae08da2ce64 = '#0052CC';
var $17c3f295c13f82d8$export$a6ee3d71bc067634 = '#0747A6';
var $17c3f295c13f82d8$export$f72948ef771f6f15 = '#D3F1A7';
var $17c3f295c13f82d8$export$29a4f05edc054374 = '#FFFFFF';
var $17c3f295c13f82d8$export$9fdfb749e33cdf97 = '#F4F5F7';
var $17c3f295c13f82d8$export$3e51e8f1440314ba = '#EBECF0';
var $17c3f295c13f82d8$export$1ce2d1575d444ceb = '#DFE1E6';
var $17c3f295c13f82d8$export$8754fc7e6d8b3000 = '#C1C7D0';
var $17c3f295c13f82d8$export$c2e91cbeada39b8b = '#B3BAC5';
var $17c3f295c13f82d8$export$eaa8c8a70ac22806 = '#97A0AF';
var $17c3f295c13f82d8$export$7c87d337fb91a97d = '#8993A4';
var $17c3f295c13f82d8$export$f563ee71e9ee74cd = '#6B778C';
var $17c3f295c13f82d8$export$e2ef2124cf4024b1 = '#5E6C84';
var $17c3f295c13f82d8$export$1ae1cebe22dcedb4 = '#DCDFE4';
var $17c3f295c13f82d8$export$13609db0e6812ab8 = '#091E4224';
var $17c3f295c13f82d8$export$c39c0fe0f26207ae = '#42526E';
var $17c3f295c13f82d8$export$7090862dc3038a9f = '#758195';
var $17c3f295c13f82d8$export$7d61b15e0da132af = '#172B4D';
var $17c3f295c13f82d8$export$f78789c8b01753cd = '#172B4D';
var $17c3f295c13f82d8$export$a19f0c33186f7767 = '#FDD0EC';
var $17c3f295c13f82d8$export$51716a84e62e022c = '#FEDEC8';
var $17c3f295c13f82d8$export$363e4475840015bb = '#EAE6FF';
var $17c3f295c13f82d8$export$4b0a4417ed59760f = '#C0B6F2';
var $17c3f295c13f82d8$export$6011520a64d9a187 = '#998DD9';
var $17c3f295c13f82d8$export$a7175d4e9206bc80 = '#DFD8FD';
var $17c3f295c13f82d8$export$b48405b95304b5a1 = '#6554C0';
var $17c3f295c13f82d8$export$c71e4279dd54a18d = '#5243AA';
var $17c3f295c13f82d8$export$147899de772240ec = '#403294';
var $17c3f295c13f82d8$export$2cf711fe14c66f06 = '#E6FCFF';
var $17c3f295c13f82d8$export$7a8f4d33f6f9772c = '#B3F5FF';
var $17c3f295c13f82d8$export$776c9c497ef08533 = '#79E2F2';
var $17c3f295c13f82d8$export$69cb3ca10c1e330e = '#C6EDFB';
var $17c3f295c13f82d8$export$9dc1ef0f3f48059b = '#00B8D9';
var $17c3f295c13f82d8$export$6036577f95c3877e = '#008DA6';
function $17c3f295c13f82d8$export$b61655071712e690(color, defaultColor) {
    if (!color) return null;
    // Normalize to hex
    color = color.trim().toLowerCase();
    if ($17c3f295c13f82d8$export$8a9b6341a7c96bc(color)) // Normalize 3-hex to 6-hex colours
    {
        if (color.length === 4) color = color.split('').map(function(c) {
            return c === '#' ? '#' : "".concat(c).concat(c);
        }).join('');
    } else if ($17c3f295c13f82d8$export$e698776ec826343(color)) return $17c3f295c13f82d8$export$34d09c4a771c46ef(color);
    else {
        // http://dev.w3.org/csswg/css-color/#named-colors
        if (color === 'default') return null;
        else if ($gMcRf.default && $gMcRf.default[color]) color = $gMcRf.default[color];
        else if ($gMcRf && $gMcRf[color]) color = $gMcRf[color];
        else return null;
    }
    if (color === defaultColor) return null;
    return color;
}
function $17c3f295c13f82d8$export$5a544e13ad4e1fa5(color) {
    if (!$17c3f295c13f82d8$export$8a9b6341a7c96bc(color)) return null;
    var colorBits = color.substring(1).split('');
    if (colorBits.length === 3) colorBits = [
        colorBits[0],
        colorBits[0],
        colorBits[1],
        colorBits[1],
        colorBits[2],
        colorBits[2]
    ];
    var rgb = Number("0x".concat(colorBits.join('')));
    // eslint-disable-next-line no-bitwise
    return "rgb(".concat(rgb >> 16 & 255, ",").concat(rgb >> 8 & 255, ",").concat(rgb & 255, ")");
}
function $17c3f295c13f82d8$export$9665a07d9187b414(rawColor, alpha) {
    var color = $17c3f295c13f82d8$export$b61655071712e690(rawColor);
    if (!color) return null;
    var hex2rgb = function hex2rgb(color) {
        return color.match(/[a-z0-9]{2}/gi).map(function(hex) {
            return parseInt(hex, 16);
        });
    };
    return "rgba(".concat(hex2rgb(color).concat(alpha).join(','), ")");
}
function $17c3f295c13f82d8$export$34d09c4a771c46ef(value) {
    var matches = value.match(/(0?\.?\d{1,3})%?\b/g);
    if (matches && matches.length >= 3) {
        var _matches$map = matches.map(Number), _matches$map2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_matches$map, 3), red = _matches$map2[0], green = _matches$map2[1], blue = _matches$map2[2];
        return '#' + (blue | green << 8 | red << 16 | 16777216).toString(16).slice(1) // eslint-disable-line no-bitwise
        ;
    }
    return null;
}
function $17c3f295c13f82d8$export$e698776ec826343(color) {
    return /rgba?\(/.test(color);
}
function $17c3f295c13f82d8$export$8a9b6341a7c96bc(color) {
    return /^#([A-Fa-f0-9]{3}){1,2}$/.test(color);
}

});
parcelRegister("gMcRf", function(module, exports) {
module.exports = JSON.parse("{\"aliceblue\":\"#f0f8ff\",\"antiquewhite\":\"#faebd7\",\"aqua\":\"#00ffff\",\"aquamarine\":\"#7fffd4\",\"azure\":\"#f0ffff\",\"beige\":\"#f5f5dc\",\"bisque\":\"#ffe4c4\",\"black\":\"#000000\",\"blanchedalmond\":\"#ffebcd\",\"blue\":\"#0000ff\",\"blueviolet\":\"#8a2be2\",\"brown\":\"#a52a2a\",\"burlywood\":\"#deb887\",\"cadetblue\":\"#5f9ea0\",\"chartreuse\":\"#7fff00\",\"chocolate\":\"#d2691e\",\"coral\":\"#ff7f50\",\"cornflowerblue\":\"#6495ed\",\"cornsilk\":\"#fff8dc\",\"crimson\":\"#dc143c\",\"cyan\":\"#00ffff\",\"darkblue\":\"#00008b\",\"darkcyan\":\"#008b8b\",\"darkgoldenrod\":\"#b8860b\",\"darkgray\":\"#a9a9a9\",\"darkgreen\":\"#006400\",\"darkgrey\":\"#a9a9a9\",\"darkkhaki\":\"#bdb76b\",\"darkmagenta\":\"#8b008b\",\"darkolivegreen\":\"#556b2f\",\"darkorange\":\"#ff8c00\",\"darkorchid\":\"#9932cc\",\"darkred\":\"#8b0000\",\"darksalmon\":\"#e9967a\",\"darkseagreen\":\"#8fbc8f\",\"darkslateblue\":\"#483d8b\",\"darkslategray\":\"#2f4f4f\",\"darkslategrey\":\"#2f4f4f\",\"darkturquoise\":\"#00ced1\",\"darkviolet\":\"#9400d3\",\"deeppink\":\"#ff1493\",\"deepskyblue\":\"#00bfff\",\"dimgray\":\"#696969\",\"dimgrey\":\"#696969\",\"dodgerblue\":\"#1e90ff\",\"firebrick\":\"#b22222\",\"floralwhite\":\"#fffaf0\",\"forestgreen\":\"#228b22\",\"fuchsia\":\"#ff00ff\",\"gainsboro\":\"#dcdcdc\",\"ghostwhite\":\"#f8f8ff\",\"gold\":\"#ffd700\",\"goldenrod\":\"#daa520\",\"gray\":\"#808080\",\"green\":\"#008000\",\"greenyellow\":\"#adff2f\",\"grey\":\"#808080\",\"honeydew\":\"#f0fff0\",\"hotpink\":\"#ff69b4\",\"indianred\":\"#cd5c5c\",\"indigo\":\"#4b0082\",\"ivory\":\"#fffff0\",\"khaki\":\"#f0e68c\",\"lavender\":\"#e6e6fa\",\"lavenderblush\":\"#fff0f5\",\"lawngreen\":\"#7cfc00\",\"lemonchiffon\":\"#fffacd\",\"lightblue\":\"#add8e6\",\"lightcoral\":\"#f08080\",\"lightcyan\":\"#e0ffff\",\"lightgoldenrodyellow\":\"#fafad2\",\"lightgray\":\"#d3d3d3\",\"lightgreen\":\"#90ee90\",\"lightgrey\":\"#d3d3d3\",\"lightpink\":\"#ffb6c1\",\"lightsalmon\":\"#ffa07a\",\"lightseagreen\":\"#20b2aa\",\"lightskyblue\":\"#87cefa\",\"lightslategray\":\"#778899\",\"lightslategrey\":\"#778899\",\"lightsteelblue\":\"#b0c4de\",\"lightyellow\":\"#ffffe0\",\"lime\":\"#00ff00\",\"limegreen\":\"#32cd32\",\"linen\":\"#faf0e6\",\"magenta\":\"#ff00ff\",\"maroon\":\"#800000\",\"mediumaquamarine\":\"#66cdaa\",\"mediumblue\":\"#0000cd\",\"mediumorchid\":\"#ba55d3\",\"mediumpurple\":\"#9370db\",\"mediumseagreen\":\"#3cb371\",\"mediumslateblue\":\"#7b68ee\",\"mediumspringgreen\":\"#00fa9a\",\"mediumturquoise\":\"#48d1cc\",\"mediumvioletred\":\"#c71585\",\"midnightblue\":\"#191970\",\"mintcream\":\"#f5fffa\",\"mistyrose\":\"#ffe4e1\",\"moccasin\":\"#ffe4b5\",\"navajowhite\":\"#ffdead\",\"navy\":\"#000080\",\"oldlace\":\"#fdf5e6\",\"olive\":\"#808000\",\"olivedrab\":\"#6b8e23\",\"orange\":\"#ffa500\",\"orangered\":\"#ff4500\",\"orchid\":\"#da70d6\",\"palegoldenrod\":\"#eee8aa\",\"palegreen\":\"#98fb98\",\"paleturquoise\":\"#afeeee\",\"palevioletred\":\"#db7093\",\"papayawhip\":\"#ffefd5\",\"peachpuff\":\"#ffdab9\",\"peru\":\"#cd853f\",\"pink\":\"#ffc0cb\",\"plum\":\"#dda0dd\",\"powderblue\":\"#b0e0e6\",\"purple\":\"#800080\",\"rebeccapurple\":\"#663399\",\"red\":\"#ff0000\",\"rosybrown\":\"#bc8f8f\",\"royalblue\":\"#4169e1\",\"saddlebrown\":\"#8b4513\",\"salmon\":\"#fa8072\",\"sandybrown\":\"#f4a460\",\"seagreen\":\"#2e8b57\",\"seashell\":\"#fff5ee\",\"sienna\":\"#a0522d\",\"silver\":\"#c0c0c0\",\"skyblue\":\"#87ceeb\",\"slateblue\":\"#6a5acd\",\"slategray\":\"#708090\",\"slategrey\":\"#708090\",\"snow\":\"#fffafa\",\"springgreen\":\"#00ff7f\",\"steelblue\":\"#4682b4\",\"tan\":\"#d2b48c\",\"teal\":\"#008080\",\"thistle\":\"#d8bfd8\",\"tomato\":\"#ff6347\",\"turquoise\":\"#40e0d0\",\"violet\":\"#ee82ee\",\"wheat\":\"#f5deb3\",\"white\":\"#ffffff\",\"whitesmoke\":\"#f5f5f5\",\"yellow\":\"#ffff00\",\"yellowgreen\":\"#9acd32\"}");

});


parcelRegister("gwjAb", function(module, exports) {
$parcel$export(module.exports, "getDarkModeLCHColor", () => $c06ed32dd488160c$export$a5065c3b8aacaf99);
// https://en.wikipedia.org/wiki/HCL_color_space
// https://en.wikipedia.org/wiki/CIE_1931_color_space#CIE_xy_chromaticity_diagram_and_the_CIE_xyY_color_space
// https://en.wikipedia.org/wiki/CIELAB_color_space
var $c06ed32dd488160c$var$clamp = function clamp(i, min, max) {
    return Math.round(Math.min(Math.max(i, min), max));
};
var $c06ed32dd488160c$var$expandShorthandHex = function expandShorthandHex(input) {
    return input.replace(/^#?([a-f\d])([a-f\d])([a-f\d])$/i, function(m, r, g, b) {
        return r + r + g + g + b + b;
    });
};
var $c06ed32dd488160c$var$rgbFromHex = function rgbFromHex(input) {
    var fullHex = $c06ed32dd488160c$var$expandShorthandHex(input);
    var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(fullHex);
    return result === null ? null : {
        r: parseInt(result[1], 16),
        g: parseInt(result[2], 16),
        b: parseInt(result[3], 16)
    };
};
var $c06ed32dd488160c$var$rgbToHex = function rgbToHex(_ref) {
    var r = _ref.r, g = _ref.g, b = _ref.b;
    var convertComponent = function convertComponent(c) {
        var cBase16 = c.toString(16);
        return cBase16.length === 1 ? "0".concat(cBase16) : cBase16;
    };
    return "#".concat(convertComponent(r)).concat(convertComponent(g)).concat(convertComponent(b));
};
var $c06ed32dd488160c$var$rgbToXyz = function rgbToXyz(rgb) {
    var convertRgbComponent = function convertRgbComponent(c) {
        return c > 0.04045 ? Math.pow((c + 0.055) / 1.055, 2.4) : c / 12.92;
    };
    var convertXyzComponent = function convertXyzComponent(c) {
        return c > 0.008856452 ? Math.pow(c, 1 / 3) : c / 0.12841855 + 0.137931034;
    };
    var r = convertRgbComponent(rgb.r / 255);
    var g = convertRgbComponent(rgb.g / 255);
    var b = convertRgbComponent(rgb.b / 255);
    return {
        x: convertXyzComponent((0.4124564 * r + 0.3575761 * g + 0.1804375 * b) / 0.95047),
        y: convertXyzComponent(0.2126729 * r + 0.7151522 * g + 0.072175 * b),
        z: convertXyzComponent((0.0193339 * r + 0.119192 * g + 0.9503041 * b) / 1.08883)
    };
};
var $c06ed32dd488160c$var$xyzToLab = function xyzToLab(_ref2) {
    var x = _ref2.x, y = _ref2.y, z = _ref2.z;
    return {
        l: Math.max(116 * y - 16, 0),
        a: 500 * (x - y),
        b: 200 * (y - z)
    };
};
var $c06ed32dd488160c$var$labToLch = function labToLch(_ref3) {
    var l = _ref3.l, a = _ref3.a, b = _ref3.b;
    var h = (Math.atan2(b, a) * (180 / Math.PI) + 360) % 360;
    var c = Math.sqrt(Math.pow(a, 2) + Math.pow(b, 2));
    if (Math.round(c * 10000) === 0) h = Number.NaN;
    return {
        l: l,
        c: c,
        h: h
    };
};
var $c06ed32dd488160c$var$lchToLab = function lchToLab(_ref4) {
    var l = _ref4.l, c = _ref4.c, h = _ref4.h;
    var convertH = Number.isNaN(h) ? 0 : h * (Math.PI / 180);
    return {
        l: l,
        a: Math.cos(convertH) * c,
        b: Math.sin(convertH) * c
    };
};
var $c06ed32dd488160c$var$labToXyz = function labToXyz(_ref5) {
    var l = _ref5.l, a = _ref5.a, b = _ref5.b;
    var convertComponent = function convertComponent(c) {
        return c > 0.206896552 ? Math.pow(c, 3) : 0.12841855 * (c - 0.137931034);
    };
    var y = (l + 16) / 116;
    var x = a / 500 + y;
    var z = y - b / 200;
    return {
        x: convertComponent(x) * 0.95047,
        y: convertComponent(y),
        z: convertComponent(z) * 1.08883
    };
};
var $c06ed32dd488160c$var$xyzToRgb = function xyzToRgb(_ref6) {
    var x = _ref6.x, y = _ref6.y, z = _ref6.z;
    var convertComponent = function convertComponent(c) {
        return 255 * (c <= 0.00304 ? 12.92 * c : 1.055 * Math.pow(c, 1 / 2.4) - 0.055);
    };
    return {
        r: $c06ed32dd488160c$var$clamp(convertComponent(3.2404542 * x - 1.5371385 * y - 0.4985314 * z), 0, 255),
        g: $c06ed32dd488160c$var$clamp(convertComponent(-0.969266 * x + 1.8760108 * y + 0.041556 * z), 0, 255),
        b: $c06ed32dd488160c$var$clamp(convertComponent(0.0556434 * x - 0.2040259 * y + 1.0572252 * z), 0, 255)
    };
};
var $c06ed32dd488160c$var$rgbToLch = function rgbToLch(rgb) {
    return $c06ed32dd488160c$var$labToLch($c06ed32dd488160c$var$xyzToLab($c06ed32dd488160c$var$rgbToXyz(rgb)));
};
var $c06ed32dd488160c$var$lchToRgb = function lchToRgb(lch) {
    return $c06ed32dd488160c$var$xyzToRgb($c06ed32dd488160c$var$labToXyz($c06ed32dd488160c$var$lchToLab(lch)));
};
var $c06ed32dd488160c$export$313b8a8fcb34c3b8 = function clampLightness(color, newPercent) {
    var rgb = $c06ed32dd488160c$var$rgbFromHex(color);
    if (rgb === null) return color;
    // LCH (rather than HSL) gives the best results here as the L component in LCH is based on human color perception
    var lch = $c06ed32dd488160c$var$rgbToLch(rgb);
    lch.l = $c06ed32dd488160c$var$clamp(newPercent, 0, 100);
    return $c06ed32dd488160c$var$rgbToHex($c06ed32dd488160c$var$lchToRgb(lch));
};
var $c06ed32dd488160c$var$getLightness = function getLightness(color) {
    var rgb = $c06ed32dd488160c$var$rgbFromHex(color);
    if (rgb === null) return 0;
    var lch = $c06ed32dd488160c$var$rgbToLch(rgb);
    return lch.l;
};
var $c06ed32dd488160c$export$a5065c3b8aacaf99 = function getDarkModeLCHColor(currentBackgroundColor) {
    var lightness = $c06ed32dd488160c$var$getLightness(currentBackgroundColor);
    var newLightness = Math.abs(100 - lightness);
    return $c06ed32dd488160c$export$313b8a8fcb34c3b8(currentBackgroundColor, newLightness).toUpperCase();
};

});


parcelRegister("jImCY", function(module, exports) {
$parcel$export(module.exports, "createSchema", () => $e5a3adc42ae6643f$export$5f4ce795563f4211);

var $6hSvq = parcelRequire("6hSvq");

var $6p3ce = parcelRequire("6p3ce");

var $dIXl1 = parcelRequire("dIXl1");

var $5fbqs = parcelRequire("5fbqs");
var $kX1mK = parcelRequire("kX1mK");
var $d3ddB = parcelRequire("d3ddB");
var $5BptP = parcelRequire("5BptP");
var $66hh0 = parcelRequire("66hh0");
var $iVDN9 = parcelRequire("iVDN9");
var $31cn2 = parcelRequire("31cn2");
var $2InDy = parcelRequire("2InDy");
var $kVedW = parcelRequire("kVedW");
var $iDfRT = parcelRequire("iDfRT");
var $13aOI = parcelRequire("13aOI");
var $5BE4e = parcelRequire("5BE4e");
var $lnr9T = parcelRequire("lnr9T");
var $1u7ml = parcelRequire("1u7ml");
var $1Ge5k = parcelRequire("1Ge5k");
var $dvZpe = parcelRequire("dvZpe");
var $9htZc = parcelRequire("9htZc");
var $1UbTw = parcelRequire("1UbTw");
var $8Krw2 = parcelRequire("8Krw2");
var $9fdRd = parcelRequire("9fdRd");

var $TWIcC = parcelRequire("TWIcC");
var $1aipV = parcelRequire("1aipV");
var $7wC9F = parcelRequire("7wC9F");
var $aUdhc = parcelRequire("aUdhc");
var $gBea6 = parcelRequire("gBea6");
var $gBtp4 = parcelRequire("gBtp4");
var $enrSO = parcelRequire("enrSO");
var $ds6FG = parcelRequire("ds6FG");
var $28jyL = parcelRequire("28jyL");
var $h4Vhg = parcelRequire("h4Vhg");
var $gTQzU = parcelRequire("gTQzU");
var $Mas9e = parcelRequire("Mas9e");
var $6e7am = parcelRequire("6e7am");
var $cO5dd = parcelRequire("cO5dd");
var $ixGXu = parcelRequire("ixGXu");
var $r9xZG = parcelRequire("r9xZG");
var $4eHHu = parcelRequire("4eHHu");
var $kUp6y = parcelRequire("kUp6y");
var $18mVh = parcelRequire("18mVh");
var $cnShX = parcelRequire("cnShX");
var $5vwuc = parcelRequire("5vwuc");
var $blZvD = parcelRequire("blZvD");
var $lta2M = parcelRequire("lta2M");
var $7S1Am = parcelRequire("7S1Am");
var $7YGzk = parcelRequire("7YGzk");
var $kuUB8 = parcelRequire("kuUB8");
var $iXSQk = parcelRequire("iXSQk");
var $d79nc = parcelRequire("d79nc");
var $2Ji8g = parcelRequire("2Ji8g");
var $6wWv8 = parcelRequire("6wWv8");
var $21g1t = parcelRequire("21g1t");
var $jzlkh = parcelRequire("jzlkh");
var $8JhSw = parcelRequire("8JhSw");
var $kZNkK = parcelRequire("kZNkK");
var $jOBJC = parcelRequire("jOBJC");
var $5MY3X = parcelRequire("5MY3X");
var $91Dmj = parcelRequire("91Dmj");
var $gAmJ3 = parcelRequire("gAmJ3");
var $e29IV = parcelRequire("e29IV");
var $9IIBj = parcelRequire("9IIBj");
var $hG501 = parcelRequire("hG501");
var $gc8Zd = parcelRequire("gc8Zd");
var $4VFl9 = parcelRequire("4VFl9");
var $lPSeS = parcelRequire("lPSeS");
var $zEe3b = parcelRequire("zEe3b");
var $hAyYk = parcelRequire("hAyYk");
var $40acJ = parcelRequire("40acJ");
function $e5a3adc42ae6643f$var$addItems(builtInItems, config) {
    var customSpecs = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    if (!config) return {};
    /**
   * Add built-in Node / Mark specs
   */ var items = builtInItems.reduce(function(items, _ref) {
        var name = _ref.name, spec = _ref.spec;
        if (config.indexOf(name) !== -1) items[name] = customSpecs[name] || spec;
        return items;
    }, {});
    /**
   * Add Custom Node / Mark specs
   */ return Object.keys(customSpecs).reduce(function(items, name) {
        if (items[name]) return items;
        items[name] = customSpecs[name];
        return items;
    }, items);
}
// We use groups to allow schemas to be constructed in different shapes without changing node/mark
// specs, but this means nodes/marks are defined with groups that might never be used in the schema.
// In this scenario ProseMirror will complain and prevent the schema from being constructed.
//
// To avoid the problem, we include items that serve to "declare" the groups in the schema. This
// approach unfortunately leaves unused items in the schema, but has the benefit of avoiding the
// need to manipulate `exclude` or content expression values for potentially every schema item.
function $e5a3adc42ae6643f$var$groupDeclaration(name) {
    return {
        name: "__".concat(name, "GroupDeclaration"),
        spec: {
            group: name
        }
    };
}
var $e5a3adc42ae6643f$var$markGroupDeclarations = [
    $e5a3adc42ae6643f$var$groupDeclaration((0, $6p3ce.COLOR)),
    $e5a3adc42ae6643f$var$groupDeclaration((0, $6p3ce.FONT_STYLE)),
    $e5a3adc42ae6643f$var$groupDeclaration((0, $6p3ce.SEARCH_QUERY)),
    $e5a3adc42ae6643f$var$groupDeclaration((0, $6p3ce.LINK))
];
var $e5a3adc42ae6643f$var$markGroupDeclarationsNames = $e5a3adc42ae6643f$var$markGroupDeclarations.map(function(groupMark) {
    return groupMark.name;
});
var $e5a3adc42ae6643f$var$nodesInOrder = [
    {
        name: 'doc',
        spec: (0, $cO5dd.doc)
    },
    {
        name: 'paragraph',
        spec: (0, $91Dmj.paragraph)
    },
    {
        name: 'text',
        spec: (0, $lPSeS.text)
    },
    {
        name: 'bulletList',
        spec: (0, $gBea6.bulletList)
    },
    {
        name: 'orderedList',
        spec: (0, $5MY3X.orderedListWithOrder)
    },
    {
        name: 'listItem',
        spec: (0, $2Ji8g.listItem)
    },
    {
        name: 'heading',
        spec: (0, $lta2M.heading)
    },
    {
        name: 'blockquote',
        spec: (0, $kUp6y.extendedBlockquote)
    },
    {
        name: 'codeBlock',
        spec: (0, $enrSO.codeBlock)
    },
    {
        name: 'panel',
        spec: (0, $18mVh.extendedPanel)(true)
    },
    {
        name: 'rule',
        spec: (0, $e29IV.rule)
    },
    {
        name: 'image',
        spec: (0, $7S1Am.image)
    },
    {
        name: 'mention',
        spec: (0, $kZNkK.mention)
    },
    {
        name: 'caption',
        spec: (0, $gBtp4.caption)
    },
    {
        name: 'media',
        spec: (0, $6wWv8.media)
    },
    {
        name: 'mediaGroup',
        spec: (0, $21g1t.mediaGroup)
    },
    {
        name: 'mediaSingle',
        spec: (0, $8JhSw.mediaSingleFull)
    },
    {
        name: 'mediaInline',
        spec: (0, $jzlkh.mediaInline)
    },
    {
        name: 'placeholder',
        spec: (0, $gAmJ3.placeholder)
    },
    {
        name: 'layoutSection',
        spec: (0, $d79nc.layoutSection)
    },
    {
        name: 'layoutColumn',
        spec: (0, $iXSQk.layoutColumn)
    },
    {
        name: 'hardBreak',
        spec: (0, $blZvD.hardBreak)
    },
    {
        name: 'emoji',
        spec: (0, $r9xZG.emoji)
    },
    {
        name: 'table',
        spec: (0, $gc8Zd.table)
    },
    {
        name: 'tableCell',
        spec: (0, $gc8Zd.tableCell)
    },
    {
        name: 'tableRow',
        spec: (0, $gc8Zd.tableRow)
    },
    {
        name: 'tableHeader',
        spec: (0, $gc8Zd.tableHeader)
    },
    {
        name: 'confluenceJiraIssue',
        spec: (0, $ds6FG.confluenceJiraIssue)
    },
    {
        name: 'confluenceUnsupportedInline',
        spec: (0, $h4Vhg.confluenceUnsupportedInline)
    },
    {
        name: 'confluenceUnsupportedBlock',
        spec: (0, $28jyL.confluenceUnsupportedBlock)
    },
    {
        name: 'decisionList',
        spec: (0, $6e7am.decisionList)
    },
    {
        name: 'decisionItem',
        spec: (0, $Mas9e.decisionItem)
    },
    {
        name: 'taskList',
        spec: (0, $4VFl9.taskList)
    },
    {
        name: 'taskItem',
        spec: (0, $1aipV.taskItem)
    },
    {
        name: 'blockTaskItem',
        spec: (0, $1aipV.blockTaskItem)
    },
    {
        name: 'date',
        spec: (0, $gTQzU.date)
    },
    {
        name: 'status',
        spec: (0, $9IIBj.status)
    },
    {
        name: 'expand',
        spec: (0, $4eHHu.expandWithNestedExpand)
    },
    {
        name: 'nestedExpand',
        spec: (0, $jOBJC.nestedExpand)
    },
    {
        name: 'extension',
        spec: (0, $cnShX.extension)
    },
    {
        name: 'inlineExtension',
        spec: (0, $kuUB8.inlineExtension)
    },
    {
        name: 'bodiedExtension',
        spec: (0, $7wC9F.bodiedExtension)
    },
    {
        name: 'multiBodiedExtension',
        spec: (0, $5vwuc.multiBodiedExtension)
    },
    {
        name: 'extensionFrame',
        spec: (0, $5vwuc.extensionFrame)
    },
    {
        name: 'inlineCard',
        spec: (0, $7YGzk.inlineCard)
    },
    {
        name: 'blockCard',
        spec: (0, $TWIcC.blockCard)
    },
    {
        name: 'embedCard',
        spec: (0, $ixGXu.embedCard)
    },
    {
        name: 'syncBlock',
        spec: (0, $hG501.syncBlock)
    },
    {
        name: 'bodiedSyncBlock',
        spec: (0, $aUdhc.bodiedSyncBlock)
    },
    {
        name: 'unknownBlock',
        spec: (0, $zEe3b.default)
    },
    {
        name: 'unsupportedBlock',
        spec: (0, $hAyYk.unsupportedBlock)
    },
    {
        name: 'unsupportedInline',
        spec: (0, $40acJ.unsupportedInline)
    }
];
var $e5a3adc42ae6643f$var$marksInOrder = [
    {
        name: 'link',
        spec: (0, $5BE4e.link)
    },
    {
        name: 'em',
        spec: (0, $kVedW.em)
    },
    {
        name: 'strong',
        spec: (0, $1u7ml.strong)
    },
    {
        name: 'textColor',
        spec: (0, $dvZpe.textColor)
    },
    {
        name: 'backgroundColor',
        spec: (0, $d3ddB.backgroundColor)
    },
    {
        name: 'strike',
        spec: (0, $lnr9T.strike)
    },
    {
        name: 'subsup',
        spec: (0, $1Ge5k.subsup)
    },
    {
        name: 'underline',
        spec: (0, $1UbTw.underline)
    },
    {
        name: 'code',
        spec: (0, $iVDN9.code)
    },
    {
        name: 'typeAheadQuery',
        spec: (0, $9htZc.typeAheadQuery)
    },
    {
        name: 'alignment',
        spec: (0, $5fbqs.alignment)
    },
    {
        name: 'annotation',
        spec: (0, $kX1mK.annotation)
    },
    {
        name: 'confluenceInlineComment',
        spec: (0, $31cn2.confluenceInlineComment)
    }
].concat($e5a3adc42ae6643f$var$markGroupDeclarations, [
    {
        name: 'breakout',
        spec: (0, $66hh0.breakout)
    },
    {
        name: 'dataConsumer',
        spec: (0, $2InDy.dataConsumer)
    },
    {
        name: 'fragment',
        spec: (0, $iDfRT.fragment)
    },
    {
        name: 'indentation',
        spec: (0, $13aOI.indentation)
    },
    {
        name: 'border',
        spec: (0, $5BptP.border)
    },
    {
        name: 'unsupportedMark',
        spec: (0, $8Krw2.unsupportedMark)
    },
    {
        name: 'unsupportedNodeAttribute',
        spec: (0, $9fdRd.unsupportedNodeAttribute)
    }
]);
function $e5a3adc42ae6643f$export$2d0c32a809131488() {
    var nodes = $e5a3adc42ae6643f$var$nodesInOrder.reduce(function(acc, _ref2) {
        var name = _ref2.name, spec = _ref2.spec;
        // @ts-expect-error - Type for SchemaBuiltInItem is not correct
        acc[name] = spec;
        return acc;
    }, {});
    var marks = $e5a3adc42ae6643f$var$marksInOrder.reduce(function(acc, _ref3) {
        var name = _ref3.name, spec = _ref3.spec;
        // @ts-expect-error - Type for SchemaBuiltInItem is not correct
        acc[name] = spec;
        return acc;
    }, {});
    return {
        nodes: nodes,
        marks: marks
    };
}
function $e5a3adc42ae6643f$export$5f4ce795563f4211(config) {
    var customNodeSpecs = config.customNodeSpecs, customMarkSpecs = config.customMarkSpecs;
    var nodesConfig = Object.keys(customNodeSpecs || {}).concat(config.nodes);
    var marksConfig = Object.keys(customMarkSpecs || {}).concat(config.marks || []).concat($e5a3adc42ae6643f$var$markGroupDeclarationsNames);
    var nodes = $e5a3adc42ae6643f$var$addItems($e5a3adc42ae6643f$var$nodesInOrder, nodesConfig, customNodeSpecs);
    var marks = $e5a3adc42ae6643f$var$addItems($e5a3adc42ae6643f$var$marksInOrder, marksConfig, customMarkSpecs);
    nodes = (0, $dIXl1.sanitizeNodes)(nodes, marks);
    return new (0, $6hSvq.Schema)({
        nodes: nodes,
        marks: marks
    });
}
var $e5a3adc42ae6643f$export$c77b6d30da5276a1 = true;

});
parcelRegister("6hSvq", function(module, exports) {
$parcel$export(module.exports, "Fragment", () => $493e9c5a7c75200a$export$ffb0004e005737fa);
$parcel$export(module.exports, "Schema", () => $493e9c5a7c75200a$export$19342e026b58ebb7);

var $at9VT = parcelRequire("at9VT");
function $493e9c5a7c75200a$var$findDiffStart(a, b, pos) {
    for(let i = 0;; i++){
        if (i == a.childCount || i == b.childCount) return a.childCount == b.childCount ? null : pos;
        let childA = a.child(i), childB = b.child(i);
        if (childA == childB) {
            pos += childA.nodeSize;
            continue;
        }
        if (!childA.sameMarkup(childB)) return pos;
        if (childA.isText && childA.text != childB.text) {
            for(let j = 0; childA.text[j] == childB.text[j]; j++)pos++;
            return pos;
        }
        if (childA.content.size || childB.content.size) {
            let inner = $493e9c5a7c75200a$var$findDiffStart(childA.content, childB.content, pos + 1);
            if (inner != null) return inner;
        }
        pos += childA.nodeSize;
    }
}
function $493e9c5a7c75200a$var$findDiffEnd(a, b, posA, posB) {
    for(let iA = a.childCount, iB = b.childCount;;){
        if (iA == 0 || iB == 0) return iA == iB ? null : {
            a: posA,
            b: posB
        };
        let childA = a.child(--iA), childB = b.child(--iB), size = childA.nodeSize;
        if (childA == childB) {
            posA -= size;
            posB -= size;
            continue;
        }
        if (!childA.sameMarkup(childB)) return {
            a: posA,
            b: posB
        };
        if (childA.isText && childA.text != childB.text) {
            let same = 0, minSize = Math.min(childA.text.length, childB.text.length);
            while(same < minSize && childA.text[childA.text.length - same - 1] == childB.text[childB.text.length - same - 1]){
                same++;
                posA--;
                posB--;
            }
            return {
                a: posA,
                b: posB
            };
        }
        if (childA.content.size || childB.content.size) {
            let inner = $493e9c5a7c75200a$var$findDiffEnd(childA.content, childB.content, posA - 1, posB - 1);
            if (inner) return inner;
        }
        posA -= size;
        posB -= size;
    }
}
/**
A fragment represents a node's collection of child nodes.

Like nodes, fragments are persistent data structures, and you
should not mutate them or their content. Rather, you create new
instances whenever needed. The API tries to make this easy.
*/ class $493e9c5a7c75200a$export$ffb0004e005737fa {
    /**
    @internal
    */ constructor(/**
    The child nodes in this fragment.
    */ content, size){
        this.content = content;
        this.size = size || 0;
        if (size == null) for(let i = 0; i < content.length; i++)this.size += content[i].nodeSize;
    }
    /**
    Invoke a callback for all descendant nodes between the given two
    positions (relative to start of this fragment). Doesn't descend
    into a node when the callback returns `false`.
    */ nodesBetween(from, to, f, nodeStart = 0, parent) {
        for(let i = 0, pos = 0; pos < to; i++){
            let child = this.content[i], end = pos + child.nodeSize;
            if (end > from && f(child, nodeStart + pos, parent || null, i) !== false && child.content.size) {
                let start = pos + 1;
                child.nodesBetween(Math.max(0, from - start), Math.min(child.content.size, to - start), f, nodeStart + start);
            }
            pos = end;
        }
    }
    /**
    Call the given callback for every descendant node. `pos` will be
    relative to the start of the fragment. The callback may return
    `false` to prevent traversal of a given node's children.
    */ descendants(f) {
        this.nodesBetween(0, this.size, f);
    }
    /**
    Extract the text between `from` and `to`. See the same method on
    [`Node`](https://prosemirror.net/docs/ref/#model.Node.textBetween).
    */ textBetween(from, to, blockSeparator, leafText) {
        let text = "", first = true;
        this.nodesBetween(from, to, (node, pos)=>{
            let nodeText = node.isText ? node.text.slice(Math.max(from, pos) - pos, to - pos) : !node.isLeaf ? "" : leafText ? typeof leafText === "function" ? leafText(node) : leafText : node.type.spec.leafText ? node.type.spec.leafText(node) : "";
            if (node.isBlock && (node.isLeaf && nodeText || node.isTextblock) && blockSeparator) {
                if (first) first = false;
                else text += blockSeparator;
            }
            text += nodeText;
        }, 0);
        return text;
    }
    /**
    Create a new fragment containing the combined content of this
    fragment and the other.
    */ append(other) {
        if (!other.size) return this;
        if (!this.size) return other;
        let last = this.lastChild, first = other.firstChild, content = this.content.slice(), i = 0;
        if (last.isText && last.sameMarkup(first)) {
            content[content.length - 1] = last.withText(last.text + first.text);
            i = 1;
        }
        for(; i < other.content.length; i++)content.push(other.content[i]);
        return new $493e9c5a7c75200a$export$ffb0004e005737fa(content, this.size + other.size);
    }
    /**
    Cut out the sub-fragment between the two given positions.
    */ cut(from, to = this.size) {
        if (from == 0 && to == this.size) return this;
        let result = [], size = 0;
        if (to > from) for(let i = 0, pos = 0; pos < to; i++){
            let child = this.content[i], end = pos + child.nodeSize;
            if (end > from) {
                if (pos < from || end > to) {
                    if (child.isText) child = child.cut(Math.max(0, from - pos), Math.min(child.text.length, to - pos));
                    else child = child.cut(Math.max(0, from - pos - 1), Math.min(child.content.size, to - pos - 1));
                }
                result.push(child);
                size += child.nodeSize;
            }
            pos = end;
        }
        return new $493e9c5a7c75200a$export$ffb0004e005737fa(result, size);
    }
    /**
    @internal
    */ cutByIndex(from, to) {
        if (from == to) return $493e9c5a7c75200a$export$ffb0004e005737fa.empty;
        if (from == 0 && to == this.content.length) return this;
        return new $493e9c5a7c75200a$export$ffb0004e005737fa(this.content.slice(from, to));
    }
    /**
    Create a new fragment in which the node at the given index is
    replaced by the given node.
    */ replaceChild(index, node) {
        let current = this.content[index];
        if (current == node) return this;
        let copy = this.content.slice();
        let size = this.size + node.nodeSize - current.nodeSize;
        copy[index] = node;
        return new $493e9c5a7c75200a$export$ffb0004e005737fa(copy, size);
    }
    /**
    Create a new fragment by prepending the given node to this
    fragment.
    */ addToStart(node) {
        return new $493e9c5a7c75200a$export$ffb0004e005737fa([
            node
        ].concat(this.content), this.size + node.nodeSize);
    }
    /**
    Create a new fragment by appending the given node to this
    fragment.
    */ addToEnd(node) {
        return new $493e9c5a7c75200a$export$ffb0004e005737fa(this.content.concat(node), this.size + node.nodeSize);
    }
    /**
    Compare this fragment to another one.
    */ eq(other) {
        if (this.content.length != other.content.length) return false;
        for(let i = 0; i < this.content.length; i++)if (!this.content[i].eq(other.content[i])) return false;
        return true;
    }
    /**
    The first child of the fragment, or `null` if it is empty.
    */ get firstChild() {
        return this.content.length ? this.content[0] : null;
    }
    /**
    The last child of the fragment, or `null` if it is empty.
    */ get lastChild() {
        return this.content.length ? this.content[this.content.length - 1] : null;
    }
    /**
    The number of child nodes in this fragment.
    */ get childCount() {
        return this.content.length;
    }
    /**
    Get the child node at the given index. Raise an error when the
    index is out of range.
    */ child(index) {
        let found = this.content[index];
        if (!found) throw new RangeError("Index " + index + " out of range for " + this);
        return found;
    }
    /**
    Get the child node at the given index, if it exists.
    */ maybeChild(index) {
        return this.content[index] || null;
    }
    /**
    Call `f` for every child node, passing the node, its offset
    into this parent node, and its index.
    */ forEach(f) {
        for(let i = 0, p = 0; i < this.content.length; i++){
            let child = this.content[i];
            f(child, p, i);
            p += child.nodeSize;
        }
    }
    /**
    Find the first position at which this fragment and another
    fragment differ, or `null` if they are the same.
    */ findDiffStart(other, pos = 0) {
        return $493e9c5a7c75200a$var$findDiffStart(this, other, pos);
    }
    /**
    Find the first position, searching from the end, at which this
    fragment and the given fragment differ, or `null` if they are
    the same. Since this position will not be the same in both
    nodes, an object with two separate positions is returned.
    */ findDiffEnd(other, pos = this.size, otherPos = other.size) {
        return $493e9c5a7c75200a$var$findDiffEnd(this, other, pos, otherPos);
    }
    /**
    Find the index and inner offset corresponding to a given relative
    position in this fragment. The result object will be reused
    (overwritten) the next time the function is called. @internal
    */ findIndex(pos, round = -1) {
        if (pos == 0) return $493e9c5a7c75200a$var$retIndex(0, pos);
        if (pos == this.size) return $493e9c5a7c75200a$var$retIndex(this.content.length, pos);
        if (pos > this.size || pos < 0) throw new RangeError(`Position ${pos} outside of fragment (${this})`);
        for(let i = 0, curPos = 0;; i++){
            let cur = this.child(i), end = curPos + cur.nodeSize;
            if (end >= pos) {
                if (end == pos || round > 0) return $493e9c5a7c75200a$var$retIndex(i + 1, end);
                return $493e9c5a7c75200a$var$retIndex(i, curPos);
            }
            curPos = end;
        }
    }
    /**
    Return a debugging string that describes this fragment.
    */ toString() {
        return "<" + this.toStringInner() + ">";
    }
    /**
    @internal
    */ toStringInner() {
        return this.content.join(", ");
    }
    /**
    Create a JSON-serializeable representation of this fragment.
    */ toJSON() {
        return this.content.length ? this.content.map((n)=>n.toJSON()) : null;
    }
    /**
    Deserialize a fragment from its JSON representation.
    */ static fromJSON(schema, value) {
        if (!value) return $493e9c5a7c75200a$export$ffb0004e005737fa.empty;
        if (!Array.isArray(value)) throw new RangeError("Invalid input for Fragment.fromJSON");
        return new $493e9c5a7c75200a$export$ffb0004e005737fa(value.map(schema.nodeFromJSON));
    }
    /**
    Build a fragment from an array of nodes. Ensures that adjacent
    text nodes with the same marks are joined together.
    */ static fromArray(array) {
        if (!array.length) return $493e9c5a7c75200a$export$ffb0004e005737fa.empty;
        let joined, size = 0;
        for(let i = 0; i < array.length; i++){
            let node = array[i];
            size += node.nodeSize;
            if (i && node.isText && array[i - 1].sameMarkup(node)) {
                if (!joined) joined = array.slice(0, i);
                joined[joined.length - 1] = node.withText(joined[joined.length - 1].text + node.text);
            } else if (joined) joined.push(node);
        }
        return new $493e9c5a7c75200a$export$ffb0004e005737fa(joined || array, size);
    }
    /**
    Create a fragment from something that can be interpreted as a
    set of nodes. For `null`, it returns the empty fragment. For a
    fragment, the fragment itself. For a node or array of nodes, a
    fragment containing those nodes.
    */ static from(nodes) {
        if (!nodes) return $493e9c5a7c75200a$export$ffb0004e005737fa.empty;
        if (nodes instanceof $493e9c5a7c75200a$export$ffb0004e005737fa) return nodes;
        if (Array.isArray(nodes)) return this.fromArray(nodes);
        if (nodes.attrs) return new $493e9c5a7c75200a$export$ffb0004e005737fa([
            nodes
        ], nodes.nodeSize);
        throw new RangeError("Can not convert " + nodes + " to a Fragment" + (nodes.nodesBetween ? " (looks like multiple versions of prosemirror-model were loaded)" : ""));
    }
}
/**
An empty fragment. Intended to be reused whenever a node doesn't
contain anything (rather than allocating a new empty fragment for
each leaf node).
*/ $493e9c5a7c75200a$export$ffb0004e005737fa.empty = new $493e9c5a7c75200a$export$ffb0004e005737fa([], 0);
const $493e9c5a7c75200a$var$found = {
    index: 0,
    offset: 0
};
function $493e9c5a7c75200a$var$retIndex(index, offset) {
    $493e9c5a7c75200a$var$found.index = index;
    $493e9c5a7c75200a$var$found.offset = offset;
    return $493e9c5a7c75200a$var$found;
}
function $493e9c5a7c75200a$var$compareDeep(a, b) {
    if (a === b) return true;
    if (!(a && typeof a == "object") || !(b && typeof b == "object")) return false;
    let array = Array.isArray(a);
    if (Array.isArray(b) != array) return false;
    if (array) {
        if (a.length != b.length) return false;
        for(let i = 0; i < a.length; i++)if (!$493e9c5a7c75200a$var$compareDeep(a[i], b[i])) return false;
    } else {
        for(let p in a)if (!(p in b) || !$493e9c5a7c75200a$var$compareDeep(a[p], b[p])) return false;
        for(let p in b)if (!(p in a)) return false;
    }
    return true;
}
/**
A mark is a piece of information that can be attached to a node,
such as it being emphasized, in code font, or a link. It has a
type and optionally a set of attributes that provide further
information (such as the target of the link). Marks are created
through a `Schema`, which controls which types exist and which
attributes they have.
*/ class $493e9c5a7c75200a$export$c9d15bcfc6d42044 {
    /**
    @internal
    */ constructor(/**
    The type of this mark.
    */ type, /**
    The attributes associated with this mark.
    */ attrs){
        this.type = type;
        this.attrs = attrs;
    }
    /**
    Given a set of marks, create a new set which contains this one as
    well, in the right position. If this mark is already in the set,
    the set itself is returned. If any marks that are set to be
    [exclusive](https://prosemirror.net/docs/ref/#model.MarkSpec.excludes) with this mark are present,
    those are replaced by this one.
    */ addToSet(set) {
        let copy, placed = false;
        for(let i = 0; i < set.length; i++){
            let other = set[i];
            if (this.eq(other)) return set;
            if (this.type.excludes(other.type)) {
                if (!copy) copy = set.slice(0, i);
            } else if (other.type.excludes(this.type)) return set;
            else {
                if (!placed && other.type.rank > this.type.rank) {
                    if (!copy) copy = set.slice(0, i);
                    copy.push(this);
                    placed = true;
                }
                if (copy) copy.push(other);
            }
        }
        if (!copy) copy = set.slice();
        if (!placed) copy.push(this);
        return copy;
    }
    /**
    Remove this mark from the given set, returning a new set. If this
    mark is not in the set, the set itself is returned.
    */ removeFromSet(set) {
        for(let i = 0; i < set.length; i++)if (this.eq(set[i])) return set.slice(0, i).concat(set.slice(i + 1));
        return set;
    }
    /**
    Test whether this mark is in the given set of marks.
    */ isInSet(set) {
        for(let i = 0; i < set.length; i++)if (this.eq(set[i])) return true;
        return false;
    }
    /**
    Test whether this mark has the same type and attributes as
    another mark.
    */ eq(other) {
        return this == other || this.type == other.type && $493e9c5a7c75200a$var$compareDeep(this.attrs, other.attrs);
    }
    /**
    Convert this mark to a JSON-serializeable representation.
    */ toJSON() {
        let obj = {
            type: this.type.name
        };
        for(let _ in this.attrs){
            obj.attrs = this.attrs;
            break;
        }
        return obj;
    }
    /**
    Deserialize a mark from JSON.
    */ static fromJSON(schema, json) {
        if (!json) throw new RangeError("Invalid input for Mark.fromJSON");
        let type = schema.marks[json.type];
        if (!type) throw new RangeError(`There is no mark type ${json.type} in this schema`);
        let mark = type.create(json.attrs);
        type.checkAttrs(mark.attrs);
        return mark;
    }
    /**
    Test whether two sets of marks are identical.
    */ static sameSet(a, b) {
        if (a == b) return true;
        if (a.length != b.length) return false;
        for(let i = 0; i < a.length; i++)if (!a[i].eq(b[i])) return false;
        return true;
    }
    /**
    Create a properly sorted mark set from null, a single mark, or an
    unsorted array of marks.
    */ static setFrom(marks) {
        if (!marks || Array.isArray(marks) && marks.length == 0) return $493e9c5a7c75200a$export$c9d15bcfc6d42044.none;
        if (marks instanceof $493e9c5a7c75200a$export$c9d15bcfc6d42044) return [
            marks
        ];
        let copy = marks.slice();
        copy.sort((a, b)=>a.type.rank - b.type.rank);
        return copy;
    }
}
/**
The empty set of marks.
*/ $493e9c5a7c75200a$export$c9d15bcfc6d42044.none = [];
/**
Error type raised by [`Node.replace`](https://prosemirror.net/docs/ref/#model.Node.replace) when
given an invalid replacement.
*/ class $493e9c5a7c75200a$export$6de0e778727af3f2 extends Error {
}
/*
ReplaceError = function(this: any, message: string) {
  let err = Error.call(this, message)
  ;(err as any).__proto__ = ReplaceError.prototype
  return err
} as any

ReplaceError.prototype = Object.create(Error.prototype)
ReplaceError.prototype.constructor = ReplaceError
ReplaceError.prototype.name = "ReplaceError"
*/ /**
A slice represents a piece cut out of a larger document. It
stores not only a fragment, but also the depth up to which nodes on
both side are ‘open’ (cut through).
*/ class $493e9c5a7c75200a$export$b3f2e2de3a8baa1e {
    /**
    Create a slice. When specifying a non-zero open depth, you must
    make sure that there are nodes of at least that depth at the
    appropriate side of the fragment—i.e. if the fragment is an
    empty paragraph node, `openStart` and `openEnd` can't be greater
    than 1.
    
    It is not necessary for the content of open nodes to conform to
    the schema's content constraints, though it should be a valid
    start/end/middle for such a node, depending on which sides are
    open.
    */ constructor(/**
    The slice's content.
    */ content, /**
    The open depth at the start of the fragment.
    */ openStart, /**
    The open depth at the end.
    */ openEnd){
        this.content = content;
        this.openStart = openStart;
        this.openEnd = openEnd;
    }
    /**
    The size this slice would add when inserted into a document.
    */ get size() {
        return this.content.size - this.openStart - this.openEnd;
    }
    /**
    @internal
    */ insertAt(pos, fragment) {
        let content = $493e9c5a7c75200a$var$insertInto(this.content, pos + this.openStart, fragment);
        return content && new $493e9c5a7c75200a$export$b3f2e2de3a8baa1e(content, this.openStart, this.openEnd);
    }
    /**
    @internal
    */ removeBetween(from, to) {
        return new $493e9c5a7c75200a$export$b3f2e2de3a8baa1e($493e9c5a7c75200a$var$removeRange(this.content, from + this.openStart, to + this.openStart), this.openStart, this.openEnd);
    }
    /**
    Tests whether this slice is equal to another slice.
    */ eq(other) {
        return this.content.eq(other.content) && this.openStart == other.openStart && this.openEnd == other.openEnd;
    }
    /**
    @internal
    */ toString() {
        return this.content + "(" + this.openStart + "," + this.openEnd + ")";
    }
    /**
    Convert a slice to a JSON-serializable representation.
    */ toJSON() {
        if (!this.content.size) return null;
        let json = {
            content: this.content.toJSON()
        };
        if (this.openStart > 0) json.openStart = this.openStart;
        if (this.openEnd > 0) json.openEnd = this.openEnd;
        return json;
    }
    /**
    Deserialize a slice from its JSON representation.
    */ static fromJSON(schema, json) {
        if (!json) return $493e9c5a7c75200a$export$b3f2e2de3a8baa1e.empty;
        let openStart = json.openStart || 0, openEnd = json.openEnd || 0;
        if (typeof openStart != "number" || typeof openEnd != "number") throw new RangeError("Invalid input for Slice.fromJSON");
        return new $493e9c5a7c75200a$export$b3f2e2de3a8baa1e($493e9c5a7c75200a$export$ffb0004e005737fa.fromJSON(schema, json.content), openStart, openEnd);
    }
    /**
    Create a slice from a fragment by taking the maximum possible
    open value on both side of the fragment.
    */ static maxOpen(fragment, openIsolating = true) {
        let openStart = 0, openEnd = 0;
        for(let n = fragment.firstChild; n && !n.isLeaf && (openIsolating || !n.type.spec.isolating); n = n.firstChild)openStart++;
        for(let n = fragment.lastChild; n && !n.isLeaf && (openIsolating || !n.type.spec.isolating); n = n.lastChild)openEnd++;
        return new $493e9c5a7c75200a$export$b3f2e2de3a8baa1e(fragment, openStart, openEnd);
    }
}
/**
The empty slice.
*/ $493e9c5a7c75200a$export$b3f2e2de3a8baa1e.empty = new $493e9c5a7c75200a$export$b3f2e2de3a8baa1e($493e9c5a7c75200a$export$ffb0004e005737fa.empty, 0, 0);
function $493e9c5a7c75200a$var$removeRange(content, from, to) {
    let { index: index, offset: offset } = content.findIndex(from), child = content.maybeChild(index);
    let { index: indexTo, offset: offsetTo } = content.findIndex(to);
    if (offset == from || child.isText) {
        if (offsetTo != to && !content.child(indexTo).isText) throw new RangeError("Removing non-flat range");
        return content.cut(0, from).append(content.cut(to));
    }
    if (index != indexTo) throw new RangeError("Removing non-flat range");
    return content.replaceChild(index, child.copy($493e9c5a7c75200a$var$removeRange(child.content, from - offset - 1, to - offset - 1)));
}
function $493e9c5a7c75200a$var$insertInto(content, dist, insert, parent) {
    let { index: index, offset: offset } = content.findIndex(dist), child = content.maybeChild(index);
    if (offset == dist || child.isText) {
        if (parent && !parent.canReplace(index, index, insert)) return null;
        return content.cut(0, dist).append(insert).append(content.cut(dist));
    }
    let inner = $493e9c5a7c75200a$var$insertInto(child.content, dist - offset - 1, insert);
    return inner && content.replaceChild(index, child.copy(inner));
}
function $493e9c5a7c75200a$var$replace($from, $to, slice) {
    if (slice.openStart > $from.depth) throw new $493e9c5a7c75200a$export$6de0e778727af3f2("Inserted content deeper than insertion position");
    if ($from.depth - slice.openStart != $to.depth - slice.openEnd) throw new $493e9c5a7c75200a$export$6de0e778727af3f2("Inconsistent open depths");
    return $493e9c5a7c75200a$var$replaceOuter($from, $to, slice, 0);
}
function $493e9c5a7c75200a$var$replaceOuter($from, $to, slice, depth) {
    let index = $from.index(depth), node = $from.node(depth);
    if (index == $to.index(depth) && depth < $from.depth - slice.openStart) {
        let inner = $493e9c5a7c75200a$var$replaceOuter($from, $to, slice, depth + 1);
        return node.copy(node.content.replaceChild(index, inner));
    } else if (!slice.content.size) return $493e9c5a7c75200a$var$close(node, $493e9c5a7c75200a$var$replaceTwoWay($from, $to, depth));
    else if (!slice.openStart && !slice.openEnd && $from.depth == depth && $to.depth == depth) {
        let parent = $from.parent, content = parent.content;
        return $493e9c5a7c75200a$var$close(parent, content.cut(0, $from.parentOffset).append(slice.content).append(content.cut($to.parentOffset)));
    } else {
        let { start: start, end: end } = $493e9c5a7c75200a$var$prepareSliceForReplace(slice, $from);
        return $493e9c5a7c75200a$var$close(node, $493e9c5a7c75200a$var$replaceThreeWay($from, start, end, $to, depth));
    }
}
function $493e9c5a7c75200a$var$checkJoin(main, sub) {
    if (!sub.type.compatibleContent(main.type)) throw new $493e9c5a7c75200a$export$6de0e778727af3f2("Cannot join " + sub.type.name + " onto " + main.type.name);
}
function $493e9c5a7c75200a$var$joinable($before, $after, depth) {
    let node = $before.node(depth);
    $493e9c5a7c75200a$var$checkJoin(node, $after.node(depth));
    return node;
}
function $493e9c5a7c75200a$var$addNode(child, target) {
    let last = target.length - 1;
    if (last >= 0 && child.isText && child.sameMarkup(target[last])) target[last] = child.withText(target[last].text + child.text);
    else target.push(child);
}
function $493e9c5a7c75200a$var$addRange($start, $end, depth, target) {
    let node = ($end || $start).node(depth);
    let startIndex = 0, endIndex = $end ? $end.index(depth) : node.childCount;
    if ($start) {
        startIndex = $start.index(depth);
        if ($start.depth > depth) startIndex++;
        else if ($start.textOffset) {
            $493e9c5a7c75200a$var$addNode($start.nodeAfter, target);
            startIndex++;
        }
    }
    for(let i = startIndex; i < endIndex; i++)$493e9c5a7c75200a$var$addNode(node.child(i), target);
    if ($end && $end.depth == depth && $end.textOffset) $493e9c5a7c75200a$var$addNode($end.nodeBefore, target);
}
function $493e9c5a7c75200a$var$close(node, content) {
    node.type.checkContent(content);
    return node.copy(content);
}
function $493e9c5a7c75200a$var$replaceThreeWay($from, $start, $end, $to, depth) {
    let openStart = $from.depth > depth && $493e9c5a7c75200a$var$joinable($from, $start, depth + 1);
    let openEnd = $to.depth > depth && $493e9c5a7c75200a$var$joinable($end, $to, depth + 1);
    let content = [];
    $493e9c5a7c75200a$var$addRange(null, $from, depth, content);
    if (openStart && openEnd && $start.index(depth) == $end.index(depth)) {
        $493e9c5a7c75200a$var$checkJoin(openStart, openEnd);
        $493e9c5a7c75200a$var$addNode($493e9c5a7c75200a$var$close(openStart, $493e9c5a7c75200a$var$replaceThreeWay($from, $start, $end, $to, depth + 1)), content);
    } else {
        if (openStart) $493e9c5a7c75200a$var$addNode($493e9c5a7c75200a$var$close(openStart, $493e9c5a7c75200a$var$replaceTwoWay($from, $start, depth + 1)), content);
        $493e9c5a7c75200a$var$addRange($start, $end, depth, content);
        if (openEnd) $493e9c5a7c75200a$var$addNode($493e9c5a7c75200a$var$close(openEnd, $493e9c5a7c75200a$var$replaceTwoWay($end, $to, depth + 1)), content);
    }
    $493e9c5a7c75200a$var$addRange($to, null, depth, content);
    return new $493e9c5a7c75200a$export$ffb0004e005737fa(content);
}
function $493e9c5a7c75200a$var$replaceTwoWay($from, $to, depth) {
    let content = [];
    $493e9c5a7c75200a$var$addRange(null, $from, depth, content);
    if ($from.depth > depth) {
        let type = $493e9c5a7c75200a$var$joinable($from, $to, depth + 1);
        $493e9c5a7c75200a$var$addNode($493e9c5a7c75200a$var$close(type, $493e9c5a7c75200a$var$replaceTwoWay($from, $to, depth + 1)), content);
    }
    $493e9c5a7c75200a$var$addRange($to, null, depth, content);
    return new $493e9c5a7c75200a$export$ffb0004e005737fa(content);
}
function $493e9c5a7c75200a$var$prepareSliceForReplace(slice, $along) {
    let extra = $along.depth - slice.openStart, parent = $along.node(extra);
    let node = parent.copy(slice.content);
    for(let i = extra - 1; i >= 0; i--)node = $along.node(i).copy($493e9c5a7c75200a$export$ffb0004e005737fa.from(node));
    return {
        start: node.resolveNoCache(slice.openStart + extra),
        end: node.resolveNoCache(node.content.size - slice.openEnd - extra)
    };
}
/**
You can [_resolve_](https://prosemirror.net/docs/ref/#model.Node.resolve) a position to get more
information about it. Objects of this class represent such a
resolved position, providing various pieces of context
information, and some helper methods.

Throughout this interface, methods that take an optional `depth`
parameter will interpret undefined as `this.depth` and negative
numbers as `this.depth + value`.
*/ class $493e9c5a7c75200a$export$b2a42f82e59e4b19 {
    /**
    @internal
    */ constructor(/**
    The position that was resolved.
    */ pos, /**
    @internal
    */ path, /**
    The offset this position has into its parent node.
    */ parentOffset){
        this.pos = pos;
        this.path = path;
        this.parentOffset = parentOffset;
        this.depth = path.length / 3 - 1;
    }
    /**
    @internal
    */ resolveDepth(val) {
        if (val == null) return this.depth;
        if (val < 0) return this.depth + val;
        return val;
    }
    /**
    The parent node that the position points into. Note that even if
    a position points into a text node, that node is not considered
    the parent—text nodes are ‘flat’ in this model, and have no content.
    */ get parent() {
        return this.node(this.depth);
    }
    /**
    The root node in which the position was resolved.
    */ get doc() {
        return this.node(0);
    }
    /**
    The ancestor node at the given level. `p.node(p.depth)` is the
    same as `p.parent`.
    */ node(depth) {
        return this.path[this.resolveDepth(depth) * 3];
    }
    /**
    The index into the ancestor at the given level. If this points
    at the 3rd node in the 2nd paragraph on the top level, for
    example, `p.index(0)` is 1 and `p.index(1)` is 2.
    */ index(depth) {
        return this.path[this.resolveDepth(depth) * 3 + 1];
    }
    /**
    The index pointing after this position into the ancestor at the
    given level.
    */ indexAfter(depth) {
        depth = this.resolveDepth(depth);
        return this.index(depth) + (depth == this.depth && !this.textOffset ? 0 : 1);
    }
    /**
    The (absolute) position at the start of the node at the given
    level.
    */ start(depth) {
        depth = this.resolveDepth(depth);
        return depth == 0 ? 0 : this.path[depth * 3 - 1] + 1;
    }
    /**
    The (absolute) position at the end of the node at the given
    level.
    */ end(depth) {
        depth = this.resolveDepth(depth);
        return this.start(depth) + this.node(depth).content.size;
    }
    /**
    The (absolute) position directly before the wrapping node at the
    given level, or, when `depth` is `this.depth + 1`, the original
    position.
    */ before(depth) {
        depth = this.resolveDepth(depth);
        if (!depth) throw new RangeError("There is no position before the top-level node");
        return depth == this.depth + 1 ? this.pos : this.path[depth * 3 - 1];
    }
    /**
    The (absolute) position directly after the wrapping node at the
    given level, or the original position when `depth` is `this.depth + 1`.
    */ after(depth) {
        depth = this.resolveDepth(depth);
        if (!depth) throw new RangeError("There is no position after the top-level node");
        return depth == this.depth + 1 ? this.pos : this.path[depth * 3 - 1] + this.path[depth * 3].nodeSize;
    }
    /**
    When this position points into a text node, this returns the
    distance between the position and the start of the text node.
    Will be zero for positions that point between nodes.
    */ get textOffset() {
        return this.pos - this.path[this.path.length - 1];
    }
    /**
    Get the node directly after the position, if any. If the position
    points into a text node, only the part of that node after the
    position is returned.
    */ get nodeAfter() {
        let parent = this.parent, index = this.index(this.depth);
        if (index == parent.childCount) return null;
        let dOff = this.pos - this.path[this.path.length - 1], child = parent.child(index);
        return dOff ? parent.child(index).cut(dOff) : child;
    }
    /**
    Get the node directly before the position, if any. If the
    position points into a text node, only the part of that node
    before the position is returned.
    */ get nodeBefore() {
        let index = this.index(this.depth);
        let dOff = this.pos - this.path[this.path.length - 1];
        if (dOff) return this.parent.child(index).cut(0, dOff);
        return index == 0 ? null : this.parent.child(index - 1);
    }
    /**
    Get the position at the given index in the parent node at the
    given depth (which defaults to `this.depth`).
    */ posAtIndex(index, depth) {
        depth = this.resolveDepth(depth);
        let node = this.path[depth * 3], pos = depth == 0 ? 0 : this.path[depth * 3 - 1] + 1;
        for(let i = 0; i < index; i++)pos += node.child(i).nodeSize;
        return pos;
    }
    /**
    Get the marks at this position, factoring in the surrounding
    marks' [`inclusive`](https://prosemirror.net/docs/ref/#model.MarkSpec.inclusive) property. If the
    position is at the start of a non-empty node, the marks of the
    node after it (if any) are returned.
    */ marks() {
        let parent = this.parent, index = this.index();
        // In an empty parent, return the empty array
        if (parent.content.size == 0) return $493e9c5a7c75200a$export$c9d15bcfc6d42044.none;
        // When inside a text node, just return the text node's marks
        if (this.textOffset) return parent.child(index).marks;
        let main = parent.maybeChild(index - 1), other = parent.maybeChild(index);
        // If the `after` flag is true of there is no node before, make
        // the node after this position the main reference.
        if (!main) {
            let tmp = main;
            main = other;
            other = tmp;
        }
        // Use all marks in the main node, except those that have
        // `inclusive` set to false and are not present in the other node.
        let marks = main.marks;
        for(var i = 0; i < marks.length; i++)if (marks[i].type.spec.inclusive === false && (!other || !marks[i].isInSet(other.marks))) marks = marks[i--].removeFromSet(marks);
        return marks;
    }
    /**
    Get the marks after the current position, if any, except those
    that are non-inclusive and not present at position `$end`. This
    is mostly useful for getting the set of marks to preserve after a
    deletion. Will return `null` if this position is at the end of
    its parent node or its parent node isn't a textblock (in which
    case no marks should be preserved).
    */ marksAcross($end) {
        let after = this.parent.maybeChild(this.index());
        if (!after || !after.isInline) return null;
        let marks = after.marks, next = $end.parent.maybeChild($end.index());
        for(var i = 0; i < marks.length; i++)if (marks[i].type.spec.inclusive === false && (!next || !marks[i].isInSet(next.marks))) marks = marks[i--].removeFromSet(marks);
        return marks;
    }
    /**
    The depth up to which this position and the given (non-resolved)
    position share the same parent nodes.
    */ sharedDepth(pos) {
        for(let depth = this.depth; depth > 0; depth--)if (this.start(depth) <= pos && this.end(depth) >= pos) return depth;
        return 0;
    }
    /**
    Returns a range based on the place where this position and the
    given position diverge around block content. If both point into
    the same textblock, for example, a range around that textblock
    will be returned. If they point into different blocks, the range
    around those blocks in their shared ancestor is returned. You can
    pass in an optional predicate that will be called with a parent
    node to see if a range into that parent is acceptable.
    */ blockRange(other = this, pred) {
        if (other.pos < this.pos) return other.blockRange(this);
        for(let d = this.depth - (this.parent.inlineContent || this.pos == other.pos ? 1 : 0); d >= 0; d--)if (other.pos <= this.end(d) && (!pred || pred(this.node(d)))) return new $493e9c5a7c75200a$export$7bc461ceb770fb16(this, other, d);
        return null;
    }
    /**
    Query whether the given position shares the same parent node.
    */ sameParent(other) {
        return this.pos - this.parentOffset == other.pos - other.parentOffset;
    }
    /**
    Return the greater of this and the given position.
    */ max(other) {
        return other.pos > this.pos ? other : this;
    }
    /**
    Return the smaller of this and the given position.
    */ min(other) {
        return other.pos < this.pos ? other : this;
    }
    /**
    @internal
    */ toString() {
        let str = "";
        for(let i = 1; i <= this.depth; i++)str += (str ? "/" : "") + this.node(i).type.name + "_" + this.index(i - 1);
        return str + ":" + this.parentOffset;
    }
    /**
    @internal
    */ static resolve(doc, pos) {
        if (!(pos >= 0 && pos <= doc.content.size)) throw new RangeError("Position " + pos + " out of range");
        let path = [];
        let start = 0, parentOffset = pos;
        for(let node = doc;;){
            let { index: index, offset: offset } = node.content.findIndex(parentOffset);
            let rem = parentOffset - offset;
            path.push(node, index, start + offset);
            if (!rem) break;
            node = node.child(index);
            if (node.isText) break;
            parentOffset = rem - 1;
            start += offset + 1;
        }
        return new $493e9c5a7c75200a$export$b2a42f82e59e4b19(pos, path, parentOffset);
    }
    /**
    @internal
    */ static resolveCached(doc, pos) {
        let cache = $493e9c5a7c75200a$var$resolveCache.get(doc);
        if (cache) for(let i = 0; i < cache.elts.length; i++){
            let elt = cache.elts[i];
            if (elt.pos == pos) return elt;
        }
        else $493e9c5a7c75200a$var$resolveCache.set(doc, cache = new $493e9c5a7c75200a$var$ResolveCache);
        let result = cache.elts[cache.i] = $493e9c5a7c75200a$export$b2a42f82e59e4b19.resolve(doc, pos);
        cache.i = (cache.i + 1) % $493e9c5a7c75200a$var$resolveCacheSize;
        return result;
    }
}
class $493e9c5a7c75200a$var$ResolveCache {
    constructor(){
        this.elts = [];
        this.i = 0;
    }
}
const $493e9c5a7c75200a$var$resolveCacheSize = 12, $493e9c5a7c75200a$var$resolveCache = new WeakMap();
/**
Represents a flat range of content, i.e. one that starts and
ends in the same node.
*/ class $493e9c5a7c75200a$export$7bc461ceb770fb16 {
    /**
    Construct a node range. `$from` and `$to` should point into the
    same node until at least the given `depth`, since a node range
    denotes an adjacent set of nodes in a single parent node.
    */ constructor(/**
    A resolved position along the start of the content. May have a
    `depth` greater than this object's `depth` property, since
    these are the positions that were used to compute the range,
    not re-resolved positions directly at its boundaries.
    */ $from, /**
    A position along the end of the content. See
    caveat for [`$from`](https://prosemirror.net/docs/ref/#model.NodeRange.$from).
    */ $to, /**
    The depth of the node that this range points into.
    */ depth){
        this.$from = $from;
        this.$to = $to;
        this.depth = depth;
    }
    /**
    The position at the start of the range.
    */ get start() {
        return this.$from.before(this.depth + 1);
    }
    /**
    The position at the end of the range.
    */ get end() {
        return this.$to.after(this.depth + 1);
    }
    /**
    The parent node that the range points into.
    */ get parent() {
        return this.$from.node(this.depth);
    }
    /**
    The start index of the range in the parent node.
    */ get startIndex() {
        return this.$from.index(this.depth);
    }
    /**
    The end index of the range in the parent node.
    */ get endIndex() {
        return this.$to.indexAfter(this.depth);
    }
}
const $493e9c5a7c75200a$var$emptyAttrs = Object.create(null);
/**
This class represents a node in the tree that makes up a
ProseMirror document. So a document is an instance of `Node`, with
children that are also instances of `Node`.

Nodes are persistent data structures. Instead of changing them, you
create new ones with the content you want. Old ones keep pointing
at the old document shape. This is made cheaper by sharing
structure between the old and new data as much as possible, which a
tree shape like this (without back pointers) makes easy.

**Do not** directly mutate the properties of a `Node` object. See
[the guide](/docs/guide/#doc) for more information.
*/ class $493e9c5a7c75200a$export$85c928794f8d04d4 {
    /**
    @internal
    */ constructor(/**
    The type of node that this is.
    */ type, /**
    An object mapping attribute names to values. The kind of
    attributes allowed and required are
    [determined](https://prosemirror.net/docs/ref/#model.NodeSpec.attrs) by the node type.
    */ attrs, // A fragment holding the node's children.
    content, /**
    The marks (things like whether it is emphasized or part of a
    link) applied to this node.
    */ marks = $493e9c5a7c75200a$export$c9d15bcfc6d42044.none){
        this.type = type;
        this.attrs = attrs;
        this.marks = marks;
        this.content = content || $493e9c5a7c75200a$export$ffb0004e005737fa.empty;
    }
    /**
    The array of this node's child nodes.
    */ get children() {
        return this.content.content;
    }
    /**
    The size of this node, as defined by the integer-based [indexing
    scheme](/docs/guide/#doc.indexing). For text nodes, this is the
    amount of characters. For other leaf nodes, it is one. For
    non-leaf nodes, it is the size of the content plus two (the
    start and end token).
    */ get nodeSize() {
        return this.isLeaf ? 1 : 2 + this.content.size;
    }
    /**
    The number of children that the node has.
    */ get childCount() {
        return this.content.childCount;
    }
    /**
    Get the child node at the given index. Raises an error when the
    index is out of range.
    */ child(index) {
        return this.content.child(index);
    }
    /**
    Get the child node at the given index, if it exists.
    */ maybeChild(index) {
        return this.content.maybeChild(index);
    }
    /**
    Call `f` for every child node, passing the node, its offset
    into this parent node, and its index.
    */ forEach(f) {
        this.content.forEach(f);
    }
    /**
    Invoke a callback for all descendant nodes recursively between
    the given two positions that are relative to start of this
    node's content. The callback is invoked with the node, its
    position relative to the original node (method receiver),
    its parent node, and its child index. When the callback returns
    false for a given node, that node's children will not be
    recursed over. The last parameter can be used to specify a
    starting position to count from.
    */ nodesBetween(from, to, f, startPos = 0) {
        this.content.nodesBetween(from, to, f, startPos, this);
    }
    /**
    Call the given callback for every descendant node. Doesn't
    descend into a node when the callback returns `false`.
    */ descendants(f) {
        this.nodesBetween(0, this.content.size, f);
    }
    /**
    Concatenates all the text nodes found in this fragment and its
    children.
    */ get textContent() {
        return this.isLeaf && this.type.spec.leafText ? this.type.spec.leafText(this) : this.textBetween(0, this.content.size, "");
    }
    /**
    Get all text between positions `from` and `to`. When
    `blockSeparator` is given, it will be inserted to separate text
    from different block nodes. If `leafText` is given, it'll be
    inserted for every non-text leaf node encountered, otherwise
    [`leafText`](https://prosemirror.net/docs/ref/#model.NodeSpec^leafText) will be used.
    */ textBetween(from, to, blockSeparator, leafText) {
        return this.content.textBetween(from, to, blockSeparator, leafText);
    }
    /**
    Returns this node's first child, or `null` if there are no
    children.
    */ get firstChild() {
        return this.content.firstChild;
    }
    /**
    Returns this node's last child, or `null` if there are no
    children.
    */ get lastChild() {
        return this.content.lastChild;
    }
    /**
    Test whether two nodes represent the same piece of document.
    */ eq(other) {
        return this == other || this.sameMarkup(other) && this.content.eq(other.content);
    }
    /**
    Compare the markup (type, attributes, and marks) of this node to
    those of another. Returns `true` if both have the same markup.
    */ sameMarkup(other) {
        return this.hasMarkup(other.type, other.attrs, other.marks);
    }
    /**
    Check whether this node's markup correspond to the given type,
    attributes, and marks.
    */ hasMarkup(type, attrs, marks) {
        return this.type == type && $493e9c5a7c75200a$var$compareDeep(this.attrs, attrs || type.defaultAttrs || $493e9c5a7c75200a$var$emptyAttrs) && $493e9c5a7c75200a$export$c9d15bcfc6d42044.sameSet(this.marks, marks || $493e9c5a7c75200a$export$c9d15bcfc6d42044.none);
    }
    /**
    Create a new node with the same markup as this node, containing
    the given content (or empty, if no content is given).
    */ copy(content = null) {
        if (content == this.content) return this;
        return new $493e9c5a7c75200a$export$85c928794f8d04d4(this.type, this.attrs, content, this.marks);
    }
    /**
    Create a copy of this node, with the given set of marks instead
    of the node's own marks.
    */ mark(marks) {
        return marks == this.marks ? this : new $493e9c5a7c75200a$export$85c928794f8d04d4(this.type, this.attrs, this.content, marks);
    }
    /**
    Create a copy of this node with only the content between the
    given positions. If `to` is not given, it defaults to the end of
    the node.
    */ cut(from, to = this.content.size) {
        if (from == 0 && to == this.content.size) return this;
        return this.copy(this.content.cut(from, to));
    }
    /**
    Cut out the part of the document between the given positions, and
    return it as a `Slice` object.
    */ slice(from, to = this.content.size, includeParents = false) {
        if (from == to) return $493e9c5a7c75200a$export$b3f2e2de3a8baa1e.empty;
        let $from = this.resolve(from), $to = this.resolve(to);
        let depth = includeParents ? 0 : $from.sharedDepth(to);
        let start = $from.start(depth), node = $from.node(depth);
        let content = node.content.cut($from.pos - start, $to.pos - start);
        return new $493e9c5a7c75200a$export$b3f2e2de3a8baa1e(content, $from.depth - depth, $to.depth - depth);
    }
    /**
    Replace the part of the document between the given positions with
    the given slice. The slice must 'fit', meaning its open sides
    must be able to connect to the surrounding content, and its
    content nodes must be valid children for the node they are placed
    into. If any of this is violated, an error of type
    [`ReplaceError`](https://prosemirror.net/docs/ref/#model.ReplaceError) is thrown.
    */ replace(from, to, slice) {
        return $493e9c5a7c75200a$var$replace(this.resolve(from), this.resolve(to), slice);
    }
    /**
    Find the node directly after the given position.
    */ nodeAt(pos) {
        for(let node = this;;){
            let { index: index, offset: offset } = node.content.findIndex(pos);
            node = node.maybeChild(index);
            if (!node) return null;
            if (offset == pos || node.isText) return node;
            pos -= offset + 1;
        }
    }
    /**
    Find the (direct) child node after the given offset, if any,
    and return it along with its index and offset relative to this
    node.
    */ childAfter(pos) {
        let { index: index, offset: offset } = this.content.findIndex(pos);
        return {
            node: this.content.maybeChild(index),
            index: index,
            offset: offset
        };
    }
    /**
    Find the (direct) child node before the given offset, if any,
    and return it along with its index and offset relative to this
    node.
    */ childBefore(pos) {
        if (pos == 0) return {
            node: null,
            index: 0,
            offset: 0
        };
        let { index: index, offset: offset } = this.content.findIndex(pos);
        if (offset < pos) return {
            node: this.content.child(index),
            index: index,
            offset: offset
        };
        let node = this.content.child(index - 1);
        return {
            node: node,
            index: index - 1,
            offset: offset - node.nodeSize
        };
    }
    /**
    Resolve the given position in the document, returning an
    [object](https://prosemirror.net/docs/ref/#model.ResolvedPos) with information about its context.
    */ resolve(pos) {
        return $493e9c5a7c75200a$export$b2a42f82e59e4b19.resolveCached(this, pos);
    }
    /**
    @internal
    */ resolveNoCache(pos) {
        return $493e9c5a7c75200a$export$b2a42f82e59e4b19.resolve(this, pos);
    }
    /**
    Test whether a given mark or mark type occurs in this document
    between the two given positions.
    */ rangeHasMark(from, to, type) {
        let found = false;
        if (to > from) this.nodesBetween(from, to, (node)=>{
            if (type.isInSet(node.marks)) found = true;
            return !found;
        });
        return found;
    }
    /**
    True when this is a block (non-inline node)
    */ get isBlock() {
        return this.type.isBlock;
    }
    /**
    True when this is a textblock node, a block node with inline
    content.
    */ get isTextblock() {
        return this.type.isTextblock;
    }
    /**
    True when this node allows inline content.
    */ get inlineContent() {
        return this.type.inlineContent;
    }
    /**
    True when this is an inline node (a text node or a node that can
    appear among text).
    */ get isInline() {
        return this.type.isInline;
    }
    /**
    True when this is a text node.
    */ get isText() {
        return this.type.isText;
    }
    /**
    True when this is a leaf node.
    */ get isLeaf() {
        return this.type.isLeaf;
    }
    /**
    True when this is an atom, i.e. when it does not have directly
    editable content. This is usually the same as `isLeaf`, but can
    be configured with the [`atom` property](https://prosemirror.net/docs/ref/#model.NodeSpec.atom)
    on a node's spec (typically used when the node is displayed as
    an uneditable [node view](https://prosemirror.net/docs/ref/#view.NodeView)).
    */ get isAtom() {
        return this.type.isAtom;
    }
    /**
    Return a string representation of this node for debugging
    purposes.
    */ toString() {
        if (this.type.spec.toDebugString) return this.type.spec.toDebugString(this);
        let name = this.type.name;
        if (this.content.size) name += "(" + this.content.toStringInner() + ")";
        return $493e9c5a7c75200a$var$wrapMarks(this.marks, name);
    }
    /**
    Get the content match in this node at the given index.
    */ contentMatchAt(index) {
        let match = this.type.contentMatch.matchFragment(this.content, 0, index);
        if (!match) throw new Error("Called contentMatchAt on a node with invalid content");
        return match;
    }
    /**
    Test whether replacing the range between `from` and `to` (by
    child index) with the given replacement fragment (which defaults
    to the empty fragment) would leave the node's content valid. You
    can optionally pass `start` and `end` indices into the
    replacement fragment.
    */ canReplace(from, to, replacement = $493e9c5a7c75200a$export$ffb0004e005737fa.empty, start = 0, end = replacement.childCount) {
        let one = this.contentMatchAt(from).matchFragment(replacement, start, end);
        let two = one && one.matchFragment(this.content, to);
        if (!two || !two.validEnd) return false;
        for(let i = start; i < end; i++)if (!this.type.allowsMarks(replacement.child(i).marks)) return false;
        return true;
    }
    /**
    Test whether replacing the range `from` to `to` (by index) with
    a node of the given type would leave the node's content valid.
    */ canReplaceWith(from, to, type, marks) {
        if (marks && !this.type.allowsMarks(marks)) return false;
        let start = this.contentMatchAt(from).matchType(type);
        let end = start && start.matchFragment(this.content, to);
        return end ? end.validEnd : false;
    }
    /**
    Test whether the given node's content could be appended to this
    node. If that node is empty, this will only return true if there
    is at least one node type that can appear in both nodes (to avoid
    merging completely incompatible nodes).
    */ canAppend(other) {
        if (other.content.size) return this.canReplace(this.childCount, this.childCount, other.content);
        else return this.type.compatibleContent(other.type);
    }
    /**
    Check whether this node and its descendants conform to the
    schema, and raise an exception when they do not.
    */ check() {
        this.type.checkContent(this.content);
        this.type.checkAttrs(this.attrs);
        let copy = $493e9c5a7c75200a$export$c9d15bcfc6d42044.none;
        for(let i = 0; i < this.marks.length; i++){
            let mark = this.marks[i];
            mark.type.checkAttrs(mark.attrs);
            copy = mark.addToSet(copy);
        }
        if (!$493e9c5a7c75200a$export$c9d15bcfc6d42044.sameSet(copy, this.marks)) throw new RangeError(`Invalid collection of marks for node ${this.type.name}: ${this.marks.map((m)=>m.type.name)}`);
        this.content.forEach((node)=>node.check());
    }
    /**
    Return a JSON-serializeable representation of this node.
    */ toJSON() {
        let obj = {
            type: this.type.name
        };
        for(let _ in this.attrs){
            obj.attrs = this.attrs;
            break;
        }
        if (this.content.size) obj.content = this.content.toJSON();
        if (this.marks.length) obj.marks = this.marks.map((n)=>n.toJSON());
        return obj;
    }
    /**
    Deserialize a node from its JSON representation.
    */ static fromJSON(schema, json) {
        if (!json) throw new RangeError("Invalid input for Node.fromJSON");
        let marks = undefined;
        if (json.marks) {
            if (!Array.isArray(json.marks)) throw new RangeError("Invalid mark data for Node.fromJSON");
            marks = json.marks.map(schema.markFromJSON);
        }
        if (json.type == "text") {
            if (typeof json.text != "string") throw new RangeError("Invalid text node in JSON");
            return schema.text(json.text, marks);
        }
        let content = $493e9c5a7c75200a$export$ffb0004e005737fa.fromJSON(schema, json.content);
        let node = schema.nodeType(json.type).create(json.attrs, content, marks);
        node.type.checkAttrs(node.attrs);
        return node;
    }
}
$493e9c5a7c75200a$export$85c928794f8d04d4.prototype.text = undefined;
class $493e9c5a7c75200a$var$TextNode extends $493e9c5a7c75200a$export$85c928794f8d04d4 {
    /**
    @internal
    */ constructor(type, attrs, content, marks){
        super(type, attrs, null, marks);
        if (!content) throw new RangeError("Empty text nodes are not allowed");
        this.text = content;
    }
    toString() {
        if (this.type.spec.toDebugString) return this.type.spec.toDebugString(this);
        return $493e9c5a7c75200a$var$wrapMarks(this.marks, JSON.stringify(this.text));
    }
    get textContent() {
        return this.text;
    }
    textBetween(from, to) {
        return this.text.slice(from, to);
    }
    get nodeSize() {
        return this.text.length;
    }
    mark(marks) {
        return marks == this.marks ? this : new $493e9c5a7c75200a$var$TextNode(this.type, this.attrs, this.text, marks);
    }
    withText(text) {
        if (text == this.text) return this;
        return new $493e9c5a7c75200a$var$TextNode(this.type, this.attrs, text, this.marks);
    }
    cut(from = 0, to = this.text.length) {
        if (from == 0 && to == this.text.length) return this;
        return this.withText(this.text.slice(from, to));
    }
    eq(other) {
        return this.sameMarkup(other) && this.text == other.text;
    }
    toJSON() {
        let base = super.toJSON();
        base.text = this.text;
        return base;
    }
}
function $493e9c5a7c75200a$var$wrapMarks(marks, str) {
    for(let i = marks.length - 1; i >= 0; i--)str = marks[i].type.name + "(" + str + ")";
    return str;
}
/**
Instances of this class represent a match state of a node type's
[content expression](https://prosemirror.net/docs/ref/#model.NodeSpec.content), and can be used to
find out whether further content matches here, and whether a given
position is a valid end of the node.
*/ class $493e9c5a7c75200a$export$364ed450558d7ec4 {
    /**
    @internal
    */ constructor(/**
    True when this match state represents a valid end of the node.
    */ validEnd){
        this.validEnd = validEnd;
        /**
        @internal
        */ this.next = [];
        /**
        @internal
        */ this.wrapCache = [];
    }
    /**
    @internal
    */ static parse(string, nodeTypes) {
        let stream = new $493e9c5a7c75200a$var$TokenStream(string, nodeTypes);
        if (stream.next == null) return $493e9c5a7c75200a$export$364ed450558d7ec4.empty;
        let expr = $493e9c5a7c75200a$var$parseExpr(stream);
        if (stream.next) stream.err("Unexpected trailing text");
        let match = $493e9c5a7c75200a$var$dfa($493e9c5a7c75200a$var$nfa(expr));
        $493e9c5a7c75200a$var$checkForDeadEnds(match, stream);
        return match;
    }
    /**
    Match a node type, returning a match after that node if
    successful.
    */ matchType(type) {
        for(let i = 0; i < this.next.length; i++)if (this.next[i].type == type) return this.next[i].next;
        return null;
    }
    /**
    Try to match a fragment. Returns the resulting match when
    successful.
    */ matchFragment(frag, start = 0, end = frag.childCount) {
        let cur = this;
        for(let i = start; cur && i < end; i++)cur = cur.matchType(frag.child(i).type);
        return cur;
    }
    /**
    @internal
    */ get inlineContent() {
        return this.next.length != 0 && this.next[0].type.isInline;
    }
    /**
    Get the first matching node type at this match position that can
    be generated.
    */ get defaultType() {
        for(let i = 0; i < this.next.length; i++){
            let { type: type } = this.next[i];
            if (!(type.isText || type.hasRequiredAttrs())) return type;
        }
        return null;
    }
    /**
    @internal
    */ compatible(other) {
        for(let i = 0; i < this.next.length; i++)for(let j = 0; j < other.next.length; j++)if (this.next[i].type == other.next[j].type) return true;
        return false;
    }
    /**
    Try to match the given fragment, and if that fails, see if it can
    be made to match by inserting nodes in front of it. When
    successful, return a fragment of inserted nodes (which may be
    empty if nothing had to be inserted). When `toEnd` is true, only
    return a fragment if the resulting match goes to the end of the
    content expression.
    */ fillBefore(after, toEnd = false, startIndex = 0) {
        let seen = [
            this
        ];
        function search(match, types) {
            let finished = match.matchFragment(after, startIndex);
            if (finished && (!toEnd || finished.validEnd)) return $493e9c5a7c75200a$export$ffb0004e005737fa.from(types.map((tp)=>tp.createAndFill()));
            for(let i = 0; i < match.next.length; i++){
                let { type: type, next: next } = match.next[i];
                if (!(type.isText || type.hasRequiredAttrs()) && seen.indexOf(next) == -1) {
                    seen.push(next);
                    let found = search(next, types.concat(type));
                    if (found) return found;
                }
            }
            return null;
        }
        return search(this, []);
    }
    /**
    Find a set of wrapping node types that would allow a node of the
    given type to appear at this position. The result may be empty
    (when it fits directly) and will be null when no such wrapping
    exists.
    */ findWrapping(target) {
        for(let i = 0; i < this.wrapCache.length; i += 2)if (this.wrapCache[i] == target) return this.wrapCache[i + 1];
        let computed = this.computeWrapping(target);
        this.wrapCache.push(target, computed);
        return computed;
    }
    /**
    @internal
    */ computeWrapping(target) {
        let seen = Object.create(null), active = [
            {
                match: this,
                type: null,
                via: null
            }
        ];
        while(active.length){
            let current = active.shift(), match = current.match;
            if (match.matchType(target)) {
                let result = [];
                for(let obj = current; obj.type; obj = obj.via)result.push(obj.type);
                return result.reverse();
            }
            for(let i = 0; i < match.next.length; i++){
                let { type: type, next: next } = match.next[i];
                if (!type.isLeaf && !type.hasRequiredAttrs() && !(type.name in seen) && (!current.type || next.validEnd)) {
                    active.push({
                        match: type.contentMatch,
                        type: type,
                        via: current
                    });
                    seen[type.name] = true;
                }
            }
        }
        return null;
    }
    /**
    The number of outgoing edges this node has in the finite
    automaton that describes the content expression.
    */ get edgeCount() {
        return this.next.length;
    }
    /**
    Get the _n_​th outgoing edge from this node in the finite
    automaton that describes the content expression.
    */ edge(n) {
        if (n >= this.next.length) throw new RangeError(`There's no ${n}th edge in this content match`);
        return this.next[n];
    }
    /**
    @internal
    */ toString() {
        let seen = [];
        function scan(m) {
            seen.push(m);
            for(let i = 0; i < m.next.length; i++)if (seen.indexOf(m.next[i].next) == -1) scan(m.next[i].next);
        }
        scan(this);
        return seen.map((m, i)=>{
            let out = i + (m.validEnd ? "*" : " ") + " ";
            for(let i = 0; i < m.next.length; i++)out += (i ? ", " : "") + m.next[i].type.name + "->" + seen.indexOf(m.next[i].next);
            return out;
        }).join("\n");
    }
}
/**
@internal
*/ $493e9c5a7c75200a$export$364ed450558d7ec4.empty = new $493e9c5a7c75200a$export$364ed450558d7ec4(true);
class $493e9c5a7c75200a$var$TokenStream {
    constructor(string, nodeTypes){
        this.string = string;
        this.nodeTypes = nodeTypes;
        this.inline = null;
        this.pos = 0;
        this.tokens = string.split(/\s*(?=\b|\W|$)/);
        if (this.tokens[this.tokens.length - 1] == "") this.tokens.pop();
        if (this.tokens[0] == "") this.tokens.shift();
    }
    get next() {
        return this.tokens[this.pos];
    }
    eat(tok) {
        return this.next == tok && (this.pos++ || true);
    }
    err(str) {
        throw new SyntaxError(str + " (in content expression '" + this.string + "')");
    }
}
function $493e9c5a7c75200a$var$parseExpr(stream) {
    let exprs = [];
    do exprs.push($493e9c5a7c75200a$var$parseExprSeq(stream));
    while (stream.eat("|"));
    return exprs.length == 1 ? exprs[0] : {
        type: "choice",
        exprs: exprs
    };
}
function $493e9c5a7c75200a$var$parseExprSeq(stream) {
    let exprs = [];
    do exprs.push($493e9c5a7c75200a$var$parseExprSubscript(stream));
    while (stream.next && stream.next != ")" && stream.next != "|");
    return exprs.length == 1 ? exprs[0] : {
        type: "seq",
        exprs: exprs
    };
}
function $493e9c5a7c75200a$var$parseExprSubscript(stream) {
    let expr = $493e9c5a7c75200a$var$parseExprAtom(stream);
    for(;;){
        if (stream.eat("+")) expr = {
            type: "plus",
            expr: expr
        };
        else if (stream.eat("*")) expr = {
            type: "star",
            expr: expr
        };
        else if (stream.eat("?")) expr = {
            type: "opt",
            expr: expr
        };
        else if (stream.eat("{")) expr = $493e9c5a7c75200a$var$parseExprRange(stream, expr);
        else break;
    }
    return expr;
}
function $493e9c5a7c75200a$var$parseNum(stream) {
    if (/\D/.test(stream.next)) stream.err("Expected number, got '" + stream.next + "'");
    let result = Number(stream.next);
    stream.pos++;
    return result;
}
function $493e9c5a7c75200a$var$parseExprRange(stream, expr) {
    let min = $493e9c5a7c75200a$var$parseNum(stream), max = min;
    if (stream.eat(",")) {
        if (stream.next != "}") max = $493e9c5a7c75200a$var$parseNum(stream);
        else max = -1;
    }
    if (!stream.eat("}")) stream.err("Unclosed braced range");
    return {
        type: "range",
        min: min,
        max: max,
        expr: expr
    };
}
function $493e9c5a7c75200a$var$resolveName(stream, name) {
    let types = stream.nodeTypes, type = types[name];
    if (type) return [
        type
    ];
    let result = [];
    for(let typeName in types){
        let type = types[typeName];
        if (type.isInGroup(name)) result.push(type);
    }
    if (result.length == 0) stream.err("No node type or group '" + name + "' found");
    return result;
}
function $493e9c5a7c75200a$var$parseExprAtom(stream) {
    if (stream.eat("(")) {
        let expr = $493e9c5a7c75200a$var$parseExpr(stream);
        if (!stream.eat(")")) stream.err("Missing closing paren");
        return expr;
    } else if (!/\W/.test(stream.next)) {
        let exprs = $493e9c5a7c75200a$var$resolveName(stream, stream.next).map((type)=>{
            if (stream.inline == null) stream.inline = type.isInline;
            else if (stream.inline != type.isInline) stream.err("Mixing inline and block content");
            return {
                type: "name",
                value: type
            };
        });
        stream.pos++;
        return exprs.length == 1 ? exprs[0] : {
            type: "choice",
            exprs: exprs
        };
    } else stream.err("Unexpected token '" + stream.next + "'");
}
// Construct an NFA from an expression as returned by the parser. The
// NFA is represented as an array of states, which are themselves
// arrays of edges, which are `{term, to}` objects. The first state is
// the entry state and the last node is the success state.
//
// Note that unlike typical NFAs, the edge ordering in this one is
// significant, in that it is used to contruct filler content when
// necessary.
function $493e9c5a7c75200a$var$nfa(expr) {
    let nfa = [
        []
    ];
    connect(compile(expr, 0), node());
    return nfa;
    function node() {
        return nfa.push([]) - 1;
    }
    function edge(from, to, term) {
        let edge = {
            term: term,
            to: to
        };
        nfa[from].push(edge);
        return edge;
    }
    function connect(edges, to) {
        edges.forEach((edge)=>edge.to = to);
    }
    function compile(expr, from) {
        if (expr.type == "choice") return expr.exprs.reduce((out, expr)=>out.concat(compile(expr, from)), []);
        else if (expr.type == "seq") for(let i = 0;; i++){
            let next = compile(expr.exprs[i], from);
            if (i == expr.exprs.length - 1) return next;
            connect(next, from = node());
        }
        else if (expr.type == "star") {
            let loop = node();
            edge(from, loop);
            connect(compile(expr.expr, loop), loop);
            return [
                edge(loop)
            ];
        } else if (expr.type == "plus") {
            let loop = node();
            connect(compile(expr.expr, from), loop);
            connect(compile(expr.expr, loop), loop);
            return [
                edge(loop)
            ];
        } else if (expr.type == "opt") return [
            edge(from)
        ].concat(compile(expr.expr, from));
        else if (expr.type == "range") {
            let cur = from;
            for(let i = 0; i < expr.min; i++){
                let next = node();
                connect(compile(expr.expr, cur), next);
                cur = next;
            }
            if (expr.max == -1) connect(compile(expr.expr, cur), cur);
            else for(let i = expr.min; i < expr.max; i++){
                let next = node();
                edge(cur, next);
                connect(compile(expr.expr, cur), next);
                cur = next;
            }
            return [
                edge(cur)
            ];
        } else if (expr.type == "name") return [
            edge(from, undefined, expr.value)
        ];
        else throw new Error("Unknown expr type");
    }
}
function $493e9c5a7c75200a$var$cmp(a, b) {
    return b - a;
}
// Get the set of nodes reachable by null edges from `node`. Omit
// nodes with only a single null-out-edge, since they may lead to
// needless duplicated nodes.
function $493e9c5a7c75200a$var$nullFrom(nfa, node) {
    let result = [];
    scan(node);
    return result.sort($493e9c5a7c75200a$var$cmp);
    function scan(node) {
        let edges = nfa[node];
        if (edges.length == 1 && !edges[0].term) return scan(edges[0].to);
        result.push(node);
        for(let i = 0; i < edges.length; i++){
            let { term: term, to: to } = edges[i];
            if (!term && result.indexOf(to) == -1) scan(to);
        }
    }
}
// Compiles an NFA as produced by `nfa` into a DFA, modeled as a set
// of state objects (`ContentMatch` instances) with transitions
// between them.
function $493e9c5a7c75200a$var$dfa(nfa) {
    let labeled = Object.create(null);
    return explore($493e9c5a7c75200a$var$nullFrom(nfa, 0));
    function explore(states) {
        let out = [];
        states.forEach((node)=>{
            nfa[node].forEach(({ term: term, to: to })=>{
                if (!term) return;
                let set;
                for(let i = 0; i < out.length; i++)if (out[i][0] == term) set = out[i][1];
                $493e9c5a7c75200a$var$nullFrom(nfa, to).forEach((node)=>{
                    if (!set) out.push([
                        term,
                        set = []
                    ]);
                    if (set.indexOf(node) == -1) set.push(node);
                });
            });
        });
        let state = labeled[states.join(",")] = new $493e9c5a7c75200a$export$364ed450558d7ec4(states.indexOf(nfa.length - 1) > -1);
        for(let i = 0; i < out.length; i++){
            let states = out[i][1].sort($493e9c5a7c75200a$var$cmp);
            state.next.push({
                type: out[i][0],
                next: labeled[states.join(",")] || explore(states)
            });
        }
        return state;
    }
}
function $493e9c5a7c75200a$var$checkForDeadEnds(match, stream) {
    for(let i = 0, work = [
        match
    ]; i < work.length; i++){
        let state = work[i], dead = !state.validEnd, nodes = [];
        for(let j = 0; j < state.next.length; j++){
            let { type: type, next: next } = state.next[j];
            nodes.push(type.name);
            if (dead && !(type.isText || type.hasRequiredAttrs())) dead = false;
            if (work.indexOf(next) == -1) work.push(next);
        }
        if (dead) stream.err("Only non-generatable nodes (" + nodes.join(", ") + ") in a required position (see https://prosemirror.net/docs/guide/#generatable)");
    }
}
// For node types where all attrs have a default value (or which don't
// have any attributes), build up a single reusable default attribute
// object, and use it for all nodes that don't specify specific
// attributes.
function $493e9c5a7c75200a$var$defaultAttrs(attrs) {
    let defaults = Object.create(null);
    for(let attrName in attrs){
        let attr = attrs[attrName];
        if (!attr.hasDefault) return null;
        defaults[attrName] = attr.default;
    }
    return defaults;
}
function $493e9c5a7c75200a$var$computeAttrs(attrs, value) {
    let built = Object.create(null);
    for(let name in attrs){
        let given = value && value[name];
        if (given === undefined) {
            let attr = attrs[name];
            if (attr.hasDefault) given = attr.default;
            else throw new RangeError("No value supplied for attribute " + name);
        }
        built[name] = given;
    }
    return built;
}
function $493e9c5a7c75200a$var$checkAttrs(attrs, values, type, name) {
    for(let name in values)if (!(name in attrs)) throw new RangeError(`Unsupported attribute ${name} for ${type} of type ${name}`);
    for(let name in attrs){
        let attr = attrs[name];
        if (attr.validate) attr.validate(values[name]);
    }
}
function $493e9c5a7c75200a$var$initAttrs(typeName, attrs) {
    let result = Object.create(null);
    if (attrs) for(let name in attrs)result[name] = new $493e9c5a7c75200a$var$Attribute(typeName, name, attrs[name]);
    return result;
}
/**
Node types are objects allocated once per `Schema` and used to
[tag](https://prosemirror.net/docs/ref/#model.Node.type) `Node` instances. They contain information
about the node type, such as its name and what kind of node it
represents.
*/ class $493e9c5a7c75200a$export$f06e977173f1857c {
    /**
    @internal
    */ constructor(/**
    The name the node type has in this schema.
    */ name, /**
    A link back to the `Schema` the node type belongs to.
    */ schema, /**
    The spec that this type is based on
    */ spec){
        this.name = name;
        this.schema = schema;
        this.spec = spec;
        /**
        The set of marks allowed in this node. `null` means all marks
        are allowed.
        */ this.markSet = null;
        this.groups = spec.group ? spec.group.split(" ") : [];
        this.attrs = $493e9c5a7c75200a$var$initAttrs(name, spec.attrs);
        this.defaultAttrs = $493e9c5a7c75200a$var$defaultAttrs(this.attrs);
        this.contentMatch = null;
        this.inlineContent = null;
        this.isBlock = !(spec.inline || name == "text");
        this.isText = name == "text";
    }
    /**
    True if this is an inline type.
    */ get isInline() {
        return !this.isBlock;
    }
    /**
    True if this is a textblock type, a block that contains inline
    content.
    */ get isTextblock() {
        return this.isBlock && this.inlineContent;
    }
    /**
    True for node types that allow no content.
    */ get isLeaf() {
        return this.contentMatch == $493e9c5a7c75200a$export$364ed450558d7ec4.empty;
    }
    /**
    True when this node is an atom, i.e. when it does not have
    directly editable content.
    */ get isAtom() {
        return this.isLeaf || !!this.spec.atom;
    }
    /**
    Return true when this node type is part of the given
    [group](https://prosemirror.net/docs/ref/#model.NodeSpec.group).
    */ isInGroup(group) {
        return this.groups.indexOf(group) > -1;
    }
    /**
    The node type's [whitespace](https://prosemirror.net/docs/ref/#model.NodeSpec.whitespace) option.
    */ get whitespace() {
        return this.spec.whitespace || (this.spec.code ? "pre" : "normal");
    }
    /**
    Tells you whether this node type has any required attributes.
    */ hasRequiredAttrs() {
        for(let n in this.attrs)if (this.attrs[n].isRequired) return true;
        return false;
    }
    /**
    Indicates whether this node allows some of the same content as
    the given node type.
    */ compatibleContent(other) {
        return this == other || this.contentMatch.compatible(other.contentMatch);
    }
    /**
    @internal
    */ computeAttrs(attrs) {
        if (!attrs && this.defaultAttrs) return this.defaultAttrs;
        else return $493e9c5a7c75200a$var$computeAttrs(this.attrs, attrs);
    }
    /**
    Create a `Node` of this type. The given attributes are
    checked and defaulted (you can pass `null` to use the type's
    defaults entirely, if no required attributes exist). `content`
    may be a `Fragment`, a node, an array of nodes, or
    `null`. Similarly `marks` may be `null` to default to the empty
    set of marks.
    */ create(attrs = null, content, marks) {
        if (this.isText) throw new Error("NodeType.create can't construct text nodes");
        return new $493e9c5a7c75200a$export$85c928794f8d04d4(this, this.computeAttrs(attrs), $493e9c5a7c75200a$export$ffb0004e005737fa.from(content), $493e9c5a7c75200a$export$c9d15bcfc6d42044.setFrom(marks));
    }
    /**
    Like [`create`](https://prosemirror.net/docs/ref/#model.NodeType.create), but check the given content
    against the node type's content restrictions, and throw an error
    if it doesn't match.
    */ createChecked(attrs = null, content, marks) {
        content = $493e9c5a7c75200a$export$ffb0004e005737fa.from(content);
        this.checkContent(content);
        return new $493e9c5a7c75200a$export$85c928794f8d04d4(this, this.computeAttrs(attrs), content, $493e9c5a7c75200a$export$c9d15bcfc6d42044.setFrom(marks));
    }
    /**
    Like [`create`](https://prosemirror.net/docs/ref/#model.NodeType.create), but see if it is
    necessary to add nodes to the start or end of the given fragment
    to make it fit the node. If no fitting wrapping can be found,
    return null. Note that, due to the fact that required nodes can
    always be created, this will always succeed if you pass null or
    `Fragment.empty` as content.
    */ createAndFill(attrs = null, content, marks) {
        attrs = this.computeAttrs(attrs);
        content = $493e9c5a7c75200a$export$ffb0004e005737fa.from(content);
        if (content.size) {
            let before = this.contentMatch.fillBefore(content);
            if (!before) return null;
            content = before.append(content);
        }
        let matched = this.contentMatch.matchFragment(content);
        let after = matched && matched.fillBefore($493e9c5a7c75200a$export$ffb0004e005737fa.empty, true);
        if (!after) return null;
        return new $493e9c5a7c75200a$export$85c928794f8d04d4(this, attrs, content.append(after), $493e9c5a7c75200a$export$c9d15bcfc6d42044.setFrom(marks));
    }
    /**
    Returns true if the given fragment is valid content for this node
    type.
    */ validContent(content) {
        let result = this.contentMatch.matchFragment(content);
        if (!result || !result.validEnd) return false;
        for(let i = 0; i < content.childCount; i++)if (!this.allowsMarks(content.child(i).marks)) return false;
        return true;
    }
    /**
    Throws a RangeError if the given fragment is not valid content for this
    node type.
    @internal
    */ checkContent(content) {
        if (!this.validContent(content)) throw new RangeError(`Invalid content for node ${this.name}: ${content.toString().slice(0, 50)}`);
    }
    /**
    @internal
    */ checkAttrs(attrs) {
        $493e9c5a7c75200a$var$checkAttrs(this.attrs, attrs, "node", this.name);
    }
    /**
    Check whether the given mark type is allowed in this node.
    */ allowsMarkType(markType) {
        return this.markSet == null || this.markSet.indexOf(markType) > -1;
    }
    /**
    Test whether the given set of marks are allowed in this node.
    */ allowsMarks(marks) {
        if (this.markSet == null) return true;
        for(let i = 0; i < marks.length; i++)if (!this.allowsMarkType(marks[i].type)) return false;
        return true;
    }
    /**
    Removes the marks that are not allowed in this node from the given set.
    */ allowedMarks(marks) {
        if (this.markSet == null) return marks;
        let copy;
        for(let i = 0; i < marks.length; i++){
            if (!this.allowsMarkType(marks[i].type)) {
                if (!copy) copy = marks.slice(0, i);
            } else if (copy) copy.push(marks[i]);
        }
        return !copy ? marks : copy.length ? copy : $493e9c5a7c75200a$export$c9d15bcfc6d42044.none;
    }
    /**
    @internal
    */ static compile(nodes, schema) {
        let result = Object.create(null);
        nodes.forEach((name, spec)=>result[name] = new $493e9c5a7c75200a$export$f06e977173f1857c(name, schema, spec));
        let topType = schema.spec.topNode || "doc";
        if (!result[topType]) throw new RangeError("Schema is missing its top node type ('" + topType + "')");
        if (!result.text) throw new RangeError("Every schema needs a 'text' type");
        for(let _ in result.text.attrs)throw new RangeError("The text node type should not have attributes");
        return result;
    }
}
function $493e9c5a7c75200a$var$validateType(typeName, attrName, type) {
    let types = type.split("|");
    return (value)=>{
        let name = value === null ? "null" : typeof value;
        if (types.indexOf(name) < 0) throw new RangeError(`Expected value of type ${types} for attribute ${attrName} on type ${typeName}, got ${name}`);
    };
}
// Attribute descriptors
class $493e9c5a7c75200a$var$Attribute {
    constructor(typeName, attrName, options){
        this.hasDefault = Object.prototype.hasOwnProperty.call(options, "default");
        this.default = options.default;
        this.validate = typeof options.validate == "string" ? $493e9c5a7c75200a$var$validateType(typeName, attrName, options.validate) : options.validate;
    }
    get isRequired() {
        return !this.hasDefault;
    }
}
// Marks
/**
Like nodes, marks (which are associated with nodes to signify
things like emphasis or being part of a link) are
[tagged](https://prosemirror.net/docs/ref/#model.Mark.type) with type objects, which are
instantiated once per `Schema`.
*/ class $493e9c5a7c75200a$export$b6a78689043c6521 {
    /**
    @internal
    */ constructor(/**
    The name of the mark type.
    */ name, /**
    @internal
    */ rank, /**
    The schema that this mark type instance is part of.
    */ schema, /**
    The spec on which the type is based.
    */ spec){
        this.name = name;
        this.rank = rank;
        this.schema = schema;
        this.spec = spec;
        this.attrs = $493e9c5a7c75200a$var$initAttrs(name, spec.attrs);
        this.excluded = null;
        let defaults = $493e9c5a7c75200a$var$defaultAttrs(this.attrs);
        this.instance = defaults ? new $493e9c5a7c75200a$export$c9d15bcfc6d42044(this, defaults) : null;
    }
    /**
    Create a mark of this type. `attrs` may be `null` or an object
    containing only some of the mark's attributes. The others, if
    they have defaults, will be added.
    */ create(attrs = null) {
        if (!attrs && this.instance) return this.instance;
        return new $493e9c5a7c75200a$export$c9d15bcfc6d42044(this, $493e9c5a7c75200a$var$computeAttrs(this.attrs, attrs));
    }
    /**
    @internal
    */ static compile(marks, schema) {
        let result = Object.create(null), rank = 0;
        marks.forEach((name, spec)=>result[name] = new $493e9c5a7c75200a$export$b6a78689043c6521(name, rank++, schema, spec));
        return result;
    }
    /**
    When there is a mark of this type in the given set, a new set
    without it is returned. Otherwise, the input set is returned.
    */ removeFromSet(set) {
        for(var i = 0; i < set.length; i++)if (set[i].type == this) {
            set = set.slice(0, i).concat(set.slice(i + 1));
            i--;
        }
        return set;
    }
    /**
    Tests whether there is a mark of this type in the given set.
    */ isInSet(set) {
        for(let i = 0; i < set.length; i++)if (set[i].type == this) return set[i];
    }
    /**
    @internal
    */ checkAttrs(attrs) {
        $493e9c5a7c75200a$var$checkAttrs(this.attrs, attrs, "mark", this.name);
    }
    /**
    Queries whether a given mark type is
    [excluded](https://prosemirror.net/docs/ref/#model.MarkSpec.excludes) by this one.
    */ excludes(other) {
        return this.excluded.indexOf(other) > -1;
    }
}
/**
A document schema. Holds [node](https://prosemirror.net/docs/ref/#model.NodeType) and [mark
type](https://prosemirror.net/docs/ref/#model.MarkType) objects for the nodes and marks that may
occur in conforming documents, and provides functionality for
creating and deserializing such documents.

When given, the type parameters provide the names of the nodes and
marks in this schema.
*/ class $493e9c5a7c75200a$export$19342e026b58ebb7 {
    /**
    Construct a schema from a schema [specification](https://prosemirror.net/docs/ref/#model.SchemaSpec).
    */ constructor(spec){
        /**
        The [linebreak
        replacement](https://prosemirror.net/docs/ref/#model.NodeSpec.linebreakReplacement) node defined
        in this schema, if any.
        */ this.linebreakReplacement = null;
        /**
        An object for storing whatever values modules may want to
        compute and cache per schema. (If you want to store something
        in it, try to use property names unlikely to clash.)
        */ this.cached = Object.create(null);
        let instanceSpec = this.spec = {};
        for(let prop in spec)instanceSpec[prop] = spec[prop];
        instanceSpec.nodes = (0, $at9VT.default).from(spec.nodes), instanceSpec.marks = (0, $at9VT.default).from(spec.marks || {}), this.nodes = $493e9c5a7c75200a$export$f06e977173f1857c.compile(this.spec.nodes, this);
        this.marks = $493e9c5a7c75200a$export$b6a78689043c6521.compile(this.spec.marks, this);
        let contentExprCache = Object.create(null);
        for(let prop in this.nodes){
            if (prop in this.marks) throw new RangeError(prop + " can not be both a node and a mark");
            let type = this.nodes[prop], contentExpr = type.spec.content || "", markExpr = type.spec.marks;
            type.contentMatch = contentExprCache[contentExpr] || (contentExprCache[contentExpr] = $493e9c5a7c75200a$export$364ed450558d7ec4.parse(contentExpr, this.nodes));
            type.inlineContent = type.contentMatch.inlineContent;
            if (type.spec.linebreakReplacement) {
                if (this.linebreakReplacement) throw new RangeError("Multiple linebreak nodes defined");
                if (!type.isInline || !type.isLeaf) throw new RangeError("Linebreak replacement nodes must be inline leaf nodes");
                this.linebreakReplacement = type;
            }
            type.markSet = markExpr == "_" ? null : markExpr ? $493e9c5a7c75200a$var$gatherMarks(this, markExpr.split(" ")) : markExpr == "" || !type.inlineContent ? [] : null;
        }
        for(let prop in this.marks){
            let type = this.marks[prop], excl = type.spec.excludes;
            type.excluded = excl == null ? [
                type
            ] : excl == "" ? [] : $493e9c5a7c75200a$var$gatherMarks(this, excl.split(" "));
        }
        this.nodeFromJSON = this.nodeFromJSON.bind(this);
        this.markFromJSON = this.markFromJSON.bind(this);
        this.topNodeType = this.nodes[this.spec.topNode || "doc"];
        this.cached.wrappings = Object.create(null);
    }
    /**
    Create a node in this schema. The `type` may be a string or a
    `NodeType` instance. Attributes will be extended with defaults,
    `content` may be a `Fragment`, `null`, a `Node`, or an array of
    nodes.
    */ node(type, attrs = null, content, marks) {
        if (typeof type == "string") type = this.nodeType(type);
        else if (!(type instanceof $493e9c5a7c75200a$export$f06e977173f1857c)) throw new RangeError("Invalid node type: " + type);
        else if (type.schema != this) throw new RangeError("Node type from different schema used (" + type.name + ")");
        return type.createChecked(attrs, content, marks);
    }
    /**
    Create a text node in the schema. Empty text nodes are not
    allowed.
    */ text(text, marks) {
        let type = this.nodes.text;
        return new $493e9c5a7c75200a$var$TextNode(type, type.defaultAttrs, text, $493e9c5a7c75200a$export$c9d15bcfc6d42044.setFrom(marks));
    }
    /**
    Create a mark with the given type and attributes.
    */ mark(type, attrs) {
        if (typeof type == "string") type = this.marks[type];
        return type.create(attrs);
    }
    /**
    Deserialize a node from its JSON representation. This method is
    bound.
    */ nodeFromJSON(json) {
        return $493e9c5a7c75200a$export$85c928794f8d04d4.fromJSON(this, json);
    }
    /**
    Deserialize a mark from its JSON representation. This method is
    bound.
    */ markFromJSON(json) {
        return $493e9c5a7c75200a$export$c9d15bcfc6d42044.fromJSON(this, json);
    }
    /**
    @internal
    */ nodeType(name) {
        let found = this.nodes[name];
        if (!found) throw new RangeError("Unknown node type: " + name);
        return found;
    }
}
function $493e9c5a7c75200a$var$gatherMarks(schema, marks) {
    let found = [];
    for(let i = 0; i < marks.length; i++){
        let name = marks[i], mark = schema.marks[name], ok = mark;
        if (mark) found.push(mark);
        else for(let prop in schema.marks){
            let mark = schema.marks[prop];
            if (name == "_" || mark.spec.group && mark.spec.group.split(" ").indexOf(name) > -1) found.push(ok = mark);
        }
        if (!ok) throw new SyntaxError("Unknown mark type: '" + marks[i] + "'");
    }
    return found;
}
function $493e9c5a7c75200a$var$isTagRule(rule) {
    return rule.tag != null;
}
function $493e9c5a7c75200a$var$isStyleRule(rule) {
    return rule.style != null;
}
/**
A DOM parser represents a strategy for parsing DOM content into a
ProseMirror document conforming to a given schema. Its behavior is
defined by an array of [rules](https://prosemirror.net/docs/ref/#model.ParseRule).
*/ class $493e9c5a7c75200a$export$1059c6e7d2ce5669 {
    /**
    Create a parser that targets the given schema, using the given
    parsing rules.
    */ constructor(/**
    The schema into which the parser parses.
    */ schema, /**
    The set of [parse rules](https://prosemirror.net/docs/ref/#model.ParseRule) that the parser
    uses, in order of precedence.
    */ rules){
        this.schema = schema;
        this.rules = rules;
        /**
        @internal
        */ this.tags = [];
        /**
        @internal
        */ this.styles = [];
        let matchedStyles = this.matchedStyles = [];
        rules.forEach((rule)=>{
            if ($493e9c5a7c75200a$var$isTagRule(rule)) this.tags.push(rule);
            else if ($493e9c5a7c75200a$var$isStyleRule(rule)) {
                let prop = /[^=]*/.exec(rule.style)[0];
                if (matchedStyles.indexOf(prop) < 0) matchedStyles.push(prop);
                this.styles.push(rule);
            }
        });
        // Only normalize list elements when lists in the schema can't directly contain themselves
        this.normalizeLists = !this.tags.some((r)=>{
            if (!/^(ul|ol)\b/.test(r.tag) || !r.node) return false;
            let node = schema.nodes[r.node];
            return node.contentMatch.matchType(node);
        });
    }
    /**
    Parse a document from the content of a DOM node.
    */ parse(dom, options = {}) {
        let context = new $493e9c5a7c75200a$var$ParseContext(this, options, false);
        context.addAll(dom, $493e9c5a7c75200a$export$c9d15bcfc6d42044.none, options.from, options.to);
        return context.finish();
    }
    /**
    Parses the content of the given DOM node, like
    [`parse`](https://prosemirror.net/docs/ref/#model.DOMParser.parse), and takes the same set of
    options. But unlike that method, which produces a whole node,
    this one returns a slice that is open at the sides, meaning that
    the schema constraints aren't applied to the start of nodes to
    the left of the input and the end of nodes at the end.
    */ parseSlice(dom, options = {}) {
        let context = new $493e9c5a7c75200a$var$ParseContext(this, options, true);
        context.addAll(dom, $493e9c5a7c75200a$export$c9d15bcfc6d42044.none, options.from, options.to);
        return $493e9c5a7c75200a$export$b3f2e2de3a8baa1e.maxOpen(context.finish());
    }
    /**
    @internal
    */ matchTag(dom, context, after) {
        for(let i = after ? this.tags.indexOf(after) + 1 : 0; i < this.tags.length; i++){
            let rule = this.tags[i];
            if ($493e9c5a7c75200a$var$matches(dom, rule.tag) && (rule.namespace === undefined || dom.namespaceURI == rule.namespace) && (!rule.context || context.matchesContext(rule.context))) {
                if (rule.getAttrs) {
                    let result = rule.getAttrs(dom);
                    if (result === false) continue;
                    rule.attrs = result || undefined;
                }
                return rule;
            }
        }
    }
    /**
    @internal
    */ matchStyle(prop, value, context, after) {
        for(let i = after ? this.styles.indexOf(after) + 1 : 0; i < this.styles.length; i++){
            let rule = this.styles[i], style = rule.style;
            if (style.indexOf(prop) != 0 || rule.context && !context.matchesContext(rule.context) || // Test that the style string either precisely matches the prop,
            // or has an '=' sign after the prop, followed by the given
            // value.
            style.length > prop.length && (style.charCodeAt(prop.length) != 61 || style.slice(prop.length + 1) != value)) continue;
            if (rule.getAttrs) {
                let result = rule.getAttrs(value);
                if (result === false) continue;
                rule.attrs = result || undefined;
            }
            return rule;
        }
    }
    /**
    @internal
    */ static schemaRules(schema) {
        let result = [];
        function insert(rule) {
            let priority = rule.priority == null ? 50 : rule.priority, i = 0;
            for(; i < result.length; i++){
                let next = result[i], nextPriority = next.priority == null ? 50 : next.priority;
                if (nextPriority < priority) break;
            }
            result.splice(i, 0, rule);
        }
        for(let name in schema.marks){
            let rules = schema.marks[name].spec.parseDOM;
            if (rules) rules.forEach((rule)=>{
                insert(rule = $493e9c5a7c75200a$var$copy(rule));
                if (!(rule.mark || rule.ignore || rule.clearMark)) rule.mark = name;
            });
        }
        for(let name in schema.nodes){
            let rules = schema.nodes[name].spec.parseDOM;
            if (rules) rules.forEach((rule)=>{
                insert(rule = $493e9c5a7c75200a$var$copy(rule));
                if (!(rule.node || rule.ignore || rule.mark)) rule.node = name;
            });
        }
        return result;
    }
    /**
    Construct a DOM parser using the parsing rules listed in a
    schema's [node specs](https://prosemirror.net/docs/ref/#model.NodeSpec.parseDOM), reordered by
    [priority](https://prosemirror.net/docs/ref/#model.ParseRule.priority).
    */ static fromSchema(schema) {
        return schema.cached.domParser || (schema.cached.domParser = new $493e9c5a7c75200a$export$1059c6e7d2ce5669(schema, $493e9c5a7c75200a$export$1059c6e7d2ce5669.schemaRules(schema)));
    }
}
const $493e9c5a7c75200a$var$blockTags = {
    address: true,
    article: true,
    aside: true,
    blockquote: true,
    canvas: true,
    dd: true,
    div: true,
    dl: true,
    fieldset: true,
    figcaption: true,
    figure: true,
    footer: true,
    form: true,
    h1: true,
    h2: true,
    h3: true,
    h4: true,
    h5: true,
    h6: true,
    header: true,
    hgroup: true,
    hr: true,
    li: true,
    noscript: true,
    ol: true,
    output: true,
    p: true,
    pre: true,
    section: true,
    table: true,
    tfoot: true,
    ul: true
};
const $493e9c5a7c75200a$var$ignoreTags = {
    head: true,
    noscript: true,
    object: true,
    script: true,
    style: true,
    title: true
};
const $493e9c5a7c75200a$var$listTags = {
    ol: true,
    ul: true
};
// Using a bitfield for node context options
const $493e9c5a7c75200a$var$OPT_PRESERVE_WS = 1, $493e9c5a7c75200a$var$OPT_PRESERVE_WS_FULL = 2, $493e9c5a7c75200a$var$OPT_OPEN_LEFT = 4;
function $493e9c5a7c75200a$var$wsOptionsFor(type, preserveWhitespace, base) {
    if (preserveWhitespace != null) return (preserveWhitespace ? $493e9c5a7c75200a$var$OPT_PRESERVE_WS : 0) | (preserveWhitespace === "full" ? $493e9c5a7c75200a$var$OPT_PRESERVE_WS_FULL : 0);
    return type && type.whitespace == "pre" ? $493e9c5a7c75200a$var$OPT_PRESERVE_WS | $493e9c5a7c75200a$var$OPT_PRESERVE_WS_FULL : base & ~$493e9c5a7c75200a$var$OPT_OPEN_LEFT;
}
class $493e9c5a7c75200a$var$NodeContext {
    constructor(type, attrs, marks, solid, match, options){
        this.type = type;
        this.attrs = attrs;
        this.marks = marks;
        this.solid = solid;
        this.options = options;
        this.content = [];
        // Marks applied to the node's children
        this.activeMarks = $493e9c5a7c75200a$export$c9d15bcfc6d42044.none;
        this.match = match || (options & $493e9c5a7c75200a$var$OPT_OPEN_LEFT ? null : type.contentMatch);
    }
    findWrapping(node) {
        if (!this.match) {
            if (!this.type) return [];
            let fill = this.type.contentMatch.fillBefore($493e9c5a7c75200a$export$ffb0004e005737fa.from(node));
            if (fill) this.match = this.type.contentMatch.matchFragment(fill);
            else {
                let start = this.type.contentMatch, wrap;
                if (wrap = start.findWrapping(node.type)) {
                    this.match = start;
                    return wrap;
                } else return null;
            }
        }
        return this.match.findWrapping(node.type);
    }
    finish(openEnd) {
        if (!(this.options & $493e9c5a7c75200a$var$OPT_PRESERVE_WS)) {
            let last = this.content[this.content.length - 1], m;
            if (last && last.isText && (m = /[ \t\r\n\u000c]+$/.exec(last.text))) {
                let text = last;
                if (last.text.length == m[0].length) this.content.pop();
                else this.content[this.content.length - 1] = text.withText(text.text.slice(0, text.text.length - m[0].length));
            }
        }
        let content = $493e9c5a7c75200a$export$ffb0004e005737fa.from(this.content);
        if (!openEnd && this.match) content = content.append(this.match.fillBefore($493e9c5a7c75200a$export$ffb0004e005737fa.empty, true));
        return this.type ? this.type.create(this.attrs, content, this.marks) : content;
    }
    inlineContext(node) {
        if (this.type) return this.type.inlineContent;
        if (this.content.length) return this.content[0].isInline;
        return node.parentNode && !$493e9c5a7c75200a$var$blockTags.hasOwnProperty(node.parentNode.nodeName.toLowerCase());
    }
}
class $493e9c5a7c75200a$var$ParseContext {
    constructor(// The parser we are using.
    parser, // The options passed to this parse.
    options, isOpen){
        this.parser = parser;
        this.options = options;
        this.isOpen = isOpen;
        this.open = 0;
        this.localPreserveWS = false;
        let topNode = options.topNode, topContext;
        let topOptions = $493e9c5a7c75200a$var$wsOptionsFor(null, options.preserveWhitespace, 0) | (isOpen ? $493e9c5a7c75200a$var$OPT_OPEN_LEFT : 0);
        if (topNode) topContext = new $493e9c5a7c75200a$var$NodeContext(topNode.type, topNode.attrs, $493e9c5a7c75200a$export$c9d15bcfc6d42044.none, true, options.topMatch || topNode.type.contentMatch, topOptions);
        else if (isOpen) topContext = new $493e9c5a7c75200a$var$NodeContext(null, null, $493e9c5a7c75200a$export$c9d15bcfc6d42044.none, true, null, topOptions);
        else topContext = new $493e9c5a7c75200a$var$NodeContext(parser.schema.topNodeType, null, $493e9c5a7c75200a$export$c9d15bcfc6d42044.none, true, null, topOptions);
        this.nodes = [
            topContext
        ];
        this.find = options.findPositions;
        this.needsBlock = false;
    }
    get top() {
        return this.nodes[this.open];
    }
    // Add a DOM node to the content. Text is inserted as text node,
    // otherwise, the node is passed to `addElement` or, if it has a
    // `style` attribute, `addElementWithStyles`.
    addDOM(dom, marks) {
        if (dom.nodeType == 3) this.addTextNode(dom, marks);
        else if (dom.nodeType == 1) this.addElement(dom, marks);
    }
    addTextNode(dom, marks) {
        let value = dom.nodeValue;
        let top = this.top, preserveWS = top.options & $493e9c5a7c75200a$var$OPT_PRESERVE_WS_FULL ? "full" : this.localPreserveWS || (top.options & $493e9c5a7c75200a$var$OPT_PRESERVE_WS) > 0;
        if (preserveWS === "full" || top.inlineContext(dom) || /[^ \t\r\n\u000c]/.test(value)) {
            if (!preserveWS) {
                value = value.replace(/[ \t\r\n\u000c]+/g, " ");
                // If this starts with whitespace, and there is no node before it, or
                // a hard break, or a text node that ends with whitespace, strip the
                // leading space.
                if (/^[ \t\r\n\u000c]/.test(value) && this.open == this.nodes.length - 1) {
                    let nodeBefore = top.content[top.content.length - 1];
                    let domNodeBefore = dom.previousSibling;
                    if (!nodeBefore || domNodeBefore && domNodeBefore.nodeName == 'BR' || nodeBefore.isText && /[ \t\r\n\u000c]$/.test(nodeBefore.text)) value = value.slice(1);
                }
            } else if (preserveWS !== "full") value = value.replace(/\r?\n|\r/g, " ");
            else value = value.replace(/\r\n?/g, "\n");
            if (value) this.insertNode(this.parser.schema.text(value), marks);
            this.findInText(dom);
        } else this.findInside(dom);
    }
    // Try to find a handler for the given tag and use that to parse. If
    // none is found, the element's content nodes are added directly.
    addElement(dom, marks, matchAfter) {
        let outerWS = this.localPreserveWS, top = this.top;
        if (dom.tagName == "PRE" || /pre/.test(dom.style && dom.style.whiteSpace)) this.localPreserveWS = true;
        let name = dom.nodeName.toLowerCase(), ruleID;
        if ($493e9c5a7c75200a$var$listTags.hasOwnProperty(name) && this.parser.normalizeLists) $493e9c5a7c75200a$var$normalizeList(dom);
        let rule = this.options.ruleFromNode && this.options.ruleFromNode(dom) || (ruleID = this.parser.matchTag(dom, this, matchAfter));
        out: if (rule ? rule.ignore : $493e9c5a7c75200a$var$ignoreTags.hasOwnProperty(name)) {
            this.findInside(dom);
            this.ignoreFallback(dom, marks);
        } else if (!rule || rule.skip || rule.closeParent) {
            if (rule && rule.closeParent) this.open = Math.max(0, this.open - 1);
            else if (rule && rule.skip.nodeType) dom = rule.skip;
            let sync, oldNeedsBlock = this.needsBlock;
            if ($493e9c5a7c75200a$var$blockTags.hasOwnProperty(name)) {
                if (top.content.length && top.content[0].isInline && this.open) {
                    this.open--;
                    top = this.top;
                }
                sync = true;
                if (!top.type) this.needsBlock = true;
            } else if (!dom.firstChild) {
                this.leafFallback(dom, marks);
                break out;
            }
            let innerMarks = rule && rule.skip ? marks : this.readStyles(dom, marks);
            if (innerMarks) this.addAll(dom, innerMarks);
            if (sync) this.sync(top);
            this.needsBlock = oldNeedsBlock;
        } else {
            let innerMarks = this.readStyles(dom, marks);
            if (innerMarks) this.addElementByRule(dom, rule, innerMarks, rule.consuming === false ? ruleID : undefined);
        }
        this.localPreserveWS = outerWS;
    }
    // Called for leaf DOM nodes that would otherwise be ignored
    leafFallback(dom, marks) {
        if (dom.nodeName == "BR" && this.top.type && this.top.type.inlineContent) this.addTextNode(dom.ownerDocument.createTextNode("\n"), marks);
    }
    // Called for ignored nodes
    ignoreFallback(dom, marks) {
        // Ignored BR nodes should at least create an inline context
        if (dom.nodeName == "BR" && (!this.top.type || !this.top.type.inlineContent)) this.findPlace(this.parser.schema.text("-"), marks);
    }
    // Run any style parser associated with the node's styles. Either
    // return an updated array of marks, or null to indicate some of the
    // styles had a rule with `ignore` set.
    readStyles(dom, marks) {
        let styles = dom.style;
        // Because many properties will only show up in 'normalized' form
        // in `style.item` (i.e. text-decoration becomes
        // text-decoration-line, text-decoration-color, etc), we directly
        // query the styles mentioned in our rules instead of iterating
        // over the items.
        if (styles && styles.length) for(let i = 0; i < this.parser.matchedStyles.length; i++){
            let name = this.parser.matchedStyles[i], value = styles.getPropertyValue(name);
            if (value) for(let after = undefined;;){
                let rule = this.parser.matchStyle(name, value, this, after);
                if (!rule) break;
                if (rule.ignore) return null;
                if (rule.clearMark) marks = marks.filter((m)=>!rule.clearMark(m));
                else marks = marks.concat(this.parser.schema.marks[rule.mark].create(rule.attrs));
                if (rule.consuming === false) after = rule;
                else break;
            }
        }
        return marks;
    }
    // Look up a handler for the given node. If none are found, return
    // false. Otherwise, apply it, use its return value to drive the way
    // the node's content is wrapped, and return true.
    addElementByRule(dom, rule, marks, continueAfter) {
        let sync, nodeType;
        if (rule.node) {
            nodeType = this.parser.schema.nodes[rule.node];
            if (!nodeType.isLeaf) {
                let inner = this.enter(nodeType, rule.attrs || null, marks, rule.preserveWhitespace);
                if (inner) {
                    sync = true;
                    marks = inner;
                }
            } else if (!this.insertNode(nodeType.create(rule.attrs), marks)) this.leafFallback(dom, marks);
        } else {
            let markType = this.parser.schema.marks[rule.mark];
            marks = marks.concat(markType.create(rule.attrs));
        }
        let startIn = this.top;
        if (nodeType && nodeType.isLeaf) this.findInside(dom);
        else if (continueAfter) this.addElement(dom, marks, continueAfter);
        else if (rule.getContent) {
            this.findInside(dom);
            rule.getContent(dom, this.parser.schema).forEach((node)=>this.insertNode(node, marks));
        } else {
            let contentDOM = dom;
            if (typeof rule.contentElement == "string") contentDOM = dom.querySelector(rule.contentElement);
            else if (typeof rule.contentElement == "function") contentDOM = rule.contentElement(dom);
            else if (rule.contentElement) contentDOM = rule.contentElement;
            this.findAround(dom, contentDOM, true);
            this.addAll(contentDOM, marks);
            this.findAround(dom, contentDOM, false);
        }
        if (sync && this.sync(startIn)) this.open--;
    }
    // Add all child nodes between `startIndex` and `endIndex` (or the
    // whole node, if not given). If `sync` is passed, use it to
    // synchronize after every block element.
    addAll(parent, marks, startIndex, endIndex) {
        let index = startIndex || 0;
        for(let dom = startIndex ? parent.childNodes[startIndex] : parent.firstChild, end = endIndex == null ? null : parent.childNodes[endIndex]; dom != end; dom = dom.nextSibling, ++index){
            this.findAtPoint(parent, index);
            this.addDOM(dom, marks);
        }
        this.findAtPoint(parent, index);
    }
    // Try to find a way to fit the given node type into the current
    // context. May add intermediate wrappers and/or leave non-solid
    // nodes that we're in.
    findPlace(node, marks) {
        let route, sync;
        for(let depth = this.open; depth >= 0; depth--){
            let cx = this.nodes[depth];
            let found = cx.findWrapping(node);
            if (found && (!route || route.length > found.length)) {
                route = found;
                sync = cx;
                if (!found.length) break;
            }
            if (cx.solid) break;
        }
        if (!route) return null;
        this.sync(sync);
        for(let i = 0; i < route.length; i++)marks = this.enterInner(route[i], null, marks, false);
        return marks;
    }
    // Try to insert the given node, adjusting the context when needed.
    insertNode(node, marks) {
        if (node.isInline && this.needsBlock && !this.top.type) {
            let block = this.textblockFromContext();
            if (block) marks = this.enterInner(block, null, marks);
        }
        let innerMarks = this.findPlace(node, marks);
        if (innerMarks) {
            this.closeExtra();
            let top = this.top;
            if (top.match) top.match = top.match.matchType(node.type);
            let nodeMarks = $493e9c5a7c75200a$export$c9d15bcfc6d42044.none;
            for (let m of innerMarks.concat(node.marks))if (top.type ? top.type.allowsMarkType(m.type) : $493e9c5a7c75200a$var$markMayApply(m.type, node.type)) nodeMarks = m.addToSet(nodeMarks);
            top.content.push(node.mark(nodeMarks));
            return true;
        }
        return false;
    }
    // Try to start a node of the given type, adjusting the context when
    // necessary.
    enter(type, attrs, marks, preserveWS) {
        let innerMarks = this.findPlace(type.create(attrs), marks);
        if (innerMarks) innerMarks = this.enterInner(type, attrs, marks, true, preserveWS);
        return innerMarks;
    }
    // Open a node of the given type
    enterInner(type, attrs, marks, solid = false, preserveWS) {
        this.closeExtra();
        let top = this.top;
        top.match = top.match && top.match.matchType(type);
        let options = $493e9c5a7c75200a$var$wsOptionsFor(type, preserveWS, top.options);
        if (top.options & $493e9c5a7c75200a$var$OPT_OPEN_LEFT && top.content.length == 0) options |= $493e9c5a7c75200a$var$OPT_OPEN_LEFT;
        let applyMarks = $493e9c5a7c75200a$export$c9d15bcfc6d42044.none;
        marks = marks.filter((m)=>{
            if (top.type ? top.type.allowsMarkType(m.type) : $493e9c5a7c75200a$var$markMayApply(m.type, type)) {
                applyMarks = m.addToSet(applyMarks);
                return false;
            }
            return true;
        });
        this.nodes.push(new $493e9c5a7c75200a$var$NodeContext(type, attrs, applyMarks, solid, null, options));
        this.open++;
        return marks;
    }
    // Make sure all nodes above this.open are finished and added to
    // their parents
    closeExtra(openEnd = false) {
        let i = this.nodes.length - 1;
        if (i > this.open) {
            for(; i > this.open; i--)this.nodes[i - 1].content.push(this.nodes[i].finish(openEnd));
            this.nodes.length = this.open + 1;
        }
    }
    finish() {
        this.open = 0;
        this.closeExtra(this.isOpen);
        return this.nodes[0].finish(!!(this.isOpen || this.options.topOpen));
    }
    sync(to) {
        for(let i = this.open; i >= 0; i--){
            if (this.nodes[i] == to) {
                this.open = i;
                return true;
            } else if (this.localPreserveWS) this.nodes[i].options |= $493e9c5a7c75200a$var$OPT_PRESERVE_WS;
        }
        return false;
    }
    get currentPos() {
        this.closeExtra();
        let pos = 0;
        for(let i = this.open; i >= 0; i--){
            let content = this.nodes[i].content;
            for(let j = content.length - 1; j >= 0; j--)pos += content[j].nodeSize;
            if (i) pos++;
        }
        return pos;
    }
    findAtPoint(parent, offset) {
        if (this.find) {
            for(let i = 0; i < this.find.length; i++)if (this.find[i].node == parent && this.find[i].offset == offset) this.find[i].pos = this.currentPos;
        }
    }
    findInside(parent) {
        if (this.find) {
            for(let i = 0; i < this.find.length; i++)if (this.find[i].pos == null && parent.nodeType == 1 && parent.contains(this.find[i].node)) this.find[i].pos = this.currentPos;
        }
    }
    findAround(parent, content, before) {
        if (parent != content && this.find) {
            for(let i = 0; i < this.find.length; i++)if (this.find[i].pos == null && parent.nodeType == 1 && parent.contains(this.find[i].node)) {
                let pos = content.compareDocumentPosition(this.find[i].node);
                if (pos & (before ? 2 : 4)) this.find[i].pos = this.currentPos;
            }
        }
    }
    findInText(textNode) {
        if (this.find) {
            for(let i = 0; i < this.find.length; i++)if (this.find[i].node == textNode) this.find[i].pos = this.currentPos - (textNode.nodeValue.length - this.find[i].offset);
        }
    }
    // Determines whether the given context string matches this context.
    matchesContext(context) {
        if (context.indexOf("|") > -1) return context.split(/\s*\|\s*/).some(this.matchesContext, this);
        let parts = context.split("/");
        let option = this.options.context;
        let useRoot = !this.isOpen && (!option || option.parent.type == this.nodes[0].type);
        let minDepth = -(option ? option.depth + 1 : 0) + (useRoot ? 0 : 1);
        let match = (i, depth)=>{
            for(; i >= 0; i--){
                let part = parts[i];
                if (part == "") {
                    if (i == parts.length - 1 || i == 0) continue;
                    for(; depth >= minDepth; depth--)if (match(i - 1, depth)) return true;
                    return false;
                } else {
                    let next = depth > 0 || depth == 0 && useRoot ? this.nodes[depth].type : option && depth >= minDepth ? option.node(depth - minDepth).type : null;
                    if (!next || next.name != part && !next.isInGroup(part)) return false;
                    depth--;
                }
            }
            return true;
        };
        return match(parts.length - 1, this.open);
    }
    textblockFromContext() {
        let $context = this.options.context;
        if ($context) for(let d = $context.depth; d >= 0; d--){
            let deflt = $context.node(d).contentMatchAt($context.indexAfter(d)).defaultType;
            if (deflt && deflt.isTextblock && deflt.defaultAttrs) return deflt;
        }
        for(let name in this.parser.schema.nodes){
            let type = this.parser.schema.nodes[name];
            if (type.isTextblock && type.defaultAttrs) return type;
        }
    }
}
// Kludge to work around directly nested list nodes produced by some
// tools and allowed by browsers to mean that the nested list is
// actually part of the list item above it.
function $493e9c5a7c75200a$var$normalizeList(dom) {
    for(let child = dom.firstChild, prevItem = null; child; child = child.nextSibling){
        let name = child.nodeType == 1 ? child.nodeName.toLowerCase() : null;
        if (name && $493e9c5a7c75200a$var$listTags.hasOwnProperty(name) && prevItem) {
            prevItem.appendChild(child);
            child = prevItem;
        } else if (name == "li") prevItem = child;
        else if (name) prevItem = null;
    }
}
// Apply a CSS selector.
function $493e9c5a7c75200a$var$matches(dom, selector) {
    return (dom.matches || dom.msMatchesSelector || dom.webkitMatchesSelector || dom.mozMatchesSelector).call(dom, selector);
}
function $493e9c5a7c75200a$var$copy(obj) {
    let copy = {};
    for(let prop in obj)copy[prop] = obj[prop];
    return copy;
}
// Used when finding a mark at the top level of a fragment parse.
// Checks whether it would be reasonable to apply a given mark type to
// a given node, by looking at the way the mark occurs in the schema.
function $493e9c5a7c75200a$var$markMayApply(markType, nodeType) {
    let nodes = nodeType.schema.nodes;
    for(let name in nodes){
        let parent = nodes[name];
        if (!parent.allowsMarkType(markType)) continue;
        let seen = [], scan = (match)=>{
            seen.push(match);
            for(let i = 0; i < match.edgeCount; i++){
                let { type: type, next: next } = match.edge(i);
                if (type == nodeType) return true;
                if (seen.indexOf(next) < 0 && scan(next)) return true;
            }
        };
        if (scan(parent.contentMatch)) return true;
    }
}
/**
A DOM serializer knows how to convert ProseMirror nodes and
marks of various types to DOM nodes.
*/ class $493e9c5a7c75200a$export$3476b78f8f5a8b72 {
    /**
    Create a serializer. `nodes` should map node names to functions
    that take a node and return a description of the corresponding
    DOM. `marks` does the same for mark names, but also gets an
    argument that tells it whether the mark's content is block or
    inline content (for typical use, it'll always be inline). A mark
    serializer may be `null` to indicate that marks of that type
    should not be serialized.
    */ constructor(/**
    The node serialization functions.
    */ nodes, /**
    The mark serialization functions.
    */ marks){
        this.nodes = nodes;
        this.marks = marks;
    }
    /**
    Serialize the content of this fragment to a DOM fragment. When
    not in the browser, the `document` option, containing a DOM
    document, should be passed so that the serializer can create
    nodes.
    */ serializeFragment(fragment, options = {}, target) {
        if (!target) target = $493e9c5a7c75200a$var$doc(options).createDocumentFragment();
        let top = target, active = [];
        fragment.forEach((node)=>{
            if (active.length || node.marks.length) {
                let keep = 0, rendered = 0;
                while(keep < active.length && rendered < node.marks.length){
                    let next = node.marks[rendered];
                    if (!this.marks[next.type.name]) {
                        rendered++;
                        continue;
                    }
                    if (!next.eq(active[keep][0]) || next.type.spec.spanning === false) break;
                    keep++;
                    rendered++;
                }
                while(keep < active.length)top = active.pop()[1];
                while(rendered < node.marks.length){
                    let add = node.marks[rendered++];
                    let markDOM = this.serializeMark(add, node.isInline, options);
                    if (markDOM) {
                        active.push([
                            add,
                            top
                        ]);
                        top.appendChild(markDOM.dom);
                        top = markDOM.contentDOM || markDOM.dom;
                    }
                }
            }
            top.appendChild(this.serializeNodeInner(node, options));
        });
        return target;
    }
    /**
    @internal
    */ serializeNodeInner(node, options) {
        let { dom: dom, contentDOM: contentDOM } = $493e9c5a7c75200a$var$renderSpec($493e9c5a7c75200a$var$doc(options), this.nodes[node.type.name](node), null, node.attrs);
        if (contentDOM) {
            if (node.isLeaf) throw new RangeError("Content hole not allowed in a leaf node spec");
            this.serializeFragment(node.content, options, contentDOM);
        }
        return dom;
    }
    /**
    Serialize this node to a DOM node. This can be useful when you
    need to serialize a part of a document, as opposed to the whole
    document. To serialize a whole document, use
    [`serializeFragment`](https://prosemirror.net/docs/ref/#model.DOMSerializer.serializeFragment) on
    its [content](https://prosemirror.net/docs/ref/#model.Node.content).
    */ serializeNode(node, options = {}) {
        let dom = this.serializeNodeInner(node, options);
        for(let i = node.marks.length - 1; i >= 0; i--){
            let wrap = this.serializeMark(node.marks[i], node.isInline, options);
            if (wrap) {
                (wrap.contentDOM || wrap.dom).appendChild(dom);
                dom = wrap.dom;
            }
        }
        return dom;
    }
    /**
    @internal
    */ serializeMark(mark, inline, options = {}) {
        let toDOM = this.marks[mark.type.name];
        return toDOM && $493e9c5a7c75200a$var$renderSpec($493e9c5a7c75200a$var$doc(options), toDOM(mark, inline), null, mark.attrs);
    }
    static renderSpec(doc, structure, xmlNS = null, blockArraysIn) {
        return $493e9c5a7c75200a$var$renderSpec(doc, structure, xmlNS, blockArraysIn);
    }
    /**
    Build a serializer using the [`toDOM`](https://prosemirror.net/docs/ref/#model.NodeSpec.toDOM)
    properties in a schema's node and mark specs.
    */ static fromSchema(schema) {
        return schema.cached.domSerializer || (schema.cached.domSerializer = new $493e9c5a7c75200a$export$3476b78f8f5a8b72(this.nodesFromSchema(schema), this.marksFromSchema(schema)));
    }
    /**
    Gather the serializers in a schema's node specs into an object.
    This can be useful as a base to build a custom serializer from.
    */ static nodesFromSchema(schema) {
        let result = $493e9c5a7c75200a$var$gatherToDOM(schema.nodes);
        if (!result.text) result.text = (node)=>node.text;
        return result;
    }
    /**
    Gather the serializers in a schema's mark specs into an object.
    */ static marksFromSchema(schema) {
        return $493e9c5a7c75200a$var$gatherToDOM(schema.marks);
    }
}
function $493e9c5a7c75200a$var$gatherToDOM(obj) {
    let result = {};
    for(let name in obj){
        let toDOM = obj[name].spec.toDOM;
        if (toDOM) result[name] = toDOM;
    }
    return result;
}
function $493e9c5a7c75200a$var$doc(options) {
    return options.document || window.document;
}
const $493e9c5a7c75200a$var$suspiciousAttributeCache = new WeakMap();
function $493e9c5a7c75200a$var$suspiciousAttributes(attrs) {
    let value = $493e9c5a7c75200a$var$suspiciousAttributeCache.get(attrs);
    if (value === undefined) $493e9c5a7c75200a$var$suspiciousAttributeCache.set(attrs, value = $493e9c5a7c75200a$var$suspiciousAttributesInner(attrs));
    return value;
}
function $493e9c5a7c75200a$var$suspiciousAttributesInner(attrs) {
    let result = null;
    function scan(value) {
        if (value && typeof value == "object") {
            if (Array.isArray(value)) {
                if (typeof value[0] == "string") {
                    if (!result) result = [];
                    result.push(value);
                } else for(let i = 0; i < value.length; i++)scan(value[i]);
            } else for(let prop in value)scan(value[prop]);
        }
    }
    scan(attrs);
    return result;
}
function $493e9c5a7c75200a$var$renderSpec(doc, structure, xmlNS, blockArraysIn) {
    if (typeof structure == "string") return {
        dom: doc.createTextNode(structure)
    };
    if (structure.nodeType != null) return {
        dom: structure
    };
    if (structure.dom && structure.dom.nodeType != null) return structure;
    let tagName = structure[0], suspicious;
    if (typeof tagName != "string") throw new RangeError("Invalid array passed to renderSpec");
    if (blockArraysIn && (suspicious = $493e9c5a7c75200a$var$suspiciousAttributes(blockArraysIn)) && suspicious.indexOf(structure) > -1) throw new RangeError("Using an array from an attribute object as a DOM spec. This may be an attempted cross site scripting attack.");
    let space = tagName.indexOf(" ");
    if (space > 0) {
        xmlNS = tagName.slice(0, space);
        tagName = tagName.slice(space + 1);
    }
    let contentDOM;
    let dom = xmlNS ? doc.createElementNS(xmlNS, tagName) : doc.createElement(tagName);
    let attrs = structure[1], start = 1;
    if (attrs && typeof attrs == "object" && attrs.nodeType == null && !Array.isArray(attrs)) {
        start = 2;
        for(let name in attrs)if (attrs[name] != null) {
            let space = name.indexOf(" ");
            if (space > 0) dom.setAttributeNS(name.slice(0, space), name.slice(space + 1), attrs[name]);
            else dom.setAttribute(name, attrs[name]);
        }
    }
    for(let i = start; i < structure.length; i++){
        let child = structure[i];
        if (child === 0) {
            if (i < structure.length - 1 || i > start) throw new RangeError("Content hole must be the only child of its parent node");
            return {
                dom: dom,
                contentDOM: dom
            };
        } else {
            let { dom: inner, contentDOM: innerContent } = $493e9c5a7c75200a$var$renderSpec(doc, child, xmlNS, blockArraysIn);
            dom.appendChild(inner);
            if (innerContent) {
                if (contentDOM) throw new RangeError("Multiple content holes");
                contentDOM = innerContent;
            }
        }
    }
    return {
        dom: dom,
        contentDOM: contentDOM
    };
}

});
parcelRegister("at9VT", function(module, exports) {
$parcel$export(module.exports, "default", () => $79f45143962c5d22$export$2e2bcd8739ae039);
// ::- Persistent data structure representing an ordered mapping from
// strings to values, with some convenient update methods.
function $79f45143962c5d22$var$OrderedMap(content) {
    this.content = content;
}
$79f45143962c5d22$var$OrderedMap.prototype = {
    constructor: $79f45143962c5d22$var$OrderedMap,
    find: function(key) {
        for(var i = 0; i < this.content.length; i += 2)if (this.content[i] === key) return i;
        return -1;
    },
    // :: (string) → ?any
    // Retrieve the value stored under `key`, or return undefined when
    // no such key exists.
    get: function(key) {
        var found = this.find(key);
        return found == -1 ? undefined : this.content[found + 1];
    },
    // :: (string, any, ?string) → OrderedMap
    // Create a new map by replacing the value of `key` with a new
    // value, or adding a binding to the end of the map. If `newKey` is
    // given, the key of the binding will be replaced with that key.
    update: function(key, value, newKey) {
        var self = newKey && newKey != key ? this.remove(newKey) : this;
        var found = self.find(key), content = self.content.slice();
        if (found == -1) content.push(newKey || key, value);
        else {
            content[found + 1] = value;
            if (newKey) content[found] = newKey;
        }
        return new $79f45143962c5d22$var$OrderedMap(content);
    },
    // :: (string) → OrderedMap
    // Return a map with the given key removed, if it existed.
    remove: function(key) {
        var found = this.find(key);
        if (found == -1) return this;
        var content = this.content.slice();
        content.splice(found, 2);
        return new $79f45143962c5d22$var$OrderedMap(content);
    },
    // :: (string, any) → OrderedMap
    // Add a new key to the start of the map.
    addToStart: function(key, value) {
        return new $79f45143962c5d22$var$OrderedMap([
            key,
            value
        ].concat(this.remove(key).content));
    },
    // :: (string, any) → OrderedMap
    // Add a new key to the end of the map.
    addToEnd: function(key, value) {
        var content = this.remove(key).content.slice();
        content.push(key, value);
        return new $79f45143962c5d22$var$OrderedMap(content);
    },
    // :: (string, string, any) → OrderedMap
    // Add a key after the given key. If `place` is not found, the new
    // key is added to the end.
    addBefore: function(place, key, value) {
        var without = this.remove(key), content = without.content.slice();
        var found = without.find(place);
        content.splice(found == -1 ? content.length : found, 0, key, value);
        return new $79f45143962c5d22$var$OrderedMap(content);
    },
    // :: ((key: string, value: any))
    // Call the given function for each key/value pair in the map, in
    // order.
    forEach: function(f) {
        for(var i = 0; i < this.content.length; i += 2)f(this.content[i], this.content[i + 1]);
    },
    // :: (union<Object, OrderedMap>) → OrderedMap
    // Create a new map by prepending the keys in this map that don't
    // appear in `map` before the keys in `map`.
    prepend: function(map) {
        map = $79f45143962c5d22$var$OrderedMap.from(map);
        if (!map.size) return this;
        return new $79f45143962c5d22$var$OrderedMap(map.content.concat(this.subtract(map).content));
    },
    // :: (union<Object, OrderedMap>) → OrderedMap
    // Create a new map by appending the keys in this map that don't
    // appear in `map` after the keys in `map`.
    append: function(map) {
        map = $79f45143962c5d22$var$OrderedMap.from(map);
        if (!map.size) return this;
        return new $79f45143962c5d22$var$OrderedMap(this.subtract(map).content.concat(map.content));
    },
    // :: (union<Object, OrderedMap>) → OrderedMap
    // Create a map containing all the keys in this map that don't
    // appear in `map`.
    subtract: function(map) {
        var result = this;
        map = $79f45143962c5d22$var$OrderedMap.from(map);
        for(var i = 0; i < map.content.length; i += 2)result = result.remove(map.content[i]);
        return result;
    },
    // :: () → Object
    // Turn ordered map into a plain object.
    toObject: function() {
        var result = {};
        this.forEach(function(key, value) {
            result[key] = value;
        });
        return result;
    },
    // :: number
    // The amount of keys in this map.
    get size () {
        return this.content.length >> 1;
    }
};
// :: (?union<Object, OrderedMap>) → OrderedMap
// Return a map with the given content. If null, create an empty
// map. If given an ordered map, return that map itself. If given an
// object, create a map from the object's properties.
$79f45143962c5d22$var$OrderedMap.from = function(value) {
    if (value instanceof $79f45143962c5d22$var$OrderedMap) return value;
    var content = [];
    if (value) for(var prop in value)content.push(prop, value[prop]);
    return new $79f45143962c5d22$var$OrderedMap(content);
};
var $79f45143962c5d22$export$2e2bcd8739ae039 = $79f45143962c5d22$var$OrderedMap;

});


parcelRegister("6p3ce", function(module, exports) {
$parcel$export(module.exports, "FONT_STYLE", () => $4a978e99466559de$export$4498a6080fed604c);
$parcel$export(module.exports, "SEARCH_QUERY", () => $4a978e99466559de$export$f8e8a5f34f6ea725);
$parcel$export(module.exports, "LINK", () => $4a978e99466559de$export$b395009ca7f092c7);
$parcel$export(module.exports, "COLOR", () => $4a978e99466559de$export$9b982809044276a6);
// # What do marks exist?
//
// Marks are categorised into different groups. One motivation for this was to allow the `code` mark
// to exclude other marks, without needing to explicitly name them. Explicit naming requires the
// named mark to exist in the schema. This is undesirable because we want to construct different
// schemas that have different sets of nodes/marks.
//
// Groups provide a level of indirection, and solve this problem. For the immediate use-case, one
// group called "not_code" would have sufficed, but this an ultra-specialised to code.
// Mark group for font styling (e.g. bold, italic, underline, superscript).
var $4a978e99466559de$export$4498a6080fed604c = 'fontStyle';
var $4a978e99466559de$export$f8e8a5f34f6ea725 = 'searchQuery';
var $4a978e99466559de$export$b395009ca7f092c7 = 'link';
var $4a978e99466559de$export$9b982809044276a6 = 'color';
var $4a978e99466559de$export$470d0905851e47a1 = 'alignment';
var $4a978e99466559de$export$bacb7f4b06a06b22 = 'indentation';

});

parcelRegister("dIXl1", function(module, exports) {
$parcel$export(module.exports, "sanitizeNodes", () => $9fdd69bb2f717f48$export$daf54fed04c8fb77);

var $25nEq = parcelRequire("25nEq");
function $9fdd69bb2f717f48$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $9fdd69bb2f717f48$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $9fdd69bb2f717f48$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $9fdd69bb2f717f48$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $9fdd69bb2f717f48$export$daf54fed04c8fb77(nodes, supportedMarks) {
    var nodeNames = Object.keys(nodes);
    nodeNames.forEach(function(nodeKey) {
        var nodeSpec = $9fdd69bb2f717f48$var$_objectSpread({}, nodes[nodeKey]);
        if (nodeSpec.marks && nodeSpec.marks !== '_') nodeSpec.marks = nodeSpec.marks.split(' ').filter(function(mark) {
            return !!supportedMarks[mark];
        }).join(' ');
        if (nodeSpec.content) nodeSpec.content = $9fdd69bb2f717f48$var$sanitizeNodeSpecContent(nodes, nodeSpec.content);
        nodes[nodeKey] = nodeSpec;
    });
    return nodes;
}
function $9fdd69bb2f717f48$var$sanitizeNodeSpecContent(nodes, rawContent) {
    var content = rawContent.replace(/\W/g, ' ');
    var contentKeys = content.split(' ');
    var unsupportedContentKeys = contentKeys.filter(function(contentKey) {
        return !$9fdd69bb2f717f48$var$isContentSupported(nodes, contentKey);
    });
    return unsupportedContentKeys.reduce(function(newContent, nodeName) {
        return $9fdd69bb2f717f48$var$sanitizedContent(newContent, nodeName);
    }, rawContent);
}
function $9fdd69bb2f717f48$var$sanitizedContent(content, invalidContent) {
    if (!invalidContent.length) return content || '';
    if (!content || !content.match(/\w/)) return '';
    var pattern = "(".concat(invalidContent, "((\\s)*\\|)+)|((\\|(\\s)*)+").concat(invalidContent, "(\\+|\\*)?)|(").concat(invalidContent, "$)|(").concat(invalidContent, "(\\+|\\*))");
    return content.replace(new RegExp(pattern, 'g'), '').replace('  ', ' ').trim();
}
function $9fdd69bb2f717f48$var$isContentSupported(nodes, contentKey) {
    var nodeKeys = Object.keys(nodes);
    // content is with valid node
    if (nodeKeys.indexOf(contentKey) > -1) return true;
    // content is with valid group
    for(var supportedKey in nodes){
        var nodeSpec = nodes[supportedKey];
        if (nodeSpec && nodeSpec.group === contentKey) return true;
    }
    return false;
}

});

parcelRegister("5fbqs", function(module, exports) {
$parcel$export(module.exports, "alignmentPositionMap", () => $3d173760bc329d8c$export$be9cf49015769bbd);
$parcel$export(module.exports, "alignment", () => $3d173760bc329d8c$export$8e53000a4ec837);

var $P0RMo = parcelRequire("P0RMo");
var $3d173760bc329d8c$export$be9cf49015769bbd = {
    end: 'right',
    right: 'end',
    center: 'center'
};
var $3d173760bc329d8c$export$8e53000a4ec837 = (0, $P0RMo.alignment)({
    parseDOM: [
        {
            tag: 'div.fabric-editor-block-mark',
            getAttrs: function getAttrs(dom) {
                var align = dom.getAttribute('data-align');
                return align ? {
                    align: align
                } : false;
            }
        }
    ],
    toDOM: function toDOM(mark) {
        return [
            'div',
            {
                class: "fabric-editor-block-mark fabric-editor-alignment fabric-editor-align-".concat(mark.attrs.align),
                'data-align': mark.attrs.align
            },
            0
        ];
    }
});

});
parcelRegister("P0RMo", function(module, exports) {
$parcel$export(module.exports, "alignment", () => $09956f961005483e$export$8e53000a4ec837);
$parcel$export(module.exports, "annotation", () => $09956f961005483e$export$8512c9afa7b24c3b);
$parcel$export(module.exports, "backgroundColor", () => $09956f961005483e$export$8c5a050822fd698c);
$parcel$export(module.exports, "border", () => $09956f961005483e$export$1edee58a52776cd9);
$parcel$export(module.exports, "breakout", () => $09956f961005483e$export$89015c65f1c75e3f);
$parcel$export(module.exports, "code", () => $09956f961005483e$export$6565f9f03506010b);
$parcel$export(module.exports, "confluenceInlineComment", () => $09956f961005483e$export$f3b72f8fc4684ecd);
$parcel$export(module.exports, "dataConsumer", () => $09956f961005483e$export$3024f02c495408d6);
$parcel$export(module.exports, "em", () => $09956f961005483e$export$c63c6f932822f543);
$parcel$export(module.exports, "fragment", () => $09956f961005483e$export$f00aeb236b6f05af);
$parcel$export(module.exports, "indentation", () => $09956f961005483e$export$480c699bd4ec0d86);
$parcel$export(module.exports, "link", () => $09956f961005483e$export$9c30223ca0a664fb);
$parcel$export(module.exports, "strike", () => $09956f961005483e$export$4899a95d70ec5056);
$parcel$export(module.exports, "strong", () => $09956f961005483e$export$59ae2c325a998f89);
$parcel$export(module.exports, "subsup", () => $09956f961005483e$export$b3401ee80eb31041);
$parcel$export(module.exports, "textColor", () => $09956f961005483e$export$32f78bffcd82ff28);
$parcel$export(module.exports, "typeAheadQuery", () => $09956f961005483e$export$20af3dabbb5538df);
$parcel$export(module.exports, "underline", () => $09956f961005483e$export$425327af25286e5e);
$parcel$export(module.exports, "unsupportedMark", () => $09956f961005483e$export$30d78d5eb6719bb8);
$parcel$export(module.exports, "unsupportedNodeAttribute", () => $09956f961005483e$export$a316dc07ff5182a2);
/**
 * This file was automatically generated by @atlaskit/adf-schema-generator
 * DO NOT MODIFY IT BY HAND. Instead, modify the source files in "packages/adf-schema/src/next-schema" ,
 * and run "yarn workspace @atlaskit/adf-schema build:schema:all" to regenerate this file.
 */ 
var $hGaoB = parcelRequire("hGaoB");
var $09956f961005483e$export$8e53000a4ec837 = (0, $hGaoB.createPMMarkSpecFactory)({
    attrs: {
        align: {}
    },
    excludes: 'alignment indentation',
    group: 'alignment'
});
var $09956f961005483e$export$8512c9afa7b24c3b = (0, $hGaoB.createPMMarkSpecFactory)({
    attrs: {
        id: {
            default: ''
        },
        annotationType: {
            default: 'inlineComment'
        }
    },
    inclusive: true,
    excludes: '',
    group: 'annotation'
});
var $09956f961005483e$export$8c5a050822fd698c = (0, $hGaoB.createPMMarkSpecFactory)({
    attrs: {
        color: {}
    },
    inclusive: true,
    excludes: 'color',
    group: 'color'
});
var $09956f961005483e$export$1edee58a52776cd9 = (0, $hGaoB.createPMMarkSpecFactory)({
    attrs: {
        size: {},
        color: {}
    },
    inclusive: false
});
var $09956f961005483e$export$89015c65f1c75e3f = (0, $hGaoB.createPMMarkSpecFactory)({
    attrs: {
        mode: {
            default: 'wide'
        },
        width: {
            default: null
        }
    },
    inclusive: false,
    spanning: false
});
var $09956f961005483e$export$6565f9f03506010b = (0, $hGaoB.createPMMarkSpecFactory)({
    inclusive: true,
    excludes: 'fontStyle link searchQuery color'
});
var $09956f961005483e$export$f3b72f8fc4684ecd = (0, $hGaoB.createPMMarkSpecFactory)({
    attrs: {
        reference: {
            default: ''
        }
    },
    inclusive: false,
    excludes: ''
});
var $09956f961005483e$export$3024f02c495408d6 = (0, $hGaoB.createPMMarkSpecFactory)({
    attrs: {
        sources: {
            default: []
        }
    }
});
var $09956f961005483e$export$c63c6f932822f543 = (0, $hGaoB.createPMMarkSpecFactory)({
    inclusive: true,
    group: 'fontStyle'
});
var $09956f961005483e$export$f00aeb236b6f05af = (0, $hGaoB.createPMMarkSpecFactory)({
    attrs: {
        localId: {
            default: ''
        },
        name: {
            default: null
        }
    },
    inclusive: false,
    excludes: ''
});
var $09956f961005483e$export$480c699bd4ec0d86 = (0, $hGaoB.createPMMarkSpecFactory)({
    attrs: {
        level: {}
    },
    excludes: 'indentation alignment',
    group: 'indentation'
});
var $09956f961005483e$export$9c30223ca0a664fb = (0, $hGaoB.createPMMarkSpecFactory)({
    attrs: {
        href: {},
        __confluenceMetadata: {
            default: null
        }
    },
    inclusive: false,
    excludes: 'link',
    group: 'link'
});
var $09956f961005483e$export$4899a95d70ec5056 = (0, $hGaoB.createPMMarkSpecFactory)({
    inclusive: true,
    group: 'fontStyle'
});
var $09956f961005483e$export$59ae2c325a998f89 = (0, $hGaoB.createPMMarkSpecFactory)({
    inclusive: true,
    group: 'fontStyle'
});
var $09956f961005483e$export$b3401ee80eb31041 = (0, $hGaoB.createPMMarkSpecFactory)({
    attrs: {
        type: {
            default: 'sub'
        }
    },
    inclusive: true,
    group: 'fontStyle'
});
var $09956f961005483e$export$32f78bffcd82ff28 = (0, $hGaoB.createPMMarkSpecFactory)({
    attrs: {
        color: {}
    },
    inclusive: true,
    group: 'color'
});
var $09956f961005483e$export$20af3dabbb5538df = (0, $hGaoB.createPMMarkSpecFactory)({
    attrs: {
        trigger: {
            default: ''
        }
    },
    inclusive: true,
    group: 'searchQuery'
});
var $09956f961005483e$export$425327af25286e5e = (0, $hGaoB.createPMMarkSpecFactory)({
    inclusive: true,
    group: 'fontStyle'
});
var $09956f961005483e$export$30d78d5eb6719bb8 = (0, $hGaoB.createPMMarkSpecFactory)({
    attrs: {
        originalValue: {}
    },
    excludes: ''
});
var $09956f961005483e$export$a316dc07ff5182a2 = (0, $hGaoB.createPMMarkSpecFactory)({
    attrs: {
        unsupported: {},
        type: {}
    }
});

});


parcelRegister("kX1mK", function(module, exports) {
$parcel$export(module.exports, "AnnotationTypes", () => $f40a60964fe12a6c$export$94aa2fc69ad33d19);
$parcel$export(module.exports, "AnnotationMarkStates", () => $f40a60964fe12a6c$export$4bab14797673da9f);
$parcel$export(module.exports, "buildDataAttributes", () => $f40a60964fe12a6c$export$93a98caa8bc6cb07);
$parcel$export(module.exports, "annotation", () => $f40a60964fe12a6c$export$8512c9afa7b24c3b);

var $25nEq = parcelRequire("25nEq");

var $P0RMo = parcelRequire("P0RMo");
function $f40a60964fe12a6c$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $f40a60964fe12a6c$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $f40a60964fe12a6c$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $f40a60964fe12a6c$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $f40a60964fe12a6c$export$94aa2fc69ad33d19 = /*#__PURE__*/ function(AnnotationTypes) {
    AnnotationTypes["INLINE_COMMENT"] = "inlineComment";
    return AnnotationTypes;
}({});
var $f40a60964fe12a6c$export$4bab14797673da9f = /*#__PURE__*/ function(AnnotationMarkStates) {
    AnnotationMarkStates["RESOLVED"] = "resolved";
    AnnotationMarkStates["ACTIVE"] = "active";
    return AnnotationMarkStates;
}({});
function $f40a60964fe12a6c$export$93a98caa8bc6cb07(_ref) {
    var id = _ref.id, annotationType = _ref.annotationType, state = _ref.state;
    var data = {
        'data-mark-type': 'annotation',
        'data-mark-annotation-type': annotationType,
        'data-id': id
    };
    if (state) return $f40a60964fe12a6c$var$_objectSpread($f40a60964fe12a6c$var$_objectSpread({}, data), {}, {
        'data-mark-annotation-state': state
    });
    return data;
}
var $f40a60964fe12a6c$export$8512c9afa7b24c3b = (0, $P0RMo.annotation)({
    parseDOM: [
        {
            tag: 'span[data-mark-type="annotation"]',
            mark: 'annotation',
            getAttrs: function getAttrs(domNode) {
                var dom = domNode;
                var attrs = {
                    id: dom.getAttribute('data-id'),
                    annotationType: dom.getAttribute('data-mark-annotation-type')
                };
                return attrs;
            }
        }
    ],
    toDOM: function toDOM(node) {
        /*
      Data attributes on the DOM node are a temporary means of
      incrementally switching over to the Annotation mark. Once renderer
      provides native support for inline comments the data attributes on the
      DOM nodes will be removed.
    */ return [
            'span',
            $f40a60964fe12a6c$var$_objectSpread({
                // Prettier will remove the quotes around class. This would cause some browsers
                // to not add this attribute properly, as its a reserved word.
                // prettier-ignore
                'class': 'fabric-editor-annotation'
            }, $f40a60964fe12a6c$export$93a98caa8bc6cb07({
                id: node.attrs.id,
                annotationType: node.attrs.annotationType
            })),
            0
        ];
    }
});

});

parcelRegister("d3ddB", function(module, exports) {
$parcel$export(module.exports, "backgroundColor", () => $9805cf1429d73941$export$8c5a050822fd698c);

var $25nEq = parcelRequire("25nEq");

var $iYJcE = parcelRequire("iYJcE");

var $P0RMo = parcelRequire("P0RMo");

var $aE9eF = parcelRequire("aE9eF");

var $22vaF = parcelRequire("22vaF");

var $dvZpe = parcelRequire("dvZpe");

var $gwjAb = parcelRequire("gwjAb");
/**
 * @name backgroundColor_mark
 */ // Remove this when cleaning up platform_editor_add_orange_highlight_color
var $9805cf1429d73941$var$colorArrayPalette = [
    [
        (0, $22vaF.Neutral300),
        'Gray'
    ],
    // token: color.background.accent.gray.subtler
    [
        (0, $22vaF.T200),
        'Teal'
    ],
    // token: color.background.accent.teal.subtler
    [
        (0, $22vaF.L200),
        'Lime'
    ],
    // token: color.background.accent.lime.subtler
    [
        (0, $22vaF.O200),
        'Orange'
    ],
    // token: color.background.accent.orange.subtler
    [
        (0, $22vaF.M200),
        'Magenta'
    ],
    // token: color.background.accent.magenta.subtler
    [
        (0, $22vaF.P200),
        'Purple'
    ] // token: color.background.accent.purple.subtler
];
var $9805cf1429d73941$var$colorArrayPaletteNext = [
    [
        (0, $22vaF.Neutral300),
        'Gray'
    ],
    // token: color.background.accent.gray.subtler
    [
        (0, $22vaF.P200),
        'Purple'
    ],
    // token: color.background.accent.purple.subtler
    [
        (0, $22vaF.M200),
        'Magenta'
    ],
    // token: color.background.accent.magenta.subtler
    [
        (0, $22vaF.O200),
        'Orange'
    ],
    // token: color.background.accent.orange.subtler
    [
        (0, $22vaF.Yellow200),
        'Yellow'
    ],
    // token: color.background.accent.yellow.subtler
    [
        (0, $22vaF.L200),
        'Lime'
    ],
    // token: color.background.accent.lime.subtler
    [
        (0, $22vaF.T200),
        'Teal'
    ] // token: color.background.accent.teal.subtler
];
var $9805cf1429d73941$export$14ec3f21a268e497 = new Map();
$9805cf1429d73941$var$colorArrayPalette.forEach(function(_ref) {
    var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_ref, 2), color = _ref2[0], label = _ref2[1];
    return $9805cf1429d73941$export$14ec3f21a268e497.set(color.toLowerCase(), label);
});
var $9805cf1429d73941$export$7ab6fa38cecaeee2 = new Map();
$9805cf1429d73941$var$colorArrayPaletteNext.forEach(function(_ref3) {
    var _ref4 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_ref3, 2), color = _ref4[0], label = _ref4[1];
    return $9805cf1429d73941$export$7ab6fa38cecaeee2.set(color.toLowerCase(), label);
});
var $9805cf1429d73941$export$8c5a050822fd698c = (0, $P0RMo.backgroundColor)({
    parseDOM: [
        {
            style: 'background-color',
            getAttrs: function getAttrs(maybeValue) {
                var value = maybeValue;
                var hexColor;
                if (value.match(/^rgb/i)) hexColor = (0, $22vaF.rgbToHex)(value);
                else if (value[0] === '#') hexColor = value.toLowerCase();
                // else handle other colour formats
                return hexColor && $9805cf1429d73941$export$14ec3f21a268e497.has(hexColor) ? {
                    color: hexColor
                } : false;
            }
        },
        // This rule ensures when loading from a renderer or editor where the
        // presented text color does not match the stored hex color -- that the
        // text color is preserved.
        //
        // This is used to support the work-around that converts the hex color to
        // a design system token to enable light / dark mode (through a CSS variable --custom-palette-color)
        {
            tag: '.fabric-background-color-mark',
            getAttrs: function getAttrs(maybeElement) {
                if (!(maybeElement instanceof HTMLElement)) return false;
                var hexColor = maybeElement.dataset.backgroundCustomColor;
                return hexColor && $9805cf1429d73941$export$14ec3f21a268e497.has(hexColor) ? {
                    color: hexColor
                } : false;
            }
        }
    ],
    toDOM: function toDOM(mark) {
        var paletteColorValue;
        /**
     * Documents can contain custom colors when content has been migrated from the old editor, or created via APIs.
     *
     * This behaviour predates the introduction of dark mode.
     *
     * Without the inversion logic below, text with custom colors, can be hard to read when the user loads the page in dark mode.
     *
     * This introduces inversion of the presentation of the custom text colors when the user is in dark mode.
     *
     * This can be done without additional changes to account for users copying and pasting content inside the Editor, because of
     * how we detect text colors copied from external editor sources. Where we load the background color from a
     * separate attribute (data-text-custom-color), instead of the inline style.
     *
     * See the following document for more details on this behaviour
     * https://hello.atlassian.net/wiki/spaces/CCECO/pages/2908658046/Unsupported+custom+text+colors+in+dark+theme+Editor+Job+Story
     */ var tokenColor = (0, $aE9eF.hexToEditorTextBackgroundPaletteColor)(mark.attrs.color);
        if (tokenColor) paletteColorValue = tokenColor;
        else if ((0, $dvZpe.getGlobalTheme)().colorMode === 'dark') // if we have a custom color, we need to check if we are in dark mode
        paletteColorValue = (0, $gwjAb.getDarkModeLCHColor)(mark.attrs.color);
        else // if we are in light mode, we can just set the color
        paletteColorValue = mark.attrs.color;
        return [
            'span',
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({
                class: 'fabric-background-color-mark',
                // Editor common has a common style which uses this css variable as the value for
                // the color property using the `fabric-text-background-color-mark` selector applied above.
                style: "--custom-palette-color: ".concat(paletteColorValue)
            }, 'data-background-custom-color', mark.attrs.color)
        ];
    }
});

});
parcelRegister("dvZpe", function(module, exports) {
$parcel$export(module.exports, "getGlobalTheme", () => $9d6dcd92ad05926a$export$813ecdf77207a053);
$parcel$export(module.exports, "textColor", () => $9d6dcd92ad05926a$export$32f78bffcd82ff28);

var $25nEq = parcelRequire("25nEq");

var $iYJcE = parcelRequire("iYJcE");

var $P0RMo = parcelRequire("P0RMo");

var $aE9eF = parcelRequire("aE9eF");

var $22vaF = parcelRequire("22vaF");

var $gwjAb = parcelRequire("gwjAb");
/**
 * @name textColor_mark
 */ // used for extended palette in text color picker
var $9d6dcd92ad05926a$var$colorArrayPalette = [
    // default row - first color is added programatically
    // [N800, 'Squid ink'], // default dark gray
    [
        (0, $22vaF.B500),
        'Dark blue'
    ],
    // Chore coat
    [
        (0, $22vaF.T500),
        'Dark teal'
    ],
    // Shabby chic
    [
        (0, $22vaF.G500),
        'Dark green'
    ],
    // Keen green
    [
        (0, $22vaF.Y400),
        'Orange'
    ],
    // Cheezy blasters
    [
        (0, $22vaF.R500),
        'Dark red'
    ],
    // Dragon's blood
    [
        (0, $22vaF.P500),
        'Dark purple'
    ],
    // Prince
    // row 2
    [
        (0, $22vaF.N80),
        'Light gray'
    ],
    // Spooky ghost
    [
        (0, $22vaF.B100),
        'Blue'
    ],
    // Arvo breeze
    [
        (0, $22vaF.T300),
        'Teal'
    ],
    // Tamarama
    [
        (0, $22vaF.G300),
        'Green'
    ],
    // Fine pine
    [
        (0, $22vaF.Y200),
        'Yellow'
    ],
    // Pub mix
    [
        (0, $22vaF.R300),
        'Red'
    ],
    // Poppy surprise
    [
        (0, $22vaF.P300),
        'Purple'
    ],
    // Da' juice
    // row 3
    [
        (0, $22vaF.N0),
        'White'
    ],
    [
        (0, $22vaF.B75),
        'Light blue'
    ],
    // Schwag
    [
        (0, $22vaF.T75),
        'Light teal'
    ],
    // Arctic chill
    [
        (0, $22vaF.G75),
        'Light green'
    ],
    // Mintie
    [
        (0, $22vaF.Y75),
        'Light yellow'
    ],
    // Dandelion whisper
    [
        (0, $22vaF.R75),
        'Light red'
    ],
    // Bondi sunburn
    [
        (0, $22vaF.P50),
        'Light purple'
    ] // Lavender secret
];
var $9d6dcd92ad05926a$export$569885e57444f84a = new Map();
var $9d6dcd92ad05926a$export$81e5ed9e84fe2e28 = $9d6dcd92ad05926a$export$569885e57444f84a;
$9d6dcd92ad05926a$var$colorArrayPalette.forEach(function(_ref) {
    var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_ref, 2), color = _ref2[0], label = _ref2[1];
    return $9d6dcd92ad05926a$export$569885e57444f84a.set(color.toLowerCase(), label);
});
// these are for test only
var $9d6dcd92ad05926a$var$testGlobalTheme;
var $9d6dcd92ad05926a$export$fd7e0dd2b74807f7 = function setGlobalTheme(theme) {
    $9d6dcd92ad05926a$var$testGlobalTheme = theme;
};
var $9d6dcd92ad05926a$export$813ecdf77207a053 = function getGlobalTheme() {
    // This should only be hit during tests.
    //
    // At time of writing Jest mocks are not working in this repository.
    if ($9d6dcd92ad05926a$var$testGlobalTheme) return {
        colorMode: $9d6dcd92ad05926a$var$testGlobalTheme
    };
    var element = document.documentElement;
    var colorMode = element.getAttribute('data-color-mode') || '';
    return {
        colorMode: colorMode
    };
};
var $9d6dcd92ad05926a$export$32f78bffcd82ff28 = (0, $P0RMo.textColor)({
    parseDOM: [
        {
            style: 'color',
            getAttrs: function getAttrs(maybeValue) {
                var value = maybeValue;
                var hexColor;
                if (value.match(/^rgb/i)) hexColor = (0, $22vaF.rgbToHex)(value);
                else if (value[0] === '#') hexColor = value.toLowerCase();
                // else handle other colour formats
                return hexColor && $9d6dcd92ad05926a$export$569885e57444f84a.has(hexColor) ? {
                    color: hexColor
                } : false;
            }
        },
        // This rule ensures when loading from a renderer or editor where the
        // presented text color does not match the stored hex color -- that the
        // text color is preserved.
        //
        // This was initially introduced to ensure text-color marks were not lost
        // when text-color was used inside a link, and is now also used to support
        // where the hex color stored in ADF is used as an ID for a design system
        // token (and based on theme mode -- the presented color will change).
        {
            tag: '.fabric-text-color-mark',
            getAttrs: function getAttrs(maybeElement) {
                if (!(maybeElement instanceof HTMLElement)) return false;
                var hexColor = maybeElement.dataset.textCustomColor;
                return hexColor && $9d6dcd92ad05926a$export$569885e57444f84a.has(hexColor) ? {
                    color: hexColor
                } : false;
            }
        }
    ],
    toDOM: function toDOM(mark) {
        var paletteColorValue;
        // Note -- while there is no way to create custom colors using default tooling
        // the editor does supported ad hoc color values -- and there may be content
        // which has been migrated or created via apis which use such values.
        /**
     * The Editor persists custom text colors when content has been migrated from the old editor, or created via
     * apis.
     *
     * This behaviour predates the introduction of dark mode.
     *
     * Without the inversion logic below, text with custom colors, can be hard to read when the user loads the page in dark mode.
     *
     * This introduces inversion of the presentation of the custom text colors when the user is in dark mode.
     *
     * This can be done without additional changes to account for users copying and pasting content inside the Editor, because of
     * how we detect text colors copied from external editor sources. Where we load the background color from a
     * seperate attribute (data-text-custom-color), instead of the inline style.
     *
     * See the following document for more details on this behaviour
     * https://hello.atlassian.net/wiki/spaces/CCECO/pages/2908658046/Unsupported+custom+text+colors+in+dark+theme+Editor+Job+Story
     */ var tokenColor = (0, $aE9eF.hexToEditorTextPaletteColor)(mark.attrs.color);
        if (tokenColor) paletteColorValue = tokenColor;
        else if ($9d6dcd92ad05926a$export$813ecdf77207a053().colorMode === 'dark') // if we have a custom color, we need to check if we are in dark mode
        paletteColorValue = (0, $gwjAb.getDarkModeLCHColor)(mark.attrs.color);
        else // if we are in light mode, we can just set the color
        paletteColorValue = mark.attrs.color;
        return [
            'span',
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({
                class: 'fabric-text-color-mark',
                // Editor common has a common style which uses this css variable as the value for
                // the color property using the `fabric-text-color-mark` selector applied above.
                style: "--custom-palette-color: ".concat(paletteColorValue)
            }, 'data-text-custom-color', mark.attrs.color)
        ];
    }
});

});


parcelRegister("5BptP", function(module, exports) {
$parcel$export(module.exports, "border", () => $41442c4148119198$export$1edee58a52776cd9);

var $iYJcE = parcelRequire("iYJcE");

var $P0RMo = parcelRequire("P0RMo");

var $aE9eF = parcelRequire("aE9eF");

var $22vaF = parcelRequire("22vaF");
/**
 * @name border_mark
 * @description This mark adds decoration to an element, and any element decorated with it will also have a border style.
 */ var $41442c4148119198$var$borderColorArrayPalette = [
    [
        (0, $22vaF.N300A),
        'Subtle gray'
    ],
    [
        (0, $22vaF.N600),
        'Gray'
    ],
    [
        (0, $22vaF.N1000),
        'Bold gray'
    ]
];
var $41442c4148119198$export$e4e044c989c86ca7 = new Map();
$41442c4148119198$var$borderColorArrayPalette.forEach(function(_ref) {
    var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_ref, 2), color = _ref2[0], label = _ref2[1];
    return $41442c4148119198$export$e4e044c989c86ca7.set(color.toLowerCase(), label);
});
var $41442c4148119198$export$1edee58a52776cd9 = (0, $P0RMo.border)({
    parseDOM: [
        {
            tag: '[data-mark-type="border"]',
            getAttrs: function getAttrs(domNode) {
                var _dom$getAttribute, _dom$getAttribute2;
                var dom = domNode;
                var color = ((_dom$getAttribute = dom.getAttribute('data-color')) !== null && _dom$getAttribute !== void 0 ? _dom$getAttribute : '').toLowerCase();
                var size = +((_dom$getAttribute2 = dom.getAttribute('data-size')) !== null && _dom$getAttribute2 !== void 0 ? _dom$getAttribute2 : '0');
                return {
                    size: size > 3 ? 3 : size < 1 ? false : size,
                    color: $41442c4148119198$export$e4e044c989c86ca7.has(color) ? color : false
                };
            }
        }
    ],
    toDOM: function toDOM(mark, isInline) {
        var wrapperStyle = isInline ? 'span' : 'div';
        // Note -- while there is no way to create custom colors using default tooling
        // the editor does supported ad hoc color values -- and there may be content
        // which has been migrated or created via apis which use such values.
        var paletteColorValue = (0, $aE9eF.hexToEditorBorderPaletteColor)(mark.attrs.color) || mark.attrs.color;
        return [
            wrapperStyle,
            {
                'data-mark-type': 'border',
                'data-color': mark.attrs.color,
                'data-size': mark.attrs.size,
                style: "--custom-palette-color: ".concat(paletteColorValue)
            }
        ];
    }
});

});

parcelRegister("66hh0", function(module, exports) {
$parcel$export(module.exports, "breakout", () => $4710b3b81a4d2e84$export$89015c65f1c75e3f);

var $P0RMo = parcelRequire("P0RMo");
var $4710b3b81a4d2e84$var$allowedTypes = [
    'wide',
    'full-width'
];
var $4710b3b81a4d2e84$export$89015c65f1c75e3f = (0, $P0RMo.breakout)({
    parseDOM: [
        {
            tag: 'div.fabric-editor-breakout-mark',
            getAttrs: function getAttrs(dom) {
                var mode = dom.getAttribute('data-mode');
                var width = dom.getAttribute('data-width');
                return {
                    mode: $4710b3b81a4d2e84$var$allowedTypes.indexOf(mode || '') === -1 ? 'wide' : mode,
                    width: width ? parseInt(width) : null
                };
            }
        }
    ],
    toDOM: function toDOM(mark) {
        var _mark$attrs;
        return [
            'div',
            {
                class: 'fabric-editor-breakout-mark',
                'data-mode': mark.attrs.mode,
                'data-width': (_mark$attrs = mark.attrs) === null || _mark$attrs === void 0 ? void 0 : _mark$attrs.width
            },
            0
        ];
    }
});

});

parcelRegister("iVDN9", function(module, exports) {
$parcel$export(module.exports, "code", () => $dc7c6aab74e1d800$export$6565f9f03506010b);

var $P0RMo = parcelRequire("P0RMo");
var $dc7c6aab74e1d800$export$6565f9f03506010b = (0, $P0RMo.code)({
    parseDOM: [
        {
            tag: 'span.code',
            preserveWhitespace: true
        },
        {
            tag: 'code',
            preserveWhitespace: true
        },
        {
            tag: 'tt',
            preserveWhitespace: true
        },
        {
            tag: 'span',
            preserveWhitespace: true,
            getAttrs: function getAttrs(domNode) {
                var dom = domNode;
                if (dom.style.whiteSpace === 'pre') return {};
                if (dom.style.fontFamily && dom.style.fontFamily.toLowerCase().indexOf('monospace') >= 0) return {};
                return false;
            }
        }
    ],
    toDOM: function toDOM() {
        return [
            'span',
            {
                class: 'code',
                spellcheck: 'false'
            }
        ];
    }
});

});

parcelRegister("31cn2", function(module, exports) {
$parcel$export(module.exports, "confluenceInlineComment", () => $232b0f9e963c91cf$export$f3b72f8fc4684ecd);

var $P0RMo = parcelRequire("P0RMo");
var $232b0f9e963c91cf$export$f3b72f8fc4684ecd = (0, $P0RMo.confluenceInlineComment)({
    parseDOM: [
        {
            tag: 'span[data-mark-type="confluenceInlineComment"]'
        }
    ],
    toDOM: function toDOM(node) {
        return [
            'span',
            {
                'data-mark-type': 'confluenceInlineComment',
                'data-reference': node.attrs.reference
            }
        ];
    }
});

});

parcelRegister("2InDy", function(module, exports) {
$parcel$export(module.exports, "dataConsumer", () => $1fa206a7f541cfd7$export$3024f02c495408d6);
$parcel$export(module.exports, "toJSON", () => $1fa206a7f541cfd7$export$54fd2c36b5cc6731);

var $25nEq = parcelRequire("25nEq");

var $P0RMo = parcelRequire("P0RMo");

var $fBYOr = parcelRequire("fBYOr");
function $1fa206a7f541cfd7$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $1fa206a7f541cfd7$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $1fa206a7f541cfd7$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $1fa206a7f541cfd7$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
/**
 * This annotation is purely for reference, & does _nothing_ given annotating
 * `minLength` on an array of strings is not supported with our schema+spec
 * generator.
 *
 * We're keeping it to signal that data consumer `sources` shouldn't be empty
 * strings
 *
 * // @minLength 1
 */ /**
 * @name dataConsumer_mark
 * @description This mark is used for metadata surrounding a node consuming data
 * from a given source node
 */ var $1fa206a7f541cfd7$var$parseDataConsumer = function parseDataConsumer(maybeValue) {
    var sources = (0, $fBYOr.isDOMElement)(maybeValue) && maybeValue.getAttribute('data-sources');
    try {
        return sources ? {
            sources: JSON.parse(sources)
        } : false;
    } catch (_unused) {
        return false;
    }
};
var $1fa206a7f541cfd7$export$3024f02c495408d6 = (0, $P0RMo.dataConsumer)({
    parseDOM: [
        {
            tag: '[data-mark-type="dataConsumer"]',
            getAttrs: function getAttrs(maybeValue) {
                return $1fa206a7f541cfd7$var$parseDataConsumer(maybeValue);
            }
        }
    ],
    toDOM: function toDOM(mark, inline) {
        var wrapperStyle = inline ? 'span' : 'div';
        return [
            wrapperStyle,
            {
                'data-mark-type': 'dataConsumer',
                'data-sources': JSON.stringify(mark.attrs.sources)
            }
        ];
    }
});
var $1fa206a7f541cfd7$export$54fd2c36b5cc6731 = function toJSON(mark) {
    // // Remove intemediary state if we don't have any sources on data consumer
    // if (mark.attrs?.sources?.length < 1) {
    //   return null;
    // }
    return {
        type: mark.type.name,
        attrs: Object.keys(mark.attrs).filter(function(key) {
            return key === 'sources' && mark.attrs[key].length > 0 && mark.attrs[key] !== null;
        }).reduce(function(acc, key) {
            return $1fa206a7f541cfd7$var$_objectSpread($1fa206a7f541cfd7$var$_objectSpread({}, acc), {}, (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, key, mark.attrs[key]));
        }, {})
    };
};

});
parcelRegister("fBYOr", function(module, exports) {
$parcel$export(module.exports, "isDOMElement", () => $b5d97bcd379dd54c$export$c296e2d4365c37a5);
var $b5d97bcd379dd54c$export$c296e2d4365c37a5 = function isDOMElement(maybeNode) {
    return maybeNode instanceof Node && maybeNode.nodeType === Node.ELEMENT_NODE;
};

});


parcelRegister("kVedW", function(module, exports) {
$parcel$export(module.exports, "em", () => $f3b42a1611ed0190$export$c63c6f932822f543);

var $P0RMo = parcelRequire("P0RMo");
/**
 * @name em_mark
 */ var $f3b42a1611ed0190$var$emDOM = [
    'em'
];
var $f3b42a1611ed0190$export$c63c6f932822f543 = (0, $P0RMo.em)({
    parseDOM: [
        {
            tag: 'i'
        },
        {
            tag: 'em'
        },
        {
            style: 'font-style=italic'
        }
    ],
    toDOM: function toDOM() {
        return $f3b42a1611ed0190$var$emDOM;
    }
});

});

parcelRegister("iDfRT", function(module, exports) {
$parcel$export(module.exports, "fragment", () => $d9082da3fca0d5e3$export$f00aeb236b6f05af);
$parcel$export(module.exports, "toJSON", () => $d9082da3fca0d5e3$export$54fd2c36b5cc6731);

var $25nEq = parcelRequire("25nEq");

var $P0RMo = parcelRequire("P0RMo");

var $fBYOr = parcelRequire("fBYOr");
function $d9082da3fca0d5e3$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $d9082da3fca0d5e3$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $d9082da3fca0d5e3$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $d9082da3fca0d5e3$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
/**
 * @name fragment_mark
 * @description Indicates that the elements decorated with this mark belong to a "fragment" entity, which represents a collection of ADF nodes.
 * This entity can be referred to later by its `localId` attribute.
 */ var $d9082da3fca0d5e3$var$parseFragment = function parseFragment(maybeValue) {
    var _maybeValue$getAttrib;
    if (!(0, $fBYOr.isDOMElement)(maybeValue)) return false;
    var name = (_maybeValue$getAttrib = maybeValue.getAttribute('data-name')) !== null && _maybeValue$getAttrib !== void 0 ? _maybeValue$getAttrib : undefined;
    var localId = maybeValue.getAttribute('data-localId');
    if (!localId) return false;
    return {
        localId: localId,
        name: name
    };
};
var $d9082da3fca0d5e3$export$f00aeb236b6f05af = (0, $P0RMo.fragment)({
    parseDOM: [
        {
            tag: '[data-mark-type="fragment"]',
            getAttrs: function getAttrs(maybeValue) {
                return $d9082da3fca0d5e3$var$parseFragment(maybeValue);
            }
        }
    ],
    toDOM: function toDOM(mark, inline) {
        var wrapperStyle = inline ? 'span' : 'div';
        return [
            wrapperStyle,
            {
                'data-mark-type': 'fragment',
                'data-name': mark.attrs.name,
                'data-localId': mark.attrs.localId
            }
        ];
    }
});
var $d9082da3fca0d5e3$export$54fd2c36b5cc6731 = function toJSON(mark) {
    return {
        type: mark.type.name,
        attrs: $d9082da3fca0d5e3$var$_objectSpread({
            localId: mark.attrs.localId
        }, mark.attrs.name ? {
            name: mark.attrs.name
        } : {})
    };
};

});

parcelRegister("13aOI", function(module, exports) {
$parcel$export(module.exports, "indentation", () => $0c3e7647fb8be3b4$export$480c699bd4ec0d86);

var $P0RMo = parcelRequire("P0RMo");
var $0c3e7647fb8be3b4$export$480c699bd4ec0d86 = (0, $P0RMo.indentation)({
    parseDOM: [
        {
            tag: 'div.fabric-editor-indentation-mark',
            getAttrs: function getAttrs(dom) {
                var level = +(dom.getAttribute('data-level') || '0');
                return {
                    level: level > 6 ? 6 : level < 1 ? false : level
                };
            }
        }
    ],
    toDOM: function toDOM(mark) {
        return [
            'div',
            {
                class: 'fabric-editor-block-mark fabric-editor-indentation-mark',
                'data-level': mark.attrs.level
            },
            0
        ];
    }
});

});

parcelRegister("5BE4e", function(module, exports) {
$parcel$export(module.exports, "link", () => $414f7cf8b289c32d$export$9c30223ca0a664fb);
$parcel$export(module.exports, "toJSON", () => $414f7cf8b289c32d$export$54fd2c36b5cc6731);

var $25nEq = parcelRequire("25nEq");

var $P0RMo = parcelRequire("P0RMo");

var $1hVTD = parcelRequire("1hVTD");
function $414f7cf8b289c32d$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $414f7cf8b289c32d$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $414f7cf8b289c32d$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $414f7cf8b289c32d$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $414f7cf8b289c32d$export$b5f67017585d1431 = function getLinkAttrs(attribute) {
    return function(domNode) {
        var dom = domNode;
        var href = dom.getAttribute(attribute) || '';
        var attrs = {
            __confluenceMetadata: dom.hasAttribute('__confluenceMetadata') ? JSON.parse(dom.getAttribute('__confluenceMetadata') || '') : undefined
        };
        if (!(0, $1hVTD.isSafeUrl)(href)) return false;
        if ((0, $1hVTD.isRootRelative)(href)) {
            attrs.href = href;
            return attrs;
        }
        attrs.href = (0, $1hVTD.normalizeUrl)(href);
        return attrs;
    };
};
var $414f7cf8b289c32d$export$9c30223ca0a664fb = (0, $P0RMo.link)({
    parseDOM: [
        {
            tag: '[data-block-link]',
            getAttrs: $414f7cf8b289c32d$export$b5f67017585d1431('data-block-link'),
            contentElement: function contentElement(node) {
                var clone = node.cloneNode(true);
                clone.removeAttribute('data-block-link');
                clone.setAttribute('data-skip-paste', 'true');
                var wrapper = document.createElement('div');
                wrapper.appendChild(clone);
                return wrapper;
            }
        },
        {
            tag: 'a[href]',
            getAttrs: $414f7cf8b289c32d$export$b5f67017585d1431('href')
        }
    ],
    toDOM: function toDOM(node, isInline) {
        var attrs = Object.keys(node.attrs).reduce(function(attrs, key) {
            if (key === '__confluenceMetadata') {
                if (node.attrs[key] !== null) attrs[key] = JSON.stringify(node.attrs[key]);
            } else if (key === 'href') attrs[key] = (0, $1hVTD.isSafeUrl)(node.attrs[key]) ? node.attrs[key] : undefined;
            else attrs[key] = node.attrs[key];
            return attrs;
        }, {});
        if (isInline) return [
            'a',
            attrs
        ];
        return [
            'a',
            $414f7cf8b289c32d$var$_objectSpread($414f7cf8b289c32d$var$_objectSpread({}, attrs), {}, (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, 'data-block-link', 'true'), "class", 'blockLink')),
            0
        ];
    }
});
var $414f7cf8b289c32d$var$OPTIONAL_ATTRS = [
    'title',
    'id',
    'collection',
    'occurrenceKey',
    '__confluenceMetadata'
];
var $414f7cf8b289c32d$export$54fd2c36b5cc6731 = function toJSON(mark) {
    return {
        type: mark.type.name,
        attrs: Object.keys(mark.attrs).reduce(function(attrs, key) {
            if ($414f7cf8b289c32d$var$OPTIONAL_ATTRS.indexOf(key) === -1 || mark.attrs[key] !== null) attrs[key] = mark.attrs[key];
            return attrs;
        }, {})
    };
};

});
parcelRegister("1hVTD", function(module, exports) {
$parcel$export(module.exports, "isSafeUrl", () => $0f0449fb62ebb7a2$export$c9f92f5469372e0f);
$parcel$export(module.exports, "normalizeUrl", () => $0f0449fb62ebb7a2$export$6535eb414fa2c8b6);
$parcel$export(module.exports, "isRootRelative", () => $0f0449fb62ebb7a2$export$23579274a7a24f7b);
/**
 * This file has been partially duplicated in packages/linking-platform/linking-common/src/url.ts
 * Any changes made here should be mirrored there.
 * Ticket for dedeplication: https://product-fabric.atlassian.net/browse/EDM-7138
 * Ticket for fixing linkification of filename-like urls: https://product-fabric.atlassian.net/browse/EDM-7190
 */ 
var $840z9 = parcelRequire("840z9");
var $0f0449fb62ebb7a2$var$whitelistedURLPatterns = [
    /^https?:\/\//im,
    /^ftps?:\/\//im,
    /^gopher:\/\//im,
    /^integrity:\/\//im,
    /^file:\/\//im,
    /^smb:\/\//im,
    /^dynamicsnav:\/\//im,
    /^jamfselfservice:\/\//im,
    /^\//im,
    /^mailto:/im,
    /^skype:/im,
    /^callto:/im,
    /^facetime:/im,
    /^git:/im,
    /^irc6?:/im,
    /^news:/im,
    /^nntp:/im,
    /^feed:/im,
    /^cvs:/im,
    /^svn:/im,
    /^mvn:/im,
    /^ssh:/im,
    /^scp:\/\//im,
    /^sftp:\/\//im,
    /^itms:/im,
    // This is not a valid notes link, but we support this pattern for backwards compatibility
    /^notes:/im,
    /^notes:\/\//im,
    /^hipchat:\/\//im,
    // This is not a valid sourcetree link, but we support this pattern for backwards compatibility
    /^sourcetree:/im,
    /^sourcetree:\/\//im,
    /^urn:/im,
    /^tel:/im,
    /^xmpp:/im,
    /^telnet:/im,
    /^vnc:/im,
    /^rdp:/im,
    /^whatsapp:/im,
    /^slack:/im,
    /^sips?:/im,
    /^magnet:/im,
    /^#/im
];
var $0f0449fb62ebb7a2$export$c9f92f5469372e0f = function isSafeUrl(url) {
    var urlTrimmed = url.trim();
    if (urlTrimmed.length === 0) return true;
    return $0f0449fb62ebb7a2$var$whitelistedURLPatterns.some(function(p) {
        return p.test(urlTrimmed);
    });
};
var $0f0449fb62ebb7a2$export$8ccbde94d5c7f8e7 = (0, $840z9.default)();
$0f0449fb62ebb7a2$export$8ccbde94d5c7f8e7.add('sourcetree:', 'http:');
$0f0449fb62ebb7a2$export$8ccbde94d5c7f8e7.add('jamfselfservice:', 'http:');
var $0f0449fb62ebb7a2$var$urlWithoutSpacesValidator = {
    validate: /[^\s]+/
};
// `tel:` URI spec is https://datatracker.ietf.org/doc/html/rfc3966
// We're not validating the phone number or separators - but if there's a space it definitely isn't a valid `tel:` URI
$0f0449fb62ebb7a2$export$8ccbde94d5c7f8e7.add('tel:', $0f0449fb62ebb7a2$var$urlWithoutSpacesValidator);
// https://datatracker.ietf.org/doc/html/rfc8089
$0f0449fb62ebb7a2$export$8ccbde94d5c7f8e7.add('file:', $0f0449fb62ebb7a2$var$urlWithoutSpacesValidator);
$0f0449fb62ebb7a2$export$8ccbde94d5c7f8e7.add('notes:', 'http:');
var $0f0449fb62ebb7a2$var$tlds = "biz|com|edu|gov|net|org|pro|web|xxx|aero|asia|coop|info|museum|name|shop|\u0440\u0444".split('|');
var $0f0449fb62ebb7a2$var$tlds2Char = 'a[cdefgilmnoqrtuwxz]|b[abdefghijmnorstvwyz]|c[acdfghiklmnoruvwxyz]|d[ejkmoz]|e[cegrstu]|f[ijkmor]|g[abdefghilmnpqrstuwy]|h[kmnrtu]|i[delmnoqrst]|j[emop]|k[eghimnprwyz]|l[abcikrstuvy]|m[acdeghklmnopqrtuvwxyz]|n[acefgilopruz]|om|p[aefghkmnrtw]|qa|r[eosuw]|s[abcdegijklmnrtuvxyz]|t[cdfghjklmnortvwz]|u[agksyz]|v[aceginu]|w[fs]|y[et]|z[amw]';
$0f0449fb62ebb7a2$var$tlds.push($0f0449fb62ebb7a2$var$tlds2Char);
$0f0449fb62ebb7a2$export$8ccbde94d5c7f8e7.tlds($0f0449fb62ebb7a2$var$tlds, false);
var $0f0449fb62ebb7a2$export$746d02eae03c72e1 = /(https?|ftp|jamfselfservice|gopher|dynamicsnav|integrity|file|smb):\/\/[^\s]+/;
var $0f0449fb62ebb7a2$export$6f7d7761b97f967 = function linkifyMatch(text) {
    if (!$0f0449fb62ebb7a2$export$746d02eae03c72e1.test(text)) return [];
    var matches = [];
    var startpos = 0;
    var substr;
    while(substr = text.substr(startpos)){
        var link = (substr.match($0f0449fb62ebb7a2$export$746d02eae03c72e1) || [
            ''
        ])[0];
        if (link) {
            var index = substr.search($0f0449fb62ebb7a2$export$746d02eae03c72e1);
            var start = index >= 0 ? index + startpos : index;
            var end = start + link.length;
            matches.push({
                index: start,
                lastIndex: end,
                raw: link,
                url: link,
                text: link,
                schema: ''
            });
            startpos += end;
        } else break;
    }
    return matches;
};
function $0f0449fb62ebb7a2$export$ce9ae45aed3e4ec(str) {
    if (!str) return null;
    // linkify-it mishandles closing braces on long urls, so we preference using our own regex first:
    // https://product-fabric.atlassian.net/browse/ED-13669
    var match = $0f0449fb62ebb7a2$export$6f7d7761b97f967(str);
    if (!match.length) match = $0f0449fb62ebb7a2$export$8ccbde94d5c7f8e7.match(str);
    return match && match[0];
}
function $0f0449fb62ebb7a2$export$6535eb414fa2c8b6(url) {
    var match = $0f0449fb62ebb7a2$export$ce9ae45aed3e4ec(url);
    return match && match.url || '';
}
function $0f0449fb62ebb7a2$export$23579274a7a24f7b(url) {
    // Support `#top` and `#` special references as per:
    // https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#linking_to_an_element_on_the_same_page
    return url.startsWith('/') || url === '#top' || url === '#';
}

});
parcelRegister("840z9", function(module, exports) {
$parcel$export(module.exports, "default", () => $5def22d34403614b$export$2e2bcd8739ae039);

var $aOi1C = parcelRequire("aOi1C");
//
// Helpers
//
// Merge objects
//
function $5def22d34403614b$var$assign(obj /* from1, from2, from3, ... */ ) {
    const sources = Array.prototype.slice.call(arguments, 1);
    sources.forEach(function(source) {
        if (!source) return;
        Object.keys(source).forEach(function(key) {
            obj[key] = source[key];
        });
    });
    return obj;
}
function $5def22d34403614b$var$_class(obj) {
    return Object.prototype.toString.call(obj);
}
function $5def22d34403614b$var$isString(obj) {
    return $5def22d34403614b$var$_class(obj) === '[object String]';
}
function $5def22d34403614b$var$isObject(obj) {
    return $5def22d34403614b$var$_class(obj) === '[object Object]';
}
function $5def22d34403614b$var$isRegExp(obj) {
    return $5def22d34403614b$var$_class(obj) === '[object RegExp]';
}
function $5def22d34403614b$var$isFunction(obj) {
    return $5def22d34403614b$var$_class(obj) === '[object Function]';
}
function $5def22d34403614b$var$escapeRE(str) {
    return str.replace(/[.?*+^$[\]\\(){}|-]/g, '\\$&');
}
//
const $5def22d34403614b$var$defaultOptions = {
    fuzzyLink: true,
    fuzzyEmail: true,
    fuzzyIP: false
};
function $5def22d34403614b$var$isOptionsObj(obj) {
    return Object.keys(obj || {}).reduce(function(acc, k) {
        /* eslint-disable-next-line no-prototype-builtins */ return acc || $5def22d34403614b$var$defaultOptions.hasOwnProperty(k);
    }, false);
}
const $5def22d34403614b$var$defaultSchemas = {
    'http:': {
        validate: function(text, pos, self) {
            const tail = text.slice(pos);
            if (!self.re.http) // compile lazily, because "host"-containing variables can change on tlds update.
            self.re.http = new RegExp(`^\\/\\/${self.re.src_auth}${self.re.src_host_port_strict}${self.re.src_path}`, 'i');
            if (self.re.http.test(tail)) return tail.match(self.re.http)[0].length;
            return 0;
        }
    },
    'https:': 'http:',
    'ftp:': 'http:',
    '//': {
        validate: function(text, pos, self) {
            const tail = text.slice(pos);
            if (!self.re.no_http) // compile lazily, because "host"-containing variables can change on tlds update.
            self.re.no_http = new RegExp('^' + self.re.src_auth + // Don't allow single-level domains, because of false positives like '//test'
            // with code comments
            `(?:localhost|(?:(?:${self.re.src_domain})\\.)+${self.re.src_domain_root})` + self.re.src_port + self.re.src_host_terminator + self.re.src_path, 'i');
            if (self.re.no_http.test(tail)) {
                // should not be `://` & `///`, that protects from errors in protocol name
                if (pos >= 3 && text[pos - 3] === ':') return 0;
                if (pos >= 3 && text[pos - 3] === '/') return 0;
                return tail.match(self.re.no_http)[0].length;
            }
            return 0;
        }
    },
    'mailto:': {
        validate: function(text, pos, self) {
            const tail = text.slice(pos);
            if (!self.re.mailto) self.re.mailto = new RegExp(`^${self.re.src_email_name}@${self.re.src_host_strict}`, 'i');
            if (self.re.mailto.test(tail)) return tail.match(self.re.mailto)[0].length;
            return 0;
        }
    }
};
// RE pattern for 2-character tlds (autogenerated by ./support/tlds_2char_gen.js)
const $5def22d34403614b$var$tlds_2ch_src_re = 'a[cdefgilmnoqrstuwxz]|b[abdefghijmnorstvwyz]|c[acdfghiklmnoruvwxyz]|d[ejkmoz]|e[cegrstu]|f[ijkmor]|g[abdefghilmnpqrstuwy]|h[kmnrtu]|i[delmnoqrst]|j[emop]|k[eghimnprwyz]|l[abcikrstuvy]|m[acdeghklmnopqrstuvwxyz]|n[acefgilopruz]|om|p[aefghklmnrstwy]|qa|r[eosuw]|s[abcdeghijklmnortuvxyz]|t[cdfghjklmnortvwz]|u[agksyz]|v[aceginu]|w[fs]|y[et]|z[amw]';
// DON'T try to make PRs with changes. Extend TLDs with LinkifyIt.tlds() instead
const $5def22d34403614b$var$tlds_default = "biz|com|edu|gov|net|org|pro|web|xxx|aero|asia|coop|info|museum|name|shop|\u0440\u0444".split('|');
function $5def22d34403614b$var$createValidator(re) {
    return function(text, pos) {
        const tail = text.slice(pos);
        if (re.test(tail)) return tail.match(re)[0].length;
        return 0;
    };
}
function $5def22d34403614b$var$createNormalizer() {
    return function(match, self) {
        self.normalize(match);
    };
}
// Schemas compiler. Build regexps.
//
function $5def22d34403614b$var$compile(self) {
    // Load & clone RE patterns.
    const re = self.re = (0, $aOi1C.default)(self.__opts__);
    // Define dynamic patterns
    const tlds = self.__tlds__.slice();
    self.onCompile();
    if (!self.__tlds_replaced__) tlds.push($5def22d34403614b$var$tlds_2ch_src_re);
    tlds.push(re.src_xn);
    re.src_tlds = tlds.join('|');
    function untpl(tpl) {
        return tpl.replace('%TLDS%', re.src_tlds);
    }
    re.email_fuzzy = RegExp(untpl(re.tpl_email_fuzzy), 'i');
    re.email_fuzzy_global = RegExp(untpl(re.tpl_email_fuzzy), 'ig');
    re.link_fuzzy = RegExp(untpl(re.tpl_link_fuzzy), 'i');
    re.link_fuzzy_global = RegExp(untpl(re.tpl_link_fuzzy), 'ig');
    re.link_no_ip_fuzzy = RegExp(untpl(re.tpl_link_no_ip_fuzzy), 'i');
    re.link_no_ip_fuzzy_global = RegExp(untpl(re.tpl_link_no_ip_fuzzy), 'ig');
    re.host_fuzzy_test = RegExp(untpl(re.tpl_host_fuzzy_test), 'i');
    //
    // Compile each schema
    //
    const aliases = [];
    self.__compiled__ = {} // Reset compiled data
    ;
    function schemaError(name, val) {
        throw new Error(`(LinkifyIt) Invalid schema "${name}": ${val}`);
    }
    Object.keys(self.__schemas__).forEach(function(name) {
        const val = self.__schemas__[name];
        // skip disabled methods
        if (val === null) return;
        const compiled = {
            validate: null,
            link: null
        };
        self.__compiled__[name] = compiled;
        if ($5def22d34403614b$var$isObject(val)) {
            if ($5def22d34403614b$var$isRegExp(val.validate)) compiled.validate = $5def22d34403614b$var$createValidator(val.validate);
            else if ($5def22d34403614b$var$isFunction(val.validate)) compiled.validate = val.validate;
            else schemaError(name, val);
            if ($5def22d34403614b$var$isFunction(val.normalize)) compiled.normalize = val.normalize;
            else if (!val.normalize) compiled.normalize = $5def22d34403614b$var$createNormalizer();
            else schemaError(name, val);
            return;
        }
        if ($5def22d34403614b$var$isString(val)) {
            aliases.push(name);
            return;
        }
        schemaError(name, val);
    });
    //
    // Compile postponed aliases
    //
    aliases.forEach(function(alias) {
        if (!self.__compiled__[self.__schemas__[alias]]) // Silently fail on missed schemas to avoid errons on disable.
        // schemaError(alias, self.__schemas__[alias]);
        return;
        self.__compiled__[alias].validate = self.__compiled__[self.__schemas__[alias]].validate;
        self.__compiled__[alias].normalize = self.__compiled__[self.__schemas__[alias]].normalize;
    });
    //
    // Fake record for guessed links
    //
    self.__compiled__[''] = {
        validate: null,
        normalize: $5def22d34403614b$var$createNormalizer()
    };
    //
    // Build schema condition
    //
    const slist = Object.keys(self.__compiled__).filter(function(name) {
        // Filter disabled & fake schemas
        return name.length > 0 && self.__compiled__[name];
    }).map($5def22d34403614b$var$escapeRE).join('|');
    // (?!_) cause 1.5x slowdown
    self.re.schema_test = RegExp(`(^|(?!_)(?:[><\uff5c]|${re.src_ZPCc}))(${slist})`, 'i');
    self.re.schema_search = RegExp(`(^|(?!_)(?:[><\uff5c]|${re.src_ZPCc}))(${slist})`, 'ig');
    self.re.schema_at_start = RegExp(`^${self.re.schema_search.source}`, 'i');
    self.re.pretest = RegExp(`(${self.re.schema_test.source})|(${self.re.host_fuzzy_test.source})|@`, 'i');
}
/**
 * class Match
 *
 * Match result. Single element of array, returned by [[LinkifyIt#match]]
 **/ function $5def22d34403614b$var$Match(text, schema, index, lastIndex) {
    const raw = text.slice(index, lastIndex);
    /**
   * Match#schema -> String
   *
   * Prefix (protocol) for matched string.
   **/ this.schema = schema.toLowerCase();
    /**
   * Match#index -> Number
   *
   * First position of matched string.
   **/ this.index = index;
    /**
   * Match#lastIndex -> Number
   *
   * Next position after matched string.
   **/ this.lastIndex = lastIndex;
    /**
   * Match#raw -> String
   *
   * Matched string.
   **/ this.raw = raw;
    /**
   * Match#text -> String
   *
   * Notmalized text of matched string.
   **/ this.text = raw;
    /**
   * Match#url -> String
   *
   * Normalized url of matched string.
   **/ this.url = raw;
}
/**
 * class LinkifyIt
 **/ /**
 * new LinkifyIt(schemas, options)
 * - schemas (Object): Optional. Additional schemas to validate (prefix/validator)
 * - options (Object): { fuzzyLink|fuzzyEmail|fuzzyIP: true|false }
 *
 * Creates new linkifier instance with optional additional schemas.
 * Can be called without `new` keyword for convenience.
 *
 * By default understands:
 *
 * - `http(s)://...` , `ftp://...`, `mailto:...` & `//...` links
 * - "fuzzy" links and emails (example.com, foo@bar.com).
 *
 * `schemas` is an object, where each key/value describes protocol/rule:
 *
 * - __key__ - link prefix (usually, protocol name with `:` at the end, `skype:`
 *   for example). `linkify-it` makes shure that prefix is not preceeded with
 *   alphanumeric char and symbols. Only whitespaces and punctuation allowed.
 * - __value__ - rule to check tail after link prefix
 *   - _String_ - just alias to existing rule
 *   - _Object_
 *     - _validate_ - validator function (should return matched length on success),
 *       or `RegExp`.
 *     - _normalize_ - optional function to normalize text & url of matched result
 *       (for example, for @twitter mentions).
 *
 * `options`:
 *
 * - __fuzzyLink__ - recognige URL-s without `http(s):` prefix. Default `true`.
 * - __fuzzyIP__ - allow IPs in fuzzy links above. Can conflict with some texts
 *   like version numbers. Default `false`.
 * - __fuzzyEmail__ - recognize emails without `mailto:` prefix.
 *
 **/ function $5def22d34403614b$var$LinkifyIt(schemas, options) {
    if (!(this instanceof $5def22d34403614b$var$LinkifyIt)) return new $5def22d34403614b$var$LinkifyIt(schemas, options);
    if (!options) {
        if ($5def22d34403614b$var$isOptionsObj(schemas)) {
            options = schemas;
            schemas = {};
        }
    }
    this.__opts__ = $5def22d34403614b$var$assign({}, $5def22d34403614b$var$defaultOptions, options);
    this.__schemas__ = $5def22d34403614b$var$assign({}, $5def22d34403614b$var$defaultSchemas, schemas);
    this.__compiled__ = {};
    this.__tlds__ = $5def22d34403614b$var$tlds_default;
    this.__tlds_replaced__ = false;
    this.re = {};
    $5def22d34403614b$var$compile(this);
}
/** chainable
 * LinkifyIt#add(schema, definition)
 * - schema (String): rule name (fixed pattern prefix)
 * - definition (String|RegExp|Object): schema definition
 *
 * Add new rule definition. See constructor description for details.
 **/ $5def22d34403614b$var$LinkifyIt.prototype.add = function add(schema, definition) {
    this.__schemas__[schema] = definition;
    $5def22d34403614b$var$compile(this);
    return this;
};
/** chainable
 * LinkifyIt#set(options)
 * - options (Object): { fuzzyLink|fuzzyEmail|fuzzyIP: true|false }
 *
 * Set recognition options for links without schema.
 **/ $5def22d34403614b$var$LinkifyIt.prototype.set = function set(options) {
    this.__opts__ = $5def22d34403614b$var$assign(this.__opts__, options);
    return this;
};
/**
 * LinkifyIt#test(text) -> Boolean
 *
 * Searches linkifiable pattern and returns `true` on success or `false` on fail.
 **/ $5def22d34403614b$var$LinkifyIt.prototype.test = function test(text) {
    if (!text.length) return false;
    let m, re;
    // try to scan for link with schema - that's the most simple rule
    if (this.re.schema_test.test(text)) {
        re = this.re.schema_search;
        re.lastIndex = 0;
        while((m = re.exec(text)) !== null){
            if (this.testSchemaAt(text, m[2], re.lastIndex)) return true;
        }
    }
    if (this.__opts__.fuzzyLink && this.__compiled__['http:']) // guess schemaless links
    {
        if (text.search(this.re.host_fuzzy_test) >= 0) {
            if (text.match(this.__opts__.fuzzyIP ? this.re.link_fuzzy : this.re.link_no_ip_fuzzy) !== null) return true;
        }
    }
    if (this.__opts__.fuzzyEmail && this.__compiled__['mailto:']) // guess schemaless emails
    {
        if (text.indexOf('@') >= 0) {
            // We can't skip this check, because this cases are possible:
            // 192.168.1.1@gmail.com, my.in@example.com
            if (text.match(this.re.email_fuzzy) !== null) return true;
        }
    }
    return false;
};
/**
 * LinkifyIt#pretest(text) -> Boolean
 *
 * Very quick check, that can give false positives. Returns true if link MAY BE
 * can exists. Can be used for speed optimization, when you need to check that
 * link NOT exists.
 **/ $5def22d34403614b$var$LinkifyIt.prototype.pretest = function pretest(text) {
    return this.re.pretest.test(text);
};
/**
 * LinkifyIt#testSchemaAt(text, name, position) -> Number
 * - text (String): text to scan
 * - name (String): rule (schema) name
 * - position (Number): text offset to check from
 *
 * Similar to [[LinkifyIt#test]] but checks only specific protocol tail exactly
 * at given position. Returns length of found pattern (0 on fail).
 **/ $5def22d34403614b$var$LinkifyIt.prototype.testSchemaAt = function testSchemaAt(text, schema, pos) {
    // If not supported schema check requested - terminate
    if (!this.__compiled__[schema.toLowerCase()]) return 0;
    return this.__compiled__[schema.toLowerCase()].validate(text, pos, this);
};
/**
 * LinkifyIt#match(text) -> Array|null
 *
 * Returns array of found link descriptions or `null` on fail. We strongly
 * recommend to use [[LinkifyIt#test]] first, for best speed.
 *
 * ##### Result match description
 *
 * - __schema__ - link schema, can be empty for fuzzy links, or `//` for
 *   protocol-neutral  links.
 * - __index__ - offset of matched text
 * - __lastIndex__ - index of next char after mathch end
 * - __raw__ - matched text
 * - __text__ - normalized text
 * - __url__ - link, generated from matched text
 **/ $5def22d34403614b$var$LinkifyIt.prototype.match = function match(text) {
    const result = [];
    const type_schemed = [];
    const type_fuzzy_link = [];
    const type_fuzzy_email = [];
    let m, len, re;
    function choose(a, b) {
        if (!a) return b;
        if (!b) return a;
        if (a.index !== b.index) return a.index < b.index ? a : b;
        return a.lastIndex >= b.lastIndex ? a : b;
    }
    if (!text.length) return null;
    // scan for links with schema
    if (this.re.schema_test.test(text)) {
        re = this.re.schema_search;
        re.lastIndex = 0;
        while((m = re.exec(text)) !== null){
            len = this.testSchemaAt(text, m[2], re.lastIndex);
            if (len) type_schemed.push({
                schema: m[2],
                index: m.index + m[1].length,
                lastIndex: m.index + m[0].length + len
            });
        }
    }
    if (this.__opts__.fuzzyLink && this.__compiled__['http:']) {
        re = this.__opts__.fuzzyIP ? this.re.link_fuzzy_global : this.re.link_no_ip_fuzzy_global;
        re.lastIndex = 0;
        while((m = re.exec(text)) !== null)type_fuzzy_link.push({
            schema: '',
            index: m.index + m[1].length,
            lastIndex: m.index + m[0].length
        });
    }
    if (this.__opts__.fuzzyEmail && this.__compiled__['mailto:']) {
        re = this.re.email_fuzzy_global;
        re.lastIndex = 0;
        while((m = re.exec(text)) !== null)type_fuzzy_email.push({
            schema: 'mailto:',
            index: m.index + m[1].length,
            lastIndex: m.index + m[0].length
        });
    }
    const indexes = [
        0,
        0,
        0
    ];
    let lastIndex = 0;
    for(;;){
        const candidates = [
            type_schemed[indexes[0]],
            type_fuzzy_email[indexes[1]],
            type_fuzzy_link[indexes[2]]
        ];
        const candidate = choose(choose(candidates[0], candidates[1]), candidates[2]);
        if (!candidate) break;
        if (candidate === candidates[0]) indexes[0]++;
        else if (candidate === candidates[1]) indexes[1]++;
        else indexes[2]++;
        if (candidate.index < lastIndex) continue;
        const match = new $5def22d34403614b$var$Match(text, candidate.schema, candidate.index, candidate.lastIndex);
        this.__compiled__[match.schema].normalize(match, this);
        result.push(match);
        lastIndex = candidate.lastIndex;
    }
    if (result.length) return result;
    return null;
};
/**
 * LinkifyIt#matchAtStart(text) -> Match|null
 *
 * Returns fully-formed (not fuzzy) link if it starts at the beginning
 * of the string, and null otherwise.
 **/ $5def22d34403614b$var$LinkifyIt.prototype.matchAtStart = function matchAtStart(text) {
    if (!text.length) return null;
    const m = this.re.schema_at_start.exec(text);
    if (!m) return null;
    const len = this.testSchemaAt(text, m[2], m[0].length);
    if (!len) return null;
    const match = new $5def22d34403614b$var$Match(text, m[2], m.index + m[1].length, m.index + m[0].length + len);
    this.__compiled__[match.schema].normalize(match, this);
    return match;
};
/** chainable
 * LinkifyIt#tlds(list [, keepOld]) -> this
 * - list (Array): list of tlds
 * - keepOld (Boolean): merge with current list if `true` (`false` by default)
 *
 * Load (or merge) new tlds list. Those are user for fuzzy links (without prefix)
 * to avoid false positives. By default this algorythm used:
 *
 * - hostname with any 2-letter root zones are ok.
 * - biz|com|edu|gov|net|org|pro|web|xxx|aero|asia|coop|info|museum|name|shop|рф
 *   are ok.
 * - encoded (`xn--...`) root zones are ok.
 *
 * If list is replaced, then exact match for 2-chars root zones will be checked.
 **/ $5def22d34403614b$var$LinkifyIt.prototype.tlds = function tlds(list, keepOld) {
    list = Array.isArray(list) ? list : [
        list
    ];
    if (!keepOld) {
        this.__tlds__ = list.slice();
        this.__tlds_replaced__ = true;
        $5def22d34403614b$var$compile(this);
        return this;
    }
    this.__tlds__ = this.__tlds__.concat(list).sort().filter(function(el, idx, arr) {
        return el !== arr[idx - 1];
    }).reverse();
    $5def22d34403614b$var$compile(this);
    return this;
};
/**
 * LinkifyIt#normalize(match)
 *
 * Default normalizer (if schema does not define it's own).
 **/ $5def22d34403614b$var$LinkifyIt.prototype.normalize = function normalize(match) {
    // Do minimal possible changes by default. Need to collect feedback prior
    // to move forward https://github.com/markdown-it/linkify-it/issues/1
    if (!match.schema) match.url = `http://${match.url}`;
    if (match.schema === 'mailto:' && !/^mailto:/i.test(match.url)) match.url = `mailto:${match.url}`;
};
/**
 * LinkifyIt#onCompile()
 *
 * Override to modify basic RegExp-s.
 **/ $5def22d34403614b$var$LinkifyIt.prototype.onCompile = function onCompile() {};
var $5def22d34403614b$export$2e2bcd8739ae039 = $5def22d34403614b$var$LinkifyIt;

});
parcelRegister("aOi1C", function(module, exports) {
$parcel$export(module.exports, "default", () => $7dec8e54d5239c8f$export$2e2bcd8739ae039);
parcelRequire("aNtO2");
var $9pzVw = parcelRequire("9pzVw");
var $fUT3l = parcelRequire("fUT3l");
var $8BybH = parcelRequire("8BybH");
var $5g06v = parcelRequire("5g06v");
function $7dec8e54d5239c8f$export$2e2bcd8739ae039(opts) {
    const re = {};
    opts = opts || {};
    re.src_Any = (0, $9pzVw.default).source;
    re.src_Cc = (0, $fUT3l.default).source;
    re.src_Z = (0, $5g06v.default).source;
    re.src_P = (0, $8BybH.default).source;
    // \p{\Z\P\Cc\CF} (white spaces + control + format + punctuation)
    re.src_ZPCc = [
        re.src_Z,
        re.src_P,
        re.src_Cc
    ].join('|');
    // \p{\Z\Cc} (white spaces + control)
    re.src_ZCc = [
        re.src_Z,
        re.src_Cc
    ].join('|');
    // Experimental. List of chars, completely prohibited in links
    // because can separate it from other part of text
    const text_separators = '[><\uff5c]';
    // All possible word characters (everything without punctuation, spaces & controls)
    // Defined via punctuation & spaces to save space
    // Should be something like \p{\L\N\S\M} (\w but without `_`)
    re.src_pseudo_letter = `(?:(?!${text_separators}|${re.src_ZPCc})${re.src_Any})`;
    // The same as abothe but without [0-9]
    // var src_pseudo_letter_non_d = '(?:(?![0-9]|' + src_ZPCc + ')' + src_Any + ')';
    re.src_ip4 = '(?:(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\\.){3}(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)';
    // Prohibit any of "@/[]()" in user/pass to avoid wrong domain fetch.
    // Length is capped to exclude possible rescans till the end and avoid O(n^2)
    // DoS. No standard limit, just take something reasonable.
    re.src_auth = `(?:(?:(?!${re.src_ZCc}|[@/\\[\\]()]).){1,50}@)?`;
    re.src_port = '(?::(?:6(?:[0-4]\\d{3}|5(?:[0-4]\\d{2}|5(?:[0-2]\\d|3[0-5])))|[1-5]?\\d{1,4}))?';
    re.src_host_terminator = `(?=$|${text_separators}|${re.src_ZPCc})` + `(?!${opts['---'] ? '-(?!--)|' : '-|'}_|:\\d|\\.-|\\.(?!$|${re.src_ZPCc}))`;
    re.src_path = "(?:[/?#](?:" + `(?!${re.src_ZCc}|${text_separators}|[()[\\]{}.,"'?!\\-;]).|` + `\\[(?:(?!${re.src_ZCc}|\\]).)*\\]|` + `\\((?:(?!${re.src_ZCc}|[)]).)*\\)|` + `\\{(?:(?!${re.src_ZCc}|[}]).)*\\}|` + `\\"(?:(?!${re.src_ZCc}|["]).)+\\"|` + `\\'(?:(?!${re.src_ZCc}|[']).)+\\'|` + // allow `I'm_king` if no pair found
    `\\'(?=${re.src_pseudo_letter}|[-])|` + // google has many dots in "google search" links (#66, #81).
    // github has ... in commit range links,
    // Restrict to
    // - english
    // - percent-encoded
    // - parts of file path
    // - params separator
    // until more examples found.
    '\\.{2,}[a-zA-Z0-9%/&]|' + `\\.(?!${re.src_ZCc}|[.]|$)|` + (opts['---'] ? '\\-(?!--(?:[^-]|$))(?:-*)|' // `---` => long dash, terminate
     : '\\-+|') + // allow `,,,` in paths
    `,(?!${re.src_ZCc}|$)|` + // allow `;` if not followed by space-like char
    `;(?!${re.src_ZCc}|$)|` + // allow `!!!` in paths, but not at the end
    `\\!+(?!${re.src_ZCc}|[!]|$)|` + `\\?(?!${re.src_ZCc}|[?]|$)` + ')+' + '|\\/' + ')?';
    // Allow anything in markdown spec, forbid quote (") at the first position
    // because emails enclosed in quotes are far more common
    // Max name length capped to 64 chars (RFC 5321). This also prevents O(n^2)
    // rescans to the end on inputs like `mailto:mailto:...`
    re.src_email_name = '[\\-;:&=\\+\\$,\\.a-zA-Z0-9_][\\-;:&=\\+\\$,\\"\\.a-zA-Z0-9_]{0,63}';
    re.src_xn = 'xn--[a-z0-9\\-]{1,59}';
    // More to read about domain names
    // http://serverfault.com/questions/638260/
    re.src_domain_root = // Allow letters & digits (http://test1)
    '(?:' + re.src_xn + '|' + `${re.src_pseudo_letter}{1,63}` + ')';
    re.src_domain = '(?:' + re.src_xn + '|' + `(?:${re.src_pseudo_letter})` + '|' + `(?:${re.src_pseudo_letter}(?:-|${re.src_pseudo_letter}){0,61}${re.src_pseudo_letter})` + ')';
    re.src_host = '(?:' + // Don't need IP check, because digits are already allowed in normal domain names
    //   src_ip4 +
    // '|' +
    `(?:(?:(?:${re.src_domain})\\.)*${re.src_domain})` + ')';
    re.tpl_host_fuzzy = '(?:' + re.src_ip4 + '|' + `(?:(?:(?:${re.src_domain})\\.)+(?:%TLDS%))` + ')';
    re.tpl_host_no_ip_fuzzy = `(?:(?:(?:${re.src_domain})\\.)+(?:%TLDS%))`;
    re.src_host_strict = re.src_host + re.src_host_terminator;
    re.tpl_host_fuzzy_strict = re.tpl_host_fuzzy + re.src_host_terminator;
    re.src_host_port_strict = re.src_host + re.src_port + re.src_host_terminator;
    re.tpl_host_port_fuzzy_strict = re.tpl_host_fuzzy + re.src_port + re.src_host_terminator;
    re.tpl_host_port_no_ip_fuzzy_strict = re.tpl_host_no_ip_fuzzy + re.src_port + re.src_host_terminator;
    //
    // Main rules
    //
    // Rude test fuzzy links by host, for quick deny
    re.tpl_host_fuzzy_test = `localhost|www\\.|\\.\\d{1,3}\\.|(?:\\.(?:%TLDS%)(?:${re.src_ZPCc}|>|$))`;
    re.tpl_email_fuzzy = `(^|${text_separators}|"|\\(|${re.src_ZCc})` + `(${re.src_email_name}@${re.tpl_host_fuzzy_strict})`;
    re.tpl_link_fuzzy = // Fuzzy link can't be prepended with .:/\- and non punctuation.
    // but can start with > (markdown blockquote)
    `(^|(?![.:/\\-_@])(?:[$+<=>^\`|\uff5c]|${re.src_ZPCc}))` + `((?![$+<=>^\`|\uff5c])${re.tpl_host_port_fuzzy_strict}${re.src_path})`;
    re.tpl_link_no_ip_fuzzy = // Fuzzy link can't be prepended with .:/\- and non punctuation.
    // but can start with > (markdown blockquote)
    `(^|(?![.:/\\-_@])(?:[$+<=>^\`|\uff5c]|${re.src_ZPCc}))` + `((?![$+<=>^\`|\uff5c])${re.tpl_host_port_no_ip_fuzzy_strict}${re.src_path})`;
    return re;
}

});
parcelRegister("aNtO2", function(module, exports) {
$parcel$export(module.exports, "Any", () => (parcelRequire("9pzVw")).default);
$parcel$export(module.exports, "Cc", () => (parcelRequire("fUT3l")).default);
$parcel$export(module.exports, "P", () => (parcelRequire("8BybH")).default);
$parcel$export(module.exports, "Z", () => (parcelRequire("5g06v")).default);

var $9pzVw = parcelRequire("9pzVw");

var $fUT3l = parcelRequire("fUT3l");

var $cIyAb = parcelRequire("cIyAb");

var $8BybH = parcelRequire("8BybH");

var $g80XX = parcelRequire("g80XX");

var $5g06v = parcelRequire("5g06v");

});
parcelRegister("9pzVw", function(module, exports) {
$parcel$export(module.exports, "default", () => $6da25128b08992af$export$2e2bcd8739ae039);
var $6da25128b08992af$export$2e2bcd8739ae039 = /[\0-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF]/;

});

parcelRegister("fUT3l", function(module, exports) {
$parcel$export(module.exports, "default", () => $b966ca5700a5fee1$export$2e2bcd8739ae039);
var $b966ca5700a5fee1$export$2e2bcd8739ae039 = /[\0-\x1F\x7F-\x9F]/;

});

parcelRegister("cIyAb", function(module, exports) {
var $94246b7671df4eee$export$2e2bcd8739ae039 = /[\xAD\u0600-\u0605\u061C\u06DD\u070F\u0890\u0891\u08E2\u180E\u200B-\u200F\u202A-\u202E\u2060-\u2064\u2066-\u206F\uFEFF\uFFF9-\uFFFB]|\uD804[\uDCBD\uDCCD]|\uD80D[\uDC30-\uDC3F]|\uD82F[\uDCA0-\uDCA3]|\uD834[\uDD73-\uDD7A]|\uDB40[\uDC01\uDC20-\uDC7F]/;

});

parcelRegister("8BybH", function(module, exports) {
$parcel$export(module.exports, "default", () => $643c4c64aeb0c9a2$export$2e2bcd8739ae039);
var $643c4c64aeb0c9a2$export$2e2bcd8739ae039 = /[!-#%-\*,-\/:;\?@\[-\]_\{\}\xA1\xA7\xAB\xB6\xB7\xBB\xBF\u037E\u0387\u055A-\u055F\u0589\u058A\u05BE\u05C0\u05C3\u05C6\u05F3\u05F4\u0609\u060A\u060C\u060D\u061B\u061D-\u061F\u066A-\u066D\u06D4\u0700-\u070D\u07F7-\u07F9\u0830-\u083E\u085E\u0964\u0965\u0970\u09FD\u0A76\u0AF0\u0C77\u0C84\u0DF4\u0E4F\u0E5A\u0E5B\u0F04-\u0F12\u0F14\u0F3A-\u0F3D\u0F85\u0FD0-\u0FD4\u0FD9\u0FDA\u104A-\u104F\u10FB\u1360-\u1368\u1400\u166E\u169B\u169C\u16EB-\u16ED\u1735\u1736\u17D4-\u17D6\u17D8-\u17DA\u1800-\u180A\u1944\u1945\u1A1E\u1A1F\u1AA0-\u1AA6\u1AA8-\u1AAD\u1B5A-\u1B60\u1B7D\u1B7E\u1BFC-\u1BFF\u1C3B-\u1C3F\u1C7E\u1C7F\u1CC0-\u1CC7\u1CD3\u2010-\u2027\u2030-\u2043\u2045-\u2051\u2053-\u205E\u207D\u207E\u208D\u208E\u2308-\u230B\u2329\u232A\u2768-\u2775\u27C5\u27C6\u27E6-\u27EF\u2983-\u2998\u29D8-\u29DB\u29FC\u29FD\u2CF9-\u2CFC\u2CFE\u2CFF\u2D70\u2E00-\u2E2E\u2E30-\u2E4F\u2E52-\u2E5D\u3001-\u3003\u3008-\u3011\u3014-\u301F\u3030\u303D\u30A0\u30FB\uA4FE\uA4FF\uA60D-\uA60F\uA673\uA67E\uA6F2-\uA6F7\uA874-\uA877\uA8CE\uA8CF\uA8F8-\uA8FA\uA8FC\uA92E\uA92F\uA95F\uA9C1-\uA9CD\uA9DE\uA9DF\uAA5C-\uAA5F\uAADE\uAADF\uAAF0\uAAF1\uABEB\uFD3E\uFD3F\uFE10-\uFE19\uFE30-\uFE52\uFE54-\uFE61\uFE63\uFE68\uFE6A\uFE6B\uFF01-\uFF03\uFF05-\uFF0A\uFF0C-\uFF0F\uFF1A\uFF1B\uFF1F\uFF20\uFF3B-\uFF3D\uFF3F\uFF5B\uFF5D\uFF5F-\uFF65]|\uD800[\uDD00-\uDD02\uDF9F\uDFD0]|\uD801\uDD6F|\uD802[\uDC57\uDD1F\uDD3F\uDE50-\uDE58\uDE7F\uDEF0-\uDEF6\uDF39-\uDF3F\uDF99-\uDF9C]|\uD803[\uDEAD\uDF55-\uDF59\uDF86-\uDF89]|\uD804[\uDC47-\uDC4D\uDCBB\uDCBC\uDCBE-\uDCC1\uDD40-\uDD43\uDD74\uDD75\uDDC5-\uDDC8\uDDCD\uDDDB\uDDDD-\uDDDF\uDE38-\uDE3D\uDEA9]|\uD805[\uDC4B-\uDC4F\uDC5A\uDC5B\uDC5D\uDCC6\uDDC1-\uDDD7\uDE41-\uDE43\uDE60-\uDE6C\uDEB9\uDF3C-\uDF3E]|\uD806[\uDC3B\uDD44-\uDD46\uDDE2\uDE3F-\uDE46\uDE9A-\uDE9C\uDE9E-\uDEA2\uDF00-\uDF09]|\uD807[\uDC41-\uDC45\uDC70\uDC71\uDEF7\uDEF8\uDF43-\uDF4F\uDFFF]|\uD809[\uDC70-\uDC74]|\uD80B[\uDFF1\uDFF2]|\uD81A[\uDE6E\uDE6F\uDEF5\uDF37-\uDF3B\uDF44]|\uD81B[\uDE97-\uDE9A\uDFE2]|\uD82F\uDC9F|\uD836[\uDE87-\uDE8B]|\uD83A[\uDD5E\uDD5F]/;

});

parcelRegister("g80XX", function(module, exports) {
var $bbde24862701b102$export$2e2bcd8739ae039 = /[\$\+<->\^`\|~\xA2-\xA6\xA8\xA9\xAC\xAE-\xB1\xB4\xB8\xD7\xF7\u02C2-\u02C5\u02D2-\u02DF\u02E5-\u02EB\u02ED\u02EF-\u02FF\u0375\u0384\u0385\u03F6\u0482\u058D-\u058F\u0606-\u0608\u060B\u060E\u060F\u06DE\u06E9\u06FD\u06FE\u07F6\u07FE\u07FF\u0888\u09F2\u09F3\u09FA\u09FB\u0AF1\u0B70\u0BF3-\u0BFA\u0C7F\u0D4F\u0D79\u0E3F\u0F01-\u0F03\u0F13\u0F15-\u0F17\u0F1A-\u0F1F\u0F34\u0F36\u0F38\u0FBE-\u0FC5\u0FC7-\u0FCC\u0FCE\u0FCF\u0FD5-\u0FD8\u109E\u109F\u1390-\u1399\u166D\u17DB\u1940\u19DE-\u19FF\u1B61-\u1B6A\u1B74-\u1B7C\u1FBD\u1FBF-\u1FC1\u1FCD-\u1FCF\u1FDD-\u1FDF\u1FED-\u1FEF\u1FFD\u1FFE\u2044\u2052\u207A-\u207C\u208A-\u208C\u20A0-\u20C0\u2100\u2101\u2103-\u2106\u2108\u2109\u2114\u2116-\u2118\u211E-\u2123\u2125\u2127\u2129\u212E\u213A\u213B\u2140-\u2144\u214A-\u214D\u214F\u218A\u218B\u2190-\u2307\u230C-\u2328\u232B-\u2426\u2440-\u244A\u249C-\u24E9\u2500-\u2767\u2794-\u27C4\u27C7-\u27E5\u27F0-\u2982\u2999-\u29D7\u29DC-\u29FB\u29FE-\u2B73\u2B76-\u2B95\u2B97-\u2BFF\u2CE5-\u2CEA\u2E50\u2E51\u2E80-\u2E99\u2E9B-\u2EF3\u2F00-\u2FD5\u2FF0-\u2FFF\u3004\u3012\u3013\u3020\u3036\u3037\u303E\u303F\u309B\u309C\u3190\u3191\u3196-\u319F\u31C0-\u31E3\u31EF\u3200-\u321E\u322A-\u3247\u3250\u3260-\u327F\u328A-\u32B0\u32C0-\u33FF\u4DC0-\u4DFF\uA490-\uA4C6\uA700-\uA716\uA720\uA721\uA789\uA78A\uA828-\uA82B\uA836-\uA839\uAA77-\uAA79\uAB5B\uAB6A\uAB6B\uFB29\uFBB2-\uFBC2\uFD40-\uFD4F\uFDCF\uFDFC-\uFDFF\uFE62\uFE64-\uFE66\uFE69\uFF04\uFF0B\uFF1C-\uFF1E\uFF3E\uFF40\uFF5C\uFF5E\uFFE0-\uFFE6\uFFE8-\uFFEE\uFFFC\uFFFD]|\uD800[\uDD37-\uDD3F\uDD79-\uDD89\uDD8C-\uDD8E\uDD90-\uDD9C\uDDA0\uDDD0-\uDDFC]|\uD802[\uDC77\uDC78\uDEC8]|\uD805\uDF3F|\uD807[\uDFD5-\uDFF1]|\uD81A[\uDF3C-\uDF3F\uDF45]|\uD82F\uDC9C|\uD833[\uDF50-\uDFC3]|\uD834[\uDC00-\uDCF5\uDD00-\uDD26\uDD29-\uDD64\uDD6A-\uDD6C\uDD83\uDD84\uDD8C-\uDDA9\uDDAE-\uDDEA\uDE00-\uDE41\uDE45\uDF00-\uDF56]|\uD835[\uDEC1\uDEDB\uDEFB\uDF15\uDF35\uDF4F\uDF6F\uDF89\uDFA9\uDFC3]|\uD836[\uDC00-\uDDFF\uDE37-\uDE3A\uDE6D-\uDE74\uDE76-\uDE83\uDE85\uDE86]|\uD838[\uDD4F\uDEFF]|\uD83B[\uDCAC\uDCB0\uDD2E\uDEF0\uDEF1]|\uD83C[\uDC00-\uDC2B\uDC30-\uDC93\uDCA0-\uDCAE\uDCB1-\uDCBF\uDCC1-\uDCCF\uDCD1-\uDCF5\uDD0D-\uDDAD\uDDE6-\uDE02\uDE10-\uDE3B\uDE40-\uDE48\uDE50\uDE51\uDE60-\uDE65\uDF00-\uDFFF]|\uD83D[\uDC00-\uDED7\uDEDC-\uDEEC\uDEF0-\uDEFC\uDF00-\uDF76\uDF7B-\uDFD9\uDFE0-\uDFEB\uDFF0]|\uD83E[\uDC00-\uDC0B\uDC10-\uDC47\uDC50-\uDC59\uDC60-\uDC87\uDC90-\uDCAD\uDCB0\uDCB1\uDD00-\uDE53\uDE60-\uDE6D\uDE70-\uDE7C\uDE80-\uDE88\uDE90-\uDEBD\uDEBF-\uDEC5\uDECE-\uDEDB\uDEE0-\uDEE8\uDEF0-\uDEF8\uDF00-\uDF92\uDF94-\uDFCA]/;

});

parcelRegister("5g06v", function(module, exports) {
$parcel$export(module.exports, "default", () => $3d3e87026be501c3$export$2e2bcd8739ae039);
var $3d3e87026be501c3$export$2e2bcd8739ae039 = /[ \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000]/;

});






parcelRegister("lnr9T", function(module, exports) {
$parcel$export(module.exports, "strike", () => $f900d01941f2446d$export$4899a95d70ec5056);

var $P0RMo = parcelRequire("P0RMo");
var $f900d01941f2446d$export$4899a95d70ec5056 = (0, $P0RMo.strike)({
    parseDOM: [
        {
            tag: 'strike'
        },
        {
            tag: 's'
        },
        {
            tag: 'del'
        },
        {
            style: 'text-decoration',
            getAttrs: function getAttrs(value) {
                return value === 'line-through' && null;
            }
        }
    ],
    toDOM: function toDOM() {
        return [
            's'
        ];
    }
});

});

parcelRegister("1u7ml", function(module, exports) {
$parcel$export(module.exports, "strong", () => $114e4d3027b06d18$export$59ae2c325a998f89);

var $P0RMo = parcelRequire("P0RMo");
/**
 * @name strong_mark
 */ var $114e4d3027b06d18$var$strongDOM = [
    'strong'
];
var $114e4d3027b06d18$export$59ae2c325a998f89 = (0, $P0RMo.strong)({
    parseDOM: [
        {
            tag: 'strong'
        },
        // This works around a Google Docs misbehavior where
        // pasted content will be inexplicably wrapped in `<b>`
        // tags with a font-weight normal.
        {
            tag: 'b',
            getAttrs: function getAttrs(node) {
                var element = node;
                return element.style.fontWeight !== 'normal' && null;
            }
        },
        {
            tag: 'span',
            getAttrs: function getAttrs(node) {
                var element = node;
                var fontWeight = element.style.fontWeight;
                return typeof fontWeight === 'string' && (fontWeight === 'bold' || fontWeight === 'bolder' || /^(bold(er)?|[5-9]\d{2,})$/.test(fontWeight)) && null;
            }
        }
    ],
    toDOM: function toDOM() {
        return $114e4d3027b06d18$var$strongDOM;
    }
});

});

parcelRegister("1Ge5k", function(module, exports) {
$parcel$export(module.exports, "subsup", () => $1394a3af0d46a777$export$b3401ee80eb31041);

var $P0RMo = parcelRequire("P0RMo");
/**
 * @name subsup_mark
 */ function $1394a3af0d46a777$var$getAttrFromVerticalAlign(node) {
    if (node === 'sub') return {
        type: 'sub'
    };
    if (node === 'super') return {
        type: 'sup'
    };
    return false;
}
var $1394a3af0d46a777$export$b3401ee80eb31041 = (0, $P0RMo.subsup)({
    parseDOM: [
        {
            tag: 'sub',
            attrs: {
                type: 'sub'
            }
        },
        {
            tag: 'sup',
            attrs: {
                type: 'sup'
            }
        },
        {
            // Special case for pasting from Google Docs
            // Google Docs uses vertical align to denote subscript and super script
            style: 'vertical-align=super',
            getAttrs: function getAttrs(node) {
                return $1394a3af0d46a777$var$getAttrFromVerticalAlign(node);
            }
        },
        {
            style: 'vertical-align=sub',
            getAttrs: function getAttrs(node) {
                return $1394a3af0d46a777$var$getAttrFromVerticalAlign(node);
            }
        }
    ],
    toDOM: function toDOM(mark) {
        return [
            mark.attrs.type
        ];
    }
});

});

parcelRegister("9htZc", function(module, exports) {
$parcel$export(module.exports, "typeAheadQuery", () => $6c1cf638064b66b7$export$20af3dabbb5538df);

var $P0RMo = parcelRequire("P0RMo");

var $22vaF = parcelRequire("22vaF");
var $6c1cf638064b66b7$export$20af3dabbb5538df = (0, $P0RMo.typeAheadQuery)({
    parseDOM: [
        {
            tag: 'span[data-type-ahead-query]'
        }
    ],
    toDOM: function toDOM(node) {
        return [
            'span',
            {
                'data-type-ahead-query': 'true',
                'data-trigger': node.attrs.trigger,
                style: "color: ".concat((0, $22vaF.B400))
            }
        ];
    }
});

});

parcelRegister("1UbTw", function(module, exports) {
$parcel$export(module.exports, "underline", () => $16343f694e54def3$export$425327af25286e5e);

var $P0RMo = parcelRequire("P0RMo");
var $16343f694e54def3$export$425327af25286e5e = (0, $P0RMo.underline)({
    parseDOM: [
        {
            tag: 'u'
        },
        {
            style: 'text-decoration',
            getAttrs: function getAttrs(value) {
                return value === 'underline' && null;
            }
        }
    ],
    toDOM: function toDOM() {
        return [
            'u'
        ];
    }
});

});

parcelRegister("8Krw2", function(module, exports) {
$parcel$export(module.exports, "unsupportedMark", () => $65e7f6ad6688b964$export$30d78d5eb6719bb8);

var $P0RMo = parcelRequire("P0RMo");
var $65e7f6ad6688b964$export$30d78d5eb6719bb8 = (0, $P0RMo.unsupportedMark)({
    toDOM: function toDOM() {
        return [
            'span'
        ];
    }
});

});

parcelRegister("9fdRd", function(module, exports) {
$parcel$export(module.exports, "unsupportedNodeAttribute", () => $6bb04387db9b433f$export$a316dc07ff5182a2);

var $P0RMo = parcelRequire("P0RMo");
var $6bb04387db9b433f$export$a316dc07ff5182a2 = (0, $P0RMo.unsupportedNodeAttribute)({
    toDOM: function toDOM() {
        return [
            'span'
        ];
    }
});

});

parcelRegister("TWIcC", function(module, exports) {
$parcel$export(module.exports, "blockCard", () => $0a82ae2359e888cd$export$c4c2f833baaebdb8);

var $25nEq = parcelRequire("25nEq");

var $2gWGi = parcelRequire("2gWGi");

var $l4823 = parcelRequire("l4823");
function $0a82ae2359e888cd$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $0a82ae2359e888cd$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $0a82ae2359e888cd$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $0a82ae2359e888cd$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
/**
 * @name blockCard_node
 */ var $0a82ae2359e888cd$var$getCommonAttributesFromDom = function getCommonAttributesFromDom(dom) {
    var anchor = dom;
    var data = anchor.getAttribute('data-card-data');
    var datasource = anchor.getAttribute('data-datasource');
    return {
        data: data ? JSON.parse(data) : undefined,
        layout: datasource ? dom.getAttribute('data-layout') || undefined : undefined,
        width: Number(dom.getAttribute('data-width')) || undefined,
        datasource: datasource ? JSON.parse(datasource) : undefined
    };
};
var $0a82ae2359e888cd$export$c4c2f833baaebdb8 = (0, $2gWGi.blockCard)({
    parseDOM: [
        {
            tag: 'a[data-block-card]',
            // bump priority higher than hyperlink
            priority: 100,
            getAttrs: function getAttrs(dom) {
                var anchor = dom;
                return $0a82ae2359e888cd$var$_objectSpread({
                    url: anchor.getAttribute('href') || undefined
                }, $0a82ae2359e888cd$var$getCommonAttributesFromDom(dom));
            }
        },
        {
            tag: 'div[data-block-card]',
            getAttrs: function getAttrs(dom) {
                var anchor = dom;
                return $0a82ae2359e888cd$var$_objectSpread({
                    url: anchor.getAttribute('data-card-url') || undefined
                }, $0a82ae2359e888cd$var$getCommonAttributesFromDom(dom));
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node$attrs;
        var _ref = node.attrs, url = _ref.url;
        var _ref2 = node.attrs, data = _ref2.data;
        var _ref3 = node.attrs, layout = _ref3.layout, width = _ref3.width, datasource = _ref3.datasource;
        var attrs = {
            'data-block-card': '',
            href: url || '',
            'data-card-data': data ? JSON.stringify(data) : '',
            'data-datasource': datasource ? JSON.stringify(datasource) : '',
            'data-layout': layout,
            'data-width': "".concat(width)
        };
        return [
            'a',
            attrs,
            (node === null || node === void 0 ? void 0 : (_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.url) || ' '
        ];
    }
});
var $0a82ae2359e888cd$export$9894f24949f094e5 = (0, $2gWGi.blockCard)({
    parseDOM: [
        {
            tag: 'a[data-block-card]',
            // bump priority higher than hyperlink
            priority: 100,
            getAttrs: function getAttrs(dom) {
                var anchor = dom;
                return $0a82ae2359e888cd$var$_objectSpread($0a82ae2359e888cd$var$_objectSpread({
                    url: anchor.getAttribute('href') || undefined
                }, $0a82ae2359e888cd$var$getCommonAttributesFromDom(dom)), {}, {
                    localId: (0, $l4823.uuid).generate()
                });
            }
        },
        {
            tag: 'div[data-block-card]',
            getAttrs: function getAttrs(dom) {
                var anchor = dom;
                return $0a82ae2359e888cd$var$_objectSpread($0a82ae2359e888cd$var$_objectSpread({
                    url: anchor.getAttribute('data-card-url') || undefined
                }, $0a82ae2359e888cd$var$getCommonAttributesFromDom(dom)), {}, {
                    localId: (0, $l4823.uuid).generate()
                });
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node$attrs2, _node$attrs3;
        var _ref4 = node.attrs, url = _ref4.url;
        var _ref5 = node.attrs, data = _ref5.data;
        var _ref6 = node.attrs, layout = _ref6.layout, width = _ref6.width, datasource = _ref6.datasource;
        var attrs = {
            'data-block-card': '',
            href: url || '',
            'data-card-data': data ? JSON.stringify(data) : '',
            'data-datasource': datasource ? JSON.stringify(datasource) : '',
            'data-layout': layout,
            'data-width': "".concat(width),
            'data-local-id': (node === null || node === void 0 ? void 0 : (_node$attrs2 = node.attrs) === null || _node$attrs2 === void 0 ? void 0 : _node$attrs2.localId) || undefined
        };
        return [
            'a',
            attrs,
            (node === null || node === void 0 ? void 0 : (_node$attrs3 = node.attrs) === null || _node$attrs3 === void 0 ? void 0 : _node$attrs3.url) || ' '
        ];
    }
});

});

parcelRegister("1aipV", function(module, exports) {
$parcel$export(module.exports, "taskItem", () => $0d9502dc3a462c45$export$6d8b0ef52e2e6390);
$parcel$export(module.exports, "blockTaskItem", () => $0d9502dc3a462c45$export$16018c61064a18df);

var $l4823 = parcelRequire("l4823");

var $2gWGi = parcelRequire("2gWGi");
var $0d9502dc3a462c45$export$6d8b0ef52e2e6390 = (0, $2gWGi.taskItem)({
    parseDOM: [
        {
            tag: 'div[data-task-local-id]',
            // Default priority is 50. We normally don't change this but since this node type is
            // also used by list-item we need to make sure that we run this parser first.
            priority: 100,
            getAttrs: function getAttrs(dom) {
                return {
                    localId: (0, $l4823.uuid).generate(),
                    state: dom.getAttribute('data-task-state') || 'TODO'
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node$attrs = node.attrs, localId = _node$attrs.localId, state = _node$attrs.state;
        var attrs = {
            'data-task-local-id': localId || 'local-task',
            'data-task-state': state || 'TODO'
        };
        return [
            'div',
            attrs,
            0
        ];
    }
});
var $0d9502dc3a462c45$export$16018c61064a18df = (0, $2gWGi.blockTaskItem)({
    parseDOM: [
        {
            tag: 'div[data-task-is-block]',
            // Default priority is 50. We normally don't change this but since this node type is
            // also used by list-item we need to make sure that we run this parser first.
            priority: 100,
            getAttrs: function getAttrs(dom) {
                return {
                    localId: (0, $l4823.uuid).generate(),
                    state: dom.getAttribute('data-task-state') || 'TODO'
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node$attrs2 = node.attrs, localId = _node$attrs2.localId, state = _node$attrs2.state;
        var attrs = {
            'data-task-local-id': localId || 'local-task',
            'data-task-state': state || 'TODO',
            'data-task-is-block': 'true'
        };
        return [
            'div',
            attrs,
            0
        ];
    }
});

});

parcelRegister("7wC9F", function(module, exports) {
$parcel$export(module.exports, "bodiedExtension", () => $57a91e507a072423$export$27903d543b563e39);

var $ljjv5 = parcelRequire("ljjv5");

var $2gWGi = parcelRequire("2gWGi");
var $57a91e507a072423$export$27903d543b563e39 = (0, $2gWGi.bodiedExtension)({
    parseDOM: [
        {
            context: 'bodiedExtension//',
            tag: '[data-node-type="bodied-extension"]',
            skip: true
        },
        {
            tag: '[data-node-type="bodied-extension"]',
            getAttrs: function getAttrs(domNode) {
                return (0, $ljjv5.getExtensionAttrs)(domNode);
            }
        }
    ],
    toDOM: function toDOM(node) {
        var attrs = {
            'data-node-type': 'bodied-extension',
            'data-extension-type': node.attrs.extensionType,
            'data-extension-key': node.attrs.extensionKey,
            'data-text': node.attrs.text,
            'data-parameters': JSON.stringify(node.attrs.parameters),
            'data-layout': node.attrs.layout,
            'data-local-id:': node.attrs.localId
        };
        return [
            'div',
            attrs,
            0
        ];
    }
});

});

parcelRegister("aUdhc", function(module, exports) {
$parcel$export(module.exports, "bodiedSyncBlock", () => $7f096ec34d684944$export$e92c7e4302dd4371);

var $2gWGi = parcelRequire("2gWGi");

var $l4823 = parcelRequire("l4823");
var $7f096ec34d684944$export$e92c7e4302dd4371 = (0, $2gWGi.bodiedSyncBlock)({
    parseDOM: [
        {
            tag: 'div[data-bodied-sync-block]',
            getAttrs: function getAttrs(domNode) {
                var dom = domNode;
                var attrs = {
                    localId: dom.getAttribute('data-local-id') || (0, $l4823.uuid).generate(),
                    resourceId: dom.getAttribute('data-resource-id') || ''
                };
                return attrs;
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node$attrs = node.attrs, localId = _node$attrs.localId, resourceId = _node$attrs.resourceId;
        var name = 'div';
        var attrs = {
            'data-bodied-sync-block': '',
            'data-local-id': localId,
            'data-resource-id': resourceId
        };
        return [
            name,
            attrs,
            0
        ];
    }
});

});

parcelRegister("gBea6", function(module, exports) {
$parcel$export(module.exports, "bulletListSelector", () => $c15b164f097d5ffe$export$5f25a39efab3b58b);
$parcel$export(module.exports, "bulletList", () => $c15b164f097d5ffe$export$a140c94e5ea26bee);

var $l4823 = parcelRequire("l4823");

var $2gWGi = parcelRequire("2gWGi");
var $c15b164f097d5ffe$export$5f25a39efab3b58b = '.ak-ul';
var $c15b164f097d5ffe$export$a140c94e5ea26bee = (0, $2gWGi.bulletList)({
    parseDOM: [
        {
            tag: 'ul'
        }
    ],
    toDOM: function toDOM() {
        var attrs = {
            class: $c15b164f097d5ffe$export$5f25a39efab3b58b.substr(1)
        };
        return [
            'ul',
            attrs,
            0
        ];
    }
});
var $c15b164f097d5ffe$export$dfd406053b2bab40 = (0, $2gWGi.bulletList)({
    parseDOM: [
        {
            tag: 'ul',
            getAttrs: function getAttrs() {
                return {
                    localId: (0, $l4823.uuid).generate()
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node$attrs;
        var attrs = {
            class: $c15b164f097d5ffe$export$5f25a39efab3b58b.substr(1),
            'data-local-id': (node === null || node === void 0 ? void 0 : (_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.localId) || undefined
        };
        return [
            'ul',
            attrs,
            0
        ];
    }
});

});

parcelRegister("gBtp4", function(module, exports) {
$parcel$export(module.exports, "caption", () => $c166e8f567426a89$export$8e3c2dfdc4f0453d);

var $2gWGi = parcelRequire("2gWGi");

var $l4823 = parcelRequire("l4823");
var $c166e8f567426a89$export$8e3c2dfdc4f0453d = (0, $2gWGi.caption)({
    parseDOM: [
        {
            tag: 'figcaption[data-caption]'
        }
    ],
    toDOM: function toDOM() {
        var attrs = {
            'data-caption': 'true'
        };
        return [
            'figcaption',
            attrs,
            0
        ];
    }
});
var $c166e8f567426a89$export$b5d01ee303c467aa = (0, $2gWGi.caption)({
    parseDOM: [
        {
            tag: 'figcaption[data-caption]',
            getAttrs: function getAttrs() {
                return {
                    localId: (0, $l4823.uuid).generate()
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node$attrs;
        var attrs = {
            'data-caption': 'true',
            'data-local-id': (node === null || node === void 0 ? void 0 : (_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.localId) || undefined
        };
        return [
            'figcaption',
            attrs,
            0
        ];
    }
});

});

parcelRegister("enrSO", function(module, exports) {
$parcel$export(module.exports, "codeBlock", () => $a778d7ac22429d96$export$7bb0d5c671655cc4);
$parcel$export(module.exports, "toJSON", () => $a778d7ac22429d96$export$54fd2c36b5cc6731);

var $6hSvq = parcelRequire("6hSvq");

var $2gWGi = parcelRequire("2gWGi");

var $l4823 = parcelRequire("l4823");
/**
 * @name codeBlock_with_no_marks_node
 */ /**
 * @name codeBlock_node
 */ var $a778d7ac22429d96$var$getLanguageFromEditorStyle = function getLanguageFromEditorStyle(dom) {
    return dom.getAttribute('data-language') || undefined;
};
// example of BB style:
// <div class="codehilite language-javascript"><pre><span>hello world</span><span>\n</span></pre></div>
var $a778d7ac22429d96$var$getLanguageFromBitbucketStyle = function getLanguageFromBitbucketStyle(dom) {
    if (dom && dom.classList.contains('codehilite')) // code block html from Bitbucket always contains an extra new line
    return $a778d7ac22429d96$var$extractLanguageFromClass(dom.className);
    return;
};
// If there is a child code element, check that for data-language
var $a778d7ac22429d96$var$getLanguageFromCode = function getLanguageFromCode(dom) {
    var firstChild = dom.firstElementChild;
    if (firstChild && firstChild.nodeName === 'CODE') return firstChild.getAttribute('data-language') || undefined;
};
var $a778d7ac22429d96$var$extractLanguageFromClass = function extractLanguageFromClass(className) {
    var languageRegex = /(?:^|\s)language-([^\s]+)/;
    var result = languageRegex.exec(className);
    if (result && result[1]) return result[1];
    return;
};
var $a778d7ac22429d96$var$removeLastNewLine = function removeLastNewLine(dom) {
    var parent = dom && dom.parentElement;
    if (parent && parent.classList.contains('codehilite')) dom.textContent = dom.textContent.replace(/\n$/, '');
    return dom;
};
function $a778d7ac22429d96$var$parseCodeFromHtml(node) {
    var code = '';
    node.childNodes.forEach(function(child) {
        if (child.nodeType === Node.TEXT_NODE) // append text
        code += child.nodeValue;
        else if (child.nodeType === Node.ELEMENT_NODE && child instanceof Element) {
            var tagName = child.tagName.toLowerCase();
            if (tagName === 'div' || tagName === 'p') // add a newline before its content, unless it's the first child to avoid leading newlines
            {
                if (child.previousElementSibling !== null) code += '\n';
            }
            if (tagName === 'br') code += '\n';
            else code += $a778d7ac22429d96$var$parseCodeFromHtml(child);
        }
    });
    return code;
}
var $a778d7ac22429d96$export$7bb0d5c671655cc4 = (0, $2gWGi.codeBlock)({
    parseDOM: [
        {
            tag: 'pre',
            preserveWhitespace: 'full',
            getAttrs: function getAttrs(domNode) {
                var dom = domNode;
                var language = $a778d7ac22429d96$var$getLanguageFromBitbucketStyle(dom.parentElement) || $a778d7ac22429d96$var$getLanguageFromEditorStyle(dom.parentElement) || $a778d7ac22429d96$var$getLanguageFromCode(dom) || dom.getAttribute('data-language');
                dom = $a778d7ac22429d96$var$removeLastNewLine(dom);
                return {
                    language: language
                };
            }
        },
        // Handle VSCode, Android Studio paste
        // Checking `white-space: pre-wrap` is too aggressive @see ED-2627
        {
            tag: 'div[style]',
            preserveWhitespace: 'full',
            getAttrs: function getAttrs(domNode) {
                var dom = domNode;
                if (dom.style.whiteSpace === 'pre' || dom.style.fontFamily && dom.style.fontFamily.toLowerCase().indexOf('monospace') > -1) return {};
                return false;
            },
            getContent: function getContent(domNode, schema) {
                var code = $a778d7ac22429d96$var$parseCodeFromHtml(domNode);
                return code ? (0, $6hSvq.Fragment).from(schema.text(code)) : (0, $6hSvq.Fragment).empty;
            }
        },
        // Handle GitHub/Gist paste
        {
            tag: 'table[style]',
            preserveWhitespace: 'full',
            getAttrs: function getAttrs(dom) {
                if (dom.querySelector('td[class*="blob-code"]')) return {};
                return false;
            }
        },
        {
            tag: 'div.code-block',
            preserveWhitespace: 'full',
            getAttrs: function getAttrs(domNode) {
                var dom = domNode;
                // TODO: ED-5604 Fix it inside `react-syntax-highlighter`
                // Remove line numbers
                var lineNumber = dom.querySelectorAll('.react-syntax-highlighter-line-number');
                if (lineNumber.length > 0) // It's possible to copy without the line numbers too hence this
                // `react-syntax-highlighter-line-number` check, so that we don't remove real code
                lineNumber.forEach(function(line) {
                    return line.remove();
                });
                return {};
            }
        }
    ],
    toDOM: function toDOM(node) {
        return [
            'pre',
            [
                'code',
                {
                    'data-language': node.attrs.language
                },
                0
            ]
        ];
    }
});
var $a778d7ac22429d96$export$54fd2c36b5cc6731 = function toJSON(node) {
    return {
        attrs: Object.keys(node.attrs).reduce(function(memo, key) {
            if (key === 'uniqueId') return memo;
            if (key === 'language' && node.attrs.language === null) return memo;
            memo[key] = node.attrs[key];
            return memo;
        }, {})
    };
};
var $a778d7ac22429d96$export$3f75de798a0b5356 = (0, $2gWGi.codeBlock)({
    parseDOM: [
        {
            tag: 'pre',
            preserveWhitespace: 'full',
            getAttrs: function getAttrs(domNode) {
                var dom = domNode;
                var language = $a778d7ac22429d96$var$getLanguageFromBitbucketStyle(dom.parentElement) || $a778d7ac22429d96$var$getLanguageFromEditorStyle(dom.parentElement) || $a778d7ac22429d96$var$getLanguageFromCode(dom) || dom.getAttribute('data-language');
                dom = $a778d7ac22429d96$var$removeLastNewLine(dom);
                return {
                    language: language,
                    localId: (0, $l4823.uuid).generate()
                };
            }
        },
        // Handle VSCode, Android Studio paste
        // Checking `white-space: pre-wrap` is too aggressive @see ED-2627
        {
            tag: 'div[style]',
            preserveWhitespace: 'full',
            getAttrs: function getAttrs(domNode) {
                var dom = domNode;
                if (dom.style.whiteSpace === 'pre' || dom.style.fontFamily && dom.style.fontFamily.toLowerCase().indexOf('monospace') > -1) return {};
                return false;
            },
            getContent: function getContent(domNode, schema) {
                var code = $a778d7ac22429d96$var$parseCodeFromHtml(domNode);
                return code ? (0, $6hSvq.Fragment).from(schema.text(code)) : (0, $6hSvq.Fragment).empty;
            }
        },
        // Handle GitHub/Gist paste
        {
            tag: 'table[style]',
            preserveWhitespace: 'full',
            getAttrs: function getAttrs(dom) {
                if (dom.querySelector('td[class*="blob-code"]')) return {};
                return false;
            }
        },
        {
            tag: 'div.code-block',
            preserveWhitespace: 'full',
            getAttrs: function getAttrs(domNode) {
                var dom = domNode;
                // TODO: ED-5604 Fix it inside `react-syntax-highlighter`
                // Remove line numbers
                var lineNumber = dom.querySelectorAll('.react-syntax-highlighter-line-number');
                if (lineNumber.length > 0) // It's possible to copy without the line numbers too hence this
                // `react-syntax-highlighter-line-number` check, so that we don't remove real code
                lineNumber.forEach(function(line) {
                    return line.remove();
                });
                return {};
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node$attrs;
        var attrs = {
            'data-local-id': (node === null || node === void 0 ? void 0 : (_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.localId) || undefined
        };
        return [
            'pre',
            attrs,
            [
                'code',
                {
                    'data-language': node.attrs.language
                },
                0
            ]
        ];
    }
});

});

parcelRegister("ds6FG", function(module, exports) {
$parcel$export(module.exports, "confluenceJiraIssue", () => $9cb310ab708b0703$export$daf889beb5092f95);

var $2gWGi = parcelRequire("2gWGi");
var $9cb310ab708b0703$var$name = 'confluenceJiraIssue';
var $9cb310ab708b0703$export$daf889beb5092f95 = (0, $2gWGi.confluenceJiraIssue)({
    parseDOM: [
        {
            tag: "span[data-node-type=\"".concat($9cb310ab708b0703$var$name, "\"]"),
            getAttrs: function getAttrs(domNode) {
                var dom = domNode;
                return {
                    issueKey: dom.textContent,
                    macroId: dom.dataset && dom.dataset.macroId,
                    schemaVersion: dom.dataset && dom.dataset.schemaVersion,
                    server: dom.dataset && dom.dataset.server,
                    serverId: dom.dataset && dom.dataset.serverId
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var attrs = {
            'data-node-type': $9cb310ab708b0703$var$name,
            'data-macro-id': node.attrs.macroId,
            'data-schema-version': node.attrs.schemaVersion,
            'data-server': node.attrs.server,
            'data-server-id': node.attrs.serverId,
            'data-jira-issue': node.attrs.issueKey
        };
        return [
            'span',
            attrs,
            node.attrs.issueKey
        ];
    }
});

});

parcelRegister("28jyL", function(module, exports) {
$parcel$export(module.exports, "confluenceUnsupportedBlock", () => $18db804d55481544$export$e6e4878f43c27cab);

var $2gWGi = parcelRequire("2gWGi");
var $18db804d55481544$var$name = 'confluenceUnsupportedBlock';
var $18db804d55481544$export$e6e4878f43c27cab = (0, $2gWGi.confluenceUnsupportedBlock)({
    toDOM: function toDOM(node) {
        // NOTE: This node cannot be "contenteditable: false". If it's the only node in a document, PM throws an error because there's nowhere to put the cursor.
        var attrs = {
            'data-node-type': $18db804d55481544$var$name,
            'data-confluence-unsupported': 'block',
            'data-confluence-unsupported-block-cxhtml': node.attrs['cxhtml']
        };
        return [
            'div',
            attrs,
            'Unsupported content'
        ];
    },
    parseDOM: [
        {
            tag: "div[data-node-type=\"".concat($18db804d55481544$var$name, "\"]"),
            getAttrs: function getAttrs(dom) {
                return {
                    cxhtml: dom.getAttribute('data-confluence-unsupported-block-cxhtml')
                };
            }
        }
    ]
});

});

parcelRegister("h4Vhg", function(module, exports) {
$parcel$export(module.exports, "confluenceUnsupportedInline", () => $c6ef3d8205120509$export$3e6d667072febc87);

var $2gWGi = parcelRequire("2gWGi");
var $c6ef3d8205120509$var$name = 'confluenceUnsupportedInline';
var $c6ef3d8205120509$export$3e6d667072febc87 = (0, $2gWGi.confluenceUnsupportedInline)({
    toDOM: function toDOM(node) {
        var attrs = {
            'data-node-type': $c6ef3d8205120509$var$name,
            'data-confluence-unsupported': 'inline',
            'data-confluence-unsupported-inline-cxhtml': node.attrs['cxhtml']
        };
        return [
            'div',
            attrs,
            'Unsupported content'
        ];
    },
    parseDOM: [
        {
            tag: "div[data-node-type=\"".concat($c6ef3d8205120509$var$name, "\"]"),
            getAttrs: function getAttrs(dom) {
                return {
                    cxhtml: dom.getAttribute('data-confluence-unsupported-inline-cxhtml')
                };
            }
        }
    ]
});

});

parcelRegister("gTQzU", function(module, exports) {
$parcel$export(module.exports, "date", () => $c4da91508771171b$export$324d90190a8b822a);

var $2gWGi = parcelRequire("2gWGi");

var $l4823 = parcelRequire("l4823");
var $c4da91508771171b$export$324d90190a8b822a = (0, $2gWGi.date)({
    parseDOM: [
        {
            tag: 'span[data-node-type="date"]',
            getAttrs: function getAttrs(dom) {
                return {
                    timestamp: dom.getAttribute('data-timestamp')
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var attrs = {
            'data-node-type': 'date',
            'data-timestamp': node.attrs.timestamp
        };
        return [
            'span',
            attrs
        ];
    }
});
var $c4da91508771171b$export$a6a035390e3921b2 = (0, $2gWGi.date)({
    parseDOM: [
        {
            tag: 'span[data-node-type="date"]',
            getAttrs: function getAttrs(dom) {
                return {
                    timestamp: dom.getAttribute('data-timestamp'),
                    localId: (0, $l4823.uuid).generate()
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node$attrs;
        var attrs = {
            'data-node-type': 'date',
            'data-timestamp': node.attrs.timestamp,
            'data-local-id': (node === null || node === void 0 ? void 0 : (_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.localId) || undefined
        };
        return [
            'span',
            attrs
        ];
    }
});

});

parcelRegister("Mas9e", function(module, exports) {
$parcel$export(module.exports, "decisionItem", () => $090c978eb6381123$export$6959e16eeff859b4);

var $l4823 = parcelRequire("l4823");

var $2gWGi = parcelRequire("2gWGi");
var $090c978eb6381123$export$6959e16eeff859b4 = (0, $2gWGi.decisionItem)({
    parseDOM: [
        {
            tag: 'li[data-decision-local-id]',
            // Default priority is 50. We normally don't change this but since this node type is
            // also used by list-item we need to make sure that we run this parser first.
            priority: 100,
            getAttrs: function getAttrs(dom) {
                return {
                    localId: (0, $l4823.uuid).generate(),
                    state: dom.getAttribute('data-decision-state')
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node$attrs = node.attrs, localId = _node$attrs.localId, state = _node$attrs.state;
        var attrs = {
            'data-decision-local-id': localId || 'local-decision',
            'data-decision-state': state
        };
        return [
            'li',
            attrs,
            0
        ];
    }
});

});

parcelRegister("6e7am", function(module, exports) {
$parcel$export(module.exports, "decisionList", () => $48899bf20ae374f5$export$62d45a65fb43d95e);

var $l4823 = parcelRequire("l4823");

var $2gWGi = parcelRequire("2gWGi");
/**
 * @name decisionList_node
 */ var $48899bf20ae374f5$var$name = 'decisionList';
var $48899bf20ae374f5$export$a5393ce68c2ff601 = "[data-node-type=\"".concat($48899bf20ae374f5$var$name, "\"]");
var $48899bf20ae374f5$export$62d45a65fb43d95e = (0, $2gWGi.decisionList)({
    parseDOM: [
        {
            tag: "ol".concat($48899bf20ae374f5$export$a5393ce68c2ff601),
            // Default priority is 50. We normally don't change this but since this node type is
            // also used by ordered-list we need to make sure that we run this parser first.
            priority: 100,
            getAttrs: function getAttrs() {
                return {
                    localId: (0, $l4823.uuid).generate()
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var localId = node.attrs.localId;
        var attrs = {
            'data-node-type': $48899bf20ae374f5$var$name,
            'data-decision-list-local-id': localId || 'local-decision-list',
            style: 'list-style: none; padding-left: 0'
        };
        return [
            'ol',
            attrs,
            0
        ];
    }
});

});

parcelRegister("cO5dd", function(module, exports) {
$parcel$export(module.exports, "doc", () => $952e328fc7258c40$export$2a111da947c407d2);

var $2gWGi = parcelRequire("2gWGi");
var $952e328fc7258c40$export$2a111da947c407d2 = (0, $2gWGi.doc)({});

});

parcelRegister("ixGXu", function(module, exports) {
$parcel$export(module.exports, "embedCard", () => $d7fca1c0c60154bd$export$be4283d9a1cb1ff6);

var $2gWGi = parcelRequire("2gWGi");

var $l4823 = parcelRequire("l4823");
var $d7fca1c0c60154bd$export$be4283d9a1cb1ff6 = (0, $2gWGi.embedCard)({
    parseDOM: [
        {
            tag: 'div[data-embed-card]',
            getAttrs: function getAttrs(dom) {
                return {
                    url: dom.getAttribute('data-card-url'),
                    layout: dom.getAttribute('data-layout') || 'center',
                    width: Number(dom.getAttribute('data-width')) || null,
                    originalWidth: Number(dom.getAttribute('data-card-original-width')) || null,
                    originalHeight: Number(dom.getAttribute('data-card-original-height')) || null
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node$attrs = node.attrs, url = _node$attrs.url, layout = _node$attrs.layout, width = _node$attrs.width, originalWidth = _node$attrs.originalWidth, originalHeight = _node$attrs.originalHeight;
        var attrs = {
            'data-embed-card': '',
            'data-card-url': url,
            'data-layout': layout,
            'data-width': width,
            'data-original-width': originalWidth,
            'data-original-height': originalHeight
        };
        return [
            'div',
            attrs
        ];
    }
});
var $d7fca1c0c60154bd$export$36734475a7f6fd3e = (0, $2gWGi.embedCard)({
    parseDOM: [
        {
            tag: 'div[data-embed-card]',
            getAttrs: function getAttrs(dom) {
                return {
                    url: dom.getAttribute('data-card-url'),
                    layout: dom.getAttribute('data-layout') || 'center',
                    width: Number(dom.getAttribute('data-width')) || null,
                    originalWidth: Number(dom.getAttribute('data-card-original-width')) || null,
                    originalHeight: Number(dom.getAttribute('data-card-original-height')) || null,
                    localId: (0, $l4823.uuid).generate()
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node$attrs3;
        var _node$attrs2 = node.attrs, url = _node$attrs2.url, layout = _node$attrs2.layout, width = _node$attrs2.width, originalWidth = _node$attrs2.originalWidth, originalHeight = _node$attrs2.originalHeight;
        var attrs = {
            'data-embed-card': '',
            'data-card-url': url,
            'data-layout': layout,
            'data-width': width,
            'data-original-width': originalWidth,
            'data-original-height': originalHeight,
            'data-local-id': (node === null || node === void 0 ? void 0 : (_node$attrs3 = node.attrs) === null || _node$attrs3 === void 0 ? void 0 : _node$attrs3.localId) || undefined
        };
        return [
            'div',
            attrs
        ];
    }
});

});

parcelRegister("r9xZG", function(module, exports) {
$parcel$export(module.exports, "emoji", () => $0519ed9fba260554$export$a19185d1233fc4b2);

var $25nEq = parcelRequire("25nEq");

var $6ktYw = parcelRequire("6ktYw");

var $2gWGi = parcelRequire("2gWGi");

var $l4823 = parcelRequire("l4823");
function $0519ed9fba260554$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $0519ed9fba260554$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $0519ed9fba260554$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $0519ed9fba260554$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $0519ed9fba260554$export$a19185d1233fc4b2 = (0, $2gWGi.emoji)({
    parseDOM: [
        // Handle copy/paste beautiful panel from renderer />
        {
            tag: 'div.ak-editor-panel__icon span',
            ignore: true
        },
        {
            tag: 'span[data-emoji-short-name]',
            getAttrs: function getAttrs(domNode) {
                var dom = domNode;
                return {
                    shortName: dom.getAttribute('data-emoji-short-name') || $0519ed9fba260554$export$a19185d1233fc4b2.attrs.shortName.default,
                    id: dom.getAttribute('data-emoji-id') || $0519ed9fba260554$export$a19185d1233fc4b2.attrs.id.default,
                    text: dom.getAttribute('data-emoji-text') || $0519ed9fba260554$export$a19185d1233fc4b2.attrs.text.default
                };
            }
        },
        // Handle copy/paste from old <ac:emoticon />
        {
            tag: 'img[data-emoticon-name]',
            getAttrs: function getAttrs(dom) {
                return (0, $6ktYw.acNameToEmoji)(dom.getAttribute('data-emoticon-name'));
            }
        },
        // Handle copy/paste from old <ac:hipchat-emoticons />
        {
            tag: 'img[data-hipchat-emoticon]',
            getAttrs: function getAttrs(dom) {
                return (0, $6ktYw.acShortcutToEmoji)(dom.getAttribute('data-hipchat-emoticon'));
            }
        },
        // Handle copy/paste from bitbucket's <img class="emoji" />
        {
            tag: 'img.emoji[data-emoji-short-name]',
            getAttrs: function getAttrs(domNode) {
                var dom = domNode;
                return {
                    shortName: dom.getAttribute('data-emoji-short-name') || $0519ed9fba260554$export$a19185d1233fc4b2.attrs.shortName.default,
                    id: dom.getAttribute('data-emoji-id') || $0519ed9fba260554$export$a19185d1233fc4b2.attrs.id.default,
                    text: dom.getAttribute('data-emoji-text') || $0519ed9fba260554$export$a19185d1233fc4b2.attrs.text.default
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node$attrs = node.attrs, shortName = _node$attrs.shortName, id = _node$attrs.id, text = _node$attrs.text;
        var attrs = {
            'data-emoji-short-name': shortName,
            'data-emoji-id': id,
            'data-emoji-text': text,
            contenteditable: 'false'
        };
        return [
            'span',
            attrs,
            text
        ];
    }
});
var $0519ed9fba260554$export$ebb3b3c7a0ac9936 = (0, $2gWGi.emoji)({
    parseDOM: [
        // Handle copy/paste beautiful panel from renderer />
        {
            tag: 'div.ak-editor-panel__icon span',
            ignore: true
        },
        {
            tag: 'span[data-emoji-short-name]',
            getAttrs: function getAttrs(domNode) {
                var dom = domNode;
                return {
                    shortName: dom.getAttribute('data-emoji-short-name') || $0519ed9fba260554$export$a19185d1233fc4b2.attrs.shortName.default,
                    id: dom.getAttribute('data-emoji-id') || $0519ed9fba260554$export$a19185d1233fc4b2.attrs.id.default,
                    text: dom.getAttribute('data-emoji-text') || $0519ed9fba260554$export$a19185d1233fc4b2.attrs.text.default,
                    localId: (0, $l4823.uuid).generate()
                };
            }
        },
        // Handle copy/paste from old <ac:emoticon />
        {
            tag: 'img[data-emoticon-name]',
            getAttrs: function getAttrs(dom) {
                var attrs = (0, $6ktYw.acNameToEmoji)(dom.getAttribute('data-emoticon-name'));
                return $0519ed9fba260554$var$_objectSpread($0519ed9fba260554$var$_objectSpread({}, attrs), {}, {
                    localId: (0, $l4823.uuid).generate()
                });
            }
        },
        // Handle copy/paste from old <ac:hipchat-emoticons />
        {
            tag: 'img[data-hipchat-emoticon]',
            getAttrs: function getAttrs(dom) {
                var attrs = (0, $6ktYw.acShortcutToEmoji)(dom.getAttribute('data-hipchat-emoticon'));
                return $0519ed9fba260554$var$_objectSpread($0519ed9fba260554$var$_objectSpread({}, attrs), {}, {
                    localId: (0, $l4823.uuid).generate()
                });
            }
        },
        // Handle copy/paste from bitbucket's <img class="emoji" />
        {
            tag: 'img.emoji[data-emoji-short-name]',
            getAttrs: function getAttrs(domNode) {
                var dom = domNode;
                return {
                    shortName: dom.getAttribute('data-emoji-short-name') || $0519ed9fba260554$export$a19185d1233fc4b2.attrs.shortName.default,
                    id: dom.getAttribute('data-emoji-id') || $0519ed9fba260554$export$a19185d1233fc4b2.attrs.id.default,
                    text: dom.getAttribute('data-emoji-text') || $0519ed9fba260554$export$a19185d1233fc4b2.attrs.text.default,
                    localId: (0, $l4823.uuid).generate()
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node$attrs3;
        var _node$attrs2 = node.attrs, shortName = _node$attrs2.shortName, id = _node$attrs2.id, text = _node$attrs2.text;
        var attrs = {
            'data-emoji-short-name': shortName,
            'data-emoji-id': id,
            'data-emoji-text': text,
            contenteditable: 'false',
            'data-local-id': (node === null || node === void 0 ? void 0 : (_node$attrs3 = node.attrs) === null || _node$attrs3 === void 0 ? void 0 : _node$attrs3.localId) || undefined
        };
        return [
            'span',
            attrs,
            text
        ];
    }
});

});
parcelRegister("6ktYw", function(module, exports) {
$parcel$export(module.exports, "acNameToEmoji", () => $49bbdccb6782eda4$export$f61e93bda2a8b420);
$parcel$export(module.exports, "acShortcutToEmoji", () => $49bbdccb6782eda4$export$441f8b58f5790a68);
// Default emoji id for Confluence glyphs that has no match to Fabric Emoji
var $49bbdccb6782eda4$var$DEFAULT_EMOJI_ID = '2b50';
// Default ac:name for emoticons as a fallback is `blue-star`
var $49bbdccb6782eda4$var$DEFAULT_EMOJI_ACNAME = 'blue-star';
// ac:hipchat-emoticon prefix when converting to Emoji ID
var $49bbdccb6782eda4$var$HC_EMOTICON_PREFIX = 'atlassian-';
/**
 * Confluence glyphs ac:name of <ac:emoticon /> map to new emojis
 * {
 *   [ac:name] : ['emoji-id', 'emoji-shortName', 'emoji-fallback']
 *   ...
 * }
 * Glyphs that do not map to Fabric Emoji
 * will be mapped to Emoji Id '2b50' (:star:) with preserving ac:name as shortName attribute;
 */ var $49bbdccb6782eda4$var$acNameToEmojiMap = {
    smile: [
        '1f642',
        ':slight_smile:',
        "\uD83D\uDE42"
    ],
    sad: [
        '1f641',
        ':slight_frown:',
        "\uD83D\uDE41"
    ],
    cheeky: [
        '1f61b',
        ':stuck_out_tongue:',
        "\uD83D\uDE1B"
    ],
    laugh: [
        '1f600',
        ':grinning:',
        "\uD83D\uDE00"
    ],
    wink: [
        '1f609',
        ':wink:',
        "\uD83D\uDE09"
    ],
    information: [
        '2139',
        ':information_source:',
        "\u2139"
    ],
    tick: [
        '2705',
        ':white_check_mark:',
        "\u2705"
    ],
    cross: [
        '274c',
        ':x:',
        "\u274C"
    ],
    warning: [
        '26a0',
        ':warning:',
        "\u26A0"
    ],
    plus: [
        '2795',
        ':heavy_plus_sign:',
        "\u2795"
    ],
    minus: [
        '2796',
        ':heavy_minus_sign:',
        "\u2796"
    ],
    question: [
        '2753',
        ':question:',
        "?"
    ],
    'thumbs-up': [
        '1f44d',
        ':thumbsup:',
        "\uD83D\uDC4D"
    ],
    'thumbs-down': [
        '1f44e',
        ':thumbsdown:',
        "\uD83D\uDC4E"
    ],
    'light-on': [
        '1f4a1',
        ':bulb:',
        "\uD83D\uDCA1"
    ],
    'yellow-star': [
        '2b50',
        ':star:',
        "\uD83D\uDC9B"
    ],
    'light-off': [
        '1f6ab',
        ':no_entry_sign:',
        "\uD83D\uDEAB"
    ],
    'red-star': [
        '2764',
        ':heart:',
        "\u2764\uFE0F"
    ],
    'green-star': [
        '1f49a',
        ':green_heart:',
        "\uD83D\uDC9A"
    ],
    'blue-star': [
        '1f499',
        ':blue_heart:',
        "\uD83D\uDC99"
    ],
    heart: [
        '2764',
        ':heart:',
        "\u2764\uFE0F"
    ],
    'broken-heart': [
        '1f494',
        ':broken_heart:',
        "\uD83D\uDC94"
    ]
};
function $49bbdccb6782eda4$export$f61e93bda2a8b420(acName) {
    var emojiData = $49bbdccb6782eda4$var$acNameToEmojiMap[acName];
    return emojiData ? {
        id: emojiData[0],
        shortName: emojiData[1],
        text: emojiData[2]
    } : {
        id: $49bbdccb6782eda4$var$DEFAULT_EMOJI_ID,
        shortName: ":".concat(acName, ":"),
        text: ''
    };
}
function $49bbdccb6782eda4$export$bc94e44ec0e7bd82(emojiId) {
    var filterEmojis = function filterEmojis(acName) {
        return $49bbdccb6782eda4$var$acNameToEmojiMap[acName] ? $49bbdccb6782eda4$var$acNameToEmojiMap[acName][0] === emojiId : false;
    };
    return Object.keys($49bbdccb6782eda4$var$acNameToEmojiMap).filter(filterEmojis)[0];
}
function $49bbdccb6782eda4$export$441f8b58f5790a68(hipchatEmoticonShortName) {
    return {
        id: "".concat($49bbdccb6782eda4$var$HC_EMOTICON_PREFIX).concat(hipchatEmoticonShortName),
        shortName: ":".concat(hipchatEmoticonShortName, ":"),
        text: ''
    };
}
function $49bbdccb6782eda4$var$getAcNameFromShortName(shortName) {
    return shortName.slice(shortName[0] === ':' ? 1 : 0, shortName[shortName.length - 1] === ':' ? -1 : shortName.length);
}
function $49bbdccb6782eda4$export$880a2465992fbbe(_ref) {
    var id = _ref.id, shortName = _ref.shortName;
    if ($49bbdccb6782eda4$var$DEFAULT_EMOJI_ID === id) {
        var possibleName = $49bbdccb6782eda4$var$getAcNameFromShortName(shortName);
        if (possibleName in $49bbdccb6782eda4$var$acNameToEmojiMap) return possibleName;
    }
    return $49bbdccb6782eda4$export$bc94e44ec0e7bd82(id) || $49bbdccb6782eda4$var$DEFAULT_EMOJI_ACNAME;
}

});


parcelRegister("kUp6y", function(module, exports) {
$parcel$export(module.exports, "extendedBlockquote", () => $f38c82de0dfe6d23$export$70a64939da3e8455);

var $2gWGi = parcelRequire("2gWGi");

var $l4823 = parcelRequire("l4823");
/**
 * @name blockquote_node
 */ var $f38c82de0dfe6d23$var$nodeSpecOptions = {
    parseDOM: [
        {
            tag: 'blockquote'
        }
    ],
    toDOM: function toDOM() {
        return [
            'blockquote',
            0
        ];
    }
};
var $f38c82de0dfe6d23$export$67dc04e652a298ca = (0, $2gWGi.blockquoteLegacy)($f38c82de0dfe6d23$var$nodeSpecOptions);
var $f38c82de0dfe6d23$export$70a64939da3e8455 = (0, $2gWGi.blockquote)($f38c82de0dfe6d23$var$nodeSpecOptions);
var $f38c82de0dfe6d23$var$nodeSpecOptionsWithLocalId = {
    parseDOM: [
        {
            tag: 'blockquote',
            getAttrs: function getAttrs() {
                return {
                    localId: (0, $l4823.uuid).generate()
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node$attrs;
        return [
            'blockquote',
            {
                'data-local-id': (node === null || node === void 0 ? void 0 : (_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.localId) || undefined
            },
            0
        ];
    }
};
var $f38c82de0dfe6d23$export$950ebf43f3364a0f = (0, $2gWGi.blockquote)($f38c82de0dfe6d23$var$nodeSpecOptionsWithLocalId);

});

parcelRegister("18mVh", function(module, exports) {
$parcel$export(module.exports, "PanelType", () => $0d3851d35c40c2fb$export$969277cf61e5a7aa);
$parcel$export(module.exports, "extendedPanel", () => $0d3851d35c40c2fb$export$ce20b13564211141);

var $25nEq = parcelRequire("25nEq");

var $2gWGi = parcelRequire("2gWGi");

var $l4823 = parcelRequire("l4823");
function $0d3851d35c40c2fb$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $0d3851d35c40c2fb$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $0d3851d35c40c2fb$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $0d3851d35c40c2fb$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $0d3851d35c40c2fb$export$969277cf61e5a7aa = /*#__PURE__*/ function(PanelType) {
    PanelType["INFO"] = "info";
    PanelType["NOTE"] = "note";
    PanelType["TIP"] = "tip";
    PanelType["WARNING"] = "warning";
    PanelType["ERROR"] = "error";
    PanelType["SUCCESS"] = "success";
    PanelType["CUSTOM"] = "custom";
    return PanelType;
}({});
/**
 * @name panel_node
 */ var $0d3851d35c40c2fb$var$getDomAttrs = function getDomAttrs(nodeAttrs) {
    var attrs = {
        'data-panel-type': nodeAttrs.panelType,
        'data-panel-icon': nodeAttrs.panelIcon,
        'data-panel-icon-id': nodeAttrs.panelIconId,
        'data-panel-icon-text': nodeAttrs.panelIconText,
        'data-panel-color': nodeAttrs.panelColor,
        'data-local-id': (nodeAttrs === null || nodeAttrs === void 0 ? void 0 : nodeAttrs.localId) || undefined
    };
    return attrs;
};
var $0d3851d35c40c2fb$var$getParseDOMAttrs = function getParseDOMAttrs(allowCustomPanel, dom, generateLocalId) {
    var parseDOMAttrs = {
        panelType: dom.getAttribute('data-panel-type')
    };
    if (generateLocalId) parseDOMAttrs.localId = (0, $l4823.uuid).generate();
    if (allowCustomPanel) parseDOMAttrs = $0d3851d35c40c2fb$var$_objectSpread($0d3851d35c40c2fb$var$_objectSpread({}, parseDOMAttrs), {}, {
        panelIcon: dom.getAttribute('data-panel-icon'),
        panelIconId: dom.getAttribute('data-panel-icon-id'),
        panelIconText: dom.getAttribute('data-panel-icon-text'),
        panelColor: dom.getAttribute('data-panel-color')
    });
    else parseDOMAttrs.panelType = parseDOMAttrs.panelType === $0d3851d35c40c2fb$export$969277cf61e5a7aa.CUSTOM ? $0d3851d35c40c2fb$export$969277cf61e5a7aa.INFO : parseDOMAttrs.panelType;
    return parseDOMAttrs;
};
var $0d3851d35c40c2fb$var$createPanelNodeSpecOptions = function createPanelNodeSpecOptions(allowCustomPanel, generateLocalId) {
    return {
        parseDOM: [
            {
                tag: 'div[data-panel-type]',
                getAttrs: function getAttrs(dom) {
                    return $0d3851d35c40c2fb$var$getParseDOMAttrs(allowCustomPanel, dom, generateLocalId);
                }
            }
        ],
        toDOM: function toDOM(node) {
            var attrs = $0d3851d35c40c2fb$var$getDomAttrs(node.attrs);
            var contentAttrs = {
                'data-panel-content': 'true'
            };
            return [
                'div',
                attrs,
                [
                    'div',
                    contentAttrs,
                    0
                ]
            ];
        }
    };
};
var $0d3851d35c40c2fb$export$ce20b13564211141 = function extendedPanel(allowCustomPanel) {
    return (0, $2gWGi.panel)($0d3851d35c40c2fb$var$createPanelNodeSpecOptions(allowCustomPanel));
};
var $0d3851d35c40c2fb$export$855c3c67c9c9ebaf = function extendedPanelWithLocalId(allowCustomPanel) {
    return (0, $2gWGi.panel)($0d3851d35c40c2fb$var$createPanelNodeSpecOptions(allowCustomPanel, true));
};

});

parcelRegister("cnShX", function(module, exports) {
$parcel$export(module.exports, "extension", () => $9041bea1cb0f5c80$export$1b45514b112dd749);

var $ljjv5 = parcelRequire("ljjv5");

var $2gWGi = parcelRequire("2gWGi");
var $9041bea1cb0f5c80$export$1b45514b112dd749 = (0, $2gWGi.extension)({
    parseDOM: [
        {
            tag: '[data-node-type="extension"]',
            getAttrs: function getAttrs(domNode) {
                return (0, $ljjv5.getExtensionAttrs)(domNode);
            }
        }
    ],
    toDOM: function toDOM(node) {
        var attrs = {
            'data-node-type': 'extension',
            'data-extension-type': node.attrs.extensionType,
            'data-extension-key': node.attrs.extensionKey,
            'data-text': node.attrs.text,
            'data-parameters': JSON.stringify(node.attrs.parameters),
            'data-layout': node.attrs.layout,
            'data-local-id:': node.attrs.localId
        };
        return [
            'div',
            attrs
        ];
    }
});

});

parcelRegister("blZvD", function(module, exports) {
$parcel$export(module.exports, "hardBreak", () => $84415e4f4d00d7c1$export$371da9dd35aba193);

var $2gWGi = parcelRequire("2gWGi");
var $84415e4f4d00d7c1$export$371da9dd35aba193 = (0, $2gWGi.hardBreak)({
    parseDOM: [
        {
            tag: 'br'
        }
    ],
    toDOM: function toDOM() {
        return [
            'br'
        ];
    }
});

});

parcelRegister("lta2M", function(module, exports) {
$parcel$export(module.exports, "heading", () => $fa1418ee148b8b3a$export$46e4a324ac90507f);

var $2gWGi = parcelRequire("2gWGi");
/**
 * @name heading_node
 */ /**
 * @name heading_with_no_marks_node
 */ // Check `paragraph` node for why we are doing things like this
/**
 * @name heading_with_alignment_node
 */ /**
 * @name heading_with_indentation_node
 */ var $fa1418ee148b8b3a$var$getAttrs = function getAttrs(level) {
    return function(domNode) {
        var _heading$attrs, _heading$attrs$localI;
        return {
            level: level,
            localId: domNode.getAttribute('data-local-id') || ((_heading$attrs = $fa1418ee148b8b3a$export$46e4a324ac90507f.attrs) === null || _heading$attrs === void 0 ? void 0 : (_heading$attrs$localI = _heading$attrs.localId) === null || _heading$attrs$localI === void 0 ? void 0 : _heading$attrs$localI.default)
        };
    };
};
var $fa1418ee148b8b3a$export$46e4a324ac90507f = (0, $2gWGi.heading)({
    parseDOM: [
        {
            tag: 'h1',
            getAttrs: $fa1418ee148b8b3a$var$getAttrs(1)
        },
        {
            tag: 'h2',
            getAttrs: $fa1418ee148b8b3a$var$getAttrs(2)
        },
        {
            tag: 'h3',
            getAttrs: $fa1418ee148b8b3a$var$getAttrs(3)
        },
        {
            tag: 'h4',
            getAttrs: $fa1418ee148b8b3a$var$getAttrs(4)
        },
        {
            tag: 'h5',
            getAttrs: $fa1418ee148b8b3a$var$getAttrs(5)
        },
        {
            tag: 'h6',
            getAttrs: $fa1418ee148b8b3a$var$getAttrs(6)
        }
    ],
    toDOM: function toDOM(node) {
        var _node$attrs = node.attrs, level = _node$attrs.level, localId = _node$attrs.localId;
        var name = 'h' + level;
        var attrs = localId !== undefined && localId !== null ? [
            {
                'data-local-id': localId
            }
        ] : [];
        return [
            name
        ].concat(attrs, [
            0
        ]);
    }
});

});

parcelRegister("7S1Am", function(module, exports) {
$parcel$export(module.exports, "image", () => $5baece5f0a467918$export$5c452ff88e35e47d);

var $2gWGi = parcelRequire("2gWGi");
var $5baece5f0a467918$export$5c452ff88e35e47d = (0, $2gWGi.image)({
    parseDOM: [
        {
            tag: 'img[src^="data:image/"]',
            ignore: true
        },
        {
            tag: 'img[src]',
            getAttrs: function getAttrs(domNode) {
                var dom = domNode;
                return {
                    src: dom.getAttribute('src'),
                    alt: dom.getAttribute('alt'),
                    title: dom.getAttribute('title')
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        return [
            'img',
            node.attrs
        ];
    }
});

});

parcelRegister("7YGzk", function(module, exports) {
$parcel$export(module.exports, "inlineCard", () => $5cef2844eb49532a$export$cbf8224b64e0d942);

var $2gWGi = parcelRequire("2gWGi");

var $l4823 = parcelRequire("l4823");
var $5cef2844eb49532a$export$cbf8224b64e0d942 = (0, $2gWGi.inlineCard)({
    parseDOM: [
        {
            tag: 'a[data-inline-card], span[data-inline-card]',
            // bump priority higher than hyperlink
            priority: 100,
            getAttrs: function getAttrs(dom) {
                var anchor = dom;
                var data = anchor.getAttribute('data-card-data');
                /* Support attrs from Editor and Renderer */ return {
                    url: anchor.getAttribute('href') || anchor.getAttribute('data-card-url') || null,
                    data: data ? JSON.parse(data) : null
                };
            }
        },
        // for renderer
        {
            tag: 'div[data-inline-card]',
            getAttrs: function getAttrs(dom) {
                var anchor = dom;
                var data = anchor.getAttribute('data-card-data');
                return {
                    url: anchor.getAttribute('data-card-url'),
                    data: data ? JSON.parse(data) : null
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var attrs = {
            'data-inline-card': '',
            href: node.attrs.url || '',
            'data-card-data': node.attrs.data ? JSON.stringify(node.attrs.data) : ''
        };
        if (node.attrs.url) return [
            'a',
            attrs,
            node.attrs.url
        ];
        else return [
            'a',
            attrs
        ];
    }
});
var $5cef2844eb49532a$export$7ed775fc743eadd1 = (0, $2gWGi.inlineCard)({
    parseDOM: [
        {
            tag: 'a[data-inline-card], span[data-inline-card]',
            // bump priority higher than hyperlink
            priority: 100,
            getAttrs: function getAttrs(dom) {
                var anchor = dom;
                var data = anchor.getAttribute('data-card-data');
                /* Support attrs from Editor and Renderer */ return {
                    url: anchor.getAttribute('href') || anchor.getAttribute('data-card-url') || null,
                    data: data ? JSON.parse(data) : null,
                    localId: (0, $l4823.uuid).generate()
                };
            }
        },
        // for renderer
        {
            tag: 'div[data-inline-card]',
            getAttrs: function getAttrs(dom) {
                var anchor = dom;
                var data = anchor.getAttribute('data-card-data');
                return {
                    url: anchor.getAttribute('data-card-url'),
                    data: data ? JSON.parse(data) : null,
                    localId: (0, $l4823.uuid).generate()
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node$attrs;
        var attrs = {
            'data-inline-card': '',
            href: node.attrs.url || '',
            'data-card-data': node.attrs.data ? JSON.stringify(node.attrs.data) : '',
            'data-local-id': (node === null || node === void 0 ? void 0 : (_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.localId) || undefined
        };
        if (node.attrs.url) return [
            'a',
            attrs,
            node.attrs.url
        ];
        else return [
            'a',
            attrs
        ];
    }
});

});

parcelRegister("kuUB8", function(module, exports) {
$parcel$export(module.exports, "inlineExtension", () => $eec2832b126ddd0a$export$16b353b2649bd8d9);

var $ljjv5 = parcelRequire("ljjv5");

var $2gWGi = parcelRequire("2gWGi");
var $eec2832b126ddd0a$export$16b353b2649bd8d9 = (0, $2gWGi.inlineExtensionWithMarks)({
    parseDOM: [
        {
            tag: 'span[data-extension-type]',
            getAttrs: function getAttrs(domNode) {
                return (0, $ljjv5.getExtensionAttrs)(domNode, true);
            }
        }
    ],
    toDOM: function toDOM(node) {
        var attrs = {
            'data-extension-type': node.attrs.extensionType,
            'data-extension-key': node.attrs.extensionKey,
            'data-text': node.attrs.text,
            'data-parameters': JSON.stringify(node.attrs.parameters),
            'data-local-id:': node.attrs.localId,
            contenteditable: 'false'
        };
        return [
            'span',
            attrs
        ];
    }
});

});

parcelRegister("iXSQk", function(module, exports) {
$parcel$export(module.exports, "layoutColumn", () => $dce847576bfa2e82$export$ab76e7c03cd6f650);

var $2gWGi = parcelRequire("2gWGi");

var $l4823 = parcelRequire("l4823");
var $dce847576bfa2e82$export$ab76e7c03cd6f650 = (0, $2gWGi.layoutColumn)({
    parseDOM: [
        {
            context: 'layoutColumn//',
            tag: 'div[data-layout-column]',
            skip: true
        },
        {
            tag: 'div[data-layout-column]',
            getAttrs: function getAttrs(domNode) {
                var dom = domNode;
                return {
                    width: Number(dom.getAttribute('data-column-width')) || undefined
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var attrs = {
            'data-layout-column': 'true'
        };
        var width = node.attrs.width;
        if (width) {
            attrs['style'] = "flex-basis: ".concat(width, "%");
            attrs['data-column-width'] = "".concat(width);
        }
        // We need to apply a attribute to the inner most child to help
        // ProseMirror identify its boundaries better.
        var contentAttrs = {
            'data-layout-content': 'true'
        };
        return [
            'div',
            attrs,
            [
                'div',
                contentAttrs,
                0
            ]
        ];
    }
});
var $dce847576bfa2e82$export$b2e27d292505bac2 = (0, $2gWGi.layoutColumn)({
    parseDOM: [
        {
            context: 'layoutColumn//',
            tag: 'div[data-layout-column]',
            skip: true
        },
        {
            tag: 'div[data-layout-column]',
            getAttrs: function getAttrs(domNode) {
                var dom = domNode;
                return {
                    width: Number(dom.getAttribute('data-column-width')) || undefined,
                    localId: (0, $l4823.uuid).generate()
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node$attrs;
        var attrs = {
            'data-layout-column': 'true',
            'data-local-id': (node === null || node === void 0 ? void 0 : (_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.localId) || undefined
        };
        var width = node.attrs.width;
        if (width) {
            attrs['style'] = "flex-basis: ".concat(width, "%");
            attrs['data-column-width'] = "".concat(width);
        }
        // We need to apply a attribute to the inner most child to help
        // ProseMirror identify its boundaries better.
        var contentAttrs = {
            'data-layout-content': 'true'
        };
        return [
            'div',
            attrs,
            [
                'div',
                contentAttrs,
                0
            ]
        ];
    }
});

});

parcelRegister("6wWv8", function(module, exports) {
$parcel$export(module.exports, "createMediaSpec", () => $4c131c6043ad0d60$export$35bdbf5bc8caa677);
$parcel$export(module.exports, "media", () => $4c131c6043ad0d60$export$987d49ffe1b0900f);
$parcel$export(module.exports, "toJSON", () => $4c131c6043ad0d60$export$54fd2c36b5cc6731);

var $25nEq = parcelRequire("25nEq");

var $22vaF = parcelRequire("22vaF");

var $2gWGi = parcelRequire("2gWGi");

var $l4823 = parcelRequire("l4823");
function $4c131c6043ad0d60$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $4c131c6043ad0d60$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $4c131c6043ad0d60$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $4c131c6043ad0d60$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $4c131c6043ad0d60$export$bb3fe706be61f640 = (0, $2gWGi.media)({}).attrs;
var $4c131c6043ad0d60$export$35bdbf5bc8caa677 = function createMediaSpec(attributes) {
    var inline = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var generateLocalId = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    var domNodeType = inline ? 'span' : 'div';
    var nodeName = inline ? 'mediaInline' : 'media';
    var parseDOM = [
        {
            tag: "".concat(domNodeType, "[data-node-type=\"").concat(nodeName, "\"]"),
            getAttrs: function getAttrs(dom) {
                var attrs = {};
                if (attributes) Object.keys(attributes).forEach(function(k) {
                    var key = $4c131c6043ad0d60$export$f84fdfb973c05bd8(k).replace(/^__/, '');
                    var value = dom.getAttribute("data-".concat(key)) || '';
                    if (value) attrs[k] = value;
                });
                // Need to do validation & type conversion manually
                if (attrs.__fileSize) attrs.__fileSize = +attrs.__fileSize;
                var width = Number(attrs.width);
                if (typeof width !== 'undefined' && !isNaN(width)) attrs.width = width;
                var height = Number(attrs.height);
                if (typeof height !== 'undefined' && !isNaN(height)) attrs.height = height;
                if (generateLocalId) attrs.localId = (0, $l4823.uuid).generate();
                return attrs;
            }
        },
        // Don't match data URI
        {
            tag: 'img[src^="data:image"]',
            ignore: true
        }
    ];
    var toDOM = function toDOM(node) {
        var attrs = {
            'data-id': node.attrs.id,
            'data-node-type': "".concat(nodeName),
            'data-type': node.attrs.type,
            'data-collection': node.attrs.collection,
            'data-occurrence-key': node.attrs.occurrenceKey,
            'data-width': node.attrs.width,
            'data-height': node.attrs.height,
            'data-url': node.attrs.url,
            'data-alt': node.attrs.alt,
            'data-local-id': node.attrs.localId || undefined,
            // toDOM is used for static rendering as well as editor rendering. This comes into play for
            // emails, copy/paste, etc, so the title and styling here *is* useful (despite a React-based
            // node view being used for editing).
            title: 'Attachment',
            // Manually kept in sync with the style of media cards. The goal is to render a plain gray
            // rectangle that provides an affordance for media.
            style: "display: inline-block; border-radius: 3px; background: ".concat((0, $22vaF.N30), "; box-shadow: 0 1px 1px rgba(9, 30, 66, 0.2), 0 0 1px 0 rgba(9, 30, 66, 0.24);")
        };
        $4c131c6043ad0d60$export$111130fa8968d741(node.attrs, attrs, function(key) {
            return "data-".concat($4c131c6043ad0d60$export$f84fdfb973c05bd8(key.slice(2)));
        });
        return [
            "".concat(domNodeType),
            attrs
        ];
    };
    if (inline) return (0, $2gWGi.mediaInline)({
        parseDOM: parseDOM,
        toDOM: toDOM
    });
    return (0, $2gWGi.media)({
        parseDOM: [].concat(parseDOM, [
            {
                // media-inline.ts uses this same function to generate the nodespec
                // this ensures that we don't make a media inline out of a copied image
                // https://product-fabric.atlassian.net/browse/EDM-2996
                tag: 'img:not(.smart-link-icon)',
                getAttrs: function getAttrs(dom) {
                    var attrs = {
                        type: 'external',
                        url: dom.getAttribute('src') || '',
                        alt: dom.getAttribute('alt') || ''
                    };
                    if (generateLocalId) attrs.localId = (0, $l4823.uuid).generate();
                    return attrs;
                }
            }
        ]),
        toDOM: toDOM
    });
};
var $4c131c6043ad0d60$export$987d49ffe1b0900f = $4c131c6043ad0d60$export$35bdbf5bc8caa677($4c131c6043ad0d60$export$bb3fe706be61f640, false, false);
var $4c131c6043ad0d60$export$8446e47a4c7fd000 = $4c131c6043ad0d60$export$35bdbf5bc8caa677($4c131c6043ad0d60$var$_objectSpread($4c131c6043ad0d60$var$_objectSpread({}, $4c131c6043ad0d60$export$bb3fe706be61f640), {}, {
    localId: {
        default: (0, $l4823.uuid).generate()
    }
}), false, true);
var $4c131c6043ad0d60$export$f84fdfb973c05bd8 = function camelCaseToKebabCase(str) {
    return str.replace(/([^A-Z]+)([A-Z])/g, function(_, x, y) {
        return "".concat(x, "-").concat(y.toLowerCase());
    });
};
var $4c131c6043ad0d60$export$111130fa8968d741 = function copyPrivateAttributes(from, to, map) {
    if ($4c131c6043ad0d60$export$987d49ffe1b0900f.attrs) Object.keys($4c131c6043ad0d60$export$987d49ffe1b0900f.attrs).forEach(function(key) {
        if (key[0] === '_' && key[1] === '_' && from[key]) to[map ? map(key) : key] = from[key];
    });
};
/**
 * There's no concept of optional property in ProseMirror. It sets value as `null`
 * when there's no use of any property. We are filtering out all private & optional attrs here.
 */ var $4c131c6043ad0d60$var$optionalAttributes = [
    'occurrenceKey',
    'width',
    'height',
    'url',
    'alt',
    'localId'
];
var $4c131c6043ad0d60$var$externalOnlyAttributes = [
    'type',
    'url',
    'width',
    'height',
    'alt',
    'localId'
];
var $4c131c6043ad0d60$export$54fd2c36b5cc6731 = function toJSON(node) {
    return {
        attrs: Object.keys(node.attrs)// Strip private attributes e.g. __fileName, __fileSize, __fileMimeType, etc.
        .filter(function(key) {
            return !(key[0] === '_' && key[1] === '_');
        }).reduce(function(obj, key) {
            if (node.attrs.type === 'external' && $4c131c6043ad0d60$var$externalOnlyAttributes.indexOf(key) === -1) return obj;
            if ($4c131c6043ad0d60$var$optionalAttributes.indexOf(key) > -1 && (node.attrs[key] === null || node.attrs[key] === '')) return obj;
            if ([
                'width',
                'height'
            ].indexOf(key) !== -1) {
                obj[key] = Number(node.attrs[key]);
                return obj;
            }
            obj[key] = node.attrs[key];
            return obj;
        }, {})
    };
};

});

parcelRegister("21g1t", function(module, exports) {
$parcel$export(module.exports, "mediaGroup", () => $17881a914a2cf857$export$2855e964765eac9);

var $2gWGi = parcelRequire("2gWGi");
var $17881a914a2cf857$export$2855e964765eac9 = (0, $2gWGi.mediaGroup)({
    parseDOM: [
        {
            tag: 'div[data-node-type="mediaGroup"]'
        },
        {
            tag: 'div[class="MediaGroup"]'
        }
    ],
    toDOM: function toDOM() {
        return [
            'div',
            {
                'data-node-type': 'mediaGroup'
            },
            0
        ];
    }
});

});

parcelRegister("jzlkh", function(module, exports) {
$parcel$export(module.exports, "mediaInline", () => $e3f1d41d42ac667f$export$38bab695e3f720f1);

var $25nEq = parcelRequire("25nEq");

var $6wWv8 = parcelRequire("6wWv8");

var $l4823 = parcelRequire("l4823");

var $2gWGi = parcelRequire("2gWGi");
function $e3f1d41d42ac667f$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $e3f1d41d42ac667f$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $e3f1d41d42ac667f$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $e3f1d41d42ac667f$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $e3f1d41d42ac667f$export$38bab695e3f720f1 = (0, $6wWv8.createMediaSpec)((0, $2gWGi.mediaInline)({}).attrs, true);
var $e3f1d41d42ac667f$export$aea8e9c496505c61 = (0, $6wWv8.createMediaSpec)($e3f1d41d42ac667f$var$_objectSpread($e3f1d41d42ac667f$var$_objectSpread({}, (0, $2gWGi.mediaInline)({}).attrs), {}, {
    localId: {
        default: (0, $l4823.uuid).generate()
    }
}), true, true);

});

parcelRegister("8JhSw", function(module, exports) {
$parcel$export(module.exports, "mediaSingleFull", () => $65b064f7fbebe4c2$export$7e767666f2ce108a);
$parcel$export(module.exports, "toJSON", () => $65b064f7fbebe4c2$export$54fd2c36b5cc6731);

var $25nEq = parcelRequire("25nEq");

var $5idWB = parcelRequire("5idWB");

var $fBYOr = parcelRequire("fBYOr");

var $2gWGi = parcelRequire("2gWGi");

var $l4823 = parcelRequire("l4823");
function $65b064f7fbebe4c2$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $65b064f7fbebe4c2$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $65b064f7fbebe4c2$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $65b064f7fbebe4c2$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $65b064f7fbebe4c2$export$bb3fe706be61f640 = {
    width: {
        default: null
    },
    // null makes small images to have original size by default
    layout: {
        default: 'center'
    }
};
var $65b064f7fbebe4c2$export$5a1e124099b60c6b = function mediaSingleSpec(_ref) {
    var _ref$withCaption = _ref.withCaption, withCaption = _ref$withCaption === void 0 ? false : _ref$withCaption, _ref$withExtendedWidt = _ref.withExtendedWidthTypes, withExtendedWidthTypes = _ref$withExtendedWidt === void 0 ? false : _ref$withExtendedWidt, _ref$generateLocalId = _ref.generateLocalId, generateLocalId = _ref$generateLocalId === void 0 ? false : _ref$generateLocalId;
    var getAttrs = function getAttrs(dom) {
        if (!(0, $fBYOr.isDOMElement)(dom)) // this should never happen
        return {
            layout: 'center'
        };
        var layout = dom.getAttribute('data-layout') || 'center';
        var width = Number(dom.getAttribute('data-width')) || null;
        var widthType = dom.getAttribute('data-width-type');
        if (generateLocalId) return {
            layout: layout,
            width: width,
            widthType: widthType,
            localId: (0, $l4823.uuid).generate()
        };
        if (withExtendedWidthTypes) return {
            layout: layout,
            width: width,
            widthType: widthType
        };
        else if (widthType === (0, $5idWB.WidthType).PIXEL) // if editor does not support widthType attribute.
        // We ignore width and widthType together.
        return {
            layout: layout
        };
        else return {
            layout: layout,
            width: width
        };
    };
    var getAttrsFromNode = function getAttrsFromNode(node) {
        var _node$attrs = node.attrs, layout = _node$attrs.layout, width = _node$attrs.width;
        var attrs = {
            'data-node-type': 'mediaSingle',
            'data-layout': layout,
            'data-width': ''
        };
        if (generateLocalId) {
            var _node$attrs2;
            attrs['data-local-id'] = (node === null || node === void 0 ? void 0 : (_node$attrs2 = node.attrs) === null || _node$attrs2 === void 0 ? void 0 : _node$attrs2.localId) || undefined;
        }
        if (width) attrs['data-width'] = isFinite(width) && Math.floor(width) === width ? width : width.toFixed(2);
        if (withExtendedWidthTypes && node.attrs.widthType) {
            var widthType = node.attrs.widthType;
            return $65b064f7fbebe4c2$var$_objectSpread($65b064f7fbebe4c2$var$_objectSpread({}, attrs), {}, {
                'data-width-type': widthType || (0, $5idWB.WidthType).PERCENTAGE
            });
        }
        return attrs;
    };
    if (withExtendedWidthTypes && withCaption) return (0, $2gWGi.mediaSingleFull)({
        parseDOM: [
            {
                tag: 'div[data-node-type="mediaSingle"]',
                getAttrs: getAttrs
            }
        ],
        toDOM: function toDOM(node) {
            return [
                'div',
                getAttrsFromNode(node),
                0
            ];
        }
    });
    if (withExtendedWidthTypes && !withCaption) return (0, $2gWGi.mediaSingleWidthType)({
        parseDOM: [
            {
                tag: 'div[data-node-type="mediaSingle"]',
                getAttrs: getAttrs
            }
        ],
        toDOM: function toDOM(node) {
            return [
                'div',
                getAttrsFromNode(node),
                0
            ];
        }
    });
    if (!withExtendedWidthTypes && withCaption) return (0, $2gWGi.mediaSingleCaption)({
        parseDOM: [
            {
                tag: 'div[data-node-type="mediaSingle"]',
                getAttrs: getAttrs
            }
        ],
        toDOM: function toDOM(node) {
            return [
                'div',
                getAttrsFromNode(node),
                0
            ];
        }
    });
    return (0, $2gWGi.mediaSingle)({
        parseDOM: [
            {
                tag: 'div[data-node-type="mediaSingle"]',
                getAttrs: getAttrs
            }
        ],
        toDOM: function toDOM(node) {
            return [
                'div',
                getAttrsFromNode(node),
                0
            ];
        }
    });
};
var $65b064f7fbebe4c2$export$969fe3781ca15058 = $65b064f7fbebe4c2$export$5a1e124099b60c6b({
    withCaption: false,
    withExtendedWidthTypes: false
});
var $65b064f7fbebe4c2$export$d35e6c006d4abdfb = $65b064f7fbebe4c2$export$5a1e124099b60c6b({
    withCaption: true,
    withExtendedWidthTypes: false
});
var $65b064f7fbebe4c2$export$9c58e19811ce4cf5 = $65b064f7fbebe4c2$export$5a1e124099b60c6b({
    withCaption: false,
    withExtendedWidthTypes: true
});
var $65b064f7fbebe4c2$export$7e767666f2ce108a = $65b064f7fbebe4c2$export$5a1e124099b60c6b({
    withCaption: true,
    withExtendedWidthTypes: true
});
var $65b064f7fbebe4c2$export$75376a385837c942 = $65b064f7fbebe4c2$export$5a1e124099b60c6b({
    withCaption: true,
    withExtendedWidthTypes: true,
    generateLocalId: true
});
var $65b064f7fbebe4c2$export$54fd2c36b5cc6731 = function toJSON(node) {
    return {
        attrs: Object.keys(node.attrs).reduce(function(obj, key) {
            if (node.attrs[key] !== null) obj[key] = node.attrs[key];
            return obj;
        }, {})
    };
};

});
parcelRegister("5idWB", function(module, exports) {
$parcel$export(module.exports, "WidthType", () => $3da9733cf4e7ae0e$export$4d41558722ac7eed);
/**
 * @description The widthType attribute is used to support fixed with media single
 */ var $3da9733cf4e7ae0e$export$4d41558722ac7eed = /*#__PURE__*/ function(WidthType) {
    WidthType["PIXEL"] = "pixel";
    WidthType["PERCENTAGE"] = "percentage";
    return WidthType;
}({});

});


parcelRegister("kZNkK", function(module, exports) {
$parcel$export(module.exports, "mention", () => $f48fc5cbb5be8229$export$db83999c14438df4);
$parcel$export(module.exports, "toJSON", () => $f48fc5cbb5be8229$export$54fd2c36b5cc6731);

var $25nEq = parcelRequire("25nEq");

var $l4823 = parcelRequire("l4823");

var $2gWGi = parcelRequire("2gWGi");
function $f48fc5cbb5be8229$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $f48fc5cbb5be8229$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $f48fc5cbb5be8229$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $f48fc5cbb5be8229$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $f48fc5cbb5be8229$export$abebb208988c258 = /*#__PURE__*/ function(USER_TYPES) {
    USER_TYPES["DEFAULT"] = "DEFAULT";
    USER_TYPES["SPECIAL"] = "SPECIAL";
    USER_TYPES["APP"] = "APP";
    return USER_TYPES;
}({});
var $f48fc5cbb5be8229$export$db83999c14438df4 = (0, $2gWGi.mention)({
    parseDOM: [
        {
            tag: 'span[data-mention-id]',
            getAttrs: function getAttrs(domNode) {
                var dom = domNode;
                var attrs = {
                    id: dom.getAttribute('data-mention-id') || $f48fc5cbb5be8229$export$db83999c14438df4.attrs.id.default,
                    text: dom.textContent || $f48fc5cbb5be8229$export$db83999c14438df4.attrs.text.default,
                    accessLevel: dom.getAttribute('data-access-level') || $f48fc5cbb5be8229$export$db83999c14438df4.attrs.accessLevel.default,
                    localId: (0, $l4823.uuid).generate()
                };
                var userType = dom.getAttribute('data-user-type');
                if ($f48fc5cbb5be8229$export$abebb208988c258[userType]) attrs.userType = userType;
                return attrs;
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node$attrs = node.attrs, id = _node$attrs.id, accessLevel = _node$attrs.accessLevel, text = _node$attrs.text, userType = _node$attrs.userType, localId = _node$attrs.localId;
        var attrs = {
            'data-mention-id': id,
            'data-access-level': accessLevel,
            contenteditable: 'false'
        };
        if (localId) attrs['data-local-id'] = localId;
        if (userType) attrs['data-user-type'] = userType;
        return [
            'span',
            attrs,
            text
        ];
    }
});
var $f48fc5cbb5be8229$var$isOptional = function isOptional(key) {
    return [
        'userType',
        'localId'
    ].indexOf(key) > -1;
};
var $f48fc5cbb5be8229$export$54fd2c36b5cc6731 = function toJSON(node) {
    return {
        attrs: Object.keys(node.attrs).reduce(function(obj, key) {
            if ($f48fc5cbb5be8229$var$isOptional(key) && !node.attrs[key]) return obj;
            return $f48fc5cbb5be8229$var$_objectSpread($f48fc5cbb5be8229$var$_objectSpread({}, obj), {}, (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, key, node.attrs[key]));
        }, {})
    };
};

});

parcelRegister("jOBJC", function(module, exports) {
$parcel$export(module.exports, "nestedExpand", () => $e6cff53242991572$export$63cadbf5f4296627);

var $fC8ib = parcelRequire("fC8ib");

var $25nEq = parcelRequire("25nEq");

var $2gWGi = parcelRequire("2gWGi");

var $l4823 = parcelRequire("l4823");
function $e6cff53242991572$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $e6cff53242991572$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $e6cff53242991572$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $e6cff53242991572$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
/**
 * @name nestedExpand_content
 * @minItems 1
 * @allowUnsupportedBlock true
 */ /**
 * @name nestedExpand_node
 */ /**
 * @name nestedExpand_with_no_marks_node
 */ function $e6cff53242991572$var$getExpandAttrs(domNode, generateLocalId) {
    var dom = domNode;
    return {
        title: dom.getAttribute('data-title'),
        __expanded: true,
        localId: generateLocalId ? (0, $l4823.uuid).generate() : undefined
    };
}
var $e6cff53242991572$var$nestedExpandFactoryOptions = {
    parseDOM: [
        {
            context: 'nestedExpand//',
            tag: '[data-node-type="nestedExpand"]',
            getAttrs: function getAttrs(domNode) {
                return $e6cff53242991572$var$getExpandAttrs(domNode, false);
            }
        },
        {
            tag: '[data-node-type="nestedExpand"] button',
            ignore: true
        },
        {
            tag: '[data-node-type="expand"] button',
            ignore: true
        },
        {
            tag: 'div[data-node-type="nestedExpand"]',
            getAttrs: function getAttrs(domNode) {
                return $e6cff53242991572$var$getExpandAttrs(domNode, false);
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node$attrs;
        var attrs = {
            'data-node-type': 'nestedExpand',
            'data-title': node.attrs.title,
            'data-expanded': node.attrs.__expanded,
            'data-local-id': (node === null || node === void 0 ? void 0 : (_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.localId) || undefined
        };
        return [
            'div',
            attrs,
            0
        ];
    }
};
var $e6cff53242991572$export$63cadbf5f4296627 = (0, $2gWGi.nestedExpand)($e6cff53242991572$var$nestedExpandFactoryOptions);
var $e6cff53242991572$export$b854197485aa1fa0 = (0, $2gWGi.nestedExpand)($e6cff53242991572$var$_objectSpread($e6cff53242991572$var$_objectSpread({}, $e6cff53242991572$var$nestedExpandFactoryOptions), {}, {
    parseDOM: [].concat((0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))($e6cff53242991572$var$nestedExpandFactoryOptions.parseDOM), [
        {
            context: 'nestedExpand//',
            tag: '[data-node-type="nestedExpand"]',
            getAttrs: function getAttrs(domNode) {
                return $e6cff53242991572$var$getExpandAttrs(domNode, true);
            }
        },
        {
            tag: '[data-node-type="nestedExpand"]',
            getAttrs: function getAttrs(domNode) {
                return $e6cff53242991572$var$getExpandAttrs(domNode, true);
            }
        }
    ])
}));

});

parcelRegister("5MY3X", function(module, exports) {
$parcel$export(module.exports, "orderedListSelector", () => $437006b003298686$export$4e7125c7ff595be5);
$parcel$export(module.exports, "orderedListWithOrder", () => $437006b003298686$export$b9ab759e8298198f);

var $l4823 = parcelRequire("l4823");

var $2gWGi = parcelRequire("2gWGi");
var $437006b003298686$export$4e7125c7ff595be5 = '.ak-ol';
var $437006b003298686$export$a5dc81035676e7a = (0, $2gWGi.orderedList)({
    parseDOM: [
        {
            tag: 'ol'
        }
    ],
    toDOM: function toDOM() {
        var attrs = {
            class: $437006b003298686$export$4e7125c7ff595be5.substr(1)
        };
        return [
            'ol',
            attrs,
            0
        ];
    }
});
var $437006b003298686$export$8157adc5747ec436 = (0, $2gWGi.orderedList)({
    parseDOM: [
        {
            tag: 'ol',
            getAttrs: function getAttrs() {
                return {
                    localId: (0, $l4823.uuid).generate()
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node$attrs;
        var attrs = {
            class: $437006b003298686$export$4e7125c7ff595be5.substr(1),
            'data-local-id': (node === null || node === void 0 ? void 0 : (_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.localId) || undefined
        };
        return [
            'ol',
            attrs,
            0
        ];
    }
});
// resolve "start" to a safe, 0+ integer, otherwise return undefined
// Note: Any changes to this function should also be made to "resolveOrder"
// in packages/editor/editor-common/src/utils/list.ts
var $437006b003298686$var$resolveStart = function resolveStart(start) {
    var num = Number(start);
    if (Number.isNaN(num)) return;
    if (num < 0) return;
    return Math.floor(Math.max(num, 0));
};
var $437006b003298686$export$b9ab759e8298198f = (0, $2gWGi.orderedList)({
    parseDOM: [
        {
            tag: 'ol',
            getAttrs: function getAttrs(domNode) {
                var dom = domNode;
                var startDOMAttr = dom.getAttribute('start');
                if (startDOMAttr) {
                    var start = $437006b003298686$var$resolveStart(startDOMAttr);
                    if (typeof start === 'number') return {
                        order: start
                    };
                }
                return null;
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node$attrs2;
        var start = $437006b003298686$var$resolveStart(node === null || node === void 0 ? void 0 : (_node$attrs2 = node.attrs) === null || _node$attrs2 === void 0 ? void 0 : _node$attrs2.order);
        var attrs = {
            start: typeof start === 'number' ? String(start) : undefined,
            class: $437006b003298686$export$4e7125c7ff595be5.substr(1)
        };
        return [
            'ol',
            attrs,
            0
        ];
    }
});
var $437006b003298686$export$2ea3505d41d7525d = (0, $2gWGi.orderedList)({
    parseDOM: [
        {
            tag: 'ol',
            getAttrs: function getAttrs(domNode) {
                var dom = domNode;
                var startDOMAttr = dom.getAttribute('start');
                var localId = (0, $l4823.uuid).generate();
                if (startDOMAttr) {
                    var start = $437006b003298686$var$resolveStart(startDOMAttr);
                    if (typeof start === 'number') return {
                        order: start,
                        localId: localId
                    };
                }
                return {
                    localId: localId
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node$attrs3, _node$attrs4;
        var start = $437006b003298686$var$resolveStart(node === null || node === void 0 ? void 0 : (_node$attrs3 = node.attrs) === null || _node$attrs3 === void 0 ? void 0 : _node$attrs3.order);
        var attrs = {
            start: typeof start === 'number' ? String(start) : undefined,
            class: $437006b003298686$export$4e7125c7ff595be5.substr(1),
            'data-local-id': (node === null || node === void 0 ? void 0 : (_node$attrs4 = node.attrs) === null || _node$attrs4 === void 0 ? void 0 : _node$attrs4.localId) || undefined
        };
        return [
            'ol',
            attrs,
            0
        ];
    }
});

});

parcelRegister("91Dmj", function(module, exports) {
$parcel$export(module.exports, "paragraph", () => $6922bce7683e6bc6$export$9c206ddddb32a9b);

var $2gWGi = parcelRequire("2gWGi");
var $6922bce7683e6bc6$export$9c206ddddb32a9b = (0, $2gWGi.paragraph)({
    parseDOM: [
        {
            tag: 'p',
            getAttrs: function getAttrs(domNode) {
                var _paragraph$attrs, _paragraph$attrs$loca;
                var dom = domNode;
                var attrs = {
                    localId: dom.getAttribute('data-local-id') || ((_paragraph$attrs = $6922bce7683e6bc6$export$9c206ddddb32a9b.attrs) === null || _paragraph$attrs === void 0 ? void 0 : (_paragraph$attrs$loca = _paragraph$attrs.localId) === null || _paragraph$attrs$loca === void 0 ? void 0 : _paragraph$attrs$loca.default)
                };
                return attrs;
            }
        }
    ],
    toDOM: function toDOM(node) {
        var localId = node.attrs.localId;
        var name = 'p';
        var attrs = localId !== undefined && localId !== null ? [
            {
                'data-local-id': localId
            }
        ] : [];
        return [
            name
        ].concat(attrs, [
            0
        ]);
    }
});

});

parcelRegister("gAmJ3", function(module, exports) {
$parcel$export(module.exports, "placeholder", () => $c131a2f8028bcf7d$export$c7187bbd1a7a9244);

var $2gWGi = parcelRequire("2gWGi");

var $l4823 = parcelRequire("l4823");
var $c131a2f8028bcf7d$export$c7187bbd1a7a9244 = (0, $2gWGi.placeholder)({
    parseDOM: [
        {
            tag: 'span[data-placeholder]',
            getAttrs: function getAttrs(dom) {
                return {
                    text: dom.getAttribute('data-placeholder') || $c131a2f8028bcf7d$export$c7187bbd1a7a9244.attrs.text.default
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var text = node.attrs.text;
        var attrs = {
            'data-placeholder': text,
            // Needs to be edtiable for mobile to not close keyboard
            contenteditable: 'true'
        };
        return [
            'span',
            attrs,
            text
        ];
    }
});
var $c131a2f8028bcf7d$export$6205248609a8f7a0 = (0, $2gWGi.placeholder)({
    parseDOM: [
        {
            tag: 'span[data-placeholder]',
            getAttrs: function getAttrs(dom) {
                return {
                    text: dom.getAttribute('data-placeholder') || $c131a2f8028bcf7d$export$c7187bbd1a7a9244.attrs.text.default,
                    localId: (0, $l4823.uuid).generate()
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node$attrs;
        var text = node.attrs.text;
        var attrs = {
            'data-placeholder': text,
            // Needs to be edtiable for mobile to not close keyboard
            contenteditable: 'true',
            'data-local-id': (node === null || node === void 0 ? void 0 : (_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.localId) || undefined
        };
        return [
            'span',
            attrs,
            text
        ];
    }
});

});

parcelRegister("e29IV", function(module, exports) {
$parcel$export(module.exports, "rule", () => $a378cb7e2d7926b6$export$fbeb3a3956e8a3c7);

var $2gWGi = parcelRequire("2gWGi");

var $l4823 = parcelRequire("l4823");
/**
 * @name rule_node
 */ var $a378cb7e2d7926b6$var$hrDOM = [
    'hr'
];
var $a378cb7e2d7926b6$export$fbeb3a3956e8a3c7 = (0, $2gWGi.rule)({
    parseDOM: [
        {
            tag: 'hr'
        }
    ],
    toDOM: function toDOM() {
        return $a378cb7e2d7926b6$var$hrDOM;
    }
});
var $a378cb7e2d7926b6$export$bf3ef6fb6ad90e7 = (0, $2gWGi.rule)({
    parseDOM: [
        {
            tag: 'hr',
            getAttrs: function getAttrs() {
                return {
                    localId: (0, $l4823.uuid).generate()
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node$attrs;
        return [
            'hr',
            {
                'data-local-id': (node === null || node === void 0 ? void 0 : (_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.localId) || undefined
            }
        ];
    }
});

});

parcelRegister("9IIBj", function(module, exports) {
$parcel$export(module.exports, "status", () => $713ad1e9e995d313$export$471f7ae5c4103ae1);

var $l4823 = parcelRequire("l4823");

var $2gWGi = parcelRequire("2gWGi");
var $713ad1e9e995d313$export$471f7ae5c4103ae1 = (0, $2gWGi.status)({
    parseDOM: [
        {
            tag: 'span[data-node-type="status"]',
            getAttrs: function getAttrs(domNode) {
                var dom = domNode;
                return {
                    text: dom.textContent.replace(/\n/, '').trim(),
                    color: dom.getAttribute('data-color'),
                    localId: (0, $l4823.uuid).generate(),
                    style: dom.getAttribute('data-style')
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node$attrs = node.attrs, text = _node$attrs.text, color = _node$attrs.color, localId = _node$attrs.localId, style = _node$attrs.style;
        var attrs = {
            'data-node-type': 'status',
            'data-color': color,
            'data-local-id': localId,
            'data-style': style,
            contenteditable: 'false'
        };
        return [
            'span',
            attrs,
            text
        ];
    }
});

});

parcelRegister("hG501", function(module, exports) {
$parcel$export(module.exports, "syncBlock", () => $cdea3caddabc8835$export$faab0ca9701d7048);

var $2gWGi = parcelRequire("2gWGi");

var $l4823 = parcelRequire("l4823");
var $cdea3caddabc8835$export$faab0ca9701d7048 = (0, $2gWGi.syncBlock)({
    parseDOM: [
        {
            tag: 'div[data-sync-block]',
            getAttrs: function getAttrs(domNode) {
                var dom = domNode;
                var attrs = {
                    localId: dom.getAttribute('data-local-id') || (0, $l4823.uuid).generate(),
                    resourceId: dom.getAttribute('data-resource-id') || ''
                };
                return attrs;
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node$attrs = node.attrs, localId = _node$attrs.localId, resourceId = _node$attrs.resourceId;
        var name = 'div';
        var attrs = {
            'data-sync-block': '',
            'data-local-id': localId,
            'data-resource-id': resourceId
        };
        return [
            name,
            attrs
        ];
    }
});

});

parcelRegister("4VFl9", function(module, exports) {
$parcel$export(module.exports, "taskList", () => $396c8d954768a0bc$export$375b6afcc5f4d291);

var $l4823 = parcelRequire("l4823");

var $2gWGi = parcelRequire("2gWGi");
/**
 * @name taskList_node
 */ var $396c8d954768a0bc$var$name = 'actionList';
var $396c8d954768a0bc$export$c0ec71adb7a18fb2 = "[data-node-type=\"".concat($396c8d954768a0bc$var$name, "\"]");
var $396c8d954768a0bc$export$375b6afcc5f4d291 = (0, $2gWGi.taskList)({
    parseDOM: [
        {
            tag: "div".concat($396c8d954768a0bc$export$c0ec71adb7a18fb2),
            // Default priority is 50. We normally don't change this but since this node type is
            // also used by ordered-list we need to make sure that we run this parser first.
            priority: 100,
            getAttrs: function getAttrs() {
                return {
                    localId: (0, $l4823.uuid).generate()
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var localId = node.attrs.localId;
        var attrs = {
            'data-node-type': $396c8d954768a0bc$var$name,
            'data-task-list-local-id': localId || 'local-task-list',
            style: 'list-style: none; padding-left: 0'
        };
        return [
            'div',
            attrs,
            0
        ];
    }
});

});

parcelRegister("lPSeS", function(module, exports) {
$parcel$export(module.exports, "text", () => $fe586f22a9d17708$export$6f093cfa640b7166);

var $2gWGi = parcelRequire("2gWGi");
var $fe586f22a9d17708$export$6f093cfa640b7166 = (0, $2gWGi.text)({
    toDebugString: function() {
        return 'text_node';
    }
});

});

parcelRegister("zEe3b", function(module, exports) {
$parcel$export(module.exports, "default", () => $06b278f7fb862e9e$export$2e2bcd8739ae039);
var $06b278f7fb862e9e$var$name = 'unknownBlock';
var $06b278f7fb862e9e$export$2e2bcd8739ae039 = {
    group: 'block',
    content: 'inline+',
    marks: '_',
    toDOM: function toDOM() {
        return [
            'div',
            {
                'data-node-type': $06b278f7fb862e9e$var$name
            },
            0
        ];
    },
    parseDOM: [
        {
            tag: "div[data-node-type=\"".concat($06b278f7fb862e9e$var$name, "\"]")
        }
    ]
};

});

parcelRegister("hAyYk", function(module, exports) {
$parcel$export(module.exports, "unsupportedBlock", () => $cce0ed2f35758eb2$export$44b79b0979d0f0f7);

var $2gWGi = parcelRequire("2gWGi");
var $cce0ed2f35758eb2$export$44b79b0979d0f0f7 = (0, $2gWGi.unsupportedBlock)({
    parseDOM: [
        {
            tag: '[data-node-type="unsupportedBlock"]',
            getAttrs: function getAttrs(dom) {
                return {
                    originalValue: JSON.parse(dom.getAttribute('data-original-value') || '{}')
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var attrs = {
            'data-node-type': 'unsupportedBlock',
            'data-original-value': JSON.stringify(node.attrs.originalValue)
        };
        return [
            'div',
            attrs,
            'Unsupported content'
        ];
    }
});

});

parcelRegister("40acJ", function(module, exports) {
$parcel$export(module.exports, "unsupportedInline", () => $2e9f13e3dcb010d6$export$310ebe0d80122e9b);

var $2gWGi = parcelRequire("2gWGi");
var $2e9f13e3dcb010d6$export$310ebe0d80122e9b = (0, $2gWGi.unsupportedInline)({
    parseDOM: [
        {
            tag: '[data-node-type="unsupportedInline"]',
            getAttrs: function getAttrs(dom) {
                return {
                    originalValue: JSON.parse(dom.getAttribute('data-original-value') || '{}')
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var attrs = {
            'data-node-type': 'unsupportedInline',
            'data-original-value': JSON.stringify(node.attrs.originalValue)
        };
        return [
            'span',
            attrs,
            'Unsupported content'
        ];
    }
});

});



parcelRegister("fBC68", function(module, exports) {
$parcel$export(module.exports, "default", () => $b5c7dd2e8b224470$export$2e2bcd8739ae039);

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $25nEq = parcelRequire("25nEq");
// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $b5c7dd2e8b224470$var$isUndefined(x) {
    return x === undefined;
}
var $b5c7dd2e8b224470$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function ProviderFactory() {
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, ProviderFactory);
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "providers", new Map());
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "subscribers", new Map());
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(ProviderFactory, [
        {
            key: "destroy",
            value: function destroy() {
                this.providers.clear();
                this.subscribers.clear();
            }
        },
        {
            key: "isEmpty",
            value: function isEmpty() {
                return !this.providers.size && !this.subscribers.size;
            }
        },
        {
            key: "setProvider",
            value: function setProvider(name, provider) {
                // Do not trigger notifyUpdate if provider is the same.
                if (this.providers.get(name) === provider) return;
                if (!$b5c7dd2e8b224470$var$isUndefined(provider)) this.providers.set(name, provider);
                else this.providers.delete(name);
                this.notifyUpdated(name, provider);
            }
        },
        {
            key: "removeProvider",
            value: function removeProvider(name) {
                this.providers.delete(name);
                this.notifyUpdated(name);
            }
        },
        {
            key: "subscribe",
            value: function subscribe(name, handler) {
                var handlers = this.subscribers.get(name) || [];
                handlers.push(handler);
                this.subscribers.set(name, handlers);
                var provider = this.providers.get(name);
                if (provider) handler(name, provider);
                return provider;
            }
        },
        {
            key: "unsubscribe",
            value: function unsubscribe(name, handler) {
                var handlers = this.subscribers.get(name);
                if (!handlers) return;
                var index = handlers.indexOf(handler);
                if (index !== -1) handlers.splice(index, 1);
                if (handlers.length === 0) this.subscribers.delete(name);
                else this.subscribers.set(name, handlers);
            }
        },
        {
            key: "unsubscribeAll",
            value: function unsubscribeAll(name) {
                var handlers = this.subscribers.get(name);
                if (!handlers) return;
                this.subscribers.delete(name);
            }
        },
        {
            key: "hasProvider",
            value: function hasProvider(name) {
                return this.providers.has(name);
            }
        },
        {
            key: "notifyUpdated",
            value: function notifyUpdated(name, provider) {
                var handlers = this.subscribers.get(name);
                if (!handlers) return;
                handlers.forEach(function(handler) {
                    handler(name, provider);
                });
            }
        }
    ], [
        {
            key: "create",
            value: function create(// Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            providers) {
                var providerFactory = new ProviderFactory();
                var keys = Object.keys(providers);
                keys.forEach(function(name) {
                    providerFactory.setProvider(name, providers[name]);
                });
                return providerFactory;
            }
        }
    ]);
}();

});

parcelRegister("d0n7Z", function(module, exports) {
$parcel$export(module.exports, "ProviderFactoryProvider", () => $977d372ececc4133$export$617c134b25cc4265);
$parcel$export(module.exports, "useProvider", () => $977d372ececc4133$export$693cdb10cec23617);
$parcel$export(module.exports, "useProviderLayout", () => $977d372ececc4133$export$6fde1d0d81db98e1);

var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");

var $fBC68 = parcelRequire("fBC68");
var $977d372ececc4133$var$ProviderFactoryContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createContext(new (0, $fBC68.default)());
var $977d372ececc4133$export$617c134b25cc4265 = $977d372ececc4133$var$ProviderFactoryContext.Provider;
var $977d372ececc4133$export$a3af4b6980aa23b5 = function useProviderFactory() {
    return (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).useContext($977d372ececc4133$var$ProviderFactoryContext);
};
var $977d372ececc4133$export$693cdb10cec23617 = function useProvider(name) {
    var _React$useState = (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).useState(), _React$useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_React$useState, 2), provider = _React$useState2[0], setProvider = _React$useState2[1];
    var providerFactory = $977d372ececc4133$export$a3af4b6980aa23b5();
    (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).useEffect(function() {
        var providerHandler = function providerHandler(_, provider) {
            setProvider(provider);
        };
        providerFactory.subscribe(name, providerHandler);
        return function() {
            providerFactory.unsubscribe(name, providerHandler);
        };
    }, [
        name,
        providerFactory
    ]);
    return provider;
};
var $977d372ececc4133$export$6fde1d0d81db98e1 = function useProviderLayout(name) {
    var _React$useState3 = (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).useState(), _React$useState4 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_React$useState3, 2), provider = _React$useState4[0], setProvider = _React$useState4[1];
    var providerFactory = $977d372ececc4133$export$a3af4b6980aa23b5();
    (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).useLayoutEffect(function() {
        var providerHandler = function providerHandler(_, provider) {
            setProvider(provider);
        };
        providerFactory.subscribe(name, providerHandler);
        return function() {
            providerFactory.unsubscribe(name, providerHandler);
        };
    }, [
        name,
        providerFactory
    ]);
    return provider;
};

});

parcelRegister("1LBcl", function(module, exports) {
$parcel$export(module.exports, "akEditorFullPageDefaultFontSize", () => $149708fd63925c6e$export$fe6b0b821a0e9067);
$parcel$export(module.exports, "akEditorFullPageDenseFontSize", () => $149708fd63925c6e$export$24495b314f307191);
$parcel$export(module.exports, "akEditorBlockquoteBorderColor", () => $149708fd63925c6e$export$a7a75e50ae62d0a8);
$parcel$export(module.exports, "akEditorCustomIconSize", () => $149708fd63925c6e$export$d2715266dd4a1fd1);
$parcel$export(module.exports, "akEditorSelectedBoxShadow", () => $149708fd63925c6e$export$b6a59ac3a19b6343);
$parcel$export(module.exports, "akEditorShadowZIndex", () => $149708fd63925c6e$export$b46cda584c619451);
$parcel$export(module.exports, "akEditorStickyHeaderZIndex", () => $149708fd63925c6e$export$6bed85de54b5de42);
$parcel$export(module.exports, "akEditorTableBorder", () => $149708fd63925c6e$export$36ba77fba4a62d5f);
$parcel$export(module.exports, "akEditorTableToolbar", () => $149708fd63925c6e$export$640eef769748f78f);
$parcel$export(module.exports, "akEditorFullPageMaxWidth", () => $149708fd63925c6e$export$fad19f16d3f953a3);
$parcel$export(module.exports, "akEditorDefaultLayoutWidth", () => $149708fd63925c6e$export$9db045950eedb49f);
$parcel$export(module.exports, "akEditorWideLayoutWidth", () => $149708fd63925c6e$export$74c442132af16a);
$parcel$export(module.exports, "akEditorFullWidthLayoutWidth", () => $149708fd63925c6e$export$f580e3d28d0986de);
$parcel$export(module.exports, "akEditorMaxWidthLayoutWidth", () => $149708fd63925c6e$export$c0f7d71e10d277e9);
$parcel$export(module.exports, "akEditorMaxLayoutWidth", () => $149708fd63925c6e$export$45eb0f5135abf6f1);
$parcel$export(module.exports, "akEditorTableNumberColumnWidth", () => $149708fd63925c6e$export$37df10057d36a0e5);
$parcel$export(module.exports, "akEditorBreakoutPadding", () => $149708fd63925c6e$export$437293c5e9fc2703);
$parcel$export(module.exports, "akEditorGutterPadding", () => $149708fd63925c6e$export$6e0f4d52efd3d2d);
$parcel$export(module.exports, "akEditorGutterPaddingDynamic", () => $149708fd63925c6e$export$f222e0c7a2dc5324);
$parcel$export(module.exports, "akEditorGutterPaddingReduced", () => $149708fd63925c6e$export$aae87d25ced827bb);
$parcel$export(module.exports, "akEditorFullPageNarrowBreakout", () => $149708fd63925c6e$export$cccda66937c91e4c);
$parcel$export(module.exports, "akEditorTableCellMinWidth", () => $149708fd63925c6e$export$e4d39a9e8607c1d3);
$parcel$export(module.exports, "akEditorTableLegacyCellMinWidth", () => $149708fd63925c6e$export$43946f2400ab6f1f);
$parcel$export(module.exports, "akEditorMediaResizeHandlerPaddingWide", () => $149708fd63925c6e$export$558438ae7fd4b8ce);
$parcel$export(module.exports, "akEditorSwoopCubicBezier", () => $149708fd63925c6e$export$3b24948cd5dbb087);
$parcel$export(module.exports, "gridMediumMaxWidth", () => $149708fd63925c6e$export$5edb4f38c3eacb1a);
$parcel$export(module.exports, "breakoutWideScaleRatio", () => $149708fd63925c6e$export$e60820063058ed59);
$parcel$export(module.exports, "akEditorCalculatedWideLayoutWidthSmallViewport", () => $149708fd63925c6e$export$60da500206e2ceec);
$parcel$export(module.exports, "akEditorCalculatedWideLayoutWidth", () => $149708fd63925c6e$export$c0e6648ae1bb2fac);
$parcel$export(module.exports, "akLayoutGutterOffset", () => $149708fd63925c6e$export$847030921e9d5a40);
$parcel$export(module.exports, "akEditorLineHeight", () => $149708fd63925c6e$export$40eb41ab799f0329);
$parcel$export(module.exports, "akEditorWrappedNodeZIndex", () => $149708fd63925c6e$export$e88f6c898960b391);
$parcel$export(module.exports, "blockNodesVerticalMargin", () => $149708fd63925c6e$export$1d0d506416d457f1);
$parcel$export(module.exports, "scaledBlockNodesVerticalMargin", () => $149708fd63925c6e$export$53030af820b542f5);
$parcel$export(module.exports, "DEFAULT_EMBED_CARD_WIDTH", () => $149708fd63925c6e$export$e683ef42725d1713);
$parcel$export(module.exports, "DEFAULT_EMBED_CARD_HEIGHT", () => $149708fd63925c6e$export$226c784ba04bd04b);
$parcel$export(module.exports, "akEditorSelectedNodeClassName", () => $149708fd63925c6e$export$a02a3f1515c2e21a);
$parcel$export(module.exports, "relativeFontSizeToBase16", () => $149708fd63925c6e$export$59733a9f61449b25);

var $iYJcE = parcelRequire("iYJcE");

var $9Zzpd = parcelRequire("9Zzpd");

var $gdZGl = parcelRequire("gdZGl");

var $9eG8k = parcelRequire("9eG8k");
var $149708fd63925c6e$export$fe6b0b821a0e9067 = 16;
var $149708fd63925c6e$export$24495b314f307191 = 13;
var $149708fd63925c6e$export$9a7c520c39e1f0aa = "var(--ds-font-family-code, ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)";
var $149708fd63925c6e$export$1d762aef048d30f9 = "var(--ds-background-accent-gray-subtler, #DDDEE1)";
var $149708fd63925c6e$export$a7a75e50ae62d0a8 = "var(--ds-border, #0B120E24)";
var $149708fd63925c6e$export$b9864494c2608629 = "var(--ds-background-accent-gray-subtlest, #F0F1F2)";
var $149708fd63925c6e$export$f0e953d95429ca1 = '12px';
var $149708fd63925c6e$export$a309dbdeca0adb1a = '2px 4px';
var $149708fd63925c6e$export$ef95eb6ef0fd0a4a = "var(--ds-background-danger, #FFECEB)";
var $149708fd63925c6e$export$8f7d2d784079e274 = 'rgba(255, 189, 173, 0.5)'; // R75 with 50% opacity
var $149708fd63925c6e$export$3c108a6bc41bb5f2 = "var(--ds-border-danger, #E2483D)";
var $149708fd63925c6e$export$bf3aaa2106c119fd = "var(--ds-icon-danger, #C9372C)";
var $149708fd63925c6e$export$d2715266dd4a1fd1 = 20;
var $149708fd63925c6e$export$cf524c1b49838a49 = "var(--ds-border-selected, #1868DB)";
var $149708fd63925c6e$export$8dac549e32469ac4 = 1;
var $149708fd63925c6e$export$befaaae517e3d864 = 2;
var $149708fd63925c6e$export$6e1e1996c4e8cc51 = "".concat($149708fd63925c6e$export$8dac549e32469ac4, "px solid ", "var(--ds-border-selected, #1868DB)");
var $149708fd63925c6e$export$b6a59ac3a19b6343 = "0 0 0 ".concat($149708fd63925c6e$export$8dac549e32469ac4, "px ", "var(--ds-border-selected, #1868DB)");
var $149708fd63925c6e$export$37e178ca41c198ca = "0 0 0 ".concat($149708fd63925c6e$export$befaaae517e3d864, "px ", "var(--ds-border-selected, #1868DB)");
var $149708fd63925c6e$export$4a007c22e25e31f6 = 0.3;
var $149708fd63925c6e$export$f35cc48f3398ab79 = 1;
var $149708fd63925c6e$export$b46cda584c619451 = 2;
var $149708fd63925c6e$export$6bed85de54b5de42 = 11; // filmstrip uses 10 for its shadow
var $149708fd63925c6e$export$321ddd2f049dd12 = $149708fd63925c6e$export$6bed85de54b5de42 + 1;
var $149708fd63925c6e$export$daeac9b8422ac3c2 = 2;
var $149708fd63925c6e$export$501d46e11ed5bf73 = 500;
var $149708fd63925c6e$export$6817b4b6a5ef78f1 = 400;
var $149708fd63925c6e$export$93768eb72dec48ce = $149708fd63925c6e$export$501d46e11ed5bf73 + 10;
var $149708fd63925c6e$export$c0aec4e0896849a0 = $149708fd63925c6e$export$93768eb72dec48ce - 5;
var $149708fd63925c6e$export$5886f057e4f21fe4 = $149708fd63925c6e$export$6817b4b6a5ef78f1 + 5;
var $149708fd63925c6e$export$6e85faa46d537a3f = 11;
var $149708fd63925c6e$export$36ba77fba4a62d5f = "var(--ds-background-accent-gray-subtler, #DDDEE1)";
var $149708fd63925c6e$export$640eef769748f78f = "var(--ds-background-accent-gray-subtlest, #F0F1F2)";
var $149708fd63925c6e$export$4c6f61fb4b9ae93 = '#F1F2F4';
var $149708fd63925c6e$export$95e9a0285b97474d = '#2C333A';
var $149708fd63925c6e$export$f7bbcec54ff5bc47 = "var(--ds-border-focused, #4688EC)";
var $149708fd63925c6e$export$76b5e653883e5290 = '3px';
var $149708fd63925c6e$export$6d85fe8177a50c0c = 0.5;
var $149708fd63925c6e$export$fad19f16d3f953a3 = 680;
var $149708fd63925c6e$export$9db045950eedb49f = 760;
var $149708fd63925c6e$export$74c442132af16a = 960; // This value is used for tables with breakouts and is used to calculate `breakoutWidthPx`
var $149708fd63925c6e$export$f580e3d28d0986de = 1800;
var $149708fd63925c6e$export$c0f7d71e10d277e9 = 4000;
var $149708fd63925c6e$export$9d5488b5afad62bf = 1792;
var $149708fd63925c6e$export$45eb0f5135abf6f1 = 4000;
var $149708fd63925c6e$export$37df10057d36a0e5 = 42;
var $149708fd63925c6e$export$437293c5e9fc2703 = 96;
var $149708fd63925c6e$export$6e0f4d52efd3d2d = 32;
var $149708fd63925c6e$export$f222e0c7a2dc5324 = function akEditorGutterPaddingDynamic() {
    return(// eslint-disable-next-line @atlaskit/platform/no-preconditioning
    (0, $9Zzpd.fg)('platform_editor_controls_increase_full_page_gutter') && (0, $9eG8k.editorExperiment)('platform_editor_controls', 'variant1') ? 72 : 52);
};
var $149708fd63925c6e$export$aae87d25ced827bb = 24;
var $149708fd63925c6e$export$cccda66937c91e4c = 600;
var $149708fd63925c6e$export$efe8561bbd3f74d2 = 720;
var $149708fd63925c6e$export$e4d39a9e8607c1d3 = 48;
var $149708fd63925c6e$export$43946f2400ab6f1f = 128;
var $149708fd63925c6e$export$558438ae7fd4b8ce = 12;
var $149708fd63925c6e$export$6beb98d32d4ca149 = 4;
var $149708fd63925c6e$export$3b24948cd5dbb087 = "cubic-bezier(0.15, 1, 0.3, 1)";
var $149708fd63925c6e$export$5edb4f38c3eacb1a = 1024;
var $149708fd63925c6e$export$e60820063058ed59 = 1.33;
var $149708fd63925c6e$export$60da500206e2ceec = 905; // from breakoutConsts.calcWideWidth, layoutMaxWidth * breakoutConsts.wideScaleRatio = 904.8 ~ 905 This is a resulting width value that is applied to nodes that currently use breakouts (except table) and are set to `wide` when the viewport's width is <= 1266px.
var $149708fd63925c6e$export$c0e6648ae1bb2fac = 1011; // = akEditorDefaultLayoutWidth * breakoutWideScaleRatio = 1010.8 ~ 1011 This is a resulting width value that is applied to nodes that currently use breakouts (except table) and are set to `wide` when the viewport's width is > 1329px.
var $149708fd63925c6e$export$fb15fade89f67217 = $149708fd63925c6e$export$f35cc48f3398ab79 * 99;
var $149708fd63925c6e$export$847030921e9d5a40 = 12;
var $149708fd63925c6e$export$40eb41ab799f0329 = 1.714;
var $149708fd63925c6e$export$e271312fc7124aec = '1px';
var $149708fd63925c6e$export$d29cb2c31fcbb7c5 = 2;
var $149708fd63925c6e$export$688a6dc01e760755 = 320;
var $149708fd63925c6e$export$e736f2caf3b39eb3 = 'rgba(179, 212, 255, 0.3)';
var $149708fd63925c6e$export$de3cef07cda55645 = 'rgba(255, 235, 230, 0.3)';
var $149708fd63925c6e$export$e88f6c898960b391 = $149708fd63925c6e$export$f35cc48f3398ab79 * 2; //prevent paragraph nodes from rendering above wrapped nodes
var $149708fd63925c6e$export$e5c605f2b2a12b00 = {
    SMALL: 550,
    MEDIUM: 760
};
var $149708fd63925c6e$export$1d0d506416d457f1 = '0.75rem';
var $149708fd63925c6e$export$53030af820b542f5 = '0.75em';
var $149708fd63925c6e$export$e683ef42725d1713 = 680;
var $149708fd63925c6e$export$226c784ba04bd04b = 480;
var $149708fd63925c6e$export$214ff00e5618d86c = 20;
var $149708fd63925c6e$export$c82675fa56f2eefd = '56px';
var $149708fd63925c6e$var$DEFAULT_FONT_SIZE = 14;
var $149708fd63925c6e$export$d7726a000ae2d7c = function FULL_PAGE_EDITOR_TOOLBAR_HEIGHT(isToolbarAIFCEnabled) {
    if (// if value is undefined assume this is being called outside of editor where the experiment can be checked
    isToolbarAIFCEnabled === undefined ? ((0, $9eG8k.editorExperiment)('platform_editor_toolbar_aifc', true) || (0, $9Zzpd.fg)('platform_editor_ai_aifc_streaming')) && (0, $gdZGl.expValEquals)('platform_editor_toolbar_aifc_patch_3', 'isEnabled', true) : isToolbarAIFCEnabled && (0, $gdZGl.expValEquals)('platform_editor_toolbar_aifc_patch_3', 'isEnabled', true)) return '44px';
    if ((0, $9eG8k.editorExperiment)('platform_editor_controls', 'variant1', {
        exposure: true
    })) return "var(--ds-space-500, 40px)";
    return "var(--ds-space-500, 40px)";
};
var $149708fd63925c6e$export$d1343597f3b52d83 = 40;
var $149708fd63925c6e$export$a02a3f1515c2e21a = 'ak-editor-selected-node';
var $149708fd63925c6e$export$58a725ff69bda73a = function editorFontSize(_ref) {
    var theme = _ref.theme;
    return theme && theme.baseFontSize ? theme.baseFontSize : $149708fd63925c6e$var$DEFAULT_FONT_SIZE;
};
var $149708fd63925c6e$export$945a9e125632354d = function relativeSize(multiplier) {
    return function(_ref2) {
        var theme = _ref2.theme;
        return $149708fd63925c6e$export$58a725ff69bda73a({
            theme: theme
        }) * multiplier;
    };
};
var $149708fd63925c6e$export$59733a9f61449b25 = function relativeFontSizeToBase16(px) {
    if (typeof px === 'string') px = parseInt(px);
    if (isNaN(px)) throw new Error("Invalid font size: '".concat(px, "'"));
    return "".concat(px / 16, "rem");
};
var $149708fd63925c6e$export$46715ac1fbd9e64e = function relativeSizeToBaseFontSize(value) {
    return "calc(".concat(value, " * var(--ak-editor-base-font-size) / ").concat($149708fd63925c6e$export$fe6b0b821a0e9067, ")");
};
var $149708fd63925c6e$export$96b72b7f243fa693 = {
    a4KMonitor: {
        width: 3440,
        height: 1440
    },
    laptopHiDPI: {
        width: 1440,
        height: 900
    },
    laptopMDPI: {
        width: 1280,
        height: 800
    },
    tabletL: {
        width: 1024,
        height: 1366
    },
    tabletS: {
        width: 768,
        height: 1024
    },
    mobileM: {
        width: 414,
        height: 736
    },
    mobileS: {
        width: 375,
        height: 667
    },
    mobileXS: {
        width: 320,
        height: 568
    }
};
var $149708fd63925c6e$export$9369fd010fa0ddd6 = 0;
var $149708fd63925c6e$export$846a716e9e69a8df = [
    [
        'White',
        '#000000'
    ],
    [
        'Light blue',
        '#0C294F'
    ],
    [
        'Light teal',
        '#0C343B'
    ],
    [
        'Light green',
        '#052E21'
    ],
    [
        'Light yellow',
        '#484123'
    ],
    [
        'Light red',
        '#441C13'
    ],
    [
        'Light purple',
        '#282249'
    ],
    [
        'Light gray',
        '#202328'
    ],
    [
        'Blue',
        '#0B3165'
    ],
    [
        'Teal',
        '#044853'
    ],
    [
        'Green',
        '#053927'
    ],
    [
        'Yellow',
        '#6F5C25'
    ],
    [
        'Red',
        '#582013'
    ],
    [
        'Purple',
        '#3E327B'
    ],
    [
        'Gray',
        '#475262'
    ],
    [
        'Dark blue',
        '#003884'
    ],
    [
        'Dark teal',
        '#055866'
    ],
    [
        'Dark green',
        '#044932'
    ],
    [
        'Dark yellow',
        '#82641C'
    ],
    [
        'Dark red',
        '#6B2A19'
    ],
    [
        'Dark purple',
        '#4D38B2'
    ]
].map(function(_ref3) {
    var _ref4 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_ref3, 2), colorName = _ref4[0], colorValue = _ref4[1];
    return $149708fd63925c6e$export$5f2dade43b841301(colorName, colorValue);
}).join('\n');
function $149708fd63925c6e$export$5f2dade43b841301(colorName, colorValue) {
    return "\n  &[colorname=\"".concat(colorName, "\"] {\n    background-color: ").concat(colorValue, " !important; // !important to override default style color\n  }\n  ");
}
var $149708fd63925c6e$export$312e1e71424c4aa1 = [
    "var(--ds-icon-accent-red, #C9372C)",
    "var(--ds-background-accent-red-bolder-hovered, #AE2E24)",
    "var(--ds-icon-accent-magenta, #CD519D)",
    "var(--ds-background-accent-magenta-bolder-hovered, #943D73)",
    "var(--ds-icon-accent-orange, #E06C00)",
    "var(--ds-background-accent-orange-bolder-hovered, #9E4C00)",
    "var(--ds-icon-accent-green, #22A06B)",
    "var(--ds-background-accent-green-bolder-hovered, #216E4E)",
    "var(--ds-icon-accent-blue, #357DE8)",
    "var(--ds-background-accent-blue-bolder-hovered, #1558BC)",
    "var(--ds-icon-accent-teal, #2898BD)",
    "var(--ds-background-accent-teal-bolder-hovered, #206A83)",
    "var(--ds-icon-accent-lime, #6A9A23)",
    "var(--ds-background-accent-lime-bolder-hovered, #4C6B1F)",
    "var(--ds-icon-accent-purple, #AF59E1)",
    "var(--ds-background-accent-purple-bolder-hovered, #803FA5)",
    "var(--ds-icon-accent-gray, #7D818A)",
    "var(--ds-background-accent-gray-bolder-hovered, #505258)",
    "var(--ds-icon-accent-yellow, #B38600)",
    "var(--ds-background-accent-yellow-bolder-hovered, #7F5F01)",
    "var(--ds-background-accent-yellow-bolder-pressed, #614A05)"
];
var $149708fd63925c6e$export$42608c013398a830 = [
    {
        textColor: "var(--ds-text-inverse, #FFFFFF)",
        backgroundColor: "var(--ds-background-accent-red-bolder, #C9372C)",
        svgBackgroundColor: "var(--ds-background-accent-red-subtler, #FFD5D2)"
    },
    {
        textColor: "var(--ds-text-inverse, #FFFFFF)",
        backgroundColor: "var(--ds-background-accent-blue-bolder, #1868DB)",
        svgBackgroundColor: "var(--ds-background-accent-blue-subtler, #CFE1FD)"
    },
    {
        textColor: "var(--ds-text-inverse, #FFFFFF)",
        backgroundColor: "var(--ds-background-accent-green-bolder, #1F845A)",
        svgBackgroundColor: "var(--ds-background-accent-green-subtler, #BAF3DB)"
    },
    {
        textColor: "var(--ds-text-inverse, #FFFFFF)",
        backgroundColor: "var(--ds-background-accent-yellow-bolder, #946F00)",
        svgBackgroundColor: "var(--ds-background-accent-yellow-subtler, #F5E989)"
    },
    {
        textColor: "var(--ds-text-inverse, #FFFFFF)",
        backgroundColor: "var(--ds-background-accent-purple-bolder, #964AC0)",
        svgBackgroundColor: "var(--ds-background-accent-purple-subtler, #EED7FC)"
    },
    {
        textColor: "var(--ds-text-inverse, #FFFFFF)",
        backgroundColor: "var(--ds-background-accent-magenta-bolder, #AE4787)",
        svgBackgroundColor: "var(--ds-background-accent-magenta-subtler, #FDD0EC)"
    },
    {
        textColor: "var(--ds-text-inverse, #FFFFFF)",
        backgroundColor: "var(--ds-background-accent-teal-bolder, #227D9B)",
        svgBackgroundColor: "var(--ds-background-accent-teal-subtler, #C6EDFB)"
    },
    {
        textColor: "var(--ds-text-inverse, #FFFFFF)",
        backgroundColor: "var(--ds-background-accent-orange-bolder, #BD5B00)",
        svgBackgroundColor: "var(--ds-background-accent-orange-subtler, #FCE4A6)"
    },
    {
        textColor: "var(--ds-text-inverse, #FFFFFF)",
        backgroundColor: "var(--ds-background-accent-lime-bolder, #5B7F24)",
        svgBackgroundColor: "var(--ds-background-accent-lime-subtler, #D3F1A7)"
    },
    {
        textColor: "var(--ds-text-inverse, #FFFFFF)",
        backgroundColor: "var(--ds-background-accent-gray-bolder, #6B6E76)",
        svgBackgroundColor: "var(--ds-background-accent-gray-subtler, #DDDEE1)"
    },
    {
        textColor: "var(--ds-text-accent-gray-bolder, #1E1F21)",
        backgroundColor: "var(--ds-background-accent-blue-subtle, #669DF1)",
        svgBackgroundColor: "var(--ds-background-accent-blue-subtlest, #E9F2FE)"
    },
    {
        textColor: "var(--ds-text-accent-gray-bolder, #1E1F21)",
        backgroundColor: "var(--ds-background-accent-red-subtle, #F87168)",
        svgBackgroundColor: "var(--ds-background-accent-red-subtlest, #FFECEB)"
    },
    {
        textColor: "var(--ds-text-accent-gray-bolder, #1E1F21)",
        backgroundColor: "var(--ds-background-accent-orange-subtle, #FCA700)",
        svgBackgroundColor: "var(--ds-background-accent-orange-subtlest, #FFF5DB)"
    },
    {
        textColor: "var(--ds-text-accent-gray-bolder, #1E1F21)",
        backgroundColor: "var(--ds-background-accent-yellow-subtle, #EED12B)",
        svgBackgroundColor: "var(--ds-background-accent-yellow-subtlest, #FEF7C8)"
    },
    {
        textColor: "var(--ds-text-accent-gray-bolder, #1E1F21)",
        backgroundColor: "var(--ds-background-accent-green-subtle, #4BCE97)",
        svgBackgroundColor: "var(--ds-background-accent-green-subtlest, #DCFFF1)"
    },
    {
        textColor: "var(--ds-text-accent-gray-bolder, #1E1F21)",
        backgroundColor: "var(--ds-background-accent-teal-subtle, #6CC3E0)",
        svgBackgroundColor: "var(--ds-background-accent-teal-subtlest, #E7F9FF)"
    },
    {
        textColor: "var(--ds-text-accent-gray-bolder, #1E1F21)",
        backgroundColor: "var(--ds-background-accent-purple-subtle, #C97CF4)",
        svgBackgroundColor: "var(--ds-background-accent-purple-subtlest, #F8EEFE)"
    },
    {
        textColor: "var(--ds-text-accent-gray-bolder, #1E1F21)",
        backgroundColor: "var(--ds-background-accent-magenta-subtle, #E774BB)",
        svgBackgroundColor: "var(--ds-background-accent-magenta-subtlest, #FFECF8)"
    }
];

});
parcelRegister("gdZGl", function(module, exports) {
$parcel$export(module.exports, "expValEquals", () => $bcfdb4fb3dbc6980$export$45abdb3f977b5b14);

var $jzBPa = parcelRequire("jzBPa");
function $bcfdb4fb3dbc6980$export$45abdb3f977b5b14(experimentName, experimentParam, experimentExpectedValue) {
    var experimentDefaultValue = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
    return (0, $jzBPa.expValEqualsInternal)(experimentName, experimentParam, experimentExpectedValue, experimentDefaultValue, true);
}

});
parcelRegister("jzBPa", function(module, exports) {
$parcel$export(module.exports, "expValEqualsInternal", () => $e3fea04c6451f26b$export$58e581060588c6bb);

var $jQr4o = parcelRequire("jQr4o");

var $8qy01 = parcelRequire("8qy01");

var $9L6oc = parcelRequire("9L6oc");
function $e3fea04c6451f26b$export$58e581060588c6bb(experimentName, experimentParam, experimentExpectedValue, experimentDefaultValue, experimentExposure) {
    // @ts-ignore need to loosen the type here to allow for any experiment name
    if ((0, $9L6oc._overrides)[experimentName] !== undefined) // This will be hit in the case of a test setting an override
    // @ts-ignore need to loosen the type here to allow for any experiment name
    return (0, $9L6oc._overrides)[experimentName] === experimentExpectedValue;
    // If client is not initialized, we compare with the default value
    if (!(0, $jQr4o.default).initializeCompleted()) return experimentDefaultValue === experimentExpectedValue;
    // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
    var experimentValue = (0, $jQr4o.default).getExperimentValue(experimentName, experimentParam, experimentDefaultValue, {
        fireExperimentExposure: experimentExposure
    });
    if (// eslint-disable-next-line @atlaskit/platform/use-recommended-utils
    (0, $jQr4o.default).getExperimentValue('cc_editor_experiments_ufo_gate_reporting', 'isEnabled', false)) // Duplicated from /confluence/next/packages/feature-experiments/src/index.ts
    (0, $8qy01.addFeatureFlagAccessed)("".concat(experimentName, ":").concat(experimentParam), experimentValue);
    return experimentValue === experimentExpectedValue;
}

});
parcelRegister("jQr4o", function(module, exports) {
$parcel$export(module.exports, "default", () => $e727df2602f0c6f0$export$2e2bcd8739ae039);

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $25nEq = parcelRequire("25nEq");

var $c9wAm = parcelRequire("c9wAm");

var $2sCeC = parcelRequire("2sCeC");



var $e727df2602f0c6f0$var$_FeatureGates;
/**
 * Access the FeatureGates object via the default export.
 * ```ts
 * import FeatureGates from '@atlaskit/feature-gate-js-client';
 * ```
 */ var $e727df2602f0c6f0$var$FeatureGates = /*#__PURE__*/ function() {
    function FeatureGates() {
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, FeatureGates);
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(FeatureGates, null, [
        {
            key: "isGateExists",
            value: function isGateExists(gateName) {
                return this.client.isGateExist(gateName);
            }
        },
        {
            key: "isExperimentExists",
            value: function isExperimentExists(experimentName) {
                return this.client.isExperimentExist(experimentName);
            }
        }
    ]);
}();
$e727df2602f0c6f0$var$_FeatureGates = $e727df2602f0c6f0$var$FeatureGates;
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($e727df2602f0c6f0$var$FeatureGates, "client", new (0, $c9wAm.Client)());
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($e727df2602f0c6f0$var$FeatureGates, "hasCheckGateErrorOccurred", false);
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($e727df2602f0c6f0$var$FeatureGates, "hasGetExperimentValueErrorOccurred", false);
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($e727df2602f0c6f0$var$FeatureGates, "checkGate", function(gateName, options) {
    try {
        // Check if the CRITERION override mechanism is available
        if (typeof window !== 'undefined' && window.__CRITERION__ && typeof window.__CRITERION__.getFeatureFlagOverride === 'function') {
            // Attempt to retrieve an override value for the feature gate
            var overrideValue = window.__CRITERION__.getFeatureFlagOverride(gateName);
            // If an override value is found, return it immediately
            if (overrideValue !== undefined) return overrideValue;
        }
    } catch (error) {
        // Log the first occurrence of the error
        if (!$e727df2602f0c6f0$var$_FeatureGates.hasCheckGateErrorOccurred) {
            // eslint-disable-next-line no-console
            console.warn({
                msg: 'An error has occurred checking the feature gate from criterion override. Only the first occurrence of this error is logged.',
                gateName: gateName,
                error: error
            });
            $e727df2602f0c6f0$var$_FeatureGates.hasCheckGateErrorOccurred = true;
        }
    }
    // Proceed with the main logic if no override is found
    return $e727df2602f0c6f0$var$_FeatureGates.client.checkGate(gateName, options);
});
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($e727df2602f0c6f0$var$FeatureGates, "getExperimentValue", function(experimentName, parameterName, defaultValue, options) {
    try {
        // Check if the CRITERION override mechanism is available
        if (typeof window !== 'undefined' && window.__CRITERION__ && typeof window.__CRITERION__.getExperimentValueOverride === 'function') {
            var overrideValue = window.__CRITERION__.getExperimentValueOverride(experimentName, parameterName);
            if (overrideValue !== undefined && overrideValue !== null) return overrideValue;
        }
    } catch (error) {
        // Log the first occurrence of the error
        if (!$e727df2602f0c6f0$var$_FeatureGates.hasGetExperimentValueErrorOccurred) {
            // eslint-disable-next-line no-console
            console.warn({
                msg: 'An error has occurred getting the experiment value from criterion override. Only the first occurrence of this error is logged.',
                experimentName: experimentName,
                defaultValue: defaultValue,
                options: options,
                error: error
            });
            $e727df2602f0c6f0$var$_FeatureGates.hasGetExperimentValueErrorOccurred = true;
        }
        return defaultValue;
    }
    // Proceed with the main logic if no override is found
    return $e727df2602f0c6f0$var$_FeatureGates.client.getExperimentValue(experimentName, parameterName, defaultValue, options);
});
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($e727df2602f0c6f0$var$FeatureGates, "initializeCalled", $e727df2602f0c6f0$var$_FeatureGates.client.initializeCalled.bind($e727df2602f0c6f0$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($e727df2602f0c6f0$var$FeatureGates, "initializeCompleted", $e727df2602f0c6f0$var$_FeatureGates.client.initializeCompleted.bind($e727df2602f0c6f0$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($e727df2602f0c6f0$var$FeatureGates, "waitUntilInitializeCompleted", $e727df2602f0c6f0$var$_FeatureGates.client.waitUntilInitializeCompleted.bind($e727df2602f0c6f0$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($e727df2602f0c6f0$var$FeatureGates, "initialize", $e727df2602f0c6f0$var$_FeatureGates.client.initialize.bind($e727df2602f0c6f0$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($e727df2602f0c6f0$var$FeatureGates, "initializeWithProvider", $e727df2602f0c6f0$var$_FeatureGates.client.initializeWithProvider.bind($e727df2602f0c6f0$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($e727df2602f0c6f0$var$FeatureGates, "initializeFromValues", $e727df2602f0c6f0$var$_FeatureGates.client.initializeFromValues.bind($e727df2602f0c6f0$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($e727df2602f0c6f0$var$FeatureGates, "manuallyLogGateExposure", $e727df2602f0c6f0$var$_FeatureGates.client.manuallyLogGateExposure.bind($e727df2602f0c6f0$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($e727df2602f0c6f0$var$FeatureGates, "getExperiment", $e727df2602f0c6f0$var$_FeatureGates.client.getExperiment.bind($e727df2602f0c6f0$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($e727df2602f0c6f0$var$FeatureGates, "manuallyLogExperimentExposure", $e727df2602f0c6f0$var$_FeatureGates.client.manuallyLogExperimentExposure.bind($e727df2602f0c6f0$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($e727df2602f0c6f0$var$FeatureGates, "manuallyLogLayerExposure", $e727df2602f0c6f0$var$_FeatureGates.client.manuallyLogLayerExposure.bind($e727df2602f0c6f0$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($e727df2602f0c6f0$var$FeatureGates, "shutdownStatsig", $e727df2602f0c6f0$var$_FeatureGates.client.shutdownStatsig.bind($e727df2602f0c6f0$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($e727df2602f0c6f0$var$FeatureGates, "overrideGate", $e727df2602f0c6f0$var$_FeatureGates.client.overrideGate.bind($e727df2602f0c6f0$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($e727df2602f0c6f0$var$FeatureGates, "clearGateOverride", $e727df2602f0c6f0$var$_FeatureGates.client.clearGateOverride.bind($e727df2602f0c6f0$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($e727df2602f0c6f0$var$FeatureGates, "overrideConfig", $e727df2602f0c6f0$var$_FeatureGates.client.overrideConfig.bind($e727df2602f0c6f0$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($e727df2602f0c6f0$var$FeatureGates, "clearConfigOverride", $e727df2602f0c6f0$var$_FeatureGates.client.clearConfigOverride.bind($e727df2602f0c6f0$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($e727df2602f0c6f0$var$FeatureGates, "setOverrides", $e727df2602f0c6f0$var$_FeatureGates.client.setOverrides.bind($e727df2602f0c6f0$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($e727df2602f0c6f0$var$FeatureGates, "getOverrides", $e727df2602f0c6f0$var$_FeatureGates.client.getOverrides.bind($e727df2602f0c6f0$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($e727df2602f0c6f0$var$FeatureGates, "clearAllOverrides", $e727df2602f0c6f0$var$_FeatureGates.client.clearAllOverrides.bind($e727df2602f0c6f0$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($e727df2602f0c6f0$var$FeatureGates, "isCurrentUser", $e727df2602f0c6f0$var$_FeatureGates.client.isCurrentUser.bind($e727df2602f0c6f0$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($e727df2602f0c6f0$var$FeatureGates, "onGateUpdated", $e727df2602f0c6f0$var$_FeatureGates.client.onGateUpdated.bind($e727df2602f0c6f0$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($e727df2602f0c6f0$var$FeatureGates, "onExperimentValueUpdated", $e727df2602f0c6f0$var$_FeatureGates.client.onExperimentValueUpdated.bind($e727df2602f0c6f0$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($e727df2602f0c6f0$var$FeatureGates, "onAnyUpdated", $e727df2602f0c6f0$var$_FeatureGates.client.onAnyUpdated.bind($e727df2602f0c6f0$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($e727df2602f0c6f0$var$FeatureGates, "updateUser", $e727df2602f0c6f0$var$_FeatureGates.client.updateUser.bind($e727df2602f0c6f0$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($e727df2602f0c6f0$var$FeatureGates, "updateUserWithProvider", $e727df2602f0c6f0$var$_FeatureGates.client.updateUserWithProvider.bind($e727df2602f0c6f0$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($e727df2602f0c6f0$var$FeatureGates, "updateUserWithValues", $e727df2602f0c6f0$var$_FeatureGates.client.updateUserWithValues.bind($e727df2602f0c6f0$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($e727df2602f0c6f0$var$FeatureGates, "getPackageVersion", $e727df2602f0c6f0$var$_FeatureGates.client.getPackageVersion.bind($e727df2602f0c6f0$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($e727df2602f0c6f0$var$FeatureGates, "getLayer", $e727df2602f0c6f0$var$_FeatureGates.client.getLayer.bind($e727df2602f0c6f0$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($e727df2602f0c6f0$var$FeatureGates, "getLayerValue", $e727df2602f0c6f0$var$_FeatureGates.client.getLayerValue.bind($e727df2602f0c6f0$var$_FeatureGates.client));
var $e727df2602f0c6f0$var$boundFGJS = $e727df2602f0c6f0$var$FeatureGates;
// This makes it possible to get a reference to the FeatureGates client at runtime.
// This is important for overriding values in Cypress tests, as there needs to be a
// way to get the exact instance for a window in order to mock some of its methods.
if (typeof window !== 'undefined') {
    if (window.__FEATUREGATES_JS__ === undefined) window.__FEATUREGATES_JS__ = $e727df2602f0c6f0$var$FeatureGates;
    else {
        var $e727df2602f0c6f0$var$_boundFGJS, $e727df2602f0c6f0$var$_boundFGJS$getPackage;
        $e727df2602f0c6f0$var$boundFGJS = window.__FEATUREGATES_JS__;
        var $e727df2602f0c6f0$var$boundVersion = (($e727df2602f0c6f0$var$_boundFGJS = $e727df2602f0c6f0$var$boundFGJS) === null || $e727df2602f0c6f0$var$_boundFGJS === void 0 || ($e727df2602f0c6f0$var$_boundFGJS$getPackage = $e727df2602f0c6f0$var$_boundFGJS.getPackageVersion) === null || $e727df2602f0c6f0$var$_boundFGJS$getPackage === void 0 ? void 0 : $e727df2602f0c6f0$var$_boundFGJS$getPackage.call($e727df2602f0c6f0$var$_boundFGJS)) || '4.10.0 or earlier';
        if ($e727df2602f0c6f0$var$boundVersion !== (0, $2sCeC.CLIENT_VERSION)) {
            var $e727df2602f0c6f0$var$message = "Multiple versions of FeatureGateClients found on the current page.\n      The currently bound version is ".concat($e727df2602f0c6f0$var$boundVersion, " when module version ").concat((0, $2sCeC.CLIENT_VERSION), " was loading.");
            // eslint-disable-next-line no-console
            console.warn($e727df2602f0c6f0$var$message);
        }
    }
}
var /**
 * @property {FeatureGates} FeatureGate default export
 */ $e727df2602f0c6f0$export$2e2bcd8739ae039 = $e727df2602f0c6f0$var$boundFGJS;

});
parcelRegister("c9wAm", function(module, exports) {
$parcel$export(module.exports, "Client", () => $8d8f9a1aa50e8aef$export$1f2bb630327ac4b6);

var $1Vcia = parcelRequire("1Vcia");

var $iYJcE = parcelRequire("iYJcE");

var $fL8KA = parcelRequire("fL8KA");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $25nEq = parcelRequire("25nEq");

var $6HG4S = parcelRequire("6HG4S");

var $iFR7a = parcelRequire("iFR7a");

var $bFONp = parcelRequire("bFONp");

var $7RzhR = parcelRequire("7RzhR");

var $176K2 = parcelRequire("176K2");

var $jSPjQ = parcelRequire("jSPjQ");

var $5lXNt = parcelRequire("5lXNt");

var $eQpFj = parcelRequire("eQpFj");

var $jbC54 = parcelRequire("jbC54");

var $k9ONe = parcelRequire("k9ONe");

var $5IOvr = parcelRequire("5IOvr");

var $2sCeC = parcelRequire("2sCeC");
var $8d8f9a1aa50e8aef$var$_excluded = [
    "sdkKey",
    "environment",
    "updateUserCompletionCallback",
    "perimeter"
];
function $8d8f9a1aa50e8aef$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $8d8f9a1aa50e8aef$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $8d8f9a1aa50e8aef$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $8d8f9a1aa50e8aef$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $8d8f9a1aa50e8aef$var$DEFAULT_CLIENT_KEY = 'client-default-key';
// default event logging api is Atlassian proxy rather than Statsig's domain, to avoid ad blockers
var $8d8f9a1aa50e8aef$var$DEFAULT_EVENT_LOGGING_API = 'https://xp.atlassian.com/v1/rgstr';
var $8d8f9a1aa50e8aef$export$1f2bb630327ac4b6 = /*#__PURE__*/ function() {
    function Client() {
        var _this = this;
        var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, _ref$localStorageKey = _ref.localStorageKey, localStorageKey = _ref$localStorageKey === void 0 ? (0, $jbC54.LOCAL_STORAGE_KEY) : _ref$localStorageKey, overrideAdapter = _ref.overrideAdapter;
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, Client);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "initPromise", null);
        /** True if an initialize method was called and completed successfully. */ (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "initCompleted", false);
        /**
     * True if an initialize method was called and completed, meaning the client is now usable.
     * However if there was an error during initialization it may have initialized with default
     * values. Use {@link initCompleted} to check for this.
     */ (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "initWithDefaults", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "hasCheckGateErrorOccurred", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "hasGetExperimentErrorOccurred", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "hasGetExperimentValueErrorOccurred", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "hasGetLayerErrorOccurred", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "hasGetLayerValueErrorOccurred", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "subscriptions", new (0, $bFONp.default)());
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "dataAdapter", new (0, $eQpFj.NoFetchDataAdapter)());
        /**
     * Call this if modifying the values being served by the Statsig library since it has its own
     * memoization cache which will not be updated if the values are changed outside of the library.
     */ (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "statsigValuesUpdated", function() {
            if (_this.user) // Trigger a reset of the memoize cache
            _this.statsigClient.updateUserSync(_this.user, {
                disableBackgroundCacheRefresh: true
            });
            _this.subscriptions.anyUpdated();
        });
        this.overrideAdapter = overrideAdapter || new (0, $jbC54.PersistentOverrideAdapter)(localStorageKey);
    }
    /**
   * @description
   * This method initializes the client using a network call to fetch the bootstrap values.
   * If the client is inialized with an `analyticsWebClient`, it will send an operational event
   * to GASv3 with the following attributes:
   * - targetApp: the target app of the client
   * - clientVersion: the version of the client
   * - success: whether the initialization was successful
   * - startTime: the time when the initialization started
   * - totalTime: the total time it took to initialize the client
   * - apiKey: the api key used to initialize the client
   * @param clientOptions {ClientOptions}
   * @param identifiers {Identifiers}
   * @param customAttributes {CustomAttributes}
   * @returns {Promise<void>}
   */ return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(Client, [
        {
            key: "initialize",
            value: function() {
                var _initialize = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee(clientOptions, identifiers, customAttributes) {
                    var _this2 = this;
                    var clientOptionsWithDefaults, startTime;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee$(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                clientOptionsWithDefaults = (0, $5IOvr.getOptionsWithDefaults)(clientOptions);
                                if (!this.initPromise) {
                                    _context.next = 4;
                                    break;
                                }
                                if (!(0, $5IOvr.shallowEquals)(clientOptionsWithDefaults, this.initOptions)) // eslint-disable-next-line no-console
                                console.warn('Feature Gates client already initialized with different options. New options were not applied.');
                                return _context.abrupt("return", this.initPromise);
                            case 4:
                                startTime = performance.now();
                                this.initOptions = clientOptionsWithDefaults;
                                this.initPromise = this.init(clientOptionsWithDefaults, identifiers, customAttributes).then(function() {
                                    _this2.initCompleted = true;
                                    _this2.initWithDefaults = true;
                                }).finally(function() {
                                    var endTime = performance.now();
                                    var totalTime = endTime - startTime;
                                    _this2.fireClientEvent(startTime, totalTime, 'initialize', _this2.initCompleted, clientOptionsWithDefaults.apiKey);
                                });
                                return _context.abrupt("return", this.initPromise);
                            case 8:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee, this);
                }));
                function initialize(_x, _x2, _x3) {
                    return _initialize.apply(this, arguments);
                }
                return initialize;
            }()
        },
        {
            key: "initializeWithProvider",
            value: function() {
                var _initializeWithProvider = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee2(clientOptions, provider, identifiers, customAttributes) {
                    var _this3 = this;
                    var clientOptionsWithDefaults, startTime;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee2$(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                clientOptionsWithDefaults = (0, $5IOvr.getOptionsWithDefaults)(clientOptions);
                                if (!this.initPromise) {
                                    _context2.next = 4;
                                    break;
                                }
                                if (!(0, $5IOvr.shallowEquals)(clientOptionsWithDefaults, this.initOptions)) // eslint-disable-next-line no-console
                                console.warn('Feature Gates client already initialized with different options. New options were not applied.');
                                return _context2.abrupt("return", this.initPromise);
                            case 4:
                                startTime = performance.now();
                                this.initOptions = clientOptionsWithDefaults;
                                this.provider = provider;
                                this.provider.setClientVersion((0, $2sCeC.CLIENT_VERSION));
                                if (this.provider.setApplyUpdateCallback) this.provider.setApplyUpdateCallback(this.applyUpdateCallback.bind(this));
                                this.initPromise = this.initWithProvider(clientOptionsWithDefaults, provider, identifiers, customAttributes).then(function() {
                                    _this3.initCompleted = true;
                                    _this3.initWithDefaults = true;
                                }).finally(function() {
                                    var endTime = performance.now();
                                    var totalTime = endTime - startTime;
                                    _this3.fireClientEvent(startTime, totalTime, 'initializeWithProvider', _this3.initCompleted, provider.getApiKey ? provider.getApiKey() : undefined);
                                });
                                return _context2.abrupt("return", this.initPromise);
                            case 11:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2, this);
                }));
                function initializeWithProvider(_x4, _x5, _x6, _x7) {
                    return _initializeWithProvider.apply(this, arguments);
                }
                return initializeWithProvider;
            }()
        },
        {
            key: "applyUpdateCallback",
            value: function applyUpdateCallback(experimentsResult) {
                try {
                    if (this.initCompleted || this.initWithDefaults) {
                        this.assertInitialized(this.statsigClient);
                        this.dataAdapter.setBootstrapData(experimentsResult.experimentValues);
                        this.dataAdapter.setData(JSON.stringify(experimentsResult.experimentValues));
                        this.statsigValuesUpdated();
                    }
                } catch (error) {
                    // eslint-disable-next-line no-console
                    console.warn('Error when attempting to apply update', error);
                }
            }
        },
        {
            key: "fireClientEvent",
            value: function fireClientEvent(startTime, totalTime, action, success) {
                var _analyticsWebClient, _this4 = this;
                var apiKey = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
                (_analyticsWebClient = this.initOptions.analyticsWebClient) === null || _analyticsWebClient === void 0 || _analyticsWebClient.then(function(analyticsWebClient) {
                    var attributes = $8d8f9a1aa50e8aef$var$_objectSpread({
                        targetApp: _this4.initOptions.targetApp,
                        clientVersion: (0, $2sCeC.CLIENT_VERSION),
                        success: success,
                        startTime: startTime,
                        totalTime: totalTime
                    }, apiKey && {
                        apiKey: apiKey
                    });
                    analyticsWebClient.sendOperationalEvent({
                        action: action,
                        actionSubject: 'featureGatesClient',
                        attributes: attributes,
                        tags: [
                            'measurement'
                        ],
                        source: '@atlaskit/feature-gate-js-client'
                    });
                }).catch(function(err) {
                    if (_this4.initOptions.environment !== (0, $k9ONe.FeatureGateEnvironment).Production) // eslint-disable-next-line no-console
                    console.error('Analytics web client promise did not resolve', err);
                });
            }
        },
        {
            key: "initializeFromValues",
            value: function() {
                var _initializeFromValues = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee3(clientOptions, identifiers, customAttributes) {
                    var _this5 = this;
                    var initializeValues, clientOptionsWithDefaults, startTime, _args3 = arguments;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee3$(_context3) {
                        while(true)switch(_context3.prev = _context3.next){
                            case 0:
                                initializeValues = _args3.length > 3 && _args3[3] !== undefined ? _args3[3] : {};
                                clientOptionsWithDefaults = (0, $5IOvr.getOptionsWithDefaults)(clientOptions);
                                if (!this.initPromise) {
                                    _context3.next = 5;
                                    break;
                                }
                                if (!(0, $5IOvr.shallowEquals)(clientOptionsWithDefaults, this.initOptions)) // eslint-disable-next-line no-console
                                console.warn('Feature Gates client already initialized with different options. New options were not applied.');
                                return _context3.abrupt("return", this.initPromise);
                            case 5:
                                // This makes sure the new Statsig client behaves like the old when bootstrap data is
                                // passed, and `has_updates` isn't specified (which happens a lot in product integration tests).
                                if (!Object.prototype.hasOwnProperty.call(initializeValues, 'has_updates')) initializeValues['has_updates'] = true;
                                startTime = performance.now();
                                this.initOptions = clientOptionsWithDefaults;
                                this.initPromise = this.initFromValues(clientOptionsWithDefaults, identifiers, customAttributes, initializeValues).then(function() {
                                    _this5.initCompleted = true;
                                    _this5.initWithDefaults = true;
                                }).finally(function() {
                                    var endTime = performance.now();
                                    var totalTime = endTime - startTime;
                                    _this5.fireClientEvent(startTime, totalTime, 'initializeFromValues', _this5.initCompleted);
                                });
                                return _context3.abrupt("return", this.initPromise);
                            case 10:
                            case "end":
                                return _context3.stop();
                        }
                    }, _callee3, this);
                }));
                function initializeFromValues(_x8, _x9, _x0) {
                    return _initializeFromValues.apply(this, arguments);
                }
                return initializeFromValues;
            }()
        },
        {
            key: "assertInitialized",
            value: function assertInitialized(statsigClient) {
                if (!statsigClient) throw new Error('Client must be initialized before using this method');
            }
        },
        {
            key: "updateUser",
            value: function() {
                var _updateUser = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee4(fetchOptions, identifiers, customAttributes) {
                    var fetchOptionsWithDefaults, initializeValuesProducer;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee4$(_context4) {
                        while(true)switch(_context4.prev = _context4.next){
                            case 0:
                                this.assertInitialized(this.statsigClient);
                                fetchOptionsWithDefaults = (0, $5IOvr.getOptionsWithDefaults)(fetchOptions);
                                initializeValuesProducer = function initializeValuesProducer() {
                                    return (0, $5lXNt.default).fetchExperimentValues(fetchOptionsWithDefaults, identifiers, customAttributes).then(function(_ref2) {
                                        var experimentValues = _ref2.experimentValues, customAttributes = _ref2.customAttributes;
                                        return {
                                            experimentValues: experimentValues,
                                            customAttributesFromFetch: customAttributes
                                        };
                                    });
                                };
                                _context4.next = 5;
                                return this.updateUserUsingInitializeValuesProducer(initializeValuesProducer, identifiers, customAttributes);
                            case 5:
                            case "end":
                                return _context4.stop();
                        }
                    }, _callee4, this);
                }));
                function updateUser(_x1, _x10, _x11) {
                    return _updateUser.apply(this, arguments);
                }
                return updateUser;
            }()
        },
        {
            key: "updateUserWithProvider",
            value: function() {
                var _updateUserWithProvider = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee5(identifiers, customAttributes) {
                    var _this6 = this;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee5$(_context5) {
                        while(true)switch(_context5.prev = _context5.next){
                            case 0:
                                this.assertInitialized(this.statsigClient);
                                if (this.provider) {
                                    _context5.next = 3;
                                    break;
                                }
                                throw new Error('Cannot update user using provider as the client was not initialised with a provider');
                            case 3:
                                _context5.next = 5;
                                return this.provider.setProfile(this.initOptions, identifiers, customAttributes);
                            case 5:
                                _context5.next = 7;
                                return this.updateUserUsingInitializeValuesProducer(function() {
                                    return _this6.provider.getExperimentValues();
                                }, identifiers, customAttributes);
                            case 7:
                            case "end":
                                return _context5.stop();
                        }
                    }, _callee5, this);
                }));
                function updateUserWithProvider(_x12, _x13) {
                    return _updateUserWithProvider.apply(this, arguments);
                }
                return updateUserWithProvider;
            }()
        },
        {
            key: "updateUserWithValues",
            value: function() {
                var _updateUserWithValues = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee6(identifiers, customAttributes) {
                    var initializeValues, initializeValuesProducer, _args6 = arguments;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee6$(_context6) {
                        while(true)switch(_context6.prev = _context6.next){
                            case 0:
                                initializeValues = _args6.length > 2 && _args6[2] !== undefined ? _args6[2] : {};
                                this.assertInitialized(this.statsigClient);
                                initializeValuesProducer = function initializeValuesProducer() {
                                    return Promise.resolve({
                                        experimentValues: initializeValues,
                                        customAttributesFromFetch: customAttributes
                                    });
                                };
                                _context6.next = 5;
                                return this.updateUserUsingInitializeValuesProducer(initializeValuesProducer, identifiers, customAttributes);
                            case 5:
                            case "end":
                                return _context6.stop();
                        }
                    }, _callee6, this);
                }));
                function updateUserWithValues(_x14, _x15) {
                    return _updateUserWithValues.apply(this, arguments);
                }
                return updateUserWithValues;
            }()
        },
        {
            key: "initializeCalled",
            value: function initializeCalled() {
                return this.initPromise != null;
            }
        },
        {
            key: "initializeCompleted",
            value: function initializeCompleted() {
                return this.initCompleted;
            }
        },
        {
            key: "waitUntilInitializeCompleted",
            value: function() {
                var _waitUntilInitializeCompleted = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee7() {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee7$(_context7) {
                        while(true)switch(_context7.prev = _context7.next){
                            case 0:
                                if (this.initPromise) {
                                    _context7.next = 2;
                                    break;
                                }
                                throw new Error('The client must be initialized before you can wait until initialized.');
                            case 2:
                                if (!this.initCompleted) {
                                    _context7.next = 4;
                                    break;
                                }
                                return _context7.abrupt("return");
                            case 4:
                                _context7.next = 6;
                                return this.initPromise;
                            case 6:
                            case "end":
                                return _context7.stop();
                        }
                    }, _callee7, this);
                }));
                function waitUntilInitializeCompleted() {
                    return _waitUntilInitializeCompleted.apply(this, arguments);
                }
                return waitUntilInitializeCompleted;
            }()
        },
        {
            key: "checkGate",
            value: function checkGate(gateName) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                try {
                    this.assertInitialized(this.statsigClient);
                    var _options$fireGateExpo = options.fireGateExposure, fireGateExposure = _options$fireGateExpo === void 0 ? true : _options$fireGateExpo;
                    return this.statsigClient.checkGate(gateName, {
                        disableExposureLog: !fireGateExposure
                    });
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!this.hasCheckGateErrorOccurred) {
                        // eslint-disable-next-line no-console
                        console.warn({
                            msg: 'An error has occurred checking the feature gate. Only the first occurrence of this error is logged.',
                            gateName: gateName,
                            error: error
                        });
                        this.hasCheckGateErrorOccurred = true;
                    }
                    return false;
                }
            }
        },
        {
            key: "isGateExist",
            value: function isGateExist(gateName) {
                try {
                    this.assertInitialized(this.statsigClient);
                    var gate = this.statsigClient.getFeatureGate(gateName, {
                        disableExposureLog: true
                    });
                    return !gate.details.reason.includes('Unrecognized');
                } catch (error) {
                    // eslint-disable-next-line no-console
                    console.error("Error occurred when trying to check FeatureGate: ".concat(error));
                    // in case of error report true to avoid false positives.
                    return true;
                }
            }
        },
        {
            key: "isExperimentExist",
            value: function isExperimentExist(experimentName) {
                try {
                    this.assertInitialized(this.statsigClient);
                    var config = this.statsigClient.getExperiment(experimentName, {
                        disableExposureLog: true
                    });
                    return !config.details.reason.includes('Unrecognized');
                } catch (error) {
                    // eslint-disable-next-line no-console
                    console.error("Error occurred when trying to check Experiment: ".concat(error));
                    // in case of error report true to avoid false positives.
                    return true;
                }
            }
        },
        {
            key: "manuallyLogGateExposure",
            value: function manuallyLogGateExposure(gateName) {
                this.assertInitialized(this.statsigClient);
                // This is the approach recommended in the docs
                // https://docs.statsig.com/client/javascript-sdk/#manual-exposures-
                this.statsigClient.checkGate(gateName);
            }
        },
        {
            key: "getExperiment",
            value: function getExperiment(experimentName) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                try {
                    this.assertInitialized(this.statsigClient);
                    var _options$fireExperime = options.fireExperimentExposure, fireExperimentExposure = _options$fireExperime === void 0 ? true : _options$fireExperime;
                    return (0, $7RzhR.DynamicConfig).fromExperiment(this.statsigClient.getExperiment(experimentName, {
                        disableExposureLog: !fireExperimentExposure
                    }));
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!this.hasGetExperimentErrorOccurred) {
                        // eslint-disable-next-line no-console
                        console.warn({
                            msg: 'An error has occurred getting the experiment. Only the first occurrence of this error is logged.',
                            experimentName: experimentName,
                            error: error
                        });
                        this.hasGetExperimentErrorOccurred = true;
                    }
                    // Return a default value
                    return new (0, $7RzhR.DynamicConfig)(experimentName, {}, '', {
                        time: Date.now(),
                        reason: (0, $jSPjQ.EvaluationReason).Error
                    });
                }
            }
        },
        {
            key: "getExperimentValue",
            value: function getExperimentValue(experimentName, parameterName, defaultValue) {
                var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var experiment = this.getExperiment(experimentName, options);
                try {
                    var typeGuard = options.typeGuard;
                    return experiment.get(parameterName, defaultValue, typeGuard);
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!this.hasGetExperimentValueErrorOccurred) {
                        // eslint-disable-next-line no-console
                        console.warn({
                            msg: 'An error has occurred getting the experiment value. Only the first occurrence of this error is logged.',
                            experimentName: experimentName,
                            defaultValue: defaultValue,
                            options: options,
                            error: error
                        });
                        this.hasGetExperimentValueErrorOccurred = true;
                    }
                    return defaultValue;
                }
            }
        },
        {
            key: "manuallyLogExperimentExposure",
            value: function manuallyLogExperimentExposure(experimentName) {
                this.assertInitialized(this.statsigClient);
                // This is the approach recommended in the docs
                // https://docs.statsig.com/client/javascript-sdk/#manual-exposures-
                this.statsigClient.getExperiment(experimentName);
            }
        },
        {
            key: "manuallyLogLayerExposure",
            value: function manuallyLogLayerExposure(layerName, parameterName) {
                var _this$statsigClient$g;
                this.assertInitialized(this.statsigClient);
                // This is the approach recommended in the docs
                // https://docs.statsig.com/client/javascript-sdk/#manual-exposures-
                (_this$statsigClient$g = this.statsigClient.getLayer(layerName)) === null || _this$statsigClient$g === void 0 || _this$statsigClient$g.get(parameterName);
            }
        },
        {
            key: "shutdownStatsig",
            value: function shutdownStatsig() {
                this.assertInitialized(this.statsigClient);
                this.statsigClient.shutdown();
            }
        },
        {
            key: "overrideGate",
            value: function overrideGate(gateName, value) {
                this.overrideAdapter.overrideGate(gateName, value);
                // Trigger a reset of the memoized gate value
                if (this.user) {
                    var _this$statsigClient;
                    (_this$statsigClient = this.statsigClient) === null || _this$statsigClient === void 0 || _this$statsigClient.updateUserSync(this.user, {
                        disableBackgroundCacheRefresh: true
                    });
                }
                this.statsigValuesUpdated();
            }
        },
        {
            key: "clearGateOverride",
            value: function clearGateOverride(gateName) {
                this.overrideAdapter.removeGateOverride(gateName);
                this.statsigValuesUpdated();
            }
        },
        {
            key: "overrideConfig",
            value: function overrideConfig(experimentName, values) {
                this.overrideAdapter.overrideDynamicConfig(experimentName, values);
                this.statsigValuesUpdated();
            }
        },
        {
            key: "clearConfigOverride",
            value: function clearConfigOverride(experimentName) {
                this.overrideAdapter.removeDynamicConfigOverride(experimentName);
                this.statsigValuesUpdated();
            }
        },
        {
            key: "setOverrides",
            value: function setOverrides(overrides) {
                this.overrideAdapter.setOverrides(overrides);
                this.statsigValuesUpdated();
            }
        },
        {
            key: "getOverrides",
            value: function getOverrides() {
                return this.overrideAdapter.getOverrides();
            }
        },
        {
            key: "clearAllOverrides",
            value: function clearAllOverrides() {
                this.overrideAdapter.removeAllOverrides();
                this.statsigValuesUpdated();
            }
        },
        {
            key: "isCurrentUser",
            value: function isCurrentUser(identifiers, customAttributes) {
                return (0, $5IOvr.shallowEquals)(this.currentIdentifiers, identifiers) && (0, $5IOvr.shallowEquals)(this.currentAttributes, customAttributes);
            }
        },
        {
            key: "onGateUpdated",
            value: function onGateUpdated(gateName, callback) {
                var _this7 = this;
                var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var wrapCallback = function wrapCallback(value) {
                    var _options$fireGateExpo2 = options.fireGateExposure, fireGateExposure = _options$fireGateExpo2 === void 0 ? true : _options$fireGateExpo2;
                    if (fireGateExposure) _this7.manuallyLogGateExposure(gateName);
                    try {
                        callback(value);
                    } catch (error) {
                        // eslint-disable-next-line no-console
                        console.warn("Error calling callback for gate ".concat(gateName, " with value ").concat(value), error);
                    }
                };
                return this.subscriptions.onGateUpdated(gateName, wrapCallback, this.checkGate.bind(this), options);
            }
        },
        {
            key: "onExperimentValueUpdated",
            value: function onExperimentValueUpdated(experimentName, parameterName, defaultValue, callback) {
                var _this8 = this;
                var options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
                var wrapCallback = function wrapCallback(value) {
                    var _options$fireExperime2 = options.fireExperimentExposure, fireExperimentExposure = _options$fireExperime2 === void 0 ? true : _options$fireExperime2;
                    if (fireExperimentExposure) _this8.manuallyLogExperimentExposure(experimentName);
                    try {
                        callback(value);
                    } catch (error) {
                        // eslint-disable-next-line no-console
                        console.warn("Error calling callback for experiment ".concat(experimentName, " with value ").concat(value), error);
                    }
                };
                return this.subscriptions.onExperimentValueUpdated(experimentName, parameterName, defaultValue, wrapCallback, this.getExperimentValue.bind(this), options);
            }
        },
        {
            key: "onAnyUpdated",
            value: function onAnyUpdated(callback) {
                return this.subscriptions.onAnyUpdated(callback);
            }
        },
        {
            key: "init",
            value: function() {
                var _init = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee8(clientOptions, identifiers, customAttributes) {
                    var fromValuesClientOptions, experimentValues, customAttributesFromResult, clientSdkKeyPromise, experimentValuesPromise, _yield$Promise$all, _yield$Promise$all2, experimentValuesResult;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee8$(_context8) {
                        while(true)switch(_context8.prev = _context8.next){
                            case 0:
                                fromValuesClientOptions = $8d8f9a1aa50e8aef$var$_objectSpread({}, clientOptions);
                                _context8.prev = 1;
                                // If client sdk key fetch fails, an error would be thrown and handled instead of waiting for
                                // the experiment values request to be settled, and it will fall back to use default values.
                                clientSdkKeyPromise = (0, $5lXNt.default).fetchClientSdk(clientOptions).then(function(value) {
                                    return fromValuesClientOptions.sdkKey = value.clientSdkKey;
                                });
                                experimentValuesPromise = (0, $5lXNt.default).fetchExperimentValues(clientOptions, identifiers, customAttributes); // Only wait for the experiment values request to finish and try to initialise the client
                                // with experiment values if both requests are successful. Else an error would be thrown and
                                // handled by the catch
                                _context8.next = 6;
                                return Promise.all([
                                    clientSdkKeyPromise,
                                    experimentValuesPromise
                                ]);
                            case 6:
                                _yield$Promise$all = _context8.sent;
                                _yield$Promise$all2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_yield$Promise$all, 2);
                                experimentValuesResult = _yield$Promise$all2[1];
                                experimentValues = experimentValuesResult.experimentValues;
                                customAttributesFromResult = experimentValuesResult.customAttributes;
                                _context8.next = 20;
                                break;
                            case 13:
                                _context8.prev = 13;
                                _context8.t0 = _context8["catch"](1);
                                if (_context8.t0 instanceof Error) // eslint-disable-next-line no-console
                                console.error("Error occurred when trying to fetch the Feature Gates client values, error: ".concat(_context8.t0 === null || _context8.t0 === void 0 ? void 0 : _context8.t0.message));
                                // eslint-disable-next-line no-console
                                console.warn("Initialising Statsig client without values");
                                _context8.next = 19;
                                return this.initFromValues(fromValuesClientOptions, identifiers, customAttributes);
                            case 19:
                                throw _context8.t0;
                            case 20:
                                return _context8.abrupt("return", this.initFromValues(fromValuesClientOptions, identifiers, customAttributesFromResult, experimentValues));
                            case 21:
                            case "end":
                                return _context8.stop();
                        }
                    }, _callee8, this, [
                        [
                            1,
                            13
                        ]
                    ]);
                }));
                function init(_x16, _x17, _x18) {
                    return _init.apply(this, arguments);
                }
                return init;
            }()
        },
        {
            key: "initWithProvider",
            value: function() {
                var _initWithProvider = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee9(baseClientOptions, provider, identifiers, customAttributes) {
                    var fromValuesClientOptions, experimentValues, customAttributesFromResult, clientSdkKeyPromise, experimentValuesPromise, _yield$Promise$all3, _yield$Promise$all4, experimentValuesResult;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee9$(_context9) {
                        while(true)switch(_context9.prev = _context9.next){
                            case 0:
                                fromValuesClientOptions = $8d8f9a1aa50e8aef$var$_objectSpread($8d8f9a1aa50e8aef$var$_objectSpread({}, baseClientOptions), {}, {
                                    disableCurrentPageLogging: true
                                });
                                _context9.prev = 1;
                                _context9.next = 4;
                                return provider.setProfile(baseClientOptions, identifiers, customAttributes);
                            case 4:
                                // If client sdk key fetch fails, an error would be thrown and handled instead of waiting for
                                // the experiment values request to be settled, and it will fall back to use default values.
                                clientSdkKeyPromise = provider.getClientSdkKey().then(function(value) {
                                    return fromValuesClientOptions.sdkKey = value;
                                });
                                experimentValuesPromise = provider.getExperimentValues(); // Only wait for the experiment values request to finish and try to initialise the client
                                // with experiment values if both requests are successful. Else an error would be thrown and
                                // handled by the catch
                                _context9.next = 8;
                                return Promise.all([
                                    clientSdkKeyPromise,
                                    experimentValuesPromise
                                ]);
                            case 8:
                                _yield$Promise$all3 = _context9.sent;
                                _yield$Promise$all4 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_yield$Promise$all3, 2);
                                experimentValuesResult = _yield$Promise$all4[1];
                                experimentValues = experimentValuesResult.experimentValues;
                                customAttributesFromResult = experimentValuesResult.customAttributesFromFetch;
                                _context9.next = 22;
                                break;
                            case 15:
                                _context9.prev = 15;
                                _context9.t0 = _context9["catch"](1);
                                if (_context9.t0 instanceof Error) // eslint-disable-next-line no-console
                                console.error("Error occurred when trying to fetch the Feature Gates client values, error: ".concat(_context9.t0 === null || _context9.t0 === void 0 ? void 0 : _context9.t0.message));
                                // eslint-disable-next-line no-console
                                console.warn("Initialising Statsig client without values");
                                _context9.next = 21;
                                return this.initFromValues(fromValuesClientOptions, identifiers, customAttributes);
                            case 21:
                                throw _context9.t0;
                            case 22:
                                return _context9.abrupt("return", this.initFromValues(fromValuesClientOptions, identifiers, customAttributesFromResult, experimentValues));
                            case 23:
                            case "end":
                                return _context9.stop();
                        }
                    }, _callee9, this, [
                        [
                            1,
                            15
                        ]
                    ]);
                }));
                function initWithProvider(_x19, _x20, _x21, _x22) {
                    return _initWithProvider.apply(this, arguments);
                }
                return initWithProvider;
            }()
        },
        {
            key: "initFromValues",
            value: function() {
                var _initFromValues = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee0(clientOptions, identifiers, customAttributes) {
                    var _newClientOptions$net;
                    var initializeValues, newClientOptions, sdkKey, environment, _updateUserCompletionCallback, _perimeter, restClientOptions, statsigOptions, _args0 = arguments;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee0$(_context0) {
                        while(true)switch(_context0.prev = _context0.next){
                            case 0:
                                initializeValues = _args0.length > 3 && _args0[3] !== undefined ? _args0[3] : {};
                                this.overrideAdapter.initFromStoredOverrides();
                                this.currentIdentifiers = identifiers;
                                this.currentAttributes = customAttributes;
                                newClientOptions = (0, $5IOvr.migrateInitializationOptions)(clientOptions);
                                if (!newClientOptions.sdkKey) newClientOptions.sdkKey = $8d8f9a1aa50e8aef$var$DEFAULT_CLIENT_KEY;
                                if (!((_newClientOptions$net = newClientOptions.networkConfig) !== null && _newClientOptions$net !== void 0 && _newClientOptions$net.logEventUrl)) newClientOptions.networkConfig = $8d8f9a1aa50e8aef$var$_objectSpread($8d8f9a1aa50e8aef$var$_objectSpread({}, newClientOptions.networkConfig), {}, {
                                    logEventUrl: $8d8f9a1aa50e8aef$var$DEFAULT_EVENT_LOGGING_API
                                });
                                if (newClientOptions.perimeter === (0, $k9ONe.PerimeterType).FEDRAMP_MODERATE) // disable all logging in FedRAMP to prevent egress of sensitive data
                                newClientOptions.disableLogging = true;
                                sdkKey = newClientOptions.sdkKey, environment = newClientOptions.environment, _updateUserCompletionCallback = newClientOptions.updateUserCompletionCallback, _perimeter = newClientOptions.perimeter, restClientOptions = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(newClientOptions, $8d8f9a1aa50e8aef$var$_excluded);
                                this.user = (0, $5IOvr.toStatsigUser)(identifiers, customAttributes);
                                statsigOptions = $8d8f9a1aa50e8aef$var$_objectSpread($8d8f9a1aa50e8aef$var$_objectSpread({}, restClientOptions), {}, {
                                    environment: {
                                        tier: environment
                                    },
                                    includeCurrentPageUrlWithEvents: false,
                                    dataAdapter: this.dataAdapter,
                                    overrideAdapter: this.overrideAdapter,
                                    logEventCompressionMode: (0, $iFR7a.LogEventCompressionMode).Forced
                                }); // Statsig validates the provided stableId against their own cookie, so we either need
                                // to update the cookie to match, or disable the validation completely.
                                if (identifiers.stableId) (0, $iFR7a.StableID).setOverride(identifiers.stableId, sdkKey);
                                else statsigOptions.disableStableID = true;
                                _context0.prev = 12;
                                this.statsigClient = new (0, $iFR7a.StatsigClient)(sdkKey, this.user, statsigOptions);
                                this.dataAdapter.setBootstrapData(initializeValues);
                                _context0.next = 17;
                                return this.statsigClient.initializeAsync();
                            case 17:
                                _context0.next = 29;
                                break;
                            case 19:
                                _context0.prev = 19;
                                _context0.t0 = _context0["catch"](12);
                                if (_context0.t0 instanceof Error) // eslint-disable-next-line no-console
                                console.error("Error occurred when trying to initialise the Statsig client, error: ".concat(_context0.t0 === null || _context0.t0 === void 0 ? void 0 : _context0.t0.message));
                                // eslint-disable-next-line no-console
                                console.warn("Initialising Statsig client with default sdk key and without values");
                                this.statsigClient = new (0, $iFR7a.StatsigClient)($8d8f9a1aa50e8aef$var$DEFAULT_CLIENT_KEY, this.user, statsigOptions);
                                this.dataAdapter.setBootstrapData();
                                _context0.next = 27;
                                return this.statsigClient.initializeAsync();
                            case 27:
                                this.initWithDefaults = true;
                                throw _context0.t0;
                            case 29:
                            case "end":
                                return _context0.stop();
                        }
                    }, _callee0, this, [
                        [
                            12,
                            19
                        ]
                    ]);
                }));
                function initFromValues(_x23, _x24, _x25) {
                    return _initFromValues.apply(this, arguments);
                }
                return initFromValues;
            }()
        },
        {
            key: "updateUserUsingInitializeValuesProducer",
            value: function() {
                var _updateUserUsingInitializeValuesProducer = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee10(getInitializeValues, identifiers, customAttributes) {
                    var _this9 = this;
                    var originalInitPromise, initializeValuesPromise, updateUserPromise;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee10$(_context10) {
                        while(true)switch(_context10.prev = _context10.next){
                            case 0:
                                this.assertInitialized(this.statsigClient);
                                if (this.initPromise) {
                                    _context10.next = 3;
                                    break;
                                }
                                throw new Error('The client must be initialized before you can update the user.');
                            case 3:
                                if (!this.isCurrentUser(identifiers, customAttributes)) {
                                    _context10.next = 5;
                                    break;
                                }
                                return _context10.abrupt("return", this.initPromise);
                            case 5:
                                // Wait for the current initialize/update to finish
                                originalInitPromise = this.initPromise;
                                _context10.prev = 6;
                                _context10.next = 9;
                                return this.initPromise;
                            case 9:
                                _context10.next = 13;
                                break;
                            case 11:
                                _context10.prev = 11;
                                _context10.t0 = _context10["catch"](6);
                            case 13:
                                initializeValuesPromise = getInitializeValues();
                                updateUserPromise = this.updateStatsigClientUser(initializeValuesPromise, identifiers, customAttributes); // We replace the init promise here since we are essentially re-initializing the client at this
                                // point. Any subsequent calls to await client.initialize() or client.updateUser()
                                // will now also await this user update.
                                this.initPromise = updateUserPromise.catch(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee1() {
                                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee1$(_context1) {
                                        while(true)switch(_context1.prev = _context1.next){
                                            case 0:
                                                // If the update failed then it changed nothing, so revert back to the original promise.
                                                _this9.initPromise = originalInitPromise;
                                                // Set the user profile again to revert back to the current user
                                                if (!_this9.provider) {
                                                    _context1.next = 4;
                                                    break;
                                                }
                                                _context1.next = 4;
                                                return _this9.provider.setProfile(_this9.initOptions, _this9.currentIdentifiers, _this9.currentAttributes);
                                            case 4:
                                            case "end":
                                                return _context1.stop();
                                        }
                                    }, _callee1);
                                })));
                                return _context10.abrupt("return", updateUserPromise);
                            case 17:
                            case "end":
                                return _context10.stop();
                        }
                    }, _callee10, this, [
                        [
                            6,
                            11
                        ]
                    ]);
                }));
                function updateUserUsingInitializeValuesProducer(_x26, _x27, _x28) {
                    return _updateUserUsingInitializeValuesProducer.apply(this, arguments);
                }
                return updateUserUsingInitializeValuesProducer;
            }()
        },
        {
            key: "updateStatsigClientUser",
            value: function() {
                var _updateStatsigClientUser = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee11(initializeValuesPromise, identifiers, customAttributes) {
                    var _this$initOptions, _this$initOptions$upd;
                    var initializeValues, user, _updateUserCompletion, _ref4, errMsg, success, errorMessage;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee11$(_context11) {
                        while(true)switch(_context11.prev = _context11.next){
                            case 0:
                                this.assertInitialized(this.statsigClient);
                                _context11.prev = 1;
                                _context11.next = 4;
                                return initializeValuesPromise;
                            case 4:
                                initializeValues = _context11.sent;
                                user = (0, $5IOvr.toStatsigUser)(identifiers, initializeValues.customAttributesFromFetch);
                                _context11.next = 13;
                                break;
                            case 8:
                                _context11.prev = 8;
                                _context11.t0 = _context11["catch"](1);
                                // Make sure the updateUserCompletionCallback is called for any errors in our custom code.
                                // This is not necessary for the updateUserWithValues call, because the Statsig client will
                                // already invoke the callback itself.
                                errMsg = _context11.t0 instanceof Error ? _context11.t0.message : JSON.stringify(_context11.t0);
                                (_updateUserCompletion = (_ref4 = this.initOptions).updateUserCompletionCallback) === null || _updateUserCompletion === void 0 || _updateUserCompletion.call(_ref4, false, errMsg);
                                throw _context11.t0;
                            case 13:
                                success = true;
                                errorMessage = null;
                                _context11.prev = 15;
                                this.dataAdapter.setBootstrapData(initializeValues.experimentValues);
                                this.user = user;
                                if (!this.user) {
                                    _context11.next = 21;
                                    break;
                                }
                                _context11.next = 21;
                                return this.statsigClient.updateUserAsync(this.user);
                            case 21:
                                _context11.next = 27;
                                break;
                            case 23:
                                _context11.prev = 23;
                                _context11.t1 = _context11["catch"](15);
                                success = false;
                                errorMessage = String(_context11.t1);
                            case 27:
                                (_this$initOptions = this.initOptions) === null || _this$initOptions === void 0 || (_this$initOptions$upd = _this$initOptions.updateUserCompletionCallback) === null || _this$initOptions$upd === void 0 || _this$initOptions$upd.call(_this$initOptions, success, errorMessage);
                                if (!success) {
                                    _context11.next = 34;
                                    break;
                                }
                                this.currentIdentifiers = identifiers;
                                this.currentAttributes = customAttributes;
                                this.subscriptions.anyUpdated();
                                _context11.next = 35;
                                break;
                            case 34:
                                throw new Error('Failed to update user. An unexpected error occured.');
                            case 35:
                            case "end":
                                return _context11.stop();
                        }
                    }, _callee11, this, [
                        [
                            1,
                            8
                        ],
                        [
                            15,
                            23
                        ]
                    ]);
                }));
                function updateStatsigClientUser(_x29, _x30, _x31) {
                    return _updateStatsigClientUser.apply(this, arguments);
                }
                return updateStatsigClientUser;
            }()
        },
        {
            key: "getPackageVersion",
            value: /**
     * @returns string version of the current package in semver style.
     */ function getPackageVersion() {
                return 0, $2sCeC.CLIENT_VERSION;
            }
        },
        {
            key: "getLayer",
            value: function getLayer(/** The name of the layer */ layerName) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                try {
                    this.assertInitialized(this.statsigClient);
                    var _options$fireLayerExp = options.fireLayerExposure, fireLayerExposure = _options$fireLayerExp === void 0 ? true : _options$fireLayerExp;
                    return (0, $176K2.Layer).fromLayer(this.statsigClient.getLayer(layerName, {
                        disableExposureLog: !fireLayerExposure
                    }));
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!this.hasGetLayerErrorOccurred) {
                        // eslint-disable-next-line no-console
                        console.warn({
                            msg: 'An error has occurred getting the layer. Only the first occurrence of this error is logged.',
                            layerName: layerName,
                            error: error
                        });
                        this.hasGetLayerErrorOccurred = true;
                    }
                    // Return a default value
                    return (0, $176K2.Layer).fromLayer((0, $iFR7a._makeLayer)(layerName, {
                        reason: 'Error'
                    }, null));
                }
            }
        },
        {
            key: "getLayerValue",
            value: function getLayerValue(layerName, parameterName, defaultValue) {
                var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var layer = this.getLayer(layerName, options);
                try {
                    var typeGuard = options.typeGuard;
                    return layer.get(parameterName, defaultValue, typeGuard);
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!this.hasGetLayerValueErrorOccurred) {
                        // eslint-disable-next-line no-console
                        console.warn({
                            msg: 'An error has occurred getting the layer value. Only the first occurrence of this error is logged.',
                            layerName: layerName,
                            defaultValue: defaultValue,
                            options: options,
                            error: error
                        });
                        this.hasGetLayerValueErrorOccurred = true;
                    }
                    return defaultValue;
                }
            }
        }
    ]);
}();

});
parcelRegister("bFONp", function(module, exports) {
$parcel$export(module.exports, "default", () => $87faed0a9889cee9$export$2e2bcd8739ae039);

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $25nEq = parcelRequire("25nEq");

var $hLfKH = parcelRequire("hLfKH");
function $87faed0a9889cee9$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $87faed0a9889cee9$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $87faed0a9889cee9$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $87faed0a9889cee9$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $87faed0a9889cee9$export$a66cbd9b2289cd78 = '@all-features';
var $87faed0a9889cee9$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function Subscriptions() {
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, Subscriptions);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "eventToValue", new Map());
        this.emitter = new (0, (/*@__PURE__*/$parcel$interopDefault($hLfKH)))();
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(Subscriptions, [
        {
            key: "onGateUpdated",
            value: function onGateUpdated(gateName, callback, checkGate, options) {
                var _this = this;
                var value = checkGate(gateName, $87faed0a9889cee9$var$_objectSpread($87faed0a9889cee9$var$_objectSpread({}, options), {}, {
                    fireGateExposure: false
                }));
                if (this.eventToValue.get(callback) === undefined) this.eventToValue.set(callback, value);
                var wrapCallback = function wrapCallback() {
                    var value = checkGate(gateName, $87faed0a9889cee9$var$_objectSpread($87faed0a9889cee9$var$_objectSpread({}, options), {}, {
                        fireGateExposure: false
                    }));
                    var existingValue = _this.eventToValue.get(callback);
                    if (existingValue !== value) {
                        _this.eventToValue.set(callback, value);
                        callback(value);
                    }
                };
                this.emitter.on(gateName, wrapCallback);
                return function() {
                    _this.emitter.off(gateName, wrapCallback);
                };
            }
        },
        {
            key: "onExperimentValueUpdated",
            value: function onExperimentValueUpdated(experimentName, parameterName, defaultValue, callback, getExperimentValue, options) {
                var _this2 = this;
                var experimentEventName = "".concat(experimentName, ".").concat(parameterName);
                var value = getExperimentValue(experimentName, parameterName, defaultValue, $87faed0a9889cee9$var$_objectSpread($87faed0a9889cee9$var$_objectSpread({}, options), {}, {
                    fireExperimentExposure: false
                }));
                if (this.eventToValue.get(callback) === undefined) this.eventToValue.set(callback, value);
                var wrapCallback = function wrapCallback() {
                    var value = getExperimentValue(experimentName, parameterName, defaultValue, $87faed0a9889cee9$var$_objectSpread($87faed0a9889cee9$var$_objectSpread({}, options), {}, {
                        fireExperimentExposure: false
                    }));
                    var existingValue = _this2.eventToValue.get(callback);
                    if (existingValue !== value) {
                        _this2.eventToValue.set(callback, value);
                        callback(value);
                    }
                };
                this.emitter.on(experimentEventName, wrapCallback);
                return function() {
                    _this2.emitter.off(experimentEventName, wrapCallback);
                };
            }
        },
        {
            key: "onAnyUpdated",
            value: function onAnyUpdated(callback) {
                var _this3 = this;
                this.emitter.on($87faed0a9889cee9$export$a66cbd9b2289cd78, callback);
                return function() {
                    _this3.emitter.off($87faed0a9889cee9$export$a66cbd9b2289cd78, callback);
                };
            }
        },
        {
            key: "anyUpdated",
            value: function anyUpdated() {
                var _this4 = this;
                this.emitter.emit($87faed0a9889cee9$export$a66cbd9b2289cd78);
                this.emitter.eventNames().filter(function(name) {
                    return name !== $87faed0a9889cee9$export$a66cbd9b2289cd78;
                }).forEach(function(event) {
                    _this4.emitter.emit(event);
                });
            }
        }
    ]);
}();

});

parcelRegister("7RzhR", function(module, exports) {
$parcel$export(module.exports, "DynamicConfig", () => $5b98dae73ef9baa8$export$6dc24881a3d96325);

var $ekGgq = parcelRequire("ekGgq");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $5IOvr = parcelRequire("5IOvr");
var $5b98dae73ef9baa8$export$6dc24881a3d96325 = /*#__PURE__*/ function() {
    function DynamicConfig(configName, configValue, ruleID, evaluationDetails) {
        var secondaryExposures = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : [];
        var allocatedExperimentName = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : '';
        var onDefaultValueFallback = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : null;
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, DynamicConfig);
        this.value = configValue;
        this._name = configName;
        this._ruleID = ruleID;
        this._secondaryExposures = secondaryExposures;
        this._allocatedExperimentName = allocatedExperimentName;
        this._evaluationDetails = evaluationDetails;
        this._onDefaultValueFallback = onDefaultValueFallback;
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(DynamicConfig, [
        {
            key: "get",
            value: function get(key, defaultValue, typeGuard) {
                var _this$_onDefaultValue2;
                var val = this.getValue(key, defaultValue);
                if (val == null) return defaultValue;
                var expectedType = Array.isArray(defaultValue) ? 'array' : (0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(defaultValue);
                var actualType = Array.isArray(val) ? 'array' : (0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(val);
                if (typeGuard) {
                    var _this$_onDefaultValue;
                    if (typeGuard(val)) {
                        this.fireExposure(key);
                        return val;
                    }
                    (_this$_onDefaultValue = this._onDefaultValueFallback) === null || _this$_onDefaultValue === void 0 || _this$_onDefaultValue.call(this, this, key, expectedType, actualType);
                    return defaultValue;
                }
                if (defaultValue == null || expectedType === actualType) {
                    this.fireExposure(key);
                    return val;
                }
                (_this$_onDefaultValue2 = this._onDefaultValueFallback) === null || _this$_onDefaultValue2 === void 0 || _this$_onDefaultValue2.call(this, this, key, expectedType, actualType);
                return defaultValue;
            }
        },
        {
            key: "getValue",
            value: function getValue(key, defaultValue) {
                if (key == null) return this.value;
                if (defaultValue == null) defaultValue = null;
                if (this.value[key] == null) return defaultValue;
                this.fireExposure(key);
                return this.value[key];
            }
        },
        {
            key: "fireExposure",
            value: function fireExposure(key) {
                // Call the wrapped experiment's get method to fire exposure
                if (this.experiment) this.experiment.get(key);
            }
        }
    ], [
        {
            key: "fromExperiment",
            value: function fromExperiment(experiment) {
                var _experiment$__evaluat, _experiment$__evaluat2, _experiment$groupName;
                var config = new DynamicConfig(experiment.name, experiment.value, experiment.ruleID, (0, $5IOvr.migrateEvaluationDetails)(experiment.details), (0, $5IOvr.migrateSecondaryExposures)((_experiment$__evaluat = (_experiment$__evaluat2 = experiment.__evaluation) === null || _experiment$__evaluat2 === void 0 ? void 0 : _experiment$__evaluat2.secondary_exposures) !== null && _experiment$__evaluat !== void 0 ? _experiment$__evaluat : []), (_experiment$groupName = experiment.groupName) !== null && _experiment$groupName !== void 0 ? _experiment$groupName : undefined);
                config.experiment = experiment;
                return config;
            }
        }
    ]);
}();

});
parcelRegister("5IOvr", function(module, exports) {
$parcel$export(module.exports, "getOptionsWithDefaults", () => $42a83d429aa9793e$export$d119b37e5f788b43);
$parcel$export(module.exports, "shallowEquals", () => $42a83d429aa9793e$export$fa1c2bbf4100b8bc);
$parcel$export(module.exports, "toStatsigUser", () => $42a83d429aa9793e$export$3dad1db244472f32);
$parcel$export(module.exports, "migrateInitializationOptions", () => $42a83d429aa9793e$export$202946b690d26d22);
$parcel$export(module.exports, "migrateEvaluationDetails", () => $42a83d429aa9793e$export$18ad168d3dbac899);
$parcel$export(module.exports, "migrateSecondaryExposures", () => $42a83d429aa9793e$export$55fd683752d01e67);

var $1Vcia = parcelRequire("1Vcia");

var $iYJcE = parcelRequire("iYJcE");

var $25nEq = parcelRequire("25nEq");

var $ygbGG = parcelRequire("ygbGG");

var $jSPjQ = parcelRequire("jSPjQ");

var $k9ONe = parcelRequire("k9ONe");
var $42a83d429aa9793e$var$_excluded = [
    "api",
    "disableCurrentPageLogging",
    "loggingIntervalMillis",
    "loggingBufferMaxSize",
    "localMode",
    "eventLoggingApi",
    "eventLoggingApiForRetries",
    "disableLocalStorage",
    "ignoreWindowUndefined",
    "disableAllLogging",
    "initTimeoutMs",
    "disableNetworkKeepalive",
    "overrideStableID",
    "disableErrorLogging",
    "disableAutoMetricsLogging"
];
function $42a83d429aa9793e$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $42a83d429aa9793e$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $42a83d429aa9793e$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $42a83d429aa9793e$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $42a83d429aa9793e$export$d119b37e5f788b43 = function getOptionsWithDefaults(options) {
    return $42a83d429aa9793e$var$_objectSpread({
        /**
     * If more federal PerimeterTypes are added in the future, this should be updated so
     * that isFedRamp() === true always returns the strictest perimeter.
     */ perimeter: (0, $ygbGG.isFedRamp)() ? (0, $k9ONe.PerimeterType).FEDRAMP_MODERATE : (0, $k9ONe.PerimeterType).COMMERCIAL
    }, options);
};
var $42a83d429aa9793e$export$fa1c2bbf4100b8bc = function shallowEquals(objectA, objectB) {
    if (!objectA && !objectB) return true;
    if (!objectA || !objectB) return false;
    var aEntries = Object.entries(objectA);
    var bEntries = Object.entries(objectB);
    if (aEntries.length !== bEntries.length) return false;
    var ascendingKeyOrder = function ascendingKeyOrder(_ref, _ref2) {
        var _ref3 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_ref, 1), key1 = _ref3[0];
        var _ref4 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_ref2, 1), key2 = _ref4[0];
        return key1.localeCompare(key2);
    };
    aEntries.sort(ascendingKeyOrder);
    bEntries.sort(ascendingKeyOrder);
    for(var i = 0; i < aEntries.length; i++){
        var _aEntries$i = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(aEntries[i], 2), aValue = _aEntries$i[1];
        var _bEntries$i = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(bEntries[i], 2), bValue = _bEntries$i[1];
        if (aValue !== bValue) return false;
    }
    return true;
};
var $42a83d429aa9793e$export$3dad1db244472f32 = function toStatsigUser(identifiers, customAttributes) {
    var user = {
        customIDs: identifiers,
        custom: customAttributes
    };
    if (identifiers.atlassianAccountId) user.userID = identifiers.atlassianAccountId;
    return user;
};
var $42a83d429aa9793e$export$202946b690d26d22 = function migrateInitializationOptions(options) {
    var api = options.api, disableCurrentPageLogging = options.disableCurrentPageLogging, loggingIntervalMillis = options.loggingIntervalMillis, loggingBufferMaxSize = options.loggingBufferMaxSize, localMode = options.localMode, eventLoggingApi = options.eventLoggingApi, eventLoggingApiForRetries = options.eventLoggingApiForRetries, disableLocalStorage = options.disableLocalStorage, ignoreWindowUndefined = options.ignoreWindowUndefined, disableAllLogging = options.disableAllLogging, _initTimeoutMs = options.initTimeoutMs, _disableNetworkKeepalive = options.disableNetworkKeepalive, _overrideStableID = options.overrideStableID, _disableErrorLogging = options.disableErrorLogging, _disableAutoMetricsLogging = options.disableAutoMetricsLogging, rest = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(options, $42a83d429aa9793e$var$_excluded);
    return $42a83d429aa9793e$var$_objectSpread($42a83d429aa9793e$var$_objectSpread({}, rest), {}, {
        networkConfig: {
            api: api,
            logEventUrl: eventLoggingApi ? eventLoggingApi + 'rgstr' : undefined,
            logEventFallbackUrls: eventLoggingApiForRetries ? [
                eventLoggingApiForRetries
            ] : undefined,
            preventAllNetworkTraffic: localMode || !ignoreWindowUndefined && typeof window === 'undefined'
        },
        includeCurrentPageUrlWithEvents: !disableCurrentPageLogging,
        loggingIntervalMs: loggingIntervalMillis,
        loggingBufferMaxSize: loggingBufferMaxSize,
        disableStorage: disableLocalStorage === undefined ? localMode : disableLocalStorage,
        disableLogging: disableAllLogging === undefined ? localMode : disableAllLogging
    });
};
var $42a83d429aa9793e$var$evaluationReasonMappings = Object.entries((0, $jSPjQ.EvaluationReason)).map(function(_ref5) {
    var _ref6 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_ref5, 2), key = _ref6[0], value = _ref6[1];
    return [
        key.toLowerCase(),
        value
    ];
});
var $42a83d429aa9793e$export$18ad168d3dbac899 = function migrateEvaluationDetails(details) {
    var _evaluationReasonMapp, _evaluationReasonMapp2, _details$receivedAt;
    var reasonLower = details.reason.toLowerCase();
    return {
        reason: (_evaluationReasonMapp = (_evaluationReasonMapp2 = $42a83d429aa9793e$var$evaluationReasonMappings.find(function(_ref7) {
            var _ref8 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_ref7, 1), key = _ref8[0];
            return reasonLower.includes(key);
        })) === null || _evaluationReasonMapp2 === void 0 ? void 0 : _evaluationReasonMapp2[1]) !== null && _evaluationReasonMapp !== void 0 ? _evaluationReasonMapp : (0, $jSPjQ.EvaluationReason).Unknown,
        time: (_details$receivedAt = details.receivedAt) !== null && _details$receivedAt !== void 0 ? _details$receivedAt : Date.now()
    };
};
var $42a83d429aa9793e$export$55fd683752d01e67 = function migrateSecondaryExposures(secondaryExposures) {
    return secondaryExposures.map(function(exposure) {
        if (typeof exposure === 'string') // This should ideally have gateValue and ruleID fields too, but it's not possible for us
        // to determine the correct values for these.
        return {
            gate: exposure
        };
        return exposure;
    });
};

});
parcelRegister("jSPjQ", function(module, exports) {
$parcel$export(module.exports, "EvaluationReason", () => $e79ade5a931ae9b1$export$c62558b199e46828);
// Reference: https://github.com/statsig-io/js-lite/blob/main/src/StatsigStore.ts
var $e79ade5a931ae9b1$export$c62558b199e46828 = /*#__PURE__*/ function(EvaluationReason) {
    // Order is important since the logic for migrating from a new client reason to an old one
    // returns the first which is a substring of the new client reason
    EvaluationReason["Error"] = "Error";
    EvaluationReason["LocalOverride"] = "LocalOverride";
    EvaluationReason["Unrecognized"] = "Unrecognized";
    EvaluationReason["Uninitialized"] = "Uninitialized";
    EvaluationReason["NetworkNotModified"] = "NetworkNotModified";
    EvaluationReason["Network"] = "Network";
    EvaluationReason["InvalidBootstrap"] = "InvalidBootstrap";
    EvaluationReason["Bootstrap"] = "Bootstrap";
    EvaluationReason["Cache"] = "Cache";
    // For when we could not migrate the reason from the new client
    EvaluationReason["Unknown"] = "Unknown";
    return EvaluationReason;
}({}); // Reference: https://github.com/statsig-io/js-lite/blob/main/src/StatsigSDKOptions.ts

});

parcelRegister("k9ONe", function(module, exports) {
$parcel$export(module.exports, "FeatureGateEnvironment", () => $eacc0c5b443d7e57$export$479e7351a733299);
$parcel$export(module.exports, "PerimeterType", () => $eacc0c5b443d7e57$export$c42b7bbc5e7ba555);
/**
 * The identifiers for the user. Options are restricted to the set that is currently supported.
 */ /**
 * Base client options. Does not include any options specific to providers
 * @interface BaseClientOptions
 * @property {FeatureGateEnvironment} environment - The environment for the client.
 * @property {string} targetApp - The target app for the client.
 * @property {AnalyticsWebClient} analyticsWebClient - The analytics web client.
 * @property {PerimeterType} perimeter - The perimeter for the client.
 */ /**
 * The options for the client.
 * @interface ClientOptions
 * @extends {BaseClientOptions}
 * @property {string} apiKey - The API key for the client.
 * @property {fetchTimeoutMs} fetchTimeoutMs - The timeout for the fetch request in milliseconds. Defaults to 5000.
 * @property {boolean} useGatewayURL - Whether to use the gateway URL. Defaults to false.
 */ /**
 * The custom attributes for the user.
 */ var $eacc0c5b443d7e57$export$479e7351a733299 = /*#__PURE__*/ function(FeatureGateEnvironment) {
    FeatureGateEnvironment["Development"] = "development";
    FeatureGateEnvironment["Staging"] = "staging";
    FeatureGateEnvironment["Production"] = "production";
    return FeatureGateEnvironment;
}({});
var $eacc0c5b443d7e57$export$c42b7bbc5e7ba555 = /*#__PURE__*/ function(PerimeterType) {
    PerimeterType["COMMERCIAL"] = "commercial";
    PerimeterType["FEDRAMP_MODERATE"] = "fedramp-moderate";
    return PerimeterType;
}({});
var $eacc0c5b443d7e57$export$42f4885608027d0c = 'non_boolean'; // Type magic to get the JSDoc comments from the Client class methods to appear on the static
 // methods in FeatureGates where the property name and function type are identical

});



parcelRegister("176K2", function(module, exports) {
$parcel$export(module.exports, "Layer", () => $0cfbac9d4c75e170$export$936d0764594b6eb3);

var $ekGgq = parcelRequire("ekGgq");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $5IOvr = parcelRequire("5IOvr");
var $0cfbac9d4c75e170$export$936d0764594b6eb3 = /*#__PURE__*/ function() {
    function Layer(name, layerValue, ruleID, evaluationDetails) {
        var logParameterFunction = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
        var secondaryExposures = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : [];
        var undelegatedSecondaryExposures = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : [];
        var allocatedExperimentName = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : '';
        var explicitParameters = arguments.length > 8 && arguments[8] !== undefined ? arguments[8] : [];
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, Layer);
        this._logParameterFunction = logParameterFunction;
        this._name = name;
        this._value = JSON.parse(JSON.stringify(layerValue !== null && layerValue !== void 0 ? layerValue : {}));
        this._ruleID = ruleID !== null && ruleID !== void 0 ? ruleID : '';
        this._evaluationDetails = evaluationDetails;
        this._secondaryExposures = secondaryExposures;
        this._undelegatedSecondaryExposures = undelegatedSecondaryExposures;
        this._allocatedExperimentName = allocatedExperimentName;
        this._explicitParameters = explicitParameters;
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(Layer, [
        {
            key: "get",
            value: function get(key, defaultValue, typeGuard) {
                var _this = this;
                var val = this._value[key];
                if (val == null) return defaultValue;
                var logAndReturn = function logAndReturn() {
                    _this._logLayerParameterExposure(key);
                    return val;
                };
                if (typeGuard) return typeGuard(val) ? logAndReturn() : defaultValue;
                if (defaultValue == null) return logAndReturn();
                if ((0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(val) === (0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(defaultValue) && Array.isArray(defaultValue) === Array.isArray(val)) return logAndReturn();
                return defaultValue;
            }
        },
        {
            key: "getValue",
            value: function getValue(key, defaultValue) {
                // eslint-disable-next-line eqeqeq
                if (defaultValue == undefined) defaultValue = null;
                var val = this._value[key];
                if (val != null) this._logLayerParameterExposure(key);
                return val !== null && val !== void 0 ? val : defaultValue;
            }
        },
        {
            key: "_logLayerParameterExposure",
            value: function _logLayerParameterExposure(parameterName) {
                var _this$_logParameterFu;
                (_this$_logParameterFu = this._logParameterFunction) === null || _this$_logParameterFu === void 0 || _this$_logParameterFu.call(this, this, parameterName);
            }
        }
    ], [
        {
            key: "fromLayer",
            value: function fromLayer(layer) {
                var _layer$__evaluation$s, _layer$__evaluation, _layer$__evaluation$u, _layer$__evaluation2, _layer$__evaluation3, _layer$__evaluation4;
                var value = new Layer(layer.name, layer.__value, layer.ruleID, (0, $5IOvr.migrateEvaluationDetails)(layer.details), function(_layer, parameterName) {
                    return layer.get(parameterName);
                }, (0, $5IOvr.migrateSecondaryExposures)((_layer$__evaluation$s = (_layer$__evaluation = layer.__evaluation) === null || _layer$__evaluation === void 0 ? void 0 : _layer$__evaluation.secondary_exposures) !== null && _layer$__evaluation$s !== void 0 ? _layer$__evaluation$s : []), (0, $5IOvr.migrateSecondaryExposures)((_layer$__evaluation$u = (_layer$__evaluation2 = layer.__evaluation) === null || _layer$__evaluation2 === void 0 ? void 0 : _layer$__evaluation2.undelegated_secondary_exposures) !== null && _layer$__evaluation$u !== void 0 ? _layer$__evaluation$u : []), (_layer$__evaluation3 = layer.__evaluation) === null || _layer$__evaluation3 === void 0 ? void 0 : _layer$__evaluation3.allocated_experiment_name, (_layer$__evaluation4 = layer.__evaluation) === null || _layer$__evaluation4 === void 0 ? void 0 : _layer$__evaluation4.explicit_parameters);
                return value;
            }
        }
    ]);
}();

});

parcelRegister("5lXNt", function(module, exports) {
$parcel$export(module.exports, "default", () => $3e5d4c5e594349f5$export$2e2bcd8739ae039);

var $25nEq = parcelRequire("25nEq");

var $fL8KA = parcelRequire("fL8KA");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $6HG4S = parcelRequire("6HG4S");

var $k9ONe = parcelRequire("k9ONe");

var $2sCeC = parcelRequire("2sCeC");

var $dMgtu = parcelRequire("dMgtu");
function $3e5d4c5e594349f5$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $3e5d4c5e594349f5$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $3e5d4c5e594349f5$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $3e5d4c5e594349f5$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $3e5d4c5e594349f5$var$DEFAULT_REQUEST_TIMEOUT_MS = 5000;
var $3e5d4c5e594349f5$export$250a58ecde616daa = 'https://api.atlassian.com/flags';
var $3e5d4c5e594349f5$export$942ba04389b0d5a2 = 'https://api.stg.atlassian.com/flags';
var $3e5d4c5e594349f5$export$f058dbf75c3bc647 = 'https://api.dev.atlassian.com/flags';
var $3e5d4c5e594349f5$export$1a401a0da8da3565 = 'https://api.stg.atlassian-us-gov-mod.com/flags';
var $3e5d4c5e594349f5$export$18c93900db9358a4 = 'https://api.atlassian-us-gov-mod.com/flags';
var $3e5d4c5e594349f5$export$4e8a0415edbfa1f7 = 'https://atlassian-statsig-proxy-archetype.atl-paas.%s.atl-ic.net';
var $3e5d4c5e594349f5$export$cb3cd156f70d7e94 = 'oasis-stg.com/flags';
var $3e5d4c5e594349f5$export$921fbc6cdfd4eee0 = 'atlassian-isolated.net/flags';
var $3e5d4c5e594349f5$export$450bd8fb2a6d7ace = '/gateway/api/flags';
var $3e5d4c5e594349f5$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function Fetcher() {
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, Fetcher);
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(Fetcher, null, [
        {
            key: "fetchClientSdk",
            value: function() {
                var _fetchClientSdk = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee(fetcherOptions) {
                    var targetApp, url;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee$(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                targetApp = fetcherOptions.targetApp;
                                url = "/api/v2/frontend/clientSdkKey/".concat(targetApp);
                                _context.prev = 2;
                                _context.next = 5;
                                return this.fetchRequest(url, 'GET', fetcherOptions);
                            case 5:
                                return _context.abrupt("return", _context.sent);
                            case 8:
                                _context.prev = 8;
                                _context.t0 = _context["catch"](2);
                                if (!(_context.t0 instanceof Error)) {
                                    _context.next = 12;
                                    break;
                                }
                                throw _context.t0;
                            case 12:
                                throw Error('Failed to retrieve client sdk key');
                            case 13:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee, this, [
                        [
                            2,
                            8
                        ]
                    ]);
                }));
                function fetchClientSdk(_x) {
                    return _fetchClientSdk.apply(this, arguments);
                }
                return fetchClientSdk;
            }()
        },
        {
            key: "fetchExperimentValues",
            value: function() {
                var _fetchExperimentValues = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee2(fetcherOptions, identifiers, customAttributes) {
                    var requestBody;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee2$(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                requestBody = {
                                    identifiers: identifiers,
                                    customAttributes: customAttributes,
                                    targetApp: fetcherOptions.targetApp
                                };
                                _context2.prev = 1;
                                _context2.next = 4;
                                return this.fetchRequest('/api/v2/frontend/experimentValues', 'POST', fetcherOptions, requestBody);
                            case 4:
                                return _context2.abrupt("return", _context2.sent);
                            case 7:
                                _context2.prev = 7;
                                _context2.t0 = _context2["catch"](1);
                                if (!(_context2.t0 instanceof Error)) {
                                    _context2.next = 11;
                                    break;
                                }
                                throw _context2.t0;
                            case 11:
                                throw Error('Failed to retrieve experiment values');
                            case 12:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2, this, [
                        [
                            1,
                            7
                        ]
                    ]);
                }));
                function fetchExperimentValues(_x2, _x3, _x4) {
                    return _fetchExperimentValues.apply(this, arguments);
                }
                return fetchExperimentValues;
            }()
        },
        {
            key: "handleResponseError",
            value: function() {
                var _handleResponseError = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee3(response) {
                    var body;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee3$(_context3) {
                        while(true)switch(_context3.prev = _context3.next){
                            case 0:
                                if (response.ok) {
                                    _context3.next = 5;
                                    break;
                                }
                                _context3.next = 3;
                                return response.text();
                            case 3:
                                body = _context3.sent;
                                throw new (0, $dMgtu.ResponseError)("Non 2xx response status received, status: ".concat(response.status, ", body: ").concat(JSON.stringify(body)));
                            case 5:
                                if (!(response.status === 204)) {
                                    _context3.next = 7;
                                    break;
                                }
                                throw new (0, $dMgtu.ResponseError)('Unexpected 204 response');
                            case 7:
                            case "end":
                                return _context3.stop();
                        }
                    }, _callee3);
                }));
                function handleResponseError(_x5) {
                    return _handleResponseError.apply(this, arguments);
                }
                return handleResponseError;
            }()
        },
        {
            key: "extractResponseBody",
            value: function() {
                var _extractResponseBody = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee4(response) {
                    var value;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee4$(_context4) {
                        while(true)switch(_context4.prev = _context4.next){
                            case 0:
                                _context4.next = 2;
                                return response.text();
                            case 2:
                                value = _context4.sent;
                                return _context4.abrupt("return", JSON.parse(value));
                            case 4:
                            case "end":
                                return _context4.stop();
                        }
                    }, _callee4);
                }));
                function extractResponseBody(_x6) {
                    return _extractResponseBody.apply(this, arguments);
                }
                return extractResponseBody;
            }()
        },
        {
            key: "getBaseUrl",
            value: function getBaseUrl(serviceEnv) {
                var useGatewayUrl = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
                var perimeter = arguments.length > 2 ? arguments[2] : undefined;
                var isolationContextId = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
                if (useGatewayUrl) return $3e5d4c5e594349f5$export$450bd8fb2a6d7ace;
                if (perimeter === (0, $k9ONe.PerimeterType).FEDRAMP_MODERATE) switch(serviceEnv){
                    case (0, $k9ONe.FeatureGateEnvironment).Production:
                        return $3e5d4c5e594349f5$export$18c93900db9358a4;
                    case (0, $k9ONe.FeatureGateEnvironment).Staging:
                        return $3e5d4c5e594349f5$export$1a401a0da8da3565;
                    default:
                        throw new Error("Invalid environment \"".concat(serviceEnv, "\" for \"").concat(perimeter, "\" perimeter"));
                }
                else if (perimeter === (0, $k9ONe.PerimeterType).COMMERCIAL) switch(serviceEnv){
                    case (0, $k9ONe.FeatureGateEnvironment).Development:
                        return $3e5d4c5e594349f5$export$f058dbf75c3bc647;
                    case (0, $k9ONe.FeatureGateEnvironment).Staging:
                        var apiUrl = this.getApiUrl(isolationContextId);
                        if (apiUrl !== null) return apiUrl;
                        return $3e5d4c5e594349f5$export$942ba04389b0d5a2;
                    default:
                        var prodApiUrl = this.getApiUrl(isolationContextId);
                        if (prodApiUrl !== null) return prodApiUrl;
                        return $3e5d4c5e594349f5$export$250a58ecde616daa;
                }
                else throw new Error("Invalid perimeter \"".concat(perimeter, "\""));
            }
        },
        {
            key: "fetchRequest",
            value: function() {
                var _fetchRequest = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee5(path, method, fetcherOptions, body) {
                    var baseUrl, fetchTimeout, abortSignal, abortController, response;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee5$(_context5) {
                        while(true)switch(_context5.prev = _context5.next){
                            case 0:
                                baseUrl = Fetcher.getBaseUrl(fetcherOptions.environment, fetcherOptions.useGatewayURL, fetcherOptions.perimeter, fetcherOptions.isolationContextId);
                                fetchTimeout = fetcherOptions.fetchTimeoutMs || $3e5d4c5e594349f5$var$DEFAULT_REQUEST_TIMEOUT_MS;
                                if (AbortSignal.timeout) abortSignal = AbortSignal.timeout(fetchTimeout);
                                else if (AbortController) {
                                    abortController = new AbortController();
                                    abortSignal = abortController.signal;
                                    setTimeout(function() {
                                        return abortController.abort();
                                    }, fetchTimeout);
                                }
                                _context5.next = 5;
                                return fetch("".concat(baseUrl).concat(path), $3e5d4c5e594349f5$var$_objectSpread({
                                    method: method,
                                    headers: {
                                        'Content-Type': 'application/json',
                                        'X-Client-Name': 'feature-gate-js-client',
                                        'X-Client-Version': (0, $2sCeC.CLIENT_VERSION),
                                        'X-API-KEY': fetcherOptions.apiKey
                                    },
                                    signal: abortSignal
                                }, body && {
                                    body: JSON.stringify(body)
                                }));
                            case 5:
                                response = _context5.sent;
                                _context5.next = 8;
                                return this.handleResponseError(response);
                            case 8:
                                _context5.next = 10;
                                return this.extractResponseBody(response);
                            case 10:
                                return _context5.abrupt("return", _context5.sent);
                            case 11:
                            case "end":
                                return _context5.stop();
                        }
                    }, _callee5, this);
                }));
                function fetchRequest(_x7, _x8, _x9, _x0) {
                    return _fetchRequest.apply(this, arguments);
                }
                return fetchRequest;
            }()
        },
        {
            key: "getApiUrl",
            value: function getApiUrl(isolationContextId) {
                var window1 = this.getWindowLocation();
                if (window1 === undefined) {
                    //this is needed when this SDK is used for SSR or plugin use cases where secret keys not available to use backend SDKs
                    if (!isolationContextId) return null;
                    return $3e5d4c5e594349f5$export$4e8a0415edbfa1f7.replace('%s', isolationContextId);
                }
                var protocol = window1.protocol, hostname = window1.hostname;
                // Match last subdomain fragment before oasis-stg.com
                var oasisMatch = hostname.match(/([^.]+)\.oasis-stg\.com$/);
                if (oasisMatch) return "".concat(protocol, "//api.").concat(oasisMatch[1], ".").concat($3e5d4c5e594349f5$export$cb3cd156f70d7e94);
                // Match last subdomain fragment before atlassian-isolated.net
                var isolatedMatch = hostname.match(/([^.]+)\.atlassian-isolated\.net$/);
                if (isolatedMatch) return "".concat(protocol, "//api.").concat(isolatedMatch[1], ".").concat($3e5d4c5e594349f5$export$921fbc6cdfd4eee0);
                return null;
            }
        },
        {
            key: "getWindowLocation",
            value: function getWindowLocation() {
                if (typeof window !== 'undefined' && window.location) return window.location;
                return undefined;
            }
        }
    ]);
}();

});
parcelRegister("2sCeC", function(module, exports) {
$parcel$export(module.exports, "CLIENT_VERSION", () => $1cabdaec6fe908d5$export$a59f8d67326bd1cb);
/// <reference types="node" />
var $1cabdaec6fe908d5$export$a59f8d67326bd1cb = "0.0.0-development";

});

parcelRegister("dMgtu", function(module, exports) {
$parcel$export(module.exports, "ResponseError", () => $a07c8996147bee60$export$286baf652d0b1206);

var $arMYe = parcelRequire("arMYe");

var $9P61R = parcelRequire("9P61R");

var $kIXpt = parcelRequire("kIXpt");

var $cYPzS = parcelRequire("cYPzS");

var $eyuDe = parcelRequire("eyuDe");

var $c7s0H = parcelRequire("c7s0H");
function $a07c8996147bee60$var$_callSuper(t, o, e) {
    return o = (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(o), (0, (/*@__PURE__*/$parcel$interopDefault($kIXpt)))(t, $a07c8996147bee60$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(t).constructor) : o.apply(t, e));
}
function $a07c8996147bee60$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($a07c8996147bee60$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $a07c8996147bee60$export$286baf652d0b1206 = /*#__PURE__*/ function(_Error) {
    function ResponseError(message) {
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, ResponseError);
        return $a07c8996147bee60$var$_callSuper(this, ResponseError, [
            message
        ]);
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($eyuDe)))(ResponseError, _Error);
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(ResponseError);
}(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($c7s0H)))(Error));

});


parcelRegister("eQpFj", function(module, exports) {
$parcel$export(module.exports, "NoFetchDataAdapter", () => $ace9d49e9e3146af$export$55fffef3474104af);

var $fL8KA = parcelRequire("fL8KA");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $kIXpt = parcelRequire("kIXpt");

var $cYPzS = parcelRequire("cYPzS");

var $lwlXp = parcelRequire("lwlXp");

var $eyuDe = parcelRequire("eyuDe");

var $25nEq = parcelRequire("25nEq");

var $6HG4S = parcelRequire("6HG4S");

var $iFR7a = parcelRequire("iFR7a");
function $ace9d49e9e3146af$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $ace9d49e9e3146af$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $ace9d49e9e3146af$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $ace9d49e9e3146af$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $ace9d49e9e3146af$var$_callSuper(t, o, e) {
    return o = (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(o), (0, (/*@__PURE__*/$parcel$interopDefault($kIXpt)))(t, $ace9d49e9e3146af$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(t).constructor) : o.apply(t, e));
}
function $ace9d49e9e3146af$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($ace9d49e9e3146af$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $ace9d49e9e3146af$var$_superPropGet(t, o, e, r) {
    var p = (0, (/*@__PURE__*/$parcel$interopDefault($lwlXp)))((0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(1 & r ? t.prototype : t), o, e);
    return 2 & r && "function" == typeof p ? function(t) {
        return p.apply(e, t);
    } : p;
}
var $ace9d49e9e3146af$export$55fffef3474104af = /*#__PURE__*/ function(_DataAdapterCore) {
    function NoFetchDataAdapter() {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, NoFetchDataAdapter);
        _this = $ace9d49e9e3146af$var$_callSuper(this, NoFetchDataAdapter, [
            'NoFetchDataAdapter',
            'nofetch'
        ]);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "bootstrapResult", null);
        return _this;
    }
    /**
   * Make sure to call this **before** calling `initializeAsync` or `updateUserAsync` but
   * after the Statsig client has been created!
   */ (0, (/*@__PURE__*/$parcel$interopDefault($eyuDe)))(NoFetchDataAdapter, _DataAdapterCore);
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(NoFetchDataAdapter, [
        {
            key: "setBootstrapData",
            value: function setBootstrapData(data) {
                this.bootstrapResult = data ? {
                    source: 'Bootstrap',
                    data: JSON.stringify(data),
                    receivedAt: Date.now(),
                    stableID: (0, $iFR7a.StableID).get(this._getSdkKey()),
                    fullUserHash: null
                } : null;
            }
        },
        {
            key: "prefetchData",
            value: function() {
                var _prefetchData = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee(_user, _options) {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee$(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee);
                }));
                function prefetchData(_x, _x2) {
                    return _prefetchData.apply(this, arguments);
                }
                return prefetchData;
            }()
        },
        {
            key: "getDataAsync",
            value: function() {
                var _getDataAsync = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee2(_current, user, _options) {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee2$(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                return _context2.abrupt("return", this.bootstrapResult && $ace9d49e9e3146af$var$_objectSpread($ace9d49e9e3146af$var$_objectSpread({}, this.bootstrapResult), {}, {
                                    fullUserHash: (0, $iFR7a._getFullUserHash)(user)
                                }));
                            case 1:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2, this);
                }));
                function getDataAsync(_x3, _x4, _x5) {
                    return _getDataAsync.apply(this, arguments);
                }
                return getDataAsync;
            }()
        },
        {
            key: "getDataSync",
            value: function getDataSync(user) {
                return this.bootstrapResult && $ace9d49e9e3146af$var$_objectSpread($ace9d49e9e3146af$var$_objectSpread({}, this.bootstrapResult), {}, {
                    fullUserHash: (0, $iFR7a._getFullUserHash)(user)
                });
            }
        },
        {
            key: "_fetchFromNetwork",
            value: function() {
                var _fetchFromNetwork2 = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee3(_current, _user, _options) {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee3$(_context3) {
                        while(true)switch(_context3.prev = _context3.next){
                            case 0:
                                return _context3.abrupt("return", null);
                            case 1:
                            case "end":
                                return _context3.stop();
                        }
                    }, _callee3);
                }));
                function _fetchFromNetwork(_x6, _x7, _x8) {
                    return _fetchFromNetwork2.apply(this, arguments);
                }
                return _fetchFromNetwork;
            }()
        },
        {
            key: "_getCacheKey",
            value: function _getCacheKey(user) {
                // Same logic as default data adapter
                // https://github.com/statsig-io/js-client-monorepo/blob/main/packages/js-client/src/StatsigEvaluationsDataAdapter.ts
                var key = (0, $iFR7a._getStorageKey)(this._getSdkKey(), user);
                return "".concat((0, $iFR7a.DataAdapterCachePrefix), ".").concat(this._cacheSuffix, ".").concat(key);
            }
        },
        {
            key: "_isCachedResultValidFor204",
            value: function _isCachedResultValidFor204(_result, _user) {
                return false;
            }
        },
        {
            key: "setDataLegacy",
            value: function setDataLegacy(data, user) {
                $ace9d49e9e3146af$var$_superPropGet(NoFetchDataAdapter, "setData", this, 3)([
                    data,
                    user
                ]);
            }
        },
        {
            key: "toJSON",
            value: function toJSON() {
                var result = $ace9d49e9e3146af$var$_objectSpread({}, this);
                delete result._options;
                delete result._inMemoryCache;
                delete result.bootstrapResult;
                return result;
            }
        }
    ]);
}((0, $iFR7a.DataAdapterCore));

});

parcelRegister("jbC54", function(module, exports) {
$parcel$export(module.exports, "LOCAL_STORAGE_KEY", () => $df7c9578dd3b213e$export$d8474cff104280f3);
$parcel$export(module.exports, "PersistentOverrideAdapter", () => $df7c9578dd3b213e$export$bcb28fbac1def494);

var $25nEq = parcelRequire("25nEq");

var $iYJcE = parcelRequire("iYJcE");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $dtn6l = parcelRequire("dtn6l");
function $df7c9578dd3b213e$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $df7c9578dd3b213e$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $df7c9578dd3b213e$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $df7c9578dd3b213e$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $df7c9578dd3b213e$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $df7c9578dd3b213e$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $df7c9578dd3b213e$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $df7c9578dd3b213e$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $df7c9578dd3b213e$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $df7c9578dd3b213e$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
var $df7c9578dd3b213e$var$LOCAL_OVERRIDE_REASON = 'LocalOverride:Recognized';
var $df7c9578dd3b213e$export$d8474cff104280f3 = 'STATSIG_OVERRIDES';
var $df7c9578dd3b213e$var$LEGACY_LOCAL_STORAGE_KEY = 'STATSIG_JS_LITE_LOCAL_OVERRIDES';
var $df7c9578dd3b213e$var$makeEmptyStore = function makeEmptyStore() {
    return {
        gates: {},
        configs: {},
        layers: {}
    };
};
var $df7c9578dd3b213e$var$djb2MapKey = function djb2MapKey(hash, kind) {
    return kind + ':' + hash;
};
var $df7c9578dd3b213e$export$bcb28fbac1def494 = /*#__PURE__*/ function() {
    function PersistentOverrideAdapter(localStorageKey) {
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, PersistentOverrideAdapter);
        this._overrides = $df7c9578dd3b213e$var$makeEmptyStore();
        this._djb2Map = new Map();
        this._localStorageKey = localStorageKey;
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(PersistentOverrideAdapter, [
        {
            key: "parseStoredOverrides",
            value: function parseStoredOverrides(localStorageKey) {
                try {
                    var json = window.localStorage.getItem(localStorageKey);
                    if (!json) return $df7c9578dd3b213e$var$makeEmptyStore();
                    return JSON.parse(json);
                } catch (_unused) {
                    return $df7c9578dd3b213e$var$makeEmptyStore();
                }
            }
        },
        {
            key: "mergeOverrides",
            value: function mergeOverrides() {
                var merged = $df7c9578dd3b213e$var$makeEmptyStore();
                for(var _len = arguments.length, allOverrides = new Array(_len), _key = 0; _key < _len; _key++)allOverrides[_key] = arguments[_key];
                for(var _i = 0, _allOverrides = allOverrides; _i < _allOverrides.length; _i++){
                    var overrides = _allOverrides[_i];
                    for(var _i2 = 0, _Object$entries = Object.entries((_overrides$gates = overrides.gates) !== null && _overrides$gates !== void 0 ? _overrides$gates : {}); _i2 < _Object$entries.length; _i2++){
                        var _overrides$gates;
                        var _Object$entries$_i = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_Object$entries[_i2], 2), name = _Object$entries$_i[0], value = _Object$entries$_i[1];
                        merged.gates[name] = value;
                    }
                    for(var _i3 = 0, _Object$entries2 = Object.entries((_overrides$configs = overrides.configs) !== null && _overrides$configs !== void 0 ? _overrides$configs : {}); _i3 < _Object$entries2.length; _i3++){
                        var _overrides$configs;
                        var _Object$entries2$_i = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_Object$entries2[_i3], 2), _name = _Object$entries2$_i[0], _value = _Object$entries2$_i[1];
                        merged.configs[_name] = _value;
                    }
                    for(var _i4 = 0, _Object$entries3 = Object.entries((_overrides$layers = overrides.layers) !== null && _overrides$layers !== void 0 ? _overrides$layers : {}); _i4 < _Object$entries3.length; _i4++){
                        var _overrides$layers;
                        var _Object$entries3$_i = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_Object$entries3[_i4], 2), _name2 = _Object$entries3$_i[0], _value2 = _Object$entries3$_i[1];
                        merged.layers[_name2] = _value2;
                    }
                }
                return merged;
            }
        },
        {
            key: "initFromStoredOverrides",
            value: function initFromStoredOverrides() {
                var storedOverrides = this.mergeOverrides(this._overrides, this.parseStoredOverrides($df7c9578dd3b213e$var$LEGACY_LOCAL_STORAGE_KEY), this.parseStoredOverrides(this._localStorageKey));
                // Clear data from legacy local storage key now we've read from it.
                // This prevents things being stuck in there that are always read but never written to.
                try {
                    window.localStorage.removeItem($df7c9578dd3b213e$var$LEGACY_LOCAL_STORAGE_KEY);
                } catch (_unused2) {
                // ignored - window is not defined in non-browser environments, and we don't save things there
                // (things like SSR, etc)
                }
                // In version 4.24.0 we introduced hashes in this override adapter, but had a bug which would cause
                // multiple hashes to continue being created. This code here removes these hashes since we've moved
                // to using a more reliable and easier to maintain map in `_djb2Map`.
                for(var _i5 = 0, _Object$values = Object.values(storedOverrides); _i5 < _Object$values.length; _i5++){
                    var container = _Object$values[_i5];
                    var allKeys = new Set(Object.keys(container));
                    var _iterator = $df7c9578dd3b213e$var$_createForOfIteratorHelper(allKeys), _step;
                    try {
                        for(_iterator.s(); !(_step = _iterator.n()).done;){
                            var name = _step.value;
                            var hash = (0, $dtn6l._DJB2)(name);
                            if (allKeys.has(hash)) delete container[hash];
                        }
                    } catch (err) {
                        _iterator.e(err);
                    } finally{
                        _iterator.f();
                    }
                }
                this.applyOverrides(storedOverrides);
            }
        },
        {
            key: "saveOverrides",
            value: function saveOverrides() {
                try {
                    window.localStorage.setItem(this._localStorageKey, JSON.stringify(this._overrides));
                } catch (_unused3) {
                // ignored - window is not defined in non-browser environments, and we don't save things there
                // (things like SSR, etc)
                }
            }
        },
        {
            key: "getOverrides",
            value: function getOverrides() {
                return this.mergeOverrides(this._overrides);
            }
        },
        {
            key: "applyOverrides",
            value: function applyOverrides(overrides) {
                var newOverrides = $df7c9578dd3b213e$var$_objectSpread($df7c9578dd3b213e$var$_objectSpread({}, $df7c9578dd3b213e$var$makeEmptyStore()), overrides);
                this._djb2Map.clear();
                for(var _i6 = 0, _Object$entries4 = Object.entries(newOverrides); _i6 < _Object$entries4.length; _i6++){
                    var _Object$entries4$_i = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_Object$entries4[_i6], 2), containerName = _Object$entries4$_i[0], container = _Object$entries4$_i[1];
                    for(var _i7 = 0, _Object$entries5 = Object.entries(container); _i7 < _Object$entries5.length; _i7++){
                        var _Object$entries5$_i = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_Object$entries5[_i7], 2), name = _Object$entries5$_i[0], value = _Object$entries5$_i[1];
                        this._djb2Map.set($df7c9578dd3b213e$var$djb2MapKey((0, $dtn6l._DJB2)(name), containerName), value);
                    }
                }
                this._overrides = newOverrides;
            }
        },
        {
            key: "setOverrides",
            value: function setOverrides(overrides) {
                this.applyOverrides(overrides);
                this.saveOverrides();
            }
        },
        {
            key: "overrideGate",
            value: function overrideGate(name, value) {
                this._overrides.gates[name] = value;
                this._djb2Map.set($df7c9578dd3b213e$var$djb2MapKey((0, $dtn6l._DJB2)(name), 'gates'), value);
                this.saveOverrides();
            }
        },
        {
            key: "removeGateOverride",
            value: function removeGateOverride(name) {
                delete this._overrides.gates[name];
                this._djb2Map.delete($df7c9578dd3b213e$var$djb2MapKey((0, $dtn6l._DJB2)(name), 'gates'));
                this.saveOverrides();
            }
        },
        {
            key: "getGateOverride",
            value: function getGateOverride(current, _user) {
                var _this$_overrides$gate;
                var overridden = (_this$_overrides$gate = this._overrides.gates[current.name]) !== null && _this$_overrides$gate !== void 0 ? _this$_overrides$gate : this._djb2Map.get($df7c9578dd3b213e$var$djb2MapKey(current.name, 'gates'));
                if (overridden == null) return null;
                return $df7c9578dd3b213e$var$_objectSpread($df7c9578dd3b213e$var$_objectSpread({}, current), {}, {
                    value: overridden,
                    details: $df7c9578dd3b213e$var$_objectSpread($df7c9578dd3b213e$var$_objectSpread({}, current.details), {}, {
                        reason: $df7c9578dd3b213e$var$LOCAL_OVERRIDE_REASON
                    })
                });
            }
        },
        {
            key: "overrideDynamicConfig",
            value: function overrideDynamicConfig(name, value) {
                this._overrides.configs[name] = value;
                this._djb2Map.set($df7c9578dd3b213e$var$djb2MapKey((0, $dtn6l._DJB2)(name), 'configs'), value);
                this.saveOverrides();
            }
        },
        {
            key: "removeDynamicConfigOverride",
            value: function removeDynamicConfigOverride(name) {
                delete this._overrides.configs[name];
                this._djb2Map.delete($df7c9578dd3b213e$var$djb2MapKey((0, $dtn6l._DJB2)(name), 'configs'));
                this.saveOverrides();
            }
        },
        {
            key: "getDynamicConfigOverride",
            value: function getDynamicConfigOverride(current, _user) {
                return this._getConfigOverride(current, this._overrides.configs);
            }
        },
        {
            key: "overrideExperiment",
            value: function overrideExperiment(name, value) {
                this._overrides.configs[name] = value;
                this._djb2Map.set($df7c9578dd3b213e$var$djb2MapKey((0, $dtn6l._DJB2)(name), 'configs'), value);
                this.saveOverrides();
            }
        },
        {
            key: "removeExperimentOverride",
            value: function removeExperimentOverride(name) {
                delete this._overrides.configs[name];
                this._djb2Map.delete($df7c9578dd3b213e$var$djb2MapKey((0, $dtn6l._DJB2)(name), 'configs'));
                this.saveOverrides();
            }
        },
        {
            key: "getExperimentOverride",
            value: function getExperimentOverride(current, _user) {
                return this._getConfigOverride(current, this._overrides.configs);
            }
        },
        {
            key: "overrideLayer",
            value: function overrideLayer(name, value) {
                this._overrides.layers[name] = value;
                this._djb2Map.set($df7c9578dd3b213e$var$djb2MapKey((0, $dtn6l._DJB2)(name), 'layers'), value);
                this.saveOverrides();
            }
        },
        {
            key: "removeLayerOverride",
            value: function removeLayerOverride(name) {
                delete this._overrides.layers[name];
                this._djb2Map.delete($df7c9578dd3b213e$var$djb2MapKey((0, $dtn6l._DJB2)(name), 'layers'));
                this.saveOverrides();
            }
        },
        {
            key: "removeAllOverrides",
            value: function removeAllOverrides() {
                this._overrides = $df7c9578dd3b213e$var$makeEmptyStore();
                try {
                    window.localStorage.removeItem(this._localStorageKey);
                } catch (_unused4) {
                // ignored - window is not defined in non-browser environments, and we don't save things there
                // (things like SSR, etc)
                }
            }
        },
        {
            key: "getLayerOverride",
            value: function getLayerOverride(current, _user) {
                var _this$_overrides$laye;
                var overridden = (_this$_overrides$laye = this._overrides.layers[current.name]) !== null && _this$_overrides$laye !== void 0 ? _this$_overrides$laye : this._djb2Map.get($df7c9578dd3b213e$var$djb2MapKey(current.name, 'layers'));
                if (overridden == null) return null;
                return $df7c9578dd3b213e$var$_objectSpread($df7c9578dd3b213e$var$_objectSpread({}, current), {}, {
                    __value: overridden,
                    get: (0, $dtn6l._makeTypedGet)(current.name, overridden),
                    details: $df7c9578dd3b213e$var$_objectSpread($df7c9578dd3b213e$var$_objectSpread({}, current.details), {}, {
                        reason: $df7c9578dd3b213e$var$LOCAL_OVERRIDE_REASON
                    })
                });
            }
        },
        {
            key: "_getConfigOverride",
            value: function _getConfigOverride(current, lookup) {
                var _lookup$current$name;
                var overridden = (_lookup$current$name = lookup[current.name]) !== null && _lookup$current$name !== void 0 ? _lookup$current$name : this._djb2Map.get($df7c9578dd3b213e$var$djb2MapKey(current.name, 'configs'));
                if (overridden == null) return null;
                return $df7c9578dd3b213e$var$_objectSpread($df7c9578dd3b213e$var$_objectSpread({}, current), {}, {
                    value: overridden,
                    get: (0, $dtn6l._makeTypedGet)(current.name, overridden),
                    details: $df7c9578dd3b213e$var$_objectSpread($df7c9578dd3b213e$var$_objectSpread({}, current.details), {}, {
                        reason: $df7c9578dd3b213e$var$LOCAL_OVERRIDE_REASON
                    })
                });
            }
        }
    ]);
}();

});



parcelRegister("9L6oc", function(module, exports) {
$parcel$export(module.exports, "_overrides", () => $71ad75a3bf7acb5a$export$e5d73bf4f8e2ae96);
$parcel$export(module.exports, "_paramOverrides", () => $71ad75a3bf7acb5a$export$4e849416bb5c5b52);
$parcel$export(module.exports, "_product", () => $71ad75a3bf7acb5a$export$cf7305fc65acbf0d);

var $25nEq = parcelRequire("25nEq");

var $iYJcE = parcelRequire("iYJcE");

var $jFnpM = parcelRequire("jFnpM");

var $1Zmoq = parcelRequire("1Zmoq");
function $71ad75a3bf7acb5a$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $71ad75a3bf7acb5a$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $71ad75a3bf7acb5a$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $71ad75a3bf7acb5a$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $71ad75a3bf7acb5a$export$e5d73bf4f8e2ae96 = {};
var $71ad75a3bf7acb5a$export$4e849416bb5c5b52 = {};
var $71ad75a3bf7acb5a$export$cf7305fc65acbf0d;
function $71ad75a3bf7acb5a$export$1c2b6dbf79eb3560(product, /**
 * Overrides are used to set the group of an experiment for testing purposes.
 * This is useful when you want to test a specific experiment group.
 */ groupOverrides, /**
 * Param overrides are used to set the experiment parameters for testing purposes.
 * This is useful when you want to tweak the experiment parameters for testing.
 */ paramOverrides, options) {
    if (groupOverrides) {
        // When setting up overrides, we want to ensure that experiments don't end up with invalid
        // values.
        // For production usage -- this is done via the feature flag client which takes the type
        // and performs equivalent logic.
        // @ts-ignore
        groupOverrides = Object.entries(groupOverrides).reduce(function(acc, _ref) {
            var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_ref, 2), key = _ref2[0], value = _ref2[1];
            var config = (0, $jFnpM.editorExperimentsConfig)[key];
            if (config) acc = $71ad75a3bf7acb5a$var$_objectSpread($71ad75a3bf7acb5a$var$_objectSpread({}, acc), {}, (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, key, config.typeGuard(value) ? value : config.defaultValue));
            return acc;
        }, {});
        $71ad75a3bf7acb5a$export$e5d73bf4f8e2ae96 = groupOverrides;
    }
    if (product === 'test' && !(options !== null && options !== void 0 && options.disableTestOverrides)) {
        // Enforce expectation - file overrides, then global overrides, then default to true for boolean
        // experiments, then last result use the default value
        var testOverrides = Object.fromEntries(Object.entries((0, $jFnpM.editorExperimentsConfig)).map(function(_ref3) {
            var _ref5, _ref6, _groupOverrides, _groupOverrides2;
            var _ref4 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_ref3, 2), key = _ref4[0], value = _ref4[1];
            var defaultValue = typeof value.defaultValue === 'boolean' ? true : value.defaultValue;
            return [
                key,
                (_ref5 = (_ref6 = (_groupOverrides = (_groupOverrides2 = groupOverrides) === null || _groupOverrides2 === void 0 ? void 0 : _groupOverrides2[key]) !== null && _groupOverrides !== void 0 ? _groupOverrides : (0, $1Zmoq.testMultivariateOverrides)[key]) !== null && _ref6 !== void 0 ? _ref6 : (0, $1Zmoq.testBooleanOverrides)[key]) !== null && _ref5 !== void 0 ? _ref5 : defaultValue
            ];
        }));
        $71ad75a3bf7acb5a$export$e5d73bf4f8e2ae96 = testOverrides;
    }
    $71ad75a3bf7acb5a$export$cf7305fc65acbf0d = product;
    $71ad75a3bf7acb5a$export$4e849416bb5c5b52 = paramOverrides || {};
}

});
parcelRegister("jFnpM", function(module, exports) {
$parcel$export(module.exports, "editorExperimentsConfig", () => $e51402548fc880a3$export$6cbb856f286b07ef);
/* eslint-disable perfectionist/sort-object-types */ /* eslint-disable @atlaskit/editor/no-re-export */ // Entry file in package.json

var $bvAQG = parcelRequire("bvAQG");
var $e51402548fc880a3$export$6cbb856f286b07ef = {
    // new format to avoid collisions with other users when updating the file
    // Editor Platform experiments
    // lwoollard experiments
    // Added 02-12-2025
    cc_fix_hydration_ttvc: (0, $bvAQG.createBooleanExperiment)({
        productKeys: {
            confluence: 'cc_fix_hydration_ttvc'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 03-09-2025
    cc_editor_limited_mode_include_lcm: (0, $bvAQG.createBooleanExperiment)({
        productKeys: {
            confluence: 'cc_editor_limited_mode_include_lcm'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 03-09-2025
    cc_editor_interactivity_monitoring: (0, $bvAQG.createBooleanExperiment)({
        productKeys: {
            confluence: 'cc_editor_interactivity_monitoring'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-11-03
    editor_tinymce_full_width_mode: (0, $bvAQG.createBooleanExperiment)({
        productKeys: {
            confluence: 'editor_tinymce_full_width_mode'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    cc_editor_insm_doc_size_stats: (0, $bvAQG.createBooleanExperiment)({
        productKeys: {
            confluence: 'cc_editor_insm_doc_size_stats'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-09-30
    cc_editor_insm_outlier_events: (0, $bvAQG.createMultivariateExperiment)({
        productKeys: {
            confluence: 'cc_editor_insm_outlier_events'
        },
        param: 'cohort',
        values: [
            'control',
            'test'
        ],
        defaultValue: 'control'
    }),
    // Added 2025-11-17
    platform_editor_renderer_extension_width_fix: (0, $bvAQG.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_renderer_extension_width_fix'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-09-30
    // variant 1: remove table overflow shadows completely, no table border shown when scrolling.
    // variant 2: remove table overflow shadows, show table border when scrolling.
    // variant 3: replace table overflow shadows with CSS-only solution.
    platform_editor_disable_table_overflow_shadows: (0, $bvAQG.createMultivariateExperiment)({
        productKeys: {
            confluence: 'platform_editor_disable_table_overflow_shadows'
        },
        param: 'cohort',
        values: [
            'control',
            'variant1',
            'variant2',
            'variant3'
        ],
        defaultValue: 'control'
    }),
    // Added 2025-11-26
    platform_editor_resizer_styles_cleanup: (0, $bvAQG.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_resizer_styles_cleanup'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-11-12
    platform_editor_media_vc_fixes: (0, $bvAQG.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_media_vc_fixes'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-11-20
    platform_editor_annotations_sync_on_docchange: (0, $bvAQG.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_annotations_sync_on_docchange'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-05-27
    platform_editor_reduce_noisy_steps_ncs: (0, $bvAQG.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_reduce_noisy_steps_ncs'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-07-24
    editor_prevent_numbered_column_too_big_jira_1: (0, $bvAQG.createBooleanExperiment)({
        productKeys: {
            jira: 'editor_prevent_numbered_column_too_big_jira_1'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-06-02
    platform_editor_block_control_optimise_render: (0, $bvAQG.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_block_control_optimise_render'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2024-08-08
    'example-boolean': (0, $bvAQG.createBooleanExperiment)({
        productKeys: {
            confluence: 'confluence_editor_experiment_test_new_package_boolean'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2024-08-08
    'example-multivariate': (0, $bvAQG.createMultivariateExperiment)({
        productKeys: {
            confluence: 'confluence_editor_experiment_test_new_package_multivariate'
        },
        param: 'variant',
        values: [
            'one',
            'two',
            'three'
        ],
        defaultValue: 'one'
    }),
    // Added 2024-08-08
    'test-new-experiments-package': (0, $bvAQG.createBooleanExperiment)({
        productKeys: {
            confluence: 'confluence_editor_experiment_test_new_package',
            jira: 'jira_editor_experiment_test_new_package'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    platform_editor_table_drag_handle_hover: (0, $bvAQG.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_table_drag_handle_hover',
            jira: 'platform_editor_table_drag_handle_hover'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2024-09-05
    support_table_in_comment: (0, $bvAQG.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_support_table_in_comment_exp'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2024-09-07
    platform_editor_exp_lazy_node_views: (0, $bvAQG.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_exp_lazy_node_views'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2024-09-18
    platform_renderer_table_sticky_scrollbar: (0, $bvAQG.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_renderer_table_sticky_scrollbar'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-11-20
    'company-hub-config-panel-keyboard-nav': (0, $bvAQG.createBooleanExperiment)({
        productKeys: {
            confluence: 'company-hub-config-panel-keyboard-nav'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-10-10
    platform_editor_experience_tracking: (0, $bvAQG.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_experience_tracking'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-05-26
    platform_editor_prevent_toolbar_layout_shifts: (0, $bvAQG.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_prevent_toolbar_layout_shifts'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2024-10-01
    comment_on_bodied_extensions: (0, $bvAQG.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_comment_on_bodied_extensions'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2024-10-14
    // https://console.statsig.com/LqivKg6ADZZaGczRfBKfX/experiments/platform_editor_advanced_layouts/setup
    advanced_layouts: (0, $bvAQG.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_advanced_layouts'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-3-15
    // https://console.statsig.com/LqivKg6ADZZaGczRfBKfX/experiments/platform_editor_single_column_layout/setup
    single_column_layouts: (0, $bvAQG.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_single_column_layout'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2024-10-08
    support_table_in_comment_jira: (0, $bvAQG.createBooleanExperiment)({
        productKeys: {
            jira: 'platform_editor_support_table_in_comment_jira'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    'platform_editor_ai-prompts-placeholder': (0, $bvAQG.createMultivariateExperiment)({
        productKeys: {
            confluence: 'platform_editor_ai-prompts-placeholder'
        },
        param: 'cohort',
        values: [
            'control',
            'test'
        ],
        defaultValue: 'control'
    }),
    // added 2024-11-06
    // https://console.statsig.com/LqivKg6ADZZaGczRfBKfX/experiments/platform_editor_nested_tables/setup
    'nested-tables-in-tables': (0, $bvAQG.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_nested_tables'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2024-11-26
    platform_editor_ai_unsplash_page_header: (0, $bvAQG.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_ai_unsplash_page_header'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2024-12-05
    platform_editor_blockquote_in_text_formatting_menu: (0, $bvAQG.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_blockquote_in_text_formatting_menu'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-01-13
    platform_editor_element_drag_and_drop_multiselect: (0, $bvAQG.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_element_drag_and_drop_multiselect'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-01-19
    platform_editor_ai_edit_response_in_preview: (0, $bvAQG.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_ai_edit_response_in_preview'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-02-10
    platform_editor_controls: (0, $bvAQG.createMultivariateExperiment)({
        productKeys: {
            confluence: 'platform_editor_controls'
        },
        param: 'cohort',
        values: [
            'control',
            'variant1'
        ],
        defaultValue: 'control'
    }),
    // Added 2025-08-01
    platform_editor_controls_block_controls_state_fix: (0, $bvAQG.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_controls_block_controls_state_fix'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-09-03
    platform_editor_hydratable_ui: (0, $bvAQG.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_hydratable_ui'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-03-28
    platform_editor_ai_proactive_ai_nudge_parameters: (0, $bvAQG.createMultivariateExperiment)({
        productKeys: {
            confluence: 'platform_editor_ai_proactive_ai_nudge_parameters'
        },
        param: 'cohort',
        values: [
            'control',
            'variant1'
        ],
        defaultValue: 'control'
    }),
    // Added 2025-04-14
    // https://switcheroo.atlassian.com/ui/gates/b159b45a-86d9-4f4b-b482-f9aca5b615d6/key/platform_editor_offline_editing_web
    platform_editor_offline_editing_web: (0, $bvAQG.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_offline_editing_web'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-10-15
    platform_editor_no_ssr: (0, $bvAQG.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_no_ssr'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-10-31
    platform_editor_lovability_suppress_toolbar_event: (0, $bvAQG.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_lovability_suppress_toolbar_event',
            jira: 'platform_editor_lovability_suppress_toolbar_event'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-04-17
    platform_editor_tables_drag_and_drop: (0, $bvAQG.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_tables_drag_and_drop'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-04-17
    platform_editor_tables_table_selector: (0, $bvAQG.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_tables_table_selector'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-04-23
    platform_editor_usesharedpluginstateselector: (0, $bvAQG.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_usesharedpluginstateselector'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-04-23
    platform_renderer_fix_analytics_memo_callback: (0, $bvAQG.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_renderer_fix_analytics_memo_callback'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-05-26
    platform_editor_stop_width_reflows: (0, $bvAQG.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_stop_width_reflows'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-12-01
    platform_editor_no_state_plugin_injection_api: (0, $bvAQG.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_no_state_plugin_injection_api'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-06-10
    platform_editor_no_cursor_on_edit_page_init: (0, $bvAQG.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_no_cursor_on_edit_page_init'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-07-14
    platform_editor_debounce_portal_provider: (0, $bvAQG.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_debounce_portal_provider'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-08-14
    platform_editor_jira_advanced_code_blocks: (0, $bvAQG.createBooleanExperiment)({
        productKeys: {
            jira: 'platform_editor_jira_advanced_code_blocks'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-07-08 - Jira work sync description comment summary
    'jira-work-sync-desc-comment-summary': (0, $bvAQG.createBooleanExperiment)({
        productKeys: {
            jira: 'jira-work-sync-desc-comment-summary'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-05-15
    platform_editor_breakout_resizing: (0, $bvAQG.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_breakout_resizing'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-05-07
    platform_editor_ai_quickstart_command: (0, $bvAQG.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_ai_quickstart_command'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-06-05
    platform_editor_block_controls_perf_optimization: (0, $bvAQG.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_block_controls_perf_optimization'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-06-16
    platform_editor_enable_single_player_step_merging: (0, $bvAQG.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_enable_single_player_step_merging'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-07-02
    platform_editor_code_block_fold_gutter: (0, $bvAQG.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_code_block_fold_gutter'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-06-18
    platform_editor_ai_iw_adf_streaming: (0, $bvAQG.createMultivariateExperiment)({
        productKeys: {
            confluence: 'platform_editor_ai_iw_adf_streaming'
        },
        param: 'cohort',
        values: [
            'control',
            'adf_gemini25flash',
            'adf_gpt41mini'
        ],
        defaultValue: 'control'
    }),
    // Added 2025-08-20
    platform_editor_ai_non_iw_adf_streaming: (0, $bvAQG.createMultivariateExperiment)({
        productKeys: {
            confluence: 'platform_editor_ai_non_iw_adf_streaming'
        },
        param: 'cohort',
        values: [
            'control',
            'adf_gemini25flash',
            'adf_gpt41mini'
        ],
        defaultValue: 'control'
    }),
    //Added 2025-07-25
    platform_editor_extension_styles: (0, $bvAQG.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_extension_styles'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-06-20
    confluence_whiteboards_quick_insert_aa: (0, $bvAQG.createMultivariateExperiment)({
        productKeys: {
            confluence: 'confluence_whiteboards_quick_insert_aa'
        },
        param: 'cohort',
        values: [
            'control',
            'test_blank',
            'test_diagram'
        ],
        defaultValue: 'control'
    }),
    // Added 2025-06-24
    platform_editor_find_and_replace_improvements: (0, $bvAQG.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_find_and_replace_improvements'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-06-24
    confluence_whiteboards_quick_insert: (0, $bvAQG.createMultivariateExperiment)({
        productKeys: {
            confluence: 'confluence_whiteboards_quick_insert'
        },
        param: 'cohort',
        values: [
            'control',
            'test_blank',
            'test_diagram'
        ],
        defaultValue: 'control'
    }),
    // Added 2025-06-26
    platform_editor_feedback_mandatory_rating: (0, $bvAQG.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_feedback_mandatory_rating'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-07-30
    platform_editor_drag_handle_aria_label: (0, $bvAQG.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_drag_handle_aria_label'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-07-07
    platform_editor_toggle_expand_on_match_found: (0, $bvAQG.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_toggle_expand_on_match_found'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    platform_editor_smart_card_otp: (0, $bvAQG.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_smart_card_otp'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-07-15
    platform_editor_preview_panel_responsiveness: (0, $bvAQG.createBooleanExperiment)({
        productKeys: {
            confluence: 'confluence_preview_panels_exp'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-08-18
    platform_editor_preview_panel_linking_exp: (0, $bvAQG.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_preview_panel_linking_exp_conf',
            jira: 'platform_editor_preview_panel_linking_exp_jira'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-10-10
    platform_editor_hoverlink_ui_fixes_exp: (0, $bvAQG.createMultivariateExperiment)({
        productKeys: {
            confluence: 'platform_editor_hoverlink_ui_fixes_exp'
        },
        param: 'cohort',
        values: [
            'control',
            'css_changes_only',
            'css_js_changes'
        ],
        defaultValue: 'control'
    }),
    // Added 2025-08-17
    platform_hover_card_preview_panel: (0, $bvAQG.createMultivariateExperiment)({
        productKeys: {
            confluence: 'platform_hover_card_preview_panel',
            jira: 'platform_hover_card_preview_panel'
        },
        param: 'cohort',
        values: [
            'control',
            'test'
        ],
        defaultValue: 'control'
    }),
    // Added 2025-09-17
    platform_hover_card_preview_panel_modal: (0, $bvAQG.createMultivariateExperiment)({
        productKeys: {
            confluence: 'platform_hover_card_preview_panel_modal',
            jira: 'platform_hover_card_preview_panel_modal'
        },
        param: 'cohort',
        values: [
            'control',
            'test'
        ],
        defaultValue: 'control'
    }),
    // Added 2025-11-25
    smart_link_confluence_short_link_analytics: (0, $bvAQG.createMultivariateExperiment)({
        productKeys: {
            confluence: 'smart-link-confluence-short-link-analytics',
            jira: 'smart-link-confluence-short-link-analytics'
        },
        param: 'cohort',
        values: [
            'control',
            'test'
        ],
        defaultValue: 'control'
    }),
    // Added 2025--8-05
    platform_editor_block_menu: (0, $bvAQG.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_block_menu'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-09-16
    platform_editor_emoji_otp: (0, $bvAQG.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_emoji_otp'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-07-23
    platform_editor_renderer_breakout_fix: (0, $bvAQG.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_renderer_breakout_fix'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-07-24
    editor_enghealth_hyperlink_toolbar_aria_values: (0, $bvAQG.createBooleanExperiment)({
        productKeys: {
            confluence: 'editor_enghealth_hyperlink_toolbar_aria_values'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-07-14
    platform_editor_add_orange_highlight_color: (0, $bvAQG.createMultivariateExperiment)({
        productKeys: {
            confluence: 'platform_editor_add_orange_highlight_color'
        },
        param: 'cohort',
        values: [
            'control',
            'test'
        ],
        defaultValue: 'control'
    }),
    //Added 2025-07-16
    platform_editor_toolbar_aifc: (0, $bvAQG.createBooleanExperiment)({
        productKeys: {
            jira: 'platform_editor_toolbar_aifc_jira',
            confluence: 'platform_editor_toolbar_aifc_confluence'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-09-04
    editor_refactor_backspace_task_and_decisions: (0, $bvAQG.createBooleanExperiment)({
        productKeys: {
            confluence: 'editor_refactor_backspace_task_and_decisions'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    //Added 2025-07-16
    platform_editor_toolbar_aifc_patch_3: (0, $bvAQG.createBooleanExperiment)({
        productKeys: {
            jira: 'platform_editor_toolbar_aifc_patch_3',
            confluence: 'platform_editor_toolbar_aifc_patch_3'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    //Added 2025-09-09
    platform_editor_toolbar_aifc_patch_4: (0, $bvAQG.createBooleanExperiment)({
        productKeys: {
            jira: 'platform_editor_toolbar_aifc_patch_4',
            confluence: 'platform_editor_toolbar_aifc_patch_4'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-09-29
    platform_editor_toolbar_aifc_selection_extension: (0, $bvAQG.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_toolbar_aifc_selection_extension',
            jira: 'platform_editor_toolbar_aifc_selection_extension'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-08-04
    platform_editor_floating_toolbar_button_aria_label: (0, $bvAQG.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_floating_toolbar_button_aria_label'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-07-24
    platform_editor_enghealth_table_plugin_lable_rule: (0, $bvAQG.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_enghealth_table_plugin_lable_rule'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-07-31
    platform_editor_breakout_interaction_rerender: (0, $bvAQG.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_breakout_interaction_rerender'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-08-27
    platform_editor_toolbar_aifc_responsive: (0, $bvAQG.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_toolbar_aifc_responsive',
            jira: 'platform_editor_toolbar_aifc_responsive'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-07-30
    platform_editor_pasting_nested_table_fix: (0, $bvAQG.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_pasting_nested_table_fix'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 20205-07-28
    platform_editor_fix_quick_insert_consistency_exp: (0, $bvAQG.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_fix_quick_insert_consistency_exp'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    //Added 2025-11-19
    platform_editor_pasting_text_in_panel: (0, $bvAQG.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_pasting_text_in_panel'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-07-31
    platform_editor_fix_a11y_aria_posinset_0: (0, $bvAQG.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_fix_a11y_aria_posinset_0'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-07-30
    platform_editor_blocktaskitem_node_tenantid: (0, $bvAQG.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_blocktaskitem_node_tenantid'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-09-08
    platform_editor_blocktaskitem_patch_1: (0, $bvAQG.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_blocktaskitem_patch_1'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-08-06
    cc_editor_limited_mode: (0, $bvAQG.createBooleanExperiment)({
        productKeys: {
            confluence: 'cc_editor_limited_mode'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-08-05
    platform_editor_native_anchor_with_dnd: (0, $bvAQG.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_native_anchor_with_dnd'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    platform_editor_native_expand_button: (0, $bvAQG.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_native_expand_button'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-08-28
    editor_enable_image_alignment_in_expand: (0, $bvAQG.createBooleanExperiment)({
        productKeys: {
            confluence: 'editor_enable_image_alignment_in_expand'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-08-05
    platform_editor_august_a11y: (0, $bvAQG.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_august_a11y'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-08-10
    platform_synced_block: (0, $bvAQG.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_synced_block',
            jira: 'platform_synced_block_jira'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-09-16
    cc_improve_writing_on_paste_v2: (0, $bvAQG.createBooleanExperiment)({
        productKeys: {
            confluence: 'cc_improve_writing_on_paste_v2'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-08-18
    platform_editor_locale_datepicker: (0, $bvAQG.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_locale_datepicker'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-08-19
    platform_editor_breakout_resizing_vc90_fix: (0, $bvAQG.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_breakout_resizing_vc90_fix'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-08-27
    platform_editor_toolbar_support_custom_components: (0, $bvAQG.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_toolbar_support_custom_components'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-08-25
    platform_editor_toolbar_aifc_template_editor: (0, $bvAQG.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_toolbar_aifc_template_editor'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-08-26
    platform_editor_toolbar_migrate_loom: (0, $bvAQG.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_toolbar_migrate_loom',
            jira: 'platform_editor_toolbar_migrate_loom'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-09-16
    platform_editor_prevent_taskitem_remount: (0, $bvAQG.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_prevent_taskitem_remount'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-09-01
    cc_editor_ai_content_mode: (0, $bvAQG.createMultivariateExperiment)({
        productKeys: {
            confluence: 'cc_editor_ai_content_mode'
        },
        param: 'variant',
        values: [
            'control',
            'test'
        ],
        defaultValue: 'control'
    }),
    // Added 2025-09-08
    platform_editor_editor_width_analytics: (0, $bvAQG.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_editor_width_analytics',
            jira: 'platform_editor_editor_width_analytics'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-09-10
    platform_editor_fix_button_name_violation_in_table: (0, $bvAQG.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_fix_button_name_violation_in_table'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-09-11
    platform_editor_quick_insert_image_wrap_right_fix: (0, $bvAQG.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_quick_insert_image_wrap_right_fix'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-09-11
    platform_editor_add_aria_checked_to_inline_img_btn: (0, $bvAQG.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_add_aria_checked_to_inline_image_btn'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-09-16
    platform_editor_nested_table_refresh_width_fix: (0, $bvAQG.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_nested_table_refresh_width_fix'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-09-15
    platform_editor_toolbar_aifc_patch_5: (0, $bvAQG.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_toolbar_aifc_patch_5'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-10-10
    platform_use_llm_space_recommendations: (0, $bvAQG.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_use_llm_space_recommendations'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-09-15
    platform_editor_text_highlight_padding: (0, $bvAQG.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_text_highlight_padding'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-10-24
    platform_editor_lovability_user_intent: (0, $bvAQG.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_lovability_user_intent'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-09-17
    cc_complexit_fe_emoji_stability: (0, $bvAQG.createBooleanExperiment)({
        productKeys: {
            confluence: 'cc_complexit_fe_emoji_stability'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-09-23
    cc_editor_ttvc_release_bundle_one: (0, $bvAQG.createBooleanExperiment)({
        productKeys: {
            confluence: 'cc_editor_ttvc_release_bundle_one'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-10-07
    platform_editor_plain_text_support: (0, $bvAQG.createBooleanExperiment)({
        productKeys: {
            jira: 'platform_editor_plain_text_support',
            confluence: 'platform_editor_plain_text_support'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-09-26
    platform_editor_toolbar_aifc_patch_6: (0, $bvAQG.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_toolbar_aifc_patch_6'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-10-17
    confluence_content_mode_replace_dense_with_compact: (0, $bvAQG.createMultivariateExperiment)({
        productKeys: {
            confluence: 'confluence_content_mode_replace_dense_with_compact'
        },
        param: 'cohort',
        values: [
            'control',
            'test'
        ],
        defaultValue: 'control'
    }),
    // Added 2025-10-01
    platform_inline_smartcard_connect_button_exp: (0, $bvAQG.createMultivariateExperiment)({
        productKeys: {
            confluence: 'platform_inline_smartcard_connect_button_exp',
            jira: 'platform_inline_smartcard_connect_button_exp'
        },
        param: 'cohort',
        values: [
            'control',
            'test1',
            'test2'
        ],
        defaultValue: 'control'
    }),
    // Added 2025-10-10
    platform_editor_new_list_decorations_logic: (0, $bvAQG.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_new_list_decorations_logic'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-10-13
    platform_editor_media_error_analytics: (0, $bvAQG.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_media_error_analytics'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-10-15
    platform_editor_new_mentions_detection_logic: (0, $bvAQG.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_new_mentions_detection_logic'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-10-20
    confluence_whiteboards_quick_insert_localised: (0, $bvAQG.createMultivariateExperiment)({
        productKeys: {
            confluence: 'confluence_whiteboards_quick_insert_localised'
        },
        param: 'cohort',
        values: [
            'control',
            'test_blank',
            'test_diagram'
        ],
        defaultValue: 'control'
    }),
    // Added 2025-10-28
    confluence_whiteboards_quick_insert_localised_aa: (0, $bvAQG.createMultivariateExperiment)({
        productKeys: {
            confluence: 'confluence_whiteboards_quick_insert_localised_aa'
        },
        param: 'cohort',
        values: [
            'control',
            'test_diagram'
        ],
        defaultValue: 'control'
    }),
    // Added 2025-10-22
    platform_editor_remove_bidi_char_warning: (0, $bvAQG.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_remove_bidi_char_warning'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-11-05
    platform_editor_nested_table_detection: (0, $bvAQG.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_nested_table_detection'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-10-24
    platform_editor_fix_clone_nesting_exp: (0, $bvAQG.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_fix_clone_nesting_exp'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-10-27
    platform_editor_table_sticky_header_improvements: (0, $bvAQG.createMultivariateExperiment)({
        productKeys: {
            confluence: 'platform_editor_table_sticky_header_improvements'
        },
        param: 'cohort',
        values: [
            'control',
            'test_with_overflow',
            'test_without_overflow'
        ],
        defaultValue: 'control'
    }),
    // Added 2025-11-04
    platform_editor_disable_lazy_load_media: (0, $bvAQG.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_disable_lazy_load_media'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-10-29
    platform_editor_lovability_inline_code: (0, $bvAQG.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_lovability_inline_code'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-11-05
    platform_editor_lovability_emoji_scaling: (0, $bvAQG.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_lovability_emoji_scaling'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-11-07
    cc_editor_limited_mode_table_align_bttn: (0, $bvAQG.createBooleanExperiment)({
        productKeys: {
            confluence: 'cc_editor_limited_mode_table_align_bttn'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-11-19
    platform_editor_lovability_navigation_fixes: (0, $bvAQG.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_lovability_navigation_fixes'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-11-27
    platform_sl_3p_unauth_paste_as_block_card: (0, $bvAQG.createMultivariateExperiment)({
        productKeys: {
            confluence: 'platform_sl_3p_unauth_paste_as_block_card',
            jira: 'platform_sl_3p_unauth_paste_as_block_card'
        },
        values: [
            'control',
            'card_by_default_only',
            'card_by_default_and_new_design'
        ],
        param: 'cohort',
        defaultValue: 'control'
    }),
    // Added 2025-11-25
    platform_editor_remove_ncsStepMetrics_plugin: (0, $bvAQG.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_remove_ncsStepMetrics_plugin'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-11-18
    platform_editor_wait_for_space_after_ascii_emoji: (0, $bvAQG.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_wait_for_space_after_ascii_emoji'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-12-03
    platform_editor_nested_media_selection_fix: (0, $bvAQG.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_nested_media_selection_fix'
        },
        param: 'isEnabled',
        defaultValue: false
    })
};

});
parcelRegister("bvAQG", function(module, exports) {
$parcel$export(module.exports, "createBooleanExperiment", () => $860f2c5cb32ff950$export$456f1587c9c92021);
$parcel$export(module.exports, "createMultivariateExperiment", () => $860f2c5cb32ff950$export$fb89e8a786694d1);

var $fC8ib = parcelRequire("fC8ib");

var $25nEq = parcelRequire("25nEq");

var $3Pcl9 = parcelRequire("3Pcl9");
function $860f2c5cb32ff950$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $860f2c5cb32ff950$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $860f2c5cb32ff950$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $860f2c5cb32ff950$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $860f2c5cb32ff950$export$456f1587c9c92021(config) {
    return $860f2c5cb32ff950$var$_objectSpread($860f2c5cb32ff950$var$_objectSpread({}, config), {}, {
        typeGuard: (0, $3Pcl9.isBoolean),
        defaultValue: config.defaultValue
    });
}
function $860f2c5cb32ff950$export$fb89e8a786694d1(config) {
    var values = config.values;
    return $860f2c5cb32ff950$var$_objectSpread($860f2c5cb32ff950$var$_objectSpread({}, config), {}, {
        values: (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(values),
        // Maintains the tuple
        typeGuard: (0, $3Pcl9.oneOf)(config.values),
        defaultValue: config.defaultValue
    });
}

});
parcelRegister("3Pcl9", function(module, exports) {
$parcel$export(module.exports, "isBoolean", () => $2c8fb4ff69ea685e$export$f9ce7b637dfbe238);
$parcel$export(module.exports, "oneOf", () => $2c8fb4ff69ea685e$export$a9a18ae5ba42aeab);

var $ekGgq = parcelRequire("ekGgq");

var $3ZMUU = parcelRequire("3ZMUU");
var $2c8fb4ff69ea685e$var$_process, $2c8fb4ff69ea685e$var$_process2;
function $2c8fb4ff69ea685e$export$f9ce7b637dfbe238(value) {
    return typeof value === 'boolean';
}
function $2c8fb4ff69ea685e$export$a9a18ae5ba42aeab(values) {
    function typeGuard(value) {
        return values.includes(value);
    }
    /**
   * This is used by test utils to get the variants when running describe.each
   */ if ($2c8fb4ff69ea685e$var$IS_TESTING_ENV) typeGuard.values = values;
    return typeGuard;
}
// @ts-ignore
var $2c8fb4ff69ea685e$var$IS_TESTING_ENV = (typeof $3ZMUU === "undefined" ? "undefined" : (0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))($3ZMUU)) !== undefined && ((($2c8fb4ff69ea685e$var$_process = $3ZMUU) === null || $2c8fb4ff69ea685e$var$_process === void 0 || ($2c8fb4ff69ea685e$var$_process = $2c8fb4ff69ea685e$var$_process.env) === null || $2c8fb4ff69ea685e$var$_process === void 0 ? void 0 : $2c8fb4ff69ea685e$var$_process.NODE_ENV) === 'test' || (($2c8fb4ff69ea685e$var$_process2 = $3ZMUU) === null || $2c8fb4ff69ea685e$var$_process2 === void 0 || ($2c8fb4ff69ea685e$var$_process2 = $2c8fb4ff69ea685e$var$_process2.env) === null || $2c8fb4ff69ea685e$var$_process2 === void 0 ? void 0 : $2c8fb4ff69ea685e$var$_process2.JEST_WORKER_ID) !== undefined);

});



parcelRegister("1Zmoq", function(module, exports) {
$parcel$export(module.exports, "testMultivariateOverrides", () => $172cdbb2e5a37249$export$7e849a84a00ffd1c);
$parcel$export(module.exports, "testBooleanOverrides", () => $172cdbb2e5a37249$export$54960937bb713f97);
var $172cdbb2e5a37249$export$7e849a84a00ffd1c = {
    'example-multivariate': 'one',
    'platform_editor_ai-prompts-placeholder': 'control',
    platform_editor_ai_proactive_ai_nudge_parameters: 'control',
    platform_editor_controls: 'control',
    confluence_whiteboards_quick_insert_aa: 'control',
    confluence_whiteboards_quick_insert: 'control',
    confluence_whiteboards_quick_insert_localised: 'control',
    confluence_whiteboards_quick_insert_localised_aa: 'control',
    cc_editor_ai_content_mode: 'control',
    platform_editor_add_orange_highlight_color: 'control',
    platform_editor_ai_iw_adf_streaming: 'control',
    platform_editor_ai_non_iw_adf_streaming: 'control',
    platform_hover_card_preview_panel: 'control',
    platform_hover_card_preview_panel_modal: 'control',
    smart_link_confluence_short_link_analytics: 'control',
    platform_inline_smartcard_connect_button_exp: 'control',
    confluence_content_mode_replace_dense_with_compact: 'control',
    cc_editor_insm_outlier_events: 'test',
    platform_editor_disable_table_overflow_shadows: 'control',
    platform_editor_hoverlink_ui_fixes_exp: 'control',
    platform_editor_table_sticky_header_improvements: 'control',
    platform_sl_3p_unauth_paste_as_block_card: 'control'
};
var $172cdbb2e5a37249$export$54960937bb713f97 = {
    platform_editor_feedback_mandatory_rating: false,
    platform_editor_preview_panel_responsiveness: false,
    platform_editor_renderer_breakout_fix: false,
    platform_editor_toolbar_aifc: false,
    platform_editor_block_control_optimise_render: false,
    'test-new-experiments-package': false,
    support_table_in_comment: false,
    platform_editor_exp_lazy_node_views: false,
    platform_renderer_table_sticky_scrollbar: false,
    platform_editor_prevent_toolbar_layout_shifts: false,
    comment_on_bodied_extensions: false,
    advanced_layouts: false,
    single_column_layouts: false,
    support_table_in_comment_jira: false,
    'nested-tables-in-tables': false,
    platform_editor_ai_unsplash_page_header: false,
    platform_editor_blockquote_in_text_formatting_menu: false,
    platform_editor_element_drag_and_drop_multiselect: false,
    platform_editor_ai_edit_response_in_preview: false,
    platform_editor_offline_editing_web: false,
    platform_editor_tables_drag_and_drop: false,
    platform_editor_tables_table_selector: false,
    platform_renderer_fix_analytics_memo_callback: false,
    platform_editor_stop_width_reflows: false,
    platform_editor_no_cursor_on_edit_page_init: false,
    'jira-work-sync-desc-comment-summary': false,
    platform_editor_breakout_resizing: false,
    platform_editor_ai_quickstart_command: false,
    platform_editor_block_controls_perf_optimization: false,
    platform_editor_enable_single_player_step_merging: false,
    platform_editor_find_and_replace_improvements: false,
    platform_editor_toggle_expand_on_match_found: false,
    platform_editor_reduce_noisy_steps_ncs: false,
    cc_improve_writing_on_paste_v2: false,
    platform_editor_text_highlight_padding: false
};

});




parcelRegister("9eG8k", function(module, exports) {
$parcel$export(module.exports, "editorExperiment", () => $6b961aa90f1df516$export$9b7cf3b74f250027);
/* eslint-disable @atlaskit/editor/no-re-export */ // Entry file in package.json

var $jQr4o = parcelRequire("jQr4o");

var $8qy01 = parcelRequire("8qy01");

var $jFnpM = parcelRequire("jFnpM");

var $9L6oc = parcelRequire("9L6oc");
function $6b961aa90f1df516$export$9b7cf3b74f250027(experimentName, expectedExperimentValue) {
    var _experimentConfig$pro;
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
        exposure: false
    };
    var experimentConfig = (0, $jFnpM.editorExperimentsConfig)[experimentName];
    if ((0, $9L6oc._overrides)[experimentName] !== undefined) // This will be hit in the case of a test setting an override
    return (0, $9L6oc._overrides)[experimentName] === expectedExperimentValue;
    if (experimentConfig === undefined) // Warning! If a product is improperly configured (ie. their editor packages are misaligned)
    // it can cause the editor to crash here or if the experiment does not exist.
    // We will definitely crash via any code path later in this function - this just makes the error explicit and clear.
    throw new Error("Editor experiment configuration is not defined ".concat(experimentName, ". Likely the experiment does not exist or editor package versions are misaligned"));
    if (!(0, $9L6oc._product)) // This will be hit in the case of a product not having setup the editor experiment tooling
    return experimentConfig.defaultValue === expectedExperimentValue;
    // Typescript is complaining here about accessing the productKeys property
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    var experimentKey = experimentConfig === null || experimentConfig === void 0 || (_experimentConfig$pro = experimentConfig.productKeys) === null || _experimentConfig$pro === void 0 ? void 0 : _experimentConfig$pro[0, $9L6oc._product];
    if (!experimentKey) {
        var _editorExperimentsCon;
        // This will be hit in the case of an experiment not being set up for the product
        return ((_editorExperimentsCon = (0, $jFnpM.editorExperimentsConfig)[experimentName]) === null || _editorExperimentsCon === void 0 ? void 0 : _editorExperimentsCon.defaultValue) === expectedExperimentValue;
    }
    // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
    var experimentValue = (0, $jQr4o.default).getExperimentValue(// @ts-ignore
    experimentKey, experimentConfig.param, experimentConfig.defaultValue, {
        typeGuard: experimentConfig.typeGuard,
        fireExperimentExposure: options.exposure
    });
    if (// When cleaning this gate up -- `calling where the experiments have the product key set`
    // in __tests__/experiments should be updated (as it's had the count bumped to include these).
    // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
    (0, $jQr4o.default).getExperimentValue('cc_editor_experiments_ufo_gate_reporting', 'isEnabled', false)) (0, $8qy01.addFeatureFlagAccessed)("".concat(experimentName, ":").concat(experimentConfig.param), experimentValue);
    return expectedExperimentValue === experimentValue;
}
function $6b961aa90f1df516$export$92316ae898e357eb(experimentName, paramName, options) {
    var _paramOverrides$exper, _options$exposure;
    if (((_paramOverrides$exper = (0, $9L6oc._paramOverrides)[experimentName]) === null || _paramOverrides$exper === void 0 ? void 0 : _paramOverrides$exper[paramName]) !== undefined) // This will be hit in the case of a test setting an override
    return (0, $9L6oc._paramOverrides)[experimentName][paramName];
    // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
    var experimentValue = (0, $jQr4o.default).getExperimentValue(experimentName, paramName, options.defaultValue, {
        typeGuard: options.typeGuard,
        fireExperimentExposure: (_options$exposure = options.exposure) !== null && _options$exposure !== void 0 ? _options$exposure : false
    });
    return experimentValue;
}

});


parcelRegister("01HkO", function(module, exports) {
$parcel$export(module.exports, "getBreakpoint", () => $0051b57d3788950d$export$1eb095b00b926404);
$parcel$export(module.exports, "WidthContext", () => $0051b57d3788950d$export$27e39f636459b9f);
$parcel$export(module.exports, "WidthConsumer", () => $0051b57d3788950d$export$5d8538aa831b6ebb);
$parcel$export(module.exports, "WidthProvider", () => $0051b57d3788950d$export$7921e18173e8c666);

var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");

var $74Zh5 = parcelRequire("74Zh5");

var $cvlyC = parcelRequire("cvlyC");

var $45Zis = parcelRequire("45Zis");

var $bxWTK = parcelRequire("bxWTK");

var $5IgjU = parcelRequire("5IgjU");
var $0051b57d3788950d$var$styles = (0, $74Zh5.css)({
    position: 'relative',
    width: '100%'
});
var $0051b57d3788950d$var$SCROLLBAR_WIDTH = 30;
function $0051b57d3788950d$export$1eb095b00b926404() {
    var width = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    var MAX_S = 1266;
    var MAX_M = 2146;
    if (width >= MAX_S && width < MAX_M) return 'M';
    else if (width >= MAX_M) return 'L';
    return 'S';
}
function $0051b57d3788950d$export$31a4966bffb9ac98() {
    var width = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    return {
        width: width,
        breakpoint: $0051b57d3788950d$export$1eb095b00b926404(width)
    };
}
var $0051b57d3788950d$export$27e39f636459b9f = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createContext($0051b57d3788950d$export$31a4966bffb9ac98());
var $0051b57d3788950d$var$Provider = $0051b57d3788950d$export$27e39f636459b9f.Provider;
var $0051b57d3788950d$export$5d8538aa831b6ebb = $0051b57d3788950d$export$27e39f636459b9f.Consumer;
var $0051b57d3788950d$export$df154c49e93b2ac2 = (0, $cvlyC.default)(function() {
    var _document$body$offset, _document$body;
    return (0, $5IgjU.isSSR)() ? 0 : (_document$body$offset = (_document$body = document.body) === null || _document$body === void 0 ? void 0 : _document$body.offsetWidth) !== null && _document$body$offset !== void 0 ? _document$body$offset : 0;
});
var $0051b57d3788950d$export$7921e18173e8c666 = function WidthProvider(_ref) {
    var className = _ref.className, shouldCheckExistingValue = _ref.shouldCheckExistingValue, children = _ref.children;
    var existingContextValue = (0, $5FkrB.useContext)($0051b57d3788950d$export$27e39f636459b9f);
    var _useState = (0, $5FkrB.useState)($0051b57d3788950d$export$df154c49e93b2ac2), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), width = _useState2[0], setWidth = _useState2[1];
    var widthRef = (0, $5FkrB.useRef)(width);
    var isMountedRef = (0, $5FkrB.useRef)(true);
    var providerValue = (0, $5FkrB.useMemo)(function() {
        return $0051b57d3788950d$export$31a4966bffb9ac98(width);
    }, [
        width
    ]);
    var updateWidth = (0, $5FkrB.useMemo)(function() {
        return (0, $45Zis.default)(function(nextWidth) {
            var currentWidth = widthRef.current || 0;
            // Ignore changes that are less than SCROLLBAR_WIDTH, otherwise it can cause infinite re-scaling
            if (Math.abs(currentWidth - nextWidth) < $0051b57d3788950d$var$SCROLLBAR_WIDTH) return;
            // Avoid React memory leak by checking if the component is still mounted
            if (!isMountedRef.current) return;
            widthRef.current = nextWidth;
            setWidth(nextWidth);
        });
    }, []);
    var skipWidthDetection = shouldCheckExistingValue && existingContextValue.width > 0;
    (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).useLayoutEffect(function() {
        isMountedRef.current = true;
        return function() {
            isMountedRef.current = false;
        };
    }, []);
    return (0, $74Zh5.jsx)("div", {
        css: $0051b57d3788950d$var$styles,
        className: className
    }, !skipWidthDetection && (0, $74Zh5.jsx)((0, $5FkrB.Fragment), null, (0, $74Zh5.jsx)((0, $bxWTK.WidthObserver), {
        setWidth: updateWidth,
        offscreen: true
    }), (0, $74Zh5.jsx)($0051b57d3788950d$var$Provider, {
        value: providerValue
    }, children)), skipWidthDetection && children);
};

});
parcelRegister("bxWTK", function(module, exports) {
$parcel$export(module.exports, "WidthObserver", () => $868076b348d71ed1$export$b2ad68b9bc407b80);

var $5FkrB = parcelRequire("5FkrB");

var $donxB = parcelRequire("donxB");
var $868076b348d71ed1$export$b2ad68b9bc407b80 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).memo(function(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $donxB.WidthDetectorObserver), {
        setWidth: props.setWidth,
        offscreen: props.offscreen
    });
});
var $868076b348d71ed1$export$2e2bcd8739ae039 = $868076b348d71ed1$export$b2ad68b9bc407b80;

});
parcelRegister("donxB", function(module, exports) {
$parcel$export(module.exports, "WidthDetectorObserver", () => $9bffc6fe1a50f729$export$ff983d2a2b6112ea);

var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");

var $huUkj = parcelRequire("huUkj");
var $9bffc6fe1a50f729$export$ff983d2a2b6112ea = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).memo(function(_ref) {
    var setWidth = _ref.setWidth, offscreen = _ref.offscreen;
    var _useInView = (0, $huUkj.useInView)({
        /* Optional options */ threshold: 0
    }), _useInView2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useInView, 3), inViewRef = _useInView2[0], inView = _useInView2[1], target = _useInView2[2];
    var observer = (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).useRef(function() {
        if (typeof window === 'undefined') return null;
        // https://github.com/DefinitelyTyped/DefinitelyTyped/pull/40909
        // @ts-ignore
        return new ResizeObserver(function(entries) {
            if (!Array.isArray(entries) || !entries.length) return;
            var width = entries[0].contentRect.width;
            setWidth(Math.round(width));
        });
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).useEffect(function() {
        var currentObserver = observer.current;
        var resizeObserver = currentObserver();
        if (resizeObserver === null) return;
        if (target) {
            if (inView || offscreen) resizeObserver.observe(target);
            else resizeObserver.unobserve(target);
        }
        return function() {
            resizeObserver.disconnect();
        };
    }, [
        target,
        inView,
        offscreen
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("div", {
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            display: 'block',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            width: '100%',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            position: 'absolute'
        },
        ref: inViewRef
    });
});

});
parcelRegister("huUkj", function(module, exports) {
$parcel$export(module.exports, "useInView", () => $cbd0ee50051aaaeb$export$2f62ee6831462844);

var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");
function $cbd0ee50051aaaeb$export$2f62ee6831462844() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var ref = (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).useRef();
    var observerInstance = (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).useRef();
    var _React$useState = (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).useState({
        inView: false,
        entry: undefined,
        target: undefined
    }), _React$useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_React$useState, 2), state = _React$useState2[0], setState = _React$useState2[1];
    var threshold = options.threshold, root = options.root, rootMargin = options.rootMargin;
    var setRef = (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).useCallback(function(node) {
        observerInstance.current = new IntersectionObserver(function(entries) {
            if (entries && entries.length) {
                var intersection = entries[0];
                var isIntersecting = intersection.isIntersecting, intersectionRatio = intersection.intersectionRatio;
                if (intersectionRatio >= 0) {
                    // Note: `0` will be used here when an array of numbers is passed as the threshold, which doesn't feel right
                    var numericThreshold = typeof threshold === 'number' ? threshold : 0;
                    var inView = intersectionRatio >= numericThreshold;
                    if (isIntersecting !== undefined) inView = inView && isIntersecting;
                    setState({
                        inView: inView,
                        entry: intersection,
                        target: node
                    });
                }
            }
        }, {
            threshold: threshold,
            root: root,
            rootMargin: rootMargin
        });
        if (ref.current) observerInstance.current.unobserve(ref.current);
        if (node) observerInstance.current.observe(node);
        // Store a reference to the node
        ref.current = node;
    }, [
        threshold,
        root,
        rootMargin
    ]);
    /**
   * Unsubscribe IntersectionObserver before unmounting a component.
   */ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).useEffect(function() {
        return function() {
            if (observerInstance.current && ref.current) observerInstance.current.unobserve(ref.current);
        };
    }, []);
    return [
        setRef,
        state.inView,
        state.target,
        state.entry
    ];
}

});



parcelRegister("5IgjU", function(module, exports) {
$parcel$export(module.exports, "isSSR", () => $428db8a4abdbe986$export$48d7c418edadb60c);

var $3ZMUU = parcelRequire("3ZMUU");
function $428db8a4abdbe986$export$48d7c418edadb60c() {
    try {
        return Boolean(// In most places there is no document when running on server-side
        typeof document === 'undefined' || // When SSRing editor with full cycle mode we define the document
        // Check Confluence specific environment variable
        typeof $3ZMUU !== 'undefined' && undefined);
    } catch (e) {
        // Catch possible error that might occur and just return false
        return false;
    }
}

});


parcelRegister("5dFQJ", function(module, exports) {
$parcel$export(module.exports, "default", () => $3ccea110c6ec6c23$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5FkrB = parcelRequire("5FkrB");

var $74Zh5 = parcelRequire("74Zh5");

var $3IjMA = parcelRequire("3IjMA");

var $1LBcl = parcelRequire("1LBcl");

var $f8aZY = parcelRequire("f8aZY");

var $c3bUn = parcelRequire("c3bUn");

var $jJH6F = parcelRequire("jJH6F");

var $c0oX9 = parcelRequire("c0oX9");

var $fpooh = parcelRequire("fpooh");

var $iY18h = parcelRequire("iY18h");
var $3ccea110c6ec6c23$var$blockNodeStyle = (0, $74Zh5.css)({
    background: "var(--ds-background-disabled, #17171708)",
    border: "var(--ds-border-width, 1px)".concat(" dashed ", "var(--ds-border-disabled, #0515240F)"),
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    borderRadius: "var(--ds-radius-small, 3px)",
    boxSizing: 'border-box',
    cursor: 'default',
    display: 'flex',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    fontSize: (0, $1LBcl.relativeFontSizeToBase16)(14),
    margin: "var(--ds-space-100, 8px)".concat(" 0"),
    minHeight: '24px',
    padding: "var(--ds-space-150, 12px)",
    textAlign: 'center',
    verticalAlign: 'text-bottom',
    minWidth: '120px',
    alignItems: 'center',
    justifyContent: 'center'
});
var $3ccea110c6ec6c23$var$UnsupportedBlockNode = function UnsupportedBlockNode(_ref) {
    var node = _ref.node, intl = _ref.intl, dispatchAnalyticsEvent = _ref.dispatchAnalyticsEvent;
    var message = (0, $iY18h.getUnsupportedContent)((0, $c0oX9.unsupportedContentMessages).unsupportedBlockContent, (0, $c0oX9.unsupportedContentMessages).unsupportedBlockContent.defaultMessage + ':', node, intl);
    var tooltipContent = intl.formatMessage((0, $c0oX9.unsupportedContentMessages).unsupportedContentTooltip);
    var _useRef = (0, $5FkrB.useRef)({
        padding: '4px'
    }), style = _useRef.current;
    var originalNodeType = node === null || node === void 0 ? void 0 : node.attrs.originalValue.type;
    var tooltipOnShowHandler = (0, $5FkrB.useCallback)(function() {
        return dispatchAnalyticsEvent && (0, $fpooh.trackUnsupportedContentTooltipDisplayedFor)(dispatchAnalyticsEvent, (0, $jJH6F.ACTION_SUBJECT_ID).ON_UNSUPPORTED_BLOCK, originalNodeType);
    }, [
        dispatchAnalyticsEvent,
        originalNodeType
    ]);
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    (0, $74Zh5.jsx)("div", {
        css: $3ccea110c6ec6c23$var$blockNodeStyle,
        className: "unsupported"
    }, message, (0, $74Zh5.jsx)((0, $c3bUn.default), {
        content: tooltipContent,
        hideTooltipOnClick: false,
        position: "bottom",
        onShow: tooltipOnShowHandler,
        strategy: "absolute"
    }, (0, $74Zh5.jsx)("span", {
        style: style
    }, (0, $74Zh5.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($f8aZY))), {
        label: "?"
    })))));
};
// eslint-disable-next-line @typescript-eslint/ban-types
var $3ccea110c6ec6c23$var$_default_1 = (0, $3IjMA.default)($3ccea110c6ec6c23$var$UnsupportedBlockNode);
var $3ccea110c6ec6c23$export$2e2bcd8739ae039 = $3ccea110c6ec6c23$var$_default_1;

});
parcelRegister("f8aZY", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::8bb31d7b8eb39bae440b5a0002b7aa63>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b0402271ff9700a6$var$_react = $b0402271ff9700a6$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $b0402271ff9700a6$var$_baseNew = $b0402271ff9700a6$var$_interopRequireDefault((parcelRequire("3l5G0")));
function $b0402271ff9700a6$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "QuestionCircle".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: help, tip.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $b0402271ff9700a6$var$QuestionCircleIcon = (props)=>/*#__PURE__*/ $b0402271ff9700a6$var$_react.default.createElement($b0402271ff9700a6$var$_baseNew.default, Object.assign({
        name: "QuestionCircleIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 1.5a6.5 6.5 0 1 0 0 13 6.5 6.5 0 0 0 0-13M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8m8-3c-.586 0-1 .414-1 1H5.5c0-1.414 1.086-2.5 2.5-2.5s2.5 1.086 2.5 2.5c0 1.133-.713 1.706-1.162 2.058-.511.402-.588.494-.588.692v.75h-1.5v-.75c0-.977.689-1.507 1.078-1.806l.084-.065C8.838 6.544 9 6.367 9 6c0-.586-.414-1-1-1" clip-rule="evenodd"/><path fill="currentcolor" d="M9 11.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0"/>`
    }, props));
$b0402271ff9700a6$var$QuestionCircleIcon.displayName = 'QuestionCircleIcon';
var $b0402271ff9700a6$var$_default = module.exports.default = $b0402271ff9700a6$var$QuestionCircleIcon;

});
parcelRegister("3l5G0", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => (parcelRequire("hdyrD")).default);
$parcel$export(module.exports, "Icon", () => (parcelRequire("hdyrD")).Icon);

var $hdyrD = parcelRequire("hdyrD");

});
parcelRegister("hdyrD", function(module, exports) {
$parcel$export(module.exports, "Icon", () => $c88e5e9792f7a307$export$f04a61298a47a40f);
$parcel$export(module.exports, "default", () => $c88e5e9792f7a307$export$2e2bcd8739ae039);
/* icon-new.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $5FkrB = parcelRequire("5FkrB");

var $1wIML = parcelRequire("1wIML");
/**
 * We are hiding this props from consumers as it's reserved for use by Icon Tile.
 */ var $c88e5e9792f7a307$var$svgStyles = null;
var $c88e5e9792f7a307$var$iconStyles = null;
var $c88e5e9792f7a307$var$smallIconStyles = null;
var $c88e5e9792f7a307$var$scaleStyles = null;
/**
 * For windows high contrast mode
 */ var $c88e5e9792f7a307$var$baseHcmStyles = null;
var $c88e5e9792f7a307$var$scaleSize = null;
var $c88e5e9792f7a307$var$coreSizeMedium = {
    none: "_1bsbpxbi _4t3ipxbi",
    compact: "_1bsb1ejb _4t3i1ejb",
    spacious: "_1bsb1ejb _4t3i1ejb"
};
var $c88e5e9792f7a307$var$coreSizeSmall = {
    none: "_1bsbutpp _4t3iutpp",
    compact: "_1bsbpxbi _4t3ipxbi",
    spacious: "_1bsb1ejb _4t3i1ejb"
};
var $c88e5e9792f7a307$var$paddingMap = {
    medium: {
        none: 0,
        compact: 4,
        spacious: 4
    },
    small: {
        none: 0,
        compact: 2.66,
        spacious: 8
    }
};
var $c88e5e9792f7a307$export$f04a61298a47a40f = /*#__PURE__*/ (0, $5FkrB.memo)(function Icon(props) {
    var _ref = props, _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, testId = _ref.testId, label = _ref.label, dangerouslySetGlyph = _ref.dangerouslySetGlyph, shouldScale = _ref.shouldScale, _ref$spacing = _ref.spacing, spacing = _ref$spacing === void 0 ? 'none' : _ref$spacing, name = _ref.name;
    var dangerouslySetInnerHTML = dangerouslySetGlyph ? {
        __html: dangerouslySetGlyph
    } : undefined;
    var size = 'medium';
    if ('size' in props && props.size !== undefined) {
        if (typeof props.size === 'string') size = props.size === 'small' || props.size === 'medium' ? props.size : size;
        else if (name) {
            var newSize = props.size(name);
            size = newSize === 'small' || newSize === 'medium' ? newSize : size;
        }
    }
    var baseSize = 16;
    var viewBoxPadding = $c88e5e9792f7a307$var$paddingMap[size][spacing];
    var viewBoxSize = baseSize + 2 * viewBoxPadding;
    return /*#__PURE__*/ $5FkrB.createElement("span", {
        "data-testid": testId,
        role: label ? 'img' : undefined,
        "aria-label": label ? label : undefined,
        "aria-hidden": label ? undefined : true,
        style: {
            color: color
        },
        className: (0, $1wIML.default)([
            "_1e0c1o8l _vchhusvi _1o9zidpf _vwz4kb7n _y4ti1igz _bozg1mb9",
            "_12va1onz _jcxd1r8n",
            shouldScale && "_1bsb1kw7 _4t3i1kw7",
            size === 'small' && "_vwz4utpp"
        ])
    }, /*#__PURE__*/ $5FkrB.createElement("svg", {
        fill: "none",
        viewBox: "".concat(0 - viewBoxPadding, " ").concat(0 - viewBoxPadding, " ").concat(viewBoxSize, " ").concat(viewBoxSize),
        role: "presentation",
        dangerouslySetInnerHTML: dangerouslySetInnerHTML,
        className: (0, $1wIML.default)([
            "_1reo15vq _18m915vq _syaz1r31 _lcxvglyw _s7n4yfq0 _vc881r31",
            shouldScale ? "_1bsb1kw7 _4t3i1kw7" : size === 'small' ? $c88e5e9792f7a307$var$coreSizeSmall[spacing] : $c88e5e9792f7a307$var$coreSizeMedium[spacing]
        ])
    }));
});
var $c88e5e9792f7a307$export$2e2bcd8739ae039 = $c88e5e9792f7a307$export$f04a61298a47a40f;

});
parcelRegister("1wIML", function(module, exports) {
$parcel$export(module.exports, "default", () => $11cb851396817a86$export$2e2bcd8739ae039);
/**
 * This length includes the underscore,
 * e.g. `"_1s4A"` would be a valid atomic group hash.
 */ const $11cb851396817a86$var$ATOMIC_GROUP_LENGTH = 5;
function $11cb851396817a86$export$2e2bcd8739ae039(classNames) {
    // Shortcut: nothing to do
    if (!classNames.length) return;
    // Shortcut: don't need to do anything if we only have a single classname
    if (classNames.length === 1 && classNames[0] && // checking to see if `classNames[0]` is a string that contains other classnames
    !classNames[0].includes(' ')) return classNames[0];
    // Using an object rather than a `Map` as it performed better in our benchmarks.
    // Would be happy to move to `Map` if it proved to be better under real conditions.
    const map = {};
    // Note: using loops to minimize iterations over the collection
    for (const value of classNames){
        // Exclude all falsy values, which leaves us with populated strings
        if (!value) continue;
        // a `value` can contain multiple classnames
        const list = value.split(' ');
        for (const className of list){
            /**
             * For atomic style classnames: the `key` is the `group`
             *
             * - Later atomic classnames with the same `group` will override earlier ones
             *   (which is what we want).
             * - Assumes atomic classnames are the only things that start with `_`
             * - Could use a regex to ensure that atomic classnames are structured how we expect,
             *   but did not add that for now as it did slow things down a bit.
             *
             * For other classnames: the `key` is the whole classname
             * - Okay to remove duplicates as doing so does not impact specificity
             *
             * */ const key = className.startsWith('_') ? className.slice(0, $11cb851396817a86$var$ATOMIC_GROUP_LENGTH) : className;
            map[key] = className;
        }
    }
    /**
     * We are converting the `map` into a string.
     *
     * The simple way to do this would be `Object.values(map).join(' ')`.
     * However, the approach below performs 10%-20% better in benchmarks.
     *
     * For `ax()` it feels right to squeeze as much runtime performance out as we can.
     */ let result = '';
    for(const key in map)result += map[key] + ' ';
    // If we have an empty string, then our `map` was empty.
    if (!result) return;
    // remove last " " from the result (we added " " at the end of every value)
    return result.trimEnd();
}

});




parcelRegister("c3bUn", function(module, exports) {
$parcel$export(module.exports, "default", () => $8c5f009596da1f31$export$2e2bcd8739ae039);

var $kqp0i = parcelRequire("kqp0i");

var $iYJcE = parcelRequire("iYJcE");

var $25nEq = parcelRequire("25nEq");

var $5FkrB = parcelRequire("5FkrB");

var $7QpUe = parcelRequire("7QpUe");

var $1Z0tG = parcelRequire("1Z0tG");

var $jnH4n = parcelRequire("jnH4n");

var $aJIjV = parcelRequire("aJIjV");

var $1ndKM = parcelRequire("1ndKM");

var $iUCre = parcelRequire("iUCre");

var $aNF62 = parcelRequire("aNF62");
var $lxUTP = parcelRequire("lxUTP");

var $9Zzpd = parcelRequire("9Zzpd");

var $5K5L9 = parcelRequire("5K5L9");

var $fV8Mu = parcelRequire("fV8Mu");

var $aUIJy = parcelRequire("aUIJy");

var $avtsZ = parcelRequire("avtsZ");

var $bRpWd = parcelRequire("bRpWd");

var $fiZuf = parcelRequire("fiZuf");

var $9Swrf = parcelRequire("9Swrf");

var $7B4ig = parcelRequire("7B4ig");

var $4enDs = parcelRequire("4enDs");
function $8c5f009596da1f31$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $8c5f009596da1f31$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $8c5f009596da1f31$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $8c5f009596da1f31$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $8c5f009596da1f31$var$tooltipZIndex = (0, $aUIJy.layers).tooltip();
var $8c5f009596da1f31$var$analyticsAttributes = {
    componentName: 'tooltip',
    packageName: "@atlaskit/tooltip",
    packageVersion: "0.0.0-development"
};
// Inverts motion direction
var $8c5f009596da1f31$var$invertedDirection = {
    top: 'bottom',
    bottom: 'top',
    left: 'right',
    right: 'left'
};
/**
 * Converts a Popper placement to it's general direction.
 *
 * @param placement - Popper Placement value, e.g. 'top-start'
 * @returns Popper Direction, e.g. 'top'
 */ var $8c5f009596da1f31$var$getDirectionFromPlacement = function getDirectionFromPlacement(placement) {
    return placement.split('-')[0];
};
/**
 * __Tooltip__
 *
 * A tooltip is a floating, non-actionable label used to explain a user interface element or feature.
 */ function $8c5f009596da1f31$var$Tooltip(_ref) {
    var children = _ref.children, _ref$position = _ref.position, position = _ref$position === void 0 ? 'bottom' : _ref$position, _ref$mousePosition = _ref.mousePosition, mousePosition = _ref$mousePosition === void 0 ? 'bottom' : _ref$mousePosition, content = _ref.content, _ref$truncate = _ref.truncate, truncate = _ref$truncate === void 0 ? false : _ref$truncate, _ref$component = _ref.component, Container = _ref$component === void 0 ? (0, $4enDs.default) : _ref$component, _ref$tag = _ref.tag, TargetContainer = _ref$tag === void 0 ? 'div' : _ref$tag, testId = _ref.testId, _ref$delay = _ref.delay, delay = _ref$delay === void 0 ? 300 : _ref$delay, _ref$onShow = _ref.onShow, onShow = _ref$onShow === void 0 ? (0, $jnH4n.default) : _ref$onShow, _ref$onHide = _ref.onHide, onHide = _ref$onHide === void 0 ? (0, $jnH4n.default) : _ref$onHide, canAppear = _ref.canAppear, _ref$hideTooltipOnCli = _ref.hideTooltipOnClick, hideTooltipOnClick = _ref$hideTooltipOnCli === void 0 ? false : _ref$hideTooltipOnCli, _ref$hideTooltipOnMou = _ref.hideTooltipOnMouseDown, hideTooltipOnMouseDown = _ref$hideTooltipOnMou === void 0 ? false : _ref$hideTooltipOnMou, analyticsContext = _ref.analyticsContext, _ref$strategy = _ref.strategy, strategy = _ref$strategy === void 0 ? 'fixed' : _ref$strategy, _ref$ignoreTooltipPoi = _ref.ignoreTooltipPointerEvents, ignoreTooltipPointerEvents = _ref$ignoreTooltipPoi === void 0 ? false : _ref$ignoreTooltipPoi, _ref$isScreenReaderAn = _ref.isScreenReaderAnnouncementDisabled, isScreenReaderAnnouncementDisabled = _ref$isScreenReaderAn === void 0 ? false : _ref$isScreenReaderAn, shortcut = _ref.shortcut, _ref$UNSAFE_shouldAlw = _ref.UNSAFE_shouldAlwaysFadeIn, shouldAlwaysFadeIn = _ref$UNSAFE_shouldAlw === void 0 ? false : _ref$UNSAFE_shouldAlw, _ref$UNSAFE_shouldRen = _ref.UNSAFE_shouldRenderToParent, UNSAFE_shouldRenderToParent = _ref$UNSAFE_shouldRen === void 0 ? false : _ref$UNSAFE_shouldRen;
    // Not using a gate for this check. When the gate is disabled `mouse-y` and `mouse-x` are treated as `mouse`.
    var isMousePosition = position === 'mouse' || position === 'mouse-y' || position === 'mouse-x';
    var tooltipPosition = isMousePosition ? mousePosition : position;
    var onShowHandler = (0, $1Z0tG.usePlatformLeafSyntheticEventHandler)($8c5f009596da1f31$var$_objectSpread({
        fn: onShow,
        action: 'displayed',
        analyticsData: analyticsContext
    }, $8c5f009596da1f31$var$analyticsAttributes));
    var onHideHandler = (0, $1Z0tG.usePlatformLeafSyntheticEventHandler)($8c5f009596da1f31$var$_objectSpread({
        fn: onHide,
        action: 'hidden',
        analyticsData: analyticsContext
    }, $8c5f009596da1f31$var$analyticsAttributes));
    var apiRef = (0, $5FkrB.useRef)(null);
    var _useState = (0, $5FkrB.useState)('hide'), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), state = _useState2[0], setState = _useState2[1];
    var targetRef = (0, $5FkrB.useRef)(null);
    var containerRef = (0, $5FkrB.useRef)(null);
    // This function is deliberately _not_ memoized as it needs to re-run every render
    // to pick up any child ref changes. If you use render props you don't have this issue.
    var setImplicitRefFromChildren = function setImplicitRefFromChildren(node) {
        containerRef.current = node;
        targetRef.current = node ? node.firstElementChild : null;
    };
    // This is memoized and passed into the render props callback.
    var setDirectRef = (0, $5FkrB.useCallback)(function(node) {
        targetRef.current = node;
    }, []);
    // Putting a few things into refs so that we don't have to break memoization
    var stableState = (0, $1ndKM.default)(state);
    // These props are placed in separate refs instead of a single object to reduce memory usage.
    // Placing them in the same object previously caused an increase in the number of JavaScript event listeners
    // before garbage collection.
    var onShowHandlerStable = (0, $1ndKM.default)(onShowHandler);
    var onHideHandlerStable = (0, $1ndKM.default)(onHideHandler);
    var delayStable = (0, $1ndKM.default)(delay);
    var canAppearStable = (0, $1ndKM.default)(canAppear);
    var hasCalledShowHandler = (0, $5FkrB.useRef)(false);
    var shouldAlwaysFadeInStable = (0, $1ndKM.default)(shouldAlwaysFadeIn);
    var start = (0, $5FkrB.useCallback)(function(api) {
        // @ts-ignore
        apiRef.current = api;
        hasCalledShowHandler.current = false;
    }, []);
    var done = (0, $5FkrB.useCallback)(function() {
        if (!apiRef.current) return;
        // Only call onHideHandler if we have called onShowHandler
        if (hasCalledShowHandler.current) onHideHandlerStable.current();
        // @ts-ignore
        apiRef.current = null;
        // @ts-ignore
        hasCalledShowHandler.current = false;
        // just in case
        setState('hide');
    }, [
        onHideHandlerStable
    ]);
    var abort = (0, $5FkrB.useCallback)(function() {
        if (!apiRef.current) return;
        apiRef.current.abort();
        // Only call onHideHandler if we have called onShowHandler
        if (hasCalledShowHandler.current) onHideHandlerStable.current();
        // @ts-ignore
        apiRef.current = null;
    }, [
        onHideHandlerStable
    ]);
    (0, $5FkrB.useEffect)(function mount() {
        return function unmount() {
            if (apiRef.current) abort();
        };
    }, [
        abort
    ]);
    var isDraggingRef = (0, $5FkrB.useRef)(false);
    (0, $5FkrB.useEffect)(function() {
        return (0, $avtsZ.register)({
            onRegister: function onRegister(_ref2) {
                var isDragging = _ref2.isDragging;
                isDraggingRef.current = isDragging;
            },
            onDragStart: function onDragStart() {
                var _apiRef$current;
                /**
         * Hiding any visible tooltips when a drag starts because otherwise it
         * looks janky (disappears and reappears), and is not required.
         */ (_apiRef$current = apiRef.current) === null || _apiRef$current === void 0 || _apiRef$current.requestHide({
                    isImmediate: true
                });
                isDraggingRef.current = true;
            },
            onDragEnd: function onDragEnd() {
                isDraggingRef.current = false;
            }
        });
    }, []);
    var tryShowTooltip = (0, $5FkrB.useCallback)(function(source) {
        var _canAppearStable$curr;
        /**
     * Prevent tooltips from being shown during a drag. This can occur with
     * the native drag and drop API, where some pointer events can fire
     * when they should not and lead to jank with tooltips.
     */ if (isDraggingRef.current) return;
        // Another tooltip is has been active but we still have the old `api`
        // around. We need to finish up the last usage.
        // Note: just being safe - this should not happen
        if (apiRef.current && !apiRef.current.isActive()) abort();
        // This tooltip is already active, we can exit
        if (apiRef.current && apiRef.current.isActive()) {
            apiRef.current.keep();
            return;
        }
        /**
     * Check if tooltip is allowed to show.
     *
     * Once a tooltip has started, or has scheduled to start
     * we won't be checking `canAppear` again.
     *
     * - We don't want tooltips to disappear once they are shown
     * - For consistency, we start after a single positive `canAppear`.
     *   Otherwise the amount of times we ask consumers would depend on
     *   how many times we get a "mousemove", which _could_ lead to situations
     *   where moving the mouse could result in a different outcome to if
     *   the mouse was not moved.
     */ if (canAppearStable.current && !((_canAppearStable$curr = canAppearStable.current) !== null && _canAppearStable$curr !== void 0 && _canAppearStable$curr.call(canAppearStable))) return;
        var entry = {
            source: source,
            delay: delayStable.current,
            show: function show(_ref3) {
                var isImmediate = _ref3.isImmediate;
                // Call the onShow handler if it hasn't been called yet
                if (!hasCalledShowHandler.current) {
                    hasCalledShowHandler.current = true;
                    onShowHandlerStable.current();
                }
                setState(!isImmediate ? 'fade-in' : 'show-immediate');
            },
            hide: function hide(_ref4) {
                var isImmediate = _ref4.isImmediate;
                if (isImmediate) setState('hide');
                else setState('before-fade-out');
            },
            done: done,
            shouldAlwaysFadeIn: (0, $9Zzpd.fg)('platform_dst_nav4_side_nav_resize_tooltip_feedback') ? shouldAlwaysFadeInStable.current : false
        };
        var api = (0, $9Swrf.show)(entry);
        start(api);
    }, [
        canAppearStable,
        delayStable,
        done,
        start,
        abort,
        onShowHandlerStable,
        shouldAlwaysFadeInStable
    ]);
    var hideTooltipOnEsc = (0, $5FkrB.useCallback)(function() {
        var _apiRef$current2;
        (_apiRef$current2 = apiRef.current) === null || _apiRef$current2 === void 0 || _apiRef$current2.requestHide({
            isImmediate: true
        });
    }, [
        apiRef
    ]);
    (0, $aJIjV.default)({
        onClose: hideTooltipOnEsc,
        isDisabled: state === 'hide' || state === 'fade-out'
    });
    (0, $5FkrB.useEffect)(function() {
        if (state === 'hide') return 0, $jnH4n.default;
        if (state === 'before-fade-out') setState('fade-out');
        var unbind = (0, $7QpUe.bind)(window, {
            type: 'scroll',
            listener: function listener() {
                if (apiRef.current) apiRef.current.requestHide({
                    isImmediate: true
                });
            },
            options: {
                capture: true,
                passive: true,
                once: true
            }
        });
        return unbind;
    }, [
        state
    ]);
    var onMouseDown = (0, $5FkrB.useCallback)(function() {
        if (hideTooltipOnMouseDown && apiRef.current) apiRef.current.requestHide({
            isImmediate: true
        });
    }, [
        hideTooltipOnMouseDown
    ]);
    var onClick = (0, $5FkrB.useCallback)(function() {
        if (hideTooltipOnClick && apiRef.current) apiRef.current.requestHide({
            isImmediate: true
        });
    }, [
        hideTooltipOnClick
    ]);
    // Ideally we would be using onMouseEnter here, but
    // because we are binding the event to the target parent
    // we need to listen for the mouseover of all sub elements
    // This means when moving along a tooltip we are quickly toggling
    // between api.requestHide and api.keep. This it not ideal
    var onMouseOver = (0, $5FkrB.useCallback)(function(event) {
        // Ignoring events from the container ref
        if (containerRef.current && event.target === containerRef.current) return;
        // Using prevent default as a signal that parent tooltips
        if (event.defaultPrevented) return;
        event.preventDefault();
        var source = isMousePosition ? {
            type: 'mouse',
            // TODO: ideally not recalculating this object each time
            // Removing old `mouse` behind gate because it stored a function.
            // With the gate we just store the coords which are easier to work with.
            mouse: (0, $9Zzpd.fg)('platform_dst_nav4_side_nav_resize_tooltip_feedback') ? undefined : (0, $bRpWd.getMousePosition)({
                left: event.clientX,
                top: event.clientY
            }),
            clientX: event.clientX,
            clientY: event.clientY
        } : {
            type: 'keyboard'
        };
        tryShowTooltip(source);
    }, [
        isMousePosition,
        tryShowTooltip
    ]);
    // Ideally we would be using onMouseEnter here, but
    // because we are binding the event to the target parent
    // we need to listen for the mouseout of all sub elements
    // This means when moving along a tooltip we are quickly toggling
    // between api.requestHide and api.keep. This it not ideal
    var onMouseOut = (0, $5FkrB.useCallback)(function(event) {
        // Ignoring events from the container ref
        if (containerRef.current && event.target === containerRef.current) return;
        // Using prevent default as a signal that parent tooltips
        if (event.defaultPrevented) return;
        event.preventDefault();
        if (apiRef.current) apiRef.current.requestHide({
            isImmediate: false
        });
    }, []);
    var onMouseMove = isMousePosition ? function(event) {
        var _apiRef$current3;
        if ((_apiRef$current3 = apiRef.current) !== null && _apiRef$current3 !== void 0 && _apiRef$current3.isActive()) {
            if (!(0, $9Zzpd.fg)('platform_dst_nav4_side_nav_resize_tooltip_feedback')) apiRef.current.mousePosition = (0, $bRpWd.getMousePosition)({
                left: event.clientX,
                top: event.clientY
            });
            apiRef.current.mousePos = {
                clientX: event.clientX,
                clientY: event.clientY
            };
        }
    } : undefined;
    var onMouseOverTooltip = (0, $5FkrB.useCallback)(function() {
        if (apiRef.current && apiRef.current.isActive()) {
            apiRef.current.keep();
            return;
        }
    }, []);
    var onFocus = (0, $5FkrB.useCallback)(function(e) {
        // Check if focus-visible
        // Prevents tooltips from showing when focus is not visible,
        // i.e., when focus is moved onto tooltip trigger inside a popup on open
        try {
            if (!e.target.matches(':focus-visible')) return;
        } catch (_unused) {
        // Ignore errors from environments that don't support :focus-visible
        }
        // TODO: this does not play well with `hideTooltipOnMouseDown`
        // as "focus" will occur after the "mousedown".
        tryShowTooltip({
            type: 'keyboard'
        });
    }, [
        tryShowTooltip
    ]);
    var onBlur = (0, $5FkrB.useCallback)(function() {
        if (apiRef.current) apiRef.current.requestHide({
            isImmediate: false
        });
    }, []);
    var onAnimationFinished = (0, $5FkrB.useCallback)(function(transition) {
        // Using lastState here because motion is not picking up the latest value
        if (transition === 'exiting' && stableState.current === 'fade-out' && apiRef.current) // @ts-ignore: refs are writeable
        apiRef.current.finishHideAnimation();
    }, [
        stableState
    ]);
    // Doing a cast because typescript is struggling to narrow the type
    var CastTargetContainer = TargetContainer;
    var shouldRenderTooltipPopup = state !== 'hide' && Boolean(content);
    var shouldRenderHiddenContent = !isScreenReaderAnnouncementDisabled && shouldRenderTooltipPopup;
    var shouldRenderTooltipChildren = state !== 'hide' && state !== 'fade-out';
    var handleOpenLayerObserverCloseSignal = (0, $5FkrB.useCallback)(function() {
        var _apiRef$current4;
        (_apiRef$current4 = apiRef.current) === null || _apiRef$current4 === void 0 || _apiRef$current4.requestHide({
            isImmediate: true
        });
    }, []);
    (0, $iUCre.useNotifyOpenLayerObserver)({
        // Layer is only visually open if both the tooltip popup (container) and children are rendered.
        isOpen: shouldRenderTooltipPopup && shouldRenderTooltipChildren,
        /**
     * We don't strictly need to provide an onClose callback at this time, as there is
     * already code that handles hiding the tooltip when a drag is started (and the only
     * usage right now is closing all layers when the user resizes the side nav).
     *
     * However, for future-proofing and semantic reasons, it makes sense to close the tooltip
     * whenever the open layer observer requests a close.
     */ onClose: handleOpenLayerObserverCloseSignal
    });
    var getReferenceElement = function getReferenceElement() {
        var _apiRef$current5, _apiRef$current6;
        if (isMousePosition && (_apiRef$current5 = apiRef.current) !== null && _apiRef$current5 !== void 0 && _apiRef$current5.mousePos && targetRef.current && (0, $9Zzpd.fg)('platform_dst_nav4_side_nav_resize_tooltip_feedback')) return (0, $fiZuf.getVirtualElementFromMousePos)(apiRef.current.mousePos, {
            targetElement: targetRef.current,
            tooltipPosition: position
        });
        if (isMousePosition && (_apiRef$current6 = apiRef.current) !== null && _apiRef$current6 !== void 0 && _apiRef$current6.mousePosition && !(0, $9Zzpd.fg)('platform_dst_nav4_side_nav_resize_tooltip_feedback')) {
            var _apiRef$current7;
            return (_apiRef$current7 = apiRef.current) === null || _apiRef$current7 === void 0 ? void 0 : _apiRef$current7.mousePosition;
        }
        return targetRef.current || undefined;
    };
    var tooltipIdForHiddenContent = (0, $7B4ig.default)('tooltip', shouldRenderHiddenContent);
    var tooltipTriggerProps = {
        onMouseOver: onMouseOver,
        onMouseOut: onMouseOut,
        onMouseMove: onMouseMove,
        onMouseDown: onMouseDown,
        onClick: onClick,
        onFocus: onFocus,
        onBlur: onBlur
    };
    // Don't set `data-testid` unless it's defined, as it's not in the interface.
    if (testId) // Adding `data-testid` to the TriggerProps interface breaks Buttons, so we use type assertion
    tooltipTriggerProps['data-testid'] = "".concat(testId, "--container");
    // This useEffect is purely for managing the aria attribute when using the
    // wrapped children approach.
    var isChildrenAFunction = typeof children === 'function';
    (0, $5FkrB.useEffect)(function() {
        if (isChildrenAFunction) return;
        // If `children` is _not_ a function, we are stepping outside of the public
        // API to add a `aria-describedby` attribute.
        var target = targetRef.current;
        if (!target || !tooltipIdForHiddenContent) return;
        target.setAttribute('aria-describedby', tooltipIdForHiddenContent);
        return function() {
            return target.removeAttribute('aria-describedby');
        };
    }, [
        isChildrenAFunction,
        tooltipIdForHiddenContent
    ]);
    var hiddenContent = shouldRenderHiddenContent ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("span", {
        "data-testid": testId ? "".concat(testId, "-hidden") : undefined,
        hidden: true,
        id: tooltipIdForHiddenContent
    }, typeof content === 'function' ? content({}) : content) : null;
    var PopperWrapper = UNSAFE_shouldRenderToParent && (0, $9Zzpd.fg)('platform_dst_nav4_side_nav_resize_tooltip_feedback') ? (0, $5FkrB.Fragment) : $8c5f009596da1f31$var$TooltipPortal;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).Fragment, null, typeof children === 'function' ? /*#__PURE__*/ // once we deprecate the wrapped approach, we can put the aria
    // attribute back into the tooltipTriggerProps and make it required
    // instead of optional in `types`
    (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).Fragment, null, children($8c5f009596da1f31$var$_objectSpread($8c5f009596da1f31$var$_objectSpread({}, tooltipTriggerProps), {}, {
        'aria-describedby': tooltipIdForHiddenContent,
        ref: setDirectRef
    })), hiddenContent) : /*#__PURE__*/ // @ts-ignore
    (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(CastTargetContainer, (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, tooltipTriggerProps, {
        ref: setImplicitRefFromChildren,
        role: "presentation"
    }), children, hiddenContent), shouldRenderTooltipPopup ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(PopperWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $5K5L9.Popper), {
        placement: tooltipPosition,
        referenceElement: getReferenceElement(),
        strategy: strategy
    }, function(_ref5) {
        var ref = _ref5.ref, style = _ref5.style, update = _ref5.update, placement = _ref5.placement;
        // Invert the entrance and exit directions.
        // E.g. a tooltip's position is on the 'right', it should enter from and exit to the 'left'
        // This gives the effect the tooltip is appearing from the target
        var direction = isMousePosition ? undefined : $8c5f009596da1f31$var$invertedDirection[$8c5f009596da1f31$var$getDirectionFromPlacement(placement)];
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $aNF62.default), {
            appear: true
        }, shouldRenderTooltipChildren && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $lxUTP.default), {
            distance: "constant",
            entranceDirection: direction,
            exitDirection: direction,
            onFinish: onAnimationFinished,
            duration: state !== 'show-immediate' ? 'medium' : 'none'
        }, function(_ref6) {
            var className = _ref6.className;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(Container, {
                ref: ref,
                className: "Tooltip ".concat(className),
                style: $8c5f009596da1f31$var$_objectSpread($8c5f009596da1f31$var$_objectSpread({}, style), ignoreTooltipPointerEvents && {
                    pointerEvents: 'none'
                }),
                truncate: truncate,
                placement: tooltipPosition,
                testId: getReferenceElement() ? testId : testId && "".concat(testId, "--unresolved"),
                onMouseOut: onMouseOut,
                onMouseOver: onMouseOverTooltip,
                shortcut: shortcut
            }, typeof content === 'function' ? content({
                update: update
            }) : content);
        }));
    })) : null);
}
var $8c5f009596da1f31$export$2e2bcd8739ae039 = $8c5f009596da1f31$var$Tooltip;
var $8c5f009596da1f31$var$TooltipPortal = function TooltipPortal(_ref7) {
    var children = _ref7.children;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $fV8Mu.default), {
        zIndex: $8c5f009596da1f31$var$tooltipZIndex
    }, children);
};

});
parcelRegister("1Z0tG", function(module, exports) {
$parcel$export(module.exports, "usePlatformLeafSyntheticEventHandler", () => $171bdbd16771f822$export$1a04351537078b55);

var $25nEq = parcelRequire("25nEq");

var $5FkrB = parcelRequire("5FkrB");

var $ls0cy = parcelRequire("ls0cy");

var $hY8BC = parcelRequire("hY8BC");
function $171bdbd16771f822$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $171bdbd16771f822$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $171bdbd16771f822$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $171bdbd16771f822$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $171bdbd16771f822$export$1a04351537078b55(_ref) {
    var fn = _ref.fn, action = _ref.action, componentName = _ref.componentName, packageName = _ref.packageName, packageVersion = _ref.packageVersion, analyticsData = _ref.analyticsData;
    var _useAnalyticsEvents = (0, $ls0cy.useAnalyticsEvents)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
    // We put analyticsData and fn in a ref so that we don't need to break
    // memoization.
    // Generally these could be defined by consumers inline
    // and so we do this to avoid breaking memoization of useCallback
    var dataRef = (0, $hY8BC.useTrackedRef)(analyticsData);
    var fnRef = (0, $hY8BC.useTrackedRef)(fn);
    var handler = (0, $5FkrB.useCallback)(function() {
        var analyticsEvent = createAnalyticsEvent({
            action: action,
            actionSubject: componentName,
            attributes: {
                componentName: componentName,
                packageName: packageName,
                packageVersion: packageVersion
            }
        });
        // To avoid wrapping this component in AnalyticsContext we manually
        // push the parent context's meta data into the context.
        // Note: this new 'context'
        var context = $171bdbd16771f822$var$_objectSpread({
            componentName: componentName,
            packageName: packageName,
            packageVersion: packageVersion
        }, dataRef.current);
        analyticsEvent.context.push(context);
        // fire an event on the atlaskit channel
        var clone = analyticsEvent.clone();
        if (clone) clone.fire('atlaskit');
        fnRef.current(analyticsEvent);
    }, [
        // These are strings and won't change
        action,
        componentName,
        packageName,
        packageVersion,
        // This function is memoized in the context
        createAnalyticsEvent,
        // these are a stable ref because of the useTrackedRef hook
        dataRef,
        fnRef
    ]);
    return handler;
}

});
parcelRegister("ls0cy", function(module, exports) {
$parcel$export(module.exports, "useAnalyticsEvents", () => $f9dc5e8738fae419$export$5bf35293e545f20c);

var $dLGML = parcelRequire("dLGML");

var $lqFSF = parcelRequire("lqFSF");

var $l5CBP = parcelRequire("l5CBP");
function $f9dc5e8738fae419$export$5bf35293e545f20c() {
    var analyticsContext = (0, $l5CBP.useAnalyticsContext)();
    var createAnalyticsEvent = (0, $dLGML.useCallbackOne)(function(payload) {
        return new (0, $lqFSF.default)({
            context: analyticsContext.getAtlaskitAnalyticsContext(),
            handlers: analyticsContext.getAtlaskitAnalyticsEventHandlers(),
            payload: payload
        });
    }, [
        analyticsContext
    ]);
    return {
        createAnalyticsEvent: createAnalyticsEvent
    };
}

});
parcelRegister("lqFSF", function(module, exports) {
$parcel$export(module.exports, "default", () => $f99c8353824c07ce$export$2e2bcd8739ae039);

var $fC8ib = parcelRequire("fC8ib");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $kIXpt = parcelRequire("kIXpt");

var $cYPzS = parcelRequire("cYPzS");

var $lwlXp = parcelRequire("lwlXp");

var $eyuDe = parcelRequire("eyuDe");

var $25nEq = parcelRequire("25nEq");

var $6gbbP = parcelRequire("6gbbP");
function $f99c8353824c07ce$var$_callSuper(t, o, e) {
    return o = (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(o), (0, (/*@__PURE__*/$parcel$interopDefault($kIXpt)))(t, $f99c8353824c07ce$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(t).constructor) : o.apply(t, e));
}
function $f99c8353824c07ce$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($f99c8353824c07ce$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $f99c8353824c07ce$var$_superPropGet(t, o, e, r) {
    var p = (0, (/*@__PURE__*/$parcel$interopDefault($lwlXp)))((0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(1 & r ? t.prototype : t), o, e);
    return 2 & r && "function" == typeof p ? function(t) {
        return p.apply(e, t);
    } : p;
}
var $f99c8353824c07ce$export$35f8383928ba8d7 = function isUIAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $f99c8353824c07ce$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isUIAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === 'UIAnalyticsEvent';
};
var $f99c8353824c07ce$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_AnalyticsEvent) {
    function UIAnalyticsEvent(props) {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, UIAnalyticsEvent);
        _this = $f99c8353824c07ce$var$_callSuper(this, UIAnalyticsEvent, [
            props
        ]);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "_isUIAnalyticsEvent", true);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "clone", function() {
            if (_this.hasFired) return null;
            var context = (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(_this.context);
            var handlers = (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(_this.handlers);
            /**
       * A hacky "deep clone" of the object. This is limited in that it wont
       * support functions, regexs, Maps, Sets, etc, but none of those need to
       * be represented in our payload.
       */ var payload = JSON.parse(JSON.stringify(_this.payload));
            return new UIAnalyticsEvent({
                context: context,
                handlers: handlers,
                payload: payload
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "fire", function(channel) {
            if (_this.hasFired) return;
            _this.handlers.forEach(function(handler) {
                return handler(_this, channel);
            });
            _this.hasFired = true;
        });
        _this.context = props.context || [];
        _this.handlers = props.handlers || [];
        _this.hasFired = false;
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($eyuDe)))(UIAnalyticsEvent, _AnalyticsEvent);
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(UIAnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (this.hasFired) return this;
                return $f99c8353824c07ce$var$_superPropGet(UIAnalyticsEvent, "update", this, 3)([
                    updater
                ]);
            }
        }
    ]);
}((0, $6gbbP.default));

});
parcelRegister("6gbbP", function(module, exports) {
$parcel$export(module.exports, "default", () => $48eceac389bf81e9$export$2e2bcd8739ae039);

var $ekGgq = parcelRequire("ekGgq");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $25nEq = parcelRequire("25nEq");
function $48eceac389bf81e9$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $48eceac389bf81e9$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $48eceac389bf81e9$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $48eceac389bf81e9$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $48eceac389bf81e9$export$ad4be5c2ec28cecf = function isAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $48eceac389bf81e9$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === 'AnalyticsEvent';
};
var $48eceac389bf81e9$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function AnalyticsEvent(props) {
        var _this = this;
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, AnalyticsEvent);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "_isAnalyticsEvent", true);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "clone", function() {
            // just a shallow clone, don't change sub refs unless you want to
            // affect the original's too
            var payload = $48eceac389bf81e9$var$_objectSpread({}, _this.payload);
            return new AnalyticsEvent({
                payload: payload
            });
        });
        this.payload = props.payload;
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(AnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (typeof updater === 'function') this.payload = updater(this.payload);
                if ((0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(updater) === 'object') this.payload = $48eceac389bf81e9$var$_objectSpread($48eceac389bf81e9$var$_objectSpread({}, this.payload), updater);
                return this;
            }
        }
    ]);
}();

});


parcelRegister("l5CBP", function(module, exports) {
$parcel$export(module.exports, "useAnalyticsContext", () => $f5a8038ea9ab1097$export$d1f587f82ad51c4);

var $5FkrB = parcelRequire("5FkrB");

var $iyyOp = parcelRequire("iyyOp");
var $f5a8038ea9ab1097$export$d1f587f82ad51c4 = function useAnalyticsContext() {
    return (0, $5FkrB.useContext)((0, $iyyOp.default));
};

});


parcelRegister("hY8BC", function(module, exports) {
$parcel$export(module.exports, "useTrackedRef", () => $d14eb72b4ef04cbd$export$1d27a74659855e44);

var $5FkrB = parcelRequire("5FkrB");
var $d14eb72b4ef04cbd$export$1d27a74659855e44 = function useTrackedRef(value) {
    var ref = (0, $5FkrB.useRef)(value);
    ref.current = value;
    return ref;
};

});


parcelRegister("jnH4n", function(module, exports) {
$parcel$export(module.exports, "default", () => $e1c193032372aee3$export$2e2bcd8739ae039);
/**
 * An empty function which does nothing.
 */ function $e1c193032372aee3$export$2e2bcd8739ae039() {}

});

parcelRegister("aJIjV", function(module, exports) {
$parcel$export(module.exports, "default", () => $7d107c751f962b8d$export$2e2bcd8739ae039);

var $5FkrB = parcelRequire("5FkrB");

var $7QpUe = parcelRequire("7QpUe");

var $h2P0C = parcelRequire("h2P0C");
function $7d107c751f962b8d$export$2e2bcd8739ae039(_ref) {
    var onClose = _ref.onClose, isDisabled = _ref.isDisabled;
    var escapePressed = (0, $5FkrB.useRef)(false);
    var onKeyDown = (0, $5FkrB.useCallback)(function(e) {
        if (isDisabled || escapePressed.current || e.key !== (0, $h2P0C.ESCAPE)) // We're either already handling the key down event or it's not escape.
        // Bail early!
        return;
        escapePressed.current = true;
        onClose(e);
    }, [
        onClose,
        isDisabled
    ]);
    var onKeyUp = (0, $5FkrB.useCallback)(function() {
        escapePressed.current = false;
    }, []);
    (0, $5FkrB.useEffect)(function() {
        // Don't attach document event listeners if the hook is disabled
        if (isDisabled) return;
        return (0, $7QpUe.bindAll)(document, [
            {
                type: 'keydown',
                listener: onKeyDown
            },
            {
                type: 'keyup',
                listener: onKeyUp
            }
        ], {
            capture: false
        });
    }, [
        onKeyDown,
        onKeyUp,
        isDisabled
    ]);
}

});
parcelRegister("h2P0C", function(module, exports) {
$parcel$export(module.exports, "ESCAPE", () => $c68a30e06d2f79e8$export$2bb790b9008907b4);
/**
 * Character key codes which can be used in keyboard events.
 */ var $c68a30e06d2f79e8$export$390330c10ff2b9a1 = 'ArrowUp';
var $c68a30e06d2f79e8$export$a80636c6f41931fe = 'ArrowDown';
var $c68a30e06d2f79e8$export$fc4577f2a2af0ae3 = 'ArrowLeft';
var $c68a30e06d2f79e8$export$c40f9845adc73fb5 = 'ArrowRight';
var $c68a30e06d2f79e8$export$4af703091671bc = 'Home';
var $c68a30e06d2f79e8$export$e2bc30913faa5db7 = 'End';
var $c68a30e06d2f79e8$export$10f6869ed0a7d75b = 'Tab';
var $c68a30e06d2f79e8$export$8152f929a25a0ff4 = 'Enter';
var $c68a30e06d2f79e8$export$e51a3576c045c8d5 = 'Space';
var $c68a30e06d2f79e8$export$2bb790b9008907b4 = 'Escape';

});


parcelRegister("1ndKM", function(module, exports) {
$parcel$export(module.exports, "default", () => $10029b96d1f16e60$export$2e2bcd8739ae039);

var $5FkrB = parcelRequire("5FkrB");
function $10029b96d1f16e60$export$2e2bcd8739ae039(value) {
    var ref = (0, $5FkrB.useRef)(value);
    (0, $5FkrB.useEffect)(function() {
        ref.current = value;
    }, [
        value
    ]);
    return ref;
}

});

parcelRegister("lxUTP", function(module, exports) {
$parcel$export(module.exports, "default", () => $faf8d110486344ab$export$2e2bcd8739ae039);

var $5FkrB = parcelRequire("5FkrB");

var $fxdVc = parcelRequire("fxdVc");
var $faf8d110486344ab$var$invertedDirection = {
    top: 'bottom',
    bottom: 'top',
    left: 'right',
    right: 'left'
};
/**
 * Props for controlling the behavior of the FadeIn animation
 */ /**
 * __FadeIn__
 *
 * Useful for fading in one or more elements.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/motion/docs/entering-motions)
 */ var $faf8d110486344ab$var$FadeIn = function FadeIn(_ref) {
    var children = _ref.children, _ref$duration = _ref.duration, duration = _ref$duration === void 0 ? 'large' : _ref$duration, entranceDirection = _ref.entranceDirection, exitDirection = _ref.exitDirection, _ref$distance = _ref.distance, distance = _ref$distance === void 0 ? 'proportional' : _ref$distance, onFinish = _ref.onFinish, isPaused = _ref.isPaused;
    var invertedEntranceDirection = entranceDirection !== undefined ? $faf8d110486344ab$var$invertedDirection[entranceDirection] : undefined;
    var isExitDirect = Boolean(exitDirection || invertedEntranceDirection) ? "fade-out-from-".concat(exitDirection || invertedEntranceDirection).concat(distance === 'proportional' ? '' : '-constant') : 'fade-out';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $fxdVc.default), {
        duration: duration,
        enteringAnimation: entranceDirection ? "fade-in-from-".concat(entranceDirection).concat(distance === 'proportional' ? '' : '-constant') : 'fade-in',
        exitingAnimation: isExitDirect,
        animationTimingFunction: "ease-in-out",
        onFinish: onFinish,
        isPaused: isPaused
    }, children);
};
var $faf8d110486344ab$export$2e2bcd8739ae039 = $faf8d110486344ab$var$FadeIn;

});
parcelRegister("fxdVc", function(module, exports) {
$parcel$export(module.exports, "default", () => $b4f4bca1dbeb6cba$export$2e2bcd8739ae039);
/* keyframes-motion.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");

var $epCrz = parcelRequire("epCrz");

var $gMOIN = parcelRequire("gMOIN");

var $eqAKy = parcelRequire("eqAKy");

var $3CquG = parcelRequire("3CquG");

var $aNF62 = parcelRequire("aNF62");

var $eTCcX = parcelRequire("eTCcX");
var $b4f4bca1dbeb6cba$var$zoomIn = null;
var $b4f4bca1dbeb6cba$var$zoomOut = null;
var $b4f4bca1dbeb6cba$var$fadeIn = null;
var $b4f4bca1dbeb6cba$var$fadeOut = null;
var $b4f4bca1dbeb6cba$var$fadeInFromTop = null;
var $b4f4bca1dbeb6cba$var$fadeOutFromTop = null;
var $b4f4bca1dbeb6cba$var$fadeInFromLeft = null;
var $b4f4bca1dbeb6cba$var$fadeOutFromLeft = null;
var $b4f4bca1dbeb6cba$var$fadeInFromBottom = null;
var $b4f4bca1dbeb6cba$var$fadeOutFromBottom = null;
var $b4f4bca1dbeb6cba$var$fadeInFromRight = null;
var $b4f4bca1dbeb6cba$var$fadeOutFromRight = null;
var $b4f4bca1dbeb6cba$var$fadeInFromTopConstant = null;
var $b4f4bca1dbeb6cba$var$fadeOutFromTopConstant = null;
var $b4f4bca1dbeb6cba$var$fadeInFromLeftConstant = null;
var $b4f4bca1dbeb6cba$var$fadeOutFromLeftConstant = null;
var $b4f4bca1dbeb6cba$var$fadeInFromBottomConstant = null;
var $b4f4bca1dbeb6cba$var$fadeOutFromBottomConstant = null;
var $b4f4bca1dbeb6cba$var$fadeInFromRightConstant = null;
var $b4f4bca1dbeb6cba$var$fadeOutFromRightConstant = null;
var $b4f4bca1dbeb6cba$var$slideInFromTop = null;
var $b4f4bca1dbeb6cba$var$slideOutFromTop = null;
var $b4f4bca1dbeb6cba$var$slideInFromRight = null;
var $b4f4bca1dbeb6cba$var$slideOutFromRight = null;
var $b4f4bca1dbeb6cba$var$slideInFromBottom = null;
var $b4f4bca1dbeb6cba$var$slideOutFromBottom = null;
var $b4f4bca1dbeb6cba$var$slideInFromLeft = null;
var $b4f4bca1dbeb6cba$var$slideOutFromLeft = null;
/**
 * These are props that motions should use as their external props for consumers.
 * See [FadeIn](packages/helpers/motion/src/entering/fade-in.tsx) for an example usage.
 */ /**
 * This is the base INTERNAL component used for all other entering motions.
 * This does not need Javascript to execute on the client so it will run immediately
 * for any SSR rendered React apps before the JS has executed.
 */ var $b4f4bca1dbeb6cba$var$EnteringMotion = function EnteringMotion(_ref) {
    var children = _ref.children, animationTimingFunction = _ref.animationTimingFunction, _ref$animationTimingF = _ref.animationTimingFunctionExiting, animationTimingFunctionExiting = _ref$animationTimingF === void 0 ? animationTimingFunction : _ref$animationTimingF, enteringAnimation = _ref.enteringAnimation, _ref$exitingAnimation = _ref.exitingAnimation, exitingAnimation = _ref$exitingAnimation === void 0 ? enteringAnimation : _ref$exitingAnimation, isPaused = _ref.isPaused, onFinishMotion = _ref.onFinish, _ref$duration = _ref.duration, duration = _ref$duration === void 0 ? 'large' : _ref$duration;
    var staggered = (0, $eTCcX.useStaggeredEntrance)();
    var _useExitingPersistenc = (0, $aNF62.useExitingPersistence)(), isExiting = _useExitingPersistenc.isExiting, onExitFinished = _useExitingPersistenc.onFinish, appear = _useExitingPersistenc.appear;
    var setTimeout = (0, $3CquG.useSetTimeout)();
    var paused = isPaused || !staggered.isReady;
    var delay = isExiting ? 0 : staggered.delay;
    var state = isExiting ? 'exiting' : 'entering';
    var _useState = (0, $5FkrB.useState)(appear), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), hasAnimationStyles = _useState2[0], setHasAnimationStyles = _useState2[1];
    (0, $5FkrB.useEffect)(function() {
        // Tracking this to prevent changing state on an unmounted component
        var isCancelled = false;
        if (paused) return;
        // On initial mount if elements aren't set to animate on appear, we return early and callback
        if (!appear) {
            onFinishMotion && onFinishMotion(state);
            return;
        }
        /**
     * Updates relevant state.
     * Called when the animation is finished, or immediately with reduced motion.
     */ var onAnimationEnd = function onAnimationEnd() {
            if (state === 'exiting') // Updates the `ExitingPersistence` to remove this child
            onExitFinished === null || onExitFinished === void 0 || onExitFinished();
            if (!isCancelled) setHasAnimationStyles(false);
            onFinishMotion === null || onFinishMotion === void 0 || onFinishMotion(state);
        };
        if ((0, $gMOIN.isReducedMotion)()) {
            // If there is reduced motion there is no exit animation, so call this immediately
            onAnimationEnd();
            return;
        }
        // Elements may need animation styles back after initial mount (they could animate out)
        setHasAnimationStyles(true);
        // Queue `onAnimationEnd` for after the animation has finished
        setTimeout(onAnimationEnd, isExiting ? (0, $eqAKy.exitingDurations)[duration] : (0, $eqAKy.durations)[duration] + delay);
        return function() {
            isCancelled = true;
        };
    // We ignore this for onFinishMotion as consumers could potentially inline the function
    // which would then trigger this effect every re-render.
    // We want to make it easier for consumers so we go down this path unfortunately.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        onExitFinished,
        state,
        isExiting,
        duration,
        delay,
        paused,
        setTimeout
    ]);
    return children({
        ref: staggered.ref,
        // @ts-expect-error: `ax` is not typed correctly
        className: hasAnimationStyles ? (0, $epCrz.default)([
            (0, $epCrz.default)([
                "_1o51eoah _1y0co91m _1bumglyw _sedtglyw"
            ]),
            paused && (0, $epCrz.default)([
                "_1y0ctrqk"
            ]),
            duration === 'small' && (0, $epCrz.default)([
                "_5sag1yx9"
            ]),
            duration === 'medium' && (0, $epCrz.default)([
                "_5sag1ttt"
            ]),
            duration === 'large' && (0, $epCrz.default)([
                "_5sagpwmj"
            ]),
            isExiting && duration === 'small' && (0, $epCrz.default)([
                "_5sag14ed"
            ]),
            isExiting && duration === 'medium' && (0, $epCrz.default)([
                "_5sagluct"
            ]),
            isExiting && duration === 'large' && (0, $epCrz.default)([
                "_5sag1ttt"
            ]),
            isExiting && (0, $epCrz.default)([
                "_ju255cps _1o51q7pw"
            ]),
            !isExiting && animationTimingFunction === 'linear' && (0, $epCrz.default)([
                "_1pglp3kn"
            ]),
            !isExiting && animationTimingFunction === 'ease-out' && (0, $epCrz.default)([
                "_1pgldkwg"
            ]),
            !isExiting && animationTimingFunction === 'ease-in' && (0, $epCrz.default)([
                "_1pgl1nzg"
            ]),
            !isExiting && animationTimingFunction === 'ease-in-40-out' && (0, $epCrz.default)([
                "_1pgl5y64"
            ]),
            !isExiting && animationTimingFunction === 'ease-in-60-out' && (0, $epCrz.default)([
                "_1pgl1ddy"
            ]),
            !isExiting && animationTimingFunction === 'ease-in-80-out' && (0, $epCrz.default)([
                "_1pglannl"
            ]),
            !isExiting && animationTimingFunction === 'ease-in-out' && (0, $epCrz.default)([
                "_1pgl1fu8"
            ]),
            isExiting && animationTimingFunction === 'linear' && (0, $epCrz.default)([
                "_1pglp3kn"
            ]),
            isExiting && animationTimingFunctionExiting === 'ease-out' && (0, $epCrz.default)([
                "_1pgldkwg"
            ]),
            isExiting && animationTimingFunctionExiting === 'ease-in' && (0, $epCrz.default)([
                "_1pgl1nzg"
            ]),
            isExiting && animationTimingFunctionExiting === 'ease-in-40-out' && (0, $epCrz.default)([
                "_1pgl5y64"
            ]),
            isExiting && animationTimingFunctionExiting === 'ease-in-60-out' && (0, $epCrz.default)([
                "_1pgl1ddy"
            ]),
            isExiting && animationTimingFunctionExiting === 'ease-in-80-out' && (0, $epCrz.default)([
                "_1pglannl"
            ]),
            isExiting && animationTimingFunctionExiting === 'ease-in-out' && (0, $epCrz.default)([
                "_1pgl1fu8"
            ]),
            (!isExiting && enteringAnimation === 'fade-in' || isExiting && exitingAnimation === 'fade-in') && (0, $epCrz.default)([
                "_j7hq1cgr"
            ]),
            (!isExiting && enteringAnimation === 'fade-out' || isExiting && exitingAnimation === 'fade-out') && (0, $epCrz.default)([
                "_j7hq1lln"
            ]),
            (!isExiting && enteringAnimation === 'zoom-in' || isExiting && exitingAnimation === 'zoom-in') && (0, $epCrz.default)([
                "_j7hqe8p0"
            ]),
            (!isExiting && enteringAnimation === 'zoom-out' || isExiting && exitingAnimation === 'zoom-out') && (0, $epCrz.default)([
                "_j7hqy6ql"
            ]),
            (!isExiting && enteringAnimation === 'slide-in-from-top' || isExiting && exitingAnimation === 'slide-in-from-top') && (0, $epCrz.default)([
                "_j7hqqshu"
            ]),
            (!isExiting && enteringAnimation === 'slide-out-from-top' || isExiting && exitingAnimation === 'slide-out-from-top') && (0, $epCrz.default)([
                "_j7hq7ri4"
            ]),
            (!isExiting && enteringAnimation === 'slide-in-from-right' || isExiting && exitingAnimation === 'slide-in-from-right') && (0, $epCrz.default)([
                "_j7hqdfjr"
            ]),
            (!isExiting && enteringAnimation === 'slide-out-from-right' || isExiting && exitingAnimation === 'slide-out-from-right') && (0, $epCrz.default)([
                "_j7hqonfj"
            ]),
            (!isExiting && enteringAnimation === 'slide-in-from-bottom' || isExiting && exitingAnimation === 'slide-in-from-bottom') && (0, $epCrz.default)([
                "_j7hq1liq"
            ]),
            (!isExiting && enteringAnimation === 'slide-out-from-bottom' || isExiting && exitingAnimation === 'slide-out-from-bottom') && (0, $epCrz.default)([
                "_j7hqhnf1"
            ]),
            (!isExiting && enteringAnimation === 'slide-in-from-left' || isExiting && exitingAnimation === 'slide-in-from-left') && (0, $epCrz.default)([
                "_j7hq1bh1"
            ]),
            (!isExiting && enteringAnimation === 'slide-out-from-left' || isExiting && exitingAnimation === 'slide-out-from-left') && (0, $epCrz.default)([
                "_j7hqj08w"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-top' || isExiting && exitingAnimation === 'fade-in-from-top') && (0, $epCrz.default)([
                "_j7hq2iua"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-top' || isExiting && exitingAnimation === 'fade-out-from-top') && (0, $epCrz.default)([
                "_j7hq39va"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-left' || isExiting && exitingAnimation === 'fade-in-from-left') && (0, $epCrz.default)([
                "_j7hq15m2"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-left' || isExiting && exitingAnimation === 'fade-out-from-left') && (0, $epCrz.default)([
                "_j7hq1yiv"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-bottom' || isExiting && exitingAnimation === 'fade-in-from-bottom') && (0, $epCrz.default)([
                "_j7hq1w00"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-bottom' || isExiting && exitingAnimation === 'fade-out-from-bottom') && (0, $epCrz.default)([
                "_j7hqzy3z"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-right' || isExiting && exitingAnimation === 'fade-in-from-right') && (0, $epCrz.default)([
                "_j7hqpqak"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-right' || isExiting && exitingAnimation === 'fade-out-from-right') && (0, $epCrz.default)([
                "_j7hq1ebg"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-top-constant' || isExiting && exitingAnimation === 'fade-in-from-top-constant') && (0, $epCrz.default)([
                "_j7hqm2e2"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-top-constant' || isExiting && exitingAnimation === 'fade-out-from-top-constant') && (0, $epCrz.default)([
                "_j7hq97jn"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-left-constant' || isExiting && exitingAnimation === 'fade-in-from-left-constant') && (0, $epCrz.default)([
                "_j7hqovgq"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-left-constant' || isExiting && exitingAnimation === 'fade-out-from-left-constant') && (0, $epCrz.default)([
                "_j7hq15do"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-bottom-constant' || isExiting && exitingAnimation === 'fade-in-from-bottom-constant') && (0, $epCrz.default)([
                "_j7hq797a"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-bottom-constant' || isExiting && exitingAnimation === 'fade-out-from-bottom-constant') && (0, $epCrz.default)([
                "_j7hqwo7r"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-right-constant' || isExiting && exitingAnimation === 'fade-in-from-right-constant') && (0, $epCrz.default)([
                "_j7hqt8u5"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-right-constant' || isExiting && exitingAnimation === 'fade-out-from-right-constant') && (0, $epCrz.default)([
                "_j7hq1pgp"
            ])
        ]) : '',
        style: {
            animationDelay: "".concat(delay, "ms")
        }
    }, state);
};
var $b4f4bca1dbeb6cba$export$2e2bcd8739ae039 = $b4f4bca1dbeb6cba$var$EnteringMotion;

});
parcelRegister("epCrz", function(module, exports) {
$parcel$export(module.exports, "default", () => $a7e1389f020c83dc$export$2e2bcd8739ae039);
/**
 * This length includes the underscore,
 * e.g. `"_1s4A"` would be a valid atomic group hash.
 */ const $a7e1389f020c83dc$var$ATOMIC_GROUP_LENGTH = 5;
function $a7e1389f020c83dc$export$2e2bcd8739ae039(classNames) {
    // Shortcut: nothing to do
    if (!classNames.length) return;
    // Shortcut: don't need to do anything if we only have a single classname
    if (classNames.length === 1 && classNames[0] && // checking to see if `classNames[0]` is a string that contains other classnames
    !classNames[0].includes(' ')) return classNames[0];
    // Using an object rather than a `Map` as it performed better in our benchmarks.
    // Would be happy to move to `Map` if it proved to be better under real conditions.
    const map = {};
    // Note: using loops to minimize iterations over the collection
    for (const value of classNames){
        // Exclude all falsy values, which leaves us with populated strings
        if (!value) continue;
        // a `value` can contain multiple classnames
        const list = value.split(' ');
        for (const className of list){
            /**
             * For atomic style classnames: the `key` is the `group`
             *
             * - Later atomic classnames with the same `group` will override earlier ones
             *   (which is what we want).
             * - Assumes atomic classnames are the only things that start with `_`
             * - Could use a regex to ensure that atomic classnames are structured how we expect,
             *   but did not add that for now as it did slow things down a bit.
             *
             * For other classnames: the `key` is the whole classname
             * - Okay to remove duplicates as doing so does not impact specificity
             *
             * */ const key = className.startsWith('_') ? className.slice(0, $a7e1389f020c83dc$var$ATOMIC_GROUP_LENGTH) : className;
            map[key] = className;
        }
    }
    /**
     * We are converting the `map` into a string.
     *
     * The simple way to do this would be `Object.values(map).join(' ')`.
     * However, the approach below performs 10%-20% better in benchmarks.
     *
     * For `ax()` it feels right to squeeze as much runtime performance out as we can.
     */ let result = '';
    for(const key in map)result += map[key] + ' ';
    // If we have an empty string, then our `map` was empty.
    if (!result) return;
    // remove last " " from the result (we added " " at the end of every value)
    return result.trimEnd();
}

});

parcelRegister("gMOIN", function(module, exports) {
$parcel$export(module.exports, "isReducedMotion", () => $c388794be4d106d9$export$b7baf7667a68d87c);

var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");

var $7QpUe = parcelRequire("7QpUe");
var $c388794be4d106d9$var$isMatchMediaAvailable = function isMatchMediaAvailable() {
    return typeof window !== 'undefined' && 'matchMedia' in window;
};
var $c388794be4d106d9$export$b7baf7667a68d87c = function isReducedMotion() {
    if (!$c388794be4d106d9$var$isMatchMediaAvailable()) return false;
    var _window$matchMedia = window.matchMedia('(prefers-reduced-motion: reduce)'), matches = _window$matchMedia.matches;
    return matches;
};
var $c388794be4d106d9$export$c537e63161742ce3 = function useIsReducedMotion() {
    var _useState = (0, $5FkrB.useState)($c388794be4d106d9$export$b7baf7667a68d87c), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), prefersReducedMotion = _useState2[0], setPrefersReducedMotion = _useState2[1];
    (0, $5FkrB.useEffect)(function() {
        if (!$c388794be4d106d9$var$isMatchMediaAvailable()) return;
        var mediaQueryList = window.matchMedia('(prefers-reduced-motion: reduce)');
        var onChange = function onChange(event) {
            return setPrefersReducedMotion(event.matches);
        };
        return (0, $7QpUe.bind)(mediaQueryList, {
            type: 'change',
            listener: onChange
        });
    }, []);
    return prefersReducedMotion;
};
var $c388794be4d106d9$export$f0f789643ba5a83c = {
    '@media (prefers-reduced-motion: reduce)': {
        animation: 'none',
        transition: 'none'
    }
};
var $c388794be4d106d9$export$ff7706047246b98b = function prefersReducedMotion() {
    return $c388794be4d106d9$export$f0f789643ba5a83c;
};

});

parcelRegister("eTCcX", function(module, exports) {
$parcel$export(module.exports, "useStaggeredEntrance", () => $ad83d708a15a323e$export$25c7213fc07ec080);

var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");

var $8MEil = parcelRequire("8MEil");

var $4uuz6 = parcelRequire("4uuz6");

var $SIQkH = parcelRequire("SIQkH");
var $ad83d708a15a323e$var$StaggeredEntranceContext = /*#__PURE__*/ (0, $5FkrB.createContext)(function() {
    return {
        isReady: true,
        delay: 0,
        ref: (0, $8MEil.default)
    };
});
var $ad83d708a15a323e$export$25c7213fc07ec080 = function useStaggeredEntrance() {
    var indentifier = (0, $SIQkH.useUniqueId)();
    var context = (0, $5FkrB.useContext)($ad83d708a15a323e$var$StaggeredEntranceContext);
    return context(indentifier);
};
/**
 * For a list of elements that need to animate in,
 * this should be used in conjunction with entering components.
 * This does not need Javascript to execute so it will run immediately for any SSR rendered React apps before the JS has executed.
 *
 * Will dynamically add delay to each child entering component.
 * Unfortunately all entering components _NEED_ to be a direct descendant.
 */ var $ad83d708a15a323e$var$StaggeredEntrance = function StaggeredEntrance(_ref) {
    var children = _ref.children, column = _ref.column, _ref$columns = _ref.columns, columns = _ref$columns === void 0 ? 'responsive' : _ref$columns, _ref$delayStep = _ref.delayStep, delayStep = _ref$delayStep === void 0 ? 50 : _ref$delayStep;
    var elementRefs = (0, $5FkrB.useRef)([]);
    var indexes = [];
    var _useState = (0, $5FkrB.useState)(function() {
        if (typeof columns === 'number') // A hardcoded columns is set so bail out and set it to that!
        return columns;
        if (typeof column === 'number') // A hardcoded column is set so we will set actualColumns to be 1.
        return 1;
        // We are in "responsive" mode.
        // So we will be calculating when the Javascript executes on the client how many columns there will be.
        return 0;
    }), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), actualColumns = _useState2[0], setActualColumns = _useState2[1];
    (0, $4uuz6.useLayoutEffect)(function() {
        // We want to only run this code when we are in "responsive" mode.
        // It is assumed we are in responsive mode if `columns` is "responsive",
        // we have children element refs ready to be read (i.e. if there are no children this won't run as well)
        // and finally that `actualColumns` is `0` - this is because for the first render cycle `actualColumns` will be `0` (set above)
        // and then after this layout effect runs the value for `actualColumns` will then be calculated and set.
        if (columns === 'responsive' && elementRefs.current.length && actualColumns === 0) {
            var currentTop = 0;
            var numberColumns = 0;
            if (elementRefs.current.length <= 1) {
                setActualColumns(1);
                return;
            }
            // We set the current top to the first elements.
            // We will be comparing this and incrementing the column count
            // until we hit an element that has a different offset top (or we run out of elements).
            currentTop = elementRefs.current[0] ? elementRefs.current[0].offsetTop : 0;
            for(var i = 0; i < elementRefs.current.length; i++){
                var child = elementRefs.current[i];
                if (!child) break;
                if (currentTop === child.offsetTop) {
                    numberColumns += 1;
                    if (elementRefs.current.length - 1 === i) setActualColumns(numberColumns);
                    continue;
                }
                setActualColumns(numberColumns);
                break;
            }
        }
    // We only want this effect to run once - on initial mount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement($ad83d708a15a323e$var$StaggeredEntranceContext.Provider, {
        value: function value(id) {
            if (!indexes.includes(id)) indexes.push(id);
            var isReady = actualColumns > 0;
            var index = indexes.indexOf(id);
            var currentColumn = column || index % actualColumns;
            var currentRow = Math.floor(index / actualColumns);
            var distanceFromTopLeftElement = currentRow + currentColumn;
            // We don't want loads of elements to have the same staggered delay as it ends up looking slow for users.
            // To get around that we calculate the logarithm using `distanceFromTopLeftElement` which ends making
            // elements appear faster the further away from the top left element.
            var delay = Math.ceil(Math.log(distanceFromTopLeftElement + 1) * delayStep * 1.5) || 0;
            return {
                delay: delay,
                isReady: isReady,
                ref: function ref(element) {
                    return elementRefs.current[index] = element;
                }
            };
        }
    }, children);
};
var $ad83d708a15a323e$export$2e2bcd8739ae039 = $ad83d708a15a323e$var$StaggeredEntrance;

});
parcelRegister("8MEil", function(module, exports) {
$parcel$export(module.exports, "default", () => $66521027fcd86d91$export$2e2bcd8739ae039);
/**
 * An empty function which does nothing.
 */ function $66521027fcd86d91$export$2e2bcd8739ae039() {}

});

parcelRegister("SIQkH", function(module, exports) {
$parcel$export(module.exports, "useUniqueId", () => $0a47d42961a6a5a3$export$c485849f2e393253);
/* eslint-disable @repo/internal/react/disallow-unstable-values */ 
var $5FkrB = parcelRequire("5FkrB");
function $0a47d42961a6a5a3$export$c485849f2e393253() {
    var identifier = (0, $5FkrB.useRef)('');
    if (!identifier.current) identifier.current = '_' + (Number(String(Math.random()).slice(2)) + Date.now() + Math.round(performance.now())).toString(36);
    return identifier.current;
}

});




parcelRegister("aUIJy", function(module, exports) {
$parcel$export(module.exports, "layers", () => $7f21d5897794264e$export$7be255094ccdc533);

var $esSRg = parcelRequire("esSRg");

var $WJSRq = parcelRequire("WJSRq");
var $7f21d5897794264e$export$44ffba16bd48dac6 = '__ATLASKIT_THEME__';
var $7f21d5897794264e$export$c93026a968943f95 = 'light';
var $7f21d5897794264e$export$6ba72c8346b4c57e = [
    'light',
    'dark'
];
var $7f21d5897794264e$export$8e24544ddba725ee = function focusRing() {
    var color = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "var(--ds-border-focused, ".concat((0, $WJSRq.B200), ")");
    var outlineWidth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
    (0, $esSRg.default)('@atlaskit/theme', 'focus ring mixin', 'Please use `@atlaskit/focus-ring` instead.');
    return "\n  &:focus {\n    outline: none;\n    box-shadow: 0px 0px 0px ".concat(outlineWidth, "px ").concat(color, ";\n  }\n");
};
var $7f21d5897794264e$export$c0dd343266bc3261 = function noFocusRing() {
    return "\n  box-shadow: none;\n";
};
var $7f21d5897794264e$export$7be255094ccdc533 = {
    card: function card() {
        return 100;
    },
    navigation: function navigation() {
        return 200;
    },
    dialog: function dialog() {
        return 300;
    },
    layer: function layer() {
        return 400;
    },
    blanket: function blanket() {
        return 500;
    },
    modal: function modal() {
        return 510;
    },
    flag: function flag() {
        return 600;
    },
    spotlight: function spotlight() {
        return 700;
    },
    tooltip: function tooltip() {
        return 9999;
    }
};
var $7f21d5897794264e$export$a1b3edb637fb4f35 = function visuallyHidden() {
    (0, $esSRg.default)('@atlaskit/theme', 'visually hidden mixin', 'Please use `@atlaskit/visually-hidden` instead.');
    return {
        border: '0 !important',
        clip: 'rect(1px, 1px, 1px, 1px) !important',
        height: '1px !important',
        overflow: 'hidden !important',
        padding: '0 !important',
        position: 'absolute !important',
        width: '1px !important',
        whiteSpace: 'nowrap !important'
    };
};
var $7f21d5897794264e$export$ba1d834b86d72a09 = $7f21d5897794264e$export$a1b3edb637fb4f35;
var $7f21d5897794264e$export$e497e856b4f89fcd = function skeletonShimmer() {
    return {
        css: {
            backgroundColor: "var(--ds-skeleton, ".concat((0, $WJSRq.N20A), ")"),
            animationDuration: '1.5s',
            animationIterationCount: 'infinite',
            animationTimingFunction: 'linear',
            animationDirection: 'alternate'
        },
        keyframes: {
            from: {
                backgroundColor: "var(--ds-skeleton, ".concat((0, $WJSRq.N20A), ")")
            },
            to: {
                backgroundColor: "var(--ds-skeleton-subtle, ".concat((0, $WJSRq.N30A), ")")
            }
        }
    };
};

});
parcelRegister("esSRg", function(module, exports) {
$parcel$export(module.exports, "default", () => $a87e3be947e25f76$export$2e2bcd8739ae039);

var $g6ooQ = parcelRequire("g6ooQ");

var $3ZMUU = parcelRequire("3ZMUU");
function $a87e3be947e25f76$export$2e2bcd8739ae039(packageName, api, additionalMessage) {
    (0, $g6ooQ.default)("[".concat(packageName, "]: The ").concat(api, " is deprecated.").concat(additionalMessage && " ".concat(additionalMessage)));
}
function $a87e3be947e25f76$export$eb1decd851a5ae56(packageName, propName, predicate, deprecationAnnouncementOnDAC) {
    typeof $3ZMUU;
}

});
parcelRegister("g6ooQ", function(module, exports) {
$parcel$export(module.exports, "default", () => $bb90222d7af668ba$export$2e2bcd8739ae039);
/* eslint-disable no-console */ var $bb90222d7af668ba$var$printed = {};
function $bb90222d7af668ba$export$2e2bcd8739ae039(message) {
    if ($bb90222d7af668ba$var$printed[message]) return;
    $bb90222d7af668ba$var$printed[message] = true;
    if (typeof window !== 'undefined') console.warn(message);
}

});


parcelRegister("WJSRq", function(module, exports) {
$parcel$export(module.exports, "B200", () => $0b090278a4d21d1a$export$215b7063051591f1);
$parcel$export(module.exports, "N20A", () => $0b090278a4d21d1a$export$8d43898f60b96a82);
$parcel$export(module.exports, "N30A", () => $0b090278a4d21d1a$export$920c0d5c49070351);
// Reds
var $0b090278a4d21d1a$export$4b84fd0e2c617bd = '#FFEBE6';
var $0b090278a4d21d1a$export$b34b069eff244586 = '#FFBDAD';
var $0b090278a4d21d1a$export$be802dd0d8b57f35 = '#FF8F73';
var $0b090278a4d21d1a$export$60847d42f9da92a6 = '#FF7452';
var $0b090278a4d21d1a$export$4a7404f376229999 = '#FF5630';
var $0b090278a4d21d1a$export$2010d0fb4295b346 = '#DE350B';
var $0b090278a4d21d1a$export$2837b5a1a71d5c02 = '#BF2600';
var $0b090278a4d21d1a$export$8d9596b529bbb9cf = '#FFFAE6';
var $0b090278a4d21d1a$export$41060a744ab0b7ae = '#FFF0B3';
var $0b090278a4d21d1a$export$1cc05bbbf340e559 = '#FFE380';
var $0b090278a4d21d1a$export$5aae31392d72caaa = '#FFC400';
var $0b090278a4d21d1a$export$c6930421db9fa514 = '#FFAB00';
var $0b090278a4d21d1a$export$59619663aa6500fb = '#FF991F';
var $0b090278a4d21d1a$export$874739ea9e379ab6 = '#FF8B00';
var $0b090278a4d21d1a$export$8a6341c32b6a3ee6 = '#E3FCEF';
var $0b090278a4d21d1a$export$69a3bf21b9686c2b = '#ABF5D1';
var $0b090278a4d21d1a$export$afbce1382ec95f73 = '#79F2C0';
var $0b090278a4d21d1a$export$747d86715d4175de = '#57D9A3';
var $0b090278a4d21d1a$export$940e1f69e873f202 = '#36B37E';
var $0b090278a4d21d1a$export$a49394138f7b8e85 = '#00875A';
var $0b090278a4d21d1a$export$6fa04827ac68a4fb = '#006644';
var $0b090278a4d21d1a$export$226de0355ed012f8 = '#DEEBFF';
var $0b090278a4d21d1a$export$8c13c2ee36917869 = '#B3D4FF';
var $0b090278a4d21d1a$export$ecfc1dff386a3e7a = '#4C9AFF';
var $0b090278a4d21d1a$export$215b7063051591f1 = '#2684FF';
var $0b090278a4d21d1a$export$e62e8919cca44969 = '#0065FF';
var $0b090278a4d21d1a$export$b3de0ae08da2ce64 = '#0052CC';
var $0b090278a4d21d1a$export$a6ee3d71bc067634 = '#0747A6';
var $0b090278a4d21d1a$export$67f15409e87642a1 = '#669DF1';
var $0b090278a4d21d1a$export$f0539dbc42dbb067 = '#8FB8F6';
var $0b090278a4d21d1a$export$363e4475840015bb = '#EAE6FF';
var $0b090278a4d21d1a$export$4b0a4417ed59760f = '#C0B6F2';
var $0b090278a4d21d1a$export$6011520a64d9a187 = '#998DD9';
var $0b090278a4d21d1a$export$a7175d4e9206bc80 = '#8777D9';
var $0b090278a4d21d1a$export$b48405b95304b5a1 = '#6554C0';
var $0b090278a4d21d1a$export$c71e4279dd54a18d = '#5243AA';
var $0b090278a4d21d1a$export$147899de772240ec = '#403294';
var $0b090278a4d21d1a$export$2cf711fe14c66f06 = '#E6FCFF';
var $0b090278a4d21d1a$export$7a8f4d33f6f9772c = '#B3F5FF';
var $0b090278a4d21d1a$export$776c9c497ef08533 = '#79E2F2';
var $0b090278a4d21d1a$export$69cb3ca10c1e330e = '#00C7E6';
var $0b090278a4d21d1a$export$9dc1ef0f3f48059b = '#00B8D9';
var $0b090278a4d21d1a$export$7c835c78b6fcdef8 = '#00A3BF';
var $0b090278a4d21d1a$export$6036577f95c3877e = '#008DA6';
var $0b090278a4d21d1a$export$29a4f05edc054374 = '#FFFFFF';
var $0b090278a4d21d1a$export$e655ef011c4aa1a2 = '#FAFBFC';
var $0b090278a4d21d1a$export$9fdfb749e33cdf97 = '#F4F5F7';
var $0b090278a4d21d1a$export$3e51e8f1440314ba = '#EBECF0';
var $0b090278a4d21d1a$export$1ce2d1575d444ceb = '#DFE1E6';
var $0b090278a4d21d1a$export$8754fc7e6d8b3000 = '#C1C7D0';
var $0b090278a4d21d1a$export$c2e91cbeada39b8b = '#B3BAC5';
var $0b090278a4d21d1a$export$5f71e19f3a7ad9de = '#A5ADBA';
var $0b090278a4d21d1a$export$eaa8c8a70ac22806 = '#97A0AF';
var $0b090278a4d21d1a$export$7c87d337fb91a97d = '#8993A4';
var $0b090278a4d21d1a$export$d6447c357493214f = '#7A869A';
var $0b090278a4d21d1a$export$f563ee71e9ee74cd = '#6B778C';
var $0b090278a4d21d1a$export$e2ef2124cf4024b1 = '#5E6C84';
var $0b090278a4d21d1a$export$eece5f492e429f08 = '#505F79';
var $0b090278a4d21d1a$export$c39c0fe0f26207ae = '#42526E';
var $0b090278a4d21d1a$export$7090862dc3038a9f = '#344563';
var $0b090278a4d21d1a$export$ad0bacf983b7ddaa = '#253858';
var $0b090278a4d21d1a$export$7d61b15e0da132af = '#172B4D';
var $0b090278a4d21d1a$export$fbda843f0a27fe96 = '#091E42';
var $0b090278a4d21d1a$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
var $0b090278a4d21d1a$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
var $0b090278a4d21d1a$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
var $0b090278a4d21d1a$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
var $0b090278a4d21d1a$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
var $0b090278a4d21d1a$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
var $0b090278a4d21d1a$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
var $0b090278a4d21d1a$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
var $0b090278a4d21d1a$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
var $0b090278a4d21d1a$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
var $0b090278a4d21d1a$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
var $0b090278a4d21d1a$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
var $0b090278a4d21d1a$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
var $0b090278a4d21d1a$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
var $0b090278a4d21d1a$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
var $0b090278a4d21d1a$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
var $0b090278a4d21d1a$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
var $0b090278a4d21d1a$export$2f6319cf7d736c2a = '#E6EDFA';
var $0b090278a4d21d1a$export$95126bc8884d6634 = '#DCE5F5';
var $0b090278a4d21d1a$export$8338d8c35d44ff1 = '#CED9EB';
var $0b090278a4d21d1a$export$5368d76ae4fbbda7 = '#B8C7E0';
var $0b090278a4d21d1a$export$9f0a771d16ec8d36 = '#ABBBD6';
var $0b090278a4d21d1a$export$abcf8c38338b4aa5 = '#9FB0CC';
var $0b090278a4d21d1a$export$97e81faa16a182c7 = '#8C9CB8';
var $0b090278a4d21d1a$export$bfe21c59123ecf33 = '#7988A3';
var $0b090278a4d21d1a$export$ee82aa2ea6a1558 = '#67758F';
var $0b090278a4d21d1a$export$682927c6ed76be02 = '#56637A';
var $0b090278a4d21d1a$export$91fd9994c5be9757 = '#455166';
var $0b090278a4d21d1a$export$d281fbfe3cff2df6 = '#3B475C';
var $0b090278a4d21d1a$export$3902c91d8b98a753 = '#313D52';
var $0b090278a4d21d1a$export$8e8133c1ba5845b5 = '#283447';
var $0b090278a4d21d1a$export$33ff357f6620b39 = '#202B3D';
var $0b090278a4d21d1a$export$633847cf062b69e0 = '#1B2638';
var $0b090278a4d21d1a$export$9776a6e503bdbf76 = '#121A29';
var $0b090278a4d21d1a$export$6c813d5160dff5db = '#0E1624';
var $0b090278a4d21d1a$export$3d4f271a500072a = '#0D1424';
var $0b090278a4d21d1a$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
var $0b090278a4d21d1a$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
var $0b090278a4d21d1a$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
var $0b090278a4d21d1a$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
var $0b090278a4d21d1a$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
var $0b090278a4d21d1a$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
var $0b090278a4d21d1a$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
var $0b090278a4d21d1a$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
var $0b090278a4d21d1a$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
var $0b090278a4d21d1a$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
var $0b090278a4d21d1a$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
var $0b090278a4d21d1a$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
var $0b090278a4d21d1a$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
var $0b090278a4d21d1a$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
var $0b090278a4d21d1a$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
var $0b090278a4d21d1a$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
var $0b090278a4d21d1a$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';
var $0b090278a4d21d1a$export$d2adc5dedf09fced = '#292A2E';
var $0b090278a4d21d1a$export$f51762073d2bb381 = '#94C748';
var $0b090278a4d21d1a$export$95e26d54def96891 = '#B3DF72';

});


parcelRegister("avtsZ", function(module, exports) {
$parcel$export(module.exports, "register", () => $7a63a81593860c81$export$6503ec6e8aabbaf);
/* eslint-disable @atlaskit/design-system/no-direct-use-of-web-platform-drag-and-drop */ /**
 * We are listening directly to drag events instead of using a monitor from
 * `@atlaskit/pragmatic-drag-and-drop` to avoid the bundle size cost, as it
 * would affect almost every view in every app.
 *
 * We can reconsider this choice in the future.
 */ 
var $7QpUe = parcelRequire("7QpUe");
var $7a63a81593860c81$var$registrations = new Set();
var $7a63a81593860c81$var$cleanupEndEventListeners = null;
function $7a63a81593860c81$var$onDragStart() {
    if ($7a63a81593860c81$var$cleanupEndEventListeners) // If the cleanup function exists then we've already run this
    return;
    $7a63a81593860c81$var$cleanupEndEventListeners = (0, $7QpUe.bindAll)(window, [
        {
            type: 'dragend',
            listener: $7a63a81593860c81$var$onDragEnd
        },
        {
            type: 'pointerdown',
            listener: $7a63a81593860c81$var$onDragEnd
        },
        {
            type: 'pointermove',
            listener: function() {
                var callCount = 0;
                return function listener() {
                    // Using 20 as it is far bigger than the most observed (3)
                    if (callCount < 20) {
                        callCount++;
                        return;
                    }
                    $7a63a81593860c81$var$onDragEnd();
                };
            }()
        }
    ]);
    var clone = Array.from($7a63a81593860c81$var$registrations);
    clone.forEach(function(subscriber) {
        subscriber.onDragStart();
    });
}
function $7a63a81593860c81$var$onDragEnd() {
    var _cleanupEndEventListe;
    (_cleanupEndEventListe = $7a63a81593860c81$var$cleanupEndEventListeners) === null || _cleanupEndEventListe === void 0 || _cleanupEndEventListe();
    $7a63a81593860c81$var$cleanupEndEventListeners = null;
    var clone = Array.from($7a63a81593860c81$var$registrations);
    clone.forEach(function(subscriber) {
        subscriber.onDragEnd();
    });
}
function $7a63a81593860c81$var$bindStartEvents() {
    return (0, $7QpUe.bindAll)(window, [
        {
            type: 'dragstart',
            listener: $7a63a81593860c81$var$onDragStart
        },
        {
            type: 'dragenter',
            listener: $7a63a81593860c81$var$onDragStart
        }
    ]);
}
var $7a63a81593860c81$var$cleanupStartEventListeners = null;
function $7a63a81593860c81$export$6503ec6e8aabbaf(registration) {
    // if first registration, bind event listeners
    if (!$7a63a81593860c81$var$cleanupStartEventListeners) // note: currently never unbinding these event listeners
    $7a63a81593860c81$var$cleanupStartEventListeners = $7a63a81593860c81$var$bindStartEvents();
    $7a63a81593860c81$var$registrations.add(registration);
    /**
   * The reasoning for this behavior is so that if a tooltip mounts during
   * a drag it can still be suppressed.
   *
   * We use a separate callback instead of onDragStart to avoid infinite loops.
   */ registration.onRegister({
        isDragging: $7a63a81593860c81$var$cleanupEndEventListeners !== null
    });
    return function unregister() {
        $7a63a81593860c81$var$registrations.delete(registration);
        if ($7a63a81593860c81$var$registrations.size === 0) {
            var _cleanupStartEventLis;
            (_cleanupStartEventLis = $7a63a81593860c81$var$cleanupStartEventListeners) === null || _cleanupStartEventLis === void 0 || _cleanupStartEventLis();
            $7a63a81593860c81$var$cleanupStartEventListeners = null;
        }
    };
}

});

parcelRegister("bRpWd", function(module, exports) {
$parcel$export(module.exports, "getMousePosition", () => $8a28c3ac215afee9$export$642213d516a9b928);
function $8a28c3ac215afee9$export$642213d516a9b928(mouseCoordinates) {
    var safeMouse = mouseCoordinates || {
        top: 0,
        left: 0
    };
    var getBoundingClientRect = function getBoundingClientRect() {
        return {
            top: safeMouse.top,
            left: safeMouse.left,
            bottom: safeMouse.top,
            right: safeMouse.left,
            width: 0,
            height: 0
        };
    };
    return {
        getBoundingClientRect: getBoundingClientRect,
        clientWidth: 0,
        clientHeight: 0
    };
}

});

parcelRegister("fiZuf", function(module, exports) {
$parcel$export(module.exports, "getVirtualElementFromMousePos", () => $b2483b7c01c77e85$export$2e68479e0a5d8746);
function $b2483b7c01c77e85$export$2e68479e0a5d8746(mousePos, _ref) {
    var targetElement = _ref.targetElement, tooltipPosition = _ref.tooltipPosition;
    if (tooltipPosition === 'mouse') return {
        getBoundingClientRect: function getBoundingClientRect() {
            return DOMRect.fromRect({
                x: mousePos.clientX,
                y: mousePos.clientY,
                width: 0,
                height: 0
            });
        }
    };
    var targetRect = targetElement.getBoundingClientRect();
    if (tooltipPosition === 'mouse-x') return {
        getBoundingClientRect: function getBoundingClientRect() {
            return DOMRect.fromRect({
                x: mousePos.clientX,
                y: targetRect.top,
                width: 0,
                height: targetRect.height
            });
        }
    };
    if (tooltipPosition === 'mouse-y') return {
        getBoundingClientRect: function getBoundingClientRect() {
            return DOMRect.fromRect({
                x: targetRect.left,
                y: mousePos.clientY,
                width: targetRect.width,
                height: 0
            });
        }
    };
    throw new Error("Invalid tooltip position for virtual element: ".concat(tooltipPosition));
}

});

parcelRegister("9Swrf", function(module, exports) {
$parcel$export(module.exports, "show", () => $731251c899343866$export$57bf213be019eeb0);

var $9Zzpd = parcelRequire("9Zzpd");

var $jB59F = parcelRequire("jB59F");
// This file is a singleton for managing tooltips
var $731251c899343866$var$active = null;
function $731251c899343866$export$57bf213be019eeb0(entry) {
    var phase = 'waiting-to-show';
    function isActive() {
        return Boolean($731251c899343866$var$active && $731251c899343866$var$active.entry === entry);
    }
    function cleanup() {
        if (isActive()) {
            (0, $jB59F.clearScheduled)();
            $731251c899343866$var$active = null;
        }
    }
    function done() {
        if (isActive()) entry.done();
        phase = 'done';
        cleanup();
    }
    function immediatelyHideAndDone() {
        if (isActive()) entry.hide({
            isImmediate: true
        });
        done();
    }
    function keep() {
        if (!isActive()) return;
        // aborting a wait to hide
        if (phase === 'waiting-to-hide') {
            phase = 'shown';
            (0, $jB59F.clearScheduled)();
            return;
        }
        // aborting hide animation
        if (phase === 'hide-animating') {
            phase = 'shown';
            (0, $jB59F.clearScheduled)();
            entry.show({
                isImmediate: false
            });
            return;
        }
    }
    function requestHide(_ref) {
        var isImmediate = _ref.isImmediate;
        if (!isActive()) return;
        // If we were not showing yet anyway; finish straight away
        if (phase === 'waiting-to-show') {
            immediatelyHideAndDone();
            return;
        }
        // already waiting to hide
        if (phase === 'waiting-to-hide') return;
        if (isImmediate) {
            immediatelyHideAndDone();
            return;
        }
        phase = 'waiting-to-hide';
        (0, $jB59F.scheduleTimeout)(function() {
            phase = 'hide-animating';
            entry.hide({
                isImmediate: false
            });
        }, entry.delay);
    }
    function finishHideAnimation() {
        if (isActive() && phase === 'hide-animating') done();
    }
    function isVisible() {
        return phase === 'shown' || phase === 'waiting-to-hide' || phase === 'hide-animating';
    }
    function getInitialMouse() {
        if (entry.source.type === 'mouse') return entry.source.mouse;
        return null;
    }
    function start() {
        var shouldAlwaysFadeIn = (0, $9Zzpd.fg)('platform_dst_nav4_side_nav_resize_tooltip_feedback') ? entry.shouldAlwaysFadeIn : false;
        var showImmediately = Boolean($731251c899343866$var$active && $731251c899343866$var$active.isVisible()) && !shouldAlwaysFadeIn;
        // If there was an active tooltip; we tell it to remove itself at once!
        if ($731251c899343866$var$active) {
            (0, $jB59F.clearScheduled)();
            $731251c899343866$var$active.entry.hide({
                isImmediate: true
            });
            $731251c899343866$var$active.entry.done();
            $731251c899343866$var$active = null;
        }
        // this tooltip is now the active tooltip
        $731251c899343866$var$active = {
            entry: entry,
            isVisible: isVisible
        };
        function show() {
            phase = 'shown';
            entry.show({
                isImmediate: showImmediately
            });
        }
        if (showImmediately) {
            show();
            return;
        }
        phase = 'waiting-to-show';
        (0, $jB59F.scheduleTimeout)(show, entry.delay);
    }
    // let's get started!
    start();
    var result = {
        keep: keep,
        abort: cleanup,
        isActive: isActive,
        requestHide: requestHide,
        finishHideAnimation: finishHideAnimation,
        // Removing old `mousePosition` behind gate because it stored a function.
        // With the gate we just store the coords which are easier to work with.
        mousePosition: (0, $9Zzpd.fg)('platform_dst_nav4_side_nav_resize_tooltip_feedback') ? undefined : getInitialMouse(),
        mousePos: entry.source.type === 'mouse' && (0, $9Zzpd.fg)('platform_dst_nav4_side_nav_resize_tooltip_feedback') ? {
            clientX: entry.source.clientX,
            clientY: entry.source.clientY
        } : null
    };
    return result;
}

});
parcelRegister("jB59F", function(module, exports) {
$parcel$export(module.exports, "clearScheduled", () => $e44578b4d511869e$export$eaf678f6f93f5250);
$parcel$export(module.exports, "scheduleTimeout", () => $e44578b4d511869e$export$5f4d6617421d489b);
var $e44578b4d511869e$var$delayId = null;
function $e44578b4d511869e$export$eaf678f6f93f5250() {
    if ($e44578b4d511869e$var$delayId != null) {
        window.clearTimeout($e44578b4d511869e$var$delayId);
        $e44578b4d511869e$var$delayId = null;
    }
}
function $e44578b4d511869e$export$5f4d6617421d489b(fn, delay) {
    $e44578b4d511869e$export$eaf678f6f93f5250();
    $e44578b4d511869e$var$delayId = window.setTimeout(function() {
        $e44578b4d511869e$var$delayId = null;
        fn();
    }, delay);
}

});


parcelRegister("7B4ig", function(module, exports) {
$parcel$export(module.exports, "default", () => $587f51bd4d18a642$export$2e2bcd8739ae039);

var $gqyzS = parcelRequire("gqyzS");
function $587f51bd4d18a642$export$2e2bcd8739ae039(prefix, shouldRenderId) {
    var seed = (0, $gqyzS.useIdSeed)();
    return shouldRenderId ? "".concat(seed(prefix)) : undefined;
}

});
parcelRegister("gqyzS", function(module, exports) {
$parcel$export(module.exports, "useIdSeed", () => $bf59e57387f8fcb4$export$6ee17796e3d70de2);

var $ekGgq = parcelRequire("ekGgq");

var $5FkrB = parcelRequire("5FkrB");
function $bf59e57387f8fcb4$export$f680877a34711e37() {
    // React uses `:` or `«»` in selectors which breaks `document.querySelector(…)`.
    // Replace with `_` to match future React 19 functionality.
    return (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).useId().replace(/[:«»]/g, '_');
}
var $bf59e57387f8fcb4$export$6be90bcb437e928f = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function(_ref, ref) {
    var children = _ref.children, _ref$postfix = _ref.postfix, postfix = _ref$postfix === void 0 ? '' : _ref$postfix, _ref$prefix = _ref.prefix, prefix = _ref$prefix === void 0 ? '' : _ref$prefix;
    var id = "".concat(prefix).concat($bf59e57387f8fcb4$export$f680877a34711e37()).concat(postfix);
    (0, $5FkrB.useEffect)(function() {
        if (!ref) return;
        switch((0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(ref)){
            case 'function':
                ref(id);
                break;
            case 'object':
                ref.current = id;
                break;
            default:
                throw new Error("Unreachable case for unsupported type of ref \"".concat((0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(ref), "\""));
        }
    }, [
        id,
        ref
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).Fragment, null, typeof children === 'function' ? children({
        id: id
    }) : children);
});
function $bf59e57387f8fcb4$export$6ee17796e3d70de2() {
    var uid = $bf59e57387f8fcb4$export$f680877a34711e37();
    return function(id) {
        return "".concat(uid, "-").concat(id.toString());
    };
}

});


parcelRegister("4enDs", function(module, exports) {
$parcel$export(module.exports, "default", () => $314acdb9eb7ef066$export$2e2bcd8739ae039);
/* tooltip-container.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $5FkrB = parcelRequire("5FkrB");

var $1wIML = parcelRequire("1wIML");

var $dOvtu = parcelRequire("dOvtu");
var $314acdb9eb7ef066$var$styles = {
    base: "_2rkofajl _11c8wadc _vchhusvi _p12fp3fh _bfhk1aqn _syaz15cr _152tze3t _1e02ze3t _1i4q1hna _1q511b66 _85i51b66 _y4ti12x7 _bozg12x7 _slp31hna",
    truncate: "_1reo15vq _18m915vq _p12f1pna _1bto1l2s _o5721q9c"
};
/**
 * Used as the default tooltip container component for the exported `Tooltip` component.
 * Adds some styles to the tooltip primitive.
 */ var $314acdb9eb7ef066$var$TooltipContainer = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function TooltipContainer(_ref, ref) {
    var style = _ref.style, className = _ref.className, children = _ref.children, truncate = _ref.truncate, placement = _ref.placement, testId = _ref.testId, onMouseOut = _ref.onMouseOut, onMouseOver = _ref.onMouseOver, id = _ref.id, shortcut = _ref.shortcut;
    return /*#__PURE__*/ $5FkrB.createElement((0, $dOvtu.default), {
        ref: ref,
        style: style,
        className: (0, $1wIML.default)([
            $314acdb9eb7ef066$var$styles.base,
            truncate && $314acdb9eb7ef066$var$styles.truncate,
            className
        ]),
        placement: placement,
        testId: testId,
        id: id,
        onMouseOut: onMouseOut,
        onMouseOver: onMouseOver,
        shortcut: shortcut
    }, children);
});
$314acdb9eb7ef066$var$TooltipContainer.displayName = 'TooltipContainer';
var $314acdb9eb7ef066$export$2e2bcd8739ae039 = $314acdb9eb7ef066$var$TooltipContainer;

});
parcelRegister("dOvtu", function(module, exports) {
$parcel$export(module.exports, "default", () => $a0e85c130006b7fa$export$2e2bcd8739ae039);
/* tooltip-primitive.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $5FkrB = parcelRequire("5FkrB");

var $1wIML = parcelRequire("1wIML");

var $br813 = parcelRequire("br813");
var $a0e85c130006b7fa$var$primitiveStyles = null;
/**
 * The lower level component for rendering a tooltip.
 */ var $a0e85c130006b7fa$var$TooltipPrimitive = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function TooltipPrimitive(_ref, ref) {
    var style = _ref.style, className = _ref.className, children = _ref.children, placement = _ref.placement, testId = _ref.testId, onMouseOut = _ref.onMouseOut, onMouseOver = _ref.onMouseOver, id = _ref.id, shortcut = _ref.shortcut;
    return /*#__PURE__*/ $5FkrB.createElement("div", {
        ref: ref,
        style: style,
        "data-testid": testId ? "".concat(testId, "--wrapper") : undefined
    }, /*#__PURE__*/ $5FkrB.createElement("div", {
        role: "tooltip",
        className: (0, $1wIML.default)([
            "_80om73ad",
            className
        ]),
        onMouseOut: onMouseOut,
        onMouseOver: onMouseOver,
        "data-placement": placement,
        "data-testid": testId,
        id: id
    }, children, shortcut && /*#__PURE__*/ $5FkrB.createElement((0, $br813.TooltipShortcut), {
        shortcut: shortcut
    })));
});
$a0e85c130006b7fa$var$TooltipPrimitive.displayName = 'TooltipPrimitive';
var $a0e85c130006b7fa$export$2e2bcd8739ae039 = $a0e85c130006b7fa$var$TooltipPrimitive;

});
parcelRegister("br813", function(module, exports) {
$parcel$export(module.exports, "TooltipShortcut", () => $85386f276256a369$export$5bcbc43c84236222);
/* tooltip-shortcut.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $5FkrB = parcelRequire("5FkrB");

var $1wIML = parcelRequire("1wIML");
var $85386f276256a369$var$styles = {
    shortcutSegmentsContainer: "_zulpv77o _1e0c1txw _1q511b66 _85i5v77o",
    shortcutSegment: "_11c8wadc _2rkolb4i _1dqonqa1 _189ee4h9 _1h6d1ihb _1e0c1txw _4cvr1h6o _4t3i1k92 _vchhusvi _1q51v77o _85i5v77o _bozg12x7 _y4ti12x7 _16qsn7od _1254n7od _cgnln7od _syazn7od _ahbqn7od _12l2n7od _1pfhn7od _6rthn7od _1ul9n7od _w19jn7od _bfhk261p"
};
var $85386f276256a369$export$5bcbc43c84236222 = function TooltipShortcut(_ref) {
    var shortcut = _ref.shortcut;
    return /*#__PURE__*/ $5FkrB.createElement("div", {
        className: (0, $1wIML.default)([
            $85386f276256a369$var$styles.shortcutSegmentsContainer
        ])
    }, shortcut.map(function(segment, index) {
        return /*#__PURE__*/ $5FkrB.createElement("kbd", {
            key: "".concat(segment, "-").concat(index),
            className: (0, $1wIML.default)([
                $85386f276256a369$var$styles.shortcutSegment
            ])
        }, segment);
    }));
};

});




parcelRegister("jJH6F", function(module, exports) {
$parcel$export(module.exports, "EVENT_TYPE", () => $e5e3a854a8f07017$export$76a2e4c433c23bb9);
$parcel$export(module.exports, "ACTION", () => $e5e3a854a8f07017$export$9523889e0a5da4ba);
$parcel$export(module.exports, "INPUT_METHOD", () => $e5e3a854a8f07017$export$85f107b1fcc9d96f);
$parcel$export(module.exports, "ACTION_SUBJECT", () => $e5e3a854a8f07017$export$7525482b5931e326);
$parcel$export(module.exports, "ACTION_SUBJECT_ID", () => $e5e3a854a8f07017$export$9957974f8b4d8f74);
var $e5e3a854a8f07017$export$76a2e4c433c23bb9 = /*#__PURE__*/ function(EVENT_TYPE) {
    EVENT_TYPE["OPERATIONAL"] = "operational";
    EVENT_TYPE["SCREEN"] = "screen";
    EVENT_TYPE["TRACK"] = "track";
    EVENT_TYPE["UI"] = "ui";
    return EVENT_TYPE;
}({});
var $e5e3a854a8f07017$export$9523889e0a5da4ba = /*#__PURE__*/ function(ACTION) {
    ACTION["ACTIONED"] = "actioned";
    ACTION["ACTIVATED"] = "activated";
    ACTION["ADDED"] = "added";
    ACTION["API_ERROR"] = "apiError";
    ACTION["API_RECEIVED"] = "apiReceived";
    ACTION["API_PURGED"] = "apiPurged";
    ACTION["BROWSER_FREEZE"] = "browserFreeze";
    ACTION["CANCELLED"] = "cancelled";
    ACTION["CAUGHT_DOM_ERROR"] = "caughtDomError";
    ACTION["CHANGED_BACKGROUND_COLOR"] = "changedBackgroundColor";
    ACTION["CHANGED_ICON"] = "changedIcon";
    ACTION["CHANGED_FULL_WIDTH_MODE"] = "changedFullWidthMode";
    ACTION["CHANGED_LAYOUT"] = "changedLayout";
    ACTION["CHANGED_BREAKOUT_MODE"] = "changedBreakoutMode";
    ACTION["CHANGED_REPLACEMENT_TEXT"] = "changedReplacementText";
    ACTION["CHANGED_TYPE"] = "changedType";
    ACTION["CHANGED_URL"] = "changedUrl";
    ACTION["CLEARED"] = "cleared";
    ACTION["CLICK"] = "click";
    ACTION["CLICKED"] = "clicked";
    ACTION["CLOSED"] = "closed";
    ACTION["COMMITTED"] = "committed";
    /** used in @atlassian/editor-referentiality */ ACTION["CONNECTED_NODES"] = "connectedNodes";
    ACTION["CONVERTED"] = "converted";
    ACTION["COPIED"] = "copied";
    ACTION["COPY_FAILED"] = "copyFailed";
    ACTION["CUT"] = "cut";
    ACTION["DEACTIVATED"] = "deactivated";
    ACTION["DECREMENTED"] = "decremented";
    ACTION["DELETED"] = "deleted";
    ACTION["DISCARDED_INVALID_STEPS_FROM_TRANSACTION"] = "discardedInvalidStepsFromTransaction";
    ACTION["DISCARDED"] = "discarded";
    /** used in @atlassian/editor-referentiality */ ACTION["DISCONNECTED_SOURCE"] = "disconnectedSource";
    /** used in @atlassian/editor-referentiality */ ACTION["DISCONNECTED_TARGET"] = "disconnectedTarget";
    ACTION["DISMISSED"] = "dismissed";
    ACTION["DISPLAYED"] = "displayed";
    ACTION["DISPATCHED_INVALID_TRANSACTION"] = "dispatchedInvalidTransaction";
    ACTION["DISPATCHED_VALID_TRANSACTION"] = "dispatchedValidTransaction";
    ACTION["DOUBLE_CLICKED"] = "doubleClicked";
    ACTION["DRAGGED"] = "dragged";
    ACTION["EDITED"] = "edited";
    ACTION["EDITOR_CRASHED"] = "unhandledErrorCaught";
    ACTION["EDITOR_CRASHED_ADDITIONAL_INFORMATION"] = "unhandledErrorCaughtAdditionalInfov2";
    ACTION["EDITOR_MOUNTED"] = "mounted";
    ACTION["EDITOR_CONTENT_RETRIEVAL_PERFORMED"] = "contentRetrievalPerformed";
    ACTION["RE_RENDERED"] = "reRendered";
    ACTION["ENDED"] = "ended";
    ACTION["ENTERED"] = "entered";
    ACTION["ERROR"] = "error";
    ACTION["ERRORED"] = "errored";
    ACTION["EXPERIENCE_MEASURED"] = "experienceMeasured";
    ACTION["EXPERIENCE_SAMPLED"] = "experienceSampled";
    ACTION["EXPOSED"] = "exposed";
    ACTION["FETCHED"] = "fetched";
    ACTION["FAILED_TO_UNMOUNT"] = "failedToUnmount";
    ACTION["FAILED_TO_INSERT"] = "failedToInsert";
    ACTION["FIND_NEXT_PERFORMED"] = "findNextPerformed";
    ACTION["FIND_PERFORMED"] = "findPerformed";
    ACTION["FIND_PREV_PERFORMED"] = "findPrevPerformed";
    ACTION["UNDO_PERFORMED"] = "undo";
    ACTION["REDO_PERFORMED"] = "redo";
    ACTION["FORMATTED"] = "formatted";
    ACTION["HELP_OPENED"] = "helpOpened";
    ACTION["HIGHLIGHTED"] = "highlighted";
    ACTION["INCREMENTED"] = "incremented";
    ACTION["INDENTED"] = "indented";
    ACTION["INITIALISED"] = "initialised";
    ACTION["INITIATED"] = "initiated";
    /** used in @atlassian/editor-referentiality */ ACTION["INITIALISED_FRAGMENT_MARK"] = "initialisedFragmentMark";
    ACTION["INPUT_PERF_SAMPLING"] = "inputPerfSampling";
    ACTION["INPUT_PERF_SAMPLING_AVG"] = "inputPerfSamplingAvg";
    ACTION["INSERTED"] = "inserted";
    ACTION["INVALID_DOCUMENT_ENCOUNTERED"] = "invalidDocumentEncountered";
    ACTION["INVOKED"] = "invoked";
    /** used in @atlassian/editor-referentiality */ ACTION["GOT_CONNECTIONS"] = "gotConnections";
    ACTION["LANGUAGE_SELECTED"] = "languageSelected";
    ACTION["LIST_ITEM_JOINED"] = "listItemJoined";
    ACTION["MATCHED"] = "matched";
    ACTION["MEDIA_LINK_TRANSFORMED"] = "mediaLinkTransformed";
    ACTION["NODE_CONTENT_SANITIZED"] = "nodeContentSanitized";
    ACTION["OFFLINE_STORAGE_TOO_MANY_RETRIES_ERROR"] = "offlineStorageTooManyRetriesError";
    ACTION["OFFLINE_STORAGE_FAILED_STEPS"] = "offlineStorageFailedSteps";
    ACTION["OFFLINE_STORAGE_STEPS_DATABASE_ERROR"] = "offlineStorageStepsDatabaseError";
    ACTION["OFFLINE_STORAGE_RESYNC_ONLINE"] = "offlineStorageResyncOnline";
    ACTION["OFFLINE_STORAGE_BROADCAST_CHANNEL_FIRST_UPDATE"] = "offlineStorageBroadcastChannelFirstUpdate";
    ACTION["OFFLINE_STORAGE_RESTORE_STEPS_INITIATED"] = "offlineStorageRestoreStepsInitiated";
    ACTION["OPENED"] = "opened";
    ACTION["OUTDENTED"] = "outdented";
    ACTION["PASTED"] = "pasted";
    ACTION["PASTED_AS_PLAIN"] = "pastedAsPlain";
    ACTION["PASTED_TIMED"] = "pastedTimed";
    ACTION["PRESSED"] = "pressed";
    ACTION["PROSEMIRROR_RENDERED"] = "proseMirrorRendered";
    ACTION["REACT_NODEVIEW_RENDERED"] = "reactNodeViewRendered";
    ACTION["REFERENCE_SYNCED_BLOCK_DELETE"] = "referenceSyncedBlockDelete";
    ACTION["REFERENCE_SYNCED_BLOCK_UPDATE"] = "referenceSyncedBlockUpdate";
    ACTION["REFERENCE_SYNCED_BLOCK_UNSYNC"] = "referenceSyncedBlockUnsync";
    ACTION["REFERENCE_SYNCED_BLOCK_COPY"] = "referenceSyncedBlockCopy";
    ACTION["REPLACED_ALL"] = "replacedAll";
    ACTION["REPLACED_ONE"] = "replacedOne";
    ACTION["RESOLVED"] = "resolved";
    ACTION["REQUEST_TO_EDIT"] = "requestToEdit";
    ACTION["SELECTED"] = "selected";
    ACTION["SHOWN"] = "shown";
    ACTION["SLOW_INPUT"] = "slowInput";
    ACTION["STARTED"] = "started";
    ACTION["STOPPED"] = "stopped";
    ACTION["SUBMITTED"] = "submitted";
    ACTION["SUBSTITUTED"] = "autoSubstituted";
    ACTION["SYNCED_BLOCK_CREATE"] = "syncedBlockCreate";
    ACTION["SYNCED_BLOCK_UPDATE"] = "syncedBlockUpdate";
    ACTION["SYNCED_BLOCK_FETCH"] = "syncedBlockFetch";
    ACTION["SYNCED_BLOCK_FETCH_REFERENCES"] = "syncedBlockFetchReferences";
    ACTION["SYNCED_BLOCK_DELETE"] = "syncedBlockDelete";
    ACTION["SYNCED_BLOCK_GET_SOURCE_INFO"] = "syncedBlockGetSourceInfo";
    ACTION["SYNCED_BLOCK_UNSYNC"] = "syncedBlockUnsync";
    ACTION["SYNCED_BLOCK_EDIT_SOURCE"] = "syncedBlockEditSource";
    ACTION["SYNCED_BLOCK_VIEW_SYNCED_LOCATIONS"] = "syncedBlockViewSyncedLocations";
    ACTION["SYNCHRONY_DISCONNECTED"] = "synchronyDisconnected";
    ACTION["SYNCHRONY_ENTITY_ERROR"] = "synchronyEntityError";
    ACTION["SYNCHRONY_ERROR"] = "synchronyError";
    ACTION["TEXT_LINK_MARK_TRANSFORMED"] = "textLinkMarkTransformed";
    ACTION["TOGGLED"] = "toggled";
    ACTION["TRIGGERED"] = "triggered";
    ACTION["DEDUPE_MARKS_TRANSFORMED_V2"] = "dedupeMarksTransformedV2";
    ACTION["NODES_MISSING_CONTENT_TRANSFORMED"] = "nodesMissingContentTransformed";
    ACTION["INDENTATION_MARKS_TRANSFORMED"] = "indentationMarksTransformed";
    ACTION["INVALID_MEDIA_CONTENT_TRANSFORMED"] = "invalidMediaContentTransformed";
    ACTION["TOGGLE_EXPAND"] = "toggleExpand";
    ACTION["TRANSACTION_MUTATED_AFTER_DISPATCH"] = "transactionMutatedAfterDispatched";
    ACTION["TYPING_FINISHED"] = "typingFinished";
    ACTION["TYPING_STARTED"] = "typingStarted";
    ACTION["UNHANDLED_ERROR_CAUGHT"] = "unhandledErrorCaught";
    ACTION["UNLINK"] = "unlinked";
    ACTION["UNSUPPORTED_CONTENT_ENCOUNTERED"] = "unsupportedContentEncounteredV2";
    ACTION["UPDATED"] = "updated";
    /** used in @atlassian/editor-referentiality */ ACTION["UPDATED_FRAGMENT_MARK_NAME"] = "updatedFragmentMarkName";
    /** used in @atlassian/editor-referentiality */ ACTION["UPDATED_SOURCE"] = "updatedSource";
    /** used in @atlassian/editor-referentiality */ ACTION["UPDATED_TARGET"] = "updatedTarget";
    ACTION["UPLOAD_EXTERNAL_FAIL"] = "uploadExternalFailed";
    ACTION["VIEWED"] = "viewed";
    ACTION["VISITED"] = "visited";
    ACTION["WITH_PLUGIN_STATE_CALLED"] = "withPluginStateCalled";
    ACTION["RENDERED"] = "rendered";
    ACTION["RENDERED_SAMPLED"] = "renderedSampled";
    ACTION["ON_EDITOR_READY_CALLBACK"] = "onEditorReadyCallback";
    /**
   * @private
   * @deprecated
   *
   * This is no longer used and can be removed at a later date
   */ ACTION["ON_CHANGE_CALLBACK"] = "onChangeCalled";
    ACTION["NESTED_TABLE_TRANSFORMED"] = "nestedTableTransformed";
    ACTION["NATIVE_EMBEDS_TRANSFORMED"] = "nativeEmbedsTransformed";
    ACTION["NEW_COLLAB_SYNC_UP_ERROR_NO_STEPS"] = "newCollabSyncUpErrorNoSteps";
    ACTION["REMOVE_ICON"] = "removedIcon";
    ACTION["INVALID_PROSEMIRROR_DOCUMENT"] = "invalidProsemirrorDocument";
    ACTION["DOCUMENT_PROCESSING_ERROR"] = "documentProcessingErrorV2";
    ACTION["CRASHED"] = "unhandledErrorCaughtV2";
    ACTION["SELECT_ALL_CAUGHT"] = "selectAllCaught";
    ACTION["SELECT_ALL_ESCAPED"] = "selectAllEscaped";
    ACTION["SORT_COLUMN"] = "sortedColumn";
    ACTION["SORT_COLUMN_NOT_ALLOWED"] = "sortColumnNotAllowed";
    // remove this enum when cleaning up platform_editor_remove_collab_step_metrics
    ACTION["NCS_SESSION_STEP_METRICS"] = "ncsSessionStepMetrics";
    ACTION["STEPS_TRACKED"] = "stepsTracked";
    ACTION["ORGANIC_CHANGES_TRACKED"] = "organicChangesTracked";
    ACTION["STEPS_FILTERED"] = "stepsFiltered";
    ACTION["CREATE_NOT_ALLOWED"] = "createNotAllowed";
    ACTION["UNSUPPORTED_CONTENT_LEVELS_TRACKING_SUCCEEDED"] = "unsupportedContentLevelsTrackingSucceeded";
    ACTION["UNSUPPORTED_CONTENT_LEVELS_TRACKING_ERRORED"] = "unsupportedContentLevelsTrackingErrored";
    ACTION["UNSUPPORTED_TOOLTIP_VIEWED"] = "viewed";
    ACTION["RECORD_VIDEO"] = "recordVideo";
    ACTION["INSERT_VIDEO"] = "insertVideo";
    ACTION["RECORD_VIDEO_FAILED"] = "recordVideoFailed";
    ACTION["ADD_CHILD"] = "addChild";
    ACTION["CHANGE_ACTIVE"] = "changeActive";
    ACTION["REMOVE_CHILD"] = "removeChild";
    ACTION["UPDATE_PARAMETERS"] = "updateParameters";
    ACTION["GET_CHILDREN"] = "getChildren";
    ACTION["GET_CHILDREN_CONTAINER"] = "getChildrenContainer";
    ACTION["MOVED"] = "moved";
    ACTION["UPLOAD_COMMENCED"] = "uploadCommenced";
    ACTION["UPLOAD_SUCCEEDED"] = "uploadSucceeded";
    ACTION["UPLOAD_FAILED"] = "uploadFailed";
    ACTION["TOGGLE_CODE_BLOCK_WRAP"] = "toggleCodeBlockWrap";
    ACTION["TRANSFORMED"] = "transformed";
    ACTION["RESIZED"] = "resized";
    ACTION["RESIZED_PERF_SAMPLING"] = "resizedPerfSampling";
    ACTION["BLOCKS_DRAG_INIT"] = "blocksDragInit";
    ACTION["SINGLE_COL_LAYOUT_DETECTED"] = "singleColumLayoutDetected";
    ACTION["VIEW_MORE"] = "viewMore";
    ACTION["LOCAL_ID_NOT_FOUND"] = "localIdNotFound";
    ACTION["NO_DOC_CHANGE_FOUND"] = "noDocChangeFound";
    ACTION["INVALID_COMMAND_FOUND"] = "invalidCommandFound";
    ACTION["MEDIA_SINGLE_WIDTH_TRANSFORMED"] = "mediaSingleWidthTransformed";
    /**
   * used in Editor AI inline suggestion for a track event when a suggestion is inserted
   * previously tracked events being used by Editor AI proactive suggestion
   *
   */ ACTION["SUGGESTION_INSERTED"] = "suggestionInserted";
    ACTION["SUGGESTION_DISMISSED"] = "suggestionDismissed";
    ACTION["SUGGESTION_VIEWED"] = "suggestionViewed";
    ACTION["TABLE_WIDTH_INFO"] = "tableWidthInformation";
    ACTION["SUPPRESSED"] = "suppressed";
    return ACTION;
}({});
var $e5e3a854a8f07017$export$85f107b1fcc9d96f = /*#__PURE__*/ function(INPUT_METHOD) {
    INPUT_METHOD["ASCII"] = "ascii";
    INPUT_METHOD["AUTO"] = "auto";
    INPUT_METHOD["AUTO_DETECT"] = "autoDetect";
    INPUT_METHOD["BUTTON"] = "button";
    INPUT_METHOD["BLUR"] = "blur";
    INPUT_METHOD["CARD"] = "card";
    INPUT_METHOD["CLIPBOARD"] = "clipboard";
    INPUT_METHOD["CONFIG_PANEL"] = "configPanel";
    INPUT_METHOD["CONTEXT_MENU"] = "contextMenu";
    INPUT_METHOD["DRAG_AND_DROP"] = "dragAndDrop";
    INPUT_METHOD["DRAG"] = "drag";
    INPUT_METHOD["EXTERNAL"] = "external";
    INPUT_METHOD["EXTENSION_API"] = "extensionApi";
    INPUT_METHOD["FLOATING_TB"] = "floatingToolbar";
    INPUT_METHOD["FORMATTING"] = "autoformatting";
    INPUT_METHOD["INSERT_MENU"] = "insertMenu";
    INPUT_METHOD["INSERT_MENU_RIGHT_RAIL"] = "insertMenuRightRail";
    INPUT_METHOD["KEYBOARD"] = "keyboard";
    INPUT_METHOD["MEDIA_PICKER"] = "mediaPicker";
    INPUT_METHOD["MACRO_BROWSER"] = "macroBrowser";
    INPUT_METHOD["MANUAL"] = "manual";
    INPUT_METHOD["PICKER"] = "picker";
    INPUT_METHOD["PICKER_CLOUD"] = "cloudPicker";
    INPUT_METHOD["PREFILL"] = "prefill";
    INPUT_METHOD["QUICK_INSERT"] = "quickInsert";
    INPUT_METHOD["SHORTCUT"] = "shortcut";
    INPUT_METHOD["TOOLBAR"] = "toolbar";
    INPUT_METHOD["TYPEAHEAD"] = "typeAhead";
    INPUT_METHOD["DATASOURCE"] = "datasource_config";
    INPUT_METHOD["TABLE_CONTEXT_MENU"] = "tableContextMenu";
    INPUT_METHOD["MOUSE"] = "mouse";
    INPUT_METHOD["BROWSER"] = "browser";
    INPUT_METHOD["DOUBLE_CLICK"] = "doubleClick";
    INPUT_METHOD["META_CLICK"] = "metaClick";
    INPUT_METHOD["INLINE_SUGGESTION_FLOATING_TB"] = "inlineSuggestionFloatingToolbar";
    INPUT_METHOD["SYNCED_BLOCK_TB"] = "syncedBlockToolbar";
    INPUT_METHOD["BLOCK_MENU"] = "blockMenu";
    INPUT_METHOD["SMART_LINK"] = "smartLink";
    INPUT_METHOD["ELEMENT_BROWSER"] = "elementBrowser";
    INPUT_METHOD["REMIX"] = "remix";
    return INPUT_METHOD;
}({});
var $e5e3a854a8f07017$export$9b31fa32ae3f8051 = /*#__PURE__*/ function(INSERT_MEDIA_VIA) {
    INSERT_MEDIA_VIA["LOCAL_UPLOAD"] = "localUpload";
    INSERT_MEDIA_VIA["EXTERNAL_URL"] = "externalUrl";
    INSERT_MEDIA_VIA["EXTERNAL_UPLOAD"] = "externalUpload";
    return INSERT_MEDIA_VIA;
}({});
var $e5e3a854a8f07017$export$81a8b7dba1aa8f75 = /*#__PURE__*/ function(TRIGGER_METHOD) {
    TRIGGER_METHOD["BUTTON"] = "button";
    TRIGGER_METHOD["KEYBOARD"] = "keyboard";
    // single key, e.g. Esc, Enter
    TRIGGER_METHOD["SHORTCUT"] = "shortcut";
    // combination of keys, e.g. Mod + F
    TRIGGER_METHOD["TOOLBAR"] = "toolbar";
    TRIGGER_METHOD["EXTERNAL"] = "external";
    return TRIGGER_METHOD;
}({});
var $e5e3a854a8f07017$export$7525482b5931e326 = /*#__PURE__*/ function(ACTION_SUBJECT) {
    ACTION_SUBJECT["AI_INTERACTION"] = "aiInteraction";
    ACTION_SUBJECT["AI_RESULT"] = "aiResult";
    ACTION_SUBJECT["AI_FEEDBACK"] = "aiFeedback";
    ACTION_SUBJECT["AI_STREAMING"] = "aiStreaming";
    ACTION_SUBJECT["COLLAB"] = "collab";
    ACTION_SUBJECT["TOOLBAR_BUTTON"] = "toolbarButton";
    ACTION_SUBJECT["BUTTON"] = "button";
    ACTION_SUBJECT["COPY_BUTTON"] = "copyButton";
    ACTION_SUBJECT["CONFIG_PANEL"] = "configPanel";
    ACTION_SUBJECT["CONTENT_COMPONENT"] = "contentComponent";
    ACTION_SUBJECT["DATE"] = "date";
    ACTION_SUBJECT["DATE_SEGMENT"] = "dateSegment";
    ACTION_SUBJECT["DOCUMENT"] = "document";
    ACTION_SUBJECT["EDITOR"] = "editor";
    ACTION_SUBJECT["ACTIVITY_SESSION"] = "activitySession";
    ACTION_SUBJECT["ELEMENT_BROWSER"] = "elementBrowser";
    ACTION_SUBJECT["EMBEDS"] = "embeds";
    ACTION_SUBJECT["EXPAND"] = "expand";
    ACTION_SUBJECT["EXTENSION"] = "extension";
    ACTION_SUBJECT["FEATURE"] = "feature";
    ACTION_SUBJECT["FEEDBACK_DIALOG"] = "feedbackDialog";
    ACTION_SUBJECT["FIND_REPLACE_DIALOG"] = "findReplaceDialog";
    ACTION_SUBJECT["FLOATING_CONTEXTUAL_BUTTON"] = "floatingContextualButton";
    ACTION_SUBJECT["FLOATING_TOOLBAR_PLUGIN"] = "floatingToolbarPlugin";
    ACTION_SUBJECT["HELP"] = "help";
    ACTION_SUBJECT["INVITE_ITEM"] = "inviteItem";
    ACTION_SUBJECT["LAYOUT"] = "layout";
    ACTION_SUBJECT["LIST"] = "list";
    ACTION_SUBJECT["MEDIA"] = "media";
    ACTION_SUBJECT["MEDIA_GROUP"] = "mediaGroup";
    ACTION_SUBJECT["MEDIA_INLINE"] = "mediaInline";
    ACTION_SUBJECT["MEDIA_SINGLE"] = "mediaSingle";
    ACTION_SUBJECT["MENTION"] = "mention";
    ACTION_SUBJECT["MENTION_TYPEAHEAD"] = "mentionTypeahead";
    ACTION_SUBJECT["NESTED_EXPAND"] = "nestedExpand";
    ACTION_SUBJECT["PANEL"] = "panel";
    ACTION_SUBJECT["PICKER"] = "picker";
    ACTION_SUBJECT["PLUS_MENU"] = "plusMenu";
    ACTION_SUBJECT["PLUGIN_SLOT"] = "pluginSlot";
    ACTION_SUBJECT["REQUEST_TO_EDIT_POP_UP"] = "requestToEditPopUp";
    ACTION_SUBJECT["REACT_NODE_VIEW"] = "reactNodeView";
    ACTION_SUBJECT["SELECTION"] = "selection";
    ACTION_SUBJECT["SMART_LINK"] = "smartLink";
    ACTION_SUBJECT["HYPERLINK"] = "hyperlink";
    ACTION_SUBJECT["TABLE"] = "table";
    ACTION_SUBJECT["TABLES_PLUGIN"] = "tablesPlugin";
    ACTION_SUBJECT["TEAM_MENTION_TYPEAHEAD"] = "teamMentionTypeahead";
    ACTION_SUBJECT["TELEPOINTER"] = "telepointer";
    ACTION_SUBJECT["TEXT"] = "text";
    ACTION_SUBJECT["TOOLBAR"] = "toolbar";
    ACTION_SUBJECT["TYPEAHEAD"] = "typeAhead";
    ACTION_SUBJECT["TYPEAHEAD_ITEM"] = "typeAheadItem";
    ACTION_SUBJECT["ANNOTATION"] = "annotation";
    ACTION_SUBJECT["SEARCH_RESULT"] = "searchResult";
    ACTION_SUBJECT["CREATE_LINK_INLINE_DIALOG"] = "createLinkInlineDialog";
    ACTION_SUBJECT["CODE_BLOCK"] = "codeBlock";
    ACTION_SUBJECT["REACT_EDITOR_VIEW"] = "reactEditorView";
    ACTION_SUBJECT["RENDERER"] = "renderer";
    ACTION_SUBJECT["ANCHOR_LINK"] = "anchorLink";
    ACTION_SUBJECT["LINK"] = "link";
    ACTION_SUBJECT["TOOLTIP"] = "tooltip";
    ACTION_SUBJECT["LOOM"] = "loom";
    ACTION_SUBJECT["MULTI_BODIED_EXTENSION"] = "multiBodiedExtension";
    ACTION_SUBJECT["BODIED_EXTENSION"] = "bodiedExtension";
    ACTION_SUBJECT["DROP_TARGET"] = "dropTarget";
    ACTION_SUBJECT["DRAG"] = "drag";
    ACTION_SUBJECT["ELEMENT"] = "element";
    ACTION_SUBJECT["INLINE_DIALOG"] = "inlineDialog";
    ACTION_SUBJECT["ENGAGEMENT_PLATFORM"] = "engagementPlatform";
    ACTION_SUBJECT["MEDIA_VIEWER"] = "mediaViewer";
    ACTION_SUBJECT["DECORATION"] = "decoration";
    ACTION_SUBJECT["EDITOR_PLUGIN_AI"] = "editorPluginAI";
    ACTION_SUBJECT["EDITOR_PLUGIN_SELECTION_EXTENSION"] = "editorPluginSelectionExtension";
    ACTION_SUBJECT["AI_DEFINITIONS"] = "aiDefinitions";
    ACTION_SUBJECT["AI_QUICK_PROMPT"] = "aiQuickPrompt";
    ACTION_SUBJECT["AI_AUTOCOMPLETE"] = "aiAutocomplete";
    ACTION_SUBJECT["USER_PREFERENCES"] = "userPreferences";
    ACTION_SUBJECT["ALIGNMENT"] = "alignment";
    ACTION_SUBJECT["OFFLINE_EDITING"] = "offlineEditing";
    ACTION_SUBJECT["TOOLBAR_DROPDOWN_MENU"] = "toolbarDropdownMenu";
    ACTION_SUBJECT["TOOLBAR_DROPDOWN_MENU_ITEM"] = "toolbarDropdownMenuItem";
    ACTION_SUBJECT["BLOCK_MENU"] = "blockMenu";
    ACTION_SUBJECT["BLOCK_MENU_ITEM"] = "blockMenuItem";
    ACTION_SUBJECT["PASTE_ACTIONS_MENU"] = "pasteActionsMenu";
    ACTION_SUBJECT["SYNCED_BLOCK"] = "syncedBlock";
    ACTION_SUBJECT["NATIVE_EMBED"] = "nativeEmbed";
    return ACTION_SUBJECT;
}({});
var $e5e3a854a8f07017$export$9957974f8b4d8f74 = /*#__PURE__*/ function(ACTION_SUBJECT_ID) {
    ACTION_SUBJECT_ID["ACTION"] = "action";
    ACTION_SUBJECT_ID["ACTIVITY"] = "activity";
    ACTION_SUBJECT_ID["AI_CHANGES_ACCEPT_BUTTON"] = "aiChangesAcceptButton";
    ACTION_SUBJECT_ID["AI_CHANGES_REJECT_BUTTON"] = "aiChangesRejectButton";
    ACTION_SUBJECT_ID["AI_DEFINITIONS_DEFINE_BUTTON"] = "aiDefinitionsDefineButton";
    ACTION_SUBJECT_ID["AI_DEFINITIONS_AUTO_HIGHLIGHT"] = "aiDefinitionsAutoHighlight";
    ACTION_SUBJECT_ID["AI_INLINE_SUGGESTION"] = "aiInlineSuggestion";
    ACTION_SUBJECT_ID["AI_PANELS_BODIED_EXTENSION"] = "aiPanelsBodiedExtension";
    ACTION_SUBJECT_ID["AI_PROMPT_LINK_PICKER_BUTTON"] = "aiPromptLinkPickerButton";
    ACTION_SUBJECT_ID["AI_PROMPT_MENTION_BUTTON"] = "aiPromptMentionButton";
    ACTION_SUBJECT_ID["AI_PROACTIVE_FEEDBACK_DIALOG"] = "aiProactiveFeedbackDialog";
    ACTION_SUBJECT_ID["AI_ASK_ROVO_BUTTON"] = "aiAskRovoButton";
    ACTION_SUBJECT_ID["AI_HERO_PROMPT_BUTTON"] = "aiHeroPromptButton";
    ACTION_SUBJECT_ID["AI_MORE_ROVO_OPTIONS"] = "aiMoreRovoOptions";
    ACTION_SUBJECT_ID["AI_TRANSLATE"] = "aiTranslate";
    ACTION_SUBJECT_ID["AI_CHANGE_TONE"] = "aiChangeTone";
    ACTION_SUBJECT_ID["ALL"] = "all";
    ACTION_SUBJECT_ID["ALT_TEXT"] = "altText";
    ACTION_SUBJECT_ID["ANNOTATE_BUTTON"] = "annotateButton";
    ACTION_SUBJECT_ID["AVATAR_GROUP_PLUGIN"] = "AvatarGroupInPlugin";
    ACTION_SUBJECT_ID["BLOCK_MENU"] = "blockMenu";
    ACTION_SUBJECT_ID["BLOCK_QUOTE"] = "blockQuote";
    ACTION_SUBJECT_ID["BORDER"] = "border";
    ACTION_SUBJECT_ID["BUTTON_CATEGORY"] = "categoryButton";
    ACTION_SUBJECT_ID["BUTTON_FEEDBACK"] = "feedbackButton";
    ACTION_SUBJECT_ID["BUTTON_HELP"] = "helpButton";
    ACTION_SUBJECT_ID["CANCEL"] = "cancel";
    ACTION_SUBJECT_ID["CAPTION"] = "caption";
    ACTION_SUBJECT_ID["CARD_BLOCK"] = "blockCard";
    ACTION_SUBJECT_ID["CARD_INLINE"] = "inlineCard";
    ACTION_SUBJECT_ID["CELL"] = "cell";
    ACTION_SUBJECT_ID["CODE_BLOCK"] = "codeBlock";
    ACTION_SUBJECT_ID["CODEBLOCK_COPY"] = "codeBlockCopy";
    ACTION_SUBJECT_ID["CODEBLOCK_WRAP"] = "codeBlockWrap";
    ACTION_SUBJECT_ID["COPY_BUTTON"] = "copyButton";
    ACTION_SUBJECT_ID["COPY_LINK_TO_ANCHOR"] = "copyLinkToAnchor";
    ACTION_SUBJECT_ID["COPY_BLOCK"] = "copyBlock";
    ACTION_SUBJECT_ID["COPY_LINK_TO_BLOCK"] = "copyLinkToBlock";
    ACTION_SUBJECT_ID["DELETE_BLOCK"] = "deleteBlock";
    ACTION_SUBJECT_ID["MOVE_UP_BLOCK"] = "moveUpBlock";
    ACTION_SUBJECT_ID["MOVE_DOWN_BLOCK"] = "moveDownBlock";
    ACTION_SUBJECT_ID["TRANSFORM_BLOCK"] = "transformBlock";
    ACTION_SUBJECT_ID["FORMAT_MENU"] = "formatMenu";
    ACTION_SUBJECT_ID["CREATE_INLINE_COMMENT_FROM_HIGHLIGHT_ACTIONS_MENU"] = "createInlineCommentFromHighlightActionsMenu";
    ACTION_SUBJECT_ID["DATE"] = "date";
    ACTION_SUBJECT_ID["DATE_DAY"] = "day";
    ACTION_SUBJECT_ID["DATE_MONTH"] = "month";
    ACTION_SUBJECT_ID["DATE_YEAR"] = "year";
    ACTION_SUBJECT_ID["DECISION"] = "decision";
    ACTION_SUBJECT_ID["DISCARD_STREAM"] = "discardStream";
    ACTION_SUBJECT_ID["DIVIDER"] = "divider";
    ACTION_SUBJECT_ID["EDIT_LINK"] = "editLink";
    ACTION_SUBJECT_ID["EDIT_DATASOURCE"] = "editDatasource";
    ACTION_SUBJECT_ID["EDITOR_PLUGIN_AI"] = "editorPluginAI";
    ACTION_SUBJECT_ID["ELEMENT_DRAG_HANDLE"] = "elementDragHandle";
    ACTION_SUBJECT_ID["ELEMENT_DROP_TARGET"] = "elementDropTarget";
    ACTION_SUBJECT_ID["EMBEDS"] = "embeds";
    ACTION_SUBJECT_ID["EMOJI"] = "emoji";
    ACTION_SUBJECT_ID["EXPAND"] = "expand";
    ACTION_SUBJECT_ID["EXPERIENCE_APPLICATION"] = "experienceApplication";
    ACTION_SUBJECT_ID["EXTENSION"] = "extension";
    ACTION_SUBJECT_ID["EXTENSION_API"] = "extensionApi";
    ACTION_SUBJECT_ID["EXTENSION_BLOCK"] = "extension";
    ACTION_SUBJECT_ID["EXTENSION_BODIED"] = "bodiedExtension";
    ACTION_SUBJECT_ID["EXTENSION_INLINE"] = "inlineExtension";
    ACTION_SUBJECT_ID["FLOATING_TOOLBAR_OVERFLOW"] = "floatingToolbarOverflow";
    ACTION_SUBJECT_ID["FLOATING_TOOLBAR"] = "floatingToolbar";
    ACTION_SUBJECT_ID["FORMAT_BACKGROUND_COLOR"] = "backgroundColor";
    ACTION_SUBJECT_ID["FORMAT_BLOCK_QUOTE"] = "blockQuote";
    ACTION_SUBJECT_ID["FORMAT_CLEAR"] = "clearFormatting";
    ACTION_SUBJECT_ID["FORMAT_CODE"] = "code";
    ACTION_SUBJECT_ID["FORMAT_COLOR"] = "color";
    ACTION_SUBJECT_ID["FORMAT_HEADING"] = "heading";
    ACTION_SUBJECT_ID["FORMAT_SMALL_TEXT"] = "smallText";
    ACTION_SUBJECT_ID["FORMAT_INDENT"] = "indentation";
    ACTION_SUBJECT_ID["FORMAT_ITALIC"] = "italic";
    ACTION_SUBJECT_ID["FORMAT_LIST_BULLET"] = "bulletedList";
    ACTION_SUBJECT_ID["FORMAT_LIST_NUMBER"] = "numberedList";
    ACTION_SUBJECT_ID["FORMAT_STRIKE"] = "strike";
    ACTION_SUBJECT_ID["FORMAT_STRONG"] = "strong";
    ACTION_SUBJECT_ID["FORMAT_SUB"] = "subscript";
    ACTION_SUBJECT_ID["FORMAT_SUPER"] = "superscript";
    ACTION_SUBJECT_ID["FORMAT_UNDERLINE"] = "underline";
    ACTION_SUBJECT_ID["FRAGMENT_MARK"] = "fragmentMark";
    ACTION_SUBJECT_ID["GOTO_SMART_LINK_SETTINGS"] = "goToSmartLinkSettings";
    ACTION_SUBJECT_ID["HELP_QUICK_INSERT"] = "helpQuickInsert";
    ACTION_SUBJECT_ID["HOVER_LABEL"] = "hoverLabel";
    ACTION_SUBJECT_ID["HYPERLINK"] = "hyperlink";
    ACTION_SUBJECT_ID["INLINE_COMMENT"] = "inlineComment";
    ACTION_SUBJECT_ID["LAYOUT"] = "layout";
    ACTION_SUBJECT_ID["LINE_BREAK"] = "lineBreak";
    ACTION_SUBJECT_ID["LINK"] = "link";
    ACTION_SUBJECT_ID["LINK_PREVIEW"] = "linkPreview";
    ACTION_SUBJECT_ID["LINK_SEARCH_INPUT"] = "linkSearchInput";
    ACTION_SUBJECT_ID["MEDIA"] = "media";
    ACTION_SUBJECT_ID["MEDIA_GROUP"] = "mediaGroup";
    ACTION_SUBJECT_ID["MEDIA_INLINE"] = "mediaInline";
    ACTION_SUBJECT_ID["MEDIA_INLINE_IMAGE"] = "mediaInlineImage";
    ACTION_SUBJECT_ID["MEDIA_LINK"] = "mediaLink";
    ACTION_SUBJECT_ID["MEDIA_SINGLE"] = "mediaSingle";
    ACTION_SUBJECT_ID["MENTION"] = "mention";
    ACTION_SUBJECT_ID["MENTION_PROVIDER"] = "mentionProvider";
    ACTION_SUBJECT_ID["NESTED_EXPAND"] = "nestedExpand";
    ACTION_SUBJECT_ID["NODE"] = "node";
    ACTION_SUBJECT_ID["OPEN_LINK"] = "openLink";
    ACTION_SUBJECT_ID["OFFLINE_EDITING"] = "offlineEditing";
    ACTION_SUBJECT_ID["PANEL"] = "panel";
    ACTION_SUBJECT_ID["PASTE_BLOCK_CARD"] = "blockCard";
    ACTION_SUBJECT_ID["PASTE_BLOCKQUOTE"] = "blockQuote";
    ACTION_SUBJECT_ID["PASTE_BODIED_EXTENSION"] = "bodiedExtension";
    ACTION_SUBJECT_ID["PASTE_BULLET_LIST"] = "bulletList";
    ACTION_SUBJECT_ID["PASTE_CODE_BLOCK"] = "codeBlock";
    ACTION_SUBJECT_ID["PASTE_DECISION_LIST"] = "decisionList";
    ACTION_SUBJECT_ID["PASTE_EXPAND"] = "expand";
    ACTION_SUBJECT_ID["PASTE_EXTENSION"] = "extension";
    ACTION_SUBJECT_ID["PASTE_HEADING"] = "heading";
    ACTION_SUBJECT_ID["PASTE_MEDIA_GROUP"] = "mediaGroup";
    ACTION_SUBJECT_ID["PASTE_MEDIA_SINGLE"] = "mediaSingle";
    ACTION_SUBJECT_ID["PASTE_NESTED_EXPAND"] = "nestedExpand";
    ACTION_SUBJECT_ID["PASTE_ORDERED_LIST"] = "orderedList";
    ACTION_SUBJECT_ID["PASTE_PANEL"] = "panel";
    ACTION_SUBJECT_ID["PASTE_PARAGRAPH"] = "paragraph";
    ACTION_SUBJECT_ID["PASTE_RULE"] = "rule";
    ACTION_SUBJECT_ID["PASTE_TABLE"] = "table";
    ACTION_SUBJECT_ID["PASTE_TABLE_CELL"] = "tableCell";
    ACTION_SUBJECT_ID["PASTE_TABLE_HEADER"] = "tableHeader";
    ACTION_SUBJECT_ID["PASTE_TABLE_ROW"] = "tableRow";
    ACTION_SUBJECT_ID["PASTE_TASK_LIST"] = "taskList";
    ACTION_SUBJECT_ID["PICKER_CLOUD"] = "cloudPicker";
    ACTION_SUBJECT_ID["PICKER_MEDIA"] = "mediaPicker";
    ACTION_SUBJECT_ID["PICKER_COLOR"] = "colorPicker";
    ACTION_SUBJECT_ID["PICKER_EMOJI"] = "emojiPicker";
    ACTION_SUBJECT_ID["PICKER_TABLE_SIZE"] = "tableSizePicker";
    ACTION_SUBJECT_ID["DOCKED_PRIMARY_TOOLBAR"] = "dockedPrimaryToolbar";
    ACTION_SUBJECT_ID["PLACEHOLDER_TEXT"] = "placeholderText";
    ACTION_SUBJECT_ID["POST_QUERY_SEARCH_RESULTS"] = "postQuerySearchResults";
    ACTION_SUBJECT_ID["PRE_QUERY_SEARCH_RESULTS"] = "preQuerySearchResults";
    ACTION_SUBJECT_ID["PRIMARY_TOOLBAR"] = "primaryToolbar";
    ACTION_SUBJECT_ID["PROACTIVE_SUGGESTION"] = "proactiveSuggestion";
    ACTION_SUBJECT_ID["PRODUCT_NAME"] = "productName";
    ACTION_SUBJECT_ID["PUNC"] = "punctuation";
    ACTION_SUBJECT_ID["QUICK_SEARCH"] = "quickSearch";
    ACTION_SUBJECT_ID["QUICK_INSERT"] = "quickInsert";
    ACTION_SUBJECT_ID["RANGE"] = "range";
    ACTION_SUBJECT_ID["REACT_NODE_VIEW"] = "reactNodeView";
    ACTION_SUBJECT_ID["RECENT_ACTIVITIES"] = "recentActivities";
    ACTION_SUBJECT_ID["RESIZED"] = "resized";
    ACTION_SUBJECT_ID["RESPONSE_FEEDBACK_BUTTON"] = "responseFeedbackButton";
    ACTION_SUBJECT_ID["RICH_MEDIA_LAYOUT"] = "richMediaLayout";
    ACTION_SUBJECT_ID["SAVE"] = "save";
    ACTION_SUBJECT_ID["SECTION"] = "section";
    ACTION_SUBJECT_ID["SMART_LINK"] = "smartLink";
    ACTION_SUBJECT_ID["SMART_LINK_TOOLBAR"] = "smartLinkToolbar";
    ACTION_SUBJECT_ID["SMART_LINK_ROVO_BUTTON"] = "smartLinkRovoButton";
    ACTION_SUBJECT_ID["SMART_LINK_SUMMARIZE_BUTTON"] = "smartLinkSummarizeButton";
    ACTION_SUBJECT_ID["STATUS"] = "status";
    ACTION_SUBJECT_ID["SYMBOL"] = "symbol";
    ACTION_SUBJECT_ID["TABLE"] = "table";
    ACTION_SUBJECT_ID["TELEPOINTER"] = "telepointer";
    ACTION_SUBJECT_ID["TEXT"] = "text";
    ACTION_SUBJECT_ID["TYPEAHEAD_EMOJI"] = "emojiTypeAhead";
    ACTION_SUBJECT_ID["TYPEAHEAD_LINK"] = "linkTypeAhead";
    ACTION_SUBJECT_ID["TYPEAHEAD_MENTION"] = "mentionTypeAhead";
    ACTION_SUBJECT_ID["TYPEAHEAD_QUICK_INSERT"] = "quickInsertTypeAhead";
    ACTION_SUBJECT_ID["TOOLBAR_PREVIEW"] = "previewFromToolbar";
    ACTION_SUBJECT_ID["UNKNOWN_NODE"] = "unknownNode";
    ACTION_SUBJECT_ID["UNLINK"] = "unlink";
    ACTION_SUBJECT_ID["HEADING_ANCHOR_LINK"] = "headingAnchorLink";
    ACTION_SUBJECT_ID["UNSUPPORTED_ERROR"] = "unsupportedUnhandled";
    ACTION_SUBJECT_ID["UNSUPPORTED_NODE_ATTRIBUTE"] = "unsupportedNodeAttribute";
    ACTION_SUBJECT_ID["UNSUPPORTED_BLOCK"] = "unsupportedBlock";
    ACTION_SUBJECT_ID["UNSUPPORTED_INLINE"] = "unsupportedInline";
    ACTION_SUBJECT_ID["UNSUPPORTED_MARK"] = "unsupportedMark";
    ACTION_SUBJECT_ID["ON_UNSUPPORTED_INLINE"] = "onUnsupportedInline";
    ACTION_SUBJECT_ID["ON_UNSUPPORTED_BLOCK"] = "onUnsupportedBlock";
    ACTION_SUBJECT_ID["MULTI_BODIED_EXTENSION"] = "multiBodiedExtension";
    ACTION_SUBJECT_ID["UPDATE_STREAM"] = "updateStream";
    ACTION_SUBJECT_ID["UPLOAD_MEDIA"] = "uploadMedia";
    ACTION_SUBJECT_ID["SELECTION_TOOLBAR_PREFERENCES"] = "selectionToolbarPreferences";
    ACTION_SUBJECT_ID["SELECTION_TOOLBAR"] = "selectionToolbar";
    ACTION_SUBJECT_ID["EDITOR_PLUGIN_SELECTION_EXTENSION_DROPDOWN"] = "editorPluginSelectionExtensionDropdown";
    ACTION_SUBJECT_ID["EDITOR_PLUGIN_SELECTION_EXTENSION_ITEM"] = "editorPluginSelectionExtensionItem";
    ACTION_SUBJECT_ID["EDITOR_PLUGIN_SELECTION_EXTENSION_COMPONENT"] = "editorPluginSelectionExtensionComponent";
    ACTION_SUBJECT_ID["TRANSFORM"] = "transform";
    ACTION_SUBJECT_ID["BODIED_SYNCED_BLOCK"] = "bodiedSyncBlock";
    ACTION_SUBJECT_ID["SYNCED_BLOCK"] = "syncBlock";
    ACTION_SUBJECT_ID["SYNCED_BLOCK_TOOLBAR"] = "syncedBlockToolbar";
    ACTION_SUBJECT_ID["SYNCED_BLOCK_COPY"] = "syncedBlockCopy";
    ACTION_SUBJECT_ID["SYNCED_BLOCK_SOURCE_URL"] = "syncedBlockSourceUrl";
    ACTION_SUBJECT_ID["SYNCED_BLOCK_UPDATE_CACHE"] = "syncedBlockUpdateCache";
    ACTION_SUBJECT_ID["SYNCED_BLOCK_UPDATE"] = "syncedBlockUpdate";
    ACTION_SUBJECT_ID["REFERENCE_SYNCED_BLOCK_UPDATE"] = "referenceSyncedBlockUpdate";
    ACTION_SUBJECT_ID["SYNCED_BLOCK_CREATE"] = "syncedBlockCreate";
    ACTION_SUBJECT_ID["REFERENCE_SYNCED_BLOCK_CREATE"] = "referenceSyncedBlockCreate";
    ACTION_SUBJECT_ID["SYNCED_BLOCK_DELETE"] = "syncedBlockDelete";
    ACTION_SUBJECT_ID["REFERENCE_SYNCED_BLOCK_DELETE"] = "referenceSyncedBlockDelete";
    ACTION_SUBJECT_ID["SYNCED_BLOCK_GET_SOURCE_INFO"] = "syncedBlockGetSourceInfo";
    ACTION_SUBJECT_ID["SYNCED_BLOCK_FETCH"] = "syncedBlockFetch";
    ACTION_SUBJECT_ID["SYNCED_BLOCK_FETCH_REFERENCES"] = "syncedBlockFetchReferences";
    ACTION_SUBJECT_ID["SYNCED_BLOCK_CLICK_SYNCED_LOCATION"] = "syncedBlockClickSyncedLocation";
    ACTION_SUBJECT_ID["SYNCED_BLOCK_LABEL"] = "syncedBlockLabel";
    ACTION_SUBJECT_ID["SYNCED_BLOCK_SSR_ERROR"] = "syncedBlockSSRError";
    ACTION_SUBJECT_ID["TABLE_STICKY_HEADER"] = "tableStickyHeader";
    return ACTION_SUBJECT_ID;
}({});
var $e5e3a854a8f07017$export$75ef928acd21e35b = /*#__PURE__*/ function(FLOATING_CONTROLS_TITLE) {
    FLOATING_CONTROLS_TITLE["CODE_BLOCK"] = "codeBlockFloatingControls";
    FLOATING_CONTROLS_TITLE["EXTENSION"] = "extensionFloatingControls";
    FLOATING_CONTROLS_TITLE["HYPERLINK"] = "hyperlinkFloatingControls";
    FLOATING_CONTROLS_TITLE["MEDIA"] = "mediaFloatingControls";
    FLOATING_CONTROLS_TITLE["PANEL"] = "panelFloatingControls";
    FLOATING_CONTROLS_TITLE["TABLE"] = "tableFloatingControls";
    FLOATING_CONTROLS_TITLE["EXPAND"] = "expandToolbar";
    return FLOATING_CONTROLS_TITLE;
}({});
var $e5e3a854a8f07017$export$9f0b2adf3cfd71b7 = /*#__PURE__*/ function(CONTENT_COMPONENT) {
    CONTENT_COMPONENT["INLINE_COMMENT"] = "inlineComment";
    CONTENT_COMPONENT["FLOATING_CONTEXTUAL_BUTTON"] = "floatingContextualButton";
    CONTENT_COMPONENT["FLOATING_INSERT_BUTTON"] = "floatingInsertButton";
    CONTENT_COMPONENT["FLOATING_TOOLBAR"] = "floatingToolbar";
    CONTENT_COMPONENT["SELECTION_TOOLBAR"] = "selectionToolbar";
    return CONTENT_COMPONENT;
}({});

});

parcelRegister("c0oX9", function(module, exports) {
$parcel$export(module.exports, "unsupportedContentMessages", () => $8bd8d7454cc3534c$export$32ec96484dd3ba39);

var $aRMzY = parcelRequire("aRMzY");
var $8bd8d7454cc3534c$export$32ec96484dd3ba39 = (0, $aRMzY.defineMessages)({
    unsupportedInlineContent: {
        id: 'fabric.editor.unsupportedInlineContent',
        defaultMessage: 'Unsupported content',
        description: 'The text is shown as an inline label in the editor when a content node type is not supported for display. It appears alongside a question mark icon that provides more details via a tooltip.'
    },
    unsupportedBlockContent: {
        id: 'fabric.editor.unsupportedBlockContent',
        defaultMessage: 'This editor does not support displaying this content',
        description: 'The text is shown as a block-level message in the editor when a content block type is not supported for display. It appears centered within a dashed border container alongside a question mark icon that provides more details via a tooltip.'
    },
    unsupportedContentTooltip: {
        id: 'fabric.editor.unsupportedContentTooltip',
        defaultMessage: 'Content is not available in this editor, this will be preserved when you edit and save',
        description: 'The text is shown as tooltip content when the user hovers over the question mark icon on an unsupported content node in the editor. It reassures users that unsupported content will not be lost when they edit and save the document.'
    }
});

});

parcelRegister("fpooh", function(module, exports) {
$parcel$export(module.exports, "findAndTrackUnsupportedContentNodes", () => $b37c1c4264661b4e$export$d343369b8f25914);
$parcel$export(module.exports, "fireUnsupportedEvent", () => $b37c1c4264661b4e$export$e1051b410945e4d4);
$parcel$export(module.exports, "trackUnsupportedContentTooltipDisplayedFor", () => $b37c1c4264661b4e$export$3a34598135e7219b);

var $25nEq = parcelRequire("25nEq");

var $jJH6F = parcelRequire("jJH6F");
function $b37c1c4264661b4e$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $b37c1c4264661b4e$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $b37c1c4264661b4e$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $b37c1c4264661b4e$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $b37c1c4264661b4e$var$whitelistedAttributes = [
    'align',
    'annotationType',
    'extensionKey',
    'extensionType',
    'layout',
    'type',
    'localId',
    'mode',
    'language',
    'timestamp',
    'state',
    'originalWidth',
    'originalHeight',
    'height',
    'width',
    'shortName',
    'level',
    'userType',
    'order',
    'panelType',
    'color',
    'style',
    'isNumberColumnEnabled',
    'colspan',
    'rowspan',
    'colwidth',
    'background'
];
function $b37c1c4264661b4e$var$concatAncestorHierarchy(node, ancestoryHierarchy) {
    var name = node.type.name;
    // Space concatenator used to reduce analytics payload size
    return ancestoryHierarchy ? "".concat(ancestoryHierarchy, " ").concat(name) : name;
}
// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
var $b37c1c4264661b4e$var$sanitizeMarks = function sanitizeMarks() {
    var marks = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var sanitizedMarks = [];
    marks.forEach(function(mark) {
        if (mark.attrs) {
            var attrs = $b37c1c4264661b4e$var$sanitizeAttributes(mark.attrs);
            sanitizedMarks.push($b37c1c4264661b4e$var$_objectSpread($b37c1c4264661b4e$var$_objectSpread({}, mark), {}, {
                attrs: attrs
            }));
        } else sanitizedMarks.push($b37c1c4264661b4e$var$_objectSpread({}, mark));
    });
    return sanitizedMarks;
};
var $b37c1c4264661b4e$var$sanitizeAttributes = function sanitizeAttributes() {
    var attrs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var sanitizedAttrs = Object.assign({}, attrs);
    Object.keys(attrs).filter(function(key) {
        return !$b37c1c4264661b4e$var$whitelistedAttributes.includes(key);
    }).forEach(function(key) {
        sanitizedAttrs[key] !== null ? sanitizedAttrs[key] = '' : sanitizedAttrs[key] = 'null';
    });
    return sanitizedAttrs;
};
var $b37c1c4264661b4e$var$trackUnsupportedContentTooltipActionFor = function trackUnsupportedContentTooltipActionFor(action, dispatchAnalyticsEvent, unsupportedContentType, originalNodeType) {
    dispatchAnalyticsEvent({
        action: action,
        actionSubjectId: unsupportedContentType,
        actionSubject: (0, $jJH6F.ACTION_SUBJECT).TOOLTIP,
        eventType: (0, $jJH6F.EVENT_TYPE).UI,
        attributes: {
            unsupportedNodeType: originalNodeType
        }
    });
};
var $b37c1c4264661b4e$export$d343369b8f25914 = function findAndTrackUnsupportedContentNodes(node, schema, dispatchAnalyticsEvent) {
    var ancestorHierarchy = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';
    var nodeType = node.type, nodeMarks = node.marks;
    var _schema$marks = schema.marks, unsupportedMark = _schema$marks.unsupportedMark, unsupportedNodeAttribute = _schema$marks.unsupportedNodeAttribute;
    var _schema$nodes = schema.nodes, unsupportedInline = _schema$nodes.unsupportedInline, unsupportedBlock = _schema$nodes.unsupportedBlock;
    var parentType = ancestorHierarchy.split(' ').pop() || '';
    if (nodeMarks.length) nodeMarks.forEach(function(mark) {
        if (mark.type === unsupportedMark) {
            var _ref = mark.attrs || {}, originalValue = _ref.originalValue;
            var _ref2 = originalValue || {}, type = _ref2.type;
            var unsupportedNode = {
                type: type || '',
                ancestry: ancestorHierarchy,
                parentType: parentType,
                marks: [],
                attrs: originalValue.attrs || {}
            };
            $b37c1c4264661b4e$export$e1051b410945e4d4(dispatchAnalyticsEvent, (0, $jJH6F.ACTION_SUBJECT_ID).UNSUPPORTED_MARK, unsupportedNode);
        } else if (mark.type === unsupportedNodeAttribute) {
            var _ref3 = mark.attrs || {}, unsupported = _ref3.unsupported;
            var _unsupportedNodeAttribute = {
                type: nodeType.name || '',
                ancestry: ancestorHierarchy,
                parentType: parentType,
                marks: [],
                attrs: unsupported || {}
            };
            $b37c1c4264661b4e$export$e1051b410945e4d4(dispatchAnalyticsEvent, (0, $jJH6F.ACTION_SUBJECT_ID).UNSUPPORTED_NODE_ATTRIBUTE, _unsupportedNodeAttribute);
        }
    });
    if (nodeType === unsupportedInline || nodeType === unsupportedBlock) {
        var _ref4 = node.attrs || {}, originalValue = _ref4.originalValue;
        var _ref5 = originalValue || [], marks = _ref5.marks;
        var _ref6 = originalValue || {}, attrs = _ref6.attrs;
        var _ref7 = originalValue || {}, type = _ref7.type;
        var unsupportedNode = {
            type: type || '',
            ancestry: ancestorHierarchy,
            parentType: parentType,
            marks: marks || [],
            attrs: attrs || {}
        };
        var actionSubjectId = nodeType === unsupportedInline ? (0, $jJH6F.ACTION_SUBJECT_ID).UNSUPPORTED_INLINE : (0, $jJH6F.ACTION_SUBJECT_ID).UNSUPPORTED_BLOCK;
        $b37c1c4264661b4e$export$e1051b410945e4d4(dispatchAnalyticsEvent, actionSubjectId, unsupportedNode);
    } else // Recursive check for nested content
    node.content.forEach(function(childNode) {
        return $b37c1c4264661b4e$export$d343369b8f25914(childNode, schema, dispatchAnalyticsEvent, $b37c1c4264661b4e$var$concatAncestorHierarchy(node, ancestorHierarchy));
    });
};
var $b37c1c4264661b4e$export$e1051b410945e4d4 = function fireUnsupportedEvent(dispatchAnalyticsEvent, actionSubjectId, unsupportedNode, errorCode) {
    var sanitizedAttrs = $b37c1c4264661b4e$var$sanitizeAttributes(unsupportedNode.attrs);
    var sanitizedMarks = $b37c1c4264661b4e$var$sanitizeMarks(unsupportedNode.marks);
    var sanitizedUnsupportedNode = {
        type: unsupportedNode.type,
        ancestry: unsupportedNode.ancestry,
        parentType: unsupportedNode.parentType,
        attrs: sanitizedAttrs,
        marks: sanitizedMarks
    };
    var payload = {
        action: (0, $jJH6F.ACTION).UNSUPPORTED_CONTENT_ENCOUNTERED,
        actionSubject: (0, $jJH6F.ACTION_SUBJECT).DOCUMENT,
        actionSubjectId: actionSubjectId,
        attributes: $b37c1c4264661b4e$var$_objectSpread({
            unsupportedNode: sanitizedUnsupportedNode
        }, !!errorCode && {
            errorCode: errorCode
        }),
        eventType: (0, $jJH6F.EVENT_TYPE).TRACK
    };
    dispatchAnalyticsEvent(payload);
};
var $b37c1c4264661b4e$export$3a34598135e7219b = function trackUnsupportedContentTooltipDisplayedFor(dispatchAnalyticsEvent, unsupportedContentType, originalNodeType) {
    $b37c1c4264661b4e$var$trackUnsupportedContentTooltipActionFor((0, $jJH6F.ACTION).UNSUPPORTED_TOOLTIP_VIEWED, dispatchAnalyticsEvent, unsupportedContentType, originalNodeType);
};

});

parcelRegister("iY18h", function(module, exports) {
$parcel$export(module.exports, "getUnsupportedContent", () => $dceeb579b418516a$export$d4ded51d0f0bd2df);
function $dceeb579b418516a$export$d4ded51d0f0bd2df(// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
message, prefix, node, intl) {
    var defaultLocale = 'en';
    var canTranslateToLocale = true;
    var locale = intl ? intl.locale : defaultLocale;
    var finalMessage = message.defaultMessage;
    if (node && locale.startsWith(defaultLocale)) {
        var originalValue = node.attrs.originalValue;
        if (originalValue.text || originalValue.attrs && originalValue.attrs.text) {
            finalMessage = originalValue.text ? originalValue.text : originalValue.attrs.text;
            canTranslateToLocale = false;
        } else if (originalValue.type) {
            finalMessage = "".concat(prefix, " ").concat(originalValue.type);
            canTranslateToLocale = false;
        }
    }
    if (intl && canTranslateToLocale) return intl.formatMessage(message);
    return finalMessage;
}

});


parcelRegister("e2N4h", function(module, exports) {
$parcel$export(module.exports, "default", () => $a3975075e9d622e0$export$2e2bcd8739ae039);

var $kqp0i = parcelRequire("kqp0i");

var $5FkrB = parcelRequire("5FkrB");

var $ls0cy = parcelRequire("ls0cy");

var $kX1Gq = parcelRequire("kX1Gq");
var $a3975075e9d622e0$var$withAnalyticsEvents = function withAnalyticsEvents() {
    var createEventMap = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return function(WrappedComponent) {
        var WithAnalyticsEvents = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function(props, ref) {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore: to unblock React 18.2.0 -> 18.3.1 version bump in Jira
            var _usePatchedProps = (0, $kX1Gq.usePatchedProps)(createEventMap, props), patchedEventProps = _usePatchedProps.patchedEventProps;
            var _useAnalyticsEvents = (0, $ls0cy.useAnalyticsEvents)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(WrappedComponent, (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, props, patchedEventProps, {
                createAnalyticsEvent: createAnalyticsEvent,
                ref: ref
            }));
        });
        WithAnalyticsEvents.displayName = "WithAnalyticsEvents(".concat(WrappedComponent.displayName || WrappedComponent.name, ")");
        return WithAnalyticsEvents;
    };
};
var $a3975075e9d622e0$export$2e2bcd8739ae039 = $a3975075e9d622e0$var$withAnalyticsEvents;

});
parcelRegister("kX1Gq", function(module, exports) {
$parcel$export(module.exports, "usePatchedProps", () => $f40a9f983f3f224d$export$9ebb5a84d17e5d18);

var $25nEq = parcelRequire("25nEq");

var $ekGgq = parcelRequire("ekGgq");

var $5FkrB = parcelRequire("5FkrB");

var $ls0cy = parcelRequire("ls0cy");
function $f40a9f983f3f224d$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $f40a9f983f3f224d$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $f40a9f983f3f224d$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $f40a9f983f3f224d$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $f40a9f983f3f224d$export$9ebb5a84d17e5d18() {
    var createEventMap = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var wrappedComponentProps = arguments.length > 1 ? arguments[1] : undefined;
    var _useAnalyticsEvents = (0, $ls0cy.useAnalyticsEvents)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
    var handlerCache = (0, $5FkrB.useRef)({});
    var patchedProps = (0, $5FkrB.useMemo)(function() {
        var cache = handlerCache.current;
        // Clean up no longer used handlers in cache
        Object.keys(cache).filter(function(key) {
            return !(key in createEventMap);
        }).forEach(function(key) {
            return delete cache[key];
        });
        return Object.keys(createEventMap).reduce(function(p, k) {
            var eventCreator = createEventMap[k];
            if (![
                'object',
                'function'
            ].includes((0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(eventCreator))) return p;
            var propValue = wrappedComponentProps[k];
            if (k in cache && cache[k].eventCreator === eventCreator && cache[k].propValue === propValue) return $f40a9f983f3f224d$var$_objectSpread($f40a9f983f3f224d$var$_objectSpread({}, p), {}, (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, k, cache[k].wrappedCallback));
            var wrappedCallback = function wrappedCallback() {
                var analyticsEvent = typeof eventCreator === 'function' ? eventCreator(createAnalyticsEvent, wrappedComponentProps) : createAnalyticsEvent(eventCreator);
                if (propValue && typeof propValue === 'function') {
                    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                    propValue.apply(void 0, args.concat([
                        analyticsEvent
                    ]));
                }
            };
            cache[k] = {
                eventCreator: eventCreator,
                wrappedCallback: wrappedCallback,
                propValue: propValue
            };
            return $f40a9f983f3f224d$var$_objectSpread($f40a9f983f3f224d$var$_objectSpread({}, p), {}, (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, k, wrappedCallback));
        }, {});
    }, [
        createEventMap,
        wrappedComponentProps,
        createAnalyticsEvent,
        handlerCache
    ]);
    return {
        patchedEventProps: patchedProps
    };
}

});


parcelRegister("fAhSf", function(module, exports) {
$parcel$export(module.exports, "editorExperiment", () => $b58815386493b3a2$export$9b7cf3b74f250027);
/* eslint-disable @atlaskit/editor/no-re-export */ // Entry file in package.json

var $8dj3L = parcelRequire("8dj3L");

var $8qy01 = parcelRequire("8qy01");

var $aj4TE = parcelRequire("aj4TE");

var $75k6K = parcelRequire("75k6K");
function $b58815386493b3a2$export$9b7cf3b74f250027(experimentName, expectedExperimentValue) {
    var _experimentConfig$pro;
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
        exposure: false
    };
    var experimentConfig = (0, $aj4TE.editorExperimentsConfig)[experimentName];
    if ((0, $75k6K._overrides)[experimentName] !== undefined) // This will be hit in the case of a test setting an override
    return (0, $75k6K._overrides)[experimentName] === expectedExperimentValue;
    if (experimentConfig === undefined) // Warning! If a product is improperly configured (ie. their editor packages are misaligned)
    // it can cause the editor to crash here or if the experiment does not exist.
    // We will definitely crash via any code path later in this function - this just makes the error explicit and clear.
    throw new Error("Editor experiment configuration is not defined ".concat(experimentName, ". Likely the experiment does not exist or editor package versions are misaligned"));
    if (!(0, $75k6K._product)) // This will be hit in the case of a product not having setup the editor experiment tooling
    return experimentConfig.defaultValue === expectedExperimentValue;
    // Typescript is complaining here about accessing the productKeys property
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    var experimentKey = experimentConfig === null || experimentConfig === void 0 || (_experimentConfig$pro = experimentConfig.productKeys) === null || _experimentConfig$pro === void 0 ? void 0 : _experimentConfig$pro[0, $75k6K._product];
    if (!experimentKey) {
        var _editorExperimentsCon;
        // This will be hit in the case of an experiment not being set up for the product
        return ((_editorExperimentsCon = (0, $aj4TE.editorExperimentsConfig)[experimentName]) === null || _editorExperimentsCon === void 0 ? void 0 : _editorExperimentsCon.defaultValue) === expectedExperimentValue;
    }
    // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
    var experimentValue = (0, $8dj3L.default).getExperimentValue(// @ts-ignore
    experimentKey, experimentConfig.param, experimentConfig.defaultValue, {
        typeGuard: experimentConfig.typeGuard,
        fireExperimentExposure: options.exposure
    });
    if (// When cleaning this gate up -- `calling where the experiments have the product key set`
    // in __tests__/experiments should be updated (as it's had the count bumped to include these).
    // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
    (0, $8dj3L.default).getExperimentValue('cc_editor_experiments_ufo_gate_reporting', 'isEnabled', false)) (0, $8qy01.addFeatureFlagAccessed)("".concat(experimentName, ":").concat(experimentConfig.param), experimentValue);
    return expectedExperimentValue === experimentValue;
}
function $b58815386493b3a2$export$92316ae898e357eb(experimentName, paramName, options) {
    var _paramOverrides$exper, _options$exposure;
    if (((_paramOverrides$exper = (0, $75k6K._paramOverrides)[experimentName]) === null || _paramOverrides$exper === void 0 ? void 0 : _paramOverrides$exper[paramName]) !== undefined) // This will be hit in the case of a test setting an override
    return (0, $75k6K._paramOverrides)[experimentName][paramName];
    // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
    var experimentValue = (0, $8dj3L.default).getExperimentValue(experimentName, paramName, options.defaultValue, {
        typeGuard: options.typeGuard,
        fireExperimentExposure: (_options$exposure = options.exposure) !== null && _options$exposure !== void 0 ? _options$exposure : false
    });
    return experimentValue;
}

});
parcelRegister("8dj3L", function(module, exports) {
$parcel$export(module.exports, "default", () => $5fae527dfb0964cc$export$2e2bcd8739ae039);

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $25nEq = parcelRequire("25nEq");

var $ecTmL = parcelRequire("ecTmL");

var $e4dMb = parcelRequire("e4dMb");



var $5fae527dfb0964cc$var$_FeatureGates;
/**
 * Access the FeatureGates object via the default export.
 * ```ts
 * import FeatureGates from '@atlaskit/feature-gate-js-client';
 * ```
 */ var $5fae527dfb0964cc$var$FeatureGates = /*#__PURE__*/ function() {
    function FeatureGates() {
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, FeatureGates);
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(FeatureGates, null, [
        {
            key: "isGateExists",
            value: function isGateExists(gateName) {
                return this.client.isGateExist(gateName);
            }
        },
        {
            key: "isExperimentExists",
            value: function isExperimentExists(experimentName) {
                return this.client.isExperimentExist(experimentName);
            }
        }
    ]);
}();
$5fae527dfb0964cc$var$_FeatureGates = $5fae527dfb0964cc$var$FeatureGates;
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($5fae527dfb0964cc$var$FeatureGates, "client", new (0, $ecTmL.Client)());
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($5fae527dfb0964cc$var$FeatureGates, "hasCheckGateErrorOccurred", false);
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($5fae527dfb0964cc$var$FeatureGates, "hasGetExperimentValueErrorOccurred", false);
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($5fae527dfb0964cc$var$FeatureGates, "checkGate", function(gateName, options) {
    try {
        // Check if the CRITERION override mechanism is available
        if (typeof window !== 'undefined' && window.__CRITERION__ && typeof window.__CRITERION__.getFeatureFlagOverride === 'function') {
            // Attempt to retrieve an override value for the feature gate
            var overrideValue = window.__CRITERION__.getFeatureFlagOverride(gateName);
            // If an override value is found, return it immediately
            if (overrideValue !== undefined) return overrideValue;
        }
    } catch (error) {
        // Log the first occurrence of the error
        if (!$5fae527dfb0964cc$var$_FeatureGates.hasCheckGateErrorOccurred) {
            // eslint-disable-next-line no-console
            console.warn({
                msg: 'An error has occurred checking the feature gate from criterion override. Only the first occurrence of this error is logged.',
                gateName: gateName,
                error: error
            });
            $5fae527dfb0964cc$var$_FeatureGates.hasCheckGateErrorOccurred = true;
        }
    }
    // Proceed with the main logic if no override is found
    return $5fae527dfb0964cc$var$_FeatureGates.client.checkGate(gateName, options);
});
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($5fae527dfb0964cc$var$FeatureGates, "getExperimentValue", function(experimentName, parameterName, defaultValue, options) {
    try {
        // Check if the CRITERION override mechanism is available
        if (typeof window !== 'undefined' && window.__CRITERION__ && typeof window.__CRITERION__.getExperimentValueOverride === 'function') {
            var overrideValue = window.__CRITERION__.getExperimentValueOverride(experimentName, parameterName);
            if (overrideValue !== undefined && overrideValue !== null) return overrideValue;
        }
    } catch (error) {
        // Log the first occurrence of the error
        if (!$5fae527dfb0964cc$var$_FeatureGates.hasGetExperimentValueErrorOccurred) {
            // eslint-disable-next-line no-console
            console.warn({
                msg: 'An error has occurred getting the experiment value from criterion override. Only the first occurrence of this error is logged.',
                experimentName: experimentName,
                defaultValue: defaultValue,
                options: options,
                error: error
            });
            $5fae527dfb0964cc$var$_FeatureGates.hasGetExperimentValueErrorOccurred = true;
        }
        return defaultValue;
    }
    // Proceed with the main logic if no override is found
    return $5fae527dfb0964cc$var$_FeatureGates.client.getExperimentValue(experimentName, parameterName, defaultValue, options);
});
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($5fae527dfb0964cc$var$FeatureGates, "initializeCalled", $5fae527dfb0964cc$var$_FeatureGates.client.initializeCalled.bind($5fae527dfb0964cc$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($5fae527dfb0964cc$var$FeatureGates, "initializeCompleted", $5fae527dfb0964cc$var$_FeatureGates.client.initializeCompleted.bind($5fae527dfb0964cc$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($5fae527dfb0964cc$var$FeatureGates, "waitUntilInitializeCompleted", $5fae527dfb0964cc$var$_FeatureGates.client.waitUntilInitializeCompleted.bind($5fae527dfb0964cc$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($5fae527dfb0964cc$var$FeatureGates, "initialize", $5fae527dfb0964cc$var$_FeatureGates.client.initialize.bind($5fae527dfb0964cc$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($5fae527dfb0964cc$var$FeatureGates, "initializeWithProvider", $5fae527dfb0964cc$var$_FeatureGates.client.initializeWithProvider.bind($5fae527dfb0964cc$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($5fae527dfb0964cc$var$FeatureGates, "initializeFromValues", $5fae527dfb0964cc$var$_FeatureGates.client.initializeFromValues.bind($5fae527dfb0964cc$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($5fae527dfb0964cc$var$FeatureGates, "manuallyLogGateExposure", $5fae527dfb0964cc$var$_FeatureGates.client.manuallyLogGateExposure.bind($5fae527dfb0964cc$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($5fae527dfb0964cc$var$FeatureGates, "getExperiment", $5fae527dfb0964cc$var$_FeatureGates.client.getExperiment.bind($5fae527dfb0964cc$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($5fae527dfb0964cc$var$FeatureGates, "manuallyLogExperimentExposure", $5fae527dfb0964cc$var$_FeatureGates.client.manuallyLogExperimentExposure.bind($5fae527dfb0964cc$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($5fae527dfb0964cc$var$FeatureGates, "manuallyLogLayerExposure", $5fae527dfb0964cc$var$_FeatureGates.client.manuallyLogLayerExposure.bind($5fae527dfb0964cc$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($5fae527dfb0964cc$var$FeatureGates, "shutdownStatsig", $5fae527dfb0964cc$var$_FeatureGates.client.shutdownStatsig.bind($5fae527dfb0964cc$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($5fae527dfb0964cc$var$FeatureGates, "overrideGate", $5fae527dfb0964cc$var$_FeatureGates.client.overrideGate.bind($5fae527dfb0964cc$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($5fae527dfb0964cc$var$FeatureGates, "clearGateOverride", $5fae527dfb0964cc$var$_FeatureGates.client.clearGateOverride.bind($5fae527dfb0964cc$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($5fae527dfb0964cc$var$FeatureGates, "overrideConfig", $5fae527dfb0964cc$var$_FeatureGates.client.overrideConfig.bind($5fae527dfb0964cc$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($5fae527dfb0964cc$var$FeatureGates, "clearConfigOverride", $5fae527dfb0964cc$var$_FeatureGates.client.clearConfigOverride.bind($5fae527dfb0964cc$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($5fae527dfb0964cc$var$FeatureGates, "setOverrides", $5fae527dfb0964cc$var$_FeatureGates.client.setOverrides.bind($5fae527dfb0964cc$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($5fae527dfb0964cc$var$FeatureGates, "getOverrides", $5fae527dfb0964cc$var$_FeatureGates.client.getOverrides.bind($5fae527dfb0964cc$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($5fae527dfb0964cc$var$FeatureGates, "clearAllOverrides", $5fae527dfb0964cc$var$_FeatureGates.client.clearAllOverrides.bind($5fae527dfb0964cc$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($5fae527dfb0964cc$var$FeatureGates, "isCurrentUser", $5fae527dfb0964cc$var$_FeatureGates.client.isCurrentUser.bind($5fae527dfb0964cc$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($5fae527dfb0964cc$var$FeatureGates, "onGateUpdated", $5fae527dfb0964cc$var$_FeatureGates.client.onGateUpdated.bind($5fae527dfb0964cc$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($5fae527dfb0964cc$var$FeatureGates, "onExperimentValueUpdated", $5fae527dfb0964cc$var$_FeatureGates.client.onExperimentValueUpdated.bind($5fae527dfb0964cc$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($5fae527dfb0964cc$var$FeatureGates, "onAnyUpdated", $5fae527dfb0964cc$var$_FeatureGates.client.onAnyUpdated.bind($5fae527dfb0964cc$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($5fae527dfb0964cc$var$FeatureGates, "updateUser", $5fae527dfb0964cc$var$_FeatureGates.client.updateUser.bind($5fae527dfb0964cc$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($5fae527dfb0964cc$var$FeatureGates, "updateUserWithProvider", $5fae527dfb0964cc$var$_FeatureGates.client.updateUserWithProvider.bind($5fae527dfb0964cc$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($5fae527dfb0964cc$var$FeatureGates, "updateUserWithValues", $5fae527dfb0964cc$var$_FeatureGates.client.updateUserWithValues.bind($5fae527dfb0964cc$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($5fae527dfb0964cc$var$FeatureGates, "getPackageVersion", $5fae527dfb0964cc$var$_FeatureGates.client.getPackageVersion.bind($5fae527dfb0964cc$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($5fae527dfb0964cc$var$FeatureGates, "getLayer", $5fae527dfb0964cc$var$_FeatureGates.client.getLayer.bind($5fae527dfb0964cc$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($5fae527dfb0964cc$var$FeatureGates, "getLayerValue", $5fae527dfb0964cc$var$_FeatureGates.client.getLayerValue.bind($5fae527dfb0964cc$var$_FeatureGates.client));
var $5fae527dfb0964cc$var$boundFGJS = $5fae527dfb0964cc$var$FeatureGates;
// This makes it possible to get a reference to the FeatureGates client at runtime.
// This is important for overriding values in Cypress tests, as there needs to be a
// way to get the exact instance for a window in order to mock some of its methods.
if (typeof window !== 'undefined') {
    if (window.__FEATUREGATES_JS__ === undefined) window.__FEATUREGATES_JS__ = $5fae527dfb0964cc$var$FeatureGates;
    else {
        var $5fae527dfb0964cc$var$_boundFGJS, $5fae527dfb0964cc$var$_boundFGJS$getPackage;
        $5fae527dfb0964cc$var$boundFGJS = window.__FEATUREGATES_JS__;
        var $5fae527dfb0964cc$var$boundVersion = (($5fae527dfb0964cc$var$_boundFGJS = $5fae527dfb0964cc$var$boundFGJS) === null || $5fae527dfb0964cc$var$_boundFGJS === void 0 || ($5fae527dfb0964cc$var$_boundFGJS$getPackage = $5fae527dfb0964cc$var$_boundFGJS.getPackageVersion) === null || $5fae527dfb0964cc$var$_boundFGJS$getPackage === void 0 ? void 0 : $5fae527dfb0964cc$var$_boundFGJS$getPackage.call($5fae527dfb0964cc$var$_boundFGJS)) || '4.10.0 or earlier';
        if ($5fae527dfb0964cc$var$boundVersion !== (0, $e4dMb.CLIENT_VERSION)) {
            var $5fae527dfb0964cc$var$message = "Multiple versions of FeatureGateClients found on the current page.\n      The currently bound version is ".concat($5fae527dfb0964cc$var$boundVersion, " when module version ").concat((0, $e4dMb.CLIENT_VERSION), " was loading.");
            // eslint-disable-next-line no-console
            console.warn($5fae527dfb0964cc$var$message);
        }
    }
}
var /**
 * @property {FeatureGates} FeatureGate default export
 */ $5fae527dfb0964cc$export$2e2bcd8739ae039 = $5fae527dfb0964cc$var$boundFGJS;

});
parcelRegister("ecTmL", function(module, exports) {
$parcel$export(module.exports, "Client", () => $a57d2244df6ae635$export$1f2bb630327ac4b6);

var $1Vcia = parcelRequire("1Vcia");

var $iYJcE = parcelRequire("iYJcE");

var $fL8KA = parcelRequire("fL8KA");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $25nEq = parcelRequire("25nEq");

var $6HG4S = parcelRequire("6HG4S");

var $iFR7a = parcelRequire("iFR7a");

var $bKBEP = parcelRequire("bKBEP");

var $3h7xZ = parcelRequire("3h7xZ");

var $NJkAC = parcelRequire("NJkAC");

var $10ogQ = parcelRequire("10ogQ");

var $7tIA6 = parcelRequire("7tIA6");

var $9kIzJ = parcelRequire("9kIzJ");

var $iohKV = parcelRequire("iohKV");

var $7LnwL = parcelRequire("7LnwL");

var $dqDG8 = parcelRequire("dqDG8");

var $e4dMb = parcelRequire("e4dMb");
var $a57d2244df6ae635$var$_excluded = [
    "sdkKey",
    "environment",
    "updateUserCompletionCallback",
    "perimeter"
];
function $a57d2244df6ae635$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $a57d2244df6ae635$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $a57d2244df6ae635$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $a57d2244df6ae635$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $a57d2244df6ae635$var$DEFAULT_CLIENT_KEY = 'client-default-key';
// default event logging api is Atlassian proxy rather than Statsig's domain, to avoid ad blockers
var $a57d2244df6ae635$var$DEFAULT_EVENT_LOGGING_API = 'https://xp.atlassian.com/v1/rgstr';
var $a57d2244df6ae635$export$1f2bb630327ac4b6 = /*#__PURE__*/ function() {
    function Client() {
        var _this = this;
        var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, _ref$localStorageKey = _ref.localStorageKey, localStorageKey = _ref$localStorageKey === void 0 ? (0, $iohKV.LOCAL_STORAGE_KEY) : _ref$localStorageKey, overrideAdapter = _ref.overrideAdapter;
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, Client);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "initPromise", null);
        /** True if an initialize method was called and completed successfully. */ (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "initCompleted", false);
        /**
     * True if an initialize method was called and completed, meaning the client is now usable.
     * However if there was an error during initialization it may have initialized with default
     * values. Use {@link initCompleted} to check for this.
     */ (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "initWithDefaults", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "hasCheckGateErrorOccurred", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "hasGetExperimentErrorOccurred", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "hasGetExperimentValueErrorOccurred", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "hasGetLayerErrorOccurred", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "hasGetLayerValueErrorOccurred", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "subscriptions", new (0, $bKBEP.default)());
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "dataAdapter", new (0, $9kIzJ.NoFetchDataAdapter)());
        /**
     * Call this if modifying the values being served by the Statsig library since it has its own
     * memoization cache which will not be updated if the values are changed outside of the library.
     */ (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "statsigValuesUpdated", function() {
            if (_this.user) // Trigger a reset of the memoize cache
            _this.statsigClient.updateUserSync(_this.user, {
                disableBackgroundCacheRefresh: true
            });
            _this.subscriptions.anyUpdated();
        });
        this.overrideAdapter = overrideAdapter || new (0, $iohKV.PersistentOverrideAdapter)(localStorageKey);
    }
    /**
   * @description
   * This method initializes the client using a network call to fetch the bootstrap values.
   * If the client is inialized with an `analyticsWebClient`, it will send an operational event
   * to GASv3 with the following attributes:
   * - targetApp: the target app of the client
   * - clientVersion: the version of the client
   * - success: whether the initialization was successful
   * - startTime: the time when the initialization started
   * - totalTime: the total time it took to initialize the client
   * - apiKey: the api key used to initialize the client
   * @param clientOptions {ClientOptions}
   * @param identifiers {Identifiers}
   * @param customAttributes {CustomAttributes}
   * @returns {Promise<void>}
   */ return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(Client, [
        {
            key: "initialize",
            value: function() {
                var _initialize = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee(clientOptions, identifiers, customAttributes) {
                    var _this2 = this;
                    var clientOptionsWithDefaults, startTime;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee$(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                clientOptionsWithDefaults = (0, $dqDG8.getOptionsWithDefaults)(clientOptions);
                                if (!this.initPromise) {
                                    _context.next = 4;
                                    break;
                                }
                                if (!(0, $dqDG8.shallowEquals)(clientOptionsWithDefaults, this.initOptions)) // eslint-disable-next-line no-console
                                console.warn('Feature Gates client already initialized with different options. New options were not applied.');
                                return _context.abrupt("return", this.initPromise);
                            case 4:
                                startTime = performance.now();
                                this.initOptions = clientOptionsWithDefaults;
                                this.initPromise = this.init(clientOptionsWithDefaults, identifiers, customAttributes).then(function() {
                                    _this2.initCompleted = true;
                                    _this2.initWithDefaults = true;
                                }).finally(function() {
                                    var endTime = performance.now();
                                    var totalTime = endTime - startTime;
                                    _this2.fireClientEvent(startTime, totalTime, 'initialize', _this2.initCompleted, clientOptionsWithDefaults.apiKey);
                                });
                                return _context.abrupt("return", this.initPromise);
                            case 8:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee, this);
                }));
                function initialize(_x, _x2, _x3) {
                    return _initialize.apply(this, arguments);
                }
                return initialize;
            }()
        },
        {
            key: "initializeWithProvider",
            value: function() {
                var _initializeWithProvider = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee2(clientOptions, provider, identifiers, customAttributes) {
                    var _this3 = this;
                    var clientOptionsWithDefaults, startTime;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee2$(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                clientOptionsWithDefaults = (0, $dqDG8.getOptionsWithDefaults)(clientOptions);
                                if (!this.initPromise) {
                                    _context2.next = 4;
                                    break;
                                }
                                if (!(0, $dqDG8.shallowEquals)(clientOptionsWithDefaults, this.initOptions)) // eslint-disable-next-line no-console
                                console.warn('Feature Gates client already initialized with different options. New options were not applied.');
                                return _context2.abrupt("return", this.initPromise);
                            case 4:
                                startTime = performance.now();
                                this.initOptions = clientOptionsWithDefaults;
                                this.provider = provider;
                                this.provider.setClientVersion((0, $e4dMb.CLIENT_VERSION));
                                if (this.provider.setApplyUpdateCallback) this.provider.setApplyUpdateCallback(this.applyUpdateCallback.bind(this));
                                this.initPromise = this.initWithProvider(clientOptionsWithDefaults, provider, identifiers, customAttributes).then(function() {
                                    _this3.initCompleted = true;
                                    _this3.initWithDefaults = true;
                                }).finally(function() {
                                    var endTime = performance.now();
                                    var totalTime = endTime - startTime;
                                    _this3.fireClientEvent(startTime, totalTime, 'initializeWithProvider', _this3.initCompleted, provider.getApiKey ? provider.getApiKey() : undefined);
                                });
                                return _context2.abrupt("return", this.initPromise);
                            case 11:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2, this);
                }));
                function initializeWithProvider(_x4, _x5, _x6, _x7) {
                    return _initializeWithProvider.apply(this, arguments);
                }
                return initializeWithProvider;
            }()
        },
        {
            key: "applyUpdateCallback",
            value: function applyUpdateCallback(experimentsResult) {
                try {
                    if (this.initCompleted || this.initWithDefaults) {
                        this.assertInitialized(this.statsigClient);
                        this.dataAdapter.setBootstrapData(experimentsResult.experimentValues);
                        this.dataAdapter.setData(JSON.stringify(experimentsResult.experimentValues));
                        this.statsigValuesUpdated();
                    }
                } catch (error) {
                    // eslint-disable-next-line no-console
                    console.warn('Error when attempting to apply update', error);
                }
            }
        },
        {
            key: "fireClientEvent",
            value: function fireClientEvent(startTime, totalTime, action, success) {
                var _analyticsWebClient, _this4 = this;
                var apiKey = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
                (_analyticsWebClient = this.initOptions.analyticsWebClient) === null || _analyticsWebClient === void 0 || _analyticsWebClient.then(function(analyticsWebClient) {
                    var attributes = $a57d2244df6ae635$var$_objectSpread({
                        targetApp: _this4.initOptions.targetApp,
                        clientVersion: (0, $e4dMb.CLIENT_VERSION),
                        success: success,
                        startTime: startTime,
                        totalTime: totalTime
                    }, apiKey && {
                        apiKey: apiKey
                    });
                    analyticsWebClient.sendOperationalEvent({
                        action: action,
                        actionSubject: 'featureGatesClient',
                        attributes: attributes,
                        tags: [
                            'measurement'
                        ],
                        source: '@atlaskit/feature-gate-js-client'
                    });
                }).catch(function(err) {
                    if (_this4.initOptions.environment !== (0, $7LnwL.FeatureGateEnvironment).Production) // eslint-disable-next-line no-console
                    console.error('Analytics web client promise did not resolve', err);
                });
            }
        },
        {
            key: "initializeFromValues",
            value: function() {
                var _initializeFromValues = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee3(clientOptions, identifiers, customAttributes) {
                    var _this5 = this;
                    var initializeValues, clientOptionsWithDefaults, startTime, _args3 = arguments;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee3$(_context3) {
                        while(true)switch(_context3.prev = _context3.next){
                            case 0:
                                initializeValues = _args3.length > 3 && _args3[3] !== undefined ? _args3[3] : {};
                                clientOptionsWithDefaults = (0, $dqDG8.getOptionsWithDefaults)(clientOptions);
                                if (!this.initPromise) {
                                    _context3.next = 5;
                                    break;
                                }
                                if (!(0, $dqDG8.shallowEquals)(clientOptionsWithDefaults, this.initOptions)) // eslint-disable-next-line no-console
                                console.warn('Feature Gates client already initialized with different options. New options were not applied.');
                                return _context3.abrupt("return", this.initPromise);
                            case 5:
                                // This makes sure the new Statsig client behaves like the old when bootstrap data is
                                // passed, and `has_updates` isn't specified (which happens a lot in product integration tests).
                                if (!Object.prototype.hasOwnProperty.call(initializeValues, 'has_updates')) initializeValues['has_updates'] = true;
                                startTime = performance.now();
                                this.initOptions = clientOptionsWithDefaults;
                                this.initPromise = this.initFromValues(clientOptionsWithDefaults, identifiers, customAttributes, initializeValues).then(function() {
                                    _this5.initCompleted = true;
                                    _this5.initWithDefaults = true;
                                }).finally(function() {
                                    var endTime = performance.now();
                                    var totalTime = endTime - startTime;
                                    _this5.fireClientEvent(startTime, totalTime, 'initializeFromValues', _this5.initCompleted);
                                });
                                return _context3.abrupt("return", this.initPromise);
                            case 10:
                            case "end":
                                return _context3.stop();
                        }
                    }, _callee3, this);
                }));
                function initializeFromValues(_x8, _x9, _x0) {
                    return _initializeFromValues.apply(this, arguments);
                }
                return initializeFromValues;
            }()
        },
        {
            key: "assertInitialized",
            value: function assertInitialized(statsigClient) {
                if (!statsigClient) throw new Error('Client must be initialized before using this method');
            }
        },
        {
            key: "updateUser",
            value: function() {
                var _updateUser = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee4(fetchOptions, identifiers, customAttributes) {
                    var fetchOptionsWithDefaults, initializeValuesProducer;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee4$(_context4) {
                        while(true)switch(_context4.prev = _context4.next){
                            case 0:
                                this.assertInitialized(this.statsigClient);
                                fetchOptionsWithDefaults = (0, $dqDG8.getOptionsWithDefaults)(fetchOptions);
                                initializeValuesProducer = function initializeValuesProducer() {
                                    return (0, $7tIA6.default).fetchExperimentValues(fetchOptionsWithDefaults, identifiers, customAttributes).then(function(_ref2) {
                                        var experimentValues = _ref2.experimentValues, customAttributes = _ref2.customAttributes;
                                        return {
                                            experimentValues: experimentValues,
                                            customAttributesFromFetch: customAttributes
                                        };
                                    });
                                };
                                _context4.next = 5;
                                return this.updateUserUsingInitializeValuesProducer(initializeValuesProducer, identifiers, customAttributes);
                            case 5:
                            case "end":
                                return _context4.stop();
                        }
                    }, _callee4, this);
                }));
                function updateUser(_x1, _x10, _x11) {
                    return _updateUser.apply(this, arguments);
                }
                return updateUser;
            }()
        },
        {
            key: "updateUserWithProvider",
            value: function() {
                var _updateUserWithProvider = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee5(identifiers, customAttributes) {
                    var _this6 = this;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee5$(_context5) {
                        while(true)switch(_context5.prev = _context5.next){
                            case 0:
                                this.assertInitialized(this.statsigClient);
                                if (this.provider) {
                                    _context5.next = 3;
                                    break;
                                }
                                throw new Error('Cannot update user using provider as the client was not initialised with a provider');
                            case 3:
                                _context5.next = 5;
                                return this.provider.setProfile(this.initOptions, identifiers, customAttributes);
                            case 5:
                                _context5.next = 7;
                                return this.updateUserUsingInitializeValuesProducer(function() {
                                    return _this6.provider.getExperimentValues();
                                }, identifiers, customAttributes);
                            case 7:
                            case "end":
                                return _context5.stop();
                        }
                    }, _callee5, this);
                }));
                function updateUserWithProvider(_x12, _x13) {
                    return _updateUserWithProvider.apply(this, arguments);
                }
                return updateUserWithProvider;
            }()
        },
        {
            key: "updateUserWithValues",
            value: function() {
                var _updateUserWithValues = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee6(identifiers, customAttributes) {
                    var initializeValues, initializeValuesProducer, _args6 = arguments;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee6$(_context6) {
                        while(true)switch(_context6.prev = _context6.next){
                            case 0:
                                initializeValues = _args6.length > 2 && _args6[2] !== undefined ? _args6[2] : {};
                                this.assertInitialized(this.statsigClient);
                                initializeValuesProducer = function initializeValuesProducer() {
                                    return Promise.resolve({
                                        experimentValues: initializeValues,
                                        customAttributesFromFetch: customAttributes
                                    });
                                };
                                _context6.next = 5;
                                return this.updateUserUsingInitializeValuesProducer(initializeValuesProducer, identifiers, customAttributes);
                            case 5:
                            case "end":
                                return _context6.stop();
                        }
                    }, _callee6, this);
                }));
                function updateUserWithValues(_x14, _x15) {
                    return _updateUserWithValues.apply(this, arguments);
                }
                return updateUserWithValues;
            }()
        },
        {
            key: "initializeCalled",
            value: function initializeCalled() {
                return this.initPromise != null;
            }
        },
        {
            key: "initializeCompleted",
            value: function initializeCompleted() {
                return this.initCompleted;
            }
        },
        {
            key: "waitUntilInitializeCompleted",
            value: function() {
                var _waitUntilInitializeCompleted = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee7() {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee7$(_context7) {
                        while(true)switch(_context7.prev = _context7.next){
                            case 0:
                                if (this.initPromise) {
                                    _context7.next = 2;
                                    break;
                                }
                                throw new Error('The client must be initialized before you can wait until initialized.');
                            case 2:
                                if (!this.initCompleted) {
                                    _context7.next = 4;
                                    break;
                                }
                                return _context7.abrupt("return");
                            case 4:
                                _context7.next = 6;
                                return this.initPromise;
                            case 6:
                            case "end":
                                return _context7.stop();
                        }
                    }, _callee7, this);
                }));
                function waitUntilInitializeCompleted() {
                    return _waitUntilInitializeCompleted.apply(this, arguments);
                }
                return waitUntilInitializeCompleted;
            }()
        },
        {
            key: "checkGate",
            value: function checkGate(gateName) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                try {
                    this.assertInitialized(this.statsigClient);
                    var _options$fireGateExpo = options.fireGateExposure, fireGateExposure = _options$fireGateExpo === void 0 ? true : _options$fireGateExpo;
                    return this.statsigClient.checkGate(gateName, {
                        disableExposureLog: !fireGateExposure
                    });
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!this.hasCheckGateErrorOccurred) {
                        // eslint-disable-next-line no-console
                        console.warn({
                            msg: 'An error has occurred checking the feature gate. Only the first occurrence of this error is logged.',
                            gateName: gateName,
                            error: error
                        });
                        this.hasCheckGateErrorOccurred = true;
                    }
                    return false;
                }
            }
        },
        {
            key: "isGateExist",
            value: function isGateExist(gateName) {
                try {
                    this.assertInitialized(this.statsigClient);
                    var gate = this.statsigClient.getFeatureGate(gateName, {
                        disableExposureLog: true
                    });
                    return !gate.details.reason.includes('Unrecognized');
                } catch (error) {
                    // eslint-disable-next-line no-console
                    console.error("Error occurred when trying to check FeatureGate: ".concat(error));
                    // in case of error report true to avoid false positives.
                    return true;
                }
            }
        },
        {
            key: "isExperimentExist",
            value: function isExperimentExist(experimentName) {
                try {
                    this.assertInitialized(this.statsigClient);
                    var config = this.statsigClient.getExperiment(experimentName, {
                        disableExposureLog: true
                    });
                    return !config.details.reason.includes('Unrecognized');
                } catch (error) {
                    // eslint-disable-next-line no-console
                    console.error("Error occurred when trying to check Experiment: ".concat(error));
                    // in case of error report true to avoid false positives.
                    return true;
                }
            }
        },
        {
            key: "manuallyLogGateExposure",
            value: function manuallyLogGateExposure(gateName) {
                this.assertInitialized(this.statsigClient);
                // This is the approach recommended in the docs
                // https://docs.statsig.com/client/javascript-sdk/#manual-exposures-
                this.statsigClient.checkGate(gateName);
            }
        },
        {
            key: "getExperiment",
            value: function getExperiment(experimentName) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                try {
                    this.assertInitialized(this.statsigClient);
                    var _options$fireExperime = options.fireExperimentExposure, fireExperimentExposure = _options$fireExperime === void 0 ? true : _options$fireExperime;
                    return (0, $3h7xZ.DynamicConfig).fromExperiment(this.statsigClient.getExperiment(experimentName, {
                        disableExposureLog: !fireExperimentExposure
                    }));
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!this.hasGetExperimentErrorOccurred) {
                        // eslint-disable-next-line no-console
                        console.warn({
                            msg: 'An error has occurred getting the experiment. Only the first occurrence of this error is logged.',
                            experimentName: experimentName,
                            error: error
                        });
                        this.hasGetExperimentErrorOccurred = true;
                    }
                    // Return a default value
                    return new (0, $3h7xZ.DynamicConfig)(experimentName, {}, '', {
                        time: Date.now(),
                        reason: (0, $10ogQ.EvaluationReason).Error
                    });
                }
            }
        },
        {
            key: "getExperimentValue",
            value: function getExperimentValue(experimentName, parameterName, defaultValue) {
                var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var experiment = this.getExperiment(experimentName, options);
                try {
                    var typeGuard = options.typeGuard;
                    return experiment.get(parameterName, defaultValue, typeGuard);
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!this.hasGetExperimentValueErrorOccurred) {
                        // eslint-disable-next-line no-console
                        console.warn({
                            msg: 'An error has occurred getting the experiment value. Only the first occurrence of this error is logged.',
                            experimentName: experimentName,
                            defaultValue: defaultValue,
                            options: options,
                            error: error
                        });
                        this.hasGetExperimentValueErrorOccurred = true;
                    }
                    return defaultValue;
                }
            }
        },
        {
            key: "manuallyLogExperimentExposure",
            value: function manuallyLogExperimentExposure(experimentName) {
                this.assertInitialized(this.statsigClient);
                // This is the approach recommended in the docs
                // https://docs.statsig.com/client/javascript-sdk/#manual-exposures-
                this.statsigClient.getExperiment(experimentName);
            }
        },
        {
            key: "manuallyLogLayerExposure",
            value: function manuallyLogLayerExposure(layerName, parameterName) {
                var _this$statsigClient$g;
                this.assertInitialized(this.statsigClient);
                // This is the approach recommended in the docs
                // https://docs.statsig.com/client/javascript-sdk/#manual-exposures-
                (_this$statsigClient$g = this.statsigClient.getLayer(layerName)) === null || _this$statsigClient$g === void 0 || _this$statsigClient$g.get(parameterName);
            }
        },
        {
            key: "shutdownStatsig",
            value: function shutdownStatsig() {
                this.assertInitialized(this.statsigClient);
                this.statsigClient.shutdown();
            }
        },
        {
            key: "overrideGate",
            value: function overrideGate(gateName, value) {
                this.overrideAdapter.overrideGate(gateName, value);
                // Trigger a reset of the memoized gate value
                if (this.user) {
                    var _this$statsigClient;
                    (_this$statsigClient = this.statsigClient) === null || _this$statsigClient === void 0 || _this$statsigClient.updateUserSync(this.user, {
                        disableBackgroundCacheRefresh: true
                    });
                }
                this.statsigValuesUpdated();
            }
        },
        {
            key: "clearGateOverride",
            value: function clearGateOverride(gateName) {
                this.overrideAdapter.removeGateOverride(gateName);
                this.statsigValuesUpdated();
            }
        },
        {
            key: "overrideConfig",
            value: function overrideConfig(experimentName, values) {
                this.overrideAdapter.overrideDynamicConfig(experimentName, values);
                this.statsigValuesUpdated();
            }
        },
        {
            key: "clearConfigOverride",
            value: function clearConfigOverride(experimentName) {
                this.overrideAdapter.removeDynamicConfigOverride(experimentName);
                this.statsigValuesUpdated();
            }
        },
        {
            key: "setOverrides",
            value: function setOverrides(overrides) {
                this.overrideAdapter.setOverrides(overrides);
                this.statsigValuesUpdated();
            }
        },
        {
            key: "getOverrides",
            value: function getOverrides() {
                return this.overrideAdapter.getOverrides();
            }
        },
        {
            key: "clearAllOverrides",
            value: function clearAllOverrides() {
                this.overrideAdapter.removeAllOverrides();
                this.statsigValuesUpdated();
            }
        },
        {
            key: "isCurrentUser",
            value: function isCurrentUser(identifiers, customAttributes) {
                return (0, $dqDG8.shallowEquals)(this.currentIdentifiers, identifiers) && (0, $dqDG8.shallowEquals)(this.currentAttributes, customAttributes);
            }
        },
        {
            key: "onGateUpdated",
            value: function onGateUpdated(gateName, callback) {
                var _this7 = this;
                var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var wrapCallback = function wrapCallback(value) {
                    var _options$fireGateExpo2 = options.fireGateExposure, fireGateExposure = _options$fireGateExpo2 === void 0 ? true : _options$fireGateExpo2;
                    if (fireGateExposure) _this7.manuallyLogGateExposure(gateName);
                    try {
                        callback(value);
                    } catch (error) {
                        // eslint-disable-next-line no-console
                        console.warn("Error calling callback for gate ".concat(gateName, " with value ").concat(value), error);
                    }
                };
                return this.subscriptions.onGateUpdated(gateName, wrapCallback, this.checkGate.bind(this), options);
            }
        },
        {
            key: "onExperimentValueUpdated",
            value: function onExperimentValueUpdated(experimentName, parameterName, defaultValue, callback) {
                var _this8 = this;
                var options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
                var wrapCallback = function wrapCallback(value) {
                    var _options$fireExperime2 = options.fireExperimentExposure, fireExperimentExposure = _options$fireExperime2 === void 0 ? true : _options$fireExperime2;
                    if (fireExperimentExposure) _this8.manuallyLogExperimentExposure(experimentName);
                    try {
                        callback(value);
                    } catch (error) {
                        // eslint-disable-next-line no-console
                        console.warn("Error calling callback for experiment ".concat(experimentName, " with value ").concat(value), error);
                    }
                };
                return this.subscriptions.onExperimentValueUpdated(experimentName, parameterName, defaultValue, wrapCallback, this.getExperimentValue.bind(this), options);
            }
        },
        {
            key: "onAnyUpdated",
            value: function onAnyUpdated(callback) {
                return this.subscriptions.onAnyUpdated(callback);
            }
        },
        {
            key: "init",
            value: function() {
                var _init = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee8(clientOptions, identifiers, customAttributes) {
                    var fromValuesClientOptions, experimentValues, customAttributesFromResult, clientSdkKeyPromise, experimentValuesPromise, _yield$Promise$all, _yield$Promise$all2, experimentValuesResult;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee8$(_context8) {
                        while(true)switch(_context8.prev = _context8.next){
                            case 0:
                                fromValuesClientOptions = $a57d2244df6ae635$var$_objectSpread({}, clientOptions);
                                _context8.prev = 1;
                                // If client sdk key fetch fails, an error would be thrown and handled instead of waiting for
                                // the experiment values request to be settled, and it will fall back to use default values.
                                clientSdkKeyPromise = (0, $7tIA6.default).fetchClientSdk(clientOptions).then(function(value) {
                                    return fromValuesClientOptions.sdkKey = value.clientSdkKey;
                                });
                                experimentValuesPromise = (0, $7tIA6.default).fetchExperimentValues(clientOptions, identifiers, customAttributes); // Only wait for the experiment values request to finish and try to initialise the client
                                // with experiment values if both requests are successful. Else an error would be thrown and
                                // handled by the catch
                                _context8.next = 6;
                                return Promise.all([
                                    clientSdkKeyPromise,
                                    experimentValuesPromise
                                ]);
                            case 6:
                                _yield$Promise$all = _context8.sent;
                                _yield$Promise$all2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_yield$Promise$all, 2);
                                experimentValuesResult = _yield$Promise$all2[1];
                                experimentValues = experimentValuesResult.experimentValues;
                                customAttributesFromResult = experimentValuesResult.customAttributes;
                                _context8.next = 20;
                                break;
                            case 13:
                                _context8.prev = 13;
                                _context8.t0 = _context8["catch"](1);
                                if (_context8.t0 instanceof Error) // eslint-disable-next-line no-console
                                console.error("Error occurred when trying to fetch the Feature Gates client values, error: ".concat(_context8.t0 === null || _context8.t0 === void 0 ? void 0 : _context8.t0.message));
                                // eslint-disable-next-line no-console
                                console.warn("Initialising Statsig client without values");
                                _context8.next = 19;
                                return this.initFromValues(fromValuesClientOptions, identifiers, customAttributes);
                            case 19:
                                throw _context8.t0;
                            case 20:
                                return _context8.abrupt("return", this.initFromValues(fromValuesClientOptions, identifiers, customAttributesFromResult, experimentValues));
                            case 21:
                            case "end":
                                return _context8.stop();
                        }
                    }, _callee8, this, [
                        [
                            1,
                            13
                        ]
                    ]);
                }));
                function init(_x16, _x17, _x18) {
                    return _init.apply(this, arguments);
                }
                return init;
            }()
        },
        {
            key: "initWithProvider",
            value: function() {
                var _initWithProvider = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee9(baseClientOptions, provider, identifiers, customAttributes) {
                    var fromValuesClientOptions, experimentValues, customAttributesFromResult, clientSdkKeyPromise, experimentValuesPromise, _yield$Promise$all3, _yield$Promise$all4, experimentValuesResult;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee9$(_context9) {
                        while(true)switch(_context9.prev = _context9.next){
                            case 0:
                                fromValuesClientOptions = $a57d2244df6ae635$var$_objectSpread($a57d2244df6ae635$var$_objectSpread({}, baseClientOptions), {}, {
                                    disableCurrentPageLogging: true
                                });
                                _context9.prev = 1;
                                _context9.next = 4;
                                return provider.setProfile(baseClientOptions, identifiers, customAttributes);
                            case 4:
                                // If client sdk key fetch fails, an error would be thrown and handled instead of waiting for
                                // the experiment values request to be settled, and it will fall back to use default values.
                                clientSdkKeyPromise = provider.getClientSdkKey().then(function(value) {
                                    return fromValuesClientOptions.sdkKey = value;
                                });
                                experimentValuesPromise = provider.getExperimentValues(); // Only wait for the experiment values request to finish and try to initialise the client
                                // with experiment values if both requests are successful. Else an error would be thrown and
                                // handled by the catch
                                _context9.next = 8;
                                return Promise.all([
                                    clientSdkKeyPromise,
                                    experimentValuesPromise
                                ]);
                            case 8:
                                _yield$Promise$all3 = _context9.sent;
                                _yield$Promise$all4 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_yield$Promise$all3, 2);
                                experimentValuesResult = _yield$Promise$all4[1];
                                experimentValues = experimentValuesResult.experimentValues;
                                customAttributesFromResult = experimentValuesResult.customAttributesFromFetch;
                                _context9.next = 22;
                                break;
                            case 15:
                                _context9.prev = 15;
                                _context9.t0 = _context9["catch"](1);
                                if (_context9.t0 instanceof Error) // eslint-disable-next-line no-console
                                console.error("Error occurred when trying to fetch the Feature Gates client values, error: ".concat(_context9.t0 === null || _context9.t0 === void 0 ? void 0 : _context9.t0.message));
                                // eslint-disable-next-line no-console
                                console.warn("Initialising Statsig client without values");
                                _context9.next = 21;
                                return this.initFromValues(fromValuesClientOptions, identifiers, customAttributes);
                            case 21:
                                throw _context9.t0;
                            case 22:
                                return _context9.abrupt("return", this.initFromValues(fromValuesClientOptions, identifiers, customAttributesFromResult, experimentValues));
                            case 23:
                            case "end":
                                return _context9.stop();
                        }
                    }, _callee9, this, [
                        [
                            1,
                            15
                        ]
                    ]);
                }));
                function initWithProvider(_x19, _x20, _x21, _x22) {
                    return _initWithProvider.apply(this, arguments);
                }
                return initWithProvider;
            }()
        },
        {
            key: "initFromValues",
            value: function() {
                var _initFromValues = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee0(clientOptions, identifiers, customAttributes) {
                    var _newClientOptions$net;
                    var initializeValues, newClientOptions, sdkKey, environment, _updateUserCompletionCallback, _perimeter, restClientOptions, statsigOptions, _args0 = arguments;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee0$(_context0) {
                        while(true)switch(_context0.prev = _context0.next){
                            case 0:
                                initializeValues = _args0.length > 3 && _args0[3] !== undefined ? _args0[3] : {};
                                this.overrideAdapter.initFromStoredOverrides();
                                this.currentIdentifiers = identifiers;
                                this.currentAttributes = customAttributes;
                                newClientOptions = (0, $dqDG8.migrateInitializationOptions)(clientOptions);
                                if (!newClientOptions.sdkKey) newClientOptions.sdkKey = $a57d2244df6ae635$var$DEFAULT_CLIENT_KEY;
                                if (!((_newClientOptions$net = newClientOptions.networkConfig) !== null && _newClientOptions$net !== void 0 && _newClientOptions$net.logEventUrl)) newClientOptions.networkConfig = $a57d2244df6ae635$var$_objectSpread($a57d2244df6ae635$var$_objectSpread({}, newClientOptions.networkConfig), {}, {
                                    logEventUrl: $a57d2244df6ae635$var$DEFAULT_EVENT_LOGGING_API
                                });
                                if (newClientOptions.perimeter === (0, $7LnwL.PerimeterType).FEDRAMP_MODERATE) // disable all logging in FedRAMP to prevent egress of sensitive data
                                newClientOptions.disableLogging = true;
                                sdkKey = newClientOptions.sdkKey, environment = newClientOptions.environment, _updateUserCompletionCallback = newClientOptions.updateUserCompletionCallback, _perimeter = newClientOptions.perimeter, restClientOptions = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(newClientOptions, $a57d2244df6ae635$var$_excluded);
                                this.user = (0, $dqDG8.toStatsigUser)(identifiers, customAttributes);
                                statsigOptions = $a57d2244df6ae635$var$_objectSpread($a57d2244df6ae635$var$_objectSpread({}, restClientOptions), {}, {
                                    environment: {
                                        tier: environment
                                    },
                                    includeCurrentPageUrlWithEvents: false,
                                    dataAdapter: this.dataAdapter,
                                    overrideAdapter: this.overrideAdapter,
                                    logEventCompressionMode: (0, $iFR7a.LogEventCompressionMode).Forced
                                }); // Statsig validates the provided stableId against their own cookie, so we either need
                                // to update the cookie to match, or disable the validation completely.
                                if (identifiers.stableId) (0, $iFR7a.StableID).setOverride(identifiers.stableId, sdkKey);
                                else statsigOptions.disableStableID = true;
                                _context0.prev = 12;
                                this.statsigClient = new (0, $iFR7a.StatsigClient)(sdkKey, this.user, statsigOptions);
                                this.dataAdapter.setBootstrapData(initializeValues);
                                _context0.next = 17;
                                return this.statsigClient.initializeAsync();
                            case 17:
                                _context0.next = 29;
                                break;
                            case 19:
                                _context0.prev = 19;
                                _context0.t0 = _context0["catch"](12);
                                if (_context0.t0 instanceof Error) // eslint-disable-next-line no-console
                                console.error("Error occurred when trying to initialise the Statsig client, error: ".concat(_context0.t0 === null || _context0.t0 === void 0 ? void 0 : _context0.t0.message));
                                // eslint-disable-next-line no-console
                                console.warn("Initialising Statsig client with default sdk key and without values");
                                this.statsigClient = new (0, $iFR7a.StatsigClient)($a57d2244df6ae635$var$DEFAULT_CLIENT_KEY, this.user, statsigOptions);
                                this.dataAdapter.setBootstrapData();
                                _context0.next = 27;
                                return this.statsigClient.initializeAsync();
                            case 27:
                                this.initWithDefaults = true;
                                throw _context0.t0;
                            case 29:
                            case "end":
                                return _context0.stop();
                        }
                    }, _callee0, this, [
                        [
                            12,
                            19
                        ]
                    ]);
                }));
                function initFromValues(_x23, _x24, _x25) {
                    return _initFromValues.apply(this, arguments);
                }
                return initFromValues;
            }()
        },
        {
            key: "updateUserUsingInitializeValuesProducer",
            value: function() {
                var _updateUserUsingInitializeValuesProducer = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee10(getInitializeValues, identifiers, customAttributes) {
                    var _this9 = this;
                    var originalInitPromise, initializeValuesPromise, updateUserPromise;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee10$(_context10) {
                        while(true)switch(_context10.prev = _context10.next){
                            case 0:
                                this.assertInitialized(this.statsigClient);
                                if (this.initPromise) {
                                    _context10.next = 3;
                                    break;
                                }
                                throw new Error('The client must be initialized before you can update the user.');
                            case 3:
                                if (!this.isCurrentUser(identifiers, customAttributes)) {
                                    _context10.next = 5;
                                    break;
                                }
                                return _context10.abrupt("return", this.initPromise);
                            case 5:
                                // Wait for the current initialize/update to finish
                                originalInitPromise = this.initPromise;
                                _context10.prev = 6;
                                _context10.next = 9;
                                return this.initPromise;
                            case 9:
                                _context10.next = 13;
                                break;
                            case 11:
                                _context10.prev = 11;
                                _context10.t0 = _context10["catch"](6);
                            case 13:
                                initializeValuesPromise = getInitializeValues();
                                updateUserPromise = this.updateStatsigClientUser(initializeValuesPromise, identifiers, customAttributes); // We replace the init promise here since we are essentially re-initializing the client at this
                                // point. Any subsequent calls to await client.initialize() or client.updateUser()
                                // will now also await this user update.
                                this.initPromise = updateUserPromise.catch(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee1() {
                                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee1$(_context1) {
                                        while(true)switch(_context1.prev = _context1.next){
                                            case 0:
                                                // If the update failed then it changed nothing, so revert back to the original promise.
                                                _this9.initPromise = originalInitPromise;
                                                // Set the user profile again to revert back to the current user
                                                if (!_this9.provider) {
                                                    _context1.next = 4;
                                                    break;
                                                }
                                                _context1.next = 4;
                                                return _this9.provider.setProfile(_this9.initOptions, _this9.currentIdentifiers, _this9.currentAttributes);
                                            case 4:
                                            case "end":
                                                return _context1.stop();
                                        }
                                    }, _callee1);
                                })));
                                return _context10.abrupt("return", updateUserPromise);
                            case 17:
                            case "end":
                                return _context10.stop();
                        }
                    }, _callee10, this, [
                        [
                            6,
                            11
                        ]
                    ]);
                }));
                function updateUserUsingInitializeValuesProducer(_x26, _x27, _x28) {
                    return _updateUserUsingInitializeValuesProducer.apply(this, arguments);
                }
                return updateUserUsingInitializeValuesProducer;
            }()
        },
        {
            key: "updateStatsigClientUser",
            value: function() {
                var _updateStatsigClientUser = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee11(initializeValuesPromise, identifiers, customAttributes) {
                    var _this$initOptions, _this$initOptions$upd;
                    var initializeValues, user, _updateUserCompletion, _ref4, errMsg, success, errorMessage;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee11$(_context11) {
                        while(true)switch(_context11.prev = _context11.next){
                            case 0:
                                this.assertInitialized(this.statsigClient);
                                _context11.prev = 1;
                                _context11.next = 4;
                                return initializeValuesPromise;
                            case 4:
                                initializeValues = _context11.sent;
                                user = (0, $dqDG8.toStatsigUser)(identifiers, initializeValues.customAttributesFromFetch);
                                _context11.next = 13;
                                break;
                            case 8:
                                _context11.prev = 8;
                                _context11.t0 = _context11["catch"](1);
                                // Make sure the updateUserCompletionCallback is called for any errors in our custom code.
                                // This is not necessary for the updateUserWithValues call, because the Statsig client will
                                // already invoke the callback itself.
                                errMsg = _context11.t0 instanceof Error ? _context11.t0.message : JSON.stringify(_context11.t0);
                                (_updateUserCompletion = (_ref4 = this.initOptions).updateUserCompletionCallback) === null || _updateUserCompletion === void 0 || _updateUserCompletion.call(_ref4, false, errMsg);
                                throw _context11.t0;
                            case 13:
                                success = true;
                                errorMessage = null;
                                _context11.prev = 15;
                                this.dataAdapter.setBootstrapData(initializeValues.experimentValues);
                                this.user = user;
                                if (!this.user) {
                                    _context11.next = 21;
                                    break;
                                }
                                _context11.next = 21;
                                return this.statsigClient.updateUserAsync(this.user);
                            case 21:
                                _context11.next = 27;
                                break;
                            case 23:
                                _context11.prev = 23;
                                _context11.t1 = _context11["catch"](15);
                                success = false;
                                errorMessage = String(_context11.t1);
                            case 27:
                                (_this$initOptions = this.initOptions) === null || _this$initOptions === void 0 || (_this$initOptions$upd = _this$initOptions.updateUserCompletionCallback) === null || _this$initOptions$upd === void 0 || _this$initOptions$upd.call(_this$initOptions, success, errorMessage);
                                if (!success) {
                                    _context11.next = 34;
                                    break;
                                }
                                this.currentIdentifiers = identifiers;
                                this.currentAttributes = customAttributes;
                                this.subscriptions.anyUpdated();
                                _context11.next = 35;
                                break;
                            case 34:
                                throw new Error('Failed to update user. An unexpected error occured.');
                            case 35:
                            case "end":
                                return _context11.stop();
                        }
                    }, _callee11, this, [
                        [
                            1,
                            8
                        ],
                        [
                            15,
                            23
                        ]
                    ]);
                }));
                function updateStatsigClientUser(_x29, _x30, _x31) {
                    return _updateStatsigClientUser.apply(this, arguments);
                }
                return updateStatsigClientUser;
            }()
        },
        {
            key: "getPackageVersion",
            value: /**
     * @returns string version of the current package in semver style.
     */ function getPackageVersion() {
                return 0, $e4dMb.CLIENT_VERSION;
            }
        },
        {
            key: "getLayer",
            value: function getLayer(/** The name of the layer */ layerName) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                try {
                    this.assertInitialized(this.statsigClient);
                    var _options$fireLayerExp = options.fireLayerExposure, fireLayerExposure = _options$fireLayerExp === void 0 ? true : _options$fireLayerExp;
                    return (0, $NJkAC.Layer).fromLayer(this.statsigClient.getLayer(layerName, {
                        disableExposureLog: !fireLayerExposure
                    }));
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!this.hasGetLayerErrorOccurred) {
                        // eslint-disable-next-line no-console
                        console.warn({
                            msg: 'An error has occurred getting the layer. Only the first occurrence of this error is logged.',
                            layerName: layerName,
                            error: error
                        });
                        this.hasGetLayerErrorOccurred = true;
                    }
                    // Return a default value
                    return (0, $NJkAC.Layer).fromLayer((0, $iFR7a._makeLayer)(layerName, {
                        reason: 'Error'
                    }, null));
                }
            }
        },
        {
            key: "getLayerValue",
            value: function getLayerValue(layerName, parameterName, defaultValue) {
                var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var layer = this.getLayer(layerName, options);
                try {
                    var typeGuard = options.typeGuard;
                    return layer.get(parameterName, defaultValue, typeGuard);
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!this.hasGetLayerValueErrorOccurred) {
                        // eslint-disable-next-line no-console
                        console.warn({
                            msg: 'An error has occurred getting the layer value. Only the first occurrence of this error is logged.',
                            layerName: layerName,
                            defaultValue: defaultValue,
                            options: options,
                            error: error
                        });
                        this.hasGetLayerValueErrorOccurred = true;
                    }
                    return defaultValue;
                }
            }
        }
    ]);
}();

});
parcelRegister("bKBEP", function(module, exports) {
$parcel$export(module.exports, "default", () => $88e1339797c2ecac$export$2e2bcd8739ae039);

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $25nEq = parcelRequire("25nEq");

var $hLfKH = parcelRequire("hLfKH");
function $88e1339797c2ecac$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $88e1339797c2ecac$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $88e1339797c2ecac$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $88e1339797c2ecac$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $88e1339797c2ecac$export$a66cbd9b2289cd78 = '@all-features';
var $88e1339797c2ecac$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function Subscriptions() {
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, Subscriptions);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "eventToValue", new Map());
        this.emitter = new (0, (/*@__PURE__*/$parcel$interopDefault($hLfKH)))();
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(Subscriptions, [
        {
            key: "onGateUpdated",
            value: function onGateUpdated(gateName, callback, checkGate, options) {
                var _this = this;
                var value = checkGate(gateName, $88e1339797c2ecac$var$_objectSpread($88e1339797c2ecac$var$_objectSpread({}, options), {}, {
                    fireGateExposure: false
                }));
                if (this.eventToValue.get(callback) === undefined) this.eventToValue.set(callback, value);
                var wrapCallback = function wrapCallback() {
                    var value = checkGate(gateName, $88e1339797c2ecac$var$_objectSpread($88e1339797c2ecac$var$_objectSpread({}, options), {}, {
                        fireGateExposure: false
                    }));
                    var existingValue = _this.eventToValue.get(callback);
                    if (existingValue !== value) {
                        _this.eventToValue.set(callback, value);
                        callback(value);
                    }
                };
                this.emitter.on(gateName, wrapCallback);
                return function() {
                    _this.emitter.off(gateName, wrapCallback);
                };
            }
        },
        {
            key: "onExperimentValueUpdated",
            value: function onExperimentValueUpdated(experimentName, parameterName, defaultValue, callback, getExperimentValue, options) {
                var _this2 = this;
                var experimentEventName = "".concat(experimentName, ".").concat(parameterName);
                var value = getExperimentValue(experimentName, parameterName, defaultValue, $88e1339797c2ecac$var$_objectSpread($88e1339797c2ecac$var$_objectSpread({}, options), {}, {
                    fireExperimentExposure: false
                }));
                if (this.eventToValue.get(callback) === undefined) this.eventToValue.set(callback, value);
                var wrapCallback = function wrapCallback() {
                    var value = getExperimentValue(experimentName, parameterName, defaultValue, $88e1339797c2ecac$var$_objectSpread($88e1339797c2ecac$var$_objectSpread({}, options), {}, {
                        fireExperimentExposure: false
                    }));
                    var existingValue = _this2.eventToValue.get(callback);
                    if (existingValue !== value) {
                        _this2.eventToValue.set(callback, value);
                        callback(value);
                    }
                };
                this.emitter.on(experimentEventName, wrapCallback);
                return function() {
                    _this2.emitter.off(experimentEventName, wrapCallback);
                };
            }
        },
        {
            key: "onAnyUpdated",
            value: function onAnyUpdated(callback) {
                var _this3 = this;
                this.emitter.on($88e1339797c2ecac$export$a66cbd9b2289cd78, callback);
                return function() {
                    _this3.emitter.off($88e1339797c2ecac$export$a66cbd9b2289cd78, callback);
                };
            }
        },
        {
            key: "anyUpdated",
            value: function anyUpdated() {
                var _this4 = this;
                this.emitter.emit($88e1339797c2ecac$export$a66cbd9b2289cd78);
                this.emitter.eventNames().filter(function(name) {
                    return name !== $88e1339797c2ecac$export$a66cbd9b2289cd78;
                }).forEach(function(event) {
                    _this4.emitter.emit(event);
                });
            }
        }
    ]);
}();

});

parcelRegister("3h7xZ", function(module, exports) {
$parcel$export(module.exports, "DynamicConfig", () => $2628d05ff189ce63$export$6dc24881a3d96325);

var $ekGgq = parcelRequire("ekGgq");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $dqDG8 = parcelRequire("dqDG8");
var $2628d05ff189ce63$export$6dc24881a3d96325 = /*#__PURE__*/ function() {
    function DynamicConfig(configName, configValue, ruleID, evaluationDetails) {
        var secondaryExposures = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : [];
        var allocatedExperimentName = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : '';
        var onDefaultValueFallback = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : null;
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, DynamicConfig);
        this.value = configValue;
        this._name = configName;
        this._ruleID = ruleID;
        this._secondaryExposures = secondaryExposures;
        this._allocatedExperimentName = allocatedExperimentName;
        this._evaluationDetails = evaluationDetails;
        this._onDefaultValueFallback = onDefaultValueFallback;
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(DynamicConfig, [
        {
            key: "get",
            value: function get(key, defaultValue, typeGuard) {
                var _this$_onDefaultValue2;
                var val = this.getValue(key, defaultValue);
                if (val == null) return defaultValue;
                var expectedType = Array.isArray(defaultValue) ? 'array' : (0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(defaultValue);
                var actualType = Array.isArray(val) ? 'array' : (0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(val);
                if (typeGuard) {
                    var _this$_onDefaultValue;
                    if (typeGuard(val)) {
                        this.fireExposure(key);
                        return val;
                    }
                    (_this$_onDefaultValue = this._onDefaultValueFallback) === null || _this$_onDefaultValue === void 0 || _this$_onDefaultValue.call(this, this, key, expectedType, actualType);
                    return defaultValue;
                }
                if (defaultValue == null || expectedType === actualType) {
                    this.fireExposure(key);
                    return val;
                }
                (_this$_onDefaultValue2 = this._onDefaultValueFallback) === null || _this$_onDefaultValue2 === void 0 || _this$_onDefaultValue2.call(this, this, key, expectedType, actualType);
                return defaultValue;
            }
        },
        {
            key: "getValue",
            value: function getValue(key, defaultValue) {
                if (key == null) return this.value;
                if (defaultValue == null) defaultValue = null;
                if (this.value[key] == null) return defaultValue;
                this.fireExposure(key);
                return this.value[key];
            }
        },
        {
            key: "fireExposure",
            value: function fireExposure(key) {
                // Call the wrapped experiment's get method to fire exposure
                if (this.experiment) this.experiment.get(key);
            }
        }
    ], [
        {
            key: "fromExperiment",
            value: function fromExperiment(experiment) {
                var _experiment$__evaluat, _experiment$__evaluat2, _experiment$groupName;
                var config = new DynamicConfig(experiment.name, experiment.value, experiment.ruleID, (0, $dqDG8.migrateEvaluationDetails)(experiment.details), (0, $dqDG8.migrateSecondaryExposures)((_experiment$__evaluat = (_experiment$__evaluat2 = experiment.__evaluation) === null || _experiment$__evaluat2 === void 0 ? void 0 : _experiment$__evaluat2.secondary_exposures) !== null && _experiment$__evaluat !== void 0 ? _experiment$__evaluat : []), (_experiment$groupName = experiment.groupName) !== null && _experiment$groupName !== void 0 ? _experiment$groupName : undefined);
                config.experiment = experiment;
                return config;
            }
        }
    ]);
}();

});
parcelRegister("dqDG8", function(module, exports) {
$parcel$export(module.exports, "getOptionsWithDefaults", () => $9c6c7b64a6b6d7d0$export$d119b37e5f788b43);
$parcel$export(module.exports, "shallowEquals", () => $9c6c7b64a6b6d7d0$export$fa1c2bbf4100b8bc);
$parcel$export(module.exports, "toStatsigUser", () => $9c6c7b64a6b6d7d0$export$3dad1db244472f32);
$parcel$export(module.exports, "migrateInitializationOptions", () => $9c6c7b64a6b6d7d0$export$202946b690d26d22);
$parcel$export(module.exports, "migrateEvaluationDetails", () => $9c6c7b64a6b6d7d0$export$18ad168d3dbac899);
$parcel$export(module.exports, "migrateSecondaryExposures", () => $9c6c7b64a6b6d7d0$export$55fd683752d01e67);

var $1Vcia = parcelRequire("1Vcia");

var $iYJcE = parcelRequire("iYJcE");

var $25nEq = parcelRequire("25nEq");

var $ygbGG = parcelRequire("ygbGG");

var $10ogQ = parcelRequire("10ogQ");

var $7LnwL = parcelRequire("7LnwL");
var $9c6c7b64a6b6d7d0$var$_excluded = [
    "api",
    "disableCurrentPageLogging",
    "loggingIntervalMillis",
    "loggingBufferMaxSize",
    "localMode",
    "eventLoggingApi",
    "eventLoggingApiForRetries",
    "disableLocalStorage",
    "ignoreWindowUndefined",
    "disableAllLogging",
    "initTimeoutMs",
    "disableNetworkKeepalive",
    "overrideStableID",
    "disableErrorLogging",
    "disableAutoMetricsLogging"
];
function $9c6c7b64a6b6d7d0$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $9c6c7b64a6b6d7d0$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $9c6c7b64a6b6d7d0$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $9c6c7b64a6b6d7d0$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $9c6c7b64a6b6d7d0$export$d119b37e5f788b43 = function getOptionsWithDefaults(options) {
    return $9c6c7b64a6b6d7d0$var$_objectSpread({
        /**
     * If more federal PerimeterTypes are added in the future, this should be updated so
     * that isFedRamp() === true always returns the strictest perimeter.
     */ perimeter: (0, $ygbGG.isFedRamp)() ? (0, $7LnwL.PerimeterType).FEDRAMP_MODERATE : (0, $7LnwL.PerimeterType).COMMERCIAL
    }, options);
};
var $9c6c7b64a6b6d7d0$export$fa1c2bbf4100b8bc = function shallowEquals(objectA, objectB) {
    if (!objectA && !objectB) return true;
    if (!objectA || !objectB) return false;
    var aEntries = Object.entries(objectA);
    var bEntries = Object.entries(objectB);
    if (aEntries.length !== bEntries.length) return false;
    var ascendingKeyOrder = function ascendingKeyOrder(_ref, _ref2) {
        var _ref3 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_ref, 1), key1 = _ref3[0];
        var _ref4 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_ref2, 1), key2 = _ref4[0];
        return key1.localeCompare(key2);
    };
    aEntries.sort(ascendingKeyOrder);
    bEntries.sort(ascendingKeyOrder);
    for(var i = 0; i < aEntries.length; i++){
        var _aEntries$i = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(aEntries[i], 2), aValue = _aEntries$i[1];
        var _bEntries$i = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(bEntries[i], 2), bValue = _bEntries$i[1];
        if (aValue !== bValue) return false;
    }
    return true;
};
var $9c6c7b64a6b6d7d0$export$3dad1db244472f32 = function toStatsigUser(identifiers, customAttributes) {
    var user = {
        customIDs: identifiers,
        custom: customAttributes
    };
    if (identifiers.atlassianAccountId) user.userID = identifiers.atlassianAccountId;
    return user;
};
var $9c6c7b64a6b6d7d0$export$202946b690d26d22 = function migrateInitializationOptions(options) {
    var api = options.api, disableCurrentPageLogging = options.disableCurrentPageLogging, loggingIntervalMillis = options.loggingIntervalMillis, loggingBufferMaxSize = options.loggingBufferMaxSize, localMode = options.localMode, eventLoggingApi = options.eventLoggingApi, eventLoggingApiForRetries = options.eventLoggingApiForRetries, disableLocalStorage = options.disableLocalStorage, ignoreWindowUndefined = options.ignoreWindowUndefined, disableAllLogging = options.disableAllLogging, _initTimeoutMs = options.initTimeoutMs, _disableNetworkKeepalive = options.disableNetworkKeepalive, _overrideStableID = options.overrideStableID, _disableErrorLogging = options.disableErrorLogging, _disableAutoMetricsLogging = options.disableAutoMetricsLogging, rest = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(options, $9c6c7b64a6b6d7d0$var$_excluded);
    return $9c6c7b64a6b6d7d0$var$_objectSpread($9c6c7b64a6b6d7d0$var$_objectSpread({}, rest), {}, {
        networkConfig: {
            api: api,
            logEventUrl: eventLoggingApi ? eventLoggingApi + 'rgstr' : undefined,
            logEventFallbackUrls: eventLoggingApiForRetries ? [
                eventLoggingApiForRetries
            ] : undefined,
            preventAllNetworkTraffic: localMode || !ignoreWindowUndefined && typeof window === 'undefined'
        },
        includeCurrentPageUrlWithEvents: !disableCurrentPageLogging,
        loggingIntervalMs: loggingIntervalMillis,
        loggingBufferMaxSize: loggingBufferMaxSize,
        disableStorage: disableLocalStorage === undefined ? localMode : disableLocalStorage,
        disableLogging: disableAllLogging === undefined ? localMode : disableAllLogging
    });
};
var $9c6c7b64a6b6d7d0$var$evaluationReasonMappings = Object.entries((0, $10ogQ.EvaluationReason)).map(function(_ref5) {
    var _ref6 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_ref5, 2), key = _ref6[0], value = _ref6[1];
    return [
        key.toLowerCase(),
        value
    ];
});
var $9c6c7b64a6b6d7d0$export$18ad168d3dbac899 = function migrateEvaluationDetails(details) {
    var _evaluationReasonMapp, _evaluationReasonMapp2, _details$receivedAt;
    var reasonLower = details.reason.toLowerCase();
    return {
        reason: (_evaluationReasonMapp = (_evaluationReasonMapp2 = $9c6c7b64a6b6d7d0$var$evaluationReasonMappings.find(function(_ref7) {
            var _ref8 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_ref7, 1), key = _ref8[0];
            return reasonLower.includes(key);
        })) === null || _evaluationReasonMapp2 === void 0 ? void 0 : _evaluationReasonMapp2[1]) !== null && _evaluationReasonMapp !== void 0 ? _evaluationReasonMapp : (0, $10ogQ.EvaluationReason).Unknown,
        time: (_details$receivedAt = details.receivedAt) !== null && _details$receivedAt !== void 0 ? _details$receivedAt : Date.now()
    };
};
var $9c6c7b64a6b6d7d0$export$55fd683752d01e67 = function migrateSecondaryExposures(secondaryExposures) {
    return secondaryExposures.map(function(exposure) {
        if (typeof exposure === 'string') // This should ideally have gateValue and ruleID fields too, but it's not possible for us
        // to determine the correct values for these.
        return {
            gate: exposure
        };
        return exposure;
    });
};

});
parcelRegister("10ogQ", function(module, exports) {
$parcel$export(module.exports, "EvaluationReason", () => $0bb89e2e2db7a4e8$export$c62558b199e46828);
// Reference: https://github.com/statsig-io/js-lite/blob/main/src/StatsigStore.ts
var $0bb89e2e2db7a4e8$export$c62558b199e46828 = /*#__PURE__*/ function(EvaluationReason) {
    // Order is important since the logic for migrating from a new client reason to an old one
    // returns the first which is a substring of the new client reason
    EvaluationReason["Error"] = "Error";
    EvaluationReason["LocalOverride"] = "LocalOverride";
    EvaluationReason["Unrecognized"] = "Unrecognized";
    EvaluationReason["Uninitialized"] = "Uninitialized";
    EvaluationReason["NetworkNotModified"] = "NetworkNotModified";
    EvaluationReason["Network"] = "Network";
    EvaluationReason["InvalidBootstrap"] = "InvalidBootstrap";
    EvaluationReason["Bootstrap"] = "Bootstrap";
    EvaluationReason["Cache"] = "Cache";
    // For when we could not migrate the reason from the new client
    EvaluationReason["Unknown"] = "Unknown";
    return EvaluationReason;
}({}); // Reference: https://github.com/statsig-io/js-lite/blob/main/src/StatsigSDKOptions.ts

});

parcelRegister("7LnwL", function(module, exports) {
$parcel$export(module.exports, "FeatureGateEnvironment", () => $5a6f2c40498279d1$export$479e7351a733299);
$parcel$export(module.exports, "PerimeterType", () => $5a6f2c40498279d1$export$c42b7bbc5e7ba555);
/**
 * The identifiers for the user. Options are restricted to the set that is currently supported.
 */ /**
 * Base client options. Does not include any options specific to providers
 * @interface BaseClientOptions
 * @property {FeatureGateEnvironment} environment - The environment for the client.
 * @property {string} targetApp - The target app for the client.
 * @property {AnalyticsWebClient} analyticsWebClient - The analytics web client.
 * @property {PerimeterType} perimeter - The perimeter for the client.
 */ /**
 * The options for the client.
 * @interface ClientOptions
 * @extends {BaseClientOptions}
 * @property {string} apiKey - The API key for the client.
 * @property {fetchTimeoutMs} fetchTimeoutMs - The timeout for the fetch request in milliseconds. Defaults to 5000.
 * @property {boolean} useGatewayURL - Whether to use the gateway URL. Defaults to false.
 */ /**
 * The custom attributes for the user.
 */ var $5a6f2c40498279d1$export$479e7351a733299 = /*#__PURE__*/ function(FeatureGateEnvironment) {
    FeatureGateEnvironment["Development"] = "development";
    FeatureGateEnvironment["Staging"] = "staging";
    FeatureGateEnvironment["Production"] = "production";
    return FeatureGateEnvironment;
}({});
var $5a6f2c40498279d1$export$c42b7bbc5e7ba555 = /*#__PURE__*/ function(PerimeterType) {
    PerimeterType["COMMERCIAL"] = "commercial";
    PerimeterType["FEDRAMP_MODERATE"] = "fedramp-moderate";
    return PerimeterType;
}({});
var $5a6f2c40498279d1$export$42f4885608027d0c = 'non_boolean'; // Type magic to get the JSDoc comments from the Client class methods to appear on the static
 // methods in FeatureGates where the property name and function type are identical

});



parcelRegister("NJkAC", function(module, exports) {
$parcel$export(module.exports, "Layer", () => $0957bd8734274e28$export$936d0764594b6eb3);

var $ekGgq = parcelRequire("ekGgq");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $dqDG8 = parcelRequire("dqDG8");
var $0957bd8734274e28$export$936d0764594b6eb3 = /*#__PURE__*/ function() {
    function Layer(name, layerValue, ruleID, evaluationDetails) {
        var logParameterFunction = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
        var secondaryExposures = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : [];
        var undelegatedSecondaryExposures = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : [];
        var allocatedExperimentName = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : '';
        var explicitParameters = arguments.length > 8 && arguments[8] !== undefined ? arguments[8] : [];
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, Layer);
        this._logParameterFunction = logParameterFunction;
        this._name = name;
        this._value = JSON.parse(JSON.stringify(layerValue !== null && layerValue !== void 0 ? layerValue : {}));
        this._ruleID = ruleID !== null && ruleID !== void 0 ? ruleID : '';
        this._evaluationDetails = evaluationDetails;
        this._secondaryExposures = secondaryExposures;
        this._undelegatedSecondaryExposures = undelegatedSecondaryExposures;
        this._allocatedExperimentName = allocatedExperimentName;
        this._explicitParameters = explicitParameters;
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(Layer, [
        {
            key: "get",
            value: function get(key, defaultValue, typeGuard) {
                var _this = this;
                var val = this._value[key];
                if (val == null) return defaultValue;
                var logAndReturn = function logAndReturn() {
                    _this._logLayerParameterExposure(key);
                    return val;
                };
                if (typeGuard) return typeGuard(val) ? logAndReturn() : defaultValue;
                if (defaultValue == null) return logAndReturn();
                if ((0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(val) === (0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(defaultValue) && Array.isArray(defaultValue) === Array.isArray(val)) return logAndReturn();
                return defaultValue;
            }
        },
        {
            key: "getValue",
            value: function getValue(key, defaultValue) {
                // eslint-disable-next-line eqeqeq
                if (defaultValue == undefined) defaultValue = null;
                var val = this._value[key];
                if (val != null) this._logLayerParameterExposure(key);
                return val !== null && val !== void 0 ? val : defaultValue;
            }
        },
        {
            key: "_logLayerParameterExposure",
            value: function _logLayerParameterExposure(parameterName) {
                var _this$_logParameterFu;
                (_this$_logParameterFu = this._logParameterFunction) === null || _this$_logParameterFu === void 0 || _this$_logParameterFu.call(this, this, parameterName);
            }
        }
    ], [
        {
            key: "fromLayer",
            value: function fromLayer(layer) {
                var _layer$__evaluation$s, _layer$__evaluation, _layer$__evaluation$u, _layer$__evaluation2, _layer$__evaluation3, _layer$__evaluation4;
                var value = new Layer(layer.name, layer.__value, layer.ruleID, (0, $dqDG8.migrateEvaluationDetails)(layer.details), function(_layer, parameterName) {
                    return layer.get(parameterName);
                }, (0, $dqDG8.migrateSecondaryExposures)((_layer$__evaluation$s = (_layer$__evaluation = layer.__evaluation) === null || _layer$__evaluation === void 0 ? void 0 : _layer$__evaluation.secondary_exposures) !== null && _layer$__evaluation$s !== void 0 ? _layer$__evaluation$s : []), (0, $dqDG8.migrateSecondaryExposures)((_layer$__evaluation$u = (_layer$__evaluation2 = layer.__evaluation) === null || _layer$__evaluation2 === void 0 ? void 0 : _layer$__evaluation2.undelegated_secondary_exposures) !== null && _layer$__evaluation$u !== void 0 ? _layer$__evaluation$u : []), (_layer$__evaluation3 = layer.__evaluation) === null || _layer$__evaluation3 === void 0 ? void 0 : _layer$__evaluation3.allocated_experiment_name, (_layer$__evaluation4 = layer.__evaluation) === null || _layer$__evaluation4 === void 0 ? void 0 : _layer$__evaluation4.explicit_parameters);
                return value;
            }
        }
    ]);
}();

});

parcelRegister("7tIA6", function(module, exports) {
$parcel$export(module.exports, "default", () => $571dd2bf98011403$export$2e2bcd8739ae039);

var $25nEq = parcelRequire("25nEq");

var $fL8KA = parcelRequire("fL8KA");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $6HG4S = parcelRequire("6HG4S");

var $7LnwL = parcelRequire("7LnwL");

var $e4dMb = parcelRequire("e4dMb");

var $eXIFi = parcelRequire("eXIFi");
function $571dd2bf98011403$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $571dd2bf98011403$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $571dd2bf98011403$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $571dd2bf98011403$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $571dd2bf98011403$var$DEFAULT_REQUEST_TIMEOUT_MS = 5000;
var $571dd2bf98011403$export$250a58ecde616daa = 'https://api.atlassian.com/flags';
var $571dd2bf98011403$export$942ba04389b0d5a2 = 'https://api.stg.atlassian.com/flags';
var $571dd2bf98011403$export$f058dbf75c3bc647 = 'https://api.dev.atlassian.com/flags';
var $571dd2bf98011403$export$1a401a0da8da3565 = 'https://api.stg.atlassian-us-gov-mod.com/flags';
var $571dd2bf98011403$export$18c93900db9358a4 = 'https://api.atlassian-us-gov-mod.com/flags';
var $571dd2bf98011403$export$4e8a0415edbfa1f7 = 'https://atlassian-statsig-proxy-archetype.atl-paas.%s.atl-ic.net';
var $571dd2bf98011403$export$cb3cd156f70d7e94 = 'oasis-stg.com/flags';
var $571dd2bf98011403$export$921fbc6cdfd4eee0 = 'atlassian-isolated.net/flags';
var $571dd2bf98011403$export$450bd8fb2a6d7ace = '/gateway/api/flags';
var $571dd2bf98011403$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function Fetcher() {
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, Fetcher);
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(Fetcher, null, [
        {
            key: "fetchClientSdk",
            value: function() {
                var _fetchClientSdk = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee(fetcherOptions) {
                    var targetApp, url;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee$(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                targetApp = fetcherOptions.targetApp;
                                url = "/api/v2/frontend/clientSdkKey/".concat(targetApp);
                                _context.prev = 2;
                                _context.next = 5;
                                return this.fetchRequest(url, 'GET', fetcherOptions);
                            case 5:
                                return _context.abrupt("return", _context.sent);
                            case 8:
                                _context.prev = 8;
                                _context.t0 = _context["catch"](2);
                                if (!(_context.t0 instanceof Error)) {
                                    _context.next = 12;
                                    break;
                                }
                                throw _context.t0;
                            case 12:
                                throw Error('Failed to retrieve client sdk key');
                            case 13:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee, this, [
                        [
                            2,
                            8
                        ]
                    ]);
                }));
                function fetchClientSdk(_x) {
                    return _fetchClientSdk.apply(this, arguments);
                }
                return fetchClientSdk;
            }()
        },
        {
            key: "fetchExperimentValues",
            value: function() {
                var _fetchExperimentValues = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee2(fetcherOptions, identifiers, customAttributes) {
                    var requestBody;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee2$(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                requestBody = {
                                    identifiers: identifiers,
                                    customAttributes: customAttributes,
                                    targetApp: fetcherOptions.targetApp
                                };
                                _context2.prev = 1;
                                _context2.next = 4;
                                return this.fetchRequest('/api/v2/frontend/experimentValues', 'POST', fetcherOptions, requestBody);
                            case 4:
                                return _context2.abrupt("return", _context2.sent);
                            case 7:
                                _context2.prev = 7;
                                _context2.t0 = _context2["catch"](1);
                                if (!(_context2.t0 instanceof Error)) {
                                    _context2.next = 11;
                                    break;
                                }
                                throw _context2.t0;
                            case 11:
                                throw Error('Failed to retrieve experiment values');
                            case 12:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2, this, [
                        [
                            1,
                            7
                        ]
                    ]);
                }));
                function fetchExperimentValues(_x2, _x3, _x4) {
                    return _fetchExperimentValues.apply(this, arguments);
                }
                return fetchExperimentValues;
            }()
        },
        {
            key: "handleResponseError",
            value: function() {
                var _handleResponseError = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee3(response) {
                    var body;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee3$(_context3) {
                        while(true)switch(_context3.prev = _context3.next){
                            case 0:
                                if (response.ok) {
                                    _context3.next = 5;
                                    break;
                                }
                                _context3.next = 3;
                                return response.text();
                            case 3:
                                body = _context3.sent;
                                throw new (0, $eXIFi.ResponseError)("Non 2xx response status received, status: ".concat(response.status, ", body: ").concat(JSON.stringify(body)));
                            case 5:
                                if (!(response.status === 204)) {
                                    _context3.next = 7;
                                    break;
                                }
                                throw new (0, $eXIFi.ResponseError)('Unexpected 204 response');
                            case 7:
                            case "end":
                                return _context3.stop();
                        }
                    }, _callee3);
                }));
                function handleResponseError(_x5) {
                    return _handleResponseError.apply(this, arguments);
                }
                return handleResponseError;
            }()
        },
        {
            key: "extractResponseBody",
            value: function() {
                var _extractResponseBody = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee4(response) {
                    var value;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee4$(_context4) {
                        while(true)switch(_context4.prev = _context4.next){
                            case 0:
                                _context4.next = 2;
                                return response.text();
                            case 2:
                                value = _context4.sent;
                                return _context4.abrupt("return", JSON.parse(value));
                            case 4:
                            case "end":
                                return _context4.stop();
                        }
                    }, _callee4);
                }));
                function extractResponseBody(_x6) {
                    return _extractResponseBody.apply(this, arguments);
                }
                return extractResponseBody;
            }()
        },
        {
            key: "getBaseUrl",
            value: function getBaseUrl(serviceEnv) {
                var useGatewayUrl = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
                var perimeter = arguments.length > 2 ? arguments[2] : undefined;
                var isolationContextId = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
                if (useGatewayUrl) return $571dd2bf98011403$export$450bd8fb2a6d7ace;
                if (perimeter === (0, $7LnwL.PerimeterType).FEDRAMP_MODERATE) switch(serviceEnv){
                    case (0, $7LnwL.FeatureGateEnvironment).Production:
                        return $571dd2bf98011403$export$18c93900db9358a4;
                    case (0, $7LnwL.FeatureGateEnvironment).Staging:
                        return $571dd2bf98011403$export$1a401a0da8da3565;
                    default:
                        throw new Error("Invalid environment \"".concat(serviceEnv, "\" for \"").concat(perimeter, "\" perimeter"));
                }
                else if (perimeter === (0, $7LnwL.PerimeterType).COMMERCIAL) switch(serviceEnv){
                    case (0, $7LnwL.FeatureGateEnvironment).Development:
                        return $571dd2bf98011403$export$f058dbf75c3bc647;
                    case (0, $7LnwL.FeatureGateEnvironment).Staging:
                        var apiUrl = this.getApiUrl(isolationContextId);
                        if (apiUrl !== null) return apiUrl;
                        return $571dd2bf98011403$export$942ba04389b0d5a2;
                    default:
                        var prodApiUrl = this.getApiUrl(isolationContextId);
                        if (prodApiUrl !== null) return prodApiUrl;
                        return $571dd2bf98011403$export$250a58ecde616daa;
                }
                else throw new Error("Invalid perimeter \"".concat(perimeter, "\""));
            }
        },
        {
            key: "fetchRequest",
            value: function() {
                var _fetchRequest = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee5(path, method, fetcherOptions, body) {
                    var baseUrl, fetchTimeout, abortSignal, abortController, response;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee5$(_context5) {
                        while(true)switch(_context5.prev = _context5.next){
                            case 0:
                                baseUrl = Fetcher.getBaseUrl(fetcherOptions.environment, fetcherOptions.useGatewayURL, fetcherOptions.perimeter, fetcherOptions.isolationContextId);
                                fetchTimeout = fetcherOptions.fetchTimeoutMs || $571dd2bf98011403$var$DEFAULT_REQUEST_TIMEOUT_MS;
                                if (AbortSignal.timeout) abortSignal = AbortSignal.timeout(fetchTimeout);
                                else if (AbortController) {
                                    abortController = new AbortController();
                                    abortSignal = abortController.signal;
                                    setTimeout(function() {
                                        return abortController.abort();
                                    }, fetchTimeout);
                                }
                                _context5.next = 5;
                                return fetch("".concat(baseUrl).concat(path), $571dd2bf98011403$var$_objectSpread({
                                    method: method,
                                    headers: {
                                        'Content-Type': 'application/json',
                                        'X-Client-Name': 'feature-gate-js-client',
                                        'X-Client-Version': (0, $e4dMb.CLIENT_VERSION),
                                        'X-API-KEY': fetcherOptions.apiKey
                                    },
                                    signal: abortSignal
                                }, body && {
                                    body: JSON.stringify(body)
                                }));
                            case 5:
                                response = _context5.sent;
                                _context5.next = 8;
                                return this.handleResponseError(response);
                            case 8:
                                _context5.next = 10;
                                return this.extractResponseBody(response);
                            case 10:
                                return _context5.abrupt("return", _context5.sent);
                            case 11:
                            case "end":
                                return _context5.stop();
                        }
                    }, _callee5, this);
                }));
                function fetchRequest(_x7, _x8, _x9, _x0) {
                    return _fetchRequest.apply(this, arguments);
                }
                return fetchRequest;
            }()
        },
        {
            key: "getApiUrl",
            value: function getApiUrl(isolationContextId) {
                var window1 = this.getWindowLocation();
                if (window1 === undefined) {
                    //this is needed when this SDK is used for SSR or plugin use cases where secret keys not available to use backend SDKs
                    if (!isolationContextId) return null;
                    return $571dd2bf98011403$export$4e8a0415edbfa1f7.replace('%s', isolationContextId);
                }
                var protocol = window1.protocol, hostname = window1.hostname;
                // Match last subdomain fragment before oasis-stg.com
                var oasisMatch = hostname.match(/([^.]+)\.oasis-stg\.com$/);
                if (oasisMatch) return "".concat(protocol, "//api.").concat(oasisMatch[1], ".").concat($571dd2bf98011403$export$cb3cd156f70d7e94);
                // Match last subdomain fragment before atlassian-isolated.net
                var isolatedMatch = hostname.match(/([^.]+)\.atlassian-isolated\.net$/);
                if (isolatedMatch) return "".concat(protocol, "//api.").concat(isolatedMatch[1], ".").concat($571dd2bf98011403$export$921fbc6cdfd4eee0);
                return null;
            }
        },
        {
            key: "getWindowLocation",
            value: function getWindowLocation() {
                if (typeof window !== 'undefined' && window.location) return window.location;
                return undefined;
            }
        }
    ]);
}();

});
parcelRegister("e4dMb", function(module, exports) {
$parcel$export(module.exports, "CLIENT_VERSION", () => $a3dc200b760ee03a$export$a59f8d67326bd1cb);
/// <reference types="node" />
var $a3dc200b760ee03a$export$a59f8d67326bd1cb = "0.0.0-development";

});

parcelRegister("eXIFi", function(module, exports) {
$parcel$export(module.exports, "ResponseError", () => $ae4938f0eed180d0$export$286baf652d0b1206);

var $arMYe = parcelRequire("arMYe");

var $9P61R = parcelRequire("9P61R");

var $kIXpt = parcelRequire("kIXpt");

var $cYPzS = parcelRequire("cYPzS");

var $eyuDe = parcelRequire("eyuDe");

var $c7s0H = parcelRequire("c7s0H");
function $ae4938f0eed180d0$var$_callSuper(t, o, e) {
    return o = (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(o), (0, (/*@__PURE__*/$parcel$interopDefault($kIXpt)))(t, $ae4938f0eed180d0$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(t).constructor) : o.apply(t, e));
}
function $ae4938f0eed180d0$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($ae4938f0eed180d0$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $ae4938f0eed180d0$export$286baf652d0b1206 = /*#__PURE__*/ function(_Error) {
    function ResponseError(message) {
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, ResponseError);
        return $ae4938f0eed180d0$var$_callSuper(this, ResponseError, [
            message
        ]);
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($eyuDe)))(ResponseError, _Error);
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(ResponseError);
}(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($c7s0H)))(Error));

});


parcelRegister("9kIzJ", function(module, exports) {
$parcel$export(module.exports, "NoFetchDataAdapter", () => $6cb88f0c18c5ad9d$export$55fffef3474104af);

var $fL8KA = parcelRequire("fL8KA");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $kIXpt = parcelRequire("kIXpt");

var $cYPzS = parcelRequire("cYPzS");

var $lwlXp = parcelRequire("lwlXp");

var $eyuDe = parcelRequire("eyuDe");

var $25nEq = parcelRequire("25nEq");

var $6HG4S = parcelRequire("6HG4S");

var $iFR7a = parcelRequire("iFR7a");
function $6cb88f0c18c5ad9d$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $6cb88f0c18c5ad9d$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $6cb88f0c18c5ad9d$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $6cb88f0c18c5ad9d$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $6cb88f0c18c5ad9d$var$_callSuper(t, o, e) {
    return o = (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(o), (0, (/*@__PURE__*/$parcel$interopDefault($kIXpt)))(t, $6cb88f0c18c5ad9d$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(t).constructor) : o.apply(t, e));
}
function $6cb88f0c18c5ad9d$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($6cb88f0c18c5ad9d$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $6cb88f0c18c5ad9d$var$_superPropGet(t, o, e, r) {
    var p = (0, (/*@__PURE__*/$parcel$interopDefault($lwlXp)))((0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(1 & r ? t.prototype : t), o, e);
    return 2 & r && "function" == typeof p ? function(t) {
        return p.apply(e, t);
    } : p;
}
var $6cb88f0c18c5ad9d$export$55fffef3474104af = /*#__PURE__*/ function(_DataAdapterCore) {
    function NoFetchDataAdapter() {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, NoFetchDataAdapter);
        _this = $6cb88f0c18c5ad9d$var$_callSuper(this, NoFetchDataAdapter, [
            'NoFetchDataAdapter',
            'nofetch'
        ]);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "bootstrapResult", null);
        return _this;
    }
    /**
   * Make sure to call this **before** calling `initializeAsync` or `updateUserAsync` but
   * after the Statsig client has been created!
   */ (0, (/*@__PURE__*/$parcel$interopDefault($eyuDe)))(NoFetchDataAdapter, _DataAdapterCore);
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(NoFetchDataAdapter, [
        {
            key: "setBootstrapData",
            value: function setBootstrapData(data) {
                this.bootstrapResult = data ? {
                    source: 'Bootstrap',
                    data: JSON.stringify(data),
                    receivedAt: Date.now(),
                    stableID: (0, $iFR7a.StableID).get(this._getSdkKey()),
                    fullUserHash: null
                } : null;
            }
        },
        {
            key: "prefetchData",
            value: function() {
                var _prefetchData = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee(_user, _options) {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee$(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee);
                }));
                function prefetchData(_x, _x2) {
                    return _prefetchData.apply(this, arguments);
                }
                return prefetchData;
            }()
        },
        {
            key: "getDataAsync",
            value: function() {
                var _getDataAsync = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee2(_current, user, _options) {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee2$(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                return _context2.abrupt("return", this.bootstrapResult && $6cb88f0c18c5ad9d$var$_objectSpread($6cb88f0c18c5ad9d$var$_objectSpread({}, this.bootstrapResult), {}, {
                                    fullUserHash: (0, $iFR7a._getFullUserHash)(user)
                                }));
                            case 1:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2, this);
                }));
                function getDataAsync(_x3, _x4, _x5) {
                    return _getDataAsync.apply(this, arguments);
                }
                return getDataAsync;
            }()
        },
        {
            key: "getDataSync",
            value: function getDataSync(user) {
                return this.bootstrapResult && $6cb88f0c18c5ad9d$var$_objectSpread($6cb88f0c18c5ad9d$var$_objectSpread({}, this.bootstrapResult), {}, {
                    fullUserHash: (0, $iFR7a._getFullUserHash)(user)
                });
            }
        },
        {
            key: "_fetchFromNetwork",
            value: function() {
                var _fetchFromNetwork2 = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee3(_current, _user, _options) {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee3$(_context3) {
                        while(true)switch(_context3.prev = _context3.next){
                            case 0:
                                return _context3.abrupt("return", null);
                            case 1:
                            case "end":
                                return _context3.stop();
                        }
                    }, _callee3);
                }));
                function _fetchFromNetwork(_x6, _x7, _x8) {
                    return _fetchFromNetwork2.apply(this, arguments);
                }
                return _fetchFromNetwork;
            }()
        },
        {
            key: "_getCacheKey",
            value: function _getCacheKey(user) {
                // Same logic as default data adapter
                // https://github.com/statsig-io/js-client-monorepo/blob/main/packages/js-client/src/StatsigEvaluationsDataAdapter.ts
                var key = (0, $iFR7a._getStorageKey)(this._getSdkKey(), user);
                return "".concat((0, $iFR7a.DataAdapterCachePrefix), ".").concat(this._cacheSuffix, ".").concat(key);
            }
        },
        {
            key: "_isCachedResultValidFor204",
            value: function _isCachedResultValidFor204(_result, _user) {
                return false;
            }
        },
        {
            key: "setDataLegacy",
            value: function setDataLegacy(data, user) {
                $6cb88f0c18c5ad9d$var$_superPropGet(NoFetchDataAdapter, "setData", this, 3)([
                    data,
                    user
                ]);
            }
        },
        {
            key: "toJSON",
            value: function toJSON() {
                var result = $6cb88f0c18c5ad9d$var$_objectSpread({}, this);
                delete result._options;
                delete result._inMemoryCache;
                delete result.bootstrapResult;
                return result;
            }
        }
    ]);
}((0, $iFR7a.DataAdapterCore));

});

parcelRegister("iohKV", function(module, exports) {
$parcel$export(module.exports, "LOCAL_STORAGE_KEY", () => $d6383dcf21a32680$export$d8474cff104280f3);
$parcel$export(module.exports, "PersistentOverrideAdapter", () => $d6383dcf21a32680$export$bcb28fbac1def494);

var $25nEq = parcelRequire("25nEq");

var $iYJcE = parcelRequire("iYJcE");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $dtn6l = parcelRequire("dtn6l");
function $d6383dcf21a32680$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $d6383dcf21a32680$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $d6383dcf21a32680$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $d6383dcf21a32680$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $d6383dcf21a32680$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $d6383dcf21a32680$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $d6383dcf21a32680$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $d6383dcf21a32680$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $d6383dcf21a32680$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $d6383dcf21a32680$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
var $d6383dcf21a32680$var$LOCAL_OVERRIDE_REASON = 'LocalOverride:Recognized';
var $d6383dcf21a32680$export$d8474cff104280f3 = 'STATSIG_OVERRIDES';
var $d6383dcf21a32680$var$LEGACY_LOCAL_STORAGE_KEY = 'STATSIG_JS_LITE_LOCAL_OVERRIDES';
var $d6383dcf21a32680$var$makeEmptyStore = function makeEmptyStore() {
    return {
        gates: {},
        configs: {},
        layers: {}
    };
};
var $d6383dcf21a32680$var$djb2MapKey = function djb2MapKey(hash, kind) {
    return kind + ':' + hash;
};
var $d6383dcf21a32680$export$bcb28fbac1def494 = /*#__PURE__*/ function() {
    function PersistentOverrideAdapter(localStorageKey) {
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, PersistentOverrideAdapter);
        this._overrides = $d6383dcf21a32680$var$makeEmptyStore();
        this._djb2Map = new Map();
        this._localStorageKey = localStorageKey;
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(PersistentOverrideAdapter, [
        {
            key: "parseStoredOverrides",
            value: function parseStoredOverrides(localStorageKey) {
                try {
                    var json = window.localStorage.getItem(localStorageKey);
                    if (!json) return $d6383dcf21a32680$var$makeEmptyStore();
                    return JSON.parse(json);
                } catch (_unused) {
                    return $d6383dcf21a32680$var$makeEmptyStore();
                }
            }
        },
        {
            key: "mergeOverrides",
            value: function mergeOverrides() {
                var merged = $d6383dcf21a32680$var$makeEmptyStore();
                for(var _len = arguments.length, allOverrides = new Array(_len), _key = 0; _key < _len; _key++)allOverrides[_key] = arguments[_key];
                for(var _i = 0, _allOverrides = allOverrides; _i < _allOverrides.length; _i++){
                    var overrides = _allOverrides[_i];
                    for(var _i2 = 0, _Object$entries = Object.entries((_overrides$gates = overrides.gates) !== null && _overrides$gates !== void 0 ? _overrides$gates : {}); _i2 < _Object$entries.length; _i2++){
                        var _overrides$gates;
                        var _Object$entries$_i = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_Object$entries[_i2], 2), name = _Object$entries$_i[0], value = _Object$entries$_i[1];
                        merged.gates[name] = value;
                    }
                    for(var _i3 = 0, _Object$entries2 = Object.entries((_overrides$configs = overrides.configs) !== null && _overrides$configs !== void 0 ? _overrides$configs : {}); _i3 < _Object$entries2.length; _i3++){
                        var _overrides$configs;
                        var _Object$entries2$_i = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_Object$entries2[_i3], 2), _name = _Object$entries2$_i[0], _value = _Object$entries2$_i[1];
                        merged.configs[_name] = _value;
                    }
                    for(var _i4 = 0, _Object$entries3 = Object.entries((_overrides$layers = overrides.layers) !== null && _overrides$layers !== void 0 ? _overrides$layers : {}); _i4 < _Object$entries3.length; _i4++){
                        var _overrides$layers;
                        var _Object$entries3$_i = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_Object$entries3[_i4], 2), _name2 = _Object$entries3$_i[0], _value2 = _Object$entries3$_i[1];
                        merged.layers[_name2] = _value2;
                    }
                }
                return merged;
            }
        },
        {
            key: "initFromStoredOverrides",
            value: function initFromStoredOverrides() {
                var storedOverrides = this.mergeOverrides(this._overrides, this.parseStoredOverrides($d6383dcf21a32680$var$LEGACY_LOCAL_STORAGE_KEY), this.parseStoredOverrides(this._localStorageKey));
                // Clear data from legacy local storage key now we've read from it.
                // This prevents things being stuck in there that are always read but never written to.
                try {
                    window.localStorage.removeItem($d6383dcf21a32680$var$LEGACY_LOCAL_STORAGE_KEY);
                } catch (_unused2) {
                // ignored - window is not defined in non-browser environments, and we don't save things there
                // (things like SSR, etc)
                }
                // In version 4.24.0 we introduced hashes in this override adapter, but had a bug which would cause
                // multiple hashes to continue being created. This code here removes these hashes since we've moved
                // to using a more reliable and easier to maintain map in `_djb2Map`.
                for(var _i5 = 0, _Object$values = Object.values(storedOverrides); _i5 < _Object$values.length; _i5++){
                    var container = _Object$values[_i5];
                    var allKeys = new Set(Object.keys(container));
                    var _iterator = $d6383dcf21a32680$var$_createForOfIteratorHelper(allKeys), _step;
                    try {
                        for(_iterator.s(); !(_step = _iterator.n()).done;){
                            var name = _step.value;
                            var hash = (0, $dtn6l._DJB2)(name);
                            if (allKeys.has(hash)) delete container[hash];
                        }
                    } catch (err) {
                        _iterator.e(err);
                    } finally{
                        _iterator.f();
                    }
                }
                this.applyOverrides(storedOverrides);
            }
        },
        {
            key: "saveOverrides",
            value: function saveOverrides() {
                try {
                    window.localStorage.setItem(this._localStorageKey, JSON.stringify(this._overrides));
                } catch (_unused3) {
                // ignored - window is not defined in non-browser environments, and we don't save things there
                // (things like SSR, etc)
                }
            }
        },
        {
            key: "getOverrides",
            value: function getOverrides() {
                return this.mergeOverrides(this._overrides);
            }
        },
        {
            key: "applyOverrides",
            value: function applyOverrides(overrides) {
                var newOverrides = $d6383dcf21a32680$var$_objectSpread($d6383dcf21a32680$var$_objectSpread({}, $d6383dcf21a32680$var$makeEmptyStore()), overrides);
                this._djb2Map.clear();
                for(var _i6 = 0, _Object$entries4 = Object.entries(newOverrides); _i6 < _Object$entries4.length; _i6++){
                    var _Object$entries4$_i = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_Object$entries4[_i6], 2), containerName = _Object$entries4$_i[0], container = _Object$entries4$_i[1];
                    for(var _i7 = 0, _Object$entries5 = Object.entries(container); _i7 < _Object$entries5.length; _i7++){
                        var _Object$entries5$_i = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_Object$entries5[_i7], 2), name = _Object$entries5$_i[0], value = _Object$entries5$_i[1];
                        this._djb2Map.set($d6383dcf21a32680$var$djb2MapKey((0, $dtn6l._DJB2)(name), containerName), value);
                    }
                }
                this._overrides = newOverrides;
            }
        },
        {
            key: "setOverrides",
            value: function setOverrides(overrides) {
                this.applyOverrides(overrides);
                this.saveOverrides();
            }
        },
        {
            key: "overrideGate",
            value: function overrideGate(name, value) {
                this._overrides.gates[name] = value;
                this._djb2Map.set($d6383dcf21a32680$var$djb2MapKey((0, $dtn6l._DJB2)(name), 'gates'), value);
                this.saveOverrides();
            }
        },
        {
            key: "removeGateOverride",
            value: function removeGateOverride(name) {
                delete this._overrides.gates[name];
                this._djb2Map.delete($d6383dcf21a32680$var$djb2MapKey((0, $dtn6l._DJB2)(name), 'gates'));
                this.saveOverrides();
            }
        },
        {
            key: "getGateOverride",
            value: function getGateOverride(current, _user) {
                var _this$_overrides$gate;
                var overridden = (_this$_overrides$gate = this._overrides.gates[current.name]) !== null && _this$_overrides$gate !== void 0 ? _this$_overrides$gate : this._djb2Map.get($d6383dcf21a32680$var$djb2MapKey(current.name, 'gates'));
                if (overridden == null) return null;
                return $d6383dcf21a32680$var$_objectSpread($d6383dcf21a32680$var$_objectSpread({}, current), {}, {
                    value: overridden,
                    details: $d6383dcf21a32680$var$_objectSpread($d6383dcf21a32680$var$_objectSpread({}, current.details), {}, {
                        reason: $d6383dcf21a32680$var$LOCAL_OVERRIDE_REASON
                    })
                });
            }
        },
        {
            key: "overrideDynamicConfig",
            value: function overrideDynamicConfig(name, value) {
                this._overrides.configs[name] = value;
                this._djb2Map.set($d6383dcf21a32680$var$djb2MapKey((0, $dtn6l._DJB2)(name), 'configs'), value);
                this.saveOverrides();
            }
        },
        {
            key: "removeDynamicConfigOverride",
            value: function removeDynamicConfigOverride(name) {
                delete this._overrides.configs[name];
                this._djb2Map.delete($d6383dcf21a32680$var$djb2MapKey((0, $dtn6l._DJB2)(name), 'configs'));
                this.saveOverrides();
            }
        },
        {
            key: "getDynamicConfigOverride",
            value: function getDynamicConfigOverride(current, _user) {
                return this._getConfigOverride(current, this._overrides.configs);
            }
        },
        {
            key: "overrideExperiment",
            value: function overrideExperiment(name, value) {
                this._overrides.configs[name] = value;
                this._djb2Map.set($d6383dcf21a32680$var$djb2MapKey((0, $dtn6l._DJB2)(name), 'configs'), value);
                this.saveOverrides();
            }
        },
        {
            key: "removeExperimentOverride",
            value: function removeExperimentOverride(name) {
                delete this._overrides.configs[name];
                this._djb2Map.delete($d6383dcf21a32680$var$djb2MapKey((0, $dtn6l._DJB2)(name), 'configs'));
                this.saveOverrides();
            }
        },
        {
            key: "getExperimentOverride",
            value: function getExperimentOverride(current, _user) {
                return this._getConfigOverride(current, this._overrides.configs);
            }
        },
        {
            key: "overrideLayer",
            value: function overrideLayer(name, value) {
                this._overrides.layers[name] = value;
                this._djb2Map.set($d6383dcf21a32680$var$djb2MapKey((0, $dtn6l._DJB2)(name), 'layers'), value);
                this.saveOverrides();
            }
        },
        {
            key: "removeLayerOverride",
            value: function removeLayerOverride(name) {
                delete this._overrides.layers[name];
                this._djb2Map.delete($d6383dcf21a32680$var$djb2MapKey((0, $dtn6l._DJB2)(name), 'layers'));
                this.saveOverrides();
            }
        },
        {
            key: "removeAllOverrides",
            value: function removeAllOverrides() {
                this._overrides = $d6383dcf21a32680$var$makeEmptyStore();
                try {
                    window.localStorage.removeItem(this._localStorageKey);
                } catch (_unused4) {
                // ignored - window is not defined in non-browser environments, and we don't save things there
                // (things like SSR, etc)
                }
            }
        },
        {
            key: "getLayerOverride",
            value: function getLayerOverride(current, _user) {
                var _this$_overrides$laye;
                var overridden = (_this$_overrides$laye = this._overrides.layers[current.name]) !== null && _this$_overrides$laye !== void 0 ? _this$_overrides$laye : this._djb2Map.get($d6383dcf21a32680$var$djb2MapKey(current.name, 'layers'));
                if (overridden == null) return null;
                return $d6383dcf21a32680$var$_objectSpread($d6383dcf21a32680$var$_objectSpread({}, current), {}, {
                    __value: overridden,
                    get: (0, $dtn6l._makeTypedGet)(current.name, overridden),
                    details: $d6383dcf21a32680$var$_objectSpread($d6383dcf21a32680$var$_objectSpread({}, current.details), {}, {
                        reason: $d6383dcf21a32680$var$LOCAL_OVERRIDE_REASON
                    })
                });
            }
        },
        {
            key: "_getConfigOverride",
            value: function _getConfigOverride(current, lookup) {
                var _lookup$current$name;
                var overridden = (_lookup$current$name = lookup[current.name]) !== null && _lookup$current$name !== void 0 ? _lookup$current$name : this._djb2Map.get($d6383dcf21a32680$var$djb2MapKey(current.name, 'configs'));
                if (overridden == null) return null;
                return $d6383dcf21a32680$var$_objectSpread($d6383dcf21a32680$var$_objectSpread({}, current), {}, {
                    value: overridden,
                    get: (0, $dtn6l._makeTypedGet)(current.name, overridden),
                    details: $d6383dcf21a32680$var$_objectSpread($d6383dcf21a32680$var$_objectSpread({}, current.details), {}, {
                        reason: $d6383dcf21a32680$var$LOCAL_OVERRIDE_REASON
                    })
                });
            }
        }
    ]);
}();

});



parcelRegister("aj4TE", function(module, exports) {
$parcel$export(module.exports, "editorExperimentsConfig", () => $780f7a13a3c2fcae$export$6cbb856f286b07ef);
/* eslint-disable perfectionist/sort-object-types */ /* eslint-disable @atlaskit/editor/no-re-export */ // Entry file in package.json

var $fAmZY = parcelRequire("fAmZY");
var $780f7a13a3c2fcae$export$6cbb856f286b07ef = {
    // new format to avoid collisions with other users when updating the file
    // Editor Platform experiments
    // lwoollard experiments
    // Added 02-12-2025
    cc_fix_hydration_ttvc: (0, $fAmZY.createBooleanExperiment)({
        productKeys: {
            confluence: 'cc_fix_hydration_ttvc'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 03-09-2025
    cc_editor_limited_mode_include_lcm: (0, $fAmZY.createBooleanExperiment)({
        productKeys: {
            confluence: 'cc_editor_limited_mode_include_lcm'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 03-09-2025
    cc_editor_interactivity_monitoring: (0, $fAmZY.createBooleanExperiment)({
        productKeys: {
            confluence: 'cc_editor_interactivity_monitoring'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-11-03
    editor_tinymce_full_width_mode: (0, $fAmZY.createBooleanExperiment)({
        productKeys: {
            confluence: 'editor_tinymce_full_width_mode'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    cc_editor_insm_doc_size_stats: (0, $fAmZY.createBooleanExperiment)({
        productKeys: {
            confluence: 'cc_editor_insm_doc_size_stats'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-09-30
    cc_editor_insm_outlier_events: (0, $fAmZY.createMultivariateExperiment)({
        productKeys: {
            confluence: 'cc_editor_insm_outlier_events'
        },
        param: 'cohort',
        values: [
            'control',
            'test'
        ],
        defaultValue: 'control'
    }),
    // Added 2025-11-17
    platform_editor_renderer_extension_width_fix: (0, $fAmZY.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_renderer_extension_width_fix'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-09-30
    // variant 1: remove table overflow shadows completely, no table border shown when scrolling.
    // variant 2: remove table overflow shadows, show table border when scrolling.
    // variant 3: replace table overflow shadows with CSS-only solution.
    platform_editor_disable_table_overflow_shadows: (0, $fAmZY.createMultivariateExperiment)({
        productKeys: {
            confluence: 'platform_editor_disable_table_overflow_shadows'
        },
        param: 'cohort',
        values: [
            'control',
            'variant1',
            'variant2',
            'variant3'
        ],
        defaultValue: 'control'
    }),
    // Added 2025-11-26
    platform_editor_resizer_styles_cleanup: (0, $fAmZY.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_resizer_styles_cleanup'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-11-12
    platform_editor_media_vc_fixes: (0, $fAmZY.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_media_vc_fixes'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-11-20
    platform_editor_annotations_sync_on_docchange: (0, $fAmZY.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_annotations_sync_on_docchange'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-05-27
    platform_editor_reduce_noisy_steps_ncs: (0, $fAmZY.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_reduce_noisy_steps_ncs'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-07-24
    editor_prevent_numbered_column_too_big_jira_1: (0, $fAmZY.createBooleanExperiment)({
        productKeys: {
            jira: 'editor_prevent_numbered_column_too_big_jira_1'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-06-02
    platform_editor_block_control_optimise_render: (0, $fAmZY.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_block_control_optimise_render'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2024-08-08
    'example-boolean': (0, $fAmZY.createBooleanExperiment)({
        productKeys: {
            confluence: 'confluence_editor_experiment_test_new_package_boolean'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2024-08-08
    'example-multivariate': (0, $fAmZY.createMultivariateExperiment)({
        productKeys: {
            confluence: 'confluence_editor_experiment_test_new_package_multivariate'
        },
        param: 'variant',
        values: [
            'one',
            'two',
            'three'
        ],
        defaultValue: 'one'
    }),
    // Added 2024-08-08
    'test-new-experiments-package': (0, $fAmZY.createBooleanExperiment)({
        productKeys: {
            confluence: 'confluence_editor_experiment_test_new_package',
            jira: 'jira_editor_experiment_test_new_package'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    platform_editor_table_drag_handle_hover: (0, $fAmZY.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_table_drag_handle_hover',
            jira: 'platform_editor_table_drag_handle_hover'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2024-09-05
    support_table_in_comment: (0, $fAmZY.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_support_table_in_comment_exp'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2024-09-07
    platform_editor_exp_lazy_node_views: (0, $fAmZY.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_exp_lazy_node_views'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2024-09-18
    platform_renderer_table_sticky_scrollbar: (0, $fAmZY.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_renderer_table_sticky_scrollbar'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-11-20
    'company-hub-config-panel-keyboard-nav': (0, $fAmZY.createBooleanExperiment)({
        productKeys: {
            confluence: 'company-hub-config-panel-keyboard-nav'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-10-10
    platform_editor_experience_tracking: (0, $fAmZY.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_experience_tracking'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-05-26
    platform_editor_prevent_toolbar_layout_shifts: (0, $fAmZY.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_prevent_toolbar_layout_shifts'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2024-10-01
    comment_on_bodied_extensions: (0, $fAmZY.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_comment_on_bodied_extensions'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2024-10-14
    // https://console.statsig.com/LqivKg6ADZZaGczRfBKfX/experiments/platform_editor_advanced_layouts/setup
    advanced_layouts: (0, $fAmZY.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_advanced_layouts'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-3-15
    // https://console.statsig.com/LqivKg6ADZZaGczRfBKfX/experiments/platform_editor_single_column_layout/setup
    single_column_layouts: (0, $fAmZY.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_single_column_layout'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2024-10-08
    support_table_in_comment_jira: (0, $fAmZY.createBooleanExperiment)({
        productKeys: {
            jira: 'platform_editor_support_table_in_comment_jira'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    'platform_editor_ai-prompts-placeholder': (0, $fAmZY.createMultivariateExperiment)({
        productKeys: {
            confluence: 'platform_editor_ai-prompts-placeholder'
        },
        param: 'cohort',
        values: [
            'control',
            'test'
        ],
        defaultValue: 'control'
    }),
    // added 2024-11-06
    // https://console.statsig.com/LqivKg6ADZZaGczRfBKfX/experiments/platform_editor_nested_tables/setup
    'nested-tables-in-tables': (0, $fAmZY.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_nested_tables'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2024-11-26
    platform_editor_ai_unsplash_page_header: (0, $fAmZY.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_ai_unsplash_page_header'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2024-12-05
    platform_editor_blockquote_in_text_formatting_menu: (0, $fAmZY.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_blockquote_in_text_formatting_menu'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-01-13
    platform_editor_element_drag_and_drop_multiselect: (0, $fAmZY.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_element_drag_and_drop_multiselect'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-01-19
    platform_editor_ai_edit_response_in_preview: (0, $fAmZY.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_ai_edit_response_in_preview'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-02-10
    platform_editor_controls: (0, $fAmZY.createMultivariateExperiment)({
        productKeys: {
            confluence: 'platform_editor_controls'
        },
        param: 'cohort',
        values: [
            'control',
            'variant1'
        ],
        defaultValue: 'control'
    }),
    // Added 2025-08-01
    platform_editor_controls_block_controls_state_fix: (0, $fAmZY.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_controls_block_controls_state_fix'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-09-03
    platform_editor_hydratable_ui: (0, $fAmZY.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_hydratable_ui'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-03-28
    platform_editor_ai_proactive_ai_nudge_parameters: (0, $fAmZY.createMultivariateExperiment)({
        productKeys: {
            confluence: 'platform_editor_ai_proactive_ai_nudge_parameters'
        },
        param: 'cohort',
        values: [
            'control',
            'variant1'
        ],
        defaultValue: 'control'
    }),
    // Added 2025-04-14
    // https://switcheroo.atlassian.com/ui/gates/b159b45a-86d9-4f4b-b482-f9aca5b615d6/key/platform_editor_offline_editing_web
    platform_editor_offline_editing_web: (0, $fAmZY.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_offline_editing_web'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-10-15
    platform_editor_no_ssr: (0, $fAmZY.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_no_ssr'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-10-31
    platform_editor_lovability_suppress_toolbar_event: (0, $fAmZY.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_lovability_suppress_toolbar_event',
            jira: 'platform_editor_lovability_suppress_toolbar_event'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-04-17
    platform_editor_tables_drag_and_drop: (0, $fAmZY.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_tables_drag_and_drop'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-04-17
    platform_editor_tables_table_selector: (0, $fAmZY.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_tables_table_selector'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-04-23
    platform_editor_usesharedpluginstateselector: (0, $fAmZY.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_usesharedpluginstateselector'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-04-23
    platform_renderer_fix_analytics_memo_callback: (0, $fAmZY.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_renderer_fix_analytics_memo_callback'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-05-26
    platform_editor_stop_width_reflows: (0, $fAmZY.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_stop_width_reflows'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-12-01
    platform_editor_no_state_plugin_injection_api: (0, $fAmZY.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_no_state_plugin_injection_api'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-06-10
    platform_editor_no_cursor_on_edit_page_init: (0, $fAmZY.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_no_cursor_on_edit_page_init'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-07-14
    platform_editor_debounce_portal_provider: (0, $fAmZY.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_debounce_portal_provider'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-08-14
    platform_editor_jira_advanced_code_blocks: (0, $fAmZY.createBooleanExperiment)({
        productKeys: {
            jira: 'platform_editor_jira_advanced_code_blocks'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-07-08 - Jira work sync description comment summary
    'jira-work-sync-desc-comment-summary': (0, $fAmZY.createBooleanExperiment)({
        productKeys: {
            jira: 'jira-work-sync-desc-comment-summary'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-05-15
    platform_editor_breakout_resizing: (0, $fAmZY.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_breakout_resizing'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-05-07
    platform_editor_ai_quickstart_command: (0, $fAmZY.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_ai_quickstart_command'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-06-05
    platform_editor_block_controls_perf_optimization: (0, $fAmZY.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_block_controls_perf_optimization'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-06-16
    platform_editor_enable_single_player_step_merging: (0, $fAmZY.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_enable_single_player_step_merging'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-07-02
    platform_editor_code_block_fold_gutter: (0, $fAmZY.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_code_block_fold_gutter'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-06-18
    platform_editor_ai_iw_adf_streaming: (0, $fAmZY.createMultivariateExperiment)({
        productKeys: {
            confluence: 'platform_editor_ai_iw_adf_streaming'
        },
        param: 'cohort',
        values: [
            'control',
            'adf_gemini25flash',
            'adf_gpt41mini'
        ],
        defaultValue: 'control'
    }),
    // Added 2025-08-20
    platform_editor_ai_non_iw_adf_streaming: (0, $fAmZY.createMultivariateExperiment)({
        productKeys: {
            confluence: 'platform_editor_ai_non_iw_adf_streaming'
        },
        param: 'cohort',
        values: [
            'control',
            'adf_gemini25flash',
            'adf_gpt41mini'
        ],
        defaultValue: 'control'
    }),
    //Added 2025-07-25
    platform_editor_extension_styles: (0, $fAmZY.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_extension_styles'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-06-20
    confluence_whiteboards_quick_insert_aa: (0, $fAmZY.createMultivariateExperiment)({
        productKeys: {
            confluence: 'confluence_whiteboards_quick_insert_aa'
        },
        param: 'cohort',
        values: [
            'control',
            'test_blank',
            'test_diagram'
        ],
        defaultValue: 'control'
    }),
    // Added 2025-06-24
    platform_editor_find_and_replace_improvements: (0, $fAmZY.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_find_and_replace_improvements'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-06-24
    confluence_whiteboards_quick_insert: (0, $fAmZY.createMultivariateExperiment)({
        productKeys: {
            confluence: 'confluence_whiteboards_quick_insert'
        },
        param: 'cohort',
        values: [
            'control',
            'test_blank',
            'test_diagram'
        ],
        defaultValue: 'control'
    }),
    // Added 2025-06-26
    platform_editor_feedback_mandatory_rating: (0, $fAmZY.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_feedback_mandatory_rating'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-07-30
    platform_editor_drag_handle_aria_label: (0, $fAmZY.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_drag_handle_aria_label'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-07-07
    platform_editor_toggle_expand_on_match_found: (0, $fAmZY.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_toggle_expand_on_match_found'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    platform_editor_smart_card_otp: (0, $fAmZY.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_smart_card_otp'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-07-15
    platform_editor_preview_panel_responsiveness: (0, $fAmZY.createBooleanExperiment)({
        productKeys: {
            confluence: 'confluence_preview_panels_exp'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-08-18
    platform_editor_preview_panel_linking_exp: (0, $fAmZY.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_preview_panel_linking_exp_conf',
            jira: 'platform_editor_preview_panel_linking_exp_jira'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-10-10
    platform_editor_hoverlink_ui_fixes_exp: (0, $fAmZY.createMultivariateExperiment)({
        productKeys: {
            confluence: 'platform_editor_hoverlink_ui_fixes_exp'
        },
        param: 'cohort',
        values: [
            'control',
            'css_changes_only',
            'css_js_changes'
        ],
        defaultValue: 'control'
    }),
    // Added 2025-08-17
    platform_hover_card_preview_panel: (0, $fAmZY.createMultivariateExperiment)({
        productKeys: {
            confluence: 'platform_hover_card_preview_panel',
            jira: 'platform_hover_card_preview_panel'
        },
        param: 'cohort',
        values: [
            'control',
            'test'
        ],
        defaultValue: 'control'
    }),
    // Added 2025-09-17
    platform_hover_card_preview_panel_modal: (0, $fAmZY.createMultivariateExperiment)({
        productKeys: {
            confluence: 'platform_hover_card_preview_panel_modal',
            jira: 'platform_hover_card_preview_panel_modal'
        },
        param: 'cohort',
        values: [
            'control',
            'test'
        ],
        defaultValue: 'control'
    }),
    // Added 2025-11-25
    smart_link_confluence_short_link_analytics: (0, $fAmZY.createMultivariateExperiment)({
        productKeys: {
            confluence: 'smart-link-confluence-short-link-analytics',
            jira: 'smart-link-confluence-short-link-analytics'
        },
        param: 'cohort',
        values: [
            'control',
            'test'
        ],
        defaultValue: 'control'
    }),
    // Added 2025--8-05
    platform_editor_block_menu: (0, $fAmZY.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_block_menu'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-09-16
    platform_editor_emoji_otp: (0, $fAmZY.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_emoji_otp'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-07-23
    platform_editor_renderer_breakout_fix: (0, $fAmZY.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_renderer_breakout_fix'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-07-24
    editor_enghealth_hyperlink_toolbar_aria_values: (0, $fAmZY.createBooleanExperiment)({
        productKeys: {
            confluence: 'editor_enghealth_hyperlink_toolbar_aria_values'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-07-14
    platform_editor_add_orange_highlight_color: (0, $fAmZY.createMultivariateExperiment)({
        productKeys: {
            confluence: 'platform_editor_add_orange_highlight_color'
        },
        param: 'cohort',
        values: [
            'control',
            'test'
        ],
        defaultValue: 'control'
    }),
    //Added 2025-07-16
    platform_editor_toolbar_aifc: (0, $fAmZY.createBooleanExperiment)({
        productKeys: {
            jira: 'platform_editor_toolbar_aifc_jira',
            confluence: 'platform_editor_toolbar_aifc_confluence'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-09-04
    editor_refactor_backspace_task_and_decisions: (0, $fAmZY.createBooleanExperiment)({
        productKeys: {
            confluence: 'editor_refactor_backspace_task_and_decisions'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    //Added 2025-07-16
    platform_editor_toolbar_aifc_patch_3: (0, $fAmZY.createBooleanExperiment)({
        productKeys: {
            jira: 'platform_editor_toolbar_aifc_patch_3',
            confluence: 'platform_editor_toolbar_aifc_patch_3'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    //Added 2025-09-09
    platform_editor_toolbar_aifc_patch_4: (0, $fAmZY.createBooleanExperiment)({
        productKeys: {
            jira: 'platform_editor_toolbar_aifc_patch_4',
            confluence: 'platform_editor_toolbar_aifc_patch_4'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-09-29
    platform_editor_toolbar_aifc_selection_extension: (0, $fAmZY.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_toolbar_aifc_selection_extension',
            jira: 'platform_editor_toolbar_aifc_selection_extension'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-08-04
    platform_editor_floating_toolbar_button_aria_label: (0, $fAmZY.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_floating_toolbar_button_aria_label'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-07-24
    platform_editor_enghealth_table_plugin_lable_rule: (0, $fAmZY.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_enghealth_table_plugin_lable_rule'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-07-31
    platform_editor_breakout_interaction_rerender: (0, $fAmZY.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_breakout_interaction_rerender'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-08-27
    platform_editor_toolbar_aifc_responsive: (0, $fAmZY.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_toolbar_aifc_responsive',
            jira: 'platform_editor_toolbar_aifc_responsive'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-07-30
    platform_editor_pasting_nested_table_fix: (0, $fAmZY.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_pasting_nested_table_fix'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 20205-07-28
    platform_editor_fix_quick_insert_consistency_exp: (0, $fAmZY.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_fix_quick_insert_consistency_exp'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    //Added 2025-11-19
    platform_editor_pasting_text_in_panel: (0, $fAmZY.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_pasting_text_in_panel'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-07-31
    platform_editor_fix_a11y_aria_posinset_0: (0, $fAmZY.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_fix_a11y_aria_posinset_0'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-07-30
    platform_editor_blocktaskitem_node_tenantid: (0, $fAmZY.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_blocktaskitem_node_tenantid'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-09-08
    platform_editor_blocktaskitem_patch_1: (0, $fAmZY.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_blocktaskitem_patch_1'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-08-06
    cc_editor_limited_mode: (0, $fAmZY.createBooleanExperiment)({
        productKeys: {
            confluence: 'cc_editor_limited_mode'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-08-05
    platform_editor_native_anchor_with_dnd: (0, $fAmZY.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_native_anchor_with_dnd'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    platform_editor_native_expand_button: (0, $fAmZY.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_native_expand_button'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-08-28
    editor_enable_image_alignment_in_expand: (0, $fAmZY.createBooleanExperiment)({
        productKeys: {
            confluence: 'editor_enable_image_alignment_in_expand'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-08-05
    platform_editor_august_a11y: (0, $fAmZY.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_august_a11y'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-08-10
    platform_synced_block: (0, $fAmZY.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_synced_block',
            jira: 'platform_synced_block_jira'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-09-16
    cc_improve_writing_on_paste_v2: (0, $fAmZY.createBooleanExperiment)({
        productKeys: {
            confluence: 'cc_improve_writing_on_paste_v2'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-08-18
    platform_editor_locale_datepicker: (0, $fAmZY.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_locale_datepicker'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-08-19
    platform_editor_breakout_resizing_vc90_fix: (0, $fAmZY.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_breakout_resizing_vc90_fix'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-08-27
    platform_editor_toolbar_support_custom_components: (0, $fAmZY.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_toolbar_support_custom_components'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-08-25
    platform_editor_toolbar_aifc_template_editor: (0, $fAmZY.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_toolbar_aifc_template_editor'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-08-26
    platform_editor_toolbar_migrate_loom: (0, $fAmZY.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_toolbar_migrate_loom',
            jira: 'platform_editor_toolbar_migrate_loom'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-09-16
    platform_editor_prevent_taskitem_remount: (0, $fAmZY.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_prevent_taskitem_remount'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-09-01
    cc_editor_ai_content_mode: (0, $fAmZY.createMultivariateExperiment)({
        productKeys: {
            confluence: 'cc_editor_ai_content_mode'
        },
        param: 'variant',
        values: [
            'control',
            'test'
        ],
        defaultValue: 'control'
    }),
    // Added 2025-09-08
    platform_editor_editor_width_analytics: (0, $fAmZY.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_editor_width_analytics',
            jira: 'platform_editor_editor_width_analytics'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-09-10
    platform_editor_fix_button_name_violation_in_table: (0, $fAmZY.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_fix_button_name_violation_in_table'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-09-11
    platform_editor_quick_insert_image_wrap_right_fix: (0, $fAmZY.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_quick_insert_image_wrap_right_fix'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-09-11
    platform_editor_add_aria_checked_to_inline_img_btn: (0, $fAmZY.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_add_aria_checked_to_inline_image_btn'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-09-16
    platform_editor_nested_table_refresh_width_fix: (0, $fAmZY.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_nested_table_refresh_width_fix'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-09-15
    platform_editor_toolbar_aifc_patch_5: (0, $fAmZY.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_toolbar_aifc_patch_5'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-10-10
    platform_use_llm_space_recommendations: (0, $fAmZY.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_use_llm_space_recommendations'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-09-15
    platform_editor_text_highlight_padding: (0, $fAmZY.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_text_highlight_padding'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-10-24
    platform_editor_lovability_user_intent: (0, $fAmZY.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_lovability_user_intent'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-09-17
    cc_complexit_fe_emoji_stability: (0, $fAmZY.createBooleanExperiment)({
        productKeys: {
            confluence: 'cc_complexit_fe_emoji_stability'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-09-23
    cc_editor_ttvc_release_bundle_one: (0, $fAmZY.createBooleanExperiment)({
        productKeys: {
            confluence: 'cc_editor_ttvc_release_bundle_one'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-10-07
    platform_editor_plain_text_support: (0, $fAmZY.createBooleanExperiment)({
        productKeys: {
            jira: 'platform_editor_plain_text_support',
            confluence: 'platform_editor_plain_text_support'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-09-26
    platform_editor_toolbar_aifc_patch_6: (0, $fAmZY.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_toolbar_aifc_patch_6'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-10-17
    confluence_content_mode_replace_dense_with_compact: (0, $fAmZY.createMultivariateExperiment)({
        productKeys: {
            confluence: 'confluence_content_mode_replace_dense_with_compact'
        },
        param: 'cohort',
        values: [
            'control',
            'test'
        ],
        defaultValue: 'control'
    }),
    // Added 2025-10-01
    platform_inline_smartcard_connect_button_exp: (0, $fAmZY.createMultivariateExperiment)({
        productKeys: {
            confluence: 'platform_inline_smartcard_connect_button_exp',
            jira: 'platform_inline_smartcard_connect_button_exp'
        },
        param: 'cohort',
        values: [
            'control',
            'test1',
            'test2'
        ],
        defaultValue: 'control'
    }),
    // Added 2025-10-10
    platform_editor_new_list_decorations_logic: (0, $fAmZY.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_new_list_decorations_logic'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-10-13
    platform_editor_media_error_analytics: (0, $fAmZY.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_media_error_analytics'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-10-15
    platform_editor_new_mentions_detection_logic: (0, $fAmZY.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_new_mentions_detection_logic'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-10-20
    confluence_whiteboards_quick_insert_localised: (0, $fAmZY.createMultivariateExperiment)({
        productKeys: {
            confluence: 'confluence_whiteboards_quick_insert_localised'
        },
        param: 'cohort',
        values: [
            'control',
            'test_blank',
            'test_diagram'
        ],
        defaultValue: 'control'
    }),
    // Added 2025-10-28
    confluence_whiteboards_quick_insert_localised_aa: (0, $fAmZY.createMultivariateExperiment)({
        productKeys: {
            confluence: 'confluence_whiteboards_quick_insert_localised_aa'
        },
        param: 'cohort',
        values: [
            'control',
            'test_diagram'
        ],
        defaultValue: 'control'
    }),
    // Added 2025-10-22
    platform_editor_remove_bidi_char_warning: (0, $fAmZY.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_remove_bidi_char_warning'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-11-05
    platform_editor_nested_table_detection: (0, $fAmZY.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_nested_table_detection'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-10-24
    platform_editor_fix_clone_nesting_exp: (0, $fAmZY.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_fix_clone_nesting_exp'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-10-27
    platform_editor_table_sticky_header_improvements: (0, $fAmZY.createMultivariateExperiment)({
        productKeys: {
            confluence: 'platform_editor_table_sticky_header_improvements'
        },
        param: 'cohort',
        values: [
            'control',
            'test_with_overflow',
            'test_without_overflow'
        ],
        defaultValue: 'control'
    }),
    // Added 2025-11-04
    platform_editor_disable_lazy_load_media: (0, $fAmZY.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_disable_lazy_load_media'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-10-29
    platform_editor_lovability_inline_code: (0, $fAmZY.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_lovability_inline_code'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-11-05
    platform_editor_lovability_emoji_scaling: (0, $fAmZY.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_lovability_emoji_scaling'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-11-07
    cc_editor_limited_mode_table_align_bttn: (0, $fAmZY.createBooleanExperiment)({
        productKeys: {
            confluence: 'cc_editor_limited_mode_table_align_bttn'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-11-19
    platform_editor_lovability_navigation_fixes: (0, $fAmZY.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_lovability_navigation_fixes'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-11-27
    platform_sl_3p_unauth_paste_as_block_card: (0, $fAmZY.createMultivariateExperiment)({
        productKeys: {
            confluence: 'platform_sl_3p_unauth_paste_as_block_card',
            jira: 'platform_sl_3p_unauth_paste_as_block_card'
        },
        values: [
            'control',
            'card_by_default_only',
            'card_by_default_and_new_design'
        ],
        param: 'cohort',
        defaultValue: 'control'
    }),
    // Added 2025-11-25
    platform_editor_remove_ncsStepMetrics_plugin: (0, $fAmZY.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_remove_ncsStepMetrics_plugin'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-11-18
    platform_editor_wait_for_space_after_ascii_emoji: (0, $fAmZY.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_wait_for_space_after_ascii_emoji'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-12-03
    platform_editor_nested_media_selection_fix: (0, $fAmZY.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_nested_media_selection_fix'
        },
        param: 'isEnabled',
        defaultValue: false
    })
};

});
parcelRegister("fAmZY", function(module, exports) {
$parcel$export(module.exports, "createBooleanExperiment", () => $b58c0edb81a459dc$export$456f1587c9c92021);
$parcel$export(module.exports, "createMultivariateExperiment", () => $b58c0edb81a459dc$export$fb89e8a786694d1);

var $fC8ib = parcelRequire("fC8ib");

var $25nEq = parcelRequire("25nEq");

var $kW7YH = parcelRequire("kW7YH");
function $b58c0edb81a459dc$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $b58c0edb81a459dc$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $b58c0edb81a459dc$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $b58c0edb81a459dc$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $b58c0edb81a459dc$export$456f1587c9c92021(config) {
    return $b58c0edb81a459dc$var$_objectSpread($b58c0edb81a459dc$var$_objectSpread({}, config), {}, {
        typeGuard: (0, $kW7YH.isBoolean),
        defaultValue: config.defaultValue
    });
}
function $b58c0edb81a459dc$export$fb89e8a786694d1(config) {
    var values = config.values;
    return $b58c0edb81a459dc$var$_objectSpread($b58c0edb81a459dc$var$_objectSpread({}, config), {}, {
        values: (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(values),
        // Maintains the tuple
        typeGuard: (0, $kW7YH.oneOf)(config.values),
        defaultValue: config.defaultValue
    });
}

});
parcelRegister("kW7YH", function(module, exports) {
$parcel$export(module.exports, "isBoolean", () => $f3df69af3a8a599a$export$f9ce7b637dfbe238);
$parcel$export(module.exports, "oneOf", () => $f3df69af3a8a599a$export$a9a18ae5ba42aeab);

var $ekGgq = parcelRequire("ekGgq");

var $3ZMUU = parcelRequire("3ZMUU");
var $f3df69af3a8a599a$var$_process, $f3df69af3a8a599a$var$_process2;
function $f3df69af3a8a599a$export$f9ce7b637dfbe238(value) {
    return typeof value === 'boolean';
}
function $f3df69af3a8a599a$export$a9a18ae5ba42aeab(values) {
    function typeGuard(value) {
        return values.includes(value);
    }
    /**
   * This is used by test utils to get the variants when running describe.each
   */ if ($f3df69af3a8a599a$var$IS_TESTING_ENV) typeGuard.values = values;
    return typeGuard;
}
// @ts-ignore
var $f3df69af3a8a599a$var$IS_TESTING_ENV = (typeof $3ZMUU === "undefined" ? "undefined" : (0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))($3ZMUU)) !== undefined && ((($f3df69af3a8a599a$var$_process = $3ZMUU) === null || $f3df69af3a8a599a$var$_process === void 0 || ($f3df69af3a8a599a$var$_process = $f3df69af3a8a599a$var$_process.env) === null || $f3df69af3a8a599a$var$_process === void 0 ? void 0 : $f3df69af3a8a599a$var$_process.NODE_ENV) === 'test' || (($f3df69af3a8a599a$var$_process2 = $3ZMUU) === null || $f3df69af3a8a599a$var$_process2 === void 0 || ($f3df69af3a8a599a$var$_process2 = $f3df69af3a8a599a$var$_process2.env) === null || $f3df69af3a8a599a$var$_process2 === void 0 ? void 0 : $f3df69af3a8a599a$var$_process2.JEST_WORKER_ID) !== undefined);

});



parcelRegister("75k6K", function(module, exports) {
$parcel$export(module.exports, "_overrides", () => $528899015f76bd1a$export$e5d73bf4f8e2ae96);
$parcel$export(module.exports, "_paramOverrides", () => $528899015f76bd1a$export$4e849416bb5c5b52);
$parcel$export(module.exports, "_product", () => $528899015f76bd1a$export$cf7305fc65acbf0d);

var $25nEq = parcelRequire("25nEq");

var $iYJcE = parcelRequire("iYJcE");

var $aj4TE = parcelRequire("aj4TE");

var $89JeF = parcelRequire("89JeF");
function $528899015f76bd1a$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $528899015f76bd1a$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $528899015f76bd1a$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $528899015f76bd1a$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $528899015f76bd1a$export$e5d73bf4f8e2ae96 = {};
var $528899015f76bd1a$export$4e849416bb5c5b52 = {};
var $528899015f76bd1a$export$cf7305fc65acbf0d;
function $528899015f76bd1a$export$1c2b6dbf79eb3560(product, /**
 * Overrides are used to set the group of an experiment for testing purposes.
 * This is useful when you want to test a specific experiment group.
 */ groupOverrides, /**
 * Param overrides are used to set the experiment parameters for testing purposes.
 * This is useful when you want to tweak the experiment parameters for testing.
 */ paramOverrides, options) {
    if (groupOverrides) {
        // When setting up overrides, we want to ensure that experiments don't end up with invalid
        // values.
        // For production usage -- this is done via the feature flag client which takes the type
        // and performs equivalent logic.
        // @ts-ignore
        groupOverrides = Object.entries(groupOverrides).reduce(function(acc, _ref) {
            var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_ref, 2), key = _ref2[0], value = _ref2[1];
            var config = (0, $aj4TE.editorExperimentsConfig)[key];
            if (config) acc = $528899015f76bd1a$var$_objectSpread($528899015f76bd1a$var$_objectSpread({}, acc), {}, (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, key, config.typeGuard(value) ? value : config.defaultValue));
            return acc;
        }, {});
        $528899015f76bd1a$export$e5d73bf4f8e2ae96 = groupOverrides;
    }
    if (product === 'test' && !(options !== null && options !== void 0 && options.disableTestOverrides)) {
        // Enforce expectation - file overrides, then global overrides, then default to true for boolean
        // experiments, then last result use the default value
        var testOverrides = Object.fromEntries(Object.entries((0, $aj4TE.editorExperimentsConfig)).map(function(_ref3) {
            var _ref5, _ref6, _groupOverrides, _groupOverrides2;
            var _ref4 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_ref3, 2), key = _ref4[0], value = _ref4[1];
            var defaultValue = typeof value.defaultValue === 'boolean' ? true : value.defaultValue;
            return [
                key,
                (_ref5 = (_ref6 = (_groupOverrides = (_groupOverrides2 = groupOverrides) === null || _groupOverrides2 === void 0 ? void 0 : _groupOverrides2[key]) !== null && _groupOverrides !== void 0 ? _groupOverrides : (0, $89JeF.testMultivariateOverrides)[key]) !== null && _ref6 !== void 0 ? _ref6 : (0, $89JeF.testBooleanOverrides)[key]) !== null && _ref5 !== void 0 ? _ref5 : defaultValue
            ];
        }));
        $528899015f76bd1a$export$e5d73bf4f8e2ae96 = testOverrides;
    }
    $528899015f76bd1a$export$cf7305fc65acbf0d = product;
    $528899015f76bd1a$export$4e849416bb5c5b52 = paramOverrides || {};
}

});
parcelRegister("89JeF", function(module, exports) {
$parcel$export(module.exports, "testMultivariateOverrides", () => $5f0240d492457d1a$export$7e849a84a00ffd1c);
$parcel$export(module.exports, "testBooleanOverrides", () => $5f0240d492457d1a$export$54960937bb713f97);
var $5f0240d492457d1a$export$7e849a84a00ffd1c = {
    'example-multivariate': 'one',
    'platform_editor_ai-prompts-placeholder': 'control',
    platform_editor_ai_proactive_ai_nudge_parameters: 'control',
    platform_editor_controls: 'control',
    confluence_whiteboards_quick_insert_aa: 'control',
    confluence_whiteboards_quick_insert: 'control',
    confluence_whiteboards_quick_insert_localised: 'control',
    confluence_whiteboards_quick_insert_localised_aa: 'control',
    cc_editor_ai_content_mode: 'control',
    platform_editor_add_orange_highlight_color: 'control',
    platform_editor_ai_iw_adf_streaming: 'control',
    platform_editor_ai_non_iw_adf_streaming: 'control',
    platform_hover_card_preview_panel: 'control',
    platform_hover_card_preview_panel_modal: 'control',
    smart_link_confluence_short_link_analytics: 'control',
    platform_inline_smartcard_connect_button_exp: 'control',
    confluence_content_mode_replace_dense_with_compact: 'control',
    cc_editor_insm_outlier_events: 'test',
    platform_editor_disable_table_overflow_shadows: 'control',
    platform_editor_hoverlink_ui_fixes_exp: 'control',
    platform_editor_table_sticky_header_improvements: 'control',
    platform_sl_3p_unauth_paste_as_block_card: 'control'
};
var $5f0240d492457d1a$export$54960937bb713f97 = {
    platform_editor_feedback_mandatory_rating: false,
    platform_editor_preview_panel_responsiveness: false,
    platform_editor_renderer_breakout_fix: false,
    platform_editor_toolbar_aifc: false,
    platform_editor_block_control_optimise_render: false,
    'test-new-experiments-package': false,
    support_table_in_comment: false,
    platform_editor_exp_lazy_node_views: false,
    platform_renderer_table_sticky_scrollbar: false,
    platform_editor_prevent_toolbar_layout_shifts: false,
    comment_on_bodied_extensions: false,
    advanced_layouts: false,
    single_column_layouts: false,
    support_table_in_comment_jira: false,
    'nested-tables-in-tables': false,
    platform_editor_ai_unsplash_page_header: false,
    platform_editor_blockquote_in_text_formatting_menu: false,
    platform_editor_element_drag_and_drop_multiselect: false,
    platform_editor_ai_edit_response_in_preview: false,
    platform_editor_offline_editing_web: false,
    platform_editor_tables_drag_and_drop: false,
    platform_editor_tables_table_selector: false,
    platform_renderer_fix_analytics_memo_callback: false,
    platform_editor_stop_width_reflows: false,
    platform_editor_no_cursor_on_edit_page_init: false,
    'jira-work-sync-desc-comment-summary': false,
    platform_editor_breakout_resizing: false,
    platform_editor_ai_quickstart_command: false,
    platform_editor_block_controls_perf_optimization: false,
    platform_editor_enable_single_player_step_merging: false,
    platform_editor_find_and_replace_improvements: false,
    platform_editor_toggle_expand_on_match_found: false,
    platform_editor_reduce_noisy_steps_ncs: false,
    cc_improve_writing_on_paste_v2: false,
    platform_editor_text_highlight_padding: false
};

});



parcelRegister("cc08P", function(module, exports) {
$parcel$export(module.exports, "Selection", () => $8e06b7206d4b50ac$export$52baac22726c72bf);
$parcel$export(module.exports, "SelectionRange", () => $8e06b7206d4b50ac$export$7bd1839c3c5d5bd4);
$parcel$export(module.exports, "TextSelection", () => $8e06b7206d4b50ac$export$c2b25f346d19bcbb);
$parcel$export(module.exports, "AllSelection", () => $8e06b7206d4b50ac$export$c15d9ba76bdbcd95);
$parcel$export(module.exports, "NodeSelection", () => $8e06b7206d4b50ac$export$e2940151ac854c0b);
$parcel$export(module.exports, "EditorState", () => $8e06b7206d4b50ac$export$afa855cbfaff27f2);
$parcel$export(module.exports, "Plugin", () => $8e06b7206d4b50ac$export$901cf72dabf2112a);
$parcel$export(module.exports, "PluginKey", () => $8e06b7206d4b50ac$export$1692d8b0e89cecc3);

var $9Jwkl = parcelRequire("9Jwkl");

var $lh06P = parcelRequire("lh06P");
const $8e06b7206d4b50ac$var$classesById = Object.create(null);
/**
Superclass for editor selections. Every selection type should
extend this. Should not be instantiated directly.
*/ class $8e06b7206d4b50ac$export$52baac22726c72bf {
    /**
    Initialize a selection with the head and anchor and ranges. If no
    ranges are given, constructs a single range across `$anchor` and
    `$head`.
    */ constructor(/**
    The resolved anchor of the selection (the side that stays in
    place when the selection is modified).
    */ $anchor, /**
    The resolved head of the selection (the side that moves when
    the selection is modified).
    */ $head, ranges){
        this.$anchor = $anchor;
        this.$head = $head;
        this.ranges = ranges || [
            new $8e06b7206d4b50ac$export$7bd1839c3c5d5bd4($anchor.min($head), $anchor.max($head))
        ];
    }
    /**
    The selection's anchor, as an unresolved position.
    */ get anchor() {
        return this.$anchor.pos;
    }
    /**
    The selection's head.
    */ get head() {
        return this.$head.pos;
    }
    /**
    The lower bound of the selection's main range.
    */ get from() {
        return this.$from.pos;
    }
    /**
    The upper bound of the selection's main range.
    */ get to() {
        return this.$to.pos;
    }
    /**
    The resolved lower  bound of the selection's main range.
    */ get $from() {
        return this.ranges[0].$from;
    }
    /**
    The resolved upper bound of the selection's main range.
    */ get $to() {
        return this.ranges[0].$to;
    }
    /**
    Indicates whether the selection contains any content.
    */ get empty() {
        let ranges = this.ranges;
        for(let i = 0; i < ranges.length; i++)if (ranges[i].$from.pos != ranges[i].$to.pos) return false;
        return true;
    }
    /**
    Get the content of this selection as a slice.
    */ content() {
        return this.$from.doc.slice(this.from, this.to, true);
    }
    /**
    Replace the selection with a slice or, if no slice is given,
    delete the selection. Will append to the given transaction.
    */ replace(tr, content = (0, $9Jwkl.Slice).empty) {
        // Put the new selection at the position after the inserted
        // content. When that ended in an inline node, search backwards,
        // to get the position after that node. If not, search forward.
        let lastNode = content.content.lastChild, lastParent = null;
        for(let i = 0; i < content.openEnd; i++){
            lastParent = lastNode;
            lastNode = lastNode.lastChild;
        }
        let mapFrom = tr.steps.length, ranges = this.ranges;
        for(let i = 0; i < ranges.length; i++){
            let { $from: $from, $to: $to } = ranges[i], mapping = tr.mapping.slice(mapFrom);
            tr.replaceRange(mapping.map($from.pos), mapping.map($to.pos), i ? (0, $9Jwkl.Slice).empty : content);
            if (i == 0) $8e06b7206d4b50ac$var$selectionToInsertionEnd(tr, mapFrom, (lastNode ? lastNode.isInline : lastParent && lastParent.isTextblock) ? -1 : 1);
        }
    }
    /**
    Replace the selection with the given node, appending the changes
    to the given transaction.
    */ replaceWith(tr, node) {
        let mapFrom = tr.steps.length, ranges = this.ranges;
        for(let i = 0; i < ranges.length; i++){
            let { $from: $from, $to: $to } = ranges[i], mapping = tr.mapping.slice(mapFrom);
            let from = mapping.map($from.pos), to = mapping.map($to.pos);
            if (i) tr.deleteRange(from, to);
            else {
                tr.replaceRangeWith(from, to, node);
                $8e06b7206d4b50ac$var$selectionToInsertionEnd(tr, mapFrom, node.isInline ? -1 : 1);
            }
        }
    }
    /**
    Find a valid cursor or leaf node selection starting at the given
    position and searching back if `dir` is negative, and forward if
    positive. When `textOnly` is true, only consider cursor
    selections. Will return null when no valid selection position is
    found.
    */ static findFrom($pos, dir, textOnly = false) {
        let inner = $pos.parent.inlineContent ? new $8e06b7206d4b50ac$export$c2b25f346d19bcbb($pos) : $8e06b7206d4b50ac$var$findSelectionIn($pos.node(0), $pos.parent, $pos.pos, $pos.index(), dir, textOnly);
        if (inner) return inner;
        for(let depth = $pos.depth - 1; depth >= 0; depth--){
            let found = dir < 0 ? $8e06b7206d4b50ac$var$findSelectionIn($pos.node(0), $pos.node(depth), $pos.before(depth + 1), $pos.index(depth), dir, textOnly) : $8e06b7206d4b50ac$var$findSelectionIn($pos.node(0), $pos.node(depth), $pos.after(depth + 1), $pos.index(depth) + 1, dir, textOnly);
            if (found) return found;
        }
        return null;
    }
    /**
    Find a valid cursor or leaf node selection near the given
    position. Searches forward first by default, but if `bias` is
    negative, it will search backwards first.
    */ static near($pos, bias = 1) {
        return this.findFrom($pos, bias) || this.findFrom($pos, -bias) || new $8e06b7206d4b50ac$export$c15d9ba76bdbcd95($pos.node(0));
    }
    /**
    Find the cursor or leaf node selection closest to the start of
    the given document. Will return an
    [`AllSelection`](https://prosemirror.net/docs/ref/#state.AllSelection) if no valid position
    exists.
    */ static atStart(doc) {
        return $8e06b7206d4b50ac$var$findSelectionIn(doc, doc, 0, 0, 1) || new $8e06b7206d4b50ac$export$c15d9ba76bdbcd95(doc);
    }
    /**
    Find the cursor or leaf node selection closest to the end of the
    given document.
    */ static atEnd(doc) {
        return $8e06b7206d4b50ac$var$findSelectionIn(doc, doc, doc.content.size, doc.childCount, -1) || new $8e06b7206d4b50ac$export$c15d9ba76bdbcd95(doc);
    }
    /**
    Deserialize the JSON representation of a selection. Must be
    implemented for custom classes (as a static class method).
    */ static fromJSON(doc, json) {
        if (!json || !json.type) throw new RangeError("Invalid input for Selection.fromJSON");
        let cls = $8e06b7206d4b50ac$var$classesById[json.type];
        if (!cls) throw new RangeError(`No selection type ${json.type} defined`);
        return cls.fromJSON(doc, json);
    }
    /**
    To be able to deserialize selections from JSON, custom selection
    classes must register themselves with an ID string, so that they
    can be disambiguated. Try to pick something that's unlikely to
    clash with classes from other modules.
    */ static jsonID(id, selectionClass) {
        if (id in $8e06b7206d4b50ac$var$classesById) throw new RangeError("Duplicate use of selection JSON ID " + id);
        $8e06b7206d4b50ac$var$classesById[id] = selectionClass;
        selectionClass.prototype.jsonID = id;
        return selectionClass;
    }
    /**
    Get a [bookmark](https://prosemirror.net/docs/ref/#state.SelectionBookmark) for this selection,
    which is a value that can be mapped without having access to a
    current document, and later resolved to a real selection for a
    given document again. (This is used mostly by the history to
    track and restore old selections.) The default implementation of
    this method just converts the selection to a text selection and
    returns the bookmark for that.
    */ getBookmark() {
        return $8e06b7206d4b50ac$export$c2b25f346d19bcbb.between(this.$anchor, this.$head).getBookmark();
    }
}
$8e06b7206d4b50ac$export$52baac22726c72bf.prototype.visible = true;
/**
Represents a selected range in a document.
*/ class $8e06b7206d4b50ac$export$7bd1839c3c5d5bd4 {
    /**
    Create a range.
    */ constructor(/**
    The lower bound of the range.
    */ $from, /**
    The upper bound of the range.
    */ $to){
        this.$from = $from;
        this.$to = $to;
    }
}
let $8e06b7206d4b50ac$var$warnedAboutTextSelection = false;
function $8e06b7206d4b50ac$var$checkTextSelection($pos) {
    if (!$8e06b7206d4b50ac$var$warnedAboutTextSelection && !$pos.parent.inlineContent) {
        $8e06b7206d4b50ac$var$warnedAboutTextSelection = true;
        console["warn"]("TextSelection endpoint not pointing into a node with inline content (" + $pos.parent.type.name + ")");
    }
}
/**
A text selection represents a classical editor selection, with a
head (the moving side) and anchor (immobile side), both of which
point into textblock nodes. It can be empty (a regular cursor
position).
*/ class $8e06b7206d4b50ac$export$c2b25f346d19bcbb extends $8e06b7206d4b50ac$export$52baac22726c72bf {
    /**
    Construct a text selection between the given points.
    */ constructor($anchor, $head = $anchor){
        $8e06b7206d4b50ac$var$checkTextSelection($anchor);
        $8e06b7206d4b50ac$var$checkTextSelection($head);
        super($anchor, $head);
    }
    /**
    Returns a resolved position if this is a cursor selection (an
    empty text selection), and null otherwise.
    */ get $cursor() {
        return this.$anchor.pos == this.$head.pos ? this.$head : null;
    }
    map(doc, mapping) {
        let $head = doc.resolve(mapping.map(this.head));
        if (!$head.parent.inlineContent) return $8e06b7206d4b50ac$export$52baac22726c72bf.near($head);
        let $anchor = doc.resolve(mapping.map(this.anchor));
        return new $8e06b7206d4b50ac$export$c2b25f346d19bcbb($anchor.parent.inlineContent ? $anchor : $head, $head);
    }
    replace(tr, content = (0, $9Jwkl.Slice).empty) {
        super.replace(tr, content);
        if (content == (0, $9Jwkl.Slice).empty) {
            let marks = this.$from.marksAcross(this.$to);
            if (marks) tr.ensureMarks(marks);
        }
    }
    eq(other) {
        return other instanceof $8e06b7206d4b50ac$export$c2b25f346d19bcbb && other.anchor == this.anchor && other.head == this.head;
    }
    getBookmark() {
        return new $8e06b7206d4b50ac$var$TextBookmark(this.anchor, this.head);
    }
    toJSON() {
        return {
            type: "text",
            anchor: this.anchor,
            head: this.head
        };
    }
    /**
    @internal
    */ static fromJSON(doc, json) {
        if (typeof json.anchor != "number" || typeof json.head != "number") throw new RangeError("Invalid input for TextSelection.fromJSON");
        return new $8e06b7206d4b50ac$export$c2b25f346d19bcbb(doc.resolve(json.anchor), doc.resolve(json.head));
    }
    /**
    Create a text selection from non-resolved positions.
    */ static create(doc, anchor, head = anchor) {
        let $anchor = doc.resolve(anchor);
        return new this($anchor, head == anchor ? $anchor : doc.resolve(head));
    }
    /**
    Return a text selection that spans the given positions or, if
    they aren't text positions, find a text selection near them.
    `bias` determines whether the method searches forward (default)
    or backwards (negative number) first. Will fall back to calling
    [`Selection.near`](https://prosemirror.net/docs/ref/#state.Selection^near) when the document
    doesn't contain a valid text position.
    */ static between($anchor, $head, bias) {
        let dPos = $anchor.pos - $head.pos;
        if (!bias || dPos) bias = dPos >= 0 ? 1 : -1;
        if (!$head.parent.inlineContent) {
            let found = $8e06b7206d4b50ac$export$52baac22726c72bf.findFrom($head, bias, true) || $8e06b7206d4b50ac$export$52baac22726c72bf.findFrom($head, -bias, true);
            if (found) $head = found.$head;
            else return $8e06b7206d4b50ac$export$52baac22726c72bf.near($head, bias);
        }
        if (!$anchor.parent.inlineContent) {
            if (dPos == 0) $anchor = $head;
            else {
                $anchor = ($8e06b7206d4b50ac$export$52baac22726c72bf.findFrom($anchor, -bias, true) || $8e06b7206d4b50ac$export$52baac22726c72bf.findFrom($anchor, bias, true)).$anchor;
                if ($anchor.pos < $head.pos != dPos < 0) $anchor = $head;
            }
        }
        return new $8e06b7206d4b50ac$export$c2b25f346d19bcbb($anchor, $head);
    }
}
$8e06b7206d4b50ac$export$52baac22726c72bf.jsonID("text", $8e06b7206d4b50ac$export$c2b25f346d19bcbb);
class $8e06b7206d4b50ac$var$TextBookmark {
    constructor(anchor, head){
        this.anchor = anchor;
        this.head = head;
    }
    map(mapping) {
        return new $8e06b7206d4b50ac$var$TextBookmark(mapping.map(this.anchor), mapping.map(this.head));
    }
    resolve(doc) {
        return $8e06b7206d4b50ac$export$c2b25f346d19bcbb.between(doc.resolve(this.anchor), doc.resolve(this.head));
    }
}
/**
A node selection is a selection that points at a single node. All
nodes marked [selectable](https://prosemirror.net/docs/ref/#model.NodeSpec.selectable) can be the
target of a node selection. In such a selection, `from` and `to`
point directly before and after the selected node, `anchor` equals
`from`, and `head` equals `to`..
*/ class $8e06b7206d4b50ac$export$e2940151ac854c0b extends $8e06b7206d4b50ac$export$52baac22726c72bf {
    /**
    Create a node selection. Does not verify the validity of its
    argument.
    */ constructor($pos){
        let node = $pos.nodeAfter;
        let $end = $pos.node(0).resolve($pos.pos + node.nodeSize);
        super($pos, $end);
        this.node = node;
    }
    map(doc, mapping) {
        let { deleted: deleted, pos: pos } = mapping.mapResult(this.anchor);
        let $pos = doc.resolve(pos);
        if (deleted) return $8e06b7206d4b50ac$export$52baac22726c72bf.near($pos);
        return new $8e06b7206d4b50ac$export$e2940151ac854c0b($pos);
    }
    content() {
        return new (0, $9Jwkl.Slice)((0, $9Jwkl.Fragment).from(this.node), 0, 0);
    }
    eq(other) {
        return other instanceof $8e06b7206d4b50ac$export$e2940151ac854c0b && other.anchor == this.anchor;
    }
    toJSON() {
        return {
            type: "node",
            anchor: this.anchor
        };
    }
    getBookmark() {
        return new $8e06b7206d4b50ac$var$NodeBookmark(this.anchor);
    }
    /**
    @internal
    */ static fromJSON(doc, json) {
        if (typeof json.anchor != "number") throw new RangeError("Invalid input for NodeSelection.fromJSON");
        return new $8e06b7206d4b50ac$export$e2940151ac854c0b(doc.resolve(json.anchor));
    }
    /**
    Create a node selection from non-resolved positions.
    */ static create(doc, from) {
        return new $8e06b7206d4b50ac$export$e2940151ac854c0b(doc.resolve(from));
    }
    /**
    Determines whether the given node may be selected as a node
    selection.
    */ static isSelectable(node) {
        return !node.isText && node.type.spec.selectable !== false;
    }
}
$8e06b7206d4b50ac$export$e2940151ac854c0b.prototype.visible = false;
$8e06b7206d4b50ac$export$52baac22726c72bf.jsonID("node", $8e06b7206d4b50ac$export$e2940151ac854c0b);
class $8e06b7206d4b50ac$var$NodeBookmark {
    constructor(anchor){
        this.anchor = anchor;
    }
    map(mapping) {
        let { deleted: deleted, pos: pos } = mapping.mapResult(this.anchor);
        return deleted ? new $8e06b7206d4b50ac$var$TextBookmark(pos, pos) : new $8e06b7206d4b50ac$var$NodeBookmark(pos);
    }
    resolve(doc) {
        let $pos = doc.resolve(this.anchor), node = $pos.nodeAfter;
        if (node && $8e06b7206d4b50ac$export$e2940151ac854c0b.isSelectable(node)) return new $8e06b7206d4b50ac$export$e2940151ac854c0b($pos);
        return $8e06b7206d4b50ac$export$52baac22726c72bf.near($pos);
    }
}
/**
A selection type that represents selecting the whole document
(which can not necessarily be expressed with a text selection, when
there are for example leaf block nodes at the start or end of the
document).
*/ class $8e06b7206d4b50ac$export$c15d9ba76bdbcd95 extends $8e06b7206d4b50ac$export$52baac22726c72bf {
    /**
    Create an all-selection over the given document.
    */ constructor(doc){
        super(doc.resolve(0), doc.resolve(doc.content.size));
    }
    replace(tr, content = (0, $9Jwkl.Slice).empty) {
        if (content == (0, $9Jwkl.Slice).empty) {
            tr.delete(0, tr.doc.content.size);
            let sel = $8e06b7206d4b50ac$export$52baac22726c72bf.atStart(tr.doc);
            if (!sel.eq(tr.selection)) tr.setSelection(sel);
        } else super.replace(tr, content);
    }
    toJSON() {
        return {
            type: "all"
        };
    }
    /**
    @internal
    */ static fromJSON(doc) {
        return new $8e06b7206d4b50ac$export$c15d9ba76bdbcd95(doc);
    }
    map(doc) {
        return new $8e06b7206d4b50ac$export$c15d9ba76bdbcd95(doc);
    }
    eq(other) {
        return other instanceof $8e06b7206d4b50ac$export$c15d9ba76bdbcd95;
    }
    getBookmark() {
        return $8e06b7206d4b50ac$var$AllBookmark;
    }
}
$8e06b7206d4b50ac$export$52baac22726c72bf.jsonID("all", $8e06b7206d4b50ac$export$c15d9ba76bdbcd95);
const $8e06b7206d4b50ac$var$AllBookmark = {
    map () {
        return this;
    },
    resolve (doc) {
        return new $8e06b7206d4b50ac$export$c15d9ba76bdbcd95(doc);
    }
};
// FIXME we'll need some awareness of text direction when scanning for selections
// Try to find a selection inside the given node. `pos` points at the
// position where the search starts. When `text` is true, only return
// text selections.
function $8e06b7206d4b50ac$var$findSelectionIn(doc, node, pos, index, dir, text = false) {
    if (node.inlineContent) return $8e06b7206d4b50ac$export$c2b25f346d19bcbb.create(doc, pos);
    for(let i = index - (dir > 0 ? 0 : 1); dir > 0 ? i < node.childCount : i >= 0; i += dir){
        let child = node.child(i);
        if (!child.isAtom) {
            let inner = $8e06b7206d4b50ac$var$findSelectionIn(doc, child, pos + dir, dir < 0 ? child.childCount : 0, dir, text);
            if (inner) return inner;
        } else if (!text && $8e06b7206d4b50ac$export$e2940151ac854c0b.isSelectable(child)) return $8e06b7206d4b50ac$export$e2940151ac854c0b.create(doc, pos - (dir < 0 ? child.nodeSize : 0));
        pos += child.nodeSize * dir;
    }
    return null;
}
function $8e06b7206d4b50ac$var$selectionToInsertionEnd(tr, startLen, bias) {
    let last = tr.steps.length - 1;
    if (last < startLen) return;
    let step = tr.steps[last];
    if (!(step instanceof (0, $lh06P.ReplaceStep) || step instanceof (0, $lh06P.ReplaceAroundStep))) return;
    let map = tr.mapping.maps[last], end;
    map.forEach((_from, _to, _newFrom, newTo)=>{
        if (end == null) end = newTo;
    });
    tr.setSelection($8e06b7206d4b50ac$export$52baac22726c72bf.near(tr.doc.resolve(end), bias));
}
const $8e06b7206d4b50ac$var$UPDATED_SEL = 1, $8e06b7206d4b50ac$var$UPDATED_MARKS = 2, $8e06b7206d4b50ac$var$UPDATED_SCROLL = 4;
/**
An editor state transaction, which can be applied to a state to
create an updated state. Use
[`EditorState.tr`](https://prosemirror.net/docs/ref/#state.EditorState.tr) to create an instance.

Transactions track changes to the document (they are a subclass of
[`Transform`](https://prosemirror.net/docs/ref/#transform.Transform)), but also other state changes,
like selection updates and adjustments of the set of [stored
marks](https://prosemirror.net/docs/ref/#state.EditorState.storedMarks). In addition, you can store
metadata properties in a transaction, which are extra pieces of
information that client code or plugins can use to describe what a
transaction represents, so that they can update their [own
state](https://prosemirror.net/docs/ref/#state.StateField) accordingly.

The [editor view](https://prosemirror.net/docs/ref/#view.EditorView) uses a few metadata
properties: it will attach a property `"pointer"` with the value
`true` to selection transactions directly caused by mouse or touch
input, a `"composition"` property holding an ID identifying the
composition that caused it to transactions caused by composed DOM
input, and a `"uiEvent"` property of that may be `"paste"`,
`"cut"`, or `"drop"`.
*/ class $8e06b7206d4b50ac$export$febc5573c75cefb0 extends (0, $lh06P.Transform) {
    /**
    @internal
    */ constructor(state){
        super(state.doc);
        // The step count for which the current selection is valid.
        this.curSelectionFor = 0;
        // Bitfield to track which aspects of the state were updated by
        // this transaction.
        this.updated = 0;
        // Object used to store metadata properties for the transaction.
        this.meta = Object.create(null);
        this.time = Date.now();
        this.curSelection = state.selection;
        this.storedMarks = state.storedMarks;
    }
    /**
    The transaction's current selection. This defaults to the editor
    selection [mapped](https://prosemirror.net/docs/ref/#state.Selection.map) through the steps in the
    transaction, but can be overwritten with
    [`setSelection`](https://prosemirror.net/docs/ref/#state.Transaction.setSelection).
    */ get selection() {
        if (this.curSelectionFor < this.steps.length) {
            this.curSelection = this.curSelection.map(this.doc, this.mapping.slice(this.curSelectionFor));
            this.curSelectionFor = this.steps.length;
        }
        return this.curSelection;
    }
    /**
    Update the transaction's current selection. Will determine the
    selection that the editor gets when the transaction is applied.
    */ setSelection(selection) {
        if (selection.$from.doc != this.doc) throw new RangeError("Selection passed to setSelection must point at the current document");
        this.curSelection = selection;
        this.curSelectionFor = this.steps.length;
        this.updated = (this.updated | $8e06b7206d4b50ac$var$UPDATED_SEL) & ~$8e06b7206d4b50ac$var$UPDATED_MARKS;
        this.storedMarks = null;
        return this;
    }
    /**
    Whether the selection was explicitly updated by this transaction.
    */ get selectionSet() {
        return (this.updated & $8e06b7206d4b50ac$var$UPDATED_SEL) > 0;
    }
    /**
    Set the current stored marks.
    */ setStoredMarks(marks) {
        this.storedMarks = marks;
        this.updated |= $8e06b7206d4b50ac$var$UPDATED_MARKS;
        return this;
    }
    /**
    Make sure the current stored marks or, if that is null, the marks
    at the selection, match the given set of marks. Does nothing if
    this is already the case.
    */ ensureMarks(marks) {
        if (!(0, $9Jwkl.Mark).sameSet(this.storedMarks || this.selection.$from.marks(), marks)) this.setStoredMarks(marks);
        return this;
    }
    /**
    Add a mark to the set of stored marks.
    */ addStoredMark(mark) {
        return this.ensureMarks(mark.addToSet(this.storedMarks || this.selection.$head.marks()));
    }
    /**
    Remove a mark or mark type from the set of stored marks.
    */ removeStoredMark(mark) {
        return this.ensureMarks(mark.removeFromSet(this.storedMarks || this.selection.$head.marks()));
    }
    /**
    Whether the stored marks were explicitly set for this transaction.
    */ get storedMarksSet() {
        return (this.updated & $8e06b7206d4b50ac$var$UPDATED_MARKS) > 0;
    }
    /**
    @internal
    */ addStep(step, doc) {
        super.addStep(step, doc);
        this.updated = this.updated & ~$8e06b7206d4b50ac$var$UPDATED_MARKS;
        this.storedMarks = null;
    }
    /**
    Update the timestamp for the transaction.
    */ setTime(time) {
        this.time = time;
        return this;
    }
    /**
    Replace the current selection with the given slice.
    */ replaceSelection(slice) {
        this.selection.replace(this, slice);
        return this;
    }
    /**
    Replace the selection with the given node. When `inheritMarks` is
    true and the content is inline, it inherits the marks from the
    place where it is inserted.
    */ replaceSelectionWith(node, inheritMarks = true) {
        let selection = this.selection;
        if (inheritMarks) node = node.mark(this.storedMarks || (selection.empty ? selection.$from.marks() : selection.$from.marksAcross(selection.$to) || (0, $9Jwkl.Mark).none));
        selection.replaceWith(this, node);
        return this;
    }
    /**
    Delete the selection.
    */ deleteSelection() {
        this.selection.replace(this);
        return this;
    }
    /**
    Replace the given range, or the selection if no range is given,
    with a text node containing the given string.
    */ insertText(text, from, to) {
        let schema = this.doc.type.schema;
        if (from == null) {
            if (!text) return this.deleteSelection();
            return this.replaceSelectionWith(schema.text(text), true);
        } else {
            if (to == null) to = from;
            if (!text) return this.deleteRange(from, to);
            let marks = this.storedMarks;
            if (!marks) {
                let $from = this.doc.resolve(from);
                marks = to == from ? $from.marks() : $from.marksAcross(this.doc.resolve(to));
            }
            this.replaceRangeWith(from, to, schema.text(text, marks));
            if (!this.selection.empty && this.selection.to == from + text.length) this.setSelection($8e06b7206d4b50ac$export$52baac22726c72bf.near(this.selection.$to));
            return this;
        }
    }
    /**
    Store a metadata property in this transaction, keyed either by
    name or by plugin.
    */ setMeta(key, value) {
        this.meta[typeof key == "string" ? key : key.key] = value;
        return this;
    }
    /**
    Retrieve a metadata property for a given name or plugin.
    */ getMeta(key) {
        return this.meta[typeof key == "string" ? key : key.key];
    }
    /**
    Returns true if this transaction doesn't contain any metadata,
    and can thus safely be extended.
    */ get isGeneric() {
        for(let _ in this.meta)return false;
        return true;
    }
    /**
    Indicate that the editor should scroll the selection into view
    when updated to the state produced by this transaction.
    */ scrollIntoView() {
        this.updated |= $8e06b7206d4b50ac$var$UPDATED_SCROLL;
        return this;
    }
    /**
    True when this transaction has had `scrollIntoView` called on it.
    */ get scrolledIntoView() {
        return (this.updated & $8e06b7206d4b50ac$var$UPDATED_SCROLL) > 0;
    }
}
function $8e06b7206d4b50ac$var$bind(f, self) {
    return !self || !f ? f : f.bind(self);
}
class $8e06b7206d4b50ac$var$FieldDesc {
    constructor(name, desc, self){
        this.name = name;
        this.init = $8e06b7206d4b50ac$var$bind(desc.init, self);
        this.apply = $8e06b7206d4b50ac$var$bind(desc.apply, self);
    }
}
const $8e06b7206d4b50ac$var$baseFields = [
    new $8e06b7206d4b50ac$var$FieldDesc("doc", {
        init (config) {
            return config.doc || config.schema.topNodeType.createAndFill();
        },
        apply (tr) {
            return tr.doc;
        }
    }),
    new $8e06b7206d4b50ac$var$FieldDesc("selection", {
        init (config, instance) {
            return config.selection || $8e06b7206d4b50ac$export$52baac22726c72bf.atStart(instance.doc);
        },
        apply (tr) {
            return tr.selection;
        }
    }),
    new $8e06b7206d4b50ac$var$FieldDesc("storedMarks", {
        init (config) {
            return config.storedMarks || null;
        },
        apply (tr, _marks, _old, state) {
            return state.selection.$cursor ? tr.storedMarks : null;
        }
    }),
    new $8e06b7206d4b50ac$var$FieldDesc("scrollToSelection", {
        init () {
            return 0;
        },
        apply (tr, prev) {
            return tr.scrolledIntoView ? prev + 1 : prev;
        }
    })
];
// Object wrapping the part of a state object that stays the same
// across transactions. Stored in the state's `config` property.
class $8e06b7206d4b50ac$var$Configuration {
    constructor(schema, plugins){
        this.schema = schema;
        this.plugins = [];
        this.pluginsByKey = Object.create(null);
        this.fields = $8e06b7206d4b50ac$var$baseFields.slice();
        if (plugins) plugins.forEach((plugin)=>{
            if (this.pluginsByKey[plugin.key]) throw new RangeError("Adding different instances of a keyed plugin (" + plugin.key + ")");
            this.plugins.push(plugin);
            this.pluginsByKey[plugin.key] = plugin;
            if (plugin.spec.state) this.fields.push(new $8e06b7206d4b50ac$var$FieldDesc(plugin.key, plugin.spec.state, plugin));
        });
    }
}
/**
The state of a ProseMirror editor is represented by an object of
this type. A state is a persistent data structure—it isn't
updated, but rather a new state value is computed from an old one
using the [`apply`](https://prosemirror.net/docs/ref/#state.EditorState.apply) method.

A state holds a number of built-in fields, and plugins can
[define](https://prosemirror.net/docs/ref/#state.PluginSpec.state) additional fields.
*/ class $8e06b7206d4b50ac$export$afa855cbfaff27f2 {
    /**
    @internal
    */ constructor(/**
    @internal
    */ config){
        this.config = config;
    }
    /**
    The schema of the state's document.
    */ get schema() {
        return this.config.schema;
    }
    /**
    The plugins that are active in this state.
    */ get plugins() {
        return this.config.plugins;
    }
    /**
    Apply the given transaction to produce a new state.
    */ apply(tr) {
        return this.applyTransaction(tr).state;
    }
    /**
    @internal
    */ filterTransaction(tr, ignore = -1) {
        for(let i = 0; i < this.config.plugins.length; i++)if (i != ignore) {
            let plugin = this.config.plugins[i];
            if (plugin.spec.filterTransaction && !plugin.spec.filterTransaction.call(plugin, tr, this)) return false;
        }
        return true;
    }
    /**
    Verbose variant of [`apply`](https://prosemirror.net/docs/ref/#state.EditorState.apply) that
    returns the precise transactions that were applied (which might
    be influenced by the [transaction
    hooks](https://prosemirror.net/docs/ref/#state.PluginSpec.filterTransaction) of
    plugins) along with the new state.
    */ applyTransaction(rootTr) {
        if (!this.filterTransaction(rootTr)) return {
            state: this,
            transactions: []
        };
        let trs = [
            rootTr
        ], newState = this.applyInner(rootTr), seen = null;
        // This loop repeatedly gives plugins a chance to respond to
        // transactions as new transactions are added, making sure to only
        // pass the transactions the plugin did not see before.
        for(;;){
            let haveNew = false;
            for(let i = 0; i < this.config.plugins.length; i++){
                let plugin = this.config.plugins[i];
                if (plugin.spec.appendTransaction) {
                    let n = seen ? seen[i].n : 0, oldState = seen ? seen[i].state : this;
                    let tr = n < trs.length && plugin.spec.appendTransaction.call(plugin, n ? trs.slice(n) : trs, oldState, newState);
                    if (tr && newState.filterTransaction(tr, i)) {
                        tr.setMeta("appendedTransaction", rootTr);
                        if (!seen) {
                            seen = [];
                            for(let j = 0; j < this.config.plugins.length; j++)seen.push(j < i ? {
                                state: newState,
                                n: trs.length
                            } : {
                                state: this,
                                n: 0
                            });
                        }
                        trs.push(tr);
                        newState = newState.applyInner(tr);
                        haveNew = true;
                    }
                    if (seen) seen[i] = {
                        state: newState,
                        n: trs.length
                    };
                }
            }
            if (!haveNew) return {
                state: newState,
                transactions: trs
            };
        }
    }
    /**
    @internal
    */ applyInner(tr) {
        if (!tr.before.eq(this.doc)) throw new RangeError("Applying a mismatched transaction");
        let newInstance = new $8e06b7206d4b50ac$export$afa855cbfaff27f2(this.config), fields = this.config.fields;
        for(let i = 0; i < fields.length; i++){
            let field = fields[i];
            newInstance[field.name] = field.apply(tr, this[field.name], this, newInstance);
        }
        return newInstance;
    }
    /**
    Accessor that constructs and returns a new [transaction](https://prosemirror.net/docs/ref/#state.Transaction) from this state.
    */ get tr() {
        return new $8e06b7206d4b50ac$export$febc5573c75cefb0(this);
    }
    /**
    Create a new state.
    */ static create(config) {
        let $config = new $8e06b7206d4b50ac$var$Configuration(config.doc ? config.doc.type.schema : config.schema, config.plugins);
        let instance = new $8e06b7206d4b50ac$export$afa855cbfaff27f2($config);
        for(let i = 0; i < $config.fields.length; i++)instance[$config.fields[i].name] = $config.fields[i].init(config, instance);
        return instance;
    }
    /**
    Create a new state based on this one, but with an adjusted set
    of active plugins. State fields that exist in both sets of
    plugins are kept unchanged. Those that no longer exist are
    dropped, and those that are new are initialized using their
    [`init`](https://prosemirror.net/docs/ref/#state.StateField.init) method, passing in the new
    configuration object..
    */ reconfigure(config) {
        let $config = new $8e06b7206d4b50ac$var$Configuration(this.schema, config.plugins);
        let fields = $config.fields, instance = new $8e06b7206d4b50ac$export$afa855cbfaff27f2($config);
        for(let i = 0; i < fields.length; i++){
            let name = fields[i].name;
            instance[name] = this.hasOwnProperty(name) ? this[name] : fields[i].init(config, instance);
        }
        return instance;
    }
    /**
    Serialize this state to JSON. If you want to serialize the state
    of plugins, pass an object mapping property names to use in the
    resulting JSON object to plugin objects. The argument may also be
    a string or number, in which case it is ignored, to support the
    way `JSON.stringify` calls `toString` methods.
    */ toJSON(pluginFields) {
        let result = {
            doc: this.doc.toJSON(),
            selection: this.selection.toJSON()
        };
        if (this.storedMarks) result.storedMarks = this.storedMarks.map((m)=>m.toJSON());
        if (pluginFields && typeof pluginFields == 'object') for(let prop in pluginFields){
            if (prop == "doc" || prop == "selection") throw new RangeError("The JSON fields `doc` and `selection` are reserved");
            let plugin = pluginFields[prop], state = plugin.spec.state;
            if (state && state.toJSON) result[prop] = state.toJSON.call(plugin, this[plugin.key]);
        }
        return result;
    }
    /**
    Deserialize a JSON representation of a state. `config` should
    have at least a `schema` field, and should contain array of
    plugins to initialize the state with. `pluginFields` can be used
    to deserialize the state of plugins, by associating plugin
    instances with the property names they use in the JSON object.
    */ static fromJSON(config, json, pluginFields) {
        if (!json) throw new RangeError("Invalid input for EditorState.fromJSON");
        if (!config.schema) throw new RangeError("Required config field 'schema' missing");
        let $config = new $8e06b7206d4b50ac$var$Configuration(config.schema, config.plugins);
        let instance = new $8e06b7206d4b50ac$export$afa855cbfaff27f2($config);
        $config.fields.forEach((field)=>{
            if (field.name == "doc") instance.doc = (0, $9Jwkl.Node).fromJSON(config.schema, json.doc);
            else if (field.name == "selection") instance.selection = $8e06b7206d4b50ac$export$52baac22726c72bf.fromJSON(instance.doc, json.selection);
            else if (field.name == "storedMarks") {
                if (json.storedMarks) instance.storedMarks = json.storedMarks.map(config.schema.markFromJSON);
            } else {
                if (pluginFields) for(let prop in pluginFields){
                    let plugin = pluginFields[prop], state = plugin.spec.state;
                    if (plugin.key == field.name && state && state.fromJSON && Object.prototype.hasOwnProperty.call(json, prop)) {
                        instance[field.name] = state.fromJSON.call(plugin, config, json[prop], instance);
                        return;
                    }
                }
                instance[field.name] = field.init(config, instance);
            }
        });
        return instance;
    }
}
function $8e06b7206d4b50ac$var$bindProps(obj, self, target) {
    for(let prop in obj){
        let val = obj[prop];
        if (val instanceof Function) val = val.bind(self);
        else if (prop == "handleDOMEvents") val = $8e06b7206d4b50ac$var$bindProps(val, self, {});
        target[prop] = val;
    }
    return target;
}
/**
Plugins bundle functionality that can be added to an editor.
They are part of the [editor state](https://prosemirror.net/docs/ref/#state.EditorState) and
may influence that state and the view that contains it.
*/ class $8e06b7206d4b50ac$export$901cf72dabf2112a {
    /**
    Create a plugin.
    */ constructor(/**
    The plugin's [spec object](https://prosemirror.net/docs/ref/#state.PluginSpec).
    */ spec){
        this.spec = spec;
        /**
        The [props](https://prosemirror.net/docs/ref/#view.EditorProps) exported by this plugin.
        */ this.props = {};
        if (spec.props) $8e06b7206d4b50ac$var$bindProps(spec.props, this, this.props);
        this.key = spec.key ? spec.key.key : $8e06b7206d4b50ac$var$createKey("plugin");
    }
    /**
    Extract the plugin's state field from an editor state.
    */ getState(state) {
        return state[this.key];
    }
}
const $8e06b7206d4b50ac$var$keys = Object.create(null);
function $8e06b7206d4b50ac$var$createKey(name) {
    if (name in $8e06b7206d4b50ac$var$keys) return name + "$" + ++$8e06b7206d4b50ac$var$keys[name];
    $8e06b7206d4b50ac$var$keys[name] = 0;
    return name + "$";
}
/**
A key is used to [tag](https://prosemirror.net/docs/ref/#state.PluginSpec.key) plugins in a way
that makes it possible to find them, given an editor state.
Assigning a key does mean only one plugin of that type can be
active in a state.
*/ class $8e06b7206d4b50ac$export$1692d8b0e89cecc3 {
    /**
    Create a plugin key.
    */ constructor(name = "key"){
        this.key = $8e06b7206d4b50ac$var$createKey(name);
    }
    /**
    Get the active plugin with this key, if any, from an editor
    state.
    */ get(state) {
        return state.config.pluginsByKey[this.key];
    }
    /**
    Get the plugin's state from an editor state.
    */ getState(state) {
        return state[this.key];
    }
}

});
parcelRegister("9Jwkl", function(module, exports) {
$parcel$export(module.exports, "Fragment", () => $7161648073377122$export$ffb0004e005737fa);
$parcel$export(module.exports, "Mark", () => $7161648073377122$export$c9d15bcfc6d42044);
$parcel$export(module.exports, "ReplaceError", () => $7161648073377122$export$6de0e778727af3f2);
$parcel$export(module.exports, "Slice", () => $7161648073377122$export$b3f2e2de3a8baa1e);
$parcel$export(module.exports, "Node", () => $7161648073377122$export$85c928794f8d04d4);
$parcel$export(module.exports, "MarkType", () => $7161648073377122$export$b6a78689043c6521);
$parcel$export(module.exports, "Schema", () => $7161648073377122$export$19342e026b58ebb7);
$parcel$export(module.exports, "DOMParser", () => $7161648073377122$export$1059c6e7d2ce5669);
$parcel$export(module.exports, "DOMSerializer", () => $7161648073377122$export$3476b78f8f5a8b72);

var $at9VT = parcelRequire("at9VT");
function $7161648073377122$var$findDiffStart(a, b, pos) {
    for(let i = 0;; i++){
        if (i == a.childCount || i == b.childCount) return a.childCount == b.childCount ? null : pos;
        let childA = a.child(i), childB = b.child(i);
        if (childA == childB) {
            pos += childA.nodeSize;
            continue;
        }
        if (!childA.sameMarkup(childB)) return pos;
        if (childA.isText && childA.text != childB.text) {
            for(let j = 0; childA.text[j] == childB.text[j]; j++)pos++;
            return pos;
        }
        if (childA.content.size || childB.content.size) {
            let inner = $7161648073377122$var$findDiffStart(childA.content, childB.content, pos + 1);
            if (inner != null) return inner;
        }
        pos += childA.nodeSize;
    }
}
function $7161648073377122$var$findDiffEnd(a, b, posA, posB) {
    for(let iA = a.childCount, iB = b.childCount;;){
        if (iA == 0 || iB == 0) return iA == iB ? null : {
            a: posA,
            b: posB
        };
        let childA = a.child(--iA), childB = b.child(--iB), size = childA.nodeSize;
        if (childA == childB) {
            posA -= size;
            posB -= size;
            continue;
        }
        if (!childA.sameMarkup(childB)) return {
            a: posA,
            b: posB
        };
        if (childA.isText && childA.text != childB.text) {
            let same = 0, minSize = Math.min(childA.text.length, childB.text.length);
            while(same < minSize && childA.text[childA.text.length - same - 1] == childB.text[childB.text.length - same - 1]){
                same++;
                posA--;
                posB--;
            }
            return {
                a: posA,
                b: posB
            };
        }
        if (childA.content.size || childB.content.size) {
            let inner = $7161648073377122$var$findDiffEnd(childA.content, childB.content, posA - 1, posB - 1);
            if (inner) return inner;
        }
        posA -= size;
        posB -= size;
    }
}
/**
A fragment represents a node's collection of child nodes.

Like nodes, fragments are persistent data structures, and you
should not mutate them or their content. Rather, you create new
instances whenever needed. The API tries to make this easy.
*/ class $7161648073377122$export$ffb0004e005737fa {
    /**
    @internal
    */ constructor(/**
    The child nodes in this fragment.
    */ content, size){
        this.content = content;
        this.size = size || 0;
        if (size == null) for(let i = 0; i < content.length; i++)this.size += content[i].nodeSize;
    }
    /**
    Invoke a callback for all descendant nodes between the given two
    positions (relative to start of this fragment). Doesn't descend
    into a node when the callback returns `false`.
    */ nodesBetween(from, to, f, nodeStart = 0, parent) {
        for(let i = 0, pos = 0; pos < to; i++){
            let child = this.content[i], end = pos + child.nodeSize;
            if (end > from && f(child, nodeStart + pos, parent || null, i) !== false && child.content.size) {
                let start = pos + 1;
                child.nodesBetween(Math.max(0, from - start), Math.min(child.content.size, to - start), f, nodeStart + start);
            }
            pos = end;
        }
    }
    /**
    Call the given callback for every descendant node. `pos` will be
    relative to the start of the fragment. The callback may return
    `false` to prevent traversal of a given node's children.
    */ descendants(f) {
        this.nodesBetween(0, this.size, f);
    }
    /**
    Extract the text between `from` and `to`. See the same method on
    [`Node`](https://prosemirror.net/docs/ref/#model.Node.textBetween).
    */ textBetween(from, to, blockSeparator, leafText) {
        let text = "", first = true;
        this.nodesBetween(from, to, (node, pos)=>{
            let nodeText = node.isText ? node.text.slice(Math.max(from, pos) - pos, to - pos) : !node.isLeaf ? "" : leafText ? typeof leafText === "function" ? leafText(node) : leafText : node.type.spec.leafText ? node.type.spec.leafText(node) : "";
            if (node.isBlock && (node.isLeaf && nodeText || node.isTextblock) && blockSeparator) {
                if (first) first = false;
                else text += blockSeparator;
            }
            text += nodeText;
        }, 0);
        return text;
    }
    /**
    Create a new fragment containing the combined content of this
    fragment and the other.
    */ append(other) {
        if (!other.size) return this;
        if (!this.size) return other;
        let last = this.lastChild, first = other.firstChild, content = this.content.slice(), i = 0;
        if (last.isText && last.sameMarkup(first)) {
            content[content.length - 1] = last.withText(last.text + first.text);
            i = 1;
        }
        for(; i < other.content.length; i++)content.push(other.content[i]);
        return new $7161648073377122$export$ffb0004e005737fa(content, this.size + other.size);
    }
    /**
    Cut out the sub-fragment between the two given positions.
    */ cut(from, to = this.size) {
        if (from == 0 && to == this.size) return this;
        let result = [], size = 0;
        if (to > from) for(let i = 0, pos = 0; pos < to; i++){
            let child = this.content[i], end = pos + child.nodeSize;
            if (end > from) {
                if (pos < from || end > to) {
                    if (child.isText) child = child.cut(Math.max(0, from - pos), Math.min(child.text.length, to - pos));
                    else child = child.cut(Math.max(0, from - pos - 1), Math.min(child.content.size, to - pos - 1));
                }
                result.push(child);
                size += child.nodeSize;
            }
            pos = end;
        }
        return new $7161648073377122$export$ffb0004e005737fa(result, size);
    }
    /**
    @internal
    */ cutByIndex(from, to) {
        if (from == to) return $7161648073377122$export$ffb0004e005737fa.empty;
        if (from == 0 && to == this.content.length) return this;
        return new $7161648073377122$export$ffb0004e005737fa(this.content.slice(from, to));
    }
    /**
    Create a new fragment in which the node at the given index is
    replaced by the given node.
    */ replaceChild(index, node) {
        let current = this.content[index];
        if (current == node) return this;
        let copy = this.content.slice();
        let size = this.size + node.nodeSize - current.nodeSize;
        copy[index] = node;
        return new $7161648073377122$export$ffb0004e005737fa(copy, size);
    }
    /**
    Create a new fragment by prepending the given node to this
    fragment.
    */ addToStart(node) {
        return new $7161648073377122$export$ffb0004e005737fa([
            node
        ].concat(this.content), this.size + node.nodeSize);
    }
    /**
    Create a new fragment by appending the given node to this
    fragment.
    */ addToEnd(node) {
        return new $7161648073377122$export$ffb0004e005737fa(this.content.concat(node), this.size + node.nodeSize);
    }
    /**
    Compare this fragment to another one.
    */ eq(other) {
        if (this.content.length != other.content.length) return false;
        for(let i = 0; i < this.content.length; i++)if (!this.content[i].eq(other.content[i])) return false;
        return true;
    }
    /**
    The first child of the fragment, or `null` if it is empty.
    */ get firstChild() {
        return this.content.length ? this.content[0] : null;
    }
    /**
    The last child of the fragment, or `null` if it is empty.
    */ get lastChild() {
        return this.content.length ? this.content[this.content.length - 1] : null;
    }
    /**
    The number of child nodes in this fragment.
    */ get childCount() {
        return this.content.length;
    }
    /**
    Get the child node at the given index. Raise an error when the
    index is out of range.
    */ child(index) {
        let found = this.content[index];
        if (!found) throw new RangeError("Index " + index + " out of range for " + this);
        return found;
    }
    /**
    Get the child node at the given index, if it exists.
    */ maybeChild(index) {
        return this.content[index] || null;
    }
    /**
    Call `f` for every child node, passing the node, its offset
    into this parent node, and its index.
    */ forEach(f) {
        for(let i = 0, p = 0; i < this.content.length; i++){
            let child = this.content[i];
            f(child, p, i);
            p += child.nodeSize;
        }
    }
    /**
    Find the first position at which this fragment and another
    fragment differ, or `null` if they are the same.
    */ findDiffStart(other, pos = 0) {
        return $7161648073377122$var$findDiffStart(this, other, pos);
    }
    /**
    Find the first position, searching from the end, at which this
    fragment and the given fragment differ, or `null` if they are
    the same. Since this position will not be the same in both
    nodes, an object with two separate positions is returned.
    */ findDiffEnd(other, pos = this.size, otherPos = other.size) {
        return $7161648073377122$var$findDiffEnd(this, other, pos, otherPos);
    }
    /**
    Find the index and inner offset corresponding to a given relative
    position in this fragment. The result object will be reused
    (overwritten) the next time the function is called. @internal
    */ findIndex(pos) {
        if (pos == 0) return $7161648073377122$var$retIndex(0, pos);
        if (pos == this.size) return $7161648073377122$var$retIndex(this.content.length, pos);
        if (pos > this.size || pos < 0) throw new RangeError(`Position ${pos} outside of fragment (${this})`);
        for(let i = 0, curPos = 0;; i++){
            let cur = this.child(i), end = curPos + cur.nodeSize;
            if (end >= pos) {
                if (end == pos) return $7161648073377122$var$retIndex(i + 1, end);
                return $7161648073377122$var$retIndex(i, curPos);
            }
            curPos = end;
        }
    }
    /**
    Return a debugging string that describes this fragment.
    */ toString() {
        return "<" + this.toStringInner() + ">";
    }
    /**
    @internal
    */ toStringInner() {
        return this.content.join(", ");
    }
    /**
    Create a JSON-serializeable representation of this fragment.
    */ toJSON() {
        return this.content.length ? this.content.map((n)=>n.toJSON()) : null;
    }
    /**
    Deserialize a fragment from its JSON representation.
    */ static fromJSON(schema, value) {
        if (!value) return $7161648073377122$export$ffb0004e005737fa.empty;
        if (!Array.isArray(value)) throw new RangeError("Invalid input for Fragment.fromJSON");
        return new $7161648073377122$export$ffb0004e005737fa(value.map(schema.nodeFromJSON));
    }
    /**
    Build a fragment from an array of nodes. Ensures that adjacent
    text nodes with the same marks are joined together.
    */ static fromArray(array) {
        if (!array.length) return $7161648073377122$export$ffb0004e005737fa.empty;
        let joined, size = 0;
        for(let i = 0; i < array.length; i++){
            let node = array[i];
            size += node.nodeSize;
            if (i && node.isText && array[i - 1].sameMarkup(node)) {
                if (!joined) joined = array.slice(0, i);
                joined[joined.length - 1] = node.withText(joined[joined.length - 1].text + node.text);
            } else if (joined) joined.push(node);
        }
        return new $7161648073377122$export$ffb0004e005737fa(joined || array, size);
    }
    /**
    Create a fragment from something that can be interpreted as a
    set of nodes. For `null`, it returns the empty fragment. For a
    fragment, the fragment itself. For a node or array of nodes, a
    fragment containing those nodes.
    */ static from(nodes) {
        if (!nodes) return $7161648073377122$export$ffb0004e005737fa.empty;
        if (nodes instanceof $7161648073377122$export$ffb0004e005737fa) return nodes;
        if (Array.isArray(nodes)) return this.fromArray(nodes);
        if (nodes.attrs) return new $7161648073377122$export$ffb0004e005737fa([
            nodes
        ], nodes.nodeSize);
        throw new RangeError("Can not convert " + nodes + " to a Fragment" + (nodes.nodesBetween ? " (looks like multiple versions of prosemirror-model were loaded)" : ""));
    }
}
/**
An empty fragment. Intended to be reused whenever a node doesn't
contain anything (rather than allocating a new empty fragment for
each leaf node).
*/ $7161648073377122$export$ffb0004e005737fa.empty = new $7161648073377122$export$ffb0004e005737fa([], 0);
const $7161648073377122$var$found = {
    index: 0,
    offset: 0
};
function $7161648073377122$var$retIndex(index, offset) {
    $7161648073377122$var$found.index = index;
    $7161648073377122$var$found.offset = offset;
    return $7161648073377122$var$found;
}
function $7161648073377122$var$compareDeep(a, b) {
    if (a === b) return true;
    if (!(a && typeof a == "object") || !(b && typeof b == "object")) return false;
    let array = Array.isArray(a);
    if (Array.isArray(b) != array) return false;
    if (array) {
        if (a.length != b.length) return false;
        for(let i = 0; i < a.length; i++)if (!$7161648073377122$var$compareDeep(a[i], b[i])) return false;
    } else {
        for(let p in a)if (!(p in b) || !$7161648073377122$var$compareDeep(a[p], b[p])) return false;
        for(let p in b)if (!(p in a)) return false;
    }
    return true;
}
/**
A mark is a piece of information that can be attached to a node,
such as it being emphasized, in code font, or a link. It has a
type and optionally a set of attributes that provide further
information (such as the target of the link). Marks are created
through a `Schema`, which controls which types exist and which
attributes they have.
*/ class $7161648073377122$export$c9d15bcfc6d42044 {
    /**
    @internal
    */ constructor(/**
    The type of this mark.
    */ type, /**
    The attributes associated with this mark.
    */ attrs){
        this.type = type;
        this.attrs = attrs;
    }
    /**
    Given a set of marks, create a new set which contains this one as
    well, in the right position. If this mark is already in the set,
    the set itself is returned. If any marks that are set to be
    [exclusive](https://prosemirror.net/docs/ref/#model.MarkSpec.excludes) with this mark are present,
    those are replaced by this one.
    */ addToSet(set) {
        let copy, placed = false;
        for(let i = 0; i < set.length; i++){
            let other = set[i];
            if (this.eq(other)) return set;
            if (this.type.excludes(other.type)) {
                if (!copy) copy = set.slice(0, i);
            } else if (other.type.excludes(this.type)) return set;
            else {
                if (!placed && other.type.rank > this.type.rank) {
                    if (!copy) copy = set.slice(0, i);
                    copy.push(this);
                    placed = true;
                }
                if (copy) copy.push(other);
            }
        }
        if (!copy) copy = set.slice();
        if (!placed) copy.push(this);
        return copy;
    }
    /**
    Remove this mark from the given set, returning a new set. If this
    mark is not in the set, the set itself is returned.
    */ removeFromSet(set) {
        for(let i = 0; i < set.length; i++)if (this.eq(set[i])) return set.slice(0, i).concat(set.slice(i + 1));
        return set;
    }
    /**
    Test whether this mark is in the given set of marks.
    */ isInSet(set) {
        for(let i = 0; i < set.length; i++)if (this.eq(set[i])) return true;
        return false;
    }
    /**
    Test whether this mark has the same type and attributes as
    another mark.
    */ eq(other) {
        return this == other || this.type == other.type && $7161648073377122$var$compareDeep(this.attrs, other.attrs);
    }
    /**
    Convert this mark to a JSON-serializeable representation.
    */ toJSON() {
        let obj = {
            type: this.type.name
        };
        for(let _ in this.attrs){
            obj.attrs = this.attrs;
            break;
        }
        return obj;
    }
    /**
    Deserialize a mark from JSON.
    */ static fromJSON(schema, json) {
        if (!json) throw new RangeError("Invalid input for Mark.fromJSON");
        let type = schema.marks[json.type];
        if (!type) throw new RangeError(`There is no mark type ${json.type} in this schema`);
        let mark = type.create(json.attrs);
        type.checkAttrs(mark.attrs);
        return mark;
    }
    /**
    Test whether two sets of marks are identical.
    */ static sameSet(a, b) {
        if (a == b) return true;
        if (a.length != b.length) return false;
        for(let i = 0; i < a.length; i++)if (!a[i].eq(b[i])) return false;
        return true;
    }
    /**
    Create a properly sorted mark set from null, a single mark, or an
    unsorted array of marks.
    */ static setFrom(marks) {
        if (!marks || Array.isArray(marks) && marks.length == 0) return $7161648073377122$export$c9d15bcfc6d42044.none;
        if (marks instanceof $7161648073377122$export$c9d15bcfc6d42044) return [
            marks
        ];
        let copy = marks.slice();
        copy.sort((a, b)=>a.type.rank - b.type.rank);
        return copy;
    }
}
/**
The empty set of marks.
*/ $7161648073377122$export$c9d15bcfc6d42044.none = [];
/**
Error type raised by [`Node.replace`](https://prosemirror.net/docs/ref/#model.Node.replace) when
given an invalid replacement.
*/ class $7161648073377122$export$6de0e778727af3f2 extends Error {
}
/*
ReplaceError = function(this: any, message: string) {
  let err = Error.call(this, message)
  ;(err as any).__proto__ = ReplaceError.prototype
  return err
} as any

ReplaceError.prototype = Object.create(Error.prototype)
ReplaceError.prototype.constructor = ReplaceError
ReplaceError.prototype.name = "ReplaceError"
*/ /**
A slice represents a piece cut out of a larger document. It
stores not only a fragment, but also the depth up to which nodes on
both side are ‘open’ (cut through).
*/ class $7161648073377122$export$b3f2e2de3a8baa1e {
    /**
    Create a slice. When specifying a non-zero open depth, you must
    make sure that there are nodes of at least that depth at the
    appropriate side of the fragment—i.e. if the fragment is an
    empty paragraph node, `openStart` and `openEnd` can't be greater
    than 1.
    
    It is not necessary for the content of open nodes to conform to
    the schema's content constraints, though it should be a valid
    start/end/middle for such a node, depending on which sides are
    open.
    */ constructor(/**
    The slice's content.
    */ content, /**
    The open depth at the start of the fragment.
    */ openStart, /**
    The open depth at the end.
    */ openEnd){
        this.content = content;
        this.openStart = openStart;
        this.openEnd = openEnd;
    }
    /**
    The size this slice would add when inserted into a document.
    */ get size() {
        return this.content.size - this.openStart - this.openEnd;
    }
    /**
    @internal
    */ insertAt(pos, fragment) {
        let content = $7161648073377122$var$insertInto(this.content, pos + this.openStart, fragment);
        return content && new $7161648073377122$export$b3f2e2de3a8baa1e(content, this.openStart, this.openEnd);
    }
    /**
    @internal
    */ removeBetween(from, to) {
        return new $7161648073377122$export$b3f2e2de3a8baa1e($7161648073377122$var$removeRange(this.content, from + this.openStart, to + this.openStart), this.openStart, this.openEnd);
    }
    /**
    Tests whether this slice is equal to another slice.
    */ eq(other) {
        return this.content.eq(other.content) && this.openStart == other.openStart && this.openEnd == other.openEnd;
    }
    /**
    @internal
    */ toString() {
        return this.content + "(" + this.openStart + "," + this.openEnd + ")";
    }
    /**
    Convert a slice to a JSON-serializable representation.
    */ toJSON() {
        if (!this.content.size) return null;
        let json = {
            content: this.content.toJSON()
        };
        if (this.openStart > 0) json.openStart = this.openStart;
        if (this.openEnd > 0) json.openEnd = this.openEnd;
        return json;
    }
    /**
    Deserialize a slice from its JSON representation.
    */ static fromJSON(schema, json) {
        if (!json) return $7161648073377122$export$b3f2e2de3a8baa1e.empty;
        let openStart = json.openStart || 0, openEnd = json.openEnd || 0;
        if (typeof openStart != "number" || typeof openEnd != "number") throw new RangeError("Invalid input for Slice.fromJSON");
        return new $7161648073377122$export$b3f2e2de3a8baa1e($7161648073377122$export$ffb0004e005737fa.fromJSON(schema, json.content), openStart, openEnd);
    }
    /**
    Create a slice from a fragment by taking the maximum possible
    open value on both side of the fragment.
    */ static maxOpen(fragment, openIsolating = true) {
        let openStart = 0, openEnd = 0;
        for(let n = fragment.firstChild; n && !n.isLeaf && (openIsolating || !n.type.spec.isolating); n = n.firstChild)openStart++;
        for(let n = fragment.lastChild; n && !n.isLeaf && (openIsolating || !n.type.spec.isolating); n = n.lastChild)openEnd++;
        return new $7161648073377122$export$b3f2e2de3a8baa1e(fragment, openStart, openEnd);
    }
}
/**
The empty slice.
*/ $7161648073377122$export$b3f2e2de3a8baa1e.empty = new $7161648073377122$export$b3f2e2de3a8baa1e($7161648073377122$export$ffb0004e005737fa.empty, 0, 0);
function $7161648073377122$var$removeRange(content, from, to) {
    let { index: index, offset: offset } = content.findIndex(from), child = content.maybeChild(index);
    let { index: indexTo, offset: offsetTo } = content.findIndex(to);
    if (offset == from || child.isText) {
        if (offsetTo != to && !content.child(indexTo).isText) throw new RangeError("Removing non-flat range");
        return content.cut(0, from).append(content.cut(to));
    }
    if (index != indexTo) throw new RangeError("Removing non-flat range");
    return content.replaceChild(index, child.copy($7161648073377122$var$removeRange(child.content, from - offset - 1, to - offset - 1)));
}
function $7161648073377122$var$insertInto(content, dist, insert, parent) {
    let { index: index, offset: offset } = content.findIndex(dist), child = content.maybeChild(index);
    if (offset == dist || child.isText) {
        if (parent && !parent.canReplace(index, index, insert)) return null;
        return content.cut(0, dist).append(insert).append(content.cut(dist));
    }
    let inner = $7161648073377122$var$insertInto(child.content, dist - offset - 1, insert, child);
    return inner && content.replaceChild(index, child.copy(inner));
}
function $7161648073377122$var$replace($from, $to, slice) {
    if (slice.openStart > $from.depth) throw new $7161648073377122$export$6de0e778727af3f2("Inserted content deeper than insertion position");
    if ($from.depth - slice.openStart != $to.depth - slice.openEnd) throw new $7161648073377122$export$6de0e778727af3f2("Inconsistent open depths");
    return $7161648073377122$var$replaceOuter($from, $to, slice, 0);
}
function $7161648073377122$var$replaceOuter($from, $to, slice, depth) {
    let index = $from.index(depth), node = $from.node(depth);
    if (index == $to.index(depth) && depth < $from.depth - slice.openStart) {
        let inner = $7161648073377122$var$replaceOuter($from, $to, slice, depth + 1);
        return node.copy(node.content.replaceChild(index, inner));
    } else if (!slice.content.size) return $7161648073377122$var$close(node, $7161648073377122$var$replaceTwoWay($from, $to, depth));
    else if (!slice.openStart && !slice.openEnd && $from.depth == depth && $to.depth == depth) {
        let parent = $from.parent, content = parent.content;
        return $7161648073377122$var$close(parent, content.cut(0, $from.parentOffset).append(slice.content).append(content.cut($to.parentOffset)));
    } else {
        let { start: start, end: end } = $7161648073377122$var$prepareSliceForReplace(slice, $from);
        return $7161648073377122$var$close(node, $7161648073377122$var$replaceThreeWay($from, start, end, $to, depth));
    }
}
function $7161648073377122$var$checkJoin(main, sub) {
    if (!sub.type.compatibleContent(main.type)) throw new $7161648073377122$export$6de0e778727af3f2("Cannot join " + sub.type.name + " onto " + main.type.name);
}
function $7161648073377122$var$joinable($before, $after, depth) {
    let node = $before.node(depth);
    $7161648073377122$var$checkJoin(node, $after.node(depth));
    return node;
}
function $7161648073377122$var$addNode(child, target) {
    let last = target.length - 1;
    if (last >= 0 && child.isText && child.sameMarkup(target[last])) target[last] = child.withText(target[last].text + child.text);
    else target.push(child);
}
function $7161648073377122$var$addRange($start, $end, depth, target) {
    let node = ($end || $start).node(depth);
    let startIndex = 0, endIndex = $end ? $end.index(depth) : node.childCount;
    if ($start) {
        startIndex = $start.index(depth);
        if ($start.depth > depth) startIndex++;
        else if ($start.textOffset) {
            $7161648073377122$var$addNode($start.nodeAfter, target);
            startIndex++;
        }
    }
    for(let i = startIndex; i < endIndex; i++)$7161648073377122$var$addNode(node.child(i), target);
    if ($end && $end.depth == depth && $end.textOffset) $7161648073377122$var$addNode($end.nodeBefore, target);
}
function $7161648073377122$var$close(node, content) {
    node.type.checkContent(content);
    return node.copy(content);
}
function $7161648073377122$var$replaceThreeWay($from, $start, $end, $to, depth) {
    let openStart = $from.depth > depth && $7161648073377122$var$joinable($from, $start, depth + 1);
    let openEnd = $to.depth > depth && $7161648073377122$var$joinable($end, $to, depth + 1);
    let content = [];
    $7161648073377122$var$addRange(null, $from, depth, content);
    if (openStart && openEnd && $start.index(depth) == $end.index(depth)) {
        $7161648073377122$var$checkJoin(openStart, openEnd);
        $7161648073377122$var$addNode($7161648073377122$var$close(openStart, $7161648073377122$var$replaceThreeWay($from, $start, $end, $to, depth + 1)), content);
    } else {
        if (openStart) $7161648073377122$var$addNode($7161648073377122$var$close(openStart, $7161648073377122$var$replaceTwoWay($from, $start, depth + 1)), content);
        $7161648073377122$var$addRange($start, $end, depth, content);
        if (openEnd) $7161648073377122$var$addNode($7161648073377122$var$close(openEnd, $7161648073377122$var$replaceTwoWay($end, $to, depth + 1)), content);
    }
    $7161648073377122$var$addRange($to, null, depth, content);
    return new $7161648073377122$export$ffb0004e005737fa(content);
}
function $7161648073377122$var$replaceTwoWay($from, $to, depth) {
    let content = [];
    $7161648073377122$var$addRange(null, $from, depth, content);
    if ($from.depth > depth) {
        let type = $7161648073377122$var$joinable($from, $to, depth + 1);
        $7161648073377122$var$addNode($7161648073377122$var$close(type, $7161648073377122$var$replaceTwoWay($from, $to, depth + 1)), content);
    }
    $7161648073377122$var$addRange($to, null, depth, content);
    return new $7161648073377122$export$ffb0004e005737fa(content);
}
function $7161648073377122$var$prepareSliceForReplace(slice, $along) {
    let extra = $along.depth - slice.openStart, parent = $along.node(extra);
    let node = parent.copy(slice.content);
    for(let i = extra - 1; i >= 0; i--)node = $along.node(i).copy($7161648073377122$export$ffb0004e005737fa.from(node));
    return {
        start: node.resolveNoCache(slice.openStart + extra),
        end: node.resolveNoCache(node.content.size - slice.openEnd - extra)
    };
}
/**
You can [_resolve_](https://prosemirror.net/docs/ref/#model.Node.resolve) a position to get more
information about it. Objects of this class represent such a
resolved position, providing various pieces of context
information, and some helper methods.

Throughout this interface, methods that take an optional `depth`
parameter will interpret undefined as `this.depth` and negative
numbers as `this.depth + value`.
*/ class $7161648073377122$export$b2a42f82e59e4b19 {
    /**
    @internal
    */ constructor(/**
    The position that was resolved.
    */ pos, /**
    @internal
    */ path, /**
    The offset this position has into its parent node.
    */ parentOffset){
        this.pos = pos;
        this.path = path;
        this.parentOffset = parentOffset;
        this.depth = path.length / 3 - 1;
    }
    /**
    @internal
    */ resolveDepth(val) {
        if (val == null) return this.depth;
        if (val < 0) return this.depth + val;
        return val;
    }
    /**
    The parent node that the position points into. Note that even if
    a position points into a text node, that node is not considered
    the parent—text nodes are ‘flat’ in this model, and have no content.
    */ get parent() {
        return this.node(this.depth);
    }
    /**
    The root node in which the position was resolved.
    */ get doc() {
        return this.node(0);
    }
    /**
    The ancestor node at the given level. `p.node(p.depth)` is the
    same as `p.parent`.
    */ node(depth) {
        return this.path[this.resolveDepth(depth) * 3];
    }
    /**
    The index into the ancestor at the given level. If this points
    at the 3rd node in the 2nd paragraph on the top level, for
    example, `p.index(0)` is 1 and `p.index(1)` is 2.
    */ index(depth) {
        return this.path[this.resolveDepth(depth) * 3 + 1];
    }
    /**
    The index pointing after this position into the ancestor at the
    given level.
    */ indexAfter(depth) {
        depth = this.resolveDepth(depth);
        return this.index(depth) + (depth == this.depth && !this.textOffset ? 0 : 1);
    }
    /**
    The (absolute) position at the start of the node at the given
    level.
    */ start(depth) {
        depth = this.resolveDepth(depth);
        return depth == 0 ? 0 : this.path[depth * 3 - 1] + 1;
    }
    /**
    The (absolute) position at the end of the node at the given
    level.
    */ end(depth) {
        depth = this.resolveDepth(depth);
        return this.start(depth) + this.node(depth).content.size;
    }
    /**
    The (absolute) position directly before the wrapping node at the
    given level, or, when `depth` is `this.depth + 1`, the original
    position.
    */ before(depth) {
        depth = this.resolveDepth(depth);
        if (!depth) throw new RangeError("There is no position before the top-level node");
        return depth == this.depth + 1 ? this.pos : this.path[depth * 3 - 1];
    }
    /**
    The (absolute) position directly after the wrapping node at the
    given level, or the original position when `depth` is `this.depth + 1`.
    */ after(depth) {
        depth = this.resolveDepth(depth);
        if (!depth) throw new RangeError("There is no position after the top-level node");
        return depth == this.depth + 1 ? this.pos : this.path[depth * 3 - 1] + this.path[depth * 3].nodeSize;
    }
    /**
    When this position points into a text node, this returns the
    distance between the position and the start of the text node.
    Will be zero for positions that point between nodes.
    */ get textOffset() {
        return this.pos - this.path[this.path.length - 1];
    }
    /**
    Get the node directly after the position, if any. If the position
    points into a text node, only the part of that node after the
    position is returned.
    */ get nodeAfter() {
        let parent = this.parent, index = this.index(this.depth);
        if (index == parent.childCount) return null;
        let dOff = this.pos - this.path[this.path.length - 1], child = parent.child(index);
        return dOff ? parent.child(index).cut(dOff) : child;
    }
    /**
    Get the node directly before the position, if any. If the
    position points into a text node, only the part of that node
    before the position is returned.
    */ get nodeBefore() {
        let index = this.index(this.depth);
        let dOff = this.pos - this.path[this.path.length - 1];
        if (dOff) return this.parent.child(index).cut(0, dOff);
        return index == 0 ? null : this.parent.child(index - 1);
    }
    /**
    Get the position at the given index in the parent node at the
    given depth (which defaults to `this.depth`).
    */ posAtIndex(index, depth) {
        depth = this.resolveDepth(depth);
        let node = this.path[depth * 3], pos = depth == 0 ? 0 : this.path[depth * 3 - 1] + 1;
        for(let i = 0; i < index; i++)pos += node.child(i).nodeSize;
        return pos;
    }
    /**
    Get the marks at this position, factoring in the surrounding
    marks' [`inclusive`](https://prosemirror.net/docs/ref/#model.MarkSpec.inclusive) property. If the
    position is at the start of a non-empty node, the marks of the
    node after it (if any) are returned.
    */ marks() {
        let parent = this.parent, index = this.index();
        // In an empty parent, return the empty array
        if (parent.content.size == 0) return $7161648073377122$export$c9d15bcfc6d42044.none;
        // When inside a text node, just return the text node's marks
        if (this.textOffset) return parent.child(index).marks;
        let main = parent.maybeChild(index - 1), other = parent.maybeChild(index);
        // If the `after` flag is true of there is no node before, make
        // the node after this position the main reference.
        if (!main) {
            let tmp = main;
            main = other;
            other = tmp;
        }
        // Use all marks in the main node, except those that have
        // `inclusive` set to false and are not present in the other node.
        let marks = main.marks;
        for(var i = 0; i < marks.length; i++)if (marks[i].type.spec.inclusive === false && (!other || !marks[i].isInSet(other.marks))) marks = marks[i--].removeFromSet(marks);
        return marks;
    }
    /**
    Get the marks after the current position, if any, except those
    that are non-inclusive and not present at position `$end`. This
    is mostly useful for getting the set of marks to preserve after a
    deletion. Will return `null` if this position is at the end of
    its parent node or its parent node isn't a textblock (in which
    case no marks should be preserved).
    */ marksAcross($end) {
        let after = this.parent.maybeChild(this.index());
        if (!after || !after.isInline) return null;
        let marks = after.marks, next = $end.parent.maybeChild($end.index());
        for(var i = 0; i < marks.length; i++)if (marks[i].type.spec.inclusive === false && (!next || !marks[i].isInSet(next.marks))) marks = marks[i--].removeFromSet(marks);
        return marks;
    }
    /**
    The depth up to which this position and the given (non-resolved)
    position share the same parent nodes.
    */ sharedDepth(pos) {
        for(let depth = this.depth; depth > 0; depth--)if (this.start(depth) <= pos && this.end(depth) >= pos) return depth;
        return 0;
    }
    /**
    Returns a range based on the place where this position and the
    given position diverge around block content. If both point into
    the same textblock, for example, a range around that textblock
    will be returned. If they point into different blocks, the range
    around those blocks in their shared ancestor is returned. You can
    pass in an optional predicate that will be called with a parent
    node to see if a range into that parent is acceptable.
    */ blockRange(other = this, pred) {
        if (other.pos < this.pos) return other.blockRange(this);
        for(let d = this.depth - (this.parent.inlineContent || this.pos == other.pos ? 1 : 0); d >= 0; d--)if (other.pos <= this.end(d) && (!pred || pred(this.node(d)))) return new $7161648073377122$export$7bc461ceb770fb16(this, other, d);
        return null;
    }
    /**
    Query whether the given position shares the same parent node.
    */ sameParent(other) {
        return this.pos - this.parentOffset == other.pos - other.parentOffset;
    }
    /**
    Return the greater of this and the given position.
    */ max(other) {
        return other.pos > this.pos ? other : this;
    }
    /**
    Return the smaller of this and the given position.
    */ min(other) {
        return other.pos < this.pos ? other : this;
    }
    /**
    @internal
    */ toString() {
        let str = "";
        for(let i = 1; i <= this.depth; i++)str += (str ? "/" : "") + this.node(i).type.name + "_" + this.index(i - 1);
        return str + ":" + this.parentOffset;
    }
    /**
    @internal
    */ static resolve(doc, pos) {
        if (!(pos >= 0 && pos <= doc.content.size)) throw new RangeError("Position " + pos + " out of range");
        let path = [];
        let start = 0, parentOffset = pos;
        for(let node = doc;;){
            let { index: index, offset: offset } = node.content.findIndex(parentOffset);
            let rem = parentOffset - offset;
            path.push(node, index, start + offset);
            if (!rem) break;
            node = node.child(index);
            if (node.isText) break;
            parentOffset = rem - 1;
            start += offset + 1;
        }
        return new $7161648073377122$export$b2a42f82e59e4b19(pos, path, parentOffset);
    }
    /**
    @internal
    */ static resolveCached(doc, pos) {
        let cache = $7161648073377122$var$resolveCache.get(doc);
        if (cache) for(let i = 0; i < cache.elts.length; i++){
            let elt = cache.elts[i];
            if (elt.pos == pos) return elt;
        }
        else $7161648073377122$var$resolveCache.set(doc, cache = new $7161648073377122$var$ResolveCache);
        let result = cache.elts[cache.i] = $7161648073377122$export$b2a42f82e59e4b19.resolve(doc, pos);
        cache.i = (cache.i + 1) % $7161648073377122$var$resolveCacheSize;
        return result;
    }
}
class $7161648073377122$var$ResolveCache {
    constructor(){
        this.elts = [];
        this.i = 0;
    }
}
const $7161648073377122$var$resolveCacheSize = 12, $7161648073377122$var$resolveCache = new WeakMap();
/**
Represents a flat range of content, i.e. one that starts and
ends in the same node.
*/ class $7161648073377122$export$7bc461ceb770fb16 {
    /**
    Construct a node range. `$from` and `$to` should point into the
    same node until at least the given `depth`, since a node range
    denotes an adjacent set of nodes in a single parent node.
    */ constructor(/**
    A resolved position along the start of the content. May have a
    `depth` greater than this object's `depth` property, since
    these are the positions that were used to compute the range,
    not re-resolved positions directly at its boundaries.
    */ $from, /**
    A position along the end of the content. See
    caveat for [`$from`](https://prosemirror.net/docs/ref/#model.NodeRange.$from).
    */ $to, /**
    The depth of the node that this range points into.
    */ depth){
        this.$from = $from;
        this.$to = $to;
        this.depth = depth;
    }
    /**
    The position at the start of the range.
    */ get start() {
        return this.$from.before(this.depth + 1);
    }
    /**
    The position at the end of the range.
    */ get end() {
        return this.$to.after(this.depth + 1);
    }
    /**
    The parent node that the range points into.
    */ get parent() {
        return this.$from.node(this.depth);
    }
    /**
    The start index of the range in the parent node.
    */ get startIndex() {
        return this.$from.index(this.depth);
    }
    /**
    The end index of the range in the parent node.
    */ get endIndex() {
        return this.$to.indexAfter(this.depth);
    }
}
const $7161648073377122$var$emptyAttrs = Object.create(null);
/**
This class represents a node in the tree that makes up a
ProseMirror document. So a document is an instance of `Node`, with
children that are also instances of `Node`.

Nodes are persistent data structures. Instead of changing them, you
create new ones with the content you want. Old ones keep pointing
at the old document shape. This is made cheaper by sharing
structure between the old and new data as much as possible, which a
tree shape like this (without back pointers) makes easy.

**Do not** directly mutate the properties of a `Node` object. See
[the guide](https://prosemirror.net/docs/guide/#doc) for more information.
*/ class $7161648073377122$export$85c928794f8d04d4 {
    /**
    @internal
    */ constructor(/**
    The type of node that this is.
    */ type, /**
    An object mapping attribute names to values. The kind of
    attributes allowed and required are
    [determined](https://prosemirror.net/docs/ref/#model.NodeSpec.attrs) by the node type.
    */ attrs, // A fragment holding the node's children.
    content, /**
    The marks (things like whether it is emphasized or part of a
    link) applied to this node.
    */ marks = $7161648073377122$export$c9d15bcfc6d42044.none){
        this.type = type;
        this.attrs = attrs;
        this.marks = marks;
        this.content = content || $7161648073377122$export$ffb0004e005737fa.empty;
    }
    /**
    The array of this node's child nodes.
    */ get children() {
        return this.content.content;
    }
    /**
    The size of this node, as defined by the integer-based [indexing
    scheme](https://prosemirror.net/docs/guide/#doc.indexing). For text nodes, this is the
    amount of characters. For other leaf nodes, it is one. For
    non-leaf nodes, it is the size of the content plus two (the
    start and end token).
    */ get nodeSize() {
        return this.isLeaf ? 1 : 2 + this.content.size;
    }
    /**
    The number of children that the node has.
    */ get childCount() {
        return this.content.childCount;
    }
    /**
    Get the child node at the given index. Raises an error when the
    index is out of range.
    */ child(index) {
        return this.content.child(index);
    }
    /**
    Get the child node at the given index, if it exists.
    */ maybeChild(index) {
        return this.content.maybeChild(index);
    }
    /**
    Call `f` for every child node, passing the node, its offset
    into this parent node, and its index.
    */ forEach(f) {
        this.content.forEach(f);
    }
    /**
    Invoke a callback for all descendant nodes recursively between
    the given two positions that are relative to start of this
    node's content. The callback is invoked with the node, its
    position relative to the original node (method receiver),
    its parent node, and its child index. When the callback returns
    false for a given node, that node's children will not be
    recursed over. The last parameter can be used to specify a
    starting position to count from.
    */ nodesBetween(from, to, f, startPos = 0) {
        this.content.nodesBetween(from, to, f, startPos, this);
    }
    /**
    Call the given callback for every descendant node. Doesn't
    descend into a node when the callback returns `false`.
    */ descendants(f) {
        this.nodesBetween(0, this.content.size, f);
    }
    /**
    Concatenates all the text nodes found in this fragment and its
    children.
    */ get textContent() {
        return this.isLeaf && this.type.spec.leafText ? this.type.spec.leafText(this) : this.textBetween(0, this.content.size, "");
    }
    /**
    Get all text between positions `from` and `to`. When
    `blockSeparator` is given, it will be inserted to separate text
    from different block nodes. If `leafText` is given, it'll be
    inserted for every non-text leaf node encountered, otherwise
    [`leafText`](https://prosemirror.net/docs/ref/#model.NodeSpec.leafText) will be used.
    */ textBetween(from, to, blockSeparator, leafText) {
        return this.content.textBetween(from, to, blockSeparator, leafText);
    }
    /**
    Returns this node's first child, or `null` if there are no
    children.
    */ get firstChild() {
        return this.content.firstChild;
    }
    /**
    Returns this node's last child, or `null` if there are no
    children.
    */ get lastChild() {
        return this.content.lastChild;
    }
    /**
    Test whether two nodes represent the same piece of document.
    */ eq(other) {
        return this == other || this.sameMarkup(other) && this.content.eq(other.content);
    }
    /**
    Compare the markup (type, attributes, and marks) of this node to
    those of another. Returns `true` if both have the same markup.
    */ sameMarkup(other) {
        return this.hasMarkup(other.type, other.attrs, other.marks);
    }
    /**
    Check whether this node's markup correspond to the given type,
    attributes, and marks.
    */ hasMarkup(type, attrs, marks) {
        return this.type == type && $7161648073377122$var$compareDeep(this.attrs, attrs || type.defaultAttrs || $7161648073377122$var$emptyAttrs) && $7161648073377122$export$c9d15bcfc6d42044.sameSet(this.marks, marks || $7161648073377122$export$c9d15bcfc6d42044.none);
    }
    /**
    Create a new node with the same markup as this node, containing
    the given content (or empty, if no content is given).
    */ copy(content = null) {
        if (content == this.content) return this;
        return new $7161648073377122$export$85c928794f8d04d4(this.type, this.attrs, content, this.marks);
    }
    /**
    Create a copy of this node, with the given set of marks instead
    of the node's own marks.
    */ mark(marks) {
        return marks == this.marks ? this : new $7161648073377122$export$85c928794f8d04d4(this.type, this.attrs, this.content, marks);
    }
    /**
    Create a copy of this node with only the content between the
    given positions. If `to` is not given, it defaults to the end of
    the node.
    */ cut(from, to = this.content.size) {
        if (from == 0 && to == this.content.size) return this;
        return this.copy(this.content.cut(from, to));
    }
    /**
    Cut out the part of the document between the given positions, and
    return it as a `Slice` object.
    */ slice(from, to = this.content.size, includeParents = false) {
        if (from == to) return $7161648073377122$export$b3f2e2de3a8baa1e.empty;
        let $from = this.resolve(from), $to = this.resolve(to);
        let depth = includeParents ? 0 : $from.sharedDepth(to);
        let start = $from.start(depth), node = $from.node(depth);
        let content = node.content.cut($from.pos - start, $to.pos - start);
        return new $7161648073377122$export$b3f2e2de3a8baa1e(content, $from.depth - depth, $to.depth - depth);
    }
    /**
    Replace the part of the document between the given positions with
    the given slice. The slice must 'fit', meaning its open sides
    must be able to connect to the surrounding content, and its
    content nodes must be valid children for the node they are placed
    into. If any of this is violated, an error of type
    [`ReplaceError`](https://prosemirror.net/docs/ref/#model.ReplaceError) is thrown.
    */ replace(from, to, slice) {
        return $7161648073377122$var$replace(this.resolve(from), this.resolve(to), slice);
    }
    /**
    Find the node directly after the given position.
    */ nodeAt(pos) {
        for(let node = this;;){
            let { index: index, offset: offset } = node.content.findIndex(pos);
            node = node.maybeChild(index);
            if (!node) return null;
            if (offset == pos || node.isText) return node;
            pos -= offset + 1;
        }
    }
    /**
    Find the (direct) child node after the given offset, if any,
    and return it along with its index and offset relative to this
    node.
    */ childAfter(pos) {
        let { index: index, offset: offset } = this.content.findIndex(pos);
        return {
            node: this.content.maybeChild(index),
            index: index,
            offset: offset
        };
    }
    /**
    Find the (direct) child node before the given offset, if any,
    and return it along with its index and offset relative to this
    node.
    */ childBefore(pos) {
        if (pos == 0) return {
            node: null,
            index: 0,
            offset: 0
        };
        let { index: index, offset: offset } = this.content.findIndex(pos);
        if (offset < pos) return {
            node: this.content.child(index),
            index: index,
            offset: offset
        };
        let node = this.content.child(index - 1);
        return {
            node: node,
            index: index - 1,
            offset: offset - node.nodeSize
        };
    }
    /**
    Resolve the given position in the document, returning an
    [object](https://prosemirror.net/docs/ref/#model.ResolvedPos) with information about its context.
    */ resolve(pos) {
        return $7161648073377122$export$b2a42f82e59e4b19.resolveCached(this, pos);
    }
    /**
    @internal
    */ resolveNoCache(pos) {
        return $7161648073377122$export$b2a42f82e59e4b19.resolve(this, pos);
    }
    /**
    Test whether a given mark or mark type occurs in this document
    between the two given positions.
    */ rangeHasMark(from, to, type) {
        let found = false;
        if (to > from) this.nodesBetween(from, to, (node)=>{
            if (type.isInSet(node.marks)) found = true;
            return !found;
        });
        return found;
    }
    /**
    True when this is a block (non-inline node)
    */ get isBlock() {
        return this.type.isBlock;
    }
    /**
    True when this is a textblock node, a block node with inline
    content.
    */ get isTextblock() {
        return this.type.isTextblock;
    }
    /**
    True when this node allows inline content.
    */ get inlineContent() {
        return this.type.inlineContent;
    }
    /**
    True when this is an inline node (a text node or a node that can
    appear among text).
    */ get isInline() {
        return this.type.isInline;
    }
    /**
    True when this is a text node.
    */ get isText() {
        return this.type.isText;
    }
    /**
    True when this is a leaf node.
    */ get isLeaf() {
        return this.type.isLeaf;
    }
    /**
    True when this is an atom, i.e. when it does not have directly
    editable content. This is usually the same as `isLeaf`, but can
    be configured with the [`atom` property](https://prosemirror.net/docs/ref/#model.NodeSpec.atom)
    on a node's spec (typically used when the node is displayed as
    an uneditable [node view](https://prosemirror.net/docs/ref/#view.NodeView)).
    */ get isAtom() {
        return this.type.isAtom;
    }
    /**
    Return a string representation of this node for debugging
    purposes.
    */ toString() {
        if (this.type.spec.toDebugString) return this.type.spec.toDebugString(this);
        let name = this.type.name;
        if (this.content.size) name += "(" + this.content.toStringInner() + ")";
        return $7161648073377122$var$wrapMarks(this.marks, name);
    }
    /**
    Get the content match in this node at the given index.
    */ contentMatchAt(index) {
        let match = this.type.contentMatch.matchFragment(this.content, 0, index);
        if (!match) throw new Error("Called contentMatchAt on a node with invalid content");
        return match;
    }
    /**
    Test whether replacing the range between `from` and `to` (by
    child index) with the given replacement fragment (which defaults
    to the empty fragment) would leave the node's content valid. You
    can optionally pass `start` and `end` indices into the
    replacement fragment.
    */ canReplace(from, to, replacement = $7161648073377122$export$ffb0004e005737fa.empty, start = 0, end = replacement.childCount) {
        let one = this.contentMatchAt(from).matchFragment(replacement, start, end);
        let two = one && one.matchFragment(this.content, to);
        if (!two || !two.validEnd) return false;
        for(let i = start; i < end; i++)if (!this.type.allowsMarks(replacement.child(i).marks)) return false;
        return true;
    }
    /**
    Test whether replacing the range `from` to `to` (by index) with
    a node of the given type would leave the node's content valid.
    */ canReplaceWith(from, to, type, marks) {
        if (marks && !this.type.allowsMarks(marks)) return false;
        let start = this.contentMatchAt(from).matchType(type);
        let end = start && start.matchFragment(this.content, to);
        return end ? end.validEnd : false;
    }
    /**
    Test whether the given node's content could be appended to this
    node. If that node is empty, this will only return true if there
    is at least one node type that can appear in both nodes (to avoid
    merging completely incompatible nodes).
    */ canAppend(other) {
        if (other.content.size) return this.canReplace(this.childCount, this.childCount, other.content);
        else return this.type.compatibleContent(other.type);
    }
    /**
    Check whether this node and its descendants conform to the
    schema, and raise an exception when they do not.
    */ check() {
        this.type.checkContent(this.content);
        this.type.checkAttrs(this.attrs);
        let copy = $7161648073377122$export$c9d15bcfc6d42044.none;
        for(let i = 0; i < this.marks.length; i++){
            let mark = this.marks[i];
            mark.type.checkAttrs(mark.attrs);
            copy = mark.addToSet(copy);
        }
        if (!$7161648073377122$export$c9d15bcfc6d42044.sameSet(copy, this.marks)) throw new RangeError(`Invalid collection of marks for node ${this.type.name}: ${this.marks.map((m)=>m.type.name)}`);
        this.content.forEach((node)=>node.check());
    }
    /**
    Return a JSON-serializeable representation of this node.
    */ toJSON() {
        let obj = {
            type: this.type.name
        };
        for(let _ in this.attrs){
            obj.attrs = this.attrs;
            break;
        }
        if (this.content.size) obj.content = this.content.toJSON();
        if (this.marks.length) obj.marks = this.marks.map((n)=>n.toJSON());
        return obj;
    }
    /**
    Deserialize a node from its JSON representation.
    */ static fromJSON(schema, json) {
        if (!json) throw new RangeError("Invalid input for Node.fromJSON");
        let marks = undefined;
        if (json.marks) {
            if (!Array.isArray(json.marks)) throw new RangeError("Invalid mark data for Node.fromJSON");
            marks = json.marks.map(schema.markFromJSON);
        }
        if (json.type == "text") {
            if (typeof json.text != "string") throw new RangeError("Invalid text node in JSON");
            return schema.text(json.text, marks);
        }
        let content = $7161648073377122$export$ffb0004e005737fa.fromJSON(schema, json.content);
        let node = schema.nodeType(json.type).create(json.attrs, content, marks);
        node.type.checkAttrs(node.attrs);
        return node;
    }
}
$7161648073377122$export$85c928794f8d04d4.prototype.text = undefined;
class $7161648073377122$var$TextNode extends $7161648073377122$export$85c928794f8d04d4 {
    /**
    @internal
    */ constructor(type, attrs, content, marks){
        super(type, attrs, null, marks);
        if (!content) throw new RangeError("Empty text nodes are not allowed");
        this.text = content;
    }
    toString() {
        if (this.type.spec.toDebugString) return this.type.spec.toDebugString(this);
        return $7161648073377122$var$wrapMarks(this.marks, JSON.stringify(this.text));
    }
    get textContent() {
        return this.text;
    }
    textBetween(from, to) {
        return this.text.slice(from, to);
    }
    get nodeSize() {
        return this.text.length;
    }
    mark(marks) {
        return marks == this.marks ? this : new $7161648073377122$var$TextNode(this.type, this.attrs, this.text, marks);
    }
    withText(text) {
        if (text == this.text) return this;
        return new $7161648073377122$var$TextNode(this.type, this.attrs, text, this.marks);
    }
    cut(from = 0, to = this.text.length) {
        if (from == 0 && to == this.text.length) return this;
        return this.withText(this.text.slice(from, to));
    }
    eq(other) {
        return this.sameMarkup(other) && this.text == other.text;
    }
    toJSON() {
        let base = super.toJSON();
        base.text = this.text;
        return base;
    }
}
function $7161648073377122$var$wrapMarks(marks, str) {
    for(let i = marks.length - 1; i >= 0; i--)str = marks[i].type.name + "(" + str + ")";
    return str;
}
/**
Instances of this class represent a match state of a node type's
[content expression](https://prosemirror.net/docs/ref/#model.NodeSpec.content), and can be used to
find out whether further content matches here, and whether a given
position is a valid end of the node.
*/ class $7161648073377122$export$364ed450558d7ec4 {
    /**
    @internal
    */ constructor(/**
    True when this match state represents a valid end of the node.
    */ validEnd){
        this.validEnd = validEnd;
        /**
        @internal
        */ this.next = [];
        /**
        @internal
        */ this.wrapCache = [];
    }
    /**
    @internal
    */ static parse(string, nodeTypes) {
        let stream = new $7161648073377122$var$TokenStream(string, nodeTypes);
        if (stream.next == null) return $7161648073377122$export$364ed450558d7ec4.empty;
        let expr = $7161648073377122$var$parseExpr(stream);
        if (stream.next) stream.err("Unexpected trailing text");
        let match = $7161648073377122$var$dfa($7161648073377122$var$nfa(expr));
        $7161648073377122$var$checkForDeadEnds(match, stream);
        return match;
    }
    /**
    Match a node type, returning a match after that node if
    successful.
    */ matchType(type) {
        for(let i = 0; i < this.next.length; i++)if (this.next[i].type == type) return this.next[i].next;
        return null;
    }
    /**
    Try to match a fragment. Returns the resulting match when
    successful.
    */ matchFragment(frag, start = 0, end = frag.childCount) {
        let cur = this;
        for(let i = start; cur && i < end; i++)cur = cur.matchType(frag.child(i).type);
        return cur;
    }
    /**
    @internal
    */ get inlineContent() {
        return this.next.length != 0 && this.next[0].type.isInline;
    }
    /**
    Get the first matching node type at this match position that can
    be generated.
    */ get defaultType() {
        for(let i = 0; i < this.next.length; i++){
            let { type: type } = this.next[i];
            if (!(type.isText || type.hasRequiredAttrs())) return type;
        }
        return null;
    }
    /**
    @internal
    */ compatible(other) {
        for(let i = 0; i < this.next.length; i++)for(let j = 0; j < other.next.length; j++)if (this.next[i].type == other.next[j].type) return true;
        return false;
    }
    /**
    Try to match the given fragment, and if that fails, see if it can
    be made to match by inserting nodes in front of it. When
    successful, return a fragment of inserted nodes (which may be
    empty if nothing had to be inserted). When `toEnd` is true, only
    return a fragment if the resulting match goes to the end of the
    content expression.
    */ fillBefore(after, toEnd = false, startIndex = 0) {
        let seen = [
            this
        ];
        function search(match, types) {
            let finished = match.matchFragment(after, startIndex);
            if (finished && (!toEnd || finished.validEnd)) return $7161648073377122$export$ffb0004e005737fa.from(types.map((tp)=>tp.createAndFill()));
            for(let i = 0; i < match.next.length; i++){
                let { type: type, next: next } = match.next[i];
                if (!(type.isText || type.hasRequiredAttrs()) && seen.indexOf(next) == -1) {
                    seen.push(next);
                    let found = search(next, types.concat(type));
                    if (found) return found;
                }
            }
            return null;
        }
        return search(this, []);
    }
    /**
    Find a set of wrapping node types that would allow a node of the
    given type to appear at this position. The result may be empty
    (when it fits directly) and will be null when no such wrapping
    exists.
    */ findWrapping(target) {
        for(let i = 0; i < this.wrapCache.length; i += 2)if (this.wrapCache[i] == target) return this.wrapCache[i + 1];
        let computed = this.computeWrapping(target);
        this.wrapCache.push(target, computed);
        return computed;
    }
    /**
    @internal
    */ computeWrapping(target) {
        let seen = Object.create(null), active = [
            {
                match: this,
                type: null,
                via: null
            }
        ];
        while(active.length){
            let current = active.shift(), match = current.match;
            if (match.matchType(target)) {
                let result = [];
                for(let obj = current; obj.type; obj = obj.via)result.push(obj.type);
                return result.reverse();
            }
            for(let i = 0; i < match.next.length; i++){
                let { type: type, next: next } = match.next[i];
                if (!type.isLeaf && !type.hasRequiredAttrs() && !(type.name in seen) && (!current.type || next.validEnd)) {
                    active.push({
                        match: type.contentMatch,
                        type: type,
                        via: current
                    });
                    seen[type.name] = true;
                }
            }
        }
        return null;
    }
    /**
    The number of outgoing edges this node has in the finite
    automaton that describes the content expression.
    */ get edgeCount() {
        return this.next.length;
    }
    /**
    Get the _n_​th outgoing edge from this node in the finite
    automaton that describes the content expression.
    */ edge(n) {
        if (n >= this.next.length) throw new RangeError(`There's no ${n}th edge in this content match`);
        return this.next[n];
    }
    /**
    @internal
    */ toString() {
        let seen = [];
        function scan(m) {
            seen.push(m);
            for(let i = 0; i < m.next.length; i++)if (seen.indexOf(m.next[i].next) == -1) scan(m.next[i].next);
        }
        scan(this);
        return seen.map((m, i)=>{
            let out = i + (m.validEnd ? "*" : " ") + " ";
            for(let i = 0; i < m.next.length; i++)out += (i ? ", " : "") + m.next[i].type.name + "->" + seen.indexOf(m.next[i].next);
            return out;
        }).join("\n");
    }
}
/**
@internal
*/ $7161648073377122$export$364ed450558d7ec4.empty = new $7161648073377122$export$364ed450558d7ec4(true);
class $7161648073377122$var$TokenStream {
    constructor(string, nodeTypes){
        this.string = string;
        this.nodeTypes = nodeTypes;
        this.inline = null;
        this.pos = 0;
        this.tokens = string.split(/\s*(?=\b|\W|$)/);
        if (this.tokens[this.tokens.length - 1] == "") this.tokens.pop();
        if (this.tokens[0] == "") this.tokens.shift();
    }
    get next() {
        return this.tokens[this.pos];
    }
    eat(tok) {
        return this.next == tok && (this.pos++ || true);
    }
    err(str) {
        throw new SyntaxError(str + " (in content expression '" + this.string + "')");
    }
}
function $7161648073377122$var$parseExpr(stream) {
    let exprs = [];
    do exprs.push($7161648073377122$var$parseExprSeq(stream));
    while (stream.eat("|"));
    return exprs.length == 1 ? exprs[0] : {
        type: "choice",
        exprs: exprs
    };
}
function $7161648073377122$var$parseExprSeq(stream) {
    let exprs = [];
    do exprs.push($7161648073377122$var$parseExprSubscript(stream));
    while (stream.next && stream.next != ")" && stream.next != "|");
    return exprs.length == 1 ? exprs[0] : {
        type: "seq",
        exprs: exprs
    };
}
function $7161648073377122$var$parseExprSubscript(stream) {
    let expr = $7161648073377122$var$parseExprAtom(stream);
    for(;;){
        if (stream.eat("+")) expr = {
            type: "plus",
            expr: expr
        };
        else if (stream.eat("*")) expr = {
            type: "star",
            expr: expr
        };
        else if (stream.eat("?")) expr = {
            type: "opt",
            expr: expr
        };
        else if (stream.eat("{")) expr = $7161648073377122$var$parseExprRange(stream, expr);
        else break;
    }
    return expr;
}
function $7161648073377122$var$parseNum(stream) {
    if (/\D/.test(stream.next)) stream.err("Expected number, got '" + stream.next + "'");
    let result = Number(stream.next);
    stream.pos++;
    return result;
}
function $7161648073377122$var$parseExprRange(stream, expr) {
    let min = $7161648073377122$var$parseNum(stream), max = min;
    if (stream.eat(",")) {
        if (stream.next != "}") max = $7161648073377122$var$parseNum(stream);
        else max = -1;
    }
    if (!stream.eat("}")) stream.err("Unclosed braced range");
    return {
        type: "range",
        min: min,
        max: max,
        expr: expr
    };
}
function $7161648073377122$var$resolveName(stream, name) {
    let types = stream.nodeTypes, type = types[name];
    if (type) return [
        type
    ];
    let result = [];
    for(let typeName in types){
        let type = types[typeName];
        if (type.isInGroup(name)) result.push(type);
    }
    if (result.length == 0) stream.err("No node type or group '" + name + "' found");
    return result;
}
function $7161648073377122$var$parseExprAtom(stream) {
    if (stream.eat("(")) {
        let expr = $7161648073377122$var$parseExpr(stream);
        if (!stream.eat(")")) stream.err("Missing closing paren");
        return expr;
    } else if (!/\W/.test(stream.next)) {
        let exprs = $7161648073377122$var$resolveName(stream, stream.next).map((type)=>{
            if (stream.inline == null) stream.inline = type.isInline;
            else if (stream.inline != type.isInline) stream.err("Mixing inline and block content");
            return {
                type: "name",
                value: type
            };
        });
        stream.pos++;
        return exprs.length == 1 ? exprs[0] : {
            type: "choice",
            exprs: exprs
        };
    } else stream.err("Unexpected token '" + stream.next + "'");
}
// Construct an NFA from an expression as returned by the parser. The
// NFA is represented as an array of states, which are themselves
// arrays of edges, which are `{term, to}` objects. The first state is
// the entry state and the last node is the success state.
//
// Note that unlike typical NFAs, the edge ordering in this one is
// significant, in that it is used to contruct filler content when
// necessary.
function $7161648073377122$var$nfa(expr) {
    let nfa = [
        []
    ];
    connect(compile(expr, 0), node());
    return nfa;
    function node() {
        return nfa.push([]) - 1;
    }
    function edge(from, to, term) {
        let edge = {
            term: term,
            to: to
        };
        nfa[from].push(edge);
        return edge;
    }
    function connect(edges, to) {
        edges.forEach((edge)=>edge.to = to);
    }
    function compile(expr, from) {
        if (expr.type == "choice") return expr.exprs.reduce((out, expr)=>out.concat(compile(expr, from)), []);
        else if (expr.type == "seq") for(let i = 0;; i++){
            let next = compile(expr.exprs[i], from);
            if (i == expr.exprs.length - 1) return next;
            connect(next, from = node());
        }
        else if (expr.type == "star") {
            let loop = node();
            edge(from, loop);
            connect(compile(expr.expr, loop), loop);
            return [
                edge(loop)
            ];
        } else if (expr.type == "plus") {
            let loop = node();
            connect(compile(expr.expr, from), loop);
            connect(compile(expr.expr, loop), loop);
            return [
                edge(loop)
            ];
        } else if (expr.type == "opt") return [
            edge(from)
        ].concat(compile(expr.expr, from));
        else if (expr.type == "range") {
            let cur = from;
            for(let i = 0; i < expr.min; i++){
                let next = node();
                connect(compile(expr.expr, cur), next);
                cur = next;
            }
            if (expr.max == -1) connect(compile(expr.expr, cur), cur);
            else for(let i = expr.min; i < expr.max; i++){
                let next = node();
                edge(cur, next);
                connect(compile(expr.expr, cur), next);
                cur = next;
            }
            return [
                edge(cur)
            ];
        } else if (expr.type == "name") return [
            edge(from, undefined, expr.value)
        ];
        else throw new Error("Unknown expr type");
    }
}
function $7161648073377122$var$cmp(a, b) {
    return b - a;
}
// Get the set of nodes reachable by null edges from `node`. Omit
// nodes with only a single null-out-edge, since they may lead to
// needless duplicated nodes.
function $7161648073377122$var$nullFrom(nfa, node) {
    let result = [];
    scan(node);
    return result.sort($7161648073377122$var$cmp);
    function scan(node) {
        let edges = nfa[node];
        if (edges.length == 1 && !edges[0].term) return scan(edges[0].to);
        result.push(node);
        for(let i = 0; i < edges.length; i++){
            let { term: term, to: to } = edges[i];
            if (!term && result.indexOf(to) == -1) scan(to);
        }
    }
}
// Compiles an NFA as produced by `nfa` into a DFA, modeled as a set
// of state objects (`ContentMatch` instances) with transitions
// between them.
function $7161648073377122$var$dfa(nfa) {
    let labeled = Object.create(null);
    return explore($7161648073377122$var$nullFrom(nfa, 0));
    function explore(states) {
        let out = [];
        states.forEach((node)=>{
            nfa[node].forEach(({ term: term, to: to })=>{
                if (!term) return;
                let set;
                for(let i = 0; i < out.length; i++)if (out[i][0] == term) set = out[i][1];
                $7161648073377122$var$nullFrom(nfa, to).forEach((node)=>{
                    if (!set) out.push([
                        term,
                        set = []
                    ]);
                    if (set.indexOf(node) == -1) set.push(node);
                });
            });
        });
        let state = labeled[states.join(",")] = new $7161648073377122$export$364ed450558d7ec4(states.indexOf(nfa.length - 1) > -1);
        for(let i = 0; i < out.length; i++){
            let states = out[i][1].sort($7161648073377122$var$cmp);
            state.next.push({
                type: out[i][0],
                next: labeled[states.join(",")] || explore(states)
            });
        }
        return state;
    }
}
function $7161648073377122$var$checkForDeadEnds(match, stream) {
    for(let i = 0, work = [
        match
    ]; i < work.length; i++){
        let state = work[i], dead = !state.validEnd, nodes = [];
        for(let j = 0; j < state.next.length; j++){
            let { type: type, next: next } = state.next[j];
            nodes.push(type.name);
            if (dead && !(type.isText || type.hasRequiredAttrs())) dead = false;
            if (work.indexOf(next) == -1) work.push(next);
        }
        if (dead) stream.err("Only non-generatable nodes (" + nodes.join(", ") + ") in a required position (see https://prosemirror.net/docs/guide/#generatable)");
    }
}
// For node types where all attrs have a default value (or which don't
// have any attributes), build up a single reusable default attribute
// object, and use it for all nodes that don't specify specific
// attributes.
function $7161648073377122$var$defaultAttrs(attrs) {
    let defaults = Object.create(null);
    for(let attrName in attrs){
        let attr = attrs[attrName];
        if (!attr.hasDefault) return null;
        defaults[attrName] = attr.default;
    }
    return defaults;
}
function $7161648073377122$var$computeAttrs(attrs, value) {
    let built = Object.create(null);
    for(let name in attrs){
        let given = value && value[name];
        if (given === undefined) {
            let attr = attrs[name];
            if (attr.hasDefault) given = attr.default;
            else throw new RangeError("No value supplied for attribute " + name);
        }
        built[name] = given;
    }
    return built;
}
function $7161648073377122$var$checkAttrs(attrs, values, type, name) {
    for(let name in values)if (!(name in attrs)) throw new RangeError(`Unsupported attribute ${name} for ${type} of type ${name}`);
    for(let name in attrs){
        let attr = attrs[name];
        if (attr.validate) attr.validate(values[name]);
    }
}
function $7161648073377122$var$initAttrs(typeName, attrs) {
    let result = Object.create(null);
    if (attrs) for(let name in attrs)result[name] = new $7161648073377122$var$Attribute(typeName, name, attrs[name]);
    return result;
}
/**
Node types are objects allocated once per `Schema` and used to
[tag](https://prosemirror.net/docs/ref/#model.Node.type) `Node` instances. They contain information
about the node type, such as its name and what kind of node it
represents.
*/ class $7161648073377122$export$f06e977173f1857c {
    /**
    @internal
    */ constructor(/**
    The name the node type has in this schema.
    */ name, /**
    A link back to the `Schema` the node type belongs to.
    */ schema, /**
    The spec that this type is based on
    */ spec){
        this.name = name;
        this.schema = schema;
        this.spec = spec;
        /**
        The set of marks allowed in this node. `null` means all marks
        are allowed.
        */ this.markSet = null;
        this.groups = spec.group ? spec.group.split(" ") : [];
        this.attrs = $7161648073377122$var$initAttrs(name, spec.attrs);
        this.defaultAttrs = $7161648073377122$var$defaultAttrs(this.attrs);
        this.contentMatch = null;
        this.inlineContent = null;
        this.isBlock = !(spec.inline || name == "text");
        this.isText = name == "text";
    }
    /**
    True if this is an inline type.
    */ get isInline() {
        return !this.isBlock;
    }
    /**
    True if this is a textblock type, a block that contains inline
    content.
    */ get isTextblock() {
        return this.isBlock && this.inlineContent;
    }
    /**
    True for node types that allow no content.
    */ get isLeaf() {
        return this.contentMatch == $7161648073377122$export$364ed450558d7ec4.empty;
    }
    /**
    True when this node is an atom, i.e. when it does not have
    directly editable content.
    */ get isAtom() {
        return this.isLeaf || !!this.spec.atom;
    }
    /**
    Return true when this node type is part of the given
    [group](https://prosemirror.net/docs/ref/#model.NodeSpec.group).
    */ isInGroup(group) {
        return this.groups.indexOf(group) > -1;
    }
    /**
    The node type's [whitespace](https://prosemirror.net/docs/ref/#model.NodeSpec.whitespace) option.
    */ get whitespace() {
        return this.spec.whitespace || (this.spec.code ? "pre" : "normal");
    }
    /**
    Tells you whether this node type has any required attributes.
    */ hasRequiredAttrs() {
        for(let n in this.attrs)if (this.attrs[n].isRequired) return true;
        return false;
    }
    /**
    Indicates whether this node allows some of the same content as
    the given node type.
    */ compatibleContent(other) {
        return this == other || this.contentMatch.compatible(other.contentMatch);
    }
    /**
    @internal
    */ computeAttrs(attrs) {
        if (!attrs && this.defaultAttrs) return this.defaultAttrs;
        else return $7161648073377122$var$computeAttrs(this.attrs, attrs);
    }
    /**
    Create a `Node` of this type. The given attributes are
    checked and defaulted (you can pass `null` to use the type's
    defaults entirely, if no required attributes exist). `content`
    may be a `Fragment`, a node, an array of nodes, or
    `null`. Similarly `marks` may be `null` to default to the empty
    set of marks.
    */ create(attrs = null, content, marks) {
        if (this.isText) throw new Error("NodeType.create can't construct text nodes");
        return new $7161648073377122$export$85c928794f8d04d4(this, this.computeAttrs(attrs), $7161648073377122$export$ffb0004e005737fa.from(content), $7161648073377122$export$c9d15bcfc6d42044.setFrom(marks));
    }
    /**
    Like [`create`](https://prosemirror.net/docs/ref/#model.NodeType.create), but check the given content
    against the node type's content restrictions, and throw an error
    if it doesn't match.
    */ createChecked(attrs = null, content, marks) {
        content = $7161648073377122$export$ffb0004e005737fa.from(content);
        this.checkContent(content);
        return new $7161648073377122$export$85c928794f8d04d4(this, this.computeAttrs(attrs), content, $7161648073377122$export$c9d15bcfc6d42044.setFrom(marks));
    }
    /**
    Like [`create`](https://prosemirror.net/docs/ref/#model.NodeType.create), but see if it is
    necessary to add nodes to the start or end of the given fragment
    to make it fit the node. If no fitting wrapping can be found,
    return null. Note that, due to the fact that required nodes can
    always be created, this will always succeed if you pass null or
    `Fragment.empty` as content.
    */ createAndFill(attrs = null, content, marks) {
        attrs = this.computeAttrs(attrs);
        content = $7161648073377122$export$ffb0004e005737fa.from(content);
        if (content.size) {
            let before = this.contentMatch.fillBefore(content);
            if (!before) return null;
            content = before.append(content);
        }
        let matched = this.contentMatch.matchFragment(content);
        let after = matched && matched.fillBefore($7161648073377122$export$ffb0004e005737fa.empty, true);
        if (!after) return null;
        return new $7161648073377122$export$85c928794f8d04d4(this, attrs, content.append(after), $7161648073377122$export$c9d15bcfc6d42044.setFrom(marks));
    }
    /**
    Returns true if the given fragment is valid content for this node
    type.
    */ validContent(content) {
        let result = this.contentMatch.matchFragment(content);
        if (!result || !result.validEnd) return false;
        for(let i = 0; i < content.childCount; i++)if (!this.allowsMarks(content.child(i).marks)) return false;
        return true;
    }
    /**
    Throws a RangeError if the given fragment is not valid content for this
    node type.
    @internal
    */ checkContent(content) {
        if (!this.validContent(content)) throw new RangeError(`Invalid content for node ${this.name}: ${content.toString().slice(0, 50)}`);
    }
    /**
    @internal
    */ checkAttrs(attrs) {
        $7161648073377122$var$checkAttrs(this.attrs, attrs, "node", this.name);
    }
    /**
    Check whether the given mark type is allowed in this node.
    */ allowsMarkType(markType) {
        return this.markSet == null || this.markSet.indexOf(markType) > -1;
    }
    /**
    Test whether the given set of marks are allowed in this node.
    */ allowsMarks(marks) {
        if (this.markSet == null) return true;
        for(let i = 0; i < marks.length; i++)if (!this.allowsMarkType(marks[i].type)) return false;
        return true;
    }
    /**
    Removes the marks that are not allowed in this node from the given set.
    */ allowedMarks(marks) {
        if (this.markSet == null) return marks;
        let copy;
        for(let i = 0; i < marks.length; i++){
            if (!this.allowsMarkType(marks[i].type)) {
                if (!copy) copy = marks.slice(0, i);
            } else if (copy) copy.push(marks[i]);
        }
        return !copy ? marks : copy.length ? copy : $7161648073377122$export$c9d15bcfc6d42044.none;
    }
    /**
    @internal
    */ static compile(nodes, schema) {
        let result = Object.create(null);
        nodes.forEach((name, spec)=>result[name] = new $7161648073377122$export$f06e977173f1857c(name, schema, spec));
        let topType = schema.spec.topNode || "doc";
        if (!result[topType]) throw new RangeError("Schema is missing its top node type ('" + topType + "')");
        if (!result.text) throw new RangeError("Every schema needs a 'text' type");
        for(let _ in result.text.attrs)throw new RangeError("The text node type should not have attributes");
        return result;
    }
}
function $7161648073377122$var$validateType(typeName, attrName, type) {
    let types = type.split("|");
    return (value)=>{
        let name = value === null ? "null" : typeof value;
        if (types.indexOf(name) < 0) throw new RangeError(`Expected value of type ${types} for attribute ${attrName} on type ${typeName}, got ${name}`);
    };
}
// Attribute descriptors
class $7161648073377122$var$Attribute {
    constructor(typeName, attrName, options){
        this.hasDefault = Object.prototype.hasOwnProperty.call(options, "default");
        this.default = options.default;
        this.validate = typeof options.validate == "string" ? $7161648073377122$var$validateType(typeName, attrName, options.validate) : options.validate;
    }
    get isRequired() {
        return !this.hasDefault;
    }
}
// Marks
/**
Like nodes, marks (which are associated with nodes to signify
things like emphasis or being part of a link) are
[tagged](https://prosemirror.net/docs/ref/#model.Mark.type) with type objects, which are
instantiated once per `Schema`.
*/ class $7161648073377122$export$b6a78689043c6521 {
    /**
    @internal
    */ constructor(/**
    The name of the mark type.
    */ name, /**
    @internal
    */ rank, /**
    The schema that this mark type instance is part of.
    */ schema, /**
    The spec on which the type is based.
    */ spec){
        this.name = name;
        this.rank = rank;
        this.schema = schema;
        this.spec = spec;
        this.attrs = $7161648073377122$var$initAttrs(name, spec.attrs);
        this.excluded = null;
        let defaults = $7161648073377122$var$defaultAttrs(this.attrs);
        this.instance = defaults ? new $7161648073377122$export$c9d15bcfc6d42044(this, defaults) : null;
    }
    /**
    Create a mark of this type. `attrs` may be `null` or an object
    containing only some of the mark's attributes. The others, if
    they have defaults, will be added.
    */ create(attrs = null) {
        if (!attrs && this.instance) return this.instance;
        return new $7161648073377122$export$c9d15bcfc6d42044(this, $7161648073377122$var$computeAttrs(this.attrs, attrs));
    }
    /**
    @internal
    */ static compile(marks, schema) {
        let result = Object.create(null), rank = 0;
        marks.forEach((name, spec)=>result[name] = new $7161648073377122$export$b6a78689043c6521(name, rank++, schema, spec));
        return result;
    }
    /**
    When there is a mark of this type in the given set, a new set
    without it is returned. Otherwise, the input set is returned.
    */ removeFromSet(set) {
        for(var i = 0; i < set.length; i++)if (set[i].type == this) {
            set = set.slice(0, i).concat(set.slice(i + 1));
            i--;
        }
        return set;
    }
    /**
    Tests whether there is a mark of this type in the given set.
    */ isInSet(set) {
        for(let i = 0; i < set.length; i++)if (set[i].type == this) return set[i];
    }
    /**
    @internal
    */ checkAttrs(attrs) {
        $7161648073377122$var$checkAttrs(this.attrs, attrs, "mark", this.name);
    }
    /**
    Queries whether a given mark type is
    [excluded](https://prosemirror.net/docs/ref/#model.MarkSpec.excludes) by this one.
    */ excludes(other) {
        return this.excluded.indexOf(other) > -1;
    }
}
/**
A document schema. Holds [node](https://prosemirror.net/docs/ref/#model.NodeType) and [mark
type](https://prosemirror.net/docs/ref/#model.MarkType) objects for the nodes and marks that may
occur in conforming documents, and provides functionality for
creating and deserializing such documents.

When given, the type parameters provide the names of the nodes and
marks in this schema.
*/ class $7161648073377122$export$19342e026b58ebb7 {
    /**
    Construct a schema from a schema [specification](https://prosemirror.net/docs/ref/#model.SchemaSpec).
    */ constructor(spec){
        /**
        The [linebreak
        replacement](https://prosemirror.net/docs/ref/#model.NodeSpec.linebreakReplacement) node defined
        in this schema, if any.
        */ this.linebreakReplacement = null;
        /**
        An object for storing whatever values modules may want to
        compute and cache per schema. (If you want to store something
        in it, try to use property names unlikely to clash.)
        */ this.cached = Object.create(null);
        let instanceSpec = this.spec = {};
        for(let prop in spec)instanceSpec[prop] = spec[prop];
        instanceSpec.nodes = (0, $at9VT.default).from(spec.nodes), instanceSpec.marks = (0, $at9VT.default).from(spec.marks || {}), this.nodes = $7161648073377122$export$f06e977173f1857c.compile(this.spec.nodes, this);
        this.marks = $7161648073377122$export$b6a78689043c6521.compile(this.spec.marks, this);
        let contentExprCache = Object.create(null);
        for(let prop in this.nodes){
            if (prop in this.marks) throw new RangeError(prop + " can not be both a node and a mark");
            let type = this.nodes[prop], contentExpr = type.spec.content || "", markExpr = type.spec.marks;
            type.contentMatch = contentExprCache[contentExpr] || (contentExprCache[contentExpr] = $7161648073377122$export$364ed450558d7ec4.parse(contentExpr, this.nodes));
            type.inlineContent = type.contentMatch.inlineContent;
            if (type.spec.linebreakReplacement) {
                if (this.linebreakReplacement) throw new RangeError("Multiple linebreak nodes defined");
                if (!type.isInline || !type.isLeaf) throw new RangeError("Linebreak replacement nodes must be inline leaf nodes");
                this.linebreakReplacement = type;
            }
            type.markSet = markExpr == "_" ? null : markExpr ? $7161648073377122$var$gatherMarks(this, markExpr.split(" ")) : markExpr == "" || !type.inlineContent ? [] : null;
        }
        for(let prop in this.marks){
            let type = this.marks[prop], excl = type.spec.excludes;
            type.excluded = excl == null ? [
                type
            ] : excl == "" ? [] : $7161648073377122$var$gatherMarks(this, excl.split(" "));
        }
        this.nodeFromJSON = (json)=>$7161648073377122$export$85c928794f8d04d4.fromJSON(this, json);
        this.markFromJSON = (json)=>$7161648073377122$export$c9d15bcfc6d42044.fromJSON(this, json);
        this.topNodeType = this.nodes[this.spec.topNode || "doc"];
        this.cached.wrappings = Object.create(null);
    }
    /**
    Create a node in this schema. The `type` may be a string or a
    `NodeType` instance. Attributes will be extended with defaults,
    `content` may be a `Fragment`, `null`, a `Node`, or an array of
    nodes.
    */ node(type, attrs = null, content, marks) {
        if (typeof type == "string") type = this.nodeType(type);
        else if (!(type instanceof $7161648073377122$export$f06e977173f1857c)) throw new RangeError("Invalid node type: " + type);
        else if (type.schema != this) throw new RangeError("Node type from different schema used (" + type.name + ")");
        return type.createChecked(attrs, content, marks);
    }
    /**
    Create a text node in the schema. Empty text nodes are not
    allowed.
    */ text(text, marks) {
        let type = this.nodes.text;
        return new $7161648073377122$var$TextNode(type, type.defaultAttrs, text, $7161648073377122$export$c9d15bcfc6d42044.setFrom(marks));
    }
    /**
    Create a mark with the given type and attributes.
    */ mark(type, attrs) {
        if (typeof type == "string") type = this.marks[type];
        return type.create(attrs);
    }
    /**
    @internal
    */ nodeType(name) {
        let found = this.nodes[name];
        if (!found) throw new RangeError("Unknown node type: " + name);
        return found;
    }
}
function $7161648073377122$var$gatherMarks(schema, marks) {
    let found = [];
    for(let i = 0; i < marks.length; i++){
        let name = marks[i], mark = schema.marks[name], ok = mark;
        if (mark) found.push(mark);
        else for(let prop in schema.marks){
            let mark = schema.marks[prop];
            if (name == "_" || mark.spec.group && mark.spec.group.split(" ").indexOf(name) > -1) found.push(ok = mark);
        }
        if (!ok) throw new SyntaxError("Unknown mark type: '" + marks[i] + "'");
    }
    return found;
}
function $7161648073377122$var$isTagRule(rule) {
    return rule.tag != null;
}
function $7161648073377122$var$isStyleRule(rule) {
    return rule.style != null;
}
/**
A DOM parser represents a strategy for parsing DOM content into a
ProseMirror document conforming to a given schema. Its behavior is
defined by an array of [rules](https://prosemirror.net/docs/ref/#model.ParseRule).
*/ class $7161648073377122$export$1059c6e7d2ce5669 {
    /**
    Create a parser that targets the given schema, using the given
    parsing rules.
    */ constructor(/**
    The schema into which the parser parses.
    */ schema, /**
    The set of [parse rules](https://prosemirror.net/docs/ref/#model.ParseRule) that the parser
    uses, in order of precedence.
    */ rules){
        this.schema = schema;
        this.rules = rules;
        /**
        @internal
        */ this.tags = [];
        /**
        @internal
        */ this.styles = [];
        let matchedStyles = this.matchedStyles = [];
        rules.forEach((rule)=>{
            if ($7161648073377122$var$isTagRule(rule)) this.tags.push(rule);
            else if ($7161648073377122$var$isStyleRule(rule)) {
                let prop = /[^=]*/.exec(rule.style)[0];
                if (matchedStyles.indexOf(prop) < 0) matchedStyles.push(prop);
                this.styles.push(rule);
            }
        });
        // Only normalize list elements when lists in the schema can't directly contain themselves
        this.normalizeLists = !this.tags.some((r)=>{
            if (!/^(ul|ol)\b/.test(r.tag) || !r.node) return false;
            let node = schema.nodes[r.node];
            return node.contentMatch.matchType(node);
        });
    }
    /**
    Parse a document from the content of a DOM node.
    */ parse(dom, options = {}) {
        let context = new $7161648073377122$var$ParseContext(this, options, false);
        context.addAll(dom, $7161648073377122$export$c9d15bcfc6d42044.none, options.from, options.to);
        return context.finish();
    }
    /**
    Parses the content of the given DOM node, like
    [`parse`](https://prosemirror.net/docs/ref/#model.DOMParser.parse), and takes the same set of
    options. But unlike that method, which produces a whole node,
    this one returns a slice that is open at the sides, meaning that
    the schema constraints aren't applied to the start of nodes to
    the left of the input and the end of nodes at the end.
    */ parseSlice(dom, options = {}) {
        let context = new $7161648073377122$var$ParseContext(this, options, true);
        context.addAll(dom, $7161648073377122$export$c9d15bcfc6d42044.none, options.from, options.to);
        return $7161648073377122$export$b3f2e2de3a8baa1e.maxOpen(context.finish());
    }
    /**
    @internal
    */ matchTag(dom, context, after) {
        for(let i = after ? this.tags.indexOf(after) + 1 : 0; i < this.tags.length; i++){
            let rule = this.tags[i];
            if ($7161648073377122$var$matches(dom, rule.tag) && (rule.namespace === undefined || dom.namespaceURI == rule.namespace) && (!rule.context || context.matchesContext(rule.context))) {
                if (rule.getAttrs) {
                    let result = rule.getAttrs(dom);
                    if (result === false) continue;
                    rule.attrs = result || undefined;
                }
                return rule;
            }
        }
    }
    /**
    @internal
    */ matchStyle(prop, value, context, after) {
        for(let i = after ? this.styles.indexOf(after) + 1 : 0; i < this.styles.length; i++){
            let rule = this.styles[i], style = rule.style;
            if (style.indexOf(prop) != 0 || rule.context && !context.matchesContext(rule.context) || // Test that the style string either precisely matches the prop,
            // or has an '=' sign after the prop, followed by the given
            // value.
            style.length > prop.length && (style.charCodeAt(prop.length) != 61 || style.slice(prop.length + 1) != value)) continue;
            if (rule.getAttrs) {
                let result = rule.getAttrs(value);
                if (result === false) continue;
                rule.attrs = result || undefined;
            }
            return rule;
        }
    }
    /**
    @internal
    */ static schemaRules(schema) {
        let result = [];
        function insert(rule) {
            let priority = rule.priority == null ? 50 : rule.priority, i = 0;
            for(; i < result.length; i++){
                let next = result[i], nextPriority = next.priority == null ? 50 : next.priority;
                if (nextPriority < priority) break;
            }
            result.splice(i, 0, rule);
        }
        for(let name in schema.marks){
            let rules = schema.marks[name].spec.parseDOM;
            if (rules) rules.forEach((rule)=>{
                insert(rule = $7161648073377122$var$copy(rule));
                if (!(rule.mark || rule.ignore || rule.clearMark)) rule.mark = name;
            });
        }
        for(let name in schema.nodes){
            let rules = schema.nodes[name].spec.parseDOM;
            if (rules) rules.forEach((rule)=>{
                insert(rule = $7161648073377122$var$copy(rule));
                if (!(rule.node || rule.ignore || rule.mark)) rule.node = name;
            });
        }
        return result;
    }
    /**
    Construct a DOM parser using the parsing rules listed in a
    schema's [node specs](https://prosemirror.net/docs/ref/#model.NodeSpec.parseDOM), reordered by
    [priority](https://prosemirror.net/docs/ref/#model.GenericParseRule.priority).
    */ static fromSchema(schema) {
        return schema.cached.domParser || (schema.cached.domParser = new $7161648073377122$export$1059c6e7d2ce5669(schema, $7161648073377122$export$1059c6e7d2ce5669.schemaRules(schema)));
    }
}
const $7161648073377122$var$blockTags = {
    address: true,
    article: true,
    aside: true,
    blockquote: true,
    canvas: true,
    dd: true,
    div: true,
    dl: true,
    fieldset: true,
    figcaption: true,
    figure: true,
    footer: true,
    form: true,
    h1: true,
    h2: true,
    h3: true,
    h4: true,
    h5: true,
    h6: true,
    header: true,
    hgroup: true,
    hr: true,
    li: true,
    noscript: true,
    ol: true,
    output: true,
    p: true,
    pre: true,
    section: true,
    table: true,
    tfoot: true,
    ul: true
};
const $7161648073377122$var$ignoreTags = {
    head: true,
    noscript: true,
    object: true,
    script: true,
    style: true,
    title: true
};
const $7161648073377122$var$listTags = {
    ol: true,
    ul: true
};
// Using a bitfield for node context options
const $7161648073377122$var$OPT_PRESERVE_WS = 1, $7161648073377122$var$OPT_PRESERVE_WS_FULL = 2, $7161648073377122$var$OPT_OPEN_LEFT = 4;
function $7161648073377122$var$wsOptionsFor(type, preserveWhitespace, base) {
    if (preserveWhitespace != null) return (preserveWhitespace ? $7161648073377122$var$OPT_PRESERVE_WS : 0) | (preserveWhitespace === "full" ? $7161648073377122$var$OPT_PRESERVE_WS_FULL : 0);
    return type && type.whitespace == "pre" ? $7161648073377122$var$OPT_PRESERVE_WS | $7161648073377122$var$OPT_PRESERVE_WS_FULL : base & ~$7161648073377122$var$OPT_OPEN_LEFT;
}
class $7161648073377122$var$NodeContext {
    constructor(type, attrs, marks, solid, match, options){
        this.type = type;
        this.attrs = attrs;
        this.marks = marks;
        this.solid = solid;
        this.options = options;
        this.content = [];
        // Marks applied to the node's children
        this.activeMarks = $7161648073377122$export$c9d15bcfc6d42044.none;
        this.match = match || (options & $7161648073377122$var$OPT_OPEN_LEFT ? null : type.contentMatch);
    }
    findWrapping(node) {
        if (!this.match) {
            if (!this.type) return [];
            let fill = this.type.contentMatch.fillBefore($7161648073377122$export$ffb0004e005737fa.from(node));
            if (fill) this.match = this.type.contentMatch.matchFragment(fill);
            else {
                let start = this.type.contentMatch, wrap;
                if (wrap = start.findWrapping(node.type)) {
                    this.match = start;
                    return wrap;
                } else return null;
            }
        }
        return this.match.findWrapping(node.type);
    }
    finish(openEnd) {
        if (!(this.options & $7161648073377122$var$OPT_PRESERVE_WS)) {
            let last = this.content[this.content.length - 1], m;
            if (last && last.isText && (m = /[ \t\r\n\u000c]+$/.exec(last.text))) {
                let text = last;
                if (last.text.length == m[0].length) this.content.pop();
                else this.content[this.content.length - 1] = text.withText(text.text.slice(0, text.text.length - m[0].length));
            }
        }
        let content = $7161648073377122$export$ffb0004e005737fa.from(this.content);
        if (!openEnd && this.match) content = content.append(this.match.fillBefore($7161648073377122$export$ffb0004e005737fa.empty, true));
        return this.type ? this.type.create(this.attrs, content, this.marks) : content;
    }
    inlineContext(node) {
        if (this.type) return this.type.inlineContent;
        if (this.content.length) return this.content[0].isInline;
        return node.parentNode && !$7161648073377122$var$blockTags.hasOwnProperty(node.parentNode.nodeName.toLowerCase());
    }
}
class $7161648073377122$var$ParseContext {
    constructor(// The parser we are using.
    parser, // The options passed to this parse.
    options, isOpen){
        this.parser = parser;
        this.options = options;
        this.isOpen = isOpen;
        this.open = 0;
        this.localPreserveWS = false;
        let topNode = options.topNode, topContext;
        let topOptions = $7161648073377122$var$wsOptionsFor(null, options.preserveWhitespace, 0) | (isOpen ? $7161648073377122$var$OPT_OPEN_LEFT : 0);
        if (topNode) topContext = new $7161648073377122$var$NodeContext(topNode.type, topNode.attrs, $7161648073377122$export$c9d15bcfc6d42044.none, true, options.topMatch || topNode.type.contentMatch, topOptions);
        else if (isOpen) topContext = new $7161648073377122$var$NodeContext(null, null, $7161648073377122$export$c9d15bcfc6d42044.none, true, null, topOptions);
        else topContext = new $7161648073377122$var$NodeContext(parser.schema.topNodeType, null, $7161648073377122$export$c9d15bcfc6d42044.none, true, null, topOptions);
        this.nodes = [
            topContext
        ];
        this.find = options.findPositions;
        this.needsBlock = false;
    }
    get top() {
        return this.nodes[this.open];
    }
    // Add a DOM node to the content. Text is inserted as text node,
    // otherwise, the node is passed to `addElement` or, if it has a
    // `style` attribute, `addElementWithStyles`.
    addDOM(dom, marks) {
        if (dom.nodeType == 3) this.addTextNode(dom, marks);
        else if (dom.nodeType == 1) this.addElement(dom, marks);
    }
    addTextNode(dom, marks) {
        let value = dom.nodeValue;
        let top = this.top, preserveWS = top.options & $7161648073377122$var$OPT_PRESERVE_WS_FULL ? "full" : this.localPreserveWS || (top.options & $7161648073377122$var$OPT_PRESERVE_WS) > 0;
        let { schema: schema } = this.parser;
        if (preserveWS === "full" || top.inlineContext(dom) || /[^ \t\r\n\u000c]/.test(value)) {
            if (!preserveWS) {
                value = value.replace(/[ \t\r\n\u000c]+/g, " ");
                // If this starts with whitespace, and there is no node before it, or
                // a hard break, or a text node that ends with whitespace, strip the
                // leading space.
                if (/^[ \t\r\n\u000c]/.test(value) && this.open == this.nodes.length - 1) {
                    let nodeBefore = top.content[top.content.length - 1];
                    let domNodeBefore = dom.previousSibling;
                    if (!nodeBefore || domNodeBefore && domNodeBefore.nodeName == 'BR' || nodeBefore.isText && /[ \t\r\n\u000c]$/.test(nodeBefore.text)) value = value.slice(1);
                }
            } else if (preserveWS === "full") value = value.replace(/\r\n?/g, "\n");
            else if (schema.linebreakReplacement && /[\r\n]/.test(value) && this.top.findWrapping(schema.linebreakReplacement.create())) {
                let lines = value.split(/\r?\n|\r/);
                for(let i = 0; i < lines.length; i++){
                    if (i) this.insertNode(schema.linebreakReplacement.create(), marks, true);
                    if (lines[i]) this.insertNode(schema.text(lines[i]), marks, !/\S/.test(lines[i]));
                }
                value = "";
            } else value = value.replace(/\r?\n|\r/g, " ");
            if (value) this.insertNode(schema.text(value), marks, !/\S/.test(value));
            this.findInText(dom);
        } else this.findInside(dom);
    }
    // Try to find a handler for the given tag and use that to parse. If
    // none is found, the element's content nodes are added directly.
    addElement(dom, marks, matchAfter) {
        let outerWS = this.localPreserveWS, top = this.top;
        if (dom.tagName == "PRE" || /pre/.test(dom.style && dom.style.whiteSpace)) this.localPreserveWS = true;
        let name = dom.nodeName.toLowerCase(), ruleID;
        if ($7161648073377122$var$listTags.hasOwnProperty(name) && this.parser.normalizeLists) $7161648073377122$var$normalizeList(dom);
        let rule = this.options.ruleFromNode && this.options.ruleFromNode(dom) || (ruleID = this.parser.matchTag(dom, this, matchAfter));
        out: if (rule ? rule.ignore : $7161648073377122$var$ignoreTags.hasOwnProperty(name)) {
            this.findInside(dom);
            this.ignoreFallback(dom, marks);
        } else if (!rule || rule.skip || rule.closeParent) {
            if (rule && rule.closeParent) this.open = Math.max(0, this.open - 1);
            else if (rule && rule.skip.nodeType) dom = rule.skip;
            let sync, oldNeedsBlock = this.needsBlock;
            if ($7161648073377122$var$blockTags.hasOwnProperty(name)) {
                if (top.content.length && top.content[0].isInline && this.open) {
                    this.open--;
                    top = this.top;
                }
                sync = true;
                if (!top.type) this.needsBlock = true;
            } else if (!dom.firstChild) {
                this.leafFallback(dom, marks);
                break out;
            }
            let innerMarks = rule && rule.skip ? marks : this.readStyles(dom, marks);
            if (innerMarks) this.addAll(dom, innerMarks);
            if (sync) this.sync(top);
            this.needsBlock = oldNeedsBlock;
        } else {
            let innerMarks = this.readStyles(dom, marks);
            if (innerMarks) this.addElementByRule(dom, rule, innerMarks, rule.consuming === false ? ruleID : undefined);
        }
        this.localPreserveWS = outerWS;
    }
    // Called for leaf DOM nodes that would otherwise be ignored
    leafFallback(dom, marks) {
        if (dom.nodeName == "BR" && this.top.type && this.top.type.inlineContent) this.addTextNode(dom.ownerDocument.createTextNode("\n"), marks);
    }
    // Called for ignored nodes
    ignoreFallback(dom, marks) {
        // Ignored BR nodes should at least create an inline context
        if (dom.nodeName == "BR" && (!this.top.type || !this.top.type.inlineContent)) this.findPlace(this.parser.schema.text("-"), marks, true);
    }
    // Run any style parser associated with the node's styles. Either
    // return an updated array of marks, or null to indicate some of the
    // styles had a rule with `ignore` set.
    readStyles(dom, marks) {
        let styles = dom.style;
        // Because many properties will only show up in 'normalized' form
        // in `style.item` (i.e. text-decoration becomes
        // text-decoration-line, text-decoration-color, etc), we directly
        // query the styles mentioned in our rules instead of iterating
        // over the items.
        if (styles && styles.length) for(let i = 0; i < this.parser.matchedStyles.length; i++){
            let name = this.parser.matchedStyles[i], value = styles.getPropertyValue(name);
            if (value) for(let after = undefined;;){
                let rule = this.parser.matchStyle(name, value, this, after);
                if (!rule) break;
                if (rule.ignore) return null;
                if (rule.clearMark) marks = marks.filter((m)=>!rule.clearMark(m));
                else marks = marks.concat(this.parser.schema.marks[rule.mark].create(rule.attrs));
                if (rule.consuming === false) after = rule;
                else break;
            }
        }
        return marks;
    }
    // Look up a handler for the given node. If none are found, return
    // false. Otherwise, apply it, use its return value to drive the way
    // the node's content is wrapped, and return true.
    addElementByRule(dom, rule, marks, continueAfter) {
        let sync, nodeType;
        if (rule.node) {
            nodeType = this.parser.schema.nodes[rule.node];
            if (!nodeType.isLeaf) {
                let inner = this.enter(nodeType, rule.attrs || null, marks, rule.preserveWhitespace);
                if (inner) {
                    sync = true;
                    marks = inner;
                }
            } else if (!this.insertNode(nodeType.create(rule.attrs), marks, dom.nodeName == "BR")) this.leafFallback(dom, marks);
        } else {
            let markType = this.parser.schema.marks[rule.mark];
            marks = marks.concat(markType.create(rule.attrs));
        }
        let startIn = this.top;
        if (nodeType && nodeType.isLeaf) this.findInside(dom);
        else if (continueAfter) this.addElement(dom, marks, continueAfter);
        else if (rule.getContent) {
            this.findInside(dom);
            rule.getContent(dom, this.parser.schema).forEach((node)=>this.insertNode(node, marks, false));
        } else {
            let contentDOM = dom;
            if (typeof rule.contentElement == "string") contentDOM = dom.querySelector(rule.contentElement);
            else if (typeof rule.contentElement == "function") contentDOM = rule.contentElement(dom);
            else if (rule.contentElement) contentDOM = rule.contentElement;
            this.findAround(dom, contentDOM, true);
            this.addAll(contentDOM, marks);
            this.findAround(dom, contentDOM, false);
        }
        if (sync && this.sync(startIn)) this.open--;
    }
    // Add all child nodes between `startIndex` and `endIndex` (or the
    // whole node, if not given). If `sync` is passed, use it to
    // synchronize after every block element.
    addAll(parent, marks, startIndex, endIndex) {
        let index = startIndex || 0;
        for(let dom = startIndex ? parent.childNodes[startIndex] : parent.firstChild, end = endIndex == null ? null : parent.childNodes[endIndex]; dom != end; dom = dom.nextSibling, ++index){
            this.findAtPoint(parent, index);
            this.addDOM(dom, marks);
        }
        this.findAtPoint(parent, index);
    }
    // Try to find a way to fit the given node type into the current
    // context. May add intermediate wrappers and/or leave non-solid
    // nodes that we're in.
    findPlace(node, marks, cautious) {
        let route, sync;
        for(let depth = this.open, penalty = 0; depth >= 0; depth--){
            let cx = this.nodes[depth];
            let found = cx.findWrapping(node);
            if (found && (!route || route.length > found.length + penalty)) {
                route = found;
                sync = cx;
                if (!found.length) break;
            }
            if (cx.solid) {
                if (cautious) break;
                penalty += 2;
            }
        }
        if (!route) return null;
        this.sync(sync);
        for(let i = 0; i < route.length; i++)marks = this.enterInner(route[i], null, marks, false);
        return marks;
    }
    // Try to insert the given node, adjusting the context when needed.
    insertNode(node, marks, cautious) {
        if (node.isInline && this.needsBlock && !this.top.type) {
            let block = this.textblockFromContext();
            if (block) marks = this.enterInner(block, null, marks);
        }
        let innerMarks = this.findPlace(node, marks, cautious);
        if (innerMarks) {
            this.closeExtra();
            let top = this.top;
            if (top.match) top.match = top.match.matchType(node.type);
            let nodeMarks = $7161648073377122$export$c9d15bcfc6d42044.none;
            for (let m of innerMarks.concat(node.marks))if (top.type ? top.type.allowsMarkType(m.type) : $7161648073377122$var$markMayApply(m.type, node.type)) nodeMarks = m.addToSet(nodeMarks);
            top.content.push(node.mark(nodeMarks));
            return true;
        }
        return false;
    }
    // Try to start a node of the given type, adjusting the context when
    // necessary.
    enter(type, attrs, marks, preserveWS) {
        let innerMarks = this.findPlace(type.create(attrs), marks, false);
        if (innerMarks) innerMarks = this.enterInner(type, attrs, marks, true, preserveWS);
        return innerMarks;
    }
    // Open a node of the given type
    enterInner(type, attrs, marks, solid = false, preserveWS) {
        this.closeExtra();
        let top = this.top;
        top.match = top.match && top.match.matchType(type);
        let options = $7161648073377122$var$wsOptionsFor(type, preserveWS, top.options);
        if (top.options & $7161648073377122$var$OPT_OPEN_LEFT && top.content.length == 0) options |= $7161648073377122$var$OPT_OPEN_LEFT;
        let applyMarks = $7161648073377122$export$c9d15bcfc6d42044.none;
        marks = marks.filter((m)=>{
            if (top.type ? top.type.allowsMarkType(m.type) : $7161648073377122$var$markMayApply(m.type, type)) {
                applyMarks = m.addToSet(applyMarks);
                return false;
            }
            return true;
        });
        this.nodes.push(new $7161648073377122$var$NodeContext(type, attrs, applyMarks, solid, null, options));
        this.open++;
        return marks;
    }
    // Make sure all nodes above this.open are finished and added to
    // their parents
    closeExtra(openEnd = false) {
        let i = this.nodes.length - 1;
        if (i > this.open) {
            for(; i > this.open; i--)this.nodes[i - 1].content.push(this.nodes[i].finish(openEnd));
            this.nodes.length = this.open + 1;
        }
    }
    finish() {
        this.open = 0;
        this.closeExtra(this.isOpen);
        return this.nodes[0].finish(!!(this.isOpen || this.options.topOpen));
    }
    sync(to) {
        for(let i = this.open; i >= 0; i--){
            if (this.nodes[i] == to) {
                this.open = i;
                return true;
            } else if (this.localPreserveWS) this.nodes[i].options |= $7161648073377122$var$OPT_PRESERVE_WS;
        }
        return false;
    }
    get currentPos() {
        this.closeExtra();
        let pos = 0;
        for(let i = this.open; i >= 0; i--){
            let content = this.nodes[i].content;
            for(let j = content.length - 1; j >= 0; j--)pos += content[j].nodeSize;
            if (i) pos++;
        }
        return pos;
    }
    findAtPoint(parent, offset) {
        if (this.find) {
            for(let i = 0; i < this.find.length; i++)if (this.find[i].node == parent && this.find[i].offset == offset) this.find[i].pos = this.currentPos;
        }
    }
    findInside(parent) {
        if (this.find) {
            for(let i = 0; i < this.find.length; i++)if (this.find[i].pos == null && parent.nodeType == 1 && parent.contains(this.find[i].node)) this.find[i].pos = this.currentPos;
        }
    }
    findAround(parent, content, before) {
        if (parent != content && this.find) {
            for(let i = 0; i < this.find.length; i++)if (this.find[i].pos == null && parent.nodeType == 1 && parent.contains(this.find[i].node)) {
                let pos = content.compareDocumentPosition(this.find[i].node);
                if (pos & (before ? 2 : 4)) this.find[i].pos = this.currentPos;
            }
        }
    }
    findInText(textNode) {
        if (this.find) {
            for(let i = 0; i < this.find.length; i++)if (this.find[i].node == textNode) this.find[i].pos = this.currentPos - (textNode.nodeValue.length - this.find[i].offset);
        }
    }
    // Determines whether the given context string matches this context.
    matchesContext(context) {
        if (context.indexOf("|") > -1) return context.split(/\s*\|\s*/).some(this.matchesContext, this);
        let parts = context.split("/");
        let option = this.options.context;
        let useRoot = !this.isOpen && (!option || option.parent.type == this.nodes[0].type);
        let minDepth = -(option ? option.depth + 1 : 0) + (useRoot ? 0 : 1);
        let match = (i, depth)=>{
            for(; i >= 0; i--){
                let part = parts[i];
                if (part == "") {
                    if (i == parts.length - 1 || i == 0) continue;
                    for(; depth >= minDepth; depth--)if (match(i - 1, depth)) return true;
                    return false;
                } else {
                    let next = depth > 0 || depth == 0 && useRoot ? this.nodes[depth].type : option && depth >= minDepth ? option.node(depth - minDepth).type : null;
                    if (!next || next.name != part && !next.isInGroup(part)) return false;
                    depth--;
                }
            }
            return true;
        };
        return match(parts.length - 1, this.open);
    }
    textblockFromContext() {
        let $context = this.options.context;
        if ($context) for(let d = $context.depth; d >= 0; d--){
            let deflt = $context.node(d).contentMatchAt($context.indexAfter(d)).defaultType;
            if (deflt && deflt.isTextblock && deflt.defaultAttrs) return deflt;
        }
        for(let name in this.parser.schema.nodes){
            let type = this.parser.schema.nodes[name];
            if (type.isTextblock && type.defaultAttrs) return type;
        }
    }
}
// Kludge to work around directly nested list nodes produced by some
// tools and allowed by browsers to mean that the nested list is
// actually part of the list item above it.
function $7161648073377122$var$normalizeList(dom) {
    for(let child = dom.firstChild, prevItem = null; child; child = child.nextSibling){
        let name = child.nodeType == 1 ? child.nodeName.toLowerCase() : null;
        if (name && $7161648073377122$var$listTags.hasOwnProperty(name) && prevItem) {
            prevItem.appendChild(child);
            child = prevItem;
        } else if (name == "li") prevItem = child;
        else if (name) prevItem = null;
    }
}
// Apply a CSS selector.
function $7161648073377122$var$matches(dom, selector) {
    return (dom.matches || dom.msMatchesSelector || dom.webkitMatchesSelector || dom.mozMatchesSelector).call(dom, selector);
}
function $7161648073377122$var$copy(obj) {
    let copy = {};
    for(let prop in obj)copy[prop] = obj[prop];
    return copy;
}
// Used when finding a mark at the top level of a fragment parse.
// Checks whether it would be reasonable to apply a given mark type to
// a given node, by looking at the way the mark occurs in the schema.
function $7161648073377122$var$markMayApply(markType, nodeType) {
    let nodes = nodeType.schema.nodes;
    for(let name in nodes){
        let parent = nodes[name];
        if (!parent.allowsMarkType(markType)) continue;
        let seen = [], scan = (match)=>{
            seen.push(match);
            for(let i = 0; i < match.edgeCount; i++){
                let { type: type, next: next } = match.edge(i);
                if (type == nodeType) return true;
                if (seen.indexOf(next) < 0 && scan(next)) return true;
            }
        };
        if (scan(parent.contentMatch)) return true;
    }
}
/**
A DOM serializer knows how to convert ProseMirror nodes and
marks of various types to DOM nodes.
*/ class $7161648073377122$export$3476b78f8f5a8b72 {
    /**
    Create a serializer. `nodes` should map node names to functions
    that take a node and return a description of the corresponding
    DOM. `marks` does the same for mark names, but also gets an
    argument that tells it whether the mark's content is block or
    inline content (for typical use, it'll always be inline). A mark
    serializer may be `null` to indicate that marks of that type
    should not be serialized.
    */ constructor(/**
    The node serialization functions.
    */ nodes, /**
    The mark serialization functions.
    */ marks){
        this.nodes = nodes;
        this.marks = marks;
    }
    /**
    Serialize the content of this fragment to a DOM fragment. When
    not in the browser, the `document` option, containing a DOM
    document, should be passed so that the serializer can create
    nodes.
    */ serializeFragment(fragment, options = {}, target) {
        if (!target) target = $7161648073377122$var$doc(options).createDocumentFragment();
        let top = target, active = [];
        fragment.forEach((node)=>{
            if (active.length || node.marks.length) {
                let keep = 0, rendered = 0;
                while(keep < active.length && rendered < node.marks.length){
                    let next = node.marks[rendered];
                    if (!this.marks[next.type.name]) {
                        rendered++;
                        continue;
                    }
                    if (!next.eq(active[keep][0]) || next.type.spec.spanning === false) break;
                    keep++;
                    rendered++;
                }
                while(keep < active.length)top = active.pop()[1];
                while(rendered < node.marks.length){
                    let add = node.marks[rendered++];
                    let markDOM = this.serializeMark(add, node.isInline, options);
                    if (markDOM) {
                        active.push([
                            add,
                            top
                        ]);
                        top.appendChild(markDOM.dom);
                        top = markDOM.contentDOM || markDOM.dom;
                    }
                }
            }
            top.appendChild(this.serializeNodeInner(node, options));
        });
        return target;
    }
    /**
    @internal
    */ serializeNodeInner(node, options) {
        let { dom: dom, contentDOM: contentDOM } = $7161648073377122$var$renderSpec($7161648073377122$var$doc(options), this.nodes[node.type.name](node), null, node.attrs);
        if (contentDOM) {
            if (node.isLeaf) throw new RangeError("Content hole not allowed in a leaf node spec");
            this.serializeFragment(node.content, options, contentDOM);
        }
        return dom;
    }
    /**
    Serialize this node to a DOM node. This can be useful when you
    need to serialize a part of a document, as opposed to the whole
    document. To serialize a whole document, use
    [`serializeFragment`](https://prosemirror.net/docs/ref/#model.DOMSerializer.serializeFragment) on
    its [content](https://prosemirror.net/docs/ref/#model.Node.content).
    */ serializeNode(node, options = {}) {
        let dom = this.serializeNodeInner(node, options);
        for(let i = node.marks.length - 1; i >= 0; i--){
            let wrap = this.serializeMark(node.marks[i], node.isInline, options);
            if (wrap) {
                (wrap.contentDOM || wrap.dom).appendChild(dom);
                dom = wrap.dom;
            }
        }
        return dom;
    }
    /**
    @internal
    */ serializeMark(mark, inline, options = {}) {
        let toDOM = this.marks[mark.type.name];
        return toDOM && $7161648073377122$var$renderSpec($7161648073377122$var$doc(options), toDOM(mark, inline), null, mark.attrs);
    }
    static renderSpec(doc, structure, xmlNS = null, blockArraysIn) {
        return $7161648073377122$var$renderSpec(doc, structure, xmlNS, blockArraysIn);
    }
    /**
    Build a serializer using the [`toDOM`](https://prosemirror.net/docs/ref/#model.NodeSpec.toDOM)
    properties in a schema's node and mark specs.
    */ static fromSchema(schema) {
        return schema.cached.domSerializer || (schema.cached.domSerializer = new $7161648073377122$export$3476b78f8f5a8b72(this.nodesFromSchema(schema), this.marksFromSchema(schema)));
    }
    /**
    Gather the serializers in a schema's node specs into an object.
    This can be useful as a base to build a custom serializer from.
    */ static nodesFromSchema(schema) {
        let result = $7161648073377122$var$gatherToDOM(schema.nodes);
        if (!result.text) result.text = (node)=>node.text;
        return result;
    }
    /**
    Gather the serializers in a schema's mark specs into an object.
    */ static marksFromSchema(schema) {
        return $7161648073377122$var$gatherToDOM(schema.marks);
    }
}
function $7161648073377122$var$gatherToDOM(obj) {
    let result = {};
    for(let name in obj){
        let toDOM = obj[name].spec.toDOM;
        if (toDOM) result[name] = toDOM;
    }
    return result;
}
function $7161648073377122$var$doc(options) {
    return options.document || window.document;
}
const $7161648073377122$var$suspiciousAttributeCache = new WeakMap();
function $7161648073377122$var$suspiciousAttributes(attrs) {
    let value = $7161648073377122$var$suspiciousAttributeCache.get(attrs);
    if (value === undefined) $7161648073377122$var$suspiciousAttributeCache.set(attrs, value = $7161648073377122$var$suspiciousAttributesInner(attrs));
    return value;
}
function $7161648073377122$var$suspiciousAttributesInner(attrs) {
    let result = null;
    function scan(value) {
        if (value && typeof value == "object") {
            if (Array.isArray(value)) {
                if (typeof value[0] == "string") {
                    if (!result) result = [];
                    result.push(value);
                } else for(let i = 0; i < value.length; i++)scan(value[i]);
            } else for(let prop in value)scan(value[prop]);
        }
    }
    scan(attrs);
    return result;
}
function $7161648073377122$var$renderSpec(doc, structure, xmlNS, blockArraysIn) {
    if (typeof structure == "string") return {
        dom: doc.createTextNode(structure)
    };
    if (structure.nodeType != null) return {
        dom: structure
    };
    if (structure.dom && structure.dom.nodeType != null) return structure;
    let tagName = structure[0], suspicious;
    if (typeof tagName != "string") throw new RangeError("Invalid array passed to renderSpec");
    if (blockArraysIn && (suspicious = $7161648073377122$var$suspiciousAttributes(blockArraysIn)) && suspicious.indexOf(structure) > -1) throw new RangeError("Using an array from an attribute object as a DOM spec. This may be an attempted cross site scripting attack.");
    let space = tagName.indexOf(" ");
    if (space > 0) {
        xmlNS = tagName.slice(0, space);
        tagName = tagName.slice(space + 1);
    }
    let contentDOM;
    let dom = xmlNS ? doc.createElementNS(xmlNS, tagName) : doc.createElement(tagName);
    let attrs = structure[1], start = 1;
    if (attrs && typeof attrs == "object" && attrs.nodeType == null && !Array.isArray(attrs)) {
        start = 2;
        for(let name in attrs)if (attrs[name] != null) {
            let space = name.indexOf(" ");
            if (space > 0) dom.setAttributeNS(name.slice(0, space), name.slice(space + 1), attrs[name]);
            else if (name == "style" && dom.style) dom.style.cssText = attrs[name];
            else dom.setAttribute(name, attrs[name]);
        }
    }
    for(let i = start; i < structure.length; i++){
        let child = structure[i];
        if (child === 0) {
            if (i < structure.length - 1 || i > start) throw new RangeError("Content hole must be the only child of its parent node");
            return {
                dom: dom,
                contentDOM: dom
            };
        } else {
            let { dom: inner, contentDOM: innerContent } = $7161648073377122$var$renderSpec(doc, child, xmlNS, blockArraysIn);
            dom.appendChild(inner);
            if (innerContent) {
                if (contentDOM) throw new RangeError("Multiple content holes");
                contentDOM = innerContent;
            }
        }
    }
    return {
        dom: dom,
        contentDOM: contentDOM
    };
}

});

parcelRegister("lh06P", function(module, exports) {
$parcel$export(module.exports, "ReplaceStep", () => $f7cb452bf977726e$export$5c860b2e74034756);
$parcel$export(module.exports, "ReplaceAroundStep", () => $f7cb452bf977726e$export$444ba800d6024a98);
$parcel$export(module.exports, "liftTarget", () => $f7cb452bf977726e$export$f1508b72cc76a09e);
$parcel$export(module.exports, "findWrapping", () => $f7cb452bf977726e$export$118cb9a83e81ba37);
$parcel$export(module.exports, "canSplit", () => $f7cb452bf977726e$export$5aaf008897aef029);
$parcel$export(module.exports, "canJoin", () => $f7cb452bf977726e$export$f15f89fd9d8cc98a);
$parcel$export(module.exports, "joinPoint", () => $f7cb452bf977726e$export$41b1d4cb5ceb3147);
$parcel$export(module.exports, "dropPoint", () => $f7cb452bf977726e$export$2819d598d048fc9c);
$parcel$export(module.exports, "replaceStep", () => $f7cb452bf977726e$export$ed6ac67359824afd);
$parcel$export(module.exports, "Transform", () => $f7cb452bf977726e$export$563a914cafbdc389);

var $9Jwkl = parcelRequire("9Jwkl");
// Recovery values encode a range index and an offset. They are
// represented as numbers, because tons of them will be created when
// mapping, for example, a large number of decorations. The number's
// lower 16 bits provide the index, the remaining bits the offset.
//
// Note: We intentionally don't use bit shift operators to en- and
// decode these, since those clip to 32 bits, which we might in rare
// cases want to overflow. A 64-bit float can represent 48-bit
// integers precisely.
const $f7cb452bf977726e$var$lower16 = 0xffff;
const $f7cb452bf977726e$var$factor16 = Math.pow(2, 16);
function $f7cb452bf977726e$var$makeRecover(index, offset) {
    return index + offset * $f7cb452bf977726e$var$factor16;
}
function $f7cb452bf977726e$var$recoverIndex(value) {
    return value & $f7cb452bf977726e$var$lower16;
}
function $f7cb452bf977726e$var$recoverOffset(value) {
    return (value - (value & $f7cb452bf977726e$var$lower16)) / $f7cb452bf977726e$var$factor16;
}
const $f7cb452bf977726e$var$DEL_BEFORE = 1, $f7cb452bf977726e$var$DEL_AFTER = 2, $f7cb452bf977726e$var$DEL_ACROSS = 4, $f7cb452bf977726e$var$DEL_SIDE = 8;
/**
An object representing a mapped position with extra
information.
*/ class $f7cb452bf977726e$export$c77c9be41668e9b4 {
    /**
    @internal
    */ constructor(/**
    The mapped version of the position.
    */ pos, /**
    @internal
    */ delInfo, /**
    @internal
    */ recover){
        this.pos = pos;
        this.delInfo = delInfo;
        this.recover = recover;
    }
    /**
    Tells you whether the position was deleted, that is, whether the
    step removed the token on the side queried (via the `assoc`)
    argument from the document.
    */ get deleted() {
        return (this.delInfo & $f7cb452bf977726e$var$DEL_SIDE) > 0;
    }
    /**
    Tells you whether the token before the mapped position was deleted.
    */ get deletedBefore() {
        return (this.delInfo & ($f7cb452bf977726e$var$DEL_BEFORE | $f7cb452bf977726e$var$DEL_ACROSS)) > 0;
    }
    /**
    True when the token after the mapped position was deleted.
    */ get deletedAfter() {
        return (this.delInfo & ($f7cb452bf977726e$var$DEL_AFTER | $f7cb452bf977726e$var$DEL_ACROSS)) > 0;
    }
    /**
    Tells whether any of the steps mapped through deletes across the
    position (including both the token before and after the
    position).
    */ get deletedAcross() {
        return (this.delInfo & $f7cb452bf977726e$var$DEL_ACROSS) > 0;
    }
}
/**
A map describing the deletions and insertions made by a step, which
can be used to find the correspondence between positions in the
pre-step version of a document and the same position in the
post-step version.
*/ class $f7cb452bf977726e$export$c53d01c3ab9721b3 {
    /**
    Create a position map. The modifications to the document are
    represented as an array of numbers, in which each group of three
    represents a modified chunk as `[start, oldSize, newSize]`.
    */ constructor(/**
    @internal
    */ ranges, /**
    @internal
    */ inverted = false){
        this.ranges = ranges;
        this.inverted = inverted;
        if (!ranges.length && $f7cb452bf977726e$export$c53d01c3ab9721b3.empty) return $f7cb452bf977726e$export$c53d01c3ab9721b3.empty;
    }
    /**
    @internal
    */ recover(value) {
        let diff = 0, index = $f7cb452bf977726e$var$recoverIndex(value);
        if (!this.inverted) for(let i = 0; i < index; i++)diff += this.ranges[i * 3 + 2] - this.ranges[i * 3 + 1];
        return this.ranges[index * 3] + diff + $f7cb452bf977726e$var$recoverOffset(value);
    }
    mapResult(pos, assoc = 1) {
        return this._map(pos, assoc, false);
    }
    map(pos, assoc = 1) {
        return this._map(pos, assoc, true);
    }
    /**
    @internal
    */ _map(pos, assoc, simple) {
        let diff = 0, oldIndex = this.inverted ? 2 : 1, newIndex = this.inverted ? 1 : 2;
        for(let i = 0; i < this.ranges.length; i += 3){
            let start = this.ranges[i] - (this.inverted ? diff : 0);
            if (start > pos) break;
            let oldSize = this.ranges[i + oldIndex], newSize = this.ranges[i + newIndex], end = start + oldSize;
            if (pos <= end) {
                let side = !oldSize ? assoc : pos == start ? -1 : pos == end ? 1 : assoc;
                let result = start + diff + (side < 0 ? 0 : newSize);
                if (simple) return result;
                let recover = pos == (assoc < 0 ? start : end) ? null : $f7cb452bf977726e$var$makeRecover(i / 3, pos - start);
                let del = pos == start ? $f7cb452bf977726e$var$DEL_AFTER : pos == end ? $f7cb452bf977726e$var$DEL_BEFORE : $f7cb452bf977726e$var$DEL_ACROSS;
                if (assoc < 0 ? pos != start : pos != end) del |= $f7cb452bf977726e$var$DEL_SIDE;
                return new $f7cb452bf977726e$export$c77c9be41668e9b4(result, del, recover);
            }
            diff += newSize - oldSize;
        }
        return simple ? pos + diff : new $f7cb452bf977726e$export$c77c9be41668e9b4(pos + diff, 0, null);
    }
    /**
    @internal
    */ touches(pos, recover) {
        let diff = 0, index = $f7cb452bf977726e$var$recoverIndex(recover);
        let oldIndex = this.inverted ? 2 : 1, newIndex = this.inverted ? 1 : 2;
        for(let i = 0; i < this.ranges.length; i += 3){
            let start = this.ranges[i] - (this.inverted ? diff : 0);
            if (start > pos) break;
            let oldSize = this.ranges[i + oldIndex], end = start + oldSize;
            if (pos <= end && i == index * 3) return true;
            diff += this.ranges[i + newIndex] - oldSize;
        }
        return false;
    }
    /**
    Calls the given function on each of the changed ranges included in
    this map.
    */ forEach(f) {
        let oldIndex = this.inverted ? 2 : 1, newIndex = this.inverted ? 1 : 2;
        for(let i = 0, diff = 0; i < this.ranges.length; i += 3){
            let start = this.ranges[i], oldStart = start - (this.inverted ? diff : 0), newStart = start + (this.inverted ? 0 : diff);
            let oldSize = this.ranges[i + oldIndex], newSize = this.ranges[i + newIndex];
            f(oldStart, oldStart + oldSize, newStart, newStart + newSize);
            diff += newSize - oldSize;
        }
    }
    /**
    Create an inverted version of this map. The result can be used to
    map positions in the post-step document to the pre-step document.
    */ invert() {
        return new $f7cb452bf977726e$export$c53d01c3ab9721b3(this.ranges, !this.inverted);
    }
    /**
    @internal
    */ toString() {
        return (this.inverted ? "-" : "") + JSON.stringify(this.ranges);
    }
    /**
    Create a map that moves all positions by offset `n` (which may be
    negative). This can be useful when applying steps meant for a
    sub-document to a larger document, or vice-versa.
    */ static offset(n) {
        return n == 0 ? $f7cb452bf977726e$export$c53d01c3ab9721b3.empty : new $f7cb452bf977726e$export$c53d01c3ab9721b3(n < 0 ? [
            0,
            -n,
            0
        ] : [
            0,
            0,
            n
        ]);
    }
}
/**
A StepMap that contains no changed ranges.
*/ $f7cb452bf977726e$export$c53d01c3ab9721b3.empty = new $f7cb452bf977726e$export$c53d01c3ab9721b3([]);
/**
A mapping represents a pipeline of zero or more [step
maps](https://prosemirror.net/docs/ref/#transform.StepMap). It has special provisions for losslessly
handling mapping positions through a series of steps in which some
steps are inverted versions of earlier steps. (This comes up when
‘[rebasing](https://prosemirror.net/docs/guide/#transform.rebasing)’ steps for
collaboration or history management.)
*/ class $f7cb452bf977726e$export$f5f785078011b62 {
    /**
    Create a new mapping with the given position maps.
    */ constructor(maps, /**
    @internal
    */ mirror, /**
    The starting position in the `maps` array, used when `map` or
    `mapResult` is called.
    */ from = 0, /**
    The end position in the `maps` array.
    */ to = maps ? maps.length : 0){
        this.mirror = mirror;
        this.from = from;
        this.to = to;
        this._maps = maps || [];
        this.ownData = !(maps || mirror);
    }
    /**
    The step maps in this mapping.
    */ get maps() {
        return this._maps;
    }
    /**
    Create a mapping that maps only through a part of this one.
    */ slice(from = 0, to = this.maps.length) {
        return new $f7cb452bf977726e$export$f5f785078011b62(this._maps, this.mirror, from, to);
    }
    /**
    Add a step map to the end of this mapping. If `mirrors` is
    given, it should be the index of the step map that is the mirror
    image of this one.
    */ appendMap(map, mirrors) {
        if (!this.ownData) {
            this._maps = this._maps.slice();
            this.mirror = this.mirror && this.mirror.slice();
            this.ownData = true;
        }
        this.to = this._maps.push(map);
        if (mirrors != null) this.setMirror(this._maps.length - 1, mirrors);
    }
    /**
    Add all the step maps in a given mapping to this one (preserving
    mirroring information).
    */ appendMapping(mapping) {
        for(let i = 0, startSize = this._maps.length; i < mapping._maps.length; i++){
            let mirr = mapping.getMirror(i);
            this.appendMap(mapping._maps[i], mirr != null && mirr < i ? startSize + mirr : undefined);
        }
    }
    /**
    Finds the offset of the step map that mirrors the map at the
    given offset, in this mapping (as per the second argument to
    `appendMap`).
    */ getMirror(n) {
        if (this.mirror) {
            for(let i = 0; i < this.mirror.length; i++)if (this.mirror[i] == n) return this.mirror[i + (i % 2 ? -1 : 1)];
        }
    }
    /**
    @internal
    */ setMirror(n, m) {
        if (!this.mirror) this.mirror = [];
        this.mirror.push(n, m);
    }
    /**
    Append the inverse of the given mapping to this one.
    */ appendMappingInverted(mapping) {
        for(let i = mapping.maps.length - 1, totalSize = this._maps.length + mapping._maps.length; i >= 0; i--){
            let mirr = mapping.getMirror(i);
            this.appendMap(mapping._maps[i].invert(), mirr != null && mirr > i ? totalSize - mirr - 1 : undefined);
        }
    }
    /**
    Create an inverted version of this mapping.
    */ invert() {
        let inverse = new $f7cb452bf977726e$export$f5f785078011b62;
        inverse.appendMappingInverted(this);
        return inverse;
    }
    /**
    Map a position through this mapping.
    */ map(pos, assoc = 1) {
        if (this.mirror) return this._map(pos, assoc, true);
        for(let i = this.from; i < this.to; i++)pos = this._maps[i].map(pos, assoc);
        return pos;
    }
    /**
    Map a position through this mapping, returning a mapping
    result.
    */ mapResult(pos, assoc = 1) {
        return this._map(pos, assoc, false);
    }
    /**
    @internal
    */ _map(pos, assoc, simple) {
        let delInfo = 0;
        for(let i = this.from; i < this.to; i++){
            let map = this._maps[i], result = map.mapResult(pos, assoc);
            if (result.recover != null) {
                let corr = this.getMirror(i);
                if (corr != null && corr > i && corr < this.to) {
                    i = corr;
                    pos = this._maps[corr].recover(result.recover);
                    continue;
                }
            }
            delInfo |= result.delInfo;
            pos = result.pos;
        }
        return simple ? pos : new $f7cb452bf977726e$export$c77c9be41668e9b4(pos, delInfo, null);
    }
}
const $f7cb452bf977726e$var$stepsByID = Object.create(null);
/**
A step object represents an atomic change. It generally applies
only to the document it was created for, since the positions
stored in it will only make sense for that document.

New steps are defined by creating classes that extend `Step`,
overriding the `apply`, `invert`, `map`, `getMap` and `fromJSON`
methods, and registering your class with a unique
JSON-serialization identifier using
[`Step.jsonID`](https://prosemirror.net/docs/ref/#transform.Step^jsonID).
*/ class $f7cb452bf977726e$export$fd55ce593607084a {
    /**
    Get the step map that represents the changes made by this step,
    and which can be used to transform between positions in the old
    and the new document.
    */ getMap() {
        return $f7cb452bf977726e$export$c53d01c3ab9721b3.empty;
    }
    /**
    Try to merge this step with another one, to be applied directly
    after it. Returns the merged step when possible, null if the
    steps can't be merged.
    */ merge(other) {
        return null;
    }
    /**
    Deserialize a step from its JSON representation. Will call
    through to the step class' own implementation of this method.
    */ static fromJSON(schema, json) {
        if (!json || !json.stepType) throw new RangeError("Invalid input for Step.fromJSON");
        let type = $f7cb452bf977726e$var$stepsByID[json.stepType];
        if (!type) throw new RangeError(`No step type ${json.stepType} defined`);
        return type.fromJSON(schema, json);
    }
    /**
    To be able to serialize steps to JSON, each step needs a string
    ID to attach to its JSON representation. Use this method to
    register an ID for your step classes. Try to pick something
    that's unlikely to clash with steps from other modules.
    */ static jsonID(id, stepClass) {
        if (id in $f7cb452bf977726e$var$stepsByID) throw new RangeError("Duplicate use of step JSON ID " + id);
        $f7cb452bf977726e$var$stepsByID[id] = stepClass;
        stepClass.prototype.jsonID = id;
        return stepClass;
    }
}
/**
The result of [applying](https://prosemirror.net/docs/ref/#transform.Step.apply) a step. Contains either a
new document or a failure value.
*/ class $f7cb452bf977726e$export$8ebf1578a4199c09 {
    /**
    @internal
    */ constructor(/**
    The transformed document, if successful.
    */ doc, /**
    The failure message, if unsuccessful.
    */ failed){
        this.doc = doc;
        this.failed = failed;
    }
    /**
    Create a successful step result.
    */ static ok(doc) {
        return new $f7cb452bf977726e$export$8ebf1578a4199c09(doc, null);
    }
    /**
    Create a failed step result.
    */ static fail(message) {
        return new $f7cb452bf977726e$export$8ebf1578a4199c09(null, message);
    }
    /**
    Call [`Node.replace`](https://prosemirror.net/docs/ref/#model.Node.replace) with the given
    arguments. Create a successful result if it succeeds, and a
    failed one if it throws a `ReplaceError`.
    */ static fromReplace(doc, from, to, slice) {
        try {
            return $f7cb452bf977726e$export$8ebf1578a4199c09.ok(doc.replace(from, to, slice));
        } catch (e) {
            if (e instanceof (0, $9Jwkl.ReplaceError)) return $f7cb452bf977726e$export$8ebf1578a4199c09.fail(e.message);
            throw e;
        }
    }
}
function $f7cb452bf977726e$var$mapFragment(fragment, f, parent) {
    let mapped = [];
    for(let i = 0; i < fragment.childCount; i++){
        let child = fragment.child(i);
        if (child.content.size) child = child.copy($f7cb452bf977726e$var$mapFragment(child.content, f, child));
        if (child.isInline) child = f(child, parent, i);
        mapped.push(child);
    }
    return (0, $9Jwkl.Fragment).fromArray(mapped);
}
/**
Add a mark to all inline content between two positions.
*/ class $f7cb452bf977726e$export$d24ba56b0e3464a9 extends $f7cb452bf977726e$export$fd55ce593607084a {
    /**
    Create a mark step.
    */ constructor(/**
    The start of the marked range.
    */ from, /**
    The end of the marked range.
    */ to, /**
    The mark to add.
    */ mark){
        super();
        this.from = from;
        this.to = to;
        this.mark = mark;
    }
    apply(doc) {
        let oldSlice = doc.slice(this.from, this.to), $from = doc.resolve(this.from);
        let parent = $from.node($from.sharedDepth(this.to));
        let slice = new (0, $9Jwkl.Slice)($f7cb452bf977726e$var$mapFragment(oldSlice.content, (node, parent)=>{
            if (!node.isAtom || !parent.type.allowsMarkType(this.mark.type)) return node;
            return node.mark(this.mark.addToSet(node.marks));
        }, parent), oldSlice.openStart, oldSlice.openEnd);
        return $f7cb452bf977726e$export$8ebf1578a4199c09.fromReplace(doc, this.from, this.to, slice);
    }
    invert() {
        return new $f7cb452bf977726e$export$94150db1311f67a9(this.from, this.to, this.mark);
    }
    map(mapping) {
        let from = mapping.mapResult(this.from, 1), to = mapping.mapResult(this.to, -1);
        if (from.deleted && to.deleted || from.pos >= to.pos) return null;
        return new $f7cb452bf977726e$export$d24ba56b0e3464a9(from.pos, to.pos, this.mark);
    }
    merge(other) {
        if (other instanceof $f7cb452bf977726e$export$d24ba56b0e3464a9 && other.mark.eq(this.mark) && this.from <= other.to && this.to >= other.from) return new $f7cb452bf977726e$export$d24ba56b0e3464a9(Math.min(this.from, other.from), Math.max(this.to, other.to), this.mark);
        return null;
    }
    toJSON() {
        return {
            stepType: "addMark",
            mark: this.mark.toJSON(),
            from: this.from,
            to: this.to
        };
    }
    /**
    @internal
    */ static fromJSON(schema, json) {
        if (typeof json.from != "number" || typeof json.to != "number") throw new RangeError("Invalid input for AddMarkStep.fromJSON");
        return new $f7cb452bf977726e$export$d24ba56b0e3464a9(json.from, json.to, schema.markFromJSON(json.mark));
    }
}
$f7cb452bf977726e$export$fd55ce593607084a.jsonID("addMark", $f7cb452bf977726e$export$d24ba56b0e3464a9);
/**
Remove a mark from all inline content between two positions.
*/ class $f7cb452bf977726e$export$94150db1311f67a9 extends $f7cb452bf977726e$export$fd55ce593607084a {
    /**
    Create a mark-removing step.
    */ constructor(/**
    The start of the unmarked range.
    */ from, /**
    The end of the unmarked range.
    */ to, /**
    The mark to remove.
    */ mark){
        super();
        this.from = from;
        this.to = to;
        this.mark = mark;
    }
    apply(doc) {
        let oldSlice = doc.slice(this.from, this.to);
        let slice = new (0, $9Jwkl.Slice)($f7cb452bf977726e$var$mapFragment(oldSlice.content, (node)=>{
            return node.mark(this.mark.removeFromSet(node.marks));
        }, doc), oldSlice.openStart, oldSlice.openEnd);
        return $f7cb452bf977726e$export$8ebf1578a4199c09.fromReplace(doc, this.from, this.to, slice);
    }
    invert() {
        return new $f7cb452bf977726e$export$d24ba56b0e3464a9(this.from, this.to, this.mark);
    }
    map(mapping) {
        let from = mapping.mapResult(this.from, 1), to = mapping.mapResult(this.to, -1);
        if (from.deleted && to.deleted || from.pos >= to.pos) return null;
        return new $f7cb452bf977726e$export$94150db1311f67a9(from.pos, to.pos, this.mark);
    }
    merge(other) {
        if (other instanceof $f7cb452bf977726e$export$94150db1311f67a9 && other.mark.eq(this.mark) && this.from <= other.to && this.to >= other.from) return new $f7cb452bf977726e$export$94150db1311f67a9(Math.min(this.from, other.from), Math.max(this.to, other.to), this.mark);
        return null;
    }
    toJSON() {
        return {
            stepType: "removeMark",
            mark: this.mark.toJSON(),
            from: this.from,
            to: this.to
        };
    }
    /**
    @internal
    */ static fromJSON(schema, json) {
        if (typeof json.from != "number" || typeof json.to != "number") throw new RangeError("Invalid input for RemoveMarkStep.fromJSON");
        return new $f7cb452bf977726e$export$94150db1311f67a9(json.from, json.to, schema.markFromJSON(json.mark));
    }
}
$f7cb452bf977726e$export$fd55ce593607084a.jsonID("removeMark", $f7cb452bf977726e$export$94150db1311f67a9);
/**
Add a mark to a specific node.
*/ class $f7cb452bf977726e$export$adefd16c402fee4e extends $f7cb452bf977726e$export$fd55ce593607084a {
    /**
    Create a node mark step.
    */ constructor(/**
    The position of the target node.
    */ pos, /**
    The mark to add.
    */ mark){
        super();
        this.pos = pos;
        this.mark = mark;
    }
    apply(doc) {
        let node = doc.nodeAt(this.pos);
        if (!node) return $f7cb452bf977726e$export$8ebf1578a4199c09.fail("No node at mark step's position");
        let updated = node.type.create(node.attrs, null, this.mark.addToSet(node.marks));
        return $f7cb452bf977726e$export$8ebf1578a4199c09.fromReplace(doc, this.pos, this.pos + 1, new (0, $9Jwkl.Slice)((0, $9Jwkl.Fragment).from(updated), 0, node.isLeaf ? 0 : 1));
    }
    invert(doc) {
        let node = doc.nodeAt(this.pos);
        if (node) {
            let newSet = this.mark.addToSet(node.marks);
            if (newSet.length == node.marks.length) {
                for(let i = 0; i < node.marks.length; i++)if (!node.marks[i].isInSet(newSet)) return new $f7cb452bf977726e$export$adefd16c402fee4e(this.pos, node.marks[i]);
                return new $f7cb452bf977726e$export$adefd16c402fee4e(this.pos, this.mark);
            }
        }
        return new $f7cb452bf977726e$export$fdf7d1dc10724da2(this.pos, this.mark);
    }
    map(mapping) {
        let pos = mapping.mapResult(this.pos, 1);
        return pos.deletedAfter ? null : new $f7cb452bf977726e$export$adefd16c402fee4e(pos.pos, this.mark);
    }
    toJSON() {
        return {
            stepType: "addNodeMark",
            pos: this.pos,
            mark: this.mark.toJSON()
        };
    }
    /**
    @internal
    */ static fromJSON(schema, json) {
        if (typeof json.pos != "number") throw new RangeError("Invalid input for AddNodeMarkStep.fromJSON");
        return new $f7cb452bf977726e$export$adefd16c402fee4e(json.pos, schema.markFromJSON(json.mark));
    }
}
$f7cb452bf977726e$export$fd55ce593607084a.jsonID("addNodeMark", $f7cb452bf977726e$export$adefd16c402fee4e);
/**
Remove a mark from a specific node.
*/ class $f7cb452bf977726e$export$fdf7d1dc10724da2 extends $f7cb452bf977726e$export$fd55ce593607084a {
    /**
    Create a mark-removing step.
    */ constructor(/**
    The position of the target node.
    */ pos, /**
    The mark to remove.
    */ mark){
        super();
        this.pos = pos;
        this.mark = mark;
    }
    apply(doc) {
        let node = doc.nodeAt(this.pos);
        if (!node) return $f7cb452bf977726e$export$8ebf1578a4199c09.fail("No node at mark step's position");
        let updated = node.type.create(node.attrs, null, this.mark.removeFromSet(node.marks));
        return $f7cb452bf977726e$export$8ebf1578a4199c09.fromReplace(doc, this.pos, this.pos + 1, new (0, $9Jwkl.Slice)((0, $9Jwkl.Fragment).from(updated), 0, node.isLeaf ? 0 : 1));
    }
    invert(doc) {
        let node = doc.nodeAt(this.pos);
        if (!node || !this.mark.isInSet(node.marks)) return this;
        return new $f7cb452bf977726e$export$adefd16c402fee4e(this.pos, this.mark);
    }
    map(mapping) {
        let pos = mapping.mapResult(this.pos, 1);
        return pos.deletedAfter ? null : new $f7cb452bf977726e$export$fdf7d1dc10724da2(pos.pos, this.mark);
    }
    toJSON() {
        return {
            stepType: "removeNodeMark",
            pos: this.pos,
            mark: this.mark.toJSON()
        };
    }
    /**
    @internal
    */ static fromJSON(schema, json) {
        if (typeof json.pos != "number") throw new RangeError("Invalid input for RemoveNodeMarkStep.fromJSON");
        return new $f7cb452bf977726e$export$fdf7d1dc10724da2(json.pos, schema.markFromJSON(json.mark));
    }
}
$f7cb452bf977726e$export$fd55ce593607084a.jsonID("removeNodeMark", $f7cb452bf977726e$export$fdf7d1dc10724da2);
/**
Replace a part of the document with a slice of new content.
*/ class $f7cb452bf977726e$export$5c860b2e74034756 extends $f7cb452bf977726e$export$fd55ce593607084a {
    /**
    The given `slice` should fit the 'gap' between `from` and
    `to`—the depths must line up, and the surrounding nodes must be
    able to be joined with the open sides of the slice. When
    `structure` is true, the step will fail if the content between
    from and to is not just a sequence of closing and then opening
    tokens (this is to guard against rebased replace steps
    overwriting something they weren't supposed to).
    */ constructor(/**
    The start position of the replaced range.
    */ from, /**
    The end position of the replaced range.
    */ to, /**
    The slice to insert.
    */ slice, /**
    @internal
    */ structure = false){
        super();
        this.from = from;
        this.to = to;
        this.slice = slice;
        this.structure = structure;
    }
    apply(doc) {
        if (this.structure && $f7cb452bf977726e$var$contentBetween(doc, this.from, this.to)) return $f7cb452bf977726e$export$8ebf1578a4199c09.fail("Structure replace would overwrite content");
        return $f7cb452bf977726e$export$8ebf1578a4199c09.fromReplace(doc, this.from, this.to, this.slice);
    }
    getMap() {
        return new $f7cb452bf977726e$export$c53d01c3ab9721b3([
            this.from,
            this.to - this.from,
            this.slice.size
        ]);
    }
    invert(doc) {
        return new $f7cb452bf977726e$export$5c860b2e74034756(this.from, this.from + this.slice.size, doc.slice(this.from, this.to));
    }
    map(mapping) {
        let from = mapping.mapResult(this.from, 1), to = mapping.mapResult(this.to, -1);
        if (from.deletedAcross && to.deletedAcross) return null;
        return new $f7cb452bf977726e$export$5c860b2e74034756(from.pos, Math.max(from.pos, to.pos), this.slice, this.structure);
    }
    merge(other) {
        if (!(other instanceof $f7cb452bf977726e$export$5c860b2e74034756) || other.structure || this.structure) return null;
        if (this.from + this.slice.size == other.from && !this.slice.openEnd && !other.slice.openStart) {
            let slice = this.slice.size + other.slice.size == 0 ? (0, $9Jwkl.Slice).empty : new (0, $9Jwkl.Slice)(this.slice.content.append(other.slice.content), this.slice.openStart, other.slice.openEnd);
            return new $f7cb452bf977726e$export$5c860b2e74034756(this.from, this.to + (other.to - other.from), slice, this.structure);
        } else if (other.to == this.from && !this.slice.openStart && !other.slice.openEnd) {
            let slice = this.slice.size + other.slice.size == 0 ? (0, $9Jwkl.Slice).empty : new (0, $9Jwkl.Slice)(other.slice.content.append(this.slice.content), other.slice.openStart, this.slice.openEnd);
            return new $f7cb452bf977726e$export$5c860b2e74034756(other.from, this.to, slice, this.structure);
        } else return null;
    }
    toJSON() {
        let json = {
            stepType: "replace",
            from: this.from,
            to: this.to
        };
        if (this.slice.size) json.slice = this.slice.toJSON();
        if (this.structure) json.structure = true;
        return json;
    }
    /**
    @internal
    */ static fromJSON(schema, json) {
        if (typeof json.from != "number" || typeof json.to != "number") throw new RangeError("Invalid input for ReplaceStep.fromJSON");
        return new $f7cb452bf977726e$export$5c860b2e74034756(json.from, json.to, (0, $9Jwkl.Slice).fromJSON(schema, json.slice), !!json.structure);
    }
}
$f7cb452bf977726e$export$fd55ce593607084a.jsonID("replace", $f7cb452bf977726e$export$5c860b2e74034756);
/**
Replace a part of the document with a slice of content, but
preserve a range of the replaced content by moving it into the
slice.
*/ class $f7cb452bf977726e$export$444ba800d6024a98 extends $f7cb452bf977726e$export$fd55ce593607084a {
    /**
    Create a replace-around step with the given range and gap.
    `insert` should be the point in the slice into which the content
    of the gap should be moved. `structure` has the same meaning as
    it has in the [`ReplaceStep`](https://prosemirror.net/docs/ref/#transform.ReplaceStep) class.
    */ constructor(/**
    The start position of the replaced range.
    */ from, /**
    The end position of the replaced range.
    */ to, /**
    The start of preserved range.
    */ gapFrom, /**
    The end of preserved range.
    */ gapTo, /**
    The slice to insert.
    */ slice, /**
    The position in the slice where the preserved range should be
    inserted.
    */ insert, /**
    @internal
    */ structure = false){
        super();
        this.from = from;
        this.to = to;
        this.gapFrom = gapFrom;
        this.gapTo = gapTo;
        this.slice = slice;
        this.insert = insert;
        this.structure = structure;
    }
    apply(doc) {
        if (this.structure && ($f7cb452bf977726e$var$contentBetween(doc, this.from, this.gapFrom) || $f7cb452bf977726e$var$contentBetween(doc, this.gapTo, this.to))) return $f7cb452bf977726e$export$8ebf1578a4199c09.fail("Structure gap-replace would overwrite content");
        let gap = doc.slice(this.gapFrom, this.gapTo);
        if (gap.openStart || gap.openEnd) return $f7cb452bf977726e$export$8ebf1578a4199c09.fail("Gap is not a flat range");
        let inserted = this.slice.insertAt(this.insert, gap.content);
        if (!inserted) return $f7cb452bf977726e$export$8ebf1578a4199c09.fail("Content does not fit in gap");
        return $f7cb452bf977726e$export$8ebf1578a4199c09.fromReplace(doc, this.from, this.to, inserted);
    }
    getMap() {
        return new $f7cb452bf977726e$export$c53d01c3ab9721b3([
            this.from,
            this.gapFrom - this.from,
            this.insert,
            this.gapTo,
            this.to - this.gapTo,
            this.slice.size - this.insert
        ]);
    }
    invert(doc) {
        let gap = this.gapTo - this.gapFrom;
        return new $f7cb452bf977726e$export$444ba800d6024a98(this.from, this.from + this.slice.size + gap, this.from + this.insert, this.from + this.insert + gap, doc.slice(this.from, this.to).removeBetween(this.gapFrom - this.from, this.gapTo - this.from), this.gapFrom - this.from, this.structure);
    }
    map(mapping) {
        let from = mapping.mapResult(this.from, 1), to = mapping.mapResult(this.to, -1);
        let gapFrom = this.from == this.gapFrom ? from.pos : mapping.map(this.gapFrom, -1);
        let gapTo = this.to == this.gapTo ? to.pos : mapping.map(this.gapTo, 1);
        if (from.deletedAcross && to.deletedAcross || gapFrom < from.pos || gapTo > to.pos) return null;
        return new $f7cb452bf977726e$export$444ba800d6024a98(from.pos, to.pos, gapFrom, gapTo, this.slice, this.insert, this.structure);
    }
    toJSON() {
        let json = {
            stepType: "replaceAround",
            from: this.from,
            to: this.to,
            gapFrom: this.gapFrom,
            gapTo: this.gapTo,
            insert: this.insert
        };
        if (this.slice.size) json.slice = this.slice.toJSON();
        if (this.structure) json.structure = true;
        return json;
    }
    /**
    @internal
    */ static fromJSON(schema, json) {
        if (typeof json.from != "number" || typeof json.to != "number" || typeof json.gapFrom != "number" || typeof json.gapTo != "number" || typeof json.insert != "number") throw new RangeError("Invalid input for ReplaceAroundStep.fromJSON");
        return new $f7cb452bf977726e$export$444ba800d6024a98(json.from, json.to, json.gapFrom, json.gapTo, (0, $9Jwkl.Slice).fromJSON(schema, json.slice), json.insert, !!json.structure);
    }
}
$f7cb452bf977726e$export$fd55ce593607084a.jsonID("replaceAround", $f7cb452bf977726e$export$444ba800d6024a98);
function $f7cb452bf977726e$var$contentBetween(doc, from, to) {
    let $from = doc.resolve(from), dist = to - from, depth = $from.depth;
    while(dist > 0 && depth > 0 && $from.indexAfter(depth) == $from.node(depth).childCount){
        depth--;
        dist--;
    }
    if (dist > 0) {
        let next = $from.node(depth).maybeChild($from.indexAfter(depth));
        while(dist > 0){
            if (!next || next.isLeaf) return true;
            next = next.firstChild;
            dist--;
        }
    }
    return false;
}
function $f7cb452bf977726e$var$addMark(tr, from, to, mark) {
    let removed = [], added = [];
    let removing, adding;
    tr.doc.nodesBetween(from, to, (node, pos, parent)=>{
        if (!node.isInline) return;
        let marks = node.marks;
        if (!mark.isInSet(marks) && parent.type.allowsMarkType(mark.type)) {
            let start = Math.max(pos, from), end = Math.min(pos + node.nodeSize, to);
            let newSet = mark.addToSet(marks);
            for(let i = 0; i < marks.length; i++)if (!marks[i].isInSet(newSet)) {
                if (removing && removing.to == start && removing.mark.eq(marks[i])) removing.to = end;
                else removed.push(removing = new $f7cb452bf977726e$export$94150db1311f67a9(start, end, marks[i]));
            }
            if (adding && adding.to == start) adding.to = end;
            else added.push(adding = new $f7cb452bf977726e$export$d24ba56b0e3464a9(start, end, mark));
        }
    });
    removed.forEach((s)=>tr.step(s));
    added.forEach((s)=>tr.step(s));
}
function $f7cb452bf977726e$var$removeMark(tr, from, to, mark) {
    let matched = [], step = 0;
    tr.doc.nodesBetween(from, to, (node, pos)=>{
        if (!node.isInline) return;
        step++;
        let toRemove = null;
        if (mark instanceof (0, $9Jwkl.MarkType)) {
            let set = node.marks, found;
            while(found = mark.isInSet(set)){
                (toRemove || (toRemove = [])).push(found);
                set = found.removeFromSet(set);
            }
        } else if (mark) {
            if (mark.isInSet(node.marks)) toRemove = [
                mark
            ];
        } else toRemove = node.marks;
        if (toRemove && toRemove.length) {
            let end = Math.min(pos + node.nodeSize, to);
            for(let i = 0; i < toRemove.length; i++){
                let style = toRemove[i], found;
                for(let j = 0; j < matched.length; j++){
                    let m = matched[j];
                    if (m.step == step - 1 && style.eq(matched[j].style)) found = m;
                }
                if (found) {
                    found.to = end;
                    found.step = step;
                } else matched.push({
                    style: style,
                    from: Math.max(pos, from),
                    to: end,
                    step: step
                });
            }
        }
    });
    matched.forEach((m)=>tr.step(new $f7cb452bf977726e$export$94150db1311f67a9(m.from, m.to, m.style)));
}
function $f7cb452bf977726e$var$clearIncompatible(tr, pos, parentType, match = parentType.contentMatch, clearNewlines = true) {
    let node = tr.doc.nodeAt(pos);
    let replSteps = [], cur = pos + 1;
    for(let i = 0; i < node.childCount; i++){
        let child = node.child(i), end = cur + child.nodeSize;
        let allowed = match.matchType(child.type);
        if (!allowed) replSteps.push(new $f7cb452bf977726e$export$5c860b2e74034756(cur, end, (0, $9Jwkl.Slice).empty));
        else {
            match = allowed;
            for(let j = 0; j < child.marks.length; j++)if (!parentType.allowsMarkType(child.marks[j].type)) tr.step(new $f7cb452bf977726e$export$94150db1311f67a9(cur, end, child.marks[j]));
            if (clearNewlines && child.isText && parentType.whitespace != "pre") {
                let m, newline = /\r?\n|\r/g, slice;
                while(m = newline.exec(child.text)){
                    if (!slice) slice = new (0, $9Jwkl.Slice)((0, $9Jwkl.Fragment).from(parentType.schema.text(" ", parentType.allowedMarks(child.marks))), 0, 0);
                    replSteps.push(new $f7cb452bf977726e$export$5c860b2e74034756(cur + m.index, cur + m.index + m[0].length, slice));
                }
            }
        }
        cur = end;
    }
    if (!match.validEnd) {
        let fill = match.fillBefore((0, $9Jwkl.Fragment).empty, true);
        tr.replace(cur, cur, new (0, $9Jwkl.Slice)(fill, 0, 0));
    }
    for(let i = replSteps.length - 1; i >= 0; i--)tr.step(replSteps[i]);
}
function $f7cb452bf977726e$var$canCut(node, start, end) {
    return (start == 0 || node.canReplace(start, node.childCount)) && (end == node.childCount || node.canReplace(0, end));
}
/**
Try to find a target depth to which the content in the given range
can be lifted. Will not go across
[isolating](https://prosemirror.net/docs/ref/#model.NodeSpec.isolating) parent nodes.
*/ function $f7cb452bf977726e$export$f1508b72cc76a09e(range) {
    let parent = range.parent;
    let content = parent.content.cutByIndex(range.startIndex, range.endIndex);
    for(let depth = range.depth, contentBefore = 0, contentAfter = 0;; --depth){
        let node = range.$from.node(depth);
        let index = range.$from.index(depth) + contentBefore, endIndex = range.$to.indexAfter(depth) - contentAfter;
        if (depth < range.depth && node.canReplace(index, endIndex, content)) return depth;
        if (depth == 0 || node.type.spec.isolating || !$f7cb452bf977726e$var$canCut(node, index, endIndex)) break;
        if (index) contentBefore = 1;
        if (endIndex < node.childCount) contentAfter = 1;
    }
    return null;
}
function $f7cb452bf977726e$var$lift(tr, range, target) {
    let { $from: $from, $to: $to, depth: depth } = range;
    let gapStart = $from.before(depth + 1), gapEnd = $to.after(depth + 1);
    let start = gapStart, end = gapEnd;
    let before = (0, $9Jwkl.Fragment).empty, openStart = 0;
    for(let d = depth, splitting = false; d > target; d--)if (splitting || $from.index(d) > 0) {
        splitting = true;
        before = (0, $9Jwkl.Fragment).from($from.node(d).copy(before));
        openStart++;
    } else start--;
    let after = (0, $9Jwkl.Fragment).empty, openEnd = 0;
    for(let d = depth, splitting = false; d > target; d--)if (splitting || $to.after(d + 1) < $to.end(d)) {
        splitting = true;
        after = (0, $9Jwkl.Fragment).from($to.node(d).copy(after));
        openEnd++;
    } else end++;
    tr.step(new $f7cb452bf977726e$export$444ba800d6024a98(start, end, gapStart, gapEnd, new (0, $9Jwkl.Slice)(before.append(after), openStart, openEnd), before.size - openStart, true));
}
/**
Try to find a valid way to wrap the content in the given range in a
node of the given type. May introduce extra nodes around and inside
the wrapper node, if necessary. Returns null if no valid wrapping
could be found. When `innerRange` is given, that range's content is
used as the content to fit into the wrapping, instead of the
content of `range`.
*/ function $f7cb452bf977726e$export$118cb9a83e81ba37(range, nodeType, attrs = null, innerRange = range) {
    let around = $f7cb452bf977726e$var$findWrappingOutside(range, nodeType);
    let inner = around && $f7cb452bf977726e$var$findWrappingInside(innerRange, nodeType);
    if (!inner) return null;
    return around.map($f7cb452bf977726e$var$withAttrs).concat({
        type: nodeType,
        attrs: attrs
    }).concat(inner.map($f7cb452bf977726e$var$withAttrs));
}
function $f7cb452bf977726e$var$withAttrs(type) {
    return {
        type: type,
        attrs: null
    };
}
function $f7cb452bf977726e$var$findWrappingOutside(range, type) {
    let { parent: parent, startIndex: startIndex, endIndex: endIndex } = range;
    let around = parent.contentMatchAt(startIndex).findWrapping(type);
    if (!around) return null;
    let outer = around.length ? around[0] : type;
    return parent.canReplaceWith(startIndex, endIndex, outer) ? around : null;
}
function $f7cb452bf977726e$var$findWrappingInside(range, type) {
    let { parent: parent, startIndex: startIndex, endIndex: endIndex } = range;
    let inner = parent.child(startIndex);
    let inside = type.contentMatch.findWrapping(inner.type);
    if (!inside) return null;
    let lastType = inside.length ? inside[inside.length - 1] : type;
    let innerMatch = lastType.contentMatch;
    for(let i = startIndex; innerMatch && i < endIndex; i++)innerMatch = innerMatch.matchType(parent.child(i).type);
    if (!innerMatch || !innerMatch.validEnd) return null;
    return inside;
}
function $f7cb452bf977726e$var$wrap(tr, range, wrappers) {
    let content = (0, $9Jwkl.Fragment).empty;
    for(let i = wrappers.length - 1; i >= 0; i--){
        if (content.size) {
            let match = wrappers[i].type.contentMatch.matchFragment(content);
            if (!match || !match.validEnd) throw new RangeError("Wrapper type given to Transform.wrap does not form valid content of its parent wrapper");
        }
        content = (0, $9Jwkl.Fragment).from(wrappers[i].type.create(wrappers[i].attrs, content));
    }
    let start = range.start, end = range.end;
    tr.step(new $f7cb452bf977726e$export$444ba800d6024a98(start, end, start, end, new (0, $9Jwkl.Slice)(content, 0, 0), wrappers.length, true));
}
function $f7cb452bf977726e$var$setBlockType(tr, from, to, type, attrs) {
    if (!type.isTextblock) throw new RangeError("Type given to setBlockType should be a textblock");
    let mapFrom = tr.steps.length;
    tr.doc.nodesBetween(from, to, (node, pos)=>{
        let attrsHere = typeof attrs == "function" ? attrs(node) : attrs;
        if (node.isTextblock && !node.hasMarkup(type, attrsHere) && $f7cb452bf977726e$var$canChangeType(tr.doc, tr.mapping.slice(mapFrom).map(pos), type)) {
            let convertNewlines = null;
            if (type.schema.linebreakReplacement) {
                let pre = type.whitespace == "pre", supportLinebreak = !!type.contentMatch.matchType(type.schema.linebreakReplacement);
                if (pre && !supportLinebreak) convertNewlines = false;
                else if (!pre && supportLinebreak) convertNewlines = true;
            }
            // Ensure all markup that isn't allowed in the new node type is cleared
            if (convertNewlines === false) $f7cb452bf977726e$var$replaceLinebreaks(tr, node, pos, mapFrom);
            $f7cb452bf977726e$var$clearIncompatible(tr, tr.mapping.slice(mapFrom).map(pos, 1), type, undefined, convertNewlines === null);
            let mapping = tr.mapping.slice(mapFrom);
            let startM = mapping.map(pos, 1), endM = mapping.map(pos + node.nodeSize, 1);
            tr.step(new $f7cb452bf977726e$export$444ba800d6024a98(startM, endM, startM + 1, endM - 1, new (0, $9Jwkl.Slice)((0, $9Jwkl.Fragment).from(type.create(attrsHere, null, node.marks)), 0, 0), 1, true));
            if (convertNewlines === true) $f7cb452bf977726e$var$replaceNewlines(tr, node, pos, mapFrom);
            return false;
        }
    });
}
function $f7cb452bf977726e$var$replaceNewlines(tr, node, pos, mapFrom) {
    node.forEach((child, offset)=>{
        if (child.isText) {
            let m, newline = /\r?\n|\r/g;
            while(m = newline.exec(child.text)){
                let start = tr.mapping.slice(mapFrom).map(pos + 1 + offset + m.index);
                tr.replaceWith(start, start + 1, node.type.schema.linebreakReplacement.create());
            }
        }
    });
}
function $f7cb452bf977726e$var$replaceLinebreaks(tr, node, pos, mapFrom) {
    node.forEach((child, offset)=>{
        if (child.type == child.type.schema.linebreakReplacement) {
            let start = tr.mapping.slice(mapFrom).map(pos + 1 + offset);
            tr.replaceWith(start, start + 1, node.type.schema.text("\n"));
        }
    });
}
function $f7cb452bf977726e$var$canChangeType(doc, pos, type) {
    let $pos = doc.resolve(pos), index = $pos.index();
    return $pos.parent.canReplaceWith(index, index + 1, type);
}
/**
Change the type, attributes, and/or marks of the node at `pos`.
When `type` isn't given, the existing node type is preserved,
*/ function $f7cb452bf977726e$var$setNodeMarkup(tr, pos, type, attrs, marks) {
    let node = tr.doc.nodeAt(pos);
    if (!node) throw new RangeError("No node at given position");
    if (!type) type = node.type;
    let newNode = type.create(attrs, null, marks || node.marks);
    if (node.isLeaf) return tr.replaceWith(pos, pos + node.nodeSize, newNode);
    if (!type.validContent(node.content)) throw new RangeError("Invalid content for node type " + type.name);
    tr.step(new $f7cb452bf977726e$export$444ba800d6024a98(pos, pos + node.nodeSize, pos + 1, pos + node.nodeSize - 1, new (0, $9Jwkl.Slice)((0, $9Jwkl.Fragment).from(newNode), 0, 0), 1, true));
}
/**
Check whether splitting at the given position is allowed.
*/ function $f7cb452bf977726e$export$5aaf008897aef029(doc, pos, depth = 1, typesAfter) {
    let $pos = doc.resolve(pos), base = $pos.depth - depth;
    let innerType = typesAfter && typesAfter[typesAfter.length - 1] || $pos.parent;
    if (base < 0 || $pos.parent.type.spec.isolating || !$pos.parent.canReplace($pos.index(), $pos.parent.childCount) || !innerType.type.validContent($pos.parent.content.cutByIndex($pos.index(), $pos.parent.childCount))) return false;
    for(let d = $pos.depth - 1, i = depth - 2; d > base; d--, i--){
        let node = $pos.node(d), index = $pos.index(d);
        if (node.type.spec.isolating) return false;
        let rest = node.content.cutByIndex(index, node.childCount);
        let overrideChild = typesAfter && typesAfter[i + 1];
        if (overrideChild) rest = rest.replaceChild(0, overrideChild.type.create(overrideChild.attrs));
        let after = typesAfter && typesAfter[i] || node;
        if (!node.canReplace(index + 1, node.childCount) || !after.type.validContent(rest)) return false;
    }
    let index = $pos.indexAfter(base);
    let baseType = typesAfter && typesAfter[0];
    return $pos.node(base).canReplaceWith(index, index, baseType ? baseType.type : $pos.node(base + 1).type);
}
function $f7cb452bf977726e$var$split(tr, pos, depth = 1, typesAfter) {
    let $pos = tr.doc.resolve(pos), before = (0, $9Jwkl.Fragment).empty, after = (0, $9Jwkl.Fragment).empty;
    for(let d = $pos.depth, e = $pos.depth - depth, i = depth - 1; d > e; d--, i--){
        before = (0, $9Jwkl.Fragment).from($pos.node(d).copy(before));
        let typeAfter = typesAfter && typesAfter[i];
        after = (0, $9Jwkl.Fragment).from(typeAfter ? typeAfter.type.create(typeAfter.attrs, after) : $pos.node(d).copy(after));
    }
    tr.step(new $f7cb452bf977726e$export$5c860b2e74034756(pos, pos, new (0, $9Jwkl.Slice)(before.append(after), depth, depth), true));
}
/**
Test whether the blocks before and after a given position can be
joined.
*/ function $f7cb452bf977726e$export$f15f89fd9d8cc98a(doc, pos) {
    let $pos = doc.resolve(pos), index = $pos.index();
    return $f7cb452bf977726e$var$joinable($pos.nodeBefore, $pos.nodeAfter) && $pos.parent.canReplace(index, index + 1);
}
function $f7cb452bf977726e$var$canAppendWithSubstitutedLinebreaks(a, b) {
    if (!b.content.size) a.type.compatibleContent(b.type);
    let match = a.contentMatchAt(a.childCount);
    let { linebreakReplacement: linebreakReplacement } = a.type.schema;
    for(let i = 0; i < b.childCount; i++){
        let child = b.child(i);
        let type = child.type == linebreakReplacement ? a.type.schema.nodes.text : child.type;
        match = match.matchType(type);
        if (!match) return false;
        if (!a.type.allowsMarks(child.marks)) return false;
    }
    return match.validEnd;
}
function $f7cb452bf977726e$var$joinable(a, b) {
    return !!(a && b && !a.isLeaf && $f7cb452bf977726e$var$canAppendWithSubstitutedLinebreaks(a, b));
}
/**
Find an ancestor of the given position that can be joined to the
block before (or after if `dir` is positive). Returns the joinable
point, if any.
*/ function $f7cb452bf977726e$export$41b1d4cb5ceb3147(doc, pos, dir = -1) {
    let $pos = doc.resolve(pos);
    for(let d = $pos.depth;; d--){
        let before, after, index = $pos.index(d);
        if (d == $pos.depth) {
            before = $pos.nodeBefore;
            after = $pos.nodeAfter;
        } else if (dir > 0) {
            before = $pos.node(d + 1);
            index++;
            after = $pos.node(d).maybeChild(index);
        } else {
            before = $pos.node(d).maybeChild(index - 1);
            after = $pos.node(d + 1);
        }
        if (before && !before.isTextblock && $f7cb452bf977726e$var$joinable(before, after) && $pos.node(d).canReplace(index, index + 1)) return pos;
        if (d == 0) break;
        pos = dir < 0 ? $pos.before(d) : $pos.after(d);
    }
}
function $f7cb452bf977726e$var$join(tr, pos, depth) {
    let convertNewlines = null;
    let { linebreakReplacement: linebreakReplacement } = tr.doc.type.schema;
    let $before = tr.doc.resolve(pos - depth), beforeType = $before.node().type;
    if (linebreakReplacement && beforeType.inlineContent) {
        let pre = beforeType.whitespace == "pre";
        let supportLinebreak = !!beforeType.contentMatch.matchType(linebreakReplacement);
        if (pre && !supportLinebreak) convertNewlines = false;
        else if (!pre && supportLinebreak) convertNewlines = true;
    }
    let mapFrom = tr.steps.length;
    if (convertNewlines === false) {
        let $after = tr.doc.resolve(pos + depth);
        $f7cb452bf977726e$var$replaceLinebreaks(tr, $after.node(), $after.before(), mapFrom);
    }
    if (beforeType.inlineContent) $f7cb452bf977726e$var$clearIncompatible(tr, pos + depth - 1, beforeType, $before.node().contentMatchAt($before.index()), convertNewlines == null);
    let mapping = tr.mapping.slice(mapFrom), start = mapping.map(pos - depth);
    tr.step(new $f7cb452bf977726e$export$5c860b2e74034756(start, mapping.map(pos + depth, -1), (0, $9Jwkl.Slice).empty, true));
    if (convertNewlines === true) {
        let $full = tr.doc.resolve(start);
        $f7cb452bf977726e$var$replaceNewlines(tr, $full.node(), $full.before(), tr.steps.length);
    }
    return tr;
}
/**
Try to find a point where a node of the given type can be inserted
near `pos`, by searching up the node hierarchy when `pos` itself
isn't a valid place but is at the start or end of a node. Return
null if no position was found.
*/ function $f7cb452bf977726e$export$64cb316d02de1dd1(doc, pos, nodeType) {
    let $pos = doc.resolve(pos);
    if ($pos.parent.canReplaceWith($pos.index(), $pos.index(), nodeType)) return pos;
    if ($pos.parentOffset == 0) for(let d = $pos.depth - 1; d >= 0; d--){
        let index = $pos.index(d);
        if ($pos.node(d).canReplaceWith(index, index, nodeType)) return $pos.before(d + 1);
        if (index > 0) return null;
    }
    if ($pos.parentOffset == $pos.parent.content.size) for(let d = $pos.depth - 1; d >= 0; d--){
        let index = $pos.indexAfter(d);
        if ($pos.node(d).canReplaceWith(index, index, nodeType)) return $pos.after(d + 1);
        if (index < $pos.node(d).childCount) return null;
    }
    return null;
}
/**
Finds a position at or around the given position where the given
slice can be inserted. Will look at parent nodes' nearest boundary
and try there, even if the original position wasn't directly at the
start or end of that node. Returns null when no position was found.
*/ function $f7cb452bf977726e$export$2819d598d048fc9c(doc, pos, slice) {
    let $pos = doc.resolve(pos);
    if (!slice.content.size) return pos;
    let content = slice.content;
    for(let i = 0; i < slice.openStart; i++)content = content.firstChild.content;
    for(let pass = 1; pass <= (slice.openStart == 0 && slice.size ? 2 : 1); pass++)for(let d = $pos.depth; d >= 0; d--){
        let bias = d == $pos.depth ? 0 : $pos.pos <= ($pos.start(d + 1) + $pos.end(d + 1)) / 2 ? -1 : 1;
        let insertPos = $pos.index(d) + (bias > 0 ? 1 : 0);
        let parent = $pos.node(d), fits = false;
        if (pass == 1) fits = parent.canReplace(insertPos, insertPos, content);
        else {
            let wrapping = parent.contentMatchAt(insertPos).findWrapping(content.firstChild.type);
            fits = wrapping && parent.canReplaceWith(insertPos, insertPos, wrapping[0]);
        }
        if (fits) return bias == 0 ? $pos.pos : bias < 0 ? $pos.before(d + 1) : $pos.after(d + 1);
    }
    return null;
}
/**
‘Fit’ a slice into a given position in the document, producing a
[step](https://prosemirror.net/docs/ref/#transform.Step) that inserts it. Will return null if
there's no meaningful way to insert the slice here, or inserting it
would be a no-op (an empty slice over an empty range).
*/ function $f7cb452bf977726e$export$ed6ac67359824afd(doc, from, to = from, slice = (0, $9Jwkl.Slice).empty) {
    if (from == to && !slice.size) return null;
    let $from = doc.resolve(from), $to = doc.resolve(to);
    // Optimization -- avoid work if it's obvious that it's not needed.
    if ($f7cb452bf977726e$var$fitsTrivially($from, $to, slice)) return new $f7cb452bf977726e$export$5c860b2e74034756(from, to, slice);
    return new $f7cb452bf977726e$var$Fitter($from, $to, slice).fit();
}
function $f7cb452bf977726e$var$fitsTrivially($from, $to, slice) {
    return !slice.openStart && !slice.openEnd && $from.start() == $to.start() && $from.parent.canReplace($from.index(), $to.index(), slice.content);
}
// Algorithm for 'placing' the elements of a slice into a gap:
//
// We consider the content of each node that is open to the left to be
// independently placeable. I.e. in <p("foo"), p("bar")>, when the
// paragraph on the left is open, "foo" can be placed (somewhere on
// the left side of the replacement gap) independently from p("bar").
//
// This class tracks the state of the placement progress in the
// following properties:
//
//  - `frontier` holds a stack of `{type, match}` objects that
//    represent the open side of the replacement. It starts at
//    `$from`, then moves forward as content is placed, and is finally
//    reconciled with `$to`.
//
//  - `unplaced` is a slice that represents the content that hasn't
//    been placed yet.
//
//  - `placed` is a fragment of placed content. Its open-start value
//    is implicit in `$from`, and its open-end value in `frontier`.
class $f7cb452bf977726e$var$Fitter {
    constructor($from, $to, unplaced){
        this.$from = $from;
        this.$to = $to;
        this.unplaced = unplaced;
        this.frontier = [];
        this.placed = (0, $9Jwkl.Fragment).empty;
        for(let i = 0; i <= $from.depth; i++){
            let node = $from.node(i);
            this.frontier.push({
                type: node.type,
                match: node.contentMatchAt($from.indexAfter(i))
            });
        }
        for(let i = $from.depth; i > 0; i--)this.placed = (0, $9Jwkl.Fragment).from($from.node(i).copy(this.placed));
    }
    get depth() {
        return this.frontier.length - 1;
    }
    fit() {
        // As long as there's unplaced content, try to place some of it.
        // If that fails, either increase the open score of the unplaced
        // slice, or drop nodes from it, and then try again.
        while(this.unplaced.size){
            let fit = this.findFittable();
            if (fit) this.placeNodes(fit);
            else this.openMore() || this.dropNode();
        }
        // When there's inline content directly after the frontier _and_
        // directly after `this.$to`, we must generate a `ReplaceAround`
        // step that pulls that content into the node after the frontier.
        // That means the fitting must be done to the end of the textblock
        // node after `this.$to`, not `this.$to` itself.
        let moveInline = this.mustMoveInline(), placedSize = this.placed.size - this.depth - this.$from.depth;
        let $from = this.$from, $to = this.close(moveInline < 0 ? this.$to : $from.doc.resolve(moveInline));
        if (!$to) return null;
        // If closing to `$to` succeeded, create a step
        let content = this.placed, openStart = $from.depth, openEnd = $to.depth;
        while(openStart && openEnd && content.childCount == 1){
            content = content.firstChild.content;
            openStart--;
            openEnd--;
        }
        let slice = new (0, $9Jwkl.Slice)(content, openStart, openEnd);
        if (moveInline > -1) return new $f7cb452bf977726e$export$444ba800d6024a98($from.pos, moveInline, this.$to.pos, this.$to.end(), slice, placedSize);
        if (slice.size || $from.pos != this.$to.pos) return new $f7cb452bf977726e$export$5c860b2e74034756($from.pos, $to.pos, slice);
        return null;
    }
    // Find a position on the start spine of `this.unplaced` that has
    // content that can be moved somewhere on the frontier. Returns two
    // depths, one for the slice and one for the frontier.
    findFittable() {
        let startDepth = this.unplaced.openStart;
        for(let cur = this.unplaced.content, d = 0, openEnd = this.unplaced.openEnd; d < startDepth; d++){
            let node = cur.firstChild;
            if (cur.childCount > 1) openEnd = 0;
            if (node.type.spec.isolating && openEnd <= d) {
                startDepth = d;
                break;
            }
            cur = node.content;
        }
        // Only try wrapping nodes (pass 2) after finding a place without
        // wrapping failed.
        for(let pass = 1; pass <= 2; pass++)for(let sliceDepth = pass == 1 ? startDepth : this.unplaced.openStart; sliceDepth >= 0; sliceDepth--){
            let fragment, parent = null;
            if (sliceDepth) {
                parent = $f7cb452bf977726e$var$contentAt(this.unplaced.content, sliceDepth - 1).firstChild;
                fragment = parent.content;
            } else fragment = this.unplaced.content;
            let first = fragment.firstChild;
            for(let frontierDepth = this.depth; frontierDepth >= 0; frontierDepth--){
                let { type: type, match: match } = this.frontier[frontierDepth], wrap, inject = null;
                // In pass 1, if the next node matches, or there is no next
                // node but the parents look compatible, we've found a
                // place.
                if (pass == 1 && (first ? match.matchType(first.type) || (inject = match.fillBefore((0, $9Jwkl.Fragment).from(first), false)) : parent && type.compatibleContent(parent.type))) return {
                    sliceDepth: sliceDepth,
                    frontierDepth: frontierDepth,
                    parent: parent,
                    inject: inject
                };
                else if (pass == 2 && first && (wrap = match.findWrapping(first.type))) return {
                    sliceDepth: sliceDepth,
                    frontierDepth: frontierDepth,
                    parent: parent,
                    wrap: wrap
                };
                // Don't continue looking further up if the parent node
                // would fit here.
                if (parent && match.matchType(parent.type)) break;
            }
        }
    }
    openMore() {
        let { content: content, openStart: openStart, openEnd: openEnd } = this.unplaced;
        let inner = $f7cb452bf977726e$var$contentAt(content, openStart);
        if (!inner.childCount || inner.firstChild.isLeaf) return false;
        this.unplaced = new (0, $9Jwkl.Slice)(content, openStart + 1, Math.max(openEnd, inner.size + openStart >= content.size - openEnd ? openStart + 1 : 0));
        return true;
    }
    dropNode() {
        let { content: content, openStart: openStart, openEnd: openEnd } = this.unplaced;
        let inner = $f7cb452bf977726e$var$contentAt(content, openStart);
        if (inner.childCount <= 1 && openStart > 0) {
            let openAtEnd = content.size - openStart <= openStart + inner.size;
            this.unplaced = new (0, $9Jwkl.Slice)($f7cb452bf977726e$var$dropFromFragment(content, openStart - 1, 1), openStart - 1, openAtEnd ? openStart - 1 : openEnd);
        } else this.unplaced = new (0, $9Jwkl.Slice)($f7cb452bf977726e$var$dropFromFragment(content, openStart, 1), openStart, openEnd);
    }
    // Move content from the unplaced slice at `sliceDepth` to the
    // frontier node at `frontierDepth`. Close that frontier node when
    // applicable.
    placeNodes({ sliceDepth: sliceDepth, frontierDepth: frontierDepth, parent: parent, inject: inject, wrap: wrap }) {
        while(this.depth > frontierDepth)this.closeFrontierNode();
        if (wrap) for(let i = 0; i < wrap.length; i++)this.openFrontierNode(wrap[i]);
        let slice = this.unplaced, fragment = parent ? parent.content : slice.content;
        let openStart = slice.openStart - sliceDepth;
        let taken = 0, add = [];
        let { match: match, type: type } = this.frontier[frontierDepth];
        if (inject) {
            for(let i = 0; i < inject.childCount; i++)add.push(inject.child(i));
            match = match.matchFragment(inject);
        }
        // Computes the amount of (end) open nodes at the end of the
        // fragment. When 0, the parent is open, but no more. When
        // negative, nothing is open.
        let openEndCount = fragment.size + sliceDepth - (slice.content.size - slice.openEnd);
        // Scan over the fragment, fitting as many child nodes as
        // possible.
        while(taken < fragment.childCount){
            let next = fragment.child(taken), matches = match.matchType(next.type);
            if (!matches) break;
            taken++;
            if (taken > 1 || openStart == 0 || next.content.size) {
                match = matches;
                add.push($f7cb452bf977726e$var$closeNodeStart(next.mark(type.allowedMarks(next.marks)), taken == 1 ? openStart : 0, taken == fragment.childCount ? openEndCount : -1));
            }
        }
        let toEnd = taken == fragment.childCount;
        if (!toEnd) openEndCount = -1;
        this.placed = $f7cb452bf977726e$var$addToFragment(this.placed, frontierDepth, (0, $9Jwkl.Fragment).from(add));
        this.frontier[frontierDepth].match = match;
        // If the parent types match, and the entire node was moved, and
        // it's not open, close this frontier node right away.
        if (toEnd && openEndCount < 0 && parent && parent.type == this.frontier[this.depth].type && this.frontier.length > 1) this.closeFrontierNode();
        // Add new frontier nodes for any open nodes at the end.
        for(let i = 0, cur = fragment; i < openEndCount; i++){
            let node = cur.lastChild;
            this.frontier.push({
                type: node.type,
                match: node.contentMatchAt(node.childCount)
            });
            cur = node.content;
        }
        // Update `this.unplaced`. Drop the entire node from which we
        // placed it we got to its end, otherwise just drop the placed
        // nodes.
        this.unplaced = !toEnd ? new (0, $9Jwkl.Slice)($f7cb452bf977726e$var$dropFromFragment(slice.content, sliceDepth, taken), slice.openStart, slice.openEnd) : sliceDepth == 0 ? (0, $9Jwkl.Slice).empty : new (0, $9Jwkl.Slice)($f7cb452bf977726e$var$dropFromFragment(slice.content, sliceDepth - 1, 1), sliceDepth - 1, openEndCount < 0 ? slice.openEnd : sliceDepth - 1);
    }
    mustMoveInline() {
        if (!this.$to.parent.isTextblock) return -1;
        let top = this.frontier[this.depth], level;
        if (!top.type.isTextblock || !$f7cb452bf977726e$var$contentAfterFits(this.$to, this.$to.depth, top.type, top.match, false) || this.$to.depth == this.depth && (level = this.findCloseLevel(this.$to)) && level.depth == this.depth) return -1;
        let { depth: depth } = this.$to, after = this.$to.after(depth);
        while(depth > 1 && after == this.$to.end(--depth))++after;
        return after;
    }
    findCloseLevel($to) {
        scan: for(let i = Math.min(this.depth, $to.depth); i >= 0; i--){
            let { match: match, type: type } = this.frontier[i];
            let dropInner = i < $to.depth && $to.end(i + 1) == $to.pos + ($to.depth - (i + 1));
            let fit = $f7cb452bf977726e$var$contentAfterFits($to, i, type, match, dropInner);
            if (!fit) continue;
            for(let d = i - 1; d >= 0; d--){
                let { match: match, type: type } = this.frontier[d];
                let matches = $f7cb452bf977726e$var$contentAfterFits($to, d, type, match, true);
                if (!matches || matches.childCount) continue scan;
            }
            return {
                depth: i,
                fit: fit,
                move: dropInner ? $to.doc.resolve($to.after(i + 1)) : $to
            };
        }
    }
    close($to) {
        let close = this.findCloseLevel($to);
        if (!close) return null;
        while(this.depth > close.depth)this.closeFrontierNode();
        if (close.fit.childCount) this.placed = $f7cb452bf977726e$var$addToFragment(this.placed, close.depth, close.fit);
        $to = close.move;
        for(let d = close.depth + 1; d <= $to.depth; d++){
            let node = $to.node(d), add = node.type.contentMatch.fillBefore(node.content, true, $to.index(d));
            this.openFrontierNode(node.type, node.attrs, add);
        }
        return $to;
    }
    openFrontierNode(type, attrs = null, content) {
        let top = this.frontier[this.depth];
        top.match = top.match.matchType(type);
        this.placed = $f7cb452bf977726e$var$addToFragment(this.placed, this.depth, (0, $9Jwkl.Fragment).from(type.create(attrs, content)));
        this.frontier.push({
            type: type,
            match: type.contentMatch
        });
    }
    closeFrontierNode() {
        let open = this.frontier.pop();
        let add = open.match.fillBefore((0, $9Jwkl.Fragment).empty, true);
        if (add.childCount) this.placed = $f7cb452bf977726e$var$addToFragment(this.placed, this.frontier.length, add);
    }
}
function $f7cb452bf977726e$var$dropFromFragment(fragment, depth, count) {
    if (depth == 0) return fragment.cutByIndex(count, fragment.childCount);
    return fragment.replaceChild(0, fragment.firstChild.copy($f7cb452bf977726e$var$dropFromFragment(fragment.firstChild.content, depth - 1, count)));
}
function $f7cb452bf977726e$var$addToFragment(fragment, depth, content) {
    if (depth == 0) return fragment.append(content);
    return fragment.replaceChild(fragment.childCount - 1, fragment.lastChild.copy($f7cb452bf977726e$var$addToFragment(fragment.lastChild.content, depth - 1, content)));
}
function $f7cb452bf977726e$var$contentAt(fragment, depth) {
    for(let i = 0; i < depth; i++)fragment = fragment.firstChild.content;
    return fragment;
}
function $f7cb452bf977726e$var$closeNodeStart(node, openStart, openEnd) {
    if (openStart <= 0) return node;
    let frag = node.content;
    if (openStart > 1) frag = frag.replaceChild(0, $f7cb452bf977726e$var$closeNodeStart(frag.firstChild, openStart - 1, frag.childCount == 1 ? openEnd - 1 : 0));
    if (openStart > 0) {
        frag = node.type.contentMatch.fillBefore(frag).append(frag);
        if (openEnd <= 0) frag = frag.append(node.type.contentMatch.matchFragment(frag).fillBefore((0, $9Jwkl.Fragment).empty, true));
    }
    return node.copy(frag);
}
function $f7cb452bf977726e$var$contentAfterFits($to, depth, type, match, open) {
    let node = $to.node(depth), index = open ? $to.indexAfter(depth) : $to.index(depth);
    if (index == node.childCount && !type.compatibleContent(node.type)) return null;
    let fit = match.fillBefore(node.content, true, index);
    return fit && !$f7cb452bf977726e$var$invalidMarks(type, node.content, index) ? fit : null;
}
function $f7cb452bf977726e$var$invalidMarks(type, fragment, start) {
    for(let i = start; i < fragment.childCount; i++)if (!type.allowsMarks(fragment.child(i).marks)) return true;
    return false;
}
function $f7cb452bf977726e$var$definesContent(type) {
    return type.spec.defining || type.spec.definingForContent;
}
function $f7cb452bf977726e$var$replaceRange(tr, from, to, slice) {
    if (!slice.size) return tr.deleteRange(from, to);
    let $from = tr.doc.resolve(from), $to = tr.doc.resolve(to);
    if ($f7cb452bf977726e$var$fitsTrivially($from, $to, slice)) return tr.step(new $f7cb452bf977726e$export$5c860b2e74034756(from, to, slice));
    let targetDepths = $f7cb452bf977726e$var$coveredDepths($from, $to);
    // Can't replace the whole document, so remove 0 if it's present
    if (targetDepths[targetDepths.length - 1] == 0) targetDepths.pop();
    // Negative numbers represent not expansion over the whole node at
    // that depth, but replacing from $from.before(-D) to $to.pos.
    let preferredTarget = -($from.depth + 1);
    targetDepths.unshift(preferredTarget);
    // This loop picks a preferred target depth, if one of the covering
    // depths is not outside of a defining node, and adds negative
    // depths for any depth that has $from at its start and does not
    // cross a defining node.
    for(let d = $from.depth, pos = $from.pos - 1; d > 0; d--, pos--){
        let spec = $from.node(d).type.spec;
        if (spec.defining || spec.definingAsContext || spec.isolating) break;
        if (targetDepths.indexOf(d) > -1) preferredTarget = d;
        else if ($from.before(d) == pos) targetDepths.splice(1, 0, -d);
    }
    // Try to fit each possible depth of the slice into each possible
    // target depth, starting with the preferred depths.
    let preferredTargetIndex = targetDepths.indexOf(preferredTarget);
    let leftNodes = [], preferredDepth = slice.openStart;
    for(let content = slice.content, i = 0;; i++){
        let node = content.firstChild;
        leftNodes.push(node);
        if (i == slice.openStart) break;
        content = node.content;
    }
    // Back up preferredDepth to cover defining textblocks directly
    // above it, possibly skipping a non-defining textblock.
    for(let d = preferredDepth - 1; d >= 0; d--){
        let leftNode = leftNodes[d], def = $f7cb452bf977726e$var$definesContent(leftNode.type);
        if (def && !leftNode.sameMarkup($from.node(Math.abs(preferredTarget) - 1))) preferredDepth = d;
        else if (def || !leftNode.type.isTextblock) break;
    }
    for(let j = slice.openStart; j >= 0; j--){
        let openDepth = (j + preferredDepth + 1) % (slice.openStart + 1);
        let insert = leftNodes[openDepth];
        if (!insert) continue;
        for(let i = 0; i < targetDepths.length; i++){
            // Loop over possible expansion levels, starting with the
            // preferred one
            let targetDepth = targetDepths[(i + preferredTargetIndex) % targetDepths.length], expand = true;
            if (targetDepth < 0) {
                expand = false;
                targetDepth = -targetDepth;
            }
            let parent = $from.node(targetDepth - 1), index = $from.index(targetDepth - 1);
            if (parent.canReplaceWith(index, index, insert.type, insert.marks)) return tr.replace($from.before(targetDepth), expand ? $to.after(targetDepth) : to, new (0, $9Jwkl.Slice)($f7cb452bf977726e$var$closeFragment(slice.content, 0, slice.openStart, openDepth), openDepth, slice.openEnd));
        }
    }
    let startSteps = tr.steps.length;
    for(let i = targetDepths.length - 1; i >= 0; i--){
        tr.replace(from, to, slice);
        if (tr.steps.length > startSteps) break;
        let depth = targetDepths[i];
        if (depth < 0) continue;
        from = $from.before(depth);
        to = $to.after(depth);
    }
}
function $f7cb452bf977726e$var$closeFragment(fragment, depth, oldOpen, newOpen, parent) {
    if (depth < oldOpen) {
        let first = fragment.firstChild;
        fragment = fragment.replaceChild(0, first.copy($f7cb452bf977726e$var$closeFragment(first.content, depth + 1, oldOpen, newOpen, first)));
    }
    if (depth > newOpen) {
        let match = parent.contentMatchAt(0);
        let start = match.fillBefore(fragment).append(fragment);
        fragment = start.append(match.matchFragment(start).fillBefore((0, $9Jwkl.Fragment).empty, true));
    }
    return fragment;
}
function $f7cb452bf977726e$var$replaceRangeWith(tr, from, to, node) {
    if (!node.isInline && from == to && tr.doc.resolve(from).parent.content.size) {
        let point = $f7cb452bf977726e$export$64cb316d02de1dd1(tr.doc, from, node.type);
        if (point != null) from = to = point;
    }
    tr.replaceRange(from, to, new (0, $9Jwkl.Slice)((0, $9Jwkl.Fragment).from(node), 0, 0));
}
function $f7cb452bf977726e$var$deleteRange(tr, from, to) {
    let $from = tr.doc.resolve(from), $to = tr.doc.resolve(to);
    let covered = $f7cb452bf977726e$var$coveredDepths($from, $to);
    for(let i = 0; i < covered.length; i++){
        let depth = covered[i], last = i == covered.length - 1;
        if (last && depth == 0 || $from.node(depth).type.contentMatch.validEnd) return tr.delete($from.start(depth), $to.end(depth));
        if (depth > 0 && (last || $from.node(depth - 1).canReplace($from.index(depth - 1), $to.indexAfter(depth - 1)))) return tr.delete($from.before(depth), $to.after(depth));
    }
    for(let d = 1; d <= $from.depth && d <= $to.depth; d++){
        if (from - $from.start(d) == $from.depth - d && to > $from.end(d) && $to.end(d) - to != $to.depth - d && $from.start(d - 1) == $to.start(d - 1) && $from.node(d - 1).canReplace($from.index(d - 1), $to.index(d - 1))) return tr.delete($from.before(d), to);
    }
    tr.delete(from, to);
}
// Returns an array of all depths for which $from - $to spans the
// whole content of the nodes at that depth.
function $f7cb452bf977726e$var$coveredDepths($from, $to) {
    let result = [], minDepth = Math.min($from.depth, $to.depth);
    for(let d = minDepth; d >= 0; d--){
        let start = $from.start(d);
        if (start < $from.pos - ($from.depth - d) || $to.end(d) > $to.pos + ($to.depth - d) || $from.node(d).type.spec.isolating || $to.node(d).type.spec.isolating) break;
        if (start == $to.start(d) || d == $from.depth && d == $to.depth && $from.parent.inlineContent && $to.parent.inlineContent && d && $to.start(d - 1) == start - 1) result.push(d);
    }
    return result;
}
/**
Update an attribute in a specific node.
*/ class $f7cb452bf977726e$export$626399c38172f669 extends $f7cb452bf977726e$export$fd55ce593607084a {
    /**
    Construct an attribute step.
    */ constructor(/**
    The position of the target node.
    */ pos, /**
    The attribute to set.
    */ attr, // The attribute's new value.
    value){
        super();
        this.pos = pos;
        this.attr = attr;
        this.value = value;
    }
    apply(doc) {
        let node = doc.nodeAt(this.pos);
        if (!node) return $f7cb452bf977726e$export$8ebf1578a4199c09.fail("No node at attribute step's position");
        let attrs = Object.create(null);
        for(let name in node.attrs)attrs[name] = node.attrs[name];
        attrs[this.attr] = this.value;
        let updated = node.type.create(attrs, null, node.marks);
        return $f7cb452bf977726e$export$8ebf1578a4199c09.fromReplace(doc, this.pos, this.pos + 1, new (0, $9Jwkl.Slice)((0, $9Jwkl.Fragment).from(updated), 0, node.isLeaf ? 0 : 1));
    }
    getMap() {
        return $f7cb452bf977726e$export$c53d01c3ab9721b3.empty;
    }
    invert(doc) {
        return new $f7cb452bf977726e$export$626399c38172f669(this.pos, this.attr, doc.nodeAt(this.pos).attrs[this.attr]);
    }
    map(mapping) {
        let pos = mapping.mapResult(this.pos, 1);
        return pos.deletedAfter ? null : new $f7cb452bf977726e$export$626399c38172f669(pos.pos, this.attr, this.value);
    }
    toJSON() {
        return {
            stepType: "attr",
            pos: this.pos,
            attr: this.attr,
            value: this.value
        };
    }
    static fromJSON(schema, json) {
        if (typeof json.pos != "number" || typeof json.attr != "string") throw new RangeError("Invalid input for AttrStep.fromJSON");
        return new $f7cb452bf977726e$export$626399c38172f669(json.pos, json.attr, json.value);
    }
}
$f7cb452bf977726e$export$fd55ce593607084a.jsonID("attr", $f7cb452bf977726e$export$626399c38172f669);
/**
Update an attribute in the doc node.
*/ class $f7cb452bf977726e$export$f50707b396300ac9 extends $f7cb452bf977726e$export$fd55ce593607084a {
    /**
    Construct an attribute step.
    */ constructor(/**
    The attribute to set.
    */ attr, // The attribute's new value.
    value){
        super();
        this.attr = attr;
        this.value = value;
    }
    apply(doc) {
        let attrs = Object.create(null);
        for(let name in doc.attrs)attrs[name] = doc.attrs[name];
        attrs[this.attr] = this.value;
        let updated = doc.type.create(attrs, doc.content, doc.marks);
        return $f7cb452bf977726e$export$8ebf1578a4199c09.ok(updated);
    }
    getMap() {
        return $f7cb452bf977726e$export$c53d01c3ab9721b3.empty;
    }
    invert(doc) {
        return new $f7cb452bf977726e$export$f50707b396300ac9(this.attr, doc.attrs[this.attr]);
    }
    map(mapping) {
        return this;
    }
    toJSON() {
        return {
            stepType: "docAttr",
            attr: this.attr,
            value: this.value
        };
    }
    static fromJSON(schema, json) {
        if (typeof json.attr != "string") throw new RangeError("Invalid input for DocAttrStep.fromJSON");
        return new $f7cb452bf977726e$export$f50707b396300ac9(json.attr, json.value);
    }
}
$f7cb452bf977726e$export$fd55ce593607084a.jsonID("docAttr", $f7cb452bf977726e$export$f50707b396300ac9);
/**
@internal
*/ let $f7cb452bf977726e$export$88cc3a1dfce48dd3 = class extends Error {
};
$f7cb452bf977726e$export$88cc3a1dfce48dd3 = function TransformError(message) {
    let err = Error.call(this, message);
    err.__proto__ = TransformError.prototype;
    return err;
};
$f7cb452bf977726e$export$88cc3a1dfce48dd3.prototype = Object.create(Error.prototype);
$f7cb452bf977726e$export$88cc3a1dfce48dd3.prototype.constructor = $f7cb452bf977726e$export$88cc3a1dfce48dd3;
$f7cb452bf977726e$export$88cc3a1dfce48dd3.prototype.name = "TransformError";
/**
Abstraction to build up and track an array of
[steps](https://prosemirror.net/docs/ref/#transform.Step) representing a document transformation.

Most transforming methods return the `Transform` object itself, so
that they can be chained.
*/ class $f7cb452bf977726e$export$563a914cafbdc389 {
    /**
    Create a transform that starts with the given document.
    */ constructor(/**
    The current document (the result of applying the steps in the
    transform).
    */ doc){
        this.doc = doc;
        /**
        The steps in this transform.
        */ this.steps = [];
        /**
        The documents before each of the steps.
        */ this.docs = [];
        /**
        A mapping with the maps for each of the steps in this transform.
        */ this.mapping = new $f7cb452bf977726e$export$f5f785078011b62;
    }
    /**
    The starting document.
    */ get before() {
        return this.docs.length ? this.docs[0] : this.doc;
    }
    /**
    Apply a new step in this transform, saving the result. Throws an
    error when the step fails.
    */ step(step) {
        let result = this.maybeStep(step);
        if (result.failed) throw new $f7cb452bf977726e$export$88cc3a1dfce48dd3(result.failed);
        return this;
    }
    /**
    Try to apply a step in this transformation, ignoring it if it
    fails. Returns the step result.
    */ maybeStep(step) {
        let result = step.apply(this.doc);
        if (!result.failed) this.addStep(step, result.doc);
        return result;
    }
    /**
    True when the document has been changed (when there are any
    steps).
    */ get docChanged() {
        return this.steps.length > 0;
    }
    /**
    @internal
    */ addStep(step, doc) {
        this.docs.push(this.doc);
        this.steps.push(step);
        this.mapping.appendMap(step.getMap());
        this.doc = doc;
    }
    /**
    Replace the part of the document between `from` and `to` with the
    given `slice`.
    */ replace(from, to = from, slice = (0, $9Jwkl.Slice).empty) {
        let step = $f7cb452bf977726e$export$ed6ac67359824afd(this.doc, from, to, slice);
        if (step) this.step(step);
        return this;
    }
    /**
    Replace the given range with the given content, which may be a
    fragment, node, or array of nodes.
    */ replaceWith(from, to, content) {
        return this.replace(from, to, new (0, $9Jwkl.Slice)((0, $9Jwkl.Fragment).from(content), 0, 0));
    }
    /**
    Delete the content between the given positions.
    */ delete(from, to) {
        return this.replace(from, to, (0, $9Jwkl.Slice).empty);
    }
    /**
    Insert the given content at the given position.
    */ insert(pos, content) {
        return this.replaceWith(pos, pos, content);
    }
    /**
    Replace a range of the document with a given slice, using
    `from`, `to`, and the slice's
    [`openStart`](https://prosemirror.net/docs/ref/#model.Slice.openStart) property as hints, rather
    than fixed start and end points. This method may grow the
    replaced area or close open nodes in the slice in order to get a
    fit that is more in line with WYSIWYG expectations, by dropping
    fully covered parent nodes of the replaced region when they are
    marked [non-defining as
    context](https://prosemirror.net/docs/ref/#model.NodeSpec.definingAsContext), or including an
    open parent node from the slice that _is_ marked as [defining
    its content](https://prosemirror.net/docs/ref/#model.NodeSpec.definingForContent).
    
    This is the method, for example, to handle paste. The similar
    [`replace`](https://prosemirror.net/docs/ref/#transform.Transform.replace) method is a more
    primitive tool which will _not_ move the start and end of its given
    range, and is useful in situations where you need more precise
    control over what happens.
    */ replaceRange(from, to, slice) {
        $f7cb452bf977726e$var$replaceRange(this, from, to, slice);
        return this;
    }
    /**
    Replace the given range with a node, but use `from` and `to` as
    hints, rather than precise positions. When from and to are the same
    and are at the start or end of a parent node in which the given
    node doesn't fit, this method may _move_ them out towards a parent
    that does allow the given node to be placed. When the given range
    completely covers a parent node, this method may completely replace
    that parent node.
    */ replaceRangeWith(from, to, node) {
        $f7cb452bf977726e$var$replaceRangeWith(this, from, to, node);
        return this;
    }
    /**
    Delete the given range, expanding it to cover fully covered
    parent nodes until a valid replace is found.
    */ deleteRange(from, to) {
        $f7cb452bf977726e$var$deleteRange(this, from, to);
        return this;
    }
    /**
    Split the content in the given range off from its parent, if there
    is sibling content before or after it, and move it up the tree to
    the depth specified by `target`. You'll probably want to use
    [`liftTarget`](https://prosemirror.net/docs/ref/#transform.liftTarget) to compute `target`, to make
    sure the lift is valid.
    */ lift(range, target) {
        $f7cb452bf977726e$var$lift(this, range, target);
        return this;
    }
    /**
    Join the blocks around the given position. If depth is 2, their
    last and first siblings are also joined, and so on.
    */ join(pos, depth = 1) {
        $f7cb452bf977726e$var$join(this, pos, depth);
        return this;
    }
    /**
    Wrap the given [range](https://prosemirror.net/docs/ref/#model.NodeRange) in the given set of wrappers.
    The wrappers are assumed to be valid in this position, and should
    probably be computed with [`findWrapping`](https://prosemirror.net/docs/ref/#transform.findWrapping).
    */ wrap(range, wrappers) {
        $f7cb452bf977726e$var$wrap(this, range, wrappers);
        return this;
    }
    /**
    Set the type of all textblocks (partly) between `from` and `to` to
    the given node type with the given attributes.
    */ setBlockType(from, to = from, type, attrs = null) {
        $f7cb452bf977726e$var$setBlockType(this, from, to, type, attrs);
        return this;
    }
    /**
    Change the type, attributes, and/or marks of the node at `pos`.
    When `type` isn't given, the existing node type is preserved,
    */ setNodeMarkup(pos, type, attrs = null, marks) {
        $f7cb452bf977726e$var$setNodeMarkup(this, pos, type, attrs, marks);
        return this;
    }
    /**
    Set a single attribute on a given node to a new value.
    The `pos` addresses the document content. Use `setDocAttribute`
    to set attributes on the document itself.
    */ setNodeAttribute(pos, attr, value) {
        this.step(new $f7cb452bf977726e$export$626399c38172f669(pos, attr, value));
        return this;
    }
    /**
    Set a single attribute on the document to a new value.
    */ setDocAttribute(attr, value) {
        this.step(new $f7cb452bf977726e$export$f50707b396300ac9(attr, value));
        return this;
    }
    /**
    Add a mark to the node at position `pos`.
    */ addNodeMark(pos, mark) {
        this.step(new $f7cb452bf977726e$export$adefd16c402fee4e(pos, mark));
        return this;
    }
    /**
    Remove a mark (or all marks of the given type) from the node at
    position `pos`.
    */ removeNodeMark(pos, mark) {
        let node = this.doc.nodeAt(pos);
        if (!node) throw new RangeError("No node at position " + pos);
        if (mark instanceof (0, $9Jwkl.Mark)) {
            if (mark.isInSet(node.marks)) this.step(new $f7cb452bf977726e$export$fdf7d1dc10724da2(pos, mark));
        } else {
            let set = node.marks, found, steps = [];
            while(found = mark.isInSet(set)){
                steps.push(new $f7cb452bf977726e$export$fdf7d1dc10724da2(pos, found));
                set = found.removeFromSet(set);
            }
            for(let i = steps.length - 1; i >= 0; i--)this.step(steps[i]);
        }
        return this;
    }
    /**
    Split the node at the given position, and optionally, if `depth` is
    greater than one, any number of nodes above that. By default, the
    parts split off will inherit the node type of the original node.
    This can be changed by passing an array of types and attributes to
    use after the split (with the outermost nodes coming first).
    */ split(pos, depth = 1, typesAfter) {
        $f7cb452bf977726e$var$split(this, pos, depth, typesAfter);
        return this;
    }
    /**
    Add the given mark to the inline content between `from` and `to`.
    */ addMark(from, to, mark) {
        $f7cb452bf977726e$var$addMark(this, from, to, mark);
        return this;
    }
    /**
    Remove marks from inline nodes between `from` and `to`. When
    `mark` is a single mark, remove precisely that mark. When it is
    a mark type, remove all marks of that type. When it is null,
    remove all marks of any type.
    */ removeMark(from, to, mark) {
        $f7cb452bf977726e$var$removeMark(this, from, to, mark);
        return this;
    }
    /**
    Removes all marks and nodes from the content of the node at
    `pos` that don't match the given new parent node type. Accepts
    an optional starting [content match](https://prosemirror.net/docs/ref/#model.ContentMatch) as
    third argument.
    */ clearIncompatible(pos, parentType, match) {
        $f7cb452bf977726e$var$clearIncompatible(this, pos, parentType, match);
        return this;
    }
}

});


parcelRegister("4inI8", function(module, exports) {
$parcel$export(module.exports, "findParentNode", () => $320b3c5928e77c42$export$dc159056ffdb4c76);
$parcel$export(module.exports, "findParentNodeOfTypeClosestToPos", () => $320b3c5928e77c42$export$8bf0d019bde85d18);
// src/selection.ts

var $cc08P = parcelRequire("cc08P");

var $9Jwkl = parcelRequire("9Jwkl");
var $320b3c5928e77c42$export$5dd18664fe8bcbde = (nodeType)=>(tr)=>{
        const parent = $320b3c5928e77c42$export$1a3a74094b9968e(nodeType)(tr.selection);
        if (parent) return $320b3c5928e77c42$var$removeNodeAtPos(parent.pos)(tr);
        return tr;
    };
var $320b3c5928e77c42$export$b72cc612b642c071 = (nodeType, content)=>(tr)=>{
        if (!Array.isArray(nodeType)) nodeType = [
            nodeType
        ];
        for(let i = 0, count = nodeType.length; i < count; i++){
            const parent = $320b3c5928e77c42$export$1a3a74094b9968e(nodeType[i])(tr.selection);
            if (parent) {
                const newTr = $320b3c5928e77c42$var$replaceNodeAtPos(parent.pos, content)(tr);
                if (newTr !== tr) return newTr;
            }
        }
        return tr;
    };
var $320b3c5928e77c42$export$7d6e4e6663186878 = (tr)=>{
    if ($320b3c5928e77c42$export$a8c1d2c13abf8822(tr.selection)) {
        const from = tr.selection.$from.pos;
        const to = tr.selection.$to.pos;
        return $320b3c5928e77c42$var$cloneTr(tr.delete(from, to));
    }
    return tr;
};
var $320b3c5928e77c42$export$39874bca494f9ba3 = (content)=>(tr)=>{
        if ($320b3c5928e77c42$export$a8c1d2c13abf8822(tr.selection)) {
            const { $from: $from, $to: $to } = tr.selection;
            if (content instanceof (0, $9Jwkl.Fragment) && $from.parent.canReplace($from.index(), $from.indexAfter(), content) || content instanceof (0, $9Jwkl.Node) && $from.parent.canReplaceWith($from.index(), $from.indexAfter(), content.type)) return $320b3c5928e77c42$var$cloneTr(tr.replaceWith($from.pos, $to.pos, content).setSelection(new (0, $cc08P.NodeSelection)(tr.doc.resolve($from.pos))));
        }
        return tr;
    };
var $320b3c5928e77c42$export$1df6d14df6b0b758 = (position, dir = 1)=>(tr)=>{
        const nextSelection = (0, $cc08P.Selection).findFrom(tr.doc.resolve(position), dir, true);
        if (nextSelection) return tr.setSelection(nextSelection);
        return tr;
    };
var $320b3c5928e77c42$var$isSelectableNode = (node)=>Boolean(node instanceof (0, $9Jwkl.Node) && node.type && node.type.spec.selectable);
var $320b3c5928e77c42$var$shouldSelectNode = (node)=>$320b3c5928e77c42$var$isSelectableNode(node) && node.type.isLeaf;
var $320b3c5928e77c42$var$setSelection = (node, pos, tr)=>{
    if ($320b3c5928e77c42$var$shouldSelectNode(node)) return tr.setSelection(new (0, $cc08P.NodeSelection)(tr.doc.resolve(pos)));
    return $320b3c5928e77c42$export$1df6d14df6b0b758(pos)(tr);
};
var $320b3c5928e77c42$export$5fe92db78385e37c = (content, position, tryToReplace)=>(tr)=>{
        const hasPosition = typeof position === "number";
        const { $from: $from } = tr.selection;
        const $insertPos = hasPosition ? tr.doc.resolve(position) : $320b3c5928e77c42$export$a8c1d2c13abf8822(tr.selection) ? tr.doc.resolve($from.pos + 1) : $from;
        const { parent: parent } = $insertPos;
        if ($320b3c5928e77c42$export$a8c1d2c13abf8822(tr.selection) && tryToReplace) {
            const oldTr = tr;
            tr = $320b3c5928e77c42$export$39874bca494f9ba3(content)(tr);
            if (oldTr !== tr) return tr;
        }
        if ($320b3c5928e77c42$var$isEmptyParagraph(parent)) {
            const oldTr = tr;
            tr = $320b3c5928e77c42$export$b72cc612b642c071(parent.type, content)(tr);
            if (oldTr !== tr) {
                const pos = $320b3c5928e77c42$var$isSelectableNode(content) ? // for selectable node, selection position would be the position of the replaced parent
                $insertPos.before($insertPos.depth) : $insertPos.pos;
                return $320b3c5928e77c42$var$setSelection(content, pos, tr);
            }
        }
        if ($320b3c5928e77c42$export$b4d1262a40ad21d4($insertPos, content)) {
            tr.insert($insertPos.pos, content);
            const pos = hasPosition ? $insertPos.pos : $320b3c5928e77c42$var$isSelectableNode(content) ? // for atom nodes selection position after insertion is the previous pos
            tr.selection.$anchor.pos - 1 : tr.selection.$anchor.pos;
            return $320b3c5928e77c42$var$cloneTr($320b3c5928e77c42$var$setSelection(content, pos, tr));
        }
        for(let i = $insertPos.depth; i > 0; i--){
            const pos = $insertPos.after(i);
            const $pos = tr.doc.resolve(pos);
            if ($320b3c5928e77c42$export$b4d1262a40ad21d4($pos, content)) {
                tr.insert(pos, content);
                return $320b3c5928e77c42$var$cloneTr($320b3c5928e77c42$var$setSelection(content, pos, tr));
            }
        }
        return tr;
    };
var $320b3c5928e77c42$export$36491a9ea218d882 = (nodeType, type, attrs, marks)=>(tr)=>{
        const parent = $320b3c5928e77c42$export$1a3a74094b9968e(nodeType)(tr.selection);
        if (parent) return $320b3c5928e77c42$var$cloneTr(tr.setNodeMarkup(parent.pos, type, Object.assign({}, parent.node.attrs, attrs), marks));
        return tr;
    };
var $320b3c5928e77c42$export$7f11cc48adfe3aed = (nodeType)=>(tr)=>{
        if (!$320b3c5928e77c42$export$a8c1d2c13abf8822(tr.selection)) {
            const parent = $320b3c5928e77c42$export$1a3a74094b9968e(nodeType)(tr.selection);
            if (parent) return $320b3c5928e77c42$var$cloneTr(tr.setSelection((0, $cc08P.NodeSelection).create(tr.doc, parent.pos)));
        }
        return tr;
    };
var $320b3c5928e77c42$export$ffb1550ab6c3d03c = (tr)=>{
    const position = $320b3c5928e77c42$export$f8088819b1e2c2dc(tr.selection);
    if (typeof position === "number") return $320b3c5928e77c42$var$removeNodeAtPos(position)(tr);
    return tr;
};
// src/helpers.ts
var $320b3c5928e77c42$export$a8c1d2c13abf8822 = (selection)=>{
    return selection instanceof (0, $cc08P.NodeSelection);
};
var $320b3c5928e77c42$var$equalNodeType = (nodeType, node)=>{
    return Array.isArray(nodeType) && nodeType.indexOf(node.type) > -1 || node.type === nodeType;
};
var $320b3c5928e77c42$var$cloneTr = (tr)=>{
    return Object.assign(Object.create(tr), tr).setTime(Date.now());
};
var $320b3c5928e77c42$var$replaceNodeAtPos = (position, content)=>(tr)=>{
        const node = tr.doc.nodeAt(position);
        const $pos = tr.doc.resolve(position);
        if (!node) return tr;
        if ($320b3c5928e77c42$var$canReplace($pos, content)) {
            tr = tr.replaceWith(position, position + node.nodeSize, content);
            const start = tr.selection.$from.pos - 1;
            tr = $320b3c5928e77c42$export$1df6d14df6b0b758(Math.max(start, 0), -1)(tr);
            tr = $320b3c5928e77c42$export$1df6d14df6b0b758(tr.selection.$from.start())(tr);
            return $320b3c5928e77c42$var$cloneTr(tr);
        }
        return tr;
    };
var $320b3c5928e77c42$var$canReplace = ($pos, content)=>{
    const node = $pos.node($pos.depth);
    return node && node.type.validContent(content instanceof (0, $9Jwkl.Fragment) ? content : (0, $9Jwkl.Fragment).from(content));
};
var $320b3c5928e77c42$var$removeNodeAtPos = (position)=>(tr)=>{
        const node = tr.doc.nodeAt(position);
        if (!node) return tr;
        return $320b3c5928e77c42$var$cloneTr(tr.delete(position, position + node.nodeSize));
    };
var $320b3c5928e77c42$export$b4d1262a40ad21d4 = ($pos, content)=>{
    const index = $pos.index();
    if (content instanceof (0, $9Jwkl.Fragment)) return $pos.parent.canReplace(index, index, content);
    else if (content instanceof (0, $9Jwkl.Node)) return $pos.parent.canReplaceWith(index, index, content.type);
    return false;
};
var $320b3c5928e77c42$var$isEmptyParagraph = (node)=>{
    return !node || node.type.name === "paragraph" && node.nodeSize === 2;
};
// src/selection.ts
var $320b3c5928e77c42$export$dc159056ffdb4c76 = (predicate)=>({ $from: $from, $to: $to }, validateSameParent = false)=>{
        if (validateSameParent && !$from.sameParent($to)) {
            let depth = Math.min($from.depth, $to.depth);
            while(depth >= 0){
                const fromNode = $from.node(depth);
                const toNode = $to.node(depth);
                if (toNode === fromNode) {
                    if (predicate(fromNode)) return {
                        // Return the resolved pos
                        pos: depth > 0 ? $from.before(depth) : 0,
                        start: $from.start(depth),
                        depth: depth,
                        node: fromNode
                    };
                }
                depth = depth - 1;
            }
            return;
        }
        return $320b3c5928e77c42$export$fe09644e3bc6166b($from, predicate);
    };
var $320b3c5928e77c42$export$fe09644e3bc6166b = ($pos, predicate)=>{
    for(let i = $pos.depth; i > 0; i--){
        const node = $pos.node(i);
        if (predicate(node)) return {
            pos: i > 0 ? $pos.before(i) : 0,
            start: $pos.start(i),
            depth: i,
            node: node
        };
    }
};
var $320b3c5928e77c42$export$8556d79fa8189214 = (predicate, domAtPos)=>(selection)=>{
        const parent = $320b3c5928e77c42$export$dc159056ffdb4c76(predicate)(selection);
        if (parent) return $320b3c5928e77c42$export$666ce65defe9ad6e(parent.pos, domAtPos);
    };
var $320b3c5928e77c42$export$178ecaf80f45fdb6 = (predicate)=>(selection)=>{
        return !!$320b3c5928e77c42$export$dc159056ffdb4c76(predicate)(selection);
    };
var $320b3c5928e77c42$export$1a3a74094b9968e = (nodeType)=>(selection)=>{
        return $320b3c5928e77c42$export$dc159056ffdb4c76((node)=>$320b3c5928e77c42$var$equalNodeType(nodeType, node))(selection);
    };
var $320b3c5928e77c42$export$8bf0d019bde85d18 = ($pos, nodeType)=>{
    return $320b3c5928e77c42$export$fe09644e3bc6166b($pos, (node)=>$320b3c5928e77c42$var$equalNodeType(nodeType, node));
};
var $320b3c5928e77c42$export$14f438bb7227ce63 = (nodeType)=>(selection)=>{
        return $320b3c5928e77c42$export$178ecaf80f45fdb6((node)=>$320b3c5928e77c42$var$equalNodeType(nodeType, node))(selection);
    };
var $320b3c5928e77c42$export$faeafc1151740116 = (nodeType, domAtPos)=>(selection)=>{
        return $320b3c5928e77c42$export$8556d79fa8189214((node)=>$320b3c5928e77c42$var$equalNodeType(nodeType, node), domAtPos)(selection);
    };
var $320b3c5928e77c42$export$924aa2dd4d9a67fa = (nodeType)=>(selection)=>{
        if ($320b3c5928e77c42$export$a8c1d2c13abf8822(selection)) {
            const { node: node, $from: $from } = selection;
            if ($320b3c5928e77c42$var$equalNodeType(nodeType, node)) return {
                node: node,
                start: $from.start(),
                pos: $from.pos,
                depth: $from.depth
            };
        }
    };
var $320b3c5928e77c42$export$f8088819b1e2c2dc = (selection)=>{
    const { nodeBefore: nodeBefore } = selection.$from;
    const maybeSelection = (0, $cc08P.Selection).findFrom(selection.$from, -1);
    if (maybeSelection && nodeBefore) {
        const parent = $320b3c5928e77c42$export$1a3a74094b9968e(nodeBefore.type)(maybeSelection);
        if (parent) return parent.pos;
        return maybeSelection.$from.pos;
    }
};
var $320b3c5928e77c42$export$666ce65defe9ad6e = (position, domAtPos)=>{
    const dom = domAtPos(position);
    const node = dom.node.childNodes[dom.offset];
    if (dom.node.nodeType === Node.TEXT_NODE && dom.node.parentNode) return dom.node.parentNode;
    if (!node || node.nodeType === Node.TEXT_NODE) return dom.node;
    return node;
};
// src/node.ts
var $320b3c5928e77c42$export$bffa455ba8c619a6 = (node, descend = true)=>{
    if (!node) throw new Error('Invalid "node" parameter');
    const result = [];
    node.descendants((child, pos)=>{
        result.push({
            node: child,
            pos: pos
        });
        if (!descend) return false;
    });
    return result;
};
var $320b3c5928e77c42$export$f94ca194e830789c = (node, predicate, descend = true)=>{
    if (!node) throw new Error('Invalid "node" parameter');
    else if (!predicate) throw new Error('Invalid "predicate" parameter');
    return $320b3c5928e77c42$export$bffa455ba8c619a6(node, descend).filter((child)=>predicate(child.node));
};
var $320b3c5928e77c42$export$53418710fbc2d8cc = (node, descend = true)=>{
    return $320b3c5928e77c42$export$f94ca194e830789c(node, (child)=>child.isText, descend);
};
var $320b3c5928e77c42$export$ddc1620722e25671 = (node, descend = true)=>{
    return $320b3c5928e77c42$export$f94ca194e830789c(node, (child)=>child.isInline, descend);
};
var $320b3c5928e77c42$export$cae8d7f259e5bbe9 = (node, descend = true)=>{
    return $320b3c5928e77c42$export$f94ca194e830789c(node, (child)=>child.isBlock, descend);
};
var $320b3c5928e77c42$export$a836476a7f9de5b4 = (node, predicate, descend = true)=>{
    return $320b3c5928e77c42$export$f94ca194e830789c(node, (child)=>!!predicate(child.attrs), descend);
};
var $320b3c5928e77c42$export$96bb9476c7c69f39 = (node, nodeType, descend = true)=>{
    return $320b3c5928e77c42$export$f94ca194e830789c(node, (child)=>child.type === nodeType, descend);
};
var $320b3c5928e77c42$export$c01a9e7ec615e821 = (node, markType, descend = true)=>{
    return $320b3c5928e77c42$export$f94ca194e830789c(node, (child)=>Boolean(markType.isInSet(child.marks)), descend);
};
var $320b3c5928e77c42$export$2344b14b097df817 = (node, nodeType)=>{
    return !!$320b3c5928e77c42$export$96bb9476c7c69f39(node, nodeType).length;
};

});

parcelRegister("2gI99", function(module, exports) {
$parcel$export(module.exports, "Fragment", () => $1a6f51facb51d04f$export$ffb0004e005737fa);
$parcel$export(module.exports, "Slice", () => $1a6f51facb51d04f$export$b3f2e2de3a8baa1e);
$parcel$export(module.exports, "Node", () => $1a6f51facb51d04f$export$85c928794f8d04d4);
$parcel$export(module.exports, "MarkType", () => $1a6f51facb51d04f$export$b6a78689043c6521);
$parcel$export(module.exports, "Schema", () => $1a6f51facb51d04f$export$19342e026b58ebb7);

var $at9VT = parcelRequire("at9VT");
function $1a6f51facb51d04f$var$findDiffStart(a, b, pos) {
    for(let i = 0;; i++){
        if (i == a.childCount || i == b.childCount) return a.childCount == b.childCount ? null : pos;
        let childA = a.child(i), childB = b.child(i);
        if (childA == childB) {
            pos += childA.nodeSize;
            continue;
        }
        if (!childA.sameMarkup(childB)) return pos;
        if (childA.isText && childA.text != childB.text) {
            for(let j = 0; childA.text[j] == childB.text[j]; j++)pos++;
            return pos;
        }
        if (childA.content.size || childB.content.size) {
            let inner = $1a6f51facb51d04f$var$findDiffStart(childA.content, childB.content, pos + 1);
            if (inner != null) return inner;
        }
        pos += childA.nodeSize;
    }
}
function $1a6f51facb51d04f$var$findDiffEnd(a, b, posA, posB) {
    for(let iA = a.childCount, iB = b.childCount;;){
        if (iA == 0 || iB == 0) return iA == iB ? null : {
            a: posA,
            b: posB
        };
        let childA = a.child(--iA), childB = b.child(--iB), size = childA.nodeSize;
        if (childA == childB) {
            posA -= size;
            posB -= size;
            continue;
        }
        if (!childA.sameMarkup(childB)) return {
            a: posA,
            b: posB
        };
        if (childA.isText && childA.text != childB.text) {
            let same = 0, minSize = Math.min(childA.text.length, childB.text.length);
            while(same < minSize && childA.text[childA.text.length - same - 1] == childB.text[childB.text.length - same - 1]){
                same++;
                posA--;
                posB--;
            }
            return {
                a: posA,
                b: posB
            };
        }
        if (childA.content.size || childB.content.size) {
            let inner = $1a6f51facb51d04f$var$findDiffEnd(childA.content, childB.content, posA - 1, posB - 1);
            if (inner) return inner;
        }
        posA -= size;
        posB -= size;
    }
}
/**
A fragment represents a node's collection of child nodes.

Like nodes, fragments are persistent data structures, and you
should not mutate them or their content. Rather, you create new
instances whenever needed. The API tries to make this easy.
*/ class $1a6f51facb51d04f$export$ffb0004e005737fa {
    /**
    @internal
    */ constructor(/**
    The child nodes in this fragment.
    */ content, size){
        this.content = content;
        this.size = size || 0;
        if (size == null) for(let i = 0; i < content.length; i++)this.size += content[i].nodeSize;
    }
    /**
    Invoke a callback for all descendant nodes between the given two
    positions (relative to start of this fragment). Doesn't descend
    into a node when the callback returns `false`.
    */ nodesBetween(from, to, f, nodeStart = 0, parent) {
        for(let i = 0, pos = 0; pos < to; i++){
            let child = this.content[i], end = pos + child.nodeSize;
            if (end > from && f(child, nodeStart + pos, parent || null, i) !== false && child.content.size) {
                let start = pos + 1;
                child.nodesBetween(Math.max(0, from - start), Math.min(child.content.size, to - start), f, nodeStart + start);
            }
            pos = end;
        }
    }
    /**
    Call the given callback for every descendant node. `pos` will be
    relative to the start of the fragment. The callback may return
    `false` to prevent traversal of a given node's children.
    */ descendants(f) {
        this.nodesBetween(0, this.size, f);
    }
    /**
    Extract the text between `from` and `to`. See the same method on
    [`Node`](https://prosemirror.net/docs/ref/#model.Node.textBetween).
    */ textBetween(from, to, blockSeparator, leafText) {
        let text = "", first = true;
        this.nodesBetween(from, to, (node, pos)=>{
            let nodeText = node.isText ? node.text.slice(Math.max(from, pos) - pos, to - pos) : !node.isLeaf ? "" : leafText ? typeof leafText === "function" ? leafText(node) : leafText : node.type.spec.leafText ? node.type.spec.leafText(node) : "";
            if (node.isBlock && (node.isLeaf && nodeText || node.isTextblock) && blockSeparator) {
                if (first) first = false;
                else text += blockSeparator;
            }
            text += nodeText;
        }, 0);
        return text;
    }
    /**
    Create a new fragment containing the combined content of this
    fragment and the other.
    */ append(other) {
        if (!other.size) return this;
        if (!this.size) return other;
        let last = this.lastChild, first = other.firstChild, content = this.content.slice(), i = 0;
        if (last.isText && last.sameMarkup(first)) {
            content[content.length - 1] = last.withText(last.text + first.text);
            i = 1;
        }
        for(; i < other.content.length; i++)content.push(other.content[i]);
        return new $1a6f51facb51d04f$export$ffb0004e005737fa(content, this.size + other.size);
    }
    /**
    Cut out the sub-fragment between the two given positions.
    */ cut(from, to = this.size) {
        if (from == 0 && to == this.size) return this;
        let result = [], size = 0;
        if (to > from) for(let i = 0, pos = 0; pos < to; i++){
            let child = this.content[i], end = pos + child.nodeSize;
            if (end > from) {
                if (pos < from || end > to) {
                    if (child.isText) child = child.cut(Math.max(0, from - pos), Math.min(child.text.length, to - pos));
                    else child = child.cut(Math.max(0, from - pos - 1), Math.min(child.content.size, to - pos - 1));
                }
                result.push(child);
                size += child.nodeSize;
            }
            pos = end;
        }
        return new $1a6f51facb51d04f$export$ffb0004e005737fa(result, size);
    }
    /**
    @internal
    */ cutByIndex(from, to) {
        if (from == to) return $1a6f51facb51d04f$export$ffb0004e005737fa.empty;
        if (from == 0 && to == this.content.length) return this;
        return new $1a6f51facb51d04f$export$ffb0004e005737fa(this.content.slice(from, to));
    }
    /**
    Create a new fragment in which the node at the given index is
    replaced by the given node.
    */ replaceChild(index, node) {
        let current = this.content[index];
        if (current == node) return this;
        let copy = this.content.slice();
        let size = this.size + node.nodeSize - current.nodeSize;
        copy[index] = node;
        return new $1a6f51facb51d04f$export$ffb0004e005737fa(copy, size);
    }
    /**
    Create a new fragment by prepending the given node to this
    fragment.
    */ addToStart(node) {
        return new $1a6f51facb51d04f$export$ffb0004e005737fa([
            node
        ].concat(this.content), this.size + node.nodeSize);
    }
    /**
    Create a new fragment by appending the given node to this
    fragment.
    */ addToEnd(node) {
        return new $1a6f51facb51d04f$export$ffb0004e005737fa(this.content.concat(node), this.size + node.nodeSize);
    }
    /**
    Compare this fragment to another one.
    */ eq(other) {
        if (this.content.length != other.content.length) return false;
        for(let i = 0; i < this.content.length; i++)if (!this.content[i].eq(other.content[i])) return false;
        return true;
    }
    /**
    The first child of the fragment, or `null` if it is empty.
    */ get firstChild() {
        return this.content.length ? this.content[0] : null;
    }
    /**
    The last child of the fragment, or `null` if it is empty.
    */ get lastChild() {
        return this.content.length ? this.content[this.content.length - 1] : null;
    }
    /**
    The number of child nodes in this fragment.
    */ get childCount() {
        return this.content.length;
    }
    /**
    Get the child node at the given index. Raise an error when the
    index is out of range.
    */ child(index) {
        let found = this.content[index];
        if (!found) throw new RangeError("Index " + index + " out of range for " + this);
        return found;
    }
    /**
    Get the child node at the given index, if it exists.
    */ maybeChild(index) {
        return this.content[index] || null;
    }
    /**
    Call `f` for every child node, passing the node, its offset
    into this parent node, and its index.
    */ forEach(f) {
        for(let i = 0, p = 0; i < this.content.length; i++){
            let child = this.content[i];
            f(child, p, i);
            p += child.nodeSize;
        }
    }
    /**
    Find the first position at which this fragment and another
    fragment differ, or `null` if they are the same.
    */ findDiffStart(other, pos = 0) {
        return $1a6f51facb51d04f$var$findDiffStart(this, other, pos);
    }
    /**
    Find the first position, searching from the end, at which this
    fragment and the given fragment differ, or `null` if they are
    the same. Since this position will not be the same in both
    nodes, an object with two separate positions is returned.
    */ findDiffEnd(other, pos = this.size, otherPos = other.size) {
        return $1a6f51facb51d04f$var$findDiffEnd(this, other, pos, otherPos);
    }
    /**
    Find the index and inner offset corresponding to a given relative
    position in this fragment. The result object will be reused
    (overwritten) the next time the function is called. @internal
    */ findIndex(pos, round = -1) {
        if (pos == 0) return $1a6f51facb51d04f$var$retIndex(0, pos);
        if (pos == this.size) return $1a6f51facb51d04f$var$retIndex(this.content.length, pos);
        if (pos > this.size || pos < 0) throw new RangeError(`Position ${pos} outside of fragment (${this})`);
        for(let i = 0, curPos = 0;; i++){
            let cur = this.child(i), end = curPos + cur.nodeSize;
            if (end >= pos) {
                if (end == pos || round > 0) return $1a6f51facb51d04f$var$retIndex(i + 1, end);
                return $1a6f51facb51d04f$var$retIndex(i, curPos);
            }
            curPos = end;
        }
    }
    /**
    Return a debugging string that describes this fragment.
    */ toString() {
        return "<" + this.toStringInner() + ">";
    }
    /**
    @internal
    */ toStringInner() {
        return this.content.join(", ");
    }
    /**
    Create a JSON-serializeable representation of this fragment.
    */ toJSON() {
        return this.content.length ? this.content.map((n)=>n.toJSON()) : null;
    }
    /**
    Deserialize a fragment from its JSON representation.
    */ static fromJSON(schema, value) {
        if (!value) return $1a6f51facb51d04f$export$ffb0004e005737fa.empty;
        if (!Array.isArray(value)) throw new RangeError("Invalid input for Fragment.fromJSON");
        return new $1a6f51facb51d04f$export$ffb0004e005737fa(value.map(schema.nodeFromJSON));
    }
    /**
    Build a fragment from an array of nodes. Ensures that adjacent
    text nodes with the same marks are joined together.
    */ static fromArray(array) {
        if (!array.length) return $1a6f51facb51d04f$export$ffb0004e005737fa.empty;
        let joined, size = 0;
        for(let i = 0; i < array.length; i++){
            let node = array[i];
            size += node.nodeSize;
            if (i && node.isText && array[i - 1].sameMarkup(node)) {
                if (!joined) joined = array.slice(0, i);
                joined[joined.length - 1] = node.withText(joined[joined.length - 1].text + node.text);
            } else if (joined) joined.push(node);
        }
        return new $1a6f51facb51d04f$export$ffb0004e005737fa(joined || array, size);
    }
    /**
    Create a fragment from something that can be interpreted as a
    set of nodes. For `null`, it returns the empty fragment. For a
    fragment, the fragment itself. For a node or array of nodes, a
    fragment containing those nodes.
    */ static from(nodes) {
        if (!nodes) return $1a6f51facb51d04f$export$ffb0004e005737fa.empty;
        if (nodes instanceof $1a6f51facb51d04f$export$ffb0004e005737fa) return nodes;
        if (Array.isArray(nodes)) return this.fromArray(nodes);
        if (nodes.attrs) return new $1a6f51facb51d04f$export$ffb0004e005737fa([
            nodes
        ], nodes.nodeSize);
        throw new RangeError("Can not convert " + nodes + " to a Fragment" + (nodes.nodesBetween ? " (looks like multiple versions of prosemirror-model were loaded)" : ""));
    }
}
/**
An empty fragment. Intended to be reused whenever a node doesn't
contain anything (rather than allocating a new empty fragment for
each leaf node).
*/ $1a6f51facb51d04f$export$ffb0004e005737fa.empty = new $1a6f51facb51d04f$export$ffb0004e005737fa([], 0);
const $1a6f51facb51d04f$var$found = {
    index: 0,
    offset: 0
};
function $1a6f51facb51d04f$var$retIndex(index, offset) {
    $1a6f51facb51d04f$var$found.index = index;
    $1a6f51facb51d04f$var$found.offset = offset;
    return $1a6f51facb51d04f$var$found;
}
function $1a6f51facb51d04f$var$compareDeep(a, b) {
    if (a === b) return true;
    if (!(a && typeof a == "object") || !(b && typeof b == "object")) return false;
    let array = Array.isArray(a);
    if (Array.isArray(b) != array) return false;
    if (array) {
        if (a.length != b.length) return false;
        for(let i = 0; i < a.length; i++)if (!$1a6f51facb51d04f$var$compareDeep(a[i], b[i])) return false;
    } else {
        for(let p in a)if (!(p in b) || !$1a6f51facb51d04f$var$compareDeep(a[p], b[p])) return false;
        for(let p in b)if (!(p in a)) return false;
    }
    return true;
}
/**
A mark is a piece of information that can be attached to a node,
such as it being emphasized, in code font, or a link. It has a
type and optionally a set of attributes that provide further
information (such as the target of the link). Marks are created
through a `Schema`, which controls which types exist and which
attributes they have.
*/ class $1a6f51facb51d04f$export$c9d15bcfc6d42044 {
    /**
    @internal
    */ constructor(/**
    The type of this mark.
    */ type, /**
    The attributes associated with this mark.
    */ attrs){
        this.type = type;
        this.attrs = attrs;
    }
    /**
    Given a set of marks, create a new set which contains this one as
    well, in the right position. If this mark is already in the set,
    the set itself is returned. If any marks that are set to be
    [exclusive](https://prosemirror.net/docs/ref/#model.MarkSpec.excludes) with this mark are present,
    those are replaced by this one.
    */ addToSet(set) {
        let copy, placed = false;
        for(let i = 0; i < set.length; i++){
            let other = set[i];
            if (this.eq(other)) return set;
            if (this.type.excludes(other.type)) {
                if (!copy) copy = set.slice(0, i);
            } else if (other.type.excludes(this.type)) return set;
            else {
                if (!placed && other.type.rank > this.type.rank) {
                    if (!copy) copy = set.slice(0, i);
                    copy.push(this);
                    placed = true;
                }
                if (copy) copy.push(other);
            }
        }
        if (!copy) copy = set.slice();
        if (!placed) copy.push(this);
        return copy;
    }
    /**
    Remove this mark from the given set, returning a new set. If this
    mark is not in the set, the set itself is returned.
    */ removeFromSet(set) {
        for(let i = 0; i < set.length; i++)if (this.eq(set[i])) return set.slice(0, i).concat(set.slice(i + 1));
        return set;
    }
    /**
    Test whether this mark is in the given set of marks.
    */ isInSet(set) {
        for(let i = 0; i < set.length; i++)if (this.eq(set[i])) return true;
        return false;
    }
    /**
    Test whether this mark has the same type and attributes as
    another mark.
    */ eq(other) {
        return this == other || this.type == other.type && $1a6f51facb51d04f$var$compareDeep(this.attrs, other.attrs);
    }
    /**
    Convert this mark to a JSON-serializeable representation.
    */ toJSON() {
        let obj = {
            type: this.type.name
        };
        for(let _ in this.attrs){
            obj.attrs = this.attrs;
            break;
        }
        return obj;
    }
    /**
    Deserialize a mark from JSON.
    */ static fromJSON(schema, json) {
        if (!json) throw new RangeError("Invalid input for Mark.fromJSON");
        let type = schema.marks[json.type];
        if (!type) throw new RangeError(`There is no mark type ${json.type} in this schema`);
        let mark = type.create(json.attrs);
        type.checkAttrs(mark.attrs);
        return mark;
    }
    /**
    Test whether two sets of marks are identical.
    */ static sameSet(a, b) {
        if (a == b) return true;
        if (a.length != b.length) return false;
        for(let i = 0; i < a.length; i++)if (!a[i].eq(b[i])) return false;
        return true;
    }
    /**
    Create a properly sorted mark set from null, a single mark, or an
    unsorted array of marks.
    */ static setFrom(marks) {
        if (!marks || Array.isArray(marks) && marks.length == 0) return $1a6f51facb51d04f$export$c9d15bcfc6d42044.none;
        if (marks instanceof $1a6f51facb51d04f$export$c9d15bcfc6d42044) return [
            marks
        ];
        let copy = marks.slice();
        copy.sort((a, b)=>a.type.rank - b.type.rank);
        return copy;
    }
}
/**
The empty set of marks.
*/ $1a6f51facb51d04f$export$c9d15bcfc6d42044.none = [];
/**
Error type raised by [`Node.replace`](https://prosemirror.net/docs/ref/#model.Node.replace) when
given an invalid replacement.
*/ class $1a6f51facb51d04f$export$6de0e778727af3f2 extends Error {
}
/*
ReplaceError = function(this: any, message: string) {
  let err = Error.call(this, message)
  ;(err as any).__proto__ = ReplaceError.prototype
  return err
} as any

ReplaceError.prototype = Object.create(Error.prototype)
ReplaceError.prototype.constructor = ReplaceError
ReplaceError.prototype.name = "ReplaceError"
*/ /**
A slice represents a piece cut out of a larger document. It
stores not only a fragment, but also the depth up to which nodes on
both side are ‘open’ (cut through).
*/ class $1a6f51facb51d04f$export$b3f2e2de3a8baa1e {
    /**
    Create a slice. When specifying a non-zero open depth, you must
    make sure that there are nodes of at least that depth at the
    appropriate side of the fragment—i.e. if the fragment is an
    empty paragraph node, `openStart` and `openEnd` can't be greater
    than 1.
    
    It is not necessary for the content of open nodes to conform to
    the schema's content constraints, though it should be a valid
    start/end/middle for such a node, depending on which sides are
    open.
    */ constructor(/**
    The slice's content.
    */ content, /**
    The open depth at the start of the fragment.
    */ openStart, /**
    The open depth at the end.
    */ openEnd){
        this.content = content;
        this.openStart = openStart;
        this.openEnd = openEnd;
    }
    /**
    The size this slice would add when inserted into a document.
    */ get size() {
        return this.content.size - this.openStart - this.openEnd;
    }
    /**
    @internal
    */ insertAt(pos, fragment) {
        let content = $1a6f51facb51d04f$var$insertInto(this.content, pos + this.openStart, fragment);
        return content && new $1a6f51facb51d04f$export$b3f2e2de3a8baa1e(content, this.openStart, this.openEnd);
    }
    /**
    @internal
    */ removeBetween(from, to) {
        return new $1a6f51facb51d04f$export$b3f2e2de3a8baa1e($1a6f51facb51d04f$var$removeRange(this.content, from + this.openStart, to + this.openStart), this.openStart, this.openEnd);
    }
    /**
    Tests whether this slice is equal to another slice.
    */ eq(other) {
        return this.content.eq(other.content) && this.openStart == other.openStart && this.openEnd == other.openEnd;
    }
    /**
    @internal
    */ toString() {
        return this.content + "(" + this.openStart + "," + this.openEnd + ")";
    }
    /**
    Convert a slice to a JSON-serializable representation.
    */ toJSON() {
        if (!this.content.size) return null;
        let json = {
            content: this.content.toJSON()
        };
        if (this.openStart > 0) json.openStart = this.openStart;
        if (this.openEnd > 0) json.openEnd = this.openEnd;
        return json;
    }
    /**
    Deserialize a slice from its JSON representation.
    */ static fromJSON(schema, json) {
        if (!json) return $1a6f51facb51d04f$export$b3f2e2de3a8baa1e.empty;
        let openStart = json.openStart || 0, openEnd = json.openEnd || 0;
        if (typeof openStart != "number" || typeof openEnd != "number") throw new RangeError("Invalid input for Slice.fromJSON");
        return new $1a6f51facb51d04f$export$b3f2e2de3a8baa1e($1a6f51facb51d04f$export$ffb0004e005737fa.fromJSON(schema, json.content), openStart, openEnd);
    }
    /**
    Create a slice from a fragment by taking the maximum possible
    open value on both side of the fragment.
    */ static maxOpen(fragment, openIsolating = true) {
        let openStart = 0, openEnd = 0;
        for(let n = fragment.firstChild; n && !n.isLeaf && (openIsolating || !n.type.spec.isolating); n = n.firstChild)openStart++;
        for(let n = fragment.lastChild; n && !n.isLeaf && (openIsolating || !n.type.spec.isolating); n = n.lastChild)openEnd++;
        return new $1a6f51facb51d04f$export$b3f2e2de3a8baa1e(fragment, openStart, openEnd);
    }
}
/**
The empty slice.
*/ $1a6f51facb51d04f$export$b3f2e2de3a8baa1e.empty = new $1a6f51facb51d04f$export$b3f2e2de3a8baa1e($1a6f51facb51d04f$export$ffb0004e005737fa.empty, 0, 0);
function $1a6f51facb51d04f$var$removeRange(content, from, to) {
    let { index: index, offset: offset } = content.findIndex(from), child = content.maybeChild(index);
    let { index: indexTo, offset: offsetTo } = content.findIndex(to);
    if (offset == from || child.isText) {
        if (offsetTo != to && !content.child(indexTo).isText) throw new RangeError("Removing non-flat range");
        return content.cut(0, from).append(content.cut(to));
    }
    if (index != indexTo) throw new RangeError("Removing non-flat range");
    return content.replaceChild(index, child.copy($1a6f51facb51d04f$var$removeRange(child.content, from - offset - 1, to - offset - 1)));
}
function $1a6f51facb51d04f$var$insertInto(content, dist, insert, parent) {
    let { index: index, offset: offset } = content.findIndex(dist), child = content.maybeChild(index);
    if (offset == dist || child.isText) {
        if (parent && !parent.canReplace(index, index, insert)) return null;
        return content.cut(0, dist).append(insert).append(content.cut(dist));
    }
    let inner = $1a6f51facb51d04f$var$insertInto(child.content, dist - offset - 1, insert);
    return inner && content.replaceChild(index, child.copy(inner));
}
function $1a6f51facb51d04f$var$replace($from, $to, slice) {
    if (slice.openStart > $from.depth) throw new $1a6f51facb51d04f$export$6de0e778727af3f2("Inserted content deeper than insertion position");
    if ($from.depth - slice.openStart != $to.depth - slice.openEnd) throw new $1a6f51facb51d04f$export$6de0e778727af3f2("Inconsistent open depths");
    return $1a6f51facb51d04f$var$replaceOuter($from, $to, slice, 0);
}
function $1a6f51facb51d04f$var$replaceOuter($from, $to, slice, depth) {
    let index = $from.index(depth), node = $from.node(depth);
    if (index == $to.index(depth) && depth < $from.depth - slice.openStart) {
        let inner = $1a6f51facb51d04f$var$replaceOuter($from, $to, slice, depth + 1);
        return node.copy(node.content.replaceChild(index, inner));
    } else if (!slice.content.size) return $1a6f51facb51d04f$var$close(node, $1a6f51facb51d04f$var$replaceTwoWay($from, $to, depth));
    else if (!slice.openStart && !slice.openEnd && $from.depth == depth && $to.depth == depth) {
        let parent = $from.parent, content = parent.content;
        return $1a6f51facb51d04f$var$close(parent, content.cut(0, $from.parentOffset).append(slice.content).append(content.cut($to.parentOffset)));
    } else {
        let { start: start, end: end } = $1a6f51facb51d04f$var$prepareSliceForReplace(slice, $from);
        return $1a6f51facb51d04f$var$close(node, $1a6f51facb51d04f$var$replaceThreeWay($from, start, end, $to, depth));
    }
}
function $1a6f51facb51d04f$var$checkJoin(main, sub) {
    if (!sub.type.compatibleContent(main.type)) throw new $1a6f51facb51d04f$export$6de0e778727af3f2("Cannot join " + sub.type.name + " onto " + main.type.name);
}
function $1a6f51facb51d04f$var$joinable($before, $after, depth) {
    let node = $before.node(depth);
    $1a6f51facb51d04f$var$checkJoin(node, $after.node(depth));
    return node;
}
function $1a6f51facb51d04f$var$addNode(child, target) {
    let last = target.length - 1;
    if (last >= 0 && child.isText && child.sameMarkup(target[last])) target[last] = child.withText(target[last].text + child.text);
    else target.push(child);
}
function $1a6f51facb51d04f$var$addRange($start, $end, depth, target) {
    let node = ($end || $start).node(depth);
    let startIndex = 0, endIndex = $end ? $end.index(depth) : node.childCount;
    if ($start) {
        startIndex = $start.index(depth);
        if ($start.depth > depth) startIndex++;
        else if ($start.textOffset) {
            $1a6f51facb51d04f$var$addNode($start.nodeAfter, target);
            startIndex++;
        }
    }
    for(let i = startIndex; i < endIndex; i++)$1a6f51facb51d04f$var$addNode(node.child(i), target);
    if ($end && $end.depth == depth && $end.textOffset) $1a6f51facb51d04f$var$addNode($end.nodeBefore, target);
}
function $1a6f51facb51d04f$var$close(node, content) {
    node.type.checkContent(content);
    return node.copy(content);
}
function $1a6f51facb51d04f$var$replaceThreeWay($from, $start, $end, $to, depth) {
    let openStart = $from.depth > depth && $1a6f51facb51d04f$var$joinable($from, $start, depth + 1);
    let openEnd = $to.depth > depth && $1a6f51facb51d04f$var$joinable($end, $to, depth + 1);
    let content = [];
    $1a6f51facb51d04f$var$addRange(null, $from, depth, content);
    if (openStart && openEnd && $start.index(depth) == $end.index(depth)) {
        $1a6f51facb51d04f$var$checkJoin(openStart, openEnd);
        $1a6f51facb51d04f$var$addNode($1a6f51facb51d04f$var$close(openStart, $1a6f51facb51d04f$var$replaceThreeWay($from, $start, $end, $to, depth + 1)), content);
    } else {
        if (openStart) $1a6f51facb51d04f$var$addNode($1a6f51facb51d04f$var$close(openStart, $1a6f51facb51d04f$var$replaceTwoWay($from, $start, depth + 1)), content);
        $1a6f51facb51d04f$var$addRange($start, $end, depth, content);
        if (openEnd) $1a6f51facb51d04f$var$addNode($1a6f51facb51d04f$var$close(openEnd, $1a6f51facb51d04f$var$replaceTwoWay($end, $to, depth + 1)), content);
    }
    $1a6f51facb51d04f$var$addRange($to, null, depth, content);
    return new $1a6f51facb51d04f$export$ffb0004e005737fa(content);
}
function $1a6f51facb51d04f$var$replaceTwoWay($from, $to, depth) {
    let content = [];
    $1a6f51facb51d04f$var$addRange(null, $from, depth, content);
    if ($from.depth > depth) {
        let type = $1a6f51facb51d04f$var$joinable($from, $to, depth + 1);
        $1a6f51facb51d04f$var$addNode($1a6f51facb51d04f$var$close(type, $1a6f51facb51d04f$var$replaceTwoWay($from, $to, depth + 1)), content);
    }
    $1a6f51facb51d04f$var$addRange($to, null, depth, content);
    return new $1a6f51facb51d04f$export$ffb0004e005737fa(content);
}
function $1a6f51facb51d04f$var$prepareSliceForReplace(slice, $along) {
    let extra = $along.depth - slice.openStart, parent = $along.node(extra);
    let node = parent.copy(slice.content);
    for(let i = extra - 1; i >= 0; i--)node = $along.node(i).copy($1a6f51facb51d04f$export$ffb0004e005737fa.from(node));
    return {
        start: node.resolveNoCache(slice.openStart + extra),
        end: node.resolveNoCache(node.content.size - slice.openEnd - extra)
    };
}
/**
You can [_resolve_](https://prosemirror.net/docs/ref/#model.Node.resolve) a position to get more
information about it. Objects of this class represent such a
resolved position, providing various pieces of context
information, and some helper methods.

Throughout this interface, methods that take an optional `depth`
parameter will interpret undefined as `this.depth` and negative
numbers as `this.depth + value`.
*/ class $1a6f51facb51d04f$export$b2a42f82e59e4b19 {
    /**
    @internal
    */ constructor(/**
    The position that was resolved.
    */ pos, /**
    @internal
    */ path, /**
    The offset this position has into its parent node.
    */ parentOffset){
        this.pos = pos;
        this.path = path;
        this.parentOffset = parentOffset;
        this.depth = path.length / 3 - 1;
    }
    /**
    @internal
    */ resolveDepth(val) {
        if (val == null) return this.depth;
        if (val < 0) return this.depth + val;
        return val;
    }
    /**
    The parent node that the position points into. Note that even if
    a position points into a text node, that node is not considered
    the parent—text nodes are ‘flat’ in this model, and have no content.
    */ get parent() {
        return this.node(this.depth);
    }
    /**
    The root node in which the position was resolved.
    */ get doc() {
        return this.node(0);
    }
    /**
    The ancestor node at the given level. `p.node(p.depth)` is the
    same as `p.parent`.
    */ node(depth) {
        return this.path[this.resolveDepth(depth) * 3];
    }
    /**
    The index into the ancestor at the given level. If this points
    at the 3rd node in the 2nd paragraph on the top level, for
    example, `p.index(0)` is 1 and `p.index(1)` is 2.
    */ index(depth) {
        return this.path[this.resolveDepth(depth) * 3 + 1];
    }
    /**
    The index pointing after this position into the ancestor at the
    given level.
    */ indexAfter(depth) {
        depth = this.resolveDepth(depth);
        return this.index(depth) + (depth == this.depth && !this.textOffset ? 0 : 1);
    }
    /**
    The (absolute) position at the start of the node at the given
    level.
    */ start(depth) {
        depth = this.resolveDepth(depth);
        return depth == 0 ? 0 : this.path[depth * 3 - 1] + 1;
    }
    /**
    The (absolute) position at the end of the node at the given
    level.
    */ end(depth) {
        depth = this.resolveDepth(depth);
        return this.start(depth) + this.node(depth).content.size;
    }
    /**
    The (absolute) position directly before the wrapping node at the
    given level, or, when `depth` is `this.depth + 1`, the original
    position.
    */ before(depth) {
        depth = this.resolveDepth(depth);
        if (!depth) throw new RangeError("There is no position before the top-level node");
        return depth == this.depth + 1 ? this.pos : this.path[depth * 3 - 1];
    }
    /**
    The (absolute) position directly after the wrapping node at the
    given level, or the original position when `depth` is `this.depth + 1`.
    */ after(depth) {
        depth = this.resolveDepth(depth);
        if (!depth) throw new RangeError("There is no position after the top-level node");
        return depth == this.depth + 1 ? this.pos : this.path[depth * 3 - 1] + this.path[depth * 3].nodeSize;
    }
    /**
    When this position points into a text node, this returns the
    distance between the position and the start of the text node.
    Will be zero for positions that point between nodes.
    */ get textOffset() {
        return this.pos - this.path[this.path.length - 1];
    }
    /**
    Get the node directly after the position, if any. If the position
    points into a text node, only the part of that node after the
    position is returned.
    */ get nodeAfter() {
        let parent = this.parent, index = this.index(this.depth);
        if (index == parent.childCount) return null;
        let dOff = this.pos - this.path[this.path.length - 1], child = parent.child(index);
        return dOff ? parent.child(index).cut(dOff) : child;
    }
    /**
    Get the node directly before the position, if any. If the
    position points into a text node, only the part of that node
    before the position is returned.
    */ get nodeBefore() {
        let index = this.index(this.depth);
        let dOff = this.pos - this.path[this.path.length - 1];
        if (dOff) return this.parent.child(index).cut(0, dOff);
        return index == 0 ? null : this.parent.child(index - 1);
    }
    /**
    Get the position at the given index in the parent node at the
    given depth (which defaults to `this.depth`).
    */ posAtIndex(index, depth) {
        depth = this.resolveDepth(depth);
        let node = this.path[depth * 3], pos = depth == 0 ? 0 : this.path[depth * 3 - 1] + 1;
        for(let i = 0; i < index; i++)pos += node.child(i).nodeSize;
        return pos;
    }
    /**
    Get the marks at this position, factoring in the surrounding
    marks' [`inclusive`](https://prosemirror.net/docs/ref/#model.MarkSpec.inclusive) property. If the
    position is at the start of a non-empty node, the marks of the
    node after it (if any) are returned.
    */ marks() {
        let parent = this.parent, index = this.index();
        // In an empty parent, return the empty array
        if (parent.content.size == 0) return $1a6f51facb51d04f$export$c9d15bcfc6d42044.none;
        // When inside a text node, just return the text node's marks
        if (this.textOffset) return parent.child(index).marks;
        let main = parent.maybeChild(index - 1), other = parent.maybeChild(index);
        // If the `after` flag is true of there is no node before, make
        // the node after this position the main reference.
        if (!main) {
            let tmp = main;
            main = other;
            other = tmp;
        }
        // Use all marks in the main node, except those that have
        // `inclusive` set to false and are not present in the other node.
        let marks = main.marks;
        for(var i = 0; i < marks.length; i++)if (marks[i].type.spec.inclusive === false && (!other || !marks[i].isInSet(other.marks))) marks = marks[i--].removeFromSet(marks);
        return marks;
    }
    /**
    Get the marks after the current position, if any, except those
    that are non-inclusive and not present at position `$end`. This
    is mostly useful for getting the set of marks to preserve after a
    deletion. Will return `null` if this position is at the end of
    its parent node or its parent node isn't a textblock (in which
    case no marks should be preserved).
    */ marksAcross($end) {
        let after = this.parent.maybeChild(this.index());
        if (!after || !after.isInline) return null;
        let marks = after.marks, next = $end.parent.maybeChild($end.index());
        for(var i = 0; i < marks.length; i++)if (marks[i].type.spec.inclusive === false && (!next || !marks[i].isInSet(next.marks))) marks = marks[i--].removeFromSet(marks);
        return marks;
    }
    /**
    The depth up to which this position and the given (non-resolved)
    position share the same parent nodes.
    */ sharedDepth(pos) {
        for(let depth = this.depth; depth > 0; depth--)if (this.start(depth) <= pos && this.end(depth) >= pos) return depth;
        return 0;
    }
    /**
    Returns a range based on the place where this position and the
    given position diverge around block content. If both point into
    the same textblock, for example, a range around that textblock
    will be returned. If they point into different blocks, the range
    around those blocks in their shared ancestor is returned. You can
    pass in an optional predicate that will be called with a parent
    node to see if a range into that parent is acceptable.
    */ blockRange(other = this, pred) {
        if (other.pos < this.pos) return other.blockRange(this);
        for(let d = this.depth - (this.parent.inlineContent || this.pos == other.pos ? 1 : 0); d >= 0; d--)if (other.pos <= this.end(d) && (!pred || pred(this.node(d)))) return new $1a6f51facb51d04f$export$7bc461ceb770fb16(this, other, d);
        return null;
    }
    /**
    Query whether the given position shares the same parent node.
    */ sameParent(other) {
        return this.pos - this.parentOffset == other.pos - other.parentOffset;
    }
    /**
    Return the greater of this and the given position.
    */ max(other) {
        return other.pos > this.pos ? other : this;
    }
    /**
    Return the smaller of this and the given position.
    */ min(other) {
        return other.pos < this.pos ? other : this;
    }
    /**
    @internal
    */ toString() {
        let str = "";
        for(let i = 1; i <= this.depth; i++)str += (str ? "/" : "") + this.node(i).type.name + "_" + this.index(i - 1);
        return str + ":" + this.parentOffset;
    }
    /**
    @internal
    */ static resolve(doc, pos) {
        if (!(pos >= 0 && pos <= doc.content.size)) throw new RangeError("Position " + pos + " out of range");
        let path = [];
        let start = 0, parentOffset = pos;
        for(let node = doc;;){
            let { index: index, offset: offset } = node.content.findIndex(parentOffset);
            let rem = parentOffset - offset;
            path.push(node, index, start + offset);
            if (!rem) break;
            node = node.child(index);
            if (node.isText) break;
            parentOffset = rem - 1;
            start += offset + 1;
        }
        return new $1a6f51facb51d04f$export$b2a42f82e59e4b19(pos, path, parentOffset);
    }
    /**
    @internal
    */ static resolveCached(doc, pos) {
        let cache = $1a6f51facb51d04f$var$resolveCache.get(doc);
        if (cache) for(let i = 0; i < cache.elts.length; i++){
            let elt = cache.elts[i];
            if (elt.pos == pos) return elt;
        }
        else $1a6f51facb51d04f$var$resolveCache.set(doc, cache = new $1a6f51facb51d04f$var$ResolveCache);
        let result = cache.elts[cache.i] = $1a6f51facb51d04f$export$b2a42f82e59e4b19.resolve(doc, pos);
        cache.i = (cache.i + 1) % $1a6f51facb51d04f$var$resolveCacheSize;
        return result;
    }
}
class $1a6f51facb51d04f$var$ResolveCache {
    constructor(){
        this.elts = [];
        this.i = 0;
    }
}
const $1a6f51facb51d04f$var$resolveCacheSize = 12, $1a6f51facb51d04f$var$resolveCache = new WeakMap();
/**
Represents a flat range of content, i.e. one that starts and
ends in the same node.
*/ class $1a6f51facb51d04f$export$7bc461ceb770fb16 {
    /**
    Construct a node range. `$from` and `$to` should point into the
    same node until at least the given `depth`, since a node range
    denotes an adjacent set of nodes in a single parent node.
    */ constructor(/**
    A resolved position along the start of the content. May have a
    `depth` greater than this object's `depth` property, since
    these are the positions that were used to compute the range,
    not re-resolved positions directly at its boundaries.
    */ $from, /**
    A position along the end of the content. See
    caveat for [`$from`](https://prosemirror.net/docs/ref/#model.NodeRange.$from).
    */ $to, /**
    The depth of the node that this range points into.
    */ depth){
        this.$from = $from;
        this.$to = $to;
        this.depth = depth;
    }
    /**
    The position at the start of the range.
    */ get start() {
        return this.$from.before(this.depth + 1);
    }
    /**
    The position at the end of the range.
    */ get end() {
        return this.$to.after(this.depth + 1);
    }
    /**
    The parent node that the range points into.
    */ get parent() {
        return this.$from.node(this.depth);
    }
    /**
    The start index of the range in the parent node.
    */ get startIndex() {
        return this.$from.index(this.depth);
    }
    /**
    The end index of the range in the parent node.
    */ get endIndex() {
        return this.$to.indexAfter(this.depth);
    }
}
const $1a6f51facb51d04f$var$emptyAttrs = Object.create(null);
/**
This class represents a node in the tree that makes up a
ProseMirror document. So a document is an instance of `Node`, with
children that are also instances of `Node`.

Nodes are persistent data structures. Instead of changing them, you
create new ones with the content you want. Old ones keep pointing
at the old document shape. This is made cheaper by sharing
structure between the old and new data as much as possible, which a
tree shape like this (without back pointers) makes easy.

**Do not** directly mutate the properties of a `Node` object. See
[the guide](/docs/guide/#doc) for more information.
*/ class $1a6f51facb51d04f$export$85c928794f8d04d4 {
    /**
    @internal
    */ constructor(/**
    The type of node that this is.
    */ type, /**
    An object mapping attribute names to values. The kind of
    attributes allowed and required are
    [determined](https://prosemirror.net/docs/ref/#model.NodeSpec.attrs) by the node type.
    */ attrs, // A fragment holding the node's children.
    content, /**
    The marks (things like whether it is emphasized or part of a
    link) applied to this node.
    */ marks = $1a6f51facb51d04f$export$c9d15bcfc6d42044.none){
        this.type = type;
        this.attrs = attrs;
        this.marks = marks;
        this.content = content || $1a6f51facb51d04f$export$ffb0004e005737fa.empty;
    }
    /**
    The array of this node's child nodes.
    */ get children() {
        return this.content.content;
    }
    /**
    The size of this node, as defined by the integer-based [indexing
    scheme](/docs/guide/#doc.indexing). For text nodes, this is the
    amount of characters. For other leaf nodes, it is one. For
    non-leaf nodes, it is the size of the content plus two (the
    start and end token).
    */ get nodeSize() {
        return this.isLeaf ? 1 : 2 + this.content.size;
    }
    /**
    The number of children that the node has.
    */ get childCount() {
        return this.content.childCount;
    }
    /**
    Get the child node at the given index. Raises an error when the
    index is out of range.
    */ child(index) {
        return this.content.child(index);
    }
    /**
    Get the child node at the given index, if it exists.
    */ maybeChild(index) {
        return this.content.maybeChild(index);
    }
    /**
    Call `f` for every child node, passing the node, its offset
    into this parent node, and its index.
    */ forEach(f) {
        this.content.forEach(f);
    }
    /**
    Invoke a callback for all descendant nodes recursively between
    the given two positions that are relative to start of this
    node's content. The callback is invoked with the node, its
    position relative to the original node (method receiver),
    its parent node, and its child index. When the callback returns
    false for a given node, that node's children will not be
    recursed over. The last parameter can be used to specify a
    starting position to count from.
    */ nodesBetween(from, to, f, startPos = 0) {
        this.content.nodesBetween(from, to, f, startPos, this);
    }
    /**
    Call the given callback for every descendant node. Doesn't
    descend into a node when the callback returns `false`.
    */ descendants(f) {
        this.nodesBetween(0, this.content.size, f);
    }
    /**
    Concatenates all the text nodes found in this fragment and its
    children.
    */ get textContent() {
        return this.isLeaf && this.type.spec.leafText ? this.type.spec.leafText(this) : this.textBetween(0, this.content.size, "");
    }
    /**
    Get all text between positions `from` and `to`. When
    `blockSeparator` is given, it will be inserted to separate text
    from different block nodes. If `leafText` is given, it'll be
    inserted for every non-text leaf node encountered, otherwise
    [`leafText`](https://prosemirror.net/docs/ref/#model.NodeSpec^leafText) will be used.
    */ textBetween(from, to, blockSeparator, leafText) {
        return this.content.textBetween(from, to, blockSeparator, leafText);
    }
    /**
    Returns this node's first child, or `null` if there are no
    children.
    */ get firstChild() {
        return this.content.firstChild;
    }
    /**
    Returns this node's last child, or `null` if there are no
    children.
    */ get lastChild() {
        return this.content.lastChild;
    }
    /**
    Test whether two nodes represent the same piece of document.
    */ eq(other) {
        return this == other || this.sameMarkup(other) && this.content.eq(other.content);
    }
    /**
    Compare the markup (type, attributes, and marks) of this node to
    those of another. Returns `true` if both have the same markup.
    */ sameMarkup(other) {
        return this.hasMarkup(other.type, other.attrs, other.marks);
    }
    /**
    Check whether this node's markup correspond to the given type,
    attributes, and marks.
    */ hasMarkup(type, attrs, marks) {
        return this.type == type && $1a6f51facb51d04f$var$compareDeep(this.attrs, attrs || type.defaultAttrs || $1a6f51facb51d04f$var$emptyAttrs) && $1a6f51facb51d04f$export$c9d15bcfc6d42044.sameSet(this.marks, marks || $1a6f51facb51d04f$export$c9d15bcfc6d42044.none);
    }
    /**
    Create a new node with the same markup as this node, containing
    the given content (or empty, if no content is given).
    */ copy(content = null) {
        if (content == this.content) return this;
        return new $1a6f51facb51d04f$export$85c928794f8d04d4(this.type, this.attrs, content, this.marks);
    }
    /**
    Create a copy of this node, with the given set of marks instead
    of the node's own marks.
    */ mark(marks) {
        return marks == this.marks ? this : new $1a6f51facb51d04f$export$85c928794f8d04d4(this.type, this.attrs, this.content, marks);
    }
    /**
    Create a copy of this node with only the content between the
    given positions. If `to` is not given, it defaults to the end of
    the node.
    */ cut(from, to = this.content.size) {
        if (from == 0 && to == this.content.size) return this;
        return this.copy(this.content.cut(from, to));
    }
    /**
    Cut out the part of the document between the given positions, and
    return it as a `Slice` object.
    */ slice(from, to = this.content.size, includeParents = false) {
        if (from == to) return $1a6f51facb51d04f$export$b3f2e2de3a8baa1e.empty;
        let $from = this.resolve(from), $to = this.resolve(to);
        let depth = includeParents ? 0 : $from.sharedDepth(to);
        let start = $from.start(depth), node = $from.node(depth);
        let content = node.content.cut($from.pos - start, $to.pos - start);
        return new $1a6f51facb51d04f$export$b3f2e2de3a8baa1e(content, $from.depth - depth, $to.depth - depth);
    }
    /**
    Replace the part of the document between the given positions with
    the given slice. The slice must 'fit', meaning its open sides
    must be able to connect to the surrounding content, and its
    content nodes must be valid children for the node they are placed
    into. If any of this is violated, an error of type
    [`ReplaceError`](https://prosemirror.net/docs/ref/#model.ReplaceError) is thrown.
    */ replace(from, to, slice) {
        return $1a6f51facb51d04f$var$replace(this.resolve(from), this.resolve(to), slice);
    }
    /**
    Find the node directly after the given position.
    */ nodeAt(pos) {
        for(let node = this;;){
            let { index: index, offset: offset } = node.content.findIndex(pos);
            node = node.maybeChild(index);
            if (!node) return null;
            if (offset == pos || node.isText) return node;
            pos -= offset + 1;
        }
    }
    /**
    Find the (direct) child node after the given offset, if any,
    and return it along with its index and offset relative to this
    node.
    */ childAfter(pos) {
        let { index: index, offset: offset } = this.content.findIndex(pos);
        return {
            node: this.content.maybeChild(index),
            index: index,
            offset: offset
        };
    }
    /**
    Find the (direct) child node before the given offset, if any,
    and return it along with its index and offset relative to this
    node.
    */ childBefore(pos) {
        if (pos == 0) return {
            node: null,
            index: 0,
            offset: 0
        };
        let { index: index, offset: offset } = this.content.findIndex(pos);
        if (offset < pos) return {
            node: this.content.child(index),
            index: index,
            offset: offset
        };
        let node = this.content.child(index - 1);
        return {
            node: node,
            index: index - 1,
            offset: offset - node.nodeSize
        };
    }
    /**
    Resolve the given position in the document, returning an
    [object](https://prosemirror.net/docs/ref/#model.ResolvedPos) with information about its context.
    */ resolve(pos) {
        return $1a6f51facb51d04f$export$b2a42f82e59e4b19.resolveCached(this, pos);
    }
    /**
    @internal
    */ resolveNoCache(pos) {
        return $1a6f51facb51d04f$export$b2a42f82e59e4b19.resolve(this, pos);
    }
    /**
    Test whether a given mark or mark type occurs in this document
    between the two given positions.
    */ rangeHasMark(from, to, type) {
        let found = false;
        if (to > from) this.nodesBetween(from, to, (node)=>{
            if (type.isInSet(node.marks)) found = true;
            return !found;
        });
        return found;
    }
    /**
    True when this is a block (non-inline node)
    */ get isBlock() {
        return this.type.isBlock;
    }
    /**
    True when this is a textblock node, a block node with inline
    content.
    */ get isTextblock() {
        return this.type.isTextblock;
    }
    /**
    True when this node allows inline content.
    */ get inlineContent() {
        return this.type.inlineContent;
    }
    /**
    True when this is an inline node (a text node or a node that can
    appear among text).
    */ get isInline() {
        return this.type.isInline;
    }
    /**
    True when this is a text node.
    */ get isText() {
        return this.type.isText;
    }
    /**
    True when this is a leaf node.
    */ get isLeaf() {
        return this.type.isLeaf;
    }
    /**
    True when this is an atom, i.e. when it does not have directly
    editable content. This is usually the same as `isLeaf`, but can
    be configured with the [`atom` property](https://prosemirror.net/docs/ref/#model.NodeSpec.atom)
    on a node's spec (typically used when the node is displayed as
    an uneditable [node view](https://prosemirror.net/docs/ref/#view.NodeView)).
    */ get isAtom() {
        return this.type.isAtom;
    }
    /**
    Return a string representation of this node for debugging
    purposes.
    */ toString() {
        if (this.type.spec.toDebugString) return this.type.spec.toDebugString(this);
        let name = this.type.name;
        if (this.content.size) name += "(" + this.content.toStringInner() + ")";
        return $1a6f51facb51d04f$var$wrapMarks(this.marks, name);
    }
    /**
    Get the content match in this node at the given index.
    */ contentMatchAt(index) {
        let match = this.type.contentMatch.matchFragment(this.content, 0, index);
        if (!match) throw new Error("Called contentMatchAt on a node with invalid content");
        return match;
    }
    /**
    Test whether replacing the range between `from` and `to` (by
    child index) with the given replacement fragment (which defaults
    to the empty fragment) would leave the node's content valid. You
    can optionally pass `start` and `end` indices into the
    replacement fragment.
    */ canReplace(from, to, replacement = $1a6f51facb51d04f$export$ffb0004e005737fa.empty, start = 0, end = replacement.childCount) {
        let one = this.contentMatchAt(from).matchFragment(replacement, start, end);
        let two = one && one.matchFragment(this.content, to);
        if (!two || !two.validEnd) return false;
        for(let i = start; i < end; i++)if (!this.type.allowsMarks(replacement.child(i).marks)) return false;
        return true;
    }
    /**
    Test whether replacing the range `from` to `to` (by index) with
    a node of the given type would leave the node's content valid.
    */ canReplaceWith(from, to, type, marks) {
        if (marks && !this.type.allowsMarks(marks)) return false;
        let start = this.contentMatchAt(from).matchType(type);
        let end = start && start.matchFragment(this.content, to);
        return end ? end.validEnd : false;
    }
    /**
    Test whether the given node's content could be appended to this
    node. If that node is empty, this will only return true if there
    is at least one node type that can appear in both nodes (to avoid
    merging completely incompatible nodes).
    */ canAppend(other) {
        if (other.content.size) return this.canReplace(this.childCount, this.childCount, other.content);
        else return this.type.compatibleContent(other.type);
    }
    /**
    Check whether this node and its descendants conform to the
    schema, and raise an exception when they do not.
    */ check() {
        this.type.checkContent(this.content);
        this.type.checkAttrs(this.attrs);
        let copy = $1a6f51facb51d04f$export$c9d15bcfc6d42044.none;
        for(let i = 0; i < this.marks.length; i++){
            let mark = this.marks[i];
            mark.type.checkAttrs(mark.attrs);
            copy = mark.addToSet(copy);
        }
        if (!$1a6f51facb51d04f$export$c9d15bcfc6d42044.sameSet(copy, this.marks)) throw new RangeError(`Invalid collection of marks for node ${this.type.name}: ${this.marks.map((m)=>m.type.name)}`);
        this.content.forEach((node)=>node.check());
    }
    /**
    Return a JSON-serializeable representation of this node.
    */ toJSON() {
        let obj = {
            type: this.type.name
        };
        for(let _ in this.attrs){
            obj.attrs = this.attrs;
            break;
        }
        if (this.content.size) obj.content = this.content.toJSON();
        if (this.marks.length) obj.marks = this.marks.map((n)=>n.toJSON());
        return obj;
    }
    /**
    Deserialize a node from its JSON representation.
    */ static fromJSON(schema, json) {
        if (!json) throw new RangeError("Invalid input for Node.fromJSON");
        let marks = undefined;
        if (json.marks) {
            if (!Array.isArray(json.marks)) throw new RangeError("Invalid mark data for Node.fromJSON");
            marks = json.marks.map(schema.markFromJSON);
        }
        if (json.type == "text") {
            if (typeof json.text != "string") throw new RangeError("Invalid text node in JSON");
            return schema.text(json.text, marks);
        }
        let content = $1a6f51facb51d04f$export$ffb0004e005737fa.fromJSON(schema, json.content);
        let node = schema.nodeType(json.type).create(json.attrs, content, marks);
        node.type.checkAttrs(node.attrs);
        return node;
    }
}
$1a6f51facb51d04f$export$85c928794f8d04d4.prototype.text = undefined;
class $1a6f51facb51d04f$var$TextNode extends $1a6f51facb51d04f$export$85c928794f8d04d4 {
    /**
    @internal
    */ constructor(type, attrs, content, marks){
        super(type, attrs, null, marks);
        if (!content) throw new RangeError("Empty text nodes are not allowed");
        this.text = content;
    }
    toString() {
        if (this.type.spec.toDebugString) return this.type.spec.toDebugString(this);
        return $1a6f51facb51d04f$var$wrapMarks(this.marks, JSON.stringify(this.text));
    }
    get textContent() {
        return this.text;
    }
    textBetween(from, to) {
        return this.text.slice(from, to);
    }
    get nodeSize() {
        return this.text.length;
    }
    mark(marks) {
        return marks == this.marks ? this : new $1a6f51facb51d04f$var$TextNode(this.type, this.attrs, this.text, marks);
    }
    withText(text) {
        if (text == this.text) return this;
        return new $1a6f51facb51d04f$var$TextNode(this.type, this.attrs, text, this.marks);
    }
    cut(from = 0, to = this.text.length) {
        if (from == 0 && to == this.text.length) return this;
        return this.withText(this.text.slice(from, to));
    }
    eq(other) {
        return this.sameMarkup(other) && this.text == other.text;
    }
    toJSON() {
        let base = super.toJSON();
        base.text = this.text;
        return base;
    }
}
function $1a6f51facb51d04f$var$wrapMarks(marks, str) {
    for(let i = marks.length - 1; i >= 0; i--)str = marks[i].type.name + "(" + str + ")";
    return str;
}
/**
Instances of this class represent a match state of a node type's
[content expression](https://prosemirror.net/docs/ref/#model.NodeSpec.content), and can be used to
find out whether further content matches here, and whether a given
position is a valid end of the node.
*/ class $1a6f51facb51d04f$export$364ed450558d7ec4 {
    /**
    @internal
    */ constructor(/**
    True when this match state represents a valid end of the node.
    */ validEnd){
        this.validEnd = validEnd;
        /**
        @internal
        */ this.next = [];
        /**
        @internal
        */ this.wrapCache = [];
    }
    /**
    @internal
    */ static parse(string, nodeTypes) {
        let stream = new $1a6f51facb51d04f$var$TokenStream(string, nodeTypes);
        if (stream.next == null) return $1a6f51facb51d04f$export$364ed450558d7ec4.empty;
        let expr = $1a6f51facb51d04f$var$parseExpr(stream);
        if (stream.next) stream.err("Unexpected trailing text");
        let match = $1a6f51facb51d04f$var$dfa($1a6f51facb51d04f$var$nfa(expr));
        $1a6f51facb51d04f$var$checkForDeadEnds(match, stream);
        return match;
    }
    /**
    Match a node type, returning a match after that node if
    successful.
    */ matchType(type) {
        for(let i = 0; i < this.next.length; i++)if (this.next[i].type == type) return this.next[i].next;
        return null;
    }
    /**
    Try to match a fragment. Returns the resulting match when
    successful.
    */ matchFragment(frag, start = 0, end = frag.childCount) {
        let cur = this;
        for(let i = start; cur && i < end; i++)cur = cur.matchType(frag.child(i).type);
        return cur;
    }
    /**
    @internal
    */ get inlineContent() {
        return this.next.length != 0 && this.next[0].type.isInline;
    }
    /**
    Get the first matching node type at this match position that can
    be generated.
    */ get defaultType() {
        for(let i = 0; i < this.next.length; i++){
            let { type: type } = this.next[i];
            if (!(type.isText || type.hasRequiredAttrs())) return type;
        }
        return null;
    }
    /**
    @internal
    */ compatible(other) {
        for(let i = 0; i < this.next.length; i++)for(let j = 0; j < other.next.length; j++)if (this.next[i].type == other.next[j].type) return true;
        return false;
    }
    /**
    Try to match the given fragment, and if that fails, see if it can
    be made to match by inserting nodes in front of it. When
    successful, return a fragment of inserted nodes (which may be
    empty if nothing had to be inserted). When `toEnd` is true, only
    return a fragment if the resulting match goes to the end of the
    content expression.
    */ fillBefore(after, toEnd = false, startIndex = 0) {
        let seen = [
            this
        ];
        function search(match, types) {
            let finished = match.matchFragment(after, startIndex);
            if (finished && (!toEnd || finished.validEnd)) return $1a6f51facb51d04f$export$ffb0004e005737fa.from(types.map((tp)=>tp.createAndFill()));
            for(let i = 0; i < match.next.length; i++){
                let { type: type, next: next } = match.next[i];
                if (!(type.isText || type.hasRequiredAttrs()) && seen.indexOf(next) == -1) {
                    seen.push(next);
                    let found = search(next, types.concat(type));
                    if (found) return found;
                }
            }
            return null;
        }
        return search(this, []);
    }
    /**
    Find a set of wrapping node types that would allow a node of the
    given type to appear at this position. The result may be empty
    (when it fits directly) and will be null when no such wrapping
    exists.
    */ findWrapping(target) {
        for(let i = 0; i < this.wrapCache.length; i += 2)if (this.wrapCache[i] == target) return this.wrapCache[i + 1];
        let computed = this.computeWrapping(target);
        this.wrapCache.push(target, computed);
        return computed;
    }
    /**
    @internal
    */ computeWrapping(target) {
        let seen = Object.create(null), active = [
            {
                match: this,
                type: null,
                via: null
            }
        ];
        while(active.length){
            let current = active.shift(), match = current.match;
            if (match.matchType(target)) {
                let result = [];
                for(let obj = current; obj.type; obj = obj.via)result.push(obj.type);
                return result.reverse();
            }
            for(let i = 0; i < match.next.length; i++){
                let { type: type, next: next } = match.next[i];
                if (!type.isLeaf && !type.hasRequiredAttrs() && !(type.name in seen) && (!current.type || next.validEnd)) {
                    active.push({
                        match: type.contentMatch,
                        type: type,
                        via: current
                    });
                    seen[type.name] = true;
                }
            }
        }
        return null;
    }
    /**
    The number of outgoing edges this node has in the finite
    automaton that describes the content expression.
    */ get edgeCount() {
        return this.next.length;
    }
    /**
    Get the _n_​th outgoing edge from this node in the finite
    automaton that describes the content expression.
    */ edge(n) {
        if (n >= this.next.length) throw new RangeError(`There's no ${n}th edge in this content match`);
        return this.next[n];
    }
    /**
    @internal
    */ toString() {
        let seen = [];
        function scan(m) {
            seen.push(m);
            for(let i = 0; i < m.next.length; i++)if (seen.indexOf(m.next[i].next) == -1) scan(m.next[i].next);
        }
        scan(this);
        return seen.map((m, i)=>{
            let out = i + (m.validEnd ? "*" : " ") + " ";
            for(let i = 0; i < m.next.length; i++)out += (i ? ", " : "") + m.next[i].type.name + "->" + seen.indexOf(m.next[i].next);
            return out;
        }).join("\n");
    }
}
/**
@internal
*/ $1a6f51facb51d04f$export$364ed450558d7ec4.empty = new $1a6f51facb51d04f$export$364ed450558d7ec4(true);
class $1a6f51facb51d04f$var$TokenStream {
    constructor(string, nodeTypes){
        this.string = string;
        this.nodeTypes = nodeTypes;
        this.inline = null;
        this.pos = 0;
        this.tokens = string.split(/\s*(?=\b|\W|$)/);
        if (this.tokens[this.tokens.length - 1] == "") this.tokens.pop();
        if (this.tokens[0] == "") this.tokens.shift();
    }
    get next() {
        return this.tokens[this.pos];
    }
    eat(tok) {
        return this.next == tok && (this.pos++ || true);
    }
    err(str) {
        throw new SyntaxError(str + " (in content expression '" + this.string + "')");
    }
}
function $1a6f51facb51d04f$var$parseExpr(stream) {
    let exprs = [];
    do exprs.push($1a6f51facb51d04f$var$parseExprSeq(stream));
    while (stream.eat("|"));
    return exprs.length == 1 ? exprs[0] : {
        type: "choice",
        exprs: exprs
    };
}
function $1a6f51facb51d04f$var$parseExprSeq(stream) {
    let exprs = [];
    do exprs.push($1a6f51facb51d04f$var$parseExprSubscript(stream));
    while (stream.next && stream.next != ")" && stream.next != "|");
    return exprs.length == 1 ? exprs[0] : {
        type: "seq",
        exprs: exprs
    };
}
function $1a6f51facb51d04f$var$parseExprSubscript(stream) {
    let expr = $1a6f51facb51d04f$var$parseExprAtom(stream);
    for(;;){
        if (stream.eat("+")) expr = {
            type: "plus",
            expr: expr
        };
        else if (stream.eat("*")) expr = {
            type: "star",
            expr: expr
        };
        else if (stream.eat("?")) expr = {
            type: "opt",
            expr: expr
        };
        else if (stream.eat("{")) expr = $1a6f51facb51d04f$var$parseExprRange(stream, expr);
        else break;
    }
    return expr;
}
function $1a6f51facb51d04f$var$parseNum(stream) {
    if (/\D/.test(stream.next)) stream.err("Expected number, got '" + stream.next + "'");
    let result = Number(stream.next);
    stream.pos++;
    return result;
}
function $1a6f51facb51d04f$var$parseExprRange(stream, expr) {
    let min = $1a6f51facb51d04f$var$parseNum(stream), max = min;
    if (stream.eat(",")) {
        if (stream.next != "}") max = $1a6f51facb51d04f$var$parseNum(stream);
        else max = -1;
    }
    if (!stream.eat("}")) stream.err("Unclosed braced range");
    return {
        type: "range",
        min: min,
        max: max,
        expr: expr
    };
}
function $1a6f51facb51d04f$var$resolveName(stream, name) {
    let types = stream.nodeTypes, type = types[name];
    if (type) return [
        type
    ];
    let result = [];
    for(let typeName in types){
        let type = types[typeName];
        if (type.isInGroup(name)) result.push(type);
    }
    if (result.length == 0) stream.err("No node type or group '" + name + "' found");
    return result;
}
function $1a6f51facb51d04f$var$parseExprAtom(stream) {
    if (stream.eat("(")) {
        let expr = $1a6f51facb51d04f$var$parseExpr(stream);
        if (!stream.eat(")")) stream.err("Missing closing paren");
        return expr;
    } else if (!/\W/.test(stream.next)) {
        let exprs = $1a6f51facb51d04f$var$resolveName(stream, stream.next).map((type)=>{
            if (stream.inline == null) stream.inline = type.isInline;
            else if (stream.inline != type.isInline) stream.err("Mixing inline and block content");
            return {
                type: "name",
                value: type
            };
        });
        stream.pos++;
        return exprs.length == 1 ? exprs[0] : {
            type: "choice",
            exprs: exprs
        };
    } else stream.err("Unexpected token '" + stream.next + "'");
}
// Construct an NFA from an expression as returned by the parser. The
// NFA is represented as an array of states, which are themselves
// arrays of edges, which are `{term, to}` objects. The first state is
// the entry state and the last node is the success state.
//
// Note that unlike typical NFAs, the edge ordering in this one is
// significant, in that it is used to contruct filler content when
// necessary.
function $1a6f51facb51d04f$var$nfa(expr) {
    let nfa = [
        []
    ];
    connect(compile(expr, 0), node());
    return nfa;
    function node() {
        return nfa.push([]) - 1;
    }
    function edge(from, to, term) {
        let edge = {
            term: term,
            to: to
        };
        nfa[from].push(edge);
        return edge;
    }
    function connect(edges, to) {
        edges.forEach((edge)=>edge.to = to);
    }
    function compile(expr, from) {
        if (expr.type == "choice") return expr.exprs.reduce((out, expr)=>out.concat(compile(expr, from)), []);
        else if (expr.type == "seq") for(let i = 0;; i++){
            let next = compile(expr.exprs[i], from);
            if (i == expr.exprs.length - 1) return next;
            connect(next, from = node());
        }
        else if (expr.type == "star") {
            let loop = node();
            edge(from, loop);
            connect(compile(expr.expr, loop), loop);
            return [
                edge(loop)
            ];
        } else if (expr.type == "plus") {
            let loop = node();
            connect(compile(expr.expr, from), loop);
            connect(compile(expr.expr, loop), loop);
            return [
                edge(loop)
            ];
        } else if (expr.type == "opt") return [
            edge(from)
        ].concat(compile(expr.expr, from));
        else if (expr.type == "range") {
            let cur = from;
            for(let i = 0; i < expr.min; i++){
                let next = node();
                connect(compile(expr.expr, cur), next);
                cur = next;
            }
            if (expr.max == -1) connect(compile(expr.expr, cur), cur);
            else for(let i = expr.min; i < expr.max; i++){
                let next = node();
                edge(cur, next);
                connect(compile(expr.expr, cur), next);
                cur = next;
            }
            return [
                edge(cur)
            ];
        } else if (expr.type == "name") return [
            edge(from, undefined, expr.value)
        ];
        else throw new Error("Unknown expr type");
    }
}
function $1a6f51facb51d04f$var$cmp(a, b) {
    return b - a;
}
// Get the set of nodes reachable by null edges from `node`. Omit
// nodes with only a single null-out-edge, since they may lead to
// needless duplicated nodes.
function $1a6f51facb51d04f$var$nullFrom(nfa, node) {
    let result = [];
    scan(node);
    return result.sort($1a6f51facb51d04f$var$cmp);
    function scan(node) {
        let edges = nfa[node];
        if (edges.length == 1 && !edges[0].term) return scan(edges[0].to);
        result.push(node);
        for(let i = 0; i < edges.length; i++){
            let { term: term, to: to } = edges[i];
            if (!term && result.indexOf(to) == -1) scan(to);
        }
    }
}
// Compiles an NFA as produced by `nfa` into a DFA, modeled as a set
// of state objects (`ContentMatch` instances) with transitions
// between them.
function $1a6f51facb51d04f$var$dfa(nfa) {
    let labeled = Object.create(null);
    return explore($1a6f51facb51d04f$var$nullFrom(nfa, 0));
    function explore(states) {
        let out = [];
        states.forEach((node)=>{
            nfa[node].forEach(({ term: term, to: to })=>{
                if (!term) return;
                let set;
                for(let i = 0; i < out.length; i++)if (out[i][0] == term) set = out[i][1];
                $1a6f51facb51d04f$var$nullFrom(nfa, to).forEach((node)=>{
                    if (!set) out.push([
                        term,
                        set = []
                    ]);
                    if (set.indexOf(node) == -1) set.push(node);
                });
            });
        });
        let state = labeled[states.join(",")] = new $1a6f51facb51d04f$export$364ed450558d7ec4(states.indexOf(nfa.length - 1) > -1);
        for(let i = 0; i < out.length; i++){
            let states = out[i][1].sort($1a6f51facb51d04f$var$cmp);
            state.next.push({
                type: out[i][0],
                next: labeled[states.join(",")] || explore(states)
            });
        }
        return state;
    }
}
function $1a6f51facb51d04f$var$checkForDeadEnds(match, stream) {
    for(let i = 0, work = [
        match
    ]; i < work.length; i++){
        let state = work[i], dead = !state.validEnd, nodes = [];
        for(let j = 0; j < state.next.length; j++){
            let { type: type, next: next } = state.next[j];
            nodes.push(type.name);
            if (dead && !(type.isText || type.hasRequiredAttrs())) dead = false;
            if (work.indexOf(next) == -1) work.push(next);
        }
        if (dead) stream.err("Only non-generatable nodes (" + nodes.join(", ") + ") in a required position (see https://prosemirror.net/docs/guide/#generatable)");
    }
}
// For node types where all attrs have a default value (or which don't
// have any attributes), build up a single reusable default attribute
// object, and use it for all nodes that don't specify specific
// attributes.
function $1a6f51facb51d04f$var$defaultAttrs(attrs) {
    let defaults = Object.create(null);
    for(let attrName in attrs){
        let attr = attrs[attrName];
        if (!attr.hasDefault) return null;
        defaults[attrName] = attr.default;
    }
    return defaults;
}
function $1a6f51facb51d04f$var$computeAttrs(attrs, value) {
    let built = Object.create(null);
    for(let name in attrs){
        let given = value && value[name];
        if (given === undefined) {
            let attr = attrs[name];
            if (attr.hasDefault) given = attr.default;
            else throw new RangeError("No value supplied for attribute " + name);
        }
        built[name] = given;
    }
    return built;
}
function $1a6f51facb51d04f$var$checkAttrs(attrs, values, type, name) {
    for(let name in values)if (!(name in attrs)) throw new RangeError(`Unsupported attribute ${name} for ${type} of type ${name}`);
    for(let name in attrs){
        let attr = attrs[name];
        if (attr.validate) attr.validate(values[name]);
    }
}
function $1a6f51facb51d04f$var$initAttrs(typeName, attrs) {
    let result = Object.create(null);
    if (attrs) for(let name in attrs)result[name] = new $1a6f51facb51d04f$var$Attribute(typeName, name, attrs[name]);
    return result;
}
/**
Node types are objects allocated once per `Schema` and used to
[tag](https://prosemirror.net/docs/ref/#model.Node.type) `Node` instances. They contain information
about the node type, such as its name and what kind of node it
represents.
*/ class $1a6f51facb51d04f$export$f06e977173f1857c {
    /**
    @internal
    */ constructor(/**
    The name the node type has in this schema.
    */ name, /**
    A link back to the `Schema` the node type belongs to.
    */ schema, /**
    The spec that this type is based on
    */ spec){
        this.name = name;
        this.schema = schema;
        this.spec = spec;
        /**
        The set of marks allowed in this node. `null` means all marks
        are allowed.
        */ this.markSet = null;
        this.groups = spec.group ? spec.group.split(" ") : [];
        this.attrs = $1a6f51facb51d04f$var$initAttrs(name, spec.attrs);
        this.defaultAttrs = $1a6f51facb51d04f$var$defaultAttrs(this.attrs);
        this.contentMatch = null;
        this.inlineContent = null;
        this.isBlock = !(spec.inline || name == "text");
        this.isText = name == "text";
    }
    /**
    True if this is an inline type.
    */ get isInline() {
        return !this.isBlock;
    }
    /**
    True if this is a textblock type, a block that contains inline
    content.
    */ get isTextblock() {
        return this.isBlock && this.inlineContent;
    }
    /**
    True for node types that allow no content.
    */ get isLeaf() {
        return this.contentMatch == $1a6f51facb51d04f$export$364ed450558d7ec4.empty;
    }
    /**
    True when this node is an atom, i.e. when it does not have
    directly editable content.
    */ get isAtom() {
        return this.isLeaf || !!this.spec.atom;
    }
    /**
    Return true when this node type is part of the given
    [group](https://prosemirror.net/docs/ref/#model.NodeSpec.group).
    */ isInGroup(group) {
        return this.groups.indexOf(group) > -1;
    }
    /**
    The node type's [whitespace](https://prosemirror.net/docs/ref/#model.NodeSpec.whitespace) option.
    */ get whitespace() {
        return this.spec.whitespace || (this.spec.code ? "pre" : "normal");
    }
    /**
    Tells you whether this node type has any required attributes.
    */ hasRequiredAttrs() {
        for(let n in this.attrs)if (this.attrs[n].isRequired) return true;
        return false;
    }
    /**
    Indicates whether this node allows some of the same content as
    the given node type.
    */ compatibleContent(other) {
        return this == other || this.contentMatch.compatible(other.contentMatch);
    }
    /**
    @internal
    */ computeAttrs(attrs) {
        if (!attrs && this.defaultAttrs) return this.defaultAttrs;
        else return $1a6f51facb51d04f$var$computeAttrs(this.attrs, attrs);
    }
    /**
    Create a `Node` of this type. The given attributes are
    checked and defaulted (you can pass `null` to use the type's
    defaults entirely, if no required attributes exist). `content`
    may be a `Fragment`, a node, an array of nodes, or
    `null`. Similarly `marks` may be `null` to default to the empty
    set of marks.
    */ create(attrs = null, content, marks) {
        if (this.isText) throw new Error("NodeType.create can't construct text nodes");
        return new $1a6f51facb51d04f$export$85c928794f8d04d4(this, this.computeAttrs(attrs), $1a6f51facb51d04f$export$ffb0004e005737fa.from(content), $1a6f51facb51d04f$export$c9d15bcfc6d42044.setFrom(marks));
    }
    /**
    Like [`create`](https://prosemirror.net/docs/ref/#model.NodeType.create), but check the given content
    against the node type's content restrictions, and throw an error
    if it doesn't match.
    */ createChecked(attrs = null, content, marks) {
        content = $1a6f51facb51d04f$export$ffb0004e005737fa.from(content);
        this.checkContent(content);
        return new $1a6f51facb51d04f$export$85c928794f8d04d4(this, this.computeAttrs(attrs), content, $1a6f51facb51d04f$export$c9d15bcfc6d42044.setFrom(marks));
    }
    /**
    Like [`create`](https://prosemirror.net/docs/ref/#model.NodeType.create), but see if it is
    necessary to add nodes to the start or end of the given fragment
    to make it fit the node. If no fitting wrapping can be found,
    return null. Note that, due to the fact that required nodes can
    always be created, this will always succeed if you pass null or
    `Fragment.empty` as content.
    */ createAndFill(attrs = null, content, marks) {
        attrs = this.computeAttrs(attrs);
        content = $1a6f51facb51d04f$export$ffb0004e005737fa.from(content);
        if (content.size) {
            let before = this.contentMatch.fillBefore(content);
            if (!before) return null;
            content = before.append(content);
        }
        let matched = this.contentMatch.matchFragment(content);
        let after = matched && matched.fillBefore($1a6f51facb51d04f$export$ffb0004e005737fa.empty, true);
        if (!after) return null;
        return new $1a6f51facb51d04f$export$85c928794f8d04d4(this, attrs, content.append(after), $1a6f51facb51d04f$export$c9d15bcfc6d42044.setFrom(marks));
    }
    /**
    Returns true if the given fragment is valid content for this node
    type.
    */ validContent(content) {
        let result = this.contentMatch.matchFragment(content);
        if (!result || !result.validEnd) return false;
        for(let i = 0; i < content.childCount; i++)if (!this.allowsMarks(content.child(i).marks)) return false;
        return true;
    }
    /**
    Throws a RangeError if the given fragment is not valid content for this
    node type.
    @internal
    */ checkContent(content) {
        if (!this.validContent(content)) throw new RangeError(`Invalid content for node ${this.name}: ${content.toString().slice(0, 50)}`);
    }
    /**
    @internal
    */ checkAttrs(attrs) {
        $1a6f51facb51d04f$var$checkAttrs(this.attrs, attrs, "node", this.name);
    }
    /**
    Check whether the given mark type is allowed in this node.
    */ allowsMarkType(markType) {
        return this.markSet == null || this.markSet.indexOf(markType) > -1;
    }
    /**
    Test whether the given set of marks are allowed in this node.
    */ allowsMarks(marks) {
        if (this.markSet == null) return true;
        for(let i = 0; i < marks.length; i++)if (!this.allowsMarkType(marks[i].type)) return false;
        return true;
    }
    /**
    Removes the marks that are not allowed in this node from the given set.
    */ allowedMarks(marks) {
        if (this.markSet == null) return marks;
        let copy;
        for(let i = 0; i < marks.length; i++){
            if (!this.allowsMarkType(marks[i].type)) {
                if (!copy) copy = marks.slice(0, i);
            } else if (copy) copy.push(marks[i]);
        }
        return !copy ? marks : copy.length ? copy : $1a6f51facb51d04f$export$c9d15bcfc6d42044.none;
    }
    /**
    @internal
    */ static compile(nodes, schema) {
        let result = Object.create(null);
        nodes.forEach((name, spec)=>result[name] = new $1a6f51facb51d04f$export$f06e977173f1857c(name, schema, spec));
        let topType = schema.spec.topNode || "doc";
        if (!result[topType]) throw new RangeError("Schema is missing its top node type ('" + topType + "')");
        if (!result.text) throw new RangeError("Every schema needs a 'text' type");
        for(let _ in result.text.attrs)throw new RangeError("The text node type should not have attributes");
        return result;
    }
}
function $1a6f51facb51d04f$var$validateType(typeName, attrName, type) {
    let types = type.split("|");
    return (value)=>{
        let name = value === null ? "null" : typeof value;
        if (types.indexOf(name) < 0) throw new RangeError(`Expected value of type ${types} for attribute ${attrName} on type ${typeName}, got ${name}`);
    };
}
// Attribute descriptors
class $1a6f51facb51d04f$var$Attribute {
    constructor(typeName, attrName, options){
        this.hasDefault = Object.prototype.hasOwnProperty.call(options, "default");
        this.default = options.default;
        this.validate = typeof options.validate == "string" ? $1a6f51facb51d04f$var$validateType(typeName, attrName, options.validate) : options.validate;
    }
    get isRequired() {
        return !this.hasDefault;
    }
}
// Marks
/**
Like nodes, marks (which are associated with nodes to signify
things like emphasis or being part of a link) are
[tagged](https://prosemirror.net/docs/ref/#model.Mark.type) with type objects, which are
instantiated once per `Schema`.
*/ class $1a6f51facb51d04f$export$b6a78689043c6521 {
    /**
    @internal
    */ constructor(/**
    The name of the mark type.
    */ name, /**
    @internal
    */ rank, /**
    The schema that this mark type instance is part of.
    */ schema, /**
    The spec on which the type is based.
    */ spec){
        this.name = name;
        this.rank = rank;
        this.schema = schema;
        this.spec = spec;
        this.attrs = $1a6f51facb51d04f$var$initAttrs(name, spec.attrs);
        this.excluded = null;
        let defaults = $1a6f51facb51d04f$var$defaultAttrs(this.attrs);
        this.instance = defaults ? new $1a6f51facb51d04f$export$c9d15bcfc6d42044(this, defaults) : null;
    }
    /**
    Create a mark of this type. `attrs` may be `null` or an object
    containing only some of the mark's attributes. The others, if
    they have defaults, will be added.
    */ create(attrs = null) {
        if (!attrs && this.instance) return this.instance;
        return new $1a6f51facb51d04f$export$c9d15bcfc6d42044(this, $1a6f51facb51d04f$var$computeAttrs(this.attrs, attrs));
    }
    /**
    @internal
    */ static compile(marks, schema) {
        let result = Object.create(null), rank = 0;
        marks.forEach((name, spec)=>result[name] = new $1a6f51facb51d04f$export$b6a78689043c6521(name, rank++, schema, spec));
        return result;
    }
    /**
    When there is a mark of this type in the given set, a new set
    without it is returned. Otherwise, the input set is returned.
    */ removeFromSet(set) {
        for(var i = 0; i < set.length; i++)if (set[i].type == this) {
            set = set.slice(0, i).concat(set.slice(i + 1));
            i--;
        }
        return set;
    }
    /**
    Tests whether there is a mark of this type in the given set.
    */ isInSet(set) {
        for(let i = 0; i < set.length; i++)if (set[i].type == this) return set[i];
    }
    /**
    @internal
    */ checkAttrs(attrs) {
        $1a6f51facb51d04f$var$checkAttrs(this.attrs, attrs, "mark", this.name);
    }
    /**
    Queries whether a given mark type is
    [excluded](https://prosemirror.net/docs/ref/#model.MarkSpec.excludes) by this one.
    */ excludes(other) {
        return this.excluded.indexOf(other) > -1;
    }
}
/**
A document schema. Holds [node](https://prosemirror.net/docs/ref/#model.NodeType) and [mark
type](https://prosemirror.net/docs/ref/#model.MarkType) objects for the nodes and marks that may
occur in conforming documents, and provides functionality for
creating and deserializing such documents.

When given, the type parameters provide the names of the nodes and
marks in this schema.
*/ class $1a6f51facb51d04f$export$19342e026b58ebb7 {
    /**
    Construct a schema from a schema [specification](https://prosemirror.net/docs/ref/#model.SchemaSpec).
    */ constructor(spec){
        /**
        The [linebreak
        replacement](https://prosemirror.net/docs/ref/#model.NodeSpec.linebreakReplacement) node defined
        in this schema, if any.
        */ this.linebreakReplacement = null;
        /**
        An object for storing whatever values modules may want to
        compute and cache per schema. (If you want to store something
        in it, try to use property names unlikely to clash.)
        */ this.cached = Object.create(null);
        let instanceSpec = this.spec = {};
        for(let prop in spec)instanceSpec[prop] = spec[prop];
        instanceSpec.nodes = (0, $at9VT.default).from(spec.nodes), instanceSpec.marks = (0, $at9VT.default).from(spec.marks || {}), this.nodes = $1a6f51facb51d04f$export$f06e977173f1857c.compile(this.spec.nodes, this);
        this.marks = $1a6f51facb51d04f$export$b6a78689043c6521.compile(this.spec.marks, this);
        let contentExprCache = Object.create(null);
        for(let prop in this.nodes){
            if (prop in this.marks) throw new RangeError(prop + " can not be both a node and a mark");
            let type = this.nodes[prop], contentExpr = type.spec.content || "", markExpr = type.spec.marks;
            type.contentMatch = contentExprCache[contentExpr] || (contentExprCache[contentExpr] = $1a6f51facb51d04f$export$364ed450558d7ec4.parse(contentExpr, this.nodes));
            type.inlineContent = type.contentMatch.inlineContent;
            if (type.spec.linebreakReplacement) {
                if (this.linebreakReplacement) throw new RangeError("Multiple linebreak nodes defined");
                if (!type.isInline || !type.isLeaf) throw new RangeError("Linebreak replacement nodes must be inline leaf nodes");
                this.linebreakReplacement = type;
            }
            type.markSet = markExpr == "_" ? null : markExpr ? $1a6f51facb51d04f$var$gatherMarks(this, markExpr.split(" ")) : markExpr == "" || !type.inlineContent ? [] : null;
        }
        for(let prop in this.marks){
            let type = this.marks[prop], excl = type.spec.excludes;
            type.excluded = excl == null ? [
                type
            ] : excl == "" ? [] : $1a6f51facb51d04f$var$gatherMarks(this, excl.split(" "));
        }
        this.nodeFromJSON = this.nodeFromJSON.bind(this);
        this.markFromJSON = this.markFromJSON.bind(this);
        this.topNodeType = this.nodes[this.spec.topNode || "doc"];
        this.cached.wrappings = Object.create(null);
    }
    /**
    Create a node in this schema. The `type` may be a string or a
    `NodeType` instance. Attributes will be extended with defaults,
    `content` may be a `Fragment`, `null`, a `Node`, or an array of
    nodes.
    */ node(type, attrs = null, content, marks) {
        if (typeof type == "string") type = this.nodeType(type);
        else if (!(type instanceof $1a6f51facb51d04f$export$f06e977173f1857c)) throw new RangeError("Invalid node type: " + type);
        else if (type.schema != this) throw new RangeError("Node type from different schema used (" + type.name + ")");
        return type.createChecked(attrs, content, marks);
    }
    /**
    Create a text node in the schema. Empty text nodes are not
    allowed.
    */ text(text, marks) {
        let type = this.nodes.text;
        return new $1a6f51facb51d04f$var$TextNode(type, type.defaultAttrs, text, $1a6f51facb51d04f$export$c9d15bcfc6d42044.setFrom(marks));
    }
    /**
    Create a mark with the given type and attributes.
    */ mark(type, attrs) {
        if (typeof type == "string") type = this.marks[type];
        return type.create(attrs);
    }
    /**
    Deserialize a node from its JSON representation. This method is
    bound.
    */ nodeFromJSON(json) {
        return $1a6f51facb51d04f$export$85c928794f8d04d4.fromJSON(this, json);
    }
    /**
    Deserialize a mark from its JSON representation. This method is
    bound.
    */ markFromJSON(json) {
        return $1a6f51facb51d04f$export$c9d15bcfc6d42044.fromJSON(this, json);
    }
    /**
    @internal
    */ nodeType(name) {
        let found = this.nodes[name];
        if (!found) throw new RangeError("Unknown node type: " + name);
        return found;
    }
}
function $1a6f51facb51d04f$var$gatherMarks(schema, marks) {
    let found = [];
    for(let i = 0; i < marks.length; i++){
        let name = marks[i], mark = schema.marks[name], ok = mark;
        if (mark) found.push(mark);
        else for(let prop in schema.marks){
            let mark = schema.marks[prop];
            if (name == "_" || mark.spec.group && mark.spec.group.split(" ").indexOf(name) > -1) found.push(ok = mark);
        }
        if (!ok) throw new SyntaxError("Unknown mark type: '" + marks[i] + "'");
    }
    return found;
}
function $1a6f51facb51d04f$var$isTagRule(rule) {
    return rule.tag != null;
}
function $1a6f51facb51d04f$var$isStyleRule(rule) {
    return rule.style != null;
}
/**
A DOM parser represents a strategy for parsing DOM content into a
ProseMirror document conforming to a given schema. Its behavior is
defined by an array of [rules](https://prosemirror.net/docs/ref/#model.ParseRule).
*/ class $1a6f51facb51d04f$export$1059c6e7d2ce5669 {
    /**
    Create a parser that targets the given schema, using the given
    parsing rules.
    */ constructor(/**
    The schema into which the parser parses.
    */ schema, /**
    The set of [parse rules](https://prosemirror.net/docs/ref/#model.ParseRule) that the parser
    uses, in order of precedence.
    */ rules){
        this.schema = schema;
        this.rules = rules;
        /**
        @internal
        */ this.tags = [];
        /**
        @internal
        */ this.styles = [];
        let matchedStyles = this.matchedStyles = [];
        rules.forEach((rule)=>{
            if ($1a6f51facb51d04f$var$isTagRule(rule)) this.tags.push(rule);
            else if ($1a6f51facb51d04f$var$isStyleRule(rule)) {
                let prop = /[^=]*/.exec(rule.style)[0];
                if (matchedStyles.indexOf(prop) < 0) matchedStyles.push(prop);
                this.styles.push(rule);
            }
        });
        // Only normalize list elements when lists in the schema can't directly contain themselves
        this.normalizeLists = !this.tags.some((r)=>{
            if (!/^(ul|ol)\b/.test(r.tag) || !r.node) return false;
            let node = schema.nodes[r.node];
            return node.contentMatch.matchType(node);
        });
    }
    /**
    Parse a document from the content of a DOM node.
    */ parse(dom, options = {}) {
        let context = new $1a6f51facb51d04f$var$ParseContext(this, options, false);
        context.addAll(dom, $1a6f51facb51d04f$export$c9d15bcfc6d42044.none, options.from, options.to);
        return context.finish();
    }
    /**
    Parses the content of the given DOM node, like
    [`parse`](https://prosemirror.net/docs/ref/#model.DOMParser.parse), and takes the same set of
    options. But unlike that method, which produces a whole node,
    this one returns a slice that is open at the sides, meaning that
    the schema constraints aren't applied to the start of nodes to
    the left of the input and the end of nodes at the end.
    */ parseSlice(dom, options = {}) {
        let context = new $1a6f51facb51d04f$var$ParseContext(this, options, true);
        context.addAll(dom, $1a6f51facb51d04f$export$c9d15bcfc6d42044.none, options.from, options.to);
        return $1a6f51facb51d04f$export$b3f2e2de3a8baa1e.maxOpen(context.finish());
    }
    /**
    @internal
    */ matchTag(dom, context, after) {
        for(let i = after ? this.tags.indexOf(after) + 1 : 0; i < this.tags.length; i++){
            let rule = this.tags[i];
            if ($1a6f51facb51d04f$var$matches(dom, rule.tag) && (rule.namespace === undefined || dom.namespaceURI == rule.namespace) && (!rule.context || context.matchesContext(rule.context))) {
                if (rule.getAttrs) {
                    let result = rule.getAttrs(dom);
                    if (result === false) continue;
                    rule.attrs = result || undefined;
                }
                return rule;
            }
        }
    }
    /**
    @internal
    */ matchStyle(prop, value, context, after) {
        for(let i = after ? this.styles.indexOf(after) + 1 : 0; i < this.styles.length; i++){
            let rule = this.styles[i], style = rule.style;
            if (style.indexOf(prop) != 0 || rule.context && !context.matchesContext(rule.context) || // Test that the style string either precisely matches the prop,
            // or has an '=' sign after the prop, followed by the given
            // value.
            style.length > prop.length && (style.charCodeAt(prop.length) != 61 || style.slice(prop.length + 1) != value)) continue;
            if (rule.getAttrs) {
                let result = rule.getAttrs(value);
                if (result === false) continue;
                rule.attrs = result || undefined;
            }
            return rule;
        }
    }
    /**
    @internal
    */ static schemaRules(schema) {
        let result = [];
        function insert(rule) {
            let priority = rule.priority == null ? 50 : rule.priority, i = 0;
            for(; i < result.length; i++){
                let next = result[i], nextPriority = next.priority == null ? 50 : next.priority;
                if (nextPriority < priority) break;
            }
            result.splice(i, 0, rule);
        }
        for(let name in schema.marks){
            let rules = schema.marks[name].spec.parseDOM;
            if (rules) rules.forEach((rule)=>{
                insert(rule = $1a6f51facb51d04f$var$copy(rule));
                if (!(rule.mark || rule.ignore || rule.clearMark)) rule.mark = name;
            });
        }
        for(let name in schema.nodes){
            let rules = schema.nodes[name].spec.parseDOM;
            if (rules) rules.forEach((rule)=>{
                insert(rule = $1a6f51facb51d04f$var$copy(rule));
                if (!(rule.node || rule.ignore || rule.mark)) rule.node = name;
            });
        }
        return result;
    }
    /**
    Construct a DOM parser using the parsing rules listed in a
    schema's [node specs](https://prosemirror.net/docs/ref/#model.NodeSpec.parseDOM), reordered by
    [priority](https://prosemirror.net/docs/ref/#model.ParseRule.priority).
    */ static fromSchema(schema) {
        return schema.cached.domParser || (schema.cached.domParser = new $1a6f51facb51d04f$export$1059c6e7d2ce5669(schema, $1a6f51facb51d04f$export$1059c6e7d2ce5669.schemaRules(schema)));
    }
}
const $1a6f51facb51d04f$var$blockTags = {
    address: true,
    article: true,
    aside: true,
    blockquote: true,
    canvas: true,
    dd: true,
    div: true,
    dl: true,
    fieldset: true,
    figcaption: true,
    figure: true,
    footer: true,
    form: true,
    h1: true,
    h2: true,
    h3: true,
    h4: true,
    h5: true,
    h6: true,
    header: true,
    hgroup: true,
    hr: true,
    li: true,
    noscript: true,
    ol: true,
    output: true,
    p: true,
    pre: true,
    section: true,
    table: true,
    tfoot: true,
    ul: true
};
const $1a6f51facb51d04f$var$ignoreTags = {
    head: true,
    noscript: true,
    object: true,
    script: true,
    style: true,
    title: true
};
const $1a6f51facb51d04f$var$listTags = {
    ol: true,
    ul: true
};
// Using a bitfield for node context options
const $1a6f51facb51d04f$var$OPT_PRESERVE_WS = 1, $1a6f51facb51d04f$var$OPT_PRESERVE_WS_FULL = 2, $1a6f51facb51d04f$var$OPT_OPEN_LEFT = 4;
function $1a6f51facb51d04f$var$wsOptionsFor(type, preserveWhitespace, base) {
    if (preserveWhitespace != null) return (preserveWhitespace ? $1a6f51facb51d04f$var$OPT_PRESERVE_WS : 0) | (preserveWhitespace === "full" ? $1a6f51facb51d04f$var$OPT_PRESERVE_WS_FULL : 0);
    return type && type.whitespace == "pre" ? $1a6f51facb51d04f$var$OPT_PRESERVE_WS | $1a6f51facb51d04f$var$OPT_PRESERVE_WS_FULL : base & ~$1a6f51facb51d04f$var$OPT_OPEN_LEFT;
}
class $1a6f51facb51d04f$var$NodeContext {
    constructor(type, attrs, marks, solid, match, options){
        this.type = type;
        this.attrs = attrs;
        this.marks = marks;
        this.solid = solid;
        this.options = options;
        this.content = [];
        // Marks applied to the node's children
        this.activeMarks = $1a6f51facb51d04f$export$c9d15bcfc6d42044.none;
        this.match = match || (options & $1a6f51facb51d04f$var$OPT_OPEN_LEFT ? null : type.contentMatch);
    }
    findWrapping(node) {
        if (!this.match) {
            if (!this.type) return [];
            let fill = this.type.contentMatch.fillBefore($1a6f51facb51d04f$export$ffb0004e005737fa.from(node));
            if (fill) this.match = this.type.contentMatch.matchFragment(fill);
            else {
                let start = this.type.contentMatch, wrap;
                if (wrap = start.findWrapping(node.type)) {
                    this.match = start;
                    return wrap;
                } else return null;
            }
        }
        return this.match.findWrapping(node.type);
    }
    finish(openEnd) {
        if (!(this.options & $1a6f51facb51d04f$var$OPT_PRESERVE_WS)) {
            let last = this.content[this.content.length - 1], m;
            if (last && last.isText && (m = /[ \t\r\n\u000c]+$/.exec(last.text))) {
                let text = last;
                if (last.text.length == m[0].length) this.content.pop();
                else this.content[this.content.length - 1] = text.withText(text.text.slice(0, text.text.length - m[0].length));
            }
        }
        let content = $1a6f51facb51d04f$export$ffb0004e005737fa.from(this.content);
        if (!openEnd && this.match) content = content.append(this.match.fillBefore($1a6f51facb51d04f$export$ffb0004e005737fa.empty, true));
        return this.type ? this.type.create(this.attrs, content, this.marks) : content;
    }
    inlineContext(node) {
        if (this.type) return this.type.inlineContent;
        if (this.content.length) return this.content[0].isInline;
        return node.parentNode && !$1a6f51facb51d04f$var$blockTags.hasOwnProperty(node.parentNode.nodeName.toLowerCase());
    }
}
class $1a6f51facb51d04f$var$ParseContext {
    constructor(// The parser we are using.
    parser, // The options passed to this parse.
    options, isOpen){
        this.parser = parser;
        this.options = options;
        this.isOpen = isOpen;
        this.open = 0;
        this.localPreserveWS = false;
        let topNode = options.topNode, topContext;
        let topOptions = $1a6f51facb51d04f$var$wsOptionsFor(null, options.preserveWhitespace, 0) | (isOpen ? $1a6f51facb51d04f$var$OPT_OPEN_LEFT : 0);
        if (topNode) topContext = new $1a6f51facb51d04f$var$NodeContext(topNode.type, topNode.attrs, $1a6f51facb51d04f$export$c9d15bcfc6d42044.none, true, options.topMatch || topNode.type.contentMatch, topOptions);
        else if (isOpen) topContext = new $1a6f51facb51d04f$var$NodeContext(null, null, $1a6f51facb51d04f$export$c9d15bcfc6d42044.none, true, null, topOptions);
        else topContext = new $1a6f51facb51d04f$var$NodeContext(parser.schema.topNodeType, null, $1a6f51facb51d04f$export$c9d15bcfc6d42044.none, true, null, topOptions);
        this.nodes = [
            topContext
        ];
        this.find = options.findPositions;
        this.needsBlock = false;
    }
    get top() {
        return this.nodes[this.open];
    }
    // Add a DOM node to the content. Text is inserted as text node,
    // otherwise, the node is passed to `addElement` or, if it has a
    // `style` attribute, `addElementWithStyles`.
    addDOM(dom, marks) {
        if (dom.nodeType == 3) this.addTextNode(dom, marks);
        else if (dom.nodeType == 1) this.addElement(dom, marks);
    }
    addTextNode(dom, marks) {
        let value = dom.nodeValue;
        let top = this.top, preserveWS = top.options & $1a6f51facb51d04f$var$OPT_PRESERVE_WS_FULL ? "full" : this.localPreserveWS || (top.options & $1a6f51facb51d04f$var$OPT_PRESERVE_WS) > 0;
        if (preserveWS === "full" || top.inlineContext(dom) || /[^ \t\r\n\u000c]/.test(value)) {
            if (!preserveWS) {
                value = value.replace(/[ \t\r\n\u000c]+/g, " ");
                // If this starts with whitespace, and there is no node before it, or
                // a hard break, or a text node that ends with whitespace, strip the
                // leading space.
                if (/^[ \t\r\n\u000c]/.test(value) && this.open == this.nodes.length - 1) {
                    let nodeBefore = top.content[top.content.length - 1];
                    let domNodeBefore = dom.previousSibling;
                    if (!nodeBefore || domNodeBefore && domNodeBefore.nodeName == 'BR' || nodeBefore.isText && /[ \t\r\n\u000c]$/.test(nodeBefore.text)) value = value.slice(1);
                }
            } else if (preserveWS !== "full") value = value.replace(/\r?\n|\r/g, " ");
            else value = value.replace(/\r\n?/g, "\n");
            if (value) this.insertNode(this.parser.schema.text(value), marks);
            this.findInText(dom);
        } else this.findInside(dom);
    }
    // Try to find a handler for the given tag and use that to parse. If
    // none is found, the element's content nodes are added directly.
    addElement(dom, marks, matchAfter) {
        let outerWS = this.localPreserveWS, top = this.top;
        if (dom.tagName == "PRE" || /pre/.test(dom.style && dom.style.whiteSpace)) this.localPreserveWS = true;
        let name = dom.nodeName.toLowerCase(), ruleID;
        if ($1a6f51facb51d04f$var$listTags.hasOwnProperty(name) && this.parser.normalizeLists) $1a6f51facb51d04f$var$normalizeList(dom);
        let rule = this.options.ruleFromNode && this.options.ruleFromNode(dom) || (ruleID = this.parser.matchTag(dom, this, matchAfter));
        out: if (rule ? rule.ignore : $1a6f51facb51d04f$var$ignoreTags.hasOwnProperty(name)) {
            this.findInside(dom);
            this.ignoreFallback(dom, marks);
        } else if (!rule || rule.skip || rule.closeParent) {
            if (rule && rule.closeParent) this.open = Math.max(0, this.open - 1);
            else if (rule && rule.skip.nodeType) dom = rule.skip;
            let sync, oldNeedsBlock = this.needsBlock;
            if ($1a6f51facb51d04f$var$blockTags.hasOwnProperty(name)) {
                if (top.content.length && top.content[0].isInline && this.open) {
                    this.open--;
                    top = this.top;
                }
                sync = true;
                if (!top.type) this.needsBlock = true;
            } else if (!dom.firstChild) {
                this.leafFallback(dom, marks);
                break out;
            }
            let innerMarks = rule && rule.skip ? marks : this.readStyles(dom, marks);
            if (innerMarks) this.addAll(dom, innerMarks);
            if (sync) this.sync(top);
            this.needsBlock = oldNeedsBlock;
        } else {
            let innerMarks = this.readStyles(dom, marks);
            if (innerMarks) this.addElementByRule(dom, rule, innerMarks, rule.consuming === false ? ruleID : undefined);
        }
        this.localPreserveWS = outerWS;
    }
    // Called for leaf DOM nodes that would otherwise be ignored
    leafFallback(dom, marks) {
        if (dom.nodeName == "BR" && this.top.type && this.top.type.inlineContent) this.addTextNode(dom.ownerDocument.createTextNode("\n"), marks);
    }
    // Called for ignored nodes
    ignoreFallback(dom, marks) {
        // Ignored BR nodes should at least create an inline context
        if (dom.nodeName == "BR" && (!this.top.type || !this.top.type.inlineContent)) this.findPlace(this.parser.schema.text("-"), marks);
    }
    // Run any style parser associated with the node's styles. Either
    // return an updated array of marks, or null to indicate some of the
    // styles had a rule with `ignore` set.
    readStyles(dom, marks) {
        let styles = dom.style;
        // Because many properties will only show up in 'normalized' form
        // in `style.item` (i.e. text-decoration becomes
        // text-decoration-line, text-decoration-color, etc), we directly
        // query the styles mentioned in our rules instead of iterating
        // over the items.
        if (styles && styles.length) for(let i = 0; i < this.parser.matchedStyles.length; i++){
            let name = this.parser.matchedStyles[i], value = styles.getPropertyValue(name);
            if (value) for(let after = undefined;;){
                let rule = this.parser.matchStyle(name, value, this, after);
                if (!rule) break;
                if (rule.ignore) return null;
                if (rule.clearMark) marks = marks.filter((m)=>!rule.clearMark(m));
                else marks = marks.concat(this.parser.schema.marks[rule.mark].create(rule.attrs));
                if (rule.consuming === false) after = rule;
                else break;
            }
        }
        return marks;
    }
    // Look up a handler for the given node. If none are found, return
    // false. Otherwise, apply it, use its return value to drive the way
    // the node's content is wrapped, and return true.
    addElementByRule(dom, rule, marks, continueAfter) {
        let sync, nodeType;
        if (rule.node) {
            nodeType = this.parser.schema.nodes[rule.node];
            if (!nodeType.isLeaf) {
                let inner = this.enter(nodeType, rule.attrs || null, marks, rule.preserveWhitespace);
                if (inner) {
                    sync = true;
                    marks = inner;
                }
            } else if (!this.insertNode(nodeType.create(rule.attrs), marks)) this.leafFallback(dom, marks);
        } else {
            let markType = this.parser.schema.marks[rule.mark];
            marks = marks.concat(markType.create(rule.attrs));
        }
        let startIn = this.top;
        if (nodeType && nodeType.isLeaf) this.findInside(dom);
        else if (continueAfter) this.addElement(dom, marks, continueAfter);
        else if (rule.getContent) {
            this.findInside(dom);
            rule.getContent(dom, this.parser.schema).forEach((node)=>this.insertNode(node, marks));
        } else {
            let contentDOM = dom;
            if (typeof rule.contentElement == "string") contentDOM = dom.querySelector(rule.contentElement);
            else if (typeof rule.contentElement == "function") contentDOM = rule.contentElement(dom);
            else if (rule.contentElement) contentDOM = rule.contentElement;
            this.findAround(dom, contentDOM, true);
            this.addAll(contentDOM, marks);
            this.findAround(dom, contentDOM, false);
        }
        if (sync && this.sync(startIn)) this.open--;
    }
    // Add all child nodes between `startIndex` and `endIndex` (or the
    // whole node, if not given). If `sync` is passed, use it to
    // synchronize after every block element.
    addAll(parent, marks, startIndex, endIndex) {
        let index = startIndex || 0;
        for(let dom = startIndex ? parent.childNodes[startIndex] : parent.firstChild, end = endIndex == null ? null : parent.childNodes[endIndex]; dom != end; dom = dom.nextSibling, ++index){
            this.findAtPoint(parent, index);
            this.addDOM(dom, marks);
        }
        this.findAtPoint(parent, index);
    }
    // Try to find a way to fit the given node type into the current
    // context. May add intermediate wrappers and/or leave non-solid
    // nodes that we're in.
    findPlace(node, marks) {
        let route, sync;
        for(let depth = this.open; depth >= 0; depth--){
            let cx = this.nodes[depth];
            let found = cx.findWrapping(node);
            if (found && (!route || route.length > found.length)) {
                route = found;
                sync = cx;
                if (!found.length) break;
            }
            if (cx.solid) break;
        }
        if (!route) return null;
        this.sync(sync);
        for(let i = 0; i < route.length; i++)marks = this.enterInner(route[i], null, marks, false);
        return marks;
    }
    // Try to insert the given node, adjusting the context when needed.
    insertNode(node, marks) {
        if (node.isInline && this.needsBlock && !this.top.type) {
            let block = this.textblockFromContext();
            if (block) marks = this.enterInner(block, null, marks);
        }
        let innerMarks = this.findPlace(node, marks);
        if (innerMarks) {
            this.closeExtra();
            let top = this.top;
            if (top.match) top.match = top.match.matchType(node.type);
            let nodeMarks = $1a6f51facb51d04f$export$c9d15bcfc6d42044.none;
            for (let m of innerMarks.concat(node.marks))if (top.type ? top.type.allowsMarkType(m.type) : $1a6f51facb51d04f$var$markMayApply(m.type, node.type)) nodeMarks = m.addToSet(nodeMarks);
            top.content.push(node.mark(nodeMarks));
            return true;
        }
        return false;
    }
    // Try to start a node of the given type, adjusting the context when
    // necessary.
    enter(type, attrs, marks, preserveWS) {
        let innerMarks = this.findPlace(type.create(attrs), marks);
        if (innerMarks) innerMarks = this.enterInner(type, attrs, marks, true, preserveWS);
        return innerMarks;
    }
    // Open a node of the given type
    enterInner(type, attrs, marks, solid = false, preserveWS) {
        this.closeExtra();
        let top = this.top;
        top.match = top.match && top.match.matchType(type);
        let options = $1a6f51facb51d04f$var$wsOptionsFor(type, preserveWS, top.options);
        if (top.options & $1a6f51facb51d04f$var$OPT_OPEN_LEFT && top.content.length == 0) options |= $1a6f51facb51d04f$var$OPT_OPEN_LEFT;
        let applyMarks = $1a6f51facb51d04f$export$c9d15bcfc6d42044.none;
        marks = marks.filter((m)=>{
            if (top.type ? top.type.allowsMarkType(m.type) : $1a6f51facb51d04f$var$markMayApply(m.type, type)) {
                applyMarks = m.addToSet(applyMarks);
                return false;
            }
            return true;
        });
        this.nodes.push(new $1a6f51facb51d04f$var$NodeContext(type, attrs, applyMarks, solid, null, options));
        this.open++;
        return marks;
    }
    // Make sure all nodes above this.open are finished and added to
    // their parents
    closeExtra(openEnd = false) {
        let i = this.nodes.length - 1;
        if (i > this.open) {
            for(; i > this.open; i--)this.nodes[i - 1].content.push(this.nodes[i].finish(openEnd));
            this.nodes.length = this.open + 1;
        }
    }
    finish() {
        this.open = 0;
        this.closeExtra(this.isOpen);
        return this.nodes[0].finish(!!(this.isOpen || this.options.topOpen));
    }
    sync(to) {
        for(let i = this.open; i >= 0; i--){
            if (this.nodes[i] == to) {
                this.open = i;
                return true;
            } else if (this.localPreserveWS) this.nodes[i].options |= $1a6f51facb51d04f$var$OPT_PRESERVE_WS;
        }
        return false;
    }
    get currentPos() {
        this.closeExtra();
        let pos = 0;
        for(let i = this.open; i >= 0; i--){
            let content = this.nodes[i].content;
            for(let j = content.length - 1; j >= 0; j--)pos += content[j].nodeSize;
            if (i) pos++;
        }
        return pos;
    }
    findAtPoint(parent, offset) {
        if (this.find) {
            for(let i = 0; i < this.find.length; i++)if (this.find[i].node == parent && this.find[i].offset == offset) this.find[i].pos = this.currentPos;
        }
    }
    findInside(parent) {
        if (this.find) {
            for(let i = 0; i < this.find.length; i++)if (this.find[i].pos == null && parent.nodeType == 1 && parent.contains(this.find[i].node)) this.find[i].pos = this.currentPos;
        }
    }
    findAround(parent, content, before) {
        if (parent != content && this.find) {
            for(let i = 0; i < this.find.length; i++)if (this.find[i].pos == null && parent.nodeType == 1 && parent.contains(this.find[i].node)) {
                let pos = content.compareDocumentPosition(this.find[i].node);
                if (pos & (before ? 2 : 4)) this.find[i].pos = this.currentPos;
            }
        }
    }
    findInText(textNode) {
        if (this.find) {
            for(let i = 0; i < this.find.length; i++)if (this.find[i].node == textNode) this.find[i].pos = this.currentPos - (textNode.nodeValue.length - this.find[i].offset);
        }
    }
    // Determines whether the given context string matches this context.
    matchesContext(context) {
        if (context.indexOf("|") > -1) return context.split(/\s*\|\s*/).some(this.matchesContext, this);
        let parts = context.split("/");
        let option = this.options.context;
        let useRoot = !this.isOpen && (!option || option.parent.type == this.nodes[0].type);
        let minDepth = -(option ? option.depth + 1 : 0) + (useRoot ? 0 : 1);
        let match = (i, depth)=>{
            for(; i >= 0; i--){
                let part = parts[i];
                if (part == "") {
                    if (i == parts.length - 1 || i == 0) continue;
                    for(; depth >= minDepth; depth--)if (match(i - 1, depth)) return true;
                    return false;
                } else {
                    let next = depth > 0 || depth == 0 && useRoot ? this.nodes[depth].type : option && depth >= minDepth ? option.node(depth - minDepth).type : null;
                    if (!next || next.name != part && !next.isInGroup(part)) return false;
                    depth--;
                }
            }
            return true;
        };
        return match(parts.length - 1, this.open);
    }
    textblockFromContext() {
        let $context = this.options.context;
        if ($context) for(let d = $context.depth; d >= 0; d--){
            let deflt = $context.node(d).contentMatchAt($context.indexAfter(d)).defaultType;
            if (deflt && deflt.isTextblock && deflt.defaultAttrs) return deflt;
        }
        for(let name in this.parser.schema.nodes){
            let type = this.parser.schema.nodes[name];
            if (type.isTextblock && type.defaultAttrs) return type;
        }
    }
}
// Kludge to work around directly nested list nodes produced by some
// tools and allowed by browsers to mean that the nested list is
// actually part of the list item above it.
function $1a6f51facb51d04f$var$normalizeList(dom) {
    for(let child = dom.firstChild, prevItem = null; child; child = child.nextSibling){
        let name = child.nodeType == 1 ? child.nodeName.toLowerCase() : null;
        if (name && $1a6f51facb51d04f$var$listTags.hasOwnProperty(name) && prevItem) {
            prevItem.appendChild(child);
            child = prevItem;
        } else if (name == "li") prevItem = child;
        else if (name) prevItem = null;
    }
}
// Apply a CSS selector.
function $1a6f51facb51d04f$var$matches(dom, selector) {
    return (dom.matches || dom.msMatchesSelector || dom.webkitMatchesSelector || dom.mozMatchesSelector).call(dom, selector);
}
function $1a6f51facb51d04f$var$copy(obj) {
    let copy = {};
    for(let prop in obj)copy[prop] = obj[prop];
    return copy;
}
// Used when finding a mark at the top level of a fragment parse.
// Checks whether it would be reasonable to apply a given mark type to
// a given node, by looking at the way the mark occurs in the schema.
function $1a6f51facb51d04f$var$markMayApply(markType, nodeType) {
    let nodes = nodeType.schema.nodes;
    for(let name in nodes){
        let parent = nodes[name];
        if (!parent.allowsMarkType(markType)) continue;
        let seen = [], scan = (match)=>{
            seen.push(match);
            for(let i = 0; i < match.edgeCount; i++){
                let { type: type, next: next } = match.edge(i);
                if (type == nodeType) return true;
                if (seen.indexOf(next) < 0 && scan(next)) return true;
            }
        };
        if (scan(parent.contentMatch)) return true;
    }
}
/**
A DOM serializer knows how to convert ProseMirror nodes and
marks of various types to DOM nodes.
*/ class $1a6f51facb51d04f$export$3476b78f8f5a8b72 {
    /**
    Create a serializer. `nodes` should map node names to functions
    that take a node and return a description of the corresponding
    DOM. `marks` does the same for mark names, but also gets an
    argument that tells it whether the mark's content is block or
    inline content (for typical use, it'll always be inline). A mark
    serializer may be `null` to indicate that marks of that type
    should not be serialized.
    */ constructor(/**
    The node serialization functions.
    */ nodes, /**
    The mark serialization functions.
    */ marks){
        this.nodes = nodes;
        this.marks = marks;
    }
    /**
    Serialize the content of this fragment to a DOM fragment. When
    not in the browser, the `document` option, containing a DOM
    document, should be passed so that the serializer can create
    nodes.
    */ serializeFragment(fragment, options = {}, target) {
        if (!target) target = $1a6f51facb51d04f$var$doc(options).createDocumentFragment();
        let top = target, active = [];
        fragment.forEach((node)=>{
            if (active.length || node.marks.length) {
                let keep = 0, rendered = 0;
                while(keep < active.length && rendered < node.marks.length){
                    let next = node.marks[rendered];
                    if (!this.marks[next.type.name]) {
                        rendered++;
                        continue;
                    }
                    if (!next.eq(active[keep][0]) || next.type.spec.spanning === false) break;
                    keep++;
                    rendered++;
                }
                while(keep < active.length)top = active.pop()[1];
                while(rendered < node.marks.length){
                    let add = node.marks[rendered++];
                    let markDOM = this.serializeMark(add, node.isInline, options);
                    if (markDOM) {
                        active.push([
                            add,
                            top
                        ]);
                        top.appendChild(markDOM.dom);
                        top = markDOM.contentDOM || markDOM.dom;
                    }
                }
            }
            top.appendChild(this.serializeNodeInner(node, options));
        });
        return target;
    }
    /**
    @internal
    */ serializeNodeInner(node, options) {
        let { dom: dom, contentDOM: contentDOM } = $1a6f51facb51d04f$var$renderSpec($1a6f51facb51d04f$var$doc(options), this.nodes[node.type.name](node), null, node.attrs);
        if (contentDOM) {
            if (node.isLeaf) throw new RangeError("Content hole not allowed in a leaf node spec");
            this.serializeFragment(node.content, options, contentDOM);
        }
        return dom;
    }
    /**
    Serialize this node to a DOM node. This can be useful when you
    need to serialize a part of a document, as opposed to the whole
    document. To serialize a whole document, use
    [`serializeFragment`](https://prosemirror.net/docs/ref/#model.DOMSerializer.serializeFragment) on
    its [content](https://prosemirror.net/docs/ref/#model.Node.content).
    */ serializeNode(node, options = {}) {
        let dom = this.serializeNodeInner(node, options);
        for(let i = node.marks.length - 1; i >= 0; i--){
            let wrap = this.serializeMark(node.marks[i], node.isInline, options);
            if (wrap) {
                (wrap.contentDOM || wrap.dom).appendChild(dom);
                dom = wrap.dom;
            }
        }
        return dom;
    }
    /**
    @internal
    */ serializeMark(mark, inline, options = {}) {
        let toDOM = this.marks[mark.type.name];
        return toDOM && $1a6f51facb51d04f$var$renderSpec($1a6f51facb51d04f$var$doc(options), toDOM(mark, inline), null, mark.attrs);
    }
    static renderSpec(doc, structure, xmlNS = null, blockArraysIn) {
        return $1a6f51facb51d04f$var$renderSpec(doc, structure, xmlNS, blockArraysIn);
    }
    /**
    Build a serializer using the [`toDOM`](https://prosemirror.net/docs/ref/#model.NodeSpec.toDOM)
    properties in a schema's node and mark specs.
    */ static fromSchema(schema) {
        return schema.cached.domSerializer || (schema.cached.domSerializer = new $1a6f51facb51d04f$export$3476b78f8f5a8b72(this.nodesFromSchema(schema), this.marksFromSchema(schema)));
    }
    /**
    Gather the serializers in a schema's node specs into an object.
    This can be useful as a base to build a custom serializer from.
    */ static nodesFromSchema(schema) {
        let result = $1a6f51facb51d04f$var$gatherToDOM(schema.nodes);
        if (!result.text) result.text = (node)=>node.text;
        return result;
    }
    /**
    Gather the serializers in a schema's mark specs into an object.
    */ static marksFromSchema(schema) {
        return $1a6f51facb51d04f$var$gatherToDOM(schema.marks);
    }
}
function $1a6f51facb51d04f$var$gatherToDOM(obj) {
    let result = {};
    for(let name in obj){
        let toDOM = obj[name].spec.toDOM;
        if (toDOM) result[name] = toDOM;
    }
    return result;
}
function $1a6f51facb51d04f$var$doc(options) {
    return options.document || window.document;
}
const $1a6f51facb51d04f$var$suspiciousAttributeCache = new WeakMap();
function $1a6f51facb51d04f$var$suspiciousAttributes(attrs) {
    let value = $1a6f51facb51d04f$var$suspiciousAttributeCache.get(attrs);
    if (value === undefined) $1a6f51facb51d04f$var$suspiciousAttributeCache.set(attrs, value = $1a6f51facb51d04f$var$suspiciousAttributesInner(attrs));
    return value;
}
function $1a6f51facb51d04f$var$suspiciousAttributesInner(attrs) {
    let result = null;
    function scan(value) {
        if (value && typeof value == "object") {
            if (Array.isArray(value)) {
                if (typeof value[0] == "string") {
                    if (!result) result = [];
                    result.push(value);
                } else for(let i = 0; i < value.length; i++)scan(value[i]);
            } else for(let prop in value)scan(value[prop]);
        }
    }
    scan(attrs);
    return result;
}
function $1a6f51facb51d04f$var$renderSpec(doc, structure, xmlNS, blockArraysIn) {
    if (typeof structure == "string") return {
        dom: doc.createTextNode(structure)
    };
    if (structure.nodeType != null) return {
        dom: structure
    };
    if (structure.dom && structure.dom.nodeType != null) return structure;
    let tagName = structure[0], suspicious;
    if (typeof tagName != "string") throw new RangeError("Invalid array passed to renderSpec");
    if (blockArraysIn && (suspicious = $1a6f51facb51d04f$var$suspiciousAttributes(blockArraysIn)) && suspicious.indexOf(structure) > -1) throw new RangeError("Using an array from an attribute object as a DOM spec. This may be an attempted cross site scripting attack.");
    let space = tagName.indexOf(" ");
    if (space > 0) {
        xmlNS = tagName.slice(0, space);
        tagName = tagName.slice(space + 1);
    }
    let contentDOM;
    let dom = xmlNS ? doc.createElementNS(xmlNS, tagName) : doc.createElement(tagName);
    let attrs = structure[1], start = 1;
    if (attrs && typeof attrs == "object" && attrs.nodeType == null && !Array.isArray(attrs)) {
        start = 2;
        for(let name in attrs)if (attrs[name] != null) {
            let space = name.indexOf(" ");
            if (space > 0) dom.setAttributeNS(name.slice(0, space), name.slice(space + 1), attrs[name]);
            else dom.setAttribute(name, attrs[name]);
        }
    }
    for(let i = start; i < structure.length; i++){
        let child = structure[i];
        if (child === 0) {
            if (i < structure.length - 1 || i > start) throw new RangeError("Content hole must be the only child of its parent node");
            return {
                dom: dom,
                contentDOM: dom
            };
        } else {
            let { dom: inner, contentDOM: innerContent } = $1a6f51facb51d04f$var$renderSpec(doc, child, xmlNS, blockArraysIn);
            dom.appendChild(inner);
            if (innerContent) {
                if (contentDOM) throw new RangeError("Multiple content holes");
                contentDOM = innerContent;
            }
        }
    }
    return {
        dom: dom,
        contentDOM: contentDOM
    };
}

});

parcelRegister("l8uaJ", function(module, exports) {
$parcel$export(module.exports, "Selection", () => $f631bfe7512b7c19$export$52baac22726c72bf);
$parcel$export(module.exports, "SelectionRange", () => $f631bfe7512b7c19$export$7bd1839c3c5d5bd4);
$parcel$export(module.exports, "TextSelection", () => $f631bfe7512b7c19$export$c2b25f346d19bcbb);
$parcel$export(module.exports, "NodeSelection", () => $f631bfe7512b7c19$export$e2940151ac854c0b);
$parcel$export(module.exports, "Plugin", () => $f631bfe7512b7c19$export$901cf72dabf2112a);
$parcel$export(module.exports, "PluginKey", () => $f631bfe7512b7c19$export$1692d8b0e89cecc3);

var $fsS3P = parcelRequire("fsS3P");

var $kQFGJ = parcelRequire("kQFGJ");
const $f631bfe7512b7c19$var$classesById = Object.create(null);
/**
Superclass for editor selections. Every selection type should
extend this. Should not be instantiated directly.
*/ class $f631bfe7512b7c19$export$52baac22726c72bf {
    /**
    Initialize a selection with the head and anchor and ranges. If no
    ranges are given, constructs a single range across `$anchor` and
    `$head`.
    */ constructor(/**
    The resolved anchor of the selection (the side that stays in
    place when the selection is modified).
    */ $anchor, /**
    The resolved head of the selection (the side that moves when
    the selection is modified).
    */ $head, ranges){
        this.$anchor = $anchor;
        this.$head = $head;
        this.ranges = ranges || [
            new $f631bfe7512b7c19$export$7bd1839c3c5d5bd4($anchor.min($head), $anchor.max($head))
        ];
    }
    /**
    The selection's anchor, as an unresolved position.
    */ get anchor() {
        return this.$anchor.pos;
    }
    /**
    The selection's head.
    */ get head() {
        return this.$head.pos;
    }
    /**
    The lower bound of the selection's main range.
    */ get from() {
        return this.$from.pos;
    }
    /**
    The upper bound of the selection's main range.
    */ get to() {
        return this.$to.pos;
    }
    /**
    The resolved lower  bound of the selection's main range.
    */ get $from() {
        return this.ranges[0].$from;
    }
    /**
    The resolved upper bound of the selection's main range.
    */ get $to() {
        return this.ranges[0].$to;
    }
    /**
    Indicates whether the selection contains any content.
    */ get empty() {
        let ranges = this.ranges;
        for(let i = 0; i < ranges.length; i++)if (ranges[i].$from.pos != ranges[i].$to.pos) return false;
        return true;
    }
    /**
    Get the content of this selection as a slice.
    */ content() {
        return this.$from.doc.slice(this.from, this.to, true);
    }
    /**
    Replace the selection with a slice or, if no slice is given,
    delete the selection. Will append to the given transaction.
    */ replace(tr, content = (0, $fsS3P.Slice).empty) {
        // Put the new selection at the position after the inserted
        // content. When that ended in an inline node, search backwards,
        // to get the position after that node. If not, search forward.
        let lastNode = content.content.lastChild, lastParent = null;
        for(let i = 0; i < content.openEnd; i++){
            lastParent = lastNode;
            lastNode = lastNode.lastChild;
        }
        let mapFrom = tr.steps.length, ranges = this.ranges;
        for(let i = 0; i < ranges.length; i++){
            let { $from: $from, $to: $to } = ranges[i], mapping = tr.mapping.slice(mapFrom);
            tr.replaceRange(mapping.map($from.pos), mapping.map($to.pos), i ? (0, $fsS3P.Slice).empty : content);
            if (i == 0) $f631bfe7512b7c19$var$selectionToInsertionEnd(tr, mapFrom, (lastNode ? lastNode.isInline : lastParent && lastParent.isTextblock) ? -1 : 1);
        }
    }
    /**
    Replace the selection with the given node, appending the changes
    to the given transaction.
    */ replaceWith(tr, node) {
        let mapFrom = tr.steps.length, ranges = this.ranges;
        for(let i = 0; i < ranges.length; i++){
            let { $from: $from, $to: $to } = ranges[i], mapping = tr.mapping.slice(mapFrom);
            let from = mapping.map($from.pos), to = mapping.map($to.pos);
            if (i) tr.deleteRange(from, to);
            else {
                tr.replaceRangeWith(from, to, node);
                $f631bfe7512b7c19$var$selectionToInsertionEnd(tr, mapFrom, node.isInline ? -1 : 1);
            }
        }
    }
    /**
    Find a valid cursor or leaf node selection starting at the given
    position and searching back if `dir` is negative, and forward if
    positive. When `textOnly` is true, only consider cursor
    selections. Will return null when no valid selection position is
    found.
    */ static findFrom($pos, dir, textOnly = false) {
        let inner = $pos.parent.inlineContent ? new $f631bfe7512b7c19$export$c2b25f346d19bcbb($pos) : $f631bfe7512b7c19$var$findSelectionIn($pos.node(0), $pos.parent, $pos.pos, $pos.index(), dir, textOnly);
        if (inner) return inner;
        for(let depth = $pos.depth - 1; depth >= 0; depth--){
            let found = dir < 0 ? $f631bfe7512b7c19$var$findSelectionIn($pos.node(0), $pos.node(depth), $pos.before(depth + 1), $pos.index(depth), dir, textOnly) : $f631bfe7512b7c19$var$findSelectionIn($pos.node(0), $pos.node(depth), $pos.after(depth + 1), $pos.index(depth) + 1, dir, textOnly);
            if (found) return found;
        }
        return null;
    }
    /**
    Find a valid cursor or leaf node selection near the given
    position. Searches forward first by default, but if `bias` is
    negative, it will search backwards first.
    */ static near($pos, bias = 1) {
        return this.findFrom($pos, bias) || this.findFrom($pos, -bias) || new $f631bfe7512b7c19$export$c15d9ba76bdbcd95($pos.node(0));
    }
    /**
    Find the cursor or leaf node selection closest to the start of
    the given document. Will return an
    [`AllSelection`](https://prosemirror.net/docs/ref/#state.AllSelection) if no valid position
    exists.
    */ static atStart(doc) {
        return $f631bfe7512b7c19$var$findSelectionIn(doc, doc, 0, 0, 1) || new $f631bfe7512b7c19$export$c15d9ba76bdbcd95(doc);
    }
    /**
    Find the cursor or leaf node selection closest to the end of the
    given document.
    */ static atEnd(doc) {
        return $f631bfe7512b7c19$var$findSelectionIn(doc, doc, doc.content.size, doc.childCount, -1) || new $f631bfe7512b7c19$export$c15d9ba76bdbcd95(doc);
    }
    /**
    Deserialize the JSON representation of a selection. Must be
    implemented for custom classes (as a static class method).
    */ static fromJSON(doc, json) {
        if (!json || !json.type) throw new RangeError("Invalid input for Selection.fromJSON");
        let cls = $f631bfe7512b7c19$var$classesById[json.type];
        if (!cls) throw new RangeError(`No selection type ${json.type} defined`);
        return cls.fromJSON(doc, json);
    }
    /**
    To be able to deserialize selections from JSON, custom selection
    classes must register themselves with an ID string, so that they
    can be disambiguated. Try to pick something that's unlikely to
    clash with classes from other modules.
    */ static jsonID(id, selectionClass) {
        if (id in $f631bfe7512b7c19$var$classesById) throw new RangeError("Duplicate use of selection JSON ID " + id);
        $f631bfe7512b7c19$var$classesById[id] = selectionClass;
        selectionClass.prototype.jsonID = id;
        return selectionClass;
    }
    /**
    Get a [bookmark](https://prosemirror.net/docs/ref/#state.SelectionBookmark) for this selection,
    which is a value that can be mapped without having access to a
    current document, and later resolved to a real selection for a
    given document again. (This is used mostly by the history to
    track and restore old selections.) The default implementation of
    this method just converts the selection to a text selection and
    returns the bookmark for that.
    */ getBookmark() {
        return $f631bfe7512b7c19$export$c2b25f346d19bcbb.between(this.$anchor, this.$head).getBookmark();
    }
}
$f631bfe7512b7c19$export$52baac22726c72bf.prototype.visible = true;
/**
Represents a selected range in a document.
*/ class $f631bfe7512b7c19$export$7bd1839c3c5d5bd4 {
    /**
    Create a range.
    */ constructor(/**
    The lower bound of the range.
    */ $from, /**
    The upper bound of the range.
    */ $to){
        this.$from = $from;
        this.$to = $to;
    }
}
let $f631bfe7512b7c19$var$warnedAboutTextSelection = false;
function $f631bfe7512b7c19$var$checkTextSelection($pos) {
    if (!$f631bfe7512b7c19$var$warnedAboutTextSelection && !$pos.parent.inlineContent) {
        $f631bfe7512b7c19$var$warnedAboutTextSelection = true;
        console["warn"]("TextSelection endpoint not pointing into a node with inline content (" + $pos.parent.type.name + ")");
    }
}
/**
A text selection represents a classical editor selection, with a
head (the moving side) and anchor (immobile side), both of which
point into textblock nodes. It can be empty (a regular cursor
position).
*/ class $f631bfe7512b7c19$export$c2b25f346d19bcbb extends $f631bfe7512b7c19$export$52baac22726c72bf {
    /**
    Construct a text selection between the given points.
    */ constructor($anchor, $head = $anchor){
        $f631bfe7512b7c19$var$checkTextSelection($anchor);
        $f631bfe7512b7c19$var$checkTextSelection($head);
        super($anchor, $head);
    }
    /**
    Returns a resolved position if this is a cursor selection (an
    empty text selection), and null otherwise.
    */ get $cursor() {
        return this.$anchor.pos == this.$head.pos ? this.$head : null;
    }
    map(doc, mapping) {
        let $head = doc.resolve(mapping.map(this.head));
        if (!$head.parent.inlineContent) return $f631bfe7512b7c19$export$52baac22726c72bf.near($head);
        let $anchor = doc.resolve(mapping.map(this.anchor));
        return new $f631bfe7512b7c19$export$c2b25f346d19bcbb($anchor.parent.inlineContent ? $anchor : $head, $head);
    }
    replace(tr, content = (0, $fsS3P.Slice).empty) {
        super.replace(tr, content);
        if (content == (0, $fsS3P.Slice).empty) {
            let marks = this.$from.marksAcross(this.$to);
            if (marks) tr.ensureMarks(marks);
        }
    }
    eq(other) {
        return other instanceof $f631bfe7512b7c19$export$c2b25f346d19bcbb && other.anchor == this.anchor && other.head == this.head;
    }
    getBookmark() {
        return new $f631bfe7512b7c19$var$TextBookmark(this.anchor, this.head);
    }
    toJSON() {
        return {
            type: "text",
            anchor: this.anchor,
            head: this.head
        };
    }
    /**
    @internal
    */ static fromJSON(doc, json) {
        if (typeof json.anchor != "number" || typeof json.head != "number") throw new RangeError("Invalid input for TextSelection.fromJSON");
        return new $f631bfe7512b7c19$export$c2b25f346d19bcbb(doc.resolve(json.anchor), doc.resolve(json.head));
    }
    /**
    Create a text selection from non-resolved positions.
    */ static create(doc, anchor, head = anchor) {
        let $anchor = doc.resolve(anchor);
        return new this($anchor, head == anchor ? $anchor : doc.resolve(head));
    }
    /**
    Return a text selection that spans the given positions or, if
    they aren't text positions, find a text selection near them.
    `bias` determines whether the method searches forward (default)
    or backwards (negative number) first. Will fall back to calling
    [`Selection.near`](https://prosemirror.net/docs/ref/#state.Selection^near) when the document
    doesn't contain a valid text position.
    */ static between($anchor, $head, bias) {
        let dPos = $anchor.pos - $head.pos;
        if (!bias || dPos) bias = dPos >= 0 ? 1 : -1;
        if (!$head.parent.inlineContent) {
            let found = $f631bfe7512b7c19$export$52baac22726c72bf.findFrom($head, bias, true) || $f631bfe7512b7c19$export$52baac22726c72bf.findFrom($head, -bias, true);
            if (found) $head = found.$head;
            else return $f631bfe7512b7c19$export$52baac22726c72bf.near($head, bias);
        }
        if (!$anchor.parent.inlineContent) {
            if (dPos == 0) $anchor = $head;
            else {
                $anchor = ($f631bfe7512b7c19$export$52baac22726c72bf.findFrom($anchor, -bias, true) || $f631bfe7512b7c19$export$52baac22726c72bf.findFrom($anchor, bias, true)).$anchor;
                if ($anchor.pos < $head.pos != dPos < 0) $anchor = $head;
            }
        }
        return new $f631bfe7512b7c19$export$c2b25f346d19bcbb($anchor, $head);
    }
}
$f631bfe7512b7c19$export$52baac22726c72bf.jsonID("text", $f631bfe7512b7c19$export$c2b25f346d19bcbb);
class $f631bfe7512b7c19$var$TextBookmark {
    constructor(anchor, head){
        this.anchor = anchor;
        this.head = head;
    }
    map(mapping) {
        return new $f631bfe7512b7c19$var$TextBookmark(mapping.map(this.anchor), mapping.map(this.head));
    }
    resolve(doc) {
        return $f631bfe7512b7c19$export$c2b25f346d19bcbb.between(doc.resolve(this.anchor), doc.resolve(this.head));
    }
}
/**
A node selection is a selection that points at a single node. All
nodes marked [selectable](https://prosemirror.net/docs/ref/#model.NodeSpec.selectable) can be the
target of a node selection. In such a selection, `from` and `to`
point directly before and after the selected node, `anchor` equals
`from`, and `head` equals `to`..
*/ class $f631bfe7512b7c19$export$e2940151ac854c0b extends $f631bfe7512b7c19$export$52baac22726c72bf {
    /**
    Create a node selection. Does not verify the validity of its
    argument.
    */ constructor($pos){
        let node = $pos.nodeAfter;
        let $end = $pos.node(0).resolve($pos.pos + node.nodeSize);
        super($pos, $end);
        this.node = node;
    }
    map(doc, mapping) {
        let { deleted: deleted, pos: pos } = mapping.mapResult(this.anchor);
        let $pos = doc.resolve(pos);
        if (deleted) return $f631bfe7512b7c19$export$52baac22726c72bf.near($pos);
        return new $f631bfe7512b7c19$export$e2940151ac854c0b($pos);
    }
    content() {
        return new (0, $fsS3P.Slice)((0, $fsS3P.Fragment).from(this.node), 0, 0);
    }
    eq(other) {
        return other instanceof $f631bfe7512b7c19$export$e2940151ac854c0b && other.anchor == this.anchor;
    }
    toJSON() {
        return {
            type: "node",
            anchor: this.anchor
        };
    }
    getBookmark() {
        return new $f631bfe7512b7c19$var$NodeBookmark(this.anchor);
    }
    /**
    @internal
    */ static fromJSON(doc, json) {
        if (typeof json.anchor != "number") throw new RangeError("Invalid input for NodeSelection.fromJSON");
        return new $f631bfe7512b7c19$export$e2940151ac854c0b(doc.resolve(json.anchor));
    }
    /**
    Create a node selection from non-resolved positions.
    */ static create(doc, from) {
        return new $f631bfe7512b7c19$export$e2940151ac854c0b(doc.resolve(from));
    }
    /**
    Determines whether the given node may be selected as a node
    selection.
    */ static isSelectable(node) {
        return !node.isText && node.type.spec.selectable !== false;
    }
}
$f631bfe7512b7c19$export$e2940151ac854c0b.prototype.visible = false;
$f631bfe7512b7c19$export$52baac22726c72bf.jsonID("node", $f631bfe7512b7c19$export$e2940151ac854c0b);
class $f631bfe7512b7c19$var$NodeBookmark {
    constructor(anchor){
        this.anchor = anchor;
    }
    map(mapping) {
        let { deleted: deleted, pos: pos } = mapping.mapResult(this.anchor);
        return deleted ? new $f631bfe7512b7c19$var$TextBookmark(pos, pos) : new $f631bfe7512b7c19$var$NodeBookmark(pos);
    }
    resolve(doc) {
        let $pos = doc.resolve(this.anchor), node = $pos.nodeAfter;
        if (node && $f631bfe7512b7c19$export$e2940151ac854c0b.isSelectable(node)) return new $f631bfe7512b7c19$export$e2940151ac854c0b($pos);
        return $f631bfe7512b7c19$export$52baac22726c72bf.near($pos);
    }
}
/**
A selection type that represents selecting the whole document
(which can not necessarily be expressed with a text selection, when
there are for example leaf block nodes at the start or end of the
document).
*/ class $f631bfe7512b7c19$export$c15d9ba76bdbcd95 extends $f631bfe7512b7c19$export$52baac22726c72bf {
    /**
    Create an all-selection over the given document.
    */ constructor(doc){
        super(doc.resolve(0), doc.resolve(doc.content.size));
    }
    replace(tr, content = (0, $fsS3P.Slice).empty) {
        if (content == (0, $fsS3P.Slice).empty) {
            tr.delete(0, tr.doc.content.size);
            let sel = $f631bfe7512b7c19$export$52baac22726c72bf.atStart(tr.doc);
            if (!sel.eq(tr.selection)) tr.setSelection(sel);
        } else super.replace(tr, content);
    }
    toJSON() {
        return {
            type: "all"
        };
    }
    /**
    @internal
    */ static fromJSON(doc) {
        return new $f631bfe7512b7c19$export$c15d9ba76bdbcd95(doc);
    }
    map(doc) {
        return new $f631bfe7512b7c19$export$c15d9ba76bdbcd95(doc);
    }
    eq(other) {
        return other instanceof $f631bfe7512b7c19$export$c15d9ba76bdbcd95;
    }
    getBookmark() {
        return $f631bfe7512b7c19$var$AllBookmark;
    }
}
$f631bfe7512b7c19$export$52baac22726c72bf.jsonID("all", $f631bfe7512b7c19$export$c15d9ba76bdbcd95);
const $f631bfe7512b7c19$var$AllBookmark = {
    map () {
        return this;
    },
    resolve (doc) {
        return new $f631bfe7512b7c19$export$c15d9ba76bdbcd95(doc);
    }
};
// FIXME we'll need some awareness of text direction when scanning for selections
// Try to find a selection inside the given node. `pos` points at the
// position where the search starts. When `text` is true, only return
// text selections.
function $f631bfe7512b7c19$var$findSelectionIn(doc, node, pos, index, dir, text = false) {
    if (node.inlineContent) return $f631bfe7512b7c19$export$c2b25f346d19bcbb.create(doc, pos);
    for(let i = index - (dir > 0 ? 0 : 1); dir > 0 ? i < node.childCount : i >= 0; i += dir){
        let child = node.child(i);
        if (!child.isAtom) {
            let inner = $f631bfe7512b7c19$var$findSelectionIn(doc, child, pos + dir, dir < 0 ? child.childCount : 0, dir, text);
            if (inner) return inner;
        } else if (!text && $f631bfe7512b7c19$export$e2940151ac854c0b.isSelectable(child)) return $f631bfe7512b7c19$export$e2940151ac854c0b.create(doc, pos - (dir < 0 ? child.nodeSize : 0));
        pos += child.nodeSize * dir;
    }
    return null;
}
function $f631bfe7512b7c19$var$selectionToInsertionEnd(tr, startLen, bias) {
    let last = tr.steps.length - 1;
    if (last < startLen) return;
    let step = tr.steps[last];
    if (!(step instanceof (0, $kQFGJ.ReplaceStep) || step instanceof (0, $kQFGJ.ReplaceAroundStep))) return;
    let map = tr.mapping.maps[last], end;
    map.forEach((_from, _to, _newFrom, newTo)=>{
        if (end == null) end = newTo;
    });
    tr.setSelection($f631bfe7512b7c19$export$52baac22726c72bf.near(tr.doc.resolve(end), bias));
}
const $f631bfe7512b7c19$var$UPDATED_SEL = 1, $f631bfe7512b7c19$var$UPDATED_MARKS = 2, $f631bfe7512b7c19$var$UPDATED_SCROLL = 4;
/**
An editor state transaction, which can be applied to a state to
create an updated state. Use
[`EditorState.tr`](https://prosemirror.net/docs/ref/#state.EditorState.tr) to create an instance.

Transactions track changes to the document (they are a subclass of
[`Transform`](https://prosemirror.net/docs/ref/#transform.Transform)), but also other state changes,
like selection updates and adjustments of the set of [stored
marks](https://prosemirror.net/docs/ref/#state.EditorState.storedMarks). In addition, you can store
metadata properties in a transaction, which are extra pieces of
information that client code or plugins can use to describe what a
transaction represents, so that they can update their [own
state](https://prosemirror.net/docs/ref/#state.StateField) accordingly.

The [editor view](https://prosemirror.net/docs/ref/#view.EditorView) uses a few metadata
properties: it will attach a property `"pointer"` with the value
`true` to selection transactions directly caused by mouse or touch
input, a `"composition"` property holding an ID identifying the
composition that caused it to transactions caused by composed DOM
input, and a `"uiEvent"` property of that may be `"paste"`,
`"cut"`, or `"drop"`.
*/ class $f631bfe7512b7c19$export$febc5573c75cefb0 extends (0, $kQFGJ.Transform) {
    /**
    @internal
    */ constructor(state){
        super(state.doc);
        // The step count for which the current selection is valid.
        this.curSelectionFor = 0;
        // Bitfield to track which aspects of the state were updated by
        // this transaction.
        this.updated = 0;
        // Object used to store metadata properties for the transaction.
        this.meta = Object.create(null);
        this.time = Date.now();
        this.curSelection = state.selection;
        this.storedMarks = state.storedMarks;
    }
    /**
    The transaction's current selection. This defaults to the editor
    selection [mapped](https://prosemirror.net/docs/ref/#state.Selection.map) through the steps in the
    transaction, but can be overwritten with
    [`setSelection`](https://prosemirror.net/docs/ref/#state.Transaction.setSelection).
    */ get selection() {
        if (this.curSelectionFor < this.steps.length) {
            this.curSelection = this.curSelection.map(this.doc, this.mapping.slice(this.curSelectionFor));
            this.curSelectionFor = this.steps.length;
        }
        return this.curSelection;
    }
    /**
    Update the transaction's current selection. Will determine the
    selection that the editor gets when the transaction is applied.
    */ setSelection(selection) {
        if (selection.$from.doc != this.doc) throw new RangeError("Selection passed to setSelection must point at the current document");
        this.curSelection = selection;
        this.curSelectionFor = this.steps.length;
        this.updated = (this.updated | $f631bfe7512b7c19$var$UPDATED_SEL) & ~$f631bfe7512b7c19$var$UPDATED_MARKS;
        this.storedMarks = null;
        return this;
    }
    /**
    Whether the selection was explicitly updated by this transaction.
    */ get selectionSet() {
        return (this.updated & $f631bfe7512b7c19$var$UPDATED_SEL) > 0;
    }
    /**
    Set the current stored marks.
    */ setStoredMarks(marks) {
        this.storedMarks = marks;
        this.updated |= $f631bfe7512b7c19$var$UPDATED_MARKS;
        return this;
    }
    /**
    Make sure the current stored marks or, if that is null, the marks
    at the selection, match the given set of marks. Does nothing if
    this is already the case.
    */ ensureMarks(marks) {
        if (!(0, $fsS3P.Mark).sameSet(this.storedMarks || this.selection.$from.marks(), marks)) this.setStoredMarks(marks);
        return this;
    }
    /**
    Add a mark to the set of stored marks.
    */ addStoredMark(mark) {
        return this.ensureMarks(mark.addToSet(this.storedMarks || this.selection.$head.marks()));
    }
    /**
    Remove a mark or mark type from the set of stored marks.
    */ removeStoredMark(mark) {
        return this.ensureMarks(mark.removeFromSet(this.storedMarks || this.selection.$head.marks()));
    }
    /**
    Whether the stored marks were explicitly set for this transaction.
    */ get storedMarksSet() {
        return (this.updated & $f631bfe7512b7c19$var$UPDATED_MARKS) > 0;
    }
    /**
    @internal
    */ addStep(step, doc) {
        super.addStep(step, doc);
        this.updated = this.updated & ~$f631bfe7512b7c19$var$UPDATED_MARKS;
        this.storedMarks = null;
    }
    /**
    Update the timestamp for the transaction.
    */ setTime(time) {
        this.time = time;
        return this;
    }
    /**
    Replace the current selection with the given slice.
    */ replaceSelection(slice) {
        this.selection.replace(this, slice);
        return this;
    }
    /**
    Replace the selection with the given node. When `inheritMarks` is
    true and the content is inline, it inherits the marks from the
    place where it is inserted.
    */ replaceSelectionWith(node, inheritMarks = true) {
        let selection = this.selection;
        if (inheritMarks) node = node.mark(this.storedMarks || (selection.empty ? selection.$from.marks() : selection.$from.marksAcross(selection.$to) || (0, $fsS3P.Mark).none));
        selection.replaceWith(this, node);
        return this;
    }
    /**
    Delete the selection.
    */ deleteSelection() {
        this.selection.replace(this);
        return this;
    }
    /**
    Replace the given range, or the selection if no range is given,
    with a text node containing the given string.
    */ insertText(text, from, to) {
        let schema = this.doc.type.schema;
        if (from == null) {
            if (!text) return this.deleteSelection();
            return this.replaceSelectionWith(schema.text(text), true);
        } else {
            if (to == null) to = from;
            to = to == null ? from : to;
            if (!text) return this.deleteRange(from, to);
            let marks = this.storedMarks;
            if (!marks) {
                let $from = this.doc.resolve(from);
                marks = to == from ? $from.marks() : $from.marksAcross(this.doc.resolve(to));
            }
            this.replaceRangeWith(from, to, schema.text(text, marks));
            if (!this.selection.empty) this.setSelection($f631bfe7512b7c19$export$52baac22726c72bf.near(this.selection.$to));
            return this;
        }
    }
    /**
    Store a metadata property in this transaction, keyed either by
    name or by plugin.
    */ setMeta(key, value) {
        this.meta[typeof key == "string" ? key : key.key] = value;
        return this;
    }
    /**
    Retrieve a metadata property for a given name or plugin.
    */ getMeta(key) {
        return this.meta[typeof key == "string" ? key : key.key];
    }
    /**
    Returns true if this transaction doesn't contain any metadata,
    and can thus safely be extended.
    */ get isGeneric() {
        for(let _ in this.meta)return false;
        return true;
    }
    /**
    Indicate that the editor should scroll the selection into view
    when updated to the state produced by this transaction.
    */ scrollIntoView() {
        this.updated |= $f631bfe7512b7c19$var$UPDATED_SCROLL;
        return this;
    }
    /**
    True when this transaction has had `scrollIntoView` called on it.
    */ get scrolledIntoView() {
        return (this.updated & $f631bfe7512b7c19$var$UPDATED_SCROLL) > 0;
    }
}
function $f631bfe7512b7c19$var$bind(f, self) {
    return !self || !f ? f : f.bind(self);
}
class $f631bfe7512b7c19$var$FieldDesc {
    constructor(name, desc, self){
        this.name = name;
        this.init = $f631bfe7512b7c19$var$bind(desc.init, self);
        this.apply = $f631bfe7512b7c19$var$bind(desc.apply, self);
    }
}
const $f631bfe7512b7c19$var$baseFields = [
    new $f631bfe7512b7c19$var$FieldDesc("doc", {
        init (config) {
            return config.doc || config.schema.topNodeType.createAndFill();
        },
        apply (tr) {
            return tr.doc;
        }
    }),
    new $f631bfe7512b7c19$var$FieldDesc("selection", {
        init (config, instance) {
            return config.selection || $f631bfe7512b7c19$export$52baac22726c72bf.atStart(instance.doc);
        },
        apply (tr) {
            return tr.selection;
        }
    }),
    new $f631bfe7512b7c19$var$FieldDesc("storedMarks", {
        init (config) {
            return config.storedMarks || null;
        },
        apply (tr, _marks, _old, state) {
            return state.selection.$cursor ? tr.storedMarks : null;
        }
    }),
    new $f631bfe7512b7c19$var$FieldDesc("scrollToSelection", {
        init () {
            return 0;
        },
        apply (tr, prev) {
            return tr.scrolledIntoView ? prev + 1 : prev;
        }
    })
];
// Object wrapping the part of a state object that stays the same
// across transactions. Stored in the state's `config` property.
class $f631bfe7512b7c19$var$Configuration {
    constructor(schema, plugins){
        this.schema = schema;
        this.plugins = [];
        this.pluginsByKey = Object.create(null);
        this.fields = $f631bfe7512b7c19$var$baseFields.slice();
        if (plugins) plugins.forEach((plugin)=>{
            if (this.pluginsByKey[plugin.key]) throw new RangeError("Adding different instances of a keyed plugin (" + plugin.key + ")");
            this.plugins.push(plugin);
            this.pluginsByKey[plugin.key] = plugin;
            if (plugin.spec.state) this.fields.push(new $f631bfe7512b7c19$var$FieldDesc(plugin.key, plugin.spec.state, plugin));
        });
    }
}
/**
The state of a ProseMirror editor is represented by an object of
this type. A state is a persistent data structure—it isn't
updated, but rather a new state value is computed from an old one
using the [`apply`](https://prosemirror.net/docs/ref/#state.EditorState.apply) method.

A state holds a number of built-in fields, and plugins can
[define](https://prosemirror.net/docs/ref/#state.PluginSpec.state) additional fields.
*/ class $f631bfe7512b7c19$export$afa855cbfaff27f2 {
    /**
    @internal
    */ constructor(/**
    @internal
    */ config){
        this.config = config;
    }
    /**
    The schema of the state's document.
    */ get schema() {
        return this.config.schema;
    }
    /**
    The plugins that are active in this state.
    */ get plugins() {
        return this.config.plugins;
    }
    /**
    Apply the given transaction to produce a new state.
    */ apply(tr) {
        return this.applyTransaction(tr).state;
    }
    /**
    @internal
    */ filterTransaction(tr, ignore = -1) {
        for(let i = 0; i < this.config.plugins.length; i++)if (i != ignore) {
            let plugin = this.config.plugins[i];
            if (plugin.spec.filterTransaction && !plugin.spec.filterTransaction.call(plugin, tr, this)) return false;
        }
        return true;
    }
    /**
    Verbose variant of [`apply`](https://prosemirror.net/docs/ref/#state.EditorState.apply) that
    returns the precise transactions that were applied (which might
    be influenced by the [transaction
    hooks](https://prosemirror.net/docs/ref/#state.PluginSpec.filterTransaction) of
    plugins) along with the new state.
    */ applyTransaction(rootTr) {
        if (!this.filterTransaction(rootTr)) return {
            state: this,
            transactions: []
        };
        let trs = [
            rootTr
        ], newState = this.applyInner(rootTr), seen = null;
        // This loop repeatedly gives plugins a chance to respond to
        // transactions as new transactions are added, making sure to only
        // pass the transactions the plugin did not see before.
        for(;;){
            let haveNew = false;
            for(let i = 0; i < this.config.plugins.length; i++){
                let plugin = this.config.plugins[i];
                if (plugin.spec.appendTransaction) {
                    let n = seen ? seen[i].n : 0, oldState = seen ? seen[i].state : this;
                    let tr = n < trs.length && plugin.spec.appendTransaction.call(plugin, n ? trs.slice(n) : trs, oldState, newState);
                    if (tr && newState.filterTransaction(tr, i)) {
                        tr.setMeta("appendedTransaction", rootTr);
                        if (!seen) {
                            seen = [];
                            for(let j = 0; j < this.config.plugins.length; j++)seen.push(j < i ? {
                                state: newState,
                                n: trs.length
                            } : {
                                state: this,
                                n: 0
                            });
                        }
                        trs.push(tr);
                        newState = newState.applyInner(tr);
                        haveNew = true;
                    }
                    if (seen) seen[i] = {
                        state: newState,
                        n: trs.length
                    };
                }
            }
            if (!haveNew) return {
                state: newState,
                transactions: trs
            };
        }
    }
    /**
    @internal
    */ applyInner(tr) {
        if (!tr.before.eq(this.doc)) throw new RangeError("Applying a mismatched transaction");
        let newInstance = new $f631bfe7512b7c19$export$afa855cbfaff27f2(this.config), fields = this.config.fields;
        for(let i = 0; i < fields.length; i++){
            let field = fields[i];
            newInstance[field.name] = field.apply(tr, this[field.name], this, newInstance);
        }
        return newInstance;
    }
    /**
    Start a [transaction](https://prosemirror.net/docs/ref/#state.Transaction) from this state.
    */ get tr() {
        return new $f631bfe7512b7c19$export$febc5573c75cefb0(this);
    }
    /**
    Create a new state.
    */ static create(config) {
        let $config = new $f631bfe7512b7c19$var$Configuration(config.doc ? config.doc.type.schema : config.schema, config.plugins);
        let instance = new $f631bfe7512b7c19$export$afa855cbfaff27f2($config);
        for(let i = 0; i < $config.fields.length; i++)instance[$config.fields[i].name] = $config.fields[i].init(config, instance);
        return instance;
    }
    /**
    Create a new state based on this one, but with an adjusted set
    of active plugins. State fields that exist in both sets of
    plugins are kept unchanged. Those that no longer exist are
    dropped, and those that are new are initialized using their
    [`init`](https://prosemirror.net/docs/ref/#state.StateField.init) method, passing in the new
    configuration object..
    */ reconfigure(config) {
        let $config = new $f631bfe7512b7c19$var$Configuration(this.schema, config.plugins);
        let fields = $config.fields, instance = new $f631bfe7512b7c19$export$afa855cbfaff27f2($config);
        for(let i = 0; i < fields.length; i++){
            let name = fields[i].name;
            instance[name] = this.hasOwnProperty(name) ? this[name] : fields[i].init(config, instance);
        }
        return instance;
    }
    /**
    Serialize this state to JSON. If you want to serialize the state
    of plugins, pass an object mapping property names to use in the
    resulting JSON object to plugin objects. The argument may also be
    a string or number, in which case it is ignored, to support the
    way `JSON.stringify` calls `toString` methods.
    */ toJSON(pluginFields) {
        let result = {
            doc: this.doc.toJSON(),
            selection: this.selection.toJSON()
        };
        if (this.storedMarks) result.storedMarks = this.storedMarks.map((m)=>m.toJSON());
        if (pluginFields && typeof pluginFields == 'object') for(let prop in pluginFields){
            if (prop == "doc" || prop == "selection") throw new RangeError("The JSON fields `doc` and `selection` are reserved");
            let plugin = pluginFields[prop], state = plugin.spec.state;
            if (state && state.toJSON) result[prop] = state.toJSON.call(plugin, this[plugin.key]);
        }
        return result;
    }
    /**
    Deserialize a JSON representation of a state. `config` should
    have at least a `schema` field, and should contain array of
    plugins to initialize the state with. `pluginFields` can be used
    to deserialize the state of plugins, by associating plugin
    instances with the property names they use in the JSON object.
    */ static fromJSON(config, json, pluginFields) {
        if (!json) throw new RangeError("Invalid input for EditorState.fromJSON");
        if (!config.schema) throw new RangeError("Required config field 'schema' missing");
        let $config = new $f631bfe7512b7c19$var$Configuration(config.schema, config.plugins);
        let instance = new $f631bfe7512b7c19$export$afa855cbfaff27f2($config);
        $config.fields.forEach((field)=>{
            if (field.name == "doc") instance.doc = (0, $fsS3P.Node).fromJSON(config.schema, json.doc);
            else if (field.name == "selection") instance.selection = $f631bfe7512b7c19$export$52baac22726c72bf.fromJSON(instance.doc, json.selection);
            else if (field.name == "storedMarks") {
                if (json.storedMarks) instance.storedMarks = json.storedMarks.map(config.schema.markFromJSON);
            } else {
                if (pluginFields) for(let prop in pluginFields){
                    let plugin = pluginFields[prop], state = plugin.spec.state;
                    if (plugin.key == field.name && state && state.fromJSON && Object.prototype.hasOwnProperty.call(json, prop)) {
                        instance[field.name] = state.fromJSON.call(plugin, config, json[prop], instance);
                        return;
                    }
                }
                instance[field.name] = field.init(config, instance);
            }
        });
        return instance;
    }
}
function $f631bfe7512b7c19$var$bindProps(obj, self, target) {
    for(let prop in obj){
        let val = obj[prop];
        if (val instanceof Function) val = val.bind(self);
        else if (prop == "handleDOMEvents") val = $f631bfe7512b7c19$var$bindProps(val, self, {});
        target[prop] = val;
    }
    return target;
}
/**
Plugins bundle functionality that can be added to an editor.
They are part of the [editor state](https://prosemirror.net/docs/ref/#state.EditorState) and
may influence that state and the view that contains it.
*/ class $f631bfe7512b7c19$export$901cf72dabf2112a {
    /**
    Create a plugin.
    */ constructor(/**
    The plugin's [spec object](https://prosemirror.net/docs/ref/#state.PluginSpec).
    */ spec){
        this.spec = spec;
        /**
        The [props](https://prosemirror.net/docs/ref/#view.EditorProps) exported by this plugin.
        */ this.props = {};
        if (spec.props) $f631bfe7512b7c19$var$bindProps(spec.props, this, this.props);
        this.key = spec.key ? spec.key.key : $f631bfe7512b7c19$var$createKey("plugin");
    }
    /**
    Extract the plugin's state field from an editor state.
    */ getState(state) {
        return state[this.key];
    }
}
const $f631bfe7512b7c19$var$keys = Object.create(null);
function $f631bfe7512b7c19$var$createKey(name) {
    if (name in $f631bfe7512b7c19$var$keys) return name + "$" + ++$f631bfe7512b7c19$var$keys[name];
    $f631bfe7512b7c19$var$keys[name] = 0;
    return name + "$";
}
/**
A key is used to [tag](https://prosemirror.net/docs/ref/#state.PluginSpec.key) plugins in a way
that makes it possible to find them, given an editor state.
Assigning a key does mean only one plugin of that type can be
active in a state.
*/ class $f631bfe7512b7c19$export$1692d8b0e89cecc3 {
    /**
    Create a plugin key.
    */ constructor(name = "key"){
        this.key = $f631bfe7512b7c19$var$createKey(name);
    }
    /**
    Get the active plugin with this key, if any, from an editor
    state.
    */ get(state) {
        return state.config.pluginsByKey[this.key];
    }
    /**
    Get the plugin's state from an editor state.
    */ getState(state) {
        return state[this.key];
    }
}

});
parcelRegister("fsS3P", function(module, exports) {
$parcel$export(module.exports, "Fragment", () => $b42367e7348c0623$export$ffb0004e005737fa);
$parcel$export(module.exports, "Mark", () => $b42367e7348c0623$export$c9d15bcfc6d42044);
$parcel$export(module.exports, "ReplaceError", () => $b42367e7348c0623$export$6de0e778727af3f2);
$parcel$export(module.exports, "Slice", () => $b42367e7348c0623$export$b3f2e2de3a8baa1e);
$parcel$export(module.exports, "Node", () => $b42367e7348c0623$export$85c928794f8d04d4);
$parcel$export(module.exports, "MarkType", () => $b42367e7348c0623$export$b6a78689043c6521);

var $at9VT = parcelRequire("at9VT");
function $b42367e7348c0623$var$findDiffStart(a, b, pos) {
    for(let i = 0;; i++){
        if (i == a.childCount || i == b.childCount) return a.childCount == b.childCount ? null : pos;
        let childA = a.child(i), childB = b.child(i);
        if (childA == childB) {
            pos += childA.nodeSize;
            continue;
        }
        if (!childA.sameMarkup(childB)) return pos;
        if (childA.isText && childA.text != childB.text) {
            for(let j = 0; childA.text[j] == childB.text[j]; j++)pos++;
            return pos;
        }
        if (childA.content.size || childB.content.size) {
            let inner = $b42367e7348c0623$var$findDiffStart(childA.content, childB.content, pos + 1);
            if (inner != null) return inner;
        }
        pos += childA.nodeSize;
    }
}
function $b42367e7348c0623$var$findDiffEnd(a, b, posA, posB) {
    for(let iA = a.childCount, iB = b.childCount;;){
        if (iA == 0 || iB == 0) return iA == iB ? null : {
            a: posA,
            b: posB
        };
        let childA = a.child(--iA), childB = b.child(--iB), size = childA.nodeSize;
        if (childA == childB) {
            posA -= size;
            posB -= size;
            continue;
        }
        if (!childA.sameMarkup(childB)) return {
            a: posA,
            b: posB
        };
        if (childA.isText && childA.text != childB.text) {
            let same = 0, minSize = Math.min(childA.text.length, childB.text.length);
            while(same < minSize && childA.text[childA.text.length - same - 1] == childB.text[childB.text.length - same - 1]){
                same++;
                posA--;
                posB--;
            }
            return {
                a: posA,
                b: posB
            };
        }
        if (childA.content.size || childB.content.size) {
            let inner = $b42367e7348c0623$var$findDiffEnd(childA.content, childB.content, posA - 1, posB - 1);
            if (inner) return inner;
        }
        posA -= size;
        posB -= size;
    }
}
/**
A fragment represents a node's collection of child nodes.

Like nodes, fragments are persistent data structures, and you
should not mutate them or their content. Rather, you create new
instances whenever needed. The API tries to make this easy.
*/ class $b42367e7348c0623$export$ffb0004e005737fa {
    /**
    @internal
    */ constructor(/**
    The child nodes in this fragment.
    */ content, size){
        this.content = content;
        this.size = size || 0;
        if (size == null) for(let i = 0; i < content.length; i++)this.size += content[i].nodeSize;
    }
    /**
    Invoke a callback for all descendant nodes between the given two
    positions (relative to start of this fragment). Doesn't descend
    into a node when the callback returns `false`.
    */ nodesBetween(from, to, f, nodeStart = 0, parent) {
        for(let i = 0, pos = 0; pos < to; i++){
            let child = this.content[i], end = pos + child.nodeSize;
            if (end > from && f(child, nodeStart + pos, parent || null, i) !== false && child.content.size) {
                let start = pos + 1;
                child.nodesBetween(Math.max(0, from - start), Math.min(child.content.size, to - start), f, nodeStart + start);
            }
            pos = end;
        }
    }
    /**
    Call the given callback for every descendant node. `pos` will be
    relative to the start of the fragment. The callback may return
    `false` to prevent traversal of a given node's children.
    */ descendants(f) {
        this.nodesBetween(0, this.size, f);
    }
    /**
    Extract the text between `from` and `to`. See the same method on
    [`Node`](https://prosemirror.net/docs/ref/#model.Node.textBetween).
    */ textBetween(from, to, blockSeparator, leafText) {
        let text = "", first = true;
        this.nodesBetween(from, to, (node, pos)=>{
            let nodeText = node.isText ? node.text.slice(Math.max(from, pos) - pos, to - pos) : !node.isLeaf ? "" : leafText ? typeof leafText === "function" ? leafText(node) : leafText : node.type.spec.leafText ? node.type.spec.leafText(node) : "";
            if (node.isBlock && (node.isLeaf && nodeText || node.isTextblock) && blockSeparator) {
                if (first) first = false;
                else text += blockSeparator;
            }
            text += nodeText;
        }, 0);
        return text;
    }
    /**
    Create a new fragment containing the combined content of this
    fragment and the other.
    */ append(other) {
        if (!other.size) return this;
        if (!this.size) return other;
        let last = this.lastChild, first = other.firstChild, content = this.content.slice(), i = 0;
        if (last.isText && last.sameMarkup(first)) {
            content[content.length - 1] = last.withText(last.text + first.text);
            i = 1;
        }
        for(; i < other.content.length; i++)content.push(other.content[i]);
        return new $b42367e7348c0623$export$ffb0004e005737fa(content, this.size + other.size);
    }
    /**
    Cut out the sub-fragment between the two given positions.
    */ cut(from, to = this.size) {
        if (from == 0 && to == this.size) return this;
        let result = [], size = 0;
        if (to > from) for(let i = 0, pos = 0; pos < to; i++){
            let child = this.content[i], end = pos + child.nodeSize;
            if (end > from) {
                if (pos < from || end > to) {
                    if (child.isText) child = child.cut(Math.max(0, from - pos), Math.min(child.text.length, to - pos));
                    else child = child.cut(Math.max(0, from - pos - 1), Math.min(child.content.size, to - pos - 1));
                }
                result.push(child);
                size += child.nodeSize;
            }
            pos = end;
        }
        return new $b42367e7348c0623$export$ffb0004e005737fa(result, size);
    }
    /**
    @internal
    */ cutByIndex(from, to) {
        if (from == to) return $b42367e7348c0623$export$ffb0004e005737fa.empty;
        if (from == 0 && to == this.content.length) return this;
        return new $b42367e7348c0623$export$ffb0004e005737fa(this.content.slice(from, to));
    }
    /**
    Create a new fragment in which the node at the given index is
    replaced by the given node.
    */ replaceChild(index, node) {
        let current = this.content[index];
        if (current == node) return this;
        let copy = this.content.slice();
        let size = this.size + node.nodeSize - current.nodeSize;
        copy[index] = node;
        return new $b42367e7348c0623$export$ffb0004e005737fa(copy, size);
    }
    /**
    Create a new fragment by prepending the given node to this
    fragment.
    */ addToStart(node) {
        return new $b42367e7348c0623$export$ffb0004e005737fa([
            node
        ].concat(this.content), this.size + node.nodeSize);
    }
    /**
    Create a new fragment by appending the given node to this
    fragment.
    */ addToEnd(node) {
        return new $b42367e7348c0623$export$ffb0004e005737fa(this.content.concat(node), this.size + node.nodeSize);
    }
    /**
    Compare this fragment to another one.
    */ eq(other) {
        if (this.content.length != other.content.length) return false;
        for(let i = 0; i < this.content.length; i++)if (!this.content[i].eq(other.content[i])) return false;
        return true;
    }
    /**
    The first child of the fragment, or `null` if it is empty.
    */ get firstChild() {
        return this.content.length ? this.content[0] : null;
    }
    /**
    The last child of the fragment, or `null` if it is empty.
    */ get lastChild() {
        return this.content.length ? this.content[this.content.length - 1] : null;
    }
    /**
    The number of child nodes in this fragment.
    */ get childCount() {
        return this.content.length;
    }
    /**
    Get the child node at the given index. Raise an error when the
    index is out of range.
    */ child(index) {
        let found = this.content[index];
        if (!found) throw new RangeError("Index " + index + " out of range for " + this);
        return found;
    }
    /**
    Get the child node at the given index, if it exists.
    */ maybeChild(index) {
        return this.content[index] || null;
    }
    /**
    Call `f` for every child node, passing the node, its offset
    into this parent node, and its index.
    */ forEach(f) {
        for(let i = 0, p = 0; i < this.content.length; i++){
            let child = this.content[i];
            f(child, p, i);
            p += child.nodeSize;
        }
    }
    /**
    Find the first position at which this fragment and another
    fragment differ, or `null` if they are the same.
    */ findDiffStart(other, pos = 0) {
        return $b42367e7348c0623$var$findDiffStart(this, other, pos);
    }
    /**
    Find the first position, searching from the end, at which this
    fragment and the given fragment differ, or `null` if they are
    the same. Since this position will not be the same in both
    nodes, an object with two separate positions is returned.
    */ findDiffEnd(other, pos = this.size, otherPos = other.size) {
        return $b42367e7348c0623$var$findDiffEnd(this, other, pos, otherPos);
    }
    /**
    Find the index and inner offset corresponding to a given relative
    position in this fragment. The result object will be reused
    (overwritten) the next time the function is called. @internal
    */ findIndex(pos) {
        if (pos == 0) return $b42367e7348c0623$var$retIndex(0, pos);
        if (pos == this.size) return $b42367e7348c0623$var$retIndex(this.content.length, pos);
        if (pos > this.size || pos < 0) throw new RangeError(`Position ${pos} outside of fragment (${this})`);
        for(let i = 0, curPos = 0;; i++){
            let cur = this.child(i), end = curPos + cur.nodeSize;
            if (end >= pos) {
                if (end == pos) return $b42367e7348c0623$var$retIndex(i + 1, end);
                return $b42367e7348c0623$var$retIndex(i, curPos);
            }
            curPos = end;
        }
    }
    /**
    Return a debugging string that describes this fragment.
    */ toString() {
        return "<" + this.toStringInner() + ">";
    }
    /**
    @internal
    */ toStringInner() {
        return this.content.join(", ");
    }
    /**
    Create a JSON-serializeable representation of this fragment.
    */ toJSON() {
        return this.content.length ? this.content.map((n)=>n.toJSON()) : null;
    }
    /**
    Deserialize a fragment from its JSON representation.
    */ static fromJSON(schema, value) {
        if (!value) return $b42367e7348c0623$export$ffb0004e005737fa.empty;
        if (!Array.isArray(value)) throw new RangeError("Invalid input for Fragment.fromJSON");
        return new $b42367e7348c0623$export$ffb0004e005737fa(value.map(schema.nodeFromJSON));
    }
    /**
    Build a fragment from an array of nodes. Ensures that adjacent
    text nodes with the same marks are joined together.
    */ static fromArray(array) {
        if (!array.length) return $b42367e7348c0623$export$ffb0004e005737fa.empty;
        let joined, size = 0;
        for(let i = 0; i < array.length; i++){
            let node = array[i];
            size += node.nodeSize;
            if (i && node.isText && array[i - 1].sameMarkup(node)) {
                if (!joined) joined = array.slice(0, i);
                joined[joined.length - 1] = node.withText(joined[joined.length - 1].text + node.text);
            } else if (joined) joined.push(node);
        }
        return new $b42367e7348c0623$export$ffb0004e005737fa(joined || array, size);
    }
    /**
    Create a fragment from something that can be interpreted as a
    set of nodes. For `null`, it returns the empty fragment. For a
    fragment, the fragment itself. For a node or array of nodes, a
    fragment containing those nodes.
    */ static from(nodes) {
        if (!nodes) return $b42367e7348c0623$export$ffb0004e005737fa.empty;
        if (nodes instanceof $b42367e7348c0623$export$ffb0004e005737fa) return nodes;
        if (Array.isArray(nodes)) return this.fromArray(nodes);
        if (nodes.attrs) return new $b42367e7348c0623$export$ffb0004e005737fa([
            nodes
        ], nodes.nodeSize);
        throw new RangeError("Can not convert " + nodes + " to a Fragment" + (nodes.nodesBetween ? " (looks like multiple versions of prosemirror-model were loaded)" : ""));
    }
}
/**
An empty fragment. Intended to be reused whenever a node doesn't
contain anything (rather than allocating a new empty fragment for
each leaf node).
*/ $b42367e7348c0623$export$ffb0004e005737fa.empty = new $b42367e7348c0623$export$ffb0004e005737fa([], 0);
const $b42367e7348c0623$var$found = {
    index: 0,
    offset: 0
};
function $b42367e7348c0623$var$retIndex(index, offset) {
    $b42367e7348c0623$var$found.index = index;
    $b42367e7348c0623$var$found.offset = offset;
    return $b42367e7348c0623$var$found;
}
function $b42367e7348c0623$var$compareDeep(a, b) {
    if (a === b) return true;
    if (!(a && typeof a == "object") || !(b && typeof b == "object")) return false;
    let array = Array.isArray(a);
    if (Array.isArray(b) != array) return false;
    if (array) {
        if (a.length != b.length) return false;
        for(let i = 0; i < a.length; i++)if (!$b42367e7348c0623$var$compareDeep(a[i], b[i])) return false;
    } else {
        for(let p in a)if (!(p in b) || !$b42367e7348c0623$var$compareDeep(a[p], b[p])) return false;
        for(let p in b)if (!(p in a)) return false;
    }
    return true;
}
/**
A mark is a piece of information that can be attached to a node,
such as it being emphasized, in code font, or a link. It has a
type and optionally a set of attributes that provide further
information (such as the target of the link). Marks are created
through a `Schema`, which controls which types exist and which
attributes they have.
*/ class $b42367e7348c0623$export$c9d15bcfc6d42044 {
    /**
    @internal
    */ constructor(/**
    The type of this mark.
    */ type, /**
    The attributes associated with this mark.
    */ attrs){
        this.type = type;
        this.attrs = attrs;
    }
    /**
    Given a set of marks, create a new set which contains this one as
    well, in the right position. If this mark is already in the set,
    the set itself is returned. If any marks that are set to be
    [exclusive](https://prosemirror.net/docs/ref/#model.MarkSpec.excludes) with this mark are present,
    those are replaced by this one.
    */ addToSet(set) {
        let copy, placed = false;
        for(let i = 0; i < set.length; i++){
            let other = set[i];
            if (this.eq(other)) return set;
            if (this.type.excludes(other.type)) {
                if (!copy) copy = set.slice(0, i);
            } else if (other.type.excludes(this.type)) return set;
            else {
                if (!placed && other.type.rank > this.type.rank) {
                    if (!copy) copy = set.slice(0, i);
                    copy.push(this);
                    placed = true;
                }
                if (copy) copy.push(other);
            }
        }
        if (!copy) copy = set.slice();
        if (!placed) copy.push(this);
        return copy;
    }
    /**
    Remove this mark from the given set, returning a new set. If this
    mark is not in the set, the set itself is returned.
    */ removeFromSet(set) {
        for(let i = 0; i < set.length; i++)if (this.eq(set[i])) return set.slice(0, i).concat(set.slice(i + 1));
        return set;
    }
    /**
    Test whether this mark is in the given set of marks.
    */ isInSet(set) {
        for(let i = 0; i < set.length; i++)if (this.eq(set[i])) return true;
        return false;
    }
    /**
    Test whether this mark has the same type and attributes as
    another mark.
    */ eq(other) {
        return this == other || this.type == other.type && $b42367e7348c0623$var$compareDeep(this.attrs, other.attrs);
    }
    /**
    Convert this mark to a JSON-serializeable representation.
    */ toJSON() {
        let obj = {
            type: this.type.name
        };
        for(let _ in this.attrs){
            obj.attrs = this.attrs;
            break;
        }
        return obj;
    }
    /**
    Deserialize a mark from JSON.
    */ static fromJSON(schema, json) {
        if (!json) throw new RangeError("Invalid input for Mark.fromJSON");
        let type = schema.marks[json.type];
        if (!type) throw new RangeError(`There is no mark type ${json.type} in this schema`);
        let mark = type.create(json.attrs);
        type.checkAttrs(mark.attrs);
        return mark;
    }
    /**
    Test whether two sets of marks are identical.
    */ static sameSet(a, b) {
        if (a == b) return true;
        if (a.length != b.length) return false;
        for(let i = 0; i < a.length; i++)if (!a[i].eq(b[i])) return false;
        return true;
    }
    /**
    Create a properly sorted mark set from null, a single mark, or an
    unsorted array of marks.
    */ static setFrom(marks) {
        if (!marks || Array.isArray(marks) && marks.length == 0) return $b42367e7348c0623$export$c9d15bcfc6d42044.none;
        if (marks instanceof $b42367e7348c0623$export$c9d15bcfc6d42044) return [
            marks
        ];
        let copy = marks.slice();
        copy.sort((a, b)=>a.type.rank - b.type.rank);
        return copy;
    }
}
/**
The empty set of marks.
*/ $b42367e7348c0623$export$c9d15bcfc6d42044.none = [];
/**
Error type raised by [`Node.replace`](https://prosemirror.net/docs/ref/#model.Node.replace) when
given an invalid replacement.
*/ class $b42367e7348c0623$export$6de0e778727af3f2 extends Error {
}
/*
ReplaceError = function(this: any, message: string) {
  let err = Error.call(this, message)
  ;(err as any).__proto__ = ReplaceError.prototype
  return err
} as any

ReplaceError.prototype = Object.create(Error.prototype)
ReplaceError.prototype.constructor = ReplaceError
ReplaceError.prototype.name = "ReplaceError"
*/ /**
A slice represents a piece cut out of a larger document. It
stores not only a fragment, but also the depth up to which nodes on
both side are ‘open’ (cut through).
*/ class $b42367e7348c0623$export$b3f2e2de3a8baa1e {
    /**
    Create a slice. When specifying a non-zero open depth, you must
    make sure that there are nodes of at least that depth at the
    appropriate side of the fragment—i.e. if the fragment is an
    empty paragraph node, `openStart` and `openEnd` can't be greater
    than 1.
    
    It is not necessary for the content of open nodes to conform to
    the schema's content constraints, though it should be a valid
    start/end/middle for such a node, depending on which sides are
    open.
    */ constructor(/**
    The slice's content.
    */ content, /**
    The open depth at the start of the fragment.
    */ openStart, /**
    The open depth at the end.
    */ openEnd){
        this.content = content;
        this.openStart = openStart;
        this.openEnd = openEnd;
    }
    /**
    The size this slice would add when inserted into a document.
    */ get size() {
        return this.content.size - this.openStart - this.openEnd;
    }
    /**
    @internal
    */ insertAt(pos, fragment) {
        let content = $b42367e7348c0623$var$insertInto(this.content, pos + this.openStart, fragment);
        return content && new $b42367e7348c0623$export$b3f2e2de3a8baa1e(content, this.openStart, this.openEnd);
    }
    /**
    @internal
    */ removeBetween(from, to) {
        return new $b42367e7348c0623$export$b3f2e2de3a8baa1e($b42367e7348c0623$var$removeRange(this.content, from + this.openStart, to + this.openStart), this.openStart, this.openEnd);
    }
    /**
    Tests whether this slice is equal to another slice.
    */ eq(other) {
        return this.content.eq(other.content) && this.openStart == other.openStart && this.openEnd == other.openEnd;
    }
    /**
    @internal
    */ toString() {
        return this.content + "(" + this.openStart + "," + this.openEnd + ")";
    }
    /**
    Convert a slice to a JSON-serializable representation.
    */ toJSON() {
        if (!this.content.size) return null;
        let json = {
            content: this.content.toJSON()
        };
        if (this.openStart > 0) json.openStart = this.openStart;
        if (this.openEnd > 0) json.openEnd = this.openEnd;
        return json;
    }
    /**
    Deserialize a slice from its JSON representation.
    */ static fromJSON(schema, json) {
        if (!json) return $b42367e7348c0623$export$b3f2e2de3a8baa1e.empty;
        let openStart = json.openStart || 0, openEnd = json.openEnd || 0;
        if (typeof openStart != "number" || typeof openEnd != "number") throw new RangeError("Invalid input for Slice.fromJSON");
        return new $b42367e7348c0623$export$b3f2e2de3a8baa1e($b42367e7348c0623$export$ffb0004e005737fa.fromJSON(schema, json.content), openStart, openEnd);
    }
    /**
    Create a slice from a fragment by taking the maximum possible
    open value on both side of the fragment.
    */ static maxOpen(fragment, openIsolating = true) {
        let openStart = 0, openEnd = 0;
        for(let n = fragment.firstChild; n && !n.isLeaf && (openIsolating || !n.type.spec.isolating); n = n.firstChild)openStart++;
        for(let n = fragment.lastChild; n && !n.isLeaf && (openIsolating || !n.type.spec.isolating); n = n.lastChild)openEnd++;
        return new $b42367e7348c0623$export$b3f2e2de3a8baa1e(fragment, openStart, openEnd);
    }
}
/**
The empty slice.
*/ $b42367e7348c0623$export$b3f2e2de3a8baa1e.empty = new $b42367e7348c0623$export$b3f2e2de3a8baa1e($b42367e7348c0623$export$ffb0004e005737fa.empty, 0, 0);
function $b42367e7348c0623$var$removeRange(content, from, to) {
    let { index: index, offset: offset } = content.findIndex(from), child = content.maybeChild(index);
    let { index: indexTo, offset: offsetTo } = content.findIndex(to);
    if (offset == from || child.isText) {
        if (offsetTo != to && !content.child(indexTo).isText) throw new RangeError("Removing non-flat range");
        return content.cut(0, from).append(content.cut(to));
    }
    if (index != indexTo) throw new RangeError("Removing non-flat range");
    return content.replaceChild(index, child.copy($b42367e7348c0623$var$removeRange(child.content, from - offset - 1, to - offset - 1)));
}
function $b42367e7348c0623$var$insertInto(content, dist, insert, parent) {
    let { index: index, offset: offset } = content.findIndex(dist), child = content.maybeChild(index);
    if (offset == dist || child.isText) {
        if (parent && !parent.canReplace(index, index, insert)) return null;
        return content.cut(0, dist).append(insert).append(content.cut(dist));
    }
    let inner = $b42367e7348c0623$var$insertInto(child.content, dist - offset - 1, insert, child);
    return inner && content.replaceChild(index, child.copy(inner));
}
function $b42367e7348c0623$var$replace($from, $to, slice) {
    if (slice.openStart > $from.depth) throw new $b42367e7348c0623$export$6de0e778727af3f2("Inserted content deeper than insertion position");
    if ($from.depth - slice.openStart != $to.depth - slice.openEnd) throw new $b42367e7348c0623$export$6de0e778727af3f2("Inconsistent open depths");
    return $b42367e7348c0623$var$replaceOuter($from, $to, slice, 0);
}
function $b42367e7348c0623$var$replaceOuter($from, $to, slice, depth) {
    let index = $from.index(depth), node = $from.node(depth);
    if (index == $to.index(depth) && depth < $from.depth - slice.openStart) {
        let inner = $b42367e7348c0623$var$replaceOuter($from, $to, slice, depth + 1);
        return node.copy(node.content.replaceChild(index, inner));
    } else if (!slice.content.size) return $b42367e7348c0623$var$close(node, $b42367e7348c0623$var$replaceTwoWay($from, $to, depth));
    else if (!slice.openStart && !slice.openEnd && $from.depth == depth && $to.depth == depth) {
        let parent = $from.parent, content = parent.content;
        return $b42367e7348c0623$var$close(parent, content.cut(0, $from.parentOffset).append(slice.content).append(content.cut($to.parentOffset)));
    } else {
        let { start: start, end: end } = $b42367e7348c0623$var$prepareSliceForReplace(slice, $from);
        return $b42367e7348c0623$var$close(node, $b42367e7348c0623$var$replaceThreeWay($from, start, end, $to, depth));
    }
}
function $b42367e7348c0623$var$checkJoin(main, sub) {
    if (!sub.type.compatibleContent(main.type)) throw new $b42367e7348c0623$export$6de0e778727af3f2("Cannot join " + sub.type.name + " onto " + main.type.name);
}
function $b42367e7348c0623$var$joinable($before, $after, depth) {
    let node = $before.node(depth);
    $b42367e7348c0623$var$checkJoin(node, $after.node(depth));
    return node;
}
function $b42367e7348c0623$var$addNode(child, target) {
    let last = target.length - 1;
    if (last >= 0 && child.isText && child.sameMarkup(target[last])) target[last] = child.withText(target[last].text + child.text);
    else target.push(child);
}
function $b42367e7348c0623$var$addRange($start, $end, depth, target) {
    let node = ($end || $start).node(depth);
    let startIndex = 0, endIndex = $end ? $end.index(depth) : node.childCount;
    if ($start) {
        startIndex = $start.index(depth);
        if ($start.depth > depth) startIndex++;
        else if ($start.textOffset) {
            $b42367e7348c0623$var$addNode($start.nodeAfter, target);
            startIndex++;
        }
    }
    for(let i = startIndex; i < endIndex; i++)$b42367e7348c0623$var$addNode(node.child(i), target);
    if ($end && $end.depth == depth && $end.textOffset) $b42367e7348c0623$var$addNode($end.nodeBefore, target);
}
function $b42367e7348c0623$var$close(node, content) {
    node.type.checkContent(content);
    return node.copy(content);
}
function $b42367e7348c0623$var$replaceThreeWay($from, $start, $end, $to, depth) {
    let openStart = $from.depth > depth && $b42367e7348c0623$var$joinable($from, $start, depth + 1);
    let openEnd = $to.depth > depth && $b42367e7348c0623$var$joinable($end, $to, depth + 1);
    let content = [];
    $b42367e7348c0623$var$addRange(null, $from, depth, content);
    if (openStart && openEnd && $start.index(depth) == $end.index(depth)) {
        $b42367e7348c0623$var$checkJoin(openStart, openEnd);
        $b42367e7348c0623$var$addNode($b42367e7348c0623$var$close(openStart, $b42367e7348c0623$var$replaceThreeWay($from, $start, $end, $to, depth + 1)), content);
    } else {
        if (openStart) $b42367e7348c0623$var$addNode($b42367e7348c0623$var$close(openStart, $b42367e7348c0623$var$replaceTwoWay($from, $start, depth + 1)), content);
        $b42367e7348c0623$var$addRange($start, $end, depth, content);
        if (openEnd) $b42367e7348c0623$var$addNode($b42367e7348c0623$var$close(openEnd, $b42367e7348c0623$var$replaceTwoWay($end, $to, depth + 1)), content);
    }
    $b42367e7348c0623$var$addRange($to, null, depth, content);
    return new $b42367e7348c0623$export$ffb0004e005737fa(content);
}
function $b42367e7348c0623$var$replaceTwoWay($from, $to, depth) {
    let content = [];
    $b42367e7348c0623$var$addRange(null, $from, depth, content);
    if ($from.depth > depth) {
        let type = $b42367e7348c0623$var$joinable($from, $to, depth + 1);
        $b42367e7348c0623$var$addNode($b42367e7348c0623$var$close(type, $b42367e7348c0623$var$replaceTwoWay($from, $to, depth + 1)), content);
    }
    $b42367e7348c0623$var$addRange($to, null, depth, content);
    return new $b42367e7348c0623$export$ffb0004e005737fa(content);
}
function $b42367e7348c0623$var$prepareSliceForReplace(slice, $along) {
    let extra = $along.depth - slice.openStart, parent = $along.node(extra);
    let node = parent.copy(slice.content);
    for(let i = extra - 1; i >= 0; i--)node = $along.node(i).copy($b42367e7348c0623$export$ffb0004e005737fa.from(node));
    return {
        start: node.resolveNoCache(slice.openStart + extra),
        end: node.resolveNoCache(node.content.size - slice.openEnd - extra)
    };
}
/**
You can [_resolve_](https://prosemirror.net/docs/ref/#model.Node.resolve) a position to get more
information about it. Objects of this class represent such a
resolved position, providing various pieces of context
information, and some helper methods.

Throughout this interface, methods that take an optional `depth`
parameter will interpret undefined as `this.depth` and negative
numbers as `this.depth + value`.
*/ class $b42367e7348c0623$export$b2a42f82e59e4b19 {
    /**
    @internal
    */ constructor(/**
    The position that was resolved.
    */ pos, /**
    @internal
    */ path, /**
    The offset this position has into its parent node.
    */ parentOffset){
        this.pos = pos;
        this.path = path;
        this.parentOffset = parentOffset;
        this.depth = path.length / 3 - 1;
    }
    /**
    @internal
    */ resolveDepth(val) {
        if (val == null) return this.depth;
        if (val < 0) return this.depth + val;
        return val;
    }
    /**
    The parent node that the position points into. Note that even if
    a position points into a text node, that node is not considered
    the parent—text nodes are ‘flat’ in this model, and have no content.
    */ get parent() {
        return this.node(this.depth);
    }
    /**
    The root node in which the position was resolved.
    */ get doc() {
        return this.node(0);
    }
    /**
    The ancestor node at the given level. `p.node(p.depth)` is the
    same as `p.parent`.
    */ node(depth) {
        return this.path[this.resolveDepth(depth) * 3];
    }
    /**
    The index into the ancestor at the given level. If this points
    at the 3rd node in the 2nd paragraph on the top level, for
    example, `p.index(0)` is 1 and `p.index(1)` is 2.
    */ index(depth) {
        return this.path[this.resolveDepth(depth) * 3 + 1];
    }
    /**
    The index pointing after this position into the ancestor at the
    given level.
    */ indexAfter(depth) {
        depth = this.resolveDepth(depth);
        return this.index(depth) + (depth == this.depth && !this.textOffset ? 0 : 1);
    }
    /**
    The (absolute) position at the start of the node at the given
    level.
    */ start(depth) {
        depth = this.resolveDepth(depth);
        return depth == 0 ? 0 : this.path[depth * 3 - 1] + 1;
    }
    /**
    The (absolute) position at the end of the node at the given
    level.
    */ end(depth) {
        depth = this.resolveDepth(depth);
        return this.start(depth) + this.node(depth).content.size;
    }
    /**
    The (absolute) position directly before the wrapping node at the
    given level, or, when `depth` is `this.depth + 1`, the original
    position.
    */ before(depth) {
        depth = this.resolveDepth(depth);
        if (!depth) throw new RangeError("There is no position before the top-level node");
        return depth == this.depth + 1 ? this.pos : this.path[depth * 3 - 1];
    }
    /**
    The (absolute) position directly after the wrapping node at the
    given level, or the original position when `depth` is `this.depth + 1`.
    */ after(depth) {
        depth = this.resolveDepth(depth);
        if (!depth) throw new RangeError("There is no position after the top-level node");
        return depth == this.depth + 1 ? this.pos : this.path[depth * 3 - 1] + this.path[depth * 3].nodeSize;
    }
    /**
    When this position points into a text node, this returns the
    distance between the position and the start of the text node.
    Will be zero for positions that point between nodes.
    */ get textOffset() {
        return this.pos - this.path[this.path.length - 1];
    }
    /**
    Get the node directly after the position, if any. If the position
    points into a text node, only the part of that node after the
    position is returned.
    */ get nodeAfter() {
        let parent = this.parent, index = this.index(this.depth);
        if (index == parent.childCount) return null;
        let dOff = this.pos - this.path[this.path.length - 1], child = parent.child(index);
        return dOff ? parent.child(index).cut(dOff) : child;
    }
    /**
    Get the node directly before the position, if any. If the
    position points into a text node, only the part of that node
    before the position is returned.
    */ get nodeBefore() {
        let index = this.index(this.depth);
        let dOff = this.pos - this.path[this.path.length - 1];
        if (dOff) return this.parent.child(index).cut(0, dOff);
        return index == 0 ? null : this.parent.child(index - 1);
    }
    /**
    Get the position at the given index in the parent node at the
    given depth (which defaults to `this.depth`).
    */ posAtIndex(index, depth) {
        depth = this.resolveDepth(depth);
        let node = this.path[depth * 3], pos = depth == 0 ? 0 : this.path[depth * 3 - 1] + 1;
        for(let i = 0; i < index; i++)pos += node.child(i).nodeSize;
        return pos;
    }
    /**
    Get the marks at this position, factoring in the surrounding
    marks' [`inclusive`](https://prosemirror.net/docs/ref/#model.MarkSpec.inclusive) property. If the
    position is at the start of a non-empty node, the marks of the
    node after it (if any) are returned.
    */ marks() {
        let parent = this.parent, index = this.index();
        // In an empty parent, return the empty array
        if (parent.content.size == 0) return $b42367e7348c0623$export$c9d15bcfc6d42044.none;
        // When inside a text node, just return the text node's marks
        if (this.textOffset) return parent.child(index).marks;
        let main = parent.maybeChild(index - 1), other = parent.maybeChild(index);
        // If the `after` flag is true of there is no node before, make
        // the node after this position the main reference.
        if (!main) {
            let tmp = main;
            main = other;
            other = tmp;
        }
        // Use all marks in the main node, except those that have
        // `inclusive` set to false and are not present in the other node.
        let marks = main.marks;
        for(var i = 0; i < marks.length; i++)if (marks[i].type.spec.inclusive === false && (!other || !marks[i].isInSet(other.marks))) marks = marks[i--].removeFromSet(marks);
        return marks;
    }
    /**
    Get the marks after the current position, if any, except those
    that are non-inclusive and not present at position `$end`. This
    is mostly useful for getting the set of marks to preserve after a
    deletion. Will return `null` if this position is at the end of
    its parent node or its parent node isn't a textblock (in which
    case no marks should be preserved).
    */ marksAcross($end) {
        let after = this.parent.maybeChild(this.index());
        if (!after || !after.isInline) return null;
        let marks = after.marks, next = $end.parent.maybeChild($end.index());
        for(var i = 0; i < marks.length; i++)if (marks[i].type.spec.inclusive === false && (!next || !marks[i].isInSet(next.marks))) marks = marks[i--].removeFromSet(marks);
        return marks;
    }
    /**
    The depth up to which this position and the given (non-resolved)
    position share the same parent nodes.
    */ sharedDepth(pos) {
        for(let depth = this.depth; depth > 0; depth--)if (this.start(depth) <= pos && this.end(depth) >= pos) return depth;
        return 0;
    }
    /**
    Returns a range based on the place where this position and the
    given position diverge around block content. If both point into
    the same textblock, for example, a range around that textblock
    will be returned. If they point into different blocks, the range
    around those blocks in their shared ancestor is returned. You can
    pass in an optional predicate that will be called with a parent
    node to see if a range into that parent is acceptable.
    */ blockRange(other = this, pred) {
        if (other.pos < this.pos) return other.blockRange(this);
        for(let d = this.depth - (this.parent.inlineContent || this.pos == other.pos ? 1 : 0); d >= 0; d--)if (other.pos <= this.end(d) && (!pred || pred(this.node(d)))) return new $b42367e7348c0623$export$7bc461ceb770fb16(this, other, d);
        return null;
    }
    /**
    Query whether the given position shares the same parent node.
    */ sameParent(other) {
        return this.pos - this.parentOffset == other.pos - other.parentOffset;
    }
    /**
    Return the greater of this and the given position.
    */ max(other) {
        return other.pos > this.pos ? other : this;
    }
    /**
    Return the smaller of this and the given position.
    */ min(other) {
        return other.pos < this.pos ? other : this;
    }
    /**
    @internal
    */ toString() {
        let str = "";
        for(let i = 1; i <= this.depth; i++)str += (str ? "/" : "") + this.node(i).type.name + "_" + this.index(i - 1);
        return str + ":" + this.parentOffset;
    }
    /**
    @internal
    */ static resolve(doc, pos) {
        if (!(pos >= 0 && pos <= doc.content.size)) throw new RangeError("Position " + pos + " out of range");
        let path = [];
        let start = 0, parentOffset = pos;
        for(let node = doc;;){
            let { index: index, offset: offset } = node.content.findIndex(parentOffset);
            let rem = parentOffset - offset;
            path.push(node, index, start + offset);
            if (!rem) break;
            node = node.child(index);
            if (node.isText) break;
            parentOffset = rem - 1;
            start += offset + 1;
        }
        return new $b42367e7348c0623$export$b2a42f82e59e4b19(pos, path, parentOffset);
    }
    /**
    @internal
    */ static resolveCached(doc, pos) {
        let cache = $b42367e7348c0623$var$resolveCache.get(doc);
        if (cache) for(let i = 0; i < cache.elts.length; i++){
            let elt = cache.elts[i];
            if (elt.pos == pos) return elt;
        }
        else $b42367e7348c0623$var$resolveCache.set(doc, cache = new $b42367e7348c0623$var$ResolveCache);
        let result = cache.elts[cache.i] = $b42367e7348c0623$export$b2a42f82e59e4b19.resolve(doc, pos);
        cache.i = (cache.i + 1) % $b42367e7348c0623$var$resolveCacheSize;
        return result;
    }
}
class $b42367e7348c0623$var$ResolveCache {
    constructor(){
        this.elts = [];
        this.i = 0;
    }
}
const $b42367e7348c0623$var$resolveCacheSize = 12, $b42367e7348c0623$var$resolveCache = new WeakMap();
/**
Represents a flat range of content, i.e. one that starts and
ends in the same node.
*/ class $b42367e7348c0623$export$7bc461ceb770fb16 {
    /**
    Construct a node range. `$from` and `$to` should point into the
    same node until at least the given `depth`, since a node range
    denotes an adjacent set of nodes in a single parent node.
    */ constructor(/**
    A resolved position along the start of the content. May have a
    `depth` greater than this object's `depth` property, since
    these are the positions that were used to compute the range,
    not re-resolved positions directly at its boundaries.
    */ $from, /**
    A position along the end of the content. See
    caveat for [`$from`](https://prosemirror.net/docs/ref/#model.NodeRange.$from).
    */ $to, /**
    The depth of the node that this range points into.
    */ depth){
        this.$from = $from;
        this.$to = $to;
        this.depth = depth;
    }
    /**
    The position at the start of the range.
    */ get start() {
        return this.$from.before(this.depth + 1);
    }
    /**
    The position at the end of the range.
    */ get end() {
        return this.$to.after(this.depth + 1);
    }
    /**
    The parent node that the range points into.
    */ get parent() {
        return this.$from.node(this.depth);
    }
    /**
    The start index of the range in the parent node.
    */ get startIndex() {
        return this.$from.index(this.depth);
    }
    /**
    The end index of the range in the parent node.
    */ get endIndex() {
        return this.$to.indexAfter(this.depth);
    }
}
const $b42367e7348c0623$var$emptyAttrs = Object.create(null);
/**
This class represents a node in the tree that makes up a
ProseMirror document. So a document is an instance of `Node`, with
children that are also instances of `Node`.

Nodes are persistent data structures. Instead of changing them, you
create new ones with the content you want. Old ones keep pointing
at the old document shape. This is made cheaper by sharing
structure between the old and new data as much as possible, which a
tree shape like this (without back pointers) makes easy.

**Do not** directly mutate the properties of a `Node` object. See
[the guide](https://prosemirror.net/docs/guide/#doc) for more information.
*/ class $b42367e7348c0623$export$85c928794f8d04d4 {
    /**
    @internal
    */ constructor(/**
    The type of node that this is.
    */ type, /**
    An object mapping attribute names to values. The kind of
    attributes allowed and required are
    [determined](https://prosemirror.net/docs/ref/#model.NodeSpec.attrs) by the node type.
    */ attrs, // A fragment holding the node's children.
    content, /**
    The marks (things like whether it is emphasized or part of a
    link) applied to this node.
    */ marks = $b42367e7348c0623$export$c9d15bcfc6d42044.none){
        this.type = type;
        this.attrs = attrs;
        this.marks = marks;
        this.content = content || $b42367e7348c0623$export$ffb0004e005737fa.empty;
    }
    /**
    The array of this node's child nodes.
    */ get children() {
        return this.content.content;
    }
    /**
    The size of this node, as defined by the integer-based [indexing
    scheme](https://prosemirror.net/docs/guide/#doc.indexing). For text nodes, this is the
    amount of characters. For other leaf nodes, it is one. For
    non-leaf nodes, it is the size of the content plus two (the
    start and end token).
    */ get nodeSize() {
        return this.isLeaf ? 1 : 2 + this.content.size;
    }
    /**
    The number of children that the node has.
    */ get childCount() {
        return this.content.childCount;
    }
    /**
    Get the child node at the given index. Raises an error when the
    index is out of range.
    */ child(index) {
        return this.content.child(index);
    }
    /**
    Get the child node at the given index, if it exists.
    */ maybeChild(index) {
        return this.content.maybeChild(index);
    }
    /**
    Call `f` for every child node, passing the node, its offset
    into this parent node, and its index.
    */ forEach(f) {
        this.content.forEach(f);
    }
    /**
    Invoke a callback for all descendant nodes recursively between
    the given two positions that are relative to start of this
    node's content. The callback is invoked with the node, its
    position relative to the original node (method receiver),
    its parent node, and its child index. When the callback returns
    false for a given node, that node's children will not be
    recursed over. The last parameter can be used to specify a
    starting position to count from.
    */ nodesBetween(from, to, f, startPos = 0) {
        this.content.nodesBetween(from, to, f, startPos, this);
    }
    /**
    Call the given callback for every descendant node. Doesn't
    descend into a node when the callback returns `false`.
    */ descendants(f) {
        this.nodesBetween(0, this.content.size, f);
    }
    /**
    Concatenates all the text nodes found in this fragment and its
    children.
    */ get textContent() {
        return this.isLeaf && this.type.spec.leafText ? this.type.spec.leafText(this) : this.textBetween(0, this.content.size, "");
    }
    /**
    Get all text between positions `from` and `to`. When
    `blockSeparator` is given, it will be inserted to separate text
    from different block nodes. If `leafText` is given, it'll be
    inserted for every non-text leaf node encountered, otherwise
    [`leafText`](https://prosemirror.net/docs/ref/#model.NodeSpec.leafText) will be used.
    */ textBetween(from, to, blockSeparator, leafText) {
        return this.content.textBetween(from, to, blockSeparator, leafText);
    }
    /**
    Returns this node's first child, or `null` if there are no
    children.
    */ get firstChild() {
        return this.content.firstChild;
    }
    /**
    Returns this node's last child, or `null` if there are no
    children.
    */ get lastChild() {
        return this.content.lastChild;
    }
    /**
    Test whether two nodes represent the same piece of document.
    */ eq(other) {
        return this == other || this.sameMarkup(other) && this.content.eq(other.content);
    }
    /**
    Compare the markup (type, attributes, and marks) of this node to
    those of another. Returns `true` if both have the same markup.
    */ sameMarkup(other) {
        return this.hasMarkup(other.type, other.attrs, other.marks);
    }
    /**
    Check whether this node's markup correspond to the given type,
    attributes, and marks.
    */ hasMarkup(type, attrs, marks) {
        return this.type == type && $b42367e7348c0623$var$compareDeep(this.attrs, attrs || type.defaultAttrs || $b42367e7348c0623$var$emptyAttrs) && $b42367e7348c0623$export$c9d15bcfc6d42044.sameSet(this.marks, marks || $b42367e7348c0623$export$c9d15bcfc6d42044.none);
    }
    /**
    Create a new node with the same markup as this node, containing
    the given content (or empty, if no content is given).
    */ copy(content = null) {
        if (content == this.content) return this;
        return new $b42367e7348c0623$export$85c928794f8d04d4(this.type, this.attrs, content, this.marks);
    }
    /**
    Create a copy of this node, with the given set of marks instead
    of the node's own marks.
    */ mark(marks) {
        return marks == this.marks ? this : new $b42367e7348c0623$export$85c928794f8d04d4(this.type, this.attrs, this.content, marks);
    }
    /**
    Create a copy of this node with only the content between the
    given positions. If `to` is not given, it defaults to the end of
    the node.
    */ cut(from, to = this.content.size) {
        if (from == 0 && to == this.content.size) return this;
        return this.copy(this.content.cut(from, to));
    }
    /**
    Cut out the part of the document between the given positions, and
    return it as a `Slice` object.
    */ slice(from, to = this.content.size, includeParents = false) {
        if (from == to) return $b42367e7348c0623$export$b3f2e2de3a8baa1e.empty;
        let $from = this.resolve(from), $to = this.resolve(to);
        let depth = includeParents ? 0 : $from.sharedDepth(to);
        let start = $from.start(depth), node = $from.node(depth);
        let content = node.content.cut($from.pos - start, $to.pos - start);
        return new $b42367e7348c0623$export$b3f2e2de3a8baa1e(content, $from.depth - depth, $to.depth - depth);
    }
    /**
    Replace the part of the document between the given positions with
    the given slice. The slice must 'fit', meaning its open sides
    must be able to connect to the surrounding content, and its
    content nodes must be valid children for the node they are placed
    into. If any of this is violated, an error of type
    [`ReplaceError`](https://prosemirror.net/docs/ref/#model.ReplaceError) is thrown.
    */ replace(from, to, slice) {
        return $b42367e7348c0623$var$replace(this.resolve(from), this.resolve(to), slice);
    }
    /**
    Find the node directly after the given position.
    */ nodeAt(pos) {
        for(let node = this;;){
            let { index: index, offset: offset } = node.content.findIndex(pos);
            node = node.maybeChild(index);
            if (!node) return null;
            if (offset == pos || node.isText) return node;
            pos -= offset + 1;
        }
    }
    /**
    Find the (direct) child node after the given offset, if any,
    and return it along with its index and offset relative to this
    node.
    */ childAfter(pos) {
        let { index: index, offset: offset } = this.content.findIndex(pos);
        return {
            node: this.content.maybeChild(index),
            index: index,
            offset: offset
        };
    }
    /**
    Find the (direct) child node before the given offset, if any,
    and return it along with its index and offset relative to this
    node.
    */ childBefore(pos) {
        if (pos == 0) return {
            node: null,
            index: 0,
            offset: 0
        };
        let { index: index, offset: offset } = this.content.findIndex(pos);
        if (offset < pos) return {
            node: this.content.child(index),
            index: index,
            offset: offset
        };
        let node = this.content.child(index - 1);
        return {
            node: node,
            index: index - 1,
            offset: offset - node.nodeSize
        };
    }
    /**
    Resolve the given position in the document, returning an
    [object](https://prosemirror.net/docs/ref/#model.ResolvedPos) with information about its context.
    */ resolve(pos) {
        return $b42367e7348c0623$export$b2a42f82e59e4b19.resolveCached(this, pos);
    }
    /**
    @internal
    */ resolveNoCache(pos) {
        return $b42367e7348c0623$export$b2a42f82e59e4b19.resolve(this, pos);
    }
    /**
    Test whether a given mark or mark type occurs in this document
    between the two given positions.
    */ rangeHasMark(from, to, type) {
        let found = false;
        if (to > from) this.nodesBetween(from, to, (node)=>{
            if (type.isInSet(node.marks)) found = true;
            return !found;
        });
        return found;
    }
    /**
    True when this is a block (non-inline node)
    */ get isBlock() {
        return this.type.isBlock;
    }
    /**
    True when this is a textblock node, a block node with inline
    content.
    */ get isTextblock() {
        return this.type.isTextblock;
    }
    /**
    True when this node allows inline content.
    */ get inlineContent() {
        return this.type.inlineContent;
    }
    /**
    True when this is an inline node (a text node or a node that can
    appear among text).
    */ get isInline() {
        return this.type.isInline;
    }
    /**
    True when this is a text node.
    */ get isText() {
        return this.type.isText;
    }
    /**
    True when this is a leaf node.
    */ get isLeaf() {
        return this.type.isLeaf;
    }
    /**
    True when this is an atom, i.e. when it does not have directly
    editable content. This is usually the same as `isLeaf`, but can
    be configured with the [`atom` property](https://prosemirror.net/docs/ref/#model.NodeSpec.atom)
    on a node's spec (typically used when the node is displayed as
    an uneditable [node view](https://prosemirror.net/docs/ref/#view.NodeView)).
    */ get isAtom() {
        return this.type.isAtom;
    }
    /**
    Return a string representation of this node for debugging
    purposes.
    */ toString() {
        if (this.type.spec.toDebugString) return this.type.spec.toDebugString(this);
        let name = this.type.name;
        if (this.content.size) name += "(" + this.content.toStringInner() + ")";
        return $b42367e7348c0623$var$wrapMarks(this.marks, name);
    }
    /**
    Get the content match in this node at the given index.
    */ contentMatchAt(index) {
        let match = this.type.contentMatch.matchFragment(this.content, 0, index);
        if (!match) throw new Error("Called contentMatchAt on a node with invalid content");
        return match;
    }
    /**
    Test whether replacing the range between `from` and `to` (by
    child index) with the given replacement fragment (which defaults
    to the empty fragment) would leave the node's content valid. You
    can optionally pass `start` and `end` indices into the
    replacement fragment.
    */ canReplace(from, to, replacement = $b42367e7348c0623$export$ffb0004e005737fa.empty, start = 0, end = replacement.childCount) {
        let one = this.contentMatchAt(from).matchFragment(replacement, start, end);
        let two = one && one.matchFragment(this.content, to);
        if (!two || !two.validEnd) return false;
        for(let i = start; i < end; i++)if (!this.type.allowsMarks(replacement.child(i).marks)) return false;
        return true;
    }
    /**
    Test whether replacing the range `from` to `to` (by index) with
    a node of the given type would leave the node's content valid.
    */ canReplaceWith(from, to, type, marks) {
        if (marks && !this.type.allowsMarks(marks)) return false;
        let start = this.contentMatchAt(from).matchType(type);
        let end = start && start.matchFragment(this.content, to);
        return end ? end.validEnd : false;
    }
    /**
    Test whether the given node's content could be appended to this
    node. If that node is empty, this will only return true if there
    is at least one node type that can appear in both nodes (to avoid
    merging completely incompatible nodes).
    */ canAppend(other) {
        if (other.content.size) return this.canReplace(this.childCount, this.childCount, other.content);
        else return this.type.compatibleContent(other.type);
    }
    /**
    Check whether this node and its descendants conform to the
    schema, and raise an exception when they do not.
    */ check() {
        this.type.checkContent(this.content);
        this.type.checkAttrs(this.attrs);
        let copy = $b42367e7348c0623$export$c9d15bcfc6d42044.none;
        for(let i = 0; i < this.marks.length; i++){
            let mark = this.marks[i];
            mark.type.checkAttrs(mark.attrs);
            copy = mark.addToSet(copy);
        }
        if (!$b42367e7348c0623$export$c9d15bcfc6d42044.sameSet(copy, this.marks)) throw new RangeError(`Invalid collection of marks for node ${this.type.name}: ${this.marks.map((m)=>m.type.name)}`);
        this.content.forEach((node)=>node.check());
    }
    /**
    Return a JSON-serializeable representation of this node.
    */ toJSON() {
        let obj = {
            type: this.type.name
        };
        for(let _ in this.attrs){
            obj.attrs = this.attrs;
            break;
        }
        if (this.content.size) obj.content = this.content.toJSON();
        if (this.marks.length) obj.marks = this.marks.map((n)=>n.toJSON());
        return obj;
    }
    /**
    Deserialize a node from its JSON representation.
    */ static fromJSON(schema, json) {
        if (!json) throw new RangeError("Invalid input for Node.fromJSON");
        let marks = undefined;
        if (json.marks) {
            if (!Array.isArray(json.marks)) throw new RangeError("Invalid mark data for Node.fromJSON");
            marks = json.marks.map(schema.markFromJSON);
        }
        if (json.type == "text") {
            if (typeof json.text != "string") throw new RangeError("Invalid text node in JSON");
            return schema.text(json.text, marks);
        }
        let content = $b42367e7348c0623$export$ffb0004e005737fa.fromJSON(schema, json.content);
        let node = schema.nodeType(json.type).create(json.attrs, content, marks);
        node.type.checkAttrs(node.attrs);
        return node;
    }
}
$b42367e7348c0623$export$85c928794f8d04d4.prototype.text = undefined;
class $b42367e7348c0623$var$TextNode extends $b42367e7348c0623$export$85c928794f8d04d4 {
    /**
    @internal
    */ constructor(type, attrs, content, marks){
        super(type, attrs, null, marks);
        if (!content) throw new RangeError("Empty text nodes are not allowed");
        this.text = content;
    }
    toString() {
        if (this.type.spec.toDebugString) return this.type.spec.toDebugString(this);
        return $b42367e7348c0623$var$wrapMarks(this.marks, JSON.stringify(this.text));
    }
    get textContent() {
        return this.text;
    }
    textBetween(from, to) {
        return this.text.slice(from, to);
    }
    get nodeSize() {
        return this.text.length;
    }
    mark(marks) {
        return marks == this.marks ? this : new $b42367e7348c0623$var$TextNode(this.type, this.attrs, this.text, marks);
    }
    withText(text) {
        if (text == this.text) return this;
        return new $b42367e7348c0623$var$TextNode(this.type, this.attrs, text, this.marks);
    }
    cut(from = 0, to = this.text.length) {
        if (from == 0 && to == this.text.length) return this;
        return this.withText(this.text.slice(from, to));
    }
    eq(other) {
        return this.sameMarkup(other) && this.text == other.text;
    }
    toJSON() {
        let base = super.toJSON();
        base.text = this.text;
        return base;
    }
}
function $b42367e7348c0623$var$wrapMarks(marks, str) {
    for(let i = marks.length - 1; i >= 0; i--)str = marks[i].type.name + "(" + str + ")";
    return str;
}
/**
Instances of this class represent a match state of a node type's
[content expression](https://prosemirror.net/docs/ref/#model.NodeSpec.content), and can be used to
find out whether further content matches here, and whether a given
position is a valid end of the node.
*/ class $b42367e7348c0623$export$364ed450558d7ec4 {
    /**
    @internal
    */ constructor(/**
    True when this match state represents a valid end of the node.
    */ validEnd){
        this.validEnd = validEnd;
        /**
        @internal
        */ this.next = [];
        /**
        @internal
        */ this.wrapCache = [];
    }
    /**
    @internal
    */ static parse(string, nodeTypes) {
        let stream = new $b42367e7348c0623$var$TokenStream(string, nodeTypes);
        if (stream.next == null) return $b42367e7348c0623$export$364ed450558d7ec4.empty;
        let expr = $b42367e7348c0623$var$parseExpr(stream);
        if (stream.next) stream.err("Unexpected trailing text");
        let match = $b42367e7348c0623$var$dfa($b42367e7348c0623$var$nfa(expr));
        $b42367e7348c0623$var$checkForDeadEnds(match, stream);
        return match;
    }
    /**
    Match a node type, returning a match after that node if
    successful.
    */ matchType(type) {
        for(let i = 0; i < this.next.length; i++)if (this.next[i].type == type) return this.next[i].next;
        return null;
    }
    /**
    Try to match a fragment. Returns the resulting match when
    successful.
    */ matchFragment(frag, start = 0, end = frag.childCount) {
        let cur = this;
        for(let i = start; cur && i < end; i++)cur = cur.matchType(frag.child(i).type);
        return cur;
    }
    /**
    @internal
    */ get inlineContent() {
        return this.next.length != 0 && this.next[0].type.isInline;
    }
    /**
    Get the first matching node type at this match position that can
    be generated.
    */ get defaultType() {
        for(let i = 0; i < this.next.length; i++){
            let { type: type } = this.next[i];
            if (!(type.isText || type.hasRequiredAttrs())) return type;
        }
        return null;
    }
    /**
    @internal
    */ compatible(other) {
        for(let i = 0; i < this.next.length; i++)for(let j = 0; j < other.next.length; j++)if (this.next[i].type == other.next[j].type) return true;
        return false;
    }
    /**
    Try to match the given fragment, and if that fails, see if it can
    be made to match by inserting nodes in front of it. When
    successful, return a fragment of inserted nodes (which may be
    empty if nothing had to be inserted). When `toEnd` is true, only
    return a fragment if the resulting match goes to the end of the
    content expression.
    */ fillBefore(after, toEnd = false, startIndex = 0) {
        let seen = [
            this
        ];
        function search(match, types) {
            let finished = match.matchFragment(after, startIndex);
            if (finished && (!toEnd || finished.validEnd)) return $b42367e7348c0623$export$ffb0004e005737fa.from(types.map((tp)=>tp.createAndFill()));
            for(let i = 0; i < match.next.length; i++){
                let { type: type, next: next } = match.next[i];
                if (!(type.isText || type.hasRequiredAttrs()) && seen.indexOf(next) == -1) {
                    seen.push(next);
                    let found = search(next, types.concat(type));
                    if (found) return found;
                }
            }
            return null;
        }
        return search(this, []);
    }
    /**
    Find a set of wrapping node types that would allow a node of the
    given type to appear at this position. The result may be empty
    (when it fits directly) and will be null when no such wrapping
    exists.
    */ findWrapping(target) {
        for(let i = 0; i < this.wrapCache.length; i += 2)if (this.wrapCache[i] == target) return this.wrapCache[i + 1];
        let computed = this.computeWrapping(target);
        this.wrapCache.push(target, computed);
        return computed;
    }
    /**
    @internal
    */ computeWrapping(target) {
        let seen = Object.create(null), active = [
            {
                match: this,
                type: null,
                via: null
            }
        ];
        while(active.length){
            let current = active.shift(), match = current.match;
            if (match.matchType(target)) {
                let result = [];
                for(let obj = current; obj.type; obj = obj.via)result.push(obj.type);
                return result.reverse();
            }
            for(let i = 0; i < match.next.length; i++){
                let { type: type, next: next } = match.next[i];
                if (!type.isLeaf && !type.hasRequiredAttrs() && !(type.name in seen) && (!current.type || next.validEnd)) {
                    active.push({
                        match: type.contentMatch,
                        type: type,
                        via: current
                    });
                    seen[type.name] = true;
                }
            }
        }
        return null;
    }
    /**
    The number of outgoing edges this node has in the finite
    automaton that describes the content expression.
    */ get edgeCount() {
        return this.next.length;
    }
    /**
    Get the _n_​th outgoing edge from this node in the finite
    automaton that describes the content expression.
    */ edge(n) {
        if (n >= this.next.length) throw new RangeError(`There's no ${n}th edge in this content match`);
        return this.next[n];
    }
    /**
    @internal
    */ toString() {
        let seen = [];
        function scan(m) {
            seen.push(m);
            for(let i = 0; i < m.next.length; i++)if (seen.indexOf(m.next[i].next) == -1) scan(m.next[i].next);
        }
        scan(this);
        return seen.map((m, i)=>{
            let out = i + (m.validEnd ? "*" : " ") + " ";
            for(let i = 0; i < m.next.length; i++)out += (i ? ", " : "") + m.next[i].type.name + "->" + seen.indexOf(m.next[i].next);
            return out;
        }).join("\n");
    }
}
/**
@internal
*/ $b42367e7348c0623$export$364ed450558d7ec4.empty = new $b42367e7348c0623$export$364ed450558d7ec4(true);
class $b42367e7348c0623$var$TokenStream {
    constructor(string, nodeTypes){
        this.string = string;
        this.nodeTypes = nodeTypes;
        this.inline = null;
        this.pos = 0;
        this.tokens = string.split(/\s*(?=\b|\W|$)/);
        if (this.tokens[this.tokens.length - 1] == "") this.tokens.pop();
        if (this.tokens[0] == "") this.tokens.shift();
    }
    get next() {
        return this.tokens[this.pos];
    }
    eat(tok) {
        return this.next == tok && (this.pos++ || true);
    }
    err(str) {
        throw new SyntaxError(str + " (in content expression '" + this.string + "')");
    }
}
function $b42367e7348c0623$var$parseExpr(stream) {
    let exprs = [];
    do exprs.push($b42367e7348c0623$var$parseExprSeq(stream));
    while (stream.eat("|"));
    return exprs.length == 1 ? exprs[0] : {
        type: "choice",
        exprs: exprs
    };
}
function $b42367e7348c0623$var$parseExprSeq(stream) {
    let exprs = [];
    do exprs.push($b42367e7348c0623$var$parseExprSubscript(stream));
    while (stream.next && stream.next != ")" && stream.next != "|");
    return exprs.length == 1 ? exprs[0] : {
        type: "seq",
        exprs: exprs
    };
}
function $b42367e7348c0623$var$parseExprSubscript(stream) {
    let expr = $b42367e7348c0623$var$parseExprAtom(stream);
    for(;;){
        if (stream.eat("+")) expr = {
            type: "plus",
            expr: expr
        };
        else if (stream.eat("*")) expr = {
            type: "star",
            expr: expr
        };
        else if (stream.eat("?")) expr = {
            type: "opt",
            expr: expr
        };
        else if (stream.eat("{")) expr = $b42367e7348c0623$var$parseExprRange(stream, expr);
        else break;
    }
    return expr;
}
function $b42367e7348c0623$var$parseNum(stream) {
    if (/\D/.test(stream.next)) stream.err("Expected number, got '" + stream.next + "'");
    let result = Number(stream.next);
    stream.pos++;
    return result;
}
function $b42367e7348c0623$var$parseExprRange(stream, expr) {
    let min = $b42367e7348c0623$var$parseNum(stream), max = min;
    if (stream.eat(",")) {
        if (stream.next != "}") max = $b42367e7348c0623$var$parseNum(stream);
        else max = -1;
    }
    if (!stream.eat("}")) stream.err("Unclosed braced range");
    return {
        type: "range",
        min: min,
        max: max,
        expr: expr
    };
}
function $b42367e7348c0623$var$resolveName(stream, name) {
    let types = stream.nodeTypes, type = types[name];
    if (type) return [
        type
    ];
    let result = [];
    for(let typeName in types){
        let type = types[typeName];
        if (type.isInGroup(name)) result.push(type);
    }
    if (result.length == 0) stream.err("No node type or group '" + name + "' found");
    return result;
}
function $b42367e7348c0623$var$parseExprAtom(stream) {
    if (stream.eat("(")) {
        let expr = $b42367e7348c0623$var$parseExpr(stream);
        if (!stream.eat(")")) stream.err("Missing closing paren");
        return expr;
    } else if (!/\W/.test(stream.next)) {
        let exprs = $b42367e7348c0623$var$resolveName(stream, stream.next).map((type)=>{
            if (stream.inline == null) stream.inline = type.isInline;
            else if (stream.inline != type.isInline) stream.err("Mixing inline and block content");
            return {
                type: "name",
                value: type
            };
        });
        stream.pos++;
        return exprs.length == 1 ? exprs[0] : {
            type: "choice",
            exprs: exprs
        };
    } else stream.err("Unexpected token '" + stream.next + "'");
}
// Construct an NFA from an expression as returned by the parser. The
// NFA is represented as an array of states, which are themselves
// arrays of edges, which are `{term, to}` objects. The first state is
// the entry state and the last node is the success state.
//
// Note that unlike typical NFAs, the edge ordering in this one is
// significant, in that it is used to contruct filler content when
// necessary.
function $b42367e7348c0623$var$nfa(expr) {
    let nfa = [
        []
    ];
    connect(compile(expr, 0), node());
    return nfa;
    function node() {
        return nfa.push([]) - 1;
    }
    function edge(from, to, term) {
        let edge = {
            term: term,
            to: to
        };
        nfa[from].push(edge);
        return edge;
    }
    function connect(edges, to) {
        edges.forEach((edge)=>edge.to = to);
    }
    function compile(expr, from) {
        if (expr.type == "choice") return expr.exprs.reduce((out, expr)=>out.concat(compile(expr, from)), []);
        else if (expr.type == "seq") for(let i = 0;; i++){
            let next = compile(expr.exprs[i], from);
            if (i == expr.exprs.length - 1) return next;
            connect(next, from = node());
        }
        else if (expr.type == "star") {
            let loop = node();
            edge(from, loop);
            connect(compile(expr.expr, loop), loop);
            return [
                edge(loop)
            ];
        } else if (expr.type == "plus") {
            let loop = node();
            connect(compile(expr.expr, from), loop);
            connect(compile(expr.expr, loop), loop);
            return [
                edge(loop)
            ];
        } else if (expr.type == "opt") return [
            edge(from)
        ].concat(compile(expr.expr, from));
        else if (expr.type == "range") {
            let cur = from;
            for(let i = 0; i < expr.min; i++){
                let next = node();
                connect(compile(expr.expr, cur), next);
                cur = next;
            }
            if (expr.max == -1) connect(compile(expr.expr, cur), cur);
            else for(let i = expr.min; i < expr.max; i++){
                let next = node();
                edge(cur, next);
                connect(compile(expr.expr, cur), next);
                cur = next;
            }
            return [
                edge(cur)
            ];
        } else if (expr.type == "name") return [
            edge(from, undefined, expr.value)
        ];
        else throw new Error("Unknown expr type");
    }
}
function $b42367e7348c0623$var$cmp(a, b) {
    return b - a;
}
// Get the set of nodes reachable by null edges from `node`. Omit
// nodes with only a single null-out-edge, since they may lead to
// needless duplicated nodes.
function $b42367e7348c0623$var$nullFrom(nfa, node) {
    let result = [];
    scan(node);
    return result.sort($b42367e7348c0623$var$cmp);
    function scan(node) {
        let edges = nfa[node];
        if (edges.length == 1 && !edges[0].term) return scan(edges[0].to);
        result.push(node);
        for(let i = 0; i < edges.length; i++){
            let { term: term, to: to } = edges[i];
            if (!term && result.indexOf(to) == -1) scan(to);
        }
    }
}
// Compiles an NFA as produced by `nfa` into a DFA, modeled as a set
// of state objects (`ContentMatch` instances) with transitions
// between them.
function $b42367e7348c0623$var$dfa(nfa) {
    let labeled = Object.create(null);
    return explore($b42367e7348c0623$var$nullFrom(nfa, 0));
    function explore(states) {
        let out = [];
        states.forEach((node)=>{
            nfa[node].forEach(({ term: term, to: to })=>{
                if (!term) return;
                let set;
                for(let i = 0; i < out.length; i++)if (out[i][0] == term) set = out[i][1];
                $b42367e7348c0623$var$nullFrom(nfa, to).forEach((node)=>{
                    if (!set) out.push([
                        term,
                        set = []
                    ]);
                    if (set.indexOf(node) == -1) set.push(node);
                });
            });
        });
        let state = labeled[states.join(",")] = new $b42367e7348c0623$export$364ed450558d7ec4(states.indexOf(nfa.length - 1) > -1);
        for(let i = 0; i < out.length; i++){
            let states = out[i][1].sort($b42367e7348c0623$var$cmp);
            state.next.push({
                type: out[i][0],
                next: labeled[states.join(",")] || explore(states)
            });
        }
        return state;
    }
}
function $b42367e7348c0623$var$checkForDeadEnds(match, stream) {
    for(let i = 0, work = [
        match
    ]; i < work.length; i++){
        let state = work[i], dead = !state.validEnd, nodes = [];
        for(let j = 0; j < state.next.length; j++){
            let { type: type, next: next } = state.next[j];
            nodes.push(type.name);
            if (dead && !(type.isText || type.hasRequiredAttrs())) dead = false;
            if (work.indexOf(next) == -1) work.push(next);
        }
        if (dead) stream.err("Only non-generatable nodes (" + nodes.join(", ") + ") in a required position (see https://prosemirror.net/docs/guide/#generatable)");
    }
}
// For node types where all attrs have a default value (or which don't
// have any attributes), build up a single reusable default attribute
// object, and use it for all nodes that don't specify specific
// attributes.
function $b42367e7348c0623$var$defaultAttrs(attrs) {
    let defaults = Object.create(null);
    for(let attrName in attrs){
        let attr = attrs[attrName];
        if (!attr.hasDefault) return null;
        defaults[attrName] = attr.default;
    }
    return defaults;
}
function $b42367e7348c0623$var$computeAttrs(attrs, value) {
    let built = Object.create(null);
    for(let name in attrs){
        let given = value && value[name];
        if (given === undefined) {
            let attr = attrs[name];
            if (attr.hasDefault) given = attr.default;
            else throw new RangeError("No value supplied for attribute " + name);
        }
        built[name] = given;
    }
    return built;
}
function $b42367e7348c0623$var$checkAttrs(attrs, values, type, name) {
    for(let name in values)if (!(name in attrs)) throw new RangeError(`Unsupported attribute ${name} for ${type} of type ${name}`);
    for(let name in attrs){
        let attr = attrs[name];
        if (attr.validate) attr.validate(values[name]);
    }
}
function $b42367e7348c0623$var$initAttrs(typeName, attrs) {
    let result = Object.create(null);
    if (attrs) for(let name in attrs)result[name] = new $b42367e7348c0623$var$Attribute(typeName, name, attrs[name]);
    return result;
}
/**
Node types are objects allocated once per `Schema` and used to
[tag](https://prosemirror.net/docs/ref/#model.Node.type) `Node` instances. They contain information
about the node type, such as its name and what kind of node it
represents.
*/ class $b42367e7348c0623$export$f06e977173f1857c {
    /**
    @internal
    */ constructor(/**
    The name the node type has in this schema.
    */ name, /**
    A link back to the `Schema` the node type belongs to.
    */ schema, /**
    The spec that this type is based on
    */ spec){
        this.name = name;
        this.schema = schema;
        this.spec = spec;
        /**
        The set of marks allowed in this node. `null` means all marks
        are allowed.
        */ this.markSet = null;
        this.groups = spec.group ? spec.group.split(" ") : [];
        this.attrs = $b42367e7348c0623$var$initAttrs(name, spec.attrs);
        this.defaultAttrs = $b42367e7348c0623$var$defaultAttrs(this.attrs);
        this.contentMatch = null;
        this.inlineContent = null;
        this.isBlock = !(spec.inline || name == "text");
        this.isText = name == "text";
    }
    /**
    True if this is an inline type.
    */ get isInline() {
        return !this.isBlock;
    }
    /**
    True if this is a textblock type, a block that contains inline
    content.
    */ get isTextblock() {
        return this.isBlock && this.inlineContent;
    }
    /**
    True for node types that allow no content.
    */ get isLeaf() {
        return this.contentMatch == $b42367e7348c0623$export$364ed450558d7ec4.empty;
    }
    /**
    True when this node is an atom, i.e. when it does not have
    directly editable content.
    */ get isAtom() {
        return this.isLeaf || !!this.spec.atom;
    }
    /**
    Return true when this node type is part of the given
    [group](https://prosemirror.net/docs/ref/#model.NodeSpec.group).
    */ isInGroup(group) {
        return this.groups.indexOf(group) > -1;
    }
    /**
    The node type's [whitespace](https://prosemirror.net/docs/ref/#model.NodeSpec.whitespace) option.
    */ get whitespace() {
        return this.spec.whitespace || (this.spec.code ? "pre" : "normal");
    }
    /**
    Tells you whether this node type has any required attributes.
    */ hasRequiredAttrs() {
        for(let n in this.attrs)if (this.attrs[n].isRequired) return true;
        return false;
    }
    /**
    Indicates whether this node allows some of the same content as
    the given node type.
    */ compatibleContent(other) {
        return this == other || this.contentMatch.compatible(other.contentMatch);
    }
    /**
    @internal
    */ computeAttrs(attrs) {
        if (!attrs && this.defaultAttrs) return this.defaultAttrs;
        else return $b42367e7348c0623$var$computeAttrs(this.attrs, attrs);
    }
    /**
    Create a `Node` of this type. The given attributes are
    checked and defaulted (you can pass `null` to use the type's
    defaults entirely, if no required attributes exist). `content`
    may be a `Fragment`, a node, an array of nodes, or
    `null`. Similarly `marks` may be `null` to default to the empty
    set of marks.
    */ create(attrs = null, content, marks) {
        if (this.isText) throw new Error("NodeType.create can't construct text nodes");
        return new $b42367e7348c0623$export$85c928794f8d04d4(this, this.computeAttrs(attrs), $b42367e7348c0623$export$ffb0004e005737fa.from(content), $b42367e7348c0623$export$c9d15bcfc6d42044.setFrom(marks));
    }
    /**
    Like [`create`](https://prosemirror.net/docs/ref/#model.NodeType.create), but check the given content
    against the node type's content restrictions, and throw an error
    if it doesn't match.
    */ createChecked(attrs = null, content, marks) {
        content = $b42367e7348c0623$export$ffb0004e005737fa.from(content);
        this.checkContent(content);
        return new $b42367e7348c0623$export$85c928794f8d04d4(this, this.computeAttrs(attrs), content, $b42367e7348c0623$export$c9d15bcfc6d42044.setFrom(marks));
    }
    /**
    Like [`create`](https://prosemirror.net/docs/ref/#model.NodeType.create), but see if it is
    necessary to add nodes to the start or end of the given fragment
    to make it fit the node. If no fitting wrapping can be found,
    return null. Note that, due to the fact that required nodes can
    always be created, this will always succeed if you pass null or
    `Fragment.empty` as content.
    */ createAndFill(attrs = null, content, marks) {
        attrs = this.computeAttrs(attrs);
        content = $b42367e7348c0623$export$ffb0004e005737fa.from(content);
        if (content.size) {
            let before = this.contentMatch.fillBefore(content);
            if (!before) return null;
            content = before.append(content);
        }
        let matched = this.contentMatch.matchFragment(content);
        let after = matched && matched.fillBefore($b42367e7348c0623$export$ffb0004e005737fa.empty, true);
        if (!after) return null;
        return new $b42367e7348c0623$export$85c928794f8d04d4(this, attrs, content.append(after), $b42367e7348c0623$export$c9d15bcfc6d42044.setFrom(marks));
    }
    /**
    Returns true if the given fragment is valid content for this node
    type.
    */ validContent(content) {
        let result = this.contentMatch.matchFragment(content);
        if (!result || !result.validEnd) return false;
        for(let i = 0; i < content.childCount; i++)if (!this.allowsMarks(content.child(i).marks)) return false;
        return true;
    }
    /**
    Throws a RangeError if the given fragment is not valid content for this
    node type.
    @internal
    */ checkContent(content) {
        if (!this.validContent(content)) throw new RangeError(`Invalid content for node ${this.name}: ${content.toString().slice(0, 50)}`);
    }
    /**
    @internal
    */ checkAttrs(attrs) {
        $b42367e7348c0623$var$checkAttrs(this.attrs, attrs, "node", this.name);
    }
    /**
    Check whether the given mark type is allowed in this node.
    */ allowsMarkType(markType) {
        return this.markSet == null || this.markSet.indexOf(markType) > -1;
    }
    /**
    Test whether the given set of marks are allowed in this node.
    */ allowsMarks(marks) {
        if (this.markSet == null) return true;
        for(let i = 0; i < marks.length; i++)if (!this.allowsMarkType(marks[i].type)) return false;
        return true;
    }
    /**
    Removes the marks that are not allowed in this node from the given set.
    */ allowedMarks(marks) {
        if (this.markSet == null) return marks;
        let copy;
        for(let i = 0; i < marks.length; i++){
            if (!this.allowsMarkType(marks[i].type)) {
                if (!copy) copy = marks.slice(0, i);
            } else if (copy) copy.push(marks[i]);
        }
        return !copy ? marks : copy.length ? copy : $b42367e7348c0623$export$c9d15bcfc6d42044.none;
    }
    /**
    @internal
    */ static compile(nodes, schema) {
        let result = Object.create(null);
        nodes.forEach((name, spec)=>result[name] = new $b42367e7348c0623$export$f06e977173f1857c(name, schema, spec));
        let topType = schema.spec.topNode || "doc";
        if (!result[topType]) throw new RangeError("Schema is missing its top node type ('" + topType + "')");
        if (!result.text) throw new RangeError("Every schema needs a 'text' type");
        for(let _ in result.text.attrs)throw new RangeError("The text node type should not have attributes");
        return result;
    }
}
function $b42367e7348c0623$var$validateType(typeName, attrName, type) {
    let types = type.split("|");
    return (value)=>{
        let name = value === null ? "null" : typeof value;
        if (types.indexOf(name) < 0) throw new RangeError(`Expected value of type ${types} for attribute ${attrName} on type ${typeName}, got ${name}`);
    };
}
// Attribute descriptors
class $b42367e7348c0623$var$Attribute {
    constructor(typeName, attrName, options){
        this.hasDefault = Object.prototype.hasOwnProperty.call(options, "default");
        this.default = options.default;
        this.validate = typeof options.validate == "string" ? $b42367e7348c0623$var$validateType(typeName, attrName, options.validate) : options.validate;
    }
    get isRequired() {
        return !this.hasDefault;
    }
}
// Marks
/**
Like nodes, marks (which are associated with nodes to signify
things like emphasis or being part of a link) are
[tagged](https://prosemirror.net/docs/ref/#model.Mark.type) with type objects, which are
instantiated once per `Schema`.
*/ class $b42367e7348c0623$export$b6a78689043c6521 {
    /**
    @internal
    */ constructor(/**
    The name of the mark type.
    */ name, /**
    @internal
    */ rank, /**
    The schema that this mark type instance is part of.
    */ schema, /**
    The spec on which the type is based.
    */ spec){
        this.name = name;
        this.rank = rank;
        this.schema = schema;
        this.spec = spec;
        this.attrs = $b42367e7348c0623$var$initAttrs(name, spec.attrs);
        this.excluded = null;
        let defaults = $b42367e7348c0623$var$defaultAttrs(this.attrs);
        this.instance = defaults ? new $b42367e7348c0623$export$c9d15bcfc6d42044(this, defaults) : null;
    }
    /**
    Create a mark of this type. `attrs` may be `null` or an object
    containing only some of the mark's attributes. The others, if
    they have defaults, will be added.
    */ create(attrs = null) {
        if (!attrs && this.instance) return this.instance;
        return new $b42367e7348c0623$export$c9d15bcfc6d42044(this, $b42367e7348c0623$var$computeAttrs(this.attrs, attrs));
    }
    /**
    @internal
    */ static compile(marks, schema) {
        let result = Object.create(null), rank = 0;
        marks.forEach((name, spec)=>result[name] = new $b42367e7348c0623$export$b6a78689043c6521(name, rank++, schema, spec));
        return result;
    }
    /**
    When there is a mark of this type in the given set, a new set
    without it is returned. Otherwise, the input set is returned.
    */ removeFromSet(set) {
        for(var i = 0; i < set.length; i++)if (set[i].type == this) {
            set = set.slice(0, i).concat(set.slice(i + 1));
            i--;
        }
        return set;
    }
    /**
    Tests whether there is a mark of this type in the given set.
    */ isInSet(set) {
        for(let i = 0; i < set.length; i++)if (set[i].type == this) return set[i];
    }
    /**
    @internal
    */ checkAttrs(attrs) {
        $b42367e7348c0623$var$checkAttrs(this.attrs, attrs, "mark", this.name);
    }
    /**
    Queries whether a given mark type is
    [excluded](https://prosemirror.net/docs/ref/#model.MarkSpec.excludes) by this one.
    */ excludes(other) {
        return this.excluded.indexOf(other) > -1;
    }
}
/**
A document schema. Holds [node](https://prosemirror.net/docs/ref/#model.NodeType) and [mark
type](https://prosemirror.net/docs/ref/#model.MarkType) objects for the nodes and marks that may
occur in conforming documents, and provides functionality for
creating and deserializing such documents.

When given, the type parameters provide the names of the nodes and
marks in this schema.
*/ class $b42367e7348c0623$export$19342e026b58ebb7 {
    /**
    Construct a schema from a schema [specification](https://prosemirror.net/docs/ref/#model.SchemaSpec).
    */ constructor(spec){
        /**
        The [linebreak
        replacement](https://prosemirror.net/docs/ref/#model.NodeSpec.linebreakReplacement) node defined
        in this schema, if any.
        */ this.linebreakReplacement = null;
        /**
        An object for storing whatever values modules may want to
        compute and cache per schema. (If you want to store something
        in it, try to use property names unlikely to clash.)
        */ this.cached = Object.create(null);
        let instanceSpec = this.spec = {};
        for(let prop in spec)instanceSpec[prop] = spec[prop];
        instanceSpec.nodes = (0, $at9VT.default).from(spec.nodes), instanceSpec.marks = (0, $at9VT.default).from(spec.marks || {}), this.nodes = $b42367e7348c0623$export$f06e977173f1857c.compile(this.spec.nodes, this);
        this.marks = $b42367e7348c0623$export$b6a78689043c6521.compile(this.spec.marks, this);
        let contentExprCache = Object.create(null);
        for(let prop in this.nodes){
            if (prop in this.marks) throw new RangeError(prop + " can not be both a node and a mark");
            let type = this.nodes[prop], contentExpr = type.spec.content || "", markExpr = type.spec.marks;
            type.contentMatch = contentExprCache[contentExpr] || (contentExprCache[contentExpr] = $b42367e7348c0623$export$364ed450558d7ec4.parse(contentExpr, this.nodes));
            type.inlineContent = type.contentMatch.inlineContent;
            if (type.spec.linebreakReplacement) {
                if (this.linebreakReplacement) throw new RangeError("Multiple linebreak nodes defined");
                if (!type.isInline || !type.isLeaf) throw new RangeError("Linebreak replacement nodes must be inline leaf nodes");
                this.linebreakReplacement = type;
            }
            type.markSet = markExpr == "_" ? null : markExpr ? $b42367e7348c0623$var$gatherMarks(this, markExpr.split(" ")) : markExpr == "" || !type.inlineContent ? [] : null;
        }
        for(let prop in this.marks){
            let type = this.marks[prop], excl = type.spec.excludes;
            type.excluded = excl == null ? [
                type
            ] : excl == "" ? [] : $b42367e7348c0623$var$gatherMarks(this, excl.split(" "));
        }
        this.nodeFromJSON = (json)=>$b42367e7348c0623$export$85c928794f8d04d4.fromJSON(this, json);
        this.markFromJSON = (json)=>$b42367e7348c0623$export$c9d15bcfc6d42044.fromJSON(this, json);
        this.topNodeType = this.nodes[this.spec.topNode || "doc"];
        this.cached.wrappings = Object.create(null);
    }
    /**
    Create a node in this schema. The `type` may be a string or a
    `NodeType` instance. Attributes will be extended with defaults,
    `content` may be a `Fragment`, `null`, a `Node`, or an array of
    nodes.
    */ node(type, attrs = null, content, marks) {
        if (typeof type == "string") type = this.nodeType(type);
        else if (!(type instanceof $b42367e7348c0623$export$f06e977173f1857c)) throw new RangeError("Invalid node type: " + type);
        else if (type.schema != this) throw new RangeError("Node type from different schema used (" + type.name + ")");
        return type.createChecked(attrs, content, marks);
    }
    /**
    Create a text node in the schema. Empty text nodes are not
    allowed.
    */ text(text, marks) {
        let type = this.nodes.text;
        return new $b42367e7348c0623$var$TextNode(type, type.defaultAttrs, text, $b42367e7348c0623$export$c9d15bcfc6d42044.setFrom(marks));
    }
    /**
    Create a mark with the given type and attributes.
    */ mark(type, attrs) {
        if (typeof type == "string") type = this.marks[type];
        return type.create(attrs);
    }
    /**
    @internal
    */ nodeType(name) {
        let found = this.nodes[name];
        if (!found) throw new RangeError("Unknown node type: " + name);
        return found;
    }
}
function $b42367e7348c0623$var$gatherMarks(schema, marks) {
    let found = [];
    for(let i = 0; i < marks.length; i++){
        let name = marks[i], mark = schema.marks[name], ok = mark;
        if (mark) found.push(mark);
        else for(let prop in schema.marks){
            let mark = schema.marks[prop];
            if (name == "_" || mark.spec.group && mark.spec.group.split(" ").indexOf(name) > -1) found.push(ok = mark);
        }
        if (!ok) throw new SyntaxError("Unknown mark type: '" + marks[i] + "'");
    }
    return found;
}
function $b42367e7348c0623$var$isTagRule(rule) {
    return rule.tag != null;
}
function $b42367e7348c0623$var$isStyleRule(rule) {
    return rule.style != null;
}
/**
A DOM parser represents a strategy for parsing DOM content into a
ProseMirror document conforming to a given schema. Its behavior is
defined by an array of [rules](https://prosemirror.net/docs/ref/#model.ParseRule).
*/ class $b42367e7348c0623$export$1059c6e7d2ce5669 {
    /**
    Create a parser that targets the given schema, using the given
    parsing rules.
    */ constructor(/**
    The schema into which the parser parses.
    */ schema, /**
    The set of [parse rules](https://prosemirror.net/docs/ref/#model.ParseRule) that the parser
    uses, in order of precedence.
    */ rules){
        this.schema = schema;
        this.rules = rules;
        /**
        @internal
        */ this.tags = [];
        /**
        @internal
        */ this.styles = [];
        let matchedStyles = this.matchedStyles = [];
        rules.forEach((rule)=>{
            if ($b42367e7348c0623$var$isTagRule(rule)) this.tags.push(rule);
            else if ($b42367e7348c0623$var$isStyleRule(rule)) {
                let prop = /[^=]*/.exec(rule.style)[0];
                if (matchedStyles.indexOf(prop) < 0) matchedStyles.push(prop);
                this.styles.push(rule);
            }
        });
        // Only normalize list elements when lists in the schema can't directly contain themselves
        this.normalizeLists = !this.tags.some((r)=>{
            if (!/^(ul|ol)\b/.test(r.tag) || !r.node) return false;
            let node = schema.nodes[r.node];
            return node.contentMatch.matchType(node);
        });
    }
    /**
    Parse a document from the content of a DOM node.
    */ parse(dom, options = {}) {
        let context = new $b42367e7348c0623$var$ParseContext(this, options, false);
        context.addAll(dom, $b42367e7348c0623$export$c9d15bcfc6d42044.none, options.from, options.to);
        return context.finish();
    }
    /**
    Parses the content of the given DOM node, like
    [`parse`](https://prosemirror.net/docs/ref/#model.DOMParser.parse), and takes the same set of
    options. But unlike that method, which produces a whole node,
    this one returns a slice that is open at the sides, meaning that
    the schema constraints aren't applied to the start of nodes to
    the left of the input and the end of nodes at the end.
    */ parseSlice(dom, options = {}) {
        let context = new $b42367e7348c0623$var$ParseContext(this, options, true);
        context.addAll(dom, $b42367e7348c0623$export$c9d15bcfc6d42044.none, options.from, options.to);
        return $b42367e7348c0623$export$b3f2e2de3a8baa1e.maxOpen(context.finish());
    }
    /**
    @internal
    */ matchTag(dom, context, after) {
        for(let i = after ? this.tags.indexOf(after) + 1 : 0; i < this.tags.length; i++){
            let rule = this.tags[i];
            if ($b42367e7348c0623$var$matches(dom, rule.tag) && (rule.namespace === undefined || dom.namespaceURI == rule.namespace) && (!rule.context || context.matchesContext(rule.context))) {
                if (rule.getAttrs) {
                    let result = rule.getAttrs(dom);
                    if (result === false) continue;
                    rule.attrs = result || undefined;
                }
                return rule;
            }
        }
    }
    /**
    @internal
    */ matchStyle(prop, value, context, after) {
        for(let i = after ? this.styles.indexOf(after) + 1 : 0; i < this.styles.length; i++){
            let rule = this.styles[i], style = rule.style;
            if (style.indexOf(prop) != 0 || rule.context && !context.matchesContext(rule.context) || // Test that the style string either precisely matches the prop,
            // or has an '=' sign after the prop, followed by the given
            // value.
            style.length > prop.length && (style.charCodeAt(prop.length) != 61 || style.slice(prop.length + 1) != value)) continue;
            if (rule.getAttrs) {
                let result = rule.getAttrs(value);
                if (result === false) continue;
                rule.attrs = result || undefined;
            }
            return rule;
        }
    }
    /**
    @internal
    */ static schemaRules(schema) {
        let result = [];
        function insert(rule) {
            let priority = rule.priority == null ? 50 : rule.priority, i = 0;
            for(; i < result.length; i++){
                let next = result[i], nextPriority = next.priority == null ? 50 : next.priority;
                if (nextPriority < priority) break;
            }
            result.splice(i, 0, rule);
        }
        for(let name in schema.marks){
            let rules = schema.marks[name].spec.parseDOM;
            if (rules) rules.forEach((rule)=>{
                insert(rule = $b42367e7348c0623$var$copy(rule));
                if (!(rule.mark || rule.ignore || rule.clearMark)) rule.mark = name;
            });
        }
        for(let name in schema.nodes){
            let rules = schema.nodes[name].spec.parseDOM;
            if (rules) rules.forEach((rule)=>{
                insert(rule = $b42367e7348c0623$var$copy(rule));
                if (!(rule.node || rule.ignore || rule.mark)) rule.node = name;
            });
        }
        return result;
    }
    /**
    Construct a DOM parser using the parsing rules listed in a
    schema's [node specs](https://prosemirror.net/docs/ref/#model.NodeSpec.parseDOM), reordered by
    [priority](https://prosemirror.net/docs/ref/#model.GenericParseRule.priority).
    */ static fromSchema(schema) {
        return schema.cached.domParser || (schema.cached.domParser = new $b42367e7348c0623$export$1059c6e7d2ce5669(schema, $b42367e7348c0623$export$1059c6e7d2ce5669.schemaRules(schema)));
    }
}
const $b42367e7348c0623$var$blockTags = {
    address: true,
    article: true,
    aside: true,
    blockquote: true,
    canvas: true,
    dd: true,
    div: true,
    dl: true,
    fieldset: true,
    figcaption: true,
    figure: true,
    footer: true,
    form: true,
    h1: true,
    h2: true,
    h3: true,
    h4: true,
    h5: true,
    h6: true,
    header: true,
    hgroup: true,
    hr: true,
    li: true,
    noscript: true,
    ol: true,
    output: true,
    p: true,
    pre: true,
    section: true,
    table: true,
    tfoot: true,
    ul: true
};
const $b42367e7348c0623$var$ignoreTags = {
    head: true,
    noscript: true,
    object: true,
    script: true,
    style: true,
    title: true
};
const $b42367e7348c0623$var$listTags = {
    ol: true,
    ul: true
};
// Using a bitfield for node context options
const $b42367e7348c0623$var$OPT_PRESERVE_WS = 1, $b42367e7348c0623$var$OPT_PRESERVE_WS_FULL = 2, $b42367e7348c0623$var$OPT_OPEN_LEFT = 4;
function $b42367e7348c0623$var$wsOptionsFor(type, preserveWhitespace, base) {
    if (preserveWhitespace != null) return (preserveWhitespace ? $b42367e7348c0623$var$OPT_PRESERVE_WS : 0) | (preserveWhitespace === "full" ? $b42367e7348c0623$var$OPT_PRESERVE_WS_FULL : 0);
    return type && type.whitespace == "pre" ? $b42367e7348c0623$var$OPT_PRESERVE_WS | $b42367e7348c0623$var$OPT_PRESERVE_WS_FULL : base & ~$b42367e7348c0623$var$OPT_OPEN_LEFT;
}
class $b42367e7348c0623$var$NodeContext {
    constructor(type, attrs, marks, solid, match, options){
        this.type = type;
        this.attrs = attrs;
        this.marks = marks;
        this.solid = solid;
        this.options = options;
        this.content = [];
        // Marks applied to the node's children
        this.activeMarks = $b42367e7348c0623$export$c9d15bcfc6d42044.none;
        this.match = match || (options & $b42367e7348c0623$var$OPT_OPEN_LEFT ? null : type.contentMatch);
    }
    findWrapping(node) {
        if (!this.match) {
            if (!this.type) return [];
            let fill = this.type.contentMatch.fillBefore($b42367e7348c0623$export$ffb0004e005737fa.from(node));
            if (fill) this.match = this.type.contentMatch.matchFragment(fill);
            else {
                let start = this.type.contentMatch, wrap;
                if (wrap = start.findWrapping(node.type)) {
                    this.match = start;
                    return wrap;
                } else return null;
            }
        }
        return this.match.findWrapping(node.type);
    }
    finish(openEnd) {
        if (!(this.options & $b42367e7348c0623$var$OPT_PRESERVE_WS)) {
            let last = this.content[this.content.length - 1], m;
            if (last && last.isText && (m = /[ \t\r\n\u000c]+$/.exec(last.text))) {
                let text = last;
                if (last.text.length == m[0].length) this.content.pop();
                else this.content[this.content.length - 1] = text.withText(text.text.slice(0, text.text.length - m[0].length));
            }
        }
        let content = $b42367e7348c0623$export$ffb0004e005737fa.from(this.content);
        if (!openEnd && this.match) content = content.append(this.match.fillBefore($b42367e7348c0623$export$ffb0004e005737fa.empty, true));
        return this.type ? this.type.create(this.attrs, content, this.marks) : content;
    }
    inlineContext(node) {
        if (this.type) return this.type.inlineContent;
        if (this.content.length) return this.content[0].isInline;
        return node.parentNode && !$b42367e7348c0623$var$blockTags.hasOwnProperty(node.parentNode.nodeName.toLowerCase());
    }
}
class $b42367e7348c0623$var$ParseContext {
    constructor(// The parser we are using.
    parser, // The options passed to this parse.
    options, isOpen){
        this.parser = parser;
        this.options = options;
        this.isOpen = isOpen;
        this.open = 0;
        this.localPreserveWS = false;
        let topNode = options.topNode, topContext;
        let topOptions = $b42367e7348c0623$var$wsOptionsFor(null, options.preserveWhitespace, 0) | (isOpen ? $b42367e7348c0623$var$OPT_OPEN_LEFT : 0);
        if (topNode) topContext = new $b42367e7348c0623$var$NodeContext(topNode.type, topNode.attrs, $b42367e7348c0623$export$c9d15bcfc6d42044.none, true, options.topMatch || topNode.type.contentMatch, topOptions);
        else if (isOpen) topContext = new $b42367e7348c0623$var$NodeContext(null, null, $b42367e7348c0623$export$c9d15bcfc6d42044.none, true, null, topOptions);
        else topContext = new $b42367e7348c0623$var$NodeContext(parser.schema.topNodeType, null, $b42367e7348c0623$export$c9d15bcfc6d42044.none, true, null, topOptions);
        this.nodes = [
            topContext
        ];
        this.find = options.findPositions;
        this.needsBlock = false;
    }
    get top() {
        return this.nodes[this.open];
    }
    // Add a DOM node to the content. Text is inserted as text node,
    // otherwise, the node is passed to `addElement` or, if it has a
    // `style` attribute, `addElementWithStyles`.
    addDOM(dom, marks) {
        if (dom.nodeType == 3) this.addTextNode(dom, marks);
        else if (dom.nodeType == 1) this.addElement(dom, marks);
    }
    addTextNode(dom, marks) {
        let value = dom.nodeValue;
        let top = this.top, preserveWS = top.options & $b42367e7348c0623$var$OPT_PRESERVE_WS_FULL ? "full" : this.localPreserveWS || (top.options & $b42367e7348c0623$var$OPT_PRESERVE_WS) > 0;
        let { schema: schema } = this.parser;
        if (preserveWS === "full" || top.inlineContext(dom) || /[^ \t\r\n\u000c]/.test(value)) {
            if (!preserveWS) {
                value = value.replace(/[ \t\r\n\u000c]+/g, " ");
                // If this starts with whitespace, and there is no node before it, or
                // a hard break, or a text node that ends with whitespace, strip the
                // leading space.
                if (/^[ \t\r\n\u000c]/.test(value) && this.open == this.nodes.length - 1) {
                    let nodeBefore = top.content[top.content.length - 1];
                    let domNodeBefore = dom.previousSibling;
                    if (!nodeBefore || domNodeBefore && domNodeBefore.nodeName == 'BR' || nodeBefore.isText && /[ \t\r\n\u000c]$/.test(nodeBefore.text)) value = value.slice(1);
                }
            } else if (preserveWS === "full") value = value.replace(/\r\n?/g, "\n");
            else if (schema.linebreakReplacement && /[\r\n]/.test(value) && this.top.findWrapping(schema.linebreakReplacement.create())) {
                let lines = value.split(/\r?\n|\r/);
                for(let i = 0; i < lines.length; i++){
                    if (i) this.insertNode(schema.linebreakReplacement.create(), marks, true);
                    if (lines[i]) this.insertNode(schema.text(lines[i]), marks, !/\S/.test(lines[i]));
                }
                value = "";
            } else value = value.replace(/\r?\n|\r/g, " ");
            if (value) this.insertNode(schema.text(value), marks, !/\S/.test(value));
            this.findInText(dom);
        } else this.findInside(dom);
    }
    // Try to find a handler for the given tag and use that to parse. If
    // none is found, the element's content nodes are added directly.
    addElement(dom, marks, matchAfter) {
        let outerWS = this.localPreserveWS, top = this.top;
        if (dom.tagName == "PRE" || /pre/.test(dom.style && dom.style.whiteSpace)) this.localPreserveWS = true;
        let name = dom.nodeName.toLowerCase(), ruleID;
        if ($b42367e7348c0623$var$listTags.hasOwnProperty(name) && this.parser.normalizeLists) $b42367e7348c0623$var$normalizeList(dom);
        let rule = this.options.ruleFromNode && this.options.ruleFromNode(dom) || (ruleID = this.parser.matchTag(dom, this, matchAfter));
        out: if (rule ? rule.ignore : $b42367e7348c0623$var$ignoreTags.hasOwnProperty(name)) {
            this.findInside(dom);
            this.ignoreFallback(dom, marks);
        } else if (!rule || rule.skip || rule.closeParent) {
            if (rule && rule.closeParent) this.open = Math.max(0, this.open - 1);
            else if (rule && rule.skip.nodeType) dom = rule.skip;
            let sync, oldNeedsBlock = this.needsBlock;
            if ($b42367e7348c0623$var$blockTags.hasOwnProperty(name)) {
                if (top.content.length && top.content[0].isInline && this.open) {
                    this.open--;
                    top = this.top;
                }
                sync = true;
                if (!top.type) this.needsBlock = true;
            } else if (!dom.firstChild) {
                this.leafFallback(dom, marks);
                break out;
            }
            let innerMarks = rule && rule.skip ? marks : this.readStyles(dom, marks);
            if (innerMarks) this.addAll(dom, innerMarks);
            if (sync) this.sync(top);
            this.needsBlock = oldNeedsBlock;
        } else {
            let innerMarks = this.readStyles(dom, marks);
            if (innerMarks) this.addElementByRule(dom, rule, innerMarks, rule.consuming === false ? ruleID : undefined);
        }
        this.localPreserveWS = outerWS;
    }
    // Called for leaf DOM nodes that would otherwise be ignored
    leafFallback(dom, marks) {
        if (dom.nodeName == "BR" && this.top.type && this.top.type.inlineContent) this.addTextNode(dom.ownerDocument.createTextNode("\n"), marks);
    }
    // Called for ignored nodes
    ignoreFallback(dom, marks) {
        // Ignored BR nodes should at least create an inline context
        if (dom.nodeName == "BR" && (!this.top.type || !this.top.type.inlineContent)) this.findPlace(this.parser.schema.text("-"), marks, true);
    }
    // Run any style parser associated with the node's styles. Either
    // return an updated array of marks, or null to indicate some of the
    // styles had a rule with `ignore` set.
    readStyles(dom, marks) {
        let styles = dom.style;
        // Because many properties will only show up in 'normalized' form
        // in `style.item` (i.e. text-decoration becomes
        // text-decoration-line, text-decoration-color, etc), we directly
        // query the styles mentioned in our rules instead of iterating
        // over the items.
        if (styles && styles.length) for(let i = 0; i < this.parser.matchedStyles.length; i++){
            let name = this.parser.matchedStyles[i], value = styles.getPropertyValue(name);
            if (value) for(let after = undefined;;){
                let rule = this.parser.matchStyle(name, value, this, after);
                if (!rule) break;
                if (rule.ignore) return null;
                if (rule.clearMark) marks = marks.filter((m)=>!rule.clearMark(m));
                else marks = marks.concat(this.parser.schema.marks[rule.mark].create(rule.attrs));
                if (rule.consuming === false) after = rule;
                else break;
            }
        }
        return marks;
    }
    // Look up a handler for the given node. If none are found, return
    // false. Otherwise, apply it, use its return value to drive the way
    // the node's content is wrapped, and return true.
    addElementByRule(dom, rule, marks, continueAfter) {
        let sync, nodeType;
        if (rule.node) {
            nodeType = this.parser.schema.nodes[rule.node];
            if (!nodeType.isLeaf) {
                let inner = this.enter(nodeType, rule.attrs || null, marks, rule.preserveWhitespace);
                if (inner) {
                    sync = true;
                    marks = inner;
                }
            } else if (!this.insertNode(nodeType.create(rule.attrs), marks, dom.nodeName == "BR")) this.leafFallback(dom, marks);
        } else {
            let markType = this.parser.schema.marks[rule.mark];
            marks = marks.concat(markType.create(rule.attrs));
        }
        let startIn = this.top;
        if (nodeType && nodeType.isLeaf) this.findInside(dom);
        else if (continueAfter) this.addElement(dom, marks, continueAfter);
        else if (rule.getContent) {
            this.findInside(dom);
            rule.getContent(dom, this.parser.schema).forEach((node)=>this.insertNode(node, marks, false));
        } else {
            let contentDOM = dom;
            if (typeof rule.contentElement == "string") contentDOM = dom.querySelector(rule.contentElement);
            else if (typeof rule.contentElement == "function") contentDOM = rule.contentElement(dom);
            else if (rule.contentElement) contentDOM = rule.contentElement;
            this.findAround(dom, contentDOM, true);
            this.addAll(contentDOM, marks);
            this.findAround(dom, contentDOM, false);
        }
        if (sync && this.sync(startIn)) this.open--;
    }
    // Add all child nodes between `startIndex` and `endIndex` (or the
    // whole node, if not given). If `sync` is passed, use it to
    // synchronize after every block element.
    addAll(parent, marks, startIndex, endIndex) {
        let index = startIndex || 0;
        for(let dom = startIndex ? parent.childNodes[startIndex] : parent.firstChild, end = endIndex == null ? null : parent.childNodes[endIndex]; dom != end; dom = dom.nextSibling, ++index){
            this.findAtPoint(parent, index);
            this.addDOM(dom, marks);
        }
        this.findAtPoint(parent, index);
    }
    // Try to find a way to fit the given node type into the current
    // context. May add intermediate wrappers and/or leave non-solid
    // nodes that we're in.
    findPlace(node, marks, cautious) {
        let route, sync;
        for(let depth = this.open, penalty = 0; depth >= 0; depth--){
            let cx = this.nodes[depth];
            let found = cx.findWrapping(node);
            if (found && (!route || route.length > found.length + penalty)) {
                route = found;
                sync = cx;
                if (!found.length) break;
            }
            if (cx.solid) {
                if (cautious) break;
                penalty += 2;
            }
        }
        if (!route) return null;
        this.sync(sync);
        for(let i = 0; i < route.length; i++)marks = this.enterInner(route[i], null, marks, false);
        return marks;
    }
    // Try to insert the given node, adjusting the context when needed.
    insertNode(node, marks, cautious) {
        if (node.isInline && this.needsBlock && !this.top.type) {
            let block = this.textblockFromContext();
            if (block) marks = this.enterInner(block, null, marks);
        }
        let innerMarks = this.findPlace(node, marks, cautious);
        if (innerMarks) {
            this.closeExtra();
            let top = this.top;
            if (top.match) top.match = top.match.matchType(node.type);
            let nodeMarks = $b42367e7348c0623$export$c9d15bcfc6d42044.none;
            for (let m of innerMarks.concat(node.marks))if (top.type ? top.type.allowsMarkType(m.type) : $b42367e7348c0623$var$markMayApply(m.type, node.type)) nodeMarks = m.addToSet(nodeMarks);
            top.content.push(node.mark(nodeMarks));
            return true;
        }
        return false;
    }
    // Try to start a node of the given type, adjusting the context when
    // necessary.
    enter(type, attrs, marks, preserveWS) {
        let innerMarks = this.findPlace(type.create(attrs), marks, false);
        if (innerMarks) innerMarks = this.enterInner(type, attrs, marks, true, preserveWS);
        return innerMarks;
    }
    // Open a node of the given type
    enterInner(type, attrs, marks, solid = false, preserveWS) {
        this.closeExtra();
        let top = this.top;
        top.match = top.match && top.match.matchType(type);
        let options = $b42367e7348c0623$var$wsOptionsFor(type, preserveWS, top.options);
        if (top.options & $b42367e7348c0623$var$OPT_OPEN_LEFT && top.content.length == 0) options |= $b42367e7348c0623$var$OPT_OPEN_LEFT;
        let applyMarks = $b42367e7348c0623$export$c9d15bcfc6d42044.none;
        marks = marks.filter((m)=>{
            if (top.type ? top.type.allowsMarkType(m.type) : $b42367e7348c0623$var$markMayApply(m.type, type)) {
                applyMarks = m.addToSet(applyMarks);
                return false;
            }
            return true;
        });
        this.nodes.push(new $b42367e7348c0623$var$NodeContext(type, attrs, applyMarks, solid, null, options));
        this.open++;
        return marks;
    }
    // Make sure all nodes above this.open are finished and added to
    // their parents
    closeExtra(openEnd = false) {
        let i = this.nodes.length - 1;
        if (i > this.open) {
            for(; i > this.open; i--)this.nodes[i - 1].content.push(this.nodes[i].finish(openEnd));
            this.nodes.length = this.open + 1;
        }
    }
    finish() {
        this.open = 0;
        this.closeExtra(this.isOpen);
        return this.nodes[0].finish(!!(this.isOpen || this.options.topOpen));
    }
    sync(to) {
        for(let i = this.open; i >= 0; i--){
            if (this.nodes[i] == to) {
                this.open = i;
                return true;
            } else if (this.localPreserveWS) this.nodes[i].options |= $b42367e7348c0623$var$OPT_PRESERVE_WS;
        }
        return false;
    }
    get currentPos() {
        this.closeExtra();
        let pos = 0;
        for(let i = this.open; i >= 0; i--){
            let content = this.nodes[i].content;
            for(let j = content.length - 1; j >= 0; j--)pos += content[j].nodeSize;
            if (i) pos++;
        }
        return pos;
    }
    findAtPoint(parent, offset) {
        if (this.find) {
            for(let i = 0; i < this.find.length; i++)if (this.find[i].node == parent && this.find[i].offset == offset) this.find[i].pos = this.currentPos;
        }
    }
    findInside(parent) {
        if (this.find) {
            for(let i = 0; i < this.find.length; i++)if (this.find[i].pos == null && parent.nodeType == 1 && parent.contains(this.find[i].node)) this.find[i].pos = this.currentPos;
        }
    }
    findAround(parent, content, before) {
        if (parent != content && this.find) {
            for(let i = 0; i < this.find.length; i++)if (this.find[i].pos == null && parent.nodeType == 1 && parent.contains(this.find[i].node)) {
                let pos = content.compareDocumentPosition(this.find[i].node);
                if (pos & (before ? 2 : 4)) this.find[i].pos = this.currentPos;
            }
        }
    }
    findInText(textNode) {
        if (this.find) {
            for(let i = 0; i < this.find.length; i++)if (this.find[i].node == textNode) this.find[i].pos = this.currentPos - (textNode.nodeValue.length - this.find[i].offset);
        }
    }
    // Determines whether the given context string matches this context.
    matchesContext(context) {
        if (context.indexOf("|") > -1) return context.split(/\s*\|\s*/).some(this.matchesContext, this);
        let parts = context.split("/");
        let option = this.options.context;
        let useRoot = !this.isOpen && (!option || option.parent.type == this.nodes[0].type);
        let minDepth = -(option ? option.depth + 1 : 0) + (useRoot ? 0 : 1);
        let match = (i, depth)=>{
            for(; i >= 0; i--){
                let part = parts[i];
                if (part == "") {
                    if (i == parts.length - 1 || i == 0) continue;
                    for(; depth >= minDepth; depth--)if (match(i - 1, depth)) return true;
                    return false;
                } else {
                    let next = depth > 0 || depth == 0 && useRoot ? this.nodes[depth].type : option && depth >= minDepth ? option.node(depth - minDepth).type : null;
                    if (!next || next.name != part && !next.isInGroup(part)) return false;
                    depth--;
                }
            }
            return true;
        };
        return match(parts.length - 1, this.open);
    }
    textblockFromContext() {
        let $context = this.options.context;
        if ($context) for(let d = $context.depth; d >= 0; d--){
            let deflt = $context.node(d).contentMatchAt($context.indexAfter(d)).defaultType;
            if (deflt && deflt.isTextblock && deflt.defaultAttrs) return deflt;
        }
        for(let name in this.parser.schema.nodes){
            let type = this.parser.schema.nodes[name];
            if (type.isTextblock && type.defaultAttrs) return type;
        }
    }
}
// Kludge to work around directly nested list nodes produced by some
// tools and allowed by browsers to mean that the nested list is
// actually part of the list item above it.
function $b42367e7348c0623$var$normalizeList(dom) {
    for(let child = dom.firstChild, prevItem = null; child; child = child.nextSibling){
        let name = child.nodeType == 1 ? child.nodeName.toLowerCase() : null;
        if (name && $b42367e7348c0623$var$listTags.hasOwnProperty(name) && prevItem) {
            prevItem.appendChild(child);
            child = prevItem;
        } else if (name == "li") prevItem = child;
        else if (name) prevItem = null;
    }
}
// Apply a CSS selector.
function $b42367e7348c0623$var$matches(dom, selector) {
    return (dom.matches || dom.msMatchesSelector || dom.webkitMatchesSelector || dom.mozMatchesSelector).call(dom, selector);
}
function $b42367e7348c0623$var$copy(obj) {
    let copy = {};
    for(let prop in obj)copy[prop] = obj[prop];
    return copy;
}
// Used when finding a mark at the top level of a fragment parse.
// Checks whether it would be reasonable to apply a given mark type to
// a given node, by looking at the way the mark occurs in the schema.
function $b42367e7348c0623$var$markMayApply(markType, nodeType) {
    let nodes = nodeType.schema.nodes;
    for(let name in nodes){
        let parent = nodes[name];
        if (!parent.allowsMarkType(markType)) continue;
        let seen = [], scan = (match)=>{
            seen.push(match);
            for(let i = 0; i < match.edgeCount; i++){
                let { type: type, next: next } = match.edge(i);
                if (type == nodeType) return true;
                if (seen.indexOf(next) < 0 && scan(next)) return true;
            }
        };
        if (scan(parent.contentMatch)) return true;
    }
}
/**
A DOM serializer knows how to convert ProseMirror nodes and
marks of various types to DOM nodes.
*/ class $b42367e7348c0623$export$3476b78f8f5a8b72 {
    /**
    Create a serializer. `nodes` should map node names to functions
    that take a node and return a description of the corresponding
    DOM. `marks` does the same for mark names, but also gets an
    argument that tells it whether the mark's content is block or
    inline content (for typical use, it'll always be inline). A mark
    serializer may be `null` to indicate that marks of that type
    should not be serialized.
    */ constructor(/**
    The node serialization functions.
    */ nodes, /**
    The mark serialization functions.
    */ marks){
        this.nodes = nodes;
        this.marks = marks;
    }
    /**
    Serialize the content of this fragment to a DOM fragment. When
    not in the browser, the `document` option, containing a DOM
    document, should be passed so that the serializer can create
    nodes.
    */ serializeFragment(fragment, options = {}, target) {
        if (!target) target = $b42367e7348c0623$var$doc(options).createDocumentFragment();
        let top = target, active = [];
        fragment.forEach((node)=>{
            if (active.length || node.marks.length) {
                let keep = 0, rendered = 0;
                while(keep < active.length && rendered < node.marks.length){
                    let next = node.marks[rendered];
                    if (!this.marks[next.type.name]) {
                        rendered++;
                        continue;
                    }
                    if (!next.eq(active[keep][0]) || next.type.spec.spanning === false) break;
                    keep++;
                    rendered++;
                }
                while(keep < active.length)top = active.pop()[1];
                while(rendered < node.marks.length){
                    let add = node.marks[rendered++];
                    let markDOM = this.serializeMark(add, node.isInline, options);
                    if (markDOM) {
                        active.push([
                            add,
                            top
                        ]);
                        top.appendChild(markDOM.dom);
                        top = markDOM.contentDOM || markDOM.dom;
                    }
                }
            }
            top.appendChild(this.serializeNodeInner(node, options));
        });
        return target;
    }
    /**
    @internal
    */ serializeNodeInner(node, options) {
        let { dom: dom, contentDOM: contentDOM } = $b42367e7348c0623$var$renderSpec($b42367e7348c0623$var$doc(options), this.nodes[node.type.name](node), null, node.attrs);
        if (contentDOM) {
            if (node.isLeaf) throw new RangeError("Content hole not allowed in a leaf node spec");
            this.serializeFragment(node.content, options, contentDOM);
        }
        return dom;
    }
    /**
    Serialize this node to a DOM node. This can be useful when you
    need to serialize a part of a document, as opposed to the whole
    document. To serialize a whole document, use
    [`serializeFragment`](https://prosemirror.net/docs/ref/#model.DOMSerializer.serializeFragment) on
    its [content](https://prosemirror.net/docs/ref/#model.Node.content).
    */ serializeNode(node, options = {}) {
        let dom = this.serializeNodeInner(node, options);
        for(let i = node.marks.length - 1; i >= 0; i--){
            let wrap = this.serializeMark(node.marks[i], node.isInline, options);
            if (wrap) {
                (wrap.contentDOM || wrap.dom).appendChild(dom);
                dom = wrap.dom;
            }
        }
        return dom;
    }
    /**
    @internal
    */ serializeMark(mark, inline, options = {}) {
        let toDOM = this.marks[mark.type.name];
        return toDOM && $b42367e7348c0623$var$renderSpec($b42367e7348c0623$var$doc(options), toDOM(mark, inline), null, mark.attrs);
    }
    static renderSpec(doc, structure, xmlNS = null, blockArraysIn) {
        return $b42367e7348c0623$var$renderSpec(doc, structure, xmlNS, blockArraysIn);
    }
    /**
    Build a serializer using the [`toDOM`](https://prosemirror.net/docs/ref/#model.NodeSpec.toDOM)
    properties in a schema's node and mark specs.
    */ static fromSchema(schema) {
        return schema.cached.domSerializer || (schema.cached.domSerializer = new $b42367e7348c0623$export$3476b78f8f5a8b72(this.nodesFromSchema(schema), this.marksFromSchema(schema)));
    }
    /**
    Gather the serializers in a schema's node specs into an object.
    This can be useful as a base to build a custom serializer from.
    */ static nodesFromSchema(schema) {
        let result = $b42367e7348c0623$var$gatherToDOM(schema.nodes);
        if (!result.text) result.text = (node)=>node.text;
        return result;
    }
    /**
    Gather the serializers in a schema's mark specs into an object.
    */ static marksFromSchema(schema) {
        return $b42367e7348c0623$var$gatherToDOM(schema.marks);
    }
}
function $b42367e7348c0623$var$gatherToDOM(obj) {
    let result = {};
    for(let name in obj){
        let toDOM = obj[name].spec.toDOM;
        if (toDOM) result[name] = toDOM;
    }
    return result;
}
function $b42367e7348c0623$var$doc(options) {
    return options.document || window.document;
}
const $b42367e7348c0623$var$suspiciousAttributeCache = new WeakMap();
function $b42367e7348c0623$var$suspiciousAttributes(attrs) {
    let value = $b42367e7348c0623$var$suspiciousAttributeCache.get(attrs);
    if (value === undefined) $b42367e7348c0623$var$suspiciousAttributeCache.set(attrs, value = $b42367e7348c0623$var$suspiciousAttributesInner(attrs));
    return value;
}
function $b42367e7348c0623$var$suspiciousAttributesInner(attrs) {
    let result = null;
    function scan(value) {
        if (value && typeof value == "object") {
            if (Array.isArray(value)) {
                if (typeof value[0] == "string") {
                    if (!result) result = [];
                    result.push(value);
                } else for(let i = 0; i < value.length; i++)scan(value[i]);
            } else for(let prop in value)scan(value[prop]);
        }
    }
    scan(attrs);
    return result;
}
function $b42367e7348c0623$var$renderSpec(doc, structure, xmlNS, blockArraysIn) {
    if (typeof structure == "string") return {
        dom: doc.createTextNode(structure)
    };
    if (structure.nodeType != null) return {
        dom: structure
    };
    if (structure.dom && structure.dom.nodeType != null) return structure;
    let tagName = structure[0], suspicious;
    if (typeof tagName != "string") throw new RangeError("Invalid array passed to renderSpec");
    if (blockArraysIn && (suspicious = $b42367e7348c0623$var$suspiciousAttributes(blockArraysIn)) && suspicious.indexOf(structure) > -1) throw new RangeError("Using an array from an attribute object as a DOM spec. This may be an attempted cross site scripting attack.");
    let space = tagName.indexOf(" ");
    if (space > 0) {
        xmlNS = tagName.slice(0, space);
        tagName = tagName.slice(space + 1);
    }
    let contentDOM;
    let dom = xmlNS ? doc.createElementNS(xmlNS, tagName) : doc.createElement(tagName);
    let attrs = structure[1], start = 1;
    if (attrs && typeof attrs == "object" && attrs.nodeType == null && !Array.isArray(attrs)) {
        start = 2;
        for(let name in attrs)if (attrs[name] != null) {
            let space = name.indexOf(" ");
            if (space > 0) dom.setAttributeNS(name.slice(0, space), name.slice(space + 1), attrs[name]);
            else if (name == "style" && dom.style) dom.style.cssText = attrs[name];
            else dom.setAttribute(name, attrs[name]);
        }
    }
    for(let i = start; i < structure.length; i++){
        let child = structure[i];
        if (child === 0) {
            if (i < structure.length - 1 || i > start) throw new RangeError("Content hole must be the only child of its parent node");
            return {
                dom: dom,
                contentDOM: dom
            };
        } else {
            let { dom: inner, contentDOM: innerContent } = $b42367e7348c0623$var$renderSpec(doc, child, xmlNS, blockArraysIn);
            dom.appendChild(inner);
            if (innerContent) {
                if (contentDOM) throw new RangeError("Multiple content holes");
                contentDOM = innerContent;
            }
        }
    }
    return {
        dom: dom,
        contentDOM: contentDOM
    };
}

});

parcelRegister("kQFGJ", function(module, exports) {
$parcel$export(module.exports, "ReplaceStep", () => $f2d90061f2fecc2e$export$5c860b2e74034756);
$parcel$export(module.exports, "ReplaceAroundStep", () => $f2d90061f2fecc2e$export$444ba800d6024a98);
$parcel$export(module.exports, "Transform", () => $f2d90061f2fecc2e$export$563a914cafbdc389);

var $fsS3P = parcelRequire("fsS3P");
// Recovery values encode a range index and an offset. They are
// represented as numbers, because tons of them will be created when
// mapping, for example, a large number of decorations. The number's
// lower 16 bits provide the index, the remaining bits the offset.
//
// Note: We intentionally don't use bit shift operators to en- and
// decode these, since those clip to 32 bits, which we might in rare
// cases want to overflow. A 64-bit float can represent 48-bit
// integers precisely.
const $f2d90061f2fecc2e$var$lower16 = 0xffff;
const $f2d90061f2fecc2e$var$factor16 = Math.pow(2, 16);
function $f2d90061f2fecc2e$var$makeRecover(index, offset) {
    return index + offset * $f2d90061f2fecc2e$var$factor16;
}
function $f2d90061f2fecc2e$var$recoverIndex(value) {
    return value & $f2d90061f2fecc2e$var$lower16;
}
function $f2d90061f2fecc2e$var$recoverOffset(value) {
    return (value - (value & $f2d90061f2fecc2e$var$lower16)) / $f2d90061f2fecc2e$var$factor16;
}
const $f2d90061f2fecc2e$var$DEL_BEFORE = 1, $f2d90061f2fecc2e$var$DEL_AFTER = 2, $f2d90061f2fecc2e$var$DEL_ACROSS = 4, $f2d90061f2fecc2e$var$DEL_SIDE = 8;
/**
An object representing a mapped position with extra
information.
*/ class $f2d90061f2fecc2e$export$c77c9be41668e9b4 {
    /**
    @internal
    */ constructor(/**
    The mapped version of the position.
    */ pos, /**
    @internal
    */ delInfo, /**
    @internal
    */ recover){
        this.pos = pos;
        this.delInfo = delInfo;
        this.recover = recover;
    }
    /**
    Tells you whether the position was deleted, that is, whether the
    step removed the token on the side queried (via the `assoc`)
    argument from the document.
    */ get deleted() {
        return (this.delInfo & $f2d90061f2fecc2e$var$DEL_SIDE) > 0;
    }
    /**
    Tells you whether the token before the mapped position was deleted.
    */ get deletedBefore() {
        return (this.delInfo & ($f2d90061f2fecc2e$var$DEL_BEFORE | $f2d90061f2fecc2e$var$DEL_ACROSS)) > 0;
    }
    /**
    True when the token after the mapped position was deleted.
    */ get deletedAfter() {
        return (this.delInfo & ($f2d90061f2fecc2e$var$DEL_AFTER | $f2d90061f2fecc2e$var$DEL_ACROSS)) > 0;
    }
    /**
    Tells whether any of the steps mapped through deletes across the
    position (including both the token before and after the
    position).
    */ get deletedAcross() {
        return (this.delInfo & $f2d90061f2fecc2e$var$DEL_ACROSS) > 0;
    }
}
/**
A map describing the deletions and insertions made by a step, which
can be used to find the correspondence between positions in the
pre-step version of a document and the same position in the
post-step version.
*/ class $f2d90061f2fecc2e$export$c53d01c3ab9721b3 {
    /**
    Create a position map. The modifications to the document are
    represented as an array of numbers, in which each group of three
    represents a modified chunk as `[start, oldSize, newSize]`.
    */ constructor(/**
    @internal
    */ ranges, /**
    @internal
    */ inverted = false){
        this.ranges = ranges;
        this.inverted = inverted;
        if (!ranges.length && $f2d90061f2fecc2e$export$c53d01c3ab9721b3.empty) return $f2d90061f2fecc2e$export$c53d01c3ab9721b3.empty;
    }
    /**
    @internal
    */ recover(value) {
        let diff = 0, index = $f2d90061f2fecc2e$var$recoverIndex(value);
        if (!this.inverted) for(let i = 0; i < index; i++)diff += this.ranges[i * 3 + 2] - this.ranges[i * 3 + 1];
        return this.ranges[index * 3] + diff + $f2d90061f2fecc2e$var$recoverOffset(value);
    }
    mapResult(pos, assoc = 1) {
        return this._map(pos, assoc, false);
    }
    map(pos, assoc = 1) {
        return this._map(pos, assoc, true);
    }
    /**
    @internal
    */ _map(pos, assoc, simple) {
        let diff = 0, oldIndex = this.inverted ? 2 : 1, newIndex = this.inverted ? 1 : 2;
        for(let i = 0; i < this.ranges.length; i += 3){
            let start = this.ranges[i] - (this.inverted ? diff : 0);
            if (start > pos) break;
            let oldSize = this.ranges[i + oldIndex], newSize = this.ranges[i + newIndex], end = start + oldSize;
            if (pos <= end) {
                let side = !oldSize ? assoc : pos == start ? -1 : pos == end ? 1 : assoc;
                let result = start + diff + (side < 0 ? 0 : newSize);
                if (simple) return result;
                let recover = pos == (assoc < 0 ? start : end) ? null : $f2d90061f2fecc2e$var$makeRecover(i / 3, pos - start);
                let del = pos == start ? $f2d90061f2fecc2e$var$DEL_AFTER : pos == end ? $f2d90061f2fecc2e$var$DEL_BEFORE : $f2d90061f2fecc2e$var$DEL_ACROSS;
                if (assoc < 0 ? pos != start : pos != end) del |= $f2d90061f2fecc2e$var$DEL_SIDE;
                return new $f2d90061f2fecc2e$export$c77c9be41668e9b4(result, del, recover);
            }
            diff += newSize - oldSize;
        }
        return simple ? pos + diff : new $f2d90061f2fecc2e$export$c77c9be41668e9b4(pos + diff, 0, null);
    }
    /**
    @internal
    */ touches(pos, recover) {
        let diff = 0, index = $f2d90061f2fecc2e$var$recoverIndex(recover);
        let oldIndex = this.inverted ? 2 : 1, newIndex = this.inverted ? 1 : 2;
        for(let i = 0; i < this.ranges.length; i += 3){
            let start = this.ranges[i] - (this.inverted ? diff : 0);
            if (start > pos) break;
            let oldSize = this.ranges[i + oldIndex], end = start + oldSize;
            if (pos <= end && i == index * 3) return true;
            diff += this.ranges[i + newIndex] - oldSize;
        }
        return false;
    }
    /**
    Calls the given function on each of the changed ranges included in
    this map.
    */ forEach(f) {
        let oldIndex = this.inverted ? 2 : 1, newIndex = this.inverted ? 1 : 2;
        for(let i = 0, diff = 0; i < this.ranges.length; i += 3){
            let start = this.ranges[i], oldStart = start - (this.inverted ? diff : 0), newStart = start + (this.inverted ? 0 : diff);
            let oldSize = this.ranges[i + oldIndex], newSize = this.ranges[i + newIndex];
            f(oldStart, oldStart + oldSize, newStart, newStart + newSize);
            diff += newSize - oldSize;
        }
    }
    /**
    Create an inverted version of this map. The result can be used to
    map positions in the post-step document to the pre-step document.
    */ invert() {
        return new $f2d90061f2fecc2e$export$c53d01c3ab9721b3(this.ranges, !this.inverted);
    }
    /**
    @internal
    */ toString() {
        return (this.inverted ? "-" : "") + JSON.stringify(this.ranges);
    }
    /**
    Create a map that moves all positions by offset `n` (which may be
    negative). This can be useful when applying steps meant for a
    sub-document to a larger document, or vice-versa.
    */ static offset(n) {
        return n == 0 ? $f2d90061f2fecc2e$export$c53d01c3ab9721b3.empty : new $f2d90061f2fecc2e$export$c53d01c3ab9721b3(n < 0 ? [
            0,
            -n,
            0
        ] : [
            0,
            0,
            n
        ]);
    }
}
/**
A StepMap that contains no changed ranges.
*/ $f2d90061f2fecc2e$export$c53d01c3ab9721b3.empty = new $f2d90061f2fecc2e$export$c53d01c3ab9721b3([]);
/**
A mapping represents a pipeline of zero or more [step
maps](https://prosemirror.net/docs/ref/#transform.StepMap). It has special provisions for losslessly
handling mapping positions through a series of steps in which some
steps are inverted versions of earlier steps. (This comes up when
‘[rebasing](https://prosemirror.net/docs/guide/#transform.rebasing)’ steps for
collaboration or history management.)
*/ class $f2d90061f2fecc2e$export$f5f785078011b62 {
    /**
    Create a new mapping with the given position maps.
    */ constructor(maps, /**
    @internal
    */ mirror, /**
    The starting position in the `maps` array, used when `map` or
    `mapResult` is called.
    */ from = 0, /**
    The end position in the `maps` array.
    */ to = maps ? maps.length : 0){
        this.mirror = mirror;
        this.from = from;
        this.to = to;
        this._maps = maps || [];
        this.ownData = !(maps || mirror);
    }
    /**
    The step maps in this mapping.
    */ get maps() {
        return this._maps;
    }
    /**
    Create a mapping that maps only through a part of this one.
    */ slice(from = 0, to = this.maps.length) {
        return new $f2d90061f2fecc2e$export$f5f785078011b62(this._maps, this.mirror, from, to);
    }
    /**
    Add a step map to the end of this mapping. If `mirrors` is
    given, it should be the index of the step map that is the mirror
    image of this one.
    */ appendMap(map, mirrors) {
        if (!this.ownData) {
            this._maps = this._maps.slice();
            this.mirror = this.mirror && this.mirror.slice();
            this.ownData = true;
        }
        this.to = this._maps.push(map);
        if (mirrors != null) this.setMirror(this._maps.length - 1, mirrors);
    }
    /**
    Add all the step maps in a given mapping to this one (preserving
    mirroring information).
    */ appendMapping(mapping) {
        for(let i = 0, startSize = this._maps.length; i < mapping._maps.length; i++){
            let mirr = mapping.getMirror(i);
            this.appendMap(mapping._maps[i], mirr != null && mirr < i ? startSize + mirr : undefined);
        }
    }
    /**
    Finds the offset of the step map that mirrors the map at the
    given offset, in this mapping (as per the second argument to
    `appendMap`).
    */ getMirror(n) {
        if (this.mirror) {
            for(let i = 0; i < this.mirror.length; i++)if (this.mirror[i] == n) return this.mirror[i + (i % 2 ? -1 : 1)];
        }
    }
    /**
    @internal
    */ setMirror(n, m) {
        if (!this.mirror) this.mirror = [];
        this.mirror.push(n, m);
    }
    /**
    Append the inverse of the given mapping to this one.
    */ appendMappingInverted(mapping) {
        for(let i = mapping.maps.length - 1, totalSize = this._maps.length + mapping._maps.length; i >= 0; i--){
            let mirr = mapping.getMirror(i);
            this.appendMap(mapping._maps[i].invert(), mirr != null && mirr > i ? totalSize - mirr - 1 : undefined);
        }
    }
    /**
    Create an inverted version of this mapping.
    */ invert() {
        let inverse = new $f2d90061f2fecc2e$export$f5f785078011b62;
        inverse.appendMappingInverted(this);
        return inverse;
    }
    /**
    Map a position through this mapping.
    */ map(pos, assoc = 1) {
        if (this.mirror) return this._map(pos, assoc, true);
        for(let i = this.from; i < this.to; i++)pos = this._maps[i].map(pos, assoc);
        return pos;
    }
    /**
    Map a position through this mapping, returning a mapping
    result.
    */ mapResult(pos, assoc = 1) {
        return this._map(pos, assoc, false);
    }
    /**
    @internal
    */ _map(pos, assoc, simple) {
        let delInfo = 0;
        for(let i = this.from; i < this.to; i++){
            let map = this._maps[i], result = map.mapResult(pos, assoc);
            if (result.recover != null) {
                let corr = this.getMirror(i);
                if (corr != null && corr > i && corr < this.to) {
                    i = corr;
                    pos = this._maps[corr].recover(result.recover);
                    continue;
                }
            }
            delInfo |= result.delInfo;
            pos = result.pos;
        }
        return simple ? pos : new $f2d90061f2fecc2e$export$c77c9be41668e9b4(pos, delInfo, null);
    }
}
const $f2d90061f2fecc2e$var$stepsByID = Object.create(null);
/**
A step object represents an atomic change. It generally applies
only to the document it was created for, since the positions
stored in it will only make sense for that document.

New steps are defined by creating classes that extend `Step`,
overriding the `apply`, `invert`, `map`, `getMap` and `fromJSON`
methods, and registering your class with a unique
JSON-serialization identifier using
[`Step.jsonID`](https://prosemirror.net/docs/ref/#transform.Step^jsonID).
*/ class $f2d90061f2fecc2e$export$fd55ce593607084a {
    /**
    Get the step map that represents the changes made by this step,
    and which can be used to transform between positions in the old
    and the new document.
    */ getMap() {
        return $f2d90061f2fecc2e$export$c53d01c3ab9721b3.empty;
    }
    /**
    Try to merge this step with another one, to be applied directly
    after it. Returns the merged step when possible, null if the
    steps can't be merged.
    */ merge(other) {
        return null;
    }
    /**
    Deserialize a step from its JSON representation. Will call
    through to the step class' own implementation of this method.
    */ static fromJSON(schema, json) {
        if (!json || !json.stepType) throw new RangeError("Invalid input for Step.fromJSON");
        let type = $f2d90061f2fecc2e$var$stepsByID[json.stepType];
        if (!type) throw new RangeError(`No step type ${json.stepType} defined`);
        return type.fromJSON(schema, json);
    }
    /**
    To be able to serialize steps to JSON, each step needs a string
    ID to attach to its JSON representation. Use this method to
    register an ID for your step classes. Try to pick something
    that's unlikely to clash with steps from other modules.
    */ static jsonID(id, stepClass) {
        if (id in $f2d90061f2fecc2e$var$stepsByID) throw new RangeError("Duplicate use of step JSON ID " + id);
        $f2d90061f2fecc2e$var$stepsByID[id] = stepClass;
        stepClass.prototype.jsonID = id;
        return stepClass;
    }
}
/**
The result of [applying](https://prosemirror.net/docs/ref/#transform.Step.apply) a step. Contains either a
new document or a failure value.
*/ class $f2d90061f2fecc2e$export$8ebf1578a4199c09 {
    /**
    @internal
    */ constructor(/**
    The transformed document, if successful.
    */ doc, /**
    The failure message, if unsuccessful.
    */ failed){
        this.doc = doc;
        this.failed = failed;
    }
    /**
    Create a successful step result.
    */ static ok(doc) {
        return new $f2d90061f2fecc2e$export$8ebf1578a4199c09(doc, null);
    }
    /**
    Create a failed step result.
    */ static fail(message) {
        return new $f2d90061f2fecc2e$export$8ebf1578a4199c09(null, message);
    }
    /**
    Call [`Node.replace`](https://prosemirror.net/docs/ref/#model.Node.replace) with the given
    arguments. Create a successful result if it succeeds, and a
    failed one if it throws a `ReplaceError`.
    */ static fromReplace(doc, from, to, slice) {
        try {
            return $f2d90061f2fecc2e$export$8ebf1578a4199c09.ok(doc.replace(from, to, slice));
        } catch (e) {
            if (e instanceof (0, $fsS3P.ReplaceError)) return $f2d90061f2fecc2e$export$8ebf1578a4199c09.fail(e.message);
            throw e;
        }
    }
}
function $f2d90061f2fecc2e$var$mapFragment(fragment, f, parent) {
    let mapped = [];
    for(let i = 0; i < fragment.childCount; i++){
        let child = fragment.child(i);
        if (child.content.size) child = child.copy($f2d90061f2fecc2e$var$mapFragment(child.content, f, child));
        if (child.isInline) child = f(child, parent, i);
        mapped.push(child);
    }
    return (0, $fsS3P.Fragment).fromArray(mapped);
}
/**
Add a mark to all inline content between two positions.
*/ class $f2d90061f2fecc2e$export$d24ba56b0e3464a9 extends $f2d90061f2fecc2e$export$fd55ce593607084a {
    /**
    Create a mark step.
    */ constructor(/**
    The start of the marked range.
    */ from, /**
    The end of the marked range.
    */ to, /**
    The mark to add.
    */ mark){
        super();
        this.from = from;
        this.to = to;
        this.mark = mark;
    }
    apply(doc) {
        let oldSlice = doc.slice(this.from, this.to), $from = doc.resolve(this.from);
        let parent = $from.node($from.sharedDepth(this.to));
        let slice = new (0, $fsS3P.Slice)($f2d90061f2fecc2e$var$mapFragment(oldSlice.content, (node, parent)=>{
            if (!node.isAtom || !parent.type.allowsMarkType(this.mark.type)) return node;
            return node.mark(this.mark.addToSet(node.marks));
        }, parent), oldSlice.openStart, oldSlice.openEnd);
        return $f2d90061f2fecc2e$export$8ebf1578a4199c09.fromReplace(doc, this.from, this.to, slice);
    }
    invert() {
        return new $f2d90061f2fecc2e$export$94150db1311f67a9(this.from, this.to, this.mark);
    }
    map(mapping) {
        let from = mapping.mapResult(this.from, 1), to = mapping.mapResult(this.to, -1);
        if (from.deleted && to.deleted || from.pos >= to.pos) return null;
        return new $f2d90061f2fecc2e$export$d24ba56b0e3464a9(from.pos, to.pos, this.mark);
    }
    merge(other) {
        if (other instanceof $f2d90061f2fecc2e$export$d24ba56b0e3464a9 && other.mark.eq(this.mark) && this.from <= other.to && this.to >= other.from) return new $f2d90061f2fecc2e$export$d24ba56b0e3464a9(Math.min(this.from, other.from), Math.max(this.to, other.to), this.mark);
        return null;
    }
    toJSON() {
        return {
            stepType: "addMark",
            mark: this.mark.toJSON(),
            from: this.from,
            to: this.to
        };
    }
    /**
    @internal
    */ static fromJSON(schema, json) {
        if (typeof json.from != "number" || typeof json.to != "number") throw new RangeError("Invalid input for AddMarkStep.fromJSON");
        return new $f2d90061f2fecc2e$export$d24ba56b0e3464a9(json.from, json.to, schema.markFromJSON(json.mark));
    }
}
$f2d90061f2fecc2e$export$fd55ce593607084a.jsonID("addMark", $f2d90061f2fecc2e$export$d24ba56b0e3464a9);
/**
Remove a mark from all inline content between two positions.
*/ class $f2d90061f2fecc2e$export$94150db1311f67a9 extends $f2d90061f2fecc2e$export$fd55ce593607084a {
    /**
    Create a mark-removing step.
    */ constructor(/**
    The start of the unmarked range.
    */ from, /**
    The end of the unmarked range.
    */ to, /**
    The mark to remove.
    */ mark){
        super();
        this.from = from;
        this.to = to;
        this.mark = mark;
    }
    apply(doc) {
        let oldSlice = doc.slice(this.from, this.to);
        let slice = new (0, $fsS3P.Slice)($f2d90061f2fecc2e$var$mapFragment(oldSlice.content, (node)=>{
            return node.mark(this.mark.removeFromSet(node.marks));
        }, doc), oldSlice.openStart, oldSlice.openEnd);
        return $f2d90061f2fecc2e$export$8ebf1578a4199c09.fromReplace(doc, this.from, this.to, slice);
    }
    invert() {
        return new $f2d90061f2fecc2e$export$d24ba56b0e3464a9(this.from, this.to, this.mark);
    }
    map(mapping) {
        let from = mapping.mapResult(this.from, 1), to = mapping.mapResult(this.to, -1);
        if (from.deleted && to.deleted || from.pos >= to.pos) return null;
        return new $f2d90061f2fecc2e$export$94150db1311f67a9(from.pos, to.pos, this.mark);
    }
    merge(other) {
        if (other instanceof $f2d90061f2fecc2e$export$94150db1311f67a9 && other.mark.eq(this.mark) && this.from <= other.to && this.to >= other.from) return new $f2d90061f2fecc2e$export$94150db1311f67a9(Math.min(this.from, other.from), Math.max(this.to, other.to), this.mark);
        return null;
    }
    toJSON() {
        return {
            stepType: "removeMark",
            mark: this.mark.toJSON(),
            from: this.from,
            to: this.to
        };
    }
    /**
    @internal
    */ static fromJSON(schema, json) {
        if (typeof json.from != "number" || typeof json.to != "number") throw new RangeError("Invalid input for RemoveMarkStep.fromJSON");
        return new $f2d90061f2fecc2e$export$94150db1311f67a9(json.from, json.to, schema.markFromJSON(json.mark));
    }
}
$f2d90061f2fecc2e$export$fd55ce593607084a.jsonID("removeMark", $f2d90061f2fecc2e$export$94150db1311f67a9);
/**
Add a mark to a specific node.
*/ class $f2d90061f2fecc2e$export$adefd16c402fee4e extends $f2d90061f2fecc2e$export$fd55ce593607084a {
    /**
    Create a node mark step.
    */ constructor(/**
    The position of the target node.
    */ pos, /**
    The mark to add.
    */ mark){
        super();
        this.pos = pos;
        this.mark = mark;
    }
    apply(doc) {
        let node = doc.nodeAt(this.pos);
        if (!node) return $f2d90061f2fecc2e$export$8ebf1578a4199c09.fail("No node at mark step's position");
        let updated = node.type.create(node.attrs, null, this.mark.addToSet(node.marks));
        return $f2d90061f2fecc2e$export$8ebf1578a4199c09.fromReplace(doc, this.pos, this.pos + 1, new (0, $fsS3P.Slice)((0, $fsS3P.Fragment).from(updated), 0, node.isLeaf ? 0 : 1));
    }
    invert(doc) {
        let node = doc.nodeAt(this.pos);
        if (node) {
            let newSet = this.mark.addToSet(node.marks);
            if (newSet.length == node.marks.length) {
                for(let i = 0; i < node.marks.length; i++)if (!node.marks[i].isInSet(newSet)) return new $f2d90061f2fecc2e$export$adefd16c402fee4e(this.pos, node.marks[i]);
                return new $f2d90061f2fecc2e$export$adefd16c402fee4e(this.pos, this.mark);
            }
        }
        return new $f2d90061f2fecc2e$export$fdf7d1dc10724da2(this.pos, this.mark);
    }
    map(mapping) {
        let pos = mapping.mapResult(this.pos, 1);
        return pos.deletedAfter ? null : new $f2d90061f2fecc2e$export$adefd16c402fee4e(pos.pos, this.mark);
    }
    toJSON() {
        return {
            stepType: "addNodeMark",
            pos: this.pos,
            mark: this.mark.toJSON()
        };
    }
    /**
    @internal
    */ static fromJSON(schema, json) {
        if (typeof json.pos != "number") throw new RangeError("Invalid input for AddNodeMarkStep.fromJSON");
        return new $f2d90061f2fecc2e$export$adefd16c402fee4e(json.pos, schema.markFromJSON(json.mark));
    }
}
$f2d90061f2fecc2e$export$fd55ce593607084a.jsonID("addNodeMark", $f2d90061f2fecc2e$export$adefd16c402fee4e);
/**
Remove a mark from a specific node.
*/ class $f2d90061f2fecc2e$export$fdf7d1dc10724da2 extends $f2d90061f2fecc2e$export$fd55ce593607084a {
    /**
    Create a mark-removing step.
    */ constructor(/**
    The position of the target node.
    */ pos, /**
    The mark to remove.
    */ mark){
        super();
        this.pos = pos;
        this.mark = mark;
    }
    apply(doc) {
        let node = doc.nodeAt(this.pos);
        if (!node) return $f2d90061f2fecc2e$export$8ebf1578a4199c09.fail("No node at mark step's position");
        let updated = node.type.create(node.attrs, null, this.mark.removeFromSet(node.marks));
        return $f2d90061f2fecc2e$export$8ebf1578a4199c09.fromReplace(doc, this.pos, this.pos + 1, new (0, $fsS3P.Slice)((0, $fsS3P.Fragment).from(updated), 0, node.isLeaf ? 0 : 1));
    }
    invert(doc) {
        let node = doc.nodeAt(this.pos);
        if (!node || !this.mark.isInSet(node.marks)) return this;
        return new $f2d90061f2fecc2e$export$adefd16c402fee4e(this.pos, this.mark);
    }
    map(mapping) {
        let pos = mapping.mapResult(this.pos, 1);
        return pos.deletedAfter ? null : new $f2d90061f2fecc2e$export$fdf7d1dc10724da2(pos.pos, this.mark);
    }
    toJSON() {
        return {
            stepType: "removeNodeMark",
            pos: this.pos,
            mark: this.mark.toJSON()
        };
    }
    /**
    @internal
    */ static fromJSON(schema, json) {
        if (typeof json.pos != "number") throw new RangeError("Invalid input for RemoveNodeMarkStep.fromJSON");
        return new $f2d90061f2fecc2e$export$fdf7d1dc10724da2(json.pos, schema.markFromJSON(json.mark));
    }
}
$f2d90061f2fecc2e$export$fd55ce593607084a.jsonID("removeNodeMark", $f2d90061f2fecc2e$export$fdf7d1dc10724da2);
/**
Replace a part of the document with a slice of new content.
*/ class $f2d90061f2fecc2e$export$5c860b2e74034756 extends $f2d90061f2fecc2e$export$fd55ce593607084a {
    /**
    The given `slice` should fit the 'gap' between `from` and
    `to`—the depths must line up, and the surrounding nodes must be
    able to be joined with the open sides of the slice. When
    `structure` is true, the step will fail if the content between
    from and to is not just a sequence of closing and then opening
    tokens (this is to guard against rebased replace steps
    overwriting something they weren't supposed to).
    */ constructor(/**
    The start position of the replaced range.
    */ from, /**
    The end position of the replaced range.
    */ to, /**
    The slice to insert.
    */ slice, /**
    @internal
    */ structure = false){
        super();
        this.from = from;
        this.to = to;
        this.slice = slice;
        this.structure = structure;
    }
    apply(doc) {
        if (this.structure && $f2d90061f2fecc2e$var$contentBetween(doc, this.from, this.to)) return $f2d90061f2fecc2e$export$8ebf1578a4199c09.fail("Structure replace would overwrite content");
        return $f2d90061f2fecc2e$export$8ebf1578a4199c09.fromReplace(doc, this.from, this.to, this.slice);
    }
    getMap() {
        return new $f2d90061f2fecc2e$export$c53d01c3ab9721b3([
            this.from,
            this.to - this.from,
            this.slice.size
        ]);
    }
    invert(doc) {
        return new $f2d90061f2fecc2e$export$5c860b2e74034756(this.from, this.from + this.slice.size, doc.slice(this.from, this.to));
    }
    map(mapping) {
        let from = mapping.mapResult(this.from, 1), to = mapping.mapResult(this.to, -1);
        if (from.deletedAcross && to.deletedAcross) return null;
        return new $f2d90061f2fecc2e$export$5c860b2e74034756(from.pos, Math.max(from.pos, to.pos), this.slice, this.structure);
    }
    merge(other) {
        if (!(other instanceof $f2d90061f2fecc2e$export$5c860b2e74034756) || other.structure || this.structure) return null;
        if (this.from + this.slice.size == other.from && !this.slice.openEnd && !other.slice.openStart) {
            let slice = this.slice.size + other.slice.size == 0 ? (0, $fsS3P.Slice).empty : new (0, $fsS3P.Slice)(this.slice.content.append(other.slice.content), this.slice.openStart, other.slice.openEnd);
            return new $f2d90061f2fecc2e$export$5c860b2e74034756(this.from, this.to + (other.to - other.from), slice, this.structure);
        } else if (other.to == this.from && !this.slice.openStart && !other.slice.openEnd) {
            let slice = this.slice.size + other.slice.size == 0 ? (0, $fsS3P.Slice).empty : new (0, $fsS3P.Slice)(other.slice.content.append(this.slice.content), other.slice.openStart, this.slice.openEnd);
            return new $f2d90061f2fecc2e$export$5c860b2e74034756(other.from, this.to, slice, this.structure);
        } else return null;
    }
    toJSON() {
        let json = {
            stepType: "replace",
            from: this.from,
            to: this.to
        };
        if (this.slice.size) json.slice = this.slice.toJSON();
        if (this.structure) json.structure = true;
        return json;
    }
    /**
    @internal
    */ static fromJSON(schema, json) {
        if (typeof json.from != "number" || typeof json.to != "number") throw new RangeError("Invalid input for ReplaceStep.fromJSON");
        return new $f2d90061f2fecc2e$export$5c860b2e74034756(json.from, json.to, (0, $fsS3P.Slice).fromJSON(schema, json.slice), !!json.structure);
    }
}
$f2d90061f2fecc2e$export$fd55ce593607084a.jsonID("replace", $f2d90061f2fecc2e$export$5c860b2e74034756);
/**
Replace a part of the document with a slice of content, but
preserve a range of the replaced content by moving it into the
slice.
*/ class $f2d90061f2fecc2e$export$444ba800d6024a98 extends $f2d90061f2fecc2e$export$fd55ce593607084a {
    /**
    Create a replace-around step with the given range and gap.
    `insert` should be the point in the slice into which the content
    of the gap should be moved. `structure` has the same meaning as
    it has in the [`ReplaceStep`](https://prosemirror.net/docs/ref/#transform.ReplaceStep) class.
    */ constructor(/**
    The start position of the replaced range.
    */ from, /**
    The end position of the replaced range.
    */ to, /**
    The start of preserved range.
    */ gapFrom, /**
    The end of preserved range.
    */ gapTo, /**
    The slice to insert.
    */ slice, /**
    The position in the slice where the preserved range should be
    inserted.
    */ insert, /**
    @internal
    */ structure = false){
        super();
        this.from = from;
        this.to = to;
        this.gapFrom = gapFrom;
        this.gapTo = gapTo;
        this.slice = slice;
        this.insert = insert;
        this.structure = structure;
    }
    apply(doc) {
        if (this.structure && ($f2d90061f2fecc2e$var$contentBetween(doc, this.from, this.gapFrom) || $f2d90061f2fecc2e$var$contentBetween(doc, this.gapTo, this.to))) return $f2d90061f2fecc2e$export$8ebf1578a4199c09.fail("Structure gap-replace would overwrite content");
        let gap = doc.slice(this.gapFrom, this.gapTo);
        if (gap.openStart || gap.openEnd) return $f2d90061f2fecc2e$export$8ebf1578a4199c09.fail("Gap is not a flat range");
        let inserted = this.slice.insertAt(this.insert, gap.content);
        if (!inserted) return $f2d90061f2fecc2e$export$8ebf1578a4199c09.fail("Content does not fit in gap");
        return $f2d90061f2fecc2e$export$8ebf1578a4199c09.fromReplace(doc, this.from, this.to, inserted);
    }
    getMap() {
        return new $f2d90061f2fecc2e$export$c53d01c3ab9721b3([
            this.from,
            this.gapFrom - this.from,
            this.insert,
            this.gapTo,
            this.to - this.gapTo,
            this.slice.size - this.insert
        ]);
    }
    invert(doc) {
        let gap = this.gapTo - this.gapFrom;
        return new $f2d90061f2fecc2e$export$444ba800d6024a98(this.from, this.from + this.slice.size + gap, this.from + this.insert, this.from + this.insert + gap, doc.slice(this.from, this.to).removeBetween(this.gapFrom - this.from, this.gapTo - this.from), this.gapFrom - this.from, this.structure);
    }
    map(mapping) {
        let from = mapping.mapResult(this.from, 1), to = mapping.mapResult(this.to, -1);
        let gapFrom = this.from == this.gapFrom ? from.pos : mapping.map(this.gapFrom, -1);
        let gapTo = this.to == this.gapTo ? to.pos : mapping.map(this.gapTo, 1);
        if (from.deletedAcross && to.deletedAcross || gapFrom < from.pos || gapTo > to.pos) return null;
        return new $f2d90061f2fecc2e$export$444ba800d6024a98(from.pos, to.pos, gapFrom, gapTo, this.slice, this.insert, this.structure);
    }
    toJSON() {
        let json = {
            stepType: "replaceAround",
            from: this.from,
            to: this.to,
            gapFrom: this.gapFrom,
            gapTo: this.gapTo,
            insert: this.insert
        };
        if (this.slice.size) json.slice = this.slice.toJSON();
        if (this.structure) json.structure = true;
        return json;
    }
    /**
    @internal
    */ static fromJSON(schema, json) {
        if (typeof json.from != "number" || typeof json.to != "number" || typeof json.gapFrom != "number" || typeof json.gapTo != "number" || typeof json.insert != "number") throw new RangeError("Invalid input for ReplaceAroundStep.fromJSON");
        return new $f2d90061f2fecc2e$export$444ba800d6024a98(json.from, json.to, json.gapFrom, json.gapTo, (0, $fsS3P.Slice).fromJSON(schema, json.slice), json.insert, !!json.structure);
    }
}
$f2d90061f2fecc2e$export$fd55ce593607084a.jsonID("replaceAround", $f2d90061f2fecc2e$export$444ba800d6024a98);
function $f2d90061f2fecc2e$var$contentBetween(doc, from, to) {
    let $from = doc.resolve(from), dist = to - from, depth = $from.depth;
    while(dist > 0 && depth > 0 && $from.indexAfter(depth) == $from.node(depth).childCount){
        depth--;
        dist--;
    }
    if (dist > 0) {
        let next = $from.node(depth).maybeChild($from.indexAfter(depth));
        while(dist > 0){
            if (!next || next.isLeaf) return true;
            next = next.firstChild;
            dist--;
        }
    }
    return false;
}
function $f2d90061f2fecc2e$var$addMark(tr, from, to, mark) {
    let removed = [], added = [];
    let removing, adding;
    tr.doc.nodesBetween(from, to, (node, pos, parent)=>{
        if (!node.isInline) return;
        let marks = node.marks;
        if (!mark.isInSet(marks) && parent.type.allowsMarkType(mark.type)) {
            let start = Math.max(pos, from), end = Math.min(pos + node.nodeSize, to);
            let newSet = mark.addToSet(marks);
            for(let i = 0; i < marks.length; i++)if (!marks[i].isInSet(newSet)) {
                if (removing && removing.to == start && removing.mark.eq(marks[i])) removing.to = end;
                else removed.push(removing = new $f2d90061f2fecc2e$export$94150db1311f67a9(start, end, marks[i]));
            }
            if (adding && adding.to == start) adding.to = end;
            else added.push(adding = new $f2d90061f2fecc2e$export$d24ba56b0e3464a9(start, end, mark));
        }
    });
    removed.forEach((s)=>tr.step(s));
    added.forEach((s)=>tr.step(s));
}
function $f2d90061f2fecc2e$var$removeMark(tr, from, to, mark) {
    let matched = [], step = 0;
    tr.doc.nodesBetween(from, to, (node, pos)=>{
        if (!node.isInline) return;
        step++;
        let toRemove = null;
        if (mark instanceof (0, $fsS3P.MarkType)) {
            let set = node.marks, found;
            while(found = mark.isInSet(set)){
                (toRemove || (toRemove = [])).push(found);
                set = found.removeFromSet(set);
            }
        } else if (mark) {
            if (mark.isInSet(node.marks)) toRemove = [
                mark
            ];
        } else toRemove = node.marks;
        if (toRemove && toRemove.length) {
            let end = Math.min(pos + node.nodeSize, to);
            for(let i = 0; i < toRemove.length; i++){
                let style = toRemove[i], found;
                for(let j = 0; j < matched.length; j++){
                    let m = matched[j];
                    if (m.step == step - 1 && style.eq(matched[j].style)) found = m;
                }
                if (found) {
                    found.to = end;
                    found.step = step;
                } else matched.push({
                    style: style,
                    from: Math.max(pos, from),
                    to: end,
                    step: step
                });
            }
        }
    });
    matched.forEach((m)=>tr.step(new $f2d90061f2fecc2e$export$94150db1311f67a9(m.from, m.to, m.style)));
}
function $f2d90061f2fecc2e$var$clearIncompatible(tr, pos, parentType, match = parentType.contentMatch, clearNewlines = true) {
    let node = tr.doc.nodeAt(pos);
    let replSteps = [], cur = pos + 1;
    for(let i = 0; i < node.childCount; i++){
        let child = node.child(i), end = cur + child.nodeSize;
        let allowed = match.matchType(child.type);
        if (!allowed) replSteps.push(new $f2d90061f2fecc2e$export$5c860b2e74034756(cur, end, (0, $fsS3P.Slice).empty));
        else {
            match = allowed;
            for(let j = 0; j < child.marks.length; j++)if (!parentType.allowsMarkType(child.marks[j].type)) tr.step(new $f2d90061f2fecc2e$export$94150db1311f67a9(cur, end, child.marks[j]));
            if (clearNewlines && child.isText && parentType.whitespace != "pre") {
                let m, newline = /\r?\n|\r/g, slice;
                while(m = newline.exec(child.text)){
                    if (!slice) slice = new (0, $fsS3P.Slice)((0, $fsS3P.Fragment).from(parentType.schema.text(" ", parentType.allowedMarks(child.marks))), 0, 0);
                    replSteps.push(new $f2d90061f2fecc2e$export$5c860b2e74034756(cur + m.index, cur + m.index + m[0].length, slice));
                }
            }
        }
        cur = end;
    }
    if (!match.validEnd) {
        let fill = match.fillBefore((0, $fsS3P.Fragment).empty, true);
        tr.replace(cur, cur, new (0, $fsS3P.Slice)(fill, 0, 0));
    }
    for(let i = replSteps.length - 1; i >= 0; i--)tr.step(replSteps[i]);
}
function $f2d90061f2fecc2e$var$canCut(node, start, end) {
    return (start == 0 || node.canReplace(start, node.childCount)) && (end == node.childCount || node.canReplace(0, end));
}
/**
Try to find a target depth to which the content in the given range
can be lifted. Will not go across
[isolating](https://prosemirror.net/docs/ref/#model.NodeSpec.isolating) parent nodes.
*/ function $f2d90061f2fecc2e$export$f1508b72cc76a09e(range) {
    let parent = range.parent;
    let content = parent.content.cutByIndex(range.startIndex, range.endIndex);
    for(let depth = range.depth, contentBefore = 0, contentAfter = 0;; --depth){
        let node = range.$from.node(depth);
        let index = range.$from.index(depth) + contentBefore, endIndex = range.$to.indexAfter(depth) - contentAfter;
        if (depth < range.depth && node.canReplace(index, endIndex, content)) return depth;
        if (depth == 0 || node.type.spec.isolating || !$f2d90061f2fecc2e$var$canCut(node, index, endIndex)) break;
        if (index) contentBefore = 1;
        if (endIndex < node.childCount) contentAfter = 1;
    }
    return null;
}
function $f2d90061f2fecc2e$var$lift(tr, range, target) {
    let { $from: $from, $to: $to, depth: depth } = range;
    let gapStart = $from.before(depth + 1), gapEnd = $to.after(depth + 1);
    let start = gapStart, end = gapEnd;
    let before = (0, $fsS3P.Fragment).empty, openStart = 0;
    for(let d = depth, splitting = false; d > target; d--)if (splitting || $from.index(d) > 0) {
        splitting = true;
        before = (0, $fsS3P.Fragment).from($from.node(d).copy(before));
        openStart++;
    } else start--;
    let after = (0, $fsS3P.Fragment).empty, openEnd = 0;
    for(let d = depth, splitting = false; d > target; d--)if (splitting || $to.after(d + 1) < $to.end(d)) {
        splitting = true;
        after = (0, $fsS3P.Fragment).from($to.node(d).copy(after));
        openEnd++;
    } else end++;
    tr.step(new $f2d90061f2fecc2e$export$444ba800d6024a98(start, end, gapStart, gapEnd, new (0, $fsS3P.Slice)(before.append(after), openStart, openEnd), before.size - openStart, true));
}
/**
Try to find a valid way to wrap the content in the given range in a
node of the given type. May introduce extra nodes around and inside
the wrapper node, if necessary. Returns null if no valid wrapping
could be found. When `innerRange` is given, that range's content is
used as the content to fit into the wrapping, instead of the
content of `range`.
*/ function $f2d90061f2fecc2e$export$118cb9a83e81ba37(range, nodeType, attrs = null, innerRange = range) {
    let around = $f2d90061f2fecc2e$var$findWrappingOutside(range, nodeType);
    let inner = around && $f2d90061f2fecc2e$var$findWrappingInside(innerRange, nodeType);
    if (!inner) return null;
    return around.map($f2d90061f2fecc2e$var$withAttrs).concat({
        type: nodeType,
        attrs: attrs
    }).concat(inner.map($f2d90061f2fecc2e$var$withAttrs));
}
function $f2d90061f2fecc2e$var$withAttrs(type) {
    return {
        type: type,
        attrs: null
    };
}
function $f2d90061f2fecc2e$var$findWrappingOutside(range, type) {
    let { parent: parent, startIndex: startIndex, endIndex: endIndex } = range;
    let around = parent.contentMatchAt(startIndex).findWrapping(type);
    if (!around) return null;
    let outer = around.length ? around[0] : type;
    return parent.canReplaceWith(startIndex, endIndex, outer) ? around : null;
}
function $f2d90061f2fecc2e$var$findWrappingInside(range, type) {
    let { parent: parent, startIndex: startIndex, endIndex: endIndex } = range;
    let inner = parent.child(startIndex);
    let inside = type.contentMatch.findWrapping(inner.type);
    if (!inside) return null;
    let lastType = inside.length ? inside[inside.length - 1] : type;
    let innerMatch = lastType.contentMatch;
    for(let i = startIndex; innerMatch && i < endIndex; i++)innerMatch = innerMatch.matchType(parent.child(i).type);
    if (!innerMatch || !innerMatch.validEnd) return null;
    return inside;
}
function $f2d90061f2fecc2e$var$wrap(tr, range, wrappers) {
    let content = (0, $fsS3P.Fragment).empty;
    for(let i = wrappers.length - 1; i >= 0; i--){
        if (content.size) {
            let match = wrappers[i].type.contentMatch.matchFragment(content);
            if (!match || !match.validEnd) throw new RangeError("Wrapper type given to Transform.wrap does not form valid content of its parent wrapper");
        }
        content = (0, $fsS3P.Fragment).from(wrappers[i].type.create(wrappers[i].attrs, content));
    }
    let start = range.start, end = range.end;
    tr.step(new $f2d90061f2fecc2e$export$444ba800d6024a98(start, end, start, end, new (0, $fsS3P.Slice)(content, 0, 0), wrappers.length, true));
}
function $f2d90061f2fecc2e$var$setBlockType(tr, from, to, type, attrs) {
    if (!type.isTextblock) throw new RangeError("Type given to setBlockType should be a textblock");
    let mapFrom = tr.steps.length;
    tr.doc.nodesBetween(from, to, (node, pos)=>{
        let attrsHere = typeof attrs == "function" ? attrs(node) : attrs;
        if (node.isTextblock && !node.hasMarkup(type, attrsHere) && $f2d90061f2fecc2e$var$canChangeType(tr.doc, tr.mapping.slice(mapFrom).map(pos), type)) {
            let convertNewlines = null;
            if (type.schema.linebreakReplacement) {
                let pre = type.whitespace == "pre", supportLinebreak = !!type.contentMatch.matchType(type.schema.linebreakReplacement);
                if (pre && !supportLinebreak) convertNewlines = false;
                else if (!pre && supportLinebreak) convertNewlines = true;
            }
            // Ensure all markup that isn't allowed in the new node type is cleared
            if (convertNewlines === false) $f2d90061f2fecc2e$var$replaceLinebreaks(tr, node, pos, mapFrom);
            $f2d90061f2fecc2e$var$clearIncompatible(tr, tr.mapping.slice(mapFrom).map(pos, 1), type, undefined, convertNewlines === null);
            let mapping = tr.mapping.slice(mapFrom);
            let startM = mapping.map(pos, 1), endM = mapping.map(pos + node.nodeSize, 1);
            tr.step(new $f2d90061f2fecc2e$export$444ba800d6024a98(startM, endM, startM + 1, endM - 1, new (0, $fsS3P.Slice)((0, $fsS3P.Fragment).from(type.create(attrsHere, null, node.marks)), 0, 0), 1, true));
            if (convertNewlines === true) $f2d90061f2fecc2e$var$replaceNewlines(tr, node, pos, mapFrom);
            return false;
        }
    });
}
function $f2d90061f2fecc2e$var$replaceNewlines(tr, node, pos, mapFrom) {
    node.forEach((child, offset)=>{
        if (child.isText) {
            let m, newline = /\r?\n|\r/g;
            while(m = newline.exec(child.text)){
                let start = tr.mapping.slice(mapFrom).map(pos + 1 + offset + m.index);
                tr.replaceWith(start, start + 1, node.type.schema.linebreakReplacement.create());
            }
        }
    });
}
function $f2d90061f2fecc2e$var$replaceLinebreaks(tr, node, pos, mapFrom) {
    node.forEach((child, offset)=>{
        if (child.type == child.type.schema.linebreakReplacement) {
            let start = tr.mapping.slice(mapFrom).map(pos + 1 + offset);
            tr.replaceWith(start, start + 1, node.type.schema.text("\n"));
        }
    });
}
function $f2d90061f2fecc2e$var$canChangeType(doc, pos, type) {
    let $pos = doc.resolve(pos), index = $pos.index();
    return $pos.parent.canReplaceWith(index, index + 1, type);
}
/**
Change the type, attributes, and/or marks of the node at `pos`.
When `type` isn't given, the existing node type is preserved,
*/ function $f2d90061f2fecc2e$var$setNodeMarkup(tr, pos, type, attrs, marks) {
    let node = tr.doc.nodeAt(pos);
    if (!node) throw new RangeError("No node at given position");
    if (!type) type = node.type;
    let newNode = type.create(attrs, null, marks || node.marks);
    if (node.isLeaf) return tr.replaceWith(pos, pos + node.nodeSize, newNode);
    if (!type.validContent(node.content)) throw new RangeError("Invalid content for node type " + type.name);
    tr.step(new $f2d90061f2fecc2e$export$444ba800d6024a98(pos, pos + node.nodeSize, pos + 1, pos + node.nodeSize - 1, new (0, $fsS3P.Slice)((0, $fsS3P.Fragment).from(newNode), 0, 0), 1, true));
}
/**
Check whether splitting at the given position is allowed.
*/ function $f2d90061f2fecc2e$export$5aaf008897aef029(doc, pos, depth = 1, typesAfter) {
    let $pos = doc.resolve(pos), base = $pos.depth - depth;
    let innerType = typesAfter && typesAfter[typesAfter.length - 1] || $pos.parent;
    if (base < 0 || $pos.parent.type.spec.isolating || !$pos.parent.canReplace($pos.index(), $pos.parent.childCount) || !innerType.type.validContent($pos.parent.content.cutByIndex($pos.index(), $pos.parent.childCount))) return false;
    for(let d = $pos.depth - 1, i = depth - 2; d > base; d--, i--){
        let node = $pos.node(d), index = $pos.index(d);
        if (node.type.spec.isolating) return false;
        let rest = node.content.cutByIndex(index, node.childCount);
        let overrideChild = typesAfter && typesAfter[i + 1];
        if (overrideChild) rest = rest.replaceChild(0, overrideChild.type.create(overrideChild.attrs));
        let after = typesAfter && typesAfter[i] || node;
        if (!node.canReplace(index + 1, node.childCount) || !after.type.validContent(rest)) return false;
    }
    let index = $pos.indexAfter(base);
    let baseType = typesAfter && typesAfter[0];
    return $pos.node(base).canReplaceWith(index, index, baseType ? baseType.type : $pos.node(base + 1).type);
}
function $f2d90061f2fecc2e$var$split(tr, pos, depth = 1, typesAfter) {
    let $pos = tr.doc.resolve(pos), before = (0, $fsS3P.Fragment).empty, after = (0, $fsS3P.Fragment).empty;
    for(let d = $pos.depth, e = $pos.depth - depth, i = depth - 1; d > e; d--, i--){
        before = (0, $fsS3P.Fragment).from($pos.node(d).copy(before));
        let typeAfter = typesAfter && typesAfter[i];
        after = (0, $fsS3P.Fragment).from(typeAfter ? typeAfter.type.create(typeAfter.attrs, after) : $pos.node(d).copy(after));
    }
    tr.step(new $f2d90061f2fecc2e$export$5c860b2e74034756(pos, pos, new (0, $fsS3P.Slice)(before.append(after), depth, depth), true));
}
/**
Test whether the blocks before and after a given position can be
joined.
*/ function $f2d90061f2fecc2e$export$f15f89fd9d8cc98a(doc, pos) {
    let $pos = doc.resolve(pos), index = $pos.index();
    return $f2d90061f2fecc2e$var$joinable($pos.nodeBefore, $pos.nodeAfter) && $pos.parent.canReplace(index, index + 1);
}
function $f2d90061f2fecc2e$var$canAppendWithSubstitutedLinebreaks(a, b) {
    if (!b.content.size) a.type.compatibleContent(b.type);
    let match = a.contentMatchAt(a.childCount);
    let { linebreakReplacement: linebreakReplacement } = a.type.schema;
    for(let i = 0; i < b.childCount; i++){
        let child = b.child(i);
        let type = child.type == linebreakReplacement ? a.type.schema.nodes.text : child.type;
        match = match.matchType(type);
        if (!match) return false;
        if (!a.type.allowsMarks(child.marks)) return false;
    }
    return match.validEnd;
}
function $f2d90061f2fecc2e$var$joinable(a, b) {
    return !!(a && b && !a.isLeaf && $f2d90061f2fecc2e$var$canAppendWithSubstitutedLinebreaks(a, b));
}
/**
Find an ancestor of the given position that can be joined to the
block before (or after if `dir` is positive). Returns the joinable
point, if any.
*/ function $f2d90061f2fecc2e$export$41b1d4cb5ceb3147(doc, pos, dir = -1) {
    let $pos = doc.resolve(pos);
    for(let d = $pos.depth;; d--){
        let before, after, index = $pos.index(d);
        if (d == $pos.depth) {
            before = $pos.nodeBefore;
            after = $pos.nodeAfter;
        } else if (dir > 0) {
            before = $pos.node(d + 1);
            index++;
            after = $pos.node(d).maybeChild(index);
        } else {
            before = $pos.node(d).maybeChild(index - 1);
            after = $pos.node(d + 1);
        }
        if (before && !before.isTextblock && $f2d90061f2fecc2e$var$joinable(before, after) && $pos.node(d).canReplace(index, index + 1)) return pos;
        if (d == 0) break;
        pos = dir < 0 ? $pos.before(d) : $pos.after(d);
    }
}
function $f2d90061f2fecc2e$var$join(tr, pos, depth) {
    let convertNewlines = null;
    let { linebreakReplacement: linebreakReplacement } = tr.doc.type.schema;
    let $before = tr.doc.resolve(pos - depth), beforeType = $before.node().type;
    if (linebreakReplacement && beforeType.inlineContent) {
        let pre = beforeType.whitespace == "pre";
        let supportLinebreak = !!beforeType.contentMatch.matchType(linebreakReplacement);
        if (pre && !supportLinebreak) convertNewlines = false;
        else if (!pre && supportLinebreak) convertNewlines = true;
    }
    let mapFrom = tr.steps.length;
    if (convertNewlines === false) {
        let $after = tr.doc.resolve(pos + depth);
        $f2d90061f2fecc2e$var$replaceLinebreaks(tr, $after.node(), $after.before(), mapFrom);
    }
    if (beforeType.inlineContent) $f2d90061f2fecc2e$var$clearIncompatible(tr, pos + depth - 1, beforeType, $before.node().contentMatchAt($before.index()), convertNewlines == null);
    let mapping = tr.mapping.slice(mapFrom), start = mapping.map(pos - depth);
    tr.step(new $f2d90061f2fecc2e$export$5c860b2e74034756(start, mapping.map(pos + depth, -1), (0, $fsS3P.Slice).empty, true));
    if (convertNewlines === true) {
        let $full = tr.doc.resolve(start);
        $f2d90061f2fecc2e$var$replaceNewlines(tr, $full.node(), $full.before(), tr.steps.length);
    }
    return tr;
}
/**
Try to find a point where a node of the given type can be inserted
near `pos`, by searching up the node hierarchy when `pos` itself
isn't a valid place but is at the start or end of a node. Return
null if no position was found.
*/ function $f2d90061f2fecc2e$export$64cb316d02de1dd1(doc, pos, nodeType) {
    let $pos = doc.resolve(pos);
    if ($pos.parent.canReplaceWith($pos.index(), $pos.index(), nodeType)) return pos;
    if ($pos.parentOffset == 0) for(let d = $pos.depth - 1; d >= 0; d--){
        let index = $pos.index(d);
        if ($pos.node(d).canReplaceWith(index, index, nodeType)) return $pos.before(d + 1);
        if (index > 0) return null;
    }
    if ($pos.parentOffset == $pos.parent.content.size) for(let d = $pos.depth - 1; d >= 0; d--){
        let index = $pos.indexAfter(d);
        if ($pos.node(d).canReplaceWith(index, index, nodeType)) return $pos.after(d + 1);
        if (index < $pos.node(d).childCount) return null;
    }
    return null;
}
/**
Finds a position at or around the given position where the given
slice can be inserted. Will look at parent nodes' nearest boundary
and try there, even if the original position wasn't directly at the
start or end of that node. Returns null when no position was found.
*/ function $f2d90061f2fecc2e$export$2819d598d048fc9c(doc, pos, slice) {
    let $pos = doc.resolve(pos);
    if (!slice.content.size) return pos;
    let content = slice.content;
    for(let i = 0; i < slice.openStart; i++)content = content.firstChild.content;
    for(let pass = 1; pass <= (slice.openStart == 0 && slice.size ? 2 : 1); pass++)for(let d = $pos.depth; d >= 0; d--){
        let bias = d == $pos.depth ? 0 : $pos.pos <= ($pos.start(d + 1) + $pos.end(d + 1)) / 2 ? -1 : 1;
        let insertPos = $pos.index(d) + (bias > 0 ? 1 : 0);
        let parent = $pos.node(d), fits = false;
        if (pass == 1) fits = parent.canReplace(insertPos, insertPos, content);
        else {
            let wrapping = parent.contentMatchAt(insertPos).findWrapping(content.firstChild.type);
            fits = wrapping && parent.canReplaceWith(insertPos, insertPos, wrapping[0]);
        }
        if (fits) return bias == 0 ? $pos.pos : bias < 0 ? $pos.before(d + 1) : $pos.after(d + 1);
    }
    return null;
}
/**
‘Fit’ a slice into a given position in the document, producing a
[step](https://prosemirror.net/docs/ref/#transform.Step) that inserts it. Will return null if
there's no meaningful way to insert the slice here, or inserting it
would be a no-op (an empty slice over an empty range).
*/ function $f2d90061f2fecc2e$export$ed6ac67359824afd(doc, from, to = from, slice = (0, $fsS3P.Slice).empty) {
    if (from == to && !slice.size) return null;
    let $from = doc.resolve(from), $to = doc.resolve(to);
    // Optimization -- avoid work if it's obvious that it's not needed.
    if ($f2d90061f2fecc2e$var$fitsTrivially($from, $to, slice)) return new $f2d90061f2fecc2e$export$5c860b2e74034756(from, to, slice);
    return new $f2d90061f2fecc2e$var$Fitter($from, $to, slice).fit();
}
function $f2d90061f2fecc2e$var$fitsTrivially($from, $to, slice) {
    return !slice.openStart && !slice.openEnd && $from.start() == $to.start() && $from.parent.canReplace($from.index(), $to.index(), slice.content);
}
// Algorithm for 'placing' the elements of a slice into a gap:
//
// We consider the content of each node that is open to the left to be
// independently placeable. I.e. in <p("foo"), p("bar")>, when the
// paragraph on the left is open, "foo" can be placed (somewhere on
// the left side of the replacement gap) independently from p("bar").
//
// This class tracks the state of the placement progress in the
// following properties:
//
//  - `frontier` holds a stack of `{type, match}` objects that
//    represent the open side of the replacement. It starts at
//    `$from`, then moves forward as content is placed, and is finally
//    reconciled with `$to`.
//
//  - `unplaced` is a slice that represents the content that hasn't
//    been placed yet.
//
//  - `placed` is a fragment of placed content. Its open-start value
//    is implicit in `$from`, and its open-end value in `frontier`.
class $f2d90061f2fecc2e$var$Fitter {
    constructor($from, $to, unplaced){
        this.$from = $from;
        this.$to = $to;
        this.unplaced = unplaced;
        this.frontier = [];
        this.placed = (0, $fsS3P.Fragment).empty;
        for(let i = 0; i <= $from.depth; i++){
            let node = $from.node(i);
            this.frontier.push({
                type: node.type,
                match: node.contentMatchAt($from.indexAfter(i))
            });
        }
        for(let i = $from.depth; i > 0; i--)this.placed = (0, $fsS3P.Fragment).from($from.node(i).copy(this.placed));
    }
    get depth() {
        return this.frontier.length - 1;
    }
    fit() {
        // As long as there's unplaced content, try to place some of it.
        // If that fails, either increase the open score of the unplaced
        // slice, or drop nodes from it, and then try again.
        while(this.unplaced.size){
            let fit = this.findFittable();
            if (fit) this.placeNodes(fit);
            else this.openMore() || this.dropNode();
        }
        // When there's inline content directly after the frontier _and_
        // directly after `this.$to`, we must generate a `ReplaceAround`
        // step that pulls that content into the node after the frontier.
        // That means the fitting must be done to the end of the textblock
        // node after `this.$to`, not `this.$to` itself.
        let moveInline = this.mustMoveInline(), placedSize = this.placed.size - this.depth - this.$from.depth;
        let $from = this.$from, $to = this.close(moveInline < 0 ? this.$to : $from.doc.resolve(moveInline));
        if (!$to) return null;
        // If closing to `$to` succeeded, create a step
        let content = this.placed, openStart = $from.depth, openEnd = $to.depth;
        while(openStart && openEnd && content.childCount == 1){
            content = content.firstChild.content;
            openStart--;
            openEnd--;
        }
        let slice = new (0, $fsS3P.Slice)(content, openStart, openEnd);
        if (moveInline > -1) return new $f2d90061f2fecc2e$export$444ba800d6024a98($from.pos, moveInline, this.$to.pos, this.$to.end(), slice, placedSize);
        if (slice.size || $from.pos != this.$to.pos) return new $f2d90061f2fecc2e$export$5c860b2e74034756($from.pos, $to.pos, slice);
        return null;
    }
    // Find a position on the start spine of `this.unplaced` that has
    // content that can be moved somewhere on the frontier. Returns two
    // depths, one for the slice and one for the frontier.
    findFittable() {
        let startDepth = this.unplaced.openStart;
        for(let cur = this.unplaced.content, d = 0, openEnd = this.unplaced.openEnd; d < startDepth; d++){
            let node = cur.firstChild;
            if (cur.childCount > 1) openEnd = 0;
            if (node.type.spec.isolating && openEnd <= d) {
                startDepth = d;
                break;
            }
            cur = node.content;
        }
        // Only try wrapping nodes (pass 2) after finding a place without
        // wrapping failed.
        for(let pass = 1; pass <= 2; pass++)for(let sliceDepth = pass == 1 ? startDepth : this.unplaced.openStart; sliceDepth >= 0; sliceDepth--){
            let fragment, parent = null;
            if (sliceDepth) {
                parent = $f2d90061f2fecc2e$var$contentAt(this.unplaced.content, sliceDepth - 1).firstChild;
                fragment = parent.content;
            } else fragment = this.unplaced.content;
            let first = fragment.firstChild;
            for(let frontierDepth = this.depth; frontierDepth >= 0; frontierDepth--){
                let { type: type, match: match } = this.frontier[frontierDepth], wrap, inject = null;
                // In pass 1, if the next node matches, or there is no next
                // node but the parents look compatible, we've found a
                // place.
                if (pass == 1 && (first ? match.matchType(first.type) || (inject = match.fillBefore((0, $fsS3P.Fragment).from(first), false)) : parent && type.compatibleContent(parent.type))) return {
                    sliceDepth: sliceDepth,
                    frontierDepth: frontierDepth,
                    parent: parent,
                    inject: inject
                };
                else if (pass == 2 && first && (wrap = match.findWrapping(first.type))) return {
                    sliceDepth: sliceDepth,
                    frontierDepth: frontierDepth,
                    parent: parent,
                    wrap: wrap
                };
                // Don't continue looking further up if the parent node
                // would fit here.
                if (parent && match.matchType(parent.type)) break;
            }
        }
    }
    openMore() {
        let { content: content, openStart: openStart, openEnd: openEnd } = this.unplaced;
        let inner = $f2d90061f2fecc2e$var$contentAt(content, openStart);
        if (!inner.childCount || inner.firstChild.isLeaf) return false;
        this.unplaced = new (0, $fsS3P.Slice)(content, openStart + 1, Math.max(openEnd, inner.size + openStart >= content.size - openEnd ? openStart + 1 : 0));
        return true;
    }
    dropNode() {
        let { content: content, openStart: openStart, openEnd: openEnd } = this.unplaced;
        let inner = $f2d90061f2fecc2e$var$contentAt(content, openStart);
        if (inner.childCount <= 1 && openStart > 0) {
            let openAtEnd = content.size - openStart <= openStart + inner.size;
            this.unplaced = new (0, $fsS3P.Slice)($f2d90061f2fecc2e$var$dropFromFragment(content, openStart - 1, 1), openStart - 1, openAtEnd ? openStart - 1 : openEnd);
        } else this.unplaced = new (0, $fsS3P.Slice)($f2d90061f2fecc2e$var$dropFromFragment(content, openStart, 1), openStart, openEnd);
    }
    // Move content from the unplaced slice at `sliceDepth` to the
    // frontier node at `frontierDepth`. Close that frontier node when
    // applicable.
    placeNodes({ sliceDepth: sliceDepth, frontierDepth: frontierDepth, parent: parent, inject: inject, wrap: wrap }) {
        while(this.depth > frontierDepth)this.closeFrontierNode();
        if (wrap) for(let i = 0; i < wrap.length; i++)this.openFrontierNode(wrap[i]);
        let slice = this.unplaced, fragment = parent ? parent.content : slice.content;
        let openStart = slice.openStart - sliceDepth;
        let taken = 0, add = [];
        let { match: match, type: type } = this.frontier[frontierDepth];
        if (inject) {
            for(let i = 0; i < inject.childCount; i++)add.push(inject.child(i));
            match = match.matchFragment(inject);
        }
        // Computes the amount of (end) open nodes at the end of the
        // fragment. When 0, the parent is open, but no more. When
        // negative, nothing is open.
        let openEndCount = fragment.size + sliceDepth - (slice.content.size - slice.openEnd);
        // Scan over the fragment, fitting as many child nodes as
        // possible.
        while(taken < fragment.childCount){
            let next = fragment.child(taken), matches = match.matchType(next.type);
            if (!matches) break;
            taken++;
            if (taken > 1 || openStart == 0 || next.content.size) {
                match = matches;
                add.push($f2d90061f2fecc2e$var$closeNodeStart(next.mark(type.allowedMarks(next.marks)), taken == 1 ? openStart : 0, taken == fragment.childCount ? openEndCount : -1));
            }
        }
        let toEnd = taken == fragment.childCount;
        if (!toEnd) openEndCount = -1;
        this.placed = $f2d90061f2fecc2e$var$addToFragment(this.placed, frontierDepth, (0, $fsS3P.Fragment).from(add));
        this.frontier[frontierDepth].match = match;
        // If the parent types match, and the entire node was moved, and
        // it's not open, close this frontier node right away.
        if (toEnd && openEndCount < 0 && parent && parent.type == this.frontier[this.depth].type && this.frontier.length > 1) this.closeFrontierNode();
        // Add new frontier nodes for any open nodes at the end.
        for(let i = 0, cur = fragment; i < openEndCount; i++){
            let node = cur.lastChild;
            this.frontier.push({
                type: node.type,
                match: node.contentMatchAt(node.childCount)
            });
            cur = node.content;
        }
        // Update `this.unplaced`. Drop the entire node from which we
        // placed it we got to its end, otherwise just drop the placed
        // nodes.
        this.unplaced = !toEnd ? new (0, $fsS3P.Slice)($f2d90061f2fecc2e$var$dropFromFragment(slice.content, sliceDepth, taken), slice.openStart, slice.openEnd) : sliceDepth == 0 ? (0, $fsS3P.Slice).empty : new (0, $fsS3P.Slice)($f2d90061f2fecc2e$var$dropFromFragment(slice.content, sliceDepth - 1, 1), sliceDepth - 1, openEndCount < 0 ? slice.openEnd : sliceDepth - 1);
    }
    mustMoveInline() {
        if (!this.$to.parent.isTextblock) return -1;
        let top = this.frontier[this.depth], level;
        if (!top.type.isTextblock || !$f2d90061f2fecc2e$var$contentAfterFits(this.$to, this.$to.depth, top.type, top.match, false) || this.$to.depth == this.depth && (level = this.findCloseLevel(this.$to)) && level.depth == this.depth) return -1;
        let { depth: depth } = this.$to, after = this.$to.after(depth);
        while(depth > 1 && after == this.$to.end(--depth))++after;
        return after;
    }
    findCloseLevel($to) {
        scan: for(let i = Math.min(this.depth, $to.depth); i >= 0; i--){
            let { match: match, type: type } = this.frontier[i];
            let dropInner = i < $to.depth && $to.end(i + 1) == $to.pos + ($to.depth - (i + 1));
            let fit = $f2d90061f2fecc2e$var$contentAfterFits($to, i, type, match, dropInner);
            if (!fit) continue;
            for(let d = i - 1; d >= 0; d--){
                let { match: match, type: type } = this.frontier[d];
                let matches = $f2d90061f2fecc2e$var$contentAfterFits($to, d, type, match, true);
                if (!matches || matches.childCount) continue scan;
            }
            return {
                depth: i,
                fit: fit,
                move: dropInner ? $to.doc.resolve($to.after(i + 1)) : $to
            };
        }
    }
    close($to) {
        let close = this.findCloseLevel($to);
        if (!close) return null;
        while(this.depth > close.depth)this.closeFrontierNode();
        if (close.fit.childCount) this.placed = $f2d90061f2fecc2e$var$addToFragment(this.placed, close.depth, close.fit);
        $to = close.move;
        for(let d = close.depth + 1; d <= $to.depth; d++){
            let node = $to.node(d), add = node.type.contentMatch.fillBefore(node.content, true, $to.index(d));
            this.openFrontierNode(node.type, node.attrs, add);
        }
        return $to;
    }
    openFrontierNode(type, attrs = null, content) {
        let top = this.frontier[this.depth];
        top.match = top.match.matchType(type);
        this.placed = $f2d90061f2fecc2e$var$addToFragment(this.placed, this.depth, (0, $fsS3P.Fragment).from(type.create(attrs, content)));
        this.frontier.push({
            type: type,
            match: type.contentMatch
        });
    }
    closeFrontierNode() {
        let open = this.frontier.pop();
        let add = open.match.fillBefore((0, $fsS3P.Fragment).empty, true);
        if (add.childCount) this.placed = $f2d90061f2fecc2e$var$addToFragment(this.placed, this.frontier.length, add);
    }
}
function $f2d90061f2fecc2e$var$dropFromFragment(fragment, depth, count) {
    if (depth == 0) return fragment.cutByIndex(count, fragment.childCount);
    return fragment.replaceChild(0, fragment.firstChild.copy($f2d90061f2fecc2e$var$dropFromFragment(fragment.firstChild.content, depth - 1, count)));
}
function $f2d90061f2fecc2e$var$addToFragment(fragment, depth, content) {
    if (depth == 0) return fragment.append(content);
    return fragment.replaceChild(fragment.childCount - 1, fragment.lastChild.copy($f2d90061f2fecc2e$var$addToFragment(fragment.lastChild.content, depth - 1, content)));
}
function $f2d90061f2fecc2e$var$contentAt(fragment, depth) {
    for(let i = 0; i < depth; i++)fragment = fragment.firstChild.content;
    return fragment;
}
function $f2d90061f2fecc2e$var$closeNodeStart(node, openStart, openEnd) {
    if (openStart <= 0) return node;
    let frag = node.content;
    if (openStart > 1) frag = frag.replaceChild(0, $f2d90061f2fecc2e$var$closeNodeStart(frag.firstChild, openStart - 1, frag.childCount == 1 ? openEnd - 1 : 0));
    if (openStart > 0) {
        frag = node.type.contentMatch.fillBefore(frag).append(frag);
        if (openEnd <= 0) frag = frag.append(node.type.contentMatch.matchFragment(frag).fillBefore((0, $fsS3P.Fragment).empty, true));
    }
    return node.copy(frag);
}
function $f2d90061f2fecc2e$var$contentAfterFits($to, depth, type, match, open) {
    let node = $to.node(depth), index = open ? $to.indexAfter(depth) : $to.index(depth);
    if (index == node.childCount && !type.compatibleContent(node.type)) return null;
    let fit = match.fillBefore(node.content, true, index);
    return fit && !$f2d90061f2fecc2e$var$invalidMarks(type, node.content, index) ? fit : null;
}
function $f2d90061f2fecc2e$var$invalidMarks(type, fragment, start) {
    for(let i = start; i < fragment.childCount; i++)if (!type.allowsMarks(fragment.child(i).marks)) return true;
    return false;
}
function $f2d90061f2fecc2e$var$definesContent(type) {
    return type.spec.defining || type.spec.definingForContent;
}
function $f2d90061f2fecc2e$var$replaceRange(tr, from, to, slice) {
    if (!slice.size) return tr.deleteRange(from, to);
    let $from = tr.doc.resolve(from), $to = tr.doc.resolve(to);
    if ($f2d90061f2fecc2e$var$fitsTrivially($from, $to, slice)) return tr.step(new $f2d90061f2fecc2e$export$5c860b2e74034756(from, to, slice));
    let targetDepths = $f2d90061f2fecc2e$var$coveredDepths($from, $to);
    // Can't replace the whole document, so remove 0 if it's present
    if (targetDepths[targetDepths.length - 1] == 0) targetDepths.pop();
    // Negative numbers represent not expansion over the whole node at
    // that depth, but replacing from $from.before(-D) to $to.pos.
    let preferredTarget = -($from.depth + 1);
    targetDepths.unshift(preferredTarget);
    // This loop picks a preferred target depth, if one of the covering
    // depths is not outside of a defining node, and adds negative
    // depths for any depth that has $from at its start and does not
    // cross a defining node.
    for(let d = $from.depth, pos = $from.pos - 1; d > 0; d--, pos--){
        let spec = $from.node(d).type.spec;
        if (spec.defining || spec.definingAsContext || spec.isolating) break;
        if (targetDepths.indexOf(d) > -1) preferredTarget = d;
        else if ($from.before(d) == pos) targetDepths.splice(1, 0, -d);
    }
    // Try to fit each possible depth of the slice into each possible
    // target depth, starting with the preferred depths.
    let preferredTargetIndex = targetDepths.indexOf(preferredTarget);
    let leftNodes = [], preferredDepth = slice.openStart;
    for(let content = slice.content, i = 0;; i++){
        let node = content.firstChild;
        leftNodes.push(node);
        if (i == slice.openStart) break;
        content = node.content;
    }
    // Back up preferredDepth to cover defining textblocks directly
    // above it, possibly skipping a non-defining textblock.
    for(let d = preferredDepth - 1; d >= 0; d--){
        let leftNode = leftNodes[d], def = $f2d90061f2fecc2e$var$definesContent(leftNode.type);
        if (def && !leftNode.sameMarkup($from.node(Math.abs(preferredTarget) - 1))) preferredDepth = d;
        else if (def || !leftNode.type.isTextblock) break;
    }
    for(let j = slice.openStart; j >= 0; j--){
        let openDepth = (j + preferredDepth + 1) % (slice.openStart + 1);
        let insert = leftNodes[openDepth];
        if (!insert) continue;
        for(let i = 0; i < targetDepths.length; i++){
            // Loop over possible expansion levels, starting with the
            // preferred one
            let targetDepth = targetDepths[(i + preferredTargetIndex) % targetDepths.length], expand = true;
            if (targetDepth < 0) {
                expand = false;
                targetDepth = -targetDepth;
            }
            let parent = $from.node(targetDepth - 1), index = $from.index(targetDepth - 1);
            if (parent.canReplaceWith(index, index, insert.type, insert.marks)) return tr.replace($from.before(targetDepth), expand ? $to.after(targetDepth) : to, new (0, $fsS3P.Slice)($f2d90061f2fecc2e$var$closeFragment(slice.content, 0, slice.openStart, openDepth), openDepth, slice.openEnd));
        }
    }
    let startSteps = tr.steps.length;
    for(let i = targetDepths.length - 1; i >= 0; i--){
        tr.replace(from, to, slice);
        if (tr.steps.length > startSteps) break;
        let depth = targetDepths[i];
        if (depth < 0) continue;
        from = $from.before(depth);
        to = $to.after(depth);
    }
}
function $f2d90061f2fecc2e$var$closeFragment(fragment, depth, oldOpen, newOpen, parent) {
    if (depth < oldOpen) {
        let first = fragment.firstChild;
        fragment = fragment.replaceChild(0, first.copy($f2d90061f2fecc2e$var$closeFragment(first.content, depth + 1, oldOpen, newOpen, first)));
    }
    if (depth > newOpen) {
        let match = parent.contentMatchAt(0);
        let start = match.fillBefore(fragment).append(fragment);
        fragment = start.append(match.matchFragment(start).fillBefore((0, $fsS3P.Fragment).empty, true));
    }
    return fragment;
}
function $f2d90061f2fecc2e$var$replaceRangeWith(tr, from, to, node) {
    if (!node.isInline && from == to && tr.doc.resolve(from).parent.content.size) {
        let point = $f2d90061f2fecc2e$export$64cb316d02de1dd1(tr.doc, from, node.type);
        if (point != null) from = to = point;
    }
    tr.replaceRange(from, to, new (0, $fsS3P.Slice)((0, $fsS3P.Fragment).from(node), 0, 0));
}
function $f2d90061f2fecc2e$var$deleteRange(tr, from, to) {
    let $from = tr.doc.resolve(from), $to = tr.doc.resolve(to);
    let covered = $f2d90061f2fecc2e$var$coveredDepths($from, $to);
    for(let i = 0; i < covered.length; i++){
        let depth = covered[i], last = i == covered.length - 1;
        if (last && depth == 0 || $from.node(depth).type.contentMatch.validEnd) return tr.delete($from.start(depth), $to.end(depth));
        if (depth > 0 && (last || $from.node(depth - 1).canReplace($from.index(depth - 1), $to.indexAfter(depth - 1)))) return tr.delete($from.before(depth), $to.after(depth));
    }
    for(let d = 1; d <= $from.depth && d <= $to.depth; d++){
        if (from - $from.start(d) == $from.depth - d && to > $from.end(d) && $to.end(d) - to != $to.depth - d && $from.start(d - 1) == $to.start(d - 1) && $from.node(d - 1).canReplace($from.index(d - 1), $to.index(d - 1))) return tr.delete($from.before(d), to);
    }
    tr.delete(from, to);
}
// Returns an array of all depths for which $from - $to spans the
// whole content of the nodes at that depth.
function $f2d90061f2fecc2e$var$coveredDepths($from, $to) {
    let result = [], minDepth = Math.min($from.depth, $to.depth);
    for(let d = minDepth; d >= 0; d--){
        let start = $from.start(d);
        if (start < $from.pos - ($from.depth - d) || $to.end(d) > $to.pos + ($to.depth - d) || $from.node(d).type.spec.isolating || $to.node(d).type.spec.isolating) break;
        if (start == $to.start(d) || d == $from.depth && d == $to.depth && $from.parent.inlineContent && $to.parent.inlineContent && d && $to.start(d - 1) == start - 1) result.push(d);
    }
    return result;
}
/**
Update an attribute in a specific node.
*/ class $f2d90061f2fecc2e$export$626399c38172f669 extends $f2d90061f2fecc2e$export$fd55ce593607084a {
    /**
    Construct an attribute step.
    */ constructor(/**
    The position of the target node.
    */ pos, /**
    The attribute to set.
    */ attr, // The attribute's new value.
    value){
        super();
        this.pos = pos;
        this.attr = attr;
        this.value = value;
    }
    apply(doc) {
        let node = doc.nodeAt(this.pos);
        if (!node) return $f2d90061f2fecc2e$export$8ebf1578a4199c09.fail("No node at attribute step's position");
        let attrs = Object.create(null);
        for(let name in node.attrs)attrs[name] = node.attrs[name];
        attrs[this.attr] = this.value;
        let updated = node.type.create(attrs, null, node.marks);
        return $f2d90061f2fecc2e$export$8ebf1578a4199c09.fromReplace(doc, this.pos, this.pos + 1, new (0, $fsS3P.Slice)((0, $fsS3P.Fragment).from(updated), 0, node.isLeaf ? 0 : 1));
    }
    getMap() {
        return $f2d90061f2fecc2e$export$c53d01c3ab9721b3.empty;
    }
    invert(doc) {
        return new $f2d90061f2fecc2e$export$626399c38172f669(this.pos, this.attr, doc.nodeAt(this.pos).attrs[this.attr]);
    }
    map(mapping) {
        let pos = mapping.mapResult(this.pos, 1);
        return pos.deletedAfter ? null : new $f2d90061f2fecc2e$export$626399c38172f669(pos.pos, this.attr, this.value);
    }
    toJSON() {
        return {
            stepType: "attr",
            pos: this.pos,
            attr: this.attr,
            value: this.value
        };
    }
    static fromJSON(schema, json) {
        if (typeof json.pos != "number" || typeof json.attr != "string") throw new RangeError("Invalid input for AttrStep.fromJSON");
        return new $f2d90061f2fecc2e$export$626399c38172f669(json.pos, json.attr, json.value);
    }
}
$f2d90061f2fecc2e$export$fd55ce593607084a.jsonID("attr", $f2d90061f2fecc2e$export$626399c38172f669);
/**
Update an attribute in the doc node.
*/ class $f2d90061f2fecc2e$export$f50707b396300ac9 extends $f2d90061f2fecc2e$export$fd55ce593607084a {
    /**
    Construct an attribute step.
    */ constructor(/**
    The attribute to set.
    */ attr, // The attribute's new value.
    value){
        super();
        this.attr = attr;
        this.value = value;
    }
    apply(doc) {
        let attrs = Object.create(null);
        for(let name in doc.attrs)attrs[name] = doc.attrs[name];
        attrs[this.attr] = this.value;
        let updated = doc.type.create(attrs, doc.content, doc.marks);
        return $f2d90061f2fecc2e$export$8ebf1578a4199c09.ok(updated);
    }
    getMap() {
        return $f2d90061f2fecc2e$export$c53d01c3ab9721b3.empty;
    }
    invert(doc) {
        return new $f2d90061f2fecc2e$export$f50707b396300ac9(this.attr, doc.attrs[this.attr]);
    }
    map(mapping) {
        return this;
    }
    toJSON() {
        return {
            stepType: "docAttr",
            attr: this.attr,
            value: this.value
        };
    }
    static fromJSON(schema, json) {
        if (typeof json.attr != "string") throw new RangeError("Invalid input for DocAttrStep.fromJSON");
        return new $f2d90061f2fecc2e$export$f50707b396300ac9(json.attr, json.value);
    }
}
$f2d90061f2fecc2e$export$fd55ce593607084a.jsonID("docAttr", $f2d90061f2fecc2e$export$f50707b396300ac9);
/**
@internal
*/ let $f2d90061f2fecc2e$export$88cc3a1dfce48dd3 = class extends Error {
};
$f2d90061f2fecc2e$export$88cc3a1dfce48dd3 = function TransformError(message) {
    let err = Error.call(this, message);
    err.__proto__ = TransformError.prototype;
    return err;
};
$f2d90061f2fecc2e$export$88cc3a1dfce48dd3.prototype = Object.create(Error.prototype);
$f2d90061f2fecc2e$export$88cc3a1dfce48dd3.prototype.constructor = $f2d90061f2fecc2e$export$88cc3a1dfce48dd3;
$f2d90061f2fecc2e$export$88cc3a1dfce48dd3.prototype.name = "TransformError";
/**
Abstraction to build up and track an array of
[steps](https://prosemirror.net/docs/ref/#transform.Step) representing a document transformation.

Most transforming methods return the `Transform` object itself, so
that they can be chained.
*/ class $f2d90061f2fecc2e$export$563a914cafbdc389 {
    /**
    Create a transform that starts with the given document.
    */ constructor(/**
    The current document (the result of applying the steps in the
    transform).
    */ doc){
        this.doc = doc;
        /**
        The steps in this transform.
        */ this.steps = [];
        /**
        The documents before each of the steps.
        */ this.docs = [];
        /**
        A mapping with the maps for each of the steps in this transform.
        */ this.mapping = new $f2d90061f2fecc2e$export$f5f785078011b62;
    }
    /**
    The starting document.
    */ get before() {
        return this.docs.length ? this.docs[0] : this.doc;
    }
    /**
    Apply a new step in this transform, saving the result. Throws an
    error when the step fails.
    */ step(step) {
        let result = this.maybeStep(step);
        if (result.failed) throw new $f2d90061f2fecc2e$export$88cc3a1dfce48dd3(result.failed);
        return this;
    }
    /**
    Try to apply a step in this transformation, ignoring it if it
    fails. Returns the step result.
    */ maybeStep(step) {
        let result = step.apply(this.doc);
        if (!result.failed) this.addStep(step, result.doc);
        return result;
    }
    /**
    True when the document has been changed (when there are any
    steps).
    */ get docChanged() {
        return this.steps.length > 0;
    }
    /**
    @internal
    */ addStep(step, doc) {
        this.docs.push(this.doc);
        this.steps.push(step);
        this.mapping.appendMap(step.getMap());
        this.doc = doc;
    }
    /**
    Replace the part of the document between `from` and `to` with the
    given `slice`.
    */ replace(from, to = from, slice = (0, $fsS3P.Slice).empty) {
        let step = $f2d90061f2fecc2e$export$ed6ac67359824afd(this.doc, from, to, slice);
        if (step) this.step(step);
        return this;
    }
    /**
    Replace the given range with the given content, which may be a
    fragment, node, or array of nodes.
    */ replaceWith(from, to, content) {
        return this.replace(from, to, new (0, $fsS3P.Slice)((0, $fsS3P.Fragment).from(content), 0, 0));
    }
    /**
    Delete the content between the given positions.
    */ delete(from, to) {
        return this.replace(from, to, (0, $fsS3P.Slice).empty);
    }
    /**
    Insert the given content at the given position.
    */ insert(pos, content) {
        return this.replaceWith(pos, pos, content);
    }
    /**
    Replace a range of the document with a given slice, using
    `from`, `to`, and the slice's
    [`openStart`](https://prosemirror.net/docs/ref/#model.Slice.openStart) property as hints, rather
    than fixed start and end points. This method may grow the
    replaced area or close open nodes in the slice in order to get a
    fit that is more in line with WYSIWYG expectations, by dropping
    fully covered parent nodes of the replaced region when they are
    marked [non-defining as
    context](https://prosemirror.net/docs/ref/#model.NodeSpec.definingAsContext), or including an
    open parent node from the slice that _is_ marked as [defining
    its content](https://prosemirror.net/docs/ref/#model.NodeSpec.definingForContent).
    
    This is the method, for example, to handle paste. The similar
    [`replace`](https://prosemirror.net/docs/ref/#transform.Transform.replace) method is a more
    primitive tool which will _not_ move the start and end of its given
    range, and is useful in situations where you need more precise
    control over what happens.
    */ replaceRange(from, to, slice) {
        $f2d90061f2fecc2e$var$replaceRange(this, from, to, slice);
        return this;
    }
    /**
    Replace the given range with a node, but use `from` and `to` as
    hints, rather than precise positions. When from and to are the same
    and are at the start or end of a parent node in which the given
    node doesn't fit, this method may _move_ them out towards a parent
    that does allow the given node to be placed. When the given range
    completely covers a parent node, this method may completely replace
    that parent node.
    */ replaceRangeWith(from, to, node) {
        $f2d90061f2fecc2e$var$replaceRangeWith(this, from, to, node);
        return this;
    }
    /**
    Delete the given range, expanding it to cover fully covered
    parent nodes until a valid replace is found.
    */ deleteRange(from, to) {
        $f2d90061f2fecc2e$var$deleteRange(this, from, to);
        return this;
    }
    /**
    Split the content in the given range off from its parent, if there
    is sibling content before or after it, and move it up the tree to
    the depth specified by `target`. You'll probably want to use
    [`liftTarget`](https://prosemirror.net/docs/ref/#transform.liftTarget) to compute `target`, to make
    sure the lift is valid.
    */ lift(range, target) {
        $f2d90061f2fecc2e$var$lift(this, range, target);
        return this;
    }
    /**
    Join the blocks around the given position. If depth is 2, their
    last and first siblings are also joined, and so on.
    */ join(pos, depth = 1) {
        $f2d90061f2fecc2e$var$join(this, pos, depth);
        return this;
    }
    /**
    Wrap the given [range](https://prosemirror.net/docs/ref/#model.NodeRange) in the given set of wrappers.
    The wrappers are assumed to be valid in this position, and should
    probably be computed with [`findWrapping`](https://prosemirror.net/docs/ref/#transform.findWrapping).
    */ wrap(range, wrappers) {
        $f2d90061f2fecc2e$var$wrap(this, range, wrappers);
        return this;
    }
    /**
    Set the type of all textblocks (partly) between `from` and `to` to
    the given node type with the given attributes.
    */ setBlockType(from, to = from, type, attrs = null) {
        $f2d90061f2fecc2e$var$setBlockType(this, from, to, type, attrs);
        return this;
    }
    /**
    Change the type, attributes, and/or marks of the node at `pos`.
    When `type` isn't given, the existing node type is preserved,
    */ setNodeMarkup(pos, type, attrs = null, marks) {
        $f2d90061f2fecc2e$var$setNodeMarkup(this, pos, type, attrs, marks);
        return this;
    }
    /**
    Set a single attribute on a given node to a new value.
    The `pos` addresses the document content. Use `setDocAttribute`
    to set attributes on the document itself.
    */ setNodeAttribute(pos, attr, value) {
        this.step(new $f2d90061f2fecc2e$export$626399c38172f669(pos, attr, value));
        return this;
    }
    /**
    Set a single attribute on the document to a new value.
    */ setDocAttribute(attr, value) {
        this.step(new $f2d90061f2fecc2e$export$f50707b396300ac9(attr, value));
        return this;
    }
    /**
    Add a mark to the node at position `pos`.
    */ addNodeMark(pos, mark) {
        this.step(new $f2d90061f2fecc2e$export$adefd16c402fee4e(pos, mark));
        return this;
    }
    /**
    Remove a mark (or all marks of the given type) from the node at
    position `pos`.
    */ removeNodeMark(pos, mark) {
        let node = this.doc.nodeAt(pos);
        if (!node) throw new RangeError("No node at position " + pos);
        if (mark instanceof (0, $fsS3P.Mark)) {
            if (mark.isInSet(node.marks)) this.step(new $f2d90061f2fecc2e$export$fdf7d1dc10724da2(pos, mark));
        } else {
            let set = node.marks, found, steps = [];
            while(found = mark.isInSet(set)){
                steps.push(new $f2d90061f2fecc2e$export$fdf7d1dc10724da2(pos, found));
                set = found.removeFromSet(set);
            }
            for(let i = steps.length - 1; i >= 0; i--)this.step(steps[i]);
        }
        return this;
    }
    /**
    Split the node at the given position, and optionally, if `depth` is
    greater than one, any number of nodes above that. By default, the
    parts split off will inherit the node type of the original node.
    This can be changed by passing an array of types and attributes to
    use after the split (with the outermost nodes coming first).
    */ split(pos, depth = 1, typesAfter) {
        $f2d90061f2fecc2e$var$split(this, pos, depth, typesAfter);
        return this;
    }
    /**
    Add the given mark to the inline content between `from` and `to`.
    */ addMark(from, to, mark) {
        $f2d90061f2fecc2e$var$addMark(this, from, to, mark);
        return this;
    }
    /**
    Remove marks from inline nodes between `from` and `to`. When
    `mark` is a single mark, remove precisely that mark. When it is
    a mark type, remove all marks of that type. When it is null,
    remove all marks of any type.
    */ removeMark(from, to, mark) {
        $f2d90061f2fecc2e$var$removeMark(this, from, to, mark);
        return this;
    }
    /**
    Removes all marks and nodes from the content of the node at
    `pos` that don't match the given new parent node type. Accepts
    an optional starting [content match](https://prosemirror.net/docs/ref/#model.ContentMatch) as
    third argument.
    */ clearIncompatible(pos, parentType, match) {
        $f2d90061f2fecc2e$var$clearIncompatible(this, pos, parentType, match);
        return this;
    }
}

});


parcelRegister("2WYRt", function(module, exports) {
$parcel$export(module.exports, "ELEMENTS_CONTEXT", () => (parcelRequire("7fUte")).ELEMENTS_CONTEXT);
$parcel$export(module.exports, "FabricElementsAnalyticsContext", () => (parcelRequire("7fUte")).FabricElementsAnalyticsContext);
$parcel$export(module.exports, "NAVIGATION_CONTEXT", () => (parcelRequire("lzPgc")).NAVIGATION_CONTEXT);
$parcel$export(module.exports, "EDITOR_CONTEXT", () => (parcelRequire("kHFeb")).EDITOR_CONTEXT);
$parcel$export(module.exports, "FabricEditorAnalyticsContext", () => (parcelRequire("kHFeb")).FabricEditorAnalyticsContext);
$parcel$export(module.exports, "MEDIA_CONTEXT", () => (parcelRequire("gwzFf")).MEDIA_CONTEXT);
$parcel$export(module.exports, "PEOPLE_TEAMS_CONTEXT", () => (parcelRequire("coUGQ")).PEOPLE_TEAMS_CONTEXT);
$parcel$export(module.exports, "NOTIFICATIONS_CONTEXT", () => (parcelRequire("gYBV8")).NOTIFICATIONS_CONTEXT);
$parcel$export(module.exports, "RECENT_WORK_CONTEXT", () => (parcelRequire("dr6Uf")).RECENT_WORK_CONTEXT);
$parcel$export(module.exports, "ATLAS_CONTEXT", () => (parcelRequire("dT6JI")).ATLAS_CONTEXT);
$parcel$export(module.exports, "TOWNSQUARE_HOME_CONTEXT", () => (parcelRequire("kBCsH")).TOWNSQUARE_HOME_CONTEXT);
$parcel$export(module.exports, "LINKING_PLATFORM_CONTEXT", () => (parcelRequire("bvSsd")).LINKING_PLATFORM_CONTEXT);
$parcel$export(module.exports, "POST_OFFICE_CONTEXT", () => (parcelRequire("9qmI1")).POST_OFFICE_CONTEXT);
$parcel$export(module.exports, "AI_MATE_CONTEXT", () => (parcelRequire("draJh")).AI_MATE_CONTEXT);
$parcel$export(module.exports, "AVP_CONTEXT", () => (parcelRequire("dRe9Q")).AVP_CONTEXT);
$parcel$export(module.exports, "GROWTH_CONTEXT", () => (parcelRequire("a4wHv")).GROWTH_CONTEXT);
$parcel$export(module.exports, "OMNI_CHANNEL_CONTEXT", () => (parcelRequire("LLMKz")).OMNI_CHANNEL_CONTEXT);
$parcel$export(module.exports, "ROVO_EXTENSION_CONTEXT", () => (parcelRequire("cmtzP")).ROVO_EXTENSION_CONTEXT);

var $7fUte = parcelRequire("7fUte");

var $lzPgc = parcelRequire("lzPgc");

var $kHFeb = parcelRequire("kHFeb");

var $gwzFf = parcelRequire("gwzFf");

var $coUGQ = parcelRequire("coUGQ");

var $gYBV8 = parcelRequire("gYBV8");

var $dr6Uf = parcelRequire("dr6Uf");

var $dT6JI = parcelRequire("dT6JI");

var $kBCsH = parcelRequire("kBCsH");

var $bvSsd = parcelRequire("bvSsd");

var $9qmI1 = parcelRequire("9qmI1");

var $draJh = parcelRequire("draJh");

var $dRe9Q = parcelRequire("dRe9Q");

var $a4wHv = parcelRequire("a4wHv");

var $LLMKz = parcelRequire("LLMKz");

var $cmtzP = parcelRequire("cmtzP");

});
parcelRegister("7fUte", function(module, exports) {
$parcel$export(module.exports, "ELEMENTS_CONTEXT", () => $5485bcf8dc53d39f$export$80450e0a84a5ede9);
$parcel$export(module.exports, "FabricElementsAnalyticsContext", () => $5485bcf8dc53d39f$export$3fe25500478a635c);

var $gA3qV = parcelRequire("gA3qV");
var $5485bcf8dc53d39f$export$80450e0a84a5ede9 = 'fabricElementsCtx';
var $5485bcf8dc53d39f$export$3fe25500478a635c = (0, $gA3qV.default)($5485bcf8dc53d39f$export$80450e0a84a5ede9, 'FabricElementsAnalyticsContext');

});
parcelRegister("gA3qV", function(module, exports) {
$parcel$export(module.exports, "default", () => $c122abe76d5b40d8$export$2e2bcd8739ae039);

var $25nEq = parcelRequire("25nEq");

var $5FkrB = parcelRequire("5FkrB");

var $apAHg = parcelRequire("apAHg");
var $c122abe76d5b40d8$var$createNamespaceContext = function createNamespaceContext(namespace) {
    var displayName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'NamespacedContext';
    var Component = function Component(props) {
        var newData = (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, namespace, props.data);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $apAHg.default), {
            data: newData
        }, (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).Children.only(props.children));
    };
    Component.displayName = displayName;
    return Component;
};
var $c122abe76d5b40d8$export$2e2bcd8739ae039 = $c122abe76d5b40d8$var$createNamespaceContext;

});
parcelRegister("apAHg", function(module, exports) {
$parcel$export(module.exports, "default", () => $7948b465c1b06efa$export$2e2bcd8739ae039);

var $5FkrB = parcelRequire("5FkrB");

var $9Zzpd = parcelRequire("9Zzpd");

var $2AeEB = parcelRequire("2AeEB");

var $htWT0 = parcelRequire("htWT0");

var $fCohw = parcelRequire("fCohw");
var $7948b465c1b06efa$var$AnalyticsContext = function AnalyticsContext(props) {
    var isModernContext = (0, $2AeEB.default) || (0, $9Zzpd.fg)('analytics-next-use-legacy-context') === false;
    return isModernContext ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $fCohw.default), props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $htWT0.default), props);
};
var $7948b465c1b06efa$export$2e2bcd8739ae039 = $7948b465c1b06efa$var$AnalyticsContext;

});
parcelRegister("2AeEB", function(module, exports) {
$parcel$export(module.exports, "default", () => $1e1a4f82804ab942$export$2e2bcd8739ae039);

var $3ZMUU = parcelRequire("3ZMUU");
var $1e1a4f82804ab942$var$_process$env;
var /// <reference types="node" />
$1e1a4f82804ab942$export$2e2bcd8739ae039 = typeof $3ZMUU !== 'undefined' && $3ZMUU !== null && (($1e1a4f82804ab942$var$_process$env = {}, $1e1a4f82804ab942$var$_process$env === void 0) ? void 0 : $1e1a4f82804ab942$var$_process$env['ANALYTICS_NEXT_MODERN_CONTEXT']);

});

parcelRegister("htWT0", function(module, exports) {
$parcel$export(module.exports, "default", () => $cba2d2a818fc9ea8$export$2e2bcd8739ae039);

var $fC8ib = parcelRequire("fC8ib");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $kIXpt = parcelRequire("kIXpt");

var $cYPzS = parcelRequire("cYPzS");

var $eyuDe = parcelRequire("eyuDe");

var $25nEq = parcelRequire("25nEq");

var $5FkrB = parcelRequire("5FkrB");

var $8vJ0V = parcelRequire("8vJ0V");

var $iyyOp = parcelRequire("iyyOp");
function $cba2d2a818fc9ea8$var$_callSuper(t, o, e) {
    return o = (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(o), (0, (/*@__PURE__*/$parcel$interopDefault($kIXpt)))(t, $cba2d2a818fc9ea8$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(t).constructor) : o.apply(t, e));
}
function $cba2d2a818fc9ea8$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($cba2d2a818fc9ea8$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $cba2d2a818fc9ea8$var$ContextTypes = {
    getAtlaskitAnalyticsContext: (0, (/*@__PURE__*/$parcel$interopDefault($8vJ0V))).func,
    getAtlaskitAnalyticsEventHandlers: (0, (/*@__PURE__*/$parcel$interopDefault($8vJ0V))).func
};
var $cba2d2a818fc9ea8$var$noop = function noop() {
    return [];
};
// eslint-disable-next-line @repo/internal/react/no-class-components
var $cba2d2a818fc9ea8$var$AnalyticsContext = /*#__PURE__*/ function(_Component) {
    function AnalyticsContext(props) {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, AnalyticsContext);
        _this = $cba2d2a818fc9ea8$var$_callSuper(this, AnalyticsContext, [
            props
        ]);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "getChildContext", function() {
            return {
                getAtlaskitAnalyticsContext: _this.getAnalyticsContext
            };
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "getAnalyticsContext", function() {
            var data = _this.props.data;
            var _this$context$getAtla = _this.context.getAtlaskitAnalyticsContext, getAtlaskitAnalyticsContext = _this$context$getAtla === void 0 ? $cba2d2a818fc9ea8$var$noop : _this$context$getAtla;
            return [].concat((0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(getAtlaskitAnalyticsContext()), [
                data
            ]);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "getAnalyticsEventHandlers", function() {
            var _this$context$getAtla2 = _this.context.getAtlaskitAnalyticsEventHandlers, getAtlaskitAnalyticsEventHandlers = _this$context$getAtla2 === void 0 ? $cba2d2a818fc9ea8$var$noop : _this$context$getAtla2;
            return getAtlaskitAnalyticsEventHandlers();
        });
        _this.contextValue = {
            getAtlaskitAnalyticsContext: _this.getAnalyticsContext,
            getAtlaskitAnalyticsEventHandlers: _this.getAnalyticsEventHandlers
        };
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($eyuDe)))(AnalyticsContext, _Component);
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(AnalyticsContext, [
        {
            key: "render",
            value: function render() {
                var children = this.props.children;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $iyyOp.default).Provider, {
                    value: this.contextValue
                }, children);
            }
        }
    ]);
}((0, $5FkrB.Component));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($cba2d2a818fc9ea8$var$AnalyticsContext, "contextTypes", $cba2d2a818fc9ea8$var$ContextTypes);
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($cba2d2a818fc9ea8$var$AnalyticsContext, "childContextTypes", $cba2d2a818fc9ea8$var$ContextTypes);
var $cba2d2a818fc9ea8$export$2e2bcd8739ae039 = $cba2d2a818fc9ea8$var$AnalyticsContext;

});

parcelRegister("fCohw", function(module, exports) {
$parcel$export(module.exports, "default", () => $b5ed3d6d0a59284e$export$2e2bcd8739ae039);

var $fC8ib = parcelRequire("fC8ib");

var $5FkrB = parcelRequire("5FkrB");

var $iyyOp = parcelRequire("iyyOp");

var $dPANg = parcelRequire("dPANg");

var $jfJnB = parcelRequire("jfJnB");
var $b5ed3d6d0a59284e$var$AnalyticsContext = function AnalyticsContext(_ref) {
    var data = _ref.data, children = _ref.children;
    var dataRef = (0, $jfJnB.useTrackedRef)(data);
    var _useAnalyticsContext = (0, $dPANg.useAnalyticsContext)(), getAtlaskitAnalyticsEventHandlers = _useAnalyticsContext.getAtlaskitAnalyticsEventHandlers, getOriginalAnalyticsContext = _useAnalyticsContext.getAtlaskitAnalyticsContext;
    var getAtlaskitAnalyticsContext = (0, $5FkrB.useCallback)(function() {
        return [].concat((0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(getOriginalAnalyticsContext()), [
            dataRef.current
        ]);
    }, [
        getOriginalAnalyticsContext,
        dataRef
    ]);
    var value = (0, $5FkrB.useMemo)(function() {
        return {
            getAtlaskitAnalyticsContext: getAtlaskitAnalyticsContext,
            getAtlaskitAnalyticsEventHandlers: getAtlaskitAnalyticsEventHandlers
        };
    }, [
        getAtlaskitAnalyticsContext,
        getAtlaskitAnalyticsEventHandlers
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $iyyOp.default).Provider, {
        value: value
    }, children);
};
var $b5ed3d6d0a59284e$export$2e2bcd8739ae039 = $b5ed3d6d0a59284e$var$AnalyticsContext;

});
parcelRegister("dPANg", function(module, exports) {
$parcel$export(module.exports, "useAnalyticsContext", () => $a11c9437d29b6862$export$d1f587f82ad51c4);

var $5FkrB = parcelRequire("5FkrB");

var $iyyOp = parcelRequire("iyyOp");
var $a11c9437d29b6862$export$d1f587f82ad51c4 = function useAnalyticsContext() {
    return (0, $5FkrB.useContext)((0, $iyyOp.default));
};

});

parcelRegister("jfJnB", function(module, exports) {
$parcel$export(module.exports, "useTrackedRef", () => $e0429e80cf61af8c$export$1d27a74659855e44);

var $5FkrB = parcelRequire("5FkrB");
var $e0429e80cf61af8c$export$1d27a74659855e44 = function useTrackedRef(value) {
    var ref = (0, $5FkrB.useRef)(value);
    ref.current = value;
    return ref;
};

});





parcelRegister("lzPgc", function(module, exports) {
$parcel$export(module.exports, "NAVIGATION_CONTEXT", () => $fb54a115516e258d$export$1fd3aad76a7c6788);

var $gA3qV = parcelRequire("gA3qV");
var $fb54a115516e258d$export$1fd3aad76a7c6788 = 'navigationCtx';
var $fb54a115516e258d$export$d0a82da1a0b94929 = (0, $gA3qV.default)($fb54a115516e258d$export$1fd3aad76a7c6788, 'NavigationAnalyticsContext');

});

parcelRegister("kHFeb", function(module, exports) {
$parcel$export(module.exports, "EDITOR_CONTEXT", () => $f127cdcabdc66218$export$8c8f6d8f1fa796f0);
$parcel$export(module.exports, "EDITOR_APPEARANCE_CONTEXT", () => $f127cdcabdc66218$export$9eb2b47430ed3f7c);
$parcel$export(module.exports, "FabricEditorAnalyticsContext", () => $f127cdcabdc66218$export$629cada6c5e621e1);

var $gA3qV = parcelRequire("gA3qV");
var $f127cdcabdc66218$export$8c8f6d8f1fa796f0 = 'fabricEditorCtx';
var $f127cdcabdc66218$export$9eb2b47430ed3f7c = /*#__PURE__*/ function(EDITOR_APPEARANCE_CONTEXT) {
    EDITOR_APPEARANCE_CONTEXT["FIXED_WIDTH"] = "fixedWidth";
    EDITOR_APPEARANCE_CONTEXT["FULL_WIDTH"] = "fullWidth";
    EDITOR_APPEARANCE_CONTEXT["COMMENT"] = "comment";
    EDITOR_APPEARANCE_CONTEXT["CHROMELESS"] = "chromeless";
    EDITOR_APPEARANCE_CONTEXT["MOBILE"] = "mobile";
    EDITOR_APPEARANCE_CONTEXT["MAX"] = "max";
    return EDITOR_APPEARANCE_CONTEXT;
}({});
var $f127cdcabdc66218$export$629cada6c5e621e1 = (0, $gA3qV.default)($f127cdcabdc66218$export$8c8f6d8f1fa796f0, 'FabricEditorAnalyticsContext');

});

parcelRegister("gwzFf", function(module, exports) {
$parcel$export(module.exports, "MEDIA_CONTEXT", () => $c07b4cab76aa5901$export$70df29c238ba7306);
// Media uses a namespaced analytics context under the following key MEDIA_CONTEXT.
var $c07b4cab76aa5901$export$70df29c238ba7306 = 'mediaCtx'; // However we don't export any JSX component to create that namespaced analytics context.
 // In media components, analytics context is being created by this component:
 // @see packages/media/media-common/src/analytics/withMediaAnalyticsContext.tsx

});

parcelRegister("coUGQ", function(module, exports) {
$parcel$export(module.exports, "PEOPLE_TEAMS_CONTEXT", () => $9073b35d423b273a$export$b326383bee6cb993);

var $gA3qV = parcelRequire("gA3qV");
var $9073b35d423b273a$export$b326383bee6cb993 = 'peopleTeamsCtx';
var $9073b35d423b273a$export$4119ddb38ccbfb87 = (0, $gA3qV.default)($9073b35d423b273a$export$b326383bee6cb993, 'PeopleTeamsAnalyticsContext');

});

parcelRegister("gYBV8", function(module, exports) {
$parcel$export(module.exports, "NOTIFICATIONS_CONTEXT", () => $c5bfaa24e1ac3102$export$da1befb791e93c7e);

var $gA3qV = parcelRequire("gA3qV");
var $c5bfaa24e1ac3102$export$da1befb791e93c7e = 'NotificationsCtx';
var $c5bfaa24e1ac3102$export$6f8e7ff1e3feafd7 = (0, $gA3qV.default)($c5bfaa24e1ac3102$export$da1befb791e93c7e, 'NotificationsAnalyticsContext');

});

parcelRegister("dr6Uf", function(module, exports) {
$parcel$export(module.exports, "RECENT_WORK_CONTEXT", () => $9c832766ec71e470$export$fc7a65795610cb71);

var $gA3qV = parcelRequire("gA3qV");
var $9c832766ec71e470$export$fc7a65795610cb71 = 'RecentWorkCtx';
var $9c832766ec71e470$export$745926731087ebe2 = (0, $gA3qV.default)($9c832766ec71e470$export$fc7a65795610cb71, 'RecentWorkAnalyticsContext');

});

parcelRegister("dT6JI", function(module, exports) {
$parcel$export(module.exports, "ATLAS_CONTEXT", () => $a1c5a3176be927c9$export$4906017439f33fc0);

var $gA3qV = parcelRequire("gA3qV");
var $a1c5a3176be927c9$export$4906017439f33fc0 = 'atlasCtx';
var $a1c5a3176be927c9$export$43ebbe41370d4543 = (0, $gA3qV.default)($a1c5a3176be927c9$export$4906017439f33fc0, 'AtlasAnalyticsContext');

});

parcelRegister("kBCsH", function(module, exports) {
$parcel$export(module.exports, "TOWNSQUARE_HOME_CONTEXT", () => $f005190eed2cf2cd$export$aa18ab4fff926c9e);

var $gA3qV = parcelRequire("gA3qV");
var $f005190eed2cf2cd$export$aa18ab4fff926c9e = 'townsquareHomeCtx';
var $f005190eed2cf2cd$export$d283110f5d85c8f2 = (0, $gA3qV.default)($f005190eed2cf2cd$export$aa18ab4fff926c9e, 'TownsquareHomeAnalyticsContext');

});

parcelRegister("bvSsd", function(module, exports) {
$parcel$export(module.exports, "LINKING_PLATFORM_CONTEXT", () => $861cd462966d849a$export$3240443bf2b83834);

var $gA3qV = parcelRequire("gA3qV");
var $861cd462966d849a$export$3240443bf2b83834 = 'linkingPlatformCtx';
var $861cd462966d849a$export$6d568da622ce0a08 = (0, $gA3qV.default)($861cd462966d849a$export$3240443bf2b83834, 'LinkingPlatformAnalyticsContext');

});

parcelRegister("9qmI1", function(module, exports) {
$parcel$export(module.exports, "POST_OFFICE_CONTEXT", () => $6dc82853dd29f159$export$ef0c05448f0f8f9);

var $gA3qV = parcelRequire("gA3qV");
var $6dc82853dd29f159$export$ef0c05448f0f8f9 = 'postOfficeCtx';
var $6dc82853dd29f159$export$dcd232f3be312f94 = (0, $gA3qV.default)($6dc82853dd29f159$export$ef0c05448f0f8f9, 'PostOfficeAnalyticsContext');

});

parcelRegister("draJh", function(module, exports) {
$parcel$export(module.exports, "AI_MATE_CONTEXT", () => $9c861e9da48289b6$export$5c3a6fd8b96e8b66);

var $gA3qV = parcelRequire("gA3qV");
var $9c861e9da48289b6$export$5c3a6fd8b96e8b66 = 'aiMateCtx';
var $9c861e9da48289b6$export$de3826c30468da26 = (0, $gA3qV.default)($9c861e9da48289b6$export$5c3a6fd8b96e8b66, 'AIMateAnalyticsContext');

});

parcelRegister("dRe9Q", function(module, exports) {
$parcel$export(module.exports, "AVP_CONTEXT", () => $a16b35082cd06ec4$export$c2a811a4e42f4af5);

var $gA3qV = parcelRequire("gA3qV");
var $a16b35082cd06ec4$export$c2a811a4e42f4af5 = 'avpCtx';
var $a16b35082cd06ec4$export$da383e8879a25b03 = (0, $gA3qV.default)($a16b35082cd06ec4$export$c2a811a4e42f4af5, 'AVPAnalyticsContext');

});

parcelRegister("a4wHv", function(module, exports) {
$parcel$export(module.exports, "GROWTH_CONTEXT", () => $7553a4cc2e10b4b0$export$82023f2f4bfb06c1);

var $gA3qV = parcelRequire("gA3qV");
var $7553a4cc2e10b4b0$export$82023f2f4bfb06c1 = 'editionAwarenessCtx';
var $7553a4cc2e10b4b0$export$84980182680018f = (0, $gA3qV.default)($7553a4cc2e10b4b0$export$82023f2f4bfb06c1, 'GrowthAnalyticsContext');

});

parcelRegister("LLMKz", function(module, exports) {
$parcel$export(module.exports, "OMNI_CHANNEL_CONTEXT", () => $08f975109aa0e40e$export$6d3c48fd1b3e4f3b);

var $gA3qV = parcelRequire("gA3qV");
var $08f975109aa0e40e$export$6d3c48fd1b3e4f3b = 'omniChannelCtx';
var $08f975109aa0e40e$export$e4e6df99270bbbb1 = (0, $gA3qV.default)($08f975109aa0e40e$export$6d3c48fd1b3e4f3b, 'OmniChannelAnalyticsContext');

});

parcelRegister("cmtzP", function(module, exports) {
$parcel$export(module.exports, "ROVO_EXTENSION_CONTEXT", () => $8ffe7b7542c06b07$export$fae437eb1dd9520c);

var $gA3qV = parcelRequire("gA3qV");
var $8ffe7b7542c06b07$export$fae437eb1dd9520c = 'rovoExtensionCtx';
var $8ffe7b7542c06b07$export$7fcecc25ee38fbef = (0, $gA3qV.default)($8ffe7b7542c06b07$export$fae437eb1dd9520c, 'RovoExtensionAnalyticsContext');

});


parcelRegister("5rVTQ", function(module, exports) {

var $4AIzG = parcelRequire("4AIzG");
/**
 * Casts `array` to a slice if it's needed.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {number} start The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the cast slice.
 */ function $3f7c630e82d8e1a9$var$castSlice(array, start, end) {
    var length = array.length;
    end = end === undefined ? length : end;
    return !start && end >= length ? array : $4AIzG(array, start, end);
}
module.exports = $3f7c630e82d8e1a9$var$castSlice;

});
parcelRegister("4AIzG", function(module, exports) {
/**
 * The base implementation of `_.slice` without an iteratee call guard.
 *
 * @private
 * @param {Array} array The array to slice.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the slice of `array`.
 */ function $357d19d0d54cb643$var$baseSlice(array, start, end) {
    var index = -1, length = array.length;
    if (start < 0) start = -start > length ? 0 : length + start;
    end = end > length ? length : end;
    if (end < 0) end += length;
    length = start > end ? 0 : end - start >>> 0;
    start >>>= 0;
    var result = Array(length);
    while(++index < length)result[index] = array[index + start];
    return result;
}
module.exports = $357d19d0d54cb643$var$baseSlice;

});


parcelRegister("3gUX4", function(module, exports) {
/** Used to compose unicode character classes. */ var $261f0b2a4c7f027e$var$rsAstralRange = '\\ud800-\\udfff', $261f0b2a4c7f027e$var$rsComboMarksRange = '\\u0300-\\u036f', $261f0b2a4c7f027e$var$reComboHalfMarksRange = '\\ufe20-\\ufe2f', $261f0b2a4c7f027e$var$rsComboSymbolsRange = '\\u20d0-\\u20ff', $261f0b2a4c7f027e$var$rsComboRange = $261f0b2a4c7f027e$var$rsComboMarksRange + $261f0b2a4c7f027e$var$reComboHalfMarksRange + $261f0b2a4c7f027e$var$rsComboSymbolsRange, $261f0b2a4c7f027e$var$rsVarRange = '\\ufe0e\\ufe0f';
/** Used to compose unicode capture groups. */ var $261f0b2a4c7f027e$var$rsZWJ = '\\u200d';
/** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */ var $261f0b2a4c7f027e$var$reHasUnicode = RegExp('[' + $261f0b2a4c7f027e$var$rsZWJ + $261f0b2a4c7f027e$var$rsAstralRange + $261f0b2a4c7f027e$var$rsComboRange + $261f0b2a4c7f027e$var$rsVarRange + ']');
/**
 * Checks if `string` contains Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a symbol is found, else `false`.
 */ function $261f0b2a4c7f027e$var$hasUnicode(string) {
    return $261f0b2a4c7f027e$var$reHasUnicode.test(string);
}
module.exports = $261f0b2a4c7f027e$var$hasUnicode;

});

parcelRegister("aqMZB", function(module, exports) {

var $6e8CA = parcelRequire("6e8CA");

var $3gUX4 = parcelRequire("3gUX4");

var $crUez = parcelRequire("crUez");
/**
 * Converts `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */ function $7982560623280317$var$stringToArray(string) {
    return $3gUX4(string) ? $crUez(string) : $6e8CA(string);
}
module.exports = $7982560623280317$var$stringToArray;

});
parcelRegister("6e8CA", function(module, exports) {
/**
 * Converts an ASCII `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */ function $488abce9e61dd352$var$asciiToArray(string) {
    return string.split('');
}
module.exports = $488abce9e61dd352$var$asciiToArray;

});

parcelRegister("crUez", function(module, exports) {
/** Used to compose unicode character classes. */ var $9103a08849585e50$var$rsAstralRange = '\\ud800-\\udfff', $9103a08849585e50$var$rsComboMarksRange = '\\u0300-\\u036f', $9103a08849585e50$var$reComboHalfMarksRange = '\\ufe20-\\ufe2f', $9103a08849585e50$var$rsComboSymbolsRange = '\\u20d0-\\u20ff', $9103a08849585e50$var$rsComboRange = $9103a08849585e50$var$rsComboMarksRange + $9103a08849585e50$var$reComboHalfMarksRange + $9103a08849585e50$var$rsComboSymbolsRange, $9103a08849585e50$var$rsVarRange = '\\ufe0e\\ufe0f';
/** Used to compose unicode capture groups. */ var $9103a08849585e50$var$rsAstral = '[' + $9103a08849585e50$var$rsAstralRange + ']', $9103a08849585e50$var$rsCombo = '[' + $9103a08849585e50$var$rsComboRange + ']', $9103a08849585e50$var$rsFitz = '\\ud83c[\\udffb-\\udfff]', $9103a08849585e50$var$rsModifier = '(?:' + $9103a08849585e50$var$rsCombo + '|' + $9103a08849585e50$var$rsFitz + ')', $9103a08849585e50$var$rsNonAstral = '[^' + $9103a08849585e50$var$rsAstralRange + ']', $9103a08849585e50$var$rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}', $9103a08849585e50$var$rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]', $9103a08849585e50$var$rsZWJ = '\\u200d';
/** Used to compose unicode regexes. */ var $9103a08849585e50$var$reOptMod = $9103a08849585e50$var$rsModifier + '?', $9103a08849585e50$var$rsOptVar = '[' + $9103a08849585e50$var$rsVarRange + ']?', $9103a08849585e50$var$rsOptJoin = '(?:' + $9103a08849585e50$var$rsZWJ + '(?:' + [
    $9103a08849585e50$var$rsNonAstral,
    $9103a08849585e50$var$rsRegional,
    $9103a08849585e50$var$rsSurrPair
].join('|') + ')' + $9103a08849585e50$var$rsOptVar + $9103a08849585e50$var$reOptMod + ')*', $9103a08849585e50$var$rsSeq = $9103a08849585e50$var$rsOptVar + $9103a08849585e50$var$reOptMod + $9103a08849585e50$var$rsOptJoin, $9103a08849585e50$var$rsSymbol = '(?:' + [
    $9103a08849585e50$var$rsNonAstral + $9103a08849585e50$var$rsCombo + '?',
    $9103a08849585e50$var$rsCombo,
    $9103a08849585e50$var$rsRegional,
    $9103a08849585e50$var$rsSurrPair,
    $9103a08849585e50$var$rsAstral
].join('|') + ')';
/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */ var $9103a08849585e50$var$reUnicode = RegExp($9103a08849585e50$var$rsFitz + '(?=' + $9103a08849585e50$var$rsFitz + ')|' + $9103a08849585e50$var$rsSymbol + $9103a08849585e50$var$rsSeq, 'g');
/**
 * Converts a Unicode `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */ function $9103a08849585e50$var$unicodeToArray(string) {
    return string.match($9103a08849585e50$var$reUnicode) || [];
}
module.exports = $9103a08849585e50$var$unicodeToArray;

});


parcelRegister("l75Tm", function(module, exports) {

var $6yyTH = parcelRequire("6yyTH");

var $duo48 = parcelRequire("duo48");
/** Used to match Latin Unicode letters (excluding mathematical operators). */ var $f5eed274d1d1f151$var$reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
/** Used to compose unicode character classes. */ var $f5eed274d1d1f151$var$rsComboMarksRange = '\\u0300-\\u036f', $f5eed274d1d1f151$var$reComboHalfMarksRange = '\\ufe20-\\ufe2f', $f5eed274d1d1f151$var$rsComboSymbolsRange = '\\u20d0-\\u20ff', $f5eed274d1d1f151$var$rsComboRange = $f5eed274d1d1f151$var$rsComboMarksRange + $f5eed274d1d1f151$var$reComboHalfMarksRange + $f5eed274d1d1f151$var$rsComboSymbolsRange;
/** Used to compose unicode capture groups. */ var $f5eed274d1d1f151$var$rsCombo = '[' + $f5eed274d1d1f151$var$rsComboRange + ']';
/**
 * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
 * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
 */ var $f5eed274d1d1f151$var$reComboMark = RegExp($f5eed274d1d1f151$var$rsCombo, 'g');
/**
 * Deburrs `string` by converting
 * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
 * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
 * letters to basic Latin letters and removing
 * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to deburr.
 * @returns {string} Returns the deburred string.
 * @example
 *
 * _.deburr('déjà vu');
 * // => 'deja vu'
 */ function $f5eed274d1d1f151$var$deburr(string) {
    string = $duo48(string);
    return string && string.replace($f5eed274d1d1f151$var$reLatin, $6yyTH).replace($f5eed274d1d1f151$var$reComboMark, '');
}
module.exports = $f5eed274d1d1f151$var$deburr;

});
parcelRegister("6yyTH", function(module, exports) {

var $1BUSy = parcelRequire("1BUSy");
/** Used to map Latin Unicode letters to basic Latin letters. */ var $4c60fcf10f95fb75$var$deburredLetters = {
    // Latin-1 Supplement block.
    '\xc0': 'A',
    '\xc1': 'A',
    '\xc2': 'A',
    '\xc3': 'A',
    '\xc4': 'A',
    '\xc5': 'A',
    '\xe0': 'a',
    '\xe1': 'a',
    '\xe2': 'a',
    '\xe3': 'a',
    '\xe4': 'a',
    '\xe5': 'a',
    '\xc7': 'C',
    '\xe7': 'c',
    '\xd0': 'D',
    '\xf0': 'd',
    '\xc8': 'E',
    '\xc9': 'E',
    '\xca': 'E',
    '\xcb': 'E',
    '\xe8': 'e',
    '\xe9': 'e',
    '\xea': 'e',
    '\xeb': 'e',
    '\xcc': 'I',
    '\xcd': 'I',
    '\xce': 'I',
    '\xcf': 'I',
    '\xec': 'i',
    '\xed': 'i',
    '\xee': 'i',
    '\xef': 'i',
    '\xd1': 'N',
    '\xf1': 'n',
    '\xd2': 'O',
    '\xd3': 'O',
    '\xd4': 'O',
    '\xd5': 'O',
    '\xd6': 'O',
    '\xd8': 'O',
    '\xf2': 'o',
    '\xf3': 'o',
    '\xf4': 'o',
    '\xf5': 'o',
    '\xf6': 'o',
    '\xf8': 'o',
    '\xd9': 'U',
    '\xda': 'U',
    '\xdb': 'U',
    '\xdc': 'U',
    '\xf9': 'u',
    '\xfa': 'u',
    '\xfb': 'u',
    '\xfc': 'u',
    '\xdd': 'Y',
    '\xfd': 'y',
    '\xff': 'y',
    '\xc6': 'Ae',
    '\xe6': 'ae',
    '\xde': 'Th',
    '\xfe': 'th',
    '\xdf': 'ss',
    // Latin Extended-A block.
    '\u0100': 'A',
    '\u0102': 'A',
    '\u0104': 'A',
    '\u0101': 'a',
    '\u0103': 'a',
    '\u0105': 'a',
    '\u0106': 'C',
    '\u0108': 'C',
    '\u010a': 'C',
    '\u010c': 'C',
    '\u0107': 'c',
    '\u0109': 'c',
    '\u010b': 'c',
    '\u010d': 'c',
    '\u010e': 'D',
    '\u0110': 'D',
    '\u010f': 'd',
    '\u0111': 'd',
    '\u0112': 'E',
    '\u0114': 'E',
    '\u0116': 'E',
    '\u0118': 'E',
    '\u011a': 'E',
    '\u0113': 'e',
    '\u0115': 'e',
    '\u0117': 'e',
    '\u0119': 'e',
    '\u011b': 'e',
    '\u011c': 'G',
    '\u011e': 'G',
    '\u0120': 'G',
    '\u0122': 'G',
    '\u011d': 'g',
    '\u011f': 'g',
    '\u0121': 'g',
    '\u0123': 'g',
    '\u0124': 'H',
    '\u0126': 'H',
    '\u0125': 'h',
    '\u0127': 'h',
    '\u0128': 'I',
    '\u012a': 'I',
    '\u012c': 'I',
    '\u012e': 'I',
    '\u0130': 'I',
    '\u0129': 'i',
    '\u012b': 'i',
    '\u012d': 'i',
    '\u012f': 'i',
    '\u0131': 'i',
    '\u0134': 'J',
    '\u0135': 'j',
    '\u0136': 'K',
    '\u0137': 'k',
    '\u0138': 'k',
    '\u0139': 'L',
    '\u013b': 'L',
    '\u013d': 'L',
    '\u013f': 'L',
    '\u0141': 'L',
    '\u013a': 'l',
    '\u013c': 'l',
    '\u013e': 'l',
    '\u0140': 'l',
    '\u0142': 'l',
    '\u0143': 'N',
    '\u0145': 'N',
    '\u0147': 'N',
    '\u014a': 'N',
    '\u0144': 'n',
    '\u0146': 'n',
    '\u0148': 'n',
    '\u014b': 'n',
    '\u014c': 'O',
    '\u014e': 'O',
    '\u0150': 'O',
    '\u014d': 'o',
    '\u014f': 'o',
    '\u0151': 'o',
    '\u0154': 'R',
    '\u0156': 'R',
    '\u0158': 'R',
    '\u0155': 'r',
    '\u0157': 'r',
    '\u0159': 'r',
    '\u015a': 'S',
    '\u015c': 'S',
    '\u015e': 'S',
    '\u0160': 'S',
    '\u015b': 's',
    '\u015d': 's',
    '\u015f': 's',
    '\u0161': 's',
    '\u0162': 'T',
    '\u0164': 'T',
    '\u0166': 'T',
    '\u0163': 't',
    '\u0165': 't',
    '\u0167': 't',
    '\u0168': 'U',
    '\u016a': 'U',
    '\u016c': 'U',
    '\u016e': 'U',
    '\u0170': 'U',
    '\u0172': 'U',
    '\u0169': 'u',
    '\u016b': 'u',
    '\u016d': 'u',
    '\u016f': 'u',
    '\u0171': 'u',
    '\u0173': 'u',
    '\u0174': 'W',
    '\u0175': 'w',
    '\u0176': 'Y',
    '\u0177': 'y',
    '\u0178': 'Y',
    '\u0179': 'Z',
    '\u017b': 'Z',
    '\u017d': 'Z',
    '\u017a': 'z',
    '\u017c': 'z',
    '\u017e': 'z',
    '\u0132': 'IJ',
    '\u0133': 'ij',
    '\u0152': 'Oe',
    '\u0153': 'oe',
    '\u0149': "'n",
    '\u017f': 's'
};
/**
 * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
 * letters to basic Latin letters.
 *
 * @private
 * @param {string} letter The matched letter to deburr.
 * @returns {string} Returns the deburred letter.
 */ var $4c60fcf10f95fb75$var$deburrLetter = $1BUSy($4c60fcf10f95fb75$var$deburredLetters);
module.exports = $4c60fcf10f95fb75$var$deburrLetter;

});
parcelRegister("1BUSy", function(module, exports) {
/**
 * The base implementation of `_.propertyOf` without support for deep paths.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Function} Returns the new accessor function.
 */ function $12c55e16f3aa6a95$var$basePropertyOf(object) {
    return function(key) {
        return object == null ? undefined : object[key];
    };
}
module.exports = $12c55e16f3aa6a95$var$basePropertyOf;

});



parcelRegister("drUcN", function(module, exports) {
$parcel$export(module.exports, "expValEquals", () => $9ca9653566c8c199$export$45abdb3f977b5b14);

var $77PRV = parcelRequire("77PRV");
function $9ca9653566c8c199$export$45abdb3f977b5b14(experimentName, experimentParam, experimentExpectedValue) {
    var experimentDefaultValue = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
    return (0, $77PRV.expValEqualsInternal)(experimentName, experimentParam, experimentExpectedValue, experimentDefaultValue, true);
}

});
parcelRegister("77PRV", function(module, exports) {
$parcel$export(module.exports, "expValEqualsInternal", () => $53016be5c91572ba$export$58e581060588c6bb);

var $8dj3L = parcelRequire("8dj3L");

var $8qy01 = parcelRequire("8qy01");

var $75k6K = parcelRequire("75k6K");
function $53016be5c91572ba$export$58e581060588c6bb(experimentName, experimentParam, experimentExpectedValue, experimentDefaultValue, experimentExposure) {
    // @ts-ignore need to loosen the type here to allow for any experiment name
    if ((0, $75k6K._overrides)[experimentName] !== undefined) // This will be hit in the case of a test setting an override
    // @ts-ignore need to loosen the type here to allow for any experiment name
    return (0, $75k6K._overrides)[experimentName] === experimentExpectedValue;
    // If client is not initialized, we compare with the default value
    if (!(0, $8dj3L.default).initializeCompleted()) return experimentDefaultValue === experimentExpectedValue;
    // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
    var experimentValue = (0, $8dj3L.default).getExperimentValue(experimentName, experimentParam, experimentDefaultValue, {
        fireExperimentExposure: experimentExposure
    });
    if (// eslint-disable-next-line @atlaskit/platform/use-recommended-utils
    (0, $8dj3L.default).getExperimentValue('cc_editor_experiments_ufo_gate_reporting', 'isEnabled', false)) // Duplicated from /confluence/next/packages/feature-experiments/src/index.ts
    (0, $8qy01.addFeatureFlagAccessed)("".concat(experimentName, ":").concat(experimentParam), experimentValue);
    return experimentValue === experimentExpectedValue;
}

});


parcelRegister("9M0Oh", function(module, exports) {
$parcel$export(module.exports, "InlineCard", () => $71d9399e774f8bc8$export$aff6291803939b05);
$parcel$export(module.exports, "toReact", () => $71d9399e774f8bc8$export$d4334b129116aad7);
$parcel$export(module.exports, "mergeTextNodes", () => $71d9399e774f8bc8$export$8045509d14b5046f);
$parcel$export(module.exports, "isTextWrapper", () => $71d9399e774f8bc8$export$d4ebd3557ee7fac1);
$parcel$export(module.exports, "isTextNode", () => $71d9399e774f8bc8$export$ccbedd67ef6e9417);
$parcel$export(module.exports, "Doc", () => (parcelRequire("ac0Rs")).default);
$parcel$export(module.exports, "DocWithSelectAllTrap", () => (parcelRequire("ac0Rs")).DocWithSelectAllTrap);

var $25nEq = parcelRequire("25nEq");

var $bhmkE = parcelRequire("bhmkE");

var $5dFQJ = parcelRequire("5dFQJ");
var $2wYtd = parcelRequire("2wYtd");

var $9Zzpd = parcelRequire("9Zzpd");

var $anuR6 = parcelRequire("anuR6");

var $21Umc = parcelRequire("21Umc");

var $5gpFM = parcelRequire("5gpFM");

var $geLdv = parcelRequire("geLdv");

var $bHdFw = parcelRequire("bHdFw");

var $aJQyW = parcelRequire("aJQyW");

var $ac0Rs = parcelRequire("ac0Rs");

var $ksTq8 = parcelRequire("ksTq8");

var $2BMm8 = parcelRequire("2BMm8");

var $cLcT3 = parcelRequire("cLcT3");

var $iXLPT = parcelRequire("iXLPT");

var $betLp = parcelRequire("betLp");

var $7n8xE = parcelRequire("7n8xE");

var $fMHNb = parcelRequire("fMHNb");

var $4piwi = parcelRequire("4piwi");

var $1KF3y = parcelRequire("1KF3y");

var $jwO6B = parcelRequire("jwO6B");

var $7UBSy = parcelRequire("7UBSy");

var $1BsF5 = parcelRequire("1BsF5");

var $8tCqL = parcelRequire("8tCqL");

var $65d1I = parcelRequire("65d1I");

var $5FiyC = parcelRequire("5FiyC");

var $fK54y = parcelRequire("fK54y");
function $71d9399e774f8bc8$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $71d9399e774f8bc8$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $71d9399e774f8bc8$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $71d9399e774f8bc8$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}

// Ignored via go/ees005
// eslint-disable-next-line import/no-named-as-default
var $71d9399e774f8bc8$export$a22ee8f907eecb5f = (0, (/*@__PURE__*/$parcel$interopDefault($bhmkE)))({
    loader: function loader() {
        return (parcelRequire("bHoWr")).then(function(mod) {
            return mod.default;
        });
    },
    loading: function loading() {
        return null;
    }
});

var $71d9399e774f8bc8$export$6c415d1fdae3dfdb = (0, (/*@__PURE__*/$parcel$interopDefault($bhmkE)))({
    loader: function loader() {
        return (parcelRequire("73HyM")).then(function(mod) {
            return mod.default;
        });
    },
    loading: function loading() {
        return null;
    }
});

var $71d9399e774f8bc8$export$771a55a10b0a40ae = (0, (/*@__PURE__*/$parcel$interopDefault($bhmkE)))({
    loader: function loader() {
        return (parcelRequire("ahHfv")).then(function(mod) {
            return mod.default;
        });
    },
    loading: function loading() {
        return null;
    }
});

var $71d9399e774f8bc8$export$27c4189b8be1bf93 = (0, (/*@__PURE__*/$parcel$interopDefault($bhmkE)))({
    loader: function loader() {
        return (parcelRequire("1enik")).then(function(mod) {
            return mod.default;
        });
    },
    loading: function loading() {
        return null;
    }
});

var $71d9399e774f8bc8$export$b458dfa720128865 = (0, (/*@__PURE__*/$parcel$interopDefault($bhmkE)))({
    loader: function loader() {
        return (parcelRequire("bfIlp")).then(function(mod) {
            return mod.default;
        });
    },
    loading: function loading() {
        return null;
    }
});

var $71d9399e774f8bc8$export$b6f73a2b0b0de599 = (0, (/*@__PURE__*/$parcel$interopDefault($bhmkE)))({
    loader: function loader() {
        return (parcelRequire("laTH3")).then(function(mod) {
            return mod.default;
        });
    },
    loading: function loading() {
        return null;
    }
});

var $71d9399e774f8bc8$export$6341f9a885713487 = (0, (/*@__PURE__*/$parcel$interopDefault($bhmkE)))({
    loader: function loader() {
        return (parcelRequire("1Oi6Q")).then(function(mod) {
            return mod.default;
        });
    },
    loading: function loading() {
        return null;
    }
});

var $71d9399e774f8bc8$export$96e9906d6d93a972 = (0, (/*@__PURE__*/$parcel$interopDefault($bhmkE)))({
    loader: function loader() {
        return (parcelRequire("bAEpH")).then(function(mod) {
            return mod.default;
        });
    },
    loading: function loading() {
        return null;
    }
});

var $71d9399e774f8bc8$export$56cc48506ff790a = (0, (/*@__PURE__*/$parcel$interopDefault($bhmkE)))({
    loader: function loader() {
        return (parcelRequire("4Sk34")).then(function(mod) {
            return mod.default;
        });
    },
    loading: function loading() {
        return null;
    }
});

var $71d9399e774f8bc8$export$2ddb90ad54e5f587 = (0, (/*@__PURE__*/$parcel$interopDefault($bhmkE)))({
    loader: function loader() {
        return (parcelRequire("4IZkt")).then(function(mod) {
            return mod.default;
        });
    },
    loading: function loading() {
        return null;
    }
});

var $71d9399e774f8bc8$export$6789d7ecdc77631b = (0, (/*@__PURE__*/$parcel$interopDefault($bhmkE)))({
    loader: function loader() {
        return (parcelRequire("cNkzS")).then(function(mod) {
            return mod.default;
        });
    },
    loading: function loading() {
        return null;
    }
});

var $71d9399e774f8bc8$export$aff6291803939b05 = (0, (/*@__PURE__*/$parcel$interopDefault($bhmkE)))({
    loader: function loader() {
        return (parcelRequire("2W7Eu")).then(function(mod) {
            return mod.default;
        });
    },
    loading: function loading() {
        return null;
    }
});

var $71d9399e774f8bc8$export$d18ccd25c0d2c6b0 = (0, (/*@__PURE__*/$parcel$interopDefault($bhmkE)))({
    loader: function loader() {
        return (parcelRequire("1JpLn")).then(function(mod) {
            return mod.default;
        });
    },
    loading: function loading() {
        return null;
    }
});

var $71d9399e774f8bc8$export$7fc53215244aec38 = (0, (/*@__PURE__*/$parcel$interopDefault($bhmkE)))({
    loader: function loader() {
        return (parcelRequire("39Ap2")).then(function(mod) {
            return mod.default;
        });
    },
    loading: function loading() {
        return null;
    }
});

var $71d9399e774f8bc8$export$d7858be3df00d59 = (0, (/*@__PURE__*/$parcel$interopDefault($bhmkE)))({
    loader: function loader() {
        return (parcelRequire("2bcaO")).then(function(mod) {
            return mod.default;
        });
    },
    loading: function loading() {
        return null;
    }
});

var $71d9399e774f8bc8$export$462ea7c2a1c4cb1f = (0, (/*@__PURE__*/$parcel$interopDefault($bhmkE)))({
    loader: function loader() {
        return (parcelRequire("eDoW2")).then(function(mod) {
            return mod.default;
        });
    },
    loading: function loading() {
        return null;
    }
});

var $71d9399e774f8bc8$export$888d74bc001c3a5d = (0, (/*@__PURE__*/$parcel$interopDefault($bhmkE)))({
    loader: function loader() {
        return (parcelRequire("hvJEH")).then(function(mod) {
            return mod.default;
        });
    },
    loading: function loading() {
        return null;
    }
});

var $71d9399e774f8bc8$export$e891316fea657d90 = (0, (/*@__PURE__*/$parcel$interopDefault($bhmkE)))({
    loader: function loader() {
        return (parcelRequire("hM7Ra")).then(function(mod) {
            return mod.default;
        });
    },
    loading: function loading() {
        return null;
    }
});

var $71d9399e774f8bc8$export$49bd1dfb0ad29c40 = (0, (/*@__PURE__*/$parcel$interopDefault($bhmkE)))({
    loader: function loader() {
        return (parcelRequire("1o3cc")).then(function(mod) {
            return mod.default;
        });
    },
    loading: function loading() {
        return null;
    }
});

var $71d9399e774f8bc8$var$SyncBlockLoader = (0, (/*@__PURE__*/$parcel$interopDefault($bhmkE)))({
    loader: function loader() {
        return (parcelRequire("61mDg")).then(function(mod) {
            return mod.default;
        });
    },
    loading: function loading() {
        return null;
    }
});

var $71d9399e774f8bc8$var$BodiedSyncBlock = (0, (/*@__PURE__*/$parcel$interopDefault($bhmkE)))({
    loader: function loader() {
        return (parcelRequire("8GAYC")).then(function(mod) {
            return mod.default;
        });
    },
    loading: function loading() {
        return null;
    }
});
var $71d9399e774f8bc8$export$3931063f6a5f290e = {
    blockquote: (0, $anuR6.default),
    bulletList: (0, $aJQyW.default),
    blockCard: $71d9399e774f8bc8$export$d18ccd25c0d2c6b0,
    caption: (0, $4piwi.default),
    date: $71d9399e774f8bc8$export$6341f9a885713487,
    decisionItem: $71d9399e774f8bc8$export$b6f73a2b0b0de599,
    decisionList: $71d9399e774f8bc8$export$b458dfa720128865,
    doc: (0, $ac0Rs.default),
    emoji: $71d9399e774f8bc8$export$56cc48506ff790a,
    extension: (0, $ksTq8.default),
    bodiedExtension: (0, $21Umc.default),
    multiBodiedExtension: (0, $geLdv.default),
    extensionFrame: (0, $bHdFw.default),
    hardBreak: (0, $2BMm8.default),
    heading: (0, $cLcT3.default),
    inlineCard: $71d9399e774f8bc8$export$aff6291803939b05,
    inlineExtension: (0, $iXLPT.default),
    layoutSection: (0, $betLp.default),
    layoutColumn: (0, $7n8xE.default),
    listItem: (0, $fMHNb.default),
    media: $71d9399e774f8bc8$export$7fc53215244aec38,
    mediaGroup: $71d9399e774f8bc8$export$d7858be3df00d59,
    mediaInline: $71d9399e774f8bc8$export$462ea7c2a1c4cb1f,
    mediaSingle: $71d9399e774f8bc8$export$888d74bc001c3a5d,
    mention: $71d9399e774f8bc8$export$e891316fea657d90,
    orderedList: (0, $1KF3y.default),
    panel: $71d9399e774f8bc8$export$2ddb90ad54e5f587,
    paragraph: (0, $jwO6B.default),
    placeholder: (0, $7UBSy.default),
    rule: (0, $1BsF5.default),
    status: $71d9399e774f8bc8$export$96e9906d6d93a972,
    taskItem: $71d9399e774f8bc8$export$27c4189b8be1bf93,
    taskList: $71d9399e774f8bc8$export$771a55a10b0a40ae,
    table: (0, $8tCqL.default),
    tableCell: (0, $65d1I.TableCell),
    tableHeader: (0, $65d1I.TableHeader),
    tableRow: (0, $5FiyC.default),
    unknownBlock: (0, $fK54y.default),
    unsupportedBlock: (0, $5dFQJ.default),
    unsupportedInline: (0, $2wYtd.default),
    expand: $71d9399e774f8bc8$export$49bd1dfb0ad29c40,
    syncBlock: $71d9399e774f8bc8$var$SyncBlockLoader,
    bodiedSyncBlock: $71d9399e774f8bc8$var$BodiedSyncBlock,
    nestedExpand: $71d9399e774f8bc8$export$49bd1dfb0ad29c40,
    embedCard: $71d9399e774f8bc8$export$6789d7ecdc77631b,
    blockTaskItem: $71d9399e774f8bc8$export$27c4189b8be1bf93
};
var $71d9399e774f8bc8$export$d4334b129116aad7 = function toReact(node, flags, nodeComponents) {
    if (node.type.name === 'doc' && (flags === null || flags === void 0 ? void 0 : flags.allowSelectAllTrap) === true) return 0, $ac0Rs.DocWithSelectAllTrap;
    if (!(0, $9Zzpd.fg)('jfp-magma-ssr-iv-editor-codeblock')) {
        if (node.type.name === 'codeBlock') {
            if ((flags === null || flags === void 0 ? void 0 : flags.allowWindowedCodeBlock) === true) return $71d9399e774f8bc8$export$a22ee8f907eecb5f;
            return $71d9399e774f8bc8$export$6c415d1fdae3dfdb;
        }
    }
    // Allowing custom components to override those provided in nodeToReact
    var nodes = $71d9399e774f8bc8$var$_objectSpread($71d9399e774f8bc8$var$_objectSpread({}, $71d9399e774f8bc8$export$3931063f6a5f290e), nodeComponents);
    if ((0, $9Zzpd.fg)('jfp-magma-ssr-iv-editor-codeblock')) {
        if (node.type.name === 'codeBlock') {
            var _nodes$codeBlock;
            if ((flags === null || flags === void 0 ? void 0 : flags.allowWindowedCodeBlock) === true) {
                var _nodes$windowedCodeBl;
                return (_nodes$windowedCodeBl = nodes.windowedCodeBlock) !== null && _nodes$windowedCodeBl !== void 0 ? _nodes$windowedCodeBl : $71d9399e774f8bc8$export$a22ee8f907eecb5f;
            }
            return (_nodes$codeBlock = nodes.codeBlock) !== null && _nodes$codeBlock !== void 0 ? _nodes$codeBlock : $71d9399e774f8bc8$export$6c415d1fdae3dfdb;
        }
    }
    nodes['multiBodiedExtension'] = (0, $9Zzpd.fg)('platform_editor_multi_body_extension_extensibility') ? (0, $geLdv.default) : (0, $5gpFM.default);
    return nodes[node.type.name];
};
var $71d9399e774f8bc8$export$8045509d14b5046f = function mergeTextNodes(nodes) {
    return nodes.reduce(function(acc, current) {
        if (!$71d9399e774f8bc8$export$1879817ac5c922b7(current.type.name)) {
            acc.push(current);
            return acc;
        }
        // Append node to previous node, if it was a text wrapper
        if (acc.length > 0 && $71d9399e774f8bc8$export$d4ebd3557ee7fac1(acc[acc.length - 1])) {
            var textWrapper = acc[acc.length - 1];
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            textWrapper.content.push(current);
            textWrapper.nodeSize += current.nodeSize;
        } else acc.push({
            type: {
                name: 'textWrapper'
            },
            content: [
                current
            ],
            nodeSize: current.nodeSize
        });
        return acc;
    }, []);
};
var $71d9399e774f8bc8$export$1879817ac5c922b7 = function isText(type) {
    return type === 'text';
};
var $71d9399e774f8bc8$export$d4ebd3557ee7fac1 = function isTextWrapper(node) {
    return node.type.name === 'textWrapper';
};
function $71d9399e774f8bc8$export$ccbedd67ef6e9417(node) {
    return node.type.name === 'text';
}
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
var $71d9399e774f8bc8$var$whitespaceRegex = /^\s*$/;
var $71d9399e774f8bc8$export$dd0c7365db1f79a5 = function isEmojiDoc(doc) {
    if (doc.childCount !== 1) return false;
    var parentNodes = [];
    doc.forEach(function(child) {
        return parentNodes.push(child);
    });
    var node = parentNodes[0];
    return node.type.name === 'paragraph' && $71d9399e774f8bc8$var$isEmojiBlock(node.content);
};
var $71d9399e774f8bc8$var$isEmojiBlock = function isEmojiBlock(pnode) {
    var content = [];
    // Optimisation for long documents - worst case block will be space-emoji-space
    if (pnode.childCount > 7) return false;
    pnode.forEach(function(child) {
        return content.push(child);
    });
    var emojiCount = 0;
    for(var i = 0; i < content.length; ++i){
        var node = content[i];
        switch(node.type.name){
            case 'text':
                if (node.text && !node.text.match($71d9399e774f8bc8$var$whitespaceRegex)) return false;
                continue;
            case 'emoji':
                if (++emojiCount > 3) return false;
                continue;
            default:
                // Only text and emoji nodes are allowed
                return false;
        }
    }
    return emojiCount > 0;
};

});
parcelRegister("bhmkE", function(module, exports) {
"use strict";
var $83629ae75cf58ece$var$_typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
    return typeof obj;
} : function(obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};
function $83629ae75cf58ece$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $83629ae75cf58ece$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $83629ae75cf58ece$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var $5FkrB = parcelRequire("5FkrB");

var $8vJ0V = parcelRequire("8vJ0V");
var $83629ae75cf58ece$var$ALL_INITIALIZERS = [];
var $83629ae75cf58ece$var$READY_INITIALIZERS = [];
function $83629ae75cf58ece$var$isWebpackReady(getModuleIds) {
    if ((typeof __webpack_modules__ === "undefined" ? "undefined" : $83629ae75cf58ece$var$_typeof(__webpack_modules__)) !== "object") return false;
    return getModuleIds().every(function(moduleId) {
        return typeof moduleId !== "undefined" && typeof __webpack_modules__[moduleId] !== "undefined";
    });
}
function $83629ae75cf58ece$var$load(loader) {
    var promise = loader();
    var state = {
        loading: true,
        loaded: null,
        error: null
    };
    state.promise = promise.then(function(loaded) {
        state.loading = false;
        state.loaded = loaded;
        return loaded;
    }).catch(function(err) {
        state.loading = false;
        state.error = err;
        throw err;
    });
    return state;
}
function $83629ae75cf58ece$var$loadMap(obj) {
    var state = {
        loading: false,
        loaded: {},
        error: null
    };
    var promises = [];
    try {
        Object.keys(obj).forEach(function(key) {
            var result = $83629ae75cf58ece$var$load(obj[key]);
            if (!result.loading) {
                state.loaded[key] = result.loaded;
                state.error = result.error;
            } else state.loading = true;
            promises.push(result.promise);
            result.promise.then(function(res) {
                state.loaded[key] = res;
            }).catch(function(err) {
                state.error = err;
            });
        });
    } catch (err) {
        state.error = err;
    }
    state.promise = Promise.all(promises).then(function(res) {
        state.loading = false;
        return res;
    }).catch(function(err) {
        state.loading = false;
        throw err;
    });
    return state;
}
function $83629ae75cf58ece$var$resolve(obj) {
    return obj && obj.__esModule ? obj.default : obj;
}
function $83629ae75cf58ece$var$render(loaded, props) {
    return $5FkrB.createElement($83629ae75cf58ece$var$resolve(loaded), props);
}
function $83629ae75cf58ece$var$createLoadableComponent(loadFn, options) {
    var _class, _temp;
    if (!options.loading) throw new Error("react-loadable requires a `loading` component");
    var opts = Object.assign({
        loader: null,
        loading: null,
        delay: 200,
        timeout: null,
        render: $83629ae75cf58ece$var$render,
        webpack: null,
        modules: null
    }, options);
    var res = null;
    function init() {
        if (!res) res = loadFn(opts.loader);
        return res.promise;
    }
    $83629ae75cf58ece$var$ALL_INITIALIZERS.push(init);
    if (typeof opts.webpack === "function") $83629ae75cf58ece$var$READY_INITIALIZERS.push(function() {
        if ($83629ae75cf58ece$var$isWebpackReady(opts.webpack)) return init();
    });
    return _temp = _class = function(_React$Component) {
        $83629ae75cf58ece$var$_inherits(LoadableComponent, _React$Component);
        function LoadableComponent(props) {
            $83629ae75cf58ece$var$_classCallCheck(this, LoadableComponent);
            var _this = $83629ae75cf58ece$var$_possibleConstructorReturn(this, _React$Component.call(this, props));
            _this.retry = function() {
                _this.setState({
                    error: null,
                    loading: true,
                    timedOut: false
                });
                res = loadFn(opts.loader);
                _this._loadModule();
            };
            init();
            _this.state = {
                error: res.error,
                pastDelay: false,
                timedOut: false,
                loading: res.loading,
                loaded: res.loaded
            };
            return _this;
        }
        LoadableComponent.preload = function preload() {
            return init();
        };
        LoadableComponent.prototype.componentWillMount = function componentWillMount() {
            this._mounted = true;
            this._loadModule();
        };
        LoadableComponent.prototype._loadModule = function _loadModule() {
            var _this2 = this;
            if (this.context.loadable && Array.isArray(opts.modules)) opts.modules.forEach(function(moduleName) {
                _this2.context.loadable.report(moduleName);
            });
            if (!res.loading) return;
            if (typeof opts.delay === "number") {
                if (opts.delay === 0) this.setState({
                    pastDelay: true
                });
                else this._delay = setTimeout(function() {
                    _this2.setState({
                        pastDelay: true
                    });
                }, opts.delay);
            }
            if (typeof opts.timeout === "number") this._timeout = setTimeout(function() {
                _this2.setState({
                    timedOut: true
                });
            }, opts.timeout);
            var update = function update() {
                if (!_this2._mounted) return;
                _this2.setState({
                    error: res.error,
                    loaded: res.loaded,
                    loading: res.loading
                });
                _this2._clearTimeouts();
            };
            res.promise.then(function() {
                update();
            }).catch(function(err) {
                update();
            });
        };
        LoadableComponent.prototype.componentWillUnmount = function componentWillUnmount() {
            this._mounted = false;
            this._clearTimeouts();
        };
        LoadableComponent.prototype._clearTimeouts = function _clearTimeouts() {
            clearTimeout(this._delay);
            clearTimeout(this._timeout);
        };
        LoadableComponent.prototype.render = function render() {
            if (this.state.loading || this.state.error) return $5FkrB.createElement(opts.loading, {
                isLoading: this.state.loading,
                pastDelay: this.state.pastDelay,
                timedOut: this.state.timedOut,
                error: this.state.error,
                retry: this.retry
            });
            else if (this.state.loaded) return opts.render(this.state.loaded, this.props);
            else return null;
        };
        return LoadableComponent;
    }($5FkrB.Component), _class.contextTypes = {
        loadable: $8vJ0V.shape({
            report: $8vJ0V.func.isRequired
        })
    }, _temp;
}
function $83629ae75cf58ece$var$Loadable(opts) {
    return $83629ae75cf58ece$var$createLoadableComponent($83629ae75cf58ece$var$load, opts);
}
function $83629ae75cf58ece$var$LoadableMap(opts) {
    if (typeof opts.render !== "function") throw new Error("LoadableMap requires a `render(loaded, props)` function");
    return $83629ae75cf58ece$var$createLoadableComponent($83629ae75cf58ece$var$loadMap, opts);
}
$83629ae75cf58ece$var$Loadable.Map = $83629ae75cf58ece$var$LoadableMap;
var $83629ae75cf58ece$var$Capture = function(_React$Component2) {
    $83629ae75cf58ece$var$_inherits(Capture, _React$Component2);
    function Capture() {
        $83629ae75cf58ece$var$_classCallCheck(this, Capture);
        return $83629ae75cf58ece$var$_possibleConstructorReturn(this, _React$Component2.apply(this, arguments));
    }
    Capture.prototype.getChildContext = function getChildContext() {
        return {
            loadable: {
                report: this.props.report
            }
        };
    };
    Capture.prototype.render = function render() {
        return $5FkrB.Children.only(this.props.children);
    };
    return Capture;
}($5FkrB.Component);
$83629ae75cf58ece$var$Capture.propTypes = {
    report: $8vJ0V.func.isRequired
};
$83629ae75cf58ece$var$Capture.childContextTypes = {
    loadable: $8vJ0V.shape({
        report: $8vJ0V.func.isRequired
    }).isRequired
};
$83629ae75cf58ece$var$Loadable.Capture = $83629ae75cf58ece$var$Capture;
function $83629ae75cf58ece$var$flushInitializers(initializers) {
    var promises = [];
    while(initializers.length){
        var init = initializers.pop();
        promises.push(init());
    }
    return Promise.all(promises).then(function() {
        if (initializers.length) return $83629ae75cf58ece$var$flushInitializers(initializers);
    });
}
$83629ae75cf58ece$var$Loadable.preloadAll = function() {
    return new Promise(function(resolve, reject) {
        $83629ae75cf58ece$var$flushInitializers($83629ae75cf58ece$var$ALL_INITIALIZERS).then(resolve, reject);
    });
};
$83629ae75cf58ece$var$Loadable.preloadReady = function() {
    return new Promise(function(resolve, reject) {
        // We always will resolve, errors should be handled within loading UIs.
        $83629ae75cf58ece$var$flushInitializers($83629ae75cf58ece$var$READY_INITIALIZERS).then(resolve, resolve);
    });
};
module.exports = $83629ae75cf58ece$var$Loadable;

});

parcelRegister("2wYtd", function(module, exports) {
$parcel$export(module.exports, "default", () => $1d7d7a085d2842c2$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5FkrB = parcelRequire("5FkrB");

var $74Zh5 = parcelRequire("74Zh5");

var $3IjMA = parcelRequire("3IjMA");

var $1LBcl = parcelRequire("1LBcl");

var $f8aZY = parcelRequire("f8aZY");

var $c3bUn = parcelRequire("c3bUn");

var $jJH6F = parcelRequire("jJH6F");

var $c0oX9 = parcelRequire("c0oX9");

var $fpooh = parcelRequire("fpooh");

var $iY18h = parcelRequire("iY18h");
var $1d7d7a085d2842c2$var$inlineNodeStyle = (0, $74Zh5.css)({
    alignItems: 'center',
    background: "var(--ds-background-disabled, #17171708)",
    border: "var(--ds-border-width, 1px)".concat(" dashed ", "var(--ds-border-disabled, #0515240F)"),
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    borderRadius: "var(--ds-radius-small, 3px)",
    boxSizing: 'border-box',
    cursor: 'default',
    display: 'inline-flex',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    fontSize: (0, $1LBcl.relativeFontSizeToBase16)(14),
    margin: "0 ".concat("var(--ds-space-025, 2px)"),
    minHeight: '24px',
    padding: "0 ".concat("var(--ds-space-100, 8px)"),
    verticalAlign: 'middle',
    whiteSpace: 'nowrap'
});
var $1d7d7a085d2842c2$var$UnsupportedInlineNode = function UnsupportedInlineNode(_ref) {
    var node = _ref.node, intl = _ref.intl, dispatchAnalyticsEvent = _ref.dispatchAnalyticsEvent;
    var message = (0, $iY18h.getUnsupportedContent)((0, $c0oX9.unsupportedContentMessages).unsupportedInlineContent, 'Unsupported', node, intl);
    var tooltipContent = intl.formatMessage((0, $c0oX9.unsupportedContentMessages).unsupportedContentTooltip);
    var _useRef = (0, $5FkrB.useRef)({
        padding: '4px'
    }), style = _useRef.current;
    var originalNodeType = node === null || node === void 0 ? void 0 : node.attrs.originalValue.type;
    var tooltipOnShowHandler = (0, $5FkrB.useCallback)(function() {
        return dispatchAnalyticsEvent && (0, $fpooh.trackUnsupportedContentTooltipDisplayedFor)(dispatchAnalyticsEvent, (0, $jJH6F.ACTION_SUBJECT_ID).ON_UNSUPPORTED_INLINE, originalNodeType);
    }, [
        dispatchAnalyticsEvent,
        originalNodeType
    ]);
    return (0, $74Zh5.jsx)("span", {
        css: $1d7d7a085d2842c2$var$inlineNodeStyle
    }, message, (0, $74Zh5.jsx)((0, $c3bUn.default), {
        content: tooltipContent,
        hideTooltipOnClick: false,
        position: "bottom",
        onShow: tooltipOnShowHandler,
        strategy: "absolute"
    }, (0, $74Zh5.jsx)("span", {
        style: style
    }, (0, $74Zh5.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($f8aZY))), {
        label: "?"
    }))));
};
// eslint-disable-next-line @typescript-eslint/ban-types
var $1d7d7a085d2842c2$var$_default_1 = (0, $3IjMA.default)($1d7d7a085d2842c2$var$UnsupportedInlineNode);
var $1d7d7a085d2842c2$export$2e2bcd8739ae039 = $1d7d7a085d2842c2$var$_default_1;

});

parcelRegister("anuR6", function(module, exports) {
$parcel$export(module.exports, "default", () => $78e3fc9ce0f3cdbe$export$2e2bcd8739ae039);

var $5FkrB = parcelRequire("5FkrB");
function $78e3fc9ce0f3cdbe$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("blockquote", {
        "data-local-id": props.localId
    }, props.children);
}

});

parcelRegister("21Umc", function(module, exports) {
$parcel$export(module.exports, "default", () => $17a76414978970eb$export$2e2bcd8739ae039);

var $kqp0i = parcelRequire("kqp0i");

var $5FkrB = parcelRequire("5FkrB");

var $cOsWw = parcelRequire("cOsWw");

var $ksTq8 = parcelRequire("ksTq8");

var $enqEB = parcelRequire("enqEB");

var $4chaE = parcelRequire("4chaE");

var $8KWVV = parcelRequire("8KWVV");

var $jJH6F = parcelRequire("jJH6F");

var $nOuq8 = parcelRequire("nOuq8");

var $caYHb = parcelRequire("caYHb");
var $17a76414978970eb$var$BodiedExtension = function BodiedExtension(props) {
    var children = props.children, _props$layout = props.layout, layout = _props$layout === void 0 ? 'default' : _props$layout, _props$path = props.path, path = _props$path === void 0 ? [] : _props$path, extensionKey = props.extensionKey, extensionType = props.extensionType, parameters = props.parameters, extensionViewportSizes = props.extensionViewportSizes, localId = props.localId;
    var _useAnalyticsEvents = (0, $cOsWw.useAnalyticsEvents)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
    var removeOverflow = (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).Children.toArray(children)// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    .map(function(child) {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).isValidElement(child) ? child.props.nodeType === 'table' : false;
    }).every(Boolean);
    var validationContextValue = (0, $5FkrB.useMemo)(function() {
        return {
            allowNestedTables: true
        };
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $enqEB.ErrorBoundary), {
        component: (0, $8KWVV.ACTION_SUBJECT).RENDERER,
        componentId: (0, $jJH6F.ACTION_SUBJECT_ID).EXTENSION_BODIED,
        createAnalyticsEvent: createAnalyticsEvent,
        additionalInfo: "".concat(extensionType, ": ").concat(extensionKey, " ")
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $nOuq8.AnnotationsPositionContext).Provider, {
        value: {
            startPos: props.startPos + 1
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $caYHb.ValidationContextProvider), {
        value: validationContextValue
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $4chaE.default), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, props, {
        type: "bodiedExtension"
    }), function(_ref) {
        var result = _ref.result;
        try {
            if (result && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).isValidElement(result)) // Return the content directly if it's a valid JSX.Element
            return (0, $ksTq8.renderExtension)(result, layout, {
                isTopLevel: path.length < 1
            }, removeOverflow, parameters === null || parameters === void 0 ? void 0 : parameters.extensionId, extensionViewportSizes, undefined, localId);
        } catch (e) {
        /** We don't want this error to block renderer */ /** We keep rendering the default content */ }
        // Always return default content if anything goes wrong
        return (0, $ksTq8.renderExtension)(children, layout, {
            isTopLevel: path.length < 1
        }, removeOverflow, parameters === null || parameters === void 0 ? void 0 : parameters.extensionId, extensionViewportSizes, undefined, localId);
    }))));
};
var $17a76414978970eb$export$2e2bcd8739ae039 = $17a76414978970eb$var$BodiedExtension;

});
parcelRegister("cOsWw", function(module, exports) {
$parcel$export(module.exports, "useAnalyticsEvents", () => $95409b076bbdef84$export$5bf35293e545f20c);

var $dLGML = parcelRequire("dLGML");

var $gOMP1 = parcelRequire("gOMP1");

var $2bMUu = parcelRequire("2bMUu");
function $95409b076bbdef84$export$5bf35293e545f20c() {
    var analyticsContext = (0, $2bMUu.useAnalyticsContext)();
    var createAnalyticsEvent = (0, $dLGML.useCallbackOne)(function(payload) {
        return new (0, $gOMP1.default)({
            context: analyticsContext.getAtlaskitAnalyticsContext(),
            handlers: analyticsContext.getAtlaskitAnalyticsEventHandlers(),
            payload: payload
        });
    }, [
        analyticsContext
    ]);
    return {
        createAnalyticsEvent: createAnalyticsEvent
    };
}

});
parcelRegister("gOMP1", function(module, exports) {
$parcel$export(module.exports, "default", () => $c3e72fda057f1b56$export$2e2bcd8739ae039);

var $fC8ib = parcelRequire("fC8ib");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $kIXpt = parcelRequire("kIXpt");

var $cYPzS = parcelRequire("cYPzS");

var $lwlXp = parcelRequire("lwlXp");

var $eyuDe = parcelRequire("eyuDe");

var $25nEq = parcelRequire("25nEq");

var $aDLC5 = parcelRequire("aDLC5");
function $c3e72fda057f1b56$var$_callSuper(t, o, e) {
    return o = (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(o), (0, (/*@__PURE__*/$parcel$interopDefault($kIXpt)))(t, $c3e72fda057f1b56$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(t).constructor) : o.apply(t, e));
}
function $c3e72fda057f1b56$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($c3e72fda057f1b56$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $c3e72fda057f1b56$var$_superPropGet(t, o, e, r) {
    var p = (0, (/*@__PURE__*/$parcel$interopDefault($lwlXp)))((0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(1 & r ? t.prototype : t), o, e);
    return 2 & r && "function" == typeof p ? function(t) {
        return p.apply(e, t);
    } : p;
}
var $c3e72fda057f1b56$export$35f8383928ba8d7 = function isUIAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $c3e72fda057f1b56$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isUIAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === 'UIAnalyticsEvent';
};
var $c3e72fda057f1b56$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_AnalyticsEvent) {
    function UIAnalyticsEvent(props) {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, UIAnalyticsEvent);
        _this = $c3e72fda057f1b56$var$_callSuper(this, UIAnalyticsEvent, [
            props
        ]);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "_isUIAnalyticsEvent", true);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "clone", function() {
            if (_this.hasFired) return null;
            var context = (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(_this.context);
            var handlers = (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(_this.handlers);
            /**
       * A hacky "deep clone" of the object. This is limited in that it wont
       * support functions, regexs, Maps, Sets, etc, but none of those need to
       * be represented in our payload.
       */ var payload = JSON.parse(JSON.stringify(_this.payload));
            return new UIAnalyticsEvent({
                context: context,
                handlers: handlers,
                payload: payload
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "fire", function(channel) {
            if (_this.hasFired) return;
            _this.handlers.forEach(function(handler) {
                return handler(_this, channel);
            });
            _this.hasFired = true;
        });
        _this.context = props.context || [];
        _this.handlers = props.handlers || [];
        _this.hasFired = false;
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($eyuDe)))(UIAnalyticsEvent, _AnalyticsEvent);
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(UIAnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (this.hasFired) return this;
                return $c3e72fda057f1b56$var$_superPropGet(UIAnalyticsEvent, "update", this, 3)([
                    updater
                ]);
            }
        }
    ]);
}((0, $aDLC5.default));

});
parcelRegister("aDLC5", function(module, exports) {
$parcel$export(module.exports, "default", () => $7bf27ae9548a2dd1$export$2e2bcd8739ae039);

var $ekGgq = parcelRequire("ekGgq");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $25nEq = parcelRequire("25nEq");
function $7bf27ae9548a2dd1$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $7bf27ae9548a2dd1$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $7bf27ae9548a2dd1$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $7bf27ae9548a2dd1$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $7bf27ae9548a2dd1$export$ad4be5c2ec28cecf = function isAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $7bf27ae9548a2dd1$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === 'AnalyticsEvent';
};
var $7bf27ae9548a2dd1$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function AnalyticsEvent(props) {
        var _this = this;
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, AnalyticsEvent);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "_isAnalyticsEvent", true);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "clone", function() {
            // just a shallow clone, don't change sub refs unless you want to
            // affect the original's too
            var payload = $7bf27ae9548a2dd1$var$_objectSpread({}, _this.payload);
            return new AnalyticsEvent({
                payload: payload
            });
        });
        this.payload = props.payload;
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(AnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (typeof updater === 'function') this.payload = updater(this.payload);
                if ((0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(updater) === 'object') this.payload = $7bf27ae9548a2dd1$var$_objectSpread($7bf27ae9548a2dd1$var$_objectSpread({}, this.payload), updater);
                return this;
            }
        }
    ]);
}();

});


parcelRegister("2bMUu", function(module, exports) {
$parcel$export(module.exports, "useAnalyticsContext", () => $19828c5f7555c307$export$d1f587f82ad51c4);

var $5FkrB = parcelRequire("5FkrB");

var $iyyOp = parcelRequire("iyyOp");
var $19828c5f7555c307$export$d1f587f82ad51c4 = function useAnalyticsContext() {
    return (0, $5FkrB.useContext)((0, $iyyOp.default));
};

});


parcelRegister("ksTq8", function(module, exports) {
$parcel$export(module.exports, "renderExtension", () => $ee61698df3dcfcb6$export$b7482bdc8aff85e4);
$parcel$export(module.exports, "default", () => $ee61698df3dcfcb6$export$2e2bcd8739ae039);

var $kqp0i = parcelRequire("kqp0i");

var $5FkrB = parcelRequire("5FkrB");

var $4chaE = parcelRequire("4chaE");

var $c6bEO = parcelRequire("c6bEO");
var $01HkO = parcelRequire("01HkO");

var $2XMn4 = parcelRequire("2XMn4");

var $53SBn = parcelRequire("53SBn");

var $drUcN = parcelRequire("drUcN");

var $2TWiQ = parcelRequire("2TWiQ");
var $ee61698df3dcfcb6$var$viewportSizes = [
    'small',
    'medium',
    'default',
    'large',
    'xlarge'
];
// Mirrors sizes from https://stash.atlassian.com/projects/ATLASSIAN/repos/atlassian-frontend-monorepo/browse/platform/packages/forge/xen-editor-provider/src/render/renderers/ForgeUIExtension.tsx
var $ee61698df3dcfcb6$var$macroHeights = {
    small: '112px',
    medium: '262px',
    default: '262px',
    large: '524px',
    xlarge: '1048px'
};
var $ee61698df3dcfcb6$var$getViewportSize = function getViewportSize(extensionId, extensionViewportSizes) {
    if (!Array.isArray(extensionViewportSizes) || !extensionId) return;
    var extension = extensionViewportSizes.find(function(extension) {
        return extension.extensionId === extensionId;
    });
    if (extension) {
        var viewportSize = extension.viewportSize && $ee61698df3dcfcb6$var$viewportSizes.includes(extension.viewportSize) ? extension.viewportSize : 'default';
        return $ee61698df3dcfcb6$var$macroHeights[viewportSize];
    }
};
var $ee61698df3dcfcb6$export$b7482bdc8aff85e4 = function renderExtension(content, layout) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var removeOverflow = arguments.length > 3 ? arguments[3] : undefined;
    var extensionId = arguments.length > 4 ? arguments[4] : undefined;
    var extensionViewportSizes = arguments.length > 5 ? arguments[5] : undefined;
    var nodeHeight = arguments.length > 6 ? arguments[6] : undefined;
    var localId = arguments.length > 7 ? arguments[7] : undefined;
    var overflowContainerClass = !removeOverflow ? (0, $53SBn.RendererCssClassName).EXTENSION_OVERFLOW_CONTAINER : '';
    // by default, we assume the extension is at top level, (direct child of doc node)
    var _ref = options || {}, _ref$isTopLevel = _ref.isTopLevel, isTopLevel = _ref$isTopLevel === void 0 ? true : _ref$isTopLevel;
    var centerAlignClass = isTopLevel && [
        'wide',
        'full-width'
    ].includes(layout) ? (0, $53SBn.RendererCssClassName).EXTENSION_CENTER_ALIGN : '';
    /**
   * To reduce cumulative layout shift, we check installed manifest values (viewportSize) for Forge and extension node parameters
   * for Connect (legacy). As Connect is being phased out, we want Forge to also start to store its expected height
   * in node parameters, especially for dynamic content macros. LegacyMacroStyledElements implements logic similar to here
   * as the extension handler in CFE for legacy macros and Connect.
   */ var viewportSize = $ee61698df3dcfcb6$var$getViewportSize(extensionId, extensionViewportSizes);
    var extensionHeight = nodeHeight || viewportSize;
    if ((0, $drUcN.expValEquals)('platform_editor_renderer_extension_width_fix', 'isEnabled', true)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("div", {
        ref: options.handleRef,
        className: "".concat((0, $53SBn.RendererCssClassName).EXTENSION, " ").concat(options.shadowClassNames, " ").concat(centerAlignClass),
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            width: isTopLevel ? (0, $2TWiQ.calcBreakoutWidthCss)(layout) : '100%',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            minHeight: extensionHeight && "".concat(extensionHeight, "px")
        },
        "data-layout": layout,
        "data-local-id": localId,
        "data-testid": "extension--wrapper",
        "data-node-type": "extension"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("div", {
        className: overflowContainerClass
    }, content));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $01HkO.WidthConsumer), null, function(_ref2) {
        var width = _ref2.width;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("div", {
            ref: options.handleRef,
            className: "".concat((0, $53SBn.RendererCssClassName).EXTENSION, " ").concat(options.shadowClassNames, " ").concat(centerAlignClass),
            style: {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                width: isTopLevel ? (0, $2XMn4.calcBreakoutWidth)(layout, width) : '100%',
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
                minHeight: "".concat(extensionHeight, "px")
            },
            "data-layout": layout,
            "data-local-id": localId
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("div", {
            className: overflowContainerClass
        }, content));
    });
};
var $ee61698df3dcfcb6$var$Extension = function Extension(props) {
    var text = props.text, _props$layout = props.layout, layout = _props$layout === void 0 ? 'default' : _props$layout, handleRef = props.handleRef, shadowClassNames = props.shadowClassNames, _props$path = props.path, path = _props$path === void 0 ? [] : _props$path, extensionViewportSizes = props.extensionViewportSizes, parameters = props.parameters, nodeHeight = props.nodeHeight, localId = props.localId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $4chaE.default), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, props, {
        type: "extension"
    }), function(_ref3) {
        var result = _ref3.result;
        try {
            // Return the result directly if it's a valid JSX.Element
            if (result && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).isValidElement(result)) return $ee61698df3dcfcb6$export$b7482bdc8aff85e4(result, layout, {
                isTopLevel: path.length < 1,
                handleRef: handleRef,
                shadowClassNames: shadowClassNames
            }, undefined, parameters === null || parameters === void 0 ? void 0 : parameters.extensionId, extensionViewportSizes, nodeHeight, localId);
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        } catch (e) {
        /** We don't want this error to block renderer */ /** We keep rendering the default content */ }
        // Always return default content if anything goes wrong
        return $ee61698df3dcfcb6$export$b7482bdc8aff85e4(text || 'extension', layout, {
            isTopLevel: path.length < 1,
            handleRef: handleRef,
            shadowClassNames: shadowClassNames
        }, undefined, parameters === null || parameters === void 0 ? void 0 : parameters.extensionId, extensionViewportSizes, nodeHeight, localId);
    });
};
var $ee61698df3dcfcb6$export$2e2bcd8739ae039 = (0, $c6bEO.default)($ee61698df3dcfcb6$var$Extension, {
    overflowSelector: ".".concat((0, $53SBn.RendererCssClassName).EXTENSION_OVERFLOW_CONTAINER)
});

});
parcelRegister("4chaE", function(module, exports) {
$parcel$export(module.exports, "default", () => $30e59a26a841843b$export$2e2bcd8739ae039);

var $iYJcE = parcelRequire("iYJcE");

var $74Zh5 = parcelRequire("74Zh5");

var $5FkrB = parcelRequire("5FkrB");

var $cvlyC = parcelRequire("cvlyC");

var $5hQFA = parcelRequire("5hQFA");

var $qprXf = parcelRequire("qprXf");

var $fIf3B = parcelRequire("fIf3B");

var $9Zzpd = parcelRequire("9Zzpd");
var $30e59a26a841843b$var$inlineExtensionStyle = (0, $74Zh5.css)({
    display: 'inline-block',
    maxWidth: '100%',
    verticalAlign: 'middle',
    // 0px margin top is important here.
    // When running on server-side emotion will generate style tags before elements.
    // This caused packages/editor/editor-common/src/styles/shared/block-marks.ts to override the margin-top.
    // However as soon as the styles are extracted to <head> it adds back the margin.
    // The timing is tricky as it happens to be when UFO collects the dimension for the placeholder for TTVC calculation.
    // This resulted 1px mismatch on the image. Further cause everything on page to shift by 1px.
    // es-lint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
    margin: "0px 1px ".concat("var(--ds-space-050, 4px)"),
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& .rich-media-item': {
        maxWidth: '100%'
    }
});
var $30e59a26a841843b$var$plainTextMacroStyle = (0, $74Zh5.css)({
    display: 'inline',
    verticalAlign: 'baseline',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-macro-body]': {
        display: 'inline'
    }
});
function $30e59a26a841843b$export$2e2bcd8739ae039(props) {
    var extensionHandlers = props.extensionHandlers, rendererContext = props.rendererContext, extensionType = props.extensionType, extensionKey = props.extensionKey, parameters = props.parameters, content = props.content, text = props.text, type = props.type, localId = props.localId, marks = props.marks, actions = props.actions, children = props.children;
    var isMounted = (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).useRef(true);
    var localGetNodeRenderer = (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).useMemo(function() {
        return (0, $cvlyC.default)((0, $5hQFA.getNodeRenderer));
    }, []);
    var _React$useState = (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).useState(null), _React$useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_React$useState, 2), extensionProvider = _React$useState2[0], setExtensionProvider = _React$useState2[1];
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var handleProvider = (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).useCallback(function(_name, providerPromise) {
        providerPromise && providerPromise.then(function(provider) {
            if (isMounted.current) setExtensionProvider(provider);
        });
    }, []);
    var renderExtensionNode = (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).useCallback(function(extensionProvider) {
        var _marks$find, _node$parameters;
        var fragmentLocalId = marks === null || marks === void 0 || (_marks$find = marks.find(function(m) {
            return m.type.name === 'fragment';
        })) === null || _marks$find === void 0 || (_marks$find = _marks$find.attrs) === null || _marks$find === void 0 ? void 0 : _marks$find.localId;
        var node = {
            type: type,
            extensionKey: extensionKey,
            extensionType: extensionType,
            parameters: parameters,
            content: content || text,
            localId: localId,
            fragmentLocalId: fragmentLocalId
        };
        var isPlainTextMacro = Boolean(node === null || node === void 0 || (_node$parameters = node.parameters) === null || _node$parameters === void 0 || (_node$parameters = _node$parameters.macroParams) === null || _node$parameters === void 0 ? void 0 : _node$parameters.__bodyContent);
        var result = null;
        try {
            if (extensionHandlers && extensionHandlers[extensionType]) {
                var render = (0, $fIf3B.getExtensionRenderer)(extensionHandlers[extensionType]);
                result = render(node, rendererContext.adDoc);
            }
            if (!result && extensionProvider) {
                var NodeRenderer = localGetNodeRenderer(extensionProvider, extensionType, extensionKey);
                if (node.type === 'multiBodiedExtension') result = (0, $74Zh5.jsx)(NodeRenderer, {
                    node: node,
                    actions: actions
                });
                else if (node.type === 'inlineExtension') {
                    if ((0, $9Zzpd.fg)('platform_editor_renderer_inline_extension_improve')) result = (0, $74Zh5.jsx)($30e59a26a841843b$export$f41ccc3bd3324832, {
                        isPlainTextMacro: isPlainTextMacro
                    }, (0, $74Zh5.jsx)(NodeRenderer, {
                        node: node
                    }));
                    else result = (0, $74Zh5.jsx)($30e59a26a841843b$export$f41ccc3bd3324832, null, (0, $74Zh5.jsx)(NodeRenderer, {
                        node: node
                    }));
                } else result = (0, $74Zh5.jsx)(NodeRenderer, {
                    node: node
                });
            }
        } catch (e) {
        /** We don't want this error to block renderer */ /** We keep rendering the default content */ }
        return children({
            result: result
        });
    }, [
        actions,
        children,
        content,
        extensionHandlers,
        extensionKey,
        extensionType,
        localGetNodeRenderer,
        localId,
        marks,
        parameters,
        rendererContext === null || rendererContext === void 0 ? void 0 : rendererContext.adDoc,
        text,
        type
    ]);
    var setupAndRenderExtensionNode = (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).useCallback(function(providers) {
        if (!extensionProvider && providers.extensionProvider) handleProvider('extensionProvider', providers.extensionProvider);
        return renderExtensionNode(extensionProvider);
    }, [
        extensionProvider,
        handleProvider,
        renderExtensionNode
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).useEffect(function() {
        isMounted.current = true;
        return function() {
            isMounted.current = false;
        };
    }, []);
    if (!props.providers) return setupAndRenderExtensionNode({});
    return (0, $74Zh5.jsx)((0, $qprXf.WithProviders), {
        providers: [
            'extensionProvider'
        ],
        providerFactory: props.providers,
        renderNode: setupAndRenderExtensionNode
    });
}
var $30e59a26a841843b$export$f41ccc3bd3324832 = function InlineNodeRendererWrapper(_ref) {
    var children = _ref.children, isPlainTextMacro = _ref.isPlainTextMacro, ssrPlaceholder = _ref.ssrPlaceholder, ssrPlaceholderReplace = _ref.ssrPlaceholderReplace;
    return (0, $74Zh5.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "inline-extension-renderer ".concat(isPlainTextMacro ? 'plain-text-macro' : ''),
        css: [
            $30e59a26a841843b$var$inlineExtensionStyle,
            isPlainTextMacro && $30e59a26a841843b$var$plainTextMacroStyle
        ],
        "data-ssr-placeholder": ssrPlaceholder,
        "data-ssr-placeholder-replace": ssrPlaceholderReplace
    }, children);
};

});
parcelRegister("5hQFA", function(module, exports) {
$parcel$export(module.exports, "getExtensionModuleNodePrivateProps", () => $3d976561732cc216$export$426f8efd8690d8aa);
$parcel$export(module.exports, "getNodeRenderer", () => $3d976561732cc216$export$67a7d49db68d30a0);

var $fL8KA = parcelRequire("fL8KA");

var $iYJcE = parcelRequire("iYJcE");

var $6HG4S = parcelRequire("6HG4S");

var $5FkrB = parcelRequire("5FkrB");

var $6Wx3K = parcelRequire("6Wx3K");

var $bhmkE = parcelRequire("bhmkE");

var $9Zzpd = parcelRequire("9Zzpd");

var $cqR4L = parcelRequire("cqR4L");

var $7mos3 = parcelRequire("7mos3");

var $bISAN = parcelRequire("bISAN");
function $3d976561732cc216$var$getNodeFromManifest(// eslint-disable-next-line @typescript-eslint/no-explicit-any
manifest, extKey, nodeKey, extensionType, extensionKey) {
    if (!manifest) throw new Error("Extension with key \"".concat(extKey, "\" and type \"").concat(extensionType, "\" not found!"));
    if (!manifest.modules.nodes) throw new Error("Couldn't find any node for extension type \"".concat(extensionType, "\" and key \"").concat(extensionKey, "\"!"));
    var node = manifest.modules.nodes[nodeKey];
    if (!node) throw new Error("Node with key \"".concat(extensionKey, "\" not found on manifest for extension type \"").concat(extensionType, "\" and key \"").concat(extensionKey, "\"!"));
    return node;
}
function $3d976561732cc216$export$573ee875a39e7e73(extensionProvider, extensionType, extensionKey) {
    var _getExtensionKeyAndNo = (0, $cqR4L.getExtensionKeyAndNodeKey)(extensionKey, extensionType), _getExtensionKeyAndNo2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_getExtensionKeyAndNo, 1), extKey = _getExtensionKeyAndNo2[0];
    return extensionProvider.getExtension(extensionType, extKey);
}
function $3d976561732cc216$export$82dd45c2db936caf(_x, _x2, _x3) {
    return $3d976561732cc216$var$_getExtensionModuleNode.apply(this, arguments);
}
function $3d976561732cc216$var$_getExtensionModuleNode() {
    $3d976561732cc216$var$_getExtensionModuleNode = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee(extensionProvider, extensionType, extensionKey) {
        var _getExtensionKeyAndNo5, _getExtensionKeyAndNo6, extKey, nodeKey, manifest;
        return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee$(_context) {
            while(true)switch(_context.prev = _context.next){
                case 0:
                    _getExtensionKeyAndNo5 = (0, $cqR4L.getExtensionKeyAndNodeKey)(extensionKey, extensionType), _getExtensionKeyAndNo6 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_getExtensionKeyAndNo5, 2), extKey = _getExtensionKeyAndNo6[0], nodeKey = _getExtensionKeyAndNo6[1];
                    _context.next = 3;
                    return extensionProvider.getExtension(extensionType, extKey);
                case 3:
                    manifest = _context.sent;
                    return _context.abrupt("return", $3d976561732cc216$var$getNodeFromManifest(manifest, extKey, nodeKey, extensionType, extensionKey));
                case 5:
                case "end":
                    return _context.stop();
            }
        }, _callee);
    }));
    return $3d976561732cc216$var$_getExtensionModuleNode.apply(this, arguments);
}
function $3d976561732cc216$export$903681ffb5af37a7(extensionProvider, extensionType, extensionKey) {
    var _extensionProvider$ge;
    var _getExtensionKeyAndNo3 = (0, $cqR4L.getExtensionKeyAndNodeKey)(extensionKey, extensionType), _getExtensionKeyAndNo4 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_getExtensionKeyAndNo3, 2), extKey = _getExtensionKeyAndNo4[0], nodeKey = _getExtensionKeyAndNo4[1];
    var manifest = extensionProvider === null || extensionProvider === void 0 || (_extensionProvider$ge = extensionProvider.getPreloadedExtension) === null || _extensionProvider$ge === void 0 ? void 0 : _extensionProvider$ge.call(extensionProvider, extensionType, extKey);
    if (manifest) return $3d976561732cc216$var$getNodeFromManifest(manifest, extKey, nodeKey, extensionType, extensionKey);
    else return extensionProvider.getExtension(extensionType, extKey).then(function(manifest) {
        return $3d976561732cc216$var$getNodeFromManifest(manifest, extKey, nodeKey, extensionType, extensionKey);
    });
}
function $3d976561732cc216$export$426f8efd8690d8aa(_x4, _x5, _x6) {
    return $3d976561732cc216$var$_getExtensionModuleNodePrivateProps.apply(this, arguments);
}
function $3d976561732cc216$var$_getExtensionModuleNodePrivateProps() {
    $3d976561732cc216$var$_getExtensionModuleNodePrivateProps = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee2(extensionProvider, extensionType, extensionKey) {
        var moduleNode;
        return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee2$(_context2) {
            while(true)switch(_context2.prev = _context2.next){
                case 0:
                    _context2.next = 2;
                    return $3d976561732cc216$export$82dd45c2db936caf(extensionProvider, extensionType, extensionKey);
                case 2:
                    moduleNode = _context2.sent;
                    return _context2.abrupt("return", Object.keys(moduleNode).filter(function(key) {
                        return key.startsWith('__');
                    }).reduce(function(acc, key) {
                        // Ignored via go/ees005
                        // eslint-disable-next-line @typescript-eslint/no-explicit-any
                        acc[key] = moduleNode[key];
                        return acc;
                    }, {}));
                case 4:
                case "end":
                    return _context2.stop();
            }
        }, _callee2);
    }));
    return $3d976561732cc216$var$_getExtensionModuleNodePrivateProps.apply(this, arguments);
}
function $3d976561732cc216$var$isUnknownConfluenceMacroWithBody(extensionNode) {
    var _extensionNode$parame;
    return extensionNode !== null && extensionNode.type === 'extension' && extensionNode.extensionType === 'com.atlassian.confluence.macro.core' && !!((_extensionNode$parame = extensionNode.parameters) !== null && _extensionNode$parame !== void 0 && (_extensionNode$parame = _extensionNode$parame.macroParams) !== null && _extensionNode$parame !== void 0 && (_extensionNode$parame = _extensionNode$parame.__bodyContent) !== null && _extensionNode$parame !== void 0 && _extensionNode$parame.value);
}
function $3d976561732cc216$var$ExtensionLoading(props) {
    var intl = (0, $6Wx3K.default)();
    var extensionNode = props.node;
    if (props.error || props.timedOut) {
        // eslint-disable-next-line no-console
        console.error('Error rendering extension', props.error);
        if (props.error && props.showUnknownMacroPlaceholder && extensionNode && $3d976561732cc216$var$isUnknownConfluenceMacroWithBody(extensionNode) && (0, $9Zzpd.fg)('tinymce_display_unknown_macro_body_content')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $bISAN.UnknownMacroPlaceholder), {
            extensionNode: extensionNode
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("div", null, intl.formatMessage((0, $7mos3.messages).extensionLoadingError));
    } else return null;
}
function $3d976561732cc216$export$67a7d49db68d30a0(extensionProvider, extensionType, extensionKey) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($bhmkE)))({
        loader: function loader() {
            var maybePromise = $3d976561732cc216$export$903681ffb5af37a7(extensionProvider, extensionType, extensionKey);
            if (maybePromise instanceof Promise) return maybePromise.then(function(node) {
                return (0, $cqR4L.resolveImport)(node.render());
            });
            else {
                var _renderSync, _ref;
                var preloaded = maybePromise === null || maybePromise === void 0 || (_renderSync = (_ref = maybePromise).renderSync) === null || _renderSync === void 0 ? void 0 : _renderSync.call(_ref);
                // Only product implemented preloading will return sync result
                // However the out-of-box won't handle this. Confluence uses a custom implementation
                return preloaded ? // eslint-disable-next-line @typescript-eslint/no-explicit-any
                (0, $cqR4L.resolveImportSync)(preloaded) : (0, $cqR4L.resolveImport)(maybePromise.render());
            }
        },
        // react-loadable passes all props from <NodeRenderer> to the loading component at runtime,
        // but its TypeScript types only expect LoadingComponentProps. We cast here because
        // ExtensionLoading accepts additional props (node, showUnknownMacroPlaceholder) that
        // react-loadable will pass through but doesn't know about in its type definitions.
        loading: $3d976561732cc216$var$ExtensionLoading
    });
}

});
parcelRegister("cqR4L", function(module, exports) {
$parcel$export(module.exports, "getExtensionKeyAndNodeKey", () => $90d1158250efa640$export$8a49818572e1d105);
$parcel$export(module.exports, "resolveImportSync", () => $90d1158250efa640$export$dca2026e63034304);
$parcel$export(module.exports, "resolveImport", () => $90d1158250efa640$export$d69c9b451c47653b);

var $25nEq = parcelRequire("25nEq");

var $fL8KA = parcelRequire("fL8KA");

var $iYJcE = parcelRequire("iYJcE");

var $6HG4S = parcelRequire("6HG4S");
function $90d1158250efa640$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $90d1158250efa640$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $90d1158250efa640$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $90d1158250efa640$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $90d1158250efa640$export$a7d04c836550045a = 'com.atlassian.ecosystem';
var $90d1158250efa640$export$862c0e8acc7585d7 = 'com.atlassian.confluence.macro.core';
var $90d1158250efa640$export$b343a94058bea058 = 'native-embed';
var $90d1158250efa640$export$8a49818572e1d105 = function getExtensionKeyAndNodeKey(extensionKey, extensionType) {
    // Forge macro extensionKey has a user generated string, so splitting on
    // a colon is unstable for their particular use case. They only have one
    // node in the relevant manifest so we can hardcode nodeKey to 'default'.
    if (extensionType === $90d1158250efa640$export$a7d04c836550045a) return [
        extensionKey,
        'default'
    ];
    var _extensionKey$split = extensionKey.split(':'), _extensionKey$split2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_extensionKey$split, 2), extKey = _extensionKey$split2[0], _extensionKey$split2$ = _extensionKey$split2[1], nodeKey = _extensionKey$split2$ === void 0 ? 'default' : _extensionKey$split2$;
    return [
        extKey,
        nodeKey
    ];
};
var $90d1158250efa640$export$5f3eb042babacbbd = function buildExtensionKeyAndNodeKey(extensionKey, nodeKey) {
    if (!nodeKey || nodeKey === 'default') return extensionKey;
    return "".concat(extensionKey, ":").concat(nodeKey);
};
function $90d1158250efa640$export$bb33bcdd9a10a608(action, manifest) {
    if (typeof action === 'function') return action;
    if (action.type === 'node' && manifest.modules.nodes) return $90d1158250efa640$export$33863d887d6f4bfd(action, manifest);
}
var $90d1158250efa640$export$dca2026e63034304 = function resolveImportSync(importedModule) {
    return importedModule && importedModule.__esModule ? importedModule.default : importedModule;
};
var $90d1158250efa640$export$d69c9b451c47653b = /*#__PURE__*/ function() {
    var _ref = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee(importPromise) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee$(_context) {
            while(true)switch(_context.prev = _context.next){
                case 0:
                    _context.t0 = $90d1158250efa640$export$dca2026e63034304;
                    _context.next = 3;
                    return importPromise;
                case 3:
                    _context.t1 = _context.sent;
                    return _context.abrupt("return", (0, _context.t0)(_context.t1));
                case 5:
                case "end":
                    return _context.stop();
            }
        }, _callee);
    }));
    return function resolveImport(_x) {
        return _ref.apply(this, arguments);
    };
}();
function $90d1158250efa640$export$33863d887d6f4bfd(action, manifest) {
    if (!manifest.modules.nodes) return;
    var node = manifest.modules.nodes[action.key];
    var extensionKey = $90d1158250efa640$export$5f3eb042babacbbd(manifest.key, action.key);
    var extension = {
        type: node.type,
        attrs: {
            extensionType: manifest.type,
            extensionKey: extensionKey,
            parameters: action.parameters
        }
    };
    if (node.type === 'bodiedExtension') return $90d1158250efa640$var$_objectSpread($90d1158250efa640$var$_objectSpread({}, extension), {}, {
        content: [
            {
                type: 'paragraph',
                content: []
            }
        ]
    });
    else if (node.type === 'multiBodiedExtension') return $90d1158250efa640$var$_objectSpread($90d1158250efa640$var$_objectSpread({}, extension), {}, {
        content: [
            {
                type: 'extensionFrame',
                content: [
                    {
                        type: 'paragraph',
                        content: []
                    }
                ]
            }
        ]
    });
    return extension;
}

});

parcelRegister("7mos3", function(module, exports) {
$parcel$export(module.exports, "messages", () => $55bd8e04676325da$export$defe85febe8b728c);

var $aRMzY = parcelRequire("aRMzY");
var $55bd8e04676325da$export$defe85febe8b728c = (0, $aRMzY.defineMessages)({
    edit: {
        id: 'fabric.editor.edit',
        defaultMessage: 'Edit',
        description: 'The text is shown as a button label in the extension context menu. Triggers opening the properties editor for the selected extension to modify its configuration.'
    },
    deleteElementTitle: {
        id: 'fabric.editor.extension.deleteElementTitle',
        defaultMessage: 'Delete element',
        description: 'Title text for confirm modal when deleting an extension linked to a data consumer.'
    },
    unnamedSource: {
        id: 'fabric.editor.extension.sourceNoTitledName',
        defaultMessage: 'this element',
        description: 'The current element without preset name been selected'
    },
    confirmDeleteLinkedModalOKButton: {
        id: 'fabric.editor.extension.confirmDeleteLinkedModalOKButton',
        defaultMessage: 'Delete',
        description: 'Action button label for confirm modal when deleting an extension linked to a data consumer.'
    },
    confirmDeleteLinkedModalMessage: {
        id: 'fabric.editor.extension.confirmDeleteLinkedModalMessage',
        defaultMessage: 'Deleting {nodeName} will break anything connected to it.',
        description: 'Message for confirm modal when deleting a extension linked to an data consumer.'
    },
    confirmModalCheckboxLabel: {
        id: 'fabric.editor.floatingToolbar.confirmModalCheckboxLabel',
        defaultMessage: 'Also delete connected elements',
        description: 'Label for a checkbox in a confirm modal that allows the user to also delete connected elements when deleting an extension.'
    },
    saveIndicator: {
        id: 'fabric.editor.extensions.config-panel.save-indicator',
        defaultMessage: 'All changes are always autosaved',
        description: 'Informational message displayed in the extension configuration panel to reassure users that their changes are being saved automatically without requiring manual save action.'
    },
    panelLoadingError: {
        id: 'fabric.editor.extensions.config-panel.loading-error.non-final',
        defaultMessage: 'We ran into a bit of trouble. Refresh to try again.',
        description: 'Error message displayed when the extension configuration panel fails to load. Instructs users to refresh the page to attempt loading the panel again.'
    },
    extensionLoadingError: {
        id: 'fabric.editor.extension.loading-error',
        defaultMessage: 'Error loading the extension!',
        description: 'Error message displayed when an extension fails to load in the editor. Indicates a problem occurred during the extension initialization or rendering process.'
    },
    unknownMacroPlaceholderAriaLabel: {
        id: 'fabric.editor.extension.unknownMacroPlaceholderAriaLabel',
        defaultMessage: 'Unknown macro placeholder',
        description: 'Accessible label for the unknown macro fallback block shown when a Confluence macro cannot be resolved.'
    },
    unknownMacroHeader: {
        id: 'fabric.editor.extension.unknownMacroHeader',
        defaultMessage: "Unknown macro: ''{macroTitle}''",
        description: 'Header text for an unresolved Confluence macro placeholder.'
    }
});
var $55bd8e04676325da$export$163c7b0716312254 = (0, $aRMzY.defineMessages)({
    configFailedToLoad: {
        id: 'fabric.editor.configFailedToLoad',
        defaultMessage: 'Failed to load',
        description: 'Displayed when the config panel fails to load fields'
    },
    submit: {
        id: 'fabric.editor.configPanel.submit',
        defaultMessage: 'Submit',
        description: 'Label for a button in the extension configuration panel that the user clicks to submit and apply configuration changes.'
    },
    cancel: {
        id: 'fabric.editor.configPanel.cancel',
        defaultMessage: 'Cancel',
        description: 'Label for a button in the extension configuration panel that the user clicks to cancel and discard configuration changes.'
    },
    close: {
        id: 'fabric.editor.configPanel.close',
        defaultMessage: 'Close',
        description: 'Label for a button in the extension configuration panel that the user clicks to close the panel.'
    },
    required: {
        id: 'fabric.editor.configPanel.required',
        defaultMessage: 'Required field',
        description: 'Validation message for required field'
    },
    invalid: {
        id: 'fabric.editor.configPanel.invalid',
        defaultMessage: 'Invalid field',
        description: 'Validation message when a field value is not acceptable'
    },
    isMultipleAndRadio: {
        id: 'fabric.editor.configPanel.fieldTypeError.isMultipleAndRadio',
        defaultMessage: 'Can not combine isMultiple with style: radio',
        description: 'Error message displayed in the extension configuration panel when isMultiple and radio style options are incorrectly combined.'
    },
    addField: {
        id: 'fabric.editor.configPanel.formType.addField',
        defaultMessage: 'Add field',
        description: 'Button to add a new field in nested forms'
    },
    removeField: {
        id: 'fabric.editor.configPanel.formType.removeField',
        defaultMessage: 'Remove field',
        description: 'Button to remove a field in nested forms'
    },
    createOption: {
        id: 'fabric.editor.configPanel.customSelect.createOption',
        defaultMessage: 'Create',
        description: 'Create a new option for a select field'
    },
    documentation: {
        id: 'fabric.editor.configPanel.documentation',
        defaultMessage: 'Documentation',
        description: 'Label for the documentation link'
    },
    help: {
        id: 'fabric.editor.configPanel.help',
        defaultMessage: 'Need help?',
        description: 'Label for documentation link v.2 (to replace "Documentation" text)'
    },
    custom: {
        id: 'fabric.editor.configPanel.dateRange.option.custom',
        defaultMessage: 'Custom',
        description: 'Label for the option "Custom" in the date range UI element'
    },
    from: {
        id: 'fabric.editor.configPanel.dateRange.custom.from',
        defaultMessage: 'From',
        description: 'Label for the initial date when the option "Custom" is selected in the date range UI element'
    },
    to: {
        id: 'fabric.editor.configPanel.dateRange.custom.to',
        defaultMessage: 'To',
        description: 'Label for the end date when the option "Custom" is selected in the date range UI element'
    },
    expand: {
        id: 'fabric.editor.configPanel.dateRange.grouping.expand',
        defaultMessage: 'Expand',
        description: 'Label for expanding a group of fields'
    },
    collapse: {
        id: 'fabric.editor.configPanel.dateRange.grouping.collapse',
        defaultMessage: 'Collapse',
        description: 'Label for collapsing a group of fields'
    },
    errorBoundaryTitle: {
        id: 'fabric.editor.configPanel.errorBoundary.title',
        defaultMessage: 'Something went wrong.',
        description: 'Title for uncaught config panel error'
    },
    errorBoundaryNote: {
        id: 'fabric.editor.configPanel.errorBoundary.note',
        defaultMessage: "We've let the team know. You can still edit and publish this page, or check the error console for more information.",
        description: 'Note for uncaught config panel error'
    }
});

});

parcelRegister("bISAN", function(module, exports) {
$parcel$export(module.exports, "UnknownMacroPlaceholder", () => $888e26acd7f7cae9$export$414b5225f50e455b);
/* UnknownMacroPlaceholder.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");

var $1wIML = parcelRequire("1wIML");
var $1X1fL = parcelRequire("1X1fL");

var $6Wx3K = parcelRequire("6Wx3K");

var $7mos3 = parcelRequire("7mos3");
// Unknown macro placeholder styling aligned with Legacy Content Macro (LCM) for consistent look
var $888e26acd7f7cae9$var$neutralBorder = "var(--ds-background-neutral, #0515240F)";
var $888e26acd7f7cae9$var$unknownMacroContainerStyles = null;
// Match LCM header exactly: lcmHeaderStyles from LegacyContentHeader/index.tsx
var $888e26acd7f7cae9$var$unknownMacroHeaderStyles = null;
// Match LCM content area: white surface, text color inherits
var $888e26acd7f7cae9$var$unknownMacroBodyStyles = null;
var $888e26acd7f7cae9$var$unknownMacroPreStyles = null;
function $888e26acd7f7cae9$export$414b5225f50e455b(_ref) {
    var _extensionNode$parame, _extensionNode$parame2, _extensionNode$parame3, _extensionNode$parame4;
    var extensionNode = _ref.extensionNode;
    var intl = (0, $6Wx3K.default)();
    var macroTitle = ((_extensionNode$parame = extensionNode.parameters) === null || _extensionNode$parame === void 0 || (_extensionNode$parame = _extensionNode$parame.macroMetadata) === null || _extensionNode$parame === void 0 ? void 0 : _extensionNode$parame.title) || extensionNode.extensionKey;
    var bodyContent = (_extensionNode$parame2 = extensionNode.parameters) === null || _extensionNode$parame2 === void 0 || (_extensionNode$parame2 = _extensionNode$parame2.macroParams) === null || _extensionNode$parame2 === void 0 || (_extensionNode$parame2 = _extensionNode$parame2.__bodyContent) === null || _extensionNode$parame2 === void 0 ? void 0 : _extensionNode$parame2.value;
    var macroParams = (_extensionNode$parame3 = (_extensionNode$parame4 = extensionNode.parameters) === null || _extensionNode$parame4 === void 0 ? void 0 : _extensionNode$parame4.macroParams) !== null && _extensionNode$parame3 !== void 0 ? _extensionNode$parame3 : {};
    var formatParam = function formatParam(key, param) {
        var _param$value;
        var value = String((_param$value = param === null || param === void 0 ? void 0 : param.value) !== null && _param$value !== void 0 ? _param$value : '').trim();
        return "".concat(key, " = ").concat(value);
    };
    // eslint-disable-next-line @atlassian/perf-linting/no-expensive-computations-in-render -- Ignored via go/ees017 (to be fixed)
    var visibleParams = Object.entries(macroParams).filter(function(_ref2) {
        var _ref3 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_ref2, 1), key = _ref3[0];
        return !key.startsWith('_');
    }).map(function(_ref4) {
        var _ref5 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_ref4, 2), key = _ref5[0], param = _ref5[1];
        return formatParam(key, param);
    }).join(' | ');
    var headerText = visibleParams ? "".concat(intl.formatMessage((0, $7mos3.messages).unknownMacroHeader, {
        macroTitle: macroTitle
    }), " | ").concat(visibleParams) : intl.formatMessage((0, $7mos3.messages).unknownMacroHeader, {
        macroTitle: macroTitle
    });
    return /*#__PURE__*/ $5FkrB.createElement("section", {
        "aria-label": intl.formatMessage((0, $7mos3.messages).unknownMacroPlaceholderAriaLabel),
        className: (0, $1wIML.default)([
            "_19it7tl1 _2rko12b0 _1reo15vq _18m915vq _bfhkhp5a"
        ]),
        style: {
            "--_98ihdp": (0, $1X1fL.default)("1px solid ".concat($888e26acd7f7cae9$var$neutralBorder))
        }
    }, /*#__PURE__*/ $5FkrB.createElement("div", {
        className: (0, $1wIML.default)([
            "_2rko14xi _11c8wadc _n7zl1q32 _bfhki8nm _ca0qu2gc _u5f3pxbi _n3td1b66 _19bvpxbi _kqswh2mm _154i1n1a"
        ]),
        style: {
            "--_1e0q5w0": (0, $1X1fL.default)("var(--ds-border-width, 1px)".concat(" solid ", $888e26acd7f7cae9$var$neutralBorder))
        }
    }, headerText), /*#__PURE__*/ $5FkrB.createElement("div", {
        className: (0, $1wIML.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _bfhkvuon _ca0qutpp _u5f3utpp _n3tdutpp _19bvutpp"
        ])
    }, /*#__PURE__*/ $5FkrB.createElement("pre", {
        className: (0, $1wIML.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _11c8fhey _o5721jtm _1nmz1hna _6z24egat"
        ])
    }, bodyContent)));
}

});
parcelRegister("1X1fL", function(module, exports) {
$parcel$export(module.exports, "default", () => $16bc45ff65d7e5ac$export$2e2bcd8739ae039);
/**
 * Returns a CSS custom property value with an optional suffix & prefix.
 * Prefix will only be added if there is a suffix.
 * If the value is undefined a fallback value will be returned to prevent children inheriting parent values.
 *
 * @param value
 * @param suffix
 * @param prefix
 */ function $16bc45ff65d7e5ac$export$2e2bcd8739ae039(value, suffix, prefix) {
    if (value != undefined) {
        if (suffix) {
            if (prefix) return prefix + value + suffix;
            return value + suffix;
        }
        return value;
    }
    // Currently React trims these values so we can't use a space " " to block the value.
    // Instead we use a CSS variable that doesn't exist which falls back to " ".
    // Bug raised here: https://github.com/facebook/react/issues/20497
    return 'var(--c-, )';
}

});



parcelRegister("qprXf", function(module, exports) {
$parcel$export(module.exports, "WithProviders", () => $04f62ba387148165$export$d498ee8be33e096f);

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $kIXpt = parcelRequire("kIXpt");

var $cYPzS = parcelRequire("cYPzS");

var $eyuDe = parcelRequire("eyuDe");

var $25nEq = parcelRequire("25nEq");

var $5FkrB = parcelRequire("5FkrB");
function $04f62ba387148165$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $04f62ba387148165$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $04f62ba387148165$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $04f62ba387148165$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $04f62ba387148165$var$_callSuper(t, o, e) {
    return o = (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(o), (0, (/*@__PURE__*/$parcel$interopDefault($kIXpt)))(t, $04f62ba387148165$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(t).constructor) : o.apply(t, e));
}
function $04f62ba387148165$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($04f62ba387148165$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $04f62ba387148165$export$d498ee8be33e096f = /*#__PURE__*/ function(_PureComponent) {
    function WithProviders(props) {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, WithProviders);
        _this = $04f62ba387148165$var$_callSuper(this, WithProviders, [
            props
        ]);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "mounted", false);
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "handleProviderIfMounted", function(name, provider) {
            if (!_this.mounted) return;
            _this.handleProvider(name, provider);
        });
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "handleProvider", function(name, provider) {
            _this.setState(function(_ref) {
                var providers = _ref.providers;
                return {
                    providers: $04f62ba387148165$var$_objectSpread($04f62ba387148165$var$_objectSpread({}, providers), {}, (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, name, provider))
                };
            });
        });
        _this.mounted = false;
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        var _providers = {};
        _this.props.providers.forEach(function(name) {
            var providerPromise = props.providerFactory.subscribe(name, _this.handleProviderIfMounted);
            _providers[name] = providerPromise;
        });
        _this.state = {
            providers: _providers
        };
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($eyuDe)))(WithProviders, _PureComponent);
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(WithProviders, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this.mounted = true;
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                var _this2 = this;
                var _this$props = this.props, providers = _this$props.providers, providerFactory = _this$props.providerFactory;
                providers.forEach(function(name) {
                    providerFactory.unsubscribe(name, _this2.handleProviderIfMounted);
                });
            }
        },
        {
            key: "render",
            value: function render() {
                var state = this.state, props = this.props;
                var renderNode = props.renderNode;
                return renderNode(state.providers);
            }
        }
    ]);
}((0, $5FkrB.PureComponent));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($04f62ba387148165$export$d498ee8be33e096f, "displayName", 'WithProviders');

});

parcelRegister("fIf3B", function(module, exports) {
$parcel$export(module.exports, "getExtensionRenderer", () => $b706a520e42ab334$export$9214452ef07eda7);

var $ekGgq = parcelRequire("ekGgq");
function $b706a520e42ab334$export$9214452ef07eda7(extensionHandler) {
    if ((0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(extensionHandler) === 'object') return extensionHandler.render;
    else return extensionHandler;
}

});


parcelRegister("c6bEO", function(module, exports) {
$parcel$export(module.exports, "shadowClassNames", () => $8cef167b7eff7b79$export$4735dd2b0fa88aa5);
$parcel$export(module.exports, "default", () => $8cef167b7eff7b79$export$2e2bcd8739ae039);

var $kqp0i = parcelRequire("kqp0i");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $kIXpt = parcelRequire("kIXpt");

var $cYPzS = parcelRequire("cYPzS");

var $eyuDe = parcelRequire("eyuDe");

var $25nEq = parcelRequire("25nEq");

var $5FkrB = parcelRequire("5FkrB");

var $3ytat = parcelRequire("3ytat");
function $8cef167b7eff7b79$var$_callSuper(t, o, e) {
    return o = (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(o), (0, (/*@__PURE__*/$parcel$interopDefault($kIXpt)))(t, $8cef167b7eff7b79$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(t).constructor) : o.apply(t, e));
}
function $8cef167b7eff7b79$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($8cef167b7eff7b79$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $8cef167b7eff7b79$export$4735dd2b0fa88aa5 = {
    RIGHT_SHADOW: 'right-shadow',
    LEFT_SHADOW: 'left-shadow'
};
function $8cef167b7eff7b79$export$2e2bcd8739ae039(Component, options) {
    return /*#__PURE__*/ function(_React$Component) {
        function OverflowShadow() {
            var _this;
            (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, OverflowShadow);
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            _this = $8cef167b7eff7b79$var$_callSuper(this, OverflowShadow, [].concat(args));
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "overflowContainerWidth", 0);
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "state", {
                showLeftShadow: false,
                showRightShadow: false
            });
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "handleScroll", function(event) {
                if (!_this.overflowContainer || event.target !== _this.overflowContainer || options.useShadowObserver) return;
                _this.updateShadows();
            });
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "updateShadows", function() {
                if (options.useShadowObserver) return;
                _this.setState(function(prevState) {
                    if (!_this.overflowContainer) return;
                    var diff = _this.calcOverflowDiff();
                    var showRightShadow = diff > 0 && diff > _this.overflowContainer.scrollLeft;
                    var showLeftShadow = _this.showLeftShadow(_this.overflowContainer);
                    if (showLeftShadow !== prevState.showLeftShadow || showRightShadow !== _this.state.showRightShadow) return {
                        showLeftShadow: showLeftShadow,
                        showRightShadow: showRightShadow
                    };
                    return null;
                });
            });
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "showLeftShadow", function(overflowContainer) {
                return !!overflowContainer && overflowContainer.scrollLeft > 0;
            });
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "calcOverflowDiff", function() {
                if (!_this.overflowContainer) return 0;
                _this.diff = _this.calcScrollableWidth();
                return _this.diff - _this.overflowContainer.offsetWidth;
            });
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "calcScrollableWidth", function() {
                if (!_this.scrollable && _this.overflowContainer) return _this.overflowContainer.scrollWidth;
                if (!_this.scrollable) return 0;
                var width = 0;
                for(var i = 0; i < _this.scrollable.length; i++){
                    var scrollableElement = _this.scrollable[i];
                    if ($8cef167b7eff7b79$var$isElementNode(scrollableElement)) width += scrollableElement.scrollWidth;
                }
                return width;
            });
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "handleContainer", function(container) {
                if (!container || _this.container) return;
                _this.container = container;
                _this.overflowContainer = container.querySelector(options.overflowSelector);
                if (!_this.overflowContainer) _this.overflowContainer = container;
                if (options.useShadowObserver) {
                    _this.initShadowObserver();
                    return;
                }
                _this.updateShadows();
                // Ignored via go/ees005
                // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                _this.overflowContainer.addEventListener('scroll', _this.handleScroll);
            });
            return _this;
        }
        (0, (/*@__PURE__*/$parcel$interopDefault($eyuDe)))(OverflowShadow, _React$Component);
        return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(OverflowShadow, [
            {
                key: "componentWillUnmount",
                value: function componentWillUnmount() {
                    if (options.useShadowObserver) return this.shadowObserver && this.shadowObserver.dispose();
                    if (this.overflowContainer) // Ignored via go/ees005
                    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                    this.overflowContainer.removeEventListener('scroll', this.handleScroll);
                    this.updateShadows();
                }
            },
            {
                key: "componentDidUpdate",
                value: function componentDidUpdate() {
                    if (!options.useShadowObserver) this.updateShadows();
                }
            },
            {
                key: "initShadowObserver",
                value: function initShadowObserver() {
                    var _this2 = this;
                    if (this.shadowObserver || !this.overflowContainer) return;
                    this.shadowObserver = new (0, $3ytat.ShadowObserver)({
                        scrollContainer: this.overflowContainer,
                        onUpdateShadows: function onUpdateShadows(shadowStates) {
                            _this2.setState(function(prevState) {
                                var showLeftShadow = shadowStates.showLeftShadow, showRightShadow = shadowStates.showRightShadow;
                                if (showLeftShadow !== prevState.showLeftShadow || showRightShadow !== prevState.showRightShadow) return {
                                    showLeftShadow: showLeftShadow,
                                    showRightShadow: showRightShadow
                                };
                                return null;
                            });
                        }
                    });
                }
            },
            {
                key: "render",
                value: function render() {
                    var _this$props, _this$props2;
                    var _this$state = this.state, showLeftShadow = _this$state.showLeftShadow, showRightShadow = _this$state.showRightShadow;
                    var classNames = [
                        !((_this$props = this.props) !== null && _this$props !== void 0 && _this$props.disableTableOverflowShadow) && showRightShadow && $8cef167b7eff7b79$export$4735dd2b0fa88aa5.RIGHT_SHADOW,
                        !((_this$props2 = this.props) !== null && _this$props2 !== void 0 && _this$props2.disableTableOverflowShadow) && showLeftShadow && $8cef167b7eff7b79$export$4735dd2b0fa88aa5.LEFT_SHADOW,
                        options.useShadowObserver && (0, $3ytat.shadowObserverClassNames).SHADOW_CONTAINER
                    ].filter(Boolean).join(' ');
                    /**
         * The widths have already been calculated to determine
         * showRightShadow and showLeftShadow. If either is true,
         * then the content is scrollable and we need to set the
         * tabIndex to 0 to allow the user to scroll the content
         * for a11y purposes.
         */ var hasOverflowScroll = showRightShadow || showLeftShadow;
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(Component, (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
                        handleRef: this.handleContainer,
                        tabIndex: hasOverflowScroll ? 0 : undefined,
                        shadowClassNames: classNames
                    }, this.props));
                }
            }
        ]);
    }((0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).Component);
}
// Helper function to check if the passed node is of Element class
function $8cef167b7eff7b79$var$isElementNode(node) {
    return node.nodeType === 1;
}

});
parcelRegister("3ytat", function(module, exports) {
$parcel$export(module.exports, "shadowObserverClassNames", () => $296b2c378a6b7159$export$1cbe0bb16052178d);
$parcel$export(module.exports, "ShadowObserver", () => $296b2c378a6b7159$export$51a5b28e4fb2dba2);

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $25nEq = parcelRequire("25nEq");

var $3tz1M = parcelRequire("3tz1M");
var $296b2c378a6b7159$export$ebeea2fe2e93862e = /*#__PURE__*/ function(ShadowKeys) {
    ShadowKeys["SHOW_LEFT_SHADOW"] = "showLeftShadow";
    ShadowKeys["SHOW_RIGHT_SHADOW"] = "showRightShadow";
    return ShadowKeys;
}({});
var $296b2c378a6b7159$export$1cbe0bb16052178d = {
    SENTINEL_LEFT: 'sentinel-left',
    SENTINEL_RIGHT: 'sentinel-right',
    SHADOW_CONTAINER: 'with-shadow-observer'
};
var $296b2c378a6b7159$var$requestIdleCallback = function requestIdleCallback(fn) {
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return window.requestIdleCallback ? // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    window.requestIdleCallback(fn) : window.requestAnimationFrame(fn);
};
var $296b2c378a6b7159$var$cancelIdleCallback = function cancelIdleCallback(id) {
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return window.cancelIdleCallback ? // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    window.cancelIdleCallback(id) : window.cancelAnimationFrame(id);
};
var $296b2c378a6b7159$export$51a5b28e4fb2dba2 = /*#__PURE__*/ function() {
    function ShadowObserver(_ref) {
        var _this = this;
        var scrollContainer = _ref.scrollContainer, onUpdateShadows = _ref.onUpdateShadows;
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, ShadowObserver);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "sentinels", {});
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "shadowStates", (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, $296b2c378a6b7159$export$ebeea2fe2e93862e.SHOW_LEFT_SHADOW, false), $296b2c378a6b7159$export$ebeea2fe2e93862e.SHOW_RIGHT_SHADOW, false));
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "init", function() {
            if (!_this.scrollContainer || _this.intersectionObserver) return;
            _this.sentinels.right = document.createElement('div');
            _this.sentinels.right.classList.add($296b2c378a6b7159$export$1cbe0bb16052178d.SENTINEL_RIGHT);
            _this.scrollContainer.appendChild(_this.sentinels.right);
            _this.sentinels.left = document.createElement('div');
            _this.sentinels.left.classList.add($296b2c378a6b7159$export$1cbe0bb16052178d.SENTINEL_LEFT);
            _this.scrollContainer.prepend(_this.sentinels.left);
            _this.intersectionObserver = new IntersectionObserver(function(entries, _) {
                entries.forEach(_this.onIntersect);
            }, {
                root: _this.scrollContainer,
                rootMargin: '1px'
            });
            _this.intersectionObserver.observe(_this.sentinels.left);
            _this.intersectionObserver.observe(_this.sentinels.right);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "onIntersect", function(entry) {
            _this.requestCallbackId = $296b2c378a6b7159$var$requestIdleCallback(function() {
                if (entry.target.classList.contains($296b2c378a6b7159$export$1cbe0bb16052178d.SENTINEL_LEFT)) _this.shadowStates[$296b2c378a6b7159$export$ebeea2fe2e93862e.SHOW_LEFT_SHADOW] = !entry.isIntersecting;
                if (entry.target.classList.contains($296b2c378a6b7159$export$1cbe0bb16052178d.SENTINEL_RIGHT)) _this.shadowStates[$296b2c378a6b7159$export$ebeea2fe2e93862e.SHOW_RIGHT_SHADOW] = !entry.isIntersecting;
                _this.onUpdateShadows(_this.shadowStates);
            });
        });
        this.scrollContainer = scrollContainer;
        this.onUpdateShadows = onUpdateShadows;
        this.init();
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(ShadowObserver, [
        {
            key: "dispose",
            value: function dispose() {
                if (this.intersectionObserver) {
                    this.intersectionObserver.disconnect();
                    this.intersectionObserver = undefined;
                    this.requestCallbackId && $296b2c378a6b7159$var$cancelIdleCallback(this.requestCallbackId);
                }
                if ((0, $3tz1M.expValEquals)('platform_editor_renderer_shadow_observer_cleanup', 'isEnabled', true)) {
                    var _this$sentinels$left, _this$sentinels$right;
                    (_this$sentinels$left = this.sentinels.left) === null || _this$sentinels$left === void 0 || _this$sentinels$left.remove();
                    (_this$sentinels$right = this.sentinels.right) === null || _this$sentinels$right === void 0 || _this$sentinels$right.remove();
                    this.sentinels = {};
                }
            }
        }
    ]);
}();

});
parcelRegister("3tz1M", function(module, exports) {
$parcel$export(module.exports, "expValEquals", () => $287f40536fb8b792$export$45abdb3f977b5b14);

var $kE9E8 = parcelRequire("kE9E8");
function $287f40536fb8b792$export$45abdb3f977b5b14(experimentName, experimentParam, experimentExpectedValue) {
    var experimentDefaultValue = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
    return (0, $kE9E8.expValEqualsInternal)(experimentName, experimentParam, experimentExpectedValue, experimentDefaultValue, true);
}

});
parcelRegister("kE9E8", function(module, exports) {
$parcel$export(module.exports, "expValEqualsInternal", () => $f07f06a7c56a5d00$export$58e581060588c6bb);

var $ivkVy = parcelRequire("ivkVy");

var $49qw5 = parcelRequire("49qw5");

var $2uJ2L = parcelRequire("2uJ2L");
function $f07f06a7c56a5d00$export$58e581060588c6bb(experimentName, experimentParam, experimentExpectedValue, experimentDefaultValue, experimentExposure) {
    // @ts-ignore need to loosen the type here to allow for any experiment name
    if ((0, $2uJ2L._overrides)[experimentName] !== undefined) // This will be hit in the case of a test setting an override
    // @ts-ignore need to loosen the type here to allow for any experiment name
    return (0, $2uJ2L._overrides)[experimentName] === experimentExpectedValue;
    // If client is not initialized, we compare with the default value
    if (!(0, $ivkVy.default).initializeCompleted()) return experimentDefaultValue === experimentExpectedValue;
    // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
    var experimentValue = (0, $ivkVy.default).getExperimentValue(experimentName, experimentParam, experimentDefaultValue, {
        fireExperimentExposure: experimentExposure
    });
    if (// eslint-disable-next-line @atlaskit/platform/use-recommended-utils
    (0, $ivkVy.default).getExperimentValue('cc_editor_experiments_ufo_gate_reporting', 'isEnabled', false)) // Duplicated from /confluence/next/packages/feature-experiments/src/index.ts
    (0, $49qw5.addFeatureFlagAccessed)("".concat(experimentName, ":").concat(experimentParam), experimentValue);
    return experimentValue === experimentExpectedValue;
}

});
parcelRegister("ivkVy", function(module, exports) {
$parcel$export(module.exports, "default", () => $d78b5af2e9b09485$export$2e2bcd8739ae039);

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $25nEq = parcelRequire("25nEq");

var $2MffS = parcelRequire("2MffS");

var $1OJWH = parcelRequire("1OJWH");



var $d78b5af2e9b09485$var$_FeatureGates;
/**
 * Access the FeatureGates object via the default export.
 * ```ts
 * import FeatureGates from '@atlaskit/feature-gate-js-client';
 * ```
 */ var $d78b5af2e9b09485$var$FeatureGates = /*#__PURE__*/ function() {
    function FeatureGates() {
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, FeatureGates);
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(FeatureGates, null, [
        {
            key: "isGateExists",
            value: function isGateExists(gateName) {
                return this.client.isGateExist(gateName);
            }
        },
        {
            key: "isExperimentExists",
            value: function isExperimentExists(experimentName) {
                return this.client.isExperimentExist(experimentName);
            }
        }
    ]);
}();
$d78b5af2e9b09485$var$_FeatureGates = $d78b5af2e9b09485$var$FeatureGates;
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($d78b5af2e9b09485$var$FeatureGates, "client", new (0, $2MffS.Client)());
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($d78b5af2e9b09485$var$FeatureGates, "hasCheckGateErrorOccurred", false);
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($d78b5af2e9b09485$var$FeatureGates, "hasGetExperimentValueErrorOccurred", false);
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($d78b5af2e9b09485$var$FeatureGates, "checkGate", function(gateName, options) {
    try {
        // Check if the CRITERION override mechanism is available
        if (typeof window !== 'undefined' && window.__CRITERION__ && typeof window.__CRITERION__.getFeatureFlagOverride === 'function') {
            // Attempt to retrieve an override value for the feature gate
            var overrideValue = window.__CRITERION__.getFeatureFlagOverride(gateName);
            // If an override value is found, return it immediately
            if (overrideValue !== undefined) return overrideValue;
        }
    } catch (error) {
        // Log the first occurrence of the error
        if (!$d78b5af2e9b09485$var$_FeatureGates.hasCheckGateErrorOccurred) {
            // eslint-disable-next-line no-console
            console.warn({
                msg: 'An error has occurred checking the feature gate from criterion override. Only the first occurrence of this error is logged.',
                gateName: gateName,
                error: error
            });
            $d78b5af2e9b09485$var$_FeatureGates.hasCheckGateErrorOccurred = true;
        }
    }
    // Proceed with the main logic if no override is found
    return $d78b5af2e9b09485$var$_FeatureGates.client.checkGate(gateName, options);
});
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($d78b5af2e9b09485$var$FeatureGates, "getExperimentValue", function(experimentName, parameterName, defaultValue, options) {
    try {
        // Check if the CRITERION override mechanism is available
        if (typeof window !== 'undefined' && window.__CRITERION__ && typeof window.__CRITERION__.getExperimentValueOverride === 'function') {
            var overrideValue = window.__CRITERION__.getExperimentValueOverride(experimentName, parameterName);
            if (overrideValue !== undefined && overrideValue !== null) return overrideValue;
        }
    } catch (error) {
        // Log the first occurrence of the error
        if (!$d78b5af2e9b09485$var$_FeatureGates.hasGetExperimentValueErrorOccurred) {
            // eslint-disable-next-line no-console
            console.warn({
                msg: 'An error has occurred getting the experiment value from criterion override. Only the first occurrence of this error is logged.',
                experimentName: experimentName,
                defaultValue: defaultValue,
                options: options,
                error: error
            });
            $d78b5af2e9b09485$var$_FeatureGates.hasGetExperimentValueErrorOccurred = true;
        }
        return defaultValue;
    }
    // Proceed with the main logic if no override is found
    return $d78b5af2e9b09485$var$_FeatureGates.client.getExperimentValue(experimentName, parameterName, defaultValue, options);
});
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($d78b5af2e9b09485$var$FeatureGates, "initializeCalled", $d78b5af2e9b09485$var$_FeatureGates.client.initializeCalled.bind($d78b5af2e9b09485$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($d78b5af2e9b09485$var$FeatureGates, "initializeCompleted", $d78b5af2e9b09485$var$_FeatureGates.client.initializeCompleted.bind($d78b5af2e9b09485$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($d78b5af2e9b09485$var$FeatureGates, "waitUntilInitializeCompleted", $d78b5af2e9b09485$var$_FeatureGates.client.waitUntilInitializeCompleted.bind($d78b5af2e9b09485$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($d78b5af2e9b09485$var$FeatureGates, "initialize", $d78b5af2e9b09485$var$_FeatureGates.client.initialize.bind($d78b5af2e9b09485$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($d78b5af2e9b09485$var$FeatureGates, "initializeWithProvider", $d78b5af2e9b09485$var$_FeatureGates.client.initializeWithProvider.bind($d78b5af2e9b09485$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($d78b5af2e9b09485$var$FeatureGates, "initializeFromValues", $d78b5af2e9b09485$var$_FeatureGates.client.initializeFromValues.bind($d78b5af2e9b09485$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($d78b5af2e9b09485$var$FeatureGates, "manuallyLogGateExposure", $d78b5af2e9b09485$var$_FeatureGates.client.manuallyLogGateExposure.bind($d78b5af2e9b09485$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($d78b5af2e9b09485$var$FeatureGates, "getExperiment", $d78b5af2e9b09485$var$_FeatureGates.client.getExperiment.bind($d78b5af2e9b09485$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($d78b5af2e9b09485$var$FeatureGates, "manuallyLogExperimentExposure", $d78b5af2e9b09485$var$_FeatureGates.client.manuallyLogExperimentExposure.bind($d78b5af2e9b09485$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($d78b5af2e9b09485$var$FeatureGates, "manuallyLogLayerExposure", $d78b5af2e9b09485$var$_FeatureGates.client.manuallyLogLayerExposure.bind($d78b5af2e9b09485$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($d78b5af2e9b09485$var$FeatureGates, "shutdownStatsig", $d78b5af2e9b09485$var$_FeatureGates.client.shutdownStatsig.bind($d78b5af2e9b09485$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($d78b5af2e9b09485$var$FeatureGates, "overrideGate", $d78b5af2e9b09485$var$_FeatureGates.client.overrideGate.bind($d78b5af2e9b09485$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($d78b5af2e9b09485$var$FeatureGates, "clearGateOverride", $d78b5af2e9b09485$var$_FeatureGates.client.clearGateOverride.bind($d78b5af2e9b09485$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($d78b5af2e9b09485$var$FeatureGates, "overrideConfig", $d78b5af2e9b09485$var$_FeatureGates.client.overrideConfig.bind($d78b5af2e9b09485$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($d78b5af2e9b09485$var$FeatureGates, "clearConfigOverride", $d78b5af2e9b09485$var$_FeatureGates.client.clearConfigOverride.bind($d78b5af2e9b09485$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($d78b5af2e9b09485$var$FeatureGates, "setOverrides", $d78b5af2e9b09485$var$_FeatureGates.client.setOverrides.bind($d78b5af2e9b09485$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($d78b5af2e9b09485$var$FeatureGates, "getOverrides", $d78b5af2e9b09485$var$_FeatureGates.client.getOverrides.bind($d78b5af2e9b09485$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($d78b5af2e9b09485$var$FeatureGates, "clearAllOverrides", $d78b5af2e9b09485$var$_FeatureGates.client.clearAllOverrides.bind($d78b5af2e9b09485$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($d78b5af2e9b09485$var$FeatureGates, "isCurrentUser", $d78b5af2e9b09485$var$_FeatureGates.client.isCurrentUser.bind($d78b5af2e9b09485$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($d78b5af2e9b09485$var$FeatureGates, "onGateUpdated", $d78b5af2e9b09485$var$_FeatureGates.client.onGateUpdated.bind($d78b5af2e9b09485$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($d78b5af2e9b09485$var$FeatureGates, "onExperimentValueUpdated", $d78b5af2e9b09485$var$_FeatureGates.client.onExperimentValueUpdated.bind($d78b5af2e9b09485$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($d78b5af2e9b09485$var$FeatureGates, "onAnyUpdated", $d78b5af2e9b09485$var$_FeatureGates.client.onAnyUpdated.bind($d78b5af2e9b09485$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($d78b5af2e9b09485$var$FeatureGates, "updateUser", $d78b5af2e9b09485$var$_FeatureGates.client.updateUser.bind($d78b5af2e9b09485$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($d78b5af2e9b09485$var$FeatureGates, "updateUserWithProvider", $d78b5af2e9b09485$var$_FeatureGates.client.updateUserWithProvider.bind($d78b5af2e9b09485$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($d78b5af2e9b09485$var$FeatureGates, "updateUserWithValues", $d78b5af2e9b09485$var$_FeatureGates.client.updateUserWithValues.bind($d78b5af2e9b09485$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($d78b5af2e9b09485$var$FeatureGates, "getPackageVersion", $d78b5af2e9b09485$var$_FeatureGates.client.getPackageVersion.bind($d78b5af2e9b09485$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($d78b5af2e9b09485$var$FeatureGates, "getLayer", $d78b5af2e9b09485$var$_FeatureGates.client.getLayer.bind($d78b5af2e9b09485$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($d78b5af2e9b09485$var$FeatureGates, "getLayerValue", $d78b5af2e9b09485$var$_FeatureGates.client.getLayerValue.bind($d78b5af2e9b09485$var$_FeatureGates.client));
var $d78b5af2e9b09485$var$boundFGJS = $d78b5af2e9b09485$var$FeatureGates;
// This makes it possible to get a reference to the FeatureGates client at runtime.
// This is important for overriding values in Cypress tests, as there needs to be a
// way to get the exact instance for a window in order to mock some of its methods.
if (typeof window !== 'undefined') {
    if (window.__FEATUREGATES_JS__ === undefined) window.__FEATUREGATES_JS__ = $d78b5af2e9b09485$var$FeatureGates;
    else {
        var $d78b5af2e9b09485$var$_boundFGJS, $d78b5af2e9b09485$var$_boundFGJS$getPackage;
        $d78b5af2e9b09485$var$boundFGJS = window.__FEATUREGATES_JS__;
        var $d78b5af2e9b09485$var$boundVersion = (($d78b5af2e9b09485$var$_boundFGJS = $d78b5af2e9b09485$var$boundFGJS) === null || $d78b5af2e9b09485$var$_boundFGJS === void 0 || ($d78b5af2e9b09485$var$_boundFGJS$getPackage = $d78b5af2e9b09485$var$_boundFGJS.getPackageVersion) === null || $d78b5af2e9b09485$var$_boundFGJS$getPackage === void 0 ? void 0 : $d78b5af2e9b09485$var$_boundFGJS$getPackage.call($d78b5af2e9b09485$var$_boundFGJS)) || '4.10.0 or earlier';
        if ($d78b5af2e9b09485$var$boundVersion !== (0, $1OJWH.CLIENT_VERSION)) {
            var $d78b5af2e9b09485$var$message = "Multiple versions of FeatureGateClients found on the current page.\n      The currently bound version is ".concat($d78b5af2e9b09485$var$boundVersion, " when module version ").concat((0, $1OJWH.CLIENT_VERSION), " was loading.");
            // eslint-disable-next-line no-console
            console.warn($d78b5af2e9b09485$var$message);
        }
    }
}
var /**
 * @property {FeatureGates} FeatureGate default export
 */ $d78b5af2e9b09485$export$2e2bcd8739ae039 = $d78b5af2e9b09485$var$boundFGJS;

});
parcelRegister("2MffS", function(module, exports) {
$parcel$export(module.exports, "Client", () => $205be5d487f24bd6$export$1f2bb630327ac4b6);

var $1Vcia = parcelRequire("1Vcia");

var $iYJcE = parcelRequire("iYJcE");

var $fL8KA = parcelRequire("fL8KA");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $25nEq = parcelRequire("25nEq");

var $6HG4S = parcelRequire("6HG4S");

var $iFR7a = parcelRequire("iFR7a");

var $a2rTA = parcelRequire("a2rTA");

var $2JDKH = parcelRequire("2JDKH");

var $fhNL7 = parcelRequire("fhNL7");

var $cjLbo = parcelRequire("cjLbo");

var $hTYAN = parcelRequire("hTYAN");

var $i8loy = parcelRequire("i8loy");

var $14TSq = parcelRequire("14TSq");

var $lK9nx = parcelRequire("lK9nx");

var $8y781 = parcelRequire("8y781");

var $1OJWH = parcelRequire("1OJWH");
var $205be5d487f24bd6$var$_excluded = [
    "sdkKey",
    "environment",
    "updateUserCompletionCallback",
    "perimeter"
];
function $205be5d487f24bd6$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $205be5d487f24bd6$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $205be5d487f24bd6$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $205be5d487f24bd6$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $205be5d487f24bd6$var$DEFAULT_CLIENT_KEY = 'client-default-key';
// default event logging api is Atlassian proxy rather than Statsig's domain, to avoid ad blockers
var $205be5d487f24bd6$var$DEFAULT_EVENT_LOGGING_API = 'https://xp.atlassian.com/v1/rgstr';
var $205be5d487f24bd6$export$1f2bb630327ac4b6 = /*#__PURE__*/ function() {
    function Client() {
        var _this = this;
        var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, _ref$localStorageKey = _ref.localStorageKey, localStorageKey = _ref$localStorageKey === void 0 ? (0, $14TSq.LOCAL_STORAGE_KEY) : _ref$localStorageKey, overrideAdapter = _ref.overrideAdapter;
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, Client);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "initPromise", null);
        /** True if an initialize method was called and completed successfully. */ (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "initCompleted", false);
        /**
     * True if an initialize method was called and completed, meaning the client is now usable.
     * However if there was an error during initialization it may have initialized with default
     * values. Use {@link initCompleted} to check for this.
     */ (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "initWithDefaults", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "hasCheckGateErrorOccurred", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "hasGetExperimentErrorOccurred", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "hasGetExperimentValueErrorOccurred", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "hasGetLayerErrorOccurred", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "hasGetLayerValueErrorOccurred", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "subscriptions", new (0, $a2rTA.default)());
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "dataAdapter", new (0, $i8loy.NoFetchDataAdapter)());
        /**
     * Call this if modifying the values being served by the Statsig library since it has its own
     * memoization cache which will not be updated if the values are changed outside of the library.
     */ (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "statsigValuesUpdated", function() {
            if (_this.user) // Trigger a reset of the memoize cache
            _this.statsigClient.updateUserSync(_this.user, {
                disableBackgroundCacheRefresh: true
            });
            _this.subscriptions.anyUpdated();
        });
        this.overrideAdapter = overrideAdapter || new (0, $14TSq.PersistentOverrideAdapter)(localStorageKey);
    }
    /**
   * @description
   * This method initializes the client using a network call to fetch the bootstrap values.
   * If the client is inialized with an `analyticsWebClient`, it will send an operational event
   * to GASv3 with the following attributes:
   * - targetApp: the target app of the client
   * - clientVersion: the version of the client
   * - success: whether the initialization was successful
   * - startTime: the time when the initialization started
   * - totalTime: the total time it took to initialize the client
   * - apiKey: the api key used to initialize the client
   * @param clientOptions {ClientOptions}
   * @param identifiers {Identifiers}
   * @param customAttributes {CustomAttributes}
   * @returns {Promise<void>}
   */ return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(Client, [
        {
            key: "initialize",
            value: function() {
                var _initialize = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee(clientOptions, identifiers, customAttributes) {
                    var _this2 = this;
                    var clientOptionsWithDefaults, startTime;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee$(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                clientOptionsWithDefaults = (0, $8y781.getOptionsWithDefaults)(clientOptions);
                                if (!this.initPromise) {
                                    _context.next = 4;
                                    break;
                                }
                                if (!(0, $8y781.shallowEquals)(clientOptionsWithDefaults, this.initOptions)) // eslint-disable-next-line no-console
                                console.warn('Feature Gates client already initialized with different options. New options were not applied.');
                                return _context.abrupt("return", this.initPromise);
                            case 4:
                                startTime = performance.now();
                                this.initOptions = clientOptionsWithDefaults;
                                this.initPromise = this.init(clientOptionsWithDefaults, identifiers, customAttributes).then(function() {
                                    _this2.initCompleted = true;
                                    _this2.initWithDefaults = true;
                                }).finally(function() {
                                    var endTime = performance.now();
                                    var totalTime = endTime - startTime;
                                    _this2.fireClientEvent(startTime, totalTime, 'initialize', _this2.initCompleted, clientOptionsWithDefaults.apiKey);
                                });
                                return _context.abrupt("return", this.initPromise);
                            case 8:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee, this);
                }));
                function initialize(_x, _x2, _x3) {
                    return _initialize.apply(this, arguments);
                }
                return initialize;
            }()
        },
        {
            key: "initializeWithProvider",
            value: function() {
                var _initializeWithProvider = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee2(clientOptions, provider, identifiers, customAttributes) {
                    var _this3 = this;
                    var clientOptionsWithDefaults, startTime;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee2$(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                clientOptionsWithDefaults = (0, $8y781.getOptionsWithDefaults)(clientOptions);
                                if (!this.initPromise) {
                                    _context2.next = 4;
                                    break;
                                }
                                if (!(0, $8y781.shallowEquals)(clientOptionsWithDefaults, this.initOptions)) // eslint-disable-next-line no-console
                                console.warn('Feature Gates client already initialized with different options. New options were not applied.');
                                return _context2.abrupt("return", this.initPromise);
                            case 4:
                                startTime = performance.now();
                                this.initOptions = clientOptionsWithDefaults;
                                this.provider = provider;
                                this.provider.setClientVersion((0, $1OJWH.CLIENT_VERSION));
                                if (this.provider.setApplyUpdateCallback) this.provider.setApplyUpdateCallback(this.applyUpdateCallback.bind(this));
                                this.initPromise = this.initWithProvider(clientOptionsWithDefaults, provider, identifiers, customAttributes).then(function() {
                                    _this3.initCompleted = true;
                                    _this3.initWithDefaults = true;
                                }).finally(function() {
                                    var endTime = performance.now();
                                    var totalTime = endTime - startTime;
                                    _this3.fireClientEvent(startTime, totalTime, 'initializeWithProvider', _this3.initCompleted, provider.getApiKey ? provider.getApiKey() : undefined);
                                });
                                return _context2.abrupt("return", this.initPromise);
                            case 11:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2, this);
                }));
                function initializeWithProvider(_x4, _x5, _x6, _x7) {
                    return _initializeWithProvider.apply(this, arguments);
                }
                return initializeWithProvider;
            }()
        },
        {
            key: "applyUpdateCallback",
            value: function applyUpdateCallback(experimentsResult) {
                try {
                    if (this.initCompleted || this.initWithDefaults) {
                        this.assertInitialized(this.statsigClient);
                        this.dataAdapter.setBootstrapData(experimentsResult.experimentValues);
                        this.dataAdapter.setData(JSON.stringify(experimentsResult.experimentValues));
                        this.statsigValuesUpdated();
                    }
                } catch (error) {
                    // eslint-disable-next-line no-console
                    console.warn('Error when attempting to apply update', error);
                }
            }
        },
        {
            key: "fireClientEvent",
            value: function fireClientEvent(startTime, totalTime, action, success) {
                var _analyticsWebClient, _this4 = this;
                var apiKey = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
                (_analyticsWebClient = this.initOptions.analyticsWebClient) === null || _analyticsWebClient === void 0 || _analyticsWebClient.then(function(analyticsWebClient) {
                    var attributes = $205be5d487f24bd6$var$_objectSpread({
                        targetApp: _this4.initOptions.targetApp,
                        clientVersion: (0, $1OJWH.CLIENT_VERSION),
                        success: success,
                        startTime: startTime,
                        totalTime: totalTime
                    }, apiKey && {
                        apiKey: apiKey
                    });
                    analyticsWebClient.sendOperationalEvent({
                        action: action,
                        actionSubject: 'featureGatesClient',
                        attributes: attributes,
                        tags: [
                            'measurement'
                        ],
                        source: '@atlaskit/feature-gate-js-client'
                    });
                }).catch(function(err) {
                    if (_this4.initOptions.environment !== (0, $lK9nx.FeatureGateEnvironment).Production) // eslint-disable-next-line no-console
                    console.error('Analytics web client promise did not resolve', err);
                });
            }
        },
        {
            key: "initializeFromValues",
            value: function() {
                var _initializeFromValues = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee3(clientOptions, identifiers, customAttributes) {
                    var _this5 = this;
                    var initializeValues, clientOptionsWithDefaults, startTime, _args3 = arguments;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee3$(_context3) {
                        while(true)switch(_context3.prev = _context3.next){
                            case 0:
                                initializeValues = _args3.length > 3 && _args3[3] !== undefined ? _args3[3] : {};
                                clientOptionsWithDefaults = (0, $8y781.getOptionsWithDefaults)(clientOptions);
                                if (!this.initPromise) {
                                    _context3.next = 5;
                                    break;
                                }
                                if (!(0, $8y781.shallowEquals)(clientOptionsWithDefaults, this.initOptions)) // eslint-disable-next-line no-console
                                console.warn('Feature Gates client already initialized with different options. New options were not applied.');
                                return _context3.abrupt("return", this.initPromise);
                            case 5:
                                // This makes sure the new Statsig client behaves like the old when bootstrap data is
                                // passed, and `has_updates` isn't specified (which happens a lot in product integration tests).
                                if (!Object.prototype.hasOwnProperty.call(initializeValues, 'has_updates')) initializeValues['has_updates'] = true;
                                startTime = performance.now();
                                this.initOptions = clientOptionsWithDefaults;
                                this.initPromise = this.initFromValues(clientOptionsWithDefaults, identifiers, customAttributes, initializeValues).then(function() {
                                    _this5.initCompleted = true;
                                    _this5.initWithDefaults = true;
                                }).finally(function() {
                                    var endTime = performance.now();
                                    var totalTime = endTime - startTime;
                                    _this5.fireClientEvent(startTime, totalTime, 'initializeFromValues', _this5.initCompleted);
                                });
                                return _context3.abrupt("return", this.initPromise);
                            case 10:
                            case "end":
                                return _context3.stop();
                        }
                    }, _callee3, this);
                }));
                function initializeFromValues(_x8, _x9, _x0) {
                    return _initializeFromValues.apply(this, arguments);
                }
                return initializeFromValues;
            }()
        },
        {
            key: "assertInitialized",
            value: function assertInitialized(statsigClient) {
                if (!statsigClient) throw new Error('Client must be initialized before using this method');
            }
        },
        {
            key: "updateUser",
            value: function() {
                var _updateUser = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee4(fetchOptions, identifiers, customAttributes) {
                    var fetchOptionsWithDefaults, initializeValuesProducer;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee4$(_context4) {
                        while(true)switch(_context4.prev = _context4.next){
                            case 0:
                                this.assertInitialized(this.statsigClient);
                                fetchOptionsWithDefaults = (0, $8y781.getOptionsWithDefaults)(fetchOptions);
                                initializeValuesProducer = function initializeValuesProducer() {
                                    return (0, $hTYAN.default).fetchExperimentValues(fetchOptionsWithDefaults, identifiers, customAttributes).then(function(_ref2) {
                                        var experimentValues = _ref2.experimentValues, customAttributes = _ref2.customAttributes;
                                        return {
                                            experimentValues: experimentValues,
                                            customAttributesFromFetch: customAttributes
                                        };
                                    });
                                };
                                _context4.next = 5;
                                return this.updateUserUsingInitializeValuesProducer(initializeValuesProducer, identifiers, customAttributes);
                            case 5:
                            case "end":
                                return _context4.stop();
                        }
                    }, _callee4, this);
                }));
                function updateUser(_x1, _x10, _x11) {
                    return _updateUser.apply(this, arguments);
                }
                return updateUser;
            }()
        },
        {
            key: "updateUserWithProvider",
            value: function() {
                var _updateUserWithProvider = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee5(identifiers, customAttributes) {
                    var _this6 = this;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee5$(_context5) {
                        while(true)switch(_context5.prev = _context5.next){
                            case 0:
                                this.assertInitialized(this.statsigClient);
                                if (this.provider) {
                                    _context5.next = 3;
                                    break;
                                }
                                throw new Error('Cannot update user using provider as the client was not initialised with a provider');
                            case 3:
                                _context5.next = 5;
                                return this.provider.setProfile(this.initOptions, identifiers, customAttributes);
                            case 5:
                                _context5.next = 7;
                                return this.updateUserUsingInitializeValuesProducer(function() {
                                    return _this6.provider.getExperimentValues();
                                }, identifiers, customAttributes);
                            case 7:
                            case "end":
                                return _context5.stop();
                        }
                    }, _callee5, this);
                }));
                function updateUserWithProvider(_x12, _x13) {
                    return _updateUserWithProvider.apply(this, arguments);
                }
                return updateUserWithProvider;
            }()
        },
        {
            key: "updateUserWithValues",
            value: function() {
                var _updateUserWithValues = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee6(identifiers, customAttributes) {
                    var initializeValues, initializeValuesProducer, _args6 = arguments;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee6$(_context6) {
                        while(true)switch(_context6.prev = _context6.next){
                            case 0:
                                initializeValues = _args6.length > 2 && _args6[2] !== undefined ? _args6[2] : {};
                                this.assertInitialized(this.statsigClient);
                                initializeValuesProducer = function initializeValuesProducer() {
                                    return Promise.resolve({
                                        experimentValues: initializeValues,
                                        customAttributesFromFetch: customAttributes
                                    });
                                };
                                _context6.next = 5;
                                return this.updateUserUsingInitializeValuesProducer(initializeValuesProducer, identifiers, customAttributes);
                            case 5:
                            case "end":
                                return _context6.stop();
                        }
                    }, _callee6, this);
                }));
                function updateUserWithValues(_x14, _x15) {
                    return _updateUserWithValues.apply(this, arguments);
                }
                return updateUserWithValues;
            }()
        },
        {
            key: "initializeCalled",
            value: function initializeCalled() {
                return this.initPromise != null;
            }
        },
        {
            key: "initializeCompleted",
            value: function initializeCompleted() {
                return this.initCompleted;
            }
        },
        {
            key: "waitUntilInitializeCompleted",
            value: function() {
                var _waitUntilInitializeCompleted = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee7() {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee7$(_context7) {
                        while(true)switch(_context7.prev = _context7.next){
                            case 0:
                                if (this.initPromise) {
                                    _context7.next = 2;
                                    break;
                                }
                                throw new Error('The client must be initialized before you can wait until initialized.');
                            case 2:
                                if (!this.initCompleted) {
                                    _context7.next = 4;
                                    break;
                                }
                                return _context7.abrupt("return");
                            case 4:
                                _context7.next = 6;
                                return this.initPromise;
                            case 6:
                            case "end":
                                return _context7.stop();
                        }
                    }, _callee7, this);
                }));
                function waitUntilInitializeCompleted() {
                    return _waitUntilInitializeCompleted.apply(this, arguments);
                }
                return waitUntilInitializeCompleted;
            }()
        },
        {
            key: "checkGate",
            value: function checkGate(gateName) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                try {
                    this.assertInitialized(this.statsigClient);
                    var _options$fireGateExpo = options.fireGateExposure, fireGateExposure = _options$fireGateExpo === void 0 ? true : _options$fireGateExpo;
                    return this.statsigClient.checkGate(gateName, {
                        disableExposureLog: !fireGateExposure
                    });
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!this.hasCheckGateErrorOccurred) {
                        // eslint-disable-next-line no-console
                        console.warn({
                            msg: 'An error has occurred checking the feature gate. Only the first occurrence of this error is logged.',
                            gateName: gateName,
                            error: error
                        });
                        this.hasCheckGateErrorOccurred = true;
                    }
                    return false;
                }
            }
        },
        {
            key: "isGateExist",
            value: function isGateExist(gateName) {
                try {
                    this.assertInitialized(this.statsigClient);
                    var gate = this.statsigClient.getFeatureGate(gateName, {
                        disableExposureLog: true
                    });
                    return !gate.details.reason.includes('Unrecognized');
                } catch (error) {
                    // eslint-disable-next-line no-console
                    console.error("Error occurred when trying to check FeatureGate: ".concat(error));
                    // in case of error report true to avoid false positives.
                    return true;
                }
            }
        },
        {
            key: "isExperimentExist",
            value: function isExperimentExist(experimentName) {
                try {
                    this.assertInitialized(this.statsigClient);
                    var config = this.statsigClient.getExperiment(experimentName, {
                        disableExposureLog: true
                    });
                    return !config.details.reason.includes('Unrecognized');
                } catch (error) {
                    // eslint-disable-next-line no-console
                    console.error("Error occurred when trying to check Experiment: ".concat(error));
                    // in case of error report true to avoid false positives.
                    return true;
                }
            }
        },
        {
            key: "manuallyLogGateExposure",
            value: function manuallyLogGateExposure(gateName) {
                this.assertInitialized(this.statsigClient);
                // This is the approach recommended in the docs
                // https://docs.statsig.com/client/javascript-sdk/#manual-exposures-
                this.statsigClient.checkGate(gateName);
            }
        },
        {
            key: "getExperiment",
            value: function getExperiment(experimentName) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                try {
                    this.assertInitialized(this.statsigClient);
                    var _options$fireExperime = options.fireExperimentExposure, fireExperimentExposure = _options$fireExperime === void 0 ? true : _options$fireExperime;
                    return (0, $2JDKH.DynamicConfig).fromExperiment(this.statsigClient.getExperiment(experimentName, {
                        disableExposureLog: !fireExperimentExposure
                    }));
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!this.hasGetExperimentErrorOccurred) {
                        // eslint-disable-next-line no-console
                        console.warn({
                            msg: 'An error has occurred getting the experiment. Only the first occurrence of this error is logged.',
                            experimentName: experimentName,
                            error: error
                        });
                        this.hasGetExperimentErrorOccurred = true;
                    }
                    // Return a default value
                    return new (0, $2JDKH.DynamicConfig)(experimentName, {}, '', {
                        time: Date.now(),
                        reason: (0, $cjLbo.EvaluationReason).Error
                    });
                }
            }
        },
        {
            key: "getExperimentValue",
            value: function getExperimentValue(experimentName, parameterName, defaultValue) {
                var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var experiment = this.getExperiment(experimentName, options);
                try {
                    var typeGuard = options.typeGuard;
                    return experiment.get(parameterName, defaultValue, typeGuard);
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!this.hasGetExperimentValueErrorOccurred) {
                        // eslint-disable-next-line no-console
                        console.warn({
                            msg: 'An error has occurred getting the experiment value. Only the first occurrence of this error is logged.',
                            experimentName: experimentName,
                            defaultValue: defaultValue,
                            options: options,
                            error: error
                        });
                        this.hasGetExperimentValueErrorOccurred = true;
                    }
                    return defaultValue;
                }
            }
        },
        {
            key: "manuallyLogExperimentExposure",
            value: function manuallyLogExperimentExposure(experimentName) {
                this.assertInitialized(this.statsigClient);
                // This is the approach recommended in the docs
                // https://docs.statsig.com/client/javascript-sdk/#manual-exposures-
                this.statsigClient.getExperiment(experimentName);
            }
        },
        {
            key: "manuallyLogLayerExposure",
            value: function manuallyLogLayerExposure(layerName, parameterName) {
                var _this$statsigClient$g;
                this.assertInitialized(this.statsigClient);
                // This is the approach recommended in the docs
                // https://docs.statsig.com/client/javascript-sdk/#manual-exposures-
                (_this$statsigClient$g = this.statsigClient.getLayer(layerName)) === null || _this$statsigClient$g === void 0 || _this$statsigClient$g.get(parameterName);
            }
        },
        {
            key: "shutdownStatsig",
            value: function shutdownStatsig() {
                this.assertInitialized(this.statsigClient);
                this.statsigClient.shutdown();
            }
        },
        {
            key: "overrideGate",
            value: function overrideGate(gateName, value) {
                this.overrideAdapter.overrideGate(gateName, value);
                // Trigger a reset of the memoized gate value
                if (this.user) {
                    var _this$statsigClient;
                    (_this$statsigClient = this.statsigClient) === null || _this$statsigClient === void 0 || _this$statsigClient.updateUserSync(this.user, {
                        disableBackgroundCacheRefresh: true
                    });
                }
                this.statsigValuesUpdated();
            }
        },
        {
            key: "clearGateOverride",
            value: function clearGateOverride(gateName) {
                this.overrideAdapter.removeGateOverride(gateName);
                this.statsigValuesUpdated();
            }
        },
        {
            key: "overrideConfig",
            value: function overrideConfig(experimentName, values) {
                this.overrideAdapter.overrideDynamicConfig(experimentName, values);
                this.statsigValuesUpdated();
            }
        },
        {
            key: "clearConfigOverride",
            value: function clearConfigOverride(experimentName) {
                this.overrideAdapter.removeDynamicConfigOverride(experimentName);
                this.statsigValuesUpdated();
            }
        },
        {
            key: "setOverrides",
            value: function setOverrides(overrides) {
                this.overrideAdapter.setOverrides(overrides);
                this.statsigValuesUpdated();
            }
        },
        {
            key: "getOverrides",
            value: function getOverrides() {
                return this.overrideAdapter.getOverrides();
            }
        },
        {
            key: "clearAllOverrides",
            value: function clearAllOverrides() {
                this.overrideAdapter.removeAllOverrides();
                this.statsigValuesUpdated();
            }
        },
        {
            key: "isCurrentUser",
            value: function isCurrentUser(identifiers, customAttributes) {
                return (0, $8y781.shallowEquals)(this.currentIdentifiers, identifiers) && (0, $8y781.shallowEquals)(this.currentAttributes, customAttributes);
            }
        },
        {
            key: "onGateUpdated",
            value: function onGateUpdated(gateName, callback) {
                var _this7 = this;
                var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var wrapCallback = function wrapCallback(value) {
                    var _options$fireGateExpo2 = options.fireGateExposure, fireGateExposure = _options$fireGateExpo2 === void 0 ? true : _options$fireGateExpo2;
                    if (fireGateExposure) _this7.manuallyLogGateExposure(gateName);
                    try {
                        callback(value);
                    } catch (error) {
                        // eslint-disable-next-line no-console
                        console.warn("Error calling callback for gate ".concat(gateName, " with value ").concat(value), error);
                    }
                };
                return this.subscriptions.onGateUpdated(gateName, wrapCallback, this.checkGate.bind(this), options);
            }
        },
        {
            key: "onExperimentValueUpdated",
            value: function onExperimentValueUpdated(experimentName, parameterName, defaultValue, callback) {
                var _this8 = this;
                var options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
                var wrapCallback = function wrapCallback(value) {
                    var _options$fireExperime2 = options.fireExperimentExposure, fireExperimentExposure = _options$fireExperime2 === void 0 ? true : _options$fireExperime2;
                    if (fireExperimentExposure) _this8.manuallyLogExperimentExposure(experimentName);
                    try {
                        callback(value);
                    } catch (error) {
                        // eslint-disable-next-line no-console
                        console.warn("Error calling callback for experiment ".concat(experimentName, " with value ").concat(value), error);
                    }
                };
                return this.subscriptions.onExperimentValueUpdated(experimentName, parameterName, defaultValue, wrapCallback, this.getExperimentValue.bind(this), options);
            }
        },
        {
            key: "onAnyUpdated",
            value: function onAnyUpdated(callback) {
                return this.subscriptions.onAnyUpdated(callback);
            }
        },
        {
            key: "init",
            value: function() {
                var _init = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee8(clientOptions, identifiers, customAttributes) {
                    var fromValuesClientOptions, experimentValues, customAttributesFromResult, clientSdkKeyPromise, experimentValuesPromise, _yield$Promise$all, _yield$Promise$all2, experimentValuesResult;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee8$(_context8) {
                        while(true)switch(_context8.prev = _context8.next){
                            case 0:
                                fromValuesClientOptions = $205be5d487f24bd6$var$_objectSpread({}, clientOptions);
                                _context8.prev = 1;
                                // If client sdk key fetch fails, an error would be thrown and handled instead of waiting for
                                // the experiment values request to be settled, and it will fall back to use default values.
                                clientSdkKeyPromise = (0, $hTYAN.default).fetchClientSdk(clientOptions).then(function(value) {
                                    return fromValuesClientOptions.sdkKey = value.clientSdkKey;
                                });
                                experimentValuesPromise = (0, $hTYAN.default).fetchExperimentValues(clientOptions, identifiers, customAttributes); // Only wait for the experiment values request to finish and try to initialise the client
                                // with experiment values if both requests are successful. Else an error would be thrown and
                                // handled by the catch
                                _context8.next = 6;
                                return Promise.all([
                                    clientSdkKeyPromise,
                                    experimentValuesPromise
                                ]);
                            case 6:
                                _yield$Promise$all = _context8.sent;
                                _yield$Promise$all2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_yield$Promise$all, 2);
                                experimentValuesResult = _yield$Promise$all2[1];
                                experimentValues = experimentValuesResult.experimentValues;
                                customAttributesFromResult = experimentValuesResult.customAttributes;
                                _context8.next = 20;
                                break;
                            case 13:
                                _context8.prev = 13;
                                _context8.t0 = _context8["catch"](1);
                                if (_context8.t0 instanceof Error) // eslint-disable-next-line no-console
                                console.error("Error occurred when trying to fetch the Feature Gates client values, error: ".concat(_context8.t0 === null || _context8.t0 === void 0 ? void 0 : _context8.t0.message));
                                // eslint-disable-next-line no-console
                                console.warn("Initialising Statsig client without values");
                                _context8.next = 19;
                                return this.initFromValues(fromValuesClientOptions, identifiers, customAttributes);
                            case 19:
                                throw _context8.t0;
                            case 20:
                                return _context8.abrupt("return", this.initFromValues(fromValuesClientOptions, identifiers, customAttributesFromResult, experimentValues));
                            case 21:
                            case "end":
                                return _context8.stop();
                        }
                    }, _callee8, this, [
                        [
                            1,
                            13
                        ]
                    ]);
                }));
                function init(_x16, _x17, _x18) {
                    return _init.apply(this, arguments);
                }
                return init;
            }()
        },
        {
            key: "initWithProvider",
            value: function() {
                var _initWithProvider = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee9(baseClientOptions, provider, identifiers, customAttributes) {
                    var fromValuesClientOptions, experimentValues, customAttributesFromResult, clientSdkKeyPromise, experimentValuesPromise, _yield$Promise$all3, _yield$Promise$all4, experimentValuesResult;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee9$(_context9) {
                        while(true)switch(_context9.prev = _context9.next){
                            case 0:
                                fromValuesClientOptions = $205be5d487f24bd6$var$_objectSpread($205be5d487f24bd6$var$_objectSpread({}, baseClientOptions), {}, {
                                    disableCurrentPageLogging: true
                                });
                                _context9.prev = 1;
                                _context9.next = 4;
                                return provider.setProfile(baseClientOptions, identifiers, customAttributes);
                            case 4:
                                // If client sdk key fetch fails, an error would be thrown and handled instead of waiting for
                                // the experiment values request to be settled, and it will fall back to use default values.
                                clientSdkKeyPromise = provider.getClientSdkKey().then(function(value) {
                                    return fromValuesClientOptions.sdkKey = value;
                                });
                                experimentValuesPromise = provider.getExperimentValues(); // Only wait for the experiment values request to finish and try to initialise the client
                                // with experiment values if both requests are successful. Else an error would be thrown and
                                // handled by the catch
                                _context9.next = 8;
                                return Promise.all([
                                    clientSdkKeyPromise,
                                    experimentValuesPromise
                                ]);
                            case 8:
                                _yield$Promise$all3 = _context9.sent;
                                _yield$Promise$all4 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_yield$Promise$all3, 2);
                                experimentValuesResult = _yield$Promise$all4[1];
                                experimentValues = experimentValuesResult.experimentValues;
                                customAttributesFromResult = experimentValuesResult.customAttributesFromFetch;
                                _context9.next = 22;
                                break;
                            case 15:
                                _context9.prev = 15;
                                _context9.t0 = _context9["catch"](1);
                                if (_context9.t0 instanceof Error) // eslint-disable-next-line no-console
                                console.error("Error occurred when trying to fetch the Feature Gates client values, error: ".concat(_context9.t0 === null || _context9.t0 === void 0 ? void 0 : _context9.t0.message));
                                // eslint-disable-next-line no-console
                                console.warn("Initialising Statsig client without values");
                                _context9.next = 21;
                                return this.initFromValues(fromValuesClientOptions, identifiers, customAttributes);
                            case 21:
                                throw _context9.t0;
                            case 22:
                                return _context9.abrupt("return", this.initFromValues(fromValuesClientOptions, identifiers, customAttributesFromResult, experimentValues));
                            case 23:
                            case "end":
                                return _context9.stop();
                        }
                    }, _callee9, this, [
                        [
                            1,
                            15
                        ]
                    ]);
                }));
                function initWithProvider(_x19, _x20, _x21, _x22) {
                    return _initWithProvider.apply(this, arguments);
                }
                return initWithProvider;
            }()
        },
        {
            key: "initFromValues",
            value: function() {
                var _initFromValues = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee0(clientOptions, identifiers, customAttributes) {
                    var _newClientOptions$net;
                    var initializeValues, newClientOptions, sdkKey, environment, _updateUserCompletionCallback, _perimeter, restClientOptions, statsigOptions, _args0 = arguments;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee0$(_context0) {
                        while(true)switch(_context0.prev = _context0.next){
                            case 0:
                                initializeValues = _args0.length > 3 && _args0[3] !== undefined ? _args0[3] : {};
                                this.overrideAdapter.initFromStoredOverrides();
                                this.currentIdentifiers = identifiers;
                                this.currentAttributes = customAttributes;
                                newClientOptions = (0, $8y781.migrateInitializationOptions)(clientOptions);
                                if (!newClientOptions.sdkKey) newClientOptions.sdkKey = $205be5d487f24bd6$var$DEFAULT_CLIENT_KEY;
                                if (!((_newClientOptions$net = newClientOptions.networkConfig) !== null && _newClientOptions$net !== void 0 && _newClientOptions$net.logEventUrl)) newClientOptions.networkConfig = $205be5d487f24bd6$var$_objectSpread($205be5d487f24bd6$var$_objectSpread({}, newClientOptions.networkConfig), {}, {
                                    logEventUrl: $205be5d487f24bd6$var$DEFAULT_EVENT_LOGGING_API
                                });
                                if (newClientOptions.perimeter === (0, $lK9nx.PerimeterType).FEDRAMP_MODERATE) // disable all logging in FedRAMP to prevent egress of sensitive data
                                newClientOptions.disableLogging = true;
                                sdkKey = newClientOptions.sdkKey, environment = newClientOptions.environment, _updateUserCompletionCallback = newClientOptions.updateUserCompletionCallback, _perimeter = newClientOptions.perimeter, restClientOptions = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(newClientOptions, $205be5d487f24bd6$var$_excluded);
                                this.user = (0, $8y781.toStatsigUser)(identifiers, customAttributes);
                                statsigOptions = $205be5d487f24bd6$var$_objectSpread($205be5d487f24bd6$var$_objectSpread({}, restClientOptions), {}, {
                                    environment: {
                                        tier: environment
                                    },
                                    includeCurrentPageUrlWithEvents: false,
                                    dataAdapter: this.dataAdapter,
                                    overrideAdapter: this.overrideAdapter,
                                    logEventCompressionMode: (0, $iFR7a.LogEventCompressionMode).Forced
                                }); // Statsig validates the provided stableId against their own cookie, so we either need
                                // to update the cookie to match, or disable the validation completely.
                                if (identifiers.stableId) (0, $iFR7a.StableID).setOverride(identifiers.stableId, sdkKey);
                                else statsigOptions.disableStableID = true;
                                _context0.prev = 12;
                                this.statsigClient = new (0, $iFR7a.StatsigClient)(sdkKey, this.user, statsigOptions);
                                this.dataAdapter.setBootstrapData(initializeValues);
                                _context0.next = 17;
                                return this.statsigClient.initializeAsync();
                            case 17:
                                _context0.next = 29;
                                break;
                            case 19:
                                _context0.prev = 19;
                                _context0.t0 = _context0["catch"](12);
                                if (_context0.t0 instanceof Error) // eslint-disable-next-line no-console
                                console.error("Error occurred when trying to initialise the Statsig client, error: ".concat(_context0.t0 === null || _context0.t0 === void 0 ? void 0 : _context0.t0.message));
                                // eslint-disable-next-line no-console
                                console.warn("Initialising Statsig client with default sdk key and without values");
                                this.statsigClient = new (0, $iFR7a.StatsigClient)($205be5d487f24bd6$var$DEFAULT_CLIENT_KEY, this.user, statsigOptions);
                                this.dataAdapter.setBootstrapData();
                                _context0.next = 27;
                                return this.statsigClient.initializeAsync();
                            case 27:
                                this.initWithDefaults = true;
                                throw _context0.t0;
                            case 29:
                            case "end":
                                return _context0.stop();
                        }
                    }, _callee0, this, [
                        [
                            12,
                            19
                        ]
                    ]);
                }));
                function initFromValues(_x23, _x24, _x25) {
                    return _initFromValues.apply(this, arguments);
                }
                return initFromValues;
            }()
        },
        {
            key: "updateUserUsingInitializeValuesProducer",
            value: function() {
                var _updateUserUsingInitializeValuesProducer = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee10(getInitializeValues, identifiers, customAttributes) {
                    var _this9 = this;
                    var originalInitPromise, initializeValuesPromise, updateUserPromise;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee10$(_context10) {
                        while(true)switch(_context10.prev = _context10.next){
                            case 0:
                                this.assertInitialized(this.statsigClient);
                                if (this.initPromise) {
                                    _context10.next = 3;
                                    break;
                                }
                                throw new Error('The client must be initialized before you can update the user.');
                            case 3:
                                if (!this.isCurrentUser(identifiers, customAttributes)) {
                                    _context10.next = 5;
                                    break;
                                }
                                return _context10.abrupt("return", this.initPromise);
                            case 5:
                                // Wait for the current initialize/update to finish
                                originalInitPromise = this.initPromise;
                                _context10.prev = 6;
                                _context10.next = 9;
                                return this.initPromise;
                            case 9:
                                _context10.next = 13;
                                break;
                            case 11:
                                _context10.prev = 11;
                                _context10.t0 = _context10["catch"](6);
                            case 13:
                                initializeValuesPromise = getInitializeValues();
                                updateUserPromise = this.updateStatsigClientUser(initializeValuesPromise, identifiers, customAttributes); // We replace the init promise here since we are essentially re-initializing the client at this
                                // point. Any subsequent calls to await client.initialize() or client.updateUser()
                                // will now also await this user update.
                                this.initPromise = updateUserPromise.catch(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee1() {
                                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee1$(_context1) {
                                        while(true)switch(_context1.prev = _context1.next){
                                            case 0:
                                                // If the update failed then it changed nothing, so revert back to the original promise.
                                                _this9.initPromise = originalInitPromise;
                                                // Set the user profile again to revert back to the current user
                                                if (!_this9.provider) {
                                                    _context1.next = 4;
                                                    break;
                                                }
                                                _context1.next = 4;
                                                return _this9.provider.setProfile(_this9.initOptions, _this9.currentIdentifiers, _this9.currentAttributes);
                                            case 4:
                                            case "end":
                                                return _context1.stop();
                                        }
                                    }, _callee1);
                                })));
                                return _context10.abrupt("return", updateUserPromise);
                            case 17:
                            case "end":
                                return _context10.stop();
                        }
                    }, _callee10, this, [
                        [
                            6,
                            11
                        ]
                    ]);
                }));
                function updateUserUsingInitializeValuesProducer(_x26, _x27, _x28) {
                    return _updateUserUsingInitializeValuesProducer.apply(this, arguments);
                }
                return updateUserUsingInitializeValuesProducer;
            }()
        },
        {
            key: "updateStatsigClientUser",
            value: function() {
                var _updateStatsigClientUser = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee11(initializeValuesPromise, identifiers, customAttributes) {
                    var _this$initOptions, _this$initOptions$upd;
                    var initializeValues, user, _updateUserCompletion, _ref4, errMsg, success, errorMessage;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee11$(_context11) {
                        while(true)switch(_context11.prev = _context11.next){
                            case 0:
                                this.assertInitialized(this.statsigClient);
                                _context11.prev = 1;
                                _context11.next = 4;
                                return initializeValuesPromise;
                            case 4:
                                initializeValues = _context11.sent;
                                user = (0, $8y781.toStatsigUser)(identifiers, initializeValues.customAttributesFromFetch);
                                _context11.next = 13;
                                break;
                            case 8:
                                _context11.prev = 8;
                                _context11.t0 = _context11["catch"](1);
                                // Make sure the updateUserCompletionCallback is called for any errors in our custom code.
                                // This is not necessary for the updateUserWithValues call, because the Statsig client will
                                // already invoke the callback itself.
                                errMsg = _context11.t0 instanceof Error ? _context11.t0.message : JSON.stringify(_context11.t0);
                                (_updateUserCompletion = (_ref4 = this.initOptions).updateUserCompletionCallback) === null || _updateUserCompletion === void 0 || _updateUserCompletion.call(_ref4, false, errMsg);
                                throw _context11.t0;
                            case 13:
                                success = true;
                                errorMessage = null;
                                _context11.prev = 15;
                                this.dataAdapter.setBootstrapData(initializeValues.experimentValues);
                                this.user = user;
                                if (!this.user) {
                                    _context11.next = 21;
                                    break;
                                }
                                _context11.next = 21;
                                return this.statsigClient.updateUserAsync(this.user);
                            case 21:
                                _context11.next = 27;
                                break;
                            case 23:
                                _context11.prev = 23;
                                _context11.t1 = _context11["catch"](15);
                                success = false;
                                errorMessage = String(_context11.t1);
                            case 27:
                                (_this$initOptions = this.initOptions) === null || _this$initOptions === void 0 || (_this$initOptions$upd = _this$initOptions.updateUserCompletionCallback) === null || _this$initOptions$upd === void 0 || _this$initOptions$upd.call(_this$initOptions, success, errorMessage);
                                if (!success) {
                                    _context11.next = 34;
                                    break;
                                }
                                this.currentIdentifiers = identifiers;
                                this.currentAttributes = customAttributes;
                                this.subscriptions.anyUpdated();
                                _context11.next = 35;
                                break;
                            case 34:
                                throw new Error('Failed to update user. An unexpected error occured.');
                            case 35:
                            case "end":
                                return _context11.stop();
                        }
                    }, _callee11, this, [
                        [
                            1,
                            8
                        ],
                        [
                            15,
                            23
                        ]
                    ]);
                }));
                function updateStatsigClientUser(_x29, _x30, _x31) {
                    return _updateStatsigClientUser.apply(this, arguments);
                }
                return updateStatsigClientUser;
            }()
        },
        {
            key: "getPackageVersion",
            value: /**
     * @returns string version of the current package in semver style.
     */ function getPackageVersion() {
                return 0, $1OJWH.CLIENT_VERSION;
            }
        },
        {
            key: "getLayer",
            value: function getLayer(/** The name of the layer */ layerName) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                try {
                    this.assertInitialized(this.statsigClient);
                    var _options$fireLayerExp = options.fireLayerExposure, fireLayerExposure = _options$fireLayerExp === void 0 ? true : _options$fireLayerExp;
                    return (0, $fhNL7.Layer).fromLayer(this.statsigClient.getLayer(layerName, {
                        disableExposureLog: !fireLayerExposure
                    }));
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!this.hasGetLayerErrorOccurred) {
                        // eslint-disable-next-line no-console
                        console.warn({
                            msg: 'An error has occurred getting the layer. Only the first occurrence of this error is logged.',
                            layerName: layerName,
                            error: error
                        });
                        this.hasGetLayerErrorOccurred = true;
                    }
                    // Return a default value
                    return (0, $fhNL7.Layer).fromLayer((0, $iFR7a._makeLayer)(layerName, {
                        reason: 'Error'
                    }, null));
                }
            }
        },
        {
            key: "getLayerValue",
            value: function getLayerValue(layerName, parameterName, defaultValue) {
                var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var layer = this.getLayer(layerName, options);
                try {
                    var typeGuard = options.typeGuard;
                    return layer.get(parameterName, defaultValue, typeGuard);
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!this.hasGetLayerValueErrorOccurred) {
                        // eslint-disable-next-line no-console
                        console.warn({
                            msg: 'An error has occurred getting the layer value. Only the first occurrence of this error is logged.',
                            layerName: layerName,
                            defaultValue: defaultValue,
                            options: options,
                            error: error
                        });
                        this.hasGetLayerValueErrorOccurred = true;
                    }
                    return defaultValue;
                }
            }
        }
    ]);
}();

});
parcelRegister("a2rTA", function(module, exports) {
$parcel$export(module.exports, "default", () => $74efbac534cea6a3$export$2e2bcd8739ae039);

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $25nEq = parcelRequire("25nEq");

var $hLfKH = parcelRequire("hLfKH");
function $74efbac534cea6a3$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $74efbac534cea6a3$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $74efbac534cea6a3$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $74efbac534cea6a3$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $74efbac534cea6a3$export$a66cbd9b2289cd78 = '@all-features';
var $74efbac534cea6a3$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function Subscriptions() {
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, Subscriptions);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "eventToValue", new Map());
        this.emitter = new (0, (/*@__PURE__*/$parcel$interopDefault($hLfKH)))();
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(Subscriptions, [
        {
            key: "onGateUpdated",
            value: function onGateUpdated(gateName, callback, checkGate, options) {
                var _this = this;
                var value = checkGate(gateName, $74efbac534cea6a3$var$_objectSpread($74efbac534cea6a3$var$_objectSpread({}, options), {}, {
                    fireGateExposure: false
                }));
                if (this.eventToValue.get(callback) === undefined) this.eventToValue.set(callback, value);
                var wrapCallback = function wrapCallback() {
                    var value = checkGate(gateName, $74efbac534cea6a3$var$_objectSpread($74efbac534cea6a3$var$_objectSpread({}, options), {}, {
                        fireGateExposure: false
                    }));
                    var existingValue = _this.eventToValue.get(callback);
                    if (existingValue !== value) {
                        _this.eventToValue.set(callback, value);
                        callback(value);
                    }
                };
                this.emitter.on(gateName, wrapCallback);
                return function() {
                    _this.emitter.off(gateName, wrapCallback);
                };
            }
        },
        {
            key: "onExperimentValueUpdated",
            value: function onExperimentValueUpdated(experimentName, parameterName, defaultValue, callback, getExperimentValue, options) {
                var _this2 = this;
                var experimentEventName = "".concat(experimentName, ".").concat(parameterName);
                var value = getExperimentValue(experimentName, parameterName, defaultValue, $74efbac534cea6a3$var$_objectSpread($74efbac534cea6a3$var$_objectSpread({}, options), {}, {
                    fireExperimentExposure: false
                }));
                if (this.eventToValue.get(callback) === undefined) this.eventToValue.set(callback, value);
                var wrapCallback = function wrapCallback() {
                    var value = getExperimentValue(experimentName, parameterName, defaultValue, $74efbac534cea6a3$var$_objectSpread($74efbac534cea6a3$var$_objectSpread({}, options), {}, {
                        fireExperimentExposure: false
                    }));
                    var existingValue = _this2.eventToValue.get(callback);
                    if (existingValue !== value) {
                        _this2.eventToValue.set(callback, value);
                        callback(value);
                    }
                };
                this.emitter.on(experimentEventName, wrapCallback);
                return function() {
                    _this2.emitter.off(experimentEventName, wrapCallback);
                };
            }
        },
        {
            key: "onAnyUpdated",
            value: function onAnyUpdated(callback) {
                var _this3 = this;
                this.emitter.on($74efbac534cea6a3$export$a66cbd9b2289cd78, callback);
                return function() {
                    _this3.emitter.off($74efbac534cea6a3$export$a66cbd9b2289cd78, callback);
                };
            }
        },
        {
            key: "anyUpdated",
            value: function anyUpdated() {
                var _this4 = this;
                this.emitter.emit($74efbac534cea6a3$export$a66cbd9b2289cd78);
                this.emitter.eventNames().filter(function(name) {
                    return name !== $74efbac534cea6a3$export$a66cbd9b2289cd78;
                }).forEach(function(event) {
                    _this4.emitter.emit(event);
                });
            }
        }
    ]);
}();

});

parcelRegister("2JDKH", function(module, exports) {
$parcel$export(module.exports, "DynamicConfig", () => $1fde9eb8de6d86b1$export$6dc24881a3d96325);

var $ekGgq = parcelRequire("ekGgq");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $8y781 = parcelRequire("8y781");
var $1fde9eb8de6d86b1$export$6dc24881a3d96325 = /*#__PURE__*/ function() {
    function DynamicConfig(configName, configValue, ruleID, evaluationDetails) {
        var secondaryExposures = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : [];
        var allocatedExperimentName = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : '';
        var onDefaultValueFallback = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : null;
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, DynamicConfig);
        this.value = configValue;
        this._name = configName;
        this._ruleID = ruleID;
        this._secondaryExposures = secondaryExposures;
        this._allocatedExperimentName = allocatedExperimentName;
        this._evaluationDetails = evaluationDetails;
        this._onDefaultValueFallback = onDefaultValueFallback;
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(DynamicConfig, [
        {
            key: "get",
            value: function get(key, defaultValue, typeGuard) {
                var _this$_onDefaultValue2;
                var val = this.getValue(key, defaultValue);
                if (val == null) return defaultValue;
                var expectedType = Array.isArray(defaultValue) ? 'array' : (0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(defaultValue);
                var actualType = Array.isArray(val) ? 'array' : (0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(val);
                if (typeGuard) {
                    var _this$_onDefaultValue;
                    if (typeGuard(val)) {
                        this.fireExposure(key);
                        return val;
                    }
                    (_this$_onDefaultValue = this._onDefaultValueFallback) === null || _this$_onDefaultValue === void 0 || _this$_onDefaultValue.call(this, this, key, expectedType, actualType);
                    return defaultValue;
                }
                if (defaultValue == null || expectedType === actualType) {
                    this.fireExposure(key);
                    return val;
                }
                (_this$_onDefaultValue2 = this._onDefaultValueFallback) === null || _this$_onDefaultValue2 === void 0 || _this$_onDefaultValue2.call(this, this, key, expectedType, actualType);
                return defaultValue;
            }
        },
        {
            key: "getValue",
            value: function getValue(key, defaultValue) {
                if (key == null) return this.value;
                if (defaultValue == null) defaultValue = null;
                if (this.value[key] == null) return defaultValue;
                this.fireExposure(key);
                return this.value[key];
            }
        },
        {
            key: "fireExposure",
            value: function fireExposure(key) {
                // Call the wrapped experiment's get method to fire exposure
                if (this.experiment) this.experiment.get(key);
            }
        }
    ], [
        {
            key: "fromExperiment",
            value: function fromExperiment(experiment) {
                var _experiment$__evaluat, _experiment$__evaluat2, _experiment$groupName;
                var config = new DynamicConfig(experiment.name, experiment.value, experiment.ruleID, (0, $8y781.migrateEvaluationDetails)(experiment.details), (0, $8y781.migrateSecondaryExposures)((_experiment$__evaluat = (_experiment$__evaluat2 = experiment.__evaluation) === null || _experiment$__evaluat2 === void 0 ? void 0 : _experiment$__evaluat2.secondary_exposures) !== null && _experiment$__evaluat !== void 0 ? _experiment$__evaluat : []), (_experiment$groupName = experiment.groupName) !== null && _experiment$groupName !== void 0 ? _experiment$groupName : undefined);
                config.experiment = experiment;
                return config;
            }
        }
    ]);
}();

});
parcelRegister("8y781", function(module, exports) {
$parcel$export(module.exports, "getOptionsWithDefaults", () => $63970741f2c34e88$export$d119b37e5f788b43);
$parcel$export(module.exports, "shallowEquals", () => $63970741f2c34e88$export$fa1c2bbf4100b8bc);
$parcel$export(module.exports, "toStatsigUser", () => $63970741f2c34e88$export$3dad1db244472f32);
$parcel$export(module.exports, "migrateInitializationOptions", () => $63970741f2c34e88$export$202946b690d26d22);
$parcel$export(module.exports, "migrateEvaluationDetails", () => $63970741f2c34e88$export$18ad168d3dbac899);
$parcel$export(module.exports, "migrateSecondaryExposures", () => $63970741f2c34e88$export$55fd683752d01e67);

var $1Vcia = parcelRequire("1Vcia");

var $iYJcE = parcelRequire("iYJcE");

var $25nEq = parcelRequire("25nEq");

var $ygbGG = parcelRequire("ygbGG");

var $cjLbo = parcelRequire("cjLbo");

var $lK9nx = parcelRequire("lK9nx");
var $63970741f2c34e88$var$_excluded = [
    "api",
    "disableCurrentPageLogging",
    "loggingIntervalMillis",
    "loggingBufferMaxSize",
    "localMode",
    "eventLoggingApi",
    "eventLoggingApiForRetries",
    "disableLocalStorage",
    "ignoreWindowUndefined",
    "disableAllLogging",
    "initTimeoutMs",
    "disableNetworkKeepalive",
    "overrideStableID",
    "disableErrorLogging",
    "disableAutoMetricsLogging"
];
function $63970741f2c34e88$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $63970741f2c34e88$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $63970741f2c34e88$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $63970741f2c34e88$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $63970741f2c34e88$export$d119b37e5f788b43 = function getOptionsWithDefaults(options) {
    return $63970741f2c34e88$var$_objectSpread({
        /**
     * If more federal PerimeterTypes are added in the future, this should be updated so
     * that isFedRamp() === true always returns the strictest perimeter.
     */ perimeter: (0, $ygbGG.isFedRamp)() ? (0, $lK9nx.PerimeterType).FEDRAMP_MODERATE : (0, $lK9nx.PerimeterType).COMMERCIAL
    }, options);
};
var $63970741f2c34e88$export$fa1c2bbf4100b8bc = function shallowEquals(objectA, objectB) {
    if (!objectA && !objectB) return true;
    if (!objectA || !objectB) return false;
    var aEntries = Object.entries(objectA);
    var bEntries = Object.entries(objectB);
    if (aEntries.length !== bEntries.length) return false;
    var ascendingKeyOrder = function ascendingKeyOrder(_ref, _ref2) {
        var _ref3 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_ref, 1), key1 = _ref3[0];
        var _ref4 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_ref2, 1), key2 = _ref4[0];
        return key1.localeCompare(key2);
    };
    aEntries.sort(ascendingKeyOrder);
    bEntries.sort(ascendingKeyOrder);
    for(var i = 0; i < aEntries.length; i++){
        var _aEntries$i = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(aEntries[i], 2), aValue = _aEntries$i[1];
        var _bEntries$i = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(bEntries[i], 2), bValue = _bEntries$i[1];
        if (aValue !== bValue) return false;
    }
    return true;
};
var $63970741f2c34e88$export$3dad1db244472f32 = function toStatsigUser(identifiers, customAttributes) {
    var user = {
        customIDs: identifiers,
        custom: customAttributes
    };
    if (identifiers.atlassianAccountId) user.userID = identifiers.atlassianAccountId;
    return user;
};
var $63970741f2c34e88$export$202946b690d26d22 = function migrateInitializationOptions(options) {
    var api = options.api, disableCurrentPageLogging = options.disableCurrentPageLogging, loggingIntervalMillis = options.loggingIntervalMillis, loggingBufferMaxSize = options.loggingBufferMaxSize, localMode = options.localMode, eventLoggingApi = options.eventLoggingApi, eventLoggingApiForRetries = options.eventLoggingApiForRetries, disableLocalStorage = options.disableLocalStorage, ignoreWindowUndefined = options.ignoreWindowUndefined, disableAllLogging = options.disableAllLogging, _initTimeoutMs = options.initTimeoutMs, _disableNetworkKeepalive = options.disableNetworkKeepalive, _overrideStableID = options.overrideStableID, _disableErrorLogging = options.disableErrorLogging, _disableAutoMetricsLogging = options.disableAutoMetricsLogging, rest = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(options, $63970741f2c34e88$var$_excluded);
    return $63970741f2c34e88$var$_objectSpread($63970741f2c34e88$var$_objectSpread({}, rest), {}, {
        networkConfig: {
            api: api,
            logEventUrl: eventLoggingApi ? eventLoggingApi + 'rgstr' : undefined,
            logEventFallbackUrls: eventLoggingApiForRetries ? [
                eventLoggingApiForRetries
            ] : undefined,
            preventAllNetworkTraffic: localMode || !ignoreWindowUndefined && typeof window === 'undefined'
        },
        includeCurrentPageUrlWithEvents: !disableCurrentPageLogging,
        loggingIntervalMs: loggingIntervalMillis,
        loggingBufferMaxSize: loggingBufferMaxSize,
        disableStorage: disableLocalStorage === undefined ? localMode : disableLocalStorage,
        disableLogging: disableAllLogging === undefined ? localMode : disableAllLogging
    });
};
var $63970741f2c34e88$var$evaluationReasonMappings = Object.entries((0, $cjLbo.EvaluationReason)).map(function(_ref5) {
    var _ref6 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_ref5, 2), key = _ref6[0], value = _ref6[1];
    return [
        key.toLowerCase(),
        value
    ];
});
var $63970741f2c34e88$export$18ad168d3dbac899 = function migrateEvaluationDetails(details) {
    var _evaluationReasonMapp, _evaluationReasonMapp2, _details$receivedAt;
    var reasonLower = details.reason.toLowerCase();
    return {
        reason: (_evaluationReasonMapp = (_evaluationReasonMapp2 = $63970741f2c34e88$var$evaluationReasonMappings.find(function(_ref7) {
            var _ref8 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_ref7, 1), key = _ref8[0];
            return reasonLower.includes(key);
        })) === null || _evaluationReasonMapp2 === void 0 ? void 0 : _evaluationReasonMapp2[1]) !== null && _evaluationReasonMapp !== void 0 ? _evaluationReasonMapp : (0, $cjLbo.EvaluationReason).Unknown,
        time: (_details$receivedAt = details.receivedAt) !== null && _details$receivedAt !== void 0 ? _details$receivedAt : Date.now()
    };
};
var $63970741f2c34e88$export$55fd683752d01e67 = function migrateSecondaryExposures(secondaryExposures) {
    return secondaryExposures.map(function(exposure) {
        if (typeof exposure === 'string') // This should ideally have gateValue and ruleID fields too, but it's not possible for us
        // to determine the correct values for these.
        return {
            gate: exposure
        };
        return exposure;
    });
};

});
parcelRegister("cjLbo", function(module, exports) {
$parcel$export(module.exports, "EvaluationReason", () => $8f7bdbe08f33fd67$export$c62558b199e46828);
// Reference: https://github.com/statsig-io/js-lite/blob/main/src/StatsigStore.ts
var $8f7bdbe08f33fd67$export$c62558b199e46828 = /*#__PURE__*/ function(EvaluationReason) {
    // Order is important since the logic for migrating from a new client reason to an old one
    // returns the first which is a substring of the new client reason
    EvaluationReason["Error"] = "Error";
    EvaluationReason["LocalOverride"] = "LocalOverride";
    EvaluationReason["Unrecognized"] = "Unrecognized";
    EvaluationReason["Uninitialized"] = "Uninitialized";
    EvaluationReason["NetworkNotModified"] = "NetworkNotModified";
    EvaluationReason["Network"] = "Network";
    EvaluationReason["InvalidBootstrap"] = "InvalidBootstrap";
    EvaluationReason["Bootstrap"] = "Bootstrap";
    EvaluationReason["Cache"] = "Cache";
    // For when we could not migrate the reason from the new client
    EvaluationReason["Unknown"] = "Unknown";
    return EvaluationReason;
}({}); // Reference: https://github.com/statsig-io/js-lite/blob/main/src/StatsigSDKOptions.ts

});

parcelRegister("lK9nx", function(module, exports) {
$parcel$export(module.exports, "FeatureGateEnvironment", () => $fd452b4241b633bb$export$479e7351a733299);
$parcel$export(module.exports, "PerimeterType", () => $fd452b4241b633bb$export$c42b7bbc5e7ba555);
/**
 * The identifiers for the user. Options are restricted to the set that is currently supported.
 */ /**
 * Base client options. Does not include any options specific to providers
 * @interface BaseClientOptions
 * @property {FeatureGateEnvironment} environment - The environment for the client.
 * @property {string} targetApp - The target app for the client.
 * @property {AnalyticsWebClient} analyticsWebClient - The analytics web client.
 * @property {PerimeterType} perimeter - The perimeter for the client.
 */ /**
 * The options for the client.
 * @interface ClientOptions
 * @extends {BaseClientOptions}
 * @property {string} apiKey - The API key for the client.
 * @property {fetchTimeoutMs} fetchTimeoutMs - The timeout for the fetch request in milliseconds. Defaults to 5000.
 * @property {boolean} useGatewayURL - Whether to use the gateway URL. Defaults to false.
 */ /**
 * The custom attributes for the user.
 */ var $fd452b4241b633bb$export$479e7351a733299 = /*#__PURE__*/ function(FeatureGateEnvironment) {
    FeatureGateEnvironment["Development"] = "development";
    FeatureGateEnvironment["Staging"] = "staging";
    FeatureGateEnvironment["Production"] = "production";
    return FeatureGateEnvironment;
}({});
var $fd452b4241b633bb$export$c42b7bbc5e7ba555 = /*#__PURE__*/ function(PerimeterType) {
    PerimeterType["COMMERCIAL"] = "commercial";
    PerimeterType["FEDRAMP_MODERATE"] = "fedramp-moderate";
    return PerimeterType;
}({});
var $fd452b4241b633bb$export$42f4885608027d0c = 'non_boolean'; // Type magic to get the JSDoc comments from the Client class methods to appear on the static
 // methods in FeatureGates where the property name and function type are identical

});



parcelRegister("fhNL7", function(module, exports) {
$parcel$export(module.exports, "Layer", () => $b20f0aa00048af96$export$936d0764594b6eb3);

var $ekGgq = parcelRequire("ekGgq");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $8y781 = parcelRequire("8y781");
var $b20f0aa00048af96$export$936d0764594b6eb3 = /*#__PURE__*/ function() {
    function Layer(name, layerValue, ruleID, evaluationDetails) {
        var logParameterFunction = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
        var secondaryExposures = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : [];
        var undelegatedSecondaryExposures = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : [];
        var allocatedExperimentName = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : '';
        var explicitParameters = arguments.length > 8 && arguments[8] !== undefined ? arguments[8] : [];
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, Layer);
        this._logParameterFunction = logParameterFunction;
        this._name = name;
        this._value = JSON.parse(JSON.stringify(layerValue !== null && layerValue !== void 0 ? layerValue : {}));
        this._ruleID = ruleID !== null && ruleID !== void 0 ? ruleID : '';
        this._evaluationDetails = evaluationDetails;
        this._secondaryExposures = secondaryExposures;
        this._undelegatedSecondaryExposures = undelegatedSecondaryExposures;
        this._allocatedExperimentName = allocatedExperimentName;
        this._explicitParameters = explicitParameters;
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(Layer, [
        {
            key: "get",
            value: function get(key, defaultValue, typeGuard) {
                var _this = this;
                var val = this._value[key];
                if (val == null) return defaultValue;
                var logAndReturn = function logAndReturn() {
                    _this._logLayerParameterExposure(key);
                    return val;
                };
                if (typeGuard) return typeGuard(val) ? logAndReturn() : defaultValue;
                if (defaultValue == null) return logAndReturn();
                if ((0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(val) === (0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(defaultValue) && Array.isArray(defaultValue) === Array.isArray(val)) return logAndReturn();
                return defaultValue;
            }
        },
        {
            key: "getValue",
            value: function getValue(key, defaultValue) {
                // eslint-disable-next-line eqeqeq
                if (defaultValue == undefined) defaultValue = null;
                var val = this._value[key];
                if (val != null) this._logLayerParameterExposure(key);
                return val !== null && val !== void 0 ? val : defaultValue;
            }
        },
        {
            key: "_logLayerParameterExposure",
            value: function _logLayerParameterExposure(parameterName) {
                var _this$_logParameterFu;
                (_this$_logParameterFu = this._logParameterFunction) === null || _this$_logParameterFu === void 0 || _this$_logParameterFu.call(this, this, parameterName);
            }
        }
    ], [
        {
            key: "fromLayer",
            value: function fromLayer(layer) {
                var _layer$__evaluation$s, _layer$__evaluation, _layer$__evaluation$u, _layer$__evaluation2, _layer$__evaluation3, _layer$__evaluation4;
                var value = new Layer(layer.name, layer.__value, layer.ruleID, (0, $8y781.migrateEvaluationDetails)(layer.details), function(_layer, parameterName) {
                    return layer.get(parameterName);
                }, (0, $8y781.migrateSecondaryExposures)((_layer$__evaluation$s = (_layer$__evaluation = layer.__evaluation) === null || _layer$__evaluation === void 0 ? void 0 : _layer$__evaluation.secondary_exposures) !== null && _layer$__evaluation$s !== void 0 ? _layer$__evaluation$s : []), (0, $8y781.migrateSecondaryExposures)((_layer$__evaluation$u = (_layer$__evaluation2 = layer.__evaluation) === null || _layer$__evaluation2 === void 0 ? void 0 : _layer$__evaluation2.undelegated_secondary_exposures) !== null && _layer$__evaluation$u !== void 0 ? _layer$__evaluation$u : []), (_layer$__evaluation3 = layer.__evaluation) === null || _layer$__evaluation3 === void 0 ? void 0 : _layer$__evaluation3.allocated_experiment_name, (_layer$__evaluation4 = layer.__evaluation) === null || _layer$__evaluation4 === void 0 ? void 0 : _layer$__evaluation4.explicit_parameters);
                return value;
            }
        }
    ]);
}();

});

parcelRegister("hTYAN", function(module, exports) {
$parcel$export(module.exports, "default", () => $d0869323f9026a2d$export$2e2bcd8739ae039);

var $25nEq = parcelRequire("25nEq");

var $fL8KA = parcelRequire("fL8KA");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $6HG4S = parcelRequire("6HG4S");

var $lK9nx = parcelRequire("lK9nx");

var $1OJWH = parcelRequire("1OJWH");

var $daAXo = parcelRequire("daAXo");
function $d0869323f9026a2d$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $d0869323f9026a2d$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $d0869323f9026a2d$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $d0869323f9026a2d$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $d0869323f9026a2d$var$DEFAULT_REQUEST_TIMEOUT_MS = 5000;
var $d0869323f9026a2d$export$250a58ecde616daa = 'https://api.atlassian.com/flags';
var $d0869323f9026a2d$export$942ba04389b0d5a2 = 'https://api.stg.atlassian.com/flags';
var $d0869323f9026a2d$export$f058dbf75c3bc647 = 'https://api.dev.atlassian.com/flags';
var $d0869323f9026a2d$export$1a401a0da8da3565 = 'https://api.stg.atlassian-us-gov-mod.com/flags';
var $d0869323f9026a2d$export$18c93900db9358a4 = 'https://api.atlassian-us-gov-mod.com/flags';
var $d0869323f9026a2d$export$4e8a0415edbfa1f7 = 'https://atlassian-statsig-proxy-archetype.atl-paas.%s.atl-ic.net';
var $d0869323f9026a2d$export$cb3cd156f70d7e94 = 'oasis-stg.com/flags';
var $d0869323f9026a2d$export$921fbc6cdfd4eee0 = 'atlassian-isolated.net/flags';
var $d0869323f9026a2d$export$450bd8fb2a6d7ace = '/gateway/api/flags';
var $d0869323f9026a2d$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function Fetcher() {
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, Fetcher);
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(Fetcher, null, [
        {
            key: "fetchClientSdk",
            value: function() {
                var _fetchClientSdk = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee(fetcherOptions) {
                    var targetApp, url;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee$(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                targetApp = fetcherOptions.targetApp;
                                url = "/api/v2/frontend/clientSdkKey/".concat(targetApp);
                                _context.prev = 2;
                                _context.next = 5;
                                return this.fetchRequest(url, 'GET', fetcherOptions);
                            case 5:
                                return _context.abrupt("return", _context.sent);
                            case 8:
                                _context.prev = 8;
                                _context.t0 = _context["catch"](2);
                                if (!(_context.t0 instanceof Error)) {
                                    _context.next = 12;
                                    break;
                                }
                                throw _context.t0;
                            case 12:
                                throw Error('Failed to retrieve client sdk key');
                            case 13:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee, this, [
                        [
                            2,
                            8
                        ]
                    ]);
                }));
                function fetchClientSdk(_x) {
                    return _fetchClientSdk.apply(this, arguments);
                }
                return fetchClientSdk;
            }()
        },
        {
            key: "fetchExperimentValues",
            value: function() {
                var _fetchExperimentValues = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee2(fetcherOptions, identifiers, customAttributes) {
                    var requestBody;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee2$(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                requestBody = {
                                    identifiers: identifiers,
                                    customAttributes: customAttributes,
                                    targetApp: fetcherOptions.targetApp
                                };
                                _context2.prev = 1;
                                _context2.next = 4;
                                return this.fetchRequest('/api/v2/frontend/experimentValues', 'POST', fetcherOptions, requestBody);
                            case 4:
                                return _context2.abrupt("return", _context2.sent);
                            case 7:
                                _context2.prev = 7;
                                _context2.t0 = _context2["catch"](1);
                                if (!(_context2.t0 instanceof Error)) {
                                    _context2.next = 11;
                                    break;
                                }
                                throw _context2.t0;
                            case 11:
                                throw Error('Failed to retrieve experiment values');
                            case 12:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2, this, [
                        [
                            1,
                            7
                        ]
                    ]);
                }));
                function fetchExperimentValues(_x2, _x3, _x4) {
                    return _fetchExperimentValues.apply(this, arguments);
                }
                return fetchExperimentValues;
            }()
        },
        {
            key: "handleResponseError",
            value: function() {
                var _handleResponseError = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee3(response) {
                    var body;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee3$(_context3) {
                        while(true)switch(_context3.prev = _context3.next){
                            case 0:
                                if (response.ok) {
                                    _context3.next = 5;
                                    break;
                                }
                                _context3.next = 3;
                                return response.text();
                            case 3:
                                body = _context3.sent;
                                throw new (0, $daAXo.ResponseError)("Non 2xx response status received, status: ".concat(response.status, ", body: ").concat(JSON.stringify(body)));
                            case 5:
                                if (!(response.status === 204)) {
                                    _context3.next = 7;
                                    break;
                                }
                                throw new (0, $daAXo.ResponseError)('Unexpected 204 response');
                            case 7:
                            case "end":
                                return _context3.stop();
                        }
                    }, _callee3);
                }));
                function handleResponseError(_x5) {
                    return _handleResponseError.apply(this, arguments);
                }
                return handleResponseError;
            }()
        },
        {
            key: "extractResponseBody",
            value: function() {
                var _extractResponseBody = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee4(response) {
                    var value;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee4$(_context4) {
                        while(true)switch(_context4.prev = _context4.next){
                            case 0:
                                _context4.next = 2;
                                return response.text();
                            case 2:
                                value = _context4.sent;
                                return _context4.abrupt("return", JSON.parse(value));
                            case 4:
                            case "end":
                                return _context4.stop();
                        }
                    }, _callee4);
                }));
                function extractResponseBody(_x6) {
                    return _extractResponseBody.apply(this, arguments);
                }
                return extractResponseBody;
            }()
        },
        {
            key: "getBaseUrl",
            value: function getBaseUrl(serviceEnv) {
                var useGatewayUrl = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
                var perimeter = arguments.length > 2 ? arguments[2] : undefined;
                var isolationContextId = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
                if (useGatewayUrl) return $d0869323f9026a2d$export$450bd8fb2a6d7ace;
                if (perimeter === (0, $lK9nx.PerimeterType).FEDRAMP_MODERATE) switch(serviceEnv){
                    case (0, $lK9nx.FeatureGateEnvironment).Production:
                        return $d0869323f9026a2d$export$18c93900db9358a4;
                    case (0, $lK9nx.FeatureGateEnvironment).Staging:
                        return $d0869323f9026a2d$export$1a401a0da8da3565;
                    default:
                        throw new Error("Invalid environment \"".concat(serviceEnv, "\" for \"").concat(perimeter, "\" perimeter"));
                }
                else if (perimeter === (0, $lK9nx.PerimeterType).COMMERCIAL) switch(serviceEnv){
                    case (0, $lK9nx.FeatureGateEnvironment).Development:
                        return $d0869323f9026a2d$export$f058dbf75c3bc647;
                    case (0, $lK9nx.FeatureGateEnvironment).Staging:
                        var apiUrl = this.getApiUrl(isolationContextId);
                        if (apiUrl !== null) return apiUrl;
                        return $d0869323f9026a2d$export$942ba04389b0d5a2;
                    default:
                        var prodApiUrl = this.getApiUrl(isolationContextId);
                        if (prodApiUrl !== null) return prodApiUrl;
                        return $d0869323f9026a2d$export$250a58ecde616daa;
                }
                else throw new Error("Invalid perimeter \"".concat(perimeter, "\""));
            }
        },
        {
            key: "fetchRequest",
            value: function() {
                var _fetchRequest = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee5(path, method, fetcherOptions, body) {
                    var baseUrl, fetchTimeout, abortSignal, abortController, response;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee5$(_context5) {
                        while(true)switch(_context5.prev = _context5.next){
                            case 0:
                                baseUrl = Fetcher.getBaseUrl(fetcherOptions.environment, fetcherOptions.useGatewayURL, fetcherOptions.perimeter, fetcherOptions.isolationContextId);
                                fetchTimeout = fetcherOptions.fetchTimeoutMs || $d0869323f9026a2d$var$DEFAULT_REQUEST_TIMEOUT_MS;
                                if (AbortSignal.timeout) abortSignal = AbortSignal.timeout(fetchTimeout);
                                else if (AbortController) {
                                    abortController = new AbortController();
                                    abortSignal = abortController.signal;
                                    setTimeout(function() {
                                        return abortController.abort();
                                    }, fetchTimeout);
                                }
                                _context5.next = 5;
                                return fetch("".concat(baseUrl).concat(path), $d0869323f9026a2d$var$_objectSpread({
                                    method: method,
                                    headers: {
                                        'Content-Type': 'application/json',
                                        'X-Client-Name': 'feature-gate-js-client',
                                        'X-Client-Version': (0, $1OJWH.CLIENT_VERSION),
                                        'X-API-KEY': fetcherOptions.apiKey
                                    },
                                    signal: abortSignal
                                }, body && {
                                    body: JSON.stringify(body)
                                }));
                            case 5:
                                response = _context5.sent;
                                _context5.next = 8;
                                return this.handleResponseError(response);
                            case 8:
                                _context5.next = 10;
                                return this.extractResponseBody(response);
                            case 10:
                                return _context5.abrupt("return", _context5.sent);
                            case 11:
                            case "end":
                                return _context5.stop();
                        }
                    }, _callee5, this);
                }));
                function fetchRequest(_x7, _x8, _x9, _x0) {
                    return _fetchRequest.apply(this, arguments);
                }
                return fetchRequest;
            }()
        },
        {
            key: "getApiUrl",
            value: function getApiUrl(isolationContextId) {
                var window1 = this.getWindowLocation();
                if (window1 === undefined) {
                    //this is needed when this SDK is used for SSR or plugin use cases where secret keys not available to use backend SDKs
                    if (!isolationContextId) return null;
                    return $d0869323f9026a2d$export$4e8a0415edbfa1f7.replace('%s', isolationContextId);
                }
                var protocol = window1.protocol, hostname = window1.hostname;
                // Match last subdomain fragment before oasis-stg.com
                var oasisMatch = hostname.match(/([^.]+)\.oasis-stg\.com$/);
                if (oasisMatch) return "".concat(protocol, "//api.").concat(oasisMatch[1], ".").concat($d0869323f9026a2d$export$cb3cd156f70d7e94);
                // Match last subdomain fragment before atlassian-isolated.net
                var isolatedMatch = hostname.match(/([^.]+)\.atlassian-isolated\.net$/);
                if (isolatedMatch) return "".concat(protocol, "//api.").concat(isolatedMatch[1], ".").concat($d0869323f9026a2d$export$921fbc6cdfd4eee0);
                return null;
            }
        },
        {
            key: "getWindowLocation",
            value: function getWindowLocation() {
                if (typeof window !== 'undefined' && window.location) return window.location;
                return undefined;
            }
        }
    ]);
}();

});
parcelRegister("1OJWH", function(module, exports) {
$parcel$export(module.exports, "CLIENT_VERSION", () => $152e19d0b9573482$export$a59f8d67326bd1cb);
/// <reference types="node" />
var $152e19d0b9573482$export$a59f8d67326bd1cb = "0.0.0-development";

});

parcelRegister("daAXo", function(module, exports) {
$parcel$export(module.exports, "ResponseError", () => $9968e069c694a701$export$286baf652d0b1206);

var $arMYe = parcelRequire("arMYe");

var $9P61R = parcelRequire("9P61R");

var $kIXpt = parcelRequire("kIXpt");

var $cYPzS = parcelRequire("cYPzS");

var $eyuDe = parcelRequire("eyuDe");

var $c7s0H = parcelRequire("c7s0H");
function $9968e069c694a701$var$_callSuper(t, o, e) {
    return o = (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(o), (0, (/*@__PURE__*/$parcel$interopDefault($kIXpt)))(t, $9968e069c694a701$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(t).constructor) : o.apply(t, e));
}
function $9968e069c694a701$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($9968e069c694a701$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $9968e069c694a701$export$286baf652d0b1206 = /*#__PURE__*/ function(_Error) {
    function ResponseError(message) {
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, ResponseError);
        return $9968e069c694a701$var$_callSuper(this, ResponseError, [
            message
        ]);
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($eyuDe)))(ResponseError, _Error);
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(ResponseError);
}(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($c7s0H)))(Error));

});


parcelRegister("i8loy", function(module, exports) {
$parcel$export(module.exports, "NoFetchDataAdapter", () => $d33991f371140a0f$export$55fffef3474104af);

var $fL8KA = parcelRequire("fL8KA");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $kIXpt = parcelRequire("kIXpt");

var $cYPzS = parcelRequire("cYPzS");

var $lwlXp = parcelRequire("lwlXp");

var $eyuDe = parcelRequire("eyuDe");

var $25nEq = parcelRequire("25nEq");

var $6HG4S = parcelRequire("6HG4S");

var $iFR7a = parcelRequire("iFR7a");
function $d33991f371140a0f$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $d33991f371140a0f$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $d33991f371140a0f$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $d33991f371140a0f$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $d33991f371140a0f$var$_callSuper(t, o, e) {
    return o = (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(o), (0, (/*@__PURE__*/$parcel$interopDefault($kIXpt)))(t, $d33991f371140a0f$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(t).constructor) : o.apply(t, e));
}
function $d33991f371140a0f$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($d33991f371140a0f$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $d33991f371140a0f$var$_superPropGet(t, o, e, r) {
    var p = (0, (/*@__PURE__*/$parcel$interopDefault($lwlXp)))((0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(1 & r ? t.prototype : t), o, e);
    return 2 & r && "function" == typeof p ? function(t) {
        return p.apply(e, t);
    } : p;
}
var $d33991f371140a0f$export$55fffef3474104af = /*#__PURE__*/ function(_DataAdapterCore) {
    function NoFetchDataAdapter() {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, NoFetchDataAdapter);
        _this = $d33991f371140a0f$var$_callSuper(this, NoFetchDataAdapter, [
            'NoFetchDataAdapter',
            'nofetch'
        ]);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "bootstrapResult", null);
        return _this;
    }
    /**
   * Make sure to call this **before** calling `initializeAsync` or `updateUserAsync` but
   * after the Statsig client has been created!
   */ (0, (/*@__PURE__*/$parcel$interopDefault($eyuDe)))(NoFetchDataAdapter, _DataAdapterCore);
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(NoFetchDataAdapter, [
        {
            key: "setBootstrapData",
            value: function setBootstrapData(data) {
                this.bootstrapResult = data ? {
                    source: 'Bootstrap',
                    data: JSON.stringify(data),
                    receivedAt: Date.now(),
                    stableID: (0, $iFR7a.StableID).get(this._getSdkKey()),
                    fullUserHash: null
                } : null;
            }
        },
        {
            key: "prefetchData",
            value: function() {
                var _prefetchData = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee(_user, _options) {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee$(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee);
                }));
                function prefetchData(_x, _x2) {
                    return _prefetchData.apply(this, arguments);
                }
                return prefetchData;
            }()
        },
        {
            key: "getDataAsync",
            value: function() {
                var _getDataAsync = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee2(_current, user, _options) {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee2$(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                return _context2.abrupt("return", this.bootstrapResult && $d33991f371140a0f$var$_objectSpread($d33991f371140a0f$var$_objectSpread({}, this.bootstrapResult), {}, {
                                    fullUserHash: (0, $iFR7a._getFullUserHash)(user)
                                }));
                            case 1:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2, this);
                }));
                function getDataAsync(_x3, _x4, _x5) {
                    return _getDataAsync.apply(this, arguments);
                }
                return getDataAsync;
            }()
        },
        {
            key: "getDataSync",
            value: function getDataSync(user) {
                return this.bootstrapResult && $d33991f371140a0f$var$_objectSpread($d33991f371140a0f$var$_objectSpread({}, this.bootstrapResult), {}, {
                    fullUserHash: (0, $iFR7a._getFullUserHash)(user)
                });
            }
        },
        {
            key: "_fetchFromNetwork",
            value: function() {
                var _fetchFromNetwork2 = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee3(_current, _user, _options) {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee3$(_context3) {
                        while(true)switch(_context3.prev = _context3.next){
                            case 0:
                                return _context3.abrupt("return", null);
                            case 1:
                            case "end":
                                return _context3.stop();
                        }
                    }, _callee3);
                }));
                function _fetchFromNetwork(_x6, _x7, _x8) {
                    return _fetchFromNetwork2.apply(this, arguments);
                }
                return _fetchFromNetwork;
            }()
        },
        {
            key: "_getCacheKey",
            value: function _getCacheKey(user) {
                // Same logic as default data adapter
                // https://github.com/statsig-io/js-client-monorepo/blob/main/packages/js-client/src/StatsigEvaluationsDataAdapter.ts
                var key = (0, $iFR7a._getStorageKey)(this._getSdkKey(), user);
                return "".concat((0, $iFR7a.DataAdapterCachePrefix), ".").concat(this._cacheSuffix, ".").concat(key);
            }
        },
        {
            key: "_isCachedResultValidFor204",
            value: function _isCachedResultValidFor204(_result, _user) {
                return false;
            }
        },
        {
            key: "setDataLegacy",
            value: function setDataLegacy(data, user) {
                $d33991f371140a0f$var$_superPropGet(NoFetchDataAdapter, "setData", this, 3)([
                    data,
                    user
                ]);
            }
        },
        {
            key: "toJSON",
            value: function toJSON() {
                var result = $d33991f371140a0f$var$_objectSpread({}, this);
                delete result._options;
                delete result._inMemoryCache;
                delete result.bootstrapResult;
                return result;
            }
        }
    ]);
}((0, $iFR7a.DataAdapterCore));

});

parcelRegister("14TSq", function(module, exports) {
$parcel$export(module.exports, "LOCAL_STORAGE_KEY", () => $0c918228b8ad6135$export$d8474cff104280f3);
$parcel$export(module.exports, "PersistentOverrideAdapter", () => $0c918228b8ad6135$export$bcb28fbac1def494);

var $25nEq = parcelRequire("25nEq");

var $iYJcE = parcelRequire("iYJcE");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $dtn6l = parcelRequire("dtn6l");
function $0c918228b8ad6135$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $0c918228b8ad6135$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $0c918228b8ad6135$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $0c918228b8ad6135$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $0c918228b8ad6135$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $0c918228b8ad6135$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $0c918228b8ad6135$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $0c918228b8ad6135$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $0c918228b8ad6135$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $0c918228b8ad6135$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
var $0c918228b8ad6135$var$LOCAL_OVERRIDE_REASON = 'LocalOverride:Recognized';
var $0c918228b8ad6135$export$d8474cff104280f3 = 'STATSIG_OVERRIDES';
var $0c918228b8ad6135$var$LEGACY_LOCAL_STORAGE_KEY = 'STATSIG_JS_LITE_LOCAL_OVERRIDES';
var $0c918228b8ad6135$var$makeEmptyStore = function makeEmptyStore() {
    return {
        gates: {},
        configs: {},
        layers: {}
    };
};
var $0c918228b8ad6135$var$djb2MapKey = function djb2MapKey(hash, kind) {
    return kind + ':' + hash;
};
var $0c918228b8ad6135$export$bcb28fbac1def494 = /*#__PURE__*/ function() {
    function PersistentOverrideAdapter(localStorageKey) {
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, PersistentOverrideAdapter);
        this._overrides = $0c918228b8ad6135$var$makeEmptyStore();
        this._djb2Map = new Map();
        this._localStorageKey = localStorageKey;
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(PersistentOverrideAdapter, [
        {
            key: "parseStoredOverrides",
            value: function parseStoredOverrides(localStorageKey) {
                try {
                    var json = window.localStorage.getItem(localStorageKey);
                    if (!json) return $0c918228b8ad6135$var$makeEmptyStore();
                    return JSON.parse(json);
                } catch (_unused) {
                    return $0c918228b8ad6135$var$makeEmptyStore();
                }
            }
        },
        {
            key: "mergeOverrides",
            value: function mergeOverrides() {
                var merged = $0c918228b8ad6135$var$makeEmptyStore();
                for(var _len = arguments.length, allOverrides = new Array(_len), _key = 0; _key < _len; _key++)allOverrides[_key] = arguments[_key];
                for(var _i = 0, _allOverrides = allOverrides; _i < _allOverrides.length; _i++){
                    var overrides = _allOverrides[_i];
                    for(var _i2 = 0, _Object$entries = Object.entries((_overrides$gates = overrides.gates) !== null && _overrides$gates !== void 0 ? _overrides$gates : {}); _i2 < _Object$entries.length; _i2++){
                        var _overrides$gates;
                        var _Object$entries$_i = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_Object$entries[_i2], 2), name = _Object$entries$_i[0], value = _Object$entries$_i[1];
                        merged.gates[name] = value;
                    }
                    for(var _i3 = 0, _Object$entries2 = Object.entries((_overrides$configs = overrides.configs) !== null && _overrides$configs !== void 0 ? _overrides$configs : {}); _i3 < _Object$entries2.length; _i3++){
                        var _overrides$configs;
                        var _Object$entries2$_i = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_Object$entries2[_i3], 2), _name = _Object$entries2$_i[0], _value = _Object$entries2$_i[1];
                        merged.configs[_name] = _value;
                    }
                    for(var _i4 = 0, _Object$entries3 = Object.entries((_overrides$layers = overrides.layers) !== null && _overrides$layers !== void 0 ? _overrides$layers : {}); _i4 < _Object$entries3.length; _i4++){
                        var _overrides$layers;
                        var _Object$entries3$_i = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_Object$entries3[_i4], 2), _name2 = _Object$entries3$_i[0], _value2 = _Object$entries3$_i[1];
                        merged.layers[_name2] = _value2;
                    }
                }
                return merged;
            }
        },
        {
            key: "initFromStoredOverrides",
            value: function initFromStoredOverrides() {
                var storedOverrides = this.mergeOverrides(this._overrides, this.parseStoredOverrides($0c918228b8ad6135$var$LEGACY_LOCAL_STORAGE_KEY), this.parseStoredOverrides(this._localStorageKey));
                // Clear data from legacy local storage key now we've read from it.
                // This prevents things being stuck in there that are always read but never written to.
                try {
                    window.localStorage.removeItem($0c918228b8ad6135$var$LEGACY_LOCAL_STORAGE_KEY);
                } catch (_unused2) {
                // ignored - window is not defined in non-browser environments, and we don't save things there
                // (things like SSR, etc)
                }
                // In version 4.24.0 we introduced hashes in this override adapter, but had a bug which would cause
                // multiple hashes to continue being created. This code here removes these hashes since we've moved
                // to using a more reliable and easier to maintain map in `_djb2Map`.
                for(var _i5 = 0, _Object$values = Object.values(storedOverrides); _i5 < _Object$values.length; _i5++){
                    var container = _Object$values[_i5];
                    var allKeys = new Set(Object.keys(container));
                    var _iterator = $0c918228b8ad6135$var$_createForOfIteratorHelper(allKeys), _step;
                    try {
                        for(_iterator.s(); !(_step = _iterator.n()).done;){
                            var name = _step.value;
                            var hash = (0, $dtn6l._DJB2)(name);
                            if (allKeys.has(hash)) delete container[hash];
                        }
                    } catch (err) {
                        _iterator.e(err);
                    } finally{
                        _iterator.f();
                    }
                }
                this.applyOverrides(storedOverrides);
            }
        },
        {
            key: "saveOverrides",
            value: function saveOverrides() {
                try {
                    window.localStorage.setItem(this._localStorageKey, JSON.stringify(this._overrides));
                } catch (_unused3) {
                // ignored - window is not defined in non-browser environments, and we don't save things there
                // (things like SSR, etc)
                }
            }
        },
        {
            key: "getOverrides",
            value: function getOverrides() {
                return this.mergeOverrides(this._overrides);
            }
        },
        {
            key: "applyOverrides",
            value: function applyOverrides(overrides) {
                var newOverrides = $0c918228b8ad6135$var$_objectSpread($0c918228b8ad6135$var$_objectSpread({}, $0c918228b8ad6135$var$makeEmptyStore()), overrides);
                this._djb2Map.clear();
                for(var _i6 = 0, _Object$entries4 = Object.entries(newOverrides); _i6 < _Object$entries4.length; _i6++){
                    var _Object$entries4$_i = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_Object$entries4[_i6], 2), containerName = _Object$entries4$_i[0], container = _Object$entries4$_i[1];
                    for(var _i7 = 0, _Object$entries5 = Object.entries(container); _i7 < _Object$entries5.length; _i7++){
                        var _Object$entries5$_i = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_Object$entries5[_i7], 2), name = _Object$entries5$_i[0], value = _Object$entries5$_i[1];
                        this._djb2Map.set($0c918228b8ad6135$var$djb2MapKey((0, $dtn6l._DJB2)(name), containerName), value);
                    }
                }
                this._overrides = newOverrides;
            }
        },
        {
            key: "setOverrides",
            value: function setOverrides(overrides) {
                this.applyOverrides(overrides);
                this.saveOverrides();
            }
        },
        {
            key: "overrideGate",
            value: function overrideGate(name, value) {
                this._overrides.gates[name] = value;
                this._djb2Map.set($0c918228b8ad6135$var$djb2MapKey((0, $dtn6l._DJB2)(name), 'gates'), value);
                this.saveOverrides();
            }
        },
        {
            key: "removeGateOverride",
            value: function removeGateOverride(name) {
                delete this._overrides.gates[name];
                this._djb2Map.delete($0c918228b8ad6135$var$djb2MapKey((0, $dtn6l._DJB2)(name), 'gates'));
                this.saveOverrides();
            }
        },
        {
            key: "getGateOverride",
            value: function getGateOverride(current, _user) {
                var _this$_overrides$gate;
                var overridden = (_this$_overrides$gate = this._overrides.gates[current.name]) !== null && _this$_overrides$gate !== void 0 ? _this$_overrides$gate : this._djb2Map.get($0c918228b8ad6135$var$djb2MapKey(current.name, 'gates'));
                if (overridden == null) return null;
                return $0c918228b8ad6135$var$_objectSpread($0c918228b8ad6135$var$_objectSpread({}, current), {}, {
                    value: overridden,
                    details: $0c918228b8ad6135$var$_objectSpread($0c918228b8ad6135$var$_objectSpread({}, current.details), {}, {
                        reason: $0c918228b8ad6135$var$LOCAL_OVERRIDE_REASON
                    })
                });
            }
        },
        {
            key: "overrideDynamicConfig",
            value: function overrideDynamicConfig(name, value) {
                this._overrides.configs[name] = value;
                this._djb2Map.set($0c918228b8ad6135$var$djb2MapKey((0, $dtn6l._DJB2)(name), 'configs'), value);
                this.saveOverrides();
            }
        },
        {
            key: "removeDynamicConfigOverride",
            value: function removeDynamicConfigOverride(name) {
                delete this._overrides.configs[name];
                this._djb2Map.delete($0c918228b8ad6135$var$djb2MapKey((0, $dtn6l._DJB2)(name), 'configs'));
                this.saveOverrides();
            }
        },
        {
            key: "getDynamicConfigOverride",
            value: function getDynamicConfigOverride(current, _user) {
                return this._getConfigOverride(current, this._overrides.configs);
            }
        },
        {
            key: "overrideExperiment",
            value: function overrideExperiment(name, value) {
                this._overrides.configs[name] = value;
                this._djb2Map.set($0c918228b8ad6135$var$djb2MapKey((0, $dtn6l._DJB2)(name), 'configs'), value);
                this.saveOverrides();
            }
        },
        {
            key: "removeExperimentOverride",
            value: function removeExperimentOverride(name) {
                delete this._overrides.configs[name];
                this._djb2Map.delete($0c918228b8ad6135$var$djb2MapKey((0, $dtn6l._DJB2)(name), 'configs'));
                this.saveOverrides();
            }
        },
        {
            key: "getExperimentOverride",
            value: function getExperimentOverride(current, _user) {
                return this._getConfigOverride(current, this._overrides.configs);
            }
        },
        {
            key: "overrideLayer",
            value: function overrideLayer(name, value) {
                this._overrides.layers[name] = value;
                this._djb2Map.set($0c918228b8ad6135$var$djb2MapKey((0, $dtn6l._DJB2)(name), 'layers'), value);
                this.saveOverrides();
            }
        },
        {
            key: "removeLayerOverride",
            value: function removeLayerOverride(name) {
                delete this._overrides.layers[name];
                this._djb2Map.delete($0c918228b8ad6135$var$djb2MapKey((0, $dtn6l._DJB2)(name), 'layers'));
                this.saveOverrides();
            }
        },
        {
            key: "removeAllOverrides",
            value: function removeAllOverrides() {
                this._overrides = $0c918228b8ad6135$var$makeEmptyStore();
                try {
                    window.localStorage.removeItem(this._localStorageKey);
                } catch (_unused4) {
                // ignored - window is not defined in non-browser environments, and we don't save things there
                // (things like SSR, etc)
                }
            }
        },
        {
            key: "getLayerOverride",
            value: function getLayerOverride(current, _user) {
                var _this$_overrides$laye;
                var overridden = (_this$_overrides$laye = this._overrides.layers[current.name]) !== null && _this$_overrides$laye !== void 0 ? _this$_overrides$laye : this._djb2Map.get($0c918228b8ad6135$var$djb2MapKey(current.name, 'layers'));
                if (overridden == null) return null;
                return $0c918228b8ad6135$var$_objectSpread($0c918228b8ad6135$var$_objectSpread({}, current), {}, {
                    __value: overridden,
                    get: (0, $dtn6l._makeTypedGet)(current.name, overridden),
                    details: $0c918228b8ad6135$var$_objectSpread($0c918228b8ad6135$var$_objectSpread({}, current.details), {}, {
                        reason: $0c918228b8ad6135$var$LOCAL_OVERRIDE_REASON
                    })
                });
            }
        },
        {
            key: "_getConfigOverride",
            value: function _getConfigOverride(current, lookup) {
                var _lookup$current$name;
                var overridden = (_lookup$current$name = lookup[current.name]) !== null && _lookup$current$name !== void 0 ? _lookup$current$name : this._djb2Map.get($0c918228b8ad6135$var$djb2MapKey(current.name, 'configs'));
                if (overridden == null) return null;
                return $0c918228b8ad6135$var$_objectSpread($0c918228b8ad6135$var$_objectSpread({}, current), {}, {
                    value: overridden,
                    get: (0, $dtn6l._makeTypedGet)(current.name, overridden),
                    details: $0c918228b8ad6135$var$_objectSpread($0c918228b8ad6135$var$_objectSpread({}, current.details), {}, {
                        reason: $0c918228b8ad6135$var$LOCAL_OVERRIDE_REASON
                    })
                });
            }
        }
    ]);
}();

});



parcelRegister("49qw5", function(module, exports) {
$parcel$export(module.exports, "addFeatureFlagAccessed", () => $305c925038c8badc$export$47fade9662f71000);

var $luw1P = parcelRequire("luw1P");
var $305c925038c8badc$export$5b78c989c8db2561 = new Map();
var $305c925038c8badc$export$2a5c8df26bb89760 = new Map();
function $305c925038c8badc$export$47fade9662f71000(featureFlagName, featureFlagValue) {
    try {
        // Inform Criterion about FF being accessed
        if (globalThis.__CRITERION__ && typeof globalThis.__CRITERION__.addFeatureFlagAccessed === 'function') globalThis.__CRITERION__.addFeatureFlagAccessed(featureFlagName, featureFlagValue);
    } catch (_e) {
    // ignore the criterion error
    }
    var value = (0, $luw1P.redactValue)(featureFlagValue);
    $305c925038c8badc$export$5b78c989c8db2561.set(featureFlagName, value);
    $305c925038c8badc$export$2a5c8df26bb89760.set(featureFlagName, value);
}

});
parcelRegister("luw1P", function(module, exports) {
$parcel$export(module.exports, "redactValue", () => $fa553e869824e069$export$fcc03ee4c944962f);

var $ekGgq = parcelRequire("ekGgq");

var $gXV4O = parcelRequire("gXV4O");
function $fa553e869824e069$var$startsAsObject(value) {
    try {
        if (value.charAt(0) === '{') return true;
    } catch (_unused) {
        return false;
    }
    return false;
}
function $fa553e869824e069$var$isObject(value) {
    return value && (0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(value) === 'object' && value.constructor === Object;
}
function $fa553e869824e069$var$isString(input) {
    var result;
    try {
        result = typeof input === 'string' || input instanceof String;
    } catch (_unused2) {
        // swallow any errors
        result = false;
    }
    return result;
}
function $fa553e869824e069$export$7b4abba432e57989(value) {
    return $fa553e869824e069$var$isString(value) && $fa553e869824e069$var$startsAsObject(value) || $fa553e869824e069$var$isObject(value);
}
function $fa553e869824e069$export$fcc03ee4c944962f(featureFlagValue) {
    return $fa553e869824e069$export$7b4abba432e57989(featureFlagValue) ? (0, $gXV4O.NON_BOOLEAN_VALUE) : featureFlagValue;
}

});
parcelRegister("gXV4O", function(module, exports) {
$parcel$export(module.exports, "NON_BOOLEAN_VALUE", () => $c59e6e3c6fd7743c$export$42f4885608027d0c);
var $c59e6e3c6fd7743c$export$42f4885608027d0c = 'non_boolean';

});



parcelRegister("2uJ2L", function(module, exports) {
$parcel$export(module.exports, "_overrides", () => $1d1152cde4aea295$export$e5d73bf4f8e2ae96);
$parcel$export(module.exports, "_paramOverrides", () => $1d1152cde4aea295$export$4e849416bb5c5b52);
$parcel$export(module.exports, "_product", () => $1d1152cde4aea295$export$cf7305fc65acbf0d);

var $25nEq = parcelRequire("25nEq");

var $iYJcE = parcelRequire("iYJcE");

var $cQG0q = parcelRequire("cQG0q");

var $aZcdL = parcelRequire("aZcdL");
function $1d1152cde4aea295$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $1d1152cde4aea295$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $1d1152cde4aea295$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $1d1152cde4aea295$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $1d1152cde4aea295$export$e5d73bf4f8e2ae96 = {};
var $1d1152cde4aea295$export$4e849416bb5c5b52 = {};
var $1d1152cde4aea295$export$cf7305fc65acbf0d;
function $1d1152cde4aea295$export$1c2b6dbf79eb3560(product, /**
 * Overrides are used to set the group of an experiment for testing purposes.
 * This is useful when you want to test a specific experiment group.
 */ groupOverrides, /**
 * Param overrides are used to set the experiment parameters for testing purposes.
 * This is useful when you want to tweak the experiment parameters for testing.
 */ paramOverrides, options) {
    if (groupOverrides) {
        // When setting up overrides, we want to ensure that experiments don't end up with invalid
        // values.
        // For production usage -- this is done via the feature flag client which takes the type
        // and performs equivalent logic.
        // @ts-ignore
        groupOverrides = Object.entries(groupOverrides).reduce(function(acc, _ref) {
            var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_ref, 2), key = _ref2[0], value = _ref2[1];
            var config = (0, $cQG0q.editorExperimentsConfig)[key];
            if (config) acc = $1d1152cde4aea295$var$_objectSpread($1d1152cde4aea295$var$_objectSpread({}, acc), {}, (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, key, config.typeGuard(value) ? value : config.defaultValue));
            return acc;
        }, {});
        $1d1152cde4aea295$export$e5d73bf4f8e2ae96 = groupOverrides;
    }
    if (product === 'test' && !(options !== null && options !== void 0 && options.disableTestOverrides)) {
        // Enforce expectation - file overrides, then global overrides, then default to true for boolean
        // experiments, then last result use the default value
        var testOverrides = Object.fromEntries(Object.entries((0, $cQG0q.editorExperimentsConfig)).map(function(_ref3) {
            var _ref5, _ref6, _groupOverrides, _groupOverrides2;
            var _ref4 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_ref3, 2), key = _ref4[0], value = _ref4[1];
            var defaultValue = typeof value.defaultValue === 'boolean' ? true : value.defaultValue;
            return [
                key,
                (_ref5 = (_ref6 = (_groupOverrides = (_groupOverrides2 = groupOverrides) === null || _groupOverrides2 === void 0 ? void 0 : _groupOverrides2[key]) !== null && _groupOverrides !== void 0 ? _groupOverrides : (0, $aZcdL.testMultivariateOverrides)[key]) !== null && _ref6 !== void 0 ? _ref6 : (0, $aZcdL.testBooleanOverrides)[key]) !== null && _ref5 !== void 0 ? _ref5 : defaultValue
            ];
        }));
        $1d1152cde4aea295$export$e5d73bf4f8e2ae96 = testOverrides;
    }
    $1d1152cde4aea295$export$cf7305fc65acbf0d = product;
    $1d1152cde4aea295$export$4e849416bb5c5b52 = paramOverrides || {};
}

});
parcelRegister("cQG0q", function(module, exports) {
$parcel$export(module.exports, "editorExperimentsConfig", () => $95aaecd90467856b$export$6cbb856f286b07ef);
/* eslint-disable perfectionist/sort-object-types */ /* eslint-disable @atlaskit/editor/no-re-export */ // Entry file in package.json

var $3PXeR = parcelRequire("3PXeR");
var $95aaecd90467856b$export$6cbb856f286b07ef = {
    // new format to avoid collisions with other users when updating the file
    // Editor Platform experiments
    // lwoollard experiments
    // Added 2026-02-11
    ai_speech_to_text_in_editor: (0, $3PXeR.createBooleanExperiment)({
        productKeys: {
            confluence: 'ai_speech_to_text_in_editor'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 22-12-2025
    confluence_load_editor_title_on_transition: (0, $3PXeR.createBooleanExperiment)({
        productKeys: {
            confluence: 'confluence_load_editor_title_on_transition'
        },
        param: 'contentPlaceholder',
        defaultValue: false
    }),
    // Added 02-12-2025
    cc_fix_hydration_ttvc: (0, $3PXeR.createBooleanExperiment)({
        productKeys: {
            confluence: 'cc_fix_hydration_ttvc'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-25
    'editor_a11y__enghealth-46814_fy26': (0, $3PXeR.createBooleanExperiment)({
        productKeys: {
            confluence: 'editor_a11y__enghealth-46814_fy26'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-02-20
    editor_a11y_decision_aria_label: (0, $3PXeR.createBooleanExperiment)({
        productKeys: {
            confluence: 'editor_a11y_decision_aria_label',
            jira: 'editor_a11y_decision_aria_label'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 03-09-2025
    cc_editor_interactivity_monitoring: (0, $3PXeR.createBooleanExperiment)({
        productKeys: {
            confluence: 'cc_editor_interactivity_monitoring'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-11-03
    editor_tinymce_full_width_mode: (0, $3PXeR.createBooleanExperiment)({
        productKeys: {
            confluence: 'editor_tinymce_full_width_mode'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 05-03-2026
    platform_editor_ai_headingautocomplete: (0, $3PXeR.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_ai_headingautocomplete'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-02-16
    platform_editor_remove_important_in_render_ext: (0, $3PXeR.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_remove_important_in_render_ext'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-12-10
    confluence_max_width_content_appearance: (0, $3PXeR.createBooleanExperiment)({
        productKeys: {
            confluence: 'confluence_max_width_content_appearance'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-01-15
    confluence_max_width_breakout_extension_fix: (0, $3PXeR.createBooleanExperiment)({
        productKeys: {
            confluence: 'confluence_max_width_breakout_extension_fix'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    confluence_remix_icon_right_side: (0, $3PXeR.createBooleanExperiment)({
        productKeys: {
            confluence: 'confluence_remix_icon_right_side'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    cc_editor_insm_doc_size_stats: (0, $3PXeR.createBooleanExperiment)({
        productKeys: {
            confluence: 'cc_editor_insm_doc_size_stats'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-26
    cc_editor_fix_insm_inp_buffer: (0, $3PXeR.createBooleanExperiment)({
        productKeys: {
            confluence: 'cc_editor_fix_insm_inp_buffer'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-04
    cwr_blank_object_experiment: (0, $3PXeR.createBooleanExperiment)({
        productKeys: {
            confluence: 'cwr_blank_object_experiment'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-09-30
    cc_editor_insm_outlier_events: (0, $3PXeR.createMultivariateExperiment)({
        productKeys: {
            confluence: 'cc_editor_insm_outlier_events'
        },
        param: 'cohort',
        values: [
            'control',
            'test'
        ],
        defaultValue: 'control'
    }),
    // Added 2025-12-09
    cc_editor_hover_link_overlay_css_fix: (0, $3PXeR.createBooleanExperiment)({
        productKeys: {
            confluence: 'cc_editor_hover_link_overlay_css_fix'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-01-7
    platform_editor_table_sticky_header_patch_10: (0, $3PXeR.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_table_sticky_header_patch_10'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-11-17
    platform_editor_renderer_extension_width_fix: (0, $3PXeR.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_renderer_extension_width_fix'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-11-12
    platform_editor_media_vc_fixes: (0, $3PXeR.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_media_vc_fixes'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-24
    platform_editor_media_vc_fixes_patch1: (0, $3PXeR.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_media_vc_fixes_patch1'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-06
    platform_editor_media_reliability_observability: (0, $3PXeR.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_media_reliability_observability'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-24
    platform_editor_media_external_badge_bbc_fix: (0, $3PXeR.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_media_external_badge_bbc_fix',
            bitbucket: 'platform_editor_media_external_badge_bbc_fix'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-11-20
    platform_editor_annotations_sync_on_docchange: (0, $3PXeR.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_annotations_sync_on_docchange'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-05-27
    platform_editor_reduce_noisy_steps_ncs: (0, $3PXeR.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_reduce_noisy_steps_ncs'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-06-02
    platform_editor_block_control_optimise_render: (0, $3PXeR.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_block_control_optimise_render'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2024-08-08
    'example-boolean': (0, $3PXeR.createBooleanExperiment)({
        productKeys: {
            confluence: 'confluence_editor_experiment_test_new_package_boolean'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2024-08-08
    'example-multivariate': (0, $3PXeR.createMultivariateExperiment)({
        productKeys: {
            confluence: 'confluence_editor_experiment_test_new_package_multivariate'
        },
        param: 'variant',
        values: [
            'one',
            'two',
            'three'
        ],
        defaultValue: 'one'
    }),
    // Added 2024-08-08
    'test-new-experiments-package': (0, $3PXeR.createBooleanExperiment)({
        productKeys: {
            confluence: 'confluence_editor_experiment_test_new_package',
            jira: 'jira_editor_experiment_test_new_package'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-09
    platform_editor_react19_migration: (0, $3PXeR.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_react19_migration'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2024-09-05
    support_table_in_comment: (0, $3PXeR.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_support_table_in_comment_exp'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2024-09-07
    platform_editor_exp_lazy_node_views: (0, $3PXeR.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_exp_lazy_node_views'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2024-09-18
    platform_renderer_table_sticky_scrollbar: (0, $3PXeR.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_renderer_table_sticky_scrollbar'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-01-05
    'company_hub_carousel_thumbnails-refactor': (0, $3PXeR.createBooleanExperiment)({
        productKeys: {
            confluence: 'company_hub_carousel_thumbnails-refactor'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-10-10
    platform_editor_experience_tracking: (0, $3PXeR.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_experience_tracking'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-05 - gates DOM mutation observer for experience tracking (toolbar + block menu)
    platform_editor_experience_tracking_observer: (0, $3PXeR.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_experience_tracking_observer',
            jira: 'platform_editor_experience_tracking_observer'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-05-26
    platform_editor_prevent_toolbar_layout_shifts: (0, $3PXeR.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_prevent_toolbar_layout_shifts'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2024-10-01
    comment_on_bodied_extensions: (0, $3PXeR.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_comment_on_bodied_extensions'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2024-10-14
    // https://console.statsig.com/LqivKg6ADZZaGczRfBKfX/experiments/platform_editor_advanced_layouts/setup
    advanced_layouts: (0, $3PXeR.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_advanced_layouts'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-3-15
    // https://console.statsig.com/LqivKg6ADZZaGczRfBKfX/experiments/platform_editor_single_column_layout/setup
    single_column_layouts: (0, $3PXeR.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_single_column_layout'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2024-10-08
    support_table_in_comment_jira: (0, $3PXeR.createBooleanExperiment)({
        productKeys: {
            jira: 'platform_editor_support_table_in_comment_jira'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    'platform_editor_ai-prompts-placeholder': (0, $3PXeR.createMultivariateExperiment)({
        productKeys: {
            confluence: 'platform_editor_ai-prompts-placeholder'
        },
        param: 'cohort',
        values: [
            'control',
            'test'
        ],
        defaultValue: 'control'
    }),
    // Added 2024-11-26
    platform_editor_ai_unsplash_page_header: (0, $3PXeR.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_ai_unsplash_page_header'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-02-24
    platform_editor_paste_actions_menu: (0, $3PXeR.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_paste_actions_menu'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-02-03
    platform_editor_aifc_fix_button_viewed_analytics: (0, $3PXeR.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_aifc_fix_button_viewed_analytics'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2024-12-05
    platform_editor_blockquote_in_text_formatting_menu: (0, $3PXeR.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_blockquote_in_text_formatting_menu'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-01-13
    platform_editor_element_drag_and_drop_multiselect: (0, $3PXeR.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_element_drag_and_drop_multiselect'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-01-19
    platform_editor_ai_edit_response_in_preview: (0, $3PXeR.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_ai_edit_response_in_preview'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-02-10
    platform_editor_controls: (0, $3PXeR.createMultivariateExperiment)({
        productKeys: {
            confluence: 'platform_editor_controls',
            jira: 'platform_editor_controls_jira'
        },
        param: 'cohort',
        values: [
            'control',
            'variant1'
        ],
        defaultValue: 'control'
    }),
    // Added 2025-09-03
    platform_editor_hydratable_ui: (0, $3PXeR.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_hydratable_ui'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-02
    platform_editor_inline_card_dispatch_guard: (0, $3PXeR.createBooleanExperiment)({
        productKeys: {
            jira: 'platform_editor_inline_card_dispatch_guard'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-04-14
    // https://switcheroo.atlassian.com/ui/gates/b159b45a-86d9-4f4b-b482-f9aca5b615d6/key/platform_editor_offline_editing_web
    platform_editor_offline_editing_web: (0, $3PXeR.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_offline_editing_web'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-10-31
    platform_editor_lovability_suppress_toolbar_event: (0, $3PXeR.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_lovability_suppress_toolbar_event',
            jira: 'platform_editor_lovability_suppress_toolbar_event'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-04-17
    platform_editor_tables_drag_and_drop: (0, $3PXeR.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_tables_drag_and_drop'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-04-17
    platform_editor_tables_table_selector: (0, $3PXeR.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_tables_table_selector'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-04-23
    platform_editor_usesharedpluginstateselector: (0, $3PXeR.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_usesharedpluginstateselector'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    platform_editor_table_display_mode_in_to_dom: (0, $3PXeR.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_table_display_mode_in_to_dom'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-04-23
    platform_renderer_fix_analytics_memo_callback: (0, $3PXeR.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_renderer_fix_analytics_memo_callback'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-06-10
    platform_editor_no_cursor_on_edit_page_init: (0, $3PXeR.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_no_cursor_on_edit_page_init'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    platform_editor_clean_up_widget_mark_logic: (0, $3PXeR.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_clean_up_widget_mark_logic',
            jira: 'platform_editor_clean_up_widget_mark_logic'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-07-14
    platform_editor_debounce_portal_provider: (0, $3PXeR.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_debounce_portal_provider'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-10
    platform_editor_renderer_shadow_observer_cleanup: (0, $3PXeR.createBooleanExperiment)({
        productKeys: {
            jira: 'platform_editor_renderer_shadow_observer_cleanup',
            confluence: 'platform_editor_renderer_shadow_observer_cleanup'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-07-08 - Jira work sync description comment summary
    'jira-work-sync-desc-comment-summary': (0, $3PXeR.createBooleanExperiment)({
        productKeys: {
            jira: 'jira-work-sync-desc-comment-summary'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-05-15
    platform_editor_breakout_resizing: (0, $3PXeR.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_breakout_resizing'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-02-17
    platform_editor_aifc_sync_block_stream_fix: (0, $3PXeR.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_aifc_sync_block_stream_fix'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-05-07
    platform_editor_ai_quickstart_command: (0, $3PXeR.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_ai_quickstart_command'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-06-05
    platform_editor_block_controls_perf_optimization: (0, $3PXeR.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_block_controls_perf_optimization'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-06-16
    platform_editor_enable_single_player_step_merging: (0, $3PXeR.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_enable_single_player_step_merging'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    platform_editor_toolbar_hide_overflow_menu: (0, $3PXeR.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_toolbar_hide_overflow_menu',
            jira: 'platform_editor_toolbar_hide_overflow_menu'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-07-02
    platform_editor_code_block_fold_gutter: (0, $3PXeR.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_code_block_fold_gutter'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-06-24
    platform_editor_find_and_replace_improvements: (0, $3PXeR.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_find_and_replace_improvements'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-06-26
    platform_editor_feedback_mandatory_rating: (0, $3PXeR.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_feedback_mandatory_rating'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-07-15
    platform_editor_preview_panel_responsiveness: (0, $3PXeR.createBooleanExperiment)({
        productKeys: {
            confluence: 'confluence_preview_panels_exp'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-08-18
    platform_editor_preview_panel_linking_exp: (0, $3PXeR.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_preview_panel_linking_exp_conf',
            jira: 'platform_editor_preview_panel_linking_exp_jira'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-01-05
    platform_editor_table_update_table_ref: (0, $3PXeR.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_table_update_table_ref'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-01-27
    platform_editor_table_excerpts_fix: (0, $3PXeR.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_table_excerpts_fix'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-08-17
    platform_hover_card_preview_panel: (0, $3PXeR.createMultivariateExperiment)({
        productKeys: {
            confluence: 'platform_hover_card_preview_panel',
            jira: 'platform_hover_card_preview_panel'
        },
        param: 'cohort',
        values: [
            'control',
            'test'
        ],
        defaultValue: 'control'
    }),
    // Added 2025-09-17
    // Added 2025-11-25
    smart_link_confluence_short_link_analytics: (0, $3PXeR.createMultivariateExperiment)({
        productKeys: {
            confluence: 'smart-link-confluence-short-link-analytics',
            jira: 'smart-link-confluence-short-link-analytics'
        },
        param: 'cohort',
        values: [
            'control',
            'test'
        ],
        defaultValue: 'control'
    }),
    // Added 2025--8-05
    platform_editor_block_menu: (0, $3PXeR.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_block_menu',
            jira: 'platform_editor_block_menu_jira'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-07-23
    // Added 2025-07-24
    editor_enghealth_hyperlink_toolbar_aria_values: (0, $3PXeR.createBooleanExperiment)({
        productKeys: {
            confluence: 'editor_enghealth_hyperlink_toolbar_aria_values'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    //Added 2025-07-16
    platform_editor_toolbar_aifc: (0, $3PXeR.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_toolbar_aifc_confluence'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-08-04
    platform_editor_floating_toolbar_button_aria_label: (0, $3PXeR.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_floating_toolbar_button_aria_label'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-07-31
    platform_editor_breakout_interaction_rerender: (0, $3PXeR.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_breakout_interaction_rerender'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    //Added 2025-11-19
    platform_editor_pasting_text_in_panel: (0, $3PXeR.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_pasting_text_in_panel'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-02-19
    platform_editor_comment_editor_border_radius: (0, $3PXeR.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_comment_editor_border_radius'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-26
    platform_editor_perf_lint_cleanup: (0, $3PXeR.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_perf_lint_cleanup'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-07-30
    platform_editor_blocktaskitem_node_tenantid: (0, $3PXeR.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_blocktaskitem_node_tenantid'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-09-08
    platform_editor_blocktaskitem_patch_1: (0, $3PXeR.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_blocktaskitem_patch_1'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-01-19
    cc_editor_limited_mode_expanded: (0, $3PXeR.createBooleanExperiment)({
        productKeys: {
            confluence: 'cc_editor_limited_mode_expanded'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-11
    platform_editor_native_embeds: (0, $3PXeR.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_native_embeds'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-08-05
    platform_editor_native_anchor_with_dnd: (0, $3PXeR.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_native_anchor_with_dnd'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-05
    'cc_perf-insights-cards_extension_a11y_list': (0, $3PXeR.createBooleanExperiment)({
        productKeys: {
            confluence: 'cc_perf-insights-cards_extension_a11y_list'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-12
    ccpi_fix_broken_uploaded_img: (0, $3PXeR.createBooleanExperiment)({
        productKeys: {
            confluence: 'ccpi_fix_broken_uploaded_img'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-02-05
    'editor-a11y-fy26-keyboard-move-row-column': (0, $3PXeR.createBooleanExperiment)({
        productKeys: {
            confluence: 'editor-a11y-fy26-keyboard-move-row-column',
            jira: 'editor-a11y-fy26-keyboard-move-row-column'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-08-28
    editor_enable_image_alignment_in_expand: (0, $3PXeR.createBooleanExperiment)({
        productKeys: {
            confluence: 'editor_enable_image_alignment_in_expand'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-08-05
    platform_editor_august_a11y: (0, $3PXeR.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_august_a11y'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-08-10
    platform_synced_block: (0, $3PXeR.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_synced_block',
            jira: 'platform_synced_block_jira'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-05
    platform_synced_block_use_new_source_nodeview: (0, $3PXeR.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_synced_block_use_new_source_nodeview',
            jira: 'platform_synced_block_use_new_source_nodeview'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-05
    platform_synced_block_patch_6: (0, $3PXeR.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_synced_block_patch_6',
            jira: 'platform_synced_block_patch_6'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-08-18
    platform_editor_locale_datepicker: (0, $3PXeR.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_locale_datepicker'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-09-16
    platform_editor_prevent_taskitem_remount: (0, $3PXeR.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_prevent_taskitem_remount'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-01-08
    platform_editor_table_toolbar_perf_fix: (0, $3PXeR.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_table_toolbar_perf_fix'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-09-01
    cc_editor_ai_content_mode: (0, $3PXeR.createMultivariateExperiment)({
        productKeys: {
            confluence: 'cc_editor_ai_content_mode'
        },
        param: 'variant',
        values: [
            'control',
            'test'
        ],
        defaultValue: 'control'
    }),
    // Added 2026-01-09
    platform_editor_render_bodied_extension_as_inline: (0, $3PXeR.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_render_bodied_extension_as_inline'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-03
    platform_editor_ai_quick_prompt_iw_cc: (0, $3PXeR.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_ai_quick_prompt_iw_cc'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-02-25
    platform_editor_ai_escape_early_for_unhealthy_node: (0, $3PXeR.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_ai_escape_early_for_unhealthy_node'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-12-04
    confluence_compact_text_format: (0, $3PXeR.createBooleanExperiment)({
        productKeys: {
            confluence: 'confluence_compact_text_format'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    platform_editor_unify_native_dnd_selectors: (0, $3PXeR.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_unify_native_dnd_selectors',
            jira: 'platform_editor_unify_native_dnd_selectors'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-05
    platform_editor_abort_ufo_on_user_interaction: (0, $3PXeR.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_abort_ufo_on_user_interaction'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-10-10
    platform_use_llm_space_recommendations: (0, $3PXeR.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_use_llm_space_recommendations'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-09-23
    cc_editor_ttvc_release_bundle_one: (0, $3PXeR.createBooleanExperiment)({
        productKeys: {
            confluence: 'cc_editor_ttvc_release_bundle_one'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-10-07
    platform_editor_plain_text_support: (0, $3PXeR.createBooleanExperiment)({
        productKeys: {
            jira: 'platform_editor_plain_text_support',
            confluence: 'platform_editor_plain_text_support'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-10-01
    // Added 2025-10-13
    platform_editor_media_error_analytics: (0, $3PXeR.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_media_error_analytics'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-10-22
    platform_editor_remove_bidi_char_warning: (0, $3PXeR.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_remove_bidi_char_warning'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-10-27
    platform_editor_table_sticky_header_improvements: (0, $3PXeR.createMultivariateExperiment)({
        productKeys: {
            confluence: 'platform_editor_table_sticky_header_improvements'
        },
        param: 'cohort',
        values: [
            'control',
            'test_with_overflow',
            'test_without_overflow'
        ],
        defaultValue: 'control'
    }),
    // Added 2025-11-04
    platform_editor_disable_lazy_load_media: (0, $3PXeR.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_disable_lazy_load_media'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-10-29
    platform_editor_lovability_inline_code: (0, $3PXeR.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_lovability_inline_code'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-02-16
    platform_editor_disable_lcm_copy_button: (0, $3PXeR.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_disable_lcm_copy_button'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-28-01
    platform_editor_primary_toolbar_early_exit: (0, $3PXeR.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_primary_toolbar_early_exit',
            jira: 'platform_editor_primary_toolbar_early_exit'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-11-05
    platform_editor_lovability_emoji_scaling: (0, $3PXeR.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_lovability_emoji_scaling'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    platform_editor_flex_based_centering: (0, $3PXeR.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_flex_based_centering'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-02-18
    editor_a11y_7152_profile_card_tab_order: (0, $3PXeR.createBooleanExperiment)({
        productKeys: {
            confluence: 'editor_a11y_7152_profile_card_tab_order'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-11-19
    platform_editor_lovability_navigation_fixes: (0, $3PXeR.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_lovability_navigation_fixes'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-11-27
    platform_sl_3p_unauth_paste_as_block_card: (0, $3PXeR.createMultivariateExperiment)({
        productKeys: {
            confluence: 'platform_sl_3p_unauth_paste_as_block_card',
            jira: 'platform_sl_3p_unauth_paste_as_block_card'
        },
        values: [
            'control',
            'card_by_default_only',
            'card_by_default_and_new_design'
        ],
        param: 'cohort',
        defaultValue: 'control'
    }),
    // Added 2026-03-17 - 3P auth Rovo actions on smart link hover card (boolean: isEnabled)
    platform_sl_3p_auth_rovo_action: (0, $3PXeR.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_sl_3p_auth_rovo_action',
            jira: 'platform_sl_3p_auth_rovo_action'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-27 — Pre-auth unauthorised inline hover card UX
    platform_sl_3p_preauth_better_hovercard: (0, $3PXeR.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_sl_3p_preauth_better_hovercard',
            jira: 'platform_sl_3p_preauth_better_hovercard'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-01-23
    platform_editor_to_use_pmr_for_collab_edit_none_ic: (0, $3PXeR.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_to_use_pmr_for_collab_edit_none_ic'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-12-12
    platform_editor_toolbar_delay_render_fix: (0, $3PXeR.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_toolbar_delay_render_fix'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-12-08
    platform_editor_add_image_editing: (0, $3PXeR.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_add_image_editing'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    platform_editor_toolbar_aifc_use_editor_typography: (0, $3PXeR.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_toolbar_aifc_use_editor_typography',
            jira: 'platform_editor_toolbar_aifc_use_editor_typography'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    platform_editor_toolbar_submenu_open_click: (0, $3PXeR.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_toolbar_submenu_open_click'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-12-30
    platform_editor_table_sticky_header_patch_9: (0, $3PXeR.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_table_sticky_header_patch_9'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-12-22
    platform_editor_localid_ime_composition_fix: (0, $3PXeR.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_localid_ime_composition_fix'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-12-22
    platform_editor_sample_renderer_rendered_event: (0, $3PXeR.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_sample_renderer_rendered_event'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-01-21
    platform_editor_copy_link_a11y_inconsistency_fix: (0, $3PXeR.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_copy_link_a11y_inconsistency_fix'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-02-25
    platform_editor_expand_paste_in_comment_editor: (0, $3PXeR.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_expand_paste_in_comment_editor'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-01-12
    platform_editor_table_sticky_header_patch_11: (0, $3PXeR.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_table_sticky_header_patch_11'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-02-16
    platform_editor_ai_fix_insert_after_selection: (0, $3PXeR.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_ai_fix_insert_after_selection'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-04-07
    platform_editor_ai_move_node: (0, $3PXeR.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_ai_move_node'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-01-08
    platform_editor_focus_on_chromeless_editor: (0, $3PXeR.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_focus_on_chromeless_editor'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-02-02
    platform_editor_ai_disable_bridge_without_ai: (0, $3PXeR.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_ai_disable_bridge_without_ai'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-01-16
    platform_editor_ai_edit_unsupported_content: (0, $3PXeR.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_ai_edit_unsupported_content'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-01-19
    platform_editor_copy_paste_issue_fix: (0, $3PXeR.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_copy_paste_issue_fix'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-01-27 - AI create-page expand collapse fix
    platform_editor_aifc_expand_collapses_oncreate_fix: (0, $3PXeR.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_aifc_expand_collapses_oncreate_fix',
            jira: 'platform_editor_aifc_expand_collapses_oncreate_fix'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-01-22
    platform_editor_ai_loading_responsive_width: (0, $3PXeR.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_ai_loading_responsive_width',
            jira: 'platform_editor_ai_loading_responsive_width'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-01-22
    platform_editor_nested_drag_handle_icon: (0, $3PXeR.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_nested_drag_handle_icon'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-01-23
    collab_bypass_out_of_sync_period_experiment: (0, $3PXeR.createBooleanExperiment)({
        productKeys: {
            confluence: 'collab_bypass_out_of_sync_period_experiment'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-16
    platform_editor_ignore_metadata_connection_errors: (0, $3PXeR.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_collab_provider_suppress_metadata_errors'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-02-18
    platform_editor_table_a11y_eslint_fix: (0, $3PXeR.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_table_a11y_eslint_fix'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-01-29
    platform_editor_renderer_toolbar_updates: (0, $3PXeR.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_renderer_toolbar_updates'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-01-30
    platform_editor_fix_cross_origin_editor_focus: (0, $3PXeR.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_fix_cross_origin_editor_focus'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    platform_editor_comment_rovoinlinechat_improvement: (0, $3PXeR.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_comment_rovoinlinechat_improvement'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    confluence_ttvc_inline_extensions: (0, $3PXeR.createBooleanExperiment)({
        productKeys: {
            confluence: 'confluence_ttvc_inline_extensions'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-02-03
    platform_editor_enghealth_a11y_jan_fixes: (0, $3PXeR.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_enghealth_a11y_jan_fixes'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-02-04
    platform_editor_emoji_tooltips_on_hover: (0, $3PXeR.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_emoji_tooltips_on_hover'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-16-05
    platform_editor_outdated_browser_update: (0, $3PXeR.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_outdated_browser_update'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-02-05
    cc_fd_db_top_editor_toolbar: (0, $3PXeR.createMultivariateExperiment)({
        productKeys: {
            confluence: 'cc_fd_db_top_editor_toolbar'
        },
        param: 'cohort',
        values: [
            'control',
            'new-description',
            'orig-description'
        ],
        defaultValue: 'control'
    }),
    // Added 2026-04-02 - CFFD-2139
    cc_fd_cwr_quick_insert: (0, $3PXeR.createMultivariateExperiment)({
        productKeys: {
            confluence: 'cc_fd_cwr_quick_insert'
        },
        param: 'cohort',
        values: [
            'control',
            'slot-four',
            'slot-two'
        ],
        defaultValue: 'control'
    }),
    // Added 2026-02-05 - A11Y-10416
    editor_a11y_role_textbox: (0, $3PXeR.createBooleanExperiment)({
        productKeys: {
            confluence: 'editor_a11y_role_textbox'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-01-28
    platform_editor_smartlink_local_cache: (0, $3PXeR.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_smartlink_local_cache'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-02-05
    platform_editor_toolbar_split_button_ui: (0, $3PXeR.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_toolbar_split_button_ui'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-02-06
    platform_rovo_inline_chat_missing_analytics_fix: (0, $3PXeR.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_rovo_inline_chat_missing_analytics_fix'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-02-12
    platform_editor_bodiedextension_layoutshift_fix: (0, $3PXeR.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_bodiedextension_layoutshift_fix'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-16
    platform_safari_cursor_typeahead_fix: (0, $3PXeR.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_safari_cursor_typeahead_fix'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-02-17
    confluence_frontend_fix_date_hydration_error: (0, $3PXeR.createBooleanExperiment)({
        productKeys: {
            confluence: 'confluence_frontend_fix_date_hydration_error'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-02-19
    platform_editor_a11y_eslint_fix: (0, $3PXeR.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_a11y_eslint_fix',
            jira: 'platform_editor_a11y_eslint_fix'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    platform_editor_fix_advanced_codeblocks_crlf_patch: (0, $3PXeR.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_fix_advanced_codeblocks_crlf_patch',
            jira: 'platform_editor_fix_advanced_codeblocks_crlf_patch'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-02-23
    'cc-maui-experiment': (0, $3PXeR.createBooleanExperiment)({
        productKeys: {
            confluence: 'cc-maui-experiment'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-04-06
    'cc-maui-experiment-phase-2': (0, $3PXeR.createBooleanExperiment)({
        productKeys: {
            confluence: 'cc-maui-experiment-phase-2'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-05
    'cc-mui-slides-experiment': (0, $3PXeR.createBooleanExperiment)({
        productKeys: {
            confluence: 'cc-mui-slides-experiment'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-02-27
    confluence_frontend_cwr_outcome_type_picker: (0, $3PXeR.createBooleanExperiment)({
        productKeys: {
            confluence: 'confluence_frontend_cwr_outcome_type_picker'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-04-01
    confluence_fe_cwr_outcome_picker_prompt_autoselect: (0, $3PXeR.createBooleanExperiment)({
        productKeys: {
            confluence: 'confluence_fe_cwr_outcome_picker_prompt_autoselect'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-02-12
    platform_editor_a11y_escape_link_dialog: (0, $3PXeR.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_a11y_escape_link_dialog',
            jira: 'platform_editor_a11y_escape_link_dialog'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-04
    platform_editor_vc90_transition_table_border: (0, $3PXeR.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_vc90_transition_table_border'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-04
    platform_editor_vc90_transition_expand_icon: (0, $3PXeR.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_vc90_transition_expand_icon'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-04
    platform_editor_vc90_transition_panel_icon: (0, $3PXeR.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_vc90_transition_panel_icon'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-04
    platform_editor_vc90_transition_mentions: (0, $3PXeR.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_vc90_transition_mentions'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-02-11
    platform_editor_prosemirror_rendered_data: (0, $3PXeR.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_prosemirror_rendered_data',
            jira: 'platform_editor_prosemirror_rendered_data'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-02-19
    platform_editor_flexible_list_indentation: (0, $3PXeR.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_flexible_list_indentation'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-24
    platform_editor_flexible_list_schema: (0, $3PXeR.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_flexible_list_schema'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-02-24
    platform_editor_emoji_default_scale: (0, $3PXeR.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_emoji_default_scale',
            jira: 'platform_editor_emoji_default_scale'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-02-26
    platform_editor_toolbar_update_jira_config: (0, $3PXeR.createBooleanExperiment)({
        productKeys: {
            jira: 'platform_editor_toolbar_update_jira_config'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-02-25
    platform_editor_a11y_typeahead_tab_keypress: (0, $3PXeR.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_a11y_typeahead_tab_keypress'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-02-27
    platform_editor_early_exit_return_draft: (0, $3PXeR.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_early_exit_return_draft'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-03
    platform_editor_ai_update_actioned_event_timeout: (0, $3PXeR.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_ai_update_actioned_event_timeout'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-02
    platform_editor_discarded_unified_analytic_events: (0, $3PXeR.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_discarded_unified_analytic_events',
            jira: 'platform_editor_discarded_unified_analytic_events'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-05
    platform_editor_appearance_shared_state: (0, $3PXeR.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_appearance_shared_state'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-04
    platform_editor_ai_blockmenu_integration: (0, $3PXeR.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_ai_blockmenu_integration'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added for space shortcut plugin: when on, space shortcut is not added if AI opt-in is not enabled
    platform_editor_ai_aifc_space_shortcut_patch: (0, $3PXeR.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_ai_aifc_space_shortcut_patch'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-04
    platform_editor_rovobutton_smartlink_toolbar_exp: (0, $3PXeR.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_rovobutton_smartlink_toolbar_exp'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-04-02
    platform_editor_ai_smartlink_toolbar_v2_exp: (0, $3PXeR.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_ai_smartlink_toolbar_v2_exp'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-30
    platform_editor_a11y_scrollable_region: (0, $3PXeR.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_a11y_scrollable_region'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-02
    platform_editor_a11y_table_wrapper_fix: (0, $3PXeR.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_a11y_table_wrapper_fix'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-11
    platform_editor_renderer_error_boundary_stable_key: (0, $3PXeR.createBooleanExperiment)({
        productKeys: {
            jira: 'platform_editor_renderer_error_boundary_stable_key',
            confluence: 'platform_editor_renderer_error_boundary_stable_key'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-04
    confluence_fe_renderer_inline_node_mark_color_fix: (0, $3PXeR.createBooleanExperiment)({
        productKeys: {
            confluence: 'confluence_fe_renderer_inline_node_mark_color_fix'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-10
    platform_editor_fix_editor_unhandled_type_errors: (0, $3PXeR.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_fix_editor_unhandled_type_errors'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-05
    platform_editor_table_resizer_extended_zone: (0, $3PXeR.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_table_resizer_extended_zone'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-10
    platform_editor_insert_location_check: (0, $3PXeR.createBooleanExperiment)({
        productKeys: {
            jira: 'platform_editor_insert_location_check',
            confluence: 'platform_editor_insert_location_check'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-05
    cc_drag_and_drop_smart_link_from_content_to_tree: (0, $3PXeR.createBooleanExperiment)({
        productKeys: {
            confluence: 'cc_drag_and_drop_smart_link_from_content_to_tree'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-19
    platform_editor_fix_table_row_drag_drop_target: (0, $3PXeR.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_fix_table_row_drag_drop_target'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-11
    platform_editor_remove_grid_init_reflow: (0, $3PXeR.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_remove_grid_init_reflow'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-07
    platform_editor_table_remove_last_cell_decoration: (0, $3PXeR.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_table_remove_last_cell_decoration'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    platform_editor_small_font_size: (0, $3PXeR.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_small_font_size',
            jira: 'platform_editor_small_font_size'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-10
    platform_editor_diff_plugin_extended: (0, $3PXeR.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_diff_plugin_extended'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-10
    platform_editor_fix_media_toolbar_border_dropdown: (0, $3PXeR.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_fix_media_toolbar_border_dropdown'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-24
    platform_editor_fix_media_picker_hidden: (0, $3PXeR.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_fix_media_picker_hidden',
            jira: 'platform_editor_fix_media_picker_hidden'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-10
    platform_editor_analyse_table_with_merged_cells: (0, $3PXeR.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_analyse_table_with_merged_cells'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    cc_editor_ttvc_media_hold_fix: (0, $3PXeR.createBooleanExperiment)({
        productKeys: {
            confluence: 'cc_editor_ttvc_media_hold_fix'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-06
    platform_editor_single_player_expand: (0, $3PXeR.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_single_player_expand'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-04-01
    platform_editor_rovo_inline_chat_aria_label: (0, $3PXeR.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_rovo_inline_chat_aria_label'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-11
    platform_editor_are_nodes_equal_ignore_mark_order: (0, $3PXeR.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_are_nodes_equal_ignore_mark_order',
            jira: 'platform_editor_are_nodes_equal_ignore_mark_order'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-11
    platform_editor_disable_last_node_para: (0, $3PXeR.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_disable_last_node_para',
            jira: 'platform_editor_disable_last_node_para'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-09
    platform_editor_remove_collab_step_metrics: (0, $3PXeR.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_remove_collab_step_metrics'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-13
    platform_editor_editor_centre_content_on_find: (0, $3PXeR.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_editor_centre_content_on_find'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-24
    platform_editor_table_ref_optimisation: (0, $3PXeR.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_table_ref_optimisation'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-20
    platform_editor_chromeless_expand_fix: (0, $3PXeR.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_chromeless_expand_fix',
            jira: 'platform_editor_chromeless_expand_fix'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-23
    platform_editor_inline_media_copy_paste_fix: (0, $3PXeR.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_inline_media_copy_paste_fix',
            jira: 'platform_editor_inline_media_copy_paste_fix'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-13
    platform_editor_misaligned_ai_screens_firefox_fix: (0, $3PXeR.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_misaligned_ai_screens_firefox_fix',
            jira: 'platform_editor_misaligned_ai_screens_firefox_fix'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-19
    platform_editor_toolbar_two_stage_hydration: (0, $3PXeR.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_toolbar_two_stage_hydration'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-15
    platform_editor_stricter_panelcolor_typecheck: (0, $3PXeR.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_stricter_panelcolor_typecheck'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-15
    platform_editor_sync_block_ssr_config: (0, $3PXeR.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_sync_block_ssr_config'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-18
    platform_editor_selection_toolbar_block_handle: (0, $3PXeR.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_selection_toolbar_block_handle'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-27
    platform_editor_preserve_node_identity: (0, $3PXeR.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_preserve_node_identity'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-23
    confluence_toc_nav_a11y: (0, $3PXeR.createBooleanExperiment)({
        productKeys: {
            confluence: 'confluence_toc_nav_a11y'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-02-004
    platform_editor_user_highlight_contrast: (0, $3PXeR.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_user_highlight_contrast'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-25
    platform_editor_improve_preset_builder_logging: (0, $3PXeR.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_improve_preset_builder_logging'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-26
    platform_editor_fix_comment_border: (0, $3PXeR.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_fix_comment_border'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-30
    platform_editor_spotlight_migration: (0, $3PXeR.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_spotlight_migration'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-30
    platform_editor_ai_xstate_migration: (0, $3PXeR.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_ai_xstate_migration'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-31
    platform_editor_dnd_accessibility_fixes_expand: (0, $3PXeR.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_dnd_accessibility_fixes_expand'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-04-01
    platform_editor_layout_column_resize_handle: (0, $3PXeR.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_layout_column_resize_handle'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-31
    platform_editor_lovability_distribute_column_fix: (0, $3PXeR.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_lovability_distribute_column_fix'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-04-02
    platform_editor_ai_aifc_listitem_indentation_fix: (0, $3PXeR.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_ai_aifc_listitem_indentation_fix'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-04-08
    cc_fd_wb_jira_quick_insert_experiment: (0, $3PXeR.createBooleanExperiment)({
        productKeys: {
            jira: 'cc_fd_wb_jira_quick_insert_experiment'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-04-07
    platform_editor_lovability_select_all_shortcut: (0, $3PXeR.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_lovability_select_all_shortcut',
            jira: 'platform_editor_lovability_select_all_shortcut'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-04-01
    platform_editor_hydration_skip_react_portal: (0, $3PXeR.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_hydration_skip_react_portal'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-04-08
    platform_editor_drag_handle_keyboard_a11y: (0, $3PXeR.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_drag_handle_keyboard_a11y'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-04-01
    show_mentions_in_suggest_reply: (0, $3PXeR.createBooleanExperiment)({
        productKeys: {
            jira: 'show_mentions_in_suggest_reply'
        },
        param: 'isEnabled',
        defaultValue: false
    })
};

});
parcelRegister("3PXeR", function(module, exports) {
$parcel$export(module.exports, "createBooleanExperiment", () => $2cb416110edd9683$export$456f1587c9c92021);
$parcel$export(module.exports, "createMultivariateExperiment", () => $2cb416110edd9683$export$fb89e8a786694d1);

var $fC8ib = parcelRequire("fC8ib");

var $25nEq = parcelRequire("25nEq");

var $11twE = parcelRequire("11twE");
function $2cb416110edd9683$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $2cb416110edd9683$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $2cb416110edd9683$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $2cb416110edd9683$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $2cb416110edd9683$export$456f1587c9c92021(config) {
    return $2cb416110edd9683$var$_objectSpread($2cb416110edd9683$var$_objectSpread({}, config), {}, {
        typeGuard: (0, $11twE.isBoolean),
        defaultValue: config.defaultValue
    });
}
function $2cb416110edd9683$export$fb89e8a786694d1(config) {
    var values = config.values;
    return $2cb416110edd9683$var$_objectSpread($2cb416110edd9683$var$_objectSpread({}, config), {}, {
        values: (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(values),
        // Maintains the tuple
        typeGuard: (0, $11twE.oneOf)(config.values),
        defaultValue: config.defaultValue
    });
}

});
parcelRegister("11twE", function(module, exports) {
$parcel$export(module.exports, "isBoolean", () => $0becc999b79402a5$export$f9ce7b637dfbe238);
$parcel$export(module.exports, "oneOf", () => $0becc999b79402a5$export$a9a18ae5ba42aeab);

var $3ZMUU = parcelRequire("3ZMUU");
var $0becc999b79402a5$var$_process, $0becc999b79402a5$var$_process2;
function $0becc999b79402a5$export$f9ce7b637dfbe238(value) {
    return typeof value === 'boolean';
}
function $0becc999b79402a5$export$a9a18ae5ba42aeab(values) {
    function typeGuard(value) {
        return values.includes(value);
    }
    /**
   * This is used by test utils to get the variants when running describe.each
   */ if ($0becc999b79402a5$var$IS_TESTING_ENV) typeGuard.values = values;
    return typeGuard;
}
// @ts-ignore
var $0becc999b79402a5$var$IS_TESTING_ENV = typeof $3ZMUU !== 'undefined' && ((($0becc999b79402a5$var$_process = $3ZMUU) === null || $0becc999b79402a5$var$_process === void 0 || ($0becc999b79402a5$var$_process = $0becc999b79402a5$var$_process.env) === null || $0becc999b79402a5$var$_process === void 0 ? void 0 : $0becc999b79402a5$var$_process.NODE_ENV) === 'test' || (($0becc999b79402a5$var$_process2 = $3ZMUU) === null || $0becc999b79402a5$var$_process2 === void 0 || ($0becc999b79402a5$var$_process2 = $0becc999b79402a5$var$_process2.env) === null || $0becc999b79402a5$var$_process2 === void 0 ? void 0 : $0becc999b79402a5$var$_process2.JEST_WORKER_ID) !== undefined);

});



parcelRegister("aZcdL", function(module, exports) {
$parcel$export(module.exports, "testMultivariateOverrides", () => $7ff914becf03f8e9$export$7e849a84a00ffd1c);
$parcel$export(module.exports, "testBooleanOverrides", () => $7ff914becf03f8e9$export$54960937bb713f97);
var $7ff914becf03f8e9$export$7e849a84a00ffd1c = {
    'example-multivariate': 'one',
    'platform_editor_ai-prompts-placeholder': 'control',
    platform_editor_controls: 'control',
    cc_editor_ai_content_mode: 'control',
    platform_hover_card_preview_panel: 'control',
    smart_link_confluence_short_link_analytics: 'control',
    cc_editor_insm_outlier_events: 'test',
    platform_editor_table_sticky_header_improvements: 'test_with_overflow',
    platform_sl_3p_unauth_paste_as_block_card: 'control',
    cc_fd_db_top_editor_toolbar: 'control',
    cc_fd_cwr_quick_insert: 'control'
};
var $7ff914becf03f8e9$export$54960937bb713f97 = {
    platform_sl_3p_auth_rovo_action: false,
    platform_sl_3p_preauth_better_hovercard: true,
    cwr_blank_object_experiment: false,
    cc_editor_hover_link_overlay_css_fix: false,
    platform_editor_feedback_mandatory_rating: false,
    platform_editor_preview_panel_responsiveness: false,
    platform_editor_toolbar_aifc: false,
    platform_editor_block_control_optimise_render: false,
    'test-new-experiments-package': false,
    support_table_in_comment: false,
    platform_editor_exp_lazy_node_views: false,
    platform_renderer_table_sticky_scrollbar: false,
    platform_editor_prevent_toolbar_layout_shifts: false,
    comment_on_bodied_extensions: false,
    advanced_layouts: false,
    single_column_layouts: false,
    support_table_in_comment_jira: false,
    platform_editor_ai_unsplash_page_header: false,
    platform_editor_blockquote_in_text_formatting_menu: false,
    platform_editor_element_drag_and_drop_multiselect: false,
    platform_editor_ai_edit_response_in_preview: false,
    platform_editor_offline_editing_web: false,
    platform_editor_tables_drag_and_drop: false,
    platform_editor_tables_table_selector: false,
    platform_renderer_fix_analytics_memo_callback: false,
    platform_editor_no_cursor_on_edit_page_init: false,
    'jira-work-sync-desc-comment-summary': false,
    platform_editor_breakout_resizing: false,
    platform_editor_ai_quickstart_command: false,
    platform_editor_block_controls_perf_optimization: false,
    platform_editor_enable_single_player_step_merging: false,
    platform_editor_find_and_replace_improvements: false,
    platform_editor_reduce_noisy_steps_ncs: false,
    platform_editor_prosemirror_rendered_data: false,
    confluence_compact_text_format: false,
    platform_editor_paste_actions_menu: false,
    platform_editor_diff_plugin_extended: false,
    platform_editor_preserve_node_identity: false
};

});






parcelRegister("2XMn4", function(module, exports) {
$parcel$export(module.exports, "breakoutConsts", () => $22869cf5d7d3b0ac$export$ead1fecec2ecf57c);
$parcel$export(module.exports, "absoluteBreakoutWidth", () => $22869cf5d7d3b0ac$export$b34ea040d1533a3);
$parcel$export(module.exports, "calcWideWidth", () => $22869cf5d7d3b0ac$export$86325001fe8f3adc);
$parcel$export(module.exports, "calcBreakoutWidth", () => $22869cf5d7d3b0ac$export$5f4502874a28dfce);

var $1LBcl = parcelRequire("1LBcl");

var $9ZxlF = parcelRequire("9ZxlF");

var $kMHA5 = parcelRequire("kMHA5");

var $01HkO = parcelRequire("01HkO");

var $7Lgzm = parcelRequire("7Lgzm");
var $22869cf5d7d3b0ac$export$2626b4a7243208a1 = [
    'expand',
    'layoutSection',
    'codeBlock',
    'syncBlock',
    'bodiedSyncBlock'
];
var $22869cf5d7d3b0ac$export$c2c078d93ed82790 = function getBreakoutResizableNodeTypes(schema) {
    var _schema$nodes = schema.nodes, expand = _schema$nodes.expand, codeBlock = _schema$nodes.codeBlock, layoutSection = _schema$nodes.layoutSection, syncBlock = _schema$nodes.syncBlock, bodiedSyncBlock = _schema$nodes.bodiedSyncBlock;
    return new Set([
        expand,
        codeBlock,
        layoutSection,
        syncBlock,
        bodiedSyncBlock
    ]);
};
/**
 * Variables required to construct a context for breakout ssr inline script.
 *
 * TODO: Clean this up after: https://product-fabric.atlassian.net/browse/ED-8942
 *
 */ var $22869cf5d7d3b0ac$export$ead1fecec2ecf57c = {
    padding: (0, $1LBcl.akEditorBreakoutPadding),
    defaultLayoutWidth: (0, $1LBcl.akEditorDefaultLayoutWidth),
    wideScaleRatio: (0, $1LBcl.breakoutWideScaleRatio),
    fullWidthLayoutWidth: (0, $1LBcl.akEditorFullWidthLayoutWidth),
    wideLayoutWidth: (0, $1LBcl.akEditorWideLayoutWidth),
    mapBreakpointToLayoutMaxWidth: (0, $kMHA5.mapBreakpointToLayoutMaxWidth),
    getBreakpoint: (0, $01HkO.getBreakpoint),
    /**
   * This function can return percentage value or px value depending upon the inputs
   */ calcBreakoutWidth: function calcBreakoutWidth(breakoutConsts) {
        return function(layout, containerWidth, padding) {
            var effectiveFullWidth = containerWidth - (padding !== null && padding !== void 0 ? padding : breakoutConsts.padding);
            switch(layout){
                case 'full-width':
                    return "".concat(Math.min(effectiveFullWidth, breakoutConsts.fullWidthLayoutWidth), "px");
                case 'wide':
                    if (effectiveFullWidth <= 0) return '100%';
                    var wideWidth = breakoutConsts.calcWideWidth(breakoutConsts)(containerWidth, undefined, undefined, padding);
                    if (wideWidth.endsWith('%')) return "".concat(Math.min(effectiveFullWidth, breakoutConsts.fullWidthLayoutWidth), "px");
                    return wideWidth;
                default:
                    return '100%';
            }
        };
    },
    calcBreakoutWithCustomWidth: function calcBreakoutWithCustomWidth(breakoutConsts) {
        return function(mode, width, editorContainerWidth) {
            if (width !== null && width > 0) {
                var effectiveFullWidth = editorContainerWidth - breakoutConsts.padding;
                // if below 0 then expect we're rendering in SSR
                return "".concat(Math.min(width, effectiveFullWidth), "px");
            }
            return breakoutConsts.calcBreakoutWidth(breakoutConsts)(mode, editorContainerWidth);
        };
    },
    calcLineLength: function calcLineLength(breakoutConsts) {
        return function() {
            return breakoutConsts.defaultLayoutWidth;
        };
    },
    calcWideWidth: function calcWideWidth(breakoutConsts) {
        return function() {
            var containerWidth = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : breakoutConsts.defaultLayoutWidth;
            var maxWidth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Infinity;
            var fallback = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '100%';
            var padding = arguments.length > 3 ? arguments[3] : undefined;
            var effectiveFullWidth = containerWidth - (padding !== null && padding !== void 0 ? padding : breakoutConsts.padding);
            var layoutMaxWidth = breakoutConsts.mapBreakpointToLayoutMaxWidth(breakoutConsts.getBreakpoint(containerWidth));
            var wideWidth = Math.min(Math.ceil(layoutMaxWidth * breakoutConsts.wideScaleRatio), effectiveFullWidth);
            return layoutMaxWidth > wideWidth ? fallback : "".concat(Math.min(maxWidth, wideWidth), "px");
        };
    }
};
var $22869cf5d7d3b0ac$export$b34ea040d1533a3 = function absoluteBreakoutWidth(layout, containerWidth) {
    var breakoutWidth = $22869cf5d7d3b0ac$export$ead1fecec2ecf57c.calcBreakoutWidth($22869cf5d7d3b0ac$export$ead1fecec2ecf57c)(layout, containerWidth);
    // If it's percent, map to max layout size
    if (breakoutWidth.endsWith('%')) switch(layout){
        case 'full-width':
            return 0, $1LBcl.akEditorFullWidthLayoutWidth;
        case 'wide':
            return 0, $1LBcl.akEditorWideLayoutWidth;
        default:
            return $22869cf5d7d3b0ac$export$ead1fecec2ecf57c.mapBreakpointToLayoutMaxWidth($22869cf5d7d3b0ac$export$ead1fecec2ecf57c.getBreakpoint(containerWidth));
    }
    return parseInt(breakoutWidth, 10);
};
var $22869cf5d7d3b0ac$export$86325001fe8f3adc = $22869cf5d7d3b0ac$export$ead1fecec2ecf57c.calcWideWidth($22869cf5d7d3b0ac$export$ead1fecec2ecf57c);
var $22869cf5d7d3b0ac$export$5f4502874a28dfce = $22869cf5d7d3b0ac$export$ead1fecec2ecf57c.calcBreakoutWidth($22869cf5d7d3b0ac$export$ead1fecec2ecf57c);
var $22869cf5d7d3b0ac$export$ccc0a02edddeed39 = $22869cf5d7d3b0ac$export$ead1fecec2ecf57c.calcBreakoutWithCustomWidth($22869cf5d7d3b0ac$export$ead1fecec2ecf57c);
function $22869cf5d7d3b0ac$export$c377853ecdd53e5b(_ref) {
    var mode = _ref.mode, widthStateLineLength = _ref.widthStateLineLength, widthStateWidth = _ref.widthStateWidth;
    var breakoutWidth = $22869cf5d7d3b0ac$export$5f4502874a28dfce(mode, widthStateWidth);
    var breakoutWidthPx = (0, $7Lgzm.parsePx)(breakoutWidth);
    if (!widthStateLineLength) // lineLength is not normally undefined when this is run for,
    // consumers but can be in SSR, initial render or test (jsdom)
    // environments.
    //
    // this approach doesn't work well with position: fixed, so
    // it breaks things like sticky headers.
    //
    // It can also cause bluriness for some child content (such as iframes)
    return {
        type: 'line-length-unknown',
        width: breakoutWidth,
        minWidth: breakoutWidthPx,
        display: 'flex',
        justifyContent: 'center',
        transform: 'none',
        transition: "min-width 0.5s ".concat((0, $1LBcl.akEditorSwoopCubicBezier))
    };
    // NOTE
    // At time of writing -- when toggling between full-width and
    // full-page appearance modes. There is a slight delay before
    // the widthState is updated.
    // During this period -- the marginLeftPx will be incorrect.
    // const marginLeftPx = -(breakoutWidthPx - widthStateLineLength) / 2;
    return {
        type: 'line-length-known',
        width: breakoutWidth,
        minWidth: breakoutWidthPx,
        transition: "min-width 0.5s ".concat((0, $1LBcl.akEditorSwoopCubicBezier)),
        transform: "translateX(-50%)",
        marginLeft: "50%"
    };
}
function $22869cf5d7d3b0ac$export$586300c53bd298dd(mode, widthStateWidth, padding) {
    return (0, $7Lgzm.parsePx)($22869cf5d7d3b0ac$export$5f4502874a28dfce(mode, widthStateWidth, padding));
}
var $22869cf5d7d3b0ac$export$7eb758567e6644fd = function getNextBreakoutMode(currentMode) {
    if (currentMode === 'full-width') return 'center';
    else if (currentMode === 'wide') return 'full-width';
    return 'wide';
};
var $22869cf5d7d3b0ac$export$70d1bf7729efff40 = function getTitle(layout) {
    switch(layout){
        case 'full-width':
            return (0, $9ZxlF.default).layoutFixedWidth;
        case 'wide':
            return (0, $9ZxlF.default).layoutFullWidth;
        default:
            return (0, $9ZxlF.default).layoutWide;
    }
};

});
parcelRegister("9ZxlF", function(module, exports) {
$parcel$export(module.exports, "default", () => $7463ade3a45ab39d$export$2e2bcd8739ae039);
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $aRMzY = parcelRequire("aRMzY");






var $6qzXE = parcelRequire("6qzXE");






var $2sM12 = parcelRequire("2sM12");



var $fvrMl = parcelRequire("fvrMl");



var $hak1L = parcelRequire("hak1L");





























var $7463ade3a45ab39d$var$_default_1 = (0, $aRMzY.defineMessages)({
    layoutFixedWidth: {
        id: 'fabric.editor.layoutFixedWidth',
        defaultMessage: 'Back to center',
        description: 'Display your element (image, table, extension, etc) as standard width'
    },
    layoutStateFixedWidth: {
        id: 'fabric.editor.layoutStateFixedWidth',
        defaultMessage: 'Centered',
        description: 'Displaying your element (image, table, extension, etc) as standard width'
    },
    layoutWide: {
        id: 'fabric.editor.layoutWide',
        defaultMessage: 'Go wide',
        description: 'Display your element (image, table, extension, etc) wider than normal'
    },
    layoutStateWide: {
        id: 'fabric.editor.layoutStateWide',
        defaultMessage: 'Wide',
        description: 'Displaying your element (image, table, extension, etc) wider than normal'
    },
    layoutFullWidth: {
        id: 'fabric.editor.layoutFullWidth',
        defaultMessage: 'Go full width',
        description: 'Display your element (image, table, extension, etc) as full width'
    },
    layoutStateFullWidth: {
        id: 'fabric.editor.layoutStateFullWidth',
        defaultMessage: 'Full width',
        description: 'Displaying your element (image, table, extension, etc) as full width'
    },
    alignImageRight: {
        id: 'fabric.editor.alignImageRight',
        defaultMessage: 'Align right',
        description: 'The text is shown as a button in the image toolbar when the user wants to align an image to the right side of the page.'
    },
    alignImageCenter: {
        id: 'fabric.editor.alignImageCenter',
        defaultMessage: 'Align center',
        description: 'The text is shown as a button in the image toolbar when the user wants to align an image to the center of the page.'
    },
    alignImageLeft: {
        id: 'fabric.editor.alignImageLeft',
        defaultMessage: 'Align left',
        description: 'The text is shown as a button in the image toolbar when the user wants to align an image to the left side of the page.'
    },
    delete: {
        id: 'fabric.editor.delete',
        defaultMessage: 'Delete',
        description: 'Delete the element (image, panel, table, etc.) from your document'
    },
    remove: {
        id: 'fabric.editor.remove',
        defaultMessage: 'Remove',
        description: 'Delete the element (image, panel, table, etc.) from your document'
    },
    removeEmoji: {
        id: 'fabric.editor.removeEmoji',
        defaultMessage: 'Remove emoji',
        description: 'Remove the emoji panel icon from custom panel'
    },
    visit: {
        id: 'fabric.editor.visit',
        defaultMessage: 'Open link in a new window',
        description: 'The text is shown as a link or button in the editor when the user wants to open the selected link in a new browser window.'
    },
    inviteToEditButtonTitle: {
        id: 'fabric.editor.editMode.inviteToEditButton.title',
        defaultMessage: 'Invite to edit',
        description: 'Invite another user to edit the current document'
    },
    saveButton: {
        id: 'fabric.editor.saveButton',
        defaultMessage: 'Save',
        description: 'Submit and save a comment or document'
    },
    cancelButton: {
        id: 'fabric.editor.cancelButton',
        defaultMessage: 'Cancel',
        description: 'Discard the current comment or document'
    },
    taskList: {
        id: 'fabric.editor.tooltip.taskList',
        defaultMessage: 'an action item',
        description: 'The text is shown as a tooltip label in the editor to describe an action item element when the user interacts with it.'
    },
    bulletList: {
        id: 'fabric.editor.tooltip.bulletList',
        defaultMessage: 'a list',
        description: 'The text is shown as a tooltip label in the editor to describe a bullet list element when the user interacts with it.'
    },
    nestedExpand: {
        id: 'fabric.editor.tooltip.nestedExpand',
        defaultMessage: 'a nested expand',
        description: 'The text is shown as a tooltip label in the editor to describe a nested expand element when the user interacts with it.'
    },
    decisionList: {
        id: 'fabric.editor.tooltip.decisionList',
        defaultMessage: 'a decision list',
        description: 'The text is shown as a tooltip label in the editor to describe a decision list element when the user interacts with it.'
    },
    defaultBlockNode: {
        id: 'fabric.editor.tooltip.defaultBlockNode',
        defaultMessage: 'a block node',
        description: 'The text is shown as a tooltip label in the editor to describe a generic block node element when the user interacts with it.'
    },
    panel: {
        id: 'fabric.editor.tooltip.blockPanel',
        defaultMessage: 'a panel',
        description: 'The text is shown as a tooltip label in the editor to describe a panel element when the user interacts with it.'
    },
    blockquote: {
        id: 'fabric.editor.blockquote',
        defaultMessage: 'a quote',
        description: 'The text is shown as a tooltip label in the editor to describe a blockquote element when the user interacts with it.'
    },
    timeUpdated: {
        id: 'fabric.editor.time.updated',
        defaultMessage: 'Updated',
        description: 'The text is shown as a label in the editor to indicate when the content was last updated by a user.'
    },
    timeViewed: {
        id: 'fabric.editor.time.viewed',
        defaultMessage: 'Viewed',
        description: 'The text is shown as a label in the editor to indicate when the content was last viewed by a user.'
    },
    timeAgo: {
        id: 'fabric.editor.time.ago',
        defaultMessage: 'ago',
        description: 'The text is shown as a label suffix after a time value to indicate that the action occurred in the past, for example "5 minutes ago".'
    },
    copyToClipboard: {
        id: 'fabric.editor.copyToClipboard',
        defaultMessage: 'Copy',
        description: 'Copy the whole content of the element to your clipboard'
    },
    copiedToClipboard: {
        id: 'fabric.editor.copiedToClipboard',
        defaultMessage: 'Copied!',
        description: 'Copied the whole content of the element to clipboard'
    },
    viewMore: {
        id: 'fabric.editor.overflowMenuViewMore',
        defaultMessage: 'View more',
        description: 'The text is shown as a button in the editor toolbar overflow menu when additional toolbar options are available for the user to view.'
    },
    imageEdit: {
        id: 'fabric.editor.imageEdit',
        defaultMessage: 'Edit image',
        description: 'Crop, flip or rotate the image'
    },
    error: {
        id: 'fabric.editor.error.message.label',
        defaultMessage: 'Error',
        description: 'The text is shown as a label for the error message icon in the editor when an operation fails or an error occurs.'
    },
    success: {
        id: 'fabric.editor.success.message.label',
        defaultMessage: 'Success',
        description: 'Label for success message icon'
    }
});
var $7463ade3a45ab39d$export$2e2bcd8739ae039 = $7463ade3a45ab39d$var$_default_1;

});
parcelRegister("6qzXE", function(module, exports) {
$parcel$export(module.exports, "codeBidiWarningMessages", () => $4ae110edca90b5da$export$42bb270d1224182);

var $aRMzY = parcelRequire("aRMzY");
var $4ae110edca90b5da$export$42bb270d1224182 = (0, $aRMzY.defineMessages)({
    /**
   * Message taken from
   * https://hello.atlassian.net/wiki/spaces/~tswan/pages/1366555782/PSHELP-2943+Investigate+Trojan+Source+Attack+Vulnerability+design
   */ label: {
        id: 'fabric.editor.codeBidiWarningLabel',
        defaultMessage: 'Bidirectional characters change the order that text is rendered. This could be used to obscure malicious code.',
        description: 'Tooltip message to present to users when a bidirectional character is encountered in code.'
    }
});

});

parcelRegister("2sM12", function(module, exports) {
$parcel$export(module.exports, "codeBlockButtonMessages", () => $1cb3713e26cbd288$export$74e304339778e94d);

var $aRMzY = parcelRequire("aRMzY");
var $1cb3713e26cbd288$export$74e304339778e94d = (0, $aRMzY.defineMessages)({
    copyCodeToClipboard: {
        id: 'fabric.editor.codeBlockCopyButton.copyToClipboard',
        defaultMessage: 'Copy as text',
        description: 'Copy the content of the code block as text to your clipboard'
    },
    copiedCodeToClipboard: {
        id: 'fabric.editor.codeBlockCopyButton.copiedToClipboard',
        defaultMessage: 'Copied!',
        description: 'Copied the content of the code block as text to clipboard'
    },
    wrapCode: {
        id: 'fabric.editor.codeBlockWrapButton.wrapCodeBlock',
        defaultMessage: 'Turn on wrap',
        description: 'Wrap the content of the code block'
    },
    unwrapCode: {
        id: 'fabric.editor.codeBlockWrapButton.unwrapCodeBlock',
        defaultMessage: 'Turn off wrap',
        description: 'Wrap the content of the code block'
    },
    selectLanguage: {
        id: 'fabric.editor.selectLanguage',
        defaultMessage: 'Select language',
        description: 'Code blocks display software code. A prompt to select the software language the code is written in.'
    }
});

});

parcelRegister("fvrMl", function(module, exports) {
$parcel$export(module.exports, "messages", () => $b49f4c8cb384de29$export$defe85febe8b728c);

var $aRMzY = parcelRequire("aRMzY");
var $b49f4c8cb384de29$export$defe85febe8b728c = (0, $aRMzY.defineMessages)({
    url: {
        id: 'fabric.editor.url',
        defaultMessage: 'Display URL',
        description: 'Convert the card to become a regular text-based hyperlink.'
    },
    block: {
        id: 'fabric.editor.displayBlock',
        defaultMessage: 'Display card',
        description: 'Display link as a card with a rich preview similar to in a Facebook feed with page title, description, and potentially an image.'
    },
    inline: {
        id: 'fabric.editor.displayInline',
        defaultMessage: 'Display inline',
        description: 'Display link with the title only.'
    },
    embed: {
        id: 'fabric.editor.displayEmbed',
        defaultMessage: 'Display embed',
        description: 'Display link as an embedded object'
    },
    link: {
        id: 'fabric.editor.displayLink',
        defaultMessage: 'Display as text',
        description: 'Convert the card to become a regular text-based hyperlink.'
    },
    card: {
        id: 'fabric.editor.cardFloatingControls',
        defaultMessage: 'Card options',
        description: 'The text is shown as a title for the floating toolbar when a user selects an inline card or smart link in the editor, providing options to change the card display type.'
    },
    blockCardUnavailable: {
        id: 'fabric.editor.blockCardUnavailable',
        defaultMessage: 'The inline link is inside {node} and cannot have its view changed',
        description: 'Warning message to show the user that this node cannot change its view'
    },
    displayOptionUnavailableInParentNode: {
        id: 'fabric.editor.displayOptionUnavailableInParentNode',
        defaultMessage: "This display option isn't available inside {node}",
        description: 'Warning message to show the user that this node option is not available inside a parent node type'
    },
    urlTitle: {
        id: 'fabric.editor.urlTitle',
        defaultMessage: 'URL',
        description: 'Title for option to convert the card to become a regular text-based hyperlink.'
    },
    blockTitle: {
        id: 'fabric.editor.blockTitle',
        defaultMessage: 'Card',
        description: 'Title for option to display link in the card view.'
    },
    inlineTitle: {
        id: 'fabric.editor.inlineTitle',
        defaultMessage: 'Inline',
        description: 'Title for option to display link in the inline view.'
    },
    openButtonTitle: {
        id: 'fabric.editor.openButtonTitle',
        defaultMessage: 'Open',
        description: 'Title for a button that opens a link when clicked.'
    },
    panelButtonTitle: {
        id: 'fabric.editor.panelButtonTitle',
        defaultMessage: 'Panel',
        description: 'Title for a button that opens side panel when clicked.'
    },
    previewButtonTitle: {
        id: 'fabric.editor.previewButtonTitle',
        defaultMessage: 'Preview',
        description: 'Title for a button that when clicked opens a preview modal or a preview panel.'
    },
    embedTitle: {
        id: 'fabric.editor.embedTitle',
        defaultMessage: 'Embed',
        description: 'Title for option to display link as an embedded object.'
    },
    urlDescription: {
        id: 'fabric.editor.urlDescription',
        defaultMessage: 'Display link as URL',
        description: 'Description for option to convert the card to become a regular text-based hyperlink.'
    },
    blockDescription: {
        id: 'fabric.editor.blockDescription',
        defaultMessage: 'Display more information about a link, including a summary and actions',
        description: 'Description for option to display link in the card view.'
    },
    inlineDescription: {
        id: 'fabric.editor.inlineDescription',
        defaultMessage: 'Display link as inline text',
        description: 'Description for option to display link in the inline view.'
    },
    embedDescription: {
        id: 'fabric.editor.ecombedDescription',
        defaultMessage: 'Display an interactive preview of a link',
        description: 'Description for option to display link as an embedded object.'
    },
    embedToBlockCardWarning: {
        id: 'fabric.editor.embedToBlockCardWarning',
        defaultMessage: 'Displays as a card on small screens',
        description: 'Warning message to show the user that embed card will be displayed as a block card on small screens.'
    },
    editDropdownExpandIconLabel: {
        id: 'fabric.editor.editDropdownExpandIconLabel',
        defaultMessage: 'Expand dropdown menu',
        description: 'Text of an icon to expand the dropdown'
    },
    editDropdownTriggerTitle: {
        id: 'fabric.editor.editDropdownTriggerTitle',
        defaultMessage: 'Edit',
        description: 'Text of a button to trigger opening an edit dropdown'
    },
    editDropdownEditLinkTitle: {
        id: 'fabric.editor.editDropdownEditLinkTitle',
        defaultMessage: 'Edit link',
        description: 'Edit dropdown edit link button text'
    },
    editDropdownEditDatasourceTitle: {
        id: 'fabric.editor.editDropdownEditDatasourceTitle',
        defaultMessage: 'Edit search query',
        description: 'Edit dropdown edit datasource button text'
    },
    datasourceTitle: {
        id: 'fabric.editor.datasourceTitle',
        defaultMessage: 'Edit search query',
        description: 'Tooltip of button to edit a card into a datasource'
    },
    datasourceAppearanceTitle: {
        id: 'fabric.editor.datasourceAppearanceTitle',
        defaultMessage: 'List',
        description: 'Tooltip of button to change to datasource appearance'
    },
    datasourceJiraIssue: {
        id: 'fabric.editor.datasource.jiraIssue',
        defaultMessage: 'Jira Issues',
        description: 'Insert a jira datasource table'
    },
    datasourceJiraIssueDescription: {
        id: 'fabric.editor.datasource.jiraIssue.description',
        defaultMessage: 'Insert Jira issues from Jira Cloud with enhanced search, filtering, and configuration.',
        description: 'Insert a jira datasource table'
    },
    datasourceAssetsObjectsGeneralAvailability: {
        id: 'fabric.editor.datasource.assetsObjectsGeneralAvailability',
        defaultMessage: 'Assets',
        description: 'Text displayed when selecting the type of data to include onto the page, in this case: JSM Assets objects.'
    },
    datasourceAssetsObjectsDescription: {
        id: 'fabric.editor.datasource.assetsObjects.description',
        defaultMessage: 'Insert objects from Assets in Jira Service Management with search and filtering',
        description: 'Description text displayed when selecting the type of data to include onto the page, in this case: JSM Assets objects'
    },
    inlineOverlay: {
        id: 'fabric.editor.inlineOverlay',
        defaultMessage: 'Configure',
        description: 'An overlay shown when hover over inline smart link to inform user that they can click the link to edit the links appearance.'
    },
    inlineConfigureLink: {
        id: 'fabric.editor.inlineConfigureLink',
        defaultMessage: 'Configure link',
        description: 'An icon shown when hovering over inline smart link to inform user they can click the icon to configure the links appearance.'
    },
    inlineGoToLink: {
        id: 'fabric.editor.inlineGoToLink',
        defaultMessage: 'Go to link',
        description: 'An option in the configure link dropdown that informs the user they can click the option to open the link'
    },
    datasourceConfluenceSearch: {
        id: 'fabric.editor.datasource.confluenceSearch',
        defaultMessage: 'Insert Confluence list',
        description: 'Title shown for Confluence Search datasource on QuickInsert options'
    },
    datasourceConfluenceSearchDescription: {
        id: 'fabric.editor.datasource.confluenceSearch.description',
        defaultMessage: 'Insert list of search results from Confluence with enhanced search, filtering, and configuration.',
        description: 'Description text displayed when selecting the type of data to include onto the page, in this case: Confluence Search objects'
    },
    datasourceJiraIssueIssueTermRefresh: {
        id: 'fabric.editor.datasource.jiraIssue.issue-term-refresh',
        defaultMessage: 'Jira Work Items',
        description: 'Insert a jira datasource table (Issue Terminology Refresh)'
    },
    datasourceJiraIssueDescriptionIssueTermRefresh: {
        id: 'fabric.editor.datasource.jiraIssue.description.issue-term-refresh',
        defaultMessage: 'Insert Jira work items from Jira Cloud with enhanced search, filtering, and configuration.',
        description: 'Insert a jira datasource table (Issue Terminology Refresh)'
    }
});

});

parcelRegister("hak1L", function(module, exports) {
$parcel$export(module.exports, "messages", () => $c7f2e7e5b810098d$export$defe85febe8b728c);

var $aRMzY = parcelRequire("aRMzY");
var $c7f2e7e5b810098d$export$defe85febe8b728c = (0, $aRMzY.defineMessages)({
    tableScrollRegion: {
        id: 'fabric.editor.tableScrollRegion',
        defaultMessage: 'Table scroll region',
        description: 'Label for the scrollable region of a table, used for accessibility purposes.'
    },
    tableOptions: {
        id: 'fabric.editor.tableOptions',
        defaultMessage: 'Table options',
        description: 'Opens a menu with additional table options'
    },
    tableSizeIncreaseScreenReaderInformation: {
        id: 'fabric.editor.tableResizeIncreaseScreenReaderInformation',
        defaultMessage: 'Table width increased to {newWidth, plural, one {# pixel} other {# pixels}}.',
        description: 'Information for screen reader users about increasing the table size by a certain number of pixels.'
    },
    tableSizeDecreaseScreenReaderInformation: {
        id: 'fabric.editor.tableResizeDecreaseScreenReaderInformation',
        defaultMessage: 'Table width decreased to {newWidth, plural, one {# pixel} other {# pixels}}.',
        description: 'Information for screen reader users about decreasing the table size by a certain number of pixels.'
    },
    headerRow: {
        id: 'fabric.editor.headerRow',
        defaultMessage: 'Header row',
        description: 'Marks the first table row as a header row'
    },
    headerColumn: {
        id: 'fabric.editor.headerColumn',
        defaultMessage: 'Header column',
        description: 'Marks the first table column as a header row'
    },
    numberedColumn: {
        id: 'fabric.editor.numberedColumn',
        defaultMessage: 'Numbered column',
        description: 'Adds an auto-numbering column to your table'
    },
    collapseTable: {
        id: 'fabric.editor.collapseTable',
        defaultMessage: 'Collapse table',
        description: 'The text is shown as a menu item in the table options dropdown when the user wants to collapse a table by wrapping it inside an expand element.'
    },
    resizeTable: {
        id: 'fabric.editor.tables.resizeTable',
        defaultMessage: 'Resize table',
        description: 'Tooltip text shown when hovering over the table width resize handle. Indicates users can drag to adjust the table width.'
    },
    insertColumn: {
        id: 'fabric.editor.insertColumn',
        defaultMessage: 'Insert column right',
        description: 'Inserts a new column to the right of selected column.'
    },
    addColumnLeft: {
        id: 'fabric.editor.addColumnLeft',
        defaultMessage: 'Add column left',
        description: 'Adds a new column to the left of selected column.'
    },
    addColumnRight: {
        id: 'fabric.editor.addColumnRight',
        defaultMessage: 'Add column right',
        description: 'Adds a new column to the right of selected column.'
    },
    insertColumnDrag: {
        id: 'fabric.editor.insertColumnDrag',
        defaultMessage: 'Insert column',
        description: 'Inserts a new column to the right of selected column.'
    },
    removeColumns: {
        id: 'fabric.editor.removeColumns',
        defaultMessage: 'Delete {0, plural, one {column} other {columns}}',
        description: 'The text is shown as a menu item or button when the user selects one or more table columns to delete them. The message adapts for singular or plural columns.'
    },
    insertRow: {
        id: 'fabric.editor.insertRow',
        defaultMessage: 'Insert row below',
        description: 'Inserts a new row below the selected row.'
    },
    addRowAbove: {
        id: 'fabric.editor.addRowAbove',
        defaultMessage: 'Add row above',
        description: 'Adds a new row above the selected row.'
    },
    addRowBelow: {
        id: 'fabric.editor.addRowBelow',
        defaultMessage: 'Add row below',
        description: 'Adds a new row below the selected row.'
    },
    moveColumnLeft: {
        id: 'fabric.editor.moveColumnLeft',
        defaultMessage: 'Move {0, plural, one {column} other {columns}} left',
        description: 'Moves a column or columns to the left.'
    },
    moveColumnLeftHelpDialogLabel: {
        id: 'fabric.editor.moveColumnLeftHelpDialogLabel',
        defaultMessage: 'Move column left',
        description: 'Description of a keymap that moves one column or multiple columns left, this is in the help dialog and can be simpler than the puralisation version'
    },
    moveColumnRight: {
        id: 'fabric.editor.moveColumnRight',
        defaultMessage: 'Move {0, plural, one {column} other {columns}} right',
        description: 'Moves a column or columns to the right.'
    },
    moveColumnRightHelpDialogLabel: {
        id: 'fabric.editor.moveColumnRightHelpDialogLabel',
        defaultMessage: 'Move column right',
        description: 'Description of a keymap that moves one column or multiple columns right, this is in the help dialog and can be simpler than the puralisation version'
    },
    moveRowUp: {
        id: 'fabric.editor.moveRowUp',
        defaultMessage: 'Move {0, plural, one {row} other {rows}} up',
        description: 'Moves a row or selected rows up.'
    },
    moveRowUpHelpDialogLabel: {
        id: 'fabric.editor.moveRowUpHelpDialogLabel',
        defaultMessage: 'Move row up',
        description: 'Description of a keymap that moves one row or multiple rows up, this is in the help dialog and can be simpler than the puralisation version'
    },
    moveRowDown: {
        id: 'fabric.editor.moveDownDown',
        defaultMessage: 'Move {0, plural, one {row} other {rows}} down',
        description: 'Moves a row or selected rows down.'
    },
    moveRowDownHelpDialogLabel: {
        id: 'fabric.editor.moveRowDownHelpDialogLabel',
        defaultMessage: 'Move row down',
        description: 'Description of a keymap that moves one row or multiple rows down, this is in the help dialog and can be simpler than the puralisation version'
    },
    insertRowDrag: {
        id: 'fabric.editor.insertRowDrag',
        defaultMessage: 'Insert row',
        description: 'Inserts a new row below the selected row.'
    },
    removeRows: {
        id: 'fabric.editor.removeRows',
        defaultMessage: 'Delete {0, plural, one {row} other {rows}}',
        description: 'The text is shown as a menu item or button when the user selects one or more table rows to delete them. The message adapts for singular or plural rows.'
    },
    rowNumbers: {
        id: 'fabrid.editor.rowNumbers',
        defaultMessage: 'Row numbers',
        description: 'The text is shown as a label for a toggle option in the table options menu that adds a number to each row except the header row.'
    },
    numberedRows: {
        id: 'fabrid.editor.numberedRows',
        defaultMessage: 'Numbered rows',
        description: 'The text is shown as a label for a toggle option in the table options menu that adds a number to each row except the header row.'
    },
    rowsAreInserted: {
        id: 'fabric.editor.rowsAreInserted',
        defaultMessage: '{count, plural, one {A row has been} other {{count} rows have been}} inserted',
        description: 'Assistive message following the insertion of row(s)'
    },
    rowsAreRemoved: {
        id: 'fabric.editor.rowsAreRemoved',
        defaultMessage: '{count, plural, one {The row has been} other {{count} rows have been}} removed',
        description: 'Assistive message following the removal of row(s)'
    },
    rowSelected: {
        id: 'fabric.editor.rowSelected',
        defaultMessage: 'Row {index} of {total} selected',
        description: 'Assistive message following the selection of a row'
    },
    rowMovedUp: {
        id: 'fabric.editor.rowMovedUp',
        defaultMessage: 'Row moved up to {index} of {total}',
        description: 'Assistive message following the upward movement of a row'
    },
    rowMovedDown: {
        id: 'fabric.editor.rowMovedDown',
        defaultMessage: 'Row moved down to {index} of {total}',
        description: 'Assistive message following the downward movement of a row'
    },
    columnsAreInserted: {
        id: 'fabric.editor.columnsAreInserted',
        defaultMessage: '{count, plural, one {A column has been} other {{count} columns have been}} inserted',
        description: 'Assistive message following the insertion of column(s)'
    },
    columnsAreRemoved: {
        id: 'fabric.editor.columnsAreRemoved',
        defaultMessage: '{count, plural, one {The column has been} other {{count} columns have been}} removed',
        description: 'Assistive message following the removal of column(s)'
    },
    columnSelected: {
        id: 'fabric.editor.columnSelected',
        defaultMessage: 'Column {index} of {total} selected',
        description: 'Assistive message following the selection of a column'
    },
    columnMovedLeft: {
        id: 'fabric.editor.columnMovedLeft',
        defaultMessage: 'Column moved left to {index} of {total}',
        description: 'Assistive message following the left movement of a column'
    },
    columnMovedRight: {
        id: 'fabric.editor.columnMovedRight',
        defaultMessage: 'Column moved right to {index} of {total}',
        description: 'Assistive message following the right movement of a column'
    },
    cellOptions: {
        id: 'fabric.editor.cellOptions',
        defaultMessage: 'Cell options',
        description: 'Opens a menu with options for the current table cell.'
    },
    confirmDeleteLinkedModalOKButton: {
        id: 'fabric.editor.tables.confirmDeleteLinkedModalOKButton',
        defaultMessage: 'Delete',
        description: 'Action button label for confirm modal when deleting a table linked to an extension.'
    },
    confirmDeleteLinkedModalMessage: {
        id: 'fabric.editor.tables.confirmDeleteLinkedModalMessage',
        defaultMessage: 'Deleting {nodeName} will break anything connected to it.',
        description: 'Message for confirm modal when deleting a table linked to an extension.'
    },
    confirmDeleteLinkedModalMessagePrefix: {
        id: 'fabric.editor.extension.confirmDeleteLinkedModalMessagePrefix',
        defaultMessage: 'Deleting',
        description: 'prefix for confirmation dialog text'
    },
    confirmModalCheckboxLabel: {
        id: 'fabric.editor.floatingToolbar.confirmModalCheckboxLabel',
        defaultMessage: 'Also delete connected elements',
        description: 'The text is shown as a checkbox label in a confirmation dialog when the user is about to delete an element that has connected extensions.'
    },
    deleteElementTitle: {
        id: 'fabric.editor.extension.deleteElementTitle',
        defaultMessage: 'Delete element',
        description: 'Title text for confirm modal when deleting an extension linked to a data consumer.'
    },
    unnamedSource: {
        id: 'fabric.editor.extension.sourceNoTitledName',
        defaultMessage: 'this element',
        description: 'The current element without preset name been selected'
    },
    adjustColumns: {
        id: 'fabric.editor.tables.adjustColumn',
        defaultMessage: 'Adjust column',
        description: 'Tooltip displayed on table column resize handle'
    },
    cornerControl: {
        id: 'fabric.editor.cornerControl',
        defaultMessage: 'Highlight table',
        description: 'A button on the upper left corner of the table that shows up when the table is in focus. Clicking on it will select the entire table.'
    },
    cellBackground: {
        id: 'fabric.editor.cellBackground',
        defaultMessage: 'Cell background',
        description: 'Change the background color of a table cell.'
    },
    backgroundColor: {
        id: 'fabric.editor.backgroundColor',
        defaultMessage: 'Background color',
        description: 'Change the background color of a table cell.'
    },
    mergeCells: {
        id: 'fabric.editor.mergeCells',
        defaultMessage: 'Merge cells',
        description: 'The text is shown as a menu item in the cell options menu when the user selects multiple table cells to merge them into a single cell.'
    },
    splitCell: {
        id: 'fabric.editor.splitCell',
        defaultMessage: 'Split cell',
        description: 'The text is shown as a menu item in the cell options menu when the user wants to split a previously merged table cell back into individual cells.'
    },
    clearCells: {
        id: 'fabric.editor.clearCells',
        defaultMessage: 'Clear {0, plural, one {cell} other {cells}}',
        description: 'Clears the contents of the selected cells (this does not delete the cells themselves).'
    },
    sortColumnASC: {
        id: 'fabric.editor.sortColumnASC',
        defaultMessage: "Sort column A \u2192 Z",
        description: 'Sort column in ascending order'
    },
    sortColumnDESC: {
        id: 'fabric.editor.sortColumnDESC',
        defaultMessage: "Sort column Z \u2192 A",
        description: 'Sort column in descending order'
    },
    sortColumnIncreasing: {
        id: 'fabric.editor.sortColumnIncreasing',
        defaultMessage: 'Sort increasing',
        description: 'Sort column in ascending order'
    },
    sortColumnDecreasing: {
        id: 'fabric.editor.sortColumnDecreasing',
        defaultMessage: 'Sort decreasing',
        description: 'Sort column in descending order'
    },
    canNotSortTable: {
        id: 'fabric.editor.canNotSortTable',
        defaultMessage: "\u26A0\uFE0F You can't sort a table with merged cells",
        description: "Split your cells to enable this feature"
    },
    distributeColumns: {
        id: 'fabric.editor.distributeColumns',
        defaultMessage: "Distribute columns",
        description: "Distribute widths between selected columns"
    },
    lockColumnWidths: {
        id: 'fabric.editor.lockColumns',
        defaultMessage: 'Fixed column widths',
        description: 'Toggle button to enable fixed column widths'
    },
    rowControl: {
        id: 'fabric.editor.rowControl',
        defaultMessage: 'Highlight row',
        description: 'A button on the left of each row that shows up when the table is in focus. Clicking on it will select the entire row.'
    },
    rowDragHandle: {
        id: 'fabric.editor.rowDragHandle',
        defaultMessage: 'Row options',
        description: 'The row drag handle to move the row within the table. Click to open a menu for more row options.'
    },
    dragHandleZone: {
        id: 'fabric.editor.dragHandleZone',
        defaultMessage: 'Activate drag handle zone',
        description: 'The drag handle zone to trigger the drag handle to move the row/column within the table.'
    },
    columnDragHandle: {
        id: 'fabric.editor.columnDragHandle',
        defaultMessage: 'Column options',
        description: 'The column drag handle to move the column within the table. Click to open a menu for more column options.'
    },
    fullWidthLabel: {
        id: 'fabric.editor.tableFullWidthLabel',
        defaultMessage: 'Full-width',
        description: 'Trigger table width to full-width mode'
    },
    startedColumnResize: {
        id: 'fabric.editor.tables.startedColumnResize',
        defaultMessage: 'Started column resize',
        description: 'Screen Reader announces when the user engages the column resizer'
    },
    focusedOtherResize: {
        id: 'fabric.editor.tables.otherResize',
        defaultMessage: '{direction, select, left {Switched to the left column resize} right {Switched to the right column resize} other {}}',
        description: 'Screen Reader announces when the user switches to the left or right column resizer'
    },
    changedColumnWidth: {
        id: 'fabric.editor.tables.columnWidth',
        defaultMessage: '{width, plural, one {Column width was changed to {width} pixel} other {Column width was changed to {width} pixels}}',
        description: 'Screen Reader announces when the user modifies the column width'
    },
    columnResizeStop: {
        id: 'fabric.editor.tables.resizeStop',
        defaultMessage: 'Stopped resize',
        description: 'Screen Reader announces when the user discontinues the resizing operation'
    },
    columnResizeOverflow: {
        id: 'fabric.editor.tables.columnResizeOverflow',
        defaultMessage: 'You can only resize this column while the table has a scroll bar.',
        description: 'Screen Reader announces when the user attempts to resize the last column without the table being in overflow state'
    },
    columnResizeLast: {
        id: 'fabric.editor.tables.columnResizeLast',
        defaultMessage: 'You can only resize this column to the left.',
        description: 'Screen Reader announces when the user attempts to resize the last column when only the previous one is available for resizing'
    },
    tableAlignmentOptions: {
        id: 'fabric.editor.tableAlignmentOptions',
        defaultMessage: 'Alignment options',
        description: 'Opens a menu with additional table alignment options'
    },
    alignTableCenter: {
        id: 'fabric.editor.alignTableCenter',
        defaultMessage: 'Align center',
        description: 'The text is shown as a menu item in the table alignment options menu when the user wants to align the table to the center of the page.'
    },
    alignTableLeft: {
        id: 'fabric.editor.alignTableLeft',
        defaultMessage: 'Align left',
        description: 'The text is shown as a menu item in the table alignment options menu when the user wants to align the table to the left side of the page.'
    }
});

});


parcelRegister("kMHA5", function(module, exports) {
$parcel$export(module.exports, "mapBreakpointToLayoutMaxWidth", () => $f21a18a56af76a1e$export$b5ccf4d25d2c5af1);
$parcel$export(module.exports, "BaseTheme", () => $f21a18a56af76a1e$export$a1a213d350ca51ca);

var $5FkrB = parcelRequire("5FkrB");

var $rxpl9 = parcelRequire("rxpl9");

var $1LBcl = parcelRequire("1LBcl");

var $01HkO = parcelRequire("01HkO");
function $f21a18a56af76a1e$export$b5ccf4d25d2c5af1(breakpoint) {
    switch(breakpoint){
        case 'M':
        case 'L':
            return 760;
        default:
            return 680;
    }
}
function $f21a18a56af76a1e$export$3de34996b814f0f0(_ref) {
    var baseFontSize = _ref.baseFontSize, children = _ref.children;
    var memoizedTheme = (0, $5FkrB.useMemo)(function() {
        return {
            baseFontSize: baseFontSize || 14,
            layoutMaxWidth: (0, $1LBcl.akEditorDefaultLayoutWidth)
        };
    }, [
        baseFontSize
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $rxpl9.b), {
        theme: memoizedTheme
    }, children);
}
function $f21a18a56af76a1e$export$a1a213d350ca51ca(_ref2) {
    var children = _ref2.children, baseFontSize = _ref2.baseFontSize;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $01HkO.WidthConsumer), null, function(_ref3) {
        var breakpoint = _ref3.breakpoint;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement($f21a18a56af76a1e$export$3de34996b814f0f0, {
            breakpoint: breakpoint,
            baseFontSize: baseFontSize
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).Fragment, null, children));
    });
}

});

parcelRegister("7Lgzm", function(module, exports) {
$parcel$export(module.exports, "parsePx", () => $5a69c6835eee336b$export$b0eef8cd00b29d5c);
/**
 * Walks a DOM tree up to the provided `stopElement`, or if falsy before.
 * @param element
 * @param stopElement
 */ function $5a69c6835eee336b$export$df14aaf7a527ab0c(element, shouldStop) {
    var rootElement = element;
    while(rootElement && rootElement.parentElement && !shouldStop(rootElement))rootElement = rootElement.parentElement;
    return rootElement;
}
function $5a69c6835eee336b$export$debb760848ca95a(parent, wrapped) {
    var docsFragment = document.createDocumentFragment();
    Array.from(wrapped.children).forEach(function(child) {
        docsFragment.appendChild(child);
    });
    parent.replaceChild(docsFragment, wrapped);
}
function $5a69c6835eee336b$export$5b66dc78851adb5e(el) {
    while(el.parentElement && el.childElementCount === 0 && el.textContent === ''){
        var parentEl = el.parentElement;
        parentEl.removeChild(el);
        el = parentEl;
    }
}
var $5a69c6835eee336b$export$c8913a477cc44663 = function containsClassName(node, className) {
    if (!node) return false;
    if (node.classList && node.classList.contains) return node.classList.contains(className);
    if (!node.className) return false;
    var classNames = typeof node.className.baseVal === 'string' ? node.className.baseVal : node.className;
    return classNames.split(' ').indexOf(className) !== -1;
};
function $5a69c6835eee336b$export$ff7f7c97cdce86e(node, s) {
    if (!node) return null;
    var el = node;
    if (!document.documentElement || !document.documentElement.contains(el)) return null;
    if (el.closest) return el.closest(s);
    do {
        var matchfn = el.matches ? el.matches : el.msMatchesSelector;
        if (matchfn && matchfn.call(el, s)) // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        return el;
        el = el.parentElement || el.parentNode;
    }while (el !== null && el.nodeType === 1);
    return null;
}
function $5a69c6835eee336b$export$d508bcfb7f019487(node, s) {
    return $5a69c6835eee336b$export$ff7f7c97cdce86e(node, s);
}
function $5a69c6835eee336b$export$b0eef8cd00b29d5c(pxStr) {
    if (!pxStr.endsWith('px')) return undefined;
    var maybeNumber = parseInt(pxStr, 10);
    return !Number.isNaN(maybeNumber) ? maybeNumber : undefined;
}
function $5a69c6835eee336b$export$b2d5d4f1aeebddf1(elem, callback) {
    var array = [];
    for(var i = 0; i < elem.childElementCount; i++)array.push(callback(elem.children[i], i, elem));
    return array;
}
function $5a69c6835eee336b$export$5b6ab01a6efa50e2(elem, callback) {
    return $5a69c6835eee336b$export$b2d5d4f1aeebddf1(elem, callback);
}

});


parcelRegister("53SBn", function(module, exports) {
$parcel$export(module.exports, "RendererCssClassName", () => $3af7965b79b0b5e5$export$91f3bbbf974496e2);
/* eslint-disable @atlaskit/editor/no-re-export */ // Entry file in package.json
var $3af7965b79b0b5e5$var$clPrefix = 'ak-renderer-';
var $3af7965b79b0b5e5$export$91f3bbbf974496e2 = {
    DOCUMENT: "".concat($3af7965b79b0b5e5$var$clPrefix, "document"),
    EXTENSION: "".concat($3af7965b79b0b5e5$var$clPrefix, "extension"),
    EXTENSION_CENTER_ALIGN: "".concat($3af7965b79b0b5e5$var$clPrefix, "extension-center-align"),
    EXTENSION_OVERFLOW_CONTAINER: "".concat($3af7965b79b0b5e5$var$clPrefix, "extension-overflow-container"),
    NUMBER_COLUMN: "".concat($3af7965b79b0b5e5$var$clPrefix, "table-number-column"),
    SORTABLE_COLUMN_WRAPPER: "".concat($3af7965b79b0b5e5$var$clPrefix, "tableHeader-sortable-column__wrapper"),
    SORTABLE_COLUMN: "".concat($3af7965b79b0b5e5$var$clPrefix, "tableHeader-sortable-column"),
    SORTABLE_COLUMN_ICON_WRAPPER: "".concat($3af7965b79b0b5e5$var$clPrefix, "tableHeader-sorting-icon__wrapper"),
    SORTABLE_COLUMN_NO_ORDER: "".concat($3af7965b79b0b5e5$var$clPrefix, "tableHeader-sorting-icon__no-order")
};

});

parcelRegister("2TWiQ", function(module, exports) {
$parcel$export(module.exports, "calcBreakoutWidthCss", () => $21cdf1999293e34b$export$87eeb477611c8fe);
var $21cdf1999293e34b$export$87eeb477611c8fe = function calcBreakoutWidthCss(layout) {
    if (layout === 'full-width') return 'min(var(--ak-editor--breakout-container-without-gutter-width), var(--ak-editor--full-width-layout-width))';
    if (layout === 'wide') return 'min(var(--ak-editor--breakout-container-without-gutter-width), var(--ak-editor--breakout-wide-layout-width))';
    return '100%';
};

});


parcelRegister("enqEB", function(module, exports) {
$parcel$export(module.exports, "ErrorBoundary", () => $a777e3904fb2911a$export$e926676385687eaf);

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $kIXpt = parcelRequire("kIXpt");

var $cYPzS = parcelRequire("cYPzS");

var $eyuDe = parcelRequire("eyuDe");

var $25nEq = parcelRequire("25nEq");

var $5FkrB = parcelRequire("5FkrB");

var $jJH6F = parcelRequire("jJH6F");

var $2H1dZ = parcelRequire("2H1dZ");

var $7bmOa = parcelRequire("7bmOa");

var $aP6HU = parcelRequire("aP6HU");

var $6JfQX = parcelRequire("6JfQX");
function $a777e3904fb2911a$var$_callSuper(t, o, e) {
    return o = (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(o), (0, (/*@__PURE__*/$parcel$interopDefault($kIXpt)))(t, $a777e3904fb2911a$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(t).constructor) : o.apply(t, e));
}
function $a777e3904fb2911a$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($a777e3904fb2911a$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $a777e3904fb2911a$export$e926676385687eaf = /*#__PURE__*/ function(_React$Component) {
    function ErrorBoundary() {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, ErrorBoundary);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = $a777e3904fb2911a$var$_callSuper(this, ErrorBoundary, [].concat(args));
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "state", {
            errorCaptured: false,
            domError: false
        });
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($eyuDe)))(ErrorBoundary, _React$Component);
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(ErrorBoundary, [
        {
            key: "fireAnalyticsEvent",
            value: function fireAnalyticsEvent(event) {
                var createAnalyticsEvent = this.props.createAnalyticsEvent;
                if (createAnalyticsEvent) {
                    var channel = (0, $2H1dZ.FabricChannel).editor;
                    createAnalyticsEvent(event).fire(channel);
                }
            }
        },
        {
            key: "hasFallback",
            value: function hasFallback() {
                return typeof this.props.fallbackComponent !== 'undefined';
            }
        },
        {
            key: "shouldRecover",
            value: function shouldRecover() {
                return this.hasFallback() && this.state.errorCaptured;
            }
        },
        {
            key: "componentDidCatch",
            value: function componentDidCatch(error, errorInfo) {
                var _this$props$additiona, _this2 = this;
                var additionalInfo = (_this$props$additiona = this.props.additionalInfo) !== null && _this$props$additiona !== void 0 ? _this$props$additiona : '';
                this.fireAnalyticsEvent({
                    action: (0, $jJH6F.ACTION).CRASHED,
                    actionSubject: this.props.component,
                    actionSubjectId: this.props.componentId,
                    eventType: (0, $jJH6F.EVENT_TYPE).OPERATIONAL,
                    attributes: {
                        platform: (0, $aP6HU.PLATFORM).WEB,
                        errorMessage: "".concat(additionalInfo).concat(error === null || error === void 0 ? void 0 : error.message),
                        componentStack: (errorInfo === null || errorInfo === void 0 ? void 0 : errorInfo.componentStack) || undefined,
                        errorRethrown: Boolean(this.props.rethrowError)
                    }
                });
                (0, $7bmOa.logException)(error, {
                    location: 'renderer'
                });
                // Ignored via go/ees005
                // eslint-disable-next-line require-unicode-regexp
                var pattern = /Failed to execute.*on 'Node'.*/;
                var matchesPattern = pattern.test(error.message);
                if (matchesPattern) {
                    this.fireAnalyticsEvent({
                        action: (0, $jJH6F.ACTION).CAUGHT_DOM_ERROR,
                        actionSubject: this.props.component,
                        actionSubjectId: this.props.componentId,
                        eventType: (0, $jJH6F.EVENT_TYPE).OPERATIONAL,
                        attributes: {
                            platform: (0, $aP6HU.PLATFORM).WEB,
                            errorMessage: "".concat(additionalInfo).concat(error === null || error === void 0 ? void 0 : error.message)
                        }
                    });
                    this.setState(function() {
                        return {
                            domError: true
                        };
                    });
                }
                if (this.hasFallback()) this.setState({
                    errorCaptured: true
                }, function() {
                    if (_this2.props.rethrowError) throw error;
                });
            }
        },
        {
            key: "render",
            value: function render() {
                if (this.state.domError) // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).Fragment, {
                    key: (0, $6JfQX.default)()
                }, this.props.children);
                if (this.shouldRecover()) return this.props.fallbackComponent;
                return this.props.children;
            }
        }
    ]);
}((0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).Component);

});
parcelRegister("2H1dZ", function(module, exports) {
$parcel$export(module.exports, "FabricChannel", () => $1f608c18fcd157a0$export$8faa0b115ef0268b);
var $1f608c18fcd157a0$export$8faa0b115ef0268b = /*#__PURE__*/ function(FabricChannel) {
    FabricChannel["atlaskit"] = "atlaskit";
    FabricChannel["elements"] = "fabric-elements";
    FabricChannel["navigation"] = "navigation";
    FabricChannel["editor"] = "editor";
    FabricChannel["media"] = "media";
    FabricChannel["peopleTeams"] = "peopleTeams";
    FabricChannel["notifications"] = "notifications";
    FabricChannel["recentWork"] = "recentWork";
    FabricChannel["atlas"] = "atlas";
    FabricChannel["crossFlow"] = "crossFlow";
    FabricChannel["linkingPlatform"] = "linkingPlatform";
    FabricChannel["postOffice"] = "postOffice";
    FabricChannel["aiMate"] = "aiMate";
    FabricChannel["avp"] = "avp";
    FabricChannel["growth"] = "growth";
    FabricChannel["omniChannel"] = "omniChannel";
    FabricChannel["townsquareHome"] = "townsquareHome";
    return FabricChannel;
}({});

});

parcelRegister("7bmOa", function(module, exports) {
$parcel$export(module.exports, "logException", () => $53ab40b2cd5b21c2$export$f86b2a1a2ce291b3);

var $25nEq = parcelRequire("25nEq");

var $fC8ib = parcelRequire("fC8ib");

var $fL8KA = parcelRequire("fL8KA");

var $6HG4S = parcelRequire("6HG4S");

var $7RT42 = parcelRequire("7RT42");

var $9Zzpd = parcelRequire("9Zzpd");

var $74GWP = parcelRequire("74GWP");

var $e6MoK = parcelRequire("e6MoK");
function $53ab40b2cd5b21c2$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $53ab40b2cd5b21c2$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $53ab40b2cd5b21c2$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $53ab40b2cd5b21c2$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $53ab40b2cd5b21c2$var$SENTRY_DSN = 'https://0b10c8e02fb44d8796c047b102c9bee8@o55978.ingest.sentry.io/4505129224110080';
var $53ab40b2cd5b21c2$var$packageName = 'editor-common'; // Sentry doesn't accept '/' in its releases https://docs.sentry.io/platforms/javascript/configuration/releases/
var $53ab40b2cd5b21c2$var$packageVersion = "112.18.8";
var $53ab40b2cd5b21c2$var$sanitiseSentryEvents = function sanitiseSentryEvents(data, _hint) {
    // Remove URL as it has UGC
    // Ignored via go/ees007
    // eslint-disable-next-line @atlaskit/editor/enforce-todo-comment-format
    // TODO: Sanitise the URL instead of just removing it
    if (data.request) delete data.request.url;
    return data;
};


var $53ab40b2cd5b21c2$export$f86b2a1a2ce291b3 = /*#__PURE__*/ function() {
    var _ref = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee(error, tags) {
        var _process$env$CLOUD_EN, _yield$import, BrowserClient, defaultIntegrations, getCurrentHub, _yield$import2, ExtraErrorData, breadcrumbsIntegration, sentryOptions, client, hub;
        return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee$(_context) {
            while(true)switch(_context.prev = _context.next){
                case 0:
                    _context.prev = 0;
                    _context.next = 3;
                    break;
                    return _context.abrupt("return");
                case 3:
                    _context.next = 5;
                    return Promise.resolve((parcelRequire("7RT42")));
                case 5:
                    _yield$import = _context.sent;
                    BrowserClient = _yield$import.BrowserClient;
                    defaultIntegrations = _yield$import.defaultIntegrations;
                    getCurrentHub = _yield$import.getCurrentHub;
                    _context.next = 11;
                    return (parcelRequire("jYDPM"));
                case 11:
                    _yield$import2 = _context.sent;
                    ExtraErrorData = _yield$import2.ExtraErrorData;
                    breadcrumbsIntegration = (0, $9Zzpd.fg)('platform_editor_sentry_breadcrumbs') ? new (0, $7RT42.Integrations).Breadcrumbs({
                        // only enable breadcrumbs for dom (UI clicks and inputs)
                        // include 'data-test-id', 'data-testid' in the breadcrumbs if they are found
                        dom: {
                            serializeAttribute: (0, $e6MoK.SERIALIZABLE_ATTRIBUTES)
                        },
                        fetch: false,
                        xhr: false,
                        console: false,
                        history: false,
                        sentry: false
                    }) : undefined;
                    sentryOptions = {
                        dsn: (0, $74GWP.isFedRamp)() ? undefined : $53ab40b2cd5b21c2$var$SENTRY_DSN,
                        release: "".concat($53ab40b2cd5b21c2$var$packageName, "@").concat($53ab40b2cd5b21c2$var$packageVersion),
                        environment: (_process$env$CLOUD_EN = undefined, _process$env$CLOUD_EN !== void 0) ? _process$env$CLOUD_EN : 'unknown',
                        beforeBreadcrumb: (0, $9Zzpd.fg)('platform_editor_sentry_breadcrumbs') ? (0, $e6MoK.normaliseSentryBreadcrumbs) : undefined,
                        ignoreErrors: [
                            // Network issues
                            // Ignored via go/ees005
                            // eslint-disable-next-line require-unicode-regexp
                            /^network error/i,
                            // Ignored via go/ees005
                            // eslint-disable-next-line require-unicode-regexp
                            /^network failure/i,
                            'TypeError: Failed to fetch',
                            // A benign error, see https://stackoverflow.com/a/50387233/2645305
                            'ResizeObserver loop limit exceeded',
                            // Ignored via go/ees005
                            // eslint-disable-next-line require-unicode-regexp
                            /ResizeObserver loop completed with undelivered notifications/
                        ],
                        autoSessionTracking: false,
                        integrations: function integrations(_integrations) {
                            return [].concat((0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(defaultIntegrations.filter(function(_ref2) {
                                var name = _ref2.name;
                                return name !== 'Breadcrumbs';
                            })), (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(breadcrumbsIntegration ? [
                                breadcrumbsIntegration
                            ] : []), [
                                // Extracts all non-native attributes from the error object and attaches them to the event as the extra data
                                // https://docs.sentry.io/platforms/javascript/configuration/integrations/plugin/?original_referrer=https%3A%2F%2Fduckduckgo.com%2F#extraerrordata
                                new ExtraErrorData()
                            ]);
                        },
                        beforeSend: $53ab40b2cd5b21c2$var$sanitiseSentryEvents
                    }; // Use a client to avoid picking up the errors from parent applications
                    client = new BrowserClient(sentryOptions);
                    hub = getCurrentHub(); // @ts-ignore - TypeScript 5.9.2 upgrade
                    hub.bindClient(client);
                    hub.withScope(function(scope) {
                        var _buildInfo;
                        scope.setTags($53ab40b2cd5b21c2$var$_objectSpread({
                            // Jira environment variables
                            // Ignored via go/ees005
                            // eslint-disable-next-line @typescript-eslint/no-explicit-any
                            'jira-bundler': window.BUNDLER_VERSION,
                            // Ignored via go/ees005
                            // eslint-disable-next-line @typescript-eslint/no-explicit-any
                            'jira-variant': window.BUILD_VARIANT,
                            // Ignored via go/ees005
                            // eslint-disable-next-line @typescript-eslint/no-explicit-any
                            'jira-release': window.BUILD_KEY,
                            // Confluence environment variables
                            // Ignored via go/ees005
                            // eslint-disable-next-line @typescript-eslint/no-explicit-any
                            'confluence-frontend-version': (_buildInfo = window.__buildInfo) === null || _buildInfo === void 0 ? void 0 : _buildInfo.FRONTEND_VERSION
                        }, tags));
                        // Explicitly remove the breadcrumbs as it's too likely to log UGC/PII to side-step the hub integrations not being respected
                        scope.clearBreadcrumbs();
                        hub.captureException(error);
                    });
                    // @ts-ignore - TypeScript 5.9.2 upgrade
                    return _context.abrupt("return", client.close());
                case 22:
                    _context.prev = 22;
                    _context.t0 = _context["catch"](0);
                case 24:
                case "end":
                    return _context.stop();
            }
        }, _callee, null, [
            [
                0,
                22
            ]
        ]);
    }));
    return function logException(_x, _x2) {
        return _ref.apply(this, arguments);
    };
}();

});
parcelRegister("7RT42", function(module, exports) {
$parcel$export(module.exports, "Integrations", () => $5ba83237ec7091f5$export$99d02219d259eb94);
$parcel$export(module.exports, "Transports", () => (parcelRequire("e3MRU")));

var $iTWOe = parcelRequire("iTWOe");

var $1hL7y = parcelRequire("1hL7y");

var $2zF9F = parcelRequire("2zF9F");
parcelRequire("i0afJ");
var $lrp9R = parcelRequire("lrp9R");

var $g55ns = parcelRequire("g55ns");

var $e3MRU = parcelRequire("e3MRU");
var $5ba83237ec7091f5$var$windowIntegrations = {};
// This block is needed to add compatibility with the integrations packages when used with a CDN
var $5ba83237ec7091f5$var$_window = (0, $lrp9R.getGlobalObject)();
if ($5ba83237ec7091f5$var$_window.Sentry && $5ba83237ec7091f5$var$_window.Sentry.Integrations) $5ba83237ec7091f5$var$windowIntegrations = $5ba83237ec7091f5$var$_window.Sentry.Integrations;
var $5ba83237ec7091f5$export$99d02219d259eb94 = (0, $iTWOe.__assign)((0, $iTWOe.__assign)((0, $iTWOe.__assign)({}, $5ba83237ec7091f5$var$windowIntegrations), (0, $2zF9F)), $g55ns);
$parcel$exportWildcard(module.exports, $1hL7y);

});
parcelRegister("iTWOe", function(module, exports) {
$parcel$export(module.exports, "__extends", () => $dc2afb5696871518$export$a8ba968b8961cb8a);
$parcel$export(module.exports, "__assign", () => $dc2afb5696871518$export$18ce0697a983be9b);
$parcel$export(module.exports, "__values", () => $dc2afb5696871518$export$19a8beecd37a4c45);
$parcel$export(module.exports, "__read", () => $dc2afb5696871518$export$8d051b38c9118094);
$parcel$export(module.exports, "__spread", () => $dc2afb5696871518$export$afc72e2116322959);
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var $dc2afb5696871518$var$extendStatics = function(d, b) {
    $dc2afb5696871518$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return $dc2afb5696871518$var$extendStatics(d, b);
};
function $dc2afb5696871518$export$a8ba968b8961cb8a(d, b) {
    $dc2afb5696871518$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $dc2afb5696871518$export$18ce0697a983be9b = function() {
    $dc2afb5696871518$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $dc2afb5696871518$export$18ce0697a983be9b.apply(this, arguments);
};
function $dc2afb5696871518$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $dc2afb5696871518$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $dc2afb5696871518$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $dc2afb5696871518$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $dc2afb5696871518$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $dc2afb5696871518$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function $dc2afb5696871518$export$45d3717a4c69092e(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function $dc2afb5696871518$export$f33643c0debef087(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function $dc2afb5696871518$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $dc2afb5696871518$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $dc2afb5696871518$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($dc2afb5696871518$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $dc2afb5696871518$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $dc2afb5696871518$export$10c90e4f7922046c(v) {
    return this instanceof $dc2afb5696871518$export$10c90e4f7922046c ? (this.v = v, this) : new $dc2afb5696871518$export$10c90e4f7922046c(v);
}
function $dc2afb5696871518$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $dc2afb5696871518$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $dc2afb5696871518$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $dc2afb5696871518$export$10c90e4f7922046c(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function $dc2afb5696871518$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $dc2afb5696871518$export$19a8beecd37a4c45 === "function" ? $dc2afb5696871518$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $dc2afb5696871518$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function $dc2afb5696871518$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function $dc2afb5696871518$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $dc2afb5696871518$export$d5dcaf168c640c35(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function $dc2afb5696871518$export$d40a35129aaff81f(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}

});

parcelRegister("1hL7y", function(module, exports) {
$parcel$export(module.exports, "Severity", () => (parcelRequire("iYYET")).Severity);
$parcel$export(module.exports, "addGlobalEventProcessor", () => (parcelRequire("FnrKW")).addGlobalEventProcessor);
$parcel$export(module.exports, "addBreadcrumb", () => (parcelRequire("kD78n")).addBreadcrumb);
$parcel$export(module.exports, "captureException", () => (parcelRequire("kD78n")).captureException);
$parcel$export(module.exports, "captureEvent", () => (parcelRequire("kD78n")).captureEvent);
$parcel$export(module.exports, "captureMessage", () => (parcelRequire("kD78n")).captureMessage);
$parcel$export(module.exports, "configureScope", () => (parcelRequire("kD78n")).configureScope);
$parcel$export(module.exports, "getHubFromCarrier", () => (parcelRequire("ir14T")).getHubFromCarrier);
$parcel$export(module.exports, "getCurrentHub", () => (parcelRequire("ir14T")).getCurrentHub);
$parcel$export(module.exports, "Hub", () => (parcelRequire("ir14T")).Hub);
$parcel$export(module.exports, "makeMain", () => (parcelRequire("ir14T")).makeMain);
$parcel$export(module.exports, "Scope", () => (parcelRequire("FnrKW")).Scope);
$parcel$export(module.exports, "Session", () => (parcelRequire("vfED8")).Session);
$parcel$export(module.exports, "startTransaction", () => (parcelRequire("kD78n")).startTransaction);
$parcel$export(module.exports, "SDK_VERSION", () => (parcelRequire("egk2u")).SDK_VERSION);
$parcel$export(module.exports, "setContext", () => (parcelRequire("kD78n")).setContext);
$parcel$export(module.exports, "setExtra", () => (parcelRequire("kD78n")).setExtra);
$parcel$export(module.exports, "setExtras", () => (parcelRequire("kD78n")).setExtras);
$parcel$export(module.exports, "setTag", () => (parcelRequire("kD78n")).setTag);
$parcel$export(module.exports, "setTags", () => (parcelRequire("kD78n")).setTags);
$parcel$export(module.exports, "setUser", () => (parcelRequire("kD78n")).setUser);
$parcel$export(module.exports, "withScope", () => (parcelRequire("kD78n")).withScope);
$parcel$export(module.exports, "BrowserClient", () => (parcelRequire("7bmvO")).BrowserClient);
$parcel$export(module.exports, "injectReportDialog", () => (parcelRequire("iuPyo")).injectReportDialog);
$parcel$export(module.exports, "eventFromException", () => (parcelRequire("QEOc2")).eventFromException);
$parcel$export(module.exports, "eventFromMessage", () => (parcelRequire("QEOc2")).eventFromMessage);
$parcel$export(module.exports, "defaultIntegrations", () => (parcelRequire("5R1Wi")).defaultIntegrations);
$parcel$export(module.exports, "forceLoad", () => (parcelRequire("5R1Wi")).forceLoad);
$parcel$export(module.exports, "init", () => (parcelRequire("5R1Wi")).init);
$parcel$export(module.exports, "lastEventId", () => (parcelRequire("5R1Wi")).lastEventId);
$parcel$export(module.exports, "onLoad", () => (parcelRequire("5R1Wi")).onLoad);
$parcel$export(module.exports, "showReportDialog", () => (parcelRequire("5R1Wi")).showReportDialog);
$parcel$export(module.exports, "flush", () => (parcelRequire("5R1Wi")).flush);
$parcel$export(module.exports, "close", () => (parcelRequire("5R1Wi")).close);
$parcel$export(module.exports, "wrap", () => (parcelRequire("5R1Wi")).wrap);
$parcel$export(module.exports, "SDK_NAME", () => (parcelRequire("7sZPK")).SDK_NAME);

var $iYYET = parcelRequire("iYYET");

var $kD78n = parcelRequire("kD78n");
var $FnrKW = parcelRequire("FnrKW");
var $ir14T = parcelRequire("ir14T");
var $egk2u = parcelRequire("egk2u");
var $vfED8 = parcelRequire("vfED8");

var $7bmvO = parcelRequire("7bmvO");

var $iuPyo = parcelRequire("iuPyo");

var $QEOc2 = parcelRequire("QEOc2");

var $5R1Wi = parcelRequire("5R1Wi");

var $7sZPK = parcelRequire("7sZPK");

});
parcelRegister("iYYET", function(module, exports) {
$parcel$export(module.exports, "Severity", () => $dd1ce21d7a983db9$export$918a9776c0a3cf27);
/**
 * TODO(v7): Remove this enum and replace with SeverityLevel
 */ var $dd1ce21d7a983db9$export$918a9776c0a3cf27;
(function(Severity) {
    /** JSDoc */ Severity["Fatal"] = "fatal";
    /** JSDoc */ Severity["Error"] = "error";
    /** JSDoc */ Severity["Warning"] = "warning";
    /** JSDoc */ Severity["Log"] = "log";
    /** JSDoc */ Severity["Info"] = "info";
    /** JSDoc */ Severity["Debug"] = "debug";
    /** JSDoc */ Severity["Critical"] = "critical";
})($dd1ce21d7a983db9$export$918a9776c0a3cf27 || ($dd1ce21d7a983db9$export$918a9776c0a3cf27 = {}));
var $dd1ce21d7a983db9$export$484b1ea9aec914c = [
    'fatal',
    'error',
    'warning',
    'log',
    'info',
    'debug',
    'critical'
];

});

parcelRegister("kD78n", function(module, exports) {
$parcel$export(module.exports, "captureException", () => $f04cfbdc3f8db658$export$f5282963edea4a68);
$parcel$export(module.exports, "captureMessage", () => $f04cfbdc3f8db658$export$45654777c133ae80);
$parcel$export(module.exports, "captureEvent", () => $f04cfbdc3f8db658$export$1462b974fdcf6ba2);
$parcel$export(module.exports, "configureScope", () => $f04cfbdc3f8db658$export$99d44f04437e9cb8);
$parcel$export(module.exports, "addBreadcrumb", () => $f04cfbdc3f8db658$export$efda9a273d7a036d);
$parcel$export(module.exports, "setContext", () => $f04cfbdc3f8db658$export$2f04de43fe27971a);
$parcel$export(module.exports, "setExtras", () => $f04cfbdc3f8db658$export$bb4922da0dd51b92);
$parcel$export(module.exports, "setTags", () => $f04cfbdc3f8db658$export$74a8fb34822092e6);
$parcel$export(module.exports, "setExtra", () => $f04cfbdc3f8db658$export$8e8e7789d42ed61d);
$parcel$export(module.exports, "setTag", () => $f04cfbdc3f8db658$export$a37d07ee78eb4569);
$parcel$export(module.exports, "setUser", () => $f04cfbdc3f8db658$export$8b6bb3dd62a01be2);
$parcel$export(module.exports, "withScope", () => $f04cfbdc3f8db658$export$ec58d9285c204497);
$parcel$export(module.exports, "startTransaction", () => $f04cfbdc3f8db658$export$e262da7ae6480481);

var $jxXLe = parcelRequire("jxXLe");

var $ir14T = parcelRequire("ir14T");
/**
 * This calls a function on the current hub.
 * @param method function to call on hub.
 * @param args to pass to function.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $f04cfbdc3f8db658$var$callOnHub(method) {
    var args = [];
    for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
    var hub = (0, $ir14T.getCurrentHub)();
    if (hub && hub[method]) // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return hub[method].apply(hub, (0, $jxXLe.__spread)(args));
    throw new Error("No hub defined or " + method + " was not found on the hub, please open a bug report.");
}
function $f04cfbdc3f8db658$export$f5282963edea4a68(exception, captureContext) {
    var syntheticException = new Error('Sentry syntheticException');
    return $f04cfbdc3f8db658$var$callOnHub('captureException', exception, {
        captureContext: captureContext,
        originalException: exception,
        syntheticException: syntheticException
    });
}
function $f04cfbdc3f8db658$export$45654777c133ae80(message, captureContext) {
    var syntheticException = new Error(message);
    // This is necessary to provide explicit scopes upgrade, without changing the original
    // arity of the `captureMessage(message, level)` method.
    var level = typeof captureContext === 'string' ? captureContext : undefined;
    var context = typeof captureContext !== 'string' ? {
        captureContext: captureContext
    } : undefined;
    return $f04cfbdc3f8db658$var$callOnHub('captureMessage', message, level, (0, $jxXLe.__assign)({
        originalException: message,
        syntheticException: syntheticException
    }, context));
}
function $f04cfbdc3f8db658$export$1462b974fdcf6ba2(event) {
    return $f04cfbdc3f8db658$var$callOnHub('captureEvent', event);
}
function $f04cfbdc3f8db658$export$99d44f04437e9cb8(callback) {
    $f04cfbdc3f8db658$var$callOnHub('configureScope', callback);
}
function $f04cfbdc3f8db658$export$efda9a273d7a036d(breadcrumb) {
    $f04cfbdc3f8db658$var$callOnHub('addBreadcrumb', breadcrumb);
}
function $f04cfbdc3f8db658$export$2f04de43fe27971a(name, context) {
    $f04cfbdc3f8db658$var$callOnHub('setContext', name, context);
}
function $f04cfbdc3f8db658$export$bb4922da0dd51b92(extras) {
    $f04cfbdc3f8db658$var$callOnHub('setExtras', extras);
}
function $f04cfbdc3f8db658$export$74a8fb34822092e6(tags) {
    $f04cfbdc3f8db658$var$callOnHub('setTags', tags);
}
function $f04cfbdc3f8db658$export$8e8e7789d42ed61d(key, extra) {
    $f04cfbdc3f8db658$var$callOnHub('setExtra', key, extra);
}
function $f04cfbdc3f8db658$export$a37d07ee78eb4569(key, value) {
    $f04cfbdc3f8db658$var$callOnHub('setTag', key, value);
}
function $f04cfbdc3f8db658$export$8b6bb3dd62a01be2(user) {
    $f04cfbdc3f8db658$var$callOnHub('setUser', user);
}
function $f04cfbdc3f8db658$export$ec58d9285c204497(callback) {
    $f04cfbdc3f8db658$var$callOnHub('withScope', callback);
}
function $f04cfbdc3f8db658$export$5b9bc6fc91daaf9f(method) {
    var args = [];
    for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
    $f04cfbdc3f8db658$var$callOnHub.apply(void 0, (0, $jxXLe.__spread)([
        '_invokeClient',
        method
    ], args));
}
function $f04cfbdc3f8db658$export$e262da7ae6480481(context, customSamplingContext) {
    return $f04cfbdc3f8db658$var$callOnHub('startTransaction', (0, $jxXLe.__assign)({}, context), customSamplingContext);
}

});
parcelRegister("jxXLe", function(module, exports) {
$parcel$export(module.exports, "__assign", () => $e3af749fec978079$export$18ce0697a983be9b);
$parcel$export(module.exports, "__spread", () => $e3af749fec978079$export$afc72e2116322959);
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var $e3af749fec978079$var$extendStatics = function(d, b) {
    $e3af749fec978079$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return $e3af749fec978079$var$extendStatics(d, b);
};
function $e3af749fec978079$export$a8ba968b8961cb8a(d, b) {
    $e3af749fec978079$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $e3af749fec978079$export$18ce0697a983be9b = function() {
    $e3af749fec978079$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $e3af749fec978079$export$18ce0697a983be9b.apply(this, arguments);
};
function $e3af749fec978079$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $e3af749fec978079$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $e3af749fec978079$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $e3af749fec978079$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $e3af749fec978079$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $e3af749fec978079$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function $e3af749fec978079$export$45d3717a4c69092e(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function $e3af749fec978079$export$f33643c0debef087(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function $e3af749fec978079$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $e3af749fec978079$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $e3af749fec978079$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($e3af749fec978079$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $e3af749fec978079$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $e3af749fec978079$export$10c90e4f7922046c(v) {
    return this instanceof $e3af749fec978079$export$10c90e4f7922046c ? (this.v = v, this) : new $e3af749fec978079$export$10c90e4f7922046c(v);
}
function $e3af749fec978079$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $e3af749fec978079$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $e3af749fec978079$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $e3af749fec978079$export$10c90e4f7922046c(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function $e3af749fec978079$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $e3af749fec978079$export$19a8beecd37a4c45 === "function" ? $e3af749fec978079$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $e3af749fec978079$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function $e3af749fec978079$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function $e3af749fec978079$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $e3af749fec978079$export$d5dcaf168c640c35(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function $e3af749fec978079$export$d40a35129aaff81f(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}

});

parcelRegister("ir14T", function(module, exports) {
$parcel$export(module.exports, "Hub", () => $d6bb95a59bff69df$export$8c41bb232f1008b1);
$parcel$export(module.exports, "makeMain", () => $d6bb95a59bff69df$export$4188a14ad302d1bc);
$parcel$export(module.exports, "getHubFromCarrier", () => $d6bb95a59bff69df$export$bfa8a924a84a76b7);
$parcel$export(module.exports, "getCurrentHub", () => $d6bb95a59bff69df$export$a07cdf6544bbd7c);

var $fClYD = parcelRequire("fClYD");
parcelRequire("i0afJ");
var $1v4ZC = parcelRequire("1v4ZC");
var $chTsM = parcelRequire("chTsM");
var $lrp9R = parcelRequire("lrp9R");
var $dBSRM = parcelRequire("dBSRM");
var $73JtC = parcelRequire("73JtC");

var $dzx2d = parcelRequire("dzx2d");

var $FnrKW = parcelRequire("FnrKW");

var $vfED8 = parcelRequire("vfED8");
var $d6bb95a59bff69df$export$24a86ef7798177e4 = 4;
/**
 * Default maximum number of breadcrumbs added to an event. Can be overwritten
 * with {@link Options.maxBreadcrumbs}.
 */ var $d6bb95a59bff69df$var$DEFAULT_BREADCRUMBS = 100;
/**
 * @inheritDoc
 */ var $d6bb95a59bff69df$export$8c41bb232f1008b1 = /** @class */ function() {
    /**
     * Creates a new instance of the hub, will push one {@link Layer} into the
     * internal stack on creation.
     *
     * @param client bound to the hub.
     * @param scope bound to the hub.
     * @param version number, higher number means higher priority.
     */ function Hub(client, scope, _version) {
        if (scope === void 0) scope = new (0, $FnrKW.Scope)();
        if (_version === void 0) _version = $d6bb95a59bff69df$export$24a86ef7798177e4;
        this._version = _version;
        /** Is a {@link Layer}[] containing the client and scope */ this._stack = [
            {}
        ];
        this.getStackTop().scope = scope;
        if (client) this.bindClient(client);
    }
    /**
     * @inheritDoc
     */ Hub.prototype.isOlderThan = function(version) {
        return this._version < version;
    };
    /**
     * @inheritDoc
     */ Hub.prototype.bindClient = function(client) {
        var top = this.getStackTop();
        top.client = client;
        if (client && client.setupIntegrations) client.setupIntegrations();
    };
    /**
     * @inheritDoc
     */ Hub.prototype.pushScope = function() {
        // We want to clone the content of prev scope
        var scope = (0, $FnrKW.Scope).clone(this.getScope());
        this.getStack().push({
            client: this.getClient(),
            scope: scope
        });
        return scope;
    };
    /**
     * @inheritDoc
     */ Hub.prototype.popScope = function() {
        if (this.getStack().length <= 1) return false;
        return !!this.getStack().pop();
    };
    /**
     * @inheritDoc
     */ Hub.prototype.withScope = function(callback) {
        var scope = this.pushScope();
        try {
            callback(scope);
        } finally{
            this.popScope();
        }
    };
    /**
     * @inheritDoc
     */ Hub.prototype.getClient = function() {
        return this.getStackTop().client;
    };
    /** Returns the scope of the top stack. */ Hub.prototype.getScope = function() {
        return this.getStackTop().scope;
    };
    /** Returns the scope stack for domains or the process. */ Hub.prototype.getStack = function() {
        return this._stack;
    };
    /** Returns the topmost scope layer in the order domain > local > process. */ Hub.prototype.getStackTop = function() {
        return this._stack[this._stack.length - 1];
    };
    /**
     * @inheritDoc
     */ // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
    Hub.prototype.captureException = function(exception, hint) {
        var eventId = this._lastEventId = hint && hint.event_id ? hint.event_id : (0, $73JtC.uuid4)();
        var finalHint = hint;
        // If there's no explicit hint provided, mimic the same thing that would happen
        // in the minimal itself to create a consistent behavior.
        // We don't do this in the client, as it's the lowest level API, and doing this,
        // would prevent user from having full control over direct calls.
        if (!hint) {
            var syntheticException = void 0;
            try {
                throw new Error('Sentry syntheticException');
            } catch (exception) {
                syntheticException = exception;
            }
            finalHint = {
                originalException: exception,
                syntheticException: syntheticException
            };
        }
        this._invokeClient('captureException', exception, (0, $fClYD.__assign)((0, $fClYD.__assign)({}, finalHint), {
            event_id: eventId
        }));
        return eventId;
    };
    /**
     * @inheritDoc
     */ Hub.prototype.captureMessage = function(message, level, hint) {
        var eventId = this._lastEventId = hint && hint.event_id ? hint.event_id : (0, $73JtC.uuid4)();
        var finalHint = hint;
        // If there's no explicit hint provided, mimic the same thing that would happen
        // in the minimal itself to create a consistent behavior.
        // We don't do this in the client, as it's the lowest level API, and doing this,
        // would prevent user from having full control over direct calls.
        if (!hint) {
            var syntheticException = void 0;
            try {
                throw new Error(message);
            } catch (exception) {
                syntheticException = exception;
            }
            finalHint = {
                originalException: message,
                syntheticException: syntheticException
            };
        }
        this._invokeClient('captureMessage', message, level, (0, $fClYD.__assign)((0, $fClYD.__assign)({}, finalHint), {
            event_id: eventId
        }));
        return eventId;
    };
    /**
     * @inheritDoc
     */ Hub.prototype.captureEvent = function(event, hint) {
        var eventId = hint && hint.event_id ? hint.event_id : (0, $73JtC.uuid4)();
        if (event.type !== 'transaction') this._lastEventId = eventId;
        this._invokeClient('captureEvent', event, (0, $fClYD.__assign)((0, $fClYD.__assign)({}, hint), {
            event_id: eventId
        }));
        return eventId;
    };
    /**
     * @inheritDoc
     */ Hub.prototype.lastEventId = function() {
        return this._lastEventId;
    };
    /**
     * @inheritDoc
     */ Hub.prototype.addBreadcrumb = function(breadcrumb, hint) {
        var _a = this.getStackTop(), scope = _a.scope, client = _a.client;
        if (!scope || !client) return;
        // eslint-disable-next-line @typescript-eslint/unbound-method
        var _b = client.getOptions && client.getOptions() || {}, _c = _b.beforeBreadcrumb, beforeBreadcrumb = _c === void 0 ? null : _c, _d = _b.maxBreadcrumbs, maxBreadcrumbs = _d === void 0 ? $d6bb95a59bff69df$var$DEFAULT_BREADCRUMBS : _d;
        if (maxBreadcrumbs <= 0) return;
        var timestamp = (0, $chTsM.dateTimestampInSeconds)();
        var mergedBreadcrumb = (0, $fClYD.__assign)({
            timestamp: timestamp
        }, breadcrumb);
        var finalBreadcrumb = beforeBreadcrumb ? (0, $1v4ZC.consoleSandbox)(function() {
            return beforeBreadcrumb(mergedBreadcrumb, hint);
        }) : mergedBreadcrumb;
        if (finalBreadcrumb === null) return;
        scope.addBreadcrumb(finalBreadcrumb, maxBreadcrumbs);
    };
    /**
     * @inheritDoc
     */ Hub.prototype.setUser = function(user) {
        var scope = this.getScope();
        if (scope) scope.setUser(user);
    };
    /**
     * @inheritDoc
     */ Hub.prototype.setTags = function(tags) {
        var scope = this.getScope();
        if (scope) scope.setTags(tags);
    };
    /**
     * @inheritDoc
     */ Hub.prototype.setExtras = function(extras) {
        var scope = this.getScope();
        if (scope) scope.setExtras(extras);
    };
    /**
     * @inheritDoc
     */ Hub.prototype.setTag = function(key, value) {
        var scope = this.getScope();
        if (scope) scope.setTag(key, value);
    };
    /**
     * @inheritDoc
     */ Hub.prototype.setExtra = function(key, extra) {
        var scope = this.getScope();
        if (scope) scope.setExtra(key, extra);
    };
    /**
     * @inheritDoc
     */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    Hub.prototype.setContext = function(name, context) {
        var scope = this.getScope();
        if (scope) scope.setContext(name, context);
    };
    /**
     * @inheritDoc
     */ Hub.prototype.configureScope = function(callback) {
        var _a = this.getStackTop(), scope = _a.scope, client = _a.client;
        if (scope && client) callback(scope);
    };
    /**
     * @inheritDoc
     */ Hub.prototype.run = function(callback) {
        var oldHub = $d6bb95a59bff69df$export$4188a14ad302d1bc(this);
        try {
            callback(this);
        } finally{
            $d6bb95a59bff69df$export$4188a14ad302d1bc(oldHub);
        }
    };
    /**
     * @inheritDoc
     */ Hub.prototype.getIntegration = function(integration) {
        var client = this.getClient();
        if (!client) return null;
        try {
            return client.getIntegration(integration);
        } catch (_oO) {
            (0, $dzx2d.IS_DEBUG_BUILD) && (0, $1v4ZC.logger).warn("Cannot retrieve integration " + integration.id + " from the current Hub");
            return null;
        }
    };
    /**
     * @inheritDoc
     */ Hub.prototype.startSpan = function(context) {
        return this._callExtensionMethod('startSpan', context);
    };
    /**
     * @inheritDoc
     */ Hub.prototype.startTransaction = function(context, customSamplingContext) {
        return this._callExtensionMethod('startTransaction', context, customSamplingContext);
    };
    /**
     * @inheritDoc
     */ Hub.prototype.traceHeaders = function() {
        return this._callExtensionMethod('traceHeaders');
    };
    /**
     * @inheritDoc
     */ Hub.prototype.captureSession = function(endSession) {
        if (endSession === void 0) endSession = false;
        // both send the update and pull the session from the scope
        if (endSession) return this.endSession();
        // only send the update
        this._sendSessionUpdate();
    };
    /**
     * @inheritDoc
     */ Hub.prototype.endSession = function() {
        var layer = this.getStackTop();
        var scope = layer && layer.scope;
        var session = scope && scope.getSession();
        if (session) session.close();
        this._sendSessionUpdate();
        // the session is over; take it off of the scope
        if (scope) scope.setSession();
    };
    /**
     * @inheritDoc
     */ Hub.prototype.startSession = function(context) {
        var _a = this.getStackTop(), scope = _a.scope, client = _a.client;
        var _b = client && client.getOptions() || {}, release = _b.release, environment = _b.environment;
        // Will fetch userAgent if called from browser sdk
        var global = (0, $lrp9R.getGlobalObject)();
        var userAgent = (global.navigator || {}).userAgent;
        var session = new (0, $vfED8.Session)((0, $fClYD.__assign)((0, $fClYD.__assign)((0, $fClYD.__assign)({
            release: release,
            environment: environment
        }, scope && {
            user: scope.getUser()
        }), userAgent && {
            userAgent: userAgent
        }), context));
        if (scope) {
            // End existing session if there's one
            var currentSession = scope.getSession && scope.getSession();
            if (currentSession && currentSession.status === 'ok') currentSession.update({
                status: 'exited'
            });
            this.endSession();
            // Afterwards we set the new session on the scope
            scope.setSession(session);
        }
        return session;
    };
    /**
     * Sends the current Session on the scope
     */ Hub.prototype._sendSessionUpdate = function() {
        var _a = this.getStackTop(), scope = _a.scope, client = _a.client;
        if (!scope) return;
        var session = scope.getSession && scope.getSession();
        if (session) {
            if (client && client.captureSession) client.captureSession(session);
        }
    };
    /**
     * Internal helper function to call a method on the top client if it exists.
     *
     * @param method The method to call on the client.
     * @param args Arguments to pass to the client function.
     */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    Hub.prototype._invokeClient = function(method) {
        var _a;
        var args = [];
        for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
        var _b = this.getStackTop(), scope = _b.scope, client = _b.client;
        if (client && client[method]) // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-explicit-any
        (_a = client)[method].apply(_a, (0, $fClYD.__spread)(args, [
            scope
        ]));
    };
    /**
     * Calls global extension method and binding current instance to the function call
     */ // @ts-ignore Function lacks ending return statement and return type does not include 'undefined'. ts(2366)
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    Hub.prototype._callExtensionMethod = function(method) {
        var args = [];
        for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
        var carrier = $d6bb95a59bff69df$export$19eade501500c6c1();
        var sentry = carrier.__SENTRY__;
        if (sentry && sentry.extensions && typeof sentry.extensions[method] === 'function') return sentry.extensions[method].apply(this, args);
        (0, $dzx2d.IS_DEBUG_BUILD) && (0, $1v4ZC.logger).warn("Extension method " + method + " couldn't be found, doing nothing.");
    };
    return Hub;
}();
function $d6bb95a59bff69df$export$19eade501500c6c1() {
    var carrier = (0, $lrp9R.getGlobalObject)();
    carrier.__SENTRY__ = carrier.__SENTRY__ || {
        extensions: {},
        hub: undefined
    };
    return carrier;
}
function $d6bb95a59bff69df$export$4188a14ad302d1bc(hub) {
    var registry = $d6bb95a59bff69df$export$19eade501500c6c1();
    var oldHub = $d6bb95a59bff69df$export$bfa8a924a84a76b7(registry);
    $d6bb95a59bff69df$export$849f05434e95d2f2(registry, hub);
    return oldHub;
}
function $d6bb95a59bff69df$export$a07cdf6544bbd7c() {
    // Get main carrier (global for every environment)
    var registry = $d6bb95a59bff69df$export$19eade501500c6c1();
    // If there's no hub, or its an old API, assign a new one
    if (!$d6bb95a59bff69df$var$hasHubOnCarrier(registry) || $d6bb95a59bff69df$export$bfa8a924a84a76b7(registry).isOlderThan($d6bb95a59bff69df$export$24a86ef7798177e4)) $d6bb95a59bff69df$export$849f05434e95d2f2(registry, new $d6bb95a59bff69df$export$8c41bb232f1008b1());
    // Prefer domains over global if they are there (applicable only to Node environment)
    if ((0, $dBSRM.isNodeEnv)()) return $d6bb95a59bff69df$var$getHubFromActiveDomain(registry);
    // Return hub that lives on a global object
    return $d6bb95a59bff69df$export$bfa8a924a84a76b7(registry);
}
function $d6bb95a59bff69df$export$1c4d656130202699() {
    (0, $dzx2d.IS_DEBUG_BUILD) && (0, $1v4ZC.logger).warn('Function `getActiveDomain` is deprecated and will be removed in a future version.');
    var sentry = $d6bb95a59bff69df$export$19eade501500c6c1().__SENTRY__;
    return sentry && sentry.extensions && sentry.extensions.domain && sentry.extensions.domain.active;
}
/**
 * Try to read the hub from an active domain, and fallback to the registry if one doesn't exist
 * @returns discovered hub
 */ function $d6bb95a59bff69df$var$getHubFromActiveDomain(registry) {
    try {
        var sentry = $d6bb95a59bff69df$export$19eade501500c6c1().__SENTRY__;
        var activeDomain = sentry && sentry.extensions && sentry.extensions.domain && sentry.extensions.domain.active;
        // If there's no active domain, just return global hub
        if (!activeDomain) return $d6bb95a59bff69df$export$bfa8a924a84a76b7(registry);
        // If there's no hub on current domain, or it's an old API, assign a new one
        if (!$d6bb95a59bff69df$var$hasHubOnCarrier(activeDomain) || $d6bb95a59bff69df$export$bfa8a924a84a76b7(activeDomain).isOlderThan($d6bb95a59bff69df$export$24a86ef7798177e4)) {
            var registryHubTopStack = $d6bb95a59bff69df$export$bfa8a924a84a76b7(registry).getStackTop();
            $d6bb95a59bff69df$export$849f05434e95d2f2(activeDomain, new $d6bb95a59bff69df$export$8c41bb232f1008b1(registryHubTopStack.client, (0, $FnrKW.Scope).clone(registryHubTopStack.scope)));
        }
        // Return hub that lives on a domain
        return $d6bb95a59bff69df$export$bfa8a924a84a76b7(activeDomain);
    } catch (_Oo) {
        // Return hub that lives on a global object
        return $d6bb95a59bff69df$export$bfa8a924a84a76b7(registry);
    }
}
/**
 * This will tell whether a carrier has a hub on it or not
 * @param carrier object
 */ function $d6bb95a59bff69df$var$hasHubOnCarrier(carrier) {
    return !!(carrier && carrier.__SENTRY__ && carrier.__SENTRY__.hub);
}
function $d6bb95a59bff69df$export$bfa8a924a84a76b7(carrier) {
    return (0, $lrp9R.getGlobalSingleton)('hub', function() {
        return new $d6bb95a59bff69df$export$8c41bb232f1008b1();
    }, carrier);
}
function $d6bb95a59bff69df$export$849f05434e95d2f2(carrier, hub) {
    if (!carrier) return false;
    var __SENTRY__ = carrier.__SENTRY__ = carrier.__SENTRY__ || {};
    __SENTRY__.hub = hub;
    return true;
}

});
parcelRegister("fClYD", function(module, exports) {
$parcel$export(module.exports, "__assign", () => $b5eb73cfb73be12c$export$18ce0697a983be9b);
$parcel$export(module.exports, "__spread", () => $b5eb73cfb73be12c$export$afc72e2116322959);
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var $b5eb73cfb73be12c$var$extendStatics = function(d, b) {
    $b5eb73cfb73be12c$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return $b5eb73cfb73be12c$var$extendStatics(d, b);
};
function $b5eb73cfb73be12c$export$a8ba968b8961cb8a(d, b) {
    $b5eb73cfb73be12c$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $b5eb73cfb73be12c$export$18ce0697a983be9b = function() {
    $b5eb73cfb73be12c$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $b5eb73cfb73be12c$export$18ce0697a983be9b.apply(this, arguments);
};
function $b5eb73cfb73be12c$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $b5eb73cfb73be12c$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $b5eb73cfb73be12c$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $b5eb73cfb73be12c$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $b5eb73cfb73be12c$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $b5eb73cfb73be12c$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function $b5eb73cfb73be12c$export$45d3717a4c69092e(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function $b5eb73cfb73be12c$export$f33643c0debef087(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function $b5eb73cfb73be12c$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $b5eb73cfb73be12c$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $b5eb73cfb73be12c$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($b5eb73cfb73be12c$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $b5eb73cfb73be12c$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $b5eb73cfb73be12c$export$10c90e4f7922046c(v) {
    return this instanceof $b5eb73cfb73be12c$export$10c90e4f7922046c ? (this.v = v, this) : new $b5eb73cfb73be12c$export$10c90e4f7922046c(v);
}
function $b5eb73cfb73be12c$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $b5eb73cfb73be12c$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $b5eb73cfb73be12c$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $b5eb73cfb73be12c$export$10c90e4f7922046c(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function $b5eb73cfb73be12c$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $b5eb73cfb73be12c$export$19a8beecd37a4c45 === "function" ? $b5eb73cfb73be12c$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $b5eb73cfb73be12c$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function $b5eb73cfb73be12c$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function $b5eb73cfb73be12c$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $b5eb73cfb73be12c$export$d5dcaf168c640c35(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function $b5eb73cfb73be12c$export$d40a35129aaff81f(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}

});

parcelRegister("i0afJ", function(module, exports) {
$parcel$export(module.exports, "forget", () => (parcelRequire("lQOiJ")).forget);
$parcel$export(module.exports, "getLocationHref", () => (parcelRequire("f9iVj")).getLocationHref);
$parcel$export(module.exports, "htmlTreeAsString", () => (parcelRequire("f9iVj")).htmlTreeAsString);
$parcel$export(module.exports, "dsnToString", () => (parcelRequire("62yRy")).dsnToString);
$parcel$export(module.exports, "makeDsn", () => (parcelRequire("62yRy")).makeDsn);
$parcel$export(module.exports, "SentryError", () => (parcelRequire("iMWNA")).SentryError);
$parcel$export(module.exports, "getGlobalObject", () => (parcelRequire("lrp9R")).getGlobalObject);
$parcel$export(module.exports, "getGlobalSingleton", () => (parcelRequire("lrp9R")).getGlobalSingleton);
$parcel$export(module.exports, "addInstrumentationHandler", () => (parcelRequire("aVmXt")).addInstrumentationHandler);
$parcel$export(module.exports, "isDOMError", () => (parcelRequire("8rX8J")).isDOMError);
$parcel$export(module.exports, "isDOMException", () => (parcelRequire("8rX8J")).isDOMException);
$parcel$export(module.exports, "isError", () => (parcelRequire("8rX8J")).isError);
$parcel$export(module.exports, "isErrorEvent", () => (parcelRequire("8rX8J")).isErrorEvent);
$parcel$export(module.exports, "isEvent", () => (parcelRequire("8rX8J")).isEvent);
$parcel$export(module.exports, "isInstanceOf", () => (parcelRequire("8rX8J")).isInstanceOf);
$parcel$export(module.exports, "isPlainObject", () => (parcelRequire("8rX8J")).isPlainObject);
$parcel$export(module.exports, "isPrimitive", () => (parcelRequire("8rX8J")).isPrimitive);
$parcel$export(module.exports, "isString", () => (parcelRequire("8rX8J")).isString);
$parcel$export(module.exports, "isThenable", () => (parcelRequire("8rX8J")).isThenable);
$parcel$export(module.exports, "CONSOLE_LEVELS", () => (parcelRequire("1v4ZC")).CONSOLE_LEVELS);
$parcel$export(module.exports, "consoleSandbox", () => (parcelRequire("1v4ZC")).consoleSandbox);
$parcel$export(module.exports, "logger", () => (parcelRequire("1v4ZC")).logger);
$parcel$export(module.exports, "addExceptionMechanism", () => (parcelRequire("73JtC")).addExceptionMechanism);
$parcel$export(module.exports, "addExceptionTypeValue", () => (parcelRequire("73JtC")).addExceptionTypeValue);
$parcel$export(module.exports, "checkOrSetAlreadyCaught", () => (parcelRequire("73JtC")).checkOrSetAlreadyCaught);
$parcel$export(module.exports, "getEventDescription", () => (parcelRequire("73JtC")).getEventDescription);
$parcel$export(module.exports, "parseUrl", () => (parcelRequire("73JtC")).parseUrl);
$parcel$export(module.exports, "uuid4", () => (parcelRequire("73JtC")).uuid4);
$parcel$export(module.exports, "normalize", () => (parcelRequire("bZWF1")).normalize);
$parcel$export(module.exports, "normalizeToSize", () => (parcelRequire("bZWF1")).normalizeToSize);
$parcel$export(module.exports, "addNonEnumerableProperty", () => (parcelRequire("909Vl")).addNonEnumerableProperty);
$parcel$export(module.exports, "dropUndefinedKeys", () => (parcelRequire("909Vl")).dropUndefinedKeys);
$parcel$export(module.exports, "extractExceptionKeysForMessage", () => (parcelRequire("909Vl")).extractExceptionKeysForMessage);
$parcel$export(module.exports, "fill", () => (parcelRequire("909Vl")).fill);
$parcel$export(module.exports, "getOriginalFunction", () => (parcelRequire("909Vl")).getOriginalFunction);
$parcel$export(module.exports, "markFunctionWrapped", () => (parcelRequire("909Vl")).markFunctionWrapped);
$parcel$export(module.exports, "urlEncode", () => (parcelRequire("909Vl")).urlEncode);
$parcel$export(module.exports, "basename", () => (parcelRequire("39Zfw")).basename);
$parcel$export(module.exports, "relative", () => (parcelRequire("39Zfw")).relative);
$parcel$export(module.exports, "makePromiseBuffer", () => (parcelRequire("bUAoW")).makePromiseBuffer);
$parcel$export(module.exports, "severityFromString", () => (parcelRequire("kpXMz")).severityFromString);
$parcel$export(module.exports, "createStackParser", () => (parcelRequire("b8srE")).createStackParser);
$parcel$export(module.exports, "getFunctionName", () => (parcelRequire("b8srE")).getFunctionName);
$parcel$export(module.exports, "eventStatusFromHttpCode", () => (parcelRequire("9P6Bi")).eventStatusFromHttpCode);
$parcel$export(module.exports, "isMatchingPattern", () => (parcelRequire("9k3Oz")).isMatchingPattern);
$parcel$export(module.exports, "safeJoin", () => (parcelRequire("9k3Oz")).safeJoin);
$parcel$export(module.exports, "truncate", () => (parcelRequire("9k3Oz")).truncate);
$parcel$export(module.exports, "isNativeFetch", () => (parcelRequire("7YVaQ")).isNativeFetch);
$parcel$export(module.exports, "supportsFetch", () => (parcelRequire("7YVaQ")).supportsFetch);
$parcel$export(module.exports, "supportsReferrerPolicy", () => (parcelRequire("7YVaQ")).supportsReferrerPolicy);
$parcel$export(module.exports, "supportsReportingObserver", () => (parcelRequire("7YVaQ")).supportsReportingObserver);
$parcel$export(module.exports, "rejectedSyncPromise", () => (parcelRequire("bdF5c")).rejectedSyncPromise);
$parcel$export(module.exports, "resolvedSyncPromise", () => (parcelRequire("bdF5c")).resolvedSyncPromise);
$parcel$export(module.exports, "SyncPromise", () => (parcelRequire("bdF5c")).SyncPromise);
$parcel$export(module.exports, "createEnvelope", () => (parcelRequire("9G22S")).createEnvelope);
$parcel$export(module.exports, "getEnvelopeType", () => (parcelRequire("9G22S")).getEnvelopeType);
$parcel$export(module.exports, "serializeEnvelope", () => (parcelRequire("9G22S")).serializeEnvelope);
$parcel$export(module.exports, "createClientReportEnvelope", () => (parcelRequire("diVdC")).createClientReportEnvelope);
$parcel$export(module.exports, "disabledUntil", () => (parcelRequire("etGw0")).disabledUntil);
$parcel$export(module.exports, "isRateLimited", () => (parcelRequire("etGw0")).isRateLimited);
$parcel$export(module.exports, "updateRateLimits", () => (parcelRequire("etGw0")).updateRateLimits);
parcelRequire("lQOiJ");
parcelRequire("f9iVj");
parcelRequire("62yRy");

parcelRequire("iMWNA");
parcelRequire("lrp9R");
parcelRequire("aVmXt");
parcelRequire("8rX8J");
parcelRequire("1v4ZC");

parcelRequire("73JtC");

var $dBSRM = parcelRequire("dBSRM");
parcelRequire("bZWF1");
parcelRequire("909Vl");
parcelRequire("39Zfw");
parcelRequire("bUAoW");
parcelRequire("kpXMz");
parcelRequire("b8srE");
parcelRequire("9P6Bi");
parcelRequire("9k3Oz");
parcelRequire("7YVaQ");
parcelRequire("bdF5c");

var $chTsM = parcelRequire("chTsM");


parcelRequire("9G22S");
parcelRequire("diVdC");
parcelRequire("etGw0");
$parcel$exportWildcard(module.exports, $dBSRM);
$parcel$exportWildcard(module.exports, $chTsM);

});
parcelRegister("lQOiJ", function(module, exports) {
$parcel$export(module.exports, "forget", () => $fe85790f9b07e485$export$93c25f2590a5b540);
/**
 * Consumes the promise and logs the error when it rejects.
 * @param promise A promise to forget.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $fe85790f9b07e485$export$93c25f2590a5b540(promise) {
    promise.then(null, function(e) {
        // TODO: Use a better logging mechanism
        // eslint-disable-next-line no-console
        console.error(e);
    });
}

});

parcelRegister("f9iVj", function(module, exports) {
$parcel$export(module.exports, "htmlTreeAsString", () => $b076601639d1314e$export$5647df6b7814ac86);
$parcel$export(module.exports, "getLocationHref", () => $b076601639d1314e$export$1cfafeee2987818b);

var $lrp9R = parcelRequire("lrp9R");

var $8rX8J = parcelRequire("8rX8J");
function $b076601639d1314e$export$5647df6b7814ac86(elem, keyAttrs) {
    // try/catch both:
    // - accessing event.target (see getsentry/raven-js#838, #768)
    // - `htmlTreeAsString` because it's complex, and just accessing the DOM incorrectly
    // - can throw an exception in some circumstances.
    try {
        var currentElem = elem;
        var MAX_TRAVERSE_HEIGHT = 5;
        var MAX_OUTPUT_LEN = 80;
        var out = [];
        var height = 0;
        var len = 0;
        var separator = ' > ';
        var sepLength = separator.length;
        var nextStr = void 0;
        // eslint-disable-next-line no-plusplus
        while(currentElem && height++ < MAX_TRAVERSE_HEIGHT){
            nextStr = $b076601639d1314e$var$_htmlElementAsString(currentElem, keyAttrs);
            // bail out if
            // - nextStr is the 'html' element
            // - the length of the string that would be created exceeds MAX_OUTPUT_LEN
            //   (ignore this limit if we are on the first iteration)
            if (nextStr === 'html' || height > 1 && len + out.length * sepLength + nextStr.length >= MAX_OUTPUT_LEN) break;
            out.push(nextStr);
            len += nextStr.length;
            currentElem = currentElem.parentNode;
        }
        return out.reverse().join(separator);
    } catch (_oO) {
        return '<unknown>';
    }
}
/**
 * Returns a simple, query-selector representation of a DOM element
 * e.g. [HTMLElement] => input#foo.btn[name=baz]
 * @returns generated DOM path
 */ function $b076601639d1314e$var$_htmlElementAsString(el, keyAttrs) {
    var elem = el;
    var out = [];
    var className;
    var classes;
    var key;
    var attr;
    var i;
    if (!elem || !elem.tagName) return '';
    out.push(elem.tagName.toLowerCase());
    // Pairs of attribute keys defined in `serializeAttribute` and their values on element.
    var keyAttrPairs = keyAttrs && keyAttrs.length ? keyAttrs.filter(function(keyAttr) {
        return elem.getAttribute(keyAttr);
    }).map(function(keyAttr) {
        return [
            keyAttr,
            elem.getAttribute(keyAttr)
        ];
    }) : null;
    if (keyAttrPairs && keyAttrPairs.length) keyAttrPairs.forEach(function(keyAttrPair) {
        out.push("[" + keyAttrPair[0] + "=\"" + keyAttrPair[1] + "\"]");
    });
    else {
        if (elem.id) out.push("#" + elem.id);
        // eslint-disable-next-line prefer-const
        className = elem.className;
        if (className && (0, $8rX8J.isString)(className)) {
            classes = className.split(/\s+/);
            for(i = 0; i < classes.length; i++)out.push("." + classes[i]);
        }
    }
    var allowedAttrs = [
        'type',
        'name',
        'title',
        'alt'
    ];
    for(i = 0; i < allowedAttrs.length; i++){
        key = allowedAttrs[i];
        attr = elem.getAttribute(key);
        if (attr) out.push("[" + key + "=\"" + attr + "\"]");
    }
    return out.join('');
}
function $b076601639d1314e$export$1cfafeee2987818b() {
    var global = (0, $lrp9R.getGlobalObject)();
    try {
        return global.document.location.href;
    } catch (oO) {
        return '';
    }
}

});
parcelRegister("lrp9R", function(module, exports) {
$parcel$export(module.exports, "getGlobalObject", () => $f9bfa2789ec923a7$export$256479dc0cea61c4);
$parcel$export(module.exports, "getGlobalSingleton", () => $f9bfa2789ec923a7$export$7e223ec222791509);
/**
 * NOTE: In order to avoid circular dependencies, if you add a function to this module and it needs to print something,
 * you must either a) use `console.log` rather than the logger, or b) put your function elsewhere.
 */ 
var $dBSRM = parcelRequire("dBSRM");
var $f9bfa2789ec923a7$var$fallbackGlobalObject = {};
function $f9bfa2789ec923a7$export$256479dc0cea61c4() {
    return (0, $dBSRM.isNodeEnv)() ? $parcel$global : typeof window !== 'undefined' // eslint-disable-line no-restricted-globals
     ? window // eslint-disable-line no-restricted-globals
     : typeof self !== 'undefined' ? self : $f9bfa2789ec923a7$var$fallbackGlobalObject;
}
function $f9bfa2789ec923a7$export$7e223ec222791509(name, creator, obj) {
    var global1 = obj || $f9bfa2789ec923a7$export$256479dc0cea61c4();
    var __SENTRY__ = global1.__SENTRY__ = global1.__SENTRY__ || {};
    var singleton = __SENTRY__[name] || (__SENTRY__[name] = creator());
    return singleton;
}

});
parcelRegister("dBSRM", function(module, exports) {
$parcel$export(module.exports, "isNodeEnv", () => isNodeEnv, (v) => isNodeEnv = v);
$parcel$export(module.exports, "dynamicRequire", () => dynamicRequire, (v) => dynamicRequire = v);
/**
 * NOTE: In order to avoid circular dependencies, if you add a function to this module and it needs to print something,
 * you must either a) use `console.log` rather than the logger, or b) put your function elsewhere.
 */ 
var $b8WCc = parcelRequire("b8WCc");

var $3ZMUU = parcelRequire("3ZMUU");
function isNodeEnv() {
    // explicitly check for browser bundles as those can be optimized statically
    // by terser/rollup.
    return !(0, $b8WCc.isBrowserBundle)() && Object.prototype.toString.call(typeof $3ZMUU !== 'undefined' ? $3ZMUU : 0) === '[object process]';
}
function dynamicRequire(mod, request) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return mod.require(request);
}
function loadModule(moduleName) {
    var mod;
    try {
        mod = dynamicRequire(module, moduleName);
    } catch (e) {
    // no-empty
    }
    try {
        var cwd = dynamicRequire(module, 'process').cwd;
        mod = dynamicRequire(module, cwd() + "/node_modules/" + moduleName);
    } catch (e) {
    // no-empty
    }
    return mod;
}

});
parcelRegister("b8WCc", function(module, exports) {
$parcel$export(module.exports, "isBrowserBundle", () => $81cde8cb5e9c669f$export$2928c40372e623c0);
/*
 * This module exists for optimizations in the build process through rollup and terser.  We define some global
 * constants, which can be overridden during build. By guarding certain pieces of code with functions that return these
 * constants, we can control whether or not they appear in the final bundle. (Any code guarded by a false condition will
 * never run, and will hence be dropped during treeshaking.) The two primary uses for this are stripping out calls to
 * `logger` and preventing node-related code from appearing in browser bundles.
 *
 * Attention:
 * This file should not be used to define constants/flags that are intended to be used for tree-shaking conducted by
 * users. These fags should live in their respective packages, as we identified user tooling (specifically webpack)
 * having issues tree-shaking these constants across package boundaries.
 * An example for this is the __SENTRY_DEBUG__ constant. It is declared in each package individually because we want
 * users to be able to shake away expressions that it guards.
 */ /**
 * Figures out if we're building a browser bundle.
 *
 * @returns true if this is a browser bundle build.
 */ function $81cde8cb5e9c669f$export$2928c40372e623c0() {
    return typeof __SENTRY_BROWSER_BUNDLE__ !== 'undefined' && !!__SENTRY_BROWSER_BUNDLE__;
}

});



parcelRegister("8rX8J", function(module, exports) {
$parcel$export(module.exports, "isError", () => $626eb84a64d84c41$export$e6127cc7fe7395c3);
$parcel$export(module.exports, "isInstanceOf", () => $626eb84a64d84c41$export$49034edbe6b62415);
$parcel$export(module.exports, "isErrorEvent", () => $626eb84a64d84c41$export$9f9636d330b71954);
$parcel$export(module.exports, "isDOMError", () => $626eb84a64d84c41$export$ef9e2056653f0c8e);
$parcel$export(module.exports, "isDOMException", () => $626eb84a64d84c41$export$12e869b2a583f783);
$parcel$export(module.exports, "isString", () => $626eb84a64d84c41$export$844ec244b1367d54);
$parcel$export(module.exports, "isPrimitive", () => $626eb84a64d84c41$export$c3825b437cbdea5c);
$parcel$export(module.exports, "isPlainObject", () => $626eb84a64d84c41$export$53b83ca8eaab0383);
$parcel$export(module.exports, "isEvent", () => $626eb84a64d84c41$export$9671ea99bd126ace);
$parcel$export(module.exports, "isElement", () => $626eb84a64d84c41$export$45a5e7f76e0caa8d);
$parcel$export(module.exports, "isRegExp", () => $626eb84a64d84c41$export$49841c62b9eff15);
$parcel$export(module.exports, "isThenable", () => $626eb84a64d84c41$export$f5b060c2914b97c8);
$parcel$export(module.exports, "isSyntheticEvent", () => $626eb84a64d84c41$export$bc2894c7158efbac);
$parcel$export(module.exports, "isNaN", () => $626eb84a64d84c41$export$c9f5652083b8129d);
/* eslint-disable @typescript-eslint/no-explicit-any */ /* eslint-disable @typescript-eslint/explicit-module-boundary-types */ // eslint-disable-next-line @typescript-eslint/unbound-method
var $626eb84a64d84c41$var$objectToString = Object.prototype.toString;
function $626eb84a64d84c41$export$e6127cc7fe7395c3(wat) {
    switch($626eb84a64d84c41$var$objectToString.call(wat)){
        case '[object Error]':
        case '[object Exception]':
        case '[object DOMException]':
            return true;
        default:
            return $626eb84a64d84c41$export$49034edbe6b62415(wat, Error);
    }
}
function $626eb84a64d84c41$var$isBuiltin(wat, ty) {
    return $626eb84a64d84c41$var$objectToString.call(wat) === "[object " + ty + "]";
}
function $626eb84a64d84c41$export$9f9636d330b71954(wat) {
    return $626eb84a64d84c41$var$isBuiltin(wat, 'ErrorEvent');
}
function $626eb84a64d84c41$export$ef9e2056653f0c8e(wat) {
    return $626eb84a64d84c41$var$isBuiltin(wat, 'DOMError');
}
function $626eb84a64d84c41$export$12e869b2a583f783(wat) {
    return $626eb84a64d84c41$var$isBuiltin(wat, 'DOMException');
}
function $626eb84a64d84c41$export$844ec244b1367d54(wat) {
    return $626eb84a64d84c41$var$isBuiltin(wat, 'String');
}
function $626eb84a64d84c41$export$c3825b437cbdea5c(wat) {
    return wat === null || typeof wat !== 'object' && typeof wat !== 'function';
}
function $626eb84a64d84c41$export$53b83ca8eaab0383(wat) {
    return $626eb84a64d84c41$var$isBuiltin(wat, 'Object');
}
function $626eb84a64d84c41$export$9671ea99bd126ace(wat) {
    return typeof Event !== 'undefined' && $626eb84a64d84c41$export$49034edbe6b62415(wat, Event);
}
function $626eb84a64d84c41$export$45a5e7f76e0caa8d(wat) {
    return typeof Element !== 'undefined' && $626eb84a64d84c41$export$49034edbe6b62415(wat, Element);
}
function $626eb84a64d84c41$export$49841c62b9eff15(wat) {
    return $626eb84a64d84c41$var$isBuiltin(wat, 'RegExp');
}
function $626eb84a64d84c41$export$f5b060c2914b97c8(wat) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return Boolean(wat && wat.then && typeof wat.then === 'function');
}
function $626eb84a64d84c41$export$bc2894c7158efbac(wat) {
    return $626eb84a64d84c41$export$53b83ca8eaab0383(wat) && 'nativeEvent' in wat && 'preventDefault' in wat && 'stopPropagation' in wat;
}
function $626eb84a64d84c41$export$c9f5652083b8129d(wat) {
    return typeof wat === 'number' && wat !== wat;
}
function $626eb84a64d84c41$export$49034edbe6b62415(wat, base) {
    try {
        return wat instanceof base;
    } catch (_e) {
        return false;
    }
}

});


parcelRegister("62yRy", function(module, exports) {
$parcel$export(module.exports, "dsnToString", () => $465df9040833ef74$export$44d472fbb931a776);
$parcel$export(module.exports, "makeDsn", () => $465df9040833ef74$export$128827c3562ec0cb);

var $dT3VW = parcelRequire("dT3VW");

var $iMWNA = parcelRequire("iMWNA");

var $iuc9e = parcelRequire("iuc9e");
/** Regular expression used to parse a Dsn. */ var $465df9040833ef74$var$DSN_REGEX = /^(?:(\w+):)\/\/(?:(\w+)(?::(\w+))?@)([\w.-]+)(?::(\d+))?\/(.+)/;
function $465df9040833ef74$var$isValidProtocol(protocol) {
    return protocol === 'http' || protocol === 'https';
}
function $465df9040833ef74$export$44d472fbb931a776(dsn, withPassword) {
    if (withPassword === void 0) withPassword = false;
    var host = dsn.host, path = dsn.path, pass = dsn.pass, port = dsn.port, projectId = dsn.projectId, protocol = dsn.protocol, publicKey = dsn.publicKey;
    return protocol + "://" + publicKey + (withPassword && pass ? ":" + pass : '') + ("@" + host + (port ? ":" + port : '') + "/" + (path ? path + "/" : path) + projectId);
}
function $465df9040833ef74$var$dsnFromString(str) {
    var match = $465df9040833ef74$var$DSN_REGEX.exec(str);
    if (!match) throw new (0, $iMWNA.SentryError)("Invalid Sentry Dsn: " + str);
    var _a = (0, $dT3VW.__read)(match.slice(1), 6), protocol = _a[0], publicKey = _a[1], _b = _a[2], pass = _b === void 0 ? '' : _b, host = _a[3], _c = _a[4], port = _c === void 0 ? '' : _c, lastPath = _a[5];
    var path = '';
    var projectId = lastPath;
    var split = projectId.split('/');
    if (split.length > 1) {
        path = split.slice(0, -1).join('/');
        projectId = split.pop();
    }
    if (projectId) {
        var projectMatch = projectId.match(/^\d+/);
        if (projectMatch) projectId = projectMatch[0];
    }
    return $465df9040833ef74$var$dsnFromComponents({
        host: host,
        pass: pass,
        path: path,
        projectId: projectId,
        port: port,
        protocol: protocol,
        publicKey: publicKey
    });
}
function $465df9040833ef74$var$dsnFromComponents(components) {
    // TODO this is for backwards compatibility, and can be removed in a future version
    if ('user' in components && !('publicKey' in components)) components.publicKey = components.user;
    return {
        user: components.publicKey || '',
        protocol: components.protocol,
        publicKey: components.publicKey || '',
        pass: components.pass || '',
        host: components.host,
        port: components.port || '',
        path: components.path || '',
        projectId: components.projectId
    };
}
function $465df9040833ef74$var$validateDsn(dsn) {
    if (!(0, $iuc9e.IS_DEBUG_BUILD)) return;
    var port = dsn.port, projectId = dsn.projectId, protocol = dsn.protocol;
    var requiredComponents = [
        'protocol',
        'publicKey',
        'host',
        'projectId'
    ];
    requiredComponents.forEach(function(component) {
        if (!dsn[component]) throw new (0, $iMWNA.SentryError)("Invalid Sentry Dsn: " + component + " missing");
    });
    if (!projectId.match(/^\d+$/)) throw new (0, $iMWNA.SentryError)("Invalid Sentry Dsn: Invalid projectId " + projectId);
    if (!$465df9040833ef74$var$isValidProtocol(protocol)) throw new (0, $iMWNA.SentryError)("Invalid Sentry Dsn: Invalid protocol " + protocol);
    if (port && isNaN(parseInt(port, 10))) throw new (0, $iMWNA.SentryError)("Invalid Sentry Dsn: Invalid port " + port);
    return true;
}
function $465df9040833ef74$export$128827c3562ec0cb(from) {
    var components = typeof from === 'string' ? $465df9040833ef74$var$dsnFromString(from) : $465df9040833ef74$var$dsnFromComponents(from);
    $465df9040833ef74$var$validateDsn(components);
    return components;
}

});
parcelRegister("dT3VW", function(module, exports) {
$parcel$export(module.exports, "__extends", () => $a1c3768bad0ada2b$export$a8ba968b8961cb8a);
$parcel$export(module.exports, "__assign", () => $a1c3768bad0ada2b$export$18ce0697a983be9b);
$parcel$export(module.exports, "__values", () => $a1c3768bad0ada2b$export$19a8beecd37a4c45);
$parcel$export(module.exports, "__read", () => $a1c3768bad0ada2b$export$8d051b38c9118094);
$parcel$export(module.exports, "__spread", () => $a1c3768bad0ada2b$export$afc72e2116322959);
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var $a1c3768bad0ada2b$var$extendStatics = function(d, b) {
    $a1c3768bad0ada2b$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return $a1c3768bad0ada2b$var$extendStatics(d, b);
};
function $a1c3768bad0ada2b$export$a8ba968b8961cb8a(d, b) {
    $a1c3768bad0ada2b$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $a1c3768bad0ada2b$export$18ce0697a983be9b = function() {
    $a1c3768bad0ada2b$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $a1c3768bad0ada2b$export$18ce0697a983be9b.apply(this, arguments);
};
function $a1c3768bad0ada2b$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $a1c3768bad0ada2b$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $a1c3768bad0ada2b$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $a1c3768bad0ada2b$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $a1c3768bad0ada2b$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $a1c3768bad0ada2b$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function $a1c3768bad0ada2b$export$45d3717a4c69092e(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function $a1c3768bad0ada2b$export$f33643c0debef087(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function $a1c3768bad0ada2b$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $a1c3768bad0ada2b$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $a1c3768bad0ada2b$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($a1c3768bad0ada2b$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $a1c3768bad0ada2b$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $a1c3768bad0ada2b$export$10c90e4f7922046c(v) {
    return this instanceof $a1c3768bad0ada2b$export$10c90e4f7922046c ? (this.v = v, this) : new $a1c3768bad0ada2b$export$10c90e4f7922046c(v);
}
function $a1c3768bad0ada2b$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $a1c3768bad0ada2b$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $a1c3768bad0ada2b$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $a1c3768bad0ada2b$export$10c90e4f7922046c(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function $a1c3768bad0ada2b$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $a1c3768bad0ada2b$export$19a8beecd37a4c45 === "function" ? $a1c3768bad0ada2b$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $a1c3768bad0ada2b$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function $a1c3768bad0ada2b$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function $a1c3768bad0ada2b$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $a1c3768bad0ada2b$export$d5dcaf168c640c35(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function $a1c3768bad0ada2b$export$d40a35129aaff81f(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}

});

parcelRegister("iMWNA", function(module, exports) {
$parcel$export(module.exports, "SentryError", () => $dada51e7b2168637$export$5949942ba2a7c0e2);

var $dT3VW = parcelRequire("dT3VW");

var $aN905 = parcelRequire("aN905");
/** An error emitted by Sentry SDKs and related utilities. */ var $dada51e7b2168637$export$5949942ba2a7c0e2 = /** @class */ function(_super) {
    (0, $dT3VW.__extends)(SentryError, _super);
    function SentryError(message) {
        var _newTarget = this.constructor;
        var _this = _super.call(this, message) || this;
        _this.message = message;
        _this.name = _newTarget.prototype.constructor.name;
        (0, $aN905.setPrototypeOf)(_this, _newTarget.prototype);
        return _this;
    }
    return SentryError;
}(Error);

});
parcelRegister("aN905", function(module, exports) {
$parcel$export(module.exports, "setPrototypeOf", () => $7db57640fe0b53a7$export$1cb0d91350beb6cc);
var $7db57640fe0b53a7$export$1cb0d91350beb6cc = Object.setPrototypeOf || (({
    __proto__: []
}) instanceof Array ? $7db57640fe0b53a7$var$setProtoOf : $7db57640fe0b53a7$var$mixinProperties);
/**
 * setPrototypeOf polyfill using __proto__
 */ // eslint-disable-next-line @typescript-eslint/ban-types
function $7db57640fe0b53a7$var$setProtoOf(obj, proto) {
    // @ts-ignore __proto__ does not exist on obj
    obj.__proto__ = proto;
    return obj;
}
/**
 * setPrototypeOf polyfill using mixin
 */ // eslint-disable-next-line @typescript-eslint/ban-types
function $7db57640fe0b53a7$var$mixinProperties(obj, proto) {
    for(var prop in proto)if (!Object.prototype.hasOwnProperty.call(obj, prop)) // @ts-ignore typescript complains about indexing so we remove
    obj[prop] = proto[prop];
    return obj;
}

});


parcelRegister("iuc9e", function(module, exports) {
$parcel$export(module.exports, "IS_DEBUG_BUILD", () => $d75473a211326e79$export$48a8984ec0bf2e44);
/*
 * This file defines flags and constants that can be modified during compile time in order to facilitate tree shaking
 * for users.
 *
 * Debug flags need to be declared in each package individually and must not be imported across package boundaries,
 * because some build tools have trouble tree-shaking imported guards.
 *
 * As a convention, we define debug flags in a `flags.ts` file in the root of a package's `src` folder.
 *
 * Debug flag files will contain "magic strings" like `__SENTRY_DEBUG__` that may get replaced with actual values during
 * our, or the user's build process. Take care when introducing new flags - they must not throw if they are not
 * replaced.
 */ /** Flag that is true for debug builds, false otherwise. */ var $d75473a211326e79$export$48a8984ec0bf2e44 = typeof __SENTRY_DEBUG__ === 'undefined' ? true : __SENTRY_DEBUG__;

});


parcelRegister("aVmXt", function(module, exports) {
$parcel$export(module.exports, "addInstrumentationHandler", () => $7f41094ed33359b4$export$285b9172a3741fb7);

var $dT3VW = parcelRequire("dT3VW");

var $iuc9e = parcelRequire("iuc9e");

var $lrp9R = parcelRequire("lrp9R");

var $8rX8J = parcelRequire("8rX8J");

var $1v4ZC = parcelRequire("1v4ZC");

var $909Vl = parcelRequire("909Vl");

var $b8srE = parcelRequire("b8srE");

var $7YVaQ = parcelRequire("7YVaQ");
var $7f41094ed33359b4$var$global = (0, $lrp9R.getGlobalObject)();
/**
 * Instrument native APIs to call handlers that can be used to create breadcrumbs, APM spans etc.
 *  - Console API
 *  - Fetch API
 *  - XHR API
 *  - History API
 *  - DOM API (click/typing)
 *  - Error API
 *  - UnhandledRejection API
 */ var $7f41094ed33359b4$var$handlers = {};
var $7f41094ed33359b4$var$instrumented = {};
/** Instruments given API */ function $7f41094ed33359b4$var$instrument(type) {
    if ($7f41094ed33359b4$var$instrumented[type]) return;
    $7f41094ed33359b4$var$instrumented[type] = true;
    switch(type){
        case 'console':
            $7f41094ed33359b4$var$instrumentConsole();
            break;
        case 'dom':
            $7f41094ed33359b4$var$instrumentDOM();
            break;
        case 'xhr':
            $7f41094ed33359b4$var$instrumentXHR();
            break;
        case 'fetch':
            $7f41094ed33359b4$var$instrumentFetch();
            break;
        case 'history':
            $7f41094ed33359b4$var$instrumentHistory();
            break;
        case 'error':
            $7f41094ed33359b4$var$instrumentError();
            break;
        case 'unhandledrejection':
            $7f41094ed33359b4$var$instrumentUnhandledRejection();
            break;
        default:
            (0, $iuc9e.IS_DEBUG_BUILD) && (0, $1v4ZC.logger).warn('unknown instrumentation type:', type);
            return;
    }
}
function $7f41094ed33359b4$export$285b9172a3741fb7(type, callback) {
    $7f41094ed33359b4$var$handlers[type] = $7f41094ed33359b4$var$handlers[type] || [];
    $7f41094ed33359b4$var$handlers[type].push(callback);
    $7f41094ed33359b4$var$instrument(type);
}
/** JSDoc */ function $7f41094ed33359b4$var$triggerHandlers(type, data) {
    var e_1, _a;
    if (!type || !$7f41094ed33359b4$var$handlers[type]) return;
    try {
        for(var _b = (0, $dT3VW.__values)($7f41094ed33359b4$var$handlers[type] || []), _c = _b.next(); !_c.done; _c = _b.next()){
            var handler = _c.value;
            try {
                handler(data);
            } catch (e) {
                (0, $iuc9e.IS_DEBUG_BUILD) && (0, $1v4ZC.logger).error("Error while triggering instrumentation handler.\nType: " + type + "\nName: " + (0, $b8srE.getFunctionName)(handler) + "\nError:", e);
            }
        }
    } catch (e_1_1) {
        e_1 = {
            error: e_1_1
        };
    } finally{
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        } finally{
            if (e_1) throw e_1.error;
        }
    }
}
/** JSDoc */ function $7f41094ed33359b4$var$instrumentConsole() {
    if (!('console' in $7f41094ed33359b4$var$global)) return;
    (0, $1v4ZC.CONSOLE_LEVELS).forEach(function(level) {
        if (!(level in $7f41094ed33359b4$var$global.console)) return;
        (0, $909Vl.fill)($7f41094ed33359b4$var$global.console, level, function(originalConsoleMethod) {
            return function() {
                var args = [];
                for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
                $7f41094ed33359b4$var$triggerHandlers('console', {
                    args: args,
                    level: level
                });
                // this fails for some browsers. :(
                if (originalConsoleMethod) originalConsoleMethod.apply($7f41094ed33359b4$var$global.console, args);
            };
        });
    });
}
/** JSDoc */ function $7f41094ed33359b4$var$instrumentFetch() {
    if (!(0, $7YVaQ.supportsNativeFetch)()) return;
    (0, $909Vl.fill)($7f41094ed33359b4$var$global, 'fetch', function(originalFetch) {
        return function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            var handlerData = {
                args: args,
                fetchData: {
                    method: $7f41094ed33359b4$var$getFetchMethod(args),
                    url: $7f41094ed33359b4$var$getFetchUrl(args)
                },
                startTimestamp: Date.now()
            };
            $7f41094ed33359b4$var$triggerHandlers('fetch', (0, $dT3VW.__assign)({}, handlerData));
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            return originalFetch.apply($7f41094ed33359b4$var$global, args).then(function(response) {
                $7f41094ed33359b4$var$triggerHandlers('fetch', (0, $dT3VW.__assign)((0, $dT3VW.__assign)({}, handlerData), {
                    endTimestamp: Date.now(),
                    response: response
                }));
                return response;
            }, function(error) {
                $7f41094ed33359b4$var$triggerHandlers('fetch', (0, $dT3VW.__assign)((0, $dT3VW.__assign)({}, handlerData), {
                    endTimestamp: Date.now(),
                    error: error
                }));
                // NOTE: If you are a Sentry user, and you are seeing this stack frame,
                //       it means the sentry.javascript SDK caught an error invoking your application code.
                //       This is expected behavior and NOT indicative of a bug with sentry.javascript.
                throw error;
            });
        };
    });
}
/* eslint-disable @typescript-eslint/no-unsafe-member-access */ /** Extract `method` from fetch call arguments */ function $7f41094ed33359b4$var$getFetchMethod(fetchArgs) {
    if (fetchArgs === void 0) fetchArgs = [];
    if ('Request' in $7f41094ed33359b4$var$global && (0, $8rX8J.isInstanceOf)(fetchArgs[0], Request) && fetchArgs[0].method) return String(fetchArgs[0].method).toUpperCase();
    if (fetchArgs[1] && fetchArgs[1].method) return String(fetchArgs[1].method).toUpperCase();
    return 'GET';
}
/** Extract `url` from fetch call arguments */ function $7f41094ed33359b4$var$getFetchUrl(fetchArgs) {
    if (fetchArgs === void 0) fetchArgs = [];
    if (typeof fetchArgs[0] === 'string') return fetchArgs[0];
    if ('Request' in $7f41094ed33359b4$var$global && (0, $8rX8J.isInstanceOf)(fetchArgs[0], Request)) return fetchArgs[0].url;
    return String(fetchArgs[0]);
}
/* eslint-enable @typescript-eslint/no-unsafe-member-access */ /** JSDoc */ function $7f41094ed33359b4$var$instrumentXHR() {
    if (!('XMLHttpRequest' in $7f41094ed33359b4$var$global)) return;
    var xhrproto = XMLHttpRequest.prototype;
    (0, $909Vl.fill)(xhrproto, 'open', function(originalOpen) {
        return function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            // eslint-disable-next-line @typescript-eslint/no-this-alias
            var xhr = this;
            var url = args[1];
            var xhrInfo = xhr.__sentry_xhr__ = {
                // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
                method: (0, $8rX8J.isString)(args[0]) ? args[0].toUpperCase() : args[0],
                url: args[1]
            };
            // if Sentry key appears in URL, don't capture it as a request
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            if ((0, $8rX8J.isString)(url) && xhrInfo.method === 'POST' && url.match(/sentry_key/)) xhr.__sentry_own_request__ = true;
            var onreadystatechangeHandler = function() {
                if (xhr.readyState === 4) {
                    try {
                        // touching statusCode in some platforms throws
                        // an exception
                        xhrInfo.status_code = xhr.status;
                    } catch (e) {
                    /* do nothing */ }
                    $7f41094ed33359b4$var$triggerHandlers('xhr', {
                        args: args,
                        endTimestamp: Date.now(),
                        startTimestamp: Date.now(),
                        xhr: xhr
                    });
                }
            };
            if ('onreadystatechange' in xhr && typeof xhr.onreadystatechange === 'function') (0, $909Vl.fill)(xhr, 'onreadystatechange', function(original) {
                return function() {
                    var readyStateArgs = [];
                    for(var _i = 0; _i < arguments.length; _i++)readyStateArgs[_i] = arguments[_i];
                    onreadystatechangeHandler();
                    return original.apply(xhr, readyStateArgs);
                };
            });
            else xhr.addEventListener('readystatechange', onreadystatechangeHandler);
            return originalOpen.apply(xhr, args);
        };
    });
    (0, $909Vl.fill)(xhrproto, 'send', function(originalSend) {
        return function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            if (this.__sentry_xhr__ && args[0] !== undefined) this.__sentry_xhr__.body = args[0];
            $7f41094ed33359b4$var$triggerHandlers('xhr', {
                args: args,
                startTimestamp: Date.now(),
                xhr: this
            });
            return originalSend.apply(this, args);
        };
    });
}
var $7f41094ed33359b4$var$lastHref;
/** JSDoc */ function $7f41094ed33359b4$var$instrumentHistory() {
    if (!(0, $7YVaQ.supportsHistory)()) return;
    var oldOnPopState = $7f41094ed33359b4$var$global.onpopstate;
    $7f41094ed33359b4$var$global.onpopstate = function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        var to = $7f41094ed33359b4$var$global.location.href;
        // keep track of the current URL state, as we always receive only the updated state
        var from = $7f41094ed33359b4$var$lastHref;
        $7f41094ed33359b4$var$lastHref = to;
        $7f41094ed33359b4$var$triggerHandlers('history', {
            from: from,
            to: to
        });
        if (oldOnPopState) // Apparently this can throw in Firefox when incorrectly implemented plugin is installed.
        // https://github.com/getsentry/sentry-javascript/issues/3344
        // https://github.com/bugsnag/bugsnag-js/issues/469
        try {
            return oldOnPopState.apply(this, args);
        } catch (_oO) {
        // no-empty
        }
    };
    /** @hidden */ function historyReplacementFunction(originalHistoryFunction) {
        return function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            var url = args.length > 2 ? args[2] : undefined;
            if (url) {
                // coerce to string (this is what pushState does)
                var from = $7f41094ed33359b4$var$lastHref;
                var to = String(url);
                // keep track of the current URL state, as we always receive only the updated state
                $7f41094ed33359b4$var$lastHref = to;
                $7f41094ed33359b4$var$triggerHandlers('history', {
                    from: from,
                    to: to
                });
            }
            return originalHistoryFunction.apply(this, args);
        };
    }
    (0, $909Vl.fill)($7f41094ed33359b4$var$global.history, 'pushState', historyReplacementFunction);
    (0, $909Vl.fill)($7f41094ed33359b4$var$global.history, 'replaceState', historyReplacementFunction);
}
var $7f41094ed33359b4$var$debounceDuration = 1000;
var $7f41094ed33359b4$var$debounceTimerID;
var $7f41094ed33359b4$var$lastCapturedEvent;
/**
 * Decide whether the current event should finish the debounce of previously captured one.
 * @param previous previously captured event
 * @param current event to be captured
 */ function $7f41094ed33359b4$var$shouldShortcircuitPreviousDebounce(previous, current) {
    // If there was no previous event, it should always be swapped for the new one.
    if (!previous) return true;
    // If both events have different type, then user definitely performed two separate actions. e.g. click + keypress.
    if (previous.type !== current.type) return true;
    try {
        // If both events have the same type, it's still possible that actions were performed on different targets.
        // e.g. 2 clicks on different buttons.
        if (previous.target !== current.target) return true;
    } catch (e) {
    // just accessing `target` property can throw an exception in some rare circumstances
    // see: https://github.com/getsentry/sentry-javascript/issues/838
    }
    // If both events have the same type _and_ same `target` (an element which triggered an event, _not necessarily_
    // to which an event listener was attached), we treat them as the same action, as we want to capture
    // only one breadcrumb. e.g. multiple clicks on the same button, or typing inside a user input box.
    return false;
}
/**
 * Decide whether an event should be captured.
 * @param event event to be captured
 */ function $7f41094ed33359b4$var$shouldSkipDOMEvent(event) {
    // We are only interested in filtering `keypress` events for now.
    if (event.type !== 'keypress') return false;
    try {
        var target = event.target;
        if (!target || !target.tagName) return true;
        // Only consider keypress events on actual input elements. This will disregard keypresses targeting body
        // e.g.tabbing through elements, hotkeys, etc.
        if (target.tagName === 'INPUT' || target.tagName === 'TEXTAREA' || target.isContentEditable) return false;
    } catch (e) {
    // just accessing `target` property can throw an exception in some rare circumstances
    // see: https://github.com/getsentry/sentry-javascript/issues/838
    }
    return true;
}
/**
 * Wraps addEventListener to capture UI breadcrumbs
 * @param handler function that will be triggered
 * @param globalListener indicates whether event was captured by the global event listener
 * @returns wrapped breadcrumb events handler
 * @hidden
 */ function $7f41094ed33359b4$var$makeDOMEventHandler(handler, globalListener) {
    if (globalListener === void 0) globalListener = false;
    return function(event) {
        // It's possible this handler might trigger multiple times for the same
        // event (e.g. event propagation through node ancestors).
        // Ignore if we've already captured that event.
        if (!event || $7f41094ed33359b4$var$lastCapturedEvent === event) return;
        // We always want to skip _some_ events.
        if ($7f41094ed33359b4$var$shouldSkipDOMEvent(event)) return;
        var name = event.type === 'keypress' ? 'input' : event.type;
        // If there is no debounce timer, it means that we can safely capture the new event and store it for future comparisons.
        if ($7f41094ed33359b4$var$debounceTimerID === undefined) {
            handler({
                event: event,
                name: name,
                global: globalListener
            });
            $7f41094ed33359b4$var$lastCapturedEvent = event;
        } else if ($7f41094ed33359b4$var$shouldShortcircuitPreviousDebounce($7f41094ed33359b4$var$lastCapturedEvent, event)) {
            handler({
                event: event,
                name: name,
                global: globalListener
            });
            $7f41094ed33359b4$var$lastCapturedEvent = event;
        }
        // Start a new debounce timer that will prevent us from capturing multiple events that should be grouped together.
        clearTimeout($7f41094ed33359b4$var$debounceTimerID);
        $7f41094ed33359b4$var$debounceTimerID = $7f41094ed33359b4$var$global.setTimeout(function() {
            $7f41094ed33359b4$var$debounceTimerID = undefined;
        }, $7f41094ed33359b4$var$debounceDuration);
    };
}
/** JSDoc */ function $7f41094ed33359b4$var$instrumentDOM() {
    if (!('document' in $7f41094ed33359b4$var$global)) return;
    // Make it so that any click or keypress that is unhandled / bubbled up all the way to the document triggers our dom
    // handlers. (Normally we have only one, which captures a breadcrumb for each click or keypress.) Do this before
    // we instrument `addEventListener` so that we don't end up attaching this handler twice.
    var triggerDOMHandler = $7f41094ed33359b4$var$triggerHandlers.bind(null, 'dom');
    var globalDOMEventHandler = $7f41094ed33359b4$var$makeDOMEventHandler(triggerDOMHandler, true);
    $7f41094ed33359b4$var$global.document.addEventListener('click', globalDOMEventHandler, false);
    $7f41094ed33359b4$var$global.document.addEventListener('keypress', globalDOMEventHandler, false);
    // After hooking into click and keypress events bubbled up to `document`, we also hook into user-handled
    // clicks & keypresses, by adding an event listener of our own to any element to which they add a listener. That
    // way, whenever one of their handlers is triggered, ours will be, too. (This is needed because their handler
    // could potentially prevent the event from bubbling up to our global listeners. This way, our handler are still
    // guaranteed to fire at least once.)
    [
        'EventTarget',
        'Node'
    ].forEach(function(target) {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        var proto = $7f41094ed33359b4$var$global[target] && $7f41094ed33359b4$var$global[target].prototype;
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, no-prototype-builtins
        if (!proto || !proto.hasOwnProperty || !proto.hasOwnProperty('addEventListener')) return;
        (0, $909Vl.fill)(proto, 'addEventListener', function(originalAddEventListener) {
            return function(type, listener, options) {
                if (type === 'click' || type == 'keypress') try {
                    var el = this;
                    var handlers_1 = el.__sentry_instrumentation_handlers__ = el.__sentry_instrumentation_handlers__ || {};
                    var handlerForType = handlers_1[type] = handlers_1[type] || {
                        refCount: 0
                    };
                    if (!handlerForType.handler) {
                        var handler = $7f41094ed33359b4$var$makeDOMEventHandler(triggerDOMHandler);
                        handlerForType.handler = handler;
                        originalAddEventListener.call(this, type, handler, options);
                    }
                    handlerForType.refCount += 1;
                } catch (e) {
                // Accessing dom properties is always fragile.
                // Also allows us to skip `addEventListenrs` calls with no proper `this` context.
                }
                return originalAddEventListener.call(this, type, listener, options);
            };
        });
        (0, $909Vl.fill)(proto, 'removeEventListener', function(originalRemoveEventListener) {
            return function(type, listener, options) {
                if (type === 'click' || type == 'keypress') try {
                    var el = this;
                    var handlers_2 = el.__sentry_instrumentation_handlers__ || {};
                    var handlerForType = handlers_2[type];
                    if (handlerForType) {
                        handlerForType.refCount -= 1;
                        // If there are no longer any custom handlers of the current type on this element, we can remove ours, too.
                        if (handlerForType.refCount <= 0) {
                            originalRemoveEventListener.call(this, type, handlerForType.handler, options);
                            handlerForType.handler = undefined;
                            delete handlers_2[type]; // eslint-disable-line @typescript-eslint/no-dynamic-delete
                        }
                        // If there are no longer any custom handlers of any type on this element, cleanup everything.
                        if (Object.keys(handlers_2).length === 0) delete el.__sentry_instrumentation_handlers__;
                    }
                } catch (e) {
                // Accessing dom properties is always fragile.
                // Also allows us to skip `addEventListenrs` calls with no proper `this` context.
                }
                return originalRemoveEventListener.call(this, type, listener, options);
            };
        });
    });
}
var $7f41094ed33359b4$var$_oldOnErrorHandler = null;
/** JSDoc */ function $7f41094ed33359b4$var$instrumentError() {
    $7f41094ed33359b4$var$_oldOnErrorHandler = $7f41094ed33359b4$var$global.onerror;
    $7f41094ed33359b4$var$global.onerror = function(msg, url, line, column, error) {
        $7f41094ed33359b4$var$triggerHandlers('error', {
            column: column,
            error: error,
            line: line,
            msg: msg,
            url: url
        });
        if ($7f41094ed33359b4$var$_oldOnErrorHandler) // eslint-disable-next-line prefer-rest-params
        return $7f41094ed33359b4$var$_oldOnErrorHandler.apply(this, arguments);
        return false;
    };
}
var $7f41094ed33359b4$var$_oldOnUnhandledRejectionHandler = null;
/** JSDoc */ function $7f41094ed33359b4$var$instrumentUnhandledRejection() {
    $7f41094ed33359b4$var$_oldOnUnhandledRejectionHandler = $7f41094ed33359b4$var$global.onunhandledrejection;
    $7f41094ed33359b4$var$global.onunhandledrejection = function(e) {
        $7f41094ed33359b4$var$triggerHandlers('unhandledrejection', e);
        if ($7f41094ed33359b4$var$_oldOnUnhandledRejectionHandler) // eslint-disable-next-line prefer-rest-params
        return $7f41094ed33359b4$var$_oldOnUnhandledRejectionHandler.apply(this, arguments);
        return true;
    };
}

});
parcelRegister("1v4ZC", function(module, exports) {
$parcel$export(module.exports, "CONSOLE_LEVELS", () => $117c8f31aa65bddd$export$2a2b1d2252a69ecb);
$parcel$export(module.exports, "consoleSandbox", () => $117c8f31aa65bddd$export$cda52e2a8927a2ca);
$parcel$export(module.exports, "logger", () => $117c8f31aa65bddd$export$af88d00dbe7f521);

var $dT3VW = parcelRequire("dT3VW");

var $iuc9e = parcelRequire("iuc9e");

var $lrp9R = parcelRequire("lrp9R");
// TODO: Implement different loggers for different environments
var $117c8f31aa65bddd$var$global = (0, $lrp9R.getGlobalObject)();
/** Prefix for logging strings */ var $117c8f31aa65bddd$var$PREFIX = 'Sentry Logger ';
var $117c8f31aa65bddd$export$2a2b1d2252a69ecb = [
    'debug',
    'info',
    'warn',
    'error',
    'log',
    'assert'
];
function $117c8f31aa65bddd$export$cda52e2a8927a2ca(callback) {
    var global = (0, $lrp9R.getGlobalObject)();
    if (!('console' in global)) return callback();
    var originalConsole = global.console;
    var wrappedLevels = {};
    // Restore all wrapped console methods
    $117c8f31aa65bddd$export$2a2b1d2252a69ecb.forEach(function(level) {
        // TODO(v7): Remove this check as it's only needed for Node 6
        var originalWrappedFunc = originalConsole[level] && originalConsole[level].__sentry_original__;
        if (level in global.console && originalWrappedFunc) {
            wrappedLevels[level] = originalConsole[level];
            originalConsole[level] = originalWrappedFunc;
        }
    });
    try {
        return callback();
    } finally{
        // Revert restoration to wrapped state
        Object.keys(wrappedLevels).forEach(function(level) {
            originalConsole[level] = wrappedLevels[level];
        });
    }
}
function $117c8f31aa65bddd$var$makeLogger() {
    var enabled = false;
    var logger = {
        enable: function() {
            enabled = true;
        },
        disable: function() {
            enabled = false;
        }
    };
    if (0, $iuc9e.IS_DEBUG_BUILD) $117c8f31aa65bddd$export$2a2b1d2252a69ecb.forEach(function(name) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        logger[name] = function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            if (enabled) $117c8f31aa65bddd$export$cda52e2a8927a2ca(function() {
                var _a;
                (_a = $117c8f31aa65bddd$var$global.console)[name].apply(_a, (0, $dT3VW.__spread)([
                    $117c8f31aa65bddd$var$PREFIX + "[" + name + "]:"
                ], args));
            });
        };
    });
    else $117c8f31aa65bddd$export$2a2b1d2252a69ecb.forEach(function(name) {
        logger[name] = function() {
            return undefined;
        };
    });
    return logger;
}
// Ensure we only have a single logger instance, even if multiple versions of @sentry/utils are being used
var $117c8f31aa65bddd$export$af88d00dbe7f521;
if (0, $iuc9e.IS_DEBUG_BUILD) $117c8f31aa65bddd$export$af88d00dbe7f521 = (0, $lrp9R.getGlobalSingleton)('logger', $117c8f31aa65bddd$var$makeLogger);
else $117c8f31aa65bddd$export$af88d00dbe7f521 = $117c8f31aa65bddd$var$makeLogger();

});

parcelRegister("909Vl", function(module, exports) {
$parcel$export(module.exports, "fill", () => $68dbcfd11e00a6d4$export$9563e054e6f787fb);
$parcel$export(module.exports, "markFunctionWrapped", () => $68dbcfd11e00a6d4$export$5c1499e2e5d010ae);
$parcel$export(module.exports, "addNonEnumerableProperty", () => $68dbcfd11e00a6d4$export$e73679ffaf56810e);
$parcel$export(module.exports, "getOriginalFunction", () => $68dbcfd11e00a6d4$export$e6cc1e135e2092e5);
$parcel$export(module.exports, "urlEncode", () => $68dbcfd11e00a6d4$export$9ef804feabbcbaf1);
$parcel$export(module.exports, "convertToPlainObject", () => $68dbcfd11e00a6d4$export$62ff257738bf57f5);
$parcel$export(module.exports, "extractExceptionKeysForMessage", () => $68dbcfd11e00a6d4$export$b0244d5063c0b61b);
$parcel$export(module.exports, "dropUndefinedKeys", () => $68dbcfd11e00a6d4$export$d25f2688db1bb433);

var $dT3VW = parcelRequire("dT3VW");

var $f9iVj = parcelRequire("f9iVj");

var $8rX8J = parcelRequire("8rX8J");

var $9k3Oz = parcelRequire("9k3Oz");
function $68dbcfd11e00a6d4$export$9563e054e6f787fb(source, name, replacementFactory) {
    if (!(name in source)) return;
    var original = source[name];
    var wrapped = replacementFactory(original);
    // Make sure it's a function first, as we need to attach an empty prototype for `defineProperties` to work
    // otherwise it'll throw "TypeError: Object.defineProperties called on non-object"
    if (typeof wrapped === 'function') try {
        $68dbcfd11e00a6d4$export$5c1499e2e5d010ae(wrapped, original);
    } catch (_Oo) {
    // This can throw if multiple fill happens on a global object like XMLHttpRequest
    // Fixes https://github.com/getsentry/sentry-javascript/issues/2043
    }
    source[name] = wrapped;
}
function $68dbcfd11e00a6d4$export$e73679ffaf56810e(obj, name, value) {
    Object.defineProperty(obj, name, {
        // enumerable: false, // the default, so we can save on bundle size by not explicitly setting it
        value: value,
        writable: true,
        configurable: true
    });
}
function $68dbcfd11e00a6d4$export$5c1499e2e5d010ae(wrapped, original) {
    var proto = original.prototype || {};
    wrapped.prototype = original.prototype = proto;
    $68dbcfd11e00a6d4$export$e73679ffaf56810e(wrapped, '__sentry_original__', original);
}
function $68dbcfd11e00a6d4$export$e6cc1e135e2092e5(func) {
    return func.__sentry_original__;
}
function $68dbcfd11e00a6d4$export$9ef804feabbcbaf1(object) {
    return Object.keys(object).map(function(key) {
        return encodeURIComponent(key) + "=" + encodeURIComponent(object[key]);
    }).join('&');
}
function $68dbcfd11e00a6d4$export$62ff257738bf57f5(value) {
    var newObj = value;
    if ((0, $8rX8J.isError)(value)) newObj = (0, $dT3VW.__assign)({
        message: value.message,
        name: value.name,
        stack: value.stack
    }, $68dbcfd11e00a6d4$var$getOwnProperties(value));
    else if ((0, $8rX8J.isEvent)(value)) {
        var event_1 = value;
        newObj = (0, $dT3VW.__assign)({
            type: event_1.type,
            target: $68dbcfd11e00a6d4$var$serializeEventTarget(event_1.target),
            currentTarget: $68dbcfd11e00a6d4$var$serializeEventTarget(event_1.currentTarget)
        }, $68dbcfd11e00a6d4$var$getOwnProperties(event_1));
        if (typeof CustomEvent !== 'undefined' && (0, $8rX8J.isInstanceOf)(value, CustomEvent)) newObj.detail = event_1.detail;
    }
    return newObj;
}
/** Creates a string representation of the target of an `Event` object */ function $68dbcfd11e00a6d4$var$serializeEventTarget(target) {
    try {
        return (0, $8rX8J.isElement)(target) ? (0, $f9iVj.htmlTreeAsString)(target) : Object.prototype.toString.call(target);
    } catch (_oO) {
        return '<unknown>';
    }
}
/** Filters out all but an object's own properties */ function $68dbcfd11e00a6d4$var$getOwnProperties(obj) {
    var extractedProps = {};
    for(var property in obj)if (Object.prototype.hasOwnProperty.call(obj, property)) extractedProps[property] = obj[property];
    return extractedProps;
}
function $68dbcfd11e00a6d4$export$b0244d5063c0b61b(exception, maxLength) {
    if (maxLength === void 0) maxLength = 40;
    var keys = Object.keys($68dbcfd11e00a6d4$export$62ff257738bf57f5(exception));
    keys.sort();
    if (!keys.length) return '[object has no keys]';
    if (keys[0].length >= maxLength) return (0, $9k3Oz.truncate)(keys[0], maxLength);
    for(var includedKeys = keys.length; includedKeys > 0; includedKeys--){
        var serialized = keys.slice(0, includedKeys).join(', ');
        if (serialized.length > maxLength) continue;
        if (includedKeys === keys.length) return serialized;
        return (0, $9k3Oz.truncate)(serialized, maxLength);
    }
    return '';
}
function $68dbcfd11e00a6d4$export$d25f2688db1bb433(val) {
    var e_1, _a;
    if ((0, $8rX8J.isPlainObject)(val)) {
        var rv = {};
        try {
            for(var _b = (0, $dT3VW.__values)(Object.keys(val)), _c = _b.next(); !_c.done; _c = _b.next()){
                var key = _c.value;
                if (typeof val[key] !== 'undefined') rv[key] = $68dbcfd11e00a6d4$export$d25f2688db1bb433(val[key]);
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
        return rv;
    }
    if (Array.isArray(val)) return val.map($68dbcfd11e00a6d4$export$d25f2688db1bb433);
    return val;
}
function $68dbcfd11e00a6d4$export$92b78acdbe066b6b(wat) {
    var objectified;
    switch(true){
        case wat === undefined || wat === null:
            objectified = new String(wat);
            break;
        // Though symbols and bigints do have wrapper classes (`Symbol` and `BigInt`, respectively), for whatever reason
        // those classes don't have constructors which can be used with the `new` keyword. We therefore need to cast each as
        // an object in order to wrap it.
        case typeof wat === 'symbol' || typeof wat === 'bigint':
            objectified = Object(wat);
            break;
        // this will catch the remaining primitives: `String`, `Number`, and `Boolean`
        case (0, $8rX8J.isPrimitive)(wat):
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            objectified = new wat.constructor(wat);
            break;
        // by process of elimination, at this point we know that `wat` must already be an object
        default:
            objectified = wat;
            break;
    }
    return objectified;
}

});
parcelRegister("9k3Oz", function(module, exports) {
$parcel$export(module.exports, "truncate", () => $6c98f0cd61ae7fe0$export$6a506b36fdea397d);
$parcel$export(module.exports, "snipLine", () => $6c98f0cd61ae7fe0$export$4215662d762d6f9d);
$parcel$export(module.exports, "safeJoin", () => $6c98f0cd61ae7fe0$export$465e9d514283d4fd);
$parcel$export(module.exports, "isMatchingPattern", () => $6c98f0cd61ae7fe0$export$cdded5b28a5f8c6d);

var $8rX8J = parcelRequire("8rX8J");
function $6c98f0cd61ae7fe0$export$6a506b36fdea397d(str, max) {
    if (max === void 0) max = 0;
    if (typeof str !== 'string' || max === 0) return str;
    return str.length <= max ? str : str.substr(0, max) + "...";
}
function $6c98f0cd61ae7fe0$export$4215662d762d6f9d(line, colno) {
    var newLine = line;
    var lineLength = newLine.length;
    if (lineLength <= 150) return newLine;
    if (colno > lineLength) // eslint-disable-next-line no-param-reassign
    colno = lineLength;
    var start = Math.max(colno - 60, 0);
    if (start < 5) start = 0;
    var end = Math.min(start + 140, lineLength);
    if (end > lineLength - 5) end = lineLength;
    if (end === lineLength) start = Math.max(end - 140, 0);
    newLine = newLine.slice(start, end);
    if (start > 0) newLine = "'{snip} " + newLine;
    if (end < lineLength) newLine += ' {snip}';
    return newLine;
}
function $6c98f0cd61ae7fe0$export$465e9d514283d4fd(input, delimiter) {
    if (!Array.isArray(input)) return '';
    var output = [];
    // eslint-disable-next-line @typescript-eslint/prefer-for-of
    for(var i = 0; i < input.length; i++){
        var value = input[i];
        try {
            output.push(String(value));
        } catch (e) {
            output.push('[value cannot be serialized]');
        }
    }
    return output.join(delimiter);
}
function $6c98f0cd61ae7fe0$export$cdded5b28a5f8c6d(value, pattern) {
    if (!(0, $8rX8J.isString)(value)) return false;
    if ((0, $8rX8J.isRegExp)(pattern)) return pattern.test(value);
    if (typeof pattern === 'string') return value.indexOf(pattern) !== -1;
    return false;
}
function $6c98f0cd61ae7fe0$export$466fc863a824cea6(regexString) {
    // escape the hyphen separately so we can also replace it with a unicode literal hyphen, to avoid the problems
    // discussed in https://github.com/sindresorhus/escape-string-regexp/issues/20.
    return regexString.replace(/[|\\{}()[\]^$+*?.]/g, '\\$&').replace(/-/g, '\\x2d');
}

});


parcelRegister("b8srE", function(module, exports) {
$parcel$export(module.exports, "createStackParser", () => $81b681a083912fb6$export$a5739666fb2d03d4);
$parcel$export(module.exports, "getFunctionName", () => $81b681a083912fb6$export$aad197c7121a6651);

var $dT3VW = parcelRequire("dT3VW");
var $81b681a083912fb6$var$STACKTRACE_LIMIT = 50;
function $81b681a083912fb6$export$a5739666fb2d03d4() {
    var parsers = [];
    for(var _i = 0; _i < arguments.length; _i++)parsers[_i] = arguments[_i];
    var sortedParsers = parsers.sort(function(a, b) {
        return a[0] - b[0];
    }).map(function(p) {
        return p[1];
    });
    return function(stack, skipFirst) {
        var e_1, _a, e_2, _b;
        if (skipFirst === void 0) skipFirst = 0;
        var frames = [];
        try {
            for(var _c = (0, $dT3VW.__values)(stack.split('\n').slice(skipFirst)), _d = _c.next(); !_d.done; _d = _c.next()){
                var line = _d.value;
                try {
                    for(var sortedParsers_1 = (e_2 = void 0, (0, $dT3VW.__values)(sortedParsers)), sortedParsers_1_1 = sortedParsers_1.next(); !sortedParsers_1_1.done; sortedParsers_1_1 = sortedParsers_1.next()){
                        var parser = sortedParsers_1_1.value;
                        var frame = parser(line);
                        if (frame) {
                            frames.push(frame);
                            break;
                        }
                    }
                } catch (e_2_1) {
                    e_2 = {
                        error: e_2_1
                    };
                } finally{
                    try {
                        if (sortedParsers_1_1 && !sortedParsers_1_1.done && (_b = sortedParsers_1.return)) _b.call(sortedParsers_1);
                    } finally{
                        if (e_2) throw e_2.error;
                    }
                }
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
        return $81b681a083912fb6$export$c55c24c0eeba0205(frames);
    };
}
function $81b681a083912fb6$export$c55c24c0eeba0205(stack) {
    if (!stack.length) return [];
    var localStack = stack;
    var firstFrameFunction = localStack[0].function || '';
    var lastFrameFunction = localStack[localStack.length - 1].function || '';
    // If stack starts with one of our API calls, remove it (starts, meaning it's the top of the stack - aka last call)
    if (firstFrameFunction.indexOf('captureMessage') !== -1 || firstFrameFunction.indexOf('captureException') !== -1) localStack = localStack.slice(1);
    // If stack ends with one of our internal API calls, remove it (ends, meaning it's the bottom of the stack - aka top-most call)
    if (lastFrameFunction.indexOf('sentryWrapped') !== -1) localStack = localStack.slice(0, -1);
    // The frame where the crash happened, should be the last entry in the array
    return localStack.slice(0, $81b681a083912fb6$var$STACKTRACE_LIMIT).map(function(frame) {
        return (0, $dT3VW.__assign)((0, $dT3VW.__assign)({}, frame), {
            filename: frame.filename || localStack[0].filename,
            function: frame.function || '?'
        });
    }).reverse();
}
var $81b681a083912fb6$var$defaultFunctionName = '<anonymous>';
function $81b681a083912fb6$export$aad197c7121a6651(fn) {
    try {
        if (!fn || typeof fn !== 'function') return $81b681a083912fb6$var$defaultFunctionName;
        return fn.name || $81b681a083912fb6$var$defaultFunctionName;
    } catch (e) {
        // Just accessing custom props in some Selenium environments
        // can cause a "Permission denied" exception (see raven-js#495).
        return $81b681a083912fb6$var$defaultFunctionName;
    }
}

});

parcelRegister("7YVaQ", function(module, exports) {
$parcel$export(module.exports, "supportsFetch", () => $5cfa7c881be62025$export$edf3cb81fd7d2a3e);
$parcel$export(module.exports, "isNativeFetch", () => $5cfa7c881be62025$export$18cf36ed71d733e7);
$parcel$export(module.exports, "supportsNativeFetch", () => $5cfa7c881be62025$export$c82d238e23c40b21);
$parcel$export(module.exports, "supportsReportingObserver", () => $5cfa7c881be62025$export$531055a6c684a70a);
$parcel$export(module.exports, "supportsReferrerPolicy", () => $5cfa7c881be62025$export$2d308b428295192f);
$parcel$export(module.exports, "supportsHistory", () => $5cfa7c881be62025$export$67fc34576016d6ec);

var $iuc9e = parcelRequire("iuc9e");

var $lrp9R = parcelRequire("lrp9R");

var $1v4ZC = parcelRequire("1v4ZC");
function $5cfa7c881be62025$export$caa710b4d7f9cadf() {
    try {
        new ErrorEvent('');
        return true;
    } catch (e) {
        return false;
    }
}
function $5cfa7c881be62025$export$1c08bd1a7eb3c472() {
    try {
        // Chrome: VM89:1 Uncaught TypeError: Failed to construct 'DOMError':
        // 1 argument required, but only 0 present.
        // @ts-ignore It really needs 1 argument, not 0.
        new DOMError('');
        return true;
    } catch (e) {
        return false;
    }
}
function $5cfa7c881be62025$export$ab12a5d056f1d3a() {
    try {
        new DOMException('');
        return true;
    } catch (e) {
        return false;
    }
}
function $5cfa7c881be62025$export$edf3cb81fd7d2a3e() {
    if (!('fetch' in (0, $lrp9R.getGlobalObject)())) return false;
    try {
        new Headers();
        new Request('');
        new Response();
        return true;
    } catch (e) {
        return false;
    }
}
function $5cfa7c881be62025$export$18cf36ed71d733e7(func) {
    return func && /^function fetch\(\)\s+\{\s+\[native code\]\s+\}$/.test(func.toString());
}
function $5cfa7c881be62025$export$c82d238e23c40b21() {
    if (!$5cfa7c881be62025$export$edf3cb81fd7d2a3e()) return false;
    var global = (0, $lrp9R.getGlobalObject)();
    // Fast path to avoid DOM I/O
    // eslint-disable-next-line @typescript-eslint/unbound-method
    if ($5cfa7c881be62025$export$18cf36ed71d733e7(global.fetch)) return true;
    // window.fetch is implemented, but is polyfilled or already wrapped (e.g: by a chrome extension)
    // so create a "pure" iframe to see if that has native fetch
    var result = false;
    var doc = global.document;
    // eslint-disable-next-line deprecation/deprecation
    if (doc && typeof doc.createElement === 'function') try {
        var sandbox = doc.createElement('iframe');
        sandbox.hidden = true;
        doc.head.appendChild(sandbox);
        if (sandbox.contentWindow && sandbox.contentWindow.fetch) // eslint-disable-next-line @typescript-eslint/unbound-method
        result = $5cfa7c881be62025$export$18cf36ed71d733e7(sandbox.contentWindow.fetch);
        doc.head.removeChild(sandbox);
    } catch (err) {
        (0, $iuc9e.IS_DEBUG_BUILD) && (0, $1v4ZC.logger).warn('Could not create sandbox iframe for pure fetch check, bailing to window.fetch: ', err);
    }
    return result;
}
function $5cfa7c881be62025$export$531055a6c684a70a() {
    return 'ReportingObserver' in (0, $lrp9R.getGlobalObject)();
}
function $5cfa7c881be62025$export$2d308b428295192f() {
    // Despite all stars in the sky saying that Edge supports old draft syntax, aka 'never', 'always', 'origin' and 'default'
    // (see https://caniuse.com/#feat=referrer-policy),
    // it doesn't. And it throws an exception instead of ignoring this parameter...
    // REF: https://github.com/getsentry/raven-js/issues/1233
    if (!$5cfa7c881be62025$export$edf3cb81fd7d2a3e()) return false;
    try {
        new Request('_', {
            referrerPolicy: 'origin'
        });
        return true;
    } catch (e) {
        return false;
    }
}
function $5cfa7c881be62025$export$67fc34576016d6ec() {
    // NOTE: in Chrome App environment, touching history.pushState, *even inside
    //       a try/catch block*, will cause Chrome to output an error to console.error
    // borrowed from: https://github.com/angular/angular.js/pull/13945/files
    var global = (0, $lrp9R.getGlobalObject)();
    /* eslint-disable @typescript-eslint/no-unsafe-member-access */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var chrome = global.chrome;
    var isChromePackagedApp = chrome && chrome.app && chrome.app.runtime;
    /* eslint-enable @typescript-eslint/no-unsafe-member-access */ var hasHistoryApi = 'history' in global && !!global.history.pushState && !!global.history.replaceState;
    return !isChromePackagedApp && hasHistoryApi;
}

});


parcelRegister("73JtC", function(module, exports) {
$parcel$export(module.exports, "uuid4", () => $523c16f3b9d02706$export$19f53698e68b2496);
$parcel$export(module.exports, "parseUrl", () => $523c16f3b9d02706$export$7a5253c0f62e0150);
$parcel$export(module.exports, "getEventDescription", () => $523c16f3b9d02706$export$4157119e2b157127);
$parcel$export(module.exports, "addExceptionTypeValue", () => $523c16f3b9d02706$export$f26508487bf83ee7);
$parcel$export(module.exports, "addExceptionMechanism", () => $523c16f3b9d02706$export$c69a9a0313b03bb1);
$parcel$export(module.exports, "checkOrSetAlreadyCaught", () => $523c16f3b9d02706$export$6de4ffac6a2f1098);

var $dT3VW = parcelRequire("dT3VW");

var $lrp9R = parcelRequire("lrp9R");

var $909Vl = parcelRequire("909Vl");

var $9k3Oz = parcelRequire("9k3Oz");
function $523c16f3b9d02706$export$19f53698e68b2496() {
    var global = (0, $lrp9R.getGlobalObject)();
    var crypto = global.crypto || global.msCrypto;
    if (!(crypto === void 0) && crypto.getRandomValues) {
        // Use window.crypto API if available
        var arr = new Uint16Array(8);
        crypto.getRandomValues(arr);
        // set 4 in byte 7
        // eslint-disable-next-line no-bitwise
        arr[3] = arr[3] & 0xfff | 0x4000;
        // set 2 most significant bits of byte 9 to '10'
        // eslint-disable-next-line no-bitwise
        arr[4] = arr[4] & 0x3fff | 0x8000;
        var pad = function(num) {
            var v = num.toString(16);
            while(v.length < 4)v = "0" + v;
            return v;
        };
        return pad(arr[0]) + pad(arr[1]) + pad(arr[2]) + pad(arr[3]) + pad(arr[4]) + pad(arr[5]) + pad(arr[6]) + pad(arr[7]);
    }
    // http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript/2117523#2117523
    return 'xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
        // eslint-disable-next-line no-bitwise
        var r = Math.random() * 16 | 0;
        // eslint-disable-next-line no-bitwise
        var v = c === 'x' ? r : r & 0x3 | 0x8;
        return v.toString(16);
    });
}
function $523c16f3b9d02706$export$7a5253c0f62e0150(url) {
    if (!url) return {};
    var match = url.match(/^(([^:/?#]+):)?(\/\/([^/?#]*))?([^?#]*)(\?([^#]*))?(#(.*))?$/);
    if (!match) return {};
    // coerce to undefined values to empty string so we don't get 'undefined'
    var query = match[6] || '';
    var fragment = match[8] || '';
    return {
        host: match[4],
        path: match[5],
        protocol: match[2],
        relative: match[5] + query + fragment
    };
}
function $523c16f3b9d02706$var$getFirstException(event) {
    return event.exception && event.exception.values ? event.exception.values[0] : undefined;
}
function $523c16f3b9d02706$export$4157119e2b157127(event) {
    var message = event.message, eventId = event.event_id;
    if (message) return message;
    var firstException = $523c16f3b9d02706$var$getFirstException(event);
    if (firstException) {
        if (firstException.type && firstException.value) return firstException.type + ": " + firstException.value;
        return firstException.type || firstException.value || eventId || '<unknown>';
    }
    return eventId || '<unknown>';
}
function $523c16f3b9d02706$export$f26508487bf83ee7(event, value, type) {
    var exception = event.exception = event.exception || {};
    var values = exception.values = exception.values || [];
    var firstException = values[0] = values[0] || {};
    if (!firstException.value) firstException.value = value || '';
    if (!firstException.type) firstException.type = type || 'Error';
}
function $523c16f3b9d02706$export$c69a9a0313b03bb1(event, newMechanism) {
    var firstException = $523c16f3b9d02706$var$getFirstException(event);
    if (!firstException) return;
    var defaultMechanism = {
        type: 'generic',
        handled: true
    };
    var currentMechanism = firstException.mechanism;
    firstException.mechanism = (0, $dT3VW.__assign)((0, $dT3VW.__assign)((0, $dT3VW.__assign)({}, defaultMechanism), currentMechanism), newMechanism);
    if (newMechanism && 'data' in newMechanism) {
        var mergedData = (0, $dT3VW.__assign)((0, $dT3VW.__assign)({}, currentMechanism && currentMechanism.data), newMechanism.data);
        firstException.mechanism.data = mergedData;
    }
}
// https://semver.org/#is-there-a-suggested-regular-expression-regex-to-check-a-semver-string
var $523c16f3b9d02706$var$SEMVER_REGEXP = /^(0|[1-9]\d*)\.(0|[1-9]\d*)\.(0|[1-9]\d*)(?:-((?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*)(?:\.(?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*))*))?(?:\+([0-9a-zA-Z-]+(?:\.[0-9a-zA-Z-]+)*))?$/;
function $523c16f3b9d02706$export$d364f2020ab30578(input) {
    var match = input.match($523c16f3b9d02706$var$SEMVER_REGEXP) || [];
    var major = parseInt(match[1], 10);
    var minor = parseInt(match[2], 10);
    var patch = parseInt(match[3], 10);
    return {
        buildmetadata: match[5],
        major: isNaN(major) ? undefined : major,
        minor: isNaN(minor) ? undefined : minor,
        patch: isNaN(patch) ? undefined : patch,
        prerelease: match[4]
    };
}
function $523c16f3b9d02706$export$ec2291bfc64632f0(lines, frame, linesOfContext) {
    if (linesOfContext === void 0) linesOfContext = 5;
    var lineno = frame.lineno || 0;
    var maxLines = lines.length;
    var sourceLine = Math.max(Math.min(maxLines, lineno - 1), 0);
    frame.pre_context = lines.slice(Math.max(0, sourceLine - linesOfContext), sourceLine).map(function(line) {
        return (0, $9k3Oz.snipLine)(line, 0);
    });
    frame.context_line = (0, $9k3Oz.snipLine)(lines[Math.min(maxLines - 1, sourceLine)], frame.colno || 0);
    frame.post_context = lines.slice(Math.min(sourceLine + 1, maxLines), sourceLine + 1 + linesOfContext).map(function(line) {
        return (0, $9k3Oz.snipLine)(line, 0);
    });
}
function $523c16f3b9d02706$export$ce084c78234bd35(urlPath) {
    // eslint-disable-next-line no-useless-escape
    return urlPath.split(/[\?#]/, 1)[0];
}
function $523c16f3b9d02706$export$6de4ffac6a2f1098(exception) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    if (exception && exception.__sentry_captured__) return true;
    try {
        // set it this way rather than by assignment so that it's not ennumerable and therefore isn't recorded by the
        // `ExtraErrorData` integration
        (0, $909Vl.addNonEnumerableProperty)(exception, '__sentry_captured__', true);
    } catch (err) {
    // `exception` is a primitive, so we can't mark it seen
    }
    return false;
}

});

parcelRegister("bZWF1", function(module, exports) {
$parcel$export(module.exports, "normalize", () => $8bc2e4fa750aec36$export$a3295358bff77e);
$parcel$export(module.exports, "normalizeToSize", () => $8bc2e4fa750aec36$export$23fbbb20bed71033);

var $dT3VW = parcelRequire("dT3VW");

var $8rX8J = parcelRequire("8rX8J");

var $6ncOC = parcelRequire("6ncOC");

var $909Vl = parcelRequire("909Vl");

var $b8srE = parcelRequire("b8srE");
function $8bc2e4fa750aec36$export$a3295358bff77e(input, depth, maxProperties) {
    if (depth === void 0) depth = Infinity;
    if (maxProperties === void 0) maxProperties = Infinity;
    try {
        // since we're at the outermost level, there is no key
        return $8bc2e4fa750aec36$export$588732934346abbf('', input, depth, maxProperties);
    } catch (err) {
        return {
            ERROR: "**non-serializable** (" + err + ")"
        };
    }
}
function $8bc2e4fa750aec36$export$23fbbb20bed71033(object, // Default Node.js REPL depth
depth, // 100kB, as 200kB is max payload size, so half sounds reasonable
maxSize) {
    if (depth === void 0) depth = 3;
    if (maxSize === void 0) maxSize = 102400;
    var normalized = $8bc2e4fa750aec36$export$a3295358bff77e(object, depth);
    if ($8bc2e4fa750aec36$var$jsonSize(normalized) > maxSize) return $8bc2e4fa750aec36$export$23fbbb20bed71033(object, depth - 1, maxSize);
    return normalized;
}
/**
 * Visits a node to perform normalization on it
 *
 * @param key The key corresponding to the given node
 * @param value The node to be visited
 * @param depth Optional number indicating the maximum recursion depth
 * @param maxProperties Optional maximum number of properties/elements included in any single object/array
 * @param memo Optional Memo class handling decycling
 */ function $8bc2e4fa750aec36$export$588732934346abbf(key, value, depth, maxProperties, memo) {
    if (depth === void 0) depth = Infinity;
    if (maxProperties === void 0) maxProperties = Infinity;
    if (memo === void 0) memo = (0, $6ncOC.memoBuilder)();
    var _a = (0, $dT3VW.__read)(memo, 2), memoize = _a[0], unmemoize = _a[1];
    // If the value has a `toJSON` method, see if we can bail and let it do the work
    var valueWithToJSON = value;
    if (valueWithToJSON && typeof valueWithToJSON.toJSON === 'function') try {
        return valueWithToJSON.toJSON();
    } catch (err) {
    // pass (The built-in `toJSON` failed, but we can still try to do it ourselves)
    }
    // Get the simple cases out of the way first
    if (value === null || [
        'number',
        'boolean',
        'string'
    ].includes(typeof value) && !(0, $8rX8J.isNaN)(value)) return value;
    var stringified = $8bc2e4fa750aec36$var$stringifyValue(key, value);
    // Anything we could potentially dig into more (objects or arrays) will have come back as `"[object XXXX]"`.
    // Everything else will have already been serialized, so if we don't see that pattern, we're done.
    if (!stringified.startsWith('[object ')) return stringified;
    // We're also done if we've reached the max depth
    if (depth === 0) // At this point we know `serialized` is a string of the form `"[object XXXX]"`. Clean it up so it's just `"[XXXX]"`.
    return stringified.replace('object ', '');
    // If we've already visited this branch, bail out, as it's circular reference. If not, note that we're seeing it now.
    if (memoize(value)) return '[Circular ~]';
    // At this point we know we either have an object or an array, we haven't seen it before, and we're going to recurse
    // because we haven't yet reached the max depth. Create an accumulator to hold the results of visiting each
    // property/entry, and keep track of the number of items we add to it.
    var normalized = Array.isArray(value) ? [] : {};
    var numAdded = 0;
    // Before we begin, convert`Error` and`Event` instances into plain objects, since some of each of their relevant
    // properties are non-enumerable and otherwise would get missed.
    var visitable = (0, $8rX8J.isError)(value) || (0, $8rX8J.isEvent)(value) ? (0, $909Vl.convertToPlainObject)(value) : value;
    for(var visitKey in visitable){
        // Avoid iterating over fields in the prototype if they've somehow been exposed to enumeration.
        if (!Object.prototype.hasOwnProperty.call(visitable, visitKey)) continue;
        if (numAdded >= maxProperties) {
            normalized[visitKey] = '[MaxProperties ~]';
            break;
        }
        // Recursively visit all the child nodes
        var visitValue = visitable[visitKey];
        normalized[visitKey] = $8bc2e4fa750aec36$export$588732934346abbf(visitKey, visitValue, depth - 1, maxProperties, memo);
        numAdded += 1;
    }
    // Once we've visited all the branches, remove the parent from memo storage
    unmemoize(value);
    // Return accumulated values
    return normalized;
}
/**
 * Stringify the given value. Handles various known special values and types.
 *
 * Not meant to be used on simple primitives which already have a string representation, as it will, for example, turn
 * the number 1231 into "[Object Number]", nor on `null`, as it will throw.
 *
 * @param value The value to stringify
 * @returns A stringified representation of the given value
 */ function $8bc2e4fa750aec36$var$stringifyValue(key, // this type is a tiny bit of a cheat, since this function does handle NaN (which is technically a number), but for
// our internal use, it'll do
value) {
    try {
        if (key === 'domain' && value && typeof value === 'object' && value._events) return '[Domain]';
        if (key === 'domainEmitter') return '[DomainEmitter]';
        // It's safe to use `global`, `window`, and `document` here in this manner, as we are asserting using `typeof` first
        // which won't throw if they are not present.
        if (typeof $parcel$global !== 'undefined' && value === $parcel$global) return '[Global]';
        // eslint-disable-next-line no-restricted-globals
        if (typeof window !== 'undefined' && value === window) return '[Window]';
        // eslint-disable-next-line no-restricted-globals
        if (typeof document !== 'undefined' && value === document) return '[Document]';
        // React's SyntheticEvent thingy
        if ((0, $8rX8J.isSyntheticEvent)(value)) return '[SyntheticEvent]';
        if (typeof value === 'number' && value !== value) return '[NaN]';
        // this catches `undefined` (but not `null`, which is a primitive and can be serialized on its own)
        if (value === void 0) return '[undefined]';
        if (typeof value === 'function') return "[Function: " + (0, $b8srE.getFunctionName)(value) + "]";
        if (typeof value === 'symbol') return "[" + String(value) + "]";
        // stringified BigInts are indistinguishable from regular numbers, so we need to label them to avoid confusion
        if (typeof value === 'bigint') return "[BigInt: " + String(value) + "]";
        // Now that we've knocked out all the special cases and the primitives, all we have left are objects. Simply casting
        // them to strings means that instances of classes which haven't defined their `toStringTag` will just come out as
        // `"[object Object]"`. If we instead look at the constructor's name (which is the same as the name of the class),
        // we can make sure that only plain objects come out that way.
        return "[object " + Object.getPrototypeOf(value).constructor.name + "]";
    } catch (err) {
        return "**non-serializable** (" + err + ")";
    }
}
/** Calculates bytes size of input string */ function $8bc2e4fa750aec36$var$utf8Length(value) {
    // eslint-disable-next-line no-bitwise
    return ~-encodeURI(value).split(/%..|./).length;
}
/** Calculates bytes size of input object */ function $8bc2e4fa750aec36$var$jsonSize(value) {
    return $8bc2e4fa750aec36$var$utf8Length(JSON.stringify(value));
}

});
parcelRegister("6ncOC", function(module, exports) {
$parcel$export(module.exports, "memoBuilder", () => $4a3ed4eafd8f719a$export$8115b0b78e956ab3);
/* eslint-disable @typescript-eslint/no-unsafe-member-access */ /* eslint-disable @typescript-eslint/no-explicit-any */ /**
 * Helper to decycle json objects
 */ function $4a3ed4eafd8f719a$export$8115b0b78e956ab3() {
    var hasWeakSet = typeof WeakSet === 'function';
    var inner = hasWeakSet ? new WeakSet() : [];
    function memoize(obj) {
        if (hasWeakSet) {
            if (inner.has(obj)) return true;
            inner.add(obj);
            return false;
        }
        // eslint-disable-next-line @typescript-eslint/prefer-for-of
        for(var i = 0; i < inner.length; i++){
            var value = inner[i];
            if (value === obj) return true;
        }
        inner.push(obj);
        return false;
    }
    function unmemoize(obj) {
        if (hasWeakSet) inner.delete(obj);
        else {
            for(var i = 0; i < inner.length; i++)if (inner[i] === obj) {
                inner.splice(i, 1);
                break;
            }
        }
    }
    return [
        memoize,
        unmemoize
    ];
}

});


parcelRegister("39Zfw", function(module, exports) {
$parcel$export(module.exports, "relative", () => $24d1b93b84f78f43$export$f0e7d1106eeabbe6);
$parcel$export(module.exports, "basename", () => $24d1b93b84f78f43$export$9bf319d8f74f51d1);
// Slightly modified (no IE8 support, ES6) and transcribed to TypeScript
// https://raw.githubusercontent.com/calvinmetcalf/rollup-plugin-node-builtins/master/src/es6/path.js
/** JSDoc */ function $24d1b93b84f78f43$var$normalizeArray(parts, allowAboveRoot) {
    // if the path tries to go above the root, `up` ends up > 0
    var up = 0;
    for(var i = parts.length - 1; i >= 0; i--){
        var last = parts[i];
        if (last === '.') parts.splice(i, 1);
        else if (last === '..') {
            parts.splice(i, 1);
            // eslint-disable-next-line no-plusplus
            up++;
        } else if (up) {
            parts.splice(i, 1);
            // eslint-disable-next-line no-plusplus
            up--;
        }
    }
    // if the path is allowed to go above the root, restore leading ..s
    if (allowAboveRoot) // eslint-disable-next-line no-plusplus
    for(; up--; up)parts.unshift('..');
    return parts;
}
// Split a filename into [root, dir, basename, ext], unix version
// 'root' is just a slash, or nothing.
var $24d1b93b84f78f43$var$splitPathRe = /^(\/?|)([\s\S]*?)((?:\.{1,2}|[^/]+?|)(\.[^./]*|))(?:[/]*)$/;
/** JSDoc */ function $24d1b93b84f78f43$var$splitPath(filename) {
    var parts = $24d1b93b84f78f43$var$splitPathRe.exec(filename);
    return parts ? parts.slice(1) : [];
}
function $24d1b93b84f78f43$export$f7ad0328861e2f03() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    var resolvedPath = '';
    var resolvedAbsolute = false;
    for(var i = args.length - 1; i >= -1 && !resolvedAbsolute; i--){
        var path = i >= 0 ? args[i] : '/';
        // Skip empty entries
        if (!path) continue;
        resolvedPath = path + "/" + resolvedPath;
        resolvedAbsolute = path.charAt(0) === '/';
    }
    // At this point the path should be resolved to a full absolute path, but
    // handle relative paths to be safe (might happen when process.cwd() fails)
    // Normalize the path
    resolvedPath = $24d1b93b84f78f43$var$normalizeArray(resolvedPath.split('/').filter(function(p) {
        return !!p;
    }), !resolvedAbsolute).join('/');
    return (resolvedAbsolute ? '/' : '') + resolvedPath || '.';
}
/** JSDoc */ function $24d1b93b84f78f43$var$trim(arr) {
    var start = 0;
    for(; start < arr.length; start++){
        if (arr[start] !== '') break;
    }
    var end = arr.length - 1;
    for(; end >= 0; end--){
        if (arr[end] !== '') break;
    }
    if (start > end) return [];
    return arr.slice(start, end - start + 1);
}
function $24d1b93b84f78f43$export$f0e7d1106eeabbe6(from, to) {
    /* eslint-disable no-param-reassign */ from = $24d1b93b84f78f43$export$f7ad0328861e2f03(from).substr(1);
    to = $24d1b93b84f78f43$export$f7ad0328861e2f03(to).substr(1);
    /* eslint-enable no-param-reassign */ var fromParts = $24d1b93b84f78f43$var$trim(from.split('/'));
    var toParts = $24d1b93b84f78f43$var$trim(to.split('/'));
    var length = Math.min(fromParts.length, toParts.length);
    var samePartsLength = length;
    for(var i = 0; i < length; i++)if (fromParts[i] !== toParts[i]) {
        samePartsLength = i;
        break;
    }
    var outputParts = [];
    for(var i = samePartsLength; i < fromParts.length; i++)outputParts.push('..');
    outputParts = outputParts.concat(toParts.slice(samePartsLength));
    return outputParts.join('/');
}
function $24d1b93b84f78f43$export$6af368f973c74c5(path) {
    var isPathAbsolute = $24d1b93b84f78f43$export$e434c7255acda994(path);
    var trailingSlash = path.substr(-1) === '/';
    // Normalize the path
    var normalizedPath = $24d1b93b84f78f43$var$normalizeArray(path.split('/').filter(function(p) {
        return !!p;
    }), !isPathAbsolute).join('/');
    if (!normalizedPath && !isPathAbsolute) normalizedPath = '.';
    if (normalizedPath && trailingSlash) normalizedPath += '/';
    return (isPathAbsolute ? '/' : '') + normalizedPath;
}
function $24d1b93b84f78f43$export$e434c7255acda994(path) {
    return path.charAt(0) === '/';
}
function $24d1b93b84f78f43$export$f7e2c8231c57a8bd() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    return $24d1b93b84f78f43$export$6af368f973c74c5(args.join('/'));
}
function $24d1b93b84f78f43$export$7f7b8152cc673abe(path) {
    var result = $24d1b93b84f78f43$var$splitPath(path);
    var root = result[0];
    var dir = result[1];
    if (!root && !dir) // No dirname whatsoever
    return '.';
    if (dir) // It has a dirname, strip trailing slash
    dir = dir.substr(0, dir.length - 1);
    return root + dir;
}
function $24d1b93b84f78f43$export$9bf319d8f74f51d1(path, ext) {
    var f = $24d1b93b84f78f43$var$splitPath(path)[2];
    if (ext && f.substr(ext.length * -1) === ext) f = f.substr(0, f.length - ext.length);
    return f;
}

});

parcelRegister("bUAoW", function(module, exports) {
$parcel$export(module.exports, "makePromiseBuffer", () => $8ac12939fa13e8f5$export$85a4f67f852183e6);

var $iMWNA = parcelRequire("iMWNA");

var $bdF5c = parcelRequire("bdF5c");
function $8ac12939fa13e8f5$export$85a4f67f852183e6(limit) {
    var buffer = [];
    function isReady() {
        return limit === undefined || buffer.length < limit;
    }
    /**
     * Remove a promise from the queue.
     *
     * @param task Can be any PromiseLike<T>
     * @returns Removed promise.
     */ function remove(task) {
        return buffer.splice(buffer.indexOf(task), 1)[0];
    }
    /**
     * Add a promise (representing an in-flight action) to the queue, and set it to remove itself on fulfillment.
     *
     * @param taskProducer A function producing any PromiseLike<T>; In previous versions this used to be `task:
     *        PromiseLike<T>`, but under that model, Promises were instantly created on the call-site and their executor
     *        functions therefore ran immediately. Thus, even if the buffer was full, the action still happened. By
     *        requiring the promise to be wrapped in a function, we can defer promise creation until after the buffer
     *        limit check.
     * @returns The original promise.
     */ function add(taskProducer) {
        if (!isReady()) return (0, $bdF5c.rejectedSyncPromise)(new (0, $iMWNA.SentryError)('Not adding Promise due to buffer limit reached.'));
        // start the task and add its promise to the queue
        var task = taskProducer();
        if (buffer.indexOf(task) === -1) buffer.push(task);
        task.then(function() {
            return remove(task);
        })// Use `then(null, rejectionHandler)` rather than `catch(rejectionHandler)` so that we can use `PromiseLike`
        // rather than `Promise`. `PromiseLike` doesn't have a `.catch` method, making its polyfill smaller. (ES5 didn't
        // have promises, so TS has to polyfill when down-compiling.)
        .then(null, function() {
            return remove(task).then(null, function() {
            // We have to add another catch here because `remove()` starts a new promise chain.
            });
        });
        return task;
    }
    /**
     * Wait for all promises in the queue to resolve or for timeout to expire, whichever comes first.
     *
     * @param timeout The time, in ms, after which to resolve to `false` if the queue is still non-empty. Passing `0` (or
     * not passing anything) will make the promise wait as long as it takes for the queue to drain before resolving to
     * `true`.
     * @returns A promise which will resolve to `true` if the queue is already empty or drains before the timeout, and
     * `false` otherwise
     */ function drain(timeout) {
        return new (0, $bdF5c.SyncPromise)(function(resolve, reject) {
            var counter = buffer.length;
            if (!counter) return resolve(true);
            // wait for `timeout` ms and then resolve to `false` (if not cancelled first)
            var capturedSetTimeout = setTimeout(function() {
                if (timeout && timeout > 0) resolve(false);
            }, timeout);
            // if all promises resolve in time, cancel the timer and resolve to `true`
            buffer.forEach(function(item) {
                (0, $bdF5c.resolvedSyncPromise)(item).then(function() {
                    // eslint-disable-next-line no-plusplus
                    if (!--counter) {
                        clearTimeout(capturedSetTimeout);
                        resolve(true);
                    }
                }, reject);
            });
        });
    }
    return {
        $: buffer,
        add: add,
        drain: drain
    };
}

});
parcelRegister("bdF5c", function(module, exports) {
$parcel$export(module.exports, "resolvedSyncPromise", () => $82b0c6d0fe80f282$export$1fda8aa4d135f8aa);
$parcel$export(module.exports, "SyncPromise", () => $82b0c6d0fe80f282$export$6f292d4960313241);
$parcel$export(module.exports, "rejectedSyncPromise", () => $82b0c6d0fe80f282$export$78e43115b553f358);
/* eslint-disable @typescript-eslint/explicit-function-return-type */ /* eslint-disable @typescript-eslint/typedef */ /* eslint-disable @typescript-eslint/explicit-module-boundary-types */ /* eslint-disable @typescript-eslint/no-explicit-any */ 
var $8rX8J = parcelRequire("8rX8J");
function $82b0c6d0fe80f282$export$1fda8aa4d135f8aa(value) {
    return new $82b0c6d0fe80f282$export$6f292d4960313241(function(resolve) {
        resolve(value);
    });
}
function $82b0c6d0fe80f282$export$78e43115b553f358(reason) {
    return new $82b0c6d0fe80f282$export$6f292d4960313241(function(_, reject) {
        reject(reason);
    });
}
/**
 * Thenable class that behaves like a Promise and follows it's interface
 * but is not async internally
 */ var $82b0c6d0fe80f282$export$6f292d4960313241 = /** @class */ function() {
    function SyncPromise(executor) {
        var _this = this;
        this._state = 0 /* PENDING */ ;
        this._handlers = [];
        /** JSDoc */ this._resolve = function(value) {
            _this._setResult(1 /* RESOLVED */ , value);
        };
        /** JSDoc */ this._reject = function(reason) {
            _this._setResult(2 /* REJECTED */ , reason);
        };
        /** JSDoc */ this._setResult = function(state, value) {
            if (_this._state !== 0 /* PENDING */ ) return;
            if ((0, $8rX8J.isThenable)(value)) {
                value.then(_this._resolve, _this._reject);
                return;
            }
            _this._state = state;
            _this._value = value;
            _this._executeHandlers();
        };
        /** JSDoc */ this._executeHandlers = function() {
            if (_this._state === 0 /* PENDING */ ) return;
            var cachedHandlers = _this._handlers.slice();
            _this._handlers = [];
            cachedHandlers.forEach(function(handler) {
                if (handler[0]) return;
                if (_this._state === 1 /* RESOLVED */ ) // eslint-disable-next-line @typescript-eslint/no-floating-promises
                handler[1](_this._value);
                if (_this._state === 2 /* REJECTED */ ) handler[2](_this._value);
                handler[0] = true;
            });
        };
        try {
            executor(this._resolve, this._reject);
        } catch (e) {
            this._reject(e);
        }
    }
    /** JSDoc */ SyncPromise.prototype.then = function(onfulfilled, onrejected) {
        var _this = this;
        return new SyncPromise(function(resolve, reject) {
            _this._handlers.push([
                false,
                function(result) {
                    if (!onfulfilled) // TODO: ¯\_(ツ)_/¯
                    // TODO: FIXME
                    resolve(result);
                    else try {
                        resolve(onfulfilled(result));
                    } catch (e) {
                        reject(e);
                    }
                },
                function(reason) {
                    if (!onrejected) reject(reason);
                    else try {
                        resolve(onrejected(reason));
                    } catch (e) {
                        reject(e);
                    }
                }
            ]);
            _this._executeHandlers();
        });
    };
    /** JSDoc */ SyncPromise.prototype.catch = function(onrejected) {
        return this.then(function(val) {
            return val;
        }, onrejected);
    };
    /** JSDoc */ SyncPromise.prototype.finally = function(onfinally) {
        var _this = this;
        return new SyncPromise(function(resolve, reject) {
            var val;
            var isRejected;
            return _this.then(function(value) {
                isRejected = false;
                val = value;
                if (onfinally) onfinally();
            }, function(reason) {
                isRejected = true;
                val = reason;
                if (onfinally) onfinally();
            }).then(function() {
                if (isRejected) {
                    reject(val);
                    return;
                }
                resolve(val);
            });
        });
    };
    return SyncPromise;
}();

});


parcelRegister("kpXMz", function(module, exports) {
$parcel$export(module.exports, "severityFromString", () => $edd483f6e1ec83f5$export$e01cef29b4327697);

var $iYYET = parcelRequire("iYYET");

var $jf6CL = parcelRequire("jf6CL");
function $edd483f6e1ec83f5$var$isSupportedSeverity(level) {
    return (0, $jf6CL.SeverityLevels).indexOf(level) !== -1;
}
function $edd483f6e1ec83f5$export$e01cef29b4327697(level) {
    if (level === 'warn') return (0, $iYYET.Severity).Warning;
    if ($edd483f6e1ec83f5$var$isSupportedSeverity(level)) return level;
    return (0, $iYYET.Severity).Log;
}

});
parcelRegister("jf6CL", function(module, exports) {
$parcel$export(module.exports, "SeverityLevels", () => $e0248e759d5a0186$export$484b1ea9aec914c);
var $e0248e759d5a0186$export$484b1ea9aec914c = [
    'fatal',
    'error',
    'warning',
    'log',
    'info',
    'debug',
    'critical'
];

});


parcelRegister("9P6Bi", function(module, exports) {
$parcel$export(module.exports, "eventStatusFromHttpCode", () => $726dff3bf31be795$export$82713360d763c449);
/**
 * Converts an HTTP status code to sentry status {@link EventStatus}.
 *
 * @param code number HTTP status code
 * @returns EventStatus
 */ function $726dff3bf31be795$export$82713360d763c449(code) {
    if (code >= 200 && code < 300) return 'success';
    if (code === 429) return 'rate_limit';
    if (code >= 400 && code < 500) return 'invalid';
    if (code >= 500) return 'failed';
    return 'unknown';
}

});

parcelRegister("chTsM", function(module, exports) {
$parcel$export(module.exports, "dateTimestampInSeconds", () => dateTimestampInSeconds, (v) => dateTimestampInSeconds = v);
$parcel$export(module.exports, "timestampInSeconds", () => timestampInSeconds, (v) => timestampInSeconds = v);
$parcel$export(module.exports, "timestampWithMs", () => timestampWithMs, (v) => timestampWithMs = v);

var $lrp9R = parcelRequire("lrp9R");

var $dBSRM = parcelRequire("dBSRM");
/**
 * A TimestampSource implementation for environments that do not support the Performance Web API natively.
 *
 * Note that this TimestampSource does not use a monotonic clock. A call to `nowSeconds` may return a timestamp earlier
 * than a previously returned value. We do not try to emulate a monotonic behavior in order to facilitate debugging. It
 * is more obvious to explain "why does my span have negative duration" than "why my spans have zero duration".
 */ var dateTimestampSource = {
    nowSeconds: function() {
        return Date.now() / 1000;
    }
};
/**
 * Returns a wrapper around the native Performance API browser implementation, or undefined for browsers that do not
 * support the API.
 *
 * Wrapping the native API works around differences in behavior from different browsers.
 */ function getBrowserPerformance() {
    var performance = (0, $lrp9R.getGlobalObject)().performance;
    if (!performance || !performance.now) return undefined;
    // Replace performance.timeOrigin with our own timeOrigin based on Date.now().
    //
    // This is a partial workaround for browsers reporting performance.timeOrigin such that performance.timeOrigin +
    // performance.now() gives a date arbitrarily in the past.
    //
    // Additionally, computing timeOrigin in this way fills the gap for browsers where performance.timeOrigin is
    // undefined.
    //
    // The assumption that performance.timeOrigin + performance.now() ~= Date.now() is flawed, but we depend on it to
    // interact with data coming out of performance entries.
    //
    // Note that despite recommendations against it in the spec, browsers implement the Performance API with a clock that
    // might stop when the computer is asleep (and perhaps under other circumstances). Such behavior causes
    // performance.timeOrigin + performance.now() to have an arbitrary skew over Date.now(). In laptop computers, we have
    // observed skews that can be as long as days, weeks or months.
    //
    // See https://github.com/getsentry/sentry-javascript/issues/2590.
    //
    // BUG: despite our best intentions, this workaround has its limitations. It mostly addresses timings of pageload
    // transactions, but ignores the skew built up over time that can aversely affect timestamps of navigation
    // transactions of long-lived web pages.
    var timeOrigin = Date.now() - performance.now();
    return {
        now: function() {
            return performance.now();
        },
        timeOrigin: timeOrigin
    };
}
/**
 * Returns the native Performance API implementation from Node.js. Returns undefined in old Node.js versions that don't
 * implement the API.
 */ function getNodePerformance() {
    try {
        var perfHooks = (0, $dBSRM.dynamicRequire)(module, 'perf_hooks');
        return perfHooks.performance;
    } catch (_) {
        return undefined;
    }
}
/**
 * The Performance API implementation for the current platform, if available.
 */ var platformPerformance = (0, $dBSRM.isNodeEnv)() ? getNodePerformance() : getBrowserPerformance();
var timestampSource = platformPerformance === undefined ? dateTimestampSource : {
    nowSeconds: function() {
        return (platformPerformance.timeOrigin + platformPerformance.now()) / 1000;
    }
};
var dateTimestampInSeconds = dateTimestampSource.nowSeconds.bind(dateTimestampSource);
var timestampInSeconds = timestampSource.nowSeconds.bind(timestampSource);
var timestampWithMs = timestampInSeconds;
var usingPerformanceAPI = platformPerformance !== undefined;
var _browserPerformanceTimeOriginMode;
var browserPerformanceTimeOrigin = function() {
    // Unfortunately browsers may report an inaccurate time origin data, through either performance.timeOrigin or
    // performance.timing.navigationStart, which results in poor results in performance data. We only treat time origin
    // data as reliable if they are within a reasonable threshold of the current time.
    var performance = (0, $lrp9R.getGlobalObject)().performance;
    if (!performance || !performance.now) {
        _browserPerformanceTimeOriginMode = 'none';
        return undefined;
    }
    var threshold = 3600000;
    var performanceNow = performance.now();
    var dateNow = Date.now();
    // if timeOrigin isn't available set delta to threshold so it isn't used
    var timeOriginDelta = performance.timeOrigin ? Math.abs(performance.timeOrigin + performanceNow - dateNow) : threshold;
    var timeOriginIsReliable = timeOriginDelta < threshold;
    // While performance.timing.navigationStart is deprecated in favor of performance.timeOrigin, performance.timeOrigin
    // is not as widely supported. Namely, performance.timeOrigin is undefined in Safari as of writing.
    // Also as of writing, performance.timing is not available in Web Workers in mainstream browsers, so it is not always
    // a valid fallback. In the absence of an initial time provided by the browser, fallback to the current time from the
    // Date API.
    // eslint-disable-next-line deprecation/deprecation
    var navigationStart = performance.timing && performance.timing.navigationStart;
    var hasNavigationStart = typeof navigationStart === 'number';
    // if navigationStart isn't available set delta to threshold so it isn't used
    var navigationStartDelta = hasNavigationStart ? Math.abs(navigationStart + performanceNow - dateNow) : threshold;
    var navigationStartIsReliable = navigationStartDelta < threshold;
    if (timeOriginIsReliable || navigationStartIsReliable) {
        // Use the more reliable time origin
        if (timeOriginDelta <= navigationStartDelta) {
            _browserPerformanceTimeOriginMode = 'timeOrigin';
            return performance.timeOrigin;
        } else {
            _browserPerformanceTimeOriginMode = 'navigationStart';
            return navigationStart;
        }
    }
    // Either both timeOrigin and navigationStart are skewed or neither is available, fallback to Date.
    _browserPerformanceTimeOriginMode = 'dateNow';
    return dateNow;
}();

});

parcelRegister("9G22S", function(module, exports) {
$parcel$export(module.exports, "createEnvelope", () => $70b99f77072cf559$export$f93f7f385160c44e);
$parcel$export(module.exports, "getEnvelopeType", () => $70b99f77072cf559$export$d84939284bbafcd4);
$parcel$export(module.exports, "serializeEnvelope", () => $70b99f77072cf559$export$32f9b428425aac85);

var $dT3VW = parcelRequire("dT3VW");

var $8rX8J = parcelRequire("8rX8J");
function $70b99f77072cf559$export$f93f7f385160c44e(headers, items) {
    if (items === void 0) items = [];
    return [
        headers,
        items
    ];
}
function $70b99f77072cf559$export$d650323442802f6f(envelope, newItem) {
    var _a = (0, $dT3VW.__read)(envelope, 2), headers = _a[0], items = _a[1];
    return [
        headers,
        (0, $dT3VW.__spread)(items, [
            newItem
        ])
    ];
}
function $70b99f77072cf559$export$d84939284bbafcd4(envelope) {
    var _a = (0, $dT3VW.__read)(envelope, 2), _b = (0, $dT3VW.__read)(_a[1], 1), _c = (0, $dT3VW.__read)(_b[0], 1), firstItemHeader = _c[0];
    return firstItemHeader.type;
}
function $70b99f77072cf559$export$32f9b428425aac85(envelope) {
    var _a = (0, $dT3VW.__read)(envelope, 2), headers = _a[0], items = _a[1];
    var serializedHeaders = JSON.stringify(headers);
    // Have to cast items to any here since Envelope is a union type
    // Fixed in Typescript 4.2
    // TODO: Remove any[] cast when we upgrade to TS 4.2
    // https://github.com/microsoft/TypeScript/issues/36390
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return items.reduce(function(acc, item) {
        var _a = (0, $dT3VW.__read)(item, 2), itemHeaders = _a[0], payload = _a[1];
        // We do not serialize payloads that are primitives
        var serializedPayload = (0, $8rX8J.isPrimitive)(payload) ? String(payload) : JSON.stringify(payload);
        return acc + "\n" + JSON.stringify(itemHeaders) + "\n" + serializedPayload;
    }, serializedHeaders);
}

});

parcelRegister("diVdC", function(module, exports) {
$parcel$export(module.exports, "createClientReportEnvelope", () => $9af9573e0ba8bc4b$export$f3b9ed77c03eeb00);

var $9G22S = parcelRequire("9G22S");

var $chTsM = parcelRequire("chTsM");
function $9af9573e0ba8bc4b$export$f3b9ed77c03eeb00(discarded_events, dsn, timestamp) {
    var clientReportItem = [
        {
            type: 'client_report'
        },
        {
            timestamp: timestamp || (0, $chTsM.dateTimestampInSeconds)(),
            discarded_events: discarded_events
        }
    ];
    return (0, $9G22S.createEnvelope)(dsn ? {
        dsn: dsn
    } : {}, [
        clientReportItem
    ]);
}

});

parcelRegister("etGw0", function(module, exports) {
$parcel$export(module.exports, "disabledUntil", () => $a8a4c0c2698a0fad$export$b89fc7b2e4c799e7);
$parcel$export(module.exports, "isRateLimited", () => $a8a4c0c2698a0fad$export$6c91fec22056810a);
$parcel$export(module.exports, "updateRateLimits", () => $a8a4c0c2698a0fad$export$699aff705e0d49d4);

var $dT3VW = parcelRequire("dT3VW");
var $a8a4c0c2698a0fad$export$b09ce39faaeb1e7c = 60000; // 60 seconds
function $a8a4c0c2698a0fad$export$615352e17ed7741(header, now) {
    if (now === void 0) now = Date.now();
    var headerDelay = parseInt("" + header, 10);
    if (!isNaN(headerDelay)) return headerDelay * 1000;
    var headerDate = Date.parse("" + header);
    if (!isNaN(headerDate)) return headerDate - now;
    return $a8a4c0c2698a0fad$export$b09ce39faaeb1e7c;
}
function $a8a4c0c2698a0fad$export$b89fc7b2e4c799e7(limits, category) {
    return limits[category] || limits.all || 0;
}
function $a8a4c0c2698a0fad$export$6c91fec22056810a(limits, category, now) {
    if (now === void 0) now = Date.now();
    return $a8a4c0c2698a0fad$export$b89fc7b2e4c799e7(limits, category) > now;
}
function $a8a4c0c2698a0fad$export$699aff705e0d49d4(limits, headers, now) {
    var e_1, _a, e_2, _b;
    if (now === void 0) now = Date.now();
    var updatedRateLimits = (0, $dT3VW.__assign)({}, limits);
    // "The name is case-insensitive."
    // https://developer.mozilla.org/en-US/docs/Web/API/Headers/get
    var rateLimitHeader = headers['x-sentry-rate-limits'];
    var retryAfterHeader = headers['retry-after'];
    if (rateLimitHeader) try {
        /**
             * rate limit headers are of the form
             *     <header>,<header>,..
             * where each <header> is of the form
             *     <retry_after>: <categories>: <scope>: <reason_code>
             * where
             *     <retry_after> is a delay in seconds
             *     <categories> is the event type(s) (error, transaction, etc) being rate limited and is of the form
             *         <category>;<category>;...
             *     <scope> is what's being limited (org, project, or key) - ignored by SDK
             *     <reason_code> is an arbitrary string like "org_quota" - ignored by SDK
             */ for(var _c = (0, $dT3VW.__values)(rateLimitHeader.trim().split(',')), _d = _c.next(); !_d.done; _d = _c.next()){
            var limit = _d.value;
            var parameters = limit.split(':', 2);
            var headerDelay = parseInt(parameters[0], 10);
            var delay = (!isNaN(headerDelay) ? headerDelay : 60) * 1000; // 60sec default
            if (!parameters[1]) updatedRateLimits.all = now + delay;
            else try {
                for(var _e = (e_2 = void 0, (0, $dT3VW.__values)(parameters[1].split(';'))), _f = _e.next(); !_f.done; _f = _e.next()){
                    var category = _f.value;
                    updatedRateLimits[category] = now + delay;
                }
            } catch (e_2_1) {
                e_2 = {
                    error: e_2_1
                };
            } finally{
                try {
                    if (_f && !_f.done && (_b = _e.return)) _b.call(_e);
                } finally{
                    if (e_2) throw e_2.error;
                }
            }
        }
    } catch (e_1_1) {
        e_1 = {
            error: e_1_1
        };
    } finally{
        try {
            if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
        } finally{
            if (e_1) throw e_1.error;
        }
    }
    else if (retryAfterHeader) updatedRateLimits.all = now + $a8a4c0c2698a0fad$export$615352e17ed7741(retryAfterHeader, now);
    return updatedRateLimits;
}

});


parcelRegister("dzx2d", function(module, exports) {
$parcel$export(module.exports, "IS_DEBUG_BUILD", () => $9e182b40f0733892$export$48a8984ec0bf2e44);
/*
 * This file defines flags and constants that can be modified during compile time in order to facilitate tree shaking
 * for users.
 *
 * Debug flags need to be declared in each package individually and must not be imported across package boundaries,
 * because some build tools have trouble tree-shaking imported guards.
 *
 * As a convention, we define debug flags in a `flags.ts` file in the root of a package's `src` folder.
 *
 * Debug flag files will contain "magic strings" like `__SENTRY_DEBUG__` that may get replaced with actual values during
 * our, or the user's build process. Take care when introducing new flags - they must not throw if they are not
 * replaced.
 */ /** Flag that is true for debug builds, false otherwise. */ var $9e182b40f0733892$export$48a8984ec0bf2e44 = typeof __SENTRY_DEBUG__ === 'undefined' ? true : __SENTRY_DEBUG__;

});

parcelRegister("FnrKW", function(module, exports) {
$parcel$export(module.exports, "Scope", () => $07c60478cbfa65e0$export$775b6bb06e53a214);
$parcel$export(module.exports, "addGlobalEventProcessor", () => $07c60478cbfa65e0$export$8e4e25f54d456511);

var $fClYD = parcelRequire("fClYD");
parcelRequire("i0afJ");
var $chTsM = parcelRequire("chTsM");
var $lrp9R = parcelRequire("lrp9R");
var $8rX8J = parcelRequire("8rX8J");
var $bdF5c = parcelRequire("bdF5c");
/**
 * Absolute maximum number of breadcrumbs added to an event.
 * The `maxBreadcrumbs` option cannot be higher than this value.
 */ var $07c60478cbfa65e0$var$MAX_BREADCRUMBS = 100;
/**
 * Holds additional event information. {@link Scope.applyToEvent} will be
 * called by the client before an event will be sent.
 */ var $07c60478cbfa65e0$export$775b6bb06e53a214 = /** @class */ function() {
    function Scope() {
        /** Flag if notifying is happening. */ this._notifyingListeners = false;
        /** Callback for client to receive scope changes. */ this._scopeListeners = [];
        /** Callback list that will be called after {@link applyToEvent}. */ this._eventProcessors = [];
        /** Array of breadcrumbs. */ this._breadcrumbs = [];
        /** User */ this._user = {};
        /** Tags */ this._tags = {};
        /** Extra */ this._extra = {};
        /** Contexts */ this._contexts = {};
        /**
         * A place to stash data which is needed at some point in the SDK's event processing pipeline but which shouldn't get
         * sent to Sentry
         */ this._sdkProcessingMetadata = {};
    }
    /**
     * Inherit values from the parent scope.
     * @param scope to clone.
     */ Scope.clone = function(scope) {
        var newScope = new Scope();
        if (scope) {
            newScope._breadcrumbs = (0, $fClYD.__spread)(scope._breadcrumbs);
            newScope._tags = (0, $fClYD.__assign)({}, scope._tags);
            newScope._extra = (0, $fClYD.__assign)({}, scope._extra);
            newScope._contexts = (0, $fClYD.__assign)({}, scope._contexts);
            newScope._user = scope._user;
            newScope._level = scope._level;
            newScope._span = scope._span;
            newScope._session = scope._session;
            newScope._transactionName = scope._transactionName;
            newScope._fingerprint = scope._fingerprint;
            newScope._eventProcessors = (0, $fClYD.__spread)(scope._eventProcessors);
            newScope._requestSession = scope._requestSession;
        }
        return newScope;
    };
    /**
     * Add internal on change listener. Used for sub SDKs that need to store the scope.
     * @hidden
     */ Scope.prototype.addScopeListener = function(callback) {
        this._scopeListeners.push(callback);
    };
    /**
     * @inheritDoc
     */ Scope.prototype.addEventProcessor = function(callback) {
        this._eventProcessors.push(callback);
        return this;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.setUser = function(user) {
        this._user = user || {};
        if (this._session) this._session.update({
            user: user
        });
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.getUser = function() {
        return this._user;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.getRequestSession = function() {
        return this._requestSession;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.setRequestSession = function(requestSession) {
        this._requestSession = requestSession;
        return this;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.setTags = function(tags) {
        this._tags = (0, $fClYD.__assign)((0, $fClYD.__assign)({}, this._tags), tags);
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.setTag = function(key, value) {
        var _a;
        this._tags = (0, $fClYD.__assign)((0, $fClYD.__assign)({}, this._tags), (_a = {}, _a[key] = value, _a));
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.setExtras = function(extras) {
        this._extra = (0, $fClYD.__assign)((0, $fClYD.__assign)({}, this._extra), extras);
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.setExtra = function(key, extra) {
        var _a;
        this._extra = (0, $fClYD.__assign)((0, $fClYD.__assign)({}, this._extra), (_a = {}, _a[key] = extra, _a));
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.setFingerprint = function(fingerprint) {
        this._fingerprint = fingerprint;
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.setLevel = function(level) {
        this._level = level;
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.setTransactionName = function(name) {
        this._transactionName = name;
        this._notifyScopeListeners();
        return this;
    };
    /**
     * Can be removed in major version.
     * @deprecated in favor of {@link this.setTransactionName}
     */ Scope.prototype.setTransaction = function(name) {
        return this.setTransactionName(name);
    };
    /**
     * @inheritDoc
     */ Scope.prototype.setContext = function(key, context) {
        var _a;
        if (context === null) // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
        delete this._contexts[key];
        else this._contexts = (0, $fClYD.__assign)((0, $fClYD.__assign)({}, this._contexts), (_a = {}, _a[key] = context, _a));
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.setSpan = function(span) {
        this._span = span;
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.getSpan = function() {
        return this._span;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.getTransaction = function() {
        // Often, this span (if it exists at all) will be a transaction, but it's not guaranteed to be. Regardless, it will
        // have a pointer to the currently-active transaction.
        var span = this.getSpan();
        return span && span.transaction;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.setSession = function(session) {
        if (!session) delete this._session;
        else this._session = session;
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.getSession = function() {
        return this._session;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.update = function(captureContext) {
        if (!captureContext) return this;
        if (typeof captureContext === 'function') {
            var updatedScope = captureContext(this);
            return updatedScope instanceof Scope ? updatedScope : this;
        }
        if (captureContext instanceof Scope) {
            this._tags = (0, $fClYD.__assign)((0, $fClYD.__assign)({}, this._tags), captureContext._tags);
            this._extra = (0, $fClYD.__assign)((0, $fClYD.__assign)({}, this._extra), captureContext._extra);
            this._contexts = (0, $fClYD.__assign)((0, $fClYD.__assign)({}, this._contexts), captureContext._contexts);
            if (captureContext._user && Object.keys(captureContext._user).length) this._user = captureContext._user;
            if (captureContext._level) this._level = captureContext._level;
            if (captureContext._fingerprint) this._fingerprint = captureContext._fingerprint;
            if (captureContext._requestSession) this._requestSession = captureContext._requestSession;
        } else if ((0, $8rX8J.isPlainObject)(captureContext)) {
            // eslint-disable-next-line no-param-reassign
            captureContext;
            this._tags = (0, $fClYD.__assign)((0, $fClYD.__assign)({}, this._tags), captureContext.tags);
            this._extra = (0, $fClYD.__assign)((0, $fClYD.__assign)({}, this._extra), captureContext.extra);
            this._contexts = (0, $fClYD.__assign)((0, $fClYD.__assign)({}, this._contexts), captureContext.contexts);
            if (captureContext.user) this._user = captureContext.user;
            if (captureContext.level) this._level = captureContext.level;
            if (captureContext.fingerprint) this._fingerprint = captureContext.fingerprint;
            if (captureContext.requestSession) this._requestSession = captureContext.requestSession;
        }
        return this;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.clear = function() {
        this._breadcrumbs = [];
        this._tags = {};
        this._extra = {};
        this._user = {};
        this._contexts = {};
        this._level = undefined;
        this._transactionName = undefined;
        this._fingerprint = undefined;
        this._requestSession = undefined;
        this._span = undefined;
        this._session = undefined;
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.addBreadcrumb = function(breadcrumb, maxBreadcrumbs) {
        var maxCrumbs = typeof maxBreadcrumbs === 'number' ? Math.min(maxBreadcrumbs, $07c60478cbfa65e0$var$MAX_BREADCRUMBS) : $07c60478cbfa65e0$var$MAX_BREADCRUMBS;
        // No data has been changed, so don't notify scope listeners
        if (maxCrumbs <= 0) return this;
        var mergedBreadcrumb = (0, $fClYD.__assign)({
            timestamp: (0, $chTsM.dateTimestampInSeconds)()
        }, breadcrumb);
        this._breadcrumbs = (0, $fClYD.__spread)(this._breadcrumbs, [
            mergedBreadcrumb
        ]).slice(-maxCrumbs);
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.clearBreadcrumbs = function() {
        this._breadcrumbs = [];
        this._notifyScopeListeners();
        return this;
    };
    /**
     * Applies the current context and fingerprint to the event.
     * Note that breadcrumbs will be added by the client.
     * Also if the event has already breadcrumbs on it, we do not merge them.
     * @param event Event
     * @param hint May contain additional information about the original exception.
     * @hidden
     */ Scope.prototype.applyToEvent = function(event, hint) {
        if (this._extra && Object.keys(this._extra).length) event.extra = (0, $fClYD.__assign)((0, $fClYD.__assign)({}, this._extra), event.extra);
        if (this._tags && Object.keys(this._tags).length) event.tags = (0, $fClYD.__assign)((0, $fClYD.__assign)({}, this._tags), event.tags);
        if (this._user && Object.keys(this._user).length) event.user = (0, $fClYD.__assign)((0, $fClYD.__assign)({}, this._user), event.user);
        if (this._contexts && Object.keys(this._contexts).length) event.contexts = (0, $fClYD.__assign)((0, $fClYD.__assign)({}, this._contexts), event.contexts);
        if (this._level) event.level = this._level;
        if (this._transactionName) event.transaction = this._transactionName;
        // We want to set the trace context for normal events only if there isn't already
        // a trace context on the event. There is a product feature in place where we link
        // errors with transaction and it relies on that.
        if (this._span) {
            event.contexts = (0, $fClYD.__assign)({
                trace: this._span.getTraceContext()
            }, event.contexts);
            var transactionName = this._span.transaction && this._span.transaction.name;
            if (transactionName) event.tags = (0, $fClYD.__assign)({
                transaction: transactionName
            }, event.tags);
        }
        this._applyFingerprint(event);
        event.breadcrumbs = (0, $fClYD.__spread)(event.breadcrumbs || [], this._breadcrumbs);
        event.breadcrumbs = event.breadcrumbs.length > 0 ? event.breadcrumbs : undefined;
        event.sdkProcessingMetadata = this._sdkProcessingMetadata;
        return this._notifyEventProcessors((0, $fClYD.__spread)($07c60478cbfa65e0$var$getGlobalEventProcessors(), this._eventProcessors), event, hint);
    };
    /**
     * Add data which will be accessible during event processing but won't get sent to Sentry
     */ Scope.prototype.setSDKProcessingMetadata = function(newData) {
        this._sdkProcessingMetadata = (0, $fClYD.__assign)((0, $fClYD.__assign)({}, this._sdkProcessingMetadata), newData);
        return this;
    };
    /**
     * This will be called after {@link applyToEvent} is finished.
     */ Scope.prototype._notifyEventProcessors = function(processors, event, hint, index) {
        var _this = this;
        if (index === void 0) index = 0;
        return new (0, $bdF5c.SyncPromise)(function(resolve, reject) {
            var processor = processors[index];
            if (event === null || typeof processor !== 'function') resolve(event);
            else {
                var result = processor((0, $fClYD.__assign)({}, event), hint);
                if ((0, $8rX8J.isThenable)(result)) result.then(function(final) {
                    return _this._notifyEventProcessors(processors, final, hint, index + 1).then(resolve);
                }).then(null, reject);
                else _this._notifyEventProcessors(processors, result, hint, index + 1).then(resolve).then(null, reject);
            }
        });
    };
    /**
     * This will be called on every set call.
     */ Scope.prototype._notifyScopeListeners = function() {
        var _this = this;
        // We need this check for this._notifyingListeners to be able to work on scope during updates
        // If this check is not here we'll produce endless recursion when something is done with the scope
        // during the callback.
        if (!this._notifyingListeners) {
            this._notifyingListeners = true;
            this._scopeListeners.forEach(function(callback) {
                callback(_this);
            });
            this._notifyingListeners = false;
        }
    };
    /**
     * Applies fingerprint from the scope to the event if there's one,
     * uses message if there's one instead or get rid of empty fingerprint
     */ Scope.prototype._applyFingerprint = function(event) {
        // Make sure it's an array first and we actually have something in place
        event.fingerprint = event.fingerprint ? Array.isArray(event.fingerprint) ? event.fingerprint : [
            event.fingerprint
        ] : [];
        // If we have something on the scope, then merge it with event
        if (this._fingerprint) event.fingerprint = event.fingerprint.concat(this._fingerprint);
        // If we have no data at all, remove empty array default
        if (event.fingerprint && !event.fingerprint.length) delete event.fingerprint;
    };
    return Scope;
}();
/**
 * Returns the global event processors.
 */ function $07c60478cbfa65e0$var$getGlobalEventProcessors() {
    return (0, $lrp9R.getGlobalSingleton)('globalEventProcessors', function() {
        return [];
    });
}
function $07c60478cbfa65e0$export$8e4e25f54d456511(callback) {
    $07c60478cbfa65e0$var$getGlobalEventProcessors().push(callback);
}

});

parcelRegister("vfED8", function(module, exports) {
$parcel$export(module.exports, "Session", () => $05df09fd05f805c0$export$1fb4852a55678982);
parcelRequire("i0afJ");
var $909Vl = parcelRequire("909Vl");
var $chTsM = parcelRequire("chTsM");
var $73JtC = parcelRequire("73JtC");
/**
 * @inheritdoc
 */ var $05df09fd05f805c0$export$1fb4852a55678982 = /** @class */ function() {
    function Session(context) {
        this.errors = 0;
        this.sid = (0, $73JtC.uuid4)();
        this.duration = 0;
        this.status = 'ok';
        this.init = true;
        this.ignoreDuration = false;
        // Both timestamp and started are in seconds since the UNIX epoch.
        var startingTime = (0, $chTsM.timestampInSeconds)();
        this.timestamp = startingTime;
        this.started = startingTime;
        if (context) this.update(context);
    }
    /** JSDoc */ // eslint-disable-next-line complexity
    Session.prototype.update = function(context) {
        if (context === void 0) context = {};
        if (context.user) {
            if (!this.ipAddress && context.user.ip_address) this.ipAddress = context.user.ip_address;
            if (!this.did && !context.did) this.did = context.user.id || context.user.email || context.user.username;
        }
        this.timestamp = context.timestamp || (0, $chTsM.timestampInSeconds)();
        if (context.ignoreDuration) this.ignoreDuration = context.ignoreDuration;
        if (context.sid) // Good enough uuid validation. — Kamil
        this.sid = context.sid.length === 32 ? context.sid : (0, $73JtC.uuid4)();
        if (context.init !== undefined) this.init = context.init;
        if (!this.did && context.did) this.did = "" + context.did;
        if (typeof context.started === 'number') this.started = context.started;
        if (this.ignoreDuration) this.duration = undefined;
        else if (typeof context.duration === 'number') this.duration = context.duration;
        else {
            var duration = this.timestamp - this.started;
            this.duration = duration >= 0 ? duration : 0;
        }
        if (context.release) this.release = context.release;
        if (context.environment) this.environment = context.environment;
        if (!this.ipAddress && context.ipAddress) this.ipAddress = context.ipAddress;
        if (!this.userAgent && context.userAgent) this.userAgent = context.userAgent;
        if (typeof context.errors === 'number') this.errors = context.errors;
        if (context.status) this.status = context.status;
    };
    /** JSDoc */ Session.prototype.close = function(status) {
        if (status) this.update({
            status: status
        });
        else if (this.status === 'ok') this.update({
            status: 'exited'
        });
        else this.update();
    };
    /** JSDoc */ Session.prototype.toJSON = function() {
        return (0, $909Vl.dropUndefinedKeys)({
            sid: "" + this.sid,
            init: this.init,
            // Make sure that sec is converted to ms for date constructor
            started: new Date(this.started * 1000).toISOString(),
            timestamp: new Date(this.timestamp * 1000).toISOString(),
            status: this.status,
            errors: this.errors,
            did: typeof this.did === 'number' || typeof this.did === 'string' ? "" + this.did : undefined,
            duration: this.duration,
            attrs: {
                release: this.release,
                environment: this.environment,
                ip_address: this.ipAddress,
                user_agent: this.userAgent
            }
        });
    };
    return Session;
}();

});



parcelRegister("egk2u", function(module, exports) {
$parcel$export(module.exports, "SDK_VERSION", () => $a6221aaf52616c2a$export$31499a9cd224b78c);
var $a6221aaf52616c2a$export$31499a9cd224b78c = '6.19.7';

});

parcelRegister("7bmvO", function(module, exports) {
$parcel$export(module.exports, "BrowserClient", () => $53ab05e71f1546f1$export$1df9218a526d318d);

var $iTWOe = parcelRequire("iTWOe");

var $5veNv = parcelRequire("5veNv");
var $egk2u = parcelRequire("egk2u");
parcelRequire("i0afJ");
var $lrp9R = parcelRequire("lrp9R");
var $1v4ZC = parcelRequire("1v4ZC");

var $1R0KG = parcelRequire("1R0KG");

var $dMTNw = parcelRequire("dMTNw");

var $iuPyo = parcelRequire("iuPyo");

var $3UPj8 = parcelRequire("3UPj8");
/**
 * The Sentry Browser SDK Client.
 *
 * @see BrowserOptions for documentation on configuration options.
 * @see SentryClient for usage documentation.
 */ var $53ab05e71f1546f1$export$1df9218a526d318d = /** @class */ function(_super) {
    (0, $iTWOe.__extends)(BrowserClient, _super);
    /**
     * Creates a new Browser SDK instance.
     *
     * @param options Configuration options for this SDK.
     */ function BrowserClient(options) {
        if (options === void 0) options = {};
        var _this = this;
        options._metadata = options._metadata || {};
        options._metadata.sdk = options._metadata.sdk || {
            name: 'sentry.javascript.browser',
            packages: [
                {
                    name: 'npm:@sentry/browser',
                    version: (0, $egk2u.SDK_VERSION)
                }
            ],
            version: (0, $egk2u.SDK_VERSION)
        };
        _this = _super.call(this, (0, $1R0KG.BrowserBackend), options) || this;
        return _this;
    }
    /**
     * Show a report dialog to the user to send feedback to a specific event.
     *
     * @param options Set individual options for the dialog
     */ BrowserClient.prototype.showReportDialog = function(options) {
        if (options === void 0) options = {};
        // doesn't work without a document (React Native)
        var document = (0, $lrp9R.getGlobalObject)().document;
        if (!document) return;
        if (!this._isEnabled()) {
            (0, $dMTNw.IS_DEBUG_BUILD) && (0, $1v4ZC.logger).error('Trying to call showReportDialog with Sentry Client disabled');
            return;
        }
        (0, $iuPyo.injectReportDialog)((0, $iTWOe.__assign)((0, $iTWOe.__assign)({}, options), {
            dsn: options.dsn || this.getDsn()
        }));
    };
    /**
     * @inheritDoc
     */ BrowserClient.prototype._prepareEvent = function(event, scope, hint) {
        event.platform = event.platform || 'javascript';
        return _super.prototype._prepareEvent.call(this, event, scope, hint);
    };
    /**
     * @inheritDoc
     */ BrowserClient.prototype._sendEvent = function(event) {
        var integration = this.getIntegration((0, $3UPj8.Breadcrumbs));
        if (integration) integration.addSentryBreadcrumb(event);
        _super.prototype._sendEvent.call(this, event);
    };
    return BrowserClient;
}((0, $5veNv.BaseClient));

});
parcelRegister("5veNv", function(module, exports) {
$parcel$export(module.exports, "BaseClient", () => $401b5375f9585e23$export$4f22f74eddb7716a);

var $iTWOe = parcelRequire("iTWOe");

var $FnrKW = parcelRequire("FnrKW");
parcelRequire("i0afJ");
var $73JtC = parcelRequire("73JtC");
var $chTsM = parcelRequire("chTsM");
var $8rX8J = parcelRequire("8rX8J");
var $1v4ZC = parcelRequire("1v4ZC");
var $62yRy = parcelRequire("62yRy");
var $bZWF1 = parcelRequire("bZWF1");
var $bdF5c = parcelRequire("bdF5c");
var $iMWNA = parcelRequire("iMWNA");
var $9k3Oz = parcelRequire("9k3Oz");

var $kT3vf = parcelRequire("kT3vf");

var $kn57e = parcelRequire("kn57e");
var $401b5375f9585e23$var$ALREADY_SEEN_ERROR = "Not capturing exception because it's already been captured.";
/**
 * Base implementation for all JavaScript SDK clients.
 *
 * Call the constructor with the corresponding backend constructor and options
 * specific to the client subclass. To access these options later, use
 * {@link Client.getOptions}. Also, the Backend instance is available via
 * {@link Client.getBackend}.
 *
 * If a Dsn is specified in the options, it will be parsed and stored. Use
 * {@link Client.getDsn} to retrieve the Dsn at any moment. In case the Dsn is
 * invalid, the constructor will throw a {@link SentryException}. Note that
 * without a valid Dsn, the SDK will not send any events to Sentry.
 *
 * Before sending an event via the backend, it is passed through
 * {@link BaseClient._prepareEvent} to add SDK information and scope data
 * (breadcrumbs and context). To add more custom information, override this
 * method and extend the resulting prepared event.
 *
 * To issue automatically created events (e.g. via instrumentation), use
 * {@link Client.captureEvent}. It will prepare the event and pass it through
 * the callback lifecycle. To issue auto-breadcrumbs, use
 * {@link Client.addBreadcrumb}.
 *
 * @example
 * class NodeClient extends BaseClient<NodeBackend, NodeOptions> {
 *   public constructor(options: NodeOptions) {
 *     super(NodeBackend, options);
 *   }
 *
 *   // ...
 * }
 */ var $401b5375f9585e23$export$4f22f74eddb7716a = /** @class */ function() {
    /**
     * Initializes this client instance.
     *
     * @param backendClass A constructor function to create the backend.
     * @param options Options for the client.
     */ function BaseClient(backendClass, options) {
        /** Array of used integrations. */ this._integrations = {};
        /** Number of calls being processed */ this._numProcessing = 0;
        this._backend = new backendClass(options);
        this._options = options;
        if (options.dsn) this._dsn = (0, $62yRy.makeDsn)(options.dsn);
    }
    /**
     * @inheritDoc
     */ // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
    BaseClient.prototype.captureException = function(exception, hint, scope) {
        var _this = this;
        // ensure we haven't captured this very object before
        if ((0, $73JtC.checkOrSetAlreadyCaught)(exception)) {
            (0, $kT3vf.IS_DEBUG_BUILD) && (0, $1v4ZC.logger).log($401b5375f9585e23$var$ALREADY_SEEN_ERROR);
            return;
        }
        var eventId = hint && hint.event_id;
        this._process(this._getBackend().eventFromException(exception, hint).then(function(event) {
            return _this._captureEvent(event, hint, scope);
        }).then(function(result) {
            eventId = result;
        }));
        return eventId;
    };
    /**
     * @inheritDoc
     */ BaseClient.prototype.captureMessage = function(message, level, hint, scope) {
        var _this = this;
        var eventId = hint && hint.event_id;
        var promisedEvent = (0, $8rX8J.isPrimitive)(message) ? this._getBackend().eventFromMessage(String(message), level, hint) : this._getBackend().eventFromException(message, hint);
        this._process(promisedEvent.then(function(event) {
            return _this._captureEvent(event, hint, scope);
        }).then(function(result) {
            eventId = result;
        }));
        return eventId;
    };
    /**
     * @inheritDoc
     */ BaseClient.prototype.captureEvent = function(event, hint, scope) {
        // ensure we haven't captured this very object before
        if (hint && hint.originalException && (0, $73JtC.checkOrSetAlreadyCaught)(hint.originalException)) {
            (0, $kT3vf.IS_DEBUG_BUILD) && (0, $1v4ZC.logger).log($401b5375f9585e23$var$ALREADY_SEEN_ERROR);
            return;
        }
        var eventId = hint && hint.event_id;
        this._process(this._captureEvent(event, hint, scope).then(function(result) {
            eventId = result;
        }));
        return eventId;
    };
    /**
     * @inheritDoc
     */ BaseClient.prototype.captureSession = function(session) {
        if (!this._isEnabled()) {
            (0, $kT3vf.IS_DEBUG_BUILD) && (0, $1v4ZC.logger).warn('SDK not enabled, will not capture session.');
            return;
        }
        if (!(typeof session.release === 'string')) (0, $kT3vf.IS_DEBUG_BUILD) && (0, $1v4ZC.logger).warn('Discarded session because of missing or non-string release');
        else {
            this._sendSession(session);
            // After sending, we set init false to indicate it's not the first occurrence
            session.update({
                init: false
            });
        }
    };
    /**
     * @inheritDoc
     */ BaseClient.prototype.getDsn = function() {
        return this._dsn;
    };
    /**
     * @inheritDoc
     */ BaseClient.prototype.getOptions = function() {
        return this._options;
    };
    /**
     * @inheritDoc
     */ BaseClient.prototype.getTransport = function() {
        return this._getBackend().getTransport();
    };
    /**
     * @inheritDoc
     */ BaseClient.prototype.flush = function(timeout) {
        var _this = this;
        return this._isClientDoneProcessing(timeout).then(function(clientFinished) {
            return _this.getTransport().close(timeout).then(function(transportFlushed) {
                return clientFinished && transportFlushed;
            });
        });
    };
    /**
     * @inheritDoc
     */ BaseClient.prototype.close = function(timeout) {
        var _this = this;
        return this.flush(timeout).then(function(result) {
            _this.getOptions().enabled = false;
            return result;
        });
    };
    /**
     * Sets up the integrations
     */ BaseClient.prototype.setupIntegrations = function() {
        if (this._isEnabled() && !this._integrations.initialized) this._integrations = (0, $kn57e.setupIntegrations)(this._options);
    };
    /**
     * @inheritDoc
     */ BaseClient.prototype.getIntegration = function(integration) {
        try {
            return this._integrations[integration.id] || null;
        } catch (_oO) {
            (0, $kT3vf.IS_DEBUG_BUILD) && (0, $1v4ZC.logger).warn("Cannot retrieve integration " + integration.id + " from the current Client");
            return null;
        }
    };
    /** Updates existing session based on the provided event */ BaseClient.prototype._updateSessionFromEvent = function(session, event) {
        var e_1, _a;
        var crashed = false;
        var errored = false;
        var exceptions = event.exception && event.exception.values;
        if (exceptions) {
            errored = true;
            try {
                for(var exceptions_1 = (0, $iTWOe.__values)(exceptions), exceptions_1_1 = exceptions_1.next(); !exceptions_1_1.done; exceptions_1_1 = exceptions_1.next()){
                    var ex = exceptions_1_1.value;
                    var mechanism = ex.mechanism;
                    if (mechanism && mechanism.handled === false) {
                        crashed = true;
                        break;
                    }
                }
            } catch (e_1_1) {
                e_1 = {
                    error: e_1_1
                };
            } finally{
                try {
                    if (exceptions_1_1 && !exceptions_1_1.done && (_a = exceptions_1.return)) _a.call(exceptions_1);
                } finally{
                    if (e_1) throw e_1.error;
                }
            }
        }
        // A session is updated and that session update is sent in only one of the two following scenarios:
        // 1. Session with non terminal status and 0 errors + an error occurred -> Will set error count to 1 and send update
        // 2. Session with non terminal status and 1 error + a crash occurred -> Will set status crashed and send update
        var sessionNonTerminal = session.status === 'ok';
        var shouldUpdateAndSend = sessionNonTerminal && session.errors === 0 || sessionNonTerminal && crashed;
        if (shouldUpdateAndSend) {
            session.update((0, $iTWOe.__assign)((0, $iTWOe.__assign)({}, crashed && {
                status: 'crashed'
            }), {
                errors: session.errors || Number(errored || crashed)
            }));
            this.captureSession(session);
        }
    };
    /** Deliver captured session to Sentry */ BaseClient.prototype._sendSession = function(session) {
        this._getBackend().sendSession(session);
    };
    /**
     * Determine if the client is finished processing. Returns a promise because it will wait `timeout` ms before saying
     * "no" (resolving to `false`) in order to give the client a chance to potentially finish first.
     *
     * @param timeout The time, in ms, after which to resolve to `false` if the client is still busy. Passing `0` (or not
     * passing anything) will make the promise wait as long as it takes for processing to finish before resolving to
     * `true`.
     * @returns A promise which will resolve to `true` if processing is already done or finishes before the timeout, and
     * `false` otherwise
     */ BaseClient.prototype._isClientDoneProcessing = function(timeout) {
        var _this = this;
        return new (0, $bdF5c.SyncPromise)(function(resolve) {
            var ticked = 0;
            var tick = 1;
            var interval = setInterval(function() {
                if (_this._numProcessing == 0) {
                    clearInterval(interval);
                    resolve(true);
                } else {
                    ticked += tick;
                    if (timeout && ticked >= timeout) {
                        clearInterval(interval);
                        resolve(false);
                    }
                }
            }, tick);
        });
    };
    /** Returns the current backend. */ BaseClient.prototype._getBackend = function() {
        return this._backend;
    };
    /** Determines whether this SDK is enabled and a valid Dsn is present. */ BaseClient.prototype._isEnabled = function() {
        return this.getOptions().enabled !== false && this._dsn !== undefined;
    };
    /**
     * Adds common information to events.
     *
     * The information includes release and environment from `options`,
     * breadcrumbs and context (extra, tags and user) from the scope.
     *
     * Information that is already present in the event is never overwritten. For
     * nested objects, such as the context, keys are merged.
     *
     * @param event The original event.
     * @param hint May contain additional information about the original exception.
     * @param scope A scope containing event metadata.
     * @returns A new event with more information.
     */ BaseClient.prototype._prepareEvent = function(event, scope, hint) {
        var _this = this;
        var _a = this.getOptions(), _b = _a.normalizeDepth, normalizeDepth = _b === void 0 ? 3 : _b, _c = _a.normalizeMaxBreadth, normalizeMaxBreadth = _c === void 0 ? 1000 : _c;
        var prepared = (0, $iTWOe.__assign)((0, $iTWOe.__assign)({}, event), {
            event_id: event.event_id || (hint && hint.event_id ? hint.event_id : (0, $73JtC.uuid4)()),
            timestamp: event.timestamp || (0, $chTsM.dateTimestampInSeconds)()
        });
        this._applyClientOptions(prepared);
        this._applyIntegrationsMetadata(prepared);
        // If we have scope given to us, use it as the base for further modifications.
        // This allows us to prevent unnecessary copying of data if `captureContext` is not provided.
        var finalScope = scope;
        if (hint && hint.captureContext) finalScope = (0, $FnrKW.Scope).clone(finalScope).update(hint.captureContext);
        // We prepare the result here with a resolved Event.
        var result = (0, $bdF5c.resolvedSyncPromise)(prepared);
        // This should be the last thing called, since we want that
        // {@link Hub.addEventProcessor} gets the finished prepared event.
        if (finalScope) // In case we have a hub we reassign it.
        result = finalScope.applyToEvent(prepared, hint);
        return result.then(function(evt) {
            if (evt) // TODO this is more of the hack trying to solve https://github.com/getsentry/sentry-javascript/issues/2809
            // it is only attached as extra data to the event if the event somehow skips being normalized
            evt.sdkProcessingMetadata = (0, $iTWOe.__assign)((0, $iTWOe.__assign)({}, evt.sdkProcessingMetadata), {
                normalizeDepth: (0, $bZWF1.normalize)(normalizeDepth) + " (" + typeof normalizeDepth + ")"
            });
            if (typeof normalizeDepth === 'number' && normalizeDepth > 0) return _this._normalizeEvent(evt, normalizeDepth, normalizeMaxBreadth);
            return evt;
        });
    };
    /**
     * Applies `normalize` function on necessary `Event` attributes to make them safe for serialization.
     * Normalized keys:
     * - `breadcrumbs.data`
     * - `user`
     * - `contexts`
     * - `extra`
     * @param event Event
     * @returns Normalized event
     */ BaseClient.prototype._normalizeEvent = function(event, depth, maxBreadth) {
        if (!event) return null;
        var normalized = (0, $iTWOe.__assign)((0, $iTWOe.__assign)((0, $iTWOe.__assign)((0, $iTWOe.__assign)((0, $iTWOe.__assign)({}, event), event.breadcrumbs && {
            breadcrumbs: event.breadcrumbs.map(function(b) {
                return (0, $iTWOe.__assign)((0, $iTWOe.__assign)({}, b), b.data && {
                    data: (0, $bZWF1.normalize)(b.data, depth, maxBreadth)
                });
            })
        }), event.user && {
            user: (0, $bZWF1.normalize)(event.user, depth, maxBreadth)
        }), event.contexts && {
            contexts: (0, $bZWF1.normalize)(event.contexts, depth, maxBreadth)
        }), event.extra && {
            extra: (0, $bZWF1.normalize)(event.extra, depth, maxBreadth)
        });
        // event.contexts.trace stores information about a Transaction. Similarly,
        // event.spans[] stores information about child Spans. Given that a
        // Transaction is conceptually a Span, normalization should apply to both
        // Transactions and Spans consistently.
        // For now the decision is to skip normalization of Transactions and Spans,
        // so this block overwrites the normalized event to add back the original
        // Transaction information prior to normalization.
        if (event.contexts && event.contexts.trace) // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        normalized.contexts.trace = event.contexts.trace;
        normalized.sdkProcessingMetadata = (0, $iTWOe.__assign)((0, $iTWOe.__assign)({}, normalized.sdkProcessingMetadata), {
            baseClientNormalized: true
        });
        return normalized;
    };
    /**
     *  Enhances event using the client configuration.
     *  It takes care of all "static" values like environment, release and `dist`,
     *  as well as truncating overly long values.
     * @param event event instance to be enhanced
     */ BaseClient.prototype._applyClientOptions = function(event) {
        var options = this.getOptions();
        var environment = options.environment, release = options.release, dist = options.dist, _a = options.maxValueLength, maxValueLength = _a === void 0 ? 250 : _a;
        if (!('environment' in event)) event.environment = 'environment' in options ? environment : 'production';
        if (event.release === undefined && release !== undefined) event.release = release;
        if (event.dist === undefined && dist !== undefined) event.dist = dist;
        if (event.message) event.message = (0, $9k3Oz.truncate)(event.message, maxValueLength);
        var exception = event.exception && event.exception.values && event.exception.values[0];
        if (exception && exception.value) exception.value = (0, $9k3Oz.truncate)(exception.value, maxValueLength);
        var request = event.request;
        if (request && request.url) request.url = (0, $9k3Oz.truncate)(request.url, maxValueLength);
    };
    /**
     * This function adds all used integrations to the SDK info in the event.
     * @param event The event that will be filled with all integrations.
     */ BaseClient.prototype._applyIntegrationsMetadata = function(event) {
        var integrationsArray = Object.keys(this._integrations);
        if (integrationsArray.length > 0) {
            event.sdk = event.sdk || {};
            event.sdk.integrations = (0, $iTWOe.__spread)(event.sdk.integrations || [], integrationsArray);
        }
    };
    /**
     * Tells the backend to send this event
     * @param event The Sentry event to send
     */ BaseClient.prototype._sendEvent = function(event) {
        this._getBackend().sendEvent(event);
    };
    /**
     * Processes the event and logs an error in case of rejection
     * @param event
     * @param hint
     * @param scope
     */ BaseClient.prototype._captureEvent = function(event, hint, scope) {
        return this._processEvent(event, hint, scope).then(function(finalEvent) {
            return finalEvent.event_id;
        }, function(reason) {
            (0, $kT3vf.IS_DEBUG_BUILD) && (0, $1v4ZC.logger).error(reason);
            return undefined;
        });
    };
    /**
     * Processes an event (either error or message) and sends it to Sentry.
     *
     * This also adds breadcrumbs and context information to the event. However,
     * platform specific meta data (such as the User's IP address) must be added
     * by the SDK implementor.
     *
     *
     * @param event The event to send to Sentry.
     * @param hint May contain additional information about the original exception.
     * @param scope A scope containing event metadata.
     * @returns A SyncPromise that resolves with the event or rejects in case event was/will not be send.
     */ BaseClient.prototype._processEvent = function(event, hint, scope) {
        var _this = this;
        // eslint-disable-next-line @typescript-eslint/unbound-method
        var _a = this.getOptions(), beforeSend = _a.beforeSend, sampleRate = _a.sampleRate;
        var transport = this.getTransport();
        function recordLostEvent(outcome, category) {
            if (transport.recordLostEvent) transport.recordLostEvent(outcome, category);
        }
        if (!this._isEnabled()) return (0, $bdF5c.rejectedSyncPromise)(new (0, $iMWNA.SentryError)('SDK not enabled, will not capture event.'));
        var isTransaction = event.type === 'transaction';
        // 1.0 === 100% events are sent
        // 0.0 === 0% events are sent
        // Sampling for transaction happens somewhere else
        if (!isTransaction && typeof sampleRate === 'number' && Math.random() > sampleRate) {
            recordLostEvent('sample_rate', 'event');
            return (0, $bdF5c.rejectedSyncPromise)(new (0, $iMWNA.SentryError)("Discarding event because it's not included in the random sample (sampling rate = " + sampleRate + ")"));
        }
        return this._prepareEvent(event, scope, hint).then(function(prepared) {
            if (prepared === null) {
                recordLostEvent('event_processor', event.type || 'event');
                throw new (0, $iMWNA.SentryError)('An event processor returned null, will not send event.');
            }
            var isInternalException = hint && hint.data && hint.data.__sentry__ === true;
            if (isInternalException || isTransaction || !beforeSend) return prepared;
            var beforeSendResult = beforeSend(prepared, hint);
            return $401b5375f9585e23$var$_ensureBeforeSendRv(beforeSendResult);
        }).then(function(processedEvent) {
            if (processedEvent === null) {
                recordLostEvent('before_send', event.type || 'event');
                throw new (0, $iMWNA.SentryError)('`beforeSend` returned `null`, will not send event.');
            }
            var session = scope && scope.getSession && scope.getSession();
            if (!isTransaction && session) _this._updateSessionFromEvent(session, processedEvent);
            _this._sendEvent(processedEvent);
            return processedEvent;
        }).then(null, function(reason) {
            if (reason instanceof (0, $iMWNA.SentryError)) throw reason;
            _this.captureException(reason, {
                data: {
                    __sentry__: true
                },
                originalException: reason
            });
            throw new (0, $iMWNA.SentryError)("Event processing pipeline threw an error, original event will not be sent. Details have been sent as a new event.\nReason: " + reason);
        });
    };
    /**
     * Occupies the client with processing and event
     */ BaseClient.prototype._process = function(promise) {
        var _this = this;
        this._numProcessing += 1;
        promise.then(function(value) {
            _this._numProcessing -= 1;
            return value;
        }, function(reason) {
            _this._numProcessing -= 1;
            return reason;
        });
    };
    return BaseClient;
}();
/**
 * Verifies that return value of configured `beforeSend` is of expected type.
 */ function $401b5375f9585e23$var$_ensureBeforeSendRv(rv) {
    var nullErr = '`beforeSend` method has to return `null` or a valid event.';
    if ((0, $8rX8J.isThenable)(rv)) return rv.then(function(event) {
        if (!((0, $8rX8J.isPlainObject)(event) || event === null)) throw new (0, $iMWNA.SentryError)(nullErr);
        return event;
    }, function(e) {
        throw new (0, $iMWNA.SentryError)("beforeSend rejected with " + e);
    });
    else if (!((0, $8rX8J.isPlainObject)(rv) || rv === null)) throw new (0, $iMWNA.SentryError)(nullErr);
    return rv;
}

});
parcelRegister("kT3vf", function(module, exports) {
$parcel$export(module.exports, "IS_DEBUG_BUILD", () => $f34ba958b299549d$export$48a8984ec0bf2e44);
/*
 * This file defines flags and constants that can be modified during compile time in order to facilitate tree shaking
 * for users.
 *
 * Debug flags need to be declared in each package individually and must not be imported across package boundaries,
 * because some build tools have trouble tree-shaking imported guards.
 *
 * As a convention, we define debug flags in a `flags.ts` file in the root of a package's `src` folder.
 *
 * Debug flag files will contain "magic strings" like `__SENTRY_DEBUG__` that may get replaced with actual values during
 * our, or the user's build process. Take care when introducing new flags - they must not throw if they are not
 * replaced.
 */ /** Flag that is true for debug builds, false otherwise. */ var $f34ba958b299549d$export$48a8984ec0bf2e44 = typeof __SENTRY_DEBUG__ === 'undefined' ? true : __SENTRY_DEBUG__;

});

parcelRegister("kn57e", function(module, exports) {
$parcel$export(module.exports, "setupIntegrations", () => $ed49ec7a550738bc$export$51abed9797baa598);

var $iTWOe = parcelRequire("iTWOe");

var $FnrKW = parcelRequire("FnrKW");
var $ir14T = parcelRequire("ir14T");
parcelRequire("i0afJ");
var $909Vl = parcelRequire("909Vl");
var $1v4ZC = parcelRequire("1v4ZC");

var $kT3vf = parcelRequire("kT3vf");
var $ed49ec7a550738bc$export$b14a8888f80a0b3e = [];
/**
 * @private
 */ function $ed49ec7a550738bc$var$filterDuplicates(integrations) {
    return integrations.reduce(function(acc, integrations) {
        if (acc.every(function(accIntegration) {
            return integrations.name !== accIntegration.name;
        })) acc.push(integrations);
        return acc;
    }, []);
}
function $ed49ec7a550738bc$export$68bc4c01ab8ae766(options) {
    var defaultIntegrations = options.defaultIntegrations && (0, $iTWOe.__spread)(options.defaultIntegrations) || [];
    var userIntegrations = options.integrations;
    var integrations = (0, $iTWOe.__spread)($ed49ec7a550738bc$var$filterDuplicates(defaultIntegrations));
    if (Array.isArray(userIntegrations)) // Filter out integrations that are also included in user options
    integrations = (0, $iTWOe.__spread)(integrations.filter(function(integrations) {
        return userIntegrations.every(function(userIntegration) {
            return userIntegration.name !== integrations.name;
        });
    }), $ed49ec7a550738bc$var$filterDuplicates(userIntegrations));
    else if (typeof userIntegrations === 'function') {
        integrations = userIntegrations(integrations);
        integrations = Array.isArray(integrations) ? integrations : [
            integrations
        ];
    }
    // Make sure that if present, `Debug` integration will always run last
    var integrationsNames = integrations.map(function(i) {
        return i.name;
    });
    var alwaysLastToRun = 'Debug';
    if (integrationsNames.indexOf(alwaysLastToRun) !== -1) integrations.push.apply(integrations, (0, $iTWOe.__spread)(integrations.splice(integrationsNames.indexOf(alwaysLastToRun), 1)));
    return integrations;
}
function $ed49ec7a550738bc$export$e7390a03b70a6f2f(integration) {
    if ($ed49ec7a550738bc$export$b14a8888f80a0b3e.indexOf(integration.name) !== -1) return;
    integration.setupOnce((0, $FnrKW.addGlobalEventProcessor), (0, $ir14T.getCurrentHub));
    $ed49ec7a550738bc$export$b14a8888f80a0b3e.push(integration.name);
    (0, $kT3vf.IS_DEBUG_BUILD) && (0, $1v4ZC.logger).log("Integration installed: " + integration.name);
}
function $ed49ec7a550738bc$export$51abed9797baa598(options) {
    var integrations = {};
    $ed49ec7a550738bc$export$68bc4c01ab8ae766(options).forEach(function(integration) {
        integrations[integration.name] = integration;
        $ed49ec7a550738bc$export$e7390a03b70a6f2f(integration);
    });
    // set the `initialized` flag so we don't run through the process again unecessarily; use `Object.defineProperty`
    // because by default it creates a property which is nonenumerable, which we want since `initialized` shouldn't be
    // considered a member of the index the way the actual integrations are
    (0, $909Vl.addNonEnumerableProperty)(integrations, 'initialized', true);
    return integrations;
}

});


parcelRegister("1R0KG", function(module, exports) {
$parcel$export(module.exports, "BrowserBackend", () => $159b530227e0a7dd$export$2526e21aec9d0ce7);

var $iTWOe = parcelRequire("iTWOe");

var $10WBH = parcelRequire("10WBH");
var $fvs8x = parcelRequire("fvs8x");

var $iYYET = parcelRequire("iYYET");
parcelRequire("i0afJ");
var $7YVaQ = parcelRequire("7YVaQ");

var $QEOc2 = parcelRequire("QEOc2");

var $bixL8 = parcelRequire("bixL8");
var $315mi = parcelRequire("315mi");
var $tw7ZC = parcelRequire("tw7ZC");
var $kV3i0 = parcelRequire("kV3i0");
/**
 * The Sentry Browser SDK Backend.
 * @hidden
 */ var $159b530227e0a7dd$export$2526e21aec9d0ce7 = /** @class */ function(_super) {
    (0, $iTWOe.__extends)(BrowserBackend, _super);
    function BrowserBackend() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * @inheritDoc
     */ BrowserBackend.prototype.eventFromException = function(exception, hint) {
        return (0, $QEOc2.eventFromException)(exception, hint, this._options.attachStacktrace);
    };
    /**
     * @inheritDoc
     */ BrowserBackend.prototype.eventFromMessage = function(message, level, hint) {
        if (level === void 0) level = (0, $iYYET.Severity).Info;
        return (0, $QEOc2.eventFromMessage)(message, level, hint, this._options.attachStacktrace);
    };
    /**
     * @inheritDoc
     */ BrowserBackend.prototype._setupTransport = function() {
        if (!this._options.dsn) // We return the noop transport here in case there is no Dsn.
        return _super.prototype._setupTransport.call(this);
        var transportOptions = (0, $iTWOe.__assign)((0, $iTWOe.__assign)({}, this._options.transportOptions), {
            dsn: this._options.dsn,
            tunnel: this._options.tunnel,
            sendClientReports: this._options.sendClientReports,
            _metadata: this._options._metadata
        });
        var api = (0, $fvs8x.initAPIDetails)(transportOptions.dsn, transportOptions._metadata, transportOptions.tunnel);
        var url = (0, $fvs8x.getEnvelopeEndpointWithUrlEncodedAuth)(api.dsn, api.tunnel);
        if (this._options.transport) return new this._options.transport(transportOptions);
        if ((0, $7YVaQ.supportsFetch)()) {
            var requestOptions = (0, $iTWOe.__assign)({}, transportOptions.fetchParameters);
            this._newTransport = (0, $315mi.makeNewFetchTransport)({
                requestOptions: requestOptions,
                url: url
            });
            return new (0, $bixL8.FetchTransport)(transportOptions);
        }
        this._newTransport = (0, $tw7ZC.makeNewXHRTransport)({
            url: url,
            headers: transportOptions.headers
        });
        return new (0, $kV3i0.XHRTransport)(transportOptions);
    };
    return BrowserBackend;
}((0, $10WBH.BaseBackend));

});
parcelRegister("10WBH", function(module, exports) {
$parcel$export(module.exports, "BaseBackend", () => $0bd340aa354f6a9a$export$8f43a53a38d7e95f);

var $iTWOe = parcelRequire("iTWOe");
parcelRequire("i0afJ");
var $1v4ZC = parcelRequire("1v4ZC");
var $iMWNA = parcelRequire("iMWNA");

var $fvs8x = parcelRequire("fvs8x");

var $kT3vf = parcelRequire("kT3vf");

var $eOYVP = parcelRequire("eOYVP");

var $3bNx0 = parcelRequire("3bNx0");
/**
 * This is the base implemention of a Backend.
 * @hidden
 */ var $0bd340aa354f6a9a$export$8f43a53a38d7e95f = /** @class */ function() {
    /** Creates a new backend instance. */ function BaseBackend(options) {
        this._options = options;
        if (!this._options.dsn) (0, $kT3vf.IS_DEBUG_BUILD) && (0, $1v4ZC.logger).warn('No DSN provided, backend will not do anything.');
        this._transport = this._setupTransport();
    }
    /**
     * @inheritDoc
     */ // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
    BaseBackend.prototype.eventFromException = function(_exception, _hint) {
        throw new (0, $iMWNA.SentryError)('Backend has to implement `eventFromException` method');
    };
    /**
     * @inheritDoc
     */ BaseBackend.prototype.eventFromMessage = function(_message, _level, _hint) {
        throw new (0, $iMWNA.SentryError)('Backend has to implement `eventFromMessage` method');
    };
    /**
     * @inheritDoc
     */ BaseBackend.prototype.sendEvent = function(event) {
        // TODO(v7): Remove the if-else
        if (this._newTransport && this._options.dsn && this._options._experiments && this._options._experiments.newTransport) {
            var api = (0, $fvs8x.initAPIDetails)(this._options.dsn, this._options._metadata, this._options.tunnel);
            var env = (0, $eOYVP.createEventEnvelope)(event, api);
            this._newTransport.send(env).then(null, function(reason) {
                (0, $kT3vf.IS_DEBUG_BUILD) && (0, $1v4ZC.logger).error('Error while sending event:', reason);
            });
        } else this._transport.sendEvent(event).then(null, function(reason) {
            (0, $kT3vf.IS_DEBUG_BUILD) && (0, $1v4ZC.logger).error('Error while sending event:', reason);
        });
    };
    /**
     * @inheritDoc
     */ BaseBackend.prototype.sendSession = function(session) {
        if (!this._transport.sendSession) {
            (0, $kT3vf.IS_DEBUG_BUILD) && (0, $1v4ZC.logger).warn("Dropping session because custom transport doesn't implement sendSession");
            return;
        }
        // TODO(v7): Remove the if-else
        if (this._newTransport && this._options.dsn && this._options._experiments && this._options._experiments.newTransport) {
            var api = (0, $fvs8x.initAPIDetails)(this._options.dsn, this._options._metadata, this._options.tunnel);
            var _a = (0, $iTWOe.__read)((0, $eOYVP.createSessionEnvelope)(session, api), 1), env = _a[0];
            this._newTransport.send(env).then(null, function(reason) {
                (0, $kT3vf.IS_DEBUG_BUILD) && (0, $1v4ZC.logger).error('Error while sending session:', reason);
            });
        } else this._transport.sendSession(session).then(null, function(reason) {
            (0, $kT3vf.IS_DEBUG_BUILD) && (0, $1v4ZC.logger).error('Error while sending session:', reason);
        });
    };
    /**
     * @inheritDoc
     */ BaseBackend.prototype.getTransport = function() {
        return this._transport;
    };
    /**
     * Sets up the transport so it can be used later to send requests.
     */ BaseBackend.prototype._setupTransport = function() {
        return new (0, $3bNx0.NoopTransport)();
    };
    return BaseBackend;
}();

});
parcelRegister("fvs8x", function(module, exports) {
$parcel$export(module.exports, "getStoreEndpointWithUrlEncodedAuth", () => $b49f939dcd0814a6$export$c1677e22ac2217a5);
$parcel$export(module.exports, "getEnvelopeEndpointWithUrlEncodedAuth", () => $b49f939dcd0814a6$export$9964600bfe84e6a3);
$parcel$export(module.exports, "initAPIDetails", () => $b49f939dcd0814a6$export$ad00a06efb2a29cb);
$parcel$export(module.exports, "getReportDialogEndpoint", () => $b49f939dcd0814a6$export$671c7ed8e40a7a57);
parcelRequire("i0afJ");
var $62yRy = parcelRequire("62yRy");
var $909Vl = parcelRequire("909Vl");
var $b49f939dcd0814a6$var$SENTRY_API_VERSION = '7';
/**
 * Helper class to provide urls, headers and metadata that can be used to form
 * different types of requests to Sentry endpoints.
 * Supports both envelopes and regular event requests.
 *
 * @deprecated Please use APIDetails
 **/ var $b49f939dcd0814a6$export$2c4e825dc9120f87 = /** @class */ function() {
    /** Create a new instance of API */ function API(dsn, metadata, tunnel) {
        if (metadata === void 0) metadata = {};
        this.dsn = dsn;
        this._dsnObject = (0, $62yRy.makeDsn)(dsn);
        this.metadata = metadata;
        this._tunnel = tunnel;
    }
    /** Returns the Dsn object. */ API.prototype.getDsn = function() {
        return this._dsnObject;
    };
    /** Does this transport force envelopes? */ API.prototype.forceEnvelope = function() {
        return !!this._tunnel;
    };
    /** Returns the prefix to construct Sentry ingestion API endpoints. */ API.prototype.getBaseApiEndpoint = function() {
        return $b49f939dcd0814a6$var$getBaseApiEndpoint(this._dsnObject);
    };
    /** Returns the store endpoint URL. */ API.prototype.getStoreEndpoint = function() {
        return $b49f939dcd0814a6$var$getStoreEndpoint(this._dsnObject);
    };
    /**
     * Returns the store endpoint URL with auth in the query string.
     *
     * Sending auth as part of the query string and not as custom HTTP headers avoids CORS preflight requests.
     */ API.prototype.getStoreEndpointWithUrlEncodedAuth = function() {
        return $b49f939dcd0814a6$export$c1677e22ac2217a5(this._dsnObject);
    };
    /**
     * Returns the envelope endpoint URL with auth in the query string.
     *
     * Sending auth as part of the query string and not as custom HTTP headers avoids CORS preflight requests.
     */ API.prototype.getEnvelopeEndpointWithUrlEncodedAuth = function() {
        return $b49f939dcd0814a6$export$9964600bfe84e6a3(this._dsnObject, this._tunnel);
    };
    return API;
}();
function $b49f939dcd0814a6$export$ad00a06efb2a29cb(dsn, metadata, tunnel) {
    return {
        initDsn: dsn,
        metadata: metadata || {},
        dsn: (0, $62yRy.makeDsn)(dsn),
        tunnel: tunnel
    };
}
/** Returns the prefix to construct Sentry ingestion API endpoints. */ function $b49f939dcd0814a6$var$getBaseApiEndpoint(dsn) {
    var protocol = dsn.protocol ? dsn.protocol + ":" : '';
    var port = dsn.port ? ":" + dsn.port : '';
    return protocol + "//" + dsn.host + port + (dsn.path ? "/" + dsn.path : '') + "/api/";
}
/** Returns the ingest API endpoint for target. */ function $b49f939dcd0814a6$var$_getIngestEndpoint(dsn, target) {
    return "" + $b49f939dcd0814a6$var$getBaseApiEndpoint(dsn) + dsn.projectId + "/" + target + "/";
}
/** Returns a URL-encoded string with auth config suitable for a query string. */ function $b49f939dcd0814a6$var$_encodedAuth(dsn) {
    return (0, $909Vl.urlEncode)({
        // We send only the minimum set of required information. See
        // https://github.com/getsentry/sentry-javascript/issues/2572.
        sentry_key: dsn.publicKey,
        sentry_version: $b49f939dcd0814a6$var$SENTRY_API_VERSION
    });
}
/** Returns the store endpoint URL. */ function $b49f939dcd0814a6$var$getStoreEndpoint(dsn) {
    return $b49f939dcd0814a6$var$_getIngestEndpoint(dsn, 'store');
}
function $b49f939dcd0814a6$export$c1677e22ac2217a5(dsn) {
    return $b49f939dcd0814a6$var$getStoreEndpoint(dsn) + "?" + $b49f939dcd0814a6$var$_encodedAuth(dsn);
}
/** Returns the envelope endpoint URL. */ function $b49f939dcd0814a6$var$_getEnvelopeEndpoint(dsn) {
    return $b49f939dcd0814a6$var$_getIngestEndpoint(dsn, 'envelope');
}
function $b49f939dcd0814a6$export$9964600bfe84e6a3(dsn, tunnel) {
    return tunnel ? tunnel : $b49f939dcd0814a6$var$_getEnvelopeEndpoint(dsn) + "?" + $b49f939dcd0814a6$var$_encodedAuth(dsn);
}
function $b49f939dcd0814a6$export$1e4d4724de7b199e(dsn, clientName, clientVersion) {
    // CHANGE THIS to use metadata but keep clientName and clientVersion compatible
    var header = [
        "Sentry sentry_version=" + $b49f939dcd0814a6$var$SENTRY_API_VERSION
    ];
    header.push("sentry_client=" + clientName + "/" + clientVersion);
    header.push("sentry_key=" + dsn.publicKey);
    if (dsn.pass) header.push("sentry_secret=" + dsn.pass);
    return {
        'Content-Type': 'application/json',
        'X-Sentry-Auth': header.join(', ')
    };
}
function $b49f939dcd0814a6$export$671c7ed8e40a7a57(dsnLike, dialogOptions) {
    var dsn = (0, $62yRy.makeDsn)(dsnLike);
    var endpoint = $b49f939dcd0814a6$var$getBaseApiEndpoint(dsn) + "embed/error-page/";
    var encodedOptions = "dsn=" + (0, $62yRy.dsnToString)(dsn);
    for(var key in dialogOptions){
        if (key === 'dsn') continue;
        if (key === 'user') {
            if (!dialogOptions.user) continue;
            if (dialogOptions.user.name) encodedOptions += "&name=" + encodeURIComponent(dialogOptions.user.name);
            if (dialogOptions.user.email) encodedOptions += "&email=" + encodeURIComponent(dialogOptions.user.email);
        } else encodedOptions += "&" + encodeURIComponent(key) + "=" + encodeURIComponent(dialogOptions[key]);
    }
    return endpoint + "?" + encodedOptions;
}

});

parcelRegister("eOYVP", function(module, exports) {
$parcel$export(module.exports, "createSessionEnvelope", () => $aca4fffc7a46a82d$export$124b03c077baa2f3);
$parcel$export(module.exports, "sessionToSentryRequest", () => $aca4fffc7a46a82d$export$977ee6eda1884ec3);
$parcel$export(module.exports, "createEventEnvelope", () => $aca4fffc7a46a82d$export$c31057337a18010f);
$parcel$export(module.exports, "eventToSentryRequest", () => $aca4fffc7a46a82d$export$2006389de558b996);

var $iTWOe = parcelRequire("iTWOe");
parcelRequire("i0afJ");
var $9G22S = parcelRequire("9G22S");
var $62yRy = parcelRequire("62yRy");
var $bZWF1 = parcelRequire("bZWF1");

var $fvs8x = parcelRequire("fvs8x");
/** Extract sdk info from from the API metadata */ function $aca4fffc7a46a82d$var$getSdkMetadataForEnvelopeHeader(api) {
    if (!api.metadata || !api.metadata.sdk) return;
    var _a = api.metadata.sdk, name = _a.name, version = _a.version;
    return {
        name: name,
        version: version
    };
}
/**
 * Apply SdkInfo (name, version, packages, integrations) to the corresponding event key.
 * Merge with existing data if any.
 **/ function $aca4fffc7a46a82d$var$enhanceEventWithSdkInfo(event, sdkInfo) {
    if (!sdkInfo) return event;
    event.sdk = event.sdk || {};
    event.sdk.name = event.sdk.name || sdkInfo.name;
    event.sdk.version = event.sdk.version || sdkInfo.version;
    event.sdk.integrations = (0, $iTWOe.__spread)(event.sdk.integrations || [], sdkInfo.integrations || []);
    event.sdk.packages = (0, $iTWOe.__spread)(event.sdk.packages || [], sdkInfo.packages || []);
    return event;
}
function $aca4fffc7a46a82d$export$124b03c077baa2f3(session, api) {
    var sdkInfo = $aca4fffc7a46a82d$var$getSdkMetadataForEnvelopeHeader(api);
    var envelopeHeaders = (0, $iTWOe.__assign)((0, $iTWOe.__assign)({
        sent_at: new Date().toISOString()
    }, sdkInfo && {
        sdk: sdkInfo
    }), !!api.tunnel && {
        dsn: (0, $62yRy.dsnToString)(api.dsn)
    });
    // I know this is hacky but we don't want to add `sessions` to request type since it's never rate limited
    var type = 'aggregates' in session ? 'sessions' : 'session';
    // TODO (v7) Have to cast type because envelope items do not accept a `SentryRequestType`
    var envelopeItem = [
        {
            type: type
        },
        session
    ];
    var envelope = (0, $9G22S.createEnvelope)(envelopeHeaders, [
        envelopeItem
    ]);
    return [
        envelope,
        type
    ];
}
function $aca4fffc7a46a82d$export$977ee6eda1884ec3(session, api) {
    var _a = (0, $iTWOe.__read)($aca4fffc7a46a82d$export$124b03c077baa2f3(session, api), 2), envelope = _a[0], type = _a[1];
    return {
        body: (0, $9G22S.serializeEnvelope)(envelope),
        type: type,
        url: (0, $fvs8x.getEnvelopeEndpointWithUrlEncodedAuth)(api.dsn, api.tunnel)
    };
}
function $aca4fffc7a46a82d$export$c31057337a18010f(event, api) {
    var sdkInfo = $aca4fffc7a46a82d$var$getSdkMetadataForEnvelopeHeader(api);
    var eventType = event.type || 'event';
    var transactionSampling = (event.sdkProcessingMetadata || {}).transactionSampling;
    var _a = transactionSampling || {}, samplingMethod = _a.method, sampleRate = _a.rate;
    // TODO: Below is a temporary hack in order to debug a serialization error - see
    // https://github.com/getsentry/sentry-javascript/issues/2809,
    // https://github.com/getsentry/sentry-javascript/pull/4425, and
    // https://github.com/getsentry/sentry-javascript/pull/4574.
    //
    // TL; DR: even though we normalize all events (which should prevent this), something is causing `JSON.stringify` to
    // throw a circular reference error.
    //
    // When it's time to remove it:
    // 1. Delete everything between here and where the request object `req` is created, EXCEPT the line deleting
    //    `sdkProcessingMetadata`
    // 2. Restore the original version of the request body, which is commented out
    // 3. Search for either of the PR URLs above and pull out the companion hacks in the browser playwright tests and the
    //    baseClient tests in this package
    $aca4fffc7a46a82d$var$enhanceEventWithSdkInfo(event, api.metadata.sdk);
    event.tags = event.tags || {};
    event.extra = event.extra || {};
    // In theory, all events should be marked as having gone through normalization and so
    // we should never set this tag/extra data
    if (!(event.sdkProcessingMetadata && event.sdkProcessingMetadata.baseClientNormalized)) {
        event.tags.skippedNormalization = true;
        event.extra.normalizeDepth = event.sdkProcessingMetadata ? event.sdkProcessingMetadata.normalizeDepth : 'unset';
    }
    // prevent this data from being sent to sentry
    // TODO: This is NOT part of the hack - DO NOT DELETE
    delete event.sdkProcessingMetadata;
    var envelopeHeaders = (0, $iTWOe.__assign)((0, $iTWOe.__assign)({
        event_id: event.event_id,
        sent_at: new Date().toISOString()
    }, sdkInfo && {
        sdk: sdkInfo
    }), !!api.tunnel && {
        dsn: (0, $62yRy.dsnToString)(api.dsn)
    });
    var eventItem = [
        {
            type: eventType,
            sample_rates: [
                {
                    id: samplingMethod,
                    rate: sampleRate
                }
            ]
        },
        event
    ];
    return (0, $9G22S.createEnvelope)(envelopeHeaders, [
        eventItem
    ]);
}
function $aca4fffc7a46a82d$export$2006389de558b996(event, api) {
    var sdkInfo = $aca4fffc7a46a82d$var$getSdkMetadataForEnvelopeHeader(api);
    var eventType = event.type || 'event';
    var useEnvelope = eventType === 'transaction' || !!api.tunnel;
    var transactionSampling = (event.sdkProcessingMetadata || {}).transactionSampling;
    var _a = transactionSampling || {}, samplingMethod = _a.method, sampleRate = _a.rate;
    // TODO: Below is a temporary hack in order to debug a serialization error - see
    // https://github.com/getsentry/sentry-javascript/issues/2809,
    // https://github.com/getsentry/sentry-javascript/pull/4425, and
    // https://github.com/getsentry/sentry-javascript/pull/4574.
    //
    // TL; DR: even though we normalize all events (which should prevent this), something is causing `JSON.stringify` to
    // throw a circular reference error.
    //
    // When it's time to remove it:
    // 1. Delete everything between here and where the request object `req` is created, EXCEPT the line deleting
    //    `sdkProcessingMetadata`
    // 2. Restore the original version of the request body, which is commented out
    // 3. Search for either of the PR URLs above and pull out the companion hacks in the browser playwright tests and the
    //    baseClient tests in this package
    $aca4fffc7a46a82d$var$enhanceEventWithSdkInfo(event, api.metadata.sdk);
    event.tags = event.tags || {};
    event.extra = event.extra || {};
    // In theory, all events should be marked as having gone through normalization and so
    // we should never set this tag/extra data
    if (!(event.sdkProcessingMetadata && event.sdkProcessingMetadata.baseClientNormalized)) {
        event.tags.skippedNormalization = true;
        event.extra.normalizeDepth = event.sdkProcessingMetadata ? event.sdkProcessingMetadata.normalizeDepth : 'unset';
    }
    // prevent this data from being sent to sentry
    // TODO: This is NOT part of the hack - DO NOT DELETE
    delete event.sdkProcessingMetadata;
    var body;
    try {
        // 99.9% of events should get through just fine - no change in behavior for them
        body = JSON.stringify(event);
    } catch (err) {
        // Record data about the error without replacing original event data, then force renormalization
        event.tags.JSONStringifyError = true;
        event.extra.JSONStringifyError = err;
        try {
            body = JSON.stringify((0, $bZWF1.normalize)(event));
        } catch (newErr) {
            // At this point even renormalization hasn't worked, meaning something about the event data has gone very wrong.
            // Time to cut our losses and record only the new error. With luck, even in the problematic cases we're trying to
            // debug with this hack, we won't ever land here.
            var innerErr = newErr;
            body = JSON.stringify({
                message: 'JSON.stringify error after renormalization',
                // setting `extra: { innerErr }` here for some reason results in an empty object, so unpack manually
                extra: {
                    message: innerErr.message,
                    stack: innerErr.stack
                }
            });
        }
    }
    var req = {
        // this is the relevant line of code before the hack was added, to make it easy to undo said hack once we've solved
        // the mystery
        // body: JSON.stringify(sdkInfo ? enhanceEventWithSdkInfo(event, api.metadata.sdk) : event),
        body: body,
        type: eventType,
        url: useEnvelope ? (0, $fvs8x.getEnvelopeEndpointWithUrlEncodedAuth)(api.dsn, api.tunnel) : (0, $fvs8x.getStoreEndpointWithUrlEncodedAuth)(api.dsn)
    };
    // https://develop.sentry.dev/sdk/envelopes/
    // Since we don't need to manipulate envelopes nor store them, there is no
    // exported concept of an Envelope with operations including serialization and
    // deserialization. Instead, we only implement a minimal subset of the spec to
    // serialize events inline here.
    if (useEnvelope) {
        var envelopeHeaders = (0, $iTWOe.__assign)((0, $iTWOe.__assign)({
            event_id: event.event_id,
            sent_at: new Date().toISOString()
        }, sdkInfo && {
            sdk: sdkInfo
        }), !!api.tunnel && {
            dsn: (0, $62yRy.dsnToString)(api.dsn)
        });
        var eventItem = [
            {
                type: eventType,
                sample_rates: [
                    {
                        id: samplingMethod,
                        rate: sampleRate
                    }
                ]
            },
            req.body
        ];
        var envelope = (0, $9G22S.createEnvelope)(envelopeHeaders, [
            eventItem
        ]);
        req.body = (0, $9G22S.serializeEnvelope)(envelope);
    }
    return req;
}

});

parcelRegister("3bNx0", function(module, exports) {
$parcel$export(module.exports, "NoopTransport", () => $2528d20e6df164a7$export$6f2767450ea1346c);
parcelRequire("i0afJ");
var $bdF5c = parcelRequire("bdF5c");
/** Noop transport */ var $2528d20e6df164a7$export$6f2767450ea1346c = /** @class */ function() {
    function NoopTransport() {}
    /**
     * @inheritDoc
     */ NoopTransport.prototype.sendEvent = function(_) {
        return (0, $bdF5c.resolvedSyncPromise)({
            reason: 'NoopTransport: Event has been skipped because no Dsn is configured.',
            status: 'skipped'
        });
    };
    /**
     * @inheritDoc
     */ NoopTransport.prototype.close = function(_) {
        return (0, $bdF5c.resolvedSyncPromise)(true);
    };
    return NoopTransport;
}();

});


parcelRegister("QEOc2", function(module, exports) {
$parcel$export(module.exports, "exceptionFromError", () => $09e4832cb98fb9cd$export$a6c2d27607295951);
$parcel$export(module.exports, "eventFromException", () => $09e4832cb98fb9cd$export$ea3ec7e569b823fc);
$parcel$export(module.exports, "eventFromUnknownInput", () => $09e4832cb98fb9cd$export$9dd56ed1ef0c3420);
$parcel$export(module.exports, "eventFromMessage", () => $09e4832cb98fb9cd$export$5425b53185d13d6c);

var $iTWOe = parcelRequire("iTWOe");

var $iYYET = parcelRequire("iYYET");
parcelRequire("i0afJ");
var $73JtC = parcelRequire("73JtC");
var $b8srE = parcelRequire("b8srE");
var $909Vl = parcelRequire("909Vl");
var $8rX8J = parcelRequire("8rX8J");
var $bZWF1 = parcelRequire("bZWF1");
var $bdF5c = parcelRequire("bdF5c");

var $9WSf6 = parcelRequire("9WSf6");
function $09e4832cb98fb9cd$export$a6c2d27607295951(ex) {
    // Get the frames first since Opera can lose the stack if we touch anything else first
    var frames = $09e4832cb98fb9cd$export$d478b2c12fbcfdda(ex);
    var exception = {
        type: ex && ex.name,
        value: $09e4832cb98fb9cd$var$extractMessage(ex)
    };
    if (frames.length) exception.stacktrace = {
        frames: frames
    };
    if (exception.type === undefined && exception.value === '') exception.value = 'Unrecoverable error caught';
    return exception;
}
function $09e4832cb98fb9cd$export$a6a5dd73e489caf(exception, syntheticException, isUnhandledRejection) {
    var event = {
        exception: {
            values: [
                {
                    type: (0, $8rX8J.isEvent)(exception) ? exception.constructor.name : isUnhandledRejection ? 'UnhandledRejection' : 'Error',
                    value: "Non-Error " + (isUnhandledRejection ? 'promise rejection' : 'exception') + " captured with keys: " + (0, $909Vl.extractExceptionKeysForMessage)(exception)
                }
            ]
        },
        extra: {
            __serialized__: (0, $bZWF1.normalizeToSize)(exception)
        }
    };
    if (syntheticException) {
        var frames_1 = $09e4832cb98fb9cd$export$d478b2c12fbcfdda(syntheticException);
        if (frames_1.length) event.stacktrace = {
            frames: frames_1
        };
    }
    return event;
}
function $09e4832cb98fb9cd$export$73fbea5a0a5234af(ex) {
    return {
        exception: {
            values: [
                $09e4832cb98fb9cd$export$a6c2d27607295951(ex)
            ]
        }
    };
}
function $09e4832cb98fb9cd$export$d478b2c12fbcfdda(ex) {
    // Access and store the stacktrace property before doing ANYTHING
    // else to it because Opera is not very good at providing it
    // reliably in other circumstances.
    var stacktrace = ex.stacktrace || ex.stack || '';
    var popSize = $09e4832cb98fb9cd$var$getPopSize(ex);
    try {
        return (0, $b8srE.createStackParser)((0, $9WSf6.opera10StackParser), (0, $9WSf6.opera11StackParser), (0, $9WSf6.chromeStackParser), (0, $9WSf6.winjsStackParser), (0, $9WSf6.geckoStackParser))(stacktrace, popSize);
    } catch (e) {
    // no-empty
    }
    return [];
}
// Based on our own mapping pattern - https://github.com/getsentry/sentry/blob/9f08305e09866c8bd6d0c24f5b0aabdd7dd6c59c/src/sentry/lang/javascript/errormapping.py#L83-L108
var $09e4832cb98fb9cd$var$reactMinifiedRegexp = /Minified React error #\d+;/i;
function $09e4832cb98fb9cd$var$getPopSize(ex) {
    if (ex) {
        if (typeof ex.framesToPop === 'number') return ex.framesToPop;
        if ($09e4832cb98fb9cd$var$reactMinifiedRegexp.test(ex.message)) return 1;
    }
    return 0;
}
/**
 * There are cases where stacktrace.message is an Event object
 * https://github.com/getsentry/sentry-javascript/issues/1949
 * In this specific case we try to extract stacktrace.message.error.message
 */ function $09e4832cb98fb9cd$var$extractMessage(ex) {
    var message = ex && ex.message;
    if (!message) return 'No error message';
    if (message.error && typeof message.error.message === 'string') return message.error.message;
    return message;
}
function $09e4832cb98fb9cd$export$ea3ec7e569b823fc(exception, hint, attachStacktrace) {
    var syntheticException = hint && hint.syntheticException || undefined;
    var event = $09e4832cb98fb9cd$export$9dd56ed1ef0c3420(exception, syntheticException, attachStacktrace);
    (0, $73JtC.addExceptionMechanism)(event); // defaults to { type: 'generic', handled: true }
    event.level = (0, $iYYET.Severity).Error;
    if (hint && hint.event_id) event.event_id = hint.event_id;
    return (0, $bdF5c.resolvedSyncPromise)(event);
}
function $09e4832cb98fb9cd$export$5425b53185d13d6c(message, level, hint, attachStacktrace) {
    if (level === void 0) level = (0, $iYYET.Severity).Info;
    var syntheticException = hint && hint.syntheticException || undefined;
    var event = $09e4832cb98fb9cd$export$47d86ae4b3c9994(message, syntheticException, attachStacktrace);
    event.level = level;
    if (hint && hint.event_id) event.event_id = hint.event_id;
    return (0, $bdF5c.resolvedSyncPromise)(event);
}
function $09e4832cb98fb9cd$export$9dd56ed1ef0c3420(exception, syntheticException, attachStacktrace, isUnhandledRejection) {
    var event;
    if ((0, $8rX8J.isErrorEvent)(exception) && exception.error) {
        // If it is an ErrorEvent with `error` property, extract it to get actual Error
        var errorEvent = exception;
        return $09e4832cb98fb9cd$export$73fbea5a0a5234af(errorEvent.error);
    }
    // If it is a `DOMError` (which is a legacy API, but still supported in some browsers) then we just extract the name
    // and message, as it doesn't provide anything else. According to the spec, all `DOMExceptions` should also be
    // `Error`s, but that's not the case in IE11, so in that case we treat it the same as we do a `DOMError`.
    //
    // https://developer.mozilla.org/en-US/docs/Web/API/DOMError
    // https://developer.mozilla.org/en-US/docs/Web/API/DOMException
    // https://webidl.spec.whatwg.org/#es-DOMException-specialness
    if ((0, $8rX8J.isDOMError)(exception) || (0, $8rX8J.isDOMException)(exception)) {
        var domException = exception;
        if ('stack' in exception) event = $09e4832cb98fb9cd$export$73fbea5a0a5234af(exception);
        else {
            var name_1 = domException.name || ((0, $8rX8J.isDOMError)(domException) ? 'DOMError' : 'DOMException');
            var message = domException.message ? name_1 + ": " + domException.message : name_1;
            event = $09e4832cb98fb9cd$export$47d86ae4b3c9994(message, syntheticException, attachStacktrace);
            (0, $73JtC.addExceptionTypeValue)(event, message);
        }
        if ('code' in domException) event.tags = (0, $iTWOe.__assign)((0, $iTWOe.__assign)({}, event.tags), {
            'DOMException.code': "" + domException.code
        });
        return event;
    }
    if ((0, $8rX8J.isError)(exception)) // we have a real Error object, do nothing
    return $09e4832cb98fb9cd$export$73fbea5a0a5234af(exception);
    if ((0, $8rX8J.isPlainObject)(exception) || (0, $8rX8J.isEvent)(exception)) {
        // If it's a plain object or an instance of `Event` (the built-in JS kind, not this SDK's `Event` type), serialize
        // it manually. This will allow us to group events based on top-level keys which is much better than creating a new
        // group on any key/value change.
        var objectException = exception;
        event = $09e4832cb98fb9cd$export$a6a5dd73e489caf(objectException, syntheticException, isUnhandledRejection);
        (0, $73JtC.addExceptionMechanism)(event, {
            synthetic: true
        });
        return event;
    }
    // If none of previous checks were valid, then it means that it's not:
    // - an instance of DOMError
    // - an instance of DOMException
    // - an instance of Event
    // - an instance of Error
    // - a valid ErrorEvent (one with an error property)
    // - a plain Object
    //
    // So bail out and capture it as a simple message:
    event = $09e4832cb98fb9cd$export$47d86ae4b3c9994(exception, syntheticException, attachStacktrace);
    (0, $73JtC.addExceptionTypeValue)(event, "" + exception, undefined);
    (0, $73JtC.addExceptionMechanism)(event, {
        synthetic: true
    });
    return event;
}
function $09e4832cb98fb9cd$export$47d86ae4b3c9994(input, syntheticException, attachStacktrace) {
    var event = {
        message: input
    };
    if (attachStacktrace && syntheticException) {
        var frames_2 = $09e4832cb98fb9cd$export$d478b2c12fbcfdda(syntheticException);
        if (frames_2.length) event.stacktrace = {
            frames: frames_2
        };
    }
    return event;
}

});
parcelRegister("9WSf6", function(module, exports) {
$parcel$export(module.exports, "chromeStackParser", () => $73e39b4aefc69ec5$export$c693d9295441d8f9);
$parcel$export(module.exports, "geckoStackParser", () => $73e39b4aefc69ec5$export$c9ddf1e2b5d48bff);
$parcel$export(module.exports, "winjsStackParser", () => $73e39b4aefc69ec5$export$b6d155d85c1dcba5);
$parcel$export(module.exports, "opera10StackParser", () => $73e39b4aefc69ec5$export$966ec832d9699d6);
$parcel$export(module.exports, "opera11StackParser", () => $73e39b4aefc69ec5$export$989a1824b4734ce6);

var $iTWOe = parcelRequire("iTWOe");
// global reference to slice
var $73e39b4aefc69ec5$var$UNKNOWN_FUNCTION = '?';
var $73e39b4aefc69ec5$var$OPERA10_PRIORITY = 10;
var $73e39b4aefc69ec5$var$OPERA11_PRIORITY = 20;
var $73e39b4aefc69ec5$var$CHROME_PRIORITY = 30;
var $73e39b4aefc69ec5$var$WINJS_PRIORITY = 40;
var $73e39b4aefc69ec5$var$GECKO_PRIORITY = 50;
function $73e39b4aefc69ec5$var$createFrame(filename, func, lineno, colno) {
    var frame = {
        filename: filename,
        function: func,
        // All browser frames are considered in_app
        in_app: true
    };
    if (lineno !== undefined) frame.lineno = lineno;
    if (colno !== undefined) frame.colno = colno;
    return frame;
}
// Chromium based browsers: Chrome, Brave, new Opera, new Edge
var $73e39b4aefc69ec5$var$chromeRegex = /^\s*at (?:(.*?) ?\((?:address at )?)?((?:file|https?|blob|chrome-extension|address|native|eval|webpack|<anonymous>|[-a-z]+:|.*bundle|\/).*?)(?::(\d+))?(?::(\d+))?\)?\s*$/i;
var $73e39b4aefc69ec5$var$chromeEvalRegex = /\((\S*)(?::(\d+))(?::(\d+))\)/;
var $73e39b4aefc69ec5$var$chrome = function(line) {
    var parts = $73e39b4aefc69ec5$var$chromeRegex.exec(line);
    if (parts) {
        var isEval = parts[2] && parts[2].indexOf('eval') === 0; // start of line
        if (isEval) {
            var subMatch = $73e39b4aefc69ec5$var$chromeEvalRegex.exec(parts[2]);
            if (subMatch) {
                // throw out eval line/column and use top-most line/column number
                parts[2] = subMatch[1]; // url
                parts[3] = subMatch[2]; // line
                parts[4] = subMatch[3]; // column
            }
        }
        // Kamil: One more hack won't hurt us right? Understanding and adding more rules on top of these regexps right now
        // would be way too time consuming. (TODO: Rewrite whole RegExp to be more readable)
        var _a = (0, $iTWOe.__read)($73e39b4aefc69ec5$var$extractSafariExtensionDetails(parts[1] || $73e39b4aefc69ec5$var$UNKNOWN_FUNCTION, parts[2]), 2), func = _a[0], filename = _a[1];
        return $73e39b4aefc69ec5$var$createFrame(filename, func, parts[3] ? +parts[3] : undefined, parts[4] ? +parts[4] : undefined);
    }
    return;
};
var $73e39b4aefc69ec5$export$c693d9295441d8f9 = [
    $73e39b4aefc69ec5$var$CHROME_PRIORITY,
    $73e39b4aefc69ec5$var$chrome
];
// gecko regex: `(?:bundle|\d+\.js)`: `bundle` is for react native, `\d+\.js` also but specifically for ram bundles because it
// generates filenames without a prefix like `file://` the filenames in the stacktrace are just 42.js
// We need this specific case for now because we want no other regex to match.
var $73e39b4aefc69ec5$var$geckoREgex = /^\s*(.*?)(?:\((.*?)\))?(?:^|@)?((?:file|https?|blob|chrome|webpack|resource|moz-extension|capacitor).*?:\/.*?|\[native code\]|[^@]*(?:bundle|\d+\.js)|\/[\w\-. /=]+)(?::(\d+))?(?::(\d+))?\s*$/i;
var $73e39b4aefc69ec5$var$geckoEvalRegex = /(\S+) line (\d+)(?: > eval line \d+)* > eval/i;
var $73e39b4aefc69ec5$var$gecko = function(line) {
    var _a;
    var parts = $73e39b4aefc69ec5$var$geckoREgex.exec(line);
    if (parts) {
        var isEval = parts[3] && parts[3].indexOf(' > eval') > -1;
        if (isEval) {
            var subMatch = $73e39b4aefc69ec5$var$geckoEvalRegex.exec(parts[3]);
            if (subMatch) {
                // throw out eval line/column and use top-most line number
                parts[1] = parts[1] || 'eval';
                parts[3] = subMatch[1];
                parts[4] = subMatch[2];
                parts[5] = ''; // no column when eval
            }
        }
        var filename = parts[3];
        var func = parts[1] || $73e39b4aefc69ec5$var$UNKNOWN_FUNCTION;
        _a = (0, $iTWOe.__read)($73e39b4aefc69ec5$var$extractSafariExtensionDetails(func, filename), 2), func = _a[0], filename = _a[1];
        return $73e39b4aefc69ec5$var$createFrame(filename, func, parts[4] ? +parts[4] : undefined, parts[5] ? +parts[5] : undefined);
    }
    return;
};
var $73e39b4aefc69ec5$export$c9ddf1e2b5d48bff = [
    $73e39b4aefc69ec5$var$GECKO_PRIORITY,
    $73e39b4aefc69ec5$var$gecko
];
var $73e39b4aefc69ec5$var$winjsRegex = /^\s*at (?:((?:\[object object\])?.+) )?\(?((?:file|ms-appx|https?|webpack|blob):.*?):(\d+)(?::(\d+))?\)?\s*$/i;
var $73e39b4aefc69ec5$var$winjs = function(line) {
    var parts = $73e39b4aefc69ec5$var$winjsRegex.exec(line);
    return parts ? $73e39b4aefc69ec5$var$createFrame(parts[2], parts[1] || $73e39b4aefc69ec5$var$UNKNOWN_FUNCTION, +parts[3], parts[4] ? +parts[4] : undefined) : undefined;
};
var $73e39b4aefc69ec5$export$b6d155d85c1dcba5 = [
    $73e39b4aefc69ec5$var$WINJS_PRIORITY,
    $73e39b4aefc69ec5$var$winjs
];
var $73e39b4aefc69ec5$var$opera10Regex = / line (\d+).*script (?:in )?(\S+)(?:: in function (\S+))?$/i;
var $73e39b4aefc69ec5$var$opera10 = function(line) {
    var parts = $73e39b4aefc69ec5$var$opera10Regex.exec(line);
    return parts ? $73e39b4aefc69ec5$var$createFrame(parts[2], parts[3] || $73e39b4aefc69ec5$var$UNKNOWN_FUNCTION, +parts[1]) : undefined;
};
var $73e39b4aefc69ec5$export$966ec832d9699d6 = [
    $73e39b4aefc69ec5$var$OPERA10_PRIORITY,
    $73e39b4aefc69ec5$var$opera10
];
var $73e39b4aefc69ec5$var$opera11Regex = / line (\d+), column (\d+)\s*(?:in (?:<anonymous function: ([^>]+)>|([^)]+))\(.*\))? in (.*):\s*$/i;
var $73e39b4aefc69ec5$var$opera11 = function(line) {
    var parts = $73e39b4aefc69ec5$var$opera11Regex.exec(line);
    return parts ? $73e39b4aefc69ec5$var$createFrame(parts[5], parts[3] || parts[4] || $73e39b4aefc69ec5$var$UNKNOWN_FUNCTION, +parts[1], +parts[2]) : undefined;
};
var $73e39b4aefc69ec5$export$989a1824b4734ce6 = [
    $73e39b4aefc69ec5$var$OPERA11_PRIORITY,
    $73e39b4aefc69ec5$var$opera11
];
/**
 * Safari web extensions, starting version unknown, can produce "frames-only" stacktraces.
 * What it means, is that instead of format like:
 *
 * Error: wat
 *   at function@url:row:col
 *   at function@url:row:col
 *   at function@url:row:col
 *
 * it produces something like:
 *
 *   function@url:row:col
 *   function@url:row:col
 *   function@url:row:col
 *
 * Because of that, it won't be captured by `chrome` RegExp and will fall into `Gecko` branch.
 * This function is extracted so that we can use it in both places without duplicating the logic.
 * Unfortunately "just" changing RegExp is too complicated now and making it pass all tests
 * and fix this case seems like an impossible, or at least way too time-consuming task.
 */ var $73e39b4aefc69ec5$var$extractSafariExtensionDetails = function(func, filename) {
    var isSafariExtension = func.indexOf('safari-extension') !== -1;
    var isSafariWebExtension = func.indexOf('safari-web-extension') !== -1;
    return isSafariExtension || isSafariWebExtension ? [
        func.indexOf('@') !== -1 ? func.split('@')[0] : $73e39b4aefc69ec5$var$UNKNOWN_FUNCTION,
        isSafariExtension ? "safari-extension:" + filename : "safari-web-extension:" + filename
    ] : [
        func,
        filename
    ];
};

});


parcelRegister("bixL8", function(module, exports) {
$parcel$export(module.exports, "FetchTransport", () => $839b900621c46fa5$export$2bdee3f9b92f4e82);

var $iTWOe = parcelRequire("iTWOe");
parcelRequire("i0afJ");
var $iMWNA = parcelRequire("iMWNA");
var $7YVaQ = parcelRequire("7YVaQ");
var $bdF5c = parcelRequire("bdF5c");

var $6aT3D = parcelRequire("6aT3D");

var $8UlxH = parcelRequire("8UlxH");
/** `fetch` based transport */ var $839b900621c46fa5$export$2bdee3f9b92f4e82 = /** @class */ function(_super) {
    (0, $iTWOe.__extends)(FetchTransport, _super);
    function FetchTransport(options, fetchImpl) {
        if (fetchImpl === void 0) fetchImpl = (0, $8UlxH.getNativeFetchImplementation)();
        var _this = _super.call(this, options) || this;
        _this._fetch = fetchImpl;
        return _this;
    }
    /**
     * @param sentryRequest Prepared SentryRequest to be delivered
     * @param originalPayload Original payload used to create SentryRequest
     */ FetchTransport.prototype._sendRequest = function(sentryRequest, originalPayload) {
        var _this = this;
        // eslint-disable-next-line deprecation/deprecation
        if (this._isRateLimited(sentryRequest.type)) {
            this.recordLostEvent('ratelimit_backoff', sentryRequest.type);
            return Promise.reject({
                event: originalPayload,
                type: sentryRequest.type,
                // eslint-disable-next-line deprecation/deprecation
                reason: "Transport for " + sentryRequest.type + " requests locked till " + this._disabledUntil(sentryRequest.type) + " due to too many requests.",
                status: 429
            });
        }
        var options = {
            body: sentryRequest.body,
            method: 'POST',
            // Despite all stars in the sky saying that Edge supports old draft syntax, aka 'never', 'always', 'origin' and 'default'
            // (see https://caniuse.com/#feat=referrer-policy),
            // it doesn't. And it throws an exception instead of ignoring this parameter...
            // REF: https://github.com/getsentry/raven-js/issues/1233
            referrerPolicy: (0, $7YVaQ.supportsReferrerPolicy)() ? 'origin' : ''
        };
        if (this.options.fetchParameters !== undefined) Object.assign(options, this.options.fetchParameters);
        if (this.options.headers !== undefined) options.headers = this.options.headers;
        return this._buffer.add(function() {
            return new (0, $bdF5c.SyncPromise)(function(resolve, reject) {
                _this._fetch(sentryRequest.url, options).then(function(response) {
                    var headers = {
                        'x-sentry-rate-limits': response.headers.get('X-Sentry-Rate-Limits'),
                        'retry-after': response.headers.get('Retry-After')
                    };
                    _this._handleResponse({
                        requestType: sentryRequest.type,
                        response: response,
                        headers: headers,
                        resolve: resolve,
                        reject: reject
                    });
                }).catch(reject);
            });
        }).then(undefined, function(reason) {
            // It's either buffer rejection or any other xhr/fetch error, which are treated as NetworkError.
            if (reason instanceof (0, $iMWNA.SentryError)) _this.recordLostEvent('queue_overflow', sentryRequest.type);
            else _this.recordLostEvent('network_error', sentryRequest.type);
            throw reason;
        });
    };
    return FetchTransport;
}((0, $6aT3D.BaseTransport));

});
parcelRegister("6aT3D", function(module, exports) {
$parcel$export(module.exports, "BaseTransport", () => $47ee628c27b8c5d2$export$74b99d619e90f481);

var $iTWOe = parcelRequire("iTWOe");

var $eOYVP = parcelRequire("eOYVP");
var $fvs8x = parcelRequire("fvs8x");
parcelRequire("i0afJ");
var $diVdC = parcelRequire("diVdC");
var $etGw0 = parcelRequire("etGw0");
var $62yRy = parcelRequire("62yRy");
var $9P6Bi = parcelRequire("9P6Bi");
var $lrp9R = parcelRequire("lrp9R");
var $1v4ZC = parcelRequire("1v4ZC");
var $bUAoW = parcelRequire("bUAoW");
var $9G22S = parcelRequire("9G22S");

var $dMTNw = parcelRequire("dMTNw");

var $8UlxH = parcelRequire("8UlxH");
function $47ee628c27b8c5d2$var$requestTypeToCategory(ty) {
    var tyStr = ty;
    return tyStr === 'event' ? 'error' : tyStr;
}
var $47ee628c27b8c5d2$var$global = (0, $lrp9R.getGlobalObject)();
/** Base Transport class implementation */ var $47ee628c27b8c5d2$export$74b99d619e90f481 = /** @class */ function() {
    function BaseTransport(options) {
        var _this = this;
        this.options = options;
        /** A simple buffer holding all requests. */ this._buffer = (0, $bUAoW.makePromiseBuffer)(30);
        /** Locks transport after receiving rate limits in a response */ this._rateLimits = {};
        this._outcomes = {};
        this._api = (0, $fvs8x.initAPIDetails)(options.dsn, options._metadata, options.tunnel);
        // eslint-disable-next-line deprecation/deprecation
        this.url = (0, $fvs8x.getStoreEndpointWithUrlEncodedAuth)(this._api.dsn);
        if (this.options.sendClientReports && $47ee628c27b8c5d2$var$global.document) $47ee628c27b8c5d2$var$global.document.addEventListener('visibilitychange', function() {
            if ($47ee628c27b8c5d2$var$global.document.visibilityState === 'hidden') _this._flushOutcomes();
        });
    }
    /**
     * @inheritDoc
     */ BaseTransport.prototype.sendEvent = function(event) {
        return this._sendRequest((0, $eOYVP.eventToSentryRequest)(event, this._api), event);
    };
    /**
     * @inheritDoc
     */ BaseTransport.prototype.sendSession = function(session) {
        return this._sendRequest((0, $eOYVP.sessionToSentryRequest)(session, this._api), session);
    };
    /**
     * @inheritDoc
     */ BaseTransport.prototype.close = function(timeout) {
        return this._buffer.drain(timeout);
    };
    /**
     * @inheritDoc
     */ BaseTransport.prototype.recordLostEvent = function(reason, category) {
        var _a;
        if (!this.options.sendClientReports) return;
        // We want to track each category (event, transaction, session) separately
        // but still keep the distinction between different type of outcomes.
        // We could use nested maps, but it's much easier to read and type this way.
        // A correct type for map-based implementation if we want to go that route
        // would be `Partial<Record<SentryRequestType, Partial<Record<Outcome, number>>>>`
        var key = $47ee628c27b8c5d2$var$requestTypeToCategory(category) + ":" + reason;
        (0, $dMTNw.IS_DEBUG_BUILD) && (0, $1v4ZC.logger).log("Adding outcome: " + key);
        this._outcomes[key] = (_a = this._outcomes[key], _a !== null && _a !== void 0 ? _a : 0) + 1;
    };
    /**
     * Send outcomes as an envelope
     */ BaseTransport.prototype._flushOutcomes = function() {
        if (!this.options.sendClientReports) return;
        var outcomes = this._outcomes;
        this._outcomes = {};
        // Nothing to send
        if (!Object.keys(outcomes).length) {
            (0, $dMTNw.IS_DEBUG_BUILD) && (0, $1v4ZC.logger).log('No outcomes to flush');
            return;
        }
        (0, $dMTNw.IS_DEBUG_BUILD) && (0, $1v4ZC.logger).log("Flushing outcomes:\n" + JSON.stringify(outcomes, null, 2));
        var url = (0, $fvs8x.getEnvelopeEndpointWithUrlEncodedAuth)(this._api.dsn, this._api.tunnel);
        var discardedEvents = Object.keys(outcomes).map(function(key) {
            var _a = (0, $iTWOe.__read)(key.split(':'), 2), category = _a[0], reason = _a[1];
            return {
                reason: reason,
                category: category,
                quantity: outcomes[key]
            };
        // TODO: Improve types on discarded_events to get rid of cast
        });
        var envelope = (0, $diVdC.createClientReportEnvelope)(discardedEvents, this._api.tunnel && (0, $62yRy.dsnToString)(this._api.dsn));
        try {
            (0, $8UlxH.sendReport)(url, (0, $9G22S.serializeEnvelope)(envelope));
        } catch (e) {
            (0, $dMTNw.IS_DEBUG_BUILD) && (0, $1v4ZC.logger).error(e);
        }
    };
    /**
     * Handle Sentry repsonse for promise-based transports.
     */ BaseTransport.prototype._handleResponse = function(_a) {
        var requestType = _a.requestType, response = _a.response, headers = _a.headers, resolve = _a.resolve, reject = _a.reject;
        var status = (0, $9P6Bi.eventStatusFromHttpCode)(response.status);
        this._rateLimits = (0, $etGw0.updateRateLimits)(this._rateLimits, headers);
        // eslint-disable-next-line deprecation/deprecation
        if (this._isRateLimited(requestType)) (0, $dMTNw.IS_DEBUG_BUILD) && // eslint-disable-next-line deprecation/deprecation
        (0, $1v4ZC.logger).warn("Too many " + requestType + " requests, backing off until: " + this._disabledUntil(requestType));
        if (status === 'success') {
            resolve({
                status: status
            });
            return;
        }
        reject(response);
    };
    /**
     * Gets the time that given category is disabled until for rate limiting
     *
     * @deprecated Please use `disabledUntil` from @sentry/utils
     */ BaseTransport.prototype._disabledUntil = function(requestType) {
        var category = $47ee628c27b8c5d2$var$requestTypeToCategory(requestType);
        return new Date((0, $etGw0.disabledUntil)(this._rateLimits, category));
    };
    /**
     * Checks if a category is rate limited
     *
     * @deprecated Please use `isRateLimited` from @sentry/utils
     */ BaseTransport.prototype._isRateLimited = function(requestType) {
        var category = $47ee628c27b8c5d2$var$requestTypeToCategory(requestType);
        return (0, $etGw0.isRateLimited)(this._rateLimits, category);
    };
    return BaseTransport;
}();

});
parcelRegister("dMTNw", function(module, exports) {
$parcel$export(module.exports, "IS_DEBUG_BUILD", () => $a09b0a5534eb220e$export$48a8984ec0bf2e44);
/*
 * This file defines flags and constants that can be modified during compile time in order to facilitate tree shaking
 * for users.
 *
 * Debug flags need to be declared in each package individually and must not be imported across package boundaries,
 * because some build tools have trouble tree-shaking imported guards.
 *
 * As a convention, we define debug flags in a `flags.ts` file in the root of a package's `src` folder.
 *
 * Debug flag files will contain "magic strings" like `__SENTRY_DEBUG__` that may get replaced with actual values during
 * our, or the user's build process. Take care when introducing new flags - they must not throw if they are not
 * replaced.
 */ /** Flag that is true for debug builds, false otherwise. */ var $a09b0a5534eb220e$export$48a8984ec0bf2e44 = typeof __SENTRY_DEBUG__ === 'undefined' ? true : __SENTRY_DEBUG__;

});

parcelRegister("8UlxH", function(module, exports) {
$parcel$export(module.exports, "getNativeFetchImplementation", () => $67c4439c099d3ecd$export$8be2119ce08e3379);
$parcel$export(module.exports, "sendReport", () => $67c4439c099d3ecd$export$84bb63b2c17ec44d);
parcelRequire("i0afJ");
var $lQOiJ = parcelRequire("lQOiJ");
var $lrp9R = parcelRequire("lrp9R");
var $7YVaQ = parcelRequire("7YVaQ");
var $1v4ZC = parcelRequire("1v4ZC");

var $dMTNw = parcelRequire("dMTNw");
var $67c4439c099d3ecd$var$global = (0, $lrp9R.getGlobalObject)();
var $67c4439c099d3ecd$var$cachedFetchImpl;
function $67c4439c099d3ecd$export$8be2119ce08e3379() {
    if ($67c4439c099d3ecd$var$cachedFetchImpl) return $67c4439c099d3ecd$var$cachedFetchImpl;
    /* eslint-disable @typescript-eslint/unbound-method */ // Fast path to avoid DOM I/O
    if ((0, $7YVaQ.isNativeFetch)($67c4439c099d3ecd$var$global.fetch)) return $67c4439c099d3ecd$var$cachedFetchImpl = $67c4439c099d3ecd$var$global.fetch.bind($67c4439c099d3ecd$var$global);
    var document = $67c4439c099d3ecd$var$global.document;
    var fetchImpl = $67c4439c099d3ecd$var$global.fetch;
    // eslint-disable-next-line deprecation/deprecation
    if (document && typeof document.createElement === 'function') try {
        var sandbox = document.createElement('iframe');
        sandbox.hidden = true;
        document.head.appendChild(sandbox);
        var contentWindow = sandbox.contentWindow;
        if (contentWindow && contentWindow.fetch) fetchImpl = contentWindow.fetch;
        document.head.removeChild(sandbox);
    } catch (e) {
        (0, $dMTNw.IS_DEBUG_BUILD) && (0, $1v4ZC.logger).warn('Could not create sandbox iframe for pure fetch check, bailing to window.fetch: ', e);
    }
    return $67c4439c099d3ecd$var$cachedFetchImpl = fetchImpl.bind($67c4439c099d3ecd$var$global);
/* eslint-enable @typescript-eslint/unbound-method */ }
function $67c4439c099d3ecd$export$84bb63b2c17ec44d(url, body) {
    var isRealNavigator = Object.prototype.toString.call($67c4439c099d3ecd$var$global && $67c4439c099d3ecd$var$global.navigator) === '[object Navigator]';
    var hasSendBeacon = isRealNavigator && typeof $67c4439c099d3ecd$var$global.navigator.sendBeacon === 'function';
    if (hasSendBeacon) {
        // Prevent illegal invocations - https://xgwang.me/posts/you-may-not-know-beacon/#it-may-throw-error%2C-be-sure-to-catch
        var sendBeacon = $67c4439c099d3ecd$var$global.navigator.sendBeacon.bind($67c4439c099d3ecd$var$global.navigator);
        return sendBeacon(url, body);
    }
    if ((0, $7YVaQ.supportsFetch)()) {
        var fetch_1 = $67c4439c099d3ecd$export$8be2119ce08e3379();
        return (0, $lQOiJ.forget)(fetch_1(url, {
            body: body,
            method: 'POST',
            credentials: 'omit',
            keepalive: true
        }));
    }
}

});



parcelRegister("315mi", function(module, exports) {
$parcel$export(module.exports, "makeNewFetchTransport", () => $23259f303e4bc615$export$1c57e6bfd09bad13);

var $iTWOe = parcelRequire("iTWOe");

var $96fA7 = parcelRequire("96fA7");

var $8UlxH = parcelRequire("8UlxH");
function $23259f303e4bc615$export$1c57e6bfd09bad13(options, nativeFetch) {
    if (nativeFetch === void 0) nativeFetch = (0, $8UlxH.getNativeFetchImplementation)();
    function makeRequest(request) {
        var requestOptions = (0, $iTWOe.__assign)({
            body: request.body,
            method: 'POST',
            referrerPolicy: 'origin'
        }, options.requestOptions);
        return nativeFetch(options.url, requestOptions).then(function(response) {
            return response.text().then(function(body) {
                return {
                    body: body,
                    headers: {
                        'x-sentry-rate-limits': response.headers.get('X-Sentry-Rate-Limits'),
                        'retry-after': response.headers.get('Retry-After')
                    },
                    reason: response.statusText,
                    statusCode: response.status
                };
            });
        });
    }
    return (0, $96fA7.createTransport)({
        bufferSize: options.bufferSize
    }, makeRequest);
}

});
parcelRegister("96fA7", function(module, exports) {
$parcel$export(module.exports, "createTransport", () => $6a00c2bfdd3876d6$export$d09f50d9ab7f7b69);
parcelRequire("i0afJ");
var $etGw0 = parcelRequire("etGw0");
var $9P6Bi = parcelRequire("9P6Bi");
var $9G22S = parcelRequire("9G22S");
var $bUAoW = parcelRequire("bUAoW");
var $bdF5c = parcelRequire("bdF5c");
var $6a00c2bfdd3876d6$export$d8a725a7dce95622 = 'error';
var $6a00c2bfdd3876d6$export$99adc6fe67a3c63e = 'transaction';
var $6a00c2bfdd3876d6$export$9d7ad34f132fe68f = 'attachment';
var $6a00c2bfdd3876d6$export$42d9e7b5fc564c45 = 'session';
var $6a00c2bfdd3876d6$export$e515cf6dfd2f98b8 = 30;
function $6a00c2bfdd3876d6$export$d09f50d9ab7f7b69(options, makeRequest, buffer) {
    if (buffer === void 0) buffer = (0, $bUAoW.makePromiseBuffer)(options.bufferSize || $6a00c2bfdd3876d6$export$e515cf6dfd2f98b8);
    var rateLimits = {};
    var flush = function(timeout) {
        return buffer.drain(timeout);
    };
    function send(envelope) {
        var envCategory = (0, $9G22S.getEnvelopeType)(envelope);
        var category = envCategory === 'event' ? 'error' : envCategory;
        var request = {
            category: category,
            body: (0, $9G22S.serializeEnvelope)(envelope)
        };
        // Don't add to buffer if transport is already rate-limited
        if ((0, $etGw0.isRateLimited)(rateLimits, category)) return (0, $bdF5c.rejectedSyncPromise)({
            status: 'rate_limit',
            reason: $6a00c2bfdd3876d6$var$getRateLimitReason(rateLimits, category)
        });
        var requestTask = function() {
            return makeRequest(request).then(function(_a) {
                var body = _a.body, headers = _a.headers, reason = _a.reason, statusCode = _a.statusCode;
                var status = (0, $9P6Bi.eventStatusFromHttpCode)(statusCode);
                if (headers) rateLimits = (0, $etGw0.updateRateLimits)(rateLimits, headers);
                if (status === 'success') return (0, $bdF5c.resolvedSyncPromise)({
                    status: status,
                    reason: reason
                });
                return (0, $bdF5c.rejectedSyncPromise)({
                    status: status,
                    reason: reason || body || (status === 'rate_limit' ? $6a00c2bfdd3876d6$var$getRateLimitReason(rateLimits, category) : 'Unknown transport error')
                });
            });
        };
        return buffer.add(requestTask);
    }
    return {
        send: send,
        flush: flush
    };
}
function $6a00c2bfdd3876d6$var$getRateLimitReason(rateLimits, category) {
    return "Too many " + category + " requests, backing off until: " + new Date((0, $etGw0.disabledUntil)(rateLimits, category)).toISOString();
}

});


parcelRegister("tw7ZC", function(module, exports) {
$parcel$export(module.exports, "makeNewXHRTransport", () => $058ba17bc7b60c8d$export$4c0ac1dd4bbf4921);

var $96fA7 = parcelRequire("96fA7");
parcelRequire("i0afJ");
var $bdF5c = parcelRequire("bdF5c");
/**
 * The DONE ready state for XmlHttpRequest
 *
 * Defining it here as a constant b/c XMLHttpRequest.DONE is not always defined
 * (e.g. during testing, it is `undefined`)
 *
 * @see {@link https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest/readyState}
 */ var $058ba17bc7b60c8d$var$XHR_READYSTATE_DONE = 4;
function $058ba17bc7b60c8d$export$4c0ac1dd4bbf4921(options) {
    function makeRequest(request) {
        return new (0, $bdF5c.SyncPromise)(function(resolve, _reject) {
            var xhr = new XMLHttpRequest();
            xhr.onreadystatechange = function() {
                if (xhr.readyState === $058ba17bc7b60c8d$var$XHR_READYSTATE_DONE) {
                    var response = {
                        body: xhr.response,
                        headers: {
                            'x-sentry-rate-limits': xhr.getResponseHeader('X-Sentry-Rate-Limits'),
                            'retry-after': xhr.getResponseHeader('Retry-After')
                        },
                        reason: xhr.statusText,
                        statusCode: xhr.status
                    };
                    resolve(response);
                }
            };
            xhr.open('POST', options.url);
            for(var header in options.headers)if (Object.prototype.hasOwnProperty.call(options.headers, header)) xhr.setRequestHeader(header, options.headers[header]);
            xhr.send(request.body);
        });
    }
    return (0, $96fA7.createTransport)({
        bufferSize: options.bufferSize
    }, makeRequest);
}

});

parcelRegister("kV3i0", function(module, exports) {
$parcel$export(module.exports, "XHRTransport", () => $f3abaeb981645c66$export$874a283af77e8e62);

var $iTWOe = parcelRequire("iTWOe");
parcelRequire("i0afJ");
var $iMWNA = parcelRequire("iMWNA");
var $bdF5c = parcelRequire("bdF5c");

var $6aT3D = parcelRequire("6aT3D");
/** `XHR` based transport */ var $f3abaeb981645c66$export$874a283af77e8e62 = /** @class */ function(_super) {
    (0, $iTWOe.__extends)(XHRTransport, _super);
    function XHRTransport() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * @param sentryRequest Prepared SentryRequest to be delivered
     * @param originalPayload Original payload used to create SentryRequest
     */ XHRTransport.prototype._sendRequest = function(sentryRequest, originalPayload) {
        var _this = this;
        // eslint-disable-next-line deprecation/deprecation
        if (this._isRateLimited(sentryRequest.type)) {
            this.recordLostEvent('ratelimit_backoff', sentryRequest.type);
            return Promise.reject({
                event: originalPayload,
                type: sentryRequest.type,
                // eslint-disable-next-line deprecation/deprecation
                reason: "Transport for " + sentryRequest.type + " requests locked till " + this._disabledUntil(sentryRequest.type) + " due to too many requests.",
                status: 429
            });
        }
        return this._buffer.add(function() {
            return new (0, $bdF5c.SyncPromise)(function(resolve, reject) {
                var request = new XMLHttpRequest();
                request.onreadystatechange = function() {
                    if (request.readyState === 4) {
                        var headers = {
                            'x-sentry-rate-limits': request.getResponseHeader('X-Sentry-Rate-Limits'),
                            'retry-after': request.getResponseHeader('Retry-After')
                        };
                        _this._handleResponse({
                            requestType: sentryRequest.type,
                            response: request,
                            headers: headers,
                            resolve: resolve,
                            reject: reject
                        });
                    }
                };
                request.open('POST', sentryRequest.url);
                for(var header in _this.options.headers)if (Object.prototype.hasOwnProperty.call(_this.options.headers, header)) request.setRequestHeader(header, _this.options.headers[header]);
                request.send(sentryRequest.body);
            });
        }).then(undefined, function(reason) {
            // It's either buffer rejection or any other xhr/fetch error, which are treated as NetworkError.
            if (reason instanceof (0, $iMWNA.SentryError)) _this.recordLostEvent('queue_overflow', sentryRequest.type);
            else _this.recordLostEvent('network_error', sentryRequest.type);
            throw reason;
        });
    };
    return XHRTransport;
}((0, $6aT3D.BaseTransport));

});


parcelRegister("iuPyo", function(module, exports) {
$parcel$export(module.exports, "shouldIgnoreOnError", () => $d77304d140466795$export$b79738ab10c590b2);
$parcel$export(module.exports, "wrap", () => $d77304d140466795$export$4997ffc0176396a6);
$parcel$export(module.exports, "injectReportDialog", () => $d77304d140466795$export$deb9aac8ea0b576c);

var $iTWOe = parcelRequire("iTWOe");

var $kD78n = parcelRequire("kD78n");
var $fvs8x = parcelRequire("fvs8x");
parcelRequire("i0afJ");
var $73JtC = parcelRequire("73JtC");
var $909Vl = parcelRequire("909Vl");
var $lrp9R = parcelRequire("lrp9R");
var $1v4ZC = parcelRequire("1v4ZC");

var $dMTNw = parcelRequire("dMTNw");
var $d77304d140466795$var$global = (0, $lrp9R.getGlobalObject)();
var $d77304d140466795$var$ignoreOnError = 0;
function $d77304d140466795$export$b79738ab10c590b2() {
    return $d77304d140466795$var$ignoreOnError > 0;
}
function $d77304d140466795$export$1265a142ff5ba165() {
    // onerror should trigger before setTimeout
    $d77304d140466795$var$ignoreOnError += 1;
    setTimeout(function() {
        $d77304d140466795$var$ignoreOnError -= 1;
    });
}
function $d77304d140466795$export$4997ffc0176396a6(fn, options, before) {
    // for future readers what this does is wrap a function and then create
    // a bi-directional wrapping between them.
    //
    // example: wrapped = wrap(original);
    //  original.__sentry_wrapped__ -> wrapped
    //  wrapped.__sentry_original__ -> original
    if (options === void 0) options = {};
    if (typeof fn !== 'function') return fn;
    try {
        // if we're dealing with a function that was previously wrapped, return
        // the original wrapper.
        var wrapper = fn.__sentry_wrapped__;
        if (wrapper) return wrapper;
        // We don't wanna wrap it twice
        if ((0, $909Vl.getOriginalFunction)(fn)) return fn;
    } catch (e) {
        // Just accessing custom props in some Selenium environments
        // can cause a "Permission denied" exception (see raven-js#495).
        // Bail on wrapping and return the function as-is (defers to window.onerror).
        return fn;
    }
    /* eslint-disable prefer-rest-params */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var sentryWrapped = function() {
        var args = Array.prototype.slice.call(arguments);
        try {
            if (before && typeof before === 'function') before.apply(this, arguments);
            // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-member-access
            var wrappedArguments = args.map(function(arg) {
                return $d77304d140466795$export$4997ffc0176396a6(arg, options);
            });
            // Attempt to invoke user-land function
            // NOTE: If you are a Sentry user, and you are seeing this stack frame, it
            //       means the sentry.javascript SDK caught an error invoking your application code. This
            //       is expected behavior and NOT indicative of a bug with sentry.javascript.
            return fn.apply(this, wrappedArguments);
        } catch (ex) {
            $d77304d140466795$export$1265a142ff5ba165();
            (0, $kD78n.withScope)(function(scope) {
                scope.addEventProcessor(function(event) {
                    if (options.mechanism) {
                        (0, $73JtC.addExceptionTypeValue)(event, undefined, undefined);
                        (0, $73JtC.addExceptionMechanism)(event, options.mechanism);
                    }
                    event.extra = (0, $iTWOe.__assign)((0, $iTWOe.__assign)({}, event.extra), {
                        arguments: args
                    });
                    return event;
                });
                (0, $kD78n.captureException)(ex);
            });
            throw ex;
        }
    };
    /* eslint-enable prefer-rest-params */ // Accessing some objects may throw
    // ref: https://github.com/getsentry/sentry-javascript/issues/1168
    try {
        for(var property in fn)if (Object.prototype.hasOwnProperty.call(fn, property)) sentryWrapped[property] = fn[property];
    } catch (_oO) {} // eslint-disable-line no-empty
    // Signal that this function has been wrapped/filled already
    // for both debugging and to prevent it to being wrapped/filled twice
    (0, $909Vl.markFunctionWrapped)(sentryWrapped, fn);
    (0, $909Vl.addNonEnumerableProperty)(fn, '__sentry_wrapped__', sentryWrapped);
    // Restore original function name (not all browsers allow that)
    try {
        var descriptor = Object.getOwnPropertyDescriptor(sentryWrapped, 'name');
        if (descriptor.configurable) Object.defineProperty(sentryWrapped, 'name', {
            get: function() {
                return fn.name;
            }
        });
    // eslint-disable-next-line no-empty
    } catch (_oO) {}
    return sentryWrapped;
}
function $d77304d140466795$export$deb9aac8ea0b576c(options) {
    if (options === void 0) options = {};
    if (!$d77304d140466795$var$global.document) return;
    if (!options.eventId) {
        (0, $dMTNw.IS_DEBUG_BUILD) && (0, $1v4ZC.logger).error('Missing eventId option in showReportDialog call');
        return;
    }
    if (!options.dsn) {
        (0, $dMTNw.IS_DEBUG_BUILD) && (0, $1v4ZC.logger).error('Missing dsn option in showReportDialog call');
        return;
    }
    var script = $d77304d140466795$var$global.document.createElement('script');
    script.async = true;
    script.src = (0, $fvs8x.getReportDialogEndpoint)(options.dsn, options);
    if (options.onLoad) // eslint-disable-next-line @typescript-eslint/unbound-method
    script.onload = options.onLoad;
    var injectionPoint = $d77304d140466795$var$global.document.head || $d77304d140466795$var$global.document.body;
    if (injectionPoint) injectionPoint.appendChild(script);
}

});

parcelRegister("3UPj8", function(module, exports) {
$parcel$export(module.exports, "Breadcrumbs", () => $2d9e66b17b884fa3$export$2dc68d50d56fbbd);

var $iTWOe = parcelRequire("iTWOe");

var $ir14T = parcelRequire("ir14T");

var $iYYET = parcelRequire("iYYET");
parcelRequire("i0afJ");
var $aVmXt = parcelRequire("aVmXt");
var $73JtC = parcelRequire("73JtC");
var $lrp9R = parcelRequire("lrp9R");
var $f9iVj = parcelRequire("f9iVj");
var $9k3Oz = parcelRequire("9k3Oz");
var $kpXMz = parcelRequire("kpXMz");
/**
 * Default Breadcrumbs instrumentations
 * TODO: Deprecated - with v6, this will be renamed to `Instrument`
 */ var $2d9e66b17b884fa3$export$2dc68d50d56fbbd = /** @class */ function() {
    /**
     * @inheritDoc
     */ function Breadcrumbs(options) {
        /**
         * @inheritDoc
         */ this.name = Breadcrumbs.id;
        this._options = (0, $iTWOe.__assign)({
            console: true,
            dom: true,
            fetch: true,
            history: true,
            sentry: true,
            xhr: true
        }, options);
    }
    /**
     * Create a breadcrumb of `sentry` from the events themselves
     */ Breadcrumbs.prototype.addSentryBreadcrumb = function(event) {
        if (!this._options.sentry) return;
        (0, $ir14T.getCurrentHub)().addBreadcrumb({
            category: "sentry." + (event.type === 'transaction' ? 'transaction' : 'event'),
            event_id: event.event_id,
            level: event.level,
            message: (0, $73JtC.getEventDescription)(event)
        }, {
            event: event
        });
    };
    /**
     * Instrument browser built-ins w/ breadcrumb capturing
     *  - Console API
     *  - DOM API (click/typing)
     *  - XMLHttpRequest API
     *  - Fetch API
     *  - History API
     */ Breadcrumbs.prototype.setupOnce = function() {
        if (this._options.console) (0, $aVmXt.addInstrumentationHandler)('console', $2d9e66b17b884fa3$var$_consoleBreadcrumb);
        if (this._options.dom) (0, $aVmXt.addInstrumentationHandler)('dom', $2d9e66b17b884fa3$var$_domBreadcrumb(this._options.dom));
        if (this._options.xhr) (0, $aVmXt.addInstrumentationHandler)('xhr', $2d9e66b17b884fa3$var$_xhrBreadcrumb);
        if (this._options.fetch) (0, $aVmXt.addInstrumentationHandler)('fetch', $2d9e66b17b884fa3$var$_fetchBreadcrumb);
        if (this._options.history) (0, $aVmXt.addInstrumentationHandler)('history', $2d9e66b17b884fa3$var$_historyBreadcrumb);
    };
    /**
     * @inheritDoc
     */ Breadcrumbs.id = 'Breadcrumbs';
    return Breadcrumbs;
}();
/**
 * A HOC that creaes a function that creates breadcrumbs from DOM API calls.
 * This is a HOC so that we get access to dom options in the closure.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $2d9e66b17b884fa3$var$_domBreadcrumb(dom) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    function _innerDomBreadcrumb(handlerData) {
        var target;
        var keyAttrs = typeof dom === 'object' ? dom.serializeAttribute : undefined;
        if (typeof keyAttrs === 'string') keyAttrs = [
            keyAttrs
        ];
        // Accessing event.target can throw (see getsentry/raven-js#838, #768)
        try {
            target = handlerData.event.target ? (0, $f9iVj.htmlTreeAsString)(handlerData.event.target, keyAttrs) : (0, $f9iVj.htmlTreeAsString)(handlerData.event, keyAttrs);
        } catch (e) {
            target = '<unknown>';
        }
        if (target.length === 0) return;
        (0, $ir14T.getCurrentHub)().addBreadcrumb({
            category: "ui." + handlerData.name,
            message: target
        }, {
            event: handlerData.event,
            name: handlerData.name,
            global: handlerData.global
        });
    }
    return _innerDomBreadcrumb;
}
/**
 * Creates breadcrumbs from console API calls
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $2d9e66b17b884fa3$var$_consoleBreadcrumb(handlerData) {
    var breadcrumb = {
        category: 'console',
        data: {
            arguments: handlerData.args,
            logger: 'console'
        },
        level: (0, $kpXMz.severityFromString)(handlerData.level),
        message: (0, $9k3Oz.safeJoin)(handlerData.args, ' ')
    };
    if (handlerData.level === 'assert') {
        if (handlerData.args[0] === false) {
            breadcrumb.message = "Assertion failed: " + ((0, $9k3Oz.safeJoin)(handlerData.args.slice(1), ' ') || 'console.assert');
            breadcrumb.data.arguments = handlerData.args.slice(1);
        } else // Don't capture a breadcrumb for passed assertions
        return;
    }
    (0, $ir14T.getCurrentHub)().addBreadcrumb(breadcrumb, {
        input: handlerData.args,
        level: handlerData.level
    });
}
/**
 * Creates breadcrumbs from XHR API calls
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $2d9e66b17b884fa3$var$_xhrBreadcrumb(handlerData) {
    if (handlerData.endTimestamp) {
        // We only capture complete, non-sentry requests
        if (handlerData.xhr.__sentry_own_request__) return;
        var _a = handlerData.xhr.__sentry_xhr__ || {}, method = _a.method, url = _a.url, status_code = _a.status_code, body = _a.body;
        (0, $ir14T.getCurrentHub)().addBreadcrumb({
            category: 'xhr',
            data: {
                method: method,
                url: url,
                status_code: status_code
            },
            type: 'http'
        }, {
            xhr: handlerData.xhr,
            input: body
        });
        return;
    }
}
/**
 * Creates breadcrumbs from fetch API calls
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $2d9e66b17b884fa3$var$_fetchBreadcrumb(handlerData) {
    // We only capture complete fetch requests
    if (!handlerData.endTimestamp) return;
    if (handlerData.fetchData.url.match(/sentry_key/) && handlerData.fetchData.method === 'POST') // We will not create breadcrumbs for fetch requests that contain `sentry_key` (internal sentry requests)
    return;
    if (handlerData.error) (0, $ir14T.getCurrentHub)().addBreadcrumb({
        category: 'fetch',
        data: handlerData.fetchData,
        level: (0, $iYYET.Severity).Error,
        type: 'http'
    }, {
        data: handlerData.error,
        input: handlerData.args
    });
    else (0, $ir14T.getCurrentHub)().addBreadcrumb({
        category: 'fetch',
        data: (0, $iTWOe.__assign)((0, $iTWOe.__assign)({}, handlerData.fetchData), {
            status_code: handlerData.response.status
        }),
        type: 'http'
    }, {
        input: handlerData.args,
        response: handlerData.response
    });
}
/**
 * Creates breadcrumbs from history API calls
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $2d9e66b17b884fa3$var$_historyBreadcrumb(handlerData) {
    var global = (0, $lrp9R.getGlobalObject)();
    var from = handlerData.from;
    var to = handlerData.to;
    var parsedLoc = (0, $73JtC.parseUrl)(global.location.href);
    var parsedFrom = (0, $73JtC.parseUrl)(from);
    var parsedTo = (0, $73JtC.parseUrl)(to);
    // Initial pushState doesn't provide `from` information
    if (!parsedFrom.path) parsedFrom = parsedLoc;
    // Use only the path component of the URL if the URL matches the current
    // document (almost all the time when using pushState)
    if (parsedLoc.protocol === parsedTo.protocol && parsedLoc.host === parsedTo.host) to = parsedTo.relative;
    if (parsedLoc.protocol === parsedFrom.protocol && parsedLoc.host === parsedFrom.host) from = parsedFrom.relative;
    (0, $ir14T.getCurrentHub)().addBreadcrumb({
        category: 'navigation',
        data: {
            from: from,
            to: to
        }
    });
}

});


parcelRegister("5R1Wi", function(module, exports) {
$parcel$export(module.exports, "defaultIntegrations", () => $4433681b335e918c$export$5ef831fccfce35e5);
$parcel$export(module.exports, "init", () => $4433681b335e918c$export$2cd8252107eb640b);
$parcel$export(module.exports, "showReportDialog", () => $4433681b335e918c$export$3a8fd680da42627b);
$parcel$export(module.exports, "lastEventId", () => $4433681b335e918c$export$5d4e9fd7fac8e617);
$parcel$export(module.exports, "forceLoad", () => $4433681b335e918c$export$a3f323d81eede727);
$parcel$export(module.exports, "onLoad", () => $4433681b335e918c$export$4e4d8b287d028b6b);
$parcel$export(module.exports, "flush", () => $4433681b335e918c$export$4909b86c8034bf73);
$parcel$export(module.exports, "close", () => $4433681b335e918c$export$8360e631d277ea4d);
$parcel$export(module.exports, "wrap", () => $4433681b335e918c$export$4997ffc0176396a6);

var $iTWOe = parcelRequire("iTWOe");

var $ir14T = parcelRequire("ir14T");
var $c9Yw8 = parcelRequire("c9Yw8");
var $2zF9F = parcelRequire("2zF9F");
parcelRequire("i0afJ");
var $aVmXt = parcelRequire("aVmXt");
var $lrp9R = parcelRequire("lrp9R");
var $1v4ZC = parcelRequire("1v4ZC");
var $bdF5c = parcelRequire("bdF5c");

var $7bmvO = parcelRequire("7bmvO");

var $dMTNw = parcelRequire("dMTNw");

var $iuPyo = parcelRequire("iuPyo");

var $3UPj8 = parcelRequire("3UPj8");
var $8P1DV = parcelRequire("8P1DV");
var $1AZSA = parcelRequire("1AZSA");
var $bE3Cg = parcelRequire("bE3Cg");
var $6VlkC = parcelRequire("6VlkC");
var $35gFN = parcelRequire("35gFN");
var $4433681b335e918c$export$5ef831fccfce35e5 = [
    new (0, $2zF9F).InboundFilters(),
    new (0, $2zF9F).FunctionToString(),
    new (0, $6VlkC.TryCatch)(),
    new (0, $3UPj8.Breadcrumbs)(),
    new (0, $1AZSA.GlobalHandlers)(),
    new (0, $bE3Cg.LinkedErrors)(),
    new (0, $8P1DV.Dedupe)(),
    new (0, $35gFN.UserAgent)()
];
function $4433681b335e918c$export$2cd8252107eb640b(options) {
    if (options === void 0) options = {};
    if (options.defaultIntegrations === undefined) options.defaultIntegrations = $4433681b335e918c$export$5ef831fccfce35e5;
    if (options.release === undefined) {
        var window_1 = (0, $lrp9R.getGlobalObject)();
        // This supports the variable that sentry-webpack-plugin injects
        if (window_1.SENTRY_RELEASE && window_1.SENTRY_RELEASE.id) options.release = window_1.SENTRY_RELEASE.id;
    }
    if (options.autoSessionTracking === undefined) options.autoSessionTracking = true;
    if (options.sendClientReports === undefined) options.sendClientReports = true;
    (0, $c9Yw8.initAndBind)((0, $7bmvO.BrowserClient), options);
    if (options.autoSessionTracking) $4433681b335e918c$var$startSessionTracking();
}
function $4433681b335e918c$export$3a8fd680da42627b(options) {
    if (options === void 0) options = {};
    var hub = (0, $ir14T.getCurrentHub)();
    var scope = hub.getScope();
    if (scope) options.user = (0, $iTWOe.__assign)((0, $iTWOe.__assign)({}, scope.getUser()), options.user);
    if (!options.eventId) options.eventId = hub.lastEventId();
    var client = hub.getClient();
    if (client) client.showReportDialog(options);
}
function $4433681b335e918c$export$5d4e9fd7fac8e617() {
    return (0, $ir14T.getCurrentHub)().lastEventId();
}
function $4433681b335e918c$export$a3f323d81eede727() {
// Noop
}
function $4433681b335e918c$export$4e4d8b287d028b6b(callback) {
    callback();
}
function $4433681b335e918c$export$4909b86c8034bf73(timeout) {
    var client = (0, $ir14T.getCurrentHub)().getClient();
    if (client) return client.flush(timeout);
    (0, $dMTNw.IS_DEBUG_BUILD) && (0, $1v4ZC.logger).warn('Cannot flush events. No client defined.');
    return (0, $bdF5c.resolvedSyncPromise)(false);
}
function $4433681b335e918c$export$8360e631d277ea4d(timeout) {
    var client = (0, $ir14T.getCurrentHub)().getClient();
    if (client) return client.close(timeout);
    (0, $dMTNw.IS_DEBUG_BUILD) && (0, $1v4ZC.logger).warn('Cannot flush events and disable SDK. No client defined.');
    return (0, $bdF5c.resolvedSyncPromise)(false);
}
function $4433681b335e918c$export$4997ffc0176396a6(fn) {
    return (0, $iuPyo.wrap)(fn)();
}
function $4433681b335e918c$var$startSessionOnHub(hub) {
    hub.startSession({
        ignoreDuration: true
    });
    hub.captureSession();
}
/**
 * Enable automatic Session Tracking for the initial page load.
 */ function $4433681b335e918c$var$startSessionTracking() {
    var window = (0, $lrp9R.getGlobalObject)();
    var document = window.document;
    if (typeof document === 'undefined') {
        (0, $dMTNw.IS_DEBUG_BUILD) && (0, $1v4ZC.logger).warn('Session tracking in non-browser environment with @sentry/browser is not supported.');
        return;
    }
    var hub = (0, $ir14T.getCurrentHub)();
    // The only way for this to be false is for there to be a version mismatch between @sentry/browser (>= 6.0.0) and
    // @sentry/hub (< 5.27.0). In the simple case, there won't ever be such a mismatch, because the two packages are
    // pinned at the same version in package.json, but there are edge cases where it's possible. See
    // https://github.com/getsentry/sentry-javascript/issues/3207 and
    // https://github.com/getsentry/sentry-javascript/issues/3234 and
    // https://github.com/getsentry/sentry-javascript/issues/3278.
    if (!hub.captureSession) return;
    // The session duration for browser sessions does not track a meaningful
    // concept that can be used as a metric.
    // Automatically captured sessions are akin to page views, and thus we
    // discard their duration.
    $4433681b335e918c$var$startSessionOnHub(hub);
    // We want to create a session for every navigation as well
    (0, $aVmXt.addInstrumentationHandler)('history', function(_a) {
        var from = _a.from, to = _a.to;
        // Don't create an additional session for the initial route or if the location did not change
        if (!(from === undefined || from === to)) $4433681b335e918c$var$startSessionOnHub((0, $ir14T.getCurrentHub)());
    });
}

});
parcelRegister("c9Yw8", function(module, exports) {
$parcel$export(module.exports, "initAndBind", () => $0248dbf2af0a53d3$export$5333c3f1c58d9bc1);

var $ir14T = parcelRequire("ir14T");
parcelRequire("i0afJ");
var $1v4ZC = parcelRequire("1v4ZC");

var $kT3vf = parcelRequire("kT3vf");
function $0248dbf2af0a53d3$export$5333c3f1c58d9bc1(clientClass, options) {
    if (options.debug === true) {
        if (0, $kT3vf.IS_DEBUG_BUILD) (0, $1v4ZC.logger).enable();
        else // use `console.warn` rather than `logger.warn` since by non-debug bundles have all `logger.x` statements stripped
        // eslint-disable-next-line no-console
        console.warn('[Sentry] Cannot initialize SDK with `debug` option using a non-debug bundle.');
    }
    var hub = (0, $ir14T.getCurrentHub)();
    var scope = hub.getScope();
    if (scope) scope.update(options.initialScope);
    var client = new clientClass(options);
    hub.bindClient(client);
}

});

parcelRegister("2zF9F", function(module, exports) {
$parcel$export(module.exports, "FunctionToString", () => (parcelRequire("gE0zC")).FunctionToString);
$parcel$export(module.exports, "InboundFilters", () => (parcelRequire("bRs5l")).InboundFilters);

var $gE0zC = parcelRequire("gE0zC");

var $bRs5l = parcelRequire("bRs5l");

});
parcelRegister("gE0zC", function(module, exports) {
$parcel$export(module.exports, "FunctionToString", () => $0320878b0eb1bc48$export$da4704525c20ae79);
parcelRequire("i0afJ");
var $909Vl = parcelRequire("909Vl");
var $0320878b0eb1bc48$var$originalFunctionToString;
/** Patch toString calls to return proper name for wrapped functions */ var $0320878b0eb1bc48$export$da4704525c20ae79 = /** @class */ function() {
    function FunctionToString() {
        /**
         * @inheritDoc
         */ this.name = FunctionToString.id;
    }
    /**
     * @inheritDoc
     */ FunctionToString.prototype.setupOnce = function() {
        // eslint-disable-next-line @typescript-eslint/unbound-method
        $0320878b0eb1bc48$var$originalFunctionToString = Function.prototype.toString;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Function.prototype.toString = function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            var context = (0, $909Vl.getOriginalFunction)(this) || this;
            return $0320878b0eb1bc48$var$originalFunctionToString.apply(context, args);
        };
    };
    /**
     * @inheritDoc
     */ FunctionToString.id = 'FunctionToString';
    return FunctionToString;
}();

});

parcelRegister("bRs5l", function(module, exports) {
$parcel$export(module.exports, "InboundFilters", () => $8a2a6e19902cb07e$export$2ffbb5359dcc6be4);

var $iTWOe = parcelRequire("iTWOe");
parcelRequire("i0afJ");
var $73JtC = parcelRequire("73JtC");
var $9k3Oz = parcelRequire("9k3Oz");
var $1v4ZC = parcelRequire("1v4ZC");

var $kT3vf = parcelRequire("kT3vf");
// "Script error." is hard coded into browsers for errors that it can't read.
// this is the result of a script being pulled in from an external domain and CORS.
var $8a2a6e19902cb07e$var$DEFAULT_IGNORE_ERRORS = [
    /^Script error\.?$/,
    /^Javascript error: Script error\.? on line 0$/
];
/** Inbound filters configurable by the user */ var $8a2a6e19902cb07e$export$2ffbb5359dcc6be4 = /** @class */ function() {
    function InboundFilters(_options) {
        if (_options === void 0) _options = {};
        this._options = _options;
        /**
         * @inheritDoc
         */ this.name = InboundFilters.id;
    }
    /**
     * @inheritDoc
     */ InboundFilters.prototype.setupOnce = function(addGlobalEventProcessor, getCurrentHub) {
        addGlobalEventProcessor(function(event) {
            var hub = getCurrentHub();
            if (hub) {
                var self_1 = hub.getIntegration(InboundFilters);
                if (self_1) {
                    var client = hub.getClient();
                    var clientOptions = client ? client.getOptions() : {};
                    var options = $8a2a6e19902cb07e$export$6620a151868b99aa(self_1._options, clientOptions);
                    return $8a2a6e19902cb07e$export$3c6361fddf6cd929(event, options) ? null : event;
                }
            }
            return event;
        });
    };
    /**
     * @inheritDoc
     */ InboundFilters.id = 'InboundFilters';
    return InboundFilters;
}();
function $8a2a6e19902cb07e$export$6620a151868b99aa(internalOptions, clientOptions) {
    if (internalOptions === void 0) internalOptions = {};
    if (clientOptions === void 0) clientOptions = {};
    return {
        allowUrls: (0, $iTWOe.__spread)(internalOptions.whitelistUrls || [], internalOptions.allowUrls || [], clientOptions.whitelistUrls || [], clientOptions.allowUrls || []),
        denyUrls: (0, $iTWOe.__spread)(internalOptions.blacklistUrls || [], internalOptions.denyUrls || [], clientOptions.blacklistUrls || [], clientOptions.denyUrls || []),
        ignoreErrors: (0, $iTWOe.__spread)(internalOptions.ignoreErrors || [], clientOptions.ignoreErrors || [], $8a2a6e19902cb07e$var$DEFAULT_IGNORE_ERRORS),
        ignoreInternal: internalOptions.ignoreInternal !== undefined ? internalOptions.ignoreInternal : true
    };
}
function $8a2a6e19902cb07e$export$3c6361fddf6cd929(event, options) {
    if (options.ignoreInternal && $8a2a6e19902cb07e$var$_isSentryError(event)) {
        (0, $kT3vf.IS_DEBUG_BUILD) && (0, $1v4ZC.logger).warn("Event dropped due to being internal Sentry Error.\nEvent: " + (0, $73JtC.getEventDescription)(event));
        return true;
    }
    if ($8a2a6e19902cb07e$var$_isIgnoredError(event, options.ignoreErrors)) {
        (0, $kT3vf.IS_DEBUG_BUILD) && (0, $1v4ZC.logger).warn("Event dropped due to being matched by `ignoreErrors` option.\nEvent: " + (0, $73JtC.getEventDescription)(event));
        return true;
    }
    if ($8a2a6e19902cb07e$var$_isDeniedUrl(event, options.denyUrls)) {
        (0, $kT3vf.IS_DEBUG_BUILD) && (0, $1v4ZC.logger).warn("Event dropped due to being matched by `denyUrls` option.\nEvent: " + (0, $73JtC.getEventDescription)(event) + ".\nUrl: " + $8a2a6e19902cb07e$var$_getEventFilterUrl(event));
        return true;
    }
    if (!$8a2a6e19902cb07e$var$_isAllowedUrl(event, options.allowUrls)) {
        (0, $kT3vf.IS_DEBUG_BUILD) && (0, $1v4ZC.logger).warn("Event dropped due to not being matched by `allowUrls` option.\nEvent: " + (0, $73JtC.getEventDescription)(event) + ".\nUrl: " + $8a2a6e19902cb07e$var$_getEventFilterUrl(event));
        return true;
    }
    return false;
}
function $8a2a6e19902cb07e$var$_isIgnoredError(event, ignoreErrors) {
    if (!ignoreErrors || !ignoreErrors.length) return false;
    return $8a2a6e19902cb07e$var$_getPossibleEventMessages(event).some(function(message) {
        return ignoreErrors.some(function(pattern) {
            return (0, $9k3Oz.isMatchingPattern)(message, pattern);
        });
    });
}
function $8a2a6e19902cb07e$var$_isDeniedUrl(event, denyUrls) {
    // TODO: Use Glob instead?
    if (!denyUrls || !denyUrls.length) return false;
    var url = $8a2a6e19902cb07e$var$_getEventFilterUrl(event);
    return !url ? false : denyUrls.some(function(pattern) {
        return (0, $9k3Oz.isMatchingPattern)(url, pattern);
    });
}
function $8a2a6e19902cb07e$var$_isAllowedUrl(event, allowUrls) {
    // TODO: Use Glob instead?
    if (!allowUrls || !allowUrls.length) return true;
    var url = $8a2a6e19902cb07e$var$_getEventFilterUrl(event);
    return !url ? true : allowUrls.some(function(pattern) {
        return (0, $9k3Oz.isMatchingPattern)(url, pattern);
    });
}
function $8a2a6e19902cb07e$var$_getPossibleEventMessages(event) {
    if (event.message) return [
        event.message
    ];
    if (event.exception) try {
        var _a = event.exception.values && event.exception.values[0] || {}, _b = _a.type, type = _b === void 0 ? '' : _b, _c = _a.value, value = _c === void 0 ? '' : _c;
        return [
            "" + value,
            type + ": " + value
        ];
    } catch (oO) {
        (0, $kT3vf.IS_DEBUG_BUILD) && (0, $1v4ZC.logger).error("Cannot extract message for event " + (0, $73JtC.getEventDescription)(event));
        return [];
    }
    return [];
}
function $8a2a6e19902cb07e$var$_isSentryError(event) {
    try {
        // @ts-ignore can't be a sentry error if undefined
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        return event.exception.values[0].type === 'SentryError';
    } catch (e) {
    // ignore
    }
    return false;
}
function $8a2a6e19902cb07e$var$_getLastValidUrl(frames) {
    if (frames === void 0) frames = [];
    for(var i = frames.length - 1; i >= 0; i--){
        var frame = frames[i];
        if (frame && frame.filename !== '<anonymous>' && frame.filename !== '[native code]') return frame.filename || null;
    }
    return null;
}
function $8a2a6e19902cb07e$var$_getEventFilterUrl(event) {
    try {
        if (event.stacktrace) return $8a2a6e19902cb07e$var$_getLastValidUrl(event.stacktrace.frames);
        var frames_1;
        try {
            // @ts-ignore we only care about frames if the whole thing here is defined
            frames_1 = event.exception.values[0].stacktrace.frames;
        } catch (e) {
        // ignore
        }
        return frames_1 ? $8a2a6e19902cb07e$var$_getLastValidUrl(frames_1) : null;
    } catch (oO) {
        (0, $kT3vf.IS_DEBUG_BUILD) && (0, $1v4ZC.logger).error("Cannot extract url for event " + (0, $73JtC.getEventDescription)(event));
        return null;
    }
}

});


parcelRegister("8P1DV", function(module, exports) {
$parcel$export(module.exports, "Dedupe", () => $66c45c6668ea1dba$export$688d98c249d31ad3);
parcelRequire("i0afJ");
var $1v4ZC = parcelRequire("1v4ZC");

var $dMTNw = parcelRequire("dMTNw");
/** Deduplication filter */ var $66c45c6668ea1dba$export$688d98c249d31ad3 = /** @class */ function() {
    function Dedupe() {
        /**
         * @inheritDoc
         */ this.name = Dedupe.id;
    }
    /**
     * @inheritDoc
     */ Dedupe.prototype.setupOnce = function(addGlobalEventProcessor, getCurrentHub) {
        addGlobalEventProcessor(function(currentEvent) {
            var self = getCurrentHub().getIntegration(Dedupe);
            if (self) {
                // Juuust in case something goes wrong
                try {
                    if ($66c45c6668ea1dba$var$_shouldDropEvent(currentEvent, self._previousEvent)) {
                        (0, $dMTNw.IS_DEBUG_BUILD) && (0, $1v4ZC.logger).warn('Event dropped due to being a duplicate of previously captured event.');
                        return null;
                    }
                } catch (_oO) {
                    return self._previousEvent = currentEvent;
                }
                return self._previousEvent = currentEvent;
            }
            return currentEvent;
        });
    };
    /**
     * @inheritDoc
     */ Dedupe.id = 'Dedupe';
    return Dedupe;
}();
/** JSDoc */ function $66c45c6668ea1dba$var$_shouldDropEvent(currentEvent, previousEvent) {
    if (!previousEvent) return false;
    if ($66c45c6668ea1dba$var$_isSameMessageEvent(currentEvent, previousEvent)) return true;
    if ($66c45c6668ea1dba$var$_isSameExceptionEvent(currentEvent, previousEvent)) return true;
    return false;
}
/** JSDoc */ function $66c45c6668ea1dba$var$_isSameMessageEvent(currentEvent, previousEvent) {
    var currentMessage = currentEvent.message;
    var previousMessage = previousEvent.message;
    // If neither event has a message property, they were both exceptions, so bail out
    if (!currentMessage && !previousMessage) return false;
    // If only one event has a stacktrace, but not the other one, they are not the same
    if (currentMessage && !previousMessage || !currentMessage && previousMessage) return false;
    if (currentMessage !== previousMessage) return false;
    if (!$66c45c6668ea1dba$var$_isSameFingerprint(currentEvent, previousEvent)) return false;
    if (!$66c45c6668ea1dba$var$_isSameStacktrace(currentEvent, previousEvent)) return false;
    return true;
}
/** JSDoc */ function $66c45c6668ea1dba$var$_isSameExceptionEvent(currentEvent, previousEvent) {
    var previousException = $66c45c6668ea1dba$var$_getExceptionFromEvent(previousEvent);
    var currentException = $66c45c6668ea1dba$var$_getExceptionFromEvent(currentEvent);
    if (!previousException || !currentException) return false;
    if (previousException.type !== currentException.type || previousException.value !== currentException.value) return false;
    if (!$66c45c6668ea1dba$var$_isSameFingerprint(currentEvent, previousEvent)) return false;
    if (!$66c45c6668ea1dba$var$_isSameStacktrace(currentEvent, previousEvent)) return false;
    return true;
}
/** JSDoc */ function $66c45c6668ea1dba$var$_isSameStacktrace(currentEvent, previousEvent) {
    var currentFrames = $66c45c6668ea1dba$var$_getFramesFromEvent(currentEvent);
    var previousFrames = $66c45c6668ea1dba$var$_getFramesFromEvent(previousEvent);
    // If neither event has a stacktrace, they are assumed to be the same
    if (!currentFrames && !previousFrames) return true;
    // If only one event has a stacktrace, but not the other one, they are not the same
    if (currentFrames && !previousFrames || !currentFrames && previousFrames) return false;
    currentFrames;
    previousFrames;
    // If number of frames differ, they are not the same
    if (previousFrames.length !== currentFrames.length) return false;
    // Otherwise, compare the two
    for(var i = 0; i < previousFrames.length; i++){
        var frameA = previousFrames[i];
        var frameB = currentFrames[i];
        if (frameA.filename !== frameB.filename || frameA.lineno !== frameB.lineno || frameA.colno !== frameB.colno || frameA.function !== frameB.function) return false;
    }
    return true;
}
/** JSDoc */ function $66c45c6668ea1dba$var$_isSameFingerprint(currentEvent, previousEvent) {
    var currentFingerprint = currentEvent.fingerprint;
    var previousFingerprint = previousEvent.fingerprint;
    // If neither event has a fingerprint, they are assumed to be the same
    if (!currentFingerprint && !previousFingerprint) return true;
    // If only one event has a fingerprint, but not the other one, they are not the same
    if (currentFingerprint && !previousFingerprint || !currentFingerprint && previousFingerprint) return false;
    currentFingerprint;
    previousFingerprint;
    // Otherwise, compare the two
    try {
        return !!(currentFingerprint.join('') === previousFingerprint.join(''));
    } catch (_oO) {
        return false;
    }
}
/** JSDoc */ function $66c45c6668ea1dba$var$_getExceptionFromEvent(event) {
    return event.exception && event.exception.values && event.exception.values[0];
}
/** JSDoc */ function $66c45c6668ea1dba$var$_getFramesFromEvent(event) {
    var exception = event.exception;
    if (exception) try {
        // @ts-ignore Object could be undefined
        return exception.values[0].stacktrace.frames;
    } catch (_oO) {
        return undefined;
    }
    else if (event.stacktrace) return event.stacktrace.frames;
    return undefined;
}

});

parcelRegister("1AZSA", function(module, exports) {
$parcel$export(module.exports, "GlobalHandlers", () => $12992736a5b27478$export$204155decbc90e5a);

var $iTWOe = parcelRequire("iTWOe");

var $ir14T = parcelRequire("ir14T");

var $iYYET = parcelRequire("iYYET");
parcelRequire("i0afJ");
var $73JtC = parcelRequire("73JtC");
var $aVmXt = parcelRequire("aVmXt");
var $f9iVj = parcelRequire("f9iVj");
var $8rX8J = parcelRequire("8rX8J");
var $1v4ZC = parcelRequire("1v4ZC");

var $QEOc2 = parcelRequire("QEOc2");

var $dMTNw = parcelRequire("dMTNw");

var $iuPyo = parcelRequire("iuPyo");
/** Global handlers */ var $12992736a5b27478$export$204155decbc90e5a = /** @class */ function() {
    /** JSDoc */ function GlobalHandlers(options) {
        /**
         * @inheritDoc
         */ this.name = GlobalHandlers.id;
        /**
         * Stores references functions to installing handlers. Will set to undefined
         * after they have been run so that they are not used twice.
         */ this._installFunc = {
            onerror: $12992736a5b27478$var$_installGlobalOnErrorHandler,
            onunhandledrejection: $12992736a5b27478$var$_installGlobalOnUnhandledRejectionHandler
        };
        this._options = (0, $iTWOe.__assign)({
            onerror: true,
            onunhandledrejection: true
        }, options);
    }
    /**
     * @inheritDoc
     */ GlobalHandlers.prototype.setupOnce = function() {
        Error.stackTraceLimit = 50;
        var options = this._options;
        // We can disable guard-for-in as we construct the options object above + do checks against
        // `this._installFunc` for the property.
        // eslint-disable-next-line guard-for-in
        for(var key in options){
            var installFunc = this._installFunc[key];
            if (installFunc && options[key]) {
                $12992736a5b27478$var$globalHandlerLog(key);
                installFunc();
                this._installFunc[key] = undefined;
            }
        }
    };
    /**
     * @inheritDoc
     */ GlobalHandlers.id = 'GlobalHandlers';
    return GlobalHandlers;
}();
/** JSDoc */ function $12992736a5b27478$var$_installGlobalOnErrorHandler() {
    (0, $aVmXt.addInstrumentationHandler)('error', // eslint-disable-next-line @typescript-eslint/no-explicit-any
    function(data) {
        var _a = (0, $iTWOe.__read)($12992736a5b27478$var$getHubAndAttachStacktrace(), 2), hub = _a[0], attachStacktrace = _a[1];
        if (!hub.getIntegration($12992736a5b27478$export$204155decbc90e5a)) return;
        var msg = data.msg, url = data.url, line = data.line, column = data.column, error = data.error;
        if ((0, $iuPyo.shouldIgnoreOnError)() || error && error.__sentry_own_request__) return;
        var event = error === undefined && (0, $8rX8J.isString)(msg) ? $12992736a5b27478$var$_eventFromIncompleteOnError(msg, url, line, column) : $12992736a5b27478$var$_enhanceEventWithInitialFrame((0, $QEOc2.eventFromUnknownInput)(error || msg, undefined, attachStacktrace, false), url, line, column);
        event.level = (0, $iYYET.Severity).Error;
        $12992736a5b27478$var$addMechanismAndCapture(hub, error, event, 'onerror');
    });
}
/** JSDoc */ function $12992736a5b27478$var$_installGlobalOnUnhandledRejectionHandler() {
    (0, $aVmXt.addInstrumentationHandler)('unhandledrejection', // eslint-disable-next-line @typescript-eslint/no-explicit-any
    function(e) {
        var _a = (0, $iTWOe.__read)($12992736a5b27478$var$getHubAndAttachStacktrace(), 2), hub = _a[0], attachStacktrace = _a[1];
        if (!hub.getIntegration($12992736a5b27478$export$204155decbc90e5a)) return;
        var error = e;
        // dig the object of the rejection out of known event types
        try {
            // PromiseRejectionEvents store the object of the rejection under 'reason'
            // see https://developer.mozilla.org/en-US/docs/Web/API/PromiseRejectionEvent
            if ('reason' in e) error = e.reason;
            else if ('detail' in e && 'reason' in e.detail) error = e.detail.reason;
        } catch (_oO) {
        // no-empty
        }
        if ((0, $iuPyo.shouldIgnoreOnError)() || error && error.__sentry_own_request__) return true;
        var event = (0, $8rX8J.isPrimitive)(error) ? $12992736a5b27478$var$_eventFromRejectionWithPrimitive(error) : (0, $QEOc2.eventFromUnknownInput)(error, undefined, attachStacktrace, true);
        event.level = (0, $iYYET.Severity).Error;
        $12992736a5b27478$var$addMechanismAndCapture(hub, error, event, 'onunhandledrejection');
        return;
    });
}
/**
 * Create an event from a promise rejection where the `reason` is a primitive.
 *
 * @param reason: The `reason` property of the promise rejection
 * @returns An Event object with an appropriate `exception` value
 */ function $12992736a5b27478$var$_eventFromRejectionWithPrimitive(reason) {
    return {
        exception: {
            values: [
                {
                    type: 'UnhandledRejection',
                    // String() is needed because the Primitive type includes symbols (which can't be automatically stringified)
                    value: "Non-Error promise rejection captured with value: " + String(reason)
                }
            ]
        }
    };
}
/**
 * This function creates a stack from an old, error-less onerror handler.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $12992736a5b27478$var$_eventFromIncompleteOnError(msg, url, line, column) {
    var ERROR_TYPES_RE = /^(?:[Uu]ncaught (?:exception: )?)?(?:((?:Eval|Internal|Range|Reference|Syntax|Type|URI|)Error): )?(.*)$/i;
    // If 'message' is ErrorEvent, get real message from inside
    var message = (0, $8rX8J.isErrorEvent)(msg) ? msg.message : msg;
    var name = 'Error';
    var groups = message.match(ERROR_TYPES_RE);
    if (groups) {
        name = groups[1];
        message = groups[2];
    }
    var event = {
        exception: {
            values: [
                {
                    type: name,
                    value: message
                }
            ]
        }
    };
    return $12992736a5b27478$var$_enhanceEventWithInitialFrame(event, url, line, column);
}
/** JSDoc */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $12992736a5b27478$var$_enhanceEventWithInitialFrame(event, url, line, column) {
    // event.exception
    var e = event.exception = event.exception || {};
    // event.exception.values
    var ev = e.values = e.values || [];
    // event.exception.values[0]
    var ev0 = ev[0] = ev[0] || {};
    // event.exception.values[0].stacktrace
    var ev0s = ev0.stacktrace = ev0.stacktrace || {};
    // event.exception.values[0].stacktrace.frames
    var ev0sf = ev0s.frames = ev0s.frames || [];
    var colno = isNaN(parseInt(column, 10)) ? undefined : column;
    var lineno = isNaN(parseInt(line, 10)) ? undefined : line;
    var filename = (0, $8rX8J.isString)(url) && url.length > 0 ? url : (0, $f9iVj.getLocationHref)();
    // event.exception.values[0].stacktrace.frames
    if (ev0sf.length === 0) ev0sf.push({
        colno: colno,
        filename: filename,
        function: '?',
        in_app: true,
        lineno: lineno
    });
    return event;
}
function $12992736a5b27478$var$globalHandlerLog(type) {
    (0, $dMTNw.IS_DEBUG_BUILD) && (0, $1v4ZC.logger).log("Global Handler attached: " + type);
}
function $12992736a5b27478$var$addMechanismAndCapture(hub, error, event, type) {
    (0, $73JtC.addExceptionMechanism)(event, {
        handled: false,
        type: type
    });
    hub.captureEvent(event, {
        originalException: error
    });
}
function $12992736a5b27478$var$getHubAndAttachStacktrace() {
    var hub = (0, $ir14T.getCurrentHub)();
    var client = hub.getClient();
    var attachStacktrace = client && client.getOptions().attachStacktrace;
    return [
        hub,
        attachStacktrace
    ];
}

});

parcelRegister("bE3Cg", function(module, exports) {
$parcel$export(module.exports, "LinkedErrors", () => $87a63c3cb8501c4d$export$8d1e60aaf616fb4f);

var $iTWOe = parcelRequire("iTWOe");

var $FnrKW = parcelRequire("FnrKW");
var $ir14T = parcelRequire("ir14T");
parcelRequire("i0afJ");
var $8rX8J = parcelRequire("8rX8J");

var $QEOc2 = parcelRequire("QEOc2");
var $87a63c3cb8501c4d$var$DEFAULT_KEY = 'cause';
var $87a63c3cb8501c4d$var$DEFAULT_LIMIT = 5;
/** Adds SDK info to an event. */ var $87a63c3cb8501c4d$export$8d1e60aaf616fb4f = /** @class */ function() {
    /**
     * @inheritDoc
     */ function LinkedErrors(options) {
        if (options === void 0) options = {};
        /**
         * @inheritDoc
         */ this.name = LinkedErrors.id;
        this._key = options.key || $87a63c3cb8501c4d$var$DEFAULT_KEY;
        this._limit = options.limit || $87a63c3cb8501c4d$var$DEFAULT_LIMIT;
    }
    /**
     * @inheritDoc
     */ LinkedErrors.prototype.setupOnce = function() {
        (0, $FnrKW.addGlobalEventProcessor)(function(event, hint) {
            var self = (0, $ir14T.getCurrentHub)().getIntegration(LinkedErrors);
            return self ? $87a63c3cb8501c4d$export$7bd713d0612d8839(self._key, self._limit, event, hint) : event;
        });
    };
    /**
     * @inheritDoc
     */ LinkedErrors.id = 'LinkedErrors';
    return LinkedErrors;
}();
function $87a63c3cb8501c4d$export$7bd713d0612d8839(key, limit, event, hint) {
    if (!event.exception || !event.exception.values || !hint || !(0, $8rX8J.isInstanceOf)(hint.originalException, Error)) return event;
    var linkedErrors = $87a63c3cb8501c4d$export$e4e3ecf6f8f76c75(limit, hint.originalException, key);
    event.exception.values = (0, $iTWOe.__spread)(linkedErrors, event.exception.values);
    return event;
}
function $87a63c3cb8501c4d$export$e4e3ecf6f8f76c75(limit, error, key, stack) {
    if (stack === void 0) stack = [];
    if (!(0, $8rX8J.isInstanceOf)(error[key], Error) || stack.length + 1 >= limit) return stack;
    var exception = (0, $QEOc2.exceptionFromError)(error[key]);
    return $87a63c3cb8501c4d$export$e4e3ecf6f8f76c75(limit, error[key], key, (0, $iTWOe.__spread)([
        exception
    ], stack));
}

});

parcelRegister("6VlkC", function(module, exports) {
$parcel$export(module.exports, "TryCatch", () => $50a89cf54a64a306$export$f1a018517668e6d3);

var $iTWOe = parcelRequire("iTWOe");
parcelRequire("i0afJ");
var $909Vl = parcelRequire("909Vl");
var $b8srE = parcelRequire("b8srE");
var $lrp9R = parcelRequire("lrp9R");

var $iuPyo = parcelRequire("iuPyo");
var $50a89cf54a64a306$var$DEFAULT_EVENT_TARGET = [
    'EventTarget',
    'Window',
    'Node',
    'ApplicationCache',
    'AudioTrackList',
    'ChannelMergerNode',
    'CryptoOperation',
    'EventSource',
    'FileReader',
    'HTMLUnknownElement',
    'IDBDatabase',
    'IDBRequest',
    'IDBTransaction',
    'KeyOperation',
    'MediaController',
    'MessagePort',
    'ModalWindow',
    'Notification',
    'SVGElementInstance',
    'Screen',
    'TextTrack',
    'TextTrackCue',
    'TextTrackList',
    'WebSocket',
    'WebSocketWorker',
    'Worker',
    'XMLHttpRequest',
    'XMLHttpRequestEventTarget',
    'XMLHttpRequestUpload'
];
/** Wrap timer functions and event targets to catch errors and provide better meta data */ var $50a89cf54a64a306$export$f1a018517668e6d3 = /** @class */ function() {
    /**
     * @inheritDoc
     */ function TryCatch(options) {
        /**
         * @inheritDoc
         */ this.name = TryCatch.id;
        this._options = (0, $iTWOe.__assign)({
            XMLHttpRequest: true,
            eventTarget: true,
            requestAnimationFrame: true,
            setInterval: true,
            setTimeout: true
        }, options);
    }
    /**
     * Wrap timer functions and event targets to catch errors
     * and provide better metadata.
     */ TryCatch.prototype.setupOnce = function() {
        var global = (0, $lrp9R.getGlobalObject)();
        if (this._options.setTimeout) (0, $909Vl.fill)(global, 'setTimeout', $50a89cf54a64a306$var$_wrapTimeFunction);
        if (this._options.setInterval) (0, $909Vl.fill)(global, 'setInterval', $50a89cf54a64a306$var$_wrapTimeFunction);
        if (this._options.requestAnimationFrame) (0, $909Vl.fill)(global, 'requestAnimationFrame', $50a89cf54a64a306$var$_wrapRAF);
        if (this._options.XMLHttpRequest && 'XMLHttpRequest' in global) (0, $909Vl.fill)(XMLHttpRequest.prototype, 'send', $50a89cf54a64a306$var$_wrapXHR);
        var eventTargetOption = this._options.eventTarget;
        if (eventTargetOption) {
            var eventTarget = Array.isArray(eventTargetOption) ? eventTargetOption : $50a89cf54a64a306$var$DEFAULT_EVENT_TARGET;
            eventTarget.forEach($50a89cf54a64a306$var$_wrapEventTarget);
        }
    };
    /**
     * @inheritDoc
     */ TryCatch.id = 'TryCatch';
    return TryCatch;
}();
/** JSDoc */ function $50a89cf54a64a306$var$_wrapTimeFunction(original) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        var originalCallback = args[0];
        args[0] = (0, $iuPyo.wrap)(originalCallback, {
            mechanism: {
                data: {
                    function: (0, $b8srE.getFunctionName)(original)
                },
                handled: true,
                type: 'instrument'
            }
        });
        return original.apply(this, args);
    };
}
/** JSDoc */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $50a89cf54a64a306$var$_wrapRAF(original) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return function(callback) {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        return original.apply(this, [
            (0, $iuPyo.wrap)(callback, {
                mechanism: {
                    data: {
                        function: 'requestAnimationFrame',
                        handler: (0, $b8srE.getFunctionName)(original)
                    },
                    handled: true,
                    type: 'instrument'
                }
            })
        ]);
    };
}
/** JSDoc */ function $50a89cf54a64a306$var$_wrapXHR(originalSend) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        var xhr = this;
        var xmlHttpRequestProps = [
            'onload',
            'onerror',
            'onprogress',
            'onreadystatechange'
        ];
        xmlHttpRequestProps.forEach(function(prop) {
            if (prop in xhr && typeof xhr[prop] === 'function') // eslint-disable-next-line @typescript-eslint/no-explicit-any
            (0, $909Vl.fill)(xhr, prop, function(original) {
                var wrapOptions = {
                    mechanism: {
                        data: {
                            function: prop,
                            handler: (0, $b8srE.getFunctionName)(original)
                        },
                        handled: true,
                        type: 'instrument'
                    }
                };
                // If Instrument integration has been called before TryCatch, get the name of original function
                var originalFunction = (0, $909Vl.getOriginalFunction)(original);
                if (originalFunction) wrapOptions.mechanism.data.handler = (0, $b8srE.getFunctionName)(originalFunction);
                // Otherwise wrap directly
                return (0, $iuPyo.wrap)(original, wrapOptions);
            });
        });
        return originalSend.apply(this, args);
    };
}
/** JSDoc */ function $50a89cf54a64a306$var$_wrapEventTarget(target) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var global = (0, $lrp9R.getGlobalObject)();
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    var proto = global[target] && global[target].prototype;
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, no-prototype-builtins
    if (!proto || !proto.hasOwnProperty || !proto.hasOwnProperty('addEventListener')) return;
    (0, $909Vl.fill)(proto, 'addEventListener', function(original) {
        return function(eventName, fn, options) {
            try {
                if (typeof fn.handleEvent === 'function') fn.handleEvent = (0, $iuPyo.wrap)(fn.handleEvent.bind(fn), {
                    mechanism: {
                        data: {
                            function: 'handleEvent',
                            handler: (0, $b8srE.getFunctionName)(fn),
                            target: target
                        },
                        handled: true,
                        type: 'instrument'
                    }
                });
            } catch (err) {
            // can sometimes get 'Permission denied to access property "handle Event'
            }
            return original.apply(this, [
                eventName,
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                (0, $iuPyo.wrap)(fn, {
                    mechanism: {
                        data: {
                            function: 'addEventListener',
                            handler: (0, $b8srE.getFunctionName)(fn),
                            target: target
                        },
                        handled: true,
                        type: 'instrument'
                    }
                }),
                options
            ]);
        };
    });
    (0, $909Vl.fill)(proto, 'removeEventListener', function(originalRemoveEventListener) {
        return function(eventName, fn, options) {
            /**
             * There are 2 possible scenarios here:
             *
             * 1. Someone passes a callback, which was attached prior to Sentry initialization, or by using unmodified
             * method, eg. `document.addEventListener.call(el, name, handler). In this case, we treat this function
             * as a pass-through, and call original `removeEventListener` with it.
             *
             * 2. Someone passes a callback, which was attached after Sentry was initialized, which means that it was using
             * our wrapped version of `addEventListener`, which internally calls `wrap` helper.
             * This helper "wraps" whole callback inside a try/catch statement, and attached appropriate metadata to it,
             * in order for us to make a distinction between wrapped/non-wrapped functions possible.
             * If a function was wrapped, it has additional property of `__sentry_wrapped__`, holding the handler.
             *
             * When someone adds a handler prior to initialization, and then do it again, but after,
             * then we have to detach both of them. Otherwise, if we'd detach only wrapped one, it'd be impossible
             * to get rid of the initial handler and it'd stick there forever.
             */ var wrappedEventHandler = fn;
            try {
                var originalEventHandler = wrappedEventHandler && wrappedEventHandler.__sentry_wrapped__;
                if (originalEventHandler) originalRemoveEventListener.call(this, eventName, originalEventHandler, options);
            } catch (e) {
            // ignore, accessing __sentry_wrapped__ will throw in some Selenium environments
            }
            return originalRemoveEventListener.call(this, eventName, wrappedEventHandler, options);
        };
    });
}

});

parcelRegister("35gFN", function(module, exports) {
$parcel$export(module.exports, "UserAgent", () => $23eec5ae3af9d036$export$5fba5e10934a4faf);

var $iTWOe = parcelRequire("iTWOe");

var $FnrKW = parcelRequire("FnrKW");
var $ir14T = parcelRequire("ir14T");
parcelRequire("i0afJ");
var $lrp9R = parcelRequire("lrp9R");
var $23eec5ae3af9d036$var$global = (0, $lrp9R.getGlobalObject)();
/** UserAgent */ var $23eec5ae3af9d036$export$5fba5e10934a4faf = /** @class */ function() {
    function UserAgent() {
        /**
         * @inheritDoc
         */ this.name = UserAgent.id;
    }
    /**
     * @inheritDoc
     */ UserAgent.prototype.setupOnce = function() {
        (0, $FnrKW.addGlobalEventProcessor)(function(event) {
            if ((0, $ir14T.getCurrentHub)().getIntegration(UserAgent)) {
                // if none of the information we want exists, don't bother
                if (!$23eec5ae3af9d036$var$global.navigator && !$23eec5ae3af9d036$var$global.location && !$23eec5ae3af9d036$var$global.document) return event;
                // grab as much info as exists and add it to the event
                var url = event.request && event.request.url || $23eec5ae3af9d036$var$global.location && $23eec5ae3af9d036$var$global.location.href;
                var referrer = ($23eec5ae3af9d036$var$global.document || {}).referrer;
                var userAgent = ($23eec5ae3af9d036$var$global.navigator || {}).userAgent;
                var headers = (0, $iTWOe.__assign)((0, $iTWOe.__assign)((0, $iTWOe.__assign)({}, event.request && event.request.headers), referrer && {
                    Referer: referrer
                }), userAgent && {
                    'User-Agent': userAgent
                });
                var request = (0, $iTWOe.__assign)((0, $iTWOe.__assign)({}, url && {
                    url: url
                }), {
                    headers: headers
                });
                return (0, $iTWOe.__assign)((0, $iTWOe.__assign)({}, event), {
                    request: request
                });
            }
            return event;
        });
    };
    /**
     * @inheritDoc
     */ UserAgent.id = 'UserAgent';
    return UserAgent;
}();

});


parcelRegister("7sZPK", function(module, exports) {
$parcel$export(module.exports, "SDK_NAME", () => $56fb1cccf452cb35$export$ca61d37259221480);
// TODO: Remove in the next major release and rely only on @sentry/core SDK_VERSION and SdkInfo metadata
var $56fb1cccf452cb35$export$ca61d37259221480 = 'sentry.javascript.browser';

});


parcelRegister("g55ns", function(module, exports) {
$parcel$export(module.exports, "GlobalHandlers", () => (parcelRequire("1AZSA")).GlobalHandlers);
$parcel$export(module.exports, "TryCatch", () => (parcelRequire("6VlkC")).TryCatch);
$parcel$export(module.exports, "Breadcrumbs", () => (parcelRequire("3UPj8")).Breadcrumbs);
$parcel$export(module.exports, "LinkedErrors", () => (parcelRequire("bE3Cg")).LinkedErrors);
$parcel$export(module.exports, "UserAgent", () => (parcelRequire("35gFN")).UserAgent);
$parcel$export(module.exports, "Dedupe", () => (parcelRequire("8P1DV")).Dedupe);

var $1AZSA = parcelRequire("1AZSA");

var $6VlkC = parcelRequire("6VlkC");

var $3UPj8 = parcelRequire("3UPj8");

var $bE3Cg = parcelRequire("bE3Cg");

var $35gFN = parcelRequire("35gFN");

var $8P1DV = parcelRequire("8P1DV");

});

parcelRegister("e3MRU", function(module, exports) {
$parcel$export(module.exports, "BaseTransport", () => (parcelRequire("6aT3D")).BaseTransport);
$parcel$export(module.exports, "FetchTransport", () => (parcelRequire("bixL8")).FetchTransport);
$parcel$export(module.exports, "XHRTransport", () => (parcelRequire("kV3i0")).XHRTransport);
$parcel$export(module.exports, "makeNewFetchTransport", () => (parcelRequire("315mi")).makeNewFetchTransport);
$parcel$export(module.exports, "makeNewXHRTransport", () => (parcelRequire("tw7ZC")).makeNewXHRTransport);

var $6aT3D = parcelRequire("6aT3D");

var $bixL8 = parcelRequire("bixL8");

var $kV3i0 = parcelRequire("kV3i0");

var $315mi = parcelRequire("315mi");

var $tw7ZC = parcelRequire("tw7ZC");

});


parcelRegister("74GWP", function(module, exports) {
$parcel$export(module.exports, "isFedRamp", () => $526a38a87f3794d6$export$64d6499adf9b2e51);
var $526a38a87f3794d6$var$FEDRAMP_MODERATE = 'fedramp-moderate';
function $526a38a87f3794d6$export$64d6499adf9b2e51() {
    var _global$location;
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var global = globalThis;
    // MICROS_PERIMETER is already used by few products, so we need to keep it for backward compatibility
    var env = global.MICROS_PERIMETER || global.UNSAFE_ATL_CONTEXT_BOUNDARY;
    if (env) return env === $526a38a87f3794d6$var$FEDRAMP_MODERATE;
    var matches = (_global$location = global.location) === null || _global$location === void 0 || (_global$location = _global$location.hostname) === null || _global$location === void 0 ? void 0 : _global$location.match(// Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    /atlassian-us-gov-mod\.(com|net)|atlassian-us-gov\.(com|net)|atlassian-fex\.(com|net)|atlassian-stg-fedm\.(com|net)/);
    return matches ? matches.length > 0 : false;
}

});

parcelRegister("e6MoK", function(module, exports) {
$parcel$export(module.exports, "SERIALIZABLE_ATTRIBUTES", () => $a4572b1af67efb60$export$b5bdb04ea16a02e3);
$parcel$export(module.exports, "normaliseSentryBreadcrumbs", () => $a4572b1af67efb60$export$6f14342128c6eaa4);
var $a4572b1af67efb60$export$b5bdb04ea16a02e3 = [
    'data-test-id',
    'data-testid'
];
var $a4572b1af67efb60$var$WHITELISTED_ATTRIBNUTES = [
    'type',
    'name'
].concat($a4572b1af67efb60$export$b5bdb04ea16a02e3);
var $a4572b1af67efb60$var$REG_MATCH_NOTALLOWED_ATTRIBUTES = new RegExp("\\[(?!".concat($a4572b1af67efb60$var$WHITELISTED_ATTRIBNUTES.join('|'), ").*?\\]"), 'gmu');
// attributes may contain UGC that we need to strip out
// only allow type and name attributes
var $a4572b1af67efb60$var$sanitiseUiBreadcrumbMessage = function sanitiseUiBreadcrumbMessage(message) {
    return message.replace($a4572b1af67efb60$var$REG_MATCH_NOTALLOWED_ATTRIBUTES, '');
};
var $a4572b1af67efb60$export$6f14342128c6eaa4 = function normaliseSentryBreadcrumbs(breadcrumb) {
    var _ref = breadcrumb || {}, category = _ref.category;
    // allow "ui*"" category breadcrumbs, that include clicks and inputs on DOM elements
    // they may contain UGC that needs to be stripped out
    if (category !== null && category !== void 0 && category.startsWith('ui')) {
        // sentry can include the element attributes in the data
        // which may contain UGC that we need to strip out
        var sanitisedBreadCrumb = breadcrumb;
        var message = sanitisedBreadCrumb.message;
        if (message !== null && message !== undefined) sanitisedBreadCrumb.message = $a4572b1af67efb60$var$sanitiseUiBreadcrumbMessage(message);
        return breadcrumb;
    }
    return breadcrumb;
};

});

parcelRegister("jYDPM", function(module, exports) {

var $iKwew = parcelRequire("iKwew");
module.exports = $iKwew("8euzK").then(()=>parcelRequire('7xb0p'));

});


parcelRegister("aP6HU", function(module, exports) {
$parcel$export(module.exports, "PLATFORM", () => $7e13deb8d79c3374$export$88c4881e092abcaf);
$parcel$export(module.exports, "MODE", () => $7e13deb8d79c3374$export$e48589d9e4824227);
var $7e13deb8d79c3374$export$88c4881e092abcaf = /*#__PURE__*/ function(PLATFORM) {
    PLATFORM["NATIVE"] = "mobileNative";
    PLATFORM["HYBRID"] = "mobileHybrid";
    PLATFORM["WEB"] = "web";
    return PLATFORM;
}({});
var $7e13deb8d79c3374$export$e48589d9e4824227 = /*#__PURE__*/ function(MODE) {
    MODE["RENDERER"] = "renderer";
    MODE["EDITOR"] = "editor";
    return MODE;
}({});
var $7e13deb8d79c3374$var$RESOLVE_METHOD = /*#__PURE__*/ function(RESOLVE_METHOD) {
    RESOLVE_METHOD["COMPONENT"] = "component";
    RESOLVE_METHOD["CONSUMER"] = "consumer";
    RESOLVE_METHOD["ORPHANED"] = "orphaned";
    return RESOLVE_METHOD;
}($7e13deb8d79c3374$var$RESOLVE_METHOD || {});

});


parcelRegister("8KWVV", function(module, exports) {
$parcel$export(module.exports, "EVENT_TYPE", () => $6600558643eed006$export$76a2e4c433c23bb9);
$parcel$export(module.exports, "ACTION", () => $6600558643eed006$export$9523889e0a5da4ba);
$parcel$export(module.exports, "ACTION_SUBJECT", () => $6600558643eed006$export$7525482b5931e326);
$parcel$export(module.exports, "ACTION_SUBJECT_ID", () => $6600558643eed006$export$9957974f8b4d8f74);
var $6600558643eed006$export$76a2e4c433c23bb9 = /*#__PURE__*/ function(EVENT_TYPE) {
    EVENT_TYPE["OPERATIONAL"] = "operational";
    EVENT_TYPE["SCREEN"] = "screen";
    EVENT_TYPE["TRACK"] = "track";
    EVENT_TYPE["UI"] = "ui";
    return EVENT_TYPE;
}({});
var $6600558643eed006$export$9523889e0a5da4ba = /*#__PURE__*/ function(ACTION) {
    ACTION["STARTED"] = "started";
    ACTION["RENDERED"] = "rendered";
    ACTION["CRASHED"] = "unhandledErrorCaught";
    ACTION["INVALID_PROSEMIRROR_DOCUMENT"] = "invalidProsemirrorDocument";
    ACTION["SELECT_ALL_CAUGHT"] = "selectAllCaught";
    ACTION["SELECT_ALL_ESCAPED"] = "selectAllEscaped";
    ACTION["CLICKED"] = "clicked";
    ACTION["VIEWED"] = "viewed";
    ACTION["VISITED"] = "visited";
    ACTION["SORT_COLUMN"] = "sortedColumn";
    ACTION["SORT_COLUMN_NOT_ALLOWED"] = "sortColumnNotAllowed";
    ACTION["TOGGLE_EXPAND"] = "toggleExpand";
    ACTION["INSERTED"] = "inserted";
    ACTION["OPENED"] = "opened";
    ACTION["CLOSED"] = "closed";
    ACTION["DELETED"] = "deleted";
    ACTION["EDITED"] = "edited";
    ACTION["RESOLVED"] = "resolved";
    ACTION["CREATE_NOT_ALLOWED"] = "createNotAllowed";
    ACTION["UNSUPPORTED_CONTENT_LEVELS_TRACKING_SUCCEEDED"] = "unsupportedContentLevelsTrackingSucceeded";
    ACTION["UNSUPPORTED_CONTENT_LEVELS_TRACKING_ERRORED"] = "unsupportedContentLevelsTrackingErrored";
    ACTION["MEDIA_LINK_TRANSFORMED"] = "mediaLinkTransformed";
    ACTION["TABLE_WIDTH_INFO"] = "tableWidthInfo";
    return ACTION;
}({});
var $6600558643eed006$export$7525482b5931e326 = /*#__PURE__*/ function(ACTION_SUBJECT) {
    ACTION_SUBJECT["RENDERER"] = "renderer";
    ACTION_SUBJECT["BUTTON"] = "button";
    ACTION_SUBJECT["ANCHOR_LINK"] = "anchorLink";
    ACTION_SUBJECT["TABLE"] = "table";
    ACTION_SUBJECT["EXPAND"] = "expand";
    ACTION_SUBJECT["NESTED_EXPAND"] = "nestedExpand";
    ACTION_SUBJECT["MEDIA_SINGLE"] = "mediaSingle";
    ACTION_SUBJECT["LINK"] = "link";
    ACTION_SUBJECT["ANNOTATION"] = "annotation";
    ACTION_SUBJECT["MEDIA"] = "media";
    ACTION_SUBJECT["SMART_LINK"] = "smartLink";
    return ACTION_SUBJECT;
}({});
var $6600558643eed006$export$9957974f8b4d8f74 = /*#__PURE__*/ function(ACTION_SUBJECT_ID) {
    ACTION_SUBJECT_ID["HEADING_ANCHOR_LINK"] = "headingAnchorLink";
    ACTION_SUBJECT_ID["LINK"] = "link";
    ACTION_SUBJECT_ID["HOVER_LABEL"] = "hoverLabel";
    ACTION_SUBJECT_ID["INLINE_COMMENT"] = "inlineComment";
    ACTION_SUBJECT_ID["CODEBLOCK_COPY"] = "codeBlockCopy";
    ACTION_SUBJECT_ID["CODEBLOCK_WRAP"] = "codeBlockWrap";
    return ACTION_SUBJECT_ID;
}({});

});

parcelRegister("nOuq8", function(module, exports) {
$parcel$export(module.exports, "AnnotationsPositionContext", () => $0479504a5498162f$export$8c8c3e12db6c0591);
$parcel$export(module.exports, "AnnotationsWrapper", () => $0479504a5498162f$export$cef0157dd42cbb3f);

var $5FkrB = parcelRequire("5FkrB");

var $kX1mK = parcelRequire("kX1mK");

var $bCYQR = parcelRequire("bCYQR");

var $ePfJP = parcelRequire("ePfJP");

var $gtPYB = parcelRequire("gtPYB");

var $lh3H1 = parcelRequire("lh3H1");

var $2pzUn = parcelRequire("2pzUn");

var $cOsWw = parcelRequire("cOsWw");

var $38vNc = parcelRequire("38vNc");

var $7bLYW = parcelRequire("7bLYW");

var $fDwDe = parcelRequire("fDwDe");
var $0479504a5498162f$var$LoadAnnotations = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).memo(function(_ref) {
    var adfDocument = _ref.adfDocument, isNestedRender = _ref.isNestedRender, onLoadComplete = _ref.onLoadComplete;
    (0, $lh3H1.useLoadAnnotations)({
        adfDocument: adfDocument,
        isNestedRender: isNestedRender,
        onLoadComplete: onLoadComplete
    });
    return null;
});
var $0479504a5498162f$export$8c8c3e12db6c0591 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createContext({
    startPos: 1
});
var $0479504a5498162f$export$7121915072388536 = function AnnotationsWrapperInner(props) {
    var _providers$inlineComm, _providers$inlineComm2;
    var children = props.children, rendererRef = props.rendererRef, adfDocument = props.adfDocument, isNestedRender = props.isNestedRender, onLoadComplete = props.onLoadComplete;
    var providers = (0, $5FkrB.useContext)((0, $gtPYB.ProvidersContext));
    var updateSubscriber = providers && providers.inlineComment && providers.inlineComment.updateSubscriber;
    var inlineCommentAnnotationsState = (0, $2pzUn.useAnnotationStateByTypeEvent)({
        type: (0, $kX1mK.AnnotationTypes).INLINE_COMMENT,
        updateSubscriber: updateSubscriber || null
    });
    var _useAnalyticsEvents = (0, $cOsWw.useAnalyticsEvents)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $gtPYB.InlineCommentsStateContext).Provider, {
        value: inlineCommentAnnotationsState
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $38vNc.AnnotationRangeProvider), {
        allowCommentsOnMedia: (_providers$inlineComm = providers === null || providers === void 0 || (_providers$inlineComm2 = providers.inlineComment) === null || _providers$inlineComm2 === void 0 ? void 0 : _providers$inlineComm2.allowCommentsOnMedia) !== null && _providers$inlineComm !== void 0 ? _providers$inlineComm : false,
        isNestedRender: isNestedRender
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $7bLYW.AnnotationHoverContext), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $ePfJP.AnnotationsContextWrapper), {
        createAnalyticsEvent: createAnalyticsEvent,
        rendererRef: rendererRef,
        isNestedRender: isNestedRender
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement($0479504a5498162f$var$LoadAnnotations, {
        adfDocument: adfDocument,
        isNestedRender: isNestedRender,
        onLoadComplete: onLoadComplete
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $bCYQR.AnnotationView), {
        isNestedRender: isNestedRender,
        createAnalyticsEvent: createAnalyticsEvent
    }), children))));
};
var $0479504a5498162f$export$cef0157dd42cbb3f = function AnnotationsWrapper(props) {
    var children = props.children, annotationProvider = props.annotationProvider, rendererRef = props.rendererRef, adfDocument = props.adfDocument, isNestedRender = props.isNestedRender, onLoadComplete = props.onLoadComplete;
    if (!isNestedRender && annotationProvider !== null && annotationProvider !== void 0 && annotationProvider.annotationManager) {
        var _annotationProvider$i, _annotationProvider$i2;
        // We need to ensure there is a single instance of the annotation manager for the whole document
        // and that it is the same instance for all annotations.
        // This is because the annotation manager is responsible for managing the state of ALL annotations.
        // This includes annotations inside extensions.
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $gtPYB.ProvidersContext).Provider, {
            value: annotationProvider
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $fDwDe.AnnotationManagerProvider), {
            annotationManager: annotationProvider.annotationManager,
            updateSubscriber: (_annotationProvider$i = annotationProvider === null || annotationProvider === void 0 || (_annotationProvider$i2 = annotationProvider.inlineComment) === null || _annotationProvider$i2 === void 0 ? void 0 : _annotationProvider$i2.updateSubscriber) !== null && _annotationProvider$i !== void 0 ? _annotationProvider$i : undefined
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement($0479504a5498162f$export$7121915072388536, {
            rendererRef: rendererRef,
            adfDocument: adfDocument,
            isNestedRender: isNestedRender,
            onLoadComplete: onLoadComplete
        }, children)));
    } else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $gtPYB.ProvidersContext).Provider, {
        value: annotationProvider
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement($0479504a5498162f$export$7121915072388536, {
        rendererRef: rendererRef,
        adfDocument: adfDocument,
        isNestedRender: isNestedRender,
        onLoadComplete: onLoadComplete
    }, children));
};

});
parcelRegister("bCYQR", function(module, exports) {
$parcel$export(module.exports, "AnnotationView", () => $8772723048e67397$export$41cd4a02859c2806);

var $5FkrB = parcelRequire("5FkrB");

var $gtPYB = parcelRequire("gtPYB");

var $2pzUn = parcelRequire("2pzUn");

var $lMzAH = parcelRequire("lMzAH");
var $8772723048e67397$export$41cd4a02859c2806 = function AnnotationView(props) {
    var providers = (0, $5FkrB.useContext)((0, $gtPYB.ProvidersContext));
    var actionContext = (0, $5FkrB.useContext)((0, $lMzAH.RendererContext));
    var inlineCommentProvider = providers && providers.inlineComment;
    var updateSubscriber = inlineCommentProvider && inlineCommentProvider.updateSubscriber || null;
    var viewComponentProps = (0, $2pzUn.useAnnotationClickEvent)({
        updateSubscriber: updateSubscriber,
        createAnalyticsEvent: props.createAnalyticsEvent,
        isNestedRender: props.isNestedRender
    });
    var ViewComponent = inlineCommentProvider && inlineCommentProvider.viewComponent;
    var deleteAnnotation = (0, $5FkrB.useMemo)(function() {
        return function(annotationInfo) {
            return actionContext.deleteAnnotation(annotationInfo.id, annotationInfo.type);
        };
    }, [
        actionContext
    ]);
    // For view mode, the finding of inline node types is a bit more complex,
    // that's why we will not provide it as a `inlineNodeTypes` props to the view component,
    // to speed up the rendering process.
    var getInlineNodeTypes = (0, $5FkrB.useCallback)(function(annotationId) {
        return actionContext.getInlineNodeTypes(annotationId);
    }, [
        actionContext
    ]);
    if (ViewComponent && viewComponentProps) {
        var annotations = viewComponentProps.annotations, clickElementTarget = viewComponentProps.clickElementTarget;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(ViewComponent, {
            annotations: annotations,
            clickElementTarget: clickElementTarget,
            deleteAnnotation: deleteAnnotation,
            getInlineNodeTypes: getInlineNodeTypes
        });
    }
    return null;
};

});
parcelRegister("gtPYB", function(module, exports) {
$parcel$export(module.exports, "ProvidersContext", () => $bff7ac333263fe0d$export$6a26b015ac619737);
$parcel$export(module.exports, "InlineCommentsStateContext", () => $bff7ac333263fe0d$export$aafe46a36ef535ba);

var $5FkrB = parcelRequire("5FkrB");
var $bff7ac333263fe0d$export$6a26b015ac619737 = /*#__PURE__*/ (0, $5FkrB.createContext)(null);
var $bff7ac333263fe0d$export$aafe46a36ef535ba = /*#__PURE__*/ (0, $5FkrB.createContext)({});

});

parcelRegister("2pzUn", function(module, exports) {
$parcel$export(module.exports, "useAnnotationStateByTypeEvent", () => $1c19c53ae2ba15da$export$95f9f9045e92d283);
$parcel$export(module.exports, "useHasFocusEvent", () => $1c19c53ae2ba15da$export$48f5d7f6702be07c);
$parcel$export(module.exports, "useAnnotationClickEvent", () => $1c19c53ae2ba15da$export$26cf539704e444c1);

var $25nEq = parcelRequire("25nEq");

var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");

var $1xyIw = parcelRequire("1xyIw");

var $kX1mK = parcelRequire("kX1mK");

var $jJH6F = parcelRequire("jJH6F");

var $2H1dZ = parcelRequire("2H1dZ");

var $fDwDe = parcelRequire("fDwDe");
function $1c19c53ae2ba15da$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $1c19c53ae2ba15da$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $1c19c53ae2ba15da$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $1c19c53ae2ba15da$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $1c19c53ae2ba15da$export$95f9f9045e92d283 = function useAnnotationStateByTypeEvent(_ref) {
    var type = _ref.type, updateSubscriber = _ref.updateSubscriber;
    var _useState = (0, $5FkrB.useState)({}), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), states = _useState2[0], setStates = _useState2[1];
    var _useAnnotationManager = (0, $fDwDe.useAnnotationManagerDispatch)(), annotationManager = _useAnnotationManager.annotationManager, dispatch = _useAnnotationManager.dispatch;
    var _useAnnotationManager2 = (0, $fDwDe.useAnnotationManagerState)(), annotations = _useAnnotationManager2.annotations;
    var isAnnotationManagerEnabled = !!annotationManager;
    (0, $5FkrB.useLayoutEffect)(function() {
        if (!updateSubscriber) return;
        var cb = function cb(payload) {
            if (!payload) return;
            var nextStates = Object.values(payload).reduce(function(acc, curr) {
                if (curr.id && curr.annotationType === type) {
                    // Check for empty state to prevent additional renders
                    var isEmpty = curr.state === null || curr.state === undefined;
                    return $1c19c53ae2ba15da$var$_objectSpread($1c19c53ae2ba15da$var$_objectSpread({}, acc), {}, (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, curr.id, !isEmpty ? curr.state : states[curr.id]));
                }
                return acc;
            }, {});
            setStates($1c19c53ae2ba15da$var$_objectSpread($1c19c53ae2ba15da$var$_objectSpread({}, states), nextStates));
        };
        if (!isAnnotationManagerEnabled) {
            updateSubscriber.on((0, $1xyIw.AnnotationUpdateEvent).SET_ANNOTATION_STATE, cb);
            return function() {
                updateSubscriber.off((0, $1xyIw.AnnotationUpdateEvent).SET_ANNOTATION_STATE, cb);
            };
        }
    }, [
        states,
        type,
        updateSubscriber,
        dispatch,
        isAnnotationManagerEnabled
    ]);
    var annotationMarkStates = (0, $5FkrB.useMemo)(function() {
        return Object.values(annotations).reduce(function(acc, curr) {
            return $1c19c53ae2ba15da$var$_objectSpread($1c19c53ae2ba15da$var$_objectSpread({}, acc), {}, (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, curr.id, curr.markState));
        }, {});
    }, [
        annotations
    ]);
    if (isAnnotationManagerEnabled) return annotationMarkStates;
    else return states;
};
var $1c19c53ae2ba15da$export$48f5d7f6702be07c = function useHasFocusEvent(_ref2) {
    var id = _ref2.id, updateSubscriber = _ref2.updateSubscriber;
    var _useState3 = (0, $5FkrB.useState)(false), _useState4 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState3, 2), hasFocus = _useState4[0], setHasFocus = _useState4[1];
    var _useState5 = (0, $5FkrB.useState)(false), _useState6 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState5, 2), isHovered = _useState6[0], setIsHovered = _useState6[1];
    var _useAnnotationManager3 = (0, $fDwDe.useAnnotationManagerState)(), currentSelectedAnnotationId = _useAnnotationManager3.currentSelectedAnnotationId, currentHoveredAnnotationId = _useAnnotationManager3.currentHoveredAnnotationId;
    var _useAnnotationManager4 = (0, $fDwDe.useAnnotationManagerDispatch)(), annotationManager = _useAnnotationManager4.annotationManager;
    var isAnnotationManagerEnabled = !!annotationManager;
    (0, $5FkrB.useLayoutEffect)(function() {
        if (!updateSubscriber) return;
        var cb = function cb(payload) {
            setHasFocus(payload && payload.annotationId === id);
        };
        var callbackForHoveredAnnotation = function callbackForHoveredAnnotation(payload) {
            setIsHovered(payload && payload.annotationId === id);
        };
        var removeFocus = function removeFocus() {
            setHasFocus(false);
        };
        var removeHoverEffect = function removeHoverEffect() {
            setIsHovered(false);
        };
        if (!isAnnotationManagerEnabled) {
            updateSubscriber.on((0, $1xyIw.AnnotationUpdateEvent).SET_ANNOTATION_FOCUS, cb);
            updateSubscriber.on((0, $1xyIw.AnnotationUpdateEvent).SET_ANNOTATION_HOVERED, callbackForHoveredAnnotation);
            updateSubscriber.on((0, $1xyIw.AnnotationUpdateEvent).REMOVE_ANNOTATION_FOCUS, removeFocus);
            updateSubscriber.on((0, $1xyIw.AnnotationUpdateEvent).REMOVE_ANNOTATION_HOVERED, removeHoverEffect);
            return function() {
                updateSubscriber.off((0, $1xyIw.AnnotationUpdateEvent).SET_ANNOTATION_FOCUS, cb);
                updateSubscriber.off((0, $1xyIw.AnnotationUpdateEvent).SET_ANNOTATION_HOVERED, callbackForHoveredAnnotation);
                updateSubscriber.off((0, $1xyIw.AnnotationUpdateEvent).REMOVE_ANNOTATION_FOCUS, removeFocus);
                updateSubscriber.off((0, $1xyIw.AnnotationUpdateEvent).SET_ANNOTATION_HOVERED, removeHoverEffect);
            };
        }
    }, [
        id,
        updateSubscriber,
        isAnnotationManagerEnabled
    ]);
    if (isAnnotationManagerEnabled) return {
        hasFocus: currentSelectedAnnotationId === id,
        isHovered: currentHoveredAnnotationId === id
    };
    else return {
        hasFocus: hasFocus,
        isHovered: isHovered
    };
};
var $1c19c53ae2ba15da$var$NO_ANNOTATION_SELECTED = {
    annotations: [],
    clickElementTarget: undefined
};
var $1c19c53ae2ba15da$export$26cf539704e444c1 = function useAnnotationClickEvent(props) {
    var _useState7 = (0, $5FkrB.useState)(null), _useState8 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState7, 2), annotationClickEvent = _useState8[0], setAnnotationClickEvent = _useState8[1];
    var updateSubscriber = props.updateSubscriber, createAnalyticsEvent = props.createAnalyticsEvent, isNestedRender = props.isNestedRender;
    var _useAnnotationManager5 = (0, $fDwDe.useAnnotationManagerDispatch)(), annotationManager = _useAnnotationManager5.annotationManager;
    var isAnnotationManagerEnabled = !!annotationManager;
    var _useAnnotationManager6 = (0, $fDwDe.useAnnotationManagerState)(), currentSelectedAnnotationId = _useAnnotationManager6.currentSelectedAnnotationId, currentSelectedMarkRef = _useAnnotationManager6.currentSelectedMarkRef;
    var selectedAnnotation = (0, $5FkrB.useMemo)(function() {
        return currentSelectedAnnotationId && currentSelectedMarkRef && currentSelectedMarkRef.id === currentSelectedAnnotationId ? {
            annotations: [
                {
                    id: currentSelectedAnnotationId,
                    type: (0, $kX1mK.AnnotationTypes).INLINE_COMMENT
                }
            ],
            clickElementTarget: currentSelectedMarkRef
        } : // This is a constant to represent the case when no annotation is selected.
        // When creating a new annotation, currentSelectedAnnotationId and currentSelectedMarkRef will be set one after another,
        // if this isn't a const, it will cause useMemo to return two different "empty" objects and causes infinite re-renders.
        $1c19c53ae2ba15da$var$NO_ANNOTATION_SELECTED;
    }, [
        currentSelectedAnnotationId,
        currentSelectedMarkRef
    ]);
    (0, $5FkrB.useLayoutEffect)(function() {
        if (!updateSubscriber || isNestedRender) return;
        var clickCb = function clickCb(_ref3) {
            var annotationIds = _ref3.annotationIds, eventTarget = _ref3.eventTarget, eventTargetType = _ref3.eventTargetType, viewMethod = _ref3.viewMethod;
            var annotationsByType = annotationIds.filter(function(id) {
                return !!id;
            }).map(function(id) {
                return {
                    id: id,
                    type: (0, $kX1mK.AnnotationTypes).INLINE_COMMENT
                };
            });
            if (createAnalyticsEvent) createAnalyticsEvent({
                action: (0, $jJH6F.ACTION).VIEWED,
                actionSubject: (0, $jJH6F.ACTION_SUBJECT).ANNOTATION,
                actionSubjectId: (0, $jJH6F.ACTION_SUBJECT_ID).INLINE_COMMENT,
                eventType: (0, $jJH6F.EVENT_TYPE).TRACK,
                attributes: {
                    overlap: annotationsByType.length || 0,
                    targetNodeType: eventTargetType,
                    method: viewMethod
                }
            }).fire((0, $2H1dZ.FabricChannel).editor);
            setAnnotationClickEvent({
                annotations: annotationsByType,
                clickElementTarget: eventTarget
            });
        };
        var deselectCb = function deselectCb() {
            setAnnotationClickEvent({
                annotations: [],
                clickElementTarget: undefined
            });
        };
        if (!isAnnotationManagerEnabled) {
            updateSubscriber.on((0, $1xyIw.AnnotationUpdateEvent).ON_ANNOTATION_CLICK, clickCb);
            updateSubscriber.on((0, $1xyIw.AnnotationUpdateEvent).DESELECT_ANNOTATIONS, deselectCb);
            return function() {
                updateSubscriber.off((0, $1xyIw.AnnotationUpdateEvent).ON_ANNOTATION_CLICK, clickCb);
                updateSubscriber.off((0, $1xyIw.AnnotationUpdateEvent).DESELECT_ANNOTATIONS, deselectCb);
            };
        }
    }, [
        updateSubscriber,
        createAnalyticsEvent,
        isNestedRender,
        isAnnotationManagerEnabled
    ]);
    if (isAnnotationManagerEnabled) return isNestedRender ? null : selectedAnnotation;
    else return annotationClickEvent;
};

});
parcelRegister("1xyIw", function(module, exports) {
$parcel$export(module.exports, "AnnotationUpdateEvent", () => $11f3cd9cc2822d28$export$c1c4b33b4e7b1c70);

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $25nEq = parcelRequire("25nEq");

var $gV2pc = parcelRequire("gV2pc");
var $11f3cd9cc2822d28$export$c1c4b33b4e7b1c70 = /*#__PURE__*/ function(AnnotationUpdateEvent) {
    AnnotationUpdateEvent["SET_ANNOTATION_FOCUS"] = "SET_ANNOTATION_FOCUS";
    AnnotationUpdateEvent["SET_ANNOTATION_HOVERED"] = "SET_ANNOTATION_HOVERED";
    AnnotationUpdateEvent["SET_ANNOTATION_STATE"] = "SET_ANNOTATION_STATE";
    AnnotationUpdateEvent["REMOVE_ANNOTATION_FOCUS"] = "REMOVE_ANNOTATION_FOCUS";
    AnnotationUpdateEvent["REMOVE_ANNOTATION_HOVERED"] = "REMOVE_ANNOTATION_HOVERED";
    AnnotationUpdateEvent["ON_ANNOTATION_CLICK"] = "ON_ANNOTATION_CLICK";
    AnnotationUpdateEvent["DESELECT_ANNOTATIONS"] = "DESELECT_ANNOTATIONS";
    return AnnotationUpdateEvent;
}({});
var $11f3cd9cc2822d28$export$7cc60aa9ef845515 = /*#__PURE__*/ function() {
    function AnnotationUpdateEmitter() {
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, AnnotationUpdateEmitter);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "emitter", new (0, (/*@__PURE__*/$parcel$interopDefault($gV2pc)))());
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(AnnotationUpdateEmitter, [
        {
            key: "emit",
            value: function emit(event, params) {
                if (typeof params === 'undefined') return this.emitter.emit(event);
                return this.emitter.emit(event, params);
            }
        },
        {
            key: "on",
            value: // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            function on(event, listener) {
                return this.emitter.on(event, listener);
            }
        },
        {
            key: "off",
            value: // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            function off(event, listener) {
                return this.emitter.removeListener(event, listener);
            }
        },
        {
            key: "listeners",
            value: function listeners(event) {
                return this.emitter.listeners(event);
            }
        }
    ]);
}();

});
parcelRegister("gV2pc", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
'use strict';
var $c513d5e44021461d$var$R = typeof Reflect === 'object' ? Reflect : null;
var $c513d5e44021461d$var$ReflectApply = $c513d5e44021461d$var$R && typeof $c513d5e44021461d$var$R.apply === 'function' ? $c513d5e44021461d$var$R.apply : function ReflectApply(target, receiver, args) {
    return Function.prototype.apply.call(target, receiver, args);
};
var $c513d5e44021461d$var$ReflectOwnKeys;
if ($c513d5e44021461d$var$R && typeof $c513d5e44021461d$var$R.ownKeys === 'function') $c513d5e44021461d$var$ReflectOwnKeys = $c513d5e44021461d$var$R.ownKeys;
else if (Object.getOwnPropertySymbols) $c513d5e44021461d$var$ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target).concat(Object.getOwnPropertySymbols(target));
};
else $c513d5e44021461d$var$ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target);
};
function $c513d5e44021461d$var$ProcessEmitWarning(warning) {
    if (console && console.warn) console.warn(warning);
}
var $c513d5e44021461d$var$NumberIsNaN = Number.isNaN || function NumberIsNaN(value) {
    return value !== value;
};
function $c513d5e44021461d$var$EventEmitter() {
    $c513d5e44021461d$var$EventEmitter.init.call(this);
}
module.exports = $c513d5e44021461d$var$EventEmitter;
module.exports.once = $c513d5e44021461d$var$once;
// Backwards-compat with node 0.10.x
$c513d5e44021461d$var$EventEmitter.EventEmitter = $c513d5e44021461d$var$EventEmitter;
$c513d5e44021461d$var$EventEmitter.prototype._events = undefined;
$c513d5e44021461d$var$EventEmitter.prototype._eventsCount = 0;
$c513d5e44021461d$var$EventEmitter.prototype._maxListeners = undefined;
// By default EventEmitters will print a warning if more than 10 listeners are
// added to it. This is a useful default which helps finding memory leaks.
var $c513d5e44021461d$var$defaultMaxListeners = 10;
function $c513d5e44021461d$var$checkListener(listener) {
    if (typeof listener !== 'function') throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof listener);
}
Object.defineProperty($c513d5e44021461d$var$EventEmitter, 'defaultMaxListeners', {
    enumerable: true,
    get: function() {
        return $c513d5e44021461d$var$defaultMaxListeners;
    },
    set: function(arg) {
        if (typeof arg !== 'number' || arg < 0 || $c513d5e44021461d$var$NumberIsNaN(arg)) throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + arg + '.');
        $c513d5e44021461d$var$defaultMaxListeners = arg;
    }
});
$c513d5e44021461d$var$EventEmitter.init = function() {
    if (this._events === undefined || this._events === Object.getPrototypeOf(this)._events) {
        this._events = Object.create(null);
        this._eventsCount = 0;
    }
    this._maxListeners = this._maxListeners || undefined;
};
// Obviously not all Emitters should be limited to 10. This function allows
// that to be increased. Set to zero for unlimited.
$c513d5e44021461d$var$EventEmitter.prototype.setMaxListeners = function setMaxListeners(n) {
    if (typeof n !== 'number' || n < 0 || $c513d5e44021461d$var$NumberIsNaN(n)) throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + n + '.');
    this._maxListeners = n;
    return this;
};
function $c513d5e44021461d$var$_getMaxListeners(that) {
    if (that._maxListeners === undefined) return $c513d5e44021461d$var$EventEmitter.defaultMaxListeners;
    return that._maxListeners;
}
$c513d5e44021461d$var$EventEmitter.prototype.getMaxListeners = function getMaxListeners() {
    return $c513d5e44021461d$var$_getMaxListeners(this);
};
$c513d5e44021461d$var$EventEmitter.prototype.emit = function emit(type) {
    var args = [];
    for(var i = 1; i < arguments.length; i++)args.push(arguments[i]);
    var doError = type === 'error';
    var events = this._events;
    if (events !== undefined) doError = doError && events.error === undefined;
    else if (!doError) return false;
    // If there is no 'error' event listener then throw.
    if (doError) {
        var er;
        if (args.length > 0) er = args[0];
        if (er instanceof Error) // Note: The comments on the `throw` lines are intentional, they show
        // up in Node's output if this results in an unhandled exception.
        throw er; // Unhandled 'error' event
        // At least give some kind of context to the user
        var err = new Error('Unhandled error.' + (er ? ' (' + er.message + ')' : ''));
        err.context = er;
        throw err; // Unhandled 'error' event
    }
    var handler = events[type];
    if (handler === undefined) return false;
    if (typeof handler === 'function') $c513d5e44021461d$var$ReflectApply(handler, this, args);
    else {
        var len = handler.length;
        var listeners = $c513d5e44021461d$var$arrayClone(handler, len);
        for(var i = 0; i < len; ++i)$c513d5e44021461d$var$ReflectApply(listeners[i], this, args);
    }
    return true;
};
function $c513d5e44021461d$var$_addListener(target, type, listener, prepend) {
    var m;
    var events;
    var existing;
    $c513d5e44021461d$var$checkListener(listener);
    events = target._events;
    if (events === undefined) {
        events = target._events = Object.create(null);
        target._eventsCount = 0;
    } else {
        // To avoid recursion in the case that type === "newListener"! Before
        // adding it to the listeners, first emit "newListener".
        if (events.newListener !== undefined) {
            target.emit('newListener', type, listener.listener ? listener.listener : listener);
            // Re-assign `events` because a newListener handler could have caused the
            // this._events to be assigned to a new object
            events = target._events;
        }
        existing = events[type];
    }
    if (existing === undefined) {
        // Optimize the case of one listener. Don't need the extra array object.
        existing = events[type] = listener;
        ++target._eventsCount;
    } else {
        if (typeof existing === 'function') // Adding the second element, need to change to array.
        existing = events[type] = prepend ? [
            listener,
            existing
        ] : [
            existing,
            listener
        ];
        else if (prepend) existing.unshift(listener);
        else existing.push(listener);
        // Check for listener leak
        m = $c513d5e44021461d$var$_getMaxListeners(target);
        if (m > 0 && existing.length > m && !existing.warned) {
            existing.warned = true;
            // No error code for this since it is a Warning
            // eslint-disable-next-line no-restricted-syntax
            var w = new Error('Possible EventEmitter memory leak detected. ' + existing.length + ' ' + String(type) + ' listeners ' + 'added. Use emitter.setMaxListeners() to ' + 'increase limit');
            w.name = 'MaxListenersExceededWarning';
            w.emitter = target;
            w.type = type;
            w.count = existing.length;
            $c513d5e44021461d$var$ProcessEmitWarning(w);
        }
    }
    return target;
}
$c513d5e44021461d$var$EventEmitter.prototype.addListener = function addListener(type, listener) {
    return $c513d5e44021461d$var$_addListener(this, type, listener, false);
};
$c513d5e44021461d$var$EventEmitter.prototype.on = $c513d5e44021461d$var$EventEmitter.prototype.addListener;
$c513d5e44021461d$var$EventEmitter.prototype.prependListener = function prependListener(type, listener) {
    return $c513d5e44021461d$var$_addListener(this, type, listener, true);
};
function $c513d5e44021461d$var$onceWrapper() {
    if (!this.fired) {
        this.target.removeListener(this.type, this.wrapFn);
        this.fired = true;
        if (arguments.length === 0) return this.listener.call(this.target);
        return this.listener.apply(this.target, arguments);
    }
}
function $c513d5e44021461d$var$_onceWrap(target, type, listener) {
    var state = {
        fired: false,
        wrapFn: undefined,
        target: target,
        type: type,
        listener: listener
    };
    var wrapped = $c513d5e44021461d$var$onceWrapper.bind(state);
    wrapped.listener = listener;
    state.wrapFn = wrapped;
    return wrapped;
}
$c513d5e44021461d$var$EventEmitter.prototype.once = function once(type, listener) {
    $c513d5e44021461d$var$checkListener(listener);
    this.on(type, $c513d5e44021461d$var$_onceWrap(this, type, listener));
    return this;
};
$c513d5e44021461d$var$EventEmitter.prototype.prependOnceListener = function prependOnceListener(type, listener) {
    $c513d5e44021461d$var$checkListener(listener);
    this.prependListener(type, $c513d5e44021461d$var$_onceWrap(this, type, listener));
    return this;
};
// Emits a 'removeListener' event if and only if the listener was removed.
$c513d5e44021461d$var$EventEmitter.prototype.removeListener = function removeListener(type, listener) {
    var list, events, position, i, originalListener;
    $c513d5e44021461d$var$checkListener(listener);
    events = this._events;
    if (events === undefined) return this;
    list = events[type];
    if (list === undefined) return this;
    if (list === listener || list.listener === listener) {
        if (--this._eventsCount === 0) this._events = Object.create(null);
        else {
            delete events[type];
            if (events.removeListener) this.emit('removeListener', type, list.listener || listener);
        }
    } else if (typeof list !== 'function') {
        position = -1;
        for(i = list.length - 1; i >= 0; i--)if (list[i] === listener || list[i].listener === listener) {
            originalListener = list[i].listener;
            position = i;
            break;
        }
        if (position < 0) return this;
        if (position === 0) list.shift();
        else $c513d5e44021461d$var$spliceOne(list, position);
        if (list.length === 1) events[type] = list[0];
        if (events.removeListener !== undefined) this.emit('removeListener', type, originalListener || listener);
    }
    return this;
};
$c513d5e44021461d$var$EventEmitter.prototype.off = $c513d5e44021461d$var$EventEmitter.prototype.removeListener;
$c513d5e44021461d$var$EventEmitter.prototype.removeAllListeners = function removeAllListeners(type) {
    var listeners, events, i;
    events = this._events;
    if (events === undefined) return this;
    // not listening for removeListener, no need to emit
    if (events.removeListener === undefined) {
        if (arguments.length === 0) {
            this._events = Object.create(null);
            this._eventsCount = 0;
        } else if (events[type] !== undefined) {
            if (--this._eventsCount === 0) this._events = Object.create(null);
            else delete events[type];
        }
        return this;
    }
    // emit removeListener for all listeners on all events
    if (arguments.length === 0) {
        var keys = Object.keys(events);
        var key;
        for(i = 0; i < keys.length; ++i){
            key = keys[i];
            if (key === 'removeListener') continue;
            this.removeAllListeners(key);
        }
        this.removeAllListeners('removeListener');
        this._events = Object.create(null);
        this._eventsCount = 0;
        return this;
    }
    listeners = events[type];
    if (typeof listeners === 'function') this.removeListener(type, listeners);
    else if (listeners !== undefined) // LIFO order
    for(i = listeners.length - 1; i >= 0; i--)this.removeListener(type, listeners[i]);
    return this;
};
function $c513d5e44021461d$var$_listeners(target, type, unwrap) {
    var events = target._events;
    if (events === undefined) return [];
    var evlistener = events[type];
    if (evlistener === undefined) return [];
    if (typeof evlistener === 'function') return unwrap ? [
        evlistener.listener || evlistener
    ] : [
        evlistener
    ];
    return unwrap ? $c513d5e44021461d$var$unwrapListeners(evlistener) : $c513d5e44021461d$var$arrayClone(evlistener, evlistener.length);
}
$c513d5e44021461d$var$EventEmitter.prototype.listeners = function listeners(type) {
    return $c513d5e44021461d$var$_listeners(this, type, true);
};
$c513d5e44021461d$var$EventEmitter.prototype.rawListeners = function rawListeners(type) {
    return $c513d5e44021461d$var$_listeners(this, type, false);
};
$c513d5e44021461d$var$EventEmitter.listenerCount = function(emitter, type) {
    if (typeof emitter.listenerCount === 'function') return emitter.listenerCount(type);
    else return $c513d5e44021461d$var$listenerCount.call(emitter, type);
};
$c513d5e44021461d$var$EventEmitter.prototype.listenerCount = $c513d5e44021461d$var$listenerCount;
function $c513d5e44021461d$var$listenerCount(type) {
    var events = this._events;
    if (events !== undefined) {
        var evlistener = events[type];
        if (typeof evlistener === 'function') return 1;
        else if (evlistener !== undefined) return evlistener.length;
    }
    return 0;
}
$c513d5e44021461d$var$EventEmitter.prototype.eventNames = function eventNames() {
    return this._eventsCount > 0 ? $c513d5e44021461d$var$ReflectOwnKeys(this._events) : [];
};
function $c513d5e44021461d$var$arrayClone(arr, n) {
    var copy = new Array(n);
    for(var i = 0; i < n; ++i)copy[i] = arr[i];
    return copy;
}
function $c513d5e44021461d$var$spliceOne(list, index) {
    for(; index + 1 < list.length; index++)list[index] = list[index + 1];
    list.pop();
}
function $c513d5e44021461d$var$unwrapListeners(arr) {
    var ret = new Array(arr.length);
    for(var i = 0; i < ret.length; ++i)ret[i] = arr[i].listener || arr[i];
    return ret;
}
function $c513d5e44021461d$var$once(emitter, name) {
    return new Promise(function(resolve, reject) {
        function errorListener(err) {
            emitter.removeListener(name, resolver);
            reject(err);
        }
        function resolver() {
            if (typeof emitter.removeListener === 'function') emitter.removeListener('error', errorListener);
            resolve([].slice.call(arguments));
        }
        $c513d5e44021461d$var$eventTargetAgnosticAddListener(emitter, name, resolver, {
            once: true
        });
        if (name !== 'error') $c513d5e44021461d$var$addErrorHandlerIfEventEmitter(emitter, errorListener, {
            once: true
        });
    });
}
function $c513d5e44021461d$var$addErrorHandlerIfEventEmitter(emitter, handler, flags) {
    if (typeof emitter.on === 'function') $c513d5e44021461d$var$eventTargetAgnosticAddListener(emitter, 'error', handler, flags);
}
function $c513d5e44021461d$var$eventTargetAgnosticAddListener(emitter, name, listener, flags) {
    if (typeof emitter.on === 'function') {
        if (flags.once) emitter.once(name, listener);
        else emitter.on(name, listener);
    } else if (typeof emitter.addEventListener === 'function') // EventTarget does not have `error` event semantics like Node
    // EventEmitters, we do not listen for `error` events here.
    emitter.addEventListener(name, function wrapListener(arg) {
        // IE does not have builtin `{ once: true }` support so we
        // have to do it manually.
        if (flags.once) emitter.removeEventListener(name, wrapListener);
        listener(arg);
    });
    else throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof emitter);
}

});


parcelRegister("fDwDe", function(module, exports) {
$parcel$export(module.exports, "AnnotationManagerProvider", () => $b623cf848f8f071e$export$f21fb05766361bb3);
$parcel$export(module.exports, "useAnnotationManagerState", () => $b623cf848f8f071e$export$654a1fb45487f838);
$parcel$export(module.exports, "useAnnotationManagerDispatch", () => $b623cf848f8f071e$export$12cbbb89fb7702d0);

var $iYJcE = parcelRequire("iYJcE");

var $25nEq = parcelRequire("25nEq");

var $5FkrB = parcelRequire("5FkrB");

var $kX1mK = parcelRequire("kX1mK");

var $1xyIw = parcelRequire("1xyIw");

var $lMzAH = parcelRequire("lMzAH");
function $b623cf848f8f071e$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $b623cf848f8f071e$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $b623cf848f8f071e$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $b623cf848f8f071e$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $b623cf848f8f071e$var$initState = {
    isDrafting: false,
    draftId: undefined,
    draftMarkRef: undefined,
    draftActionResult: undefined,
    annotations: {},
    currentSelectedAnnotationId: undefined,
    currentSelectedMarkRef: undefined,
    currentHoveredAnnotationId: undefined
};
var $b623cf848f8f071e$var$AnnotationManagerStateContext = /*#__PURE__*/ (0, $5FkrB.createContext)($b623cf848f8f071e$var$initState);
var $b623cf848f8f071e$var$AnnotationManagerDispatchContext = /*#__PURE__*/ (0, $5FkrB.createContext)({
    annotationManager: undefined,
    dispatch: function dispatch() {}
});
function $b623cf848f8f071e$var$reducer(state, action) {
    switch(action.type){
        case 'reset':
            return $b623cf848f8f071e$var$_objectSpread($b623cf848f8f071e$var$_objectSpread({}, state), $b623cf848f8f071e$var$initState);
        case 'loadAnnotation':
            var currentIds = Object.keys(state.annotations);
            var uids = Array.from(new Set(currentIds.concat(action.data.map(function(a) {
                return a.id;
            }))));
            var updates = [];
            var _loop = function _loop() {
                var _state$annotations$id, _state$annotations$id2;
                var id = _uids[_i];
                var loadedAnnotation = action.data.find(function(a) {
                    return a.id === id;
                });
                if (!loadedAnnotation && ((_state$annotations$id = state.annotations[id]) === null || _state$annotations$id === void 0 ? void 0 : _state$annotations$id.markState) === (0, $kX1mK.AnnotationMarkStates).ACTIVE) {
                    // If the annotation is not in the loaded data, we need to remove it from the state. However,
                    // rather then removing it, we will set the mark state to resolved. This is to align it better with
                    // how the editor works.
                    updates.push({
                        id: id,
                        markState: (0, $kX1mK.AnnotationMarkStates).RESOLVED
                    });
                    return 0; // continue
                }
                if (!!(loadedAnnotation !== null && loadedAnnotation !== void 0 && loadedAnnotation.markState) && ((_state$annotations$id2 = state.annotations[id]) === null || _state$annotations$id2 === void 0 ? void 0 : _state$annotations$id2.markState) !== loadedAnnotation.markState) {
                    updates.push({
                        id: id,
                        markState: loadedAnnotation.markState
                    });
                    return 0; // continue
                }
            }, _ret;
            for(var _i = 0, _uids = uids; _i < _uids.length; _i++){
                _ret = _loop();
                if (_ret === 0) continue;
            }
            if (updates.length > 0) return $b623cf848f8f071e$var$_objectSpread($b623cf848f8f071e$var$_objectSpread({}, state), {}, {
                annotations: updates.reduce(function(nextAnnotations, update) {
                    return $b623cf848f8f071e$var$_objectSpread($b623cf848f8f071e$var$_objectSpread({}, nextAnnotations), {}, (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, update.id, $b623cf848f8f071e$var$_objectSpread($b623cf848f8f071e$var$_objectSpread({}, nextAnnotations[update.id]), update)));
                }, state.annotations)
            });
            return state;
        case 'updateAnnotation':
            var current = state.annotations[action.data.id];
            var _action$data = action.data, id = _action$data.id, selected = _action$data.selected, hovered = _action$data.hovered, _action$data$markStat = _action$data.markState, markState = _action$data$markStat === void 0 ? current === null || current === void 0 ? void 0 : current.markState : _action$data$markStat;
            var _updates = [];
            // If the annotation is not currently in the state, we need to add it to the state.
            if (!current) _updates.push({
                id: id,
                markState: markState !== null && markState !== void 0 ? markState : (0, $kX1mK.AnnotationMarkStates).ACTIVE
            });
            // The goal of the following is to enforce a single selection and a single hover state across all annotations.
            var nextSelectedId = state.currentSelectedAnnotationId;
            if (selected && nextSelectedId !== id) nextSelectedId = id;
            // If the annotation is currently selected and it's being unselected, we need to remove it from the
            // current selected annotation id.
            if (selected === false && nextSelectedId === id) nextSelectedId = undefined;
            var nextHoveredId = state.currentHoveredAnnotationId;
            if (hovered && nextHoveredId !== id) nextHoveredId = id;
            // If the annotation is currently hovered and it's being unhovered, we need to remove it from the
            // current hovered annotation id.
            if (hovered === false && nextHoveredId === id) nextHoveredId = undefined;
            // If the annotations mark state is not the same as the current mark state, we need to update it.
            if ((current === null || current === void 0 ? void 0 : current.markState) !== markState) {
                _updates.push({
                    id: id,
                    markState: markState !== null && markState !== void 0 ? markState : (0, $kX1mK.AnnotationMarkStates).ACTIVE
                });
                // If the annotation is currently selected and it's being resolved, then we need to remove it from the
                // current selected annotation id also.
                if (markState === (0, $kX1mK.AnnotationMarkStates).RESOLVED && nextSelectedId === id) nextSelectedId = undefined;
            }
            if (_updates.length > 0 || nextSelectedId !== state.currentSelectedAnnotationId || nextHoveredId !== state.currentHoveredAnnotationId) return $b623cf848f8f071e$var$_objectSpread($b623cf848f8f071e$var$_objectSpread({}, state), {}, {
                currentSelectedAnnotationId: nextSelectedId,
                currentHoveredAnnotationId: nextHoveredId,
                annotations: _updates.reduce(function(nextAnnotations, update) {
                    return $b623cf848f8f071e$var$_objectSpread($b623cf848f8f071e$var$_objectSpread({}, nextAnnotations), {}, (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, update.id, $b623cf848f8f071e$var$_objectSpread($b623cf848f8f071e$var$_objectSpread({}, nextAnnotations[update.id]), update)));
                }, state.annotations)
            });
            return state;
        case 'resetSelectedAnnotation':
            if (state.currentSelectedAnnotationId !== undefined) return $b623cf848f8f071e$var$_objectSpread($b623cf848f8f071e$var$_objectSpread({}, state), {}, {
                currentSelectedAnnotationId: undefined,
                currentSelectedMarkRef: undefined
            });
            return state;
        case 'resetHoveredAnnotation':
            if (state.currentHoveredAnnotationId !== undefined) return $b623cf848f8f071e$var$_objectSpread($b623cf848f8f071e$var$_objectSpread({}, state), {}, {
                currentHoveredAnnotationId: undefined
            });
            return state;
        case 'setDrafting':
            if (state.isDrafting !== action.data.isDrafting || state.draftId !== action.data.draftId || state.draftActionResult !== action.data.draftActionResult) // XXX: When a draft is open the current selected annotation should no longer be selected. We need
            // to decide what is better UX,
            // 1 - do we want to deselct the selected annotation on draft open, if so then when draft is closed the s
            // selected annotation will not come back
            // 2 - do we want to still allow the selected annotation to be selected when draft is open, however the underlying
            // mark style just shows the annotation as not selected when a draft is active. Then when a draft closes
            // we can reopen the previous selected annotation.
            return $b623cf848f8f071e$var$_objectSpread($b623cf848f8f071e$var$_objectSpread({}, state), {}, {
                isDrafting: action.data.isDrafting,
                draftId: action.data.draftId,
                draftActionResult: action.data.draftActionResult
            });
            return state;
        case 'setDraftMarkRef':
            if (state.draftMarkRef !== action.data.draftMarkRef) return $b623cf848f8f071e$var$_objectSpread($b623cf848f8f071e$var$_objectSpread({}, state), {}, {
                draftMarkRef: action.data.draftMarkRef
            });
            return state;
        case 'setSelectedMarkRef':
            if (state.currentSelectedMarkRef !== action.data.markRef) return $b623cf848f8f071e$var$_objectSpread($b623cf848f8f071e$var$_objectSpread({}, state), {}, {
                currentSelectedMarkRef: action.data.markRef
            });
            return state;
    }
}
var $b623cf848f8f071e$export$f21fb05766361bb3 = function AnnotationManagerProvider(_ref) {
    var children = _ref.children, annotationManager = _ref.annotationManager, updateSubscriber = _ref.updateSubscriber;
    var _useReducer = (0, $5FkrB.useReducer)($b623cf848f8f071e$var$reducer, $b623cf848f8f071e$var$initState), _useReducer2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useReducer, 2), state = _useReducer2[0], dispatch = _useReducer2[1];
    var actionContext = (0, $5FkrB.useContext)((0, $lMzAH.RendererContext));
    (0, $5FkrB.useEffect)(function() {
        var getDraft = function getDraft() {
            var _state$draftActionRes;
            if (!state.isDrafting || !state.draftActionResult || !state.draftMarkRef || !state.draftId) return {
                success: false,
                reason: 'draft-not-started'
            };
            return {
                success: true,
                inlineNodeTypes: (_state$draftActionRes = state.draftActionResult.inlineNodeTypes) !== null && _state$draftActionRes !== void 0 ? _state$draftActionRes : [],
                targetElement: state.draftMarkRef,
                actionResult: {
                    step: state.draftActionResult.step,
                    doc: state.draftActionResult.doc,
                    inlineNodeTypes: state.draftActionResult.inlineNodeTypes,
                    targetNodeType: state.draftActionResult.targetNodeType,
                    originalSelection: state.draftActionResult.originalSelection,
                    numMatches: state.draftActionResult.numMatches,
                    matchIndex: state.draftActionResult.matchIndex,
                    pos: state.draftActionResult.pos
                }
            };
        };
        annotationManager === null || annotationManager === void 0 || annotationManager.hook('getDraft', getDraft);
        return function() {
            annotationManager === null || annotationManager === void 0 || annotationManager.unhook('getDraft', getDraft);
        };
    }, [
        annotationManager,
        state.draftId,
        state.isDrafting,
        state.draftMarkRef,
        state.draftActionResult
    ]);
    // We need to watch for the draft mark element to exist, so we can inform any listeners that the draft has been started
    // and give them a reference to the element
    (0, $5FkrB.useEffect)(function() {
        if (state.isDrafting && state.draftId && state.draftMarkRef && state.draftActionResult) {
            var _state$draftActionRes2;
            annotationManager === null || annotationManager === void 0 || annotationManager.emit({
                name: 'draftAnnotationStarted',
                data: {
                    inlineNodeTypes: (_state$draftActionRes2 = state.draftActionResult.inlineNodeTypes) !== null && _state$draftActionRes2 !== void 0 ? _state$draftActionRes2 : [],
                    targetElement: state.draftMarkRef,
                    actionResult: {
                        step: state.draftActionResult.step,
                        doc: state.draftActionResult.doc,
                        inlineNodeTypes: state.draftActionResult.inlineNodeTypes,
                        targetNodeType: state.draftActionResult.targetNodeType,
                        originalSelection: state.draftActionResult.originalSelection,
                        numMatches: state.draftActionResult.numMatches,
                        matchIndex: state.draftActionResult.matchIndex,
                        pos: state.draftActionResult.pos
                    }
                }
            });
        }
    }, [
        annotationManager,
        state.draftId,
        state.isDrafting,
        state.draftMarkRef,
        state.draftActionResult
    ]);
    (0, $5FkrB.useEffect)(function() {
        var setIsAnnotationSelected = function setIsAnnotationSelected(id, isSelected) {
            var _state$annotations;
            if (state.isDrafting) return {
                success: false,
                reason: 'draft-in-progress'
            };
            if (!((_state$annotations = state.annotations) !== null && _state$annotations !== void 0 && _state$annotations[id])) return {
                success: false,
                reason: 'id-not-valid'
            };
            // the annotation is currently not selected and is being selected
            if (id !== state.currentSelectedAnnotationId && isSelected) {
                dispatch({
                    type: 'updateAnnotation',
                    data: {
                        id: id,
                        selected: true
                    }
                });
                dispatch({
                    type: 'setSelectedMarkRef',
                    data: {
                        markRef: document.getElementById(id) || undefined
                    }
                });
            } else if (id === state.currentSelectedAnnotationId && !isSelected) dispatch({
                type: 'resetSelectedAnnotation'
            });
            return {
                success: true,
                isSelected: isSelected
            };
        };
        annotationManager === null || annotationManager === void 0 || annotationManager.hook('setIsAnnotationSelected', setIsAnnotationSelected);
        return function() {
            annotationManager === null || annotationManager === void 0 || annotationManager.unhook('setIsAnnotationSelected', setIsAnnotationSelected);
        };
    }, [
        annotationManager,
        state.isDrafting,
        state.annotations,
        state.currentSelectedAnnotationId,
        state.currentSelectedMarkRef
    ]);
    var prevSelectedAnnotationId = (0, $5FkrB.useRef)(undefined);
    (0, $5FkrB.useEffect)(function() {
        if (prevSelectedAnnotationId.current) annotationManager === null || annotationManager === void 0 || annotationManager.emit({
            name: 'annotationSelectionChanged',
            data: {
                annotationId: prevSelectedAnnotationId.current,
                isSelected: false,
                inlineNodeTypes: []
            }
        });
        prevSelectedAnnotationId.current = state.currentSelectedAnnotationId;
    }, [
        state.currentSelectedAnnotationId,
        annotationManager
    ]);
    (0, $5FkrB.useEffect)(function() {
        if (state.currentSelectedAnnotationId && state.currentSelectedMarkRef && state.currentSelectedMarkRef.id === state.currentSelectedAnnotationId) annotationManager === null || annotationManager === void 0 || annotationManager.emit({
            name: 'annotationSelectionChanged',
            data: {
                annotationId: state.currentSelectedAnnotationId,
                isSelected: true,
                inlineNodeTypes: []
            }
        });
    }, [
        annotationManager,
        state.currentSelectedAnnotationId,
        state.currentSelectedMarkRef
    ]);
    (0, $5FkrB.useEffect)(function() {
        var setIsAnnotationHovered = function setIsAnnotationHovered(id, isHovered) {
            var _state$annotations2;
            if (!((_state$annotations2 = state.annotations) !== null && _state$annotations2 !== void 0 && _state$annotations2[id])) return {
                success: false,
                reason: 'id-not-valid'
            };
            dispatch({
                type: 'updateAnnotation',
                data: {
                    id: id,
                    hovered: isHovered
                }
            });
            return {
                success: true,
                isHovered: isHovered
            };
        };
        annotationManager === null || annotationManager === void 0 || annotationManager.hook('setIsAnnotationHovered', setIsAnnotationHovered);
        return function() {
            annotationManager === null || annotationManager === void 0 || annotationManager.unhook('setIsAnnotationHovered', setIsAnnotationHovered);
        };
    }, [
        annotationManager,
        state.annotations
    ]);
    (0, $5FkrB.useEffect)(function() {
        var clearAnnotation = function clearAnnotation(id) {
            var _state$annotations3;
            if (!((_state$annotations3 = state.annotations) !== null && _state$annotations3 !== void 0 && _state$annotations3[id])) return {
                success: false,
                reason: 'id-not-valid'
            };
            var result = actionContext.deleteAnnotation(id, (0, $kX1mK.AnnotationTypes).INLINE_COMMENT);
            if (!result) return {
                success: false,
                reason: 'clear-failed'
            };
            var step = result.step, doc = result.doc;
            return {
                success: true,
                actionResult: {
                    step: step,
                    doc: doc
                }
            };
        };
        annotationManager === null || annotationManager === void 0 || annotationManager.hook('clearAnnotation', clearAnnotation);
        return function() {
            annotationManager === null || annotationManager === void 0 || annotationManager.unhook('clearAnnotation', clearAnnotation);
        };
    }, [
        annotationManager,
        state.annotations,
        actionContext
    ]);
    /**
   * This is a temporary solution to ensure that the annotation manager state is in sync with the
   * old updateSubscriber. The updateSubscriber will eventually be deprecated and the state will be managed
   * by the annotation manager itself.
   */ (0, $5FkrB.useEffect)(function() {
        var onSetAnnotationState = function onSetAnnotationState(payload) {
            if (!payload) return;
            Object.values(payload).forEach(function(annotation) {
                if (annotation.id && annotation.annotationType === (0, $kX1mK.AnnotationTypes).INLINE_COMMENT) {
                    var _annotation$state;
                    dispatch({
                        type: 'updateAnnotation',
                        data: {
                            id: annotation.id,
                            markState: (_annotation$state = annotation.state) !== null && _annotation$state !== void 0 ? _annotation$state : undefined
                        }
                    });
                }
            });
        };
        var onAnnotationSelected = function onAnnotationSelected(payload) {
            dispatch({
                type: 'updateAnnotation',
                data: {
                    id: payload.annotationId,
                    selected: true
                }
            });
        };
        var onAnnotationHovered = function onAnnotationHovered(payload) {
            dispatch({
                type: 'updateAnnotation',
                data: {
                    id: payload.annotationId,
                    hovered: true
                }
            });
        };
        var onAnnotationSelectedRemoved = function onAnnotationSelectedRemoved() {
            dispatch({
                type: 'resetSelectedAnnotation'
            });
        };
        var onAnnotationHoveredRemoved = function onAnnotationHoveredRemoved() {
            dispatch({
                type: 'resetHoveredAnnotation'
            });
        };
        var onAnnotationClick = function onAnnotationClick(_ref2) {
            var annotationIds = _ref2.annotationIds, eventTarget = _ref2.eventTarget, _eventTargetType = _ref2.eventTargetType, _viewMethod = _ref2.viewMethod;
            dispatch({
                type: 'updateAnnotation',
                data: {
                    id: annotationIds[0],
                    selected: true
                }
            });
            dispatch({
                type: 'setSelectedMarkRef',
                data: {
                    markRef: eventTarget
                }
            });
        };
        var onAnnotationDeselect = function onAnnotationDeselect() {
            dispatch({
                type: 'resetSelectedAnnotation'
            });
        };
        updateSubscriber === null || updateSubscriber === void 0 || updateSubscriber.on((0, $1xyIw.AnnotationUpdateEvent).SET_ANNOTATION_STATE, onSetAnnotationState);
        updateSubscriber === null || updateSubscriber === void 0 || updateSubscriber.on((0, $1xyIw.AnnotationUpdateEvent).SET_ANNOTATION_FOCUS, onAnnotationSelected);
        updateSubscriber === null || updateSubscriber === void 0 || updateSubscriber.on((0, $1xyIw.AnnotationUpdateEvent).SET_ANNOTATION_HOVERED, onAnnotationHovered);
        updateSubscriber === null || updateSubscriber === void 0 || updateSubscriber.on((0, $1xyIw.AnnotationUpdateEvent).REMOVE_ANNOTATION_FOCUS, onAnnotationSelectedRemoved);
        updateSubscriber === null || updateSubscriber === void 0 || updateSubscriber.on((0, $1xyIw.AnnotationUpdateEvent).REMOVE_ANNOTATION_HOVERED, onAnnotationHoveredRemoved);
        updateSubscriber === null || updateSubscriber === void 0 || updateSubscriber.on((0, $1xyIw.AnnotationUpdateEvent).ON_ANNOTATION_CLICK, onAnnotationClick);
        updateSubscriber === null || updateSubscriber === void 0 || updateSubscriber.on((0, $1xyIw.AnnotationUpdateEvent).DESELECT_ANNOTATIONS, onAnnotationDeselect);
        return function() {
            updateSubscriber === null || updateSubscriber === void 0 || updateSubscriber.off((0, $1xyIw.AnnotationUpdateEvent).SET_ANNOTATION_STATE, onSetAnnotationState);
            updateSubscriber === null || updateSubscriber === void 0 || updateSubscriber.off((0, $1xyIw.AnnotationUpdateEvent).SET_ANNOTATION_FOCUS, onAnnotationSelected);
            updateSubscriber === null || updateSubscriber === void 0 || updateSubscriber.off((0, $1xyIw.AnnotationUpdateEvent).SET_ANNOTATION_HOVERED, onAnnotationHovered);
            updateSubscriber === null || updateSubscriber === void 0 || updateSubscriber.off((0, $1xyIw.AnnotationUpdateEvent).REMOVE_ANNOTATION_FOCUS, onAnnotationSelectedRemoved);
            updateSubscriber === null || updateSubscriber === void 0 || updateSubscriber.off((0, $1xyIw.AnnotationUpdateEvent).REMOVE_ANNOTATION_HOVERED, onAnnotationHoveredRemoved);
            updateSubscriber === null || updateSubscriber === void 0 || updateSubscriber.off((0, $1xyIw.AnnotationUpdateEvent).ON_ANNOTATION_CLICK, onAnnotationClick);
            updateSubscriber === null || updateSubscriber === void 0 || updateSubscriber.off((0, $1xyIw.AnnotationUpdateEvent).DESELECT_ANNOTATIONS, onAnnotationDeselect);
        };
    }, [
        updateSubscriber
    ]);
    var dispatchData = (0, $5FkrB.useMemo)(function() {
        return {
            annotationManager: annotationManager,
            dispatch: dispatch
        };
    }, [
        annotationManager,
        dispatch
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement($b623cf848f8f071e$var$AnnotationManagerStateContext.Provider, {
        value: state
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement($b623cf848f8f071e$var$AnnotationManagerDispatchContext.Provider, {
        value: dispatchData
    }, children));
};
var $b623cf848f8f071e$export$654a1fb45487f838 = function useAnnotationManagerState() {
    return (0, $5FkrB.useContext)($b623cf848f8f071e$var$AnnotationManagerStateContext);
};
var $b623cf848f8f071e$export$12cbbb89fb7702d0 = function useAnnotationManagerDispatch() {
    return (0, $5FkrB.useContext)($b623cf848f8f071e$var$AnnotationManagerDispatchContext);
};

});
parcelRegister("lMzAH", function(module, exports) {
$parcel$export(module.exports, "RendererContext", () => $fdb9b0466c2c6c3d$export$1e9ea4edb6d1bfe6);
$parcel$export(module.exports, "RendererActionsContext", () => $fdb9b0466c2c6c3d$export$66feffbad722f9d4);

var $5FkrB = parcelRequire("5FkrB");

var $9Zzpd = parcelRequire("9Zzpd");

var $cOsWw = parcelRequire("cOsWw");
parcelRequire("5nezv");
var $2H1dZ = parcelRequire("2H1dZ");

var $jJH6F = parcelRequire("jJH6F");

var $hFyhw = parcelRequire("hFyhw");
var $fdb9b0466c2c6c3d$export$1e9ea4edb6d1bfe6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createContext(new (0, $hFyhw.default)());
function $fdb9b0466c2c6c3d$export$66feffbad722f9d4(_ref) {
    var children = _ref.children, context = _ref.context;
    var _useAnalyticsEvents = (0, $cOsWw.useAnalyticsEvents)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
    var actions = (0, $5FkrB.useMemo)(function() {
        return new (0, $hFyhw.default)(true);
    }, []);
    // Remove this eventually when root cause is assessed
    if ((0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).Children.count(children) > 1 && (0, $9Zzpd.fg)('confluence_frontend_fix_view_page_slo')) // Send event when we get more than 1 child
    try {
        throw new Error('Too many children');
    } catch (e) {
        var _ref2 = e, stack = _ref2.stack;
        createAnalyticsEvent({
            eventType: (0, $jJH6F.EVENT_TYPE).TRACK,
            action: 'rendered',
            actionSubject: 'multipleChildren',
            actionSubjectId: 'rendererActionsContext',
            attributes: {
                numChildren: (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).Children.count(children),
                stackTrace: stack
            }
        }).fire((0, $2H1dZ.FabricChannel).editor);
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement($fdb9b0466c2c6c3d$export$1e9ea4edb6d1bfe6.Provider, {
        value: context || actions
    }, (0, $9Zzpd.fg)('confluence_frontend_fix_view_page_slo') ? (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).Children.only(children) : children);
}
var $fdb9b0466c2c6c3d$export$d5fcf151601331bc = $fdb9b0466c2c6c3d$export$1e9ea4edb6d1bfe6.Consumer;

});
parcelRegister("5nezv", function(module, exports) {
$parcel$export(module.exports, "FabricChannel", () => (parcelRequire("2H1dZ")).FabricChannel);

var $hCOpp = parcelRequire("hCOpp");

var $gLrwD = parcelRequire("gLrwD");

var $2H1dZ = parcelRequire("2H1dZ");

});
parcelRegister("hCOpp", function(module, exports) {

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $kIXpt = parcelRequire("kIXpt");

var $cYPzS = parcelRequire("cYPzS");

var $eyuDe = parcelRequire("eyuDe");

var $25nEq = parcelRequire("25nEq");

var $5FkrB = parcelRequire("5FkrB");

var $2H1dZ = parcelRequire("2H1dZ");

var $cwPdS = parcelRequire("cwPdS");

var $iIobB = parcelRequire("iIobB");

var $gLrwD = parcelRequire("gLrwD");

var $e8sqz = parcelRequire("e8sqz");

var $djbX4 = parcelRequire("djbX4");

var $G3sga = parcelRequire("G3sga");

var $eKEna = parcelRequire("eKEna");

var $3D2FR = parcelRequire("3D2FR");

var $7NLcS = parcelRequire("7NLcS");

var $6vcvs = parcelRequire("6vcvs");

var $89IQS = parcelRequire("89IQS");

var $gUhCZ = parcelRequire("gUhCZ");

var $26RMx = parcelRequire("26RMx");

var $lyeuJ = parcelRequire("lyeuJ");

var $cIOw3 = parcelRequire("cIOw3");

var $6Edu4 = parcelRequire("6Edu4");

var $eDDnG = parcelRequire("eDDnG");

var $9oOCJ = parcelRequire("9oOCJ");
var $cd4d1671635e4fd6$var$_listenerMap;
function $cd4d1671635e4fd6$var$_callSuper(t, o, e) {
    return o = (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(o), (0, (/*@__PURE__*/$parcel$interopDefault($kIXpt)))(t, $cd4d1671635e4fd6$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(t).constructor) : o.apply(t, e));
}
function $cd4d1671635e4fd6$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($cd4d1671635e4fd6$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $cd4d1671635e4fd6$var$listenerMap = ($cd4d1671635e4fd6$var$_listenerMap = {}, (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($cd4d1671635e4fd6$var$_listenerMap, (0, $2H1dZ.FabricChannel).elements, (0, $cwPdS.default)), (0, $2H1dZ.FabricChannel).editor, (0, $djbX4.default)), (0, $2H1dZ.FabricChannel).atlaskit, (0, $iIobB.default)), (0, $2H1dZ.FabricChannel).navigation, (0, $e8sqz.default)), (0, $2H1dZ.FabricChannel).media, (0, $G3sga.default)), (0, $2H1dZ.FabricChannel).peopleTeams, (0, $eKEna.default)), (0, $2H1dZ.FabricChannel).notifications, (0, $3D2FR.default)), (0, $2H1dZ.FabricChannel).recentWork, (0, $7NLcS.default)), (0, $2H1dZ.FabricChannel).atlas, (0, $6vcvs.default)), (0, $2H1dZ.FabricChannel).crossFlow, (0, $89IQS.default)), (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($cd4d1671635e4fd6$var$_listenerMap, (0, $2H1dZ.FabricChannel).linkingPlatform, (0, $gUhCZ.default)), (0, $2H1dZ.FabricChannel).postOffice, (0, $26RMx.default)), (0, $2H1dZ.FabricChannel).aiMate, (0, $lyeuJ.default)), (0, $2H1dZ.FabricChannel).avp, (0, $cIOw3.default)), (0, $2H1dZ.FabricChannel).growth, (0, $6Edu4.default)), (0, $2H1dZ.FabricChannel).omniChannel, (0, $eDDnG.default)), (0, $2H1dZ.FabricChannel).townsquareHome, (0, $9oOCJ.default)));
var $cd4d1671635e4fd6$var$FabricAnalyticsListeners = /*#__PURE__*/ function(_React$Component) {
    function FabricAnalyticsListeners(props) {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, FabricAnalyticsListeners);
        _this = $cd4d1671635e4fd6$var$_callSuper(this, FabricAnalyticsListeners, [
            props
        ]);
        _this.logger = new (0, $gLrwD.default)({
            logLevel: props.logLevel
        });
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($eyuDe)))(FabricAnalyticsListeners, _React$Component);
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(FabricAnalyticsListeners, [
        {
            key: "render",
            value: function render() {
                var _this2 = this;
                var _this$props = this.props, client = _this$props.client, children = _this$props.children, logLevel = _this$props.logLevel, excludedChannels = _this$props.excludedChannels;
                if (typeof logLevel === 'number') this.logger.setLogLevel(logLevel);
                var listeners = Object.keys($cd4d1671635e4fd6$var$listenerMap).filter(function(channel) {
                    return !excludedChannels || excludedChannels.indexOf(channel) < 0;
                }).map(function(channel) {
                    return $cd4d1671635e4fd6$var$listenerMap[channel];
                }).reduce(function(prev, Listener) {
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(Listener, {
                        client: client,
                        logger: _this2.logger
                    }, prev);
                }, children);
                return listeners;
            }
        }
    ]);
}((0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).Component);
var $cd4d1671635e4fd6$export$2e2bcd8739ae039 = $cd4d1671635e4fd6$var$FabricAnalyticsListeners;

});
parcelRegister("cwPdS", function(module, exports) {
$parcel$export(module.exports, "ELEMENTS_TAG", () => $91f034fda0c7bd6e$export$ed71ae78997933a);
$parcel$export(module.exports, "default", () => $91f034fda0c7bd6e$export$2e2bcd8739ae039);

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $kIXpt = parcelRequire("kIXpt");

var $cYPzS = parcelRequire("cYPzS");

var $eyuDe = parcelRequire("eyuDe");

var $25nEq = parcelRequire("25nEq");

var $5FkrB = parcelRequire("5FkrB");

var $38rNl = parcelRequire("38rNl");

var $2H1dZ = parcelRequire("2H1dZ");

var $cntcM = parcelRequire("cntcM");
function $91f034fda0c7bd6e$var$_callSuper(t, o, e) {
    return o = (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(o), (0, (/*@__PURE__*/$parcel$interopDefault($kIXpt)))(t, $91f034fda0c7bd6e$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(t).constructor) : o.apply(t, e));
}
function $91f034fda0c7bd6e$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($91f034fda0c7bd6e$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $91f034fda0c7bd6e$export$ed71ae78997933a = 'fabricElements';
var $91f034fda0c7bd6e$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_React$Component) {
    function FabricElementsListener() {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, FabricElementsListener);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = $91f034fda0c7bd6e$var$_callSuper(this, FabricElementsListener, [].concat(args));
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "handleEventWrapper", function(event) {
            (0, $cntcM.handleEvent)(event, $91f034fda0c7bd6e$export$ed71ae78997933a, _this.props.logger, _this.props.client);
        });
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($eyuDe)))(FabricElementsListener, _React$Component);
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(FabricElementsListener, [
        {
            key: "render",
            value: function render() {
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $38rNl.default), {
                    onEvent: this.handleEventWrapper,
                    channel: (0, $2H1dZ.FabricChannel).elements
                }, this.props.children);
            }
        }
    ]);
}((0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).Component);

});
parcelRegister("38rNl", function(module, exports) {
$parcel$export(module.exports, "default", () => $2487adf41c3e7a47$export$2e2bcd8739ae039);

var $5FkrB = parcelRequire("5FkrB");

var $9Zzpd = parcelRequire("9Zzpd");

var $5OYzN = parcelRequire("5OYzN");

var $cWxjb = parcelRequire("cWxjb");

var $f6l8Z = parcelRequire("f6l8Z");
var $2487adf41c3e7a47$var$AnalyticsListener = function AnalyticsListener(props) {
    var isModernContext = (0, $5OYzN.default) || (0, $9Zzpd.fg)('analytics-next-use-legacy-context') === false;
    return isModernContext ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $f6l8Z.default), props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $cWxjb.default), props);
};
var $2487adf41c3e7a47$export$2e2bcd8739ae039 = $2487adf41c3e7a47$var$AnalyticsListener;

});
parcelRegister("5OYzN", function(module, exports) {
$parcel$export(module.exports, "default", () => $43d09c73bd9ee73c$export$2e2bcd8739ae039);

var $3ZMUU = parcelRequire("3ZMUU");
var $43d09c73bd9ee73c$var$_process$env;
var /// <reference types="node" />
$43d09c73bd9ee73c$export$2e2bcd8739ae039 = typeof $3ZMUU !== 'undefined' && $3ZMUU !== null && (($43d09c73bd9ee73c$var$_process$env = {}, $43d09c73bd9ee73c$var$_process$env === void 0) ? void 0 : $43d09c73bd9ee73c$var$_process$env['ANALYTICS_NEXT_MODERN_CONTEXT']);

});

parcelRegister("cWxjb", function(module, exports) {
$parcel$export(module.exports, "default", () => $96c4bd3151bc4c70$export$2e2bcd8739ae039);

var $fC8ib = parcelRequire("fC8ib");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $kIXpt = parcelRequire("kIXpt");

var $cYPzS = parcelRequire("cYPzS");

var $eyuDe = parcelRequire("eyuDe");

var $25nEq = parcelRequire("25nEq");

var $5FkrB = parcelRequire("5FkrB");

var $8vJ0V = parcelRequire("8vJ0V");

var $iyyOp = parcelRequire("iyyOp");
function $96c4bd3151bc4c70$var$_callSuper(t, o, e) {
    return o = (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(o), (0, (/*@__PURE__*/$parcel$interopDefault($kIXpt)))(t, $96c4bd3151bc4c70$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(t).constructor) : o.apply(t, e));
}
function $96c4bd3151bc4c70$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($96c4bd3151bc4c70$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $96c4bd3151bc4c70$var$ContextTypes = {
    getAtlaskitAnalyticsEventHandlers: (0, (/*@__PURE__*/$parcel$interopDefault($8vJ0V))).func,
    getAtlaskitAnalyticsContext: (0, (/*@__PURE__*/$parcel$interopDefault($8vJ0V))).func
};
var $96c4bd3151bc4c70$var$noop = function noop() {
    return [];
};
// eslint-disable-next-line @repo/internal/react/no-class-components
var $96c4bd3151bc4c70$var$AnalyticsListener = /*#__PURE__*/ function(_Component) {
    function AnalyticsListener(props) {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, AnalyticsListener);
        _this = $96c4bd3151bc4c70$var$_callSuper(this, AnalyticsListener, [
            props
        ]);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "getChildContext", function() {
            return {
                getAtlaskitAnalyticsEventHandlers: _this.getAnalyticsEventHandlers,
                getAtlaskitAnalyticsContext: _this.getAtlaskitAnalyticsContext
            };
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "getAnalyticsEventHandlers", function() {
            var _this$props = _this.props, channel = _this$props.channel, onEvent = _this$props.onEvent;
            var _this$context$getAtla = _this.context.getAtlaskitAnalyticsEventHandlers, getAtlaskitAnalyticsEventHandlers = _this$context$getAtla === void 0 ? $96c4bd3151bc4c70$var$noop : _this$context$getAtla;
            var handler = function handler(event, eventChannel) {
                if (channel === '*' || channel === eventChannel) onEvent(event, eventChannel);
            };
            return [
                handler
            ].concat((0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(getAtlaskitAnalyticsEventHandlers()));
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "getAtlaskitAnalyticsContext", function() {
            var _this$context$getAtla2 = _this.context.getAtlaskitAnalyticsContext, getAtlaskitAnalyticsContext = _this$context$getAtla2 === void 0 ? $96c4bd3151bc4c70$var$noop : _this$context$getAtla2;
            return getAtlaskitAnalyticsContext();
        });
        _this.contextValue = {
            getAtlaskitAnalyticsContext: _this.getAtlaskitAnalyticsContext,
            getAtlaskitAnalyticsEventHandlers: _this.getAnalyticsEventHandlers
        };
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($eyuDe)))(AnalyticsListener, _Component);
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(AnalyticsListener, [
        {
            key: "render",
            value: function render() {
                var children = this.props.children;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $iyyOp.default).Provider, {
                    value: this.contextValue
                }, children);
            }
        }
    ]);
}((0, $5FkrB.Component));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($96c4bd3151bc4c70$var$AnalyticsListener, "contextTypes", $96c4bd3151bc4c70$var$ContextTypes);
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($96c4bd3151bc4c70$var$AnalyticsListener, "childContextTypes", $96c4bd3151bc4c70$var$ContextTypes);
var $96c4bd3151bc4c70$export$2e2bcd8739ae039 = $96c4bd3151bc4c70$var$AnalyticsListener;

});

parcelRegister("f6l8Z", function(module, exports) {
$parcel$export(module.exports, "default", () => $afe7d153c03f5ac9$export$2e2bcd8739ae039);

var $fC8ib = parcelRequire("fC8ib");

var $5FkrB = parcelRequire("5FkrB");

var $iyyOp = parcelRequire("iyyOp");

var $2bMUu = parcelRequire("2bMUu");

var $5SnFU = parcelRequire("5SnFU");
var $afe7d153c03f5ac9$var$AnalyticsListener = function AnalyticsListener(_ref) {
    var children = _ref.children, channel = _ref.channel, onEvent = _ref.onEvent;
    var _useAnalyticsContext = (0, $2bMUu.useAnalyticsContext)(), _useAnalyticsContext$ = _useAnalyticsContext.getAtlaskitAnalyticsEventHandlers, getAtlaskitAnalyticsEventHandlers = _useAnalyticsContext$ === void 0 ? function() {
        return [];
    } : _useAnalyticsContext$, getAtlaskitAnalyticsContext = _useAnalyticsContext.getAtlaskitAnalyticsContext;
    var onEventRef = (0, $5SnFU.useTrackedRef)(onEvent);
    var channelRef = (0, $5SnFU.useTrackedRef)(channel);
    var getAnalyticsEventHandlers = (0, $5FkrB.useCallback)(function() {
        var thisHandler = function thisHandler(event, eventChannel) {
            if (channelRef.current === '*' || channelRef.current === eventChannel) onEventRef.current(event, eventChannel);
        };
        return [
            thisHandler
        ].concat((0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(getAtlaskitAnalyticsEventHandlers()));
    }, [
        channelRef,
        onEventRef,
        getAtlaskitAnalyticsEventHandlers
    ]);
    var value = (0, $5FkrB.useMemo)(function() {
        return {
            getAtlaskitAnalyticsContext: getAtlaskitAnalyticsContext,
            getAtlaskitAnalyticsEventHandlers: getAnalyticsEventHandlers
        };
    }, [
        getAtlaskitAnalyticsContext,
        getAnalyticsEventHandlers
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $iyyOp.default).Provider, {
        value: value
    }, children);
};
var $afe7d153c03f5ac9$export$2e2bcd8739ae039 = $afe7d153c03f5ac9$var$AnalyticsListener;

});
parcelRegister("5SnFU", function(module, exports) {
$parcel$export(module.exports, "useTrackedRef", () => $44745c3aab68f4b6$export$1d27a74659855e44);

var $5FkrB = parcelRequire("5FkrB");
var $44745c3aab68f4b6$export$1d27a74659855e44 = function useTrackedRef(value) {
    var ref = (0, $5FkrB.useRef)(value);
    ref.current = value;
    return ref;
};

});



parcelRegister("cntcM", function(module, exports) {
$parcel$export(module.exports, "handleEvent", () => $902e4986579d19b7$export$d6e5ca10785815df);

var $6jwcp = parcelRequire("6jwcp");

var $bXbH1 = parcelRequire("bXbH1");
var $902e4986579d19b7$export$d6e5ca10785815df = function handleEvent(event, tags, logger, client) {
    if (!event.payload) return;
    var payload = (0, $bXbH1.processEventPayload)(event, tags);
    (0, $6jwcp.sendEvent)(logger, client)(payload);
};

});
parcelRegister("6jwcp", function(module, exports) {
$parcel$export(module.exports, "sendEvent", () => $498d7e8026c51d18$export$7329bcdc3edcd90e);

var $1Vcia = parcelRequire("1Vcia");
var $498d7e8026c51d18$var$_excluded = [
    "eventType"
];
var $498d7e8026c51d18$var$isPromise = function isPromise(c) {
    return typeof c.then === 'function';
};
var $498d7e8026c51d18$export$7329bcdc3edcd90e = function sendEvent(logger, client) {
    return function(event) {
        if (client) {
            var eventType = event.eventType, gasEvent = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(event, $498d7e8026c51d18$var$_excluded);
            var withClient = function withClient(cb) {
                if ($498d7e8026c51d18$var$isPromise(client)) client.then(cb).catch(function(e) {
                    return logger.warn('There was an error sending the event', e);
                });
                else try {
                    cb(client);
                } catch (e) {
                    logger.warn('There was an error sending the event', e);
                }
            };
            switch(event.eventType){
                case 'ui':
                    logger.debug('Sending UI Event via analytics client', gasEvent);
                    withClient(function(client) {
                        return client.sendUIEvent(gasEvent);
                    });
                    break;
                case 'operational':
                    logger.debug('Sending Operational Event via analytics client', gasEvent);
                    withClient(function(client) {
                        return client.sendOperationalEvent(gasEvent);
                    });
                    break;
                case 'track':
                    logger.debug('Sending Track Event via analytics client', gasEvent);
                    withClient(function(client) {
                        return client.sendTrackEvent(gasEvent);
                    });
                    break;
                case 'screen':
                    logger.debug('Sending Screen Event via analytics client', gasEvent);
                    withClient(function(client) {
                        return client.sendScreenEvent(gasEvent);
                    });
                    break;
                default:
                    logger.error("cannot map eventType ".concat(event.eventType, " to an analytics-web-client function"));
            }
        } else logger.warn('AnalyticsWebClient instance is not provided');
    };
};

});

parcelRegister("bXbH1", function(module, exports) {
$parcel$export(module.exports, "processEventPayload", () => $8b3e465c29f4e35a$export$c37d638b7f2ca192);

var $ekGgq = parcelRequire("ekGgq");

var $fC8ib = parcelRequire("fC8ib");

var $1Vcia = parcelRequire("1Vcia");

var $25nEq = parcelRequire("25nEq");

var $bBV6T = parcelRequire("bBV6T");
parcelRequire("2WYRt");
var $kHFeb = parcelRequire("kHFeb");
var $7fUte = parcelRequire("7fUte");

var $34xOs = parcelRequire("34xOs");

var $cwPdS = parcelRequire("cwPdS");

var $djbX4 = parcelRequire("djbX4");
function $8b3e465c29f4e35a$var$_toPropertyKey(t) {
    var i = $8b3e465c29f4e35a$var$_toPrimitive(t, "string");
    return "symbol" == (0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(i) ? i : i + "";
}
function $8b3e465c29f4e35a$var$_toPrimitive(t, r) {
    if ("object" != (0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $8b3e465c29f4e35a$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $8b3e465c29f4e35a$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $8b3e465c29f4e35a$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $8b3e465c29f4e35a$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $8b3e465c29f4e35a$var$extractFieldsFromContext = function extractFieldsFromContext(fieldsToPick) {
    return function(contexts) {
        return contexts.map(function(ctx) {
            return fieldsToPick.reduce(function(result, key) {
                return ctx[key] ? (0, (/*@__PURE__*/$parcel$interopDefault($34xOs)))(result, (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, key, ctx[key])) : result;
            }, {});
        }).reduce(function(result, item) {
            return (0, (/*@__PURE__*/$parcel$interopDefault($34xOs)))(result, item);
        }, {});
    };
};
var $8b3e465c29f4e35a$var$fieldExtractor = function fieldExtractor(contextKey) {
    return $8b3e465c29f4e35a$var$extractFieldsFromContext([
        'source',
        'objectType',
        'objectId',
        'containerType',
        'containerId',
        contextKey
    ]);
};
var $8b3e465c29f4e35a$var$getContextKey = function getContextKey(tag) {
    switch(tag){
        case 0, $cwPdS.ELEMENTS_TAG:
            return 0, $7fUte.ELEMENTS_CONTEXT;
        case 0, $djbX4.EDITOR_TAG:
            return 0, $kHFeb.EDITOR_CONTEXT;
        default:
            return '';
    }
};
var $8b3e465c29f4e35a$var$updatePayloadWithContext = function updatePayloadWithContext(primaryTag, event) {
    if (event.context.length === 0) return $8b3e465c29f4e35a$var$_objectSpread({
        source: (0, $bBV6T.DEFAULT_SOURCE)
    }, event.payload);
    var contextKey = $8b3e465c29f4e35a$var$getContextKey(primaryTag) || 'attributes';
    var _fieldExtractor = $8b3e465c29f4e35a$var$fieldExtractor(contextKey)(event.context), attributes = _fieldExtractor[contextKey], fields = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_fieldExtractor, [
        contextKey
    ].map($8b3e465c29f4e35a$var$_toPropertyKey));
    if (attributes) event.payload.attributes = (0, (/*@__PURE__*/$parcel$interopDefault($34xOs)))(attributes, event.payload.attributes || {});
    return $8b3e465c29f4e35a$var$_objectSpread($8b3e465c29f4e35a$var$_objectSpread({
        source: (0, $bBV6T.DEFAULT_SOURCE)
    }, fields), event.payload);
};
var $8b3e465c29f4e35a$var$addTags = function addTags(tags) {
    var originalTags = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    var mergedTags = new Set([].concat((0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(originalTags), (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(tags)));
    return Array.from(mergedTags);
};
/**
 * The primary tag is used for matching the analytics event payload
 * with its context.
 */ function $8b3e465c29f4e35a$var$getPrimaryTag(tags) {
    if (typeof tags === 'string') return tags;
    if (!tags.length) throw new Error('Empty tags string array. Unable to match analytics event payload with context');
    return tags[0];
}
var $8b3e465c29f4e35a$export$c37d638b7f2ca192 = function processEventPayload(event, tags) {
    var primaryTag = $8b3e465c29f4e35a$var$getPrimaryTag(tags);
    var tagsArray = typeof tags === 'string' ? [
        tags
    ] : tags;
    return $8b3e465c29f4e35a$var$_objectSpread($8b3e465c29f4e35a$var$_objectSpread({}, $8b3e465c29f4e35a$var$updatePayloadWithContext(primaryTag, event)), {}, {
        tags: $8b3e465c29f4e35a$var$addTags(tagsArray, event.payload.tags)
    });
};

});
parcelRegister("bBV6T", function(module, exports) {
$parcel$export(module.exports, "UI_EVENT_TYPE", () => $873f7350fa85064d$export$a1562d08625f5d7e);
$parcel$export(module.exports, "TRACK_EVENT_TYPE", () => $873f7350fa85064d$export$947dac6c72b26f81);
$parcel$export(module.exports, "SCREEN_EVENT_TYPE", () => $873f7350fa85064d$export$f1d537d508d2945a);
$parcel$export(module.exports, "OPERATIONAL_EVENT_TYPE", () => $873f7350fa85064d$export$12346a674644c156);
$parcel$export(module.exports, "DEFAULT_SOURCE", () => $873f7350fa85064d$export$b055de0e665cb20c);
// same types defined in analytics-web-client but avoid creating dependency with that
var $873f7350fa85064d$export$a1562d08625f5d7e = 'ui';
var $873f7350fa85064d$export$947dac6c72b26f81 = 'track';
var $873f7350fa85064d$export$f1d537d508d2945a = 'screen';
var $873f7350fa85064d$export$12346a674644c156 = 'operational';
var $873f7350fa85064d$export$b055de0e665cb20c = 'unknown';

});

parcelRegister("34xOs", function(module, exports) {

var $gevq4 = parcelRequire("gevq4");

var $agSaC = parcelRequire("agSaC");
/**
 * This method is like `_.assign` except that it recursively merges own and
 * inherited enumerable string keyed properties of source objects into the
 * destination object. Source properties that resolve to `undefined` are
 * skipped if a destination value exists. Array and plain object properties
 * are merged recursively. Other objects and value types are overridden by
 * assignment. Source objects are applied from left to right. Subsequent
 * sources overwrite property assignments of previous sources.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 0.5.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = {
 *   'a': [{ 'b': 2 }, { 'd': 4 }]
 * };
 *
 * var other = {
 *   'a': [{ 'c': 3 }, { 'e': 5 }]
 * };
 *
 * _.merge(object, other);
 * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
 */ var $23cbf95b84c28d93$var$merge = $agSaC(function(object, source, srcIndex) {
    $gevq4(object, source, srcIndex);
});
module.exports = $23cbf95b84c28d93$var$merge;

});
parcelRegister("gevq4", function(module, exports) {

var $7kqkb = parcelRequire("7kqkb");

var $8K1SY = parcelRequire("8K1SY");

var $I4Pc3 = parcelRequire("I4Pc3");

var $2IzzJ = parcelRequire("2IzzJ");

var $lIhLB = parcelRequire("lIhLB");

var $5audB = parcelRequire("5audB");

var $3w9wx = parcelRequire("3w9wx");
/**
 * The base implementation of `_.merge` without support for multiple sources.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} [customizer] The function to customize merged values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */ function $bd165363e9b28225$var$baseMerge(object, source, srcIndex, customizer, stack) {
    if (object === source) return;
    $I4Pc3(source, function(srcValue, key) {
        stack || (stack = new $7kqkb);
        if ($lIhLB(srcValue)) $2IzzJ(object, source, key, srcIndex, $bd165363e9b28225$var$baseMerge, customizer, stack);
        else {
            var newValue = customizer ? customizer($3w9wx(object, key), srcValue, key + '', object, source, stack) : undefined;
            if (newValue === undefined) newValue = srcValue;
            $8K1SY(object, key, newValue);
        }
    }, $5audB);
}
module.exports = $bd165363e9b28225$var$baseMerge;

});
parcelRegister("8K1SY", function(module, exports) {

var $dJvo4 = parcelRequire("dJvo4");

var $grAle = parcelRequire("grAle");
/**
 * This function is like `assignValue` except that it doesn't assign
 * `undefined` values.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $65d41514458e3dbd$var$assignMergeValue(object, key, value) {
    if (value !== undefined && !$grAle(object[key], value) || value === undefined && !(key in object)) $dJvo4(object, key, value);
}
module.exports = $65d41514458e3dbd$var$assignMergeValue;

});

parcelRegister("I4Pc3", function(module, exports) {

var $f5Ew3 = parcelRequire("f5Ew3");
/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */ var $0847da42a0f21624$var$baseFor = $f5Ew3();
module.exports = $0847da42a0f21624$var$baseFor;

});
parcelRegister("f5Ew3", function(module, exports) {
/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function $afc6c042c81b48d4$var$createBaseFor(fromRight) {
    return function(object, iteratee, keysFunc) {
        var index = -1, iterable = Object(object), props = keysFunc(object), length = props.length;
        while(length--){
            var key = props[fromRight ? length : ++index];
            if (iteratee(iterable[key], key, iterable) === false) break;
        }
        return object;
    };
}
module.exports = $afc6c042c81b48d4$var$createBaseFor;

});


parcelRegister("2IzzJ", function(module, exports) {

var $8K1SY = parcelRequire("8K1SY");

var $j6ksh = parcelRequire("j6ksh");

var $2zq4B = parcelRequire("2zq4B");

var $fmYao = parcelRequire("fmYao");

var $dv0bv = parcelRequire("dv0bv");

var $bB85C = parcelRequire("bB85C");

var $4vMNO = parcelRequire("4vMNO");

var $31tsY = parcelRequire("31tsY");

var $hKJGr = parcelRequire("hKJGr");

var $78AO6 = parcelRequire("78AO6");

var $lIhLB = parcelRequire("lIhLB");

var $73f6r = parcelRequire("73f6r");

var $35WaP = parcelRequire("35WaP");

var $3w9wx = parcelRequire("3w9wx");

var $8rwQe = parcelRequire("8rwQe");
/**
 * A specialized version of `baseMerge` for arrays and objects which performs
 * deep merges and tracks traversed objects enabling objects with circular
 * references to be merged.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {string} key The key of the value to merge.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} mergeFunc The function to merge values.
 * @param {Function} [customizer] The function to customize assigned values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */ function $1fab4958865b5bfe$var$baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
    var objValue = $3w9wx(object, key), srcValue = $3w9wx(source, key), stacked = stack.get(srcValue);
    if (stacked) {
        $8K1SY(object, key, stacked);
        return;
    }
    var newValue = customizer ? customizer(objValue, srcValue, key + '', object, source, stack) : undefined;
    var isCommon = newValue === undefined;
    if (isCommon) {
        var isArr = $4vMNO(srcValue), isBuff = !isArr && $hKJGr(srcValue), isTyped = !isArr && !isBuff && $35WaP(srcValue);
        newValue = srcValue;
        if (isArr || isBuff || isTyped) {
            if ($4vMNO(objValue)) newValue = objValue;
            else if ($31tsY(objValue)) newValue = $fmYao(objValue);
            else if (isBuff) {
                isCommon = false;
                newValue = $j6ksh(srcValue, true);
            } else if (isTyped) {
                isCommon = false;
                newValue = $2zq4B(srcValue, true);
            } else newValue = [];
        } else if ($73f6r(srcValue) || $bB85C(srcValue)) {
            newValue = objValue;
            if ($bB85C(objValue)) newValue = $8rwQe(objValue);
            else if (!$lIhLB(objValue) || $78AO6(objValue)) newValue = $dv0bv(srcValue);
        } else isCommon = false;
    }
    if (isCommon) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, newValue);
        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
        stack['delete'](srcValue);
    }
    $8K1SY(object, key, newValue);
}
module.exports = $1fab4958865b5bfe$var$baseMergeDeep;

});
parcelRegister("j6ksh", function(module, exports) {

var $iXqsg = parcelRequire("iXqsg");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? $iXqsg.Buffer : undefined, allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;
/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */ function cloneBuffer(buffer, isDeep) {
    if (isDeep) return buffer.slice();
    var length = buffer.length, result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
    buffer.copy(result);
    return result;
}
module.exports = cloneBuffer;

});

parcelRegister("2zq4B", function(module, exports) {

var $eVLFU = parcelRequire("eVLFU");
/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */ function $1df3133ee8c949b9$var$cloneTypedArray(typedArray, isDeep) {
    var buffer = isDeep ? $eVLFU(typedArray.buffer) : typedArray.buffer;
    return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}
module.exports = $1df3133ee8c949b9$var$cloneTypedArray;

});
parcelRegister("eVLFU", function(module, exports) {

var $e4K2f = parcelRequire("e4K2f");
/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */ function $adeb5ed5aa7d0742$var$cloneArrayBuffer(arrayBuffer) {
    var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
    new $e4K2f(result).set(new $e4K2f(arrayBuffer));
    return result;
}
module.exports = $adeb5ed5aa7d0742$var$cloneArrayBuffer;

});


parcelRegister("fmYao", function(module, exports) {
/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */ function $b30794eb54e786e6$var$copyArray(source, array) {
    var index = -1, length = source.length;
    array || (array = Array(length));
    while(++index < length)array[index] = source[index];
    return array;
}
module.exports = $b30794eb54e786e6$var$copyArray;

});

parcelRegister("dv0bv", function(module, exports) {

var $kgZjv = parcelRequire("kgZjv");

var $1RKpC = parcelRequire("1RKpC");

var $8wFaN = parcelRequire("8wFaN");
/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */ function $9d3e5049c4170ee8$var$initCloneObject(object) {
    return typeof object.constructor == 'function' && !$8wFaN(object) ? $kgZjv($1RKpC(object)) : {};
}
module.exports = $9d3e5049c4170ee8$var$initCloneObject;

});
parcelRegister("kgZjv", function(module, exports) {

var $lIhLB = parcelRequire("lIhLB");
/** Built-in value references. */ var $ec24dcdbed245355$var$objectCreate = Object.create;
/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */ var $ec24dcdbed245355$var$baseCreate = function() {
    function object() {}
    return function(proto) {
        if (!$lIhLB(proto)) return {};
        if ($ec24dcdbed245355$var$objectCreate) return $ec24dcdbed245355$var$objectCreate(proto);
        object.prototype = proto;
        var result = new object;
        object.prototype = undefined;
        return result;
    };
}();
module.exports = $ec24dcdbed245355$var$baseCreate;

});

parcelRegister("1RKpC", function(module, exports) {

var $gFyuD = parcelRequire("gFyuD");
/** Built-in value references. */ var $15bebe32b0072eb8$var$getPrototype = $gFyuD(Object.getPrototypeOf, Object);
module.exports = $15bebe32b0072eb8$var$getPrototype;

});


parcelRegister("31tsY", function(module, exports) {

var $8Ak9r = parcelRequire("8Ak9r");

var $9Msco = parcelRequire("9Msco");
/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */ function $23385281683e9541$var$isArrayLikeObject(value) {
    return $9Msco(value) && $8Ak9r(value);
}
module.exports = $23385281683e9541$var$isArrayLikeObject;

});

parcelRegister("73f6r", function(module, exports) {

var $7Vpf7 = parcelRequire("7Vpf7");

var $1RKpC = parcelRequire("1RKpC");

var $9Msco = parcelRequire("9Msco");
/** `Object#toString` result references. */ var $5224875582d0d97d$var$objectTag = '[object Object]';
/** Used for built-in method references. */ var $5224875582d0d97d$var$funcProto = Function.prototype, $5224875582d0d97d$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $5224875582d0d97d$var$funcToString = $5224875582d0d97d$var$funcProto.toString;
/** Used to check objects for own properties. */ var $5224875582d0d97d$var$hasOwnProperty = $5224875582d0d97d$var$objectProto.hasOwnProperty;
/** Used to infer the `Object` constructor. */ var $5224875582d0d97d$var$objectCtorString = $5224875582d0d97d$var$funcToString.call(Object);
/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */ function $5224875582d0d97d$var$isPlainObject(value) {
    if (!$9Msco(value) || $7Vpf7(value) != $5224875582d0d97d$var$objectTag) return false;
    var proto = $1RKpC(value);
    if (proto === null) return true;
    var Ctor = $5224875582d0d97d$var$hasOwnProperty.call(proto, 'constructor') && proto.constructor;
    return typeof Ctor == 'function' && Ctor instanceof Ctor && $5224875582d0d97d$var$funcToString.call(Ctor) == $5224875582d0d97d$var$objectCtorString;
}
module.exports = $5224875582d0d97d$var$isPlainObject;

});

parcelRegister("3w9wx", function(module, exports) {
/**
 * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function $28fbbf771d703bea$var$safeGet(object, key) {
    if (key === 'constructor' && typeof object[key] === 'function') return;
    if (key == '__proto__') return;
    return object[key];
}
module.exports = $28fbbf771d703bea$var$safeGet;

});

parcelRegister("8rwQe", function(module, exports) {

var $5Azvw = parcelRequire("5Azvw");

var $5audB = parcelRequire("5audB");
/**
 * Converts `value` to a plain object flattening inherited enumerable string
 * keyed properties of `value` to own properties of the plain object.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {Object} Returns the converted plain object.
 * @example
 *
 * function Foo() {
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.assign({ 'a': 1 }, new Foo);
 * // => { 'a': 1, 'b': 2 }
 *
 * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
 * // => { 'a': 1, 'b': 2, 'c': 3 }
 */ function $625a51fd953bf994$var$toPlainObject(value) {
    return $5Azvw(value, $5audB(value));
}
module.exports = $625a51fd953bf994$var$toPlainObject;

});
parcelRegister("5Azvw", function(module, exports) {

var $3vX86 = parcelRequire("3vX86");

var $dJvo4 = parcelRequire("dJvo4");
/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */ function $411bdb90c603afe0$var$copyObject(source, props, object, customizer) {
    var isNew = !object;
    object || (object = {});
    var index = -1, length = props.length;
    while(++index < length){
        var key = props[index];
        var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
        if (newValue === undefined) newValue = source[key];
        if (isNew) $dJvo4(object, key, newValue);
        else $3vX86(object, key, newValue);
    }
    return object;
}
module.exports = $411bdb90c603afe0$var$copyObject;

});

parcelRegister("5audB", function(module, exports) {

var $5WR7T = parcelRequire("5WR7T");

var $wQj4D = parcelRequire("wQj4D");

var $8Ak9r = parcelRequire("8Ak9r");
/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */ function $3c3553ab2cfb701a$var$keysIn(object) {
    return $8Ak9r(object) ? $5WR7T(object, true) : $wQj4D(object);
}
module.exports = $3c3553ab2cfb701a$var$keysIn;

});
parcelRegister("wQj4D", function(module, exports) {

var $lIhLB = parcelRequire("lIhLB");

var $8wFaN = parcelRequire("8wFaN");

var $lBijS = parcelRequire("lBijS");
/** Used for built-in method references. */ var $062b904884fa4af3$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $062b904884fa4af3$var$hasOwnProperty = $062b904884fa4af3$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $062b904884fa4af3$var$baseKeysIn(object) {
    if (!$lIhLB(object)) return $lBijS(object);
    var isProto = $8wFaN(object), result = [];
    for(var key in object)if (!(key == 'constructor' && (isProto || !$062b904884fa4af3$var$hasOwnProperty.call(object, key)))) result.push(key);
    return result;
}
module.exports = $062b904884fa4af3$var$baseKeysIn;

});
parcelRegister("lBijS", function(module, exports) {
/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $fb9b43925d49aa79$var$nativeKeysIn(object) {
    var result = [];
    if (object != null) for(var key in Object(object))result.push(key);
    return result;
}
module.exports = $fb9b43925d49aa79$var$nativeKeysIn;

});






parcelRegister("agSaC", function(module, exports) {

var $gjysd = parcelRequire("gjysd");

var $dYQO9 = parcelRequire("dYQO9");
/**
 * Creates a function like `_.assign`.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */ function $77a56b17e87551b2$var$createAssigner(assigner) {
    return $gjysd(function(object, sources) {
        var index = -1, length = sources.length, customizer = length > 1 ? sources[length - 1] : undefined, guard = length > 2 ? sources[2] : undefined;
        customizer = assigner.length > 3 && typeof customizer == 'function' ? (length--, customizer) : undefined;
        if (guard && $dYQO9(sources[0], sources[1], guard)) {
            customizer = length < 3 ? undefined : customizer;
            length = 1;
        }
        object = Object(object);
        while(++index < length){
            var source = sources[index];
            if (source) assigner(object, source, index, customizer);
        }
        return object;
    });
}
module.exports = $77a56b17e87551b2$var$createAssigner;

});
parcelRegister("gjysd", function(module, exports) {

var $4XdzH = parcelRequire("4XdzH");

var $au8Mg = parcelRequire("au8Mg");

var $aUUF1 = parcelRequire("aUUF1");
/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */ function $be09258e8cb85ece$var$baseRest(func, start) {
    return $aUUF1($au8Mg(func, start, $4XdzH), func + '');
}
module.exports = $be09258e8cb85ece$var$baseRest;

});
parcelRegister("au8Mg", function(module, exports) {

var $g9N2L = parcelRequire("g9N2L");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $7a2383c334b5bbef$var$nativeMax = Math.max;
/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */ function $7a2383c334b5bbef$var$overRest(func, start, transform) {
    start = $7a2383c334b5bbef$var$nativeMax(start === undefined ? func.length - 1 : start, 0);
    return function() {
        var args = arguments, index = -1, length = $7a2383c334b5bbef$var$nativeMax(args.length - start, 0), array = Array(length);
        while(++index < length)array[index] = args[start + index];
        index = -1;
        var otherArgs = Array(start + 1);
        while(++index < start)otherArgs[index] = args[index];
        otherArgs[start] = transform(array);
        return $g9N2L(func, this, otherArgs);
    };
}
module.exports = $7a2383c334b5bbef$var$overRest;

});
parcelRegister("g9N2L", function(module, exports) {
/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */ function $bc3387a2527054dc$var$apply(func, thisArg, args) {
    switch(args.length){
        case 0:
            return func.call(thisArg);
        case 1:
            return func.call(thisArg, args[0]);
        case 2:
            return func.call(thisArg, args[0], args[1]);
        case 3:
            return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
}
module.exports = $bc3387a2527054dc$var$apply;

});


parcelRegister("aUUF1", function(module, exports) {

var $dO7h6 = parcelRequire("dO7h6");

var $lVQUY = parcelRequire("lVQUY");
/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */ var $7f2b15f395e77d38$var$setToString = $lVQUY($dO7h6);
module.exports = $7f2b15f395e77d38$var$setToString;

});
parcelRegister("dO7h6", function(module, exports) {

var $jyO4X = parcelRequire("jyO4X");

var $hDKHs = parcelRequire("hDKHs");

var $4XdzH = parcelRequire("4XdzH");
/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */ var $a0d596876eeacc09$var$baseSetToString = !$hDKHs ? $4XdzH : function(func, string) {
    return $hDKHs(func, 'toString', {
        'configurable': true,
        'enumerable': false,
        'value': $jyO4X(string),
        'writable': true
    });
};
module.exports = $a0d596876eeacc09$var$baseSetToString;

});
parcelRegister("jyO4X", function(module, exports) {
/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */ function $e3d809f51e95a709$var$constant(value) {
    return function() {
        return value;
    };
}
module.exports = $e3d809f51e95a709$var$constant;

});


parcelRegister("lVQUY", function(module, exports) {
/** Used to detect hot functions by number of calls within a span of milliseconds. */ var $ff77f83e8f062c24$var$HOT_COUNT = 800, $ff77f83e8f062c24$var$HOT_SPAN = 16;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $ff77f83e8f062c24$var$nativeNow = Date.now;
/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */ function $ff77f83e8f062c24$var$shortOut(func) {
    var count = 0, lastCalled = 0;
    return function() {
        var stamp = $ff77f83e8f062c24$var$nativeNow(), remaining = $ff77f83e8f062c24$var$HOT_SPAN - (stamp - lastCalled);
        lastCalled = stamp;
        if (remaining > 0) {
            if (++count >= $ff77f83e8f062c24$var$HOT_COUNT) return arguments[0];
        } else count = 0;
        return func.apply(undefined, arguments);
    };
}
module.exports = $ff77f83e8f062c24$var$shortOut;

});



parcelRegister("dYQO9", function(module, exports) {

var $grAle = parcelRequire("grAle");

var $8Ak9r = parcelRequire("8Ak9r");

var $kgLdF = parcelRequire("kgLdF");

var $lIhLB = parcelRequire("lIhLB");
/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */ function $a2d9d77c359ebd19$var$isIterateeCall(value, index, object) {
    if (!$lIhLB(object)) return false;
    var type = typeof index;
    if (type == 'number' ? $8Ak9r(object) && $kgLdF(index, object.length) : type == 'string' && index in object) return $grAle(object[index], value);
    return false;
}
module.exports = $a2d9d77c359ebd19$var$isIterateeCall;

});



parcelRegister("djbX4", function(module, exports) {
$parcel$export(module.exports, "EDITOR_TAG", () => $9b065214bccd5d42$export$a1d9dc589a29b3aa);
$parcel$export(module.exports, "default", () => $9b065214bccd5d42$export$2e2bcd8739ae039);

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $kIXpt = parcelRequire("kIXpt");

var $cYPzS = parcelRequire("cYPzS");

var $eyuDe = parcelRequire("eyuDe");

var $25nEq = parcelRequire("25nEq");

var $5FkrB = parcelRequire("5FkrB");

var $38rNl = parcelRequire("38rNl");

var $2H1dZ = parcelRequire("2H1dZ");

var $cntcM = parcelRequire("cntcM");
function $9b065214bccd5d42$var$_callSuper(t, o, e) {
    return o = (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(o), (0, (/*@__PURE__*/$parcel$interopDefault($kIXpt)))(t, $9b065214bccd5d42$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(t).constructor) : o.apply(t, e));
}
function $9b065214bccd5d42$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($9b065214bccd5d42$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $9b065214bccd5d42$export$a1d9dc589a29b3aa = 'editor';
var $9b065214bccd5d42$export$8aa0d788f94a809 = 'fabricEditor';
var $9b065214bccd5d42$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_React$Component) {
    function FabricEditorListener() {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, FabricEditorListener);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = $9b065214bccd5d42$var$_callSuper(this, FabricEditorListener, [].concat(args));
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "handleEventWrapper", function(event) {
            (0, $cntcM.handleEvent)(event, [
                $9b065214bccd5d42$export$a1d9dc589a29b3aa,
                $9b065214bccd5d42$export$8aa0d788f94a809
            ], _this.props.logger, _this.props.client);
        });
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($eyuDe)))(FabricEditorListener, _React$Component);
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(FabricEditorListener, [
        {
            key: "render",
            value: function render() {
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $38rNl.default), {
                    onEvent: this.handleEventWrapper,
                    channel: (0, $2H1dZ.FabricChannel).editor
                }, this.props.children);
            }
        }
    ]);
}((0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).Component);

});




parcelRegister("iIobB", function(module, exports) {
$parcel$export(module.exports, "default", () => $d9ff18ec55cbdbe5$export$2e2bcd8739ae039);

var $kqp0i = parcelRequire("kqp0i");

var $5FkrB = parcelRequire("5FkrB");

var $2H1dZ = parcelRequire("2H1dZ");

var $cTH1h = parcelRequire("cTH1h");

var $aDmPS = parcelRequire("aDmPS");
function $d9ff18ec55cbdbe5$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $aDmPS.default), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, props, {
        channel: (0, $2H1dZ.FabricChannel).atlaskit,
        processEvent: (0, $cTH1h.default)
    }));
}

});
parcelRegister("cTH1h", function(module, exports) {
$parcel$export(module.exports, "default", () => $963bfdeb2c1d954d$export$2e2bcd8739ae039);

var $25nEq = parcelRequire("25nEq");

var $eBFOC = parcelRequire("eBFOC");

var $34xOs = parcelRequire("34xOs");

var $bBV6T = parcelRequire("bBV6T");

var $8TkFc = parcelRequire("8TkFc");
function $963bfdeb2c1d954d$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $963bfdeb2c1d954d$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $963bfdeb2c1d954d$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $963bfdeb2c1d954d$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $963bfdeb2c1d954d$var$ATLASKIT_TAG = 'atlaskit';
var $963bfdeb2c1d954d$var$listenerVersion = "0.0.0-development";
var /**
 * This util exists to convert the Atlaskit event format into the analytics platform format.
 *
 * Atlaskit event format:
 * event {
 *      payload: {
 *          ...attributesFromLowestPointInTheTree
 *      },
 *      context: [{
 *          ...attributesFromHighestPointInTheTree
 *      }, {
 *          ...attributesFromSecondHighestPointInTheTree
 *      }]
 * }
 *
 * Analytics platform event format:
 *  event {
 *      type: @atlaskit/analytics-gas-types.EventType
 *      payload {
 *          ...mandatoryAttributesBasedOnEventType
 *          attributes: {
 *              ...arbitraryAttributes
 *          }
 *      }
 *  }
 */ $963bfdeb2c1d954d$export$2e2bcd8739ae039 = function(event, logger) {
    var sources = (0, $8TkFc.getSources)(event);
    var source = (0, (/*@__PURE__*/$parcel$interopDefault($eBFOC)))(sources) || (0, $bBV6T.DEFAULT_SOURCE);
    var extraAttributes = (0, $8TkFc.getExtraAttributes)(event);
    var components = (0, $8TkFc.getComponents)(event);
    var _ref = (0, (/*@__PURE__*/$parcel$interopDefault($eBFOC)))((0, $8TkFc.getPackageInfo)(event)) || {}, packageName = _ref.packageName, packageVersion = _ref.packageVersion;
    var _event$payload = event.payload, _event$payload$eventT = _event$payload.eventType, eventType = _event$payload$eventT === void 0 ? (0, $bBV6T.UI_EVENT_TYPE) : _event$payload$eventT, action = _event$payload.action, actionSubjectId = _event$payload.actionSubjectId, payloadAttributes = _event$payload.attributes, containerId = _event$payload.containerId;
    var attributes = $963bfdeb2c1d954d$var$_objectSpread($963bfdeb2c1d954d$var$_objectSpread({
        listenerVersion: $963bfdeb2c1d954d$var$listenerVersion,
        sourceHierarchy: sources.join('.') || undefined,
        componentHierarchy: components.join('.') || undefined,
        packageHierarchy: (0, $8TkFc.getPackageHierarchy)(event) || undefined
    }, {
        packageName: packageName,
        packageVersion: packageVersion
    }), (0, (/*@__PURE__*/$parcel$interopDefault($34xOs)))(extraAttributes, payloadAttributes));
    // Ensure atlaskit tag is not duplicated by using Set
    var tags = new Set(event.payload.tags || []);
    tags.add($963bfdeb2c1d954d$var$ATLASKIT_TAG);
    if (event.payload) {
        if (eventType === (0, $bBV6T.UI_EVENT_TYPE)) return {
            eventType: eventType,
            source: source,
            actionSubject: (0, $8TkFc.getActionSubject)(event),
            action: action,
            actionSubjectId: actionSubjectId,
            attributes: attributes,
            containerId: containerId,
            tags: Array.from(tags)
        };
        if (eventType === (0, $bBV6T.TRACK_EVENT_TYPE) || eventType === (0, $bBV6T.OPERATIONAL_EVENT_TYPE) || eventType === (0, $bBV6T.SCREEN_EVENT_TYPE)) logger.error('Track, screen and operational events are currently not supported for atlaskit events');
        else logger.error('Invalid event type', eventType);
    }
    return null;
};

});
parcelRegister("eBFOC", function(module, exports) {
/**
 * Gets the last element of `array`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to query.
 * @returns {*} Returns the last element of `array`.
 * @example
 *
 * _.last([1, 2, 3]);
 * // => 3
 */ function $aa24f50d0b0a109e$var$last(array) {
    var length = array == null ? 0 : array.length;
    return length ? array[length - 1] : undefined;
}
module.exports = $aa24f50d0b0a109e$var$last;

});

parcelRegister("8TkFc", function(module, exports) {
$parcel$export(module.exports, "extractFromEventContext", () => $67937d1e560f6e35$export$9b947b4502cd2705);
$parcel$export(module.exports, "getActionSubject", () => $67937d1e560f6e35$export$6f40cdf6d42c018d);
$parcel$export(module.exports, "getSources", () => $67937d1e560f6e35$export$5f9bc633b116660f);
$parcel$export(module.exports, "getComponents", () => $67937d1e560f6e35$export$4e811121b221213b);
$parcel$export(module.exports, "getExtraAttributes", () => $67937d1e560f6e35$export$67c3590839ebecdd);
$parcel$export(module.exports, "getPackageInfo", () => $67937d1e560f6e35$export$cd17d76da7967240);
$parcel$export(module.exports, "getPackageHierarchy", () => $67937d1e560f6e35$export$4e0b83da1896ebc7);
/**
 * Largely taken from analytics-web-react
 */ 
var $34xOs = parcelRequire("34xOs");
var $67937d1e560f6e35$export$9b947b4502cd2705 = function extractFromEventContext(propertyName, event) {
    return event.context.map(function(contextItem) {
        return contextItem[propertyName];
    }).filter(Boolean);
};
var $67937d1e560f6e35$export$6f40cdf6d42c018d = function getActionSubject(event) {
    var overrides = $67937d1e560f6e35$export$9b947b4502cd2705('actionSubjectOverride', event);
    var closestContext = event.context.length > 0 ? event.context[event.context.length - 1] : {};
    var actionSubject = event.payload.actionSubject || closestContext.component;
    return overrides.length > 0 ? overrides[0] : actionSubject;
};
var $67937d1e560f6e35$export$5f9bc633b116660f = function getSources(event) {
    return $67937d1e560f6e35$export$9b947b4502cd2705('source', event);
};
var $67937d1e560f6e35$export$4e811121b221213b = function getComponents(event) {
    return $67937d1e560f6e35$export$9b947b4502cd2705('component', event);
};
var $67937d1e560f6e35$export$67c3590839ebecdd = function getExtraAttributes(event) {
    return $67937d1e560f6e35$export$9b947b4502cd2705('attributes', event).reduce(function(result, extraAttributes) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($34xOs)))(result, extraAttributes);
    }, {});
};
var $67937d1e560f6e35$export$cd17d76da7967240 = function getPackageInfo(event) {
    return event.context.map(function(contextItem) {
        return {
            packageName: contextItem.packageName,
            packageVersion: contextItem.packageVersion
        };
    }).filter(function(p) {
        return p.packageName;
    });
};
var $67937d1e560f6e35$export$18cd124b5098d330 = function getPackageVersion(event) {
    return $67937d1e560f6e35$export$9b947b4502cd2705('packageVersion', event);
};
function $67937d1e560f6e35$export$4e0b83da1896ebc7(event) {
    var packages = $67937d1e560f6e35$export$cd17d76da7967240(event) || [];
    return packages.map(function(p) {
        return p.packageVersion ? "".concat(p.packageName, "@").concat(p.packageVersion) : p.packageName;
    }).join(',') || undefined;
}

});


parcelRegister("aDmPS", function(module, exports) {
$parcel$export(module.exports, "default", () => $7bdf4298d4e38f0c$export$2e2bcd8739ae039);

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $kIXpt = parcelRequire("kIXpt");

var $cYPzS = parcelRequire("cYPzS");

var $eyuDe = parcelRequire("eyuDe");

var $25nEq = parcelRequire("25nEq");

var $5FkrB = parcelRequire("5FkrB");

var $38rNl = parcelRequire("38rNl");

var $6jwcp = parcelRequire("6jwcp");
function $7bdf4298d4e38f0c$var$_callSuper(t, o, e) {
    return o = (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(o), (0, (/*@__PURE__*/$parcel$interopDefault($kIXpt)))(t, $7bdf4298d4e38f0c$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(t).constructor) : o.apply(t, e));
}
function $7bdf4298d4e38f0c$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($7bdf4298d4e38f0c$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $7bdf4298d4e38f0c$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_React$Component) {
    function GenericAnalyticsListener() {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, GenericAnalyticsListener);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = $7bdf4298d4e38f0c$var$_callSuper(this, GenericAnalyticsListener, [].concat(args));
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "listenerHandler", function(event) {
            var _this$props = _this.props, client = _this$props.client, logger = _this$props.logger, channel = _this$props.channel, processEvent = _this$props.processEvent;
            if (!event.payload) return;
            logger.debug("Received ".concat(channel, " event"), event);
            var payload = processEvent(event, logger);
            logger.debug("Processed ".concat(channel, " event"), payload);
            if (payload) (0, $6jwcp.sendEvent)(logger, client)(payload);
        });
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($eyuDe)))(GenericAnalyticsListener, _React$Component);
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(GenericAnalyticsListener, [
        {
            key: "render",
            value: function render() {
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $38rNl.default), {
                    onEvent: this.listenerHandler,
                    channel: this.props.channel
                }, this.props.children);
            }
        }
    ]);
}((0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).Component);

});


parcelRegister("gLrwD", function(module, exports) {
$parcel$export(module.exports, "default", () => $c346631c19c74027$export$2e2bcd8739ae039);

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $25nEq = parcelRequire("25nEq");
var $c346631c19c74027$export$ffe0c436e29512cf = {
    DEBUG: 0,
    INFO: 1,
    WARN: 2,
    ERROR: 3,
    OFF: 4
};
var $c346631c19c74027$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function Logger() {
        var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, logLevel = _ref.logLevel;
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, Logger);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "logLevel", $c346631c19c74027$export$ffe0c436e29512cf.OFF);
        if (typeof logLevel === 'number') this.setLogLevel(logLevel);
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(Logger, [
        {
            key: "setLogLevel",
            value: function setLogLevel(logLevel) {
                if (logLevel >= $c346631c19c74027$export$ffe0c436e29512cf.DEBUG && logLevel <= $c346631c19c74027$export$ffe0c436e29512cf.OFF) this.logLevel = +logLevel;
                else this.logLevel = $c346631c19c74027$export$ffe0c436e29512cf.OFF;
            }
        },
        {
            key: "logMessage",
            value: function logMessage(level, type) {
                if (level >= this.logLevel) {
                    var _console;
                    for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)args[_key - 2] = arguments[_key];
                    (_console = console)[type].apply(_console, args);
                }
            }
        },
        {
            key: "debug",
            value: function debug() {
                for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
                this.logMessage.apply(this, [
                    $c346631c19c74027$export$ffe0c436e29512cf.DEBUG,
                    'log'
                ].concat(args));
            }
        },
        {
            key: "info",
            value: function info() {
                for(var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++)args[_key3] = arguments[_key3];
                this.logMessage.apply(this, [
                    $c346631c19c74027$export$ffe0c436e29512cf.INFO,
                    'info'
                ].concat(args));
            }
        },
        {
            key: "warn",
            value: function warn() {
                for(var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++)args[_key4] = arguments[_key4];
                this.logMessage.apply(this, [
                    $c346631c19c74027$export$ffe0c436e29512cf.WARN,
                    'warn'
                ].concat(args));
            }
        },
        {
            key: "error",
            value: function error() {
                for(var _len5 = arguments.length, args = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++)args[_key5] = arguments[_key5];
                this.logMessage.apply(this, [
                    $c346631c19c74027$export$ffe0c436e29512cf.ERROR,
                    'error'
                ].concat(args));
            }
        }
    ]);
}();

});

parcelRegister("e8sqz", function(module, exports) {
$parcel$export(module.exports, "default", () => $a4a7dd2caff495de$export$2e2bcd8739ae039);

var $kqp0i = parcelRequire("kqp0i");

var $5FkrB = parcelRequire("5FkrB");

var $2H1dZ = parcelRequire("2H1dZ");

var $c1Pfl = parcelRequire("c1Pfl");

var $aDmPS = parcelRequire("aDmPS");
function $a4a7dd2caff495de$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $aDmPS.default), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, props, {
        channel: (0, $2H1dZ.FabricChannel).navigation,
        processEvent: (0, $c1Pfl.default)
    }));
}

});
parcelRegister("c1Pfl", function(module, exports) {
$parcel$export(module.exports, "default", () => $8c1d5485cd4f4982$export$2e2bcd8739ae039);

var $25nEq = parcelRequire("25nEq");

var $eBFOC = parcelRequire("eBFOC");

var $34xOs = parcelRequire("34xOs");

var $bBV6T = parcelRequire("bBV6T");
parcelRequire("2WYRt");
var $lzPgc = parcelRequire("lzPgc");

var $kbNOG = parcelRequire("kbNOG");
function $8c1d5485cd4f4982$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $8c1d5485cd4f4982$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $8c1d5485cd4f4982$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $8c1d5485cd4f4982$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $8c1d5485cd4f4982$var$NAVIGATION_TAG = 'navigation';
var $8c1d5485cd4f4982$var$listenerVersion = "0.0.0-development";
var /**
 * This util exists to convert the analytics-next event format into the analytics platform format.
 *
 * Analytics-next event format:
 * event {
 *      payload: {
 *          ...attributesFromLowestPointInTheTree
 *      },
 *      context: [{
 *          ...attributesFromHighestPointInTheTree
 *      }, {
 *          ...attributesFromSecondHighestPointInTheTree
 *      }]
 * }
 *
 * Analytics platform event format:
 *  event {
 *      type: @atlaskit/analytics-gas-types.EventType
 *      payload {
 *          ...mandatoryAttributesBasedOnEventType
 *          attributes: {
 *              ...arbitraryAttributes
 *          }
 *      }
 *  }
 */ $8c1d5485cd4f4982$export$2e2bcd8739ae039 = function(event, logger) {
    var sources = (0, $kbNOG.getSources)(event, (0, $lzPgc.NAVIGATION_CONTEXT));
    var source = (0, (/*@__PURE__*/$parcel$interopDefault($eBFOC)))(sources) || (0, $bBV6T.DEFAULT_SOURCE);
    var extraAttributes = (0, $kbNOG.getExtraAttributes)(event, (0, $lzPgc.NAVIGATION_CONTEXT));
    var components = (0, $kbNOG.getComponents)(event, (0, $lzPgc.NAVIGATION_CONTEXT));
    var packages = (0, $kbNOG.getPackageInfo)(event, (0, $lzPgc.NAVIGATION_CONTEXT));
    var _ref = (0, (/*@__PURE__*/$parcel$interopDefault($eBFOC)))((0, $kbNOG.getPackageInfo)(event, (0, $lzPgc.NAVIGATION_CONTEXT))) || {}, packageName = _ref.packageName, packageVersion = _ref.packageVersion;
    var packageHierarchy = packages.map(function(p) {
        return p.packageVersion ? "".concat(p.packageName, "@").concat(p.packageVersion) : p.packageName;
    });
    var _event$payload = event.payload, _event$payload$eventT = _event$payload.eventType, eventType = _event$payload$eventT === void 0 ? (0, $bBV6T.UI_EVENT_TYPE) : _event$payload$eventT, action = _event$payload.action, actionSubject = _event$payload.actionSubject, actionSubjectId = _event$payload.actionSubjectId, payloadAttributes = _event$payload.attributes, name = _event$payload.name;
    var attributes = $8c1d5485cd4f4982$var$_objectSpread($8c1d5485cd4f4982$var$_objectSpread({
        listenerVersion: $8c1d5485cd4f4982$var$listenerVersion,
        sourceHierarchy: sources.join('.') || undefined,
        componentHierarchy: components.join('.') || undefined,
        packageHierarchy: packageHierarchy.join(',') || undefined
    }, {
        packageName: packageName,
        packageVersion: packageVersion
    }), (0, (/*@__PURE__*/$parcel$interopDefault($34xOs)))(extraAttributes, payloadAttributes));
    // Ensure navigation tag is not duplicated by using Set
    var tags = new Set(event.payload.tags || []);
    tags.add($8c1d5485cd4f4982$var$NAVIGATION_TAG);
    if (event.payload) switch(eventType){
        case 0, $bBV6T.UI_EVENT_TYPE:
        case 0, $bBV6T.OPERATIONAL_EVENT_TYPE:
        case 0, $bBV6T.TRACK_EVENT_TYPE:
            return {
                eventType: eventType,
                source: source,
                actionSubject: actionSubject,
                action: action,
                actionSubjectId: actionSubjectId,
                attributes: attributes,
                tags: Array.from(tags)
            };
        case 0, $bBV6T.SCREEN_EVENT_TYPE:
            return {
                eventType: eventType,
                name: name,
                attributes: attributes,
                tags: Array.from(tags)
            };
        default:
            logger.error('Invalid event type', eventType);
            break;
    }
    return null;
};

});
parcelRegister("kbNOG", function(module, exports) {
$parcel$export(module.exports, "getSources", () => $eb2b7a4168eb8d6a$export$5f9bc633b116660f);
$parcel$export(module.exports, "getComponents", () => $eb2b7a4168eb8d6a$export$4e811121b221213b);
$parcel$export(module.exports, "getExtraAttributes", () => $eb2b7a4168eb8d6a$export$67c3590839ebecdd);
$parcel$export(module.exports, "getPackageInfo", () => $eb2b7a4168eb8d6a$export$cd17d76da7967240);
/**
 * Largely taken from analytics-web-react
 */ 
var $34xOs = parcelRequire("34xOs");
var $eb2b7a4168eb8d6a$var$extractFromEventContext = function extractFromEventContext(propertyNames, event) {
    var namespacedContextOnly = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    var contextName = arguments.length > 3 ? arguments[3] : undefined;
    return event.context.reduce(function(acc, contextItem) {
        propertyNames.forEach(function(propertyName) {
            var navContext = contextItem[contextName];
            var navContextProp = navContext ? navContext[propertyName] : null;
            var value = namespacedContextOnly ? navContextProp : navContextProp || contextItem[propertyName];
            if (value) acc.push(value);
        });
        return acc;
    }, []);
};
var $eb2b7a4168eb8d6a$export$5f9bc633b116660f = function getSources(event, contextName) {
    return $eb2b7a4168eb8d6a$var$extractFromEventContext([
        'source'
    ], event, false, contextName);
};
var $eb2b7a4168eb8d6a$export$4e811121b221213b = function getComponents(event, contextName) {
    return $eb2b7a4168eb8d6a$var$extractFromEventContext([
        'component',
        'componentName'
    ], event, false, contextName);
};
var $eb2b7a4168eb8d6a$export$67c3590839ebecdd = function getExtraAttributes(event, contextName) {
    return $eb2b7a4168eb8d6a$var$extractFromEventContext([
        'attributes'
    ], event, true, contextName).reduce(function(result, extraAttributes) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($34xOs)))(result, extraAttributes);
    }, {});
};
var $eb2b7a4168eb8d6a$export$cd17d76da7967240 = function getPackageInfo(event, contextName) {
    return event.context.map(function(contextItem) {
        var navContext = contextItem[contextName];
        var item = navContext ? navContext : contextItem;
        return {
            packageName: item.packageName,
            packageVersion: item.packageVersion
        };
    }).filter(function(p) {
        return p.packageName;
    });
};
var $eb2b7a4168eb8d6a$export$18cd124b5098d330 = function getPackageVersion(event, contextName) {
    return $eb2b7a4168eb8d6a$var$extractFromEventContext([
        'packageVersion'
    ], event, true, contextName);
};

});



parcelRegister("G3sga", function(module, exports) {
$parcel$export(module.exports, "default", () => $07e69a691c8d4c4a$export$2e2bcd8739ae039);

var $kqp0i = parcelRequire("kqp0i");

var $5FkrB = parcelRequire("5FkrB");

var $2H1dZ = parcelRequire("2H1dZ");

var $8Qkkg = parcelRequire("8Qkkg");

var $aDmPS = parcelRequire("aDmPS");
function $07e69a691c8d4c4a$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $aDmPS.default), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, props, {
        channel: (0, $2H1dZ.FabricChannel).media,
        processEvent: (0, $8Qkkg.processEvent)
    }));
}

});
parcelRegister("8Qkkg", function(module, exports) {
$parcel$export(module.exports, "processEvent", () => $6702f25afe000ae9$export$22af68e3614bf024);

var $25nEq = parcelRequire("25nEq");

var $fC8ib = parcelRequire("fC8ib");

var $bBV6T = parcelRequire("bBV6T");
parcelRequire("2WYRt");
var $gwzFf = parcelRequire("gwzFf");

var $34xOs = parcelRequire("34xOs");

var $eBFOC = parcelRequire("eBFOC");

var $8TkFc = parcelRequire("8TkFc");
function $6702f25afe000ae9$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $6702f25afe000ae9$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $6702f25afe000ae9$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $6702f25afe000ae9$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $6702f25afe000ae9$var$listenerVersion = "0.0.0-development";
function $6702f25afe000ae9$var$getMediaContexts(event) {
    return (0, $8TkFc.extractFromEventContext)((0, $gwzFf.MEDIA_CONTEXT), event);
}
function $6702f25afe000ae9$var$getMediaRegion() {
    try {
        return window && window.sessionStorage && window.sessionStorage.getItem('media-api-region');
    } catch (e) {
        return;
    }
}
function $6702f25afe000ae9$export$22af68e3614bf024(event) {
    var sources = (0, $8TkFc.getSources)(event);
    var _ref = (0, (/*@__PURE__*/$parcel$interopDefault($eBFOC)))((0, $8TkFc.getPackageInfo)(event)) || {}, packageName = _ref.packageName, packageVersion = _ref.packageVersion;
    var extraAttributes = (0, $8TkFc.getExtraAttributes)(event);
    var mediaContexts = $6702f25afe000ae9$var$getMediaContexts(event) || [];
    var mediaAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($34xOs))).apply(void 0, [
        {}
    ].concat((0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(mediaContexts)));
    var tags = new Set(event.payload.tags || []);
    tags.add('media');
    var components = (0, $8TkFc.getComponents)(event);
    var mediaRegion = $6702f25afe000ae9$var$getMediaRegion();
    var payload = {
        source: (0, (/*@__PURE__*/$parcel$interopDefault($eBFOC)))(sources) || (0, $bBV6T.DEFAULT_SOURCE),
        actionSubject: event.payload.actionSubject,
        action: event.payload.action,
        eventType: event.payload.eventType,
        actionSubjectId: event.payload.actionSubjectId,
        // for backward compatibilty
        name: event.payload.name,
        tags: Array.from(tags),
        attributes: $6702f25afe000ae9$var$_objectSpread($6702f25afe000ae9$var$_objectSpread({
            packageName: packageName,
            packageVersion: packageVersion
        }, (0, (/*@__PURE__*/$parcel$interopDefault($34xOs)))({}, extraAttributes, mediaAttributes, event.payload.attributes)), {}, {
            componentHierarchy: components.join('.') || undefined,
            packageHierarchy: (0, $8TkFc.getPackageHierarchy)(event),
            sourceHierarchy: sources.join('.') || undefined,
            listenerVersion: $6702f25afe000ae9$var$listenerVersion
        }, mediaRegion ? {
            mediaRegion: mediaRegion
        } : undefined),
        nonPrivacySafeAttributes: event.payload.nonPrivacySafeAttributes
    };
    return payload;
}

});


parcelRegister("eKEna", function(module, exports) {
$parcel$export(module.exports, "default", () => $abd4adb83734b03c$export$2e2bcd8739ae039);

var $kqp0i = parcelRequire("kqp0i");

var $5FkrB = parcelRequire("5FkrB");

var $2H1dZ = parcelRequire("2H1dZ");

var $fZKHh = parcelRequire("fZKHh");

var $aDmPS = parcelRequire("aDmPS");
function $abd4adb83734b03c$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $aDmPS.default), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, props, {
        channel: (0, $2H1dZ.FabricChannel).peopleTeams,
        processEvent: (0, $fZKHh.default)
    }));
}

});
parcelRegister("fZKHh", function(module, exports) {
$parcel$export(module.exports, "default", () => $ba50c69215f0df1e$export$2e2bcd8739ae039);

var $25nEq = parcelRequire("25nEq");

var $eBFOC = parcelRequire("eBFOC");

var $34xOs = parcelRequire("34xOs");

var $bBV6T = parcelRequire("bBV6T");
parcelRequire("2WYRt");
var $coUGQ = parcelRequire("coUGQ");

var $kbNOG = parcelRequire("kbNOG");
function $ba50c69215f0df1e$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $ba50c69215f0df1e$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $ba50c69215f0df1e$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $ba50c69215f0df1e$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $ba50c69215f0df1e$var$PEOPLE_TEAMS_TAG = 'peopleTeams';
var $ba50c69215f0df1e$var$listenerVersion = "0.0.0-development";
var /**
 * This util exists to convert the analytics-next event format into the analytics platform format.
 *
 * Analytics-next event format:
 * event {
 *      payload: {
 *          ...attributesFromLowestPointInTheTree
 *      },
 *      context: [{
 *          ...attributesFromHighestPointInTheTree
 *      }, {
 *          ...attributesFromSecondHighestPointInTheTree
 *      }]
 * }
 *
 * Analytics platform event format:
 *  event {
 *      type: @atlaskit/analytics-gas-types.EventType
 *      payload {
 *          ...mandatoryAttributesBasedOnEventType
 *          attributes: {
 *              ...arbitraryAttributes
 *          }
 *      }
 *  }
 */ $ba50c69215f0df1e$export$2e2bcd8739ae039 = function(event, logger) {
    var sources = (0, $kbNOG.getSources)(event, (0, $coUGQ.PEOPLE_TEAMS_CONTEXT));
    var source = (0, (/*@__PURE__*/$parcel$interopDefault($eBFOC)))(sources) || (0, $bBV6T.DEFAULT_SOURCE);
    var extraAttributes = (0, $kbNOG.getExtraAttributes)(event, (0, $coUGQ.PEOPLE_TEAMS_CONTEXT));
    var components = (0, $kbNOG.getComponents)(event, (0, $coUGQ.PEOPLE_TEAMS_CONTEXT));
    var packages = (0, $kbNOG.getPackageInfo)(event, (0, $coUGQ.PEOPLE_TEAMS_CONTEXT));
    var _ref = (0, (/*@__PURE__*/$parcel$interopDefault($eBFOC)))((0, $kbNOG.getPackageInfo)(event, (0, $coUGQ.PEOPLE_TEAMS_CONTEXT))) || {}, packageName = _ref.packageName, packageVersion = _ref.packageVersion;
    var packageHierarchy = packages.map(function(p) {
        return p.packageVersion ? "".concat(p.packageName, "@").concat(p.packageVersion) : p.packageName;
    });
    var _event$payload = event.payload, _event$payload$eventT = _event$payload.eventType, eventType = _event$payload$eventT === void 0 ? (0, $bBV6T.UI_EVENT_TYPE) : _event$payload$eventT, action = _event$payload.action, actionSubject = _event$payload.actionSubject, actionSubjectId = _event$payload.actionSubjectId, payloadAttributes = _event$payload.attributes, name = _event$payload.name;
    var attributes = $ba50c69215f0df1e$var$_objectSpread($ba50c69215f0df1e$var$_objectSpread({
        listenerVersion: $ba50c69215f0df1e$var$listenerVersion,
        sourceHierarchy: sources.join('.') || undefined,
        componentHierarchy: components.join('.') || undefined,
        packageHierarchy: packageHierarchy.join(',') || undefined
    }, {
        packageName: packageName,
        packageVersion: packageVersion
    }), (0, (/*@__PURE__*/$parcel$interopDefault($34xOs)))(extraAttributes, payloadAttributes));
    // Ensure navigation tag is not duplicated by using Set
    var tags = new Set(event.payload.tags || []);
    tags.add($ba50c69215f0df1e$var$PEOPLE_TEAMS_TAG);
    if (event.payload) switch(eventType){
        case 0, $bBV6T.UI_EVENT_TYPE:
        case 0, $bBV6T.OPERATIONAL_EVENT_TYPE:
        case 0, $bBV6T.TRACK_EVENT_TYPE:
            return {
                eventType: eventType,
                source: source,
                actionSubject: actionSubject,
                action: action,
                actionSubjectId: actionSubjectId,
                attributes: attributes,
                tags: Array.from(tags)
            };
        case 0, $bBV6T.SCREEN_EVENT_TYPE:
            return {
                eventType: eventType,
                name: name,
                attributes: attributes,
                tags: Array.from(tags)
            };
        default:
            logger.error('Invalid event type', eventType);
            break;
    }
    return null;
};

});


parcelRegister("3D2FR", function(module, exports) {
$parcel$export(module.exports, "default", () => $2a4716a74666bb73$export$2e2bcd8739ae039);

var $kqp0i = parcelRequire("kqp0i");

var $5FkrB = parcelRequire("5FkrB");

var $2H1dZ = parcelRequire("2H1dZ");

var $563Ep = parcelRequire("563Ep");

var $aDmPS = parcelRequire("aDmPS");
function $2a4716a74666bb73$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $aDmPS.default), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, props, {
        channel: (0, $2H1dZ.FabricChannel).notifications,
        processEvent: (0, $563Ep.default)
    }));
}

});
parcelRegister("563Ep", function(module, exports) {
$parcel$export(module.exports, "default", () => $3b605842083126d3$export$2e2bcd8739ae039);

var $25nEq = parcelRequire("25nEq");

var $eBFOC = parcelRequire("eBFOC");

var $34xOs = parcelRequire("34xOs");

var $bBV6T = parcelRequire("bBV6T");

var $kbNOG = parcelRequire("kbNOG");
parcelRequire("2WYRt");
var $gYBV8 = parcelRequire("gYBV8");

var $2H1dZ = parcelRequire("2H1dZ");
function $3b605842083126d3$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $3b605842083126d3$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $3b605842083126d3$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $3b605842083126d3$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $3b605842083126d3$var$listenerVersion = "0.0.0-development";
var /**
 * This util exists to convert the analytics-next event format into the analytics platform format.
 *
 * Analytics-next event format:
 * event {
 *      payload: {
 *          ...attributesFromLowestPointInTheTree
 *      },
 *      context: [{
 *          ...attributesFromHighestPointInTheTree
 *      }, {
 *          ...attributesFromSecondHighestPointInTheTree
 *      }]
 * }
 *
 * Analytics platform event format:
 *  event {
 *      type: @atlaskit/analytics-gas-types.EventType
 *      payload {
 *          ...mandatoryAttributesBasedOnEventType
 *          attributes: {
 *              ...arbitraryAttributes
 *          }
 *      }
 *  }
 */ $3b605842083126d3$export$2e2bcd8739ae039 = function(event, logger) {
    var sources = (0, $kbNOG.getSources)(event, (0, $gYBV8.NOTIFICATIONS_CONTEXT));
    var source = (0, (/*@__PURE__*/$parcel$interopDefault($eBFOC)))(sources) || (0, $bBV6T.DEFAULT_SOURCE);
    var extraAttributes = (0, $kbNOG.getExtraAttributes)(event, (0, $gYBV8.NOTIFICATIONS_CONTEXT));
    var components = (0, $kbNOG.getComponents)(event, (0, $gYBV8.NOTIFICATIONS_CONTEXT));
    var packages = (0, $kbNOG.getPackageInfo)(event, (0, $gYBV8.NOTIFICATIONS_CONTEXT));
    var _ref = (0, (/*@__PURE__*/$parcel$interopDefault($eBFOC)))((0, $kbNOG.getPackageInfo)(event, (0, $gYBV8.NOTIFICATIONS_CONTEXT))) || {}, packageName = _ref.packageName, packageVersion = _ref.packageVersion;
    var packageHierarchy = packages.map(function(p) {
        return p.packageVersion ? "".concat(p.packageName, "@").concat(p.packageVersion) : p.packageName;
    });
    var _event$payload = event.payload, _event$payload$eventT = _event$payload.eventType, eventType = _event$payload$eventT === void 0 ? (0, $bBV6T.UI_EVENT_TYPE) : _event$payload$eventT, action = _event$payload.action, actionSubject = _event$payload.actionSubject, actionSubjectId = _event$payload.actionSubjectId, payloadAttributes = _event$payload.attributes, name = _event$payload.name;
    var attributes = $3b605842083126d3$var$_objectSpread($3b605842083126d3$var$_objectSpread({
        listenerVersion: $3b605842083126d3$var$listenerVersion,
        sourceHierarchy: sources.join('.') || undefined,
        componentHierarchy: components.join('.') || undefined,
        packageHierarchy: packageHierarchy.join(',') || undefined
    }, {
        packageName: packageName,
        packageVersion: packageVersion
    }), (0, (/*@__PURE__*/$parcel$interopDefault($34xOs)))(extraAttributes, payloadAttributes));
    // Ensure navigation tag is not duplicated by using Set
    var tags = new Set(event.payload.tags || []);
    tags.add((0, $2H1dZ.FabricChannel).notifications);
    if (event.payload) switch(eventType){
        case 0, $bBV6T.UI_EVENT_TYPE:
        case 0, $bBV6T.OPERATIONAL_EVENT_TYPE:
        case 0, $bBV6T.TRACK_EVENT_TYPE:
            return {
                eventType: eventType,
                source: source,
                actionSubject: actionSubject,
                action: action,
                actionSubjectId: actionSubjectId,
                attributes: attributes,
                tags: Array.from(tags)
            };
        case 0, $bBV6T.SCREEN_EVENT_TYPE:
            return {
                eventType: eventType,
                name: name,
                attributes: attributes,
                tags: Array.from(tags)
            };
        default:
            logger.error('Invalid event type', eventType);
            break;
    }
    return null;
};

});


parcelRegister("7NLcS", function(module, exports) {
$parcel$export(module.exports, "default", () => $017740f0a42695bd$export$2e2bcd8739ae039);

var $kqp0i = parcelRequire("kqp0i");

var $5FkrB = parcelRequire("5FkrB");

var $2H1dZ = parcelRequire("2H1dZ");

var $fSdSD = parcelRequire("fSdSD");

var $aDmPS = parcelRequire("aDmPS");
function $017740f0a42695bd$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $aDmPS.default), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, props, {
        channel: (0, $2H1dZ.FabricChannel).recentWork,
        processEvent: (0, $fSdSD.default)
    }));
}

});
parcelRegister("fSdSD", function(module, exports) {
$parcel$export(module.exports, "default", () => $b8e6aa7570be5deb$export$2e2bcd8739ae039);

var $25nEq = parcelRequire("25nEq");

var $eBFOC = parcelRequire("eBFOC");

var $34xOs = parcelRequire("34xOs");

var $bBV6T = parcelRequire("bBV6T");

var $kbNOG = parcelRequire("kbNOG");
parcelRequire("2WYRt");
var $dr6Uf = parcelRequire("dr6Uf");

var $2H1dZ = parcelRequire("2H1dZ");
function $b8e6aa7570be5deb$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $b8e6aa7570be5deb$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $b8e6aa7570be5deb$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $b8e6aa7570be5deb$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $b8e6aa7570be5deb$var$listenerVersion = "0.0.0-development";
var /**
 * This util exists to convert the analytics-next event format into the analytics platform format.
 *
 * Analytics-next event format:
 * event {
 *      payload: {
 *          ...attributesFromLowestPointInTheTree
 *      },
 *      context: [{
 *          ...attributesFromHighestPointInTheTree
 *      }, {
 *          ...attributesFromSecondHighestPointInTheTree
 *      }]
 * }
 *
 * Analytics platform event format:
 *  event {
 *      type: @atlaskit/analytics-gas-types.EventType
 *      payload {
 *          ...mandatoryAttributesBasedOnEventType
 *          attributes: {
 *              ...arbitraryAttributes
 *          }
 *      }
 *  }
 */ $b8e6aa7570be5deb$export$2e2bcd8739ae039 = function(event, logger) {
    var sources = (0, $kbNOG.getSources)(event, (0, $dr6Uf.RECENT_WORK_CONTEXT));
    var source = (0, (/*@__PURE__*/$parcel$interopDefault($eBFOC)))(sources) || (0, $bBV6T.DEFAULT_SOURCE);
    var extraAttributes = (0, $kbNOG.getExtraAttributes)(event, (0, $dr6Uf.RECENT_WORK_CONTEXT));
    var components = (0, $kbNOG.getComponents)(event, (0, $dr6Uf.RECENT_WORK_CONTEXT));
    var packages = (0, $kbNOG.getPackageInfo)(event, (0, $dr6Uf.RECENT_WORK_CONTEXT));
    var _ref = (0, (/*@__PURE__*/$parcel$interopDefault($eBFOC)))((0, $kbNOG.getPackageInfo)(event, (0, $dr6Uf.RECENT_WORK_CONTEXT))) || {}, packageName = _ref.packageName, packageVersion = _ref.packageVersion;
    var packageHierarchy = packages.map(function(p) {
        return p.packageVersion ? "".concat(p.packageName, "@").concat(p.packageVersion) : p.packageName;
    });
    var _event$payload = event.payload, _event$payload$eventT = _event$payload.eventType, eventType = _event$payload$eventT === void 0 ? (0, $bBV6T.UI_EVENT_TYPE) : _event$payload$eventT, action = _event$payload.action, actionSubject = _event$payload.actionSubject, actionSubjectId = _event$payload.actionSubjectId, payloadAttributes = _event$payload.attributes, name = _event$payload.name;
    var attributes = $b8e6aa7570be5deb$var$_objectSpread($b8e6aa7570be5deb$var$_objectSpread({
        listenerVersion: $b8e6aa7570be5deb$var$listenerVersion,
        sourceHierarchy: sources.join('.') || undefined,
        componentHierarchy: components.join('.') || undefined,
        packageHierarchy: packageHierarchy.join(',') || undefined
    }, {
        packageName: packageName,
        packageVersion: packageVersion
    }), (0, (/*@__PURE__*/$parcel$interopDefault($34xOs)))(extraAttributes, payloadAttributes));
    // Ensure navigation tag is not duplicated by using Set
    var tags = new Set(event.payload.tags || []);
    tags.add((0, $2H1dZ.FabricChannel).recentWork);
    if (event.payload) switch(eventType){
        case 0, $bBV6T.UI_EVENT_TYPE:
        case 0, $bBV6T.OPERATIONAL_EVENT_TYPE:
        case 0, $bBV6T.TRACK_EVENT_TYPE:
            return {
                eventType: eventType,
                source: source,
                actionSubject: actionSubject,
                action: action,
                actionSubjectId: actionSubjectId,
                attributes: attributes,
                tags: Array.from(tags)
            };
        case 0, $bBV6T.SCREEN_EVENT_TYPE:
            return {
                eventType: eventType,
                name: name,
                attributes: attributes,
                tags: Array.from(tags)
            };
        default:
            logger.error('Invalid event type', eventType);
            break;
    }
    return null;
};

});


parcelRegister("6vcvs", function(module, exports) {
$parcel$export(module.exports, "default", () => $4bbf56daade9c3aa$export$2e2bcd8739ae039);

var $kqp0i = parcelRequire("kqp0i");

var $5FkrB = parcelRequire("5FkrB");

var $2H1dZ = parcelRequire("2H1dZ");

var $e3PsP = parcelRequire("e3PsP");

var $aDmPS = parcelRequire("aDmPS");
function $4bbf56daade9c3aa$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $aDmPS.default), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, props, {
        channel: (0, $2H1dZ.FabricChannel).atlas,
        processEvent: (0, $e3PsP.default)
    }));
}

});
parcelRegister("e3PsP", function(module, exports) {
$parcel$export(module.exports, "default", () => $a3c9442d051ffe11$export$2e2bcd8739ae039);

var $25nEq = parcelRequire("25nEq");

var $eBFOC = parcelRequire("eBFOC");

var $34xOs = parcelRequire("34xOs");

var $bBV6T = parcelRequire("bBV6T");

var $kbNOG = parcelRequire("kbNOG");
parcelRequire("2WYRt");
var $dT6JI = parcelRequire("dT6JI");
function $a3c9442d051ffe11$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $a3c9442d051ffe11$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $a3c9442d051ffe11$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $a3c9442d051ffe11$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $a3c9442d051ffe11$var$ATLAS_TAG = 'atlas';
var $a3c9442d051ffe11$var$listenerVersion = "0.0.0-development";
var /**
 * This util exists to convert the analytics-next event format into the analytics platform format.
 *
 * Analytics-next event format:
 * event {
 *      payload: {
 *          ...attributesFromLowestPointInTheTree
 *      },
 *      context: [{
 *          ...attributesFromHighestPointInTheTree
 *      }, {
 *          ...attributesFromSecondHighestPointInTheTree
 *      }]
 * }
 *
 * Analytics platform event format:
 *  event {
 *      type: @atlaskit/analytics-gas-types.EventType
 *      payload {
 *          ...mandatoryAttributesBasedOnEventType
 *          attributes: {
 *              ...arbitraryAttributes
 *          }
 *      }
 *  }
 */ $a3c9442d051ffe11$export$2e2bcd8739ae039 = function(event, logger) {
    var sources = (0, $kbNOG.getSources)(event, (0, $dT6JI.ATLAS_CONTEXT));
    var source = (0, (/*@__PURE__*/$parcel$interopDefault($eBFOC)))(sources) || (0, $bBV6T.DEFAULT_SOURCE);
    var extraAttributes = (0, $kbNOG.getExtraAttributes)(event, (0, $dT6JI.ATLAS_CONTEXT));
    var components = (0, $kbNOG.getComponents)(event, (0, $dT6JI.ATLAS_CONTEXT));
    var packages = (0, $kbNOG.getPackageInfo)(event, (0, $dT6JI.ATLAS_CONTEXT));
    var _ref = (0, (/*@__PURE__*/$parcel$interopDefault($eBFOC)))((0, $kbNOG.getPackageInfo)(event, (0, $dT6JI.ATLAS_CONTEXT))) || {}, packageName = _ref.packageName, packageVersion = _ref.packageVersion;
    var packageHierarchy = packages.map(function(p) {
        return p.packageVersion ? "".concat(p.packageName, "@").concat(p.packageVersion) : p.packageName;
    });
    var _event$payload = event.payload, _event$payload$eventT = _event$payload.eventType, eventType = _event$payload$eventT === void 0 ? (0, $bBV6T.UI_EVENT_TYPE) : _event$payload$eventT, action = _event$payload.action, actionSubject = _event$payload.actionSubject, actionSubjectId = _event$payload.actionSubjectId, payloadAttributes = _event$payload.attributes, name = _event$payload.name;
    var attributes = $a3c9442d051ffe11$var$_objectSpread($a3c9442d051ffe11$var$_objectSpread({
        listenerVersion: $a3c9442d051ffe11$var$listenerVersion,
        sourceHierarchy: sources.join('.') || undefined,
        componentHierarchy: components.join('.') || undefined,
        packageHierarchy: packageHierarchy.join(',') || undefined
    }, {
        packageName: packageName,
        packageVersion: packageVersion
    }), (0, (/*@__PURE__*/$parcel$interopDefault($34xOs)))(extraAttributes, payloadAttributes));
    // Ensure navigation tag is not duplicated by using Set
    var tags = new Set(event.payload.tags || []);
    tags.add($a3c9442d051ffe11$var$ATLAS_TAG);
    if (event.payload) switch(eventType){
        case 0, $bBV6T.UI_EVENT_TYPE:
        case 0, $bBV6T.OPERATIONAL_EVENT_TYPE:
        case 0, $bBV6T.TRACK_EVENT_TYPE:
            return {
                eventType: eventType,
                source: source,
                actionSubject: actionSubject,
                action: action,
                actionSubjectId: actionSubjectId,
                attributes: attributes,
                tags: Array.from(tags)
            };
        case 0, $bBV6T.SCREEN_EVENT_TYPE:
            return {
                eventType: eventType,
                name: name,
                attributes: attributes,
                tags: Array.from(tags)
            };
        default:
            logger.error('Invalid event type', eventType);
            break;
    }
    return null;
};

});


parcelRegister("89IQS", function(module, exports) {
$parcel$export(module.exports, "default", () => $5f01f4a1f21f0234$export$2e2bcd8739ae039);

var $kqp0i = parcelRequire("kqp0i");

var $5FkrB = parcelRequire("5FkrB");

var $2H1dZ = parcelRequire("2H1dZ");

var $54SNM = parcelRequire("54SNM");

var $aDmPS = parcelRequire("aDmPS");
function $5f01f4a1f21f0234$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $aDmPS.default), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, props, {
        channel: (0, $2H1dZ.FabricChannel).crossFlow,
        processEvent: (0, $54SNM.default)
    }));
}

});
parcelRegister("54SNM", function(module, exports) {
$parcel$export(module.exports, "default", () => $3b27d60284f2a5b8$export$2e2bcd8739ae039);

var $25nEq = parcelRequire("25nEq");

var $bBV6T = parcelRequire("bBV6T");

var $eBFOC = parcelRequire("eBFOC");
parcelRequire("2WYRt");
var $lzPgc = parcelRequire("lzPgc");

var $8TkFc = parcelRequire("8TkFc");

var $kbNOG = parcelRequire("kbNOG");
function $3b27d60284f2a5b8$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $3b27d60284f2a5b8$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $3b27d60284f2a5b8$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $3b27d60284f2a5b8$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $3b27d60284f2a5b8$var$CROSS_FLOW_TAG = 'crossFlow';
var $3b27d60284f2a5b8$export$2e2bcd8739ae039 = function(event, logger) {
    var _event$payload$source;
    var _event$payload = event.payload, _event$payload$eventT = _event$payload.eventType, eventType = _event$payload$eventT === void 0 ? (0, $bBV6T.UI_EVENT_TYPE) : _event$payload$eventT, action = _event$payload.action, actionSubject = _event$payload.actionSubject, actionSubjectId = _event$payload.actionSubjectId, name = _event$payload.name;
    var sources = (0, $8TkFc.getSources)(event);
    var lastSourceFromContext = (0, (/*@__PURE__*/$parcel$interopDefault($eBFOC)))(sources);
    var source = (_event$payload$source = event.payload.source) !== null && _event$payload$source !== void 0 ? _event$payload$source : lastSourceFromContext;
    if (lastSourceFromContext !== source) sources.push(source);
    var attributes = $3b27d60284f2a5b8$var$_objectSpread($3b27d60284f2a5b8$var$_objectSpread($3b27d60284f2a5b8$var$_objectSpread($3b27d60284f2a5b8$var$_objectSpread({}, (0, $8TkFc.getExtraAttributes)(event)), (0, $kbNOG.getExtraAttributes)(event, (0, $lzPgc.NAVIGATION_CONTEXT))), event.payload.attributes), {}, {
        namespaces: sources.join('.')
    });
    // Ensure navigation tag is not duplicated by using Set
    var tags = new Set(event.payload.tags || []);
    tags.add($3b27d60284f2a5b8$var$CROSS_FLOW_TAG);
    if (event.payload) switch(eventType){
        case 0, $bBV6T.UI_EVENT_TYPE:
        case 0, $bBV6T.OPERATIONAL_EVENT_TYPE:
        case 0, $bBV6T.TRACK_EVENT_TYPE:
            return {
                eventType: eventType,
                source: source,
                actionSubject: actionSubject,
                action: action,
                actionSubjectId: actionSubjectId,
                attributes: attributes,
                tags: Array.from(tags)
            };
        case 0, $bBV6T.SCREEN_EVENT_TYPE:
            return {
                eventType: eventType,
                name: name,
                attributes: attributes,
                tags: Array.from(tags)
            };
        default:
            logger.error('Invalid event type', eventType);
            break;
    }
    return null;
};

});


parcelRegister("gUhCZ", function(module, exports) {
$parcel$export(module.exports, "default", () => $c4ef8cdb7b9c964a$export$2e2bcd8739ae039);

var $kqp0i = parcelRequire("kqp0i");

var $5FkrB = parcelRequire("5FkrB");

var $kVLwc = parcelRequire("kVLwc");

var $2H1dZ = parcelRequire("2H1dZ");

var $aDmPS = parcelRequire("aDmPS");
function $c4ef8cdb7b9c964a$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $aDmPS.default), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, props, {
        channel: (0, $2H1dZ.FabricChannel).linkingPlatform,
        processEvent: (0, $kVLwc.default)
    }));
}

});
parcelRegister("kVLwc", function(module, exports) {
$parcel$export(module.exports, "default", () => $f3cdfdaae47a2766$export$2e2bcd8739ae039);

var $25nEq = parcelRequire("25nEq");

var $eBFOC = parcelRequire("eBFOC");

var $34xOs = parcelRequire("34xOs");

var $bBV6T = parcelRequire("bBV6T");
parcelRequire("2WYRt");
var $bvSsd = parcelRequire("bvSsd");

var $kbNOG = parcelRequire("kbNOG");

var $2H1dZ = parcelRequire("2H1dZ");
function $f3cdfdaae47a2766$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $f3cdfdaae47a2766$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $f3cdfdaae47a2766$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $f3cdfdaae47a2766$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $f3cdfdaae47a2766$var$listenerVersion = "0.0.0-development";
var $f3cdfdaae47a2766$export$2e2bcd8739ae039 = function(event) {
    var sources = (0, $kbNOG.getSources)(event, (0, $bvSsd.LINKING_PLATFORM_CONTEXT));
    var packages = (0, $kbNOG.getPackageInfo)(event, (0, $bvSsd.LINKING_PLATFORM_CONTEXT));
    var components = (0, $kbNOG.getComponents)(event, (0, $bvSsd.LINKING_PLATFORM_CONTEXT));
    var extraAttributes = (0, $kbNOG.getExtraAttributes)(event, (0, $bvSsd.LINKING_PLATFORM_CONTEXT));
    var _ref = (0, (/*@__PURE__*/$parcel$interopDefault($eBFOC)))(packages) || {}, packageName = _ref.packageName, packageVersion = _ref.packageVersion;
    var packageHierarchy = packages.map(function(p) {
        return p.packageVersion ? "".concat(p.packageName, "@").concat(p.packageVersion) : p.packageName;
    });
    var tags = new Set(event.payload.tags || []);
    tags.add((0, $2H1dZ.FabricChannel).linkingPlatform);
    var payload = {
        name: event.payload.name,
        action: event.payload.action,
        actionSubject: event.payload.actionSubject,
        actionSubjectId: event.payload.actionSubjectId,
        eventType: event.payload.eventType,
        attributes: $f3cdfdaae47a2766$var$_objectSpread({
            packageName: packageName,
            packageVersion: packageVersion,
            listenerVersion: $f3cdfdaae47a2766$var$listenerVersion,
            sourceHierarchy: sources.join('.') || undefined,
            componentHierarchy: components.join('.') || undefined,
            packageHierarchy: packageHierarchy.join(',') || undefined
        }, (0, (/*@__PURE__*/$parcel$interopDefault($34xOs)))(extraAttributes, event.payload.attributes)),
        tags: Array.from(tags),
        source: (0, (/*@__PURE__*/$parcel$interopDefault($eBFOC)))(sources) || (0, $bBV6T.DEFAULT_SOURCE),
        nonPrivacySafeAttributes: event.payload.nonPrivacySafeAttributes
    };
    return payload;
};

});


parcelRegister("26RMx", function(module, exports) {
$parcel$export(module.exports, "default", () => $1895dc45790d155c$export$2e2bcd8739ae039);

var $kqp0i = parcelRequire("kqp0i");

var $5FkrB = parcelRequire("5FkrB");

var $2H1dZ = parcelRequire("2H1dZ");

var $gU2Jn = parcelRequire("gU2Jn");

var $aDmPS = parcelRequire("aDmPS");
function $1895dc45790d155c$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $aDmPS.default), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, props, {
        channel: (0, $2H1dZ.FabricChannel).postOffice,
        processEvent: (0, $gU2Jn.default)
    }));
}

});
parcelRegister("gU2Jn", function(module, exports) {
$parcel$export(module.exports, "default", () => $c4e3fe990fbeb827$export$2e2bcd8739ae039);

var $25nEq = parcelRequire("25nEq");

var $eBFOC = parcelRequire("eBFOC");

var $34xOs = parcelRequire("34xOs");

var $bBV6T = parcelRequire("bBV6T");
parcelRequire("2WYRt");
var $9qmI1 = parcelRequire("9qmI1");

var $kbNOG = parcelRequire("kbNOG");

var $2H1dZ = parcelRequire("2H1dZ");
function $c4e3fe990fbeb827$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $c4e3fe990fbeb827$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $c4e3fe990fbeb827$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $c4e3fe990fbeb827$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $c4e3fe990fbeb827$var$POST_OFFICE_TAG = (0, $2H1dZ.FabricChannel).postOffice;
var $c4e3fe990fbeb827$var$listenerVersion = "0.0.0-development";
var /**
 * This util exists to convert the analytics-next event format into the analytics platform format.
 *
 * Analytics-next event format:
 * event {
 *      payload: {
 *          ...attributesFromLowestPointInTheTree
 *      },
 *      context: [{
 *          ...attributesFromHighestPointInTheTree
 *      }, {
 *          ...attributesFromSecondHighestPointInTheTree
 *      }]
 * }
 *
 * Analytics platform event format:
 *  event {
 *      type: @atlaskit/analytics-gas-types.EventType
 *      payload {
 *          ...mandatoryAttributesBasedOnEventType
 *          attributes: {
 *              ...arbitraryAttributes
 *          }
 *      }
 *  }
 */ $c4e3fe990fbeb827$export$2e2bcd8739ae039 = function(event, logger) {
    var sources = (0, $kbNOG.getSources)(event, (0, $9qmI1.POST_OFFICE_CONTEXT));
    var source = (0, (/*@__PURE__*/$parcel$interopDefault($eBFOC)))(sources) || (0, $bBV6T.DEFAULT_SOURCE);
    var extraAttributes = (0, $kbNOG.getExtraAttributes)(event, (0, $9qmI1.POST_OFFICE_CONTEXT));
    var components = (0, $kbNOG.getComponents)(event, (0, $9qmI1.POST_OFFICE_CONTEXT));
    var packages = (0, $kbNOG.getPackageInfo)(event, (0, $9qmI1.POST_OFFICE_CONTEXT));
    var _ref = (0, (/*@__PURE__*/$parcel$interopDefault($eBFOC)))((0, $kbNOG.getPackageInfo)(event, (0, $9qmI1.POST_OFFICE_CONTEXT))) || {}, packageName = _ref.packageName, packageVersion = _ref.packageVersion;
    var packageHierarchy = packages.map(function(p) {
        return p.packageVersion ? "".concat(p.packageName, "@").concat(p.packageVersion) : p.packageName;
    });
    var _event$payload = event.payload, _event$payload$eventT = _event$payload.eventType, eventType = _event$payload$eventT === void 0 ? (0, $bBV6T.UI_EVENT_TYPE) : _event$payload$eventT, action = _event$payload.action, actionSubject = _event$payload.actionSubject, actionSubjectId = _event$payload.actionSubjectId, payloadAttributes = _event$payload.attributes, name = _event$payload.name;
    var attributes = $c4e3fe990fbeb827$var$_objectSpread($c4e3fe990fbeb827$var$_objectSpread({
        listenerVersion: $c4e3fe990fbeb827$var$listenerVersion,
        sourceHierarchy: sources.join('.') || undefined,
        componentHierarchy: components.join('.') || undefined,
        packageHierarchy: packageHierarchy.join(',') || undefined
    }, {
        packageName: packageName,
        packageVersion: packageVersion
    }), (0, (/*@__PURE__*/$parcel$interopDefault($34xOs)))(extraAttributes, payloadAttributes));
    // Ensure navigation tag is not duplicated by using Set
    var tags = new Set(event.payload.tags || []);
    tags.add($c4e3fe990fbeb827$var$POST_OFFICE_TAG);
    if (event.payload) switch(eventType){
        case 0, $bBV6T.UI_EVENT_TYPE:
        case 0, $bBV6T.OPERATIONAL_EVENT_TYPE:
        case 0, $bBV6T.TRACK_EVENT_TYPE:
            return {
                eventType: eventType,
                source: source,
                actionSubject: actionSubject,
                action: action,
                actionSubjectId: actionSubjectId,
                attributes: attributes,
                tags: Array.from(tags)
            };
        case 0, $bBV6T.SCREEN_EVENT_TYPE:
            return {
                eventType: eventType,
                name: name,
                attributes: attributes,
                tags: Array.from(tags)
            };
        default:
            logger.error('Invalid event type', eventType);
            break;
    }
    return null;
};

});


parcelRegister("lyeuJ", function(module, exports) {
$parcel$export(module.exports, "default", () => $fb08044a39d7f3ba$export$2e2bcd8739ae039);

var $kqp0i = parcelRequire("kqp0i");

var $5FkrB = parcelRequire("5FkrB");

var $2H1dZ = parcelRequire("2H1dZ");

var $4s4Z6 = parcelRequire("4s4Z6");

var $aDmPS = parcelRequire("aDmPS");
function $fb08044a39d7f3ba$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $aDmPS.default), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, props, {
        channel: (0, $2H1dZ.FabricChannel).aiMate,
        processEvent: (0, $4s4Z6.default)
    }));
}

});
parcelRegister("4s4Z6", function(module, exports) {
$parcel$export(module.exports, "default", () => $33dda4ca9a4f8363$export$2e2bcd8739ae039);

var $25nEq = parcelRequire("25nEq");

var $eBFOC = parcelRequire("eBFOC");

var $34xOs = parcelRequire("34xOs");

var $bBV6T = parcelRequire("bBV6T");
parcelRequire("2WYRt");
var $draJh = parcelRequire("draJh");

var $kbNOG = parcelRequire("kbNOG");
function $33dda4ca9a4f8363$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $33dda4ca9a4f8363$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $33dda4ca9a4f8363$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $33dda4ca9a4f8363$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $33dda4ca9a4f8363$var$AI_MATE_TAG = 'aiMate';
var $33dda4ca9a4f8363$var$listenerVersion = "0.0.0-development";
var /**
 * This util exists to convert the analytics-next event format into the analytics platform format.
 *
 * Analytics-next event format:
 * event {
 *      payload: {
 *          ...attributesFromLowestPointInTheTree
 *      },
 *      context: [{
 *          ...attributesFromHighestPointInTheTree
 *      }, {
 *          ...attributesFromSecondHighestPointInTheTree
 *      }]
 * }
 *
 * Analytics platform event format:
 *  event {
 *      type: @atlaskit/analytics-gas-types.EventType
 *      payload {
 *          ...mandatoryAttributesBasedOnEventType
 *          attributes: {
 *              ...arbitraryAttributes
 *          }
 *      }
 *  }
 */ $33dda4ca9a4f8363$export$2e2bcd8739ae039 = function(event, logger) {
    var sources = (0, $kbNOG.getSources)(event, (0, $draJh.AI_MATE_CONTEXT));
    var source = (0, (/*@__PURE__*/$parcel$interopDefault($eBFOC)))(sources) || (0, $bBV6T.DEFAULT_SOURCE);
    var extraAttributes = (0, $kbNOG.getExtraAttributes)(event, (0, $draJh.AI_MATE_CONTEXT));
    var components = (0, $kbNOG.getComponents)(event, (0, $draJh.AI_MATE_CONTEXT));
    var packages = (0, $kbNOG.getPackageInfo)(event, (0, $draJh.AI_MATE_CONTEXT));
    var _ref = (0, (/*@__PURE__*/$parcel$interopDefault($eBFOC)))((0, $kbNOG.getPackageInfo)(event, (0, $draJh.AI_MATE_CONTEXT))) || {}, packageName = _ref.packageName, packageVersion = _ref.packageVersion;
    var packageHierarchy = packages.map(function(p) {
        return p.packageVersion ? "".concat(p.packageName, "@").concat(p.packageVersion) : p.packageName;
    });
    var _event$payload = event.payload, _event$payload$eventT = _event$payload.eventType, eventType = _event$payload$eventT === void 0 ? (0, $bBV6T.UI_EVENT_TYPE) : _event$payload$eventT, action = _event$payload.action, actionSubject = _event$payload.actionSubject, actionSubjectId = _event$payload.actionSubjectId, payloadAttributes = _event$payload.attributes, name = _event$payload.name;
    var attributes = $33dda4ca9a4f8363$var$_objectSpread($33dda4ca9a4f8363$var$_objectSpread({
        listenerVersion: $33dda4ca9a4f8363$var$listenerVersion,
        sourceHierarchy: sources.join('.') || undefined,
        componentHierarchy: components.join('.') || undefined,
        packageHierarchy: packageHierarchy.join(',') || undefined
    }, {
        packageName: packageName,
        packageVersion: packageVersion
    }), (0, (/*@__PURE__*/$parcel$interopDefault($34xOs)))(extraAttributes, payloadAttributes));
    // Ensure navigation tag is not duplicated by using Set
    var tags = new Set(event.payload.tags || []);
    tags.add($33dda4ca9a4f8363$var$AI_MATE_TAG);
    if (event.payload) switch(eventType){
        case 0, $bBV6T.UI_EVENT_TYPE:
        case 0, $bBV6T.OPERATIONAL_EVENT_TYPE:
        case 0, $bBV6T.TRACK_EVENT_TYPE:
            return {
                eventType: eventType,
                source: source,
                actionSubject: actionSubject,
                action: action,
                actionSubjectId: actionSubjectId,
                attributes: attributes,
                tags: Array.from(tags)
            };
        case 0, $bBV6T.SCREEN_EVENT_TYPE:
            return {
                eventType: eventType,
                name: name,
                attributes: attributes,
                tags: Array.from(tags)
            };
        default:
            logger.error('Invalid event type', eventType);
            break;
    }
    return null;
};

});


parcelRegister("cIOw3", function(module, exports) {
$parcel$export(module.exports, "default", () => $9430c7810246311a$export$2e2bcd8739ae039);

var $kqp0i = parcelRequire("kqp0i");

var $5FkrB = parcelRequire("5FkrB");

var $2H1dZ = parcelRequire("2H1dZ");

var $70iTq = parcelRequire("70iTq");

var $aDmPS = parcelRequire("aDmPS");
function $9430c7810246311a$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $aDmPS.default), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, props, {
        channel: (0, $2H1dZ.FabricChannel).avp,
        processEvent: (0, $70iTq.default)
    }));
}

});
parcelRegister("70iTq", function(module, exports) {
$parcel$export(module.exports, "default", () => $519730399a79dca8$export$2e2bcd8739ae039);

var $fC8ib = parcelRequire("fC8ib");

var $25nEq = parcelRequire("25nEq");

var $eBFOC = parcelRequire("eBFOC");

var $34xOs = parcelRequire("34xOs");

var $bBV6T = parcelRequire("bBV6T");
parcelRequire("2WYRt");
var $dRe9Q = parcelRequire("dRe9Q");

var $kbNOG = parcelRequire("kbNOG");
function $519730399a79dca8$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $519730399a79dca8$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $519730399a79dca8$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $519730399a79dca8$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $519730399a79dca8$var$AVP_TAG = 'avp';
var $519730399a79dca8$var$listenerVersion = "0.0.0-development";
var /**
 * This util exists to convert the analytics-next event format into the analytics platform format.
 *
 * Analytics-next event format:
 * event {
 *      payload: {
 *          ...attributesFromLowestPointInTheTree
 *      },
 *      context: [{
 *          ...attributesFromHighestPointInTheTree
 *      }, {
 *          ...attributesFromSecondHighestPointInTheTree
 *      }]
 * }
 *
 * Analytics platform event format:
 *  event {
 *      type: @atlaskit/analytics-gas-types.EventType
 *      payload {
 *          ...mandatoryAttributesBasedOnEventType
 *          attributes: {
 *              ...arbitraryAttributes
 *          }
 *      }
 *  }
 */ $519730399a79dca8$export$2e2bcd8739ae039 = function(event, logger) {
    var sources = (0, $kbNOG.getSources)(event, (0, $dRe9Q.AVP_CONTEXT));
    var source = (0, (/*@__PURE__*/$parcel$interopDefault($eBFOC)))(sources) || (0, $bBV6T.DEFAULT_SOURCE);
    var extraAttributes = (0, $kbNOG.getExtraAttributes)(event, (0, $dRe9Q.AVP_CONTEXT));
    var components = (0, $kbNOG.getComponents)(event, (0, $dRe9Q.AVP_CONTEXT));
    var packages = (0, $kbNOG.getPackageInfo)(event, (0, $dRe9Q.AVP_CONTEXT));
    var _ref = (0, (/*@__PURE__*/$parcel$interopDefault($eBFOC)))((0, $kbNOG.getPackageInfo)(event, (0, $dRe9Q.AVP_CONTEXT))) || {}, packageName = _ref.packageName, packageVersion = _ref.packageVersion;
    var packageHierarchy = packages.map(function(p) {
        return p.packageVersion ? "".concat(p.packageName, "@").concat(p.packageVersion) : p.packageName;
    });
    var _event$payload = event.payload, _event$payload$eventT = _event$payload.eventType, eventType = _event$payload$eventT === void 0 ? (0, $bBV6T.UI_EVENT_TYPE) : _event$payload$eventT, action = _event$payload.action, actionSubject = _event$payload.actionSubject, actionSubjectId = _event$payload.actionSubjectId, payloadAttributes = _event$payload.attributes, name = _event$payload.name;
    var attributes = $519730399a79dca8$var$_objectSpread($519730399a79dca8$var$_objectSpread($519730399a79dca8$var$_objectSpread({
        listenerVersion: $519730399a79dca8$var$listenerVersion,
        sourceHierarchy: sources.join('.') || undefined,
        componentHierarchy: components.join('.') || undefined,
        packageHierarchy: packageHierarchy.join(',') || undefined
    }, {
        packageName: packageName,
        packageVersion: packageVersion
    }), (0, (/*@__PURE__*/$parcel$interopDefault($34xOs)))(extraAttributes, payloadAttributes)), (0, (/*@__PURE__*/$parcel$interopDefault($34xOs))).apply(void 0, [
        {}
    ].concat((0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(event.context))));
    // Ensure navigation tag is not duplicated by using Set
    var tags = new Set(event.payload.tags || []);
    tags.add($519730399a79dca8$var$AVP_TAG);
    if (event.payload) switch(eventType){
        case 0, $bBV6T.UI_EVENT_TYPE:
        case 0, $bBV6T.OPERATIONAL_EVENT_TYPE:
        case 0, $bBV6T.TRACK_EVENT_TYPE:
            return {
                eventType: eventType,
                source: source,
                actionSubject: actionSubject,
                action: action,
                actionSubjectId: actionSubjectId,
                attributes: attributes,
                tags: Array.from(tags)
            };
        case 0, $bBV6T.SCREEN_EVENT_TYPE:
            return {
                eventType: eventType,
                name: name,
                attributes: attributes,
                tags: Array.from(tags)
            };
        default:
            logger.error('Invalid event type', eventType);
            break;
    }
    return null;
};

});


parcelRegister("6Edu4", function(module, exports) {
$parcel$export(module.exports, "default", () => $4d70f022519508f2$export$2e2bcd8739ae039);

var $kqp0i = parcelRequire("kqp0i");

var $5FkrB = parcelRequire("5FkrB");

var $2H1dZ = parcelRequire("2H1dZ");

var $9Ax9d = parcelRequire("9Ax9d");

var $aDmPS = parcelRequire("aDmPS");
function $4d70f022519508f2$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $aDmPS.default), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, props, {
        channel: (0, $2H1dZ.FabricChannel).growth,
        processEvent: (0, $9Ax9d.default)
    }));
}

});
parcelRegister("9Ax9d", function(module, exports) {
$parcel$export(module.exports, "default", () => $6fb1304154a263ef$export$2e2bcd8739ae039);

var $25nEq = parcelRequire("25nEq");

var $eBFOC = parcelRequire("eBFOC");

var $34xOs = parcelRequire("34xOs");

var $bBV6T = parcelRequire("bBV6T");
parcelRequire("2WYRt");
var $a4wHv = parcelRequire("a4wHv");

var $kbNOG = parcelRequire("kbNOG");
function $6fb1304154a263ef$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $6fb1304154a263ef$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $6fb1304154a263ef$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $6fb1304154a263ef$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $6fb1304154a263ef$var$GROWTH_TAG = 'growth';
var $6fb1304154a263ef$var$listenerVersion = "0.0.0-development";
var /**
 * This util exists to convert the analytics-next event format into the analytics platform format.
 *
 * Analytics-next event format:
 * event {
 *      payload: {
 *          ...attributesFromLowestPointInTheTree
 *      },
 *      context: [{
 *          ...attributesFromHighestPointInTheTree
 *      }, {
 *          ...attributesFromSecondHighestPointInTheTree
 *      }]
 * }
 *
 * Analytics platform event format:
 *  event {
 *      type: @atlaskit/analytics-gas-types.EventType
 *      payload {
 *          ...mandatoryAttributesBasedOnEventType
 *          attributes: {
 *              ...arbitraryAttributes
 *          }
 *      }
 *  }
 */ $6fb1304154a263ef$export$2e2bcd8739ae039 = function(event, logger) {
    var sources = (0, $kbNOG.getSources)(event, (0, $a4wHv.GROWTH_CONTEXT));
    var source = (0, (/*@__PURE__*/$parcel$interopDefault($eBFOC)))(sources) || (0, $bBV6T.DEFAULT_SOURCE);
    var extraAttributes = (0, $kbNOG.getExtraAttributes)(event, (0, $a4wHv.GROWTH_CONTEXT));
    var components = (0, $kbNOG.getComponents)(event, (0, $a4wHv.GROWTH_CONTEXT));
    var packages = (0, $kbNOG.getPackageInfo)(event, (0, $a4wHv.GROWTH_CONTEXT));
    var _ref = (0, (/*@__PURE__*/$parcel$interopDefault($eBFOC)))((0, $kbNOG.getPackageInfo)(event, (0, $a4wHv.GROWTH_CONTEXT))) || {}, packageName = _ref.packageName, packageVersion = _ref.packageVersion;
    var packageHierarchy = packages.map(function(p) {
        return p.packageVersion ? "".concat(p.packageName, "@").concat(p.packageVersion) : p.packageName;
    });
    var _event$payload = event.payload, _event$payload$eventT = _event$payload.eventType, eventType = _event$payload$eventT === void 0 ? (0, $bBV6T.UI_EVENT_TYPE) : _event$payload$eventT, action = _event$payload.action, actionSubject = _event$payload.actionSubject, actionSubjectId = _event$payload.actionSubjectId, payloadAttributes = _event$payload.attributes, name = _event$payload.name;
    var attributes = $6fb1304154a263ef$var$_objectSpread($6fb1304154a263ef$var$_objectSpread({
        listenerVersion: $6fb1304154a263ef$var$listenerVersion,
        sourceHierarchy: sources.join('.') || undefined,
        componentHierarchy: components.join('.') || undefined,
        packageHierarchy: packageHierarchy.join(',') || undefined
    }, {
        packageName: packageName,
        packageVersion: packageVersion
    }), (0, (/*@__PURE__*/$parcel$interopDefault($34xOs)))(extraAttributes, payloadAttributes));
    // Ensure navigation tag is not duplicated by using Set
    var tags = new Set(event.payload.tags || []);
    tags.add($6fb1304154a263ef$var$GROWTH_TAG);
    if (event.payload) switch(eventType){
        case 0, $bBV6T.UI_EVENT_TYPE:
        case 0, $bBV6T.OPERATIONAL_EVENT_TYPE:
        case 0, $bBV6T.TRACK_EVENT_TYPE:
            return {
                eventType: eventType,
                source: source,
                actionSubject: actionSubject,
                action: action,
                actionSubjectId: actionSubjectId,
                attributes: attributes,
                tags: Array.from(tags)
            };
        case 0, $bBV6T.SCREEN_EVENT_TYPE:
            return {
                eventType: eventType,
                name: name,
                attributes: attributes,
                tags: Array.from(tags)
            };
        default:
            logger.error('Invalid event type', eventType);
            break;
    }
    return null;
};

});


parcelRegister("eDDnG", function(module, exports) {
$parcel$export(module.exports, "default", () => $aa8341792f93c1e9$export$2e2bcd8739ae039);

var $kqp0i = parcelRequire("kqp0i");

var $5FkrB = parcelRequire("5FkrB");

var $2H1dZ = parcelRequire("2H1dZ");

var $aKOmH = parcelRequire("aKOmH");

var $aDmPS = parcelRequire("aDmPS");
var $aa8341792f93c1e9$var$OmniChannelAnalyticsListener = function OmniChannelAnalyticsListener(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $aDmPS.default), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, props, {
        channel: (0, $2H1dZ.FabricChannel).omniChannel,
        processEvent: (0, $aKOmH.default)
    }));
};
var $aa8341792f93c1e9$export$2e2bcd8739ae039 = $aa8341792f93c1e9$var$OmniChannelAnalyticsListener;

});
parcelRegister("aKOmH", function(module, exports) {
$parcel$export(module.exports, "default", () => $7d4544b6acec2aab$export$2e2bcd8739ae039);

var $25nEq = parcelRequire("25nEq");

var $bBV6T = parcelRequire("bBV6T");
parcelRequire("2WYRt");
var $LLMKz = parcelRequire("LLMKz");

var $kbNOG = parcelRequire("kbNOG");

var $eBFOC = parcelRequire("eBFOC");

var $34xOs = parcelRequire("34xOs");

var $2H1dZ = parcelRequire("2H1dZ");
function $7d4544b6acec2aab$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $7d4544b6acec2aab$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $7d4544b6acec2aab$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $7d4544b6acec2aab$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $7d4544b6acec2aab$var$listenerVersion = "0.0.0-development";
var $7d4544b6acec2aab$export$2e2bcd8739ae039 = function(event, logger) {
    var sources = (0, $kbNOG.getSources)(event, (0, $LLMKz.OMNI_CHANNEL_CONTEXT));
    var source = (0, (/*@__PURE__*/$parcel$interopDefault($eBFOC)))(sources) || (0, $bBV6T.DEFAULT_SOURCE);
    var extraAttributes = (0, $kbNOG.getExtraAttributes)(event, (0, $LLMKz.OMNI_CHANNEL_CONTEXT));
    var components = (0, $kbNOG.getComponents)(event, (0, $LLMKz.OMNI_CHANNEL_CONTEXT));
    var packages = (0, $kbNOG.getPackageInfo)(event, (0, $LLMKz.OMNI_CHANNEL_CONTEXT));
    var _ref = (0, (/*@__PURE__*/$parcel$interopDefault($eBFOC)))((0, $kbNOG.getPackageInfo)(event, (0, $LLMKz.OMNI_CHANNEL_CONTEXT))) || {}, packageName = _ref.packageName, packageVersion = _ref.packageVersion;
    var packageHierarchy = packages.map(function(p) {
        return p.packageVersion ? "".concat(p.packageName, "@").concat(p.packageVersion) : p.packageName;
    });
    var _event$payload = event.payload, _event$payload$eventT = _event$payload.eventType, eventType = _event$payload$eventT === void 0 ? (0, $bBV6T.UI_EVENT_TYPE) : _event$payload$eventT, action = _event$payload.action, actionSubject = _event$payload.actionSubject, actionSubjectId = _event$payload.actionSubjectId, payloadAttributes = _event$payload.attributes, name = _event$payload.name;
    var attributes = $7d4544b6acec2aab$var$_objectSpread($7d4544b6acec2aab$var$_objectSpread({
        listenerVersion: $7d4544b6acec2aab$var$listenerVersion,
        sourceHierarchy: sources.join('.') || undefined,
        componentHierarchy: components.join('.') || undefined,
        packageHierarchy: packageHierarchy.join(',') || undefined
    }, {
        packageName: packageName,
        packageVersion: packageVersion
    }), (0, (/*@__PURE__*/$parcel$interopDefault($34xOs)))(extraAttributes, payloadAttributes));
    // Ensure navigation tag is not duplicated by using Set
    var tags = new Set(event.payload.tags || []);
    tags.add((0, $2H1dZ.FabricChannel).omniChannel);
    if (event.payload) switch(eventType){
        case 0, $bBV6T.UI_EVENT_TYPE:
        case 0, $bBV6T.OPERATIONAL_EVENT_TYPE:
        case 0, $bBV6T.TRACK_EVENT_TYPE:
            return {
                eventType: eventType,
                source: source,
                actionSubject: actionSubject,
                action: action,
                actionSubjectId: actionSubjectId,
                attributes: attributes,
                tags: Array.from(tags)
            };
        case 0, $bBV6T.SCREEN_EVENT_TYPE:
            return {
                eventType: eventType,
                name: name,
                attributes: attributes,
                tags: Array.from(tags)
            };
        default:
            logger.error('Invalid event type', eventType);
            break;
    }
    return null;
};

});


parcelRegister("9oOCJ", function(module, exports) {
$parcel$export(module.exports, "default", () => $6d7d9fc5a5004b0b$export$2e2bcd8739ae039);

var $kqp0i = parcelRequire("kqp0i");

var $5FkrB = parcelRequire("5FkrB");

var $2H1dZ = parcelRequire("2H1dZ");

var $MShoo = parcelRequire("MShoo");

var $aDmPS = parcelRequire("aDmPS");
function $6d7d9fc5a5004b0b$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $aDmPS.default), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, props, {
        channel: (0, $2H1dZ.FabricChannel).townsquareHome,
        processEvent: (0, $MShoo.default)
    }));
}

});
parcelRegister("MShoo", function(module, exports) {
$parcel$export(module.exports, "default", () => $092e96977c2e1544$export$2e2bcd8739ae039);

var $25nEq = parcelRequire("25nEq");

var $eBFOC = parcelRequire("eBFOC");

var $34xOs = parcelRequire("34xOs");

var $bBV6T = parcelRequire("bBV6T");

var $kbNOG = parcelRequire("kbNOG");
parcelRequire("2WYRt");
var $kBCsH = parcelRequire("kBCsH");
function $092e96977c2e1544$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $092e96977c2e1544$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $092e96977c2e1544$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $092e96977c2e1544$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $092e96977c2e1544$var$TOWNSQUARE_TAG = 'townsquare';
var $092e96977c2e1544$var$TOWNSQUARE_HOME_TAG = 'townsquareHome';
var $092e96977c2e1544$var$listenerVersion = "0.0.0-development";
var /**
 * This util exists to convert the analytics-next event format into the analytics platform format.
 *
 * It's a copy paste from the other process-event mappers.
 */ $092e96977c2e1544$export$2e2bcd8739ae039 = function(event, logger) {
    var sources = (0, $kbNOG.getSources)(event, (0, $kBCsH.TOWNSQUARE_HOME_CONTEXT));
    var source = (0, (/*@__PURE__*/$parcel$interopDefault($eBFOC)))(sources) || (0, $bBV6T.DEFAULT_SOURCE);
    var extraAttributes = (0, $kbNOG.getExtraAttributes)(event, (0, $kBCsH.TOWNSQUARE_HOME_CONTEXT));
    var components = (0, $kbNOG.getComponents)(event, (0, $kBCsH.TOWNSQUARE_HOME_CONTEXT));
    var packages = (0, $kbNOG.getPackageInfo)(event, (0, $kBCsH.TOWNSQUARE_HOME_CONTEXT));
    var _ref = (0, (/*@__PURE__*/$parcel$interopDefault($eBFOC)))((0, $kbNOG.getPackageInfo)(event, (0, $kBCsH.TOWNSQUARE_HOME_CONTEXT))) || {}, packageName = _ref.packageName, packageVersion = _ref.packageVersion;
    var packageHierarchy = packages.map(function(p) {
        return p.packageVersion ? "".concat(p.packageName, "@").concat(p.packageVersion) : p.packageName;
    });
    var _event$payload = event.payload, _event$payload$eventT = _event$payload.eventType, eventType = _event$payload$eventT === void 0 ? (0, $bBV6T.UI_EVENT_TYPE) : _event$payload$eventT, action = _event$payload.action, actionSubject = _event$payload.actionSubject, actionSubjectId = _event$payload.actionSubjectId, payloadAttributes = _event$payload.attributes, name = _event$payload.name;
    var attributes = $092e96977c2e1544$var$_objectSpread($092e96977c2e1544$var$_objectSpread({
        listenerVersion: $092e96977c2e1544$var$listenerVersion,
        sourceHierarchy: sources.join('.') || undefined,
        componentHierarchy: components.join('.') || undefined,
        packageHierarchy: packageHierarchy.join(',') || undefined
    }, {
        packageName: packageName,
        packageVersion: packageVersion
    }), (0, (/*@__PURE__*/$parcel$interopDefault($34xOs)))(extraAttributes, payloadAttributes));
    var tags = new Set(event.payload.tags || []);
    // "townsquare" is our platform analytic for data portal
    tags.add($092e96977c2e1544$var$TOWNSQUARE_TAG);
    // "townsquareHome" allows us to differentiate our events from townsquare events.
    tags.add($092e96977c2e1544$var$TOWNSQUARE_HOME_TAG);
    if (event.payload) switch(eventType){
        case 0, $bBV6T.UI_EVENT_TYPE:
        case 0, $bBV6T.OPERATIONAL_EVENT_TYPE:
        case 0, $bBV6T.TRACK_EVENT_TYPE:
            return {
                eventType: eventType,
                source: source,
                actionSubject: actionSubject,
                action: action,
                actionSubjectId: actionSubjectId,
                attributes: attributes,
                tags: Array.from(tags)
            };
        case 0, $bBV6T.SCREEN_EVENT_TYPE:
            return {
                eventType: eventType,
                name: name,
                attributes: attributes,
                tags: Array.from(tags)
            };
        default:
            logger.error('Invalid event type', eventType);
            break;
    }
    return null;
};

});




parcelRegister("hFyhw", function(module, exports) {
$parcel$export(module.exports, "default", () => $cdd0db9bf3992173$export$2e2bcd8739ae039);

var $fC8ib = parcelRequire("fC8ib");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $25nEq = parcelRequire("25nEq");

var $kX1mK = parcelRequire("kX1mK");

var $ht7Bg = parcelRequire("ht7Bg");

var $kRa9z = parcelRequire("kRa9z");

var $l8uaJ = parcelRequire("l8uaJ");

var $jJH6F = parcelRequire("jJH6F");

var $hYeeB = parcelRequire("hYeeB");

var $9Zzpd = parcelRequire("9Zzpd");

var $1IPWy = parcelRequire("1IPWy");

var $35DNJ = parcelRequire("35DNJ");

var $7KUde = parcelRequire("7KUde");
function $cdd0db9bf3992173$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $cdd0db9bf3992173$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $cdd0db9bf3992173$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $cdd0db9bf3992173$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $cdd0db9bf3992173$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    // Any kind of refence is allowed
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    function RendererActions() {
        var initFromContext = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, RendererActions);
        // This is our psuedo feature flag for now
        // This module can only be used when wrapped with
        // the <RendererContext> component for now.
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "initFromContext", false);
        this.initFromContext = initFromContext;
        this.transformer = new (0, $kRa9z.JSONTransformer)();
    }
    //#region private
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(RendererActions, [
        {
            key: "_privateRegisterRenderer",
            value: function _privateRegisterRenderer(ref, doc, schema, onAnalyticsEvent) {
                if (!this.initFromContext) return;
                else if (!this.ref) this.ref = ref;
                else if (this.ref !== ref) throw new Error("Renderer has already been registered! It's not allowed to re-register with another new Renderer instance.");
                this.doc = doc;
                this.schema = schema;
                this.onAnalyticsEvent = onAnalyticsEvent;
            }
        },
        {
            key: "_privateUnregisterRenderer",
            value: function _privateUnregisterRenderer() {
                this.doc = undefined;
                this.ref = undefined;
                this.schema = undefined;
            }
        },
        {
            key: "_privateValidatePositionsForAnnotation",
            value: function _privateValidatePositionsForAnnotation(from, to) {
                if (!this.doc || !this.schema) return false;
                var currentSelection = (0, $l8uaJ.TextSelection).create(this.doc, from, to);
                if ((0, $ht7Bg.isEmptyTextSelectionRenderer)(currentSelection, this.schema)) return false;
                var result = (0, $ht7Bg.canApplyAnnotationOnRange)({
                    from: from,
                    to: to
                }, this.doc, this.schema);
                return result;
            }
        },
        {
            key: "deleteAnnotation",
            value: function deleteAnnotation(annotationId, annotationType) {
                if (!this.doc || !this.schema || !this.schema.marks.annotation) return false;
                var mark = this.schema.marks.annotation.create({
                    id: annotationId,
                    annotationType: annotationType
                });
                var from;
                var to;
                var nodePos;
                var step;
                this.doc.descendants(function(node, pos) {
                    var found = mark.isInSet(node.marks);
                    if (found && node.type.name === 'media') nodePos = pos;
                    if (found && !from) {
                        // Set both here incase it only spans one node.
                        from = pos;
                        to = pos + node.nodeSize;
                    } else if (found && from) // If the mark spans multiple nodes,
                    // we'll keep setting the end until no longer found.
                    to = pos + node.nodeSize;
                    return true;
                });
                if (nodePos !== undefined) step = new (0, $hYeeB.RemoveNodeMarkStep)(nodePos, mark);
                else {
                    if (from === undefined || to === undefined) return false;
                    step = new (0, $hYeeB.RemoveMarkStep)(from, to, mark);
                }
                var _step$apply = step.apply(this.doc), doc = _step$apply.doc, failed = _step$apply.failed;
                if (this.onAnalyticsEvent) {
                    var payload = {
                        action: (0, $jJH6F.ACTION).DELETED,
                        actionSubject: (0, $jJH6F.ACTION_SUBJECT).ANNOTATION,
                        actionSubjectId: (0, $jJH6F.ACTION_SUBJECT_ID).INLINE_COMMENT,
                        eventType: (0, $jJH6F.EVENT_TYPE).TRACK,
                        attributes: {
                            inlineNodeNames: step instanceof (0, $hYeeB.RemoveMarkStep) ? (0, $35DNJ.getRendererRangeInlineNodeNames)({
                                // Ignored via go/ees005
                                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                                pos: {
                                    from: from,
                                    to: to
                                },
                                actions: this
                            }) : undefined
                        }
                    };
                    this.onAnalyticsEvent(payload);
                }
                if (!failed && doc) return {
                    step: step,
                    doc: this.transformer.encode(doc)
                };
                return false;
            }
        },
        {
            key: "annotate",
            value: function annotate(range, annotationId, _annotationType) {
                if (!this.doc || !this.schema || !this.schema.marks.annotation) return false;
                var pos = (0, $1IPWy.getPosFromRange)(range);
                if (!pos) return false;
                var from = pos.from, to = pos.to;
                var validPositions = this._privateValidatePositionsForAnnotation(from, to);
                if (!validPositions) return false;
                return this.applyAnnotation(pos, {
                    annotationId: annotationId,
                    annotationType: (0, $kX1mK.AnnotationTypes).INLINE_COMMENT
                });
            }
        },
        {
            key: "isValidAnnotationRange",
            value: function isValidAnnotationRange(range) {
                if (!range) return false;
                if ((0, $9Zzpd.fg)('editor_inline_comments_on_inline_nodes')) {
                    if (this.isRendererWithinRange(range)) return false;
                }
                var pos = (0, $1IPWy.getPosFromRange)(range);
                if (!pos || !this.doc) return false;
                return this._privateValidatePositionsForAnnotation(pos.from, pos.to);
            }
        },
        {
            key: "isRangeAnnotatable",
            value: function isRangeAnnotatable(range) {
                try {
                    var _startContainer$paren, _endContainer$parentE;
                    if (!range) return false;
                    var startContainer = range.startContainer, endContainer = range.endContainer;
                    if ((_startContainer$paren = startContainer.parentElement) !== null && _startContainer$paren !== void 0 && _startContainer$paren.closest('.ak-renderer-extension') || (_endContainer$parentE = endContainer.parentElement) !== null && _endContainer$parentE !== void 0 && _endContainer$parentE.closest('.ak-renderer-extension')) return false;
                    return this.isValidAnnotationRange(range);
                } catch (_unused) {
                    // isValidAnnotationRange can fail when called inside nested renderers.
                    // while isRendererWithinRange guards against this to some degree -- the classnames
                    // are controlled by product -- and we don't have platform guarantees on them.
                    //
                    // Currently there is a mix of logic across the platform and confluence on determining
                    // positions that are annotatable. This is a defensive check to ensure we don't throw an error
                    // in cases where the range is not valid.
                    return false;
                }
            }
        },
        {
            key: "isRendererWithinRange",
            value: function isRendererWithinRange(range) {
                var startContainer = range.startContainer, endContainer = range.endContainer;
                if (startContainer.parentElement && startContainer.parentElement.closest('.ak-renderer-extension') || endContainer.parentElement && endContainer.parentElement.closest('.ak-renderer-extension')) return true;
                return false;
            }
        },
        {
            key: "isValidAnnotationPosition",
            value: function isValidAnnotationPosition(pos) {
                if (!pos || !this.doc) return false;
                return this._privateValidatePositionsForAnnotation(pos.from, pos.to);
            }
        },
        {
            key: "getPositionFromRange",
            value: function getPositionFromRange(range) {
                if (!this.doc || !this.schema || !range) return false;
                return (0, $1IPWy.getPosFromRange)(range);
            }
        },
        {
            key: "getAnnotationMarks",
            value: function getAnnotationMarks() {
                var schema = this.schema, doc = this.doc;
                if (!schema || !doc) return [];
                var annotationMarkType = schema.marks.annotation;
                if (!annotationMarkType) return [];
                var marks = [];
                doc.descendants(function(node) {
                    var annotationsMark = node.marks.filter(function(m) {
                        return m.type === annotationMarkType;
                    });
                    if (!annotationsMark || !annotationsMark.length) return true;
                    marks.push.apply(marks, (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(annotationsMark));
                    return false;
                });
                var uniqueMarks = new Map();
                marks.forEach(function(m) {
                    uniqueMarks.set(m.attrs.id, m);
                });
                return Array.from(uniqueMarks.values());
            }
        },
        {
            key: "getAnnotationsByPosition",
            value: function getAnnotationsByPosition(range) {
                if (!this.doc || !this.schema) return [];
                var pos = (0, $1IPWy.getPosFromRange)(range);
                if (!pos || !this.doc) return [];
                return (0, $ht7Bg.getAnnotationIdsFromRange)(pos, this.doc, this.schema);
            }
        },
        {
            key: "applyAnnotation",
            value: function applyAnnotation(pos, annotation) {
                if (!this.doc || !pos || !this.schema) return false;
                var from = pos.from, to = pos.to;
                var annotationId = annotation.annotationId, annotationType = annotation.annotationType;
                var step;
                var targetNodeType;
                // As part of fix for RAP, `from` points to the position right before media node
                // hence, -1 is not needed
                var beforeNodePos = from;
                var possibleNode = this.doc.nodeAt(beforeNodePos);
                if ((possibleNode === null || possibleNode === void 0 ? void 0 : possibleNode.type.name) === 'media') {
                    targetNodeType = 'media';
                    step = new (0, $hYeeB.AddNodeMarkStep)(beforeNodePos, this.schema.marks.annotation.create({
                        id: annotationId,
                        type: annotationType
                    }));
                } else {
                    var resolvedNode = this.doc.resolve(from).node();
                    // annotation is technically on text, but the context is caption
                    targetNodeType = resolvedNode.type.name === 'caption' ? 'caption' : 'text';
                    step = (0, $1IPWy.createAnnotationStep)(from, to, {
                        annotationId: annotationId,
                        annotationType: annotationType,
                        schema: this.schema
                    });
                }
                var _step$apply2 = step.apply(this.doc), doc = _step$apply2.doc, failed = _step$apply2.failed;
                if (failed || !doc) return false;
                var originalSelection = doc.textBetween(from, to);
                var _getIndexMatch = (0, $7KUde.getIndexMatch)(this.doc, this.schema, originalSelection, from), numMatches = _getIndexMatch.numMatches, matchIndex = _getIndexMatch.matchIndex, blockNodePos = _getIndexMatch.blockNodePos;
                return $cdd0db9bf3992173$var$_objectSpread({
                    step: step,
                    doc: this.transformer.encode(doc),
                    inlineNodeTypes: (0, $35DNJ.getRendererRangeInlineNodeNames)({
                        actions: this,
                        pos: {
                            from: from,
                            to: to
                        }
                    }),
                    ancestorNodeTypes: (0, $35DNJ.getRendererRangeAncestorNodeNames)({
                        actions: this,
                        pos: {
                            from: from,
                            to: to
                        }
                    }),
                    originalSelection: originalSelection,
                    numMatches: numMatches,
                    matchIndex: matchIndex,
                    pos: blockNodePos
                }, {
                    targetNodeType: targetNodeType
                });
            }
        },
        {
            key: "generateAnnotationIndexMatch",
            value: function generateAnnotationIndexMatch(pos) {
                if (!this.doc || !pos || !this.schema) return false;
                var from = pos.from, to = pos.to;
                var originalSelection = this.doc.textBetween(from, to);
                var _getIndexMatch2 = (0, $7KUde.getIndexMatch)(this.doc, this.schema, originalSelection, from), numMatches = _getIndexMatch2.numMatches, matchIndex = _getIndexMatch2.matchIndex, blockNodePos = _getIndexMatch2.blockNodePos;
                return {
                    originalSelection: originalSelection,
                    numMatches: numMatches,
                    matchIndex: matchIndex,
                    pos: blockNodePos
                };
            }
        },
        {
            key: "getInlineNodeTypes",
            value: function getInlineNodeTypes(annotationId) {
                if (!this.doc || !this.schema) return [];
                return (0, $ht7Bg.getAnnotationInlineNodeTypes)({
                    doc: this.doc,
                    schema: this.schema
                }, annotationId);
            }
        }
    ]);
}();

});
parcelRegister("ht7Bg", function(module, exports) {
$parcel$export(module.exports, "canApplyAnnotationOnRange", () => $cb7b0a5052cddeaa$export$77ddf8216f9eb904);
$parcel$export(module.exports, "getAnnotationIdsFromRange", () => $cb7b0a5052cddeaa$export$badbcc229c848aec);
$parcel$export(module.exports, "getRangeInlineNodeNames", () => $cb7b0a5052cddeaa$export$35054451202ed5d9);
$parcel$export(module.exports, "getRangeAncestorNodeNames", () => $cb7b0a5052cddeaa$export$2a160f09551a3adc);
$parcel$export(module.exports, "getAnnotationInlineNodeTypes", () => $cb7b0a5052cddeaa$export$8261bc1f662f3f6e);
$parcel$export(module.exports, "isEmptyTextSelectionRenderer", () => $cb7b0a5052cddeaa$export$a35880e7ecdcf47b);

var $fC8ib = parcelRequire("fC8ib");

var $jJtX0 = parcelRequire("jJtX0");

var $9Zzpd = parcelRequire("9Zzpd");
var $cb7b0a5052cddeaa$export$77ddf8216f9eb904 = function canApplyAnnotationOnRange(rangeSelection, doc, schema) {
    var from = rangeSelection.from, to = rangeSelection.to;
    if (isNaN(from + to) || to - from <= 0 || to < 0 || from < 0) return false;
    var foundInvalid = false;
    doc.nodesBetween(rangeSelection.from, rangeSelection.to, function(node, _pos, parent) {
        // Special exception for hardBreak nodes
        if (schema.nodes.hardBreak === node.type) return false;
        // For block elements or text nodes, we want to check
        // if annotations are allowed inside this tree
        // or if we're leaf and not text
        if ((0, $9Zzpd.fg)('editor_inline_comments_on_inline_nodes')) {
            var isAllowedInlineNode = [
                'emoji',
                'status',
                'date',
                'mention',
                'inlineCard'
            ].includes(node.type.name);
            if (node.isInline && !node.isText && !isAllowedInlineNode || node.isLeaf && !node.isText && !isAllowedInlineNode || node.isText && !(parent !== null && parent !== void 0 && parent.type.allowsMarkType(schema.marks.annotation))) {
                foundInvalid = true;
                return false;
            }
        } else if (node.isInline && !node.isText || node.isLeaf && !node.isText || node.isText && !(parent !== null && parent !== void 0 && parent.type.allowsMarkType(schema.marks.annotation))) {
            foundInvalid = true;
            return false;
        }
        return true;
    });
    return !foundInvalid;
};
var $cb7b0a5052cddeaa$export$badbcc229c848aec = function getAnnotationIdsFromRange(rangeSelection, doc, schema) {
    var from = rangeSelection.from, to = rangeSelection.to;
    var annotations = new Set();
    doc.nodesBetween(from, to, function(node) {
        if (!node.marks) return true;
        node.marks.forEach(function(mark) {
            if (mark.type === schema.marks.annotation && mark.attrs) annotations.add(mark.attrs.id);
        });
        return true;
    });
    return Array.from(annotations);
};
function $cb7b0a5052cddeaa$export$5fe1412b20386053(node, state) {
    var annotationMark = state.schema.marks.annotation;
    return !!(annotationMark && node && node.marks.length && annotationMark.isInSet(node.marks));
}
function $cb7b0a5052cddeaa$export$1976770b876b2728(slice, state) {
    if (!slice.content.size) return false;
    var hasAnnotation = false;
    slice.content.forEach(function(node) {
        hasAnnotation = hasAnnotation || $cb7b0a5052cddeaa$export$5fe1412b20386053(node, state);
        // return early if annotation found already
        if (hasAnnotation) return true;
        // check annotations in descendants
        node.descendants(function(node) {
            if ($cb7b0a5052cddeaa$export$5fe1412b20386053(node, state)) {
                hasAnnotation = true;
                return false;
            }
            return true;
        });
    });
    return hasAnnotation;
}
function $cb7b0a5052cddeaa$export$35054451202ed5d9(_ref) {
    var doc = _ref.doc, pos = _ref.pos;
    if (!(0, $9Zzpd.fg)('editor_inline_comments_on_inline_nodes')) return undefined;
    var nodeNames = new Set();
    try {
        doc.nodesBetween(pos.from, pos.to, function(node) {
            if (node.isInline) nodeNames.add(node.type.name);
        });
        // We sort the list alphabetically to make human consumption of the list easier (in tools like the analytics extension)
        var sortedNames = (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(nodeNames).sort();
        return sortedNames;
    } catch (_unused) {
        // Some callers have existing gaps where the positions are not valid,
        // and so when called in the current document can throw an error if out of range.
        //
        // This is a defensive check to ensure we don't throw an error in those cases.
        return undefined;
    }
}
function $cb7b0a5052cddeaa$export$2a160f09551a3adc(_ref2) {
    var doc = _ref2.doc, pos = _ref2.pos;
    if (!(0, $9Zzpd.fg)('cc_comments_log_draft_annotation_ancestor_nodes')) return undefined;
    var nodeNames = new Set();
    try {
        // For a range, we can get ancestors at both from and to positions
        // or just use the from position if you want ancestors at the start
        var resolvedFromPos = doc.resolve(pos.from);
        var resolvedToPos = doc.resolve(pos.to);
        // Collect ancestors at the 'from' position
        for(var depth = resolvedFromPos.depth; depth > 0; depth--){
            var ancestorNode = resolvedFromPos.node(depth);
            nodeNames.add(ancestorNode.type.name);
        }
        // Use nodesBetween to collect parent types without additional resolve() calls
        // This isn't as precise as calling resolve() on each parent, but it's a lot faster
        // and should hopefully provide a good approximation of the ancestor nodes
        var seenParents = new Set();
        doc.nodesBetween(pos.from, pos.to, function(_node, _nodePos, parent) {
            // Collect parent chain using the parent parameter
            var currentParent = parent;
            if (!!currentParent && !seenParents.has(currentParent)) {
                seenParents.add(currentParent);
                nodeNames.add(currentParent.type.name);
            // Note: We can't easily get the parent's parent from this context
            // without additional resolve calls, so this approach has limitations
            }
            return true;
        });
        // Optionally collect ancestors at the 'to' position if different
        // This ensures we capture all ancestor contexts across the range
        if (pos.from !== pos.to) for(var _depth = resolvedToPos.depth; _depth > 0; _depth--){
            var _ancestorNode = resolvedToPos.node(_depth);
            nodeNames.add(_ancestorNode.type.name);
        }
        return (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(nodeNames);
    } catch (_unused2) {
        // Some callers have existing gaps where the positions are not valid,
        // and so when called in the current document can throw an error if out of range.
        //
        // This is a defensive check to ensure we don't throw an error in those cases.
        return undefined;
    }
}
function $cb7b0a5052cddeaa$export$8261bc1f662f3f6e(state, annotationId) {
    if (!(0, $9Zzpd.fg)('editor_inline_comments_on_inline_nodes')) return undefined;
    var mark = state.schema.marks.annotation.create({
        id: annotationId,
        annotationType: (0, $jJtX0.AnnotationTypes).INLINE_COMMENT
    });
    var inlineNodeNames = new Set();
    state.doc.descendants(function(node, _pos) {
        if (mark.isInSet(node.marks)) inlineNodeNames.add(node.type.name);
        return true;
    });
    // This sorting is done to make human consumption easier (ie. in dev tools, test snapshots, analytics events, ...)
    return (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(inlineNodeNames).sort();
}
function $cb7b0a5052cddeaa$export$bb1945a828f2864b(pos) {
    var annotationMarks = pos.marks().filter(function(mark) {
        return mark.type === pos.doc.type.schema.marks.annotation;
    });
    return annotationMarks;
}
function $cb7b0a5052cddeaa$export$2efbc6d84ea0fbec(selection, schema) {
    var _schema$nodes = schema.nodes, text = _schema$nodes.text, paragraph = _schema$nodes.paragraph;
    var hasContent = false;
    selection.content().content.descendants(function(node) {
        // for empty paragraph - consider empty (nothing to comment on)
        if (node.type === paragraph && !node.content.size) return false;
        // for not a text or nonempty text - consider nonempty (can comment if the node is supported for annotations)
        if (node.type !== text || !node.textContent) hasContent = true;
        return !hasContent;
    });
    return !hasContent;
}
function $cb7b0a5052cddeaa$export$a35880e7ecdcf47b(selection, schema) {
    var _schema$nodes2 = schema.nodes, text = _schema$nodes2.text, paragraph = _schema$nodes2.paragraph;
    var hasContent = false;
    selection.content().content.descendants(function(node) {
        // for empty paragraph - consider empty (nothing to comment on)
        if (node.type === paragraph && !node.content.size) return false;
        // for inline elements - consider nonempty
        if (node.type !== text && node.type.isInline) hasContent = true;
        // for nonempty text - consider nonempty (can comment if the node is supported for annotations)
        if (node.type === text && !!node.textContent) hasContent = true;
        // for other non-text nodes - continue descending
        return !hasContent;
    });
    return !hasContent;
}

});
parcelRegister("jJtX0", function(module, exports) {
$parcel$export(module.exports, "AnnotationTypes", () => $e5d973dfc9b3dd40$export$94aa2fc69ad33d19);
$parcel$export(module.exports, "annotation", () => $e5d973dfc9b3dd40$export$8512c9afa7b24c3b);

var $25nEq = parcelRequire("25nEq");

var $idfOp = parcelRequire("idfOp");
function $e5d973dfc9b3dd40$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $e5d973dfc9b3dd40$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $e5d973dfc9b3dd40$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $e5d973dfc9b3dd40$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $e5d973dfc9b3dd40$export$94aa2fc69ad33d19 = /*#__PURE__*/ function(AnnotationTypes) {
    AnnotationTypes["INLINE_COMMENT"] = "inlineComment";
    return AnnotationTypes;
}({});
var $e5d973dfc9b3dd40$export$4bab14797673da9f = /*#__PURE__*/ function(AnnotationMarkStates) {
    AnnotationMarkStates["RESOLVED"] = "resolved";
    AnnotationMarkStates["ACTIVE"] = "active";
    return AnnotationMarkStates;
}({});
function $e5d973dfc9b3dd40$export$93a98caa8bc6cb07(_ref) {
    var id = _ref.id, annotationType = _ref.annotationType, state = _ref.state;
    var data = {
        'data-mark-type': 'annotation',
        'data-mark-annotation-type': annotationType,
        'data-id': id
    };
    if (state) return $e5d973dfc9b3dd40$var$_objectSpread($e5d973dfc9b3dd40$var$_objectSpread({}, data), {}, {
        'data-mark-annotation-state': state
    });
    return data;
}
var $e5d973dfc9b3dd40$export$8512c9afa7b24c3b = (0, $idfOp.annotation)({
    parseDOM: [
        {
            tag: 'span[data-mark-type="annotation"]',
            mark: 'annotation',
            getAttrs: function getAttrs(domNode) {
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                var dom = domNode;
                var attrs = {
                    id: dom.getAttribute('data-id'),
                    annotationType: dom.getAttribute('data-mark-annotation-type')
                };
                return attrs;
            }
        }
    ],
    toDOM: function toDOM(node) {
        /*
        Data attributes on the DOM node are a temporary means of
        incrementally switching over to the Annotation mark. Once renderer
        provides native support for inline comments the data attributes on the
        DOM nodes will be removed.
      */ return [
            'span',
            $e5d973dfc9b3dd40$var$_objectSpread({
                // Prettier will remove the quotes around class. This would cause some browsers
                // to not add this attribute properly, as its a reserved word.
                // prettier-ignore
                'class': 'fabric-editor-annotation'
            }, $e5d973dfc9b3dd40$export$93a98caa8bc6cb07({
                id: node.attrs.id,
                annotationType: node.attrs.annotationType
            })),
            0
        ];
    }
});

});
parcelRegister("idfOp", function(module, exports) {
$parcel$export(module.exports, "alignment", () => $d425b4d9712dbab9$export$8e53000a4ec837);
$parcel$export(module.exports, "annotation", () => $d425b4d9712dbab9$export$8512c9afa7b24c3b);
$parcel$export(module.exports, "backgroundColor", () => $d425b4d9712dbab9$export$8c5a050822fd698c);
$parcel$export(module.exports, "border", () => $d425b4d9712dbab9$export$1edee58a52776cd9);
$parcel$export(module.exports, "breakout", () => $d425b4d9712dbab9$export$89015c65f1c75e3f);
$parcel$export(module.exports, "code", () => $d425b4d9712dbab9$export$6565f9f03506010b);
$parcel$export(module.exports, "confluenceInlineComment", () => $d425b4d9712dbab9$export$f3b72f8fc4684ecd);
$parcel$export(module.exports, "dataConsumer", () => $d425b4d9712dbab9$export$3024f02c495408d6);
$parcel$export(module.exports, "em", () => $d425b4d9712dbab9$export$c63c6f932822f543);
$parcel$export(module.exports, "fontSize", () => $d425b4d9712dbab9$export$85e3c3ca0c6fb93);
$parcel$export(module.exports, "fragment", () => $d425b4d9712dbab9$export$f00aeb236b6f05af);
$parcel$export(module.exports, "indentation", () => $d425b4d9712dbab9$export$480c699bd4ec0d86);
$parcel$export(module.exports, "link", () => $d425b4d9712dbab9$export$9c30223ca0a664fb);
$parcel$export(module.exports, "strike", () => $d425b4d9712dbab9$export$4899a95d70ec5056);
$parcel$export(module.exports, "strong", () => $d425b4d9712dbab9$export$59ae2c325a998f89);
$parcel$export(module.exports, "subsup", () => $d425b4d9712dbab9$export$b3401ee80eb31041);
$parcel$export(module.exports, "textColor", () => $d425b4d9712dbab9$export$32f78bffcd82ff28);
$parcel$export(module.exports, "typeAheadQuery", () => $d425b4d9712dbab9$export$20af3dabbb5538df);
$parcel$export(module.exports, "underline", () => $d425b4d9712dbab9$export$425327af25286e5e);
$parcel$export(module.exports, "unsupportedMark", () => $d425b4d9712dbab9$export$30d78d5eb6719bb8);
$parcel$export(module.exports, "unsupportedNodeAttribute", () => $d425b4d9712dbab9$export$a316dc07ff5182a2);
/**
 * This file was automatically generated by @atlaskit/adf-schema-generator
 * DO NOT MODIFY IT BY HAND. Instead, modify the source files in "packages/adf-schema/src/next-schema" ,
 * and run "yarn workspace @atlaskit/adf-schema build:schema:all" to regenerate this file.
 */ 
var $cDw0B = parcelRequire("cDw0B");
var $d425b4d9712dbab9$export$8e53000a4ec837 = (0, $cDw0B.createPMMarkSpecFactory)({
    attrs: {
        align: {}
    },
    excludes: 'alignment indentation',
    group: 'alignment'
});
var $d425b4d9712dbab9$export$8512c9afa7b24c3b = (0, $cDw0B.createPMMarkSpecFactory)({
    attrs: {
        id: {
            default: ''
        },
        annotationType: {
            default: 'inlineComment'
        }
    },
    inclusive: true,
    excludes: '',
    group: 'annotation'
});
var $d425b4d9712dbab9$export$8c5a050822fd698c = (0, $cDw0B.createPMMarkSpecFactory)({
    attrs: {
        color: {}
    },
    inclusive: true,
    excludes: 'color',
    group: 'color'
});
var $d425b4d9712dbab9$export$1edee58a52776cd9 = (0, $cDw0B.createPMMarkSpecFactory)({
    attrs: {
        size: {},
        color: {}
    },
    inclusive: false
});
var $d425b4d9712dbab9$export$89015c65f1c75e3f = (0, $cDw0B.createPMMarkSpecFactory)({
    attrs: {
        mode: {
            default: 'wide'
        },
        width: {
            default: null
        }
    },
    inclusive: false,
    spanning: false
});
var $d425b4d9712dbab9$export$6565f9f03506010b = (0, $cDw0B.createPMMarkSpecFactory)({
    inclusive: true,
    excludes: 'fontStyle link searchQuery color'
});
var $d425b4d9712dbab9$export$f3b72f8fc4684ecd = (0, $cDw0B.createPMMarkSpecFactory)({
    attrs: {
        reference: {
            default: ''
        }
    },
    inclusive: false,
    excludes: ''
});
var $d425b4d9712dbab9$export$3024f02c495408d6 = (0, $cDw0B.createPMMarkSpecFactory)({
    attrs: {
        sources: {
            default: []
        }
    }
});
var $d425b4d9712dbab9$export$c63c6f932822f543 = (0, $cDw0B.createPMMarkSpecFactory)({
    inclusive: true,
    group: 'fontStyle'
});
var $d425b4d9712dbab9$export$85e3c3ca0c6fb93 = (0, $cDw0B.createPMMarkSpecFactory)({
    attrs: {
        fontSize: {}
    },
    inclusive: false,
    spanning: false
});
var $d425b4d9712dbab9$export$f00aeb236b6f05af = (0, $cDw0B.createPMMarkSpecFactory)({
    attrs: {
        localId: {
            default: ''
        },
        name: {
            default: null
        }
    },
    inclusive: false,
    excludes: ''
});
var $d425b4d9712dbab9$export$480c699bd4ec0d86 = (0, $cDw0B.createPMMarkSpecFactory)({
    attrs: {
        level: {}
    },
    excludes: 'indentation alignment',
    group: 'indentation'
});
var $d425b4d9712dbab9$export$9c30223ca0a664fb = (0, $cDw0B.createPMMarkSpecFactory)({
    attrs: {
        href: {},
        __confluenceMetadata: {
            default: null
        }
    },
    inclusive: false,
    excludes: 'link',
    group: 'link'
});
var $d425b4d9712dbab9$export$4899a95d70ec5056 = (0, $cDw0B.createPMMarkSpecFactory)({
    inclusive: true,
    group: 'fontStyle'
});
var $d425b4d9712dbab9$export$59ae2c325a998f89 = (0, $cDw0B.createPMMarkSpecFactory)({
    inclusive: true,
    group: 'fontStyle'
});
var $d425b4d9712dbab9$export$b3401ee80eb31041 = (0, $cDw0B.createPMMarkSpecFactory)({
    attrs: {
        type: {
            default: 'sub'
        }
    },
    inclusive: true,
    group: 'fontStyle'
});
var $d425b4d9712dbab9$export$32f78bffcd82ff28 = (0, $cDw0B.createPMMarkSpecFactory)({
    attrs: {
        color: {}
    },
    inclusive: true,
    group: 'color'
});
var $d425b4d9712dbab9$export$20af3dabbb5538df = (0, $cDw0B.createPMMarkSpecFactory)({
    attrs: {
        trigger: {
            default: ''
        }
    },
    inclusive: true,
    group: 'searchQuery'
});
var $d425b4d9712dbab9$export$425327af25286e5e = (0, $cDw0B.createPMMarkSpecFactory)({
    inclusive: true,
    group: 'fontStyle'
});
var $d425b4d9712dbab9$export$30d78d5eb6719bb8 = (0, $cDw0B.createPMMarkSpecFactory)({
    attrs: {
        originalValue: {}
    },
    excludes: ''
});
var $d425b4d9712dbab9$export$a316dc07ff5182a2 = (0, $cDw0B.createPMMarkSpecFactory)({
    attrs: {
        unsupported: {},
        type: {}
    }
});

});
parcelRegister("cDw0B", function(module, exports) {
$parcel$export(module.exports, "createPMNodeSpecFactory", () => $9331f4cb9652a3b9$export$bf0a80f00e2b8ff6);
$parcel$export(module.exports, "createPMMarkSpecFactory", () => $9331f4cb9652a3b9$export$cf5823ed4e9f4c6f);

var $25nEq = parcelRequire("25nEq");
function $9331f4cb9652a3b9$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $9331f4cb9652a3b9$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $9331f4cb9652a3b9$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $9331f4cb9652a3b9$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $9331f4cb9652a3b9$export$bf0a80f00e2b8ff6 = function createPMNodeSpecFactory(nodeSpec) {
    return function(_ref) {
        var parseDOM = _ref.parseDOM, toDOM = _ref.toDOM, toDebugString = _ref.toDebugString;
        // @ts-ignore
        return $9331f4cb9652a3b9$var$_objectSpread($9331f4cb9652a3b9$var$_objectSpread($9331f4cb9652a3b9$var$_objectSpread($9331f4cb9652a3b9$var$_objectSpread({}, nodeSpec), parseDOM && {
            parseDOM: parseDOM
        }), toDOM && {
            toDOM: toDOM
        }), toDebugString && {
            toDebugString: toDebugString
        });
    };
};
var $9331f4cb9652a3b9$export$cf5823ed4e9f4c6f = function createPMMarkSpecFactory(markSpec) {
    return function(_ref2) {
        var parseDOM = _ref2.parseDOM, toDOM = _ref2.toDOM, toDebugString = _ref2.toDebugString;
        // @ts-ignore
        return $9331f4cb9652a3b9$var$_objectSpread($9331f4cb9652a3b9$var$_objectSpread($9331f4cb9652a3b9$var$_objectSpread($9331f4cb9652a3b9$var$_objectSpread({}, markSpec), parseDOM && {
            parseDOM: parseDOM
        }), toDOM && {
            toDOM: toDOM
        }), toDebugString && {
            toDebugString: toDebugString
        });
    };
};

});




parcelRegister("kRa9z", function(module, exports) {
$parcel$export(module.exports, "JSONTransformer", () => $f2f0a21af4c5eb59$export$98cb1d9308d0944d);

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $ekGgq = parcelRequire("ekGgq");

var $1Vcia = parcelRequire("1Vcia");

var $25nEq = parcelRequire("25nEq");

var $bTFoW = parcelRequire("bTFoW");

var $enrSO = parcelRequire("enrSO");
var $2InDy = parcelRequire("2InDy");
var $4eHHu = parcelRequire("4eHHu");
var $iDfRT = parcelRequire("iDfRT");
var $5BE4e = parcelRequire("5BE4e");
var $8JhSw = parcelRequire("8JhSw");
var $6wWv8 = parcelRequire("6wWv8");
var $kZNkK = parcelRequire("kZNkK");
var $gc8Zd = parcelRequire("gc8Zd");

var $kYLlQ = parcelRequire("kYLlQ");

var $PTaSg = parcelRequire("PTaSg");

var $cpxic = parcelRequire("cpxic");
function $f2f0a21af4c5eb59$var$_toPropertyKey(t) {
    var i = $f2f0a21af4c5eb59$var$_toPrimitive(t, "string");
    return "symbol" == (0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(i) ? i : i + "";
}
function $f2f0a21af4c5eb59$var$_toPrimitive(t, r) {
    if ("object" != (0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $f2f0a21af4c5eb59$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $f2f0a21af4c5eb59$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $f2f0a21af4c5eb59$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $f2f0a21af4c5eb59$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $f2f0a21af4c5eb59$export$933e6445c497ffd5 = /*#__PURE__*/ function(SchemaStage) {
    SchemaStage["FINAL"] = "final";
    SchemaStage["STAGE_0"] = "stage0";
    return SchemaStage;
}({});
var $f2f0a21af4c5eb59$var$isType = function isType(type) {
    return function(node) {
        return node.type.name === type;
    };
};
// Create a Set of node types that should have empty attrs removed
var $f2f0a21af4c5eb59$var$NODES_WITH_EMPTY_ATTRS_REMOVAL = new Set([
    'paragraph',
    'layoutSection',
    'blockquote',
    'nestedExpand',
    'bulletList',
    'listItem',
    'orderedList',
    'rule',
    'caption',
    'tableRow',
    'media',
    'mediaSingle',
    'mediaInline'
]);
var $f2f0a21af4c5eb59$var$isCodeBlock = $f2f0a21af4c5eb59$var$isType('codeBlock');
var $f2f0a21af4c5eb59$var$isMediaNode = $f2f0a21af4c5eb59$var$isType('media');
var $f2f0a21af4c5eb59$var$isMediaInline = $f2f0a21af4c5eb59$var$isType('mediaInline');
var $f2f0a21af4c5eb59$var$isMediaSingleNode = $f2f0a21af4c5eb59$var$isType('mediaSingle');
var $f2f0a21af4c5eb59$var$isMentionNode = $f2f0a21af4c5eb59$var$isType('mention');
var $f2f0a21af4c5eb59$var$isParagraph = $f2f0a21af4c5eb59$var$isType('paragraph');
var $f2f0a21af4c5eb59$var$isHeading = $f2f0a21af4c5eb59$var$isType('heading');
var $f2f0a21af4c5eb59$var$isTable = $f2f0a21af4c5eb59$var$isType('table');
var $f2f0a21af4c5eb59$var$isTableCell = $f2f0a21af4c5eb59$var$isType('tableCell');
var $f2f0a21af4c5eb59$var$isTableHeader = $f2f0a21af4c5eb59$var$isType('tableHeader');
var $f2f0a21af4c5eb59$var$isLinkMark = $f2f0a21af4c5eb59$var$isType('link');
var $f2f0a21af4c5eb59$var$isUnsupportedMark = $f2f0a21af4c5eb59$var$isType('unsupportedMark');
var $f2f0a21af4c5eb59$var$isUnsupportedNodeAttributeMark = $f2f0a21af4c5eb59$var$isType('unsupportedNodeAttribute');
var $f2f0a21af4c5eb59$var$isExpand = $f2f0a21af4c5eb59$var$isType('expand');
var $f2f0a21af4c5eb59$var$isNestedExpand = $f2f0a21af4c5eb59$var$isType('nestedExpand');
var $f2f0a21af4c5eb59$var$isUnsupportedNode = function isUnsupportedNode(node) {
    return $f2f0a21af4c5eb59$var$isType('unsupportedBlock')(node) || $f2f0a21af4c5eb59$var$isType('unsupportedInline')(node);
};
var $f2f0a21af4c5eb59$var$isDataConsumer = $f2f0a21af4c5eb59$var$isType('dataConsumer');
var $f2f0a21af4c5eb59$var$isFragmentMark = $f2f0a21af4c5eb59$var$isType('fragment');
var $f2f0a21af4c5eb59$var$isHardBreak = $f2f0a21af4c5eb59$var$isType('hardBreak');
// eslint-disable-next-line @typescript-eslint/no-explicit-any
var $f2f0a21af4c5eb59$var$_filterNull = function filterNull(subject) {
    var output = $f2f0a21af4c5eb59$var$_objectSpread({}, subject);
    // eslint-disable-next-line guard-for-in
    for(var key in output){
        var current = output[key];
        if (current === null) {
            var _output = output, unusedKey = _output[key], filteredObj = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_output, [
                key
            ].map($f2f0a21af4c5eb59$var$_toPropertyKey));
            output = filteredObj;
        } else if ((0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(current) === 'object' && !Array.isArray(current)) output[key] = $f2f0a21af4c5eb59$var$_filterNull(current);
    }
    return output;
};
var $f2f0a21af4c5eb59$var$createDocFromContent = function createDocFromContent(content) {
    return {
        version: 1,
        type: 'doc',
        content: content || []
    };
};
var $f2f0a21af4c5eb59$var$emptyDoc = $f2f0a21af4c5eb59$var$createDocFromContent([
    {
        type: 'paragraph',
        content: []
    }
]);
/**
 * Transforms a Prosemirror node into a JSON representation. Compared with
 * native Prosemirror JSON, this representation ensures we have valid ADF attrs.
 *
 * @param node The Prosemirror node to transform.
 * @param mentionMap A map of mention IDs to their display names.
 * @returns The JSON representation of the node.
 */ var $f2f0a21af4c5eb59$export$3a858d3babd60825 = function toJSON(node, mentionMap) {
    var obj = {
        type: node.type.name
    };
    if ($f2f0a21af4c5eb59$var$isUnsupportedNode(node)) return node.attrs.originalValue;
    else if ($f2f0a21af4c5eb59$var$isMediaNode(node)) obj.attrs = (0, $6wWv8.toJSON)(node).attrs;
    else if ($f2f0a21af4c5eb59$var$isMediaSingleNode(node)) obj.attrs = (0, $8JhSw.toJSON)(node).attrs;
    else if ($f2f0a21af4c5eb59$var$isMediaInline(node)) obj.attrs = (0, $6wWv8.toJSON)(node).attrs;
    else if ($f2f0a21af4c5eb59$var$isMentionNode(node)) obj.attrs = (0, $kZNkK.toJSON)(node).attrs;
    else if ($f2f0a21af4c5eb59$var$isCodeBlock(node)) obj.attrs = (0, $enrSO.toJSON)(node).attrs;
    else if ($f2f0a21af4c5eb59$var$isTable(node)) obj.attrs = (0, $gc8Zd.tableToJSON)(node).attrs;
    else if ($f2f0a21af4c5eb59$var$isTableCell(node)) obj.attrs = (0, $gc8Zd.toJSONTableCell)(node).attrs;
    else if ($f2f0a21af4c5eb59$var$isTableHeader(node)) obj.attrs = (0, $gc8Zd.toJSONTableHeader)(node).attrs;
    else if ($f2f0a21af4c5eb59$var$isExpand(node) || $f2f0a21af4c5eb59$var$isNestedExpand(node)) obj.attrs = (0, $4eHHu.toJSON)(node).attrs;
    else if (node.attrs && Object.keys(node.attrs).length) obj.attrs = node.attrs;
    if (obj.attrs) obj.attrs = $f2f0a21af4c5eb59$var$_filterNull(obj.attrs);
    if ($f2f0a21af4c5eb59$var$isMentionNode(node) && mentionMap) {
        var _text, _obj$attrs;
        // If the mentionMap exists and has a name defined then we should use it and prepend @ to the begining of it.
        var name = !!(mentionMap !== null && mentionMap !== void 0 && mentionMap[node.attrs.id]) ? "@".concat(mentionMap[node.attrs.id]) : '';
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        var text = (_text = (_obj$attrs = obj.attrs) === null || _obj$attrs === void 0 ? void 0 : _obj$attrs.text) !== null && _text !== void 0 ? _text : '';
        obj.attrs = $f2f0a21af4c5eb59$var$_objectSpread($f2f0a21af4c5eb59$var$_objectSpread({}, obj.attrs), {}, {
            // If an explicit text value is set on the mention then that should take priority over the mentionMap value.
            text: !!text ? text : name
        });
    }
    if ($f2f0a21af4c5eb59$var$NODES_WITH_EMPTY_ATTRS_REMOVAL.has(node.type.name) && obj.attrs && !Object.keys(obj.attrs).length || $f2f0a21af4c5eb59$var$isHardBreak(node)) delete obj.attrs;
    if (node.isText) obj.text = node.textContent;
    else node.content.forEach(function(child) {
        obj.content = obj.content || [];
        obj.content.push($f2f0a21af4c5eb59$export$3a858d3babd60825(child, mentionMap));
    });
    if ($f2f0a21af4c5eb59$var$isParagraph(node) || $f2f0a21af4c5eb59$var$isHeading(node)) obj.content = obj.content || [];
    if (node.marks.length) {
        // Run any custom mark serialisers
        var parsedMarks = node.marks.map(function(mark) {
            if ($f2f0a21af4c5eb59$var$isUnsupportedMark(mark)) return $f2f0a21af4c5eb59$var$canOverrideMark(mark, node.marks) ? null : mark.attrs.originalValue;
            else if ($f2f0a21af4c5eb59$var$isUnsupportedNodeAttributeMark(mark)) return null;
            else if ($f2f0a21af4c5eb59$var$isLinkMark(mark)) return (0, $5BE4e.toJSON)(mark);
            else if ($f2f0a21af4c5eb59$var$isDataConsumer(mark)) {
                var _serialised$attrs$sou;
                var serialised = (0, $2InDy.toJSON)(mark);
                return !serialised.attrs.sources || ((_serialised$attrs$sou = serialised.attrs.sources) === null || _serialised$attrs$sou === void 0 ? void 0 : _serialised$attrs$sou.length) === 0 ? null : serialised;
            } else if ($f2f0a21af4c5eb59$var$isFragmentMark(mark)) {
                var fragmentMark = (0, $iDfRT.toJSON)(mark);
                if (!fragmentMark.attrs.localId) return null;
                return fragmentMark;
            } else return mark.toJSON();
        }).filter(function(maybeMark) {
            return maybeMark !== null;
        });
        // Only set if we have a non-empty array, otherwise explicitly undefine it (as we only run this path if `node.marks.length`)
        obj.marks = (parsedMarks === null || parsedMarks === void 0 ? void 0 : parsedMarks.length) > 0 ? parsedMarks : undefined;
        var nodeAttributeMark = node.marks.find($f2f0a21af4c5eb59$var$isUnsupportedNodeAttributeMark);
        if (nodeAttributeMark && nodeAttributeMark.attrs.type.nodeType === obj.type) obj.attrs = $f2f0a21af4c5eb59$var$_objectSpread({}, $f2f0a21af4c5eb59$var$getUnwrappedNodeAttributes(node, nodeAttributeMark, obj));
    }
    return obj;
};
var $f2f0a21af4c5eb59$var$canOverrideMark = function canOverrideMark(mark, existingMarks) {
    if (existingMarks.some(function(e) {
        return mark.attrs.originalValue.type === e.type.name;
    })) return (0, $PTaSg.markOverrideRuleFor)(mark.attrs.originalValue.type).canOverrideUnsupportedMark();
    return false;
};
var $f2f0a21af4c5eb59$var$getUnwrappedNodeAttributes = function getUnwrappedNodeAttributes(node, mark, obj) {
    var nodeAttributes = node.type.spec.attrs;
    var attributes = $f2f0a21af4c5eb59$var$_objectSpread($f2f0a21af4c5eb59$var$_objectSpread({}, mark.attrs.unsupported), obj.attrs);
    // Ignored via go/ees005
    // eslint-disable-next-line no-var
    for(var key in obj.attrs)if (obj.attrs.hasOwnProperty(key)) {
        var attribute = nodeAttributes ? nodeAttributes[key] : null;
        if (attribute) {
            if (attribute.default === node.attrs[key] && mark.attrs.unsupported[key]) return $f2f0a21af4c5eb59$var$_objectSpread($f2f0a21af4c5eb59$var$_objectSpread({}, attributes), {}, (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, key, mark.attrs.unsupported[key]));
        }
    }
    return attributes;
};
var $f2f0a21af4c5eb59$export$98cb1d9308d0944d = /*#__PURE__*/ function() {
    /**
   * @param schema The current editor schema
   * @param mentionMap An optional mapping of user IDs to mention names. This is used by the encoder to substitute empty
   * mention node.attr.text values with mapped names.
   */ function JSONTransformer() {
        var schema = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, $kYLlQ.defaultSchema);
        var mentionMap = arguments.length > 1 ? arguments[1] : undefined;
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, JSONTransformer);
        this.schema = schema;
        this.mentionMap = mentionMap;
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(JSONTransformer, [
        {
            key: "encode",
            value: function encode(node) {
                var _this = this;
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var content = [];
                node.content.forEach(function(child) {
                    content.push((0, $cpxic.sanitizeNode)($f2f0a21af4c5eb59$export$3a858d3babd60825(child, _this.mentionMap), options));
                });
                if (!content || (0, (/*@__PURE__*/$parcel$interopDefault($bTFoW)))(content, $f2f0a21af4c5eb59$var$emptyDoc.content)) return $f2f0a21af4c5eb59$var$createDocFromContent([]);
                return $f2f0a21af4c5eb59$var$createDocFromContent(content);
            }
        },
        {
            key: "internalParse",
            value: function internalParse(content, schema) {
                var doc = schema.nodeFromJSON(content);
                doc.check();
                return doc;
            }
        },
        {
            key: "parse",
            value: function parse(content, stage) {
                if (content.type !== 'doc') throw new Error('Expected content format to be ADF');
                var schema = !!stage ? (0, $kYLlQ.getSchemaBasedOnStage)(stage) : this.schema;
                if (!content.content || content.content.length === 0) return this.internalParse($f2f0a21af4c5eb59$var$emptyDoc, schema);
                return this.internalParse(content, schema);
            }
        },
        {
            key: "encodeNode",
            value: function encodeNode(node) {
                return (0, $cpxic.sanitizeNode)($f2f0a21af4c5eb59$export$3a858d3babd60825(node, this.mentionMap));
            }
        }
    ]);
}();

});
parcelRegister("bTFoW", function(module, exports) {

var $ca8FL = parcelRequire("ca8FL");
/**
 * Performs a deep comparison between two values to determine if they are
 * equivalent.
 *
 * **Note:** This method supports comparing arrays, array buffers, booleans,
 * date objects, error objects, maps, numbers, `Object` objects, regexes,
 * sets, strings, symbols, and typed arrays. `Object` objects are compared
 * by their own, not inherited, enumerable properties. Functions and DOM
 * nodes are compared by strict equality, i.e. `===`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.isEqual(object, other);
 * // => true
 *
 * object === other;
 * // => false
 */ function $8a94f231e336fe73$var$isEqual(value, other) {
    return $ca8FL(value, other);
}
module.exports = $8a94f231e336fe73$var$isEqual;

});

parcelRegister("PTaSg", function(module, exports) {
$parcel$export(module.exports, "markOverrideRuleFor", () => $09bf9004ffa4fc12$export$28e4e3c024cce988);
var $09bf9004ffa4fc12$var$defaultAllowOverrideBehaviour = {
    canOverrideUnsupportedMark: function canOverrideUnsupportedMark() {
        return true;
    }
};
var $09bf9004ffa4fc12$var$defaultDoNotAllowOverrideBehaviour = {
    canOverrideUnsupportedMark: function canOverrideUnsupportedMark() {
        return false;
    }
};
var $09bf9004ffa4fc12$export$28e4e3c024cce988 = function markOverrideRuleFor(type) {
    switch(type){
        case 'link':
        case 'em':
        case 'strong':
        case 'strike':
        case 'subsup':
        case 'underline':
        case 'code':
        case 'textColor':
        case 'backgroundColor':
        case 'confluenceInlineComment':
        case 'breakout':
        case 'alignment':
        case 'indentation':
        case 'border':
            return $09bf9004ffa4fc12$var$defaultAllowOverrideBehaviour;
        default:
            return $09bf9004ffa4fc12$var$defaultDoNotAllowOverrideBehaviour;
    }
};

});

parcelRegister("cpxic", function(module, exports) {
$parcel$export(module.exports, "sanitizeNode", () => $9091a507380c0122$export$48b382180baf8e88);

var $25nEq = parcelRequire("25nEq");

var $8mLOq = parcelRequire("8mLOq");

var $a4liq = parcelRequire("a4liq");

var $7rzIl = parcelRequire("7rzIl");
function $9091a507380c0122$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $9091a507380c0122$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $9091a507380c0122$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $9091a507380c0122$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $9091a507380c0122$var$hasNestedTable = function hasNestedTable(tableCellNode) {
    var _tableCellNode$conten;
    return (_tableCellNode$conten = tableCellNode.content) === null || _tableCellNode$conten === void 0 ? void 0 : _tableCellNode$conten.some(function(node) {
        return (node === null || node === void 0 ? void 0 : node.type) === 'table';
    });
};
function $9091a507380c0122$export$48b382180baf8e88(json) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var _options$keepNestedTa = options.keepNestedTables, keepNestedTables = _options$keepNestedTa === void 0 ? false : _options$keepNestedTa;
    var sanitizedJSON = (0, $a4liq.traverse)(json, {
        text: function text(node) {
            if (!node || !Array.isArray(node.marks)) return node;
            return $9091a507380c0122$var$_objectSpread($9091a507380c0122$var$_objectSpread({}, node), {}, {
                marks: node.marks.filter(function(mark) {
                    return mark.type !== 'typeAheadQuery';
                })
            });
        },
        status: function status(node) {
            if (node.attrs && !!node.attrs.text) return (0, $7rzIl.removeNonAnnotationMarks)(node);
            return false; // empty status
        },
        caption: function caption(node) {
            if (node.content) return node;
            return false; // empty caption
        },
        tableCell: function tableCell(node) {
            if ($9091a507380c0122$var$hasNestedTable(node)) return keepNestedTables ? node : (0, $8mLOq.transformNestedTableNodeOutgoingDocument)(node);
            return;
        },
        tableHeader: function tableHeader(node) {
            if ($9091a507380c0122$var$hasNestedTable(node)) return keepNestedTables ? node : (0, $8mLOq.transformNestedTableNodeOutgoingDocument)(node);
            return;
        },
        emoji: (0, $7rzIl.removeNonAnnotationMarks),
        mention: (0, $7rzIl.removeNonAnnotationMarks),
        date: (0, $7rzIl.removeNonAnnotationMarks),
        hardBreak: (0, $7rzIl.removeMarks),
        inlineCard: (0, $7rzIl.removeNonAnnotationMarks)
    });
    return sanitizedJSON;
}

});
parcelRegister("8mLOq", function(module, exports) {
$parcel$export(module.exports, "transformNestedTableNodeOutgoingDocument", () => $6175775151bd8078$export$8a334a7d9fe120ec);

var $25nEq = parcelRequire("25nEq");

var $a4liq = parcelRequire("a4liq");

var $6B49U = parcelRequire("6B49U");

var $j8OEG = parcelRequire("j8OEG");
function $6175775151bd8078$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $6175775151bd8078$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $6175775151bd8078$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $6175775151bd8078$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $6175775151bd8078$var$NESTED_TABLE_EXTENSION_TYPE = 'com.atlassian.confluence.migration', $6175775151bd8078$var$NESTED_TABLE_EXTENSION_KEY = 'nested-table';
var $6175775151bd8078$export$f45e7335ec874bfe = function isNestedTableExtension(extensionNode) {
    var _extensionNode$attrs, _extensionNode$attrs2;
    return ((_extensionNode$attrs = extensionNode.attrs) === null || _extensionNode$attrs === void 0 ? void 0 : _extensionNode$attrs.extensionType) === $6175775151bd8078$var$NESTED_TABLE_EXTENSION_TYPE && ((_extensionNode$attrs2 = extensionNode.attrs) === null || _extensionNode$attrs2 === void 0 ? void 0 : _extensionNode$attrs2.extensionKey) === $6175775151bd8078$var$NESTED_TABLE_EXTENSION_KEY;
};
var $6175775151bd8078$var$transformNestedTableExtension = function transformNestedTableExtension(nestedTableExtension) {
    var _nestedTableExtension;
    // No content - drop the extension node
    if (!((_nestedTableExtension = nestedTableExtension.attrs) !== null && _nestedTableExtension !== void 0 && (_nestedTableExtension = _nestedTableExtension.parameters) !== null && _nestedTableExtension !== void 0 && _nestedTableExtension.adf)) return false;
    try {
        var _nestedTableExtension2;
        var adf = JSON.parse((_nestedTableExtension2 = nestedTableExtension.attrs) === null || _nestedTableExtension2 === void 0 || (_nestedTableExtension2 = _nestedTableExtension2.parameters) === null || _nestedTableExtension2 === void 0 ? void 0 : _nestedTableExtension2.adf);
        if (!adf.content || adf.content.length === 0) return false;
        return adf.content[0];
    } catch (e) {
        throw new (0, $j8OEG.NodeNestingTransformError)('Failed to parse nested table content');
    }
};
var $6175775151bd8078$export$18544d0b5f43e4a1 = function transformNestedTablesIncomingDocument(adf) {
    var isTransformed = false;
    var transformedAdf = (0, $a4liq.traverse)(adf, {
        extension: function extension(node) {
            if ($6175775151bd8078$export$f45e7335ec874bfe(node)) {
                isTransformed = true;
                return $6175775151bd8078$var$transformNestedTableExtension(node);
            }
            return;
        }
    });
    return {
        transformedAdf: transformedAdf,
        isTransformed: isTransformed
    };
};
var $6175775151bd8078$export$8a334a7d9fe120ec = function transformNestedTableNodeOutgoingDocument(tableCellNode) {
    try {
        var _tableCellNode$conten;
        return $6175775151bd8078$var$_objectSpread($6175775151bd8078$var$_objectSpread({}, tableCellNode), {}, {
            content: (_tableCellNode$conten = tableCellNode.content) === null || _tableCellNode$conten === void 0 ? void 0 : _tableCellNode$conten.map(function(childNode) {
                // wrap nested table in an extension node
                if ((childNode === null || childNode === void 0 ? void 0 : childNode.type) === 'table') return (0, $6B49U.extension)({
                    extensionType: $6175775151bd8078$var$NESTED_TABLE_EXTENSION_TYPE,
                    extensionKey: $6175775151bd8078$var$NESTED_TABLE_EXTENSION_KEY,
                    parameters: {
                        adf: JSON.stringify({
                            type: 'doc',
                            version: 1,
                            content: [
                                childNode
                            ]
                        })
                    }
                });
                return childNode;
            })
        });
    } catch (e) {
        throw new (0, $j8OEG.NodeNestingTransformError)('Failed to encode nested table node');
    }
};

});
parcelRegister("a4liq", function(module, exports) {
$parcel$export(module.exports, "traverse", () => $754acc1334cb0a35$export$df3f009e3d155b20);

var $25nEq = parcelRequire("25nEq");
function $754acc1334cb0a35$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $754acc1334cb0a35$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $754acc1334cb0a35$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $754acc1334cb0a35$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $754acc1334cb0a35$export$735cfea22ce30f58(_visitors) {
    return true;
}
function $754acc1334cb0a35$export$df3f009e3d155b20(adf, visitors) {
    if (!$754acc1334cb0a35$export$735cfea22ce30f58(visitors)) throw new Error("Visitors are not valid: \"".concat(Object.keys(visitors).join(', '), "\""));
    return $754acc1334cb0a35$var$traverseNode(adf, {
        node: undefined
    }, visitors, 0, 0);
}
function $754acc1334cb0a35$var$traverseNode(adfNode, parent, visitors, index, depth) {
    var visitor = visitors[adfNode.type] || visitors['any'];
    var newNode = $754acc1334cb0a35$var$_objectSpread({}, adfNode);
    if (visitor) {
        var processedNode = visitor($754acc1334cb0a35$var$_objectSpread({}, newNode), parent, index, depth);
        if (processedNode === false) return false;
        newNode = processedNode || adfNode;
    }
    if (newNode.content) newNode.content = newNode.content.reduce(function(acc, node, idx) {
        if (!node) return acc;
        var processedNode = $754acc1334cb0a35$var$traverseNode(node, {
            node: newNode,
            parent: parent
        }, visitors, idx, depth + 1);
        if (processedNode !== false) acc.push(processedNode);
        return acc;
    }, []);
    return newNode;
}

});

parcelRegister("6B49U", function(module, exports) {
$parcel$export(module.exports, "extension", () => $4cd96ca860be822a$export$1b45514b112dd749);
var $4cd96ca860be822a$export$1b45514b112dd749 = function extension(attrs) {
    return {
        type: 'extension',
        attrs: attrs
    };
};

});

parcelRegister("j8OEG", function(module, exports) {
$parcel$export(module.exports, "NodeNestingTransformError", () => $def60ebd870c774e$export$3d8e8d2182f13924);

var $arMYe = parcelRequire("arMYe");

var $9P61R = parcelRequire("9P61R");

var $kIXpt = parcelRequire("kIXpt");

var $cYPzS = parcelRequire("cYPzS");

var $eyuDe = parcelRequire("eyuDe");

var $c7s0H = parcelRequire("c7s0H");
function $def60ebd870c774e$var$_callSuper(t, o, e) {
    return o = (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(o), (0, (/*@__PURE__*/$parcel$interopDefault($kIXpt)))(t, $def60ebd870c774e$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(t).constructor) : o.apply(t, e));
}
function $def60ebd870c774e$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($def60ebd870c774e$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $def60ebd870c774e$export$3d8e8d2182f13924 = /*#__PURE__*/ function(_Error) {
    /**
   * @param message - Error message - Do not use any UGC in this message
   */ function NodeNestingTransformError(message) {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, NodeNestingTransformError);
        _this = $def60ebd870c774e$var$_callSuper(this, NodeNestingTransformError, [
            message
        ]);
        _this.name = 'NodeNestingTransformError';
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($eyuDe)))(NodeNestingTransformError, _Error);
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(NodeNestingTransformError);
}(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($c7s0H)))(Error));

});


parcelRegister("7rzIl", function(module, exports) {
$parcel$export(module.exports, "removeMarks", () => $56b6c22177910998$export$9bf001d8ef76e497);
$parcel$export(module.exports, "removeNonAnnotationMarks", () => $56b6c22177910998$export$8cae9126fc577085);

var $25nEq = parcelRequire("25nEq");
function $56b6c22177910998$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $56b6c22177910998$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $56b6c22177910998$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $56b6c22177910998$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $56b6c22177910998$export$9bf001d8ef76e497(node) {
    var newNode = $56b6c22177910998$var$_objectSpread({}, node);
    delete newNode.marks;
    return newNode;
}
function $56b6c22177910998$export$8cae9126fc577085(node) {
    var newNode = $56b6c22177910998$var$_objectSpread({}, node);
    if (node.marks) newNode.marks = node.marks.filter(function(mark) {
        return mark.type === 'annotation';
    });
    return newNode;
}

});



parcelRegister("hYeeB", function(module, exports) {
$parcel$export(module.exports, "Mapping", () => $d15314f635f1e9c3$export$f5f785078011b62);
$parcel$export(module.exports, "AddMarkStep", () => $d15314f635f1e9c3$export$d24ba56b0e3464a9);
$parcel$export(module.exports, "RemoveMarkStep", () => $d15314f635f1e9c3$export$94150db1311f67a9);
$parcel$export(module.exports, "AddNodeMarkStep", () => $d15314f635f1e9c3$export$adefd16c402fee4e);
$parcel$export(module.exports, "RemoveNodeMarkStep", () => $d15314f635f1e9c3$export$fdf7d1dc10724da2);
$parcel$export(module.exports, "Transform", () => $d15314f635f1e9c3$export$563a914cafbdc389);

var $1k1D7 = parcelRequire("1k1D7");
// Recovery values encode a range index and an offset. They are
// represented as numbers, because tons of them will be created when
// mapping, for example, a large number of decorations. The number's
// lower 16 bits provide the index, the remaining bits the offset.
//
// Note: We intentionally don't use bit shift operators to en- and
// decode these, since those clip to 32 bits, which we might in rare
// cases want to overflow. A 64-bit float can represent 48-bit
// integers precisely.
const $d15314f635f1e9c3$var$lower16 = 0xffff;
const $d15314f635f1e9c3$var$factor16 = Math.pow(2, 16);
function $d15314f635f1e9c3$var$makeRecover(index, offset) {
    return index + offset * $d15314f635f1e9c3$var$factor16;
}
function $d15314f635f1e9c3$var$recoverIndex(value) {
    return value & $d15314f635f1e9c3$var$lower16;
}
function $d15314f635f1e9c3$var$recoverOffset(value) {
    return (value - (value & $d15314f635f1e9c3$var$lower16)) / $d15314f635f1e9c3$var$factor16;
}
const $d15314f635f1e9c3$var$DEL_BEFORE = 1, $d15314f635f1e9c3$var$DEL_AFTER = 2, $d15314f635f1e9c3$var$DEL_ACROSS = 4, $d15314f635f1e9c3$var$DEL_SIDE = 8;
/**
An object representing a mapped position with extra
information.
*/ class $d15314f635f1e9c3$export$c77c9be41668e9b4 {
    /**
    @internal
    */ constructor(/**
    The mapped version of the position.
    */ pos, /**
    @internal
    */ delInfo, /**
    @internal
    */ recover){
        this.pos = pos;
        this.delInfo = delInfo;
        this.recover = recover;
    }
    /**
    Tells you whether the position was deleted, that is, whether the
    step removed the token on the side queried (via the `assoc`)
    argument from the document.
    */ get deleted() {
        return (this.delInfo & $d15314f635f1e9c3$var$DEL_SIDE) > 0;
    }
    /**
    Tells you whether the token before the mapped position was deleted.
    */ get deletedBefore() {
        return (this.delInfo & ($d15314f635f1e9c3$var$DEL_BEFORE | $d15314f635f1e9c3$var$DEL_ACROSS)) > 0;
    }
    /**
    True when the token after the mapped position was deleted.
    */ get deletedAfter() {
        return (this.delInfo & ($d15314f635f1e9c3$var$DEL_AFTER | $d15314f635f1e9c3$var$DEL_ACROSS)) > 0;
    }
    /**
    Tells whether any of the steps mapped through deletes across the
    position (including both the token before and after the
    position).
    */ get deletedAcross() {
        return (this.delInfo & $d15314f635f1e9c3$var$DEL_ACROSS) > 0;
    }
}
/**
A map describing the deletions and insertions made by a step, which
can be used to find the correspondence between positions in the
pre-step version of a document and the same position in the
post-step version.
*/ class $d15314f635f1e9c3$export$c53d01c3ab9721b3 {
    /**
    Create a position map. The modifications to the document are
    represented as an array of numbers, in which each group of three
    represents a modified chunk as `[start, oldSize, newSize]`.
    */ constructor(/**
    @internal
    */ ranges, /**
    @internal
    */ inverted = false){
        this.ranges = ranges;
        this.inverted = inverted;
        if (!ranges.length && $d15314f635f1e9c3$export$c53d01c3ab9721b3.empty) return $d15314f635f1e9c3$export$c53d01c3ab9721b3.empty;
    }
    /**
    @internal
    */ recover(value) {
        let diff = 0, index = $d15314f635f1e9c3$var$recoverIndex(value);
        if (!this.inverted) for(let i = 0; i < index; i++)diff += this.ranges[i * 3 + 2] - this.ranges[i * 3 + 1];
        return this.ranges[index * 3] + diff + $d15314f635f1e9c3$var$recoverOffset(value);
    }
    mapResult(pos, assoc = 1) {
        return this._map(pos, assoc, false);
    }
    map(pos, assoc = 1) {
        return this._map(pos, assoc, true);
    }
    /**
    @internal
    */ _map(pos, assoc, simple) {
        let diff = 0, oldIndex = this.inverted ? 2 : 1, newIndex = this.inverted ? 1 : 2;
        for(let i = 0; i < this.ranges.length; i += 3){
            let start = this.ranges[i] - (this.inverted ? diff : 0);
            if (start > pos) break;
            let oldSize = this.ranges[i + oldIndex], newSize = this.ranges[i + newIndex], end = start + oldSize;
            if (pos <= end) {
                let side = !oldSize ? assoc : pos == start ? -1 : pos == end ? 1 : assoc;
                let result = start + diff + (side < 0 ? 0 : newSize);
                if (simple) return result;
                let recover = pos == (assoc < 0 ? start : end) ? null : $d15314f635f1e9c3$var$makeRecover(i / 3, pos - start);
                let del = pos == start ? $d15314f635f1e9c3$var$DEL_AFTER : pos == end ? $d15314f635f1e9c3$var$DEL_BEFORE : $d15314f635f1e9c3$var$DEL_ACROSS;
                if (assoc < 0 ? pos != start : pos != end) del |= $d15314f635f1e9c3$var$DEL_SIDE;
                return new $d15314f635f1e9c3$export$c77c9be41668e9b4(result, del, recover);
            }
            diff += newSize - oldSize;
        }
        return simple ? pos + diff : new $d15314f635f1e9c3$export$c77c9be41668e9b4(pos + diff, 0, null);
    }
    /**
    @internal
    */ touches(pos, recover) {
        let diff = 0, index = $d15314f635f1e9c3$var$recoverIndex(recover);
        let oldIndex = this.inverted ? 2 : 1, newIndex = this.inverted ? 1 : 2;
        for(let i = 0; i < this.ranges.length; i += 3){
            let start = this.ranges[i] - (this.inverted ? diff : 0);
            if (start > pos) break;
            let oldSize = this.ranges[i + oldIndex], end = start + oldSize;
            if (pos <= end && i == index * 3) return true;
            diff += this.ranges[i + newIndex] - oldSize;
        }
        return false;
    }
    /**
    Calls the given function on each of the changed ranges included in
    this map.
    */ forEach(f) {
        let oldIndex = this.inverted ? 2 : 1, newIndex = this.inverted ? 1 : 2;
        for(let i = 0, diff = 0; i < this.ranges.length; i += 3){
            let start = this.ranges[i], oldStart = start - (this.inverted ? diff : 0), newStart = start + (this.inverted ? 0 : diff);
            let oldSize = this.ranges[i + oldIndex], newSize = this.ranges[i + newIndex];
            f(oldStart, oldStart + oldSize, newStart, newStart + newSize);
            diff += newSize - oldSize;
        }
    }
    /**
    Create an inverted version of this map. The result can be used to
    map positions in the post-step document to the pre-step document.
    */ invert() {
        return new $d15314f635f1e9c3$export$c53d01c3ab9721b3(this.ranges, !this.inverted);
    }
    /**
    @internal
    */ toString() {
        return (this.inverted ? "-" : "") + JSON.stringify(this.ranges);
    }
    /**
    Create a map that moves all positions by offset `n` (which may be
    negative). This can be useful when applying steps meant for a
    sub-document to a larger document, or vice-versa.
    */ static offset(n) {
        return n == 0 ? $d15314f635f1e9c3$export$c53d01c3ab9721b3.empty : new $d15314f635f1e9c3$export$c53d01c3ab9721b3(n < 0 ? [
            0,
            -n,
            0
        ] : [
            0,
            0,
            n
        ]);
    }
}
/**
A StepMap that contains no changed ranges.
*/ $d15314f635f1e9c3$export$c53d01c3ab9721b3.empty = new $d15314f635f1e9c3$export$c53d01c3ab9721b3([]);
/**
A mapping represents a pipeline of zero or more [step
maps](https://prosemirror.net/docs/ref/#transform.StepMap). It has special provisions for losslessly
handling mapping positions through a series of steps in which some
steps are inverted versions of earlier steps. (This comes up when
‘[rebasing](/docs/guide/#transform.rebasing)’ steps for
collaboration or history management.)
*/ class $d15314f635f1e9c3$export$f5f785078011b62 {
    /**
    Create a new mapping with the given position maps.
    */ constructor(/**
    The step maps in this mapping.
    */ maps = [], /**
    @internal
    */ mirror, /**
    The starting position in the `maps` array, used when `map` or
    `mapResult` is called.
    */ from = 0, /**
    The end position in the `maps` array.
    */ to = maps.length){
        this.maps = maps;
        this.mirror = mirror;
        this.from = from;
        this.to = to;
    }
    /**
    Create a mapping that maps only through a part of this one.
    */ slice(from = 0, to = this.maps.length) {
        return new $d15314f635f1e9c3$export$f5f785078011b62(this.maps, this.mirror, from, to);
    }
    /**
    @internal
    */ copy() {
        return new $d15314f635f1e9c3$export$f5f785078011b62(this.maps.slice(), this.mirror && this.mirror.slice(), this.from, this.to);
    }
    /**
    Add a step map to the end of this mapping. If `mirrors` is
    given, it should be the index of the step map that is the mirror
    image of this one.
    */ appendMap(map, mirrors) {
        this.to = this.maps.push(map);
        if (mirrors != null) this.setMirror(this.maps.length - 1, mirrors);
    }
    /**
    Add all the step maps in a given mapping to this one (preserving
    mirroring information).
    */ appendMapping(mapping) {
        for(let i = 0, startSize = this.maps.length; i < mapping.maps.length; i++){
            let mirr = mapping.getMirror(i);
            this.appendMap(mapping.maps[i], mirr != null && mirr < i ? startSize + mirr : undefined);
        }
    }
    /**
    Finds the offset of the step map that mirrors the map at the
    given offset, in this mapping (as per the second argument to
    `appendMap`).
    */ getMirror(n) {
        if (this.mirror) {
            for(let i = 0; i < this.mirror.length; i++)if (this.mirror[i] == n) return this.mirror[i + (i % 2 ? -1 : 1)];
        }
    }
    /**
    @internal
    */ setMirror(n, m) {
        if (!this.mirror) this.mirror = [];
        this.mirror.push(n, m);
    }
    /**
    Append the inverse of the given mapping to this one.
    */ appendMappingInverted(mapping) {
        for(let i = mapping.maps.length - 1, totalSize = this.maps.length + mapping.maps.length; i >= 0; i--){
            let mirr = mapping.getMirror(i);
            this.appendMap(mapping.maps[i].invert(), mirr != null && mirr > i ? totalSize - mirr - 1 : undefined);
        }
    }
    /**
    Create an inverted version of this mapping.
    */ invert() {
        let inverse = new $d15314f635f1e9c3$export$f5f785078011b62;
        inverse.appendMappingInverted(this);
        return inverse;
    }
    /**
    Map a position through this mapping.
    */ map(pos, assoc = 1) {
        if (this.mirror) return this._map(pos, assoc, true);
        for(let i = this.from; i < this.to; i++)pos = this.maps[i].map(pos, assoc);
        return pos;
    }
    /**
    Map a position through this mapping, returning a mapping
    result.
    */ mapResult(pos, assoc = 1) {
        return this._map(pos, assoc, false);
    }
    /**
    @internal
    */ _map(pos, assoc, simple) {
        let delInfo = 0;
        for(let i = this.from; i < this.to; i++){
            let map = this.maps[i], result = map.mapResult(pos, assoc);
            if (result.recover != null) {
                let corr = this.getMirror(i);
                if (corr != null && corr > i && corr < this.to) {
                    i = corr;
                    pos = this.maps[corr].recover(result.recover);
                    continue;
                }
            }
            delInfo |= result.delInfo;
            pos = result.pos;
        }
        return simple ? pos : new $d15314f635f1e9c3$export$c77c9be41668e9b4(pos, delInfo, null);
    }
}
const $d15314f635f1e9c3$var$stepsByID = Object.create(null);
/**
A step object represents an atomic change. It generally applies
only to the document it was created for, since the positions
stored in it will only make sense for that document.

New steps are defined by creating classes that extend `Step`,
overriding the `apply`, `invert`, `map`, `getMap` and `fromJSON`
methods, and registering your class with a unique
JSON-serialization identifier using
[`Step.jsonID`](https://prosemirror.net/docs/ref/#transform.Step^jsonID).
*/ class $d15314f635f1e9c3$export$fd55ce593607084a {
    /**
    Get the step map that represents the changes made by this step,
    and which can be used to transform between positions in the old
    and the new document.
    */ getMap() {
        return $d15314f635f1e9c3$export$c53d01c3ab9721b3.empty;
    }
    /**
    Try to merge this step with another one, to be applied directly
    after it. Returns the merged step when possible, null if the
    steps can't be merged.
    */ merge(other) {
        return null;
    }
    /**
    Deserialize a step from its JSON representation. Will call
    through to the step class' own implementation of this method.
    */ static fromJSON(schema, json) {
        if (!json || !json.stepType) throw new RangeError("Invalid input for Step.fromJSON");
        let type = $d15314f635f1e9c3$var$stepsByID[json.stepType];
        if (!type) throw new RangeError(`No step type ${json.stepType} defined`);
        return type.fromJSON(schema, json);
    }
    /**
    To be able to serialize steps to JSON, each step needs a string
    ID to attach to its JSON representation. Use this method to
    register an ID for your step classes. Try to pick something
    that's unlikely to clash with steps from other modules.
    */ static jsonID(id, stepClass) {
        if (id in $d15314f635f1e9c3$var$stepsByID) throw new RangeError("Duplicate use of step JSON ID " + id);
        $d15314f635f1e9c3$var$stepsByID[id] = stepClass;
        stepClass.prototype.jsonID = id;
        return stepClass;
    }
}
/**
The result of [applying](https://prosemirror.net/docs/ref/#transform.Step.apply) a step. Contains either a
new document or a failure value.
*/ class $d15314f635f1e9c3$export$8ebf1578a4199c09 {
    /**
    @internal
    */ constructor(/**
    The transformed document, if successful.
    */ doc, /**
    The failure message, if unsuccessful.
    */ failed){
        this.doc = doc;
        this.failed = failed;
    }
    /**
    Create a successful step result.
    */ static ok(doc) {
        return new $d15314f635f1e9c3$export$8ebf1578a4199c09(doc, null);
    }
    /**
    Create a failed step result.
    */ static fail(message) {
        return new $d15314f635f1e9c3$export$8ebf1578a4199c09(null, message);
    }
    /**
    Call [`Node.replace`](https://prosemirror.net/docs/ref/#model.Node.replace) with the given
    arguments. Create a successful result if it succeeds, and a
    failed one if it throws a `ReplaceError`.
    */ static fromReplace(doc, from, to, slice) {
        try {
            return $d15314f635f1e9c3$export$8ebf1578a4199c09.ok(doc.replace(from, to, slice));
        } catch (e) {
            if (e instanceof (0, $1k1D7.ReplaceError)) return $d15314f635f1e9c3$export$8ebf1578a4199c09.fail(e.message);
            throw e;
        }
    }
}
function $d15314f635f1e9c3$var$mapFragment(fragment, f, parent) {
    let mapped = [];
    for(let i = 0; i < fragment.childCount; i++){
        let child = fragment.child(i);
        if (child.content.size) child = child.copy($d15314f635f1e9c3$var$mapFragment(child.content, f, child));
        if (child.isInline) child = f(child, parent, i);
        mapped.push(child);
    }
    return (0, $1k1D7.Fragment).fromArray(mapped);
}
/**
Add a mark to all inline content between two positions.
*/ class $d15314f635f1e9c3$export$d24ba56b0e3464a9 extends $d15314f635f1e9c3$export$fd55ce593607084a {
    /**
    Create a mark step.
    */ constructor(/**
    The start of the marked range.
    */ from, /**
    The end of the marked range.
    */ to, /**
    The mark to add.
    */ mark){
        super();
        this.from = from;
        this.to = to;
        this.mark = mark;
    }
    apply(doc) {
        let oldSlice = doc.slice(this.from, this.to), $from = doc.resolve(this.from);
        let parent = $from.node($from.sharedDepth(this.to));
        let slice = new (0, $1k1D7.Slice)($d15314f635f1e9c3$var$mapFragment(oldSlice.content, (node, parent)=>{
            if (!node.isAtom || !parent.type.allowsMarkType(this.mark.type)) return node;
            return node.mark(this.mark.addToSet(node.marks));
        }, parent), oldSlice.openStart, oldSlice.openEnd);
        return $d15314f635f1e9c3$export$8ebf1578a4199c09.fromReplace(doc, this.from, this.to, slice);
    }
    invert() {
        return new $d15314f635f1e9c3$export$94150db1311f67a9(this.from, this.to, this.mark);
    }
    map(mapping) {
        let from = mapping.mapResult(this.from, 1), to = mapping.mapResult(this.to, -1);
        if (from.deleted && to.deleted || from.pos >= to.pos) return null;
        return new $d15314f635f1e9c3$export$d24ba56b0e3464a9(from.pos, to.pos, this.mark);
    }
    merge(other) {
        if (other instanceof $d15314f635f1e9c3$export$d24ba56b0e3464a9 && other.mark.eq(this.mark) && this.from <= other.to && this.to >= other.from) return new $d15314f635f1e9c3$export$d24ba56b0e3464a9(Math.min(this.from, other.from), Math.max(this.to, other.to), this.mark);
        return null;
    }
    toJSON() {
        return {
            stepType: "addMark",
            mark: this.mark.toJSON(),
            from: this.from,
            to: this.to
        };
    }
    /**
    @internal
    */ static fromJSON(schema, json) {
        if (typeof json.from != "number" || typeof json.to != "number") throw new RangeError("Invalid input for AddMarkStep.fromJSON");
        return new $d15314f635f1e9c3$export$d24ba56b0e3464a9(json.from, json.to, schema.markFromJSON(json.mark));
    }
}
$d15314f635f1e9c3$export$fd55ce593607084a.jsonID("addMark", $d15314f635f1e9c3$export$d24ba56b0e3464a9);
/**
Remove a mark from all inline content between two positions.
*/ class $d15314f635f1e9c3$export$94150db1311f67a9 extends $d15314f635f1e9c3$export$fd55ce593607084a {
    /**
    Create a mark-removing step.
    */ constructor(/**
    The start of the unmarked range.
    */ from, /**
    The end of the unmarked range.
    */ to, /**
    The mark to remove.
    */ mark){
        super();
        this.from = from;
        this.to = to;
        this.mark = mark;
    }
    apply(doc) {
        let oldSlice = doc.slice(this.from, this.to);
        let slice = new (0, $1k1D7.Slice)($d15314f635f1e9c3$var$mapFragment(oldSlice.content, (node)=>{
            return node.mark(this.mark.removeFromSet(node.marks));
        }, doc), oldSlice.openStart, oldSlice.openEnd);
        return $d15314f635f1e9c3$export$8ebf1578a4199c09.fromReplace(doc, this.from, this.to, slice);
    }
    invert() {
        return new $d15314f635f1e9c3$export$d24ba56b0e3464a9(this.from, this.to, this.mark);
    }
    map(mapping) {
        let from = mapping.mapResult(this.from, 1), to = mapping.mapResult(this.to, -1);
        if (from.deleted && to.deleted || from.pos >= to.pos) return null;
        return new $d15314f635f1e9c3$export$94150db1311f67a9(from.pos, to.pos, this.mark);
    }
    merge(other) {
        if (other instanceof $d15314f635f1e9c3$export$94150db1311f67a9 && other.mark.eq(this.mark) && this.from <= other.to && this.to >= other.from) return new $d15314f635f1e9c3$export$94150db1311f67a9(Math.min(this.from, other.from), Math.max(this.to, other.to), this.mark);
        return null;
    }
    toJSON() {
        return {
            stepType: "removeMark",
            mark: this.mark.toJSON(),
            from: this.from,
            to: this.to
        };
    }
    /**
    @internal
    */ static fromJSON(schema, json) {
        if (typeof json.from != "number" || typeof json.to != "number") throw new RangeError("Invalid input for RemoveMarkStep.fromJSON");
        return new $d15314f635f1e9c3$export$94150db1311f67a9(json.from, json.to, schema.markFromJSON(json.mark));
    }
}
$d15314f635f1e9c3$export$fd55ce593607084a.jsonID("removeMark", $d15314f635f1e9c3$export$94150db1311f67a9);
/**
Add a mark to a specific node.
*/ class $d15314f635f1e9c3$export$adefd16c402fee4e extends $d15314f635f1e9c3$export$fd55ce593607084a {
    /**
    Create a node mark step.
    */ constructor(/**
    The position of the target node.
    */ pos, /**
    The mark to add.
    */ mark){
        super();
        this.pos = pos;
        this.mark = mark;
    }
    apply(doc) {
        let node = doc.nodeAt(this.pos);
        if (!node) return $d15314f635f1e9c3$export$8ebf1578a4199c09.fail("No node at mark step's position");
        let updated = node.type.create(node.attrs, null, this.mark.addToSet(node.marks));
        return $d15314f635f1e9c3$export$8ebf1578a4199c09.fromReplace(doc, this.pos, this.pos + 1, new (0, $1k1D7.Slice)((0, $1k1D7.Fragment).from(updated), 0, node.isLeaf ? 0 : 1));
    }
    invert(doc) {
        let node = doc.nodeAt(this.pos);
        if (node) {
            let newSet = this.mark.addToSet(node.marks);
            if (newSet.length == node.marks.length) {
                for(let i = 0; i < node.marks.length; i++)if (!node.marks[i].isInSet(newSet)) return new $d15314f635f1e9c3$export$adefd16c402fee4e(this.pos, node.marks[i]);
                return new $d15314f635f1e9c3$export$adefd16c402fee4e(this.pos, this.mark);
            }
        }
        return new $d15314f635f1e9c3$export$fdf7d1dc10724da2(this.pos, this.mark);
    }
    map(mapping) {
        let pos = mapping.mapResult(this.pos, 1);
        return pos.deletedAfter ? null : new $d15314f635f1e9c3$export$adefd16c402fee4e(pos.pos, this.mark);
    }
    toJSON() {
        return {
            stepType: "addNodeMark",
            pos: this.pos,
            mark: this.mark.toJSON()
        };
    }
    /**
    @internal
    */ static fromJSON(schema, json) {
        if (typeof json.pos != "number") throw new RangeError("Invalid input for AddNodeMarkStep.fromJSON");
        return new $d15314f635f1e9c3$export$adefd16c402fee4e(json.pos, schema.markFromJSON(json.mark));
    }
}
$d15314f635f1e9c3$export$fd55ce593607084a.jsonID("addNodeMark", $d15314f635f1e9c3$export$adefd16c402fee4e);
/**
Remove a mark from a specific node.
*/ class $d15314f635f1e9c3$export$fdf7d1dc10724da2 extends $d15314f635f1e9c3$export$fd55ce593607084a {
    /**
    Create a mark-removing step.
    */ constructor(/**
    The position of the target node.
    */ pos, /**
    The mark to remove.
    */ mark){
        super();
        this.pos = pos;
        this.mark = mark;
    }
    apply(doc) {
        let node = doc.nodeAt(this.pos);
        if (!node) return $d15314f635f1e9c3$export$8ebf1578a4199c09.fail("No node at mark step's position");
        let updated = node.type.create(node.attrs, null, this.mark.removeFromSet(node.marks));
        return $d15314f635f1e9c3$export$8ebf1578a4199c09.fromReplace(doc, this.pos, this.pos + 1, new (0, $1k1D7.Slice)((0, $1k1D7.Fragment).from(updated), 0, node.isLeaf ? 0 : 1));
    }
    invert(doc) {
        let node = doc.nodeAt(this.pos);
        if (!node || !this.mark.isInSet(node.marks)) return this;
        return new $d15314f635f1e9c3$export$adefd16c402fee4e(this.pos, this.mark);
    }
    map(mapping) {
        let pos = mapping.mapResult(this.pos, 1);
        return pos.deletedAfter ? null : new $d15314f635f1e9c3$export$fdf7d1dc10724da2(pos.pos, this.mark);
    }
    toJSON() {
        return {
            stepType: "removeNodeMark",
            pos: this.pos,
            mark: this.mark.toJSON()
        };
    }
    /**
    @internal
    */ static fromJSON(schema, json) {
        if (typeof json.pos != "number") throw new RangeError("Invalid input for RemoveNodeMarkStep.fromJSON");
        return new $d15314f635f1e9c3$export$fdf7d1dc10724da2(json.pos, schema.markFromJSON(json.mark));
    }
}
$d15314f635f1e9c3$export$fd55ce593607084a.jsonID("removeNodeMark", $d15314f635f1e9c3$export$fdf7d1dc10724da2);
/**
Replace a part of the document with a slice of new content.
*/ class $d15314f635f1e9c3$export$5c860b2e74034756 extends $d15314f635f1e9c3$export$fd55ce593607084a {
    /**
    The given `slice` should fit the 'gap' between `from` and
    `to`—the depths must line up, and the surrounding nodes must be
    able to be joined with the open sides of the slice. When
    `structure` is true, the step will fail if the content between
    from and to is not just a sequence of closing and then opening
    tokens (this is to guard against rebased replace steps
    overwriting something they weren't supposed to).
    */ constructor(/**
    The start position of the replaced range.
    */ from, /**
    The end position of the replaced range.
    */ to, /**
    The slice to insert.
    */ slice, /**
    @internal
    */ structure = false){
        super();
        this.from = from;
        this.to = to;
        this.slice = slice;
        this.structure = structure;
    }
    apply(doc) {
        if (this.structure && $d15314f635f1e9c3$var$contentBetween(doc, this.from, this.to)) return $d15314f635f1e9c3$export$8ebf1578a4199c09.fail("Structure replace would overwrite content");
        return $d15314f635f1e9c3$export$8ebf1578a4199c09.fromReplace(doc, this.from, this.to, this.slice);
    }
    getMap() {
        return new $d15314f635f1e9c3$export$c53d01c3ab9721b3([
            this.from,
            this.to - this.from,
            this.slice.size
        ]);
    }
    invert(doc) {
        return new $d15314f635f1e9c3$export$5c860b2e74034756(this.from, this.from + this.slice.size, doc.slice(this.from, this.to));
    }
    map(mapping) {
        let from = mapping.mapResult(this.from, 1), to = mapping.mapResult(this.to, -1);
        if (from.deletedAcross && to.deletedAcross) return null;
        return new $d15314f635f1e9c3$export$5c860b2e74034756(from.pos, Math.max(from.pos, to.pos), this.slice);
    }
    merge(other) {
        if (!(other instanceof $d15314f635f1e9c3$export$5c860b2e74034756) || other.structure || this.structure) return null;
        if (this.from + this.slice.size == other.from && !this.slice.openEnd && !other.slice.openStart) {
            let slice = this.slice.size + other.slice.size == 0 ? (0, $1k1D7.Slice).empty : new (0, $1k1D7.Slice)(this.slice.content.append(other.slice.content), this.slice.openStart, other.slice.openEnd);
            return new $d15314f635f1e9c3$export$5c860b2e74034756(this.from, this.to + (other.to - other.from), slice, this.structure);
        } else if (other.to == this.from && !this.slice.openStart && !other.slice.openEnd) {
            let slice = this.slice.size + other.slice.size == 0 ? (0, $1k1D7.Slice).empty : new (0, $1k1D7.Slice)(other.slice.content.append(this.slice.content), other.slice.openStart, this.slice.openEnd);
            return new $d15314f635f1e9c3$export$5c860b2e74034756(other.from, this.to, slice, this.structure);
        } else return null;
    }
    toJSON() {
        let json = {
            stepType: "replace",
            from: this.from,
            to: this.to
        };
        if (this.slice.size) json.slice = this.slice.toJSON();
        if (this.structure) json.structure = true;
        return json;
    }
    /**
    @internal
    */ static fromJSON(schema, json) {
        if (typeof json.from != "number" || typeof json.to != "number") throw new RangeError("Invalid input for ReplaceStep.fromJSON");
        return new $d15314f635f1e9c3$export$5c860b2e74034756(json.from, json.to, (0, $1k1D7.Slice).fromJSON(schema, json.slice), !!json.structure);
    }
}
$d15314f635f1e9c3$export$fd55ce593607084a.jsonID("replace", $d15314f635f1e9c3$export$5c860b2e74034756);
/**
Replace a part of the document with a slice of content, but
preserve a range of the replaced content by moving it into the
slice.
*/ class $d15314f635f1e9c3$export$444ba800d6024a98 extends $d15314f635f1e9c3$export$fd55ce593607084a {
    /**
    Create a replace-around step with the given range and gap.
    `insert` should be the point in the slice into which the content
    of the gap should be moved. `structure` has the same meaning as
    it has in the [`ReplaceStep`](https://prosemirror.net/docs/ref/#transform.ReplaceStep) class.
    */ constructor(/**
    The start position of the replaced range.
    */ from, /**
    The end position of the replaced range.
    */ to, /**
    The start of preserved range.
    */ gapFrom, /**
    The end of preserved range.
    */ gapTo, /**
    The slice to insert.
    */ slice, /**
    The position in the slice where the preserved range should be
    inserted.
    */ insert, /**
    @internal
    */ structure = false){
        super();
        this.from = from;
        this.to = to;
        this.gapFrom = gapFrom;
        this.gapTo = gapTo;
        this.slice = slice;
        this.insert = insert;
        this.structure = structure;
    }
    apply(doc) {
        if (this.structure && ($d15314f635f1e9c3$var$contentBetween(doc, this.from, this.gapFrom) || $d15314f635f1e9c3$var$contentBetween(doc, this.gapTo, this.to))) return $d15314f635f1e9c3$export$8ebf1578a4199c09.fail("Structure gap-replace would overwrite content");
        let gap = doc.slice(this.gapFrom, this.gapTo);
        if (gap.openStart || gap.openEnd) return $d15314f635f1e9c3$export$8ebf1578a4199c09.fail("Gap is not a flat range");
        let inserted = this.slice.insertAt(this.insert, gap.content);
        if (!inserted) return $d15314f635f1e9c3$export$8ebf1578a4199c09.fail("Content does not fit in gap");
        return $d15314f635f1e9c3$export$8ebf1578a4199c09.fromReplace(doc, this.from, this.to, inserted);
    }
    getMap() {
        return new $d15314f635f1e9c3$export$c53d01c3ab9721b3([
            this.from,
            this.gapFrom - this.from,
            this.insert,
            this.gapTo,
            this.to - this.gapTo,
            this.slice.size - this.insert
        ]);
    }
    invert(doc) {
        let gap = this.gapTo - this.gapFrom;
        return new $d15314f635f1e9c3$export$444ba800d6024a98(this.from, this.from + this.slice.size + gap, this.from + this.insert, this.from + this.insert + gap, doc.slice(this.from, this.to).removeBetween(this.gapFrom - this.from, this.gapTo - this.from), this.gapFrom - this.from, this.structure);
    }
    map(mapping) {
        let from = mapping.mapResult(this.from, 1), to = mapping.mapResult(this.to, -1);
        let gapFrom = this.from == this.gapFrom ? from.pos : mapping.map(this.gapFrom, -1);
        let gapTo = this.to == this.gapTo ? to.pos : mapping.map(this.gapTo, 1);
        if (from.deletedAcross && to.deletedAcross || gapFrom < from.pos || gapTo > to.pos) return null;
        return new $d15314f635f1e9c3$export$444ba800d6024a98(from.pos, to.pos, gapFrom, gapTo, this.slice, this.insert, this.structure);
    }
    toJSON() {
        let json = {
            stepType: "replaceAround",
            from: this.from,
            to: this.to,
            gapFrom: this.gapFrom,
            gapTo: this.gapTo,
            insert: this.insert
        };
        if (this.slice.size) json.slice = this.slice.toJSON();
        if (this.structure) json.structure = true;
        return json;
    }
    /**
    @internal
    */ static fromJSON(schema, json) {
        if (typeof json.from != "number" || typeof json.to != "number" || typeof json.gapFrom != "number" || typeof json.gapTo != "number" || typeof json.insert != "number") throw new RangeError("Invalid input for ReplaceAroundStep.fromJSON");
        return new $d15314f635f1e9c3$export$444ba800d6024a98(json.from, json.to, json.gapFrom, json.gapTo, (0, $1k1D7.Slice).fromJSON(schema, json.slice), json.insert, !!json.structure);
    }
}
$d15314f635f1e9c3$export$fd55ce593607084a.jsonID("replaceAround", $d15314f635f1e9c3$export$444ba800d6024a98);
function $d15314f635f1e9c3$var$contentBetween(doc, from, to) {
    let $from = doc.resolve(from), dist = to - from, depth = $from.depth;
    while(dist > 0 && depth > 0 && $from.indexAfter(depth) == $from.node(depth).childCount){
        depth--;
        dist--;
    }
    if (dist > 0) {
        let next = $from.node(depth).maybeChild($from.indexAfter(depth));
        while(dist > 0){
            if (!next || next.isLeaf) return true;
            next = next.firstChild;
            dist--;
        }
    }
    return false;
}
function $d15314f635f1e9c3$var$addMark(tr, from, to, mark) {
    let removed = [], added = [];
    let removing, adding;
    tr.doc.nodesBetween(from, to, (node, pos, parent)=>{
        if (!node.isInline) return;
        let marks = node.marks;
        if (!mark.isInSet(marks) && parent.type.allowsMarkType(mark.type)) {
            let start = Math.max(pos, from), end = Math.min(pos + node.nodeSize, to);
            let newSet = mark.addToSet(marks);
            for(let i = 0; i < marks.length; i++)if (!marks[i].isInSet(newSet)) {
                if (removing && removing.to == start && removing.mark.eq(marks[i])) removing.to = end;
                else removed.push(removing = new $d15314f635f1e9c3$export$94150db1311f67a9(start, end, marks[i]));
            }
            if (adding && adding.to == start) adding.to = end;
            else added.push(adding = new $d15314f635f1e9c3$export$d24ba56b0e3464a9(start, end, mark));
        }
    });
    removed.forEach((s)=>tr.step(s));
    added.forEach((s)=>tr.step(s));
}
function $d15314f635f1e9c3$var$removeMark(tr, from, to, mark) {
    let matched = [], step = 0;
    tr.doc.nodesBetween(from, to, (node, pos)=>{
        if (!node.isInline) return;
        step++;
        let toRemove = null;
        if (mark instanceof (0, $1k1D7.MarkType)) {
            let set = node.marks, found;
            while(found = mark.isInSet(set)){
                (toRemove || (toRemove = [])).push(found);
                set = found.removeFromSet(set);
            }
        } else if (mark) {
            if (mark.isInSet(node.marks)) toRemove = [
                mark
            ];
        } else toRemove = node.marks;
        if (toRemove && toRemove.length) {
            let end = Math.min(pos + node.nodeSize, to);
            for(let i = 0; i < toRemove.length; i++){
                let style = toRemove[i], found;
                for(let j = 0; j < matched.length; j++){
                    let m = matched[j];
                    if (m.step == step - 1 && style.eq(matched[j].style)) found = m;
                }
                if (found) {
                    found.to = end;
                    found.step = step;
                } else matched.push({
                    style: style,
                    from: Math.max(pos, from),
                    to: end,
                    step: step
                });
            }
        }
    });
    matched.forEach((m)=>tr.step(new $d15314f635f1e9c3$export$94150db1311f67a9(m.from, m.to, m.style)));
}
function $d15314f635f1e9c3$var$clearIncompatible(tr, pos, parentType, match = parentType.contentMatch, clearNewlines = true) {
    let node = tr.doc.nodeAt(pos);
    let replSteps = [], cur = pos + 1;
    for(let i = 0; i < node.childCount; i++){
        let child = node.child(i), end = cur + child.nodeSize;
        let allowed = match.matchType(child.type);
        if (!allowed) replSteps.push(new $d15314f635f1e9c3$export$5c860b2e74034756(cur, end, (0, $1k1D7.Slice).empty));
        else {
            match = allowed;
            for(let j = 0; j < child.marks.length; j++)if (!parentType.allowsMarkType(child.marks[j].type)) tr.step(new $d15314f635f1e9c3$export$94150db1311f67a9(cur, end, child.marks[j]));
            if (clearNewlines && child.isText && parentType.whitespace != "pre") {
                let m, newline = /\r?\n|\r/g, slice;
                while(m = newline.exec(child.text)){
                    if (!slice) slice = new (0, $1k1D7.Slice)((0, $1k1D7.Fragment).from(parentType.schema.text(" ", parentType.allowedMarks(child.marks))), 0, 0);
                    replSteps.push(new $d15314f635f1e9c3$export$5c860b2e74034756(cur + m.index, cur + m.index + m[0].length, slice));
                }
            }
        }
        cur = end;
    }
    if (!match.validEnd) {
        let fill = match.fillBefore((0, $1k1D7.Fragment).empty, true);
        tr.replace(cur, cur, new (0, $1k1D7.Slice)(fill, 0, 0));
    }
    for(let i = replSteps.length - 1; i >= 0; i--)tr.step(replSteps[i]);
}
function $d15314f635f1e9c3$var$canCut(node, start, end) {
    return (start == 0 || node.canReplace(start, node.childCount)) && (end == node.childCount || node.canReplace(0, end));
}
/**
Try to find a target depth to which the content in the given range
can be lifted. Will not go across
[isolating](https://prosemirror.net/docs/ref/#model.NodeSpec.isolating) parent nodes.
*/ function $d15314f635f1e9c3$export$f1508b72cc76a09e(range) {
    let parent = range.parent;
    let content = parent.content.cutByIndex(range.startIndex, range.endIndex);
    for(let depth = range.depth;; --depth){
        let node = range.$from.node(depth);
        let index = range.$from.index(depth), endIndex = range.$to.indexAfter(depth);
        if (depth < range.depth && node.canReplace(index, endIndex, content)) return depth;
        if (depth == 0 || node.type.spec.isolating || !$d15314f635f1e9c3$var$canCut(node, index, endIndex)) break;
    }
    return null;
}
function $d15314f635f1e9c3$var$lift(tr, range, target) {
    let { $from: $from, $to: $to, depth: depth } = range;
    let gapStart = $from.before(depth + 1), gapEnd = $to.after(depth + 1);
    let start = gapStart, end = gapEnd;
    let before = (0, $1k1D7.Fragment).empty, openStart = 0;
    for(let d = depth, splitting = false; d > target; d--)if (splitting || $from.index(d) > 0) {
        splitting = true;
        before = (0, $1k1D7.Fragment).from($from.node(d).copy(before));
        openStart++;
    } else start--;
    let after = (0, $1k1D7.Fragment).empty, openEnd = 0;
    for(let d = depth, splitting = false; d > target; d--)if (splitting || $to.after(d + 1) < $to.end(d)) {
        splitting = true;
        after = (0, $1k1D7.Fragment).from($to.node(d).copy(after));
        openEnd++;
    } else end++;
    tr.step(new $d15314f635f1e9c3$export$444ba800d6024a98(start, end, gapStart, gapEnd, new (0, $1k1D7.Slice)(before.append(after), openStart, openEnd), before.size - openStart, true));
}
/**
Try to find a valid way to wrap the content in the given range in a
node of the given type. May introduce extra nodes around and inside
the wrapper node, if necessary. Returns null if no valid wrapping
could be found. When `innerRange` is given, that range's content is
used as the content to fit into the wrapping, instead of the
content of `range`.
*/ function $d15314f635f1e9c3$export$118cb9a83e81ba37(range, nodeType, attrs = null, innerRange = range) {
    let around = $d15314f635f1e9c3$var$findWrappingOutside(range, nodeType);
    let inner = around && $d15314f635f1e9c3$var$findWrappingInside(innerRange, nodeType);
    if (!inner) return null;
    return around.map($d15314f635f1e9c3$var$withAttrs).concat({
        type: nodeType,
        attrs: attrs
    }).concat(inner.map($d15314f635f1e9c3$var$withAttrs));
}
function $d15314f635f1e9c3$var$withAttrs(type) {
    return {
        type: type,
        attrs: null
    };
}
function $d15314f635f1e9c3$var$findWrappingOutside(range, type) {
    let { parent: parent, startIndex: startIndex, endIndex: endIndex } = range;
    let around = parent.contentMatchAt(startIndex).findWrapping(type);
    if (!around) return null;
    let outer = around.length ? around[0] : type;
    return parent.canReplaceWith(startIndex, endIndex, outer) ? around : null;
}
function $d15314f635f1e9c3$var$findWrappingInside(range, type) {
    let { parent: parent, startIndex: startIndex, endIndex: endIndex } = range;
    let inner = parent.child(startIndex);
    let inside = type.contentMatch.findWrapping(inner.type);
    if (!inside) return null;
    let lastType = inside.length ? inside[inside.length - 1] : type;
    let innerMatch = lastType.contentMatch;
    for(let i = startIndex; innerMatch && i < endIndex; i++)innerMatch = innerMatch.matchType(parent.child(i).type);
    if (!innerMatch || !innerMatch.validEnd) return null;
    return inside;
}
function $d15314f635f1e9c3$var$wrap(tr, range, wrappers) {
    let content = (0, $1k1D7.Fragment).empty;
    for(let i = wrappers.length - 1; i >= 0; i--){
        if (content.size) {
            let match = wrappers[i].type.contentMatch.matchFragment(content);
            if (!match || !match.validEnd) throw new RangeError("Wrapper type given to Transform.wrap does not form valid content of its parent wrapper");
        }
        content = (0, $1k1D7.Fragment).from(wrappers[i].type.create(wrappers[i].attrs, content));
    }
    let start = range.start, end = range.end;
    tr.step(new $d15314f635f1e9c3$export$444ba800d6024a98(start, end, start, end, new (0, $1k1D7.Slice)(content, 0, 0), wrappers.length, true));
}
function $d15314f635f1e9c3$var$setBlockType(tr, from, to, type, attrs) {
    if (!type.isTextblock) throw new RangeError("Type given to setBlockType should be a textblock");
    let mapFrom = tr.steps.length;
    tr.doc.nodesBetween(from, to, (node, pos)=>{
        let attrsHere = typeof attrs == "function" ? attrs(node) : attrs;
        if (node.isTextblock && !node.hasMarkup(type, attrsHere) && $d15314f635f1e9c3$var$canChangeType(tr.doc, tr.mapping.slice(mapFrom).map(pos), type)) {
            let convertNewlines = null;
            if (type.schema.linebreakReplacement) {
                let pre = type.whitespace == "pre", supportLinebreak = !!type.contentMatch.matchType(type.schema.linebreakReplacement);
                if (pre && !supportLinebreak) convertNewlines = false;
                else if (!pre && supportLinebreak) convertNewlines = true;
            }
            // Ensure all markup that isn't allowed in the new node type is cleared
            if (convertNewlines === false) $d15314f635f1e9c3$var$replaceLinebreaks(tr, node, pos, mapFrom);
            $d15314f635f1e9c3$var$clearIncompatible(tr, tr.mapping.slice(mapFrom).map(pos, 1), type, undefined, convertNewlines === null);
            let mapping = tr.mapping.slice(mapFrom);
            let startM = mapping.map(pos, 1), endM = mapping.map(pos + node.nodeSize, 1);
            tr.step(new $d15314f635f1e9c3$export$444ba800d6024a98(startM, endM, startM + 1, endM - 1, new (0, $1k1D7.Slice)((0, $1k1D7.Fragment).from(type.create(attrsHere, null, node.marks)), 0, 0), 1, true));
            if (convertNewlines === true) $d15314f635f1e9c3$var$replaceNewlines(tr, node, pos, mapFrom);
            return false;
        }
    });
}
function $d15314f635f1e9c3$var$replaceNewlines(tr, node, pos, mapFrom) {
    node.forEach((child, offset)=>{
        if (child.isText) {
            let m, newline = /\r?\n|\r/g;
            while(m = newline.exec(child.text)){
                let start = tr.mapping.slice(mapFrom).map(pos + 1 + offset + m.index);
                tr.replaceWith(start, start + 1, node.type.schema.linebreakReplacement.create());
            }
        }
    });
}
function $d15314f635f1e9c3$var$replaceLinebreaks(tr, node, pos, mapFrom) {
    node.forEach((child, offset)=>{
        if (child.type == child.type.schema.linebreakReplacement) {
            let start = tr.mapping.slice(mapFrom).map(pos + 1 + offset);
            tr.replaceWith(start, start + 1, node.type.schema.text("\n"));
        }
    });
}
function $d15314f635f1e9c3$var$canChangeType(doc, pos, type) {
    let $pos = doc.resolve(pos), index = $pos.index();
    return $pos.parent.canReplaceWith(index, index + 1, type);
}
/**
Change the type, attributes, and/or marks of the node at `pos`.
When `type` isn't given, the existing node type is preserved,
*/ function $d15314f635f1e9c3$var$setNodeMarkup(tr, pos, type, attrs, marks) {
    let node = tr.doc.nodeAt(pos);
    if (!node) throw new RangeError("No node at given position");
    if (!type) type = node.type;
    let newNode = type.create(attrs, null, marks || node.marks);
    if (node.isLeaf) return tr.replaceWith(pos, pos + node.nodeSize, newNode);
    if (!type.validContent(node.content)) throw new RangeError("Invalid content for node type " + type.name);
    tr.step(new $d15314f635f1e9c3$export$444ba800d6024a98(pos, pos + node.nodeSize, pos + 1, pos + node.nodeSize - 1, new (0, $1k1D7.Slice)((0, $1k1D7.Fragment).from(newNode), 0, 0), 1, true));
}
/**
Check whether splitting at the given position is allowed.
*/ function $d15314f635f1e9c3$export$5aaf008897aef029(doc, pos, depth = 1, typesAfter) {
    let $pos = doc.resolve(pos), base = $pos.depth - depth;
    let innerType = typesAfter && typesAfter[typesAfter.length - 1] || $pos.parent;
    if (base < 0 || $pos.parent.type.spec.isolating || !$pos.parent.canReplace($pos.index(), $pos.parent.childCount) || !innerType.type.validContent($pos.parent.content.cutByIndex($pos.index(), $pos.parent.childCount))) return false;
    for(let d = $pos.depth - 1, i = depth - 2; d > base; d--, i--){
        let node = $pos.node(d), index = $pos.index(d);
        if (node.type.spec.isolating) return false;
        let rest = node.content.cutByIndex(index, node.childCount);
        let overrideChild = typesAfter && typesAfter[i + 1];
        if (overrideChild) rest = rest.replaceChild(0, overrideChild.type.create(overrideChild.attrs));
        let after = typesAfter && typesAfter[i] || node;
        if (!node.canReplace(index + 1, node.childCount) || !after.type.validContent(rest)) return false;
    }
    let index = $pos.indexAfter(base);
    let baseType = typesAfter && typesAfter[0];
    return $pos.node(base).canReplaceWith(index, index, baseType ? baseType.type : $pos.node(base + 1).type);
}
function $d15314f635f1e9c3$var$split(tr, pos, depth = 1, typesAfter) {
    let $pos = tr.doc.resolve(pos), before = (0, $1k1D7.Fragment).empty, after = (0, $1k1D7.Fragment).empty;
    for(let d = $pos.depth, e = $pos.depth - depth, i = depth - 1; d > e; d--, i--){
        before = (0, $1k1D7.Fragment).from($pos.node(d).copy(before));
        let typeAfter = typesAfter && typesAfter[i];
        after = (0, $1k1D7.Fragment).from(typeAfter ? typeAfter.type.create(typeAfter.attrs, after) : $pos.node(d).copy(after));
    }
    tr.step(new $d15314f635f1e9c3$export$5c860b2e74034756(pos, pos, new (0, $1k1D7.Slice)(before.append(after), depth, depth), true));
}
/**
Test whether the blocks before and after a given position can be
joined.
*/ function $d15314f635f1e9c3$export$f15f89fd9d8cc98a(doc, pos) {
    let $pos = doc.resolve(pos), index = $pos.index();
    return $d15314f635f1e9c3$var$joinable($pos.nodeBefore, $pos.nodeAfter) && $pos.parent.canReplace(index, index + 1);
}
function $d15314f635f1e9c3$var$canAppendWithSubstitutedLinebreaks(a, b) {
    if (!b.content.size) a.type.compatibleContent(b.type);
    let match = a.contentMatchAt(a.childCount);
    let { linebreakReplacement: linebreakReplacement } = a.type.schema;
    for(let i = 0; i < b.childCount; i++){
        let child = b.child(i);
        let type = child.type == linebreakReplacement ? a.type.schema.nodes.text : child.type;
        match = match.matchType(type);
        if (!match) return false;
        if (!a.type.allowsMarks(child.marks)) return false;
    }
    return match.validEnd;
}
function $d15314f635f1e9c3$var$joinable(a, b) {
    return !!(a && b && !a.isLeaf && $d15314f635f1e9c3$var$canAppendWithSubstitutedLinebreaks(a, b));
}
/**
Find an ancestor of the given position that can be joined to the
block before (or after if `dir` is positive). Returns the joinable
point, if any.
*/ function $d15314f635f1e9c3$export$41b1d4cb5ceb3147(doc, pos, dir = -1) {
    let $pos = doc.resolve(pos);
    for(let d = $pos.depth;; d--){
        let before, after, index = $pos.index(d);
        if (d == $pos.depth) {
            before = $pos.nodeBefore;
            after = $pos.nodeAfter;
        } else if (dir > 0) {
            before = $pos.node(d + 1);
            index++;
            after = $pos.node(d).maybeChild(index);
        } else {
            before = $pos.node(d).maybeChild(index - 1);
            after = $pos.node(d + 1);
        }
        if (before && !before.isTextblock && $d15314f635f1e9c3$var$joinable(before, after) && $pos.node(d).canReplace(index, index + 1)) return pos;
        if (d == 0) break;
        pos = dir < 0 ? $pos.before(d) : $pos.after(d);
    }
}
function $d15314f635f1e9c3$var$join(tr, pos, depth) {
    let convertNewlines = null;
    let { linebreakReplacement: linebreakReplacement } = tr.doc.type.schema;
    let $before = tr.doc.resolve(pos - depth), beforeType = $before.node().type;
    if (linebreakReplacement && beforeType.inlineContent) {
        let pre = beforeType.whitespace == "pre";
        let supportLinebreak = !!beforeType.contentMatch.matchType(linebreakReplacement);
        if (pre && !supportLinebreak) convertNewlines = false;
        else if (!pre && supportLinebreak) convertNewlines = true;
    }
    let mapFrom = tr.steps.length;
    if (convertNewlines === false) {
        let $after = tr.doc.resolve(pos + depth);
        $d15314f635f1e9c3$var$replaceLinebreaks(tr, $after.node(), $after.before(), mapFrom);
    }
    if (beforeType.inlineContent) $d15314f635f1e9c3$var$clearIncompatible(tr, pos + depth - 1, beforeType, $before.node().contentMatchAt($before.index()), convertNewlines == null);
    let mapping = tr.mapping.slice(mapFrom), start = mapping.map(pos - depth);
    tr.step(new $d15314f635f1e9c3$export$5c860b2e74034756(start, mapping.map(pos + depth, -1), (0, $1k1D7.Slice).empty, true));
    if (convertNewlines === true) {
        let $full = tr.doc.resolve(start);
        $d15314f635f1e9c3$var$replaceNewlines(tr, $full.node(), $full.before(), tr.steps.length);
    }
    return tr;
}
/**
Try to find a point where a node of the given type can be inserted
near `pos`, by searching up the node hierarchy when `pos` itself
isn't a valid place but is at the start or end of a node. Return
null if no position was found.
*/ function $d15314f635f1e9c3$export$64cb316d02de1dd1(doc, pos, nodeType) {
    let $pos = doc.resolve(pos);
    if ($pos.parent.canReplaceWith($pos.index(), $pos.index(), nodeType)) return pos;
    if ($pos.parentOffset == 0) for(let d = $pos.depth - 1; d >= 0; d--){
        let index = $pos.index(d);
        if ($pos.node(d).canReplaceWith(index, index, nodeType)) return $pos.before(d + 1);
        if (index > 0) return null;
    }
    if ($pos.parentOffset == $pos.parent.content.size) for(let d = $pos.depth - 1; d >= 0; d--){
        let index = $pos.indexAfter(d);
        if ($pos.node(d).canReplaceWith(index, index, nodeType)) return $pos.after(d + 1);
        if (index < $pos.node(d).childCount) return null;
    }
    return null;
}
/**
Finds a position at or around the given position where the given
slice can be inserted. Will look at parent nodes' nearest boundary
and try there, even if the original position wasn't directly at the
start or end of that node. Returns null when no position was found.
*/ function $d15314f635f1e9c3$export$2819d598d048fc9c(doc, pos, slice) {
    let $pos = doc.resolve(pos);
    if (!slice.content.size) return pos;
    let content = slice.content;
    for(let i = 0; i < slice.openStart; i++)content = content.firstChild.content;
    for(let pass = 1; pass <= (slice.openStart == 0 && slice.size ? 2 : 1); pass++)for(let d = $pos.depth; d >= 0; d--){
        let bias = d == $pos.depth ? 0 : $pos.pos <= ($pos.start(d + 1) + $pos.end(d + 1)) / 2 ? -1 : 1;
        let insertPos = $pos.index(d) + (bias > 0 ? 1 : 0);
        let parent = $pos.node(d), fits = false;
        if (pass == 1) fits = parent.canReplace(insertPos, insertPos, content);
        else {
            let wrapping = parent.contentMatchAt(insertPos).findWrapping(content.firstChild.type);
            fits = wrapping && parent.canReplaceWith(insertPos, insertPos, wrapping[0]);
        }
        if (fits) return bias == 0 ? $pos.pos : bias < 0 ? $pos.before(d + 1) : $pos.after(d + 1);
    }
    return null;
}
/**
‘Fit’ a slice into a given position in the document, producing a
[step](https://prosemirror.net/docs/ref/#transform.Step) that inserts it. Will return null if
there's no meaningful way to insert the slice here, or inserting it
would be a no-op (an empty slice over an empty range).
*/ function $d15314f635f1e9c3$export$ed6ac67359824afd(doc, from, to = from, slice = (0, $1k1D7.Slice).empty) {
    if (from == to && !slice.size) return null;
    let $from = doc.resolve(from), $to = doc.resolve(to);
    // Optimization -- avoid work if it's obvious that it's not needed.
    if ($d15314f635f1e9c3$var$fitsTrivially($from, $to, slice)) return new $d15314f635f1e9c3$export$5c860b2e74034756(from, to, slice);
    return new $d15314f635f1e9c3$var$Fitter($from, $to, slice).fit();
}
function $d15314f635f1e9c3$var$fitsTrivially($from, $to, slice) {
    return !slice.openStart && !slice.openEnd && $from.start() == $to.start() && $from.parent.canReplace($from.index(), $to.index(), slice.content);
}
// Algorithm for 'placing' the elements of a slice into a gap:
//
// We consider the content of each node that is open to the left to be
// independently placeable. I.e. in <p("foo"), p("bar")>, when the
// paragraph on the left is open, "foo" can be placed (somewhere on
// the left side of the replacement gap) independently from p("bar").
//
// This class tracks the state of the placement progress in the
// following properties:
//
//  - `frontier` holds a stack of `{type, match}` objects that
//    represent the open side of the replacement. It starts at
//    `$from`, then moves forward as content is placed, and is finally
//    reconciled with `$to`.
//
//  - `unplaced` is a slice that represents the content that hasn't
//    been placed yet.
//
//  - `placed` is a fragment of placed content. Its open-start value
//    is implicit in `$from`, and its open-end value in `frontier`.
class $d15314f635f1e9c3$var$Fitter {
    constructor($from, $to, unplaced){
        this.$from = $from;
        this.$to = $to;
        this.unplaced = unplaced;
        this.frontier = [];
        this.placed = (0, $1k1D7.Fragment).empty;
        for(let i = 0; i <= $from.depth; i++){
            let node = $from.node(i);
            this.frontier.push({
                type: node.type,
                match: node.contentMatchAt($from.indexAfter(i))
            });
        }
        for(let i = $from.depth; i > 0; i--)this.placed = (0, $1k1D7.Fragment).from($from.node(i).copy(this.placed));
    }
    get depth() {
        return this.frontier.length - 1;
    }
    fit() {
        // As long as there's unplaced content, try to place some of it.
        // If that fails, either increase the open score of the unplaced
        // slice, or drop nodes from it, and then try again.
        while(this.unplaced.size){
            let fit = this.findFittable();
            if (fit) this.placeNodes(fit);
            else this.openMore() || this.dropNode();
        }
        // When there's inline content directly after the frontier _and_
        // directly after `this.$to`, we must generate a `ReplaceAround`
        // step that pulls that content into the node after the frontier.
        // That means the fitting must be done to the end of the textblock
        // node after `this.$to`, not `this.$to` itself.
        let moveInline = this.mustMoveInline(), placedSize = this.placed.size - this.depth - this.$from.depth;
        let $from = this.$from, $to = this.close(moveInline < 0 ? this.$to : $from.doc.resolve(moveInline));
        if (!$to) return null;
        // If closing to `$to` succeeded, create a step
        let content = this.placed, openStart = $from.depth, openEnd = $to.depth;
        while(openStart && openEnd && content.childCount == 1){
            content = content.firstChild.content;
            openStart--;
            openEnd--;
        }
        let slice = new (0, $1k1D7.Slice)(content, openStart, openEnd);
        if (moveInline > -1) return new $d15314f635f1e9c3$export$444ba800d6024a98($from.pos, moveInline, this.$to.pos, this.$to.end(), slice, placedSize);
        if (slice.size || $from.pos != this.$to.pos) return new $d15314f635f1e9c3$export$5c860b2e74034756($from.pos, $to.pos, slice);
        return null;
    }
    // Find a position on the start spine of `this.unplaced` that has
    // content that can be moved somewhere on the frontier. Returns two
    // depths, one for the slice and one for the frontier.
    findFittable() {
        let startDepth = this.unplaced.openStart;
        for(let cur = this.unplaced.content, d = 0, openEnd = this.unplaced.openEnd; d < startDepth; d++){
            let node = cur.firstChild;
            if (cur.childCount > 1) openEnd = 0;
            if (node.type.spec.isolating && openEnd <= d) {
                startDepth = d;
                break;
            }
            cur = node.content;
        }
        // Only try wrapping nodes (pass 2) after finding a place without
        // wrapping failed.
        for(let pass = 1; pass <= 2; pass++)for(let sliceDepth = pass == 1 ? startDepth : this.unplaced.openStart; sliceDepth >= 0; sliceDepth--){
            let fragment, parent = null;
            if (sliceDepth) {
                parent = $d15314f635f1e9c3$var$contentAt(this.unplaced.content, sliceDepth - 1).firstChild;
                fragment = parent.content;
            } else fragment = this.unplaced.content;
            let first = fragment.firstChild;
            for(let frontierDepth = this.depth; frontierDepth >= 0; frontierDepth--){
                let { type: type, match: match } = this.frontier[frontierDepth], wrap, inject = null;
                // In pass 1, if the next node matches, or there is no next
                // node but the parents look compatible, we've found a
                // place.
                if (pass == 1 && (first ? match.matchType(first.type) || (inject = match.fillBefore((0, $1k1D7.Fragment).from(first), false)) : parent && type.compatibleContent(parent.type))) return {
                    sliceDepth: sliceDepth,
                    frontierDepth: frontierDepth,
                    parent: parent,
                    inject: inject
                };
                else if (pass == 2 && first && (wrap = match.findWrapping(first.type))) return {
                    sliceDepth: sliceDepth,
                    frontierDepth: frontierDepth,
                    parent: parent,
                    wrap: wrap
                };
                // Don't continue looking further up if the parent node
                // would fit here.
                if (parent && match.matchType(parent.type)) break;
            }
        }
    }
    openMore() {
        let { content: content, openStart: openStart, openEnd: openEnd } = this.unplaced;
        let inner = $d15314f635f1e9c3$var$contentAt(content, openStart);
        if (!inner.childCount || inner.firstChild.isLeaf) return false;
        this.unplaced = new (0, $1k1D7.Slice)(content, openStart + 1, Math.max(openEnd, inner.size + openStart >= content.size - openEnd ? openStart + 1 : 0));
        return true;
    }
    dropNode() {
        let { content: content, openStart: openStart, openEnd: openEnd } = this.unplaced;
        let inner = $d15314f635f1e9c3$var$contentAt(content, openStart);
        if (inner.childCount <= 1 && openStart > 0) {
            let openAtEnd = content.size - openStart <= openStart + inner.size;
            this.unplaced = new (0, $1k1D7.Slice)($d15314f635f1e9c3$var$dropFromFragment(content, openStart - 1, 1), openStart - 1, openAtEnd ? openStart - 1 : openEnd);
        } else this.unplaced = new (0, $1k1D7.Slice)($d15314f635f1e9c3$var$dropFromFragment(content, openStart, 1), openStart, openEnd);
    }
    // Move content from the unplaced slice at `sliceDepth` to the
    // frontier node at `frontierDepth`. Close that frontier node when
    // applicable.
    placeNodes({ sliceDepth: sliceDepth, frontierDepth: frontierDepth, parent: parent, inject: inject, wrap: wrap }) {
        while(this.depth > frontierDepth)this.closeFrontierNode();
        if (wrap) for(let i = 0; i < wrap.length; i++)this.openFrontierNode(wrap[i]);
        let slice = this.unplaced, fragment = parent ? parent.content : slice.content;
        let openStart = slice.openStart - sliceDepth;
        let taken = 0, add = [];
        let { match: match, type: type } = this.frontier[frontierDepth];
        if (inject) {
            for(let i = 0; i < inject.childCount; i++)add.push(inject.child(i));
            match = match.matchFragment(inject);
        }
        // Computes the amount of (end) open nodes at the end of the
        // fragment. When 0, the parent is open, but no more. When
        // negative, nothing is open.
        let openEndCount = fragment.size + sliceDepth - (slice.content.size - slice.openEnd);
        // Scan over the fragment, fitting as many child nodes as
        // possible.
        while(taken < fragment.childCount){
            let next = fragment.child(taken), matches = match.matchType(next.type);
            if (!matches) break;
            taken++;
            if (taken > 1 || openStart == 0 || next.content.size) {
                match = matches;
                add.push($d15314f635f1e9c3$var$closeNodeStart(next.mark(type.allowedMarks(next.marks)), taken == 1 ? openStart : 0, taken == fragment.childCount ? openEndCount : -1));
            }
        }
        let toEnd = taken == fragment.childCount;
        if (!toEnd) openEndCount = -1;
        this.placed = $d15314f635f1e9c3$var$addToFragment(this.placed, frontierDepth, (0, $1k1D7.Fragment).from(add));
        this.frontier[frontierDepth].match = match;
        // If the parent types match, and the entire node was moved, and
        // it's not open, close this frontier node right away.
        if (toEnd && openEndCount < 0 && parent && parent.type == this.frontier[this.depth].type && this.frontier.length > 1) this.closeFrontierNode();
        // Add new frontier nodes for any open nodes at the end.
        for(let i = 0, cur = fragment; i < openEndCount; i++){
            let node = cur.lastChild;
            this.frontier.push({
                type: node.type,
                match: node.contentMatchAt(node.childCount)
            });
            cur = node.content;
        }
        // Update `this.unplaced`. Drop the entire node from which we
        // placed it we got to its end, otherwise just drop the placed
        // nodes.
        this.unplaced = !toEnd ? new (0, $1k1D7.Slice)($d15314f635f1e9c3$var$dropFromFragment(slice.content, sliceDepth, taken), slice.openStart, slice.openEnd) : sliceDepth == 0 ? (0, $1k1D7.Slice).empty : new (0, $1k1D7.Slice)($d15314f635f1e9c3$var$dropFromFragment(slice.content, sliceDepth - 1, 1), sliceDepth - 1, openEndCount < 0 ? slice.openEnd : sliceDepth - 1);
    }
    mustMoveInline() {
        if (!this.$to.parent.isTextblock) return -1;
        let top = this.frontier[this.depth], level;
        if (!top.type.isTextblock || !$d15314f635f1e9c3$var$contentAfterFits(this.$to, this.$to.depth, top.type, top.match, false) || this.$to.depth == this.depth && (level = this.findCloseLevel(this.$to)) && level.depth == this.depth) return -1;
        let { depth: depth } = this.$to, after = this.$to.after(depth);
        while(depth > 1 && after == this.$to.end(--depth))++after;
        return after;
    }
    findCloseLevel($to) {
        scan: for(let i = Math.min(this.depth, $to.depth); i >= 0; i--){
            let { match: match, type: type } = this.frontier[i];
            let dropInner = i < $to.depth && $to.end(i + 1) == $to.pos + ($to.depth - (i + 1));
            let fit = $d15314f635f1e9c3$var$contentAfterFits($to, i, type, match, dropInner);
            if (!fit) continue;
            for(let d = i - 1; d >= 0; d--){
                let { match: match, type: type } = this.frontier[d];
                let matches = $d15314f635f1e9c3$var$contentAfterFits($to, d, type, match, true);
                if (!matches || matches.childCount) continue scan;
            }
            return {
                depth: i,
                fit: fit,
                move: dropInner ? $to.doc.resolve($to.after(i + 1)) : $to
            };
        }
    }
    close($to) {
        let close = this.findCloseLevel($to);
        if (!close) return null;
        while(this.depth > close.depth)this.closeFrontierNode();
        if (close.fit.childCount) this.placed = $d15314f635f1e9c3$var$addToFragment(this.placed, close.depth, close.fit);
        $to = close.move;
        for(let d = close.depth + 1; d <= $to.depth; d++){
            let node = $to.node(d), add = node.type.contentMatch.fillBefore(node.content, true, $to.index(d));
            this.openFrontierNode(node.type, node.attrs, add);
        }
        return $to;
    }
    openFrontierNode(type, attrs = null, content) {
        let top = this.frontier[this.depth];
        top.match = top.match.matchType(type);
        this.placed = $d15314f635f1e9c3$var$addToFragment(this.placed, this.depth, (0, $1k1D7.Fragment).from(type.create(attrs, content)));
        this.frontier.push({
            type: type,
            match: type.contentMatch
        });
    }
    closeFrontierNode() {
        let open = this.frontier.pop();
        let add = open.match.fillBefore((0, $1k1D7.Fragment).empty, true);
        if (add.childCount) this.placed = $d15314f635f1e9c3$var$addToFragment(this.placed, this.frontier.length, add);
    }
}
function $d15314f635f1e9c3$var$dropFromFragment(fragment, depth, count) {
    if (depth == 0) return fragment.cutByIndex(count, fragment.childCount);
    return fragment.replaceChild(0, fragment.firstChild.copy($d15314f635f1e9c3$var$dropFromFragment(fragment.firstChild.content, depth - 1, count)));
}
function $d15314f635f1e9c3$var$addToFragment(fragment, depth, content) {
    if (depth == 0) return fragment.append(content);
    return fragment.replaceChild(fragment.childCount - 1, fragment.lastChild.copy($d15314f635f1e9c3$var$addToFragment(fragment.lastChild.content, depth - 1, content)));
}
function $d15314f635f1e9c3$var$contentAt(fragment, depth) {
    for(let i = 0; i < depth; i++)fragment = fragment.firstChild.content;
    return fragment;
}
function $d15314f635f1e9c3$var$closeNodeStart(node, openStart, openEnd) {
    if (openStart <= 0) return node;
    let frag = node.content;
    if (openStart > 1) frag = frag.replaceChild(0, $d15314f635f1e9c3$var$closeNodeStart(frag.firstChild, openStart - 1, frag.childCount == 1 ? openEnd - 1 : 0));
    if (openStart > 0) {
        frag = node.type.contentMatch.fillBefore(frag).append(frag);
        if (openEnd <= 0) frag = frag.append(node.type.contentMatch.matchFragment(frag).fillBefore((0, $1k1D7.Fragment).empty, true));
    }
    return node.copy(frag);
}
function $d15314f635f1e9c3$var$contentAfterFits($to, depth, type, match, open) {
    let node = $to.node(depth), index = open ? $to.indexAfter(depth) : $to.index(depth);
    if (index == node.childCount && !type.compatibleContent(node.type)) return null;
    let fit = match.fillBefore(node.content, true, index);
    return fit && !$d15314f635f1e9c3$var$invalidMarks(type, node.content, index) ? fit : null;
}
function $d15314f635f1e9c3$var$invalidMarks(type, fragment, start) {
    for(let i = start; i < fragment.childCount; i++)if (!type.allowsMarks(fragment.child(i).marks)) return true;
    return false;
}
function $d15314f635f1e9c3$var$definesContent(type) {
    return type.spec.defining || type.spec.definingForContent;
}
function $d15314f635f1e9c3$var$replaceRange(tr, from, to, slice) {
    if (!slice.size) return tr.deleteRange(from, to);
    let $from = tr.doc.resolve(from), $to = tr.doc.resolve(to);
    if ($d15314f635f1e9c3$var$fitsTrivially($from, $to, slice)) return tr.step(new $d15314f635f1e9c3$export$5c860b2e74034756(from, to, slice));
    let targetDepths = $d15314f635f1e9c3$var$coveredDepths($from, tr.doc.resolve(to));
    // Can't replace the whole document, so remove 0 if it's present
    if (targetDepths[targetDepths.length - 1] == 0) targetDepths.pop();
    // Negative numbers represent not expansion over the whole node at
    // that depth, but replacing from $from.before(-D) to $to.pos.
    let preferredTarget = -($from.depth + 1);
    targetDepths.unshift(preferredTarget);
    // This loop picks a preferred target depth, if one of the covering
    // depths is not outside of a defining node, and adds negative
    // depths for any depth that has $from at its start and does not
    // cross a defining node.
    for(let d = $from.depth, pos = $from.pos - 1; d > 0; d--, pos--){
        let spec = $from.node(d).type.spec;
        if (spec.defining || spec.definingAsContext || spec.isolating) break;
        if (targetDepths.indexOf(d) > -1) preferredTarget = d;
        else if ($from.before(d) == pos) targetDepths.splice(1, 0, -d);
    }
    // Try to fit each possible depth of the slice into each possible
    // target depth, starting with the preferred depths.
    let preferredTargetIndex = targetDepths.indexOf(preferredTarget);
    let leftNodes = [], preferredDepth = slice.openStart;
    for(let content = slice.content, i = 0;; i++){
        let node = content.firstChild;
        leftNodes.push(node);
        if (i == slice.openStart) break;
        content = node.content;
    }
    // Back up preferredDepth to cover defining textblocks directly
    // above it, possibly skipping a non-defining textblock.
    for(let d = preferredDepth - 1; d >= 0; d--){
        let leftNode = leftNodes[d], def = $d15314f635f1e9c3$var$definesContent(leftNode.type);
        if (def && !leftNode.sameMarkup($from.node(Math.abs(preferredTarget) - 1))) preferredDepth = d;
        else if (def || !leftNode.type.isTextblock) break;
    }
    for(let j = slice.openStart; j >= 0; j--){
        let openDepth = (j + preferredDepth + 1) % (slice.openStart + 1);
        let insert = leftNodes[openDepth];
        if (!insert) continue;
        for(let i = 0; i < targetDepths.length; i++){
            // Loop over possible expansion levels, starting with the
            // preferred one
            let targetDepth = targetDepths[(i + preferredTargetIndex) % targetDepths.length], expand = true;
            if (targetDepth < 0) {
                expand = false;
                targetDepth = -targetDepth;
            }
            let parent = $from.node(targetDepth - 1), index = $from.index(targetDepth - 1);
            if (parent.canReplaceWith(index, index, insert.type, insert.marks)) return tr.replace($from.before(targetDepth), expand ? $to.after(targetDepth) : to, new (0, $1k1D7.Slice)($d15314f635f1e9c3$var$closeFragment(slice.content, 0, slice.openStart, openDepth), openDepth, slice.openEnd));
        }
    }
    let startSteps = tr.steps.length;
    for(let i = targetDepths.length - 1; i >= 0; i--){
        tr.replace(from, to, slice);
        if (tr.steps.length > startSteps) break;
        let depth = targetDepths[i];
        if (depth < 0) continue;
        from = $from.before(depth);
        to = $to.after(depth);
    }
}
function $d15314f635f1e9c3$var$closeFragment(fragment, depth, oldOpen, newOpen, parent) {
    if (depth < oldOpen) {
        let first = fragment.firstChild;
        fragment = fragment.replaceChild(0, first.copy($d15314f635f1e9c3$var$closeFragment(first.content, depth + 1, oldOpen, newOpen, first)));
    }
    if (depth > newOpen) {
        let match = parent.contentMatchAt(0);
        let start = match.fillBefore(fragment).append(fragment);
        fragment = start.append(match.matchFragment(start).fillBefore((0, $1k1D7.Fragment).empty, true));
    }
    return fragment;
}
function $d15314f635f1e9c3$var$replaceRangeWith(tr, from, to, node) {
    if (!node.isInline && from == to && tr.doc.resolve(from).parent.content.size) {
        let point = $d15314f635f1e9c3$export$64cb316d02de1dd1(tr.doc, from, node.type);
        if (point != null) from = to = point;
    }
    tr.replaceRange(from, to, new (0, $1k1D7.Slice)((0, $1k1D7.Fragment).from(node), 0, 0));
}
function $d15314f635f1e9c3$var$deleteRange(tr, from, to) {
    let $from = tr.doc.resolve(from), $to = tr.doc.resolve(to);
    let covered = $d15314f635f1e9c3$var$coveredDepths($from, $to);
    for(let i = 0; i < covered.length; i++){
        let depth = covered[i], last = i == covered.length - 1;
        if (last && depth == 0 || $from.node(depth).type.contentMatch.validEnd) return tr.delete($from.start(depth), $to.end(depth));
        if (depth > 0 && (last || $from.node(depth - 1).canReplace($from.index(depth - 1), $to.indexAfter(depth - 1)))) return tr.delete($from.before(depth), $to.after(depth));
    }
    for(let d = 1; d <= $from.depth && d <= $to.depth; d++){
        if (from - $from.start(d) == $from.depth - d && to > $from.end(d) && $to.end(d) - to != $to.depth - d && $from.start(d - 1) == $to.start(d - 1) && $from.node(d - 1).canReplace($from.index(d - 1), $to.index(d - 1))) return tr.delete($from.before(d), to);
    }
    tr.delete(from, to);
}
// Returns an array of all depths for which $from - $to spans the
// whole content of the nodes at that depth.
function $d15314f635f1e9c3$var$coveredDepths($from, $to) {
    let result = [], minDepth = Math.min($from.depth, $to.depth);
    for(let d = minDepth; d >= 0; d--){
        let start = $from.start(d);
        if (start < $from.pos - ($from.depth - d) || $to.end(d) > $to.pos + ($to.depth - d) || $from.node(d).type.spec.isolating || $to.node(d).type.spec.isolating) break;
        if (start == $to.start(d) || d == $from.depth && d == $to.depth && $from.parent.inlineContent && $to.parent.inlineContent && d && $to.start(d - 1) == start - 1) result.push(d);
    }
    return result;
}
/**
Update an attribute in a specific node.
*/ class $d15314f635f1e9c3$export$626399c38172f669 extends $d15314f635f1e9c3$export$fd55ce593607084a {
    /**
    Construct an attribute step.
    */ constructor(/**
    The position of the target node.
    */ pos, /**
    The attribute to set.
    */ attr, // The attribute's new value.
    value){
        super();
        this.pos = pos;
        this.attr = attr;
        this.value = value;
    }
    apply(doc) {
        let node = doc.nodeAt(this.pos);
        if (!node) return $d15314f635f1e9c3$export$8ebf1578a4199c09.fail("No node at attribute step's position");
        let attrs = Object.create(null);
        for(let name in node.attrs)attrs[name] = node.attrs[name];
        attrs[this.attr] = this.value;
        let updated = node.type.create(attrs, null, node.marks);
        return $d15314f635f1e9c3$export$8ebf1578a4199c09.fromReplace(doc, this.pos, this.pos + 1, new (0, $1k1D7.Slice)((0, $1k1D7.Fragment).from(updated), 0, node.isLeaf ? 0 : 1));
    }
    getMap() {
        return $d15314f635f1e9c3$export$c53d01c3ab9721b3.empty;
    }
    invert(doc) {
        return new $d15314f635f1e9c3$export$626399c38172f669(this.pos, this.attr, doc.nodeAt(this.pos).attrs[this.attr]);
    }
    map(mapping) {
        let pos = mapping.mapResult(this.pos, 1);
        return pos.deletedAfter ? null : new $d15314f635f1e9c3$export$626399c38172f669(pos.pos, this.attr, this.value);
    }
    toJSON() {
        return {
            stepType: "attr",
            pos: this.pos,
            attr: this.attr,
            value: this.value
        };
    }
    static fromJSON(schema, json) {
        if (typeof json.pos != "number" || typeof json.attr != "string") throw new RangeError("Invalid input for AttrStep.fromJSON");
        return new $d15314f635f1e9c3$export$626399c38172f669(json.pos, json.attr, json.value);
    }
}
$d15314f635f1e9c3$export$fd55ce593607084a.jsonID("attr", $d15314f635f1e9c3$export$626399c38172f669);
/**
Update an attribute in the doc node.
*/ class $d15314f635f1e9c3$export$f50707b396300ac9 extends $d15314f635f1e9c3$export$fd55ce593607084a {
    /**
    Construct an attribute step.
    */ constructor(/**
    The attribute to set.
    */ attr, // The attribute's new value.
    value){
        super();
        this.attr = attr;
        this.value = value;
    }
    apply(doc) {
        let attrs = Object.create(null);
        for(let name in doc.attrs)attrs[name] = doc.attrs[name];
        attrs[this.attr] = this.value;
        let updated = doc.type.create(attrs, doc.content, doc.marks);
        return $d15314f635f1e9c3$export$8ebf1578a4199c09.ok(updated);
    }
    getMap() {
        return $d15314f635f1e9c3$export$c53d01c3ab9721b3.empty;
    }
    invert(doc) {
        return new $d15314f635f1e9c3$export$f50707b396300ac9(this.attr, doc.attrs[this.attr]);
    }
    map(mapping) {
        return this;
    }
    toJSON() {
        return {
            stepType: "docAttr",
            attr: this.attr,
            value: this.value
        };
    }
    static fromJSON(schema, json) {
        if (typeof json.attr != "string") throw new RangeError("Invalid input for DocAttrStep.fromJSON");
        return new $d15314f635f1e9c3$export$f50707b396300ac9(json.attr, json.value);
    }
}
$d15314f635f1e9c3$export$fd55ce593607084a.jsonID("docAttr", $d15314f635f1e9c3$export$f50707b396300ac9);
/**
@internal
*/ let $d15314f635f1e9c3$export$88cc3a1dfce48dd3 = class extends Error {
};
$d15314f635f1e9c3$export$88cc3a1dfce48dd3 = function TransformError(message) {
    let err = Error.call(this, message);
    err.__proto__ = TransformError.prototype;
    return err;
};
$d15314f635f1e9c3$export$88cc3a1dfce48dd3.prototype = Object.create(Error.prototype);
$d15314f635f1e9c3$export$88cc3a1dfce48dd3.prototype.constructor = $d15314f635f1e9c3$export$88cc3a1dfce48dd3;
$d15314f635f1e9c3$export$88cc3a1dfce48dd3.prototype.name = "TransformError";
/**
Abstraction to build up and track an array of
[steps](https://prosemirror.net/docs/ref/#transform.Step) representing a document transformation.

Most transforming methods return the `Transform` object itself, so
that they can be chained.
*/ class $d15314f635f1e9c3$export$563a914cafbdc389 {
    /**
    Create a transform that starts with the given document.
    */ constructor(/**
    The current document (the result of applying the steps in the
    transform).
    */ doc){
        this.doc = doc;
        /**
        The steps in this transform.
        */ this.steps = [];
        /**
        The documents before each of the steps.
        */ this.docs = [];
        /**
        A mapping with the maps for each of the steps in this transform.
        */ this.mapping = new $d15314f635f1e9c3$export$f5f785078011b62;
    }
    /**
    The starting document.
    */ get before() {
        return this.docs.length ? this.docs[0] : this.doc;
    }
    /**
    Apply a new step in this transform, saving the result. Throws an
    error when the step fails.
    */ step(step) {
        let result = this.maybeStep(step);
        if (result.failed) throw new $d15314f635f1e9c3$export$88cc3a1dfce48dd3(result.failed);
        return this;
    }
    /**
    Try to apply a step in this transformation, ignoring it if it
    fails. Returns the step result.
    */ maybeStep(step) {
        let result = step.apply(this.doc);
        if (!result.failed) this.addStep(step, result.doc);
        return result;
    }
    /**
    True when the document has been changed (when there are any
    steps).
    */ get docChanged() {
        return this.steps.length > 0;
    }
    /**
    @internal
    */ addStep(step, doc) {
        this.docs.push(this.doc);
        this.steps.push(step);
        this.mapping.appendMap(step.getMap());
        this.doc = doc;
    }
    /**
    Replace the part of the document between `from` and `to` with the
    given `slice`.
    */ replace(from, to = from, slice = (0, $1k1D7.Slice).empty) {
        let step = $d15314f635f1e9c3$export$ed6ac67359824afd(this.doc, from, to, slice);
        if (step) this.step(step);
        return this;
    }
    /**
    Replace the given range with the given content, which may be a
    fragment, node, or array of nodes.
    */ replaceWith(from, to, content) {
        return this.replace(from, to, new (0, $1k1D7.Slice)((0, $1k1D7.Fragment).from(content), 0, 0));
    }
    /**
    Delete the content between the given positions.
    */ delete(from, to) {
        return this.replace(from, to, (0, $1k1D7.Slice).empty);
    }
    /**
    Insert the given content at the given position.
    */ insert(pos, content) {
        return this.replaceWith(pos, pos, content);
    }
    /**
    Replace a range of the document with a given slice, using
    `from`, `to`, and the slice's
    [`openStart`](https://prosemirror.net/docs/ref/#model.Slice.openStart) property as hints, rather
    than fixed start and end points. This method may grow the
    replaced area or close open nodes in the slice in order to get a
    fit that is more in line with WYSIWYG expectations, by dropping
    fully covered parent nodes of the replaced region when they are
    marked [non-defining as
    context](https://prosemirror.net/docs/ref/#model.NodeSpec.definingAsContext), or including an
    open parent node from the slice that _is_ marked as [defining
    its content](https://prosemirror.net/docs/ref/#model.NodeSpec.definingForContent).
    
    This is the method, for example, to handle paste. The similar
    [`replace`](https://prosemirror.net/docs/ref/#transform.Transform.replace) method is a more
    primitive tool which will _not_ move the start and end of its given
    range, and is useful in situations where you need more precise
    control over what happens.
    */ replaceRange(from, to, slice) {
        $d15314f635f1e9c3$var$replaceRange(this, from, to, slice);
        return this;
    }
    /**
    Replace the given range with a node, but use `from` and `to` as
    hints, rather than precise positions. When from and to are the same
    and are at the start or end of a parent node in which the given
    node doesn't fit, this method may _move_ them out towards a parent
    that does allow the given node to be placed. When the given range
    completely covers a parent node, this method may completely replace
    that parent node.
    */ replaceRangeWith(from, to, node) {
        $d15314f635f1e9c3$var$replaceRangeWith(this, from, to, node);
        return this;
    }
    /**
    Delete the given range, expanding it to cover fully covered
    parent nodes until a valid replace is found.
    */ deleteRange(from, to) {
        $d15314f635f1e9c3$var$deleteRange(this, from, to);
        return this;
    }
    /**
    Split the content in the given range off from its parent, if there
    is sibling content before or after it, and move it up the tree to
    the depth specified by `target`. You'll probably want to use
    [`liftTarget`](https://prosemirror.net/docs/ref/#transform.liftTarget) to compute `target`, to make
    sure the lift is valid.
    */ lift(range, target) {
        $d15314f635f1e9c3$var$lift(this, range, target);
        return this;
    }
    /**
    Join the blocks around the given position. If depth is 2, their
    last and first siblings are also joined, and so on.
    */ join(pos, depth = 1) {
        $d15314f635f1e9c3$var$join(this, pos, depth);
        return this;
    }
    /**
    Wrap the given [range](https://prosemirror.net/docs/ref/#model.NodeRange) in the given set of wrappers.
    The wrappers are assumed to be valid in this position, and should
    probably be computed with [`findWrapping`](https://prosemirror.net/docs/ref/#transform.findWrapping).
    */ wrap(range, wrappers) {
        $d15314f635f1e9c3$var$wrap(this, range, wrappers);
        return this;
    }
    /**
    Set the type of all textblocks (partly) between `from` and `to` to
    the given node type with the given attributes.
    */ setBlockType(from, to = from, type, attrs = null) {
        $d15314f635f1e9c3$var$setBlockType(this, from, to, type, attrs);
        return this;
    }
    /**
    Change the type, attributes, and/or marks of the node at `pos`.
    When `type` isn't given, the existing node type is preserved,
    */ setNodeMarkup(pos, type, attrs = null, marks) {
        $d15314f635f1e9c3$var$setNodeMarkup(this, pos, type, attrs, marks);
        return this;
    }
    /**
    Set a single attribute on a given node to a new value.
    The `pos` addresses the document content. Use `setDocAttribute`
    to set attributes on the document itself.
    */ setNodeAttribute(pos, attr, value) {
        this.step(new $d15314f635f1e9c3$export$626399c38172f669(pos, attr, value));
        return this;
    }
    /**
    Set a single attribute on the document to a new value.
    */ setDocAttribute(attr, value) {
        this.step(new $d15314f635f1e9c3$export$f50707b396300ac9(attr, value));
        return this;
    }
    /**
    Add a mark to the node at position `pos`.
    */ addNodeMark(pos, mark) {
        this.step(new $d15314f635f1e9c3$export$adefd16c402fee4e(pos, mark));
        return this;
    }
    /**
    Remove a mark (or a mark of the given type) from the node at
    position `pos`.
    */ removeNodeMark(pos, mark) {
        if (!(mark instanceof (0, $1k1D7.Mark))) {
            let node = this.doc.nodeAt(pos);
            if (!node) throw new RangeError("No node at position " + pos);
            mark = mark.isInSet(node.marks);
            if (!mark) return this;
        }
        this.step(new $d15314f635f1e9c3$export$fdf7d1dc10724da2(pos, mark));
        return this;
    }
    /**
    Split the node at the given position, and optionally, if `depth` is
    greater than one, any number of nodes above that. By default, the
    parts split off will inherit the node type of the original node.
    This can be changed by passing an array of types and attributes to
    use after the split.
    */ split(pos, depth = 1, typesAfter) {
        $d15314f635f1e9c3$var$split(this, pos, depth, typesAfter);
        return this;
    }
    /**
    Add the given mark to the inline content between `from` and `to`.
    */ addMark(from, to, mark) {
        $d15314f635f1e9c3$var$addMark(this, from, to, mark);
        return this;
    }
    /**
    Remove marks from inline nodes between `from` and `to`. When
    `mark` is a single mark, remove precisely that mark. When it is
    a mark type, remove all marks of that type. When it is null,
    remove all marks of any type.
    */ removeMark(from, to, mark) {
        $d15314f635f1e9c3$var$removeMark(this, from, to, mark);
        return this;
    }
    /**
    Removes all marks and nodes from the content of the node at
    `pos` that don't match the given new parent node type. Accepts
    an optional starting [content match](https://prosemirror.net/docs/ref/#model.ContentMatch) as
    third argument.
    */ clearIncompatible(pos, parentType, match) {
        $d15314f635f1e9c3$var$clearIncompatible(this, pos, parentType, match);
        return this;
    }
}

});
parcelRegister("1k1D7", function(module, exports) {
$parcel$export(module.exports, "Fragment", () => $0f68ec5a5289168c$export$ffb0004e005737fa);
$parcel$export(module.exports, "Mark", () => $0f68ec5a5289168c$export$c9d15bcfc6d42044);
$parcel$export(module.exports, "ReplaceError", () => $0f68ec5a5289168c$export$6de0e778727af3f2);
$parcel$export(module.exports, "Slice", () => $0f68ec5a5289168c$export$b3f2e2de3a8baa1e);
$parcel$export(module.exports, "MarkType", () => $0f68ec5a5289168c$export$b6a78689043c6521);

var $at9VT = parcelRequire("at9VT");
function $0f68ec5a5289168c$var$findDiffStart(a, b, pos) {
    for(let i = 0;; i++){
        if (i == a.childCount || i == b.childCount) return a.childCount == b.childCount ? null : pos;
        let childA = a.child(i), childB = b.child(i);
        if (childA == childB) {
            pos += childA.nodeSize;
            continue;
        }
        if (!childA.sameMarkup(childB)) return pos;
        if (childA.isText && childA.text != childB.text) {
            for(let j = 0; childA.text[j] == childB.text[j]; j++)pos++;
            return pos;
        }
        if (childA.content.size || childB.content.size) {
            let inner = $0f68ec5a5289168c$var$findDiffStart(childA.content, childB.content, pos + 1);
            if (inner != null) return inner;
        }
        pos += childA.nodeSize;
    }
}
function $0f68ec5a5289168c$var$findDiffEnd(a, b, posA, posB) {
    for(let iA = a.childCount, iB = b.childCount;;){
        if (iA == 0 || iB == 0) return iA == iB ? null : {
            a: posA,
            b: posB
        };
        let childA = a.child(--iA), childB = b.child(--iB), size = childA.nodeSize;
        if (childA == childB) {
            posA -= size;
            posB -= size;
            continue;
        }
        if (!childA.sameMarkup(childB)) return {
            a: posA,
            b: posB
        };
        if (childA.isText && childA.text != childB.text) {
            let same = 0, minSize = Math.min(childA.text.length, childB.text.length);
            while(same < minSize && childA.text[childA.text.length - same - 1] == childB.text[childB.text.length - same - 1]){
                same++;
                posA--;
                posB--;
            }
            return {
                a: posA,
                b: posB
            };
        }
        if (childA.content.size || childB.content.size) {
            let inner = $0f68ec5a5289168c$var$findDiffEnd(childA.content, childB.content, posA - 1, posB - 1);
            if (inner) return inner;
        }
        posA -= size;
        posB -= size;
    }
}
/**
A fragment represents a node's collection of child nodes.

Like nodes, fragments are persistent data structures, and you
should not mutate them or their content. Rather, you create new
instances whenever needed. The API tries to make this easy.
*/ class $0f68ec5a5289168c$export$ffb0004e005737fa {
    /**
    @internal
    */ constructor(/**
    The child nodes in this fragment.
    */ content, size){
        this.content = content;
        this.size = size || 0;
        if (size == null) for(let i = 0; i < content.length; i++)this.size += content[i].nodeSize;
    }
    /**
    Invoke a callback for all descendant nodes between the given two
    positions (relative to start of this fragment). Doesn't descend
    into a node when the callback returns `false`.
    */ nodesBetween(from, to, f, nodeStart = 0, parent) {
        for(let i = 0, pos = 0; pos < to; i++){
            let child = this.content[i], end = pos + child.nodeSize;
            if (end > from && f(child, nodeStart + pos, parent || null, i) !== false && child.content.size) {
                let start = pos + 1;
                child.nodesBetween(Math.max(0, from - start), Math.min(child.content.size, to - start), f, nodeStart + start);
            }
            pos = end;
        }
    }
    /**
    Call the given callback for every descendant node. `pos` will be
    relative to the start of the fragment. The callback may return
    `false` to prevent traversal of a given node's children.
    */ descendants(f) {
        this.nodesBetween(0, this.size, f);
    }
    /**
    Extract the text between `from` and `to`. See the same method on
    [`Node`](https://prosemirror.net/docs/ref/#model.Node.textBetween).
    */ textBetween(from, to, blockSeparator, leafText) {
        let text = "", first = true;
        this.nodesBetween(from, to, (node, pos)=>{
            let nodeText = node.isText ? node.text.slice(Math.max(from, pos) - pos, to - pos) : !node.isLeaf ? "" : leafText ? typeof leafText === "function" ? leafText(node) : leafText : node.type.spec.leafText ? node.type.spec.leafText(node) : "";
            if (node.isBlock && (node.isLeaf && nodeText || node.isTextblock) && blockSeparator) {
                if (first) first = false;
                else text += blockSeparator;
            }
            text += nodeText;
        }, 0);
        return text;
    }
    /**
    Create a new fragment containing the combined content of this
    fragment and the other.
    */ append(other) {
        if (!other.size) return this;
        if (!this.size) return other;
        let last = this.lastChild, first = other.firstChild, content = this.content.slice(), i = 0;
        if (last.isText && last.sameMarkup(first)) {
            content[content.length - 1] = last.withText(last.text + first.text);
            i = 1;
        }
        for(; i < other.content.length; i++)content.push(other.content[i]);
        return new $0f68ec5a5289168c$export$ffb0004e005737fa(content, this.size + other.size);
    }
    /**
    Cut out the sub-fragment between the two given positions.
    */ cut(from, to = this.size) {
        if (from == 0 && to == this.size) return this;
        let result = [], size = 0;
        if (to > from) for(let i = 0, pos = 0; pos < to; i++){
            let child = this.content[i], end = pos + child.nodeSize;
            if (end > from) {
                if (pos < from || end > to) {
                    if (child.isText) child = child.cut(Math.max(0, from - pos), Math.min(child.text.length, to - pos));
                    else child = child.cut(Math.max(0, from - pos - 1), Math.min(child.content.size, to - pos - 1));
                }
                result.push(child);
                size += child.nodeSize;
            }
            pos = end;
        }
        return new $0f68ec5a5289168c$export$ffb0004e005737fa(result, size);
    }
    /**
    @internal
    */ cutByIndex(from, to) {
        if (from == to) return $0f68ec5a5289168c$export$ffb0004e005737fa.empty;
        if (from == 0 && to == this.content.length) return this;
        return new $0f68ec5a5289168c$export$ffb0004e005737fa(this.content.slice(from, to));
    }
    /**
    Create a new fragment in which the node at the given index is
    replaced by the given node.
    */ replaceChild(index, node) {
        let current = this.content[index];
        if (current == node) return this;
        let copy = this.content.slice();
        let size = this.size + node.nodeSize - current.nodeSize;
        copy[index] = node;
        return new $0f68ec5a5289168c$export$ffb0004e005737fa(copy, size);
    }
    /**
    Create a new fragment by prepending the given node to this
    fragment.
    */ addToStart(node) {
        return new $0f68ec5a5289168c$export$ffb0004e005737fa([
            node
        ].concat(this.content), this.size + node.nodeSize);
    }
    /**
    Create a new fragment by appending the given node to this
    fragment.
    */ addToEnd(node) {
        return new $0f68ec5a5289168c$export$ffb0004e005737fa(this.content.concat(node), this.size + node.nodeSize);
    }
    /**
    Compare this fragment to another one.
    */ eq(other) {
        if (this.content.length != other.content.length) return false;
        for(let i = 0; i < this.content.length; i++)if (!this.content[i].eq(other.content[i])) return false;
        return true;
    }
    /**
    The first child of the fragment, or `null` if it is empty.
    */ get firstChild() {
        return this.content.length ? this.content[0] : null;
    }
    /**
    The last child of the fragment, or `null` if it is empty.
    */ get lastChild() {
        return this.content.length ? this.content[this.content.length - 1] : null;
    }
    /**
    The number of child nodes in this fragment.
    */ get childCount() {
        return this.content.length;
    }
    /**
    Get the child node at the given index. Raise an error when the
    index is out of range.
    */ child(index) {
        let found = this.content[index];
        if (!found) throw new RangeError("Index " + index + " out of range for " + this);
        return found;
    }
    /**
    Get the child node at the given index, if it exists.
    */ maybeChild(index) {
        return this.content[index] || null;
    }
    /**
    Call `f` for every child node, passing the node, its offset
    into this parent node, and its index.
    */ forEach(f) {
        for(let i = 0, p = 0; i < this.content.length; i++){
            let child = this.content[i];
            f(child, p, i);
            p += child.nodeSize;
        }
    }
    /**
    Find the first position at which this fragment and another
    fragment differ, or `null` if they are the same.
    */ findDiffStart(other, pos = 0) {
        return $0f68ec5a5289168c$var$findDiffStart(this, other, pos);
    }
    /**
    Find the first position, searching from the end, at which this
    fragment and the given fragment differ, or `null` if they are
    the same. Since this position will not be the same in both
    nodes, an object with two separate positions is returned.
    */ findDiffEnd(other, pos = this.size, otherPos = other.size) {
        return $0f68ec5a5289168c$var$findDiffEnd(this, other, pos, otherPos);
    }
    /**
    Find the index and inner offset corresponding to a given relative
    position in this fragment. The result object will be reused
    (overwritten) the next time the function is called. @internal
    */ findIndex(pos) {
        if (pos == 0) return $0f68ec5a5289168c$var$retIndex(0, pos);
        if (pos == this.size) return $0f68ec5a5289168c$var$retIndex(this.content.length, pos);
        if (pos > this.size || pos < 0) throw new RangeError(`Position ${pos} outside of fragment (${this})`);
        for(let i = 0, curPos = 0;; i++){
            let cur = this.child(i), end = curPos + cur.nodeSize;
            if (end >= pos) {
                if (end == pos) return $0f68ec5a5289168c$var$retIndex(i + 1, end);
                return $0f68ec5a5289168c$var$retIndex(i, curPos);
            }
            curPos = end;
        }
    }
    /**
    Return a debugging string that describes this fragment.
    */ toString() {
        return "<" + this.toStringInner() + ">";
    }
    /**
    @internal
    */ toStringInner() {
        return this.content.join(", ");
    }
    /**
    Create a JSON-serializeable representation of this fragment.
    */ toJSON() {
        return this.content.length ? this.content.map((n)=>n.toJSON()) : null;
    }
    /**
    Deserialize a fragment from its JSON representation.
    */ static fromJSON(schema, value) {
        if (!value) return $0f68ec5a5289168c$export$ffb0004e005737fa.empty;
        if (!Array.isArray(value)) throw new RangeError("Invalid input for Fragment.fromJSON");
        return new $0f68ec5a5289168c$export$ffb0004e005737fa(value.map(schema.nodeFromJSON));
    }
    /**
    Build a fragment from an array of nodes. Ensures that adjacent
    text nodes with the same marks are joined together.
    */ static fromArray(array) {
        if (!array.length) return $0f68ec5a5289168c$export$ffb0004e005737fa.empty;
        let joined, size = 0;
        for(let i = 0; i < array.length; i++){
            let node = array[i];
            size += node.nodeSize;
            if (i && node.isText && array[i - 1].sameMarkup(node)) {
                if (!joined) joined = array.slice(0, i);
                joined[joined.length - 1] = node.withText(joined[joined.length - 1].text + node.text);
            } else if (joined) joined.push(node);
        }
        return new $0f68ec5a5289168c$export$ffb0004e005737fa(joined || array, size);
    }
    /**
    Create a fragment from something that can be interpreted as a
    set of nodes. For `null`, it returns the empty fragment. For a
    fragment, the fragment itself. For a node or array of nodes, a
    fragment containing those nodes.
    */ static from(nodes) {
        if (!nodes) return $0f68ec5a5289168c$export$ffb0004e005737fa.empty;
        if (nodes instanceof $0f68ec5a5289168c$export$ffb0004e005737fa) return nodes;
        if (Array.isArray(nodes)) return this.fromArray(nodes);
        if (nodes.attrs) return new $0f68ec5a5289168c$export$ffb0004e005737fa([
            nodes
        ], nodes.nodeSize);
        throw new RangeError("Can not convert " + nodes + " to a Fragment" + (nodes.nodesBetween ? " (looks like multiple versions of prosemirror-model were loaded)" : ""));
    }
}
/**
An empty fragment. Intended to be reused whenever a node doesn't
contain anything (rather than allocating a new empty fragment for
each leaf node).
*/ $0f68ec5a5289168c$export$ffb0004e005737fa.empty = new $0f68ec5a5289168c$export$ffb0004e005737fa([], 0);
const $0f68ec5a5289168c$var$found = {
    index: 0,
    offset: 0
};
function $0f68ec5a5289168c$var$retIndex(index, offset) {
    $0f68ec5a5289168c$var$found.index = index;
    $0f68ec5a5289168c$var$found.offset = offset;
    return $0f68ec5a5289168c$var$found;
}
function $0f68ec5a5289168c$var$compareDeep(a, b) {
    if (a === b) return true;
    if (!(a && typeof a == "object") || !(b && typeof b == "object")) return false;
    let array = Array.isArray(a);
    if (Array.isArray(b) != array) return false;
    if (array) {
        if (a.length != b.length) return false;
        for(let i = 0; i < a.length; i++)if (!$0f68ec5a5289168c$var$compareDeep(a[i], b[i])) return false;
    } else {
        for(let p in a)if (!(p in b) || !$0f68ec5a5289168c$var$compareDeep(a[p], b[p])) return false;
        for(let p in b)if (!(p in a)) return false;
    }
    return true;
}
/**
A mark is a piece of information that can be attached to a node,
such as it being emphasized, in code font, or a link. It has a
type and optionally a set of attributes that provide further
information (such as the target of the link). Marks are created
through a `Schema`, which controls which types exist and which
attributes they have.
*/ class $0f68ec5a5289168c$export$c9d15bcfc6d42044 {
    /**
    @internal
    */ constructor(/**
    The type of this mark.
    */ type, /**
    The attributes associated with this mark.
    */ attrs){
        this.type = type;
        this.attrs = attrs;
    }
    /**
    Given a set of marks, create a new set which contains this one as
    well, in the right position. If this mark is already in the set,
    the set itself is returned. If any marks that are set to be
    [exclusive](https://prosemirror.net/docs/ref/#model.MarkSpec.excludes) with this mark are present,
    those are replaced by this one.
    */ addToSet(set) {
        let copy, placed = false;
        for(let i = 0; i < set.length; i++){
            let other = set[i];
            if (this.eq(other)) return set;
            if (this.type.excludes(other.type)) {
                if (!copy) copy = set.slice(0, i);
            } else if (other.type.excludes(this.type)) return set;
            else {
                if (!placed && other.type.rank > this.type.rank) {
                    if (!copy) copy = set.slice(0, i);
                    copy.push(this);
                    placed = true;
                }
                if (copy) copy.push(other);
            }
        }
        if (!copy) copy = set.slice();
        if (!placed) copy.push(this);
        return copy;
    }
    /**
    Remove this mark from the given set, returning a new set. If this
    mark is not in the set, the set itself is returned.
    */ removeFromSet(set) {
        for(let i = 0; i < set.length; i++)if (this.eq(set[i])) return set.slice(0, i).concat(set.slice(i + 1));
        return set;
    }
    /**
    Test whether this mark is in the given set of marks.
    */ isInSet(set) {
        for(let i = 0; i < set.length; i++)if (this.eq(set[i])) return true;
        return false;
    }
    /**
    Test whether this mark has the same type and attributes as
    another mark.
    */ eq(other) {
        return this == other || this.type == other.type && $0f68ec5a5289168c$var$compareDeep(this.attrs, other.attrs);
    }
    /**
    Convert this mark to a JSON-serializeable representation.
    */ toJSON() {
        let obj = {
            type: this.type.name
        };
        for(let _ in this.attrs){
            obj.attrs = this.attrs;
            break;
        }
        return obj;
    }
    /**
    Deserialize a mark from JSON.
    */ static fromJSON(schema, json) {
        if (!json) throw new RangeError("Invalid input for Mark.fromJSON");
        let type = schema.marks[json.type];
        if (!type) throw new RangeError(`There is no mark type ${json.type} in this schema`);
        let mark = type.create(json.attrs);
        type.checkAttrs(mark.attrs);
        return mark;
    }
    /**
    Test whether two sets of marks are identical.
    */ static sameSet(a, b) {
        if (a == b) return true;
        if (a.length != b.length) return false;
        for(let i = 0; i < a.length; i++)if (!a[i].eq(b[i])) return false;
        return true;
    }
    /**
    Create a properly sorted mark set from null, a single mark, or an
    unsorted array of marks.
    */ static setFrom(marks) {
        if (!marks || Array.isArray(marks) && marks.length == 0) return $0f68ec5a5289168c$export$c9d15bcfc6d42044.none;
        if (marks instanceof $0f68ec5a5289168c$export$c9d15bcfc6d42044) return [
            marks
        ];
        let copy = marks.slice();
        copy.sort((a, b)=>a.type.rank - b.type.rank);
        return copy;
    }
}
/**
The empty set of marks.
*/ $0f68ec5a5289168c$export$c9d15bcfc6d42044.none = [];
/**
Error type raised by [`Node.replace`](https://prosemirror.net/docs/ref/#model.Node.replace) when
given an invalid replacement.
*/ class $0f68ec5a5289168c$export$6de0e778727af3f2 extends Error {
}
/*
ReplaceError = function(this: any, message: string) {
  let err = Error.call(this, message)
  ;(err as any).__proto__ = ReplaceError.prototype
  return err
} as any

ReplaceError.prototype = Object.create(Error.prototype)
ReplaceError.prototype.constructor = ReplaceError
ReplaceError.prototype.name = "ReplaceError"
*/ /**
A slice represents a piece cut out of a larger document. It
stores not only a fragment, but also the depth up to which nodes on
both side are ‘open’ (cut through).
*/ class $0f68ec5a5289168c$export$b3f2e2de3a8baa1e {
    /**
    Create a slice. When specifying a non-zero open depth, you must
    make sure that there are nodes of at least that depth at the
    appropriate side of the fragment—i.e. if the fragment is an
    empty paragraph node, `openStart` and `openEnd` can't be greater
    than 1.
    
    It is not necessary for the content of open nodes to conform to
    the schema's content constraints, though it should be a valid
    start/end/middle for such a node, depending on which sides are
    open.
    */ constructor(/**
    The slice's content.
    */ content, /**
    The open depth at the start of the fragment.
    */ openStart, /**
    The open depth at the end.
    */ openEnd){
        this.content = content;
        this.openStart = openStart;
        this.openEnd = openEnd;
    }
    /**
    The size this slice would add when inserted into a document.
    */ get size() {
        return this.content.size - this.openStart - this.openEnd;
    }
    /**
    @internal
    */ insertAt(pos, fragment) {
        let content = $0f68ec5a5289168c$var$insertInto(this.content, pos + this.openStart, fragment);
        return content && new $0f68ec5a5289168c$export$b3f2e2de3a8baa1e(content, this.openStart, this.openEnd);
    }
    /**
    @internal
    */ removeBetween(from, to) {
        return new $0f68ec5a5289168c$export$b3f2e2de3a8baa1e($0f68ec5a5289168c$var$removeRange(this.content, from + this.openStart, to + this.openStart), this.openStart, this.openEnd);
    }
    /**
    Tests whether this slice is equal to another slice.
    */ eq(other) {
        return this.content.eq(other.content) && this.openStart == other.openStart && this.openEnd == other.openEnd;
    }
    /**
    @internal
    */ toString() {
        return this.content + "(" + this.openStart + "," + this.openEnd + ")";
    }
    /**
    Convert a slice to a JSON-serializable representation.
    */ toJSON() {
        if (!this.content.size) return null;
        let json = {
            content: this.content.toJSON()
        };
        if (this.openStart > 0) json.openStart = this.openStart;
        if (this.openEnd > 0) json.openEnd = this.openEnd;
        return json;
    }
    /**
    Deserialize a slice from its JSON representation.
    */ static fromJSON(schema, json) {
        if (!json) return $0f68ec5a5289168c$export$b3f2e2de3a8baa1e.empty;
        let openStart = json.openStart || 0, openEnd = json.openEnd || 0;
        if (typeof openStart != "number" || typeof openEnd != "number") throw new RangeError("Invalid input for Slice.fromJSON");
        return new $0f68ec5a5289168c$export$b3f2e2de3a8baa1e($0f68ec5a5289168c$export$ffb0004e005737fa.fromJSON(schema, json.content), openStart, openEnd);
    }
    /**
    Create a slice from a fragment by taking the maximum possible
    open value on both side of the fragment.
    */ static maxOpen(fragment, openIsolating = true) {
        let openStart = 0, openEnd = 0;
        for(let n = fragment.firstChild; n && !n.isLeaf && (openIsolating || !n.type.spec.isolating); n = n.firstChild)openStart++;
        for(let n = fragment.lastChild; n && !n.isLeaf && (openIsolating || !n.type.spec.isolating); n = n.lastChild)openEnd++;
        return new $0f68ec5a5289168c$export$b3f2e2de3a8baa1e(fragment, openStart, openEnd);
    }
}
/**
The empty slice.
*/ $0f68ec5a5289168c$export$b3f2e2de3a8baa1e.empty = new $0f68ec5a5289168c$export$b3f2e2de3a8baa1e($0f68ec5a5289168c$export$ffb0004e005737fa.empty, 0, 0);
function $0f68ec5a5289168c$var$removeRange(content, from, to) {
    let { index: index, offset: offset } = content.findIndex(from), child = content.maybeChild(index);
    let { index: indexTo, offset: offsetTo } = content.findIndex(to);
    if (offset == from || child.isText) {
        if (offsetTo != to && !content.child(indexTo).isText) throw new RangeError("Removing non-flat range");
        return content.cut(0, from).append(content.cut(to));
    }
    if (index != indexTo) throw new RangeError("Removing non-flat range");
    return content.replaceChild(index, child.copy($0f68ec5a5289168c$var$removeRange(child.content, from - offset - 1, to - offset - 1)));
}
function $0f68ec5a5289168c$var$insertInto(content, dist, insert, parent) {
    let { index: index, offset: offset } = content.findIndex(dist), child = content.maybeChild(index);
    if (offset == dist || child.isText) {
        if (parent && !parent.canReplace(index, index, insert)) return null;
        return content.cut(0, dist).append(insert).append(content.cut(dist));
    }
    let inner = $0f68ec5a5289168c$var$insertInto(child.content, dist - offset - 1, insert, child);
    return inner && content.replaceChild(index, child.copy(inner));
}
function $0f68ec5a5289168c$var$replace($from, $to, slice) {
    if (slice.openStart > $from.depth) throw new $0f68ec5a5289168c$export$6de0e778727af3f2("Inserted content deeper than insertion position");
    if ($from.depth - slice.openStart != $to.depth - slice.openEnd) throw new $0f68ec5a5289168c$export$6de0e778727af3f2("Inconsistent open depths");
    return $0f68ec5a5289168c$var$replaceOuter($from, $to, slice, 0);
}
function $0f68ec5a5289168c$var$replaceOuter($from, $to, slice, depth) {
    let index = $from.index(depth), node = $from.node(depth);
    if (index == $to.index(depth) && depth < $from.depth - slice.openStart) {
        let inner = $0f68ec5a5289168c$var$replaceOuter($from, $to, slice, depth + 1);
        return node.copy(node.content.replaceChild(index, inner));
    } else if (!slice.content.size) return $0f68ec5a5289168c$var$close(node, $0f68ec5a5289168c$var$replaceTwoWay($from, $to, depth));
    else if (!slice.openStart && !slice.openEnd && $from.depth == depth && $to.depth == depth) {
        let parent = $from.parent, content = parent.content;
        return $0f68ec5a5289168c$var$close(parent, content.cut(0, $from.parentOffset).append(slice.content).append(content.cut($to.parentOffset)));
    } else {
        let { start: start, end: end } = $0f68ec5a5289168c$var$prepareSliceForReplace(slice, $from);
        return $0f68ec5a5289168c$var$close(node, $0f68ec5a5289168c$var$replaceThreeWay($from, start, end, $to, depth));
    }
}
function $0f68ec5a5289168c$var$checkJoin(main, sub) {
    if (!sub.type.compatibleContent(main.type)) throw new $0f68ec5a5289168c$export$6de0e778727af3f2("Cannot join " + sub.type.name + " onto " + main.type.name);
}
function $0f68ec5a5289168c$var$joinable($before, $after, depth) {
    let node = $before.node(depth);
    $0f68ec5a5289168c$var$checkJoin(node, $after.node(depth));
    return node;
}
function $0f68ec5a5289168c$var$addNode(child, target) {
    let last = target.length - 1;
    if (last >= 0 && child.isText && child.sameMarkup(target[last])) target[last] = child.withText(target[last].text + child.text);
    else target.push(child);
}
function $0f68ec5a5289168c$var$addRange($start, $end, depth, target) {
    let node = ($end || $start).node(depth);
    let startIndex = 0, endIndex = $end ? $end.index(depth) : node.childCount;
    if ($start) {
        startIndex = $start.index(depth);
        if ($start.depth > depth) startIndex++;
        else if ($start.textOffset) {
            $0f68ec5a5289168c$var$addNode($start.nodeAfter, target);
            startIndex++;
        }
    }
    for(let i = startIndex; i < endIndex; i++)$0f68ec5a5289168c$var$addNode(node.child(i), target);
    if ($end && $end.depth == depth && $end.textOffset) $0f68ec5a5289168c$var$addNode($end.nodeBefore, target);
}
function $0f68ec5a5289168c$var$close(node, content) {
    node.type.checkContent(content);
    return node.copy(content);
}
function $0f68ec5a5289168c$var$replaceThreeWay($from, $start, $end, $to, depth) {
    let openStart = $from.depth > depth && $0f68ec5a5289168c$var$joinable($from, $start, depth + 1);
    let openEnd = $to.depth > depth && $0f68ec5a5289168c$var$joinable($end, $to, depth + 1);
    let content = [];
    $0f68ec5a5289168c$var$addRange(null, $from, depth, content);
    if (openStart && openEnd && $start.index(depth) == $end.index(depth)) {
        $0f68ec5a5289168c$var$checkJoin(openStart, openEnd);
        $0f68ec5a5289168c$var$addNode($0f68ec5a5289168c$var$close(openStart, $0f68ec5a5289168c$var$replaceThreeWay($from, $start, $end, $to, depth + 1)), content);
    } else {
        if (openStart) $0f68ec5a5289168c$var$addNode($0f68ec5a5289168c$var$close(openStart, $0f68ec5a5289168c$var$replaceTwoWay($from, $start, depth + 1)), content);
        $0f68ec5a5289168c$var$addRange($start, $end, depth, content);
        if (openEnd) $0f68ec5a5289168c$var$addNode($0f68ec5a5289168c$var$close(openEnd, $0f68ec5a5289168c$var$replaceTwoWay($end, $to, depth + 1)), content);
    }
    $0f68ec5a5289168c$var$addRange($to, null, depth, content);
    return new $0f68ec5a5289168c$export$ffb0004e005737fa(content);
}
function $0f68ec5a5289168c$var$replaceTwoWay($from, $to, depth) {
    let content = [];
    $0f68ec5a5289168c$var$addRange(null, $from, depth, content);
    if ($from.depth > depth) {
        let type = $0f68ec5a5289168c$var$joinable($from, $to, depth + 1);
        $0f68ec5a5289168c$var$addNode($0f68ec5a5289168c$var$close(type, $0f68ec5a5289168c$var$replaceTwoWay($from, $to, depth + 1)), content);
    }
    $0f68ec5a5289168c$var$addRange($to, null, depth, content);
    return new $0f68ec5a5289168c$export$ffb0004e005737fa(content);
}
function $0f68ec5a5289168c$var$prepareSliceForReplace(slice, $along) {
    let extra = $along.depth - slice.openStart, parent = $along.node(extra);
    let node = parent.copy(slice.content);
    for(let i = extra - 1; i >= 0; i--)node = $along.node(i).copy($0f68ec5a5289168c$export$ffb0004e005737fa.from(node));
    return {
        start: node.resolveNoCache(slice.openStart + extra),
        end: node.resolveNoCache(node.content.size - slice.openEnd - extra)
    };
}
/**
You can [_resolve_](https://prosemirror.net/docs/ref/#model.Node.resolve) a position to get more
information about it. Objects of this class represent such a
resolved position, providing various pieces of context
information, and some helper methods.

Throughout this interface, methods that take an optional `depth`
parameter will interpret undefined as `this.depth` and negative
numbers as `this.depth + value`.
*/ class $0f68ec5a5289168c$export$b2a42f82e59e4b19 {
    /**
    @internal
    */ constructor(/**
    The position that was resolved.
    */ pos, /**
    @internal
    */ path, /**
    The offset this position has into its parent node.
    */ parentOffset){
        this.pos = pos;
        this.path = path;
        this.parentOffset = parentOffset;
        this.depth = path.length / 3 - 1;
    }
    /**
    @internal
    */ resolveDepth(val) {
        if (val == null) return this.depth;
        if (val < 0) return this.depth + val;
        return val;
    }
    /**
    The parent node that the position points into. Note that even if
    a position points into a text node, that node is not considered
    the parent—text nodes are ‘flat’ in this model, and have no content.
    */ get parent() {
        return this.node(this.depth);
    }
    /**
    The root node in which the position was resolved.
    */ get doc() {
        return this.node(0);
    }
    /**
    The ancestor node at the given level. `p.node(p.depth)` is the
    same as `p.parent`.
    */ node(depth) {
        return this.path[this.resolveDepth(depth) * 3];
    }
    /**
    The index into the ancestor at the given level. If this points
    at the 3rd node in the 2nd paragraph on the top level, for
    example, `p.index(0)` is 1 and `p.index(1)` is 2.
    */ index(depth) {
        return this.path[this.resolveDepth(depth) * 3 + 1];
    }
    /**
    The index pointing after this position into the ancestor at the
    given level.
    */ indexAfter(depth) {
        depth = this.resolveDepth(depth);
        return this.index(depth) + (depth == this.depth && !this.textOffset ? 0 : 1);
    }
    /**
    The (absolute) position at the start of the node at the given
    level.
    */ start(depth) {
        depth = this.resolveDepth(depth);
        return depth == 0 ? 0 : this.path[depth * 3 - 1] + 1;
    }
    /**
    The (absolute) position at the end of the node at the given
    level.
    */ end(depth) {
        depth = this.resolveDepth(depth);
        return this.start(depth) + this.node(depth).content.size;
    }
    /**
    The (absolute) position directly before the wrapping node at the
    given level, or, when `depth` is `this.depth + 1`, the original
    position.
    */ before(depth) {
        depth = this.resolveDepth(depth);
        if (!depth) throw new RangeError("There is no position before the top-level node");
        return depth == this.depth + 1 ? this.pos : this.path[depth * 3 - 1];
    }
    /**
    The (absolute) position directly after the wrapping node at the
    given level, or the original position when `depth` is `this.depth + 1`.
    */ after(depth) {
        depth = this.resolveDepth(depth);
        if (!depth) throw new RangeError("There is no position after the top-level node");
        return depth == this.depth + 1 ? this.pos : this.path[depth * 3 - 1] + this.path[depth * 3].nodeSize;
    }
    /**
    When this position points into a text node, this returns the
    distance between the position and the start of the text node.
    Will be zero for positions that point between nodes.
    */ get textOffset() {
        return this.pos - this.path[this.path.length - 1];
    }
    /**
    Get the node directly after the position, if any. If the position
    points into a text node, only the part of that node after the
    position is returned.
    */ get nodeAfter() {
        let parent = this.parent, index = this.index(this.depth);
        if (index == parent.childCount) return null;
        let dOff = this.pos - this.path[this.path.length - 1], child = parent.child(index);
        return dOff ? parent.child(index).cut(dOff) : child;
    }
    /**
    Get the node directly before the position, if any. If the
    position points into a text node, only the part of that node
    before the position is returned.
    */ get nodeBefore() {
        let index = this.index(this.depth);
        let dOff = this.pos - this.path[this.path.length - 1];
        if (dOff) return this.parent.child(index).cut(0, dOff);
        return index == 0 ? null : this.parent.child(index - 1);
    }
    /**
    Get the position at the given index in the parent node at the
    given depth (which defaults to `this.depth`).
    */ posAtIndex(index, depth) {
        depth = this.resolveDepth(depth);
        let node = this.path[depth * 3], pos = depth == 0 ? 0 : this.path[depth * 3 - 1] + 1;
        for(let i = 0; i < index; i++)pos += node.child(i).nodeSize;
        return pos;
    }
    /**
    Get the marks at this position, factoring in the surrounding
    marks' [`inclusive`](https://prosemirror.net/docs/ref/#model.MarkSpec.inclusive) property. If the
    position is at the start of a non-empty node, the marks of the
    node after it (if any) are returned.
    */ marks() {
        let parent = this.parent, index = this.index();
        // In an empty parent, return the empty array
        if (parent.content.size == 0) return $0f68ec5a5289168c$export$c9d15bcfc6d42044.none;
        // When inside a text node, just return the text node's marks
        if (this.textOffset) return parent.child(index).marks;
        let main = parent.maybeChild(index - 1), other = parent.maybeChild(index);
        // If the `after` flag is true of there is no node before, make
        // the node after this position the main reference.
        if (!main) {
            let tmp = main;
            main = other;
            other = tmp;
        }
        // Use all marks in the main node, except those that have
        // `inclusive` set to false and are not present in the other node.
        let marks = main.marks;
        for(var i = 0; i < marks.length; i++)if (marks[i].type.spec.inclusive === false && (!other || !marks[i].isInSet(other.marks))) marks = marks[i--].removeFromSet(marks);
        return marks;
    }
    /**
    Get the marks after the current position, if any, except those
    that are non-inclusive and not present at position `$end`. This
    is mostly useful for getting the set of marks to preserve after a
    deletion. Will return `null` if this position is at the end of
    its parent node or its parent node isn't a textblock (in which
    case no marks should be preserved).
    */ marksAcross($end) {
        let after = this.parent.maybeChild(this.index());
        if (!after || !after.isInline) return null;
        let marks = after.marks, next = $end.parent.maybeChild($end.index());
        for(var i = 0; i < marks.length; i++)if (marks[i].type.spec.inclusive === false && (!next || !marks[i].isInSet(next.marks))) marks = marks[i--].removeFromSet(marks);
        return marks;
    }
    /**
    The depth up to which this position and the given (non-resolved)
    position share the same parent nodes.
    */ sharedDepth(pos) {
        for(let depth = this.depth; depth > 0; depth--)if (this.start(depth) <= pos && this.end(depth) >= pos) return depth;
        return 0;
    }
    /**
    Returns a range based on the place where this position and the
    given position diverge around block content. If both point into
    the same textblock, for example, a range around that textblock
    will be returned. If they point into different blocks, the range
    around those blocks in their shared ancestor is returned. You can
    pass in an optional predicate that will be called with a parent
    node to see if a range into that parent is acceptable.
    */ blockRange(other = this, pred) {
        if (other.pos < this.pos) return other.blockRange(this);
        for(let d = this.depth - (this.parent.inlineContent || this.pos == other.pos ? 1 : 0); d >= 0; d--)if (other.pos <= this.end(d) && (!pred || pred(this.node(d)))) return new $0f68ec5a5289168c$export$7bc461ceb770fb16(this, other, d);
        return null;
    }
    /**
    Query whether the given position shares the same parent node.
    */ sameParent(other) {
        return this.pos - this.parentOffset == other.pos - other.parentOffset;
    }
    /**
    Return the greater of this and the given position.
    */ max(other) {
        return other.pos > this.pos ? other : this;
    }
    /**
    Return the smaller of this and the given position.
    */ min(other) {
        return other.pos < this.pos ? other : this;
    }
    /**
    @internal
    */ toString() {
        let str = "";
        for(let i = 1; i <= this.depth; i++)str += (str ? "/" : "") + this.node(i).type.name + "_" + this.index(i - 1);
        return str + ":" + this.parentOffset;
    }
    /**
    @internal
    */ static resolve(doc, pos) {
        if (!(pos >= 0 && pos <= doc.content.size)) throw new RangeError("Position " + pos + " out of range");
        let path = [];
        let start = 0, parentOffset = pos;
        for(let node = doc;;){
            let { index: index, offset: offset } = node.content.findIndex(parentOffset);
            let rem = parentOffset - offset;
            path.push(node, index, start + offset);
            if (!rem) break;
            node = node.child(index);
            if (node.isText) break;
            parentOffset = rem - 1;
            start += offset + 1;
        }
        return new $0f68ec5a5289168c$export$b2a42f82e59e4b19(pos, path, parentOffset);
    }
    /**
    @internal
    */ static resolveCached(doc, pos) {
        let cache = $0f68ec5a5289168c$var$resolveCache.get(doc);
        if (cache) for(let i = 0; i < cache.elts.length; i++){
            let elt = cache.elts[i];
            if (elt.pos == pos) return elt;
        }
        else $0f68ec5a5289168c$var$resolveCache.set(doc, cache = new $0f68ec5a5289168c$var$ResolveCache);
        let result = cache.elts[cache.i] = $0f68ec5a5289168c$export$b2a42f82e59e4b19.resolve(doc, pos);
        cache.i = (cache.i + 1) % $0f68ec5a5289168c$var$resolveCacheSize;
        return result;
    }
}
class $0f68ec5a5289168c$var$ResolveCache {
    constructor(){
        this.elts = [];
        this.i = 0;
    }
}
const $0f68ec5a5289168c$var$resolveCacheSize = 12, $0f68ec5a5289168c$var$resolveCache = new WeakMap();
/**
Represents a flat range of content, i.e. one that starts and
ends in the same node.
*/ class $0f68ec5a5289168c$export$7bc461ceb770fb16 {
    /**
    Construct a node range. `$from` and `$to` should point into the
    same node until at least the given `depth`, since a node range
    denotes an adjacent set of nodes in a single parent node.
    */ constructor(/**
    A resolved position along the start of the content. May have a
    `depth` greater than this object's `depth` property, since
    these are the positions that were used to compute the range,
    not re-resolved positions directly at its boundaries.
    */ $from, /**
    A position along the end of the content. See
    caveat for [`$from`](https://prosemirror.net/docs/ref/#model.NodeRange.$from).
    */ $to, /**
    The depth of the node that this range points into.
    */ depth){
        this.$from = $from;
        this.$to = $to;
        this.depth = depth;
    }
    /**
    The position at the start of the range.
    */ get start() {
        return this.$from.before(this.depth + 1);
    }
    /**
    The position at the end of the range.
    */ get end() {
        return this.$to.after(this.depth + 1);
    }
    /**
    The parent node that the range points into.
    */ get parent() {
        return this.$from.node(this.depth);
    }
    /**
    The start index of the range in the parent node.
    */ get startIndex() {
        return this.$from.index(this.depth);
    }
    /**
    The end index of the range in the parent node.
    */ get endIndex() {
        return this.$to.indexAfter(this.depth);
    }
}
const $0f68ec5a5289168c$var$emptyAttrs = Object.create(null);
/**
This class represents a node in the tree that makes up a
ProseMirror document. So a document is an instance of `Node`, with
children that are also instances of `Node`.

Nodes are persistent data structures. Instead of changing them, you
create new ones with the content you want. Old ones keep pointing
at the old document shape. This is made cheaper by sharing
structure between the old and new data as much as possible, which a
tree shape like this (without back pointers) makes easy.

**Do not** directly mutate the properties of a `Node` object. See
[the guide](https://prosemirror.net/docs/guide/#doc) for more information.
*/ class $0f68ec5a5289168c$export$85c928794f8d04d4 {
    /**
    @internal
    */ constructor(/**
    The type of node that this is.
    */ type, /**
    An object mapping attribute names to values. The kind of
    attributes allowed and required are
    [determined](https://prosemirror.net/docs/ref/#model.NodeSpec.attrs) by the node type.
    */ attrs, // A fragment holding the node's children.
    content, /**
    The marks (things like whether it is emphasized or part of a
    link) applied to this node.
    */ marks = $0f68ec5a5289168c$export$c9d15bcfc6d42044.none){
        this.type = type;
        this.attrs = attrs;
        this.marks = marks;
        this.content = content || $0f68ec5a5289168c$export$ffb0004e005737fa.empty;
    }
    /**
    The array of this node's child nodes.
    */ get children() {
        return this.content.content;
    }
    /**
    The size of this node, as defined by the integer-based [indexing
    scheme](https://prosemirror.net/docs/guide/#doc.indexing). For text nodes, this is the
    amount of characters. For other leaf nodes, it is one. For
    non-leaf nodes, it is the size of the content plus two (the
    start and end token).
    */ get nodeSize() {
        return this.isLeaf ? 1 : 2 + this.content.size;
    }
    /**
    The number of children that the node has.
    */ get childCount() {
        return this.content.childCount;
    }
    /**
    Get the child node at the given index. Raises an error when the
    index is out of range.
    */ child(index) {
        return this.content.child(index);
    }
    /**
    Get the child node at the given index, if it exists.
    */ maybeChild(index) {
        return this.content.maybeChild(index);
    }
    /**
    Call `f` for every child node, passing the node, its offset
    into this parent node, and its index.
    */ forEach(f) {
        this.content.forEach(f);
    }
    /**
    Invoke a callback for all descendant nodes recursively between
    the given two positions that are relative to start of this
    node's content. The callback is invoked with the node, its
    position relative to the original node (method receiver),
    its parent node, and its child index. When the callback returns
    false for a given node, that node's children will not be
    recursed over. The last parameter can be used to specify a
    starting position to count from.
    */ nodesBetween(from, to, f, startPos = 0) {
        this.content.nodesBetween(from, to, f, startPos, this);
    }
    /**
    Call the given callback for every descendant node. Doesn't
    descend into a node when the callback returns `false`.
    */ descendants(f) {
        this.nodesBetween(0, this.content.size, f);
    }
    /**
    Concatenates all the text nodes found in this fragment and its
    children.
    */ get textContent() {
        return this.isLeaf && this.type.spec.leafText ? this.type.spec.leafText(this) : this.textBetween(0, this.content.size, "");
    }
    /**
    Get all text between positions `from` and `to`. When
    `blockSeparator` is given, it will be inserted to separate text
    from different block nodes. If `leafText` is given, it'll be
    inserted for every non-text leaf node encountered, otherwise
    [`leafText`](https://prosemirror.net/docs/ref/#model.NodeSpec.leafText) will be used.
    */ textBetween(from, to, blockSeparator, leafText) {
        return this.content.textBetween(from, to, blockSeparator, leafText);
    }
    /**
    Returns this node's first child, or `null` if there are no
    children.
    */ get firstChild() {
        return this.content.firstChild;
    }
    /**
    Returns this node's last child, or `null` if there are no
    children.
    */ get lastChild() {
        return this.content.lastChild;
    }
    /**
    Test whether two nodes represent the same piece of document.
    */ eq(other) {
        return this == other || this.sameMarkup(other) && this.content.eq(other.content);
    }
    /**
    Compare the markup (type, attributes, and marks) of this node to
    those of another. Returns `true` if both have the same markup.
    */ sameMarkup(other) {
        return this.hasMarkup(other.type, other.attrs, other.marks);
    }
    /**
    Check whether this node's markup correspond to the given type,
    attributes, and marks.
    */ hasMarkup(type, attrs, marks) {
        return this.type == type && $0f68ec5a5289168c$var$compareDeep(this.attrs, attrs || type.defaultAttrs || $0f68ec5a5289168c$var$emptyAttrs) && $0f68ec5a5289168c$export$c9d15bcfc6d42044.sameSet(this.marks, marks || $0f68ec5a5289168c$export$c9d15bcfc6d42044.none);
    }
    /**
    Create a new node with the same markup as this node, containing
    the given content (or empty, if no content is given).
    */ copy(content = null) {
        if (content == this.content) return this;
        return new $0f68ec5a5289168c$export$85c928794f8d04d4(this.type, this.attrs, content, this.marks);
    }
    /**
    Create a copy of this node, with the given set of marks instead
    of the node's own marks.
    */ mark(marks) {
        return marks == this.marks ? this : new $0f68ec5a5289168c$export$85c928794f8d04d4(this.type, this.attrs, this.content, marks);
    }
    /**
    Create a copy of this node with only the content between the
    given positions. If `to` is not given, it defaults to the end of
    the node.
    */ cut(from, to = this.content.size) {
        if (from == 0 && to == this.content.size) return this;
        return this.copy(this.content.cut(from, to));
    }
    /**
    Cut out the part of the document between the given positions, and
    return it as a `Slice` object.
    */ slice(from, to = this.content.size, includeParents = false) {
        if (from == to) return $0f68ec5a5289168c$export$b3f2e2de3a8baa1e.empty;
        let $from = this.resolve(from), $to = this.resolve(to);
        let depth = includeParents ? 0 : $from.sharedDepth(to);
        let start = $from.start(depth), node = $from.node(depth);
        let content = node.content.cut($from.pos - start, $to.pos - start);
        return new $0f68ec5a5289168c$export$b3f2e2de3a8baa1e(content, $from.depth - depth, $to.depth - depth);
    }
    /**
    Replace the part of the document between the given positions with
    the given slice. The slice must 'fit', meaning its open sides
    must be able to connect to the surrounding content, and its
    content nodes must be valid children for the node they are placed
    into. If any of this is violated, an error of type
    [`ReplaceError`](https://prosemirror.net/docs/ref/#model.ReplaceError) is thrown.
    */ replace(from, to, slice) {
        return $0f68ec5a5289168c$var$replace(this.resolve(from), this.resolve(to), slice);
    }
    /**
    Find the node directly after the given position.
    */ nodeAt(pos) {
        for(let node = this;;){
            let { index: index, offset: offset } = node.content.findIndex(pos);
            node = node.maybeChild(index);
            if (!node) return null;
            if (offset == pos || node.isText) return node;
            pos -= offset + 1;
        }
    }
    /**
    Find the (direct) child node after the given offset, if any,
    and return it along with its index and offset relative to this
    node.
    */ childAfter(pos) {
        let { index: index, offset: offset } = this.content.findIndex(pos);
        return {
            node: this.content.maybeChild(index),
            index: index,
            offset: offset
        };
    }
    /**
    Find the (direct) child node before the given offset, if any,
    and return it along with its index and offset relative to this
    node.
    */ childBefore(pos) {
        if (pos == 0) return {
            node: null,
            index: 0,
            offset: 0
        };
        let { index: index, offset: offset } = this.content.findIndex(pos);
        if (offset < pos) return {
            node: this.content.child(index),
            index: index,
            offset: offset
        };
        let node = this.content.child(index - 1);
        return {
            node: node,
            index: index - 1,
            offset: offset - node.nodeSize
        };
    }
    /**
    Resolve the given position in the document, returning an
    [object](https://prosemirror.net/docs/ref/#model.ResolvedPos) with information about its context.
    */ resolve(pos) {
        return $0f68ec5a5289168c$export$b2a42f82e59e4b19.resolveCached(this, pos);
    }
    /**
    @internal
    */ resolveNoCache(pos) {
        return $0f68ec5a5289168c$export$b2a42f82e59e4b19.resolve(this, pos);
    }
    /**
    Test whether a given mark or mark type occurs in this document
    between the two given positions.
    */ rangeHasMark(from, to, type) {
        let found = false;
        if (to > from) this.nodesBetween(from, to, (node)=>{
            if (type.isInSet(node.marks)) found = true;
            return !found;
        });
        return found;
    }
    /**
    True when this is a block (non-inline node)
    */ get isBlock() {
        return this.type.isBlock;
    }
    /**
    True when this is a textblock node, a block node with inline
    content.
    */ get isTextblock() {
        return this.type.isTextblock;
    }
    /**
    True when this node allows inline content.
    */ get inlineContent() {
        return this.type.inlineContent;
    }
    /**
    True when this is an inline node (a text node or a node that can
    appear among text).
    */ get isInline() {
        return this.type.isInline;
    }
    /**
    True when this is a text node.
    */ get isText() {
        return this.type.isText;
    }
    /**
    True when this is a leaf node.
    */ get isLeaf() {
        return this.type.isLeaf;
    }
    /**
    True when this is an atom, i.e. when it does not have directly
    editable content. This is usually the same as `isLeaf`, but can
    be configured with the [`atom` property](https://prosemirror.net/docs/ref/#model.NodeSpec.atom)
    on a node's spec (typically used when the node is displayed as
    an uneditable [node view](https://prosemirror.net/docs/ref/#view.NodeView)).
    */ get isAtom() {
        return this.type.isAtom;
    }
    /**
    Return a string representation of this node for debugging
    purposes.
    */ toString() {
        if (this.type.spec.toDebugString) return this.type.spec.toDebugString(this);
        let name = this.type.name;
        if (this.content.size) name += "(" + this.content.toStringInner() + ")";
        return $0f68ec5a5289168c$var$wrapMarks(this.marks, name);
    }
    /**
    Get the content match in this node at the given index.
    */ contentMatchAt(index) {
        let match = this.type.contentMatch.matchFragment(this.content, 0, index);
        if (!match) throw new Error("Called contentMatchAt on a node with invalid content");
        return match;
    }
    /**
    Test whether replacing the range between `from` and `to` (by
    child index) with the given replacement fragment (which defaults
    to the empty fragment) would leave the node's content valid. You
    can optionally pass `start` and `end` indices into the
    replacement fragment.
    */ canReplace(from, to, replacement = $0f68ec5a5289168c$export$ffb0004e005737fa.empty, start = 0, end = replacement.childCount) {
        let one = this.contentMatchAt(from).matchFragment(replacement, start, end);
        let two = one && one.matchFragment(this.content, to);
        if (!two || !two.validEnd) return false;
        for(let i = start; i < end; i++)if (!this.type.allowsMarks(replacement.child(i).marks)) return false;
        return true;
    }
    /**
    Test whether replacing the range `from` to `to` (by index) with
    a node of the given type would leave the node's content valid.
    */ canReplaceWith(from, to, type, marks) {
        if (marks && !this.type.allowsMarks(marks)) return false;
        let start = this.contentMatchAt(from).matchType(type);
        let end = start && start.matchFragment(this.content, to);
        return end ? end.validEnd : false;
    }
    /**
    Test whether the given node's content could be appended to this
    node. If that node is empty, this will only return true if there
    is at least one node type that can appear in both nodes (to avoid
    merging completely incompatible nodes).
    */ canAppend(other) {
        if (other.content.size) return this.canReplace(this.childCount, this.childCount, other.content);
        else return this.type.compatibleContent(other.type);
    }
    /**
    Check whether this node and its descendants conform to the
    schema, and raise an exception when they do not.
    */ check() {
        this.type.checkContent(this.content);
        this.type.checkAttrs(this.attrs);
        let copy = $0f68ec5a5289168c$export$c9d15bcfc6d42044.none;
        for(let i = 0; i < this.marks.length; i++){
            let mark = this.marks[i];
            mark.type.checkAttrs(mark.attrs);
            copy = mark.addToSet(copy);
        }
        if (!$0f68ec5a5289168c$export$c9d15bcfc6d42044.sameSet(copy, this.marks)) throw new RangeError(`Invalid collection of marks for node ${this.type.name}: ${this.marks.map((m)=>m.type.name)}`);
        this.content.forEach((node)=>node.check());
    }
    /**
    Return a JSON-serializeable representation of this node.
    */ toJSON() {
        let obj = {
            type: this.type.name
        };
        for(let _ in this.attrs){
            obj.attrs = this.attrs;
            break;
        }
        if (this.content.size) obj.content = this.content.toJSON();
        if (this.marks.length) obj.marks = this.marks.map((n)=>n.toJSON());
        return obj;
    }
    /**
    Deserialize a node from its JSON representation.
    */ static fromJSON(schema, json) {
        if (!json) throw new RangeError("Invalid input for Node.fromJSON");
        let marks = undefined;
        if (json.marks) {
            if (!Array.isArray(json.marks)) throw new RangeError("Invalid mark data for Node.fromJSON");
            marks = json.marks.map(schema.markFromJSON);
        }
        if (json.type == "text") {
            if (typeof json.text != "string") throw new RangeError("Invalid text node in JSON");
            return schema.text(json.text, marks);
        }
        let content = $0f68ec5a5289168c$export$ffb0004e005737fa.fromJSON(schema, json.content);
        let node = schema.nodeType(json.type).create(json.attrs, content, marks);
        node.type.checkAttrs(node.attrs);
        return node;
    }
}
$0f68ec5a5289168c$export$85c928794f8d04d4.prototype.text = undefined;
class $0f68ec5a5289168c$var$TextNode extends $0f68ec5a5289168c$export$85c928794f8d04d4 {
    /**
    @internal
    */ constructor(type, attrs, content, marks){
        super(type, attrs, null, marks);
        if (!content) throw new RangeError("Empty text nodes are not allowed");
        this.text = content;
    }
    toString() {
        if (this.type.spec.toDebugString) return this.type.spec.toDebugString(this);
        return $0f68ec5a5289168c$var$wrapMarks(this.marks, JSON.stringify(this.text));
    }
    get textContent() {
        return this.text;
    }
    textBetween(from, to) {
        return this.text.slice(from, to);
    }
    get nodeSize() {
        return this.text.length;
    }
    mark(marks) {
        return marks == this.marks ? this : new $0f68ec5a5289168c$var$TextNode(this.type, this.attrs, this.text, marks);
    }
    withText(text) {
        if (text == this.text) return this;
        return new $0f68ec5a5289168c$var$TextNode(this.type, this.attrs, text, this.marks);
    }
    cut(from = 0, to = this.text.length) {
        if (from == 0 && to == this.text.length) return this;
        return this.withText(this.text.slice(from, to));
    }
    eq(other) {
        return this.sameMarkup(other) && this.text == other.text;
    }
    toJSON() {
        let base = super.toJSON();
        base.text = this.text;
        return base;
    }
}
function $0f68ec5a5289168c$var$wrapMarks(marks, str) {
    for(let i = marks.length - 1; i >= 0; i--)str = marks[i].type.name + "(" + str + ")";
    return str;
}
/**
Instances of this class represent a match state of a node type's
[content expression](https://prosemirror.net/docs/ref/#model.NodeSpec.content), and can be used to
find out whether further content matches here, and whether a given
position is a valid end of the node.
*/ class $0f68ec5a5289168c$export$364ed450558d7ec4 {
    /**
    @internal
    */ constructor(/**
    True when this match state represents a valid end of the node.
    */ validEnd){
        this.validEnd = validEnd;
        /**
        @internal
        */ this.next = [];
        /**
        @internal
        */ this.wrapCache = [];
    }
    /**
    @internal
    */ static parse(string, nodeTypes) {
        let stream = new $0f68ec5a5289168c$var$TokenStream(string, nodeTypes);
        if (stream.next == null) return $0f68ec5a5289168c$export$364ed450558d7ec4.empty;
        let expr = $0f68ec5a5289168c$var$parseExpr(stream);
        if (stream.next) stream.err("Unexpected trailing text");
        let match = $0f68ec5a5289168c$var$dfa($0f68ec5a5289168c$var$nfa(expr));
        $0f68ec5a5289168c$var$checkForDeadEnds(match, stream);
        return match;
    }
    /**
    Match a node type, returning a match after that node if
    successful.
    */ matchType(type) {
        for(let i = 0; i < this.next.length; i++)if (this.next[i].type == type) return this.next[i].next;
        return null;
    }
    /**
    Try to match a fragment. Returns the resulting match when
    successful.
    */ matchFragment(frag, start = 0, end = frag.childCount) {
        let cur = this;
        for(let i = start; cur && i < end; i++)cur = cur.matchType(frag.child(i).type);
        return cur;
    }
    /**
    @internal
    */ get inlineContent() {
        return this.next.length != 0 && this.next[0].type.isInline;
    }
    /**
    Get the first matching node type at this match position that can
    be generated.
    */ get defaultType() {
        for(let i = 0; i < this.next.length; i++){
            let { type: type } = this.next[i];
            if (!(type.isText || type.hasRequiredAttrs())) return type;
        }
        return null;
    }
    /**
    @internal
    */ compatible(other) {
        for(let i = 0; i < this.next.length; i++)for(let j = 0; j < other.next.length; j++)if (this.next[i].type == other.next[j].type) return true;
        return false;
    }
    /**
    Try to match the given fragment, and if that fails, see if it can
    be made to match by inserting nodes in front of it. When
    successful, return a fragment of inserted nodes (which may be
    empty if nothing had to be inserted). When `toEnd` is true, only
    return a fragment if the resulting match goes to the end of the
    content expression.
    */ fillBefore(after, toEnd = false, startIndex = 0) {
        let seen = [
            this
        ];
        function search(match, types) {
            let finished = match.matchFragment(after, startIndex);
            if (finished && (!toEnd || finished.validEnd)) return $0f68ec5a5289168c$export$ffb0004e005737fa.from(types.map((tp)=>tp.createAndFill()));
            for(let i = 0; i < match.next.length; i++){
                let { type: type, next: next } = match.next[i];
                if (!(type.isText || type.hasRequiredAttrs()) && seen.indexOf(next) == -1) {
                    seen.push(next);
                    let found = search(next, types.concat(type));
                    if (found) return found;
                }
            }
            return null;
        }
        return search(this, []);
    }
    /**
    Find a set of wrapping node types that would allow a node of the
    given type to appear at this position. The result may be empty
    (when it fits directly) and will be null when no such wrapping
    exists.
    */ findWrapping(target) {
        for(let i = 0; i < this.wrapCache.length; i += 2)if (this.wrapCache[i] == target) return this.wrapCache[i + 1];
        let computed = this.computeWrapping(target);
        this.wrapCache.push(target, computed);
        return computed;
    }
    /**
    @internal
    */ computeWrapping(target) {
        let seen = Object.create(null), active = [
            {
                match: this,
                type: null,
                via: null
            }
        ];
        while(active.length){
            let current = active.shift(), match = current.match;
            if (match.matchType(target)) {
                let result = [];
                for(let obj = current; obj.type; obj = obj.via)result.push(obj.type);
                return result.reverse();
            }
            for(let i = 0; i < match.next.length; i++){
                let { type: type, next: next } = match.next[i];
                if (!type.isLeaf && !type.hasRequiredAttrs() && !(type.name in seen) && (!current.type || next.validEnd)) {
                    active.push({
                        match: type.contentMatch,
                        type: type,
                        via: current
                    });
                    seen[type.name] = true;
                }
            }
        }
        return null;
    }
    /**
    The number of outgoing edges this node has in the finite
    automaton that describes the content expression.
    */ get edgeCount() {
        return this.next.length;
    }
    /**
    Get the _n_​th outgoing edge from this node in the finite
    automaton that describes the content expression.
    */ edge(n) {
        if (n >= this.next.length) throw new RangeError(`There's no ${n}th edge in this content match`);
        return this.next[n];
    }
    /**
    @internal
    */ toString() {
        let seen = [];
        function scan(m) {
            seen.push(m);
            for(let i = 0; i < m.next.length; i++)if (seen.indexOf(m.next[i].next) == -1) scan(m.next[i].next);
        }
        scan(this);
        return seen.map((m, i)=>{
            let out = i + (m.validEnd ? "*" : " ") + " ";
            for(let i = 0; i < m.next.length; i++)out += (i ? ", " : "") + m.next[i].type.name + "->" + seen.indexOf(m.next[i].next);
            return out;
        }).join("\n");
    }
}
/**
@internal
*/ $0f68ec5a5289168c$export$364ed450558d7ec4.empty = new $0f68ec5a5289168c$export$364ed450558d7ec4(true);
class $0f68ec5a5289168c$var$TokenStream {
    constructor(string, nodeTypes){
        this.string = string;
        this.nodeTypes = nodeTypes;
        this.inline = null;
        this.pos = 0;
        this.tokens = string.split(/\s*(?=\b|\W|$)/);
        if (this.tokens[this.tokens.length - 1] == "") this.tokens.pop();
        if (this.tokens[0] == "") this.tokens.shift();
    }
    get next() {
        return this.tokens[this.pos];
    }
    eat(tok) {
        return this.next == tok && (this.pos++ || true);
    }
    err(str) {
        throw new SyntaxError(str + " (in content expression '" + this.string + "')");
    }
}
function $0f68ec5a5289168c$var$parseExpr(stream) {
    let exprs = [];
    do exprs.push($0f68ec5a5289168c$var$parseExprSeq(stream));
    while (stream.eat("|"));
    return exprs.length == 1 ? exprs[0] : {
        type: "choice",
        exprs: exprs
    };
}
function $0f68ec5a5289168c$var$parseExprSeq(stream) {
    let exprs = [];
    do exprs.push($0f68ec5a5289168c$var$parseExprSubscript(stream));
    while (stream.next && stream.next != ")" && stream.next != "|");
    return exprs.length == 1 ? exprs[0] : {
        type: "seq",
        exprs: exprs
    };
}
function $0f68ec5a5289168c$var$parseExprSubscript(stream) {
    let expr = $0f68ec5a5289168c$var$parseExprAtom(stream);
    for(;;){
        if (stream.eat("+")) expr = {
            type: "plus",
            expr: expr
        };
        else if (stream.eat("*")) expr = {
            type: "star",
            expr: expr
        };
        else if (stream.eat("?")) expr = {
            type: "opt",
            expr: expr
        };
        else if (stream.eat("{")) expr = $0f68ec5a5289168c$var$parseExprRange(stream, expr);
        else break;
    }
    return expr;
}
function $0f68ec5a5289168c$var$parseNum(stream) {
    if (/\D/.test(stream.next)) stream.err("Expected number, got '" + stream.next + "'");
    let result = Number(stream.next);
    stream.pos++;
    return result;
}
function $0f68ec5a5289168c$var$parseExprRange(stream, expr) {
    let min = $0f68ec5a5289168c$var$parseNum(stream), max = min;
    if (stream.eat(",")) {
        if (stream.next != "}") max = $0f68ec5a5289168c$var$parseNum(stream);
        else max = -1;
    }
    if (!stream.eat("}")) stream.err("Unclosed braced range");
    return {
        type: "range",
        min: min,
        max: max,
        expr: expr
    };
}
function $0f68ec5a5289168c$var$resolveName(stream, name) {
    let types = stream.nodeTypes, type = types[name];
    if (type) return [
        type
    ];
    let result = [];
    for(let typeName in types){
        let type = types[typeName];
        if (type.isInGroup(name)) result.push(type);
    }
    if (result.length == 0) stream.err("No node type or group '" + name + "' found");
    return result;
}
function $0f68ec5a5289168c$var$parseExprAtom(stream) {
    if (stream.eat("(")) {
        let expr = $0f68ec5a5289168c$var$parseExpr(stream);
        if (!stream.eat(")")) stream.err("Missing closing paren");
        return expr;
    } else if (!/\W/.test(stream.next)) {
        let exprs = $0f68ec5a5289168c$var$resolveName(stream, stream.next).map((type)=>{
            if (stream.inline == null) stream.inline = type.isInline;
            else if (stream.inline != type.isInline) stream.err("Mixing inline and block content");
            return {
                type: "name",
                value: type
            };
        });
        stream.pos++;
        return exprs.length == 1 ? exprs[0] : {
            type: "choice",
            exprs: exprs
        };
    } else stream.err("Unexpected token '" + stream.next + "'");
}
// Construct an NFA from an expression as returned by the parser. The
// NFA is represented as an array of states, which are themselves
// arrays of edges, which are `{term, to}` objects. The first state is
// the entry state and the last node is the success state.
//
// Note that unlike typical NFAs, the edge ordering in this one is
// significant, in that it is used to contruct filler content when
// necessary.
function $0f68ec5a5289168c$var$nfa(expr) {
    let nfa = [
        []
    ];
    connect(compile(expr, 0), node());
    return nfa;
    function node() {
        return nfa.push([]) - 1;
    }
    function edge(from, to, term) {
        let edge = {
            term: term,
            to: to
        };
        nfa[from].push(edge);
        return edge;
    }
    function connect(edges, to) {
        edges.forEach((edge)=>edge.to = to);
    }
    function compile(expr, from) {
        if (expr.type == "choice") return expr.exprs.reduce((out, expr)=>out.concat(compile(expr, from)), []);
        else if (expr.type == "seq") for(let i = 0;; i++){
            let next = compile(expr.exprs[i], from);
            if (i == expr.exprs.length - 1) return next;
            connect(next, from = node());
        }
        else if (expr.type == "star") {
            let loop = node();
            edge(from, loop);
            connect(compile(expr.expr, loop), loop);
            return [
                edge(loop)
            ];
        } else if (expr.type == "plus") {
            let loop = node();
            connect(compile(expr.expr, from), loop);
            connect(compile(expr.expr, loop), loop);
            return [
                edge(loop)
            ];
        } else if (expr.type == "opt") return [
            edge(from)
        ].concat(compile(expr.expr, from));
        else if (expr.type == "range") {
            let cur = from;
            for(let i = 0; i < expr.min; i++){
                let next = node();
                connect(compile(expr.expr, cur), next);
                cur = next;
            }
            if (expr.max == -1) connect(compile(expr.expr, cur), cur);
            else for(let i = expr.min; i < expr.max; i++){
                let next = node();
                edge(cur, next);
                connect(compile(expr.expr, cur), next);
                cur = next;
            }
            return [
                edge(cur)
            ];
        } else if (expr.type == "name") return [
            edge(from, undefined, expr.value)
        ];
        else throw new Error("Unknown expr type");
    }
}
function $0f68ec5a5289168c$var$cmp(a, b) {
    return b - a;
}
// Get the set of nodes reachable by null edges from `node`. Omit
// nodes with only a single null-out-edge, since they may lead to
// needless duplicated nodes.
function $0f68ec5a5289168c$var$nullFrom(nfa, node) {
    let result = [];
    scan(node);
    return result.sort($0f68ec5a5289168c$var$cmp);
    function scan(node) {
        let edges = nfa[node];
        if (edges.length == 1 && !edges[0].term) return scan(edges[0].to);
        result.push(node);
        for(let i = 0; i < edges.length; i++){
            let { term: term, to: to } = edges[i];
            if (!term && result.indexOf(to) == -1) scan(to);
        }
    }
}
// Compiles an NFA as produced by `nfa` into a DFA, modeled as a set
// of state objects (`ContentMatch` instances) with transitions
// between them.
function $0f68ec5a5289168c$var$dfa(nfa) {
    let labeled = Object.create(null);
    return explore($0f68ec5a5289168c$var$nullFrom(nfa, 0));
    function explore(states) {
        let out = [];
        states.forEach((node)=>{
            nfa[node].forEach(({ term: term, to: to })=>{
                if (!term) return;
                let set;
                for(let i = 0; i < out.length; i++)if (out[i][0] == term) set = out[i][1];
                $0f68ec5a5289168c$var$nullFrom(nfa, to).forEach((node)=>{
                    if (!set) out.push([
                        term,
                        set = []
                    ]);
                    if (set.indexOf(node) == -1) set.push(node);
                });
            });
        });
        let state = labeled[states.join(",")] = new $0f68ec5a5289168c$export$364ed450558d7ec4(states.indexOf(nfa.length - 1) > -1);
        for(let i = 0; i < out.length; i++){
            let states = out[i][1].sort($0f68ec5a5289168c$var$cmp);
            state.next.push({
                type: out[i][0],
                next: labeled[states.join(",")] || explore(states)
            });
        }
        return state;
    }
}
function $0f68ec5a5289168c$var$checkForDeadEnds(match, stream) {
    for(let i = 0, work = [
        match
    ]; i < work.length; i++){
        let state = work[i], dead = !state.validEnd, nodes = [];
        for(let j = 0; j < state.next.length; j++){
            let { type: type, next: next } = state.next[j];
            nodes.push(type.name);
            if (dead && !(type.isText || type.hasRequiredAttrs())) dead = false;
            if (work.indexOf(next) == -1) work.push(next);
        }
        if (dead) stream.err("Only non-generatable nodes (" + nodes.join(", ") + ") in a required position (see https://prosemirror.net/docs/guide/#generatable)");
    }
}
// For node types where all attrs have a default value (or which don't
// have any attributes), build up a single reusable default attribute
// object, and use it for all nodes that don't specify specific
// attributes.
function $0f68ec5a5289168c$var$defaultAttrs(attrs) {
    let defaults = Object.create(null);
    for(let attrName in attrs){
        let attr = attrs[attrName];
        if (!attr.hasDefault) return null;
        defaults[attrName] = attr.default;
    }
    return defaults;
}
function $0f68ec5a5289168c$var$computeAttrs(attrs, value) {
    let built = Object.create(null);
    for(let name in attrs){
        let given = value && value[name];
        if (given === undefined) {
            let attr = attrs[name];
            if (attr.hasDefault) given = attr.default;
            else throw new RangeError("No value supplied for attribute " + name);
        }
        built[name] = given;
    }
    return built;
}
function $0f68ec5a5289168c$var$checkAttrs(attrs, values, type, name) {
    for(let name in values)if (!(name in attrs)) throw new RangeError(`Unsupported attribute ${name} for ${type} of type ${name}`);
    for(let name in attrs){
        let attr = attrs[name];
        if (attr.validate) attr.validate(values[name]);
    }
}
function $0f68ec5a5289168c$var$initAttrs(typeName, attrs) {
    let result = Object.create(null);
    if (attrs) for(let name in attrs)result[name] = new $0f68ec5a5289168c$var$Attribute(typeName, name, attrs[name]);
    return result;
}
/**
Node types are objects allocated once per `Schema` and used to
[tag](https://prosemirror.net/docs/ref/#model.Node.type) `Node` instances. They contain information
about the node type, such as its name and what kind of node it
represents.
*/ class $0f68ec5a5289168c$export$f06e977173f1857c {
    /**
    @internal
    */ constructor(/**
    The name the node type has in this schema.
    */ name, /**
    A link back to the `Schema` the node type belongs to.
    */ schema, /**
    The spec that this type is based on
    */ spec){
        this.name = name;
        this.schema = schema;
        this.spec = spec;
        /**
        The set of marks allowed in this node. `null` means all marks
        are allowed.
        */ this.markSet = null;
        this.groups = spec.group ? spec.group.split(" ") : [];
        this.attrs = $0f68ec5a5289168c$var$initAttrs(name, spec.attrs);
        this.defaultAttrs = $0f68ec5a5289168c$var$defaultAttrs(this.attrs);
        this.contentMatch = null;
        this.inlineContent = null;
        this.isBlock = !(spec.inline || name == "text");
        this.isText = name == "text";
    }
    /**
    True if this is an inline type.
    */ get isInline() {
        return !this.isBlock;
    }
    /**
    True if this is a textblock type, a block that contains inline
    content.
    */ get isTextblock() {
        return this.isBlock && this.inlineContent;
    }
    /**
    True for node types that allow no content.
    */ get isLeaf() {
        return this.contentMatch == $0f68ec5a5289168c$export$364ed450558d7ec4.empty;
    }
    /**
    True when this node is an atom, i.e. when it does not have
    directly editable content.
    */ get isAtom() {
        return this.isLeaf || !!this.spec.atom;
    }
    /**
    Return true when this node type is part of the given
    [group](https://prosemirror.net/docs/ref/#model.NodeSpec.group).
    */ isInGroup(group) {
        return this.groups.indexOf(group) > -1;
    }
    /**
    The node type's [whitespace](https://prosemirror.net/docs/ref/#model.NodeSpec.whitespace) option.
    */ get whitespace() {
        return this.spec.whitespace || (this.spec.code ? "pre" : "normal");
    }
    /**
    Tells you whether this node type has any required attributes.
    */ hasRequiredAttrs() {
        for(let n in this.attrs)if (this.attrs[n].isRequired) return true;
        return false;
    }
    /**
    Indicates whether this node allows some of the same content as
    the given node type.
    */ compatibleContent(other) {
        return this == other || this.contentMatch.compatible(other.contentMatch);
    }
    /**
    @internal
    */ computeAttrs(attrs) {
        if (!attrs && this.defaultAttrs) return this.defaultAttrs;
        else return $0f68ec5a5289168c$var$computeAttrs(this.attrs, attrs);
    }
    /**
    Create a `Node` of this type. The given attributes are
    checked and defaulted (you can pass `null` to use the type's
    defaults entirely, if no required attributes exist). `content`
    may be a `Fragment`, a node, an array of nodes, or
    `null`. Similarly `marks` may be `null` to default to the empty
    set of marks.
    */ create(attrs = null, content, marks) {
        if (this.isText) throw new Error("NodeType.create can't construct text nodes");
        return new $0f68ec5a5289168c$export$85c928794f8d04d4(this, this.computeAttrs(attrs), $0f68ec5a5289168c$export$ffb0004e005737fa.from(content), $0f68ec5a5289168c$export$c9d15bcfc6d42044.setFrom(marks));
    }
    /**
    Like [`create`](https://prosemirror.net/docs/ref/#model.NodeType.create), but check the given content
    against the node type's content restrictions, and throw an error
    if it doesn't match.
    */ createChecked(attrs = null, content, marks) {
        content = $0f68ec5a5289168c$export$ffb0004e005737fa.from(content);
        this.checkContent(content);
        return new $0f68ec5a5289168c$export$85c928794f8d04d4(this, this.computeAttrs(attrs), content, $0f68ec5a5289168c$export$c9d15bcfc6d42044.setFrom(marks));
    }
    /**
    Like [`create`](https://prosemirror.net/docs/ref/#model.NodeType.create), but see if it is
    necessary to add nodes to the start or end of the given fragment
    to make it fit the node. If no fitting wrapping can be found,
    return null. Note that, due to the fact that required nodes can
    always be created, this will always succeed if you pass null or
    `Fragment.empty` as content.
    */ createAndFill(attrs = null, content, marks) {
        attrs = this.computeAttrs(attrs);
        content = $0f68ec5a5289168c$export$ffb0004e005737fa.from(content);
        if (content.size) {
            let before = this.contentMatch.fillBefore(content);
            if (!before) return null;
            content = before.append(content);
        }
        let matched = this.contentMatch.matchFragment(content);
        let after = matched && matched.fillBefore($0f68ec5a5289168c$export$ffb0004e005737fa.empty, true);
        if (!after) return null;
        return new $0f68ec5a5289168c$export$85c928794f8d04d4(this, attrs, content.append(after), $0f68ec5a5289168c$export$c9d15bcfc6d42044.setFrom(marks));
    }
    /**
    Returns true if the given fragment is valid content for this node
    type.
    */ validContent(content) {
        let result = this.contentMatch.matchFragment(content);
        if (!result || !result.validEnd) return false;
        for(let i = 0; i < content.childCount; i++)if (!this.allowsMarks(content.child(i).marks)) return false;
        return true;
    }
    /**
    Throws a RangeError if the given fragment is not valid content for this
    node type.
    @internal
    */ checkContent(content) {
        if (!this.validContent(content)) throw new RangeError(`Invalid content for node ${this.name}: ${content.toString().slice(0, 50)}`);
    }
    /**
    @internal
    */ checkAttrs(attrs) {
        $0f68ec5a5289168c$var$checkAttrs(this.attrs, attrs, "node", this.name);
    }
    /**
    Check whether the given mark type is allowed in this node.
    */ allowsMarkType(markType) {
        return this.markSet == null || this.markSet.indexOf(markType) > -1;
    }
    /**
    Test whether the given set of marks are allowed in this node.
    */ allowsMarks(marks) {
        if (this.markSet == null) return true;
        for(let i = 0; i < marks.length; i++)if (!this.allowsMarkType(marks[i].type)) return false;
        return true;
    }
    /**
    Removes the marks that are not allowed in this node from the given set.
    */ allowedMarks(marks) {
        if (this.markSet == null) return marks;
        let copy;
        for(let i = 0; i < marks.length; i++){
            if (!this.allowsMarkType(marks[i].type)) {
                if (!copy) copy = marks.slice(0, i);
            } else if (copy) copy.push(marks[i]);
        }
        return !copy ? marks : copy.length ? copy : $0f68ec5a5289168c$export$c9d15bcfc6d42044.none;
    }
    /**
    @internal
    */ static compile(nodes, schema) {
        let result = Object.create(null);
        nodes.forEach((name, spec)=>result[name] = new $0f68ec5a5289168c$export$f06e977173f1857c(name, schema, spec));
        let topType = schema.spec.topNode || "doc";
        if (!result[topType]) throw new RangeError("Schema is missing its top node type ('" + topType + "')");
        if (!result.text) throw new RangeError("Every schema needs a 'text' type");
        for(let _ in result.text.attrs)throw new RangeError("The text node type should not have attributes");
        return result;
    }
}
function $0f68ec5a5289168c$var$validateType(typeName, attrName, type) {
    let types = type.split("|");
    return (value)=>{
        let name = value === null ? "null" : typeof value;
        if (types.indexOf(name) < 0) throw new RangeError(`Expected value of type ${types} for attribute ${attrName} on type ${typeName}, got ${name}`);
    };
}
// Attribute descriptors
class $0f68ec5a5289168c$var$Attribute {
    constructor(typeName, attrName, options){
        this.hasDefault = Object.prototype.hasOwnProperty.call(options, "default");
        this.default = options.default;
        this.validate = typeof options.validate == "string" ? $0f68ec5a5289168c$var$validateType(typeName, attrName, options.validate) : options.validate;
    }
    get isRequired() {
        return !this.hasDefault;
    }
}
// Marks
/**
Like nodes, marks (which are associated with nodes to signify
things like emphasis or being part of a link) are
[tagged](https://prosemirror.net/docs/ref/#model.Mark.type) with type objects, which are
instantiated once per `Schema`.
*/ class $0f68ec5a5289168c$export$b6a78689043c6521 {
    /**
    @internal
    */ constructor(/**
    The name of the mark type.
    */ name, /**
    @internal
    */ rank, /**
    The schema that this mark type instance is part of.
    */ schema, /**
    The spec on which the type is based.
    */ spec){
        this.name = name;
        this.rank = rank;
        this.schema = schema;
        this.spec = spec;
        this.attrs = $0f68ec5a5289168c$var$initAttrs(name, spec.attrs);
        this.excluded = null;
        let defaults = $0f68ec5a5289168c$var$defaultAttrs(this.attrs);
        this.instance = defaults ? new $0f68ec5a5289168c$export$c9d15bcfc6d42044(this, defaults) : null;
    }
    /**
    Create a mark of this type. `attrs` may be `null` or an object
    containing only some of the mark's attributes. The others, if
    they have defaults, will be added.
    */ create(attrs = null) {
        if (!attrs && this.instance) return this.instance;
        return new $0f68ec5a5289168c$export$c9d15bcfc6d42044(this, $0f68ec5a5289168c$var$computeAttrs(this.attrs, attrs));
    }
    /**
    @internal
    */ static compile(marks, schema) {
        let result = Object.create(null), rank = 0;
        marks.forEach((name, spec)=>result[name] = new $0f68ec5a5289168c$export$b6a78689043c6521(name, rank++, schema, spec));
        return result;
    }
    /**
    When there is a mark of this type in the given set, a new set
    without it is returned. Otherwise, the input set is returned.
    */ removeFromSet(set) {
        for(var i = 0; i < set.length; i++)if (set[i].type == this) {
            set = set.slice(0, i).concat(set.slice(i + 1));
            i--;
        }
        return set;
    }
    /**
    Tests whether there is a mark of this type in the given set.
    */ isInSet(set) {
        for(let i = 0; i < set.length; i++)if (set[i].type == this) return set[i];
    }
    /**
    @internal
    */ checkAttrs(attrs) {
        $0f68ec5a5289168c$var$checkAttrs(this.attrs, attrs, "mark", this.name);
    }
    /**
    Queries whether a given mark type is
    [excluded](https://prosemirror.net/docs/ref/#model.MarkSpec.excludes) by this one.
    */ excludes(other) {
        return this.excluded.indexOf(other) > -1;
    }
}
/**
A document schema. Holds [node](https://prosemirror.net/docs/ref/#model.NodeType) and [mark
type](https://prosemirror.net/docs/ref/#model.MarkType) objects for the nodes and marks that may
occur in conforming documents, and provides functionality for
creating and deserializing such documents.

When given, the type parameters provide the names of the nodes and
marks in this schema.
*/ class $0f68ec5a5289168c$export$19342e026b58ebb7 {
    /**
    Construct a schema from a schema [specification](https://prosemirror.net/docs/ref/#model.SchemaSpec).
    */ constructor(spec){
        /**
        The [linebreak
        replacement](https://prosemirror.net/docs/ref/#model.NodeSpec.linebreakReplacement) node defined
        in this schema, if any.
        */ this.linebreakReplacement = null;
        /**
        An object for storing whatever values modules may want to
        compute and cache per schema. (If you want to store something
        in it, try to use property names unlikely to clash.)
        */ this.cached = Object.create(null);
        let instanceSpec = this.spec = {};
        for(let prop in spec)instanceSpec[prop] = spec[prop];
        instanceSpec.nodes = (0, $at9VT.default).from(spec.nodes), instanceSpec.marks = (0, $at9VT.default).from(spec.marks || {}), this.nodes = $0f68ec5a5289168c$export$f06e977173f1857c.compile(this.spec.nodes, this);
        this.marks = $0f68ec5a5289168c$export$b6a78689043c6521.compile(this.spec.marks, this);
        let contentExprCache = Object.create(null);
        for(let prop in this.nodes){
            if (prop in this.marks) throw new RangeError(prop + " can not be both a node and a mark");
            let type = this.nodes[prop], contentExpr = type.spec.content || "", markExpr = type.spec.marks;
            type.contentMatch = contentExprCache[contentExpr] || (contentExprCache[contentExpr] = $0f68ec5a5289168c$export$364ed450558d7ec4.parse(contentExpr, this.nodes));
            type.inlineContent = type.contentMatch.inlineContent;
            if (type.spec.linebreakReplacement) {
                if (this.linebreakReplacement) throw new RangeError("Multiple linebreak nodes defined");
                if (!type.isInline || !type.isLeaf) throw new RangeError("Linebreak replacement nodes must be inline leaf nodes");
                this.linebreakReplacement = type;
            }
            type.markSet = markExpr == "_" ? null : markExpr ? $0f68ec5a5289168c$var$gatherMarks(this, markExpr.split(" ")) : markExpr == "" || !type.inlineContent ? [] : null;
        }
        for(let prop in this.marks){
            let type = this.marks[prop], excl = type.spec.excludes;
            type.excluded = excl == null ? [
                type
            ] : excl == "" ? [] : $0f68ec5a5289168c$var$gatherMarks(this, excl.split(" "));
        }
        this.nodeFromJSON = (json)=>$0f68ec5a5289168c$export$85c928794f8d04d4.fromJSON(this, json);
        this.markFromJSON = (json)=>$0f68ec5a5289168c$export$c9d15bcfc6d42044.fromJSON(this, json);
        this.topNodeType = this.nodes[this.spec.topNode || "doc"];
        this.cached.wrappings = Object.create(null);
    }
    /**
    Create a node in this schema. The `type` may be a string or a
    `NodeType` instance. Attributes will be extended with defaults,
    `content` may be a `Fragment`, `null`, a `Node`, or an array of
    nodes.
    */ node(type, attrs = null, content, marks) {
        if (typeof type == "string") type = this.nodeType(type);
        else if (!(type instanceof $0f68ec5a5289168c$export$f06e977173f1857c)) throw new RangeError("Invalid node type: " + type);
        else if (type.schema != this) throw new RangeError("Node type from different schema used (" + type.name + ")");
        return type.createChecked(attrs, content, marks);
    }
    /**
    Create a text node in the schema. Empty text nodes are not
    allowed.
    */ text(text, marks) {
        let type = this.nodes.text;
        return new $0f68ec5a5289168c$var$TextNode(type, type.defaultAttrs, text, $0f68ec5a5289168c$export$c9d15bcfc6d42044.setFrom(marks));
    }
    /**
    Create a mark with the given type and attributes.
    */ mark(type, attrs) {
        if (typeof type == "string") type = this.marks[type];
        return type.create(attrs);
    }
    /**
    @internal
    */ nodeType(name) {
        let found = this.nodes[name];
        if (!found) throw new RangeError("Unknown node type: " + name);
        return found;
    }
}
function $0f68ec5a5289168c$var$gatherMarks(schema, marks) {
    let found = [];
    for(let i = 0; i < marks.length; i++){
        let name = marks[i], mark = schema.marks[name], ok = mark;
        if (mark) found.push(mark);
        else for(let prop in schema.marks){
            let mark = schema.marks[prop];
            if (name == "_" || mark.spec.group && mark.spec.group.split(" ").indexOf(name) > -1) found.push(ok = mark);
        }
        if (!ok) throw new SyntaxError("Unknown mark type: '" + marks[i] + "'");
    }
    return found;
}
function $0f68ec5a5289168c$var$isTagRule(rule) {
    return rule.tag != null;
}
function $0f68ec5a5289168c$var$isStyleRule(rule) {
    return rule.style != null;
}
/**
A DOM parser represents a strategy for parsing DOM content into a
ProseMirror document conforming to a given schema. Its behavior is
defined by an array of [rules](https://prosemirror.net/docs/ref/#model.ParseRule).
*/ class $0f68ec5a5289168c$export$1059c6e7d2ce5669 {
    /**
    Create a parser that targets the given schema, using the given
    parsing rules.
    */ constructor(/**
    The schema into which the parser parses.
    */ schema, /**
    The set of [parse rules](https://prosemirror.net/docs/ref/#model.ParseRule) that the parser
    uses, in order of precedence.
    */ rules){
        this.schema = schema;
        this.rules = rules;
        /**
        @internal
        */ this.tags = [];
        /**
        @internal
        */ this.styles = [];
        let matchedStyles = this.matchedStyles = [];
        rules.forEach((rule)=>{
            if ($0f68ec5a5289168c$var$isTagRule(rule)) this.tags.push(rule);
            else if ($0f68ec5a5289168c$var$isStyleRule(rule)) {
                let prop = /[^=]*/.exec(rule.style)[0];
                if (matchedStyles.indexOf(prop) < 0) matchedStyles.push(prop);
                this.styles.push(rule);
            }
        });
        // Only normalize list elements when lists in the schema can't directly contain themselves
        this.normalizeLists = !this.tags.some((r)=>{
            if (!/^(ul|ol)\b/.test(r.tag) || !r.node) return false;
            let node = schema.nodes[r.node];
            return node.contentMatch.matchType(node);
        });
    }
    /**
    Parse a document from the content of a DOM node.
    */ parse(dom, options = {}) {
        let context = new $0f68ec5a5289168c$var$ParseContext(this, options, false);
        context.addAll(dom, $0f68ec5a5289168c$export$c9d15bcfc6d42044.none, options.from, options.to);
        return context.finish();
    }
    /**
    Parses the content of the given DOM node, like
    [`parse`](https://prosemirror.net/docs/ref/#model.DOMParser.parse), and takes the same set of
    options. But unlike that method, which produces a whole node,
    this one returns a slice that is open at the sides, meaning that
    the schema constraints aren't applied to the start of nodes to
    the left of the input and the end of nodes at the end.
    */ parseSlice(dom, options = {}) {
        let context = new $0f68ec5a5289168c$var$ParseContext(this, options, true);
        context.addAll(dom, $0f68ec5a5289168c$export$c9d15bcfc6d42044.none, options.from, options.to);
        return $0f68ec5a5289168c$export$b3f2e2de3a8baa1e.maxOpen(context.finish());
    }
    /**
    @internal
    */ matchTag(dom, context, after) {
        for(let i = after ? this.tags.indexOf(after) + 1 : 0; i < this.tags.length; i++){
            let rule = this.tags[i];
            if ($0f68ec5a5289168c$var$matches(dom, rule.tag) && (rule.namespace === undefined || dom.namespaceURI == rule.namespace) && (!rule.context || context.matchesContext(rule.context))) {
                if (rule.getAttrs) {
                    let result = rule.getAttrs(dom);
                    if (result === false) continue;
                    rule.attrs = result || undefined;
                }
                return rule;
            }
        }
    }
    /**
    @internal
    */ matchStyle(prop, value, context, after) {
        for(let i = after ? this.styles.indexOf(after) + 1 : 0; i < this.styles.length; i++){
            let rule = this.styles[i], style = rule.style;
            if (style.indexOf(prop) != 0 || rule.context && !context.matchesContext(rule.context) || // Test that the style string either precisely matches the prop,
            // or has an '=' sign after the prop, followed by the given
            // value.
            style.length > prop.length && (style.charCodeAt(prop.length) != 61 || style.slice(prop.length + 1) != value)) continue;
            if (rule.getAttrs) {
                let result = rule.getAttrs(value);
                if (result === false) continue;
                rule.attrs = result || undefined;
            }
            return rule;
        }
    }
    /**
    @internal
    */ static schemaRules(schema) {
        let result = [];
        function insert(rule) {
            let priority = rule.priority == null ? 50 : rule.priority, i = 0;
            for(; i < result.length; i++){
                let next = result[i], nextPriority = next.priority == null ? 50 : next.priority;
                if (nextPriority < priority) break;
            }
            result.splice(i, 0, rule);
        }
        for(let name in schema.marks){
            let rules = schema.marks[name].spec.parseDOM;
            if (rules) rules.forEach((rule)=>{
                insert(rule = $0f68ec5a5289168c$var$copy(rule));
                if (!(rule.mark || rule.ignore || rule.clearMark)) rule.mark = name;
            });
        }
        for(let name in schema.nodes){
            let rules = schema.nodes[name].spec.parseDOM;
            if (rules) rules.forEach((rule)=>{
                insert(rule = $0f68ec5a5289168c$var$copy(rule));
                if (!(rule.node || rule.ignore || rule.mark)) rule.node = name;
            });
        }
        return result;
    }
    /**
    Construct a DOM parser using the parsing rules listed in a
    schema's [node specs](https://prosemirror.net/docs/ref/#model.NodeSpec.parseDOM), reordered by
    [priority](https://prosemirror.net/docs/ref/#model.GenericParseRule.priority).
    */ static fromSchema(schema) {
        return schema.cached.domParser || (schema.cached.domParser = new $0f68ec5a5289168c$export$1059c6e7d2ce5669(schema, $0f68ec5a5289168c$export$1059c6e7d2ce5669.schemaRules(schema)));
    }
}
const $0f68ec5a5289168c$var$blockTags = {
    address: true,
    article: true,
    aside: true,
    blockquote: true,
    canvas: true,
    dd: true,
    div: true,
    dl: true,
    fieldset: true,
    figcaption: true,
    figure: true,
    footer: true,
    form: true,
    h1: true,
    h2: true,
    h3: true,
    h4: true,
    h5: true,
    h6: true,
    header: true,
    hgroup: true,
    hr: true,
    li: true,
    noscript: true,
    ol: true,
    output: true,
    p: true,
    pre: true,
    section: true,
    table: true,
    tfoot: true,
    ul: true
};
const $0f68ec5a5289168c$var$ignoreTags = {
    head: true,
    noscript: true,
    object: true,
    script: true,
    style: true,
    title: true
};
const $0f68ec5a5289168c$var$listTags = {
    ol: true,
    ul: true
};
// Using a bitfield for node context options
const $0f68ec5a5289168c$var$OPT_PRESERVE_WS = 1, $0f68ec5a5289168c$var$OPT_PRESERVE_WS_FULL = 2, $0f68ec5a5289168c$var$OPT_OPEN_LEFT = 4;
function $0f68ec5a5289168c$var$wsOptionsFor(type, preserveWhitespace, base) {
    if (preserveWhitespace != null) return (preserveWhitespace ? $0f68ec5a5289168c$var$OPT_PRESERVE_WS : 0) | (preserveWhitespace === "full" ? $0f68ec5a5289168c$var$OPT_PRESERVE_WS_FULL : 0);
    return type && type.whitespace == "pre" ? $0f68ec5a5289168c$var$OPT_PRESERVE_WS | $0f68ec5a5289168c$var$OPT_PRESERVE_WS_FULL : base & ~$0f68ec5a5289168c$var$OPT_OPEN_LEFT;
}
class $0f68ec5a5289168c$var$NodeContext {
    constructor(type, attrs, marks, solid, match, options){
        this.type = type;
        this.attrs = attrs;
        this.marks = marks;
        this.solid = solid;
        this.options = options;
        this.content = [];
        // Marks applied to the node's children
        this.activeMarks = $0f68ec5a5289168c$export$c9d15bcfc6d42044.none;
        this.match = match || (options & $0f68ec5a5289168c$var$OPT_OPEN_LEFT ? null : type.contentMatch);
    }
    findWrapping(node) {
        if (!this.match) {
            if (!this.type) return [];
            let fill = this.type.contentMatch.fillBefore($0f68ec5a5289168c$export$ffb0004e005737fa.from(node));
            if (fill) this.match = this.type.contentMatch.matchFragment(fill);
            else {
                let start = this.type.contentMatch, wrap;
                if (wrap = start.findWrapping(node.type)) {
                    this.match = start;
                    return wrap;
                } else return null;
            }
        }
        return this.match.findWrapping(node.type);
    }
    finish(openEnd) {
        if (!(this.options & $0f68ec5a5289168c$var$OPT_PRESERVE_WS)) {
            let last = this.content[this.content.length - 1], m;
            if (last && last.isText && (m = /[ \t\r\n\u000c]+$/.exec(last.text))) {
                let text = last;
                if (last.text.length == m[0].length) this.content.pop();
                else this.content[this.content.length - 1] = text.withText(text.text.slice(0, text.text.length - m[0].length));
            }
        }
        let content = $0f68ec5a5289168c$export$ffb0004e005737fa.from(this.content);
        if (!openEnd && this.match) content = content.append(this.match.fillBefore($0f68ec5a5289168c$export$ffb0004e005737fa.empty, true));
        return this.type ? this.type.create(this.attrs, content, this.marks) : content;
    }
    inlineContext(node) {
        if (this.type) return this.type.inlineContent;
        if (this.content.length) return this.content[0].isInline;
        return node.parentNode && !$0f68ec5a5289168c$var$blockTags.hasOwnProperty(node.parentNode.nodeName.toLowerCase());
    }
}
class $0f68ec5a5289168c$var$ParseContext {
    constructor(// The parser we are using.
    parser, // The options passed to this parse.
    options, isOpen){
        this.parser = parser;
        this.options = options;
        this.isOpen = isOpen;
        this.open = 0;
        this.localPreserveWS = false;
        let topNode = options.topNode, topContext;
        let topOptions = $0f68ec5a5289168c$var$wsOptionsFor(null, options.preserveWhitespace, 0) | (isOpen ? $0f68ec5a5289168c$var$OPT_OPEN_LEFT : 0);
        if (topNode) topContext = new $0f68ec5a5289168c$var$NodeContext(topNode.type, topNode.attrs, $0f68ec5a5289168c$export$c9d15bcfc6d42044.none, true, options.topMatch || topNode.type.contentMatch, topOptions);
        else if (isOpen) topContext = new $0f68ec5a5289168c$var$NodeContext(null, null, $0f68ec5a5289168c$export$c9d15bcfc6d42044.none, true, null, topOptions);
        else topContext = new $0f68ec5a5289168c$var$NodeContext(parser.schema.topNodeType, null, $0f68ec5a5289168c$export$c9d15bcfc6d42044.none, true, null, topOptions);
        this.nodes = [
            topContext
        ];
        this.find = options.findPositions;
        this.needsBlock = false;
    }
    get top() {
        return this.nodes[this.open];
    }
    // Add a DOM node to the content. Text is inserted as text node,
    // otherwise, the node is passed to `addElement` or, if it has a
    // `style` attribute, `addElementWithStyles`.
    addDOM(dom, marks) {
        if (dom.nodeType == 3) this.addTextNode(dom, marks);
        else if (dom.nodeType == 1) this.addElement(dom, marks);
    }
    addTextNode(dom, marks) {
        let value = dom.nodeValue;
        let top = this.top, preserveWS = top.options & $0f68ec5a5289168c$var$OPT_PRESERVE_WS_FULL ? "full" : this.localPreserveWS || (top.options & $0f68ec5a5289168c$var$OPT_PRESERVE_WS) > 0;
        let { schema: schema } = this.parser;
        if (preserveWS === "full" || top.inlineContext(dom) || /[^ \t\r\n\u000c]/.test(value)) {
            if (!preserveWS) {
                value = value.replace(/[ \t\r\n\u000c]+/g, " ");
                // If this starts with whitespace, and there is no node before it, or
                // a hard break, or a text node that ends with whitespace, strip the
                // leading space.
                if (/^[ \t\r\n\u000c]/.test(value) && this.open == this.nodes.length - 1) {
                    let nodeBefore = top.content[top.content.length - 1];
                    let domNodeBefore = dom.previousSibling;
                    if (!nodeBefore || domNodeBefore && domNodeBefore.nodeName == 'BR' || nodeBefore.isText && /[ \t\r\n\u000c]$/.test(nodeBefore.text)) value = value.slice(1);
                }
            } else if (preserveWS === "full") value = value.replace(/\r\n?/g, "\n");
            else if (schema.linebreakReplacement && /[\r\n]/.test(value) && this.top.findWrapping(schema.linebreakReplacement.create())) {
                let lines = value.split(/\r?\n|\r/);
                for(let i = 0; i < lines.length; i++){
                    if (i) this.insertNode(schema.linebreakReplacement.create(), marks, true);
                    if (lines[i]) this.insertNode(schema.text(lines[i]), marks, !/\S/.test(lines[i]));
                }
                value = "";
            } else value = value.replace(/\r?\n|\r/g, " ");
            if (value) this.insertNode(schema.text(value), marks, !/\S/.test(value));
            this.findInText(dom);
        } else this.findInside(dom);
    }
    // Try to find a handler for the given tag and use that to parse. If
    // none is found, the element's content nodes are added directly.
    addElement(dom, marks, matchAfter) {
        let outerWS = this.localPreserveWS, top = this.top;
        if (dom.tagName == "PRE" || /pre/.test(dom.style && dom.style.whiteSpace)) this.localPreserveWS = true;
        let name = dom.nodeName.toLowerCase(), ruleID;
        if ($0f68ec5a5289168c$var$listTags.hasOwnProperty(name) && this.parser.normalizeLists) $0f68ec5a5289168c$var$normalizeList(dom);
        let rule = this.options.ruleFromNode && this.options.ruleFromNode(dom) || (ruleID = this.parser.matchTag(dom, this, matchAfter));
        out: if (rule ? rule.ignore : $0f68ec5a5289168c$var$ignoreTags.hasOwnProperty(name)) {
            this.findInside(dom);
            this.ignoreFallback(dom, marks);
        } else if (!rule || rule.skip || rule.closeParent) {
            if (rule && rule.closeParent) this.open = Math.max(0, this.open - 1);
            else if (rule && rule.skip.nodeType) dom = rule.skip;
            let sync, oldNeedsBlock = this.needsBlock;
            if ($0f68ec5a5289168c$var$blockTags.hasOwnProperty(name)) {
                if (top.content.length && top.content[0].isInline && this.open) {
                    this.open--;
                    top = this.top;
                }
                sync = true;
                if (!top.type) this.needsBlock = true;
            } else if (!dom.firstChild) {
                this.leafFallback(dom, marks);
                break out;
            }
            let innerMarks = rule && rule.skip ? marks : this.readStyles(dom, marks);
            if (innerMarks) this.addAll(dom, innerMarks);
            if (sync) this.sync(top);
            this.needsBlock = oldNeedsBlock;
        } else {
            let innerMarks = this.readStyles(dom, marks);
            if (innerMarks) this.addElementByRule(dom, rule, innerMarks, rule.consuming === false ? ruleID : undefined);
        }
        this.localPreserveWS = outerWS;
    }
    // Called for leaf DOM nodes that would otherwise be ignored
    leafFallback(dom, marks) {
        if (dom.nodeName == "BR" && this.top.type && this.top.type.inlineContent) this.addTextNode(dom.ownerDocument.createTextNode("\n"), marks);
    }
    // Called for ignored nodes
    ignoreFallback(dom, marks) {
        // Ignored BR nodes should at least create an inline context
        if (dom.nodeName == "BR" && (!this.top.type || !this.top.type.inlineContent)) this.findPlace(this.parser.schema.text("-"), marks, true);
    }
    // Run any style parser associated with the node's styles. Either
    // return an updated array of marks, or null to indicate some of the
    // styles had a rule with `ignore` set.
    readStyles(dom, marks) {
        let styles = dom.style;
        // Because many properties will only show up in 'normalized' form
        // in `style.item` (i.e. text-decoration becomes
        // text-decoration-line, text-decoration-color, etc), we directly
        // query the styles mentioned in our rules instead of iterating
        // over the items.
        if (styles && styles.length) for(let i = 0; i < this.parser.matchedStyles.length; i++){
            let name = this.parser.matchedStyles[i], value = styles.getPropertyValue(name);
            if (value) for(let after = undefined;;){
                let rule = this.parser.matchStyle(name, value, this, after);
                if (!rule) break;
                if (rule.ignore) return null;
                if (rule.clearMark) marks = marks.filter((m)=>!rule.clearMark(m));
                else marks = marks.concat(this.parser.schema.marks[rule.mark].create(rule.attrs));
                if (rule.consuming === false) after = rule;
                else break;
            }
        }
        return marks;
    }
    // Look up a handler for the given node. If none are found, return
    // false. Otherwise, apply it, use its return value to drive the way
    // the node's content is wrapped, and return true.
    addElementByRule(dom, rule, marks, continueAfter) {
        let sync, nodeType;
        if (rule.node) {
            nodeType = this.parser.schema.nodes[rule.node];
            if (!nodeType.isLeaf) {
                let inner = this.enter(nodeType, rule.attrs || null, marks, rule.preserveWhitespace);
                if (inner) {
                    sync = true;
                    marks = inner;
                }
            } else if (!this.insertNode(nodeType.create(rule.attrs), marks, dom.nodeName == "BR")) this.leafFallback(dom, marks);
        } else {
            let markType = this.parser.schema.marks[rule.mark];
            marks = marks.concat(markType.create(rule.attrs));
        }
        let startIn = this.top;
        if (nodeType && nodeType.isLeaf) this.findInside(dom);
        else if (continueAfter) this.addElement(dom, marks, continueAfter);
        else if (rule.getContent) {
            this.findInside(dom);
            rule.getContent(dom, this.parser.schema).forEach((node)=>this.insertNode(node, marks, false));
        } else {
            let contentDOM = dom;
            if (typeof rule.contentElement == "string") contentDOM = dom.querySelector(rule.contentElement);
            else if (typeof rule.contentElement == "function") contentDOM = rule.contentElement(dom);
            else if (rule.contentElement) contentDOM = rule.contentElement;
            this.findAround(dom, contentDOM, true);
            this.addAll(contentDOM, marks);
            this.findAround(dom, contentDOM, false);
        }
        if (sync && this.sync(startIn)) this.open--;
    }
    // Add all child nodes between `startIndex` and `endIndex` (or the
    // whole node, if not given). If `sync` is passed, use it to
    // synchronize after every block element.
    addAll(parent, marks, startIndex, endIndex) {
        let index = startIndex || 0;
        for(let dom = startIndex ? parent.childNodes[startIndex] : parent.firstChild, end = endIndex == null ? null : parent.childNodes[endIndex]; dom != end; dom = dom.nextSibling, ++index){
            this.findAtPoint(parent, index);
            this.addDOM(dom, marks);
        }
        this.findAtPoint(parent, index);
    }
    // Try to find a way to fit the given node type into the current
    // context. May add intermediate wrappers and/or leave non-solid
    // nodes that we're in.
    findPlace(node, marks, cautious) {
        let route, sync;
        for(let depth = this.open, penalty = 0; depth >= 0; depth--){
            let cx = this.nodes[depth];
            let found = cx.findWrapping(node);
            if (found && (!route || route.length > found.length + penalty)) {
                route = found;
                sync = cx;
                if (!found.length) break;
            }
            if (cx.solid) {
                if (cautious) break;
                penalty += 2;
            }
        }
        if (!route) return null;
        this.sync(sync);
        for(let i = 0; i < route.length; i++)marks = this.enterInner(route[i], null, marks, false);
        return marks;
    }
    // Try to insert the given node, adjusting the context when needed.
    insertNode(node, marks, cautious) {
        if (node.isInline && this.needsBlock && !this.top.type) {
            let block = this.textblockFromContext();
            if (block) marks = this.enterInner(block, null, marks);
        }
        let innerMarks = this.findPlace(node, marks, cautious);
        if (innerMarks) {
            this.closeExtra();
            let top = this.top;
            if (top.match) top.match = top.match.matchType(node.type);
            let nodeMarks = $0f68ec5a5289168c$export$c9d15bcfc6d42044.none;
            for (let m of innerMarks.concat(node.marks))if (top.type ? top.type.allowsMarkType(m.type) : $0f68ec5a5289168c$var$markMayApply(m.type, node.type)) nodeMarks = m.addToSet(nodeMarks);
            top.content.push(node.mark(nodeMarks));
            return true;
        }
        return false;
    }
    // Try to start a node of the given type, adjusting the context when
    // necessary.
    enter(type, attrs, marks, preserveWS) {
        let innerMarks = this.findPlace(type.create(attrs), marks, false);
        if (innerMarks) innerMarks = this.enterInner(type, attrs, marks, true, preserveWS);
        return innerMarks;
    }
    // Open a node of the given type
    enterInner(type, attrs, marks, solid = false, preserveWS) {
        this.closeExtra();
        let top = this.top;
        top.match = top.match && top.match.matchType(type);
        let options = $0f68ec5a5289168c$var$wsOptionsFor(type, preserveWS, top.options);
        if (top.options & $0f68ec5a5289168c$var$OPT_OPEN_LEFT && top.content.length == 0) options |= $0f68ec5a5289168c$var$OPT_OPEN_LEFT;
        let applyMarks = $0f68ec5a5289168c$export$c9d15bcfc6d42044.none;
        marks = marks.filter((m)=>{
            if (top.type ? top.type.allowsMarkType(m.type) : $0f68ec5a5289168c$var$markMayApply(m.type, type)) {
                applyMarks = m.addToSet(applyMarks);
                return false;
            }
            return true;
        });
        this.nodes.push(new $0f68ec5a5289168c$var$NodeContext(type, attrs, applyMarks, solid, null, options));
        this.open++;
        return marks;
    }
    // Make sure all nodes above this.open are finished and added to
    // their parents
    closeExtra(openEnd = false) {
        let i = this.nodes.length - 1;
        if (i > this.open) {
            for(; i > this.open; i--)this.nodes[i - 1].content.push(this.nodes[i].finish(openEnd));
            this.nodes.length = this.open + 1;
        }
    }
    finish() {
        this.open = 0;
        this.closeExtra(this.isOpen);
        return this.nodes[0].finish(!!(this.isOpen || this.options.topOpen));
    }
    sync(to) {
        for(let i = this.open; i >= 0; i--){
            if (this.nodes[i] == to) {
                this.open = i;
                return true;
            } else if (this.localPreserveWS) this.nodes[i].options |= $0f68ec5a5289168c$var$OPT_PRESERVE_WS;
        }
        return false;
    }
    get currentPos() {
        this.closeExtra();
        let pos = 0;
        for(let i = this.open; i >= 0; i--){
            let content = this.nodes[i].content;
            for(let j = content.length - 1; j >= 0; j--)pos += content[j].nodeSize;
            if (i) pos++;
        }
        return pos;
    }
    findAtPoint(parent, offset) {
        if (this.find) {
            for(let i = 0; i < this.find.length; i++)if (this.find[i].node == parent && this.find[i].offset == offset) this.find[i].pos = this.currentPos;
        }
    }
    findInside(parent) {
        if (this.find) {
            for(let i = 0; i < this.find.length; i++)if (this.find[i].pos == null && parent.nodeType == 1 && parent.contains(this.find[i].node)) this.find[i].pos = this.currentPos;
        }
    }
    findAround(parent, content, before) {
        if (parent != content && this.find) {
            for(let i = 0; i < this.find.length; i++)if (this.find[i].pos == null && parent.nodeType == 1 && parent.contains(this.find[i].node)) {
                let pos = content.compareDocumentPosition(this.find[i].node);
                if (pos & (before ? 2 : 4)) this.find[i].pos = this.currentPos;
            }
        }
    }
    findInText(textNode) {
        if (this.find) {
            for(let i = 0; i < this.find.length; i++)if (this.find[i].node == textNode) this.find[i].pos = this.currentPos - (textNode.nodeValue.length - this.find[i].offset);
        }
    }
    // Determines whether the given context string matches this context.
    matchesContext(context) {
        if (context.indexOf("|") > -1) return context.split(/\s*\|\s*/).some(this.matchesContext, this);
        let parts = context.split("/");
        let option = this.options.context;
        let useRoot = !this.isOpen && (!option || option.parent.type == this.nodes[0].type);
        let minDepth = -(option ? option.depth + 1 : 0) + (useRoot ? 0 : 1);
        let match = (i, depth)=>{
            for(; i >= 0; i--){
                let part = parts[i];
                if (part == "") {
                    if (i == parts.length - 1 || i == 0) continue;
                    for(; depth >= minDepth; depth--)if (match(i - 1, depth)) return true;
                    return false;
                } else {
                    let next = depth > 0 || depth == 0 && useRoot ? this.nodes[depth].type : option && depth >= minDepth ? option.node(depth - minDepth).type : null;
                    if (!next || next.name != part && !next.isInGroup(part)) return false;
                    depth--;
                }
            }
            return true;
        };
        return match(parts.length - 1, this.open);
    }
    textblockFromContext() {
        let $context = this.options.context;
        if ($context) for(let d = $context.depth; d >= 0; d--){
            let deflt = $context.node(d).contentMatchAt($context.indexAfter(d)).defaultType;
            if (deflt && deflt.isTextblock && deflt.defaultAttrs) return deflt;
        }
        for(let name in this.parser.schema.nodes){
            let type = this.parser.schema.nodes[name];
            if (type.isTextblock && type.defaultAttrs) return type;
        }
    }
}
// Kludge to work around directly nested list nodes produced by some
// tools and allowed by browsers to mean that the nested list is
// actually part of the list item above it.
function $0f68ec5a5289168c$var$normalizeList(dom) {
    for(let child = dom.firstChild, prevItem = null; child; child = child.nextSibling){
        let name = child.nodeType == 1 ? child.nodeName.toLowerCase() : null;
        if (name && $0f68ec5a5289168c$var$listTags.hasOwnProperty(name) && prevItem) {
            prevItem.appendChild(child);
            child = prevItem;
        } else if (name == "li") prevItem = child;
        else if (name) prevItem = null;
    }
}
// Apply a CSS selector.
function $0f68ec5a5289168c$var$matches(dom, selector) {
    return (dom.matches || dom.msMatchesSelector || dom.webkitMatchesSelector || dom.mozMatchesSelector).call(dom, selector);
}
function $0f68ec5a5289168c$var$copy(obj) {
    let copy = {};
    for(let prop in obj)copy[prop] = obj[prop];
    return copy;
}
// Used when finding a mark at the top level of a fragment parse.
// Checks whether it would be reasonable to apply a given mark type to
// a given node, by looking at the way the mark occurs in the schema.
function $0f68ec5a5289168c$var$markMayApply(markType, nodeType) {
    let nodes = nodeType.schema.nodes;
    for(let name in nodes){
        let parent = nodes[name];
        if (!parent.allowsMarkType(markType)) continue;
        let seen = [], scan = (match)=>{
            seen.push(match);
            for(let i = 0; i < match.edgeCount; i++){
                let { type: type, next: next } = match.edge(i);
                if (type == nodeType) return true;
                if (seen.indexOf(next) < 0 && scan(next)) return true;
            }
        };
        if (scan(parent.contentMatch)) return true;
    }
}
/**
A DOM serializer knows how to convert ProseMirror nodes and
marks of various types to DOM nodes.
*/ class $0f68ec5a5289168c$export$3476b78f8f5a8b72 {
    /**
    Create a serializer. `nodes` should map node names to functions
    that take a node and return a description of the corresponding
    DOM. `marks` does the same for mark names, but also gets an
    argument that tells it whether the mark's content is block or
    inline content (for typical use, it'll always be inline). A mark
    serializer may be `null` to indicate that marks of that type
    should not be serialized.
    */ constructor(/**
    The node serialization functions.
    */ nodes, /**
    The mark serialization functions.
    */ marks){
        this.nodes = nodes;
        this.marks = marks;
    }
    /**
    Serialize the content of this fragment to a DOM fragment. When
    not in the browser, the `document` option, containing a DOM
    document, should be passed so that the serializer can create
    nodes.
    */ serializeFragment(fragment, options = {}, target) {
        if (!target) target = $0f68ec5a5289168c$var$doc(options).createDocumentFragment();
        let top = target, active = [];
        fragment.forEach((node)=>{
            if (active.length || node.marks.length) {
                let keep = 0, rendered = 0;
                while(keep < active.length && rendered < node.marks.length){
                    let next = node.marks[rendered];
                    if (!this.marks[next.type.name]) {
                        rendered++;
                        continue;
                    }
                    if (!next.eq(active[keep][0]) || next.type.spec.spanning === false) break;
                    keep++;
                    rendered++;
                }
                while(keep < active.length)top = active.pop()[1];
                while(rendered < node.marks.length){
                    let add = node.marks[rendered++];
                    let markDOM = this.serializeMark(add, node.isInline, options);
                    if (markDOM) {
                        active.push([
                            add,
                            top
                        ]);
                        top.appendChild(markDOM.dom);
                        top = markDOM.contentDOM || markDOM.dom;
                    }
                }
            }
            top.appendChild(this.serializeNodeInner(node, options));
        });
        return target;
    }
    /**
    @internal
    */ serializeNodeInner(node, options) {
        let { dom: dom, contentDOM: contentDOM } = $0f68ec5a5289168c$var$renderSpec($0f68ec5a5289168c$var$doc(options), this.nodes[node.type.name](node), null, node.attrs);
        if (contentDOM) {
            if (node.isLeaf) throw new RangeError("Content hole not allowed in a leaf node spec");
            this.serializeFragment(node.content, options, contentDOM);
        }
        return dom;
    }
    /**
    Serialize this node to a DOM node. This can be useful when you
    need to serialize a part of a document, as opposed to the whole
    document. To serialize a whole document, use
    [`serializeFragment`](https://prosemirror.net/docs/ref/#model.DOMSerializer.serializeFragment) on
    its [content](https://prosemirror.net/docs/ref/#model.Node.content).
    */ serializeNode(node, options = {}) {
        let dom = this.serializeNodeInner(node, options);
        for(let i = node.marks.length - 1; i >= 0; i--){
            let wrap = this.serializeMark(node.marks[i], node.isInline, options);
            if (wrap) {
                (wrap.contentDOM || wrap.dom).appendChild(dom);
                dom = wrap.dom;
            }
        }
        return dom;
    }
    /**
    @internal
    */ serializeMark(mark, inline, options = {}) {
        let toDOM = this.marks[mark.type.name];
        return toDOM && $0f68ec5a5289168c$var$renderSpec($0f68ec5a5289168c$var$doc(options), toDOM(mark, inline), null, mark.attrs);
    }
    static renderSpec(doc, structure, xmlNS = null, blockArraysIn) {
        return $0f68ec5a5289168c$var$renderSpec(doc, structure, xmlNS, blockArraysIn);
    }
    /**
    Build a serializer using the [`toDOM`](https://prosemirror.net/docs/ref/#model.NodeSpec.toDOM)
    properties in a schema's node and mark specs.
    */ static fromSchema(schema) {
        return schema.cached.domSerializer || (schema.cached.domSerializer = new $0f68ec5a5289168c$export$3476b78f8f5a8b72(this.nodesFromSchema(schema), this.marksFromSchema(schema)));
    }
    /**
    Gather the serializers in a schema's node specs into an object.
    This can be useful as a base to build a custom serializer from.
    */ static nodesFromSchema(schema) {
        let result = $0f68ec5a5289168c$var$gatherToDOM(schema.nodes);
        if (!result.text) result.text = (node)=>node.text;
        return result;
    }
    /**
    Gather the serializers in a schema's mark specs into an object.
    */ static marksFromSchema(schema) {
        return $0f68ec5a5289168c$var$gatherToDOM(schema.marks);
    }
}
function $0f68ec5a5289168c$var$gatherToDOM(obj) {
    let result = {};
    for(let name in obj){
        let toDOM = obj[name].spec.toDOM;
        if (toDOM) result[name] = toDOM;
    }
    return result;
}
function $0f68ec5a5289168c$var$doc(options) {
    return options.document || window.document;
}
const $0f68ec5a5289168c$var$suspiciousAttributeCache = new WeakMap();
function $0f68ec5a5289168c$var$suspiciousAttributes(attrs) {
    let value = $0f68ec5a5289168c$var$suspiciousAttributeCache.get(attrs);
    if (value === undefined) $0f68ec5a5289168c$var$suspiciousAttributeCache.set(attrs, value = $0f68ec5a5289168c$var$suspiciousAttributesInner(attrs));
    return value;
}
function $0f68ec5a5289168c$var$suspiciousAttributesInner(attrs) {
    let result = null;
    function scan(value) {
        if (value && typeof value == "object") {
            if (Array.isArray(value)) {
                if (typeof value[0] == "string") {
                    if (!result) result = [];
                    result.push(value);
                } else for(let i = 0; i < value.length; i++)scan(value[i]);
            } else for(let prop in value)scan(value[prop]);
        }
    }
    scan(attrs);
    return result;
}
function $0f68ec5a5289168c$var$renderSpec(doc, structure, xmlNS, blockArraysIn) {
    if (typeof structure == "string") return {
        dom: doc.createTextNode(structure)
    };
    if (structure.nodeType != null) return {
        dom: structure
    };
    if (structure.dom && structure.dom.nodeType != null) return structure;
    let tagName = structure[0], suspicious;
    if (typeof tagName != "string") throw new RangeError("Invalid array passed to renderSpec");
    if (blockArraysIn && (suspicious = $0f68ec5a5289168c$var$suspiciousAttributes(blockArraysIn)) && suspicious.indexOf(structure) > -1) throw new RangeError("Using an array from an attribute object as a DOM spec. This may be an attempted cross site scripting attack.");
    let space = tagName.indexOf(" ");
    if (space > 0) {
        xmlNS = tagName.slice(0, space);
        tagName = tagName.slice(space + 1);
    }
    let contentDOM;
    let dom = xmlNS ? doc.createElementNS(xmlNS, tagName) : doc.createElement(tagName);
    let attrs = structure[1], start = 1;
    if (attrs && typeof attrs == "object" && attrs.nodeType == null && !Array.isArray(attrs)) {
        start = 2;
        for(let name in attrs)if (attrs[name] != null) {
            let space = name.indexOf(" ");
            if (space > 0) dom.setAttributeNS(name.slice(0, space), name.slice(space + 1), attrs[name]);
            else if (name == "style" && dom.style) dom.style.cssText = attrs[name];
            else dom.setAttribute(name, attrs[name]);
        }
    }
    for(let i = start; i < structure.length; i++){
        let child = structure[i];
        if (child === 0) {
            if (i < structure.length - 1 || i > start) throw new RangeError("Content hole must be the only child of its parent node");
            return {
                dom: dom,
                contentDOM: dom
            };
        } else {
            let { dom: inner, contentDOM: innerContent } = $0f68ec5a5289168c$var$renderSpec(doc, child, xmlNS, blockArraysIn);
            dom.appendChild(inner);
            if (innerContent) {
                if (contentDOM) throw new RangeError("Multiple content holes");
                contentDOM = innerContent;
            }
        }
    }
    return {
        dom: dom,
        contentDOM: contentDOM
    };
}

});


parcelRegister("1IPWy", function(module, exports) {
$parcel$export(module.exports, "getPosFromRange", () => $14123162341d1c59$export$243cdddc5b21d8c1);
$parcel$export(module.exports, "createAnnotationStep", () => $14123162341d1c59$export$74899f7e5acb5cd3);

var $9Zzpd = parcelRequire("9Zzpd");

var $hYeeB = parcelRequire("hYeeB");
function $14123162341d1c59$var$getStartPos(element) {
    return parseInt(element.dataset.rendererStartPos || '-1', 10);
}
var $14123162341d1c59$var$getNodeType = function getNodeType(element) {
    return element.dataset.nodeType;
};
function $14123162341d1c59$var$isPositionPointer(element) {
    return $14123162341d1c59$var$getStartPos(element) > -1;
}
function $14123162341d1c59$var$findParent(element) {
    var parentElement = element.parentElement;
    if (!parentElement || $14123162341d1c59$export$e3140dc7d0c35e48(parentElement)) return null;
    if ($14123162341d1c59$var$isPositionPointer(parentElement)) return parentElement;
    return $14123162341d1c59$var$findParent(parentElement);
}
function $14123162341d1c59$var$findMediaParent(element) {
    var parentElement = element.parentElement;
    if (!parentElement || $14123162341d1c59$export$e3140dc7d0c35e48(parentElement)) return null;
    if (parentElement.dataset.nodeType === 'mediaSingle') return parentElement;
    return $14123162341d1c59$var$findMediaParent(parentElement);
}
function $14123162341d1c59$var$findParentBeforePointer(element) {
    var parentElement = element.parentElement;
    if ($14123162341d1c59$export$e3140dc7d0c35e48(parentElement) || !parentElement) return null;
    if ($14123162341d1c59$var$isPositionPointer(parentElement)) return element;
    return $14123162341d1c59$var$findParentBeforePointer(parentElement);
}
function $14123162341d1c59$var$isElementNode(node) {
    return node.nodeType === Node.ELEMENT_NODE;
}
function $14123162341d1c59$var$isTextNode(node) {
    return node.nodeType === Node.TEXT_NODE;
}
function $14123162341d1c59$var$isHighlightTextNode(node) {
    var _dataset;
    // Ignored via go/ees005
    // eslint-disable-next-line @atlaskit/editor/no-as-casting
    return !!(node !== null && node !== void 0 && (_dataset = node.dataset) !== null && _dataset !== void 0 && _dataset.highlighted);
}
function $14123162341d1c59$var$isNodeInlineMark(node) {
    return $14123162341d1c59$var$isElementNode(node) && Boolean(node.dataset.rendererMark);
}
function $14123162341d1c59$var$isElementInlineMark(element) {
    return !!element && Boolean(element.dataset.rendererMark);
}
function $14123162341d1c59$var$isNodeInlineTextMark(node) {
    if (node === null) return false;
    var isInlineMark = $14123162341d1c59$var$isElementNode(node) && Boolean(node.dataset.rendererMark);
    if (!isInlineMark) return false;
    /**
   * This checks if the element has any descendents with the data-inline-card
   * attribute set to 'true'. If it does, we should not consider it as an
   * inline text mark.
   **/ if ($14123162341d1c59$var$hasInlineNodeDescendant(node)) return false;
    return true;
}
/**
 * This checks all the descendents of a node and returns true if it reaches
 * a descendant with the data-inline-card attribute set to 'true'.
 */ function $14123162341d1c59$var$hasInlineNodeDescendant(node) {
    if ($14123162341d1c59$var$isElementNode(node)) {
        if ((0, $9Zzpd.fg)('editor_inline_comments_on_inline_nodes')) {
            if (node.dataset.annotationInlineNode === 'true') return true;
        } else {
            if (node.dataset.inlineCard === 'true') return true;
        }
        return Array.from(node.childNodes).some($14123162341d1c59$var$hasInlineNodeDescendant);
    }
    return false;
}
function $14123162341d1c59$var$resolveNodePos(node) {
    var resolvedPos = 0;
    var prev = node.previousSibling;
    while(prev){
        if (prev.nodeType === Node.COMMENT_NODE) {
            // Comment nodes should not result in the position being
            // incremented, so we skip them.
            prev = prev.previousSibling;
            continue;
        }
        if (prev && ($14123162341d1c59$var$isTextNode(prev) || $14123162341d1c59$var$isHighlightTextNode(prev))) resolvedPos += (prev.textContent || '').length;
        else if (prev) {
            if ((0, $9Zzpd.fg)('editor_inline_comments_on_inline_nodes')) {
                if ($14123162341d1c59$var$isNodeInlineTextMark(prev) && prev.textContent) resolvedPos += prev.textContent.length;
                else resolvedPos += 1;
            } else if ($14123162341d1c59$var$isNodeInlineMark(prev) && prev.textContent) resolvedPos += prev.textContent.length;
            else resolvedPos += 1;
        }
        prev = prev.previousSibling;
    }
    return resolvedPos;
}
function $14123162341d1c59$export$e3140dc7d0c35e48(element) {
    return !!element && element.classList.contains('ak-renderer-document');
}
function $14123162341d1c59$export$5db587db55468da7(node, offset) {
    var findEnd = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    // If the passed node doesn't exist, we should abort
    if (!node) return false;
    if ((0, $9Zzpd.fg)('editor_inline_comments_on_inline_nodes')) {
        var _node$parentElement;
        var startPosAncestor = (_node$parentElement = node.parentElement) === null || _node$parentElement === void 0 ? void 0 : _node$parentElement.closest('[data-renderer-start-pos');
        var potentialParent = (0, $9Zzpd.fg)('editor_inline_comments_on_inline_nodes') ? 'data-annotation-mark' : 'data-inline-card';
        if (startPosAncestor !== null && startPosAncestor !== void 0 && startPosAncestor.hasAttribute(potentialParent)) {
            if (findEnd) return parseInt((startPosAncestor === null || startPosAncestor === void 0 ? void 0 : startPosAncestor.getAttribute('data-renderer-start-pos')) || '-1', 10) + 1;
            else return parseInt((startPosAncestor === null || startPosAncestor === void 0 ? void 0 : startPosAncestor.getAttribute('data-renderer-start-pos')) || '-1', 10);
        }
    }
    /**
   * If anchor node is an element (e.g. after a triple click) the anchorOffset
   * is the number of child nodes preceding the anchor.
   * https://developer.mozilla.org/en-US/docs/Web/API/Selection/anchorOffset
   *
   * For end pos we calculate the number of characters by stepping through
   * each of the node's children.
   */ if (node instanceof HTMLElement && $14123162341d1c59$var$isPositionPointer(node)) {
        if (findEnd) {
            var count = $14123162341d1c59$var$getStartPos(node);
            var children = node.childNodes;
            for(var i = 0; i < offset; i++){
                var _children$i;
                count += ((_children$i = children[i]) === null || _children$i === void 0 || (_children$i = _children$i.textContent) === null || _children$i === void 0 ? void 0 : _children$i.length) || 1;
            }
            return count;
        }
        return $14123162341d1c59$var$getStartPos(node) + offset;
    }
    var parent = $14123162341d1c59$var$findParent(node);
    // Similar to above, if we cant find a parent position pointer
    // we should not proceed.
    if (!parent) return false;
    var resolvedPos = $14123162341d1c59$var$getStartPos(parent);
    var current = node;
    if (current.parentElement && current.parentElement !== parent) {
        // Find the parent element that is a direct child of the position pointer
        // the outer most element from our text position.
        var preParentPointer = $14123162341d1c59$var$findParentBeforePointer(current.parentElement);
        // If our range is inside an inline node
        // We need to move our pointers to parent element
        // since we don't want to count text inside inline nodes at all
        if ((0, $9Zzpd.fg)('editor_inline_comments_on_inline_nodes')) {
            if (!($14123162341d1c59$var$isNodeInlineTextMark(preParentPointer) || $14123162341d1c59$var$isHighlightTextNode(preParentPointer))) {
                current = current.parentElement;
                offset = 0;
            }
        } else if (!($14123162341d1c59$var$isElementInlineMark(preParentPointer) || $14123162341d1c59$var$isHighlightTextNode(preParentPointer))) {
            current = current.parentElement;
            offset = 0;
        }
        resolvedPos += $14123162341d1c59$var$resolveNodePos(current);
        while(current && current.parentElement !== parent){
            current = current.parentNode;
            if (current) {
                var nodePos = $14123162341d1c59$var$resolveNodePos(current);
                resolvedPos += nodePos;
            }
        }
    } else resolvedPos += $14123162341d1c59$var$resolveNodePos(current);
    return resolvedPos + offset;
}
function $14123162341d1c59$export$243cdddc5b21d8c1(range) {
    var startContainer = range.startContainer, startOffset = range.startOffset, endContainer = range.endContainer, endOffset = range.endOffset;
    var possibleMediaOrMediaSingleElement = $14123162341d1c59$var$findParent(startContainer);
    // Video hover targets return media single, not media, thus, the extra check in condition.
    var isMediaOrMediaSingle = possibleMediaOrMediaSingleElement && // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    /media|mediaSingle/.test($14123162341d1c59$var$getNodeType(possibleMediaOrMediaSingleElement) || '');
    if (isMediaOrMediaSingle) {
        var pos;
        var mediaSingleElement = $14123162341d1c59$var$getNodeType(possibleMediaOrMediaSingleElement) === 'mediaSingle' ? possibleMediaOrMediaSingleElement : $14123162341d1c59$var$findMediaParent(possibleMediaOrMediaSingleElement);
        if (mediaSingleElement) pos = $14123162341d1c59$var$getStartPos(mediaSingleElement);
        if (pos !== undefined) return {
            from: pos,
            to: pos
        };
    }
    var from = $14123162341d1c59$export$5db587db55468da7(startContainer, startOffset);
    var findEnd = true;
    var to = $14123162341d1c59$export$5db587db55468da7(endContainer, endOffset, findEnd);
    if (from === false || to === false) return false;
    return {
        from: from,
        to: to
    };
}
function $14123162341d1c59$export$74899f7e5acb5cd3(from, to, opts) {
    return new (0, $hYeeB.AddMarkStep)(Math.min(from, to), Math.max(from, to), opts.schema.marks.annotation.create({
        id: opts.annotationId,
        annotationType: opts.annotationType
    }));
}

});

parcelRegister("35DNJ", function(module, exports) {
$parcel$export(module.exports, "getRendererRangeInlineNodeNames", () => $2400b66c914289a7$export$b0ea72d31617ccea);
$parcel$export(module.exports, "getRendererRangeAncestorNodeNames", () => $2400b66c914289a7$export$1726c23d64498b6);

var $ht7Bg = parcelRequire("ht7Bg");

var $9Zzpd = parcelRequire("9Zzpd");
function $2400b66c914289a7$export$b0ea72d31617ccea(_ref) {
    var actions = _ref.actions, pos = _ref.pos;
    if (!(0, $9Zzpd.fg)('editor_inline_comments_on_inline_nodes')) return undefined;
    var doc = actions.doc;
    if (!pos || !doc) return undefined;
    var inlineNodeNames = (0, $ht7Bg.getRangeInlineNodeNames)({
        doc: doc,
        pos: pos
    });
    return inlineNodeNames;
}
function $2400b66c914289a7$export$1726c23d64498b6(_ref2) {
    var actions = _ref2.actions, pos = _ref2.pos;
    if (!(0, $9Zzpd.fg)('cc_comments_log_draft_annotation_ancestor_nodes')) return undefined;
    var doc = actions.doc;
    if (!pos || !doc) return undefined;
    var ancestorNodeNames = (0, $ht7Bg.getRangeAncestorNodeNames)({
        doc: doc,
        pos: pos
    });
    return ancestorNodeNames;
}

});

parcelRegister("7KUde", function(module, exports) {
$parcel$export(module.exports, "getIndexMatch", () => $5a586ee42600f998$export$fb7dab895a0d310e);
// getIndexMatch finds the position of a given string within a given document, in accordance to the Confluence Annotation backend
// The document is serialised into one large string, excluding any nodes that can not have annotations (eg: emojis, media).
// Finds where the given query string is relative to the serialised partial document
function $5a586ee42600f998$export$fb7dab895a0d310e(doc, schema, selectedText, startIndex) {
    var textContent = '';
    var matchIndex = 0;
    var numMatches = 0;
    var blockNodePos;
    doc.descendants(function(node, pos) {
        var nodeType = node.type;
        var media = schema.nodes.media;
        // Mirrors Confluence backend and doesn't construct textContent if it doesn't allow annotations
        // Don't skip media node so that block node can be defined its startIndex in within [nodeStart, nodeEnd]
        if ((node.isText || !nodeType.allowsMarkType(schema.marks.annotation)) && nodeType !== media) // Note: `return true` as a parent disallowing annotations does not mean a child disallows annotations.
        // Eg: panel (invalid) > p (valid)
        return true;
        var nodeStart = pos;
        var nodeEnd = nodeStart + node.nodeSize;
        if (startIndex >= nodeStart && startIndex <= nodeEnd) {
            // if it's a node block, set position to pos to indicate to the backend
            // that it's an annotation on a block node
            if (nodeType === media) blockNodePos = pos;
            // If the start of the annotation selection is within the current node, we scan the document for previous occurrences
            // Find the index by counting all previous instances of the selectedText in the partial textContent
            // Need to scan from start, up to `startIndex` (which includes partial of the current node)
            textContent += doc.textBetween(nodeStart, startIndex - 1);
            matchIndex = $5a586ee42600f998$export$3c2359e76fc742da(textContent, selectedText);
            // Complete appending of the node
            textContent += doc.textBetween(startIndex, nodeEnd);
        } else textContent += node.textContent;
        return true;
    });
    // Count total number of matches in final text
    numMatches = $5a586ee42600f998$export$3c2359e76fc742da(textContent, selectedText);
    return {
        numMatches: numMatches,
        matchIndex: matchIndex,
        textContent: textContent,
        blockNodePos: blockNodePos
    };
}
function $5a586ee42600f998$export$3c2359e76fc742da(searchString, query) {
    if (searchString === '' || query === '') return 0;
    // Escape characters that would trigger as syntax in a regex query before converting to the query
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    var reg = new RegExp(query.replace(/(?=[.\\+*?[^\]$(){}\|])/g, '\\'), 'g');
    return (searchString.match(reg) || []).length;
}

});






parcelRegister("ePfJP", function(module, exports) {
$parcel$export(module.exports, "AnnotationsContextWrapper", () => $acb209651792431a$export$787af8a111ff3c03);

var $5FkrB = parcelRequire("5FkrB");

var $gtPYB = parcelRequire("gtPYB");

var $mAJgs = parcelRequire("mAJgs");

var $1yLa0 = parcelRequire("1yLa0");
var $acb209651792431a$export$787af8a111ff3c03 = function AnnotationsContextWrapper(props) {
    var providers = (0, $5FkrB.useContext)((0, $gtPYB.ProvidersContext));
    var rendererRef = props.rendererRef, createAnalyticsEvent = props.createAnalyticsEvent, children = props.children;
    var inlineCommentProvider = providers && providers.inlineComment;
    var selectionComponent = inlineCommentProvider && inlineCommentProvider.selectionComponent;
    var hoverComponent = inlineCommentProvider && inlineCommentProvider.hoverComponent;
    if (!selectionComponent && !hoverComponent) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).Fragment, null, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).Fragment, null, children, !!hoverComponent && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $mAJgs.RangeValidator), {
        createAnalyticsEvent: createAnalyticsEvent,
        rendererRef: rendererRef,
        component: hoverComponent
    }), !!selectionComponent && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $1yLa0.SelectionRangeValidator), {
        createAnalyticsEvent: createAnalyticsEvent,
        rendererRef: rendererRef,
        selectionComponent: selectionComponent
    }));
};

});
parcelRegister("mAJgs", function(module, exports) {
$parcel$export(module.exports, "RangeValidator", () => $043e8bd14c222153$export$6d8376a902cb8aa7);

var $5FkrB = parcelRequire("5FkrB");

var $cxORw = parcelRequire("cxORw");

var $lMzAH = parcelRequire("lMzAH");

var $38vNc = parcelRequire("38vNc");

var $7bLYW = parcelRequire("7bLYW");
var $043e8bd14c222153$export$6d8376a902cb8aa7 = function RangeValidator(props) {
    var component = props.component, rendererRef = props.rendererRef, createAnalyticsEvent = props.createAnalyticsEvent;
    var actions = (0, $5FkrB.useContext)((0, $lMzAH.RendererContext));
    var _useAnnotationRangeDi = (0, $38vNc.useAnnotationRangeDispatch)(), clearHoverRange = _useAnnotationRangeDi.clearHoverRange;
    var _useAnnotationRangeSt = (0, $38vNc.useAnnotationRangeState)(), range = _useAnnotationRangeSt.range, type = _useAnnotationRangeSt.type;
    var _useAnnotationHoverCo = (0, $7bLYW.useAnnotationHoverContext)(), isWithinRange = _useAnnotationHoverCo.isWithinRange;
    if (!range || type !== 'hover') return null;
    var documentPosition = actions.getPositionFromRange(range);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $cxORw.Mounter), {
        isWithinRange: isWithinRange,
        range: range,
        wrapperDOM: rendererRef,
        component: component,
        onClose: clearHoverRange,
        documentPosition: documentPosition,
        isAnnotationAllowed: true,
        applyAnnotation: actions.applyAnnotation.bind(actions),
        generateIndexMatch: actions.generateAnnotationIndexMatch.bind(actions),
        createAnalyticsEvent: createAnalyticsEvent
    });
};
$043e8bd14c222153$export$6d8376a902cb8aa7.displayName = 'HoverRangeValidator';

});
parcelRegister("cxORw", function(module, exports) {
$parcel$export(module.exports, "Mounter", () => $92200545d098e80e$export$2109cd350bcf6eda);

var $5FkrB = parcelRequire("5FkrB");

var $kX1mK = parcelRequire("kX1mK");

var $eyRpM = parcelRequire("eyRpM");

var $2H1dZ = parcelRequire("2H1dZ");

var $jJH6F = parcelRequire("jJH6F");

var $lMzAH = parcelRequire("lMzAH");

var $38vNc = parcelRequire("38vNc");
var $92200545d098e80e$export$2109cd350bcf6eda = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).memo(function(props) {
    var Component = props.component, range = props.range, isWithinRange = props.isWithinRange, isAnnotationAllowed = props.isAnnotationAllowed, wrapperDOM = props.wrapperDOM, onCloseProps = props.onClose, documentPosition = props.documentPosition, applyAnnotation = props.applyAnnotation, createAnalyticsEvent = props.createAnalyticsEvent, generateIndexMatch = props.generateIndexMatch;
    var _useAnnotationRangeDi = (0, $38vNc.useAnnotationRangeDispatch)(), promoteHoverToDraft = _useAnnotationRangeDi.promoteHoverToDraft, clearHoverDraft = _useAnnotationRangeDi.clearHoverDraft;
    var _useAnnotationRangeSt = (0, $38vNc.useAnnotationRangeState)(), hoverDraftDocumentPosition = _useAnnotationRangeSt.hoverDraftDocumentPosition;
    var actions = (0, $5FkrB.useContext)((0, $lMzAH.RendererContext));
    var onCreateCallback = (0, $5FkrB.useCallback)(function(annotationId) {
        var positionToAnnotate = hoverDraftDocumentPosition || documentPosition;
        if (!isAnnotationAllowed || !positionToAnnotate || !applyAnnotation) return false;
        var annotation = {
            annotationId: annotationId,
            annotationType: (0, $kX1mK.AnnotationTypes).INLINE_COMMENT
        };
        if (createAnalyticsEvent) createAnalyticsEvent({
            action: (0, $jJH6F.ACTION).INSERTED,
            actionSubject: (0, $jJH6F.ACTION_SUBJECT).ANNOTATION,
            actionSubjectId: (0, $jJH6F.ACTION_SUBJECT_ID).INLINE_COMMENT,
            attributes: {},
            eventType: (0, $jJH6F.EVENT_TYPE).TRACK
        }).fire((0, $2H1dZ.FabricChannel).editor);
        return applyAnnotation(positionToAnnotate, annotation);
    }, [
        isAnnotationAllowed,
        documentPosition,
        applyAnnotation,
        createAnalyticsEvent,
        hoverDraftDocumentPosition
    ]);
    var createIndexCallback = (0, $5FkrB.useCallback)(function() {
        if (!documentPosition || !generateIndexMatch) return false;
        var result = generateIndexMatch(documentPosition);
        if (!result) return false;
        return result;
    }, [
        documentPosition,
        generateIndexMatch
    ]);
    var applyDraftModeCallback = (0, $5FkrB.useCallback)(function(options) {
        if (!documentPosition || !isAnnotationAllowed) {
            if (createAnalyticsEvent) createAnalyticsEvent({
                action: (0, $jJH6F.ACTION).CREATE_NOT_ALLOWED,
                actionSubject: (0, $jJH6F.ACTION_SUBJECT).ANNOTATION,
                actionSubjectId: (0, $jJH6F.ACTION_SUBJECT_ID).INLINE_COMMENT,
                attributes: {
                    documentPosition: documentPosition,
                    isAnnotationAllowed: isAnnotationAllowed
                },
                eventType: (0, $jJH6F.EVENT_TYPE).TRACK
            }).fire((0, $2H1dZ.FabricChannel).editor);
            return false;
        }
        promoteHoverToDraft(documentPosition);
        if (createAnalyticsEvent) {
            var uniqueAnnotationsInRange = actions.getAnnotationsByPosition(range);
            createAnalyticsEvent({
                action: (0, $jJH6F.ACTION).OPENED,
                actionSubject: (0, $jJH6F.ACTION_SUBJECT).ANNOTATION,
                actionSubjectId: (0, $jJH6F.ACTION_SUBJECT_ID).INLINE_COMMENT,
                eventType: (0, $jJH6F.EVENT_TYPE).TRACK,
                attributes: {
                    overlap: uniqueAnnotationsInRange.length
                }
            }).fire((0, $2H1dZ.FabricChannel).editor);
        }
        window.requestAnimationFrame(function() {
            if (options.keepNativeSelection) (0, $eyRpM.updateWindowSelectionAroundDraft)(documentPosition);
            else {
                var sel = window.getSelection();
                if (sel) sel.removeAllRanges();
            }
        });
        var positionToAnnotate = hoverDraftDocumentPosition || documentPosition;
        if (!positionToAnnotate || !applyAnnotation || !options.annotationId) {
            if (createAnalyticsEvent) createAnalyticsEvent({
                action: (0, $jJH6F.ACTION).CREATE_NOT_ALLOWED,
                actionSubject: (0, $jJH6F.ACTION_SUBJECT).ANNOTATION,
                actionSubjectId: (0, $jJH6F.ACTION_SUBJECT_ID).INLINE_COMMENT,
                attributes: {
                    positionToAnnotate: positionToAnnotate,
                    applyAnnotationMissing: !applyAnnotation,
                    annotationId: options.annotationId
                },
                eventType: (0, $jJH6F.EVENT_TYPE).TRACK
            }).fire((0, $2H1dZ.FabricChannel).editor);
            return false;
        }
        var annotation = {
            annotationId: options.annotationId,
            annotationType: (0, $kX1mK.AnnotationTypes).INLINE_COMMENT
        };
        return applyAnnotation(positionToAnnotate, annotation);
    }, [
        documentPosition,
        isAnnotationAllowed,
        createAnalyticsEvent,
        applyAnnotation,
        actions,
        range,
        promoteHoverToDraft,
        hoverDraftDocumentPosition
    ]);
    var removeDraftModeCallback = (0, $5FkrB.useCallback)(function() {
        clearHoverDraft();
        var sel = window.getSelection();
        if (sel) sel.removeAllRanges();
    }, [
        clearHoverDraft
    ]);
    var onCloseCallback = (0, $5FkrB.useCallback)(function() {
        if (createAnalyticsEvent) createAnalyticsEvent({
            action: (0, $jJH6F.ACTION).CLOSED,
            actionSubject: (0, $jJH6F.ACTION_SUBJECT).ANNOTATION,
            actionSubjectId: (0, $jJH6F.ACTION_SUBJECT_ID).INLINE_COMMENT,
            eventType: (0, $jJH6F.EVENT_TYPE).TRACK,
            attributes: {}
        }).fire((0, $2H1dZ.FabricChannel).editor);
        removeDraftModeCallback();
        onCloseProps();
    }, [
        onCloseProps,
        removeDraftModeCallback,
        createAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(Component, {
        range: range,
        isWithinRange: isWithinRange,
        wrapperDOM: wrapperDOM.current,
        isAnnotationAllowed: isAnnotationAllowed,
        onClose: onCloseCallback,
        onCreate: onCreateCallback,
        getAnnotationIndexMatch: createIndexCallback,
        applyDraftMode: applyDraftModeCallback,
        removeDraftMode: removeDraftModeCallback
    });
});

});
parcelRegister("eyRpM", function(module, exports) {
$parcel$export(module.exports, "dataAttributes", () => $a99dacbc9874dca0$export$15d6ddc168d35719);
$parcel$export(module.exports, "updateWindowSelectionAroundDraft", () => $a99dacbc9874dca0$export$e14699d956e87e73);

var $iYJcE = parcelRequire("iYJcE");

var $25nEq = parcelRequire("25nEq");
var $a99dacbc9874dca0$export$15d6ddc168d35719 = function dataAttributes(_ref) {
    var from = _ref.from, to = _ref.to;
    return (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, 'data-annotation-draft-mark', true), 'data-draft-start-at', from), 'data-draft-end-at', to);
};
var $a99dacbc9874dca0$var$buildDataAttributesQuery = function buildDataAttributesQuery(pos) {
    var a = $a99dacbc9874dca0$export$15d6ddc168d35719(pos);
    return Object.entries(a).map(function(_ref3) {
        var _ref4 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_ref3, 2), k = _ref4[0], v = _ref4[1];
        return "[".concat(k, "=\"").concat(v, "\"]");
    }).join('');
};
var $a99dacbc9874dca0$export$e14699d956e87e73 = function updateWindowSelectionAroundDraft(pos) {
    var sel = window.getSelection();
    if (!sel) return false;
    var draftNodes = document.querySelectorAll($a99dacbc9874dca0$var$buildDataAttributesQuery(pos));
    if (!draftNodes || draftNodes.length === 0) return false;
    sel.removeAllRanges();
    var range = document.createRange();
    range.setStart(draftNodes[0], 0);
    range.setEndAfter(draftNodes[draftNodes.length - 1]);
    sel.addRange(range);
    return true;
};

});

parcelRegister("38vNc", function(module, exports) {
$parcel$export(module.exports, "AnnotationRangeProvider", () => $248ac7c5d12222d0$export$30384a6aedd19fee);
$parcel$export(module.exports, "useAnnotationRangeState", () => $248ac7c5d12222d0$export$e07ee6d6cc95d9a0);
$parcel$export(module.exports, "useAnnotationRangeDispatch", () => $248ac7c5d12222d0$export$708fc397e2b6f08d);

var $iYJcE = parcelRequire("iYJcE");

var $25nEq = parcelRequire("25nEq");

var $5FkrB = parcelRequire("5FkrB");
function $248ac7c5d12222d0$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $248ac7c5d12222d0$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $248ac7c5d12222d0$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $248ac7c5d12222d0$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $248ac7c5d12222d0$var$initialState = {
    type: null,
    selectionRange: null,
    hoverRange: null,
    selectionDraftRange: null,
    hoverDraftRange: null,
    selectionDraftDocumentPosition: null,
    hoverDraftDocumentPosition: null
};
function $248ac7c5d12222d0$var$reducer(state, action) {
    switch(action.type){
        case 'clearSelection':
            if (state.selectionRange !== null) return $248ac7c5d12222d0$var$_objectSpread($248ac7c5d12222d0$var$_objectSpread({}, state), {}, {
                selectionRange: null,
                type: state.type === 'selection' ? null : state.type
            });
            return state;
        case 'clearHover':
            if (state.hoverRange !== null) return $248ac7c5d12222d0$var$_objectSpread($248ac7c5d12222d0$var$_objectSpread({}, state), {}, {
                hoverRange: null,
                type: state.type === 'hover' ? null : state.type
            });
            return state;
        case 'setSelection':
            if (state.selectionRange !== action.range) return $248ac7c5d12222d0$var$_objectSpread($248ac7c5d12222d0$var$_objectSpread({}, state), {}, {
                selectionRange: action.range,
                type: 'selection'
            });
            return state;
        case 'setHover':
            if (state.hoverRange !== action.range) return $248ac7c5d12222d0$var$_objectSpread($248ac7c5d12222d0$var$_objectSpread({}, state), {}, {
                hoverRange: action.range,
                type: 'hover'
            });
            return state;
        case 'promoteSelectionToDraft':
            // we should only promote the range to a draft if the current range type is a selection
            // we should also store the promotion type, so that a clear will not accidently clear the draft of a
            // different type
            if (state.selectionDraftRange !== state.selectionRange) return $248ac7c5d12222d0$var$_objectSpread($248ac7c5d12222d0$var$_objectSpread({}, state), {}, {
                selectionRange: null,
                type: state.type === 'selection' ? null : state.type,
                selectionDraftRange: state.selectionRange,
                selectionDraftDocumentPosition: action.position
            });
            return state;
        case 'promoteHoverToDraft':
            if (state.hoverDraftRange !== state.hoverRange) return $248ac7c5d12222d0$var$_objectSpread($248ac7c5d12222d0$var$_objectSpread({}, state), {}, {
                hoverRange: null,
                type: state.type === 'hover' ? null : state.type,
                hoverDraftRange: state.hoverRange,
                hoverDraftDocumentPosition: action.position
            });
            return state;
        case 'clearSelectionDraft':
            if (state.selectionDraftRange !== null) return $248ac7c5d12222d0$var$_objectSpread($248ac7c5d12222d0$var$_objectSpread({}, state), {}, {
                selectionDraftRange: null,
                selectionDraftDocumentPosition: null
            });
            return state;
        case 'clearHoverDraft':
            if (state.hoverDraftRange !== null) return $248ac7c5d12222d0$var$_objectSpread($248ac7c5d12222d0$var$_objectSpread({}, state), {}, {
                hoverDraftRange: null,
                hoverDraftDocumentPosition: null
            });
            return state;
    }
}
var $248ac7c5d12222d0$export$145b9bb655c3d220 = /*#__PURE__*/ (0, $5FkrB.createContext)({
    range: null,
    type: null,
    selectionDraftRange: null,
    hoverDraftRange: null,
    selectionDraftDocumentPosition: null,
    hoverDraftDocumentPosition: null
});
var $248ac7c5d12222d0$export$efb0d1c8cbaac647 = /*#__PURE__*/ (0, $5FkrB.createContext)({
    clearSelectionRange: function clearSelectionRange() {},
    clearHoverRange: function clearHoverRange() {},
    setSelectionRange: function setSelectionRange() {},
    promoteSelectionToDraft: function promoteSelectionToDraft() {},
    promoteHoverToDraft: function promoteHoverToDraft() {},
    clearSelectionDraft: function clearSelectionDraft() {},
    clearHoverDraft: function clearHoverDraft() {}
});
var $248ac7c5d12222d0$export$7cf774ce920e4bbd = function AnnotationRangeProviderInner(_ref) {
    var children = _ref.children, allowCommentsOnMedia = _ref.allowCommentsOnMedia;
    var _useReducer = (0, $5FkrB.useReducer)($248ac7c5d12222d0$var$reducer, $248ac7c5d12222d0$var$initialState), _useReducer2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useReducer, 2), _useReducer2$ = _useReducer2[0], selectionRange = _useReducer2$.selectionRange, hoverRange = _useReducer2$.hoverRange, type = _useReducer2$.type, selectionDraftRange = _useReducer2$.selectionDraftRange, selectionDraftDocumentPosition = _useReducer2$.selectionDraftDocumentPosition, hoverDraftRange = _useReducer2$.hoverDraftRange, hoverDraftDocumentPosition = _useReducer2$.hoverDraftDocumentPosition, dispatch = _useReducer2[1];
    var clearSelectionRange = (0, $5FkrB.useCallback)(function() {
        return dispatch({
            type: 'clearSelection'
        });
    }, []);
    var clearHoverRange = (0, $5FkrB.useCallback)(function() {
        return dispatch({
            type: 'clearHover'
        });
    }, []);
    var setSelectionRange = (0, $5FkrB.useCallback)(function(range) {
        return dispatch({
            type: 'setSelection',
            range: range
        });
    }, []);
    var setHoverTarget = (0, $5FkrB.useCallback)(function(target) {
        // the HoverComponent expects an element deeply nested inside media, these classes work with the current implementation
        var mediaNode = target.querySelector('.media-card-inline-player, .media-file-card-view');
        if (!mediaNode) return;
        var range = document.createRange();
        range.setStartBefore(mediaNode);
        range.setEndAfter(mediaNode);
        dispatch({
            type: 'setHover',
            range: range
        });
    }, []);
    var promoteSelectionToDraft = (0, $5FkrB.useCallback)(function(position) {
        dispatch({
            type: 'promoteSelectionToDraft',
            position: position
        });
    }, []);
    var clearSelectionDraft = (0, $5FkrB.useCallback)(function() {
        dispatch({
            type: 'clearSelectionDraft'
        });
    }, []);
    var promoteHoverToDraft = (0, $5FkrB.useCallback)(function(position) {
        dispatch({
            type: 'promoteHoverToDraft',
            position: position
        });
    }, []);
    var clearHoverDraft = (0, $5FkrB.useCallback)(function() {
        dispatch({
            type: 'clearHoverDraft'
        });
    }, []);
    var stateData = (0, $5FkrB.useMemo)(function() {
        return {
            // We techinically have two ranges, however we only want to expose one of them at a time, because only one draft
            // can be active at a time. The type of range is used to determine which range is active.
            range: type === 'selection' ? selectionRange : hoverRange,
            type: type,
            selectionDraftRange: selectionDraftRange,
            hoverDraftRange: hoverDraftRange,
            selectionDraftDocumentPosition: selectionDraftDocumentPosition,
            hoverDraftDocumentPosition: hoverDraftDocumentPosition
        };
    }, [
        selectionRange,
        hoverRange,
        type,
        selectionDraftRange,
        selectionDraftDocumentPosition,
        hoverDraftRange,
        hoverDraftDocumentPosition
    ]);
    var dispatchData = (0, $5FkrB.useMemo)(function() {
        return {
            clearSelectionRange: clearSelectionRange,
            clearHoverRange: clearHoverRange,
            setSelectionRange: setSelectionRange,
            setHoverTarget: !!allowCommentsOnMedia ? setHoverTarget : undefined,
            promoteSelectionToDraft: promoteSelectionToDraft,
            promoteHoverToDraft: promoteHoverToDraft,
            clearSelectionDraft: clearSelectionDraft,
            clearHoverDraft: clearHoverDraft
        };
    }, [
        allowCommentsOnMedia,
        clearSelectionRange,
        clearHoverRange,
        setSelectionRange,
        setHoverTarget,
        promoteSelectionToDraft,
        promoteHoverToDraft,
        clearSelectionDraft,
        clearHoverDraft
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement($248ac7c5d12222d0$export$145b9bb655c3d220.Provider, {
        value: stateData
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement($248ac7c5d12222d0$export$efb0d1c8cbaac647.Provider, {
        value: dispatchData
    }, children));
};
var $248ac7c5d12222d0$export$30384a6aedd19fee = function AnnotationRangeProvider(_ref2) {
    var children = _ref2.children, allowCommentsOnMedia = _ref2.allowCommentsOnMedia, isNestedRender = _ref2.isNestedRender;
    /*
   * If this is a nested render, we do not provide the context
   * because it has already been provided higher up the component tree
   * and we need the original context to create annotations on extensions.
   */ return isNestedRender ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).Fragment, null, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement($248ac7c5d12222d0$export$7cf774ce920e4bbd, {
        allowCommentsOnMedia: allowCommentsOnMedia
    }, children);
};
var $248ac7c5d12222d0$export$e07ee6d6cc95d9a0 = function useAnnotationRangeState() {
    return (0, $5FkrB.useContext)($248ac7c5d12222d0$export$145b9bb655c3d220);
};
var $248ac7c5d12222d0$export$708fc397e2b6f08d = function useAnnotationRangeDispatch() {
    return (0, $5FkrB.useContext)($248ac7c5d12222d0$export$efb0d1c8cbaac647);
};

});


parcelRegister("7bLYW", function(module, exports) {
$parcel$export(module.exports, "AnnotationHoverContext", () => $53bec7b5a0d2c17a$export$b3db0feb20552fc3);
$parcel$export(module.exports, "useAnnotationHoverContext", () => $53bec7b5a0d2c17a$export$a02bfcbbbf920306);
$parcel$export(module.exports, "useAnnotationHoverDispatch", () => $53bec7b5a0d2c17a$export$c288883964405c82);

var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");
var $53bec7b5a0d2c17a$var$AnnotationHoverStateContext = /*#__PURE__*/ (0, $5FkrB.createContext)({
    isWithinRange: false
});
var $53bec7b5a0d2c17a$var$AnnotationHoverDispatchContext = /*#__PURE__*/ (0, $5FkrB.createContext)({
    cancelTimeout: function cancelTimeout() {},
    initiateTimeout: function initiateTimeout() {},
    setIsWithinRange: function setIsWithinRange() {}
});
var $53bec7b5a0d2c17a$export$b3db0feb20552fc3 = function AnnotationHoverContext(_ref) {
    var children = _ref.children;
    var _useState = (0, $5FkrB.useState)(false), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), isWithinRange = _useState2[0], setIsWithinRange = _useState2[1];
    var timeoutHandler = (0, $5FkrB.useRef)();
    var cancelTimeout = (0, $5FkrB.useCallback)(function() {
        if (timeoutHandler) clearTimeout(timeoutHandler.current);
    }, [
        timeoutHandler
    ]);
    var initiateTimeout = (0, $5FkrB.useCallback)(function() {
        if (isWithinRange) timeoutHandler.current = setTimeout(function() {
            setIsWithinRange(false);
        }, 500);
    }, [
        isWithinRange
    ]);
    var stateData = (0, $5FkrB.useMemo)(function() {
        return {
            isWithinRange: isWithinRange
        };
    }, [
        isWithinRange
    ]);
    var dispatchData = (0, $5FkrB.useMemo)(function() {
        return {
            cancelTimeout: cancelTimeout,
            initiateTimeout: initiateTimeout,
            setIsWithinRange: setIsWithinRange
        };
    }, [
        cancelTimeout,
        initiateTimeout,
        setIsWithinRange
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement($53bec7b5a0d2c17a$var$AnnotationHoverStateContext.Provider, {
        value: stateData
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement($53bec7b5a0d2c17a$var$AnnotationHoverDispatchContext.Provider, {
        value: dispatchData
    }, children));
};
var $53bec7b5a0d2c17a$export$a02bfcbbbf920306 = function useAnnotationHoverContext() {
    return (0, $5FkrB.useContext)($53bec7b5a0d2c17a$var$AnnotationHoverStateContext);
};
var $53bec7b5a0d2c17a$export$c288883964405c82 = function useAnnotationHoverDispatch() {
    return (0, $5FkrB.useContext)($53bec7b5a0d2c17a$var$AnnotationHoverDispatchContext);
};

});


parcelRegister("1yLa0", function(module, exports) {
$parcel$export(module.exports, "SelectionRangeValidator", () => $122d8c7ce0dee5eb$export$74435b85e23b84d9);

var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");

var $lWfP7 = parcelRequire("lWfP7");

var $hSqHE = parcelRequire("hSqHE");

var $lMzAH = parcelRequire("lMzAH");
var $122d8c7ce0dee5eb$export$74435b85e23b84d9 = function SelectionRangeValidator(props) {
    var selectionComponent = props.selectionComponent, rendererRef = props.rendererRef, createAnalyticsEvent = props.createAnalyticsEvent;
    var actions = (0, $5FkrB.useContext)((0, $lMzAH.RendererContext));
    var _useUserSelectionRang = (0, $lWfP7.useUserSelectionRange)({
        rendererRef: rendererRef
    }), _useUserSelectionRang2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useUserSelectionRang, 4), type = _useUserSelectionRang2[0], range = _useUserSelectionRang2[1], draftRange = _useUserSelectionRang2[2], clearRange = _useUserSelectionRang2[3];
    var selectionRange = type === 'selection' ? range : null;
    // !!! the draft range will become invalid after the mark DOM is inserted
    if (!selectionRange && !draftRange) return null;
    var documentPosition = actions.getPositionFromRange(range);
    // This property is drilled down to consumers when a new range is selected to test it's validity
    var isAnnotationAllowedOnRange = false;
    try {
        isAnnotationAllowedOnRange = documentPosition && actions.isValidAnnotationPosition(documentPosition);
    } catch (_unused) {
        isAnnotationAllowedOnRange = false;
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $hSqHE.SelectionInlineCommentMounter), {
        range: selectionRange,
        draftRange: draftRange,
        wrapperDOM: rendererRef,
        component: selectionComponent,
        onClose: clearRange,
        documentPosition: documentPosition,
        isAnnotationAllowed: isAnnotationAllowedOnRange,
        applyAnnotation: actions.applyAnnotation.bind(actions),
        generateIndexMatch: actions.generateAnnotationIndexMatch.bind(actions),
        createAnalyticsEvent: createAnalyticsEvent
    });
};
$122d8c7ce0dee5eb$export$74435b85e23b84d9.displayName = 'SelectionRangeValidator';

});
parcelRegister("lWfP7", function(module, exports) {
$parcel$export(module.exports, "useUserSelectionRange", () => $ff8b49f4191e9037$export$47201332e612f5a4);

var $5FkrB = parcelRequire("5FkrB");

var $38vNc = parcelRequire("38vNc");

var $8aXvJ = parcelRequire("8aXvJ");

var $fDwDe = parcelRequire("fDwDe");
var $ff8b49f4191e9037$export$47201332e612f5a4 = function useUserSelectionRange(props) {
    var rendererDOM = props.rendererRef.current;
    var selectionTimeoutRef = (0, $5FkrB.useRef)();
    var _useAnnotationRangeDi = (0, $38vNc.useAnnotationRangeDispatch)(), clearSelectionRange = _useAnnotationRangeDi.clearSelectionRange, setSelectionRange = _useAnnotationRangeDi.setSelectionRange;
    var _useAnnotationRangeSt = (0, $38vNc.useAnnotationRangeState)(), range = _useAnnotationRangeSt.range, type = _useAnnotationRangeSt.type, selectionDraftRange = _useAnnotationRangeSt.selectionDraftRange;
    var _useAnnotationManager = (0, $fDwDe.useAnnotationManagerDispatch)(), annotationManager = _useAnnotationManager.annotationManager;
    var lastRangeRef = (0, $5FkrB.useRef)(null);
    var isAnnotationManagerEnabled = !!annotationManager;
    var onSelectionChange = (0, $5FkrB.useCallback)(function(_event) {
        if (selectionTimeoutRef.current) clearTimeout(selectionTimeoutRef.current);
        selectionTimeoutRef.current = setTimeout(function() {
            var sel = document.getSelection();
            if (!sel || sel.type !== 'Range' || sel.rangeCount !== 1) {
                lastRangeRef.current = null; // Clear last range if selection is invalid
                if (isAnnotationManagerEnabled) clearSelectionRange();
                return;
            }
            var _range = sel.getRangeAt(0);
            // Skip if the selection hasn't changed
            if (lastRangeRef.current && _range.compareBoundaryPoints(Range.START_TO_START, lastRangeRef.current) === 0 && _range.compareBoundaryPoints(Range.END_TO_END, lastRangeRef.current) === 0) return;
            if (rendererDOM && (0, $8aXvJ.isRangeInsideOfRendererContainer)(rendererDOM, _range)) {
                var _range2 = _range, startContainer = _range2.startContainer, endContainer = _range2.endContainer;
                var isTripleClick = endContainer.nodeType !== Node.TEXT_NODE;
                if (isTripleClick) {
                    var p = startContainer;
                    while(p && p.nodeName !== 'P' && p !== rendererDOM)p = p.parentNode;
                    if (p && p.nodeName === 'P' && p instanceof Element) {
                        var _range3 = document.createRange();
                        _range3.selectNodeContents(p);
                        sel.removeAllRanges();
                        sel.addRange(_range3);
                        _range = sel.getRangeAt(0);
                    }
                }
                setSelectionRange(_range.cloneRange());
                lastRangeRef.current = _range;
            }
        }, 100);
    }, [
        rendererDOM,
        setSelectionRange,
        clearSelectionRange,
        isAnnotationManagerEnabled
    ]);
    (0, $5FkrB.useEffect)(function() {
        if (!document || !rendererDOM) return;
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        document.addEventListener('selectionchange', onSelectionChange);
        return function() {
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.removeEventListener('selectionchange', onSelectionChange);
            clearSelectionRange();
        };
    }, [
        rendererDOM,
        onSelectionChange,
        clearSelectionRange
    ]);
    return [
        type,
        range,
        selectionDraftRange,
        clearSelectionRange
    ];
};

});
parcelRegister("8aXvJ", function(module, exports) {
$parcel$export(module.exports, "isRangeInsideOfRendererContainer", () => $5f3d6b826ccb6432$export$90ee8f2d9317f430);
/** Exists in its own module to allow mocking in unit tests */ var $5f3d6b826ccb6432$export$90ee8f2d9317f430 = function isRangeInsideOfRendererContainer(rendererDOM, range) {
    var sourceRange = document.createRange();
    sourceRange.selectNode(rendererDOM);
    var isSelectionStartsAfterRenderer = range.compareBoundaryPoints(Range.START_TO_START, sourceRange) === 1;
    var isSelectionStartsBeforeRenderer = range.compareBoundaryPoints(Range.START_TO_END, sourceRange) === 1;
    var isSelectionEndsAfterRenderer = range.compareBoundaryPoints(Range.END_TO_END, sourceRange) === 1;
    return isSelectionStartsAfterRenderer && isSelectionStartsBeforeRenderer && !isSelectionEndsAfterRenderer;
};

});


parcelRegister("hSqHE", function(module, exports) {
$parcel$export(module.exports, "SelectionInlineCommentMounter", () => $d03c317538671a16$export$ca7741472ed8ba00);

var $5FkrB = parcelRequire("5FkrB");

var $6JfQX = parcelRequire("6JfQX");

var $kX1mK = parcelRequire("kX1mK");

var $9Zzpd = parcelRequire("9Zzpd");

var $eyRpM = parcelRequire("eyRpM");

var $2H1dZ = parcelRequire("2H1dZ");

var $jJH6F = parcelRequire("jJH6F");

var $35DNJ = parcelRequire("35DNJ");

var $lMzAH = parcelRequire("lMzAH");

var $fDwDe = parcelRequire("fDwDe");

var $38vNc = parcelRequire("38vNc");
var $d03c317538671a16$export$ca7741472ed8ba00 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).memo(function(props) {
    var Component = props.component, range = props.range, draftRange = props.draftRange, isAnnotationAllowed = props.isAnnotationAllowed, wrapperDOM = props.wrapperDOM, onCloseProps = props.onClose, documentPosition = props.documentPosition, applyAnnotation = props.applyAnnotation, createAnalyticsEvent = props.createAnalyticsEvent, generateIndexMatch = props.generateIndexMatch;
    var _useAnnotationRangeDi = (0, $38vNc.useAnnotationRangeDispatch)(), promoteSelectionToDraft = _useAnnotationRangeDi.promoteSelectionToDraft, clearSelectionDraft = _useAnnotationRangeDi.clearSelectionDraft;
    var _useAnnotationRangeSt = (0, $38vNc.useAnnotationRangeState)(), selectionDraftDocumentPosition = _useAnnotationRangeSt.selectionDraftDocumentPosition;
    var actions = (0, $5FkrB.useContext)((0, $lMzAH.RendererContext));
    var _useAnnotationManager = (0, $fDwDe.useAnnotationManagerState)(), isDrafting = _useAnnotationManager.isDrafting, draftId = _useAnnotationManager.draftId;
    var _useAnnotationManager2 = (0, $fDwDe.useAnnotationManagerDispatch)(), annotationManager = _useAnnotationManager2.annotationManager, dispatch = _useAnnotationManager2.dispatch;
    var inlineNodeTypes = (0, $5FkrB.useMemo)(function() {
        if (!actions.isRangeAnnotatable(range)) return undefined;
        return (0, $35DNJ.getRendererRangeInlineNodeNames)({
            pos: documentPosition,
            actions: actions
        });
    }, [
        documentPosition,
        actions,
        range
    ]);
    var onCreateCallback = (0, $5FkrB.useCallback)(function(annotationId) {
        // We want to support creation on a documentPosition if the user is only using ranges
        // but we want to prioritize draft positions if they are being used by consumers
        // !!! at this point, the documentPosition can be the wrong position if the user select something else
        var positionToAnnotate = selectionDraftDocumentPosition || documentPosition;
        if (!positionToAnnotate || !applyAnnotation) return false;
        // Evaluate position validity when the user commits the position to be annotated
        var isCreateAllowedOnPosition = actions.isValidAnnotationPosition(positionToAnnotate);
        if (!isCreateAllowedOnPosition) return false;
        var annotation = {
            annotationId: annotationId,
            annotationType: (0, $kX1mK.AnnotationTypes).INLINE_COMMENT
        };
        if (createAnalyticsEvent) createAnalyticsEvent({
            action: (0, $jJH6F.ACTION).INSERTED,
            actionSubject: (0, $jJH6F.ACTION_SUBJECT).ANNOTATION,
            actionSubjectId: (0, $jJH6F.ACTION_SUBJECT_ID).INLINE_COMMENT,
            attributes: {
                inlineNodeNames: inlineNodeTypes
            },
            eventType: (0, $jJH6F.EVENT_TYPE).TRACK
        }).fire((0, $2H1dZ.FabricChannel).editor);
        return applyAnnotation(positionToAnnotate, annotation);
    }, [
        actions,
        documentPosition,
        applyAnnotation,
        createAnalyticsEvent,
        inlineNodeTypes,
        selectionDraftDocumentPosition
    ]);
    var createIndexCallback = (0, $5FkrB.useCallback)(function() {
        if (!documentPosition || !generateIndexMatch) return false;
        var result = generateIndexMatch(documentPosition);
        if (!result) return false;
        return result;
    }, [
        documentPosition,
        generateIndexMatch
    ]);
    var applyDraftModeCallback = (0, $5FkrB.useCallback)(function(options) {
        if (!documentPosition || !isAnnotationAllowed) {
            if (createAnalyticsEvent) createAnalyticsEvent({
                action: (0, $jJH6F.ACTION).CREATE_NOT_ALLOWED,
                actionSubject: (0, $jJH6F.ACTION_SUBJECT).ANNOTATION,
                actionSubjectId: (0, $jJH6F.ACTION_SUBJECT_ID).INLINE_COMMENT,
                attributes: {
                    inlineNodeNames: inlineNodeTypes,
                    documentPosition: documentPosition,
                    isAnnotationAllowed: isAnnotationAllowed
                },
                eventType: (0, $jJH6F.EVENT_TYPE).TRACK
            }).fire((0, $2H1dZ.FabricChannel).editor);
            return false;
        }
        promoteSelectionToDraft(documentPosition);
        if (createAnalyticsEvent) {
            var uniqueAnnotationsInRange = range ? actions.getAnnotationsByPosition(range) : [];
            createAnalyticsEvent({
                action: (0, $jJH6F.ACTION).OPENED,
                actionSubject: (0, $jJH6F.ACTION_SUBJECT).ANNOTATION,
                actionSubjectId: (0, $jJH6F.ACTION_SUBJECT_ID).INLINE_COMMENT,
                eventType: (0, $jJH6F.EVENT_TYPE).TRACK,
                attributes: {
                    overlap: uniqueAnnotationsInRange.length,
                    inlineNodeNames: inlineNodeTypes
                }
            }).fire((0, $2H1dZ.FabricChannel).editor);
        }
        window.requestAnimationFrame(function() {
            if (options.keepNativeSelection) (0, $eyRpM.updateWindowSelectionAroundDraft)(documentPosition);
            else {
                var sel = window.getSelection();
                if (sel) sel.removeAllRanges();
            }
        });
        // at this point, the documentPosition is the position that the user has selected,
        // not the selectionDraftDocumentPosition
        // because the documentPosition is not promoted to selectionDraftDocumentPosition yet
        // use platform_editor_comments_api_manager here so we can clear the code path when the flag is removed
        var positionToAnnotate = (0, $9Zzpd.fg)('platform_editor_comments_api_manager') ? documentPosition : selectionDraftDocumentPosition || documentPosition;
        if (!positionToAnnotate || !applyAnnotation || !options.annotationId) {
            if (createAnalyticsEvent) createAnalyticsEvent({
                action: (0, $jJH6F.ACTION).CREATE_NOT_ALLOWED,
                actionSubject: (0, $jJH6F.ACTION_SUBJECT).ANNOTATION,
                actionSubjectId: (0, $jJH6F.ACTION_SUBJECT_ID).INLINE_COMMENT,
                attributes: {
                    positionToAnnotate: positionToAnnotate,
                    applyAnnotationMissing: !applyAnnotation,
                    annotationId: options.annotationId
                },
                eventType: (0, $jJH6F.EVENT_TYPE).TRACK
            }).fire((0, $2H1dZ.FabricChannel).editor);
            return false;
        }
        var annotation = {
            annotationId: options.annotationId,
            annotationType: (0, $kX1mK.AnnotationTypes).INLINE_COMMENT
        };
        return applyAnnotation(positionToAnnotate, annotation);
    }, [
        documentPosition,
        isAnnotationAllowed,
        createAnalyticsEvent,
        applyAnnotation,
        actions,
        range,
        inlineNodeTypes,
        promoteSelectionToDraft,
        selectionDraftDocumentPosition
    ]);
    var removeDraftModeCallback = (0, $5FkrB.useCallback)(function() {
        clearSelectionDraft();
        var sel = window.getSelection();
        if (sel) sel.removeAllRanges();
    }, [
        clearSelectionDraft
    ]);
    var onCloseCallback = (0, $5FkrB.useCallback)(function() {
        if (createAnalyticsEvent) createAnalyticsEvent({
            action: (0, $jJH6F.ACTION).CLOSED,
            actionSubject: (0, $jJH6F.ACTION_SUBJECT).ANNOTATION,
            actionSubjectId: (0, $jJH6F.ACTION_SUBJECT_ID).INLINE_COMMENT,
            eventType: (0, $jJH6F.EVENT_TYPE).TRACK,
            attributes: {
                inlineNodeNames: inlineNodeTypes
            }
        }).fire((0, $2H1dZ.FabricChannel).editor);
        removeDraftModeCallback();
        onCloseProps();
    }, [
        onCloseProps,
        removeDraftModeCallback,
        createAnalyticsEvent,
        inlineNodeTypes
    ]);
    (0, $5FkrB.useEffect)(function() {
        if (annotationManager) {
            var allowAnnotation = function allowAnnotation() {
                if (isDrafting) return false;
                return isAnnotationAllowed;
            };
            annotationManager.hook('allowAnnotation', allowAnnotation);
            return function() {
                annotationManager.unhook('allowAnnotation', allowAnnotation);
            };
        }
    }, [
        annotationManager,
        isAnnotationAllowed,
        isDrafting
    ]);
    (0, $5FkrB.useEffect)(function() {
        if (annotationManager) {
            var startDraft = function startDraft() {
                var _result$inlineNodeTyp;
                // if there is a draft in progress, we ignore it and start a new draft
                // this is because clearing the draft will remove the mark node from the DOM, which will cause the selection range to be invalid
                // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
                var id = (0, $6JfQX.default)();
                var result = applyDraftModeCallback({
                    annotationId: id,
                    keepNativeSelection: false
                });
                if (!result) return {
                    success: false,
                    reason: 'invalid-range'
                };
                dispatch({
                    type: 'setDrafting',
                    data: {
                        isDrafting: true,
                        draftId: id,
                        draftActionResult: result
                    }
                });
                dispatch({
                    type: 'resetSelectedAnnotation'
                });
                return {
                    success: true,
                    // We cannot get a ref to the target element here
                    // because the draft is not yet applied to the DOM
                    targetElement: undefined,
                    inlineNodeTypes: (_result$inlineNodeTyp = result.inlineNodeTypes) !== null && _result$inlineNodeTyp !== void 0 ? _result$inlineNodeTyp : [],
                    actionResult: {
                        step: result.step,
                        doc: result.doc,
                        inlineNodeTypes: result.inlineNodeTypes,
                        targetNodeType: result.targetNodeType,
                        originalSelection: result.originalSelection,
                        numMatches: result.numMatches,
                        matchIndex: result.matchIndex,
                        pos: result.pos
                    }
                };
            };
            annotationManager.hook('startDraft', startDraft);
            return function() {
                annotationManager.unhook('startDraft', startDraft);
            };
        }
    }, [
        annotationManager,
        isDrafting,
        applyDraftModeCallback,
        actions,
        range,
        dispatch
    ]);
    (0, $5FkrB.useEffect)(function() {
        if (annotationManager) {
            var clearDraft = function clearDraft() {
                if (!isDrafting) return {
                    success: false,
                    reason: 'draft-not-started'
                };
                dispatch({
                    type: 'setDrafting',
                    data: {
                        isDrafting: false,
                        draftId: undefined,
                        draftActionResult: undefined
                    }
                });
                onCloseCallback();
                return {
                    success: true
                };
            };
            annotationManager.hook('clearDraft', clearDraft);
            return function() {
                annotationManager.unhook('clearDraft', clearDraft);
            };
        }
    }, [
        annotationManager,
        onCloseCallback,
        isDrafting,
        dispatch
    ]);
    (0, $5FkrB.useEffect)(function() {
        if (annotationManager) {
            var applyDraft = function applyDraft(id) {
                if (!isDrafting || !draftId) return {
                    success: false,
                    reason: 'draft-not-started'
                };
                var result = onCreateCallback(id);
                if (!result) return {
                    success: false,
                    reason: 'range-no-longer-exists'
                };
                onCloseCallback();
                dispatch({
                    type: 'setDrafting',
                    data: {
                        isDrafting: false,
                        draftId: undefined,
                        draftActionResult: undefined
                    }
                });
                dispatch({
                    type: 'updateAnnotation',
                    data: {
                        id: id,
                        selected: true,
                        markState: (0, $kX1mK.AnnotationMarkStates).ACTIVE
                    }
                });
                return {
                    success: true,
                    targetElement: undefined,
                    actionResult: id !== draftId ? {
                        step: result.step,
                        doc: result.doc,
                        inlineNodeTypes: result.inlineNodeTypes,
                        targetNodeType: result.targetNodeType,
                        originalSelection: result.originalSelection,
                        numMatches: result.numMatches,
                        matchIndex: result.matchIndex,
                        pos: result.pos
                    } : undefined
                };
            };
            annotationManager.hook('applyDraft', applyDraft);
            return function() {
                annotationManager.unhook('applyDraft', applyDraft);
            };
        }
    }, [
        annotationManager,
        onCreateCallback,
        onCloseCallback,
        isDrafting,
        draftId,
        dispatch
    ]);
    // Please remove this NOP function when the flag platform_editor_comments_api_manager is removed.
    var nop = (0, $5FkrB.useMemo)(function() {
        return function() {
            return false;
        };
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(Component, {
        range: range,
        draftRange: draftRange,
        wrapperDOM: wrapperDOM.current,
        isAnnotationAllowed: isAnnotationAllowed,
        onClose: annotationManager ? nop : onCloseCallback,
        onCreate: annotationManager ? nop : onCreateCallback,
        getAnnotationIndexMatch: createIndexCallback,
        applyDraftMode: annotationManager ? nop : applyDraftModeCallback,
        removeDraftMode: annotationManager ? nop : removeDraftModeCallback,
        inlineNodeTypes: inlineNodeTypes
    });
});

});



parcelRegister("lh3H1", function(module, exports) {
$parcel$export(module.exports, "useLoadAnnotations", () => $f7ce0cd297733cf6$export$39f7c1a861a0d41c);

var $25nEq = parcelRequire("25nEq");

var $5FkrB = parcelRequire("5FkrB");

var $1xyIw = parcelRequire("1xyIw");

var $gtPYB = parcelRequire("gtPYB");

var $lMzAH = parcelRequire("lMzAH");

var $fDwDe = parcelRequire("fDwDe");
function $f7ce0cd297733cf6$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $f7ce0cd297733cf6$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $f7ce0cd297733cf6$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $f7ce0cd297733cf6$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $f7ce0cd297733cf6$export$39f7c1a861a0d41c = function useLoadAnnotations(_ref) {
    var adfDocument = _ref.adfDocument, isNestedRender = _ref.isNestedRender, onLoadComplete = _ref.onLoadComplete;
    var actions = (0, $5FkrB.useContext)((0, $lMzAH.RendererContext));
    var providers = (0, $5FkrB.useContext)((0, $gtPYB.ProvidersContext));
    var _useAnnotationManager = (0, $fDwDe.useAnnotationManagerDispatch)(), annotationManager = _useAnnotationManager.annotationManager, dispatch = _useAnnotationManager.dispatch;
    var isAnnotationManagerEnabled = !!annotationManager;
    (0, $5FkrB.useEffect)(function() {
        if (!providers) return;
        var _providers$inlineComm = providers.inlineComment, inlineCommentGetState = _providers$inlineComm.getState, updateSubscriberInlineComment = _providers$inlineComm.updateSubscriber;
        var annotations = actions.getAnnotationMarks();
        // we don't want to request integrators for state with an empty list of ids.
        if (!annotations.length) {
            if (!isNestedRender) // inlineCommentGetState handles empty lists gracefully. It has a side-effect of clearing state, which is why this call is needed
            inlineCommentGetState([], isNestedRender);
            onLoadComplete && onLoadComplete({
                numberOfUnresolvedInlineComments: 0
            });
            return;
        }
        var ids = annotations.map(function(mark) {
            return mark.attrs.id;
        });
        var cb = function cb(data) {
            if (!updateSubscriberInlineComment) return;
            var payload = data.reduce(function(acc, value) {
                return $f7ce0cd297733cf6$var$_objectSpread($f7ce0cd297733cf6$var$_objectSpread({}, acc), {}, (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, value.id, value));
            }, {});
            if (isAnnotationManagerEnabled) dispatch({
                type: 'loadAnnotation',
                data: Object.keys(payload).map(function(id) {
                    var _payload$id$state;
                    return {
                        id: id,
                        markState: (_payload$id$state = payload[id].state) !== null && _payload$id$state !== void 0 ? _payload$id$state : undefined
                    };
                })
            });
            else updateSubscriberInlineComment.emit((0, $1xyIw.AnnotationUpdateEvent).SET_ANNOTATION_STATE, payload);
            onLoadComplete && onLoadComplete({
                numberOfUnresolvedInlineComments: data.filter(function(data) {
                    return data.state === 'active';
                }).length
            });
        };
        inlineCommentGetState(ids, isNestedRender).then(cb);
    }, [
        actions,
        providers,
        adfDocument,
        isNestedRender,
        onLoadComplete,
        dispatch,
        isAnnotationManagerEnabled
    ]);
};

});


parcelRegister("caYHb", function(module, exports) {
$parcel$export(module.exports, "ValidationContext", () => $8dd5801438f5053b$export$d452675449e81987);
$parcel$export(module.exports, "ValidationContextProvider", () => $8dd5801438f5053b$export$5b655fe45447a548);

var $5FkrB = parcelRequire("5FkrB");
var $8dd5801438f5053b$export$d452675449e81987 = /*#__PURE__*/ (0, $5FkrB.createContext)(null);
var $8dd5801438f5053b$export$5b655fe45447a548 = $8dd5801438f5053b$export$d452675449e81987.Provider;

});


parcelRegister("5gpFM", function(module, exports) {
$parcel$export(module.exports, "default", () => $3d525c7e0bdc42f1$export$2e2bcd8739ae039);

var $kqp0i = parcelRequire("kqp0i");

var $iYJcE = parcelRequire("iYJcE");

var $lAD7C = parcelRequire("lAD7C");

var $74Zh5 = parcelRequire("74Zh5");

var $d4dXm = parcelRequire("d4dXm");

var $5FkrB = parcelRequire("5FkrB");

var $ksTq8 = parcelRequire("ksTq8");

var $4chaE = parcelRequire("4chaE");

var $h4UGN = parcelRequire("h4UGN");
var $01HkO = parcelRequire("01HkO");

var $53SBn = parcelRequire("53SBn");

var $2XMn4 = parcelRequire("2XMn4");
var $3d525c7e0bdc42f1$var$_templateObject, $3d525c7e0bdc42f1$var$_templateObject2;
var $3d525c7e0bdc42f1$var$useMultiBodiedExtensionActions = function useMultiBodiedExtensionActions(_ref) {
    var updateActiveChild = _ref.updateActiveChild, children = _ref.children;
    var actions = (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).useMemo(function() {
        return {
            changeActive: function changeActive(index) {
                return updateActiveChild(index);
            },
            addChild: function addChild() {
                return false;
            },
            getChildrenCount: function getChildrenCount() {
                return children ? children === null || children === void 0 ? void 0 : children.length : 0;
            },
            removeChild: function removeChild(_index) {
                return false;
            },
            updateParameters: function updateParameters(_parameters) {
                return false;
            },
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            getChildren: function getChildren() {
                return [];
            },
            getChildrenContainer: function getChildrenContainer() {
                return null;
            }
        };
    }, [
        updateActiveChild,
        children
    ]);
    return actions;
};
// eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- Ignored via go/DSP-18766
var $3d525c7e0bdc42f1$var$navigationCssExtended = (0, $74Zh5.css)($3d525c7e0bdc42f1$var$_templateObject || ($3d525c7e0bdc42f1$var$_templateObject = (0, (/*@__PURE__*/$parcel$interopDefault($lAD7C)))([
    "\n\t",
    ";\n\tmargin-left: 0 !important;\n\tmargin-right: 0 !important;\n\t.mbe-add-tab-button,\n\t.mbe-remove-tab {\n\t\tdisplay: none;\n\t}\n"
])), (0, $h4UGN.sharedMultiBodiedExtensionStyles).mbeNavigation);
var $3d525c7e0bdc42f1$var$MultiBodiedExtension = function MultiBodiedExtension(props) {
    var children = props.children, _props$layout = props.layout, layout = _props$layout === void 0 ? 'default' : _props$layout, _props$path = props.path, path = _props$path === void 0 ? [] : _props$path;
    var _useState = (0, $5FkrB.useState)(0), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), activeChildIndex = _useState2[0], setActiveChildIndex = _useState2[1];
    var removeOverflow = (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).Children.toArray(children)// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    .map(function(child) {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).isValidElement(child) ? child.props.nodeType === 'table' : false;
    }).every(Boolean);
    var overflowContainerClass = !removeOverflow ? (0, $53SBn.RendererCssClassName).EXTENSION_OVERFLOW_CONTAINER : '';
    var updateActiveChild = (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).useCallback(function(index) {
        if (typeof index !== 'number') {
            // Ignored via go/ees007
            // eslint-disable-next-line @atlaskit/editor/enforce-todo-comment-format
            // TODO: Make sure we log this somewhere if this happens
            setActiveChildIndex(0);
            return false;
        }
        setActiveChildIndex(index);
        return true;
    }, [
        setActiveChildIndex
    ]);
    var actions = $3d525c7e0bdc42f1$var$useMultiBodiedExtensionActions({
        updateActiveChild: updateActiveChild,
        children: children
    });
    // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- needs manual remediation
    var containerCssExtended = (0, $74Zh5.css)($3d525c7e0bdc42f1$var$_templateObject2 || ($3d525c7e0bdc42f1$var$_templateObject2 = (0, (/*@__PURE__*/$parcel$interopDefault($lAD7C)))([
        "\n\t\t",
        ";\n\t\t.ak-renderer-extension {\n\t\t\tmargin-top: 0 !important;\n\t\t}\n\n\t\t[data-layout='full-width'],\n\t\t[data-layout='wide'] {\n\t\t\t.multiBodiedExtension-navigation {\n\t\t\t\tborder-right: 3px solid ",
        " !important;\n\t\t\t}\n\t\t}\n\n\t\t.multiBodiedExtension--frames\n\t\t\t> [data-extension-frame='true']:nth-of-type(",
        ") {\n\t\t\t",
        "\n\t\t\tmargin-left: 0;\n\t\t\tmargin-right: 0;\n\t\t}\n\t"
    ])), (0, $h4UGN.sharedMultiBodiedExtensionStyles).mbeExtensionContainer, "var(--ds-border, ".concat((0, $d4dXm.N40), ")"), activeChildIndex + 1, (0, $h4UGN.sharedMultiBodiedExtensionStyles).extensionFrameContent);
    var isTopLevel = path.length < 1;
    var centerAlignClass = isTopLevel && [
        'wide',
        'full-width'
    ].includes(layout) ? (0, $53SBn.RendererCssClassName).EXTENSION_CENTER_ALIGN : '';
    function renderMbeContent(width) {
        return (0, $74Zh5.jsx)("div", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: "".concat((0, $53SBn.RendererCssClassName).EXTENSION, " ").concat(centerAlignClass, " ").concat(overflowContainerClass),
            style: {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                width: isTopLevel ? (0, $2XMn4.calcBreakoutWidth)(layout, width) : '100%'
            },
            "data-layout": layout
        }, (0, $74Zh5.jsx)("nav", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: "multiBodiedExtension-navigation",
            css: $3d525c7e0bdc42f1$var$navigationCssExtended,
            "data-testid": "multiBodiedExtension-navigation"
        }, (0, $74Zh5.jsx)((0, $4chaE.default), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, props, {
            actions: actions,
            type: "multiBodiedExtension"
        }), function(_ref2) {
            var result = _ref2.result;
            try {
                if (result && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).isValidElement(result)) // Return the content directly if it's a valid JSX.Element
                return (0, $ksTq8.renderExtension)(result, layout, {
                    isTopLevel: path.length < 1
                });
            } catch (e) {
            /** We don't want this error to block renderer */ /** We keep rendering the default content */ }
            // Always return default content if anything goes wrong
            return (0, $ksTq8.renderExtension)(children, layout, {
                isTopLevel: path.length < 1
            });
        })), (0, $74Zh5.jsx)("article", {
            "data-testid": "multiBodiedExtension--frames",
            className: "multiBodiedExtension--frames"
        }, children));
    }
    return (0, $74Zh5.jsx)("section", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "multiBodiedExtension--container",
        css: containerCssExtended,
        "data-testid": "multiBodiedExtension--container",
        "data-active-child-index": activeChildIndex,
        "data-layout": layout
    }, (0, $74Zh5.jsx)((0, $01HkO.WidthConsumer), null, function(_ref3) {
        var width = _ref3.width;
        return renderMbeContent(width);
    }));
};
var $3d525c7e0bdc42f1$export$2e2bcd8739ae039 = $3d525c7e0bdc42f1$var$MultiBodiedExtension;

});
parcelRegister("d4dXm", function(module, exports) {
$parcel$export(module.exports, "R50", () => $9836798edbd03569$export$4b84fd0e2c617bd);
$parcel$export(module.exports, "R300", () => $9836798edbd03569$export$4a7404f376229999);
$parcel$export(module.exports, "R400", () => $9836798edbd03569$export$2010d0fb4295b346);
$parcel$export(module.exports, "R500", () => $9836798edbd03569$export$2837b5a1a71d5c02);
$parcel$export(module.exports, "Y75", () => $9836798edbd03569$export$41060a744ab0b7ae);
$parcel$export(module.exports, "Y300", () => $9836798edbd03569$export$c6930421db9fa514);
$parcel$export(module.exports, "G300", () => $9836798edbd03569$export$940e1f69e873f202);
$parcel$export(module.exports, "G400", () => $9836798edbd03569$export$a49394138f7b8e85);
$parcel$export(module.exports, "B100", () => $9836798edbd03569$export$ecfc1dff386a3e7a);
$parcel$export(module.exports, "B200", () => $9836798edbd03569$export$215b7063051591f1);
$parcel$export(module.exports, "B300", () => $9836798edbd03569$export$e62e8919cca44969);
$parcel$export(module.exports, "B400", () => $9836798edbd03569$export$b3de0ae08da2ce64);
$parcel$export(module.exports, "B500", () => $9836798edbd03569$export$a6ee3d71bc067634);
$parcel$export(module.exports, "P300", () => $9836798edbd03569$export$b48405b95304b5a1);
$parcel$export(module.exports, "N0", () => $9836798edbd03569$export$29a4f05edc054374);
$parcel$export(module.exports, "N10", () => $9836798edbd03569$export$e655ef011c4aa1a2);
$parcel$export(module.exports, "N20", () => $9836798edbd03569$export$9fdfb749e33cdf97);
$parcel$export(module.exports, "N30", () => $9836798edbd03569$export$3e51e8f1440314ba);
$parcel$export(module.exports, "N40", () => $9836798edbd03569$export$1ce2d1575d444ceb);
$parcel$export(module.exports, "N70", () => $9836798edbd03569$export$5f71e19f3a7ad9de);
$parcel$export(module.exports, "N200", () => $9836798edbd03569$export$f563ee71e9ee74cd);
$parcel$export(module.exports, "N300", () => $9836798edbd03569$export$e2ef2124cf4024b1);
$parcel$export(module.exports, "N400", () => $9836798edbd03569$export$eece5f492e429f08);
$parcel$export(module.exports, "N500", () => $9836798edbd03569$export$c39c0fe0f26207ae);
$parcel$export(module.exports, "N700", () => $9836798edbd03569$export$ad0bacf983b7ddaa);
$parcel$export(module.exports, "N800", () => $9836798edbd03569$export$7d61b15e0da132af);
$parcel$export(module.exports, "N900", () => $9836798edbd03569$export$fbda843f0a27fe96);
$parcel$export(module.exports, "N20A", () => $9836798edbd03569$export$8d43898f60b96a82);
$parcel$export(module.exports, "N30A", () => $9836798edbd03569$export$920c0d5c49070351);
$parcel$export(module.exports, "N40A", () => $9836798edbd03569$export$46987b49aab6d1a8);
$parcel$export(module.exports, "N50A", () => $9836798edbd03569$export$7d3359664e8bb0e5);
$parcel$export(module.exports, "N60A", () => $9836798edbd03569$export$d2d3bedfb276cac0);
// Reds
var $9836798edbd03569$export$4b84fd0e2c617bd = '#FFEBE6';
var $9836798edbd03569$export$b34b069eff244586 = '#FFBDAD';
var $9836798edbd03569$export$be802dd0d8b57f35 = '#FF8F73';
var $9836798edbd03569$export$60847d42f9da92a6 = '#FF7452';
var $9836798edbd03569$export$4a7404f376229999 = '#FF5630';
var $9836798edbd03569$export$2010d0fb4295b346 = '#DE350B';
var $9836798edbd03569$export$2837b5a1a71d5c02 = '#BF2600';
var $9836798edbd03569$export$8d9596b529bbb9cf = '#FFFAE6';
var $9836798edbd03569$export$41060a744ab0b7ae = '#FFF0B3';
var $9836798edbd03569$export$1cc05bbbf340e559 = '#FFE380';
var $9836798edbd03569$export$5aae31392d72caaa = '#FFC400';
var $9836798edbd03569$export$c6930421db9fa514 = '#FFAB00';
var $9836798edbd03569$export$59619663aa6500fb = '#FF991F';
var $9836798edbd03569$export$874739ea9e379ab6 = '#FF8B00';
var $9836798edbd03569$export$8a6341c32b6a3ee6 = '#E3FCEF';
var $9836798edbd03569$export$69a3bf21b9686c2b = '#ABF5D1';
var $9836798edbd03569$export$afbce1382ec95f73 = '#79F2C0';
var $9836798edbd03569$export$747d86715d4175de = '#57D9A3';
var $9836798edbd03569$export$940e1f69e873f202 = '#36B37E';
var $9836798edbd03569$export$a49394138f7b8e85 = '#00875A';
var $9836798edbd03569$export$6fa04827ac68a4fb = '#006644';
var $9836798edbd03569$export$226de0355ed012f8 = '#DEEBFF';
var $9836798edbd03569$export$8c13c2ee36917869 = '#B3D4FF';
var $9836798edbd03569$export$ecfc1dff386a3e7a = '#4C9AFF';
var $9836798edbd03569$export$215b7063051591f1 = '#2684FF';
var $9836798edbd03569$export$e62e8919cca44969 = '#0065FF';
var $9836798edbd03569$export$b3de0ae08da2ce64 = '#0052CC';
var $9836798edbd03569$export$a6ee3d71bc067634 = '#0747A6';
var $9836798edbd03569$export$67f15409e87642a1 = '#669DF1';
var $9836798edbd03569$export$f0539dbc42dbb067 = '#8FB8F6';
var $9836798edbd03569$export$363e4475840015bb = '#EAE6FF';
var $9836798edbd03569$export$4b0a4417ed59760f = '#C0B6F2';
var $9836798edbd03569$export$6011520a64d9a187 = '#998DD9';
var $9836798edbd03569$export$a7175d4e9206bc80 = '#8777D9';
var $9836798edbd03569$export$b48405b95304b5a1 = '#6554C0';
var $9836798edbd03569$export$c71e4279dd54a18d = '#5243AA';
var $9836798edbd03569$export$147899de772240ec = '#403294';
var $9836798edbd03569$export$2cf711fe14c66f06 = '#E6FCFF';
var $9836798edbd03569$export$7a8f4d33f6f9772c = '#B3F5FF';
var $9836798edbd03569$export$776c9c497ef08533 = '#79E2F2';
var $9836798edbd03569$export$69cb3ca10c1e330e = '#00C7E6';
var $9836798edbd03569$export$9dc1ef0f3f48059b = '#00B8D9';
var $9836798edbd03569$export$7c835c78b6fcdef8 = '#00A3BF';
var $9836798edbd03569$export$6036577f95c3877e = '#008DA6';
var $9836798edbd03569$export$29a4f05edc054374 = '#FFFFFF';
var $9836798edbd03569$export$e655ef011c4aa1a2 = '#FAFBFC';
var $9836798edbd03569$export$9fdfb749e33cdf97 = '#F4F5F7';
var $9836798edbd03569$export$3e51e8f1440314ba = '#EBECF0';
var $9836798edbd03569$export$1ce2d1575d444ceb = '#DFE1E6';
var $9836798edbd03569$export$8754fc7e6d8b3000 = '#C1C7D0';
var $9836798edbd03569$export$c2e91cbeada39b8b = '#B3BAC5';
var $9836798edbd03569$export$5f71e19f3a7ad9de = '#A5ADBA';
var $9836798edbd03569$export$eaa8c8a70ac22806 = '#97A0AF';
var $9836798edbd03569$export$7c87d337fb91a97d = '#8993A4';
var $9836798edbd03569$export$d6447c357493214f = '#7A869A';
var $9836798edbd03569$export$f563ee71e9ee74cd = '#6B778C';
var $9836798edbd03569$export$e2ef2124cf4024b1 = '#5E6C84';
var $9836798edbd03569$export$eece5f492e429f08 = '#505F79';
var $9836798edbd03569$export$c39c0fe0f26207ae = '#42526E';
var $9836798edbd03569$export$7090862dc3038a9f = '#344563';
var $9836798edbd03569$export$ad0bacf983b7ddaa = '#253858';
var $9836798edbd03569$export$7d61b15e0da132af = '#172B4D';
var $9836798edbd03569$export$fbda843f0a27fe96 = '#091E42';
var $9836798edbd03569$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
var $9836798edbd03569$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
var $9836798edbd03569$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
var $9836798edbd03569$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
var $9836798edbd03569$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
var $9836798edbd03569$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
var $9836798edbd03569$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
var $9836798edbd03569$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
var $9836798edbd03569$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
var $9836798edbd03569$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
var $9836798edbd03569$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
var $9836798edbd03569$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
var $9836798edbd03569$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
var $9836798edbd03569$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
var $9836798edbd03569$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
var $9836798edbd03569$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
var $9836798edbd03569$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
var $9836798edbd03569$export$2f6319cf7d736c2a = '#E6EDFA';
var $9836798edbd03569$export$95126bc8884d6634 = '#DCE5F5';
var $9836798edbd03569$export$8338d8c35d44ff1 = '#CED9EB';
var $9836798edbd03569$export$5368d76ae4fbbda7 = '#B8C7E0';
var $9836798edbd03569$export$9f0a771d16ec8d36 = '#ABBBD6';
var $9836798edbd03569$export$abcf8c38338b4aa5 = '#9FB0CC';
var $9836798edbd03569$export$97e81faa16a182c7 = '#8C9CB8';
var $9836798edbd03569$export$bfe21c59123ecf33 = '#7988A3';
var $9836798edbd03569$export$ee82aa2ea6a1558 = '#67758F';
var $9836798edbd03569$export$682927c6ed76be02 = '#56637A';
var $9836798edbd03569$export$91fd9994c5be9757 = '#455166';
var $9836798edbd03569$export$d281fbfe3cff2df6 = '#3B475C';
var $9836798edbd03569$export$3902c91d8b98a753 = '#313D52';
var $9836798edbd03569$export$8e8133c1ba5845b5 = '#283447';
var $9836798edbd03569$export$33ff357f6620b39 = '#202B3D';
var $9836798edbd03569$export$633847cf062b69e0 = '#1B2638';
var $9836798edbd03569$export$9776a6e503bdbf76 = '#121A29';
var $9836798edbd03569$export$6c813d5160dff5db = '#0E1624';
var $9836798edbd03569$export$3d4f271a500072a = '#0D1424';
var $9836798edbd03569$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
var $9836798edbd03569$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
var $9836798edbd03569$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
var $9836798edbd03569$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
var $9836798edbd03569$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
var $9836798edbd03569$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
var $9836798edbd03569$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
var $9836798edbd03569$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
var $9836798edbd03569$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
var $9836798edbd03569$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
var $9836798edbd03569$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
var $9836798edbd03569$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
var $9836798edbd03569$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
var $9836798edbd03569$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
var $9836798edbd03569$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
var $9836798edbd03569$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
var $9836798edbd03569$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';
var $9836798edbd03569$export$d2adc5dedf09fced = '#292A2E';
var $9836798edbd03569$export$f51762073d2bb381 = '#94C748';
var $9836798edbd03569$export$95e26d54def96891 = '#B3DF72';

});

parcelRegister("h4UGN", function(module, exports) {
$parcel$export(module.exports, "sharedMultiBodiedExtensionStyles", () => $c6eec8b7cb45d06d$export$9c7196ca47f67390);
/* eslint-disable @atlaskit/ui-styling-standard/use-compiled -- Pre-existing lint debt surfaced by this mechanical type-import-only PR. */ /**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $74Zh5 = parcelRequire("74Zh5");
// Wraps the navigation bar and extensionFrames
var $c6eec8b7cb45d06d$var$mbeExtensionContainer = (0, $74Zh5.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
    background: 'transparent !important',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    'padding:': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
        left: "var(--ds-space-100, 8px)".concat(" !important"),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
        right: "var(--ds-space-100, 8px)".concat(" !important")
    },
    paddingBottom: "var(--ds-space-100, 8px)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.remove-padding': {
        paddingBottom: 0
    },
    position: 'relative',
    verticalAlign: 'middle',
    cursor: 'pointer',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.multiBodiedExtension-handler-result': {
        marginLeft: "var(--ds-space-100, 8px)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    ".multiBodiedExtension-content-dom-wrapper > [data-extension-frame='true'], .multiBodiedExtension--frames > [data-extension-frame='true']": {
        display: 'none'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.multiBodiedExtension-content-dom-wrapper, .multiBodiedExtension--frames': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        "[data-extension-frame='true'] > :not(style):first-child, [data-extension-frame='true'] > style:first-child + *": {
            marginTop: 0
        }
    }
});
var $c6eec8b7cb45d06d$var$mbeNavigation = (0, $74Zh5.css)({
    borderTopLeftRadius: "var(--ds-radius-small, 3px)",
    borderTopRightRadius: "var(--ds-radius-small, 3px)",
    userSelect: 'none',
    WebkitUserModify: 'read-only',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
    borderBottom: 'none !important',
    background: "var(--ds-surface, #FFFFFF)",
    marginLeft: "var(--ds-space-100, 8px)",
    marginRight: "var(--ds-space-100, 8px)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.remove-margins': {
        margin: "var(--ds-space-negative-100, -8px)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.remove-border': {
        border: 'none'
    }
});
var $c6eec8b7cb45d06d$var$extensionFrameContent = (0, $74Zh5.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
    padding: "var(--ds-space-100, 8px)".concat(" !important"),
    display: 'block',
    minHeight: '100px',
    background: 'transparent',
    borderBottomLeftRadius: "var(--ds-radius-small, 3px)",
    borderBottomRightRadius: "var(--ds-radius-small, 3px)",
    marginLeft: "var(--ds-space-100, 8px)",
    marginRight: "var(--ds-space-100, 8px)",
    cursor: 'initial',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.pm-table-with-controls': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
        marginLeft: "var(--ds-space-150, 12px)".concat(" !important"),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
        paddingRight: "var(--ds-space-150, 12px)".concat(" !important")
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.bodiedExtensionView-content-wrap': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
        marginTop: "var(--ds-space-150, 12px)".concat(" !important")
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.extensionView-content-wrap': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
        marginTop: "var(--ds-space-100, 8px)".concat(" !important")
    }
});
var $c6eec8b7cb45d06d$export$8df0393dc2d5d656 = (0, $74Zh5.css)({
    marginLeft: 0,
    marginRight: 0,
    border: 'none'
});
var $c6eec8b7cb45d06d$export$9c7196ca47f67390 = {
    mbeExtensionContainer: $c6eec8b7cb45d06d$var$mbeExtensionContainer,
    mbeNavigation: $c6eec8b7cb45d06d$var$mbeNavigation,
    extensionFrameContent: $c6eec8b7cb45d06d$var$extensionFrameContent
};

});


parcelRegister("geLdv", function(module, exports) {
$parcel$export(module.exports, "default", () => $bd229469dfadfb0e$export$2e2bcd8739ae039);

var $lAD7C = parcelRequire("lAD7C");

var $iYJcE = parcelRequire("iYJcE");

var $74Zh5 = parcelRequire("74Zh5");

var $5FkrB = parcelRequire("5FkrB");

var $01HkO = parcelRequire("01HkO");

var $53SBn = parcelRequire("53SBn");

var $2XMn4 = parcelRequire("2XMn4");

var $hm5SD = parcelRequire("hm5SD");

var $5ZkfV = parcelRequire("5ZkfV");

var $drUcN = parcelRequire("drUcN");

var $2TWiQ = parcelRequire("2TWiQ");
var $bd229469dfadfb0e$var$_templateObject;
var $bd229469dfadfb0e$var$containerStyles = (0, $74Zh5.css)({
    // Remove top margin if MBE is the first on the doc/page (MBE can only be on the first level)
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors, @atlaskit/ui-styling-standard/no-nested-selectors
    '&:first-child > .ak-renderer-extension': {
        marginTop: 0
    }
});
var $bd229469dfadfb0e$var$MultiBodiedExtensionChildrenContainer = function MultiBodiedExtensionChildrenContainer(_ref) {
    var children = _ref.children;
    return (0, $74Zh5.jsx)("article", {
        "data-testid": "multiBodiedExtension--frames"
    }, children);
};
var $bd229469dfadfb0e$var$MultiBodiedExtensionNavigation = function MultiBodiedExtensionNavigation(_ref2) {
    var children = _ref2.children;
    return (0, $74Zh5.jsx)("nav", {
        "data-testid": "multiBodiedExtension-navigation"
    }, children);
};
var $bd229469dfadfb0e$var$MultiBodiedExtensionWrapperLegacy = function MultiBodiedExtensionWrapperLegacy(_ref3) {
    var width = _ref3.width, path = _ref3.path, layout = _ref3.layout, children = _ref3.children;
    var isTopLevel = path.length < 1;
    var centerAlignClass = isTopLevel && [
        'wide',
        'full-width'
    ].includes(layout) ? (0, $53SBn.RendererCssClassName).EXTENSION_CENTER_ALIGN : '';
    // This hierarchy is copied from regular extension (see extension.tsx)
    return (0, $74Zh5.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "".concat((0, $53SBn.RendererCssClassName).EXTENSION, " ").concat(centerAlignClass),
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            width: isTopLevel ? (0, $2XMn4.calcBreakoutWidth)(layout, width) : '100%'
        },
        "data-layout": layout,
        "data-testid": "multiBodiedExtension--wrapper"
    }, (0, $74Zh5.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: "".concat((0, $53SBn.RendererCssClassName).EXTENSION_OVERFLOW_CONTAINER)
    }, children));
};
var $bd229469dfadfb0e$var$MultiBodiedExtensionWrapperNext = function MultiBodiedExtensionWrapperNext(_ref4) {
    var path = _ref4.path, layout = _ref4.layout, children = _ref4.children;
    var isTopLevel = path.length < 1;
    var centerAlignClass = isTopLevel && [
        'wide',
        'full-width'
    ].includes(layout) ? (0, $53SBn.RendererCssClassName).EXTENSION_CENTER_ALIGN : '';
    // This hierarchy is copied from regular extension (see extension.tsx)
    return (0, $74Zh5.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "".concat((0, $53SBn.RendererCssClassName).EXTENSION, " ").concat(centerAlignClass),
        style: {
            width: isTopLevel ? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $2TWiQ.calcBreakoutWidthCss)(layout) : '100%'
        },
        "data-layout": layout,
        "data-testid": "multiBodiedExtension--wrapper"
    }, (0, $74Zh5.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: "".concat((0, $53SBn.RendererCssClassName).EXTENSION_OVERFLOW_CONTAINER)
    }, children));
};
var $bd229469dfadfb0e$var$MultiBodiedExtension = function MultiBodiedExtension(props) {
    var _extensionContext$pri;
    var children = props.children, _props$layout = props.layout, layout = _props$layout === void 0 ? 'default' : _props$layout, _props$path = props.path, path = _props$path === void 0 ? [] : _props$path, parameters = props.parameters, extensionType = props.extensionType, extensionKey = props.extensionKey, content = props.content, marks = props.marks, localId = props.localId;
    var _useState = (0, $5FkrB.useState)(0), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), activeChildIndex = _useState2[0], setActiveChildIndex = _useState2[1];
    var _useMultiBodiedExtens = (0, $5ZkfV.useMultiBodiedExtensionContext)({
        extensionType: extensionType,
        extensionKey: extensionKey
    }), loading = _useMultiBodiedExtens.loading, extensionContext = _useMultiBodiedExtens.extensionContext;
    var actions = (0, $hm5SD.useMultiBodiedExtensionActions)({
        updateActiveChild: setActiveChildIndex,
        children: children,
        childrenContainer: (0, $74Zh5.jsx)($bd229469dfadfb0e$var$MultiBodiedExtensionChildrenContainer, null, children),
        allowBodiedOverride: extensionContext === null || extensionContext === void 0 || (_extensionContext$pri = extensionContext.privateProps) === null || _extensionContext$pri === void 0 ? void 0 : _extensionContext$pri.__allowBodiedOverride
    });
    var renderContent = (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).useCallback(function() {
        var _marks$find;
        if (loading || !extensionContext) return null;
        var NodeRenderer = extensionContext.NodeRenderer, privateProps = extensionContext.privateProps;
        var fragmentLocalId = marks === null || marks === void 0 || (_marks$find = marks.find(function(m) {
            return m.type.name === 'fragment';
        })) === null || _marks$find === void 0 || (_marks$find = _marks$find.attrs) === null || _marks$find === void 0 ? void 0 : _marks$find.localId;
        var node = {
            type: 'multiBodiedExtension',
            extensionKey: extensionKey,
            extensionType: extensionType,
            parameters: parameters,
            content: content,
            localId: localId,
            fragmentLocalId: fragmentLocalId
        };
        if (privateProps.__allowBodiedOverride) return (0, $74Zh5.jsx)(NodeRenderer, {
            node: node,
            actions: actions
        });
        else return (0, $74Zh5.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).Fragment, null, (0, $74Zh5.jsx)($bd229469dfadfb0e$var$MultiBodiedExtensionNavigation, null, (0, $74Zh5.jsx)(NodeRenderer, {
            node: node,
            actions: actions
        })), (0, $74Zh5.jsx)($bd229469dfadfb0e$var$MultiBodiedExtensionChildrenContainer, null, children));
    }, [
        loading,
        extensionContext,
        marks,
        extensionKey,
        extensionType,
        parameters,
        content,
        localId,
        actions,
        children
    ]);
    // make the frame visible
    // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression
    var containerActiveFrameStyles = (0, $74Zh5.css)($bd229469dfadfb0e$var$_templateObject || ($bd229469dfadfb0e$var$_templateObject = (0, (/*@__PURE__*/$parcel$interopDefault($lAD7C)))([
        "\n\t\t& [data-extension-frame='true']:nth-of-type(",
        ") {\n\t\t\tdisplay: block;\n\t\t}\n\t"
    ])), activeChildIndex + 1);
    if ((0, $drUcN.expValEquals)('platform_editor_renderer_extension_width_fix', 'isEnabled', true)) return (0, $74Zh5.jsx)("section", {
        css: [
            $bd229469dfadfb0e$var$containerStyles,
            containerActiveFrameStyles
        ],
        "data-testid": "multiBodiedExtension--container",
        "data-multiBodiedExtension-container": true,
        "data-active-child-index": activeChildIndex,
        "data-layout": layout,
        "data-local-id": localId,
        "data-node-type": "multiBodiedExtension"
    }, (0, $74Zh5.jsx)($bd229469dfadfb0e$var$MultiBodiedExtensionWrapperNext, {
        layout: layout,
        path: path
    }, renderContent()));
    return (0, $74Zh5.jsx)("section", {
        css: [
            $bd229469dfadfb0e$var$containerStyles,
            containerActiveFrameStyles
        ],
        "data-testid": "multiBodiedExtension--container",
        "data-multiBodiedExtension-container": true,
        "data-active-child-index": activeChildIndex,
        "data-layout": layout,
        "data-local-id": localId
    }, (0, $74Zh5.jsx)((0, $01HkO.WidthConsumer), null, function(_ref5) {
        var width = _ref5.width;
        return (0, $74Zh5.jsx)($bd229469dfadfb0e$var$MultiBodiedExtensionWrapperLegacy, {
            layout: layout,
            width: width,
            path: path
        }, renderContent());
    }));
};
var $bd229469dfadfb0e$export$2e2bcd8739ae039 = $bd229469dfadfb0e$var$MultiBodiedExtension;

});
parcelRegister("hm5SD", function(module, exports) {
$parcel$export(module.exports, "useMultiBodiedExtensionActions", () => $ca290d6a53ebbd9b$export$3c7139d93ecb4f1f);

var $5FkrB = parcelRequire("5FkrB");
var $ca290d6a53ebbd9b$export$3c7139d93ecb4f1f = function useMultiBodiedExtensionActions(_ref) {
    var updateActiveChild = _ref.updateActiveChild, children = _ref.children, allowBodiedOverride = _ref.allowBodiedOverride, childrenContainer = _ref.childrenContainer;
    return (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).useMemo(function() {
        return {
            changeActive: function changeActive(index) {
                if (!Number.isInteger(index)) return false;
                updateActiveChild(index);
                return true;
            },
            addChild: function addChild() {
                return false;
            },
            getChildrenCount: function getChildrenCount() {
                return children && Array.isArray(children) ? children.length : 0;
            },
            removeChild: function removeChild(_index) {
                return false;
            },
            updateParameters: function updateParameters(_parameters) {
                return false;
            },
            getChildren: function getChildren() {
                return [];
            },
            getChildrenContainer: function getChildrenContainer() {
                return allowBodiedOverride ? childrenContainer : null;
            }
        };
    }, [
        updateActiveChild,
        children,
        allowBodiedOverride,
        childrenContainer
    ]);
};

});

parcelRegister("5ZkfV", function(module, exports) {
$parcel$export(module.exports, "useMultiBodiedExtensionContext", () => $45c25ca64ace5164$export$e55394818db35473);

var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");

var $cvlyC = parcelRequire("cvlyC");

var $5hQFA = parcelRequire("5hQFA");

var $d0n7Z = parcelRequire("d0n7Z");
var $45c25ca64ace5164$export$e55394818db35473 = function useMultiBodiedExtensionContext(_ref) {
    var extensionType = _ref.extensionType, extensionKey = _ref.extensionKey;
    var isMounted = (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).useRef(true);
    var localGetNodeRenderer = (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).useMemo(function() {
        return (0, $cvlyC.default)((0, $5hQFA.getNodeRenderer));
    }, []);
    var _React$useState = (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).useState(), _React$useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_React$useState, 2), provider = _React$useState2[0], setProvider = _React$useState2[1];
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var _React$useState3 = (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).useState(), _React$useState4 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_React$useState3, 2), privateProps = _React$useState4[0], setPrivateProps = _React$useState4[1];
    var providerPromise = (0, $d0n7Z.useProvider)('extensionProvider');
    (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).useEffect(function() {
        if (providerPromise) providerPromise.then(function(p) {
            if (isMounted.current) setProvider(p);
            return (0, $5hQFA.getExtensionModuleNodePrivateProps)(p, extensionType, extensionKey);
        }).then(function(pr) {
            if (isMounted.current) setPrivateProps(pr);
        });
    }, [
        providerPromise,
        extensionType,
        extensionKey
    ]);
    var NodeRenderer = (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).useMemo(function() {
        if (!provider) return null;
        return localGetNodeRenderer(provider, extensionType, extensionKey);
    }, [
        provider,
        extensionType,
        extensionKey,
        localGetNodeRenderer
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).useEffect(function() {
        isMounted.current = true;
        return function() {
            isMounted.current = false;
        };
    }, []);
    return (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).useMemo(function() {
        if (!provider || !NodeRenderer || !privateProps) return {
            extensionContext: null,
            loading: true
        };
        return {
            extensionContext: {
                NodeRenderer: NodeRenderer,
                privateProps: privateProps
            },
            loading: false
        };
    }, [
        provider,
        NodeRenderer,
        privateProps
    ]);
};

});


parcelRegister("bHdFw", function(module, exports) {
$parcel$export(module.exports, "default", () => $883e5034413346f2$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $74Zh5 = parcelRequire("74Zh5");

var $9Zzpd = parcelRequire("9Zzpd");
var $883e5034413346f2$var$containerCSSOld = (0, $74Zh5.css)({
    minHeight: '100px',
    flexBasis: '100%'
});
var $883e5034413346f2$var$containerCSSNew = (0, $74Zh5.css)({
    padding: "var(--ds-space-100, 8px)",
    minHeight: '100px',
    // by default all frames are hidden, this style is overridden in multiBodiedExtensions for active frame
    display: 'none'
});
var $883e5034413346f2$var$ExtensionFrame = function ExtensionFrame(props) {
    return (0, $74Zh5.jsx)("div", {
        css: [
            (0, $9Zzpd.fg)('platform_editor_multi_body_extension_extensibility') ? $883e5034413346f2$var$containerCSSNew : $883e5034413346f2$var$containerCSSOld
        ],
        "data-extension-frame": "true"
    }, props.children);
};
var $883e5034413346f2$export$2e2bcd8739ae039 = $883e5034413346f2$var$ExtensionFrame;

});

parcelRegister("aJQyW", function(module, exports) {
$parcel$export(module.exports, "default", () => $7d16e128cef916e6$export$2e2bcd8739ae039);

var $5FkrB = parcelRequire("5FkrB");

var $gBea6 = parcelRequire("gBea6");

var $7q4H1 = parcelRequire("7q4H1");
function $7d16e128cef916e6$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("ul", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $gBea6.bulletListSelector).substr(1),
        "data-local-id": props.localId,
        "data-indent-level": props.path ? (0, $7q4H1.getListIndentLevel)(props.path) : 1
    }, props.children);
}

});
parcelRegister("7q4H1", function(module, exports) {
$parcel$export(module.exports, "getListIndentLevel", () => $566e9a0b72f23ba4$export$75aa84e85754623e);
function $566e9a0b72f23ba4$export$75aa84e85754623e(path) {
    var count = 1;
    path.forEach(function(node) {
        if (node.type.name === 'bulletList' || node.type.name === 'orderedList') count++;
    });
    return count;
}

});


parcelRegister("ac0Rs", function(module, exports) {
$parcel$export(module.exports, "default", () => $76bbb165680518ac$export$2e2bcd8739ae039);
$parcel$export(module.exports, "DocWithSelectAllTrap", () => $76bbb165680518ac$export$41121a410ca2f650);

var $5FkrB = parcelRequire("5FkrB");

var $53SBn = parcelRequire("53SBn");

var $lXWgS = parcelRequire("lXWgS");
function $76bbb165680518ac$export$2e2bcd8739ae039(props) {
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("div", {
        className: (0, $53SBn.RendererCssClassName).DOCUMENT
    }, props.children);
}
function $76bbb165680518ac$export$41121a410ca2f650(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("div", {
        ref: (0, $lXWgS.useSelectAllTrap)(),
        className: (0, $53SBn.RendererCssClassName).DOCUMENT
    }, props.children);
}

});
parcelRegister("lXWgS", function(module, exports) {
$parcel$export(module.exports, "useSelectAllTrap", () => $ffdc4f16ec2303eb$export$98871b245ee25215);

var $jJH6F = parcelRequire("jJH6F");

var $5FkrB = parcelRequire("5FkrB");

var $gPdZj = parcelRequire("gPdZj");

var $cYcab = parcelRequire("cYcab");
var $ffdc4f16ec2303eb$export$98871b245ee25215 = function useSelectAllTrap() {
    var _React$useContext = (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).useContext((0, $gPdZj.default)), fireAnalyticsEvent = _React$useContext.fireAnalyticsEvent;
    var ref = (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).useRef(null);
    var clicked = (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).useRef(false);
    var caught = (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).useRef();
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    var mac = typeof navigator !== 'undefined' ? /Mac/.test(navigator.platform) : false;
    var onKeyDown = (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).useCallback(function(e) {
        var _e$target, _e$target$matches;
        var el = ref.current;
        if (!el) return;
        var modKey = mac ? e.metaKey : e.ctrlKey;
        if (!modKey || e.code !== 'KeyA' || e.shiftKey) return;
        var elementSelection = (0, $cYcab.ElementSelection).fromWindow();
        var isInput = (_e$target = e.target) === null || _e$target === void 0 || (_e$target$matches = _e$target.matches) === null || _e$target$matches === void 0 ? void 0 : _e$target$matches.call(_e$target, 'input');
        if (elementSelection.eq(caught.current) || isInput) {
            fireAnalyticsEvent({
                eventType: (0, $jJH6F.EVENT_TYPE).TRACK,
                action: (0, $jJH6F.ACTION).SELECT_ALL_ESCAPED,
                actionSubject: (0, $jJH6F.ACTION_SUBJECT).RENDERER
            });
            return;
        }
        if (elementSelection.inside(el) || elementSelection.type === 'None' && clicked.current) {
            fireAnalyticsEvent({
                eventType: (0, $jJH6F.EVENT_TYPE).TRACK,
                action: (0, $jJH6F.ACTION).SELECT_ALL_CAUGHT,
                actionSubject: (0, $jJH6F.ACTION_SUBJECT).RENDERER
            });
            e.preventDefault();
            caught.current = elementSelection.select(el);
        }
    }, [
        mac,
        ref,
        fireAnalyticsEvent,
        clicked,
        caught
    ]);
    var onClick = (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).useCallback(function(e) {
        var _ref$current$contains, _ref$current;
        clicked.current = (_ref$current$contains = (_ref$current = ref.current) === null || _ref$current === void 0 ? void 0 : _ref$current.contains(e.target)) !== null && _ref$current$contains !== void 0 ? _ref$current$contains : false;
    }, [
        ref,
        clicked
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).useEffect(function() {
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        window.addEventListener('keydown', onKeyDown);
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        window.addEventListener('click', onClick);
        return function() {
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            window.removeEventListener('keydown', onKeyDown);
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            window.removeEventListener('click', onClick);
        };
    }, [
        onKeyDown,
        onClick
    ]);
    return ref;
};

});
parcelRegister("gPdZj", function(module, exports) {
$parcel$export(module.exports, "default", () => $c3fc4273f9997a70$export$2e2bcd8739ae039);

var $5FkrB = parcelRequire("5FkrB");
var $c3fc4273f9997a70$var$AnalyticsContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createContext({
    fireAnalyticsEvent: function fireAnalyticsEvent(_event) {
        return null;
    }
});
var $c3fc4273f9997a70$export$2e2bcd8739ae039 = $c3fc4273f9997a70$var$AnalyticsContext;

});

parcelRegister("cYcab", function(module, exports) {
$parcel$export(module.exports, "ElementSelection", () => $971485fb58fb0558$export$6e6724d89f27411);

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");
var $971485fb58fb0558$export$6e6724d89f27411 = /*#__PURE__*/ function() {
    function ElementSelection(selection) {
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, ElementSelection);
        this.type = selection ? selection.type : 'None';
        if (selection && this.type !== 'None') this.range = selection.getRangeAt(0);
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(ElementSelection, [
        {
            key: "eq",
            value: function eq(selection) {
                if (!selection) return false;
                if (this.range && selection.range) {
                    var _this$range, _this$range2;
                    var startMatches = ((_this$range = this.range) === null || _this$range === void 0 ? void 0 : _this$range.compareBoundaryPoints(Range.START_TO_START, selection.range)) === 0;
                    var endMatches = ((_this$range2 = this.range) === null || _this$range2 === void 0 ? void 0 : _this$range2.compareBoundaryPoints(Range.END_TO_END, selection.range)) === 0;
                    return startMatches && endMatches;
                }
                return this.type === 'None' && selection.type === 'None';
            }
        },
        {
            key: "inside",
            value: function inside(el) {
                var _this$range$commonAnc, _this$range3;
                return el.contains((_this$range$commonAnc = (_this$range3 = this.range) === null || _this$range3 === void 0 ? void 0 : _this$range3.commonAncestorContainer) !== null && _this$range$commonAnc !== void 0 ? _this$range$commonAnc : null);
            }
        },
        {
            key: "select",
            value: function select(el) {
                var range = document.createRange();
                range.selectNodeContents(el);
                var selection = window.getSelection();
                if (selection) {
                    selection.removeAllRanges();
                    selection.addRange(range);
                }
                return ElementSelection.fromWindow();
            }
        }
    ], [
        {
            key: "fromWindow",
            value: function fromWindow() {
                var win = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window;
                return new ElementSelection(win.getSelection());
            }
        }
    ]);
}();

});



parcelRegister("2BMm8", function(module, exports) {
$parcel$export(module.exports, "default", () => $1e648bfa1e354ef2$export$2e2bcd8739ae039);

var $5FkrB = parcelRequire("5FkrB");
var $1e648bfa1e354ef2$var$HardBreak = function HardBreak(_ref) {
    var _ref$forceNewLine = _ref.forceNewLine, forceNewLine = _ref$forceNewLine === void 0 ? false : _ref$forceNewLine;
    // To display an empty line using Shift+Enter, ProseMirror inserts a
    // double <br>. The second <br> is not part of the document, it's just
    // there to make browsers behave properly. The forceNewLine prop in this
    // component replicates this behaviour. If the last child node is a
    // hardBreak, it will also insert a double <br>.
    if (forceNewLine) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("br", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("br", null));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("br", null);
};
var $1e648bfa1e354ef2$export$2e2bcd8739ae039 = $1e648bfa1e354ef2$var$HardBreak;

});

parcelRegister("cLcT3", function(module, exports) {
$parcel$export(module.exports, "default", () => $94a3dee679077c6e$export$2e2bcd8739ae039);

var $5FkrB = parcelRequire("5FkrB");

var $e8kqY = parcelRequire("e8kqY");

var $iGolp = parcelRequire("iGolp");

var $jJH6F = parcelRequire("jJH6F");

var $gPdZj = parcelRequire("gPdZj");

var $bXlPp = parcelRequire("bXlPp");

var $fq8Dd = parcelRequire("fq8Dd");
var $94a3dee679077c6e$var$getCurrentUrlWithHash = function getCurrentUrlWithHash() {
    var hash = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    var url = new URL(window.location.href);
    url.search = ''; // clear any query params so that the page will correctly scroll to the anchor
    url.hash = encodeURIComponent(hash);
    return url.href;
};
function $94a3dee679077c6e$var$hasRightAlignmentMark(marks) {
    if (!marks || !marks.length) return false;
    return marks.some(function(mark) {
        return mark.type.name === 'alignment' && mark.attrs.align === 'end';
    });
}
function $94a3dee679077c6e$var$WrappedHeadingAnchor(_ref) {
    var enableNestedHeaderLinks = _ref.enableNestedHeaderLinks, level = _ref.level, headingId = _ref.headingId, hideFromScreenReader = _ref.hideFromScreenReader;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $gPdZj.default).Consumer, null, function(_ref2) {
        var fireAnalyticsEvent = _ref2.fireAnalyticsEvent;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $fq8Dd.default), {
            enableNestedHeaderLinks: enableNestedHeaderLinks,
            level: level,
            onCopyText: function onCopyText() {
                fireAnalyticsEvent({
                    action: (0, $jJH6F.ACTION).CLICKED,
                    actionSubject: (0, $jJH6F.ACTION_SUBJECT).BUTTON,
                    actionSubjectId: (0, $jJH6F.ACTION_SUBJECT_ID).HEADING_ANCHOR_LINK,
                    eventType: (0, $jJH6F.EVENT_TYPE).UI
                });
                return (0, $bXlPp.copyTextToClipboard)($94a3dee679077c6e$var$getCurrentUrlWithHash(headingId));
            },
            hideFromScreenReader: hideFromScreenReader,
            headingId: headingId
        });
    });
}
function $94a3dee679077c6e$var$Heading(props) {
    var headingId = props.headingId, dataAttributes = props.dataAttributes, allowHeadingAnchorLinks = props.allowHeadingAnchorLinks, marks = props.marks, invisible = props.invisible, localId = props.localId;
    var HX = "h".concat(props.level);
    var mouseEntered = (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).useRef(false);
    var showAnchorLink = !!props.showAnchorLink;
    var isRightAligned = $94a3dee679077c6e$var$hasRightAlignmentMark(marks);
    var enableNestedHeaderLinks = allowHeadingAnchorLinks && allowHeadingAnchorLinks.allowNestedHeaderLinks;
    var headingIdToUse = invisible ? undefined : headingId;
    var mouseEnterHandler = function mouseEnterHandler() {
        if (showAnchorLink && !mouseEntered.current) {
            // Abort TTVC calculation when the mouse hovers over heading. Hovering over
            // heading render heading anchor and inline comment buttons. These user-induced
            // DOM changes are valid reasons to abort the TTVC calculation.
            (0, $iGolp.abortAll)('new_interaction');
            mouseEntered.current = true;
        }
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(HX, {
        id: headingIdToUse,
        "data-local-id": localId,
        "data-renderer-start-pos": dataAttributes['data-renderer-start-pos'],
        onMouseEnter: mouseEnterHandler
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).Fragment, null, showAnchorLink && headingId && isRightAligned && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement($94a3dee679077c6e$var$WrappedHeadingAnchor, {
        level: props.level,
        enableNestedHeaderLinks: enableNestedHeaderLinks,
        headingId: headingId,
        hideFromScreenReader: true
    }), props.children, showAnchorLink && headingId && !isRightAligned && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement($94a3dee679077c6e$var$WrappedHeadingAnchor, {
        level: props.level,
        enableNestedHeaderLinks: enableNestedHeaderLinks,
        headingId: headingId,
        hideFromScreenReader: true
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $e8kqY.default), {
        testId: "visually-hidden-heading-anchor"
    }, showAnchorLink && headingId && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement($94a3dee679077c6e$var$WrappedHeadingAnchor, {
        level: props.level,
        enableNestedHeaderLinks: enableNestedHeaderLinks,
        headingId: headingId
    })));
}
var $94a3dee679077c6e$export$2e2bcd8739ae039 = $94a3dee679077c6e$var$Heading;

});
parcelRegister("bXlPp", function(module, exports) {
$parcel$export(module.exports, "copyTextToClipboard", () => $8b46230357357c0e$export$f980440e1ab4537d);
var $8b46230357357c0e$export$f980440e1ab4537d = function copyTextToClipboard(text) {
    return new Promise(function(resolve, reject) {
        var isApiSupported = !!navigator.clipboard && typeof navigator.clipboard.writeText === 'function';
        if (isApiSupported) navigator.clipboard.writeText(text).then(function() {
            return resolve();
        }, function(e) {
            return reject(e);
        });
        else reject('Clipboard API is not supported');
    });
};

});

parcelRegister("fq8Dd", function(module, exports) {
$parcel$export(module.exports, "HeadingAnchorWrapperClassName", () => $b39ffac6b64a69e3$export$3c9cedc52604835d);
$parcel$export(module.exports, "default", () => $b39ffac6b64a69e3$export$2e2bcd8739ae039);

var $fL8KA = parcelRequire("fL8KA");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $kIXpt = parcelRequire("kIXpt");

var $cYPzS = parcelRequire("cYPzS");

var $eyuDe = parcelRequire("eyuDe");

var $25nEq = parcelRequire("25nEq");

var $kqp0i = parcelRequire("kqp0i");

var $1Vcia = parcelRequire("1Vcia");

var $6HG4S = parcelRequire("6HG4S");

var $5FkrB = parcelRequire("5FkrB");

var $74Zh5 = parcelRequire("74Zh5");

var $3IjMA = parcelRequire("3IjMA");

var $h6AKR = parcelRequire("h6AKR");

var $l7ujg = parcelRequire("l7ujg");

var $3cXxO = parcelRequire("3cXxO");
var $b39ffac6b64a69e3$var$_excluded = [
    "children"
];
function $b39ffac6b64a69e3$var$_callSuper(t, o, e) {
    return o = (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(o), (0, (/*@__PURE__*/$parcel$interopDefault($kIXpt)))(t, $b39ffac6b64a69e3$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(t).constructor) : o.apply(t, e));
}
function $b39ffac6b64a69e3$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($b39ffac6b64a69e3$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $b39ffac6b64a69e3$export$3c9cedc52604835d = 'heading-anchor-wrapper';
var $b39ffac6b64a69e3$var$CopyAnchorWrapperWithRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).forwardRef(function(props, ref) {
    var children = props.children, rest = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(props, $b39ffac6b64a69e3$var$_excluded);
    return (0, $74Zh5.jsx)("span", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, rest, {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: $b39ffac6b64a69e3$export$3c9cedc52604835d,
        ref: ref
    }), children);
});
var $b39ffac6b64a69e3$var$copyAnchorButtonStyles = (0, $74Zh5.css)({
    display: 'inline',
    outline: 'none',
    backgroundColor: 'transparent',
    border: 'none',
    color: "var(--ds-icon, #292A2E)",
    cursor: 'pointer',
    right: 0
});
// Ignored via go/ees005
// eslint-disable-next-line @repo/internal/react/no-class-components
var $b39ffac6b64a69e3$var$HeadingAnchor = /*#__PURE__*/ function(_React$PureComponent) {
    function HeadingAnchor() {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, HeadingAnchor);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = $b39ffac6b64a69e3$var$_callSuper(this, HeadingAnchor, [].concat(args));
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "state", {
            tooltipMessage: '',
            isClicked: false
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "setTooltipState", function(message) {
            var isClicked = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
            _this.setState({
                // TODO: ED-14403 - investigate why this does not translate
                tooltipMessage: _this.props.intl.formatMessage(message),
                isClicked: isClicked
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "getCopyAriaLabel", function() {
            var copyAriaLabel = (0, $3cXxO.headingAnchorLinkMessages).copyAriaLabel;
            return _this.props.intl.formatMessage(copyAriaLabel);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "copyToClipboard", /*#__PURE__*/ function() {
            var _ref = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee(event) {
                var copiedHeadingLinkToClipboard, failedToCopyHeadingLink;
                return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee$(_context) {
                    while(true)switch(_context.prev = _context.next){
                        case 0:
                            copiedHeadingLinkToClipboard = (0, $3cXxO.headingAnchorLinkMessages).copiedHeadingLinkToClipboard, failedToCopyHeadingLink = (0, $3cXxO.headingAnchorLinkMessages).failedToCopyHeadingLink;
                            event.stopPropagation();
                            _context.prev = 2;
                            _context.next = 5;
                            return _this.props.onCopyText();
                        case 5:
                            _this.setTooltipState(copiedHeadingLinkToClipboard, true);
                            _context.next = 11;
                            break;
                        case 8:
                            _context.prev = 8;
                            _context.t0 = _context["catch"](2);
                            _this.setTooltipState(failedToCopyHeadingLink);
                        case 11:
                        case "end":
                            return _context.stop();
                    }
                }, _callee, null, [
                    [
                        2,
                        8
                    ]
                ]);
            }));
            return function(_x) {
                return _ref.apply(this, arguments);
            };
        }());
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "resetMessage", function() {
            _this.setTooltipState((0, $3cXxO.headingAnchorLinkMessages).copyHeadingLinkToClipboard);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "renderAnchorButton", function() {
            var _this$props = _this.props, _this$props$hideFromS = _this$props.hideFromScreenReader, hideFromScreenReader = _this$props$hideFromS === void 0 ? false : _this$props$hideFromS, headingId = _this$props.headingId;
            return (0, $74Zh5.jsx)("button", {
                "data-testid": "anchor-button",
                css: $b39ffac6b64a69e3$var$copyAnchorButtonStyles,
                onMouseLeave: _this.resetMessage,
                onClick: _this.copyToClipboard,
                "aria-hidden": hideFromScreenReader,
                tabIndex: hideFromScreenReader ? undefined : -1,
                "aria-label": hideFromScreenReader ? undefined : _this.state.tooltipMessage,
                "aria-labelledby": hideFromScreenReader ? undefined : headingId,
                type: "button"
            }, (0, $74Zh5.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($h6AKR))), {
                label: _this.getCopyAriaLabel(),
                LEGACY_size: _this.props.level > 3 ? 'small' : 'medium',
                color: _this.state.isClicked ? "var(--ds-icon-selected, #1868DB)" : "var(--ds-icon-subtle, #505258)"
            }));
        });
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($eyuDe)))(HeadingAnchor, _React$PureComponent);
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(HeadingAnchor, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this.resetMessage();
            }
        },
        {
            key: "render",
            value: function render() {
                var tooltipMessage = this.state.tooltipMessage;
                if (tooltipMessage) // We set the key to the message to ensure it remounts when the message
                // changes, so that it correctly repositions.
                // @see https://ecosystem.atlassian.net/projects/AK/queues/issue/AK-6548
                return (0, $74Zh5.jsx)((0, $l7ujg.default), {
                    tag: $b39ffac6b64a69e3$var$CopyAnchorWrapperWithRef,
                    content: tooltipMessage,
                    position: "top",
                    delay: 0,
                    key: tooltipMessage
                }, this.renderAnchorButton());
                return this.renderAnchorButton();
            }
        }
    ]);
}((0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).PureComponent);
var $b39ffac6b64a69e3$export$2e2bcd8739ae039 = (0, $3IjMA.default)($b39ffac6b64a69e3$var$HeadingAnchor);

});
parcelRegister("h6AKR", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c7207a1a192d06bb66aba669d57a8645>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c73f81f06d43cbf9$var$_react = $c73f81f06d43cbf9$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $c73f81f06d43cbf9$var$_link = $c73f81f06d43cbf9$var$_interopRequireDefault((parcelRequire("1buT4")));

var $c73f81f06d43cbf9$var$_link2 = $c73f81f06d43cbf9$var$_interopRequireDefault((parcelRequire("coj3f")));
function $c73f81f06d43cbf9$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for LinkIcon.
 * This component is LinkIcon, with `UNSAFE_fallbackIcon` set to "LinkIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for links, urls, or copy link.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c73f81f06d43cbf9$var$LinkIcon = (props)=>/*#__PURE__*/ $c73f81f06d43cbf9$var$_react.default.createElement($c73f81f06d43cbf9$var$_link.default, Object.assign({
        name: "LinkIcon",
        LEGACY_fallbackIcon: $c73f81f06d43cbf9$var$_link2.default
    }, props));
$c73f81f06d43cbf9$var$LinkIcon.displayName = 'LinkIconMigration';
var $c73f81f06d43cbf9$var$_default = module.exports.default = $c73f81f06d43cbf9$var$LinkIcon;

});
parcelRegister("1buT4", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4f51e3026bdf0966f56fca36d1a42e0f>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0dcec71ac857133b$var$_react = $0dcec71ac857133b$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $0dcec71ac857133b$var$_baseNew = $0dcec71ac857133b$var$_interopRequireDefault((parcelRequire("axuVY")));
function $0dcec71ac857133b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Link".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for links, urls, or copy link.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $0dcec71ac857133b$var$LinkIcon = (props)=>/*#__PURE__*/ $0dcec71ac857133b$var$_react.default.createElement($0dcec71ac857133b$var$_baseNew.default, Object.assign({
        name: "LinkIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8.22 2.22a3.932 3.932 0 1 1 5.56 5.56l-2.25 2.25-1.06-1.06 2.25-2.25a2.432 2.432 0 0 0-3.44-3.44L7.03 5.53 5.97 4.47zm3.06 3.56-5.5 5.5-1.06-1.06 5.5-5.5zM2.22 8.22l2.25-2.25 1.06 1.06-2.25 2.25a2.432 2.432 0 0 0 3.44 3.44l2.25-2.25 1.06 1.06-2.25 2.25a3.932 3.932 0 1 1-5.56-5.56" clip-rule="evenodd"/>`
    }, props));
$0dcec71ac857133b$var$LinkIcon.displayName = 'LinkIcon';
var $0dcec71ac857133b$var$_default = module.exports.default = $0dcec71ac857133b$var$LinkIcon;

});

parcelRegister("coj3f", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $90568121c2e044f4$var$_react = $90568121c2e044f4$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $2SuPM = parcelRequire("2SuPM");
function $90568121c2e044f4$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $90568121c2e044f4$var$LinkIcon = (props)=>/*#__PURE__*/ $90568121c2e044f4$var$_react.default.createElement($2SuPM.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path d="m12.856 5.457-.937.92a1 1 0 0 0 0 1.437 1.047 1.047 0 0 0 1.463 0l.984-.966c.967-.95 2.542-1.135 3.602-.288a2.54 2.54 0 0 1 .203 3.81l-2.903 2.852a2.646 2.646 0 0 1-3.696 0l-1.11-1.09L9 13.57l1.108 1.089c1.822 1.788 4.802 1.788 6.622 0l2.905-2.852a4.558 4.558 0 0 0-.357-6.82c-1.893-1.517-4.695-1.226-6.422.47"/><path d="m11.144 19.543.937-.92a1 1 0 0 0 0-1.437 1.047 1.047 0 0 0-1.462 0l-.985.966c-.967.95-2.542 1.135-3.602.288a2.54 2.54 0 0 1-.203-3.81l2.903-2.852a2.646 2.646 0 0 1 3.696 0l1.11 1.09L15 11.43l-1.108-1.089c-1.822-1.788-4.802-1.788-6.622 0l-2.905 2.852a4.558 4.558 0 0 0 .357 6.82c1.893 1.517 4.695 1.226 6.422-.47"/></g></svg>`
    }, props));
$90568121c2e044f4$var$LinkIcon.displayName = 'LinkIcon';
var $90568121c2e044f4$var$_default = module.exports.default = $90568121c2e044f4$var$LinkIcon;

});


parcelRegister("l7ujg", function(module, exports) {
$parcel$export(module.exports, "default", () => $f601c34d7cc1e826$export$2e2bcd8739ae039);

var $kqp0i = parcelRequire("kqp0i");

var $iYJcE = parcelRequire("iYJcE");

var $25nEq = parcelRequire("25nEq");

var $5FkrB = parcelRequire("5FkrB");

var $7QpUe = parcelRequire("7QpUe");

var $4DEMe = parcelRequire("4DEMe");

var $eVb4V = parcelRequire("eVb4V");

var $hy47X = parcelRequire("hy47X");

var $3UUXy = parcelRequire("3UUXy");

var $afypb = parcelRequire("afypb");

var $9Et5g = parcelRequire("9Et5g");
var $7ujRa = parcelRequire("7ujRa");

var $5K5L9 = parcelRequire("5K5L9");

var $7iRPx = parcelRequire("7iRPx");

var $97BuP = parcelRequire("97BuP");

var $eJh19 = parcelRequire("eJh19");

var $cHrj9 = parcelRequire("cHrj9");

var $gFwXq = parcelRequire("gFwXq");

var $1NNhV = parcelRequire("1NNhV");

var $ayv7G = parcelRequire("ayv7G");
function $f601c34d7cc1e826$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $f601c34d7cc1e826$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $f601c34d7cc1e826$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $f601c34d7cc1e826$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $f601c34d7cc1e826$var$tooltipZIndex = (0, $97BuP.layers).tooltip();
var $f601c34d7cc1e826$var$analyticsAttributes = {
    componentName: 'tooltip',
    packageName: "@atlaskit/tooltip",
    packageVersion: "20.9.0"
};
// Inverts motion direction
var $f601c34d7cc1e826$var$invertedDirection = {
    top: 'bottom',
    bottom: 'top',
    left: 'right',
    right: 'left'
};
/**
 * Converts a Popper placement to it's general direction.
 *
 * @param placement - Popper Placement value, e.g. 'top-start'
 * @returns Popper Direction, e.g. 'top'
 */ var $f601c34d7cc1e826$var$getDirectionFromPlacement = function getDirectionFromPlacement(placement) {
    return placement.split('-')[0];
};
/**
 * __Tooltip__
 *
 * A tooltip is a floating, non-actionable label used to explain a user interface element or feature.
 */ function $f601c34d7cc1e826$var$Tooltip(_ref) {
    var children = _ref.children, _ref$position = _ref.position, position = _ref$position === void 0 ? 'bottom' : _ref$position, _ref$mousePosition = _ref.mousePosition, mousePosition = _ref$mousePosition === void 0 ? 'bottom' : _ref$mousePosition, content = _ref.content, _ref$truncate = _ref.truncate, truncate = _ref$truncate === void 0 ? false : _ref$truncate, _ref$component = _ref.component, Container = _ref$component === void 0 ? (0, $1NNhV.default) : _ref$component, _ref$tag = _ref.tag, TargetContainer = _ref$tag === void 0 ? 'div' : _ref$tag, testId = _ref.testId, _ref$delay = _ref.delay, delay = _ref$delay === void 0 ? 300 : _ref$delay, _ref$onShow = _ref.onShow, onShow = _ref$onShow === void 0 ? (0, $eVb4V.default) : _ref$onShow, _ref$onHide = _ref.onHide, onHide = _ref$onHide === void 0 ? (0, $eVb4V.default) : _ref$onHide, canAppear = _ref.canAppear, _ref$hideTooltipOnCli = _ref.hideTooltipOnClick, hideTooltipOnClick = _ref$hideTooltipOnCli === void 0 ? false : _ref$hideTooltipOnCli, _ref$hideTooltipOnMou = _ref.hideTooltipOnMouseDown, hideTooltipOnMouseDown = _ref$hideTooltipOnMou === void 0 ? false : _ref$hideTooltipOnMou, analyticsContext = _ref.analyticsContext, _ref$strategy = _ref.strategy, strategy = _ref$strategy === void 0 ? 'fixed' : _ref$strategy, _ref$ignoreTooltipPoi = _ref.ignoreTooltipPointerEvents, ignoreTooltipPointerEvents = _ref$ignoreTooltipPoi === void 0 ? false : _ref$ignoreTooltipPoi, _ref$isScreenReaderAn = _ref.isScreenReaderAnnouncementDisabled, isScreenReaderAnnouncementDisabled = _ref$isScreenReaderAn === void 0 ? false : _ref$isScreenReaderAn, shortcut = _ref.shortcut;
    var tooltipPosition = position === 'mouse' ? mousePosition : position;
    var onShowHandler = (0, $4DEMe.usePlatformLeafSyntheticEventHandler)($f601c34d7cc1e826$var$_objectSpread({
        fn: onShow,
        action: 'displayed',
        analyticsData: analyticsContext
    }, $f601c34d7cc1e826$var$analyticsAttributes));
    var onHideHandler = (0, $4DEMe.usePlatformLeafSyntheticEventHandler)($f601c34d7cc1e826$var$_objectSpread({
        fn: onHide,
        action: 'hidden',
        analyticsData: analyticsContext
    }, $f601c34d7cc1e826$var$analyticsAttributes));
    var apiRef = (0, $5FkrB.useRef)(null);
    var _useState = (0, $5FkrB.useState)('hide'), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), state = _useState2[0], setState = _useState2[1];
    var targetRef = (0, $5FkrB.useRef)(null);
    var containerRef = (0, $5FkrB.useRef)(null);
    // This function is deliberately _not_ memoized as it needs to re-run every render
    // to pick up any child ref changes. If you use render props you don't have this issue.
    var setImplicitRefFromChildren = function setImplicitRefFromChildren(node) {
        containerRef.current = node;
        targetRef.current = node ? node.firstElementChild : null;
    };
    // This is memoized and passed into the render props callback.
    var setDirectRef = (0, $5FkrB.useCallback)(function(node) {
        targetRef.current = node;
    }, []);
    // Putting a few things into refs so that we don't have to break memoization
    var stableState = (0, $3UUXy.default)(state);
    // These props are placed in separate refs instead of a single object to reduce memory usage.
    // Placing them in the same object previously caused an increase in the number of JavaScript event listeners
    // before garbage collection.
    var onShowHandlerStable = (0, $3UUXy.default)(onShowHandler);
    var onHideHandlerStable = (0, $3UUXy.default)(onHideHandler);
    var delayStable = (0, $3UUXy.default)(delay);
    var canAppearStable = (0, $3UUXy.default)(canAppear);
    var hasCalledShowHandler = (0, $5FkrB.useRef)(false);
    var start = (0, $5FkrB.useCallback)(function(api) {
        // @ts-ignore
        apiRef.current = api;
        hasCalledShowHandler.current = false;
    }, []);
    var done = (0, $5FkrB.useCallback)(function() {
        if (!apiRef.current) return;
        // Only call onHideHandler if we have called onShowHandler
        if (hasCalledShowHandler.current) onHideHandlerStable.current();
        // @ts-ignore
        apiRef.current = null;
        // @ts-ignore
        hasCalledShowHandler.current = false;
        // just in case
        setState('hide');
    }, [
        onHideHandlerStable
    ]);
    var abort = (0, $5FkrB.useCallback)(function() {
        if (!apiRef.current) return;
        apiRef.current.abort();
        // Only call onHideHandler if we have called onShowHandler
        if (hasCalledShowHandler.current) onHideHandlerStable.current();
        // @ts-ignore
        apiRef.current = null;
    }, [
        onHideHandlerStable
    ]);
    (0, $5FkrB.useEffect)(function mount() {
        return function unmount() {
            if (apiRef.current) abort();
        };
    }, [
        abort
    ]);
    var isDraggingRef = (0, $5FkrB.useRef)(false);
    (0, $5FkrB.useEffect)(function() {
        return (0, $eJh19.register)({
            onRegister: function onRegister(_ref2) {
                var isDragging = _ref2.isDragging;
                isDraggingRef.current = isDragging;
            },
            onDragStart: function onDragStart() {
                var _apiRef$current;
                /**
         * Hiding any visible tooltips when a drag starts because otherwise it
         * looks janky (disappears and reappears), and is not required.
         */ (_apiRef$current = apiRef.current) === null || _apiRef$current === void 0 || _apiRef$current.requestHide({
                    isImmediate: true
                });
                isDraggingRef.current = true;
            },
            onDragEnd: function onDragEnd() {
                isDraggingRef.current = false;
            }
        });
    }, []);
    var tryShowTooltip = (0, $5FkrB.useCallback)(function(source) {
        var _canAppearStable$curr;
        /**
     * Prevent tooltips from being shown during a drag. This can occur with
     * the native drag and drop API, where some pointer events can fire
     * when they should not and lead to jank with tooltips.
     */ if (isDraggingRef.current) return;
        // Another tooltip is has been active but we still have the old `api`
        // around. We need to finish up the last usage.
        // Note: just being safe - this should not happen
        if (apiRef.current && !apiRef.current.isActive()) abort();
        // This tooltip is already active, we can exit
        if (apiRef.current && apiRef.current.isActive()) {
            apiRef.current.keep();
            return;
        }
        /**
     * Check if tooltip is allowed to show.
     *
     * Once a tooltip has started, or has scheduled to start
     * we won't be checking `canAppear` again.
     *
     * - We don't want tooltips to disappear once they are shown
     * - For consistency, we start after a single positive `canAppear`.
     *   Otherwise the amount of times we ask consumers would depend on
     *   how many times we get a "mousemove", which _could_ lead to situations
     *   where moving the mouse could result in a different outcome to if
     *   the mouse was not moved.
     */ if (canAppearStable.current && !((_canAppearStable$curr = canAppearStable.current) !== null && _canAppearStable$curr !== void 0 && _canAppearStable$curr.call(canAppearStable))) return;
        var entry = {
            source: source,
            delay: delayStable.current,
            show: function show(_ref3) {
                var isImmediate = _ref3.isImmediate;
                // Call the onShow handler if it hasn't been called yet
                if (!hasCalledShowHandler.current) {
                    hasCalledShowHandler.current = true;
                    onShowHandlerStable.current();
                }
                setState(isImmediate ? 'show-immediate' : 'fade-in');
            },
            hide: function hide(_ref4) {
                var isImmediate = _ref4.isImmediate;
                if (isImmediate) setState('hide');
                else setState('before-fade-out');
            },
            done: done
        };
        var api = (0, $cHrj9.show)(entry);
        start(api);
    }, [
        canAppearStable,
        delayStable,
        done,
        start,
        abort,
        onShowHandlerStable
    ]);
    var hideTooltipOnEsc = (0, $5FkrB.useCallback)(function() {
        var _apiRef$current2;
        (_apiRef$current2 = apiRef.current) === null || _apiRef$current2 === void 0 || _apiRef$current2.requestHide({
            isImmediate: true
        });
    }, [
        apiRef
    ]);
    (0, $hy47X.default)({
        onClose: hideTooltipOnEsc,
        isDisabled: state === 'hide' || state === 'fade-out'
    });
    (0, $5FkrB.useEffect)(function() {
        if (state === 'hide') return 0, $eVb4V.default;
        if (state === 'before-fade-out') setState('fade-out');
        var unbind = (0, $7QpUe.bind)(window, {
            type: 'scroll',
            listener: function listener() {
                if (apiRef.current) apiRef.current.requestHide({
                    isImmediate: true
                });
            },
            options: {
                capture: true,
                passive: true,
                once: true
            }
        });
        return unbind;
    }, [
        state
    ]);
    var onMouseDown = (0, $5FkrB.useCallback)(function() {
        if (hideTooltipOnMouseDown && apiRef.current) apiRef.current.requestHide({
            isImmediate: true
        });
    }, [
        hideTooltipOnMouseDown
    ]);
    var onClick = (0, $5FkrB.useCallback)(function() {
        if (hideTooltipOnClick && apiRef.current) apiRef.current.requestHide({
            isImmediate: true
        });
    }, [
        hideTooltipOnClick
    ]);
    // Ideally we would be using onMouseEnter here, but
    // because we are binding the event to the target parent
    // we need to listen for the mouseover of all sub elements
    // This means when moving along a tooltip we are quickly toggling
    // between api.requestHide and api.keep. This it not ideal
    var onMouseOver = (0, $5FkrB.useCallback)(function(event) {
        // Ignoring events from the container ref
        if (containerRef.current && event.target === containerRef.current) return;
        // Using prevent default as a signal that parent tooltips
        if (event.defaultPrevented) return;
        event.preventDefault();
        var source = position === 'mouse' ? {
            type: 'mouse',
            // TODO: ideally not recalculating this object each time
            mouse: (0, $ayv7G.getMousePosition)({
                left: event.clientX,
                top: event.clientY
            })
        } : {
            type: 'keyboard'
        };
        tryShowTooltip(source);
    }, [
        position,
        tryShowTooltip
    ]);
    // Ideally we would be using onMouseEnter here, but
    // because we are binding the event to the target parent
    // we need to listen for the mouseout of all sub elements
    // This means when moving along a tooltip we are quickly toggling
    // between api.requestHide and api.keep. This it not ideal
    var onMouseOut = (0, $5FkrB.useCallback)(function(event) {
        // Ignoring events from the container ref
        if (containerRef.current && event.target === containerRef.current) return;
        // Using prevent default as a signal that parent tooltips
        if (event.defaultPrevented) return;
        event.preventDefault();
        if (apiRef.current) apiRef.current.requestHide({
            isImmediate: false
        });
    }, []);
    var onMouseMove = position === 'mouse' ? function(event) {
        var _apiRef$current3;
        if ((_apiRef$current3 = apiRef.current) !== null && _apiRef$current3 !== void 0 && _apiRef$current3.isActive()) apiRef.current.mousePosition = (0, $ayv7G.getMousePosition)({
            left: event.clientX,
            top: event.clientY
        });
    } : undefined;
    var onMouseOverTooltip = (0, $5FkrB.useCallback)(function() {
        if (apiRef.current && apiRef.current.isActive()) {
            apiRef.current.keep();
            return;
        }
    }, []);
    var onFocus = (0, $5FkrB.useCallback)(function(e) {
        // Check if focus-visible
        // Prevents tooltips from showing when focus is not visible,
        // i.e., when focus is moved onto tooltip trigger inside a popup on open
        try {
            if (!e.target.matches(':focus-visible')) return;
        } catch (_) {
        // Ignore errors from environments that don't support :focus-visible
        }
        // TODO: this does not play well with `hideTooltipOnMouseDown`
        // as "focus" will occur after the "mousedown".
        tryShowTooltip({
            type: 'keyboard'
        });
    }, [
        tryShowTooltip
    ]);
    var onBlur = (0, $5FkrB.useCallback)(function() {
        if (apiRef.current) apiRef.current.requestHide({
            isImmediate: false
        });
    }, []);
    var onAnimationFinished = (0, $5FkrB.useCallback)(function(transition) {
        // Using lastState here because motion is not picking up the latest value
        if (transition === 'exiting' && stableState.current === 'fade-out' && apiRef.current) // @ts-ignore: refs are writeable
        apiRef.current.finishHideAnimation();
    }, [
        stableState
    ]);
    // Doing a cast because typescript is struggling to narrow the type
    var CastTargetContainer = TargetContainer;
    var shouldRenderTooltipPopup = state !== 'hide' && Boolean(content);
    var shouldRenderHiddenContent = !isScreenReaderAnnouncementDisabled && shouldRenderTooltipPopup;
    var shouldRenderTooltipChildren = state !== 'hide' && state !== 'fade-out';
    var handleOpenLayerObserverCloseSignal = (0, $5FkrB.useCallback)(function() {
        var _apiRef$current4;
        (_apiRef$current4 = apiRef.current) === null || _apiRef$current4 === void 0 || _apiRef$current4.requestHide({
            isImmediate: true
        });
    }, []);
    (0, $afypb.useNotifyOpenLayerObserver)({
        // Layer is only visually open if both the tooltip popup (container) and children are rendered.
        isOpen: shouldRenderTooltipPopup && shouldRenderTooltipChildren,
        /**
     * We don't strictly need to provide an onClose callback at this time, as there is
     * already code that handles hiding the tooltip when a drag is started (and the only
     * usage right now is closing all layers when the user resizes the side nav).
     *
     * However, for future-proofing and semantic reasons, it makes sense to close the tooltip
     * whenever the open layer observer requests a close.
     */ onClose: handleOpenLayerObserverCloseSignal
    });
    var getReferenceElement = function getReferenceElement() {
        var _apiRef$current5;
        if (position === 'mouse' && (_apiRef$current5 = apiRef.current) !== null && _apiRef$current5 !== void 0 && _apiRef$current5.mousePosition) {
            var _apiRef$current6;
            return (_apiRef$current6 = apiRef.current) === null || _apiRef$current6 === void 0 ? void 0 : _apiRef$current6.mousePosition;
        }
        return targetRef.current || undefined;
    };
    var tooltipIdForHiddenContent = (0, $gFwXq.default)('tooltip', shouldRenderHiddenContent);
    var tooltipTriggerProps = {
        onMouseOver: onMouseOver,
        onMouseOut: onMouseOut,
        onMouseMove: onMouseMove,
        onMouseDown: onMouseDown,
        onClick: onClick,
        onFocus: onFocus,
        onBlur: onBlur
    };
    // Don't set `data-testid` unless it's defined, as it's not in the interface.
    if (testId) // Adding `data-testid` to the TriggerProps interface breaks Buttons, so we use type assertion
    tooltipTriggerProps['data-testid'] = "".concat(testId, "--container");
    // This useEffect is purely for managing the aria attribute when using the
    // wrapped children approach.
    var isChildrenAFunction = typeof children === 'function';
    (0, $5FkrB.useEffect)(function() {
        if (isChildrenAFunction) return;
        // If `children` is _not_ a function, we are stepping outside of the public
        // API to add a `aria-describedby` attribute.
        var target = targetRef.current;
        if (!target || !tooltipIdForHiddenContent) return;
        target.setAttribute('aria-describedby', tooltipIdForHiddenContent);
        return function() {
            return target.removeAttribute('aria-describedby');
        };
    }, [
        isChildrenAFunction,
        tooltipIdForHiddenContent
    ]);
    var hiddenContent = shouldRenderHiddenContent ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("span", {
        "data-testid": testId ? "".concat(testId, "-hidden") : undefined,
        hidden: true,
        id: tooltipIdForHiddenContent
    }, typeof content === 'function' ? content({}) : content) : null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).Fragment, null, typeof children === 'function' ? /*#__PURE__*/ // once we deprecate the wrapped approach, we can put the aria
    // attribute back into the tooltipTriggerProps and make it required
    // instead of optional in `types`
    (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).Fragment, null, children($f601c34d7cc1e826$var$_objectSpread($f601c34d7cc1e826$var$_objectSpread({}, tooltipTriggerProps), {}, {
        'aria-describedby': tooltipIdForHiddenContent,
        ref: setDirectRef
    })), hiddenContent) : /*#__PURE__*/ // @ts-ignore
    (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(CastTargetContainer, (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, tooltipTriggerProps, {
        ref: setImplicitRefFromChildren,
        role: "presentation"
    }), children, hiddenContent), shouldRenderTooltipPopup ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $7iRPx.default), {
        zIndex: $f601c34d7cc1e826$var$tooltipZIndex
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $5K5L9.Popper), {
        placement: tooltipPosition,
        referenceElement: getReferenceElement(),
        strategy: strategy
    }, function(_ref5) {
        var ref = _ref5.ref, style = _ref5.style, update = _ref5.update, placement = _ref5.placement;
        // Invert the entrance and exit directions.
        // E.g. a tooltip's position is on the 'right', it should enter from and exit to the 'left'
        // This gives the effect the tooltip is appearing from the target
        var direction = position === 'mouse' ? undefined : $f601c34d7cc1e826$var$invertedDirection[$f601c34d7cc1e826$var$getDirectionFromPlacement(placement)];
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $9Et5g.default), {
            appear: true
        }, shouldRenderTooltipChildren && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $7ujRa.default), {
            distance: "constant",
            entranceDirection: direction,
            exitDirection: direction,
            onFinish: onAnimationFinished,
            duration: state !== 'show-immediate' ? 'medium' : 'none'
        }, function(_ref6) {
            var className = _ref6.className;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(Container, {
                ref: ref,
                className: "Tooltip ".concat(className),
                style: $f601c34d7cc1e826$var$_objectSpread($f601c34d7cc1e826$var$_objectSpread({}, style), ignoreTooltipPointerEvents && {
                    pointerEvents: 'none'
                }),
                truncate: truncate,
                placement: tooltipPosition,
                testId: getReferenceElement() ? testId : testId && "".concat(testId, "--unresolved"),
                onMouseOut: onMouseOut,
                onMouseOver: onMouseOverTooltip,
                shortcut: shortcut
            }, typeof content === 'function' ? content({
                update: update
            }) : content);
        }));
    })) : null);
}
var $f601c34d7cc1e826$export$2e2bcd8739ae039 = $f601c34d7cc1e826$var$Tooltip;

});
parcelRegister("4DEMe", function(module, exports) {
$parcel$export(module.exports, "usePlatformLeafSyntheticEventHandler", () => $360a6f655e5f9f8d$export$1a04351537078b55);

var $25nEq = parcelRequire("25nEq");

var $5FkrB = parcelRequire("5FkrB");

var $cOsWw = parcelRequire("cOsWw");

var $5SnFU = parcelRequire("5SnFU");
function $360a6f655e5f9f8d$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $360a6f655e5f9f8d$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $360a6f655e5f9f8d$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $360a6f655e5f9f8d$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $360a6f655e5f9f8d$export$1a04351537078b55(_ref) {
    var fn = _ref.fn, action = _ref.action, componentName = _ref.componentName, packageName = _ref.packageName, packageVersion = _ref.packageVersion, analyticsData = _ref.analyticsData;
    var _useAnalyticsEvents = (0, $cOsWw.useAnalyticsEvents)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
    // We put analyticsData and fn in a ref so that we don't need to break
    // memoization.
    // Generally these could be defined by consumers inline
    // and so we do this to avoid breaking memoization of useCallback
    var dataRef = (0, $5SnFU.useTrackedRef)(analyticsData);
    var fnRef = (0, $5SnFU.useTrackedRef)(fn);
    var handler = (0, $5FkrB.useCallback)(function() {
        var analyticsEvent = createAnalyticsEvent({
            action: action,
            actionSubject: componentName,
            attributes: {
                componentName: componentName,
                packageName: packageName,
                packageVersion: packageVersion
            }
        });
        // To avoid wrapping this component in AnalyticsContext we manually
        // push the parent context's meta data into the context.
        // Note: this new 'context'
        var context = $360a6f655e5f9f8d$var$_objectSpread({
            componentName: componentName,
            packageName: packageName,
            packageVersion: packageVersion
        }, dataRef.current);
        analyticsEvent.context.push(context);
        // fire an event on the atlaskit channel
        var clone = analyticsEvent.clone();
        if (clone) clone.fire('atlaskit');
        fnRef.current(analyticsEvent);
    }, [
        // These are strings and won't change
        action,
        componentName,
        packageName,
        packageVersion,
        // This function is memoized in the context
        createAnalyticsEvent,
        // these are a stable ref because of the useTrackedRef hook
        dataRef,
        fnRef
    ]);
    return handler;
}

});

parcelRegister("afypb", function(module, exports) {
$parcel$export(module.exports, "useNotifyOpenLayerObserver", () => $7765fe448f99173d$export$469bb693f11edc7f);

var $5FkrB = parcelRequire("5FkrB");

var $8lFT1 = parcelRequire("8lFT1");

var $bQwYl = parcelRequire("bQwYl");
function $7765fe448f99173d$export$469bb693f11edc7f(_ref) {
    var isOpen = _ref.isOpen, type = _ref.type, onClose = _ref.onClose;
    var context = (0, $5FkrB.useContext)((0, $8lFT1.OpenLayerObserverContext));
    var namespace = (0, $bQwYl.useOpenLayerObserverNamespace)();
    (0, $5FkrB.useEffect)(function() {
        /**
     * Registers the `onClose` callback with the OpenLayerObserver.
     */ if (context === null) return;
        if (!isOpen) /**
       * If the layer is not open, we are not registering the `onClose` callback.
       * This is important to prevent the `onClose` from being called for layers that
       * are not open.
       *
       * Some consumers mistakenly pass "toggle" functions to `onClose` callbacks for
       * layer components, as Popup, e.g. `onClose={() => setIsOpen(!isOpen)}`.
       */ return;
        return context.onClose(onClose, {
            namespace: namespace,
            type: type
        });
    }, [
        context,
        isOpen,
        namespace,
        onClose,
        type
    ]);
}

});
parcelRegister("8lFT1", function(module, exports) {
$parcel$export(module.exports, "OpenLayerObserverContext", () => $6140c6a9b86f59e0$export$5fbf4d7fae6cdc00);

var $5FkrB = parcelRequire("5FkrB");
var $6140c6a9b86f59e0$export$5fbf4d7fae6cdc00 = /*#__PURE__*/ (0, $5FkrB.createContext)(null);

});

parcelRegister("bQwYl", function(module, exports) {
$parcel$export(module.exports, "useOpenLayerObserverNamespace", () => $89fe20abd916f861$export$1d57e79091cc3046);

var $5FkrB = parcelRequire("5FkrB");

var $7DfF0 = parcelRequire("7DfF0");
function $89fe20abd916f861$export$1d57e79091cc3046() {
    var namespace = (0, $5FkrB.useContext)((0, $7DfF0.OpenLayerObserverNamespaceContext));
    return namespace;
}

});
parcelRegister("7DfF0", function(module, exports) {
$parcel$export(module.exports, "OpenLayerObserverNamespaceContext", () => $58e852b90ce47561$export$644a49f3b8c50fcd);

var $5FkrB = parcelRequire("5FkrB");
var $58e852b90ce47561$export$644a49f3b8c50fcd = /*#__PURE__*/ (0, $5FkrB.createContext)(null);

});



parcelRegister("9Et5g", function(module, exports) {
$parcel$export(module.exports, "useExitingPersistence", () => $706e68f369439541$export$3b6f38abbdcbd000);
$parcel$export(module.exports, "default", () => $706e68f369439541$export$2e2bcd8739ae039);

var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");
/**
 * Internally we will be playing with an element that will always have a key defined.
 */ /**
 * Internal data passed to child motions.
 */ // We define empty context here so the object doesn't change.
var $706e68f369439541$var$emptyContext = {
    // Motions will always appear if not inside a exiting persistence component.
    appear: true,
    isExiting: false
};
/**
 * __Exiting context__
 *
 * An exiting context.
 */ var $706e68f369439541$var$ExitingContext = /*#__PURE__*/ (0, $5FkrB.createContext)($706e68f369439541$var$emptyContext);
/**
 * This method will wrap any React element with a context provider. We're using context (instead of
 * cloneElement) so we can communicate between multiple elements without the need of prop drilling
 * (results in a better API for consumers).
 */ var $706e68f369439541$var$wrapChildWithContextProvider = function wrapChildWithContextProvider(child) {
    var value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $706e68f369439541$var$emptyContext;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement($706e68f369439541$var$ExitingContext.Provider, {
        key: "".concat(child.key, "-provider"),
        value: value
    }, child);
};
/**
 * This function will convert all children types to an array while also filtering out non-valid React elements.
 */ var $706e68f369439541$var$childrenToArray = function childrenToArray(children) {
    var childrenAsArray = [];
    // We convert children to an array using this helper method as it will add keys to children that do not
    // have them, such as when we have hardcoded children that are conditionally rendered.
    (0, $5FkrB.Children).toArray(children).forEach(function(child) {
        // We ignore any boolean children to make our code a little more simple later on,
        // and also filter out any falsies (empty strings, nulls, and undefined).
        if (typeof child !== 'boolean' && Boolean(child)) // Children WILL have a key after being forced into an array using the React.Children helper.
        childrenAsArray.push(child);
    });
    return childrenAsArray;
};
var $706e68f369439541$var$spliceNewElementsIntoPrevious = function spliceNewElementsIntoPrevious(current, previous) {
    var splicedChildren = previous.concat([]);
    var previousMap = $706e68f369439541$var$childrenToObj(previous);
    for(var i = 0; i < current.length; i++){
        var child = current[i];
        var childIsNew = !previousMap[child.key];
        if (childIsNew) // This will insert the new element after the previous element.
        splicedChildren.splice(i + 1, 0, child);
    }
    return splicedChildren;
};
var $706e68f369439541$var$childrenToObj = function childrenToObj(children) {
    return children.reduce(function(acc, child) {
        acc[child.key] = child;
        return acc;
    }, {});
};
var $706e68f369439541$var$getMissingKeys = function getMissingKeys(current, previous) {
    var currentMapKeys = new Set(current.map(function(child) {
        return child.key;
    }));
    var missing = new Set();
    for(var i = 0; i < previous.length; i++){
        var element = previous[i];
        var _key = element.key;
        if (!currentMapKeys.has(_key)) missing.add(_key);
    }
    return missing;
};
/**
 * How does this component work?
 *
 * It looks at changes in its children to see what is removed.
 *
 * If a child is removed it clones it and wraps it with context providing an `onFinish` callback.
 *
 * The cloned child will call the `onFinish` when it finishes its exit animation,
 * which lets `ExitingPersistence` know to stop rendering it.
 */ /**
 * __ExitingPersistence__
 *
 * Useful for enabling elements to persist and animate away when they are removed from the DOM.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/motion/docs/entering-motions)
 */ var $706e68f369439541$var$ExitingPersistence = /*#__PURE__*/ (0, $5FkrB.memo)(function(_ref) {
    var _ref$appear = _ref.appear, appear = _ref$appear === void 0 ? false : _ref$appear, children = _ref.children, exitThenEnter = _ref.exitThenEnter;
    var _useState = (0, $5FkrB.useState)([
        null,
        children
    ]), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), stateChildren = _useState2[0], setChildren = _useState2[1];
    var _useState3 = (0, $5FkrB.useState)([]), _useState4 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState3, 2), exitingChildren = _useState4[0], setExitingChildren = _useState4[1];
    var _useState5 = (0, $5FkrB.useState)(function() {
        return {
            appear: appear,
            isExiting: false
        };
    }), _useState6 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState5, 2), defaultContext = _useState6[0], setDefaultContext = _useState6[1];
    (0, $5FkrB.useEffect)(function() {
        if (!defaultContext.appear) setDefaultContext({
            appear: true,
            isExiting: false
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    /**
   * NOTE: This is a workaround for the test case written in Jira where the stateChildren is a boolean value because
   * useState is mocked to return a boolean value.
   */ if (typeof stateChildren === 'boolean') return children;
    var _stateChildren = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(stateChildren, 2), previousChildren = _stateChildren[0], currentChildren = _stateChildren[1];
    var previous = $706e68f369439541$var$childrenToArray(previousChildren);
    var current = $706e68f369439541$var$childrenToArray(currentChildren);
    if (currentChildren !== children) setChildren([
        currentChildren,
        children
    ]);
    var missingKeys = $706e68f369439541$var$getMissingKeys(current, previous);
    var isSomeChildRemoved = !!missingKeys.size;
    var visibleChildren = current;
    if (isSomeChildRemoved) visibleChildren = $706e68f369439541$var$spliceNewElementsIntoPrevious(current, previous);
    if (exitThenEnter) {
        if (exitingChildren.length) visibleChildren = exitingChildren;
        else {
            var nextExitingChildren = visibleChildren.filter(function(child) {
                return missingKeys.has(child.key);
            });
            if (nextExitingChildren.length) setExitingChildren(nextExitingChildren);
        }
    }
    if (missingKeys.size) visibleChildren = visibleChildren.map(function(child) {
        var isExiting = missingKeys.has(child.key);
        return $706e68f369439541$var$wrapChildWithContextProvider(child, {
            appear: true,
            isExiting: isExiting,
            onFinish: isExiting ? function() {
                missingKeys.delete(child.key);
                if (missingKeys.size === 0) {
                    setChildren([
                        null,
                        children
                    ]);
                    setExitingChildren([]);
                }
            } : undefined
        });
    });
    else visibleChildren = visibleChildren.map(function(child) {
        return $706e68f369439541$var$wrapChildWithContextProvider(child, defaultContext);
    });
    return visibleChildren;
});
var $706e68f369439541$export$3b6f38abbdcbd000 = function useExitingPersistence() {
    return (0, $5FkrB.useContext)($706e68f369439541$var$ExitingContext);
};
$706e68f369439541$var$ExitingPersistence.displayName = 'ExitingPersistence';
var $706e68f369439541$export$2e2bcd8739ae039 = $706e68f369439541$var$ExitingPersistence;

});

parcelRegister("7ujRa", function(module, exports) {
$parcel$export(module.exports, "default", () => $573abcdb18932d22$export$2e2bcd8739ae039);

var $5FkrB = parcelRequire("5FkrB");

var $7RWCv = parcelRequire("7RWCv");
var $573abcdb18932d22$var$invertedDirection = {
    top: 'bottom',
    bottom: 'top',
    left: 'right',
    right: 'left'
};
/**
 * Props for controlling the behavior of the FadeIn animation
 */ /**
 * __FadeIn__
 *
 * Useful for fading in one or more elements.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/motion/docs/entering-motions)
 */ var $573abcdb18932d22$var$FadeIn = function FadeIn(_ref) {
    var children = _ref.children, _ref$duration = _ref.duration, duration = _ref$duration === void 0 ? 'large' : _ref$duration, entranceDirection = _ref.entranceDirection, exitDirection = _ref.exitDirection, _ref$distance = _ref.distance, distance = _ref$distance === void 0 ? 'proportional' : _ref$distance, onFinish = _ref.onFinish, isPaused = _ref.isPaused;
    var invertedEntranceDirection = entranceDirection !== undefined ? $573abcdb18932d22$var$invertedDirection[entranceDirection] : undefined;
    var isExitDirect = Boolean(exitDirection || invertedEntranceDirection) ? "fade-out-from-".concat(exitDirection || invertedEntranceDirection).concat(distance === 'proportional' ? '' : '-constant') : 'fade-out';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $7RWCv.default), {
        duration: duration,
        enteringAnimation: entranceDirection ? "fade-in-from-".concat(entranceDirection).concat(distance === 'proportional' ? '' : '-constant') : 'fade-in',
        exitingAnimation: isExitDirect,
        animationTimingFunction: "ease-in-out",
        onFinish: onFinish,
        isPaused: isPaused
    }, children);
};
var $573abcdb18932d22$export$2e2bcd8739ae039 = $573abcdb18932d22$var$FadeIn;

});
parcelRegister("7RWCv", function(module, exports) {
$parcel$export(module.exports, "default", () => $5baaf4612228c082$export$2e2bcd8739ae039);
/* keyframes-motion.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");

var $hSzjq = parcelRequire("hSzjq");

var $VfFcJ = parcelRequire("VfFcJ");

var $fiuq8 = parcelRequire("fiuq8");

var $9Et5g = parcelRequire("9Et5g");

var $k0MSS = parcelRequire("k0MSS");
var $5baaf4612228c082$var$zoomIn = null;
var $5baaf4612228c082$var$zoomOut = null;
var $5baaf4612228c082$var$fadeIn = null;
var $5baaf4612228c082$var$fadeOut = null;
var $5baaf4612228c082$var$fadeInFromTop = null;
var $5baaf4612228c082$var$fadeOutFromTop = null;
var $5baaf4612228c082$var$fadeInFromLeft = null;
var $5baaf4612228c082$var$fadeOutFromLeft = null;
var $5baaf4612228c082$var$fadeInFromBottom = null;
var $5baaf4612228c082$var$fadeOutFromBottom = null;
var $5baaf4612228c082$var$fadeInFromRight = null;
var $5baaf4612228c082$var$fadeOutFromRight = null;
var $5baaf4612228c082$var$fadeInFromTopConstant = null;
var $5baaf4612228c082$var$fadeOutFromTopConstant = null;
var $5baaf4612228c082$var$fadeInFromLeftConstant = null;
var $5baaf4612228c082$var$fadeOutFromLeftConstant = null;
var $5baaf4612228c082$var$fadeInFromBottomConstant = null;
var $5baaf4612228c082$var$fadeOutFromBottomConstant = null;
var $5baaf4612228c082$var$fadeInFromRightConstant = null;
var $5baaf4612228c082$var$fadeOutFromRightConstant = null;
var $5baaf4612228c082$var$slideInFromTop = null;
var $5baaf4612228c082$var$slideOutFromTop = null;
var $5baaf4612228c082$var$slideInFromRight = null;
var $5baaf4612228c082$var$slideOutFromRight = null;
var $5baaf4612228c082$var$slideInFromBottom = null;
var $5baaf4612228c082$var$slideOutFromBottom = null;
var $5baaf4612228c082$var$slideInFromLeft = null;
var $5baaf4612228c082$var$slideOutFromLeft = null;
/**
 * These are props that motions should use as their external props for consumers.
 * See [FadeIn](packages/helpers/motion/src/entering/fade-in.tsx) for an example usage.
 */ /**
 * This is the base INTERNAL component used for all other entering motions.
 * This does not need Javascript to execute on the client so it will run immediately
 * for any SSR rendered React apps before the JS has executed.
 */ var $5baaf4612228c082$var$EnteringMotion = function EnteringMotion(_ref) {
    var children = _ref.children, animationTimingFunction = _ref.animationTimingFunction, _ref$animationTimingF = _ref.animationTimingFunctionExiting, animationTimingFunctionExiting = _ref$animationTimingF === void 0 ? animationTimingFunction : _ref$animationTimingF, enteringAnimation = _ref.enteringAnimation, _ref$exitingAnimation = _ref.exitingAnimation, exitingAnimation = _ref$exitingAnimation === void 0 ? enteringAnimation : _ref$exitingAnimation, isPaused = _ref.isPaused, onFinishMotion = _ref.onFinish, _ref$duration = _ref.duration, duration = _ref$duration === void 0 ? 'large' : _ref$duration;
    var staggered = (0, $k0MSS.useStaggeredEntrance)();
    var _useExitingPersistenc = (0, $9Et5g.useExitingPersistence)(), isExiting = _useExitingPersistenc.isExiting, onExitFinished = _useExitingPersistenc.onFinish, appear = _useExitingPersistenc.appear;
    var setTimeout = (0, $fiuq8.useSetTimeout)();
    var paused = isPaused || !staggered.isReady;
    var delay = isExiting ? 0 : staggered.delay;
    var state = isExiting ? 'exiting' : 'entering';
    var _useState = (0, $5FkrB.useState)(appear), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), hasAnimationStyles = _useState2[0], setHasAnimationStyles = _useState2[1];
    (0, $5FkrB.useEffect)(function() {
        // Tracking this to prevent changing state on an unmounted component
        var isCancelled = false;
        if (paused) return;
        // On initial mount if elements aren't set to animate on appear, we return early and callback
        if (!appear) {
            onFinishMotion && onFinishMotion(state);
            return;
        }
        /**
     * Updates relevant state.
     * Called when the animation is finished, or immediately with reduced motion.
     */ var onAnimationEnd = function onAnimationEnd() {
            if (state === 'exiting') // Updates the `ExitingPersistence` to remove this child
            onExitFinished === null || onExitFinished === void 0 || onExitFinished();
            if (!isCancelled) setHasAnimationStyles(false);
            onFinishMotion === null || onFinishMotion === void 0 || onFinishMotion(state);
        };
        if ((0, $hSzjq.isReducedMotion)()) {
            // If there is reduced motion there is no exit animation, so call this immediately
            onAnimationEnd();
            return;
        }
        // Elements may need animation styles back after initial mount (they could animate out)
        setHasAnimationStyles(true);
        // Queue `onAnimationEnd` for after the animation has finished
        setTimeout(onAnimationEnd, isExiting ? (0, $VfFcJ.exitingDurations)[duration] : (0, $VfFcJ.durations)[duration] + delay);
        return function() {
            isCancelled = true;
        };
    // We ignore this for onFinishMotion as consumers could potentially inline the function
    // which would then trigger this effect every re-render.
    // We want to make it easier for consumers so we go down this path unfortunately.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        onExitFinished,
        state,
        isExiting,
        duration,
        delay,
        paused,
        setTimeout
    ]);
    return children({
        ref: staggered.ref,
        // @ts-expect-error: `ax` is not typed correctly
        className: hasAnimationStyles ? (0, $970q7.default)([
            (0, $970q7.default)([
                "_1o51eoah _1y0co91m _1bumglyw _sedtglyw"
            ]),
            paused && (0, $970q7.default)([
                "_1y0ctrqk"
            ]),
            duration === 'small' && (0, $970q7.default)([
                "_5sag1yx9"
            ]),
            duration === 'medium' && (0, $970q7.default)([
                "_5sag1ttt"
            ]),
            duration === 'large' && (0, $970q7.default)([
                "_5sagpwmj"
            ]),
            isExiting && duration === 'small' && (0, $970q7.default)([
                "_5sag14ed"
            ]),
            isExiting && duration === 'medium' && (0, $970q7.default)([
                "_5sagluct"
            ]),
            isExiting && duration === 'large' && (0, $970q7.default)([
                "_5sag1ttt"
            ]),
            isExiting && (0, $970q7.default)([
                "_ju255cps _1o51q7pw"
            ]),
            !isExiting && animationTimingFunction === 'linear' && (0, $970q7.default)([
                "_1pglp3kn"
            ]),
            !isExiting && animationTimingFunction === 'ease-out' && (0, $970q7.default)([
                "_1pgldkwg"
            ]),
            !isExiting && animationTimingFunction === 'ease-in' && (0, $970q7.default)([
                "_1pgl1nzg"
            ]),
            !isExiting && animationTimingFunction === 'ease-in-40-out' && (0, $970q7.default)([
                "_1pgl5y64"
            ]),
            !isExiting && animationTimingFunction === 'ease-in-60-out' && (0, $970q7.default)([
                "_1pgl1ddy"
            ]),
            !isExiting && animationTimingFunction === 'ease-in-80-out' && (0, $970q7.default)([
                "_1pglannl"
            ]),
            !isExiting && animationTimingFunction === 'ease-in-out' && (0, $970q7.default)([
                "_1pgl1fu8"
            ]),
            isExiting && animationTimingFunction === 'linear' && (0, $970q7.default)([
                "_1pglp3kn"
            ]),
            isExiting && animationTimingFunctionExiting === 'ease-out' && (0, $970q7.default)([
                "_1pgldkwg"
            ]),
            isExiting && animationTimingFunctionExiting === 'ease-in' && (0, $970q7.default)([
                "_1pgl1nzg"
            ]),
            isExiting && animationTimingFunctionExiting === 'ease-in-40-out' && (0, $970q7.default)([
                "_1pgl5y64"
            ]),
            isExiting && animationTimingFunctionExiting === 'ease-in-60-out' && (0, $970q7.default)([
                "_1pgl1ddy"
            ]),
            isExiting && animationTimingFunctionExiting === 'ease-in-80-out' && (0, $970q7.default)([
                "_1pglannl"
            ]),
            isExiting && animationTimingFunctionExiting === 'ease-in-out' && (0, $970q7.default)([
                "_1pgl1fu8"
            ]),
            (!isExiting && enteringAnimation === 'fade-in' || isExiting && exitingAnimation === 'fade-in') && (0, $970q7.default)([
                "_j7hq1cgr"
            ]),
            (!isExiting && enteringAnimation === 'fade-out' || isExiting && exitingAnimation === 'fade-out') && (0, $970q7.default)([
                "_j7hq1lln"
            ]),
            (!isExiting && enteringAnimation === 'zoom-in' || isExiting && exitingAnimation === 'zoom-in') && (0, $970q7.default)([
                "_j7hqe8p0"
            ]),
            (!isExiting && enteringAnimation === 'zoom-out' || isExiting && exitingAnimation === 'zoom-out') && (0, $970q7.default)([
                "_j7hqy6ql"
            ]),
            (!isExiting && enteringAnimation === 'slide-in-from-top' || isExiting && exitingAnimation === 'slide-in-from-top') && (0, $970q7.default)([
                "_j7hqqshu"
            ]),
            (!isExiting && enteringAnimation === 'slide-out-from-top' || isExiting && exitingAnimation === 'slide-out-from-top') && (0, $970q7.default)([
                "_j7hq7ri4"
            ]),
            (!isExiting && enteringAnimation === 'slide-in-from-right' || isExiting && exitingAnimation === 'slide-in-from-right') && (0, $970q7.default)([
                "_j7hqdfjr"
            ]),
            (!isExiting && enteringAnimation === 'slide-out-from-right' || isExiting && exitingAnimation === 'slide-out-from-right') && (0, $970q7.default)([
                "_j7hqonfj"
            ]),
            (!isExiting && enteringAnimation === 'slide-in-from-bottom' || isExiting && exitingAnimation === 'slide-in-from-bottom') && (0, $970q7.default)([
                "_j7hq1liq"
            ]),
            (!isExiting && enteringAnimation === 'slide-out-from-bottom' || isExiting && exitingAnimation === 'slide-out-from-bottom') && (0, $970q7.default)([
                "_j7hqhnf1"
            ]),
            (!isExiting && enteringAnimation === 'slide-in-from-left' || isExiting && exitingAnimation === 'slide-in-from-left') && (0, $970q7.default)([
                "_j7hq1bh1"
            ]),
            (!isExiting && enteringAnimation === 'slide-out-from-left' || isExiting && exitingAnimation === 'slide-out-from-left') && (0, $970q7.default)([
                "_j7hqj08w"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-top' || isExiting && exitingAnimation === 'fade-in-from-top') && (0, $970q7.default)([
                "_j7hq2iua"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-top' || isExiting && exitingAnimation === 'fade-out-from-top') && (0, $970q7.default)([
                "_j7hq39va"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-left' || isExiting && exitingAnimation === 'fade-in-from-left') && (0, $970q7.default)([
                "_j7hq15m2"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-left' || isExiting && exitingAnimation === 'fade-out-from-left') && (0, $970q7.default)([
                "_j7hq1yiv"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-bottom' || isExiting && exitingAnimation === 'fade-in-from-bottom') && (0, $970q7.default)([
                "_j7hq1w00"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-bottom' || isExiting && exitingAnimation === 'fade-out-from-bottom') && (0, $970q7.default)([
                "_j7hqzy3z"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-right' || isExiting && exitingAnimation === 'fade-in-from-right') && (0, $970q7.default)([
                "_j7hqpqak"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-right' || isExiting && exitingAnimation === 'fade-out-from-right') && (0, $970q7.default)([
                "_j7hq1ebg"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-top-constant' || isExiting && exitingAnimation === 'fade-in-from-top-constant') && (0, $970q7.default)([
                "_j7hqm2e2"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-top-constant' || isExiting && exitingAnimation === 'fade-out-from-top-constant') && (0, $970q7.default)([
                "_j7hq97jn"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-left-constant' || isExiting && exitingAnimation === 'fade-in-from-left-constant') && (0, $970q7.default)([
                "_j7hqovgq"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-left-constant' || isExiting && exitingAnimation === 'fade-out-from-left-constant') && (0, $970q7.default)([
                "_j7hq15do"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-bottom-constant' || isExiting && exitingAnimation === 'fade-in-from-bottom-constant') && (0, $970q7.default)([
                "_j7hq797a"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-bottom-constant' || isExiting && exitingAnimation === 'fade-out-from-bottom-constant') && (0, $970q7.default)([
                "_j7hqwo7r"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-right-constant' || isExiting && exitingAnimation === 'fade-in-from-right-constant') && (0, $970q7.default)([
                "_j7hqt8u5"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-right-constant' || isExiting && exitingAnimation === 'fade-out-from-right-constant') && (0, $970q7.default)([
                "_j7hq1pgp"
            ])
        ]) : '',
        style: {
            animationDelay: "".concat(delay, "ms")
        }
    }, state);
};
var $5baaf4612228c082$export$2e2bcd8739ae039 = $5baaf4612228c082$var$EnteringMotion;

});
parcelRegister("hSzjq", function(module, exports) {
$parcel$export(module.exports, "isReducedMotion", () => $d042df1fc6d0c111$export$b7baf7667a68d87c);

var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");

var $7QpUe = parcelRequire("7QpUe");
var $d042df1fc6d0c111$var$isMatchMediaAvailable = function isMatchMediaAvailable() {
    return typeof window !== 'undefined' && 'matchMedia' in window;
};
var $d042df1fc6d0c111$export$b7baf7667a68d87c = function isReducedMotion() {
    if (!$d042df1fc6d0c111$var$isMatchMediaAvailable()) return false;
    var _window$matchMedia = window.matchMedia('(prefers-reduced-motion: reduce)'), matches = _window$matchMedia.matches;
    return matches;
};
var $d042df1fc6d0c111$export$c537e63161742ce3 = function useIsReducedMotion() {
    var _useState = (0, $5FkrB.useState)($d042df1fc6d0c111$export$b7baf7667a68d87c), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), prefersReducedMotion = _useState2[0], setPrefersReducedMotion = _useState2[1];
    (0, $5FkrB.useEffect)(function() {
        if (!$d042df1fc6d0c111$var$isMatchMediaAvailable()) return;
        var mediaQueryList = window.matchMedia('(prefers-reduced-motion: reduce)');
        var onChange = function onChange(event) {
            return setPrefersReducedMotion(event.matches);
        };
        return (0, $7QpUe.bind)(mediaQueryList, {
            type: 'change',
            listener: onChange
        });
    }, []);
    return prefersReducedMotion;
};
var $d042df1fc6d0c111$export$f0f789643ba5a83c = {
    '@media (prefers-reduced-motion: reduce)': {
        animation: 'none',
        transition: 'none'
    }
};
var $d042df1fc6d0c111$export$ff7706047246b98b = function prefersReducedMotion() {
    return $d042df1fc6d0c111$export$f0f789643ba5a83c;
};

});

parcelRegister("VfFcJ", function(module, exports) {
$parcel$export(module.exports, "durations", () => $0ac17972b568e600$export$38b928a7167ce124);
$parcel$export(module.exports, "exitingDurations", () => $0ac17972b568e600$export$30fa1a2e62ae150c);
/**
 * Think of this as the motion equivalent of the @atlaskit/theme `grid()`.
 */ var $0ac17972b568e600$export$368bacef0dacbe05 = 25;
var $0ac17972b568e600$export$38b928a7167ce124 = {
    none: 0,
    small: 100,
    medium: 350,
    large: 700
};
/**
 * Used to multiply the initial duration for exiting motions.
 */ var $0ac17972b568e600$var$EXITING_MOTION_MULTIPLIER = 0.5;
var $0ac17972b568e600$export$30fa1a2e62ae150c = {
    none: $0ac17972b568e600$export$38b928a7167ce124.none,
    small: $0ac17972b568e600$export$38b928a7167ce124.small * $0ac17972b568e600$var$EXITING_MOTION_MULTIPLIER,
    medium: $0ac17972b568e600$export$38b928a7167ce124.medium * $0ac17972b568e600$var$EXITING_MOTION_MULTIPLIER,
    large: $0ac17972b568e600$export$38b928a7167ce124.large * $0ac17972b568e600$var$EXITING_MOTION_MULTIPLIER
};

});

parcelRegister("fiuq8", function(module, exports) {
$parcel$export(module.exports, "useSetTimeout", () => $b230225bc3ed5652$export$4f34107a2b00f39c);

var $5FkrB = parcelRequire("5FkrB");
// Handle both browser and Node.js environments
var $b230225bc3ed5652$var$getHookDeps = function getHookDeps(opts) {
    switch(opts.cleanup){
        case 'next-effect':
            return undefined;
        case 'unmount':
        default:
            return [];
    }
};
var $b230225bc3ed5652$export$1775f27e7c8051ca = function useRequestAnimationFrame() {
    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        cleanup: 'unmount'
    };
    var frames = (0, $5FkrB.useRef)([]);
    (0, $5FkrB.useEffect)(function() {
        return function() {
            if (frames.current.length) {
                frames.current.forEach(function(id) {
                    return cancelAnimationFrame(id);
                });
                frames.current = [];
            }
        };
    // We dynamically set this so we either clean up on the next effect - or on unmount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, $b230225bc3ed5652$var$getHookDeps(opts));
    return (0, $5FkrB.useCallback)(function(handler) {
        var id = requestAnimationFrame(function(time) {
            frames.current = frames.current.filter(function(frameId) {
                return frameId !== id;
            });
            handler(time);
        });
        frames.current.push(id);
    }, []);
};
var $b230225bc3ed5652$export$4f34107a2b00f39c = function useSetTimeout() {
    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        cleanup: 'unmount'
    };
    var timeouts = (0, $5FkrB.useRef)([]);
    (0, $5FkrB.useEffect)(function() {
        return function() {
            if (timeouts.current.length) {
                timeouts.current.forEach(function(id) {
                    return clearTimeout(id);
                });
                timeouts.current = [];
            }
        };
    // We dynamically set this so we either clean up on the next effect - or on unmount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, $b230225bc3ed5652$var$getHookDeps(opts));
    return (0, $5FkrB.useCallback)(function(handler, timeout) {
        for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)args[_key - 2] = arguments[_key];
        var id = setTimeout.apply(void 0, [
            function() {
                timeouts.current = timeouts.current.filter(function(timeoutId) {
                    return timeoutId !== id;
                });
                handler();
            },
            timeout
        ].concat(args));
        timeouts.current.push(id);
    }, []);
};

});

parcelRegister("k0MSS", function(module, exports) {
$parcel$export(module.exports, "useStaggeredEntrance", () => $e919ba1527cc5d5b$export$25c7213fc07ec080);

var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");

var $eVb4V = parcelRequire("eVb4V");

var $TkNEP = parcelRequire("TkNEP");

var $ile2D = parcelRequire("ile2D");
var $e919ba1527cc5d5b$var$StaggeredEntranceContext = /*#__PURE__*/ (0, $5FkrB.createContext)(function() {
    return {
        isReady: true,
        delay: 0,
        ref: (0, $eVb4V.default)
    };
});
var $e919ba1527cc5d5b$export$25c7213fc07ec080 = function useStaggeredEntrance() {
    var indentifier = (0, $ile2D.useUniqueId)();
    var context = (0, $5FkrB.useContext)($e919ba1527cc5d5b$var$StaggeredEntranceContext);
    return context(indentifier);
};
/**
 * For a list of elements that need to animate in,
 * this should be used in conjunction with entering components.
 * This does not need Javascript to execute so it will run immediately for any SSR rendered React apps before the JS has executed.
 *
 * Will dynamically add delay to each child entering component.
 * Unfortunately all entering components _NEED_ to be a direct descendant.
 */ var $e919ba1527cc5d5b$var$StaggeredEntrance = function StaggeredEntrance(_ref) {
    var children = _ref.children, column = _ref.column, _ref$columns = _ref.columns, columns = _ref$columns === void 0 ? 'responsive' : _ref$columns, _ref$delayStep = _ref.delayStep, delayStep = _ref$delayStep === void 0 ? 50 : _ref$delayStep;
    var elementRefs = (0, $5FkrB.useRef)([]);
    var indexes = [];
    var _useState = (0, $5FkrB.useState)(function() {
        if (typeof columns === 'number') // A hardcoded columns is set so bail out and set it to that!
        return columns;
        if (typeof column === 'number') // A hardcoded column is set so we will set actualColumns to be 1.
        return 1;
        // We are in "responsive" mode.
        // So we will be calculating when the Javascript executes on the client how many columns there will be.
        return 0;
    }), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), actualColumns = _useState2[0], setActualColumns = _useState2[1];
    (0, $TkNEP.useLayoutEffect)(function() {
        // We want to only run this code when we are in "responsive" mode.
        // It is assumed we are in responsive mode if `columns` is "responsive",
        // we have children element refs ready to be read (i.e. if there are no children this won't run as well)
        // and finally that `actualColumns` is `0` - this is because for the first render cycle `actualColumns` will be `0` (set above)
        // and then after this layout effect runs the value for `actualColumns` will then be calculated and set.
        if (columns === 'responsive' && elementRefs.current.length && actualColumns === 0) {
            var currentTop = 0;
            var numberColumns = 0;
            if (elementRefs.current.length <= 1) {
                setActualColumns(1);
                return;
            }
            // We set the current top to the first elements.
            // We will be comparing this and incrementing the column count
            // until we hit an element that has a different offset top (or we run out of elements).
            currentTop = elementRefs.current[0] ? elementRefs.current[0].offsetTop : 0;
            for(var i = 0; i < elementRefs.current.length; i++){
                var child = elementRefs.current[i];
                if (!child) break;
                if (currentTop === child.offsetTop) {
                    numberColumns += 1;
                    if (elementRefs.current.length - 1 === i) setActualColumns(numberColumns);
                    continue;
                }
                setActualColumns(numberColumns);
                break;
            }
        }
    // We only want this effect to run once - on initial mount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement($e919ba1527cc5d5b$var$StaggeredEntranceContext.Provider, {
        value: function value(id) {
            if (!indexes.includes(id)) indexes.push(id);
            var isReady = actualColumns > 0;
            var index = indexes.indexOf(id);
            var currentColumn = column || index % actualColumns;
            var currentRow = Math.floor(index / actualColumns);
            var distanceFromTopLeftElement = currentRow + currentColumn;
            // We don't want loads of elements to have the same staggered delay as it ends up looking slow for users.
            // To get around that we calculate the logarithm using `distanceFromTopLeftElement` which ends making
            // elements appear faster the further away from the top left element.
            var delay = Math.ceil(Math.log(distanceFromTopLeftElement + 1) * delayStep * 1.5) || 0;
            return {
                delay: delay,
                isReady: isReady,
                ref: function ref(element) {
                    return elementRefs.current[index] = element;
                }
            };
        }
    }, children);
};
var $e919ba1527cc5d5b$export$2e2bcd8739ae039 = $e919ba1527cc5d5b$var$StaggeredEntrance;

});
parcelRegister("TkNEP", function(module, exports) {
$parcel$export(module.exports, "useLayoutEffect", () => $0a654599dda37512$export$e5c5a5f917a5871c);

var $5FkrB = parcelRequire("5FkrB");
var $0a654599dda37512$export$e5c5a5f917a5871c = typeof window === 'undefined' ? (0, $5FkrB.useEffect) : (0, $5FkrB.useLayoutEffect);

});

parcelRegister("ile2D", function(module, exports) {
$parcel$export(module.exports, "useUniqueId", () => $d5a5147f99037ecf$export$c485849f2e393253);
/* eslint-disable @repo/internal/react/disallow-unstable-values */ 
var $5FkrB = parcelRequire("5FkrB");
function $d5a5147f99037ecf$export$c485849f2e393253() {
    var identifier = (0, $5FkrB.useRef)('');
    if (!identifier.current) identifier.current = '_' + (Number(String(Math.random()).slice(2)) + Date.now() + Math.round(performance.now())).toString(36);
    return identifier.current;
}

});




parcelRegister("7iRPx", function(module, exports) {
$parcel$export(module.exports, "default", () => $5513f86f48010eb9$export$2e2bcd8739ae039);

var $5FkrB = parcelRequire("5FkrB");

var $9Zzpd = parcelRequire("9Zzpd");

var $doQwS = parcelRequire("doQwS");

var $5gqkQ = parcelRequire("5gqkQ");

var $fudbI = parcelRequire("fudbI");

var $dy3bg = parcelRequire("dy3bg");
function $5513f86f48010eb9$export$2e2bcd8739ae039(_ref) {
    var _ref$zIndex = _ref.zIndex, zIndex = _ref$zIndex === void 0 ? 0 : _ref$zIndex, children = _ref.children, _ref$mountStrategy = _ref.mountStrategy, mountStrategy = _ref$mountStrategy === void 0 ? 'effect' : _ref$mountStrategy;
    var isSubsequentRender = (0, $fudbI.default)(mountStrategy);
    (0, $dy3bg.default)(zIndex);
    return !(0, $9Zzpd.fg)('platform_design_system_team_portal_logic_r18_fix') ? isSubsequentRender ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $doQwS.default), {
        zIndex: zIndex
    }, children) : null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $5gqkQ.default), {
        zIndex: zIndex
    }, children);
}

});
parcelRegister("doQwS", function(module, exports) {
$parcel$export(module.exports, "default", () => $9c1643779d729ed9$export$2e2bcd8739ae039);

var $5FkrB = parcelRequire("5FkrB");

var $aLeHs = parcelRequire("aLeHs");

var $cdJr3 = parcelRequire("cdJr3");
function $9c1643779d729ed9$export$2e2bcd8739ae039(props) {
    var zIndex = props.zIndex, children = props.children;
    var container = (0, $5FkrB.useMemo)(function() {
        return (0, $cdJr3.createContainer)(zIndex);
    }, [
        zIndex
    ]);
    // This is in the render method instead of useEffect so that
    // the portal will be added to the DOM before the children render.
    // For any further changes, ensure that the container does not have a
    // parent besides the portal parent.
    (0, $cdJr3.appendPortalContainerIfNotAppended)(container);
    (0, $5FkrB.useEffect)(function() {
        return function() {
            (0, $cdJr3.removePortalContainer)(container);
        };
    }, [
        container
    ]);
    return /*#__PURE__*/ (0, $aLeHs.createPortal)(children, container);
}

});
parcelRegister("cdJr3", function(module, exports) {
$parcel$export(module.exports, "createContainer", () => $8e59f17390d39b1b$export$26ae5ca175b4ec5a);
$parcel$export(module.exports, "removePortalContainer", () => $8e59f17390d39b1b$export$da99f98bf3fe55b3);
$parcel$export(module.exports, "appendPortalContainerIfNotAppended", () => $8e59f17390d39b1b$export$c582005add11e141);
$parcel$export(module.exports, "createAtlaskitPortal", () => $8e59f17390d39b1b$export$fef014d7cef9e543);
$parcel$export(module.exports, "createPortalParent", () => $8e59f17390d39b1b$export$95029ca7aca2989e);

var $5fGgh = parcelRequire("5fGgh");
var $8e59f17390d39b1b$export$26ae5ca175b4ec5a = function createContainer(zIndex) {
    var container = document.createElement('div');
    container.className = (0, $5fGgh.portalClassName);
    container.style.zIndex = "".concat(zIndex);
    return container;
};
/**
 * Returns document body element
 * @return {number} - The document body element
 */ var $8e59f17390d39b1b$var$getBody = function getBody() {
    return document.body;
};
/**
 * Returns portal parent container. If no container exists already then it creates a new container with class name 'atlaskit-portal-container'
 * @return {Element} - The portal parent container div element
 */ var $8e59f17390d39b1b$var$getPortalParent = function getPortalParent() {
    var parentElement = document.querySelector((0, $5fGgh.portalParentSelector));
    if (!parentElement) {
        var _getBody;
        var parent = document.createElement('div');
        parent.className = (0, $5fGgh.portalParentClassName);
        // we are setting display to flex because we want each portal to create a new stacking context
        // See https://developer.mozilla.org/en-US/docs/Web/CSS/CSS_Positioning/Understanding_z_index/The_stacking_context
        parent.style.display = 'flex';
        (_getBody = $8e59f17390d39b1b$var$getBody()) === null || _getBody === void 0 || _getBody.appendChild(parent);
        return parent;
    }
    return parentElement;
};
var $8e59f17390d39b1b$export$da99f98bf3fe55b3 = function removePortalContainer(container) {
    $8e59f17390d39b1b$var$getPortalParent().removeChild(container);
};
var $8e59f17390d39b1b$export$c582005add11e141 = function appendPortalContainerIfNotAppended(container) {
    if (!container.parentElement) $8e59f17390d39b1b$var$getPortalParent().appendChild(container);
};
var $8e59f17390d39b1b$var$isDocumentDefined = function isDocumentDefined() {
    return document !== undefined;
};
var $8e59f17390d39b1b$export$fef014d7cef9e543 = function createAtlaskitPortal(zIndex) {
    //atlaskit-portal div
    if ($8e59f17390d39b1b$var$isDocumentDefined()) {
        var atlaskitportal = document.createElement('div');
        atlaskitportal.className = (0, $5fGgh.portalClassName);
        atlaskitportal.style.zIndex = "".concat(zIndex);
        return atlaskitportal;
    }
    return;
};
var $8e59f17390d39b1b$export$95029ca7aca2989e = function createPortalParent() {
    //atlaskit-portal-container div
    if ($8e59f17390d39b1b$var$isDocumentDefined()) {
        var parentElement = document.querySelector((0, $5fGgh.portalParentSelector));
        if (!parentElement) {
            var _getBody2;
            var parent = document.createElement('div');
            parent.className = (0, $5fGgh.portalParentClassName);
            parent.style.display = 'flex';
            (_getBody2 = $8e59f17390d39b1b$var$getBody()) === null || _getBody2 === void 0 || _getBody2.appendChild(parent);
            return parent;
        }
        return parentElement;
    }
    return;
};

});
parcelRegister("5fGgh", function(module, exports) {
$parcel$export(module.exports, "portalParentClassName", () => $3d2f22b6816d2d04$export$e4c79eb95c23a0da);
$parcel$export(module.exports, "portalParentSelector", () => $3d2f22b6816d2d04$export$72f415121273627e);
$parcel$export(module.exports, "portalClassName", () => $3d2f22b6816d2d04$export$13f57c02915787b3);
var $3d2f22b6816d2d04$export$e4c79eb95c23a0da = 'atlaskit-portal-container';
var $3d2f22b6816d2d04$export$72f415121273627e = 'body > .atlaskit-portal-container';
var $3d2f22b6816d2d04$export$13f57c02915787b3 = 'atlaskit-portal';

});



parcelRegister("5gqkQ", function(module, exports) {
$parcel$export(module.exports, "default", () => $3d52dffa1bfaf682$export$2e2bcd8739ae039);

var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");

var $aLeHs = parcelRequire("aLeHs");

var $gCMe8 = parcelRequire("gCMe8");

var $cdJr3 = parcelRequire("cdJr3");
function $3d52dffa1bfaf682$export$2e2bcd8739ae039(props) {
    var zIndex = props.zIndex, children = props.children;
    var _useState = (0, $5FkrB.useState)(null), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), atlaskitPortal = _useState2[0], setAtlaskitPortal = _useState2[1];
    (0, $gCMe8.useIsomorphicLayoutEffect)(function() {
        var tempPortalContainer = (0, $cdJr3.createAtlaskitPortal)(zIndex);
        setAtlaskitPortal(tempPortalContainer);
        var portalParent = (0, $cdJr3.createPortalParent)();
        if (!tempPortalContainer || !portalParent) return;
        portalParent.appendChild(tempPortalContainer);
        return function() {
            if (tempPortalContainer) portalParent.removeChild(tempPortalContainer);
            setAtlaskitPortal(null);
        };
    }, [
        zIndex
    ]);
    /**
   * We wrap portal children with a Suspense boundary because in React 18 concurrent,
   * if you suspend from _within_ a portal to a Suspense boundary _outside_ the portal,
   * our portal gets in an infinite loop of rendering.
   */ var suspendedChildren = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $5FkrB.Suspense), {
        fallback: null
    }, children);
    return atlaskitPortal ? /*#__PURE__*/ (0, $aLeHs.createPortal)(suspendedChildren, atlaskitPortal) : null;
}

});
parcelRegister("gCMe8", function(module, exports) {
$parcel$export(module.exports, "useIsomorphicLayoutEffect", () => $c1a59ace1369b2f2$export$700979bc83e7db82);

var $5FkrB = parcelRequire("5FkrB");
var $c1a59ace1369b2f2$export$700979bc83e7db82 = typeof window !== 'undefined' ? (0, $5FkrB.useLayoutEffect) : (0, $5FkrB.useEffect);

});


parcelRegister("fudbI", function(module, exports) {
$parcel$export(module.exports, "default", () => $b463e336d1468baf$export$2e2bcd8739ae039);

var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");

var $gCMe8 = parcelRequire("gCMe8");
var $b463e336d1468baf$var$useIsSubsequentRender = function useIsSubsequentRender(mountStrategy) {
    var _useState = (0, $5FkrB.useState)(false), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), isSubsequentRender = _useState2[0], setIsSubsequentRender = _useState2[1];
    var _useState3 = (0, $5FkrB.useState)(function() {
        return mountStrategy === 'layoutEffect' ? (0, $gCMe8.useIsomorphicLayoutEffect) : (0, $5FkrB.useEffect);
    }), _useState4 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState3, 1), useMountEffect = _useState4[0];
    useMountEffect(function() {
        setIsSubsequentRender(true);
    }, []);
    return isSubsequentRender;
};
var $b463e336d1468baf$export$2e2bcd8739ae039 = $b463e336d1468baf$var$useIsSubsequentRender;

});

parcelRegister("dy3bg", function(module, exports) {
$parcel$export(module.exports, "default", () => $9dd0eaf96d79264f$export$2e2bcd8739ae039);

var $5FkrB = parcelRequire("5FkrB");

var $A7pk3 = parcelRequire("A7pk3");

var $aQ4QN = parcelRequire("aQ4QN");
var $9dd0eaf96d79264f$var$useFirePortalEvent = function useFirePortalEvent(zIndex) {
    var zIndexNumber = Number(zIndex);
    (0, $5FkrB.useEffect)(function() {
        (0, $aQ4QN.default)((0, $A7pk3.PORTAL_MOUNT_EVENT), zIndexNumber);
        return function() {
            (0, $aQ4QN.default)((0, $A7pk3.PORTAL_UNMOUNT_EVENT), zIndexNumber);
        };
    }, [
        zIndexNumber
    ]);
};
var $9dd0eaf96d79264f$export$2e2bcd8739ae039 = $9dd0eaf96d79264f$var$useFirePortalEvent;

});
parcelRegister("A7pk3", function(module, exports) {
$parcel$export(module.exports, "PORTAL_MOUNT_EVENT", () => $06c91bde3b67890d$export$ed5835cc67e87f72);
$parcel$export(module.exports, "PORTAL_UNMOUNT_EVENT", () => $06c91bde3b67890d$export$80816bd900e5bd00);
var $06c91bde3b67890d$export$ed5835cc67e87f72 = 'akPortalMount';
var $06c91bde3b67890d$export$80816bd900e5bd00 = 'akPortalUnmount';

});

parcelRegister("aQ4QN", function(module, exports) {
$parcel$export(module.exports, "default", () => $7e4285f203f6d824$export$2e2bcd8739ae039);
var $7e4285f203f6d824$var$zIndexToName = {
    100: 'card',
    200: 'navigation',
    300: 'dialog',
    400: 'layer',
    500: 'blanket',
    510: 'modal',
    600: 'flag',
    700: 'spotlight',
    9999: 'tooltip'
};
/**
 * return layer name in Atlassian design system corresponding to given z-index
 * @param {number} zIndex - z-index value for which layer name is needed
 * @returns {LayerName | null} - The layer name for given z-index. If layer name is not found then null is returned
 */ var $7e4285f203f6d824$var$getLayerName = function getLayerName(zIndex) {
    return $7e4285f203f6d824$var$zIndexToName.hasOwnProperty(zIndex) ? $7e4285f203f6d824$var$zIndexToName[zIndex] : null;
};
/**
 * Creates a PortalEvent object with given eventName, given zIndex and corresponding layer
 * @param {string} eventName - either of Mount or Unmount event name
 * @param {number} zIndex - z-index value which will be included in the event to be dispatched
 * @returns {PortalEvent} - The newly created PortalEvent object
 */ var $7e4285f203f6d824$var$getEvent = function getEvent(eventName, zIndex) {
    var detail = {
        layer: $7e4285f203f6d824$var$getLayerName(Number(zIndex)),
        zIndex: zIndex
    };
    return new CustomEvent(eventName, {
        detail: detail
    });
};
function $7e4285f203f6d824$export$2e2bcd8739ae039(eventName, zIndex) {
    var event = $7e4285f203f6d824$var$getEvent(eventName, zIndex);
    window.dispatchEvent(event);
}

});



parcelRegister("97BuP", function(module, exports) {
$parcel$export(module.exports, "layers", () => $6a41da73813c44f3$export$7be255094ccdc533);

var $kxpsr = parcelRequire("kxpsr");

var $d4dXm = parcelRequire("d4dXm");
var $6a41da73813c44f3$export$44ffba16bd48dac6 = '__ATLASKIT_THEME__';
var $6a41da73813c44f3$export$c93026a968943f95 = 'light';
var $6a41da73813c44f3$export$6ba72c8346b4c57e = [
    'light',
    'dark'
];
var $6a41da73813c44f3$export$8e24544ddba725ee = function focusRing() {
    var color = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "var(--ds-border-focused, ".concat((0, $d4dXm.B200), ")");
    var outlineWidth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
    (0, $kxpsr.default)('@atlaskit/theme', 'focus ring mixin', 'Please use `@atlaskit/focus-ring` instead.');
    return "\n  &:focus {\n    outline: none;\n    box-shadow: 0px 0px 0px ".concat(outlineWidth, "px ").concat(color, ";\n  }\n");
};
var $6a41da73813c44f3$export$c0dd343266bc3261 = function noFocusRing() {
    return "\n  box-shadow: none;\n";
};
var $6a41da73813c44f3$export$7be255094ccdc533 = {
    card: function card() {
        return 100;
    },
    navigation: function navigation() {
        return 200;
    },
    dialog: function dialog() {
        return 300;
    },
    layer: function layer() {
        return 400;
    },
    blanket: function blanket() {
        return 500;
    },
    modal: function modal() {
        return 510;
    },
    flag: function flag() {
        return 600;
    },
    spotlight: function spotlight() {
        return 700;
    },
    tooltip: function tooltip() {
        return 9999;
    }
};
var $6a41da73813c44f3$export$a1b3edb637fb4f35 = function visuallyHidden() {
    (0, $kxpsr.default)('@atlaskit/theme', 'visually hidden mixin', 'Please use `@atlaskit/visually-hidden` instead.');
    return {
        border: '0 !important',
        clip: 'rect(1px, 1px, 1px, 1px) !important',
        height: '1px !important',
        overflow: 'hidden !important',
        padding: '0 !important',
        position: 'absolute !important',
        width: '1px !important',
        whiteSpace: 'nowrap !important'
    };
};
var $6a41da73813c44f3$export$ba1d834b86d72a09 = $6a41da73813c44f3$export$a1b3edb637fb4f35;
var $6a41da73813c44f3$export$e497e856b4f89fcd = function skeletonShimmer() {
    return {
        css: {
            backgroundColor: "var(--ds-skeleton, ".concat((0, $d4dXm.N20A), ")"),
            animationDuration: '1.5s',
            animationIterationCount: 'infinite',
            animationTimingFunction: 'linear',
            animationDirection: 'alternate'
        },
        keyframes: {
            from: {
                backgroundColor: "var(--ds-skeleton, ".concat((0, $d4dXm.N20A), ")")
            },
            to: {
                backgroundColor: "var(--ds-skeleton-subtle, ".concat((0, $d4dXm.N30A), ")")
            }
        }
    };
};

});

parcelRegister("eJh19", function(module, exports) {
$parcel$export(module.exports, "register", () => $ab9277f8c91ea1ce$export$6503ec6e8aabbaf);
/* eslint-disable @atlaskit/design-system/no-direct-use-of-web-platform-drag-and-drop */ /**
 * We are listening directly to drag events instead of using a monitor from
 * `@atlaskit/pragmatic-drag-and-drop` to avoid the bundle size cost, as it
 * would affect almost every view in every app.
 *
 * We can reconsider this choice in the future.
 */ 
var $7QpUe = parcelRequire("7QpUe");
var $ab9277f8c91ea1ce$var$registrations = new Set();
var $ab9277f8c91ea1ce$var$cleanupEndEventListeners = null;
function $ab9277f8c91ea1ce$var$onDragStart() {
    if ($ab9277f8c91ea1ce$var$cleanupEndEventListeners) // If the cleanup function exists then we've already run this
    return;
    $ab9277f8c91ea1ce$var$cleanupEndEventListeners = (0, $7QpUe.bindAll)(window, [
        {
            type: 'dragend',
            listener: $ab9277f8c91ea1ce$var$onDragEnd
        },
        {
            type: 'pointerdown',
            listener: $ab9277f8c91ea1ce$var$onDragEnd
        },
        {
            type: 'pointermove',
            listener: function() {
                var callCount = 0;
                return function listener() {
                    // Using 20 as it is far bigger than the most observed (3)
                    if (callCount < 20) {
                        callCount++;
                        return;
                    }
                    $ab9277f8c91ea1ce$var$onDragEnd();
                };
            }()
        }
    ]);
    var clone = Array.from($ab9277f8c91ea1ce$var$registrations);
    clone.forEach(function(subscriber) {
        subscriber.onDragStart();
    });
}
function $ab9277f8c91ea1ce$var$onDragEnd() {
    var _cleanupEndEventListe;
    (_cleanupEndEventListe = $ab9277f8c91ea1ce$var$cleanupEndEventListeners) === null || _cleanupEndEventListe === void 0 || _cleanupEndEventListe();
    $ab9277f8c91ea1ce$var$cleanupEndEventListeners = null;
    var clone = Array.from($ab9277f8c91ea1ce$var$registrations);
    clone.forEach(function(subscriber) {
        subscriber.onDragEnd();
    });
}
function $ab9277f8c91ea1ce$var$bindStartEvents() {
    return (0, $7QpUe.bindAll)(window, [
        {
            type: 'dragstart',
            listener: $ab9277f8c91ea1ce$var$onDragStart
        },
        {
            type: 'dragenter',
            listener: $ab9277f8c91ea1ce$var$onDragStart
        }
    ]);
}
var $ab9277f8c91ea1ce$var$cleanupStartEventListeners = null;
function $ab9277f8c91ea1ce$export$6503ec6e8aabbaf(registration) {
    // if first registration, bind event listeners
    if (!$ab9277f8c91ea1ce$var$cleanupStartEventListeners) // note: currently never unbinding these event listeners
    $ab9277f8c91ea1ce$var$cleanupStartEventListeners = $ab9277f8c91ea1ce$var$bindStartEvents();
    $ab9277f8c91ea1ce$var$registrations.add(registration);
    /**
   * The reasoning for this behavior is so that if a tooltip mounts during
   * a drag it can still be suppressed.
   *
   * We use a separate callback instead of onDragStart to avoid infinite loops.
   */ registration.onRegister({
        isDragging: $ab9277f8c91ea1ce$var$cleanupEndEventListeners !== null
    });
    return function unregister() {
        $ab9277f8c91ea1ce$var$registrations.delete(registration);
        if ($ab9277f8c91ea1ce$var$registrations.size === 0) {
            var _cleanupStartEventLis;
            (_cleanupStartEventLis = $ab9277f8c91ea1ce$var$cleanupStartEventListeners) === null || _cleanupStartEventLis === void 0 || _cleanupStartEventLis();
            $ab9277f8c91ea1ce$var$cleanupStartEventListeners = null;
        }
    };
}

});

parcelRegister("cHrj9", function(module, exports) {
$parcel$export(module.exports, "show", () => $93eeaef525404288$export$57bf213be019eeb0);

var $jE2sL = parcelRequire("jE2sL");
// This file is a singleton for managing tooltips
var $93eeaef525404288$var$active = null;
function $93eeaef525404288$export$57bf213be019eeb0(entry) {
    var phase = 'waiting-to-show';
    function isActive() {
        return Boolean($93eeaef525404288$var$active && $93eeaef525404288$var$active.entry === entry);
    }
    function cleanup() {
        if (isActive()) {
            (0, $jE2sL.clearScheduled)();
            $93eeaef525404288$var$active = null;
        }
    }
    function done() {
        if (isActive()) entry.done();
        phase = 'done';
        cleanup();
    }
    function immediatelyHideAndDone() {
        if (isActive()) entry.hide({
            isImmediate: true
        });
        done();
    }
    function keep() {
        if (!isActive()) return;
        // aborting a wait to hide
        if (phase === 'waiting-to-hide') {
            phase = 'shown';
            (0, $jE2sL.clearScheduled)();
            return;
        }
        // aborting hide animation
        if (phase === 'hide-animating') {
            phase = 'shown';
            (0, $jE2sL.clearScheduled)();
            entry.show({
                isImmediate: false
            });
            return;
        }
    }
    function requestHide(_ref) {
        var isImmediate = _ref.isImmediate;
        if (!isActive()) return;
        // If we were not showing yet anyway; finish straight away
        if (phase === 'waiting-to-show') {
            immediatelyHideAndDone();
            return;
        }
        // already waiting to hide
        if (phase === 'waiting-to-hide') return;
        if (isImmediate) {
            immediatelyHideAndDone();
            return;
        }
        phase = 'waiting-to-hide';
        (0, $jE2sL.scheduleTimeout)(function() {
            phase = 'hide-animating';
            entry.hide({
                isImmediate: false
            });
        }, entry.delay);
    }
    function finishHideAnimation() {
        if (isActive() && phase === 'hide-animating') done();
    }
    function isVisible() {
        return phase === 'shown' || phase === 'waiting-to-hide' || phase === 'hide-animating';
    }
    function getInitialMouse() {
        if (entry.source.type === 'mouse') return entry.source.mouse;
        return null;
    }
    function start() {
        var showImmediately = Boolean($93eeaef525404288$var$active && $93eeaef525404288$var$active.isVisible());
        // If there was an active tooltip; we tell it to remove itself at once!
        if ($93eeaef525404288$var$active) {
            (0, $jE2sL.clearScheduled)();
            $93eeaef525404288$var$active.entry.hide({
                isImmediate: true
            });
            $93eeaef525404288$var$active.entry.done();
            $93eeaef525404288$var$active = null;
        }
        // this tooltip is now the active tooltip
        $93eeaef525404288$var$active = {
            entry: entry,
            isVisible: isVisible
        };
        function show() {
            phase = 'shown';
            entry.show({
                isImmediate: showImmediately
            });
        }
        if (showImmediately) {
            show();
            return;
        }
        phase = 'waiting-to-show';
        (0, $jE2sL.scheduleTimeout)(show, entry.delay);
    }
    // let's get started!
    start();
    var result = {
        keep: keep,
        abort: cleanup,
        isActive: isActive,
        requestHide: requestHide,
        finishHideAnimation: finishHideAnimation,
        mousePosition: getInitialMouse()
    };
    return result;
}

});
parcelRegister("jE2sL", function(module, exports) {
$parcel$export(module.exports, "clearScheduled", () => $e4d3a9da6debe8b1$export$eaf678f6f93f5250);
$parcel$export(module.exports, "scheduleTimeout", () => $e4d3a9da6debe8b1$export$5f4d6617421d489b);
var $e4d3a9da6debe8b1$var$delayId = null;
function $e4d3a9da6debe8b1$export$eaf678f6f93f5250() {
    if ($e4d3a9da6debe8b1$var$delayId != null) {
        window.clearTimeout($e4d3a9da6debe8b1$var$delayId);
        $e4d3a9da6debe8b1$var$delayId = null;
    }
}
function $e4d3a9da6debe8b1$export$5f4d6617421d489b(fn, delay) {
    $e4d3a9da6debe8b1$export$eaf678f6f93f5250();
    $e4d3a9da6debe8b1$var$delayId = window.setTimeout(function() {
        $e4d3a9da6debe8b1$var$delayId = null;
        fn();
    }, delay);
}

});


parcelRegister("gFwXq", function(module, exports) {
$parcel$export(module.exports, "default", () => $c22a0a5e55d1cf91$export$2e2bcd8739ae039);

var $h8qvJ = parcelRequire("h8qvJ");
function $c22a0a5e55d1cf91$export$2e2bcd8739ae039(prefix, shouldRenderId) {
    var seed = (0, $h8qvJ.useIdSeed)();
    return shouldRenderId ? "".concat(seed(prefix)) : undefined;
}

});

parcelRegister("1NNhV", function(module, exports) {
$parcel$export(module.exports, "default", () => $150099a9515ddbe1$export$2e2bcd8739ae039);
/* tooltip-container.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");

var $f2O6y = parcelRequire("f2O6y");
var $150099a9515ddbe1$var$styles = {
    base: "_2rkofajl _11c8dcr7 _vchhusvi _p12fp3fh _bfhkgkf6 _syaz15cr _152tze3t _1e02ze3t _1i4q1hna _1q511b66 _85i51b66 _y4ti12x7 _bozg12x7 _slp31hna",
    truncate: "_1reo15vq _18m915vq _p12f1pna _1bto1l2s _o5721q9c"
};
/**
 * Used as the default tooltip container component for the exported `Tooltip` component.
 * Adds some styles to the tooltip primitive.
 */ var $150099a9515ddbe1$var$TooltipContainer = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function TooltipContainer(_ref, ref) {
    var style = _ref.style, className = _ref.className, children = _ref.children, truncate = _ref.truncate, placement = _ref.placement, testId = _ref.testId, onMouseOut = _ref.onMouseOut, onMouseOver = _ref.onMouseOver, id = _ref.id, shortcut = _ref.shortcut;
    return /*#__PURE__*/ $5FkrB.createElement((0, $f2O6y.default), {
        ref: ref,
        style: style,
        className: (0, $970q7.default)([
            $150099a9515ddbe1$var$styles.base,
            truncate && $150099a9515ddbe1$var$styles.truncate,
            className
        ]),
        placement: placement,
        testId: testId,
        id: id,
        onMouseOut: onMouseOut,
        onMouseOver: onMouseOver,
        shortcut: shortcut
    }, children);
});
$150099a9515ddbe1$var$TooltipContainer.displayName = 'TooltipContainer';
var $150099a9515ddbe1$export$2e2bcd8739ae039 = $150099a9515ddbe1$var$TooltipContainer;

});
parcelRegister("f2O6y", function(module, exports) {
$parcel$export(module.exports, "default", () => $af3de8b2442ce0ef$export$2e2bcd8739ae039);
/* tooltip-primitive.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");

var $3nmOD = parcelRequire("3nmOD");
var $af3de8b2442ce0ef$var$primitiveStyles = null;
/**
 * The lower level component for rendering a tooltip.
 */ var $af3de8b2442ce0ef$var$TooltipPrimitive = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function TooltipPrimitive(_ref, ref) {
    var style = _ref.style, className = _ref.className, children = _ref.children, placement = _ref.placement, testId = _ref.testId, onMouseOut = _ref.onMouseOut, onMouseOver = _ref.onMouseOver, id = _ref.id, shortcut = _ref.shortcut;
    return /*#__PURE__*/ $5FkrB.createElement("div", {
        ref: ref,
        style: style,
        "data-testid": testId ? "".concat(testId, "--wrapper") : undefined
    }, /*#__PURE__*/ $5FkrB.createElement("div", {
        role: "tooltip",
        className: (0, $970q7.default)([
            "_80om73ad",
            className
        ]),
        onMouseOut: onMouseOut,
        onMouseOver: onMouseOver,
        "data-placement": placement,
        "data-testid": testId,
        id: id
    }, children, shortcut && /*#__PURE__*/ $5FkrB.createElement((0, $3nmOD.TooltipShortcut), {
        shortcut: shortcut
    })));
});
$af3de8b2442ce0ef$var$TooltipPrimitive.displayName = 'TooltipPrimitive';
var $af3de8b2442ce0ef$export$2e2bcd8739ae039 = $af3de8b2442ce0ef$var$TooltipPrimitive;

});
parcelRegister("3nmOD", function(module, exports) {
$parcel$export(module.exports, "TooltipShortcut", () => $275537c9061e3d2f$export$5bcbc43c84236222);
/* tooltip-shortcut.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");

var $9Zzpd = parcelRequire("9Zzpd");
var $275537c9061e3d2f$var$styles = {
    shortcutSegmentsContainer: "_zulpv77o _1e0c1txw _1q511b66 _85i5v77o",
    shortcutSegment: "_11c81u0j _2rkolb4i _1dqonqa1 _189ee4h9 _1h6d1ihb _1e0c1txw _4cvr1h6o _4t3i1k92 _vchhusvi _1q51v77o _85i5v77o _bozg12x7 _y4ti12x7 _16qsn7od _1254n7od _cgnln7od _syazn7od _ahbqn7od _12l2n7od _1pfhn7od _6rthn7od _1ul9n7od _w19jn7od _bfhk261p",
    regularFont: "_11c81o8v"
};
var $275537c9061e3d2f$export$5bcbc43c84236222 = function TooltipShortcut(_ref) {
    var shortcut = _ref.shortcut;
    return /*#__PURE__*/ $5FkrB.createElement("div", {
        className: (0, $970q7.default)([
            $275537c9061e3d2f$var$styles.shortcutSegmentsContainer
        ])
    }, shortcut.map(function(segment, index) {
        return /*#__PURE__*/ $5FkrB.createElement("kbd", {
            key: "".concat(segment, "-").concat(index),
            className: (0, $970q7.default)([
                $275537c9061e3d2f$var$styles.shortcutSegment,
                (0, $9Zzpd.fg)('platform-tooltip-shortcuts-regular-font') && $275537c9061e3d2f$var$styles.regularFont
            ])
        }, segment);
    }));
};

});



parcelRegister("ayv7G", function(module, exports) {
$parcel$export(module.exports, "getMousePosition", () => $7af538b368053957$export$642213d516a9b928);
function $7af538b368053957$export$642213d516a9b928(mouseCoordinates) {
    var safeMouse = mouseCoordinates || {
        top: 0,
        left: 0
    };
    var getBoundingClientRect = function getBoundingClientRect() {
        return {
            top: safeMouse.top,
            left: safeMouse.left,
            bottom: safeMouse.top,
            right: safeMouse.left,
            width: 0,
            height: 0
        };
    };
    return {
        getBoundingClientRect: getBoundingClientRect,
        clientWidth: 0,
        clientHeight: 0
    };
}

});


parcelRegister("3cXxO", function(module, exports) {
$parcel$export(module.exports, "headingAnchorLinkMessages", () => $2560ae608c660717$export$74bada844422036d);
$parcel$export(module.exports, "tableCellMessages", () => $2560ae608c660717$export$c79ebc36348824d1);
$parcel$export(module.exports, "inlineCommentMessages", () => $2560ae608c660717$export$9f52c375a6ef34fc);
/* eslint-disable @atlaskit/editor/no-re-export */ // Entry file in package.json

var $aRMzY = parcelRequire("aRMzY");
var $2560ae608c660717$export$74bada844422036d = (0, $aRMzY.defineMessages)({
    copyHeadingLinkToClipboard: {
        id: 'fabric.editor.headingLink.copyAnchorLink',
        defaultMessage: 'Copy link to heading',
        description: 'Copy heading link to clipboard'
    },
    copiedHeadingLinkToClipboard: {
        id: 'fabric.editor.headingLink.copied',
        defaultMessage: 'Copied!',
        description: 'Copied heading link to clipboard'
    },
    failedToCopyHeadingLink: {
        id: 'fabric.editor.headingLink.failedToCopy',
        defaultMessage: 'Copy failed',
        description: 'failed to copy heading link to clipboard'
    },
    copyAriaLabel: {
        id: 'fabric.editor.headingLink.copyAriaLabel',
        defaultMessage: 'Copy',
        description: 'copy aria label for link icon'
    }
});
var $2560ae608c660717$export$c79ebc36348824d1 = (0, $aRMzY.defineMessages)({
    noneSortingLabel: {
        id: 'fabric.editor.headingLink.noneSortingLabel',
        defaultMessage: 'none',
        description: 'this table column is not sorted'
    },
    ascSortingLabel: {
        id: 'fabric.editor.headingLink.ascSortingLabel',
        defaultMessage: 'ascending',
        description: 'this table column is sorted in ascending order'
    },
    descSortingLabel: {
        id: 'fabric.editor.headingLink.descSortingLabel',
        defaultMessage: 'descending',
        description: 'this table column is sorted in descending order'
    }
});
var $2560ae608c660717$export$9f52c375a6ef34fc = (0, $aRMzY.defineMessages)({
    contentRendererInlineCommentMarkerStart: {
        id: 'fabric.editor.inlineComment.marker.start',
        defaultMessage: 'inline comment start',
        description: 'Starting marker to indicate that text is highlighted with an inline comment by a screen reader.'
    },
    contentRendererInlineCommentMarkerEnd: {
        id: 'fabric.editor.inlineComment.marker.end',
        defaultMessage: 'inline comment end',
        description: 'Ending marker to indicate that text was highlighted with an inline comment by a screen reader.'
    }
});

});



parcelRegister("iXLPT", function(module, exports) {
$parcel$export(module.exports, "default", () => $dce2d7eb202c1794$export$2e2bcd8739ae039);

var $kqp0i = parcelRequire("kqp0i");

var $5FkrB = parcelRequire("5FkrB");

var $4chaE = parcelRequire("4chaE");
var $dce2d7eb202c1794$var$InlineExtension = function InlineExtension(props) {
    var text = props.text;
    return(/*#__PURE__*/ // Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $4chaE.default), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, props, {
        type: "inlineExtension"
    }), function(_ref) {
        var result = _ref.result;
        try {
            // Return the result directly if it's a valid JSX.Element
            if (result && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).isValidElement(result)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("span", null, result);
        } catch (e) {
        /** We don't want this error to block renderer */ /** We keep rendering the default content */ }
        // Always return default content if anything goes wrong
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("span", null, text || 'inlineExtension');
    }));
};
var $dce2d7eb202c1794$export$2e2bcd8739ae039 = $dce2d7eb202c1794$var$InlineExtension;

});

parcelRegister("betLp", function(module, exports) {
$parcel$export(module.exports, "default", () => $82d816efe2d68914$export$2e2bcd8739ae039);

var $5FkrB = parcelRequire("5FkrB");

var $fAhSf = parcelRequire("fAhSf");
function $82d816efe2d68914$export$2e2bcd8739ae039(props) {
    var _props$content;
    return (0, $fAhSf.editorExperiment)('advanced_layouts', true) ? /*#__PURE__*/ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("div", {
        className: "layout-section-container",
        "data-local-id": props.localId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("div", {
        "data-layout-section": true,
        "data-layout-columns": props === null || props === void 0 || (_props$content = props.content) === null || _props$content === void 0 ? void 0 : _props$content.length
    }, props.children)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("div", {
        "data-layout-section": true,
        "data-local-id": props.localId
    }, props.children);
}

});

parcelRegister("7n8xE", function(module, exports) {
$parcel$export(module.exports, "default", () => $55e14e9ead21bc7a$export$2e2bcd8739ae039);

var $25nEq = parcelRequire("25nEq");
parcelRequire("5FkrB");

var $74Zh5 = parcelRequire("74Zh5");

var $01HkO = parcelRequire("01HkO");

var $9Zzpd = parcelRequire("9Zzpd");
// localized styles, was from clearNextSiblingMarginTopStyle in @atlaskit/editor-common/ui
var $55e14e9ead21bc7a$var$clearNextSiblingMarginTopStyle = (0, $74Zh5.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& + *': {
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview, @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
        marginTop: '0 !important'
    }
});
var $55e14e9ead21bc7a$var$multipleWrappedImagesStyle = (0, $74Zh5.css)({
    // Given the first wrapped mediaSingle has 0 marginTop (see clearNextSiblingMarginTopStyle),
    // update all wrapped mediaSingle inside layout to have 0 margin top unless they don't have sibling wrapped mediaSingle
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,  @atlaskit/ui-styling-standard/no-unsafe-selectors
    '& [class*="image-wrap-"] + [class*="image-wrap-"], & [class*="image-wrap-"]:has( + [class*="image-wrap-"])': {
        marginTop: '0'
    }
});
// localized styles, was from clearNextSiblingBlockMarkMarginTopStyle in @atlaskit/editor-common/ui
var $55e14e9ead21bc7a$var$clearNextSiblingBlockMarkMarginTopStyle = (0, $74Zh5.css)((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, "+ .fabric-editor-block-mark > p,\n\t  + .fabric-editor-block-mark > h1,\n\t  + .fabric-editor-block-mark > h2,\n\t  + .fabric-editor-block-mark > h3,\n\t  + .fabric-editor-block-mark > h4,\n\t  + .fabric-editor-block-mark > h5,\n\t  + .fabric-editor-block-mark > h6\n\t", {
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview, @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
    marginTop: '0 !important'
}));
function $55e14e9ead21bc7a$export$2e2bcd8739ae039(props) {
    return (0, $74Zh5.jsx)("div", {
        "data-layout-column": true,
        "data-column-width": props.width,
        style: {
            flexBasis: "".concat(props.width, "%")
        },
        css: (0, $9Zzpd.fg)('platform_editor_fix_media_in_renderer') && $55e14e9ead21bc7a$var$multipleWrappedImagesStyle
    }, (0, $74Zh5.jsx)((0, $01HkO.WidthProvider), null, (0, $74Zh5.jsx)("div", {
        css: [
            $55e14e9ead21bc7a$var$clearNextSiblingMarginTopStyle,
            $55e14e9ead21bc7a$var$clearNextSiblingBlockMarkMarginTopStyle
        ]
    }), props.children));
}

});

parcelRegister("fMHNb", function(module, exports) {
$parcel$export(module.exports, "default", () => $b7dd4ef636c225fa$export$2e2bcd8739ae039);

var $5FkrB = parcelRequire("5FkrB");
function $b7dd4ef636c225fa$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("li", null, props.children);
}

});

parcelRegister("4piwi", function(module, exports) {
$parcel$export(module.exports, "default", () => $3357dcdf4d2a16f4$export$2e2bcd8739ae039);

var $5FkrB = parcelRequire("5FkrB");

var $h2boL = parcelRequire("h2boL");
var $3357dcdf4d2a16f4$var$RenderCaption = function RenderCaption(_ref) {
    var children = _ref.children, dataAttributes = _ref.dataAttributes;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $h2boL.default), {
        hasContent: true,
        dataAttributes: dataAttributes
    }, children);
};
var $3357dcdf4d2a16f4$export$2e2bcd8739ae039 = $3357dcdf4d2a16f4$var$RenderCaption;

});
parcelRegister("h2boL", function(module, exports) {
$parcel$export(module.exports, "default", () => $c66b771491fe9957$export$2e2bcd8739ae039);

var $kqp0i = parcelRequire("kqp0i");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $kIXpt = parcelRequire("kIXpt");

var $cYPzS = parcelRequire("cYPzS");

var $eyuDe = parcelRequire("eyuDe");

var $5FkrB = parcelRequire("5FkrB");

var $74Zh5 = parcelRequire("74Zh5");

var $3IjMA = parcelRequire("3IjMA");

var $dSlAE = parcelRequire("dSlAE");
var $3b5Jw = parcelRequire("3b5Jw");
var $a4gGZ = parcelRequire("a4gGZ");

var $cGH6O = parcelRequire("cGH6O");
function $c66b771491fe9957$var$_callSuper(t, o, e) {
    return o = (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(o), (0, (/*@__PURE__*/$parcel$interopDefault($kIXpt)))(t, $c66b771491fe9957$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(t).constructor) : o.apply(t, e));
}
function $c66b771491fe9957$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($c66b771491fe9957$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $c66b771491fe9957$var$captionWrapperStyle = (0, $74Zh5.css)({
    marginTop: "var(--ds-space-100, 8px)",
    textAlign: 'center',
    position: 'relative',
    color: "var(--ds-text-subtle, #505258)"
});
var $c66b771491fe9957$var$placeholderStyle = (0, $a4gGZ.xcss)({
    color: 'color.text.subtlest',
    position: 'absolute',
    top: 'space.0',
    width: '100%'
});
var $c66b771491fe9957$export$f7feb87190a94c76 = /*#__PURE__*/ function(_React$Component) {
    function CaptionComponent() {
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, CaptionComponent);
        return $c66b771491fe9957$var$_callSuper(this, CaptionComponent, arguments);
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($eyuDe)))(CaptionComponent, _React$Component);
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(CaptionComponent, [
        {
            key: "render",
            value: function render() {
                var _this$props = this.props, selected = _this$props.selected, hasContent = _this$props.hasContent, children = _this$props.children, dataAttributes = _this$props.dataAttributes, formatMessage = _this$props.intl.formatMessage;
                var showPlaceholder = !selected && !hasContent;
                return (0, $74Zh5.jsx)("div", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
                    "data-media-caption": true,
                    "data-testid": "media-caption"
                }, dataAttributes, {
                    css: $c66b771491fe9957$var$captionWrapperStyle
                }), showPlaceholder ? (0, $74Zh5.jsx)((0, $dSlAE.default), {
                    xcss: $c66b771491fe9957$var$placeholderStyle
                }, (0, $74Zh5.jsx)((0, $3b5Jw.default), null, formatMessage((0, $cGH6O.messages).placeholder))) : null, children);
            }
        }
    ]);
}((0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).Component);
// eslint-disable-next-line @typescript-eslint/ban-types
var $c66b771491fe9957$var$_default_1 = (0, $3IjMA.default)($c66b771491fe9957$export$f7feb87190a94c76);
var $c66b771491fe9957$export$2e2bcd8739ae039 = $c66b771491fe9957$var$_default_1;

});
parcelRegister("dSlAE", function(module, exports) {
$parcel$export(module.exports, "default", () => $a1a110e23a86eff0$export$2e2bcd8739ae039);

var $kqp0i = parcelRequire("kqp0i");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");

var $74Zh5 = parcelRequire("74Zh5");

var $38QhU = parcelRequire("38QhU");

var $1L15X = parcelRequire("1L15X");

var $a4gGZ = parcelRequire("a4gGZ");
var $a1a110e23a86eff0$var$_excluded = [
    "as",
    "children",
    "backgroundColor",
    "padding",
    "paddingBlock",
    "paddingBlockStart",
    "paddingBlockEnd",
    "paddingInline",
    "paddingInlineStart",
    "paddingInlineEnd",
    "style",
    "testId",
    "xcss"
], $a1a110e23a86eff0$var$_excluded2 = [
    "className"
];
var $a1a110e23a86eff0$export$e71c4d32a2263218 = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? 'div' : _ref$as, children = _ref.children, backgroundColor = _ref.backgroundColor, padding = _ref.padding, paddingBlock = _ref.paddingBlock, paddingBlockStart = _ref.paddingBlockStart, paddingBlockEnd = _ref.paddingBlockEnd, paddingInline = _ref.paddingInline, paddingInlineStart = _ref.paddingInlineStart, paddingInlineEnd = _ref.paddingInlineEnd, style = _ref.style, testId = _ref.testId, xcss = _ref.xcss, htmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $a1a110e23a86eff0$var$_excluded);
    // This is to remove className from safeHtmlAttributes
    // @ts-ignore -- not using expect since it causes issues with help-center local consumption - className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(htmlAttributes, $a1a110e23a86eff0$var$_excluded2);
    var resolvedStyles = (0, $a4gGZ.parseXcss)(xcss);
    var node = // @ts-expect-error Expression produces a union type that is too complex to represent. I think this is unavoidable
    (0, $74Zh5.jsx)(Component, (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        style: style,
        ref: ref,
        className: resolvedStyles.static
    }, safeHtmlAttributes, {
        css: [
            $a1a110e23a86eff0$var$baseStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            backgroundColor && (0, $1L15X.backgroundColorStylesMap)[backgroundColor],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $1L15X.isSurfaceColorToken)(backgroundColor) && (0, $1L15X.surfaceColorStylesMap)[backgroundColor],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            padding && (0, $1L15X.paddingStylesMap).padding[padding],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlock && (0, $1L15X.paddingStylesMap).paddingBlock[paddingBlock],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlockStart && (0, $1L15X.paddingStylesMap).paddingBlockStart[paddingBlockStart],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlockEnd && (0, $1L15X.paddingStylesMap).paddingBlockEnd[paddingBlockEnd],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInline && (0, $1L15X.paddingStylesMap).paddingInline[paddingInline],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInlineStart && (0, $1L15X.paddingStylesMap).paddingInlineStart[paddingInlineStart],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInlineEnd && (0, $1L15X.paddingStylesMap).paddingInlineEnd[paddingInlineEnd],
            resolvedStyles.emotion
        ],
        "data-testid": testId
    }), children);
    return backgroundColor ? (0, $74Zh5.jsx)((0, $38QhU.SurfaceContext).Provider, {
        value: backgroundColor
    }, node) : node;
});
var $a1a110e23a86eff0$export$2e2bcd8739ae039 = $a1a110e23a86eff0$export$e71c4d32a2263218;
var $a1a110e23a86eff0$var$baseStyles = (0, $74Zh5.css)({
    boxSizing: 'border-box',
    appearance: 'none',
    border: 'none'
});

});
parcelRegister("38QhU", function(module, exports) {
$parcel$export(module.exports, "SurfaceContext", () => $249aadc07ae42f45$export$1ca2a26fecb070ae);
$parcel$export(module.exports, "useSurface", () => $249aadc07ae42f45$export$1aeb4f6b93c4540d);

var $5FkrB = parcelRequire("5FkrB");
var $249aadc07ae42f45$export$1ca2a26fecb070ae = /*#__PURE__*/ (0, $5FkrB.createContext)('elevation.surface');
var $249aadc07ae42f45$export$1aeb4f6b93c4540d = function useSurface() {
    return (0, $5FkrB.useContext)($249aadc07ae42f45$export$1ca2a26fecb070ae);
};
$249aadc07ae42f45$export$1ca2a26fecb070ae.displayName = 'SurfaceProvider';

});

parcelRegister("1L15X", function(module, exports) {
$parcel$export(module.exports, "dimensionMap", () => $147b07b1e1c36302$export$6ccdbebca2ee545f);
$parcel$export(module.exports, "positiveSpaceMap", () => $147b07b1e1c36302$export$958d0ae7f2977ae4);
$parcel$export(module.exports, "allSpaceMap", () => $147b07b1e1c36302$export$632685d741f3dbbf);
$parcel$export(module.exports, "inverseColorMap", () => $147b07b1e1c36302$export$2185ce37f9bdd963);
$parcel$export(module.exports, "opacityMap", () => $147b07b1e1c36302$export$daf94a976c798b4f);
$parcel$export(module.exports, "shadowMap", () => $147b07b1e1c36302$export$7aff6e7ba39bb774);
$parcel$export(module.exports, "borderColorMap", () => $147b07b1e1c36302$export$1531ad5bb3fbedac);
$parcel$export(module.exports, "backgroundColorMap", () => $147b07b1e1c36302$export$d1d79bf68ac056bd);
$parcel$export(module.exports, "textColorMap", () => $147b07b1e1c36302$export$8473307aa00d6ea1);
$parcel$export(module.exports, "layerMap", () => $147b07b1e1c36302$export$b5f31a7e431d2eab);
$parcel$export(module.exports, "borderWidthMap", () => $147b07b1e1c36302$export$e1b83c5210c471b8);
$parcel$export(module.exports, "borderRadiusMap", () => $147b07b1e1c36302$export$3c0a6c3e64bb180d);
$parcel$export(module.exports, "fontMap", () => $147b07b1e1c36302$export$6ffa317d5e70375);
$parcel$export(module.exports, "fontWeightMap", () => $147b07b1e1c36302$export$303e322c6b1ed114);
$parcel$export(module.exports, "fontFamilyMap", () => $147b07b1e1c36302$export$3c7e9587132614b4);
$parcel$export(module.exports, "paddingStylesMap", () => $147b07b1e1c36302$export$e615f061ca585a6c);
$parcel$export(module.exports, "spaceStylesMap", () => $147b07b1e1c36302$export$bf46c3f9eeafc71f);
$parcel$export(module.exports, "backgroundColorStylesMap", () => $147b07b1e1c36302$export$e7af83bafe7f9e63);
$parcel$export(module.exports, "textColorStylesMap", () => $147b07b1e1c36302$export$3a1bcba60b23d7f0);
$parcel$export(module.exports, "textSizeStylesMap", () => $147b07b1e1c36302$export$219d364c0da35ae4);
$parcel$export(module.exports, "textWeightStylesMap", () => $147b07b1e1c36302$export$38845ca010b93505);
$parcel$export(module.exports, "surfaceColorStylesMap", () => $147b07b1e1c36302$export$ff257d957d48c421);
$parcel$export(module.exports, "isSurfaceColorToken", () => $147b07b1e1c36302$export$5e65a44e5b6ecadb);

var $25nEq = parcelRequire("25nEq");

var $74Zh5 = parcelRequire("74Zh5");

var $lYcLA = parcelRequire("lYcLA");
function $147b07b1e1c36302$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $147b07b1e1c36302$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $147b07b1e1c36302$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $147b07b1e1c36302$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $147b07b1e1c36302$export$6ccdbebca2ee545f = {
    '100%': '100%',
    'size.100': '1rem',
    'size.200': '1.5rem',
    'size.300': '2rem',
    'size.400': '2.5rem',
    'size.500': '3rem',
    'size.600': '6rem',
    'size.1000': '12rem'
};
var $147b07b1e1c36302$export$958d0ae7f2977ae4 = {
    'space.0': "var(--ds-space-0, 0px)",
    'space.025': "var(--ds-space-025, 2px)",
    'space.050': "var(--ds-space-050, 4px)",
    'space.075': "var(--ds-space-075, 6px)",
    'space.100': "var(--ds-space-100, 8px)",
    'space.150': "var(--ds-space-150, 12px)",
    'space.200': "var(--ds-space-200, 16px)",
    'space.250': "var(--ds-space-250, 20px)",
    'space.300': "var(--ds-space-300, 24px)",
    'space.400': "var(--ds-space-400, 32px)",
    'space.500': "var(--ds-space-500, 40px)",
    'space.600': "var(--ds-space-600, 48px)",
    'space.800': "var(--ds-space-800, 64px)",
    'space.1000': "var(--ds-space-1000, 80px)"
};
var $147b07b1e1c36302$export$d2dc61f58390201c = {
    'space.negative.025': "var(--ds-space-negative-025, -2px)",
    'space.negative.050': "var(--ds-space-negative-050, -4px)",
    'space.negative.075': "var(--ds-space-negative-075, -6px)",
    'space.negative.100': "var(--ds-space-negative-100, -8px)",
    'space.negative.150': "var(--ds-space-negative-150, -12px)",
    'space.negative.200': "var(--ds-space-negative-200, -16px)",
    'space.negative.250': "var(--ds-space-negative-250, -20px)",
    'space.negative.300': "var(--ds-space-negative-300, -24px)",
    'space.negative.400': "var(--ds-space-negative-400, -32px)"
};
var $147b07b1e1c36302$export$632685d741f3dbbf = $147b07b1e1c36302$var$_objectSpread($147b07b1e1c36302$var$_objectSpread({}, $147b07b1e1c36302$export$958d0ae7f2977ae4), $147b07b1e1c36302$export$d2dc61f58390201c);
var $147b07b1e1c36302$export$2185ce37f9bdd963 = {
    'color.background.neutral.bold': 'color.text.inverse',
    'color.background.neutral.bold.hovered': 'color.text.inverse',
    'color.background.neutral.bold.pressed': 'color.text.inverse',
    'color.background.selected.bold': 'color.text.inverse',
    'color.background.selected.bold.hovered': 'color.text.inverse',
    'color.background.selected.bold.pressed': 'color.text.inverse',
    'color.background.brand.bold': 'color.text.inverse',
    'color.background.brand.bold.hovered': 'color.text.inverse',
    'color.background.brand.bold.pressed': 'color.text.inverse',
    'color.background.brand.boldest': 'color.text.inverse',
    'color.background.brand.boldest.hovered': 'color.text.inverse',
    'color.background.brand.boldest.pressed': 'color.text.inverse',
    'color.background.danger.bold': 'color.text.inverse',
    'color.background.danger.bold.hovered': 'color.text.inverse',
    'color.background.danger.bold.pressed': 'color.text.inverse',
    'color.background.warning.bold': 'color.text.warning.inverse',
    'color.background.warning.bold.hovered': 'color.text.warning.inverse',
    'color.background.warning.bold.pressed': 'color.text.warning.inverse',
    'color.background.success.bold': 'color.text.inverse',
    'color.background.success.bold.hovered': 'color.text.inverse',
    'color.background.success.bold.pressed': 'color.text.inverse',
    'color.background.discovery.bold': 'color.text.inverse',
    'color.background.discovery.bold.hovered': 'color.text.inverse',
    'color.background.discovery.bold.pressed': 'color.text.inverse',
    'color.background.information.bold': 'color.text.inverse',
    'color.background.information.bold.hovered': 'color.text.inverse',
    'color.background.information.bold.pressed': 'color.text.inverse'
};
var $147b07b1e1c36302$export$daf94a976c798b4f = {
    'opacity.disabled': "var(--ds-opacity-disabled, 0.4)",
    'opacity.loading': "var(--ds-opacity-loading, 0.2)"
};
var $147b07b1e1c36302$export$7aff6e7ba39bb774 = {
    'elevation.shadow.overflow': "var(--ds-shadow-overflow, 0px 0px 8px #1E1F21, 0px 0px 1px #1E1F21)",
    'elevation.shadow.overflow.perimeter': "var(--ds-shadow-overflow-perimeter, #1E1F211f)",
    'elevation.shadow.overflow.spread': "var(--ds-shadow-overflow-spread, #1E1F2129)",
    'elevation.shadow.overlay': "var(--ds-shadow-overlay, 0px 8px 12px #1E1F21, 0px 0px 1px #1E1F21)",
    'elevation.shadow.raised': "var(--ds-shadow-raised, 0px 1px 1px #1E1F21, 0px 0px 1px #1E1F21)"
};
var $147b07b1e1c36302$export$41a358c9c2356760 = {
    'elevation.surface': "var(--ds-surface, #FFFFFF)",
    'elevation.surface.hovered': "var(--ds-surface-hovered, #F0F1F2)",
    'elevation.surface.pressed': "var(--ds-surface-pressed, #DDDEE1)",
    'elevation.surface.overlay': "var(--ds-surface-overlay, #FFFFFF)",
    'elevation.surface.overlay.hovered': "var(--ds-surface-overlay-hovered, #F0F1F2)",
    'elevation.surface.overlay.pressed': "var(--ds-surface-overlay-pressed, #DDDEE1)",
    'elevation.surface.raised': "var(--ds-surface-raised, #FFFFFF)",
    'elevation.surface.raised.hovered': "var(--ds-surface-raised-hovered, #F0F1F2)",
    'elevation.surface.raised.pressed': "var(--ds-surface-raised-pressed, #DDDEE1)",
    'elevation.surface.sunken': "var(--ds-surface-sunken, #F8F8F8)"
};
var $147b07b1e1c36302$export$1531ad5bb3fbedac = {
    'color.border': "var(--ds-border, #0B120E24)",
    'color.border.accent.lime': "var(--ds-border-accent-lime, #6A9A23)",
    'color.border.accent.red': "var(--ds-border-accent-red, #E2483D)",
    'color.border.accent.orange': "var(--ds-border-accent-orange, #E06C00)",
    'color.border.accent.yellow': "var(--ds-border-accent-yellow, #B38600)",
    'color.border.accent.green': "var(--ds-border-accent-green, #22A06B)",
    'color.border.accent.teal': "var(--ds-border-accent-teal, #2898BD)",
    'color.border.accent.blue': "var(--ds-border-accent-blue, #357DE8)",
    'color.border.accent.purple': "var(--ds-border-accent-purple, #AF59E1)",
    'color.border.accent.magenta': "var(--ds-border-accent-magenta, #CD519D)",
    'color.border.accent.gray': "var(--ds-border-accent-gray, #7D818A)",
    'color.border.disabled': "var(--ds-border-disabled, #0515240F)",
    'color.border.focused': "var(--ds-border-focused, #4688EC)",
    'color.border.input': "var(--ds-border-input, #8C8F97)",
    'color.border.inverse': "var(--ds-border-inverse, #FFFFFF)",
    'color.border.selected': "var(--ds-border-selected, #1868DB)",
    'color.border.brand': "var(--ds-border-brand, #1868DB)",
    'color.border.danger': "var(--ds-border-danger, #E2483D)",
    'color.border.warning': "var(--ds-border-warning, #E06C00)",
    'color.border.success': "var(--ds-border-success, #6A9A23)",
    'color.border.discovery': "var(--ds-border-discovery, #AF59E1)",
    'color.border.information': "var(--ds-border-information, #357DE8)",
    'color.border.bold': "var(--ds-border-bold, #7D818A)"
};
var $147b07b1e1c36302$export$d1d79bf68ac056bd = {
    'color.background.accent.lime.subtlest': "var(--ds-background-accent-lime-subtlest, #EFFFD6)",
    'color.background.accent.lime.subtlest.hovered': "var(--ds-background-accent-lime-subtlest-hovered, #D3F1A7)",
    'color.background.accent.lime.subtlest.pressed': "var(--ds-background-accent-lime-subtlest-pressed, #BDE97C)",
    'color.background.accent.lime.subtler': "var(--ds-background-accent-lime-subtler, #D3F1A7)",
    'color.background.accent.lime.subtler.hovered': "var(--ds-background-accent-lime-subtler-hovered, #BDE97C)",
    'color.background.accent.lime.subtler.pressed': "var(--ds-background-accent-lime-subtler-pressed, #B3DF72)",
    'color.background.accent.lime.subtle': "var(--ds-background-accent-lime-subtle, #94C748)",
    'color.background.accent.lime.subtle.hovered': "var(--ds-background-accent-lime-subtle-hovered, #B3DF72)",
    'color.background.accent.lime.subtle.pressed': "var(--ds-background-accent-lime-subtle-pressed, #BDE97C)",
    'color.background.accent.lime.bolder': "var(--ds-background-accent-lime-bolder, #5B7F24)",
    'color.background.accent.lime.bolder.hovered': "var(--ds-background-accent-lime-bolder-hovered, #4C6B1F)",
    'color.background.accent.lime.bolder.pressed': "var(--ds-background-accent-lime-bolder-pressed, #3F5224)",
    'color.background.accent.red.subtlest': "var(--ds-background-accent-red-subtlest, #FFECEB)",
    'color.background.accent.red.subtlest.hovered': "var(--ds-background-accent-red-subtlest-hovered, #FFD5D2)",
    'color.background.accent.red.subtlest.pressed': "var(--ds-background-accent-red-subtlest-pressed, #FFB8B2)",
    'color.background.accent.red.subtler': "var(--ds-background-accent-red-subtler, #FFD5D2)",
    'color.background.accent.red.subtler.hovered': "var(--ds-background-accent-red-subtler-hovered, #FFB8B2)",
    'color.background.accent.red.subtler.pressed': "var(--ds-background-accent-red-subtler-pressed, #FD9891)",
    'color.background.accent.red.subtle': "var(--ds-background-accent-red-subtle, #F87168)",
    'color.background.accent.red.subtle.hovered': "var(--ds-background-accent-red-subtle-hovered, #FD9891)",
    'color.background.accent.red.subtle.pressed': "var(--ds-background-accent-red-subtle-pressed, #FFB8B2)",
    'color.background.accent.red.bolder': "var(--ds-background-accent-red-bolder, #C9372C)",
    'color.background.accent.red.bolder.hovered': "var(--ds-background-accent-red-bolder-hovered, #AE2E24)",
    'color.background.accent.red.bolder.pressed': "var(--ds-background-accent-red-bolder-pressed, #872821)",
    'color.background.accent.orange.subtlest': "var(--ds-background-accent-orange-subtlest, #FFF5DB)",
    'color.background.accent.orange.subtlest.hovered': "var(--ds-background-accent-orange-subtlest-hovered, #FCE4A6)",
    'color.background.accent.orange.subtlest.pressed': "var(--ds-background-accent-orange-subtlest-pressed, #FBD779)",
    'color.background.accent.orange.subtler': "var(--ds-background-accent-orange-subtler, #FCE4A6)",
    'color.background.accent.orange.subtler.hovered': "var(--ds-background-accent-orange-subtler-hovered, #FBD779)",
    'color.background.accent.orange.subtler.pressed': "var(--ds-background-accent-orange-subtler-pressed, #FBC828)",
    'color.background.accent.orange.subtle': "var(--ds-background-accent-orange-subtle, #FCA700)",
    'color.background.accent.orange.subtle.hovered': "var(--ds-background-accent-orange-subtle-hovered, #FBC828)",
    'color.background.accent.orange.subtle.pressed': "var(--ds-background-accent-orange-subtle-pressed, #FBD779)",
    'color.background.accent.orange.bolder': "var(--ds-background-accent-orange-bolder, #BD5B00)",
    'color.background.accent.orange.bolder.hovered': "var(--ds-background-accent-orange-bolder-hovered, #9E4C00)",
    'color.background.accent.orange.bolder.pressed': "var(--ds-background-accent-orange-bolder-pressed, #7A3B00)",
    'color.background.accent.yellow.subtlest': "var(--ds-background-accent-yellow-subtlest, #FEF7C8)",
    'color.background.accent.yellow.subtlest.hovered': "var(--ds-background-accent-yellow-subtlest-hovered, #F5E989)",
    'color.background.accent.yellow.subtlest.pressed': "var(--ds-background-accent-yellow-subtlest-pressed, #EFDD4E)",
    'color.background.accent.yellow.subtler': "var(--ds-background-accent-yellow-subtler, #F5E989)",
    'color.background.accent.yellow.subtler.hovered': "var(--ds-background-accent-yellow-subtler-hovered, #EFDD4E)",
    'color.background.accent.yellow.subtler.pressed': "var(--ds-background-accent-yellow-subtler-pressed, #EED12B)",
    'color.background.accent.yellow.subtle': "var(--ds-background-accent-yellow-subtle, #EED12B)",
    'color.background.accent.yellow.subtle.hovered': "var(--ds-background-accent-yellow-subtle-hovered, #DDB30E)",
    'color.background.accent.yellow.subtle.pressed': "var(--ds-background-accent-yellow-subtle-pressed, #EFDD4E)",
    'color.background.accent.yellow.bolder': "var(--ds-background-accent-yellow-bolder, #946F00)",
    'color.background.accent.yellow.bolder.hovered': "var(--ds-background-accent-yellow-bolder-hovered, #7F5F01)",
    'color.background.accent.yellow.bolder.pressed': "var(--ds-background-accent-yellow-bolder-pressed, #614A05)",
    'color.background.accent.green.subtlest': "var(--ds-background-accent-green-subtlest, #DCFFF1)",
    'color.background.accent.green.subtlest.hovered': "var(--ds-background-accent-green-subtlest-hovered, #BAF3DB)",
    'color.background.accent.green.subtlest.pressed': "var(--ds-background-accent-green-subtlest-pressed, #97EDC9)",
    'color.background.accent.green.subtler': "var(--ds-background-accent-green-subtler, #BAF3DB)",
    'color.background.accent.green.subtler.hovered': "var(--ds-background-accent-green-subtler-hovered, #97EDC9)",
    'color.background.accent.green.subtler.pressed': "var(--ds-background-accent-green-subtler-pressed, #7EE2B8)",
    'color.background.accent.green.subtle': "var(--ds-background-accent-green-subtle, #4BCE97)",
    'color.background.accent.green.subtle.hovered': "var(--ds-background-accent-green-subtle-hovered, #7EE2B8)",
    'color.background.accent.green.subtle.pressed': "var(--ds-background-accent-green-subtle-pressed, #97EDC9)",
    'color.background.accent.green.bolder': "var(--ds-background-accent-green-bolder, #1F845A)",
    'color.background.accent.green.bolder.hovered': "var(--ds-background-accent-green-bolder-hovered, #216E4E)",
    'color.background.accent.green.bolder.pressed': "var(--ds-background-accent-green-bolder-pressed, #19573D)",
    'color.background.accent.teal.subtlest': "var(--ds-background-accent-teal-subtlest, #E7F9FF)",
    'color.background.accent.teal.subtlest.hovered': "var(--ds-background-accent-teal-subtlest-hovered, #C6EDFB)",
    'color.background.accent.teal.subtlest.pressed': "var(--ds-background-accent-teal-subtlest-pressed, #B1E4F7)",
    'color.background.accent.teal.subtler': "var(--ds-background-accent-teal-subtler, #C6EDFB)",
    'color.background.accent.teal.subtler.hovered': "var(--ds-background-accent-teal-subtler-hovered, #B1E4F7)",
    'color.background.accent.teal.subtler.pressed': "var(--ds-background-accent-teal-subtler-pressed, #9DD9EE)",
    'color.background.accent.teal.subtle': "var(--ds-background-accent-teal-subtle, #6CC3E0)",
    'color.background.accent.teal.subtle.hovered': "var(--ds-background-accent-teal-subtle-hovered, #9DD9EE)",
    'color.background.accent.teal.subtle.pressed': "var(--ds-background-accent-teal-subtle-pressed, #B1E4F7)",
    'color.background.accent.teal.bolder': "var(--ds-background-accent-teal-bolder, #227D9B)",
    'color.background.accent.teal.bolder.hovered': "var(--ds-background-accent-teal-bolder-hovered, #206A83)",
    'color.background.accent.teal.bolder.pressed': "var(--ds-background-accent-teal-bolder-pressed, #1A5265)",
    'color.background.accent.blue.subtlest': "var(--ds-background-accent-blue-subtlest, #E9F2FE)",
    'color.background.accent.blue.subtlest.hovered': "var(--ds-background-accent-blue-subtlest-hovered, #CFE1FD)",
    'color.background.accent.blue.subtlest.pressed': "var(--ds-background-accent-blue-subtlest-pressed, #ADCBFB)",
    'color.background.accent.blue.subtler': "var(--ds-background-accent-blue-subtler, #CFE1FD)",
    'color.background.accent.blue.subtler.hovered': "var(--ds-background-accent-blue-subtler-hovered, #ADCBFB)",
    'color.background.accent.blue.subtler.pressed': "var(--ds-background-accent-blue-subtler-pressed, #8FB8F6)",
    'color.background.accent.blue.subtle': "var(--ds-background-accent-blue-subtle, #669DF1)",
    'color.background.accent.blue.subtle.hovered': "var(--ds-background-accent-blue-subtle-hovered, #8FB8F6)",
    'color.background.accent.blue.subtle.pressed': "var(--ds-background-accent-blue-subtle-pressed, #ADCBFB)",
    'color.background.accent.blue.bolder': "var(--ds-background-accent-blue-bolder, #1868DB)",
    'color.background.accent.blue.bolder.hovered': "var(--ds-background-accent-blue-bolder-hovered, #1558BC)",
    'color.background.accent.blue.bolder.pressed': "var(--ds-background-accent-blue-bolder-pressed, #144794)",
    'color.background.accent.purple.subtlest': "var(--ds-background-accent-purple-subtlest, #F8EEFE)",
    'color.background.accent.purple.subtlest.hovered': "var(--ds-background-accent-purple-subtlest-hovered, #EED7FC)",
    'color.background.accent.purple.subtlest.pressed': "var(--ds-background-accent-purple-subtlest-pressed, #E3BDFA)",
    'color.background.accent.purple.subtler': "var(--ds-background-accent-purple-subtler, #EED7FC)",
    'color.background.accent.purple.subtler.hovered': "var(--ds-background-accent-purple-subtler-hovered, #E3BDFA)",
    'color.background.accent.purple.subtler.pressed': "var(--ds-background-accent-purple-subtler-pressed, #D8A0F7)",
    'color.background.accent.purple.subtle': "var(--ds-background-accent-purple-subtle, #C97CF4)",
    'color.background.accent.purple.subtle.hovered': "var(--ds-background-accent-purple-subtle-hovered, #D8A0F7)",
    'color.background.accent.purple.subtle.pressed': "var(--ds-background-accent-purple-subtle-pressed, #E3BDFA)",
    'color.background.accent.purple.bolder': "var(--ds-background-accent-purple-bolder, #964AC0)",
    'color.background.accent.purple.bolder.hovered': "var(--ds-background-accent-purple-bolder-hovered, #803FA5)",
    'color.background.accent.purple.bolder.pressed': "var(--ds-background-accent-purple-bolder-pressed, #673286)",
    'color.background.accent.magenta.subtlest': "var(--ds-background-accent-magenta-subtlest, #FFECF8)",
    'color.background.accent.magenta.subtlest.hovered': "var(--ds-background-accent-magenta-subtlest-hovered, #FDD0EC)",
    'color.background.accent.magenta.subtlest.pressed': "var(--ds-background-accent-magenta-subtlest-pressed, #FCB6E1)",
    'color.background.accent.magenta.subtler': "var(--ds-background-accent-magenta-subtler, #FDD0EC)",
    'color.background.accent.magenta.subtler.hovered': "var(--ds-background-accent-magenta-subtler-hovered, #FCB6E1)",
    'color.background.accent.magenta.subtler.pressed': "var(--ds-background-accent-magenta-subtler-pressed, #F797D2)",
    'color.background.accent.magenta.subtle': "var(--ds-background-accent-magenta-subtle, #E774BB)",
    'color.background.accent.magenta.subtle.hovered': "var(--ds-background-accent-magenta-subtle-hovered, #F797D2)",
    'color.background.accent.magenta.subtle.pressed': "var(--ds-background-accent-magenta-subtle-pressed, #FCB6E1)",
    'color.background.accent.magenta.bolder': "var(--ds-background-accent-magenta-bolder, #AE4787)",
    'color.background.accent.magenta.bolder.hovered': "var(--ds-background-accent-magenta-bolder-hovered, #943D73)",
    'color.background.accent.magenta.bolder.pressed': "var(--ds-background-accent-magenta-bolder-pressed, #77325B)",
    'color.background.accent.gray.subtlest': "var(--ds-background-accent-gray-subtlest, #F0F1F2)",
    'color.background.accent.gray.subtlest.hovered': "var(--ds-background-accent-gray-subtlest-hovered, #DDDEE1)",
    'color.background.accent.gray.subtlest.pressed': "var(--ds-background-accent-gray-subtlest-pressed, #B7B9BE)",
    'color.background.accent.gray.subtler': "var(--ds-background-accent-gray-subtler, #DDDEE1)",
    'color.background.accent.gray.subtler.hovered': "var(--ds-background-accent-gray-subtler-hovered, #B7B9BE)",
    'color.background.accent.gray.subtler.pressed': "var(--ds-background-accent-gray-subtler-pressed, #8C8F97)",
    'color.background.accent.gray.subtle': "var(--ds-background-accent-gray-subtle, #8C8F97)",
    'color.background.accent.gray.subtle.hovered': "var(--ds-background-accent-gray-subtle-hovered, #B7B9BE)",
    'color.background.accent.gray.subtle.pressed': "var(--ds-background-accent-gray-subtle-pressed, #DDDEE1)",
    'color.background.accent.gray.bolder': "var(--ds-background-accent-gray-bolder, #6B6E76)",
    'color.background.accent.gray.bolder.hovered': "var(--ds-background-accent-gray-bolder-hovered, #505258)",
    'color.background.accent.gray.bolder.pressed': "var(--ds-background-accent-gray-bolder-pressed, #3B3D42)",
    'color.background.disabled': "var(--ds-background-disabled, #17171708)",
    'color.background.input': "var(--ds-background-input, #FFFFFF)",
    'color.background.input.hovered': "var(--ds-background-input-hovered, #F8F8F8)",
    'color.background.input.pressed': "var(--ds-background-input-pressed, #FFFFFF)",
    'color.background.inverse.subtle': "var(--ds-background-inverse-subtle, #00000029)",
    'color.background.inverse.subtle.hovered': "var(--ds-background-inverse-subtle-hovered, #0000003D)",
    'color.background.inverse.subtle.pressed': "var(--ds-background-inverse-subtle-pressed, #00000052)",
    'color.background.neutral': "var(--ds-background-neutral, #0515240F)",
    'color.background.neutral.hovered': "var(--ds-background-neutral-hovered, #0B120E24)",
    'color.background.neutral.pressed': "var(--ds-background-neutral-pressed, #080F214A)",
    'color.background.neutral.subtle': "var(--ds-background-neutral-subtle, #00000000)",
    'color.background.neutral.subtle.hovered': "var(--ds-background-neutral-subtle-hovered, #0515240F)",
    'color.background.neutral.subtle.pressed': "var(--ds-background-neutral-subtle-pressed, #0B120E24)",
    'color.background.neutral.bold': "var(--ds-background-neutral-bold, #292A2E)",
    'color.background.neutral.bold.hovered': "var(--ds-background-neutral-bold-hovered, #3B3D42)",
    'color.background.neutral.bold.pressed': "var(--ds-background-neutral-bold-pressed, #505258)",
    'color.background.selected': "var(--ds-background-selected, #E9F2FE)",
    'color.background.selected.hovered': "var(--ds-background-selected-hovered, #CFE1FD)",
    'color.background.selected.pressed': "var(--ds-background-selected-pressed, #8FB8F6)",
    'color.background.selected.bold': "var(--ds-background-selected-bold, #1868DB)",
    'color.background.selected.bold.hovered': "var(--ds-background-selected-bold-hovered, #1558BC)",
    'color.background.selected.bold.pressed': "var(--ds-background-selected-bold-pressed, #123263)",
    'color.background.brand.subtlest': "var(--ds-background-brand-subtlest, #E9F2FE)",
    'color.background.brand.subtlest.hovered': "var(--ds-background-brand-subtlest-hovered, #CFE1FD)",
    'color.background.brand.subtlest.pressed': "var(--ds-background-brand-subtlest-pressed, #ADCBFB)",
    'color.background.brand.bold': "var(--ds-background-brand-bold, #1868DB)",
    'color.background.brand.bold.hovered': "var(--ds-background-brand-bold-hovered, #1558BC)",
    'color.background.brand.bold.pressed': "var(--ds-background-brand-bold-pressed, #144794)",
    'color.background.brand.boldest': "var(--ds-background-brand-boldest, #1C2B42)",
    'color.background.brand.boldest.hovered': "var(--ds-background-brand-boldest-hovered, #123263)",
    'color.background.brand.boldest.pressed': "var(--ds-background-brand-boldest-pressed, #144794)",
    'color.background.danger': "var(--ds-background-danger, #FFECEB)",
    'color.background.danger.hovered': "var(--ds-background-danger-hovered, #FFD5D2)",
    'color.background.danger.pressed': "var(--ds-background-danger-pressed, #FFB8B2)",
    'color.background.danger.subtler': "var(--ds-background-danger-subtler, #FFD5D2)",
    'color.background.danger.subtler.hovered': "var(--ds-background-danger-subtler-hovered, #FFB8B2)",
    'color.background.danger.subtler.pressed': "var(--ds-background-danger-subtler-pressed, #FD9891)",
    'color.background.danger.bold': "var(--ds-background-danger-bold, #C9372C)",
    'color.background.danger.bold.hovered': "var(--ds-background-danger-bold-hovered, #AE2E24)",
    'color.background.danger.bold.pressed': "var(--ds-background-danger-bold-pressed, #872821)",
    'color.background.warning': "var(--ds-background-warning, #FFF5DB)",
    'color.background.warning.hovered': "var(--ds-background-warning-hovered, #FCE4A6)",
    'color.background.warning.pressed': "var(--ds-background-warning-pressed, #FBD779)",
    'color.background.warning.subtler': "var(--ds-background-warning-subtler, #FCE4A6)",
    'color.background.warning.subtler.hovered': "var(--ds-background-warning-subtler-hovered, #FBD779)",
    'color.background.warning.subtler.pressed': "var(--ds-background-warning-subtler-pressed, #FBC828)",
    'color.background.warning.bold': "var(--ds-background-warning-bold, #FBC828)",
    'color.background.warning.bold.hovered': "var(--ds-background-warning-bold-hovered, #FCA700)",
    'color.background.warning.bold.pressed': "var(--ds-background-warning-bold-pressed, #F68909)",
    'color.background.success': "var(--ds-background-success, #EFFFD6)",
    'color.background.success.hovered': "var(--ds-background-success-hovered, #D3F1A7)",
    'color.background.success.pressed': "var(--ds-background-success-pressed, #BDE97C)",
    'color.background.success.subtler': "var(--ds-background-success-subtler, #D3F1A7)",
    'color.background.success.subtler.hovered': "var(--ds-background-success-subtler-hovered, #BDE97C)",
    'color.background.success.subtler.pressed': "var(--ds-background-success-subtler-pressed, #B3DF72)",
    'color.background.success.bold': "var(--ds-background-success-bold, #5B7F24)",
    'color.background.success.bold.hovered': "var(--ds-background-success-bold-hovered, #4C6B1F)",
    'color.background.success.bold.pressed': "var(--ds-background-success-bold-pressed, #3F5224)",
    'color.background.discovery': "var(--ds-background-discovery, #F8EEFE)",
    'color.background.discovery.hovered': "var(--ds-background-discovery-hovered, #EED7FC)",
    'color.background.discovery.pressed': "var(--ds-background-discovery-pressed, #E3BDFA)",
    'color.background.discovery.subtler': "var(--ds-background-discovery-subtler, #EED7FC)",
    'color.background.discovery.subtler.hovered': "var(--ds-background-discovery-subtler-hovered, #E3BDFA)",
    'color.background.discovery.subtler.pressed': "var(--ds-background-discovery-subtler-pressed, #D8A0F7)",
    'color.background.discovery.bold': "var(--ds-background-discovery-bold, #964AC0)",
    'color.background.discovery.bold.hovered': "var(--ds-background-discovery-bold-hovered, #803FA5)",
    'color.background.discovery.bold.pressed': "var(--ds-background-discovery-bold-pressed, #673286)",
    'color.background.information': "var(--ds-background-information, #E9F2FE)",
    'color.background.information.hovered': "var(--ds-background-information-hovered, #CFE1FD)",
    'color.background.information.pressed': "var(--ds-background-information-pressed, #ADCBFB)",
    'color.background.information.subtler': "var(--ds-background-information-subtler, #CFE1FD)",
    'color.background.information.subtler.hovered': "var(--ds-background-information-subtler-hovered, #ADCBFB)",
    'color.background.information.subtler.pressed': "var(--ds-background-information-subtler-pressed, #8FB8F6)",
    'color.background.information.bold': "var(--ds-background-information-bold, #1868DB)",
    'color.background.information.bold.hovered': "var(--ds-background-information-bold-hovered, #1558BC)",
    'color.background.information.bold.pressed': "var(--ds-background-information-bold-pressed, #144794)",
    'color.blanket': "var(--ds-blanket, #050C1F75)",
    'color.blanket.selected': "var(--ds-blanket-selected, #388BFF14)",
    'color.blanket.danger': "var(--ds-blanket-danger, #EF5C4814)",
    'color.skeleton': "var(--ds-skeleton, #0515240F)",
    'color.skeleton.subtle': "var(--ds-skeleton-subtle, #17171708)",
    'elevation.surface': "var(--ds-surface, #FFFFFF)",
    'elevation.surface.hovered': "var(--ds-surface-hovered, #F0F1F2)",
    'elevation.surface.pressed': "var(--ds-surface-pressed, #DDDEE1)",
    'elevation.surface.overlay': "var(--ds-surface-overlay, #FFFFFF)",
    'elevation.surface.overlay.hovered': "var(--ds-surface-overlay-hovered, #F0F1F2)",
    'elevation.surface.overlay.pressed': "var(--ds-surface-overlay-pressed, #DDDEE1)",
    'elevation.surface.raised': "var(--ds-surface-raised, #FFFFFF)",
    'elevation.surface.raised.hovered': "var(--ds-surface-raised-hovered, #F0F1F2)",
    'elevation.surface.raised.pressed': "var(--ds-surface-raised-pressed, #DDDEE1)",
    'elevation.surface.sunken': "var(--ds-surface-sunken, #F8F8F8)",
    'utility.elevation.surface.current': "var(--ds-elevation-surface-current, #FFFFFF)"
};
var $147b07b1e1c36302$export$8473307aa00d6ea1 = {
    'color.text': "var(--ds-text, #292A2E)",
    'color.text.accent.lime': "var(--ds-text-accent-lime, #4C6B1F)",
    'color.text.accent.lime.bolder': "var(--ds-text-accent-lime-bolder, #37471F)",
    'color.text.accent.red': "var(--ds-text-accent-red, #AE2E24)",
    'color.text.accent.red.bolder': "var(--ds-text-accent-red-bolder, #5D1F1A)",
    'color.text.accent.orange': "var(--ds-text-accent-orange, #9E4C00)",
    'color.text.accent.orange.bolder': "var(--ds-text-accent-orange-bolder, #693200)",
    'color.text.accent.yellow': "var(--ds-text-accent-yellow, #7F5F01)",
    'color.text.accent.yellow.bolder': "var(--ds-text-accent-yellow-bolder, #533F04)",
    'color.text.accent.green': "var(--ds-text-accent-green, #216E4E)",
    'color.text.accent.green.bolder': "var(--ds-text-accent-green-bolder, #164B35)",
    'color.text.accent.teal': "var(--ds-text-accent-teal, #206A83)",
    'color.text.accent.teal.bolder': "var(--ds-text-accent-teal-bolder, #164555)",
    'color.text.accent.blue': "var(--ds-text-accent-blue, #1558BC)",
    'color.text.accent.blue.bolder': "var(--ds-text-accent-blue-bolder, #123263)",
    'color.text.accent.purple': "var(--ds-text-accent-purple, #803FA5)",
    'color.text.accent.purple.bolder': "var(--ds-text-accent-purple-bolder, #48245D)",
    'color.text.accent.magenta': "var(--ds-text-accent-magenta, #943D73)",
    'color.text.accent.magenta.bolder': "var(--ds-text-accent-magenta-bolder, #50253F)",
    'color.text.accent.gray': "var(--ds-text-accent-gray, #505258)",
    'color.text.accent.gray.bolder': "var(--ds-text-accent-gray-bolder, #1E1F21)",
    'color.text.disabled': "var(--ds-text-disabled, #080F214A)",
    'color.text.inverse': "var(--ds-text-inverse, #FFFFFF)",
    'color.text.selected': "var(--ds-text-selected, #1868DB)",
    'color.text.brand': "var(--ds-text-brand, #1868DB)",
    'color.text.danger': "var(--ds-text-danger, #AE2E24)",
    'color.text.danger.bolder': "var(--ds-text-danger-bolder, #5D1F1A)",
    'color.text.warning': "var(--ds-text-warning, #9E4C00)",
    'color.text.warning.inverse': "var(--ds-text-warning-inverse, #292A2E)",
    'color.text.warning.bolder': "var(--ds-text-warning-bolder, #693200)",
    'color.text.success': "var(--ds-text-success, #4C6B1F)",
    'color.text.success.bolder': "var(--ds-text-success-bolder, #37471F)",
    'color.text.discovery': "var(--ds-text-discovery, #803FA5)",
    'color.text.discovery.bolder': "var(--ds-text-discovery-bolder, #48245D)",
    'color.text.information': "var(--ds-text-information, #1558BC)",
    'color.text.information.bolder': "var(--ds-text-information-bolder, #123263)",
    'color.text.subtlest': "var(--ds-text-subtlest, #6B6E76)",
    'color.text.subtle': "var(--ds-text-subtle, #505258)",
    'color.link': "var(--ds-link, #1868DB)",
    'color.link.pressed': "var(--ds-link-pressed, #1558BC)",
    'color.link.visited': "var(--ds-link-visited, #803FA5)",
    'color.link.visited.pressed': "var(--ds-link-visited-pressed, #48245D)"
};
var $147b07b1e1c36302$export$498780f74be9af68 = {
    'color.icon': "var(--ds-icon, #292A2E)",
    'color.icon.accent.lime': "var(--ds-icon-accent-lime, #6A9A23)",
    'color.icon.accent.red': "var(--ds-icon-accent-red, #C9372C)",
    'color.icon.accent.orange': "var(--ds-icon-accent-orange, #E06C00)",
    'color.icon.accent.yellow': "var(--ds-icon-accent-yellow, #B38600)",
    'color.icon.accent.green': "var(--ds-icon-accent-green, #22A06B)",
    'color.icon.accent.teal': "var(--ds-icon-accent-teal, #2898BD)",
    'color.icon.accent.blue': "var(--ds-icon-accent-blue, #357DE8)",
    'color.icon.accent.purple': "var(--ds-icon-accent-purple, #AF59E1)",
    'color.icon.accent.magenta': "var(--ds-icon-accent-magenta, #CD519D)",
    'color.icon.accent.gray': "var(--ds-icon-accent-gray, #7D818A)",
    'color.icon.disabled': "var(--ds-icon-disabled, #080F214A)",
    'color.icon.inverse': "var(--ds-icon-inverse, #FFFFFF)",
    'color.icon.selected': "var(--ds-icon-selected, #1868DB)",
    'color.icon.brand': "var(--ds-icon-brand, #1868DB)",
    'color.icon.danger': "var(--ds-icon-danger, #C9372C)",
    'color.icon.warning': "var(--ds-icon-warning, #E06C00)",
    'color.icon.warning.inverse': "var(--ds-icon-warning-inverse, #292A2E)",
    'color.icon.success': "var(--ds-icon-success, #6A9A23)",
    'color.icon.discovery': "var(--ds-icon-discovery, #AF59E1)",
    'color.icon.information': "var(--ds-icon-information, #357DE8)",
    'color.icon.subtlest': "var(--ds-icon-subtlest, #6B6E76)",
    'color.icon.subtle': "var(--ds-icon-subtle, #505258)"
};
var $147b07b1e1c36302$export$b5f31a7e431d2eab = {
    '1': 1,
    card: 100,
    navigation: 200,
    dialog: 300,
    layer: 400,
    blanket: 500,
    modal: 510,
    flag: 600,
    spotlight: 700,
    tooltip: 800
};
var $147b07b1e1c36302$export$e1b83c5210c471b8 = {
    'border.width': "var(--ds-border-width, 1px)",
    'border.width.selected': "var(--ds-border-width-selected, 2px)",
    'border.width.focused': "var(--ds-border-width-focused, 2px)"
};
var $147b07b1e1c36302$export$3c0a6c3e64bb180d = {
    'radius.xsmall': "var(--ds-radius-xsmall, 2px)",
    'radius.small': "var(--ds-radius-small, 3px)",
    'radius.medium': "var(--ds-radius-medium, 6px)",
    'radius.large': "var(--ds-radius-large, 8px)",
    'radius.xlarge': "var(--ds-radius-xlarge, 12px)",
    'radius.xxlarge': "var(--ds-radius-xxlarge, 16px)",
    'radius.full': "var(--ds-radius-full, 9999px)",
    'radius.tile': "var(--ds-radius-tile, 25%)"
};
var $147b07b1e1c36302$export$6ffa317d5e70375 = {
    'font.body': "var(--ds-font-body, normal 400 14px/20px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    // @deprecated
    'font.body.UNSAFE_small': "var(--ds-font-body-UNSAFE_small, normal 400 12px/16px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.body.large': "var(--ds-font-body-large, normal 400 16px/24px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.body.small': "var(--ds-font-body-small, normal 400 12px/16px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.code': "var(--ds-font-code, normal 400 0.875em/1 \"Atlassian Mono\", ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)",
    'font.heading.large': "var(--ds-font-heading-large, normal 653 24px/28px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.heading.medium': "var(--ds-font-heading-medium, normal 653 20px/24px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.heading.small': "var(--ds-font-heading-small, normal 653 16px/20px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.heading.xlarge': "var(--ds-font-heading-xlarge, normal 653 28px/32px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.heading.xsmall': "var(--ds-font-heading-xsmall, normal 653 14px/20px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.heading.xxlarge': "var(--ds-font-heading-xxlarge, normal 653 32px/36px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.heading.xxsmall': "var(--ds-font-heading-xxsmall, normal 653 12px/16px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.metric.large': "var(--ds-font-metric-large, normal 653 28px/32px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.metric.medium': "var(--ds-font-metric-medium, normal 653 24px/28px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.metric.small': "var(--ds-font-metric-small, normal 653 16px/20px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
};
var $147b07b1e1c36302$export$303e322c6b1ed114 = {
    'font.weight.bold': "var(--ds-font-weight-bold, 653)",
    'font.weight.medium': "var(--ds-font-weight-medium, 500)",
    'font.weight.regular': "var(--ds-font-weight-regular, 400)",
    'font.weight.semibold': "var(--ds-font-weight-semibold, 600)"
};
var $147b07b1e1c36302$export$3c7e9587132614b4 = {
    'font.family.body': "var(--ds-font-family-body, \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.family.brand.body': "var(--ds-font-family-brand-body, \"Charlie Text\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.family.brand.heading': "var(--ds-font-family-brand-heading, \"Charlie Display\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.family.code': "var(--ds-font-family-code, \"Atlassian Mono\", ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)",
    'font.family.heading': "var(--ds-font-family-heading, \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
};
var $147b07b1e1c36302$export$236bfe3a33ef1292 = {
    medium: "var(--ds-font-body, normal 400 14px/20px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    UNSAFE_small: "var(--ds-font-body-UNSAFE_small, normal 400 12px/16px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    large: "var(--ds-font-body-large, normal 400 16px/24px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    small: "var(--ds-font-body-small, normal 400 12px/16px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
};
var $147b07b1e1c36302$export$855cfd311192d666 = {
    bold: "var(--ds-font-weight-bold, 653)",
    medium: "var(--ds-font-weight-medium, 500)",
    regular: "var(--ds-font-weight-regular, 400)",
    semibold: "var(--ds-font-weight-semibold, 600)"
};
var $147b07b1e1c36302$export$b805719bc8cb376 = {
    large: "var(--ds-font-metric-large, normal 653 28px/32px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    medium: "var(--ds-font-metric-medium, normal 653 24px/28px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    small: "var(--ds-font-metric-small, normal 653 16px/20px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
};
/**
 * @codegenEnd
 */ // Margin needs some bespoke types: https://atlassian.slack.com/archives/CKRHB23K8/p1712623192772909
/**
 * Token functions are currently allowed for borderRadius in xcss to ease migration.
 * Because 'radius.small' defaults to 3px, we need a mechanism to allow for 4px values to be provided:
 * This is done by calling the token function - token('radius.small')
 *
 * TODO: Remove once shape them is rolled out and fg platform-dst-shape-theme-default removed
 */ // Generate maps for Box props. backgroundColor, padding, etc
var $147b07b1e1c36302$var$spacingProperties = [
    // Used by Box
    'padding',
    'paddingBlock',
    'paddingBlockStart',
    'paddingBlockEnd',
    'paddingInline',
    'paddingInlineStart',
    'paddingInlineEnd',
    // Used by Inline and Stack
    'gap',
    'rowGap',
    'columnGap'
];
var $147b07b1e1c36302$export$ca0f9c2de39ffed7 = function getSerializedStylesMap(cssProperty, tokenMap) {
    return Object.keys(tokenMap).reduce(function(emotionSpacingMap, token) {
        // eslint-disable-next-line @repo/internal/styles/no-exported-styles
        emotionSpacingMap[token] = (0, $74Zh5.css)((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, cssProperty, tokenMap[token]));
        return emotionSpacingMap;
    }, {});
};
var $147b07b1e1c36302$export$e615f061ca585a6c = $147b07b1e1c36302$var$spacingProperties.reduce(function(styleMap, spacingProperty) {
    styleMap[spacingProperty] = $147b07b1e1c36302$export$ca0f9c2de39ffed7(spacingProperty, $147b07b1e1c36302$export$958d0ae7f2977ae4);
    return styleMap;
}, {});
var $147b07b1e1c36302$export$bf46c3f9eeafc71f = $147b07b1e1c36302$var$spacingProperties.reduce(function(styleMap, spacingProperty) {
    styleMap[spacingProperty] = $147b07b1e1c36302$export$ca0f9c2de39ffed7(spacingProperty, $147b07b1e1c36302$export$958d0ae7f2977ae4);
    return styleMap;
}, {});
var $147b07b1e1c36302$export$e7af83bafe7f9e63 = $147b07b1e1c36302$export$ca0f9c2de39ffed7('backgroundColor', $147b07b1e1c36302$export$d1d79bf68ac056bd);
var $147b07b1e1c36302$export$3a1bcba60b23d7f0 = $147b07b1e1c36302$export$ca0f9c2de39ffed7('color', $147b07b1e1c36302$export$8473307aa00d6ea1);
var $147b07b1e1c36302$export$45f3f4fe16f9f7d5 = $147b07b1e1c36302$export$ca0f9c2de39ffed7('fontWeight', $147b07b1e1c36302$export$303e322c6b1ed114);
var $147b07b1e1c36302$export$68cc305da27dbaa4 = $147b07b1e1c36302$export$ca0f9c2de39ffed7('fontFamily', $147b07b1e1c36302$export$3c7e9587132614b4);
var $147b07b1e1c36302$export$128f10c238242f83 = $147b07b1e1c36302$export$ca0f9c2de39ffed7('font', $147b07b1e1c36302$export$6ffa317d5e70375);
var $147b07b1e1c36302$export$219d364c0da35ae4 = $147b07b1e1c36302$export$ca0f9c2de39ffed7('font', $147b07b1e1c36302$export$236bfe3a33ef1292);
var $147b07b1e1c36302$export$38845ca010b93505 = $147b07b1e1c36302$export$ca0f9c2de39ffed7('fontWeight', $147b07b1e1c36302$export$855cfd311192d666);
var $147b07b1e1c36302$export$ff257d957d48c421 = $147b07b1e1c36302$export$ca0f9c2de39ffed7((0, $lYcLA.CURRENT_SURFACE_CSS_VAR), $147b07b1e1c36302$export$41a358c9c2356760);
var $147b07b1e1c36302$export$5e65a44e5b6ecadb = function isSurfaceColorToken(color) {
    return $147b07b1e1c36302$export$41a358c9c2356760[color] !== undefined;
};
var $147b07b1e1c36302$export$7001ce64d9ff7c7f = $147b07b1e1c36302$export$ca0f9c2de39ffed7('font', $147b07b1e1c36302$export$b805719bc8cb376);

});
parcelRegister("lYcLA", function(module, exports) {
$parcel$export(module.exports, "CURRENT_SURFACE_CSS_VAR", () => $ffe91ac0d89ab8ec$export$9d7b58831ae93caa);
var $ffe91ac0d89ab8ec$export$4ef52930e33717cd = 'data-theme';
var $ffe91ac0d89ab8ec$export$cb374d25ded7f6ab = 'data-subtree-theme';
var $ffe91ac0d89ab8ec$export$a00eac3f8684bcd0 = 'data-color-mode';
var $ffe91ac0d89ab8ec$export$2112803007239c61 = 'data-contrast-mode';
var $ffe91ac0d89ab8ec$export$352e418ed5b6193a = 'data-custom-theme';
var $ffe91ac0d89ab8ec$export$6f0c6fb8c80fcc92 = 'ds';
var $ffe91ac0d89ab8ec$export$4d0c7bbf80185957 = [
    'opacity',
    'font',
    'space',
    'border',
    'radius'
];
var $ffe91ac0d89ab8ec$export$dddac1532e822863 = "--".concat($ffe91ac0d89ab8ec$export$6f0c6fb8c80fcc92, "-token-not-found");
var $ffe91ac0d89ab8ec$export$9d7b58831ae93caa = "--".concat($ffe91ac0d89ab8ec$export$6f0c6fb8c80fcc92, "-elevation-surface-current");

});


parcelRegister("a4gGZ", function(module, exports) {
$parcel$export(module.exports, "parseXcss", () => $754739de4ade0036$export$a9c84988c8f81f2d);
$parcel$export(module.exports, "xcss", () => $754739de4ade0036$export$f6c783d06584602c);

var $fC8ib = parcelRequire("fC8ib");

var $25nEq = parcelRequire("25nEq");

var $iYJcE = parcelRequire("iYJcE");

var $ekGgq = parcelRequire("ekGgq");

var $74Zh5 = parcelRequire("74Zh5");

var $1L15X = parcelRequire("1L15X");

var $3ZMUU = parcelRequire("3ZMUU");
function $754739de4ade0036$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $754739de4ade0036$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $754739de4ade0036$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $754739de4ade0036$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $754739de4ade0036$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $754739de4ade0036$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
var $754739de4ade0036$export$9a199fbafee0014e = {
    backgroundColor: (0, $1L15X.backgroundColorMap),
    blockSize: (0, $1L15X.dimensionMap),
    borderBlockColor: (0, $1L15X.borderColorMap),
    borderBlockEndColor: (0, $1L15X.borderColorMap),
    borderBlockEndWidth: (0, $1L15X.borderWidthMap),
    borderBlockStartColor: (0, $1L15X.borderColorMap),
    borderBlockStartWidth: (0, $1L15X.borderWidthMap),
    borderBlockWidth: (0, $1L15X.borderWidthMap),
    borderBottomColor: (0, $1L15X.borderColorMap),
    borderBottomLeftRadius: (0, $1L15X.borderRadiusMap),
    borderBottomRightRadius: (0, $1L15X.borderRadiusMap),
    borderBottomWidth: (0, $1L15X.borderWidthMap),
    borderColor: (0, $1L15X.borderColorMap),
    borderEndEndRadius: (0, $1L15X.borderRadiusMap),
    borderEndStartRadius: (0, $1L15X.borderRadiusMap),
    borderInlineColor: (0, $1L15X.borderColorMap),
    borderInlineEndColor: (0, $1L15X.borderColorMap),
    borderInlineEndWidth: (0, $1L15X.borderWidthMap),
    borderInlineStartColor: (0, $1L15X.borderColorMap),
    borderInlineStartWidth: (0, $1L15X.borderWidthMap),
    borderInlineWidth: (0, $1L15X.borderWidthMap),
    borderLeftColor: (0, $1L15X.borderColorMap),
    borderLeftWidth: (0, $1L15X.borderWidthMap),
    borderRadius: (0, $1L15X.borderRadiusMap),
    borderRightColor: (0, $1L15X.borderColorMap),
    borderRightWidth: (0, $1L15X.borderWidthMap),
    borderStartEndRadius: (0, $1L15X.borderRadiusMap),
    borderStartStartRadius: (0, $1L15X.borderRadiusMap),
    borderTopColor: (0, $1L15X.borderColorMap),
    borderTopLeftRadius: (0, $1L15X.borderRadiusMap),
    borderTopRightRadius: (0, $1L15X.borderRadiusMap),
    borderTopWidth: (0, $1L15X.borderWidthMap),
    borderWidth: (0, $1L15X.borderWidthMap),
    bottom: (0, $1L15X.allSpaceMap),
    boxShadow: (0, $1L15X.shadowMap),
    color: (0, $1L15X.textColorMap),
    columnGap: (0, $1L15X.positiveSpaceMap),
    font: (0, $1L15X.fontMap),
    fontFamily: (0, $1L15X.fontFamilyMap),
    fontWeight: (0, $1L15X.fontWeightMap),
    gap: (0, $1L15X.positiveSpaceMap),
    height: (0, $1L15X.dimensionMap),
    inlineSize: (0, $1L15X.dimensionMap),
    inset: (0, $1L15X.allSpaceMap),
    insetBlock: (0, $1L15X.allSpaceMap),
    insetBlockEnd: (0, $1L15X.allSpaceMap),
    insetBlockStart: (0, $1L15X.allSpaceMap),
    insetInline: (0, $1L15X.allSpaceMap),
    insetInlineEnd: (0, $1L15X.allSpaceMap),
    insetInlineStart: (0, $1L15X.allSpaceMap),
    left: (0, $1L15X.allSpaceMap),
    margin: (0, $1L15X.allSpaceMap),
    marginBlock: (0, $1L15X.allSpaceMap),
    marginBlockEnd: (0, $1L15X.allSpaceMap),
    marginBlockStart: (0, $1L15X.allSpaceMap),
    marginBottom: (0, $1L15X.allSpaceMap),
    marginInline: (0, $1L15X.allSpaceMap),
    marginInlineEnd: (0, $1L15X.allSpaceMap),
    marginInlineStart: (0, $1L15X.allSpaceMap),
    marginLeft: (0, $1L15X.allSpaceMap),
    marginRight: (0, $1L15X.allSpaceMap),
    marginTop: (0, $1L15X.allSpaceMap),
    maxBlockSize: (0, $1L15X.dimensionMap),
    maxHeight: (0, $1L15X.dimensionMap),
    maxInlineSize: (0, $1L15X.dimensionMap),
    maxWidth: (0, $1L15X.dimensionMap),
    minBlockSize: (0, $1L15X.dimensionMap),
    minHeight: (0, $1L15X.dimensionMap),
    minInlineSize: (0, $1L15X.dimensionMap),
    minWidth: (0, $1L15X.dimensionMap),
    opacity: (0, $1L15X.opacityMap),
    outlineColor: (0, $1L15X.borderColorMap),
    outlineOffset: (0, $1L15X.allSpaceMap),
    outlineWidth: (0, $1L15X.borderWidthMap),
    padding: (0, $1L15X.positiveSpaceMap),
    paddingBlock: (0, $1L15X.positiveSpaceMap),
    paddingBlockEnd: (0, $1L15X.positiveSpaceMap),
    paddingBlockStart: (0, $1L15X.positiveSpaceMap),
    paddingBottom: (0, $1L15X.positiveSpaceMap),
    paddingInline: (0, $1L15X.positiveSpaceMap),
    paddingInlineEnd: (0, $1L15X.positiveSpaceMap),
    paddingInlineStart: (0, $1L15X.positiveSpaceMap),
    paddingLeft: (0, $1L15X.positiveSpaceMap),
    paddingRight: (0, $1L15X.positiveSpaceMap),
    paddingTop: (0, $1L15X.positiveSpaceMap),
    right: (0, $1L15X.allSpaceMap),
    rowGap: (0, $1L15X.positiveSpaceMap),
    top: (0, $1L15X.allSpaceMap),
    width: (0, $1L15X.dimensionMap),
    zIndex: (0, $1L15X.layerMap)
};
var $754739de4ade0036$var$uniqueSymbol = Symbol('UNSAFE_INTERNAL_styles');
var $754739de4ade0036$var$isSafeEnvToThrow = function isSafeEnvToThrow() {
    return (typeof $3ZMUU === "undefined" ? "undefined" : (0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))($3ZMUU)) === 'object' && (0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))($3ZMUU.env) === 'object' && false;
};
var $754739de4ade0036$var$reNestedSelectors = /(\.|\s|&+|\*\>|#|\[.*\])/;
var $754739de4ade0036$var$safeSelectors = /^@media .*$|^::?.*$|^@supports .*$/;
var $754739de4ade0036$var$_transformStyles = function transformStyles(styleObj) {
    if (!styleObj || (0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(styleObj) !== 'object') return styleObj;
    // If styles are defined as a CSSObject[], recursively call on each element until we reach CSSObject
    if (Array.isArray(styleObj)) return styleObj.map($754739de4ade0036$var$_transformStyles);
    // Modifies styleObj in place. Be careful.
    Object.entries(styleObj).forEach(function(_ref) {
        var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_ref, 2), key = _ref2[0], value = _ref2[1];
        // If key is a pseudo class or a pseudo element, then value should be an object.
        // So, call transformStyles on the value
        if ((0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(value) === 'object' && $754739de4ade0036$var$safeSelectors.test(key)) {
            styleObj[key] = $754739de4ade0036$var$_transformStyles(value);
            return;
        }
        if ($754739de4ade0036$var$isSafeEnvToThrow()) {
            // We don't support `.class`, `[data-testid]`, `> *`, `#some-id`
            if ($754739de4ade0036$var$reNestedSelectors.test(key)) throw new Error("Styles not supported for key '".concat(key, "'."));
        }
        // We have now dealt with all the special cases, so,
        // check whether what remains is a style property
        // that can be transformed.
        if (!(key in $754739de4ade0036$export$9a199fbafee0014e)) return;
        var tokenValue = $754739de4ade0036$export$9a199fbafee0014e[key][value];
        styleObj[key] = tokenValue !== null && tokenValue !== void 0 ? tokenValue : value;
    });
    return styleObj;
};
var $754739de4ade0036$var$baseXcss = function baseXcss(style) {
    var transformedStyles = $754739de4ade0036$var$_transformStyles(style);
    return (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, $754739de4ade0036$var$uniqueSymbol, (0, $74Zh5.css)(transformedStyles));
};
/**
 * Picks out runtime XCSS objects and build-time XCSS strings. This is needed
 * to supported both Emotion and Compiled styles until we've fully migrated
 * to Compiled.
 *
 * @private
 * @deprecated
 */ var $754739de4ade0036$export$a9c84988c8f81f2d = function parseXcss(args) {
    if (Array.isArray(args)) {
        var emotion = [];
        var staticArr = [];
        var _iterator = $754739de4ade0036$var$_createForOfIteratorHelper(args), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var arg = _step.value;
                var result = $754739de4ade0036$export$a9c84988c8f81f2d(arg);
                if (result.emotion) emotion.push.apply(emotion, (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(result.emotion));
                if (result.static) staticArr.push(result.static);
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
        return {
            emotion: emotion,
            static: staticArr.join(' ')
        };
    }
    var objArgs = args;
    var _ref4 = objArgs || {}, styles = _ref4[$754739de4ade0036$var$uniqueSymbol];
    if (styles) return {
        emotion: [
            styles
        ]
    };
    if (args) {
        // We use string interpolation here instead of .toString() just
        // in case the resulting object doesn't have the method available.
        var stringifiedArgs = "".concat(args);
        if (stringifiedArgs) return {
            static: stringifiedArgs
        };
    }
    return {};
};
function $754739de4ade0036$export$f6c783d06584602c(style) {
    return $754739de4ade0036$var$baseXcss(style);
}

});


parcelRegister("3b5Jw", function(module, exports) {
$parcel$export(module.exports, "default", () => $2506d8a9b1e321ba$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5FkrB = parcelRequire("5FkrB");

var $74Zh5 = parcelRequire("74Zh5");

var $afMOk = parcelRequire("afMOk");

var $037uR = parcelRequire("037uR");

var $38QhU = parcelRequire("38QhU");

var $1L15X = parcelRequire("1L15X");
var $2506d8a9b1e321ba$var$asAllowlist = [
    'span',
    'p',
    'strong',
    'em'
];
// We're doing this because our CSS reset can add top margins to elements such as `p` which is totally insane.
// Long term we should remove those instances from the reset - it should be a reset to 0.
// For now, at least we know <Text> will be unaffected by this.
var $2506d8a9b1e321ba$var$resetStyles = (0, $74Zh5.css)({
    margin: 0,
    overflowWrap: 'anywhere'
});
var $2506d8a9b1e321ba$var$strongStyles = (0, $74Zh5.css)({
    fontWeight: "var(--ds-font-weight-bold, 653)"
});
var $2506d8a9b1e321ba$var$emStyles = (0, $74Zh5.css)({
    fontStyle: 'italic'
});
var $2506d8a9b1e321ba$var$textAlignMap = {
    center: (0, $74Zh5.css)({
        textAlign: 'center'
    }),
    end: (0, $74Zh5.css)({
        textAlign: 'end'
    }),
    start: (0, $74Zh5.css)({
        textAlign: 'start'
    })
};
var $2506d8a9b1e321ba$var$truncationStyles = (0, $74Zh5.css)({
    display: '-webkit-box',
    overflow: 'hidden',
    WebkitBoxOrient: 'vertical'
});
var $2506d8a9b1e321ba$var$wordBreakMap = {
    breakAll: (0, $74Zh5.css)({
        wordBreak: 'break-all'
    })
};
/**
 * Custom hook designed to abstract the parsing of the color props and make it clearer in the future how color is reconciled between themes and tokens.
 */ var $2506d8a9b1e321ba$var$useColor = function useColor(colorProp, hasTextAncestor) {
    var surface = (0, $38QhU.useSurface)();
    if (colorProp === 'inherit') return undefined;
    if (colorProp) return colorProp;
    if (hasTextAncestor) return undefined;
    if ((0, $1L15X.inverseColorMap).hasOwnProperty(surface)) return (0, $1L15X.inverseColorMap)[surface];
    return 'color.text';
};
/**
 * __Text__
 *
 * Text is a primitive component that has the Atlassian Design System's design guidelines baked in.
 * This includes considerations for text attributes such as color, font size, font weight, and line height.
 * It renders a `span` by default.
 *
 * @internal
 */ var $2506d8a9b1e321ba$var$Text = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? 'span' : _ref$as, colorProp = _ref.color, align = _ref.align, testId = _ref.testId, id = _ref.id, size = _ref.size, weight = _ref.weight, maxLines = _ref.maxLines, children = _ref.children;
    (0, $afMOk.default)($2506d8a9b1e321ba$var$asAllowlist.includes(Component), "@atlaskit/primitives: Text received an invalid \"as\" value of \"".concat(Component, "\""));
    var hasTextAncestor = (0, $037uR.useHasTextAncestor)();
    var color = $2506d8a9b1e321ba$var$useColor(colorProp, hasTextAncestor);
    if (!size && !hasTextAncestor) size = 'medium';
    var component = (0, $74Zh5.jsx)(Component, {
        ref: ref,
        css: [
            $2506d8a9b1e321ba$var$resetStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            size && (0, $1L15X.textSizeStylesMap)[size],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            color && (0, $1L15X.textColorStylesMap)[color],
            maxLines && $2506d8a9b1e321ba$var$truncationStyles,
            maxLines === 1 && $2506d8a9b1e321ba$var$wordBreakMap.breakAll,
            align && $2506d8a9b1e321ba$var$textAlignMap[align],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            weight && (0, $1L15X.textWeightStylesMap)[weight],
            Component === 'em' && $2506d8a9b1e321ba$var$emStyles,
            Component === 'strong' && $2506d8a9b1e321ba$var$strongStyles
        ],
        style: {
            WebkitLineClamp: maxLines
        },
        "data-testid": testId,
        id: id
    }, children);
    return hasTextAncestor ? // no need to re-apply context if the text is already wrapped
    component : (0, $74Zh5.jsx)((0, $037uR.HasTextAncestorProvider), {
        value: true
    }, component);
});
var $2506d8a9b1e321ba$export$2e2bcd8739ae039 = $2506d8a9b1e321ba$var$Text;

});
parcelRegister("037uR", function(module, exports) {
$parcel$export(module.exports, "useHasTextAncestor", () => $0096189b7aab1cb1$export$9322276ec105d055);
$parcel$export(module.exports, "HasTextAncestorProvider", () => $0096189b7aab1cb1$export$ae933c6cbe5643ad);

var $5FkrB = parcelRequire("5FkrB");
var $0096189b7aab1cb1$var$HasTextAncestorContext = /*#__PURE__*/ (0, $5FkrB.createContext)(false);
var $0096189b7aab1cb1$export$9322276ec105d055 = function useHasTextAncestor() {
    return (0, $5FkrB.useContext)($0096189b7aab1cb1$var$HasTextAncestorContext);
};
var $0096189b7aab1cb1$export$ae933c6cbe5643ad = $0096189b7aab1cb1$var$HasTextAncestorContext.Provider;

});


parcelRegister("cGH6O", function(module, exports) {
$parcel$export(module.exports, "messages", () => $02623d4d982ffa32$export$defe85febe8b728c);

var $aRMzY = parcelRequire("aRMzY");
var $02623d4d982ffa32$export$defe85febe8b728c = (0, $aRMzY.defineMessages)({
    placeholder: {
        id: 'fabric.editor.captionPlaceholder',
        defaultMessage: 'Add a caption',
        description: 'Placeholder description for an empty (new) caption in the editor'
    }
});

});



parcelRegister("1KF3y", function(module, exports) {
$parcel$export(module.exports, "default", () => $1469ef440d7c049e$export$2e2bcd8739ae039);

var $kqp0i = parcelRequire("kqp0i");

var $5FkrB = parcelRequire("5FkrB");

var $5MY3X = parcelRequire("5MY3X");

var $14WDN = parcelRequire("14WDN");

var $eskLW = parcelRequire("eskLW");

var $7q4H1 = parcelRequire("7q4H1");
function $1469ef440d7c049e$export$2e2bcd8739ae039(props) {
    var _props$content;
    var extraProps = {};
    var itemCounterDigitsSize = (0, $eskLW.getItemCounterDigitsSize)({
        order: props.order,
        itemsCount: props === null || props === void 0 || (_props$content = props.content) === null || _props$content === void 0 ? void 0 : _props$content.length
    });
    if (itemCounterDigitsSize && itemCounterDigitsSize > 1) extraProps.style = (0, $14WDN.getOrderedListInlineStyles)(itemCounterDigitsSize, 'object');
    if (props.order !== undefined) extraProps.start = (0, $eskLW.resolveOrder)(props.order);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("ol", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $5MY3X.orderedListSelector).substr(1),
        "data-local-id": props.localId,
        "data-indent-level": props.path ? (0, $7q4H1.getListIndentLevel)(props.path) : 1,
        start: props.start
    }, extraProps), props.children);
}

});
parcelRegister("14WDN", function(module, exports) {
$parcel$export(module.exports, "listItemCounterPadding", () => $0c93a70a73f78a3d$export$bafd6beec0797f87);
$parcel$export(module.exports, "getOrderedListInlineStyles", () => $0c93a70a73f78a3d$export$6d31fdb1d74cee3e);

var $25nEq = parcelRequire("25nEq");

var $iYJcE = parcelRequire("iYJcE");
var $0c93a70a73f78a3d$export$bafd6beec0797f87 = 24;
var $0c93a70a73f78a3d$var$CSS_VAR_NAMES = /*#__PURE__*/ function(CSS_VAR_NAMES) {
    CSS_VAR_NAMES["ITEM_COUNTER_PADDING"] = "--ed--list--item-counter--padding";
    return CSS_VAR_NAMES;
}($0c93a70a73f78a3d$var$CSS_VAR_NAMES || {});
var $0c93a70a73f78a3d$var$getItemCounterLeftPadding = function getItemCounterLeftPadding(itemCounterDigitsSize) {
    // Previous padding-left was approximately 24px. We approximate that
    // same value using "ch" units (which represent the width of a "0" digit
    // character). We use "ch" so that this computed padding can now grow if
    //  the font-size ever enlarges.
    var paddingLeft = "2.385ch";
    if (itemCounterDigitsSize >= 2) {
        // When there are 2 or more digits, we use a combination of "ch" units and
        // pixel values so that while the computed padding grows if font-size ever
        // enlarges, it doesn't over-scale with each digit (because of the fixed pixel
        // portion of the computed value). This way, very large item counters will not
        // become overly left-padded.
        var fixedBasePx = 2;
        paddingLeft = "calc(".concat(itemCounterDigitsSize + 1, "ch - ").concat(fixedBasePx, "px)");
    }
    return paddingLeft;
};
var $0c93a70a73f78a3d$var$stringifyStyle = function stringifyStyle(style) {
    return Object.entries(style).reduce(function(str, _ref) {
        var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_ref, 2), key = _ref2[0], value = _ref2[1];
        return "".concat(str).concat(key, ":").concat(value, ";");
    }, "");
};
function $0c93a70a73f78a3d$export$6d31fdb1d74cee3e(itemCounterDigitsSize, styleFormat) {
    var style = (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, $0c93a70a73f78a3d$var$CSS_VAR_NAMES.ITEM_COUNTER_PADDING, $0c93a70a73f78a3d$var$getItemCounterLeftPadding(itemCounterDigitsSize));
    if (styleFormat === 'string') return $0c93a70a73f78a3d$var$stringifyStyle(style);
    return style;
}

});

parcelRegister("eskLW", function(module, exports) {
$parcel$export(module.exports, "resolveOrder", () => $a863cb2158f9759f$export$d445360e2a3c026b);
$parcel$export(module.exports, "getItemCounterDigitsSize", () => $a863cb2158f9759f$export$320582fc14ba1e0f);
// File has been copied to packages/editor/editor-plugin-ai/src/provider/prosemirror-transformer/utils/list.ts
// If changes are made to this file, please make the same update in the linked file.
var $a863cb2158f9759f$export$8ef94ae42a3729bd = 1;
var $a863cb2158f9759f$export$d445360e2a3c026b = function resolveOrder(order) {
    var num = Number(order);
    if (Number.isNaN(num)) return;
    if (num < 0) return;
    return Math.floor(Math.max(num, 0));
};
var $a863cb2158f9759f$export$cbefb5b89ef0719f = function getOrderFromOrderedListNode(orderedListNode) {
    var _orderedListNode$attr, _resolveOrder;
    var order = orderedListNode === null || orderedListNode === void 0 || (_orderedListNode$attr = orderedListNode.attrs) === null || _orderedListNode$attr === void 0 ? void 0 : _orderedListNode$attr.order;
    return (_resolveOrder = $a863cb2158f9759f$export$d445360e2a3c026b(order)) !== null && _resolveOrder !== void 0 ? _resolveOrder : $a863cb2158f9759f$export$8ef94ae42a3729bd;
};
var $a863cb2158f9759f$export$320582fc14ba1e0f = function getItemCounterDigitsSize(options) {
    var _resolveOrder2, _String;
    var order = (_resolveOrder2 = $a863cb2158f9759f$export$d445360e2a3c026b(options.order)) !== null && _resolveOrder2 !== void 0 ? _resolveOrder2 : $a863cb2158f9759f$export$8ef94ae42a3729bd;
    var itemsCount = typeof options.itemsCount === 'number' ? options.itemsCount : 0;
    var largestCounter = order + (itemsCount - 1);
    return (_String = String(largestCounter)) === null || _String === void 0 || (_String = _String.split('.')) === null || _String === void 0 || (_String = _String[0]) === null || _String === void 0 ? void 0 : _String.length;
};
function $a863cb2158f9759f$export$a7d7d2b9ba4d4dbb(node) {
    return Boolean(node && node.type && [
        'orderedList',
        'bulletList'
    ].includes(node.type.name));
}
function $a863cb2158f9759f$export$35f600abfe6f0127(node) {
    return Boolean(node && node.type && 'paragraph' === node.type.name);
}
function $a863cb2158f9759f$export$2ddb0a75547407f6(node) {
    return Boolean(node && node.type && 'listItem' === node.type.name);
}
function $a863cb2158f9759f$export$35b2f400604e700(node) {
    return Boolean(node && node.type && 'bulletList' === node.type.name);
}

});


parcelRegister("jwO6B", function(module, exports) {
$parcel$export(module.exports, "default", () => $e377df60540b5f4b$export$2e2bcd8739ae039);

var $kqp0i = parcelRequire("kqp0i");

var $5FkrB = parcelRequire("5FkrB");

var $eS9fF = parcelRequire("eS9fF");
function $e377df60540b5f4b$export$2e2bcd8739ae039(_ref) {
    var children = _ref.children, dataAttributes = _ref.dataAttributes, localId = _ref.localId;
    return(/*#__PURE__*/ // ignore the eslint warning Text primitive does not support dataAttributes
    // eslint-disable-next-line @atlaskit/design-system/use-primitives-text
    // Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading, @atlaskit/design-system/use-primitives-text
    (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("p", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, dataAttributes, {
        "data-local-id": localId
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $eS9fF.default), null, children)));
}

});
parcelRegister("eS9fF", function(module, exports) {
$parcel$export(module.exports, "default", () => $ad3d490d42c7e378$export$2e2bcd8739ae039);

var $5FkrB = parcelRequire("5FkrB");
function $ad3d490d42c7e378$export$2e2bcd8739ae039(props) {
    var children = props.children;
    var childCount = (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).Children.toArray(children).length;
    if (!childCount) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).Fragment, null, "\xA0");
    return children;
}

});


parcelRegister("7UBSy", function(module, exports) {
$parcel$export(module.exports, "default", () => $5c2b2555a7521c16$export$2e2bcd8739ae039);

var $5FkrB = parcelRequire("5FkrB");
function $5c2b2555a7521c16$export$2e2bcd8739ae039(props) {
    if (props.allowPlaceholderText) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("span", {
        "data-placeholder": "".concat(props.text)
    }, props.text);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("span", null);
}

});

parcelRegister("1BsF5", function(module, exports) {
$parcel$export(module.exports, "default", () => $12af7abf61242b45$export$2e2bcd8739ae039);

var $5FkrB = parcelRequire("5FkrB");
function $12af7abf61242b45$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("hr", {
        role: "presentation"
    });
}

});

parcelRegister("8tCqL", function(module, exports) {
$parcel$export(module.exports, "isTableResizingEnabled", () => isTableResizingEnabled);
$parcel$export(module.exports, "isStickyScrollbarEnabled", () => isStickyScrollbarEnabled);
$parcel$export(module.exports, "orderChildren", () => orderChildren);
$parcel$export(module.exports, "hasRowspan", () => hasRowspan);
$parcel$export(module.exports, "getRefTop", () => getRefTop);
$parcel$export(module.exports, "shouldHeaderStick", () => shouldHeaderStick);
$parcel$export(module.exports, "shouldHeaderPinBottom", () => shouldHeaderPinBottom);
$parcel$export(module.exports, "addSortableColumn", () => addSortableColumn);
$parcel$export(module.exports, "isHeaderRowEnabled", () => isHeaderRowEnabled);
$parcel$export(module.exports, "tableCanBeSticky", () => tableCanBeSticky);
$parcel$export(module.exports, "TableContainer", () => TableContainer);
$parcel$export(module.exports, "TableProcessor", () => TableProcessor);
$parcel$export(module.exports, "default", () => $62bed7ae84e05238$export$2e2bcd8739ae039);

var $kqp0i = parcelRequire("kqp0i");

var $iYJcE = parcelRequire("iYJcE");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $kIXpt = parcelRequire("kIXpt");

var $cYPzS = parcelRequire("cYPzS");

var $eyuDe = parcelRequire("eyuDe");

var $25nEq = parcelRequire("25nEq");

var $5FkrB = parcelRequire("5FkrB");

var $6Wx3K = parcelRequire("6Wx3K");

var $fMtrl = parcelRequire("fMtrl");

var $hak1L = parcelRequire("hak1L");

var $c6bEO = parcelRequire("c6bEO");
var $01HkO = parcelRequire("01HkO");

var $9Zzpd = parcelRequire("9Zzpd");

var $3s4hn = parcelRequire("3s4hn");
var $il4RY = parcelRequire("il4RY");
var $1fkTi = parcelRequire("1fkTi");

var $gmeX4 = parcelRequire("gmeX4");

var $1LBcl = parcelRequire("1LBcl");

var $hrVpF = parcelRequire("hrVpF");

var $fAhSf = parcelRequire("fAhSf");

var $13ECD = parcelRequire("13ECD");

var $65d1I = parcelRequire("65d1I");

var $4qXRD = parcelRequire("4qXRD");

var $lAKm0 = parcelRequire("lAKm0");

var $dhEtU = parcelRequire("dhEtU");

var $KYtRS = parcelRequire("KYtRS");

var $gdaDF = parcelRequire("gdaDF");

var $4WuBO = parcelRequire("4WuBO");

var $drUcN = parcelRequire("drUcN");
function _createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function _unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return _arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
    }
}
function _arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function _callSuper(t, o, e) {
    return o = (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(o), (0, (/*@__PURE__*/$parcel$interopDefault($kIXpt)))(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(t).constructor) : o.apply(t, e));
}
function _isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return (_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var isTableResizingEnabled = function isTableResizingEnabled(appearance) {
    return (0, $KYtRS.isFullWidthOrFullPageAppearance)(appearance) || (0, $KYtRS.isCommentAppearance)(appearance) && (0, $fAhSf.editorExperiment)('support_table_in_comment', true, {
        exposure: true
    });
};
var isStickyScrollbarEnabled = function isStickyScrollbarEnabled(appearance) {
    return (0, $KYtRS.isFullWidthOrFullPageAppearance)(appearance) && (0, $fAhSf.editorExperiment)('platform_renderer_table_sticky_scrollbar', true, {
        exposure: true
    });
};
var orderChildren = function orderChildren(children, tableNode, smartCardStorage, tableOrderStatus) {
    if (!tableOrderStatus || tableOrderStatus.order === (0, $gmeX4.SortOrder).NO_ORDER) return children;
    var order = tableOrderStatus.order, columnIndex = tableOrderStatus.columnIndex;
    var compareNodesInOrder = (0, $1fkTi.createCompareNodes)({
        getInlineCardTextFromStore: function getInlineCardTextFromStore(attrs) {
            var _ref = attrs, url = _ref.url;
            if (!url) return null;
            return smartCardStorage.get(url) || null;
        }
    }, order);
    var tableArray = (0, $il4RY.convertProsemirrorTableNodeToArrayOfRows)(tableNode);
    var tableArrayWithChildren = tableArray.map(function(rowNodes, index) {
        return {
            rowNodes: rowNodes,
            rowReact: children[index]
        };
    });
    var headerRow = tableArrayWithChildren.shift();
    var sortedTable = tableArrayWithChildren.sort(function(rowA, rowB) {
        return compareNodesInOrder(rowA.rowNodes[columnIndex], rowB.rowNodes[columnIndex]);
    });
    if (headerRow) sortedTable.unshift(headerRow);
    return sortedTable.map(function(elem) {
        return elem.rowReact;
    });
};
var hasRowspan = function hasRowspan(row) {
    var hasRowspan = false;
    row.forEach(function(cell) {
        return hasRowspan = hasRowspan || cell.attrs.rowspan > 1;
    });
    return hasRowspan;
};
var getRefTop = function getRefTop(refElement) {
    return Math.round(refElement.getBoundingClientRect().top);
};
var shouldHeaderStick = function shouldHeaderStick(scrollTop, tableTop, tableBottom, rowHeight) {
    return tableTop <= scrollTop && !(tableBottom - rowHeight <= scrollTop);
};
var shouldHeaderPinBottom = function shouldHeaderPinBottom(scrollTop, tableBottom, rowHeight) {
    return tableBottom - rowHeight <= scrollTop && !(tableBottom < scrollTop);
};
var addSortableColumn = function addSortableColumn(rows, tableOrderStatus, onSorting) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).Children.map(rows, function(row, index) {
        if (index === 0) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).cloneElement((0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).Children.only(row), {
            tableOrderStatus: tableOrderStatus,
            onSorting: onSorting
        });
        return row;
    });
};
var isHeaderRowEnabled = function isHeaderRowEnabled(rows) {
    if (!rows.length) return false;
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var children = rows[0].props.children;
    if (!children.length) return false;
    if (children.length === 1) return children[0].type === (0, $65d1I.TableHeader);
    return children.every(function(node) {
        return node.type === (0, $65d1I.TableHeader);
    });
};
/**
 * This TableWrapper component was created to make sure that the aria-label can be
 * internationalized without needing to add `intl` to the TableContainer.
 *
 * @param {TableWrapperProps} root0 - The props object.
 * @param {React.ReactNode} root0.children - The table content to render inside the wrapper.
 * @param {React.RefObject<HTMLDivElement>} root0.wrapperRef - Ref to the wrapper div element.
 * @param {(() => void) | undefined} root0.onScroll - Optional scroll event handler.
 * @param {StickyHeaderConfig | undefined} root0.stickyHeaders - Optional sticky header configuration.
 * @returns The rendered table wrapper component.
 * @example
 * <TableWrapper wrapperRef={ref} onScroll={handleScroll} stickyHeaders={config}>
 *   <Table>...</Table>
 * </TableWrapper>
 */ var TableWrapper = function TableWrapper(_ref2) {
    var children = _ref2.children, wrapperRef = _ref2.wrapperRef, onScroll = _ref2.onScroll, stickyHeaders = _ref2.stickyHeaders;
    var _useIntl = (0, $6Wx3K.default)(), formatMessage = _useIntl.formatMessage;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $fMtrl.TableSharedCssClassName).TABLE_NODE_WRAPPER,
        ref: wrapperRef,
        onScroll: stickyHeaders ? onScroll : undefined,
        tabIndex: 0,
        role: "region",
        "aria-label": formatMessage((0, $hak1L.messages).tableScrollRegion)
    }, children);
};
var tableCanBeSticky = function tableCanBeSticky(node, children) {
    return isHeaderRowEnabled(children) && node && node.firstChild && !hasRowspan(node.firstChild);
};
var TableContainer = /*#__PURE__*/ function(_React$Component) {
    function TableContainer() {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, TableContainer);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _callSuper(this, TableContainer, [].concat(args));
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "state", {
            stickyMode: 'none',
            wrapperWidth: 0,
            headerRowHeight: 0
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "tableRef", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createRef());
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "stickyHeaderRef", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createRef());
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "stickyScrollbarRef", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createRef());
        // used for sync scroll + copying wrapper width to sticky header
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "stickyWrapperRef", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createRef());
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "wrapperRef", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createRef());
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "overflowParent", null);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "resizeObserver", null);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "applyResizerChange", function(entries) {
            var wrapperWidth = _this.state.wrapperWidth;
            var headerRowHeight = _this.state.headerRowHeight;
            var _iterator = _createForOfIteratorHelper(entries), _step;
            try {
                for(_iterator.s(); !(_step = _iterator.n()).done;){
                    var entry = _step.value;
                    if (entry.target === _this.wrapperRef.current) wrapperWidth = entry.contentRect.width;
                    else if (entry.target === _this.stickyHeaderRef.current) headerRowHeight = Math.round(entry.contentRect.height);
                }
            } catch (err) {
                _iterator.e(err);
            } finally{
                _iterator.f();
            }
            if (headerRowHeight !== _this.state.headerRowHeight || wrapperWidth !== _this.state.wrapperWidth) _this.setState({
                wrapperWidth: wrapperWidth,
                headerRowHeight: headerRowHeight
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "componentWillUnmount", function() {
            if (_this.overflowParent) // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            _this.overflowParent.removeEventListener('scroll', _this.onScroll);
            if (_this.nextFrame) cancelAnimationFrame(_this.nextFrame);
            if (_this.resizeObserver) _this.resizeObserver.disconnect();
            if (_this.stickyScrollbar) _this.stickyScrollbar.dispose();
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "getScrollTop", function() {
            var stickyHeaders = _this.props.stickyHeaders;
            var offsetTop = stickyHeaders && stickyHeaders.offsetTop || 0;
            return (_this.overflowParent ? _this.overflowParent.top : 0) + offsetTop;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "updateSticky", function() {
            var tableElem = _this.tableRef.current;
            var refElem = _this.stickyHeaderRef.current;
            if (!tableElem || !refElem) return;
            var scrollTop = _this.getScrollTop() + (0, $lAKm0.tableStickyPadding);
            var tableTop = getRefTop(tableElem);
            var tableBottom = tableTop + tableElem.clientHeight;
            var shouldSticky = shouldHeaderStick(scrollTop, tableTop, tableBottom, refElem.clientHeight);
            var shouldPin = shouldHeaderPinBottom(scrollTop, tableBottom, refElem.clientHeight);
            var stickyMode = 'none';
            if (shouldPin) stickyMode = 'pin-bottom';
            else if (shouldSticky) stickyMode = 'stick';
            if (_this.state.stickyMode !== stickyMode) _this.setState({
                stickyMode: stickyMode
            });
            _this.nextFrame = undefined;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "onScroll", function() {
            if (!_this.nextFrame) _this.nextFrame = requestAnimationFrame(_this.updateSticky);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "onWrapperScrolled", function() {
            if (!_this.wrapperRef.current || !_this.stickyWrapperRef.current) return;
            _this.stickyWrapperRef.current.scrollLeft = _this.wrapperRef.current.scrollLeft;
            if (_this.stickyScrollbarRef.current) _this.stickyScrollbarRef.current.scrollLeft = _this.wrapperRef.current.scrollLeft;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "grabFirstRowRef", function(children) {
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            return (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).Children.map(children || false, function(child, idx) {
                if (idx === 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).isValidElement(child)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).cloneElement(child, {
                    innerRef: _this.stickyHeaderRef
                });
                return child;
            });
        });
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($eyuDe)))(TableContainer, _React$Component);
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(TableContainer, [
        {
            key: "componentDidMount",
            value: /**
     *
     * @example
     */ function componentDidMount() {
                this.resizeObserver = new ResizeObserver(this.applyResizerChange);
                if (this.wrapperRef.current) this.resizeObserver.observe(this.wrapperRef.current);
                if (this.stickyHeaderRef.current) this.resizeObserver.observe(this.stickyHeaderRef.current);
                if (this.props.stickyHeaders) {
                    var _this$props$stickyHea;
                    this.overflowParent = (0, $lAKm0.OverflowParent).fromElement(this.tableRef.current, (_this$props$stickyHea = this.props.stickyHeaders) === null || _this$props$stickyHea === void 0 ? void 0 : _this$props$stickyHea.defaultScrollRootId_DO_NOT_USE);
                    // Ignored via go/ees005
                    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                    this.overflowParent.addEventListener('scroll', this.onScroll);
                }
                if (this.wrapperRef.current && isStickyScrollbarEnabled(this.props.rendererAppearance)) this.stickyScrollbar = new (0, $gdaDF.TableStickyScrollbar)(this.wrapperRef.current);
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps, prevState) {
                // toggling sticky headers visiblity
                if (this.props.stickyHeaders && !this.overflowParent) {
                    var _this$props$stickyHea2;
                    this.overflowParent = (0, $lAKm0.OverflowParent).fromElement(this.tableRef.current, (_this$props$stickyHea2 = this.props.stickyHeaders) === null || _this$props$stickyHea2 === void 0 ? void 0 : _this$props$stickyHea2.defaultScrollRootId_DO_NOT_USE);
                } else if (!this.props.stickyHeaders && this.overflowParent) {
                    // Ignored via go/ees005
                    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                    this.overflowParent.removeEventListener('scroll', this.onScroll);
                    this.overflowParent = null;
                }
                // offsetTop might have changed, re-position sticky header
                if (this.props.stickyHeaders !== prevProps.stickyHeaders) this.updateSticky();
                // sync horizontal scroll in floating div when toggling modes
                if (prevState.stickyMode !== this.state.stickyMode) this.onWrapperScrolled();
            }
        },
        {
            key: "pinTop",
            get: /**
     *
     */ function get() {
                if (!this.tableRef.current || !this.stickyHeaderRef.current) return;
                return this.tableRef.current.offsetHeight - this.stickyHeaderRef.current.offsetHeight + (0, $fMtrl.tableMarginTop) - (0, $lAKm0.tableStickyPadding);
            }
        },
        {
            key: "shouldAddOverflowParentOffsetTop_DO_NOT_USE",
            get: function get() {
                // IF the StickyHeaderConfig specifies that the default scroll root offsetTop should be added
                // AND the StickyHeaderConfig specifies a default scroll root id
                // AND the OverflowParent is the corresponding element
                // THEN we should add the OverflowParent offset top (RETURN TRUE)
                return this.props.stickyHeaders && !!this.props.stickyHeaders.shouldAddDefaultScrollRootOffsetTop_DO_NOT_USE && !!this.props.stickyHeaders.defaultScrollRootId_DO_NOT_USE && this.overflowParent && this.overflowParent.id === this.props.stickyHeaders.defaultScrollRootId_DO_NOT_USE;
            }
        },
        {
            key: "stickyTop",
            get: function get() {
                switch(this.state.stickyMode){
                    case 'pin-bottom':
                        return this.pinTop;
                    case 'stick':
                        var offsetTop = this.props.stickyHeaders && this.props.stickyHeaders.offsetTop;
                        if (typeof offsetTop === 'number' && this.shouldAddOverflowParentOffsetTop_DO_NOT_USE) {
                            var overflowParentOffsetTop = this.overflowParent ? this.overflowParent.top : 0;
                            return offsetTop + overflowParentOffsetTop;
                        } else return offsetTop;
                    default:
                        return undefined;
                }
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$tableRef$curren;
                var _this$props = this.props, isNumberColumnEnabled = _this$props.isNumberColumnEnabled, layout = _this$props.layout, renderWidth = _this$props.renderWidth, columnWidths = _this$props.columnWidths, stickyHeaders = _this$props.stickyHeaders, tableNode = _this$props.tableNode, rendererAppearance = _this$props.rendererAppearance, isInsideOfBlockNode = _this$props.isInsideOfBlockNode, isInsideOfTable = _this$props.isInsideOfTable, isinsideMultiBodiedExtension = _this$props.isinsideMultiBodiedExtension, allowTableAlignment = _this$props.allowTableAlignment, allowTableResizing = _this$props.allowTableResizing, isPresentational = _this$props.isPresentational;
                var stickyMode = this.state.stickyMode;
                var lineLengthFixedWidth = (0, $1LBcl.akEditorDefaultLayoutWidth);
                var left;
                var updatedLayout;
                // The tableWidth and left offset logic below must stay aligned with the `breakout-ssr.tsx` logic
                // Please consider changes below carefully to not negatively impact SSR
                // `renderWidth` cannot be depended on during SSR
                var isRenderWidthValid = !!renderWidth && renderWidth > 0;
                var fullPageRendererWidthCSS = (0, $fAhSf.editorExperiment)('platform_editor_preview_panel_responsiveness', true, {
                    exposure: true
                }) ? 'calc(100cqw - var(--ak-renderer--full-page-gutter) * 2)' : "100cqw - ".concat((0, $13ECD.FullPagePadding), "px * 2");
                var renderWidthCSS = rendererAppearance === 'full-page' ? fullPageRendererWidthCSS : "100cqw";
                var calcDefaultLayoutWidthByAppearance = function calcDefaultLayoutWidthByAppearance(rendererAppearance, tableNode) {
                    if (rendererAppearance === 'full-width' && !(tableNode !== null && tableNode !== void 0 && tableNode.attrs.width)) return [
                        isRenderWidthValid ? Math.min((0, $1LBcl.akEditorFullWidthLayoutWidth), renderWidth) : (0, $1LBcl.akEditorFullWidthLayoutWidth),
                        "min(".concat((0, $1LBcl.akEditorFullWidthLayoutWidth), "px, ").concat(renderWidthCSS, ")")
                    ];
                    else if (rendererAppearance === 'max' && !(tableNode !== null && tableNode !== void 0 && tableNode.attrs.width)) return [
                        isRenderWidthValid ? Math.min((0, $1LBcl.akEditorMaxWidthLayoutWidth), renderWidth) : (0, $1LBcl.akEditorMaxWidthLayoutWidth),
                        "min(".concat((0, $1LBcl.akEditorMaxWidthLayoutWidth), "px, ").concat(renderWidthCSS, ")")
                    ];
                    else if (rendererAppearance === 'comment' && allowTableResizing && !(tableNode !== null && tableNode !== void 0 && tableNode.attrs.width)) {
                        var tableContainerWidth = (0, $hrVpF.getTableContainerWidth)(tableNode);
                        return [
                            isRenderWidthValid ? renderWidth : tableContainerWidth,
                            renderWidthCSS
                        ];
                    } else {
                        // custom width, or width mapped to breakpoint
                        var _tableContainerWidth = (0, $hrVpF.getTableContainerWidth)(tableNode);
                        return [
                            isRenderWidthValid ? Math.min(_tableContainerWidth, renderWidth) : _tableContainerWidth,
                            "min(".concat(_tableContainerWidth, "px, ").concat(renderWidthCSS, ")")
                        ];
                    }
                };
                var _calcDefaultLayoutWid = calcDefaultLayoutWidthByAppearance(rendererAppearance, tableNode), _calcDefaultLayoutWid2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_calcDefaultLayoutWid, 2), tableWidth = _calcDefaultLayoutWid2[0], tableWidthCSS = _calcDefaultLayoutWid2[1];
                // Logic for table alignment in renderer
                var isTableAlignStart = tableNode && tableNode.attrs && tableNode.attrs.layout === 'align-start' && allowTableAlignment;
                var fullWidthLineLength = isRenderWidthValid ? Math.min((0, $1LBcl.akEditorFullWidthLayoutWidth), renderWidth) : (0, $1LBcl.akEditorFullWidthLayoutWidth);
                var fullWidthLineLengthCSS = "min(".concat((0, $1LBcl.akEditorFullWidthLayoutWidth), "px, ").concat(renderWidthCSS, ")");
                var maxWidthLineLength = isRenderWidthValid ? Math.min((0, $1LBcl.akEditorMaxWidthLayoutWidth), renderWidth) : (0, $1LBcl.akEditorMaxWidthLayoutWidth);
                var maxWidthLineLengthCSS = "min(".concat((0, $1LBcl.akEditorMaxWidthLayoutWidth), "px, ").concat(renderWidthCSS, ")");
                var commentLineLength = isRenderWidthValid ? renderWidth : lineLengthFixedWidth;
                var isCommentAppearanceAndTableAlignmentEnabled = (0, $KYtRS.isCommentAppearance)(rendererAppearance) && allowTableAlignment;
                var lineLength = (0, $KYtRS.isFullWidthAppearance)(rendererAppearance) ? fullWidthLineLength : (0, $KYtRS.isMaxWidthAppearance)(rendererAppearance) && (0, $drUcN.expValEquals)('editor_tinymce_full_width_mode', 'isEnabled', true) ? maxWidthLineLength : isCommentAppearanceAndTableAlignmentEnabled ? commentLineLength : lineLengthFixedWidth;
                var lineLengthCSS = (0, $KYtRS.isFullWidthAppearance)(rendererAppearance) ? fullWidthLineLengthCSS : (0, $KYtRS.isMaxWidthAppearance)(rendererAppearance) && (0, $drUcN.expValEquals)('editor_tinymce_full_width_mode', 'isEnabled', true) ? maxWidthLineLengthCSS : isCommentAppearanceAndTableAlignmentEnabled ? renderWidthCSS : "".concat(lineLengthFixedWidth, "px");
                // Setting fixTableSSRResizing to false while FG logic is true in tableNew
                var fixTableSSRResizing = false;
                var tableWidthNew = fixTableSSRResizing ? (0, $hrVpF.getTableContainerWidth)(tableNode) : tableWidth;
                var shouldCalculateLeftForAlignment = !isInsideOfBlockNode && !isInsideOfTable && isTableAlignStart && ((0, $KYtRS.isFullPageAppearance)(rendererAppearance) && tableWidthNew <= lineLengthFixedWidth || (0, $KYtRS.isFullWidthAppearance)(rendererAppearance) || (0, $drUcN.expValEquals)('editor_tinymce_full_width_mode', 'isEnabled', true) && (0, $KYtRS.isMaxWidthAppearance)(rendererAppearance) || isCommentAppearanceAndTableAlignmentEnabled);
                var leftCSS;
                if (shouldCalculateLeftForAlignment) {
                    left = (tableWidth - lineLength) / 2;
                    leftCSS = "(".concat(tableWidthCSS, " - ").concat(lineLengthCSS, ") / 2");
                }
                if (fixTableSSRResizing) {
                    if (!shouldCalculateLeftForAlignment && (0, $KYtRS.isFullPageAppearance)(rendererAppearance)) // Note tableWidthCSS here is the renderer width
                    // When the screen is super wide we want table to break out.
                    // However if screen is smaller than 760px. We want table align to left.
                    leftCSS = "min(0px, ".concat(lineLengthCSS, " - ").concat(tableWidthCSS, ") / 2");
                } else if (!shouldCalculateLeftForAlignment && (0, $KYtRS.isFullPageAppearance)(rendererAppearance) && tableWidthNew > lineLengthFixedWidth) left = lineLengthFixedWidth / 2 - tableWidth / 2;
                var children = (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).Children.toArray(this.props.children);
                // Historically, tables in the full-width renderer had their layout set to 'default' which is deceiving.
                // This check caters for those tables and helps with SSR logic
                var isFullWidth = !(tableNode !== null && tableNode !== void 0 && tableNode.attrs.width) && rendererAppearance === 'full-width' && layout !== 'full-width';
                if (isFullWidth) updatedLayout = 'full-width';
                else if (tableNode !== null && tableNode !== void 0 && tableNode.attrs.width) updatedLayout = 'custom';
                else updatedLayout = layout;
                var finalTableContainerWidth = allowTableResizing ? tableWidthNew : 'inherit';
                // We can only use CSS to determine the width when we have a known width in container.
                // When appearance is full-page, full-width or comment we use CSS based width calculation.
                // Otherwise it's fixed table width (customized width) or inherit.
                if ((rendererAppearance === 'full-page' || rendererAppearance === 'full-width' || rendererAppearance === 'max') && fixTableSSRResizing) finalTableContainerWidth = allowTableResizing ? "calc(".concat(tableWidthCSS, ")") : 'inherit';
                if (rendererAppearance === 'comment' && allowTableResizing && !allowTableAlignment) // If table alignment is disabled and table width is akEditorDefaultLayoutWidth = 760,
                // it is most likely a table created before "Support Table in Comments" FF was enabled
                // and we would see a bug ED-24795. A table created before "Support Table in Comments",
                // should inhirit the width of the renderer container.
                // !NOTE: it a table resized to 760 is copied from 'full-page' editor and pasted in comment editor
                // where (allowTableResizing && !allowTableAlignment), the table will loose 760px width.
                finalTableContainerWidth = tableNode !== null && tableNode !== void 0 && tableNode.attrs.width && (tableNode === null || tableNode === void 0 ? void 0 : tableNode.attrs.width) !== (0, $1LBcl.akEditorDefaultLayoutWidth) ? fixTableSSRResizing ? "calc(".concat(tableWidthCSS, ")") : tableWidth : 'inherit';
                if (rendererAppearance === 'comment' && allowTableResizing && allowTableAlignment) // If table alignment is enabled and layout is not 'align-start' or 'center', we are loading a table that was
                // created before "Support Table in Comments" FF was enabled. So the table should have the same width as renderer container
                // instead of 760 that was set on tableNode when the table had been published.
                finalTableContainerWidth = ((tableNode === null || tableNode === void 0 ? void 0 : tableNode.attrs.layout) === 'align-start' || (tableNode === null || tableNode === void 0 ? void 0 : tableNode.attrs.layout) === 'center') && tableNode !== null && tableNode !== void 0 && tableNode.attrs.width ? fixTableSSRResizing ? "calc(".concat(tableWidthCSS, ")") : tableWidth : 'inherit';
                var style;
                if (fixTableSSRResizing) style = {
                    width: finalTableContainerWidth,
                    left: leftCSS ? "calc(".concat(leftCSS, ")") : undefined,
                    marginLeft: shouldCalculateLeftForAlignment && leftCSS !== undefined ? "calc(-1 * (".concat(leftCSS, "))") : undefined
                };
                else style = {
                    width: finalTableContainerWidth,
                    left: left,
                    marginLeft: shouldCalculateLeftForAlignment && left !== undefined ? -left : undefined
                };
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("div", {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                    className: "".concat((0, $fMtrl.TableSharedCssClassName).TABLE_CONTAINER, " ").concat(this.props.shadowClassNames || ''),
                    "data-layout": updatedLayout,
                    ref: this.props.handleRef,
                    style: style
                }, isStickyScrollbarEnabled(this.props.rendererAppearance) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("div", {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                    className: (0, $fMtrl.TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_SENTINEL_TOP,
                    "data-testid": "sticky-scrollbar-sentinel-top"
                }), stickyHeaders && tableCanBeSticky(tableNode, children) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $lAKm0.StickyTable), {
                    isNumberColumnEnabled: isNumberColumnEnabled,
                    tableWidth: tableWidth,
                    layout: layout,
                    renderWidth: renderWidth,
                    handleRef: this.props.handleRef,
                    shadowClassNames: this.props.shadowClassNames,
                    top: this.stickyTop,
                    mode: stickyMode,
                    innerRef: this.stickyWrapperRef,
                    wrapperWidth: this.state.wrapperWidth,
                    columnWidths: columnWidths,
                    rowHeight: this.state.headerRowHeight,
                    tableNode: tableNode,
                    rendererAppearance: rendererAppearance,
                    allowTableResizing: allowTableResizing
                }, [
                    children && children[0]
                ]), (0, $9Zzpd.fg)('editor_enghealth_focusable_scrollable_tables') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(TableWrapper, {
                    wrapperRef: this.wrapperRef,
                    onScroll: this.props.stickyHeaders ? this.onWrapperScrolled : undefined,
                    stickyHeaders: stickyHeaders
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $dhEtU.Table), {
                    innerRef: this.tableRef,
                    columnWidths: columnWidths,
                    layout: layout,
                    isNumberColumnEnabled: isNumberColumnEnabled,
                    renderWidth: renderWidth,
                    tableNode: tableNode,
                    rendererAppearance: rendererAppearance,
                    isInsideOfBlockNode: isInsideOfBlockNode,
                    isInsideOfTable: isInsideOfTable,
                    isinsideMultiBodiedExtension: isinsideMultiBodiedExtension,
                    allowTableResizing: allowTableResizing,
                    isPresentational: isPresentational
                }, this.grabFirstRowRef(children))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("div", {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                    className: (0, $fMtrl.TableSharedCssClassName).TABLE_NODE_WRAPPER,
                    ref: this.wrapperRef,
                    onScroll: this.props.stickyHeaders && this.onWrapperScrolled
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $dhEtU.Table), {
                    innerRef: this.tableRef,
                    columnWidths: columnWidths,
                    layout: layout,
                    isNumberColumnEnabled: isNumberColumnEnabled,
                    renderWidth: renderWidth,
                    tableNode: tableNode,
                    rendererAppearance: rendererAppearance,
                    isInsideOfBlockNode: isInsideOfBlockNode,
                    isInsideOfTable: isInsideOfTable,
                    isinsideMultiBodiedExtension: isinsideMultiBodiedExtension,
                    allowTableResizing: allowTableResizing,
                    isPresentational: isPresentational
                }, this.grabFirstRowRef(children))), isStickyScrollbarEnabled(this.props.rendererAppearance) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("div", {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                    className: (0, $fMtrl.TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_CONTAINER,
                    ref: this.stickyScrollbarRef,
                    style: {
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                        height: "var(--ds-space-250, 20px)",
                        // MAX_BROWSER_SCROLLBAR_HEIGHT
                        // Follow editor to hide by default so it does not show empty gap in SSR
                        // https://stash.atlassian.com/projects/ATLASSIAN/repos/atlassian-frontend-monorepo/browse/platform/packages/editor/editor-plugin-table/src/nodeviews/TableComponent.tsx#957
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                        display: fixTableSSRResizing ? 'none' : 'block',
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
                        width: '100%'
                    }
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("div", {
                    style: {
                        width: (_this$tableRef$curren = this.tableRef.current) === null || _this$tableRef$curren === void 0 ? void 0 : _this$tableRef$curren.clientWidth,
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                        height: '100%'
                    }
                })), isStickyScrollbarEnabled(this.props.rendererAppearance) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("div", {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                    className: (0, $fMtrl.TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_SENTINEL_BOTTOM,
                    "data-testid": "sticky-scrollbar-sentinel-bottom"
                })));
            }
        }
    ]);
}((0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).Component);
var TableProcessor = /*#__PURE__*/ function(_React$Component2) {
    function TableProcessor() {
        var _this2;
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, TableProcessor);
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        _this2 = _callSuper(this, TableProcessor, [].concat(args));
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this2, "state", {
            tableOrderStatus: undefined
        });
        // adds sortable + re-orders children
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this2, "addSortableColumn", function(childrenArray) {
            var _this2$props = _this2.props, tableNode = _this2$props.tableNode, allowColumnSorting = _this2$props.allowColumnSorting, smartCardStorage = _this2$props.smartCardStorage;
            var tableOrderStatus = _this2.state.tableOrderStatus;
            if (allowColumnSorting && isHeaderRowEnabled(childrenArray) && tableNode && !(0, $il4RY.hasMergedCell)(tableNode)) return addSortableColumn(orderChildren(childrenArray, tableNode, smartCardStorage, tableOrderStatus), tableOrderStatus, _this2.changeSortOrder);
            return childrenArray;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this2, "changeSortOrder", function(columnIndex, sortOrder) {
            _this2.setState({
                tableOrderStatus: {
                    columnIndex: columnIndex,
                    order: sortOrder
                }
            });
        });
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this2, "addNumberColumnIndexes", function(rows) {
            var isNumberColumnEnabled = _this2.props.isNumberColumnEnabled;
            var headerRowEnabled = isHeaderRowEnabled(rows);
            return (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).Children.map(rows, function(row, index) {
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).cloneElement((0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).Children.only(row), {
                    isNumberColumnEnabled: isNumberColumnEnabled,
                    index: headerRowEnabled ? index === 0 ? '' : index : index + 1
                });
            });
        });
        return _this2;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($eyuDe)))(TableProcessor, _React$Component2);
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(TableProcessor, [
        {
            key: "render",
            value: /**
     *
     * @example
     */ function render() {
                var children = this.props.children;
                if (!children) return null;
                var childrenArray = (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).Children.toArray(children);
                var orderedChildren = (0, $3s4hn.compose)(this.addNumberColumnIndexes, this.addSortableColumn)(childrenArray);
                // Ignored via go/ees005
                // eslint-disable-next-line react/jsx-props-no-spreading
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(TableContainer, this.props, orderedChildren);
            }
        }
    ]);
}((0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).Component);
// eslint-disable-next-line @typescript-eslint/no-explicit-any
var TableWithShadowsAndContainerStyles = (0, $c6bEO.default)((0, $4WuBO.TableProcessorWithContainerStyles), {
    /**
   * The :scope is in reference to table container and we are selecting only
   * direct children that match the table node wrapper selector, not their
   * descendants.
   */ overflowSelector: ":scope > .".concat((0, $fMtrl.TableSharedCssClassName).TABLE_NODE_WRAPPER),
    useShadowObserver: true
});
// eslint-disable-next-line @typescript-eslint/no-explicit-any
var TableWithShadows = (0, $c6bEO.default)(TableProcessor, {
    /**
   * The :scope is in reference to table container and we are selecting only
   * direct children that match the table node wrapper selector, not their
   * descendants.
   */ overflowSelector: ":scope > .".concat((0, $fMtrl.TableSharedCssClassName).TABLE_NODE_WRAPPER),
    useShadowObserver: true
});
var TableWithWidth = function TableWithWidth(props) {
    if ((0, $9Zzpd.fg)('platform-ssr-table-resize')) {
        var _props$columnWidths;
        var colWidthsSum = ((_props$columnWidths = props.columnWidths) === null || _props$columnWidths === void 0 ? void 0 : _props$columnWidths.reduce(function(total, val) {
            return total + val;
        }, 0)) || 0;
        if (colWidthsSum || props.allowTableResizing) // Ignored via go/ees005
        // eslint-disable-next-line react/jsx-props-no-spreading
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(TableWithShadowsAndContainerStyles, props);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $4WuBO.TableProcessorWithContainerStyles), props);
    } else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $01HkO.WidthConsumer), null, function(_ref3) {
        var _props$columnWidths2;
        var width = _ref3.width;
        var renderWidth = props.rendererAppearance === 'full-page' ? width - (0, $13ECD.FullPagePadding) * 2 : width;
        var colWidthsSum = ((_props$columnWidths2 = props.columnWidths) === null || _props$columnWidths2 === void 0 ? void 0 : _props$columnWidths2.reduce(function(total, val) {
            return total + val;
        }, 0)) || 0;
        if (colWidthsSum || props.allowTableResizing) // Ignored via go/ees005
        // eslint-disable-next-line react/jsx-props-no-spreading
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(TableWithShadows, (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
            renderWidth: renderWidth
        }, props));
        // there should not be a case when colWidthsSum is 0 and table is in overflow state - so no need to render shadows in this case
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(TableProcessor, (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
            renderWidth: renderWidth
        }, props));
    });
};
var $62bed7ae84e05238$export$2e2bcd8739ae039 = (0, $4qXRD.withSmartCardStorage)(TableWithWidth);

});
parcelRegister("fMtrl", function(module, exports) {
$parcel$export(module.exports, "tableMarginTop", () => $b7d22ce51fe68d56$export$808015ab1dd6897a);
$parcel$export(module.exports, "tableCellMinWidth", () => $b7d22ce51fe68d56$export$531f77930bf508de);
$parcel$export(module.exports, "tableCellBorderWidth", () => $b7d22ce51fe68d56$export$72aad729077aa0fb);
$parcel$export(module.exports, "tableCellPadding", () => $b7d22ce51fe68d56$export$e56b8ca552b280f6);
$parcel$export(module.exports, "TableSharedCssClassName", () => $b7d22ce51fe68d56$export$c096bca5477eb7ad);

var $lAD7C = parcelRequire("lAD7C");

var $74Zh5 = parcelRequire("74Zh5");

var $4iuZ2 = parcelRequire("4iuZ2");

var $1LBcl = parcelRequire("1LBcl");
var $5wL5P = parcelRequire("5wL5P");

var $9Zzpd = parcelRequire("9Zzpd");

var $3tz1M = parcelRequire("3tz1M");

var $4vXmi = parcelRequire("4vXmi");

var $knSf2 = parcelRequire("knSf2");

var $iv75Q = parcelRequire("iv75Q");
var $b7d22ce51fe68d56$var$_templateObject, $b7d22ce51fe68d56$var$_templateObject2, $b7d22ce51fe68d56$var$_templateObject3;
var $b7d22ce51fe68d56$export$808015ab1dd6897a = 24;
var $b7d22ce51fe68d56$export$afe1899c3eea9823 = 16;
var $b7d22ce51fe68d56$export$910bf0d22c3d10f2 = 14;
var $b7d22ce51fe68d56$export$a43e30915fab3ccf = 8;
var $b7d22ce51fe68d56$export$531f77930bf508de = 48;
var $b7d22ce51fe68d56$export$c60fae4049791eae = 140;
var $b7d22ce51fe68d56$export$72aad729077aa0fb = 1;
var $b7d22ce51fe68d56$export$e56b8ca552b280f6 = 8;
var $b7d22ce51fe68d56$export$bba39e724bc39451 = 6;
var $b7d22ce51fe68d56$export$e5ff276883773ffd = 8;
var $b7d22ce51fe68d56$export$880976487022eb5 = $b7d22ce51fe68d56$export$808015ab1dd6897a + $b7d22ce51fe68d56$export$e5ff276883773ffd - $b7d22ce51fe68d56$export$72aad729077aa0fb;
var $b7d22ce51fe68d56$export$c096bca5477eb7ad = {
    TABLE_CONTAINER: "".concat((0, $4iuZ2.tablePrefixSelector), "-container"),
    TABLE_NODE_WRAPPER: "".concat((0, $4iuZ2.tablePrefixSelector), "-wrapper"),
    TABLE_NODE_WRAPPER_NO_OVERFLOW: "".concat((0, $4iuZ2.tablePrefixSelector), "-wrapper-no-overflow"),
    TABLE_SCROLL_INLINE_SHADOW: "".concat((0, $4iuZ2.tablePrefixSelector), "-scroll-inline-shadow"),
    TABLE_RIGHT_BORDER: "".concat((0, $4iuZ2.tablePrefixSelector), "-right-border"),
    TABLE_LEFT_BORDER: "".concat((0, $4iuZ2.tablePrefixSelector), "-left-border"),
    TABLE_LEFT_SHADOW: "".concat((0, $4iuZ2.tablePrefixSelector), "-with-left-shadow"),
    TABLE_RIGHT_SHADOW: "".concat((0, $4iuZ2.tablePrefixSelector), "-with-right-shadow"),
    TABLE_STICKY_SHADOW: "".concat((0, $4iuZ2.tablePrefixSelector), "-sticky-shadow"),
    TABLE_STICKY_WRAPPER: "".concat((0, $4iuZ2.tablePrefixSelector), "-sticky-wrapper"),
    TABLE_STICKY_SCROLLBAR_CONTAINER: "".concat((0, $4iuZ2.tablePrefixSelector), "-sticky-scrollbar-container"),
    TABLE_STICKY_SENTINEL_TOP: "".concat((0, $4iuZ2.tablePrefixSelector), "-sticky-sentinel-top"),
    TABLE_STICKY_SENTINEL_BOTTOM: "".concat((0, $4iuZ2.tablePrefixSelector), "-sticky-sentinel-bottom"),
    TABLE_STICKY_SCROLLBAR_SENTINEL_TOP: "".concat((0, $4iuZ2.tablePrefixSelector), "-sticky-scrollbar-sentinel-top"),
    TABLE_STICKY_SCROLLBAR_SENTINEL_BOTTOM: "".concat((0, $4iuZ2.tablePrefixSelector), "-sticky-scrollbar-sentinel-bottom"),
    TABLE_SHADOW_SENTINEL_LEFT: "".concat((0, $4iuZ2.tablePrefixSelector), "-shadow-sentinel-left"),
    TABLE_SHADOW_SENTINEL_RIGHT: "".concat((0, $4iuZ2.tablePrefixSelector), "-shadow-sentinel-right"),
    // eslint-disable-next-line @atlaskit/editor/no-re-export
    TABLE_CELL_NODEVIEW_CONTENT_DOM: (0, $4iuZ2.tableCellContentDomSelector),
    // eslint-disable-next-line @atlaskit/editor/no-re-export
    TABLE_CELL_WRAPPER: (0, $4iuZ2.tableCellSelector),
    // eslint-disable-next-line @atlaskit/editor/no-re-export
    TABLE_HEADER_CELL_WRAPPER: (0, $4iuZ2.tableHeaderSelector),
    TABLE_ROW_CONTROLS_WRAPPER: "".concat((0, $4iuZ2.tablePrefixSelector), "-row-controls-wrapper"),
    TABLE_COLUMN_CONTROLS_DECORATIONS: "".concat((0, $4iuZ2.tablePrefixSelector), "-column-controls-decoration"),
    TABLE_RESIZER_CONTAINER: "".concat((0, $4iuZ2.tablePrefixSelector), "-resizer-container")
};
/* first block node has 0 top margin */ var $b7d22ce51fe68d56$var$firstNodeWithNotMarginTop = function firstNodeWithNotMarginTop() {
    return (0, $9Zzpd.fg)('platform_editor_nested_dnd_styles_changes') ? (0, $74Zh5.css)($b7d22ce51fe68d56$var$_templateObject || ($b7d22ce51fe68d56$var$_templateObject = (0, (/*@__PURE__*/$parcel$interopDefault($lAD7C)))([
        "\n\t\t\t\t> :nth-child(1 of :not(style, .ProseMirror-gapcursor, .ProseMirror-widget, span)) {\n\t\t\t\t\tmargin-top: 0;\n\t\t\t\t}\n\t\t\t"
    ]))) : (0, $74Zh5.css)($b7d22ce51fe68d56$var$_templateObject2 || ($b7d22ce51fe68d56$var$_templateObject2 = (0, (/*@__PURE__*/$parcel$interopDefault($lAD7C)))([
        "\n\t\t\t\t> :first-child:not(style),\n\t\t\t\t> style:first-child + * {\n\t\t\t\t\tmargin-top: 0;\n\t\t\t\t}\n\n\t\t\t\t> .ProseMirror-gapcursor:first-child + *,\n\t\t\t\t> style:first-child + .ProseMirror-gapcursor + * {\n\t\t\t\t\tmargin-top: 0;\n\t\t\t\t}\n\n\t\t\t\t> .ProseMirror-gapcursor:first-child + span + *,\n\t\t\t\t> style:first-child + .ProseMirror-gapcursor + span + * {\n\t\t\t\t\tmargin-top: 0;\n\t\t\t\t}\n\t\t\t"
    ])));
};
var $b7d22ce51fe68d56$export$c2bf8eea75aa9302 = function tableSharedStyle() {
    var browser = (0, $3tz1M.expValEquals)('platform_editor_hydratable_ui', 'isEnabled', true) ? (0, $4vXmi.getBrowserInfo)() : (0, $4vXmi.browser);
    // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- Appears safe to auto-fix, but leaving it up to the team to remediate as the readability only gets worse with autofixing
    return (0, $74Zh5.css)($b7d22ce51fe68d56$var$_templateObject3 || ($b7d22ce51fe68d56$var$_templateObject3 = (0, (/*@__PURE__*/$parcel$interopDefault($lAD7C)))([
        "\n\t\t",
        "\n\t\t.",
        " {\n\t\t\tposition: relative;\n\t\t\tmargin: 0 auto ",
        ";\n\t\t\tbox-sizing: border-box;\n\n\t\t\t/**\n     * Fix block top alignment inside table cells.\n     */\n\t\t\t.decisionItemView-content-wrap:first-of-type > div {\n\t\t\t\tmargin-top: 0;\n\t\t\t}\n\t\t\t.",
        ",\n\t\t\t\t.",
        " {\n\t\t\t\tdisplay: block;\n\t\t\t\twidth: 1px;\n\t\t\t\theight: calc(100% - ",
        ");\n\t\t\t\tbackground: ",
        ";\n\t\t\t\tposition: absolute;\n\t\t\t\ttop: ",
        ";\n\t\t\t}\n\t\t\t.",
        " {\n\t\t\t\tright: 0;\n\t\t\t}\n\t\t\t.",
        " {\n\t\t\t\tleft: 0;\n\t\t\t}\n\t\t\t.",
        "[data-with-numbered-table='true'] {\n\t\t\t\tleft: ",
        "px;\n\t\t\t}\n\t\t}\n\t\t.",
        "[data-number-column='true'] {\n\t\t\tpadding-left: ",
        "px;\n\t\t\tclear: both;\n\t\t}\n\n\t\t.",
        " {\n\t\t\twill-change: width, margin-left;\n\t\t}\n\n\t\t.",
        " table {\n\t\t\twill-change: width;\n\t\t}\n\n\t\t.",
        " > table {\n\t\t\tmargin: ",
        " 0 0 0;\n\t\t}\n\n\t\t.",
        " > table,\n\t\t.",
        " > table {\n\t\t\tmargin: ",
        " ",
        " 0 0;\n\t\t}\n\n\t\t/* support panel nested in table */\n\t\t",
        "\n\n\t\t/* avoid applying styles to nested tables (possible via extensions) */\n\t.",
        " > table,\n\t.",
        " > table,\n\t.",
        " > table {\n\t\t\tborder-collapse: collapse;\n\t\t\tborder: ",
        "px solid ",
        ";\n\t\t\tborder-left-color: transparent;\n\t\t\tborder-right-color: transparent;\n\t\t\ttable-layout: fixed;\n\t\t\tfont-size: 1em;\n\t\t\twidth: 100%;\n\n\t\t\t&[data-autosize='true'] {\n\t\t\t\ttable-layout: auto;\n\t\t\t}\n\n\t\t\t& {\n\t\t\t\t* {\n\t\t\t\t\tbox-sizing: border-box;\n\t\t\t\t}\n\t\t\t\thr {\n\t\t\t\t\tbox-sizing: content-box;\n\t\t\t\t}\n\n\t\t\t\ttbody {\n\t\t\t\t\tborder-bottom: none;\n\t\t\t\t}\n\t\t\t\tth td {\n\t\t\t\t\tbackground-color: ",
        ";\n\t\t\t\t}\n\n\t\t\t\t> tbody > tr > th,\n\t\t\t\t> tbody > tr > td {\n\t\t\t\t\tmin-width: ",
        "px;\n\t\t\t\t\tfont-weight: ",
        ";\n\t\t\t\t\tvertical-align: top;\n\t\t\t\t\tborder: 1px solid ",
        ";\n\t\t\t\t\tborder-right-width: 0;\n\t\t\t\t\tborder-bottom-width: 0;\n\n\t\t\t\t\tpadding: ",
        ";\n\t\t\t\t\t/* https://stackoverflow.com/questions/7517127/borders-not-shown-in-firefox-with-border-collapse-on-table-position-relative-o */\n\t\t\t\t\t",
        "\n\n\t\t\t\t\t",
        "\n\n\t\t\t\tth p:not(:first-of-type),\n\t\t\t\ttd p:not(:first-of-type) {\n\t\t\t\t\t\tmargin-top: ",
        ";\n\t\t\t\t\t}\n\t\t\t\t}\n\n\t\t\t\t/* Ensures nested tables are compatible with parent table background color - uses specificity to ensure tables nested by extensions are not affected */\n\t\t\t\t> tbody > tr > td {\n\t\t\t\t\tbackground-color: ",
        ";\n\t\t\t\t}\n\n\t\t\t\tth {\n\t\t\t\t\tbackground-color: ",
        ";\n\t\t\t\t\ttext-align: left;\n\n\t\t\t\t\t/* only apply this styling to codeblocks in default background headercells */\n\t\t\t\t\t/* TODO this needs to be overhauled as it relies on unsafe selectors */\n\t\t\t\t\t",
        " {\n\t\t\t\t\t\t.",
        ":not(.danger) {\n\t\t\t\t\t\t\tbackground-color: ",
        ";\n\n\t\t\t\t\t\t\t:not(.",
        ") {\n\t\t\t\t\t\t\t\tbox-shadow: 0px 0px 0px 1px ",
        ";\n\t\t\t\t\t\t\t}\n\n\t\t\t\t\t\t\t.",
        " {\n\t\t\t\t\t\t\t\tbackground-image: ",
        ";\n\n\t\t\t\t\t\t\t\tbackground-color: ",
        ";\n\t\t\t\t\t\t\t}\n\n\t\t\t\t\t\t\t.",
        " {\n\t\t\t\t\t\t\t\tbackground-color: ",
        ";\n\t\t\t\t\t\t\t}\n\n\t\t\t\t\t\t\t/* this is only relevant to the element taken care of by renderer */\n\t\t\t\t\t\t\t> [data-ds--code--code-block] {\n\t\t\t\t\t\t\t\tbackground-image: ",
        "!important;\n\n\t\t\t\t\t\t\t\tbackground-color: ",
        "!important;\n\n\t\t\t\t\t\t\t\t/* selector lives inside @atlaskit/code */\n\t\t\t\t\t\t\t\t--ds--code--line-number-bg-color: ",
        ";\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t"
    ])), (0, $iv75Q.tableCellBackgroundStyleOverride)(), $b7d22ce51fe68d56$export$c096bca5477eb7ad.TABLE_CONTAINER, "var(--ds-space-200, 16px)", $b7d22ce51fe68d56$export$c096bca5477eb7ad.TABLE_RIGHT_BORDER, $b7d22ce51fe68d56$export$c096bca5477eb7ad.TABLE_LEFT_BORDER, "var(--ds-space-300, 24px)", "var(--ds-background-accent-gray-subtler, #DDDEE1)", "var(--ds-space-300, 24px)", $b7d22ce51fe68d56$export$c096bca5477eb7ad.TABLE_RIGHT_BORDER, $b7d22ce51fe68d56$export$c096bca5477eb7ad.TABLE_LEFT_BORDER, $b7d22ce51fe68d56$export$c096bca5477eb7ad.TABLE_LEFT_BORDER, (0, $1LBcl.akEditorTableNumberColumnWidth) - 1, $b7d22ce51fe68d56$export$c096bca5477eb7ad.TABLE_CONTAINER, (0, $1LBcl.akEditorTableNumberColumnWidth) - 1, $b7d22ce51fe68d56$export$c096bca5477eb7ad.TABLE_RESIZER_CONTAINER, $b7d22ce51fe68d56$export$c096bca5477eb7ad.TABLE_RESIZER_CONTAINER, $b7d22ce51fe68d56$export$c096bca5477eb7ad.TABLE_NODE_WRAPPER, "var(--ds-space-300, 24px)", $b7d22ce51fe68d56$export$c096bca5477eb7ad.TABLE_CONTAINER, $b7d22ce51fe68d56$export$c096bca5477eb7ad.TABLE_STICKY_WRAPPER, "var(--ds-space-300, 24px)", "var(--ds-space-100, 8px)", (0, $9Zzpd.fg)('platform_editor_bordered_panel_nested_in_table') ? ".".concat($b7d22ce51fe68d56$export$c096bca5477eb7ad.TABLE_NODE_WRAPPER, " .ak-editor-panel {\n\t\t\tborder: ", "var(--ds-border-width, 1px)", " solid ", "var(--ds-border, #0B120E24)", ";\n\t\t}") : '', $b7d22ce51fe68d56$export$c096bca5477eb7ad.TABLE_CONTAINER, $b7d22ce51fe68d56$export$c096bca5477eb7ad.TABLE_NODE_WRAPPER, $b7d22ce51fe68d56$export$c096bca5477eb7ad.TABLE_STICKY_WRAPPER, $b7d22ce51fe68d56$export$72aad729077aa0fb, "var(--ds-background-accent-gray-subtler, #DDDEE1)", "var(--ds-background-neutral-subtle, #00000000)", $b7d22ce51fe68d56$export$531f77930bf508de, "var(--ds-font-weight-regular, 400)", "var(--ds-background-accent-gray-subtler, #DDDEE1)", "var(--ds-space-100, 8px)", browser.gecko || browser.ie || browser.mac && browser.chrome ? 'background-clip: padding-box;' : '', $b7d22ce51fe68d56$var$firstNodeWithNotMarginTop(), "var(--ds-space-150, 12px)", "var(--ds-surface, #FFFFFF)", "var(--ds-background-accent-gray-subtlest, #F0F1F2)", (0, $3tz1M.expValEquals)('platform_editor_native_anchor_with_dnd', 'isEnabled', true) ? '&:not(.danger)' : '&:not([style]):not(.danger)', (0, $knSf2.CodeBlockSharedCssClassName).CODEBLOCK_CONTAINER, "var(--ds-surface-raised, #FFFFFF)", (0, $1LBcl.akEditorSelectedNodeClassName), "var(--ds-border, #0B120E24)", (0, $knSf2.CodeBlockSharedCssClassName).CODEBLOCK_CONTENT_WRAPPER, (0, $5wL5P.overflowShadow)({
        leftCoverWidth: "var(--ds-space-300, 24px)"
    }), "var(--ds-background-neutral, #0515240F)", (0, $knSf2.CodeBlockSharedCssClassName).CODEBLOCK_LINE_NUMBER_GUTTER, "var(--ds-background-neutral, #0515240F)", (0, $5wL5P.overflowShadow)({
        leftCoverWidth: "var(--ds-space-300, 24px)"
    }), "var(--ds-background-neutral, #0515240F)", "var(--ds-background-neutral, #0515240F)");
};
var $b7d22ce51fe68d56$export$d7ece4d8beb06815 = function calcTableWidth(layout, containerWidth) {
    var addControllerPadding = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    switch(layout){
        case 'full-width':
            return containerWidth ? Math.min(containerWidth - (addControllerPadding ? (0, $1LBcl.akEditorBreakoutPadding) : 0), (0, $1LBcl.akEditorFullWidthLayoutWidth)) : (0, $1LBcl.akEditorFullWidthLayoutWidth);
        case 'wide':
            if (containerWidth) return Math.min(containerWidth - (addControllerPadding ? (0, $1LBcl.akEditorBreakoutPadding) : 0), (0, $1LBcl.akEditorWideLayoutWidth));
            return 0, $1LBcl.akEditorWideLayoutWidth;
        default:
            return 'inherit';
    }
};

});
parcelRegister("4iuZ2", function(module, exports) {
$parcel$export(module.exports, "tablePrefixSelector", () => $3210e08c7d4764f9$export$9cfceb893b24742a);
$parcel$export(module.exports, "tableCellSelector", () => $3210e08c7d4764f9$export$69cb4c3f80383763);
$parcel$export(module.exports, "tableHeaderSelector", () => $3210e08c7d4764f9$export$7b07d37d879c957f);
$parcel$export(module.exports, "tableCellContentWrapperSelector", () => $3210e08c7d4764f9$export$8dd42a84cd52da07);
$parcel$export(module.exports, "tableCellContentDomSelector", () => $3210e08c7d4764f9$export$5e26a5c19f0865d8);
$parcel$export(module.exports, "getCellAttrs", () => $3210e08c7d4764f9$export$43977bde391e007);
$parcel$export(module.exports, "getCellDomAttrs", () => $3210e08c7d4764f9$export$363c8dda799bfe9c);
$parcel$export(module.exports, "tableBackgroundColorNames", () => $3210e08c7d4764f9$export$8cc2833b5b349a1e);
$parcel$export(module.exports, "tableBackgroundColorPalette", () => $3210e08c7d4764f9$export$219b7f492ad209f8);
$parcel$export(module.exports, "tableBackgroundBorderColor", () => $3210e08c7d4764f9$export$95e9c925fbf01d1c);
$parcel$export(module.exports, "table", () => $3210e08c7d4764f9$export$9852986a3ec5f6a0);
$parcel$export(module.exports, "tableWithCustomWidth", () => $3210e08c7d4764f9$export$90e634fbace1f0c4);
$parcel$export(module.exports, "tableStage0", () => $3210e08c7d4764f9$export$3862de5c8c9098cf);
$parcel$export(module.exports, "tableToJSON", () => $3210e08c7d4764f9$export$1f92a2f429e06fa8);
$parcel$export(module.exports, "tableRow", () => $3210e08c7d4764f9$export$ce666bf02318c957);
$parcel$export(module.exports, "tableCell", () => $3210e08c7d4764f9$export$e1e720e5f4603e6a);
$parcel$export(module.exports, "toJSONTableCell", () => $3210e08c7d4764f9$export$2ac34c099660f1a8);
$parcel$export(module.exports, "tableHeader", () => $3210e08c7d4764f9$export$48884d2a5190dc73);
$parcel$export(module.exports, "toJSONTableHeader", () => $3210e08c7d4764f9$export$2af48797a1010bb1);
$parcel$export(module.exports, "tableWithNestedTable", () => $3210e08c7d4764f9$export$ce086a560a1d05f5);
$parcel$export(module.exports, "tableRowWithNestedTable", () => $3210e08c7d4764f9$export$7d657479499397);
$parcel$export(module.exports, "tableCellWithNestedTable", () => $3210e08c7d4764f9$export$abf39ca178940ff3);
$parcel$export(module.exports, "tableHeaderWithNestedTable", () => $3210e08c7d4764f9$export$2a5a518232fa1a97);
$parcel$export(module.exports, "tableRowWithLocalId", () => $3210e08c7d4764f9$export$c8f0853ac97552c9);
$parcel$export(module.exports, "tableCellWithLocalId", () => $3210e08c7d4764f9$export$db76cfd28a574029);
$parcel$export(module.exports, "tableHeaderWithLocalId", () => $3210e08c7d4764f9$export$b82d2b1d8824143d);
$parcel$export(module.exports, "tableRowWithNestedTableWithLocalId", () => $3210e08c7d4764f9$export$27926e30c8a74147);
$parcel$export(module.exports, "tableCellWithNestedTableWithLocalId", () => $3210e08c7d4764f9$export$e9fd700fafee293a);
$parcel$export(module.exports, "tableHeaderWithNestedTableWithLocalId", () => $3210e08c7d4764f9$export$7928c3aeb4cd2213);

var $iYJcE = parcelRequire("iYJcE");

var $25nEq = parcelRequire("25nEq");

var $4KSDi = parcelRequire("4KSDi");

var $8HAlz = parcelRequire("8HAlz");

var $l56lt = parcelRequire("l56lt");

var $dGnui = parcelRequire("dGnui");

var $hibjE = parcelRequire("hibjE");
function $3210e08c7d4764f9$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $3210e08c7d4764f9$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $3210e08c7d4764f9$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $3210e08c7d4764f9$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $3210e08c7d4764f9$export$9cfceb893b24742a = 'pm-table';
var $3210e08c7d4764f9$export$69cb4c3f80383763 = "".concat($3210e08c7d4764f9$export$9cfceb893b24742a, "-cell-content-wrap");
var $3210e08c7d4764f9$export$7b07d37d879c957f = "".concat($3210e08c7d4764f9$export$9cfceb893b24742a, "-header-content-wrap");
var $3210e08c7d4764f9$export$8dd42a84cd52da07 = "".concat($3210e08c7d4764f9$export$9cfceb893b24742a, "-cell-nodeview-wrapper");
var $3210e08c7d4764f9$export$5e26a5c19f0865d8 = "".concat($3210e08c7d4764f9$export$9cfceb893b24742a, "-cell-nodeview-content-dom");
var $3210e08c7d4764f9$var$DEFAULT_TABLE_HEADER_CELL_BACKGROUND = (0, $8HAlz.N20).toLocaleLowerCase();
var $3210e08c7d4764f9$export$43977bde391e007 = function getCellAttrs(dom) {
    var defaultValues = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var widthAttr = dom.getAttribute('data-colwidth');
    var width = // @ts-ignore TS1501: This regular expression flag is only available when targeting 'es6' or later.
    widthAttr && /^[0-9]+(,[0-9]+)*$/.test(widthAttr) ? widthAttr.split(',').map(function(str) {
        return Number(str);
    }) : null;
    var colspan = Number(dom.getAttribute('colspan') || 1);
    var backgroundColor = dom.style.backgroundColor;
    /**
   * We have pivoted to store background color information in
   *  data-cell-background.
   * We will have original hex code (which we map to DST token)
   *  stored in data-cell-background, use that.
   * More details at https://product-fabric.atlassian.net/wiki/spaces/EUXQ/pages/3472556903/Tokenising+tableCell+background+colors#Update-toDom-and-parseDom-to-store-and-read-background-color-from-data-cell-background-attribute.4
   */ var dataCellBackground = dom.getAttribute('data-cell-background');
    var dataCellBackgroundHexCode = dataCellBackground && (0, $8HAlz.isHex)(dataCellBackground) ? dataCellBackground : undefined;
    // ignore setting background attr if ds neutral token is detected
    if (backgroundColor.includes('--ds-background-neutral')) backgroundColor = '';
    else if (backgroundColor && (0, $8HAlz.isRgb)(backgroundColor)) {
        var result = (0, $8HAlz.rgbToHex)(backgroundColor);
        if (result !== null) backgroundColor = result;
    }
    var backgroundHexCode = dataCellBackgroundHexCode || (backgroundColor && backgroundColor !== defaultValues['background'] ? backgroundColor : null);
    var localId = defaultValues === null || defaultValues === void 0 ? void 0 : defaultValues.localId;
    return $3210e08c7d4764f9$var$_objectSpread({
        colspan: colspan,
        rowspan: Number(dom.getAttribute('rowspan') || 1),
        colwidth: width && width.length === colspan ? width : null,
        background: backgroundHexCode
    }, localId && {
        localId: localId
    });
};
// these are for test only
var $3210e08c7d4764f9$var$testGlobalTheme;
var $3210e08c7d4764f9$export$fd7e0dd2b74807f7 = function setGlobalTheme(theme) {
    $3210e08c7d4764f9$var$testGlobalTheme = theme;
};
// This is a minimal duplication of the method from @atlaskit/tokens
// to minimise the number of dependencies required as these changes are expected
// to be patched onto CR8.
var $3210e08c7d4764f9$var$getGlobalTheme = function getGlobalTheme() {
    // This should only be hit during tests.
    //
    // At time of writing Jest mocks are not working in this repository.
    if ($3210e08c7d4764f9$var$testGlobalTheme) return {
        colorMode: $3210e08c7d4764f9$var$testGlobalTheme
    };
    var element = document.documentElement;
    var colorMode = element.getAttribute('data-color-mode') || '';
    return {
        colorMode: colorMode
    };
};
// @ts-ignore TS1501: This regular expression flag is only available when targeting 'es6' or later.
var $3210e08c7d4764f9$var$cssVariablePattern = /^var\(--(?:[\0-\t\x0B\f\x0E-\u2027\u202A-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])*\)$/;
var $3210e08c7d4764f9$export$363c8dda799bfe9c = function getCellDomAttrs(node) {
    var _node$attrs;
    var attrs = {};
    var nodeType = node.type.name;
    if (node.attrs.colspan !== 1) attrs.colspan = node.attrs.colspan;
    if (node.attrs.rowspan !== 1) attrs.rowspan = node.attrs.rowspan;
    if (node.attrs.colwidth) attrs['data-colwidth'] = node.attrs.colwidth.join(',');
    if (node.attrs.background) {
        var background = node.attrs.background;
        // to ensure that we don't overwrite product's style:
        // - it clears background color for <th> if its set to gray
        // - it clears background color for <td> if its set to white
        // - it clears background color for <th> if ds neutral token is detected
        var ignored = nodeType === 'tableHeader' && background === $3210e08c7d4764f9$export$8cc2833b5b349a1e.get('light gray') || nodeType === 'tableCell' && background === $3210e08c7d4764f9$export$8cc2833b5b349a1e.get('white') || nodeType === 'tableHeader' && background.includes('--ds-background-neutral');
        if (ignored) attrs.style = '';
        else {
            var color = (0, $8HAlz.isRgb)(background) && (0, $8HAlz.rgbToHex)(background) ? (0, $8HAlz.rgbToHex)(background) : background;
            /**
       * The Editor supports users pasting content from external sources with custom table cell backgrounds and having those
       * backgrounds persisted.
       *
       * This feature predates the introduction of dark mode.
       *
       * Without the inversion logic below, tokenised content (ie. text), can be hard to read when the user loads the page in dark mode.
       *
       * This introduces inversion of the presentation of the custom background color when the user is in dark mode.
       *
       * This can be done without additional changes to account for users copying and pasting content inside the Editor, because of
       * how we detect table cell background colors copied from external editor sources. Where we load the background color from a
       * seperate attribute (data-cell-background), instead of the inline style.
       *
       * See the following document for more details on this behaviour
       * https://hello.atlassian.net/wiki/spaces/CCECO/pages/2892247168/Unsupported+custom+table+cell+background+colors+in+dark+theme+Editor+Job+Story
       */ var tokenColor = (0, $4KSDi.hexToEditorBackgroundPaletteRawValue)(color);
            if (tokenColor) attrs.style = "background-color: ".concat(tokenColor, ";");
            else if (/**
       * There was previously a bug in dark mode where we would attempt to invert
       * a design token in `getDarkModeLCHColor` causing issues.
       * If it's a design token we should return it as is.
       */ $3210e08c7d4764f9$var$cssVariablePattern.test(color)) attrs.style = "background-color: ".concat(color, ";");
            else // if we have a custom color, we need to check if we are in dark mode
            if ($3210e08c7d4764f9$var$getGlobalTheme().colorMode === 'dark') // if we have a custom color, we need to check if we are in dark mode
            attrs.style = "background-color: ".concat((0, $dGnui.getDarkModeLCHColor)(color), ";");
            else // if we are in light mode, we can just set the color
            attrs.style = "background-color: ".concat(background, ";");
            /**
       * Storing hex code in data-cell-background because
       *  we want to have DST token (css variable) or
       *  DST token value (value (hex code) of css variable) in
       *  inline style to correct render table cell background
       *  based on selected theme.
       * Currently we rely on background color hex code stored in
       *  inline style.
       * Because of that when we copy and paste table, we end up
       *  having DST token or DST token value in ADF instead of
       *  original hex code which we map to DST token.
       * So, introducing data-cell-background.
       * More details at https://product-fabric.atlassian.net/wiki/spaces/EUXQ/pages/3472556903/Tokenising+tableCell+background+colors#Update-toDom-and-parseDom-to-store-and-read-background-color-from-data-cell-background-attribute.4
       */ if (color) attrs['data-cell-background'] = color;
            if (typeof color === 'string') attrs.colorname = $3210e08c7d4764f9$export$219b7f492ad209f8.get(color.toLowerCase());
        }
    }
    if (nodeType === 'tableHeader') attrs.class = $3210e08c7d4764f9$export$7b07d37d879c957f;
    else attrs.class = $3210e08c7d4764f9$export$69cb4c3f80383763;
    if (node !== null && node !== void 0 && (_node$attrs = node.attrs) !== null && _node$attrs !== void 0 && _node$attrs.localId) attrs['data-local-id'] = node.attrs.localId;
    return attrs;
};
var $3210e08c7d4764f9$export$219b7f492ad209f8 = new Map();
var $3210e08c7d4764f9$export$95e9c925fbf01d1c = (0, $8HAlz.hexToRgba)((0, $8HAlz.N800), 0.12) || (0, $8HAlz.N0);
var $3210e08c7d4764f9$export$8cc2833b5b349a1e = new Map();
[
    [
        (0, $8HAlz.N0),
        'White'
    ],
    [
        (0, $8HAlz.B50),
        'Light blue'
    ],
    [
        (0, $8HAlz.T50),
        'Light teal'
    ],
    [
        (0, $8HAlz.G50),
        'Light green'
    ],
    [
        (0, $8HAlz.Y50),
        'Light yellow'
    ],
    [
        (0, $8HAlz.R50),
        'Light red'
    ],
    [
        (0, $8HAlz.P50),
        'Light purple'
    ],
    [
        (0, $8HAlz.N20),
        'Light gray'
    ],
    [
        (0, $8HAlz.B75),
        'Blue'
    ],
    [
        (0, $8HAlz.T75),
        'Teal'
    ],
    [
        (0, $8HAlz.G75),
        'Green'
    ],
    [
        (0, $8HAlz.Y75),
        'Yellow'
    ],
    [
        (0, $8HAlz.R75),
        'Red'
    ],
    [
        (0, $8HAlz.P75),
        'Purple'
    ],
    [
        (0, $8HAlz.N60),
        'Gray'
    ],
    [
        (0, $8HAlz.B100),
        'Dark blue'
    ],
    [
        (0, $8HAlz.T100),
        'Dark teal'
    ],
    [
        (0, $8HAlz.G200),
        'Dark green'
    ],
    [
        (0, $8HAlz.Y200),
        'Dark yellow'
    ],
    [
        (0, $8HAlz.R100),
        'Dark red'
    ],
    [
        (0, $8HAlz.P100),
        'Dark purple'
    ]
].forEach(function(_ref) {
    var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_ref, 2), colorValue = _ref2[0], colorName = _ref2[1];
    $3210e08c7d4764f9$export$219b7f492ad209f8.set(colorValue.toLowerCase(), colorName);
    $3210e08c7d4764f9$export$8cc2833b5b349a1e.set(colorName.toLowerCase(), colorValue.toLowerCase());
});
/**
 * @name table_node
 */ /**
 * @name table_row_node
 */ /**
 * @name table_cell_content
 // eslint-disable-next-line eslint-plugin-jsdoc/check-tag-names
 * @minItems 1
 // eslint-disable-next-line eslint-plugin-jsdoc/check-tag-names
 * @allowUnsupportedBlock true
 */ /**
 * @name table_cell_node
 */ /**
 * @name table_header_node
 */ // table nodes with nested tables support
var $3210e08c7d4764f9$var$tableNodeSpecOptions = {
    parseDOM: [
        {
            tag: 'table',
            getAttrs: function getAttrs(node) {
                var _dom$parentElement;
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                var dom = node;
                var breakoutWrapper = (_dom$parentElement = dom.parentElement) === null || _dom$parentElement === void 0 ? void 0 : _dom$parentElement.parentElement;
                return {
                    isNumberColumnEnabled: dom.getAttribute('data-number-column') === 'true',
                    layout: // copying from editor
                    dom.getAttribute('data-layout') || (breakoutWrapper === null || breakoutWrapper === void 0 ? void 0 : breakoutWrapper.getAttribute('data-layout')) || 'default',
                    __autoSize: dom.getAttribute('data-autosize') === 'true',
                    localId: dom.getAttribute('data-table-local-id') || (0, $l56lt.uuid).generate(),
                    width: Number(dom.getAttribute('data-table-width')) || null,
                    displayMode: dom.getAttribute('data-table-display-mode') || null
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var attrs = {
            'data-number-column': node.attrs.isNumberColumnEnabled,
            'data-layout': node.attrs.layout,
            'data-autosize': node.attrs.__autoSize,
            'data-table-local-id': node.attrs.localId,
            'data-table-width': node.attrs.width,
            'data-table-display-mode': node.attrs.displayMode
        };
        return [
            'table',
            attrs,
            [
                'tbody',
                0
            ]
        ];
    }
};
// TODO: ED-5048 - Fix any, potential issue.
var $3210e08c7d4764f9$var$createTableSpec = function createTableSpec() {
    return (0, $hibjE.table)($3210e08c7d4764f9$var$tableNodeSpecOptions);
};
var $3210e08c7d4764f9$export$9852986a3ec5f6a0 = $3210e08c7d4764f9$var$createTableSpec();
var $3210e08c7d4764f9$export$90e634fbace1f0c4 = $3210e08c7d4764f9$var$createTableSpec();
var $3210e08c7d4764f9$export$3862de5c8c9098cf = $3210e08c7d4764f9$var$createTableSpec();
var $3210e08c7d4764f9$var$shouldIncludeAttribute = function shouldIncludeAttribute(key, value) {
    return !key.startsWith('__') && (key !== 'localId' || !!value);
};
var $3210e08c7d4764f9$export$1f92a2f429e06fa8 = function tableToJSON(node) {
    return {
        attrs: Object.keys(node.attrs).filter(function(key) {
            return $3210e08c7d4764f9$var$shouldIncludeAttribute(key, node.attrs[key]);
        }).reduce(function(obj, key) {
            return $3210e08c7d4764f9$var$_objectSpread($3210e08c7d4764f9$var$_objectSpread({}, obj), {}, (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, key, node.attrs[key]));
        }, {})
    };
};
var $3210e08c7d4764f9$var$tableRowNodeSpecOptions = {
    parseDOM: [
        {
            tag: 'tr'
        }
    ],
    toDOM: function toDOM() {
        return [
            'tr',
            0
        ];
    }
};
var $3210e08c7d4764f9$export$ce666bf02318c957 = (0, $hibjE.tableRow)($3210e08c7d4764f9$var$tableRowNodeSpecOptions);
var $3210e08c7d4764f9$var$cellAttrs = {
    colspan: {
        default: 1
    },
    rowspan: {
        default: 1
    },
    colwidth: {
        default: null
    },
    background: {
        default: null
    },
    localId: {
        default: null,
        optional: true
    }
};
var $3210e08c7d4764f9$var$tableCellNodeSpecOptions = {
    parseDOM: [
        // Ignore number cell copied from renderer
        {
            tag: '.ak-renderer-table-number-column',
            ignore: true
        },
        {
            tag: 'td',
            // eslint-disable-next-line @atlaskit/editor/no-as-casting
            getAttrs: function getAttrs(dom) {
                return $3210e08c7d4764f9$export$43977bde391e007(dom);
            }
        }
    ],
    toDOM: function toDOM(node) {
        return [
            'td',
            $3210e08c7d4764f9$export$363c8dda799bfe9c(node),
            0
        ];
    }
};
var $3210e08c7d4764f9$export$e1e720e5f4603e6a = (0, $hibjE.tableCell)($3210e08c7d4764f9$var$tableCellNodeSpecOptions);
var $3210e08c7d4764f9$export$2ac34c099660f1a8 = function toJSONTableCell(node) {
    return {
        attrs: Object.keys(node.attrs).reduce(function(obj, key) {
            // Only process keys that are defined in cellAttrs
            if ($3210e08c7d4764f9$var$cellAttrs[key] && $3210e08c7d4764f9$var$cellAttrs[key].default !== node.attrs[key]) obj[key] = node.attrs[key];
            return obj;
        }, {})
    };
};
var $3210e08c7d4764f9$var$tableHeaderNodeSpecOptions = {
    parseDOM: [
        {
            tag: 'th',
            getAttrs: function getAttrs(dom) {
                return(// eslint-disable-next-line @atlaskit/editor/no-as-casting
                $3210e08c7d4764f9$export$43977bde391e007(dom, {
                    background: $3210e08c7d4764f9$var$DEFAULT_TABLE_HEADER_CELL_BACKGROUND
                }));
            }
        }
    ],
    toDOM: function toDOM(node) {
        return [
            'th',
            $3210e08c7d4764f9$export$363c8dda799bfe9c(node),
            0
        ];
    }
};
var $3210e08c7d4764f9$export$48884d2a5190dc73 = (0, $hibjE.tableHeader)($3210e08c7d4764f9$var$tableHeaderNodeSpecOptions);
var $3210e08c7d4764f9$export$2af48797a1010bb1 = $3210e08c7d4764f9$export$2ac34c099660f1a8;
var $3210e08c7d4764f9$export$ce086a560a1d05f5 = (0, $hibjE.tableWithNestedTable)($3210e08c7d4764f9$var$tableNodeSpecOptions);
var $3210e08c7d4764f9$export$7d657479499397 = (0, $hibjE.tableRowWithNestedTable)($3210e08c7d4764f9$var$tableRowNodeSpecOptions);
var $3210e08c7d4764f9$export$abf39ca178940ff3 = (0, $hibjE.tableCellWithNestedTable)($3210e08c7d4764f9$var$tableCellNodeSpecOptions);
var $3210e08c7d4764f9$export$2a5a518232fa1a97 = (0, $hibjE.tableHeaderWithNestedTable)($3210e08c7d4764f9$var$tableHeaderNodeSpecOptions);
// table nodes with localId support
var $3210e08c7d4764f9$var$tableRowNodeSpecOptionsWithLocalId = {
    parseDOM: [
        {
            tag: 'tr',
            getAttrs: function getAttrs() {
                return {
                    localId: (0, $l56lt.uuid).generate()
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node$attrs2;
        return [
            'tr',
            {
                'data-local-id': (node === null || node === void 0 ? void 0 : (_node$attrs2 = node.attrs) === null || _node$attrs2 === void 0 ? void 0 : _node$attrs2.localId) || undefined
            },
            0
        ];
    }
};
var $3210e08c7d4764f9$export$c8f0853ac97552c9 = (0, $hibjE.tableRow)($3210e08c7d4764f9$var$tableRowNodeSpecOptionsWithLocalId);
var $3210e08c7d4764f9$var$tableCellNodeSpecOptionsWithLocalId = {
    parseDOM: [
        {
            tag: 'td',
            getAttrs: function getAttrs(dom) {
                return(// eslint-disable-next-line @atlaskit/editor/no-as-casting
                $3210e08c7d4764f9$export$43977bde391e007(dom, {
                    localId: (0, $l56lt.uuid).generate()
                }));
            }
        }
    ],
    toDOM: function toDOM(node) {
        return [
            'td',
            $3210e08c7d4764f9$export$363c8dda799bfe9c(node),
            0
        ];
    }
};
var $3210e08c7d4764f9$export$db76cfd28a574029 = (0, $hibjE.tableCell)($3210e08c7d4764f9$var$tableCellNodeSpecOptionsWithLocalId);
var $3210e08c7d4764f9$var$tableHeaderNodeSpecOptionsWithLocalId = {
    parseDOM: [
        {
            tag: 'th',
            getAttrs: function getAttrs(dom) {
                return(// eslint-disable-next-line @atlaskit/editor/no-as-casting
                $3210e08c7d4764f9$export$43977bde391e007(dom, {
                    background: $3210e08c7d4764f9$var$DEFAULT_TABLE_HEADER_CELL_BACKGROUND,
                    localId: (0, $l56lt.uuid).generate()
                }));
            }
        }
    ],
    toDOM: function toDOM(node) {
        return [
            'th',
            $3210e08c7d4764f9$export$363c8dda799bfe9c(node),
            0
        ];
    }
};
var $3210e08c7d4764f9$export$b82d2b1d8824143d = (0, $hibjE.tableHeader)($3210e08c7d4764f9$var$tableHeaderNodeSpecOptionsWithLocalId);
var $3210e08c7d4764f9$export$27926e30c8a74147 = (0, $hibjE.tableRowWithNestedTable)($3210e08c7d4764f9$var$tableRowNodeSpecOptionsWithLocalId);
var $3210e08c7d4764f9$export$e9fd700fafee293a = (0, $hibjE.tableCellWithNestedTable)($3210e08c7d4764f9$var$tableCellNodeSpecOptionsWithLocalId);
var $3210e08c7d4764f9$export$7928c3aeb4cd2213 = (0, $hibjE.tableHeaderWithNestedTable)($3210e08c7d4764f9$var$tableHeaderNodeSpecOptionsWithLocalId);

});
parcelRegister("4KSDi", function(module, exports) {
$parcel$export(module.exports, "hexToEditorBorderPaletteColor", () => $3765d63a56454829$export$bad3c41dd33cb4bc);
$parcel$export(module.exports, "hexToEditorTextPaletteColor", () => $3765d63a56454829$export$9c2f408d391feb93);
$parcel$export(module.exports, "hexToEditorTextBackgroundPaletteColor", () => $3765d63a56454829$export$8b58ff1b36bb75e0);
$parcel$export(module.exports, "hexToEditorBackgroundPaletteRawValue", () => $3765d63a56454829$export$a270511a0e7fd61a);
/**
 * This takes an adf hex color and returns a matching border palette color.
 *
 * By providing a design token, this enables ADF content to be rendered in new themes such as dark mode.
 *
 * Example usage
 * ```tsx
 * const cssValue = hexToEditorBorderPaletteColor('#091E4224');
 * //     ^? const cssValue: string
 * <div style={{borderColor: cssValue}} />
 * ```
 * The names of tokens can change over time, and the values of tokens will differ between themes.
 * The exact output of this function is an implementation detail and should only be used when rendering
 * content to the user, on a client with a matching major version of `@atlaskit/tokens`.
 * - **DO NOT**: store the output of these functions in any user-generated content or back-end.
 * - **DO**: store the ADF hex color, and use these utilities at render time to display the themed version of the color
 */ function $3765d63a56454829$export$bad3c41dd33cb4bc(hexColor) {
    // Ts ignore was used to allow use of conditional return type
    // (preferencing better type on consumption over safety in implementation)
    // @ts-expect-error
    return hexColor ? $3765d63a56454829$export$aa000893c5e2b9c2[hexColor.toUpperCase()] : undefined;
}
var $3765d63a56454829$export$aa000893c5e2b9c2 = {
    /** gray - subtle */ '#091E4224': 'var(--ds-border, #091E4224)',
    /** gray */ '#758195': 'var(--ds-border-bold, #758195)',
    /** gray - bold */ '#172B4D': 'var(--ds-text, #172B4D)'
};
function $3765d63a56454829$export$9c2f408d391feb93(hexColor) {
    // Ts ignore was used to allow use of conditional return type
    // (preferencing better type on consumption over safety in implementation)
    // @ts-expect-error
    return hexColor ? $3765d63a56454829$export$57fa5089caad992[hexColor.toUpperCase()] : undefined;
}
var $3765d63a56454829$export$57fa5089caad992 = {
    /** blue - light */ '#B3D4FF': 'var(--ds-background-accent-blue-subtler, #B3D4FF)',
    /** blue - medium */ '#4C9AFF': 'var(--ds-icon-accent-blue, #4C9AFF)',
    /** blue - strong */ '#0747A6': 'var(--ds-text-accent-blue, #0747A6)',
    /** teal - light */ '#B3F5FF': 'var(--ds-background-accent-teal-subtler, #B3F5FF)',
    /** teal - medium */ '#00B8D9': 'var(--ds-icon-accent-teal, #00B8D9)',
    /** teal - strong */ '#008DA6': 'var(--ds-text-accent-teal, #008DA6)',
    /** green - light */ '#ABF5D1': 'var(--ds-background-accent-green-subtler, #ABF5D1)',
    /** green - medium */ '#36B37E': 'var(--ds-icon-accent-green, #36B37E)',
    /** green - strong */ '#006644': 'var(--ds-text-accent-green, #006644)',
    /** yellowOrange - light */ '#FFF0B3': 'var(--ds-background-accent-yellow-subtler, #FFF0B3)',
    /** yellowOrange - medium */ '#FFC400': 'var(--ds-background-accent-orange-subtle, #FFC400)',
    /** yellowOrange - strong */ '#FF991F': 'var(--ds-icon-accent-orange, #FF991F)',
    /** red - light */ '#FFBDAD': 'var(--ds-background-accent-red-subtler, #FFBDAD)',
    /** red - medium */ '#FF5630': 'var(--ds-icon-accent-red, #FF5630)',
    /** red - strong */ '#BF2600': 'var(--ds-text-accent-red, #BF2600)',
    /** purple - light */ '#EAE6FF': 'var(--ds-background-accent-purple-subtler, #EAE6FF)',
    /** purple - medium */ '#6554C0': 'var(--ds-icon-accent-purple, #6554C0)',
    /** purple - strong */ '#403294': 'var(--ds-text-accent-purple, #403294)',
    /** whiteGray - light */ '#FFFFFF': 'var(--ds-text-inverse, #FFFFFF)',
    /** whiteGray - medium */ '#97A0AF': 'var(--ds-icon-accent-gray, #97A0AF)',
    /** whiteGray - strong */ '#172B4D': 'var(--ds-text, #172B4D)'
};
function $3765d63a56454829$export$8b58ff1b36bb75e0(hexColor) {
    // Ts ignore was used to allow use of conditional return type
    // (preferring better type on consumption over safety in implementation)
    // @ts-expect-error
    return hexColor ? $3765d63a56454829$export$12a518ff137dd389[hexColor.toUpperCase()] : undefined;
}
var $3765d63a56454829$export$12a518ff137dd389 = {
    /** Gray - light */ '#DCDFE4': 'var(--ds-background-accent-gray-subtler, #DCDFE4)',
    /** Teal - light */ '#C6EDFB': 'var(--ds-background-accent-teal-subtler, #C6EDFB)',
    /** Lime - light */ '#D3F1A7': 'var(--ds-background-accent-lime-subtler, #D3F1A7)',
    /** Yellow - light */ '#F8E6A0': 'var(--ds-background-accent-yellow-subtler, #F8E6A0)',
    /** Orange - light */ '#FEDEC8': 'var(--ds-background-accent-orange-subtler, #FEDEC8)',
    /** Magenta - light */ '#FDD0EC': 'var(--ds-background-accent-magenta-subtler, #FDD0EC)',
    /** Purple - light */ '#DFD8FD': 'var(--ds-background-accent-purple-subtler, #DFD8FD)'
};
function $3765d63a56454829$export$a270511a0e7fd61a(hexColor) {
    // Ts ignore was used to allow use of conditional return type
    // (preferencing better type on consumption over safety in implementation)
    // @ts-ignore
    var tokenData = hexColor ? $3765d63a56454829$export$2462741d70e6a62f[hexColor.toUpperCase()] : undefined;
    // @ts-expect-error
    return tokenData ? tokenData.getValue(hexColor) : undefined;
}
var $3765d63a56454829$export$2462741d70e6a62f = {
    /** blue - light */ '#DEEBFF': {
        getValue: function getValue() {
            return '#DEEBFF';
        },
        token: 'var(--ds-background-accent-blue-subtlest, #DEEBFF)'
    },
    /** blue - medium */ '#B3D4FF': {
        getValue: function getValue() {
            return '#B3D4FF';
        },
        token: 'var(--ds-background-accent-blue-subtler, #B3D4FF)'
    },
    /** blue - strong */ '#4C9AFF': {
        getValue: function getValue() {
            return '#4C9AFF';
        },
        token: 'var(--ds-background-accent-blue-subtle, #4C9AFF)'
    },
    /** teal - light */ '#E6FCFF': {
        getValue: function getValue() {
            return '#E6FCFF';
        },
        token: 'var(--ds-background-accent-teal-subtlest, #E6FCFF)'
    },
    /** teal - medium */ '#B3F5FF': {
        getValue: function getValue() {
            return '#B3F5FF';
        },
        token: 'var(--ds-background-accent-teal-subtler, #B3F5FF)'
    },
    /** teal - strong */ '#79E2F2': {
        getValue: function getValue() {
            return '#79E2F2';
        },
        token: 'var(--ds-background-accent-teal-subtle, #79E2F2)'
    },
    /** green - light */ '#E3FCEF': {
        getValue: function getValue() {
            return '#E3FCEF';
        },
        token: 'var(--ds-background-accent-green-subtlest, #E3FCEF)'
    },
    /** green - medium */ '#ABF5D1': {
        getValue: function getValue() {
            return '#ABF5D1';
        },
        token: 'var(--ds-background-accent-green-subtler, #ABF5D1)'
    },
    /** green - strong */ '#57D9A3': {
        getValue: function getValue() {
            return '#57D9A3';
        },
        token: 'var(--ds-background-accent-green-subtle, #57D9A3)'
    },
    /** yellowOrange - light */ '#FFFAE6': {
        getValue: function getValue() {
            return '#FFFAE6';
        },
        token: 'var(--ds-background-accent-yellow-subtlest, #FFFAE6)'
    },
    /** yellowOrange - medium */ '#FFF0B3': {
        getValue: function getValue() {
            return '#FFF0B3';
        },
        token: 'var(--ds-background-accent-yellow-subtler, #FFF0B3)'
    },
    /** yellowOrange - strong */ '#FFC400': {
        getValue: function getValue() {
            return '#FFC400';
        },
        token: 'var(--ds-background-accent-orange-subtle, #FFC400)'
    },
    /** red - light */ '#FFEBE6': {
        getValue: function getValue() {
            return '#FFEBE6';
        },
        token: 'var(--ds-background-accent-red-subtlest, #FFEBE6)'
    },
    /** red - medium */ '#FFBDAD': {
        getValue: function getValue() {
            return '#FFBDAD';
        },
        token: 'var(--ds-background-accent-red-subtler, #FFBDAD)'
    },
    /** red - strong */ '#FF8F73': {
        getValue: function getValue() {
            return '#FF8F73';
        },
        token: 'var(--ds-background-accent-red-subtle, #FF8F73)'
    },
    /** purple - light */ '#EAE6FF': {
        getValue: function getValue() {
            return '#EAE6FF';
        },
        token: 'var(--ds-background-accent-purple-subtlest, #EAE6FF)'
    },
    /** purple - medium */ '#C0B6F2': {
        getValue: function getValue() {
            return '#C0B6F2';
        },
        token: 'var(--ds-background-accent-purple-subtler, #C0B6F2)'
    },
    /** purple - strong */ '#998DD9': {
        getValue: function getValue() {
            return '#998DD9';
        },
        token: 'var(--ds-background-accent-purple-subtle, #998DD9)'
    },
    /** whiteGray - light */ '#FFFFFF': {
        getValue: function getValue() {
            return '#FFFFFF';
        },
        token: 'var(--ds-surface, #FFFFFF)'
    },
    /** whiteGray - medium */ '#F4F5F7': {
        getValue: function getValue() {
            return '#F4F5F7';
        },
        token: 'var(--ds-background-accent-gray-subtlest, #F4F5F7)'
    },
    /** whiteGray - strong */ '#B3BAC5': {
        getValue: function getValue() {
            return '#B3BAC5';
        },
        token: 'var(--ds-background-accent-gray-subtle, #B3BAC5)'
    }
};

});

parcelRegister("8HAlz", function(module, exports) {
$parcel$export(module.exports, "R50", () => $655e88a26762ab9b$export$4b84fd0e2c617bd);
$parcel$export(module.exports, "R75", () => $655e88a26762ab9b$export$b34b069eff244586);
$parcel$export(module.exports, "R100", () => $655e88a26762ab9b$export$be802dd0d8b57f35);
$parcel$export(module.exports, "R300", () => $655e88a26762ab9b$export$4a7404f376229999);
$parcel$export(module.exports, "R500", () => $655e88a26762ab9b$export$2837b5a1a71d5c02);
$parcel$export(module.exports, "Y50", () => $655e88a26762ab9b$export$8d9596b529bbb9cf);
$parcel$export(module.exports, "Y75", () => $655e88a26762ab9b$export$41060a744ab0b7ae);
$parcel$export(module.exports, "Y200", () => $655e88a26762ab9b$export$5aae31392d72caaa);
$parcel$export(module.exports, "Yellow200", () => $655e88a26762ab9b$export$fc857b6f8771648a);
$parcel$export(module.exports, "Y400", () => $655e88a26762ab9b$export$59619663aa6500fb);
$parcel$export(module.exports, "G50", () => $655e88a26762ab9b$export$8a6341c32b6a3ee6);
$parcel$export(module.exports, "G75", () => $655e88a26762ab9b$export$69a3bf21b9686c2b);
$parcel$export(module.exports, "G200", () => $655e88a26762ab9b$export$747d86715d4175de);
$parcel$export(module.exports, "G300", () => $655e88a26762ab9b$export$940e1f69e873f202);
$parcel$export(module.exports, "G500", () => $655e88a26762ab9b$export$6fa04827ac68a4fb);
$parcel$export(module.exports, "B50", () => $655e88a26762ab9b$export$226de0355ed012f8);
$parcel$export(module.exports, "B75", () => $655e88a26762ab9b$export$8c13c2ee36917869);
$parcel$export(module.exports, "B100", () => $655e88a26762ab9b$export$ecfc1dff386a3e7a);
$parcel$export(module.exports, "B400", () => $655e88a26762ab9b$export$b3de0ae08da2ce64);
$parcel$export(module.exports, "B500", () => $655e88a26762ab9b$export$a6ee3d71bc067634);
$parcel$export(module.exports, "L200", () => $655e88a26762ab9b$export$f72948ef771f6f15);
$parcel$export(module.exports, "N0", () => $655e88a26762ab9b$export$29a4f05edc054374);
$parcel$export(module.exports, "N20", () => $655e88a26762ab9b$export$9fdfb749e33cdf97);
$parcel$export(module.exports, "N30", () => $655e88a26762ab9b$export$3e51e8f1440314ba);
$parcel$export(module.exports, "N60", () => $655e88a26762ab9b$export$c2e91cbeada39b8b);
$parcel$export(module.exports, "N80", () => $655e88a26762ab9b$export$eaa8c8a70ac22806);
$parcel$export(module.exports, "Neutral300", () => $655e88a26762ab9b$export$1ae1cebe22dcedb4);
$parcel$export(module.exports, "N300A", () => $655e88a26762ab9b$export$13609db0e6812ab8);
$parcel$export(module.exports, "N600", () => $655e88a26762ab9b$export$7090862dc3038a9f);
$parcel$export(module.exports, "N800", () => $655e88a26762ab9b$export$7d61b15e0da132af);
$parcel$export(module.exports, "N1000", () => $655e88a26762ab9b$export$f78789c8b01753cd);
$parcel$export(module.exports, "M200", () => $655e88a26762ab9b$export$a19f0c33186f7767);
$parcel$export(module.exports, "O200", () => $655e88a26762ab9b$export$51716a84e62e022c);
$parcel$export(module.exports, "P50", () => $655e88a26762ab9b$export$363e4475840015bb);
$parcel$export(module.exports, "P75", () => $655e88a26762ab9b$export$4b0a4417ed59760f);
$parcel$export(module.exports, "P100", () => $655e88a26762ab9b$export$6011520a64d9a187);
$parcel$export(module.exports, "P200", () => $655e88a26762ab9b$export$a7175d4e9206bc80);
$parcel$export(module.exports, "P300", () => $655e88a26762ab9b$export$b48405b95304b5a1);
$parcel$export(module.exports, "P500", () => $655e88a26762ab9b$export$147899de772240ec);
$parcel$export(module.exports, "T50", () => $655e88a26762ab9b$export$2cf711fe14c66f06);
$parcel$export(module.exports, "T75", () => $655e88a26762ab9b$export$7a8f4d33f6f9772c);
$parcel$export(module.exports, "T100", () => $655e88a26762ab9b$export$776c9c497ef08533);
$parcel$export(module.exports, "T200", () => $655e88a26762ab9b$export$69cb3ca10c1e330e);
$parcel$export(module.exports, "T300", () => $655e88a26762ab9b$export$9dc1ef0f3f48059b);
$parcel$export(module.exports, "T500", () => $655e88a26762ab9b$export$6036577f95c3877e);
$parcel$export(module.exports, "isHex", () => $655e88a26762ab9b$export$8a9b6341a7c96bc);
$parcel$export(module.exports, "isRgb", () => $655e88a26762ab9b$export$e698776ec826343);
$parcel$export(module.exports, "rgbToHex", () => $655e88a26762ab9b$export$34d09c4a771c46ef);
$parcel$export(module.exports, "hexToRgba", () => $655e88a26762ab9b$export$9665a07d9187b414);

var $iYJcE = parcelRequire("iYJcE");

var $gMcRf = parcelRequire("gMcRf");
var $655e88a26762ab9b$export$4b84fd0e2c617bd = '#FFEBE6';
var $655e88a26762ab9b$export$b34b069eff244586 = '#FFBDAD';
var $655e88a26762ab9b$export$be802dd0d8b57f35 = '#FF8F73';
var $655e88a26762ab9b$export$4a7404f376229999 = '#FF5630';
var $655e88a26762ab9b$export$2010d0fb4295b346 = '#DE350B';
var $655e88a26762ab9b$export$2837b5a1a71d5c02 = '#BF2600';
var $655e88a26762ab9b$export$8d9596b529bbb9cf = '#FFFAE6';
var $655e88a26762ab9b$export$41060a744ab0b7ae = '#FFF0B3';
var $655e88a26762ab9b$export$5aae31392d72caaa = '#FFC400';
var $655e88a26762ab9b$export$fc857b6f8771648a = '#F8E6A0';
var $655e88a26762ab9b$export$59619663aa6500fb = '#FF991F';
var $655e88a26762ab9b$export$874739ea9e379ab6 = '#FF8B00';
var $655e88a26762ab9b$export$8a6341c32b6a3ee6 = '#E3FCEF';
var $655e88a26762ab9b$export$69a3bf21b9686c2b = '#ABF5D1';
var $655e88a26762ab9b$export$747d86715d4175de = '#57D9A3';
var $655e88a26762ab9b$export$940e1f69e873f202 = '#36B37E';
var $655e88a26762ab9b$export$a49394138f7b8e85 = '#00875A';
var $655e88a26762ab9b$export$6fa04827ac68a4fb = '#006644';
var $655e88a26762ab9b$export$226de0355ed012f8 = '#DEEBFF';
var $655e88a26762ab9b$export$8c13c2ee36917869 = '#B3D4FF';
var $655e88a26762ab9b$export$ecfc1dff386a3e7a = '#4C9AFF';
var $655e88a26762ab9b$export$b3de0ae08da2ce64 = '#0052CC';
var $655e88a26762ab9b$export$a6ee3d71bc067634 = '#0747A6';
var $655e88a26762ab9b$export$f72948ef771f6f15 = '#D3F1A7';
var $655e88a26762ab9b$export$29a4f05edc054374 = '#FFFFFF';
var $655e88a26762ab9b$export$9fdfb749e33cdf97 = '#F4F5F7';
var $655e88a26762ab9b$export$3e51e8f1440314ba = '#EBECF0';
var $655e88a26762ab9b$export$1ce2d1575d444ceb = '#DFE1E6';
var $655e88a26762ab9b$export$8754fc7e6d8b3000 = '#C1C7D0';
var $655e88a26762ab9b$export$c2e91cbeada39b8b = '#B3BAC5';
var $655e88a26762ab9b$export$eaa8c8a70ac22806 = '#97A0AF';
var $655e88a26762ab9b$export$7c87d337fb91a97d = '#8993A4';
var $655e88a26762ab9b$export$f563ee71e9ee74cd = '#6B778C';
var $655e88a26762ab9b$export$e2ef2124cf4024b1 = '#5E6C84';
var $655e88a26762ab9b$export$1ae1cebe22dcedb4 = '#DCDFE4';
var $655e88a26762ab9b$export$13609db0e6812ab8 = '#091E4224';
var $655e88a26762ab9b$export$c39c0fe0f26207ae = '#42526E';
var $655e88a26762ab9b$export$7090862dc3038a9f = '#758195';
var $655e88a26762ab9b$export$7d61b15e0da132af = '#172B4D';
var $655e88a26762ab9b$export$f78789c8b01753cd = '#172B4D';
var $655e88a26762ab9b$export$a19f0c33186f7767 = '#FDD0EC';
var $655e88a26762ab9b$export$51716a84e62e022c = '#FEDEC8';
var $655e88a26762ab9b$export$363e4475840015bb = '#EAE6FF';
var $655e88a26762ab9b$export$4b0a4417ed59760f = '#C0B6F2';
var $655e88a26762ab9b$export$6011520a64d9a187 = '#998DD9';
var $655e88a26762ab9b$export$a7175d4e9206bc80 = '#DFD8FD';
var $655e88a26762ab9b$export$b48405b95304b5a1 = '#6554C0';
var $655e88a26762ab9b$export$c71e4279dd54a18d = '#5243AA';
var $655e88a26762ab9b$export$147899de772240ec = '#403294';
var $655e88a26762ab9b$export$2cf711fe14c66f06 = '#E6FCFF';
var $655e88a26762ab9b$export$7a8f4d33f6f9772c = '#B3F5FF';
var $655e88a26762ab9b$export$776c9c497ef08533 = '#79E2F2';
var $655e88a26762ab9b$export$69cb3ca10c1e330e = '#C6EDFB';
var $655e88a26762ab9b$export$9dc1ef0f3f48059b = '#00B8D9';
var $655e88a26762ab9b$export$6036577f95c3877e = '#008DA6';
function $655e88a26762ab9b$export$b61655071712e690(color, defaultColor) {
    if (!color) return null;
    // Normalize to hex
    color = color.trim().toLowerCase();
    if ($655e88a26762ab9b$export$8a9b6341a7c96bc(color)) // Normalize 3-hex to 6-hex colours
    {
        if (color.length === 4) color = color.split('').map(function(c) {
            return c === '#' ? '#' : "".concat(c).concat(c);
        }).join('');
    } else if ($655e88a26762ab9b$export$e698776ec826343(color)) return $655e88a26762ab9b$export$34d09c4a771c46ef(color);
    else {
        // http://dev.w3.org/csswg/css-color/#named-colors
        if (color === 'default') return null;
        else if (// eslint-disable-next-line @typescript-eslint/no-explicit-any
        $gMcRf.default && // eslint-disable-next-line @typescript-eslint/no-explicit-any
        $gMcRf.default[color]) // eslint-disable-next-line @typescript-eslint/no-explicit-any
        color = $gMcRf.default[color];
        else if ($gMcRf && $gMcRf[color]) // eslint-disable-next-line @typescript-eslint/no-explicit-any
        color = $gMcRf[color];
        else return null;
    }
    if (color === defaultColor) return null;
    return color;
}
function $655e88a26762ab9b$export$5a544e13ad4e1fa5(color) {
    if (!$655e88a26762ab9b$export$8a9b6341a7c96bc(color)) return null;
    var colorBits = color.substring(1).split('');
    if (colorBits.length === 3) colorBits = [
        colorBits[0],
        colorBits[0],
        colorBits[1],
        colorBits[1],
        colorBits[2],
        colorBits[2]
    ];
    var rgb = Number("0x".concat(colorBits.join('')));
    return "rgb(".concat(rgb >> 16 & 255, ",").concat(rgb >> 8 & 255, ",").concat(rgb & 255, ")");
}
function $655e88a26762ab9b$export$9665a07d9187b414(rawColor, alpha) {
    var color = $655e88a26762ab9b$export$b61655071712e690(rawColor);
    if (!color) return null;
    var hex2rgb = function hex2rgb(color) {
        // @ts-ignore TS1501: This regular expression flag is only available when targeting 'es6' or later.
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        return color.match(/[0-9a-z\u017F\u212A]{2}/gi).map(function(hex) {
            return parseInt(hex, 16);
        });
    };
    return "rgba(".concat(hex2rgb(color).concat(alpha).join(','), ")");
}
function $655e88a26762ab9b$export$34d09c4a771c46ef(value) {
    // @ts-ignore TS1501: This regular expression flag is only available when targeting 'es6' or later.
    var matches = value.match(/(0?\.?[0-9]{1,3})%?\b/g);
    if (matches && matches.length >= 3) {
        var _matches$map = matches.map(Number), _matches$map2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_matches$map, 3), red = _matches$map2[0], green = _matches$map2[1], blue = _matches$map2[2];
        return '#' + (blue | green << 8 | red << 16 | 16777216).toString(16).slice(1);
    }
    return null;
}
function $655e88a26762ab9b$export$e698776ec826343(color) {
    // @ts-ignore TS1501: This regular expression flag is only available when targeting 'es6' or later.
    return /rgba?\(/.test(color);
}
function $655e88a26762ab9b$export$8a9b6341a7c96bc(color) {
    // @ts-ignore TS1501: This regular expression flag is only available when targeting 'es6' or later.
    return /^#([0-9A-Fa-f]{3}){1,2}$/.test(color);
}

});

parcelRegister("l56lt", function(module, exports) {
$parcel$export(module.exports, "generateUuid", () => $f58efca43d2bd66c$export$1c3aefb711c3a4cc);
$parcel$export(module.exports, "uuid", () => $f58efca43d2bd66c$export$31b40729666a4ae0);
var $f58efca43d2bd66c$export$1c3aefb711c3a4cc = function generateUuid() {
    return(// @ts-ignore TS1501: This regular expression flag is only available when targeting 'es6' or later.
    'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
        var r = Math.random() * 16 | 0;
        return (c === 'x' ? r : r & 0x3 | 0x8).toString(16);
    }));
};
var $f58efca43d2bd66c$var$staticValue = false;
var $f58efca43d2bd66c$export$31b40729666a4ae0 = {
    setStatic: function setStatic(value) {
        $f58efca43d2bd66c$var$staticValue = value;
    },
    generate: function generate() {
        return $f58efca43d2bd66c$var$staticValue || $f58efca43d2bd66c$export$1c3aefb711c3a4cc();
    }
};

});

parcelRegister("dGnui", function(module, exports) {
$parcel$export(module.exports, "getDarkModeLCHColor", () => $9f616ac737c730f8$export$a5065c3b8aacaf99);
// https://en.wikipedia.org/wiki/HCL_color_space
// https://en.wikipedia.org/wiki/CIE_1931_color_space#CIE_xy_chromaticity_diagram_and_the_CIE_xyY_color_space
// https://en.wikipedia.org/wiki/CIELAB_color_space
var $9f616ac737c730f8$var$clamp = function clamp(i, min, max) {
    return Math.round(Math.min(Math.max(i, min), max));
};
var $9f616ac737c730f8$var$expandShorthandHex = function expandShorthandHex(input) {
    return(// @ts-ignore TS1501: This regular expression flag is only available when targeting 'es6' or later.
    input.replace(/^#?([0-9a-f])([0-9a-f])([0-9a-f])$/i, function(m, r, g, b) {
        return r + r + g + g + b + b;
    }));
};
var $9f616ac737c730f8$var$rgbFromHex = function rgbFromHex(input) {
    var fullHex = $9f616ac737c730f8$var$expandShorthandHex(input);
    // @ts-ignore TS1501: This regular expression flag is only available when targeting 'es6' or later.
    var result = /^#?([0-9a-f]{2})([0-9a-f]{2})([0-9a-f]{2})$/i.exec(fullHex);
    return result === null ? null : {
        r: parseInt(result[1], 16),
        g: parseInt(result[2], 16),
        b: parseInt(result[3], 16)
    };
};
var $9f616ac737c730f8$var$rgbToHex = function rgbToHex(_ref) {
    var r = _ref.r, g = _ref.g, b = _ref.b;
    var convertComponent = function convertComponent(c) {
        var cBase16 = c.toString(16);
        return cBase16.length === 1 ? "0".concat(cBase16) : cBase16;
    };
    return "#".concat(convertComponent(r)).concat(convertComponent(g)).concat(convertComponent(b));
};
var $9f616ac737c730f8$var$rgbToXyz = function rgbToXyz(rgb) {
    var convertRgbComponent = function convertRgbComponent(c) {
        return c > 0.04045 ? Math.pow((c + 0.055) / 1.055, 2.4) : c / 12.92;
    };
    var convertXyzComponent = function convertXyzComponent(c) {
        return c > 0.008856452 ? Math.pow(c, 1 / 3) : c / 0.12841855 + 0.137931034;
    };
    var r = convertRgbComponent(rgb.r / 255);
    var g = convertRgbComponent(rgb.g / 255);
    var b = convertRgbComponent(rgb.b / 255);
    return {
        x: convertXyzComponent((0.4124564 * r + 0.3575761 * g + 0.1804375 * b) / 0.95047),
        y: convertXyzComponent(0.2126729 * r + 0.7151522 * g + 0.072175 * b),
        z: convertXyzComponent((0.0193339 * r + 0.119192 * g + 0.9503041 * b) / 1.08883)
    };
};
var $9f616ac737c730f8$var$xyzToLab = function xyzToLab(_ref2) {
    var x = _ref2.x, y = _ref2.y, z = _ref2.z;
    return {
        l: Math.max(116 * y - 16, 0),
        a: 500 * (x - y),
        b: 200 * (y - z)
    };
};
var $9f616ac737c730f8$var$labToLch = function labToLch(_ref3) {
    var l = _ref3.l, a = _ref3.a, b = _ref3.b;
    var h = (Math.atan2(b, a) * (180 / Math.PI) + 360) % 360;
    var c = Math.sqrt(Math.pow(a, 2) + Math.pow(b, 2));
    if (Math.round(c * 10000) === 0) h = Number.NaN;
    return {
        l: l,
        c: c,
        h: h
    };
};
var $9f616ac737c730f8$var$lchToLab = function lchToLab(_ref4) {
    var l = _ref4.l, c = _ref4.c, h = _ref4.h;
    var convertH = Number.isNaN(h) ? 0 : h * (Math.PI / 180);
    return {
        l: l,
        a: Math.cos(convertH) * c,
        b: Math.sin(convertH) * c
    };
};
var $9f616ac737c730f8$var$labToXyz = function labToXyz(_ref5) {
    var l = _ref5.l, a = _ref5.a, b = _ref5.b;
    var convertComponent = function convertComponent(c) {
        return c > 0.206896552 ? Math.pow(c, 3) : 0.12841855 * (c - 0.137931034);
    };
    var y = (l + 16) / 116;
    var x = a / 500 + y;
    var z = y - b / 200;
    return {
        x: convertComponent(x) * 0.95047,
        y: convertComponent(y),
        z: convertComponent(z) * 1.08883
    };
};
var $9f616ac737c730f8$var$xyzToRgb = function xyzToRgb(_ref6) {
    var x = _ref6.x, y = _ref6.y, z = _ref6.z;
    var convertComponent = function convertComponent(c) {
        return 255 * (c <= 0.00304 ? 12.92 * c : 1.055 * Math.pow(c, 1 / 2.4) - 0.055);
    };
    return {
        r: $9f616ac737c730f8$var$clamp(convertComponent(3.2404542 * x - 1.5371385 * y - 0.4985314 * z), 0, 255),
        g: $9f616ac737c730f8$var$clamp(convertComponent(-0.969266 * x + 1.8760108 * y + 0.041556 * z), 0, 255),
        b: $9f616ac737c730f8$var$clamp(convertComponent(0.0556434 * x - 0.2040259 * y + 1.0572252 * z), 0, 255)
    };
};
var $9f616ac737c730f8$var$rgbToLch = function rgbToLch(rgb) {
    return $9f616ac737c730f8$var$labToLch($9f616ac737c730f8$var$xyzToLab($9f616ac737c730f8$var$rgbToXyz(rgb)));
};
var $9f616ac737c730f8$var$lchToRgb = function lchToRgb(lch) {
    return $9f616ac737c730f8$var$xyzToRgb($9f616ac737c730f8$var$labToXyz($9f616ac737c730f8$var$lchToLab(lch)));
};
var $9f616ac737c730f8$export$313b8a8fcb34c3b8 = function clampLightness(color, newPercent) {
    var rgb = $9f616ac737c730f8$var$rgbFromHex(color);
    if (rgb === null) return color;
    // LCH (rather than HSL) gives the best results here as the L component in LCH is based on human color perception
    var lch = $9f616ac737c730f8$var$rgbToLch(rgb);
    lch.l = $9f616ac737c730f8$var$clamp(newPercent, 0, 100);
    return $9f616ac737c730f8$var$rgbToHex($9f616ac737c730f8$var$lchToRgb(lch));
};
var $9f616ac737c730f8$var$getLightness = function getLightness(color) {
    var rgb = $9f616ac737c730f8$var$rgbFromHex(color);
    if (rgb === null) return 0;
    var lch = $9f616ac737c730f8$var$rgbToLch(rgb);
    return lch.l;
};
var $9f616ac737c730f8$export$a5065c3b8aacaf99 = function getDarkModeLCHColor(currentBackgroundColor) {
    var lightness = $9f616ac737c730f8$var$getLightness(currentBackgroundColor);
    var newLightness = Math.abs(100 - lightness);
    return $9f616ac737c730f8$export$313b8a8fcb34c3b8(currentBackgroundColor, newLightness).toUpperCase();
};

});

parcelRegister("hibjE", function(module, exports) {
$parcel$export(module.exports, "blockCard", () => $c96ce53c15e04104$export$c4c2f833baaebdb8);
$parcel$export(module.exports, "blockquote", () => $c96ce53c15e04104$export$67dc04e652a298ca);
$parcel$export(module.exports, "blockquoteLegacy", () => $c96ce53c15e04104$export$199922e5af8e9a6);
$parcel$export(module.exports, "blockTaskItem", () => $c96ce53c15e04104$export$16018c61064a18df);
$parcel$export(module.exports, "bodiedExtension", () => $c96ce53c15e04104$export$27903d543b563e39);
$parcel$export(module.exports, "bodiedSyncBlock", () => $c96ce53c15e04104$export$e92c7e4302dd4371);
$parcel$export(module.exports, "bulletList", () => $c96ce53c15e04104$export$a140c94e5ea26bee);
$parcel$export(module.exports, "caption", () => $c96ce53c15e04104$export$8e3c2dfdc4f0453d);
$parcel$export(module.exports, "codeBlock", () => $c96ce53c15e04104$export$7bb0d5c671655cc4);
$parcel$export(module.exports, "confluenceJiraIssue", () => $c96ce53c15e04104$export$daf889beb5092f95);
$parcel$export(module.exports, "confluenceUnsupportedBlock", () => $c96ce53c15e04104$export$e6e4878f43c27cab);
$parcel$export(module.exports, "confluenceUnsupportedInline", () => $c96ce53c15e04104$export$3e6d667072febc87);
$parcel$export(module.exports, "date", () => $c96ce53c15e04104$export$324d90190a8b822a);
$parcel$export(module.exports, "decisionItem", () => $c96ce53c15e04104$export$6959e16eeff859b4);
$parcel$export(module.exports, "decisionList", () => $c96ce53c15e04104$export$62d45a65fb43d95e);
$parcel$export(module.exports, "doc", () => $c96ce53c15e04104$export$2a111da947c407d2);
$parcel$export(module.exports, "embedCard", () => $c96ce53c15e04104$export$be4283d9a1cb1ff6);
$parcel$export(module.exports, "emoji", () => $c96ce53c15e04104$export$a19185d1233fc4b2);
$parcel$export(module.exports, "expand", () => $c96ce53c15e04104$export$9f77e0932fb78f72);
$parcel$export(module.exports, "extension", () => $c96ce53c15e04104$export$1b45514b112dd749);
$parcel$export(module.exports, "extensionFrameStage0", () => $c96ce53c15e04104$export$b555be60c7703afb);
$parcel$export(module.exports, "hardBreak", () => $c96ce53c15e04104$export$371da9dd35aba193);
$parcel$export(module.exports, "heading", () => $c96ce53c15e04104$export$46e4a324ac90507f);
$parcel$export(module.exports, "image", () => $c96ce53c15e04104$export$5c452ff88e35e47d);
$parcel$export(module.exports, "inlineCard", () => $c96ce53c15e04104$export$cbf8224b64e0d942);
$parcel$export(module.exports, "inlineExtensionWithMarks", () => $c96ce53c15e04104$export$b3b1e36c2105006d);
$parcel$export(module.exports, "layoutColumn", () => $c96ce53c15e04104$export$ab76e7c03cd6f650);
$parcel$export(module.exports, "layoutSection", () => $c96ce53c15e04104$export$b3b6a70a7fa4a5be);
$parcel$export(module.exports, "layoutSectionFull", () => $c96ce53c15e04104$export$cdae19acb0a520fd);
$parcel$export(module.exports, "layoutSectionWithSingleColumnStage0", () => $c96ce53c15e04104$export$206007566ca0aca5);
$parcel$export(module.exports, "listItem", () => $c96ce53c15e04104$export$76c7e83ecc9cdf05);
$parcel$export(module.exports, "listItemWithFlexibleFirstChildStage0", () => $c96ce53c15e04104$export$fcbecfed570fc881);
$parcel$export(module.exports, "media", () => $c96ce53c15e04104$export$987d49ffe1b0900f);
$parcel$export(module.exports, "mediaGroup", () => $c96ce53c15e04104$export$2855e964765eac9);
$parcel$export(module.exports, "mediaInline", () => $c96ce53c15e04104$export$38bab695e3f720f1);
$parcel$export(module.exports, "mediaSingle", () => $c96ce53c15e04104$export$969fe3781ca15058);
$parcel$export(module.exports, "mediaSingleCaption", () => $c96ce53c15e04104$export$8d067f22dc2d1254);
$parcel$export(module.exports, "mediaSingleFull", () => $c96ce53c15e04104$export$7e767666f2ce108a);
$parcel$export(module.exports, "mediaSingleWidthType", () => $c96ce53c15e04104$export$4bd9a38995f6bf50);
$parcel$export(module.exports, "mention", () => $c96ce53c15e04104$export$db83999c14438df4);
$parcel$export(module.exports, "multiBodiedExtensionStage0", () => $c96ce53c15e04104$export$750e45819f66d9d0);
$parcel$export(module.exports, "nestedExpand", () => $c96ce53c15e04104$export$63cadbf5f4296627);
$parcel$export(module.exports, "orderedList", () => $c96ce53c15e04104$export$a5dc81035676e7a);
$parcel$export(module.exports, "panel", () => $c96ce53c15e04104$export$21f42ab9b6679f44);
$parcel$export(module.exports, "paragraph", () => $c96ce53c15e04104$export$9c206ddddb32a9b);
$parcel$export(module.exports, "placeholder", () => $c96ce53c15e04104$export$c7187bbd1a7a9244);
$parcel$export(module.exports, "rule", () => $c96ce53c15e04104$export$fbeb3a3956e8a3c7);
$parcel$export(module.exports, "status", () => $c96ce53c15e04104$export$471f7ae5c4103ae1);
$parcel$export(module.exports, "syncBlock", () => $c96ce53c15e04104$export$faab0ca9701d7048);
$parcel$export(module.exports, "table", () => $c96ce53c15e04104$export$9852986a3ec5f6a0);
$parcel$export(module.exports, "tableWithNestedTable", () => $c96ce53c15e04104$export$ce086a560a1d05f5);
$parcel$export(module.exports, "tableCell", () => $c96ce53c15e04104$export$e1e720e5f4603e6a);
$parcel$export(module.exports, "tableCellWithNestedTable", () => $c96ce53c15e04104$export$abf39ca178940ff3);
$parcel$export(module.exports, "tableHeader", () => $c96ce53c15e04104$export$48884d2a5190dc73);
$parcel$export(module.exports, "tableHeaderWithNestedTable", () => $c96ce53c15e04104$export$2a5a518232fa1a97);
$parcel$export(module.exports, "tableRow", () => $c96ce53c15e04104$export$ce666bf02318c957);
$parcel$export(module.exports, "tableRowWithNestedTable", () => $c96ce53c15e04104$export$7d657479499397);
$parcel$export(module.exports, "taskItem", () => $c96ce53c15e04104$export$6d8b0ef52e2e6390);
$parcel$export(module.exports, "taskList", () => $c96ce53c15e04104$export$375b6afcc5f4d291);
$parcel$export(module.exports, "taskListWithFlexibleFirstChildStage0", () => $c96ce53c15e04104$export$3c86306d85ad1f18);
$parcel$export(module.exports, "text", () => $c96ce53c15e04104$export$6f093cfa640b7166);
$parcel$export(module.exports, "unsupportedBlock", () => $c96ce53c15e04104$export$44b79b0979d0f0f7);
$parcel$export(module.exports, "unsupportedInline", () => $c96ce53c15e04104$export$310ebe0d80122e9b);
/**
 * This file was automatically generated by @atlaskit/adf-schema-generator
 * DO NOT MODIFY IT BY HAND. Instead, modify the source files in "packages/adf-schema/src/next-schema" ,
 * and run "yarn workspace @atlaskit/adf-schema build:schema:all" to regenerate this file.
 */ 
var $cDw0B = parcelRequire("cDw0B");
var $c96ce53c15e04104$export$c4c2f833baaebdb8 = (0, $cDw0B.createPMNodeSpecFactory)({
    group: 'block',
    attrs: {
        localId: {
            default: null
        },
        url: {
            default: null
        },
        datasource: {
            default: null
        },
        width: {
            default: null
        },
        layout: {
            default: null
        },
        data: {
            default: null
        }
    },
    selectable: true,
    draggable: true
});
var $c96ce53c15e04104$export$67dc04e652a298ca = (0, $cDw0B.createPMNodeSpecFactory)({
    content: '(paragraph | orderedList | bulletList | unsupportedBlock | codeBlock | mediaSingle | mediaGroup | extension)+',
    marks: 'unsupportedMark unsupportedNodeAttribute dataConsumer fragment',
    group: 'block',
    attrs: {
        localId: {
            default: null
        }
    },
    selectable: true,
    defining: true
});
var $c96ce53c15e04104$export$199922e5af8e9a6 = (0, $cDw0B.createPMNodeSpecFactory)({
    content: '(paragraph | unsupportedBlock)+',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    attrs: {
        localId: {
            default: null
        }
    },
    selectable: true,
    defining: true
});
var $c96ce53c15e04104$export$16018c61064a18df = (0, $cDw0B.createPMNodeSpecFactory)({
    content: '(paragraph | extension) (paragraph | extension)*',
    marks: 'fontSize unsupportedMark unsupportedNodeAttribute dataConsumer fragment',
    attrs: {
        localId: {
            default: ''
        },
        state: {
            default: 'TODO'
        }
    },
    selectable: false,
    defining: true
});
var $c96ce53c15e04104$export$27903d543b563e39 = (0, $cDw0B.createPMNodeSpecFactory)({
    content: '(paragraph | panel | blockquote | orderedList | bulletList | rule | heading | codeBlock | mediaGroup | mediaSingle | decisionList | taskList | table | blockCard | embedCard | extension | unsupportedBlock)+',
    marks: 'dataConsumer fontSize fragment unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    attrs: {
        extensionKey: {
            default: ''
        },
        extensionType: {
            default: ''
        },
        parameters: {
            default: null
        },
        text: {
            default: null
        },
        layout: {
            default: 'default'
        },
        localId: {
            default: null
        }
    },
    selectable: true,
    defining: true,
    isolating: true
});
var $c96ce53c15e04104$export$e7320d153c538837 = (0, $cDw0B.createPMNodeSpecFactory)({
    marks: 'dataConsumer fontSize fragment unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    attrs: {
        extensionKey: {
            default: ''
        },
        extensionType: {
            default: ''
        },
        parameters: {
            default: null
        },
        text: {
            default: null
        },
        layout: {
            default: 'default'
        },
        localId: {
            default: null
        }
    },
    selectable: true,
    defining: true,
    isolating: true
});
var $c96ce53c15e04104$export$e92c7e4302dd4371 = (0, $cDw0B.createPMNodeSpecFactory)({
    content: '(paragraph | blockCard | blockquote | bulletList | codeBlock | confluenceUnsupportedBlock | decisionList | embedCard | expand | heading | layoutSection | mediaGroup | mediaSingle | orderedList | panel | rule | table | taskList | unsupportedBlock)+',
    marks: 'unsupportedMark unsupportedNodeAttribute alignment indentation fontSize breakout link fragment',
    attrs: {
        resourceId: {
            default: ''
        },
        localId: {
            default: ''
        }
    },
    selectable: true,
    isolating: true
});
var $c96ce53c15e04104$export$a140c94e5ea26bee = (0, $cDw0B.createPMNodeSpecFactory)({
    content: 'listItem+',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    attrs: {
        localId: {
            default: null
        }
    },
    selectable: false
});
var $c96ce53c15e04104$export$8e3c2dfdc4f0453d = (0, $cDw0B.createPMNodeSpecFactory)({
    content: '(hardBreak | mention | emoji | date | placeholder | inlineCard | status | text | unsupportedInline)*',
    marks: '_',
    attrs: {
        localId: {
            default: null
        }
    },
    selectable: false,
    isolating: true
});
var $c96ce53c15e04104$export$7bb0d5c671655cc4 = (0, $cDw0B.createPMNodeSpecFactory)({
    content: '(text | unsupportedInline)*',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    attrs: {
        language: {
            default: null
        },
        uniqueId: {
            default: null
        },
        localId: {
            default: null
        }
    },
    code: true,
    defining: true
});
var $c96ce53c15e04104$export$e4f1c66d84049f8b = (0, $cDw0B.createPMNodeSpecFactory)({
    content: '(text | unsupportedInline)*',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    attrs: {
        language: {
            default: null
        },
        uniqueId: {
            default: null
        },
        localId: {
            default: null
        }
    },
    code: true,
    defining: true
});
var $c96ce53c15e04104$export$daf889beb5092f95 = (0, $cDw0B.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    atom: true,
    attrs: {
        issueKey: {
            default: ''
        },
        macroId: {
            default: null
        },
        schemaVersion: {
            default: null
        },
        server: {
            default: null
        },
        serverId: {
            default: null
        }
    }
});
var $c96ce53c15e04104$export$e6e4878f43c27cab = (0, $cDw0B.createPMNodeSpecFactory)({
    group: 'block',
    attrs: {
        cxhtml: {
            default: null
        }
    }
});
var $c96ce53c15e04104$export$3e6d667072febc87 = (0, $cDw0B.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    atom: true,
    attrs: {
        cxhtml: {
            default: null
        }
    }
});
var $c96ce53c15e04104$export$324d90190a8b822a = (0, $cDw0B.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        timestamp: {
            default: ''
        },
        localId: {
            default: null
        }
    },
    selectable: true
});
var $c96ce53c15e04104$export$47988d68fe575725 = (0, $cDw0B.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        timestamp: {
            default: ''
        },
        localId: {
            default: null
        }
    },
    selectable: true
});
var $c96ce53c15e04104$export$6959e16eeff859b4 = (0, $cDw0B.createPMNodeSpecFactory)({
    content: 'inline*',
    marks: '_',
    attrs: {
        localId: {
            default: ''
        },
        state: {
            default: 'DECIDED'
        }
    },
    defining: true
});
var $c96ce53c15e04104$export$62d45a65fb43d95e = (0, $cDw0B.createPMNodeSpecFactory)({
    content: '(decisionItem | unsupportedBlock)+',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    attrs: {
        localId: {
            default: ''
        }
    },
    selectable: false,
    defining: true
});
var $c96ce53c15e04104$export$2a111da947c407d2 = (0, $cDw0B.createPMNodeSpecFactory)({
    content: '(block | codeBlock | layoutSection | blockRootOnly | expand | syncBlock | bodiedSyncBlock)+',
    marks: 'unsupportedMark unsupportedNodeAttribute alignment indentation fontSize dataConsumer fragment breakout'
});
var $c96ce53c15e04104$export$be4283d9a1cb1ff6 = (0, $cDw0B.createPMNodeSpecFactory)({
    group: 'block',
    attrs: {
        url: {
            default: ''
        },
        layout: {
            default: 'center'
        },
        width: {
            default: 100
        },
        originalHeight: {
            default: null
        },
        originalWidth: {
            default: null
        },
        localId: {
            default: null
        }
    },
    selectable: true
});
var $c96ce53c15e04104$export$a19185d1233fc4b2 = (0, $cDw0B.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        shortName: {
            default: ''
        },
        id: {
            default: ''
        },
        text: {
            default: ''
        },
        localId: {
            default: null
        }
    },
    selectable: true
});
var $c96ce53c15e04104$export$f5574b5d45fc2112 = (0, $cDw0B.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        shortName: {
            default: ''
        },
        id: {
            default: ''
        },
        text: {
            default: ''
        },
        localId: {
            default: null
        }
    },
    selectable: true
});
var $c96ce53c15e04104$export$9f77e0932fb78f72 = (0, $cDw0B.createPMNodeSpecFactory)({
    content: '(paragraph | panel | blockquote | orderedList | bulletList | rule | heading | codeBlock | mediaGroup | mediaSingle | decisionList | taskList | table | blockCard | embedCard | extension | unsupportedBlock | nestedExpand)+',
    marks: 'fontSize unsupportedMark unsupportedNodeAttribute fragment dataConsumer',
    group: 'block',
    attrs: {
        title: {
            default: ''
        },
        __expanded: {
            default: true
        },
        localId: {
            default: null
        }
    },
    selectable: true,
    isolating: true
});
var $c96ce53c15e04104$export$7e3788972005cc72 = (0, $cDw0B.createPMNodeSpecFactory)({
    content: '(paragraph | panel | blockquote | orderedList | bulletList | rule | heading | codeBlock | mediaGroup | mediaSingle | decisionList | taskList | table | blockCard | embedCard | extension | unsupportedBlock | nestedExpand)+',
    marks: 'fontSize unsupportedMark unsupportedNodeAttribute fragment dataConsumer',
    attrs: {
        title: {
            default: ''
        },
        __expanded: {
            default: true
        },
        localId: {
            default: null
        }
    },
    selectable: true,
    isolating: true
});
var $c96ce53c15e04104$export$1b45514b112dd749 = (0, $cDw0B.createPMNodeSpecFactory)({
    group: 'block',
    atom: true,
    attrs: {
        extensionKey: {
            default: ''
        },
        extensionType: {
            default: ''
        },
        parameters: {
            default: null
        },
        text: {
            default: null
        },
        layout: {
            default: 'default'
        },
        localId: {
            default: null
        }
    },
    selectable: true
});
var $c96ce53c15e04104$export$a8baf338431a691 = (0, $cDw0B.createPMNodeSpecFactory)({
    group: 'block',
    atom: true,
    attrs: {
        extensionKey: {
            default: ''
        },
        extensionType: {
            default: ''
        },
        parameters: {
            default: null
        },
        text: {
            default: null
        },
        layout: {
            default: 'default'
        },
        localId: {
            default: null
        }
    },
    selectable: true
});
var $c96ce53c15e04104$export$b555be60c7703afb = (0, $cDw0B.createPMNodeSpecFactory)({
    content: '(paragraph | panel | blockquote | orderedList | bulletList | rule | heading | codeBlock | mediaGroup | mediaSingle | decisionList | taskList | table | extension | bodiedExtension | unsupportedBlock | blockCard | embedCard)+',
    marks: 'dataConsumer fontSize fragment unsupportedMark unsupportedNodeAttribute',
    attrs: {},
    selectable: false,
    definingAsContext: false,
    definingForContent: true,
    isolating: true
});
var $c96ce53c15e04104$export$371da9dd35aba193 = (0, $cDw0B.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        text: {
            default: '\n'
        },
        localId: {
            default: null
        }
    },
    selectable: false,
    linebreakReplacement: true
});
var $c96ce53c15e04104$export$46e4a324ac90507f = (0, $cDw0B.createPMNodeSpecFactory)({
    content: 'inline*',
    marks: 'link em strong strike subsup underline textColor annotation backgroundColor typeAheadQuery confluenceInlineComment unsupportedNodeAttribute unsupportedMark code dataConsumer fragment border',
    group: 'block',
    attrs: {
        level: {
            default: 1
        },
        localId: {
            default: null
        }
    },
    selectable: false,
    defining: true
});
var $c96ce53c15e04104$export$1b0c1557b234fa00 = (0, $cDw0B.createPMNodeSpecFactory)({
    group: 'block',
    attrs: {
        level: {
            default: 1
        },
        localId: {
            default: null
        }
    },
    selectable: false,
    defining: true
});
var $c96ce53c15e04104$export$85461f751c457cc2 = (0, $cDw0B.createPMNodeSpecFactory)({
    group: 'block',
    attrs: {
        level: {
            default: 1
        },
        localId: {
            default: null
        }
    },
    selectable: false,
    defining: true
});
var $c96ce53c15e04104$export$2b380a0f7e250af1 = (0, $cDw0B.createPMNodeSpecFactory)({
    group: 'block',
    attrs: {
        level: {
            default: 1
        },
        localId: {
            default: null
        }
    },
    selectable: false,
    defining: true
});
var $c96ce53c15e04104$export$5c452ff88e35e47d = (0, $cDw0B.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        src: {
            default: ''
        },
        alt: {
            default: ''
        },
        title: {
            default: null
        }
    },
    draggable: true
});
var $c96ce53c15e04104$export$cbf8224b64e0d942 = (0, $cDw0B.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        url: {
            default: null
        },
        localId: {
            default: null
        },
        data: {
            default: null
        }
    },
    selectable: true,
    draggable: true
});
var $c96ce53c15e04104$export$2f4e72b9459914ad = (0, $cDw0B.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        url: {
            default: null
        },
        localId: {
            default: null
        },
        data: {
            default: null
        }
    },
    selectable: true,
    draggable: true
});
var $c96ce53c15e04104$export$16b353b2649bd8d9 = (0, $cDw0B.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        extensionKey: {
            default: ''
        },
        extensionType: {
            default: ''
        },
        parameters: {
            default: null
        },
        text: {
            default: null
        },
        localId: {
            default: null
        }
    },
    selectable: true
});
var $c96ce53c15e04104$export$b3b1e36c2105006d = (0, $cDw0B.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        extensionKey: {
            default: ''
        },
        extensionType: {
            default: ''
        },
        parameters: {
            default: null
        },
        text: {
            default: null
        },
        localId: {
            default: null
        }
    },
    selectable: true
});
var $c96ce53c15e04104$export$ab76e7c03cd6f650 = (0, $cDw0B.createPMNodeSpecFactory)({
    content: '(block | unsupportedBlock)+',
    marks: 'unsupportedMark unsupportedNodeAttribute alignment indentation fontSize dataConsumer fragment',
    attrs: {
        width: {
            default: undefined
        },
        localId: {
            default: null
        }
    },
    selectable: false,
    isolating: true
});
var $c96ce53c15e04104$export$b3b6a70a7fa4a5be = (0, $cDw0B.createPMNodeSpecFactory)({
    content: '(layoutColumn | unsupportedBlock){1,3} unsupportedBlock*',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    attrs: {
        localId: {
            default: null
        }
    },
    isolating: true
});
var $c96ce53c15e04104$export$cdae19acb0a520fd = (0, $cDw0B.createPMNodeSpecFactory)({
    content: '(layoutColumn | unsupportedBlock){2,3}',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    attrs: {
        localId: {
            default: null
        }
    },
    isolating: true
});
var $c96ce53c15e04104$export$206007566ca0aca5 = (0, $cDw0B.createPMNodeSpecFactory)({
    content: '(layoutColumn | unsupportedBlock){1,5} unsupportedBlock*',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    attrs: {
        columnRuleStyle: {
            default: null
        },
        localId: {
            default: null
        }
    },
    isolating: true
});
var $c96ce53c15e04104$export$76c7e83ecc9cdf05 = (0, $cDw0B.createPMNodeSpecFactory)({
    content: '(paragraph | mediaSingle | codeBlock | unsupportedBlock | extension) (paragraph | bulletList | orderedList | taskList | mediaSingle | codeBlock | unsupportedBlock | extension)*',
    marks: 'fontSize unsupportedMark unsupportedNodeAttribute dataConsumer fragment',
    attrs: {
        localId: {
            default: null
        }
    },
    selectable: false,
    defining: true
});
var $c96ce53c15e04104$export$fcbecfed570fc881 = (0, $cDw0B.createPMNodeSpecFactory)({
    content: '(paragraph | bulletList | orderedList | taskList | mediaSingle | codeBlock | unsupportedBlock | extension)+',
    marks: 'fontSize unsupportedMark unsupportedNodeAttribute dataConsumer fragment',
    attrs: {
        localId: {
            default: null
        }
    },
    selectable: false,
    defining: true
});
var $c96ce53c15e04104$export$987d49ffe1b0900f = (0, $cDw0B.createPMNodeSpecFactory)({
    attrs: {
        type: {
            default: 'file'
        },
        localId: {
            default: null
        },
        id: {
            default: ''
        },
        alt: {
            default: ''
        },
        collection: {
            default: ''
        },
        height: {
            default: null
        },
        occurrenceKey: {
            default: null
        },
        width: {
            default: null
        },
        __contextId: {
            default: null
        },
        __displayType: {
            default: null
        },
        __external: {
            default: false
        },
        __fileMimeType: {
            default: null
        },
        __fileName: {
            default: null
        },
        __fileSize: {
            default: null
        },
        __mediaTraceId: {
            default: null
        },
        url: {
            default: null
        }
    },
    selectable: true
});
var $c96ce53c15e04104$export$2855e964765eac9 = (0, $cDw0B.createPMNodeSpecFactory)({
    content: '(media | unsupportedBlock)+',
    marks: 'dataConsumer link annotation border unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    attrs: {},
    selectable: false
});
var $c96ce53c15e04104$export$38bab695e3f720f1 = (0, $cDw0B.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        type: {
            default: 'file'
        },
        localId: {
            default: null
        },
        url: {
            default: null
        },
        id: {
            default: ''
        },
        alt: {
            default: ''
        },
        collection: {
            default: ''
        },
        occurrenceKey: {
            default: null
        },
        width: {
            default: null
        },
        height: {
            default: null
        },
        __fileName: {
            default: null
        },
        __fileSize: {
            default: null
        },
        __fileMimeType: {
            default: null
        },
        __displayType: {
            default: null
        },
        __contextId: {
            default: null
        },
        __mediaTraceId: {
            default: null
        },
        __external: {
            default: false
        }
    },
    selectable: true
});
var $c96ce53c15e04104$export$969fe3781ca15058 = (0, $cDw0B.createPMNodeSpecFactory)({
    group: 'block',
    atom: true,
    attrs: {
        layout: {
            default: 'center'
        },
        width: {
            default: null
        }
    },
    selectable: true,
    content: 'media|unsupportedBlock+|media unsupportedBlock+',
    marks: 'annotation border link unsupportedMark unsupportedNodeAttribute'
});
var $c96ce53c15e04104$export$8d067f22dc2d1254 = (0, $cDw0B.createPMNodeSpecFactory)({
    content: 'media|unsupportedBlock+|media (caption|unsupportedBlock) unsupportedBlock*',
    marks: 'dataConsumer link annotation border unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    atom: false,
    attrs: {
        layout: {
            default: 'center'
        },
        width: {
            default: null
        }
    },
    selectable: true
});
var $c96ce53c15e04104$export$7e767666f2ce108a = (0, $cDw0B.createPMNodeSpecFactory)({
    content: 'media|unsupportedBlock+|media (caption|unsupportedBlock) unsupportedBlock*',
    marks: 'dataConsumer link annotation border unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    atom: false,
    attrs: {
        localId: {
            default: null
        },
        width: {
            default: null
        },
        layout: {
            default: 'center'
        },
        widthType: {
            default: null
        }
    },
    selectable: true
});
var $c96ce53c15e04104$export$4bd9a38995f6bf50 = (0, $cDw0B.createPMNodeSpecFactory)({
    content: 'media|unsupportedBlock+|media unsupportedBlock+',
    marks: 'dataConsumer link annotation border unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    atom: true,
    attrs: {
        localId: {
            default: null
        },
        width: {
            default: null
        },
        layout: {
            default: 'center'
        },
        widthType: {
            default: null
        }
    },
    selectable: true
});
var $c96ce53c15e04104$export$db83999c14438df4 = (0, $cDw0B.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        id: {
            default: ''
        },
        localId: {
            default: null
        },
        text: {
            default: ''
        },
        accessLevel: {
            default: ''
        },
        userType: {
            default: null
        }
    },
    selectable: true
});
var $c96ce53c15e04104$export$46f790bd65f760d0 = (0, $cDw0B.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        id: {
            default: ''
        },
        localId: {
            default: null
        },
        text: {
            default: ''
        },
        accessLevel: {
            default: ''
        },
        userType: {
            default: null
        }
    },
    selectable: true
});
var $c96ce53c15e04104$export$750e45819f66d9d0 = (0, $cDw0B.createPMNodeSpecFactory)({
    content: 'extensionFrame+',
    marks: 'unsupportedNodeAttribute unsupportedMark',
    group: 'blockRootOnly',
    attrs: {
        extensionKey: {
            default: ''
        },
        extensionType: {
            default: ''
        },
        parameters: {
            default: null
        },
        text: {
            default: null
        },
        layout: {
            default: 'default'
        },
        localId: {
            default: null
        }
    },
    selectable: true,
    definingAsContext: true
});
var $c96ce53c15e04104$export$63cadbf5f4296627 = (0, $cDw0B.createPMNodeSpecFactory)({
    content: '(paragraph | heading | mediaSingle | mediaGroup | codeBlock | bulletList | orderedList | taskList | decisionList | rule | panel | blockquote | unsupportedBlock | extension)+',
    marks: 'fontSize unsupportedMark unsupportedNodeAttribute dataConsumer fragment',
    attrs: {
        title: {
            default: ''
        },
        __expanded: {
            default: true
        },
        localId: {
            default: null
        }
    },
    selectable: true,
    isolating: true
});
var $c96ce53c15e04104$export$f03786aa6312d1e4 = (0, $cDw0B.createPMNodeSpecFactory)({
    attrs: {
        title: {
            default: ''
        },
        __expanded: {
            default: true
        },
        localId: {
            default: null
        }
    },
    selectable: true,
    isolating: true
});
var $c96ce53c15e04104$export$a5dc81035676e7a = (0, $cDw0B.createPMNodeSpecFactory)({
    content: 'listItem+',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    attrs: {
        order: {
            default: 1
        },
        localId: {
            default: null
        }
    },
    selectable: false
});
var $c96ce53c15e04104$export$21f42ab9b6679f44 = (0, $cDw0B.createPMNodeSpecFactory)({
    content: '(paragraph | heading | bulletList | orderedList | blockCard | mediaGroup | mediaSingle | codeBlock | taskList | rule | decisionList | unsupportedBlock | extension)+',
    marks: 'fontSize unsupportedMark unsupportedNodeAttribute dataConsumer fragment',
    group: 'block',
    attrs: {
        panelType: {
            default: 'info'
        },
        panelIcon: {
            default: null
        },
        panelIconId: {
            default: null
        },
        panelIconText: {
            default: null
        },
        panelColor: {
            default: null
        },
        localId: {
            default: null
        }
    },
    selectable: true
});
var $c96ce53c15e04104$export$9c206ddddb32a9b = (0, $cDw0B.createPMNodeSpecFactory)({
    content: 'inline*',
    marks: 'link em strong strike subsup underline textColor annotation backgroundColor typeAheadQuery confluenceInlineComment unsupportedNodeAttribute unsupportedMark code dataConsumer fragment border',
    group: 'block',
    attrs: {
        localId: {
            default: null
        }
    },
    selectable: false
});
var $c96ce53c15e04104$export$4f98472e6dc14293 = (0, $cDw0B.createPMNodeSpecFactory)({
    group: 'block',
    attrs: {
        localId: {
            default: null
        }
    },
    selectable: false
});
var $c96ce53c15e04104$export$ab32079c0da00ac2 = (0, $cDw0B.createPMNodeSpecFactory)({
    group: 'block',
    attrs: {
        localId: {
            default: null
        }
    },
    selectable: false
});
var $c96ce53c15e04104$export$d1c89394b5f252a = (0, $cDw0B.createPMNodeSpecFactory)({
    group: 'block',
    attrs: {
        localId: {
            default: null
        }
    },
    selectable: false
});
var $c96ce53c15e04104$export$961993701b15405a = (0, $cDw0B.createPMNodeSpecFactory)({
    attrs: {
        localId: {
            default: null
        }
    },
    selectable: false
});
var $c96ce53c15e04104$export$ea332b61641b0588 = (0, $cDw0B.createPMNodeSpecFactory)({
    group: 'block',
    attrs: {
        localId: {
            default: null
        }
    },
    selectable: false
});
var $c96ce53c15e04104$export$a1f41dc4901771f8 = (0, $cDw0B.createPMNodeSpecFactory)({
    group: 'block',
    attrs: {
        localId: {
            default: null
        }
    },
    selectable: false
});
var $c96ce53c15e04104$export$c7187bbd1a7a9244 = (0, $cDw0B.createPMNodeSpecFactory)({
    marks: '',
    group: 'inline',
    inline: true,
    attrs: {
        text: {
            default: ''
        },
        localId: {
            default: null
        }
    },
    selectable: false
});
var $c96ce53c15e04104$export$fbeb3a3956e8a3c7 = (0, $cDw0B.createPMNodeSpecFactory)({
    group: 'block',
    attrs: {
        localId: {
            default: null
        }
    }
});
var $c96ce53c15e04104$export$471f7ae5c4103ae1 = (0, $cDw0B.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        text: {
            default: ''
        },
        color: {
            default: ''
        },
        localId: {
            default: ''
        },
        style: {
            default: ''
        }
    },
    selectable: true
});
var $c96ce53c15e04104$export$b6ce52be8d7a261 = (0, $cDw0B.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        text: {
            default: ''
        },
        color: {
            default: ''
        },
        localId: {
            default: ''
        },
        style: {
            default: ''
        }
    },
    selectable: true
});
var $c96ce53c15e04104$export$faab0ca9701d7048 = (0, $cDw0B.createPMNodeSpecFactory)({
    attrs: {
        resourceId: {
            default: ''
        },
        localId: {
            default: ''
        }
    },
    selectable: true
});
var $c96ce53c15e04104$export$9852986a3ec5f6a0 = (0, $cDw0B.createPMNodeSpecFactory)({
    content: 'tableRow+',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    attrs: {
        displayMode: {
            default: null
        },
        isNumberColumnEnabled: {
            default: false
        },
        layout: {
            default: 'default'
        },
        localId: {
            default: ''
        },
        width: {
            default: null
        },
        __autoSize: {
            default: false
        }
    },
    selectable: true,
    isolating: true,
    tableRole: 'table'
});
var $c96ce53c15e04104$export$ce086a560a1d05f5 = (0, $cDw0B.createPMNodeSpecFactory)({
    content: 'tableRow+',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    attrs: {
        displayMode: {
            default: null
        },
        isNumberColumnEnabled: {
            default: false
        },
        layout: {
            default: 'default'
        },
        localId: {
            default: ''
        },
        width: {
            default: null
        },
        __autoSize: {
            default: false
        }
    },
    selectable: true,
    isolating: true,
    tableRole: 'table'
});
var $c96ce53c15e04104$export$e1e720e5f4603e6a = (0, $cDw0B.createPMNodeSpecFactory)({
    content: '(paragraph | panel | blockquote | orderedList | bulletList | rule | heading | codeBlock | mediaSingle | mediaGroup | decisionList | taskList | blockCard | embedCard | extension | nestedExpand | unsupportedBlock)+',
    marks: 'alignment unsupportedMark unsupportedNodeAttribute fontSize dataConsumer fragment',
    attrs: {
        colspan: {
            default: 1
        },
        rowspan: {
            default: 1
        },
        colwidth: {
            default: null
        },
        background: {
            default: null
        },
        localId: {
            default: null
        }
    },
    selectable: false,
    isolating: true,
    tableRole: 'cell'
});
var $c96ce53c15e04104$export$abf39ca178940ff3 = (0, $cDw0B.createPMNodeSpecFactory)({
    content: '(paragraph | panel | blockquote | orderedList | bulletList | rule | heading | codeBlock | mediaSingle | mediaGroup | decisionList | taskList | blockCard | embedCard | extension | nestedExpand | unsupportedBlock | table)+',
    marks: 'alignment unsupportedMark unsupportedNodeAttribute fontSize dataConsumer fragment',
    attrs: {
        colspan: {
            default: 1
        },
        rowspan: {
            default: 1
        },
        colwidth: {
            default: null
        },
        background: {
            default: null
        },
        localId: {
            default: null
        }
    },
    selectable: false,
    isolating: true,
    tableRole: 'cell'
});
var $c96ce53c15e04104$export$48884d2a5190dc73 = (0, $cDw0B.createPMNodeSpecFactory)({
    content: '(paragraph | panel | blockquote | orderedList | bulletList | rule | heading | codeBlock | mediaSingle | mediaGroup | decisionList | taskList | blockCard | embedCard | extension | nestedExpand)+',
    marks: 'alignment unsupportedMark unsupportedNodeAttribute fontSize dataConsumer fragment',
    attrs: {
        colspan: {
            default: 1
        },
        rowspan: {
            default: 1
        },
        colwidth: {
            default: null
        },
        background: {
            default: null
        },
        localId: {
            default: null
        }
    },
    selectable: false,
    isolating: true,
    tableRole: 'header_cell'
});
var $c96ce53c15e04104$export$2a5a518232fa1a97 = (0, $cDw0B.createPMNodeSpecFactory)({
    content: '(paragraph | panel | blockquote | orderedList | bulletList | rule | heading | codeBlock | mediaSingle | mediaGroup | decisionList | taskList | blockCard | embedCard | extension | nestedExpand | table)+',
    marks: 'alignment unsupportedMark unsupportedNodeAttribute fontSize dataConsumer fragment',
    attrs: {
        colspan: {
            default: 1
        },
        rowspan: {
            default: 1
        },
        colwidth: {
            default: null
        },
        background: {
            default: null
        },
        localId: {
            default: null
        }
    },
    selectable: false,
    isolating: true,
    tableRole: 'header_cell'
});
var $c96ce53c15e04104$export$ce666bf02318c957 = (0, $cDw0B.createPMNodeSpecFactory)({
    content: '(tableCell | tableHeader)+',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    attrs: {
        localId: {
            default: null
        }
    },
    selectable: false,
    tableRole: 'row'
});
var $c96ce53c15e04104$export$7d657479499397 = (0, $cDw0B.createPMNodeSpecFactory)({
    content: '(tableCell | tableHeader)+',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    attrs: {
        localId: {
            default: null
        }
    },
    selectable: false,
    tableRole: 'row'
});
var $c96ce53c15e04104$export$6d8b0ef52e2e6390 = (0, $cDw0B.createPMNodeSpecFactory)({
    content: 'inline*',
    marks: '_',
    attrs: {
        localId: {
            default: ''
        },
        state: {
            default: 'TODO'
        }
    },
    selectable: false,
    defining: true
});
var $c96ce53c15e04104$export$375b6afcc5f4d291 = (0, $cDw0B.createPMNodeSpecFactory)({
    content: '(taskItem | unsupportedBlock | blockTaskItem)+ (taskItem | taskList | unsupportedBlock | blockTaskItem)*',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    attrs: {
        localId: {
            default: ''
        }
    },
    selectable: false,
    defining: true
});
var $c96ce53c15e04104$export$3c86306d85ad1f18 = (0, $cDw0B.createPMNodeSpecFactory)({
    content: '(taskItem | taskList | unsupportedBlock | blockTaskItem)+',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    attrs: {
        localId: {
            default: ''
        }
    },
    selectable: false,
    defining: true
});
var $c96ce53c15e04104$export$6f093cfa640b7166 = (0, $cDw0B.createPMNodeSpecFactory)({
    group: 'inline'
});
var $c96ce53c15e04104$export$5ea06bc686c59dc2 = (0, $cDw0B.createPMNodeSpecFactory)({
    group: 'inline'
});
var $c96ce53c15e04104$export$93256a4c17b33a82 = (0, $cDw0B.createPMNodeSpecFactory)({
    group: 'inline'
});
var $c96ce53c15e04104$export$a12828d0f14a2762 = (0, $cDw0B.createPMNodeSpecFactory)({});
var $c96ce53c15e04104$export$44b79b0979d0f0f7 = (0, $cDw0B.createPMNodeSpecFactory)({
    group: 'block',
    atom: true,
    attrs: {
        originalValue: {
            default: {}
        }
    },
    selectable: true
});
var $c96ce53c15e04104$export$310ebe0d80122e9b = (0, $cDw0B.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        originalValue: {
            default: {}
        }
    },
    selectable: true
});

});


parcelRegister("5wL5P", function(module, exports) {
$parcel$export(module.exports, "overflowShadow", () => $40647893eba0d518$export$c5c1e4f4640336fb);

var $lAD7C = parcelRequire("lAD7C");

var $74Zh5 = parcelRequire("74Zh5");
var $40647893eba0d518$var$_templateObject;
var $40647893eba0d518$export$c5c1e4f4640336fb = function overflowShadow(_ref) {
    var leftCoverWidth = _ref.leftCoverWidth, rightCoverWidth = _ref.rightCoverWidth;
    var width = "var(--ds-space-100, 8px)";
    var leftCoverWidthResolved = leftCoverWidth || width;
    var rightCoverWidthResolved = rightCoverWidth || width;
    // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- needs manual remediation
    return (0, $74Zh5.css)($40647893eba0d518$var$_templateObject || ($40647893eba0d518$var$_templateObject = (0, (/*@__PURE__*/$parcel$interopDefault($lAD7C)))([
        "\n/* shadow cover left */\n  linear-gradient(\n    to right,\n    ",
        " ",
        ",\n    transparent ",
        "\n  ),\n/* shadow cover background left */\n  linear-gradient(\n    to right,\n    ",
        " ",
        ",\n    transparent ",
        "\n  ),\n/* shadow cover right */\n  linear-gradient(\n    to left,\n    ",
        " ",
        ",\n    transparent ",
        "\n  ),\n/* shadow cover background right */\n  linear-gradient(\n    to left,\n    ",
        " ",
        ",\n    transparent ",
        "\n  ),\n/* overflow shadow right spread */\n  linear-gradient(\n    to left,\n    ",
        " 0,\n    ",
        "  ",
        "\n  ),\n  /* overflow shadow right perimeter */\n  linear-gradient(\n    to left,\n    ",
        " 0,\n    ",
        "  ",
        "\n  ),\n  /* overflow shadow left spread */\n  linear-gradient(\n    to right,\n    ",
        " 0,\n    ",
        "  ",
        "\n  ),\n  /* overflow shadow left perimeter */\n  linear-gradient(\n    to right,\n    ",
        " 0,\n    ",
        "  ",
        "\n  )\n"
    ])), "var(--ds-background-neutral, #0515240F)", leftCoverWidthResolved, leftCoverWidthResolved, "var(--ds-surface-raised, #FFFFFF)", leftCoverWidthResolved, leftCoverWidthResolved, "var(--ds-background-neutral, #0515240F)", rightCoverWidthResolved, rightCoverWidthResolved, "var(--ds-surface-raised, #FFFFFF)", rightCoverWidthResolved, rightCoverWidthResolved, "var(--ds-shadow-overflow-spread, #1E1F2129)", "var(--ds-UNSAFE-transparent, transparent)", width, "var(--ds-shadow-overflow-perimeter, #1E1F211f)", "var(--ds-UNSAFE-transparent, transparent)", width, "var(--ds-shadow-overflow-spread, #1E1F2129)", "var(--ds-UNSAFE-transparent, transparent)", width, "var(--ds-shadow-overflow-perimeter, #1E1F211f)", "var(--ds-UNSAFE-transparent, transparent)", width);
};

});

parcelRegister("4vXmi", function(module, exports) {
$parcel$export(module.exports, "browser", () => $34981a11f81fcf93$export$3f2684e5d7cb1006);
$parcel$export(module.exports, "getBrowserInfo", () => $34981a11f81fcf93$export$6c724a6ffa2dc3e1);

var $cvlyC = parcelRequire("cvlyC");
// eslint-disable-next-line @repo/internal/deprecations/deprecation-ticket-required
/**
 * @deprecated
 * This file is deprecated and will be removed in the next major release.
 * Please use `getBrowserInfo` function to get the browser info on demand.
 * Static `browser` info is no longer supported.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
var $34981a11f81fcf93$export$3f2684e5d7cb1006 = {
    mac: false,
    windows: false,
    ie: false,
    ie_version: 0,
    gecko: false,
    gecko_version: 0,
    chrome: false,
    chrome_version: 0,
    android: false,
    ios: false,
    webkit: false,
    safari: false,
    safari_version: 0,
    supportsIntersectionObserver: false,
    supportsResizeObserver: false
};
if (typeof navigator !== 'undefined') {
    var $34981a11f81fcf93$var$_userAgentData;
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    var $34981a11f81fcf93$var$ieEdge = /(?:Edge|Edg)\/(\d+)/.exec(navigator.userAgent);
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    var $34981a11f81fcf93$var$ieUpTo10 = /MSIE \d/.test(navigator.userAgent);
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    var $34981a11f81fcf93$var$ie11up = /Trident\/(?:[7-9]|\d{2,})\..*rv:(\d+)/.exec(navigator.userAgent);
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    $34981a11f81fcf93$export$3f2684e5d7cb1006.mac = /Mac/.test(navigator.platform);
    $34981a11f81fcf93$export$3f2684e5d7cb1006.windows = // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (($34981a11f81fcf93$var$_userAgentData = navigator.userAgentData) === null || $34981a11f81fcf93$var$_userAgentData === void 0 ? void 0 : $34981a11f81fcf93$var$_userAgentData.platform) === 'Windows' || // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    /Windows|Win\d+/i.test(navigator.userAgent);
    var $34981a11f81fcf93$var$ie = $34981a11f81fcf93$export$3f2684e5d7cb1006.ie = !!($34981a11f81fcf93$var$ieUpTo10 || $34981a11f81fcf93$var$ie11up || $34981a11f81fcf93$var$ieEdge);
    $34981a11f81fcf93$export$3f2684e5d7cb1006.ie_version = $34981a11f81fcf93$var$ieUpTo10 ? // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    document.documentMode || 6 : $34981a11f81fcf93$var$ie11up ? +$34981a11f81fcf93$var$ie11up[1] : $34981a11f81fcf93$var$ieEdge ? +$34981a11f81fcf93$var$ieEdge[1] : null;
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    $34981a11f81fcf93$export$3f2684e5d7cb1006.gecko = !$34981a11f81fcf93$var$ie && /gecko\/\d/i.test(navigator.userAgent);
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    $34981a11f81fcf93$export$3f2684e5d7cb1006.gecko_version = parseInt((navigator.userAgent.match(/Firefox\/(\d+)/) || [])[1], 10);
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    $34981a11f81fcf93$export$3f2684e5d7cb1006.chrome = !$34981a11f81fcf93$var$ie && /Chrome\//.test(navigator.userAgent);
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    $34981a11f81fcf93$export$3f2684e5d7cb1006.chrome_version = parseInt((navigator.userAgent.match(/Chrome\/(\d+)/) || [])[1], 10);
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    $34981a11f81fcf93$export$3f2684e5d7cb1006.android = /Android \d/.test(navigator.userAgent);
    $34981a11f81fcf93$export$3f2684e5d7cb1006.ios = // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    !$34981a11f81fcf93$var$ie && /AppleWebKit/.test(navigator.userAgent) && /Mobile\/\w+/.test(navigator.userAgent);
    $34981a11f81fcf93$export$3f2684e5d7cb1006.webkit = !$34981a11f81fcf93$var$ie && !!document.documentElement && 'WebkitAppearance' in document.documentElement.style;
    $34981a11f81fcf93$export$3f2684e5d7cb1006.safari = Boolean(navigator.vendor && navigator.vendor.indexOf('Apple') > -1 && navigator.userAgent && navigator.userAgent.indexOf('CriOS') === -1 && navigator.userAgent.indexOf('FxiOS') === -1);
    $34981a11f81fcf93$export$3f2684e5d7cb1006.safari_version = parseInt(// Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    (navigator.userAgent.match(/Version\/([0-9\._]+).*Safari/) || [])[1], 10);
    $34981a11f81fcf93$export$3f2684e5d7cb1006.supportsIntersectionObserver = typeof window !== 'undefined' && 'IntersectionObserver' in window && 'IntersectionObserverEntry' in window && // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    'intersectionRatio' in window.IntersectionObserverEntry.prototype;
    $34981a11f81fcf93$export$3f2684e5d7cb1006.supportsResizeObserver = typeof window !== 'undefined' && 'ResizeObserver' in window && 'ResizeObserverEntry' in window;
}
var $34981a11f81fcf93$var$getFirstMatch = function getFirstMatch(regexp, ua) {
    var match = ua.match(regexp);
    return match && match.length > 0 && match[1] || '';
};
var $34981a11f81fcf93$var$getSecondMatch = function getSecondMatch(regexp, ua) {
    var match = ua.match(regexp);
    return match && match.length > 0 && match[2] || '';
};
// Helper functions to safely access browser properties
var $34981a11f81fcf93$var$getSafeUserAgent = function getSafeUserAgent() {
    var _window$navigator;
    if (typeof window === 'undefined') return undefined;
    var ssrUserAgent;
    // Fallback to navigator.userAgent with proper null checking
    return (_window$navigator = window.navigator) === null || _window$navigator === void 0 ? void 0 : _window$navigator.userAgent;
};
var $34981a11f81fcf93$var$getSafePlatform = function getSafePlatform() {
    var _window$navigator2;
    if (typeof window === 'undefined') return undefined;
    return (_window$navigator2 = window.navigator) === null || _window$navigator2 === void 0 ? void 0 : _window$navigator2.platform;
};
var $34981a11f81fcf93$var$hasIntersectionObserver = function hasIntersectionObserver() {
    return typeof window !== 'undefined' && 'IntersectionObserver' in window && 'IntersectionObserverEntry' in window && // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    'intersectionRatio' in window.IntersectionObserverEntry.prototype;
};
var $34981a11f81fcf93$var$hasResizeObserver = function hasResizeObserver() {
    return typeof window !== 'undefined' && 'ResizeObserver' in window && 'ResizeObserverEntry' in window;
};
var $34981a11f81fcf93$export$6c724a6ffa2dc3e1 = (0, $cvlyC.default)(function() {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var result = {
        mac: false,
        windows: false,
        ie: false,
        ie_version: 0,
        gecko: false,
        gecko_version: 0,
        chrome: false,
        chrome_version: 0,
        android: false,
        ios: false,
        webkit: false,
        safari: false,
        safari_version: 0,
        supportsIntersectionObserver: false,
        supportsResizeObserver: false
    };
    var userAgent = $34981a11f81fcf93$var$getSafeUserAgent();
    var platform = $34981a11f81fcf93$var$getSafePlatform();
    if (userAgent) {
        // inspired from https://github.com/bowser-js/bowser/blob/master/src/parser-browsers.js
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        var _ieEdge = /\sedg\//i.test(userAgent);
        // eslint-disable-next-line require-unicode-regexp
        var ieEdge2 = /edg([ea]|ios)/i.test(userAgent);
        // eslint-disable-next-line require-unicode-regexp
        var internetExplorer = /msie|trident/i.test(userAgent);
        // Ideally we should use userAgent instead of platform, but we have lots of keymap tests failure when we change it
        // So leave it as is for now.
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        result.mac = platform && /Mac/.test(platform);
        // Previously relied on navigator.userAgentData?.platform and userAgent, now used only userAgent
        result.windows = // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        /Windows|Win\d+/i.test(userAgent);
        // used userAgent rather than relying on documentMode
        var _ie = _ieEdge || ieEdge2 || internetExplorer;
        result.ie = _ie;
        // inspired from https://github.com/bowser-js/bowser/blob/master/src/parser-browsers.js
        result.ie_version = _ieEdge ? // eslint-disable-next-line require-unicode-regexp
        parseInt($34981a11f81fcf93$var$getFirstMatch(/\sedg\/(\d+(\.?_?\d+)+)/i, userAgent), 10) : // eslint-disable-next-line require-unicode-regexp
        ieEdge2 ? // eslint-disable-next-line require-unicode-regexp
        parseInt($34981a11f81fcf93$var$getSecondMatch(/edg([ea]|ios)\/(\d+(\.?_?\d+)+)/i, userAgent), 10) : // eslint-disable-next-line require-unicode-regexp
        parseInt($34981a11f81fcf93$var$getFirstMatch(/(?:msie |rv:)(\d+(\.?_?\d+)+)/i, userAgent), 10);
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        result.gecko = !_ie && /gecko\/\d/i.test(userAgent);
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        result.gecko_version = parseInt((userAgent.match(/Firefox\/(\d+)/) || [])[1], 10);
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        result.chrome = !_ie && /Chrome\//.test(userAgent);
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        result.chrome_version = parseInt((userAgent.match(/Chrome\/(\d+)/) || [])[1], 10);
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        result.android = /Android \d/.test(userAgent);
        result.ios = // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        !_ie && /AppleWebKit/.test(userAgent) && /Mobile\/\w+/.test(userAgent);
        // Previously relied on navigator.vendor, now used userAgent
        result.safari = !result.chrome && !result.ie && !result.gecko && !result.android && !userAgent.includes('CriOS') && !userAgent.includes('FxiOS') && // eslint-disable-next-line require-unicode-regexp
        /safari|applewebkit/i.test(userAgent);
        result.safari_version = parseInt(// eslint-disable-next-line require-unicode-regexp
        (userAgent.match(/Version\/([0-9\._]+).*Safari/) || [])[1], 10);
        // Previously we relied on documentElement.style.WebkitAppearance, now changed to userAgent
        // eslint-disable-next-line require-unicode-regexp
        result.webkit = /(apple)?webkit/i.test(userAgent);
        result.supportsIntersectionObserver = $34981a11f81fcf93$var$hasIntersectionObserver();
        result.supportsResizeObserver = $34981a11f81fcf93$var$hasResizeObserver();
    }
    return result;
});

});

parcelRegister("knSf2", function(module, exports) {
$parcel$export(module.exports, "CodeBlockSharedCssClassName", () => $ed7007e19d6d79d9$export$42659c26f026f6ea);
var $ed7007e19d6d79d9$export$42659c26f026f6ea = {
    CODEBLOCK_CONTAINER: 'code-block',
    CODEBLOCK_START: 'code-block--start',
    CODEBLOCK_END: 'code-block--end',
    CODEBLOCK_CONTENT_WRAPPER: 'code-block-content-wrapper',
    CODEBLOCK_LINE_NUMBER_GUTTER: 'line-number-gutter',
    CODEBLOCK_CONTENT: 'code-content',
    DS_CODEBLOCK: '[data-ds--code--code-block]',
    CODEBLOCK_CONTENT_WRAPPED: 'code-content--wrapped',
    CODEBLOCK_CONTAINER_LINE_NUMBER_WIDGET: 'code-content__line-number--wrapped'
};

});

parcelRegister("iv75Q", function(module, exports) {
$parcel$export(module.exports, "tableCellBackgroundStyleOverride", () => $d7809fd0775f876c$export$677e93f0f5f9623a);
/* eslint-disable @atlaskit/ui-styling-standard/use-compiled -- Pre-existing lint debt surfaced by this mechanical type-import-only PR. */ /* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $74Zh5 = parcelRequire("74Zh5");

var $4iuZ2 = parcelRequire("4iuZ2");

var $b6T7g = parcelRequire("b6T7g");
// This is used in order to support usage of DS tokens. Table cell background-color
// is set inline in '@atlaskit/adf-schema' and the color value is stored in ADF so
// it is not possible to use tokens there without polluting ADF.
// As table cell backgrounds are set inline, this should not break mobile as
// hexToEditorBackgroundPaletteColor() outputs a css variable with fallback hex.
var $d7809fd0775f876c$var$mapBackgroundColors = function mapBackgroundColors() {
    var cssString = '';
    (0, $4iuZ2.tableBackgroundColorNames).forEach(function(value, key) {
        var paletteColorValue = (0, $b6T7g.hexToEditorBackgroundPaletteColor)(value);
        if (paletteColorValue) cssString += "\n        td[colorname='".concat(key, "' i],\n        th[colorname='").concat(key, "' i] {\n          background-color: ").concat(paletteColorValue, " !important;\n        }\n      ");
    });
    return cssString;
};
var $d7809fd0775f876c$export$677e93f0f5f9623a = function tableCellBackgroundStyleOverride() {
    return (0, $74Zh5.css)($d7809fd0775f876c$var$mapBackgroundColors());
};

});
parcelRegister("b6T7g", function(module, exports) {
$parcel$export(module.exports, "hexToEditorBackgroundPaletteColor", () => $816b0228f3b23cfb$export$5f6a44a42a4b38c2);
$parcel$export(module.exports, "hexToEditorBackgroundPaletteRawValue", () => $816b0228f3b23cfb$export$a270511a0e7fd61a);

var $25nEq = parcelRequire("25nEq");

var $ZZ05K = parcelRequire("ZZ05K");
var $816b0228f3b23cfb$var$_editorBackgroundPale;
function $816b0228f3b23cfb$export$5f6a44a42a4b38c2(hexColor) {
    // Ts ignore used to allow use of conditional return type
    // (preferencing better type on consumption over safety in implementation)
    // @ts-ignore
    var tokenData = $816b0228f3b23cfb$export$2462741d70e6a62f[hexColor.toUpperCase()];
    // @ts-ignore - TS2322 TypeScript 5.9.2 upgrade
    return tokenData ? tokenData.token : undefined;
}
function $816b0228f3b23cfb$export$a270511a0e7fd61a(hexColor) {
    // Ts ignore used to allow use of conditional return type
    // (preferencing better type on consumption over safety in implementation)
    // @ts-ignore
    var tokenData = $816b0228f3b23cfb$export$2462741d70e6a62f[hexColor.toUpperCase()];
    // @ts-ignore - TS2322 TypeScript 5.9.2 upgrade
    return tokenData ? tokenData.getValue(hexColor) : undefined;
}
var $816b0228f3b23cfb$export$2462741d70e6a62f = ($816b0228f3b23cfb$var$_editorBackgroundPale = {}, (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($816b0228f3b23cfb$var$_editorBackgroundPale, '#DEEBFF', {
    getValue: function getValue(fallback) {
        return (0, $ZZ05K.default)('color.background.accent.blue.subtlest', fallback);
    },
    token: "var(--ds-background-accent-blue-subtlest, #DEEBFF)"
}), '#B3D4FF', {
    getValue: function getValue(fallback) {
        return (0, $ZZ05K.default)('color.background.accent.blue.subtler', fallback);
    },
    token: "var(--ds-background-accent-blue-subtler, #B3D4FF)"
}), '#4C9AFF', {
    getValue: function getValue(fallback) {
        return (0, $ZZ05K.default)('color.background.accent.blue.subtle', fallback);
    },
    token: "var(--ds-background-accent-blue-subtle, #4C9AFF)"
}), '#E6FCFF', {
    getValue: function getValue(fallback) {
        return (0, $ZZ05K.default)('color.background.accent.teal.subtlest', fallback);
    },
    token: "var(--ds-background-accent-teal-subtlest, #E6FCFF)" // source for hex code was legacy token T50,
}), '#B3F5FF', {
    getValue: function getValue(fallback) {
        return (0, $ZZ05K.default)('color.background.accent.teal.subtler', fallback);
    },
    token: "var(--ds-background-accent-teal-subtler, #B3F5FF)" // source for hex code was legacy token T75,
}), '#79E2F2', {
    getValue: function getValue(fallback) {
        return (0, $ZZ05K.default)('color.background.accent.teal.subtle', fallback);
    },
    token: "var(--ds-background-accent-teal-subtle, #79E2F2)" // source for hex code was legacy token T100,
}), '#E3FCEF', {
    getValue: function getValue(fallback) {
        return (0, $ZZ05K.default)('color.background.accent.green.subtlest', fallback);
    },
    token: "var(--ds-background-accent-green-subtlest, #E3FCEF)" // source for hex code was legacy token G50,
}), '#ABF5D1', {
    getValue: function getValue(fallback) {
        return (0, $ZZ05K.default)('color.background.accent.green.subtler', fallback);
    },
    token: "var(--ds-background-accent-green-subtler, #ABF5D1)" // source for hex code was legacy token G75,
}), '#57D9A3', {
    getValue: function getValue(fallback) {
        return (0, $ZZ05K.default)('color.background.accent.green.subtle', fallback);
    },
    token: "var(--ds-background-accent-green-subtle, #57D9A3)" // source for hex code was legacy token G200,
}), '#FFFAE6', {
    getValue: function getValue(fallback) {
        return (0, $ZZ05K.default)('color.background.accent.yellow.subtlest', fallback);
    },
    token: "var(--ds-background-accent-yellow-subtlest, #FFFAE6)" // source for hex code was legacy token Y50,
}), (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($816b0228f3b23cfb$var$_editorBackgroundPale, '#FFF0B3', {
    getValue: function getValue(fallback) {
        return (0, $ZZ05K.default)('color.background.accent.yellow.subtler', fallback);
    },
    token: "var(--ds-background-accent-yellow-subtler, #FFF0B3)" // source for hex code was legacy token Y75,
}), '#FFC400', {
    getValue: function getValue(fallback) {
        return (0, $ZZ05K.default)('color.background.accent.orange.subtle', fallback);
    },
    token: "var(--ds-background-accent-orange-subtle, #FFC400)" // source for hex code was legacy token Y200,
}), '#FFEBE6', {
    getValue: function getValue(fallback) {
        return (0, $ZZ05K.default)('color.background.accent.red.subtlest', fallback);
    },
    token: "var(--ds-background-accent-red-subtlest, #FFEBE6)" // source for hex code was legacy token R50,
}), '#FFBDAD', {
    getValue: function getValue(fallback) {
        return (0, $ZZ05K.default)('color.background.accent.red.subtler', fallback);
    },
    token: "var(--ds-background-accent-red-subtler, #FFBDAD)" // source for hex code was legacy token R75,
}), '#FF8F73', {
    getValue: function getValue(fallback) {
        return (0, $ZZ05K.default)('color.background.accent.red.subtle', fallback);
    },
    token: "var(--ds-background-accent-red-subtle, #FF8F73)" // source for hex code was legacy token R100,
}), '#EAE6FF', {
    getValue: function getValue(fallback) {
        return (0, $ZZ05K.default)('color.background.accent.purple.subtlest', fallback);
    },
    token: "var(--ds-background-accent-purple-subtlest, #EAE6FF)" // source for hex code was legacy token P50,
}), '#C0B6F2', {
    getValue: function getValue(fallback) {
        return (0, $ZZ05K.default)('color.background.accent.purple.subtler', fallback);
    },
    token: "var(--ds-background-accent-purple-subtler, #C0B6F2)" // source for hex code was legacy token P75,
}), '#998DD9', {
    getValue: function getValue(fallback) {
        return (0, $ZZ05K.default)('color.background.accent.purple.subtle', fallback);
    },
    token: "var(--ds-background-accent-purple-subtle, #998DD9)" // source for hex code was legacy token P100,
}), '#FFFFFF', {
    getValue: function getValue(fallback) {
        return (0, $ZZ05K.default)('elevation.surface', fallback);
    },
    token: "var(--ds-surface, #FFFFFF)" // source for hex code was legacy token N0,
}), '#F4F5F7', {
    getValue: function getValue(fallback) {
        return (0, $ZZ05K.default)('color.background.accent.gray.subtlest', fallback);
    },
    token: "var(--ds-background-accent-gray-subtlest, #F4F5F7)" // source for hex code was legacy token N20,
}), (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($816b0228f3b23cfb$var$_editorBackgroundPale, '#B3BAC5', {
    getValue: function getValue(fallback) {
        return (0, $ZZ05K.default)('color.background.accent.gray.subtle', fallback);
    },
    token: "var(--ds-background-accent-gray-subtle, #B3BAC5)" // source for hex code was legacy token N60,
}));

});
parcelRegister("ZZ05K", function(module, exports) {
$parcel$export(module.exports, "default", () => $0ba5040b50b8cb6c$export$2e2bcd8739ae039);


var $4Is3S = parcelRequire("4Is3S");

var $3ZMUU = parcelRequire("3ZMUU");
/**
 * Takes a dot-separated token name and and an optional fallback, and returns the current computed CSS value for the
 * resulting CSS Custom Property.
 * This should be used for when the CSS cascade isn't available, eg. `<canvas>` elements, JS charting libraries, etc.
 *
 * Note: these values change depending on the theme so consider pairing them with `useThemeObserver` in React, or the
 * `ThemeMutationObserver` class elsewhere.
 *
 * @param {string} path - A dot-separated token name (example: `'color.background.brand'` or `'spacing.scale.100'`).
 * @param {string} [fallback] - The fallback value that should render when token CSS is not present in your app.
 *
 * @example
 * ```
 * const theme = useThemeObserver();
 *
 * useEffect(() => {
 *  const lineColor = getTokenValue('color.background.accent.blue.subtle', B400);
 * }, [theme]);
 * ```
 *
 */ function $0ba5040b50b8cb6c$var$getTokenValue(tokenId) {
    var fallback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    var token = (0, $4Is3S.default)[tokenId];
    var tokenValue = fallback;
    typeof $3ZMUU;
    if (typeof window === 'undefined') return tokenValue;
    tokenValue = window.getComputedStyle(document.documentElement).getPropertyValue(token).trim();
    tokenValue = tokenValue || fallback;
    return tokenValue;
}
var $0ba5040b50b8cb6c$export$2e2bcd8739ae039 = $0ba5040b50b8cb6c$var$getTokenValue;

});
parcelRegister("4Is3S", function(module, exports) {
$parcel$export(module.exports, "default", () => $36f109edfb21e392$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c89a29e7cce7f49704b4559e5f42c4ea>>
 * @codegenCommand yarn build tokens
 */ var $36f109edfb21e392$var$tokens = {
    'color.text': '--ds-text',
    'color.text.accent.lime': '--ds-text-accent-lime',
    'color.text.accent.lime.bolder': '--ds-text-accent-lime-bolder',
    'color.text.accent.red': '--ds-text-accent-red',
    'color.text.accent.red.bolder': '--ds-text-accent-red-bolder',
    'color.text.accent.orange': '--ds-text-accent-orange',
    'color.text.accent.orange.bolder': '--ds-text-accent-orange-bolder',
    'color.text.accent.yellow': '--ds-text-accent-yellow',
    'color.text.accent.yellow.bolder': '--ds-text-accent-yellow-bolder',
    'color.text.accent.green': '--ds-text-accent-green',
    'color.text.accent.green.bolder': '--ds-text-accent-green-bolder',
    'color.text.accent.teal': '--ds-text-accent-teal',
    'color.text.accent.teal.bolder': '--ds-text-accent-teal-bolder',
    'color.text.accent.blue': '--ds-text-accent-blue',
    'color.text.accent.blue.bolder': '--ds-text-accent-blue-bolder',
    'color.text.accent.purple': '--ds-text-accent-purple',
    'color.text.accent.purple.bolder': '--ds-text-accent-purple-bolder',
    'color.text.accent.magenta': '--ds-text-accent-magenta',
    'color.text.accent.magenta.bolder': '--ds-text-accent-magenta-bolder',
    'color.text.accent.gray': '--ds-text-accent-gray',
    'color.text.accent.gray.bolder': '--ds-text-accent-gray-bolder',
    'color.text.disabled': '--ds-text-disabled',
    'color.text.inverse': '--ds-text-inverse',
    'color.text.selected': '--ds-text-selected',
    'color.text.brand': '--ds-text-brand',
    'color.text.danger': '--ds-text-danger',
    'color.text.danger.bolder': '--ds-text-danger-bolder',
    'color.text.warning': '--ds-text-warning',
    'color.text.warning.inverse': '--ds-text-warning-inverse',
    'color.text.warning.bolder': '--ds-text-warning-bolder',
    'color.text.success': '--ds-text-success',
    'color.text.success.bolder': '--ds-text-success-bolder',
    'color.text.discovery': '--ds-text-discovery',
    'color.text.discovery.bolder': '--ds-text-discovery-bolder',
    'color.text.information': '--ds-text-information',
    'color.text.information.bolder': '--ds-text-information-bolder',
    'color.text.subtlest': '--ds-text-subtlest',
    'color.text.subtle': '--ds-text-subtle',
    'color.link': '--ds-link',
    'color.link.pressed': '--ds-link-pressed',
    'color.link.visited': '--ds-link-visited',
    'color.link.visited.pressed': '--ds-link-visited-pressed',
    'color.icon': '--ds-icon',
    'color.icon.accent.lime': '--ds-icon-accent-lime',
    'color.icon.accent.red': '--ds-icon-accent-red',
    'color.icon.accent.orange': '--ds-icon-accent-orange',
    'color.icon.accent.yellow': '--ds-icon-accent-yellow',
    'color.icon.accent.green': '--ds-icon-accent-green',
    'color.icon.accent.teal': '--ds-icon-accent-teal',
    'color.icon.accent.blue': '--ds-icon-accent-blue',
    'color.icon.accent.purple': '--ds-icon-accent-purple',
    'color.icon.accent.magenta': '--ds-icon-accent-magenta',
    'color.icon.accent.gray': '--ds-icon-accent-gray',
    'color.icon.disabled': '--ds-icon-disabled',
    'color.icon.inverse': '--ds-icon-inverse',
    'color.icon.selected': '--ds-icon-selected',
    'color.icon.brand': '--ds-icon-brand',
    'color.icon.danger': '--ds-icon-danger',
    'color.icon.warning': '--ds-icon-warning',
    'color.icon.warning.inverse': '--ds-icon-warning-inverse',
    'color.icon.success': '--ds-icon-success',
    'color.icon.discovery': '--ds-icon-discovery',
    'color.icon.information': '--ds-icon-information',
    'color.icon.subtlest': '--ds-icon-subtlest',
    'color.icon.subtle': '--ds-icon-subtle',
    'color.border': '--ds-border',
    'color.border.accent.lime': '--ds-border-accent-lime',
    'color.border.accent.red': '--ds-border-accent-red',
    'color.border.accent.orange': '--ds-border-accent-orange',
    'color.border.accent.yellow': '--ds-border-accent-yellow',
    'color.border.accent.green': '--ds-border-accent-green',
    'color.border.accent.teal': '--ds-border-accent-teal',
    'color.border.accent.blue': '--ds-border-accent-blue',
    'color.border.accent.purple': '--ds-border-accent-purple',
    'color.border.accent.magenta': '--ds-border-accent-magenta',
    'color.border.accent.gray': '--ds-border-accent-gray',
    'color.border.disabled': '--ds-border-disabled',
    'color.border.focused': '--ds-border-focused',
    'color.border.input': '--ds-border-input',
    'color.border.inverse': '--ds-border-inverse',
    'color.border.selected': '--ds-border-selected',
    'color.border.brand': '--ds-border-brand',
    'color.border.danger': '--ds-border-danger',
    'color.border.warning': '--ds-border-warning',
    'color.border.success': '--ds-border-success',
    'color.border.discovery': '--ds-border-discovery',
    'color.border.information': '--ds-border-information',
    'color.border.bold': '--ds-border-bold',
    'color.background.accent.lime.subtlest': '--ds-background-accent-lime-subtlest',
    'color.background.accent.lime.subtlest.hovered': '--ds-background-accent-lime-subtlest-hovered',
    'color.background.accent.lime.subtlest.pressed': '--ds-background-accent-lime-subtlest-pressed',
    'color.background.accent.lime.subtler': '--ds-background-accent-lime-subtler',
    'color.background.accent.lime.subtler.hovered': '--ds-background-accent-lime-subtler-hovered',
    'color.background.accent.lime.subtler.pressed': '--ds-background-accent-lime-subtler-pressed',
    'color.background.accent.lime.subtle': '--ds-background-accent-lime-subtle',
    'color.background.accent.lime.subtle.hovered': '--ds-background-accent-lime-subtle-hovered',
    'color.background.accent.lime.subtle.pressed': '--ds-background-accent-lime-subtle-pressed',
    'color.background.accent.lime.bolder': '--ds-background-accent-lime-bolder',
    'color.background.accent.lime.bolder.hovered': '--ds-background-accent-lime-bolder-hovered',
    'color.background.accent.lime.bolder.pressed': '--ds-background-accent-lime-bolder-pressed',
    'color.background.accent.red.subtlest': '--ds-background-accent-red-subtlest',
    'color.background.accent.red.subtlest.hovered': '--ds-background-accent-red-subtlest-hovered',
    'color.background.accent.red.subtlest.pressed': '--ds-background-accent-red-subtlest-pressed',
    'color.background.accent.red.subtler': '--ds-background-accent-red-subtler',
    'color.background.accent.red.subtler.hovered': '--ds-background-accent-red-subtler-hovered',
    'color.background.accent.red.subtler.pressed': '--ds-background-accent-red-subtler-pressed',
    'color.background.accent.red.subtle': '--ds-background-accent-red-subtle',
    'color.background.accent.red.subtle.hovered': '--ds-background-accent-red-subtle-hovered',
    'color.background.accent.red.subtle.pressed': '--ds-background-accent-red-subtle-pressed',
    'color.background.accent.red.bolder': '--ds-background-accent-red-bolder',
    'color.background.accent.red.bolder.hovered': '--ds-background-accent-red-bolder-hovered',
    'color.background.accent.red.bolder.pressed': '--ds-background-accent-red-bolder-pressed',
    'color.background.accent.orange.subtlest': '--ds-background-accent-orange-subtlest',
    'color.background.accent.orange.subtlest.hovered': '--ds-background-accent-orange-subtlest-hovered',
    'color.background.accent.orange.subtlest.pressed': '--ds-background-accent-orange-subtlest-pressed',
    'color.background.accent.orange.subtler': '--ds-background-accent-orange-subtler',
    'color.background.accent.orange.subtler.hovered': '--ds-background-accent-orange-subtler-hovered',
    'color.background.accent.orange.subtler.pressed': '--ds-background-accent-orange-subtler-pressed',
    'color.background.accent.orange.subtle': '--ds-background-accent-orange-subtle',
    'color.background.accent.orange.subtle.hovered': '--ds-background-accent-orange-subtle-hovered',
    'color.background.accent.orange.subtle.pressed': '--ds-background-accent-orange-subtle-pressed',
    'color.background.accent.orange.bolder': '--ds-background-accent-orange-bolder',
    'color.background.accent.orange.bolder.hovered': '--ds-background-accent-orange-bolder-hovered',
    'color.background.accent.orange.bolder.pressed': '--ds-background-accent-orange-bolder-pressed',
    'color.background.accent.yellow.subtlest': '--ds-background-accent-yellow-subtlest',
    'color.background.accent.yellow.subtlest.hovered': '--ds-background-accent-yellow-subtlest-hovered',
    'color.background.accent.yellow.subtlest.pressed': '--ds-background-accent-yellow-subtlest-pressed',
    'color.background.accent.yellow.subtler': '--ds-background-accent-yellow-subtler',
    'color.background.accent.yellow.subtler.hovered': '--ds-background-accent-yellow-subtler-hovered',
    'color.background.accent.yellow.subtler.pressed': '--ds-background-accent-yellow-subtler-pressed',
    'color.background.accent.yellow.subtle': '--ds-background-accent-yellow-subtle',
    'color.background.accent.yellow.subtle.hovered': '--ds-background-accent-yellow-subtle-hovered',
    'color.background.accent.yellow.subtle.pressed': '--ds-background-accent-yellow-subtle-pressed',
    'color.background.accent.yellow.bolder': '--ds-background-accent-yellow-bolder',
    'color.background.accent.yellow.bolder.hovered': '--ds-background-accent-yellow-bolder-hovered',
    'color.background.accent.yellow.bolder.pressed': '--ds-background-accent-yellow-bolder-pressed',
    'color.background.accent.green.subtlest': '--ds-background-accent-green-subtlest',
    'color.background.accent.green.subtlest.hovered': '--ds-background-accent-green-subtlest-hovered',
    'color.background.accent.green.subtlest.pressed': '--ds-background-accent-green-subtlest-pressed',
    'color.background.accent.green.subtler': '--ds-background-accent-green-subtler',
    'color.background.accent.green.subtler.hovered': '--ds-background-accent-green-subtler-hovered',
    'color.background.accent.green.subtler.pressed': '--ds-background-accent-green-subtler-pressed',
    'color.background.accent.green.subtle': '--ds-background-accent-green-subtle',
    'color.background.accent.green.subtle.hovered': '--ds-background-accent-green-subtle-hovered',
    'color.background.accent.green.subtle.pressed': '--ds-background-accent-green-subtle-pressed',
    'color.background.accent.green.bolder': '--ds-background-accent-green-bolder',
    'color.background.accent.green.bolder.hovered': '--ds-background-accent-green-bolder-hovered',
    'color.background.accent.green.bolder.pressed': '--ds-background-accent-green-bolder-pressed',
    'color.background.accent.teal.subtlest': '--ds-background-accent-teal-subtlest',
    'color.background.accent.teal.subtlest.hovered': '--ds-background-accent-teal-subtlest-hovered',
    'color.background.accent.teal.subtlest.pressed': '--ds-background-accent-teal-subtlest-pressed',
    'color.background.accent.teal.subtler': '--ds-background-accent-teal-subtler',
    'color.background.accent.teal.subtler.hovered': '--ds-background-accent-teal-subtler-hovered',
    'color.background.accent.teal.subtler.pressed': '--ds-background-accent-teal-subtler-pressed',
    'color.background.accent.teal.subtle': '--ds-background-accent-teal-subtle',
    'color.background.accent.teal.subtle.hovered': '--ds-background-accent-teal-subtle-hovered',
    'color.background.accent.teal.subtle.pressed': '--ds-background-accent-teal-subtle-pressed',
    'color.background.accent.teal.bolder': '--ds-background-accent-teal-bolder',
    'color.background.accent.teal.bolder.hovered': '--ds-background-accent-teal-bolder-hovered',
    'color.background.accent.teal.bolder.pressed': '--ds-background-accent-teal-bolder-pressed',
    'color.background.accent.blue.subtlest': '--ds-background-accent-blue-subtlest',
    'color.background.accent.blue.subtlest.hovered': '--ds-background-accent-blue-subtlest-hovered',
    'color.background.accent.blue.subtlest.pressed': '--ds-background-accent-blue-subtlest-pressed',
    'color.background.accent.blue.subtler': '--ds-background-accent-blue-subtler',
    'color.background.accent.blue.subtler.hovered': '--ds-background-accent-blue-subtler-hovered',
    'color.background.accent.blue.subtler.pressed': '--ds-background-accent-blue-subtler-pressed',
    'color.background.accent.blue.subtle': '--ds-background-accent-blue-subtle',
    'color.background.accent.blue.subtle.hovered': '--ds-background-accent-blue-subtle-hovered',
    'color.background.accent.blue.subtle.pressed': '--ds-background-accent-blue-subtle-pressed',
    'color.background.accent.blue.bolder': '--ds-background-accent-blue-bolder',
    'color.background.accent.blue.bolder.hovered': '--ds-background-accent-blue-bolder-hovered',
    'color.background.accent.blue.bolder.pressed': '--ds-background-accent-blue-bolder-pressed',
    'color.background.accent.purple.subtlest': '--ds-background-accent-purple-subtlest',
    'color.background.accent.purple.subtlest.hovered': '--ds-background-accent-purple-subtlest-hovered',
    'color.background.accent.purple.subtlest.pressed': '--ds-background-accent-purple-subtlest-pressed',
    'color.background.accent.purple.subtler': '--ds-background-accent-purple-subtler',
    'color.background.accent.purple.subtler.hovered': '--ds-background-accent-purple-subtler-hovered',
    'color.background.accent.purple.subtler.pressed': '--ds-background-accent-purple-subtler-pressed',
    'color.background.accent.purple.subtle': '--ds-background-accent-purple-subtle',
    'color.background.accent.purple.subtle.hovered': '--ds-background-accent-purple-subtle-hovered',
    'color.background.accent.purple.subtle.pressed': '--ds-background-accent-purple-subtle-pressed',
    'color.background.accent.purple.bolder': '--ds-background-accent-purple-bolder',
    'color.background.accent.purple.bolder.hovered': '--ds-background-accent-purple-bolder-hovered',
    'color.background.accent.purple.bolder.pressed': '--ds-background-accent-purple-bolder-pressed',
    'color.background.accent.magenta.subtlest': '--ds-background-accent-magenta-subtlest',
    'color.background.accent.magenta.subtlest.hovered': '--ds-background-accent-magenta-subtlest-hovered',
    'color.background.accent.magenta.subtlest.pressed': '--ds-background-accent-magenta-subtlest-pressed',
    'color.background.accent.magenta.subtler': '--ds-background-accent-magenta-subtler',
    'color.background.accent.magenta.subtler.hovered': '--ds-background-accent-magenta-subtler-hovered',
    'color.background.accent.magenta.subtler.pressed': '--ds-background-accent-magenta-subtler-pressed',
    'color.background.accent.magenta.subtle': '--ds-background-accent-magenta-subtle',
    'color.background.accent.magenta.subtle.hovered': '--ds-background-accent-magenta-subtle-hovered',
    'color.background.accent.magenta.subtle.pressed': '--ds-background-accent-magenta-subtle-pressed',
    'color.background.accent.magenta.bolder': '--ds-background-accent-magenta-bolder',
    'color.background.accent.magenta.bolder.hovered': '--ds-background-accent-magenta-bolder-hovered',
    'color.background.accent.magenta.bolder.pressed': '--ds-background-accent-magenta-bolder-pressed',
    'color.background.accent.gray.subtlest': '--ds-background-accent-gray-subtlest',
    'color.background.accent.gray.subtlest.hovered': '--ds-background-accent-gray-subtlest-hovered',
    'color.background.accent.gray.subtlest.pressed': '--ds-background-accent-gray-subtlest-pressed',
    'color.background.accent.gray.subtler': '--ds-background-accent-gray-subtler',
    'color.background.accent.gray.subtler.hovered': '--ds-background-accent-gray-subtler-hovered',
    'color.background.accent.gray.subtler.pressed': '--ds-background-accent-gray-subtler-pressed',
    'color.background.accent.gray.subtle': '--ds-background-accent-gray-subtle',
    'color.background.accent.gray.subtle.hovered': '--ds-background-accent-gray-subtle-hovered',
    'color.background.accent.gray.subtle.pressed': '--ds-background-accent-gray-subtle-pressed',
    'color.background.accent.gray.bolder': '--ds-background-accent-gray-bolder',
    'color.background.accent.gray.bolder.hovered': '--ds-background-accent-gray-bolder-hovered',
    'color.background.accent.gray.bolder.pressed': '--ds-background-accent-gray-bolder-pressed',
    'color.background.disabled': '--ds-background-disabled',
    'color.background.input': '--ds-background-input',
    'color.background.input.hovered': '--ds-background-input-hovered',
    'color.background.input.pressed': '--ds-background-input-pressed',
    'color.background.inverse.subtle': '--ds-background-inverse-subtle',
    'color.background.inverse.subtle.hovered': '--ds-background-inverse-subtle-hovered',
    'color.background.inverse.subtle.pressed': '--ds-background-inverse-subtle-pressed',
    'color.background.neutral': '--ds-background-neutral',
    'color.background.neutral.hovered': '--ds-background-neutral-hovered',
    'color.background.neutral.pressed': '--ds-background-neutral-pressed',
    'color.background.neutral.subtle': '--ds-background-neutral-subtle',
    'color.background.neutral.subtle.hovered': '--ds-background-neutral-subtle-hovered',
    'color.background.neutral.subtle.pressed': '--ds-background-neutral-subtle-pressed',
    'color.background.neutral.bold': '--ds-background-neutral-bold',
    'color.background.neutral.bold.hovered': '--ds-background-neutral-bold-hovered',
    'color.background.neutral.bold.pressed': '--ds-background-neutral-bold-pressed',
    'color.background.selected': '--ds-background-selected',
    'color.background.selected.hovered': '--ds-background-selected-hovered',
    'color.background.selected.pressed': '--ds-background-selected-pressed',
    'color.background.selected.bold': '--ds-background-selected-bold',
    'color.background.selected.bold.hovered': '--ds-background-selected-bold-hovered',
    'color.background.selected.bold.pressed': '--ds-background-selected-bold-pressed',
    'color.background.brand.subtlest': '--ds-background-brand-subtlest',
    'color.background.brand.subtlest.hovered': '--ds-background-brand-subtlest-hovered',
    'color.background.brand.subtlest.pressed': '--ds-background-brand-subtlest-pressed',
    'color.background.brand.bold': '--ds-background-brand-bold',
    'color.background.brand.bold.hovered': '--ds-background-brand-bold-hovered',
    'color.background.brand.bold.pressed': '--ds-background-brand-bold-pressed',
    'color.background.brand.boldest': '--ds-background-brand-boldest',
    'color.background.brand.boldest.hovered': '--ds-background-brand-boldest-hovered',
    'color.background.brand.boldest.pressed': '--ds-background-brand-boldest-pressed',
    'color.background.danger': '--ds-background-danger',
    'color.background.danger.hovered': '--ds-background-danger-hovered',
    'color.background.danger.pressed': '--ds-background-danger-pressed',
    'color.background.danger.subtler': '--ds-background-danger-subtler',
    'color.background.danger.subtler.hovered': '--ds-background-danger-subtler-hovered',
    'color.background.danger.subtler.pressed': '--ds-background-danger-subtler-pressed',
    'color.background.danger.bold': '--ds-background-danger-bold',
    'color.background.danger.bold.hovered': '--ds-background-danger-bold-hovered',
    'color.background.danger.bold.pressed': '--ds-background-danger-bold-pressed',
    'color.background.warning': '--ds-background-warning',
    'color.background.warning.hovered': '--ds-background-warning-hovered',
    'color.background.warning.pressed': '--ds-background-warning-pressed',
    'color.background.warning.subtler': '--ds-background-warning-subtler',
    'color.background.warning.subtler.hovered': '--ds-background-warning-subtler-hovered',
    'color.background.warning.subtler.pressed': '--ds-background-warning-subtler-pressed',
    'color.background.warning.bold': '--ds-background-warning-bold',
    'color.background.warning.bold.hovered': '--ds-background-warning-bold-hovered',
    'color.background.warning.bold.pressed': '--ds-background-warning-bold-pressed',
    'color.background.success': '--ds-background-success',
    'color.background.success.hovered': '--ds-background-success-hovered',
    'color.background.success.pressed': '--ds-background-success-pressed',
    'color.background.success.subtler': '--ds-background-success-subtler',
    'color.background.success.subtler.hovered': '--ds-background-success-subtler-hovered',
    'color.background.success.subtler.pressed': '--ds-background-success-subtler-pressed',
    'color.background.success.bold': '--ds-background-success-bold',
    'color.background.success.bold.hovered': '--ds-background-success-bold-hovered',
    'color.background.success.bold.pressed': '--ds-background-success-bold-pressed',
    'color.background.discovery': '--ds-background-discovery',
    'color.background.discovery.hovered': '--ds-background-discovery-hovered',
    'color.background.discovery.pressed': '--ds-background-discovery-pressed',
    'color.background.discovery.subtler': '--ds-background-discovery-subtler',
    'color.background.discovery.subtler.hovered': '--ds-background-discovery-subtler-hovered',
    'color.background.discovery.subtler.pressed': '--ds-background-discovery-subtler-pressed',
    'color.background.discovery.bold': '--ds-background-discovery-bold',
    'color.background.discovery.bold.hovered': '--ds-background-discovery-bold-hovered',
    'color.background.discovery.bold.pressed': '--ds-background-discovery-bold-pressed',
    'color.background.information': '--ds-background-information',
    'color.background.information.hovered': '--ds-background-information-hovered',
    'color.background.information.pressed': '--ds-background-information-pressed',
    'color.background.information.subtler': '--ds-background-information-subtler',
    'color.background.information.subtler.hovered': '--ds-background-information-subtler-hovered',
    'color.background.information.subtler.pressed': '--ds-background-information-subtler-pressed',
    'color.background.information.bold': '--ds-background-information-bold',
    'color.background.information.bold.hovered': '--ds-background-information-bold-hovered',
    'color.background.information.bold.pressed': '--ds-background-information-bold-pressed',
    'color.blanket': '--ds-blanket',
    'color.blanket.selected': '--ds-blanket-selected',
    'color.blanket.danger': '--ds-blanket-danger',
    'color.interaction.hovered': '--ds-interaction-hovered',
    'color.interaction.pressed': '--ds-interaction-pressed',
    'color.skeleton': '--ds-skeleton',
    'color.skeleton.subtle': '--ds-skeleton-subtle',
    'color.chart.categorical.1': '--ds-chart-categorical-1',
    'color.chart.categorical.1.hovered': '--ds-chart-categorical-1-hovered',
    'color.chart.categorical.2': '--ds-chart-categorical-2',
    'color.chart.categorical.2.hovered': '--ds-chart-categorical-2-hovered',
    'color.chart.categorical.3': '--ds-chart-categorical-3',
    'color.chart.categorical.3.hovered': '--ds-chart-categorical-3-hovered',
    'color.chart.categorical.4': '--ds-chart-categorical-4',
    'color.chart.categorical.4.hovered': '--ds-chart-categorical-4-hovered',
    'color.chart.categorical.5': '--ds-chart-categorical-5',
    'color.chart.categorical.5.hovered': '--ds-chart-categorical-5-hovered',
    'color.chart.categorical.6': '--ds-chart-categorical-6',
    'color.chart.categorical.6.hovered': '--ds-chart-categorical-6-hovered',
    'color.chart.categorical.7': '--ds-chart-categorical-7',
    'color.chart.categorical.7.hovered': '--ds-chart-categorical-7-hovered',
    'color.chart.categorical.8': '--ds-chart-categorical-8',
    'color.chart.categorical.8.hovered': '--ds-chart-categorical-8-hovered',
    'color.chart.lime.bold': '--ds-chart-lime-bold',
    'color.chart.lime.bold.hovered': '--ds-chart-lime-bold-hovered',
    'color.chart.lime.bolder': '--ds-chart-lime-bolder',
    'color.chart.lime.bolder.hovered': '--ds-chart-lime-bolder-hovered',
    'color.chart.lime.boldest': '--ds-chart-lime-boldest',
    'color.chart.lime.boldest.hovered': '--ds-chart-lime-boldest-hovered',
    'color.chart.neutral': '--ds-chart-neutral',
    'color.chart.neutral.hovered': '--ds-chart-neutral-hovered',
    'color.chart.red.bold': '--ds-chart-red-bold',
    'color.chart.red.bold.hovered': '--ds-chart-red-bold-hovered',
    'color.chart.red.bolder': '--ds-chart-red-bolder',
    'color.chart.red.bolder.hovered': '--ds-chart-red-bolder-hovered',
    'color.chart.red.boldest': '--ds-chart-red-boldest',
    'color.chart.red.boldest.hovered': '--ds-chart-red-boldest-hovered',
    'color.chart.orange.bold': '--ds-chart-orange-bold',
    'color.chart.orange.bold.hovered': '--ds-chart-orange-bold-hovered',
    'color.chart.orange.bolder': '--ds-chart-orange-bolder',
    'color.chart.orange.bolder.hovered': '--ds-chart-orange-bolder-hovered',
    'color.chart.orange.boldest': '--ds-chart-orange-boldest',
    'color.chart.orange.boldest.hovered': '--ds-chart-orange-boldest-hovered',
    'color.chart.yellow.bold': '--ds-chart-yellow-bold',
    'color.chart.yellow.bold.hovered': '--ds-chart-yellow-bold-hovered',
    'color.chart.yellow.bolder': '--ds-chart-yellow-bolder',
    'color.chart.yellow.bolder.hovered': '--ds-chart-yellow-bolder-hovered',
    'color.chart.yellow.boldest': '--ds-chart-yellow-boldest',
    'color.chart.yellow.boldest.hovered': '--ds-chart-yellow-boldest-hovered',
    'color.chart.green.bold': '--ds-chart-green-bold',
    'color.chart.green.bold.hovered': '--ds-chart-green-bold-hovered',
    'color.chart.green.bolder': '--ds-chart-green-bolder',
    'color.chart.green.bolder.hovered': '--ds-chart-green-bolder-hovered',
    'color.chart.green.boldest': '--ds-chart-green-boldest',
    'color.chart.green.boldest.hovered': '--ds-chart-green-boldest-hovered',
    'color.chart.teal.bold': '--ds-chart-teal-bold',
    'color.chart.teal.bold.hovered': '--ds-chart-teal-bold-hovered',
    'color.chart.teal.bolder': '--ds-chart-teal-bolder',
    'color.chart.teal.bolder.hovered': '--ds-chart-teal-bolder-hovered',
    'color.chart.teal.boldest': '--ds-chart-teal-boldest',
    'color.chart.teal.boldest.hovered': '--ds-chart-teal-boldest-hovered',
    'color.chart.blue.bold': '--ds-chart-blue-bold',
    'color.chart.blue.bold.hovered': '--ds-chart-blue-bold-hovered',
    'color.chart.blue.bolder': '--ds-chart-blue-bolder',
    'color.chart.blue.bolder.hovered': '--ds-chart-blue-bolder-hovered',
    'color.chart.blue.boldest': '--ds-chart-blue-boldest',
    'color.chart.blue.boldest.hovered': '--ds-chart-blue-boldest-hovered',
    'color.chart.purple.bold': '--ds-chart-purple-bold',
    'color.chart.purple.bold.hovered': '--ds-chart-purple-bold-hovered',
    'color.chart.purple.bolder': '--ds-chart-purple-bolder',
    'color.chart.purple.bolder.hovered': '--ds-chart-purple-bolder-hovered',
    'color.chart.purple.boldest': '--ds-chart-purple-boldest',
    'color.chart.purple.boldest.hovered': '--ds-chart-purple-boldest-hovered',
    'color.chart.magenta.bold': '--ds-chart-magenta-bold',
    'color.chart.magenta.bold.hovered': '--ds-chart-magenta-bold-hovered',
    'color.chart.magenta.bolder': '--ds-chart-magenta-bolder',
    'color.chart.magenta.bolder.hovered': '--ds-chart-magenta-bolder-hovered',
    'color.chart.magenta.boldest': '--ds-chart-magenta-boldest',
    'color.chart.magenta.boldest.hovered': '--ds-chart-magenta-boldest-hovered',
    'color.chart.gray.bold': '--ds-chart-gray-bold',
    'color.chart.gray.bold.hovered': '--ds-chart-gray-bold-hovered',
    'color.chart.gray.bolder': '--ds-chart-gray-bolder',
    'color.chart.gray.bolder.hovered': '--ds-chart-gray-bolder-hovered',
    'color.chart.gray.boldest': '--ds-chart-gray-boldest',
    'color.chart.gray.boldest.hovered': '--ds-chart-gray-boldest-hovered',
    'color.chart.brand': '--ds-chart-brand',
    'color.chart.brand.hovered': '--ds-chart-brand-hovered',
    'color.chart.danger': '--ds-chart-danger',
    'color.chart.danger.hovered': '--ds-chart-danger-hovered',
    'color.chart.danger.bold': '--ds-chart-danger-bold',
    'color.chart.danger.bold.hovered': '--ds-chart-danger-bold-hovered',
    'color.chart.warning': '--ds-chart-warning',
    'color.chart.warning.hovered': '--ds-chart-warning-hovered',
    'color.chart.warning.bold': '--ds-chart-warning-bold',
    'color.chart.warning.bold.hovered': '--ds-chart-warning-bold-hovered',
    'color.chart.success': '--ds-chart-success',
    'color.chart.success.hovered': '--ds-chart-success-hovered',
    'color.chart.success.bold': '--ds-chart-success-bold',
    'color.chart.success.bold.hovered': '--ds-chart-success-bold-hovered',
    'color.chart.discovery': '--ds-chart-discovery',
    'color.chart.discovery.hovered': '--ds-chart-discovery-hovered',
    'color.chart.discovery.bold': '--ds-chart-discovery-bold',
    'color.chart.discovery.bold.hovered': '--ds-chart-discovery-bold-hovered',
    'color.chart.information': '--ds-chart-information',
    'color.chart.information.hovered': '--ds-chart-information-hovered',
    'color.chart.information.bold': '--ds-chart-information-bold',
    'color.chart.information.bold.hovered': '--ds-chart-information-bold-hovered',
    'elevation.surface': '--ds-surface',
    'elevation.surface.hovered': '--ds-surface-hovered',
    'elevation.surface.pressed': '--ds-surface-pressed',
    'elevation.surface.overlay': '--ds-surface-overlay',
    'elevation.surface.overlay.hovered': '--ds-surface-overlay-hovered',
    'elevation.surface.overlay.pressed': '--ds-surface-overlay-pressed',
    'elevation.surface.raised': '--ds-surface-raised',
    'elevation.surface.raised.hovered': '--ds-surface-raised-hovered',
    'elevation.surface.raised.pressed': '--ds-surface-raised-pressed',
    'elevation.surface.sunken': '--ds-surface-sunken',
    'elevation.shadow.overflow': '--ds-shadow-overflow',
    'elevation.shadow.overflow.perimeter': '--ds-shadow-overflow-perimeter',
    'elevation.shadow.overflow.spread': '--ds-shadow-overflow-spread',
    'elevation.shadow.overlay': '--ds-shadow-overlay',
    'elevation.shadow.raised': '--ds-shadow-raised',
    'opacity.disabled': '--ds-opacity-disabled',
    'opacity.loading': '--ds-opacity-loading',
    'utility.UNSAFE.textTransformUppercase': '--ds-UNSAFE-textTransformUppercase',
    'utility.UNSAFE.transparent': '--ds-UNSAFE-transparent',
    'utility.elevation.surface.current': '--ds-elevation-surface-current',
    'space.0': '--ds-space-0',
    'space.025': '--ds-space-025',
    'space.050': '--ds-space-050',
    'space.075': '--ds-space-075',
    'space.100': '--ds-space-100',
    'space.150': '--ds-space-150',
    'space.200': '--ds-space-200',
    'space.250': '--ds-space-250',
    'space.300': '--ds-space-300',
    'space.400': '--ds-space-400',
    'space.500': '--ds-space-500',
    'space.600': '--ds-space-600',
    'space.800': '--ds-space-800',
    'space.1000': '--ds-space-1000',
    'space.negative.025': '--ds-space-negative-025',
    'space.negative.050': '--ds-space-negative-050',
    'space.negative.075': '--ds-space-negative-075',
    'space.negative.100': '--ds-space-negative-100',
    'space.negative.150': '--ds-space-negative-150',
    'space.negative.200': '--ds-space-negative-200',
    'space.negative.250': '--ds-space-negative-250',
    'space.negative.300': '--ds-space-negative-300',
    'space.negative.400': '--ds-space-negative-400',
    'font.heading.xxlarge': '--ds-font-heading-xxlarge',
    'font.heading.xlarge': '--ds-font-heading-xlarge',
    'font.heading.large': '--ds-font-heading-large',
    'font.heading.medium': '--ds-font-heading-medium',
    'font.heading.small': '--ds-font-heading-small',
    'font.heading.xsmall': '--ds-font-heading-xsmall',
    'font.heading.xxsmall': '--ds-font-heading-xxsmall',
    'font.body.large': '--ds-font-body-large',
    'font.body': '--ds-font-body',
    'font.body.small': '--ds-font-body-small',
    'font.body.UNSAFE_small': '--ds-font-body-UNSAFE_small',
    'font.metric.large': '--ds-font-metric-large',
    'font.metric.medium': '--ds-font-metric-medium',
    'font.metric.small': '--ds-font-metric-small',
    'font.code': '--ds-font-code',
    'font.weight.regular': '--ds-font-weight-regular',
    'font.weight.medium': '--ds-font-weight-medium',
    'font.weight.semibold': '--ds-font-weight-semibold',
    'font.weight.bold': '--ds-font-weight-bold',
    'font.family.heading': '--ds-font-family-heading',
    'font.family.body': '--ds-font-family-body',
    'font.family.code': '--ds-font-family-code',
    'font.family.brand.heading': '--ds-font-family-brand-heading',
    'font.family.brand.body': '--ds-font-family-brand-body',
    'radius.xsmall': '--ds-radius-xsmall',
    'radius.small': '--ds-radius-small',
    'radius.medium': '--ds-radius-medium',
    'radius.large': '--ds-radius-large',
    'radius.xlarge': '--ds-radius-xlarge',
    'radius.xxlarge': '--ds-radius-xxlarge',
    'radius.full': '--ds-radius-full',
    'radius.tile': '--ds-radius-tile',
    'border.width': '--ds-border-width',
    'border.width.selected': '--ds-border-width-selected',
    'border.width.focused': '--ds-border-width-focused'
};
var $36f109edfb21e392$export$2e2bcd8739ae039 = $36f109edfb21e392$var$tokens;

});





parcelRegister("3s4hn", function(module, exports) {
$parcel$export(module.exports, "compose", () => $28374e629f0028ec$export$f672e0b6f7222cd7);
/** Helper type for single arg function */ /**
 * Compose 1 to n functions.
 * @param func first function
 * @param funcs additional functions
 */ function $28374e629f0028ec$export$f672e0b6f7222cd7(func) {
    for(var _len = arguments.length, funcs = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)funcs[_key - 1] = arguments[_key];
    var allFuncs = [
        func
    ].concat(funcs);
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return function composed(raw) {
        return allFuncs.reduceRight(function(memo, func) {
            return func(memo);
        }, raw);
    };
}

});

parcelRegister("il4RY", function(module, exports) {
$parcel$export(module.exports, "getColumnWidths", () => $d59df72c0fedc43c$export$e54c9225ca52acc);
$parcel$export(module.exports, "hasMergedCell", () => $d59df72c0fedc43c$export$f9d610bfbb78949b);
$parcel$export(module.exports, "convertProsemirrorTableNodeToArrayOfRows", () => $d59df72c0fedc43c$export$69fbfaf01f2fd534);

var $fC8ib = parcelRequire("fC8ib");
function $d59df72c0fedc43c$export$e54c9225ca52acc(node) {
    var tableColumnWidths = [];
    node.forEach(function(row) {
        var currentTableWidth = [];
        row.forEach(function(cell) {
            var _ref = cell.attrs, colspan = _ref.colspan, colwidth = _ref.colwidth;
            // column has been resized, colWidth will be an array, can safely take values even if cell is merged
            if (Array.isArray(colwidth)) currentTableWidth.push.apply(currentTableWidth, (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(colwidth));
            else if (colspan !== undefined && colspan > 1) currentTableWidth.push.apply(currentTableWidth, (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(Array(colspan).fill(0)));
            else currentTableWidth.push(0);
        });
        if (currentTableWidth.length > tableColumnWidths.length) tableColumnWidths = currentTableWidth;
    });
    return tableColumnWidths;
}
function $d59df72c0fedc43c$export$98951d3cdcfd364b(node) {
    var firstRow = node.firstChild;
    var tableColumnWidths = [];
    if (firstRow) firstRow.forEach(function(cell) {
        var _cell$attrs = cell.attrs, colspan = _cell$attrs.colspan, colwidth = _cell$attrs.colwidth;
        // column has been resized, colWidth will be an array, can safely take values even if cell is merged
        if (Array.isArray(colwidth)) tableColumnWidths.push.apply(tableColumnWidths, (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(colwidth));
        else if (colspan > 1) tableColumnWidths.push.apply(tableColumnWidths, (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(Array(colspan).fill(0)));
        else tableColumnWidths.push(0);
    });
    return tableColumnWidths;
}
function $d59df72c0fedc43c$export$f9d610bfbb78949b(tableNode) {
    var hasSpan = false;
    tableNode.descendants(function(node) {
        if (node.type.name === 'tableRow') return true;
        var _node$attrs = node.attrs, colspan = _node$attrs.colspan, rowspan = _node$attrs.rowspan;
        if (colspan > 1 || rowspan > 1) hasSpan = true;
        return false;
    });
    return hasSpan;
}
function $d59df72c0fedc43c$export$69fbfaf01f2fd534(tableNode) {
    var result = [];
    tableNode.forEach(function(rowNode) {
        if (rowNode.type.name === 'tableRow') {
            var row = [];
            rowNode.forEach(function(n) {
                return row.push(n);
            });
            result.push(row);
        }
    });
    return result;
}
function $d59df72c0fedc43c$export$889a8e446452be16(pos, schema, direction) {
    if (!schema.nodes.tableRow) return false;
    var doc = pos.doc;
    var resolved = pos;
    var sibling = direction === 'before' ? 'nodeBefore' : 'nodeAfter';
    while(resolved.depth > 0){
        var _resolved$sibling;
        var siblingType = (_resolved$sibling = resolved[sibling]) === null || _resolved$sibling === void 0 ? void 0 : _resolved$sibling.type;
        if (siblingType === schema.nodes.tableRow) return true;
        resolved = doc.resolve(resolved[direction]());
    }
    return false;
}

});

parcelRegister("1fkTi", function(module, exports) {
$parcel$export(module.exports, "createCompareNodes", () => $0e8765a50c144ac1$export$49215374a8bec29c);

var $iYJcE = parcelRequire("iYJcE");

var $9Zzpd = parcelRequire("9Zzpd");

var $gmeX4 = parcelRequire("gmeX4");
var $0e8765a50c144ac1$export$e2e108cbe2e4f865 = /*#__PURE__*/ function(ContentType) {
    ContentType[ContentType["NUMBER"] = 0] = "NUMBER";
    ContentType[ContentType["TEXT"] = 5] = "TEXT";
    ContentType[ContentType["MENTION"] = 10] = "MENTION";
    ContentType[ContentType["DATE"] = 15] = "DATE";
    ContentType[ContentType["STATUS"] = 20] = "STATUS";
    ContentType[ContentType["LINK"] = 25] = "LINK";
    return ContentType;
}({});
function $0e8765a50c144ac1$var$getLinkMark(node) {
    var _node$marks$filter = node.marks.filter(function(mark) {
        return mark.type.name === 'link';
    }), _node$marks$filter2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_node$marks$filter, 1), linkMark = _node$marks$filter2[0];
    return linkMark || null;
}
function $0e8765a50c144ac1$var$parseLocaleNumber(stringNumber, groupPattern, fractionPattern) {
    if (!stringNumber.trim().length) return null;
    var maybeANumber = Number.parseFloat(stringNumber.replace(groupPattern, '').replace(fractionPattern, '.'));
    if (Number.isNaN(maybeANumber)) return null;
    return maybeANumber;
}
function $0e8765a50c144ac1$export$8ebf986086b1866f() {
    // Source: https://stackoverflow.com/questions/12004808/does-javascript-take-local-decimal-separators-into-account
    var locale = window.navigator.language;
    var thousandSeparator = Intl.NumberFormat(locale).format(11111)// @ts-ignore - TS1501 TypeScript 5.9.2 upgrade
    .replace(/(?:[0-9\xB2\xB3\xB9\xBC-\xBE\u0660-\u0669\u06F0-\u06F9\u07C0-\u07C9\u0966-\u096F\u09E6-\u09EF\u09F4-\u09F9\u0A66-\u0A6F\u0AE6-\u0AEF\u0B66-\u0B6F\u0B72-\u0B77\u0BE6-\u0BF2\u0C66-\u0C6F\u0C78-\u0C7E\u0CE6-\u0CEF\u0D58-\u0D5E\u0D66-\u0D78\u0DE6-\u0DEF\u0E50-\u0E59\u0ED0-\u0ED9\u0F20-\u0F33\u1040-\u1049\u1090-\u1099\u1369-\u137C\u16EE-\u16F0\u17E0-\u17E9\u17F0-\u17F9\u1810-\u1819\u1946-\u194F\u19D0-\u19DA\u1A80-\u1A89\u1A90-\u1A99\u1B50-\u1B59\u1BB0-\u1BB9\u1C40-\u1C49\u1C50-\u1C59\u2070\u2074-\u2079\u2080-\u2089\u2150-\u2182\u2185-\u2189\u2460-\u249B\u24EA-\u24FF\u2776-\u2793\u2CFD\u3007\u3021-\u3029\u3038-\u303A\u3192-\u3195\u3220-\u3229\u3248-\u324F\u3251-\u325F\u3280-\u3289\u32B1-\u32BF\uA620-\uA629\uA6E6-\uA6EF\uA830-\uA835\uA8D0-\uA8D9\uA900-\uA909\uA9D0-\uA9D9\uA9F0-\uA9F9\uAA50-\uAA59\uABF0-\uABF9\uFF10-\uFF19]|\uD800[\uDD07-\uDD33\uDD40-\uDD78\uDD8A\uDD8B\uDEE1-\uDEFB\uDF20-\uDF23\uDF41\uDF4A\uDFD1-\uDFD5]|\uD801[\uDCA0-\uDCA9]|\uD802[\uDC58-\uDC5F\uDC79-\uDC7F\uDCA7-\uDCAF\uDCFB-\uDCFF\uDD16-\uDD1B\uDDBC\uDDBD\uDDC0-\uDDCF\uDDD2-\uDDFF\uDE40-\uDE48\uDE7D\uDE7E\uDE9D-\uDE9F\uDEEB-\uDEEF\uDF58-\uDF5F\uDF78-\uDF7F\uDFA9-\uDFAF]|\uD803[\uDCFA-\uDCFF\uDD30-\uDD39\uDD40-\uDD49\uDE60-\uDE7E\uDF1D-\uDF26\uDF51-\uDF54\uDFC5-\uDFCB]|\uD804[\uDC52-\uDC6F\uDCF0-\uDCF9\uDD36-\uDD3F\uDDD0-\uDDD9\uDDE1-\uDDF4\uDEF0-\uDEF9]|\uD805[\uDC50-\uDC59\uDCD0-\uDCD9\uDE50-\uDE59\uDEC0-\uDEC9\uDED0-\uDEE3\uDF30-\uDF3B]|\uD806[\uDCE0-\uDCF2\uDD50-\uDD59\uDFF0-\uDFF9]|\uD807[\uDC50-\uDC6C\uDD50-\uDD59\uDDA0-\uDDA9\uDDE0-\uDDE9\uDF50-\uDF59\uDFC0-\uDFD4]|\uD809[\uDC00-\uDC6E]|\uD818[\uDD30-\uDD39]|\uD81A[\uDE60-\uDE69\uDEC0-\uDEC9\uDF50-\uDF59\uDF5B-\uDF61]|\uD81B[\uDD70-\uDD79\uDE80-\uDE96\uDFF4-\uDFF6]|\uD833[\uDCF0-\uDCF9]|\uD834[\uDEC0-\uDED3\uDEE0-\uDEF3\uDF60-\uDF78]|\uD835[\uDFCE-\uDFFF]|\uD838[\uDD40-\uDD49\uDEF0-\uDEF9]|\uD839[\uDCF0-\uDCF9\uDDF1-\uDDFA]|\uD83A[\uDCC7-\uDCCF\uDD50-\uDD59]|\uD83B[\uDC71-\uDCAB\uDCAD-\uDCAF\uDCB1-\uDCB4\uDD01-\uDD2D\uDD2F-\uDD3D]|\uD83C[\uDD00-\uDD0C]|\uD83E[\uDFF0-\uDFF9])/g, '');
    var decimalSeparator = Intl.NumberFormat(locale).format(1.1)// @ts-ignore - TS1501 TypeScript 5.9.2 upgrade
    .replace(/(?:[0-9\xB2\xB3\xB9\xBC-\xBE\u0660-\u0669\u06F0-\u06F9\u07C0-\u07C9\u0966-\u096F\u09E6-\u09EF\u09F4-\u09F9\u0A66-\u0A6F\u0AE6-\u0AEF\u0B66-\u0B6F\u0B72-\u0B77\u0BE6-\u0BF2\u0C66-\u0C6F\u0C78-\u0C7E\u0CE6-\u0CEF\u0D58-\u0D5E\u0D66-\u0D78\u0DE6-\u0DEF\u0E50-\u0E59\u0ED0-\u0ED9\u0F20-\u0F33\u1040-\u1049\u1090-\u1099\u1369-\u137C\u16EE-\u16F0\u17E0-\u17E9\u17F0-\u17F9\u1810-\u1819\u1946-\u194F\u19D0-\u19DA\u1A80-\u1A89\u1A90-\u1A99\u1B50-\u1B59\u1BB0-\u1BB9\u1C40-\u1C49\u1C50-\u1C59\u2070\u2074-\u2079\u2080-\u2089\u2150-\u2182\u2185-\u2189\u2460-\u249B\u24EA-\u24FF\u2776-\u2793\u2CFD\u3007\u3021-\u3029\u3038-\u303A\u3192-\u3195\u3220-\u3229\u3248-\u324F\u3251-\u325F\u3280-\u3289\u32B1-\u32BF\uA620-\uA629\uA6E6-\uA6EF\uA830-\uA835\uA8D0-\uA8D9\uA900-\uA909\uA9D0-\uA9D9\uA9F0-\uA9F9\uAA50-\uAA59\uABF0-\uABF9\uFF10-\uFF19]|\uD800[\uDD07-\uDD33\uDD40-\uDD78\uDD8A\uDD8B\uDEE1-\uDEFB\uDF20-\uDF23\uDF41\uDF4A\uDFD1-\uDFD5]|\uD801[\uDCA0-\uDCA9]|\uD802[\uDC58-\uDC5F\uDC79-\uDC7F\uDCA7-\uDCAF\uDCFB-\uDCFF\uDD16-\uDD1B\uDDBC\uDDBD\uDDC0-\uDDCF\uDDD2-\uDDFF\uDE40-\uDE48\uDE7D\uDE7E\uDE9D-\uDE9F\uDEEB-\uDEEF\uDF58-\uDF5F\uDF78-\uDF7F\uDFA9-\uDFAF]|\uD803[\uDCFA-\uDCFF\uDD30-\uDD39\uDD40-\uDD49\uDE60-\uDE7E\uDF1D-\uDF26\uDF51-\uDF54\uDFC5-\uDFCB]|\uD804[\uDC52-\uDC6F\uDCF0-\uDCF9\uDD36-\uDD3F\uDDD0-\uDDD9\uDDE1-\uDDF4\uDEF0-\uDEF9]|\uD805[\uDC50-\uDC59\uDCD0-\uDCD9\uDE50-\uDE59\uDEC0-\uDEC9\uDED0-\uDEE3\uDF30-\uDF3B]|\uD806[\uDCE0-\uDCF2\uDD50-\uDD59\uDFF0-\uDFF9]|\uD807[\uDC50-\uDC6C\uDD50-\uDD59\uDDA0-\uDDA9\uDDE0-\uDDE9\uDF50-\uDF59\uDFC0-\uDFD4]|\uD809[\uDC00-\uDC6E]|\uD818[\uDD30-\uDD39]|\uD81A[\uDE60-\uDE69\uDEC0-\uDEC9\uDF50-\uDF59\uDF5B-\uDF61]|\uD81B[\uDD70-\uDD79\uDE80-\uDE96\uDFF4-\uDFF6]|\uD833[\uDCF0-\uDCF9]|\uD834[\uDEC0-\uDED3\uDEE0-\uDEF3\uDF60-\uDF78]|\uD835[\uDFCE-\uDFFF]|\uD838[\uDD40-\uDD49\uDEF0-\uDEF9]|\uD839[\uDCF0-\uDCF9\uDDF1-\uDDFA]|\uD83A[\uDCC7-\uDCCF\uDD50-\uDD59]|\uD83B[\uDC71-\uDCAB\uDCAD-\uDCAF\uDCB1-\uDCB4\uDD01-\uDD2D\uDD2F-\uDD3D]|\uD83C[\uDD00-\uDD0C]|\uD83E[\uDFF0-\uDFF9])/g, '');
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    var numericPattern = new RegExp("(\\d+(?:[".concat(thousandSeparator).concat(decimalSeparator, "]?\\d+)*)"), 'g');
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    var thousandSeparatorPattern = new RegExp('\\' + thousandSeparator, 'g');
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    var decimalSeparatorPattern = new RegExp('\\' + decimalSeparator);
    return function(text) {
        if (!text.trim().length) return null;
        // This will break the text apart at the locations of the formatted numbers
        var result = text.split(numericPattern);
        // We then put the text back together but with all the formatted numbers converted back to plain numerals,
        // for example a sentence like "What is 1,000.01% of 10,000.01" would be normalized and sorted as
        // if it's saying "What is 1000.01% of 10000.01". This way the Intl.Collator can use the numeric setting to sort
        // numeral values within string correctly.
        var tokens = result.reduce(function(acc, stringNumber) {
            if (!(stringNumber !== null && stringNumber !== void 0 && stringNumber.length)) return acc;
            var maybeANumber = $0e8765a50c144ac1$var$parseLocaleNumber(stringNumber, thousandSeparatorPattern, decimalSeparatorPattern);
            // NOTE: We know there can only be a single decimal separator. So we can assume that if the first found separator
            // is not at the same position as the last found one, then we can assume the locale used to format the number
            // is different to our locale. This will result in the value being treated as a string.
            if (maybeANumber !== null && stringNumber.indexOf(decimalSeparator) === stringNumber.lastIndexOf(decimalSeparator)) acc.push(maybeANumber);
            else acc.push(stringNumber);
            return acc;
        }, []);
        if (tokens.length === 1) return tokens[0];
        return tokens.join('');
    };
}
function $0e8765a50c144ac1$export$7cc053f549ed70b8(textNode, normalizeTextParser) {
    // treat as a link if contain a link
    var linkMark = $0e8765a50c144ac1$var$getLinkMark(textNode);
    if (linkMark) {
        var value = textNode.text || '';
        return {
            type: $0e8765a50c144ac1$export$e2e108cbe2e4f865.LINK,
            value: value
        };
    }
    var text = textNode.text || '';
    var normalizedText = normalizeTextParser(text);
    if (typeof normalizedText === 'number') return {
        type: $0e8765a50c144ac1$export$e2e108cbe2e4f865.NUMBER,
        value: normalizedText
    };
    return {
        type: $0e8765a50c144ac1$export$e2e108cbe2e4f865.TEXT,
        value: normalizedText !== null && normalizedText !== void 0 ? normalizedText : text
    };
}
function $0e8765a50c144ac1$var$getMetaFromNode(node, options, normalizeTextParser) {
    if (!node) return null;
    var firstChild = node.firstChild;
    if (!firstChild) return null;
    switch(firstChild.type.name){
        // Text case
        /*
        Get Meta value from the first child if the cell is of type
          * Heading (Any cell where the text is set to a heading type)
          * Paragraph (Normal text)
       */ case 'heading':
        case 'paragraph':
            return $0e8765a50c144ac1$var$getMetaFromNode(firstChild, options, normalizeTextParser);
        case 'inlineCard':
            var attrs = firstChild.attrs;
            var maybeTitle = options.getInlineCardTextFromStore(attrs);
            if (maybeTitle) return {
                type: $0e8765a50c144ac1$export$e2e108cbe2e4f865.LINK,
                value: maybeTitle
            };
            var url = attrs.url;
            return {
                type: $0e8765a50c144ac1$export$e2e108cbe2e4f865.LINK,
                value: url ? url : ''
            };
        case 'text':
            return $0e8765a50c144ac1$export$7cc053f549ed70b8(firstChild, normalizeTextParser);
        case 'status':
            var _text = firstChild.attrs.text;
            return {
                type: $0e8765a50c144ac1$export$e2e108cbe2e4f865.STATUS,
                value: _text
            };
        case 'date':
            var timestamp = Number.parseInt(firstChild.attrs.timestamp, 20);
            return {
                type: $0e8765a50c144ac1$export$e2e108cbe2e4f865.DATE,
                value: timestamp
            };
        case 'mention':
            var _text2 = firstChild.attrs.text || '';
            return {
                type: $0e8765a50c144ac1$export$e2e108cbe2e4f865.MENTION,
                value: _text2.toLowerCase()
            };
        default:
            return null;
    }
}
function $0e8765a50c144ac1$var$compareValue(valueA, valueB) {
    if (valueA === valueB) return 0;
    if (typeof valueA === 'string' && typeof valueB === 'string') return valueA.localeCompare(valueB, window.navigator.language, {
        caseFirst: 'upper',
        numeric: true
    });
    return valueA > valueB ? 1 : -1;
}
var $0e8765a50c144ac1$export$49215374a8bec29c = function createCompareNodes(options) {
    var order = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (0, $gmeX4.SortOrder).ASC;
    var normalizeTextParser = $0e8765a50c144ac1$export$8ebf986086b1866f();
    return function(nodeA, nodeB) {
        var metaNodeA = $0e8765a50c144ac1$var$getMetaFromNode(nodeA, options, normalizeTextParser);
        var metaNodeB = $0e8765a50c144ac1$var$getMetaFromNode(nodeB, options, normalizeTextParser);
        /*
        Donot switch the order (Asec or Desc) if either node is null.
        This will ensure that empty cells are always at the bottom during sorting.
      */ if (metaNodeA === null || metaNodeB === null) return $0e8765a50c144ac1$var$compareMetaFromNode(metaNodeA, metaNodeB);
        return (order === (0, $gmeX4.SortOrder).DESC ? -1 : 1) * $0e8765a50c144ac1$var$compareMetaFromNode(metaNodeA, metaNodeB);
    };
};
function $0e8765a50c144ac1$var$compareMetaFromNode(metaNodeA, metaNodeB) {
    if (metaNodeA === metaNodeB) return 0;
    if (metaNodeA === null || metaNodeB === null) return metaNodeB === null ? -1 : 1;
    if ((0, $9Zzpd.fg)('platform_editor_fix_mixed_types_column_sort')) {
        if (metaNodeA.type === $0e8765a50c144ac1$export$e2e108cbe2e4f865.TEXT && metaNodeB.type === $0e8765a50c144ac1$export$e2e108cbe2e4f865.NUMBER || metaNodeA.type === $0e8765a50c144ac1$export$e2e108cbe2e4f865.NUMBER && metaNodeB.type === $0e8765a50c144ac1$export$e2e108cbe2e4f865.TEXT) return $0e8765a50c144ac1$var$compareValue(String(metaNodeA.value), String(metaNodeB.value));
    }
    if (metaNodeA.type !== metaNodeB.type) return metaNodeA.type > metaNodeB.type ? 1 : -1;
    return $0e8765a50c144ac1$var$compareValue(metaNodeA.value, metaNodeB.value);
}

});
parcelRegister("gmeX4", function(module, exports) {
$parcel$export(module.exports, "SortOrder", () => $be8a4c82821a90ef$export$7ae723045d45777a);
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $1xyIw = parcelRequire("1xyIw");


var $be8a4c82821a90ef$export$7ae723045d45777a = /*#__PURE__*/ function(SortOrder) {
    SortOrder["ASC"] = "asc";
    SortOrder["DESC"] = "desc";
    SortOrder["NO_ORDER"] = "no_order";
    return SortOrder;
}({});

});


parcelRegister("hrVpF", function(module, exports) {
$parcel$export(module.exports, "getTableContainerWidth", () => $cb417e52aeae7756$export$3930799be057b305);

var $fC8ib = parcelRequire("fC8ib");

var $4inI8 = parcelRequire("4inI8");

var $1LBcl = parcelRequire("1LBcl");

var $9Zzpd = parcelRequire("9Zzpd");

var $3jgn3 = parcelRequire("3jgn3");

var $2q0Pn = parcelRequire("2q0Pn");

var $fMtrl = parcelRequire("fMtrl");

var $2XMn4 = parcelRequire("2XMn4");
var $cb417e52aeae7756$var$GRID_SIZE = 8;
var $cb417e52aeae7756$var$NESTED_DND_GUTTER_OFFSET = 8;
var $cb417e52aeae7756$var$NESTED_DND_MARGIN_OFFSET = 12;
var $cb417e52aeae7756$export$9b77d38feba5446 = {
    // eslint-disable-next-line @atlaskit/editor/no-re-export
    default: (0, $1LBcl.akEditorDefaultLayoutWidth),
    // eslint-disable-next-line @atlaskit/editor/no-re-export
    wide: (0, $1LBcl.akEditorWideLayoutWidth),
    // eslint-disable-next-line @atlaskit/editor/no-re-export
    'full-width': (0, $1LBcl.akEditorFullWidthLayoutWidth)
};
var $cb417e52aeae7756$export$d76cc081ce1449a8 = function getParentNodeWidth(pos, state, containerWidth, isFullWidthModeEnabled) {
    var _contextPanelPluginKe, _contextPanelPluginKe2;
    if (!pos) return;
    var node = $cb417e52aeae7756$var$getNestedParentNode(pos, state);
    if (!node) return;
    var layout = node.attrs.layout || 'default';
    var schema = state.schema;
    var breakoutMark = schema.marks.breakout && schema.marks.breakout.isInSet(node.marks);
    if (breakoutMark && breakoutMark.attrs.mode) layout = breakoutMark.attrs.mode;
    var breakoutWidth = breakoutMark ? breakoutMark.attrs.width : undefined;
    var parentWidth = $cb417e52aeae7756$var$calcBreakoutNodeWidth(layout, containerWidth, isFullWidthModeEnabled, breakoutWidth);
    // Please, do not copy or use this kind of code below
    // @ts-ignore
    var contextPanelPluginKey = {
        key: 'contextPanelPluginKey$',
        getState: function getState(state) {
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            return state['contextPanelPluginKey$'];
        }
    };
    switch(node.type){
        case schema.nodes.layoutSection:
            // Calculate width of parent layout column when
            // Parallel layout with viewport greater than 1024px
            // OR side panel of an extension is open and change the node width to smaller than containerWidth
            if (containerWidth.width > (0, $1LBcl.gridMediumMaxWidth) || ((_contextPanelPluginKe = contextPanelPluginKey.getState(state)) === null || _contextPanelPluginKe === void 0 ? void 0 : _contextPanelPluginKe.contents.length) > 0 && ((_contextPanelPluginKe2 = contextPanelPluginKey.getState(state)) === null || _contextPanelPluginKe2 === void 0 ? void 0 : _contextPanelPluginKe2.contents[0]) !== undefined) {
                // margin between sections
                parentWidth -= (0, $9Zzpd.fg)('platform_editor_nested_dnd_styles_changes') ? ((0, $2q0Pn.LAYOUT_SECTION_MARGIN) + $cb417e52aeae7756$var$NESTED_DND_MARGIN_OFFSET + 2) * (node.childCount - 1) : ((0, $2q0Pn.LAYOUT_SECTION_MARGIN) + 2) * (node.childCount - 1);
                var $pos = state.doc.resolve(pos);
                var column = (0, $4inI8.findParentNodeOfTypeClosestToPos)($pos, [
                    state.schema.nodes.layoutColumn
                ]);
                if (column && column.node && !isNaN(column.node.attrs.width)) // get exact width of parent layout column using node attrs
                parentWidth = Math.round(parentWidth * column.node.attrs.width * 0.01);
            }
            // account for the padding of the parent node
            parentWidth -= (0, $9Zzpd.fg)('platform_editor_nested_dnd_styles_changes') ? ((0, $2q0Pn.LAYOUT_COLUMN_PADDING) + $cb417e52aeae7756$var$NESTED_DND_GUTTER_OFFSET) * 2 : (0, $2q0Pn.LAYOUT_COLUMN_PADDING) * 2;
            break;
        case schema.nodes.bodiedExtension:
            parentWidth -= (0, $3jgn3.BODIED_EXT_PADDING) * 2;
            break;
        case schema.nodes.extensionFrame:
            parentWidth -= (0, $3jgn3.BODIED_EXT_PADDING) * 2;
            break;
        case schema.nodes.expand:
            // padding
            parentWidth -= $cb417e52aeae7756$var$GRID_SIZE * 2;
            // gutter offset
            parentWidth += $cb417e52aeae7756$var$GRID_SIZE * 3;
            // padding right
            parentWidth -= $cb417e52aeae7756$var$GRID_SIZE;
            // padding left
            parentWidth -= $cb417e52aeae7756$var$GRID_SIZE * 4 - $cb417e52aeae7756$var$GRID_SIZE / 2;
            break;
        case schema.nodes.tableCell:
        case schema.nodes.tableHeader:
            // Calculate the available column width
            if (Array.isArray(node.attrs.colwidth)) parentWidth = node.attrs.colwidth.slice(0, node.attrs.colspan).reduce(function(sum, width) {
                return sum + width;
            }, 0);
            // Compensate for padding
            parentWidth -= (0, $fMtrl.tableCellPadding) * 2;
            break;
    }
    parentWidth -= 2; // border
    return parentWidth;
};
var $cb417e52aeae7756$var$getNestedParentNode = function getNestedParentNode(tablePos, state) {
    if (tablePos === undefined) return null;
    var $pos = state.doc.resolve(tablePos);
    var parent = (0, $4inI8.findParentNodeOfTypeClosestToPos)($pos, [
        state.schema.nodes.bodiedExtension,
        state.schema.nodes.extensionFrame,
        state.schema.nodes.layoutSection,
        state.schema.nodes.expand,
        state.schema.nodes.tableCell,
        state.schema.nodes.tableHeader
    ].concat((0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))((0, $9Zzpd.fg)('platform_synced_block_patch_8') ? [
        state.schema.nodes.bodiedSyncBlock
    ] : [])));
    return parent ? parent.node : null;
};
var $cb417e52aeae7756$var$calcBreakoutNodeWidth = function calcBreakoutNodeWidth(layout, containerWidth, isFullWidthModeEnabled, breakoutWidth) {
    if (breakoutWidth) return isFullWidthModeEnabled ? Math.min(containerWidth.lineLength, breakoutWidth) : // container width minus breakout padding
    // --ak-editor--breakout-full-page-guttering-padding = (--ak-editor--large-gutter-padding * 2) + --ak-editor--default-gutter-padding
    Math.min(containerWidth.width - ((0, $1LBcl.akEditorGutterPaddingDynamic)() * 2 + (0, $1LBcl.akEditorGutterPadding)), breakoutWidth);
    return isFullWidthModeEnabled ? Math.min(containerWidth.lineLength, (0, $1LBcl.akEditorFullWidthLayoutWidth)) : (0, $2XMn4.absoluteBreakoutWidth)(layout, containerWidth.width);
};
var $cb417e52aeae7756$export$3930799be057b305 = function getTableContainerWidth(node) {
    if (node !== null && node !== void 0 && node.attrs.width) return node.attrs.width;
    return $cb417e52aeae7756$export$9b77d38feba5446[node === null || node === void 0 ? void 0 : node.attrs.layout] || (0, $1LBcl.akEditorDefaultLayoutWidth);
};
var $cb417e52aeae7756$export$9724081a0d43786a = function getTableWidthWithNumberColumn(node, offset) {
    var isNumberColumnEnabled = node.attrs.isNumberColumnEnabled;
    if (isNumberColumnEnabled && offset > 0) return $cb417e52aeae7756$export$3930799be057b305(node) - offset;
    return $cb417e52aeae7756$export$3930799be057b305(node);
};

});
parcelRegister("3jgn3", function(module, exports) {
$parcel$export(module.exports, "BODIED_EXT_PADDING", () => $268fd85975958ef1$export$5ac5087fe1217160);
var $268fd85975958ef1$export$f5ecdce4c60ff98b = 8;
var $268fd85975958ef1$export$5ac5087fe1217160 = $268fd85975958ef1$export$f5ecdce4c60ff98b * 2;
var $268fd85975958ef1$export$91624ec52c59c24c = 12;

});

parcelRegister("2q0Pn", function(module, exports) {
$parcel$export(module.exports, "LAYOUT_SECTION_MARGIN", () => $1c2ea6dac5ad5bac$export$cd04f19842abff0);
$parcel$export(module.exports, "LAYOUT_COLUMN_PADDING", () => $1c2ea6dac5ad5bac$export$a1bb91aa2d5fcce8);
var $1c2ea6dac5ad5bac$export$cd04f19842abff0 = 8;
var $1c2ea6dac5ad5bac$export$a1bb91aa2d5fcce8 = $1c2ea6dac5ad5bac$export$cd04f19842abff0 * 1.5;
var $1c2ea6dac5ad5bac$export$e5ee675b2c7e739b = 50;

});


parcelRegister("13ECD", function(module, exports) {
$parcel$export(module.exports, "FullPagePadding", () => $0c5594f72c7837da$export$12fd658e5eef0d79);
$parcel$export(module.exports, "TELEPOINTER_ID", () => $0c5594f72c7837da$export$74b525449cc7cbd1);
var $0c5594f72c7837da$export$12fd658e5eef0d79 = 32;
var $0c5594f72c7837da$export$74b525449cc7cbd1 = 'ai-streaming-telepointer';

});

parcelRegister("65d1I", function(module, exports) {
$parcel$export(module.exports, "TableHeader", () => $46dd508ed67d6196$export$f850895b287ef28e);
$parcel$export(module.exports, "TableCell", () => $46dd508ed67d6196$export$1e4baea7053fc0e3);

var $kqp0i = parcelRequire("kqp0i");

var $5FkrB = parcelRequire("5FkrB");

var $gwjAb = parcelRequire("gwjAb");
var $gc8Zd = parcelRequire("gc8Zd");

var $jLsC1 = parcelRequire("jLsC1");

var $gmeX4 = parcelRequire("gmeX4");

var $b6T7g = parcelRequire("b6T7g");

var $blliI = parcelRequire("blliI");

var $aP6HU = parcelRequire("aP6HU");

var $jJH6F = parcelRequire("jJH6F");

var $53SBn = parcelRequire("53SBn");

var $6Wx3K = parcelRequire("6Wx3K");

var $3cXxO = parcelRequire("3cXxO");
var $46dd508ed67d6196$var$IgnoreSorting = [
    'LABEL',
    'INPUT'
];
var $46dd508ed67d6196$var$nextStatusOrder = function nextStatusOrder(currentSortOrder) {
    switch(currentSortOrder){
        case (0, $gmeX4.SortOrder).NO_ORDER:
            return (0, $gmeX4.SortOrder).ASC;
        case (0, $gmeX4.SortOrder).ASC:
            return (0, $gmeX4.SortOrder).DESC;
        case (0, $gmeX4.SortOrder).DESC:
            return (0, $gmeX4.SortOrder).NO_ORDER;
    }
    return (0, $gmeX4.SortOrder).NO_ORDER;
};
var $46dd508ed67d6196$var$getSortOrderLabel = function getSortOrderLabel(intl, currentSortOrder) {
    var noneSortingLabel = (0, $3cXxO.tableCellMessages).noneSortingLabel, ascSortingLabel = (0, $3cXxO.tableCellMessages).ascSortingLabel, descSortingLabel = (0, $3cXxO.tableCellMessages).descSortingLabel;
    switch(currentSortOrder){
        case (0, $gmeX4.SortOrder).NO_ORDER:
            return intl.formatMessage(noneSortingLabel);
        case (0, $gmeX4.SortOrder).ASC:
            return intl.formatMessage(ascSortingLabel);
        case (0, $gmeX4.SortOrder).DESC:
            return intl.formatMessage(descSortingLabel);
        default:
            return intl.formatMessage(noneSortingLabel);
    }
};
// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
var $46dd508ed67d6196$var$getDataAttributes = function getDataAttributes(colwidth, background) {
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var attrs = {};
    if (colwidth) attrs['data-colwidth'] = colwidth.join(',');
    /**
   * Storing hex code in data-cell-background because
   *  we want to have DST token (css variable) or
   *  DST token value (value (hex code) of css variable) in
   *  inline style to correct render table cell background
   *  based on selected theme.
   * Currently we rely on background color hex code stored in
   *  inline style.
   * Because of that when we copy and paste table, we end up
   *  having DST token or DST token value in ADF instead of
   *  original hex code which we map to DST token.
   * So, introducing data-cell-background.
   * More details at https://product-fabric.atlassian.net/wiki/spaces/EUXQ/pages/3472556903/Tokenising+tableCell+background+colors#Update-toDom-and-parseDom-to-store-and-read-background-color-from-data-cell-background-attribute.4
   */ if (background) attrs['data-cell-background'] = background;
    return attrs;
};
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
var $46dd508ed67d6196$var$cssVariablePattern = /^var\(--.*\)$/;
var $46dd508ed67d6196$var$getStyle = function getStyle(_ref) {
    var background = _ref.background, colGroupWidth = _ref.colGroupWidth, offsetTop = _ref.offsetTop, colorMode = _ref.colorMode;
    var style = {};
    if (background && // ignore setting inline styles if ds neutral token is detected
    !background.includes('--ds-background-neutral')) {
        /**
     * The Editor supports users pasting content from external sources with custom table cell backgrounds and having those
     * backgrounds persisted.
     *
     * This feature predates the introduction of dark mode.
     *
     * Without the inversion logic below, tokenised content (ie. text), can be hard to read when the user loads the page in dark mode.
     *
     * This introduces inversion of the presentation of the custom background color when the user is in dark mode.
     *
     * This can be done without additional changes to account for users copying and pasting content inside the Editor, because of
     * how we detect table cell background colors copied from external editor sources. Where we load the background color from a
     * seperate attribute (data-cell-background), instead of the inline style.
     *
     * See the following document for more details on this behaviour
     * https://hello.atlassian.net/wiki/spaces/CCECO/pages/2892247168/Unsupported+custom+table+cell+background+colors+in+dark+theme+Editor+Job+Story
     */ var tokenColor = (0, $b6T7g.hexToEditorBackgroundPaletteRawValue)(background);
        if (tokenColor) style.backgroundColor = tokenColor;
        else if (/**
     * There was previously a bug in dark mode where we would attempt to invert
     * a design token in `getDarkModeLCHColor` causing issues.
     * If it's a design token we should return it as is.
     */ $46dd508ed67d6196$var$cssVariablePattern.test(background)) style.backgroundColor = background;
        else // if we have a custom color, we need to check if we are in dark mode
        if (colorMode === 'dark') // if we are in dark mode, we need to invert the color
        style.backgroundColor = (0, $gwjAb.getDarkModeLCHColor)(background);
        else // if we are in light mode, we can just set the color
        style.backgroundColor = background;
    }
    if (colGroupWidth) {
        style.width = colGroupWidth;
        style.minWidth = colGroupWidth;
    }
    if (offsetTop !== undefined) style.top = offsetTop;
    return style;
};
var $46dd508ed67d6196$var$getWithCellProps = function getWithCellProps(WrapperComponent) {
    return function WithCellProps(props) {
        var _useThemeObserver = (0, $jLsC1.default)(), colorMode = _useThemeObserver.colorMode;
        var children = props.children, className = props.className, onClick = props.onClick, colwidth = props.colwidth, colGroupWidth = props.colGroupWidth, rowspan = props.rowspan, colspan = props.colspan, background = props.background, offsetTop = props.offsetTop, ariaSort = props.ariaSort;
        // This is used to set the background color of the cell
        // to a dark mode color in mobile dark mode
        var colorName = background ? (0, $gc8Zd.tableBackgroundColorPalette).get(background) : '';
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(WrapperComponent, (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
            rowSpan: rowspan,
            colSpan: colspan,
            style: $46dd508ed67d6196$var$getStyle({
                background: background,
                colGroupWidth: colGroupWidth,
                offsetTop: offsetTop,
                colorMode: colorMode
            }),
            colorname: colorName,
            onClick: onClick,
            className: className
        }, $46dd508ed67d6196$var$getDataAttributes(colwidth, background), {
            "aria-sort": ariaSort
        }), children);
    };
};
var $46dd508ed67d6196$var$TH = $46dd508ed67d6196$var$getWithCellProps('th');
var $46dd508ed67d6196$export$cfca40ca5c56a38e = function withSortableColumn(WrapperComponent) {
    return function THWithSortableColumn(props) {
        var intl = (0, $6Wx3K.default)();
        var allowColumnSorting = props.allowColumnSorting, onSorting = props.onSorting, children = props.children, sortOrdered = props.sortOrdered, isHeaderRow = props.isHeaderRow;
        var sortOrderedClassName = sortOrdered === (0, $gmeX4.SortOrder).NO_ORDER ? (0, $53SBn.RendererCssClassName).SORTABLE_COLUMN_NO_ORDER : '';
        if (!allowColumnSorting || !isHeaderRow) // Ignored via go/ees005
        // eslint-disable-next-line react/jsx-props-no-spreading
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(WrapperComponent, props);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(WrapperComponent, (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, props, {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: (0, $53SBn.RendererCssClassName).SORTABLE_COLUMN_WRAPPER,
            ariaSort: $46dd508ed67d6196$var$getSortOrderLabel(intl, sortOrdered)
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("div", {
            className: (0, $53SBn.RendererCssClassName).SORTABLE_COLUMN
        }, children, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("figure", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: "".concat((0, $53SBn.RendererCssClassName).SORTABLE_COLUMN_ICON_WRAPPER, " ").concat(sortOrderedClassName)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $blliI.default), {
            isSortingAllowed: !!onSorting,
            sortOrdered: sortOrdered,
            onClick: sort,
            onKeyDown: onKeyPress
        }))));
        function onKeyPress(event) {
            var keys = [
                ' ',
                'Enter',
                'Spacebar'
            ];
            // Ignored via go/ees005
            // eslint-disable-next-line @atlaskit/editor/no-as-casting
            var _ref2 = event.target, tagName = _ref2.tagName;
            // trigger sorting if space or enter are clicked but not when in an input field (template variables)
            if (keys.includes(event.key) && !$46dd508ed67d6196$var$IgnoreSorting.includes(tagName)) {
                event.preventDefault();
                sort();
            }
        }
        function sort() {
            var fireAnalyticsEvent = props.fireAnalyticsEvent, onSorting = props.onSorting, columnIndex = props.columnIndex, sortOrdered = props.sortOrdered;
            if (onSorting && columnIndex != null) {
                var sortOrder = $46dd508ed67d6196$var$nextStatusOrder(sortOrdered);
                onSorting(columnIndex, sortOrder);
                fireAnalyticsEvent && fireAnalyticsEvent({
                    action: (0, $jJH6F.ACTION).SORT_COLUMN,
                    actionSubject: (0, $jJH6F.ACTION_SUBJECT).TABLE,
                    attributes: {
                        platform: (0, $aP6HU.PLATFORM).WEB,
                        mode: (0, $aP6HU.MODE).RENDERER,
                        columnIndex: columnIndex,
                        sortOrder: sortOrder
                    },
                    eventType: (0, $jJH6F.EVENT_TYPE).TRACK
                });
            } else fireAnalyticsEvent && fireAnalyticsEvent({
                action: (0, $jJH6F.ACTION).SORT_COLUMN_NOT_ALLOWED,
                actionSubject: (0, $jJH6F.ACTION_SUBJECT).TABLE,
                attributes: {
                    platform: (0, $aP6HU.PLATFORM).WEB,
                    mode: (0, $aP6HU.MODE).RENDERER
                },
                eventType: (0, $jJH6F.EVENT_TYPE).TRACK
            });
        }
    };
};
var $46dd508ed67d6196$export$f850895b287ef28e = $46dd508ed67d6196$export$cfca40ca5c56a38e($46dd508ed67d6196$var$TH);
var $46dd508ed67d6196$var$TD = $46dd508ed67d6196$var$getWithCellProps('td');
var $46dd508ed67d6196$export$1e4baea7053fc0e3 = $46dd508ed67d6196$var$TD;

});
parcelRegister("jLsC1", function(module, exports) {
$parcel$export(module.exports, "default", () => $e63899ecc922e32c$export$2e2bcd8739ae039);

var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");

var $hQjaP = parcelRequire("hQjaP");

var $1Za0O = parcelRequire("1Za0O");
/**
 * A React hook which returns the current themes and color-mode set on `<html>`.
 *
 * @example
 * ```
 * const { colorMode, dark, light, spacing, typography } = useThemeObserver();
 *
 * // Performing side effects when it changes
 * useEffect(() => {
 *   console.log(`The color mode has changed to ${theme.colorMode}`);
 * }, [theme.colorMode]);
 * ```
 */ var $e63899ecc922e32c$var$useThemeObserver = function useThemeObserver() {
    var _useState = (0, $5FkrB.useState)((0, $hQjaP.default)()), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), theme = _useState2[0], setTheme = _useState2[1];
    (0, $5FkrB.useEffect)(function() {
        var observer = new (0, $1Za0O.default)(function(theme) {
            return setTheme(theme);
        });
        observer.observe();
        return function() {
            return observer.disconnect();
        };
    }, []);
    return theme;
};
var $e63899ecc922e32c$export$2e2bcd8739ae039 = $e63899ecc922e32c$var$useThemeObserver;

});
parcelRegister("hQjaP", function(module, exports) {
$parcel$export(module.exports, "default", () => $cfd62a790ef0448a$export$2e2bcd8739ae039);

var $25nEq = parcelRequire("25nEq");

var $f3FlH = parcelRequire("f3FlH");

var $2WCd2 = parcelRequire("2WCd2");

var $9Lb0O = parcelRequire("9Lb0O");
function $cfd62a790ef0448a$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $cfd62a790ef0448a$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $cfd62a790ef0448a$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $cfd62a790ef0448a$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $cfd62a790ef0448a$var$isThemeColorMode = function isThemeColorMode(colorMode) {
    return (0, $2WCd2.themeColorModes).find(function(mode) {
        return mode === colorMode;
    }) !== undefined;
};
var $cfd62a790ef0448a$var$getGlobalTheme = function getGlobalTheme() {
    if (typeof document === 'undefined') return {};
    var element = document.documentElement;
    var colorMode = element.getAttribute((0, $f3FlH.COLOR_MODE_ATTRIBUTE)) || '';
    var theme = element.getAttribute((0, $f3FlH.THEME_DATA_ATTRIBUTE)) || '';
    return $cfd62a790ef0448a$var$_objectSpread($cfd62a790ef0448a$var$_objectSpread({}, (0, $9Lb0O.themeStringToObject)(theme)), $cfd62a790ef0448a$var$isThemeColorMode(colorMode) && {
        colorMode: colorMode
    });
};
var $cfd62a790ef0448a$export$2e2bcd8739ae039 = $cfd62a790ef0448a$var$getGlobalTheme;

});
parcelRegister("f3FlH", function(module, exports) {
$parcel$export(module.exports, "THEME_DATA_ATTRIBUTE", () => $af6735e58aca415b$export$4ef52930e33717cd);
$parcel$export(module.exports, "COLOR_MODE_ATTRIBUTE", () => $af6735e58aca415b$export$a00eac3f8684bcd0);
$parcel$export(module.exports, "CONTRAST_MODE_ATTRIBUTE", () => $af6735e58aca415b$export$2112803007239c61);
$parcel$export(module.exports, "CUSTOM_THEME_ATTRIBUTE", () => $af6735e58aca415b$export$352e418ed5b6193a);
var $af6735e58aca415b$export$4ef52930e33717cd = 'data-theme';
var $af6735e58aca415b$export$a00eac3f8684bcd0 = 'data-color-mode';
var $af6735e58aca415b$export$2112803007239c61 = 'data-contrast-mode';
var $af6735e58aca415b$export$352e418ed5b6193a = 'data-custom-theme';
var $af6735e58aca415b$export$6f0c6fb8c80fcc92 = 'ds';
var $af6735e58aca415b$export$4d0c7bbf80185957 = [
    'opacity',
    'font',
    'space',
    'border',
    'radius'
];
var $af6735e58aca415b$export$dddac1532e822863 = "--".concat($af6735e58aca415b$export$6f0c6fb8c80fcc92, "-token-not-found");
var $af6735e58aca415b$export$9d7b58831ae93caa = "--".concat($af6735e58aca415b$export$6f0c6fb8c80fcc92, "-elevation-surface-current");

});

parcelRegister("2WCd2", function(module, exports) {
$parcel$export(module.exports, "themeColorModes", () => $224ea321cd5772ef$export$83993de8eb66733);
$parcel$export(module.exports, "themeIds", () => $224ea321cd5772ef$export$7d43e72a58e3283f);
$parcel$export(module.exports, "themeStateDefaults", () => $224ea321cd5772ef$export$9aedcfa7336a207);
$parcel$export(module.exports, "default", () => $224ea321cd5772ef$export$2e2bcd8739ae039);

var $9Zzpd = parcelRequire("9Zzpd");
var $224ea321cd5772ef$export$83993de8eb66733 = [
    'light',
    'dark',
    'auto'
];
/**
 * Contrast preferences: The system contrast preference
 */ var $224ea321cd5772ef$var$themeContrastModes = [
    'more',
    'no-preference',
    'auto'
];
var $224ea321cd5772ef$export$7d43e72a58e3283f = [
    'light-increased-contrast',
    'light',
    'light-future',
    'dark',
    'dark-future',
    'dark-increased-contrast',
    'legacy-light',
    'legacy-dark',
    'spacing',
    'shape',
    'typography',
    'typography-adg3',
    'typography-modernized',
    'typography-refreshed'
];
/**
 * Theme override ids: the equivalent of themeIds for theme overrides.
 * Theme overrides are temporary and there may not be any defined at times.
 */ var $224ea321cd5772ef$var$themeOverrideIds = [];
var $224ea321cd5772ef$export$92ba366331403db2 = [].concat($224ea321cd5772ef$export$7d43e72a58e3283f, $224ea321cd5772ef$var$themeOverrideIds);
/**
 * Theme to use a base. This will create the theme as
 * an extension with all token values marked as optional
 * to allow tokens to be overridden as required.
 */ /**
 * Palettes: The set of base tokens a given theme may be populated with.
 * For example: legacy light & dark themes use the "legacyPalette" containing colors from our
 * previous color set.
 */ /**
 * ThemeConfig: the source of truth for all theme meta-data.
 * This object should be used whenever interfacing with themes.
 */ var $224ea321cd5772ef$var$themeConfig = {
    'atlassian-light': {
        id: 'light',
        displayName: 'Light Theme',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'light'
        }
    },
    'atlassian-light-future': {
        id: 'light-future',
        displayName: 'Future Light Theme',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'light'
        },
        override: 'light'
    },
    'atlassian-light-increased-contrast': {
        id: 'light-increased-contrast',
        displayName: 'Light Theme (increased contrast)',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'light'
        },
        extends: 'light',
        increasesContrastFor: 'light'
    },
    'atlassian-dark': {
        id: 'dark',
        displayName: 'Dark Theme',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'dark'
        }
    },
    'atlassian-dark-future': {
        id: 'dark-future',
        displayName: 'Future Dark Theme',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'dark'
        },
        override: 'light'
    },
    'atlassian-dark-increased-contrast': {
        id: 'dark-increased-contrast',
        displayName: 'Dark Theme (increased contrast)',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'dark'
        },
        extends: 'dark',
        increasesContrastFor: 'dark'
    },
    'atlassian-legacy-light': {
        id: 'legacy-light',
        displayName: 'Light Theme (legacy)',
        palette: 'legacyPalette',
        attributes: {
            type: 'color',
            mode: 'light'
        }
    },
    'atlassian-legacy-dark': {
        id: 'legacy-dark',
        displayName: 'Dark Theme (legacy)',
        palette: 'legacyPalette',
        attributes: {
            type: 'color',
            mode: 'dark'
        }
    },
    'atlassian-spacing': {
        id: 'spacing',
        displayName: 'Atlassian Spacing',
        palette: 'spacingScale',
        attributes: {
            type: 'spacing'
        }
    },
    'atlassian-typography': {
        id: 'typography',
        displayName: 'Atlassian Typography',
        palette: 'typographyPalette',
        attributes: {
            type: 'typography'
        }
    },
    'atlassian-typography-adg3': {
        id: 'typography-adg3',
        displayName: 'ADG3 Typography',
        palette: 'typographyPalette',
        attributes: {
            type: 'typography'
        }
    },
    'atlassian-shape': {
        id: 'shape',
        displayName: 'Shape',
        palette: 'shapePalette',
        attributes: {
            type: 'shape'
        }
    },
    'atlassian-typography-modernized': {
        id: 'typography-modernized',
        displayName: 'Atlassian Typography (Modernized)',
        palette: 'typographyPalette',
        attributes: {
            type: 'typography'
        }
    },
    'atlassian-typography-refreshed': {
        id: 'typography-refreshed',
        displayName: 'Atlassian Typography (Refreshed)',
        palette: 'typographyPalette',
        attributes: {
            type: 'typography'
        }
    }
};
var $224ea321cd5772ef$export$9aedcfa7336a207 = {
    colorMode: 'auto',
    contrastMode: 'auto',
    dark: 'dark',
    light: 'light',
    shape: function shape() {
        if ((0, $9Zzpd.fg)('platform-dst-shape-theme-default')) return 'shape';
        return undefined;
    },
    spacing: 'spacing',
    typography: function typography() {
        if ((0, $9Zzpd.fg)('platform-disable-default-typography')) return undefined;
        return 'typography';
    },
    UNSAFE_themeOptions: undefined
};
var /**
 * Represents theme state once mounted to the page
 * (the page doesn't have an "auto" color mode, it's either light or dark)
 */ $224ea321cd5772ef$export$2e2bcd8739ae039 = $224ea321cd5772ef$var$themeConfig;

});

parcelRegister("9Lb0O", function(module, exports) {
$parcel$export(module.exports, "themeStringToObject", () => $71b10b9dc712ee2d$export$f19b488f7c0547ee);
$parcel$export(module.exports, "themeObjectToString", () => $71b10b9dc712ee2d$export$62c37ab81302621a);

var $ekGgq = parcelRequire("ekGgq");

var $iYJcE = parcelRequire("iYJcE");

var $2WCd2 = parcelRequire("2WCd2");
var $71b10b9dc712ee2d$var$themeKinds = [
    'light',
    'dark',
    'spacing',
    'typography',
    'shape'
];
var $71b10b9dc712ee2d$var$customThemeOptions = 'UNSAFE_themeOptions';
var $71b10b9dc712ee2d$var$isThemeKind = function isThemeKind(themeKind) {
    return $71b10b9dc712ee2d$var$themeKinds.find(function(kind) {
        return kind === themeKind;
    }) !== undefined;
};
var $71b10b9dc712ee2d$var$isThemeIds = function isThemeIds(themeId) {
    return (0, $2WCd2.themeIds).find(function(id) {
        return id === themeId;
    }) !== undefined;
};
var $71b10b9dc712ee2d$var$isColorMode = function isColorMode(modeId) {
    return [
        'light',
        'dark',
        'auto'
    ].includes(modeId);
};
var $71b10b9dc712ee2d$export$f19b488f7c0547ee = function themeStringToObject(themeState) {
    return themeState.split(' ')// @ts-ignore - TS1501 TypeScript 5.9.2 upgrade
    .map(function(theme) {
        return theme.split(/:([^]*)/);
    }).reduce(function(themeObject, _ref) {
        var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_ref, 2), kind = _ref2[0], id = _ref2[1];
        if (kind === 'colorMode' && $71b10b9dc712ee2d$var$isColorMode(id)) themeObject[kind] = id;
        if ($71b10b9dc712ee2d$var$isThemeKind(kind) && $71b10b9dc712ee2d$var$isThemeIds(id)) // @ts-expect-error FIXME - this is a valid ts error
        themeObject[kind] = id;
        if (kind === $71b10b9dc712ee2d$var$customThemeOptions) try {
            themeObject[$71b10b9dc712ee2d$var$customThemeOptions] = JSON.parse(id);
        } catch (e) {
            new Error('Invalid custom theme string');
        }
        return themeObject;
    }, {});
};
var $71b10b9dc712ee2d$export$62c37ab81302621a = function themeObjectToString(themeState) {
    return Object.entries(themeState).reduce(function(themeString, _ref3) {
        var _ref4 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_ref3, 2), kind = _ref4[0], id = _ref4[1];
        if (// colorMode theme state
        kind === 'colorMode' && typeof id === 'string' && $71b10b9dc712ee2d$var$isColorMode(id) || // custom theme state
        kind === $71b10b9dc712ee2d$var$customThemeOptions && (0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(id) === 'object' || // other theme states
        $71b10b9dc712ee2d$var$isThemeKind(kind) && typeof id === 'string' && $71b10b9dc712ee2d$var$isThemeIds(id)) return themeString + "".concat(themeString ? ' ' : '') + "".concat(kind, ":").concat((0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(id) === 'object' ? JSON.stringify(id) : id);
        return themeString;
    }, '');
};

});


parcelRegister("1Za0O", function(module, exports) {
$parcel$export(module.exports, "default", () => $17234123196e21f2$export$2e2bcd8739ae039);

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $25nEq = parcelRequire("25nEq");

var $f3FlH = parcelRequire("f3FlH");

var $hQjaP = parcelRequire("hQjaP");
/**
 * A MutationObserver which watches the `<html>` element for changes to the theme.
 *
 * In React, use the {@link useThemeObserver `useThemeObserver`} hook instead.
 *
 * @param {function} callback - A callback function which fires when the theme changes.
 *
 * @example
 * ```
 * const observer = new ThemeMutationObserver((theme) => {});
 * observer.observe();
 * ```
 */ var $17234123196e21f2$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function ThemeMutationObserver(callback) {
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, ThemeMutationObserver);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "legacyObserver", null);
        this.callback = callback;
        ThemeMutationObserver.callbacks.add(callback);
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(ThemeMutationObserver, [
        {
            key: "observe",
            value: function observe() {
                if (!ThemeMutationObserver.observer) {
                    ThemeMutationObserver.observer = new MutationObserver(function() {
                        var theme = (0, $hQjaP.default)();
                        ThemeMutationObserver.callbacks.forEach(function(callback) {
                            return callback(theme);
                        });
                    });
                    // Observer only needs to be configured once
                    ThemeMutationObserver.observer.observe(document.documentElement, {
                        attributeFilter: [
                            (0, $f3FlH.THEME_DATA_ATTRIBUTE),
                            (0, $f3FlH.COLOR_MODE_ATTRIBUTE)
                        ]
                    });
                }
            }
        },
        {
            key: "disconnect",
            value: function disconnect() {
                if (this.callback) ThemeMutationObserver.callbacks.delete(this.callback);
                if (ThemeMutationObserver.callbacks.size === 0 && ThemeMutationObserver.observer) {
                    ThemeMutationObserver.observer.disconnect();
                    ThemeMutationObserver.observer = null;
                }
            }
        }
    ]);
}();
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($17234123196e21f2$export$2e2bcd8739ae039, "observer", null);
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($17234123196e21f2$export$2e2bcd8739ae039, "callbacks", new Set());

});


parcelRegister("blliI", function(module, exports) {
$parcel$export(module.exports, "default", () => $84222dc4e6677658$export$2e2bcd8739ae039);

var $lAD7C = parcelRequire("lAD7C");

var $74Zh5 = parcelRequire("74Zh5");

var $3IjMA = parcelRequire("3IjMA");

var $c3bUn = parcelRequire("c3bUn");

var $gmeX4 = parcelRequire("gmeX4");

var $4VBpm = parcelRequire("4VBpm");

var $6awId = parcelRequire("6awId");
var $84222dc4e6677658$var$_templateObject, $84222dc4e6677658$var$_templateObject2;
var $84222dc4e6677658$export$c3618f310f725028 = /*#__PURE__*/ function(StatusClassNames) {
    StatusClassNames["ASC"] = "sorting-icon-svg__asc";
    StatusClassNames["DESC"] = "sorting-icon-svg__desc";
    StatusClassNames["NO_ORDER"] = "sorting-icon-svg__no_order";
    StatusClassNames["SORTING_NOT_ALLOWED"] = "sorting-icon-svg__not-allowed";
    return StatusClassNames;
}({});
// eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
var $84222dc4e6677658$var$buttonStyles = (0, $74Zh5.css)($84222dc4e6677658$var$_templateObject || ($84222dc4e6677658$var$_templateObject = (0, (/*@__PURE__*/$parcel$interopDefault($lAD7C)))([
    "\n\tposition: absolute;\n\tdisplay: flex;\n\theight: 28px;\n\twidth: 28px;\n\tmargin: ",
    ";\n\tright: 0;\n\ttop: 0;\n\tborder: ",
    " solid ",
    ";\n\tborder-radius: ",
    ";\n\tbackground-color: ",
    ";\n\tjustify-content: center;\n\talign-items: center;\n\tcursor: pointer;\n\n\t&:hover {\n\t\tbackground-color: ",
    ";\n\t}\n\n\t&:active {\n\t\tbackground-color: ",
    ";\n\t}\n\n\t&.",
    "__not-allowed {\n\t\tcursor: not-allowed;\n\t}\n"
])), "var(--ds-space-075, 6px)", "var(--ds-border-width-selected, 2px)", "var(--ds-border, #0B120E24)", "var(--ds-radius-small, 4px)", "var(--ds-surface-overlay, #FFFFFF)", "var(--ds-surface-overlay-hovered, #F0F1F2)", "var(--ds-surface-overlay-pressed, #DDDEE1)", (0, $4VBpm.SORTABLE_COLUMN_ICON_CLASSNAME));
// eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
var $84222dc4e6677658$var$iconWrapperStyles = (0, $74Zh5.css)($84222dc4e6677658$var$_templateObject2 || ($84222dc4e6677658$var$_templateObject2 = (0, (/*@__PURE__*/$parcel$interopDefault($lAD7C)))([
    "\n\twidth: 8px;\n\theight: 12px;\n\ttransition: transform 0.3s cubic-bezier(0.15, 1, 0.3, 1);\n\ttransform-origin: 50% 50%;\n\tdisplay: flex;\n\tjustify-content: center;\n\n\t&.",
    " {\n\t\ttransform: rotate(-180deg);\n\t}\n\n\t&.",
    "-inactive {\n\t\topacity: 0.7;\n\t}\n"
])), $84222dc4e6677658$export$c3618f310f725028.DESC, (0, $4VBpm.SORTABLE_COLUMN_ICON_CLASSNAME));
// The icon is created with CSS due to the following Firefox issue: https://product-fabric.atlassian.net/browse/ED-8001
// The TL;DR is that svg's in tables mess up how HTML is copied in Firefox. Using a styled div instead solves the problem.
// For this reason, svg's should be avoided in tables until this issue is fixed: https://bugzilla.mozilla.org/show_bug.cgi?id=1664350
var $84222dc4e6677658$var$iconStyles = (0, $74Zh5.css)({
    height: '100%',
    width: '2px',
    borderRadius: "var(--ds-radius-full, 9999px)",
    background: "var(--ds-icon, #292A2E)",
    userSelect: 'none',
    '&::before, &::after': {
        background: "var(--ds-icon, #292A2E)",
        content: "''",
        height: '2px',
        width: '6px',
        position: 'absolute',
        borderRadius: "var(--ds-radius-full, 9999px)"
    },
    '&::before': {
        transform: 'rotate(45deg) translate(3.4px, 8.5px)'
    },
    '&::after': {
        transform: 'rotate(-45deg) translate(-6.3px, 5.7px)'
    }
});
var $84222dc4e6677658$var$getIconClassName = function getIconClassName(isSortingAllowed, sortOrdered) {
    var activated = sortOrdered !== (0, $gmeX4.SortOrder).NO_ORDER;
    var activeStatusClass = "".concat((0, $4VBpm.SORTABLE_COLUMN_ICON_CLASSNAME), "-").concat(activated ? 'active' : 'inactive');
    if (!isSortingAllowed) return "".concat($84222dc4e6677658$export$c3618f310f725028.SORTING_NOT_ALLOWED, " ").concat(activeStatusClass);
    switch(sortOrdered){
        case (0, $gmeX4.SortOrder).ASC:
            return "".concat($84222dc4e6677658$export$c3618f310f725028.ASC, " ").concat(activeStatusClass);
        case (0, $gmeX4.SortOrder).DESC:
            return "".concat($84222dc4e6677658$export$c3618f310f725028.DESC, " ").concat(activeStatusClass);
        default:
            return "".concat($84222dc4e6677658$export$c3618f310f725028.NO_ORDER, " ").concat(activeStatusClass);
    }
};
var $84222dc4e6677658$var$getTooltipTitle = function getTooltipTitle(intl, isSortingAllowed, sortOrdered) {
    var noOrderLabel = (0, $6awId.sortingIconMessages).noOrderLabel, ascOrderLabel = (0, $6awId.sortingIconMessages).ascOrderLabel, descOrderLabel = (0, $6awId.sortingIconMessages).descOrderLabel, invalidLabel = (0, $6awId.sortingIconMessages).invalidLabel;
    if (!isSortingAllowed) return intl.formatMessage(invalidLabel);
    switch(sortOrdered){
        case (0, $gmeX4.SortOrder).NO_ORDER:
            return intl.formatMessage(noOrderLabel);
        case (0, $gmeX4.SortOrder).ASC:
            return intl.formatMessage(ascOrderLabel);
        case (0, $gmeX4.SortOrder).DESC:
            return intl.formatMessage(descOrderLabel);
    }
    return '';
};
var $84222dc4e6677658$var$getAriaLabel = function getAriaLabel(intl, isSortingAllowed, sortOrdered) {
    var noOrderLabel = (0, $6awId.sortingAriaLabelMessages).noOrderLabel, ascOrderLabel = (0, $6awId.sortingAriaLabelMessages).ascOrderLabel, descOrderLabel = (0, $6awId.sortingAriaLabelMessages).descOrderLabel, invalidLabel = (0, $6awId.sortingAriaLabelMessages).invalidLabel, defaultLabel = (0, $6awId.sortingAriaLabelMessages).defaultLabel;
    if (!isSortingAllowed) return intl.formatMessage(invalidLabel);
    switch(sortOrdered){
        case (0, $gmeX4.SortOrder).NO_ORDER:
            return intl.formatMessage(noOrderLabel);
        case (0, $gmeX4.SortOrder).ASC:
            return intl.formatMessage(ascOrderLabel);
        case (0, $gmeX4.SortOrder).DESC:
            return intl.formatMessage(descOrderLabel);
    }
    return intl.formatMessage(defaultLabel);
};
var $84222dc4e6677658$var$SortingIcon = function SortingIcon(_ref) {
    var isSortingAllowed = _ref.isSortingAllowed, sortOrdered = _ref.sortOrdered, intl = _ref.intl, onClick = _ref.onClick, onKeyDown = _ref.onKeyDown;
    var buttonClassName = "".concat((0, $4VBpm.SORTABLE_COLUMN_ICON_CLASSNAME), " ").concat(sortOrdered !== (0, $gmeX4.SortOrder).NO_ORDER ? 'is-active' : '').concat(isSortingAllowed ? '' : " ".concat((0, $4VBpm.SORTABLE_COLUMN_ICON_CLASSNAME), "__not-allowed "));
    var content = $84222dc4e6677658$var$getTooltipTitle(intl, isSortingAllowed, sortOrdered);
    var ariaLabel = $84222dc4e6677658$var$getAriaLabel(intl, isSortingAllowed, sortOrdered);
    var handleClick = function handleClick() {
        if (isSortingAllowed) onClick();
    };
    var handleKeyDown = function handleKeyDown(event) {
        if (isSortingAllowed) onKeyDown(event);
    };
    return (0, $74Zh5.jsx)((0, $c3bUn.default), {
        delay: 0,
        content: content,
        position: "top"
    }, (0, $74Zh5.jsx)("div", {
        css: $84222dc4e6677658$var$buttonStyles,
        className: buttonClassName,
        role: "button",
        tabIndex: isSortingAllowed ? 0 : -1,
        "aria-label": ariaLabel,
        "aria-disabled": !isSortingAllowed,
        "aria-hidden": !isSortingAllowed,
        onClick: handleClick,
        onKeyDown: handleKeyDown
    }, (0, $74Zh5.jsx)("div", {
        css: $84222dc4e6677658$var$iconWrapperStyles,
        className: $84222dc4e6677658$var$getIconClassName(isSortingAllowed, sortOrdered)
    }, (0, $74Zh5.jsx)("div", {
        css: [
            $84222dc4e6677658$var$iconStyles
        ]
    }))));
};
var $84222dc4e6677658$var$_default_1 = (0, $3IjMA.default)($84222dc4e6677658$var$SortingIcon);
var $84222dc4e6677658$export$2e2bcd8739ae039 = $84222dc4e6677658$var$_default_1;

});
parcelRegister("4VBpm", function(module, exports) {
$parcel$export(module.exports, "SORTABLE_COLUMN_ICON_CLASSNAME", () => $396980bc0f5b5002$export$bd4f24d8b1e86b23);
var $396980bc0f5b5002$export$bd4f24d8b1e86b23 = "ak-renderer-tableHeader-sorting-icon";

});

parcelRegister("6awId", function(module, exports) {
$parcel$export(module.exports, "sortingIconMessages", () => $47dd0d34cf14ed1a$export$458c50917513cd1a);
$parcel$export(module.exports, "sortingAriaLabelMessages", () => $47dd0d34cf14ed1a$export$f142573f51a67577);

var $aRMzY = parcelRequire("aRMzY");
var $47dd0d34cf14ed1a$export$458c50917513cd1a = (0, $aRMzY.defineMessages)({
    noOrderLabel: {
        id: 'fabric.editor.headingLink.noOrderLabel',
        defaultMessage: 'Sort column A to Z',
        description: 'Sort the column in ascending order'
    },
    ascOrderLabel: {
        id: 'fabric.editor.headingLink.ascOrderLabel',
        defaultMessage: 'Sort column Z to A',
        description: 'Sort the column in descending order'
    },
    descOrderLabel: {
        id: 'fabric.editor.headingLink.descOrderLabel',
        defaultMessage: 'Clear sorting',
        description: 'clear the sorting from this column'
    },
    invalidLabel: {
        id: 'fabric.editor.headingLink.invalidLabel',
        // eslint-disable-next-line @atlassian/i18n/no-multiple-whitespaces
        defaultMessage: "\u26A0\uFE0F  You can't sort a table with merged cells",
        description: 'this sort is invalid for merged cells'
    }
});
var $47dd0d34cf14ed1a$export$f142573f51a67577 = (0, $aRMzY.defineMessages)({
    noOrderLabel: {
        id: 'fabric.editor.tableHeader.sorting.no',
        defaultMessage: 'No sort applied to the column',
        description: 'Aria-label for Sort column button when sorting was not applied or the sorting has been cleared'
    },
    ascOrderLabel: {
        id: 'fabric.editor.tableHeader.sorting.asc',
        defaultMessage: 'Ascending sort applied',
        description: 'Aria-label for Sort column button when ascending sorting was applied'
    },
    descOrderLabel: {
        id: 'fabric.editor.tableHeader.sorting.desc',
        defaultMessage: 'Descending sort applied',
        description: 'Aria-label for Sort column button when descending sorting was applied'
    },
    invalidLabel: {
        id: 'fabric.editor.tableHeader.sorting.invalid',
        defaultMessage: "You can't sort a table with merged cells",
        description: 'Aria-label for Sort column button when sorting is not possible'
    },
    defaultLabel: {
        id: 'fabric.editor.tableHeader.sorting.default',
        defaultMessage: 'Sort the column',
        description: 'Default aria-label for Sort column button'
    }
});

});



parcelRegister("4qXRD", function(module, exports) {
$parcel$export(module.exports, "Provider", () => $33a806e87b8f2642$export$2881499e37b75b9a);
$parcel$export(module.exports, "withSmartCardStorage", () => $33a806e87b8f2642$export$65e2d5a272a382b0);

var $kqp0i = parcelRequire("kqp0i");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $kIXpt = parcelRequire("kIXpt");

var $cYPzS = parcelRequire("cYPzS");

var $eyuDe = parcelRequire("eyuDe");

var $5FkrB = parcelRequire("5FkrB");
function $33a806e87b8f2642$var$_callSuper(t, o, e) {
    return o = (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(o), (0, (/*@__PURE__*/$parcel$interopDefault($kIXpt)))(t, $33a806e87b8f2642$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(t).constructor) : o.apply(t, e));
}
function $33a806e87b8f2642$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($33a806e87b8f2642$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $33a806e87b8f2642$export$841858b892ce1f4c = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createContext(new Map());
var $33a806e87b8f2642$export$2881499e37b75b9a = function Provider(_ref) {
    var children = _ref.children;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement($33a806e87b8f2642$export$841858b892ce1f4c.Provider, {
        value: new Map()
    }, children);
};
var $33a806e87b8f2642$export$65e2d5a272a382b0 = function withSmartCardStorage(WrappedComponent) {
    // Ignored via go/ees005
    // eslint-disable-next-line react/prefer-stateless-function
    return /*#__PURE__*/ function(_React$Component) {
        function _class() {
            (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, _class);
            return $33a806e87b8f2642$var$_callSuper(this, _class, arguments);
        }
        (0, (/*@__PURE__*/$parcel$interopDefault($eyuDe)))(_class, _React$Component);
        return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(_class, [
            {
                key: "render",
                value: function render() {
                    var _this = this;
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement($33a806e87b8f2642$export$841858b892ce1f4c.Consumer, null, function(storage) {
                        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(WrappedComponent, (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, _this.props, {
                            smartCardStorage: storage
                        }));
                    });
                }
            }
        ]);
    }((0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).Component);
};

});

parcelRegister("lAKm0", function(module, exports) {
$parcel$export(module.exports, "tableStickyPadding", () => $fb80eab4330438e9$export$3de6413b528017ca);
$parcel$export(module.exports, "StickyTable", () => $fb80eab4330438e9$export$fd9654fc359d55a3);
$parcel$export(module.exports, "OverflowParent", () => $fb80eab4330438e9$export$e97bc6692974bd0b);

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $kqp0i = parcelRequire("kqp0i");

var $25nEq = parcelRequire("25nEq");
parcelRequire("5FkrB");

var $74Zh5 = parcelRequire("74Zh5");

var $fMtrl = parcelRequire("fMtrl");

var $1LBcl = parcelRequire("1LBcl");

var $d4dXm = parcelRequire("d4dXm");

var $dhEtU = parcelRequire("dhEtU");

var $a0WZy = parcelRequire("a0WZy");
var $fb80eab4330438e9$export$3de6413b528017ca = 8;
var $fb80eab4330438e9$var$modeSpecficStyles = {
    none: (0, $74Zh5.css)({
        display: 'none'
    }),
    stick: (0, $74Zh5.css)({
        position: 'fixed'
    }),
    'pin-bottom': (0, $74Zh5.css)({
        position: 'absolute'
    })
};
// refactored based on fixedTableDivStaticStyles
// TODO: DSP-4123 - Quality ticket
var $fb80eab4330438e9$var$fixedTableDivStaticStyles = (0, $74Zh5.css)((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({
    zIndex: 'var(--ak-renderer-sticky-header-zindex)'
}, "& .".concat((0, $fMtrl.TableSharedCssClassName).TABLE_CONTAINER, ", & .").concat((0, $fMtrl.TableSharedCssClassName).TABLE_STICKY_WRAPPER, " > table"), {
    marginTop: 0,
    marginBottom: 0,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    tr: {
        background: "var(--ds-surface, white)"
    }
}), "borderTop", "".concat($fb80eab4330438e9$export$3de6413b528017ca, "px solid ", "var(--ds-surface, white)")), "background", "var(--ds-surface-overlay, white)"), "boxShadow", "0 6px 4px -4px ".concat("var(--ds-shadow-overflow-perimeter, ".concat((0, $d4dXm.N40A), ")"))), "div[data-expanded='false'] &", {
    display: 'none'
}), "& .".concat((0, $fMtrl.TableSharedCssClassName).TABLE_CONTAINER, ".is-sticky.right-shadow::after, & .").concat((0, $fMtrl.TableSharedCssClassName).TABLE_CONTAINER, ".is-sticky.left-shadow::before"), {
    top: '0px',
    height: '100%'
}), "&.fixed-table-div-custom-table-resizing[mode='stick']", {
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    zIndex: 'var(--ak-renderer-sticky-header-zindex)'
}));
var $fb80eab4330438e9$var$FixedTableDiv = function FixedTableDiv(props) {
    var top = props.top, wrapperWidth = props.wrapperWidth, mode = props.mode, allowTableResizing = props.allowTableResizing;
    var stickyHeaderZIndex;
    if (allowTableResizing) stickyHeaderZIndex = 13;
    else stickyHeaderZIndex = (0, $1LBcl.akEditorStickyHeaderZIndex);
    var attrs = {
        mode: mode
    };
    return (0, $74Zh5.jsx)("div", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, attrs, {
        "data-testid": "sticky-table-fixed",
        className: allowTableResizing ? 'fixed-table-div-custom-table-resizing' : '',
        css: [
            $fb80eab4330438e9$var$fixedTableDivStaticStyles,
            $fb80eab4330438e9$var$modeSpecficStyles === null || $fb80eab4330438e9$var$modeSpecficStyles === void 0 ? void 0 : $fb80eab4330438e9$var$modeSpecficStyles[mode]
        ],
        style: {
            '--ak-renderer-sticky-header-zindex': stickyHeaderZIndex,
            width: "".concat(wrapperWidth, "px"),
            top: typeof top === 'number' ? "".concat(top, "px") : undefined
        }
    }), props.children);
};
var $fb80eab4330438e9$export$fd9654fc359d55a3 = function StickyTable(_ref) {
    var top = _ref.top, left = _ref.left, mode = _ref.mode, shadowClassNames = _ref.shadowClassNames, innerRef = _ref.innerRef, wrapperWidth = _ref.wrapperWidth, tableWidth = _ref.tableWidth, isNumberColumnEnabled = _ref.isNumberColumnEnabled, layout = _ref.layout, children = _ref.children, columnWidths = _ref.columnWidths, renderWidth = _ref.renderWidth, rowHeight = _ref.rowHeight, tableNode = _ref.tableNode, rendererAppearance = _ref.rendererAppearance, allowTableResizing = _ref.allowTableResizing, _ref$fixTableSSRResiz = _ref.fixTableSSRResizing, fixTableSSRResizing = _ref$fixTableSSRResiz === void 0 ? false : _ref$fixTableSSRResiz;
    var styles;
    /* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ if (allowTableResizing) styles = (0, $74Zh5.css)({
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        top: mode === 'pin-bottom' ? top : undefined,
        position: 'absolute'
    });
    else styles = (0, $74Zh5.css)({
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        left: left && left < 0 ? left : undefined,
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        top: mode === 'pin-bottom' ? top : undefined,
        position: 'relative'
    });
    /* eslint-enable @atlaskit/design-system/ensure-design-token-usage */ return(// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
    (0, $74Zh5.jsx)("div", {
        css: styles
    }, (0, $74Zh5.jsx)($fb80eab4330438e9$var$FixedTableDiv, {
        top: mode === 'stick' ? top : undefined,
        mode: rowHeight > 300 ? 'none' : mode,
        wrapperWidth: wrapperWidth,
        allowTableResizing: allowTableResizing
    }, (0, $74Zh5.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "".concat((0, $fMtrl.TableSharedCssClassName).TABLE_CONTAINER, " is-sticky ").concat(shadowClassNames || ''),
        "data-layout": layout,
        style: {
            width: tableWidth,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            marginBottom: fixTableSSRResizing ? 0 : ''
        }
    }, (0, $74Zh5.jsx)("div", {
        ref: innerRef,
        className: "".concat((0, $fMtrl.TableSharedCssClassName).TABLE_STICKY_WRAPPER),
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            overflow: 'hidden'
        }
    }, (0, $74Zh5.jsx)((0, $dhEtU.Table), {
        columnWidths: columnWidths,
        layout: layout,
        isNumberColumnEnabled: isNumberColumnEnabled,
        renderWidth: renderWidth,
        tableNode: tableNode,
        rendererAppearance: rendererAppearance,
        fixTableSSRResizing: fixTableSSRResizing
    }, /**
     * @see https://product-fabric.atlassian.net/browse/ED-10235
     * We pass prop 'invisible' to our table's children nodes meaning
     * they exist inside of the 'invisible' duplicated table component that
     * enables sticky headers.
     */ (0, $a0WZy.recursivelyInjectProps)(children, {
        invisible: true
    })))))));
};
/**
 * Traverse DOM Tree upwards looking for table parents with "overflow: scroll".
 * @param table
 * @param defaultScrollRootId
 * @example
 */ function $fb80eab4330438e9$var$findHorizontalOverflowScrollParent(table, defaultScrollRootId) {
    var parent = table;
    if (!parent) return null;
    // Ignored via go/ees005
    // eslint-disable-next-line no-cond-assign
    while(parent = parent.parentElement){
        // IE11 on Window 8 doesn't show styles from CSS when accessing through element.style property.
        var style = window.getComputedStyle(parent);
        if (style.overflow === 'scroll' || style.overflowY === 'scroll') return parent;
        if (!!defaultScrollRootId && parent.id === defaultScrollRootId) // If a defaultScrollRootId was specified and we reached the element with this id without finding a closer
        // scroll parent, use this element as the scroll parent
        return parent;
    }
    return null;
}
var $fb80eab4330438e9$export$e97bc6692974bd0b = /*#__PURE__*/ function() {
    function OverflowParent(ref) {
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, OverflowParent);
        this.ref = ref;
        this.ref = ref;
    }
    /**
   *
   * @param el
   * @param defaultScrollRootId
   * @example
   */ return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(OverflowParent, [
        {
            key: "isElement",
            get: /**
     *
     */ function get() {
                return this.ref instanceof HTMLElement;
            }
        },
        {
            key: "id",
            get: function get() {
                if (this.ref instanceof HTMLElement) return this.ref.id;
                return '';
            }
        },
        {
            key: "top",
            get: function get() {
                if (this.ref instanceof HTMLElement) return this.ref.getBoundingClientRect().top;
                return 0;
            }
        },
        {
            key: "addEventListener",
            value: function addEventListener(type, cb) {
                var _this$ref;
                for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)args[_key - 2] = arguments[_key];
                // Ignored via go/ees005
                // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                (_this$ref = this.ref).addEventListener.apply(_this$ref, [
                    type,
                    cb
                ].concat(args));
            }
        },
        {
            key: "removeEventListener",
            value: function removeEventListener(type, cb) {
                var _this$ref2;
                for(var _len2 = arguments.length, args = new Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++)args[_key2 - 2] = arguments[_key2];
                // Ignored via go/ees005
                // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                (_this$ref2 = this.ref).removeEventListener.apply(_this$ref2, [
                    type,
                    cb
                ].concat(args));
            }
        }
    ], [
        {
            key: "fromElement",
            value: function fromElement(el, defaultScrollRootId) {
                return new OverflowParent($fb80eab4330438e9$var$findHorizontalOverflowScrollParent(el, defaultScrollRootId) || window);
            }
        }
    ]);
}();

});
parcelRegister("dhEtU", function(module, exports) {
$parcel$export(module.exports, "Table", () => $9abc43ad65de416a$export$54ec01a60f47d33d);

var $kqp0i = parcelRequire("kqp0i");

var $5FkrB = parcelRequire("5FkrB");

var $bSj2D = parcelRequire("bSj2D");

var $hrVpF = parcelRequire("hrVpF");

var $1LBcl = parcelRequire("1LBcl");

var $9Zzpd = parcelRequire("9Zzpd");
var $9abc43ad65de416a$export$54ec01a60f47d33d = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).memo(function(_ref) {
    var _tableNode$attrs;
    var innerRef = _ref.innerRef, isNumberColumnEnabled = _ref.isNumberColumnEnabled, columnWidths = _ref.columnWidths, layout = _ref.layout, renderWidth = _ref.renderWidth, children = _ref.children, tableNode = _ref.tableNode, rendererAppearance = _ref.rendererAppearance, isInsideOfBlockNode = _ref.isInsideOfBlockNode, isInsideOfTable = _ref.isInsideOfTable, isinsideMultiBodiedExtension = _ref.isinsideMultiBodiedExtension, allowTableResizing = _ref.allowTableResizing, isPresentational = _ref.isPresentational, _ref$fixTableSSRResiz = _ref.fixTableSSRResizing, fixTableSSRResizing = _ref$fixTableSSRResiz === void 0 ? false : _ref$fixTableSSRResiz;
    var tableWidth = tableNode ? (0, $hrVpF.getTableContainerWidth)(tableNode) : (0, $1LBcl.akEditorDefaultLayoutWidth);
    var tableColumnWidths = columnWidths;
    if (rendererAppearance === 'comment' && allowTableResizing && tableNode && !((_tableNode$attrs = tableNode.attrs) !== null && _tableNode$attrs !== void 0 && _tableNode$attrs.width)) tableWidth = 'inherit';
    if (rendererAppearance === 'comment' && !allowTableResizing) // in the case we have css container stylings,
    // we don't need to calculate width here as this
    // is done via css
    {
        if (!(0, $9Zzpd.fg)('platform-ssr-table-resize')) tableWidth = renderWidth;
    }
    // for columns that are evenly distributed, do not return `colgroup` since existing table containerQuery
    // scales up the columns width. This ensures columns always have 42px.
    if (rendererAppearance === 'comment') {
        if ((0, $9Zzpd.fg)('platform-ssr-table-resize')) tableColumnWidths = columnWidths && (0, $bSj2D.colWidthSum)(columnWidths) ? columnWidths : undefined;
    }
    var tableLayout = tableNode === null || tableNode === void 0 ? void 0 : tableNode.attrs.layout;
    var tableDisplayMode = tableNode === null || tableNode === void 0 ? void 0 : tableNode.attrs.displayMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("table", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, (0, $9Zzpd.fg)('platform_renderer_isPresentational') && {
        role: isPresentational ? 'presentation' : undefined
    }, {
        "data-testid": "renderer-table",
        "data-number-column": isNumberColumnEnabled,
        "data-table-width": tableWidth,
        "data-layout": tableLayout,
        "data-table-display-mode": tableDisplayMode,
        ref: innerRef,
        style: {
            marginTop: fixTableSSRResizing ? '0px' : ''
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $bSj2D.Colgroup), {
        columnWidths: tableColumnWidths,
        layout: layout,
        isNumberColumnEnabled: isNumberColumnEnabled,
        renderWidth: renderWidth,
        tableNode: tableNode,
        rendererAppearance: rendererAppearance,
        isInsideOfBlockNode: isInsideOfBlockNode,
        isInsideOfTable: isInsideOfTable,
        isinsideMultiBodiedExtension: isinsideMultiBodiedExtension,
        allowTableResizing: allowTableResizing
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("tbody", null, children));
});

});
parcelRegister("bSj2D", function(module, exports) {
$parcel$export(module.exports, "colWidthSum", () => $8a538216a4f48875$export$2d9bdaa5b8cd99f0);
$parcel$export(module.exports, "Colgroup", () => $8a538216a4f48875$export$89efc2d0ceeaa030);

var $25nEq = parcelRequire("25nEq");

var $5FkrB = parcelRequire("5FkrB");

var $fMtrl = parcelRequire("fMtrl");

var $1LBcl = parcelRequire("1LBcl");

var $fAhSf = parcelRequire("fAhSf");

var $hrVpF = parcelRequire("hrVpF");

var $4qeLW = parcelRequire("4qeLW");

var $ky5Ao = parcelRequire("ky5Ao");

var $9Zzpd = parcelRequire("9Zzpd");

var $drUcN = parcelRequire("drUcN");
function $8a538216a4f48875$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $8a538216a4f48875$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $8a538216a4f48875$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $8a538216a4f48875$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
// we allow scaling down column widths by no more than 30%
// this intends to reduce unwanted scrolling in the Renderer in these scenarios:
// User A creates a table with column widths → User B views it on a smaller screen
// User A creates a table with column widths → User A views it with reduced viewport space (eg. Confluence sidebar is open)
var $8a538216a4f48875$var$MAX_SCALING_PERCENT = 0.3;
var $8a538216a4f48875$var$MAX_SCALING_PERCENT_TABLES_WITH_FIXED_COLUMN_WIDTHS_OPTION = 0.4;
var $8a538216a4f48875$var$isTableColumnResized = function isTableColumnResized(columnWidths) {
    var filteredWidths = columnWidths.filter(function(width) {
        return width !== 0;
    });
    return !!filteredWidths.length;
};
var $8a538216a4f48875$var$fixColumnWidth = function fixColumnWidth(_ref) {
    var columnWidth = _ref.columnWidth, zeroWidthColumnsCount = _ref.zeroWidthColumnsCount, scaleDownPercent = _ref.scaleDownPercent;
    if (columnWidth === 0) return columnWidth;
    // If the tables total width (including no zero widths col or cols without width) is less than the current layout
    // We scale up the columns to meet the minimum of the table layout.
    if (zeroWidthColumnsCount === 0 && scaleDownPercent) return Math.max(Math.floor((1 - scaleDownPercent) * columnWidth), (0, $fMtrl.tableCellMinWidth));
    return Math.max(// We need to take tableCellBorderWidth, to avoid unnecessary overflow.
    columnWidth - (0, $fMtrl.tableCellBorderWidth), zeroWidthColumnsCount ? (0, $1LBcl.akEditorTableLegacyCellMinWidth) : (0, $fMtrl.tableCellMinWidth));
};
var $8a538216a4f48875$var$calcScalePercent = function calcScalePercent(_ref2) {
    var renderWidth = _ref2.renderWidth, tableWidth = _ref2.tableWidth, maxScale = _ref2.maxScale, isNumberColumnEnabled = _ref2.isNumberColumnEnabled;
    var noNumColumnScalePercent = renderWidth / tableWidth;
    // when numbered column is enabled, we need to calculate the scale percent without the akEditorTableNumberColumnWidth
    // As numbered column width is not scaled down
    var numColumnScalePercent = (renderWidth - (0, $1LBcl.akEditorTableNumberColumnWidth)) / (tableWidth - (0, $1LBcl.akEditorTableNumberColumnWidth));
    var diffPercent = 1 - noNumColumnScalePercent;
    return diffPercent < maxScale ? isNumberColumnEnabled ? 1 - numColumnScalePercent : diffPercent : maxScale;
};
var $8a538216a4f48875$export$2d9bdaa5b8cd99f0 = function colWidthSum(columnWidths) {
    return columnWidths.reduce(function(prev, curr) {
        return curr + prev;
    }, 0);
};
var $8a538216a4f48875$var$renderScaleDownColgroup = function renderScaleDownColgroup(props) {
    var _props$tableNode;
    var columnWidths = props.columnWidths, isNumberColumnEnabled = props.isNumberColumnEnabled, renderWidth = props.renderWidth, tableNode = props.tableNode, rendererAppearance = props.rendererAppearance, isInsideOfBlockNode = props.isInsideOfBlockNode, isInsideOfTable = props.isInsideOfTable, isinsideMultiBodiedExtension = props.isinsideMultiBodiedExtension, isTableScalingEnabled = props.isTableScalingEnabled, isTableFixedColumnWidthsOptionEnabled = props.isTableFixedColumnWidthsOptionEnabled, allowTableResizing = props.allowTableResizing, isTopLevelRenderer = props.isTopLevelRenderer;
    if (!columnWidths || columnWidths.every(function(width) {
        return width === 0;
    }) && (0, $9Zzpd.fg)('platform_editor_numbered_column_in_include')) return [];
    var tableColumnResized = $8a538216a4f48875$var$isTableColumnResized(columnWidths);
    var noOfColumns = columnWidths.length;
    var targetWidths;
    // This is a fix for ED-23259
    // Some extensions (for ex: Page Properties or Excerpt) do not renderer tables directly inside themselves. They use ReactRenderer.
    // So if we add a check like isInsideExtension (similar to exising isInsideBlockNode), it will fail, and to the only way to learn
    // if the table is rendered inside another node, is to check if the Renderer itself is nested.
    var isRendererNested = isTopLevelRenderer === false;
    // appearance == comment && allowTableResizing && !tableNode?.attrs.width, means it is a comment
    // appearance == comment && !allowTableResizing && !tableNode?.attrs.width, means it is a inline comment
    // When comment and inline comment table width inherits from the parent container, we want tableContainerWidth === renderWidth
    // Tables with numbered columns inside of extensions cannot use the renderWidth when it is 0. In this case, it should
    // explicitly use the width coming from the table node as the final table container width.
    var tableContainerWidth = rendererAppearance === 'comment' && !(tableNode !== null && tableNode !== void 0 && tableNode.attrs.width) || isRendererNested && (!(0, $9Zzpd.fg)('platform_fix_nested_num_column_scaling') || !isNumberColumnEnabled) ? renderWidth : (0, $hrVpF.getTableContainerWidth)(tableNode);
    if (allowTableResizing && !isInsideOfBlockNode && !isInsideOfTable && !isinsideMultiBodiedExtension && !tableColumnResized) {
        // when no columns are resized, each column should have equal width, equals to tableWidth / noOfColumns
        var _tableWidth = (isNumberColumnEnabled ? tableContainerWidth - (0, $1LBcl.akEditorTableNumberColumnWidth) : tableContainerWidth) - 1;
        var defaultColumnWidth = _tableWidth / noOfColumns;
        targetWidths = new Array(noOfColumns).fill(defaultColumnWidth);
    } else if (!tableColumnResized) return null;
    var sumOfColumns = $8a538216a4f48875$export$2d9bdaa5b8cd99f0(columnWidths);
    // tables in the wild may be smaller than table container width (col resizing bugs, created before custom widths etc.)
    // this causes issues with num column scaling as we add a new table column in renderer
    var isTableSmallerThanContainer = sumOfColumns < tableContainerWidth - 1;
    var forceScaleForNumColumn = isTableScalingEnabled && isNumberColumnEnabled && tableColumnResized;
    // when table resized and number column is enabled, we need to scale down the table in render
    if (forceScaleForNumColumn) {
        var calculatedTableContainerWidth = rendererAppearance === 'comment' ? sumOfColumns : tableContainerWidth;
        var scalePercentage = +((calculatedTableContainerWidth - (0, $1LBcl.akEditorTableNumberColumnWidth)) / calculatedTableContainerWidth);
        var targetMaxWidth = calculatedTableContainerWidth - (0, $1LBcl.akEditorTableNumberColumnWidth);
        var totalWidthAfterScale = 0;
        var newScaledTargetWidths = columnWidths.map(function(width) {
            // we need to scale each column UP, to ensure total width of table matches table container
            var patchedWidth = isTableSmallerThanContainer ? width / sumOfColumns * (calculatedTableContainerWidth - 1) : width;
            var newWidth = Math.floor(patchedWidth * scalePercentage);
            totalWidthAfterScale += newWidth;
            return newWidth;
        });
        var diff = targetMaxWidth - totalWidthAfterScale;
        targetWidths = newScaledTargetWidths;
        if (diff > 0 || diff < 0 && Math.abs(diff) < (0, $fMtrl.tableCellMinWidth)) {
            var updated = false;
            targetWidths = targetWidths.map(function(width) {
                if (!updated && width + diff > (0, $fMtrl.tableCellMinWidth)) {
                    updated = true;
                    width += diff;
                }
                return width;
            });
        }
    }
    targetWidths = targetWidths || columnWidths;
    // @see ED-6056
    var maxTableWidth = renderWidth < tableContainerWidth ? renderWidth : tableContainerWidth;
    var tableWidth = isNumberColumnEnabled ? (0, $1LBcl.akEditorTableNumberColumnWidth) : 0;
    var minTableWidth = tableWidth;
    var zeroWidthColumnsCount = 0;
    targetWidths.forEach(function(width) {
        if (width) tableWidth += Math.ceil(width);
        else zeroWidthColumnsCount += 1;
        minTableWidth += Math.ceil(width) || (0, $1LBcl.akEditorTableLegacyCellMinWidth);
    });
    var cellMinWidth = 0;
    var scaleDownPercent = 0;
    var isTableScalingWithFixedColumnWidthsOptionEnabled = isTableScalingEnabled && isTableFixedColumnWidthsOptionEnabled;
    var isTableWidthFixed = isTableScalingWithFixedColumnWidthsOptionEnabled && ((_props$tableNode = props.tableNode) === null || _props$tableNode === void 0 ? void 0 : _props$tableNode.attrs.displayMode) === 'fixed';
    var maxScalingPercent = isTableScalingWithFixedColumnWidthsOptionEnabled || isTableScalingEnabled && rendererAppearance === 'comment' ? $8a538216a4f48875$var$MAX_SCALING_PERCENT_TABLES_WITH_FIXED_COLUMN_WIDTHS_OPTION : $8a538216a4f48875$var$MAX_SCALING_PERCENT;
    // fixes migration tables with zero-width columns
    if (zeroWidthColumnsCount > 0) {
        if (minTableWidth > maxTableWidth) {
            var minWidth = Math.ceil((maxTableWidth - tableWidth) / zeroWidthColumnsCount);
            cellMinWidth = minWidth < (0, $1LBcl.akEditorTableLegacyCellMinWidth) ? (0, $1LBcl.akEditorTableLegacyCellMinWidth) : minWidth;
        }
    } else if (renderWidth < tableWidth && !isTableWidthFixed) {
        var shouldTable100ScaleDown = rendererAppearance === 'comment' && allowTableResizing && !(tableNode !== null && tableNode !== void 0 && tableNode.attrs.width);
        scaleDownPercent = $8a538216a4f48875$var$calcScalePercent({
            renderWidth: renderWidth,
            tableWidth: tableWidth,
            maxScale: (0, $9Zzpd.fg)('platform-ssr-table-resize') ? maxScalingPercent : shouldTable100ScaleDown ? 1 : maxScalingPercent,
            isNumberColumnEnabled: isNumberColumnEnabled
        });
    }
    if (isNumberColumnEnabled && (tableWidth < maxTableWidth || maxTableWidth === 0) && (0, $drUcN.expValEquals)('editor_prevent_numbered_column_too_big_jira_1', 'isEnabled', true)) {
        var fixedColWidths = targetWidths.map(function(width) {
            return $8a538216a4f48875$var$fixColumnWidth({
                columnWidth: width,
                zeroWidthColumnsCount: zeroWidthColumnsCount,
                scaleDownPercent: scaleDownPercent
            }) || cellMinWidth;
        });
        var sumFixedColumnWidths = $8a538216a4f48875$export$2d9bdaa5b8cd99f0(fixedColWidths);
        return fixedColWidths.map(function(colWidth) {
            var width = Math.max(colWidth, cellMinWidth);
            if (colWidth > (0, $1LBcl.akEditorTableCellMinWidth)) // To make sure the numbered column isn't scaled, use
            // percentages for the other columns.
            // Calculate the percentage based on the sum of the fixed column widths
            return {
                width: "".concat(width / sumFixedColumnWidths * 100, "%")
            };
            else {
                // If the column is equal to or less than the minimum cell width, we need to return a fixed pixel width.
                // This is to prevent columns being scaled below the minimum cell width.
                var style = width ? {
                    width: "".concat(width, "px")
                } : {};
                return style;
            }
        });
    }
    /**
   * When cleaning up editor_prevent_numbered_column_too_big_jira_1 experiment,
   * resuse the fixedColWidths const to avoid code duplication.
   */ return targetWidths.map(function(colWidth) {
        var width = $8a538216a4f48875$var$fixColumnWidth({
            columnWidth: colWidth,
            zeroWidthColumnsCount: zeroWidthColumnsCount,
            scaleDownPercent: scaleDownPercent
        }) || cellMinWidth;
        var style = width ? {
            width: "".concat(width, "px")
        } : {};
        return style;
    });
};
var $8a538216a4f48875$export$89efc2d0ceeaa030 = function Colgroup(props) {
    var _useRendererContext = (0, $ky5Ao.useRendererContext)(), isTopLevelRenderer = _useRendererContext.isTopLevelRenderer;
    var columnWidths = props.columnWidths, isNumberColumnEnabled = props.isNumberColumnEnabled;
    var flags = (0, $4qeLW.useFeatureFlags)();
    if (!columnWidths) return null;
    var colStyles = $8a538216a4f48875$var$renderScaleDownColgroup($8a538216a4f48875$var$_objectSpread($8a538216a4f48875$var$_objectSpread({}, props), {}, {
        isTopLevelRenderer: isTopLevelRenderer,
        isTableScalingEnabled: props.rendererAppearance === 'full-page' || props.rendererAppearance === 'full-width' || props.rendererAppearance === 'max' && (0, $drUcN.expValEquals)('editor_tinymce_full_width_mode', 'isEnabled', true) || props.rendererAppearance === 'comment' && (0, $fAhSf.editorExperiment)('support_table_in_comment', true, {
            exposure: true
        }) || props.rendererAppearance === 'comment' && (0, $fAhSf.editorExperiment)('support_table_in_comment_jira', true, {
            exposure: true
        }),
        isTableFixedColumnWidthsOptionEnabled: !!(flags && 'tableWithFixedColumnWidthsOption' in flags && flags.tableWithFixedColumnWidthsOption) && (props.rendererAppearance === 'full-page' || props.rendererAppearance === 'full-width' || props.rendererAppearance === 'max' && (0, $drUcN.expValEquals)('editor_tinymce_full_width_mode', 'isEnabled', true))
    }));
    if (!colStyles) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("colgroup", null, isNumberColumnEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("col", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        style: {
            width: (0, $1LBcl.akEditorTableNumberColumnWidth)
        },
        "data-test-id": 'num'
    }), colStyles.map(function(style, idx) {
        return(/*#__PURE__*/ // Ignored via go/ees005
        // eslint-disable-next-line react/no-array-index-key, @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("col", {
            key: idx,
            style: style
        }));
    }));
};

});
parcelRegister("4qeLW", function(module, exports) {
$parcel$export(module.exports, "useFeatureFlags", () => $33850c9be5128f32$export$90335b3ff08f335);
/* eslint-disable @atlaskit/editor/no-re-export */ // Entry file in package.json

var $ky5Ao = parcelRequire("ky5Ao");
var $33850c9be5128f32$export$90335b3ff08f335 = function useFeatureFlags() {
    var _useRendererContext;
    return (_useRendererContext = (0, $ky5Ao.useRendererContext)()) === null || _useRendererContext === void 0 ? void 0 : _useRendererContext.featureFlags;
};

});
parcelRegister("ky5Ao", function(module, exports) {
$parcel$export(module.exports, "useRendererContext", () => $ef5b50e852fe2b42$export$a906432540ed7ed8);
$parcel$export(module.exports, "RendererContextProvider", () => $ef5b50e852fe2b42$export$ca5df47902194781);
/* eslint-disable @atlaskit/editor/no-re-export */ // Entry file in package.json

var $5FkrB = parcelRequire("5FkrB");
var $ef5b50e852fe2b42$var$RendererContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createContext({});
var $ef5b50e852fe2b42$export$a906432540ed7ed8 = function useRendererContext() {
    return (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).useContext($ef5b50e852fe2b42$var$RendererContext);
};
var $ef5b50e852fe2b42$export$ca5df47902194781 = $ef5b50e852fe2b42$var$RendererContext.Provider;

});




parcelRegister("a0WZy", function(module, exports) {
$parcel$export(module.exports, "recursivelyInjectProps", () => $74a7aa0640e1d4dc$export$40e12ce8e0a76b0c);

var $5FkrB = parcelRequire("5FkrB");
function $74a7aa0640e1d4dc$export$40e12ce8e0a76b0c(children, propsToInject) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).Children.toArray(children).map(function(child) {
        // Cannot add a prop to an invalid element, so just return the child
        if (!/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).isValidElement(child)) return child;
        // Recursive call if child has nested children
        if (child.props.children) child = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).cloneElement(child, {
            children: $74a7aa0640e1d4dc$export$40e12ce8e0a76b0c(child.props.children, propsToInject)
        });
        // Add props to react child node
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).cloneElement(child, propsToInject);
    });
}

});


parcelRegister("KYtRS", function(module, exports) {
$parcel$export(module.exports, "isFullWidthAppearance", () => $08d336355350b722$export$c0112b8340d4924b);
$parcel$export(module.exports, "isMaxWidthAppearance", () => $08d336355350b722$export$ab050440a1241762);
$parcel$export(module.exports, "isFullPageAppearance", () => $08d336355350b722$export$a64737a81cde10b4);
$parcel$export(module.exports, "isCommentAppearance", () => $08d336355350b722$export$f77d2ff45b2c53ed);
$parcel$export(module.exports, "isFullWidthOrFullPageAppearance", () => $08d336355350b722$export$33331a99fac775a1);
var $08d336355350b722$export$c0112b8340d4924b = function isFullWidthAppearance(appearance) {
    return appearance === 'full-width';
};
var $08d336355350b722$export$ab050440a1241762 = function isMaxWidthAppearance(appearance) {
    return appearance === 'max';
};
var $08d336355350b722$export$a64737a81cde10b4 = function isFullPageAppearance(appearance) {
    return appearance === 'full-page';
};
var $08d336355350b722$export$f77d2ff45b2c53ed = function isCommentAppearance(appearance) {
    return appearance === 'comment';
};
var $08d336355350b722$export$33331a99fac775a1 = function isFullWidthOrFullPageAppearance(appearance) {
    return $08d336355350b722$export$a64737a81cde10b4(appearance) || $08d336355350b722$export$c0112b8340d4924b(appearance) || $08d336355350b722$export$ab050440a1241762(appearance);
};

});

parcelRegister("gdaDF", function(module, exports) {
$parcel$export(module.exports, "TableStickyScrollbar", () => $bcd61ce4d6efd477$export$8c072780619cfc83);

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $25nEq = parcelRequire("25nEq");

var $fMtrl = parcelRequire("fMtrl");

var $9Zzpd = parcelRequire("9Zzpd");
var $bcd61ce4d6efd477$export$8c072780619cfc83 = /*#__PURE__*/ function() {
    function TableStickyScrollbar(wrapper) {
        var _this = this;
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, TableStickyScrollbar);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "sentinels", {});
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "handleScroll", function(event) {
            if (!_this.stickyScrollbarContainerElement || !_this.wrapper || event.target !== _this.stickyScrollbarContainerElement) return;
            _this.wrapper.scrollLeft = _this.stickyScrollbarContainerElement.scrollLeft;
        });
        this.wrapper = wrapper;
        this.init();
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(TableStickyScrollbar, [
        {
            key: "dispose",
            value: function dispose() {
                if (this.stickyScrollbarContainerElement) // Ignored via go/ees005
                // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                this.stickyScrollbarContainerElement.removeEventListener('scroll', this.handleScroll);
                this.deleteIntersectionObserver();
            }
        },
        {
            key: "scrollLeft",
            value: function scrollLeft(left) {
                if (this.stickyScrollbarContainerElement) this.stickyScrollbarContainerElement.scrollLeft = left;
            }
        },
        {
            key: "init",
            value: function init() {
                var _this$wrapper$parentE, _this$wrapper$parentE2;
                if (!this.wrapper) return;
                var scrollbarContainers = (_this$wrapper$parentE = this.wrapper.parentElement) === null || _this$wrapper$parentE === void 0 ? void 0 : _this$wrapper$parentE.querySelectorAll(".".concat((0, $fMtrl.TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_CONTAINER));
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                this.stickyScrollbarContainerElement = (0, $9Zzpd.fg)('platform_editor_querySelector_fix_table_renderer') ? scrollbarContainers === null || scrollbarContainers === void 0 ? void 0 : scrollbarContainers.item(scrollbarContainers.length - 1) : (_this$wrapper$parentE2 = this.wrapper.parentElement) === null || _this$wrapper$parentE2 === void 0 ? void 0 : _this$wrapper$parentE2.querySelector(".".concat((0, $fMtrl.TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_CONTAINER));
                if (this.stickyScrollbarContainerElement) // Ignored via go/ees005
                // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                this.stickyScrollbarContainerElement.addEventListener('scroll', this.handleScroll, {
                    passive: true
                });
                this.createIntersectionObserver();
            }
        },
        {
            key: "createIntersectionObserver",
            value: function createIntersectionObserver() {
                var _this2 = this, _this$wrapper, _this$wrapper2, _this$wrapper3;
                this.rendererScrollableElement = window.document;
                if (!this.rendererScrollableElement || !this.wrapper) return;
                this.intersectionObserver = new IntersectionObserver(function(entries, _) {
                    if (!_this2.stickyScrollbarContainerElement) return;
                    entries.forEach(function(entry) {
                        // Ignored via go/ees005
                        // eslint-disable-next-line @atlaskit/editor/no-as-casting
                        var target = entry.target;
                        if (target.classList.contains((0, $fMtrl.TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_SENTINEL_BOTTOM)) _this2.sentinelBottomCallback(entry);
                        if (target.classList.contains((0, $fMtrl.TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_SENTINEL_TOP)) _this2.sentinelTopCallback(entry);
                    });
                }, {
                    root: this.rendererScrollableElement
                });
                var bottomSentinels = (_this$wrapper = this.wrapper) === null || _this$wrapper === void 0 || (_this$wrapper = _this$wrapper.parentElement) === null || _this$wrapper === void 0 ? void 0 : _this$wrapper.getElementsByClassName((0, $fMtrl.TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_SENTINEL_BOTTOM);
                this.sentinels.bottom = (0, $9Zzpd.fg)('platform_editor_querySelector_fix_table_renderer') ? bottomSentinels === null || bottomSentinels === void 0 ? void 0 : bottomSentinels.item(bottomSentinels.length - 1) : (_this$wrapper2 = this.wrapper) === null || _this$wrapper2 === void 0 || (_this$wrapper2 = _this$wrapper2.parentElement) === null || _this$wrapper2 === void 0 || (_this$wrapper2 = _this$wrapper2.getElementsByClassName((0, $fMtrl.TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_SENTINEL_BOTTOM)) === null || _this$wrapper2 === void 0 ? void 0 : _this$wrapper2.item(0);
                // Ignored via go/ees005
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                this.sentinels.top = (_this$wrapper3 = this.wrapper) === null || _this$wrapper3 === void 0 || (_this$wrapper3 = _this$wrapper3.parentElement) === null || _this$wrapper3 === void 0 || (_this$wrapper3 = _this$wrapper3.getElementsByClassName((0, $fMtrl.TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_SENTINEL_TOP)) === null || _this$wrapper3 === void 0 ? void 0 : _this$wrapper3.item(0);
                [
                    this.sentinels.bottom,
                    this.sentinels.top
                ].forEach(function(el) {
                    return(// Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    _this2.intersectionObserver.observe(el));
                });
            }
        },
        {
            key: "deleteIntersectionObserver",
            value: function deleteIntersectionObserver() {
                if (this.intersectionObserver) {
                    if (this.sentinels.bottom) this.intersectionObserver.unobserve(this.sentinels.bottom);
                    this.intersectionObserver.disconnect();
                }
            }
        },
        {
            key: "sentinelBottomCallback",
            value: function sentinelBottomCallback(entry) {
                var _entry$rootBounds;
                var sentinelIsAboveScrollArea = entry.boundingClientRect.top < (((_entry$rootBounds = entry.rootBounds) === null || _entry$rootBounds === void 0 ? void 0 : _entry$rootBounds.top) || 0);
                this.bottomSentinelState = sentinelIsAboveScrollArea ? 'above' : entry.isIntersecting ? 'visible' : 'below';
                this.toggle();
            }
        },
        {
            key: "sentinelTopCallback",
            value: function sentinelTopCallback(entry) {
                var _entry$rootBounds2;
                var sentinelIsBelowScrollArea = (((_entry$rootBounds2 = entry.rootBounds) === null || _entry$rootBounds2 === void 0 ? void 0 : _entry$rootBounds2.bottom) || 0) < entry.boundingClientRect.top;
                this.topSentinelState = sentinelIsBelowScrollArea ? 'below' : entry.isIntersecting ? 'visible' : 'above';
                this.toggle();
            }
        },
        {
            key: "toggle",
            value: function toggle() {
                if ((this.topSentinelState === 'visible' || this.topSentinelState === 'above') && this.bottomSentinelState === 'below') this.show();
                else this.hide();
            }
        },
        {
            key: "hide",
            value: function hide() {
                if (this.stickyScrollbarContainerElement && this.stickyScrollbarContainerElement.style.visibility !== 'hidden') this.stickyScrollbarContainerElement.style.visibility = 'hidden';
            }
        },
        {
            key: "show",
            value: function show() {
                if (this.stickyScrollbarContainerElement && this.stickyScrollbarContainerElement.style.visibility !== 'visible') this.stickyScrollbarContainerElement.style.visibility = 'visible';
            }
        }
    ]);
}();

});

parcelRegister("4WuBO", function(module, exports) {
$parcel$export(module.exports, "TableProcessorWithContainerStyles", () => TableProcessorWithContainerStyles);

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $kIXpt = parcelRequire("kIXpt");

var $cYPzS = parcelRequire("cYPzS");

var $eyuDe = parcelRequire("eyuDe");

var $25nEq = parcelRequire("25nEq");

var $5FkrB = parcelRequire("5FkrB");

var $fMtrl = parcelRequire("fMtrl");

var $hrVpF = parcelRequire("hrVpF");

var $13ECD = parcelRequire("13ECD");

var $9Zzpd = parcelRequire("9Zzpd");

var $3s4hn = parcelRequire("3s4hn");
var $il4RY = parcelRequire("il4RY");
var $1fkTi = parcelRequire("1fkTi");

var $gmeX4 = parcelRequire("gmeX4");

var $1LBcl = parcelRequire("1LBcl");

var $fAhSf = parcelRequire("fAhSf");

var $65d1I = parcelRequire("65d1I");

var $lAKm0 = parcelRequire("lAKm0");

var $dhEtU = parcelRequire("dhEtU");

var $KYtRS = parcelRequire("KYtRS");

var $gdaDF = parcelRequire("gdaDF");

var $drUcN = parcelRequire("drUcN");
function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function _objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function _createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function _unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return _arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
    }
}
function _arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function _callSuper(t, o, e) {
    return o = (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(o), (0, (/*@__PURE__*/$parcel$interopDefault($kIXpt)))(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(t).constructor) : o.apply(t, e));
}
function _isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return (_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var stickyContainerBaseStyles = {
    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
    height: "var(--ds-space-250, 20px)",
    // MAX_BROWSER_SCROLLBAR_HEIGHT
    // Follow editor to hide by default so it does not show empty gap in SSR
    // https://stash.atlassian.com/projects/ATLASSIAN/repos/atlassian-frontend-monorepo/browse/platform/packages/editor/editor-plugin-table/src/nodeviews/TableComponent.tsx#957
    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
    display: 'block',
    width: '100%'
};
var stickyContainerAdditionalStyles = {
    visibility: 'hidden',
    overflowX: 'auto',
    position: 'sticky',
    bottom: "var(--ds-space-0, 0px)",
    zIndex: 1
};
var isTableResizingEnabled = function isTableResizingEnabled(appearance) {
    return (0, $KYtRS.isFullWidthOrFullPageAppearance)(appearance) || (0, $KYtRS.isCommentAppearance)(appearance) && (0, $fAhSf.editorExperiment)('support_table_in_comment', true, {
        exposure: true
    });
};
var isStickyScrollbarEnabled = function isStickyScrollbarEnabled(appearance) {
    return (0, $KYtRS.isFullWidthOrFullPageAppearance)(appearance) && (0, $fAhSf.editorExperiment)('platform_renderer_table_sticky_scrollbar', true, {
        exposure: true
    });
};
var orderChildren = function orderChildren(children, tableNode, smartCardStorage, tableOrderStatus) {
    if (!tableOrderStatus || tableOrderStatus.order === (0, $gmeX4.SortOrder).NO_ORDER) return children;
    var order = tableOrderStatus.order, columnIndex = tableOrderStatus.columnIndex;
    var compareNodesInOrder = (0, $1fkTi.createCompareNodes)({
        getInlineCardTextFromStore: function getInlineCardTextFromStore(attrs) {
            var _ref = attrs, url = _ref.url;
            if (!url) return null;
            return smartCardStorage.get(url) || null;
        }
    }, order);
    var tableArray = (0, $il4RY.convertProsemirrorTableNodeToArrayOfRows)(tableNode);
    var tableArrayWithChildren = tableArray.map(function(rowNodes, index) {
        return {
            rowNodes: rowNodes,
            rowReact: children[index]
        };
    });
    var headerRow = tableArrayWithChildren.shift();
    var sortedTable = tableArrayWithChildren.sort(function(rowA, rowB) {
        return compareNodesInOrder(rowA.rowNodes[columnIndex], rowB.rowNodes[columnIndex]);
    });
    if (headerRow) sortedTable.unshift(headerRow);
    return sortedTable.map(function(elem) {
        return elem.rowReact;
    });
};
var hasRowspan = function hasRowspan(row) {
    var hasRowspan = false;
    row.forEach(function(cell) {
        return hasRowspan = hasRowspan || cell.attrs.rowspan > 1;
    });
    return hasRowspan;
};
var getRefTop = function getRefTop(refElement) {
    return Math.round(refElement.getBoundingClientRect().top);
};
var shouldHeaderStick = function shouldHeaderStick(scrollTop, tableTop, tableBottom, rowHeight) {
    return tableTop <= scrollTop && !(tableBottom - rowHeight <= scrollTop);
};
var shouldHeaderPinBottom = function shouldHeaderPinBottom(scrollTop, tableBottom, rowHeight) {
    return tableBottom - rowHeight <= scrollTop && !(tableBottom < scrollTop);
};
var addSortableColumn = function addSortableColumn(rows, tableOrderStatus, onSorting) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).Children.map(rows, function(row, index) {
        if (index === 0) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).cloneElement((0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).Children.only(row), {
            tableOrderStatus: tableOrderStatus,
            onSorting: onSorting
        });
        return row;
    });
};
var isHeaderRowEnabled = function isHeaderRowEnabled(rows) {
    if (!rows.length) return false;
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var children = rows[0].props.children;
    if (!children.length) return false;
    if (children.length === 1) return children[0].type === (0, $65d1I.TableHeader);
    return children.every(function(node) {
        return node.type === (0, $65d1I.TableHeader);
    });
};
var tableCanBeSticky = function tableCanBeSticky(node, children) {
    return isHeaderRowEnabled(children) && node && node.firstChild && !hasRowspan(node.firstChild);
};
var TableContainer = /*#__PURE__*/ function(_React$Component) {
    function TableContainer() {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, TableContainer);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _callSuper(this, TableContainer, [].concat(args));
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "state", {
            stickyMode: 'none',
            wrapperWidth: 0,
            headerRowHeight: 0
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "tableRef", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createRef());
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "stickyHeaderRef", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createRef());
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "stickyScrollbarRef", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createRef());
        // used for sync scroll + copying wrapper width to sticky header
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "stickyWrapperRef", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createRef());
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "wrapperRef", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createRef());
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "overflowParent", null);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "updatedLayout", 'custom');
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "resizeObserver", null);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "applyResizerChange", function(entries) {
            var wrapperWidth = _this.state.wrapperWidth;
            var headerRowHeight = _this.state.headerRowHeight;
            var _iterator = _createForOfIteratorHelper(entries), _step;
            try {
                for(_iterator.s(); !(_step = _iterator.n()).done;){
                    var entry = _step.value;
                    if (entry.target === _this.wrapperRef.current) wrapperWidth = entry.contentRect.width;
                    else if (entry.target === _this.stickyHeaderRef.current) headerRowHeight = Math.round(entry.contentRect.height);
                }
            } catch (err) {
                _iterator.e(err);
            } finally{
                _iterator.f();
            }
            if (headerRowHeight !== _this.state.headerRowHeight || wrapperWidth !== _this.state.wrapperWidth) _this.setState({
                wrapperWidth: wrapperWidth,
                headerRowHeight: headerRowHeight
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "componentWillUnmount", function() {
            if (_this.overflowParent) // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            _this.overflowParent.removeEventListener('scroll', _this.onScroll);
            if (_this.nextFrame) cancelAnimationFrame(_this.nextFrame);
            if (_this.resizeObserver) _this.resizeObserver.disconnect();
            if (_this.stickyScrollbar) _this.stickyScrollbar.dispose();
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "getScrollTop", function() {
            var stickyHeaders = _this.props.stickyHeaders;
            var offsetTop = stickyHeaders && stickyHeaders.offsetTop || 0;
            return (_this.overflowParent ? _this.overflowParent.top : 0) + offsetTop;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "updateSticky", function() {
            var tableElem = _this.tableRef.current;
            var refElem = _this.stickyHeaderRef.current;
            if (!tableElem || !refElem) return;
            var scrollTop = _this.getScrollTop() + (0, $lAKm0.tableStickyPadding);
            var tableTop = getRefTop(tableElem);
            var tableBottom = tableTop + tableElem.clientHeight;
            var shouldSticky = shouldHeaderStick(scrollTop, tableTop, tableBottom, refElem.clientHeight);
            var shouldPin = shouldHeaderPinBottom(scrollTop, tableBottom, refElem.clientHeight);
            var stickyMode = 'none';
            if (shouldPin) stickyMode = 'pin-bottom';
            else if (shouldSticky) stickyMode = 'stick';
            if (_this.state.stickyMode !== stickyMode) _this.setState({
                stickyMode: stickyMode
            });
            _this.nextFrame = undefined;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "onScroll", function() {
            if (!_this.nextFrame) _this.nextFrame = requestAnimationFrame(_this.updateSticky);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "onWrapperScrolled", function() {
            if (!_this.wrapperRef.current || !_this.stickyWrapperRef.current) return;
            _this.stickyWrapperRef.current.scrollLeft = _this.wrapperRef.current.scrollLeft;
            if (_this.stickyScrollbarRef.current) _this.stickyScrollbarRef.current.scrollLeft = _this.wrapperRef.current.scrollLeft;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "grabFirstRowRef", function(children) {
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            return (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).Children.map(children || false, function(child, idx) {
                if (idx === 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).isValidElement(child)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).cloneElement(child, {
                    innerRef: _this.stickyHeaderRef
                });
                return child;
            });
        });
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($eyuDe)))(TableContainer, _React$Component);
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(TableContainer, [
        {
            key: "componentDidMount",
            value: /**
     *
     * @example
     */ function componentDidMount() {
                this.resizeObserver = new ResizeObserver(this.applyResizerChange);
                if (this.wrapperRef.current) this.resizeObserver.observe(this.wrapperRef.current);
                if (this.stickyHeaderRef.current) this.resizeObserver.observe(this.stickyHeaderRef.current);
                if (this.props.stickyHeaders) {
                    var _this$props$stickyHea;
                    this.overflowParent = (0, $lAKm0.OverflowParent).fromElement(this.tableRef.current, (_this$props$stickyHea = this.props.stickyHeaders) === null || _this$props$stickyHea === void 0 ? void 0 : _this$props$stickyHea.defaultScrollRootId_DO_NOT_USE);
                    // Ignored via go/ees005
                    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                    this.overflowParent.addEventListener('scroll', this.onScroll);
                }
                if (this.wrapperRef.current && isStickyScrollbarEnabled(this.props.rendererAppearance)) this.stickyScrollbar = new (0, $gdaDF.TableStickyScrollbar)(this.wrapperRef.current);
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps, prevState) {
                // toggling sticky headers visiblity
                if (this.props.stickyHeaders && !this.overflowParent) {
                    var _this$props$stickyHea2;
                    this.overflowParent = (0, $lAKm0.OverflowParent).fromElement(this.tableRef.current, (_this$props$stickyHea2 = this.props.stickyHeaders) === null || _this$props$stickyHea2 === void 0 ? void 0 : _this$props$stickyHea2.defaultScrollRootId_DO_NOT_USE);
                } else if (!this.props.stickyHeaders && this.overflowParent) {
                    // Ignored via go/ees005
                    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                    this.overflowParent.removeEventListener('scroll', this.onScroll);
                    this.overflowParent = null;
                }
                // offsetTop might have changed, re-position sticky header
                if (this.props.stickyHeaders !== prevProps.stickyHeaders) this.updateSticky();
                // sync horizontal scroll in floating div when toggling modes
                if (prevState.stickyMode !== this.state.stickyMode) this.onWrapperScrolled();
            }
        },
        {
            key: "pinTop",
            get: /**
     *
     */ function get() {
                if (!this.tableRef.current || !this.stickyHeaderRef.current) return;
                return this.tableRef.current.offsetHeight - this.stickyHeaderRef.current.offsetHeight + (0, $fMtrl.tableMarginTop) - (0, $lAKm0.tableStickyPadding);
            }
        },
        {
            key: "shouldAddOverflowParentOffsetTop_DO_NOT_USE",
            get: function get() {
                // IF the StickyHeaderConfig specifies that the default scroll root offsetTop should be added
                // AND the StickyHeaderConfig specifies a default scroll root id
                // AND the OverflowParent is the corresponding element
                // THEN we should add the OverflowParent offset top (RETURN TRUE)
                return this.props.stickyHeaders && !!this.props.stickyHeaders.shouldAddDefaultScrollRootOffsetTop_DO_NOT_USE && !!this.props.stickyHeaders.defaultScrollRootId_DO_NOT_USE && this.overflowParent && this.overflowParent.id === this.props.stickyHeaders.defaultScrollRootId_DO_NOT_USE;
            }
        },
        {
            key: "stickyTop",
            get: function get() {
                switch(this.state.stickyMode){
                    case 'pin-bottom':
                        return this.pinTop;
                    case 'stick':
                        var offsetTop = this.props.stickyHeaders && this.props.stickyHeaders.offsetTop;
                        if (typeof offsetTop === 'number' && this.shouldAddOverflowParentOffsetTop_DO_NOT_USE) {
                            var overflowParentOffsetTop = this.overflowParent ? this.overflowParent.top : 0;
                            return offsetTop + overflowParentOffsetTop;
                        } else return offsetTop;
                    default:
                        return undefined;
                }
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$tableRef$curren;
                var _this$props = this.props, isNumberColumnEnabled = _this$props.isNumberColumnEnabled, layout = _this$props.layout, columnWidths = _this$props.columnWidths, stickyHeaders = _this$props.stickyHeaders, tableNode = _this$props.tableNode, rendererAppearance = _this$props.rendererAppearance, isInsideOfBlockNode = _this$props.isInsideOfBlockNode, isInsideOfTable = _this$props.isInsideOfTable, isinsideMultiBodiedExtension = _this$props.isinsideMultiBodiedExtension, allowTableAlignment = _this$props.allowTableAlignment, allowTableResizing = _this$props.allowTableResizing, isPresentational = _this$props.isPresentational;
                var stickyMode = this.state.stickyMode;
                var lineLengthFixedWidth = (0, $1LBcl.akEditorDefaultLayoutWidth);
                var updatedLayout;
                var fullPageRendererWidthCSS = (0, $fAhSf.editorExperiment)('platform_editor_preview_panel_responsiveness', true, {
                    exposure: true
                }) ? 'calc(100cqw - var(--ak-renderer--full-page-gutter) * 2)' : "100cqw - ".concat((0, $13ECD.FullPagePadding), "px * 2");
                var renderWidthCSS = rendererAppearance === 'full-page' ? fullPageRendererWidthCSS : "100cqw";
                var calcDefaultLayoutWidthByAppearance = function calcDefaultLayoutWidthByAppearance(rendererAppearance, tableNode) {
                    if (rendererAppearance === 'max' && !(tableNode !== null && tableNode !== void 0 && tableNode.attrs.width) && (0, $drUcN.expValEquals)('editor_tinymce_full_width_mode', 'isEnabled', true)) return "min(".concat((0, $1LBcl.akEditorMaxWidthLayoutWidth), "px, ").concat(renderWidthCSS, ")");
                    else if (rendererAppearance === 'full-width' && !(tableNode !== null && tableNode !== void 0 && tableNode.attrs.width)) return "min(".concat((0, $1LBcl.akEditorFullWidthLayoutWidth), "px, ").concat(renderWidthCSS, ")");
                    else if (rendererAppearance === 'comment' && allowTableResizing && !(tableNode !== null && tableNode !== void 0 && tableNode.attrs.width)) return renderWidthCSS;
                    else {
                        // custom width, or width mapped to breakpoint
                        var tableContainerWidth = (0, $hrVpF.getTableContainerWidth)(tableNode);
                        return "min(".concat(tableContainerWidth, "px, ").concat(renderWidthCSS, ")");
                    }
                };
                var tableWidthCSS = calcDefaultLayoutWidthByAppearance(rendererAppearance, tableNode);
                // Logic for table alignment in renderer
                var isTableAlignStart = tableNode && tableNode.attrs && tableNode.attrs.layout === 'align-start' && allowTableAlignment;
                var fullWidthLineLengthCSS = "min(".concat((0, $1LBcl.akEditorFullWidthLayoutWidth), "px, ").concat(renderWidthCSS, ")");
                var maxWidthLineLengthCSS = "min(".concat((0, $1LBcl.akEditorMaxWidthLayoutWidth), "px, ").concat(renderWidthCSS, ")");
                var isCommentAppearanceAndTableAlignmentEnabled = (0, $KYtRS.isCommentAppearance)(rendererAppearance) && allowTableAlignment;
                var lineLengthCSS = (0, $KYtRS.isFullWidthAppearance)(rendererAppearance) ? fullWidthLineLengthCSS : (0, $KYtRS.isMaxWidthAppearance)(rendererAppearance) && (0, $drUcN.expValEquals)('editor_tinymce_full_width_mode', 'isEnabled', true) ? maxWidthLineLengthCSS : isCommentAppearanceAndTableAlignmentEnabled ? renderWidthCSS : "".concat(lineLengthFixedWidth, "px");
                var tableWidthNew = (0, $hrVpF.getTableContainerWidth)(tableNode);
                var shouldCalculateLeftForAlignment = !isInsideOfBlockNode && !isInsideOfTable && isTableAlignStart && ((0, $KYtRS.isFullPageAppearance)(rendererAppearance) && tableWidthNew <= lineLengthFixedWidth || (0, $KYtRS.isFullWidthAppearance)(rendererAppearance) || (0, $KYtRS.isMaxWidthAppearance)(rendererAppearance) && (0, $drUcN.expValEquals)('editor_tinymce_full_width_mode', 'isEnabled', true) || isCommentAppearanceAndTableAlignmentEnabled);
                var leftCSS;
                if (shouldCalculateLeftForAlignment) leftCSS = "(".concat(tableWidthCSS, " - ").concat(lineLengthCSS, ") / 2");
                if (!shouldCalculateLeftForAlignment && (0, $KYtRS.isFullPageAppearance)(rendererAppearance)) // Note tableWidthCSS here is the renderer width
                // When the screen is super wide we want table to break out.
                // However if screen is smaller than 760px. We want table align to left.
                leftCSS = "min(0px, ".concat(lineLengthCSS, " - ").concat(tableWidthCSS, ") / 2");
                var children = (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).Children.toArray(this.props.children);
                // Historically, tables in the full-width renderer had their layout set to 'default' which is deceiving.
                // This check caters for those tables and helps with SSR logic
                var isFullWidth = !(tableNode !== null && tableNode !== void 0 && tableNode.attrs.width) && rendererAppearance === 'full-width' && layout !== 'full-width';
                if (isFullWidth) updatedLayout = 'full-width';
                else if (tableNode !== null && tableNode !== void 0 && tableNode.attrs.width) updatedLayout = 'custom';
                else updatedLayout = layout;
                var finalTableContainerWidth = allowTableResizing ? tableWidthNew : 'inherit';
                // We can only use CSS to determine the width when we have a known width in container.
                // When appearance is full-page, full-width or comment we use CSS based width calculation.
                // Otherwise it's fixed table width (customized width) or inherit.
                if (rendererAppearance === 'full-page' || rendererAppearance === 'full-width' || rendererAppearance === 'max' && (0, $drUcN.expValEquals)('editor_tinymce_full_width_mode', 'isEnabled', true)) finalTableContainerWidth = allowTableResizing ? "calc(".concat(tableWidthCSS, ")") : 'inherit';
                if (rendererAppearance === 'comment' && allowTableResizing && !allowTableAlignment) // If table alignment is disabled and table width is akEditorDefaultLayoutWidth = 760,
                // it is most likely a table created before "Support Table in Comments" FF was enabled
                // and we would see a bug ED-24795. A table created before "Support Table in Comments",
                // should inhirit the width of the renderer container.
                // !NOTE: it a table resized to 760 is copied from 'full-page' editor and pasted in comment editor
                // where (allowTableResizing && !allowTableAlignment), the table will loose 760px width.
                finalTableContainerWidth = tableNode !== null && tableNode !== void 0 && tableNode.attrs.width && (tableNode === null || tableNode === void 0 ? void 0 : tableNode.attrs.width) !== (0, $1LBcl.akEditorDefaultLayoutWidth) ? "calc(".concat(tableWidthCSS, ")") : 'inherit';
                if (rendererAppearance === 'comment' && allowTableResizing && allowTableAlignment) // If table alignment is enabled and layout is not 'align-start' or 'center', we are loading a table that was
                // created before "Support Table in Comments" FF was enabled. So the table should have the same width as renderer container
                // instead of 760 that was set on tableNode when the table had been published.
                finalTableContainerWidth = ((tableNode === null || tableNode === void 0 ? void 0 : tableNode.attrs.layout) === 'align-start' || (tableNode === null || tableNode === void 0 ? void 0 : tableNode.attrs.layout) === 'center') && tableNode !== null && tableNode !== void 0 && tableNode.attrs.width ? "calc(".concat(tableWidthCSS, ")") : 'inherit';
                var style = {
                    width: finalTableContainerWidth,
                    left: leftCSS ? "calc(".concat(leftCSS, ")") : undefined,
                    marginLeft: shouldCalculateLeftForAlignment && leftCSS !== undefined ? "calc(-1 * (".concat(leftCSS, "))") : undefined
                };
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("div", {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                    className: "".concat((0, $fMtrl.TableSharedCssClassName).TABLE_CONTAINER, " ").concat(this.props.shadowClassNames || ''),
                    "data-layout": updatedLayout,
                    "data-testid": "table-container",
                    ref: this.props.handleRef,
                    style: style
                }, isStickyScrollbarEnabled(this.props.rendererAppearance) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("div", {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                    className: (0, $fMtrl.TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_SENTINEL_TOP,
                    "data-testid": "sticky-scrollbar-sentinel-top"
                }), stickyHeaders && tableNode && tableCanBeSticky(tableNode, children) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $lAKm0.StickyTable), {
                    isNumberColumnEnabled: isNumberColumnEnabled,
                    tableWidth: "inherit",
                    renderWidth: 0,
                    layout: layout,
                    handleRef: this.props.handleRef,
                    shadowClassNames: this.props.shadowClassNames,
                    top: this.stickyTop,
                    mode: stickyMode,
                    innerRef: this.stickyWrapperRef,
                    wrapperWidth: this.state.wrapperWidth,
                    columnWidths: columnWidths,
                    rowHeight: this.state.headerRowHeight,
                    tableNode: tableNode,
                    rendererAppearance: rendererAppearance,
                    allowTableResizing: allowTableResizing,
                    fixTableSSRResizing: true
                }, [
                    children && children[0]
                ]), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("div", {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                    className: (0, $fMtrl.TableSharedCssClassName).TABLE_NODE_WRAPPER,
                    ref: this.wrapperRef,
                    "data-number-column": tableNode === null || tableNode === void 0 ? void 0 : tableNode.attrs.isNumberColumnEnabled,
                    "data-layout": tableNode === null || tableNode === void 0 ? void 0 : tableNode.attrs.layout,
                    "data-autosize": tableNode === null || tableNode === void 0 ? void 0 : tableNode.attrs.__autoSize,
                    "data-table-local-id": tableNode === null || tableNode === void 0 ? void 0 : tableNode.attrs.localId,
                    "data-table-width": tableNode === null || tableNode === void 0 ? void 0 : tableNode.attrs.width,
                    "data-vc": "table-node-wrapper",
                    onScroll: this.props.stickyHeaders && this.onWrapperScrolled
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $dhEtU.Table), {
                    innerRef: this.tableRef,
                    columnWidths: columnWidths,
                    layout: layout,
                    renderWidth: 0,
                    isNumberColumnEnabled: isNumberColumnEnabled,
                    tableNode: tableNode,
                    rendererAppearance: rendererAppearance,
                    isInsideOfBlockNode: isInsideOfBlockNode,
                    isInsideOfTable: isInsideOfTable,
                    isinsideMultiBodiedExtension: isinsideMultiBodiedExtension,
                    allowTableResizing: allowTableResizing,
                    isPresentational: isPresentational
                }, this.grabFirstRowRef(children))), isStickyScrollbarEnabled(this.props.rendererAppearance) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("div", {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                    className: "".concat((0, $fMtrl.TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_CONTAINER).concat((0, $9Zzpd.fg)('confluence_frontend_table_scrollbar_ttvc_fix') ? '-view-page' : ''),
                    ref: this.stickyScrollbarRef,
                    "data-vc": "table-sticky-scrollbar-container",
                    style: (0, $9Zzpd.fg)('confluence_frontend_table_scrollbar_ttvc_fix') ? _objectSpread(_objectSpread({}, stickyContainerBaseStyles), stickyContainerAdditionalStyles) : stickyContainerBaseStyles
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("div", {
                    style: {
                        width: (0, $9Zzpd.fg)('confluence_frontend_table_scrollbar_ttvc_fix') ? '100%' : (_this$tableRef$curren = this.tableRef.current) === null || _this$tableRef$curren === void 0 ? void 0 : _this$tableRef$curren.clientWidth,
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                        height: '100%'
                    }
                })), isStickyScrollbarEnabled(this.props.rendererAppearance) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("div", {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                    className: (0, $fMtrl.TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_SENTINEL_BOTTOM,
                    "data-testid": "sticky-scrollbar-sentinel-bottom"
                })));
            }
        }
    ]);
}((0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).Component);
var TableProcessorWithContainerStyles = /*#__PURE__*/ function(_React$Component2) {
    function TableProcessorWithContainerStyles() {
        var _this2;
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, TableProcessorWithContainerStyles);
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        _this2 = _callSuper(this, TableProcessorWithContainerStyles, [].concat(args));
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this2, "state", {
            tableOrderStatus: undefined
        });
        // adds sortable + re-orders children
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this2, "addSortableColumn", function(childrenArray) {
            var _this2$props = _this2.props, tableNode = _this2$props.tableNode, allowColumnSorting = _this2$props.allowColumnSorting, smartCardStorage = _this2$props.smartCardStorage;
            var tableOrderStatus = _this2.state.tableOrderStatus;
            if (allowColumnSorting && isHeaderRowEnabled(childrenArray) && tableNode && !(0, $il4RY.hasMergedCell)(tableNode)) return addSortableColumn(orderChildren(childrenArray, tableNode, smartCardStorage, tableOrderStatus), tableOrderStatus, _this2.changeSortOrder);
            return childrenArray;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this2, "changeSortOrder", function(columnIndex, sortOrder) {
            _this2.setState({
                tableOrderStatus: {
                    columnIndex: columnIndex,
                    order: sortOrder
                }
            });
        });
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this2, "addNumberColumnIndexes", function(rows) {
            var isNumberColumnEnabled = _this2.props.isNumberColumnEnabled;
            var headerRowEnabled = isHeaderRowEnabled(rows);
            return (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).Children.map(rows, function(row, index) {
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).cloneElement((0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).Children.only(row), {
                    isNumberColumnEnabled: isNumberColumnEnabled,
                    index: headerRowEnabled ? index === 0 ? '' : index : index + 1
                });
            });
        });
        return _this2;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($eyuDe)))(TableProcessorWithContainerStyles, _React$Component2);
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(TableProcessorWithContainerStyles, [
        {
            key: "render",
            value: /**
     *
     * @example
     */ function render() {
                var children = this.props.children;
                if (!children) return null;
                var childrenArray = (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).Children.toArray(children);
                var orderedChildren = (0, $3s4hn.compose)(this.addNumberColumnIndexes, this.addSortableColumn)(childrenArray);
                // Ignored via go/ees005
                // eslint-disable-next-line react/jsx-props-no-spreading
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(TableContainer, this.props, orderedChildren);
            }
        }
    ]);
}((0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).Component);

});


parcelRegister("5FiyC", function(module, exports) {
$parcel$export(module.exports, "default", () => $41ff2d2e501c158e$export$2e2bcd8739ae039);

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $kIXpt = parcelRequire("kIXpt");

var $cYPzS = parcelRequire("cYPzS");

var $eyuDe = parcelRequire("eyuDe");

var $25nEq = parcelRequire("25nEq");

var $5FkrB = parcelRequire("5FkrB");

var $3s4hn = parcelRequire("3s4hn");

var $gmeX4 = parcelRequire("gmeX4");

var $53SBn = parcelRequire("53SBn");
function $41ff2d2e501c158e$var$_callSuper(t, o, e) {
    return o = (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(o), (0, (/*@__PURE__*/$parcel$interopDefault($kIXpt)))(t, $41ff2d2e501c158e$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(t).constructor) : o.apply(t, e));
}
function $41ff2d2e501c158e$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($41ff2d2e501c158e$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
// Ignored via go/ees005
// eslint-disable-next-line @repo/internal/react/no-class-components
var $41ff2d2e501c158e$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_React$Component) {
    function TableRow() {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, TableRow);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = $41ff2d2e501c158e$var$_callSuper(this, TableRow, [].concat(args));
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "state", {
            colGroupWidths: []
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "addSortableColumn", function(childrenArray) {
            var _this$props = _this.props, allowColumnSorting = _this$props.allowColumnSorting, rowIndex = _this$props.index;
            var isHeaderRow = !rowIndex;
            if (allowColumnSorting && isHeaderRow) childrenArray = childrenArray.map(function(child, index) {
                if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).isValidElement(child)) {
                    var tableOrderStatus = _this.props.tableOrderStatus;
                    var sortOrdered = (0, $gmeX4.SortOrder).NO_ORDER;
                    if (tableOrderStatus) sortOrdered = index === tableOrderStatus.columnIndex ? tableOrderStatus.order : (0, $gmeX4.SortOrder).NO_ORDER;
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).cloneElement(child, {
                        columnIndex: index,
                        onSorting: _this.props.onSorting,
                        sortOrdered: sortOrdered,
                        isHeaderRow: isHeaderRow
                    });
                }
            });
            return childrenArray;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "addColGroupWidth", function(childrenArray) {
            var _this$state$colGroupW;
            if ((_this$state$colGroupW = _this.state.colGroupWidths) !== null && _this$state$colGroupW !== void 0 && _this$state$colGroupW.length) childrenArray = childrenArray.map(function(child, index) {
                if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).isValidElement(child)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).cloneElement(child, {
                    colGroupWidth: _this.state.colGroupWidths[index]
                });
            });
            return childrenArray;
        });
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($eyuDe)))(TableRow, _React$Component);
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(TableRow, [
        {
            key: "render",
            value: function render() {
                var _this$props2 = this.props, children = _this$props2.children, innerRef = _this$props2.innerRef;
                var childrenArray = (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).Children.toArray(children);
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("tr", {
                    ref: innerRef
                }, this.props.isNumberColumnEnabled && /*#__PURE__*/ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("td", {
                    className: (0, $53SBn.RendererCssClassName).NUMBER_COLUMN
                }, this.props.index), (0, $3s4hn.compose)(this.addSortableColumn, this.addColGroupWidth)(childrenArray));
            }
        }
    ]);
}((0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).Component);

});

parcelRegister("fK54y", function(module, exports) {
$parcel$export(module.exports, "default", () => $b75f1629470d9b1b$export$2e2bcd8739ae039);

var $5FkrB = parcelRequire("5FkrB");
function $b75f1629470d9b1b$export$2e2bcd8739ae039(props) {
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("div", {
        className: "UnknownBlock"
    }, props.children);
}

});

parcelRegister("bHoWr", function(module, exports) {

var $iKwew = parcelRequire("iKwew");
module.exports = $iKwew("j4QBD").then(()=>parcelRequire('4hE9f'));

});

parcelRegister("73HyM", function(module, exports) {

var $iKwew = parcelRequire("iKwew");
module.exports = Promise.all([
    $iKwew("2cSUL"),
    $iKwew("g0TIv")
]).then(()=>parcelRequire('5CR1A'));

});

parcelRegister("ahHfv", function(module, exports) {

var $iKwew = parcelRequire("iKwew");
module.exports = $iKwew("luehB").then(()=>parcelRequire('lKUgJ'));

});

parcelRegister("1enik", function(module, exports) {

var $iKwew = parcelRequire("iKwew");
module.exports = $iKwew("1c9eM").then(()=>parcelRequire('7Gk8b'));

});

parcelRegister("bfIlp", function(module, exports) {

var $iKwew = parcelRequire("iKwew");
module.exports = $iKwew("lTFer").then(()=>parcelRequire('hmytH'));

});

parcelRegister("laTH3", function(module, exports) {

var $iKwew = parcelRequire("iKwew");
module.exports = $iKwew("dXLwt").then(()=>parcelRequire('cat7i'));

});

parcelRegister("1Oi6Q", function(module, exports) {

var $iKwew = parcelRequire("iKwew");
module.exports = $iKwew("ZeF87").then(()=>parcelRequire('5Kz7L'));

});

parcelRegister("bAEpH", function(module, exports) {

var $iKwew = parcelRequire("iKwew");
module.exports = $iKwew("1Nc0s").then(()=>parcelRequire('laBdk'));

});

parcelRegister("4Sk34", function(module, exports) {

var $iKwew = parcelRequire("iKwew");
module.exports = $iKwew("dB391").then(()=>parcelRequire('fNWSO'));

});

parcelRegister("4IZkt", function(module, exports) {

var $iKwew = parcelRequire("iKwew");
module.exports = Promise.all([
    $iKwew("dB391"),
    $iKwew("daJIT")
]).then(()=>parcelRequire('6fzc3'));

});

parcelRegister("cNkzS", function(module, exports) {

var $iKwew = parcelRequire("iKwew");
module.exports = Promise.all([
    $iKwew("klQA0"),
    $iKwew("gyN0a"),
    $iKwew("9Q4Fd"),
    $iKwew("chJ63"),
    $iKwew("bWZor")
]).then(()=>parcelRequire('1t1Nh'));

});

parcelRegister("2W7Eu", function(module, exports) {

var $iKwew = parcelRequire("iKwew");
module.exports = Promise.all([
    $iKwew("gyN0a"),
    $iKwew("9Q4Fd")
]).then(()=>parcelRequire('5UpN9'));

});

parcelRegister("1JpLn", function(module, exports) {

var $iKwew = parcelRequire("iKwew");
module.exports = Promise.all([
    $iKwew("gyN0a"),
    $iKwew("9Q4Fd"),
    $iKwew("chJ63")
]).then(()=>parcelRequire('lEFXS'));

});

parcelRegister("39Ap2", function(module, exports) {

var $iKwew = parcelRequire("iKwew");
module.exports = Promise.all([
    $iKwew("8OpEs"),
    $iKwew("avedu"),
    $iKwew("klQA0"),
    $iKwew("hPp8h"),
    $iKwew("knhFz"),
    $iKwew("e3dbm"),
    $iKwew("hZLj1"),
    $iKwew("fxnVM"),
    $iKwew("8z7xJ"),
    $iKwew("jaqgk"),
    $iKwew("9KlEX"),
    $iKwew("ldt0C"),
    $iKwew("4yN8Z"),
    $iKwew("2GrMW"),
    $iKwew("1Ah6C"),
    $iKwew("lxGQI"),
    $iKwew("jjQxd"),
    $iKwew("gyN0a"),
    $iKwew("HrFTV")
]).then(()=>parcelRequire('drRJk'));

});

parcelRegister("2bcaO", function(module, exports) {

var $iKwew = parcelRequire("iKwew");
module.exports = $iKwew("9Q5nO").then(()=>parcelRequire('fDe2F'));

});

parcelRegister("eDoW2", function(module, exports) {

var $iKwew = parcelRequire("iKwew");
module.exports = Promise.all([
    $iKwew("8OpEs"),
    $iKwew("avedu"),
    $iKwew("hPp8h"),
    $iKwew("knhFz"),
    $iKwew("e3dbm"),
    $iKwew("hZLj1"),
    $iKwew("fxnVM"),
    $iKwew("8z7xJ"),
    $iKwew("jaqgk"),
    $iKwew("9KlEX"),
    $iKwew("ldt0C"),
    $iKwew("4yN8Z"),
    $iKwew("2GrMW"),
    $iKwew("1Ah6C"),
    $iKwew("lxGQI"),
    $iKwew("jjQxd"),
    $iKwew("gyN0a"),
    $iKwew("iTKQz")
]).then(()=>parcelRequire('yvHLt'));

});

parcelRegister("hvJEH", function(module, exports) {

var $iKwew = parcelRequire("iKwew");
module.exports = Promise.all([
    $iKwew("klQA0"),
    $iKwew("ii3mC")
]).then(()=>parcelRequire('2olcs'));

});

parcelRegister("hM7Ra", function(module, exports) {

var $iKwew = parcelRequire("iKwew");
module.exports = $iKwew("k0PNK").then(()=>parcelRequire('fHLTP'));

});

parcelRegister("1o3cc", function(module, exports) {

var $iKwew = parcelRequire("iKwew");
module.exports = $iKwew("jZMhO").then(()=>parcelRequire('PMdqA'));

});

parcelRegister("61mDg", function(module, exports) {

var $iKwew = parcelRequire("iKwew");
module.exports = $iKwew("9uy2k").then(()=>parcelRequire('dVBiK'));

});

parcelRegister("8GAYC", function(module, exports) {

var $iKwew = parcelRequire("iKwew");
module.exports = $iKwew("6yob9").then(()=>parcelRequire('7kspH'));

});


parcelRegister("jRLnM", function(module, exports) {
$parcel$export(module.exports, "PanelType", () => $e767b8c46860fddd$export$969277cf61e5a7aa);
$parcel$export(module.exports, "extendedPanel", () => $e767b8c46860fddd$export$ce20b13564211141);
$parcel$export(module.exports, "extendedPanelWithLocalId", () => $e767b8c46860fddd$export$855c3c67c9c9ebaf);

var $25nEq = parcelRequire("25nEq");

var $hibjE = parcelRequire("hibjE");

var $l56lt = parcelRequire("l56lt");
function $e767b8c46860fddd$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $e767b8c46860fddd$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $e767b8c46860fddd$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $e767b8c46860fddd$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $e767b8c46860fddd$export$969277cf61e5a7aa = /*#__PURE__*/ function(PanelType) {
    PanelType["INFO"] = "info";
    PanelType["NOTE"] = "note";
    PanelType["TIP"] = "tip";
    PanelType["WARNING"] = "warning";
    PanelType["ERROR"] = "error";
    PanelType["SUCCESS"] = "success";
    PanelType["CUSTOM"] = "custom";
    return PanelType;
}({});
/**
 * @name panel_node
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
var $e767b8c46860fddd$var$getDomAttrs = function getDomAttrs(nodeAttrs) {
    var attrs = {
        'data-panel-type': nodeAttrs.panelType,
        'data-panel-icon': nodeAttrs.panelIcon,
        'data-panel-icon-id': nodeAttrs.panelIconId,
        'data-panel-icon-text': nodeAttrs.panelIconText,
        'data-panel-color': nodeAttrs.panelColor,
        'data-local-id': (nodeAttrs === null || nodeAttrs === void 0 ? void 0 : nodeAttrs.localId) || undefined
    };
    return attrs;
};
var $e767b8c46860fddd$var$getParseDOMAttrs = function getParseDOMAttrs(allowCustomPanel, dom, generateLocalId) {
    var parseDOMAttrs = {
        // eslint-disable-next-line @atlaskit/editor/no-as-casting, @typescript-eslint/no-non-null-assertion
        panelType: dom.getAttribute('data-panel-type')
    };
    if (generateLocalId) parseDOMAttrs.localId = (0, $l56lt.uuid).generate();
    if (allowCustomPanel) parseDOMAttrs = $e767b8c46860fddd$var$_objectSpread($e767b8c46860fddd$var$_objectSpread({}, parseDOMAttrs), {}, {
        // eslint-disable-next-line @atlaskit/editor/no-as-casting, @typescript-eslint/no-non-null-assertion
        panelIcon: dom.getAttribute('data-panel-icon'),
        // eslint-disable-next-line @atlaskit/editor/no-as-casting, @typescript-eslint/no-non-null-assertion
        panelIconId: dom.getAttribute('data-panel-icon-id'),
        // eslint-disable-next-line @atlaskit/editor/no-as-casting, @typescript-eslint/no-non-null-assertion
        panelIconText: dom.getAttribute('data-panel-icon-text'),
        // eslint-disable-next-line @atlaskit/editor/no-as-casting, @typescript-eslint/no-non-null-assertion
        panelColor: dom.getAttribute('data-panel-color')
    });
    else parseDOMAttrs.panelType = parseDOMAttrs.panelType === $e767b8c46860fddd$export$969277cf61e5a7aa.CUSTOM ? $e767b8c46860fddd$export$969277cf61e5a7aa.INFO : parseDOMAttrs.panelType;
    return parseDOMAttrs;
};
var $e767b8c46860fddd$var$createPanelNodeSpecOptions = function createPanelNodeSpecOptions(allowCustomPanel, generateLocalId) {
    return {
        parseDOM: [
            {
                tag: 'div[data-panel-type]',
                getAttrs: function getAttrs(dom) {
                    return $e767b8c46860fddd$var$getParseDOMAttrs(allowCustomPanel, dom, generateLocalId);
                }
            }
        ],
        toDOM: function toDOM(node) {
            var attrs = $e767b8c46860fddd$var$getDomAttrs(node.attrs);
            var contentAttrs = {
                'data-panel-content': 'true'
            };
            return [
                'div',
                attrs,
                [
                    'div',
                    contentAttrs,
                    0
                ]
            ];
        }
    };
};
var $e767b8c46860fddd$export$ce20b13564211141 = function extendedPanel(allowCustomPanel) {
    return (0, $hibjE.panel)($e767b8c46860fddd$var$createPanelNodeSpecOptions(allowCustomPanel));
};
var $e767b8c46860fddd$export$855c3c67c9c9ebaf = function extendedPanelWithLocalId(allowCustomPanel) {
    return (0, $hibjE.panel)($e767b8c46860fddd$var$createPanelNodeSpecOptions(allowCustomPanel, true));
};

});

parcelRegister("iVSxl", function(module, exports) {
$parcel$export(module.exports, "editorExperiment", () => $dc87dabffd76a197$export$9b7cf3b74f250027);
/* eslint-disable @atlaskit/editor/no-re-export */ // Entry file in package.json

var $ivkVy = parcelRequire("ivkVy");

var $49qw5 = parcelRequire("49qw5");

var $cQG0q = parcelRequire("cQG0q");

var $2uJ2L = parcelRequire("2uJ2L");
function $dc87dabffd76a197$export$9b7cf3b74f250027(experimentName, expectedExperimentValue) {
    var _experimentConfig$pro;
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
        exposure: false
    };
    var experimentConfig = (0, $cQG0q.editorExperimentsConfig)[experimentName];
    if ((0, $2uJ2L._overrides)[experimentName] !== undefined) // This will be hit in the case of a test setting an override
    return (0, $2uJ2L._overrides)[experimentName] === expectedExperimentValue;
    if (experimentConfig === undefined) // Warning! If a product is improperly configured (ie. their editor packages are misaligned)
    // it can cause the editor to crash here or if the experiment does not exist.
    // We will definitely crash via any code path later in this function - this just makes the error explicit and clear.
    throw new Error("Editor experiment configuration is not defined ".concat(experimentName, ". Likely the experiment does not exist or editor package versions are misaligned"));
    if (!(0, $2uJ2L._product)) // This will be hit in the case of a product not having setup the editor experiment tooling
    return experimentConfig.defaultValue === expectedExperimentValue;
    // Typescript is complaining here about accessing the productKeys property
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    var experimentKey = experimentConfig === null || experimentConfig === void 0 || (_experimentConfig$pro = experimentConfig.productKeys) === null || _experimentConfig$pro === void 0 ? void 0 : _experimentConfig$pro[0, $2uJ2L._product];
    if (!experimentKey) {
        var _editorExperimentsCon;
        // This will be hit in the case of an experiment not being set up for the product
        return ((_editorExperimentsCon = (0, $cQG0q.editorExperimentsConfig)[experimentName]) === null || _editorExperimentsCon === void 0 ? void 0 : _editorExperimentsCon.defaultValue) === expectedExperimentValue;
    }
    // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
    var experimentValue = (0, $ivkVy.default).getExperimentValue(// @ts-ignore
    experimentKey, experimentConfig.param, experimentConfig.defaultValue, {
        typeGuard: experimentConfig.typeGuard,
        fireExperimentExposure: options.exposure
    });
    if (// When cleaning this gate up -- `calling where the experiments have the product key set`
    // in __tests__/experiments should be updated (as it's had the count bumped to include these).
    // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
    (0, $ivkVy.default).getExperimentValue('cc_editor_experiments_ufo_gate_reporting', 'isEnabled', false)) (0, $49qw5.addFeatureFlagAccessed)("".concat(experimentName, ":").concat(experimentConfig.param), experimentValue);
    return expectedExperimentValue === experimentValue;
}
function $dc87dabffd76a197$export$92316ae898e357eb(experimentName, paramName, options) {
    var _paramOverrides$exper, _options$exposure;
    if (((_paramOverrides$exper = (0, $2uJ2L._paramOverrides)[experimentName]) === null || _paramOverrides$exper === void 0 ? void 0 : _paramOverrides$exper[paramName]) !== undefined) // This will be hit in the case of a test setting an override
    return (0, $2uJ2L._paramOverrides)[experimentName][paramName];
    // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
    var experimentValue = (0, $ivkVy.default).getExperimentValue(experimentName, paramName, options.defaultValue, {
        typeGuard: options.typeGuard,
        fireExperimentExposure: (_options$exposure = options.exposure) !== null && _options$exposure !== void 0 ? _options$exposure : false
    });
    return experimentValue;
}

});

parcelRegister("9F9pG", function(module, exports) {
$parcel$export(module.exports, "getText", () => $708f3ea6d303159c$export$c72d34660a162238);
$parcel$export(module.exports, "getEventHandler", () => $708f3ea6d303159c$export$eee20638634729b3);
$parcel$export(module.exports, "findInTree", () => $708f3ea6d303159c$export$38b61ebf4950cd39);

var $arMYe = parcelRequire("arMYe");

var $9P61R = parcelRequire("9P61R");

var $kYLlQ = parcelRequire("kYLlQ");

var $kRa9z = parcelRequire("kRa9z");
// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $708f3ea6d303159c$var$createEncoder(parser, encoder) {
    return function(value) {
        return encoder.encode(parser.parse(value));
    };
}
var $708f3ea6d303159c$export$bcf771b83128eae7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function ADFEncoder(createTransformerWithSchema) {
    (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, ADFEncoder);
    var transformer = createTransformerWithSchema((0, $kYLlQ.defaultSchema));
    this.encode = $708f3ea6d303159c$var$createEncoder(transformer, new (0, $kRa9z.JSONTransformer)());
});
var $708f3ea6d303159c$export$c72d34660a162238 = function getText(node) {
    return node.text || node.attrs && (node.attrs.text || node.attrs.shortName) || "[".concat(typeof node.type === 'string' ? node.type : node.type.name, "]");
};
var $708f3ea6d303159c$export$eee20638634729b3 = function getEventHandler(eventHandlers, type) {
    var eventName = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'onClick';
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return eventHandlers && type && eventHandlers[type] && eventHandlers[type][eventName];
};
function $708f3ea6d303159c$export$38b61ebf4950cd39(element, topElement, evaluate) {
    if (element === topElement) return false;
    if (evaluate(element)) return true;
    if (!element.parentElement) return false;
    return $708f3ea6d303159c$export$38b61ebf4950cd39(element.parentElement, topElement, evaluate);
}

});

parcelRegister("w2fDc", function(module, exports) {
$parcel$export(module.exports, "isAnnotationMark", () => $0604bc4c791a2097$export$855795c145f03402);
$parcel$export(module.exports, "default", () => $0604bc4c791a2097$export$2e2bcd8739ae039);

var $kqp0i = parcelRequire("kqp0i");

var $25nEq = parcelRequire("25nEq");

var $5FkrB = parcelRequire("5FkrB");

var $kX1mK = parcelRequire("kX1mK");

var $fpW0x = parcelRequire("fpW0x");
function $0604bc4c791a2097$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $0604bc4c791a2097$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $0604bc4c791a2097$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $0604bc4c791a2097$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $0604bc4c791a2097$export$855795c145f03402 = function isAnnotationMark(mark) {
    return mark && mark.type && mark.type.name === 'annotation';
};
var $0604bc4c791a2097$var$AnnotationComponent = function AnnotationComponent(_ref) {
    var id = _ref.id, annotationType = _ref.annotationType, children = _ref.children, dataAttributes = _ref.dataAttributes, _ref$annotationParent = _ref.annotationParentIds, annotationParentIds = _ref$annotationParent === void 0 ? [] : _ref$annotationParent, allowAnnotations = _ref.allowAnnotations, useBlockLevel = _ref.useBlockLevel, isMediaInline = _ref.isMediaInline;
    var data = $0604bc4c791a2097$var$_objectSpread($0604bc4c791a2097$var$_objectSpread({}, dataAttributes), (0, $kX1mK.buildDataAttributes)({
        id: id,
        annotationType: annotationType
    }));
    if (allowAnnotations) return isMediaInline ? /*#__PURE__*/ // Inline comment on mediaInline is not supported as part of comments on media project,
    // hence skip any styling/event handling for annotations on mediaInline.
    // `id` is still needed so that comment view component can be correct positioned
    // when using comment navigation to access comments on mediaInline
    (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("span", {
        id: id
    }, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $fpW0x.MarkElement), {
        id: id,
        dataAttributes: data,
        annotationParentIds: annotationParentIds,
        annotationType: annotationType,
        useBlockLevel: useBlockLevel
    }, children);
    return(/*#__PURE__*/ // Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("span", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        id: id
    }, data), children));
};
var $0604bc4c791a2097$export$2e2bcd8739ae039 = $0604bc4c791a2097$var$AnnotationComponent;

});
parcelRegister("fpW0x", function(module, exports) {
$parcel$export(module.exports, "MarkElement", () => $b3962fe9d6209a66$export$f3069f755c1eba0b);

var $5FkrB = parcelRequire("5FkrB");

var $kX1mK = parcelRequire("kX1mK");

var $1xyIw = parcelRequire("1xyIw");

var $gn91R = parcelRequire("gn91R");

var $8vb4Q = parcelRequire("8vb4Q");

var $71QIw = parcelRequire("71QIw");

var $2pzUn = parcelRequire("2pzUn");

var $gtPYB = parcelRequire("gtPYB");

var $fDwDe = parcelRequire("fDwDe");
var $b3962fe9d6209a66$export$f3069f755c1eba0b = function MarkElement(_ref) {
    var annotationParentIds = _ref.annotationParentIds, children = _ref.children, dataAttributes = _ref.dataAttributes, id = _ref.id, useBlockLevel = _ref.useBlockLevel;
    var updateSubscriber = (0, $71QIw.useInlineCommentSubscriberContext)();
    var states = (0, $5FkrB.useContext)((0, $gtPYB.InlineCommentsStateContext));
    var _useHasFocusEvent = (0, $2pzUn.useHasFocusEvent)({
        id: id,
        updateSubscriber: updateSubscriber
    }), hasFocus = _useHasFocusEvent.hasFocus, isHovered = _useHasFocusEvent.isHovered;
    var dataAttributesMemorized = (0, $5FkrB.useMemo)(function() {
        return dataAttributes;
    }, [
        dataAttributes
    ]);
    var _useAnnotationManager = (0, $fDwDe.useAnnotationManagerDispatch)(), dispatch = _useAnnotationManager.dispatch, annotationManager = _useAnnotationManager.annotationManager;
    var onClick = (0, $5FkrB.useCallback)(function(props) {
        if (!updateSubscriber) return;
        if (useBlockLevel) return;
        var eventTarget = props.eventTarget, annotationIds = props.annotationIds;
        if (annotationManager) {
            if (hasFocus) {
                dispatch({
                    type: 'resetSelectedAnnotation'
                });
                return;
            }
            annotationManager.checkPreemptiveGate().then(function(canSelect) {
                if (canSelect) {
                    // if there is a draft, clear it first
                    annotationManager === null || annotationManager === void 0 || annotationManager.clearDraft();
                    // use setIsAnnotationSelected won't work here if there is a draft in progress
                    // so we need to use dispatch to update the state directly
                    dispatch({
                        type: 'updateAnnotation',
                        data: {
                            id: annotationIds[0],
                            selected: true
                        }
                    });
                    dispatch({
                        type: 'setSelectedMarkRef',
                        data: {
                            markRef: eventTarget
                        }
                    });
                }
            }).catch(function(_error) {
            // TODO: EDITOR-595 - An error occurred while checking the preemptive gate. We should report this error.
            });
        } else updateSubscriber.emit((0, $1xyIw.AnnotationUpdateEvent).ON_ANNOTATION_CLICK, {
            annotationIds: annotationIds,
            eventTarget: eventTarget
        });
    }, [
        updateSubscriber,
        useBlockLevel,
        dispatch,
        annotationManager,
        hasFocus
    ]);
    var activeParentIds = (0, $8vb4Q.useInlineCommentsFilter)({
        annotationIds: annotationParentIds,
        filter: {
            state: (0, $kX1mK.AnnotationMarkStates).ACTIVE
        }
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $gn91R.MarkComponent), {
        id: id,
        dataAttributes: dataAttributesMemorized,
        annotationParentIds: activeParentIds,
        onClick: onClick,
        hasFocus: hasFocus,
        isHovered: isHovered,
        state: states[id],
        useBlockLevel: useBlockLevel
    }, children);
};

});
parcelRegister("gn91R", function(module, exports) {
$parcel$export(module.exports, "MarkComponent", () => $beb5cc4ddf5a93f5$export$4f5a51511304fdd0);

var $fC8ib = parcelRequire("fC8ib");

var $25nEq = parcelRequire("25nEq");

var $5FkrB = parcelRequire("5FkrB");

var $74Zh5 = parcelRequire("74Zh5");

var $kX1mK = parcelRequire("kX1mK");

var $9Zzpd = parcelRequire("9Zzpd");

var $6Wx3K = parcelRequire("6Wx3K");

var $3cXxO = parcelRequire("3cXxO");

var $fDwDe = parcelRequire("fDwDe");
function $beb5cc4ddf5a93f5$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $beb5cc4ddf5a93f5$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $beb5cc4ddf5a93f5$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $beb5cc4ddf5a93f5$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $beb5cc4ddf5a93f5$var$markStyles = (0, $74Zh5.css)((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({
    color: 'inherit',
    backgroundColor: 'unset',
    WebkitTapHighlightColor: 'transparent'
}, "&[data-mark-annotation-state='".concat((0, $kX1mK.AnnotationMarkStates).ACTIVE, "']"), {
    // was from blur in AnnotationSharedCSSByState().blur
    background: "var(--ds-background-accent-yellow-subtlest, #FEF7C8)",
    borderBottom: "var(--ds-border-width-selected, 2px)".concat(" solid ", "var(--ds-border-accent-yellow, #B38600)"),
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '&[data-has-focus="true"]': {
        background: "var(--ds-background-accent-yellow-subtler, #F5E989)",
        borderBottom: "var(--ds-border-width-selected, 2px)".concat(" solid ", "var(--ds-border-accent-yellow, #B38600)"),
        // TODO: DSP-4147 - Annotation shadow
        boxShadow: "var(--ds-shadow-overlay, 0px 8px 12px #1E1F2126, 0px 0px 1px #1E1F214f)",
        cursor: 'pointer'
    }
}));
var $beb5cc4ddf5a93f5$var$markStylesLayeringFix = (0, $74Zh5.css)((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, "&[data-mark-annotation-state='".concat((0, $kX1mK.AnnotationMarkStates).ACTIVE, "']"), {
    // Only apply transparency to nested marks when parent is focused
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '&[data-has-focus="true"] mark': {
        backgroundColor: 'transparent'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.fabric-background-color-mark &[data-has-focus="true"], &[data-has-focus="true"]': {
        background: "var(--ds-background-accent-yellow-subtlest-pressed, #EFDD4E)",
        borderBottomColor: "var(--ds-border-accent-yellow, #B38600)",
        boxShadow: "var(--ds-shadow-raised, 0px 1px 1px #1E1F2140, 0px 0px 1px #1E1F214f)"
    }
}));
var $beb5cc4ddf5a93f5$var$markStylesWithUpdatedShadow = (0, $74Zh5.css)((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, "&[data-mark-annotation-state='".concat((0, $kX1mK.AnnotationMarkStates).ACTIVE, "']"), {
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '&[data-has-focus="true"]': {
        background: "var(--ds-background-accent-yellow-subtlest-pressed, #EFDD4E)",
        borderBottomColor: "var(--ds-border-accent-yellow, #B38600)",
        boxShadow: "var(--ds-shadow-raised, 0px 1px 1px #1E1F2140, 0px 0px 1px #1E1F214f)"
    }
}));
var $beb5cc4ddf5a93f5$var$markStylesWithInlineComments = (0, $74Zh5.css)((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, "&[data-mark-annotation-state='".concat((0, $kX1mK.AnnotationMarkStates).ACTIVE, "']"), {
    // was from common in AnnotationSharedCSSByState().common
    borderBottom: "var(--ds-border-width-selected, 2px)".concat(" solid transparent"),
    cursor: 'pointer',
    padding: "1px 0 ".concat("var(--ds-space-025, 2px)"),
    // it was under fg(annotations_align_editor_and_renderer_styles) from AnnotationSharedCSSByState().common, assume it's on as already rolled out
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
    '&:has(.card), &:has([data-inline-card])': {
        padding: '5px 0 3px 0'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
    '&:has(.date-lozenger-container)': {
        paddingTop: "var(--ds-space-025, 2px)"
    },
    // was from blur in AnnotationSharedCSSByState().blur
    background: "var(--ds-background-accent-yellow-subtlest, #FEF7C8)",
    borderBottomColor: "var(--ds-border-accent-yellow, #B38600)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '&[data-has-focus="true"]': {
        background: "var(--ds-background-accent-yellow-subtlest-pressed, #EFDD4E)",
        borderBottomColor: "var(--ds-border-accent-yellow, #B38600)",
        boxShadow: "var(--ds-shadow-overlay, 0px 8px 12px #1E1F2126, 0px 0px 1px #1E1F214f)"
    }
}));
var $beb5cc4ddf5a93f5$var$markStylesWithCommentsPanel = (0, $74Zh5.css)((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, "&[data-mark-annotation-state='".concat((0, $kX1mK.AnnotationMarkStates).ACTIVE, "']"), {
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
    '&[data-is-hovered="true"]:not([data-has-focus="true"])': {
        background: "var(--ds-background-accent-yellow-subtlest-hovered, #F5E989)",
        borderBottomColor: "var(--ds-border-accent-yellow, #B38600)",
        boxShadow: "var(--ds-shadow-overlay, 0px 8px 12px #1E1F2126, 0px 0px 1px #1E1F214f)"
    }
}));
var $beb5cc4ddf5a93f5$var$isMobile = function isMobile() {
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
};
var $beb5cc4ddf5a93f5$var$accessibilityStyles = (0, $74Zh5.css)({
    '&::before, &::after': {
        clipPath: 'inset(100%)',
        clip: 'rect(1px, 1px, 1px, 1px)',
        height: '1px',
        overflow: 'hidden',
        position: 'absolute',
        whiteSpace: 'nowrap',
        width: '1px'
    },
    '&::before': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
        content: "' [var(--ak-renderer-annotation-startmarker)] '"
    },
    '&::after': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
        content: "' [var(--ak-renderer-annotation-endmarker)] '"
    }
});
var $beb5cc4ddf5a93f5$export$4f5a51511304fdd0 = function MarkComponent(_ref) {
    var annotationParentIds = _ref.annotationParentIds, children = _ref.children, dataAttributes = _ref.dataAttributes, id = _ref.id, state = _ref.state, hasFocus = _ref.hasFocus, isHovered = _ref.isHovered, onClick = _ref.onClick, useBlockLevel = _ref.useBlockLevel;
    var intl = (0, $6Wx3K.default)();
    var annotationIds = (0, $5FkrB.useMemo)(function() {
        return (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(new Set([].concat((0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(annotationParentIds), [
            id
        ])));
    }, [
        id,
        annotationParentIds
    ]);
    var _useAnnotationManager = (0, $fDwDe.useAnnotationManagerDispatch)(), annotationManager = _useAnnotationManager.annotationManager, dispatch = _useAnnotationManager.dispatch;
    var _useAnnotationManager2 = (0, $fDwDe.useAnnotationManagerState)(), currentSelectedAnnotationId = _useAnnotationManager2.currentSelectedAnnotationId;
    var isAnnotationManagerEnabled = !!annotationManager;
    // after creating a new annotation, we need to set the markRef to the new mark
    var markRef = (0, $5FkrB.useCallback)(function(node) {
        if (id === currentSelectedAnnotationId && node) dispatch({
            type: 'setSelectedMarkRef',
            data: {
                markRef: node
            }
        });
    }, [
        dispatch,
        id,
        currentSelectedAnnotationId
    ]);
    var onMarkClick = (0, $5FkrB.useCallback)(function(event) {
        // prevent inline mark logic for media block marks
        if (event.currentTarget instanceof HTMLElement && event.currentTarget.getAttribute('data-block-mark')) return;
        // prevents multiple callback on overlapping annotations
        if (event.defaultPrevented || state !== (0, $kX1mK.AnnotationMarkStates).ACTIVE) return;
        if ((0, $9Zzpd.fg)('editor_inline_comments_on_inline_nodes')) // We only want to interfere with click events if the click is on some ui inside the renderer document
        // This is to prevent the click events from portaled content (such as link previews and mention profiles)
        {
            if (event.target instanceof HTMLElement && event.target.closest('.ak-renderer-document')) {
                if (event.target.closest('[data-mention-id]')) ;
                else {
                    // prevents from opening link URL inside webView in Safari
                    event.preventDefault();
                    event.stopPropagation();
                }
            }
        } else // prevents from opening link URL inside webView in Safari
        event.preventDefault();
        if (isAnnotationManagerEnabled) // currentTarget is the right element if there are multiple overlapping annotations
        // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        onClick({
            eventTarget: event.currentTarget,
            annotationIds: annotationIds
        });
        else // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        onClick({
            eventTarget: event.target,
            annotationIds: annotationIds
        });
    }, [
        annotationIds,
        onClick,
        state,
        isAnnotationManagerEnabled
    ]);
    var onMarkEnter = function onMarkEnter(evt) {
        var _document$activeEleme;
        var focusedElementTag = (_document$activeEleme = document.activeElement) === null || _document$activeEleme === void 0 ? void 0 : _document$activeEleme.tagName;
        if (focusedElementTag === 'MARK' && evt.key === 'Enter') onMarkClick(evt);
    };
    var overriddenData = !state ? dataAttributes : $beb5cc4ddf5a93f5$var$_objectSpread($beb5cc4ddf5a93f5$var$_objectSpread({}, dataAttributes), {}, {
        'data-mark-annotation-state': state,
        'data-has-focus': hasFocus,
        'data-is-hovered': isHovered
    });
    var desktopAccessibilityAttributes = $beb5cc4ddf5a93f5$var$isMobile() ? {} : {
        role: 'button',
        tabIndex: 0,
        onKeyDown: onMarkEnter,
        'aria-expanded': hasFocus
    };
    var accessibility = state !== (0, $kX1mK.AnnotationMarkStates).ACTIVE ? {
        'aria-disabled': true
    } : $beb5cc4ddf5a93f5$var$_objectSpread({
        'aria-details': annotationIds.join(', ')
    }, desktopAccessibilityAttributes);
    return (0, $74Zh5.jsx)(useBlockLevel ? 'div' : 'mark', $beb5cc4ddf5a93f5$var$_objectSpread($beb5cc4ddf5a93f5$var$_objectSpread($beb5cc4ddf5a93f5$var$_objectSpread((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({
        ref: id === currentSelectedAnnotationId ? markRef : undefined,
        id: id
    }, (0, $9Zzpd.fg)('editor_inline_comments_on_inline_nodes') ? 'onClickCapture' : 'onClick', onMarkClick), accessibility), overriddenData), !useBlockLevel && {
        css: [
            $beb5cc4ddf5a93f5$var$markStyles,
            $beb5cc4ddf5a93f5$var$markStylesLayeringFix,
            (0, $9Zzpd.fg)('editor_inline_comments_on_inline_nodes') && $beb5cc4ddf5a93f5$var$markStylesWithInlineComments,
            (0, $9Zzpd.fg)('confluence-frontend-comments-panel') && $beb5cc4ddf5a93f5$var$markStylesWithCommentsPanel,
            !$beb5cc4ddf5a93f5$var$isMobile() && $beb5cc4ddf5a93f5$var$accessibilityStyles,
            $beb5cc4ddf5a93f5$var$markStylesWithUpdatedShadow
        ],
        style: {
            '--ak-renderer-annotation-startmarker': intl.formatMessage((0, $3cXxO.inlineCommentMessages).contentRendererInlineCommentMarkerStart),
            '--ak-renderer-annotation-endmarker': intl.formatMessage((0, $3cXxO.inlineCommentMessages).contentRendererInlineCommentMarkerEnd)
        }
    }), children);
};

});

parcelRegister("8vb4Q", function(module, exports) {
$parcel$export(module.exports, "useInlineCommentsFilter", () => $6309cfab0c111d17$export$8e7d47f9e38ad4f1);

var $fC8ib = parcelRequire("fC8ib");

var $5FkrB = parcelRequire("5FkrB");

var $gtPYB = parcelRequire("gtPYB");
var $6309cfab0c111d17$export$8e7d47f9e38ad4f1 = function useInlineCommentsFilter(_ref) {
    var annotationIds = _ref.annotationIds, stateFilter = _ref.filter.state;
    var states = (0, $5FkrB.useContext)((0, $gtPYB.InlineCommentsStateContext));
    return (0, $5FkrB.useMemo)(function() {
        return annotationIds.reduce(function(acc, id) {
            if (states && states[id] === stateFilter) return [].concat((0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(acc), [
                id
            ]);
            return acc;
        }, []);
    }, [
        annotationIds,
        states,
        stateFilter
    ]);
};

});

parcelRegister("71QIw", function(module, exports) {
$parcel$export(module.exports, "useInlineCommentSubscriberContext", () => $51e184ee0f1fdd60$export$b46737175cffd396);

var $5FkrB = parcelRequire("5FkrB");

var $gtPYB = parcelRequire("gtPYB");
var $51e184ee0f1fdd60$export$b46737175cffd396 = function useInlineCommentSubscriberContext() {
    var providers = (0, $5FkrB.useContext)((0, $gtPYB.ProvidersContext));
    if (!providers) return null;
    var updateSubscriber = providers.inlineComment.updateSubscriber;
    return updateSubscriber || null;
};

});



parcelRegister("l23cj", function(module, exports) {
$parcel$export(module.exports, "default", () => $f4fc43d74b7f1cb9$export$2e2bcd8739ae039);

var $kqp0i = parcelRequire("kqp0i");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");

var $7dZXU = parcelRequire("7dZXU");

var $8zrJb = parcelRequire("8zrJb");
var $f4fc43d74b7f1cb9$var$_excluded = [
    "children"
];
function $f4fc43d74b7f1cb9$export$2e2bcd8739ae039(_ref) {
    var testId = _ref.testId, bidiCharacter = _ref.bidiCharacter, skipChildren = _ref.skipChildren, shouldSkipChildren = _ref.shouldSkipChildren, tooltipEnabled = _ref.tooltipEnabled, isTooltipEnabled = _ref.isTooltipEnabled, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Bidirectional characters change the order that text is rendered. This could be used to obscure malicious code.' : _ref$label;
    // Use new props if provided, otherwise fall back to deprecated props
    var shouldEnableTooltip = isTooltipEnabled !== undefined ? isTooltipEnabled : tooltipEnabled;
    var shouldSkip = shouldSkipChildren !== undefined ? shouldSkipChildren : skipChildren;
    if (shouldEnableTooltip) return(/*#__PURE__*/ // Following patches, this should be updated to use the render props signature which will provide aria attributes.
    // Note: this should be tested, as initial testing did not see attributes work with current tooltip implementation.
    // @ts-ignore: [PIT-1685] Fails in post-office due to backwards incompatibility issue with React 18
    (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $7dZXU.default), {
        content: label,
        tag: $f4fc43d74b7f1cb9$var$CustomizedTagWithRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $8zrJb.Decorator), {
        testId: testId,
        bidiCharacter: bidiCharacter
    }, shouldSkip ? null : bidiCharacter)));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $8zrJb.Decorator), {
        testId: testId,
        bidiCharacter: bidiCharacter
    }, shouldSkip ? null : bidiCharacter);
}
var $f4fc43d74b7f1cb9$var$CustomizedTagWithRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).forwardRef(function(props, ref) {
    var children = props.children, rest = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(props, $f4fc43d74b7f1cb9$var$_excluded);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("span", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, rest, {
        ref: ref
    }), children);
});

});
parcelRegister("7dZXU", function(module, exports) {
$parcel$export(module.exports, "default", () => $5429d053a3d597fa$export$2e2bcd8739ae039);

var $kqp0i = parcelRequire("kqp0i");

var $iYJcE = parcelRequire("iYJcE");

var $25nEq = parcelRequire("25nEq");

var $5FkrB = parcelRequire("5FkrB");

var $7QpUe = parcelRequire("7QpUe");

var $il10m = parcelRequire("il10m");

var $eVb4V = parcelRequire("eVb4V");

var $hy47X = parcelRequire("hy47X");

var $3UUXy = parcelRequire("3UUXy");

var $aJI78 = parcelRequire("aJI78");

var $CewGr = parcelRequire("CewGr");
var $6PYH9 = parcelRequire("6PYH9");

var $5K5L9 = parcelRequire("5K5L9");

var $9mzLx = parcelRequire("9mzLx");

var $12Oht = parcelRequire("12Oht");

var $dBJsk = parcelRequire("dBJsk");

var $55O85 = parcelRequire("55O85");

var $84v6q = parcelRequire("84v6q");

var $h7i8q = parcelRequire("h7i8q");

var $biujZ = parcelRequire("biujZ");
function $5429d053a3d597fa$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $5429d053a3d597fa$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $5429d053a3d597fa$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $5429d053a3d597fa$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $5429d053a3d597fa$var$tooltipZIndex = (0, $12Oht.layers).tooltip();
var $5429d053a3d597fa$var$analyticsAttributes = {
    componentName: 'tooltip',
    packageName: "@atlaskit/tooltip",
    packageVersion: "20.9.0"
};
// Inverts motion direction
var $5429d053a3d597fa$var$invertedDirection = {
    top: 'bottom',
    bottom: 'top',
    left: 'right',
    right: 'left'
};
/**
 * Converts a Popper placement to it's general direction.
 *
 * @param placement - Popper Placement value, e.g. 'top-start'
 * @returns Popper Direction, e.g. 'top'
 */ var $5429d053a3d597fa$var$getDirectionFromPlacement = function getDirectionFromPlacement(placement) {
    return placement.split('-')[0];
};
/**
 * __Tooltip__
 *
 * A tooltip is a floating, non-actionable label used to explain a user interface element or feature.
 */ function $5429d053a3d597fa$var$Tooltip(_ref) {
    var children = _ref.children, _ref$position = _ref.position, position = _ref$position === void 0 ? 'bottom' : _ref$position, _ref$mousePosition = _ref.mousePosition, mousePosition = _ref$mousePosition === void 0 ? 'bottom' : _ref$mousePosition, content = _ref.content, _ref$truncate = _ref.truncate, truncate = _ref$truncate === void 0 ? false : _ref$truncate, _ref$component = _ref.component, Container = _ref$component === void 0 ? (0, $h7i8q.default) : _ref$component, _ref$tag = _ref.tag, TargetContainer = _ref$tag === void 0 ? 'div' : _ref$tag, testId = _ref.testId, _ref$delay = _ref.delay, delay = _ref$delay === void 0 ? 300 : _ref$delay, _ref$onShow = _ref.onShow, onShow = _ref$onShow === void 0 ? (0, $eVb4V.default) : _ref$onShow, _ref$onHide = _ref.onHide, onHide = _ref$onHide === void 0 ? (0, $eVb4V.default) : _ref$onHide, canAppear = _ref.canAppear, _ref$hideTooltipOnCli = _ref.hideTooltipOnClick, hideTooltipOnClick = _ref$hideTooltipOnCli === void 0 ? false : _ref$hideTooltipOnCli, _ref$hideTooltipOnMou = _ref.hideTooltipOnMouseDown, hideTooltipOnMouseDown = _ref$hideTooltipOnMou === void 0 ? false : _ref$hideTooltipOnMou, analyticsContext = _ref.analyticsContext, _ref$strategy = _ref.strategy, strategy = _ref$strategy === void 0 ? 'fixed' : _ref$strategy, _ref$ignoreTooltipPoi = _ref.ignoreTooltipPointerEvents, ignoreTooltipPointerEvents = _ref$ignoreTooltipPoi === void 0 ? false : _ref$ignoreTooltipPoi, _ref$isScreenReaderAn = _ref.isScreenReaderAnnouncementDisabled, isScreenReaderAnnouncementDisabled = _ref$isScreenReaderAn === void 0 ? false : _ref$isScreenReaderAn, shortcut = _ref.shortcut;
    var tooltipPosition = position === 'mouse' ? mousePosition : position;
    var onShowHandler = (0, $il10m.usePlatformLeafSyntheticEventHandler)($5429d053a3d597fa$var$_objectSpread({
        fn: onShow,
        action: 'displayed',
        analyticsData: analyticsContext
    }, $5429d053a3d597fa$var$analyticsAttributes));
    var onHideHandler = (0, $il10m.usePlatformLeafSyntheticEventHandler)($5429d053a3d597fa$var$_objectSpread({
        fn: onHide,
        action: 'hidden',
        analyticsData: analyticsContext
    }, $5429d053a3d597fa$var$analyticsAttributes));
    var apiRef = (0, $5FkrB.useRef)(null);
    var _useState = (0, $5FkrB.useState)('hide'), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), state = _useState2[0], setState = _useState2[1];
    var targetRef = (0, $5FkrB.useRef)(null);
    var containerRef = (0, $5FkrB.useRef)(null);
    // This function is deliberately _not_ memoized as it needs to re-run every render
    // to pick up any child ref changes. If you use render props you don't have this issue.
    var setImplicitRefFromChildren = function setImplicitRefFromChildren(node) {
        containerRef.current = node;
        targetRef.current = node ? node.firstElementChild : null;
    };
    // This is memoized and passed into the render props callback.
    var setDirectRef = (0, $5FkrB.useCallback)(function(node) {
        targetRef.current = node;
    }, []);
    // Putting a few things into refs so that we don't have to break memoization
    var stableState = (0, $3UUXy.default)(state);
    // These props are placed in separate refs instead of a single object to reduce memory usage.
    // Placing them in the same object previously caused an increase in the number of JavaScript event listeners
    // before garbage collection.
    var onShowHandlerStable = (0, $3UUXy.default)(onShowHandler);
    var onHideHandlerStable = (0, $3UUXy.default)(onHideHandler);
    var delayStable = (0, $3UUXy.default)(delay);
    var canAppearStable = (0, $3UUXy.default)(canAppear);
    var hasCalledShowHandler = (0, $5FkrB.useRef)(false);
    var start = (0, $5FkrB.useCallback)(function(api) {
        // @ts-ignore
        apiRef.current = api;
        hasCalledShowHandler.current = false;
    }, []);
    var done = (0, $5FkrB.useCallback)(function() {
        if (!apiRef.current) return;
        // Only call onHideHandler if we have called onShowHandler
        if (hasCalledShowHandler.current) onHideHandlerStable.current();
        // @ts-ignore
        apiRef.current = null;
        // @ts-ignore
        hasCalledShowHandler.current = false;
        // just in case
        setState('hide');
    }, [
        onHideHandlerStable
    ]);
    var abort = (0, $5FkrB.useCallback)(function() {
        if (!apiRef.current) return;
        apiRef.current.abort();
        // Only call onHideHandler if we have called onShowHandler
        if (hasCalledShowHandler.current) onHideHandlerStable.current();
        // @ts-ignore
        apiRef.current = null;
    }, [
        onHideHandlerStable
    ]);
    (0, $5FkrB.useEffect)(function mount() {
        return function unmount() {
            if (apiRef.current) abort();
        };
    }, [
        abort
    ]);
    var isDraggingRef = (0, $5FkrB.useRef)(false);
    (0, $5FkrB.useEffect)(function() {
        return (0, $dBJsk.register)({
            onRegister: function onRegister(_ref2) {
                var isDragging = _ref2.isDragging;
                isDraggingRef.current = isDragging;
            },
            onDragStart: function onDragStart() {
                var _apiRef$current;
                /**
         * Hiding any visible tooltips when a drag starts because otherwise it
         * looks janky (disappears and reappears), and is not required.
         */ (_apiRef$current = apiRef.current) === null || _apiRef$current === void 0 || _apiRef$current.requestHide({
                    isImmediate: true
                });
                isDraggingRef.current = true;
            },
            onDragEnd: function onDragEnd() {
                isDraggingRef.current = false;
            }
        });
    }, []);
    var tryShowTooltip = (0, $5FkrB.useCallback)(function(source) {
        var _canAppearStable$curr;
        /**
     * Prevent tooltips from being shown during a drag. This can occur with
     * the native drag and drop API, where some pointer events can fire
     * when they should not and lead to jank with tooltips.
     */ if (isDraggingRef.current) return;
        // Another tooltip is has been active but we still have the old `api`
        // around. We need to finish up the last usage.
        // Note: just being safe - this should not happen
        if (apiRef.current && !apiRef.current.isActive()) abort();
        // This tooltip is already active, we can exit
        if (apiRef.current && apiRef.current.isActive()) {
            apiRef.current.keep();
            return;
        }
        /**
     * Check if tooltip is allowed to show.
     *
     * Once a tooltip has started, or has scheduled to start
     * we won't be checking `canAppear` again.
     *
     * - We don't want tooltips to disappear once they are shown
     * - For consistency, we start after a single positive `canAppear`.
     *   Otherwise the amount of times we ask consumers would depend on
     *   how many times we get a "mousemove", which _could_ lead to situations
     *   where moving the mouse could result in a different outcome to if
     *   the mouse was not moved.
     */ if (canAppearStable.current && !((_canAppearStable$curr = canAppearStable.current) !== null && _canAppearStable$curr !== void 0 && _canAppearStable$curr.call(canAppearStable))) return;
        var entry = {
            source: source,
            delay: delayStable.current,
            show: function show(_ref3) {
                var isImmediate = _ref3.isImmediate;
                // Call the onShow handler if it hasn't been called yet
                if (!hasCalledShowHandler.current) {
                    hasCalledShowHandler.current = true;
                    onShowHandlerStable.current();
                }
                setState(isImmediate ? 'show-immediate' : 'fade-in');
            },
            hide: function hide(_ref4) {
                var isImmediate = _ref4.isImmediate;
                if (isImmediate) setState('hide');
                else setState('before-fade-out');
            },
            done: done
        };
        var api = (0, $55O85.show)(entry);
        start(api);
    }, [
        canAppearStable,
        delayStable,
        done,
        start,
        abort,
        onShowHandlerStable
    ]);
    var hideTooltipOnEsc = (0, $5FkrB.useCallback)(function() {
        var _apiRef$current2;
        (_apiRef$current2 = apiRef.current) === null || _apiRef$current2 === void 0 || _apiRef$current2.requestHide({
            isImmediate: true
        });
    }, [
        apiRef
    ]);
    (0, $hy47X.default)({
        onClose: hideTooltipOnEsc,
        isDisabled: state === 'hide' || state === 'fade-out'
    });
    (0, $5FkrB.useEffect)(function() {
        if (state === 'hide') return 0, $eVb4V.default;
        if (state === 'before-fade-out') setState('fade-out');
        var unbind = (0, $7QpUe.bind)(window, {
            type: 'scroll',
            listener: function listener() {
                if (apiRef.current) apiRef.current.requestHide({
                    isImmediate: true
                });
            },
            options: {
                capture: true,
                passive: true,
                once: true
            }
        });
        return unbind;
    }, [
        state
    ]);
    var onMouseDown = (0, $5FkrB.useCallback)(function() {
        if (hideTooltipOnMouseDown && apiRef.current) apiRef.current.requestHide({
            isImmediate: true
        });
    }, [
        hideTooltipOnMouseDown
    ]);
    var onClick = (0, $5FkrB.useCallback)(function() {
        if (hideTooltipOnClick && apiRef.current) apiRef.current.requestHide({
            isImmediate: true
        });
    }, [
        hideTooltipOnClick
    ]);
    // Ideally we would be using onMouseEnter here, but
    // because we are binding the event to the target parent
    // we need to listen for the mouseover of all sub elements
    // This means when moving along a tooltip we are quickly toggling
    // between api.requestHide and api.keep. This it not ideal
    var onMouseOver = (0, $5FkrB.useCallback)(function(event) {
        // Ignoring events from the container ref
        if (containerRef.current && event.target === containerRef.current) return;
        // Using prevent default as a signal that parent tooltips
        if (event.defaultPrevented) return;
        event.preventDefault();
        var source = position === 'mouse' ? {
            type: 'mouse',
            // TODO: ideally not recalculating this object each time
            mouse: (0, $biujZ.getMousePosition)({
                left: event.clientX,
                top: event.clientY
            })
        } : {
            type: 'keyboard'
        };
        tryShowTooltip(source);
    }, [
        position,
        tryShowTooltip
    ]);
    // Ideally we would be using onMouseEnter here, but
    // because we are binding the event to the target parent
    // we need to listen for the mouseout of all sub elements
    // This means when moving along a tooltip we are quickly toggling
    // between api.requestHide and api.keep. This it not ideal
    var onMouseOut = (0, $5FkrB.useCallback)(function(event) {
        // Ignoring events from the container ref
        if (containerRef.current && event.target === containerRef.current) return;
        // Using prevent default as a signal that parent tooltips
        if (event.defaultPrevented) return;
        event.preventDefault();
        if (apiRef.current) apiRef.current.requestHide({
            isImmediate: false
        });
    }, []);
    var onMouseMove = position === 'mouse' ? function(event) {
        var _apiRef$current3;
        if ((_apiRef$current3 = apiRef.current) !== null && _apiRef$current3 !== void 0 && _apiRef$current3.isActive()) apiRef.current.mousePosition = (0, $biujZ.getMousePosition)({
            left: event.clientX,
            top: event.clientY
        });
    } : undefined;
    var onMouseOverTooltip = (0, $5FkrB.useCallback)(function() {
        if (apiRef.current && apiRef.current.isActive()) {
            apiRef.current.keep();
            return;
        }
    }, []);
    var onFocus = (0, $5FkrB.useCallback)(function(e) {
        // Check if focus-visible
        // Prevents tooltips from showing when focus is not visible,
        // i.e., when focus is moved onto tooltip trigger inside a popup on open
        try {
            if (!e.target.matches(':focus-visible')) return;
        } catch (_) {
        // Ignore errors from environments that don't support :focus-visible
        }
        // TODO: this does not play well with `hideTooltipOnMouseDown`
        // as "focus" will occur after the "mousedown".
        tryShowTooltip({
            type: 'keyboard'
        });
    }, [
        tryShowTooltip
    ]);
    var onBlur = (0, $5FkrB.useCallback)(function() {
        if (apiRef.current) apiRef.current.requestHide({
            isImmediate: false
        });
    }, []);
    var onAnimationFinished = (0, $5FkrB.useCallback)(function(transition) {
        // Using lastState here because motion is not picking up the latest value
        if (transition === 'exiting' && stableState.current === 'fade-out' && apiRef.current) // @ts-ignore: refs are writeable
        apiRef.current.finishHideAnimation();
    }, [
        stableState
    ]);
    // Doing a cast because typescript is struggling to narrow the type
    var CastTargetContainer = TargetContainer;
    var shouldRenderTooltipPopup = state !== 'hide' && Boolean(content);
    var shouldRenderHiddenContent = !isScreenReaderAnnouncementDisabled && shouldRenderTooltipPopup;
    var shouldRenderTooltipChildren = state !== 'hide' && state !== 'fade-out';
    var handleOpenLayerObserverCloseSignal = (0, $5FkrB.useCallback)(function() {
        var _apiRef$current4;
        (_apiRef$current4 = apiRef.current) === null || _apiRef$current4 === void 0 || _apiRef$current4.requestHide({
            isImmediate: true
        });
    }, []);
    (0, $aJI78.useNotifyOpenLayerObserver)({
        // Layer is only visually open if both the tooltip popup (container) and children are rendered.
        isOpen: shouldRenderTooltipPopup && shouldRenderTooltipChildren,
        /**
     * We don't strictly need to provide an onClose callback at this time, as there is
     * already code that handles hiding the tooltip when a drag is started (and the only
     * usage right now is closing all layers when the user resizes the side nav).
     *
     * However, for future-proofing and semantic reasons, it makes sense to close the tooltip
     * whenever the open layer observer requests a close.
     */ onClose: handleOpenLayerObserverCloseSignal
    });
    var getReferenceElement = function getReferenceElement() {
        var _apiRef$current5;
        if (position === 'mouse' && (_apiRef$current5 = apiRef.current) !== null && _apiRef$current5 !== void 0 && _apiRef$current5.mousePosition) {
            var _apiRef$current6;
            return (_apiRef$current6 = apiRef.current) === null || _apiRef$current6 === void 0 ? void 0 : _apiRef$current6.mousePosition;
        }
        return targetRef.current || undefined;
    };
    var tooltipIdForHiddenContent = (0, $84v6q.default)('tooltip', shouldRenderHiddenContent);
    var tooltipTriggerProps = {
        onMouseOver: onMouseOver,
        onMouseOut: onMouseOut,
        onMouseMove: onMouseMove,
        onMouseDown: onMouseDown,
        onClick: onClick,
        onFocus: onFocus,
        onBlur: onBlur
    };
    // Don't set `data-testid` unless it's defined, as it's not in the interface.
    if (testId) // Adding `data-testid` to the TriggerProps interface breaks Buttons, so we use type assertion
    tooltipTriggerProps['data-testid'] = "".concat(testId, "--container");
    // This useEffect is purely for managing the aria attribute when using the
    // wrapped children approach.
    var isChildrenAFunction = typeof children === 'function';
    (0, $5FkrB.useEffect)(function() {
        if (isChildrenAFunction) return;
        // If `children` is _not_ a function, we are stepping outside of the public
        // API to add a `aria-describedby` attribute.
        var target = targetRef.current;
        if (!target || !tooltipIdForHiddenContent) return;
        target.setAttribute('aria-describedby', tooltipIdForHiddenContent);
        return function() {
            return target.removeAttribute('aria-describedby');
        };
    }, [
        isChildrenAFunction,
        tooltipIdForHiddenContent
    ]);
    var hiddenContent = shouldRenderHiddenContent ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("span", {
        "data-testid": testId ? "".concat(testId, "-hidden") : undefined,
        hidden: true,
        id: tooltipIdForHiddenContent
    }, typeof content === 'function' ? content({}) : content) : null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).Fragment, null, typeof children === 'function' ? /*#__PURE__*/ // once we deprecate the wrapped approach, we can put the aria
    // attribute back into the tooltipTriggerProps and make it required
    // instead of optional in `types`
    (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).Fragment, null, children($5429d053a3d597fa$var$_objectSpread($5429d053a3d597fa$var$_objectSpread({}, tooltipTriggerProps), {}, {
        'aria-describedby': tooltipIdForHiddenContent,
        ref: setDirectRef
    })), hiddenContent) : /*#__PURE__*/ // @ts-ignore
    (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(CastTargetContainer, (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, tooltipTriggerProps, {
        ref: setImplicitRefFromChildren,
        role: "presentation"
    }), children, hiddenContent), shouldRenderTooltipPopup ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $9mzLx.default), {
        zIndex: $5429d053a3d597fa$var$tooltipZIndex
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $5K5L9.Popper), {
        placement: tooltipPosition,
        referenceElement: getReferenceElement(),
        strategy: strategy
    }, function(_ref5) {
        var ref = _ref5.ref, style = _ref5.style, update = _ref5.update, placement = _ref5.placement;
        // Invert the entrance and exit directions.
        // E.g. a tooltip's position is on the 'right', it should enter from and exit to the 'left'
        // This gives the effect the tooltip is appearing from the target
        var direction = position === 'mouse' ? undefined : $5429d053a3d597fa$var$invertedDirection[$5429d053a3d597fa$var$getDirectionFromPlacement(placement)];
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $CewGr.default), {
            appear: true
        }, shouldRenderTooltipChildren && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $6PYH9.default), {
            distance: "constant",
            entranceDirection: direction,
            exitDirection: direction,
            onFinish: onAnimationFinished,
            duration: state !== 'show-immediate' ? 'medium' : 'none'
        }, function(_ref6) {
            var className = _ref6.className;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(Container, {
                ref: ref,
                className: "Tooltip ".concat(className),
                style: $5429d053a3d597fa$var$_objectSpread($5429d053a3d597fa$var$_objectSpread({}, style), ignoreTooltipPointerEvents && {
                    pointerEvents: 'none'
                }),
                truncate: truncate,
                placement: tooltipPosition,
                testId: getReferenceElement() ? testId : testId && "".concat(testId, "--unresolved"),
                onMouseOut: onMouseOut,
                onMouseOver: onMouseOverTooltip,
                shortcut: shortcut
            }, typeof content === 'function' ? content({
                update: update
            }) : content);
        }));
    })) : null);
}
var $5429d053a3d597fa$export$2e2bcd8739ae039 = $5429d053a3d597fa$var$Tooltip;

});
parcelRegister("il10m", function(module, exports) {
$parcel$export(module.exports, "usePlatformLeafSyntheticEventHandler", () => $d59af7b485f3fbb4$export$1a04351537078b55);

var $25nEq = parcelRequire("25nEq");

var $5FkrB = parcelRequire("5FkrB");

var $1xcFC = parcelRequire("1xcFC");

var $b7rOP = parcelRequire("b7rOP");
function $d59af7b485f3fbb4$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $d59af7b485f3fbb4$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $d59af7b485f3fbb4$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $d59af7b485f3fbb4$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $d59af7b485f3fbb4$export$1a04351537078b55(_ref) {
    var fn = _ref.fn, action = _ref.action, componentName = _ref.componentName, packageName = _ref.packageName, packageVersion = _ref.packageVersion, analyticsData = _ref.analyticsData;
    var _useAnalyticsEvents = (0, $1xcFC.useAnalyticsEvents)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
    // We put analyticsData and fn in a ref so that we don't need to break
    // memoization.
    // Generally these could be defined by consumers inline
    // and so we do this to avoid breaking memoization of useCallback
    var dataRef = (0, $b7rOP.useTrackedRef)(analyticsData);
    var fnRef = (0, $b7rOP.useTrackedRef)(fn);
    var handler = (0, $5FkrB.useCallback)(function() {
        var analyticsEvent = createAnalyticsEvent({
            action: action,
            actionSubject: componentName,
            attributes: {
                componentName: componentName,
                packageName: packageName,
                packageVersion: packageVersion
            }
        });
        // To avoid wrapping this component in AnalyticsContext we manually
        // push the parent context's meta data into the context.
        // Note: this new 'context'
        var context = $d59af7b485f3fbb4$var$_objectSpread({
            componentName: componentName,
            packageName: packageName,
            packageVersion: packageVersion
        }, dataRef.current);
        analyticsEvent.context.push(context);
        // fire an event on the atlaskit channel
        var clone = analyticsEvent.clone();
        if (clone) clone.fire('atlaskit');
        fnRef.current(analyticsEvent);
    }, [
        // These are strings and won't change
        action,
        componentName,
        packageName,
        packageVersion,
        // This function is memoized in the context
        createAnalyticsEvent,
        // these are a stable ref because of the useTrackedRef hook
        dataRef,
        fnRef
    ]);
    return handler;
}

});
parcelRegister("1xcFC", function(module, exports) {
$parcel$export(module.exports, "useAnalyticsEvents", () => $11e2b38c3bbc92c8$export$5bf35293e545f20c);

var $dLGML = parcelRequire("dLGML");

var $fz6Tb = parcelRequire("fz6Tb");

var $bfe09 = parcelRequire("bfe09");
function $11e2b38c3bbc92c8$export$5bf35293e545f20c() {
    var analyticsContext = (0, $bfe09.useAnalyticsContext)();
    var createAnalyticsEvent = (0, $dLGML.useCallbackOne)(function(payload) {
        return new (0, $fz6Tb.default)({
            context: analyticsContext.getAtlaskitAnalyticsContext(),
            handlers: analyticsContext.getAtlaskitAnalyticsEventHandlers(),
            payload: payload
        });
    }, [
        analyticsContext
    ]);
    return {
        createAnalyticsEvent: createAnalyticsEvent
    };
}

});
parcelRegister("fz6Tb", function(module, exports) {
$parcel$export(module.exports, "default", () => $b54f77e743853f05$export$2e2bcd8739ae039);

var $fC8ib = parcelRequire("fC8ib");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $kIXpt = parcelRequire("kIXpt");

var $cYPzS = parcelRequire("cYPzS");

var $lwlXp = parcelRequire("lwlXp");

var $eyuDe = parcelRequire("eyuDe");

var $25nEq = parcelRequire("25nEq");

var $4jKP4 = parcelRequire("4jKP4");
function $b54f77e743853f05$var$_callSuper(t, o, e) {
    return o = (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(o), (0, (/*@__PURE__*/$parcel$interopDefault($kIXpt)))(t, $b54f77e743853f05$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(t).constructor) : o.apply(t, e));
}
function $b54f77e743853f05$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($b54f77e743853f05$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $b54f77e743853f05$var$_superPropGet(t, o, e, r) {
    var p = (0, (/*@__PURE__*/$parcel$interopDefault($lwlXp)))((0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(1 & r ? t.prototype : t), o, e);
    return 2 & r && "function" == typeof p ? function(t) {
        return p.apply(e, t);
    } : p;
}
var $b54f77e743853f05$export$35f8383928ba8d7 = function isUIAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $b54f77e743853f05$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isUIAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === 'UIAnalyticsEvent';
};
var $b54f77e743853f05$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_AnalyticsEvent) {
    function UIAnalyticsEvent(props) {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, UIAnalyticsEvent);
        _this = $b54f77e743853f05$var$_callSuper(this, UIAnalyticsEvent, [
            props
        ]);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "_isUIAnalyticsEvent", true);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "clone", function() {
            if (_this.hasFired) return null;
            var context = (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(_this.context);
            var handlers = (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(_this.handlers);
            /**
       * A hacky "deep clone" of the object. This is limited in that it wont
       * support functions, regexs, Maps, Sets, etc, but none of those need to
       * be represented in our payload.
       */ var payload = JSON.parse(JSON.stringify(_this.payload));
            return new UIAnalyticsEvent({
                context: context,
                handlers: handlers,
                payload: payload
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "fire", function(channel) {
            if (_this.hasFired) return;
            _this.handlers.forEach(function(handler) {
                return handler(_this, channel);
            });
            _this.hasFired = true;
        });
        _this.context = props.context || [];
        _this.handlers = props.handlers || [];
        _this.hasFired = false;
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($eyuDe)))(UIAnalyticsEvent, _AnalyticsEvent);
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(UIAnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (this.hasFired) return this;
                return $b54f77e743853f05$var$_superPropGet(UIAnalyticsEvent, "update", this, 3)([
                    updater
                ]);
            }
        }
    ]);
}((0, $4jKP4.default));

});
parcelRegister("4jKP4", function(module, exports) {
$parcel$export(module.exports, "default", () => $324d41cf35b85996$export$2e2bcd8739ae039);

var $ekGgq = parcelRequire("ekGgq");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $25nEq = parcelRequire("25nEq");
function $324d41cf35b85996$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $324d41cf35b85996$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $324d41cf35b85996$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $324d41cf35b85996$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $324d41cf35b85996$export$ad4be5c2ec28cecf = function isAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $324d41cf35b85996$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === 'AnalyticsEvent';
};
var $324d41cf35b85996$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function AnalyticsEvent(props) {
        var _this = this;
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, AnalyticsEvent);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "_isAnalyticsEvent", true);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "clone", function() {
            // just a shallow clone, don't change sub refs unless you want to
            // affect the original's too
            var payload = $324d41cf35b85996$var$_objectSpread({}, _this.payload);
            return new AnalyticsEvent({
                payload: payload
            });
        });
        this.payload = props.payload;
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(AnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (typeof updater === 'function') this.payload = updater(this.payload);
                if ((0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(updater) === 'object') this.payload = $324d41cf35b85996$var$_objectSpread($324d41cf35b85996$var$_objectSpread({}, this.payload), updater);
                return this;
            }
        }
    ]);
}();

});


parcelRegister("bfe09", function(module, exports) {
$parcel$export(module.exports, "useAnalyticsContext", () => $82fbf4d299ff54c3$export$d1f587f82ad51c4);

var $5FkrB = parcelRequire("5FkrB");

var $iyyOp = parcelRequire("iyyOp");
var $82fbf4d299ff54c3$export$d1f587f82ad51c4 = function useAnalyticsContext() {
    return (0, $5FkrB.useContext)((0, $iyyOp.default));
};

});


parcelRegister("b7rOP", function(module, exports) {
$parcel$export(module.exports, "useTrackedRef", () => $8185ed5fb227f46b$export$1d27a74659855e44);

var $5FkrB = parcelRequire("5FkrB");
var $8185ed5fb227f46b$export$1d27a74659855e44 = function useTrackedRef(value) {
    var ref = (0, $5FkrB.useRef)(value);
    ref.current = value;
    return ref;
};

});


parcelRegister("aJI78", function(module, exports) {
$parcel$export(module.exports, "useNotifyOpenLayerObserver", () => $7d10537f49dd0080$export$469bb693f11edc7f);

var $5FkrB = parcelRequire("5FkrB");

var $gBPQG = parcelRequire("gBPQG");

var $lcLil = parcelRequire("lcLil");
function $7d10537f49dd0080$export$469bb693f11edc7f(_ref) {
    var isOpen = _ref.isOpen, type = _ref.type, onClose = _ref.onClose;
    var context = (0, $5FkrB.useContext)((0, $gBPQG.OpenLayerObserverContext));
    var namespace = (0, $lcLil.useOpenLayerObserverNamespace)();
    (0, $5FkrB.useEffect)(function() {
        /**
     * Registers the `onClose` callback with the OpenLayerObserver.
     */ if (context === null) return;
        if (!isOpen) /**
       * If the layer is not open, we are not registering the `onClose` callback.
       * This is important to prevent the `onClose` from being called for layers that
       * are not open.
       *
       * Some consumers mistakenly pass "toggle" functions to `onClose` callbacks for
       * layer components, as Popup, e.g. `onClose={() => setIsOpen(!isOpen)}`.
       */ return;
        return context.onClose(onClose, {
            namespace: namespace,
            type: type
        });
    }, [
        context,
        isOpen,
        namespace,
        onClose,
        type
    ]);
}

});
parcelRegister("gBPQG", function(module, exports) {
$parcel$export(module.exports, "OpenLayerObserverContext", () => $c178521933ccd0e4$export$5fbf4d7fae6cdc00);

var $5FkrB = parcelRequire("5FkrB");
var $c178521933ccd0e4$export$5fbf4d7fae6cdc00 = /*#__PURE__*/ (0, $5FkrB.createContext)(null);

});

parcelRegister("lcLil", function(module, exports) {
$parcel$export(module.exports, "useOpenLayerObserverNamespace", () => $f6ff67c1d48506a2$export$1d57e79091cc3046);

var $5FkrB = parcelRequire("5FkrB");

var $aomRe = parcelRequire("aomRe");
function $f6ff67c1d48506a2$export$1d57e79091cc3046() {
    var namespace = (0, $5FkrB.useContext)((0, $aomRe.OpenLayerObserverNamespaceContext));
    return namespace;
}

});
parcelRegister("aomRe", function(module, exports) {
$parcel$export(module.exports, "OpenLayerObserverNamespaceContext", () => $790de04fd656a96c$export$644a49f3b8c50fcd);

var $5FkrB = parcelRequire("5FkrB");
var $790de04fd656a96c$export$644a49f3b8c50fcd = /*#__PURE__*/ (0, $5FkrB.createContext)(null);

});



parcelRegister("CewGr", function(module, exports) {
$parcel$export(module.exports, "useExitingPersistence", () => $072ed150d7755f1d$export$3b6f38abbdcbd000);
$parcel$export(module.exports, "default", () => $072ed150d7755f1d$export$2e2bcd8739ae039);

var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");
/**
 * Internally we will be playing with an element that will always have a key defined.
 */ /**
 * Internal data passed to child motions.
 */ // We define empty context here so the object doesn't change.
var $072ed150d7755f1d$var$emptyContext = {
    // Motions will always appear if not inside a exiting persistence component.
    appear: true,
    isExiting: false
};
/**
 * __Exiting context__
 *
 * An exiting context.
 */ var $072ed150d7755f1d$var$ExitingContext = /*#__PURE__*/ (0, $5FkrB.createContext)($072ed150d7755f1d$var$emptyContext);
/**
 * This method will wrap any React element with a context provider. We're using context (instead of
 * cloneElement) so we can communicate between multiple elements without the need of prop drilling
 * (results in a better API for consumers).
 */ var $072ed150d7755f1d$var$wrapChildWithContextProvider = function wrapChildWithContextProvider(child) {
    var value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $072ed150d7755f1d$var$emptyContext;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement($072ed150d7755f1d$var$ExitingContext.Provider, {
        key: "".concat(child.key, "-provider"),
        value: value
    }, child);
};
/**
 * This function will convert all children types to an array while also filtering out non-valid React elements.
 */ var $072ed150d7755f1d$var$childrenToArray = function childrenToArray(children) {
    var childrenAsArray = [];
    // We convert children to an array using this helper method as it will add keys to children that do not
    // have them, such as when we have hardcoded children that are conditionally rendered.
    (0, $5FkrB.Children).toArray(children).forEach(function(child) {
        // We ignore any boolean children to make our code a little more simple later on,
        // and also filter out any falsies (empty strings, nulls, and undefined).
        if (typeof child !== 'boolean' && Boolean(child)) // Children WILL have a key after being forced into an array using the React.Children helper.
        childrenAsArray.push(child);
    });
    return childrenAsArray;
};
var $072ed150d7755f1d$var$spliceNewElementsIntoPrevious = function spliceNewElementsIntoPrevious(current, previous) {
    var splicedChildren = previous.concat([]);
    var previousMap = $072ed150d7755f1d$var$childrenToObj(previous);
    for(var i = 0; i < current.length; i++){
        var child = current[i];
        var childIsNew = !previousMap[child.key];
        if (childIsNew) // This will insert the new element after the previous element.
        splicedChildren.splice(i + 1, 0, child);
    }
    return splicedChildren;
};
var $072ed150d7755f1d$var$childrenToObj = function childrenToObj(children) {
    return children.reduce(function(acc, child) {
        acc[child.key] = child;
        return acc;
    }, {});
};
var $072ed150d7755f1d$var$getMissingKeys = function getMissingKeys(current, previous) {
    var currentMapKeys = new Set(current.map(function(child) {
        return child.key;
    }));
    var missing = new Set();
    for(var i = 0; i < previous.length; i++){
        var element = previous[i];
        var _key = element.key;
        if (!currentMapKeys.has(_key)) missing.add(_key);
    }
    return missing;
};
/**
 * How does this component work?
 *
 * It looks at changes in its children to see what is removed.
 *
 * If a child is removed it clones it and wraps it with context providing an `onFinish` callback.
 *
 * The cloned child will call the `onFinish` when it finishes its exit animation,
 * which lets `ExitingPersistence` know to stop rendering it.
 */ /**
 * __ExitingPersistence__
 *
 * Useful for enabling elements to persist and animate away when they are removed from the DOM.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/motion/docs/entering-motions)
 */ var $072ed150d7755f1d$var$ExitingPersistence = /*#__PURE__*/ (0, $5FkrB.memo)(function(_ref) {
    var _ref$appear = _ref.appear, appear = _ref$appear === void 0 ? false : _ref$appear, children = _ref.children, exitThenEnter = _ref.exitThenEnter;
    var _useState = (0, $5FkrB.useState)([
        null,
        children
    ]), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), stateChildren = _useState2[0], setChildren = _useState2[1];
    var _useState3 = (0, $5FkrB.useState)([]), _useState4 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState3, 2), exitingChildren = _useState4[0], setExitingChildren = _useState4[1];
    var _useState5 = (0, $5FkrB.useState)(function() {
        return {
            appear: appear,
            isExiting: false
        };
    }), _useState6 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState5, 2), defaultContext = _useState6[0], setDefaultContext = _useState6[1];
    (0, $5FkrB.useEffect)(function() {
        if (!defaultContext.appear) setDefaultContext({
            appear: true,
            isExiting: false
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    /**
   * NOTE: This is a workaround for the test case written in Jira where the stateChildren is a boolean value because
   * useState is mocked to return a boolean value.
   */ if (typeof stateChildren === 'boolean') return children;
    var _stateChildren = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(stateChildren, 2), previousChildren = _stateChildren[0], currentChildren = _stateChildren[1];
    var previous = $072ed150d7755f1d$var$childrenToArray(previousChildren);
    var current = $072ed150d7755f1d$var$childrenToArray(currentChildren);
    if (currentChildren !== children) setChildren([
        currentChildren,
        children
    ]);
    var missingKeys = $072ed150d7755f1d$var$getMissingKeys(current, previous);
    var isSomeChildRemoved = !!missingKeys.size;
    var visibleChildren = current;
    if (isSomeChildRemoved) visibleChildren = $072ed150d7755f1d$var$spliceNewElementsIntoPrevious(current, previous);
    if (exitThenEnter) {
        if (exitingChildren.length) visibleChildren = exitingChildren;
        else {
            var nextExitingChildren = visibleChildren.filter(function(child) {
                return missingKeys.has(child.key);
            });
            if (nextExitingChildren.length) setExitingChildren(nextExitingChildren);
        }
    }
    if (missingKeys.size) visibleChildren = visibleChildren.map(function(child) {
        var isExiting = missingKeys.has(child.key);
        return $072ed150d7755f1d$var$wrapChildWithContextProvider(child, {
            appear: true,
            isExiting: isExiting,
            onFinish: isExiting ? function() {
                missingKeys.delete(child.key);
                if (missingKeys.size === 0) {
                    setChildren([
                        null,
                        children
                    ]);
                    setExitingChildren([]);
                }
            } : undefined
        });
    });
    else visibleChildren = visibleChildren.map(function(child) {
        return $072ed150d7755f1d$var$wrapChildWithContextProvider(child, defaultContext);
    });
    return visibleChildren;
});
var $072ed150d7755f1d$export$3b6f38abbdcbd000 = function useExitingPersistence() {
    return (0, $5FkrB.useContext)($072ed150d7755f1d$var$ExitingContext);
};
$072ed150d7755f1d$var$ExitingPersistence.displayName = 'ExitingPersistence';
var $072ed150d7755f1d$export$2e2bcd8739ae039 = $072ed150d7755f1d$var$ExitingPersistence;

});

parcelRegister("6PYH9", function(module, exports) {
$parcel$export(module.exports, "default", () => $4fa69644b0a87262$export$2e2bcd8739ae039);

var $5FkrB = parcelRequire("5FkrB");

var $6SLL2 = parcelRequire("6SLL2");
var $4fa69644b0a87262$var$invertedDirection = {
    top: 'bottom',
    bottom: 'top',
    left: 'right',
    right: 'left'
};
/**
 * Props for controlling the behavior of the FadeIn animation
 */ /**
 * __FadeIn__
 *
 * Useful for fading in one or more elements.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/motion/docs/entering-motions)
 */ var $4fa69644b0a87262$var$FadeIn = function FadeIn(_ref) {
    var children = _ref.children, _ref$duration = _ref.duration, duration = _ref$duration === void 0 ? 'large' : _ref$duration, entranceDirection = _ref.entranceDirection, exitDirection = _ref.exitDirection, _ref$distance = _ref.distance, distance = _ref$distance === void 0 ? 'proportional' : _ref$distance, onFinish = _ref.onFinish, isPaused = _ref.isPaused;
    var invertedEntranceDirection = entranceDirection !== undefined ? $4fa69644b0a87262$var$invertedDirection[entranceDirection] : undefined;
    var isExitDirect = Boolean(exitDirection || invertedEntranceDirection) ? "fade-out-from-".concat(exitDirection || invertedEntranceDirection).concat(distance === 'proportional' ? '' : '-constant') : 'fade-out';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $6SLL2.default), {
        duration: duration,
        enteringAnimation: entranceDirection ? "fade-in-from-".concat(entranceDirection).concat(distance === 'proportional' ? '' : '-constant') : 'fade-in',
        exitingAnimation: isExitDirect,
        animationTimingFunction: "ease-in-out",
        onFinish: onFinish,
        isPaused: isPaused
    }, children);
};
var $4fa69644b0a87262$export$2e2bcd8739ae039 = $4fa69644b0a87262$var$FadeIn;

});
parcelRegister("6SLL2", function(module, exports) {
$parcel$export(module.exports, "default", () => $502cd4e4cfef9fcb$export$2e2bcd8739ae039);
/* keyframes-motion.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");

var $goV6V = parcelRequire("goV6V");

var $69QxS = parcelRequire("69QxS");

var $9ke9L = parcelRequire("9ke9L");

var $CewGr = parcelRequire("CewGr");

var $35xoB = parcelRequire("35xoB");
var $502cd4e4cfef9fcb$var$zoomIn = null;
var $502cd4e4cfef9fcb$var$zoomOut = null;
var $502cd4e4cfef9fcb$var$fadeIn = null;
var $502cd4e4cfef9fcb$var$fadeOut = null;
var $502cd4e4cfef9fcb$var$fadeInFromTop = null;
var $502cd4e4cfef9fcb$var$fadeOutFromTop = null;
var $502cd4e4cfef9fcb$var$fadeInFromLeft = null;
var $502cd4e4cfef9fcb$var$fadeOutFromLeft = null;
var $502cd4e4cfef9fcb$var$fadeInFromBottom = null;
var $502cd4e4cfef9fcb$var$fadeOutFromBottom = null;
var $502cd4e4cfef9fcb$var$fadeInFromRight = null;
var $502cd4e4cfef9fcb$var$fadeOutFromRight = null;
var $502cd4e4cfef9fcb$var$fadeInFromTopConstant = null;
var $502cd4e4cfef9fcb$var$fadeOutFromTopConstant = null;
var $502cd4e4cfef9fcb$var$fadeInFromLeftConstant = null;
var $502cd4e4cfef9fcb$var$fadeOutFromLeftConstant = null;
var $502cd4e4cfef9fcb$var$fadeInFromBottomConstant = null;
var $502cd4e4cfef9fcb$var$fadeOutFromBottomConstant = null;
var $502cd4e4cfef9fcb$var$fadeInFromRightConstant = null;
var $502cd4e4cfef9fcb$var$fadeOutFromRightConstant = null;
var $502cd4e4cfef9fcb$var$slideInFromTop = null;
var $502cd4e4cfef9fcb$var$slideOutFromTop = null;
var $502cd4e4cfef9fcb$var$slideInFromRight = null;
var $502cd4e4cfef9fcb$var$slideOutFromRight = null;
var $502cd4e4cfef9fcb$var$slideInFromBottom = null;
var $502cd4e4cfef9fcb$var$slideOutFromBottom = null;
var $502cd4e4cfef9fcb$var$slideInFromLeft = null;
var $502cd4e4cfef9fcb$var$slideOutFromLeft = null;
/**
 * These are props that motions should use as their external props for consumers.
 * See [FadeIn](packages/helpers/motion/src/entering/fade-in.tsx) for an example usage.
 */ /**
 * This is the base INTERNAL component used for all other entering motions.
 * This does not need Javascript to execute on the client so it will run immediately
 * for any SSR rendered React apps before the JS has executed.
 */ var $502cd4e4cfef9fcb$var$EnteringMotion = function EnteringMotion(_ref) {
    var children = _ref.children, animationTimingFunction = _ref.animationTimingFunction, _ref$animationTimingF = _ref.animationTimingFunctionExiting, animationTimingFunctionExiting = _ref$animationTimingF === void 0 ? animationTimingFunction : _ref$animationTimingF, enteringAnimation = _ref.enteringAnimation, _ref$exitingAnimation = _ref.exitingAnimation, exitingAnimation = _ref$exitingAnimation === void 0 ? enteringAnimation : _ref$exitingAnimation, isPaused = _ref.isPaused, onFinishMotion = _ref.onFinish, _ref$duration = _ref.duration, duration = _ref$duration === void 0 ? 'large' : _ref$duration;
    var staggered = (0, $35xoB.useStaggeredEntrance)();
    var _useExitingPersistenc = (0, $CewGr.useExitingPersistence)(), isExiting = _useExitingPersistenc.isExiting, onExitFinished = _useExitingPersistenc.onFinish, appear = _useExitingPersistenc.appear;
    var setTimeout = (0, $9ke9L.useSetTimeout)();
    var paused = isPaused || !staggered.isReady;
    var delay = isExiting ? 0 : staggered.delay;
    var state = isExiting ? 'exiting' : 'entering';
    var _useState = (0, $5FkrB.useState)(appear), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), hasAnimationStyles = _useState2[0], setHasAnimationStyles = _useState2[1];
    (0, $5FkrB.useEffect)(function() {
        // Tracking this to prevent changing state on an unmounted component
        var isCancelled = false;
        if (paused) return;
        // On initial mount if elements aren't set to animate on appear, we return early and callback
        if (!appear) {
            onFinishMotion && onFinishMotion(state);
            return;
        }
        /**
     * Updates relevant state.
     * Called when the animation is finished, or immediately with reduced motion.
     */ var onAnimationEnd = function onAnimationEnd() {
            if (state === 'exiting') // Updates the `ExitingPersistence` to remove this child
            onExitFinished === null || onExitFinished === void 0 || onExitFinished();
            if (!isCancelled) setHasAnimationStyles(false);
            onFinishMotion === null || onFinishMotion === void 0 || onFinishMotion(state);
        };
        if ((0, $goV6V.isReducedMotion)()) {
            // If there is reduced motion there is no exit animation, so call this immediately
            onAnimationEnd();
            return;
        }
        // Elements may need animation styles back after initial mount (they could animate out)
        setHasAnimationStyles(true);
        // Queue `onAnimationEnd` for after the animation has finished
        setTimeout(onAnimationEnd, isExiting ? (0, $69QxS.exitingDurations)[duration] : (0, $69QxS.durations)[duration] + delay);
        return function() {
            isCancelled = true;
        };
    // We ignore this for onFinishMotion as consumers could potentially inline the function
    // which would then trigger this effect every re-render.
    // We want to make it easier for consumers so we go down this path unfortunately.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        onExitFinished,
        state,
        isExiting,
        duration,
        delay,
        paused,
        setTimeout
    ]);
    return children({
        ref: staggered.ref,
        // @ts-expect-error: `ax` is not typed correctly
        className: hasAnimationStyles ? (0, $970q7.default)([
            (0, $970q7.default)([
                "_1o51eoah _1y0co91m _1bumglyw _sedtglyw"
            ]),
            paused && (0, $970q7.default)([
                "_1y0ctrqk"
            ]),
            duration === 'small' && (0, $970q7.default)([
                "_5sag1yx9"
            ]),
            duration === 'medium' && (0, $970q7.default)([
                "_5sag1ttt"
            ]),
            duration === 'large' && (0, $970q7.default)([
                "_5sagpwmj"
            ]),
            isExiting && duration === 'small' && (0, $970q7.default)([
                "_5sag14ed"
            ]),
            isExiting && duration === 'medium' && (0, $970q7.default)([
                "_5sagluct"
            ]),
            isExiting && duration === 'large' && (0, $970q7.default)([
                "_5sag1ttt"
            ]),
            isExiting && (0, $970q7.default)([
                "_ju255cps _1o51q7pw"
            ]),
            !isExiting && animationTimingFunction === 'linear' && (0, $970q7.default)([
                "_1pglp3kn"
            ]),
            !isExiting && animationTimingFunction === 'ease-out' && (0, $970q7.default)([
                "_1pgldkwg"
            ]),
            !isExiting && animationTimingFunction === 'ease-in' && (0, $970q7.default)([
                "_1pgl1nzg"
            ]),
            !isExiting && animationTimingFunction === 'ease-in-40-out' && (0, $970q7.default)([
                "_1pgl5y64"
            ]),
            !isExiting && animationTimingFunction === 'ease-in-60-out' && (0, $970q7.default)([
                "_1pgl1ddy"
            ]),
            !isExiting && animationTimingFunction === 'ease-in-80-out' && (0, $970q7.default)([
                "_1pglannl"
            ]),
            !isExiting && animationTimingFunction === 'ease-in-out' && (0, $970q7.default)([
                "_1pgl1fu8"
            ]),
            isExiting && animationTimingFunction === 'linear' && (0, $970q7.default)([
                "_1pglp3kn"
            ]),
            isExiting && animationTimingFunctionExiting === 'ease-out' && (0, $970q7.default)([
                "_1pgldkwg"
            ]),
            isExiting && animationTimingFunctionExiting === 'ease-in' && (0, $970q7.default)([
                "_1pgl1nzg"
            ]),
            isExiting && animationTimingFunctionExiting === 'ease-in-40-out' && (0, $970q7.default)([
                "_1pgl5y64"
            ]),
            isExiting && animationTimingFunctionExiting === 'ease-in-60-out' && (0, $970q7.default)([
                "_1pgl1ddy"
            ]),
            isExiting && animationTimingFunctionExiting === 'ease-in-80-out' && (0, $970q7.default)([
                "_1pglannl"
            ]),
            isExiting && animationTimingFunctionExiting === 'ease-in-out' && (0, $970q7.default)([
                "_1pgl1fu8"
            ]),
            (!isExiting && enteringAnimation === 'fade-in' || isExiting && exitingAnimation === 'fade-in') && (0, $970q7.default)([
                "_j7hq1cgr"
            ]),
            (!isExiting && enteringAnimation === 'fade-out' || isExiting && exitingAnimation === 'fade-out') && (0, $970q7.default)([
                "_j7hq1lln"
            ]),
            (!isExiting && enteringAnimation === 'zoom-in' || isExiting && exitingAnimation === 'zoom-in') && (0, $970q7.default)([
                "_j7hqe8p0"
            ]),
            (!isExiting && enteringAnimation === 'zoom-out' || isExiting && exitingAnimation === 'zoom-out') && (0, $970q7.default)([
                "_j7hqy6ql"
            ]),
            (!isExiting && enteringAnimation === 'slide-in-from-top' || isExiting && exitingAnimation === 'slide-in-from-top') && (0, $970q7.default)([
                "_j7hqqshu"
            ]),
            (!isExiting && enteringAnimation === 'slide-out-from-top' || isExiting && exitingAnimation === 'slide-out-from-top') && (0, $970q7.default)([
                "_j7hq7ri4"
            ]),
            (!isExiting && enteringAnimation === 'slide-in-from-right' || isExiting && exitingAnimation === 'slide-in-from-right') && (0, $970q7.default)([
                "_j7hqdfjr"
            ]),
            (!isExiting && enteringAnimation === 'slide-out-from-right' || isExiting && exitingAnimation === 'slide-out-from-right') && (0, $970q7.default)([
                "_j7hqonfj"
            ]),
            (!isExiting && enteringAnimation === 'slide-in-from-bottom' || isExiting && exitingAnimation === 'slide-in-from-bottom') && (0, $970q7.default)([
                "_j7hq1liq"
            ]),
            (!isExiting && enteringAnimation === 'slide-out-from-bottom' || isExiting && exitingAnimation === 'slide-out-from-bottom') && (0, $970q7.default)([
                "_j7hqhnf1"
            ]),
            (!isExiting && enteringAnimation === 'slide-in-from-left' || isExiting && exitingAnimation === 'slide-in-from-left') && (0, $970q7.default)([
                "_j7hq1bh1"
            ]),
            (!isExiting && enteringAnimation === 'slide-out-from-left' || isExiting && exitingAnimation === 'slide-out-from-left') && (0, $970q7.default)([
                "_j7hqj08w"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-top' || isExiting && exitingAnimation === 'fade-in-from-top') && (0, $970q7.default)([
                "_j7hq2iua"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-top' || isExiting && exitingAnimation === 'fade-out-from-top') && (0, $970q7.default)([
                "_j7hq39va"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-left' || isExiting && exitingAnimation === 'fade-in-from-left') && (0, $970q7.default)([
                "_j7hq15m2"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-left' || isExiting && exitingAnimation === 'fade-out-from-left') && (0, $970q7.default)([
                "_j7hq1yiv"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-bottom' || isExiting && exitingAnimation === 'fade-in-from-bottom') && (0, $970q7.default)([
                "_j7hq1w00"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-bottom' || isExiting && exitingAnimation === 'fade-out-from-bottom') && (0, $970q7.default)([
                "_j7hqzy3z"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-right' || isExiting && exitingAnimation === 'fade-in-from-right') && (0, $970q7.default)([
                "_j7hqpqak"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-right' || isExiting && exitingAnimation === 'fade-out-from-right') && (0, $970q7.default)([
                "_j7hq1ebg"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-top-constant' || isExiting && exitingAnimation === 'fade-in-from-top-constant') && (0, $970q7.default)([
                "_j7hqm2e2"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-top-constant' || isExiting && exitingAnimation === 'fade-out-from-top-constant') && (0, $970q7.default)([
                "_j7hq97jn"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-left-constant' || isExiting && exitingAnimation === 'fade-in-from-left-constant') && (0, $970q7.default)([
                "_j7hqovgq"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-left-constant' || isExiting && exitingAnimation === 'fade-out-from-left-constant') && (0, $970q7.default)([
                "_j7hq15do"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-bottom-constant' || isExiting && exitingAnimation === 'fade-in-from-bottom-constant') && (0, $970q7.default)([
                "_j7hq797a"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-bottom-constant' || isExiting && exitingAnimation === 'fade-out-from-bottom-constant') && (0, $970q7.default)([
                "_j7hqwo7r"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-right-constant' || isExiting && exitingAnimation === 'fade-in-from-right-constant') && (0, $970q7.default)([
                "_j7hqt8u5"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-right-constant' || isExiting && exitingAnimation === 'fade-out-from-right-constant') && (0, $970q7.default)([
                "_j7hq1pgp"
            ])
        ]) : '',
        style: {
            animationDelay: "".concat(delay, "ms")
        }
    }, state);
};
var $502cd4e4cfef9fcb$export$2e2bcd8739ae039 = $502cd4e4cfef9fcb$var$EnteringMotion;

});
parcelRegister("goV6V", function(module, exports) {
$parcel$export(module.exports, "isReducedMotion", () => $bf0b303e393f28f7$export$b7baf7667a68d87c);

var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");

var $7QpUe = parcelRequire("7QpUe");
var $bf0b303e393f28f7$var$isMatchMediaAvailable = function isMatchMediaAvailable() {
    return typeof window !== 'undefined' && 'matchMedia' in window;
};
var $bf0b303e393f28f7$export$b7baf7667a68d87c = function isReducedMotion() {
    if (!$bf0b303e393f28f7$var$isMatchMediaAvailable()) return false;
    var _window$matchMedia = window.matchMedia('(prefers-reduced-motion: reduce)'), matches = _window$matchMedia.matches;
    return matches;
};
var $bf0b303e393f28f7$export$c537e63161742ce3 = function useIsReducedMotion() {
    var _useState = (0, $5FkrB.useState)($bf0b303e393f28f7$export$b7baf7667a68d87c), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), prefersReducedMotion = _useState2[0], setPrefersReducedMotion = _useState2[1];
    (0, $5FkrB.useEffect)(function() {
        if (!$bf0b303e393f28f7$var$isMatchMediaAvailable()) return;
        var mediaQueryList = window.matchMedia('(prefers-reduced-motion: reduce)');
        var onChange = function onChange(event) {
            return setPrefersReducedMotion(event.matches);
        };
        return (0, $7QpUe.bind)(mediaQueryList, {
            type: 'change',
            listener: onChange
        });
    }, []);
    return prefersReducedMotion;
};
var $bf0b303e393f28f7$export$f0f789643ba5a83c = {
    '@media (prefers-reduced-motion: reduce)': {
        animation: 'none',
        transition: 'none'
    }
};
var $bf0b303e393f28f7$export$ff7706047246b98b = function prefersReducedMotion() {
    return $bf0b303e393f28f7$export$f0f789643ba5a83c;
};

});

parcelRegister("69QxS", function(module, exports) {
$parcel$export(module.exports, "durations", () => $47bc57be10fc7918$export$38b928a7167ce124);
$parcel$export(module.exports, "exitingDurations", () => $47bc57be10fc7918$export$30fa1a2e62ae150c);
/**
 * Think of this as the motion equivalent of the @atlaskit/theme `grid()`.
 */ var $47bc57be10fc7918$export$368bacef0dacbe05 = 25;
var $47bc57be10fc7918$export$38b928a7167ce124 = {
    none: 0,
    small: 100,
    medium: 350,
    large: 700
};
/**
 * Used to multiply the initial duration for exiting motions.
 */ var $47bc57be10fc7918$var$EXITING_MOTION_MULTIPLIER = 0.5;
var $47bc57be10fc7918$export$30fa1a2e62ae150c = {
    none: $47bc57be10fc7918$export$38b928a7167ce124.none,
    small: $47bc57be10fc7918$export$38b928a7167ce124.small * $47bc57be10fc7918$var$EXITING_MOTION_MULTIPLIER,
    medium: $47bc57be10fc7918$export$38b928a7167ce124.medium * $47bc57be10fc7918$var$EXITING_MOTION_MULTIPLIER,
    large: $47bc57be10fc7918$export$38b928a7167ce124.large * $47bc57be10fc7918$var$EXITING_MOTION_MULTIPLIER
};

});

parcelRegister("9ke9L", function(module, exports) {
$parcel$export(module.exports, "useSetTimeout", () => $6ca0f67936e4281c$export$4f34107a2b00f39c);

var $5FkrB = parcelRequire("5FkrB");
// Handle both browser and Node.js environments
var $6ca0f67936e4281c$var$getHookDeps = function getHookDeps(opts) {
    switch(opts.cleanup){
        case 'next-effect':
            return undefined;
        case 'unmount':
        default:
            return [];
    }
};
var $6ca0f67936e4281c$export$1775f27e7c8051ca = function useRequestAnimationFrame() {
    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        cleanup: 'unmount'
    };
    var frames = (0, $5FkrB.useRef)([]);
    (0, $5FkrB.useEffect)(function() {
        return function() {
            if (frames.current.length) {
                frames.current.forEach(function(id) {
                    return cancelAnimationFrame(id);
                });
                frames.current = [];
            }
        };
    // We dynamically set this so we either clean up on the next effect - or on unmount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, $6ca0f67936e4281c$var$getHookDeps(opts));
    return (0, $5FkrB.useCallback)(function(handler) {
        var id = requestAnimationFrame(function(time) {
            frames.current = frames.current.filter(function(frameId) {
                return frameId !== id;
            });
            handler(time);
        });
        frames.current.push(id);
    }, []);
};
var $6ca0f67936e4281c$export$4f34107a2b00f39c = function useSetTimeout() {
    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        cleanup: 'unmount'
    };
    var timeouts = (0, $5FkrB.useRef)([]);
    (0, $5FkrB.useEffect)(function() {
        return function() {
            if (timeouts.current.length) {
                timeouts.current.forEach(function(id) {
                    return clearTimeout(id);
                });
                timeouts.current = [];
            }
        };
    // We dynamically set this so we either clean up on the next effect - or on unmount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, $6ca0f67936e4281c$var$getHookDeps(opts));
    return (0, $5FkrB.useCallback)(function(handler, timeout) {
        for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)args[_key - 2] = arguments[_key];
        var id = setTimeout.apply(void 0, [
            function() {
                timeouts.current = timeouts.current.filter(function(timeoutId) {
                    return timeoutId !== id;
                });
                handler();
            },
            timeout
        ].concat(args));
        timeouts.current.push(id);
    }, []);
};

});

parcelRegister("35xoB", function(module, exports) {
$parcel$export(module.exports, "useStaggeredEntrance", () => $23fbbe730a75fd33$export$25c7213fc07ec080);

var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");

var $eVb4V = parcelRequire("eVb4V");

var $crIAh = parcelRequire("crIAh");

var $jOFu8 = parcelRequire("jOFu8");
var $23fbbe730a75fd33$var$StaggeredEntranceContext = /*#__PURE__*/ (0, $5FkrB.createContext)(function() {
    return {
        isReady: true,
        delay: 0,
        ref: (0, $eVb4V.default)
    };
});
var $23fbbe730a75fd33$export$25c7213fc07ec080 = function useStaggeredEntrance() {
    var indentifier = (0, $jOFu8.useUniqueId)();
    var context = (0, $5FkrB.useContext)($23fbbe730a75fd33$var$StaggeredEntranceContext);
    return context(indentifier);
};
/**
 * For a list of elements that need to animate in,
 * this should be used in conjunction with entering components.
 * This does not need Javascript to execute so it will run immediately for any SSR rendered React apps before the JS has executed.
 *
 * Will dynamically add delay to each child entering component.
 * Unfortunately all entering components _NEED_ to be a direct descendant.
 */ var $23fbbe730a75fd33$var$StaggeredEntrance = function StaggeredEntrance(_ref) {
    var children = _ref.children, column = _ref.column, _ref$columns = _ref.columns, columns = _ref$columns === void 0 ? 'responsive' : _ref$columns, _ref$delayStep = _ref.delayStep, delayStep = _ref$delayStep === void 0 ? 50 : _ref$delayStep;
    var elementRefs = (0, $5FkrB.useRef)([]);
    var indexes = [];
    var _useState = (0, $5FkrB.useState)(function() {
        if (typeof columns === 'number') // A hardcoded columns is set so bail out and set it to that!
        return columns;
        if (typeof column === 'number') // A hardcoded column is set so we will set actualColumns to be 1.
        return 1;
        // We are in "responsive" mode.
        // So we will be calculating when the Javascript executes on the client how many columns there will be.
        return 0;
    }), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), actualColumns = _useState2[0], setActualColumns = _useState2[1];
    (0, $crIAh.useLayoutEffect)(function() {
        // We want to only run this code when we are in "responsive" mode.
        // It is assumed we are in responsive mode if `columns` is "responsive",
        // we have children element refs ready to be read (i.e. if there are no children this won't run as well)
        // and finally that `actualColumns` is `0` - this is because for the first render cycle `actualColumns` will be `0` (set above)
        // and then after this layout effect runs the value for `actualColumns` will then be calculated and set.
        if (columns === 'responsive' && elementRefs.current.length && actualColumns === 0) {
            var currentTop = 0;
            var numberColumns = 0;
            if (elementRefs.current.length <= 1) {
                setActualColumns(1);
                return;
            }
            // We set the current top to the first elements.
            // We will be comparing this and incrementing the column count
            // until we hit an element that has a different offset top (or we run out of elements).
            currentTop = elementRefs.current[0] ? elementRefs.current[0].offsetTop : 0;
            for(var i = 0; i < elementRefs.current.length; i++){
                var child = elementRefs.current[i];
                if (!child) break;
                if (currentTop === child.offsetTop) {
                    numberColumns += 1;
                    if (elementRefs.current.length - 1 === i) setActualColumns(numberColumns);
                    continue;
                }
                setActualColumns(numberColumns);
                break;
            }
        }
    // We only want this effect to run once - on initial mount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement($23fbbe730a75fd33$var$StaggeredEntranceContext.Provider, {
        value: function value(id) {
            if (!indexes.includes(id)) indexes.push(id);
            var isReady = actualColumns > 0;
            var index = indexes.indexOf(id);
            var currentColumn = column || index % actualColumns;
            var currentRow = Math.floor(index / actualColumns);
            var distanceFromTopLeftElement = currentRow + currentColumn;
            // We don't want loads of elements to have the same staggered delay as it ends up looking slow for users.
            // To get around that we calculate the logarithm using `distanceFromTopLeftElement` which ends making
            // elements appear faster the further away from the top left element.
            var delay = Math.ceil(Math.log(distanceFromTopLeftElement + 1) * delayStep * 1.5) || 0;
            return {
                delay: delay,
                isReady: isReady,
                ref: function ref(element) {
                    return elementRefs.current[index] = element;
                }
            };
        }
    }, children);
};
var $23fbbe730a75fd33$export$2e2bcd8739ae039 = $23fbbe730a75fd33$var$StaggeredEntrance;

});
parcelRegister("crIAh", function(module, exports) {
$parcel$export(module.exports, "useLayoutEffect", () => $90fa971df6e9c81a$export$e5c5a5f917a5871c);

var $5FkrB = parcelRequire("5FkrB");
var $90fa971df6e9c81a$export$e5c5a5f917a5871c = typeof window === 'undefined' ? (0, $5FkrB.useEffect) : (0, $5FkrB.useLayoutEffect);

});

parcelRegister("jOFu8", function(module, exports) {
$parcel$export(module.exports, "useUniqueId", () => $e6d2dde69da2e365$export$c485849f2e393253);
/* eslint-disable @repo/internal/react/disallow-unstable-values */ 
var $5FkrB = parcelRequire("5FkrB");
function $e6d2dde69da2e365$export$c485849f2e393253() {
    var identifier = (0, $5FkrB.useRef)('');
    if (!identifier.current) identifier.current = '_' + (Number(String(Math.random()).slice(2)) + Date.now() + Math.round(performance.now())).toString(36);
    return identifier.current;
}

});




parcelRegister("9mzLx", function(module, exports) {
$parcel$export(module.exports, "default", () => $6d11e972b4481c4d$export$2e2bcd8739ae039);

var $5FkrB = parcelRequire("5FkrB");

var $9Zzpd = parcelRequire("9Zzpd");

var $dHfgc = parcelRequire("dHfgc");

var $8gSu7 = parcelRequire("8gSu7");

var $jayNZ = parcelRequire("jayNZ");

var $cSkX6 = parcelRequire("cSkX6");
function $6d11e972b4481c4d$export$2e2bcd8739ae039(_ref) {
    var _ref$zIndex = _ref.zIndex, zIndex = _ref$zIndex === void 0 ? 0 : _ref$zIndex, children = _ref.children, _ref$mountStrategy = _ref.mountStrategy, mountStrategy = _ref$mountStrategy === void 0 ? 'effect' : _ref$mountStrategy;
    var isSubsequentRender = (0, $jayNZ.default)(mountStrategy);
    (0, $cSkX6.default)(zIndex);
    return !(0, $9Zzpd.fg)('platform_design_system_team_portal_logic_r18_fix') ? isSubsequentRender ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $dHfgc.default), {
        zIndex: zIndex
    }, children) : null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $8gSu7.default), {
        zIndex: zIndex
    }, children);
}

});
parcelRegister("dHfgc", function(module, exports) {
$parcel$export(module.exports, "default", () => $9f8b20e91a586311$export$2e2bcd8739ae039);

var $5FkrB = parcelRequire("5FkrB");

var $aLeHs = parcelRequire("aLeHs");

var $eFb9R = parcelRequire("eFb9R");
function $9f8b20e91a586311$export$2e2bcd8739ae039(props) {
    var zIndex = props.zIndex, children = props.children;
    var container = (0, $5FkrB.useMemo)(function() {
        return (0, $eFb9R.createContainer)(zIndex);
    }, [
        zIndex
    ]);
    // This is in the render method instead of useEffect so that
    // the portal will be added to the DOM before the children render.
    // For any further changes, ensure that the container does not have a
    // parent besides the portal parent.
    (0, $eFb9R.appendPortalContainerIfNotAppended)(container);
    (0, $5FkrB.useEffect)(function() {
        return function() {
            (0, $eFb9R.removePortalContainer)(container);
        };
    }, [
        container
    ]);
    return /*#__PURE__*/ (0, $aLeHs.createPortal)(children, container);
}

});
parcelRegister("eFb9R", function(module, exports) {
$parcel$export(module.exports, "createContainer", () => $aacd8cc937d4ff4e$export$26ae5ca175b4ec5a);
$parcel$export(module.exports, "removePortalContainer", () => $aacd8cc937d4ff4e$export$da99f98bf3fe55b3);
$parcel$export(module.exports, "appendPortalContainerIfNotAppended", () => $aacd8cc937d4ff4e$export$c582005add11e141);
$parcel$export(module.exports, "createAtlaskitPortal", () => $aacd8cc937d4ff4e$export$fef014d7cef9e543);
$parcel$export(module.exports, "createPortalParent", () => $aacd8cc937d4ff4e$export$95029ca7aca2989e);

var $cJqhb = parcelRequire("cJqhb");
var $aacd8cc937d4ff4e$export$26ae5ca175b4ec5a = function createContainer(zIndex) {
    var container = document.createElement('div');
    container.className = (0, $cJqhb.portalClassName);
    container.style.zIndex = "".concat(zIndex);
    return container;
};
/**
 * Returns document body element
 * @return {number} - The document body element
 */ var $aacd8cc937d4ff4e$var$getBody = function getBody() {
    return document.body;
};
/**
 * Returns portal parent container. If no container exists already then it creates a new container with class name 'atlaskit-portal-container'
 * @return {Element} - The portal parent container div element
 */ var $aacd8cc937d4ff4e$var$getPortalParent = function getPortalParent() {
    var parentElement = document.querySelector((0, $cJqhb.portalParentSelector));
    if (!parentElement) {
        var _getBody;
        var parent = document.createElement('div');
        parent.className = (0, $cJqhb.portalParentClassName);
        // we are setting display to flex because we want each portal to create a new stacking context
        // See https://developer.mozilla.org/en-US/docs/Web/CSS/CSS_Positioning/Understanding_z_index/The_stacking_context
        parent.style.display = 'flex';
        (_getBody = $aacd8cc937d4ff4e$var$getBody()) === null || _getBody === void 0 || _getBody.appendChild(parent);
        return parent;
    }
    return parentElement;
};
var $aacd8cc937d4ff4e$export$da99f98bf3fe55b3 = function removePortalContainer(container) {
    $aacd8cc937d4ff4e$var$getPortalParent().removeChild(container);
};
var $aacd8cc937d4ff4e$export$c582005add11e141 = function appendPortalContainerIfNotAppended(container) {
    if (!container.parentElement) $aacd8cc937d4ff4e$var$getPortalParent().appendChild(container);
};
var $aacd8cc937d4ff4e$var$isDocumentDefined = function isDocumentDefined() {
    return document !== undefined;
};
var $aacd8cc937d4ff4e$export$fef014d7cef9e543 = function createAtlaskitPortal(zIndex) {
    //atlaskit-portal div
    if ($aacd8cc937d4ff4e$var$isDocumentDefined()) {
        var atlaskitportal = document.createElement('div');
        atlaskitportal.className = (0, $cJqhb.portalClassName);
        atlaskitportal.style.zIndex = "".concat(zIndex);
        return atlaskitportal;
    }
    return;
};
var $aacd8cc937d4ff4e$export$95029ca7aca2989e = function createPortalParent() {
    //atlaskit-portal-container div
    if ($aacd8cc937d4ff4e$var$isDocumentDefined()) {
        var parentElement = document.querySelector((0, $cJqhb.portalParentSelector));
        if (!parentElement) {
            var _getBody2;
            var parent = document.createElement('div');
            parent.className = (0, $cJqhb.portalParentClassName);
            parent.style.display = 'flex';
            (_getBody2 = $aacd8cc937d4ff4e$var$getBody()) === null || _getBody2 === void 0 || _getBody2.appendChild(parent);
            return parent;
        }
        return parentElement;
    }
    return;
};

});
parcelRegister("cJqhb", function(module, exports) {
$parcel$export(module.exports, "portalParentClassName", () => $944e11ec286a04d1$export$e4c79eb95c23a0da);
$parcel$export(module.exports, "portalParentSelector", () => $944e11ec286a04d1$export$72f415121273627e);
$parcel$export(module.exports, "portalClassName", () => $944e11ec286a04d1$export$13f57c02915787b3);
var $944e11ec286a04d1$export$e4c79eb95c23a0da = 'atlaskit-portal-container';
var $944e11ec286a04d1$export$72f415121273627e = 'body > .atlaskit-portal-container';
var $944e11ec286a04d1$export$13f57c02915787b3 = 'atlaskit-portal';

});



parcelRegister("8gSu7", function(module, exports) {
$parcel$export(module.exports, "default", () => $605a14e09f941d52$export$2e2bcd8739ae039);

var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");

var $aLeHs = parcelRequire("aLeHs");

var $akSoc = parcelRequire("akSoc");

var $eFb9R = parcelRequire("eFb9R");
function $605a14e09f941d52$export$2e2bcd8739ae039(props) {
    var zIndex = props.zIndex, children = props.children;
    var _useState = (0, $5FkrB.useState)(null), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), atlaskitPortal = _useState2[0], setAtlaskitPortal = _useState2[1];
    (0, $akSoc.useIsomorphicLayoutEffect)(function() {
        var tempPortalContainer = (0, $eFb9R.createAtlaskitPortal)(zIndex);
        setAtlaskitPortal(tempPortalContainer);
        var portalParent = (0, $eFb9R.createPortalParent)();
        if (!tempPortalContainer || !portalParent) return;
        portalParent.appendChild(tempPortalContainer);
        return function() {
            if (tempPortalContainer) portalParent.removeChild(tempPortalContainer);
            setAtlaskitPortal(null);
        };
    }, [
        zIndex
    ]);
    /**
   * We wrap portal children with a Suspense boundary because in React 18 concurrent,
   * if you suspend from _within_ a portal to a Suspense boundary _outside_ the portal,
   * our portal gets in an infinite loop of rendering.
   */ var suspendedChildren = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $5FkrB.Suspense), {
        fallback: null
    }, children);
    return atlaskitPortal ? /*#__PURE__*/ (0, $aLeHs.createPortal)(suspendedChildren, atlaskitPortal) : null;
}

});
parcelRegister("akSoc", function(module, exports) {
$parcel$export(module.exports, "useIsomorphicLayoutEffect", () => $7865f63aa36cd43d$export$700979bc83e7db82);

var $5FkrB = parcelRequire("5FkrB");
var $7865f63aa36cd43d$export$700979bc83e7db82 = typeof window !== 'undefined' ? (0, $5FkrB.useLayoutEffect) : (0, $5FkrB.useEffect);

});


parcelRegister("jayNZ", function(module, exports) {
$parcel$export(module.exports, "default", () => $df49f31b2d8ee781$export$2e2bcd8739ae039);

var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");

var $akSoc = parcelRequire("akSoc");
var $df49f31b2d8ee781$var$useIsSubsequentRender = function useIsSubsequentRender(mountStrategy) {
    var _useState = (0, $5FkrB.useState)(false), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), isSubsequentRender = _useState2[0], setIsSubsequentRender = _useState2[1];
    var _useState3 = (0, $5FkrB.useState)(function() {
        return mountStrategy === 'layoutEffect' ? (0, $akSoc.useIsomorphicLayoutEffect) : (0, $5FkrB.useEffect);
    }), _useState4 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState3, 1), useMountEffect = _useState4[0];
    useMountEffect(function() {
        setIsSubsequentRender(true);
    }, []);
    return isSubsequentRender;
};
var $df49f31b2d8ee781$export$2e2bcd8739ae039 = $df49f31b2d8ee781$var$useIsSubsequentRender;

});

parcelRegister("cSkX6", function(module, exports) {
$parcel$export(module.exports, "default", () => $95fac7dcec603452$export$2e2bcd8739ae039);

var $5FkrB = parcelRequire("5FkrB");

var $5kEgn = parcelRequire("5kEgn");

var $kkoCg = parcelRequire("kkoCg");
var $95fac7dcec603452$var$useFirePortalEvent = function useFirePortalEvent(zIndex) {
    var zIndexNumber = Number(zIndex);
    (0, $5FkrB.useEffect)(function() {
        (0, $kkoCg.default)((0, $5kEgn.PORTAL_MOUNT_EVENT), zIndexNumber);
        return function() {
            (0, $kkoCg.default)((0, $5kEgn.PORTAL_UNMOUNT_EVENT), zIndexNumber);
        };
    }, [
        zIndexNumber
    ]);
};
var $95fac7dcec603452$export$2e2bcd8739ae039 = $95fac7dcec603452$var$useFirePortalEvent;

});
parcelRegister("5kEgn", function(module, exports) {
$parcel$export(module.exports, "PORTAL_MOUNT_EVENT", () => $3e1e0d6b3c26c986$export$ed5835cc67e87f72);
$parcel$export(module.exports, "PORTAL_UNMOUNT_EVENT", () => $3e1e0d6b3c26c986$export$80816bd900e5bd00);
var $3e1e0d6b3c26c986$export$ed5835cc67e87f72 = 'akPortalMount';
var $3e1e0d6b3c26c986$export$80816bd900e5bd00 = 'akPortalUnmount';

});

parcelRegister("kkoCg", function(module, exports) {
$parcel$export(module.exports, "default", () => $ecc8c5250fb5d519$export$2e2bcd8739ae039);
var $ecc8c5250fb5d519$var$zIndexToName = {
    100: 'card',
    200: 'navigation',
    300: 'dialog',
    400: 'layer',
    500: 'blanket',
    510: 'modal',
    600: 'flag',
    700: 'spotlight',
    9999: 'tooltip'
};
/**
 * return layer name in Atlassian design system corresponding to given z-index
 * @param {number} zIndex - z-index value for which layer name is needed
 * @returns {LayerName | null} - The layer name for given z-index. If layer name is not found then null is returned
 */ var $ecc8c5250fb5d519$var$getLayerName = function getLayerName(zIndex) {
    return $ecc8c5250fb5d519$var$zIndexToName.hasOwnProperty(zIndex) ? $ecc8c5250fb5d519$var$zIndexToName[zIndex] : null;
};
/**
 * Creates a PortalEvent object with given eventName, given zIndex and corresponding layer
 * @param {string} eventName - either of Mount or Unmount event name
 * @param {number} zIndex - z-index value which will be included in the event to be dispatched
 * @returns {PortalEvent} - The newly created PortalEvent object
 */ var $ecc8c5250fb5d519$var$getEvent = function getEvent(eventName, zIndex) {
    var detail = {
        layer: $ecc8c5250fb5d519$var$getLayerName(Number(zIndex)),
        zIndex: zIndex
    };
    return new CustomEvent(eventName, {
        detail: detail
    });
};
function $ecc8c5250fb5d519$export$2e2bcd8739ae039(eventName, zIndex) {
    var event = $ecc8c5250fb5d519$var$getEvent(eventName, zIndex);
    window.dispatchEvent(event);
}

});



parcelRegister("12Oht", function(module, exports) {
$parcel$export(module.exports, "layers", () => $0c2cfb0e0eaa58b2$export$7be255094ccdc533);

var $kxpsr = parcelRequire("kxpsr");

var $hc0xu = parcelRequire("hc0xu");
var $0c2cfb0e0eaa58b2$export$44ffba16bd48dac6 = '__ATLASKIT_THEME__';
var $0c2cfb0e0eaa58b2$export$c93026a968943f95 = 'light';
var $0c2cfb0e0eaa58b2$export$6ba72c8346b4c57e = [
    'light',
    'dark'
];
var $0c2cfb0e0eaa58b2$export$8e24544ddba725ee = function focusRing() {
    var color = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "var(--ds-border-focused, ".concat((0, $hc0xu.B200), ")");
    var outlineWidth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
    (0, $kxpsr.default)('@atlaskit/theme', 'focus ring mixin', 'Please use `@atlaskit/focus-ring` instead.');
    return "\n  &:focus {\n    outline: none;\n    box-shadow: 0px 0px 0px ".concat(outlineWidth, "px ").concat(color, ";\n  }\n");
};
var $0c2cfb0e0eaa58b2$export$c0dd343266bc3261 = function noFocusRing() {
    return "\n  box-shadow: none;\n";
};
var $0c2cfb0e0eaa58b2$export$7be255094ccdc533 = {
    card: function card() {
        return 100;
    },
    navigation: function navigation() {
        return 200;
    },
    dialog: function dialog() {
        return 300;
    },
    layer: function layer() {
        return 400;
    },
    blanket: function blanket() {
        return 500;
    },
    modal: function modal() {
        return 510;
    },
    flag: function flag() {
        return 600;
    },
    spotlight: function spotlight() {
        return 700;
    },
    tooltip: function tooltip() {
        return 9999;
    }
};
var $0c2cfb0e0eaa58b2$export$a1b3edb637fb4f35 = function visuallyHidden() {
    (0, $kxpsr.default)('@atlaskit/theme', 'visually hidden mixin', 'Please use `@atlaskit/visually-hidden` instead.');
    return {
        border: '0 !important',
        clip: 'rect(1px, 1px, 1px, 1px) !important',
        height: '1px !important',
        overflow: 'hidden !important',
        padding: '0 !important',
        position: 'absolute !important',
        width: '1px !important',
        whiteSpace: 'nowrap !important'
    };
};
var $0c2cfb0e0eaa58b2$export$ba1d834b86d72a09 = $0c2cfb0e0eaa58b2$export$a1b3edb637fb4f35;
var $0c2cfb0e0eaa58b2$export$e497e856b4f89fcd = function skeletonShimmer() {
    return {
        css: {
            backgroundColor: "var(--ds-skeleton, ".concat((0, $hc0xu.N20A), ")"),
            animationDuration: '1.5s',
            animationIterationCount: 'infinite',
            animationTimingFunction: 'linear',
            animationDirection: 'alternate'
        },
        keyframes: {
            from: {
                backgroundColor: "var(--ds-skeleton, ".concat((0, $hc0xu.N20A), ")")
            },
            to: {
                backgroundColor: "var(--ds-skeleton-subtle, ".concat((0, $hc0xu.N30A), ")")
            }
        }
    };
};

});
parcelRegister("hc0xu", function(module, exports) {
$parcel$export(module.exports, "B200", () => $c843f9b7fb07a8e7$export$215b7063051591f1);
$parcel$export(module.exports, "N20A", () => $c843f9b7fb07a8e7$export$8d43898f60b96a82);
$parcel$export(module.exports, "N30A", () => $c843f9b7fb07a8e7$export$920c0d5c49070351);
// Reds
var $c843f9b7fb07a8e7$export$4b84fd0e2c617bd = '#FFEBE6';
var $c843f9b7fb07a8e7$export$b34b069eff244586 = '#FFBDAD';
var $c843f9b7fb07a8e7$export$be802dd0d8b57f35 = '#FF8F73';
var $c843f9b7fb07a8e7$export$60847d42f9da92a6 = '#FF7452';
var $c843f9b7fb07a8e7$export$4a7404f376229999 = '#FF5630';
var $c843f9b7fb07a8e7$export$2010d0fb4295b346 = '#DE350B';
var $c843f9b7fb07a8e7$export$2837b5a1a71d5c02 = '#BF2600';
var $c843f9b7fb07a8e7$export$8d9596b529bbb9cf = '#FFFAE6';
var $c843f9b7fb07a8e7$export$41060a744ab0b7ae = '#FFF0B3';
var $c843f9b7fb07a8e7$export$1cc05bbbf340e559 = '#FFE380';
var $c843f9b7fb07a8e7$export$5aae31392d72caaa = '#FFC400';
var $c843f9b7fb07a8e7$export$c6930421db9fa514 = '#FFAB00';
var $c843f9b7fb07a8e7$export$59619663aa6500fb = '#FF991F';
var $c843f9b7fb07a8e7$export$874739ea9e379ab6 = '#FF8B00';
var $c843f9b7fb07a8e7$export$8a6341c32b6a3ee6 = '#E3FCEF';
var $c843f9b7fb07a8e7$export$69a3bf21b9686c2b = '#ABF5D1';
var $c843f9b7fb07a8e7$export$afbce1382ec95f73 = '#79F2C0';
var $c843f9b7fb07a8e7$export$747d86715d4175de = '#57D9A3';
var $c843f9b7fb07a8e7$export$940e1f69e873f202 = '#36B37E';
var $c843f9b7fb07a8e7$export$a49394138f7b8e85 = '#00875A';
var $c843f9b7fb07a8e7$export$6fa04827ac68a4fb = '#006644';
var $c843f9b7fb07a8e7$export$226de0355ed012f8 = '#DEEBFF';
var $c843f9b7fb07a8e7$export$8c13c2ee36917869 = '#B3D4FF';
var $c843f9b7fb07a8e7$export$ecfc1dff386a3e7a = '#4C9AFF';
var $c843f9b7fb07a8e7$export$215b7063051591f1 = '#2684FF';
var $c843f9b7fb07a8e7$export$e62e8919cca44969 = '#0065FF';
var $c843f9b7fb07a8e7$export$b3de0ae08da2ce64 = '#0052CC';
var $c843f9b7fb07a8e7$export$a6ee3d71bc067634 = '#0747A6';
var $c843f9b7fb07a8e7$export$67f15409e87642a1 = '#669DF1';
var $c843f9b7fb07a8e7$export$f0539dbc42dbb067 = '#8FB8F6';
var $c843f9b7fb07a8e7$export$363e4475840015bb = '#EAE6FF';
var $c843f9b7fb07a8e7$export$4b0a4417ed59760f = '#C0B6F2';
var $c843f9b7fb07a8e7$export$6011520a64d9a187 = '#998DD9';
var $c843f9b7fb07a8e7$export$a7175d4e9206bc80 = '#8777D9';
var $c843f9b7fb07a8e7$export$b48405b95304b5a1 = '#6554C0';
var $c843f9b7fb07a8e7$export$c71e4279dd54a18d = '#5243AA';
var $c843f9b7fb07a8e7$export$147899de772240ec = '#403294';
var $c843f9b7fb07a8e7$export$2cf711fe14c66f06 = '#E6FCFF';
var $c843f9b7fb07a8e7$export$7a8f4d33f6f9772c = '#B3F5FF';
var $c843f9b7fb07a8e7$export$776c9c497ef08533 = '#79E2F2';
var $c843f9b7fb07a8e7$export$69cb3ca10c1e330e = '#00C7E6';
var $c843f9b7fb07a8e7$export$9dc1ef0f3f48059b = '#00B8D9';
var $c843f9b7fb07a8e7$export$7c835c78b6fcdef8 = '#00A3BF';
var $c843f9b7fb07a8e7$export$6036577f95c3877e = '#008DA6';
var $c843f9b7fb07a8e7$export$29a4f05edc054374 = '#FFFFFF';
var $c843f9b7fb07a8e7$export$e655ef011c4aa1a2 = '#FAFBFC';
var $c843f9b7fb07a8e7$export$9fdfb749e33cdf97 = '#F4F5F7';
var $c843f9b7fb07a8e7$export$3e51e8f1440314ba = '#EBECF0';
var $c843f9b7fb07a8e7$export$1ce2d1575d444ceb = '#DFE1E6';
var $c843f9b7fb07a8e7$export$8754fc7e6d8b3000 = '#C1C7D0';
var $c843f9b7fb07a8e7$export$c2e91cbeada39b8b = '#B3BAC5';
var $c843f9b7fb07a8e7$export$5f71e19f3a7ad9de = '#A5ADBA';
var $c843f9b7fb07a8e7$export$eaa8c8a70ac22806 = '#97A0AF';
var $c843f9b7fb07a8e7$export$7c87d337fb91a97d = '#8993A4';
var $c843f9b7fb07a8e7$export$d6447c357493214f = '#7A869A';
var $c843f9b7fb07a8e7$export$f563ee71e9ee74cd = '#6B778C';
var $c843f9b7fb07a8e7$export$e2ef2124cf4024b1 = '#5E6C84';
var $c843f9b7fb07a8e7$export$eece5f492e429f08 = '#505F79';
var $c843f9b7fb07a8e7$export$c39c0fe0f26207ae = '#42526E';
var $c843f9b7fb07a8e7$export$7090862dc3038a9f = '#344563';
var $c843f9b7fb07a8e7$export$ad0bacf983b7ddaa = '#253858';
var $c843f9b7fb07a8e7$export$7d61b15e0da132af = '#172B4D';
var $c843f9b7fb07a8e7$export$fbda843f0a27fe96 = '#091E42';
var $c843f9b7fb07a8e7$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
var $c843f9b7fb07a8e7$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
var $c843f9b7fb07a8e7$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
var $c843f9b7fb07a8e7$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
var $c843f9b7fb07a8e7$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
var $c843f9b7fb07a8e7$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
var $c843f9b7fb07a8e7$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
var $c843f9b7fb07a8e7$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
var $c843f9b7fb07a8e7$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
var $c843f9b7fb07a8e7$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
var $c843f9b7fb07a8e7$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
var $c843f9b7fb07a8e7$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
var $c843f9b7fb07a8e7$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
var $c843f9b7fb07a8e7$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
var $c843f9b7fb07a8e7$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
var $c843f9b7fb07a8e7$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
var $c843f9b7fb07a8e7$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
var $c843f9b7fb07a8e7$export$2f6319cf7d736c2a = '#E6EDFA';
var $c843f9b7fb07a8e7$export$95126bc8884d6634 = '#DCE5F5';
var $c843f9b7fb07a8e7$export$8338d8c35d44ff1 = '#CED9EB';
var $c843f9b7fb07a8e7$export$5368d76ae4fbbda7 = '#B8C7E0';
var $c843f9b7fb07a8e7$export$9f0a771d16ec8d36 = '#ABBBD6';
var $c843f9b7fb07a8e7$export$abcf8c38338b4aa5 = '#9FB0CC';
var $c843f9b7fb07a8e7$export$97e81faa16a182c7 = '#8C9CB8';
var $c843f9b7fb07a8e7$export$bfe21c59123ecf33 = '#7988A3';
var $c843f9b7fb07a8e7$export$ee82aa2ea6a1558 = '#67758F';
var $c843f9b7fb07a8e7$export$682927c6ed76be02 = '#56637A';
var $c843f9b7fb07a8e7$export$91fd9994c5be9757 = '#455166';
var $c843f9b7fb07a8e7$export$d281fbfe3cff2df6 = '#3B475C';
var $c843f9b7fb07a8e7$export$3902c91d8b98a753 = '#313D52';
var $c843f9b7fb07a8e7$export$8e8133c1ba5845b5 = '#283447';
var $c843f9b7fb07a8e7$export$33ff357f6620b39 = '#202B3D';
var $c843f9b7fb07a8e7$export$633847cf062b69e0 = '#1B2638';
var $c843f9b7fb07a8e7$export$9776a6e503bdbf76 = '#121A29';
var $c843f9b7fb07a8e7$export$6c813d5160dff5db = '#0E1624';
var $c843f9b7fb07a8e7$export$3d4f271a500072a = '#0D1424';
var $c843f9b7fb07a8e7$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
var $c843f9b7fb07a8e7$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
var $c843f9b7fb07a8e7$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
var $c843f9b7fb07a8e7$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
var $c843f9b7fb07a8e7$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
var $c843f9b7fb07a8e7$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
var $c843f9b7fb07a8e7$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
var $c843f9b7fb07a8e7$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
var $c843f9b7fb07a8e7$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
var $c843f9b7fb07a8e7$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
var $c843f9b7fb07a8e7$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
var $c843f9b7fb07a8e7$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
var $c843f9b7fb07a8e7$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
var $c843f9b7fb07a8e7$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
var $c843f9b7fb07a8e7$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
var $c843f9b7fb07a8e7$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
var $c843f9b7fb07a8e7$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';
var $c843f9b7fb07a8e7$export$d2adc5dedf09fced = '#292A2E';
var $c843f9b7fb07a8e7$export$f51762073d2bb381 = '#94C748';
var $c843f9b7fb07a8e7$export$95e26d54def96891 = '#B3DF72';

});


parcelRegister("dBJsk", function(module, exports) {
$parcel$export(module.exports, "register", () => $9e81fdabd3b4593e$export$6503ec6e8aabbaf);
/* eslint-disable @atlaskit/design-system/no-direct-use-of-web-platform-drag-and-drop */ /**
 * We are listening directly to drag events instead of using a monitor from
 * `@atlaskit/pragmatic-drag-and-drop` to avoid the bundle size cost, as it
 * would affect almost every view in every app.
 *
 * We can reconsider this choice in the future.
 */ 
var $7QpUe = parcelRequire("7QpUe");
var $9e81fdabd3b4593e$var$registrations = new Set();
var $9e81fdabd3b4593e$var$cleanupEndEventListeners = null;
function $9e81fdabd3b4593e$var$onDragStart() {
    if ($9e81fdabd3b4593e$var$cleanupEndEventListeners) // If the cleanup function exists then we've already run this
    return;
    $9e81fdabd3b4593e$var$cleanupEndEventListeners = (0, $7QpUe.bindAll)(window, [
        {
            type: 'dragend',
            listener: $9e81fdabd3b4593e$var$onDragEnd
        },
        {
            type: 'pointerdown',
            listener: $9e81fdabd3b4593e$var$onDragEnd
        },
        {
            type: 'pointermove',
            listener: function() {
                var callCount = 0;
                return function listener() {
                    // Using 20 as it is far bigger than the most observed (3)
                    if (callCount < 20) {
                        callCount++;
                        return;
                    }
                    $9e81fdabd3b4593e$var$onDragEnd();
                };
            }()
        }
    ]);
    var clone = Array.from($9e81fdabd3b4593e$var$registrations);
    clone.forEach(function(subscriber) {
        subscriber.onDragStart();
    });
}
function $9e81fdabd3b4593e$var$onDragEnd() {
    var _cleanupEndEventListe;
    (_cleanupEndEventListe = $9e81fdabd3b4593e$var$cleanupEndEventListeners) === null || _cleanupEndEventListe === void 0 || _cleanupEndEventListe();
    $9e81fdabd3b4593e$var$cleanupEndEventListeners = null;
    var clone = Array.from($9e81fdabd3b4593e$var$registrations);
    clone.forEach(function(subscriber) {
        subscriber.onDragEnd();
    });
}
function $9e81fdabd3b4593e$var$bindStartEvents() {
    return (0, $7QpUe.bindAll)(window, [
        {
            type: 'dragstart',
            listener: $9e81fdabd3b4593e$var$onDragStart
        },
        {
            type: 'dragenter',
            listener: $9e81fdabd3b4593e$var$onDragStart
        }
    ]);
}
var $9e81fdabd3b4593e$var$cleanupStartEventListeners = null;
function $9e81fdabd3b4593e$export$6503ec6e8aabbaf(registration) {
    // if first registration, bind event listeners
    if (!$9e81fdabd3b4593e$var$cleanupStartEventListeners) // note: currently never unbinding these event listeners
    $9e81fdabd3b4593e$var$cleanupStartEventListeners = $9e81fdabd3b4593e$var$bindStartEvents();
    $9e81fdabd3b4593e$var$registrations.add(registration);
    /**
   * The reasoning for this behavior is so that if a tooltip mounts during
   * a drag it can still be suppressed.
   *
   * We use a separate callback instead of onDragStart to avoid infinite loops.
   */ registration.onRegister({
        isDragging: $9e81fdabd3b4593e$var$cleanupEndEventListeners !== null
    });
    return function unregister() {
        $9e81fdabd3b4593e$var$registrations.delete(registration);
        if ($9e81fdabd3b4593e$var$registrations.size === 0) {
            var _cleanupStartEventLis;
            (_cleanupStartEventLis = $9e81fdabd3b4593e$var$cleanupStartEventListeners) === null || _cleanupStartEventLis === void 0 || _cleanupStartEventLis();
            $9e81fdabd3b4593e$var$cleanupStartEventListeners = null;
        }
    };
}

});

parcelRegister("55O85", function(module, exports) {
$parcel$export(module.exports, "show", () => $3b544e08c1bf1ab0$export$57bf213be019eeb0);

var $5dNmy = parcelRequire("5dNmy");
// This file is a singleton for managing tooltips
var $3b544e08c1bf1ab0$var$active = null;
function $3b544e08c1bf1ab0$export$57bf213be019eeb0(entry) {
    var phase = 'waiting-to-show';
    function isActive() {
        return Boolean($3b544e08c1bf1ab0$var$active && $3b544e08c1bf1ab0$var$active.entry === entry);
    }
    function cleanup() {
        if (isActive()) {
            (0, $5dNmy.clearScheduled)();
            $3b544e08c1bf1ab0$var$active = null;
        }
    }
    function done() {
        if (isActive()) entry.done();
        phase = 'done';
        cleanup();
    }
    function immediatelyHideAndDone() {
        if (isActive()) entry.hide({
            isImmediate: true
        });
        done();
    }
    function keep() {
        if (!isActive()) return;
        // aborting a wait to hide
        if (phase === 'waiting-to-hide') {
            phase = 'shown';
            (0, $5dNmy.clearScheduled)();
            return;
        }
        // aborting hide animation
        if (phase === 'hide-animating') {
            phase = 'shown';
            (0, $5dNmy.clearScheduled)();
            entry.show({
                isImmediate: false
            });
            return;
        }
    }
    function requestHide(_ref) {
        var isImmediate = _ref.isImmediate;
        if (!isActive()) return;
        // If we were not showing yet anyway; finish straight away
        if (phase === 'waiting-to-show') {
            immediatelyHideAndDone();
            return;
        }
        // already waiting to hide
        if (phase === 'waiting-to-hide') return;
        if (isImmediate) {
            immediatelyHideAndDone();
            return;
        }
        phase = 'waiting-to-hide';
        (0, $5dNmy.scheduleTimeout)(function() {
            phase = 'hide-animating';
            entry.hide({
                isImmediate: false
            });
        }, entry.delay);
    }
    function finishHideAnimation() {
        if (isActive() && phase === 'hide-animating') done();
    }
    function isVisible() {
        return phase === 'shown' || phase === 'waiting-to-hide' || phase === 'hide-animating';
    }
    function getInitialMouse() {
        if (entry.source.type === 'mouse') return entry.source.mouse;
        return null;
    }
    function start() {
        var showImmediately = Boolean($3b544e08c1bf1ab0$var$active && $3b544e08c1bf1ab0$var$active.isVisible());
        // If there was an active tooltip; we tell it to remove itself at once!
        if ($3b544e08c1bf1ab0$var$active) {
            (0, $5dNmy.clearScheduled)();
            $3b544e08c1bf1ab0$var$active.entry.hide({
                isImmediate: true
            });
            $3b544e08c1bf1ab0$var$active.entry.done();
            $3b544e08c1bf1ab0$var$active = null;
        }
        // this tooltip is now the active tooltip
        $3b544e08c1bf1ab0$var$active = {
            entry: entry,
            isVisible: isVisible
        };
        function show() {
            phase = 'shown';
            entry.show({
                isImmediate: showImmediately
            });
        }
        if (showImmediately) {
            show();
            return;
        }
        phase = 'waiting-to-show';
        (0, $5dNmy.scheduleTimeout)(show, entry.delay);
    }
    // let's get started!
    start();
    var result = {
        keep: keep,
        abort: cleanup,
        isActive: isActive,
        requestHide: requestHide,
        finishHideAnimation: finishHideAnimation,
        mousePosition: getInitialMouse()
    };
    return result;
}

});
parcelRegister("5dNmy", function(module, exports) {
$parcel$export(module.exports, "clearScheduled", () => $3cd47514c4b3522a$export$eaf678f6f93f5250);
$parcel$export(module.exports, "scheduleTimeout", () => $3cd47514c4b3522a$export$5f4d6617421d489b);
var $3cd47514c4b3522a$var$delayId = null;
function $3cd47514c4b3522a$export$eaf678f6f93f5250() {
    if ($3cd47514c4b3522a$var$delayId != null) {
        window.clearTimeout($3cd47514c4b3522a$var$delayId);
        $3cd47514c4b3522a$var$delayId = null;
    }
}
function $3cd47514c4b3522a$export$5f4d6617421d489b(fn, delay) {
    $3cd47514c4b3522a$export$eaf678f6f93f5250();
    $3cd47514c4b3522a$var$delayId = window.setTimeout(function() {
        $3cd47514c4b3522a$var$delayId = null;
        fn();
    }, delay);
}

});


parcelRegister("84v6q", function(module, exports) {
$parcel$export(module.exports, "default", () => $5e06d2c72180381d$export$2e2bcd8739ae039);

var $h8qvJ = parcelRequire("h8qvJ");
function $5e06d2c72180381d$export$2e2bcd8739ae039(prefix, shouldRenderId) {
    var seed = (0, $h8qvJ.useIdSeed)();
    return shouldRenderId ? "".concat(seed(prefix)) : undefined;
}

});

parcelRegister("h7i8q", function(module, exports) {
$parcel$export(module.exports, "default", () => $c7612858b1646e98$export$2e2bcd8739ae039);
/* tooltip-container.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");

var $2Zurx = parcelRequire("2Zurx");
var $c7612858b1646e98$var$styles = {
    base: "_2rkofajl _11c8dcr7 _vchhusvi _p12fp3fh _bfhkgkf6 _syaz15cr _152tze3t _1e02ze3t _1i4q1hna _1q511b66 _85i51b66 _y4ti12x7 _bozg12x7 _slp31hna",
    truncate: "_1reo15vq _18m915vq _p12f1pna _1bto1l2s _o5721q9c"
};
/**
 * Used as the default tooltip container component for the exported `Tooltip` component.
 * Adds some styles to the tooltip primitive.
 */ var $c7612858b1646e98$var$TooltipContainer = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function TooltipContainer(_ref, ref) {
    var style = _ref.style, className = _ref.className, children = _ref.children, truncate = _ref.truncate, placement = _ref.placement, testId = _ref.testId, onMouseOut = _ref.onMouseOut, onMouseOver = _ref.onMouseOver, id = _ref.id, shortcut = _ref.shortcut;
    return /*#__PURE__*/ $5FkrB.createElement((0, $2Zurx.default), {
        ref: ref,
        style: style,
        className: (0, $970q7.default)([
            $c7612858b1646e98$var$styles.base,
            truncate && $c7612858b1646e98$var$styles.truncate,
            className
        ]),
        placement: placement,
        testId: testId,
        id: id,
        onMouseOut: onMouseOut,
        onMouseOver: onMouseOver,
        shortcut: shortcut
    }, children);
});
$c7612858b1646e98$var$TooltipContainer.displayName = 'TooltipContainer';
var $c7612858b1646e98$export$2e2bcd8739ae039 = $c7612858b1646e98$var$TooltipContainer;

});
parcelRegister("2Zurx", function(module, exports) {
$parcel$export(module.exports, "default", () => $22d8e4a371ab5ef8$export$2e2bcd8739ae039);
/* tooltip-primitive.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");

var $8BDAw = parcelRequire("8BDAw");
var $22d8e4a371ab5ef8$var$primitiveStyles = null;
/**
 * The lower level component for rendering a tooltip.
 */ var $22d8e4a371ab5ef8$var$TooltipPrimitive = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function TooltipPrimitive(_ref, ref) {
    var style = _ref.style, className = _ref.className, children = _ref.children, placement = _ref.placement, testId = _ref.testId, onMouseOut = _ref.onMouseOut, onMouseOver = _ref.onMouseOver, id = _ref.id, shortcut = _ref.shortcut;
    return /*#__PURE__*/ $5FkrB.createElement("div", {
        ref: ref,
        style: style,
        "data-testid": testId ? "".concat(testId, "--wrapper") : undefined
    }, /*#__PURE__*/ $5FkrB.createElement("div", {
        role: "tooltip",
        className: (0, $970q7.default)([
            "_80om73ad",
            className
        ]),
        onMouseOut: onMouseOut,
        onMouseOver: onMouseOver,
        "data-placement": placement,
        "data-testid": testId,
        id: id
    }, children, shortcut && /*#__PURE__*/ $5FkrB.createElement((0, $8BDAw.TooltipShortcut), {
        shortcut: shortcut
    })));
});
$22d8e4a371ab5ef8$var$TooltipPrimitive.displayName = 'TooltipPrimitive';
var $22d8e4a371ab5ef8$export$2e2bcd8739ae039 = $22d8e4a371ab5ef8$var$TooltipPrimitive;

});
parcelRegister("8BDAw", function(module, exports) {
$parcel$export(module.exports, "TooltipShortcut", () => $64407cc8ac72d26b$export$5bcbc43c84236222);
/* tooltip-shortcut.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");

var $9Zzpd = parcelRequire("9Zzpd");
var $64407cc8ac72d26b$var$styles = {
    shortcutSegmentsContainer: "_zulpv77o _1e0c1txw _1q511b66 _85i5v77o",
    shortcutSegment: "_11c81u0j _2rkolb4i _1dqonqa1 _189ee4h9 _1h6d1ihb _1e0c1txw _4cvr1h6o _4t3i1k92 _vchhusvi _1q51v77o _85i5v77o _bozg12x7 _y4ti12x7 _16qsn7od _1254n7od _cgnln7od _syazn7od _ahbqn7od _12l2n7od _1pfhn7od _6rthn7od _1ul9n7od _w19jn7od _bfhk261p",
    regularFont: "_11c81o8v"
};
var $64407cc8ac72d26b$export$5bcbc43c84236222 = function TooltipShortcut(_ref) {
    var shortcut = _ref.shortcut;
    return /*#__PURE__*/ $5FkrB.createElement("div", {
        className: (0, $970q7.default)([
            $64407cc8ac72d26b$var$styles.shortcutSegmentsContainer
        ])
    }, shortcut.map(function(segment, index) {
        return /*#__PURE__*/ $5FkrB.createElement("kbd", {
            key: "".concat(segment, "-").concat(index),
            className: (0, $970q7.default)([
                $64407cc8ac72d26b$var$styles.shortcutSegment,
                (0, $9Zzpd.fg)('platform-tooltip-shortcuts-regular-font') && $64407cc8ac72d26b$var$styles.regularFont
            ])
        }, segment);
    }));
};

});



parcelRegister("biujZ", function(module, exports) {
$parcel$export(module.exports, "getMousePosition", () => $8398e554ef75f34e$export$642213d516a9b928);
function $8398e554ef75f34e$export$642213d516a9b928(mouseCoordinates) {
    var safeMouse = mouseCoordinates || {
        top: 0,
        left: 0
    };
    var getBoundingClientRect = function getBoundingClientRect() {
        return {
            top: safeMouse.top,
            left: safeMouse.left,
            bottom: safeMouse.top,
            right: safeMouse.left,
            width: 0,
            height: 0
        };
    };
    return {
        getBoundingClientRect: getBoundingClientRect,
        clientWidth: 0,
        clientHeight: 0
    };
}

});


parcelRegister("8zrJb", function(module, exports) {
$parcel$export(module.exports, "Decorator", () => $63d719c16a57aa3a$export$a592b67c93d52467);
/* styled.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");

var $e8kqY = parcelRequire("e8kqY");
var $63d719c16a57aa3a$var$decoration = {
    root: "_kqswh2mm _szpl2smr _dsq41wug _1xyt1b66 _123w1b66 _15nnze3t _rxygze3t _1a354jg8 _1j6r1odn _1uakf6fq _1kt9y7el _is06wx40 _1rus1tzq _1cfcvrvc _24gj1h6o _19o61h6o _cfu1116y _1rbawx40 _1xqc1rd4"
};
function $63d719c16a57aa3a$export$a592b67c93d52467(_ref) {
    var bidiCharacter = _ref.bidiCharacter, children = _ref.children, testId = _ref.testId;
    var bidiCharacterCode = $63d719c16a57aa3a$var$getBidiCharacterCode(bidiCharacter);
    return /*#__PURE__*/ $5FkrB.createElement((0, $5FkrB.Fragment), null, /*#__PURE__*/ $5FkrB.createElement("span", {
        "data-testid": testId,
        "data-bidi-character-code": bidiCharacterCode,
        "aria-hidden": "true",
        className: (0, $970q7.default)([
            $63d719c16a57aa3a$var$decoration.root
        ])
    }, children), /*#__PURE__*/ $5FkrB.createElement((0, $e8kqY.default), {
        testId: testId && "".concat(testId, "--visually-hidden")
    }, /*#__PURE__*/ $5FkrB.createElement("mark", null, bidiCharacterCode)));
}
function $63d719c16a57aa3a$var$getBidiCharacterCode(bidiCharacter) {
    var _bidiCharacter$codePo;
    var bidiCharacterCode = (_bidiCharacter$codePo = bidiCharacter.codePointAt(0)) === null || _bidiCharacter$codePo === void 0 ? void 0 : _bidiCharacter$codePo.toString(16);
    return "U+".concat(bidiCharacterCode);
}

});


parcelRegister("deLXP", function(module, exports) {
$parcel$export(module.exports, "default", () => $9a31c9d07fbb1db4$export$2e2bcd8739ae039);

var $fC8ib = parcelRequire("fC8ib");
function $9a31c9d07fbb1db4$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $9a31c9d07fbb1db4$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $9a31c9d07fbb1db4$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $9a31c9d07fbb1db4$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $9a31c9d07fbb1db4$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $9a31c9d07fbb1db4$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
var $9a31c9d07fbb1db4$export$ecb256e6a1f5ee7e = /[\u202A-\u202E\u2066-\u2069]/g;
function $9a31c9d07fbb1db4$export$2e2bcd8739ae039(originalText, decorate) {
    var matches = (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(originalText.matchAll($9a31c9d07fbb1db4$export$ecb256e6a1f5ee7e));
    if (matches.length === 0) // No matches encountered, so we return the originalText value
    return originalText;
    var children = [];
    var mappedTo = 0;
    var _iterator = $9a31c9d07fbb1db4$var$_createForOfIteratorHelper(matches), _step;
    try {
        for(_iterator.s(); !(_step = _iterator.n()).done;){
            var match = _step.value;
            if (mappedTo !== match.index) // There were unmatched characters prior to this match which haven't been
            // mapped to the children.
            // Add them as plain text.
            children.push(originalText.substring(mappedTo, match.index));
            children.push(decorate({
                bidiCharacter: match[0],
                index: match.index
            }));
            // While index is guaranteed to be present, it needs to be asserted due
            // to a limitation of typescripts regex handling
            //
            // https://github.com/microsoft/TypeScript/issues/36788
            // Decorate bidi character
            mappedTo = match.index + match[0].length;
        }
    } catch (err) {
        _iterator.e(err);
    } finally{
        _iterator.f();
    }
    if (mappedTo !== originalText.length) // There is text following the final match, which needs to be mapped
    // to the children.
    // Added as plain text.
    children.push(originalText.substring(mappedTo, originalText.length));
    // return the mapped children with decorated bidi characters
    return children;
}

});

parcelRegister("48wjX", function(module, exports) {
$parcel$export(module.exports, "default", () => $3030fb03e7954f9c$export$2e2bcd8739ae039);

var $kqp0i = parcelRequire("kqp0i");

var $25nEq = parcelRequire("25nEq");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");

var $lrGSQ = parcelRequire("lrGSQ");
var $3030fb03e7954f9c$var$_excluded = [
    "analyticsContext"
];
function $3030fb03e7954f9c$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $3030fb03e7954f9c$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $3030fb03e7954f9c$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $3030fb03e7954f9c$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $3030fb03e7954f9c$var$withAnalyticsContext = function withAnalyticsContext(defaultData) {
    return function(WrappedComponent) {
        var WithAnalyticsContext = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function(_ref, ref) {
            var analyticsContext = _ref.analyticsContext, rest = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $3030fb03e7954f9c$var$_excluded);
            var analyticsData = (0, $5FkrB.useMemo)(function() {
                return $3030fb03e7954f9c$var$_objectSpread($3030fb03e7954f9c$var$_objectSpread({}, defaultData), analyticsContext);
            }, [
                analyticsContext
            ]);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $lrGSQ.default), {
                data: analyticsData
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(WrappedComponent, (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, rest, {
                ref: ref
            })));
        });
        WithAnalyticsContext.displayName = "WithAnalyticsContext(".concat(WrappedComponent.displayName || WrappedComponent.name, ")");
        return WithAnalyticsContext;
    };
};
var $3030fb03e7954f9c$export$2e2bcd8739ae039 = $3030fb03e7954f9c$var$withAnalyticsContext;

});
parcelRegister("lrGSQ", function(module, exports) {
$parcel$export(module.exports, "default", () => $f9cd625d90e70d34$export$2e2bcd8739ae039);

var $5FkrB = parcelRequire("5FkrB");

var $9Zzpd = parcelRequire("9Zzpd");

var $5OYzN = parcelRequire("5OYzN");

var $epYwG = parcelRequire("epYwG");

var $8pj2A = parcelRequire("8pj2A");
var $f9cd625d90e70d34$var$AnalyticsContext = function AnalyticsContext(props) {
    var isModernContext = (0, $5OYzN.default) || (0, $9Zzpd.fg)('analytics-next-use-legacy-context') === false;
    return isModernContext ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $8pj2A.default), props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $epYwG.default), props);
};
var $f9cd625d90e70d34$export$2e2bcd8739ae039 = $f9cd625d90e70d34$var$AnalyticsContext;

});
parcelRegister("epYwG", function(module, exports) {
$parcel$export(module.exports, "default", () => $a7f259bcf1cf981f$export$2e2bcd8739ae039);

var $fC8ib = parcelRequire("fC8ib");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $kIXpt = parcelRequire("kIXpt");

var $cYPzS = parcelRequire("cYPzS");

var $eyuDe = parcelRequire("eyuDe");

var $25nEq = parcelRequire("25nEq");

var $5FkrB = parcelRequire("5FkrB");

var $8vJ0V = parcelRequire("8vJ0V");

var $iyyOp = parcelRequire("iyyOp");
function $a7f259bcf1cf981f$var$_callSuper(t, o, e) {
    return o = (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(o), (0, (/*@__PURE__*/$parcel$interopDefault($kIXpt)))(t, $a7f259bcf1cf981f$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(t).constructor) : o.apply(t, e));
}
function $a7f259bcf1cf981f$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($a7f259bcf1cf981f$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $a7f259bcf1cf981f$var$ContextTypes = {
    getAtlaskitAnalyticsContext: (0, (/*@__PURE__*/$parcel$interopDefault($8vJ0V))).func,
    getAtlaskitAnalyticsEventHandlers: (0, (/*@__PURE__*/$parcel$interopDefault($8vJ0V))).func
};
var $a7f259bcf1cf981f$var$noop = function noop() {
    return [];
};
// eslint-disable-next-line @repo/internal/react/no-class-components
var $a7f259bcf1cf981f$var$AnalyticsContext = /*#__PURE__*/ function(_Component) {
    function AnalyticsContext(props) {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, AnalyticsContext);
        _this = $a7f259bcf1cf981f$var$_callSuper(this, AnalyticsContext, [
            props
        ]);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "getChildContext", function() {
            return {
                getAtlaskitAnalyticsContext: _this.getAnalyticsContext
            };
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "getAnalyticsContext", function() {
            var data = _this.props.data;
            var _this$context$getAtla = _this.context.getAtlaskitAnalyticsContext, getAtlaskitAnalyticsContext = _this$context$getAtla === void 0 ? $a7f259bcf1cf981f$var$noop : _this$context$getAtla;
            return [].concat((0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(getAtlaskitAnalyticsContext()), [
                data
            ]);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "getAnalyticsEventHandlers", function() {
            var _this$context$getAtla2 = _this.context.getAtlaskitAnalyticsEventHandlers, getAtlaskitAnalyticsEventHandlers = _this$context$getAtla2 === void 0 ? $a7f259bcf1cf981f$var$noop : _this$context$getAtla2;
            return getAtlaskitAnalyticsEventHandlers();
        });
        _this.contextValue = {
            getAtlaskitAnalyticsContext: _this.getAnalyticsContext,
            getAtlaskitAnalyticsEventHandlers: _this.getAnalyticsEventHandlers
        };
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($eyuDe)))(AnalyticsContext, _Component);
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(AnalyticsContext, [
        {
            key: "render",
            value: function render() {
                var children = this.props.children;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $iyyOp.default).Provider, {
                    value: this.contextValue
                }, children);
            }
        }
    ]);
}((0, $5FkrB.Component));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($a7f259bcf1cf981f$var$AnalyticsContext, "contextTypes", $a7f259bcf1cf981f$var$ContextTypes);
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($a7f259bcf1cf981f$var$AnalyticsContext, "childContextTypes", $a7f259bcf1cf981f$var$ContextTypes);
var $a7f259bcf1cf981f$export$2e2bcd8739ae039 = $a7f259bcf1cf981f$var$AnalyticsContext;

});

parcelRegister("8pj2A", function(module, exports) {
$parcel$export(module.exports, "default", () => $61ef6d994dbaabca$export$2e2bcd8739ae039);

var $fC8ib = parcelRequire("fC8ib");

var $5FkrB = parcelRequire("5FkrB");

var $iyyOp = parcelRequire("iyyOp");

var $2bMUu = parcelRequire("2bMUu");

var $5SnFU = parcelRequire("5SnFU");
var $61ef6d994dbaabca$var$AnalyticsContext = function AnalyticsContext(_ref) {
    var data = _ref.data, children = _ref.children;
    var dataRef = (0, $5SnFU.useTrackedRef)(data);
    var _useAnalyticsContext = (0, $2bMUu.useAnalyticsContext)(), getAtlaskitAnalyticsEventHandlers = _useAnalyticsContext.getAtlaskitAnalyticsEventHandlers, getOriginalAnalyticsContext = _useAnalyticsContext.getAtlaskitAnalyticsContext;
    var getAtlaskitAnalyticsContext = (0, $5FkrB.useCallback)(function() {
        return [].concat((0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(getOriginalAnalyticsContext()), [
            dataRef.current
        ]);
    }, [
        getOriginalAnalyticsContext,
        dataRef
    ]);
    var value = (0, $5FkrB.useMemo)(function() {
        return {
            getAtlaskitAnalyticsContext: getAtlaskitAnalyticsContext,
            getAtlaskitAnalyticsEventHandlers: getAtlaskitAnalyticsEventHandlers
        };
    }, [
        getAtlaskitAnalyticsContext,
        getAtlaskitAnalyticsEventHandlers
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $iyyOp.default).Provider, {
        value: value
    }, children);
};
var $61ef6d994dbaabca$export$2e2bcd8739ae039 = $61ef6d994dbaabca$var$AnalyticsContext;

});



parcelRegister("iDztP", function(module, exports) {
$parcel$export(module.exports, "default", () => $d917641e8f454f72$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $kqp0i = parcelRequire("kqp0i");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");

var $evbIR = parcelRequire("evbIR");

var $9Zzpd = parcelRequire("9Zzpd");

var $jFgzo = parcelRequire("jFgzo");
var $b6FeK = parcelRequire("b6FeK");
var $d917641e8f454f72$var$_excluded = [
    "children",
    "testId",
    "appearance",
    "newWindowLabel",
    "target",
    "className",
    "style"
];
var $d917641e8f454f72$var$styles = {
    visitedLink: "_ect41gqc _10531ra0 _1ien1ra0 _n0fx1ra0 _1vhv17z1",
    defaultAppearance: "_4bfu1r31 _1hms8stv _ajmmnqa1 _syaz13af _ect41gqc _1a3b1r31 _4fpr8stv _5goinqa1 _f8pj13af _9oik1r31 _1bnxglyw _jf4cnqa1 _30l313af _1nrm1r31 _c2waglyw _1iohnqa1 _9h8h12zz",
    subtleAppearance: "_4bfu1r31 _1hmsglyw _ajmmnqa1 _ect41gqc _syazazsu _1a3b1r31 _4fprglyw _5goinqa1 _f8pjazsu _9oik1r31 _1bnx8stv _jf4cnqa1 _30l3azsu _1nrm1r31 _c2wa8stv _1iohnqa1 _9h8hi7uo",
    inverseAppearance: "_4bfu1r31 _1hms8stv _ajmmnqa1 _ect41gqc _syaz15cr _105315cr _1a3b1r31 _4fpr8stv _5goinqa1 _f8pj15cr _9oik1r31 _1bnxglyw _jf4cnqa1 _30l315cr _1nrm1r31 _c2waglyw _1iohnqa1 _9h8h15cr",
    iconWrapper: "_1e0c1nu9 _o5721q9c _s7n41q9y _kqswh2mm _152ttb3r"
};
var $d917641e8f454f72$var$iconStyles = null;
var $d917641e8f454f72$var$LinkWithoutRef = function LinkWithoutRef(_ref, ref) {
    var children = _ref.children, testId = _ref.testId, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'default' : _ref$appearance, newWindowLabel = _ref.newWindowLabel, target = _ref.target, preventedClassName = _ref.className, preventedStyle = _ref.style, htmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $d917641e8f454f72$var$_excluded);
    return /*#__PURE__*/ $5FkrB.createElement((0, $jFgzo.default), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, htmlAttributes, {
        target: target,
        ref: ref,
        xcss: (0, $evbIR.cx)(appearance === 'default' && $d917641e8f454f72$var$styles.defaultAppearance, appearance === 'subtle' && $d917641e8f454f72$var$styles.subtleAppearance, appearance === 'inverse' && $d917641e8f454f72$var$styles.inverseAppearance, // Visited styles are not supported for inverse links due to contrast issues
        appearance !== 'inverse' && $d917641e8f454f72$var$styles.visitedLink),
        testId: testId,
        componentName: "Link",
        newWindowLabel: newWindowLabel
    }), children, target === '_blank' && /*#__PURE__*/ $5FkrB.createElement((0, $b6FeK.default), {
        as: "span",
        xcss: $d917641e8f454f72$var$styles.iconWrapper,
        testId: testId && "".concat(testId, "__icon")
    }, "\uFEFF", (0, $9Zzpd.fg)('platform-visual-refresh-icons') ? /*#__PURE__*/ $5FkrB.createElement("svg", {
        width: "12",
        height: "12",
        viewBox: "0 0 12 12",
        fill: "none",
        className: (0, $970q7.default)([
            "_1bsbgm0b _4t3igm0b _ahbqzjw7"
        ])
    }, /*#__PURE__*/ $5FkrB.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M0 1.82609C0 0.817938 0.817938 0 1.82609 0H3.91304V1.04348H1.82609C1.39424 1.04348 1.04348 1.39424 1.04348 1.82609V10.1739C1.04348 10.6058 1.39424 10.9565 1.82609 10.9565H10.1739C10.6058 10.9565 10.9565 10.6058 10.9565 10.1739V8.08696H12V10.1739C12 11.1821 11.1821 12 10.1739 12H1.82609C0.817938 12 0 11.1821 0 10.1739V1.82609ZM7.04348 0H12V4.95652H10.9565V1.78133L6.36893 6.36893L5.63107 5.63107L10.2187 1.04348H7.04348V0Z",
        fill: "currentColor"
    })) : /*#__PURE__*/ $5FkrB.createElement("svg", {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        className: (0, $970q7.default)([
            "_1bsbgm0b _4t3igm0b _ahbqzjw7"
        ])
    }, /*#__PURE__*/ $5FkrB.createElement("path", {
        d: "M17.5715 3.95926L10.7587 10.772C10.5546 10.9692 10.2811 11.0784 9.99723 11.0759C9.71338 11.0734 9.44185 10.9596 9.24113 10.7589C9.04041 10.5581 8.92655 10.2866 8.92409 10.0027C8.92162 9.7189 9.03074 9.44543 9.22794 9.24125L16.0407 2.4285H14.3237C14.0366 2.4285 13.7613 2.31444 13.5582 2.11142C13.3552 1.90839 13.2411 1.63303 13.2411 1.34591C13.2411 1.05879 13.3552 0.783424 13.5582 0.580399C13.7613 0.377373 14.0366 0.263314 14.3237 0.263314H18.4981C18.5509 0.254962 18.6043 0.250507 18.658 0.250041C18.8017 0.248792 18.9443 0.276183 19.0773 0.330617C19.2104 0.385051 19.3313 0.465437 19.4329 0.567084C19.5346 0.668732 19.6149 0.789606 19.6694 0.922652C19.7238 1.0557 19.7512 1.19825 19.75 1.342C19.7495 1.3956 19.7451 1.44896 19.7367 1.50165V5.67628C19.7367 5.9634 19.6227 6.23877 19.4196 6.44179C19.2166 6.64482 18.9412 6.75888 18.6541 6.75888C18.367 6.75888 18.0916 6.64482 17.8886 6.44179C17.6856 6.23877 17.5715 5.9634 17.5715 5.67628V3.95926Z"
    }), /*#__PURE__*/ $5FkrB.createElement("path", {
        d: "M2.41519 17.5848V2.4285H8.91076V0.263314H2.41194C1.22001 0.263314 0.25 1.23007 0.25 2.42201V17.5913C0.250574 18.1638 0.47834 18.7127 0.883283 19.1175C1.28823 19.5222 1.83724 19.7497 2.40978 19.75H17.5769C17.8608 19.7499 18.1418 19.6938 18.404 19.585C18.6662 19.4762 18.9044 19.3168 19.105 19.116C19.3055 18.9151 19.4646 18.6767 19.573 18.4143C19.6814 18.152 19.737 17.8708 19.7367 17.587V11.0893H17.5715V17.5848H2.41519Z"
    }))));
};
// Workarounds to support generic types with forwardRef
/**
 * __Link__
 *
 * A link is an inline text element that navigates to a new location when clicked.
 *
 * - [Examples](https://atlassian.design/components/primitives/link/examples)
 * - [Code](https://atlassian.design/components/primitives/link/code)
 * - [Usage](https://atlassian.design/components/primitives/link/usage)
 */ var $d917641e8f454f72$var$Link = /*#__PURE__*/ (0, $5FkrB.forwardRef)($d917641e8f454f72$var$LinkWithoutRef);
var $d917641e8f454f72$export$2e2bcd8739ae039 = $d917641e8f454f72$var$Link;

});
parcelRegister("evbIR", function(module, exports) {
$parcel$export(module.exports, "cx", () => $a8ed0dce0882e791$export$a274e22fb40f762e);
/* index.tsx generated by @compiled/babel-plugin v0.38.1 */ parcelRequire("5FkrB");


var $Pd8py = parcelRequire("Pd8py");
var $a8ed0dce0882e791$var$strictApi = (0, $Pd8py.createStrictAPI)();
var $a8ed0dce0882e791$export$dbf350e5966cf602 = $a8ed0dce0882e791$var$strictApi.css;
var $a8ed0dce0882e791$export$eb1ecd84a24ee424 = $a8ed0dce0882e791$var$strictApi.cssMap;
$a8ed0dce0882e791$var$strictApi.cssMap;
var $a8ed0dce0882e791$export$a274e22fb40f762e = $a8ed0dce0882e791$var$strictApi.cx;
var $a8ed0dce0882e791$var$XCSSProp = $a8ed0dce0882e791$var$strictApi.XCSSProp; // This is to mitigate local TS error TS2315: Type 'StrictXCSSProp' is not generic.
 // Currently for some reason tsc is generating malformed .d.ts in local dev environment, below change fixes it
 /**
 * ## StrictXCSSProp
 *
 * Declare styles your component takes with all other styles marked as violations
 * by the TypeScript compiler. There are two primary use cases for xcss prop:
 *
 * - safe style overrides
 * - inverting style declarations
 *
 * Interverting style declarations is interesting for platform teams as
 * it means apps only pay for styles they use as they're now the ones who declare
 * the styles!
 *
 * The {@link StrictXCSSProp} type has generics two of which must be defined — use to explicitly
 * set what you want to maintain as API. Use {@link XCSSAllProperties} and {@link XCSSAllPseudos}
 * to enable all properties and pseudos.
 *
 * The third generic is used to declare what properties and pseudos should be required.
 *
 * ```tsx
 * interface MyComponentProps {
 *   // Color is accepted, all other properties / pseudos are considered violations.
 *   xcss?: StrictXCSSProp<'color', never>;
 *
 *   // Only background color and hover pseudo are accepted.
 *   xcss?: StrictXCSSProp<'backgroundColor', '&:hover'>;
 *
 *   // All properties are accepted, all pseudos are considered violations.
 *   xcss?: StrictXCSSProp<XCSSAllProperties, never>;
 *
 *   // All properties are accepted, only the hover pseudo is accepted.
 *   xcss?: StrictXCSSProp<XCSSAllProperties, '&:hover'>;
 *
 *   // The xcss prop is required as well as the color property. No pseudos are required.
 *   xcss: StrictXCSSProp<
 *     XCSSAllProperties,
 *     '&:hover',
 *     { requiredProperties: 'color', requiredPseudos: never }
 *   >;
 * }
 *
 * function MyComponent({ xcss }: MyComponentProps) {
 *   return <div css={{ color: 'var(--ds-text-danger)' }} className={xcss} />
 * }
 * ```
 *
 * The xcss prop works with static inline objects and the [cssMap](https://compiledcssinjs.com/docs/api-cssmap) API.
 *
 * ```jsx
 * // Declared as an inline object
 * <Component xcss={{ color: 'var(--ds-text)' }} />
 *
 * // Declared with the cssMap API
 * const styles = cssMap({ text: { color: 'var(--ds-text)' } });
 * <Component xcss={styles.text} />
 * ```
 *
 * To concatenate and conditonally apply styles use the {@link cssMap} and {@link cx} functions.
 */ 

});

parcelRegister("jFgzo", function(module, exports) {
$parcel$export(module.exports, "default", () => $e50eb313538143a4$export$2e2bcd8739ae039);
/* anchor.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $kqp0i = parcelRequire("kqp0i");

var $ekGgq = parcelRequire("ekGgq");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");


var $hUFig = parcelRequire("hUFig");

var $afMOk = parcelRequire("afMOk");

var $bSNj8 = parcelRequire("bSNj8");

var $3bjY4 = parcelRequire("3bjY4");

var $eVb4V = parcelRequire("eVb4V");

var $h8qvJ = parcelRequire("h8qvJ");

var $eqVaP = parcelRequire("eqVaP");

var $e8kqY = parcelRequire("e8kqY");

var $8grH2 = parcelRequire("8grH2");
var $e50eb313538143a4$var$_excluded = [
    "href",
    "children",
    "onClick",
    "interactionName",
    "componentName",
    "analyticsContext",
    "aria-label",
    "aria-labelledby",
    "style",
    "target",
    "testId",
    "xcss",
    "newWindowLabel"
], $e50eb313538143a4$var$_excluded2 = [
    "className"
];
var $e50eb313538143a4$var$styles = {
    root: "_4bfu1r31 _1hms8stv _ajmmnqa1 _vchhusvi",
    position: "_kqswh2mm"
};
var $e50eb313538143a4$var$IS_EXTERNAL_LINK_REGEX = /^(?:(http|https):\/\/)/;
var $e50eb313538143a4$var$IS_NON_HTTP_BASED = /^(((mailto|tel|sms|blob):)|(#))/;
/**
 * __Anchor__
 *
 * A primitive for building custom anchor links.
 *
 * - [Examples](https://atlassian.design/components/primitives/anchor/examples)
 * - [Code](https://atlassian.design/components/primitives/anchor/code)
 * - [Usage](https://atlassian.design/components/primitives/anchor/usage)
 */ var $e50eb313538143a4$var$AnchorNoRef = function AnchorNoRef(_ref, ref) {
    var href = _ref.href, children = _ref.children, _ref$onClick = _ref.onClick, providedOnClick = _ref$onClick === void 0 ? (0, $eVb4V.default) : _ref$onClick, interactionName = _ref.interactionName, componentName = _ref.componentName, analyticsContext = _ref.analyticsContext, ariaLabel = _ref['aria-label'], ariaLabelledBy = _ref['aria-labelledby'], style = _ref.style, target = _ref.target, testId = _ref.testId, xcss = _ref.xcss, _ref$newWindowLabel = _ref.newWindowLabel, newWindowLabel = _ref$newWindowLabel === void 0 ? '(opens new window)' : _ref$newWindowLabel, htmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $e50eb313538143a4$var$_excluded);
    var interactionContext = (0, $5FkrB.useContext)((0, $eqVaP.default));
    var handleClick = (0, $5FkrB.useCallback)(function(e, analyticsEvent) {
        interactionContext && interactionContext.tracePress(interactionName, e.timeStamp);
        providedOnClick(e, analyticsEvent);
    }, [
        providedOnClick,
        interactionContext,
        interactionName
    ]);
    var opensNewWindowLabelId = (0, $h8qvJ.useId)();
    var onClick = (0, $bSNj8.usePlatformLeafEventHandler)({
        fn: handleClick,
        action: 'clicked',
        componentName: componentName || 'Anchor',
        packageName: "@atlaskit/primitives",
        packageVersion: "16.4.4",
        analyticsData: analyticsContext,
        actionSubject: 'link'
    });
    // This is to remove className from safeHtmlAttributes
    // @ts-expect-error className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(htmlAttributes, $e50eb313538143a4$var$_excluded2);
    var RouterLink = (0, $3bjY4.default)();
    var isExternal = typeof href === 'string' && $e50eb313538143a4$var$IS_EXTERNAL_LINK_REGEX.test(href);
    var isNonHttpBased = typeof href === 'string' && $e50eb313538143a4$var$IS_NON_HTTP_BASED.test(href);
    /**
   * Renders a router link if:
   *
   * - a link component is set in the app provider
   * - it's not an external link (starting with `http://` or `https://`)
   * - it's not a non-HTTP-based link (e.g. emails, phone numbers, hash links etc.).
   */ var isRouterLink = RouterLink && !isExternal && !isNonHttpBased;
    var hrefObjectUsedWithoutRouterLink = RouterLink === undefined && (0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(href) === 'object';
    (0, $afMOk.default)(!hrefObjectUsedWithoutRouterLink, "@atlaskit/primitives: Anchor primitive cannot pass an object to 'href' unless a router link is configured in the AppProvider");
    var Component = isRouterLink ? RouterLink : 'a';
    return /*#__PURE__*/ $5FkrB.createElement((0, $8grH2.default), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        as: Component,
        className: xcss,
        style: style,
        ref: ref
    }, safeHtmlAttributes, {
        href: !isRouterLink && typeof href !== 'string' ? undefined : href,
        target: target,
        onClick: onClick,
        "aria-label": ariaLabel && target === '_blank' && !ariaLabelledBy ? "".concat(ariaLabel, " , ").concat(newWindowLabel) : ariaLabel,
        "aria-labelledby": ariaLabelledBy && target === '_blank' ? "".concat(ariaLabelledBy, " ").concat(opensNewWindowLabelId) : ariaLabelledBy,
        xcss: (0, $hUFig.cx)($e50eb313538143a4$var$styles.root, $e50eb313538143a4$var$styles.position, xcss),
        testId: testId,
        "data-is-router-link": testId ? isRouterLink ? 'true' : 'false' : undefined
    }), children, target === '_blank' && (children && !ariaLabel && !ariaLabelledBy || ariaLabelledBy) && /*#__PURE__*/ $5FkrB.createElement((0, $e8kqY.default), {
        id: opensNewWindowLabelId
    }, ", ".concat(newWindowLabel)));
};
// Workarounds to support generic types with forwardRef
/**
 * __Anchor__
 *
 * Anchor is a primitive for building custom anchor links. It's a wrapper around the HTML `<a>` element that provides a consistent API for handling client-side routing and Atlassian Design System styling.
 *
 * - [Examples](https://atlassian.design/components/primitives/anchor/examples)
 * - [Code](https://atlassian.design/components/primitives/anchor/code)
 * - [Usage](https://atlassian.design/components/primitives/anchor/usage)
 */ var $e50eb313538143a4$var$Anchor = /*#__PURE__*/ (0, $5FkrB.forwardRef)($e50eb313538143a4$var$AnchorNoRef);
var $e50eb313538143a4$export$2e2bcd8739ae039 = $e50eb313538143a4$var$Anchor;

});
parcelRegister("bSNj8", function(module, exports) {
$parcel$export(module.exports, "usePlatformLeafEventHandler", () => $8a6afc58e3e0886f$export$a4687b0234b40e28);

var $25nEq = parcelRequire("25nEq");

var $5FkrB = parcelRequire("5FkrB");

var $cOsWw = parcelRequire("cOsWw");

var $5SnFU = parcelRequire("5SnFU");
function $8a6afc58e3e0886f$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $8a6afc58e3e0886f$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $8a6afc58e3e0886f$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $8a6afc58e3e0886f$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $8a6afc58e3e0886f$export$a4687b0234b40e28(_ref) {
    var fn = _ref.fn, action = _ref.action, componentName = _ref.componentName, actionSubject = _ref.actionSubject, packageName = _ref.packageName, packageVersion = _ref.packageVersion, analyticsData = _ref.analyticsData;
    var _useAnalyticsEvents = (0, $cOsWw.useAnalyticsEvents)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
    // We put analyticsData and fn in a ref so that we don't need to break
    // memoization.
    // Generally these could be defined by consumers inline
    // and so we do this to avoid breaking memoization of useCallback
    var dataRef = (0, $5SnFU.useTrackedRef)(analyticsData);
    var fnRef = (0, $5SnFU.useTrackedRef)(fn);
    var handler = (0, $5FkrB.useCallback)(function(value) {
        var analyticsEvent = createAnalyticsEvent({
            action: action,
            actionSubject: actionSubject || componentName,
            attributes: {
                componentName: componentName,
                packageName: packageName,
                packageVersion: packageVersion
            }
        });
        // To avoid wrapping this component in AnalyticsContext we manually
        // push the parent context's meta data into the context.
        // Note: this new 'context'
        var context = $8a6afc58e3e0886f$var$_objectSpread({
            componentName: componentName,
            packageName: packageName,
            packageVersion: packageVersion
        }, dataRef.current);
        analyticsEvent.context.push(context);
        // fire an event on the atlaskit channel
        var clone = analyticsEvent.clone();
        if (clone) clone.fire('atlaskit');
        fnRef.current(value, analyticsEvent);
    }, [
        // These are strings and won't change
        action,
        componentName,
        actionSubject,
        packageName,
        packageVersion,
        // This function is memoized in the context
        createAnalyticsEvent,
        // these are a stable ref because of the useTrackedRef hook
        dataRef,
        fnRef
    ]);
    return handler;
}

});

parcelRegister("3bjY4", function(module, exports) {
$parcel$export(module.exports, "default", () => $2511e35fb374cb97$export$2e2bcd8739ae039);

var $5FkrB = parcelRequire("5FkrB");

var $7ELWQ = parcelRequire("7ELWQ");
/**
 * __useRouterLink()__
 *
 * Hook: Returns app-configured router link component.
 *
 * A generic can be passed to define advanced link configuration:
 * ```
 * type MyRouterLinkConfig = {
 *  to: string;
 *  replace?: boolean;
 * }
 *
 * const RouterLink = useRouterLink<MyRouterLinkConfig>();
 * ```
 */ var $2511e35fb374cb97$var$useRouterLink = function useRouterLink() {
    var _useContext = (0, $5FkrB.useContext)((0, $7ELWQ.RouterLinkProviderContext)), routerLinkComponent = _useContext.routerLinkComponent;
    if (routerLinkComponent) return routerLinkComponent;
    return;
};
var $2511e35fb374cb97$export$2e2bcd8739ae039 = $2511e35fb374cb97$var$useRouterLink;

});
parcelRegister("7ELWQ", function(module, exports) {
$parcel$export(module.exports, "RouterLinkProviderContext", () => $5931764cf7f9abe2$export$2931e0ee690eee88);

var $5FkrB = parcelRequire("5FkrB");
var $5931764cf7f9abe2$export$2931e0ee690eee88 = /*#__PURE__*/ (0, $5FkrB.createContext)({});
/**
 * __RouterLinkProvider__
 *
 * Provides a configured router link component for use
 * within Design System components.
 */ var $5931764cf7f9abe2$var$RouterLinkProvider = function RouterLinkProvider(_ref) {
    var routerLinkComponent = _ref.routerLinkComponent, children = _ref.children;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement($5931764cf7f9abe2$export$2931e0ee690eee88.Provider, {
        value: {
            routerLinkComponent: routerLinkComponent
        }
    }, children);
};
var $5931764cf7f9abe2$export$2e2bcd8739ae039 = $5931764cf7f9abe2$var$RouterLinkProvider;

});


parcelRegister("8grH2", function(module, exports) {
$parcel$export(module.exports, "default", () => $60454c9ee3adb107$export$2e2bcd8739ae039);
/* focusable.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $kqp0i = parcelRequire("kqp0i");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");
var $60454c9ee3adb107$var$_excluded = [
    "as",
    "children",
    "isInset",
    "testId",
    "style",
    "xcss"
], $60454c9ee3adb107$var$_excluded2 = [
    "className"
];
var $60454c9ee3adb107$var$focusRingStyles = null;
var $60454c9ee3adb107$var$insetFocusRingStyles = null;
/**
 * __Focus ring__
 *
 * A focus ring visually indicates the currently focused item.
 *
 */ var $60454c9ee3adb107$var$Focusable = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? 'button' : _ref$as, children = _ref.children, isInset = _ref.isInset, testId = _ref.testId, style = _ref.style, xcss = _ref.xcss, htmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $60454c9ee3adb107$var$_excluded);
    // This is to remove className from safeHtmlAttributes
    // @ts-ignore -- not using expect since it causes issues with help-center local consumption - className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(htmlAttributes, $60454c9ee3adb107$var$_excluded2);
    return /*#__PURE__*/ $5FkrB.createElement(Component, (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, safeHtmlAttributes, {
        // @ts-ignore Expression produces a union type that is too complex to represent. We may be able to narrow the type here but unsure.
        ref: ref,
        className: (0, $970q7.default)([
            "_ymio1r31 _ypr0glyw _zcxs1o36 _mizu194a _1ah3dkaa _ra3xnqa1 _128mdkaa _1cvmnqa1 _4davt94y",
            isInset && "_1ah31gjf _2mwq1gjf",
            xcss
        ]),
        style: style,
        "data-testid": testId
    }), children);
});
var $60454c9ee3adb107$export$2e2bcd8739ae039 = $60454c9ee3adb107$var$Focusable;

});


parcelRegister("b6FeK", function(module, exports) {
$parcel$export(module.exports, "default", () => $81603e0a6e5f4b4b$export$2e2bcd8739ae039);
/* box.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $kqp0i = parcelRequire("kqp0i");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");

var $iKoHy = parcelRequire("iKoHy");
var $81603e0a6e5f4b4b$var$_excluded = [
    "as",
    "children",
    "backgroundColor",
    "padding",
    "paddingBlock",
    "paddingBlockStart",
    "paddingBlockEnd",
    "paddingInline",
    "paddingInlineStart",
    "paddingInlineEnd",
    "style",
    "testId",
    "xcss"
], $81603e0a6e5f4b4b$var$_excluded2 = [
    "className"
];
// Can either Exclude or Extract - here we're excluding all SVG-related elements, <button> elements (handled by Pressable), and <a> elements (handled by Anchor)
// Basically just ElementType but without ComponentType, it makes sense to keep the "Type" suffix
// eslint-disable-next-line @repo/internal/react/consistent-types-definitions
var $81603e0a6e5f4b4b$var$baseStyles = null;
var $81603e0a6e5f4b4b$var$backgroundColorMap = {
    'color.background.accent.lime.subtlest': "_bfhkm890",
    'color.background.accent.lime.subtlest.hovered': "_bfhkd4y8",
    'color.background.accent.lime.subtlest.pressed': "_bfhkkuup",
    'color.background.accent.lime.subtler': "_bfhkz2ec",
    'color.background.accent.lime.subtler.hovered': "_bfhk1gf0",
    'color.background.accent.lime.subtler.pressed': "_bfhk2kxc",
    'color.background.accent.lime.subtle': "_bfhkbq5w",
    'color.background.accent.lime.subtle.hovered': "_bfhkfoww",
    'color.background.accent.lime.subtle.pressed': "_bfhk1jbd",
    'color.background.accent.lime.bolder': "_bfhktde4",
    'color.background.accent.lime.bolder.hovered': "_bfhknzpa",
    'color.background.accent.lime.bolder.pressed': "_bfhkh0j0",
    'color.background.accent.red.subtlest': "_bfhk1vk5",
    'color.background.accent.red.subtlest.hovered': "_bfhk1i6i",
    'color.background.accent.red.subtlest.pressed': "_bfhknbir",
    'color.background.accent.red.subtler': "_bfhk1rtt",
    'color.background.accent.red.subtler.hovered': "_bfhkaffd",
    'color.background.accent.red.subtler.pressed': "_bfhk1j5a",
    'color.background.accent.red.subtle': "_bfhkkrt9",
    'color.background.accent.red.subtle.hovered': "_bfhk1sou",
    'color.background.accent.red.subtle.pressed': "_bfhk1fnn",
    'color.background.accent.red.bolder': "_bfhkuibq",
    'color.background.accent.red.bolder.hovered': "_bfhk100f",
    'color.background.accent.red.bolder.pressed': "_bfhk1cl6",
    'color.background.accent.orange.subtlest': "_bfhkf5uh",
    'color.background.accent.orange.subtlest.hovered': "_bfhk19yr",
    'color.background.accent.orange.subtlest.pressed': "_bfhkf90x",
    'color.background.accent.orange.subtler': "_bfhk165s",
    'color.background.accent.orange.subtler.hovered': "_bfhk1ei0",
    'color.background.accent.orange.subtler.pressed': "_bfhkdpo3",
    'color.background.accent.orange.subtle': "_bfhk1kkj",
    'color.background.accent.orange.subtle.hovered': "_bfhk9mfs",
    'color.background.accent.orange.subtle.pressed': "_bfhkaxpp",
    'color.background.accent.orange.bolder': "_bfhk1qg1",
    'color.background.accent.orange.bolder.hovered': "_bfhk12qo",
    'color.background.accent.orange.bolder.pressed': "_bfhk1fyq",
    'color.background.accent.yellow.subtlest': "_bfhkibhp",
    'color.background.accent.yellow.subtlest.hovered': "_bfhkaetg",
    'color.background.accent.yellow.subtlest.pressed': "_bfhk1o1l",
    'color.background.accent.yellow.subtler': "_bfhk1773",
    'color.background.accent.yellow.subtler.hovered': "_bfhk1uw7",
    'color.background.accent.yellow.subtler.pressed': "_bfhk1r9w",
    'color.background.accent.yellow.subtle': "_bfhk8y3s",
    'color.background.accent.yellow.subtle.hovered': "_bfhk819w",
    'color.background.accent.yellow.subtle.pressed': "_bfhk1jx0",
    'color.background.accent.yellow.bolder': "_bfhk1vop",
    'color.background.accent.yellow.bolder.hovered': "_bfhkkjqf",
    'color.background.accent.yellow.bolder.pressed': "_bfhk1okt",
    'color.background.accent.green.subtlest': "_bfhkn729",
    'color.background.accent.green.subtlest.hovered': "_bfhk3utz",
    'color.background.accent.green.subtlest.pressed': "_bfhkyfny",
    'color.background.accent.green.subtler': "_bfhk1wnw",
    'color.background.accent.green.subtler.hovered': "_bfhk1e2h",
    'color.background.accent.green.subtler.pressed': "_bfhkybhx",
    'color.background.accent.green.subtle': "_bfhk1rsu",
    'color.background.accent.green.subtle.hovered': "_bfhk12e3",
    'color.background.accent.green.subtle.pressed': "_bfhk1g86",
    'color.background.accent.green.bolder': "_bfhk1e5c",
    'color.background.accent.green.bolder.hovered': "_bfhka5yi",
    'color.background.accent.green.bolder.pressed': "_bfhk1j68",
    'color.background.accent.teal.subtlest': "_bfhk7xuz",
    'color.background.accent.teal.subtlest.hovered': "_bfhk108c",
    'color.background.accent.teal.subtlest.pressed': "_bfhk1cxp",
    'color.background.accent.teal.subtler': "_bfhk1a17",
    'color.background.accent.teal.subtler.hovered': "_bfhkkwwr",
    'color.background.accent.teal.subtler.pressed': "_bfhk1jb0",
    'color.background.accent.teal.subtle': "_bfhktdv8",
    'color.background.accent.teal.subtle.hovered': "_bfhkzh8h",
    'color.background.accent.teal.subtle.pressed': "_bfhk16zl",
    'color.background.accent.teal.bolder': "_bfhk2c8p",
    'color.background.accent.teal.bolder.hovered': "_bfhkl3ve",
    'color.background.accent.teal.bolder.pressed': "_bfhktor0",
    'color.background.accent.blue.subtlest': "_bfhk1s93",
    'color.background.accent.blue.subtlest.hovered': "_bfhkdaj9",
    'color.background.accent.blue.subtlest.pressed': "_bfhkxm0g",
    'color.background.accent.blue.subtler': "_bfhk1dy8",
    'color.background.accent.blue.subtler.hovered': "_bfhk815t",
    'color.background.accent.blue.subtler.pressed': "_bfhkrwxf",
    'color.background.accent.blue.subtle': "_bfhk115i",
    'color.background.accent.blue.subtle.hovered': "_bfhk9pr4",
    'color.background.accent.blue.subtle.pressed': "_bfhknpx7",
    'color.background.accent.blue.bolder': "_bfhk16e3",
    'color.background.accent.blue.bolder.hovered': "_bfhk1vbm",
    'color.background.accent.blue.bolder.pressed': "_bfhk1xwi",
    'color.background.accent.purple.subtlest': "_bfhkp2ly",
    'color.background.accent.purple.subtlest.hovered': "_bfhkkca2",
    'color.background.accent.purple.subtlest.pressed': "_bfhk1jbm",
    'color.background.accent.purple.subtler': "_bfhk1nm4",
    'color.background.accent.purple.subtler.hovered': "_bfhkattl",
    'color.background.accent.purple.subtler.pressed': "_bfhk3nfk",
    'color.background.accent.purple.subtle': "_bfhk18ah",
    'color.background.accent.purple.subtle.hovered': "_bfhk8bp1",
    'color.background.accent.purple.subtle.pressed': "_bfhk1cd2",
    'color.background.accent.purple.bolder': "_bfhkya33",
    'color.background.accent.purple.bolder.hovered': "_bfhk1af5",
    'color.background.accent.purple.bolder.pressed': "_bfhk6cze",
    'color.background.accent.magenta.subtlest': "_bfhk8tvm",
    'color.background.accent.magenta.subtlest.hovered': "_bfhkr3zd",
    'color.background.accent.magenta.subtlest.pressed': "_bfhk1ckf",
    'color.background.accent.magenta.subtler': "_bfhkv9ra",
    'color.background.accent.magenta.subtler.hovered': "_bfhk1axx",
    'color.background.accent.magenta.subtler.pressed': "_bfhk42ri",
    'color.background.accent.magenta.subtle': "_bfhk1mi6",
    'color.background.accent.magenta.subtle.hovered': "_bfhkrwyz",
    'color.background.accent.magenta.subtle.pressed': "_bfhk6c15",
    'color.background.accent.magenta.bolder': "_bfhkc3uk",
    'color.background.accent.magenta.bolder.hovered': "_bfhk1ok8",
    'color.background.accent.magenta.bolder.pressed': "_bfhkeawv",
    'color.background.accent.gray.subtlest': "_bfhkysee",
    'color.background.accent.gray.subtlest.hovered': "_bfhkwejn",
    'color.background.accent.gray.subtlest.pressed': "_bfhk18ut",
    'color.background.accent.gray.subtler': "_bfhk7qp0",
    'color.background.accent.gray.subtler.hovered': "_bfhk10ef",
    'color.background.accent.gray.subtler.pressed': "_bfhk1rk9",
    'color.background.accent.gray.subtle': "_bfhk18j9",
    'color.background.accent.gray.subtle.hovered': "_bfhk1nv3",
    'color.background.accent.gray.subtle.pressed': "_bfhkq9tj",
    'color.background.accent.gray.bolder': "_bfhk1i45",
    'color.background.accent.gray.bolder.hovered': "_bfhkbyip",
    'color.background.accent.gray.bolder.pressed': "_bfhk1van",
    'color.background.disabled': "_bfhkby5v",
    'color.background.input': "_bfhk1j9a",
    'color.background.input.hovered': "_bfhkl4ek",
    'color.background.input.pressed': "_bfhkr01l",
    'color.background.inverse.subtle': "_bfhk1vck",
    'color.background.inverse.subtle.hovered': "_bfhkmpja",
    'color.background.inverse.subtle.pressed': "_bfhk1gii",
    'color.background.neutral': "_bfhki8nm",
    'color.background.neutral.hovered': "_bfhkplhp",
    'color.background.neutral.pressed': "_bfhk1gdz",
    'color.background.neutral.subtle': "_bfhksm61",
    'color.background.neutral.subtle.hovered': "_bfhk1dpa",
    'color.background.neutral.subtle.pressed': "_bfhkfcek",
    'color.background.neutral.bold': "_bfhk1aqn",
    'color.background.neutral.bold.hovered': "_bfhk1ibz",
    'color.background.neutral.bold.pressed': "_bfhkof27",
    'color.background.selected': "_bfhk15s3",
    'color.background.selected.hovered': "_bfhkufnl",
    'color.background.selected.pressed': "_bfhknozp",
    'color.background.selected.bold': "_bfhkjmqp",
    'color.background.selected.bold.hovered': "_bfhk1q28",
    'color.background.selected.bold.pressed': "_bfhk12kk",
    'color.background.brand.subtlest': "_bfhk1gmr",
    'color.background.brand.subtlest.hovered': "_bfhk3v15",
    'color.background.brand.subtlest.pressed': "_bfhku02c",
    'color.background.brand.bold': "_bfhk1856",
    'color.background.brand.bold.hovered': "_bfhkhf2y",
    'color.background.brand.bold.pressed': "_bfhkg6ey",
    'color.background.brand.boldest': "_bfhk1o4i",
    'color.background.brand.boldest.hovered': "_bfhklefx",
    'color.background.brand.boldest.pressed': "_bfhk16k6",
    'color.background.danger': "_bfhk1gly",
    'color.background.danger.hovered': "_bfhk1yvi",
    'color.background.danger.pressed': "_bfhk1r4b",
    'color.background.danger.bold': "_bfhkybec",
    'color.background.danger.bold.hovered': "_bfhks9hg",
    'color.background.danger.bold.pressed': "_bfhk13a9",
    'color.background.warning': "_bfhk1917",
    'color.background.warning.hovered': "_bfhk19zu",
    'color.background.warning.pressed': "_bfhkzr32",
    'color.background.warning.bold': "_bfhk1kmu",
    'color.background.warning.bold.hovered': "_bfhk1spp",
    'color.background.warning.bold.pressed': "_bfhk4m4m",
    'color.background.success': "_bfhk1y9u",
    'color.background.success.hovered': "_bfhk1vfx",
    'color.background.success.pressed': "_bfhk1wl5",
    'color.background.success.bold': "_bfhkkcmj",
    'color.background.success.bold.hovered': "_bfhky7x8",
    'color.background.success.bold.pressed': "_bfhkwcbh",
    'color.background.discovery': "_bfhk6vm6",
    'color.background.discovery.hovered': "_bfhk12eq",
    'color.background.discovery.pressed': "_bfhk18vq",
    'color.background.discovery.bold': "_bfhku5tj",
    'color.background.discovery.bold.hovered': "_bfhkfqeg",
    'color.background.discovery.bold.pressed': "_bfhk1f1m",
    'color.background.information': "_bfhk19ip",
    'color.background.information.hovered': "_bfhk86z5",
    'color.background.information.pressed': "_bfhk1c1j",
    'color.background.information.bold': "_bfhkx4w0",
    'color.background.information.bold.hovered': "_bfhkq2ii",
    'color.background.information.bold.pressed': "_bfhkf89v",
    'color.blanket': "_bfhk1i5c",
    'color.blanket.selected': "_bfhk7wq0",
    'color.blanket.danger': "_bfhkrprw",
    'color.skeleton': "_bfhkizff",
    'color.skeleton.subtle': "_bfhkvkf5",
    'elevation.surface': "_bfhkvuon",
    'elevation.surface.hovered': "_bfhk19i6",
    'elevation.surface.pressed': "_bfhk13ro",
    'elevation.surface.overlay': "_bfhk1bhr",
    'elevation.surface.overlay.hovered': "_bfhk6o2t",
    'elevation.surface.overlay.pressed': "_bfhkm8nx",
    'elevation.surface.raised': "_bfhkhp5a",
    'elevation.surface.raised.hovered': "_bfhk116u",
    'elevation.surface.raised.pressed': "_bfhk14aj",
    'elevation.surface.sunken': "_bfhkhfxm",
    'utility.elevation.surface.current': "_bfhkchd4"
};
var $81603e0a6e5f4b4b$var$CURRENT_SURFACE_CSS_VAR = "--ds-elevation-surface-current";
var $81603e0a6e5f4b4b$var$setSurfaceTokenMap = {
    'elevation.surface': "_1q1lvuon",
    'elevation.surface.hovered': "_1q1l19i6",
    'elevation.surface.pressed': "_1q1l13ro",
    'elevation.surface.overlay': "_1q1l1bhr",
    'elevation.surface.overlay.hovered': "_1q1l6o2t",
    'elevation.surface.overlay.pressed': "_1q1lm8nx",
    'elevation.surface.raised': "_1q1lhp5a",
    'elevation.surface.raised.hovered': "_1q1l116u",
    'elevation.surface.raised.pressed': "_1q1l14aj",
    'elevation.surface.sunken': "_1q1lhfxm"
};
var $81603e0a6e5f4b4b$var$paddingBlockStartMap = {
    'space.0': "_1q51ze3t",
    'space.025': "_1q51v77o",
    'space.050': "_1q511b66",
    'space.075': "_1q5112x7",
    'space.100': "_1q51u2gc",
    'space.150': "_1q51utpp",
    'space.200': "_1q51pxbi",
    'space.250': "_1q51v47k",
    'space.300': "_1q511ejb",
    'space.400': "_1q51xy5q",
    'space.500': "_1q511jfw",
    'space.600': "_1q51oahv",
    'space.800': "_1q51xncg",
    'space.1000': "_1q511epz"
};
var $81603e0a6e5f4b4b$var$paddingBlockEndMap = {
    'space.0': "_85i5ze3t",
    'space.025': "_85i5v77o",
    'space.050': "_85i51b66",
    'space.075': "_85i512x7",
    'space.100': "_85i5u2gc",
    'space.150': "_85i5utpp",
    'space.200': "_85i5pxbi",
    'space.250': "_85i5v47k",
    'space.300': "_85i51ejb",
    'space.400': "_85i5xy5q",
    'space.500': "_85i51jfw",
    'space.600': "_85i5oahv",
    'space.800': "_85i5xncg",
    'space.1000': "_85i51epz"
};
var $81603e0a6e5f4b4b$var$paddingInlineStartMap = {
    'space.0': "_bozgze3t",
    'space.025': "_bozgv77o",
    'space.050': "_bozg1b66",
    'space.075': "_bozg12x7",
    'space.100': "_bozgu2gc",
    'space.150': "_bozgutpp",
    'space.200': "_bozgpxbi",
    'space.250': "_bozgv47k",
    'space.300': "_bozg1ejb",
    'space.400': "_bozgxy5q",
    'space.500': "_bozg1jfw",
    'space.600': "_bozgoahv",
    'space.800': "_bozgxncg",
    'space.1000': "_bozg1epz"
};
var $81603e0a6e5f4b4b$var$paddingInlineEndMap = {
    'space.0': "_y4tize3t",
    'space.025': "_y4tiv77o",
    'space.050': "_y4ti1b66",
    'space.075': "_y4ti12x7",
    'space.100': "_y4tiu2gc",
    'space.150': "_y4tiutpp",
    'space.200': "_y4tipxbi",
    'space.250': "_y4tiv47k",
    'space.300': "_y4ti1ejb",
    'space.400': "_y4tixy5q",
    'space.500': "_y4ti1jfw",
    'space.600': "_y4tioahv",
    'space.800': "_y4tixncg",
    'space.1000': "_y4ti1epz"
};
/**
 * __Box__
 *
 * A Box is a primitive component that has the design decisions of the Atlassian Design System baked in.
 * Renders a `div` by default.
 *
 * - [Examples](https://atlassian.design/components/primitives/box/examples)
 * - [Code](https://atlassian.design/components/primitives/box/code)
 * - [Usage](https://atlassian.design/components/primitives/box/usage)
 */ var $81603e0a6e5f4b4b$var$Box = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? 'div' : _ref$as, children = _ref.children, backgroundColor = _ref.backgroundColor, padding = _ref.padding, _ref$paddingBlock = _ref.paddingBlock, paddingBlock = _ref$paddingBlock === void 0 ? padding : _ref$paddingBlock, _ref$paddingBlockStar = _ref.paddingBlockStart, paddingBlockStart = _ref$paddingBlockStar === void 0 ? paddingBlock : _ref$paddingBlockStar, _ref$paddingBlockEnd = _ref.paddingBlockEnd, paddingBlockEnd = _ref$paddingBlockEnd === void 0 ? paddingBlock : _ref$paddingBlockEnd, _ref$paddingInline = _ref.paddingInline, paddingInline = _ref$paddingInline === void 0 ? padding : _ref$paddingInline, _ref$paddingInlineSta = _ref.paddingInlineStart, paddingInlineStart = _ref$paddingInlineSta === void 0 ? paddingInline : _ref$paddingInlineSta, _ref$paddingInlineEnd = _ref.paddingInlineEnd, paddingInlineEnd = _ref$paddingInlineEnd === void 0 ? paddingInline : _ref$paddingInlineEnd, style = _ref.style, testId = _ref.testId, xcss = _ref.xcss, htmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $81603e0a6e5f4b4b$var$_excluded);
    // This is to remove className from safeHtmlAttributes
    // @ts-ignore -- not using expect since it causes issues with help-center local consumption - className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(htmlAttributes, $81603e0a6e5f4b4b$var$_excluded2);
    var node = /*#__PURE__*/ $5FkrB.createElement(Component, (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        style: style,
        ref: ref,
        className: (0, $970q7.default)([
            "_19itglyw _vchhusvi _r06hglyw",
            backgroundColor && $81603e0a6e5f4b4b$var$backgroundColorMap[backgroundColor],
            backgroundColor && $81603e0a6e5f4b4b$var$isSurfaceToken(backgroundColor) && $81603e0a6e5f4b4b$var$setSurfaceTokenMap[backgroundColor],
            paddingBlockStart && $81603e0a6e5f4b4b$var$paddingBlockStartMap[paddingBlockStart],
            paddingBlockEnd && $81603e0a6e5f4b4b$var$paddingBlockEndMap[paddingBlockEnd],
            paddingInlineStart && $81603e0a6e5f4b4b$var$paddingInlineStartMap[paddingInlineStart],
            paddingInlineEnd && $81603e0a6e5f4b4b$var$paddingInlineEndMap[paddingInlineEnd],
            xcss
        ])
    }, safeHtmlAttributes, {
        "data-testid": testId
    }), children);
    if (backgroundColor) return /*#__PURE__*/ $5FkrB.createElement((0, $iKoHy.SurfaceContext).Provider, {
        value: backgroundColor
    }, node);
    return node;
});
var $81603e0a6e5f4b4b$export$2e2bcd8739ae039 = $81603e0a6e5f4b4b$var$Box;
function $81603e0a6e5f4b4b$var$isSurfaceToken(backgroundColor) {
    return backgroundColor in $81603e0a6e5f4b4b$var$setSurfaceTokenMap;
}

});
parcelRegister("iKoHy", function(module, exports) {
$parcel$export(module.exports, "SurfaceContext", () => $da5faf10254a297f$export$1ca2a26fecb070ae);
$parcel$export(module.exports, "useSurface", () => $da5faf10254a297f$export$1aeb4f6b93c4540d);

var $5FkrB = parcelRequire("5FkrB");
var $da5faf10254a297f$export$1ca2a26fecb070ae = /*#__PURE__*/ (0, $5FkrB.createContext)('elevation.surface');
var $da5faf10254a297f$export$1aeb4f6b93c4540d = function useSurface() {
    return (0, $5FkrB.useContext)($da5faf10254a297f$export$1ca2a26fecb070ae);
};
$da5faf10254a297f$export$1ca2a26fecb070ae.displayName = 'SurfaceProvider';

});



parcelRegister("5bCL3", function(module, exports) {
$parcel$export(module.exports, "fireLinkClickedEvent", () => $3c6c0b59a145c1e0$export$7987de3055fbdcb0);
$parcel$export(module.exports, "withLinkClickedEvent", () => $3c6c0b59a145c1e0$export$263352d59c0c5966);

var $25nEq = parcelRequire("25nEq");

var $5FkrB = parcelRequire("5FkrB");

var $6phP8 = parcelRequire("6phP8");

var $9GB8v = parcelRequire("9GB8v");

var $drUcN = parcelRequire("drUcN");

var $2hUC0 = parcelRequire("2hUC0");

var $8ckEN = parcelRequire("8ckEN");
function $3c6c0b59a145c1e0$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $3c6c0b59a145c1e0$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $3c6c0b59a145c1e0$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $3c6c0b59a145c1e0$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $3c6c0b59a145c1e0$export$cfb45d54e1604f6c = new Map([
    [
        undefined,
        'none'
    ],
    [
        0,
        'left'
    ],
    [
        1,
        'middle'
    ],
    [
        2,
        'right'
    ]
]);
var $3c6c0b59a145c1e0$export$74743eda5dda3ccf = function getKeys(e) {
    return [
        'alt',
        'ctrl',
        'meta',
        'shift'
    ].filter(function(key) {
        return e["".concat(key, "Key")] === true;
    });
};
var $3c6c0b59a145c1e0$var$isContentEditable = function isContentEditable(el) {
    return el instanceof HTMLElement && el.isContentEditable;
};
function $3c6c0b59a145c1e0$export$d2a83e3b34be812b(e, clickType) {
    var _browser = (0, $6phP8.browser)(), mac = _browser.mac, safari = _browser.safari;
    /**
   * If the link/parent is content editable then left click won't have typical effect
   */ if ($3c6c0b59a145c1e0$var$isContentEditable(e.currentTarget) && [
        'left',
        'middle'
    ].includes(clickType)) return 'contentEditable';
    switch(clickType){
        case 'left':
        case 'keyboard':
            // Meta key = Cmd for macOS, Windows key sometimes for Windows (otherwise false)
            // https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/metaKey
            if (e.metaKey) return mac ? 'clickThroughNewTabOrWindow' : 'clickThrough';
            if (e.shiftKey) {
                // Alt/option click in safari typically adds the link to bookmarks
                if (safari) return 'alt';
                return 'clickThroughNewTabOrWindow';
            }
            if (e.ctrlKey) {
                // Ctrl+Left on macOS defaults to triggering a right click instead (so won't trigger onClick)
                // but if this behaviour is disabled, likely outcome is clickThrough
                if (mac) return 'clickThrough';
                return 'clickThroughNewTabOrWindow';
            }
            if (e.altKey) return 'alt';
            var target = e.currentTarget.getAttribute('target');
            if (target === '_blank') return 'clickThroughNewTabOrWindow';
            return 'clickThrough';
        case 'middle':
            return 'clickThroughNewTabOrWindow';
        case 'right':
            return 'contextMenu';
    }
    return 'unknown';
}
var $3c6c0b59a145c1e0$var$linkClickedEventOld = function linkClickedEventOld(_ref) {
    var clickType = _ref.clickType, clickOutcome = _ref.clickOutcome, keysHeld = _ref.keysHeld, defaultPrevented = _ref.defaultPrevented;
    return {
        action: 'clicked',
        actionSubject: 'link',
        eventType: 'ui',
        attributes: {
            clickType: clickType,
            clickOutcome: clickOutcome,
            keysHeld: keysHeld,
            defaultPrevented: defaultPrevented
        }
    };
};
var $3c6c0b59a145c1e0$var$linkClickedEventWithShortLink = function linkClickedEventWithShortLink(_ref2) {
    var clickType = _ref2.clickType, clickOutcome = _ref2.clickOutcome, keysHeld = _ref2.keysHeld, defaultPrevented = _ref2.defaultPrevented, isConfluenceShortLink = _ref2.isConfluenceShortLink;
    return {
        action: 'clicked',
        actionSubject: 'link',
        eventType: 'ui',
        attributes: {
            clickType: clickType,
            clickOutcome: clickOutcome,
            keysHeld: keysHeld,
            defaultPrevented: defaultPrevented,
            isConfluenceShortLink: isConfluenceShortLink
        }
    };
};
var $3c6c0b59a145c1e0$export$880d2168464029dd = function createLinkClickedPayloadOld(event) {
    // Through the `detail` property, we're able to determine if the event is (most likely) triggered via keyboard
    // https://developer.mozilla.org/en-US/docs/Web/API/UIEvent/detail
    var isKeyboard = event.nativeEvent.detail === 0;
    var clickType = isKeyboard ? 'keyboard' : $3c6c0b59a145c1e0$export$cfb45d54e1604f6c.get(event.button);
    if (!clickType) return;
    var clickOutcome = $3c6c0b59a145c1e0$export$d2a83e3b34be812b(event, clickType);
    var keysHeld = $3c6c0b59a145c1e0$export$74743eda5dda3ccf(event);
    var defaultPrevented = event.defaultPrevented;
    var linkClickedEventResult = $3c6c0b59a145c1e0$var$linkClickedEventOld({
        clickType: clickType,
        clickOutcome: clickOutcome,
        keysHeld: keysHeld,
        defaultPrevented: defaultPrevented
    });
    // if the current target is an anchor tag, we can get the href from it and use that as the url being navigated too.
    if (event.currentTarget instanceof HTMLAnchorElement) {
        var url = event.currentTarget.href;
        return $3c6c0b59a145c1e0$var$_objectSpread($3c6c0b59a145c1e0$var$_objectSpread({}, linkClickedEventResult), {}, {
            nonPrivacySafeAttributes: {
                url: url
            }
        });
    } else // We can't get the href from the event target, so dont include the url or any non privacy safe attributes
    return linkClickedEventResult;
};
var $3c6c0b59a145c1e0$export$fb40cb818618aeeb = function createLinkClickedPayloadNew(event) {
    // Through the `detail` property, we're able to determine if the event is (most likely) triggered via keyboard
    // https://developer.mozilla.org/en-US/docs/Web/API/UIEvent/detail
    var isKeyboard = event.nativeEvent.detail === 0;
    var clickType = isKeyboard ? 'keyboard' : $3c6c0b59a145c1e0$export$cfb45d54e1604f6c.get(event.button);
    if (!clickType) return;
    var clickOutcome = $3c6c0b59a145c1e0$export$d2a83e3b34be812b(event, clickType);
    var keysHeld = $3c6c0b59a145c1e0$export$74743eda5dda3ccf(event);
    var defaultPrevented = event.defaultPrevented;
    // Check if the URL is a Confluence shortLink (contains "/l/cp/")
    var isConfluenceShortLink = false;
    if (event.currentTarget instanceof HTMLAnchorElement) {
        var url = event.currentTarget.href;
        isConfluenceShortLink = url.includes('/l/cp/');
    }
    var linkClickedEventResult = $3c6c0b59a145c1e0$var$linkClickedEventWithShortLink({
        clickType: clickType,
        clickOutcome: clickOutcome,
        keysHeld: keysHeld,
        defaultPrevented: defaultPrevented,
        isConfluenceShortLink: isConfluenceShortLink
    });
    // if the current target is an anchor tag, we can get the href from it and use that as the url being navigated too.
    if (event.currentTarget instanceof HTMLAnchorElement) {
        var _url = event.currentTarget.href;
        return $3c6c0b59a145c1e0$var$_objectSpread($3c6c0b59a145c1e0$var$_objectSpread({}, linkClickedEventResult), {}, {
            nonPrivacySafeAttributes: {
                url: _url
            }
        });
    } else // We can't get the href from the event target, so dont include the url or any non privacy safe attributes
    return linkClickedEventResult;
};
var $3c6c0b59a145c1e0$export$7fedc699766c16de = (0, $9GB8v.functionWithCondition)(function() {
    return (0, $drUcN.expValEquals)('smart_link_confluence_short_link_analytics', 'cohort', 'test');
}, // 12/17/2025: Clean up this feature gate once it's out in prod for 2 weeks - https://product-fabric.atlassian.net/browse/CCPERMS-5030
$3c6c0b59a145c1e0$export$fb40cb818618aeeb, $3c6c0b59a145c1e0$export$880d2168464029dd);
var $3c6c0b59a145c1e0$export$7987de3055fbdcb0 = function fireLinkClickedEvent(createAnalyticsEvent) {
    return function(event) {
        var overrides = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var payload = $3c6c0b59a145c1e0$export$7fedc699766c16de(event);
        if (payload) createAnalyticsEvent($3c6c0b59a145c1e0$var$_objectSpread($3c6c0b59a145c1e0$var$_objectSpread($3c6c0b59a145c1e0$var$_objectSpread({}, payload), overrides), {}, {
            attributes: $3c6c0b59a145c1e0$var$_objectSpread($3c6c0b59a145c1e0$var$_objectSpread({}, payload.attributes), overrides === null || overrides === void 0 ? void 0 : overrides.attributes),
            nonPrivacySafeAttributes: $3c6c0b59a145c1e0$var$_objectSpread($3c6c0b59a145c1e0$var$_objectSpread({}, payload.nonPrivacySafeAttributes), overrides === null || overrides === void 0 ? void 0 : overrides.nonPrivacySafeAttributes)
        })).fire((0, $8ckEN.ANALYTICS_CHANNEL));
    };
};
var $3c6c0b59a145c1e0$var$getDisplayName = function getDisplayName(WrappedComponent) {
    if (typeof WrappedComponent === 'string') return WrappedComponent;
    return WrappedComponent.displayName || WrappedComponent.name || 'Component';
};
function $3c6c0b59a145c1e0$export$263352d59c0c5966(WrappedComponent) {
    var Component = function Component(props) {
        var onClick = (0, $2hUC0.useLinkClicked)(props.onClick);
        var onMouseDown = (0, $2hUC0.useMouseDownEvent)(props.onMouseDown);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(WrappedComponent, $3c6c0b59a145c1e0$var$_objectSpread($3c6c0b59a145c1e0$var$_objectSpread({}, props), {}, {
            onClick: onClick,
            onMouseDown: onMouseDown
        }));
    };
    Component.displayName = "withLinkClickedEvent(".concat($3c6c0b59a145c1e0$var$getDisplayName(WrappedComponent), ")");
    return Component;
}

});
parcelRegister("6phP8", function(module, exports) {
$parcel$export(module.exports, "browser", () => $4aa2e74cf8171e1c$export$3f2684e5d7cb1006);
var $4aa2e74cf8171e1c$var$result = {
    mac: false,
    ie: false,
    ie_version: 0,
    gecko: false,
    chrome: false,
    chrome_version: 0,
    android: false,
    ios: false,
    webkit: false,
    safari: false,
    supportsIntersectionObserver: false,
    supportsResizeObserver: false
};
if (typeof navigator !== 'undefined') {
    var $4aa2e74cf8171e1c$var$ieEdge = /Edge\/(\d+)/.exec(navigator.userAgent);
    var $4aa2e74cf8171e1c$var$ieUpTo10 = /MSIE \d/.test(navigator.userAgent);
    var $4aa2e74cf8171e1c$var$ie11up = /Trident\/(?:[7-9]|\d{2,})\..*rv:(\d+)/.exec(navigator.userAgent);
    $4aa2e74cf8171e1c$var$result.mac = /Mac/.test(navigator.platform);
    var $4aa2e74cf8171e1c$var$ie = $4aa2e74cf8171e1c$var$result.ie = !!($4aa2e74cf8171e1c$var$ieUpTo10 || $4aa2e74cf8171e1c$var$ie11up || $4aa2e74cf8171e1c$var$ieEdge);
    $4aa2e74cf8171e1c$var$result.ie_version = $4aa2e74cf8171e1c$var$ieUpTo10 ? document.documentMode || 6 : $4aa2e74cf8171e1c$var$ie11up ? +$4aa2e74cf8171e1c$var$ie11up[1] : $4aa2e74cf8171e1c$var$ieEdge ? +$4aa2e74cf8171e1c$var$ieEdge[1] : null;
    $4aa2e74cf8171e1c$var$result.gecko = !$4aa2e74cf8171e1c$var$ie && /gecko\/\d/i.test(navigator.userAgent);
    $4aa2e74cf8171e1c$var$result.chrome = !$4aa2e74cf8171e1c$var$ie && /Chrome\//.test(navigator.userAgent);
    $4aa2e74cf8171e1c$var$result.chrome_version = parseInt((navigator.userAgent.match(/Chrome\/(\d+)/) || [])[1], 10);
    $4aa2e74cf8171e1c$var$result.android = /Android \d/.test(navigator.userAgent);
    $4aa2e74cf8171e1c$var$result.ios = !$4aa2e74cf8171e1c$var$ie && /AppleWebKit/.test(navigator.userAgent) && /Mobile\/\w+/.test(navigator.userAgent);
    $4aa2e74cf8171e1c$var$result.webkit = !$4aa2e74cf8171e1c$var$ie && !!document.documentElement && 'WebkitAppearance' in document.documentElement.style;
    $4aa2e74cf8171e1c$var$result.safari = Boolean(navigator.vendor && navigator.vendor.indexOf('Apple') > -1 && navigator.userAgent && navigator.userAgent.indexOf('CriOS') === -1 && navigator.userAgent.indexOf('FxiOS') === -1);
    $4aa2e74cf8171e1c$var$result.supportsIntersectionObserver = typeof window !== 'undefined' && 'IntersectionObserver' in window && 'IntersectionObserverEntry' in window && 'intersectionRatio' in window.IntersectionObserverEntry.prototype;
    $4aa2e74cf8171e1c$var$result.supportsResizeObserver = typeof window !== 'undefined' && 'ResizeObserver' in window && 'ResizeObserverEntry' in window;
}
function $4aa2e74cf8171e1c$export$3f2684e5d7cb1006() {
    return $4aa2e74cf8171e1c$var$result;
}

});

parcelRegister("9GB8v", function(module, exports) {
$parcel$export(module.exports, "functionWithCondition", () => $70d4d7cacf1d46e2$export$af3c0e82a18fc057);
$parcel$export(module.exports, "functionUnionWithCondition", () => $70d4d7cacf1d46e2$export$c41c28c1d883fcd5);
/**
 * Returns one of functions depending on a boolean condition.
 * Both functions should have the same signature.
 * @see {@link functionUnionWithCondition} for functions with different return types
 */ function $70d4d7cacf1d46e2$export$af3c0e82a18fc057(condition, functionTrue, functionFalse) {
    var fnWithCondition = function fnWithCondition() {
        return condition() ? functionTrue.apply(void 0, arguments) : functionFalse.apply(void 0, arguments);
    };
    // Improvement: set name on a function. Requires external helper, not required for production
    return fnWithCondition;
}
function $70d4d7cacf1d46e2$export$c41c28c1d883fcd5(condition, functionTrue, functionFalse) {
    // @ts-expect-error TS2345: Argument of type '(...args: C) => R2' is not assignable to parameter of type '(...args: C) => R1'.
    return $70d4d7cacf1d46e2$export$af3c0e82a18fc057(condition, functionTrue, functionFalse);
}

});

parcelRegister("2hUC0", function(module, exports) {
$parcel$export(module.exports, "useLinkClicked", () => $1aa9153f316b7a97$export$5993d3ca6c85f774);
$parcel$export(module.exports, "useMouseDownEvent", () => $1aa9153f316b7a97$export$df67f318ded0283c);

var $5FkrB = parcelRequire("5FkrB");

var $cOsWw = parcelRequire("cOsWw");

var $5bCL3 = parcelRequire("5bCL3");
var $1aa9153f316b7a97$export$81a5b494baf0f17c = /*#__PURE__*/ function(ClickButton) {
    ClickButton[ClickButton["Left"] = 0] = "Left";
    ClickButton[ClickButton["Middle"] = 1] = "Middle";
    ClickButton[ClickButton["Right"] = 2] = "Right";
    return ClickButton;
}({});
var $1aa9153f316b7a97$export$5993d3ca6c85f774 = function useLinkClicked(handler, predicate) {
    var _useAnalyticsEvents = (0, $cOsWw.useAnalyticsEvents)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
    return (0, $5FkrB.useCallback)(function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var event = args[0];
        handler === null || handler === void 0 || handler.apply(null, args);
        if (!predicate || predicate !== null && predicate !== void 0 && predicate(event)) (0, $5bCL3.fireLinkClickedEvent)(createAnalyticsEvent)(event);
    }, [
        handler,
        predicate,
        createAnalyticsEvent
    ]);
};
var $1aa9153f316b7a97$var$isNotLeftClick = function isNotLeftClick(event) {
    return event.button !== 0;
};
var $1aa9153f316b7a97$export$df67f318ded0283c = function useMouseDownEvent(onMouseDown) {
    return $1aa9153f316b7a97$export$5993d3ca6c85f774(onMouseDown, $1aa9153f316b7a97$var$isNotLeftClick);
};

});

parcelRegister("8ckEN", function(module, exports) {
$parcel$export(module.exports, "ANALYTICS_CHANNEL", () => $5f7f77cabcf8cd3d$export$85183a312807388d);
$parcel$export(module.exports, "context", () => $5f7f77cabcf8cd3d$export$a078c61943f9dbbe);
$parcel$export(module.exports, "TrackQuickActionType", () => $5f7f77cabcf8cd3d$export$72af824fa910c33e);
$parcel$export(module.exports, "TrackQuickActionFailureReason", () => $5f7f77cabcf8cd3d$export$c89e475f7f7174c2);
$parcel$export(module.exports, "SmartLinkEvents", () => $5f7f77cabcf8cd3d$export$b91e0203b928470c);

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");
var $5f7f77cabcf8cd3d$export$85183a312807388d = 'media';
var $5f7f77cabcf8cd3d$export$a078c61943f9dbbe = {
    componentName: 'smart-cards',
    packageName: "@atlaskit/smart-card",
    packageVersion: "43.12.3"
};
var $5f7f77cabcf8cd3d$export$72af824fa910c33e = /*#__PURE__*/ function(TrackQuickActionType) {
    TrackQuickActionType["StatusUpdate"] = "StatusUpdate";
    return TrackQuickActionType;
}({});
var $5f7f77cabcf8cd3d$export$c89e475f7f7174c2 = /*#__PURE__*/ function(TrackQuickActionFailureReason) {
    TrackQuickActionFailureReason["PermissionError"] = "PermissionError";
    TrackQuickActionFailureReason["ValidationError"] = "ValidationError";
    TrackQuickActionFailureReason["UnknownError"] = "UnknownError";
    return TrackQuickActionFailureReason;
}({});
var $5f7f77cabcf8cd3d$export$b91e0203b928470c = /*#__PURE__*/ function() {
    function SmartLinkEvents() {
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, SmartLinkEvents);
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(SmartLinkEvents, [
        {
            key: "insertSmartLink",
            value: function insertSmartLink(url, type, createAnalyticsEvent) {
                $5f7f77cabcf8cd3d$export$2a123f7ee48a122c({
                    action: 'inserted',
                    actionSubject: 'smartLink',
                    eventType: 'track',
                    attributes: {
                        type: type
                    },
                    nonPrivacySafeAttributes: {
                        domainName: url
                    }
                }, createAnalyticsEvent);
            }
        }
    ]);
}();
var $5f7f77cabcf8cd3d$export$2a123f7ee48a122c = function fireSmartLinkEvent(payload, createAnalyticsEvent) {
    if (createAnalyticsEvent) createAnalyticsEvent(payload).fire($5f7f77cabcf8cd3d$export$85183a312807388d);
};

});


parcelRegister("3spbj", function(module, exports) {

(function(global, factory) {
    factory(module.exports, (parcelRequire("5FkrB")));
})(module.exports, function(exports1, React) {
    'use strict';
    function _interopNamespace(e) {
        if (e && e.__esModule) return e;
        var n = Object.create(null);
        if (e) Object.keys(e).forEach(function(k) {
            if (k !== 'default') {
                var d = Object.getOwnPropertyDescriptor(e, k);
                Object.defineProperty(n, k, d.get ? d : {
                    enumerable: true,
                    get: function() {
                        return e[k];
                    }
                });
            }
        });
        n["default"] = e;
        return Object.freeze(n);
    }
    var React__namespace = /*#__PURE__*/ _interopNamespace(React);
    function _setPrototypeOf(o, p) {
        _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
            o.__proto__ = p;
            return o;
        };
        return _setPrototypeOf(o, p);
    }
    function _inheritsLoose(subClass, superClass) {
        subClass.prototype = Object.create(superClass.prototype);
        subClass.prototype.constructor = subClass;
        _setPrototypeOf(subClass, superClass);
    }
    var changedArray = function changedArray(a, b) {
        if (a === void 0) a = [];
        if (b === void 0) b = [];
        return a.length !== b.length || a.some(function(item, index) {
            return !Object.is(item, b[index]);
        });
    };
    var initialState = {
        error: null
    };
    var ErrorBoundary = /*#__PURE__*/ function(_React$Component) {
        _inheritsLoose(ErrorBoundary, _React$Component);
        function ErrorBoundary() {
            var _this;
            for(var _len = arguments.length, _args = new Array(_len), _key = 0; _key < _len; _key++)_args[_key] = arguments[_key];
            _this = _React$Component.call.apply(_React$Component, [
                this
            ].concat(_args)) || this;
            _this.state = initialState;
            _this.resetErrorBoundary = function() {
                var _this$props;
                for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
                _this.props.onReset == null || (_this$props = _this.props).onReset.apply(_this$props, args);
                _this.reset();
            };
            return _this;
        }
        ErrorBoundary.getDerivedStateFromError = function getDerivedStateFromError(error) {
            return {
                error: error
            };
        };
        var _proto = ErrorBoundary.prototype;
        _proto.reset = function reset() {
            this.setState(initialState);
        };
        _proto.componentDidCatch = function componentDidCatch(error, info) {
            var _this$props$onError, _this$props2;
            (_this$props$onError = (_this$props2 = this.props).onError) == null || _this$props$onError.call(_this$props2, error, info);
        };
        _proto.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
            var error = this.state.error;
            var resetKeys = this.props.resetKeys; // There's an edge case where if the thing that triggered the error
            // happens to *also* be in the resetKeys array, we'd end up resetting
            // the error boundary immediately. This would likely trigger a second
            // error to be thrown.
            // So we make sure that we don't check the resetKeys on the first call
            // of cDU after the error is set
            if (error !== null && prevState.error !== null && changedArray(prevProps.resetKeys, resetKeys)) {
                var _this$props$onResetKe, _this$props3;
                (_this$props$onResetKe = (_this$props3 = this.props).onResetKeysChange) == null || _this$props$onResetKe.call(_this$props3, prevProps.resetKeys, resetKeys);
                this.reset();
            }
        };
        _proto.render = function render() {
            var error = this.state.error;
            var _this$props4 = this.props, fallbackRender = _this$props4.fallbackRender, FallbackComponent = _this$props4.FallbackComponent, fallback = _this$props4.fallback;
            if (error !== null) {
                var _props = {
                    error: error,
                    resetErrorBoundary: this.resetErrorBoundary
                };
                if (/*#__PURE__*/ React__namespace.isValidElement(fallback)) return fallback;
                else if (typeof fallbackRender === 'function') return fallbackRender(_props);
                else if (FallbackComponent) return /*#__PURE__*/ React__namespace.createElement(FallbackComponent, _props);
                else throw new Error('react-error-boundary requires either a fallback, fallbackRender, or FallbackComponent prop');
            }
            return this.props.children;
        };
        return ErrorBoundary;
    }(React__namespace.Component);
    function withErrorBoundary(Component, errorBoundaryProps) {
        var Wrapped = function Wrapped(props) {
            return /*#__PURE__*/ React__namespace.createElement(ErrorBoundary, errorBoundaryProps, /*#__PURE__*/ React__namespace.createElement(Component, props));
        }; // Format for display in DevTools
        var name = Component.displayName || Component.name || 'Unknown';
        Wrapped.displayName = "withErrorBoundary(" + name + ")";
        return Wrapped;
    }
    function useErrorHandler(givenError) {
        var _React$useState = React__namespace.useState(null), error = _React$useState[0], setError = _React$useState[1];
        if (givenError != null) throw givenError;
        if (error != null) throw error;
        return setError;
    }
    /*
  eslint
    @typescript-eslint/sort-type-union-intersection-members: "off",
    @typescript-eslint/no-throw-literal: "off",
    @typescript-eslint/prefer-nullish-coalescing: "off"
  */ exports1.ErrorBoundary = ErrorBoundary;
    exports1.useErrorHandler = useErrorHandler;
    exports1.withErrorBoundary = withErrorBoundary;
    Object.defineProperty(exports1, '__esModule', {
        value: true
    });
});

});

parcelRegister("jPneb", function(module, exports) {
$parcel$export(module.exports, "extractSmartLinkTitle", () => $e6f4cc4d8f4b06b2$export$3eda18658b66108);
$parcel$export(module.exports, "extractSmartLinkUrl", () => $e6f4cc4d8f4b06b2$export$7ba9b12c6a1b73de);
$parcel$export(module.exports, "extractSmartLinkAri", () => $e6f4cc4d8f4b06b2$export$16b02be3e2bb31ad);
$parcel$export(module.exports, "extractSmartLinkEmbed", () => $e6f4cc4d8f4b06b2$export$864b719baf5d744d);
$parcel$export(module.exports, "extractSmartLinkProvider", () => $e6f4cc4d8f4b06b2$export$ff753ed519e96e9e);
$parcel$export(module.exports, "extractSmartLinkCreatedOn", () => $e6f4cc4d8f4b06b2$export$7a685df468cbf38f);
$parcel$export(module.exports, "extractSmartLinkModifiedOn", () => $e6f4cc4d8f4b06b2$export$75047940e157fd1f);
$parcel$export(module.exports, "extractSmartLinkCreatedBy", () => $e6f4cc4d8f4b06b2$export$242875b46118beb2);
$parcel$export(module.exports, "extractSmartLinkAuthorGroup", () => $e6f4cc4d8f4b06b2$export$41fc716e1bc2dc90);
$parcel$export(module.exports, "extractSmartLinkModifiedBy", () => $e6f4cc4d8f4b06b2$export$7f099a839071a190);
$parcel$export(module.exports, "extractSmartLinkDownloadUrl", () => $e6f4cc4d8f4b06b2$export$96ed4c1b14ac210a);

var $blDi2 = parcelRequire("blDi2");
var $a70Fy = parcelRequire("a70Fy");
var $eDQvD = parcelRequire("eDQvD");
var $icEYt = parcelRequire("icEYt");
var $jEgUY = parcelRequire("jEgUY");
var $gyOtX = parcelRequire("gyOtX");
var $h28De = parcelRequire("h28De");
var $DzZhj = parcelRequire("DzZhj");

var $r1O4b = parcelRequire("r1O4b");

var $33An2 = parcelRequire("33An2");
var $e6f4cc4d8f4b06b2$export$3eda18658b66108 = function extractSmartLinkTitle(response, removeTextHighlightingFromTitle) {
    if ((0, $33An2.isEntityPresent)(response)) {
        var _extractEntity;
        return (_extractEntity = (0, $33An2.extractEntity)(response)) === null || _extractEntity === void 0 ? void 0 : _extractEntity.displayName;
    }
    return (0, $DzZhj.extractTitle)(response === null || response === void 0 ? void 0 : response.data, removeTextHighlightingFromTitle);
};
var $e6f4cc4d8f4b06b2$export$7ba9b12c6a1b73de = function extractSmartLinkUrl(response) {
    if ((0, $33An2.isEntityPresent)(response)) {
        var _extractEntity2;
        return (_extractEntity2 = (0, $33An2.extractEntity)(response)) === null || _extractEntity2 === void 0 ? void 0 : _extractEntity2.url;
    }
    return (0, $icEYt.extractLink)(response === null || response === void 0 ? void 0 : response.data);
};
var $e6f4cc4d8f4b06b2$export$16b02be3e2bb31ad = function extractSmartLinkAri(response) {
    if ((0, $33An2.isEntityPresent)(response)) {
        var _extractEntity3, _extractEntity4;
        return ((_extractEntity3 = (0, $33An2.extractEntity)(response)) === null || _extractEntity3 === void 0 ? void 0 : _extractEntity3.ari) || ((_extractEntity4 = (0, $33An2.extractEntity)(response)) === null || _extractEntity4 === void 0 ? void 0 : _extractEntity4.thirdPartyAri);
    }
    var data = response === null || response === void 0 ? void 0 : response.data;
    return (0, $blDi2.extractAri)(data);
};
var $e6f4cc4d8f4b06b2$export$864b719baf5d744d = function extractSmartLinkEmbed(response, iframeUrlType) {
    if ((0, $33An2.isEntityPresent)(response)) {
        // TODO: Missing iframeUrlType
        var embedUrl = (0, $33An2.extractEntityEmbedUrl)(response);
        return embedUrl ? {
            src: embedUrl
        } : undefined;
    }
    return (0, $r1O4b.extractPreview)(response === null || response === void 0 ? void 0 : response.data, 'web', iframeUrlType);
};
var $e6f4cc4d8f4b06b2$export$ff753ed519e96e9e = function extractSmartLinkProvider(response) {
    if ((0, $33An2.isEntityPresent)(response)) return (0, $33An2.extractEntityProvider)(response);
    return (response === null || response === void 0 ? void 0 : response.data) && (0, $h28De.extractProvider)(response === null || response === void 0 ? void 0 : response.data);
};
var $e6f4cc4d8f4b06b2$export$7a685df468cbf38f = function extractSmartLinkCreatedOn(response) {
    if ((0, $33An2.isEntityPresent)(response)) {
        var _extractEntity5;
        return (_extractEntity5 = (0, $33An2.extractEntity)(response)) === null || _extractEntity5 === void 0 ? void 0 : _extractEntity5.createdAt;
    }
    return (response === null || response === void 0 ? void 0 : response.data) && (0, $a70Fy.extractDateCreated)(response.data);
};
var $e6f4cc4d8f4b06b2$export$75047940e157fd1f = function extractSmartLinkModifiedOn(response) {
    if ((0, $33An2.isEntityPresent)(response)) {
        var _extractEntity6;
        return (_extractEntity6 = (0, $33An2.extractEntity)(response)) === null || _extractEntity6 === void 0 ? void 0 : _extractEntity6.lastUpdatedAt;
    }
    return (response === null || response === void 0 ? void 0 : response.data) && (0, $eDQvD.extractDateUpdated)(response.data);
};
var $e6f4cc4d8f4b06b2$export$242875b46118beb2 = function extractSmartLinkCreatedBy(response) {
    if (!response || !response.data) return undefined;
    if ((0, $33An2.isEntityPresent)(response)) {
        var _extractEntity7;
        return (_extractEntity7 = (0, $33An2.extractEntity)(response)) === null || _extractEntity7 === void 0 || (_extractEntity7 = _extractEntity7.createdBy) === null || _extractEntity7 === void 0 ? void 0 : _extractEntity7.displayName;
    }
    var persons = (0, $jEgUY.extractPersonCreatedBy)(response.data);
    return !!(persons !== null && persons !== void 0 && persons.length) ? persons[0].name : undefined;
};
var $e6f4cc4d8f4b06b2$export$41fc716e1bc2dc90 = function extractSmartLinkAuthorGroup(response) {
    if (!response || !response.data) return undefined;
    if ((0, $33An2.isEntityPresent)(response)) {
        var entity = (0, $33An2.extractEntity)(response);
        var owners = entity === null || entity === void 0 ? void 0 : entity.owners;
        if (owners) return owners.map(function(owner) {
            return {
                name: owner.displayName,
                src: owner.picture
            };
        }).filter(function(item) {
            return !!item;
        });
    }
    return (0, $jEgUY.extractPersonCreatedBy)(response.data);
};
var $e6f4cc4d8f4b06b2$export$7f099a839071a190 = function extractSmartLinkModifiedBy(response) {
    if (!response || !response.data) return undefined;
    if ((0, $33An2.isEntityPresent)(response)) {
        var _extractEntity8;
        return (_extractEntity8 = (0, $33An2.extractEntity)(response)) === null || _extractEntity8 === void 0 || (_extractEntity8 = _extractEntity8.lastUpdatedBy) === null || _extractEntity8 === void 0 ? void 0 : _extractEntity8.displayName;
    }
    var person = (0, $gyOtX.extractPersonUpdatedBy)(response.data);
    return person ? person.name : undefined;
};
var $e6f4cc4d8f4b06b2$export$96ed4c1b14ac210a = function extractSmartLinkDownloadUrl(response) {
    var _response$data;
    if ((0, $33An2.isEntityPresent)(response)) {
        var _entity$exportLinks;
        var entity = (0, $33An2.extractEntity)(response);
        return entity && 'exportLinks' in entity && Array.isArray(entity.exportLinks) && entity.exportLinks.length > 0 ? entity === null || entity === void 0 || (_entity$exportLinks = entity.exportLinks) === null || _entity$exportLinks === void 0 ? void 0 : _entity$exportLinks[0].url : undefined;
    }
    return response === null || response === void 0 || (_response$data = response.data) === null || _response$data === void 0 ? void 0 : _response$data['atlassian:downloadUrl'];
};

});
parcelRegister("blDi2", function(module, exports) {
$parcel$export(module.exports, "extractAri", () => $84302206313a833a$export$be18a6294fd426ec);
var $84302206313a833a$export$be18a6294fd426ec = function extractAri(jsonLd) {
    if (jsonLd['atlassian:ari']) return jsonLd['atlassian:ari'];
    return undefined;
};

});

parcelRegister("a70Fy", function(module, exports) {
$parcel$export(module.exports, "extractDateCreated", () => $75cb13beb06ad216$export$e1226a5e0bbbf862);
var $75cb13beb06ad216$export$e1226a5e0bbbf862 = function extractDateCreated(jsonLd) {
    if (jsonLd['schema:dateCreated']) return jsonLd['schema:dateCreated'];
    return undefined;
};

});

parcelRegister("eDQvD", function(module, exports) {
$parcel$export(module.exports, "extractDateUpdated", () => $aa8d70784b84beeb$export$7fc2f5e6f9d22ae7);
var $aa8d70784b84beeb$export$7fc2f5e6f9d22ae7 = function extractDateUpdated(jsonLd) {
    if (jsonLd.updated) return jsonLd.updated;
    return undefined;
};

});

parcelRegister("icEYt", function(module, exports) {
$parcel$export(module.exports, "extractLink", () => $d40921a916e5c78f$export$63f54cf4c5883620);

var $k2wEH = parcelRequire("k2wEH");
var $d40921a916e5c78f$export$63f54cf4c5883620 = function extractLink(jsonLd) {
    var url = jsonLd === null || jsonLd === void 0 ? void 0 : jsonLd.url;
    if (url) {
        if (typeof url === 'string') return url;
        else return (0, $k2wEH.extractUrlFromLinkJsonLd)(url);
    }
    return undefined;
};

});
parcelRegister("k2wEH", function(module, exports) {
$parcel$export(module.exports, "extractUrlFromLinkJsonLd", () => $e96d533c532bb790$export$396ba4ef2e37dc65);
/**
 * Extracts the URL from a JSON-LD Link object or array of link objects.
 *
 * If the link is a string, it is assumed to be a URL and is returned as is.
 * If the link is an array, returns the URL in the first link object.
 * Otherwise the href property is returned.
 *
 * @param link - The JSON-LD link object or array of link objects.
 * @returns URL string if one is found, otherwise undefined.
 */ var $e96d533c532bb790$export$396ba4ef2e37dc65 = function extractUrlFromLinkJsonLd(link) {
    if (typeof link === 'string') return link;
    else if (Array.isArray(link)) {
        if (link.length > 0) return $e96d533c532bb790$export$396ba4ef2e37dc65(link[0]);
    } else return link.href;
    return undefined;
};

});


parcelRegister("jEgUY", function(module, exports) {
$parcel$export(module.exports, "extractPersonCreatedBy", () => $e4dee05021dbc039$export$a66235cba0c9d11a);

var $2Hwhh = parcelRequire("2Hwhh");
var $e4dee05021dbc039$export$a66235cba0c9d11a = function extractPersonCreatedBy(jsonLd) {
    var attributedTo = jsonLd.attributedTo;
    if (attributedTo) {
        if (Array.isArray(attributedTo)) return attributedTo.map((0, $2Hwhh.extractPersonFromJsonLd)).filter(function(item) {
            return !!item;
        });
        else {
            var item = (0, $2Hwhh.extractPersonFromJsonLd)(attributedTo);
            if (item) return [
                item
            ];
        }
    }
    return undefined;
};

});
parcelRegister("2Hwhh", function(module, exports) {
$parcel$export(module.exports, "extractPersonFromJsonLd", () => $1f78a2986f60d4b4$export$c471ae5fddcf1392);

var $ab6GS = parcelRequire("ab6GS");
var $1f78a2986f60d4b4$export$c471ae5fddcf1392 = function extractPersonFromJsonLd(person) {
    if (typeof person === 'string') throw Error('Link.person needs to be an object.');
    else if (person['@type'] === 'Link') {
        if (person.name) return {
            name: person.name
        };
    } else {
        if (person.name) return {
            name: person.name,
            src: person.icon && (0, $ab6GS.extractUrlFromIconJsonLd)(person.icon)
        };
    }
    return undefined;
};

});
parcelRegister("ab6GS", function(module, exports) {
$parcel$export(module.exports, "extractUrlFromIconJsonLd", () => $76901f0efd43e037$export$67f3d92c824fd850);

var $k2wEH = parcelRequire("k2wEH");
var $76901f0efd43e037$export$67f3d92c824fd850 = function extractUrlFromIconJsonLd(icon) {
    if (typeof icon === 'string') return icon;
    else if (icon['@type'] === 'Link') return (0, $k2wEH.extractUrlFromLinkJsonLd)(icon);
    else {
        if (icon.url) return (0, $k2wEH.extractUrlFromLinkJsonLd)(icon.url);
    }
    return undefined;
};

});



parcelRegister("gyOtX", function(module, exports) {
$parcel$export(module.exports, "extractPersonUpdatedBy", () => $c0e6fb035ac6cc5f$export$8a2d1ed7e6f336f0);

var $2Hwhh = parcelRequire("2Hwhh");
var $c0e6fb035ac6cc5f$export$8a2d1ed7e6f336f0 = function extractPersonUpdatedBy(jsonLd) {
    var updatedBy = jsonLd['atlassian:updatedBy'];
    if (updatedBy) return (0, $2Hwhh.extractPersonFromJsonLd)(updatedBy);
    return undefined;
};

});

parcelRegister("h28De", function(module, exports) {
$parcel$export(module.exports, "extractProvider", () => $c66951a59fc810b5$export$a832871718466647);
$parcel$export(module.exports, "extractProviderIcon", () => $c66951a59fc810b5$export$6fb636a2ac885215);
$parcel$export(module.exports, "isConfluenceGenerator", () => $c66951a59fc810b5$export$38df542ff03a4183);

var $kqp0i = parcelRequire("kqp0i");

var $5FkrB = parcelRequire("5FkrB");

var $bSdlY = parcelRequire("bSdlY");

var $8Tu2m = parcelRequire("8Tu2m");

var $9Zzpd = parcelRequire("9Zzpd");

var $i6ESA = parcelRequire("i6ESA");

var $ab6GS = parcelRequire("ab6GS");
var $k2wEH = parcelRequire("k2wEH");
var $c66951a59fc810b5$export$a832871718466647 = function extractProvider(jsonLd) {
    var generator = jsonLd.generator;
    if (generator) {
        if (typeof generator === 'string') throw Error('Link.generator requires a name and icon.');
        else if (generator['@type'] === 'Link') {
            if (generator.name) return {
                text: generator.name
            };
        } else if (generator.name) {
            var id = generator['@id'];
            return {
                text: generator.name,
                icon: $c66951a59fc810b5$export$6fb636a2ac885215(generator.icon, id),
                id: id,
                image: $c66951a59fc810b5$var$extractProviderImage(generator.image)
            };
        }
    }
    return undefined;
};
var $c66951a59fc810b5$export$6fb636a2ac885215 = function extractProviderIcon(icon, id) {
    if (id) {
        if (id === (0, $i6ESA.CONFLUENCE_GENERATOR_ID)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $bSdlY.ConfluenceIcon), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
            appearance: "brand",
            size: "xxsmall"
        }, (0, $9Zzpd.fg)('navx-1895-new-logo-design') ? {
            shouldUseNewLogoDesign: true
        } : undefined));
        else if (id === (0, $i6ESA.JIRA_GENERATOR_ID)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $8Tu2m.JiraIcon), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
            appearance: "brand",
            size: "xxsmall"
        }, (0, $9Zzpd.fg)('navx-1895-new-logo-design') ? {
            shouldUseNewLogoDesign: true
        } : undefined));
    }
    if (icon) return (0, $ab6GS.extractUrlFromIconJsonLd)(icon);
    return undefined;
};
var $c66951a59fc810b5$var$extractProviderImage = function extractProviderImage(image) {
    if (image) {
        if (typeof image === 'string') return image;
        else if (image['@type'] === 'Link') return (0, $k2wEH.extractUrlFromLinkJsonLd)(image);
        else if (image['@type'] === 'Image') {
            if (image.url) return (0, $k2wEH.extractUrlFromLinkJsonLd)(image.url);
        }
    }
    return undefined;
};
var $c66951a59fc810b5$export$38df542ff03a4183 = function isConfluenceGenerator(id) {
    return id === (0, $i6ESA.CONFLUENCE_GENERATOR_ID);
};

});
parcelRegister("bSdlY", function(module, exports) {
$parcel$export(module.exports, "ConfluenceIcon", () => $8a4f188b8603afcf$export$68f3db7f6af48bcb);

var $gicOj = parcelRequire("gicOj");

var $dvJw4 = parcelRequire("dvJw4");

var $8VIvt = parcelRequire("8VIvt");
/**
 * __Confluence icon__
 *
 * The Confluence icon without an accompanying wordmark.
 *
 * - [Examples](https://atlassian.design/components/logo/examples)
 * - [Code](https://atlassian.design/components/logo/code)
 * - [Usage](https://atlassian.design/components/logo/usage)
 */ var $8a4f188b8603afcf$export$68f3db7f6af48bcb = (0, $8VIvt.createFeatureFlaggedComponent)((0, $dvJw4.ConfluenceIcon), (0, $gicOj.ConfluenceIcon));

});
parcelRegister("gicOj", function(module, exports) {
$parcel$export(module.exports, "ConfluenceIcon", () => $bdc843aa064a2764$export$68f3db7f6af48bcb);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2264fa822c5f74cedf4229a8911c73b4>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

var $6S9Aj = parcelRequire("6S9Aj");
// `height` is set to 100% to allow the SVG to scale with the parent element
var $bdc843aa064a2764$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#1868db)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, white)\" d=\"M17.888 14.461c-4.039-1.953-5.219-2.245-6.92-2.245-1.997 0-3.699.831-5.219 3.165l-.25.382c-.204.314-.249.426-.249.561s.068.247.318.404l2.564 1.594c.136.09.25.135.363.135.136 0 .226-.068.363-.27l.408-.628c.635-.966 1.203-1.28 1.928-1.28.636 0 1.385.18 2.315.629l2.677 1.257c.272.134.567.067.704-.247l1.27-2.783c.136-.315.046-.517-.272-.674M6.112 9.545c4.039 1.953 5.219 2.245 6.92 2.245 1.997 0 3.699-.83 5.219-3.165l.25-.381c.204-.315.249-.427.249-.562 0-.134-.068-.247-.318-.404L15.87 5.685c-.137-.09-.25-.135-.364-.135-.136 0-.226.067-.363.27l-.408.628c-.635.965-1.203 1.28-1.928 1.28-.636 0-1.385-.18-2.315-.63L7.814 5.843c-.272-.135-.567-.068-.703.247L5.84 8.872c-.136.314-.045.516.272.673\"/>\n</svg>\n";
var $bdc843aa064a2764$var$customThemeSvg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--themed-icon-color, currentcolor)\" d=\"M18 0a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6V6a6 6 0 0 1 6-6zm-7.032 12.217c-1.997 0-3.699.83-5.219 3.165l-.249.38c-.204.315-.25.427-.25.562s.068.247.317.404l2.565 1.594c.136.09.249.135.362.135.136 0 .227-.068.363-.27l.409-.628c.635-.966 1.202-1.28 1.928-1.28.636 0 1.384.18 2.315.63l2.677 1.256c.273.134.568.067.704-.247l1.27-2.783c.136-.315.045-.517-.272-.674-4.039-1.953-5.219-2.244-6.92-2.244m4.538-6.667c-.136 0-.227.067-.363.27l-.409.628c-.635.965-1.202 1.28-1.928 1.28-.636 0-1.384-.18-2.315-.63L7.813 5.843c-.272-.135-.567-.067-.703.247L5.84 8.872c-.136.314-.045.517.272.674 4.039 1.953 5.219 2.244 6.92 2.244 1.997 0 3.699-.83 5.219-3.165l.249-.382c.204-.314.25-.426.25-.56s-.068-.248-.317-.405l-2.565-1.593c-.136-.09-.249-.135-.362-.135\"/>\n</svg>\n";
function $bdc843aa064a2764$export$68f3db7f6af48bcb(_ref) {
    var iconColor = _ref.iconColor, size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Confluence' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $6S9Aj.IconWrapper), {
        svg: $bdc843aa064a2764$var$svg,
        customThemeSvg: $bdc843aa064a2764$var$customThemeSvg,
        iconColor: iconColor,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});
parcelRegister("6S9Aj", function(module, exports) {
$parcel$export(module.exports, "IconWrapper", () => $500f388d46ad0b51$export$be58b4326e23250f);
/* icon-wrapper.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $5FkrB = parcelRequire("5FkrB");

var $5EqJ2 = parcelRequire("5EqJ2");

var $9Zzpd = parcelRequire("9Zzpd");

var $8zwGK = parcelRequire("8zwGK");
var $500f388d46ad0b51$var$styles = {
    root: "_1e0c1o8l",
    TEMP_assets: "_9aea1fkg"
};
/* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ var $500f388d46ad0b51$var$cloudLightAppearanceMap = {
    brand: "_1b3i18uv _9aea18uv",
    neutral: "_1b3i1e01 _9aea1fkg",
    inverse: "_1b3i5a6q _9aeau67f",
    legacy: "_1b3iu67f _9aeadoyu"
};
/* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ var $500f388d46ad0b51$var$cloudDarkAppearanceMap = {
    brand: "_1b3i18uv _9aea18uv",
    neutral: "_1b3i1gvk _9aea8hz0",
    inverse: "_1b3iu67f _9aea5a6q",
    legacy: "_1b3iu67f _9aeadoyu"
};
/* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ var $500f388d46ad0b51$var$dataCenterLightAppearanceMap = {
    brand: "_1b3idoyu _9aeau67f _3wu01fkg",
    neutral: "_1b3i1e01 _9aea1fkg _3wu01e01",
    inverse: "_1b3iu67f _9aeaqlpt _3wu0u67f",
    legacy: "_1b3idoyu _9aeau67f _3wu01fkg"
};
/* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ var $500f388d46ad0b51$var$dataCenterDarkAppearanceMap = {
    brand: "_1b3idoyu _9aeaqlpt _3wu08hz0",
    neutral: "_1b3i1gvk _9aea8hz0 _3wu01gvk",
    inverse: "_1b3i1501 _9aeau67f _3wu01501",
    legacy: "_1b3idoyu _9aeaqlpt _3wu08hz0"
};
var $500f388d46ad0b51$var$rovoDarkAppearanceMap = {
    brand: "_170318uv _1evo18uv _epb518uv _1osd18uv",
    neutral: "_17031gvk _1evo1gvk _epb51gvk _1osd1gvk",
    inverse: "_1703qlpt _1evoqlpt _epb5qlpt _1osdqlpt",
    legacy: "_1703doyu _1evodoyu _epb5doyu _1osddoyu"
};
var $500f388d46ad0b51$var$rovoLightAppearanceMap = {
    brand: "_170318uv _1evo18uv _epb518uv _1osd18uv",
    neutral: "_17031e01 _1evo1e01 _epb51e01 _1osd1e01",
    inverse: "_1703u67f _1evou67f _epb5u67f _1osdu67f",
    legacy: "_1703doyu _1evodoyu _epb5doyu _1osddoyu"
};
/* eslint-enable @atlaskit/ui-styling-standard/no-imported-style-values */ /* eslint-enable @atlaskit/ui-styling-standard/no-unsafe-values */ var $500f388d46ad0b51$var$sizeMap = {
    xxsmall: "_4t3i7vkz",
    xsmall: "_4t3igktf",
    small: "_4t3i1tcg",
    medium: "_4t3izwfg",
    large: "_4t3i1ylp",
    xlarge: "_4t3ickbl",
    '12': "_4t3i1crf",
    '16': "_4t3i7vkz",
    '20': "_4t3igktf",
    '24': "_4t3i1tcg",
    '32': "_4t3izwfg"
};
function $500f388d46ad0b51$export$be58b4326e23250f(_ref) {
    var _ref$size = _ref.size, size = _ref$size === void 0 ? '20' : _ref$size, label = _ref.label, svg = _ref.svg, customThemeSvg = _ref.customThemeSvg, userDefinedTestId = _ref.testId, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, customIconColor = _ref.iconColor, _ref$isAssets = _ref.isAssets, isAssets = _ref$isAssets === void 0 ? false : _ref$isAssets, _ref$type = _ref.type, type = _ref$type === void 0 ? 'tile' : _ref$type;
    var testId = userDefinedTestId && "".concat(userDefinedTestId, "--wrapper");
    var isCustomThemed = customThemeSvg && customIconColor;
    var _useThemeObserver = (0, $8zwGK.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ $5FkrB.createElement("span", {
        "data-testid": testId,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            '--themed-icon-color': customIconColor || 'initial'
        },
        "aria-label": label ? label : undefined,
        role: label ? 'img' : undefined,
        "aria-hidden": label === '' ? true : undefined,
        dangerouslySetInnerHTML: {
            __html: isCustomThemed ? customThemeSvg : svg
        },
        className: (0, $5EqJ2.default)([
            $500f388d46ad0b51$var$styles.root,
            $500f388d46ad0b51$var$sizeMap[size],
            colorMode === 'dark' ? $500f388d46ad0b51$var$dataCenterDarkAppearanceMap[appearance] : $500f388d46ad0b51$var$dataCenterLightAppearanceMap[appearance],
            type === 'rovo' ? colorMode === 'dark' ? $500f388d46ad0b51$var$rovoDarkAppearanceMap[appearance] : $500f388d46ad0b51$var$rovoLightAppearanceMap[appearance] : colorMode === 'dark' ? $500f388d46ad0b51$var$cloudDarkAppearanceMap[appearance] : $500f388d46ad0b51$var$cloudLightAppearanceMap[appearance],
            isAssets && appearance === 'brand' && (0, $9Zzpd.fg)('assets-platform-branding') && $500f388d46ad0b51$var$styles.TEMP_assets
        ])
    });
}

});
parcelRegister("5EqJ2", function(module, exports) {
$parcel$export(module.exports, "default", () => $41d56b45c222aa4c$export$2e2bcd8739ae039);
/**
 * This length includes the underscore,
 * e.g. `"_1s4A"` would be a valid atomic group hash.
 */ const $41d56b45c222aa4c$var$ATOMIC_GROUP_LENGTH = 5;
function $41d56b45c222aa4c$export$2e2bcd8739ae039(classNames) {
    // Shortcut: nothing to do
    if (!classNames.length) return;
    // Shortcut: don't need to do anything if we only have a single classname
    if (classNames.length === 1 && classNames[0] && // checking to see if `classNames[0]` is a string that contains other classnames
    !classNames[0].includes(' ')) return classNames[0];
    // Using an object rather than a `Map` as it performed better in our benchmarks.
    // Would be happy to move to `Map` if it proved to be better under real conditions.
    const map = {};
    // Note: using loops to minimize iterations over the collection
    for (const value of classNames){
        // Exclude all falsy values, which leaves us with populated strings
        if (!value) continue;
        // a `value` can contain multiple classnames
        const list = value.split(' ');
        for (const className of list){
            /**
             * For atomic style classnames: the `key` is the `group`
             *
             * - Later atomic classnames with the same `group` will override earlier ones
             *   (which is what we want).
             * - Assumes atomic classnames are the only things that start with `_`
             * - Could use a regex to ensure that atomic classnames are structured how we expect,
             *   but did not add that for now as it did slow things down a bit.
             *
             * For other classnames: the `key` is the whole classname
             * - Okay to remove duplicates as doing so does not impact specificity
             *
             * */ const key = className.startsWith('_') ? className.slice(0, $41d56b45c222aa4c$var$ATOMIC_GROUP_LENGTH) : className;
            map[key] = className;
        }
    }
    /**
     * We are converting the `map` into a string.
     *
     * The simple way to do this would be `Object.values(map).join(' ')`.
     * However, the approach below performs 10%-20% better in benchmarks.
     *
     * For `ax()` it feels right to squeeze as much runtime performance out as we can.
     */ let result = '';
    for(const key in map)result += map[key] + ' ';
    // If we have an empty string, then our `map` was empty.
    if (!result) return;
    // remove last " " from the result (we added " " at the end of every value)
    return result.trimEnd();
}

});

parcelRegister("8zwGK", function(module, exports) {
$parcel$export(module.exports, "default", () => $63daf2e22f0694ff$export$2e2bcd8739ae039);

var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");

var $40lAl = parcelRequire("40lAl");

var $lqtRB = parcelRequire("lqtRB");
/**
 * A React hook which returns the current themes and color-mode set on `<html>`.
 *
 * @example
 * ```
 * const { colorMode, dark, light, spacing, typography } = useThemeObserver();
 *
 * // Performing side effects when it changes
 * useEffect(() => {
 *   console.log(`The color mode has changed to ${theme.colorMode}`);
 * }, [theme.colorMode]);
 * ```
 */ var $63daf2e22f0694ff$var$useThemeObserver = function useThemeObserver() {
    var _useState = (0, $5FkrB.useState)((0, $40lAl.default)()), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), theme = _useState2[0], setTheme = _useState2[1];
    (0, $5FkrB.useEffect)(function() {
        var observer = new (0, $lqtRB.default)(function(theme) {
            return setTheme(theme);
        });
        observer.observe();
        return function() {
            return observer.disconnect();
        };
    }, []);
    return theme;
};
var $63daf2e22f0694ff$export$2e2bcd8739ae039 = $63daf2e22f0694ff$var$useThemeObserver;

});
parcelRegister("40lAl", function(module, exports) {
$parcel$export(module.exports, "default", () => $2ea7e7dd44a436b3$export$2e2bcd8739ae039);

var $25nEq = parcelRequire("25nEq");

var $bIz1q = parcelRequire("bIz1q");

var $hXZKI = parcelRequire("hXZKI");

var $3OmSh = parcelRequire("3OmSh");
function $2ea7e7dd44a436b3$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $2ea7e7dd44a436b3$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $2ea7e7dd44a436b3$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $2ea7e7dd44a436b3$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $2ea7e7dd44a436b3$var$isThemeColorMode = function isThemeColorMode(colorMode) {
    return (0, $hXZKI.themeColorModes).find(function(mode) {
        return mode === colorMode;
    }) !== undefined;
};
var $2ea7e7dd44a436b3$var$getGlobalTheme = function getGlobalTheme() {
    if (typeof document === 'undefined') return {};
    var element = document.documentElement;
    var colorMode = element.getAttribute((0, $bIz1q.COLOR_MODE_ATTRIBUTE)) || '';
    var theme = element.getAttribute((0, $bIz1q.THEME_DATA_ATTRIBUTE)) || '';
    return $2ea7e7dd44a436b3$var$_objectSpread($2ea7e7dd44a436b3$var$_objectSpread({}, (0, $3OmSh.themeStringToObject)(theme)), $2ea7e7dd44a436b3$var$isThemeColorMode(colorMode) && {
        colorMode: colorMode
    });
};
var $2ea7e7dd44a436b3$export$2e2bcd8739ae039 = $2ea7e7dd44a436b3$var$getGlobalTheme;

});
parcelRegister("bIz1q", function(module, exports) {
$parcel$export(module.exports, "THEME_DATA_ATTRIBUTE", () => $887ef8643b01f160$export$4ef52930e33717cd);
$parcel$export(module.exports, "COLOR_MODE_ATTRIBUTE", () => $887ef8643b01f160$export$a00eac3f8684bcd0);
var $887ef8643b01f160$export$4ef52930e33717cd = 'data-theme';
var $887ef8643b01f160$export$cb374d25ded7f6ab = 'data-subtree-theme';
var $887ef8643b01f160$export$a00eac3f8684bcd0 = 'data-color-mode';
var $887ef8643b01f160$export$2112803007239c61 = 'data-contrast-mode';
var $887ef8643b01f160$export$352e418ed5b6193a = 'data-custom-theme';
var $887ef8643b01f160$export$6f0c6fb8c80fcc92 = 'ds';
var $887ef8643b01f160$export$4d0c7bbf80185957 = [
    'opacity',
    'font',
    'space',
    'border',
    'radius'
];
var $887ef8643b01f160$export$dddac1532e822863 = "--".concat($887ef8643b01f160$export$6f0c6fb8c80fcc92, "-token-not-found");
var $887ef8643b01f160$export$9d7b58831ae93caa = "--".concat($887ef8643b01f160$export$6f0c6fb8c80fcc92, "-elevation-surface-current");

});

parcelRegister("hXZKI", function(module, exports) {
$parcel$export(module.exports, "themeColorModes", () => $d147d91e2e429476$export$83993de8eb66733);
$parcel$export(module.exports, "themeIds", () => $d147d91e2e429476$export$7d43e72a58e3283f);

var $9Zzpd = parcelRequire("9Zzpd");
var $d147d91e2e429476$export$83993de8eb66733 = [
    'light',
    'dark',
    'auto'
];
/**
 * Contrast preferences: The system contrast preference
 */ var $d147d91e2e429476$var$themeContrastModes = [
    'more',
    'no-preference',
    'auto'
];
var $d147d91e2e429476$export$7d43e72a58e3283f = [
    'light-increased-contrast',
    'light',
    'light-future',
    'dark',
    'dark-future',
    'dark-increased-contrast',
    'spacing',
    'shape',
    'typography',
    'motion'
];
/**
 * Theme override ids: the equivalent of themeIds for theme overrides.
 * Theme overrides are temporary and there may not be any defined at times.
 */ var $d147d91e2e429476$var$themeOverrideIds = [];
var $d147d91e2e429476$export$92ba366331403db2 = [].concat($d147d91e2e429476$export$7d43e72a58e3283f, $d147d91e2e429476$var$themeOverrideIds);
/**
 * Theme to use a base. This will create the theme as
 * an extension with all token values marked as optional
 * to allow tokens to be overridden as required.
 */ /**
 * Palettes: The set of base tokens a given theme may be populated with.
 * For example: legacy light & dark themes use the "legacyPalette" containing colors from our
 * previous color set.
 */ /**
 * ThemeConfig: the source of truth for all theme meta-data.
 * This object should be used whenever interfacing with themes.
 */ var $d147d91e2e429476$var$themeConfig = {
    'atlassian-light': {
        id: 'light',
        displayName: 'Light Theme',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'light'
        }
    },
    'atlassian-light-future': {
        id: 'light-future',
        displayName: 'Future Light Theme',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'light'
        },
        override: 'light'
    },
    'atlassian-light-increased-contrast': {
        id: 'light-increased-contrast',
        displayName: 'Light Theme (increased contrast)',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'light'
        },
        extends: 'light',
        increasesContrastFor: 'light'
    },
    'atlassian-dark': {
        id: 'dark',
        displayName: 'Dark Theme',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'dark'
        }
    },
    'atlassian-dark-future': {
        id: 'dark-future',
        displayName: 'Future Dark Theme',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'dark'
        },
        override: 'light'
    },
    'atlassian-dark-increased-contrast': {
        id: 'dark-increased-contrast',
        displayName: 'Dark Theme (increased contrast)',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'dark'
        },
        extends: 'dark',
        increasesContrastFor: 'dark'
    },
    'atlassian-spacing': {
        id: 'spacing',
        displayName: 'Atlassian Spacing',
        palette: 'spacingScale',
        attributes: {
            type: 'spacing'
        }
    },
    'atlassian-typography': {
        id: 'typography',
        displayName: 'Atlassian Typography',
        palette: 'typographyPalette',
        attributes: {
            type: 'typography'
        }
    },
    'atlassian-shape': {
        id: 'shape',
        displayName: 'Shape',
        palette: 'shapePalette',
        attributes: {
            type: 'shape'
        }
    },
    'atlassian-motion': {
        id: 'motion',
        displayName: 'Motion',
        palette: 'motionPalette',
        attributes: {
            type: 'motion'
        }
    }
};
var $d147d91e2e429476$export$9aedcfa7336a207 = {
    colorMode: 'auto',
    contrastMode: 'auto',
    dark: 'dark',
    light: 'light',
    shape: function shape() {
        if ((0, $9Zzpd.fg)('platform-dst-shape-theme-default')) return 'shape';
        return undefined;
    },
    spacing: 'spacing',
    typography: 'typography',
    motion: function motion() {
        if ((0, $9Zzpd.fg)('platform-dst-motion-theme-default')) return 'motion';
        return undefined;
    },
    UNSAFE_themeOptions: undefined
};
var /**
 * Represents theme state once mounted to the page
 * (the page doesn't have an "auto" color mode, it's either light or dark)
 */ $d147d91e2e429476$export$2e2bcd8739ae039 = $d147d91e2e429476$var$themeConfig;

});

parcelRegister("3OmSh", function(module, exports) {
$parcel$export(module.exports, "themeStringToObject", () => $2c67c8fcb77d2ec4$export$f19b488f7c0547ee);

var $ekGgq = parcelRequire("ekGgq");

var $iYJcE = parcelRequire("iYJcE");

var $hXZKI = parcelRequire("hXZKI");
var $2c67c8fcb77d2ec4$var$themeKinds = [
    'light',
    'dark',
    'spacing',
    'typography',
    'shape',
    'motion'
];
var $2c67c8fcb77d2ec4$var$customThemeOptions = 'UNSAFE_themeOptions';
var $2c67c8fcb77d2ec4$var$isThemeKind = function isThemeKind(themeKind) {
    return $2c67c8fcb77d2ec4$var$themeKinds.find(function(kind) {
        return kind === themeKind;
    }) !== undefined;
};
var $2c67c8fcb77d2ec4$var$isThemeIds = function isThemeIds(themeId) {
    return (0, $hXZKI.themeIds).find(function(id) {
        return id === themeId;
    }) !== undefined;
};
var $2c67c8fcb77d2ec4$var$isColorMode = function isColorMode(modeId) {
    return [
        'light',
        'dark',
        'auto'
    ].includes(modeId);
};
var $2c67c8fcb77d2ec4$export$f19b488f7c0547ee = function themeStringToObject(themeState) {
    return themeState.split(' ')// @ts-ignore - TS1501 TypeScript 5.9.2 upgrade
    .map(function(theme) {
        return theme.split(/:([^]*)/);
    }).reduce(function(themeObject, _ref) {
        var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_ref, 2), kind = _ref2[0], id = _ref2[1];
        if (kind === 'colorMode' && $2c67c8fcb77d2ec4$var$isColorMode(id)) themeObject[kind] = id;
        if ($2c67c8fcb77d2ec4$var$isThemeKind(kind) && $2c67c8fcb77d2ec4$var$isThemeIds(id)) // @ts-expect-error FIXME - this is a valid ts error
        themeObject[kind] = id;
        if (kind === $2c67c8fcb77d2ec4$var$customThemeOptions) try {
            themeObject[$2c67c8fcb77d2ec4$var$customThemeOptions] = JSON.parse(id);
        } catch (_unused) {
            new Error('Invalid custom theme string');
        }
        return themeObject;
    }, {});
};
var $2c67c8fcb77d2ec4$export$62c37ab81302621a = function themeObjectToString(themeState) {
    return Object.entries(themeState).reduce(function(themeString, _ref3) {
        var _ref4 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_ref3, 2), kind = _ref4[0], id = _ref4[1];
        if (// colorMode theme state
        kind === 'colorMode' && typeof id === 'string' && $2c67c8fcb77d2ec4$var$isColorMode(id) || // custom theme state
        kind === $2c67c8fcb77d2ec4$var$customThemeOptions && (0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(id) === 'object' || // other theme states
        $2c67c8fcb77d2ec4$var$isThemeKind(kind) && typeof id === 'string' && $2c67c8fcb77d2ec4$var$isThemeIds(id)) return themeString + "".concat(themeString ? ' ' : '') + "".concat(kind, ":").concat((0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(id) === 'object' ? JSON.stringify(id) : id);
        return themeString;
    }, '');
};

});


parcelRegister("lqtRB", function(module, exports) {
$parcel$export(module.exports, "default", () => $f99330fa668b5087$export$2e2bcd8739ae039);

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $25nEq = parcelRequire("25nEq");

var $bIz1q = parcelRequire("bIz1q");

var $40lAl = parcelRequire("40lAl");
/**
 * A MutationObserver which watches the `<html>` element for changes to the theme.
 *
 * In React, use the {@link useThemeObserver `useThemeObserver`} hook instead.
 *
 * @param {function} callback - A callback function which fires when the theme changes.
 *
 * @example
 * ```
 * const observer = new ThemeMutationObserver((theme) => {});
 * observer.observe();
 * ```
 */ var $f99330fa668b5087$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function ThemeMutationObserver(callback) {
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, ThemeMutationObserver);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "legacyObserver", null);
        this.callback = callback;
        ThemeMutationObserver.callbacks.add(callback);
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(ThemeMutationObserver, [
        {
            key: "observe",
            value: function observe() {
                if (!ThemeMutationObserver.observer) {
                    ThemeMutationObserver.observer = new MutationObserver(function() {
                        var theme = (0, $40lAl.default)();
                        ThemeMutationObserver.callbacks.forEach(function(callback) {
                            return callback(theme);
                        });
                    });
                    // Observer only needs to be configured once
                    ThemeMutationObserver.observer.observe(document.documentElement, {
                        attributeFilter: [
                            (0, $bIz1q.THEME_DATA_ATTRIBUTE),
                            (0, $bIz1q.COLOR_MODE_ATTRIBUTE)
                        ]
                    });
                }
            }
        },
        {
            key: "disconnect",
            value: function disconnect() {
                if (this.callback) ThemeMutationObserver.callbacks.delete(this.callback);
                if (ThemeMutationObserver.callbacks.size === 0 && ThemeMutationObserver.observer) {
                    ThemeMutationObserver.observer.disconnect();
                    ThemeMutationObserver.observer = null;
                }
            }
        }
    ]);
}();
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($f99330fa668b5087$export$2e2bcd8739ae039, "observer", null);
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($f99330fa668b5087$export$2e2bcd8739ae039, "callbacks", new Set());

});




parcelRegister("dvJw4", function(module, exports) {
$parcel$export(module.exports, "ConfluenceIcon", () => $9d617a3749cd9541$export$68f3db7f6af48bcb);

var $5FkrB = parcelRequire("5FkrB");

var $8zwGK = parcelRequire("8zwGK");

var $epSHF = parcelRequire("epSHF");

var $dBzF0 = parcelRequire("dBzF0");

var $cjKLY = parcelRequire("cjKLY");
var $9d617a3749cd9541$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor;
    var colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $cjKLY.getColorsFromAppearance)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" viewBox=\"0 0 32 32\" focusable=\"false\" aria-hidden=\"true\" xmlns=\"http://www.w3.org/2000/svg\">\n      <path fill=\"".concat(colors.iconColor, "\" d=\"M25.769 20.234c-6.584-3.183-8.507-3.66-11.282-3.66-3.254 0-6.028 1.355-8.507 5.16l-.406.622c-.333.513-.407.696-.407.915s.11.403.517.659l4.18 2.598c.222.146.407.22.592.22.222 0 .37-.11.592-.44l.665-1.024c1.036-1.574 1.96-2.086 3.144-2.086 1.036 0 2.257.293 3.773 1.025l4.365 2.049c.443.22.924.11 1.146-.403l2.071-4.537c.222-.512.074-.842-.444-1.098M6.572 12.22c6.584 3.184 8.507 3.66 11.281 3.66 3.255 0 6.03-1.354 8.507-5.16l.407-.622c.333-.512.407-.695.407-.915s-.11-.402-.518-.658l-4.18-2.598c-.221-.147-.406-.22-.591-.22-.222 0-.37.11-.592.44l-.666 1.024c-1.035 1.573-1.96 2.086-3.144 2.086-1.035 0-2.256-.293-3.772-1.025L9.346 6.183c-.444-.22-.924-.11-1.146.402l-2.072 4.538c-.222.512-.074.841.444 1.098\"/>\n    </svg>");
};
var $9d617a3749cd9541$export$68f3db7f6af48bcb = function ConfluenceIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Confluence' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $epSHF.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $epSHF.defaultLogoParams).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $epSHF.defaultLogoParams).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $8zwGK.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $dBzF0.default), {
        appearance: appearance,
        label: label,
        svg: $9d617a3749cd9541$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};

});
parcelRegister("epSHF", function(module, exports) {
$parcel$export(module.exports, "defaultLogoParams", () => $a7edd56680ce7f95$export$438460117ae6b7ee);
/**
 * These are the default parameters for LogoProps if the user does not specify values.
 */ var $a7edd56680ce7f95$export$438460117ae6b7ee = {
    iconColor: 'inherit',
    label: '',
    size: 'medium',
    textColor: 'currentColor'
};
var $a7edd56680ce7f95$export$793fba32aed8942a = {
    iconGradientStart: 'inherit',
    iconGradientStop: 'inherit'
}; /**
 * The props for the <Wrapper /> that takes the svg and turns it into a component.
 */ 

});

parcelRegister("dBzF0", function(module, exports) {
$parcel$export(module.exports, "default", () => $028e5c757c5f3895$export$2e2bcd8739ae039);
/* wrapper.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $kqp0i = parcelRequire("kqp0i");

var $25nEq = parcelRequire("25nEq");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");

var $5EqJ2 = parcelRequire("5EqJ2");
var $028e5c757c5f3895$var$_excluded = [
    "label",
    "svg",
    "size",
    "appearance",
    "iconColor",
    "textColor",
    "testId"
];
var $028e5c757c5f3895$var$CSS_VAR_COLOR = '--logo-color';
var $028e5c757c5f3895$var$CSS_VAR_FILL = '--logo-fill';
var $028e5c757c5f3895$var$styles = {
    root: "_1e0c1o8l _kqswh2mm _syaz1vry _lswu1xf6 _vwz4kb7n _uiztglyw _o5724jg8 _zbji1osq _3se11kw7",
    stop: "_vc881r31",
    xxsmall: "_4t3i7vkz",
    xsmall: "_4t3igktf",
    small: "_4t3i1tcg",
    medium: "_4t3izwfg",
    large: "_4t3i1ylp",
    xlarge: "_4t3ickbl"
};
/**
 * __Wrapper__
 *
 * An internal component used by `@atlaskit/logo` to render logo SVGs with correct styles.
 */ var $028e5c757c5f3895$var$Wrapper = function Wrapper(_ref) {
    var label = _ref.label, svg = _ref.svg, size = _ref.size, appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor, userDefinedTestId = _ref.testId, rest = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $028e5c757c5f3895$var$_excluded);
    // Only required for old logos with gradients, which set gradient values to `inherit` when no appearance is provided
    var shouldApplyStopColor = appearance === undefined;
    var testId = userDefinedTestId && "".concat(userDefinedTestId, "--wrapper");
    return /*#__PURE__*/ $5FkrB.createElement("span", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        "data-testid": testId,
        style: (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, $028e5c757c5f3895$var$CSS_VAR_COLOR, iconColor), $028e5c757c5f3895$var$CSS_VAR_FILL, textColor),
        "aria-label": label ? label : undefined,
        role: label ? 'img' : undefined,
        dangerouslySetInnerHTML: {
            __html: svg
        }
    }, rest, {
        className: (0, $5EqJ2.default)([
            $028e5c757c5f3895$var$styles.root,
            shouldApplyStopColor && $028e5c757c5f3895$var$styles.stop,
            size && $028e5c757c5f3895$var$styles[size]
        ])
    }));
};
var $028e5c757c5f3895$export$2e2bcd8739ae039 = $028e5c757c5f3895$var$Wrapper;

});

parcelRegister("cjKLY", function(module, exports) {
$parcel$export(module.exports, "getColorsFromAppearanceOldLogos", () => $8f7b8a7ac8098741$export$362a25f017e2bc8a);
$parcel$export(module.exports, "getColorsFromAppearance", () => $8f7b8a7ac8098741$export$bbacc3980e0f3029);
$parcel$export(module.exports, "getColorsForLoom", () => $8f7b8a7ac8098741$export$7818df200941dbbf);

var $6P7et = parcelRequire("6P7et");
var $8f7b8a7ac8098741$export$362a25f017e2bc8a = function getColorsFromAppearanceOldLogos(appearance, colorMode) {
    var iconGradientStart, iconGradientStop, iconColor, textColor, atlassianLogoTextColor;
    switch(appearance){
        case 'brand':
            iconGradientStart = (0, $6P7et.B400);
            iconGradientStop = (0, $6P7et.B200);
            iconColor = (0, $6P7et.B200);
            textColor = "var(--ds-text, #292A2E)";
            // This is only used for the top level Atlassian wordmark (see AtlassianLogo
            // or AtlassianStartLogo for example), and is only different for the Brand
            // appearance - a bold brand color. For other appearances,
            // atlassianLogoTextColor is the same as textColor.
            atlassianLogoTextColor = (0, $6P7et.B400);
            break;
        case 'neutral':
            iconGradientStart = (0, $6P7et.N600);
            iconGradientStop = (0, $6P7et.N100);
            iconColor = (0, $6P7et.N100);
            textColor = (0, $6P7et.N400);
            atlassianLogoTextColor = (0, $6P7et.N400);
            break;
        case 'inverse':
            iconGradientStart = '#FFFFFF66';
            iconGradientStop = '#FFFFFF';
            iconColor = '#FFFFFF';
            textColor = '#FFFFFF';
            atlassianLogoTextColor = '#FFFFFF';
            break;
    }
    if (colorMode === 'dark' && appearance === 'inverse') {
        iconGradientStart = '#161A1D66';
        iconGradientStop = '#161A1D';
        iconColor = '#161A1D';
        textColor = '#161A1D';
        atlassianLogoTextColor = '#161A1D';
    }
    return {
        iconGradientStart: iconGradientStart,
        iconGradientStop: iconGradientStop,
        iconColor: iconColor,
        textColor: textColor,
        atlassianLogoTextColor: atlassianLogoTextColor
    };
};
var $8f7b8a7ac8098741$export$bbacc3980e0f3029 = function getColorsFromAppearance(appearance, colorMode) {
    var iconColor, textColor, atlassianLogoTextColor;
    if (colorMode === 'dark') switch(appearance){
        case 'brand':
            iconColor = '#357DE8';
            textColor = '#E2E3E4';
            atlassianLogoTextColor = '#357DE8';
            break;
        case 'neutral':
            iconColor = '#96999E';
            textColor = '#BFC1C4';
            atlassianLogoTextColor = '#96999E';
            break;
        case 'inverse':
            iconColor = '#101214';
            textColor = '#101214';
            atlassianLogoTextColor = '#101214';
            break;
    }
    else switch(appearance){
        case 'brand':
            iconColor = '#1868DB';
            textColor = '#101214';
            atlassianLogoTextColor = '#1868DB';
            break;
        case 'neutral':
            iconColor = '#6C6F77';
            textColor = '#3B3D42';
            atlassianLogoTextColor = '#6C6F77';
            break;
        case 'inverse':
            iconColor = (0, $6P7et.N0);
            textColor = (0, $6P7et.N0);
            atlassianLogoTextColor = (0, $6P7et.N0);
            break;
    }
    return {
        iconColor: iconColor,
        textColor: textColor,
        atlassianLogoTextColor: atlassianLogoTextColor
    };
};
var $8f7b8a7ac8098741$export$7818df200941dbbf = function getColorsForLoom(appearance, colorMode) {
    var iconColor = $8f7b8a7ac8098741$export$bbacc3980e0f3029(appearance, colorMode).iconColor;
    var textColor = $8f7b8a7ac8098741$export$bbacc3980e0f3029(appearance, colorMode).textColor;
    if (colorMode === 'dark') switch(appearance){
        case 'brand':
            iconColor = '#625DF5';
            textColor = '#EFF0FF';
            break;
    }
    else switch(appearance){
        case 'brand':
            iconColor = '#625DF5';
            textColor = '#252434';
            break;
    }
    return {
        iconColor: iconColor,
        textColor: textColor
    };
};

});
parcelRegister("6P7et", function(module, exports) {
$parcel$export(module.exports, "B200", () => $4f7d1db2af3a9194$export$215b7063051591f1);
$parcel$export(module.exports, "B400", () => $4f7d1db2af3a9194$export$b3de0ae08da2ce64);
$parcel$export(module.exports, "N0", () => $4f7d1db2af3a9194$export$29a4f05edc054374);
$parcel$export(module.exports, "N100", () => $4f7d1db2af3a9194$export$d6447c357493214f);
$parcel$export(module.exports, "N400", () => $4f7d1db2af3a9194$export$eece5f492e429f08);
$parcel$export(module.exports, "N600", () => $4f7d1db2af3a9194$export$7090862dc3038a9f);
// Reds
var $4f7d1db2af3a9194$export$4b84fd0e2c617bd = '#FFEBE6';
var $4f7d1db2af3a9194$export$b34b069eff244586 = '#FFBDAD';
var $4f7d1db2af3a9194$export$be802dd0d8b57f35 = '#FF8F73';
var $4f7d1db2af3a9194$export$60847d42f9da92a6 = '#FF7452';
var $4f7d1db2af3a9194$export$4a7404f376229999 = '#FF5630';
var $4f7d1db2af3a9194$export$2010d0fb4295b346 = '#DE350B';
var $4f7d1db2af3a9194$export$2837b5a1a71d5c02 = '#BF2600';
var $4f7d1db2af3a9194$export$8d9596b529bbb9cf = '#FFFAE6';
var $4f7d1db2af3a9194$export$41060a744ab0b7ae = '#FFF0B3';
var $4f7d1db2af3a9194$export$1cc05bbbf340e559 = '#FFE380';
var $4f7d1db2af3a9194$export$5aae31392d72caaa = '#FFC400';
var $4f7d1db2af3a9194$export$c6930421db9fa514 = '#FFAB00';
var $4f7d1db2af3a9194$export$59619663aa6500fb = '#FF991F';
var $4f7d1db2af3a9194$export$874739ea9e379ab6 = '#FF8B00';
var $4f7d1db2af3a9194$export$8a6341c32b6a3ee6 = '#E3FCEF';
var $4f7d1db2af3a9194$export$69a3bf21b9686c2b = '#ABF5D1';
var $4f7d1db2af3a9194$export$afbce1382ec95f73 = '#79F2C0';
var $4f7d1db2af3a9194$export$747d86715d4175de = '#57D9A3';
var $4f7d1db2af3a9194$export$940e1f69e873f202 = '#36B37E';
var $4f7d1db2af3a9194$export$a49394138f7b8e85 = '#00875A';
var $4f7d1db2af3a9194$export$6fa04827ac68a4fb = '#006644';
var $4f7d1db2af3a9194$export$226de0355ed012f8 = '#DEEBFF';
var $4f7d1db2af3a9194$export$8c13c2ee36917869 = '#B3D4FF';
var $4f7d1db2af3a9194$export$ecfc1dff386a3e7a = '#4C9AFF';
var $4f7d1db2af3a9194$export$215b7063051591f1 = '#2684FF';
var $4f7d1db2af3a9194$export$e62e8919cca44969 = '#0065FF';
var $4f7d1db2af3a9194$export$b3de0ae08da2ce64 = '#0052CC';
var $4f7d1db2af3a9194$export$a6ee3d71bc067634 = '#0747A6';
var $4f7d1db2af3a9194$export$67f15409e87642a1 = '#669DF1';
var $4f7d1db2af3a9194$export$f0539dbc42dbb067 = '#8FB8F6';
var $4f7d1db2af3a9194$export$363e4475840015bb = '#EAE6FF';
var $4f7d1db2af3a9194$export$4b0a4417ed59760f = '#C0B6F2';
var $4f7d1db2af3a9194$export$6011520a64d9a187 = '#998DD9';
var $4f7d1db2af3a9194$export$a7175d4e9206bc80 = '#8777D9';
var $4f7d1db2af3a9194$export$b48405b95304b5a1 = '#6554C0';
var $4f7d1db2af3a9194$export$c71e4279dd54a18d = '#5243AA';
var $4f7d1db2af3a9194$export$147899de772240ec = '#403294';
var $4f7d1db2af3a9194$export$2cf711fe14c66f06 = '#E6FCFF';
var $4f7d1db2af3a9194$export$7a8f4d33f6f9772c = '#B3F5FF';
var $4f7d1db2af3a9194$export$776c9c497ef08533 = '#79E2F2';
var $4f7d1db2af3a9194$export$69cb3ca10c1e330e = '#00C7E6';
var $4f7d1db2af3a9194$export$9dc1ef0f3f48059b = '#00B8D9';
var $4f7d1db2af3a9194$export$7c835c78b6fcdef8 = '#00A3BF';
var $4f7d1db2af3a9194$export$6036577f95c3877e = '#008DA6';
var $4f7d1db2af3a9194$export$29a4f05edc054374 = '#FFFFFF';
var $4f7d1db2af3a9194$export$e655ef011c4aa1a2 = '#FAFBFC';
var $4f7d1db2af3a9194$export$9fdfb749e33cdf97 = '#F4F5F7';
var $4f7d1db2af3a9194$export$3e51e8f1440314ba = '#EBECF0';
var $4f7d1db2af3a9194$export$1ce2d1575d444ceb = '#DFE1E6';
var $4f7d1db2af3a9194$export$8754fc7e6d8b3000 = '#C1C7D0';
var $4f7d1db2af3a9194$export$c2e91cbeada39b8b = '#B3BAC5';
var $4f7d1db2af3a9194$export$5f71e19f3a7ad9de = '#A5ADBA';
var $4f7d1db2af3a9194$export$eaa8c8a70ac22806 = '#97A0AF';
var $4f7d1db2af3a9194$export$7c87d337fb91a97d = '#8993A4';
var $4f7d1db2af3a9194$export$d6447c357493214f = '#7A869A';
var $4f7d1db2af3a9194$export$f563ee71e9ee74cd = '#6B778C';
var $4f7d1db2af3a9194$export$e2ef2124cf4024b1 = '#5E6C84';
var $4f7d1db2af3a9194$export$eece5f492e429f08 = '#505F79';
var $4f7d1db2af3a9194$export$c39c0fe0f26207ae = '#42526E';
var $4f7d1db2af3a9194$export$7090862dc3038a9f = '#344563';
var $4f7d1db2af3a9194$export$ad0bacf983b7ddaa = '#253858';
var $4f7d1db2af3a9194$export$7d61b15e0da132af = '#172B4D';
var $4f7d1db2af3a9194$export$fbda843f0a27fe96 = '#091E42';
var $4f7d1db2af3a9194$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
var $4f7d1db2af3a9194$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
var $4f7d1db2af3a9194$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
var $4f7d1db2af3a9194$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
var $4f7d1db2af3a9194$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
var $4f7d1db2af3a9194$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
var $4f7d1db2af3a9194$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
var $4f7d1db2af3a9194$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
var $4f7d1db2af3a9194$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
var $4f7d1db2af3a9194$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
var $4f7d1db2af3a9194$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
var $4f7d1db2af3a9194$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
var $4f7d1db2af3a9194$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
var $4f7d1db2af3a9194$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
var $4f7d1db2af3a9194$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
var $4f7d1db2af3a9194$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
var $4f7d1db2af3a9194$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
var $4f7d1db2af3a9194$export$2f6319cf7d736c2a = '#E6EDFA';
var $4f7d1db2af3a9194$export$95126bc8884d6634 = '#DCE5F5';
var $4f7d1db2af3a9194$export$8338d8c35d44ff1 = '#CED9EB';
var $4f7d1db2af3a9194$export$5368d76ae4fbbda7 = '#B8C7E0';
var $4f7d1db2af3a9194$export$9f0a771d16ec8d36 = '#ABBBD6';
var $4f7d1db2af3a9194$export$abcf8c38338b4aa5 = '#9FB0CC';
var $4f7d1db2af3a9194$export$97e81faa16a182c7 = '#8C9CB8';
var $4f7d1db2af3a9194$export$bfe21c59123ecf33 = '#7988A3';
var $4f7d1db2af3a9194$export$ee82aa2ea6a1558 = '#67758F';
var $4f7d1db2af3a9194$export$682927c6ed76be02 = '#56637A';
var $4f7d1db2af3a9194$export$91fd9994c5be9757 = '#455166';
var $4f7d1db2af3a9194$export$d281fbfe3cff2df6 = '#3B475C';
var $4f7d1db2af3a9194$export$3902c91d8b98a753 = '#313D52';
var $4f7d1db2af3a9194$export$8e8133c1ba5845b5 = '#283447';
var $4f7d1db2af3a9194$export$33ff357f6620b39 = '#202B3D';
var $4f7d1db2af3a9194$export$633847cf062b69e0 = '#1B2638';
var $4f7d1db2af3a9194$export$9776a6e503bdbf76 = '#121A29';
var $4f7d1db2af3a9194$export$6c813d5160dff5db = '#0E1624';
var $4f7d1db2af3a9194$export$3d4f271a500072a = '#0D1424';
var $4f7d1db2af3a9194$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
var $4f7d1db2af3a9194$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
var $4f7d1db2af3a9194$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
var $4f7d1db2af3a9194$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
var $4f7d1db2af3a9194$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
var $4f7d1db2af3a9194$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
var $4f7d1db2af3a9194$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
var $4f7d1db2af3a9194$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
var $4f7d1db2af3a9194$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
var $4f7d1db2af3a9194$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
var $4f7d1db2af3a9194$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
var $4f7d1db2af3a9194$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
var $4f7d1db2af3a9194$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
var $4f7d1db2af3a9194$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
var $4f7d1db2af3a9194$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
var $4f7d1db2af3a9194$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
var $4f7d1db2af3a9194$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';
var $4f7d1db2af3a9194$export$d2adc5dedf09fced = '#292A2E';
var $4f7d1db2af3a9194$export$f51762073d2bb381 = '#94C748';
var $4f7d1db2af3a9194$export$95e26d54def96891 = '#B3DF72';

});



parcelRegister("8VIvt", function(module, exports) {
$parcel$export(module.exports, "createFeatureFlaggedComponent", () => $68062bb1e2731c93$export$e30d2ddc605f6bb);
$parcel$export(module.exports, "createFeatureFlaggedServiceCollectionComponent", () => $68062bb1e2731c93$export$436fcf6e31fbacea);
$parcel$export(module.exports, "createFeatureFlaggedRovoComponent", () => $68062bb1e2731c93$export$2469203854060337);
$parcel$export(module.exports, "tempSizeWrapper", () => $68062bb1e2731c93$export$667425256e2e7296);
$parcel$export(module.exports, "teamEUFlaggedIcon", () => $68062bb1e2731c93$export$3fe521abfbbe6ab3);

var $kqp0i = parcelRequire("kqp0i");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");

var $9Zzpd = parcelRequire("9Zzpd");
var $68062bb1e2731c93$var$_excluded = [
    "size",
    "shouldUseNewLogoDesign"
], $68062bb1e2731c93$var$_excluded2 = [
    "size",
    "shouldUseNewLogoDesign"
], $68062bb1e2731c93$var$_excluded3 = [
    "shouldUseHexLogo"
], $68062bb1e2731c93$var$_excluded4 = [
    "size"
];
/**
 * Creates a feature flagged component that renders the legacy logo or the new logo
 * based on the platform-logo-rebrand feature flag.
 *
 * @param LegacyComponent - The legacy logo component.
 * @param NewComponent - The new logo component.
 * @returns A feature flagged component that renders the legacy logo or the new logo.
 */ var $68062bb1e2731c93$export$e30d2ddc605f6bb = function createFeatureFlaggedComponent(LegacyComponent, NewComponent) {
    // Note: textColor and iconColor aren't supported on all new logos
    // These props will be deprecated in the future
    return function(_ref) {
        var size = _ref.size, shouldUseNewLogoDesign = _ref.shouldUseNewLogoDesign, props = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $68062bb1e2731c93$var$_excluded);
        if ((0, $9Zzpd.fg)('platform-logo-rebrand') || shouldUseNewLogoDesign) // Size defaults need to be set, as the temp library had different defaults
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(NewComponent, (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
            size: size || 'medium'
        }, props));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(LegacyComponent, (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
            size: size
        }, props));
    };
};
var $68062bb1e2731c93$export$436fcf6e31fbacea = function createFeatureFlaggedServiceCollectionComponent(LegacyComponent, NewComponent) {
    // Note: textColor and iconColor aren't supported on all new logos
    // These props will be deprecated in the future
    return function(_ref2) {
        var size = _ref2.size, shouldUseNewLogoDesign = _ref2.shouldUseNewLogoDesign, props = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref2, $68062bb1e2731c93$var$_excluded2);
        if ((0, $9Zzpd.fg)('platform-logo-rebrand') || shouldUseNewLogoDesign) // Size defaults need to be set, as the temp library had different defaults
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(NewComponent, (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
            size: size || 'medium'
        }, props));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(LegacyComponent, (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
            size: size
        }, props));
    };
};
var $68062bb1e2731c93$export$2469203854060337 = function createFeatureFlaggedRovoComponent(LegacyComponent, NewComponent, NewHexComponent) {
    var RovoHexWrapped = $68062bb1e2731c93$export$667425256e2e7296(NewHexComponent);
    var RovoServiceCollectionWrapped = $68062bb1e2731c93$export$436fcf6e31fbacea(LegacyComponent, NewComponent);
    return function(_ref3) {
        var shouldUseHexLogo = _ref3.shouldUseHexLogo, props = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref3, $68062bb1e2731c93$var$_excluded3);
        // Return hex logo if feature flag enabled. Otherwise revert to old set of components
        if ((0, $9Zzpd.fg)('platform-logo-rebrand-rovo-hex') || shouldUseHexLogo) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(RovoHexWrapped, props);
        else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(RovoServiceCollectionWrapped, props);
    };
};
var $68062bb1e2731c93$export$667425256e2e7296 = function tempSizeWrapper(NewComponent) {
    return function(_ref4) {
        var size = _ref4.size, props = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref4, $68062bb1e2731c93$var$_excluded4);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(NewComponent, (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
            size: size || 'medium'
        }, props));
    };
};
var $68062bb1e2731c93$export$3fe521abfbbe6ab3 = function teamEUFlaggedIcon(LegacyComponent, NewComponent) {
    return function(props) {
        var Logo = (0, $9Zzpd.fg)('platform-logo-rebrand-team-eu') ? $68062bb1e2731c93$export$667425256e2e7296(NewComponent) : $68062bb1e2731c93$export$667425256e2e7296(LegacyComponent);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(Logo, props);
    };
};
var $68062bb1e2731c93$export$172fd793eb6ecac4 = [
    // Program logos
    {
        name: 'atlassian',
        type: 'legacy',
        category: 'program'
    },
    {
        name: 'atlassian-access',
        type: 'legacy',
        category: 'program'
    },
    {
        name: 'atlassian-marketplace',
        type: 'legacy',
        category: 'program'
    },
    // Home collection
    {
        name: 'home',
        type: 'new',
        category: 'app'
    },
    {
        name: 'hub',
        type: 'new',
        category: 'app'
    },
    // Teamwork collection
    {
        name: 'confluence',
        type: 'migration',
        category: 'app'
    },
    {
        name: 'jira',
        type: 'migration',
        category: 'app'
    },
    {
        name: 'loom',
        type: 'migration',
        category: 'app'
    },
    {
        name: 'loom-blurple',
        type: 'new',
        category: 'app',
        skipExample: true
    },
    {
        name: 'loom-attribution',
        type: 'migration',
        category: 'app'
    },
    {
        name: 'rovo',
        type: 'rovo-hex',
        category: 'app'
    },
    // Strategy collection
    {
        name: 'align',
        type: 'new',
        category: 'app'
    },
    {
        name: 'focus',
        type: 'migration',
        category: 'app'
    },
    {
        name: 'talent',
        type: 'new',
        category: 'app'
    },
    // App collection
    {
        name: 'jira-product-discovery',
        type: 'migration',
        category: 'app'
    },
    // Dev collection
    {
        name: 'bitbucket',
        type: 'migration',
        category: 'app'
    },
    {
        name: 'compass',
        type: 'migration',
        category: 'app'
    },
    {
        name: 'dx',
        type: 'new',
        category: 'app',
        skipLogo: true
    },
    {
        name: 'rovo-dev',
        type: 'new',
        category: 'app'
    },
    {
        name: 'rovo-dev-agent',
        type: 'new',
        category: 'agent'
    },
    // Customer collection
    {
        name: 'jira-service-management',
        type: 'migration',
        category: 'app'
    },
    {
        name: 'assets',
        type: 'new',
        category: 'app'
    },
    {
        name: 'customer-service-management',
        type: 'new',
        category: 'app'
    },
    {
        name: 'opsgenie',
        type: 'migration',
        category: 'app'
    },
    {
        name: 'statuspage',
        type: 'migration',
        category: 'app'
    },
    {
        name: 'trello',
        type: 'migration',
        category: 'app'
    },
    // Platform Collection
    {
        name: 'admin',
        type: 'new',
        category: 'app'
    },
    {
        name: 'analytics',
        type: 'new',
        category: 'app'
    },
    {
        name: 'chat',
        type: 'new',
        category: 'app'
    },
    {
        name: 'goals',
        type: 'new',
        category: 'app'
    },
    {
        name: 'guard',
        type: 'migration',
        category: 'app'
    },
    {
        name: 'projects',
        type: 'new',
        category: 'app'
    },
    {
        name: 'search',
        type: 'new',
        category: 'app'
    },
    {
        name: 'studio',
        type: 'new',
        category: 'app'
    },
    {
        name: 'teams',
        type: 'new',
        category: 'app'
    },
    // Data Center
    {
        name: 'jira-data-center',
        type: 'new',
        category: 'app'
    },
    {
        name: 'jira-service-management-data-center',
        type: 'new',
        category: 'app'
    },
    {
        name: 'confluence-data-center',
        type: 'new',
        category: 'app'
    },
    {
        name: 'bitbucket-data-center',
        type: 'new',
        category: 'app'
    },
    {
        name: 'bamboo',
        type: 'new',
        category: 'app'
    },
    {
        name: 'crowd',
        type: 'new',
        category: 'app'
    },
    // Deprecated
    {
        name: 'atlassian-administration',
        type: 'legacy',
        category: 'app',
        skipExample: true,
        deprecated: true
    },
    {
        name: 'atlassian-admin',
        type: 'legacy',
        category: 'app',
        skipExample: true,
        deprecated: true
    },
    {
        name: 'atlassian-analytics',
        type: 'legacy',
        category: 'app',
        skipExample: true,
        deprecated: true
    },
    {
        name: 'atlas',
        type: 'legacy',
        category: 'app',
        skipExample: true,
        deprecated: true
    },
    {
        name: 'jira-align',
        type: 'legacy',
        category: 'app',
        skipExample: true,
        deprecated: true
    },
    {
        name: 'jira-software',
        type: 'legacy',
        category: 'app',
        skipExample: true,
        deprecated: true
    },
    {
        name: 'jira-work-management',
        type: 'legacy',
        category: 'app',
        skipExample: true,
        deprecated: true
    }
];
var $68062bb1e2731c93$export$62e1212796a86b1b = $68062bb1e2731c93$export$172fd793eb6ecac4.filter(function(logo) {
    return logo.category === 'program' && !logo.skipExample;
}).map(function(logo) {
    return logo.name;
});
var $68062bb1e2731c93$export$e0dee4a765830f4d = $68062bb1e2731c93$export$172fd793eb6ecac4.filter(function(logo) {
    return logo.category === 'app' && !logo.skipExample;
}).map(function(logo) {
    return logo.name;
});
var $68062bb1e2731c93$export$a13ce90e90d7bfc1 = $68062bb1e2731c93$export$172fd793eb6ecac4.filter(function(logo) {
    return logo.category === 'agent' && !logo.skipExample;
}).map(function(logo) {
    return logo.name;
}) || [];
var $68062bb1e2731c93$export$516fce44c502c1d3 = $68062bb1e2731c93$export$172fd793eb6ecac4.filter(function(logo) {
    return logo.type === 'legacy';
});
var $68062bb1e2731c93$export$b805fae8e798ed39 = $68062bb1e2731c93$export$172fd793eb6ecac4.filter(function(logo) {
    return logo.type === 'migration';
});
var $68062bb1e2731c93$export$3f9abd26214cd85f = $68062bb1e2731c93$export$172fd793eb6ecac4.filter(function(logo) {
    return logo.type === 'new';
});

});


parcelRegister("8Tu2m", function(module, exports) {
$parcel$export(module.exports, "JiraIcon", () => $679ac2861cb37ac2$export$c4b5b1f965d8b3eb);

var $4Kdh6 = parcelRequire("4Kdh6");
var $gVGtb = parcelRequire("gVGtb");

var $87Zya = parcelRequire("87Zya");
var $8I9KT = parcelRequire("8I9KT");

var $bQu6s = parcelRequire("bQu6s");
var $hQCOF = parcelRequire("hQCOF");

var $k6Cb9 = parcelRequire("k6Cb9");
var $1VDeR = parcelRequire("1VDeR");

var $4ciqS = parcelRequire("4ciqS");
var $8E05W = parcelRequire("8E05W");

var $iZ1Si = parcelRequire("iZ1Si");
var $9LYU9 = parcelRequire("9LYU9");

var $3cSVw = parcelRequire("3cSVw");
var $BsLUu = parcelRequire("BsLUu");

var $d21dh = parcelRequire("d21dh");
var $a0PUs = parcelRequire("a0PUs");

var $8Xwt9 = parcelRequire("8Xwt9");
var $cnNGt = parcelRequire("cnNGt");

var $2VpZv = parcelRequire("2VpZv");
var $f3Gpb = parcelRequire("f3Gpb");

var $gicOj = parcelRequire("gicOj");
var $f1nD4 = parcelRequire("f1nD4");

var $bx9df = parcelRequire("bx9df");
var $1kajK = parcelRequire("1kajK");

var $lC725 = parcelRequire("lC725");
var $gCRKh = parcelRequire("gCRKh");

var $ltZmE = parcelRequire("ltZmE");
var $lx9EO = parcelRequire("lx9EO");

var $d8qHL = parcelRequire("d8qHL");

var $6VWeS = parcelRequire("6VWeS");
var $jwoQS = parcelRequire("jwoQS");

var $9YoqB = parcelRequire("9YoqB");
var $dJnaB = parcelRequire("dJnaB");

var $iGWzy = parcelRequire("iGWzy");
var $OtwCy = parcelRequire("OtwCy");

var $5F1rh = parcelRequire("5F1rh");
var $kBC8w = parcelRequire("kBC8w");

var $gC6DE = parcelRequire("gC6DE");
var $923YP = parcelRequire("923YP");

var $jua8c = parcelRequire("jua8c");
var $b5K36 = parcelRequire("b5K36");

var $g1wQb = parcelRequire("g1wQb");
var $jzYgU = parcelRequire("jzYgU");

var $as6dI = parcelRequire("as6dI");
var $04Bi0 = parcelRequire("04Bi0");

var $ijdNw = parcelRequire("ijdNw");
var $dbjyg = parcelRequire("dbjyg");

var $cr5XE = parcelRequire("cr5XE");
var $jFppn = parcelRequire("jFppn");

var $eLaBI = parcelRequire("eLaBI");
var $b6zdK = parcelRequire("b6zdK");

var $iWe5o = parcelRequire("iWe5o");

var $dxzOv = parcelRequire("dxzOv");
var $b0jBl = parcelRequire("b0jBl");

var $3rWiD = parcelRequire("3rWiD");
var $5iCT1 = parcelRequire("5iCT1");

var $8kiMR = parcelRequire("8kiMR");
var $6tHn8 = parcelRequire("6tHn8");

var $j3Kxp = parcelRequire("j3Kxp");
var $8Q3Zc = parcelRequire("8Q3Zc");

var $iHGc3 = parcelRequire("iHGc3");
var $dkjYp = parcelRequire("dkjYp");

var $4TBto = parcelRequire("4TBto");
var $1bhUU = parcelRequire("1bhUU");

var $2JaJ7 = parcelRequire("2JaJ7");
var $fmqRP = parcelRequire("fmqRP");

var $5YANc = parcelRequire("5YANc");
var $fpDzJ = parcelRequire("fpDzJ");

var $fP54Y = parcelRequire("fP54Y");
var $eUIl7 = parcelRequire("eUIl7");

var $lGzBY = parcelRequire("lGzBY");
var $irena = parcelRequire("irena");

var $e62x9 = parcelRequire("e62x9");
var $bdWJY = parcelRequire("bdWJY");

var $c9EzA = parcelRequire("c9EzA");
var $32evx = parcelRequire("32evx");

var $ixRbu = parcelRequire("ixRbu");
var $l88pz = parcelRequire("l88pz");

var $lkWiF = parcelRequire("lkWiF");
var $2Knfx = parcelRequire("2Knfx");

var $f58QK = parcelRequire("f58QK");
var $k99Uz = parcelRequire("k99Uz");

var $gljFT = parcelRequire("gljFT");
var $lEFHv = parcelRequire("lEFHv");

var $1uztH = parcelRequire("1uztH");
var $ft85g = parcelRequire("ft85g");

var $oJHVJ = parcelRequire("oJHVJ");
var $k10Jw = parcelRequire("k10Jw");

var $3dZcQ = parcelRequire("3dZcQ");
var $gpFW4 = parcelRequire("gpFW4");

var $4gFa7 = parcelRequire("4gFa7");
var $lxChN = parcelRequire("lxChN");

var $dvJw4 = parcelRequire("dvJw4");
var $gvR58 = parcelRequire("gvR58");

var $kzQer = parcelRequire("kzQer");
var $eiyYh = parcelRequire("eiyYh");

var $MIVBE = parcelRequire("MIVBE");
var $7jJm4 = parcelRequire("7jJm4");

var $b80fJ = parcelRequire("b80fJ");
var $dfI4K = parcelRequire("dfI4K");

var $4cFVz = parcelRequire("4cFVz");
var $7VYCY = parcelRequire("7VYCY");

var $d5SeO = parcelRequire("d5SeO");
var $9kAuE = parcelRequire("9kAuE");

var $ggWcZ = parcelRequire("ggWcZ");
var $7uRko = parcelRequire("7uRko");

var $kb8Bx = parcelRequire("kb8Bx");
var $9cPpa = parcelRequire("9cPpa");

var $cKMMr = parcelRequire("cKMMr");
var $1IYzI = parcelRequire("1IYzI");

var $6qbsR = parcelRequire("6qbsR");
var $kfv2v = parcelRequire("kfv2v");

var $3Deu1 = parcelRequire("3Deu1");
var $gXHVt = parcelRequire("gXHVt");

var $3l5GX = parcelRequire("3l5GX");
var $8Ar69 = parcelRequire("8Ar69");

var $drVNk = parcelRequire("drVNk");
var $2hO7t = parcelRequire("2hO7t");







var $8VIvt = parcelRequire("8VIvt");
/**
 * __Admin icon__
 *
 * The Admin icon without an accompanying wordmark.
 *
 * - [Examples](https://atlassian.design/components/logo/examples)
 * - [Code](https://atlassian.design/components/logo/code)
 * - [Usage](https://atlassian.design/components/logo/usage)
 */ var $679ac2861cb37ac2$export$ef8e5f836dd989d3 = (0, $8VIvt.tempSizeWrapper)((0, $4Kdh6.AdminIcon));
var $679ac2861cb37ac2$export$ebcd30672e67406 = (0, $8VIvt.tempSizeWrapper)((0, $gVGtb.AdminLogoCS));
var $679ac2861cb37ac2$export$af3460f51ce3602a = (0, $8VIvt.tempSizeWrapper)((0, $bQu6s.AnalyticsIcon));
var $679ac2861cb37ac2$export$c8415b6abe4a8587 = (0, $8VIvt.tempSizeWrapper)((0, $hQCOF.AnalyticsLogoCS));
var $679ac2861cb37ac2$export$d89497e7f33ca6f5 = (0, $8VIvt.tempSizeWrapper)((0, $k6Cb9.AssetsIcon));
var $679ac2861cb37ac2$export$48ca930f3071e3e4 = (0, $8VIvt.tempSizeWrapper)((0, $1VDeR.AssetsLogoCS));
var $679ac2861cb37ac2$export$52cd484a7ef4f2b9 = (0, $8VIvt.teamEUFlaggedIcon)((0, $d21dh.ChatIcon), (0, $8Xwt9.ChatNewIcon));
var $679ac2861cb37ac2$export$9ca9881809919df8 = (0, $8VIvt.teamEUFlaggedIcon)((0, $a0PUs.ChatLogoCS), (0, $cnNGt.ChatNewLogoCS));
/**
 * __Customer Service Management icon__
 *
 * The Customer service management icon without an accompanying wordmark.
 *
 * - [Examples](https://atlassian.design/components/logo/examples)
 * - [Code](https://atlassian.design/components/logo/code)
 * - [Usage](https://atlassian.design/components/logo/usage)
 */ var $679ac2861cb37ac2$export$6da5aa77c402ba0f = (0, $8VIvt.tempSizeWrapper)((0, $ltZmE.CustomerServiceManagementIcon));
var $679ac2861cb37ac2$export$abc95e6180bb1d88 = (0, $8VIvt.tempSizeWrapper)((0, $lx9EO.CustomerServiceManagementLogoCS));
var $679ac2861cb37ac2$export$9eb74917ea768ed4 = (0, $8VIvt.tempSizeWrapper)((0, $9YoqB.GoalsIcon));
var $679ac2861cb37ac2$export$d2577aa28451395f = (0, $8VIvt.tempSizeWrapper)((0, $dJnaB.GoalsLogoCS));
var $679ac2861cb37ac2$export$92c8767b874048d = (0, $8VIvt.tempSizeWrapper)((0, $5F1rh.HomeIcon));
var $679ac2861cb37ac2$export$d5648119d5b68e90 = (0, $8VIvt.tempSizeWrapper)((0, $kBC8w.HomeLogoCS));
var $679ac2861cb37ac2$export$80b8b269d8b5014e = (0, $8VIvt.tempSizeWrapper)((0, $gC6DE.HubIcon));
var $679ac2861cb37ac2$export$fc9bd6687b80fe3b = (0, $8VIvt.tempSizeWrapper)((0, $923YP.HubLogoCS));
var $679ac2861cb37ac2$export$5ed3e1bb3b04fc02 = (0, $8VIvt.tempSizeWrapper)((0, $8kiMR.ProjectsIcon));
var $679ac2861cb37ac2$export$aeefab651bcf2338 = (0, $8VIvt.tempSizeWrapper)((0, $6tHn8.ProjectsLogoCS));
var $679ac2861cb37ac2$export$8b784b3227531b3e = (0, $8VIvt.tempSizeWrapper)((0, $iHGc3.RovoDevIcon));
var $679ac2861cb37ac2$export$f0750468d67c6902 = (0, $8VIvt.tempSizeWrapper)((0, $dkjYp.RovoDevLogoCS));
var $679ac2861cb37ac2$export$813cff80931d9dbf = (0, $8VIvt.tempSizeWrapper)((0, $4TBto.RovoDevAgentIcon));
var $679ac2861cb37ac2$export$409b7a5b7f180eba = (0, $8VIvt.tempSizeWrapper)((0, $1bhUU.RovoDevAgentLogoCS));
var $679ac2861cb37ac2$export$82eafebb825fc23f = (0, $8VIvt.teamEUFlaggedIcon)((0, $5YANc.SearchIcon), (0, $fP54Y.SearchNewIcon));
var $679ac2861cb37ac2$export$e4c5487c9a8ae3b1 = (0, $8VIvt.teamEUFlaggedIcon)((0, $fpDzJ.SearchLogoCS), (0, $eUIl7.SearchNewLogoCS));
var $679ac2861cb37ac2$export$290a0f24614cde9f = (0, $8VIvt.teamEUFlaggedIcon)((0, $e62x9.StudioIcon), (0, $c9EzA.StudioNewIcon));
var $679ac2861cb37ac2$export$8aceb78c659789b6 = (0, $8VIvt.teamEUFlaggedIcon)((0, $bdWJY.StudioLogoCS), (0, $32evx.StudioNewLogoCS));
/**
 * __Talent icon__
 *
 * The Talent icon without an accompanying wordmark.
 *
 * - [Examples](https://atlassian.design/components/logo/examples)
 * - [Code](https://atlassian.design/components/logo/code)
 * - [Usage](https://atlassian.design/components/logo/usage)
 */ var $679ac2861cb37ac2$export$4b05688514531169 = (0, $8VIvt.tempSizeWrapper)((0, $ixRbu.TalentIcon));
var $679ac2861cb37ac2$export$4f6453e012279f89 = (0, $8VIvt.tempSizeWrapper)((0, $l88pz.TalentLogoCS));
var $679ac2861cb37ac2$export$1bcbc9c337da86da = (0, $8VIvt.tempSizeWrapper)((0, $lkWiF.TeamsIcon));
var $679ac2861cb37ac2$export$9b1a0a0c574cec2a = (0, $8VIvt.tempSizeWrapper)((0, $2Knfx.TeamsLogoCS));
var $679ac2861cb37ac2$export$e812398311cab9a3 = (0, $8VIvt.tempSizeWrapper)((0, $4ciqS.BambooIcon));
var $679ac2861cb37ac2$export$765f5afcc1a5a7e3 = (0, $8VIvt.tempSizeWrapper)((0, $8E05W.BambooLogoCS));
var $679ac2861cb37ac2$export$d3ab16bbf4f954ee = (0, $8VIvt.tempSizeWrapper)((0, $3cSVw.BitbucketDataCenterIcon));
var $679ac2861cb37ac2$export$36044946916e84a0 = (0, $8VIvt.tempSizeWrapper)((0, $BsLUu.BitbucketDataCenterLogoCS));
var $679ac2861cb37ac2$export$53305f1f2855d3be = (0, $8VIvt.tempSizeWrapper)((0, $bx9df.ConfluenceDataCenterIcon));
var $679ac2861cb37ac2$export$5e06396bce773a3 = (0, $8VIvt.tempSizeWrapper)((0, $1kajK.ConfluenceDataCenterLogoCS));
var $679ac2861cb37ac2$export$eaf73f391f7103bd = (0, $8VIvt.tempSizeWrapper)((0, $lC725.CrowdIcon));
var $679ac2861cb37ac2$export$6128b385660fd3c6 = (0, $8VIvt.tempSizeWrapper)((0, $gCRKh.CrowdLogoCS));
var $679ac2861cb37ac2$export$f8455b5667a3ee0c = (0, $8VIvt.tempSizeWrapper)((0, $g1wQb.JiraDataCenterIcon));
var $679ac2861cb37ac2$export$eb152ab3801b2ae3 = (0, $8VIvt.tempSizeWrapper)((0, $jzYgU.JiraDataCenterLogoCS));
var $679ac2861cb37ac2$export$65fae0eaf343f2ca = (0, $8VIvt.tempSizeWrapper)((0, $cr5XE.JiraServiceManagementDataCenterIcon));
var $679ac2861cb37ac2$export$fffc0d480fb1ebf1 = (0, $8VIvt.tempSizeWrapper)((0, $jFppn.JiraServiceManagementDataCenterLogoCS));
var $679ac2861cb37ac2$export$74517ed253186308 = (0, $8VIvt.createFeatureFlaggedComponent)((0, $1uztH.AtlassianAdministrationIcon), (0, $4Kdh6.AdminIcon));
var $679ac2861cb37ac2$export$833abe6c2ce5ebfd = (0, $8VIvt.createFeatureFlaggedComponent)((0, $ft85g.AtlassianAdministrationLogo), (0, $gVGtb.AdminLogoCS));
var $679ac2861cb37ac2$export$84109e099492cb5f = (0, $8VIvt.createFeatureFlaggedComponent)((0, $gljFT.AtlassianAdminIcon), (0, $4Kdh6.AdminIcon));
var $679ac2861cb37ac2$export$f845d9b9254f0541 = (0, $8VIvt.createFeatureFlaggedComponent)((0, $lEFHv.AtlassianAdminLogo), (0, $gVGtb.AdminLogoCS));
var $679ac2861cb37ac2$export$c42ad8a0b925c762 = (0, $8VIvt.createFeatureFlaggedComponent)((0, $oJHVJ.AtlassianAnalyticsIcon), (0, $bQu6s.AnalyticsIcon));
var $679ac2861cb37ac2$export$e6470bfc39010cc4 = (0, $8VIvt.createFeatureFlaggedComponent)((0, $k10Jw.AtlassianAnalyticsLogo), (0, $hQCOF.AnalyticsLogoCS));
var $679ac2861cb37ac2$export$5fc1066e677788d4 = (0, $8VIvt.createFeatureFlaggedComponent)((0, $3dZcQ.BitbucketIcon), (0, $iZ1Si.BitbucketIcon));
var $679ac2861cb37ac2$export$bd40525f5333524b = (0, $8VIvt.createFeatureFlaggedComponent)((0, $gpFW4.BitbucketLogo), (0, $9LYU9.BitbucketLogoCS));
var $679ac2861cb37ac2$export$f7857fe64d7161d9 = (0, $8VIvt.createFeatureFlaggedComponent)((0, $4gFa7.CompassIcon), (0, $2VpZv.CompassIcon));
var $679ac2861cb37ac2$export$eb7d748e4f9c9676 = (0, $8VIvt.createFeatureFlaggedComponent)((0, $lxChN.CompassLogo), (0, $f3Gpb.CompassLogoCS));
var $679ac2861cb37ac2$export$9951d02c2d848122 = (0, $8VIvt.tempSizeWrapper)((0, $d8qHL.DxIcon));
var $679ac2861cb37ac2$export$68f3db7f6af48bcb = (0, $8VIvt.createFeatureFlaggedComponent)((0, $dvJw4.ConfluenceIcon), (0, $gicOj.ConfluenceIcon));
var $679ac2861cb37ac2$export$1b2e4fe6ef471556 = (0, $8VIvt.createFeatureFlaggedComponent)((0, $gvR58.ConfluenceLogo), (0, $f1nD4.ConfluenceLogoCS));
var $679ac2861cb37ac2$export$70a0c2f5862937b6 = (0, $8VIvt.tempSizeWrapper)((0, $87Zya.AlignIcon));
var $679ac2861cb37ac2$export$1b8596b4b0ef673b = (0, $8VIvt.tempSizeWrapper)((0, $8I9KT.AlignLogoCS));
var $679ac2861cb37ac2$export$407687b2dd89cc68 = (0, $8VIvt.createFeatureFlaggedComponent)((0, $4cFVz.JiraAlignIcon), (0, $87Zya.AlignIcon));
var $679ac2861cb37ac2$export$ee11e928d3d045fd = (0, $8VIvt.createFeatureFlaggedComponent)((0, $7VYCY.JiraAlignLogo), (0, $8I9KT.AlignLogoCS));
var $679ac2861cb37ac2$export$c4b5b1f965d8b3eb = (0, $8VIvt.createFeatureFlaggedComponent)((0, $b80fJ.JiraIcon), (0, $jua8c.JiraIcon));
var $679ac2861cb37ac2$export$17d3acb0b4379d02 = (0, $8VIvt.createFeatureFlaggedComponent)((0, $dfI4K.JiraLogo), (0, $b5K36.JiraLogoCS));
var $679ac2861cb37ac2$export$21bfbeb62fdcce8d = (0, $8VIvt.createFeatureFlaggedComponent)((0, $d5SeO.JiraProductDiscoveryIcon), (0, $as6dI.JiraProductDiscoveryIcon));
var $679ac2861cb37ac2$export$c49a2b642fe9eef4 = (0, $8VIvt.createFeatureFlaggedComponent)((0, $9kAuE.JiraProductDiscoveryLogo), (0, $04Bi0.JiraProductDiscoveryLogoCS));
var $679ac2861cb37ac2$export$3c6158790f5e01c4 = (0, $8VIvt.createFeatureFlaggedServiceCollectionComponent)((0, $ggWcZ.JiraServiceManagementIcon), (0, $ijdNw.JiraServiceManagementIcon));
var $679ac2861cb37ac2$export$dabef2be6cd28c20 = (0, $8VIvt.createFeatureFlaggedServiceCollectionComponent)((0, $7uRko.JiraServiceManagementLogo), (0, $dbjyg.JiraServiceManagementLogoCS));
var $679ac2861cb37ac2$export$8d789f76fde3e05 = (0, $8VIvt.createFeatureFlaggedComponent)((0, $kb8Bx.LoomIcon), (0, $eLaBI.LoomIcon));
var $679ac2861cb37ac2$export$94e206806e36c2ec = (0, $8VIvt.createFeatureFlaggedComponent)((0, $9cPpa.LoomLogo), (0, $b6zdK.LoomLogoCS));
var $679ac2861cb37ac2$export$1bf47cdade1a9fcb = (0, $8VIvt.createFeatureFlaggedComponent)((0, $cKMMr.LoomAttributionIcon), (0, $eLaBI.LoomIcon));
var $679ac2861cb37ac2$export$6e87ce8d41eda665 = (0, $8VIvt.createFeatureFlaggedComponent)((0, $1IYzI.LoomAttributionLogo), (0, $iWe5o.LoomAttributionLogoCS));
var $679ac2861cb37ac2$export$e84e925618e0e5bc = (0, $8VIvt.tempSizeWrapper)((0, $b0jBl.LoomInternalLogoCS));
var $679ac2861cb37ac2$export$1940ba72c868b663 = (0, $8VIvt.tempSizeWrapper)((0, $dxzOv.LoomInternalIcon));
var $679ac2861cb37ac2$export$eeccc49dc7a12d9f = (0, $8VIvt.createFeatureFlaggedServiceCollectionComponent)((0, $6qbsR.OpsgenieIcon), (0, $3rWiD.OpsgenieIcon));
var $679ac2861cb37ac2$export$a1c6484cdecc2c4b = (0, $8VIvt.createFeatureFlaggedServiceCollectionComponent)((0, $kfv2v.OpsgenieLogo), (0, $5iCT1.OpsgenieLogoCS));
var $679ac2861cb37ac2$export$f3f5aa321d88adf9 = (0, $8VIvt.createFeatureFlaggedServiceCollectionComponent)((0, $3l5GX.StatuspageIcon), (0, $lGzBY.StatuspageIcon));
var $679ac2861cb37ac2$export$bb4ae5b41b43be04 = (0, $8VIvt.createFeatureFlaggedServiceCollectionComponent)((0, $8Ar69.StatuspageLogo), (0, $irena.StatuspageLogoCS));
var $679ac2861cb37ac2$export$4384da9b8b140bf4 = (0, $8VIvt.createFeatureFlaggedComponent)((0, $drVNk.TrelloIcon), (0, $f58QK.TrelloIcon));
var $679ac2861cb37ac2$export$60e26212f3b61a28 = (0, $8VIvt.createFeatureFlaggedComponent)((0, $2hO7t.TrelloLogo), (0, $k99Uz.TrelloLogoCS));
var $679ac2861cb37ac2$export$e23ae35269442b4f = (0, $8VIvt.createFeatureFlaggedRovoComponent)((0, $3Deu1.RovoIcon), (0, $j3Kxp.RovoIcon), (0, $2JaJ7.RovoHexIcon));
var $679ac2861cb37ac2$export$a0f6cb8061290bbb = (0, $8VIvt.createFeatureFlaggedRovoComponent)((0, $gXHVt.RovoLogo), (0, $8Q3Zc.RovoLogoCS), (0, $fmqRP.RovoHexLogoCS));
var $679ac2861cb37ac2$export$3f95fcfdc25a741d = (0, $8VIvt.createFeatureFlaggedComponent)((0, $MIVBE.GuardIcon), (0, $iGWzy.GuardIcon));
var $679ac2861cb37ac2$export$a4a891d202775deb = (0, $8VIvt.createFeatureFlaggedComponent)((0, $7jJm4.GuardLogo), (0, $OtwCy.GuardLogoCS));
var $679ac2861cb37ac2$export$1e02e7298035a77c = (0, $8VIvt.createFeatureFlaggedComponent)((0, $kzQer.FocusIcon), (0, $6VWeS.FocusIcon));
var $679ac2861cb37ac2$export$33908560ea1b226d = (0, $8VIvt.createFeatureFlaggedComponent)((0, $eiyYh.FocusLogo), (0, $jwoQS.FocusLogoCS));

});
parcelRegister("4Kdh6", function(module, exports) {
$parcel$export(module.exports, "AdminIcon", () => $3745c166753a636e$export$ef8e5f836dd989d3);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ced2179e9e0992ccb4af61b51b4f10a3>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

var $6S9Aj = parcelRequire("6S9Aj");
// `height` is set to 100% to allow the SVG to scale with the parent element
var $3745c166753a636e$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" fill-rule=\"evenodd\" d=\"M10.444 5h3.111l.98 2.61 2.75-.457 1.555 2.694L17.07 12l1.77 2.153-1.555 2.694-2.75-.457-.979 2.61h-3.11l-.98-2.61-2.75.457-1.555-2.694L6.931 12 5.16 9.847l1.555-2.694 2.75.457zM12 14.625a2.625 2.625 0 1 0 0-5.25 2.625 2.625 0 0 0 0 5.25\" clip-rule=\"evenodd\"/>\n</svg>\n";
function $3745c166753a636e$export$ef8e5f836dd989d3(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Admin' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $6S9Aj.IconWrapper), {
        svg: $3745c166753a636e$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("gVGtb", function(module, exports) {
$parcel$export(module.exports, "AdminLogoCS", () => $c532e9cd9870e6b1$export$61afcb38c001e19);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::58c9ee3b4e44f14aa5c8a2e33c7dac51>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

var $jU1LC = parcelRequire("jU1LC");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $c532e9cd9870e6b1$var$svg = "<svg height=\"100%\" viewBox=\"0 0 126 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M124.84 16.35v8.99h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.51c.98-1.81 2.79-2.82 4.85-2.82 3.53 0 5.55 2.42 5.55 6.66m-20.15-10.4c0-1.17.77-1.84 1.84-1.84s1.84.67 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-14.07-8.52v8.53h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.51c.98-1.81 2.79-2.82 4.85-2.82 2.61 0 4.39 1.32 5.15 3.74.86-2.36 2.91-3.74 5.46-3.74 3.44 0 5.34 2.33 5.34 6.66v8.99h-2.64v-8.52c0-3.16-1.1-4.72-3.62-4.72-2.45 0-4.14 1.63-4.14 4.72m-28.32.85c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V3.59h2.64v21.74zm-22.02-4.01c-1.53 0-3.1-.18-4.81-.52l-1.69 4.54h-3.1l7.94-20.15h3.5l7.94 20.15h-3.1l-1.69-4.57c-1.81.37-3.37.55-5 .55m0-2.45c1.29 0 2.61-.15 4.17-.4L49.53 7.43 45.45 18.5c1.5.25 2.76.37 3.99.37\"/>\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" fill-rule=\"evenodd\" d=\"M13.826 6.4h4.255l1.338 3.569 3.76-.626 2.128 3.684-2.422 2.945 2.421 2.943L23.18 22.6l-3.76-.626-1.338 3.57h-4.255l-1.338-3.57-3.76.625L6.6 18.915l2.421-2.943L6.6 13.028l2.127-3.685 3.76.626zm2.128 13.16a3.59 3.59 0 1 0 0-7.178 3.59 3.59 0 0 0 0 7.179\" clip-rule=\"evenodd\"/>\n</svg>\n";
function $c532e9cd9870e6b1$export$61afcb38c001e19(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Admin' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $jU1LC.LogoWrapper), {
        svg: $c532e9cd9870e6b1$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});
parcelRegister("jU1LC", function(module, exports) {
$parcel$export(module.exports, "LogoWrapper", () => $e7d49e32ad4f200f$export$f827d3c5a9c3f644);
/* logo-wrapper.tsx generated by @compiled/babel-plugin v0.39.1 */ /* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ 
var $5FkrB = parcelRequire("5FkrB");

var $5EqJ2 = parcelRequire("5EqJ2");

var $9Zzpd = parcelRequire("9Zzpd");

var $8zwGK = parcelRequire("8zwGK");
var $e7d49e32ad4f200f$var$styles = {
    root: "_1e0c1o8l _vwz4idpf",
    TEMP_assets: "_9aea1fkg"
};
// These styles set the `color` property so that the child SVG can inherit the correct text color using "currentColor"
var $e7d49e32ad4f200f$var$logoTextColorMap = {
    light: "_syazqlpt",
    dark: "_syazz6c6"
};
var $e7d49e32ad4f200f$var$sizeMap = {
    xxsmall: "_4t3i7vkz",
    xsmall: "_4t3igktf",
    small: "_4t3i1tcg",
    medium: "_4t3izwfg",
    large: "_4t3i1ylp",
    xlarge: "_4t3ickbl"
};
/* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ var $e7d49e32ad4f200f$var$textLightAppearanceMap = {
    brand: "_1wyci7uo",
    neutral: "_1wyc1e01",
    inverse: "_1wycu67f",
    legacy: "_1wycu67f"
};
/* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ var $e7d49e32ad4f200f$var$textDarkAppearanceMap = {
    brand: "_1wyci7uo",
    neutral: "_1wyc1gvk",
    inverse: "_1wyc5a6q",
    legacy: "_1wycu67f"
};
/* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ var $e7d49e32ad4f200f$var$cloudLightAppearanceMap = {
    brand: "_1b3i18uv _9aea18uv",
    neutral: "_1b3i1e01 _9aea1fkg",
    inverse: "_1b3i5a6q _9aeau67f",
    legacy: "_1b3iu67f _9aeadoyu"
};
/* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ var $e7d49e32ad4f200f$var$cloudDarkAppearanceMap = {
    brand: "_1b3i18uv _9aea18uv",
    neutral: "_1b3i1gvk _9aea8hz0",
    inverse: "_1b3iu67f _9aea5a6q",
    legacy: "_1b3iu67f _9aeadoyu"
};
/* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ var $e7d49e32ad4f200f$var$dataCenterLightAppearanceMap = {
    brand: "_1b3idoyu _9aeau67f _3wu01fkg",
    neutral: "_1b3i1e01 _9aea1fkg _3wu01e01",
    inverse: "_1b3iu67f _9aeaqlpt _3wu0u67f",
    legacy: "_1b3idoyu _9aeau67f _3wu01fkg"
};
/* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ var $e7d49e32ad4f200f$var$dataCenterDarkAppearanceMap = {
    brand: "_1b3idoyu _9aeaqlpt _3wu08hz0",
    neutral: "_1b3i1gvk _9aea8hz0 _3wu01gvk",
    inverse: "_1b3i1501 _9aeau67f _3wu01501",
    legacy: "_1b3idoyu _9aeaqlpt _3wu08hz0"
};
var $e7d49e32ad4f200f$var$rovoDarkAppearanceMap = {
    brand: "_1703lrxy _1evoh727 _epb51yy8 _1osdxeun",
    neutral: "_17031gvk _1evo1gvk _epb51gvk _1osd1gvk",
    inverse: "_1703qlpt _1evoqlpt _epb5qlpt _1osdqlpt",
    legacy: "_1703doyu _1evodoyu _epb5doyu _1osddoyu"
};
var $e7d49e32ad4f200f$var$rovoLightAppearanceMap = {
    brand: "_170318uv _1evo18uv _epb518uv _1osd18uv",
    neutral: "_17031e01 _1evo1e01 _epb51e01 _1osd1e01",
    inverse: "_1703u67f _1evou67f _epb5u67f _1osdu67f",
    legacy: "_1703doyu _1evodoyu _epb5doyu _1osddoyu"
};
function $e7d49e32ad4f200f$export$f827d3c5a9c3f644(_ref) {
    var _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$size = _ref.size, size = _ref$size === void 0 ? 'small' : _ref$size, svg = _ref.svg, customThemeSvg = _ref.customThemeSvg, label = _ref.label, userDefinedTestId = _ref.testId, customIconColor = _ref.iconColor, customTextColor = _ref.textColor, _ref$isAssets = _ref.isAssets, isAssets = _ref$isAssets === void 0 ? false : _ref$isAssets, _ref$type = _ref.type, type = _ref$type === void 0 ? 'tile' : _ref$type;
    var _useThemeObserver = (0, $8zwGK.default)(), colorMode = _useThemeObserver.colorMode;
    var testId = userDefinedTestId && "".concat(userDefinedTestId, "--wrapper");
    var isCustomThemed = customThemeSvg && (customIconColor || customTextColor);
    return /*#__PURE__*/ $5FkrB.createElement("span", {
        style: {
            // Nav v3 passes in "inherit" incorrectly for iconColor, so we fall back to textColor when this happens.
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            '--themed-icon-color': customIconColor === 'inherit' ? customTextColor : customIconColor,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            '--themed-text-color': customTextColor || 'inherit'
        },
        "data-testid": testId,
        "aria-label": label ? label : undefined,
        role: label ? 'img' : undefined,
        "aria-hidden": label === '' ? true : undefined,
        dangerouslySetInnerHTML: {
            __html: isCustomThemed ? customThemeSvg : svg
        },
        className: (0, $5EqJ2.default)([
            $e7d49e32ad4f200f$var$styles.root,
            // Setting the color so that the SVG can inherit the correct text color using "currentColor"
            $e7d49e32ad4f200f$var$logoTextColorMap[colorMode !== null && colorMode !== void 0 ? colorMode : 'light'],
            $e7d49e32ad4f200f$var$sizeMap[size],
            colorMode === 'dark' ? $e7d49e32ad4f200f$var$textDarkAppearanceMap[appearance] : $e7d49e32ad4f200f$var$textLightAppearanceMap[appearance],
            colorMode === 'dark' ? $e7d49e32ad4f200f$var$dataCenterDarkAppearanceMap[appearance] : $e7d49e32ad4f200f$var$dataCenterLightAppearanceMap[appearance],
            type === 'rovo' ? colorMode === 'dark' ? $e7d49e32ad4f200f$var$rovoDarkAppearanceMap[appearance] : $e7d49e32ad4f200f$var$rovoLightAppearanceMap[appearance] : colorMode === 'dark' ? $e7d49e32ad4f200f$var$cloudDarkAppearanceMap[appearance] : $e7d49e32ad4f200f$var$cloudLightAppearanceMap[appearance],
            isAssets && appearance === 'brand' && (0, $9Zzpd.fg)('assets-platform-branding') && $e7d49e32ad4f200f$var$styles.TEMP_assets
        ])
    });
}

});


parcelRegister("87Zya", function(module, exports) {
$parcel$export(module.exports, "AlignIcon", () => $5eaeb8bd0ce37261$export$70a0c2f5862937b6);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::9c308d558bb8f01b0a6c887a98e5347d>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

var $6S9Aj = parcelRequire("6S9Aj");
// `height` is set to 100% to allow the SVG to scale with the parent element
var $5eaeb8bd0ce37261$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#fb9700)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M18.545 18.545a4.49 4.49 0 0 0-4.48-4.48h-4.13v-3.78h-4.48v7.434c0 .576.25.826.826.826zM5.455 5.455a4.454 4.454 0 0 0 4.455 4.48h4.155v3.78h4.48V6.28q0-.825-.826-.826z\"/>\n</svg>\n";
function $5eaeb8bd0ce37261$export$70a0c2f5862937b6(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Align' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $6S9Aj.IconWrapper), {
        svg: $5eaeb8bd0ce37261$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("8I9KT", function(module, exports) {
$parcel$export(module.exports, "AlignLogoCS", () => $6579fff9c770ce06$export$8b5103382c06639c);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4d1c9f8765265019cd33e94ea5235515>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

var $jU1LC = parcelRequire("jU1LC");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $6579fff9c770ce06$var$svg = "<svg height=\"100%\" viewBox=\"0 0 106 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M105.76 16.35v8.99h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.63V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 3.53 0 5.55 2.42 5.55 6.66m-19.6 7.75v-1.53c-.98 2.02-2.82 3.07-5.18 3.07-4.05 0-6.07-3.46-6.07-7.97 0-4.32 2.12-7.97 6.38-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.58v13.95c0 4.51-2.12 7.54-7.61 7.54-2.58 0-3.99-.34-5.46-.83v-2.58c1.69.55 3.43.92 5.34.92 3.83 0 5.15-2.05 5.15-4.91m-8.68-6.44c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52M68.73 5.95c0-1.17.77-1.84 1.84-1.84s1.84.67 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-2.54-.03c-.21.06-.67.12-1.35.12-2.51 0-4.11-1.19-4.11-4.02V3.59h2.64V21.1c0 1.38.92 1.87 2.06 1.87.28 0 .46 0 .77-.03zM49.6 21.32c-1.53 0-3.1-.18-4.82-.52l-1.69 4.54H40l7.94-20.15h3.5l7.94 20.15h-3.1l-1.69-4.57c-1.81.37-3.37.55-5 .55m0-2.45c1.29 0 2.61-.15 4.17-.4L49.68 7.43 45.6 18.5c1.5.25 2.76.37 3.99.37\"/>\n    <path fill=\"var(--tile-color,#fb9700)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M23.735 23.735c0-2.928-2.396-5.295-5.295-5.295h-4.88v-4.466H8.265v8.785c0 .68.296.976.976.976zM8.265 8.265c0 2.928 2.337 5.295 5.265 5.295h4.91v4.466h5.295V9.241q0-.976-.976-.976z\"/>\n</svg>\n";
function $6579fff9c770ce06$export$8b5103382c06639c(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Align' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $jU1LC.LogoWrapper), {
        svg: $6579fff9c770ce06$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("bQu6s", function(module, exports) {
$parcel$export(module.exports, "AnalyticsIcon", () => $89fbe6e8b8762c1f$export$af3460f51ce3602a);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::5edf47443601d30b199c36fbcc7b1d7c>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

var $6S9Aj = parcelRequire("6S9Aj");
// `height` is set to 100% to allow the SVG to scale with the parent element
var $89fbe6e8b8762c1f$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M14.63 5.88v9.19h3.06v-9.2zM5.88 18.13h11.81v-1.75H5.87zm0-3.07v-4.81h3.06v4.81zm4.37-6.56v6.56h3.06V8.5z\"/>\n</svg>\n";
function $89fbe6e8b8762c1f$export$af3460f51ce3602a(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Analytics' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $6S9Aj.IconWrapper), {
        svg: $89fbe6e8b8762c1f$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("hQCOF", function(module, exports) {
$parcel$export(module.exports, "AnalyticsLogoCS", () => $cfe5671694be6ac9$export$f0bac2b7ac3e3504);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::843c7beab94f5191123277c61cbca79e>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

var $jU1LC = parcelRequire("jU1LC");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $cfe5671694be6ac9$var$svg = "<svg height=\"100%\" viewBox=\"0 0 161 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M160.66 21.16c0 2.55-1.66 4.48-5.76 4.48-2.3 0-4.17-.52-5.34-1.13v-2.79c1.32.77 3.53 1.5 5.46 1.5 2.02 0 3.07-.83 3.07-2.02 0-1.17-.89-1.84-3.8-2.55-3.4-.83-4.85-2.15-4.85-4.66 0-2.67 2.06-4.29 5.55-4.29 1.99 0 3.8.49 4.94 1.1v2.73c-1.84-.92-3.34-1.41-4.97-1.41-1.93 0-2.97.67-2.97 1.87 0 1.07.74 1.75 3.56 2.42 3.4.83 5.12 2.09 5.12 4.75m-13.6 1.41v2.36c-.92.49-2.33.71-3.74.71-5.46 0-8-3.31-8-8 0-4.63 2.55-7.94 8-7.94 1.38 0 2.45.18 3.65.74v2.45c-.98-.46-2.02-.74-3.47-.74-3.99 0-5.61 2.52-5.61 5.49s1.66 5.49 5.67 5.49c1.56 0 2.55-.21 3.5-.55M129.13 5.95c0-1.16.77-1.84 1.84-1.84s1.84.68 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-7.46-4.75c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55c-.46.12-.98.25-1.78.25-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zm-14.12 3.77h-1.72L100.77 10h2.82l4.91 13.13L113.41 10h2.82l-5.8 14.84c-1.72 4.39-2.7 6.66-6.59 6.66-1.32 0-2.05-.12-2.82-.43V28.8c.89.28 1.9.37 2.67.37 2.15 0 3.1-1.47 4.36-4.81m-7.8.94c-.21.06-.67.12-1.35.12-2.51 0-4.11-1.19-4.11-4.02V3.59h2.64V21.1c0 1.38.92 1.87 2.06 1.87.28 0 .46 0 .77-.03zM79.5 17.67c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.47-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zM74.1 16.35v8.99h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.63V10h2.64v2.51c.98-1.81 2.79-2.82 4.85-2.82 3.53 0 5.55 2.42 5.55 6.66m-24.66 4.97c-1.53 0-3.1-.18-4.81-.52l-1.69 4.54h-3.1l7.94-20.15h3.5l7.94 20.15h-3.1l-1.69-4.57c-1.81.37-3.37.55-5 .55m0-2.45c1.29 0 2.61-.15 4.17-.4L49.53 7.43 45.45 18.5c1.5.25 2.76.37 3.99.37\"/>\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M19.5 7.83v12.25h4.08V7.83zM7.83 24.17h15.75v-2.33H7.83zm0-4.09v-6.42h4.08v6.42zm5.84-8.75v8.75h4.08v-8.75z\"/>\n</svg>\n";
function $cfe5671694be6ac9$export$f0bac2b7ac3e3504(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Analytics' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $jU1LC.LogoWrapper), {
        svg: $cfe5671694be6ac9$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("k6Cb9", function(module, exports) {
$parcel$export(module.exports, "AssetsIcon", () => $ea31fbb0ed517f07$export$d89497e7f33ca6f5);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6ef8f48b1d072b5b8a0869540d1f52a5>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

var $6S9Aj = parcelRequire("6S9Aj");
// `height` is set to 100% to allow the SVG to scale with the parent element
var $ea31fbb0ed517f07$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#ffc716)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" fill-rule=\"evenodd\" d=\"M8.34 11.495a3.64 3.64 0 0 0 3.155-3.154h2.3V6.523h-2.537a3.638 3.638 0 1 0-4.735 4.735v2.538H8.34zM7.887 9.25a1.364 1.364 0 1 0 0-2.727 1.364 1.364 0 0 0 0 2.727\" clip-rule=\"evenodd\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M19.25 7.43a2.27 2.27 0 1 1-4.54 0 2.27 2.27 0 0 1 4.55 0M7.43 19.25a2.27 2.27 0 1 0 0-4.54 2.27 2.27 0 0 0 0 4.55m9.55-.01a2.27 2.27 0 1 0 0-4.54 2.27 2.27 0 0 0 0 4.55m-3.18-3.19h-3.18v1.82h3.18zm2.27-5.46v3.18h1.82v-3.18z\"/>\n</svg>\n";
var $ea31fbb0ed517f07$var$customThemeSvg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--themed-icon-color, currentcolor)\" d=\"M18 0a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6V6a6 6 0 0 1 6-6zM7.432 14.704a2.273 2.273 0 1 0 .001 4.547 2.273 2.273 0 0 0-.001-4.547m9.545 0a2.274 2.274 0 1 0 .001 4.548 2.274 2.274 0 0 0 0-4.548m-6.364 1.364v1.819h3.183v-1.819zM7.887 4.25a3.637 3.637 0 0 0-1.365 7.009v2.537h1.819v-2.302a3.64 3.64 0 0 0 3.153-3.153h2.302V6.522h-2.537A3.64 3.64 0 0 0 7.887 4.25m8.181 6.363v3.183h1.819v-3.183zm.91-5.454a2.273 2.273 0 1 0 0 4.547 2.273 2.273 0 0 0 0-4.547M7.887 6.522a1.364 1.364 0 1 1-.002 2.729 1.364 1.364 0 0 1 .002-2.729\"/>\n</svg>\n";
function $ea31fbb0ed517f07$export$d89497e7f33ca6f5(_ref) {
    var iconColor = _ref.iconColor, size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Assets' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $6S9Aj.IconWrapper), {
        svg: $ea31fbb0ed517f07$var$svg,
        customThemeSvg: $ea31fbb0ed517f07$var$customThemeSvg,
        iconColor: iconColor,
        label: label,
        isAssets: true,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("1VDeR", function(module, exports) {
$parcel$export(module.exports, "AssetsLogoCS", () => $16798d4d32a34527$export$81c47abe19675c4c);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3e04e8bc884193d0eee2f110efb35733>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

var $jU1LC = parcelRequire("jU1LC");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $16798d4d32a34527$var$svg = "<svg height=\"100%\" viewBox=\"0 0 126 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M125.8 21.16c0 2.55-1.66 4.48-5.76 4.48-2.3 0-4.17-.52-5.34-1.13v-2.79c1.32.77 3.53 1.5 5.46 1.5 2.02 0 3.07-.83 3.07-2.02 0-1.16-.89-1.84-3.8-2.54-3.4-.83-4.84-2.15-4.84-4.66 0-2.67 2.06-4.29 5.55-4.29 1.99 0 3.8.49 4.94 1.1v2.73c-1.84-.92-3.34-1.41-4.97-1.41-1.93 0-2.97.67-2.97 1.87 0 1.07.74 1.75 3.56 2.42 3.4.83 5.12 2.09 5.12 4.75m-17.77-.59c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55c-.46.12-.98.25-1.78.25-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zm-13.53-8.5c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.2c.37 2.61 2.05 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-15.13-3.56c0 2.55-1.66 4.48-5.77 4.48-2.3 0-4.17-.52-5.34-1.13v-2.79c1.32.77 3.53 1.5 5.46 1.5 2.02 0 3.07-.83 3.07-2.02 0-1.16-.89-1.84-3.8-2.54-3.4-.83-4.85-2.15-4.85-4.66 0-2.67 2.06-4.29 5.55-4.29 1.99 0 3.8.49 4.94 1.1v2.73c-1.84-.92-3.34-1.41-4.97-1.41-1.93 0-2.97.67-2.97 1.87 0 1.07.74 1.75 3.56 2.42 3.4.83 5.12 2.09 5.12 4.75m-13.63-.01c0 2.55-1.66 4.48-5.76 4.48-2.3 0-4.17-.52-5.34-1.13v-2.79c1.32.77 3.53 1.5 5.46 1.5 2.02 0 3.07-.83 3.07-2.02 0-1.16-.89-1.84-3.8-2.54-3.4-.83-4.84-2.15-4.84-4.66 0-2.67 2.06-4.29 5.55-4.29 1.99 0 3.8.49 4.94 1.1v2.73c-1.84-.92-3.34-1.41-4.97-1.41-1.93 0-2.97.67-2.97 1.87 0 1.07.74 1.75 3.56 2.42 3.4.83 5.12 2.09 5.12 4.75m-22.22.15c-1.53 0-3.1-.18-4.81-.52l-1.69 4.54h-3.1l7.94-20.15h3.5l7.94 20.15h-3.1l-1.69-4.57c-1.81.37-3.37.55-5 .55m0-2.45c1.29 0 2.61-.15 4.17-.4L49.53 7.43 45.45 18.5c1.5.25 2.76.37 3.99.37\"/>\n    <path fill=\"var(--tile-color,#ffc716)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" fill-rule=\"evenodd\" d=\"M11.667 15.425a4.335 4.335 0 0 0 3.758-3.758h2.742V9.5h-3.023A4.335 4.335 0 1 0 9.5 15.144v3.023h2.167zm-.542-2.675a1.625 1.625 0 1 0 0-3.25 1.625 1.625 0 0 0 0 3.25\" clip-rule=\"evenodd\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M24.67 10.58a2.71 2.71 0 1 1-5.42 0 2.71 2.71 0 0 1 5.42 0M10.58 24.67a2.71 2.71 0 1 0 0-5.42 2.71 2.71 0 0 0 0 5.42m11.38 0a2.71 2.71 0 1 0 0-5.42 2.71 2.71 0 0 0 0 5.42m-3.79-3.79h-3.79v2.17h3.79zm2.71-6.5v3.79h2.17v-3.79z\"/>\n</svg>\n";
function $16798d4d32a34527$export$81c47abe19675c4c(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Assets' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $jU1LC.LogoWrapper), {
        svg: $16798d4d32a34527$var$svg,
        label: label,
        isAssets: true,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("4ciqS", function(module, exports) {
$parcel$export(module.exports, "BambooIcon", () => $30e694bb94d913c5$export$e812398311cab9a3);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::74f0ca66b8bc3995f7a9817f08a67d6f>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

var $6S9Aj = parcelRequire("6S9Aj");
// `height` is set to 100% to allow the SVG to scale with the parent element
var $30e694bb94d913c5$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color, white)\" d=\"M6 .5h12A5.5 5.5 0 0 1 23.5 6v12a5.5 5.5 0 0 1-5.5 5.5H6A5.5 5.5 0 0 1 .5 18V6A5.5 5.5 0 0 1 6 .5\"/>\n    <path fill=\"none\" stroke=\"var(--border-color, #dddee1)\" d=\"M6 .5h12A5.5 5.5 0 0 1 23.5 6v12a5.5 5.5 0 0 1-5.5 5.5H6A5.5 5.5 0 0 1 .5 18V6A5.5 5.5 0 0 1 6 .5Z\"/>\n    <path fill=\"var(--icon-color, #1868db)\" d=\"M9.215 12.652a2.75 2.75 0 0 0 2.749 2.742v4.205a6.964 6.964 0 0 1-6.849-5.727l-.049-.317zm9.26 0a.44.44 0 0 1 .436.468c-.222 3.311-2.783 5.989-6.043 6.414l-.904-4.14a2.75 2.75 0 0 0 2.723-2.37.44.44 0 0 1 .44-.372zM11.963 9.91a2.75 2.75 0 0 0-2.748 2.742H5v-.065c.033-3.495 2.668-6.374 6.059-6.816zm0-5.972a.436.436 0 0 1 .72-.33l4.824 4.138a.436.436 0 0 1 0 .662l-4.823 4.139a.436.436 0 0 1-.72-.331z\"/>\n</svg>\n";
function $30e694bb94d913c5$export$e812398311cab9a3(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Bamboo' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $6S9Aj.IconWrapper), {
        svg: $30e694bb94d913c5$var$svg,
        label: label,
        type: "data-center",
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("8E05W", function(module, exports) {
$parcel$export(module.exports, "BambooLogoCS", () => $64b222020a38b46f$export$7c51958462d750e);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::5436ab9ea17c11b656095d6ae713006c>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

var $jU1LC = parcelRequire("jU1LC");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $64b222020a38b46f$var$svg = "<svg height=\"100%\" viewBox=\"0 0 154 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M146 25.64c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49m-16.68 13.49c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49m-12.07 5.52c0-3.68-1.47-5.52-4.2-5.52-2.36 0-4.48 1.5-4.48 4.91v1.23c0 3.4 1.93 4.91 4.17 4.91 2.98 0 4.51-1.96 4.51-5.52m-3.8 7.97c-2.24 0-3.96-1.01-4.88-3v2.7h-2.64V3.59h2.64v9.17c.98-2.02 2.82-3.07 5.18-3.07 4.08 0 6.13 3.47 6.13 7.97 0 4.32-2.15 7.97-6.44 7.97m-21.58-8.82v8.53h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 2.61 0 4.39 1.32 5.15 3.74.86-2.36 2.91-3.74 5.46-3.74 3.43 0 5.34 2.33 5.34 6.66v8.99h-2.64v-8.52c0-3.16-1.1-4.72-3.62-4.72-2.45 0-4.14 1.63-4.14 4.72m-28.32.84c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-20.23-9.04H45.8v6.29h6.26c2.64 0 3.83-.95 3.83-2.97 0-2.15-1.13-3.31-3.89-3.31m-.89-8.46h-5.3v6.01h5.31c2.61 0 3.68-1.2 3.68-3.13 0-1.96-1.16-2.88-3.68-2.88m-8.06 17.51V5.19h8.43c4.11 0 6.1 2.02 6.1 5.28 0 2.42-1.1 3.93-3.37 4.48 2.97.49 4.45 2.12 4.45 4.97 0 3.22-2.18 5.43-6.68 5.43z\"/>\n    <path fill=\"var(--tile-color, white)\" d=\"M8 .667h16A7.333 7.333 0 0 1 31.333 8v16A7.333 7.333 0 0 1 24 31.333H8A7.333 7.333 0 0 1 .667 24V8A7.333 7.333 0 0 1 8 .667\"/>\n    <path fill=\"none\" stroke=\"var(--border-color, #dddee1)\" stroke-width=\"1.333\" d=\"M8 .667h16A7.333 7.333 0 0 1 31.333 8v16A7.333 7.333 0 0 1 24 31.333H8A7.333 7.333 0 0 1 .667 24V8A7.333 7.333 0 0 1 8 .667Z\"/>\n    <path fill=\"var(--icon-color, #1868db)\" d=\"M12.287 16.869a3.665 3.665 0 0 0 3.665 3.656v5.607c-4.71 0-8.602-3.52-9.196-8.06zm12.347 0a.584.584 0 0 1 .581.624c-.295 4.415-3.71 7.986-8.057 8.554l-1.206-5.521a3.67 3.67 0 0 0 3.63-3.161.59.59 0 0 1 .589-.496zm-8.683-3.656a3.664 3.664 0 0 0-3.665 3.656h-5.62v-.088c.044-4.66 3.557-8.498 8.078-9.088zm0-7.964a.58.58 0 0 1 .96-.44l6.432 5.518c.27.232.27.65 0 .883l-6.431 5.517a.581.581 0 0 1-.96-.44z\"/>\n</svg>\n";
function $64b222020a38b46f$export$7c51958462d750e(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Bamboo' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $jU1LC.LogoWrapper), {
        svg: $64b222020a38b46f$var$svg,
        label: label,
        type: "data-center",
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("iZ1Si", function(module, exports) {
$parcel$export(module.exports, "BitbucketIcon", () => $dd1f60cf5070a57d$export$5fc1066e677788d4);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::83bd991a11895fc697ec86ba4d2d82c2>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

var $6S9Aj = parcelRequire("6S9Aj");
// `height` is set to 100% to allow the SVG to scale with the parent element
var $dd1f60cf5070a57d$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#94c748)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"m17.898 11.353-.994 6.064c-.065.367-.324.583-.691.583H7.787c-.367 0-.627-.216-.691-.583L5.346 6.604C5.28 6.237 5.476 6 5.82 6h12.358c.346 0 .54.237.475.604l-.475 2.85c-.065.41-.303.582-.691.582h-7.432c-.109 0-.173.065-.152.194l.584 3.583c.021.086.086.151.172.151h2.68c.086 0 .15-.065.172-.151l.41-2.59c.044-.324.26-.453.563-.453H17.4c.432 0 .562.216.497.582\"/>\n</svg>\n";
var $dd1f60cf5070a57d$var$customThemeSvg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--themed-icon-color, currentcolor)\" d=\"M18 0a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6V6a6 6 0 0 1 6-6zM5.821 6c-.345 0-.54.238-.475.604l1.75 10.813c.065.367.324.583.691.583h8.426c.367 0 .627-.216.691-.583l.994-6.065c.065-.366-.065-.582-.497-.582h-2.917c-.302 0-.518.13-.561.453l-.41 2.59c-.022.086-.087.15-.173.15h-2.68c-.086 0-.151-.064-.173-.15l-.583-3.583c-.021-.129.044-.194.152-.194h7.431c.39 0 .627-.173.692-.583l.475-2.849c.065-.366-.13-.604-.475-.604z\"/>\n</svg>\n";
function $dd1f60cf5070a57d$export$5fc1066e677788d4(_ref) {
    var iconColor = _ref.iconColor, size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Bitbucket' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $6S9Aj.IconWrapper), {
        svg: $dd1f60cf5070a57d$var$svg,
        customThemeSvg: $dd1f60cf5070a57d$var$customThemeSvg,
        iconColor: iconColor,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("9LYU9", function(module, exports) {
$parcel$export(module.exports, "BitbucketLogoCS", () => $71d7bf3e132a14f1$export$f7ef5e5488e4b430);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7131ffd6f745f530e9a82fe4842b6a8c>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

var $jU1LC = parcelRequire("jU1LC");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $71d7bf3e132a14f1$var$svg = "<svg height=\"100%\" viewBox=\"0 0 166 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M161.21 20.58c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55a6.3 6.3 0 0 1-1.78.25c-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zm-13.53-8.49c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.67-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.05 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-23.83.6h-2.64V3.59h2.64v13.59l6.6-7.18h3.44l-7.21 7.54 7.51 7.79h-3.59l-6.75-7.18zm-5.64-2.76v2.36c-.92.49-2.33.71-3.74.71-5.46 0-8-3.31-8-8 0-4.63 2.55-7.94 8-7.94 1.38 0 2.45.18 3.65.74v2.45c-.98-.46-2.02-.74-3.46-.74-3.99 0-5.61 2.52-5.61 5.49s1.66 5.49 5.67 5.49c1.56 0 2.55-.21 3.5-.55m-27.86-3.59V10h2.64v9.26c0 2.76 1.1 3.99 3.62 3.99 2.45 0 4.14-1.63 4.14-4.72V10h2.64v15.33h-2.64v-2.51c-.98 1.81-2.79 2.82-4.84 2.82-3.53 0-5.55-2.42-5.55-6.65m-5.4-1.32c0-3.68-1.47-5.52-4.2-5.52-2.36 0-4.48 1.5-4.48 4.91v1.23c0 3.4 1.93 4.91 4.17 4.91 2.98 0 4.51-1.96 4.51-5.52m-3.8 7.97c-2.24 0-3.96-1.01-4.88-3v2.7h-2.64V3.59h2.64v9.17c.98-2.02 2.82-3.07 5.18-3.07 4.08 0 6.13 3.47 6.13 7.97 0 4.32-2.15 7.97-6.44 7.97m-14.96-5.05c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55c-.46.12-.98.25-1.78.25-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zM61.33 5.95c0-1.16.77-1.84 1.84-1.84s1.84.68 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-9.83-9.04H45.8v6.29h6.26c2.64 0 3.83-.95 3.83-2.97 0-2.15-1.13-3.31-3.89-3.31m-.89-8.46h-5.3v6.01h5.31c2.61 0 3.68-1.2 3.68-3.13 0-1.96-1.17-2.88-3.68-2.88m-8.06 17.51V5.19h8.43c4.11 0 6.1 2.02 6.1 5.27 0 2.42-1.1 3.93-3.37 4.48 2.97.49 4.45 2.12 4.45 4.97 0 3.22-2.18 5.43-6.69 5.43z\"/>\n    <path fill=\"var(--tile-color,#94c748)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"m23.79 15.684-1.315 8.032c-.085.486-.428.772-.914.772H10.413c-.486 0-.829-.286-.915-.772L7.183 9.396c-.086-.486.172-.8.629-.8h16.35c.457 0 .714.314.629.8l-.63 3.773c-.085.543-.4.772-.914.772h-9.833c-.143 0-.228.086-.2.257l.772 4.745c.029.114.114.2.229.2h3.544c.114 0 .2-.086.229-.2l.543-3.43c.057-.429.343-.6.743-.6h3.859c.572 0 .743.285.657.771\"/>\n</svg>\n";
function $71d7bf3e132a14f1$export$f7ef5e5488e4b430(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Bitbucket' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $jU1LC.LogoWrapper), {
        svg: $71d7bf3e132a14f1$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("3cSVw", function(module, exports) {
$parcel$export(module.exports, "BitbucketDataCenterIcon", () => $255d1961ac535130$export$d3ab16bbf4f954ee);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::61dd349b817df11b196de45b8945fcdf>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

var $6S9Aj = parcelRequire("6S9Aj");
// `height` is set to 100% to allow the SVG to scale with the parent element
var $255d1961ac535130$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color, white)\" d=\"M6 .5h12A5.5 5.5 0 0 1 23.5 6v12a5.5 5.5 0 0 1-5.5 5.5H6A5.5 5.5 0 0 1 .5 18V6A5.5 5.5 0 0 1 6 .5\"/>\n    <path fill=\"none\" stroke=\"var(--border-color, #dddee1)\" d=\"M6 .5h12A5.5 5.5 0 0 1 23.5 6v12a5.5 5.5 0 0 1-5.5 5.5H6A5.5 5.5 0 0 1 .5 18V6A5.5 5.5 0 0 1 6 .5Z\"/>\n    <path fill=\"var(--icon-color, #1868db)\" d=\"m17.843 11.763-.986 6.024c-.065.365-.322.58-.686.58H7.81c-.365 0-.622-.215-.686-.58L5.387 7.047c-.064-.364.129-.6.472-.6h12.262c.343 0 .536.236.472.6l-.472 2.83c-.064.407-.3.579-.686.579h-7.374c-.107 0-.172.064-.15.193l.579 3.558c.021.086.085.15.171.15h2.658c.086 0 .15-.064.172-.15l.407-2.572c.043-.322.257-.45.558-.45h2.894c.428 0 .557.214.493.578\"/>\n</svg>\n";
function $255d1961ac535130$export$d3ab16bbf4f954ee(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Bitbucket Data Center' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $6S9Aj.IconWrapper), {
        svg: $255d1961ac535130$var$svg,
        label: label,
        type: "data-center",
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("BsLUu", function(module, exports) {
$parcel$export(module.exports, "BitbucketDataCenterLogoCS", () => $0709c648fbc31c38$export$cc55e2a4c4b40552);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::68c2bbf4fd6874e93c78c51b9065dc7c>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

var $jU1LC = parcelRequire("jU1LC");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $0709c648fbc31c38$var$svg = "<svg height=\"100%\" viewBox=\"0 0 166 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M161.21 20.58c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55c-.46.12-.98.25-1.78.25-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zm-13.53-8.49c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-23.83.6h-2.64V3.59h2.64v13.59l6.6-7.18h3.44l-7.21 7.54 7.51 7.79h-3.59l-6.75-7.18zm-5.64-2.76v2.36c-.92.49-2.33.71-3.74.71-5.46 0-8-3.31-8-8 0-4.63 2.55-7.94 8-7.94 1.38 0 2.45.18 3.65.74v2.45c-.98-.46-2.02-.74-3.47-.74-3.99 0-5.61 2.51-5.61 5.49s1.66 5.49 5.67 5.49c1.56 0 2.55-.21 3.5-.55m-27.85-3.59V10h2.64v9.26c0 2.76 1.1 3.99 3.62 3.99 2.45 0 4.14-1.62 4.14-4.72V10h2.64v15.33h-2.64v-2.51c-.98 1.81-2.79 2.82-4.85 2.82-3.53 0-5.55-2.42-5.55-6.65m-5.39-1.32c0-3.68-1.47-5.52-4.2-5.52-2.36 0-4.48 1.5-4.48 4.91v1.23c0 3.4 1.93 4.91 4.17 4.91 2.98 0 4.51-1.96 4.51-5.52m-3.8 7.97c-2.24 0-3.96-1.01-4.88-3v2.7h-2.64V3.59h2.64v9.17c.98-2.02 2.82-3.07 5.18-3.07 4.08 0 6.13 3.47 6.13 7.97 0 4.32-2.15 7.97-6.44 7.97m-14.96-5.05c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55a6.3 6.3 0 0 1-1.78.25c-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zM61.33 5.95c0-1.16.77-1.84 1.84-1.84s1.84.68 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-9.83-9.04H45.8v6.29h6.26c2.64 0 3.83-.95 3.83-2.97 0-2.15-1.13-3.31-3.89-3.31m-.89-8.46h-5.3v6.01h5.31c2.61 0 3.68-1.2 3.68-3.13 0-1.96-1.16-2.88-3.68-2.88m-8.06 17.51V5.19h8.43c4.11 0 6.1 2.02 6.1 5.28 0 2.42-1.1 3.93-3.37 4.48 2.97.49 4.45 2.12 4.45 4.97 0 3.22-2.18 5.43-6.68 5.43z\"/>\n    <path fill=\"var(--tile-color, white)\" d=\"M8 .667h16A7.333 7.333 0 0 1 31.333 8v16A7.333 7.333 0 0 1 24 31.333H8A7.333 7.333 0 0 1 .667 24V8A7.333 7.333 0 0 1 8 .667\"/>\n    <path fill=\"none\" stroke=\"var(--border-color, #dddee1)\" stroke-width=\"1.333\" d=\"M8 .667h16A7.333 7.333 0 0 1 31.333 8v16A7.333 7.333 0 0 1 24 31.333H8A7.333 7.333 0 0 1 .667 24V8A7.333 7.333 0 0 1 8 .667Z\"/>\n    <path fill=\"var(--icon-color, #1868db)\" d=\"m23.79 15.684-1.315 8.032c-.085.486-.428.772-.914.772H10.413c-.486 0-.829-.286-.915-.772L7.183 9.396c-.086-.486.172-.8.629-.8h16.35c.457 0 .714.314.629.8l-.63 3.773c-.085.543-.4.772-.914.772h-9.833c-.143 0-.228.086-.2.257l.772 4.745c.028.114.114.2.229.2h3.544c.114 0 .2-.086.229-.2l.543-3.43c.057-.429.343-.6.743-.6h3.859c.571 0 .743.285.657.771\"/>\n</svg>\n";
function $0709c648fbc31c38$export$cc55e2a4c4b40552(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Bitbucket Data Center' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $jU1LC.LogoWrapper), {
        svg: $0709c648fbc31c38$var$svg,
        label: label,
        type: "data-center",
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("d21dh", function(module, exports) {
$parcel$export(module.exports, "ChatIcon", () => $97cc6732066dfb33$export$52cd484a7ef4f2b9);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3a833c6410fabd244b1134a630f9a005>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

var $6S9Aj = parcelRequire("6S9Aj");
// `height` is set to 100% to allow the SVG to scale with the parent element
var $97cc6732066dfb33$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" fill-rule=\"evenodd\" d=\"M10.125 16.5h8.125V6H5.75v13zM12 12.125a.875.875 0 1 0 0-1.75.875.875 0 0 0 0 1.75m4-.875a.875.875 0 1 1-1.75 0 .875.875 0 0 1 1.75 0m-7.125.875a.875.875 0 1 0 0-1.75.875.875 0 0 0 0 1.75\" clip-rule=\"evenodd\"/>\n</svg>\n";
function $97cc6732066dfb33$export$52cd484a7ef4f2b9(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Chat' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $6S9Aj.IconWrapper), {
        svg: $97cc6732066dfb33$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("a0PUs", function(module, exports) {
$parcel$export(module.exports, "ChatLogoCS", () => $74a22ba3e6af2c45$export$a529e78951cd6709);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b3a55f079b563dca3c91045ce0a761dc>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

var $jU1LC = parcelRequire("jU1LC");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $74a22ba3e6af2c45$var$svg = "<svg height=\"100%\" viewBox=\"0 0 102 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M97.51 20.58c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55c-.46.12-.98.25-1.78.25-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zm-18.94-2.91c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.47-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-14.1-8.98v8.99h-2.64v-8.52c0-3.16-1.1-4.72-3.62-4.72-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V3.59h2.64v8.96c1.01-1.81 2.85-2.85 5.06-2.85 3.44 0 5.34 2.33 5.34 6.65m-16.22 5.43v2.67c-1.26.83-3.25 1.2-5.34 1.2-6.62 0-10.36-3.99-10.36-10.33 0-6.13 3.74-10.43 10.3-10.43 1.96 0 3.93.37 5.37 1.41v2.67c-1.44-.92-3.04-1.41-5.37-1.41-4.72 0-7.54 3.13-7.54 7.76s2.91 7.7 7.7 7.7c2.12 0 3.77-.49 5.24-1.23\"/>\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" fill-rule=\"evenodd\" d=\"M24.167 21.834h-10.5l-5.833 3.5v-17.5h16.333zm-12.25-5.833a1.167 1.167 0 1 0 0-2.334 1.167 1.167 0 0 0 0 2.334M16 16a1.167 1.167 0 1 0 0-2.334A1.167 1.167 0 0 0 16 16m5.25-1.167a1.167 1.167 0 1 1-2.334 0 1.167 1.167 0 0 1 2.333 0\" clip-rule=\"evenodd\"/>\n</svg>\n";
function $74a22ba3e6af2c45$export$a529e78951cd6709(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Chat' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $jU1LC.LogoWrapper), {
        svg: $74a22ba3e6af2c45$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("8Xwt9", function(module, exports) {
$parcel$export(module.exports, "ChatNewIcon", () => $685d0524a509dd73$export$402a257da320c93c);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ad5b8ef64559dc5207c779379dec44c9>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

var $6S9Aj = parcelRequire("6S9Aj");
// `height` is set to 100% to allow the SVG to scale with the parent element
var $685d0524a509dd73$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" fill-rule=\"evenodd\" d=\"M18.563 16.688h-8.438L5.438 19.5V5.438h13.125zm-6.83-9.375-.255.647c-.362.92-.543 1.38-.878 1.727-.334.346-.787.543-1.694.938l-.388.17v.535l.388.17c.907.394 1.36.592 1.694.938.335.346.516.807.878 1.727l.255.648h.535l.255-.648c.362-.92.543-1.38.877-1.727.335-.346.788-.544 1.694-.939l.388-.169v-.535l-.388-.17c-.906-.395-1.36-.592-1.694-.938-.334-.347-.515-.807-.877-1.727l-.255-.647z\" clip-rule=\"evenodd\"/>\n</svg>\n";
function $685d0524a509dd73$export$402a257da320c93c(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Chat' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $6S9Aj.IconWrapper), {
        svg: $685d0524a509dd73$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("cnNGt", function(module, exports) {
$parcel$export(module.exports, "ChatNewLogoCS", () => $903e2c3b96286c75$export$a3af32a9109d706d);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::1eb74baaf9574600817f9bd5473029df>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

var $jU1LC = parcelRequire("jU1LC");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $903e2c3b96286c75$var$svg = "<svg height=\"100%\" viewBox=\"0 0 102 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M97.51 20.58c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55c-.46.12-.98.25-1.78.25-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zm-18.94-2.91c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-14.1-8.98v8.99h-2.64v-8.52c0-3.16-1.1-4.72-3.62-4.72-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V3.59h2.64v8.95c1.01-1.81 2.85-2.85 5.06-2.85 3.44 0 5.34 2.33 5.34 6.66m-16.22 5.43v2.67c-1.26.83-3.25 1.2-5.34 1.2-6.62 0-10.36-3.99-10.36-10.33 0-6.13 3.74-10.43 10.3-10.43 1.96 0 3.93.37 5.37 1.41v2.67c-1.44-.92-3.04-1.41-5.37-1.41-4.72 0-7.54 3.13-7.54 7.76s2.91 7.7 7.7 7.7c2.12 0 3.77-.49 5.24-1.23\"/>\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" fill-rule=\"evenodd\" d=\"M24.75 22.25H13.5L7.25 26V7.25h17.5zm-9.107-12.5-.34.864c-.482 1.226-.724 1.84-1.17 2.302s-1.05.725-2.258 1.251l-.518.226v.714l.518.226c1.209.526 1.813.79 2.259 1.251.445.462.687 1.076 1.17 2.303l.34.863h.714l.34-.864c.482-1.227.724-1.84 1.17-2.302s1.049-.725 2.258-1.251l.517-.226v-.714l-.517-.226c-1.21-.526-1.813-.79-2.259-1.251-.445-.462-.687-1.075-1.17-2.302l-.34-.864z\" clip-rule=\"evenodd\"/>\n</svg>\n";
function $903e2c3b96286c75$export$a3af32a9109d706d(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Chat' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $jU1LC.LogoWrapper), {
        svg: $903e2c3b96286c75$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("2VpZv", function(module, exports) {
$parcel$export(module.exports, "CompassIcon", () => $221510edb82f5c66$export$f7857fe64d7161d9);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e5ce5248a23a237688e2341559569305>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

var $6S9Aj = parcelRequire("6S9Aj");
// `height` is set to 100% to allow the SVG to scale with the parent element
var $221510edb82f5c66$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#94c748)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M12.75 7.877v-3.37l6.16-.007h.007a.59.59 0 0 1 .583.598v6.147h-3.366V7.877z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M12.75 14.615v-3.37h3.368v6.165a.59.59 0 0 1-.591.59H6.583A.59.59 0 0 1 6 17.402V8.467a.59.59 0 0 1 .591-.59h6.16v3.368H9.373v3.37z\"/>\n</svg>\n";
function $221510edb82f5c66$export$f7857fe64d7161d9(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Compass' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $6S9Aj.IconWrapper), {
        svg: $221510edb82f5c66$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("f3Gpb", function(module, exports) {
$parcel$export(module.exports, "CompassLogoCS", () => $af6807a36901d44b$export$a16f50a81d183ce);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::bbcc7f43e0a51fb6caa253b27359fb22>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

var $jU1LC = parcelRequire("jU1LC");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $af6807a36901d44b$var$svg = "<svg height=\"100%\" viewBox=\"0 0 162 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M161.79 21.16c0 2.55-1.66 4.48-5.76 4.48-2.3 0-4.17-.52-5.34-1.13v-2.79c1.32.77 3.53 1.5 5.46 1.5 2.02 0 3.07-.83 3.07-2.02 0-1.16-.89-1.84-3.8-2.55-3.4-.83-4.85-2.15-4.85-4.66 0-2.67 2.06-4.29 5.55-4.29 1.99 0 3.8.49 4.94 1.1v2.73c-1.84-.92-3.34-1.41-4.97-1.41-1.93 0-2.97.68-2.97 1.87 0 1.07.74 1.75 3.56 2.42 3.4.83 5.12 2.09 5.12 4.75m-13.63 0c0 2.55-1.66 4.48-5.76 4.48-2.3 0-4.17-.52-5.34-1.13v-2.79c1.32.77 3.53 1.5 5.46 1.5 2.02 0 3.07-.83 3.07-2.02 0-1.16-.89-1.84-3.8-2.55-3.4-.83-4.84-2.15-4.84-4.66 0-2.67 2.06-4.29 5.55-4.29 1.99 0 3.8.49 4.94 1.1v2.73c-1.84-.92-3.34-1.41-4.97-1.41-1.93 0-2.97.68-2.97 1.87 0 1.07.74 1.75 3.56 2.42 3.4.83 5.12 2.09 5.12 4.75m-25.9-3.49c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01v-2.7h2.64v15.33zm-16.09-7.66c0-3.68-1.47-5.52-4.2-5.52-2.36 0-4.48 1.5-4.48 4.91v1.23c0 3.4 1.93 4.91 4.17 4.91 2.98 0 4.51-1.96 4.51-5.52m-3.8 7.97c-2.24 0-3.96-1.01-4.88-3v8.68h-2.64V10h2.64v2.76c.98-2.02 2.82-3.07 5.18-3.07 4.08 0 6.13 3.47 6.13 7.97 0 4.32-2.15 7.97-6.44 7.97M89.5 16.81v8.53h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.51c.98-1.81 2.79-2.82 4.85-2.82 2.61 0 4.39 1.32 5.15 3.74.86-2.36 2.91-3.74 5.46-3.74 3.43 0 5.34 2.33 5.34 6.66v8.99h-2.64v-8.53c0-3.16-1.1-4.72-3.62-4.72-2.45 0-4.14 1.63-4.14 4.72m-23.34 8.83c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49m-9.23 9.63v2.67c-1.26.83-3.25 1.2-5.34 1.2-6.62 0-10.36-3.99-10.36-10.33 0-6.13 3.74-10.43 10.3-10.43 1.96 0 3.93.37 5.37 1.41v2.67c-1.44-.92-3.04-1.41-5.37-1.41-4.72 0-7.54 3.13-7.54 7.76s2.91 7.7 7.7 7.7c2.12 0 3.77-.49 5.24-1.23\"/>\n    <path fill=\"var(--tile-color,#94c748)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M16.69 15.16v4.24h-4.25v-4.24zv-4.24H8.93a.74.74 0 0 0-.74.74v11.25a.74.74 0 0 0 .74.75h11.26a.74.74 0 0 0 .75-.74v-7.76zm0-8.48v4.24h4.26v4.24h4.24V7.42a.74.74 0 0 0-.73-.75h-.01z\"/>\n</svg>\n";
function $af6807a36901d44b$export$a16f50a81d183ce(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Compass' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $jU1LC.LogoWrapper), {
        svg: $af6807a36901d44b$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("f1nD4", function(module, exports) {
$parcel$export(module.exports, "ConfluenceLogoCS", () => $aef9474ac9fe67eb$export$a88b0b0da9ef63ce);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::90f8012e577da50adfff14718da1e4b3>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

var $jU1LC = parcelRequire("jU1LC");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $aef9474ac9fe67eb$var$svg = "<svg height=\"100%\" viewBox=\"0 0 188 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M181.16 12.09c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.2c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-15.1-2.16v2.36c-.92.49-2.33.71-3.74.71-5.46 0-8-3.31-8-8 0-4.63 2.55-7.94 8-7.94 1.38 0 2.45.18 3.65.74v2.45c-.98-.46-2.02-.74-3.46-.74-3.99 0-5.61 2.51-5.61 5.49s1.66 5.49 5.67 5.49c1.56 0 2.55-.21 3.5-.55m-14.51-6.23v8.99h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 3.53 0 5.55 2.42 5.55 6.66m-22.92-4.27c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-29.1-5.74V10h2.64v9.26c0 2.76 1.1 3.99 3.62 3.99 2.45 0 4.14-1.62 4.14-4.72V10h2.64v15.33h-2.64v-2.51c-.98 1.81-2.79 2.82-4.84 2.82-3.53 0-5.55-2.42-5.55-6.65m-2.24 6.31c-.21.06-.67.12-1.35.12-2.51 0-4.11-1.19-4.11-4.02V3.59h2.64V21.1c0 1.38.92 1.87 2.06 1.87.28 0 .46 0 .77-.03zM96.82 8.38V10h3.96v2.45h-3.96v12.88h-2.58V12.45h-2.48V10h2.48V8.31c0-2.85 1.59-4.78 4.88-4.78.8 0 1.32.12 1.78.25V6.2a8.7 8.7 0 0 0-1.66-.15c-1.62 0-2.42.95-2.42 2.33m-7.32 7.97v8.99h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 3.53 0 5.55 2.42 5.55 6.66m-23.34 9.28c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49m-9.23 9.63v2.67c-1.26.83-3.25 1.2-5.34 1.2-6.62 0-10.36-3.99-10.36-10.33 0-6.13 3.74-10.43 10.3-10.43 1.96 0 3.93.37 5.37 1.41v2.67c-1.44-.92-3.04-1.41-5.37-1.41-4.72 0-7.54 3.13-7.54 7.76s2.91 7.7 7.7 7.7c2.12 0 3.77-.49 5.24-1.23\"/>\n    <path fill=\"var(--tile-color,#1868db)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, white)\" d=\"M23.16 19.02c-4.938-2.387-6.38-2.744-8.461-2.744-2.442 0-4.522 1.015-6.38 3.87l-.306.466c-.25.384-.305.521-.305.686s.083.302.388.494l3.135 1.948c.167.11.305.165.444.165.166 0 .277-.082.444-.33l.5-.768c.776-1.18 1.47-1.564 2.357-1.564.777 0 1.692.22 2.83.768l3.273 1.537c.333.165.693.083.86-.302l1.553-3.403c.167-.384.056-.63-.333-.823M8.761 13.01c4.938 2.388 6.38 2.744 8.461 2.744 2.441 0 4.522-1.015 6.38-3.87l.305-.466c.25-.384.305-.521.305-.686 0-.164-.083-.302-.388-.494L20.691 8.29c-.167-.11-.306-.165-.444-.165-.167 0-.278.082-.444.33l-.5.768c-.776 1.18-1.47 1.564-2.357 1.564-.777 0-1.693-.22-2.83-.768l-3.273-1.537c-.333-.165-.694-.083-.86.302l-1.554 3.403c-.166.384-.055.63.333.823\"/>\n</svg>\n";
function $aef9474ac9fe67eb$export$a88b0b0da9ef63ce(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Confluence' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $jU1LC.LogoWrapper), {
        svg: $aef9474ac9fe67eb$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("bx9df", function(module, exports) {
$parcel$export(module.exports, "ConfluenceDataCenterIcon", () => $8659ec3898bd3218$export$53305f1f2855d3be);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::daf8acf7c1707ab5f837689f4e92f4a5>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

var $6S9Aj = parcelRequire("6S9Aj");
// `height` is set to 100% to allow the SVG to scale with the parent element
var $8659ec3898bd3218$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color, white)\" d=\"M6 .5h12A5.5 5.5 0 0 1 23.5 6v12a5.5 5.5 0 0 1-5.5 5.5H6A5.5 5.5 0 0 1 .5 18V6A5.5 5.5 0 0 1 6 .5\"/>\n    <path fill=\"none\" stroke=\"var(--border-color, #dddee1)\" d=\"M6 .5h12A5.5 5.5 0 0 1 23.5 6v12a5.5 5.5 0 0 1-5.5 5.5H6A5.5 5.5 0 0 1 .5 18V6A5.5 5.5 0 0 1 6 .5Z\"/>\n    <path fill=\"var(--icon-color, #1868db)\" d=\"M17.37 14.265c-3.704-1.79-4.785-2.058-6.346-2.058-1.83 0-3.391.761-4.785 2.902l-.229.35c-.187.288-.229.39-.229.514s.063.227.292.37l2.35 1.462c.125.083.23.124.333.124.125 0 .208-.062.333-.247l.375-.577c.582-.885 1.102-1.173 1.768-1.173.583 0 1.27.165 2.122.577l2.455 1.152c.25.124.52.062.645-.226l1.165-2.552c.125-.289.042-.474-.25-.618M6.572 9.757c3.703 1.791 4.785 2.059 6.346 2.059 1.83 0 3.39-.762 4.785-2.902l.229-.35c.187-.288.228-.391.228-.515 0-.123-.062-.226-.29-.37l-2.352-1.462c-.125-.082-.229-.123-.333-.123-.125 0-.208.061-.333.247l-.374.576c-.583.885-1.103 1.173-1.769 1.173-.582 0-1.269-.164-2.122-.576L8.132 6.361c-.25-.123-.52-.061-.645.227L6.322 9.14c-.125.288-.041.473.25.617\"/>\n</svg>\n";
function $8659ec3898bd3218$export$53305f1f2855d3be(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Confluence Data Center' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $6S9Aj.IconWrapper), {
        svg: $8659ec3898bd3218$var$svg,
        label: label,
        type: "data-center",
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("1kajK", function(module, exports) {
$parcel$export(module.exports, "ConfluenceDataCenterLogoCS", () => $0f6fa98e87111a87$export$b3e508cb103e1f93);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c86f2cdcf615e24dd3ad3f9b48bca5bf>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

var $jU1LC = parcelRequire("jU1LC");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $0f6fa98e87111a87$var$svg = "<svg height=\"100%\" viewBox=\"0 0 188 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M181.16 12.09c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.2c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-15.1-2.16v2.36c-.92.49-2.33.71-3.74.71-5.46 0-8-3.31-8-8 0-4.63 2.55-7.94 8-7.94 1.38 0 2.45.18 3.65.74v2.45c-.98-.46-2.02-.74-3.47-.74-3.99 0-5.61 2.51-5.61 5.49s1.66 5.49 5.67 5.49c1.56 0 2.55-.21 3.5-.55m-14.5-6.23v8.99h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 3.53 0 5.55 2.42 5.55 6.66m-22.92-4.27c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-29.1-5.74V10h2.64v9.26c0 2.76 1.1 3.99 3.62 3.99 2.45 0 4.14-1.62 4.14-4.72V10h2.64v15.33h-2.64v-2.51c-.98 1.81-2.79 2.82-4.85 2.82-3.53 0-5.55-2.42-5.55-6.65m-2.23 6.31c-.21.06-.67.12-1.35.12-2.51 0-4.11-1.2-4.11-4.02V3.59h2.64V21.1c0 1.38.92 1.87 2.06 1.87.28 0 .46 0 .77-.03zM96.82 8.38V10h3.96v2.45h-3.96v12.88h-2.58V12.45h-2.48V10h2.48V8.31c0-2.85 1.59-4.78 4.88-4.78.8 0 1.32.12 1.78.25V6.2a8.7 8.7 0 0 0-1.66-.15c-1.62 0-2.42.95-2.42 2.33m-7.32 7.97v8.99h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 3.53 0 5.55 2.42 5.55 6.66m-23.34 9.28c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49m-9.23 9.63v2.67c-1.26.83-3.25 1.2-5.34 1.2-6.62 0-10.36-3.99-10.36-10.33 0-6.13 3.74-10.43 10.3-10.43 1.96 0 3.93.37 5.37 1.41v2.67c-1.44-.92-3.04-1.41-5.37-1.41-4.72 0-7.54 3.13-7.54 7.76s2.91 7.7 7.7 7.7c2.12 0 3.77-.49 5.24-1.23\"/>\n    <path fill=\"var(--tile-color, white)\" d=\"M8 .667h16A7.333 7.333 0 0 1 31.333 8v16A7.333 7.333 0 0 1 24 31.333H8A7.333 7.333 0 0 1 .667 24V8A7.333 7.333 0 0 1 8 .667\"/>\n    <path fill=\"none\" stroke=\"var(--border-color, #dddee1)\" stroke-width=\"1.333\" d=\"M8 .667h16A7.333 7.333 0 0 1 31.333 8v16A7.333 7.333 0 0 1 24 31.333H8A7.333 7.333 0 0 1 .667 24V8A7.333 7.333 0 0 1 8 .667Z\"/>\n    <path fill=\"var(--icon-color, #1868db)\" d=\"M23.16 19.02c-4.938-2.387-6.38-2.744-8.461-2.744-2.441 0-4.522 1.015-6.38 3.87l-.306.466c-.25.384-.305.521-.305.686s.084.302.389.494l3.134 1.948c.167.11.306.165.444.165.167 0 .278-.082.444-.33l.5-.768c.776-1.18 1.47-1.564 2.357-1.564.777 0 1.693.22 2.83.768l3.273 1.537c.333.165.694.083.86-.302l1.554-3.403c.166-.384.055-.63-.333-.823M8.762 13.01c4.938 2.388 6.38 2.744 8.461 2.744 2.441 0 4.522-1.015 6.38-3.87l.306-.466c.25-.384.305-.521.305-.686 0-.164-.083-.302-.388-.494L20.69 8.29c-.167-.11-.305-.165-.444-.165-.166 0-.277.082-.444.33l-.5.768c-.776 1.18-1.47 1.564-2.357 1.564-.777 0-1.692-.22-2.83-.768l-3.273-1.537c-.333-.165-.694-.083-.86.302L8.43 12.187c-.167.384-.056.63.332.823\"/>\n</svg>\n";
function $0f6fa98e87111a87$export$b3e508cb103e1f93(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Confluence Data Center' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $jU1LC.LogoWrapper), {
        svg: $0f6fa98e87111a87$var$svg,
        label: label,
        type: "data-center",
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("lC725", function(module, exports) {
$parcel$export(module.exports, "CrowdIcon", () => $fbc29a25bd61c0e0$export$eaf73f391f7103bd);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::9928c9b96accda0f9234a11fc7ddaca0>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

var $6S9Aj = parcelRequire("6S9Aj");
// `height` is set to 100% to allow the SVG to scale with the parent element
var $fbc29a25bd61c0e0$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color, white)\" d=\"M6 .5h12A5.5 5.5 0 0 1 23.5 6v12a5.5 5.5 0 0 1-5.5 5.5H6A5.5 5.5 0 0 1 .5 18V6A5.5 5.5 0 0 1 6 .5\"/>\n    <path fill=\"none\" stroke=\"var(--border-color, #dddee1)\" d=\"M6 .5h12A5.5 5.5 0 0 1 23.5 6v12a5.5 5.5 0 0 1-5.5 5.5H6A5.5 5.5 0 0 1 .5 18V6A5.5 5.5 0 0 1 6 .5Z\"/>\n    <path fill=\"var(--icon-color, #1868db)\" d=\"M18.71 7.463 12 4.993l-6.71 2.47a.44.44 0 0 0-.29.433l.14 3.807c.103 3.148 1.684 5.489 4.163 7.018a.446.446 0 0 0 .646-.204l1.445-3.412a.22.22 0 0 0-.14-.298 2.585 2.585 0 1 1 1.492 0 .22.22 0 0 0-.14.298l1.446 3.412a.446.446 0 0 0 .645.204c2.48-1.529 4.06-3.87 4.163-7.018L19 7.896a.44.44 0 0 0-.29-.433\"/>\n</svg>\n";
function $fbc29a25bd61c0e0$export$eaf73f391f7103bd(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Crowd' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $6S9Aj.IconWrapper), {
        svg: $fbc29a25bd61c0e0$var$svg,
        label: label,
        type: "data-center",
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("gCRKh", function(module, exports) {
$parcel$export(module.exports, "CrowdLogoCS", () => $c1a9e2a98e9f6e5e$export$3c371bdbcdfcdce);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::206fa44ab9c6427ebeb6aaad7e53b58f>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

var $jU1LC = parcelRequire("jU1LC");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $c1a9e2a98e9f6e5e$var$svg = "<svg height=\"100%\" viewBox=\"0 0 126 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M113.97 17.67c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V3.59h2.64v21.74zm-17.72 0h-3.37l-2.64-7.42-1.41-4.72-1.41 4.72-2.64 7.42h-3.37L84.45 10h2.91l4.42 13 4.48-13h2.51l4.48 13 4.41-13h2.91zm-28.47.31c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49m-13.77 4.14v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.68-5.43 3.93m-5.76 5.48v2.67c-1.26.83-3.25 1.2-5.34 1.2-6.62 0-10.36-3.99-10.36-10.33 0-6.13 3.74-10.43 10.3-10.43 1.96 0 3.93.37 5.37 1.41v2.67c-1.44-.92-3.04-1.41-5.37-1.41-4.72 0-7.54 3.13-7.54 7.76s2.91 7.7 7.7 7.7c2.12 0 3.77-.49 5.24-1.23\"/>\n    <path fill=\"var(--tile-color, white)\" d=\"M8 .667h16A7.333 7.333 0 0 1 31.333 8v16A7.333 7.333 0 0 1 24 31.333H8A7.333 7.333 0 0 1 .667 24V8A7.333 7.333 0 0 1 8 .667\"/>\n    <path fill=\"none\" stroke=\"var(--border-color, #dddee1)\" stroke-width=\"1.333\" d=\"M8 .667h16A7.333 7.333 0 0 1 31.333 8v16A7.333 7.333 0 0 1 24 31.333H8A7.333 7.333 0 0 1 .667 24V8A7.333 7.333 0 0 1 8 .667Z\"/>\n    <path fill=\"var(--icon-color, #1868db)\" d=\"M24.946 9.951 16 6.657 7.054 9.95a.59.59 0 0 0-.387.577l.187 5.076c.137 4.197 2.245 7.319 5.55 9.357.31.19.719.063.86-.272l1.928-4.55a.294.294 0 0 0-.185-.396 3.447 3.447 0 1 1 1.987 0 .294.294 0 0 0-.185.397l1.927 4.549c.142.335.55.463.86.272 3.305-2.038 5.413-5.16 5.55-9.357l.187-5.076a.59.59 0 0 0-.387-.577\"/>\n</svg>\n";
function $c1a9e2a98e9f6e5e$export$3c371bdbcdfcdce(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Crowd' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $jU1LC.LogoWrapper), {
        svg: $c1a9e2a98e9f6e5e$var$svg,
        label: label,
        type: "data-center",
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("ltZmE", function(module, exports) {
$parcel$export(module.exports, "CustomerServiceManagementIcon", () => $fa3be814c29e12fd$export$6da5aa77c402ba0f);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2cbaafcea60527c20df8d8395e491b95>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

var $6S9Aj = parcelRequire("6S9Aj");
// `height` is set to 100% to allow the SVG to scale with the parent element
var $fa3be814c29e12fd$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#ffc716)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M16.43 17.42A6.97 6.97 0 0 1 12 19H6.4v-.47l3.84-3.78a3.25 3.25 0 0 0 1.76.52c.65 0 1.25-.19 1.76-.51zm.99-.99A6.97 6.97 0 0 0 19 12a6.97 6.97 0 0 0-1.58-4.43l-2.67 2.67c.33.51.52 1.11.52 1.76s-.19 1.25-.51 1.76zm-.99-9.85-2.67 2.67A3.25 3.25 0 0 0 12 8.73c-.65 0-1.25.19-1.76.52L7.57 6.58A6.97 6.97 0 0 1 12 5c1.68 0 3.22.59 4.43 1.58m-9.85.99A6.97 6.97 0 0 0 5 12c0 1.68.59 3.22 1.58 4.43l2.67-2.67A3.25 3.25 0 0 1 8.73 12c0-.65.19-1.25.52-1.76z\"/>\n</svg>\n";
var $fa3be814c29e12fd$var$customThemeSvg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--themed-icon-color, currentcolor)\" d=\"M18 0a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6V6a6 6 0 0 1 6-6zm-4.238 14.751a3.25 3.25 0 0 1-1.762.516 3.25 3.25 0 0 1-1.762-.515L6.4 18.533V19H12a6.97 6.97 0 0 0 4.43-1.58zM6.58 7.571A6.97 6.97 0 0 0 5 12a6.97 6.97 0 0 0 1.58 4.43l2.669-2.668A3.25 3.25 0 0 1 8.733 12c0-.649.19-1.253.516-1.762zm8.172 2.667c.326.508.515 1.113.515 1.762s-.189 1.254-.515 1.762l2.668 2.668A6.97 6.97 0 0 0 19 12a6.97 6.97 0 0 0-1.58-4.43zM12 5a6.97 6.97 0 0 0-4.43 1.58l2.668 2.668A3.25 3.25 0 0 1 12 8.733c.649 0 1.253.19 1.762.516L16.43 6.58A6.97 6.97 0 0 0 12 5\"/>\n</svg>\n";
function $fa3be814c29e12fd$export$6da5aa77c402ba0f(_ref) {
    var iconColor = _ref.iconColor, size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Customer Service Management' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $6S9Aj.IconWrapper), {
        svg: $fa3be814c29e12fd$var$svg,
        customThemeSvg: $fa3be814c29e12fd$var$customThemeSvg,
        iconColor: iconColor,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("lx9EO", function(module, exports) {
$parcel$export(module.exports, "CustomerServiceManagementLogoCS", () => $fad42bc1fa03053f$export$f597f0f7fadce0b9);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7b7476897879e097648c054d2783409e>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

var $jU1LC = parcelRequire("jU1LC");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $fad42bc1fa03053f$var$svg = "<svg height=\"100%\" viewBox=\"0 0 456 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M451.86 20.58c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55c-.46.12-.98.25-1.78.25-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zm-7.33-4.23v8.99h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 3.53 0 5.55 2.42 5.55 6.66m-22.92-4.27c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-26.16-7.92v8.53h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 2.61 0 4.39 1.32 5.15 3.74.86-2.36 2.91-3.74 5.46-3.74 3.44 0 5.34 2.33 5.34 6.66v8.99h-2.64v-8.52c0-3.16-1.1-4.72-3.62-4.72-2.45 0-4.14 1.63-4.14 4.72m-22.92-4.74c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-18.64-.62v-1.53c-.98 2.02-2.82 3.07-5.18 3.07-4.05 0-6.07-3.46-6.07-7.97 0-4.32 2.12-7.97 6.38-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.58v13.95c0 4.51-2.12 7.54-7.6 7.54-2.58 0-3.99-.34-5.46-.83v-2.58c1.69.55 3.44.92 5.34.92 3.83 0 5.15-2.05 5.15-4.91m-8.68-6.44c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m-16.96.03c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-14.08-8.98v8.99h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 3.53 0 5.55 2.42 5.55 6.66m-28.33 1.31c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-31.44-11.01-2.76-7.48v18.49h-2.76V5.19h4.78l4.57 11.56 1.87 5.55 1.87-5.55 4.6-11.56h4.45v20.15h-2.76V7.06l-2.36 7.27-4.45 11.01h-2.67zm-21.51-2.23c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-15.1-2.16v2.36c-.92.49-2.33.71-3.74.71-5.46 0-8-3.31-8-8 0-4.63 2.55-7.94 8-7.94 1.38 0 2.45.18 3.65.74v2.45c-.98-.46-2.02-.74-3.47-.74-3.99 0-5.61 2.51-5.61 5.49s1.66 5.49 5.67 5.49c1.56 0 2.55-.21 3.5-.55M234.91 5.95c0-1.16.77-1.84 1.84-1.84s1.84.68 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-8.24 0h-3.53L217.69 10h2.76l4.97 13.09L230.36 10h2.76zm-15.45-9.04v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.68-5.43 3.93m-12.46-4.21c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.05 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-15.33-4.95c0 3.5-2.08 5.86-7.08 5.86-3.89 0-5.7-.77-7.27-1.56v-2.82c1.87.98 4.75 1.69 7.42 1.69 3.04 0 4.17-1.2 4.17-2.97 0-1.78-1.1-2.73-4.94-3.65-4.54-1.1-6.56-2.67-6.56-5.98 0-3.13 2.39-5.46 7.08-5.46 2.91 0 4.78.71 6.16 1.47v2.76c-2.02-1.16-4.2-1.53-6.29-1.53-2.64 0-4.2.92-4.2 2.76 0 1.66 1.29 2.48 4.85 3.37 4.26 1.07 6.65 2.45 6.65 6.07m-26.4-3.5v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.68-5.43 3.93m-12.46-4.21c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2H146.5c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-26.15-7.92v8.53h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 2.61 0 4.39 1.32 5.15 3.74.86-2.36 2.91-3.74 5.46-3.74 3.44 0 5.34 2.33 5.34 6.66v8.99h-2.64v-8.52c0-3.16-1.1-4.72-3.62-4.72-2.45 0-4.14 1.63-4.14 4.72m-23.34 8.81c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49M94.1 20.58c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55a6.3 6.3 0 0 1-1.78.25c-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45H94.1zm-6.7.58c0 2.55-1.66 4.48-5.77 4.48-2.3 0-4.17-.52-5.34-1.13v-2.79c1.32.77 3.53 1.5 5.46 1.5 2.02 0 3.07-.83 3.07-2.02 0-1.16-.89-1.84-3.8-2.54-3.4-.83-4.84-2.15-4.84-4.66 0-2.67 2.05-4.29 5.55-4.29 1.99 0 3.8.49 4.94 1.1v2.73c-1.84-.92-3.34-1.41-4.97-1.41-1.93 0-2.97.68-2.97 1.87 0 1.07.74 1.75 3.56 2.42 3.4.83 5.12 2.09 5.12 4.75m-27.6-2.18V10h2.64v9.26c0 2.76 1.1 3.99 3.62 3.99 2.45 0 4.14-1.63 4.14-4.72V10h2.64v15.33h-2.64v-2.51c-.98 1.81-2.79 2.82-4.84 2.82-3.53 0-5.55-2.42-5.55-6.65m-2.89 2.79v2.67c-1.26.83-3.25 1.2-5.34 1.2-6.62 0-10.36-3.99-10.36-10.33 0-6.13 3.74-10.43 10.3-10.43 1.96 0 3.93.37 5.37 1.41v2.67c-1.44-.92-3.04-1.41-5.37-1.41-4.72 0-7.54 3.13-7.54 7.76s2.91 7.7 7.7 7.7c2.12 0 3.77-.49 5.24-1.23\"/>\n    <path fill=\"var(--tile-color,#ffc716)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M21.91 23.23a9.3 9.3 0 0 1-5.91 2.1H8.53v-.62l5.12-5.04a4.34 4.34 0 0 0 2.35.69c.86 0 1.67-.25 2.35-.69zm1.32-1.32a9.3 9.3 0 0 0 2.1-5.91c0-2.24-.79-4.3-2.11-5.91l-3.56 3.56c.43.68.69 1.48.69 2.35s-.25 1.67-.69 2.35zM21.91 8.77l-3.56 3.56a4.34 4.34 0 0 0-2.35-.69c-.86 0-1.67.25-2.35.69l-3.56-3.56A9.3 9.3 0 0 1 16 6.67c2.24 0 4.3.79 5.91 2.11M8.77 10.09A9.3 9.3 0 0 0 6.67 16c0 2.24.79 4.3 2.11 5.91l3.56-3.56a4.34 4.34 0 0 1-.69-2.35c0-.86.25-1.67.69-2.35z\"/>\n</svg>\n";
function $fad42bc1fa03053f$export$f597f0f7fadce0b9(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Customer Service Management' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $jU1LC.LogoWrapper), {
        svg: $fad42bc1fa03053f$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("d8qHL", function(module, exports) {
$parcel$export(module.exports, "DxIcon", () => $9900bcc584cc09f3$export$9951d02c2d848122);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::fe1275028f179c85adabcde30f1dc14d>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

var $6S9Aj = parcelRequire("6S9Aj");
// `height` is set to 100% to allow the SVG to scale with the parent element
var $9900bcc584cc09f3$var$svg = "<svg height=\"100%\" viewBox=\"0 0 48 48\">\n    <path fill=\"var(--tile-color,#94c748)\" d=\"M0 12C0 5.373 5.373 0 12 0h24c6.627 0 12 5.373 12 12v24c0 6.627-5.373 12-12 12H12C5.373 48 0 42.627 0 36z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"m36.22 26.75 4.9 7.25h-4.78c-.52-.6-1.02-1.31-1.47-1.98-.68-1.02-.68-2.41.03-3.41zm-7.3-5.5L24.02 14h4.78c.52.6 1.02 1.31 1.47 1.98.68 1.02.68 2.41-.02 3.41zm6.98-6.02c.5-.84 1.07-1.16 1.95-1.16l3.9-.07-12.68 19.27a1.46 1.46 0 0 1-1.22.67H23.6c4.07-6.25 8.37-12.37 12.31-18.7M8 33.94h6.89c6.16 0 9.92-3.88 9.92-9.94s-3.76-9.94-9.92-9.94H8l4.28 3.9h-1.76C9.13 17.96 8 19.12 8 20.55v13.38m4.41-3.9V17.96h2.46c3.52 0 5.49 2.38 5.49 6.04 0 3.65-1.97 6.04-5.46 6.04z\"/>\n</svg>\n";
function $9900bcc584cc09f3$export$9951d02c2d848122(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Dx' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $6S9Aj.IconWrapper), {
        svg: $9900bcc584cc09f3$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("6VWeS", function(module, exports) {
$parcel$export(module.exports, "FocusIcon", () => $50c53dfc69b4a83e$export$1e02e7298035a77c);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c86bc4a90f7eb35fd36ae7c99f20011b>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

var $6S9Aj = parcelRequire("6S9Aj");
// `height` is set to 100% to allow the SVG to scale with the parent element
var $50c53dfc69b4a83e$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#fb9700)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M20.84 12.21a4.29 4.29 0 0 0-6.05 0l-1.394 1.393c-.77.769-2.02.769-2.789 0L9.45 12.445 6.424 15.47l1.158 1.158a6.25 6.25 0 0 0 8.838 0zm-17.68-.418a4.253 4.253 0 0 0 6.034.017l1.412-1.412a1.973 1.973 0 0 1 2.788 0l1.158 1.158 3.026-3.025-1.158-1.158a6.25 6.25 0 0 0-8.838 0l-4.42 4.419z\"/>\n</svg>\n";
function $50c53dfc69b4a83e$export$1e02e7298035a77c(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Focus' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $6S9Aj.IconWrapper), {
        svg: $50c53dfc69b4a83e$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("jwoQS", function(module, exports) {
$parcel$export(module.exports, "FocusLogoCS", () => $e364488a002356e6$export$3a6e8b37e069a69d);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7aca4717e5f7edbaa74141430c7d1f8d>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

var $jU1LC = parcelRequire("jU1LC");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $e364488a002356e6$var$svg = "<svg height=\"100%\" viewBox=\"0 0 117 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M116.03 21.16c0 2.55-1.66 4.48-5.76 4.48-2.3 0-4.17-.52-5.34-1.13v-2.79c1.32.77 3.53 1.5 5.46 1.5 2.02 0 3.07-.83 3.07-2.02 0-1.16-.89-1.84-3.8-2.54-3.4-.83-4.85-2.15-4.85-4.66 0-2.67 2.06-4.29 5.55-4.29 1.99 0 3.8.49 4.94 1.1v2.73c-1.84-.92-3.34-1.41-4.97-1.41-1.93 0-2.97.68-2.97 1.87 0 1.07.74 1.75 3.56 2.42 3.4.83 5.12 2.09 5.12 4.75m-27.6-2.18V10h2.64v9.26c0 2.76 1.1 3.99 3.62 3.99 2.45 0 4.14-1.62 4.14-4.72V10h2.64v15.33h-2.64v-2.51c-.98 1.81-2.79 2.82-4.85 2.82-3.53 0-5.55-2.42-5.55-6.65m-2.71 3.58v2.36c-.92.49-2.33.71-3.74.71-5.46 0-8-3.31-8-8 0-4.63 2.55-7.94 8-7.94 1.38 0 2.45.18 3.65.74v2.45c-.98-.46-2.02-.74-3.47-.74-3.99 0-5.61 2.51-5.61 5.49s1.66 5.49 5.67 5.49c1.56 0 2.55-.21 3.5-.55M64.6 25.64c-4.6 0-7.3-3.4-7.3-8S60 9.7 64.6 9.7c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49m-9.97 5.67h-9.14v7.51h-2.76V5.19h12.94v2.64H45.49v7.36h9.14z\"/>\n    <path fill=\"var(--tile-color,#fb9700)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M27.607 16.272c-2.176-2.176-5.712-2.152-7.865 0l-1.812 1.812c-1 1-2.625 1-3.625 0L12.8 16.578l-3.933 3.934 1.505 1.505a8.126 8.126 0 0 0 11.49 0zm-22.982-.541c2.176 2.175 5.668 2.196 7.844.02l1.834-1.834c1-1 2.625-1 3.625 0l1.505 1.505 3.934-3.933-1.505-1.505a8.126 8.126 0 0 0-11.49 0l-5.745 5.745z\"/>\n</svg>\n";
function $e364488a002356e6$export$3a6e8b37e069a69d(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Focus' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $jU1LC.LogoWrapper), {
        svg: $e364488a002356e6$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("9YoqB", function(module, exports) {
$parcel$export(module.exports, "GoalsIcon", () => $742caa8e97aad736$export$9eb74917ea768ed4);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::691ffc068fd79d2f7585ba74e9375893>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

var $6S9Aj = parcelRequire("6S9Aj");
// `height` is set to 100% to allow the SVG to scale with the parent element
var $742caa8e97aad736$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M14.352 12a2.352 2.352 0 1 1-4.704 0 2.352 2.352 0 0 1 4.704 0\"/>\n    <path fill=\"var(--icon-color, #101214)\" fill-rule=\"evenodd\" d=\"M12 18.563a6.562 6.562 0 1 0 0-13.125 6.562 6.562 0 0 0 0 13.125M16.102 12a4.102 4.102 0 1 1-8.204 0 4.102 4.102 0 0 1 8.204 0\" clip-rule=\"evenodd\"/>\n</svg>\n";
function $742caa8e97aad736$export$9eb74917ea768ed4(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Goals' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $6S9Aj.IconWrapper), {
        svg: $742caa8e97aad736$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("dJnaB", function(module, exports) {
$parcel$export(module.exports, "GoalsLogoCS", () => $9ff173663441d0df$export$c527a545aa426db3);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4fcd237a4e74e8fc6ee2ed98ecae9d02>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

var $jU1LC = parcelRequire("jU1LC");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $9ff173663441d0df$var$svg = "<svg height=\"100%\" viewBox=\"0 0 116 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M115.55 21.16c0 2.55-1.66 4.48-5.77 4.48-2.3 0-4.17-.52-5.34-1.13v-2.79c1.32.77 3.53 1.5 5.46 1.5 2.02 0 3.07-.83 3.07-2.02 0-1.16-.89-1.84-3.8-2.54-3.4-.83-4.84-2.15-4.84-4.66 0-2.67 2.05-4.29 5.55-4.29 1.99 0 3.8.49 4.94 1.1v2.73c-1.84-.92-3.34-1.41-4.97-1.41-1.93 0-2.97.68-2.97 1.87 0 1.07.74 1.75 3.56 2.42 3.4.83 5.12 2.09 5.12 4.75m-13.12 4.13c-.21.06-.67.12-1.35.12-2.51 0-4.11-1.19-4.11-4.02V3.59h2.64V21.1c0 1.38.92 1.87 2.06 1.87.28 0 .46 0 .77-.03zm-20.75-7.63c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-20.7.31c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49M58.71 24.2c-1.59.95-4.54 1.44-6.81 1.44-6.93 0-10.67-4.23-10.67-10.33 0-6.56 4.26-10.46 11.44-10.46 1.6 0 3.47.18 5.24.8v2.76c-1.53-.61-3.34-.89-5.21-.89-5.98 0-8.71 2.98-8.71 7.73 0 4.66 2.76 7.76 8.56 7.76.95 0 2.27-.09 3.4-.43v-5.61H50.8v-2.64h7.91z\"/>\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M19.36 16a3.36 3.36 0 1 1-6.72 0 3.36 3.36 0 0 1 6.72 0\"/>\n    <path fill=\"var(--icon-color, #101214)\" fill-rule=\"evenodd\" d=\"M16 25.375a9.375 9.375 0 1 0 0-18.75 9.375 9.375 0 1 0 0 18.75M21.86 16a5.86 5.86 0 1 1-11.72 0 5.86 5.86 0 0 1 11.72 0\" clip-rule=\"evenodd\"/>\n</svg>\n";
function $9ff173663441d0df$export$c527a545aa426db3(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Goals' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $jU1LC.LogoWrapper), {
        svg: $9ff173663441d0df$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("iGWzy", function(module, exports) {
$parcel$export(module.exports, "GuardIcon", () => $d9b9957bd2325acc$export$3f95fcfdc25a741d);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::9271fe2e99ed03180fc112676167f42e>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

var $6S9Aj = parcelRequire("6S9Aj");
// `height` is set to 100% to allow the SVG to scale with the parent element
var $d9b9957bd2325acc$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M5.49 10.87h13.02c.374 0 .574-.2.574-.574V5.907c0-.374-.2-.574-.574-.574h-2.744c-.374 0-.573.2-.573.574v2.22h-1.247v-2.22c0-.374-.2-.574-.574-.574h-2.743c-.374 0-.574.2-.574.574v2.22H8.807v-2.22c0-.374-.2-.574-.573-.574H5.49c-.374 0-.573.2-.573.574v4.39c0 .373.2.573.573.573m.225 3.84a8.7 8.7 0 0 1-.5-2.493c-.024-.324.126-.499.475-.499h12.62c.349 0 .498.15.498.449a8.2 8.2 0 0 1-.523 2.544c-.15.399-.375.573-.799.573H6.513c-.424 0-.649-.174-.798-.573m11.547 2.07C16.065 18.253 14.095 19.2 12 19.2s-4.116-.948-5.288-2.42c-.299-.398-.15-.648.15-.648h10.275c.3 0 .45.25.125.649\"/>\n</svg>\n";
function $d9b9957bd2325acc$export$3f95fcfdc25a741d(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Guard' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $6S9Aj.IconWrapper), {
        svg: $d9b9957bd2325acc$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("OtwCy", function(module, exports) {
$parcel$export(module.exports, "GuardLogoCS", () => $097b92b47d320743$export$2b896c4d595a4331);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::db6984f13fa8a1f65e3a27814935822a>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

var $jU1LC = parcelRequire("jU1LC");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $097b92b47d320743$var$svg = "<svg height=\"100%\" viewBox=\"0 0 120 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M108.4 17.67c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V3.59h2.64v21.74zm-17.8-9.04v9.05H96.7V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.67-5.43 3.93m-17.86 1.37c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-27.42-6.34V10h2.64v9.26c0 2.76 1.1 3.99 3.62 3.99 2.45 0 4.14-1.62 4.14-4.72V10h2.64v15.33h-2.64v-2.51c-.98 1.81-2.79 2.82-4.84 2.82-3.53 0-5.55-2.42-5.55-6.65m-3.98 5.21c-1.59.95-4.54 1.44-6.81 1.44-6.93 0-10.67-4.23-10.67-10.33 0-6.56 4.26-10.46 11.44-10.46 1.6 0 3.47.18 5.24.8v2.76c-1.53-.61-3.34-.89-5.21-.89-5.98 0-8.71 2.98-8.71 7.73 0 4.66 2.76 7.76 8.56 7.76.95 0 2.27-.09 3.4-.43v-5.61H50.8v-2.64h7.91z\"/>\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M8.188 14.644h15.623c.449 0 .688-.24.688-.688V8.688c0-.449-.24-.688-.688-.688h-3.292c-.45 0-.689.24-.689.688v2.664h-1.496V8.688c0-.449-.24-.688-.688-.688h-3.293c-.448 0-.688.24-.688.688v2.664H12.17V8.688c0-.449-.24-.688-.689-.688H8.188c-.449 0-.688.24-.688.688v5.268c0 .449.24.688.688.688m.27 4.609a10.4 10.4 0 0 1-.599-2.993c-.03-.389.15-.598.569-.598H23.57c.42 0 .599.18.599.538q-.09 1.662-.629 3.053c-.18.479-.448.688-.957.688H9.415c-.508 0-.778-.21-.957-.688m13.856 2.484c-1.436 1.766-3.8 2.903-6.314 2.903s-4.939-1.137-6.345-2.903c-.36-.479-.18-.778.18-.778h12.33c.359 0 .538.3.15.778\"/>\n</svg>\n";
function $097b92b47d320743$export$2b896c4d595a4331(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Guard' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $jU1LC.LogoWrapper), {
        svg: $097b92b47d320743$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("5F1rh", function(module, exports) {
$parcel$export(module.exports, "HomeIcon", () => $41f1e5d4268005ad$export$92c8767b874048d);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2dae141e789f6f860676eab772d48c16>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

var $6S9Aj = parcelRequire("6S9Aj");
// `height` is set to 100% to allow the SVG to scale with the parent element
var $41f1e5d4268005ad$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M5.875 10.688v7.437h4.375V13.75h3.5v4.375h4.375v-7.437L12 5z\"/>\n</svg>\n";
function $41f1e5d4268005ad$export$92c8767b874048d(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Home' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $6S9Aj.IconWrapper), {
        svg: $41f1e5d4268005ad$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("kBC8w", function(module, exports) {
$parcel$export(module.exports, "HomeLogoCS", () => $f004d8741e3354fc$export$8b6b7f1b1b2367d3);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f61715fd61f2481e52a0f7c7611f421f>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

var $jU1LC = parcelRequire("jU1LC");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $f004d8741e3354fc$var$svg = "<svg height=\"100%\" viewBox=\"0 0 121 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M113.57 12.09c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zM93.3 16.81v8.53h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 2.61 0 4.39 1.32 5.15 3.74.86-2.36 2.91-3.74 5.46-3.74 3.43 0 5.34 2.33 5.34 6.66v8.99h-2.64v-8.52c0-3.16-1.1-4.72-3.62-4.72-2.45 0-4.14 1.63-4.14 4.72m-23.33 8.81c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49M56.41 5.19h2.76v20.15h-2.76v-8.71H45.8v8.71h-2.76V5.19h2.76v8.8h10.61z\"/>\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M7.25 14.125V24.75h6.25V18.5h5v6.25h6.25V14.125L16 6z\"/>\n</svg>\n";
function $f004d8741e3354fc$export$8b6b7f1b1b2367d3(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Home' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $jU1LC.LogoWrapper), {
        svg: $f004d8741e3354fc$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("gC6DE", function(module, exports) {
$parcel$export(module.exports, "HubIcon", () => $c185583fb75ca3f2$export$80b8b269d8b5014e);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::459e9cba95b1e0b094b9b0a89db30ecd>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

var $6S9Aj = parcelRequire("6S9Aj");
// `height` is set to 100% to allow the SVG to scale with the parent element
var $c185583fb75ca3f2$var$svg = "<svg height=\"100%\" viewBox=\"0 0 32 32\">\n    <g clip-path=\"url(#clip0_95164_16219)\">\n        <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n        <g clip-path=\"url(#clip1_95164_16219)\">\n            <path fill=\"var(--icon-color, #101214)\" fill-rule=\"evenodd\" d=\"M9 25.333V6.667h14v18.666h-5.25V21.25h-3.5v4.083zm3.5-14.583h2.333V9H12.5zm4.667 0H19.5V9h-2.333zm-2.334 4.083H12.5v-1.75h2.333zM12.5 18.916h2.333v-1.75H12.5zm7-4.083h-2.333v-1.75H19.5zm-2.333 4.083H19.5v-1.75h-2.333z\" clip-rule=\"evenodd\"/>\n        </g>\n    </g>\n    <defs>\n        <clipPath id=\"clip0_95164_16219\">\n            <path fill=\"var(--icon-color, white)\" d=\"M0 0h32v32H0z\"/>\n        </clipPath>\n        <clipPath id=\"clip1_95164_16219\">\n            <path fill=\"var(--icon-color, white)\" d=\"M2 2h28v28H2z\"/>\n        </clipPath>\n    </defs>\n</svg>\n";
function $c185583fb75ca3f2$export$80b8b269d8b5014e(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Hub' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $6S9Aj.IconWrapper), {
        svg: $c185583fb75ca3f2$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("923YP", function(module, exports) {
$parcel$export(module.exports, "HubLogoCS", () => $6937635475fae761$export$7a38180641471460);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::edd23980285704c09d78f5241a37a99c>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

var $jU1LC = parcelRequire("jU1LC");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $6937635475fae761$var$svg = "<svg height=\"100%\" viewBox=\"0 0 95 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M91.61 17.67c0-3.68-1.47-5.52-4.2-5.52-2.36 0-4.48 1.5-4.48 4.91v1.23c0 3.4 1.93 4.91 4.17 4.91 2.98 0 4.51-1.96 4.51-5.52m-3.8 7.97c-2.24 0-3.96-1.01-4.88-3v2.7h-2.64V3.59h2.64v9.17c.98-2.02 2.82-3.07 5.18-3.07 4.08 0 6.13 3.47 6.13 7.97 0 4.32-2.15 7.97-6.44 7.97m-24.52-6.64V10h2.64v9.26c0 2.76 1.1 3.99 3.62 3.99 2.45 0 4.14-1.62 4.14-4.72V10h2.64v15.33h-2.64v-2.51c-.98 1.81-2.79 2.82-4.84 2.82-3.53 0-5.55-2.42-5.55-6.65M56.4 5.19h2.76v20.15H56.4v-8.71H45.79v8.71h-2.76V5.19h2.76v8.8H56.4z\"/>\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" fill-rule=\"evenodd\" d=\"M9 25.333V6.667h14v18.666h-5.25V21.25h-3.5v4.083zm3.5-14.583h2.333V9H12.5zm4.667 0H19.5V9h-2.333zm-2.334 4.083H12.5v-1.75h2.333zM12.5 18.916h2.333v-1.75H12.5zm7-4.083h-2.333v-1.75H19.5zm-2.333 4.083H19.5v-1.75h-2.333z\" clip-rule=\"evenodd\"/>\n</svg>\n";
function $6937635475fae761$export$7a38180641471460(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Hub' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $jU1LC.LogoWrapper), {
        svg: $6937635475fae761$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("jua8c", function(module, exports) {
$parcel$export(module.exports, "JiraIcon", () => $e2f8ad8721bdd7c4$export$c4b5b1f965d8b3eb);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b225283860ba91a6c228b8f4fa0e1d39>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

var $6S9Aj = parcelRequire("6S9Aj");
// `height` is set to 100% to allow the SVG to scale with the parent element
var $e2f8ad8721bdd7c4$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#1868db)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, white)\" d=\"M9.051 15.434H7.734c-1.988 0-3.413-1.218-3.413-3h7.085c.367 0 .605.26.605.63v7.13c-1.772 0-2.96-1.435-2.96-3.434zm3.5-3.543h-1.318c-1.987 0-3.413-1.196-3.413-2.978h7.085c.367 0 .627.239.627.608v7.13c-1.772 0-2.981-1.435-2.981-3.434zm3.52-3.522h-1.317c-1.987 0-3.413-1.217-3.413-3h7.085c.367 0 .605.262.605.61v7.129c-1.771 0-2.96-1.435-2.96-3.434z\"/>\n</svg>\n";
var $e2f8ad8721bdd7c4$var$customThemeSvg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--themed-icon-color, currentcolor)\" d=\"M18 0a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6V6a6 6 0 0 1 6-6zM4.321 12.434c0 1.782 1.425 3 3.412 3h1.319v1.326c0 2 1.188 3.433 2.959 3.433v-7.129c0-.369-.238-.63-.605-.63zm3.5-3.52c0 1.781 1.425 2.977 3.412 2.977h1.318v1.326c0 2 1.21 3.433 2.98 3.433V9.521c0-.369-.259-.608-.626-.608zm3.52-3.544c0 1.782 1.426 3 3.413 3h1.317v1.304c0 2 1.188 3.433 2.96 3.433V5.98c0-.348-.238-.609-.605-.609z\"/>\n</svg>\n";
function $e2f8ad8721bdd7c4$export$c4b5b1f965d8b3eb(_ref) {
    var iconColor = _ref.iconColor, size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Jira' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $6S9Aj.IconWrapper), {
        svg: $e2f8ad8721bdd7c4$var$svg,
        customThemeSvg: $e2f8ad8721bdd7c4$var$customThemeSvg,
        iconColor: iconColor,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("b5K36", function(module, exports) {
$parcel$export(module.exports, "JiraLogoCS", () => $8133e1b9399ad3e1$export$bf4c5f97b468e8d6);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3ed7d2f84cfdfe8bfef2a295bafed6da>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

var $jU1LC = parcelRequire("jU1LC");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $8133e1b9399ad3e1$var$svg = "<svg height=\"100%\" viewBox=\"0 0 83 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M71.02 17.67c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.98 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-17.79-9.04v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.67-5.43 3.93M52.22 5.95c0-1.17.77-1.84 1.84-1.84s1.84.67 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-6.42-5.95V5.19h2.76V19.2c0 3.71-1.63 6.26-5.43 6.26-1.44 0-2.55-.25-3.31-.52v-2.67c.83.34 1.84.52 2.85.52 2.33 0 3.13-1.41 3.13-3.4\"/>\n    <path fill=\"var(--tile-color,#1868db)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, white)\" d=\"M11.965 20.698h-1.803c-2.72 0-4.67-1.666-4.67-4.105h9.695c.502 0 .827.357.827.863v9.756c-2.423 0-4.05-1.963-4.05-4.7zm4.788-4.848H14.95c-2.72 0-4.67-1.636-4.67-4.075h9.695c.503 0 .857.327.857.832v9.756c-2.424 0-4.079-1.963-4.079-4.7zm4.818-4.82h-1.803c-2.72 0-4.67-1.665-4.67-4.104h9.695c.503 0 .828.357.828.833v9.756c-2.424 0-4.05-1.963-4.05-4.7z\"/>\n</svg>\n";
function $8133e1b9399ad3e1$export$bf4c5f97b468e8d6(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Jira' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $jU1LC.LogoWrapper), {
        svg: $8133e1b9399ad3e1$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("g1wQb", function(module, exports) {
$parcel$export(module.exports, "JiraDataCenterIcon", () => $baa636cd77b7051d$export$f8455b5667a3ee0c);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::61edfa3e375524991498620530471e0e>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

var $6S9Aj = parcelRequire("6S9Aj");
// `height` is set to 100% to allow the SVG to scale with the parent element
var $baa636cd77b7051d$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color, white)\" d=\"M6 .5h12A5.5 5.5 0 0 1 23.5 6v12a5.5 5.5 0 0 1-5.5 5.5H6A5.5 5.5 0 0 1 .5 18V6A5.5 5.5 0 0 1 6 .5\"/>\n    <path fill=\"none\" stroke=\"var(--border-color, #dddee1)\" d=\"M6 .5h12A5.5 5.5 0 0 1 23.5 6v12a5.5 5.5 0 0 1-5.5 5.5H6A5.5 5.5 0 0 1 .5 18V6A5.5 5.5 0 0 1 6 .5Z\"/>\n    <path fill=\"var(--icon-color, #1868db)\" d=\"M8.974 15.523H7.62c-2.04 0-3.502-1.249-3.502-3.078h7.271c.377 0 .62.268.62.647v7.317c-1.817 0-3.036-1.472-3.036-3.525zm3.591-3.636h-1.352c-2.04 0-3.503-1.227-3.503-3.056h7.272c.376 0 .642.245.642.625v7.317c-1.817 0-3.059-1.473-3.059-3.525zm3.614-3.614h-1.353c-2.04 0-3.502-1.249-3.502-3.078h7.271c.377 0 .62.268.62.624v7.318c-1.817 0-3.036-1.473-3.036-3.525z\"/>\n</svg>\n";
function $baa636cd77b7051d$export$f8455b5667a3ee0c(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Jira Data Center' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $6S9Aj.IconWrapper), {
        svg: $baa636cd77b7051d$var$svg,
        label: label,
        type: "data-center",
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("jzYgU", function(module, exports) {
$parcel$export(module.exports, "JiraDataCenterLogoCS", () => $e41009eae1712a96$export$3224b07bc93ef23e);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::193cafbd0d66aed78a8eae06654a150d>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

var $jU1LC = parcelRequire("jU1LC");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $e41009eae1712a96$var$svg = "<svg height=\"100%\" viewBox=\"0 0 83 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M71.02 17.67c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.98 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.47-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-17.79-9.04v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.67-5.43 3.93M52.22 5.95c0-1.17.77-1.84 1.84-1.84s1.84.67 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-6.42-5.95V5.19h2.76V19.2c0 3.71-1.63 6.26-5.43 6.26-1.44 0-2.55-.24-3.31-.52v-2.67c.83.34 1.84.52 2.85.52 2.33 0 3.13-1.41 3.13-3.4\"/>\n    <path fill=\"var(--tile-color, white)\" d=\"M8 .667h16A7.333 7.333 0 0 1 31.333 8v16A7.333 7.333 0 0 1 24 31.333H8A7.333 7.333 0 0 1 .667 24V8A7.333 7.333 0 0 1 8 .667\"/>\n    <path fill=\"none\" stroke=\"var(--border-color, #dddee1)\" stroke-width=\"1.333\" d=\"M8 .667h16A7.333 7.333 0 0 1 31.333 8v16A7.333 7.333 0 0 1 24 31.333H8A7.333 7.333 0 0 1 .667 24V8A7.333 7.333 0 0 1 8 .667Z\"/>\n    <path fill=\"var(--icon-color, #1868db)\" d=\"M11.965 20.699h-1.803c-2.72 0-4.67-1.666-4.67-4.105h9.695c.502 0 .827.357.827.863v9.756c-2.424 0-4.05-1.963-4.05-4.7zm4.788-4.848H14.95c-2.72 0-4.67-1.636-4.67-4.075h9.695c.502 0 .857.327.857.832v9.756c-2.424 0-4.079-1.963-4.079-4.699zm4.818-4.819h-1.803c-2.72 0-4.67-1.666-4.67-4.105h9.695c.503 0 .828.357.828.833v9.756c-2.424 0-4.05-1.963-4.05-4.7z\"/>\n</svg>\n";
function $e41009eae1712a96$export$3224b07bc93ef23e(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Jira Data Center' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $jU1LC.LogoWrapper), {
        svg: $e41009eae1712a96$var$svg,
        label: label,
        type: "data-center",
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("as6dI", function(module, exports) {
$parcel$export(module.exports, "JiraProductDiscoveryIcon", () => $79c1581a4dccccf4$export$21bfbeb62fdcce8d);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3b3ec3c590ed89c431e0f979daa3e25e>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

var $6S9Aj = parcelRequire("6S9Aj");
// `height` is set to 100% to allow the SVG to scale with the parent element
var $79c1581a4dccccf4$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#c97cf4)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M13.467 4.882a9.47 9.47 0 0 0 5.422 0c.159-.035.265.07.23.229-.513 1.85-.513 3.558 0 5.408.035.14-.072.264-.23.211a10.1 10.1 0 0 0-5.422 0c-.142.053-.265-.07-.212-.211.476-1.85.476-3.559 0-5.408-.053-.159.07-.264.212-.23m.724 6.553v.3c0 1.39-.972 2.412-2.173 2.412a2.153 2.153 0 0 1-2.154-2.166c0-1.198.971-2.15 2.331-2.15h.353V5.62c-.176-.017-.353-.017-.53-.017a6.387 6.387 0 0 0-6.393 6.394 6.37 6.37 0 0 0 6.393 6.377c3.533 0 6.411-2.854 6.411-6.377v-.563z\"/>\n</svg>\n";
var $79c1581a4dccccf4$var$customThemeSvg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--themed-icon-color, currentcolor)\" d=\"M18 0a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6V6a6 6 0 0 1 6-6zm-5.981 5.604a6.387 6.387 0 0 0-6.394 6.394 6.373 6.373 0 0 0 6.394 6.377c3.532 0 6.41-2.854 6.41-6.377v-.563H14.19v.3c0 1.39-.97 2.412-2.171 2.413a2.154 2.154 0 0 1-2.156-2.168c0-1.197.973-2.148 2.332-2.148h.353v-4.21c-.177-.018-.353-.018-.53-.018m6.87-.722a9.47 9.47 0 0 1-5.422 0c-.141-.035-.265.07-.212.228.477 1.85.477 3.559 0 5.409-.053.14.07.264.212.211a10.1 10.1 0 0 1 5.422 0c.159.053.265-.07.23-.211-.513-1.85-.513-3.56 0-5.409.034-.158-.072-.263-.23-.228\"/>\n</svg>\n";
function $79c1581a4dccccf4$export$21bfbeb62fdcce8d(_ref) {
    var iconColor = _ref.iconColor, size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Jira Product Discovery' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $6S9Aj.IconWrapper), {
        svg: $79c1581a4dccccf4$var$svg,
        customThemeSvg: $79c1581a4dccccf4$var$customThemeSvg,
        iconColor: iconColor,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("04Bi0", function(module, exports) {
$parcel$export(module.exports, "JiraProductDiscoveryLogoCS", () => $00dd4cbc23c00675$export$602140a6a10b02bf);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c8e2d27dec964efc37c6ed5782c3fe57>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

var $jU1LC = parcelRequire("jU1LC");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $00dd4cbc23c00675$var$svg = "<svg height=\"100%\" viewBox=\"0 0 327 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M317.88 24.35h-1.72L310.62 10h2.82l4.91 13.13 4.9-13.13h2.82l-5.8 14.84c-1.72 4.39-2.7 6.65-6.59 6.65-1.32 0-2.06-.12-2.82-.43v-2.27c.89.28 1.9.37 2.67.37 2.15 0 3.1-1.47 4.36-4.82m-13.25-8.05v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.67-5.43 3.93m-12.47-4.21c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-19.72.6h-3.53L268.87 10h2.76l4.97 13.1 4.93-13.1h2.76zm-17.46.31c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49m-9.39 10.42v2.36c-.92.49-2.33.71-3.74.71-5.46 0-8-3.31-8-8 0-4.63 2.55-7.94 8-7.94 1.38 0 2.45.18 3.65.74v2.45c-.98-.46-2.02-.74-3.46-.74-3.99 0-5.61 2.51-5.61 5.49s1.66 5.49 5.67 5.49c1.56 0 2.55-.21 3.5-.55m-13.88-1.42c0 2.55-1.66 4.48-5.76 4.48-2.3 0-4.17-.52-5.34-1.13v-2.79c1.32.77 3.53 1.5 5.46 1.5 2.02 0 3.07-.83 3.07-2.02 0-1.16-.89-1.84-3.8-2.54-3.4-.83-4.85-2.15-4.85-4.66 0-2.67 2.06-4.29 5.55-4.29 1.99 0 3.8.49 4.94 1.1v2.73c-1.84-.92-3.34-1.41-4.97-1.41-1.93 0-2.97.68-2.97 1.87 0 1.07.74 1.75 3.56 2.42 3.4.83 5.12 2.09 5.12 4.75m-17.7-15.22c0-1.16.77-1.84 1.84-1.84s1.84.68 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zM207.68 7.82h-4.54v14.87h4.69c4.6 0 6.9-2.42 6.9-7.3 0-4.91-2.18-7.57-7.05-7.57m-7.3 17.51V5.19h7.42c6.53 0 9.69 4.08 9.69 10.12 0 6.1-3.19 10.03-9.69 10.03zm-13.41-4.75c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55c-.46.12-.98.25-1.78.25-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zm-6.66 1.99v2.36c-.92.49-2.33.71-3.74.71-5.46 0-8-3.31-8-8 0-4.63 2.55-7.94 8-7.94 1.38 0 2.45.18 3.65.74v2.45c-.98-.46-2.02-.74-3.46-.74-3.99 0-5.61 2.51-5.61 5.49s1.66 5.49 5.67 5.49c1.56 0 2.55-.21 3.5-.55m-27.86-3.59V10h2.64v9.26c0 2.76 1.1 3.99 3.62 3.99 2.45 0 4.14-1.62 4.14-4.72V10h2.64v15.33h-2.64v-2.51c-.98 1.81-2.79 2.82-4.84 2.82-3.53 0-5.55-2.42-5.55-6.65m-14.99-1.32c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V3.59h2.64v21.74zm-20.7.31c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49m-13.78 4.14v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.67-5.43 3.93m-5-4.4c0 4.39-2.45 6.84-7.48 6.84h-4.02v6.59h-2.76V5.19h6.78c5.03 0 7.48 2.58 7.48 6.72m-7.79 4.2c3.56.12 4.94-1.56 4.94-4.14 0-2.45-1.38-4.14-4.94-4.14h-3.71v8.28zm-27.87 1.56c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.98 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-17.79-9.04v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.67-5.43 3.93M52.22 5.95c0-1.16.77-1.84 1.84-1.84s1.84.68 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-6.42-5.95V5.19h2.76V19.2c0 3.71-1.63 6.26-5.43 6.26-1.44 0-2.55-.24-3.31-.52v-2.67c.83.34 1.84.52 2.85.52 2.33 0 3.13-1.41 3.13-3.4\"/>\n    <path fill=\"var(--tile-color,#c97cf4)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M17.448 6.967c2.544.746 5.113.746 7.656 0 .225-.05.375.1.325.323-.724 2.612-.724 5.025 0 7.637.05.199-.1.373-.325.298a14.3 14.3 0 0 0-7.656 0c-.2.075-.374-.1-.3-.298.674-2.612.674-5.025 0-7.637-.074-.223.1-.373.3-.323m1.023 9.253v.423c0 1.965-1.372 3.408-3.068 3.408a3.04 3.04 0 0 1-3.043-3.06c0-1.691 1.372-3.034 3.292-3.034h.5V8.012c-.25-.025-.5-.025-.749-.025a9.02 9.02 0 0 0-9.028 9.03c0 4.999 4.04 9.004 9.028 9.004s9.053-4.03 9.053-9.005v-.796z\"/>\n</svg>\n";
function $00dd4cbc23c00675$export$602140a6a10b02bf(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Jira Product Discovery' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $jU1LC.LogoWrapper), {
        svg: $00dd4cbc23c00675$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("ijdNw", function(module, exports) {
$parcel$export(module.exports, "JiraServiceManagementIcon", () => $d544b447cbe7a4a9$export$3c6158790f5e01c4);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::cedb5d68059644a06a093aa74d8e3cc5>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

var $6S9Aj = parcelRequire("6S9Aj");
// `height` is set to 100% to allow the SVG to scale with the parent element
var $d544b447cbe7a4a9$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#ffc716)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M13.744 10.156h4.578c.688 0 .922.654.503 1.174l-7.16 8.837c-2.314-1.845-2.096-4.763-.402-6.892zm-3.538 3.521H5.63c-.688 0-.923-.654-.504-1.173l7.16-8.837c2.315 1.844 2.063 4.728.386 6.875z\"/>\n</svg>\n";
var $d544b447cbe7a4a9$var$customThemeSvg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--themed-icon-color, currentcolor)\" d=\"M18 0a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6V6a6 6 0 0 1 6-6zm-4.256 10.156-2.481 3.12c-1.694 2.129-1.912 5.047.402 6.891l7.16-8.837c.42-.52.185-1.174-.503-1.174zm-8.619 2.348c-.419.52-.183 1.174.504 1.174h4.577l2.465-3.136c1.677-2.146 1.928-5.03-.386-6.875z\"/>\n</svg>\n";
function $d544b447cbe7a4a9$export$3c6158790f5e01c4(_ref) {
    var iconColor = _ref.iconColor, size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Jira Service Management' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $6S9Aj.IconWrapper), {
        svg: $d544b447cbe7a4a9$var$svg,
        customThemeSvg: $d544b447cbe7a4a9$var$customThemeSvg,
        iconColor: iconColor,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("dbjyg", function(module, exports) {
$parcel$export(module.exports, "JiraServiceManagementLogoCS", () => $998b77fc3d120d0c$export$de148263c75d2bc1);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::bcf1b6bc0c0712320d6fbdb868500ebb>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

var $jU1LC = parcelRequire("jU1LC");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $998b77fc3d120d0c$var$svg = "<svg height=\"100%\" viewBox=\"0 0 372 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M367.07 20.58c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55a6.3 6.3 0 0 1-1.78.25c-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zm-7.32-4.23v8.99h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 3.53 0 5.55 2.42 5.55 6.66m-22.92-4.27c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-26.16-7.92v8.53h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 2.61 0 4.39 1.32 5.15 3.74.86-2.36 2.91-3.74 5.46-3.74 3.43 0 5.34 2.33 5.34 6.66v8.99h-2.64v-8.52c0-3.16-1.1-4.72-3.62-4.72-2.45 0-4.14 1.63-4.14 4.72m-22.92-4.74c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2H289.2c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-18.64-.62v-1.53c-.98 2.02-2.82 3.07-5.18 3.07-4.05 0-6.07-3.46-6.07-7.97 0-4.32 2.12-7.97 6.38-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.58v13.95c0 4.51-2.12 7.54-7.6 7.54-2.58 0-3.99-.34-5.46-.83v-2.58c1.69.55 3.44.92 5.34.92 3.83 0 5.15-2.05 5.15-4.91m-8.68-6.44c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m-16.97.03c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-14.07-8.98v8.99h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 3.53 0 5.55 2.42 5.55 6.66m-28.33 1.31c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-31.44-11.01-2.76-7.48v18.49h-2.76V5.19h4.78l4.57 11.56 1.87 5.55 1.87-5.55 4.6-11.56h4.45v20.15h-2.76V7.06l-2.36 7.27-4.45 11.01h-2.67zm-21.52-2.23c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.05 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-15.09-2.16v2.36c-.92.49-2.33.71-3.74.71-5.46 0-8-3.31-8-8 0-4.63 2.55-7.94 8-7.94 1.38 0 2.45.18 3.65.74v2.45c-.98-.46-2.02-.74-3.46-.74-3.99 0-5.61 2.51-5.61 5.49s1.66 5.49 5.67 5.49c1.56 0 2.55-.21 3.5-.55M150.12 5.95c0-1.17.77-1.84 1.84-1.84s1.84.67 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-8.23 0h-3.53L132.91 10h2.76l4.97 13.1 4.93-13.1h2.76zm-15.45-9.04v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.67-5.43 3.93m-12.47-4.21c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-15.33-4.95c0 3.5-2.08 5.86-7.08 5.86-3.89 0-5.7-.77-7.27-1.56v-2.82c1.87.98 4.75 1.69 7.42 1.69 3.04 0 4.17-1.2 4.17-2.97 0-1.78-1.1-2.73-4.94-3.65-4.54-1.1-6.56-2.67-6.56-5.98 0-3.13 2.39-5.46 7.08-5.46 2.91 0 4.78.71 6.16 1.47v2.76c-2.02-1.16-4.2-1.53-6.29-1.53-2.64 0-4.2.92-4.2 2.76 0 1.66 1.29 2.48 4.84 3.37 4.26 1.07 6.66 2.45 6.66 6.07m-33.99-2.12c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.98 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-17.79-9.04v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.67-5.43 3.93M52.22 5.95c0-1.17.77-1.84 1.84-1.84s1.84.67 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-6.42-5.95V5.19h2.76V19.2c0 3.71-1.63 6.26-5.43 6.26-1.44 0-2.55-.25-3.31-.52v-2.67c.83.34 1.84.52 2.85.52 2.33 0 3.13-1.41 3.13-3.4\"/>\n    <path fill=\"var(--tile-color,#ffc716)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M18.268 13.604h5.951c.894 0 1.199.85.654 1.526l-9.308 11.487c-3.008-2.397-2.725-6.19-.523-8.959zm-4.6 4.577h-5.95c-.894 0-1.2-.85-.655-1.526l9.308-11.488c3.009 2.398 2.682 6.148.502 8.938z\"/>\n</svg>\n";
function $998b77fc3d120d0c$export$de148263c75d2bc1(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Jira Service Management' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $jU1LC.LogoWrapper), {
        svg: $998b77fc3d120d0c$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("cr5XE", function(module, exports) {
$parcel$export(module.exports, "JiraServiceManagementDataCenterIcon", () => $90dca16c3b204590$export$65fae0eaf343f2ca);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::5b3684e2355c28ec62827d09d362b6cf>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

var $6S9Aj = parcelRequire("6S9Aj");
// `height` is set to 100% to allow the SVG to scale with the parent element
var $90dca16c3b204590$var$svg = "<svg height=\"100%\" viewBox=\"0 0 25 24\">\n    <path fill=\"var(--tile-color, white)\" d=\"M6.417.5h12a5.5 5.5 0 0 1 5.5 5.5v12a5.5 5.5 0 0 1-5.5 5.5h-12a5.5 5.5 0 0 1-5.5-5.5V6a5.5 5.5 0 0 1 5.5-5.5\"/>\n    <path fill=\"none\" stroke=\"var(--border-color, #dddee1)\" d=\"M6.417.5h12a5.5 5.5 0 0 1 5.5 5.5v12a5.5 5.5 0 0 1-5.5 5.5h-12a5.5 5.5 0 0 1-5.5-5.5V6a5.5 5.5 0 0 1 5.5-5.5Z\"/>\n    <path fill=\"var(--icon-color, #1868db)\" d=\"M14.117 10.203h4.464c.67 0 .899.637.49 1.144l-6.98 8.616c-2.257-1.798-2.044-4.643-.393-6.72zm-3.45 3.433H6.205c-.67 0-.899-.638-.49-1.144l6.981-8.617c2.256 1.799 2.011 4.61.376 6.704z\"/>\n</svg>\n";
function $90dca16c3b204590$export$65fae0eaf343f2ca(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Jira Service Management Data Center' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $6S9Aj.IconWrapper), {
        svg: $90dca16c3b204590$var$svg,
        label: label,
        type: "data-center",
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("jFppn", function(module, exports) {
$parcel$export(module.exports, "JiraServiceManagementDataCenterLogoCS", () => $e5158e3a88c0b624$export$f64bc7a7f04428d0);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d19396c378541211d8225aae490bcbcf>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

var $jU1LC = parcelRequire("jU1LC");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $e5158e3a88c0b624$var$svg = "<svg height=\"100%\" viewBox=\"0 0 372 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M367.07 20.58c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55c-.46.12-.98.25-1.78.25-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zm-7.32-4.23v8.99h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 3.53 0 5.55 2.42 5.55 6.66m-22.92-4.27c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-26.16-7.92v8.53h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 2.61 0 4.39 1.32 5.15 3.74.86-2.36 2.91-3.74 5.46-3.74 3.43 0 5.34 2.33 5.34 6.66v8.99h-2.64v-8.52c0-3.16-1.1-4.72-3.62-4.72-2.45 0-4.14 1.63-4.14 4.72m-22.92-4.74c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2H289.2c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-18.64-.62v-1.53c-.98 2.02-2.82 3.07-5.18 3.07-4.05 0-6.07-3.46-6.07-7.97 0-4.32 2.12-7.97 6.38-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.58v13.95c0 4.51-2.12 7.54-7.6 7.54-2.58 0-3.99-.34-5.46-.83v-2.58c1.69.55 3.44.92 5.34.92 3.83 0 5.15-2.05 5.15-4.91m-8.68-6.44c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m-16.97.03c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-14.07-8.98v8.99h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 3.53 0 5.55 2.42 5.55 6.66m-28.33 1.31c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-31.44-11.01-2.76-7.48v18.49h-2.76V5.19h4.78l4.57 11.56 1.87 5.55 1.87-5.55 4.6-11.56h4.45v20.15h-2.76V7.06l-2.36 7.27-4.45 11.01h-2.67zm-21.52-2.23c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.05 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-15.09-2.16v2.36c-.92.49-2.33.71-3.74.71-5.46 0-8-3.31-8-8 0-4.63 2.55-7.94 8-7.94 1.38 0 2.45.18 3.65.74v2.45c-.98-.46-2.02-.74-3.46-.74-3.99 0-5.61 2.51-5.61 5.49s1.66 5.49 5.67 5.49c1.56 0 2.55-.21 3.5-.55M150.12 5.95c0-1.16.77-1.84 1.84-1.84s1.84.68 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-8.23 0h-3.53L132.91 10h2.76l4.97 13.1 4.93-13.1h2.76zm-15.45-9.04v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.68-5.43 3.93m-12.47-4.21c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-15.33-4.95c0 3.5-2.08 5.86-7.08 5.86-3.89 0-5.7-.77-7.27-1.56v-2.82c1.87.98 4.75 1.69 7.42 1.69 3.04 0 4.17-1.2 4.17-2.97s-1.1-2.73-4.94-3.65c-4.54-1.1-6.56-2.67-6.56-5.98 0-3.13 2.39-5.46 7.08-5.46 2.91 0 4.78.71 6.16 1.47v2.76c-2.02-1.17-4.2-1.53-6.29-1.53-2.64 0-4.2.92-4.2 2.76 0 1.66 1.29 2.48 4.84 3.37 4.26 1.07 6.66 2.45 6.66 6.07m-33.99-2.12c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-17.79-9.04v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.68-5.43 3.93M52.22 5.95c0-1.16.77-1.84 1.84-1.84s1.84.68 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-6.42-5.95V5.19h2.76V19.2c0 3.71-1.63 6.26-5.43 6.26-1.44 0-2.55-.24-3.31-.52v-2.67c.83.34 1.84.52 2.85.52 2.33 0 3.13-1.41 3.13-3.4\"/>\n    <path fill=\"var(--tile-color, white)\" d=\"M8 .667h16A7.333 7.333 0 0 1 31.333 8v16A7.333 7.333 0 0 1 24 31.333H8A7.333 7.333 0 0 1 .667 24V8A7.333 7.333 0 0 1 8 .667\"/>\n    <path fill=\"none\" stroke=\"var(--border-color, #dddee1)\" stroke-width=\"1.333\" d=\"M8 .667h16A7.333 7.333 0 0 1 31.333 8v16A7.333 7.333 0 0 1 24 31.333H8A7.333 7.333 0 0 1 .667 24V8A7.333 7.333 0 0 1 8 .667Z\"/>\n    <path fill=\"var(--icon-color, #1868db)\" d=\"M18.268 13.604h5.95c.895 0 1.2.85.655 1.526l-9.308 11.487c-3.008-2.397-2.725-6.19-.524-8.959zm-4.6 4.577h-5.95c-.895 0-1.2-.85-.655-1.526l9.308-11.488c3.009 2.398 2.682 6.148.502 8.938z\"/>\n</svg>\n";
function $e5158e3a88c0b624$export$f64bc7a7f04428d0(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Jira Service Management Data Center' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $jU1LC.LogoWrapper), {
        svg: $e5158e3a88c0b624$var$svg,
        label: label,
        type: "data-center",
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("eLaBI", function(module, exports) {
$parcel$export(module.exports, "LoomIcon", () => $abedaed9eb3ea0c1$export$8d789f76fde3e05);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::568f663154fd35333110385dd0c22e41>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

var $6S9Aj = parcelRequire("6S9Aj");
// `height` is set to 100% to allow the SVG to scale with the parent element
var $abedaed9eb3ea0c1$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#1868db)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, white)\" d=\"M19.083 11.212h-4.142l3.588-2.071-.788-1.365-3.588 2.071 2.07-3.587-1.364-.788-2.071 3.587V4.917h-1.576v4.142L9.141 5.472l-1.365.787 2.071 3.588L6.26 7.776 5.472 9.14l3.587 2.07H4.917v1.577h4.142l-3.587 2.071.788 1.365 3.587-2.07-2.071 3.587 1.365.787 2.07-3.587v4.142h1.577V14.94l2.07 3.587 1.365-.787-2.07-3.588 3.587 2.071.788-1.365-3.587-2.07h4.142zM12 14.143a2.151 2.151 0 1 1 0-4.302 2.151 2.151 0 0 1 0 4.302\"/>\n</svg>\n";
function $abedaed9eb3ea0c1$export$8d789f76fde3e05(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Loom' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $6S9Aj.IconWrapper), {
        svg: $abedaed9eb3ea0c1$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("b6zdK", function(module, exports) {
$parcel$export(module.exports, "LoomLogoCS", () => $815b9356f5738031$export$78c0b4d8be34c9b2);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2d69248f39a87c063a78e83a58b63bd7>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

var $jU1LC = parcelRequire("jU1LC");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $815b9356f5738031$var$svg = "<svg height=\"100%\" viewBox=\"0 0 103 32\">\n    <path fill=\"var(--tile-color,#1868db)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, white)\" d=\"M25.375 15.31H19.99l4.664-2.693-1.024-1.775-4.664 2.693 2.692-4.663-1.775-1.025-2.692 4.663V7.125h-2.048v5.386l-2.694-4.664-1.774 1.024 2.693 4.664-4.664-2.693-1.024 1.774 4.664 2.693H6.959v2.049h5.384L7.68 20.05l1.024 1.774 4.663-2.692-2.692 4.664 1.774 1.024 2.693-4.664v5.385h2.049v-5.385l2.692 4.664 1.774-1.024-2.692-4.665 4.663 2.693 1.025-1.774-4.664-2.693h5.385zm-9.208 3.81a2.797 2.797 0 1 1 0-5.593 2.797 2.797 0 0 1 0 5.593\"/>\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M42.67 25.34V3.93h3.93v21.41zm37.7-14.55h3.75v1.78c.8-1.42 2.66-2.19 4.26-2.19 1.98 0 3.58.86 4.32 2.43 1.15-1.77 2.69-2.42 4.61-2.42 2.69 0 5.26 1.63 5.26 5.53v9.43h-3.81v-8.63c0-1.57-.77-2.75-2.57-2.75-1.68 0-2.69 1.3-2.69 2.87v8.52h-3.9v-8.63c0-1.57-.8-2.75-2.57-2.75-1.71 0-2.72 1.27-2.72 2.87v8.52h-3.93zM55.48 25.77c-4.43 0-7.63-3.28-7.63-7.7 0-4.34 3.2-7.7 7.64-7.7 4.46 0 7.63 3.39 7.63 7.7 0 4.38-3.21 7.7-7.63 7.7m0-11.84a4.15 4.15 0 0 0-4.14 4.14 4.15 4.15 0 0 0 4.14 4.14 4.15 4.15 0 0 0 4.14-4.14 4.15 4.15 0 0 0-4.14-4.14m16.02 11.84c-4.43 0-7.63-3.28-7.63-7.7 0-4.34 3.2-7.7 7.63-7.7 4.46 0 7.64 3.39 7.64 7.7 0 4.38-3.21 7.7-7.63 7.7m0-11.89c-2.31 0-4.19 1.88-4.19 4.19s1.88 4.19 4.19 4.19 4.19-1.88 4.19-4.19-1.88-4.19-4.19-4.19\"/>\n</svg>\n";
function $815b9356f5738031$export$78c0b4d8be34c9b2(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Loom' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $jU1LC.LogoWrapper), {
        svg: $815b9356f5738031$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("iWe5o", function(module, exports) {
$parcel$export(module.exports, "LoomAttributionLogoCS", () => $dc9891f62d1a3d8f$export$68d7391318cdef11);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::9f5d94b0d7bf822b6ab4c2ad26c21970>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

var $jU1LC = parcelRequire("jU1LC");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $dc9891f62d1a3d8f$var$svg = "<svg height=\"100%\" viewBox=\"0 0 100 32\">\n    <path fill=\"var(--icon-color, #101214)\" d=\"M66.71 5.11c0 1.08.49 1.93 2.47 2.31 1.16.26 1.41.44 1.41.82 0 .39-.26.62-1.08.62-.95 0-2.08-.33-2.83-.77v1.75c.59.28 1.36.62 2.83.62 2.06 0 2.85-.92 2.85-2.26m0 .03c0-1.28-.67-1.88-2.59-2.29-1.05-.23-1.31-.46-1.31-.8 0-.41.39-.59 1.08-.59.85 0 1.67.26 2.47.62V3.5c-.56-.28-1.41-.49-2.41-.49-1.9 0-2.88.82-2.88 2.16m26.29-2.11v7.32h1.57V4.81l.64 1.46 2.21 4.11h1.95V3.06h-1.54v4.73l-.59-1.39-1.77-3.34zm-9.91 0h-1.7v7.32h1.7zM79.45 8.2c0-1.28-.67-1.88-2.59-2.29-1.05-.23-1.31-.46-1.31-.8 0-.41.39-.59 1.08-.59.85 0 1.67.26 2.47.62V3.47c-.56-.28-1.41-.49-2.41-.49-1.9 0-2.88.82-2.88 2.16 0 1.08.49 1.93 2.47 2.31 1.16.26 1.41.44 1.41.82s-.26.62-1.08.62c-.95 0-2.08-.33-2.83-.77v1.75c.59.28 1.36.62 2.83.62 2.03 0 2.85-.92 2.85-2.29M53.5 3.06v7.32h3.49l.54-1.59h-2.34V3.06zm-6.91 0v1.57h1.88v5.75h1.72V4.63h2.03V3.06zm-2.49 0h-2.24l-2.54 7.32h1.95l.36-1.23c.44.13.9.21 1.36.21s.93-.08 1.36-.21l.36 1.23h1.95c-.03 0-2.57-7.32-2.57-7.32m-1.13 4.75c-.33 0-.64-.05-.93-.13l.93-3.19.93 3.19c-.28.08-.59.13-.92.13m20.06-4.75H60.8l-2.57 7.32h1.95l.36-1.23c.44.13.9.21 1.36.21s.93-.08 1.36-.21l.36 1.23h1.95zM61.9 7.81c-.33 0-.64-.05-.92-.13l.93-3.19.93 3.19c-.28.08-.59.13-.92.13m27.32-4.75h-2.23l-2.54 7.32h1.95l.36-1.23c.44.13.9.21 1.36.21s.93-.08 1.36-.21l.36 1.23h1.95zm-1.11 4.75c-.33 0-.64-.05-.92-.13l.93-3.19.93 3.19a3.7 3.7 0 0 1-.92.13\"/>\n    <path fill=\"var(--tile-color,#1868db)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, white)\" d=\"M25.375 15.31H19.99l4.664-2.693-1.024-1.775-4.664 2.693 2.692-4.664-1.775-1.025-2.692 4.664V7.125h-2.048v5.385l-2.694-4.664-1.774 1.025 2.693 4.663-4.664-2.692-1.024 1.774 4.664 2.693H6.958v2.048h5.385L7.68 20.05l1.024 1.775 4.663-2.693-2.692 4.664 1.774 1.024 2.693-4.664v5.386h2.049v-5.385l2.692 4.663 1.774-1.024-2.692-4.664 4.663 2.693 1.025-1.775-4.664-2.692h5.385zm-9.208 3.81a2.797 2.797 0 1 1 0-5.594 2.797 2.797 0 0 1 0 5.593\"/>\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M39.32 27.74v-13.7h2.52v13.7zm24.13-9.31h2.4v1.14c.51-.91 1.7-1.4 2.72-1.4 1.27 0 2.29.55 2.76 1.55.74-1.14 1.72-1.55 2.95-1.55 1.72 0 3.37 1.04 3.37 3.54v6.04h-2.44v-5.53c0-1-.49-1.76-1.65-1.76-1.08 0-1.72.83-1.72 1.84v5.45h-2.49v-5.53c0-1-.51-1.76-1.65-1.76-1.1 0-1.74.81-1.74 1.84v5.45h-2.52zm-15.93 9.58c-2.83 0-4.89-2.1-4.89-4.93 0-2.78 2.05-4.93 4.89-4.93 2.85 0 4.89 2.17 4.89 4.93 0 2.8-2.05 4.93-4.89 4.93m0-7.58a2.65 2.65 0 0 0-2.65 2.65 2.65 2.65 0 0 0 2.65 2.65c1.46 0 2.65-1.19 2.65-2.65a2.65 2.65 0 0 0-2.65-2.65m10.26 7.58c-2.83 0-4.89-2.1-4.89-4.93 0-2.78 2.05-4.93 4.89-4.93 2.85 0 4.89 2.17 4.89 4.93 0 2.8-2.06 4.93-4.89 4.93m0-7.61a2.69 2.69 0 0 0-2.68 2.68 2.69 2.69 0 0 0 2.68 2.68 2.69 2.69 0 0 0 2.68-2.68 2.69 2.69 0 0 0-2.68-2.68\"/>\n</svg>\n";
function $dc9891f62d1a3d8f$export$68d7391318cdef11(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Loom Attribution' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $jU1LC.LogoWrapper), {
        svg: $dc9891f62d1a3d8f$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("dxzOv", function(module, exports) {
$parcel$export(module.exports, "LoomInternalIcon", () => $9dba233eed3ec911$export$38c7b37a3e5e8d70);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::45c3b4b2f73587dee325566fc7978684>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

var $6S9Aj = parcelRequire("6S9Aj");
// `height` is set to 100% to allow the SVG to scale with the parent element
var $9dba233eed3ec911$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#625df5)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, white)\" d=\"M19.083 11.212h-4.142l3.588-2.071-.788-1.365-3.588 2.071 2.07-3.587-1.364-.788-2.071 3.587V4.917h-1.576v4.142L9.141 5.472l-1.365.787 2.071 3.588L6.26 7.776 5.472 9.14l3.587 2.07H4.917v1.577h4.142l-3.587 2.071.788 1.365 3.587-2.07-2.071 3.587 1.365.787 2.07-3.587v4.142h1.577V14.94l2.07 3.587 1.365-.787-2.07-3.588 3.587 2.071.788-1.365-3.587-2.07h4.142zM12 14.143a2.151 2.151 0 1 1 0-4.302 2.151 2.151 0 0 1 0 4.302\"/>\n</svg>\n";
function $9dba233eed3ec911$export$38c7b37a3e5e8d70(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Loom' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $6S9Aj.IconWrapper), {
        svg: $9dba233eed3ec911$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("b0jBl", function(module, exports) {
$parcel$export(module.exports, "LoomInternalLogoCS", () => $802ee63763db21db$export$71743a944cb62e48);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7f4fa46a3d520008396bf538a250ebef>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

var $jU1LC = parcelRequire("jU1LC");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $802ee63763db21db$var$svg = "<svg height=\"100%\" viewBox=\"0 0 103 32\">\n    <path fill=\"var(--tile-color,#625df5)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, white)\" d=\"M25.375 15.31H19.99l4.664-2.693-1.024-1.775-4.664 2.693 2.692-4.663-1.775-1.025-2.692 4.663V7.125h-2.048v5.386l-2.694-4.664-1.774 1.024 2.693 4.664-4.664-2.693-1.024 1.774 4.664 2.693H6.959v2.049h5.384L7.68 20.05l1.024 1.774 4.663-2.692-2.692 4.664 1.774 1.024 2.693-4.664v5.385h2.049v-5.385l2.692 4.664 1.774-1.024-2.692-4.665 4.663 2.693 1.025-1.774-4.664-2.693h5.385zm-9.208 3.81a2.797 2.797 0 1 1 0-5.593 2.797 2.797 0 0 1 0 5.593\"/>\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M42.67 25.34V3.93h3.93v21.41zm37.7-14.55h3.75v1.78c.8-1.42 2.66-2.19 4.26-2.19 1.98 0 3.58.86 4.32 2.43 1.15-1.77 2.69-2.42 4.61-2.42 2.69 0 5.26 1.63 5.26 5.53v9.43h-3.81v-8.63c0-1.57-.77-2.75-2.57-2.75-1.68 0-2.69 1.3-2.69 2.87v8.52h-3.9v-8.63c0-1.57-.8-2.75-2.57-2.75-1.71 0-2.72 1.27-2.72 2.87v8.52h-3.93zM55.48 25.77c-4.43 0-7.63-3.28-7.63-7.7 0-4.34 3.2-7.7 7.64-7.7 4.46 0 7.63 3.39 7.63 7.7 0 4.38-3.21 7.7-7.63 7.7m0-11.84a4.15 4.15 0 0 0-4.14 4.14 4.15 4.15 0 0 0 4.14 4.14 4.15 4.15 0 0 0 4.14-4.14 4.15 4.15 0 0 0-4.14-4.14m16.02 11.84c-4.43 0-7.63-3.28-7.63-7.7 0-4.34 3.2-7.7 7.63-7.7 4.46 0 7.64 3.39 7.64 7.7 0 4.38-3.21 7.7-7.63 7.7m0-11.89c-2.31 0-4.19 1.88-4.19 4.19s1.88 4.19 4.19 4.19 4.19-1.88 4.19-4.19-1.88-4.19-4.19-4.19\"/>\n</svg>\n";
function $802ee63763db21db$export$71743a944cb62e48(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Loom' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $jU1LC.LogoWrapper), {
        svg: $802ee63763db21db$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("3rWiD", function(module, exports) {
$parcel$export(module.exports, "OpsgenieIcon", () => $28311dc8ea089857$export$eeccc49dc7a12d9f);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2bf4732a418598faff0fcffc57f4a7b7>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

var $6S9Aj = parcelRequire("6S9Aj");
// `height` is set to 100% to allow the SVG to scale with the parent element
var $28311dc8ea089857$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#ffc716)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M12.696 19.45c-.49.361-.749.336-1.24-.026-2.375-1.704-4.57-3.641-6.042-5.655-.155-.207-.078-.49.155-.62l2.685-1.678q.35-.233.62.077c1.033 1.188 2.04 2.35 3.202 3.176 1.162-.826 2.17-1.988 3.202-3.176q.272-.31.62-.078l2.686 1.679c.232.13.31.413.155.62-1.472 2.014-3.667 3.95-6.043 5.68m-.62-7.411c2.118 0 3.874-1.73 3.874-3.848s-1.756-3.9-3.874-3.9c-2.117 0-3.873 1.757-3.873 3.9s1.704 3.848 3.873 3.848\"/>\n</svg>\n";
function $28311dc8ea089857$export$eeccc49dc7a12d9f(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Opsgenie' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $6S9Aj.IconWrapper), {
        svg: $28311dc8ea089857$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("5iCT1", function(module, exports) {
$parcel$export(module.exports, "OpsgenieLogoCS", () => $3dbccc3c6ff17112$export$a5b9122e89b32ad3);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::032f8fa95ed51413adb506dd076fd343>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

var $jU1LC = parcelRequire("jU1LC");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $3dbccc3c6ff17112$var$svg = "<svg height=\"100%\" viewBox=\"0 0 164 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M156.69 12.09c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.67-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zM143.39 5.95c0-1.16.77-1.84 1.84-1.84s1.84.68 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-3.68-8.98v8.99h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.51c.98-1.81 2.79-2.82 4.85-2.82 3.53 0 5.55 2.42 5.55 6.66m-22.92-4.26c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.67-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-18.64-.62v-1.53c-.98 2.02-2.82 3.07-5.18 3.07-4.05 0-6.07-3.47-6.07-7.97 0-4.32 2.12-7.97 6.38-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.58v13.95c0 4.51-2.12 7.54-7.6 7.54-2.58 0-3.99-.34-5.46-.83v-2.58c1.69.55 3.44.92 5.34.92 3.83 0 5.15-2.06 5.15-4.91m-8.68-6.44c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m-4.72 3.52c0 2.55-1.66 4.48-5.76 4.48-2.3 0-4.17-.52-5.34-1.13v-2.79c1.32.77 3.53 1.5 5.46 1.5 2.02 0 3.07-.83 3.07-2.02 0-1.17-.89-1.84-3.8-2.55-3.4-.83-4.85-2.15-4.85-4.66 0-2.67 2.06-4.29 5.55-4.29 1.99 0 3.8.49 4.94 1.1v2.73c-1.84-.92-3.34-1.41-4.97-1.41-1.93 0-2.97.67-2.97 1.87 0 1.07.74 1.75 3.56 2.42 3.4.83 5.12 2.09 5.12 4.75m-16.29-3.49c0-3.68-1.47-5.52-4.2-5.52-2.36 0-4.48 1.5-4.48 4.91v1.23c0 3.4 1.93 4.91 4.17 4.91 2.98 0 4.51-1.96 4.51-5.52m-3.8 7.97c-2.24 0-3.96-1.01-4.88-3.01v8.68h-2.64V10h2.64v2.76c.98-2.02 2.82-3.07 5.18-3.07 4.08 0 6.13 3.47 6.13 7.97 0 4.32-2.15 7.97-6.44 7.97m-20.11.01c-6.22 0-9.72-4.29-9.72-10.43 0-6.07 3.5-10.33 9.72-10.33 6.2 0 9.69 4.26 9.69 10.34 0 6.13-3.5 10.43-9.69 10.43m0-18.12c-4.97 0-6.96 3.53-6.96 7.7 0 4.26 1.99 7.79 6.96 7.79 4.94 0 6.93-3.53 6.93-7.79 0-4.17-1.99-7.7-6.93-7.7\"/>\n    <path fill=\"var(--tile-color,#ffc716)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M16.905 25.684c-.638.47-.974.437-1.612-.033-3.088-2.216-5.942-4.734-7.855-7.352-.202-.269-.1-.638.201-.806l3.491-2.182q.454-.302.806.1c1.343 1.545 2.652 3.056 4.163 4.13 1.51-1.074 2.82-2.585 4.163-4.13q.352-.402.805-.1l3.491 2.182c.303.168.403.537.202.806-1.914 2.618-4.767 5.136-7.855 7.385m-.806-9.635c2.753 0 5.035-2.249 5.035-5.001s-2.282-5.07-5.035-5.07-5.036 2.283-5.036 5.07c0 2.786 2.216 5.001 5.036 5.001\"/>\n</svg>\n";
function $3dbccc3c6ff17112$export$a5b9122e89b32ad3(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Opsgenie' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $jU1LC.LogoWrapper), {
        svg: $3dbccc3c6ff17112$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("8kiMR", function(module, exports) {
$parcel$export(module.exports, "ProjectsIcon", () => $60fec3b9194c046d$export$5ed3e1bb3b04fc02);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6bab74cd77291828d528d124967c3552>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

var $6S9Aj = parcelRequire("6S9Aj");
// `height` is set to 100% to allow the SVG to scale with the parent element
var $60fec3b9194c046d$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" fill-rule=\"evenodd\" d=\"m5.106 14.44 1.856-1.856-1.856-1.856L6.653 9.18h3.712l2.784-2.784h4.332v4.33l-2.785 2.785v3.712L13.15 18.77l-1.857-1.856-1.856 1.856-1.7-1.7 2.784-2.784-.928-.928-2.784 2.784zm10.209-4.331a1.094 1.094 0 1 1-1.547-1.546 1.094 1.094 0 0 1 1.547 1.546\" clip-rule=\"evenodd\"/>\n</svg>\n";
function $60fec3b9194c046d$export$5ed3e1bb3b04fc02(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Projects' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $6S9Aj.IconWrapper), {
        svg: $60fec3b9194c046d$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("6tHn8", function(module, exports) {
$parcel$export(module.exports, "ProjectsLogoCS", () => $4b771850cf63f351$export$e3d1678155aaab99);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::820b1edb3bac4a2b82da6f532724cb11>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

var $jU1LC = parcelRequire("jU1LC");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $4b771850cf63f351$var$svg = "<svg height=\"100%\" viewBox=\"0 0 145 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M144.54 21.16c0 2.55-1.66 4.48-5.77 4.48-2.3 0-4.17-.52-5.34-1.13v-2.79c1.32.77 3.53 1.5 5.46 1.5 2.02 0 3.07-.83 3.07-2.02 0-1.17-.89-1.84-3.8-2.55-3.4-.83-4.84-2.15-4.84-4.66 0-2.67 2.05-4.29 5.55-4.29 1.99 0 3.8.49 4.94 1.1v2.73c-1.84-.92-3.34-1.41-4.97-1.41-1.93 0-2.97.67-2.97 1.87 0 1.07.74 1.75 3.56 2.42 3.4.83 5.12 2.09 5.12 4.75m-17.75-.58c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55c-.46.12-.98.25-1.78.25-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zm-6.66 1.99v2.36c-.92.49-2.33.71-3.74.71-5.46 0-8-3.31-8-8 0-4.63 2.55-7.94 8-7.94 1.38 0 2.45.18 3.65.74v2.45c-.98-.46-2.02-.74-3.47-.74-3.99 0-5.61 2.52-5.61 5.49s1.66 5.49 5.67 5.49c1.56 0 2.55-.21 3.5-.55M99.43 12.09c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.67-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.2c.37 2.61 2.05 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zM83.8 31.25v-2.36c.31.03.49.03.77.03 1.13 0 2.05-.49 2.05-1.87V10h2.64v17.36c0 2.82-1.59 4.02-4.11 4.02-.67 0-1.13-.06-1.35-.12m2.3-25.3c0-1.16.77-1.84 1.84-1.84s1.84.68 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84M76.07 25.64c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49M62.3 16.29v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.67-5.43 3.93m-5-4.4c0 4.39-2.45 6.84-7.48 6.84H45.8v6.59h-2.76V5.19h6.78c5.03 0 7.48 2.58 7.48 6.72m-7.79 4.2c3.56.12 4.94-1.56 4.94-4.14 0-2.45-1.38-4.14-4.94-4.14H45.8v8.28z\"/>\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" fill-rule=\"evenodd\" d=\"m6.152 19.486 2.651-2.652-2.651-2.651 2.21-2.21h5.303l3.977-3.977h6.187v6.187l-3.977 3.977v5.304l-2.21 2.21-2.652-2.652-2.651 2.651-2.429-2.428 3.978-3.978-1.326-1.325-3.978 3.977zM20.736 13.3a1.562 1.562 0 1 1-2.21-2.21 1.562 1.562 0 0 1 2.21 2.21\" clip-rule=\"evenodd\"/>\n</svg>\n";
function $4b771850cf63f351$export$e3d1678155aaab99(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Projects' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $jU1LC.LogoWrapper), {
        svg: $4b771850cf63f351$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("j3Kxp", function(module, exports) {
$parcel$export(module.exports, "RovoIcon", () => $de02659a0a04ea2d$export$e23ae35269442b4f);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c09aee6cc96e54887271dd42a7eae172>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

var $6S9Aj = parcelRequire("6S9Aj");
// `height` is set to 100% to allow the SVG to scale with the parent element
var $de02659a0a04ea2d$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#1868db)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, white)\" d=\"M11.057 5.257a1.57 1.57 0 0 1 1.539.015l4.621 2.668c.484.279.783.797.783 1.354v5.336a1.56 1.56 0 0 1-.782 1.355l-3.474 2.005a2 2 0 0 0 .12-.691v-5.337c0-.733-.39-1.409-1.026-1.774l-2.59-1.495V6.626q.001-.246.074-.473c.117-.364.366-.68.707-.877z\"/>\n    <path fill=\"var(--icon-color, white)\" d=\"M9.881 5.94 6.408 7.945A1.56 1.56 0 0 0 5.625 9.3v5.337c0 .557.3 1.075.783 1.354l4.621 2.668c.475.274 1.06.279 1.539.015l.027-.019a1.57 1.57 0 0 0 .781-1.35v-2.067l-2.589-1.495a2.05 2.05 0 0 1-1.026-1.775V6.631a2 2 0 0 1 .12-.691\"/>\n</svg>\n";
function $de02659a0a04ea2d$export$e23ae35269442b4f(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Rovo' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $6S9Aj.IconWrapper), {
        svg: $de02659a0a04ea2d$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("8Q3Zc", function(module, exports) {
$parcel$export(module.exports, "RovoLogoCS", () => $66f645a065a69f56$export$b0e15f0a1c9f4c55);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::29265478015ee48ec34dc1fd6eae4b81>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

var $jU1LC = parcelRequire("jU1LC");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $66f645a065a69f56$var$svg = "<svg height=\"100%\" viewBox=\"0 0 106 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M98.36 25.64c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49M84.34 25.33h-3.53L74.87 10h2.76l4.97 13.1L87.53 10h2.76zm-17.46.31c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49M49.84 7.82h-4.05v7.36h4.05c3.59 0 4.69-1.38 4.69-3.68 0-2.18-1.13-3.68-4.69-3.68m7.45 3.62c0 3.04-1.29 5.09-3.96 5.95l4.94 7.94h-3.25l-4.44-7.51H45.8v7.51h-2.76V5.19h7.12c4.81 0 7.15 2.39 7.15 6.26\"/>\n    <path fill=\"var(--tile-color,#1868db)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, white)\" d=\"M15.013 6.281a2.26 2.26 0 0 1 2.222.021l6.674 3.854a2.26 2.26 0 0 1 1.131 1.956v7.707c0 .809-.43 1.553-1.13 1.956l-5.018 2.896q.017-.046.032-.093c.093-.289.142-.594.142-.906v-7.707a2.95 2.95 0 0 0-1.481-2.563l-3.74-2.158V8.258c0-.235.036-.465.105-.682.17-.527.529-.983 1.021-1.267h.002z\"/>\n    <path fill=\"var(--icon-color, white)\" d=\"m13.314 7.267-5.017 2.896a2.25 2.25 0 0 0-1.13 1.956v7.707c0 .806.432 1.553 1.13 1.956l6.675 3.854c.686.396 1.53.403 2.222.02l.04-.026c.493-.284.853-.74 1.023-1.267a2.3 2.3 0 0 0 .105-.683v-2.986l-3.74-2.158a2.96 2.96 0 0 1-1.482-2.563V8.266a3 3 0 0 1 .174-1\"/>\n</svg>\n";
function $66f645a065a69f56$export$b0e15f0a1c9f4c55(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Rovo' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $jU1LC.LogoWrapper), {
        svg: $66f645a065a69f56$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("iHGc3", function(module, exports) {
$parcel$export(module.exports, "RovoDevIcon", () => $d9dcf8e066287ee0$export$8b784b3227531b3e);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::0424c604e8fb1e51fac762a4e1efa562>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

var $6S9Aj = parcelRequire("6S9Aj");
// `height` is set to 100% to allow the SVG to scale with the parent element
var $d9dcf8e066287ee0$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#94c748)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M11.26 4.71a1.7 1.7 0 0 1 1.666.017l5.006 2.89c.524.302.848.863.848 1.467v5.78a1.69 1.69 0 0 1-.848 1.467l-3.763 2.172.024-.07c.07-.216.107-.445.107-.679v-5.78c0-.794-.423-1.526-1.112-1.922l-2.805-1.62V6.195q.001-.267.08-.512c.126-.395.396-.737.765-.95l.002-.001z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M9.986 5.45 6.223 7.623a1.69 1.69 0 0 0-.848 1.466v5.78c0 .605.324 1.166.848 1.468l5.006 2.89a1.7 1.7 0 0 0 1.666.016l.03-.02c.37-.214.64-.556.768-.95q.078-.247.079-.513v-2.24l-2.805-1.618a2.22 2.22 0 0 1-1.112-1.922V6.2a2.2 2.2 0 0 1 .13-.75\"/>\n</svg>\n";
function $d9dcf8e066287ee0$export$8b784b3227531b3e(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Rovo Dev' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $6S9Aj.IconWrapper), {
        svg: $d9dcf8e066287ee0$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("dkjYp", function(module, exports) {
$parcel$export(module.exports, "RovoDevLogoCS", () => $9b3ca2e255f4597c$export$4145bd793c9ed1d0);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e0f280d200b0e27835aec655dfa5a41e>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

var $jU1LC = parcelRequire("jU1LC");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $9b3ca2e255f4597c$var$svg = "<svg height=\"100%\" viewBox=\"0 0 165 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M158.79 25.33h-3.53L149.32 10h2.76l4.97 13.1 4.93-13.1h2.76zm-17.64-13.24c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.05 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zM121.91 7.82h-4.54v14.87h4.69c4.6 0 6.9-2.42 6.9-7.3 0-4.91-2.18-7.57-7.05-7.57m-7.3 17.51V5.19h7.42c6.53 0 9.69 4.08 9.69 10.12 0 6.1-3.19 10.03-9.69 10.03zm-16.26.31c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49M84.34 25.33h-3.53L74.86 10h2.76l4.97 13.1L87.53 10h2.76zm-17.46.31c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49M49.84 7.82h-4.05v7.36h4.05c3.59 0 4.69-1.38 4.69-3.68 0-2.18-1.13-3.68-4.69-3.68m7.45 3.62c0 3.04-1.29 5.09-3.96 5.95l4.94 7.94h-3.25l-4.44-7.51H45.8v7.51h-2.76V5.19h7.12c4.81 0 7.15 2.39 7.15 6.26\"/>\n    <path fill=\"var(--tile-color,#94c748)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M15.013 6.281a2.26 2.26 0 0 1 2.222.021l6.674 3.854a2.26 2.26 0 0 1 1.131 1.956v7.707c0 .809-.43 1.553-1.13 1.956l-5.018 2.896.032-.093c.093-.289.142-.594.142-.906v-7.707a2.95 2.95 0 0 0-1.481-2.563l-3.74-2.158V8.258c0-.235.036-.465.105-.682a2.26 2.26 0 0 1 1.021-1.267h.002z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"m13.314 7.267-5.017 2.896a2.25 2.25 0 0 0-1.13 1.956v7.707c0 .806.432 1.553 1.13 1.956l6.675 3.854c.686.396 1.53.403 2.222.02l.04-.026c.493-.284.853-.74 1.023-1.267a2.3 2.3 0 0 0 .105-.683v-2.986l-3.74-2.158a2.96 2.96 0 0 1-1.482-2.563V8.266a3 3 0 0 1 .174-1\"/>\n</svg>\n";
function $9b3ca2e255f4597c$export$4145bd793c9ed1d0(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Rovo Dev' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $jU1LC.LogoWrapper), {
        svg: $9b3ca2e255f4597c$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("4TBto", function(module, exports) {
$parcel$export(module.exports, "RovoDevAgentIcon", () => $39095dd4b30675ef$export$813cff80931d9dbf);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c56e9a05bb3a4c70bfd4cbcb5fa54ba2>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

var $6S9Aj = parcelRequire("6S9Aj");
// `height` is set to 100% to allow the SVG to scale with the parent element
var $39095dd4b30675ef$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#94c748)\" d=\"M10.7.368a2.75 2.75 0 0 1 2.748 0l8.016 4.626a2.75 2.75 0 0 1 1.375 2.38v9.252c0 .982-.524 1.889-1.375 2.38l-8.016 4.626a2.75 2.75 0 0 1-2.749 0l-8.016-4.626a2.75 2.75 0 0 1-1.374-2.38V7.374c0-.982.524-1.889 1.374-2.38z\"/>\n    <path fill=\"var(--icon-color, #101214)\" fill-rule=\"evenodd\" d=\"M10.181 6.096 6.777 8.06a1.53 1.53 0 0 0-.768 1.327v5.229c0 .547.294 1.054.768 1.327l.807.466 3.722 2.149a1.54 1.54 0 0 0 1.508.014l.027-.018a1.54 1.54 0 0 0 .766-1.323v-2.026l-1.97-1.137-.568-.327a2 2 0 0 1-1.006-1.74V6.775a2 2 0 0 1 .118-.678\" clip-rule=\"evenodd\"/>\n    <path fill=\"var(--icon-color, #101214)\" fill-rule=\"evenodd\" d=\"M12.842 5.441a1.54 1.54 0 0 0-1.508-.014l-.028.019a1.54 1.54 0 0 0-.765 1.323v2.025l1.91 1.102.628.362a2 2 0 0 1 1.006 1.74v5.228a2 2 0 0 1-.118.678l3.404-1.965c.476-.273.767-.778.767-1.327V9.383c0-.546-.293-1.054-.767-1.327l-.868-.501z\" clip-rule=\"evenodd\"/>\n</svg>\n";
function $39095dd4b30675ef$export$813cff80931d9dbf(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Rovo Dev Agent' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $6S9Aj.IconWrapper), {
        svg: $39095dd4b30675ef$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("1bhUU", function(module, exports) {
$parcel$export(module.exports, "RovoDevAgentLogoCS", () => $0dc4b7762e2dc0a2$export$58747af448450872);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ca2d332c134816706ee434029a355d3c>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

var $jU1LC = parcelRequire("jU1LC");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $0dc4b7762e2dc0a2$var$svg = "<svg height=\"100%\" viewBox=\"0 0 160 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M153.94 25.67h-3.53l-5.95-15.33h2.76l4.97 13.1 4.94-13.09h2.76zM136.3 12.42c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.67-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.2c.37 2.61 2.05 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-25.13-16.9h-4.54v14.87h4.69c4.6 0 6.9-2.42 6.9-7.3 0-4.91-2.18-7.57-7.05-7.57m-7.3 17.51V5.52h7.42c6.53 0 9.69 4.08 9.69 10.12 0 6.1-3.19 10.03-9.69 10.03zm-16.25.31c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49M79.49 25.67h-3.53l-5.95-15.33h2.76l4.97 13.1 4.94-13.09h2.76zm-17.46.31c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49M45 8.16h-4.05v7.36H45c3.59 0 4.69-1.38 4.69-3.68 0-2.18-1.13-3.68-4.69-3.68m7.45 3.62c0 3.04-1.29 5.09-3.96 5.95l4.94 7.94h-3.25l-4.45-7.51h-4.78v7.51h-2.76V5.52h7.11c4.82 0 7.15 2.39 7.15 6.26\"/>\n    <path fill=\"var(--tile-color,#94c748)\" d=\"M12.52.49a3.67 3.67 0 0 1 3.666 0l10.688 6.17a3.66 3.66 0 0 1 1.833 3.173v12.336a3.66 3.66 0 0 1-1.833 3.173L16.186 31.51a3.67 3.67 0 0 1-3.665 0L1.833 25.341A3.66 3.66 0 0 1 0 22.168V9.832c0-1.309.7-2.519 1.833-3.173z\"/>\n    <path fill=\"var(--icon-color, #101214)\" fill-rule=\"evenodd\" d=\"m11.83 8.128-4.54 2.62a2.04 2.04 0 0 0-1.022 1.77v6.972c0 .728.39 1.405 1.023 1.77l1.076.62 4.963 2.865a2.05 2.05 0 0 0 2.01.02l.037-.025c.445-.257.771-.67.925-1.146q.094-.297.095-.619v-2.7l-2.627-1.516-.757-.436a2.67 2.67 0 0 1-1.34-2.32v-6.97a2.7 2.7 0 0 1 .157-.904\" clip-rule=\"evenodd\"/>\n    <path fill=\"var(--icon-color, #101214)\" fill-rule=\"evenodd\" d=\"M15.377 7.255a2.05 2.05 0 0 0-2.01-.019l-.038.026c-.445.257-.77.67-.924 1.145a2 2 0 0 0-.095.618v2.7l2.545 1.47.839.483a2.67 2.67 0 0 1 1.34 2.319v6.972a2.7 2.7 0 0 1-.157.903l4.54-2.62a2.04 2.04 0 0 0 1.022-1.77v-6.971c0-.729-.39-1.405-1.023-1.77l-1.157-.668z\" clip-rule=\"evenodd\"/>\n</svg>\n";
function $0dc4b7762e2dc0a2$export$58747af448450872(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Rovo Dev Agent' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $jU1LC.LogoWrapper), {
        svg: $0dc4b7762e2dc0a2$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("2JaJ7", function(module, exports) {
$parcel$export(module.exports, "RovoHexIcon", () => $1fc81addba82a112$export$9e62346a60cfb459);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b1fdf93317430cb701429972e6c41dc4>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

var $6S9Aj = parcelRequire("6S9Aj");
// `height` is set to 100% to allow the SVG to scale with the parent element
var $1fc81addba82a112$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--rovo-blue-color, #1868db)\" fill-rule=\"evenodd\" d=\"m13.227 16.789-7.154 4.169-3.403-1.96a2.72 2.72 0 0 1-1.362-2.355V7.366c0-.973.518-1.87 1.361-2.354l6.044-3.487-.038.114a3.6 3.6 0 0 0-.172 1.088v9.278c0 1.274.68 2.45 1.786 3.085z\" clip-rule=\"evenodd\"/>\n    <path fill=\"var(--rovo-green-color, #6a9a23)\" fill-rule=\"evenodd\" d=\"m11.296 15.671-7.193 4.153 6.607 3.812a2.73 2.73 0 0 0 2.676.026l.048-.033a2.73 2.73 0 0 0 1.232-1.525 2.7 2.7 0 0 0 .127-.822v-3.594z\" clip-rule=\"evenodd\"/>\n    <path fill=\"var(--rovo-purple-color, #af59e1)\" fill-rule=\"evenodd\" d=\"m21.477 5.003-4.404-2.539-5.904 4.89 2.69 1.556a3.56 3.56 0 0 1 1.785 3.086v9.277a3.6 3.6 0 0 1-.21 1.202l6.044-3.486a2.71 2.71 0 0 0 1.362-2.355V7.357c0-.97-.521-1.87-1.363-2.354\" clip-rule=\"evenodd\"/>\n    <path fill=\"var(--rovo-yellow-color, #fca700)\" fill-rule=\"evenodd\" d=\"M12.74 8.266 9.353 6.312V2.718c0-.283.044-.56.127-.821A2.73 2.73 0 0 1 10.71.372V.37a.4.4 0 0 0 .048-.033 2.73 2.73 0 0 1 2.676.026l6.499 3.75z\" clip-rule=\"evenodd\"/>\n</svg>\n";
function $1fc81addba82a112$export$9e62346a60cfb459(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Rovo' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $6S9Aj.IconWrapper), {
        svg: $1fc81addba82a112$var$svg,
        label: label,
        type: "rovo",
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("fmqRP", function(module, exports) {
$parcel$export(module.exports, "RovoHexLogoCS", () => $b2edc054b5ef1902$export$5e38d02efdb45577);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::0e01ef8caae93929e35d346a5091c5ef>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

var $jU1LC = parcelRequire("jU1LC");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $b2edc054b5ef1902$var$svg = "<svg height=\"100%\" viewBox=\"0 0 102 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M93.5 25.97c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49M79.49 25.67h-3.53l-5.95-15.33h2.76l4.97 13.1 4.94-13.09h2.76zm-17.46.3c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49M44.99 8.16h-4.05v7.36h4.05c3.59 0 4.69-1.38 4.69-3.68 0-2.18-1.13-3.68-4.69-3.68m7.45 3.62c0 3.04-1.29 5.09-3.96 5.95l4.94 7.94h-3.25l-4.45-7.51h-4.78v7.51h-2.76V5.52h7.11c4.82 0 7.15 2.39 7.15 6.26\"/>\n    <path fill=\"var(--rovo-blue-color, #1868db)\" fill-rule=\"evenodd\" d=\"m15.892 22.385-9.538 5.559-4.538-2.613A3.63 3.63 0 0 1 0 22.19V9.821C0 8.524.69 7.33 1.816 6.682l8.058-4.649-.052.152a4.7 4.7 0 0 0-.228 1.452v12.37a4.74 4.74 0 0 0 2.38 4.113z\" clip-rule=\"evenodd\"/>\n    <path fill=\"var(--rovo-green-color, #6a9a23)\" fill-rule=\"evenodd\" d=\"m13.318 20.895-9.591 5.538 8.809 5.082a3.64 3.64 0 0 0 3.568.034l.065-.043a3.63 3.63 0 0 0 1.642-2.034c.11-.35.17-.718.17-1.096v-4.792z\" clip-rule=\"evenodd\"/>\n    <path fill=\"var(--rovo-purple-color, #af59e1)\" fill-rule=\"evenodd\" d=\"M26.893 6.67 21.02 3.285l-7.873 6.52 3.587 2.075a4.74 4.74 0 0 1 2.38 4.115v12.369a4.7 4.7 0 0 1-.28 1.603l8.058-4.649a3.62 3.62 0 0 0 1.816-3.139V9.81a3.63 3.63 0 0 0-1.816-3.139\" clip-rule=\"evenodd\"/>\n    <path fill=\"var(--rovo-yellow-color, #fca700)\" fill-rule=\"evenodd\" d=\"m15.244 11.022-4.519-2.606V3.625c0-.378.059-.747.17-1.096a3.63 3.63 0 0 1 1.64-2.033l.002-.001.064-.044a3.64 3.64 0 0 1 3.569.034l8.665 5z\" clip-rule=\"evenodd\"/>\n</svg>\n";
function $b2edc054b5ef1902$export$5e38d02efdb45577(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Rovo' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $jU1LC.LogoWrapper), {
        svg: $b2edc054b5ef1902$var$svg,
        label: label,
        type: "rovo",
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("5YANc", function(module, exports) {
$parcel$export(module.exports, "SearchIcon", () => $459f1891af322b96$export$82eafebb825fc23f);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::88ee37f21199df8c4f6de50b597bc415>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

var $6S9Aj = parcelRequire("6S9Aj");
// `height` is set to 100% to allow the SVG to scale with the parent element
var $459f1891af322b96$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" fill-rule=\"evenodd\" d=\"M5 10.688a5.69 5.69 0 0 0 5.697 5.687c1.01 0 1.958-.262 2.78-.723L16.832 19 19 16.834l-3.347-3.341c.471-.828.74-1.785.74-2.806A5.69 5.69 0 0 0 10.697 5 5.69 5.69 0 0 0 5 10.688m2.191 0c0 1.932 1.57 3.5 3.506 3.5a3.503 3.503 0 0 0 3.505-3.5c0-1.933-1.57-3.5-3.505-3.5a3.503 3.503 0 0 0-3.506 3.5\" clip-rule=\"evenodd\"/>\n</svg>\n";
function $459f1891af322b96$export$82eafebb825fc23f(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Search' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $6S9Aj.IconWrapper), {
        svg: $459f1891af322b96$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("fpDzJ", function(module, exports) {
$parcel$export(module.exports, "SearchLogoCS", () => $b387e3aa3e230888$export$fa08cbfe393f2a68);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4165d5d8279c6abbf1ec41290594700b>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

var $jU1LC = parcelRequire("jU1LC");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $b387e3aa3e230888$var$svg = "<svg height=\"100%\" viewBox=\"0 0 130 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M128.82 16.35v8.99h-2.64v-8.53c0-3.16-1.1-4.72-3.62-4.72-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V3.59h2.64v8.96c1.01-1.81 2.85-2.85 5.06-2.85 3.44 0 5.34 2.33 5.34 6.66m-16.04 6.21v2.36c-.92.49-2.33.71-3.74.71-5.46 0-8-3.31-8-8 0-4.63 2.55-7.94 8-7.94 1.38 0 2.45.18 3.65.74v2.45c-.98-.46-2.02-.74-3.47-.74-3.99 0-5.61 2.51-5.61 5.49s1.66 5.49 5.67 5.49c1.56 0 2.55-.21 3.5-.55m-18.23-6.29v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.68-5.43 3.93m-17.87 1.37c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10H88v15.33zM65.08 12.09c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.2c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-15.33-4.95c0 3.5-2.08 5.86-7.08 5.86-3.89 0-5.7-.77-7.27-1.56v-2.82c1.87.98 4.75 1.69 7.42 1.69 3.04 0 4.17-1.2 4.17-2.97 0-1.78-1.1-2.73-4.94-3.65-4.54-1.1-6.56-2.67-6.56-5.98 0-3.13 2.39-5.46 7.08-5.46 2.91 0 4.78.71 6.16 1.47v2.76c-2.02-1.16-4.2-1.53-6.29-1.53-2.64 0-4.2.92-4.2 2.76 0 1.66 1.29 2.48 4.84 3.37 4.26 1.07 6.66 2.45 6.66 6.07\"/>\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" fill-rule=\"evenodd\" d=\"M7.127 14.833a7.583 7.583 0 0 0 11.286 6.62l4.464 4.464 2.887-2.888-4.455-4.455a7.583 7.583 0 1 0-14.181-3.74m2.917 0a4.667 4.667 0 1 0 9.333 0 4.667 4.667 0 0 0-9.333 0\" clip-rule=\"evenodd\"/>\n</svg>\n";
function $b387e3aa3e230888$export$fa08cbfe393f2a68(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Search' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $jU1LC.LogoWrapper), {
        svg: $b387e3aa3e230888$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("fP54Y", function(module, exports) {
$parcel$export(module.exports, "SearchNewIcon", () => $b84f8f15aa01e043$export$3599582ddc9fc5cf);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::5fb81b6548e62d67fc83daf888114f8f>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

var $6S9Aj = parcelRequire("6S9Aj");
// `height` is set to 100% to allow the SVG to scale with the parent element
var $b84f8f15aa01e043$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 6.625a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" fill-rule=\"evenodd\" d=\"M10.76 17.176a5.791 5.791 0 1 1 5.038-2.935l3.403 3.403-2.205 2.204-3.409-3.408a5.77 5.77 0 0 1-2.827.736m-.274-9.37-.242.615c-.344.874-.516 1.312-.833 1.64-.318.33-.749.518-1.61.893l-.37.16v.51l.37.16c.861.376 1.292.563 1.61.893.317.329.49.766.833 1.64l.242.616h.51l.242-.616c.344-.874.516-1.311.834-1.64.317-.33.748-.517 1.61-.893l.368-.16v-.51l-.369-.16c-.861-.375-1.292-.563-1.61-.892-.317-.33-.489-.766-.833-1.64l-.242-.616z\" clip-rule=\"evenodd\"/>\n</svg>\n";
function $b84f8f15aa01e043$export$3599582ddc9fc5cf(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Search' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $6S9Aj.IconWrapper), {
        svg: $b84f8f15aa01e043$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("eUIl7", function(module, exports) {
$parcel$export(module.exports, "SearchNewLogoCS", () => $adb8b094abec557e$export$d669f6cbbb67e061);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::12cecbe0aa290ffe5232721f12ef458f>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

var $jU1LC = parcelRequire("jU1LC");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $adb8b094abec557e$var$svg = "<svg height=\"100%\" viewBox=\"0 0 130 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M128.82 16.35v8.99h-2.64v-8.52c0-3.16-1.1-4.72-3.62-4.72-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V3.59h2.64v8.96c1.01-1.81 2.85-2.85 5.06-2.85 3.44 0 5.34 2.33 5.34 6.66m-16.05 6.21v2.36c-.92.49-2.33.71-3.74.71-5.46 0-8-3.31-8-8 0-4.63 2.55-7.94 8-7.94 1.38 0 2.45.18 3.65.74v2.45c-.98-.46-2.02-.74-3.46-.74-3.99 0-5.61 2.52-5.61 5.49s1.66 5.49 5.67 5.49c1.56 0 2.55-.21 3.5-.55m-18.23-6.29v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.67-5.43 3.93m-17.87 1.37c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.47-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zM65.08 12.09c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.67-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.2c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-15.33-4.95c0 3.5-2.08 5.86-7.08 5.86-3.89 0-5.7-.77-7.27-1.56v-2.82c1.87.98 4.75 1.69 7.42 1.69 3.04 0 4.17-1.2 4.17-2.97s-1.1-2.73-4.94-3.65c-4.54-1.1-6.56-2.67-6.56-5.98 0-3.13 2.39-5.46 7.08-5.46 2.91 0 4.78.71 6.16 1.47v2.76c-2.02-1.16-4.2-1.53-6.29-1.53-2.64 0-4.2.92-4.2 2.76 0 1.66 1.29 2.48 4.85 3.37 4.26 1.07 6.66 2.45 6.66 6.07\"/>\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" fill-rule=\"evenodd\" d=\"M14.346 22.068a7.721 7.721 0 1 1 6.718-3.913l4.537 4.536-2.94 2.94-4.545-4.545a7.7 7.7 0 0 1-3.77.982m-.364-12.494-.323.82c-.459 1.167-.688 1.75-1.112 2.188-.423.44-.997.69-2.146 1.19l-.492.214v.68l.492.213c1.149.5 1.723.75 2.146 1.19.424.439.653 1.022 1.112 2.188l.323.82h.679l.323-.82c.459-1.166.688-1.75 1.111-2.188.424-.44.998-.69 2.147-1.19l.491-.214v-.679l-.491-.214c-1.149-.5-1.723-.75-2.147-1.19-.423-.438-.652-1.021-1.111-2.187l-.323-.82z\" clip-rule=\"evenodd\"/>\n</svg>\n";
function $adb8b094abec557e$export$d669f6cbbb67e061(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Search' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $jU1LC.LogoWrapper), {
        svg: $adb8b094abec557e$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("lGzBY", function(module, exports) {
$parcel$export(module.exports, "StatuspageIcon", () => $fc9924ef36ab5aff$export$f3f5aa321d88adf9);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::37c59c3ee979ff8acaf7525e576da094>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

var $6S9Aj = parcelRequire("6S9Aj");
// `height` is set to 100% to allow the SVG to scale with the parent element
var $fc9924ef36ab5aff$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#ffc716)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M12 9.796c-1.924 0-3.796.832-5.324 2.118q-.238.227-.475.227c-.132 0-.263-.076-.369-.202L3.908 9.771c-.105-.126-.158-.252-.158-.353 0-.151.08-.277.237-.429C6.307 7.023 9.127 5.914 12 5.914s5.693 1.109 8.013 3.075c.158.152.237.278.237.429 0 .1-.053.227-.158.353l-1.924 2.168c-.106.126-.238.202-.37.202q-.236 0-.474-.227c-1.529-1.286-3.4-2.118-5.324-2.118m0 8.118c-2.135 0-3.875-1.664-3.875-3.68 0-2.018 1.74-3.682 3.875-3.682s3.875 1.64 3.875 3.681-1.74 3.68-3.875 3.68\"/>\n</svg>\n";
function $fc9924ef36ab5aff$export$f3f5aa321d88adf9(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Statuspage' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $6S9Aj.IconWrapper), {
        svg: $fc9924ef36ab5aff$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("irena", function(module, exports) {
$parcel$export(module.exports, "StatuspageLogoCS", () => $d6c5e5b8553135a6$export$2bc88a281410ffa7);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4e31a509778b74933bf91345a74560c5>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

var $jU1LC = parcelRequire("jU1LC");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $d6c5e5b8553135a6$var$svg = "<svg height=\"100%\" viewBox=\"0 0 192 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M184.96 12.09c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.05 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-18.64-.62v-1.53c-.98 2.02-2.82 3.07-5.18 3.07-4.05 0-6.07-3.46-6.07-7.97 0-4.32 2.12-7.97 6.38-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.58v13.95c0 4.51-2.12 7.54-7.61 7.54-2.58 0-3.99-.34-5.46-.83v-2.58c1.69.55 3.43.92 5.34.92 3.83 0 5.15-2.05 5.15-4.91m-8.68-6.44c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m-16.96.03c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-16.09-7.66c0-3.68-1.47-5.52-4.2-5.52-2.36 0-4.48 1.5-4.48 4.91v1.23c0 3.4 1.93 4.91 4.17 4.91 2.98 0 4.51-1.96 4.51-5.52m-3.8 7.97c-2.24 0-3.96-1.01-4.88-3v8.68h-2.64V10h2.64v2.76c.98-2.02 2.82-3.07 5.18-3.07 4.08 0 6.13 3.47 6.13 7.97 0 4.32-2.15 7.97-6.44 7.97m-10.55-4.47c0 2.55-1.66 4.48-5.77 4.48-2.3 0-4.17-.52-5.34-1.13v-2.79c1.32.77 3.53 1.5 5.46 1.5 2.02 0 3.07-.83 3.07-2.02 0-1.16-.89-1.84-3.8-2.54-3.4-.83-4.84-2.15-4.84-4.66 0-2.67 2.05-4.29 5.55-4.29 1.99 0 3.8.49 4.94 1.1v2.73c-1.84-.92-3.34-1.41-4.97-1.41-1.93 0-2.97.68-2.97 1.87 0 1.07.74 1.75 3.56 2.42 3.4.83 5.12 2.09 5.12 4.75m-27.61-2.18V10h2.64v9.26c0 2.76 1.1 3.99 3.62 3.99 2.45 0 4.14-1.62 4.14-4.72V10h2.64v15.33h-2.64v-2.51c-.98 1.81-2.79 2.82-4.84 2.82-3.53 0-5.55-2.42-5.55-6.65m-7.16 1.59c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55c-.46.12-.98.25-1.78.25-3.28 0-4.88-1.93-4.88-4.78v-8.19H85V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zm-18.95-2.91c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-17.26-4.75c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55c-.46.12-.98.25-1.78.25-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zm-6.89-.8c0 3.5-2.08 5.86-7.08 5.86-3.89 0-5.7-.77-7.27-1.56v-2.82c1.87.98 4.75 1.69 7.42 1.69 3.04 0 4.17-1.2 4.17-2.97s-1.1-2.73-4.94-3.65c-4.54-1.1-6.56-2.67-6.56-5.98 0-3.13 2.39-5.46 7.08-5.46 2.91 0 4.78.71 6.16 1.47v2.76c-2.02-1.16-4.2-1.53-6.29-1.53-2.64 0-4.2.92-4.2 2.76 0 1.66 1.29 2.48 4.84 3.37 4.26 1.07 6.66 2.45 6.66 6.07\"/>\n    <path fill=\"var(--tile-color,#ffc716)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M15.896 13.196c-2.464 0-4.86 1.114-6.817 2.835q-.303.304-.607.304c-.169 0-.338-.102-.473-.27l-2.463-2.902c-.135-.17-.202-.338-.202-.473 0-.202.1-.371.303-.573C8.607 9.484 12.217 8 15.896 8c3.678 0 7.29 1.484 10.259 4.117.202.202.303.37.303.573 0 .135-.067.304-.202.473l-2.463 2.902c-.135.168-.304.27-.473.27q-.303 0-.607-.304c-1.958-1.721-4.353-2.835-6.817-2.835m0 10.867c-2.733 0-4.96-2.228-4.96-4.927 0-2.7 2.227-4.927 4.96-4.927s4.96 2.193 4.96 4.927-2.227 4.927-4.96 4.927\"/>\n</svg>\n";
function $d6c5e5b8553135a6$export$2bc88a281410ffa7(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Statuspage' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $jU1LC.LogoWrapper), {
        svg: $d6c5e5b8553135a6$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("e62x9", function(module, exports) {
$parcel$export(module.exports, "StudioIcon", () => $a433975bf5f7e38e$export$290a0f24614cde9f);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2be4b98bf6f70e39467c5c4d0f75c6d5>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

var $6S9Aj = parcelRequire("6S9Aj");
// `height` is set to 100% to allow the SVG to scale with the parent element
var $a433975bf5f7e38e$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M10.7 11.222V19h7.8v-7.778z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M14.6 7.609 10.05 5 5.5 7.609v5.217l3.64 2.087V9.667h5.46z\"/>\n</svg>\n";
function $a433975bf5f7e38e$export$290a0f24614cde9f(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Studio' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $6S9Aj.IconWrapper), {
        svg: $a433975bf5f7e38e$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("bdWJY", function(module, exports) {
$parcel$export(module.exports, "StudioLogoCS", () => $021bd8aa5457461d$export$273fd56580e523ae);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a96e3d2d2d3910fdbea7d20bda091bd2>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

var $jU1LC = parcelRequire("jU1LC");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $021bd8aa5457461d$var$svg = "<svg height=\"100%\" viewBox=\"0 0 124 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M116.71 25.64c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49m-13.48-6.2c0-1.16.77-1.84 1.84-1.84s1.84.68 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-15.3-7.66c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V3.59h2.64v21.74zm-27.41-6.34V10h2.64v9.26c0 2.76 1.1 3.99 3.62 3.99 2.45 0 4.14-1.62 4.14-4.72V10h2.64v15.33h-2.64v-2.51c-.98 1.81-2.79 2.82-4.84 2.82-3.53 0-5.55-2.42-5.55-6.65m-7.17 1.59c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55c-.46.12-.98.25-1.78.25-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zm-6.89-.8c0 3.5-2.08 5.86-7.08 5.86-3.89 0-5.7-.77-7.27-1.56v-2.82c1.87.98 4.75 1.69 7.42 1.69 3.04 0 4.17-1.2 4.17-2.97 0-1.78-1.1-2.73-4.94-3.65-4.54-1.1-6.56-2.67-6.56-5.98 0-3.13 2.39-5.46 7.08-5.46 2.91 0 4.78.71 6.16 1.47v2.76c-2.02-1.16-4.2-1.53-6.29-1.53-2.64 0-4.2.92-4.2 2.76 0 1.66 1.29 2.48 4.84 3.37 4.26 1.07 6.66 2.45 6.66 6.07\"/>\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M14.125 14.125V24.75H24.75V14.125z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M19.75 9.594 13.5 6 7.25 9.594v7.187l5 2.875V12.25h7.5z\"/>\n</svg>\n";
function $021bd8aa5457461d$export$273fd56580e523ae(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Studio' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $jU1LC.LogoWrapper), {
        svg: $021bd8aa5457461d$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("c9EzA", function(module, exports) {
$parcel$export(module.exports, "StudioNewIcon", () => $8d95cc456b2600a5$export$8bb9894377e04e04);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e6df92ef654dd711bfb690d95b2c06d7>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

var $6S9Aj = parcelRequire("6S9Aj");
// `height` is set to 100% to allow the SVG to scale with the parent element
var $8d95cc456b2600a5$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" fill-rule=\"evenodd\" d=\"M10.594 18.563v-7.97h7.969v7.97zm3.808-6.488-.163.429c-.235.615-.352.922-.572 1.155s-.52.368-1.12.638l-.222.1v.357l.222.099c.6.27.9.405 1.12.638s.337.54.572 1.156l.163.428h.347l.163-.429c.235-.615.352-.922.572-1.155s.52-.368 1.12-.638l.221-.1v-.357l-.22-.1c-.601-.269-.901-.404-1.121-.637s-.337-.54-.572-1.155l-.164-.429z\" clip-rule=\"evenodd\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M14.813 7.195 10.125 4.5 5.438 7.195v5.39l3.75 2.157V9.187h5.625z\"/>\n</svg>\n";
function $8d95cc456b2600a5$export$8bb9894377e04e04(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Studio' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $6S9Aj.IconWrapper), {
        svg: $8d95cc456b2600a5$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("32evx", function(module, exports) {
$parcel$export(module.exports, "StudioNewLogoCS", () => $235ccff208f28072$export$170353c338ac5f4a);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::88f184410a9d6dcf22f1ca1246d077a0>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

var $jU1LC = parcelRequire("jU1LC");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $235ccff208f28072$var$svg = "<svg height=\"100%\" viewBox=\"0 0 124 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M116.71 25.64c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49m-13.48-6.2c0-1.17.77-1.84 1.84-1.84s1.84.67 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-15.3-7.66c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.47-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V3.59h2.64v21.74zm-27.41-6.34V10h2.64v9.26c0 2.76 1.1 3.99 3.62 3.99 2.45 0 4.14-1.63 4.14-4.72V10h2.64v15.33h-2.64v-2.51c-.98 1.81-2.79 2.82-4.85 2.82-3.53 0-5.55-2.42-5.55-6.65m-7.16 1.59c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55a6.3 6.3 0 0 1-1.78.25c-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zm-6.89-.8c0 3.5-2.08 5.86-7.08 5.86-3.89 0-5.7-.77-7.27-1.56v-2.82c1.87.98 4.75 1.69 7.42 1.69 3.04 0 4.17-1.2 4.17-2.97s-1.1-2.73-4.94-3.65c-4.54-1.1-6.56-2.67-6.56-5.98 0-3.13 2.39-5.46 7.08-5.46 2.91 0 4.78.71 6.16 1.47v2.76c-2.02-1.16-4.2-1.53-6.29-1.53-2.64 0-4.2.92-4.2 2.76 0 1.66 1.29 2.48 4.85 3.37 4.26 1.07 6.66 2.45 6.66 6.07\"/>\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" fill-rule=\"evenodd\" d=\"M14.125 24.75V14.125H24.75V24.75zm5.078-8.65-.218.571c-.312.82-.469 1.23-.762 1.541s-.694.49-1.494.85l-.295.133v.476l.295.133c.8.36 1.2.54 1.494.85.293.311.45.721.762 1.541l.218.572h.462l.218-.572c.313-.82.469-1.23.762-1.54s.694-.491 1.494-.851l.295-.133v-.476l-.295-.132c-.8-.36-1.2-.54-1.494-.85-.293-.312-.45-.722-.762-1.542l-.218-.571z\" clip-rule=\"evenodd\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M19.75 9.594 13.5 6 7.25 9.594v7.187l5 2.875V12.25h7.5z\"/>\n</svg>\n";
function $235ccff208f28072$export$170353c338ac5f4a(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Studio' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $jU1LC.LogoWrapper), {
        svg: $235ccff208f28072$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("ixRbu", function(module, exports) {
$parcel$export(module.exports, "TalentIcon", () => $d8049057fda6644a$export$4b05688514531169);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f1d8fa09e3a068fb57474a844fe5ab56>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

var $6S9Aj = parcelRequire("6S9Aj");
// `height` is set to 100% to allow the SVG to scale with the parent element
var $d8049057fda6644a$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#fb9700)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" fill-rule=\"evenodd\" d=\"m9.297 8.753 2.277-5.073h.858l2.277 5.073 5.529.598.265.816-4.121 3.734 1.14 5.442-.695.505-4.824-2.766-4.824 2.766-.695-.505 1.14-5.442-4.121-3.733.265-.817zm.777 6.415v-.678a1.857 1.857 0 0 1 3.715 0v.613a3.6 3.6 0 0 1-1.886.548h-.053a3.6 3.6 0 0 1-1.776-.483m1.858-3.134a1.393 1.393 0 1 0 0-2.786 1.393 1.393 0 0 0 0 2.786\" clip-rule=\"evenodd\"/>\n</svg>\n";
function $d8049057fda6644a$export$4b05688514531169(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Talent' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $6S9Aj.IconWrapper), {
        svg: $d8049057fda6644a$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("l88pz", function(module, exports) {
$parcel$export(module.exports, "TalentLogoCS", () => $f620deadfddcfbe8$export$1b3979d995ebbc6e);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4af27131cfc453f0f255c3cbe65f158e>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

var $jU1LC = parcelRequire("jU1LC");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $f620deadfddcfbe8$var$svg = "<svg height=\"100%\" viewBox=\"0 0 122 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M117.1 20.58c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55c-.46.12-.98.25-1.78.25-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zm-7.33-4.23v8.99h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.51c.98-1.81 2.79-2.82 4.85-2.82 3.53 0 5.55 2.42 5.55 6.66m-22.92-4.26c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.67-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2H82.4c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-14.47.57c-.21.06-.67.12-1.35.12-2.51 0-4.11-1.19-4.11-4.02V3.59h2.64V21.1c0 1.38.92 1.87 2.06 1.87.28 0 .46 0 .77-.03zm-20.75-7.63c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.47-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zM40.28 5.19h15.09v2.64H49.2v17.51h-2.76V7.82h-6.16z\"/>\n    <path fill=\"var(--tile-color,#fb9700)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"m16.577 4.907 3.035 6.763 7.372.797.354 1.09-5.495 4.977 1.52 7.257-.927.672-6.431-3.687-6.433 3.687-.926-.672 1.52-7.257-5.495-4.978.353-1.089 7.372-.797 3.035-6.763zm-.668 11.936a2.476 2.476 0 0 0-2.476 2.477v.904a4.8 4.8 0 0 0 2.369.644h.07a4.8 4.8 0 0 0 2.514-.73v-.818a2.477 2.477 0 0 0-2.477-2.477m0-4.511a1.857 1.857 0 1 0 0 3.714 1.857 1.857 0 0 0 0-3.714\"/>\n</svg>\n";
function $f620deadfddcfbe8$export$1b3979d995ebbc6e(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Talent' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $jU1LC.LogoWrapper), {
        svg: $f620deadfddcfbe8$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("lkWiF", function(module, exports) {
$parcel$export(module.exports, "TeamsIcon", () => $f888b06ad2a0a146$export$1bcbc9c337da86da);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7cfe9311dc5f8070530ce9772b12f3fc>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

var $6S9Aj = parcelRequire("6S9Aj");
// `height` is set to 100% to allow the SVG to scale with the parent element
var $f888b06ad2a0a146$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M8.06 11.25a2.63 2.63 0 1 0 0-5.25 2.63 2.63 0 0 0 0 5.25m7.88 0a2.63 2.63 0 1 0 0-5.25 2.63 2.63 0 0 0 0 5.25m.17 1.31a2.89 2.89 0 0 1 2.89 2.9V18h-7.22l1.66-3.67a2.89 2.89 0 0 1 2.67-1.77M5 15.63V18h4.81l1.31-2.81a2.63 2.63 0 0 0-2.62-2.63h-.44A3.06 3.06 0 0 0 5 15.63\"/>\n</svg>\n";
function $f888b06ad2a0a146$export$1bcbc9c337da86da(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Teams' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $6S9Aj.IconWrapper), {
        svg: $f888b06ad2a0a146$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("2Knfx", function(module, exports) {
$parcel$export(module.exports, "TeamsLogoCS", () => $2001e983b85d5479$export$bfd8d1c4da84ce71);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a9a7a0d4583e5a9f22d08a0d2f6ac1f1>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

var $jU1LC = parcelRequire("jU1LC");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $2001e983b85d5479$var$svg = "<svg height=\"100%\" viewBox=\"0 0 127 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M126.58 21.16c0 2.55-1.66 4.48-5.77 4.48-2.3 0-4.17-.52-5.34-1.13v-2.79c1.32.77 3.53 1.5 5.46 1.5 2.02 0 3.07-.83 3.07-2.02 0-1.16-.89-1.84-3.8-2.54-3.4-.83-4.84-2.15-4.84-4.66 0-2.67 2.05-4.29 5.55-4.29 1.99 0 3.8.49 4.94 1.1v2.73c-1.84-.92-3.34-1.41-4.97-1.41-1.93 0-2.97.67-2.97 1.87 0 1.07.74 1.75 3.56 2.42 3.4.83 5.12 2.09 5.12 4.75m-24.66-4.36v8.53h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 2.61 0 4.39 1.32 5.15 3.74.86-2.36 2.91-3.74 5.46-3.74 3.44 0 5.34 2.33 5.34 6.66v8.99h-2.64v-8.52c0-3.16-1.1-4.72-3.62-4.72-2.45 0-4.14 1.63-4.14 4.72m-28.33.84c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zM61.99 12.08c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2H57.55c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zM40.28 5.19h15.09v2.64H49.2v17.51h-2.76V7.82h-6.16z\"/>\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M10.75 14.83a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7m10.5 0a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7m.23 1.75a3.86 3.86 0 0 1 3.86 3.86v3.72h-9.62l2.21-5.23a3.86 3.86 0 0 1 3.55-2.35M6.67 20.67v3.5h6.42l1.75-4.08a3.5 3.5 0 0 0-3.5-3.5h-.58a4.08 4.08 0 0 0-4.08 4.08\"/>\n</svg>\n";
function $2001e983b85d5479$export$bfd8d1c4da84ce71(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Teams' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $jU1LC.LogoWrapper), {
        svg: $2001e983b85d5479$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("f58QK", function(module, exports) {
$parcel$export(module.exports, "TrelloIcon", () => $afae300087d0a5bf$export$4384da9b8b140bf4);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2fc7b25031952cd94704eefaa85d7de4>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

var $6S9Aj = parcelRequire("6S9Aj");
// `height` is set to 100% to allow the SVG to scale with the parent element
var $afae300087d0a5bf$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#1558bc)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, white)\" d=\"M9.39 18.23a.95.95 0 0 0 .95-.95V5.38a.95.95 0 0 0-.95-.95H5.38a.95.95 0 0 0-.95.95v11.91c0 .52.42.95.95.95zm9.23-5.46a.95.95 0 0 0 .95-.95V5.38a.95.95 0 0 0-.95-.95h-4.01a.95.95 0 0 0-.95.95v6.44c0 .52.42.95.95.95z\"/>\n</svg>\n";
var $afae300087d0a5bf$var$customThemeSvg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--themed-icon-color, currentcolor)\" d=\"M18 0a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6V6a6 6 0 0 1 6-6zM5.379 4.43a.95.95 0 0 0-.948.949v11.907c0 .523.424.948.948.948H9.39a.95.95 0 0 0 .947-.948V5.38a.95.95 0 0 0-.947-.948zm9.23 0a.95.95 0 0 0-.947.949v6.44c0 .523.423.948.947.949h4.012a.95.95 0 0 0 .948-.949V5.38a.95.95 0 0 0-.948-.948z\"/>\n</svg>\n";
function $afae300087d0a5bf$export$4384da9b8b140bf4(_ref) {
    var iconColor = _ref.iconColor, size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Trello' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $6S9Aj.IconWrapper), {
        svg: $afae300087d0a5bf$var$svg,
        customThemeSvg: $afae300087d0a5bf$var$customThemeSvg,
        iconColor: iconColor,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("k99Uz", function(module, exports) {
$parcel$export(module.exports, "TrelloLogoCS", () => $eaac5616b2480c3a$export$1b13139dfc0336af);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b73a20da143650f747e32cb182c99798>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

var $jU1LC = parcelRequire("jU1LC");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $eaac5616b2480c3a$var$svg = "<svg height=\"100%\" viewBox=\"0 0 113 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M104.97 25.64c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49M96.21 25.3c-.21.06-.67.12-1.35.12-2.51 0-4.11-1.19-4.11-4.02V3.59h2.64V21.1c0 1.38.92 1.87 2.06 1.87.28 0 .46 0 .77-.03zm-8 0c-.21.06-.67.12-1.35.12-2.51 0-4.11-1.19-4.11-4.02V3.59h2.64V21.1c0 1.38.92 1.87 2.06 1.87.28 0 .46 0 .77-.03zM72.86 12.09c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.67-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2H68.42c.37 2.61 2.05 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-19.48-8.44v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.67-5.43 3.93M40.28 5.19h15.09v2.64H49.2v17.51h-2.76V7.82h-6.16z\"/>\n    <path fill=\"var(--tile-color,#1558bc)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, white)\" d=\"M12.9 24c.62 0 1.13-.49 1.13-1.1V9.1c0-.61-.5-1.1-1.13-1.1H8.13C7.51 8 7 8.49 7 9.1v13.8c0 .61.5 1.1 1.13 1.1zm10.97-6.34c.62 0 1.13-.49 1.13-1.1V9.1c0-.61-.5-1.1-1.13-1.1H19.1c-.62 0-1.13.49-1.13 1.1v7.47c0 .61.5 1.1 1.13 1.1z\"/>\n</svg>\n";
function $eaac5616b2480c3a$export$1b13139dfc0336af(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Trello' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $jU1LC.LogoWrapper), {
        svg: $eaac5616b2480c3a$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("gljFT", function(module, exports) {
$parcel$export(module.exports, "AtlassianAdminIcon", () => $be5dde791ff5e212$export$84109e099492cb5f);

var $5FkrB = parcelRequire("5FkrB");

var $8zwGK = parcelRequire("8zwGK");

var $epSHF = parcelRequire("epSHF");

var $dBzF0 = parcelRequire("dBzF0");

var $cjKLY = parcelRequire("cjKLY");
var $be5dde791ff5e212$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor;
    var colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $cjKLY.getColorsFromAppearance)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" focusable=\"false\" aria-hidden=\"true\">\n      <path\n        d=\"M27.545 24.378 16.96 3.208c-.208-.458-.417-.541-.667-.541-.208 0-.458.083-.708.5-1.5 2.375-2.167 5.125-2.167 8 0 4.001 2.042 7.752 5.042 13.794.334.667.584.792 1.167.792h7.335c.541 0 .833-.208.833-.625 0-.208-.042-.333-.25-.75M12.168 14.377c-.834-1.25-1.084-1.334-1.292-1.334s-.333.083-.708.834L4.875 24.46c-.167.334-.208.459-.208.625 0 .334.291.667.916.667h7.46c.5 0 .875-.416 1.083-1.208.25-1 .334-1.876.334-2.917 0-2.917-1.292-5.751-2.292-7.251z\"\n        fill=\"".concat(colors.iconColor, "\"\n      />\n    </svg>");
};
var $be5dde791ff5e212$export$84109e099492cb5f = function AtlassianAdminIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Atlassian Admin' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $epSHF.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $epSHF.defaultLogoParams).textColor : _ref2$textColor, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $epSHF.defaultLogoParams).iconColor : _ref2$iconColor;
    var _useThemeObserver = (0, $8zwGK.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $dBzF0.default), {
        appearance: appearance,
        svg: $be5dde791ff5e212$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        label: label,
        size: size,
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("lEFHv", function(module, exports) {
$parcel$export(module.exports, "AtlassianAdminLogo", () => $fc3dae4a8dba496d$export$f845d9b9254f0541);

var $5FkrB = parcelRequire("5FkrB");

var $8zwGK = parcelRequire("8zwGK");

var $epSHF = parcelRequire("epSHF");

var $dBzF0 = parcelRequire("dBzF0");

var $cjKLY = parcelRequire("cjKLY");
var $fc3dae4a8dba496d$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $cjKLY.getColorsFromAppearance)(appearance, colorMode);
    return "<svg\n      fill=\"none\"\n      height=\"32\"\n      xmlns=\"http://www.w3.org/2000/svg\"\n      viewBox=\"0 0 295 32\"\n      focusable=\"false\"\n      aria-hidden=\"true\"\n    >\n      <path\n        d=\"M294.31 16.348v8.985h-2.637v-9.261c0-2.76-1.104-3.987-3.619-3.987-2.453 0-4.14 1.626-4.14 4.723v8.525h-2.637V10h2.637v2.515c.982-1.81 2.791-2.822 4.846-2.822 3.526 0 5.55 2.423 5.55 6.655M274.168 5.952c0-1.165.766-1.84 1.84-1.84 1.073 0 1.84.675 1.84 1.84s-.767 1.84-1.84 1.84c-1.074 0-1.84-.675-1.84-1.84m.49 19.381V10h2.638v15.333zm-14.069-8.525v8.525h-2.637v-9.261c0-2.76-1.104-3.987-3.619-3.987-2.453 0-4.14 1.626-4.14 4.723v8.525h-2.637V10h2.637v2.515c.981-1.81 2.791-2.822 4.845-2.822 2.607 0 4.386 1.319 5.152 3.742.859-2.362 2.914-3.742 5.459-3.742 3.435 0 5.336 2.331 5.336 6.655v8.985h-2.637v-8.525c0-3.159-1.104-4.723-3.619-4.723-2.453 0-4.14 1.626-4.14 4.723m-28.327.859c0 3.68 1.472 5.52 4.202 5.52 2.361 0 4.477-1.503 4.477-4.907v-1.227c0-3.404-1.932-4.906-4.171-4.906-2.974 0-4.508 1.962-4.508 5.52m8.679 7.666v-2.76c-.981 2.024-2.821 3.067-5.183 3.067-4.078 0-6.133-3.465-6.133-7.973 0-4.324 2.147-7.974 6.44-7.974 2.239 0 3.956 1.012 4.876 3.006V3.59h2.637v21.742zm-22.021-4.017c-1.533 0-3.097-.184-4.814-.521l-1.687 4.538h-3.097l7.942-20.148h3.496l7.943 20.148h-3.097l-1.687-4.569c-1.809.368-3.373.552-4.999.552m0-2.453c1.288 0 2.607-.154 4.171-.399l-4.079-11.04-4.078 11.07c1.502.246 2.76.369 3.986.369\"\n        fill=\"".concat(colors.textColor, "\"\n      />\n      <path\n        d=\"M107.447 10.828c0 2.972 1.345 5.308 6.795 6.37 3.185.707 3.893 1.203 3.893 2.264 0 1.062-.708 1.699-2.973 1.699-2.619 0-5.733-.92-7.785-2.123v4.812c1.627.779 3.751 1.699 7.785 1.699 5.662 0 7.856-2.548 7.856-6.228m0 .07c0-3.538-1.84-5.166-7.148-6.299-2.902-.637-3.61-1.274-3.61-2.194 0-1.132 1.062-1.628 2.973-1.628 2.335 0 4.6.708 6.794 1.7V6.368c-1.557-.779-3.892-1.345-6.653-1.345-5.237 0-7.927 2.265-7.927 5.945m72.475-5.803v20.172h4.318V9.978l1.769 4.034 6.087 11.325h5.379V5.165h-4.247v13.023l-1.628-3.822-4.883-9.2zm-27.319 0h-4.671v20.172h4.671zm-10.05 14.155c0-3.538-1.841-5.166-7.149-6.298-2.902-.637-3.609-1.274-3.609-2.194 0-1.133 1.061-1.628 2.972-1.628 2.336 0 4.601.707 6.795 1.698v-4.6c-1.557-.779-3.893-1.345-6.653-1.345-5.238 0-7.927 2.265-7.927 5.945 0 2.973 1.345 5.309 6.794 6.37 3.185.708 3.893 1.203 3.893 2.265s-.708 1.699-2.973 1.699c-2.618 0-5.733-.92-7.785-2.124v4.813c1.628.779 3.751 1.699 7.785 1.699 5.592 0 7.857-2.548 7.857-6.3M71.069 5.165v20.172h9.625l1.486-4.389h-6.44V5.165zm-19.039 0v4.318h5.167v15.854h4.741V9.483h5.592V5.165zm-6.866 0h-6.157L32 25.336h5.379l.99-3.397c1.204.354 2.478.566 3.752.566s2.548-.212 3.751-.566l.991 3.397h5.379c-.07 0-7.078-20.17-7.078-20.17zM42.05 18.26c-.92 0-1.77-.142-2.548-.354L42.05 9.13l2.548 8.776a9.6 9.6 0 0 1-2.548.354M97.326 5.165H91.17l-7.08 20.171h5.38l.99-3.397c1.203.354 2.477.566 3.751.566s2.548-.212 3.751-.566l.991 3.397h5.379zM94.212 18.26c-.92 0-1.77-.142-2.548-.354l2.548-8.776 2.548 8.776a9.6 9.6 0 0 1-2.548.354m75.306-13.095h-6.157l-7.007 20.171h5.379l.991-3.397c1.203.354 2.477.566 3.751.566s2.548-.212 3.751-.566l.991 3.397h5.379zm-3.043 13.094c-.92 0-1.77-.142-2.548-.354l2.548-8.776 2.548 8.776a10 10 0 0 1-2.548.354M22.878 24.378 12.293 3.208c-.208-.458-.416-.541-.666-.541-.209 0-.459.083-.709.5-1.5 2.375-2.167 5.125-2.167 8 0 4.001 2.042 7.752 5.043 13.794.333.667.583.792 1.166.792h7.335c.542 0 .833-.208.833-.625 0-.208-.041-.333-.25-.75M7.501 14.377c-.833-1.25-1.083-1.334-1.292-1.334s-.333.083-.708.834L.208 24.46c-.166.334-.208.459-.208.625 0 .334.292.667.917.667h7.46c.5 0 .874-.416 1.083-1.208.25-1 .333-1.876.333-2.917 0-2.917-1.292-5.751-2.292-7.251z\"\n        fill=\"").concat(colors.iconColor, "\"\n      />\n    </svg>");
};
var $fc3dae4a8dba496d$export$f845d9b9254f0541 = function AtlassianAdminLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Atlassian Admin' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $epSHF.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $epSHF.defaultLogoParams).textColor : _ref2$textColor, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $epSHF.defaultLogoParams).iconColor : _ref2$iconColor;
    var _useThemeObserver = (0, $8zwGK.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $dBzF0.default), {
        appearance: appearance,
        iconColor: iconColor,
        label: label,
        size: size,
        svg: $fc3dae4a8dba496d$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("1uztH", function(module, exports) {
$parcel$export(module.exports, "AtlassianAdministrationIcon", () => $11641d002e034dd0$export$74517ed253186308);

var $5FkrB = parcelRequire("5FkrB");

var $8zwGK = parcelRequire("8zwGK");

var $epSHF = parcelRequire("epSHF");

var $dBzF0 = parcelRequire("dBzF0");

var $cjKLY = parcelRequire("cjKLY");
var $11641d002e034dd0$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor;
    var colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $cjKLY.getColorsFromAppearance)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" focusable=\"false\" aria-hidden=\"true\">\n      <path\n        d=\"M27.545 24.378 16.96 3.208c-.208-.458-.417-.541-.667-.541-.208 0-.458.083-.708.5-1.5 2.375-2.167 5.125-2.167 8 0 4.001 2.042 7.752 5.042 13.794.334.667.584.792 1.167.792h7.335c.541 0 .833-.208.833-.625 0-.208-.042-.333-.25-.75M12.168 14.377c-.834-1.25-1.084-1.334-1.292-1.334s-.333.083-.708.834L4.875 24.46c-.167.334-.208.459-.208.625 0 .334.291.667.916.667h7.46c.5 0 .875-.416 1.083-1.208.25-1 .334-1.876.334-2.917 0-2.917-1.292-5.751-2.292-7.251z\"\n        fill=\"".concat(colors.iconColor, "\"\n      />\n    </svg>");
};
var $11641d002e034dd0$export$74517ed253186308 = function AtlassianAdministrationIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Atlassian Administration' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $epSHF.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $epSHF.defaultLogoParams).textColor : _ref2$textColor, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $epSHF.defaultLogoParams).iconColor : _ref2$iconColor;
    var _useThemeObserver = (0, $8zwGK.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $dBzF0.default), {
        appearance: appearance,
        svg: $11641d002e034dd0$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        label: label,
        size: size,
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("ft85g", function(module, exports) {
$parcel$export(module.exports, "AtlassianAdministrationLogo", () => $b42fd5b9194bb9eb$export$833abe6c2ce5ebfd);

var $5FkrB = parcelRequire("5FkrB");

var $8zwGK = parcelRequire("8zwGK");

var $epSHF = parcelRequire("epSHF");

var $dBzF0 = parcelRequire("dBzF0");

var $cjKLY = parcelRequire("cjKLY");
var $b42fd5b9194bb9eb$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $cjKLY.getColorsFromAppearance)(appearance, colorMode);
    return "<svg\n      fill=\"none\"\n      height=\"32\"\n      xmlns=\"http://www.w3.org/2000/svg\"\n      viewBox=\"0 0 404 32\"\n      focusable=\"false\"\n      aria-hidden=\"true\"\n    >\n      <path\n        d=\"M403.77 16.348v8.985h-2.637v-9.261c0-2.76-1.104-3.987-3.619-3.987-2.453 0-4.14 1.626-4.14 4.723v8.525h-2.637V10h2.637v2.515c.981-1.81 2.791-2.822 4.845-2.822 3.527 0 5.551 2.423 5.551 6.655m-23.336 9.292c-4.6 0-7.299-3.404-7.299-8.004s2.699-7.943 7.299-7.943c4.57 0 7.237 3.343 7.237 7.943s-2.667 8.004-7.237 8.004m0-13.493c-3.281 0-4.723 2.576-4.723 5.489s1.442 5.55 4.723 5.55c3.251 0 4.661-2.637 4.661-5.55s-1.41-5.49-4.661-5.49zm-13.488-6.195c0-1.165.767-1.84 1.84-1.84 1.074 0 1.84.675 1.84 1.84s-.766 1.84-1.84 1.84c-1.073 0-1.84-.675-1.84-1.84m.491 19.381V10h2.637v15.333zm-7.461-4.753c0 1.35.797 2.27 2.422 2.27.614 0 1.196-.123 1.656-.215v2.545a6.3 6.3 0 0 1-1.778.245c-3.282 0-4.876-1.932-4.876-4.784v-8.188h-2.484V10h2.484V6.75h2.576V10h4.078v2.453h-4.078zm-18.943-2.913c0 3.68 1.472 5.52 4.202 5.52 2.361 0 4.477-1.503 4.477-4.907v-1.227c0-3.404-1.932-4.906-4.171-4.906-2.974 0-4.508 1.962-4.508 5.52m8.679 7.666v-2.76c-.981 2.024-2.821 3.067-5.183 3.067-4.078 0-6.133-3.465-6.133-7.973 0-4.324 2.147-7.974 6.44-7.974 2.239 0 3.956 1.012 4.876 3.006V10h2.637v15.333zm-17.793-9.046v9.046h-2.576V10h2.576v2.699c.89-1.81 2.423-3.098 5.428-2.914v2.576c-3.373-.337-5.428.675-5.428 3.926m-10.037 4.293c0 1.35.797 2.27 2.423 2.27.613 0 1.196-.123 1.656-.215v2.545c-.46.123-.982.245-1.779.245-3.281 0-4.876-1.932-4.876-4.784v-8.188h-2.484V10h2.484V6.75h2.576V10h4.079v2.453h-4.079zm-6.696.583c0 2.545-1.656 4.477-5.765 4.477-2.3 0-4.171-.521-5.336-1.135v-2.79c1.319.766 3.527 1.502 5.459 1.502 2.024 0 3.066-.828 3.066-2.024 0-1.165-.889-1.84-3.802-2.545-3.404-.828-4.846-2.147-4.846-4.661 0-2.668 2.055-4.294 5.551-4.294 1.993 0 3.803.491 4.937 1.104v2.73c-1.84-.92-3.342-1.411-4.968-1.411-1.932 0-2.974.675-2.974 1.87 0 1.074.736 1.749 3.557 2.423 3.404.828 5.121 2.086 5.121 4.754M297.497 5.952c0-1.165.767-1.84 1.84-1.84 1.074 0 1.84.675 1.84 1.84s-.766 1.84-1.84 1.84c-1.073 0-1.84-.675-1.84-1.84m.491 19.381V10h2.637v15.333zm-3.678-8.985v8.985h-2.637v-9.261c0-2.76-1.104-3.987-3.619-3.987-2.453 0-4.14 1.626-4.14 4.723v8.525h-2.637V10h2.637v2.515c.982-1.81 2.791-2.822 4.846-2.822 3.526 0 5.55 2.423 5.55 6.655M274.168 5.952c0-1.165.766-1.84 1.84-1.84 1.073 0 1.84.675 1.84 1.84s-.767 1.84-1.84 1.84c-1.074 0-1.84-.675-1.84-1.84m.49 19.381V10h2.638v15.333zm-14.069-8.525v8.525h-2.637v-9.261c0-2.76-1.104-3.987-3.619-3.987-2.453 0-4.14 1.626-4.14 4.723v8.525h-2.637V10h2.637v2.515c.981-1.81 2.791-2.822 4.845-2.822 2.607 0 4.386 1.319 5.152 3.742.859-2.362 2.914-3.742 5.459-3.742 3.435 0 5.336 2.331 5.336 6.655v8.985h-2.637v-8.525c0-3.159-1.104-4.723-3.619-4.723-2.453 0-4.14 1.626-4.14 4.723m-28.327.859c0 3.68 1.472 5.52 4.202 5.52 2.361 0 4.477-1.503 4.477-4.907v-1.227c0-3.404-1.932-4.906-4.171-4.906-2.974 0-4.508 1.962-4.508 5.52m8.679 7.666v-2.76c-.981 2.024-2.821 3.067-5.183 3.067-4.078 0-6.133-3.465-6.133-7.973 0-4.324 2.147-7.974 6.44-7.974 2.239 0 3.956 1.012 4.876 3.006V3.59h2.637v21.742zm-22.021-4.017c-1.533 0-3.097-.184-4.814-.521l-1.687 4.538h-3.097l7.942-20.148h3.496l7.943 20.148h-3.097l-1.687-4.569c-1.809.368-3.373.552-4.999.552m0-2.453c1.288 0 2.607-.154 4.171-.399l-4.079-11.04-4.078 11.07c1.502.246 2.76.369 3.986.369\"\n        fill=\"".concat(colors.textColor, "\"\n      />\n      <path\n        d=\"M107.447 10.828c0 2.972 1.345 5.308 6.795 6.37 3.185.707 3.893 1.203 3.893 2.264 0 1.062-.708 1.699-2.973 1.699-2.619 0-5.733-.92-7.785-2.123v4.812c1.627.779 3.751 1.699 7.785 1.699 5.662 0 7.856-2.548 7.856-6.228m0 .07c0-3.538-1.84-5.166-7.148-6.299-2.902-.637-3.61-1.274-3.61-2.194 0-1.132 1.062-1.628 2.973-1.628 2.335 0 4.6.708 6.794 1.7V6.368c-1.557-.779-3.892-1.345-6.653-1.345-5.237 0-7.927 2.265-7.927 5.945m72.475-5.803v20.172h4.318V9.978l1.769 4.034 6.087 11.325h5.379V5.165h-4.247v13.023l-1.628-3.822-4.883-9.2zm-27.319 0h-4.671v20.172h4.671zm-10.05 14.155c0-3.538-1.841-5.166-7.149-6.298-2.902-.637-3.609-1.274-3.609-2.194 0-1.133 1.061-1.628 2.972-1.628 2.336 0 4.601.707 6.795 1.698v-4.6c-1.557-.779-3.893-1.345-6.653-1.345-5.238 0-7.927 2.265-7.927 5.945 0 2.973 1.345 5.309 6.794 6.37 3.185.708 3.893 1.203 3.893 2.265s-.708 1.699-2.973 1.699c-2.618 0-5.733-.92-7.785-2.124v4.813c1.628.779 3.751 1.699 7.785 1.699 5.592 0 7.857-2.548 7.857-6.3M71.069 5.165v20.172h9.625l1.486-4.389h-6.44V5.165zm-19.039 0v4.318h5.167v15.854h4.741V9.483h5.592V5.165zm-6.866 0h-6.157L32 25.336h5.379l.99-3.397c1.204.354 2.478.566 3.752.566s2.548-.212 3.751-.566l.991 3.397h5.379c-.07 0-7.078-20.17-7.078-20.17zM42.05 18.26c-.92 0-1.77-.142-2.548-.354L42.05 9.13l2.548 8.776a9.6 9.6 0 0 1-2.548.354M97.326 5.165H91.17l-7.08 20.171h5.38l.99-3.397c1.203.354 2.477.566 3.751.566s2.548-.212 3.751-.566l.991 3.397h5.379zM94.212 18.26c-.92 0-1.77-.142-2.548-.354l2.548-8.776 2.548 8.776a9.6 9.6 0 0 1-2.548.354m75.306-13.095h-6.157l-7.007 20.171h5.379l.991-3.397c1.203.354 2.477.566 3.751.566s2.548-.212 3.751-.566l.991 3.397h5.379zm-3.043 13.094c-.92 0-1.77-.142-2.548-.354l2.548-8.776 2.548 8.776a10 10 0 0 1-2.548.354M22.878 24.378 12.293 3.208c-.208-.458-.416-.541-.666-.541-.209 0-.459.083-.709.5-1.5 2.375-2.167 5.125-2.167 8 0 4.001 2.042 7.752 5.043 13.794.333.667.583.792 1.166.792h7.335c.542 0 .833-.208.833-.625 0-.208-.041-.333-.25-.75M7.501 14.377c-.833-1.25-1.083-1.334-1.292-1.334s-.333.083-.708.834L.208 24.46c-.166.334-.208.459-.208.625 0 .334.292.667.917.667h7.46c.5 0 .874-.416 1.083-1.208.25-1 .333-1.876.333-2.917 0-2.917-1.292-5.751-2.292-7.251z\"\n        fill=\"").concat(colors.iconColor, "\"\n      />\n    </svg>");
};
var $b42fd5b9194bb9eb$export$833abe6c2ce5ebfd = function AtlassianAdministrationLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Atlassian Administration' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $epSHF.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $epSHF.defaultLogoParams).textColor : _ref2$textColor, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $epSHF.defaultLogoParams).iconColor : _ref2$iconColor;
    var _useThemeObserver = (0, $8zwGK.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $dBzF0.default), {
        appearance: appearance,
        iconColor: iconColor,
        label: label,
        size: size,
        svg: $b42fd5b9194bb9eb$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("oJHVJ", function(module, exports) {
$parcel$export(module.exports, "AtlassianAnalyticsIcon", () => $04a5b292b855fc5d$export$c42ad8a0b925c762);

var $5FkrB = parcelRequire("5FkrB");

var $clOBm = parcelRequire("clOBm");

var $8zwGK = parcelRequire("8zwGK");

var $epSHF = parcelRequire("epSHF");

var $dBzF0 = parcelRequire("dBzF0");

var $cjKLY = parcelRequire("cjKLY");
var $04a5b292b855fc5d$var$svg = function svg(_ref, colorMode, id) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor;
    var colors = {
        iconGradientStart: iconColor,
        iconGradientStop: iconColor,
        iconColor: iconColor
    };
    if (appearance) colors = (0, $cjKLY.getColorsFromAppearanceOldLogos)(appearance, colorMode);
    return "<svg height=\"32\" viewBox=\"0 0 48 48\" xmlns=\"http://www.w3.org/2000/svg\">\n  <defs>\n    <linearGradient id=\"".concat(id, "-a\" x1=\"12.595\" x2=\"12.595\" y1=\"40\" y2=\"30\" gradientUnits=\"userSpaceOnUse\">\n      <stop offset=\"0\" stop-color=\"").concat(colors.iconGradientStart, "\"/>\n      <stop offset=\"1\" stop-color=\"").concat(colors.iconGradientStop, "\"/>\n    </linearGradient>\n    <linearGradient id=\"").concat(id, "-b\" x1=\"28.595\" x2=\"28.595\" y1=\"40\" y2=\"27\" gradientUnits=\"userSpaceOnUse\">\n      <stop offset=\"0\" stop-color=\"").concat(colors.iconGradientStart, "\"/>\n      <stop offset=\"1\" stop-color=\"").concat(colors.iconGradientStop, "\"/>\n    </linearGradient>\n    <linearGradient xlink:href=\"#").concat(id, "-b\" id=\"").concat(id, "-c\" x1=\"20.595\" x2=\"20.595\" y2=\"22\"/>\n    <linearGradient xlink:href=\"#").concat(id, "-b\" id=\"").concat(id, "-d\" x1=\"36.595\" x2=\"36.595\" y2=\"20\"/>\n  </defs>\n  <path d=\"M10.595 30h4v10h-4z\" fill=\"url(#").concat(id, "-a)\"/>\n  <path d=\"M26.595 27h4v13h-4z\" fill=\"url(#").concat(id, "-b)\"/>\n  <path d=\"M18.595 22h4v18h-4z\" fill=\"url(#").concat(id, "-c)\"/>\n  <path d=\"M34.595 20h4v20h-4z\" fill=\"url(#").concat(id, "-d)\"/>\n  <path fill=\"").concat(colors.iconColor, "\" d=\"m9.009 25.414-2.828-2.828 10.127-10.128a5 5 0 0 1 6.605-.411l4.471 3.477a1.5 1.5 0 0 0 1.982-.123l9.815-9.815 2.828 2.828-10.127 10.128a5 5 0 0 1-6.605.411l-4.471-3.477a1.5 1.5 0 0 0-1.982.123l-9.815 9.815Z\" />\n</svg>");
};
var $04a5b292b855fc5d$export$c42ad8a0b925c762 = function AtlassianAnalyticsIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Atlassian Analytics' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $epSHF.defaultLogoParams).size : _ref2$size, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $epSHF.defaultLogoParams).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $epSHF.defaultLogoParams).textColor : _ref2$textColor, testId = _ref2.testId;
    var _useThemeObserver = (0, $8zwGK.default)(), colorMode = _useThemeObserver.colorMode;
    var id = (0, $clOBm.useId)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $dBzF0.default), {
        appearance: appearance,
        label: label,
        svg: $04a5b292b855fc5d$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode, id),
        iconColor: iconColor,
        textColor: textColor,
        size: size,
        testId: testId
    });
};

});
parcelRegister("clOBm", function(module, exports) {
$parcel$export(module.exports, "useId", () => $8fdeb29f084eb05c$export$f680877a34711e37);

var $ekGgq = parcelRequire("ekGgq");

var $5FkrB = parcelRequire("5FkrB");
function $8fdeb29f084eb05c$export$f680877a34711e37() {
    // React uses `:` or `«»` in selectors which breaks `document.querySelector(…)`.
    // Replace with `_` to match future React 19 functionality.
    return (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).useId().replace(/[:«»]/g, '_');
}
var $8fdeb29f084eb05c$export$6be90bcb437e928f = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function(_ref, ref) {
    var children = _ref.children, _ref$postfix = _ref.postfix, postfix = _ref$postfix === void 0 ? '' : _ref$postfix, _ref$prefix = _ref.prefix, prefix = _ref$prefix === void 0 ? '' : _ref$prefix;
    var id = "".concat(prefix).concat($8fdeb29f084eb05c$export$f680877a34711e37()).concat(postfix);
    (0, $5FkrB.useEffect)(function() {
        if (!ref) return;
        switch((0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(ref)){
            case 'function':
                ref(id);
                break;
            case 'object':
                ref.current = id;
                break;
            default:
                throw new Error("Unreachable case for unsupported type of ref \"".concat((0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(ref), "\""));
        }
    }, [
        id,
        ref
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).Fragment, null, typeof children === 'function' ? children({
        id: id
    }) : children);
});
function $8fdeb29f084eb05c$export$6ee17796e3d70de2() {
    var uid = $8fdeb29f084eb05c$export$f680877a34711e37();
    return function(id) {
        return "".concat(uid, "-").concat(id.toString());
    };
}

});


parcelRegister("k10Jw", function(module, exports) {
$parcel$export(module.exports, "AtlassianAnalyticsLogo", () => $e924784294e0676a$export$e6470bfc39010cc4);

var $5FkrB = parcelRequire("5FkrB");

var $clOBm = parcelRequire("clOBm");

var $8zwGK = parcelRequire("8zwGK");

var $epSHF = parcelRequire("epSHF");

var $dBzF0 = parcelRequire("dBzF0");

var $cjKLY = parcelRequire("cjKLY");
var $e924784294e0676a$var$svg = function svg(_ref, colorMode, id) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconGradientStart: iconColor,
        iconGradientStop: iconColor,
        textColor: textColor,
        iconColor: iconColor,
        // We treat the word "Atlassian" differently to normal app logos, it has a bold brand look
        atlassianLogoTextColor: textColor
    };
    if (appearance) colors = (0, $cjKLY.getColorsFromAppearanceOldLogos)(appearance, colorMode);
    return "\n  <svg height=\"32\" viewBox=\"0 0 477 48\" xmlns=\"http://www.w3.org/2000/svg\">\n  <defs>\n    <linearGradient id=\"".concat(id, "-a\" x1=\"447.285\" x2=\"447.285\" y1=\"40\" y2=\"30\" gradientUnits=\"userSpaceOnUse\">\n      <stop offset=\"0\" stop-color=\"").concat(colors.iconGradientStart, "\"/>\n      <stop offset=\"1\" stop-color=\"").concat(colors.iconGradientStop, "\"/>\n    </linearGradient>\n    <linearGradient xlink:href=\"#").concat(id, "-a\" id=\"").concat(id, "-b\" x1=\"463.285\" x2=\"463.285\" y2=\"27\"/>\n    <linearGradient xlink:href=\"#").concat(id, "-a\" id=\"").concat(id, "-c\" x1=\"455.285\" x2=\"455.285\" y2=\"22\"/>\n    <linearGradient xlink:href=\"#").concat(id, "-a\" id=\"").concat(id, "-d\" x1=\"471.285\" x2=\"471.285\" y2=\"20\"/>\n  </defs>\n  <g fill=\"").concat(colors.atlassianLogoTextColor, "\">\n    <path d=\"M106.72 18.359c0 4.201 1.949 7.536 9.572 9.008 4.548.953 5.5 1.689 5.5 3.205 0 1.473-.953 2.425-4.158 2.425-3.725 0-8.142-1.256-11.044-2.988v6.843c2.295 1.126 5.327 2.382 10.957 2.382 7.969 0 11.131-3.551 11.131-8.835m0 0c0-4.981-2.642-7.319-10.091-8.922-4.114-.91-5.111-1.819-5.111-3.118 0-1.646 1.473-2.339 4.201-2.339 3.292 0 6.54.996 9.615 2.382v-6.54c-2.166-1.083-5.5-1.949-9.398-1.949-7.363 0-11.174 3.205-11.174 8.445M209.1 10.346v28.455h6.063V17.103l2.556 5.76 8.575 15.938h7.623V10.346h-6.064V28.71l-2.295-5.327-6.886-13.037H209.1zM163.909 10.346h6.626v28.455h-6.626zM156.263 30.399c0-4.981-2.642-7.319-10.091-8.922-4.114-.91-5.111-1.819-5.111-3.118 0-1.646 1.473-2.339 4.201-2.339 3.292 0 6.54.996 9.615 2.382v-6.54c-2.166-1.083-5.5-1.949-9.398-1.949-7.363 0-11.174 3.205-11.174 8.445 0 4.201 1.949 7.536 9.572 9.008 4.548.953 5.5 1.689 5.5 3.205 0 1.473-.953 2.425-4.158 2.425-3.725 0-8.142-1.256-11.044-2.988v6.843c2.295 1.126 5.327 2.382 10.957 2.382 7.969 0 11.131-3.551 11.131-8.835M55.243 10.346v28.455h13.62l2.145-6.15h-9.095V10.346h-6.67zM28.334 10.346v6.15h7.363v22.305h6.67V16.496h7.882v-6.15H28.334zM18.663 10.346h-8.74L0 38.801h7.579l1.407-4.792a18.852 18.852 0 0 0 10.612 0l1.407 4.792h7.579l-9.922-28.455Zm-4.37 18.533c-1.267 0-2.49-.185-3.647-.524l3.647-12.422 3.647 12.422c-1.157.339-2.38.524-3.647.524ZM92.344 10.346h-8.74l-9.922 28.455h7.579l1.407-4.792a18.852 18.852 0 0 0 10.612 0l1.407 4.792h7.579l-9.922-28.455Zm-4.37 18.533c-1.267 0-2.49-.185-3.647-.524l3.647-12.422 3.647 12.422c-1.157.339-2.38.524-3.647.524ZM194.414 10.346h-8.74l-9.922 28.455h7.579l1.407-4.792a18.852 18.852 0 0 0 10.612 0l1.407 4.792h7.579l-9.922-28.455Zm-4.37 18.533c-1.267 0-2.49-.185-3.647-.524l3.647-12.422 3.647 12.422c-1.157.339-2.38.524-3.647.524Z\"/>\n  </g>\n  <g fill=\"").concat(colors.textColor, "\">\n    <path d=\"m254.776 31.987-2.53 6.809H247.6l11.916-30.225h5.244l11.916 30.225h-4.646l-2.53-6.855c-2.714.552-5.061.828-7.499.828-2.3 0-4.646-.276-7.223-.782Zm13.479-3.496-6.119-16.562-6.119 16.608c2.254.368 4.141.552 5.98.552 1.933 0 3.911-.23 6.257-.598ZM298.984 38.796h-3.957V24.902c0-4.141-1.656-5.981-5.428-5.981-3.681 0-6.211 2.438-6.211 7.085v12.79h-3.957V15.794h3.957v3.772c1.472-2.715 4.187-4.232 7.269-4.232 5.291 0 8.327 3.634 8.327 9.983v13.479ZM320.097 34.656c-1.472 3.036-4.232 4.6-7.775 4.6-6.119 0-9.201-5.199-9.201-11.961 0-6.486 3.22-11.961 9.661-11.961 3.358 0 5.935 1.518 7.314 4.508v-4.048h3.957v23.002h-3.957v-4.14Zm-6.717.92c3.542 0 6.717-2.254 6.717-7.361v-1.84c0-5.106-2.898-7.361-6.256-7.361-4.463 0-6.763 2.944-6.763 8.281 0 5.521 2.208 8.281 6.303 8.281ZM336.196 38.935c-3.772 0-6.165-1.794-6.165-6.027V6.179h3.957v26.269c0 2.07 1.38 2.806 3.083 2.806.414 0 .69 0 1.15-.046v3.542c-.322.092-1.012.184-2.024.184ZM347.328 37.324l-8.327-21.53h4.232l7.361 19.69 7.361-19.69h4.232l-8.695 22.267c-2.576 6.579-4.048 9.983-9.891 9.983-1.979 0-3.083-.184-4.232-.644v-3.404c1.334.414 2.852.552 4.002.552 3.22 0 4.646-2.208 6.533-7.223h-2.576ZM374.698 35.07c.92 0 1.794-.185 2.484-.322v3.818c-.69.184-1.472.368-2.668.368-4.923 0-7.315-2.898-7.315-7.177V19.473h-3.727v-3.68h3.727v-4.877h3.864v4.877h6.119v3.68h-6.119v12.191c0 2.024 1.196 3.405 3.635 3.405ZM384.265 6.961c1.61 0 2.76 1.012 2.76 2.76s-1.15 2.76-2.76 2.76-2.76-1.012-2.76-2.76 1.15-2.76 2.76-2.76Zm-2.024 8.833h3.957v23.002h-3.957V15.794ZM408.416 38.198c-1.38.736-3.496 1.058-5.612 1.058-8.189 0-12.007-4.968-12.007-12.007 0-6.947 3.818-11.915 12.007-11.915 2.07 0 3.68.276 5.475 1.104v3.681c-1.472-.69-3.037-1.104-5.199-1.104-5.98 0-8.419 3.772-8.419 8.235s2.484 8.235 8.511 8.235c2.346 0 3.818-.322 5.244-.828v3.542ZM420.144 39.256c-3.451 0-6.257-.782-8.005-1.702v-4.187c1.978 1.15 5.291 2.254 8.188 2.254 3.037 0 4.601-1.242 4.601-3.036 0-1.749-1.334-2.761-5.705-3.818-5.106-1.242-7.269-3.221-7.269-6.993 0-4.002 3.082-6.44 8.327-6.44 2.99 0 5.705.736 7.407 1.656v4.094c-2.76-1.38-5.014-2.117-7.453-2.117-2.898 0-4.462 1.013-4.462 2.807 0 1.61 1.104 2.622 5.336 3.635 5.106 1.242 7.683 3.128 7.683 7.13 0 3.819-2.484 6.717-8.649 6.717Z\"/>\n  </g>\n  <path fill=\"url(#").concat(id, "-a)\" d=\"M445.285 30h4v10h-4z\"/>\n  <path fill=\"url(#").concat(id, "-b)\" d=\"M461.285 27h4v13h-4z\"/>\n  <path fill=\"url(#").concat(id, "-c)\" d=\"M453.285 22h4v18h-4z\"/>\n  <path fill=\"url(#").concat(id, "-d)\" d=\"M469.285 20h4v20h-4z\"/>\n  <path fill=\"").concat(colors.iconColor, "\" d=\"m443.699 25.414-2.828-2.828 10.127-10.128a5 5 0 0 1 6.605-.411l4.471 3.477a1.5 1.5 0 0 0 1.982-.123l9.815-9.815 2.828 2.828-10.127 10.128a5 5 0 0 1-6.605.411l-4.471-3.477a1.5 1.5 0 0 0-1.982.123l-9.815 9.815Z\"/>\n</svg>");
};
var $e924784294e0676a$export$e6470bfc39010cc4 = function AtlassianAnalyticsLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Atlassian Analytics' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $epSHF.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $epSHF.defaultLogoParams).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $epSHF.defaultLogoParams).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $8zwGK.default)(), colorMode = _useThemeObserver.colorMode;
    var id = (0, $clOBm.useId)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $dBzF0.default), {
        appearance: appearance,
        label: label,
        size: size,
        iconColor: iconColor,
        svg: $e924784294e0676a$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode, id),
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("3dZcQ", function(module, exports) {
$parcel$export(module.exports, "BitbucketIcon", () => $25921040dfc276c5$export$5fc1066e677788d4);

var $5FkrB = parcelRequire("5FkrB");

var $8zwGK = parcelRequire("8zwGK");

var $epSHF = parcelRequire("epSHF");

var $dBzF0 = parcelRequire("dBzF0");

var $cjKLY = parcelRequire("cjKLY");
var $25921040dfc276c5$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor;
    var colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $cjKLY.getColorsFromAppearance)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" viewBox=\"0 0 32 32\" focusable=\"false\" aria-hidden=\"true\" xmlns=\"http://www.w3.org/2000/svg\">\n      <path fill=".concat(colors.iconColor, " d=\"m25.586 15.819-1.618 9.885c-.106.598-.528.95-1.126.95H9.122c-.598 0-1.02-.352-1.126-.95L5.146 8.08c-.105-.598.212-.985.775-.985h20.123c.562 0 .88.387.773.985l-.773 4.644c-.106.668-.493.95-1.126.95H12.816c-.176 0-.282.105-.246.316l.95 5.84c.035.14.14.246.281.246h4.362c.141 0 .246-.105.282-.246l.668-4.222c.07-.527.422-.738.915-.738h4.75c.703 0 .914.351.808.95\"/>\n    </svg>");
};
var $25921040dfc276c5$export$5fc1066e677788d4 = function BitbucketIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Bitbucket' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $epSHF.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $epSHF.defaultLogoParams).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $epSHF.defaultLogoParams).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $8zwGK.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $dBzF0.default), {
        appearance: appearance,
        label: label,
        svg: $25921040dfc276c5$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("gpFW4", function(module, exports) {
$parcel$export(module.exports, "BitbucketLogo", () => $bf2f82aad785a582$export$bd40525f5333524b);

var $5FkrB = parcelRequire("5FkrB");

var $8zwGK = parcelRequire("8zwGK");

var $epSHF = parcelRequire("epSHF");

var $dBzF0 = parcelRequire("dBzF0");

var $cjKLY = parcelRequire("cjKLY");
var $bf2f82aad785a582$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $cjKLY.getColorsFromAppearance)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" viewBox=\"0 0 158 32\" focusable=\"false\" aria-hidden=\"true\" xmlns=\"http://www.w3.org/2000/svg\">\n        <path fill=".concat(colors.iconColor, " d=\"m20.46 15.152-1.619 9.885c-.105.598-.527.95-1.125.95H3.996c-.599 0-1.02-.352-1.126-.95L.02 7.412c-.105-.598.211-.985.774-.985h20.123c.563 0 .88.387.774.985l-.774 4.644c-.106.668-.493.95-1.126.95H7.69c-.176 0-.281.105-.246.316l.95 5.84c.035.141.14.247.281.247h4.363c.14 0 .246-.106.281-.247l.668-4.221c.07-.528.423-.739.915-.739h4.75c.703 0 .914.352.809.95\"/>\n        <path fill=").concat(colors.textColor, " d=\"M153.212 20.787c0 1.35.797 2.27 2.422 2.27.614 0 1.196-.123 1.656-.215v2.545c-.46.123-.981.245-1.778.245-3.282 0-4.876-1.932-4.876-4.784v-8.187h-2.484v-2.454h2.484v-3.25h2.576v3.25h4.078v2.453h-4.078zm-13.537-8.494c-2.791 0-4.201 1.809-4.477 4.477h8.556c-.154-2.852-1.442-4.477-4.079-4.477m5.888 12.634c-1.257.675-3.189.92-4.753.92-5.735 0-8.25-3.312-8.25-8.004 0-4.63 2.576-7.942 7.238-7.942 4.722 0 6.624 3.281 6.624 7.942v1.196h-11.194c.368 2.607 2.055 4.294 5.674 4.294 1.778 0 3.281-.338 4.661-.828zm-23.82.613h-2.638V3.799h2.638v13.585l6.593-7.176h3.435l-7.207 7.544 7.513 7.79h-3.588l-6.746-7.176zm-5.648-2.76v2.362c-.92.49-2.331.705-3.742.705-5.458 0-8.004-3.312-8.004-8.004 0-4.63 2.546-7.942 8.004-7.942 1.38 0 2.454.184 3.65.736v2.453c-.982-.46-2.024-.736-3.466-.736-3.986 0-5.612 2.515-5.612 5.49s1.656 5.489 5.674 5.489c1.564 0 2.545-.215 3.496-.552m-27.843-3.588v-8.986h2.637v9.262c0 2.76 1.104 3.986 3.619 3.986 2.453 0 4.14-1.625 4.14-4.722v-8.526h2.637v15.334h-2.637v-2.515c-.982 1.81-2.79 2.821-4.846 2.821-3.526 0-5.55-2.422-5.55-6.654m-5.388-1.319c0-3.68-1.472-5.52-4.201-5.52-2.362 0-4.478 1.503-4.478 4.907v1.226c0 3.404 1.932 4.907 4.171 4.907 2.975 0 4.508-1.963 4.508-5.52m-3.803 7.973c-2.238 0-3.956-1.012-4.876-3.005v2.699h-2.637V3.798h2.637v9.17c.982-2.025 2.822-3.067 5.183-3.067 4.079 0 6.133 3.465 6.133 7.973 0 4.324-2.146 7.973-6.44 7.973m-14.974-5.06c0 1.35.797 2.27 2.422 2.27.614 0 1.196-.123 1.656-.215v2.545a6.3 6.3 0 0 1-1.778.245c-3.282 0-4.876-1.932-4.876-4.784v-8.187h-2.484v-2.454h2.484v-3.25h2.576v3.25h4.078v2.453h-4.078zM53.328 6.16c0-1.166.767-1.84 1.84-1.84s1.84.674 1.84 1.84S56.242 8 55.168 8s-1.84-.676-1.84-1.84m.49 19.38V10.207h2.638V25.54zm-9.828-9.046h-6.194v6.287h6.256c2.637 0 3.833-.951 3.833-2.975 0-2.147-1.134-3.312-3.894-3.312m-.889-8.464h-5.305v6.01h5.305c2.607 0 3.68-1.195 3.68-3.127 0-1.963-1.165-2.883-3.68-2.883m-8.065 17.51V5.394h8.433c4.11 0 6.103 2.024 6.103 5.274 0 2.423-1.104 3.926-3.373 4.478 2.974.49 4.446 2.116 4.446 4.968 0 3.22-2.177 5.428-6.685 5.428z\"/>\n      </svg>");
};
var $bf2f82aad785a582$export$bd40525f5333524b = function BitbucketLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Bitbucket' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $epSHF.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $epSHF.defaultLogoParams).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $epSHF.defaultLogoParams).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $8zwGK.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $dBzF0.default), {
        appearance: appearance,
        label: label,
        iconColor: iconColor,
        size: size,
        svg: $bf2f82aad785a582$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("4gFa7", function(module, exports) {
$parcel$export(module.exports, "CompassIcon", () => $31b895fd5ef452db$export$f7857fe64d7161d9);

var $5FkrB = parcelRequire("5FkrB");

var $8zwGK = parcelRequire("8zwGK");

var $epSHF = parcelRequire("epSHF");

var $dBzF0 = parcelRequire("dBzF0");

var $cjKLY = parcelRequire("cjKLY");
var $31b895fd5ef452db$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor;
    var colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $cjKLY.getColorsFromAppearance)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" viewBox=\"0 0 32 32\" focusable=\"false\" aria-hidden=\"true\" xmlns=\"http://www.w3.org/2000/svg\">\n      <path fill=\"".concat(colors.iconColor, "\" d=\"M15.667 15.66v5.942H9.713V15.66zV9.722H4.807c-.58.004-1.047.47-1.043 1.04v15.755a1.04 1.04 0 0 0 1.028 1.054h15.771a1.04 1.04 0 0 0 1.042-1.04V15.66zm0-11.88v5.942h5.967v5.938h5.935V4.82a1.04 1.04 0 0 0-1.028-1.053h-.014z\"/>\n      </svg>\n    ");
};
var $31b895fd5ef452db$export$f7857fe64d7161d9 = function CompassIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Compass' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $epSHF.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $epSHF.defaultLogoParams).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $epSHF.defaultLogoParams).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $8zwGK.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $dBzF0.default), {
        appearance: appearance,
        label: label,
        svg: $31b895fd5ef452db$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("lxChN", function(module, exports) {
$parcel$export(module.exports, "CompassLogo", () => $faea60d6fabbfbac$export$eb7d748e4f9c9676);

var $5FkrB = parcelRequire("5FkrB");

var $8zwGK = parcelRequire("8zwGK");

var $epSHF = parcelRequire("epSHF");

var $dBzF0 = parcelRequire("dBzF0");

var $cjKLY = parcelRequire("cjKLY");
var $faea60d6fabbfbac$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $cjKLY.getColorsFromAppearance)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" viewBox=\"0 0 155 32\" focusable=\"false\" aria-hidden=\"true\" xmlns=\"http://www.w3.org/2000/svg\">\n    <path fill=".concat(colors.iconColor, " d=\"M11.903 14.993v5.942H5.95v-5.942zV9.055H1.043c-.58.004-1.047.47-1.043 1.04v15.756a1.04 1.04 0 0 0 1.028 1.054H16.8a1.04 1.04 0 0 0 1.043-1.04V14.993zm0-11.879v5.941h5.967v5.938h5.936V4.153A1.04 1.04 0 0 0 22.778 3.1h-.015z\"/>\n    <path fill=\"").concat(colors.textColor, "\" d=\"M154.46 21.37c0 2.545-1.656 4.477-5.765 4.477-2.3 0-4.171-.521-5.336-1.134v-2.791c1.318.767 3.526 1.503 5.458 1.503 2.024 0 3.067-.828 3.067-2.024 0-1.166-.889-1.84-3.803-2.546-3.404-.828-4.845-2.146-4.845-4.661 0-2.668 2.055-4.293 5.551-4.293 1.993 0 3.802.49 4.937 1.104v2.729c-1.84-.92-3.343-1.41-4.968-1.41-1.932 0-2.975.674-2.975 1.87 0 1.073.736 1.748 3.558 2.423 3.404.828 5.121 2.085 5.121 4.753m-13.626 0c0 2.545-1.656 4.477-5.766 4.477-2.3 0-4.17-.521-5.336-1.134v-2.791c1.319.767 3.527 1.503 5.459 1.503 2.024 0 3.067-.828 3.067-2.024 0-1.166-.89-1.84-3.803-2.546-3.404-.828-4.845-2.146-4.845-4.661 0-2.668 2.054-4.293 5.55-4.293 1.994 0 3.803.49 4.938 1.104v2.729c-1.84-.92-3.343-1.41-4.968-1.41-1.932 0-2.975.674-2.975 1.87 0 1.073.736 1.748 3.557 2.423 3.404.828 5.122 2.085 5.122 4.753m-25.873-3.496c0 3.68 1.472 5.52 4.201 5.52 2.361 0 4.477-1.503 4.477-4.907v-1.226c0-3.404-1.932-4.907-4.17-4.907-2.975 0-4.508 1.963-4.508 5.52m8.678 7.667v-2.76c-.981 2.024-2.821 3.066-5.182 3.066-4.079 0-6.134-3.465-6.134-7.973 0-4.324 2.147-7.973 6.44-7.973 2.239 0 3.956 1.012 4.876 3.005v-2.699h2.638v15.334zm-16.09-7.667c0-3.68-1.472-5.52-4.201-5.52-2.362 0-4.478 1.503-4.478 4.907v1.226c0 3.404 1.932 4.907 4.171 4.907 2.975 0 4.508-1.963 4.508-5.52m-3.803 7.973c-2.238 0-3.956-1.012-4.876-3.005v8.679h-2.637V10.207h2.637v2.76c.982-2.024 2.822-3.066 5.183-3.066 4.079 0 6.133 3.465 6.133 7.973 0 4.324-2.146 7.973-6.44 7.973m-21.583-8.832v8.526h-2.637v-9.262c0-2.76-1.104-3.986-3.619-3.986-2.453 0-4.14 1.625-4.14 4.722v8.526H69.13V10.207h2.637v2.515c.982-1.81 2.791-2.821 4.846-2.821 2.606 0 4.385 1.318 5.152 3.741.858-2.361 2.913-3.741 5.458-3.741 3.435 0 5.336 2.33 5.336 6.654v8.986h-2.637v-8.526c0-3.158-1.104-4.722-3.619-4.722-2.453 0-4.14 1.625-4.14 4.722m-23.335 8.832c-4.6 0-7.299-3.404-7.299-8.004s2.699-7.942 7.299-7.942c4.57 0 7.237 3.342 7.237 7.942s-2.668 8.004-7.237 8.004m0-13.493c-3.282 0-4.723 2.576-4.723 5.49s1.441 5.55 4.723 5.55c3.25 0 4.661-2.637 4.661-5.55s-1.41-5.49-4.661-5.49m-9.233 9.629v2.668c-1.258.828-3.251 1.196-5.336 1.196-6.624 0-10.366-3.986-10.366-10.334 0-6.134 3.742-10.427 10.304-10.427 1.963 0 3.926.368 5.367 1.41v2.669c-1.441-.92-3.036-1.411-5.367-1.411-4.722 0-7.544 3.128-7.544 7.759s2.914 7.697 7.698 7.697c2.116 0 3.772-.49 5.244-1.227\"/>\n  </svg>");
};
var $faea60d6fabbfbac$export$eb7d748e4f9c9676 = function CompassLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Compass' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $epSHF.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $epSHF.defaultLogoParams).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $epSHF.defaultLogoParams).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $8zwGK.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $dBzF0.default), {
        appearance: appearance,
        label: label,
        iconColor: iconColor,
        size: size,
        svg: $faea60d6fabbfbac$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("gvR58", function(module, exports) {
$parcel$export(module.exports, "ConfluenceLogo", () => $c058b78f804ab151$export$1b2e4fe6ef471556);

var $5FkrB = parcelRequire("5FkrB");

var $8zwGK = parcelRequire("8zwGK");

var $epSHF = parcelRequire("epSHF");

var $dBzF0 = parcelRequire("dBzF0");

var $cjKLY = parcelRequire("cjKLY");
var $c058b78f804ab151$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $cjKLY.getColorsFromAppearance)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" viewBox=\"0 0 180 32\" focusable=\"false\" aria-hidden=\"true\" xmlns=\"http://www.w3.org/2000/svg\">\n      <path fill=\"".concat(colors.iconColor, "\" d=\"M20.602 20.234c-6.584-3.183-8.507-3.66-11.281-3.66-3.255 0-6.03 1.355-8.507 5.16l-.407.622c-.333.513-.407.696-.407.915s.111.403.518.659l4.18 2.598c.221.146.406.22.591.22.222 0 .37-.11.592-.44l.666-1.024c1.035-1.574 1.96-2.086 3.144-2.086 1.035 0 2.256.293 3.772 1.025l4.365 2.049c.444.22.925.11 1.146-.403l2.072-4.537c.222-.512.074-.842-.444-1.098M1.406 12.22c6.583 3.184 8.507 3.66 11.28 3.66 3.256 0 6.03-1.354 8.508-5.16l.407-.622c.332-.512.406-.695.406-.915s-.11-.402-.518-.658L17.31 5.927c-.222-.147-.407-.22-.592-.22-.222 0-.37.11-.592.44l-.665 1.024c-1.036 1.573-1.96 2.086-3.144 2.086-1.036 0-2.257-.293-3.773-1.025L4.18 6.183c-.444-.22-.925-.11-1.147.402L.962 11.123c-.222.512-.074.841.444 1.098\"/>\n      <path fill=\"").concat(colors.textColor, "\" d=\"M172.49 12.293c-2.791 0-4.201 1.809-4.477 4.477h8.556c-.154-2.852-1.442-4.477-4.079-4.477m5.888 12.634c-1.257.675-3.189.92-4.753.92-5.735 0-8.25-3.312-8.25-8.004 0-4.63 2.576-7.942 7.238-7.942 4.722 0 6.624 3.281 6.624 7.942v1.196h-11.194c.368 2.607 2.055 4.294 5.674 4.294 1.778 0 3.281-.338 4.661-.828zm-15.093-2.147v2.362c-.92.49-2.331.705-3.742.705-5.458 0-8.004-3.312-8.004-8.004 0-4.63 2.546-7.942 8.004-7.942 1.38 0 2.454.184 3.65.736v2.453c-.982-.46-2.024-.736-3.466-.736-3.986 0-5.612 2.515-5.612 5.49s1.656 5.489 5.674 5.489c1.564 0 2.545-.215 3.496-.552m-14.503-6.226v8.986h-2.637v-9.262c0-2.76-1.104-3.986-3.619-3.986-2.453 0-4.14 1.625-4.14 4.722v8.526h-2.637V10.207h2.637v2.515c.981-1.81 2.791-2.821 4.845-2.821 3.527 0 5.551 2.422 5.551 6.654m-22.921-4.262c-2.79 0-4.201 1.809-4.477 4.477h8.556c-.154-2.852-1.441-4.477-4.079-4.477m5.888 12.634c-1.257.675-3.189.92-4.753.92-5.735 0-8.249-3.312-8.249-8.004 0-4.63 2.576-7.942 7.237-7.942 4.723 0 6.624 3.281 6.624 7.942v1.196h-11.193c.368 2.607 2.054 4.294 5.673 4.294 1.778 0 3.281-.338 4.661-.828zm-29.1-5.734v-8.986h2.637v9.262c0 2.76 1.104 3.986 3.619 3.986 2.453 0 4.14-1.625 4.14-4.722v-8.526h2.637v15.334h-2.637v-2.515c-.981 1.81-2.791 2.821-4.845 2.821-3.527 0-5.551-2.422-5.551-6.654m-2.231 6.317c-.215.061-.674.122-1.35.122-2.514 0-4.108-1.196-4.108-4.017V3.798h2.637v17.51c0 1.38.92 1.871 2.055 1.871.275 0 .459 0 .766-.03zM88.157 8.582v1.625h3.956v2.454h-3.956v12.88h-2.576V12.66h-2.484v-2.454h2.484V8.521c0-2.852 1.595-4.784 4.876-4.784a6.3 6.3 0 0 1 1.779.245v2.423a8.7 8.7 0 0 0-1.656-.154c-1.626 0-2.423.95-2.423 2.33m-7.327 7.974v8.986h-2.637v-9.262c0-2.76-1.104-3.986-3.619-3.986-2.453 0-4.14 1.625-4.14 4.722v8.526h-2.637V10.207h2.637v2.515c.981-1.81 2.79-2.821 4.845-2.821 3.527 0 5.551 2.422 5.551 6.654m-23.336 9.292c-4.6 0-7.298-3.404-7.298-8.004s2.698-7.942 7.298-7.942c4.57 0 7.238 3.342 7.238 7.942s-2.668 8.004-7.238 8.004m0-13.493c-3.28 0-4.722 2.576-4.722 5.49s1.441 5.55 4.722 5.55c3.251 0 4.662-2.637 4.662-5.55s-1.41-5.49-4.662-5.49m-9.233 9.629v2.668c-1.257.828-3.25 1.196-5.336 1.196-6.624 0-10.365-3.986-10.365-10.334 0-6.134 3.741-10.427 10.304-10.427 1.963 0 3.925.368 5.367 1.41v2.669c-1.442-.92-3.036-1.411-5.367-1.411-4.723 0-7.544 3.128-7.544 7.759s2.913 7.697 7.697 7.697c2.116 0 3.772-.49 5.244-1.227\"/>\n    </svg>\n    ");
};
var $c058b78f804ab151$export$1b2e4fe6ef471556 = function ConfluenceLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Confluence' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $epSHF.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $epSHF.defaultLogoParams).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $epSHF.defaultLogoParams).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $8zwGK.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $dBzF0.default), {
        appearance: appearance,
        label: label,
        iconColor: iconColor,
        size: size,
        svg: $c058b78f804ab151$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("kzQer", function(module, exports) {
$parcel$export(module.exports, "FocusIcon", () => $efaf97afdcb7a75d$export$1e02e7298035a77c);

var $5FkrB = parcelRequire("5FkrB");

var $8zwGK = parcelRequire("8zwGK");

var $epSHF = parcelRequire("epSHF");

var $dBzF0 = parcelRequire("dBzF0");

var $cjKLY = parcelRequire("cjKLY");
var $efaf97afdcb7a75d$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor;
    var colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $cjKLY.getColorsFromAppearance)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" viewBox=\"0 0 48 48\" focusable=\"false\" aria-hidden=\"true\" xmlns=\"http://www.w3.org/2000/svg\">\n\t\t<path fill=\"".concat(colors.iconColor, "\" d=\"M45.4277 24.5018C41.4108 20.4849 34.8821 20.5276 30.908 24.5018L27.5636 27.8462C25.717 29.6927 22.7177 29.6927 20.8712 27.8462L18.0925 25.0675L10.8309 32.3291L13.6096 35.1078C19.4658 40.9641 28.9654 40.9641 34.8216 35.1078L45.4277 24.5018ZM3 23.5018C7.01684 27.5186 13.4637 27.5578 17.4805 23.5409L20.8676 20.1538C22.7142 18.3073 25.7135 18.3073 27.56 20.1538L30.3387 22.9325L37.6003 15.6709L34.8216 12.8922C28.9654 7.03593 19.4658 7.03593 13.6096 12.8922L3.00356 23.4982L3 23.5018Z\"/>\n\t\t</svg>\n\t\t");
};
var $efaf97afdcb7a75d$export$1e02e7298035a77c = function FocusIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Focus' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $epSHF.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $epSHF.defaultLogoParams).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $epSHF.defaultLogoParams).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $8zwGK.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $dBzF0.default), {
        appearance: appearance,
        label: label,
        svg: $efaf97afdcb7a75d$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("eiyYh", function(module, exports) {
$parcel$export(module.exports, "FocusLogo", () => $a68ddfab47427e0d$export$33908560ea1b226d);

var $5FkrB = parcelRequire("5FkrB");

var $8zwGK = parcelRequire("8zwGK");

var $epSHF = parcelRequire("epSHF");

var $dBzF0 = parcelRequire("dBzF0");

var $cjKLY = parcelRequire("cjKLY");
var $a68ddfab47427e0d$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $cjKLY.getColorsFromAppearance)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" viewBox=\"0 0 168 48\" focusable=\"false\" aria-hidden=\"true\" xmlns=\"http://www.w3.org/2000/svg\">\n\t\t<path fill=\"".concat(colors.iconColor, "\" d=\"M42.4277 24.5018C38.4108 20.4849 31.8821 20.5276 27.908 24.5018L24.5636 27.8462C22.717 29.6927 19.7177 29.6927 17.8712 27.8462L15.0925 25.0675L7.83088 32.3291L10.6096 35.1078C16.4658 40.9641 25.9654 40.9641 31.8216 35.1078L42.4277 24.5018ZM0 23.5018C4.01684 27.5186 10.4637 27.5578 14.4805 23.5409L17.8676 20.1538C19.7142 18.3073 22.7135 18.3073 24.56 20.1538L27.3387 22.9325L34.6003 15.6709L31.8216 12.8922C25.9654 7.03593 16.4658 7.03593 10.6096 12.8922L0.00355592 23.4982L0 23.5018Z\"/>\n\t\t<path fill=\"").concat(colors.textColor, "\" d=\"M167.405 31.746C167.405 35.564 164.921 38.462 158.757 38.462C155.307 38.462 152.501 37.68 150.753 36.76V32.574C152.731 33.724 156.043 34.828 158.941 34.828C161.977 34.828 163.541 33.586 163.541 31.792C163.541 30.044 162.207 29.032 157.837 27.974C152.731 26.732 150.569 24.754 150.569 20.982C150.569 16.98 153.651 14.542 158.895 14.542C161.885 14.542 164.599 15.278 166.301 16.198V20.292C163.541 18.912 161.287 18.176 158.849 18.176C155.951 18.176 154.387 19.188 154.387 20.982C154.387 22.592 155.491 23.604 159.723 24.616C164.829 25.858 167.405 27.744 167.405 31.746Z\"/>\n\t\t<path fill=\"").concat(colors.textColor, "\" d=\"M126.009 28.48V15.002H129.965V28.894C129.965 33.034 131.621 34.874 135.393 34.874C139.073 34.874 141.603 32.436 141.603 27.79V15.002H145.559V38.002H141.603V34.23C140.131 36.944 137.417 38.462 134.335 38.462C129.045 38.462 126.009 34.828 126.009 28.48Z\"/>\n\t\t<path fill=\"").concat(colors.textColor, "\" d=\"M121.953 33.862V37.404C120.573 38.14 118.457 38.462 116.341 38.462C108.153 38.462 104.335 33.494 104.335 26.456C104.335 19.51 108.153 14.542 116.341 14.542C118.411 14.542 120.021 14.818 121.815 15.646V19.326C120.343 18.636 118.779 18.222 116.617 18.222C110.637 18.222 108.199 21.994 108.199 26.456C108.199 30.918 110.683 34.69 116.709 34.69C119.055 34.69 120.527 34.368 121.953 33.862Z\"/>\n\t\t<path fill=\"").concat(colors.textColor, "\" d=\"M90.2616 38.462C83.3616 38.462 79.3136 33.356 79.3136 26.456C79.3136 19.556 83.3616 14.542 90.2616 14.542C97.1156 14.542 101.118 19.556 101.118 26.456C101.118 33.356 97.1156 38.462 90.2616 38.462ZM90.2616 18.222C85.3396 18.222 83.1776 22.086 83.1776 26.456C83.1776 30.826 85.3396 34.782 90.2616 34.782C95.1376 34.782 97.2536 30.826 97.2536 26.456C97.2536 22.086 95.1376 18.222 90.2616 18.222Z\"/>\n\t\t<path fill=\"").concat(colors.textColor, "\" d=\"M75.298 26.732H61.59V38.002H57.45V7.78003H76.862V11.736H61.59V22.776H75.298V26.732Z\"/>\n\t\t</svg>\n\t\t");
};
var $a68ddfab47427e0d$export$33908560ea1b226d = function FocusLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Focus' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $epSHF.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $epSHF.defaultLogoParams).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $epSHF.defaultLogoParams).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $8zwGK.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $dBzF0.default), {
        appearance: appearance,
        label: label,
        iconColor: iconColor,
        size: size,
        svg: $a68ddfab47427e0d$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("MIVBE", function(module, exports) {
$parcel$export(module.exports, "GuardIcon", () => $09275599d3771b74$export$3f95fcfdc25a741d);

var $5FkrB = parcelRequire("5FkrB");

var $8zwGK = parcelRequire("8zwGK");

var $epSHF = parcelRequire("epSHF");

var $dBzF0 = parcelRequire("dBzF0");

var $cjKLY = parcelRequire("cjKLY");
var $09275599d3771b74$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor;
    var colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $cjKLY.getColorsFromAppearance)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" focusable=\"false\" aria-hidden=\"true\">\n      <path\n        d=\"M5.584 14.4h20.83c.599 0 .918-.32.918-.918V6.459c0-.599-.319-.918-.918-.918h-4.39c-.598 0-.917.32-.917.918v3.551h-1.995V6.46c0-.599-.32-.918-.918-.918h-4.39c-.598 0-.917.32-.917.918v3.551h-1.995V6.46c0-.599-.32-.918-.918-.918h-4.39c-.598 0-.917.32-.917.918v7.023c0 .599.319.918.917.918zm.36 6.145a13.9 13.9 0 0 1-.798-3.99c-.04-.52.199-.799.758-.799h20.191c.559 0 .798.24.798.719q-.12 2.214-.838 4.07c-.24.638-.598.918-1.277.918H7.221c-.679 0-1.038-.28-1.277-.918m18.475 3.312c-1.915 2.354-5.068 3.87-8.42 3.87s-6.584-1.516-8.46-3.87c-.478-.638-.239-1.038.24-1.038h16.44c.48 0 .719.4.2 1.038\"\n        fill=\"".concat(colors.iconColor, "\"\n      />\n    </svg>");
};
var $09275599d3771b74$export$3f95fcfdc25a741d = function GuardIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Guard' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $epSHF.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $epSHF.defaultLogoParams).textColor : _ref2$textColor, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $epSHF.defaultLogoParams).iconColor : _ref2$iconColor;
    var _useThemeObserver = (0, $8zwGK.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $dBzF0.default), {
        appearance: appearance,
        svg: $09275599d3771b74$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        label: label,
        size: size,
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("7jJm4", function(module, exports) {
$parcel$export(module.exports, "GuardLogo", () => $553d7d48c46a0010$export$a4a891d202775deb);

var $5FkrB = parcelRequire("5FkrB");

var $8zwGK = parcelRequire("8zwGK");

var $epSHF = parcelRequire("epSHF");

var $dBzF0 = parcelRequire("dBzF0");

var $cjKLY = parcelRequire("cjKLY");
var $553d7d48c46a0010$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $cjKLY.getColorsFromAppearance)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 114 32\" focusable=\"false\" aria-hidden=\"true\">\n      <path\n        d=\"M.918 13.733h20.83c.598 0 .918-.32.918-.918V5.792c0-.599-.32-.918-.918-.918h-4.39c-.598 0-.918.32-.918.918v3.551h-1.995V5.792c0-.599-.319-.918-.918-.918H9.139c-.599 0-.918.32-.918.918v3.551H6.225V5.792c0-.599-.32-.918-.918-.918H.917c-.598 0-.917.32-.917.918v7.023c0 .599.32.918.918.918m.359 6.145a13.9 13.9 0 0 1-.798-3.99c-.04-.52.2-.799.758-.799h20.191c.56 0 .799.24.799.719q-.12 2.214-.838 4.07c-.24.638-.599.918-1.277.918H2.554c-.679 0-1.038-.28-1.277-.918m18.476 3.312c-1.916 2.354-5.068 3.87-8.42 3.87s-6.584-1.516-8.46-3.87c-.479-.638-.24-1.038.24-1.038h16.44c.479 0 .718.4.2 1.038\"\n        fill=\"".concat(colors.iconColor, "\"\n      />\n      <path\n        d=\"M102.398 17.874c0 3.68 1.472 5.52 4.202 5.52 2.361 0 4.477-1.502 4.477-4.906V17.26c0-3.404-1.932-4.907-4.171-4.907-2.974 0-4.508 1.963-4.508 5.52zm8.679 7.667v-2.76c-.982 2.024-2.822 3.067-5.183 3.067-4.079 0-6.133-3.466-6.133-7.974 0-4.324 2.146-7.973 6.44-7.973 2.238 0 3.956 1.012 4.876 3.005V3.798h2.637v21.743zm-17.793-9.047v9.047h-2.576V10.208h2.576v2.698c.89-1.809 2.423-3.097 5.428-2.913v2.576c-3.373-.337-5.428.675-5.428 3.925m-17.869 1.381c0 3.68 1.472 5.52 4.201 5.52 2.362 0 4.478-1.503 4.478-4.907v-1.227c0-3.404-1.932-4.906-4.17-4.906-2.976 0-4.509 1.962-4.509 5.52m8.679 7.666v-2.76c-.982 2.024-2.822 3.067-5.183 3.067-4.079 0-6.133-3.465-6.133-7.973 0-4.324 2.146-7.974 6.44-7.974 2.238 0 3.956 1.012 4.876 3.006v-2.699h2.637v15.333zM56.68 19.193v-8.985h2.637v9.261c0 2.76 1.105 3.987 3.62 3.987 2.453 0 4.14-1.625 4.14-4.723v-8.525h2.637v15.333h-2.638v-2.514c-.981 1.809-2.79 2.821-4.845 2.821-3.527 0-5.55-2.423-5.55-6.655zm-3.973 5.213c-1.595.951-4.539 1.442-6.808 1.442-6.931 0-10.672-4.232-10.672-10.335 0-6.563 4.262-10.457 11.438-10.457 1.595 0 3.466.184 5.244.797v2.76c-1.533-.613-3.342-.89-5.213-.89-5.98 0-8.71 2.975-8.71 7.729 0 4.661 2.76 7.758 8.557 7.758.95 0 2.269-.092 3.404-.429v-5.612h-5.152v-2.637h7.912z\"\n        fill=\"").concat(colors.textColor, "\"\n      />\n    </svg>");
};
var $553d7d48c46a0010$export$a4a891d202775deb = function GuardLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Guard' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $epSHF.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $epSHF.defaultLogoParams).textColor : _ref2$textColor, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $epSHF.defaultLogoParams).iconColor : _ref2$iconColor;
    var _useThemeObserver = (0, $8zwGK.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $dBzF0.default), {
        appearance: appearance,
        iconColor: iconColor,
        label: label,
        size: size,
        svg: $553d7d48c46a0010$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("b80fJ", function(module, exports) {
$parcel$export(module.exports, "JiraIcon", () => $81a0a33aea386cf3$export$c4b5b1f965d8b3eb);

var $5FkrB = parcelRequire("5FkrB");

var $8zwGK = parcelRequire("8zwGK");

var $epSHF = parcelRequire("epSHF");

var $dBzF0 = parcelRequire("dBzF0");

var $cjKLY = parcelRequire("cjKLY");
var $81a0a33aea386cf3$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor;
    var colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $cjKLY.getColorsFromAppearance)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" viewBox=\"0 0 32 32\" focusable=\"false\" aria-hidden=\"true\" xmlns=\"http://www.w3.org/2000/svg\">\n      <path fill=\"".concat(colors.iconColor, "\" d=\"M11.034 21.99h-2.22c-3.346 0-5.747-2.05-5.747-5.052h11.932c.619 0 1.019.44 1.019 1.062v12.007c-2.983 0-4.984-2.416-4.984-5.784zm5.893-5.967h-2.219c-3.347 0-5.748-2.013-5.748-5.015h11.933c.618 0 1.055.402 1.055 1.025V24.04c-2.983 0-5.02-2.416-5.02-5.784zm5.93-5.93h-2.219c-3.347 0-5.748-2.05-5.748-5.052h11.933c.618 0 1.018.439 1.018 1.025v12.007c-2.983 0-4.984-2.416-4.984-5.784z\"/>\n    </svg>");
};
var $81a0a33aea386cf3$export$c4b5b1f965d8b3eb = function JiraIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Jira' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $epSHF.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $epSHF.defaultLogoParams).textColor : _ref2$textColor, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $epSHF.defaultLogoParams).iconColor : _ref2$iconColor;
    var _useThemeObserver = (0, $8zwGK.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $dBzF0.default), {
        appearance: appearance,
        label: label,
        svg: $81a0a33aea386cf3$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("dfI4K", function(module, exports) {
$parcel$export(module.exports, "JiraLogo", () => $9a5edd9167b50d6f$export$17d3acb0b4379d02);

var $5FkrB = parcelRequire("5FkrB");

var $8zwGK = parcelRequire("8zwGK");

var $epSHF = parcelRequire("epSHF");

var $dBzF0 = parcelRequire("dBzF0");

var $cjKLY = parcelRequire("cjKLY");
var $9a5edd9167b50d6f$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $cjKLY.getColorsFromAppearance)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" viewBox=\"0 0 77 32\" focusable=\"false\" aria-hidden=\"true\" xmlns=\"http://www.w3.org/2000/svg\">\n      <path fill=\"".concat(colors.iconColor, "\" d=\"M7.967 21.323H5.748C2.401 21.323 0 19.273 0 16.271h11.933c.618 0 1.018.44 1.018 1.062V29.34c-2.983 0-4.984-2.416-4.984-5.784zm5.894-5.967h-2.22c-3.346 0-5.747-2.013-5.747-5.015h11.932c.618 0 1.055.402 1.055 1.025v12.007c-2.983 0-5.02-2.416-5.02-5.784zm5.93-5.93h-2.22c-3.347 0-5.748-2.05-5.748-5.052h11.933c.618 0 1.019.439 1.019 1.025v12.007c-2.983 0-4.984-2.416-4.984-5.784z\"/>\n      <path fill=\"").concat(colors.textColor, "\" d=\"M65.023 17.874c0 3.68 1.472 5.52 4.202 5.52 2.36 0 4.477-1.503 4.477-4.907V17.26c0-3.404-1.932-4.906-4.17-4.906-2.975 0-4.509 1.962-4.509 5.52m8.679 7.666v-2.76c-.981 2.024-2.821 3.067-5.183 3.067-4.078 0-6.133-3.465-6.133-7.973 0-4.324 2.147-7.974 6.44-7.974 2.239 0 3.956 1.012 4.876 3.006v-2.699h2.637V25.54zM55.91 16.493v9.047h-2.577V10.207h2.576v2.698c.89-1.809 2.423-3.097 5.428-2.913v2.576c-3.373-.337-5.428.675-5.428 3.925M46.224 6.159c0-1.165.767-1.84 1.84-1.84s1.84.675 1.84 1.84-.767 1.84-1.84 1.84-1.84-.675-1.84-1.84m.49 19.381V10.207h2.638V25.54zm-6.427-5.95V5.393h2.76v14.015c0 3.71-1.626 6.256-5.428 6.256-1.442 0-2.546-.246-3.312-.522v-2.668c.828.338 1.84.522 2.852.522 2.33 0 3.128-1.41 3.128-3.404\"/>\n    </svg>");
};
var $9a5edd9167b50d6f$export$17d3acb0b4379d02 = function JiraLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Jira' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $epSHF.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $epSHF.defaultLogoParams).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $epSHF.defaultLogoParams).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $8zwGK.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $dBzF0.default), {
        appearance: appearance,
        label: label,
        iconColor: iconColor,
        size: size,
        svg: $9a5edd9167b50d6f$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("4cFVz", function(module, exports) {
$parcel$export(module.exports, "JiraAlignIcon", () => $30f8ce5cde342f63$export$407687b2dd89cc68);

var $5FkrB = parcelRequire("5FkrB");

var $8zwGK = parcelRequire("8zwGK");

var $epSHF = parcelRequire("epSHF");

var $dBzF0 = parcelRequire("dBzF0");

var $cjKLY = parcelRequire("cjKLY");
var $30f8ce5cde342f63$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor;
    var colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $cjKLY.getColorsFromAppearance)(appearance, colorMode);
    return "<svg viewBox=\"0 0 32 32\" focusable=\"false\" aria-hidden=\"true\" height=\"32\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n    <path\n      fill=\"".concat(colors.iconColor, "\"\n      d=\"M25.52 25.727c0-3.604-2.949-6.517-6.517-6.517h-6.007v-5.497H6.48v10.813c0 .837.364 1.201 1.201 1.201zM6.48 6.687c0 3.604 2.876 6.517 6.48 6.517h6.043V18.7h6.517V7.888q0-1.2-1.201-1.201z\"\n    />\n  </svg>");
};
var $30f8ce5cde342f63$export$407687b2dd89cc68 = function JiraAlignIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Jira Align' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $epSHF.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $epSHF.defaultLogoParams).textColor : _ref2$textColor, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $epSHF.defaultLogoParams).iconColor : _ref2$iconColor;
    var _useThemeObserver = (0, $8zwGK.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $dBzF0.default), {
        appearance: appearance,
        label: label,
        svg: $30f8ce5cde342f63$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("7VYCY", function(module, exports) {
$parcel$export(module.exports, "JiraAlignLogo", () => $5c6ce2accd6a8463$export$ee11e928d3d045fd);

var $5FkrB = parcelRequire("5FkrB");

var $8zwGK = parcelRequire("8zwGK");

var $epSHF = parcelRequire("epSHF");

var $dBzF0 = parcelRequire("dBzF0");

var $cjKLY = parcelRequire("cjKLY");
var $5c6ce2accd6a8463$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $cjKLY.getColorsFromAppearance)(appearance, colorMode);
    return "<svg viewBox=\"0 0 146 32\" focusable=\"false\" aria-hidden=\"true\" height=\"32\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n      <path d=\"M19.04 25.727c0-3.604-2.949-6.517-6.517-6.517H6.517v-5.497H0v10.813c0 .837.364 1.201 1.201 1.201zM0 6.687c0 3.604 2.876 6.517 6.48 6.517h6.043V18.7h6.517V7.888q0-1.2-1.201-1.201z\" fill=\"".concat(colors.iconColor, "\"/>\n      <path d=\"M144.993 16.555v8.985h-2.638v-9.26c0-2.76-1.104-3.988-3.618-3.988-2.454 0-4.14 1.626-4.14 4.723v8.525h-2.638V10.207h2.638v2.515c.981-1.81 2.79-2.822 4.845-2.822 3.527 0 5.551 2.423 5.551 6.655m-19.589 7.759V22.78c-.982 2.024-2.822 3.067-5.183 3.067-4.048 0-6.072-3.465-6.072-7.973 0-4.324 2.116-7.974 6.379-7.974 2.238 0 3.956 1.012 4.876 3.006v-2.699h2.576V24.16c0 4.508-2.116 7.544-7.606 7.544-2.576 0-3.986-.337-5.458-.828V28.3c1.686.552 3.434.92 5.336.92 3.833 0 5.152-2.054 5.152-4.906m-8.679-6.44c0 3.68 1.472 5.52 4.201 5.52 2.362 0 4.478-1.503 4.478-4.907V17.26c0-3.404-1.932-4.906-4.171-4.906-2.975 0-4.508 1.962-4.508 5.52M107.96 6.16c0-1.166.766-1.84 1.84-1.84 1.073 0 1.84.674 1.84 1.84S110.873 8 109.8 8c-1.074 0-1.84-.675-1.84-1.84m.49 19.38V10.208h2.638v15.334h-2.638Zm-2.537-.03c-.215.061-.675.122-1.349.122-2.515 0-4.11-1.196-4.11-4.017V3.798h2.638v17.51c0 1.38.92 1.871 2.054 1.871.276 0 .46 0 .767-.03v2.36ZM88.83 21.523c-1.534 0-3.098-.184-4.815-.521l-1.687 4.539h-3.097l7.942-20.148h3.496l7.943 20.148h-3.097l-1.687-4.57c-1.81.368-3.373.552-4.999.552Zm0-2.453c1.287 0 2.606-.153 4.17-.399l-4.079-11.04-4.078 11.07c1.502.246 2.76.369 3.986.369Zm-27.807-1.196c0 3.68 1.472 5.52 4.202 5.52 2.36 0 4.477-1.503 4.477-4.907V17.26c0-3.404-1.932-4.906-4.17-4.906-2.975 0-4.509 1.962-4.509 5.52m8.679 7.666v-2.76c-.981 2.024-2.822 3.067-5.183 3.067-4.079 0-6.133-3.465-6.133-7.973 0-4.324 2.146-7.974 6.44-7.974 2.239 0 3.956 1.012 4.876 3.006v-2.699h2.637V25.54zM51.91 16.494v9.047h-2.577V10.207h2.576v2.699c.89-1.81 2.423-3.097 5.428-2.913v2.576c-3.373-.338-5.428.674-5.428 3.925ZM42.224 6.16c0-1.166.767-1.84 1.84-1.84s1.84.674 1.84 1.84S45.137 8 44.064 8s-1.84-.675-1.84-1.84m.49 19.38V10.208h2.638v15.334h-2.637Zm-6.427-5.949V5.393h2.76v14.014c0 3.71-1.626 6.256-5.428 6.256-1.442 0-2.546-.245-3.312-.521v-2.668c.828.337 1.84.521 2.852.521 2.33 0 3.128-1.41 3.128-3.404\" fill=\"").concat(colors.textColor, "\"/>\n    </svg>\n  ");
};
var $5c6ce2accd6a8463$export$ee11e928d3d045fd = function JiraAlignLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Jira Align' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $epSHF.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $epSHF.defaultLogoParams).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $epSHF.defaultLogoParams).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $8zwGK.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $dBzF0.default), {
        appearance: appearance,
        label: label,
        iconColor: iconColor,
        size: size,
        svg: $5c6ce2accd6a8463$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("d5SeO", function(module, exports) {
$parcel$export(module.exports, "JiraProductDiscoveryIcon", () => $9885d07eef3ec5c7$export$21bfbeb62fdcce8d);

var $5FkrB = parcelRequire("5FkrB");

var $8zwGK = parcelRequire("8zwGK");

var $epSHF = parcelRequire("epSHF");

var $dBzF0 = parcelRequire("dBzF0");

var $cjKLY = parcelRequire("cjKLY");
var $9885d07eef3ec5c7$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor;
    var colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $cjKLY.getColorsFromAppearance)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" viewBox=\"0 0 32 32\" focusable=\"false\" aria-hidden=\"true\" xmlns=\"http://www.w3.org/2000/svg\">\n      <path fill=\"".concat(colors.iconColor, "\" d=\"M17.655 5.884a15.3 15.3 0 0 0 8.75 0c.257-.056.428.114.37.37-.826 2.985-.826 5.742 0 8.727.058.228-.113.427-.37.342a16.33 16.33 0 0 0-8.75 0c-.228.085-.428-.114-.342-.342.77-2.985.77-5.742 0-8.727-.086-.256.114-.426.342-.37m1.169 10.576v.483c0 2.246-1.568 3.894-3.506 3.894a3.474 3.474 0 0 1-3.477-3.496c0-1.933 1.567-3.468 3.762-3.468h.57V7.078c-.285-.028-.57-.028-.855-.028C9.618 7.05 5 11.655 5 17.37c0 5.713 4.617 10.29 10.318 10.29s10.346-4.605 10.346-10.29v-.91z\"/>\n    </svg>");
};
var $9885d07eef3ec5c7$export$21bfbeb62fdcce8d = function JiraProductDiscoveryIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Jira Product Discovery' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $epSHF.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $epSHF.defaultLogoParams).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $epSHF.defaultLogoParams).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $8zwGK.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $dBzF0.default), {
        appearance: appearance,
        label: label,
        svg: $9885d07eef3ec5c7$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("9kAuE", function(module, exports) {
$parcel$export(module.exports, "JiraProductDiscoveryLogo", () => $6cb24a277283e583$export$c49a2b642fe9eef4);

var $5FkrB = parcelRequire("5FkrB");

var $8zwGK = parcelRequire("8zwGK");

var $epSHF = parcelRequire("epSHF");

var $dBzF0 = parcelRequire("dBzF0");

var $cjKLY = parcelRequire("cjKLY");
var $6cb24a277283e583$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $cjKLY.getColorsFromAppearance)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" viewBox=\"0 0 318 32\" focusable=\"false\" aria-hidden=\"true\" xmlns=\"http://www.w3.org/2000/svg\">\n      <path fill=\"".concat(colors.iconColor, "\" d=\"M12.655 5.218a15.3 15.3 0 0 0 8.75 0c.257-.057.428.114.37.37-.826 2.984-.826 5.742 0 8.727.058.227-.113.426-.37.341a16.33 16.33 0 0 0-8.75 0c-.228.085-.428-.114-.342-.341.77-2.985.77-5.743 0-8.727-.086-.256.114-.427.342-.37m1.169 10.575v.483c0 2.246-1.568 3.895-3.506 3.895a3.474 3.474 0 0 1-3.478-3.497c0-1.933 1.568-3.468 3.763-3.468h.57V6.412c-.285-.028-.57-.028-.855-.028C4.618 6.384 0 10.989 0 16.703s4.617 10.29 10.318 10.29 10.346-4.605 10.346-10.29v-.91z\" />\n      <path fill=\"").concat(colors.textColor, "\" d=\"M308.551 24.559h-1.718l-5.55-14.352h2.821l4.907 13.125 4.906-13.125h2.822l-5.796 14.843c-1.718 4.385-2.699 6.654-6.594 6.654-1.318 0-2.054-.122-2.821-.429v-2.27c.889.277 1.901.369 2.668.369 2.147 0 3.097-1.472 4.355-4.815m-13.247-8.065v9.047h-2.576V10.207h2.576v2.699c.889-1.81 2.422-3.097 5.428-2.913v2.576c-3.374-.338-5.428.674-5.428 3.925m-12.464-4.202c-2.79 0-4.201 1.81-4.477 4.478h8.556c-.153-2.852-1.441-4.478-4.079-4.478m5.888 12.635c-1.257.675-3.189.92-4.753.92-5.735 0-8.249-3.312-8.249-8.004 0-4.63 2.576-7.943 7.237-7.943 4.723 0 6.624 3.282 6.624 7.943v1.196h-11.193c.368 2.607 2.054 4.293 5.673 4.293 1.779 0 3.281-.337 4.661-.828zm-19.717.613h-3.527l-5.949-15.333h2.76l4.968 13.095 4.937-13.095h2.76zm-17.462.307c-4.6 0-7.299-3.404-7.299-8.004s2.699-7.943 7.299-7.943c4.569 0 7.237 3.343 7.237 7.943s-2.668 8.004-7.237 8.004m0-13.493c-3.281 0-4.723 2.576-4.723 5.49 0 2.912 1.442 5.55 4.723 5.55 3.251 0 4.661-2.638 4.661-5.55 0-2.914-1.41-5.49-4.661-5.49M242.16 22.78v2.362c-.92.49-2.331.705-3.742.705-5.458 0-8.004-3.312-8.004-8.004 0-4.63 2.546-7.943 8.004-7.943 1.38 0 2.454.184 3.65.736v2.454c-.982-.46-2.024-.736-3.466-.736-3.986 0-5.612 2.514-5.612 5.49 0 2.974 1.656 5.488 5.674 5.488 1.564 0 2.545-.214 3.496-.552m-13.872-1.41c0 2.545-1.656 4.477-5.765 4.477-2.3 0-4.171-.521-5.336-1.135v-2.79c1.319.766 3.527 1.502 5.459 1.502 2.024 0 3.066-.828 3.066-2.024 0-1.165-.889-1.84-3.802-2.545-3.404-.828-4.846-2.147-4.846-4.661 0-2.668 2.055-4.294 5.551-4.294 1.993 0 3.803.491 4.937 1.104v2.73c-1.84-.92-3.342-1.41-4.968-1.41-1.932 0-2.974.674-2.974 1.87 0 1.073.736 1.748 3.557 2.422 3.404.828 5.121 2.086 5.121 4.754M210.599 6.16c0-1.166.767-1.84 1.84-1.84s1.84.674 1.84 1.84-.767 1.84-1.84 1.84-1.84-.675-1.84-1.84m.491 19.38V10.208h2.637v15.334zM198.344 8.03h-4.539v14.873h4.692c4.6 0 6.9-2.422 6.9-7.298 0-4.907-2.177-7.575-7.053-7.575m-7.299 17.51V5.394h7.422c6.532 0 9.69 4.078 9.69 10.12 0 6.102-3.189 10.028-9.69 10.028zm-13.411-4.753c0 1.35.797 2.27 2.422 2.27.614 0 1.196-.123 1.656-.215v2.545c-.46.123-.981.245-1.778.245-3.282 0-4.876-1.932-4.876-4.784v-8.187h-2.484v-2.454h2.484v-3.25h2.576v3.25h4.078v2.453h-4.078zm-6.66 1.993v2.362c-.92.49-2.331.705-3.742.705-5.458 0-8.004-3.312-8.004-8.004 0-4.63 2.546-7.943 8.004-7.943 1.38 0 2.454.184 3.65.736v2.454c-.982-.46-2.024-.736-3.466-.736-3.986 0-5.612 2.514-5.612 5.49 0 2.974 1.656 5.488 5.674 5.488 1.564 0 2.545-.214 3.496-.552m-27.843-3.588v-8.985h2.637v9.261c0 2.76 1.104 3.987 3.619 3.987 2.453 0 4.14-1.625 4.14-4.723v-8.525h2.637V25.54h-2.637v-2.514c-.982 1.809-2.791 2.821-4.846 2.821-3.526 0-5.55-2.423-5.55-6.655m-14.987-1.318c0 3.68 1.472 5.52 4.202 5.52 2.361 0 4.477-1.503 4.477-4.907V17.26c0-3.404-1.932-4.906-4.171-4.906-2.974 0-4.508 1.962-4.508 5.52m8.679 7.667v-2.76c-.981 2.023-2.821 3.066-5.183 3.066-4.078 0-6.133-3.465-6.133-7.973 0-4.324 2.147-7.973 6.44-7.973 2.239 0 3.956 1.012 4.876 3.005V3.798h2.637V25.54zm-20.698.306c-4.6 0-7.299-3.404-7.299-8.004s2.699-7.943 7.299-7.943c4.569 0 7.237 3.343 7.237 7.943s-2.668 8.004-7.237 8.004m0-13.493c-3.282 0-4.723 2.576-4.723 5.49 0 2.912 1.441 5.55 4.723 5.55 3.25 0 4.661-2.638 4.661-5.55 0-2.914-1.411-5.49-4.661-5.49m-13.776 4.14v9.047h-2.576V10.207h2.576v2.699c.89-1.81 2.423-3.097 5.428-2.913v2.576c-3.373-.338-5.428.674-5.428 3.925m-5.002-4.385c0 4.385-2.454 6.838-7.483 6.838h-4.017v6.594h-2.76V5.393h6.777c5.03 0 7.483 2.576 7.483 6.716m-7.79 4.2c3.558.124 4.938-1.563 4.938-4.14 0-2.452-1.38-4.14-4.938-4.14h-3.71v8.28zM61.69 17.874c0 3.68 1.472 5.52 4.201 5.52 2.361 0 4.477-1.503 4.477-4.907V17.26c0-3.404-1.931-4.906-4.17-4.906-2.975 0-4.508 1.962-4.508 5.52m8.679 7.666v-2.76c-.982 2.024-2.822 3.067-5.183 3.067-4.079 0-6.134-3.465-6.134-7.973 0-4.324 2.147-7.974 6.44-7.974 2.24 0 3.957 1.012 4.877 3.006v-2.699h2.637V25.54zm-17.793-9.046v9.047H50V10.207h2.576v2.699c.89-1.81 2.423-3.097 5.428-2.913v2.576c-3.373-.338-5.428.674-5.428 3.925M42.89 6.16c0-1.166.767-1.84 1.84-1.84s1.84.674 1.84 1.84S45.805 8 44.73 8s-1.84-.675-1.84-1.84m.491 19.38V10.208h2.638v15.334zm-6.428-5.949V5.393h2.76v14.014c0 3.71-1.625 6.256-5.428 6.256-1.441 0-2.545-.245-3.312-.521v-2.668c.828.337 1.84.521 2.852.521 2.331 0 3.128-1.41 3.128-3.404\" />\n    </svg>");
};
var $6cb24a277283e583$export$c49a2b642fe9eef4 = function JiraProductDiscoveryLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Jira Product Discovery' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $epSHF.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $epSHF.defaultLogoParams).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $epSHF.defaultLogoParams).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $8zwGK.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $dBzF0.default), {
        appearance: appearance,
        label: label,
        iconColor: iconColor,
        size: size,
        svg: $6cb24a277283e583$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("ggWcZ", function(module, exports) {
$parcel$export(module.exports, "JiraServiceManagementIcon", () => $bd8b4af169de6e27$export$3c6158790f5e01c4);

var $5FkrB = parcelRequire("5FkrB");

var $8zwGK = parcelRequire("8zwGK");

var $epSHF = parcelRequire("epSHF");

var $dBzF0 = parcelRequire("dBzF0");

var $cjKLY = parcelRequire("cjKLY");
var $bd8b4af169de6e27$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor;
    var colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $cjKLY.getColorsFromAppearance)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" viewBox=\"0 0 32 32\" focusable=\"false\" aria-hidden=\"true\" xmlns=\"http://www.w3.org/2000/svg\">\n      <path fill=".concat(colors.iconColor, " d=\"M18.79 13.257h7.325c1.1 0 1.476 1.046.805 1.878L15.464 29.274c-3.702-2.951-3.353-7.62-.644-11.027zm-5.66 5.634H5.806c-1.1 0-1.476-1.046-.805-1.878L16.457 2.874c3.702 2.951 3.3 7.566.617 11z\"/>\n    </svg>");
};
var $bd8b4af169de6e27$export$3c6158790f5e01c4 = function JiraServiceManagementIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Jira Service Management' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $epSHF.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $epSHF.defaultLogoParams).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $epSHF.defaultLogoParams).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $8zwGK.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $dBzF0.default), {
        appearance: appearance,
        label: label,
        svg: $bd8b4af169de6e27$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("7uRko", function(module, exports) {
$parcel$export(module.exports, "JiraServiceManagementLogo", () => $5754b390ebf2649e$export$dabef2be6cd28c20);

var $5FkrB = parcelRequire("5FkrB");

var $8zwGK = parcelRequire("8zwGK");

var $epSHF = parcelRequire("epSHF");

var $dBzF0 = parcelRequire("dBzF0");

var $cjKLY = parcelRequire("cjKLY");
var $5754b390ebf2649e$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $cjKLY.getColorsFromAppearance)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" viewBox=\"0 0 362 32\" focusable=\"false\" aria-hidden=\"true\" xmlns=\"http://www.w3.org/2000/svg\">\n      <path fill=".concat(colors.iconColor, " d=\"M14.124 13.257h7.325c1.1 0 1.475 1.046.804 1.878L10.798 29.274c-3.702-2.951-3.353-7.62-.644-11.027zm-5.66 5.634H1.138c-1.1 0-1.476-1.046-.805-1.878L11.79 2.874c3.703 2.951 3.3 7.566.617 11z\" />\n      <path fill=").concat(colors.textColor, " d=\"M357.074 20.787c0 1.35.797 2.27 2.422 2.27.614 0 1.196-.123 1.656-.215v2.545c-.46.123-.981.245-1.778.245-3.282 0-4.876-1.932-4.876-4.784v-8.187h-2.484v-2.454h2.484v-3.25h2.576v3.25h4.078v2.453h-4.078zm-7.327-4.231v8.985h-2.638V16.28c0-2.76-1.104-3.987-3.618-3.987-2.454 0-4.14 1.625-4.14 4.723v8.525h-2.638V10.208h2.638v2.514c.981-1.81 2.79-2.821 4.845-2.821 3.527 0 5.551 2.423 5.551 6.655m-22.921-4.263c-2.791 0-4.201 1.81-4.477 4.477h8.556c-.154-2.852-1.442-4.477-4.079-4.477m5.888 12.635c-1.257.674-3.189.92-4.753.92-5.735 0-8.25-3.312-8.25-8.004 0-4.631 2.576-7.943 7.238-7.943 4.722 0 6.624 3.281 6.624 7.943v1.196h-11.194c.368 2.606 2.055 4.293 5.674 4.293 1.778 0 3.281-.337 4.661-.828zm-26.152-7.912v8.525h-2.637V16.28c0-2.76-1.104-3.987-3.619-3.987-2.453 0-4.14 1.625-4.14 4.723v8.525h-2.637V10.208h2.637v2.514c.981-1.81 2.79-2.821 4.845-2.821 2.607 0 4.385 1.319 5.152 3.741.859-2.361 2.913-3.741 5.459-3.741 3.434 0 5.336 2.33 5.336 6.655v8.985h-2.638v-8.525c0-3.16-1.104-4.723-3.618-4.723-2.454 0-4.14 1.625-4.14 4.723m-22.921-4.723c-2.79 0-4.201 1.81-4.477 4.477h8.556c-.153-2.852-1.441-4.477-4.079-4.477m5.888 12.635c-1.257.674-3.189.92-4.753.92-5.735 0-8.25-3.312-8.25-8.004 0-4.631 2.577-7.943 7.238-7.943 4.723 0 6.624 3.281 6.624 7.943v1.196h-11.193c.368 2.606 2.054 4.293 5.673 4.293 1.779 0 3.281-.337 4.661-.828zm-18.638-.614v-1.533c-.982 2.024-2.822 3.067-5.183 3.067-4.048 0-6.072-3.466-6.072-7.974 0-4.324 2.116-7.973 6.379-7.973 2.238 0 3.956 1.012 4.876 3.005v-2.698h2.576V24.16c0 4.508-2.116 7.544-7.606 7.544-2.576 0-3.986-.337-5.458-.828V28.3c1.686.552 3.434.92 5.336.92 3.833 0 5.152-2.055 5.152-4.907m-8.679-6.44c0 3.68 1.472 5.52 4.201 5.52 2.362 0 4.478-1.503 4.478-4.906V17.26c0-3.404-1.932-4.907-4.171-4.907-2.975 0-4.508 1.963-4.508 5.52m-16.949.001c0 3.68 1.472 5.52 4.201 5.52 2.361 0 4.477-1.503 4.477-4.906V17.26c0-3.404-1.932-4.907-4.17-4.907-2.975 0-4.508 1.963-4.508 5.52m8.678 7.667v-2.76c-.981 2.024-2.821 3.066-5.182 3.066-4.079 0-6.134-3.465-6.134-7.973 0-4.324 2.147-7.973 6.44-7.973 2.239 0 3.956 1.012 4.876 3.005v-2.699h2.638V25.54zm-14.073-8.984v8.985h-2.638V16.28c0-2.76-1.104-3.987-3.618-3.987-2.454 0-4.14 1.625-4.14 4.723v8.525h-2.638V10.208h2.638v2.514c.981-1.81 2.79-2.821 4.845-2.821 3.527 0 5.551 2.423 5.551 6.655m-28.327 1.318c0 3.68 1.472 5.52 4.202 5.52 2.361 0 4.477-1.503 4.477-4.906V17.26c0-3.404-1.932-4.907-4.171-4.907-2.974 0-4.508 1.963-4.508 5.52m8.679 7.667v-2.76c-.981 2.024-2.821 3.066-5.183 3.066-4.078 0-6.133-3.465-6.133-7.973 0-4.324 2.147-7.973 6.44-7.973 2.239 0 3.956 1.012 4.876 3.005v-2.699h2.637V25.54zm-31.445-11.009-2.76-7.482V25.54h-2.76V5.393h4.784l4.569 11.56 1.871 5.552 1.87-5.551 4.6-11.561h4.447V25.54h-2.76V7.263l-2.361 7.268-4.447 11.01h-2.668zm-21.511-2.238c-2.791 0-4.202 1.81-4.478 4.477h8.556c-.153-2.852-1.441-4.477-4.078-4.477m5.888 12.635c-1.258.674-3.19.92-4.754.92-5.734 0-8.249-3.312-8.249-8.004 0-4.631 2.576-7.943 7.237-7.943 4.723 0 6.624 3.281 6.624 7.943v1.196h-11.193c.368 2.606 2.055 4.293 5.673 4.293 1.779 0 3.282-.337 4.662-.828zm-15.094-2.148v2.362c-.92.49-2.33.705-3.741.705-5.459 0-8.004-3.312-8.004-8.004 0-4.63 2.545-7.942 8.004-7.942 1.38 0 2.453.184 3.649.736v2.453c-.981-.46-2.024-.736-3.465-.736-3.987 0-5.612 2.515-5.612 5.49s1.656 5.489 5.673 5.489c1.564 0 2.546-.215 3.496-.552M140.124 6.16c0-1.166.766-1.84 1.84-1.84 1.073 0 1.84.674 1.84 1.84S143.037 8 141.964 8c-1.074 0-1.84-.675-1.84-1.84m.49 19.38V10.208h2.638v15.334zm-8.233 0h-3.527l-5.949-15.332h2.76l4.968 13.094 4.937-13.094h2.76zm-15.455-9.046v9.047h-2.576V10.207h2.576v2.699c.889-1.81 2.423-3.097 5.428-2.913v2.576c-3.373-.338-5.428.674-5.428 3.925m-12.463-4.201c-2.791 0-4.202 1.81-4.478 4.477h8.556c-.153-2.852-1.441-4.477-4.078-4.477m5.888 12.635c-1.258.674-3.19.92-4.754.92-5.734 0-8.249-3.312-8.249-8.004 0-4.631 2.576-7.943 7.237-7.943 4.723 0 6.624 3.281 6.624 7.943v1.196h-11.193c.368 2.606 2.055 4.293 5.673 4.293 1.779 0 3.282-.337 4.662-.828zM95.024 19.99c0 3.496-2.085 5.857-7.084 5.857-3.894 0-5.704-.766-7.268-1.564v-2.821c1.87.981 4.754 1.687 7.422 1.687 3.036 0 4.17-1.196 4.17-2.975s-1.104-2.73-4.937-3.65c-4.539-1.103-6.563-2.667-6.563-5.98 0-3.127 2.392-5.458 7.084-5.458 2.914 0 4.784.705 6.164 1.472v2.76c-2.024-1.165-4.201-1.533-6.286-1.533-2.638 0-4.202.92-4.202 2.76 0 1.656 1.288 2.484 4.845 3.373 4.263 1.073 6.655 2.453 6.655 6.072m-34.001-2.116c0 3.68 1.472 5.52 4.201 5.52 2.362 0 4.478-1.503 4.478-4.906V17.26c0-3.404-1.932-4.907-4.17-4.907-2.975 0-4.509 1.963-4.509 5.52m8.679 7.667v-2.76c-.981 2.024-2.821 3.066-5.183 3.066-4.078 0-6.133-3.465-6.133-7.973 0-4.324 2.147-7.973 6.44-7.973 2.239 0 3.956 1.012 4.876 3.005v-2.699h2.637V25.54zM51.91 16.494v9.047h-2.577V10.207h2.576v2.699c.89-1.81 2.423-3.097 5.428-2.913v2.576c-3.373-.338-5.428.674-5.428 3.925M42.224 6.16c0-1.166.767-1.84 1.84-1.84s1.84.674 1.84 1.84S45.137 8 44.064 8s-1.84-.675-1.84-1.84m.49 19.38V10.208h2.638v15.334zm-6.427-5.949V5.393h2.76v14.014c0 3.71-1.626 6.256-5.428 6.256-1.442 0-2.546-.245-3.312-.521v-2.668c.828.337 1.84.521 2.852.521 2.33 0 3.128-1.41 3.128-3.404\" />\n    </svg>");
};
var $5754b390ebf2649e$export$dabef2be6cd28c20 = function JiraServiceManagementLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Jira Service Management' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $epSHF.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $epSHF.defaultLogoParams).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $epSHF.defaultLogoParams).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $8zwGK.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $dBzF0.default), {
        appearance: appearance,
        label: label,
        iconColor: iconColor,
        size: size,
        svg: $5754b390ebf2649e$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("kb8Bx", function(module, exports) {
$parcel$export(module.exports, "LoomIcon", () => $eb0b825f9501267f$export$8d789f76fde3e05);

var $5FkrB = parcelRequire("5FkrB");

var $8zwGK = parcelRequire("8zwGK");

var $epSHF = parcelRequire("epSHF");

var $dBzF0 = parcelRequire("dBzF0");

var $cjKLY = parcelRequire("cjKLY");
var $eb0b825f9501267f$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor;
    var colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $cjKLY.getColorsForLoom)(appearance, colorMode);
    return "<svg\n    fill=\"none\"\n    height=\"32\"\n    viewBox=\"0 0 32 32\"\n    xmlns=\"http://www.w3.org/2000/svg\"\n    focusable=\"false\"\n    aria-hidden=\"true\"\n  >\n    <path\n      d=\"M27.333 15.508h-6.628l5.74-3.315-1.26-2.184-5.74 3.314 3.313-5.74-2.184-1.26-3.313 5.74V5.434h-2.522v6.628l-3.314-5.74-2.184 1.26 3.314 5.74-5.74-3.314-1.26 2.184 5.74 3.314H4.667v2.521h6.627l-5.74 3.314 1.261 2.184 5.74-3.313-3.314 5.74 2.184 1.26 3.314-5.74V28.1h2.521v-6.627l3.313 5.74 2.184-1.261-3.314-5.74 5.74 3.313 1.261-2.184-5.74-3.313h6.628zM16 20.198a3.442 3.442 0 1 1 0-6.885 3.442 3.442 0 0 1 0 6.884\"\n      fill=\"".concat(colors.iconColor, "\"\n    />\n  </svg>");
};
var $eb0b825f9501267f$export$8d789f76fde3e05 = function LoomIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Loom' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $epSHF.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $epSHF.defaultLogoParams).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $epSHF.defaultLogoParams).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $8zwGK.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $dBzF0.default), {
        appearance: appearance,
        label: label,
        svg: $eb0b825f9501267f$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("9cPpa", function(module, exports) {
$parcel$export(module.exports, "LoomLogo", () => $6b3d1bfb35e3dead$export$94e206806e36c2ec);

var $5FkrB = parcelRequire("5FkrB");

var $8zwGK = parcelRequire("8zwGK");

var $epSHF = parcelRequire("epSHF");

var $dBzF0 = parcelRequire("dBzF0");

var $cjKLY = parcelRequire("cjKLY");
var $6b3d1bfb35e3dead$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $cjKLY.getColorsForLoom)(appearance, colorMode);
    return "<svg\n      fill=\"none\"\n      height=\"32\"\n      xmlns=\"http://www.w3.org/2000/svg\"\n      viewBox=\"0 0 98 32\"\n      focusable=\"false\"\n      aria-hidden=\"true\"\n    >\n      <path\n        d=\"M29.657 13.659h-8.672l7.51-4.337-1.649-2.857-7.51 4.336 4.335-7.51-2.857-1.65-4.336 7.51V.479H13.18v8.672l-4.337-7.51-2.856 1.65 4.336 7.51-7.51-4.336-1.65 2.857 7.51 4.336H0v3.299h8.671l-7.51 4.336 1.65 2.858 7.51-4.336-4.336 7.51 2.857 1.65 4.336-7.511v8.672h3.3v-8.671l4.335 7.51 2.857-1.65-4.336-7.51 7.51 4.336 1.65-2.858-7.51-4.335h8.672v-3.3zM14.83 19.794a4.503 4.503 0 1 1 0-9.006 4.503 4.503 0 0 1 0 9.006\"\n        fill=\"".concat(colors.iconColor, "\"\n      />\n      <path\n        d=\"M37.303 26.155V4.459h3.983v21.696zm38.204-14.743h3.803v1.798c.808-1.438 2.696-2.218 4.313-2.218 2.007 0 3.624.87 4.373 2.457 1.167-1.798 2.726-2.457 4.673-2.457 2.725 0 5.33 1.648 5.33 5.604v9.559h-3.862v-8.75c0-1.588-.78-2.786-2.607-2.786-1.707 0-2.726 1.318-2.726 2.907v8.63H84.85v-8.75c0-1.59-.808-2.787-2.606-2.787-1.738 0-2.757 1.288-2.757 2.907v8.63h-3.981zm-25.219 15.17c-4.487 0-7.737-3.328-7.737-7.798 0-4.4 3.24-7.806 7.737-7.806 4.52 0 7.737 3.439 7.737 7.806 0 4.438-3.251 7.798-7.737 7.798m0-11.996a4.2 4.2 0 0 0-4.197 4.199c0 2.315 1.883 4.199 4.197 4.199s4.196-1.884 4.196-4.2a4.2 4.2 0 0 0-4.196-4.198m16.245 11.996c-4.487 0-7.737-3.328-7.737-7.798 0-4.4 3.24-7.806 7.737-7.806 4.52 0 7.737 3.439 7.737 7.806 0 4.438-3.253 7.798-7.737 7.798m0-12.046c-2.34 0-4.245 1.906-4.245 4.247s1.904 4.247 4.245 4.247a4.25 4.25 0 0 0 4.245-4.247 4.25 4.25 0 0 0-4.245-4.247\"\n        fill=\"").concat(colors.textColor, "\"\n      />\n    </svg>");
};
var $6b3d1bfb35e3dead$export$94e206806e36c2ec = function LoomLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Loom' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $epSHF.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $epSHF.defaultLogoParams).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $epSHF.defaultLogoParams).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $8zwGK.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $dBzF0.default), {
        appearance: appearance,
        label: label,
        iconColor: iconColor,
        size: size,
        svg: $6b3d1bfb35e3dead$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("cKMMr", function(module, exports) {
$parcel$export(module.exports, "LoomAttributionIcon", () => $948f9ea8130a73bd$export$1bf47cdade1a9fcb);

var $5FkrB = parcelRequire("5FkrB");

var $epSHF = parcelRequire("epSHF");

var $kb8Bx = parcelRequire("kb8Bx");
var $948f9ea8130a73bd$export$1bf47cdade1a9fcb = function LoomAttributionIcon(_ref) {
    var appearance = _ref.appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Loom Attribution' : _ref$label, _ref$size = _ref.size, size = _ref$size === void 0 ? (0, $epSHF.defaultLogoParams).size : _ref$size, testId = _ref.testId, _ref$iconColor = _ref.iconColor, iconColor = _ref$iconColor === void 0 ? (0, $epSHF.defaultLogoParams).iconColor : _ref$iconColor, _ref$textColor = _ref.textColor, textColor = _ref$textColor === void 0 ? (0, $epSHF.defaultLogoParams).textColor : _ref$textColor;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $kb8Bx.LoomIcon), {
        appearance: appearance,
        label: label,
        size: size,
        testId: testId,
        iconColor: iconColor,
        textColor: textColor
    });
};

});

parcelRegister("1IYzI", function(module, exports) {
$parcel$export(module.exports, "LoomAttributionLogo", () => $1418e3794a123aa7$export$6e87ce8d41eda665);

var $5FkrB = parcelRequire("5FkrB");

var $8zwGK = parcelRequire("8zwGK");

var $epSHF = parcelRequire("epSHF");

var $dBzF0 = parcelRequire("dBzF0");

var $cjKLY = parcelRequire("cjKLY");
var $1418e3794a123aa7$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $cjKLY.getColorsForLoom)(appearance, colorMode);
    return "<svg\n\t\tfill=\"none\"\n\t\theight=\"32\"\n\t\txmlns=\"http://www.w3.org/2000/svg\"\n\t\tfocusable=\"false\"\n\t\taria-hidden=\"true\"\n\t\tviewBox=\"0 0 88 32\"\n\t>\n\t\t<path\n\t\t\td=\"M29.488 12.765h-8.983l7.78-4.344-1.544-2.585-7.78 4.344 4.492-7.523-2.674-1.493-4.491 7.522V0H13.2v8.687L8.71 1.164 6.035 2.657l4.49 7.522-7.778-4.343L1.204 8.42l7.779 4.344H0v2.986h8.982l-7.778 4.343 1.543 2.585 7.78-4.342-4.492 7.522 2.674 1.493L13.2 19.83v8.687h3.087v-8.873l4.574 7.663 2.507-1.4-4.575-7.663 7.946 4.437 1.544-2.586-7.779-4.343h8.982v-2.986h.001Zm-14.744 5.552c-2.318 0-4.197-1.817-4.197-4.059s1.88-4.059 4.197-4.059 4.198 1.817 4.198 4.06c0 2.24-1.88 4.058-4.198 4.058\"\n\t\t\tfill=\"".concat(colors.iconColor, "\"\n\t\t/>\n\t\t<path\n\t\t\td=\"M38.379 26.847V10.094h3.18v16.753zm30.503-11.79h3.036v1.438c.646-1.15 2.153-1.773 3.444-1.773 1.602 0 2.893.695 3.49 1.964.932-1.438 2.177-1.964 3.731-1.964 2.175 0 4.256 1.318 4.256 4.48v7.642h-3.084V19.85c0-1.27-.623-2.228-2.081-2.228-1.363 0-2.177 1.054-2.177 2.324v6.9h-3.155V19.85c0-1.27-.646-2.228-2.081-2.228-1.387 0-2.2 1.03-2.2 2.324v6.9h-3.18V15.057Zm-20.134 12.13c-3.582 0-6.176-2.66-6.176-6.234 0-3.517 2.585-6.242 6.176-6.242 3.609 0 6.177 2.75 6.177 6.242 0 3.547-2.596 6.234-6.177 6.234m0-9.59a3.357 3.357 0 0 0 0 6.713 3.357 3.357 0 0 0 0-6.713m12.966 9.59c-3.583 0-6.177-2.66-6.177-6.234 0-3.517 2.586-6.242 6.177-6.242 3.608 0 6.176 2.75 6.176 6.242 0 3.547-2.597 6.234-6.176 6.234m0-9.63a3.397 3.397 0 0 0-3.39 3.395 3.397 3.397 0 0 0 3.39 3.395 3.396 3.396 0 0 0 0-6.79M64.933 5.63c0-1.102-.697-1.522-1.983-1.837-.803-.21-1.018-.368-1.018-.63q0-.473.804-.473c.643 0 1.286.21 1.93.473V1.798a4.5 4.5 0 0 0-1.876-.42c-1.447 0-2.25.682-2.25 1.785 0 1.05.696 1.575 1.928 1.838.804.157 1.072.315 1.072.682 0 .263-.215.473-.804.473a4.46 4.46 0 0 1-2.197-.63v1.417c.483.263 1.233.473 2.197.473 1.5.052 2.197-.683 2.197-1.785Zm16.662-4.067v5.988h1.3V3.007l.542 1.23 1.841 3.368h1.626V1.563h-1.3v3.85l-.488-1.123-1.463-2.727zm-8.056 0h-1.465v6.042h1.465zm-23.981 0v6.042h2.863l.432-1.295h-1.945V1.563zm-5.671 0v1.295h1.604v4.747h1.44V2.858h1.715V1.563zm-2.177 0h-1.802l-2.066 6.042h1.59l.317-1.025a4 4 0 0 0 1.113.162q.556 0 1.113-.162l.318 1.025h1.59zm-.9 3.938a3 3 0 0 1-.743-.108l.742-2.643.742 2.643c-.265.054-.477.108-.742.108Zm16.577-3.938H55.53L53.4 7.605h1.638l.328-1.025q.573.162 1.146.162.574 0 1.147-.162l.328 1.025h1.638l-2.24-6.042Zm-.928 3.938c-.273 0-.546-.054-.765-.108l.765-2.643.764 2.643a3.3 3.3 0 0 1-.764.108m21.98-3.938h-1.857l-2.13 6.042h1.638l.328-1.025q.574.162 1.147.162c.573 0 .764-.054 1.146-.162l.328 1.025h1.638zm-.93 3.938c-.272 0-.545-.054-.763-.108l.764-2.643.765 2.643a3.3 3.3 0 0 1-.765.108Zm-6.894.129c0-1.102-.697-1.522-1.983-1.837-.803-.21-1.018-.368-1.018-.63q0-.473.804-.473c.643 0 1.286.21 1.93.473V1.798a4.5 4.5 0 0 0-1.876-.42c-1.447 0-2.25.682-2.25 1.785 0 1.05.696 1.575 1.928 1.838.804.157 1.072.315 1.072.682 0 .263-.215.473-.804.473-.75 0-1.608-.263-2.197-.63v1.417c.482.263 1.233.473 2.197.473 1.447.052 2.197-.683 2.197-1.785Z\"\n\t\t\tfill=\"").concat(colors.textColor, "\"\n\t\t/>\n\t</svg>");
};
var $1418e3794a123aa7$export$6e87ce8d41eda665 = function LoomAttributionLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Loom Attribution' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $epSHF.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $epSHF.defaultLogoParams).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $epSHF.defaultLogoParams).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $8zwGK.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $dBzF0.default), {
        appearance: appearance,
        label: label,
        iconColor: iconColor,
        size: size,
        svg: $1418e3794a123aa7$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("6qbsR", function(module, exports) {
$parcel$export(module.exports, "OpsgenieIcon", () => $4ace10650fa1c391$export$eeccc49dc7a12d9f);

var $5FkrB = parcelRequire("5FkrB");

var $8zwGK = parcelRequire("8zwGK");

var $epSHF = parcelRequire("epSHF");

var $dBzF0 = parcelRequire("dBzF0");

var $cjKLY = parcelRequire("cjKLY");
var $4ace10650fa1c391$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor;
    var colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $cjKLY.getColorsFromAppearance)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" viewBox=\"0 0 32 32\" focusable=\"false\" aria-hidden=\"true\" xmlns=\"http://www.w3.org/2000/svg\">\n      <path fill=\"".concat(colors.iconColor, "\" d=\"M17.114 28.127c-.785.578-1.199.537-1.984-.041-3.8-2.727-7.313-5.826-9.668-9.049-.248-.33-.124-.785.248-.991l4.297-2.686q.558-.372.992.124c1.652 1.9 3.264 3.76 5.123 5.082 1.86-1.322 3.47-3.181 5.123-5.082q.434-.495.992-.124l4.297 2.686c.372.206.496.66.248.991-2.355 3.223-5.867 6.322-9.668 9.09m-.992-11.858c3.388 0 6.198-2.768 6.198-6.156s-2.81-6.239-6.198-6.239-6.198 2.81-6.198 6.239c0 3.43 2.727 6.156 6.198 6.156\"/>\n    </svg>");
};
var $4ace10650fa1c391$export$eeccc49dc7a12d9f = function OpsgenieIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Opsgenie' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $epSHF.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $epSHF.defaultLogoParams).textColor : _ref2$textColor, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $epSHF.defaultLogoParams).iconColor : _ref2$iconColor;
    var _useThemeObserver = (0, $8zwGK.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $dBzF0.default), {
        appearance: appearance,
        svg: $4ace10650fa1c391$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        label: label,
        size: size,
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("kfv2v", function(module, exports) {
$parcel$export(module.exports, "OpsgenieLogo", () => $ebdd49278187292c$export$a1c6484cdecc2c4b);

var $5FkrB = parcelRequire("5FkrB");

var $8zwGK = parcelRequire("8zwGK");

var $epSHF = parcelRequire("epSHF");

var $dBzF0 = parcelRequire("dBzF0");

var $cjKLY = parcelRequire("cjKLY");
var $ebdd49278187292c$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $cjKLY.getColorsFromAppearance)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" viewBox=\"0 0 154 32\" focusable=\"false\" aria-hidden=\"true\" xmlns=\"http://www.w3.org/2000/svg\">\n      <path fill=\"".concat(colors.iconColor, "\" d=\"M11.78 28.127c-.785.578-1.198.537-1.983-.041-3.801-2.727-7.313-5.826-9.668-9.049-.248-.33-.124-.785.248-.991l4.297-2.686q.558-.372.991.124c1.653 1.9 3.264 3.76 5.124 5.082 1.859-1.322 3.47-3.181 5.123-5.082q.435-.495.992-.124l4.297 2.686c.371.206.495.66.247.991-2.355 3.223-5.867 6.322-9.668 9.09m-.99-11.857c3.388 0 6.197-2.768 6.197-6.156s-2.81-6.239-6.197-6.239-6.198 2.81-6.198 6.239c0 3.43 2.727 6.156 6.198 6.156\"/>\n      <path fill=\"").concat(colors.textColor, "\" d=\"M146.689 12.293c-2.79 0-4.201 1.81-4.477 4.477h8.556c-.153-2.852-1.441-4.477-4.079-4.477m5.888 12.635c-1.257.674-3.189.92-4.753.92-5.735 0-8.249-3.312-8.249-8.004 0-4.631 2.576-7.943 7.237-7.943 4.723 0 6.624 3.281 6.624 7.943v1.196h-11.193c.368 2.606 2.054 4.293 5.673 4.293 1.779 0 3.281-.337 4.661-.828zM133.385 6.16c0-1.166.767-1.84 1.841-1.84s1.84.674 1.84 1.84-.767 1.84-1.84 1.84c-1.074 0-1.841-.675-1.841-1.84m.491 19.38V10.208h2.638v15.334zm-3.677-8.984v8.985h-2.638V16.28c0-2.76-1.104-3.987-3.618-3.987-2.454 0-4.14 1.625-4.14 4.723v8.525h-2.638V10.208h2.638v2.514c.981-1.81 2.79-2.821 4.845-2.821 3.527 0 5.551 2.423 5.551 6.655m-22.921-4.263c-2.791 0-4.201 1.81-4.477 4.477h8.556c-.154-2.852-1.442-4.477-4.079-4.477m5.888 12.635c-1.257.674-3.189.92-4.753.92-5.735 0-8.25-3.312-8.25-8.004 0-4.631 2.576-7.943 7.238-7.943 4.722 0 6.624 3.281 6.624 7.943v1.196h-11.194c.368 2.606 2.055 4.293 5.674 4.293 1.778 0 3.281-.337 4.661-.828zm-18.639-.614v-1.533c-.981 2.024-2.821 3.067-5.182 3.067-4.048 0-6.072-3.466-6.072-7.974 0-4.324 2.116-7.973 6.378-7.973 2.239 0 3.956 1.012 4.876 3.005v-2.698h2.576V24.16c0 4.508-2.116 7.544-7.605 7.544-2.576 0-3.987-.337-5.459-.828V28.3c1.687.552 3.435.92 5.336.92 3.834 0 5.152-2.055 5.152-4.907m-8.678-6.44c0 3.68 1.472 5.52 4.2 5.52 2.362 0 4.478-1.503 4.478-4.906V17.26c0-3.404-1.932-4.907-4.17-4.907-2.975 0-4.508 1.963-4.508 5.52m-4.703 3.497c0 2.545-1.656 4.477-5.765 4.477-2.3 0-4.17-.52-5.336-1.134v-2.79c1.319.766 3.527 1.502 5.459 1.502 2.024 0 3.066-.828 3.066-2.024 0-1.165-.89-1.84-3.802-2.545-3.404-.829-4.846-2.147-4.846-4.662 0-2.668 2.055-4.293 5.55-4.293 1.994 0 3.804.49 4.938 1.104v2.73c-1.84-.92-3.342-1.411-4.968-1.411-1.932 0-2.974.674-2.974 1.87 0 1.073.736 1.748 3.557 2.423 3.404.828 5.121 2.085 5.121 4.753m-16.274-3.496c0-3.68-1.472-5.52-4.202-5.52-2.36 0-4.477 1.503-4.477 4.907v1.227c0 3.404 1.932 4.906 4.17 4.906 2.975 0 4.509-1.962 4.509-5.52m-3.803 7.974c-2.239 0-3.956-1.013-4.876-3.006v8.679h-2.637V10.207h2.637v2.76c.981-2.024 2.821-3.066 5.183-3.066 4.079 0 6.133 3.465 6.133 7.973 0 4.324-2.147 7.973-6.44 7.973m-20.121 0c-6.225 0-9.721-4.293-9.721-10.426 0-6.072 3.496-10.335 9.721-10.335 6.195 0 9.69 4.263 9.69 10.335 0 6.133-3.495 10.426-9.69 10.426m0-18.124c-4.968 0-6.961 3.527-6.961 7.698 0 4.262 1.993 7.789 6.961 7.789 4.937 0 6.93-3.527 6.93-7.79 0-4.17-1.993-7.697-6.93-7.697\" />\n    </svg>");
};
var $ebdd49278187292c$export$a1c6484cdecc2c4b = function OpsgenieLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Opsgenie' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $epSHF.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $epSHF.defaultLogoParams).textColor : _ref2$textColor, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $epSHF.defaultLogoParams).iconColor : _ref2$iconColor;
    var _useThemeObserver = (0, $8zwGK.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $dBzF0.default), {
        appearance: appearance,
        iconColor: iconColor,
        label: label,
        size: size,
        svg: $ebdd49278187292c$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("3Deu1", function(module, exports) {
$parcel$export(module.exports, "RovoIcon", () => $2a503fb01acf4ff1$export$e23ae35269442b4f);

var $5FkrB = parcelRequire("5FkrB");

var $8zwGK = parcelRequire("8zwGK");

var $epSHF = parcelRequire("epSHF");

var $dBzF0 = parcelRequire("dBzF0");

var $cjKLY = parcelRequire("cjKLY");
var $2a503fb01acf4ff1$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor;
    var colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $cjKLY.getColorsFromAppearance)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" focusable=\"false\" aria-hidden=\"true\">\n    <g fill=\"".concat(colors.iconColor, "\" fill-rule=\"evenodd\">\n      <path d=\"M17.06 4.246a2.79 2.79 0 0 0-2.736-.026l-.049.033-.002.001c-.605.35-1.048.91-1.256 1.558-.085.268-.13.552-.13.842v3.675l4.603 2.656a3.64 3.64 0 0 1 1.824 3.155v9.487a3.6 3.6 0 0 1-.214 1.23l6.175-3.566a2.77 2.77 0 0 0 1.392-2.407v-9.487c0-.991-.532-1.912-1.392-2.408z\"/>\n      <path d=\"m6.058 9 6.176-3.566a3.7 3.7 0 0 0-.214 1.23v9.486c0 1.303.693 2.505 1.823 3.155l4.604 2.657v3.674c0 .29-.045.575-.13.843a2.8 2.8 0 0 1-1.258 1.558.4.4 0 0 0-.05.033c-.851.47-1.89.461-2.735-.026L6.06 23.301a2.78 2.78 0 0 1-1.392-2.408v-9.486c0-.996.529-1.912 1.391-2.408z\"/>\n    </g>\n  </svg>");
};
var $2a503fb01acf4ff1$export$e23ae35269442b4f = function RovoIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Rovo' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $epSHF.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $epSHF.defaultLogoParams).textColor : _ref2$textColor, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $epSHF.defaultLogoParams).iconColor : _ref2$iconColor;
    var _useThemeObserver = (0, $8zwGK.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $dBzF0.default), {
        appearance: appearance,
        svg: $2a503fb01acf4ff1$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        label: label,
        size: size,
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("gXHVt", function(module, exports) {
$parcel$export(module.exports, "RovoLogo", () => $c5943acc1a1971d4$export$a0f6cb8061290bbb);

var $5FkrB = parcelRequire("5FkrB");

var $8zwGK = parcelRequire("8zwGK");

var $epSHF = parcelRequire("epSHF");

var $dBzF0 = parcelRequire("dBzF0");

var $cjKLY = parcelRequire("cjKLY");
var $c5943acc1a1971d4$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $cjKLY.getColorsFromAppearance)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" viewBox=\"0 0 100 32\" focusable=\"false\" aria-hidden=\"true\" xmlns=\"http://www.w3.org/2000/svg\">\n      <path\n        d=\"M12.393 4.246a2.79 2.79 0 0 0-2.735-.026.4.4 0 0 1-.05.033l-.001.001c-.606.35-1.048.91-1.257 1.558q-.129.404-.13.842v3.675l4.603 2.656a3.64 3.64 0 0 1 1.824 3.155v9.487a3.6 3.6 0 0 1-.214 1.23l6.175-3.566A2.77 2.77 0 0 0 22 20.884v-9.487c0-.991-.532-1.912-1.392-2.408z\"\n        fill=\"".concat(colors.iconColor, "\"\n        fillRule=\"evenodd\"\n      />\n      <path\n        d=\"m1.391 9 6.176-3.566a3.6 3.6 0 0 0-.214 1.23v9.486c0 1.303.693 2.505 1.823 3.155h.001l4.603 2.657v3.674c0 .29-.045.575-.13.843a2.8 2.8 0 0 1-1.258 1.558.4.4 0 0 0-.05.033c-.85.47-1.89.461-2.734-.026l-8.216-4.743A2.78 2.78 0 0 1 0 20.893v-9.486c0-.996.529-1.912 1.391-2.408z\"\n        fill=\"").concat(colors.iconColor, "\"\n        fillRule=\"evenodd\"\n      />\n      <path\n        d=\"M91.688 25.848c-4.6 0-7.298-3.404-7.298-8.004S87.088 9.9 91.688 9.9c4.57 0 7.238 3.342 7.238 7.942s-2.668 8.004-7.238 8.004zm0-13.494c-3.28 0-4.722 2.576-4.722 5.49 0 2.913 1.441 5.55 4.722 5.55 3.251 0 4.662-2.637 4.662-5.55 0-2.914-1.41-5.49-4.662-5.49M77.675 25.54H74.15L68.2 10.208h2.76l4.968 13.094 4.938-13.095h2.76zm-17.462.308c-4.6 0-7.299-3.404-7.299-8.004s2.7-7.943 7.3-7.943c4.568 0 7.236 3.342 7.236 7.942s-2.668 8.004-7.237 8.004zm0-13.494c-3.281 0-4.723 2.576-4.723 5.49 0 2.913 1.442 5.55 4.723 5.55 3.25 0 4.661-2.637 4.661-5.55 0-2.914-1.41-5.49-4.66-5.49zM43.177 8.03H39.13v7.36h4.048c3.588 0 4.692-1.38 4.692-3.68 0-2.177-1.134-3.68-4.692-3.68zm7.452 3.619c0 3.036-1.288 5.09-3.956 5.949l4.938 7.943H48.36l-4.447-7.514H39.13v7.514h-2.76V5.393h7.115c4.815 0 7.145 2.392 7.145 6.256z\"\n        fill=\"").concat(colors.textColor, "\"\n      />\n    </svg>");
};
var $c5943acc1a1971d4$export$a0f6cb8061290bbb = function RovoLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Rovo' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $epSHF.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $epSHF.defaultLogoParams).textColor : _ref2$textColor, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $epSHF.defaultLogoParams).iconColor : _ref2$iconColor;
    var _useThemeObserver = (0, $8zwGK.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $dBzF0.default), {
        appearance: appearance,
        iconColor: iconColor,
        label: label,
        size: size,
        svg: $c5943acc1a1971d4$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("3l5GX", function(module, exports) {
$parcel$export(module.exports, "StatuspageIcon", () => $26e7bf863c9ec8c9$export$f3f5aa321d88adf9);

var $5FkrB = parcelRequire("5FkrB");

var $8zwGK = parcelRequire("8zwGK");

var $epSHF = parcelRequire("epSHF");

var $dBzF0 = parcelRequire("dBzF0");

var $cjKLY = parcelRequire("cjKLY");
var $26e7bf863c9ec8c9$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor;
    var colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $cjKLY.getColorsFromAppearance)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" viewBox=\"0 0 32 32\" focusable=\"false\" aria-hidden=\"true\" xmlns=\"http://www.w3.org/2000/svg\">\n      <path fill=\"".concat(colors.iconColor, "\" d=\"M16 12.604c-3.033 0-5.981 1.37-8.39 3.489q-.375.373-.748.373c-.208 0-.415-.124-.581-.332l-3.032-3.572c-.166-.207-.25-.415-.25-.581 0-.25.125-.457.374-.706 3.655-3.24 8.1-5.067 12.627-5.067s8.97 1.827 12.626 5.067c.249.249.374.457.374.706 0 .166-.084.374-.25.581l-3.032 3.572c-.166.208-.373.332-.581.332q-.374 0-.748-.374c-2.409-2.118-5.358-3.488-8.39-3.488m0 13.374c-3.365 0-6.106-2.742-6.106-6.064S12.635 13.85 16 13.85s6.106 2.7 6.106 6.064-2.741 6.063-6.105 6.063\"/>\n    </svg>");
};
var $26e7bf863c9ec8c9$export$f3f5aa321d88adf9 = function StatuspageIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Statuspage' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $epSHF.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $epSHF.defaultLogoParams).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $epSHF.defaultLogoParams).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $8zwGK.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $dBzF0.default), {
        appearance: appearance,
        label: label,
        svg: $26e7bf863c9ec8c9$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("8Ar69", function(module, exports) {
$parcel$export(module.exports, "StatuspageLogo", () => $6406b4a5ac5a7f77$export$bb4ae5b41b43be04);

var $5FkrB = parcelRequire("5FkrB");

var $8zwGK = parcelRequire("8zwGK");

var $epSHF = parcelRequire("epSHF");

var $dBzF0 = parcelRequire("dBzF0");

var $cjKLY = parcelRequire("cjKLY");
var $6406b4a5ac5a7f77$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $cjKLY.getColorsFromAppearance)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" viewBox=\"0 0 188 32\" focusable=\"false\" aria-hidden=\"true\" xmlns=\"http://www.w3.org/2000/svg\">\n      <path fill=\"".concat(colors.iconColor, "\" d=\"M13 12.604c-3.032 0-5.98 1.37-8.39 3.489q-.373.373-.747.373c-.208 0-.416-.124-.582-.332L.25 12.562c-.167-.207-.25-.415-.25-.581 0-.25.125-.457.374-.706C4.029 8.035 8.473 6.208 13 6.208s8.971 1.827 12.626 5.067c.25.249.374.457.374.706 0 .166-.083.374-.25.581l-3.031 3.572c-.166.208-.374.332-.582.332q-.373 0-.747-.374c-2.41-2.118-5.358-3.488-8.39-3.488m0 13.374c-3.364 0-6.105-2.742-6.105-6.064S9.635 13.85 13 13.85c3.364 0 6.105 2.7 6.105 6.064s-2.74 6.063-6.105 6.063\" />\n      <path fill=\"").concat(colors.textColor, "\" d=\"M180.293 12.293c-2.79 0-4.201 1.81-4.477 4.477h8.556c-.153-2.852-1.441-4.477-4.079-4.477m5.888 12.635c-1.257.674-3.189.92-4.753.92-5.735 0-8.249-3.312-8.249-8.004 0-4.631 2.576-7.943 7.237-7.943 4.723 0 6.624 3.281 6.624 7.943v1.196h-11.193c.368 2.606 2.054 4.293 5.673 4.293 1.779 0 3.281-.337 4.661-.828zm-18.638-.614v-1.533c-.981 2.024-2.821 3.067-5.183 3.067-4.048 0-6.072-3.466-6.072-7.974 0-4.324 2.116-7.973 6.379-7.973 2.239 0 3.956 1.012 4.876 3.005v-2.698h2.576V24.16c0 4.508-2.116 7.544-7.605 7.544-2.576 0-3.987-.337-5.459-.828V28.3c1.687.552 3.435.92 5.336.92 3.833 0 5.152-2.055 5.152-4.907m-8.679-6.44c0 3.68 1.472 5.52 4.202 5.52 2.361 0 4.477-1.503 4.477-4.906V17.26c0-3.404-1.932-4.907-4.171-4.907-2.974 0-4.508 1.963-4.508 5.52m-16.949.001c0 3.68 1.472 5.52 4.201 5.52 2.362 0 4.478-1.503 4.478-4.906V17.26c0-3.404-1.932-4.907-4.171-4.907-2.975 0-4.508 1.963-4.508 5.52m8.679 7.667v-2.76c-.982 2.024-2.822 3.066-5.183 3.066-4.079 0-6.133-3.465-6.133-7.973 0-4.324 2.146-7.973 6.44-7.973 2.238 0 3.956 1.012 4.876 3.005v-2.699h2.637V25.54zm-16.091-7.666c0-3.68-1.472-5.52-4.201-5.52-2.361 0-4.477 1.503-4.477 4.907v1.227c0 3.404 1.932 4.906 4.17 4.906 2.975 0 4.508-1.962 4.508-5.52m-3.802 7.974c-2.239 0-3.956-1.013-4.876-3.006v8.679h-2.638V10.207h2.638v2.76c.981-2.024 2.821-3.066 5.182-3.066 4.079 0 6.134 3.465 6.134 7.973 0 4.324-2.147 7.973-6.44 7.973m-10.56-4.477c0 2.545-1.656 4.477-5.765 4.477-2.3 0-4.171-.52-5.336-1.134v-2.79c1.318.766 3.526 1.502 5.458 1.502 2.024 0 3.067-.828 3.067-2.024 0-1.165-.889-1.84-3.803-2.545-3.404-.829-4.845-2.147-4.845-4.662 0-2.668 2.055-4.293 5.551-4.293 1.993 0 3.802.49 4.937 1.104v2.73c-1.84-.92-3.343-1.411-4.968-1.411-1.932 0-2.975.674-2.975 1.87 0 1.073.736 1.748 3.558 2.423 3.404.828 5.121 2.085 5.121 4.753m-27.598-2.177v-8.985h2.638v9.26c0 2.76 1.104 3.988 3.618 3.988 2.454 0 4.14-1.626 4.14-4.723v-8.525h2.638V25.54h-2.638v-2.515c-.981 1.81-2.79 2.821-4.845 2.821-3.527 0-5.55-2.422-5.55-6.654m-7.155 1.596c0 1.349.797 2.269 2.422 2.269.614 0 1.196-.123 1.656-.215v2.546a6.3 6.3 0 0 1-1.778.245c-3.282 0-4.876-1.932-4.876-4.784v-8.188h-2.484v-2.453h2.484V6.957h2.576v3.25h4.078v2.454H85.39zm-18.943-2.914c0 3.68 1.472 5.52 4.202 5.52 2.361 0 4.477-1.503 4.477-4.906V17.26c0-3.404-1.932-4.907-4.17-4.907-2.975 0-4.509 1.963-4.509 5.52m8.679 7.667v-2.76c-.981 2.024-2.821 3.066-5.183 3.066-4.078 0-6.133-3.465-6.133-7.973 0-4.324 2.147-7.973 6.44-7.973 2.239 0 3.956 1.012 4.876 3.005v-2.699h2.637V25.54zm-17.258-4.752c0 1.349.797 2.269 2.422 2.269.614 0 1.196-.123 1.656-.215v2.546a6.3 6.3 0 0 1-1.778.245c-3.282 0-4.876-1.932-4.876-4.784v-8.188h-2.484v-2.453h2.484V6.957h2.576v3.25h4.078v2.454h-4.078zm-6.894-.798c0 3.496-2.085 5.858-7.084 5.858-3.894 0-5.704-.767-7.268-1.564v-2.822c1.871.982 4.754 1.687 7.422 1.687 3.036 0 4.17-1.196 4.17-2.975 0-1.778-1.104-2.729-4.937-3.649-4.539-1.104-6.563-2.668-6.563-5.98 0-3.128 2.392-5.459 7.084-5.459 2.914 0 4.784.706 6.164 1.472v2.76c-2.024-1.165-4.201-1.533-6.286-1.533-2.638 0-4.202.92-4.202 2.76 0 1.656 1.288 2.484 4.846 3.373 4.262 1.074 6.654 2.454 6.654 6.072\" />\n    </svg>");
};
var $6406b4a5ac5a7f77$export$bb4ae5b41b43be04 = function StatuspageLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Statuspage' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $epSHF.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $epSHF.defaultLogoParams).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $epSHF.defaultLogoParams).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $8zwGK.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $dBzF0.default), {
        appearance: appearance,
        label: label,
        iconColor: iconColor,
        size: size,
        svg: $6406b4a5ac5a7f77$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("drVNk", function(module, exports) {
$parcel$export(module.exports, "TrelloIcon", () => $9caaa0c2f401d067$export$4384da9b8b140bf4);

var $5FkrB = parcelRequire("5FkrB");

var $8zwGK = parcelRequire("8zwGK");

var $epSHF = parcelRequire("epSHF");

var $dBzF0 = parcelRequire("dBzF0");

var $cjKLY = parcelRequire("cjKLY");
var $9caaa0c2f401d067$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor;
    var colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $cjKLY.getColorsFromAppearance)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" viewBox=\"0 0 32 32\" focusable=\"false\" aria-hidden=\"true\" xmlns=\"http://www.w3.org/2000/svg\">\n      <path fill=".concat(colors.iconColor, " clip-rule=\"evenodd\" d=\"M24.286 5.337H7.714a2.585 2.585 0 0 0-2.585 2.585v16.572a2.585 2.585 0 0 0 2.585 2.584h16.572a2.585 2.585 0 0 0 2.585-2.584V7.922a2.585 2.585 0 0 0-2.585-2.585m-9.791 15.66a.86.86 0 0 1-.859.858h-3.634a.86.86 0 0 1-.859-.859V10.21a.86.86 0 0 1 .859-.86h3.634a.86.86 0 0 1 .859.86zm8.362-4.953a.86.86 0 0 1-.859.859h-3.634a.86.86 0 0 1-.859-.859V10.21a.86.86 0 0 1 .859-.86h3.634a.86.86 0 0 1 .859.86z\" fill-rule=\"evenodd\"/>\n    </svg>");
};
var $9caaa0c2f401d067$export$4384da9b8b140bf4 = function TrelloIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Trello' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $epSHF.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $epSHF.defaultLogoParams).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $epSHF.defaultLogoParams).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $8zwGK.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $dBzF0.default), {
        appearance: appearance,
        label: label,
        svg: $9caaa0c2f401d067$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("2hO7t", function(module, exports) {
$parcel$export(module.exports, "TrelloLogo", () => $1aa40bfe32b3590a$export$60e26212f3b61a28);

var $5FkrB = parcelRequire("5FkrB");

var $8zwGK = parcelRequire("8zwGK");

var $epSHF = parcelRequire("epSHF");

var $dBzF0 = parcelRequire("dBzF0");

var $cjKLY = parcelRequire("cjKLY");
var $1aa40bfe32b3590a$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $cjKLY.getColorsFromAppearance)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" viewBox=\"0 0 106 32\" focusable=\"false\" aria-hidden=\"true\" xmlns=\"http://www.w3.org/2000/svg\">\n      <path fill=\"".concat(colors.iconColor, "\" clip-rule=\"evenodd\" d=\"M19.157 4.67H2.585A2.585 2.585 0 0 0 0 7.255v16.572a2.585 2.585 0 0 0 2.585 2.585h16.572a2.585 2.585 0 0 0 2.584-2.585V7.255a2.585 2.585 0 0 0-2.584-2.585M9.365 20.33a.86.86 0 0 1-.858.858H4.873a.86.86 0 0 1-.859-.858V9.543c0-.475.385-.859.859-.859h3.634c.474 0 .858.385.858.86zm8.362-4.952a.86.86 0 0 1-.858.858h-3.634a.86.86 0 0 1-.859-.858V9.543c0-.475.385-.859.859-.859h3.634c.474 0 .858.385.858.86z\" fill-rule=\"evenodd\"/>\n      <path fill=\"").concat(colors.textColor, "\" d=\"M97.64 25.848c-4.6 0-7.298-3.404-7.298-8.004S93.04 9.9 97.64 9.9c4.57 0 7.238 3.342 7.238 7.942s-2.668 8.004-7.238 8.004m0-13.494c-3.281 0-4.722 2.576-4.722 5.49 0 2.913 1.44 5.55 4.722 5.55 3.251 0 4.662-2.637 4.662-5.55 0-2.914-1.411-5.49-4.662-5.49M88.874 25.51c-.215.062-.675.123-1.35.123-2.514 0-4.109-1.196-4.109-4.017V3.798h2.637V21.31c0 1.38.92 1.87 2.055 1.87.276 0 .46 0 .767-.03zm-7.996 0c-.215.062-.675.123-1.35.123-2.514 0-4.109-1.196-4.109-4.017V3.798h2.637V21.31c0 1.38.92 1.87 2.055 1.87.276 0 .46 0 .767-.03zM65.532 12.293c-2.79 0-4.202 1.81-4.478 4.477h8.556c-.153-2.852-1.44-4.477-4.078-4.477m5.888 12.635c-1.258.674-3.19.92-4.754.92-5.734 0-8.249-3.312-8.249-8.004 0-4.631 2.576-7.943 7.237-7.943 4.723 0 6.624 3.281 6.624 7.943v1.196H61.085c.368 2.606 2.055 4.293 5.673 4.293 1.78 0 3.282-.337 4.662-.828zm-19.48-8.434v9.047h-2.576V10.208h2.576v2.698c.89-1.809 2.423-3.097 5.428-2.913v2.576c-3.373-.337-5.428.675-5.428 3.925M32.943 5.393H48.03V8.03h-6.164v17.511h-2.76V8.031h-6.164z\"/>\n    </svg>");
};
var $1aa40bfe32b3590a$export$60e26212f3b61a28 = function TrelloLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Trello' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $epSHF.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $epSHF.defaultLogoParams).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $epSHF.defaultLogoParams).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $8zwGK.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $dBzF0.default), {
        appearance: appearance,
        label: label,
        iconColor: iconColor,
        size: size,
        svg: $1aa40bfe32b3590a$var$svg({
            appearance: appearance,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};

});


parcelRegister("i6ESA", function(module, exports) {
$parcel$export(module.exports, "CONFLUENCE_GENERATOR_ID", () => $d2e87f57b28435e5$export$cee224b5de4d6d66);
$parcel$export(module.exports, "JIRA_GENERATOR_ID", () => $d2e87f57b28435e5$export$f654d825189934a7);
var $d2e87f57b28435e5$export$cee224b5de4d6d66 = 'https://www.atlassian.com/#Confluence';
var $d2e87f57b28435e5$export$f654d825189934a7 = 'https://www.atlassian.com/#Jira';
var $d2e87f57b28435e5$export$84a73a0383f58180 = 'JiraTask';
var $d2e87f57b28435e5$export$c6c83963a9378a67 = 'JiraSubTask';
var $d2e87f57b28435e5$export$58af3c426c111a6d = 'JiraStory';
var $d2e87f57b28435e5$export$ac9898a63417219e = 'JiraBug';
var $d2e87f57b28435e5$export$54db5e3fb12e39cd = 'JiraEpic';
var $d2e87f57b28435e5$export$2f54a5a217202c85 = 'JiraIncident';
var $d2e87f57b28435e5$export$d097371052bfc411 = 'JiraServiceRequest';
var $d2e87f57b28435e5$export$efd9452ad16c6676 = 'JiraChange';
var $d2e87f57b28435e5$export$2e7e70abb5d81f67 = 'JiraProblem';
var $d2e87f57b28435e5$export$ce25cfc40b280dbc = 'JiraCustomTaskType';

});


parcelRegister("DzZhj", function(module, exports) {
$parcel$export(module.exports, "extractTitle", () => $076f8ef919070ae0$export$b05803156e5015b6);

var $iYJcE = parcelRequire("iYJcE");

var $7BVbA = parcelRequire("7BVbA");

var $04ZlU = parcelRequire("04ZlU");
var $076f8ef919070ae0$export$b05803156e5015b6 = function extractTitle(jsonLd, removeTextHighlightingFromTitle) {
    var _jsonLd$name;
    if (!jsonLd) return undefined;
    var name = (_jsonLd$name = jsonLd.name) === null || _jsonLd$name === void 0 ? void 0 : _jsonLd$name.replace(/[\r\n]+/g, '');
    var id = jsonLd['@id'] || '';
    // Check if this is a reference to something _inside_ a Repository.
    // We format these titles to represent more metadata.
    var context = (0, $7BVbA.extractContext)(jsonLd);
    var type = (0, $04ZlU.extractType)(jsonLd);
    var hasContextType = context && context.type;
    var hasContextRepo = hasContextType && context.type.includes('atlassian:SourceCodeRepository');
    if (hasContextRepo && type) {
        var contextName = context.name && "".concat(context.name, ": ") || '';
        // COMMIT: `repo-name: abf137c title of commit message`
        if (type.includes('atlassian:SourceCodeCommit')) {
            var _id$split = id.split(':'), _id$split2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_id$split, 2), hashContent = _id$split2[1];
            var hash = hashContent && "".concat(hashContent.substring(0, 8), " ");
            return contextName + (hash || '') + name;
        }
        // PR: `repo-name: #42 title of pull request`
        if (type.includes('atlassian:SourceCodePullRequest')) {
            var pullRequest = jsonLd;
            var internalId = pullRequest['atlassian:internalId'];
            var internalIdRef = internalId && "#".concat(internalId, " ");
            return contextName + (internalIdRef || '') + name;
        }
        // BRANCH: `repo-name/branch-name`
        if (type.includes('atlassian:SourceCodeReference')) return contextName + name;
        // FILE: `repo-name: filepath`
        if (type.includes('schema:DigitalDocument')) return contextName + name;
    }
    if (removeTextHighlightingFromTitle) {
        var textFragmentRegex = new RegExp(' \\| :~:text=.*', 'g');
        var truncated = name === null || name === void 0 ? void 0 : name.replace(textFragmentRegex, '');
        return truncated;
    }
    return name;
};

});
parcelRegister("7BVbA", function(module, exports) {
$parcel$export(module.exports, "extractContext", () => $58a8590e1eba38ac$export$efdbd45f3e77a161);

var $04ZlU = parcelRequire("04ZlU");

var $ab6GS = parcelRequire("ab6GS");
var $58a8590e1eba38ac$export$efdbd45f3e77a161 = function extractContext(jsonLd) {
    var context = jsonLd.context;
    if (context) {
        if (typeof context === 'string') return {
            name: context
        };
        else if (context['@type'] === 'Link') {
            if (context.name) return {
                name: context.name
            };
        } else {
            if (context.name) return {
                name: context.name,
                icon: context.icon && (0, $ab6GS.extractUrlFromIconJsonLd)(context.icon),
                type: (0, $04ZlU.extractType)(context)
            };
        }
    }
    return undefined;
};

});
parcelRegister("04ZlU", function(module, exports) {
$parcel$export(module.exports, "extractType", () => $00eff725f795c003$export$2e9ae379995d99e3);
var $00eff725f795c003$export$2e9ae379995d99e3 = function extractType(jsonLd) {
    var type = jsonLd['@type'];
    if (type) {
        if (Array.isArray(jsonLd['@type'])) return type;
        else return [
            type
        ];
    }
    return undefined;
};

});



parcelRegister("r1O4b", function(module, exports) {
$parcel$export(module.exports, "extractPreview", () => $0513ec7832b06e5a$export$4b0d98b1b7f6d115);

var $lOiVl = parcelRequire("lOiVl");

var $k2wEH = parcelRequire("k2wEH");
var $0513ec7832b06e5a$export$4b0d98b1b7f6d115 = function extractPreview(jsonLd, platform, iframeUrlType) {
    var preview = jsonLd === null || jsonLd === void 0 ? void 0 : jsonLd.preview;
    var isSupported = (0, $lOiVl.extractPlatformIsSupported)(preview, platform);
    if (preview && isSupported) {
        if (typeof preview === 'string') return {
            src: preview
        };
        else if (preview['@type'] === 'Link' && iframeUrlType === 'interactiveHref' && preview.interactiveHref) return {
            src: preview.interactiveHref,
            aspectRatio: preview['atlassian:aspectRatio']
        };
        else if (preview['@type'] === 'Link') return {
            src: (0, $k2wEH.extractUrlFromLinkJsonLd)(preview),
            aspectRatio: preview['atlassian:aspectRatio']
        };
        else {
            // TODO, EDM-565: Remove this once the typings for Dropbox and Jira have been patched up.
            if (preview.url || preview.href) {
                if (iframeUrlType === 'interactiveHref' && preview.interactiveHref) return {
                    src: preview.interactiveHref,
                    aspectRatio: preview['atlassian:aspectRatio']
                };
                return {
                    src: (0, $k2wEH.extractUrlFromLinkJsonLd)(preview.url || preview.href),
                    aspectRatio: preview['atlassian:aspectRatio']
                };
            } else if (preview.content) return {
                content: preview.content
            };
        }
    }
    return undefined;
};

});
parcelRegister("lOiVl", function(module, exports) {
$parcel$export(module.exports, "extractPlatformIsSupported", () => $fe0cf264cbb27b07$export$3e8ad908070b68b2);
var $fe0cf264cbb27b07$export$3e8ad908070b68b2 = function extractPlatformIsSupported(preview, platform) {
    if (preview) {
        // By default, we support previews everywhere.
        if (typeof preview === 'string') return true;
        else {
            var supportedPlatforms = preview['atlassian:supportedPlatforms'];
            if (supportedPlatforms) {
                var isWeb = platform === 'web';
                return isWeb && supportedPlatforms.includes('web') || !isWeb && supportedPlatforms.includes('mobile');
            }
            // No supported platforms - assume they are all supported.
            return true;
        }
    }
    // No preview, don't try and render it on any platforms.
    return false;
};

});


parcelRegister("33An2", function(module, exports) {
$parcel$export(module.exports, "extractEntity", () => $239ddd54de5f77e8$export$8beff7405d020ddf);
$parcel$export(module.exports, "isEntityPresent", () => $239ddd54de5f77e8$export$c7168210b81d9383);
$parcel$export(module.exports, "extractEntityEmbedUrl", () => $239ddd54de5f77e8$export$f97663ee76ac5b24);
$parcel$export(module.exports, "extractEntityProvider", () => $239ddd54de5f77e8$export$ad879f2c9d5100a0);
$parcel$export(module.exports, "extractEntityIcon", () => $239ddd54de5f77e8$export$19346520e937a99f);

var $kqp0i = parcelRequire("kqp0i");

var $5FkrB = parcelRequire("5FkrB");

var $bSdlY = parcelRequire("bSdlY");

var $8Tu2m = parcelRequire("8Tu2m");

var $9Zzpd = parcelRequire("9Zzpd");

var $i6ESA = parcelRequire("i6ESA");
var $239ddd54de5f77e8$export$8beff7405d020ddf = function extractEntity(response) {
    return response === null || response === void 0 ? void 0 : response.entityData;
};
var $239ddd54de5f77e8$export$c7168210b81d9383 = function isEntityPresent(response) {
    return Boolean($239ddd54de5f77e8$export$8beff7405d020ddf(response));
};
var $239ddd54de5f77e8$export$f97663ee76ac5b24 = function extractEntityEmbedUrl(response) {
    var entity = $239ddd54de5f77e8$export$8beff7405d020ddf(response);
    return entity && 'liveEmbedUrl' in entity && typeof (entity === null || entity === void 0 ? void 0 : entity.liveEmbedUrl) === 'string' ? entity === null || entity === void 0 ? void 0 : entity.liveEmbedUrl : undefined;
};
var $239ddd54de5f77e8$export$ad879f2c9d5100a0 = function extractEntityProvider(response) {
    var _response$meta;
    if (!(response !== null && response !== void 0 && (_response$meta = response.meta) !== null && _response$meta !== void 0 && _response$meta.generator)) return undefined;
    var _ref = response.meta.generator, icon = _ref.icon, id = _ref.id, image = _ref.image, name = _ref.name;
    if (!name || !icon) throw Error('Link.generator requires a name and icon.');
    var providerIcon;
    switch(id){
        case 0, $i6ESA.CONFLUENCE_GENERATOR_ID:
            providerIcon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $bSdlY.ConfluenceIcon), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
                appearance: "brand"
            }, (0, $9Zzpd.fg)('navx-1895-new-logo-design') ? {
                shouldUseNewLogoDesign: true
            } : undefined, {
                size: "xxsmall"
            }));
            break;
        case 0, $i6ESA.JIRA_GENERATOR_ID:
            providerIcon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $8Tu2m.JiraIcon), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
                appearance: "brand"
            }, (0, $9Zzpd.fg)('navx-1895-new-logo-design') ? {
                shouldUseNewLogoDesign: true
            } : undefined, {
                size: "xxsmall"
            }));
            break;
        default:
            providerIcon = icon.url;
    }
    return {
        text: name,
        icon: providerIcon,
        id: id,
        image: image ? image : icon.url
    };
};
var $239ddd54de5f77e8$export$19346520e937a99f = function extractEntityIcon(response) {
    var entity = $239ddd54de5f77e8$export$8beff7405d020ddf(response);
    var url;
    if (entity) {
        var _response$meta$genera;
        url = 'iconUrl' in entity && typeof (entity === null || entity === void 0 ? void 0 : entity.iconUrl) === 'string' ? entity.iconUrl : response === null || response === void 0 || (_response$meta$genera = response.meta.generator) === null || _response$meta$genera === void 0 || (_response$meta$genera = _response$meta$genera.icon) === null || _response$meta$genera === void 0 ? void 0 : _response$meta$genera.url;
    }
    return {
        url: url,
        label: entity === null || entity === void 0 ? void 0 : entity.displayName
    };
};

});


parcelRegister("bCLMC", function(module, exports) {
$parcel$export(module.exports, "getByDefinitionId", () => $87684f095af8a242$export$f75b0b690ab4dfb9);
$parcel$export(module.exports, "getClickUrl", () => $87684f095af8a242$export$cf3c5acf9e9d0f02);
$parcel$export(module.exports, "getDefinitionId", () => $87684f095af8a242$export$46fa3e7718c82e41);
$parcel$export(module.exports, "getExtensionKey", () => $87684f095af8a242$export$218d96312e385949);
$parcel$export(module.exports, "getObjectAri", () => $87684f095af8a242$export$81164c1570bcd038);
$parcel$export(module.exports, "getThirdPartyARI", () => $87684f095af8a242$export$e029950864672b4);
$parcel$export(module.exports, "getFirstPartyIdentifier", () => $87684f095af8a242$export$48b4e58cdb8031ba);
$parcel$export(module.exports, "getObjectName", () => $87684f095af8a242$export$5615361d76a8be5);
$parcel$export(module.exports, "getObjectIconUrl", () => $87684f095af8a242$export$bcf275804417edda);
$parcel$export(module.exports, "getResourceType", () => $87684f095af8a242$export$16c0ebb0de9b767b);
$parcel$export(module.exports, "getServices", () => $87684f095af8a242$export$a009e3a1163d46fb);
$parcel$export(module.exports, "isFinalState", () => $87684f095af8a242$export$d590d08942abc17a);
$parcel$export(module.exports, "hasAuthScopeOverrides", () => $87684f095af8a242$export$3f9446bb21b945a0);

var $ekGgq = parcelRequire("ekGgq");

var $9Zzpd = parcelRequire("9Zzpd");

var $cJfQ6 = parcelRequire("cJfQ6");
var $87684f095af8a242$export$f75b0b690ab4dfb9 = function getByDefinitionId(definitionId, store) {
    var urls = Object.keys(store);
    return urls.filter(function(url) {
        var details = store[url].details;
        return details && details.meta.definitionId === definitionId;
    });
};
var $87684f095af8a242$export$cf3c5acf9e9d0f02 = function getClickUrl(url, jsonLd) {
    if (jsonLd && jsonLd.data) {
        var visitUrl = (0, $cJfQ6.extractVisitUrl)(jsonLd.data);
        if (visitUrl) return visitUrl;
    }
    return url;
};
var $87684f095af8a242$export$46fa3e7718c82e41 = function getDefinitionId(details) {
    var _details$meta;
    return details === null || details === void 0 || (_details$meta = details.meta) === null || _details$meta === void 0 ? void 0 : _details$meta.definitionId;
};
var $87684f095af8a242$export$218d96312e385949 = function getExtensionKey(details) {
    var _details$meta2;
    return details === null || details === void 0 || (_details$meta2 = details.meta) === null || _details$meta2 === void 0 ? void 0 : _details$meta2.key;
};
var $87684f095af8a242$export$81164c1570bcd038 = function getObjectAri(details) {
    return (details === null || details === void 0 ? void 0 : details.data) && 'atlassian:ari' in details.data && details.data['atlassian:ari'] || undefined;
};
var $87684f095af8a242$export$e029950864672b4 = function getThirdPartyARI(details) {
    if ((0, $9Zzpd.fg)('platform_smartlink_3pclick_analytics')) {
        if (details !== null && details !== void 0 && details.entityData && 'thirdPartyAri' in details.entityData && details.entityData.thirdPartyAri) return details.entityData.thirdPartyAri;
        if (details !== null && details !== void 0 && details.data && 'atlassian:ari' in details.data && typeof details.data['atlassian:ari'] === 'string') {
            var ari = details.data['atlassian:ari'];
            if (ari.includes('ari:third-party')) return ari;
        }
    }
    return undefined;
};
var $87684f095af8a242$export$48b4e58cdb8031ba = function getFirstPartyIdentifier() {
    if (!(0, $9Zzpd.fg)('platform_smartlink_3pclick_analytics')) return undefined;
    var product = $87684f095af8a242$var$getProductFromWindowURL();
    var currentURL = window.location.href;
    if (product === 'confluence') {
        if (currentURL.includes('content.id')) {
            var contentId = $87684f095af8a242$var$extractContentIdFromURL(currentURL);
            if (contentId) return "ConfluenceContentId:".concat(contentId);
        }
        var pageId = $87684f095af8a242$var$extractPageIdFromURL(currentURL);
        if (pageId) return "ConfluencePageId:".concat(pageId);
    } else if (product === 'jira') {
        var issueKey = $87684f095af8a242$var$extractJiraIssueIdFromURL(currentURL);
        if (issueKey) return "JiraIssueKey:".concat(issueKey);
    }
    return undefined;
};
var $87684f095af8a242$export$5615361d76a8be5 = function getObjectName(details) {
    return (details === null || details === void 0 ? void 0 : details.data) && 'name' in details.data && details.data.name || undefined;
};
var $87684f095af8a242$export$bcf275804417edda = function getObjectIconUrl(details) {
    if (details !== null && details !== void 0 && details.data && 'icon' in details.data && details.data.icon) {
        if ((0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(details.data.icon) === 'object' && 'url' in details.data.icon && details.data.icon.url && typeof details.data.icon.url === 'string') return details.data.icon.url;
    }
    return undefined;
};
var $87684f095af8a242$export$16c0ebb0de9b767b = function getResourceType(details) {
    var _details$meta3;
    return details === null || details === void 0 || (_details$meta3 = details.meta) === null || _details$meta3 === void 0 ? void 0 : _details$meta3.resourceType;
};
var $87684f095af8a242$export$e2005c9600188ac7 = function getProduct(details) {
    var _details$meta4;
    return details === null || details === void 0 || (_details$meta4 = details.meta) === null || _details$meta4 === void 0 ? void 0 : _details$meta4.product;
};
var $87684f095af8a242$export$f8fdefc70357968e = function getSubproduct(details) {
    var _details$meta5;
    return details === null || details === void 0 || (_details$meta5 = details.meta) === null || _details$meta5 === void 0 ? void 0 : _details$meta5.subproduct;
};
var $87684f095af8a242$export$a009e3a1163d46fb = function getServices(details) {
    return details && details.meta.auth || [];
};
var $87684f095af8a242$export$ac5d414b1ebfab5a = function hasResolved(details) {
    return details && $87684f095af8a242$export$cd41ae544cfc2a65(details) && $87684f095af8a242$export$795910f5f15a9633(details);
};
var $87684f095af8a242$export$cd41ae544cfc2a65 = function isAccessible(_ref) {
    var access = _ref.meta.access;
    return access === 'granted';
};
var $87684f095af8a242$export$795910f5f15a9633 = function isVisible(_ref2) {
    var visibility = _ref2.meta.visibility;
    return visibility === 'restricted' || visibility === 'public';
};
var $87684f095af8a242$export$a752a116d184ffbd = function getStatusDetails(details) {
    var _details$meta6;
    return details === null || details === void 0 || (_details$meta6 = details.meta) === null || _details$meta6 === void 0 || (_details$meta6 = _details$meta6.requestAccess) === null || _details$meta6 === void 0 ? void 0 : _details$meta6.accessType;
};
var $87684f095af8a242$export$d590d08942abc17a = function isFinalState(status) {
    return [
        'unauthorized',
        'forbidden',
        'errored',
        'resolved',
        'not_found'
    ].indexOf(status) > -1;
};
var $87684f095af8a242$export$66805b16d2a1da7c = function getDatasources(details) {
    return details === null || details === void 0 ? void 0 : details.datasources;
};
var $87684f095af8a242$export$ba6d13ab7b87c55c = function getCanBeDatasource(details) {
    var datasources = $87684f095af8a242$export$66805b16d2a1da7c(details);
    return !!datasources && datasources.length > 0;
};
var $87684f095af8a242$export$3f9446bb21b945a0 = function hasAuthScopeOverrides(details) {
    return !!(details !== null && details !== void 0 && details.meta.hasScopeOverrides);
};
// Helper function to extract page ID from standard Confluence page URLs
var $87684f095af8a242$var$extractPageIdFromURL = function extractPageIdFromURL(url) {
    try {
        var urlObj = new URL(url);
        // Following this pattern for confluence URL -> /wiki/spaces/{space}/pages/{pageId}/{title}
        var pagesMatch = urlObj.pathname.match(/\/wiki\/spaces\/[^\/]+\/pages\/(\d+)(?:\/|$)/);
        if (pagesMatch && pagesMatch[1]) return pagesMatch[1];
        // Following this pattern for confluence URL -> /wiki/pages/viewpage.action?pageId={pageId}
        var pageIdParam = urlObj.searchParams.get('pageId');
        if (pageIdParam) return pageIdParam;
        // Following this pattern for confluence URL -> /wiki/display/{space}/{pageId}
        var displayMatch = urlObj.pathname.match(/\/wiki\/display\/[^\/]+\/(\d+)/);
        if (displayMatch && displayMatch[1]) return displayMatch[1];
    } catch (_unused) {
        return undefined;
    }
    return undefined;
};
var $87684f095af8a242$var$extractContentIdFromURL = function extractContentIdFromURL(url) {
    try {
        var urlObj = new URL(url);
        // Pattern: ?content.id={contentId} (for app connector URLs and plugin servlet URLs)
        var contentId = urlObj.searchParams.get('content.id');
        if (contentId) return contentId;
        // Also support URLs where content.id is in the query string but not parsed by URL (edge case)
        // e.g., /wiki/plugins/servlet/ac/com.atlassian.perspectiveretros/perspective-retros?content.id=5662725850
        var match = url.match(/[?&]content\.id=(\d+)/);
        if (match && match[1]) return match[1];
    } catch (_unused2) {
        return undefined;
    }
    return undefined;
};
var $87684f095af8a242$var$extractJiraIssueIdFromURL = function extractJiraIssueIdFromURL(url) {
    try {
        var urlObj = new URL(url);
        // Support any case for Jira keys (e.g., AI3W-864, ai3w-864, Ai3W-864)
        var browseMatch = urlObj.pathname.match(/\/browse\/([A-Za-z0-9]+-\d+)/);
        if (browseMatch && browseMatch[1]) return browseMatch[1];
        // /jira/browse/{issueKey}
        var jiraBrowseMatch = urlObj.pathname.match(/\/jira\/browse\/([A-Za-z0-9]+-\d+)/);
        if (jiraBrowseMatch && jiraBrowseMatch[1]) return jiraBrowseMatch[1];
        // Query parameter ?selectedIssue={issueKey}
        var selectedIssue = urlObj.searchParams.get('selectedIssue');
        if (selectedIssue && /^[A-Za-z0-9]+-\d+$/.test(selectedIssue)) return selectedIssue;
        // Query parameter ?issueKey={issueKey}
        var issueKeyParam = urlObj.searchParams.get('issueKey');
        if (issueKeyParam && /^[A-Za-z0-9]+-\d+$/.test(issueKeyParam)) return issueKeyParam;
    } catch (_unused3) {
        return undefined;
    }
    return undefined;
};
var $87684f095af8a242$var$getProductFromWindowURL = function getProductFromWindowURL() {
    try {
        var currentUrl = window.location.href;
        var urlObj = new URL(currentUrl);
        var hostname = urlObj.hostname.toLowerCase();
        var pathname = urlObj.pathname.toLowerCase();
        // Check for Confluence patterns
        if (hostname.includes('confluence') || pathname.includes('/wiki/') || pathname.includes('/display/') || pathname.includes('/spaces/')) return 'confluence';
        // Check for Jira patterns
        if (hostname.includes('jira') || pathname.includes('/browse/') || pathname.includes('/projects/') || pathname.includes('/secure/')) return 'jira';
    } catch (_unused4) {
        return undefined;
    }
    return undefined;
};

});
parcelRegister("cJfQ6", function(module, exports) {
$parcel$export(module.exports, "extractVisitUrl", () => $9445f95e8e1aa9c9$export$c81497d3681f24f4);
var $9445f95e8e1aa9c9$export$c81497d3681f24f4 = function extractVisitUrl(jsonLd) {
    return jsonLd['atlassian:visitUrl'];
};

});


parcelRegister("96IWe", function(module, exports) {
$parcel$export(module.exports, "useAnalyticsEvents", () => $6a1788687212c434$export$5bf35293e545f20c);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 *
 * Generates Typescript types for analytics events from analytics.spec.yaml
 *
 * @codegen <<SignedSource::676f76a2e45920437adc8c35a9af8b37>>
 * @codegenCommand yarn workspace @atlassian/analytics-tooling run analytics:codegen smart-card
 */ 
var $5FkrB = parcelRequire("5FkrB");

var $cOsWw = parcelRequire("cOsWw");

var $jCYzm = parcelRequire("jCYzm");

var $aZSNw = parcelRequire("aZSNw");
var $6a1788687212c434$export$5bf35293e545f20c = function useAnalyticsEvents() {
    var _useAnalyticsNextEven = (0, $cOsWw.useAnalyticsEvents)(), createAnalyticsEvent = _useAnalyticsNextEven.createAnalyticsEvent;
    var fireEvent = (0, $5FkrB.useCallback)(function() {
        var event = createAnalyticsEvent((0, $aZSNw.default).apply(void 0, arguments));
        event.fire((0, $jCYzm.EVENT_CHANNEL));
    }, [
        createAnalyticsEvent
    ]);
    return {
        fireEvent: fireEvent
    };
};

});
parcelRegister("jCYzm", function(module, exports) {
$parcel$export(module.exports, "EVENT_CHANNEL", () => $e4a08cbb891afb3e$export$3f072f06b90c3985);
var $e4a08cbb891afb3e$export$3f072f06b90c3985 = 'media';

});

parcelRegister("aZSNw", function(module, exports) {
$parcel$export(module.exports, "default", () => $801a1b94db6f8f4f$export$2e2bcd8739ae039);

var $iYJcE = parcelRequire("iYJcE");
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 *
 * Generates Typescript types for analytics events from analytics.spec.yaml
 *
 * @codegen <<SignedSource::f914fb83fac56e7154ef460866628f7d>>
 * @codegenCommand yarn workspace @atlassian/analytics-tooling run analytics:codegen smart-card
 */ var $801a1b94db6f8f4f$var$createEventPayload = function createEventPayload(eventKey) {
    for(var _len = arguments.length, _ref = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)_ref[_key - 1] = arguments[_key];
    var attributes = _ref[0];
    var _eventKey$split = eventKey.split('.'), _eventKey$split2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_eventKey$split, 4), eventType = _eventKey$split2[0], actionSubject = _eventKey$split2[1], action = _eventKey$split2[2], actionSubjectId = _eventKey$split2[3];
    if (eventType === 'screen') return {
        eventType: eventType,
        name: actionSubject,
        action: 'viewed',
        attributes: attributes
    };
    return {
        eventType: eventType,
        actionSubject: actionSubject,
        action: action,
        actionSubjectId: actionSubjectId,
        attributes: attributes
    };
};
var $801a1b94db6f8f4f$export$2e2bcd8739ae039 = $801a1b94db6f8f4f$var$createEventPayload;

});


parcelRegister("1Bpy8", function(module, exports) {
$parcel$export(module.exports, "clearMarks", () => $12ad10c2a1fc90f6$export$1a717feb4df1a945);
$parcel$export(module.exports, "clearMeasures", () => $12ad10c2a1fc90f6$export$de42547d395c8271);
$parcel$export(module.exports, "getMeasure", () => $12ad10c2a1fc90f6$export$d6e97a903ae9a3aa);
$parcel$export(module.exports, "mark", () => $12ad10c2a1fc90f6$export$bf7f2fce5c1cf636);
$parcel$export(module.exports, "create", () => $12ad10c2a1fc90f6$export$185802fd694ee1f5);
var $12ad10c2a1fc90f6$var$isPerformanceAPIAvailable = function isPerformanceAPIAvailable() {
    return typeof window !== 'undefined' && 'performance' in window && [
        'measure',
        'clearMeasures',
        'clearMarks',
        'getEntriesByName',
        'getEntriesByType'
    ].every(function(api) {
        return !!performance[api];
    });
};
var $12ad10c2a1fc90f6$var$hasPerformanceAPIAvailable = $12ad10c2a1fc90f6$var$isPerformanceAPIAvailable();
var $12ad10c2a1fc90f6$export$fcff3185c7ce7f2b = function getMarkName(id, status) {
    return "".concat(status, ":").concat(id);
};
var $12ad10c2a1fc90f6$export$984df7f61dd7928f = function getMeasureName(id, status) {
    return "time-to-".concat(status, ":").concat(id);
};
var $12ad10c2a1fc90f6$export$1a717feb4df1a945 = function clearMarks(id) {
    if ($12ad10c2a1fc90f6$var$hasPerformanceAPIAvailable) {
        var marks = performance.getEntriesByType('mark').filter(function(mark) {
            return mark.name.includes(id);
        });
        marks.forEach(function(mark) {
            return performance.clearMarks(mark.name);
        });
    }
};
var $12ad10c2a1fc90f6$export$de42547d395c8271 = function clearMeasures(id) {
    if ($12ad10c2a1fc90f6$var$hasPerformanceAPIAvailable) {
        var measures = performance.getEntriesByType('measure').filter(function(measure) {
            return measure.name.includes(id);
        });
        measures.forEach(function(measure) {
            return performance.clearMeasures(measure.name);
        });
    }
};
var $12ad10c2a1fc90f6$var$getMark = function getMark(id, status) {
    if ($12ad10c2a1fc90f6$var$hasPerformanceAPIAvailable) {
        var name = $12ad10c2a1fc90f6$export$fcff3185c7ce7f2b(id, status);
        var marks = performance.getEntriesByName(name);
        if (marks.length > 0) return marks[0];
        return undefined;
    }
};
var $12ad10c2a1fc90f6$export$d6e97a903ae9a3aa = function getMeasure(id, status) {
    if ($12ad10c2a1fc90f6$var$hasPerformanceAPIAvailable) {
        var name = $12ad10c2a1fc90f6$export$984df7f61dd7928f(id, status);
        var measures = performance.getEntriesByName(name);
        if (measures.length > 0) return measures[0];
        return undefined;
    }
};
var $12ad10c2a1fc90f6$export$bf7f2fce5c1cf636 = function mark(id, status) {
    if ($12ad10c2a1fc90f6$var$hasPerformanceAPIAvailable) {
        var name = $12ad10c2a1fc90f6$export$fcff3185c7ce7f2b(id, status);
        performance.mark(name);
    }
};
var $12ad10c2a1fc90f6$export$185802fd694ee1f5 = function create(id, status) {
    if ($12ad10c2a1fc90f6$var$hasPerformanceAPIAvailable) {
        var name = $12ad10c2a1fc90f6$export$984df7f61dd7928f(id, status);
        var measure = $12ad10c2a1fc90f6$export$d6e97a903ae9a3aa(id, status);
        if (!measure) {
            var startMark = $12ad10c2a1fc90f6$var$getMark(id, 'pending');
            var endMark = $12ad10c2a1fc90f6$var$getMark(id, status);
            if (startMark && endMark) performance.measure(name, startMark.name, endMark.name);
        }
    }
};

});

parcelRegister("g8q8G", function(module, exports) {
$parcel$export(module.exports, "useSmartCardActions", () => $bbf1ab5ebd8fa76c$export$f7c340395f31e832);

var $fL8KA = parcelRequire("fL8KA");

var $6HG4S = parcelRequire("6HG4S");

var $5FkrB = parcelRequire("5FkrB");

var $8dj3L = parcelRequire("8dj3L");

var $9kTNw = parcelRequire("9kTNw");

var $iNBng = parcelRequire("iNBng");

var $lVeMA = parcelRequire("lVeMA");

var $96IWe = parcelRequire("96IWe");

var $fXlyu = parcelRequire("fXlyu");

var $fq7gV = parcelRequire("fq7gV");

var $hZBUK = parcelRequire("hZBUK");

var $bCLMC = parcelRequire("bCLMC");

var $9ULzi = parcelRequire("9ULzi");

var $186iK = parcelRequire("186iK");
var $bbf1ab5ebd8fa76c$export$f7c340395f31e832 = function useSmartCardActions(id, url) {
    var resolveUrl = (0, $186iK.default)();
    var invokeClientAction = (0, $9ULzi.default)({});
    var _useAnalyticsEvents = (0, $96IWe.useAnalyticsEvents)(), fireEvent = _useAnalyticsEvents.fireEvent;
    var _useSmartLinkContext = (0, $9kTNw.useSmartLinkContext)(), store = _useSmartLinkContext.store;
    var getState = store.getState, dispatch = store.dispatch;
    var getSmartLinkState = (0, $5FkrB.useCallback)(function() {
        var _getState$url;
        var _ref = (_getState$url = getState()[url]) !== null && _getState$url !== void 0 ? _getState$url : {
            status: (0, $fXlyu.SmartLinkStatus).Pending
        }, details = _ref.details, status = _ref.status, metadataStatus = _ref.metadataStatus;
        return {
            details: details,
            status: status,
            metadataStatus: metadataStatus
        };
    }, [
        getState,
        url
    ]);
    var setMetadataStatus = (0, $5FkrB.useCallback)(function(metadataStatus) {
        dispatch((0, $iNBng.cardAction)((0, $iNBng.ACTION_UPDATE_METADATA_STATUS), {
            url: url
        }, undefined, undefined, metadataStatus));
    }, [
        dispatch,
        url
    ]);
    var resolve = (0, $5FkrB.useCallback)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee() {
        var resourceUrl, isReloading, isMetadataRequest, _args = arguments;
        return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee$(_context) {
            while(true)switch(_context.prev = _context.next){
                case 0:
                    resourceUrl = _args.length > 0 && _args[0] !== undefined ? _args[0] : url;
                    isReloading = _args.length > 1 && _args[1] !== undefined ? _args[1] : false;
                    isMetadataRequest = _args.length > 2 && _args[2] !== undefined ? _args[2] : false;
                    return _context.abrupt("return", resolveUrl(resourceUrl, isReloading, isMetadataRequest, id));
                case 4:
                case "end":
                    return _context.stop();
            }
        }, _callee);
    })), [
        id,
        resolveUrl,
        url
    ]);
    var register = (0, $5FkrB.useCallback)(function() {
        var _getSmartLinkState = getSmartLinkState(), details = _getSmartLinkState.details;
        if (!details) {
            dispatch((0, $iNBng.cardAction)((0, $iNBng.ACTION_RESOLVING), {
                url: url
            }));
            setMetadataStatus('pending');
        }
        return resolve();
    }, [
        getSmartLinkState,
        resolve,
        dispatch,
        url,
        setMetadataStatus
    ]);
    var reload = (0, $5FkrB.useCallback)(function() {
        var _getSmartLinkState2 = getSmartLinkState(), details = _getSmartLinkState2.details;
        var definitionId = (0, $bCLMC.getDefinitionId)(details);
        if (definitionId) (0, $bCLMC.getByDefinitionId)(definitionId, getState()).map(function(url) {
            return resolve(url, true);
        });
        else resolve(url, true);
    }, [
        getSmartLinkState,
        url,
        getState,
        resolve
    ]);
    var loadMetadata = (0, $5FkrB.useCallback)(function() {
        var _getSmartLinkState3 = getSmartLinkState(), metadataStatus = _getSmartLinkState3.metadataStatus;
        //metadataStatus will be undefined for SSR links only
        if (metadataStatus === undefined) {
            setMetadataStatus('pending');
            return resolve(url, false, true);
        }
    }, [
        getSmartLinkState,
        resolve,
        setMetadataStatus,
        url
    ]);
    var authorize = (0, $5FkrB.useCallback)(function(appearance) {
        var _getSmartLinkState4 = getSmartLinkState(), details = _getSmartLinkState4.details, status = _getSmartLinkState4.status;
        var definitionId = (0, $bCLMC.getDefinitionId)(details);
        var extensionKey = (0, $bCLMC.getExtensionKey)(details);
        var services = (0, $bCLMC.getServices)(details);
        // When authentication is triggered, let GAS know!
        if (status === 'unauthorized') fireEvent('ui.button.clicked.connectAccount', {
            display: appearance,
            definitionId: definitionId !== null && definitionId !== void 0 ? definitionId : null
        });
        if (status === 'forbidden') fireEvent('ui.smartLink.clicked.tryAnotherAccount', {
            display: appearance,
            definitionId: definitionId !== null && definitionId !== void 0 ? definitionId : null
        });
        if (services.length > 0) {
            fireEvent('screen.consentModal.viewed', {
                definitionId: definitionId !== null && definitionId !== void 0 ? definitionId : null
            });
            var shouldShowInPopupWindow = status === 'unauthorized' && (0, $8dj3L.default).getExperimentValue('platform_sl_3p_auth_window_experiment', 'cohort', 'control') === 'test';
            var windowFeatures = shouldShowInPopupWindow ? (0, $fq7gV.getWindowOpenFeatures)((0, $fq7gV.AUTH_WINDOW_HEIGHT), (0, $fq7gV.AUTH_WINDOW_WIDTH)) : undefined;
            (0, $lVeMA.auth)(services[0].url, windowFeatures).then(function() {
                fireEvent('track.applicationAccount.connected', {
                    definitionId: definitionId !== null && definitionId !== void 0 ? definitionId : null
                });
                (0, $hZBUK.startUfoExperience)('smart-link-authenticated', id, {
                    extensionKey: extensionKey,
                    status: 'success'
                });
                fireEvent('operational.smartLink.connectSucceeded', {
                    definitionId: definitionId !== null && definitionId !== void 0 ? definitionId : null
                });
                reload();
            }, function(err) {
                var _err$type;
                (0, $hZBUK.startUfoExperience)('smart-link-authenticated', id, {
                    extensionKey: extensionKey,
                    status: err.type
                });
                fireEvent('operational.smartLink.connectFailed', {
                    definitionId: definitionId !== null && definitionId !== void 0 ? definitionId : null,
                    reason: (_err$type = err.type) !== null && _err$type !== void 0 ? _err$type : null
                });
                if (err.type === 'auth_window_closed') fireEvent('ui.consentModal.closed', {
                    display: appearance,
                    definitionId: definitionId !== null && definitionId !== void 0 ? definitionId : null
                });
                reload();
            });
        }
    }, [
        getSmartLinkState,
        id,
        reload,
        fireEvent
    ]);
    var invoke = (0, $5FkrB.useCallback)(/*#__PURE__*/ function() {
        var _ref3 = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee2(opts, appearance) {
            var key, action, source;
            return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee2$(_context2) {
                while(true)switch(_context2.prev = _context2.next){
                    case 0:
                        key = opts.key, action = opts.action;
                        source = opts.source || appearance;
                        if (!(opts.type === 'client')) {
                            _context2.next = 6;
                            break;
                        }
                        _context2.next = 5;
                        return invokeClientAction({
                            actionFn: opts.action.promise,
                            actionType: action.type,
                            display: source,
                            extensionKey: key
                        });
                    case 5:
                        return _context2.abrupt("return", _context2.sent);
                    case 6:
                    case "end":
                        return _context2.stop();
                }
            }, _callee2);
        }));
        return function(_x, _x2) {
            return _ref3.apply(this, arguments);
        };
    }(), [
        invokeClientAction
    ]);
    return (0, $5FkrB.useMemo)(function() {
        return {
            register: register,
            reload: reload,
            authorize: authorize,
            invoke: invoke,
            loadMetadata: loadMetadata
        };
    }, [
        register,
        reload,
        authorize,
        invoke,
        loadMetadata
    ]);
};

});
parcelRegister("9kTNw", function(module, exports) {
$parcel$export(module.exports, "SmartCardContext", () => $6cc14395f5da269b$export$156b523e63b4f63a);
$parcel$export(module.exports, "useSmartLinkContext", () => $6cc14395f5da269b$export$e1d190b530cf0ee9);
$parcel$export(module.exports, "useSmartCardContext", () => $6cc14395f5da269b$export$10e9cca30e50f657);

var $5FkrB = parcelRequire("5FkrB");

var $6cc14395f5da269b$export$156b523e63b4f63a = /*#__PURE__*/ (0, $5FkrB.createContext)(undefined);
function $6cc14395f5da269b$export$e1d190b530cf0ee9() {
    var context = (0, $5FkrB.useContext)($6cc14395f5da269b$export$156b523e63b4f63a);
    if (!context) throw Error('useSmartCard() must be wrapped in <SmartCardProvider>');
    return context;
}
var $6cc14395f5da269b$export$10e9cca30e50f657 = function useSmartCardContext() {
    return $6cc14395f5da269b$var$useContextMemoized($6cc14395f5da269b$export$156b523e63b4f63a);
};
var $6cc14395f5da269b$export$797e3658f090919c = function EditorSmartCardProviderValueGuard(_ref) {
    var children = _ref.children;
    var cardContext = $6cc14395f5da269b$export$10e9cca30e50f657();
    if (!(cardContext !== null && cardContext !== void 0 && cardContext.value)) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).Fragment, null, children);
};
function $6cc14395f5da269b$var$useContextMemoized(reactContext) {
    var value = (0, $5FkrB.useContext)(reactContext);
    var context = (0, $5FkrB.useMemo)(function() {
        return {
            Provider: reactContext.Provider,
            Consumer: reactContext.Consumer,
            value: value
        };
    }, [
        value,
        reactContext
    ]);
    return context;
}
var $6cc14395f5da269b$export$2a29ca11e08dc129 = function EditorSmartCardProvider(_ref2) {
    var children = _ref2.children;
    var cardContext = $6cc14395f5da269b$export$10e9cca30e50f657();
    var Provider = cardContext.Provider;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(Provider, {
        value: cardContext.value
    }, children);
};
var $6cc14395f5da269b$export$2e2bcd8739ae039 = $6cc14395f5da269b$export$156b523e63b4f63a;

});

parcelRegister("iNBng", function(module, exports) {
$parcel$export(module.exports, "ACTION_RESOLVING", () => $daf9cb5194d44a1f$export$9a6a932a0a39498e);
$parcel$export(module.exports, "ACTION_RESOLVED", () => $daf9cb5194d44a1f$export$63ec8bc7a8a75482);
$parcel$export(module.exports, "ACTION_RELOADING", () => $daf9cb5194d44a1f$export$b8cfaa842c9ab487);
$parcel$export(module.exports, "ACTION_ERROR", () => $daf9cb5194d44a1f$export$6d8ed3f9433dd372);
$parcel$export(module.exports, "ACTION_ERROR_FALLBACK", () => $daf9cb5194d44a1f$export$cfbbb7126bc8a0c6);
$parcel$export(module.exports, "ACTION_UPDATE_METADATA_STATUS", () => $daf9cb5194d44a1f$export$2c5edb971b673330);
$parcel$export(module.exports, "cardAction", () => $daf9cb5194d44a1f$export$a884a52152489cc3);
// TODO: eventually move this file to @atlaskit/link-actions
var $daf9cb5194d44a1f$export$6e470aad5ba8952e = 'pending';
var $daf9cb5194d44a1f$export$9a6a932a0a39498e = 'resolving';
var $daf9cb5194d44a1f$export$63ec8bc7a8a75482 = 'resolved';
var $daf9cb5194d44a1f$export$b8cfaa842c9ab487 = 'reloading';
var $daf9cb5194d44a1f$export$6d8ed3f9433dd372 = 'errored';
var $daf9cb5194d44a1f$export$cfbbb7126bc8a0c6 = 'fallback';
var $daf9cb5194d44a1f$export$76b5c1aca20759c6 = 'preload';
var $daf9cb5194d44a1f$export$2c5edb971b673330 = 'metadata';
var $daf9cb5194d44a1f$export$a884a52152489cc3 = function cardAction(type, _ref, payload, error, metadataStatus, ignoreStatusCheck) {
    var url = _ref.url;
    return {
        type: type,
        url: url,
        payload: payload,
        error: error,
        metadataStatus: metadataStatus,
        ignoreStatusCheck: ignoreStatusCheck
    };
};

});

parcelRegister("lVeMA", function(module, exports) {
$parcel$export(module.exports, "auth", () => $ff5a635efd528715$export$73693bad9f5880b0);
$parcel$export(module.exports, "AuthError", () => (parcelRequire("2EfRC")).AuthError);

var $ekGgq = parcelRequire("ekGgq");

var $2EfRC = parcelRequire("2EfRC");

var $imQ9z = parcelRequire("imQ9z");
function $ff5a635efd528715$export$73693bad9f5880b0(startUrl, windowFeatures) {
    return new Promise(function(resolve, reject) {
        var authWindow = null;
        var authWindowInterval;
        var handleAuthWindowMessage = function handleAuthWindowMessage(event) {
            if (event.source !== authWindow) return;
            var data = event.data;
            if ((0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(data) !== 'object') return;
            switch(data.type){
                case 'outbound-auth:success':
                    finish();
                    resolve();
                    break;
                case 'outbound-auth:failure':
                    finish();
                    var errorType = data.errorType.toLowerCase();
                    if ((0, $imQ9z.isOfTypeAuthError)(errorType)) reject(new (0, $2EfRC.AuthError)(data.message, errorType));
                    else reject(new (0, $2EfRC.AuthError)(data.message));
                    break;
            }
        };
        var handleAuthWindowInterval = function handleAuthWindowInterval() {
            if (authWindow && authWindow.closed) {
                finish();
                reject(new (0, $2EfRC.AuthError)('The auth window was closed', 'auth_window_closed'));
            }
        };
        var start = function start() {
            window.addEventListener('message', handleAuthWindowMessage);
            authWindow = window.open(startUrl, startUrl, windowFeatures);
            authWindowInterval = window.setInterval(handleAuthWindowInterval, 500);
        };
        var finish = function finish() {
            clearInterval(authWindowInterval);
            window.removeEventListener('message', handleAuthWindowMessage);
            if (authWindow) {
                authWindow.close();
                authWindow = null;
            }
        };
        start();
    });
}

});
parcelRegister("2EfRC", function(module, exports) {
$parcel$export(module.exports, "AuthError", () => $1edb9f68b30de640$export$145273558d58e0ac);

var $arMYe = parcelRequire("arMYe");

var $9P61R = parcelRequire("9P61R");

var $eyuDe = parcelRequire("eyuDe");

var $kIXpt = parcelRequire("kIXpt");

var $cYPzS = parcelRequire("cYPzS");

var $c7s0H = parcelRequire("c7s0H");
function $1edb9f68b30de640$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $1edb9f68b30de640$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, (/*@__PURE__*/$parcel$interopDefault($kIXpt)))(this, result);
    };
}
function $1edb9f68b30de640$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($1edb9f68b30de640$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $1edb9f68b30de640$export$145273558d58e0ac = /*#__PURE__*/ function(_Error) {
    (0, (/*@__PURE__*/$parcel$interopDefault($eyuDe)))(AuthError, _Error);
    var _super = $1edb9f68b30de640$var$_createSuper(AuthError);
    function AuthError(message, type) {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, AuthError);
        _this = _super.call(this, message);
        _this.message = message;
        _this.type = type;
        _this.name = 'AuthError';
        _this.type = type;
        _this.message = message;
        return _this;
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(AuthError);
}(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($c7s0H)))(Error));

});

parcelRegister("imQ9z", function(module, exports) {
$parcel$export(module.exports, "isOfTypeAuthError", () => $d5f2bca406531d6c$export$400e64c8451aa84f);
// See https://tools.ietf.org/html/rfc6749#section-4.1.2.1
// 'auth_window_closed' is returned in addition to types from this RFC,
// representing when the authentication window is closed by the user
// 'authclientoauth2.autherror' is added to represent errors from
// outbound-auth
var $d5f2bca406531d6c$export$400e64c8451aa84f = function isOfTypeAuthError(inputString) {
    return [
        'auth_window_closed',
        'invalid_request',
        'unauthorized_client',
        'access_denied',
        'unsupported_response_type',
        'invalid_scope',
        'server_error',
        'temporarily_unavailable',
        'authclientoauth2.autherror'
    ].includes(inputString);
};

});


parcelRegister("fXlyu", function(module, exports) {
$parcel$export(module.exports, "CONTENT_URL_SECURITY_AND_PERMISSIONS", () => $b9dd161ee11f453b$export$5c881701926acbef);
$parcel$export(module.exports, "CONTENT_URL_3P_ACCOUNT_AUTH", () => $b9dd161ee11f453b$export$93d67ab022d9f8d2);
$parcel$export(module.exports, "CONTENT_URL_AI", () => $b9dd161ee11f453b$export$70d24f0465ae60f8);
$parcel$export(module.exports, "CONTENT_URL_AI_TROUBLESHOOTING", () => $b9dd161ee11f453b$export$a3ed5c4e9d9599b7);
$parcel$export(module.exports, "CONTENT_URL_ACCEPTABLE_USE_POLICY", () => $b9dd161ee11f453b$export$73b198e73554a323);
$parcel$export(module.exports, "SmartLinkAlignment", () => $b9dd161ee11f453b$export$8910bf86027fe6be);
$parcel$export(module.exports, "SmartLinkDirection", () => $b9dd161ee11f453b$export$60831686b0574c86);
$parcel$export(module.exports, "SmartLinkPosition", () => $b9dd161ee11f453b$export$d58e6377644d1dcf);
$parcel$export(module.exports, "SmartLinkSize", () => $b9dd161ee11f453b$export$51f13ced115cbdae);
$parcel$export(module.exports, "SmartLinkStatus", () => $b9dd161ee11f453b$export$61cff06be26816f);
$parcel$export(module.exports, "SmartLinkTheme", () => $b9dd161ee11f453b$export$aed0f1e801ad691f);
$parcel$export(module.exports, "SmartLinkInternalTheme", () => $b9dd161ee11f453b$export$9aafec380d7005da);
$parcel$export(module.exports, "SmartLinkWidth", () => $b9dd161ee11f453b$export$19c60054ee783de6);
$parcel$export(module.exports, "ElementName", () => $b9dd161ee11f453b$export$d65b168331104a46);
$parcel$export(module.exports, "ActionName", () => $b9dd161ee11f453b$export$9c95d6e1614bad84);
$parcel$export(module.exports, "InternalActionName", () => $b9dd161ee11f453b$export$4871a84b35cf8eb9);
$parcel$export(module.exports, "IconType", () => $b9dd161ee11f453b$export$13ff1290a9e22e77);
$parcel$export(module.exports, "MediaType", () => $b9dd161ee11f453b$export$483c11740a902fcd);
$parcel$export(module.exports, "MediaPlacement", () => $b9dd161ee11f453b$export$f9f4737e25ab90fa);
$parcel$export(module.exports, "CardDisplay", () => $b9dd161ee11f453b$export$6ca4ef8b3dc2c804);
var $b9dd161ee11f453b$export$5c881701926acbef = 'https://support.atlassian.com/confluence-cloud/docs/insert-links-and-anchors/#Smart-links';
var $b9dd161ee11f453b$export$93d67ab022d9f8d2 = 'https://support.atlassian.com/confluence-cloud/docs/what-data-is-sent-and-received-when-pasting-a-smart-link/';
var $b9dd161ee11f453b$export$70d24f0465ae60f8 = 'https://www.atlassian.com/trust/atlassian-intelligence';
var $b9dd161ee11f453b$export$a3ed5c4e9d9599b7 = 'https://status.atlassian.com/';
var $b9dd161ee11f453b$export$73b198e73554a323 = 'https://www.atlassian.com/legal/acceptable-use-policy';
var $b9dd161ee11f453b$export$8910bf86027fe6be = /*#__PURE__*/ function(SmartLinkAlignment) {
    SmartLinkAlignment["Left"] = "left";
    SmartLinkAlignment["Right"] = "right";
    return SmartLinkAlignment;
}({});
var $b9dd161ee11f453b$export$60831686b0574c86 = /*#__PURE__*/ function(SmartLinkDirection) {
    SmartLinkDirection["Horizontal"] = "horizontal";
    SmartLinkDirection["Vertical"] = "vertical";
    return SmartLinkDirection;
}({});
var $b9dd161ee11f453b$export$d58e6377644d1dcf = /*#__PURE__*/ function(SmartLinkPosition) {
    SmartLinkPosition["Top"] = "top";
    SmartLinkPosition["Center"] = "center";
    return SmartLinkPosition;
}({});
var $b9dd161ee11f453b$export$51f13ced115cbdae = /*#__PURE__*/ function(SmartLinkSize) {
    SmartLinkSize["XLarge"] = "xlarge";
    SmartLinkSize["Large"] = "large";
    SmartLinkSize["Medium"] = "medium";
    SmartLinkSize["Small"] = "small";
    return SmartLinkSize;
}({});
var $b9dd161ee11f453b$export$61cff06be26816f = /*#__PURE__*/ function(SmartLinkStatus) {
    SmartLinkStatus["Pending"] = "pending";
    SmartLinkStatus["Resolving"] = "resolving";
    SmartLinkStatus["Resolved"] = "resolved";
    SmartLinkStatus["Forbidden"] = "forbidden";
    SmartLinkStatus["Errored"] = "errored";
    SmartLinkStatus["NotFound"] = "not_found";
    SmartLinkStatus["Unauthorized"] = "unauthorized";
    SmartLinkStatus["Fallback"] = "fallback";
    return SmartLinkStatus;
}({});
var $b9dd161ee11f453b$export$aed0f1e801ad691f = /*#__PURE__*/ function(SmartLinkTheme) {
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
    SmartLinkTheme["Black"] = "black";
    SmartLinkTheme["Link"] = "link";
    return SmartLinkTheme;
}({});
var $b9dd161ee11f453b$export$9aafec380d7005da = /*#__PURE__*/ function(SmartLinkInternalTheme) {
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
    SmartLinkInternalTheme["Grey"] = "grey";
    return SmartLinkInternalTheme;
}({});
var $b9dd161ee11f453b$export$19c60054ee783de6 = /*#__PURE__*/ function(SmartLinkWidth) {
    SmartLinkWidth["FitToContent"] = "fit-to-content";
    SmartLinkWidth["Flexible"] = "flexible";
    return SmartLinkWidth;
}({});
var $b9dd161ee11f453b$export$d65b168331104a46 = /*#__PURE__*/ function(ElementName) {
    ElementName["AppliedToComponentsCount"] = "AppliedToComponentsCount";
    ElementName["AssignedTo"] = "AssignedTo";
    ElementName["AssignedToGroup"] = "AssignedToGroup";
    ElementName["AttachmentCount"] = "AttachmentCount";
    ElementName["AuthorGroup"] = "AuthorGroup";
    ElementName["ChecklistProgress"] = "ChecklistProgress";
    ElementName["CollaboratorGroup"] = "CollaboratorGroup";
    ElementName["CommentCount"] = "CommentCount";
    ElementName["CreatedBy"] = "CreatedBy";
    ElementName["CreatedOn"] = "CreatedOn";
    ElementName["DueOn"] = "DueOn";
    ElementName["LatestCommit"] = "LatestCommit";
    ElementName["LinkIcon"] = "LinkIcon";
    ElementName["Location"] = "Location";
    ElementName["ModifiedBy"] = "ModifiedBy";
    ElementName["ModifiedOn"] = "ModifiedOn";
    ElementName["OwnedBy"] = "OwnedBy";
    ElementName["OwnedByGroup"] = "OwnedByGroup";
    ElementName["Preview"] = "Preview";
    ElementName["Priority"] = "Priority";
    ElementName["ProgrammingLanguage"] = "ProgrammingLanguage";
    ElementName["Provider"] = "Provider";
    ElementName["ReactCount"] = "ReactCount";
    ElementName["ReadTime"] = "ReadTime";
    ElementName["Snippet"] = "Snippet";
    ElementName["SourceBranch"] = "SourceBranch";
    ElementName["State"] = "State";
    ElementName["SubscriberCount"] = "SubscriberCount";
    ElementName["SubTasksProgress"] = "SubTasksProgress";
    ElementName["StoryPoints"] = "StoryPoints";
    ElementName["TargetBranch"] = "TargetBranch";
    ElementName["TeamMemberCount"] = "TeamMemberCount";
    ElementName["Title"] = "Title";
    ElementName["UserAttributes"] = "UserAttributes";
    ElementName["ViewCount"] = "ViewCount";
    ElementName["VoteCount"] = "VoteCount";
    ElementName["SentOn"] = "SentOn";
    ElementName["HostName"] = "HostName";
    return ElementName;
}({});
var $b9dd161ee11f453b$export$9c95d6e1614bad84 = /*#__PURE__*/ function(ActionName) {
    ActionName["CopyLinkAction"] = "CopyLinkAction";
    ActionName["DeleteAction"] = "DeleteAction";
    ActionName["EditAction"] = "EditAction";
    ActionName["FollowAction"] = "FollowAction";
    ActionName["PreviewAction"] = "PreviewAction";
    ActionName["AutomationAction"] = "AutomationAction";
    ActionName["DownloadAction"] = "DownloadAction";
    ActionName["CustomAction"] = "CustomAction";
    return ActionName;
}({});
var $b9dd161ee11f453b$export$4871a84b35cf8eb9 = /*#__PURE__*/ function(InternalActionName) {
    InternalActionName["AISummaryAction"] = "AISummaryAction";
    InternalActionName["UnresolvedAction"] = "UnresolvedAction";
    InternalActionName["ViewRelatedLinksAction"] = "ViewRelatedLinksAction";
    return InternalActionName;
}({});
var $b9dd161ee11f453b$export$13ff1290a9e22e77 = /*#__PURE__*/ function(IconType) {
    IconType["Archive"] = "FileType:Archive";
    IconType["Audio"] = "FileType:Audio";
    IconType["Blog"] = "FileType:Blog";
    IconType["Code"] = "FileType:Code";
    IconType["Document"] = "FileType:Document";
    IconType["Executable"] = "FileType:Executable";
    IconType["File"] = "FileType:File";
    IconType["Folder"] = "FileType:Folder";
    IconType["Generic"] = "FileType:Generic";
    IconType["GIF"] = "FileType:GIF";
    IconType["GoogleDocs"] = "FileType:GoogleDocs";
    IconType["GoogleForms"] = "FileType:GoogleForms";
    IconType["GoogleSheets"] = "FileType:GoogleSheets";
    IconType["GoogleSlides"] = "FileType:GoogleSlides";
    IconType["Image"] = "FileType.Image";
    IconType["MSExcel"] = "FileType:Excel";
    IconType["MSPowerpoint"] = "FileType:Powerpoint";
    IconType["MSWord"] = "FileType:WordDocument";
    IconType["PDF"] = "FileType:PDF";
    IconType["Presentation"] = "FileType:Presentation";
    IconType["Sketch"] = "FileType:Sketch";
    IconType["Spreadsheet"] = "FileType:Spreadsheet";
    IconType["Template"] = "FileType:Template";
    IconType["Video"] = "FileType:Video";
    // BitBucket?
    IconType["Branch"] = "BitBucket:Branch";
    IconType["Commit"] = "BitBucket:Commit";
    IconType["Project"] = "BitBucket:Project";
    IconType["PullRequest"] = "BitBucket:PullRequest";
    IconType["Repo"] = "BitBucket:Repo";
    // Jira?
    IconType["Bug"] = "Jira:Bug";
    IconType["Change"] = "Jira:Change";
    IconType["Epic"] = "Jira:Epic";
    IconType["Incident"] = "Jira:Incident";
    IconType["Problem"] = "Jira:Problem";
    IconType["ServiceRequest"] = "Jira:ServiceRequest";
    IconType["Story"] = "Jira:Story";
    IconType["SubTask"] = "Jira:SubTask";
    IconType["Task"] = "Jira:Task";
    // Confluence
    IconType["LiveDocument"] = "Confluence:LiveDocument";
    // Provider
    IconType["Confluence"] = "Provider:Confluence";
    IconType["Jira"] = "Provider:Jira";
    // Fallback
    IconType["Default"] = "Default";
    IconType["Error"] = "Default:Error";
    IconType["Forbidden"] = "Default:Forbidden";
    // Badge
    IconType["Attachment"] = "Badge:Attachment";
    IconType["CheckItem"] = "Badge:Task";
    IconType["Comment"] = "Badge:Comment";
    IconType["Component"] = "Badge:Component";
    IconType["View"] = "Badge:View";
    IconType["React"] = "Badge:React";
    IconType["Vote"] = "Badge:Vote";
    IconType["PriorityBlocker"] = "Badge:PriorityBlocker";
    IconType["PriorityCritical"] = "Badge:PriorityCritical";
    IconType["PriorityHigh"] = "Badge:PriorityHigh";
    IconType["PriorityHighest"] = "Badge:PriorityHighest";
    IconType["PriorityLow"] = "Badge:PriorityLow";
    IconType["PriorityLowest"] = "Badge:PriorityLowest";
    IconType["PriorityMajor"] = "Badge:PriorityMajor";
    IconType["PriorityMedium"] = "Badge:PriorityMedium";
    IconType["PriorityMinor"] = "Badge:PriorityMinor";
    IconType["PriorityTrivial"] = "Badge:PriorityTrivial";
    IconType["PriorityUndefined"] = "Badge:PriorityUndefined";
    IconType["ProgrammingLanguage"] = "Badge:ProgrammingLanguage";
    IconType["Subscriber"] = "Badge:Subscriber";
    IconType["SubTasksProgress"] = "Badge:SubTask";
    return IconType;
}({});
var $b9dd161ee11f453b$export$483c11740a902fcd = /*#__PURE__*/ function(MediaType) {
    MediaType["Image"] = "image";
    return MediaType;
}({});
var $b9dd161ee11f453b$export$f9f4737e25ab90fa = /*#__PURE__*/ function(MediaPlacement) {
    MediaPlacement["Left"] = "left";
    MediaPlacement["Right"] = "right";
    return MediaPlacement;
}({});
var $b9dd161ee11f453b$export$6ca4ef8b3dc2c804 = /*#__PURE__*/ function(CardDisplay) {
    CardDisplay["Inline"] = "inline";
    CardDisplay["Block"] = "block";
    CardDisplay["Embed"] = "embed";
    CardDisplay["EmbedPreview"] = "embedPreview";
    CardDisplay["Flexible"] = "flexible";
    CardDisplay["HoverCardPreview"] = "hoverCardPreview";
    return CardDisplay;
}({});

});

parcelRegister("fq7gV", function(module, exports) {
$parcel$export(module.exports, "AUTH_WINDOW_HEIGHT", () => $b39eeccc43532cae$export$9737b997a3f49711);
$parcel$export(module.exports, "AUTH_WINDOW_WIDTH", () => $b39eeccc43532cae$export$9a6efef0b9731ce2);
$parcel$export(module.exports, "getWindowOpenFeatures", () => $b39eeccc43532cae$export$ae408235f8b77e96);
var $b39eeccc43532cae$var$BROWSER_SIZE_THRESHOLD = 38;
var $b39eeccc43532cae$export$9737b997a3f49711 = 760;
var $b39eeccc43532cae$export$9a6efef0b9731ce2 = 620;
var $b39eeccc43532cae$export$ae408235f8b77e96 = function getWindowOpenFeatures(popupHeight, popupWidth) {
    var vw = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0);
    var vh = Math.max(document.documentElement.clientHeight || 0, window.innerHeight || 0);
    var vl = window.screenLeft || 0;
    var vt = window.screenTop || 0;
    // Center the popup window
    var left = (vw - popupWidth) / 2 + vl;
    var top = (vh - popupHeight) / 2 + vt;
    // Open a popup if there's enough space in the viewport
    // Otherwise, fall back to the default behavior (opening in a new tab)
    var windowFeatures = vw > popupWidth + $b39eeccc43532cae$var$BROWSER_SIZE_THRESHOLD && vh > popupHeight + $b39eeccc43532cae$var$BROWSER_SIZE_THRESHOLD ? "width=".concat(popupWidth, ",height=").concat(popupHeight, ",left=").concat(left, ",top=").concat(top) : undefined;
    return windowFeatures;
};

});

parcelRegister("hZBUK", function(module, exports) {
$parcel$export(module.exports, "startUfoExperience", () => $d1958b2a2ecd12fe$export$5e9287b6a10f8075);
$parcel$export(module.exports, "succeedUfoExperience", () => $d1958b2a2ecd12fe$export$c5a5cf072c836c0e);
$parcel$export(module.exports, "failUfoExperience", () => $d1958b2a2ecd12fe$export$8dda83bafca11b77);
$parcel$export(module.exports, "addMetadataToExperience", () => $d1958b2a2ecd12fe$export$4084c0df4a03a6af);

var $hqBlU = parcelRequire("hqBlU");
var $fYRtb = parcelRequire("fYRtb");
var $d1958b2a2ecd12fe$var$inlineExperience = {
    platform: {
        component: 'smart-links'
    },
    type: (0, $fYRtb.ExperienceTypes).Experience,
    performanceType: (0, $fYRtb.ExperiencePerformanceTypes).InlineResult
};
var $d1958b2a2ecd12fe$var$renderExperience = {
    platform: {
        component: 'smart-links'
    },
    type: (0, $fYRtb.ExperienceTypes).Load,
    performanceType: (0, $fYRtb.ExperiencePerformanceTypes).PageSegmentLoad
};
var $d1958b2a2ecd12fe$var$aiExperience = {
    platform: {
        component: 'smart-links'
    },
    type: (0, $fYRtb.ExperienceTypes).Experience,
    performanceType: (0, $fYRtb.ExperiencePerformanceTypes).InlineResult
};
var $d1958b2a2ecd12fe$var$ufoExperiences = {
    'smart-link-rendered': new (0, $hqBlU.ConcurrentExperience)('smart-link-rendered', $d1958b2a2ecd12fe$var$renderExperience),
    'smart-link-authenticated': new (0, $hqBlU.ConcurrentExperience)('smart-link-authenticated', $d1958b2a2ecd12fe$var$inlineExperience),
    'smart-link-action-invocation': new (0, $hqBlU.ConcurrentExperience)('smart-link-action-invocation', $d1958b2a2ecd12fe$var$inlineExperience),
    'smart-link-ai-summary': new (0, $hqBlU.ConcurrentExperience)('smart-link-ai-summary', $d1958b2a2ecd12fe$var$aiExperience)
};
var $d1958b2a2ecd12fe$export$5e9287b6a10f8075 = function startUfoExperience(experienceName, id, properties) {
    var experience = $d1958b2a2ecd12fe$var$ufoExperiences[experienceName].getInstance(id);
    experience.start();
    if (properties) experience.addMetadata(properties);
};
var $d1958b2a2ecd12fe$export$c5a5cf072c836c0e = function succeedUfoExperience(experienceName, id, properties) {
    var experience = $d1958b2a2ecd12fe$var$ufoExperiences[experienceName].getInstance(id);
    experience.success({
        metadata: properties
    });
};
var $d1958b2a2ecd12fe$export$8dda83bafca11b77 = function failUfoExperience(experienceName, id, properties) {
    var experience = $d1958b2a2ecd12fe$var$ufoExperiences[experienceName].getInstance(id);
    experience.failure({
        metadata: properties
    });
};
var $d1958b2a2ecd12fe$export$4084c0df4a03a6af = function addMetadataToExperience(experienceName, id, properties) {
    $d1958b2a2ecd12fe$var$ufoExperiences[experienceName].getInstance(id).addMetadata(properties);
};

});
parcelRegister("hqBlU", function(module, exports) {
$parcel$export(module.exports, "ConcurrentExperience", () => $cb01d6c60374d351$export$ac1cddfee07ba6ac);

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $25nEq = parcelRequire("25nEq");

var $h3pbb = parcelRequire("h3pbb");

var $lg6ET = parcelRequire("lg6ET");
var $cb01d6c60374d351$export$ac1cddfee07ba6ac = /*#__PURE__*/ function() {
    function ConcurrentExperience(experienceId, config) {
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, ConcurrentExperience);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "instances", {});
        this.experienceId = experienceId;
        this.config = config;
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(ConcurrentExperience, [
        {
            key: "getInstance",
            value: function getInstance(instanceId) {
                if (!this.instances[instanceId]) this.instances[instanceId] = new (0, $lg6ET.UFOExperience)(this.experienceId, this.config, instanceId);
                return this.instances[instanceId];
            }
        },
        {
            key: "release",
            value: function release(instanceId) {
                (0, $h3pbb.ufolog)('instanceId', instanceId);
                if (this.instances[instanceId]) this.instances[instanceId].abort();
                delete this.instances[instanceId];
            }
        }
    ]);
}();

});
parcelRegister("h3pbb", function(module, exports) {
$parcel$export(module.exports, "ufolog", () => $c6a63f8ee444c14f$export$b4958caff08a0960);
$parcel$export(module.exports, "ufowarn", () => $c6a63f8ee444c14f$export$d53d07b6034c4560);

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $25nEq = parcelRequire("25nEq");
var $c6a63f8ee444c14f$var$UFOLogger = /*#__PURE__*/ function() {
    function UFOLogger() {
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, UFOLogger);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "enabled", false);
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(UFOLogger, [
        {
            key: "log",
            value: function log() {
                var _console;
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                // eslint-disable-next-line no-console
                this.enabled && (_console = console).log.apply(_console, [
                    UFOLogger.UFOprefix
                ].concat(args));
            }
        },
        {
            key: "warn",
            value: function warn() {
                var _console2;
                for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
                // eslint-disable-next-line no-console
                this.enabled && (_console2 = console).warn.apply(_console2, [
                    UFOLogger.UFOprefix
                ].concat(args));
            }
        },
        {
            key: "enable",
            value: function enable() {
                this.enabled = true;
            }
        },
        {
            key: "disable",
            value: function disable() {
                this.enabled = false;
            }
        }
    ]);
}();
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($c6a63f8ee444c14f$var$UFOLogger, "UFOprefix", "[ufo\uD83D\uDEF8]");
var $c6a63f8ee444c14f$export$4ab84f6f04f6566d = new $c6a63f8ee444c14f$var$UFOLogger();
var $c6a63f8ee444c14f$export$b4958caff08a0960 = function ufolog() {
    $c6a63f8ee444c14f$export$4ab84f6f04f6566d.log.apply($c6a63f8ee444c14f$export$4ab84f6f04f6566d, arguments);
};
var $c6a63f8ee444c14f$export$d53d07b6034c4560 = function ufowarn() {
    $c6a63f8ee444c14f$export$4ab84f6f04f6566d.warn.apply($c6a63f8ee444c14f$export$4ab84f6f04f6566d, arguments);
};

});

parcelRegister("lg6ET", function(module, exports) {
$parcel$export(module.exports, "UFOExperience", () => $f7a041d5481ac9bd$export$c00d22927c60484a);

var $arMYe = parcelRequire("arMYe");

var $9P61R = parcelRequire("9P61R");

var $kIXpt = parcelRequire("kIXpt");

var $cYPzS = parcelRequire("cYPzS");

var $eyuDe = parcelRequire("eyuDe");

var $1I3IC = parcelRequire("1I3IC");
function $f7a041d5481ac9bd$var$_callSuper(t, o, e) {
    return o = (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(o), (0, (/*@__PURE__*/$parcel$interopDefault($kIXpt)))(t, $f7a041d5481ac9bd$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(t).constructor) : o.apply(t, e));
}
function $f7a041d5481ac9bd$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($f7a041d5481ac9bd$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $f7a041d5481ac9bd$export$c00d22927c60484a = /*#__PURE__*/ function(_UFOAbstractExperienc) {
    function UFOExperience() {
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, UFOExperience);
        return $f7a041d5481ac9bd$var$_callSuper(this, UFOExperience, arguments);
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($eyuDe)))(UFOExperience, _UFOAbstractExperienc);
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(UFOExperience);
}((0, $1I3IC.UFOAbstractExperience));

});
parcelRegister("1I3IC", function(module, exports) {
$parcel$export(module.exports, "UFOAbstractExperience", () => $13ecc8f76084f934$export$d31c89db257648c);

var $fC8ib = parcelRequire("fC8ib");

var $fL8KA = parcelRequire("fL8KA");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $25nEq = parcelRequire("25nEq");

var $6HG4S = parcelRequire("6HG4S");

var $6JfQX = parcelRequire("6JfQX");

var $fdcp6 = parcelRequire("fdcp6");

var $4FJEb = parcelRequire("4FJEb");

var $h3pbb = parcelRequire("h3pbb");

var $kJk66 = parcelRequire("kJk66");

var $25YhN = parcelRequire("25YhN");

var $68R4m = parcelRequire("68R4m");

var $fREsH = parcelRequire("fREsH");

var $3AL5i = parcelRequire("3AL5i");

var $fOMQ4 = parcelRequire("fOMQ4");

var $fYRtb = parcelRequire("fYRtb");
function $13ecc8f76084f934$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $13ecc8f76084f934$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $13ecc8f76084f934$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $13ecc8f76084f934$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $13ecc8f76084f934$var$getPageVisibleState = function getPageVisibleState() {
    return !(0, $fREsH.isWindowObjectAvailable)() || !window.document || window.document.visibilityState === 'visible' ? (0, $25YhN.PageVisibleState).VISIBLE : (0, $25YhN.PageVisibleState).HIDDEN;
};
var $13ecc8f76084f934$export$c753e8669d30c8ad = function perfNowOrTimestamp(timestamp) {
    if (timestamp !== undefined) return ~~timestamp;
    return (0, $68R4m.roundPerfNow)();
};
var $13ecc8f76084f934$export$d31c89db257648c = /*#__PURE__*/ function() {
    function UFOAbstractExperience(id, config) {
        var _this = this;
        var instanceId = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, UFOAbstractExperience);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "state", (0, $3AL5i.UFOExperienceState).NOT_STARTED);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "instanceId", null);
        // for concurrent
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "parent", null);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "category", null);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "metadata", {});
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "onDoneCallbacks", []);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "childExperiences", []);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "explicitTimings", {});
        // @todo move to page load experience when proper classes/inheritance prepared
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "isSSROutputAsFMP", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "uuid", null);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "_until", null);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "metrics", {
            startTime: null,
            endTime: null,
            marks: []
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "performanceConfig", {});
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "setPageVisibleStateToMixed", function() {
            _this.pageVisibleState = (0, $25YhN.PageVisibleState).MIXED;
            (0, $kJk66.visibilityChangeObserver).unsubscribe(_this.setPageVisibleStateToMixed);
        });
        this.id = id;
        this.category = (config === null || config === void 0 ? void 0 : config.category) || null;
        this.until = (config === null || config === void 0 ? void 0 : config.until) || null;
        this.instanceId = instanceId;
        this.handleDoneBind = this._handleDoneExperience.bind(this);
        this.type = config.type;
        this.performanceType = config.performanceType;
        this.performanceConfig = config.performanceConfig || {};
        this.config = config;
        this.pageVisibleState = $13ecc8f76084f934$var$getPageVisibleState();
        this.featureFlags = config.featureFlags || [];
        this.timings = config.timings || [];
        if (config.performanceType === (0, $fYRtb.ExperiencePerformanceTypes).PageLoad || config.performanceType === (0, $fYRtb.ExperiencePerformanceTypes).PageSegmentLoad) this.isSSROutputAsFMP = config.isSSROutputAsFMP || false;
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(UFOAbstractExperience, [
        {
            key: "transition",
            value: function() {
                var _transition = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee(newState, timestamp) {
                    var data;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee$(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                (0, $h3pbb.ufolog)('async transition', this.id, this.state.id, newState.id);
                                if (!(0, $fOMQ4.canTransition)(this.state, newState)) {
                                    _context.next = 15;
                                    break;
                                }
                                (0, $h3pbb.ufolog)("TRANSITION: ".concat(this.id, " from ").concat(this.state.id, " to ").concat(newState.id, " successful"), this.state.final, !newState.final);
                                if (newState === (0, $3AL5i.UFOExperienceState).STARTED) this._reset();
                                if (this.state.final && !newState.final) {
                                    this.metrics.startTime = $13ecc8f76084f934$export$c753e8669d30c8ad(timestamp);
                                    this.uuid = (0, $6JfQX.default)();
                                }
                                this.state = newState;
                                if (!newState.final) {
                                    _context.next = 14;
                                    break;
                                }
                                this.metrics.endTime = $13ecc8f76084f934$export$c753e8669d30c8ad(timestamp);
                                if (!this._isManualStateEnabled()) (0, $4FJEb.getGlobalEventStream)().push((0, $4FJEb.unsubscribeEvent)((0, $25YhN.SUBSCRIBE_ALL), this.handleDoneBind));
                                _context.next = 11;
                                return this.exportData();
                            case 11:
                                data = _context.sent;
                                (0, $h3pbb.ufolog)('this.parent', this.parent);
                                (0, $4FJEb.getGlobalEventStream)().push((0, $4FJEb.experiencePayloadEvent)(data));
                            case 14:
                                return _context.abrupt("return", true);
                            case 15:
                                (0, $h3pbb.ufolog)("TRANSITION: ".concat(this.id, " from ").concat(this.state.id, " to ").concat(newState.id, " unsuccessful"));
                                (0, $h3pbb.ufowarn)("transition of ".concat(this.id, " from ").concat(this.state, " to ").concat(newState, " is not possible"));
                                return _context.abrupt("return", false);
                            case 18:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee, this);
                }));
                function transition(_x, _x2) {
                    return _transition.apply(this, arguments);
                }
                return transition;
            }()
        },
        {
            key: "start",
            value: function() {
                var _start = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee2(startTime) {
                    var transitionSuccessful;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee2$(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                _context2.next = 2;
                                return this.transition((0, $3AL5i.UFOExperienceState).STARTED, startTime);
                            case 2:
                                transitionSuccessful = _context2.sent;
                                if (transitionSuccessful) {
                                    this.pageVisibleState = $13ecc8f76084f934$var$getPageVisibleState();
                                    (0, $kJk66.visibilityChangeObserver).subscribe(this.setPageVisibleStateToMixed);
                                    if (!this._isManualStateEnabled()) {
                                        (0, $h3pbb.ufolog)('subscribed', this.id);
                                        (0, $4FJEb.getGlobalEventStream)().push((0, $4FJEb.subscribeEvent)((0, $25YhN.SUBSCRIBE_ALL), this.handleDoneBind));
                                    }
                                }
                            case 4:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2, this);
                }));
                function start(_x3) {
                    return _start.apply(this, arguments);
                }
                return start;
            }()
        },
        {
            key: "mark",
            value: function mark(name, timestamp) {
                if (name !== (0, $25YhN.FMP_MARK) && name !== (0, $25YhN.INLINE_RESPONSE_MARK)) this._mark(name, timestamp);
                else (0, $h3pbb.ufowarn)('please use markFMP or markInlineResponse for specialised marks');
            }
        },
        {
            key: "_mark",
            value: function _mark(name, timestamp) {
                this.metrics.marks.push({
                    name: name,
                    time: $13ecc8f76084f934$export$c753e8669d30c8ad(timestamp)
                });
                this.transition((0, $3AL5i.UFOExperienceState).IN_PROGRESS);
            }
        },
        {
            key: "markFMP",
            value: function markFMP(timestamp) {
                this._mark((0, $25YhN.FMP_MARK), timestamp);
            }
        },
        {
            key: "markInlineResponse",
            value: function markInlineResponse(timestamp) {
                this._mark((0, $25YhN.INLINE_RESPONSE_MARK), timestamp);
            }
        },
        {
            key: "_isManualStateEnabled",
            value: function _isManualStateEnabled() {
                return this.until === null;
            }
        },
        {
            key: "_validateManualState",
            value: function _validateManualState() {
                if (!this._isManualStateEnabled()) {
                    (0, $h3pbb.ufowarn)('manual change of state not allowed as "until" is defined');
                    return false;
                }
                return true;
            }
        },
        {
            key: "switchToEndState",
            value: function switchToEndState(state, config) {
                if (!(config !== null && config !== void 0 && config.force) && !this._validateManualState()) return null;
                if (config !== null && config !== void 0 && config.metadata) this.addMetadata(config.metadata);
                (0, $kJk66.visibilityChangeObserver).unsubscribe(this.setPageVisibleStateToMixed);
                return this.transition(state);
            }
        },
        {
            key: "success",
            value: function() {
                var _success = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee3(config) {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee3$(_context3) {
                        while(true)switch(_context3.prev = _context3.next){
                            case 0:
                                return _context3.abrupt("return", this.switchToEndState((0, $3AL5i.UFOExperienceState).SUCCEEDED, config));
                            case 1:
                            case "end":
                                return _context3.stop();
                        }
                    }, _callee3, this);
                }));
                function success(_x4) {
                    return _success.apply(this, arguments);
                }
                return success;
            }()
        },
        {
            key: "failure",
            value: function() {
                var _failure = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee4(config) {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee4$(_context4) {
                        while(true)switch(_context4.prev = _context4.next){
                            case 0:
                                return _context4.abrupt("return", this.switchToEndState((0, $3AL5i.UFOExperienceState).FAILED, config));
                            case 1:
                            case "end":
                                return _context4.stop();
                        }
                    }, _callee4, this);
                }));
                function failure(_x5) {
                    return _failure.apply(this, arguments);
                }
                return failure;
            }()
        },
        {
            key: "abort",
            value: function() {
                var _abort = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee5(config) {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee5$(_context5) {
                        while(true)switch(_context5.prev = _context5.next){
                            case 0:
                                return _context5.abrupt("return", this.switchToEndState((0, $3AL5i.UFOExperienceState).ABORTED, config));
                            case 1:
                            case "end":
                                return _context5.stop();
                        }
                    }, _callee5, this);
                }));
                function abort(_x6) {
                    return _abort.apply(this, arguments);
                }
                return abort;
            }()
        },
        {
            key: "addMetadata",
            value: function addMetadata(data) {
                Object.assign(this.metadata, data);
            }
        },
        {
            key: "_handleDoneExperience",
            value: function _handleDoneExperience(data) {
                (0, $h3pbb.ufolog)('_handleDoneExperience in', this.id, data.state, data, this._until);
                if (data.state.final) {
                    if (this._until !== null) {
                        var _this$_until = this._until(data), done = _this$_until.done, state = _this$_until.state;
                        if (done && !this.state.final) this.transition(state);
                    }
                }
            }
        },
        {
            key: "getId",
            value: function() {
                var _getId = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee6() {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee6$(_context6) {
                        while(true)switch(_context6.prev = _context6.next){
                            case 0:
                                return _context6.abrupt("return", this.id);
                            case 1:
                            case "end":
                                return _context6.stop();
                        }
                    }, _callee6, this);
                }));
                function getId() {
                    return _getId.apply(this, arguments);
                }
                return getId;
            }()
        },
        {
            key: "exportData",
            value: function() {
                var _exportData = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee7() {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee7$(_context7) {
                        while(true)switch(_context7.prev = _context7.next){
                            case 0:
                                _context7.next = 2;
                                return this.getId();
                            case 2:
                                _context7.t0 = _context7.sent;
                                _context7.t1 = this.uuid;
                                _context7.t2 = this.type;
                                _context7.t3 = (0, $fdcp6.UFO_EXPERIMENTAL_BUILD_VERSION) || 'unknown';
                                _context7.t4 = this.performanceType;
                                _context7.t5 = this.category;
                                _context7.t6 = this.state;
                                _context7.t7 = $13ecc8f76084f934$var$_objectSpread({}, this.metadata);
                                _context7.t8 = $13ecc8f76084f934$var$_objectSpread({}, this.metrics);
                                _context7.t9 = (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(this.childExperiences);
                                _context7.t10 = {
                                    success: !!this.state.success,
                                    startTime: this.metrics.startTime,
                                    duration: (this.metrics.endTime || 0) - (this.metrics.startTime || 0)
                                };
                                _context7.t11 = this.config.platform || null;
                                _context7.t12 = this.pageVisibleState;
                                _context7.t13 = this.featureFlags;
                                _context7.t14 = this.isSSROutputAsFMP;
                                _context7.t15 = this.timings;
                                _context7.t16 = this.explicitTimings;
                                _context7.t17 = this.performanceConfig;
                                return _context7.abrupt("return", {
                                    id: _context7.t0,
                                    uuid: _context7.t1,
                                    type: _context7.t2,
                                    schemaVersion: _context7.t3,
                                    performanceType: _context7.t4,
                                    category: _context7.t5,
                                    state: _context7.t6,
                                    metadata: _context7.t7,
                                    metrics: _context7.t8,
                                    children: _context7.t9,
                                    result: _context7.t10,
                                    platform: _context7.t11,
                                    pageVisibleState: _context7.t12,
                                    featureFlags: _context7.t13,
                                    isSSROutputAsFMP: _context7.t14,
                                    timings: _context7.t15,
                                    explicitTimings: _context7.t16,
                                    performanceConfig: _context7.t17
                                });
                            case 21:
                            case "end":
                                return _context7.stop();
                        }
                    }, _callee7, this);
                }));
                function exportData() {
                    return _exportData.apply(this, arguments);
                }
                return exportData;
            }()
        },
        {
            key: "_reset",
            value: function _reset() {
                this.parent = null;
                this.metadata = {};
                this.onDoneCallbacks = [];
                this.childExperiences = [];
                this.metrics = {
                    startTime: null,
                    endTime: null,
                    marks: []
                };
                this._until = this.until ? this.until() : null;
            }
        }
    ]);
}();

});
parcelRegister("fdcp6", function(module, exports) {
$parcel$export(module.exports, "UFO_EXPERIMENTAL_BUILD_VERSION", () => $b131b10a56db3a64$export$2295b861f318254a);
// temp solution until we can get it automated
var $b131b10a56db3a64$export$2295b861f318254a = '0.1.5';

});

parcelRegister("4FJEb", function(module, exports) {
$parcel$export(module.exports, "getGlobalEventStream", () => $366e664f555d0092$export$6123a44dc2384540);
$parcel$export(module.exports, "subscribeEvent", () => $366e664f555d0092$export$37863216db4b714d);
$parcel$export(module.exports, "unsubscribeEvent", () => $366e664f555d0092$export$ee1a7bd1fc9ea85e);
$parcel$export(module.exports, "experiencePayloadEvent", () => $366e664f555d0092$export$7c957416596ca127);

var $h3pbb = parcelRequire("h3pbb");

var $25YhN = parcelRequire("25YhN");
var $366e664f555d0092$var$MAX_EARLY_QUEUE_LENGTH = 250;
var $366e664f555d0092$export$6123a44dc2384540 = function getGlobalEventStream() {
    if (!globalThis.__UFO_GLOBAL_EVENT_STREAM__) {
        var earlyStream = function() {
            var stream = [];
            return {
                __buffer_only__: true,
                push: function push(event) {
                    if (stream.length < $366e664f555d0092$var$MAX_EARLY_QUEUE_LENGTH) stream.push(event);
                },
                getStream: function getStream() {
                    return stream;
                }
            };
        }();
        globalThis.__UFO_GLOBAL_EVENT_STREAM__ = earlyStream;
    }
    return globalThis.__UFO_GLOBAL_EVENT_STREAM__;
};
var $366e664f555d0092$export$c1522520b417b066 = function setGlobalEventStream(eventStream) {
    var _globalThis$__UFO_GLO, _globalThis$__UFO_GLO2;
    if (globalThis.__UFO_GLOBAL_EVENT_STREAM__ && !((_globalThis$__UFO_GLO = globalThis.__UFO_GLOBAL_EVENT_STREAM__) !== null && _globalThis$__UFO_GLO !== void 0 && _globalThis$__UFO_GLO.__buffer_only__)) {
        (0, $h3pbb.ufowarn)('Global Event Stream already initialised. Ignoring new event stream setup');
        return;
    }
    if ((_globalThis$__UFO_GLO2 = globalThis.__UFO_GLOBAL_EVENT_STREAM__) !== null && _globalThis$__UFO_GLO2 !== void 0 && _globalThis$__UFO_GLO2.__buffer_only__) globalThis.__UFO_GLOBAL_EVENT_STREAM__.getStream().forEach(eventStream.push.bind(eventStream));
    globalThis.__UFO_GLOBAL_EVENT_STREAM__ = eventStream;
};
var $366e664f555d0092$export$37863216db4b714d = function subscribeEvent(experienceId, callback) {
    return {
        type: (0, $25YhN.UFOGlobalEventStreamEventType).SUBSCRIBE,
        payload: {
            experienceId: experienceId,
            callback: callback
        }
    };
};
var $366e664f555d0092$export$ee1a7bd1fc9ea85e = function unsubscribeEvent(experienceId, callback) {
    return {
        type: (0, $25YhN.UFOGlobalEventStreamEventType).UNSUBSCRIBE,
        payload: {
            experienceId: experienceId,
            callback: callback
        }
    };
};
var $366e664f555d0092$export$7c957416596ca127 = function experiencePayloadEvent(data) {
    return {
        type: (0, $25YhN.UFOGlobalEventStreamEventType).EXPERIENCE_PAYLOAD,
        payload: data
    };
};

});
parcelRegister("25YhN", function(module, exports) {
$parcel$export(module.exports, "UFOGlobalEventStreamEventType", () => $186acff5526ecea1$export$96253c35c37cf96b);
$parcel$export(module.exports, "PageVisibleState", () => $186acff5526ecea1$export$a12c67b37a306b13);
$parcel$export(module.exports, "SUBSCRIBE_ALL", () => $186acff5526ecea1$export$79bf131685ad41d7);
$parcel$export(module.exports, "FMP_MARK", () => $186acff5526ecea1$export$9f2bf58999404c75);
$parcel$export(module.exports, "INLINE_RESPONSE_MARK", () => $186acff5526ecea1$export$837e0f79a8056912);
var $186acff5526ecea1$export$96253c35c37cf96b = /*#__PURE__*/ function(UFOGlobalEventStreamEventType) {
    UFOGlobalEventStreamEventType[UFOGlobalEventStreamEventType["EXPERIENCE_PAYLOAD"] = 0] = "EXPERIENCE_PAYLOAD";
    UFOGlobalEventStreamEventType[UFOGlobalEventStreamEventType["SUBSCRIBE"] = 1] = "SUBSCRIBE";
    UFOGlobalEventStreamEventType[UFOGlobalEventStreamEventType["UNSUBSCRIBE"] = 2] = "UNSUBSCRIBE";
    return UFOGlobalEventStreamEventType;
}({});
var $186acff5526ecea1$export$a12c67b37a306b13 = /*#__PURE__*/ function(PageVisibleState) {
    PageVisibleState["VISIBLE"] = "visible";
    PageVisibleState["HIDDEN"] = "hidden";
    PageVisibleState["MIXED"] = "mixed";
    return PageVisibleState;
}({});
var $186acff5526ecea1$export$66b33c055cbb625e = /*#__PURE__*/ function(PageLoadMetrics) {
    PageLoadMetrics["fmp"] = "fmp";
    PageLoadMetrics["tti"] = "tti";
    return PageLoadMetrics;
}({});
var $186acff5526ecea1$export$3ce489cbe02dc21b = /*#__PURE__*/ function(PageSegmentLoadMetrics) {
    PageSegmentLoadMetrics["fmp"] = "fmp";
    PageSegmentLoadMetrics["tti"] = "tti";
    return PageSegmentLoadMetrics;
}({});
var $186acff5526ecea1$export$341b330828bd3906 = /*#__PURE__*/ function(InteractionMetrics) {
    InteractionMetrics["response"] = "response";
    InteractionMetrics["result"] = "result";
    return InteractionMetrics;
}({});
var $186acff5526ecea1$export$b9b20160f581e4f8 = /*#__PURE__*/ function(CustomMetrics) {
    CustomMetrics["duration"] = "duration";
    return CustomMetrics;
}({});
var $186acff5526ecea1$export$79bf131685ad41d7 = '__SUBSCRIBE_ALL__';
var $186acff5526ecea1$export$9f2bf58999404c75 = 'fmp';
var $186acff5526ecea1$export$837e0f79a8056912 = 'inline-response';

});


parcelRegister("kJk66", function(module, exports) {
$parcel$export(module.exports, "visibilityChangeObserver", () => $f17799879d9640c6$export$13e680397ec8f3eb);

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $25nEq = parcelRequire("25nEq");

var $fREsH = parcelRequire("fREsH");
var $f17799879d9640c6$var$VisibilityChangeObserver = /*#__PURE__*/ function() {
    function VisibilityChangeObserver() {
        var _this = this;
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, VisibilityChangeObserver);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "started", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "observers", []);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "broadcast", function() {
            _this.observers.forEach(function(fn) {
                return fn();
            });
            _this.observers = [];
        });
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(VisibilityChangeObserver, [
        {
            key: "start",
            value: function start() {
                if (this.started) return;
                this.started = true;
                document.addEventListener('visibilitychange', this.broadcast);
                /**
       * According to https://developer.mozilla.org/en-US/docs/Web/API/Document/visibilitychange_event
       * Safari doesn’t fire visibilitychange as expected when the value of the visibilityState property transitions to hidden;
       * so for that case, you need to also include code to listen for the pagehide event.
       */ if ((0, $fREsH.isWindowObjectAvailable)()) window.addEventListener('pagehide', this.broadcast);
            }
        },
        {
            key: "subscribe",
            value: function subscribe(callback) {
                this.observers.push(callback);
            }
        },
        {
            key: "unsubscribe",
            value: function unsubscribe(callback) {
                this.observers = this.observers.filter(function(fn) {
                    return fn !== callback;
                });
            }
        }
    ]);
}();
var $f17799879d9640c6$export$13e680397ec8f3eb = new $f17799879d9640c6$var$VisibilityChangeObserver();

});
parcelRegister("fREsH", function(module, exports) {
$parcel$export(module.exports, "isWindowObjectAvailable", () => $b8cb312791cacffb$export$15e172712955e18f);
var $b8cb312791cacffb$export$15e172712955e18f = function isWindowObjectAvailable() {
    return typeof window !== 'undefined';
};

});


parcelRegister("68R4m", function(module, exports) {
$parcel$export(module.exports, "roundPerfNow", () => $478ca7e4c14c5d04$export$5f490af6b2b115cf);
var $478ca7e4c14c5d04$export$5f490af6b2b115cf = function roundPerfNow() {
    return ~~performance.now();
};

});

parcelRegister("3AL5i", function(module, exports) {
$parcel$export(module.exports, "UFOExperienceState", () => $29d941dd3320dbd6$export$81b70111112841a0);
var $29d941dd3320dbd6$export$81b70111112841a0 = {
    NOT_STARTED: {
        id: 'NOT_STARTED',
        final: true
    },
    STARTED: {
        id: 'STARTED'
    },
    IN_PROGRESS: {
        id: 'IN_PROGRESS'
    },
    BLOCKED: {
        id: 'BLOCKED'
    },
    RECOVERED: {
        id: 'RECOVERED'
    },
    // isn't recovered IN_PROGRESS?
    SUCCEEDED: {
        id: 'SUCCEEDED',
        final: true,
        success: true
    },
    SUCCEEDED_WAITING_FOR_DEPS: {
        id: 'SUCCEEDED_WAITING_FOR_DEPS'
    },
    FAILED: {
        id: 'FAILED',
        final: true
    },
    ABORTED: {
        id: 'ABORTED',
        final: true
    }
};

});

parcelRegister("fOMQ4", function(module, exports) {
$parcel$export(module.exports, "canTransition", () => $02f8cc03cf8b2cad$export$178881f329fdb81f);

var $25nEq = parcelRequire("25nEq");

var $3AL5i = parcelRequire("3AL5i");
var $02f8cc03cf8b2cad$var$UFOStateAvailableTransitions = (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, (0, $3AL5i.UFOExperienceState).NOT_STARTED.id, [
    (0, $3AL5i.UFOExperienceState).STARTED.id
]), (0, $3AL5i.UFOExperienceState).STARTED.id, [
    (0, $3AL5i.UFOExperienceState).IN_PROGRESS.id,
    (0, $3AL5i.UFOExperienceState).BLOCKED.id,
    (0, $3AL5i.UFOExperienceState).SUCCEEDED.id,
    (0, $3AL5i.UFOExperienceState).SUCCEEDED_WAITING_FOR_DEPS.id,
    (0, $3AL5i.UFOExperienceState).FAILED.id,
    (0, $3AL5i.UFOExperienceState).ABORTED.id
]), (0, $3AL5i.UFOExperienceState).IN_PROGRESS.id, [
    (0, $3AL5i.UFOExperienceState).BLOCKED.id,
    (0, $3AL5i.UFOExperienceState).SUCCEEDED.id,
    (0, $3AL5i.UFOExperienceState).SUCCEEDED_WAITING_FOR_DEPS.id,
    (0, $3AL5i.UFOExperienceState).FAILED.id,
    (0, $3AL5i.UFOExperienceState).ABORTED.id
]), (0, $3AL5i.UFOExperienceState).BLOCKED.id, [
    (0, $3AL5i.UFOExperienceState).RECOVERED.id,
    (0, $3AL5i.UFOExperienceState).ABORTED.id
]), (0, $3AL5i.UFOExperienceState).RECOVERED.id, [
    (0, $3AL5i.UFOExperienceState).STARTED.id,
    (0, $3AL5i.UFOExperienceState).SUCCEEDED.id,
    (0, $3AL5i.UFOExperienceState).SUCCEEDED_WAITING_FOR_DEPS.id,
    (0, $3AL5i.UFOExperienceState).FAILED.id,
    (0, $3AL5i.UFOExperienceState).ABORTED.id
]), (0, $3AL5i.UFOExperienceState).SUCCEEDED.id, [
    (0, $3AL5i.UFOExperienceState).STARTED.id
]), (0, $3AL5i.UFOExperienceState).SUCCEEDED_WAITING_FOR_DEPS.id, [
    (0, $3AL5i.UFOExperienceState).SUCCEEDED.id,
    (0, $3AL5i.UFOExperienceState).FAILED.id,
    (0, $3AL5i.UFOExperienceState).ABORTED.id
]), (0, $3AL5i.UFOExperienceState).FAILED.id, [
    (0, $3AL5i.UFOExperienceState).STARTED.id
]), (0, $3AL5i.UFOExperienceState).ABORTED.id, [
    (0, $3AL5i.UFOExperienceState).STARTED.id
]);
var $02f8cc03cf8b2cad$export$178881f329fdb81f = function canTransition(state1, state2) {
    return $02f8cc03cf8b2cad$var$UFOStateAvailableTransitions[state1.id] && $02f8cc03cf8b2cad$var$UFOStateAvailableTransitions[state1.id].includes(state2.id);
};

});

parcelRegister("fYRtb", function(module, exports) {
$parcel$export(module.exports, "ExperienceTypes", () => $ba25ef9ad6d9c0bf$export$994164cf3ae1cc9a);
$parcel$export(module.exports, "ExperiencePerformanceTypes", () => $ba25ef9ad6d9c0bf$export$cc26007c03242fff);
var $ba25ef9ad6d9c0bf$export$994164cf3ae1cc9a = /*#__PURE__*/ function(ExperienceTypes) {
    ExperienceTypes["Load"] = "load";
    ExperienceTypes["Experience"] = "experience";
    ExperienceTypes["Operation"] = "operation";
    return ExperienceTypes;
}({});
var $ba25ef9ad6d9c0bf$export$cc26007c03242fff = /*#__PURE__*/ function(ExperiencePerformanceTypes) {
    ExperiencePerformanceTypes["PageLoad"] = "page-load";
    ExperiencePerformanceTypes["PageSegmentLoad"] = "page-segment-load";
    ExperiencePerformanceTypes["InlineResult"] = "inline-result";
    ExperiencePerformanceTypes["Custom"] = "custom";
    return ExperiencePerformanceTypes;
}({});

});





parcelRegister("9ULzi", function(module, exports) {
$parcel$export(module.exports, "default", () => $737e3e1bd20a0070$export$2e2bcd8739ae039);

var $fL8KA = parcelRequire("fL8KA");

var $6HG4S = parcelRequire("6HG4S");

var $5FkrB = parcelRequire("5FkrB");

var $6JfQX = parcelRequire("6JfQX");

var $96IWe = parcelRequire("96IWe");

var $1Bpy8 = parcelRequire("1Bpy8");

var $hZBUK = parcelRequire("hZBUK");
var $737e3e1bd20a0070$var$ACTION_EXPERIENCE_NAME = 'smart-link-action-invocation';
/**
 * Invoke client action such as preview, download and open link
 */ var $737e3e1bd20a0070$var$useInvokeClientAction = function useInvokeClientAction(_ref) {
    var fireEventProp = _ref.fireEvent;
    var _useAnalyticsEvents = (0, $96IWe.useAnalyticsEvents)(), defaultFireEvent = _useAnalyticsEvents.fireEvent;
    var fireEvent = fireEventProp !== null && fireEventProp !== void 0 ? fireEventProp : defaultFireEvent;
    return (0, $5FkrB.useCallback)(/*#__PURE__*/ function() {
        var _ref3 = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee(_ref2) {
            var actionSubjectId, actionType, actionFn, _ref2$definitionId, definitionId, extensionKey, display, id, _ref2$resourceType, resourceType, experienceId, markName, _measure$getMeasure$d, _measure$getMeasure, result, _measure$getMeasure$d2, _measure$getMeasure2, reason;
            return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee$(_context) {
                while(true)switch(_context.prev = _context.next){
                    case 0:
                        actionSubjectId = _ref2.actionSubjectId, actionType = _ref2.actionType, actionFn = _ref2.actionFn, _ref2$definitionId = _ref2.definitionId, definitionId = _ref2$definitionId === void 0 ? null : _ref2$definitionId, extensionKey = _ref2.extensionKey, display = _ref2.display, id = _ref2.id, _ref2$resourceType = _ref2.resourceType, resourceType = _ref2$resourceType === void 0 ? null : _ref2$resourceType;
                        // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
                        experienceId = (0, $6JfQX.default)(); // Begin performance instrumentation.
                        markName = "".concat(experienceId, "-").concat(actionType);
                        $1Bpy8.mark(markName, 'pending');
                        _context.prev = 4;
                        // Begin UFO experience
                        (0, $hZBUK.startUfoExperience)($737e3e1bd20a0070$var$ACTION_EXPERIENCE_NAME, experienceId, {
                            actionType: actionType,
                            display: display,
                            extensionKey: extensionKey,
                            invokeType: 'client'
                        });
                        // Begin analytics instrumentation.
                        if (actionSubjectId !== undefined) fireEvent("ui.button.clicked.".concat(actionSubjectId), {
                            actionType: actionType !== null && actionType !== void 0 ? actionType : null,
                            definitionId: definitionId,
                            display: display !== null && display !== void 0 ? display : null,
                            id: id !== null && id !== void 0 ? id : experienceId,
                            resourceType: resourceType
                        });
                        // Invoke action
                        _context.next = 9;
                        return actionFn();
                    case 9:
                        result = _context.sent;
                        $1Bpy8.mark(markName, 'resolved');
                        (0, $hZBUK.succeedUfoExperience)($737e3e1bd20a0070$var$ACTION_EXPERIENCE_NAME, experienceId);
                        fireEvent('operational.smartLinkAction.resolved', {
                            actionType: actionType !== null && actionType !== void 0 ? actionType : null,
                            definitionId: definitionId,
                            display: display !== null && display !== void 0 ? display : null,
                            duration: (_measure$getMeasure$d = (_measure$getMeasure = $1Bpy8.getMeasure(markName, 'resolved')) === null || _measure$getMeasure === void 0 ? void 0 : _measure$getMeasure.duration) !== null && _measure$getMeasure$d !== void 0 ? _measure$getMeasure$d : null,
                            id: id !== null && id !== void 0 ? id : experienceId,
                            resourceType: resourceType
                        });
                        return _context.abrupt("return", result);
                    case 16:
                        _context.prev = 16;
                        _context.t0 = _context["catch"](4);
                        $1Bpy8.mark(markName, 'errored');
                        (0, $hZBUK.failUfoExperience)($737e3e1bd20a0070$var$ACTION_EXPERIENCE_NAME, experienceId);
                        reason = typeof _context.t0 === 'string' ? _context.t0 : _context.t0 === null || _context.t0 === void 0 ? void 0 : _context.t0.message;
                        fireEvent('operational.smartLinkAction.unresolved', {
                            actionType: actionType !== null && actionType !== void 0 ? actionType : null,
                            definitionId: definitionId,
                            display: display !== null && display !== void 0 ? display : null,
                            duration: (_measure$getMeasure$d2 = (_measure$getMeasure2 = $1Bpy8.getMeasure(markName, 'errored')) === null || _measure$getMeasure2 === void 0 ? void 0 : _measure$getMeasure2.duration) !== null && _measure$getMeasure$d2 !== void 0 ? _measure$getMeasure$d2 : null,
                            id: id !== null && id !== void 0 ? id : experienceId,
                            reason: reason,
                            resourceType: resourceType
                        });
                    case 22:
                    case "end":
                        return _context.stop();
                }
            }, _callee, null, [
                [
                    4,
                    16
                ]
            ]);
        }));
        return function(_x) {
            return _ref3.apply(this, arguments);
        };
    }(), [
        fireEvent
    ]);
};
var $737e3e1bd20a0070$export$2e2bcd8739ae039 = $737e3e1bd20a0070$var$useInvokeClientAction;

});

parcelRegister("186iK", function(module, exports) {
$parcel$export(module.exports, "default", () => $0d2b6d20e0e4eb7b$export$2e2bcd8739ae039);

var $fL8KA = parcelRequire("fL8KA");

var $6HG4S = parcelRequire("6HG4S");

var $5FkrB = parcelRequire("5FkrB");

var $33An2 = parcelRequire("33An2");

var $9kTNw = parcelRequire("9kTNw");

var $fXlyu = parcelRequire("fXlyu");

var $hZBUK = parcelRequire("hZBUK");

var $3lLQT = parcelRequire("3lLQT");
var $0d2b6d20e0e4eb7b$var$useResolve = function useResolve() {
    // Request JSON-LD data for the card from ORS, if it has extended
    // its cache lifespan OR there is no data for it currently. Once the data
    // has come back asynchronously, call the useResponse callback to
    // dispatch the resolved action for the card.
    var _useSmartLinkContext = (0, $9kTNw.useSmartLinkContext)(), store = _useSmartLinkContext.store, connections = _useSmartLinkContext.connections;
    var getState = store.getState;
    var _useResponse = (0, $3lLQT.default)(), handleResolvedLinkResponse = _useResponse.handleResolvedLinkResponse, handleResolvedLinkError = _useResponse.handleResolvedLinkError;
    return (0, $5FkrB.useCallback)(/*#__PURE__*/ function() {
        var _ref = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee(url) {
            var isReloading, isMetadataRequest, id, _ref2, details, hasData, _args = arguments;
            return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee$(_context) {
                while(true)switch(_context.prev = _context.next){
                    case 0:
                        isReloading = _args.length > 1 && _args[1] !== undefined ? _args[1] : false;
                        isMetadataRequest = _args.length > 2 && _args[2] !== undefined ? _args[2] : false;
                        id = _args.length > 3 && _args[3] !== undefined ? _args[3] : '';
                        _ref2 = getState()[url] || {
                            status: (0, $fXlyu.SmartLinkStatus).Pending,
                            details: undefined
                        }, details = _ref2.details;
                        hasData = !!(details && details.data || (0, $33An2.isEntityPresent)(details));
                        if (!(isReloading || !hasData || isMetadataRequest)) {
                            _context.next = 9;
                            break;
                        }
                        return _context.abrupt("return", connections.client.fetchData(url, isReloading).then(function(response) {
                            return handleResolvedLinkResponse(url, response, isReloading, isMetadataRequest);
                        }).catch(function(error) {
                            return handleResolvedLinkError(url, error, undefined, isMetadataRequest);
                        }));
                    case 9:
                        (0, $hZBUK.addMetadataToExperience)('smart-link-rendered', id, {
                            cached: true
                        });
                    case 10:
                    case "end":
                        return _context.stop();
                }
            }, _callee);
        }));
        return function(_x) {
            return _ref.apply(this, arguments);
        };
    }(), [
        connections.client,
        getState,
        handleResolvedLinkError,
        handleResolvedLinkResponse
    ]);
};
var $0d2b6d20e0e4eb7b$export$2e2bcd8739ae039 = $0d2b6d20e0e4eb7b$var$useResolve;

});
parcelRegister("3lLQT", function(module, exports) {
$parcel$export(module.exports, "default", () => $270873b03b515926$export$2e2bcd8739ae039);

var $5FkrB = parcelRequire("5FkrB");

var $aLeHs = parcelRequire("aLeHs");

var $9kTNw = parcelRequire("9kTNw");

var $iNBng = parcelRequire("iNBng");
var $1Qm9s = parcelRequire("1Qm9s");
var $f48iT = parcelRequire("f48iT");

var $fXlyu = parcelRequire("fXlyu");

var $9MF4G = parcelRequire("9MF4G");

var $frn9t = parcelRequire("frn9t");
var $270873b03b515926$var$useResponse = function useResponse() {
    // Takes in the JSON-LD response and dispatch the resolved action for the card.
    // It will dispatch a successful or error action
    var _useSmartLinkContext = (0, $9kTNw.useSmartLinkContext)(), store = _useSmartLinkContext.store, config = _useSmartLinkContext.config;
    var getState = store.getState, dispatch = store.dispatch;
    var hasAuthFlowSupported = config.authFlow !== 'disabled';
    var setMetadataStatus = (0, $5FkrB.useCallback)(function(url, metadataStatus) {
        dispatch((0, $iNBng.cardAction)((0, $iNBng.ACTION_UPDATE_METADATA_STATUS), {
            url: url
        }, undefined, undefined, metadataStatus));
    }, [
        dispatch
    ]);
    var handleResolvedLinkError = (0, $5FkrB.useCallback)(function(url, error, response, isMetadataRequest) {
        var newState = {
            status: (0, $fXlyu.SmartLinkStatus).Pending,
            details: undefined
        };
        var _ref = getState()[url] || newState, details = _ref.details;
        var hasData = !!(details && details.data);
        // If metadata request then set metadata status, return and do not alter link status
        if (isMetadataRequest) {
            setMetadataStatus(url, 'errored');
            return;
        }
        if (error.kind === 'fatal') {
            // If we already have resolved data for this URL in the store, then
            // simply fallback to the previous data.
            if (hasData) dispatch((0, $iNBng.cardAction)((0, $iNBng.ACTION_RESOLVED), {
                url: url
            }, details));
            else {
                dispatch((0, $iNBng.cardAction)((0, $iNBng.ACTION_ERROR), {
                    url: url
                }, details, error));
                throw error;
            }
        } else if (error.kind === 'auth') dispatch((0, $iNBng.cardAction)((0, $iNBng.ACTION_RESOLVED), {
            url: url
        }, (0, $9MF4G.getUnauthorizedJsonLd)()));
        else if (error.kind === 'fallback') // Fallback to blue link with smart link formatting. Not part of reliability.
        dispatch((0, $iNBng.cardAction)((0, $iNBng.ACTION_ERROR_FALLBACK), {
            url: url
        }, response, error));
        else // Fallback to blue link with smart link formatting. Part of reliability.
        dispatch((0, $iNBng.cardAction)((0, $iNBng.ACTION_ERROR), {
            url: url
        }, undefined, error));
    }, [
        getState,
        setMetadataStatus,
        dispatch
    ]);
    var handleResolvedLinkSuccess = (0, $5FkrB.useCallback)(function(resourceUrl, response, isReloading, isMetadataRequest) {
        //if a link resolves normally, metadata will also always be resolved
        setMetadataStatus(resourceUrl, 'resolved');
        // Dispatch Analytics and resolved card action - including unauthorized states.
        if (isReloading) dispatch((0, $iNBng.cardAction)((0, $iNBng.ACTION_RELOADING), {
            url: resourceUrl
        }, response));
        else dispatch((0, $iNBng.cardAction)((0, $iNBng.ACTION_RESOLVED), {
            url: resourceUrl
        }, response, undefined, undefined, isMetadataRequest));
    }, [
        setMetadataStatus,
        dispatch
    ]);
    var handleResolvedLinkResponse = (0, $5FkrB.useCallback)(function(resourceUrl, response) {
        var isReloading = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
        var isMetadataRequest = arguments.length > 3 ? arguments[3] : undefined;
        var hostname = new URL(resourceUrl).hostname;
        var nextStatus = response ? (0, $f48iT.getStatus)(response) : 'fatal';
        // If we require authorization & do not have an authFlow available,
        // throw an error and render as a normal blue link.
        if ((nextStatus === 'unauthorized' || nextStatus === 'forbidden') && !hasAuthFlowSupported) {
            handleResolvedLinkError(resourceUrl, new (0, $1Qm9s.APIError)('fallback', hostname, (0, $frn9t.ERROR_MESSAGE_OAUTH)), response, isMetadataRequest);
            return;
        }
        // Handle any other errors
        if (!response || nextStatus === 'fatal') {
            handleResolvedLinkError(resourceUrl, new (0, $1Qm9s.APIError)('fatal', hostname, (0, $frn9t.ERROR_MESSAGE_FATAL)), undefined, isMetadataRequest);
            return;
        }
        // Handle errors of any other kind in the metadata request response
        if (isMetadataRequest && nextStatus !== 'resolved') {
            handleResolvedLinkError(resourceUrl, new (0, $1Qm9s.APIError)('error', hostname, (0, $frn9t.ERROR_MESSAGE_METADATA)), response, isMetadataRequest);
            return;
        }
        /**
     * Using unstable_batchedUpdates because this store update happens async and triggers a rerender
     * more info:
     * https://github.com/facebook/react/blob/v18.2.0/packages/use-sync-external-store/src/useSyncExternalStoreShimClient.js#L113
     * https://react-redux.js.org/api/batch
     */ (0, $aLeHs.unstable_batchedUpdates)(function() {
            handleResolvedLinkSuccess(resourceUrl, response, isReloading, isMetadataRequest);
        });
    }, [
        handleResolvedLinkError,
        handleResolvedLinkSuccess,
        hasAuthFlowSupported
    ]);
    return (0, $5FkrB.useMemo)(function() {
        return {
            handleResolvedLinkError: handleResolvedLinkError,
            handleResolvedLinkResponse: handleResolvedLinkResponse
        };
    }, [
        handleResolvedLinkError,
        handleResolvedLinkResponse
    ]);
};
var $270873b03b515926$export$2e2bcd8739ae039 = $270873b03b515926$var$useResponse;

});
parcelRegister("1Qm9s", function(module, exports) {
$parcel$export(module.exports, "APIError", () => $157bd49fdd5ff49b$export$3e5b797e39668f84);

var $arMYe = parcelRequire("arMYe");

var $9P61R = parcelRequire("9P61R");

var $kIXpt = parcelRequire("kIXpt");

var $cYPzS = parcelRequire("cYPzS");

var $eyuDe = parcelRequire("eyuDe");

var $c7s0H = parcelRequire("c7s0H");
function $157bd49fdd5ff49b$var$_callSuper(t, o, e) {
    return o = (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(o), (0, (/*@__PURE__*/$parcel$interopDefault($kIXpt)))(t, $157bd49fdd5ff49b$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(t).constructor) : o.apply(t, e));
}
function $157bd49fdd5ff49b$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($157bd49fdd5ff49b$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $157bd49fdd5ff49b$export$3e5b797e39668f84 = /*#__PURE__*/ function(_Error) {
    function APIError(kind, hostname, message, type, extensionKey) {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, APIError);
        _this = $157bd49fdd5ff49b$var$_callSuper(this, APIError, [
            "".concat(kind, ": ").concat(message)
        ]);
        _this.kind = kind;
        _this.hostname = hostname;
        _this.message = message;
        _this.type = type;
        _this.extensionKey = extensionKey;
        _this.name = 'APIError';
        // The error type received from the server.
        _this.type = type;
        // The kind mapped to on the client.
        _this.kind = kind;
        // The message received from the server.
        _this.message = message;
        // The hostname of the URL which failed - do NOT log this (contains PII/UGC).
        _this.hostname = hostname;
        // The extensionKey passed from the error response from ORS
        _this.extensionKey = extensionKey;
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($eyuDe)))(APIError, _Error);
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(APIError);
}(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($c7s0H)))(Error));

});

parcelRegister("f48iT", function(module, exports) {
$parcel$export(module.exports, "getStatus", () => $af7dabafb9247411$export$b70265791d2079d4);
var $af7dabafb9247411$var$getStatusForNotFoundVisibility = function getStatusForNotFoundVisibility(meta) {
    var _meta$requestAccess;
    var accessType = (_meta$requestAccess = meta.requestAccess) === null || _meta$requestAccess === void 0 ? void 0 : _meta$requestAccess.accessType;
    if (!accessType || accessType === 'ACCESS_EXISTS') return 'not_found';
    // for the rest of the accessTypes we will return forbidden,see https://product-fabric.atlassian.net/browse/EDM-7125
    return 'forbidden';
};
var $af7dabafb9247411$export$b70265791d2079d4 = function getStatus(_ref) {
    var meta = _ref.meta;
    var access = meta.access, visibility = meta.visibility;
    switch(access){
        case 'forbidden':
            if (visibility === 'not_found') return $af7dabafb9247411$var$getStatusForNotFoundVisibility(meta);
            else return 'forbidden';
        case 'unauthorized':
            return 'unauthorized';
        default:
            return 'resolved';
    }
};

});

parcelRegister("9MF4G", function(module, exports) {
$parcel$export(module.exports, "getEmptyJsonLd", () => $71f875462e622a15$export$2796a804c6e44f63);
$parcel$export(module.exports, "getUnauthorizedJsonLd", () => $71f875462e622a15$export$b9482e0f6d365cc7);
$parcel$export(module.exports, "getForbiddenJsonLd", () => $71f875462e622a15$export$e32193033a594efb);

var $25nEq = parcelRequire("25nEq");
function $71f875462e622a15$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $71f875462e622a15$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $71f875462e622a15$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $71f875462e622a15$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $71f875462e622a15$var$emptyData = {
    '@context': {
        '@vocab': 'https://www.w3.org/ns/activitystreams#',
        atlassian: 'https://schema.atlassian.com/ns/vocabulary#',
        schema: 'http://schema.org/'
    },
    '@type': 'Object'
};
var $71f875462e622a15$export$2796a804c6e44f63 = function getEmptyJsonLd() {
    return $71f875462e622a15$var$emptyData;
};
var $71f875462e622a15$export$b9482e0f6d365cc7 = function getUnauthorizedJsonLd() {
    return {
        meta: {
            visibility: 'restricted',
            access: 'unauthorized',
            auth: [],
            definitionId: 'provider-not-found'
        },
        data: $71f875462e622a15$var$_objectSpread({}, $71f875462e622a15$var$emptyData)
    };
};
var $71f875462e622a15$export$e32193033a594efb = function getForbiddenJsonLd() {
    return {
        meta: {
            visibility: 'restricted',
            access: 'forbidden',
            auth: [],
            definitionId: 'provider-not-found'
        },
        data: $71f875462e622a15$var$_objectSpread({}, $71f875462e622a15$var$emptyData)
    };
};

});

parcelRegister("frn9t", function(module, exports) {
$parcel$export(module.exports, "ERROR_MESSAGE_OAUTH", () => $b3db561c4eeb9cf7$export$3e81ce851ffda0ad);
$parcel$export(module.exports, "ERROR_MESSAGE_FATAL", () => $b3db561c4eeb9cf7$export$45e7dda0d43d7f55);
$parcel$export(module.exports, "ERROR_MESSAGE_METADATA", () => $b3db561c4eeb9cf7$export$338f7d9ccca1975d);
var $b3db561c4eeb9cf7$export$297c39c8b9bfca0 = 'resolving';
var $b3db561c4eeb9cf7$export$b64a888338c24e0e = 'errored';
var $b3db561c4eeb9cf7$export$677b6edfa0002c70 = 'fallback';
var $b3db561c4eeb9cf7$export$3e81ce851ffda0ad = 'Provider.authFlow is not set to OAuth2.';
var $b3db561c4eeb9cf7$export$45e7dda0d43d7f55 = 'Fatal error resolving URL';
var $b3db561c4eeb9cf7$export$338f7d9ccca1975d = 'Error resolving metadata.';

});




parcelRegister("eDkLs", function(module, exports) {
$parcel$export(module.exports, "useSmartCardState", () => $aa74d091a869321b$export$b0444d00ba7313c6);

var $2hCy3 = parcelRequire("2hCy3");

var $9kTNw = parcelRequire("9kTNw");
var $aa74d091a869321b$var$PENDING_STATE = {
    status: 'pending'
};
function $aa74d091a869321b$export$b0444d00ba7313c6(url) {
    var _useSmartLinkContext = (0, $9kTNw.useSmartLinkContext)(), store = _useSmartLinkContext.store;
    var cardState = (0, $2hCy3.useSyncExternalStoreWithSelector)(store.subscribe, store.getState, store.getState, function(state) {
        return state[url];
    });
    return cardState !== null && cardState !== void 0 ? cardState : $aa74d091a869321b$var$PENDING_STATE;
}

});
parcelRegister("2hCy3", function(module, exports) {
'use strict';

module.exports = (parcelRequire("1fF0z"));

});
parcelRegister("1fF0z", function(module, exports) {
$parcel$export(module.exports, "useSyncExternalStoreWithSelector", () => $0e970089a187f9cc$export$bf730a2d8bf68b42, (v) => $0e970089a187f9cc$export$bf730a2d8bf68b42 = v);
/**
 * @license React
 * use-sync-external-store-shim/with-selector.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $0e970089a187f9cc$export$bf730a2d8bf68b42;
"use strict";

var $5FkrB = parcelRequire("5FkrB");

var $h209R = parcelRequire("h209R");
function $0e970089a187f9cc$var$is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var $0e970089a187f9cc$var$objectIs = "function" === typeof Object.is ? Object.is : $0e970089a187f9cc$var$is, $0e970089a187f9cc$var$useSyncExternalStore = $h209R.useSyncExternalStore, $0e970089a187f9cc$var$useRef = $5FkrB.useRef, $0e970089a187f9cc$var$useEffect = $5FkrB.useEffect, $0e970089a187f9cc$var$useMemo = $5FkrB.useMemo, $0e970089a187f9cc$var$useDebugValue = $5FkrB.useDebugValue;
$0e970089a187f9cc$export$bf730a2d8bf68b42 = function(subscribe, getSnapshot, getServerSnapshot, selector, isEqual) {
    var instRef = $0e970089a187f9cc$var$useRef(null);
    if (null === instRef.current) {
        var inst = {
            hasValue: !1,
            value: null
        };
        instRef.current = inst;
    } else inst = instRef.current;
    instRef = $0e970089a187f9cc$var$useMemo(function() {
        function memoizedSelector(nextSnapshot) {
            if (!hasMemo) {
                hasMemo = !0;
                memoizedSnapshot = nextSnapshot;
                nextSnapshot = selector(nextSnapshot);
                if (void 0 !== isEqual && inst.hasValue) {
                    var currentSelection = inst.value;
                    if (isEqual(currentSelection, nextSnapshot)) return memoizedSelection = currentSelection;
                }
                return memoizedSelection = nextSnapshot;
            }
            currentSelection = memoizedSelection;
            if ($0e970089a187f9cc$var$objectIs(memoizedSnapshot, nextSnapshot)) return currentSelection;
            var nextSelection = selector(nextSnapshot);
            if (void 0 !== isEqual && isEqual(currentSelection, nextSelection)) return memoizedSnapshot = nextSnapshot, currentSelection;
            memoizedSnapshot = nextSnapshot;
            return memoizedSelection = nextSelection;
        }
        var hasMemo = !1, memoizedSnapshot, memoizedSelection, maybeGetServerSnapshot = void 0 === getServerSnapshot ? null : getServerSnapshot;
        return [
            function() {
                return memoizedSelector(getSnapshot());
            },
            null === maybeGetServerSnapshot ? void 0 : function() {
                return memoizedSelector(maybeGetServerSnapshot());
            }
        ];
    }, [
        getSnapshot,
        getServerSnapshot,
        selector,
        isEqual
    ]);
    var value = $0e970089a187f9cc$var$useSyncExternalStore(subscribe, instRef[0], instRef[1]);
    $0e970089a187f9cc$var$useEffect(function() {
        inst.hasValue = !0;
        inst.value = value;
    }, [
        value
    ]);
    $0e970089a187f9cc$var$useDebugValue(value);
    return value;
};

});



parcelRegister("LjX2F", function(module, exports) {
$parcel$export(module.exports, "useSmartLinkAnalyticsContext", () => $08e3ddcfc1ab5f1e$export$ac28ada90c4970b7);
$parcel$export(module.exports, "SmartLinkAnalyticsContext", () => $08e3ddcfc1ab5f1e$export$eaff10f7ec59c455);

var $25nEq = parcelRequire("25nEq");

var $5FkrB = parcelRequire("5FkrB");

var $lrGSQ = parcelRequire("lrGSQ");

var $8dj3L = parcelRequire("8dj3L");

var $fmTNB = parcelRequire("fmTNB");

var $9kTNw = parcelRequire("9kTNw");

var $9ln9l = parcelRequire("9ln9l");

var $9Zzpd = parcelRequire("9Zzpd");

var $eDkLs = parcelRequire("eDkLs");

var $8ckEN = parcelRequire("8ckEN");
function $08e3ddcfc1ab5f1e$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $08e3ddcfc1ab5f1e$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $08e3ddcfc1ab5f1e$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $08e3ddcfc1ab5f1e$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $08e3ddcfc1ab5f1e$var$getExtendedResolvedAttributes = function getExtendedResolvedAttributes(linkDetails, details, linkStatus, error) {
    var _details$meta$definit, _details$meta, _details$meta$resourc, _details$meta2;
    return $08e3ddcfc1ab5f1e$var$_objectSpread({
        definitionId: (_details$meta$definit = details === null || details === void 0 || (_details$meta = details.meta) === null || _details$meta === void 0 ? void 0 : _details$meta.definitionId) !== null && _details$meta$definit !== void 0 ? _details$meta$definit : null,
        resourceType: (_details$meta$resourc = details === null || details === void 0 || (_details$meta2 = details.meta) === null || _details$meta2 === void 0 ? void 0 : _details$meta2.resourceType) !== null && _details$meta$resourc !== void 0 ? _details$meta$resourc : null
    }, (0, $fmTNB.getResolvedAttributes)(linkDetails, details, linkStatus, error));
};
var $08e3ddcfc1ab5f1e$var$getSmartLinkAnalyticsContext = function getSmartLinkAnalyticsContext(_ref) {
    var display = _ref.display, id = _ref.id, response = _ref.response, source = _ref.source, status = _ref.status, url = _ref.url, error = _ref.error;
    var isHyperlinkConnectExperimentEnabled = (0, $8dj3L.default).getExperimentValue('platform_linking_bluelink_connect_confluence', 'isEnabled', false) || (0, $8dj3L.default).getExperimentValue('platform_linking_bluelink_connect_jira', 'isEnabled', false);
    var resolvedAttributes = isHyperlinkConnectExperimentEnabled ? $08e3ddcfc1ab5f1e$var$getExtendedResolvedAttributes({
        url: url,
        displayCategory: display === 'url' ? 'link' : 'smartLink'
    }, response, status, error) : $08e3ddcfc1ab5f1e$var$getExtendedResolvedAttributes({
        url: url
    }, response, status, error);
    return {
        source: source,
        attributes: $08e3ddcfc1ab5f1e$var$_objectSpread($08e3ddcfc1ab5f1e$var$_objectSpread({}, (0, $8ckEN.context)), {}, {
            display: display,
            id: id
        }, resolvedAttributes)
    };
};
var $08e3ddcfc1ab5f1e$export$ac28ada90c4970b7 = function useSmartLinkAnalyticsContext(_ref2) {
    var display = _ref2.display, id = _ref2.id, source = _ref2.source, url = _ref2.url;
    var _useSmartLinkContext = (0, $9kTNw.useSmartLinkContext)(), store = _useSmartLinkContext.store;
    var state = store ? (0, $9ln9l.getUrl)(store, url) : undefined;
    return (0, $5FkrB.useMemo)(function() {
        return $08e3ddcfc1ab5f1e$var$getSmartLinkAnalyticsContext({
            display: display,
            id: id,
            response: state === null || state === void 0 ? void 0 : state.details,
            source: source,
            status: state === null || state === void 0 ? void 0 : state.status,
            url: url,
            error: state === null || state === void 0 ? void 0 : state.error
        });
    }, [
        display,
        id,
        source,
        state === null || state === void 0 ? void 0 : state.details,
        state === null || state === void 0 ? void 0 : state.status,
        url,
        state === null || state === void 0 ? void 0 : state.error
    ]);
};
var $08e3ddcfc1ab5f1e$export$eaff10f7ec59c455 = function SmartLinkAnalyticsContext(_ref3) {
    var children = _ref3.children, display = _ref3.display, id = _ref3.id, source = _ref3.source, url = _ref3.url;
    var _useSmartLinkState = (0, $eDkLs.useSmartCardState)(url), details = _useSmartLinkState.details, status = _useSmartLinkState.status, error = _useSmartLinkState.error;
    var data = $08e3ddcfc1ab5f1e$var$getSmartLinkAnalyticsContext({
        display: display,
        id: id,
        response: details,
        source: source,
        status: status,
        url: url,
        error: (0, $9Zzpd.fg)('platform_bandicoots-smartlink-unresolved-error-key') ? error : undefined
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $lrGSQ.default), {
        data: data
    }, children);
};

});
parcelRegister("fmTNB", function(module, exports) {
$parcel$export(module.exports, "getResolvedAttributes", () => $b30431a43dd838b8$export$7243431f5325a7b);

var $f48iT = parcelRequire("f48iT");

var $jGsGq = parcelRequire("jGsGq");

var $9Zzpd = parcelRequire("9Zzpd");
var $b30431a43dd838b8$export$7243431f5325a7b = function getResolvedAttributes(linkDetails, details, linkStatus, error) {
    var _details$meta$request, _details$meta, _ref, _details$meta$key, _details$meta2, _details$meta$key2, _details$meta3, _details$meta$tenantI, _details$meta4, _details$meta$activat, _details$meta5, _details$meta$contain, _details$meta6, _details$meta$categor, _details$meta7, _details$meta$product, _details$meta8, _details$meta$subprod, _details$meta9, _details$meta$objectI, _details$meta0, _details$meta$resourc, _details$meta1;
    var status = linkStatus !== null && linkStatus !== void 0 ? linkStatus : details && (0, $f48iT.getStatus)(details);
    var displayCategory = linkDetails.displayCategory === 'link' ? 'link' : (0, $jGsGq.getDisplayCategory)(status);
    return {
        status: status !== null && status !== void 0 ? status : null,
        statusDetails: (_details$meta$request = details === null || details === void 0 || (_details$meta = details.meta) === null || _details$meta === void 0 || (_details$meta = _details$meta.requestAccess) === null || _details$meta === void 0 ? void 0 : _details$meta.accessType) !== null && _details$meta$request !== void 0 ? _details$meta$request : null,
        displayCategory: displayCategory,
        extensionKey: (0, $9Zzpd.fg)('platform_bandicoots-smartlink-unresolved-error-key') ? (_ref = (_details$meta$key = details === null || details === void 0 || (_details$meta2 = details.meta) === null || _details$meta2 === void 0 ? void 0 : _details$meta2.key) !== null && _details$meta$key !== void 0 ? _details$meta$key : error === null || error === void 0 ? void 0 : error.extensionKey) !== null && _ref !== void 0 ? _ref : null : (_details$meta$key2 = details === null || details === void 0 || (_details$meta3 = details.meta) === null || _details$meta3 === void 0 ? void 0 : _details$meta3.key) !== null && _details$meta$key2 !== void 0 ? _details$meta$key2 : null,
        destinationTenantId: (_details$meta$tenantI = details === null || details === void 0 || (_details$meta4 = details.meta) === null || _details$meta4 === void 0 ? void 0 : _details$meta4.tenantId) !== null && _details$meta$tenantI !== void 0 ? _details$meta$tenantI : null,
        destinationActivationId: (_details$meta$activat = details === null || details === void 0 || (_details$meta5 = details.meta) === null || _details$meta5 === void 0 ? void 0 : _details$meta5.activationId) !== null && _details$meta$activat !== void 0 ? _details$meta$activat : null,
        destinationContainerId: (_details$meta$contain = details === null || details === void 0 || (_details$meta6 = details.meta) === null || _details$meta6 === void 0 ? void 0 : _details$meta6.containerId) !== null && _details$meta$contain !== void 0 ? _details$meta$contain : null,
        destinationCategory: (_details$meta$categor = details === null || details === void 0 || (_details$meta7 = details.meta) === null || _details$meta7 === void 0 ? void 0 : _details$meta7.category) !== null && _details$meta$categor !== void 0 ? _details$meta$categor : null,
        destinationProduct: (_details$meta$product = details === null || details === void 0 || (_details$meta8 = details.meta) === null || _details$meta8 === void 0 ? void 0 : _details$meta8.product) !== null && _details$meta$product !== void 0 ? _details$meta$product : null,
        destinationSubproduct: (_details$meta$subprod = details === null || details === void 0 || (_details$meta9 = details.meta) === null || _details$meta9 === void 0 ? void 0 : _details$meta9.subproduct) !== null && _details$meta$subprod !== void 0 ? _details$meta$subprod : null,
        destinationObjectId: (_details$meta$objectI = details === null || details === void 0 || (_details$meta0 = details.meta) === null || _details$meta0 === void 0 ? void 0 : _details$meta0.objectId) !== null && _details$meta$objectI !== void 0 ? _details$meta$objectI : null,
        destinationObjectType: (_details$meta$resourc = details === null || details === void 0 || (_details$meta1 = details.meta) === null || _details$meta1 === void 0 ? void 0 : _details$meta1.resourceType) !== null && _details$meta$resourc !== void 0 ? _details$meta$resourc : null,
        canBeDatasource: ((details === null || details === void 0 ? void 0 : details.datasources) || []).length > 0
    };
};

});
parcelRegister("jGsGq", function(module, exports) {
$parcel$export(module.exports, "getDisplayCategory", () => $e548307650dae0aa$export$28ddbae335bd80b5);
var $e548307650dae0aa$export$28ddbae335bd80b5 = function getDisplayCategory(status) {
    return !status || status !== 'not_found' ? 'smartLink' : 'link';
};

});


parcelRegister("9ln9l", function(module, exports) {
$parcel$export(module.exports, "getUrl", () => $6cd808435806d039$export$94df0e59ebebf4a7);
var $6cd808435806d039$export$94df0e59ebebf4a7 = function getUrl(store, url) {
    return store.getState()[url] || {
        status: 'pending'
    };
};

});


parcelRegister("fFOdD", function(module, exports) {
$parcel$export(module.exports, "useFire3PWorkflowsClickEvent", () => $b691a3c960387934$export$e682245dc886cff2);

var $5FkrB = parcelRequire("5FkrB");

var $cOsWw = parcelRequire("cOsWw");

var $8ckEN = parcelRequire("8ckEN");
function $b691a3c960387934$export$ed70996d478e16d3() {
    /**
   * this utility maybe extended in the future to include
   * more contextual info about SLs
   */ var events = (0, $5FkrB.useMemo)(function() {
        return new (0, $8ckEN.SmartLinkEvents)();
    }, []);
    return events;
}
function $b691a3c960387934$export$e682245dc886cff2(firstPartyIdentifier, thirdPartyARI) {
    var _useAnalyticsEventsNe = (0, $cOsWw.useAnalyticsEvents)(), createAnalyticsEvent = _useAnalyticsEventsNe.createAnalyticsEvent;
    return function() {
        var smartlinkClickAnalyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'smartLink',
            actionSubjectId: 'smartlinkClickAnalyticsWorkflows',
            eventType: 'ui',
            attributes: {
                eventName: 'smartLinkClickAnalyticsThirdPartyWorkflows',
                firstPartyIdentifier: firstPartyIdentifier
            },
            nonPrivacySafeAttributes: {
                thirdPartyARI: thirdPartyARI
            }
        });
        smartlinkClickAnalyticsEvent.fire('media');
    };
}

});

parcelRegister("aSVEw", function(module, exports) {
$parcel$export(module.exports, "messages", () => $7ecbab23daaa9fc5$export$defe85febe8b728c);

var $aRMzY = parcelRequire("aRMzY");
var $7ecbab23daaa9fc5$export$defe85febe8b728c = (0, $aRMzY.defineMessages)({
    actions: {
        id: 'fabric.linking.actions',
        defaultMessage: 'Actions',
        description: ''
    },
    add_account: {
        id: 'fabric.linking.add_account',
        defaultMessage: 'Add account',
        description: 'Allows to add a new account'
    },
    ai_summarize: {
        id: 'fabric.linking.ai_summarize',
        defaultMessage: 'Summarize',
        description: 'Action to summarize link resource content with AI'
    },
    ai_summarized: {
        id: 'fabric.linking.ai_summarized',
        defaultMessage: 'Summarized by Atlassian Intelligence',
        description: 'Shown with the content summarised by AI.'
    },
    ai_summarized_abbreviation: {
        id: 'fabric.linking.ai_summarized_abbreviation',
        defaultMessage: 'Summarized by AI',
        description: 'Shown with the content summarised by AI. AI is in abbreviation form to reduce space.'
    },
    ai_summarized_info: {
        id: 'fabric.linking.ai_summarized_info',
        defaultMessage: 'Information quality may vary. <a>Learn more</a>',
        description: 'Additional info about the content summarised by AI.'
    },
    ai_summarized_info_short: {
        id: 'fabric.linking.ai_summarized_info_short',
        defaultMessage: 'Content quality may vary',
        description: 'Additional info about the content summarised by AI.'
    },
    ai_summarizing: {
        id: 'fabric.linking.ai_summarizing',
        defaultMessage: 'Atlassian Intelligence is working...',
        description: 'Shown when AI summary is summarising the link resource content.'
    },
    ai_summary_error_generic: {
        id: 'fabric.linking.ai_summary_error_generic',
        defaultMessage: "Atlassian Intelligence (AI) isn\u2019t responding. Try again later or <a>check the status of AI</a>.",
        description: 'Shown when AI Summary encountered an unexpected error while summarizing the linked resource content.'
    },
    ai_summary_error_acceptable_use_violation: {
        id: 'fabric.linking.ai_summary_error_acceptable_use_violation',
        defaultMessage: "We cannot show the results of this summary as it goes against <a>Atlassian's Acceptable Use Policy</a>.",
        description: 'Shown when AI summary is summarising the link resource content and the content violates atlassians acceptable use policy.'
    },
    ai_summary_error_hipaa_content_detected: {
        id: 'fabric.linking.ai_summary_error_hipaa_content_detected',
        defaultMessage: 'Atlassian Intelligence was unable to process your request as your content contains links to HIPAA restricted content.',
        description: 'Shown when the AI summary is summarising the link resource content and the content contains HIPAA restricted content.'
    },
    ai_summary_error_exceeding_context_length_error: {
        id: 'fabric.linking.ai_summary_error_exceeding_context_length_error',
        defaultMessage: "Atlassian Intelligence can't generate a summary for you right now as there is too much content to summarize.",
        description: 'Shown when the AI summary is summarising the link resource content and the content is too large to summarize.'
    },
    assigned_to: {
        id: 'fabric.linking.assigned_to',
        defaultMessage: 'Assigned to {context}',
        description: 'Indicates the person or entity that the resource is assigned to.'
    },
    automation_action_title: {
        id: 'fabric.linking.automation-action.title',
        defaultMessage: 'View automation rules',
        description: 'The title of the button in a hover card to open an automation menu for a given SmartLink.'
    },
    automation_action_icon_label: {
        id: 'fabric.linking.automation-action.icon.label',
        defaultMessage: 'Automation icon',
        description: 'The label for the automation icon inside of the button opening the automation menu.'
    },
    automation_action_tooltip: {
        id: 'fabric.linking.automation-action.tooltip',
        defaultMessage: 'Select an automation rule to run',
        description: 'The tooltip for the automation action indicating that a button will open an automation modal.'
    },
    automation_action_confluence_page_modal_title: {
        id: 'fabric.linking.automation-action.confluence.page.modal.title',
        defaultMessage: 'Page automations',
        description: 'The title of the automation modal when the SmartLink is a Confluence page'
    },
    automation_action_confluence_page_modal_description: {
        id: 'fabric.linking.automation-action.confluence.page.modal.description',
        defaultMessage: 'Apply an automation to <b>{name}</b>.{br}The available selections are controlled by Confluence and space administrators.',
        description: 'The description in the automation modal when the SmartLink is a Confluence page. Indicating which page the automation will apply to, and who controls the available automations.'
    },
    cancel: {
        id: 'fabric.linking.cancel',
        defaultMessage: 'Cancel',
        description: 'cancel'
    },
    beta: {
        id: 'fabric.linking.beta',
        defaultMessage: 'Beta',
        description: 'Indicates a beta phase of the feature.'
    },
    cannot_connect: {
        id: 'fabric.linking.cannot_connect',
        defaultMessage: "Can't connect, try again",
        description: 'Error for when a provided link is not found.'
    },
    cannot_find_link: {
        id: 'fabric.linking.cannot_find_link',
        defaultMessage: "Can't find link",
        description: 'Error for when a provided link is not found.'
    },
    click_to_join: {
        id: 'fabric.linking.click_to_join',
        defaultMessage: 'Join {context}',
        description: 'Allows the user join the product or service immediately'
    },
    click_to_join_description: {
        id: 'fabric.linking.click_to_join_description',
        defaultMessage: "You've been approved, so you can join {context} right away.",
        description: 'Informs the user that they have access to this product, and can sign up or join right away.'
    },
    close: {
        id: 'fabric.linking.close',
        defaultMessage: 'Close',
        description: ''
    },
    check_this_link: {
        id: 'fabric.linking.check_this_link',
        defaultMessage: 'Check this link',
        description: 'Link safety warning modal header'
    },
    compass_applied_components_count: {
        id: 'compass.applied_components_count.non-final',
        defaultMessage: 'Applied to {numberOfComponents, plural, one {{numberOfComponents, number} component}  other {{numberOfComponents, number} components}}'
    },
    connect_to: {
        id: 'fabric.linking.connect_to',
        defaultMessage: 'Connect to {name}',
        description: 'Allows the user to connect with different types of external services'
    },
    connect_account_description: {
        id: 'fabric.linking.connect_account_description',
        defaultMessage: "We'll open a new page to help you connect your {name} account",
        description: 'Explains what will happen when the users connects to a new account'
    },
    connect_link_account: {
        id: 'fabric.linking.connect_link_account',
        defaultMessage: 'Connect to preview',
        description: 'Shown when a user does not have access to a link, but can connect their external account to view the link.'
    },
    connect_link_account_card: {
        id: 'fabric.linking.connect_link_account_card_view',
        defaultMessage: 'Connect',
        description: 'Shown when a user does not have access to a link, but can connect their external account to view the link on card view.'
    },
    connect_link_account_card_name: {
        id: 'fabric.linking.connect_link_account_card_view_name',
        defaultMessage: 'Connect your {context} account',
        description: 'Shown when a user does not have access to a link, but can connect their external account to view the link on card view. Displayed in title.'
    },
    connect_link_account_card_description: {
        id: 'fabric.linking.connect_link_account_card_view_description',
        defaultMessage: 'To show a preview of this link, connect your {context} account.',
        description: 'Shown when a user does not have access to a link, but can connect their external account to view the link on card view. Displayed in byline.'
    },
    connect_unauthorised_account_action: {
        id: 'fabric.linking.connect_unauthorised_account_action',
        defaultMessage: 'Connect to {context}',
        description: 'Shown on a button to connect user external account to their Atlassian account.'
    },
    connect_unauthorised_account_description: {
        id: 'fabric.linking.connect_unauthorised_account_description',
        defaultMessage: 'Connect your {context} account to collaborate on work across Atlassian products.',
        description: 'Shown when a user does not have access to a link, but can connect their external account to view the link on card view.'
    },
    connect_unauthorised_account_description_no_provider: {
        id: 'fabric.linking.connect_unauthorised_account_description_no_provider',
        defaultMessage: 'Connect your account to collaborate on work across Atlassian products.',
        description: 'Shown when a user does not have access to a link, but can connect their external account to view the link on card view and we do not have the providers name.'
    },
    continue: {
        id: 'fabric.linking.continue',
        defaultMessage: 'Continue',
        description: 'continue'
    },
    copy_url_to_clipboard: {
        id: 'fabric.linking.copy_url_to_clipboard',
        defaultMessage: 'Copy link',
        description: ''
    },
    copied_url_to_clipboard: {
        id: 'fabric.linking.copied_url_to_clipboard',
        defaultMessage: 'Copied!',
        description: 'Url has been copied to the clipboard'
    },
    could_not_load_link: {
        id: 'fabric.linking.couldnt_load_link',
        defaultMessage: "We couldn't load this link for an unknown reason.",
        description: 'Error case for card view - link could not be loaded.'
    },
    created_by: {
        id: 'fabric.linking.created_by',
        defaultMessage: 'Created by {context}',
        description: 'Indicates the person or entity that created the resource.'
    },
    created_on_relative: {
        id: 'fabric.linking.create_on_relative',
        defaultMessage: 'Created {context}',
        description: 'Indicated when entity was created (relative form)'
    },
    created_on_absolute: {
        id: 'fabric.linking.create_on_absolute',
        defaultMessage: 'Created on {context}',
        description: 'Indicated when entity was created (absolute form)'
    },
    delete: {
        id: 'fabric.linking.delete',
        defaultMessage: 'Delete',
        description: 'Allow a user to delete a link'
    },
    download: {
        id: 'fabric.linking.download',
        defaultMessage: 'Download',
        description: ''
    },
    download_description: {
        id: 'fabric.linking.download_description',
        defaultMessage: 'Download this file into your local storage',
        description: 'Description on what Download does'
    },
    download_file: {
        id: 'fabric.linking.download_file',
        defaultMessage: 'Download file',
        description: 'Allow a user to download a file'
    },
    ai_summary_action: {
        id: 'fabric.linking.ai_summary_action',
        defaultMessage: 'Summarize with AI',
        description: 'Allow a user to summarize a link'
    },
    ai_summary_action_description: {
        id: 'fabric.linking.ai_summary_action_description',
        defaultMessage: 'Summarize the content of this link using Atlassian Intelligence.',
        description: 'Description of what the summarize link with AI action does'
    },
    copy_summary_action: {
        id: 'fabric.linking.copy_summary_action',
        defaultMessage: 'Copy summary',
        description: 'Allow a user to copy a generated summary'
    },
    copy_summary_action_description: {
        id: 'fabric.linking.copy_summary_action_description',
        defaultMessage: 'Copy summary',
        description: 'Description of what the copy summary AI action does'
    },
    copied_summary_action_description: {
        id: 'fabric.linking.copied_summary_action_description',
        defaultMessage: 'Copied summary to clipboard',
        description: 'Confirmation to the user that the summry has been copied'
    },
    edit: {
        id: 'fabric.linking.edit',
        defaultMessage: 'Edit',
        description: 'Allow a user to edit a link'
    },
    follow: {
        id: 'fabric.linking.follow',
        defaultMessage: 'Follow',
        description: 'Click to follow a project.'
    },
    follow_project_description: {
        id: 'fabric.linking.follow_project_description',
        defaultMessage: 'Follow to get notifications on this project',
        description: 'Description on what Follow does'
    },
    follow_project: {
        id: 'fabric.linking.follow_project',
        defaultMessage: 'Follow project',
        description: 'Click to follow a project.'
    },
    follow_project_error: {
        id: 'fabric.linking.follow_project_error',
        defaultMessage: 'We encountered an error while trying to follow the project. Check your connection or refresh the page and try again.',
        description: 'Shown when an unknown error occurs when following an Atlas project'
    },
    follow_goal_description: {
        id: 'fabric.linking.follow_goal_description',
        defaultMessage: 'Follow this goal to get notifications on updates',
        description: 'Description on what Follow does'
    },
    follow_goal: {
        id: 'fabric.linking.follow_goal',
        defaultMessage: 'Follow goal',
        description: 'Click to follow a project.'
    },
    follow_goal_error: {
        id: 'fabric.linking.follow_goal_error',
        defaultMessage: 'We encountered an error while trying to follow the goal. Check your connection or refresh the page and try again.',
        description: 'Shown when an unknown error occurs when following an Atlas goal'
    },
    go_back: {
        id: 'fabric.linking.go_back',
        defaultMessage: 'Go back',
        description: 'go back'
    },
    invalid_permissions: {
        id: 'fabric.linking.invalid_permissions',
        defaultMessage: 'Restricted content',
        description: 'Message shown when a user does not have permissions to view an item'
    },
    invalid_permissions_description: {
        id: 'fabric.linking.invalid_permissions_description',
        defaultMessage: "You'll need to request access or try a different account to view this preview.",
        description: 'Message shown when a user does not have permissions to view an item. Displayed as description.'
    },
    join_to_view: {
        id: 'fabric.linking.join_to_view',
        defaultMessage: 'Join {context} to view this issue',
        description: 'Allows the user join the product or service immediately'
    },
    learn_more_about_smart_links: {
        id: 'fabric.linking.learn_more_about_smart_links',
        defaultMessage: 'Learn more about Smart Links.',
        description: 'An anchor link to redirect user to a page about Smart Links.'
    },
    learn_more_about_connecting_account: {
        id: 'fabric.linking.learn_more_about_connecting_account',
        defaultMessage: 'Learn more about connecting your account to Atlassian products.',
        description: 'An anchor link to redirect user to a page about authorization with 3rd party accounts.'
    },
    loading: {
        id: 'fabric.linking.loading',
        defaultMessage: 'Loading...',
        description: 'Indicates an element on a page is loading.'
    },
    modified_by: {
        id: 'fabric.linking.updated_by',
        defaultMessage: 'Modified by {context}',
        description: 'Indicates the person or entity that modified the resource.'
    },
    modified_on_relative: {
        id: 'fabric.linking.modified_on_relative',
        defaultMessage: 'Updated {context}',
        description: 'Indicated when entity was modified (relative form)'
    },
    modified_on_absolute: {
        id: 'fabric.linking.modified_on_absolute',
        defaultMessage: 'Updated on {context}',
        description: 'Indicated when entity was modified (absolute form)'
    },
    more_actions: {
        id: 'fabric.linking.more_actions',
        defaultMessage: 'More actions',
        description: 'Allows the users to see more link actions'
    },
    open_issue_in_jira: {
        id: 'fabric.linking.open_issue_in_jira',
        defaultMessage: 'Open issue in Jira',
        description: 'Click to open link in Jira'
    },
    open_link_in_a_new_tab: {
        id: 'fabric.linking.open_link_in_a_new_tab',
        defaultMessage: 'Open link in a new tab',
        description: 'Click to open link in a new tab'
    },
    owned_by: {
        id: 'fabric.linking.owned_by',
        defaultMessage: 'Owned by {context}',
        description: 'Indicates the person or entity that owns or maintains the resource.'
    },
    owned_by_override: {
        id: 'fabric.linking.owned_by_override',
        defaultMessage: 'By {context}',
        description: 'Indicates the person or entity that owns or maintains the resource.'
    },
    preview_description: {
        id: 'fabric.linking.preview_description',
        defaultMessage: 'Open a full screen preview of this link',
        description: 'Description on what Preview does'
    },
    preview_improved: {
        id: 'fabric.linking.preview_improved',
        defaultMessage: 'Open preview',
        description: 'Click to view a richer view of your content, without needing to navigate to it.'
    },
    preview_modal: {
        id: 'fabric.linking.preview_modal',
        defaultMessage: 'Open preview modal',
        description: 'Button used to view a modal view of your content without needing to navigate to it.'
    },
    preview_panel: {
        id: 'fabric.linking.preview_panel',
        defaultMessage: 'Open preview panel',
        description: 'Button used to view a side panel view of your content without needing to navigate to it.'
    },
    preview_close: {
        id: 'fabric.linking.preview_close',
        defaultMessage: 'Close preview',
        description: 'Click to close embed preview modal.'
    },
    preview_max_size: {
        id: 'fabric.linking.preview_max_size',
        defaultMessage: 'View full screen',
        description: 'Click to increase embed preview modal size to a maximum viewing size.'
    },
    preview_min_size: {
        id: 'fabric.linking.preview_min_size',
        defaultMessage: 'Close full screen',
        description: 'Click to decrease embed preview modal size to a minimum viewing size.'
    },
    priority_blocker: {
        id: 'fabric.linking.priority_blocker',
        defaultMessage: 'Blocker',
        description: 'Indicated priority as blocker'
    },
    priority_critical: {
        id: 'fabric.linking.priority_critical',
        defaultMessage: 'Critical',
        description: 'Indicated priority as critical'
    },
    priority_high: {
        id: 'fabric.linking.priority_high',
        defaultMessage: 'High',
        description: 'Indicated priority as high'
    },
    priority_highest: {
        id: 'fabric.linking.priority_highest',
        defaultMessage: 'Highest',
        description: 'Indicated priority as highest'
    },
    priority_low: {
        id: 'fabric.linking.priority_low',
        defaultMessage: 'Low',
        description: 'Indicated priority as low'
    },
    priority_lowest: {
        id: 'fabric.linking.priority_lowest',
        defaultMessage: 'Lowest',
        description: 'Indicated priority as lowest'
    },
    priority_major: {
        id: 'fabric.linking.priority_major',
        defaultMessage: 'Major',
        description: 'Indicated priority as major'
    },
    priority_medium: {
        id: 'fabric.linking.priority_medium',
        defaultMessage: 'Medium',
        description: 'Indicated priority as medium'
    },
    priority_minor: {
        id: 'fabric.linking.priority_minor',
        defaultMessage: 'Minor',
        description: 'Indicated priority as minor'
    },
    priority_trivial: {
        id: 'fabric.linking.priority_trivial',
        defaultMessage: 'Trivial',
        description: 'Indicated priority as trivial'
    },
    priority_undefined: {
        id: 'fabric.linking.priority_undefined',
        defaultMessage: 'Undefined',
        description: 'Indicated priority as unknown'
    },
    forbidden_access: {
        id: 'fabric.linking.forbidden_access',
        defaultMessage: 'Your access is forbidden',
        description: 'Shown when a user does not have access to a resource behind the link.'
    },
    pending_request: {
        id: 'fabric.linking.pending_request',
        defaultMessage: 'Your access request is pending',
        description: 'Shown when a user has requested an access but status is pending.'
    },
    read_time: {
        id: 'fabric.linking.read_time',
        defaultMessage: '{context} min read',
        description: 'Estimated time to read this resource'
    },
    restricted_link: {
        id: 'fabric.linking.restricted_link',
        defaultMessage: 'Restricted link, try another account',
        description: 'Message shown when a user does not have permissions to view an item'
    },
    request_access_to_view: {
        id: 'fabric.linking.request_access_to_view',
        defaultMessage: 'Request access to {context} to view this issue',
        description: 'Allows the user to request access to a product or service'
    },
    request_denied: {
        id: 'fabric.linking.request_denied',
        defaultMessage: 'Your access request was denied',
        description: 'The user had request access but the request was denied by a product or service'
    },
    retry: {
        id: 'fabric.linking.retry',
        defaultMessage: 'Retry',
        description: 'Allows user to perform an action again'
    },
    save: {
        id: 'fabric.linking.save',
        defaultMessage: 'Save',
        description: 'Just the "save" word'
    },
    sent_on_relative: {
        id: 'fabric.linking.sent_on_relative',
        defaultMessage: 'Sent {context}',
        description: 'Indicated when entity was sent (relative form)'
    },
    sent_on_absolute: {
        id: 'fabric.linking.sent_on_absolute',
        defaultMessage: 'Sent on {context}',
        description: 'Indicated when entity was sent (absolute form)'
    },
    status_change_load_error: {
        id: 'fabric.linking.status_change_load_error',
        defaultMessage: "We couldn\u2019t load the statuses and transitions",
        description: 'Informs the user that the loading of status transitions failed'
    },
    status_change_permission_error: {
        id: 'fabric.linking.status_change_permission_error',
        defaultMessage: "You don\u2019t have permission to transition this issue. ",
        description: 'Informs the user that they do not have enough permissions to update a status'
    },
    status_change_update_error: {
        id: 'fabric.linking.status_change_update_error',
        defaultMessage: "We couldn\u2019t update the status",
        description: "Occurs when a user tries to update an issue's status but fails to do so"
    },
    try_again: {
        id: 'fabric.linking.try_again',
        defaultMessage: 'Try again',
        description: 'Allow the user to try an action again'
    },
    try_another_account: {
        id: 'fabric.linking.try_another_account',
        defaultMessage: 'Try another account',
        description: 'Allows the user to try an action again with a different account'
    },
    link_safety_warning_message: {
        id: 'fabric.linking.link_safety_warning_message',
        defaultMessage: 'The link {unsafeLinkText} is taking you to a different site, <a>actual link here</a>',
        description: 'Link safety check warning message'
    },
    unauthorised_account_description: {
        id: 'fabric.linking.unauthorised_account_description',
        defaultMessage: "You're trying to preview a link to a private {context} page. We recommend you review the URL or contact the page owner.",
        description: 'Explains that user does not have access to a link.'
    },
    unauthorised_account_description_no_provider: {
        id: 'fabric.linking.unauthorised_account_description_no_provider',
        defaultMessage: "You're trying to preview a link to a private page. We recommend you review the URL or contact the page owner.",
        description: 'Explains that user does not have access to a link.'
    },
    unauthorised_account_name: {
        id: 'fabric.linking.unauthorised_account_name',
        defaultMessage: "We can't display private pages from {context}",
        description: 'Shown when a user does not have access to a link.'
    },
    unauthorised_account_name_no_provider: {
        id: 'fabric.linking.unauthorised_account_name_no_provider',
        defaultMessage: "We can't display private pages",
        description: 'Shown when a user does not have access to a link.'
    },
    unassigned: {
        id: 'fabric.linking.unassigned',
        defaultMessage: 'Unassigned',
        description: 'Shown as a tooltip text for a default unassigned fallback avatar'
    },
    unfollow: {
        id: 'fabric.linking.unfollow',
        defaultMessage: 'Unfollow',
        description: 'Click to unfollow a project.'
    },
    unfollow_project_description: {
        id: 'fabric.linking.unfollow_project_description',
        defaultMessage: 'Unfollow to stop receiving project notifications',
        description: 'Description on what Unfollow does'
    },
    unfollow_project: {
        id: 'fabric.linking.unfollow_project',
        defaultMessage: 'Unfollow project',
        description: 'Click to unfollow a project.'
    },
    unfollow_project_error: {
        id: 'fabric.linking.unfollow_project_error',
        defaultMessage: 'We encountered an error while trying to unfollow the project. Check your connection or refresh the page and try again.',
        description: 'Shown when an unknown error occurs when unfollowing an Atlas project'
    },
    unfollow_goal_description: {
        id: 'fabric.linking.unfollow_goal_description',
        defaultMessage: 'Unfollow to stop receiving notifications for this goal',
        description: 'Description on what Unfollow does'
    },
    unfollow_goal: {
        id: 'fabric.linking.unfollow_goal',
        defaultMessage: 'Unfollow goal',
        description: 'Click to unfollow a project.'
    },
    unfollow_goal_error: {
        id: 'fabric.linking.unfollow_goal_error',
        defaultMessage: 'We encountered an error while trying to unfollow the goal. Check your connection or refresh the page and try again.',
        description: 'Shown when an unknown error occurs when unfollowing an Atlas goal'
    },
    unlink_account: {
        id: 'fabric.linking.unlink_account',
        defaultMessage: 'Unlink Account',
        description: 'Allows to remove a connected account from the user'
    },
    view: {
        id: 'fabric.linking.view',
        defaultMessage: 'View',
        description: 'Go through to a piece of content to view it in its original context.'
    },
    viewIn: {
        id: 'fabric.linking.srclink',
        defaultMessage: 'View in',
        description: 'We have a link in our preview modals to the original document. This text goes before the provider name'
    },
    viewOriginal: {
        id: 'fabric.linking.srclinkunknown',
        defaultMessage: 'View Original',
        description: "We have a link in our preview modals to the original document. This is for when we don't know the provider name"
    },
    default_no_access_title: {
        id: 'fabric.linking.no_access_title',
        defaultMessage: 'Join {product} to view this content',
        description: 'Informs the user that they dont have access to certain content'
    },
    direct_access_title: {
        id: 'fabric.linking.direct_access_title',
        defaultMessage: 'Join {product} to view this content',
        description: 'Informs the user that they have access to this product, and can sign up or join right away.'
    },
    direct_access_description: {
        id: 'fabric.linking.direct_access_description',
        defaultMessage: 'Your team uses {product} to collaborate and you can start using it right away!',
        description: 'Informs the user that they have access to this product, and can sign up or join right away.'
    },
    direct_access: {
        id: 'fabric.linking.direct_access',
        defaultMessage: 'Join now',
        description: 'Allows the user join the product or service immediately'
    },
    request_access_description: {
        id: 'fabric.linking.request_access_description',
        defaultMessage: 'Your team uses {product} to collaborate. Send your admin a request for access.',
        description: 'Informs the user to request access to a product by talking to the website administrator'
    },
    request_access: {
        id: 'fabric.linking.request_access',
        defaultMessage: 'Request access',
        description: 'Allows the user to request access to a product or service'
    },
    request_access_pending_title: {
        id: 'fabric.linking.request_access_pending_title',
        defaultMessage: 'Access to {product} is pending',
        description: 'Informs the user that their request to view this content is pending'
    },
    request_access_pending_description: {
        id: 'fabric.linking.request_access_pending_description',
        defaultMessage: 'Your request to access {hostname} is awaiting admin approval.',
        description: 'Informs the user that their request to view this content is pending website administrator approval'
    },
    request_access_pending: {
        id: 'fabric.linking.request_access_pending',
        defaultMessage: 'Pending approval',
        description: 'Informs the user that their request to view this content is pending'
    },
    request_denied_description: {
        id: 'fabric.linking.request_denied_description',
        defaultMessage: "Your admin didn't approve your request to view {product} pages from {hostname}.",
        description: 'Informs the user that their request to view this content was denied'
    },
    access_exists_description: {
        id: 'fabric.linking.access_exists_description',
        defaultMessage: 'Request access to view this content from {hostname}.',
        description: 'Informs the user to contact the website administrator to request access to a product'
    },
    not_found_description: {
        id: 'fabric.linking.not_found_description',
        defaultMessage: "The page doesn't exist or it may have changed after this link was added.",
        description: 'Error case for when a provided item is not found within the list of items'
    },
    not_found_title: {
        id: 'fabric.linking.not_found_title',
        defaultMessage: "We can't show you this {product} page",
        description: 'Error case for when a provided link is not found'
    },
    forbidden_title: {
        id: 'fabric.linking.forbidden_title',
        defaultMessage: "You don't have access to this content",
        description: 'Informs the user that they do not have access to the linked content.'
    },
    forbidden_description: {
        id: 'fabric.linking.forbidden_description',
        defaultMessage: 'Contact your admin to request access to {hostname}.',
        description: 'Informs the user that they must contact the site administrator for access.'
    },
    related: {
        id: 'fabric.linking.related',
        defaultMessage: 'Related',
        description: 'Informs the user about related resources'
    },
    generic_error_message: {
        id: 'fabric.linking.generic_error_message',
        defaultMessage: 'An error occurred',
        description: 'A generic error message to the user'
    },
    related_links_modal_title: {
        id: 'fabric.linking.related_links_modal_title',
        defaultMessage: 'Related links',
        description: 'Shown as the title for the related links modal'
    },
    related_links_view_related_urls: {
        id: 'fabric.linking.related_links_view_related_urls',
        defaultMessage: 'View recent links',
        description: 'Action to view related links to the given resource'
    },
    related_links_view_related_links: {
        id: 'fabric.linking.related_links_view_related_links',
        defaultMessage: 'View related links',
        description: 'Action to view related links to the given resource'
    },
    related_links_found_in: {
        id: 'fabric.linking.related_links_found_in',
        defaultMessage: 'Found in',
        description: 'Informs the user of the resources are found in the given url'
    },
    related_links_not_found: {
        id: 'fabric.linking.related_links_not_found',
        defaultMessage: "We didn't find any links to show here.",
        description: 'Informs the user that there are no related resources for the given url'
    },
    related_links_includes_links_to: {
        id: 'fabric.linking.related_links_includes_links_to',
        defaultMessage: 'Includes links to',
        description: 'Informs the user of the resources the url links to'
    },
    related_links_modal_error_title: {
        id: 'fabric.linking.related_links_modal_error_title',
        defaultMessage: "We're having trouble loading related links",
        description: 'Title for related links error'
    },
    related_links_modal_unavailable_title: {
        id: 'fabric.linking.related_links_modal_unavailable_title',
        defaultMessage: "We couldn't find any related links",
        description: 'Title for related links error'
    },
    related_links_modal_error_description: {
        id: 'fabric.linking.related_links_modal_error_description',
        defaultMessage: 'Check your connection or refresh the page to try again',
        description: 'Informs the user that there was a problem loading related links'
    },
    related_links_modal_unavailable_description: {
        id: 'fabric.linking.related_links_modal_unavailable_description',
        defaultMessage: 'We continuously review and add related links for updated pages or other content types',
        description: 'Informs the user that there was a problem loading related links'
    },
    join_to_viewIssueTermRefresh: {
        id: 'fabric.linking.join_to_view-issue-term-refresh',
        defaultMessage: 'Join {context} to view this work item',
        description: 'Allows the user join the product or service immediately'
    },
    open_issue_in_jiraIssueTermRefresh: {
        id: 'fabric.linking.open_issue_in_jira-issue-term-refresh',
        defaultMessage: 'Open work item in Jira',
        description: 'Click to open link in Jira'
    },
    request_access_to_viewIssueTermRefresh: {
        id: 'fabric.linking.request_access_to_view-issue-term-refresh',
        defaultMessage: 'Request access to {context} to view this work item',
        description: 'Allows the user to request access to a product or service'
    },
    status_change_permission_errorIssueTermRefresh: {
        id: 'fabric.linking.status_change_permission_error-issue-term-refresh',
        defaultMessage: "You don\u2019t have permission to transition this work item. ",
        description: 'Informs the user that they do not have enough permissions to update a status'
    },
    team_members_count: {
        id: 'fabric.linking.team_members_count',
        defaultMessage: '{context} members',
        description: 'Indicates the count of team member'
    },
    user_attributes: {
        id: 'fabric.linking.user_attributes',
        defaultMessage: '{context}',
        description: 'Displays user attributes like role, department, location, and pronouns'
    },
    follow_project_descriptionGalaxia: {
        id: 'fabric.linking.follow_project_description-galaxia',
        defaultMessage: 'Follow to get notifications on this space',
        description: 'Description on what Follow does'
    },
    follow_project_errorGalaxia: {
        id: 'fabric.linking.follow_project_error-galaxia',
        defaultMessage: 'We encountered an error while trying to follow the space. Check your connection or refresh the page and try again.',
        description: 'Shown when an unknown error occurs when following an Atlas project'
    },
    unfollow_project_descriptionGalaxia: {
        id: 'fabric.linking.unfollow_project_description-galaxia',
        defaultMessage: 'Unfollow to stop receiving space notifications',
        description: 'Description on what Unfollow does'
    },
    unfollow_project_errorGalaxia: {
        id: 'fabric.linking.unfollow_project_error-galaxia',
        defaultMessage: 'We encountered an error while trying to unfollow the space. Check your connection or refresh the page and try again.',
        description: 'Shown when an unknown error occurs when unfollowing an Atlas project'
    },
    connect_unauthorised_account_description_appify: {
        id: 'fabric.linking.connect_unauthorised_account_description-appify',
        defaultMessage: 'Connect your {context} account to collaborate on work across Atlassian apps.',
        description: 'Shown when a user does not have access to a link, but can connect their external account to view the link on card view.'
    },
    connect_unauthorised_account_description_no_provider_appify: {
        id: 'fabric.linking.connect_unauthorised_account_description_no_provider-appify',
        defaultMessage: 'Connect your account to collaborate on work across Atlassian apps.',
        description: 'Shown when a user does not have access to a link, but can connect their external account to view the link on card view and we do not have the providers name.'
    },
    learn_more_about_connecting_account_appify: {
        id: 'fabric.linking.learn_more_about_connecting_account-appify',
        defaultMessage: 'Learn more about connecting your account to Atlassian apps.',
        description: 'An anchor link to redirect user to a page about authorization with 3rd party accounts.'
    },
    learn_more_about_connecting_account_experiment_shorter: {
        id: 'fabric.linking.learn_more_about_connecting_account_experiment_short',
        defaultMessage: 'Turn your URLs into rich, interactive previews.',
        description: 'An anchor link to redirect user to a page about authorization with 3rd party accounts.'
    }
});

});

parcelRegister("h4cku", function(module, exports) {
$parcel$export(module.exports, "ActionButton", () => $c6cc5fc597354ca4$export$cfc7921d29ef7b80);
/* index.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $kqp0i = parcelRequire("kqp0i");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");

var $ikDDG = parcelRequire("ikDDG");

var $cPcZL = parcelRequire("cPcZL");
var $c6cc5fc597354ca4$var$_excluded = [
    "children",
    "isDisabled",
    "viewType"
];
var $c6cc5fc597354ca4$var$styles = {
    button: "_1e0c1bgi",
    innerContainer: "_1e0c1nu9 _1y1m1u8q _16d9qvcn _k48p1wq8 _19bv12x7 _ca0qv77o _n3tdv77o _u5f312x7 _y3gn18uv _o5721btx _1nmz9jpi",
    enabled: "_syazi7uo _80omtlke _bfhki8nm _irr3plhp _1di61gdz",
    disabled: "_syaz1gmx _80om13gf _bfhkby5v"
};
var $c6cc5fc597354ca4$var$experimentEnabledStyles = {
    control: "_syazi7uo _80omtlke _bfhki8nm _irr3plhp _1di61gdz",
    test1: "_syaz15cr _80omtlke _bfhkjmqp _qrwqlb4i _1o0zlb4i _13lilb4i _mrkblb4i _ca0qt94y _n3tdt94y _2hwxt94y _k48pi7a9 _irr31q28 _1di612kk",
    test2: "_syaz15cr _80omtlke _bfhk1i45 _qrwqlb4i _1o0zlb4i _irr3byip _1di61van"
};
var $c6cc5fc597354ca4$export$cfc7921d29ef7b80 = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function(_ref, ref) {
    var children = _ref.children, isDisabled = _ref.isDisabled, _ref$viewType = _ref.viewType, viewType = _ref$viewType === void 0 ? 'default' : _ref$viewType, props = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $c6cc5fc597354ca4$var$_excluded);
    var experimentValue = viewType === 'unauthorised' ? (0, $cPcZL.expVal)('platform_inline_smartcard_connect_button_exp', 'cohort', 'control') : 'control';
    return /*#__PURE__*/ $5FkrB.createElement((0, $ikDDG.default), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, props, {
        isDisabled: isDisabled,
        ref: ref,
        style: {
            font: "inherit"
        },
        xcss: $c6cc5fc597354ca4$var$styles.button
    }), /*#__PURE__*/ $5FkrB.createElement("span", {
        tabIndex: isDisabled ? undefined : 0,
        className: (0, $970q7.default)([
            $c6cc5fc597354ca4$var$styles.innerContainer,
            isDisabled ? $c6cc5fc597354ca4$var$styles.disabled : experimentValue !== 'control' ? $c6cc5fc597354ca4$var$experimentEnabledStyles[experimentValue] : $c6cc5fc597354ca4$var$styles.enabled
        ])
    }, children));
});

});
parcelRegister("ikDDG", function(module, exports) {
$parcel$export(module.exports, "default", () => $d588d7bd9377e639$export$2e2bcd8739ae039);
/* pressable.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $kqp0i = parcelRequire("kqp0i");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");


var $hUFig = parcelRequire("hUFig");

var $bSNj8 = parcelRequire("bSNj8");

var $dJ32z = parcelRequire("dJ32z");

var $eVb4V = parcelRequire("eVb4V");

var $eqVaP = parcelRequire("eqVaP");

var $8grH2 = parcelRequire("8grH2");
var $d588d7bd9377e639$var$_excluded = [
    "children",
    "isDisabled",
    "type",
    "onClick",
    "interactionName",
    "componentName",
    "analyticsContext",
    "style",
    "testId",
    "xcss",
    "tabIndex"
], $d588d7bd9377e639$var$_excluded2 = [
    "className"
];
var $d588d7bd9377e639$var$styles = {
    root: "_19itglyw _vchhusvi _r06hglyw _80omtlke",
    disabled: "_80om13gf"
};
/**
 * __Pressable__
 *
 * A primitive for building custom buttons.
 *
 * - [Examples](https://atlassian.design/components/primitives/pressable/examples)
 * - [Code](https://atlassian.design/components/primitives/pressable/code)
 * - [Usage](https://atlassian.design/components/primitives/pressable/usage)
 */ var $d588d7bd9377e639$var$Pressable = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function(_ref, ref) {
    var children = _ref.children, isDisabled = _ref.isDisabled, _ref$type = _ref.type, type = _ref$type === void 0 ? 'button' : _ref$type, _ref$onClick = _ref.onClick, providedOnClick = _ref$onClick === void 0 ? (0, $eVb4V.default) : _ref$onClick, interactionName = _ref.interactionName, componentName = _ref.componentName, analyticsContext = _ref.analyticsContext, style = _ref.style, testId = _ref.testId, xcss = _ref.xcss, tabIndex = _ref.tabIndex, htmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $d588d7bd9377e639$var$_excluded);
    var interactionContext = (0, $5FkrB.useContext)((0, $eqVaP.default));
    var handleClick = (0, $5FkrB.useCallback)(function(e, analyticsEvent) {
        interactionContext && interactionContext.tracePress(interactionName, e.timeStamp);
        providedOnClick(e, analyticsEvent);
    }, [
        providedOnClick,
        interactionContext,
        interactionName
    ]);
    var onClick = (0, $bSNj8.usePlatformLeafEventHandler)({
        fn: handleClick,
        action: 'clicked',
        componentName: componentName || 'Pressable',
        packageName: "@atlaskit/primitives",
        packageVersion: "16.4.4",
        analyticsData: analyticsContext,
        actionSubject: 'button'
    });
    // This is to remove className from safeHtmlAttributes
    // @ts-expect-error className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(htmlAttributes, $d588d7bd9377e639$var$_excluded2);
    return /*#__PURE__*/ $5FkrB.createElement((0, $8grH2.default), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        as: "button",
        tabIndex: tabIndex !== null && tabIndex !== void 0 ? tabIndex : (0, $dJ32z.isSafari)() && !isDisabled ? 0 : undefined,
        style: style
    }, safeHtmlAttributes, {
        type: type,
        onClick: onClick,
        disabled: isDisabled,
        xcss: (0, $hUFig.cx)($d588d7bd9377e639$var$styles.root, isDisabled && $d588d7bd9377e639$var$styles.disabled, xcss),
        testId: testId,
        ref: ref
    }), children);
});
var $d588d7bd9377e639$export$2e2bcd8739ae039 = $d588d7bd9377e639$var$Pressable;

});

parcelRegister("cPcZL", function(module, exports) {
$parcel$export(module.exports, "expVal", () => $95645407dc1693e2$export$9db1624a8af791a4);

var $8dj3L = parcelRequire("8dj3L");

var $8qy01 = parcelRequire("8qy01");

var $aj4TE = parcelRequire("aj4TE");

var $75k6K = parcelRequire("75k6K");
function $95645407dc1693e2$var$expValInternal(_ref) {
    var _paramOverrides2, _experimentConfig$pro;
    var experimentName = _ref.experimentName, experimentParam = _ref.experimentParam, defaultValue = _ref.defaultValue, fireExperimentExposure = _ref.fireExperimentExposure;
    var experimentConfig = (0, $aj4TE.editorExperimentsConfig)[experimentName];
    if (experimentConfig === undefined) // Warning! If a product is improperly configured (ie. their editor packages are misaligned)
    // it can cause the editor to crash here or if the experiment does not exist.
    // We will definitely crash via any code path later in this function - this just makes the error explicit and clear.
    throw new Error("Editor experiment configuration is not defined ".concat(experimentName, ". Likely the experiment does not exist or editor package versions are misaligned"));
    // @ts-ignore need to loosen the type here to allow for any experiment name
    if ((0, $75k6K._overrides)[experimentName] !== undefined) // This will be hit in the case of a test setting an override
    // @ts-ignore need to loosen the type here to allow for any experiment name
    return (0, $75k6K._overrides)[experimentName];
    // Check for parameter overrides
    var paramOverride = (_paramOverrides2 = (0, $75k6K._paramOverrides)[experimentName]) === null || _paramOverrides2 === void 0 ? void 0 : _paramOverrides2[experimentParam];
    if (paramOverride !== undefined) return paramOverride;
    // If client is not initialized, we return the default value
    if (!(0, $8dj3L.default).initializeCompleted()) return defaultValue;
    if (!(0, $75k6K._product)) // This will be hit in the case of a product not having setup the editor experiment tooling
    return defaultValue;
    // Typescript is complaining here about accessing the productKeys property
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    var experimentKey = experimentConfig === null || experimentConfig === void 0 || (_experimentConfig$pro = experimentConfig.productKeys) === null || _experimentConfig$pro === void 0 ? void 0 : _experimentConfig$pro[0, $75k6K._product];
    if (!experimentKey) // This will be hit in the case of an experiment not being set up for the product
    return defaultValue;
    // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
    var experimentValue = (0, $8dj3L.default).getExperimentValue(experimentName, experimentParam, defaultValue, {
        fireExperimentExposure: fireExperimentExposure
    });
    if (// eslint-disable-next-line @atlaskit/platform/use-recommended-utils
    (0, $8dj3L.default).getExperimentValue('cc_editor_experiments_ufo_gate_reporting_expval', 'isEnabled', false)) // Duplicated from /confluence/next/packages/feature-experiments/src/index.ts
    (0, $8qy01.addFeatureFlagAccessed)("".concat(experimentName, ":").concat(experimentParam), experimentValue);
    return experimentValue;
}
function $95645407dc1693e2$export$9db1624a8af791a4(experimentName, experimentParam, defaultValue) {
    return $95645407dc1693e2$var$expValInternal({
        experimentName: experimentName,
        experimentParam: experimentParam,
        defaultValue: defaultValue,
        fireExperimentExposure: true
    });
} /**
  * Use to check a any param value for an experiment without firing an exposure event
  *
  * **Note**: this will return the default value when the experiment;
  * - is not being served to the client (ie. pre start)
  * - or is not configured in experiments-config
  *
  * @example
  * ```ts
  * const delay = expParamEqualsNoExposure('experiment-name', 'param-name', defaultValue)
  * await new Promise(res => setTimeout(res, delay)
  * ```
  */ 
function $95645407dc1693e2$export$94f132839aec533f(experimentName, experimentParam, defaultValue) {
    return $95645407dc1693e2$var$expValInternal({
        experimentName: experimentName,
        experimentParam: experimentParam,
        defaultValue: defaultValue,
        fireExperimentExposure: false
    });
}

});


parcelRegister("fv8CT", function(module, exports) {
$parcel$export(module.exports, "default", () => $b49071420a48032f$export$2e2bcd8739ae039);

var $kqp0i = parcelRequire("kqp0i");

var $5FkrB = parcelRequire("5FkrB");

var $9REMj = parcelRequire("9REMj");
function $b49071420a48032f$export$2e2bcd8739ae039(props) {
    // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $9REMj.default), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, props, {
        isFullScreen: false
    }));
}

});
parcelRegister("9REMj", function(module, exports) {
$parcel$export(module.exports, "default", () => $72e8b2045ea4c80b$export$2e2bcd8739ae039);
/* modal-wrapper.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $kqp0i = parcelRequire("kqp0i");

var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");

var $69J3E = parcelRequire("69J3E");

var $3FlkA = parcelRequire("3FlkA");

var $bSNj8 = parcelRequire("bSNj8");

var $1qBWl = parcelRequire("1qBWl");

var $eVb4V = parcelRequire("eVb4V");

var $a9xCt = parcelRequire("a9xCt");

var $afypb = parcelRequire("afypb");

var $7ujRa = parcelRequire("7ujRa");

var $7iRPx = parcelRequire("7iRPx");

var $97BuP = parcelRequire("97BuP");

var $bL9ob = parcelRequire("bL9ob");

var $izyyW = parcelRequire("izyyW");

var $4tRFQ = parcelRequire("4tRFQ");
var $72e8b2045ea4c80b$var$fillScreenStyles = null;
var $72e8b2045ea4c80b$var$allowlistElements = function allowlistElements(element, callback) {
    // Allow focus to reach elements outside the modal:
    // if AUI dialog is allowListed and visible
    if (!!document.querySelector('.aui-blanket:not([hidden])')) return false;
    // allows to pass a callback function to allow elements be ignored by focus lock
    if (typeof callback === 'function') return callback(element);
    return true;
};
/**
 * __Modal wrapper__
 *
 * A modal wrapper displays content that requires user interaction, in a layer above the page.
 * This component is primary container for other modal components.
 *
 * - [Examples](https://atlassian.design/components/modal-dialog/examples)
 * - [Code](https://atlassian.design/components/modal-dialog/code)
 * - [Usage](https://atlassian.design/components/modal-dialog/usage)
 */ var $72e8b2045ea4c80b$var$InternalModalWrapper = function InternalModalWrapper(props) {
    var _props$autoFocus = props.autoFocus, autoFocus = _props$autoFocus === void 0 ? true : _props$autoFocus, focusLockAllowlist = props.focusLockAllowlist, _props$shouldCloseOnE = props.shouldCloseOnEscapePress, shouldCloseOnEscapePress = _props$shouldCloseOnE === void 0 ? true : _props$shouldCloseOnE, _props$shouldCloseOnO = props.shouldCloseOnOverlayClick, shouldCloseOnOverlayClick = _props$shouldCloseOnO === void 0 ? true : _props$shouldCloseOnO, _props$shouldScrollIn = props.shouldScrollInViewport, shouldScrollInViewport = _props$shouldScrollIn === void 0 ? false : _props$shouldScrollIn, _props$shouldReturnFo = props.shouldReturnFocus, shouldReturnFocus = _props$shouldReturnFo === void 0 ? true : _props$shouldReturnFo, stackIndexOverride = props.stackIndex, providedOnClose = props.onClose, _props$onStackChange = props.onStackChange, onStackChange = _props$onStackChange === void 0 ? (0, $eVb4V.default) : _props$onStackChange, isBlanketHidden = props.isBlanketHidden, children = props.children, height = props.height, width = props.width, onCloseComplete = props.onCloseComplete, onOpenComplete = props.onOpenComplete, label = props.label, testId = props.testId, isFullScreen = props.isFullScreen;
    var calculatedStackIndex = (0, $bL9ob.default)({
        onStackChange: onStackChange
    });
    var stackIndex = stackIndexOverride || calculatedStackIndex;
    var isForeground = stackIndex === 0;
    // When a user supplies a ref to focus we skip auto focus via react-focus-lock
    var autoFocusLock = typeof autoFocus === 'boolean' ? autoFocus : false;
    var onCloseHandler = (0, $bSNj8.usePlatformLeafEventHandler)({
        fn: providedOnClose || (0, $eVb4V.default),
        action: 'closed',
        componentName: 'modalDialog',
        packageName: "@atlaskit/modal-dialog",
        packageVersion: "14.7.1"
    });
    var onBlanketClicked = (0, $5FkrB.useCallback)(function(e) {
        if (shouldCloseOnOverlayClick) onCloseHandler(e);
    }, [
        shouldCloseOnOverlayClick,
        onCloseHandler
    ]);
    // This ensures to prevent additional re-renders while nothing is passed to focusLockAllowlist explicitly.
    var allowListCallback = (0, $5FkrB.useCallback)(function(element) {
        return $72e8b2045ea4c80b$var$allowlistElements(element, focusLockAllowlist);
    }, [
        focusLockAllowlist
    ]);
    (0, $izyyW.default)();
    (0, $afypb.useNotifyOpenLayerObserver)({
        type: 'modal',
        // Modal dialog is conditionally rendered when visible, so when this runs it is always open.
        isOpen: true,
        // Passing a no-op for now, as there isn't a real use case for closing the modal dialog programmatically
        // by the OpenLayerObserver. The only current use case is closing layers when resizing the nav layout,
        // which cannot happen while a modal dialog is open.
        onClose: (0, $eVb4V.default)
    });
    var modalDialogWithBlanket = /*#__PURE__*/ $5FkrB.createElement((0, $1qBWl.default), {
        isTinted: !isBlanketHidden,
        onBlanketClicked: onBlanketClicked,
        testId: testId && "".concat(testId, "--blanket")
    }, /*#__PURE__*/ $5FkrB.createElement((0, $4tRFQ.default), {
        testId: testId,
        label: label,
        autoFocus: autoFocus,
        stackIndex: stackIndex,
        onClose: onCloseHandler,
        shouldCloseOnEscapePress: shouldCloseOnEscapePress && isForeground,
        shouldScrollInViewport: shouldScrollInViewport,
        height: height,
        width: width,
        onCloseComplete: onCloseComplete,
        onOpenComplete: onOpenComplete,
        hasProvidedOnClose: Boolean(providedOnClose),
        isFullScreen: isFullScreen
    }, children));
    var returnFocus = true;
    var onDeactivation;
    if ('boolean' === typeof shouldReturnFocus) returnFocus = shouldReturnFocus;
    else onDeactivation = function onDeactivation() {
        window.setTimeout(function() {
            var _shouldReturnFocus$cu;
            (_shouldReturnFocus$cu = shouldReturnFocus.current) === null || _shouldReturnFocus$cu === void 0 || _shouldReturnFocus$cu.focus();
        }, 0);
    };
    return /*#__PURE__*/ $5FkrB.createElement((0, $a9xCt.Layering), {
        isDisabled: false
    }, /*#__PURE__*/ $5FkrB.createElement((0, $7iRPx.default), {
        zIndex: (0, $97BuP.layers).modal()
    }, /*#__PURE__*/ $5FkrB.createElement((0, $7ujRa.default), null, function(fadeInProps) {
        return /*#__PURE__*/ $5FkrB.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, fadeInProps, {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
            className: (0, $970q7.default)([
                "_1bsbauwl _4t3i1kxc _kqsw1n9t _152tze3t _1e02ze3t _18m91wug _8am5i4x0",
                fadeInProps.className
            ]),
            "aria-hidden": !isForeground
        }), /*#__PURE__*/ $5FkrB.createElement((0, $69J3E.default), {
            autoFocus: autoFocusLock,
            returnFocus: returnFocus,
            onDeactivation: onDeactivation,
            whiteList: allowListCallback
        }, /*#__PURE__*/ $5FkrB.createElement((0, (/*@__PURE__*/$parcel$interopDefault($3FlkA))), null), shouldScrollInViewport ? /*#__PURE__*/ $5FkrB.createElement((0, $3FlkA.TouchScrollable), null, modalDialogWithBlanket) : modalDialogWithBlanket));
    })));
};
var $72e8b2045ea4c80b$export$2e2bcd8739ae039 = $72e8b2045ea4c80b$var$InternalModalWrapper;

});
parcelRegister("a9xCt", function(module, exports) {
$parcel$export(module.exports, "LevelContext", () => $7644d2c8d9418fc7$export$650d12d3c2ddb8fc);
$parcel$export(module.exports, "LevelNodeContext", () => $7644d2c8d9418fc7$export$18f4d8b5b3a77f59);
$parcel$export(module.exports, "RootNodeContext", () => $7644d2c8d9418fc7$export$fa973f110e8f6ca8);
$parcel$export(module.exports, "Layering", () => $7644d2c8d9418fc7$export$7c885f891c940977);

var $5FkrB = parcelRequire("5FkrB");

var $e0sSj = parcelRequire("e0sSj");
var $7644d2c8d9418fc7$export$650d12d3c2ddb8fc = /*#__PURE__*/ (0, $5FkrB.createContext)(0);
var $7644d2c8d9418fc7$export$18f4d8b5b3a77f59 = /*#__PURE__*/ (0, $5FkrB.createContext)({
    current: null
});
var $7644d2c8d9418fc7$export$fa973f110e8f6ca8 = /*#__PURE__*/ (0, $5FkrB.createContext)({
    current: null
});
/**
 *
 *  @internal
 * Context Provider Component which provider the current level of nested layers
 * It handles level management when it mounts and unmounts
 *
 */ var $7644d2c8d9418fc7$var$LevelProvider = function LevelProvider(_ref) {
    var children = _ref.children, currentLevel = _ref.currentLevel, levelNode = _ref.node;
    (0, $5FkrB.useEffect)(function() {
        var levelNodeSafe = levelNode.current;
        var parentNode = levelNodeSafe.parent;
        parentNode === null || parentNode === void 0 || parentNode.addChild(levelNodeSafe);
        return function() {
            parentNode === null || parentNode === void 0 || parentNode.removeChild(levelNodeSafe);
        };
    }, [
        levelNode
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement($7644d2c8d9418fc7$export$650d12d3c2ddb8fc.Provider, {
        value: currentLevel
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement($7644d2c8d9418fc7$export$18f4d8b5b3a77f59.Provider, {
        value: levelNode
    }, children));
};
var $7644d2c8d9418fc7$export$7c885f891c940977 = function Layering(_ref2) {
    var children = _ref2.children, _ref2$isDisabled = _ref2.isDisabled, isDisabled = _ref2$isDisabled === void 0 ? true : _ref2$isDisabled;
    var currentLevel = (0, $5FkrB.useContext)($7644d2c8d9418fc7$export$650d12d3c2ddb8fc);
    var parentNode = (0, $5FkrB.useContext)($7644d2c8d9418fc7$export$18f4d8b5b3a77f59);
    // eslint-disable-next-line  @repo/internal/react/disallow-unstable-values
    var newNode = (0, $5FkrB.useRef)(new (0, $e0sSj.LayerNode)(Math.random().toString(36), parentNode.current));
    if (isDisabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).Fragment, null, children);
    var isNested = currentLevel > 0;
    var content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement($7644d2c8d9418fc7$var$LevelProvider, {
        currentLevel: currentLevel + 1,
        node: newNode
    }, children);
    return isNested ? content : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement($7644d2c8d9418fc7$export$fa973f110e8f6ca8.Provider, {
        value: newNode
    }, content);
};

});
parcelRegister("e0sSj", function(module, exports) {
$parcel$export(module.exports, "LayerNode", () => $a32776bf2329a89c$export$da4f61fd78d35243);

var $fC8ib = parcelRequire("fC8ib");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");
var $a32776bf2329a89c$export$da4f61fd78d35243 = /*#__PURE__*/ function() {
    function LayerNode(id, parent) {
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, LayerNode);
        this.id = id;
        this.childNodes = [];
        this.parent = parent;
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(LayerNode, [
        {
            key: "addChild",
            value: function addChild(node) {
                this.childNodes.push(node);
            }
        },
        {
            key: "removeChild",
            value: function removeChild(node) {
                this.childNodes = this.childNodes.filter(function(child) {
                    return child.id !== node.id;
                });
            }
        },
        {
            key: "getLevel",
            value: function getLevel() {
                if (!this.parent) return 1;
                return this.parent.getLevel() + 1;
            }
        },
        {
            key: "getHeight",
            value: function getHeight() {
                if (this.childNodes.length === 0) return 1;
                return Math.max.apply(Math, (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(this.childNodes.map(function(child) {
                    return child.getHeight();
                }))) + 1;
            }
        }
    ]);
}();

});


parcelRegister("bL9ob", function(module, exports) {
$parcel$export(module.exports, "default", () => $88fb5df7fc5c6e51$export$2e2bcd8739ae039);

var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");

var $Xr0F9 = parcelRequire("Xr0F9");

var $8iJkX = parcelRequire("8iJkX");

var $9NSoN = parcelRequire("9NSoN");

var $9Et5g = parcelRequire("9Et5g");
/**
 *  ________________________________________________
 * | MAJOR VERSIONS WILL NOT KNOW ABOUT EACH OTHER! |
 *  ------------------------------------------------
 *
 * An array which holds references to all currently open modal dialogs.
 * This will only work for modal dialogs of the same major version,
 * as the reference will be different between them.
 *
 * E.g. V11 won't know about any from V12.
 */ var $88fb5df7fc5c6e51$var$modalStackRegister = [];
function $88fb5df7fc5c6e51$export$2e2bcd8739ae039(_ref) {
    var onStackChange = _ref.onStackChange;
    var _useExitingPersistenc = (0, $9Et5g.useExitingPersistence)(), isExiting = _useExitingPersistenc.isExiting;
    var _useStateRef = (0, $9NSoN.default)(0), _useStateRef2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useStateRef, 2), stackIndexRef = _useStateRef2[0], setStackIndex = _useStateRef2[1];
    var currentStackIndex = stackIndexRef.current;
    var previousStackIndex = (0, $8iJkX.default)(stackIndexRef.current);
    // We want to ensure this function **never changes** during the lifecycle of this component.
    // This is why it's assigned to a ref and not in a useMemo/useCallback.
    var updateStack = (0, $Xr0F9.default)(function() {
        var newStackIndex = $88fb5df7fc5c6e51$var$modalStackRegister.indexOf(updateStack);
        // We access the stack index ref instead of state because this closure will always only
        // have the initial state and not any of the later values.
        if (stackIndexRef.current !== newStackIndex) {
            setStackIndex(newStackIndex);
            stackIndexRef.current = newStackIndex;
        }
    });
    (0, $5FkrB.useEffect)(function() {
        var currentStackIndex = $88fb5df7fc5c6e51$var$modalStackRegister.indexOf(updateStack);
        if (!isExiting && currentStackIndex === -1) // We are opening the modal dialog.
        // Add ourselves to the modal stack register!
        $88fb5df7fc5c6e51$var$modalStackRegister.unshift(updateStack);
        if (isExiting && currentStackIndex !== -1) // We are closing the modal dialog using a wrapping modal transition component.
        // Remove ourselves from the modal stack register!
        // NOTE: Modal dialogs that don't have a wrapping modal transition component won't flow through here!
        // For that scenario we cleanup when the component unmounts.
        $88fb5df7fc5c6e51$var$modalStackRegister.splice(currentStackIndex, 1);
        // Fire all registered modal dialogs to update their position in the stack.
        $88fb5df7fc5c6e51$var$modalStackRegister.forEach(function(cb) {
            return cb();
        });
    }, [
        updateStack,
        isExiting
    ]);
    (0, $5FkrB.useEffect)(function() {
        return function() {
            // Final cleanup just in case this modal dialog did not have a wrapping modal transition.
            var currentStackIndex = $88fb5df7fc5c6e51$var$modalStackRegister.indexOf(updateStack);
            if (currentStackIndex !== -1) {
                $88fb5df7fc5c6e51$var$modalStackRegister.splice(currentStackIndex, 1);
                $88fb5df7fc5c6e51$var$modalStackRegister.forEach(function(cb) {
                    return cb();
                });
            }
        };
    }, [
        updateStack
    ]);
    (0, $5FkrB.useEffect)(function() {
        if (previousStackIndex === undefined) // Initial case that we don't need to notify about.
        return;
        if (previousStackIndex !== currentStackIndex) onStackChange(currentStackIndex);
    }, [
        onStackChange,
        previousStackIndex,
        currentStackIndex
    ]);
    return currentStackIndex;
}

});
parcelRegister("Xr0F9", function(module, exports) {
$parcel$export(module.exports, "default", () => $0b2a765d61005f29$export$2e2bcd8739ae039);

var $b9s5x = parcelRequire("b9s5x");
function $0b2a765d61005f29$export$2e2bcd8739ae039(callback) {
    var ref = (0, $b9s5x.default)(function() {
        return callback;
    });
    return ref.current;
}

});
parcelRegister("b9s5x", function(module, exports) {
$parcel$export(module.exports, "default", () => $81e652ba4695f5f9$export$2e2bcd8739ae039);

var $5FkrB = parcelRequire("5FkrB");
var $81e652ba4695f5f9$var$uniqueReferencedValue = {};
function $81e652ba4695f5f9$export$2e2bcd8739ae039(initializer) {
    var ref = (0, $5FkrB.useRef)($81e652ba4695f5f9$var$uniqueReferencedValue);
    if (ref.current === $81e652ba4695f5f9$var$uniqueReferencedValue) ref.current = initializer();
    return ref;
}

});


parcelRegister("8iJkX", function(module, exports) {
$parcel$export(module.exports, "default", () => $60b32c220ba1ae7f$export$2e2bcd8739ae039);

var $5FkrB = parcelRequire("5FkrB");
function $60b32c220ba1ae7f$export$2e2bcd8739ae039(value) {
    var ref = (0, $5FkrB.useRef)();
    (0, $5FkrB.useEffect)(function() {
        ref.current = value;
    }, [
        value
    ]);
    return ref.current;
}

});

parcelRegister("9NSoN", function(module, exports) {
$parcel$export(module.exports, "default", () => $7232e324d909781d$export$2e2bcd8739ae039);

var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");
function $7232e324d909781d$export$2e2bcd8739ae039(initialState) {
    var _useState = (0, $5FkrB.useState)(initialState), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), value = _useState2[0], setValue = _useState2[1];
    var valueRef = (0, $5FkrB.useRef)(value);
    valueRef.current = value;
    return [
        valueRef,
        setValue
    ];
}

});


parcelRegister("izyyW", function(module, exports) {
$parcel$export(module.exports, "default", () => $d8564e4c13cd335a$export$2e2bcd8739ae039);

var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");

var $7QpUe = parcelRequire("7QpUe");
/**
 * Returns how far the body is scrolled from the top of the viewport.
 *
 *   ____
 * ||____|| <-- overflow
 *  |    |  <-- viewport
 *  |____|
 *
 * Scroll distance is the height of overflow outside the viewport.
 */ function $d8564e4c13cd335a$var$getScrollDistance() {
    var _document$documentEle, _document$body;
    return window.pageYOffset || ((_document$documentEle = document.documentElement) === null || _document$documentEle === void 0 ? void 0 : _document$documentEle.scrollTop) || ((_document$body = document.body) === null || _document$body === void 0 ? void 0 : _document$body.scrollTop) || 0;
}
function $d8564e4c13cd335a$export$2e2bcd8739ae039() {
    var _useState = (0, $5FkrB.useState)(0), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), scrollTopOffset = _useState2[0], setScrollTopOffset = _useState2[1];
    (0, $5FkrB.useLayoutEffect)(function() {
        setScrollTopOffset($d8564e4c13cd335a$var$getScrollDistance());
    }, []);
    var onWindowScroll = (0, $5FkrB.useCallback)(function() {
        if ($d8564e4c13cd335a$var$getScrollDistance() !== scrollTopOffset) window.scrollTo(window.pageXOffset, scrollTopOffset);
    }, [
        scrollTopOffset
    ]);
    (0, $5FkrB.useEffect)(function() {
        return (0, $7QpUe.bind)(window, {
            type: 'scroll',
            listener: onWindowScroll
        });
    }, [
        onWindowScroll
    ]);
    return scrollTopOffset;
}

});

parcelRegister("4tRFQ", function(module, exports) {
$parcel$export(module.exports, "default", () => $34338163c6f3d5c9$export$2e2bcd8739ae039);
/* modal-dialog.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $kqp0i = parcelRequire("kqp0i");

var $iYJcE = parcelRequire("iYJcE");

var $ekGgq = parcelRequire("ekGgq");

var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");

var $iO8GM = parcelRequire("iO8GM");

var $gpUQB = parcelRequire("gpUQB");

var $h8qvJ = parcelRequire("h8qvJ");

var $emVfW = parcelRequire("emVfW");

var $7ujRa = parcelRequire("7ujRa");
parcelRequire("jkmxD");
var $fGFYU = parcelRequire("fGFYU");

var $fAYgP = parcelRequire("fAYgP");

var $gPZ7j = parcelRequire("gPZ7j");

var $5YyDq = parcelRequire("5YyDq");

var $amgLb = parcelRequire("amgLb");

var $6fqgi = parcelRequire("6fqgi");

var $6mOEm = parcelRequire("6mOEm");

var $fA8Gf = parcelRequire("fA8Gf");
var $34338163c6f3d5c9$var$LOCAL_CURRENT_SURFACE_CSS_VAR = '--ds-elevation-surface-current';
var $34338163c6f3d5c9$var$dialogStyles = {
    root: "_16jlidpf _1o9zkb7n _i0dl1wug _1e0c1txw _1bsb1osq _p12fauwl _4t3i1osq _1tkeidpf _c71l1kxc _2lx21bp4 _bfhk1bhr _syazi7uo _1q1l1bhr _lcxv1wug _1mq81kw7 _m01u1kw7 _1dg11kw7 _mizu1v1w _1ah3dkaa _ra3xnqa1 _128mdkaa _1cvmnqa1 _4davt94y _we1i1kw7 _zg7p130s _yakv1kw7 _4lht1kw7 _1xlt6m9r",
    borderRadius: "_epkxfajl"
};
var $34338163c6f3d5c9$var$viewportScrollStyles = null;
var $34338163c6f3d5c9$var$bodyScrollStyles = null;
var $34338163c6f3d5c9$var$ModalDialog = function ModalDialog(props) {
    var _props$width = props.width, width = _props$width === void 0 ? 'medium' : _props$width, _props$shouldScrollIn = props.shouldScrollInViewport, shouldScrollInViewport = _props$shouldScrollIn === void 0 ? false : _props$shouldScrollIn, shouldCloseOnEscapePress = props.shouldCloseOnEscapePress, autoFocus = props.autoFocus, stackIndex = props.stackIndex, onClose = props.onClose, onCloseComplete = props.onCloseComplete, onOpenComplete = props.onOpenComplete, height = props.height, hasProvidedOnClose = props.hasProvidedOnClose, children = props.children, label = props.label, testId = props.testId, _props$isFullScreen = props.isFullScreen, isFullScreen = _props$isFullScreen === void 0 ? false : _props$isFullScreen;
    var id = (0, $h8qvJ.useId)();
    var titleId = "modal-dialog-title-".concat(id);
    var defaultTestId = testId || 'modal-dialog';
    (0, $5FkrB.useEffect)(function() {
        // Modal dialogs can appear on top of iframe elements that are on another domain.
        // There is a Chrome bug where drag and drop in an element on top of a cross domain
        // iframe is not working. We are applying the workaround for this bug in modal so
        // that consumers of our modal don't have to worry about this bug and are free to
        // create whatever drag and drop experience they like inside a modal
        //
        // Chrome bug: https://issues.chromium.org/issues/362301053
        return (0, $fGFYU.combine)((0, $5YyDq.disableDraggingToCrossOriginIFramesForElement)(), (0, $6fqgi.disableDraggingToCrossOriginIFramesForTextSelection)(), (0, $amgLb.disableDraggingToCrossOriginIFramesForExternal)());
    }, []);
    (0, $gpUQB.default)((0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(autoFocus) === 'object' ? autoFocus : undefined, // When a user supplies  a ref to focus we enable this hook
    (0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(autoFocus) === 'object');
    var _useOnMotionFinish = (0, $gPZ7j.default)({
        onOpenComplete: onOpenComplete,
        onCloseComplete: onCloseComplete
    }), _useOnMotionFinish2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useOnMotionFinish, 2), motionRef = _useOnMotionFinish2[0], onMotionFinish = _useOnMotionFinish2[1];
    var modalDialogContext = (0, $5FkrB.useMemo)(function() {
        return {
            testId: defaultTestId,
            titleId: titleId,
            onClose: onClose,
            hasProvidedOnClose: hasProvidedOnClose,
            isFullScreen: isFullScreen
        };
    }, [
        defaultTestId,
        titleId,
        onClose,
        hasProvidedOnClose,
        isFullScreen
    ]);
    (0, $emVfW.useCloseOnEscapePress)({
        onClose: onClose,
        isDisabled: !shouldCloseOnEscapePress
    });
    var _useLayering = (0, $emVfW.useLayering)(), currentLevel = _useLayering.currentLevel;
    return /*#__PURE__*/ $5FkrB.createElement((0, $fA8Gf.default), {
        stackIndex: stackIndex,
        shouldScrollInViewport: shouldScrollInViewport,
        testId: defaultTestId,
        isFullScreen: isFullScreen
    }, /*#__PURE__*/ $5FkrB.createElement((0, $fAYgP.ModalContext).Provider, {
        value: modalDialogContext
    }, /*#__PURE__*/ $5FkrB.createElement((0, $fAYgP.ScrollContext).Provider, {
        value: shouldScrollInViewport
    }, /*#__PURE__*/ $5FkrB.createElement((0, $7ujRa.default), {
        entranceDirection: isFullScreen ? undefined : 'bottom',
        onFinish: onMotionFinish
    }, function(bottomFadeInProps) {
        return /*#__PURE__*/ $5FkrB.createElement("section", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, bottomFadeInProps, {
            "aria-label": label,
            ref: (0, $iO8GM.default)([
                bottomFadeInProps.ref,
                motionRef
            ]),
            style: {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                '--modal-dialog-width': (0, $6mOEm.dialogWidth)(width),
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                '--modal-dialog-height': (0, $6mOEm.dialogHeight)(height)
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
            className: (0, $970q7.default)([
                $34338163c6f3d5c9$var$dialogStyles.root,
                !isFullScreen && $34338163c6f3d5c9$var$dialogStyles.borderRadius,
                shouldScrollInViewport ? "_1tke1kxc _c71lglyw _8kn617ks" : "_cbiz17ks _bolh1kw7",
                bottomFadeInProps.className
            ]),
            role: "dialog",
            "aria-labelledby": label ? undefined : titleId,
            "data-testid": defaultTestId,
            "data-modal-stack": stackIndex,
            tabIndex: -1,
            "aria-modal": true,
            "data-ds--level": currentLevel
        }), children);
    }))));
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$34338163c6f3d5c9$export$2e2bcd8739ae039 = $34338163c6f3d5c9$var$ModalDialog;

});
parcelRegister("emVfW", function(module, exports) {
$parcel$export(module.exports, "useCloseOnEscapePress", () => $a75f88a47c0cf0ed$export$4a4bf067ea9e7886);
$parcel$export(module.exports, "useLayering", () => $a75f88a47c0cf0ed$export$c8b4d54e03dee6ed);

var $5FkrB = parcelRequire("5FkrB");

var $7QpUe = parcelRequire("7QpUe");

var $a9xCt = parcelRequire("a9xCt");
var $a75f88a47c0cf0ed$var$ESCAPE = 'Escape';
function $a75f88a47c0cf0ed$export$4a4bf067ea9e7886(_ref) {
    var onClose = _ref.onClose, isDisabled = _ref.isDisabled;
    var escapePressed = (0, $5FkrB.useRef)(false);
    var _useLayering = $a75f88a47c0cf0ed$export$c8b4d54e03dee6ed(), isLayerDisabled = _useLayering.isLayerDisabled;
    var onKeyDown = (0, $5FkrB.useCallback)(function(e) {
        var isDisabledLayer = isLayerDisabled();
        if (isDisabled || escapePressed.current || e.key !== $a75f88a47c0cf0ed$var$ESCAPE || isDisabledLayer) // We're either already handling the key down event or it's not escape or disabled.
        // Bail early!
        return;
        escapePressed.current = true;
        onClose(e);
    }, [
        onClose,
        isDisabled,
        isLayerDisabled
    ]);
    var onKeyUp = (0, $5FkrB.useCallback)(function() {
        escapePressed.current = false;
    }, []);
    (0, $5FkrB.useEffect)(function() {
        return (0, $7QpUe.bindAll)(window, [
            {
                type: 'keydown',
                listener: onKeyDown
            },
            {
                type: 'keyup',
                listener: onKeyUp
            }
        ], {
            capture: false
        });
    }, [
        onKeyDown,
        onKeyUp
    ]);
}
function $a75f88a47c0cf0ed$export$c8b4d54e03dee6ed() {
    var currentLevel = (0, $5FkrB.useContext)((0, $a9xCt.LevelContext));
    var layerNode = (0, $5FkrB.useContext)((0, $a9xCt.LevelNodeContext));
    var rootNode = (0, $5FkrB.useContext)((0, $a9xCt.RootNodeContext));
    var isLayerDisabled = (0, $5FkrB.useCallback)(function() {
        // This is an impossible case, added for type safety
        if (!(layerNode !== null && layerNode !== void 0 && layerNode.current) || !(rootNode !== null && rootNode !== void 0 && rootNode.current)) return false;
        return layerNode.current.getLevel() < rootNode.current.getHeight();
    }, [
        layerNode,
        rootNode
    ]);
    var getTopLevel = (0, $5FkrB.useCallback)(function() {
        return rootNode !== null && rootNode !== void 0 && rootNode.current ? rootNode.current.getHeight() : null;
    }, [
        rootNode
    ]);
    return {
        currentLevel: currentLevel,
        isLayerDisabled: isLayerDisabled,
        getTopLevel: getTopLevel
    };
}

});

parcelRegister("fAYgP", function(module, exports) {
$parcel$export(module.exports, "ModalContext", () => $b5a8f83d2810f673$export$ab57792b9b6974a6);
$parcel$export(module.exports, "ScrollContext", () => $b5a8f83d2810f673$export$dece24112a937f92);

var $5FkrB = parcelRequire("5FkrB");
var $b5a8f83d2810f673$export$ab57792b9b6974a6 = /*#__PURE__*/ (0, $5FkrB.createContext)(null);
var $b5a8f83d2810f673$export$dece24112a937f92 = /*#__PURE__*/ (0, $5FkrB.createContext)(null);

});

parcelRegister("gPZ7j", function(module, exports) {
$parcel$export(module.exports, "default", () => $c420d149c35f2219$export$2e2bcd8739ae039);

var $5FkrB = parcelRequire("5FkrB");
function $c420d149c35f2219$export$2e2bcd8739ae039(_ref) {
    var onOpenComplete = _ref.onOpenComplete, onCloseComplete = _ref.onCloseComplete;
    var motionRef = (0, $5FkrB.useRef)(null);
    var onMotionFinish = (0, $5FkrB.useCallback)(function(state) {
        if (state === 'entering' && onOpenComplete) onOpenComplete(motionRef.current, true);
        if (state === 'exiting' && onCloseComplete) onCloseComplete(motionRef.current);
    }, [
        onOpenComplete,
        onCloseComplete
    ]);
    return [
        motionRef,
        onMotionFinish
    ];
}

});

parcelRegister("5YyDq", function(module, exports) {
$parcel$export(module.exports, "disableDraggingToCrossOriginIFramesForElement", () => $459d6c181f35bf76$export$ec28e97c7d8b1b35);

var $7QpUe = parcelRequire("7QpUe");
parcelRequire("jkmxD");
var $fGFYU = parcelRequire("fGFYU");
parcelRequire("5ldyY");
var $f8loy = parcelRequire("f8loy");

var $hcsdE = parcelRequire("hcsdE");
function $459d6c181f35bf76$var$watchForInteractionEnd(_ref) {
    var stop = _ref.stop;
    var isDragging = false;
    function stopIfNotDragging() {
        if (isDragging) return;
        stop();
    }
    var unbindEvents = (0, $7QpUe.bindAll)(window, [
        {
            // Another interaction is starting, this fix should be removed.
            type: 'pointerdown',
            listener: stop
        },
        {
            // The user did not start a drag
            type: 'pointerup',
            listener: stopIfNotDragging
        },
        {
            // if a "dragstart" occurs and the flag is not set,
            // then a drag has not started.
            // Note: could not use "pointercancel" as it is not
            // published in Safari
            // → https://bugs.webkit.org/show_bug.cgi?id=222632
            type: 'dragstart',
            listener: stopIfNotDragging,
            // Need to come after the element adapter
            options: {
                capture: false
            }
        }
    ], {
        // Listening in the capture phase to increase resilience
        // against events being stopped.
        capture: true,
        // Being super clear these should only run once
        once: true
    });
    var unbindMonitor = (0, $f8loy.monitorForElements)({
        onGenerateDragPreview: function onGenerateDragPreview() {
            isDragging = true;
        },
        onDrop: function onDrop() {
            isDragging = false;
            stop();
        }
    });
    return (0, $fGFYU.combine)(unbindEvents, unbindMonitor);
}
function $459d6c181f35bf76$var$watchForInteractionStart(_ref2) {
    var start = _ref2.start;
    return (0, $7QpUe.bind)(window, {
        // Note: Using "mousedown" rather than "pointerdown" due to a Safari bug.
        // Safari not publish a "pointerdown" on the interaction after a drag
        // → https://bugs.webkit.org/show_bug.cgi?id=279749
        type: 'mousedown',
        listener: function listener(event) {
            // Only starting if pressing down inside a draggable element
            // At this point, we are not sure which if:
            // 1. a text selection drag is starting
            // 2. a draggable managed by pdnd is going to be dragged
            // 3. a draggable not managed by pdnd is going to be dragged
            // 4. The user will be dragging anything at all (might be doing a click)
            if (event.target instanceof HTMLElement && event.target.closest('[draggable="true"]')) start();
        }
    });
}
var $459d6c181f35bf76$var$api = (0, $hcsdE.makeFixForAdapter)({
    watchForInteractionStart: $459d6c181f35bf76$var$watchForInteractionStart,
    watchForInteractionEnd: $459d6c181f35bf76$var$watchForInteractionEnd
});
function $459d6c181f35bf76$export$ec28e97c7d8b1b35() {
    return $459d6c181f35bf76$var$api.registerUsage();
}

});
parcelRegister("hcsdE", function(module, exports) {
$parcel$export(module.exports, "makeFixForAdapter", () => $c859726891399d7b$export$a74bff2507e6126b);

var $fC8ib = parcelRequire("fC8ib");
parcelRequire("jkmxD");
var $fGFYU = parcelRequire("fGFYU");
/**
 * Set a `style` property on a `HTMLElement`
 *
 * @returns a `cleanup` function to restore the `style` property to it's original state
 */ function $c859726891399d7b$var$setStyle(el, _ref) {
    var property = _ref.property, rule = _ref.rule, _ref$priority = _ref.priority, priority = _ref$priority === void 0 ? '' : _ref$priority;
    var originalValue = el.style.getPropertyValue(property);
    var originalPriority = el.style.getPropertyPriority(property);
    el.style.setProperty(property, rule, priority);
    return function cleanup() {
        el.style.setProperty(property, originalValue, originalPriority);
    };
}
function $c859726891399d7b$var$hasSameOrigin(href1, href2) {
    var url1;
    var url2;
    try {
        url1 = new URL(href1);
        url2 = new URL(href2);
    } catch (error) {
        // failed to parse a href
        return false;
    }
    // https://developer.mozilla.org/en-US/docs/Web/Security/Same-origin_policy
    return url1.protocol === url2.protocol && url1.host === url2.host && url1.port === url2.port;
}
function $c859726891399d7b$var$isIframeOnAnotherDomain(iframe) {
    /**
   * iframe with contents defined inline. Runs on the current origin.
   * `<iframe srcdoc="<!doctype html><body>Hello</body>" />`
   */ if (iframe.srcdoc) return false;
    /**
   * iframe with contents defined inline. Runs on the current origin.
   * `<iframe src={`data:text/html;charset=utf-8,${encodeURI('<!doctype html><body>Hello</body>')}`} />`
   */ if (iframe.src.startsWith('data:')) return false;
    return !$c859726891399d7b$var$hasSameOrigin(window.location.href, iframe.src);
}
var $c859726891399d7b$var$registry = new Map();
function $c859726891399d7b$var$applyFix(watchForEndOfInteraction) {
    var iframes = Array.from(document.querySelectorAll('iframe')).filter($c859726891399d7b$var$isIframeOnAnotherDomain);
    var cleanups = iframes.map(function(iframe) {
        var entry = $c859726891399d7b$var$registry.get(iframe);
        if (!entry) {
            entry = {
                reset: $c859726891399d7b$var$setStyle(iframe, {
                    property: 'pointer-events',
                    rule: 'none',
                    priority: 'important'
                }),
                count: 1
            };
            $c859726891399d7b$var$registry.set(iframe, entry);
        } else // pointer-events:none already applied to the iframe
        // increment how many things requested the fix
        entry.count++;
        return function cleanup() {
            entry.count--;
            if (entry.count < 1) {
                entry.reset();
                $c859726891399d7b$var$registry.delete(iframe);
            }
        };
    });
    function stop() {
        cleanupWatcher();
        (0, $fGFYU.combine).apply(void 0, (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(cleanups))();
    }
    var cleanupWatcher = watchForEndOfInteraction({
        stop: stop
    });
}
function $c859726891399d7b$export$a74bff2507e6126b(_ref2) {
    var watchForInteractionStart = _ref2.watchForInteractionStart, watchForInteractionEnd = _ref2.watchForInteractionEnd;
    var registrationCount = 0;
    var stopWatchingInteractionStart = null;
    function start() {
        $c859726891399d7b$var$applyFix(watchForInteractionEnd);
    }
    function registerUsage() {
        if (registrationCount === 0) stopWatchingInteractionStart = watchForInteractionStart({
            start: start
        });
        registrationCount++;
        return function unregisterUsage() {
            var _stopWatchingInteract;
            registrationCount--;
            if (registrationCount !== 0) return;
            (_stopWatchingInteract = stopWatchingInteractionStart) === null || _stopWatchingInteract === void 0 || _stopWatchingInteract();
            stopWatchingInteractionStart = null;
        };
    }
    return {
        registerUsage: registerUsage
    };
}

});


parcelRegister("amgLb", function(module, exports) {
$parcel$export(module.exports, "disableDraggingToCrossOriginIFramesForExternal", () => $78a8f5a56061ae1c$export$27d79116d3a4e7d5);
parcelRequire("aPh0Z");
var $h6ZPT = parcelRequire("h6ZPT");

var $hcsdE = parcelRequire("hcsdE");
function $78a8f5a56061ae1c$var$watchForInteractionStart(_ref) {
    var start = _ref.start;
    return (0, $h6ZPT.monitorForExternal)({
        onDragStart: function onDragStart() {
            start();
        }
    });
}
function $78a8f5a56061ae1c$var$watchForInteractionEnd(_ref2) {
    var stop = _ref2.stop;
    return (0, $h6ZPT.monitorForExternal)({
        onDrop: function onDrop() {
            stop();
        }
    });
}
var $78a8f5a56061ae1c$var$api = (0, $hcsdE.makeFixForAdapter)({
    watchForInteractionStart: $78a8f5a56061ae1c$var$watchForInteractionStart,
    watchForInteractionEnd: $78a8f5a56061ae1c$var$watchForInteractionEnd
});
function $78a8f5a56061ae1c$export$27d79116d3a4e7d5() {
    return $78a8f5a56061ae1c$var$api.registerUsage();
}

});

parcelRegister("6fqgi", function(module, exports) {
$parcel$export(module.exports, "disableDraggingToCrossOriginIFramesForTextSelection", () => $48c883d283507441$export$9c0606fcefb5d1e2);

var $7QpUe = parcelRequire("7QpUe");
parcelRequire("jkmxD");
var $fGFYU = parcelRequire("fGFYU");
parcelRequire("4p4mj");
var $5O7Kz = parcelRequire("5O7Kz");

var $hcsdE = parcelRequire("hcsdE");
function $48c883d283507441$var$watchForInteractionEnd(_ref) {
    var stop = _ref.stop;
    var isDragging = false;
    function stopIfNotDragging() {
        if (isDragging) return;
        stop();
    }
    var frameId = null;
    var unbindEvents = (0, $7QpUe.bindAll)(window, [
        {
            // User is starting another interaction
            type: 'pointerdown',
            listener: stop
        },
        {
            // User did not start a drag.
            // "pointerdown" won't be fired if a drag started
            type: 'pointerup',
            listener: stopIfNotDragging
        },
        {
            type: 'dragstart',
            listener: function listener() {
                /**
       * The pdnd `onDragStart()` fires in the frame after "dragstart"
       * So we are delaying our isDragging check to give a chance
       * for `onDragStart()` to set the value correctly.
       *
       * Note: could not use "pointercancel" as it is not
       * published in Safari → https://bugs.webkit.org/show_bug.cgi?id=222632
       */ frameId = requestAnimationFrame(function() {
                    frameId = null;
                    stopIfNotDragging();
                });
            },
            // need to schedule our frame after the text-selection
            // adapter queues it's `onDragStart` frame.
            options: {
                capture: false
            }
        }
    ], {
        // Listening in the capture phase to increase resilience
        // against events being stopped.
        capture: true,
        // being super clear these should only run once
        once: true
    });
    var unbindMonitor = (0, $5O7Kz.monitorForTextSelection)({
        onDragStart: function onDragStart() {
            isDragging = true;
        },
        onDrop: function onDrop() {
            isDragging = false;
            stop();
        }
    });
    return (0, $fGFYU.combine)(unbindEvents, unbindMonitor, function abortFrame() {
        if (frameId != null) cancelAnimationFrame(frameId);
    });
}
function $48c883d283507441$var$watchForInteractionStart(_ref2) {
    var start = _ref2.start;
    return (0, $7QpUe.bind)(window, {
        // Note: Using "mousedown" rather than "pointerdown" due to a Safari bug.
        // Safari not publish a "pointerdown" on the interaction after a drag
        // → https://bugs.webkit.org/show_bug.cgi?id=279749
        type: 'mousedown',
        listener: function listener() {
            // A text selection drag will only start when there is
            // an active text selection.
            var selection = window.getSelection();
            // No selection object found
            if (!selection) return;
            // `isCollapsed` is "true" if there is currently no selected text
            if (selection.isCollapsed) return;
            start();
        }
    });
}
var $48c883d283507441$var$api = (0, $hcsdE.makeFixForAdapter)({
    watchForInteractionStart: $48c883d283507441$var$watchForInteractionStart,
    watchForInteractionEnd: $48c883d283507441$var$watchForInteractionEnd
});
function $48c883d283507441$export$9c0606fcefb5d1e2() {
    return $48c883d283507441$var$api.registerUsage();
}

});

parcelRegister("6mOEm", function(module, exports) {
$parcel$export(module.exports, "dialogWidth", () => $4a2c1630bd9b67e2$export$a3da89b899389ed8);
$parcel$export(module.exports, "dialogHeight", () => $4a2c1630bd9b67e2$export$ceba93bf0bdd16f2);
var $4a2c1630bd9b67e2$export$7e3df82ee760448c = {
    values: [
        'small',
        'medium',
        'large',
        'x-large'
    ],
    widths: {
        small: 400,
        medium: 600,
        large: 800,
        'x-large': 968
    },
    defaultValue: 'medium'
};
var $4a2c1630bd9b67e2$export$a3da89b899389ed8 = function dialogWidth(input) {
    if (!input) return 'auto';
    var isWidthName = $4a2c1630bd9b67e2$export$7e3df82ee760448c.values.indexOf(input.toString()) !== -1;
    var widthName = isWidthName && input;
    if (widthName) return "".concat($4a2c1630bd9b67e2$export$7e3df82ee760448c.widths[widthName], "px");
    return typeof input === 'number' ? "".concat(input, "px") : input;
};
var $4a2c1630bd9b67e2$export$ceba93bf0bdd16f2 = function dialogHeight(input) {
    if (!input) return 'auto';
    return typeof input === 'number' ? "".concat(input, "px") : input;
};

});

parcelRegister("fA8Gf", function(module, exports) {
$parcel$export(module.exports, "default", () => $b580f38a937ff05b$export$2e2bcd8739ae039);
/* positioner.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");

var $2ToBd = parcelRequire("2ToBd");

var $VfFcJ = parcelRequire("VfFcJ");

// Flex and min-content are set to constrain the height of the body and support multi-column scrolling experiences
var $b580f38a937ff05b$var$positionerStyles = null;
var $b580f38a937ff05b$var$stackStyles = {
    stackTransition: "_k8m01e03 _1bumglyw _sedtglyw",
    stackTransform: "_t9ec1b95",
    stackIdle: "_t9ecglyw"
};
// Hardcoded pixels are based off a 60px base gutter
var $b580f38a937ff05b$var$scrollStyles = {
    viewport: "_4t3i1wug _kqswh2mm _1f6n1wqb _1eot1wug _eoawglyw",
    body: "_we1i18uh _e8uozwhf _y1k5stnw _5ee41nf8 _1urridpf _1juqidpf _yakv1wug _4lht1wug _eoawglyw",
    fullScreen: ""
};
function $b580f38a937ff05b$var$getScrollBehavior(_ref) {
    var isFullScreen = _ref.isFullScreen, shouldScrollInViewport = _ref.shouldScrollInViewport;
    if (isFullScreen) return 'fullScreen';
    if (shouldScrollInViewport) return 'viewport';
    return 'body';
}
var $b580f38a937ff05b$var$Positioner = function Positioner(props) {
    var children = props.children, stackIndex = props.stackIndex, shouldScrollInViewport = props.shouldScrollInViewport, testId = props.testId, isFullScreen = props.isFullScreen;
    var scrollBehavior = $b580f38a937ff05b$var$getScrollBehavior({
        isFullScreen: isFullScreen,
        shouldScrollInViewport: shouldScrollInViewport
    });
    return /*#__PURE__*/ $5FkrB.createElement("div", {
        style: {
            '--modal-dialog-translate-y': "calc(".concat(stackIndex, "px * ", "var(--ds-space-100, 8px)", ")"),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            transitionDuration: "".concat((0, $VfFcJ.durations).medium, "ms"),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            transitionTimingFunction: (0, $2ToBd.easeInOut)
        },
        "data-testid": testId && "".concat(testId, "--positioner"),
        className: (0, $970q7.default)([
            "_1e0c1txw _1bsb1osq _p12f1osq _4t3i1osq _kqsw1n9t _1pby16oo _2lx21bp4 _152tidpf _1e02idpf",
            $b580f38a937ff05b$var$stackStyles.stackTransition,
            stackIndex > 0 ? $b580f38a937ff05b$var$stackStyles.stackTransform : $b580f38a937ff05b$var$stackStyles.stackIdle,
            $b580f38a937ff05b$var$scrollStyles[scrollBehavior]
        ])
    }, children);
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$b580f38a937ff05b$export$2e2bcd8739ae039 = $b580f38a937ff05b$var$Positioner;

});
parcelRegister("2ToBd", function(module, exports) {
$parcel$export(module.exports, "easeInOut", () => $21b3ccb8584b7523$export$c07234257a03d5e9);
var $21b3ccb8584b7523$export$c07234257a03d5e9 = 'cubic-bezier(0.15,1,0.3,1)';
var $21b3ccb8584b7523$export$57636bb43b1ccbb0 = 'cubic-bezier(0.2,0,0,1)';
var $21b3ccb8584b7523$export$929e5a82286172a6 = 'cubic-bezier(0.8,0,0,0.8)';
var $21b3ccb8584b7523$export$fc825baa2ef870d0 = 'cubic-bezier(0.4,0,0,1)';
var $21b3ccb8584b7523$export$816ee5d79b5bd9a5 = 'cubic-bezier(0.6,0,0,1)';
var $21b3ccb8584b7523$export$53ce3390a1a8f2a2 = 'cubic-bezier(0.8,0,0,1)';
var $21b3ccb8584b7523$export$45db2fc2f15997e7 = 'cubic-bezier(0,0,1,1)';

});





parcelRegister("jh6Of", function(module, exports) {
$parcel$export(module.exports, "default", () => $e084e30e97499a91$export$2e2bcd8739ae039);
/* modal-body.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $970q7 = parcelRequire("970q7");

var $5FkrB = parcelRequire("5FkrB");

var $3FlkA = parcelRequire("3FlkA");

var $9Zzpd = parcelRequire("9Zzpd");

var $k8Idm = parcelRequire("k8Idm");

var $9R5s9 = parcelRequire("9R5s9");

var $6nKMA = parcelRequire("6nKMA");
var $e084e30e97499a91$var$styles = {
    root: "_16jlkb7n _1o9zkb7n _i0dl1wug",
    font: "_11c82smr",
    paddingBlock: "_1rjcv77o",
    paddingInline: "_18zr1ejb"
};
/**
 * __Modal body__
 *
 * A modal body is used to display the main content of a modal.
 *
 * - [Examples](https://atlassian.design/components/modal-dialog/examples)
 * - [Code](https://atlassian.design/components/modal-dialog/code#modal-body-props)
 * - [Usage](https://atlassian.design/components/modal-dialog/usage)
 */ var $e084e30e97499a91$var$ModalBody = function ModalBody(props) {
    var children = props.children, userDefinedTestId = props.testId, _props$hasInlinePaddi = props.hasInlinePadding, hasInlinePadding = _props$hasInlinePaddi === void 0 ? true : _props$hasInlinePaddi;
    var _useModal = (0, $k8Idm.useModal)(), modalTestId = _useModal.testId;
    var shouldScrollInViewport = (0, $6nKMA.default)();
    var testId = userDefinedTestId || modalTestId && "".concat(modalTestId, "--body");
    return shouldScrollInViewport ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("div", {
        "data-testid": testId,
        className: (0, $970q7.default)([
            $e084e30e97499a91$var$styles.root,
            hasInlinePadding && $e084e30e97499a91$var$styles.paddingInline,
            (0, $9Zzpd.fg)('platform_ads_explicit_font_styles') && $e084e30e97499a91$var$styles.font
        ])
    }, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $3FlkA.TouchScrollable), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $9R5s9.default), {
        testId: userDefinedTestId || modalTestId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("div", {
        "data-testid": testId,
        className: (0, $970q7.default)([
            $e084e30e97499a91$var$styles.root,
            /**
     * Adding block padding for scroll keylines, which are only shown when the scrolling
     * is on the container.
     */ $e084e30e97499a91$var$styles.paddingBlock,
            hasInlinePadding && $e084e30e97499a91$var$styles.paddingInline,
            (0, $9Zzpd.fg)('platform_ads_explicit_font_styles') && $e084e30e97499a91$var$styles.font
        ])
    }, children)));
};
var $e084e30e97499a91$export$2e2bcd8739ae039 = $e084e30e97499a91$var$ModalBody;

});
parcelRegister("k8Idm", function(module, exports) {
$parcel$export(module.exports, "useModal", () => $ea96da15490aa5e1$export$33ffd74ebf07f060);

var $5FkrB = parcelRequire("5FkrB");

var $fAYgP = parcelRequire("fAYgP");
var $ea96da15490aa5e1$export$33ffd74ebf07f060 = function useModal() {
    var modalContext = (0, $5FkrB.useContext)((0, $fAYgP.ModalContext));
    if (modalContext == null) throw Error("@atlaskit/modal-dialog: Modal context unavailable \u2013 this component needs to be a child of ModalDialog.");
    return modalContext;
};

});

parcelRegister("9R5s9", function(module, exports) {
$parcel$export(module.exports, "default", () => $72cd4b2b8adc7c2e$export$2e2bcd8739ae039);
/* scroll-container.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $iYJcE = parcelRequire("iYJcE");


var $5FkrB = parcelRequire("5FkrB");

var $7QpUe = parcelRequire("7QpUe");

var $45Zis = parcelRequire("45Zis");

var $evbIR = parcelRequire("evbIR");

var $iO8GM = parcelRequire("iO8GM");

var $eVb4V = parcelRequire("eVb4V");

var $Xr0F9 = parcelRequire("Xr0F9");

var $8grH2 = parcelRequire("8grH2");
var $72cd4b2b8adc7c2e$var$keylineColor = "var(--ds-border, #0B120E24)";
var $72cd4b2b8adc7c2e$var$styles = {
    base: "_kkes1kw7 _1e0c1kw7 _2lx21kw7 _16jlkb7n _6rthze3t _1pfhze3t _12l2ze3t _ahbqze3t _1reo15vq _18m91wug _1jykn7od _wzg61wug",
    topKeyline: "_mqm21uh4",
    bottomKeyline: "_179r1uh4"
};
var $72cd4b2b8adc7c2e$var$keylineHeight = 2;
/**
 * A container that shows top and bottom keylines when the
 * content overflows into the scrollable element.
 */ var $72cd4b2b8adc7c2e$var$ScrollContainer = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function(_ref, ref) {
    var testId = _ref.testId, children = _ref.children;
    var scrollableRef = (0, $5FkrB.useRef)(null);
    var _useState = (0, $5FkrB.useState)(false), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), showTopKeyline = _useState2[0], setTopKeyline = _useState2[1];
    var _useState3 = (0, $5FkrB.useState)(false), _useState4 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState3, 2), showBottomKeyline = _useState4[0], setBottomKeyline = _useState4[1];
    var _useState5 = (0, $5FkrB.useState)(false), _useState6 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState5, 2), showContentFocus = _useState6[0], setContentFocus = _useState6[1];
    // Schedule a content focus on the target element
    // WARNING: In theory, `target` may not be available when `rafSchedule` hits in concurrent rendering
    (0, $5FkrB.useEffect)(function() {
        var schedule = (0, $45Zis.default)(function() {
            var target = scrollableRef.current;
            target && setContentFocus(target.scrollHeight > target.clientHeight);
        });
        schedule();
    }, [
        scrollableRef
    ]);
    var setLazyKeylines = (0, $Xr0F9.default)((0, $45Zis.default)(function() {
        var target = scrollableRef.current;
        if (target) {
            var scrollableDistance = target.scrollHeight - target.clientHeight;
            if (target.previousElementSibling) setTopKeyline(target.scrollTop > $72cd4b2b8adc7c2e$var$keylineHeight);
            if (target.nextElementSibling) setBottomKeyline(target.scrollTop <= scrollableDistance - $72cd4b2b8adc7c2e$var$keylineHeight);
        }
    }));
    // On load (and scroll/resize events), we set "keylines"
    // these border the content to indicate scrollability when content underflows the header or footer
    (0, $5FkrB.useEffect)(function() {
        var target = scrollableRef.current;
        setLazyKeylines();
        var unbindWindowEvent = (0, $7QpUe.bind)(window, {
            type: 'resize',
            listener: setLazyKeylines
        });
        var unbindTargetEvent = target ? (0, $7QpUe.bind)(target, {
            type: 'scroll',
            listener: setLazyKeylines
        }) : (0, $eVb4V.default);
        return function() {
            unbindWindowEvent();
            unbindTargetEvent();
        };
    }, [
        setLazyKeylines
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $8grH2.default), {
        as: "div",
        isInset: true,
        tabIndex: showContentFocus ? 0 : undefined,
        role: showContentFocus ? 'region' : undefined,
        "aria-label": showContentFocus ? 'Scrollable content' : undefined,
        testId: testId && "".concat(testId, "--scrollable"),
        ref: (0, $iO8GM.default)([
            ref,
            scrollableRef
        ]),
        xcss: (0, $evbIR.cx)($72cd4b2b8adc7c2e$var$styles.base, showTopKeyline && $72cd4b2b8adc7c2e$var$styles.topKeyline, showBottomKeyline && $72cd4b2b8adc7c2e$var$styles.bottomKeyline)
    }, children);
});
$72cd4b2b8adc7c2e$var$ScrollContainer.displayName = 'ScrollContainer';
var $72cd4b2b8adc7c2e$export$2e2bcd8739ae039 = $72cd4b2b8adc7c2e$var$ScrollContainer;

});

parcelRegister("6nKMA", function(module, exports) {
$parcel$export(module.exports, "default", () => $4a592e18864cff1e$export$2e2bcd8739ae039);

var $5FkrB = parcelRequire("5FkrB");

var $fAYgP = parcelRequire("fAYgP");
function $4a592e18864cff1e$export$2e2bcd8739ae039() {
    var shouldScrollInViewport = (0, $5FkrB.useContext)((0, $fAYgP.ScrollContext));
    if (shouldScrollInViewport == null) throw Error("@atlaskit/modal-dialog: Scroll context unavailable \u2013 this component needs to be a child of ModalDialog.");
    return shouldScrollInViewport;
}

});


parcelRegister("3oYKE", function(module, exports) {
$parcel$export(module.exports, "default", () => $27a2bcf6b5739b95$export$2e2bcd8739ae039);
/* modal-footer.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");

var $k8Idm = parcelRequire("k8Idm");
var $27a2bcf6b5739b95$var$footerStyles = null;
/**
 * __Modal footer__
 *
 * A modal footer often contains a primary action and the ability to cancel and close the dialog, though can contain any React element.
 *
 * - [Examples](https://atlassian.design/components/modal-dialog/examples#modal-footer)
 * - [Code](https://atlassian.design/components/modal-dialog/code#modal-footer-props)
 * - [Usage](https://atlassian.design/components/modal-dialog/usage)
 */ var $27a2bcf6b5739b95$var$ModalFooter = function ModalFooter(props) {
    var children = props.children, userDefinedTestId = props.testId;
    var _useModal = (0, $k8Idm.useModal)(), modalTestId = _useModal.testId;
    var testId = userDefinedTestId || modalTestId && "".concat(modalTestId, "--footer");
    return /*#__PURE__*/ $5FkrB.createElement("div", {
        "data-testid": testId,
        className: (0, $970q7.default)([
            "_zulpu2gc _18zr1ejb _1e0c1txw _kqswh2mm _4cvr1h6o _1bahesu3 _1pfh1i6y _85i51ejb _1q51pxbi"
        ])
    }, children);
};
var $27a2bcf6b5739b95$export$2e2bcd8739ae039 = $27a2bcf6b5739b95$var$ModalFooter;

});

parcelRegister("acmdv", function(module, exports) {
$parcel$export(module.exports, "default", () => $76cc42296ea847b3$export$2e2bcd8739ae039);
/* modal-header.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $970q7 = parcelRequire("970q7");

var $5FkrB = parcelRequire("5FkrB");

var $gLyAa = parcelRequire("gLyAa");
var $8cni7 = parcelRequire("8cni7");

var $83z99 = parcelRequire("83z99");

var $k8Idm = parcelRequire("k8Idm");
var $76cc42296ea847b3$var$headerStyles = null;
var $76cc42296ea847b3$var$flexStyles = (0, $8cni7.xcss)({
    flexDirection: 'row-reverse',
    width: '100%'
});
/**
 * __Modal header__
 *
 * A modal header contains the title of the modal and can contain other React elements such as a close button.
 *
 * - [Examples](https://atlassian.design/components/modal-dialog/examples#modal-header)
 * - [Code](https://atlassian.design/components/modal-dialog/code#modal-header-props)
 * - [Usage](https://atlassian.design/components/modal-dialog/usage)
 */ var $76cc42296ea847b3$var$ModalHeader = function ModalHeader(props) {
    var children = props.children, userDefinedTestId = props.testId, _props$hasCloseButton = props.hasCloseButton, hasCloseButton = _props$hasCloseButton === void 0 ? false : _props$hasCloseButton;
    var _useModal = (0, $k8Idm.useModal)(), hasProvidedOnClose = _useModal.hasProvidedOnClose, onClose = _useModal.onClose, modalTestId = _useModal.testId;
    var testId = userDefinedTestId || modalTestId && "".concat(modalTestId, "--header");
    // Only show if an onClose was provided for the modal dialog
    var shouldShowCloseButton = hasCloseButton && hasProvidedOnClose && onClose;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("div", {
        "data-testid": testId,
        className: (0, $970q7.default)([
            "_18zr1ejb _1e0c1txw _kqswh2mm _4cvr1h6o _1bah1yb4 _6rth1i6y _85i5pxbi _1q511ejb"
        ])
    }, shouldShowCloseButton ? /*#__PURE__*/ // The reason we are putting the close button first in the DOM and then
    // reordering them is to ensure that users of assistive technology get
    // all the context of a modal when initial focus is placed on the close
    // button, since it's the first interactive element.
    (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $gLyAa.default), {
        gap: "space.200",
        justifyContent: "space-between",
        xcss: $76cc42296ea847b3$var$flexStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $gLyAa.default), {
        justifyContent: "end"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $83z99.CloseButton), {
        onClick: onClose,
        testId: modalTestId
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $gLyAa.default), {
        justifyContent: "start",
        alignItems: "center"
    }, children)) : children);
};
var $76cc42296ea847b3$export$2e2bcd8739ae039 = $76cc42296ea847b3$var$ModalHeader;

});
parcelRegister("gLyAa", function(module, exports) {
$parcel$export(module.exports, "default", () => $c34bdc745f5e9e41$export$2e2bcd8739ae039);

var $fC8ib = parcelRequire("fC8ib");

var $5FkrB = parcelRequire("5FkrB");

var $74Zh5 = parcelRequire("74Zh5");

var $imxuh = parcelRequire("imxuh");

var $8cni7 = parcelRequire("8cni7");
var $c34bdc745f5e9e41$var$justifyContentMap = {
    start: (0, $74Zh5.css)({
        justifyContent: 'start'
    }),
    center: (0, $74Zh5.css)({
        justifyContent: 'center'
    }),
    end: (0, $74Zh5.css)({
        justifyContent: 'end'
    }),
    'space-between': (0, $74Zh5.css)({
        justifyContent: 'space-between'
    }),
    'space-around': (0, $74Zh5.css)({
        justifyContent: 'space-around'
    }),
    'space-evenly': (0, $74Zh5.css)({
        justifyContent: 'space-evenly'
    }),
    stretch: (0, $74Zh5.css)({
        justifyContent: 'stretch'
    })
};
var $c34bdc745f5e9e41$var$flexDirectionMap = {
    column: (0, $74Zh5.css)({
        flexDirection: 'column'
    }),
    row: (0, $74Zh5.css)({
        flexDirection: 'row'
    })
};
var $c34bdc745f5e9e41$var$flexWrapMap = {
    wrap: (0, $74Zh5.css)({
        flexWrap: 'wrap'
    }),
    nowrap: (0, $74Zh5.css)({
        flexWrap: 'nowrap'
    })
};
var $c34bdc745f5e9e41$var$alignItemsMap = {
    start: (0, $74Zh5.css)({
        alignItems: 'start'
    }),
    center: (0, $74Zh5.css)({
        alignItems: 'center'
    }),
    baseline: (0, $74Zh5.css)({
        alignItems: 'baseline'
    }),
    end: (0, $74Zh5.css)({
        alignItems: 'end'
    }),
    stretch: (0, $74Zh5.css)({
        alignItems: 'stretch'
    })
};
var $c34bdc745f5e9e41$var$baseStyles = (0, $74Zh5.css)({
    display: 'flex',
    boxSizing: 'border-box'
});
/**
 * __Flex__
 *
 * `Flex` is a primitive component that implements the CSS Flexbox API.
 *
 * - [Examples](https://atlassian.design/components/primitives/flex/examples)
 * - [Code](https://atlassian.design/components/primitives/flex/code)
 *
 * @example
 * ```tsx
 * // eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
 * import { Flex, Box } from '@atlaskit/primitives'
 *
 * const Component = () => (
 *   <Flex direction="column">
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *   </Flex>
 * )
 * ```
 */ var $c34bdc745f5e9e41$var$Flex = /*#__PURE__*/ (0, $5FkrB.memo)(/*#__PURE__*/ (0, $5FkrB.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? 'div' : _ref$as, role = _ref.role, alignItems = _ref.alignItems, justifyContent = _ref.justifyContent, gap = _ref.gap, columnGap = _ref.columnGap, rowGap = _ref.rowGap, children = _ref.children, testId = _ref.testId, direction = _ref.direction, wrap = _ref.wrap, xcss = _ref.xcss, id = _ref.id;
    var resolvedStyles = (0, $8cni7.parseXcss)(xcss);
    return (0, $74Zh5.jsx)(Component, {
        id: id,
        role: role,
        className: resolvedStyles.static,
        css: [
            $c34bdc745f5e9e41$var$baseStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            gap && (0, $imxuh.spaceStylesMap).gap[gap],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            columnGap && (0, $imxuh.spaceStylesMap).columnGap[columnGap],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            rowGap && (0, $imxuh.spaceStylesMap).rowGap[rowGap],
            alignItems && $c34bdc745f5e9e41$var$alignItemsMap[alignItems],
            direction && $c34bdc745f5e9e41$var$flexDirectionMap[direction],
            justifyContent && $c34bdc745f5e9e41$var$justifyContentMap[justifyContent],
            wrap && $c34bdc745f5e9e41$var$flexWrapMap[wrap]
        ].concat((0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(resolvedStyles.emotion || [])),
        "data-testid": testId,
        ref: ref
    }, children);
}));
$c34bdc745f5e9e41$var$Flex.displayName = 'Flex';
var $c34bdc745f5e9e41$export$2e2bcd8739ae039 = $c34bdc745f5e9e41$var$Flex;

});
parcelRegister("imxuh", function(module, exports) {
$parcel$export(module.exports, "dimensionMap", () => $d5e441fb06e0ea7d$export$6ccdbebca2ee545f);
$parcel$export(module.exports, "positiveSpaceMap", () => $d5e441fb06e0ea7d$export$958d0ae7f2977ae4);
$parcel$export(module.exports, "allSpaceMap", () => $d5e441fb06e0ea7d$export$632685d741f3dbbf);
$parcel$export(module.exports, "inverseColorMap", () => $d5e441fb06e0ea7d$export$2185ce37f9bdd963);
$parcel$export(module.exports, "opacityMap", () => $d5e441fb06e0ea7d$export$daf94a976c798b4f);
$parcel$export(module.exports, "shadowMap", () => $d5e441fb06e0ea7d$export$7aff6e7ba39bb774);
$parcel$export(module.exports, "borderColorMap", () => $d5e441fb06e0ea7d$export$1531ad5bb3fbedac);
$parcel$export(module.exports, "backgroundColorMap", () => $d5e441fb06e0ea7d$export$d1d79bf68ac056bd);
$parcel$export(module.exports, "textColorMap", () => $d5e441fb06e0ea7d$export$8473307aa00d6ea1);
$parcel$export(module.exports, "layerMap", () => $d5e441fb06e0ea7d$export$b5f31a7e431d2eab);
$parcel$export(module.exports, "borderWidthMap", () => $d5e441fb06e0ea7d$export$e1b83c5210c471b8);
$parcel$export(module.exports, "borderRadiusMap", () => $d5e441fb06e0ea7d$export$3c0a6c3e64bb180d);
$parcel$export(module.exports, "fontMap", () => $d5e441fb06e0ea7d$export$6ffa317d5e70375);
$parcel$export(module.exports, "fontWeightMap", () => $d5e441fb06e0ea7d$export$303e322c6b1ed114);
$parcel$export(module.exports, "fontFamilyMap", () => $d5e441fb06e0ea7d$export$3c7e9587132614b4);
$parcel$export(module.exports, "spaceStylesMap", () => $d5e441fb06e0ea7d$export$bf46c3f9eeafc71f);
$parcel$export(module.exports, "textColorStylesMap", () => $d5e441fb06e0ea7d$export$3a1bcba60b23d7f0);
$parcel$export(module.exports, "textSizeStylesMap", () => $d5e441fb06e0ea7d$export$219d364c0da35ae4);
$parcel$export(module.exports, "textWeightStylesMap", () => $d5e441fb06e0ea7d$export$38845ca010b93505);

var $25nEq = parcelRequire("25nEq");

var $74Zh5 = parcelRequire("74Zh5");

var $4bYmA = parcelRequire("4bYmA");
function $d5e441fb06e0ea7d$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $d5e441fb06e0ea7d$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $d5e441fb06e0ea7d$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $d5e441fb06e0ea7d$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $d5e441fb06e0ea7d$export$6ccdbebca2ee545f = {
    '100%': '100%',
    'size.100': '1rem',
    'size.200': '1.5rem',
    'size.300': '2rem',
    'size.400': '2.5rem',
    'size.500': '3rem',
    'size.600': '6rem',
    'size.1000': '12rem'
};
var $d5e441fb06e0ea7d$export$958d0ae7f2977ae4 = {
    'space.0': "var(--ds-space-0, 0px)",
    'space.025': "var(--ds-space-025, 2px)",
    'space.050': "var(--ds-space-050, 4px)",
    'space.075': "var(--ds-space-075, 6px)",
    'space.100': "var(--ds-space-100, 8px)",
    'space.150': "var(--ds-space-150, 12px)",
    'space.200': "var(--ds-space-200, 16px)",
    'space.250': "var(--ds-space-250, 20px)",
    'space.300': "var(--ds-space-300, 24px)",
    'space.400': "var(--ds-space-400, 32px)",
    'space.500': "var(--ds-space-500, 40px)",
    'space.600': "var(--ds-space-600, 48px)",
    'space.800': "var(--ds-space-800, 64px)",
    'space.1000': "var(--ds-space-1000, 80px)"
};
var $d5e441fb06e0ea7d$export$d2dc61f58390201c = {
    'space.negative.025': "var(--ds-space-negative-025, -2px)",
    'space.negative.050': "var(--ds-space-negative-050, -4px)",
    'space.negative.075': "var(--ds-space-negative-075, -6px)",
    'space.negative.100': "var(--ds-space-negative-100, -8px)",
    'space.negative.150': "var(--ds-space-negative-150, -12px)",
    'space.negative.200': "var(--ds-space-negative-200, -16px)",
    'space.negative.250': "var(--ds-space-negative-250, -20px)",
    'space.negative.300': "var(--ds-space-negative-300, -24px)",
    'space.negative.400': "var(--ds-space-negative-400, -32px)"
};
var $d5e441fb06e0ea7d$export$632685d741f3dbbf = $d5e441fb06e0ea7d$var$_objectSpread($d5e441fb06e0ea7d$var$_objectSpread({}, $d5e441fb06e0ea7d$export$958d0ae7f2977ae4), $d5e441fb06e0ea7d$export$d2dc61f58390201c);
var $d5e441fb06e0ea7d$export$2185ce37f9bdd963 = {
    'color.background.neutral.bold': 'color.text.inverse',
    'color.background.neutral.bold.hovered': 'color.text.inverse',
    'color.background.neutral.bold.pressed': 'color.text.inverse',
    'color.background.selected.bold': 'color.text.inverse',
    'color.background.selected.bold.hovered': 'color.text.inverse',
    'color.background.selected.bold.pressed': 'color.text.inverse',
    'color.background.brand.bold': 'color.text.inverse',
    'color.background.brand.bold.hovered': 'color.text.inverse',
    'color.background.brand.bold.pressed': 'color.text.inverse',
    'color.background.brand.boldest': 'color.text.inverse',
    'color.background.brand.boldest.hovered': 'color.text.inverse',
    'color.background.brand.boldest.pressed': 'color.text.inverse',
    'color.background.danger.bold': 'color.text.inverse',
    'color.background.danger.bold.hovered': 'color.text.inverse',
    'color.background.danger.bold.pressed': 'color.text.inverse',
    'color.background.warning.bold': 'color.text.warning.inverse',
    'color.background.warning.bold.hovered': 'color.text.warning.inverse',
    'color.background.warning.bold.pressed': 'color.text.warning.inverse',
    'color.background.success.bold': 'color.text.inverse',
    'color.background.success.bold.hovered': 'color.text.inverse',
    'color.background.success.bold.pressed': 'color.text.inverse',
    'color.background.discovery.bold': 'color.text.inverse',
    'color.background.discovery.bold.hovered': 'color.text.inverse',
    'color.background.discovery.bold.pressed': 'color.text.inverse',
    'color.background.information.bold': 'color.text.inverse',
    'color.background.information.bold.hovered': 'color.text.inverse',
    'color.background.information.bold.pressed': 'color.text.inverse'
};
var $d5e441fb06e0ea7d$export$daf94a976c798b4f = {
    'opacity.disabled': "var(--ds-opacity-disabled, 0.4)",
    'opacity.loading': "var(--ds-opacity-loading, 0.2)"
};
var $d5e441fb06e0ea7d$export$7aff6e7ba39bb774 = {
    'elevation.shadow.overflow': "var(--ds-shadow-overflow, 0px 0px 8px #091e423f, 0px 0px 1px #091e424f)",
    'elevation.shadow.overflow.perimeter': "var(--ds-shadow-overflow-perimeter, #091e421f)",
    'elevation.shadow.overflow.spread': "var(--ds-shadow-overflow-spread, #091e4229)",
    'elevation.shadow.overlay': "var(--ds-shadow-overlay, 0px 8px 12px #091e423f, 0px 0px 1px #091e424f)",
    'elevation.shadow.raised': "var(--ds-shadow-raised, 0px 1px 1px #091e423f, 0px 0px 1px #091e4221)"
};
var $d5e441fb06e0ea7d$export$41a358c9c2356760 = {
    'elevation.surface': "var(--ds-surface, #FFFFFF)",
    'elevation.surface.hovered': "var(--ds-surface-hovered, #FAFBFC)",
    'elevation.surface.pressed': "var(--ds-surface-pressed, #F4F5F7)",
    'elevation.surface.overlay': "var(--ds-surface-overlay, #FFFFFF)",
    'elevation.surface.overlay.hovered': "var(--ds-surface-overlay-hovered, #FAFBFC)",
    'elevation.surface.overlay.pressed': "var(--ds-surface-overlay-pressed, #F4F5F7)",
    'elevation.surface.raised': "var(--ds-surface-raised, #FFFFFF)",
    'elevation.surface.raised.hovered': "var(--ds-surface-raised-hovered, #FAFBFC)",
    'elevation.surface.raised.pressed': "var(--ds-surface-raised-pressed, #F4F5F7)",
    'elevation.surface.sunken': "var(--ds-surface-sunken, #F4F5F7)"
};
var $d5e441fb06e0ea7d$export$1531ad5bb3fbedac = {
    'color.border': "var(--ds-border, #091e4221)",
    'color.border.accent.lime': "var(--ds-border-accent-lime, #6A9A23)",
    'color.border.accent.red': "var(--ds-border-accent-red, #FF5630)",
    'color.border.accent.orange': "var(--ds-border-accent-orange, #D94008)",
    'color.border.accent.yellow': "var(--ds-border-accent-yellow, #FFAB00)",
    'color.border.accent.green': "var(--ds-border-accent-green, #36B37E)",
    'color.border.accent.teal': "var(--ds-border-accent-teal, #00B8D9)",
    'color.border.accent.blue': "var(--ds-border-accent-blue, #0065FF)",
    'color.border.accent.purple': "var(--ds-border-accent-purple, #6554C0)",
    'color.border.accent.magenta': "var(--ds-border-accent-magenta, #CD519D)",
    'color.border.accent.gray': "var(--ds-border-accent-gray, #5E6C84)",
    'color.border.disabled': "var(--ds-border-disabled, #FAFBFC)",
    'color.border.focused': "var(--ds-border-focused, #2684FF)",
    'color.border.input': "var(--ds-border-input, #FAFBFC)",
    'color.border.inverse': "var(--ds-border-inverse, #FFFFFF)",
    'color.border.selected': "var(--ds-border-selected, #0052CC)",
    'color.border.brand': "var(--ds-border-brand, #0052CC)",
    'color.border.danger': "var(--ds-border-danger, #FF5630)",
    'color.border.warning': "var(--ds-border-warning, #FFC400)",
    'color.border.success': "var(--ds-border-success, #00875A)",
    'color.border.discovery': "var(--ds-border-discovery, #998DD9)",
    'color.border.information': "var(--ds-border-information, #0065FF)",
    'color.border.bold': "var(--ds-border-bold, #344563)"
};
var $d5e441fb06e0ea7d$export$d1d79bf68ac056bd = {
    'color.background.accent.lime.subtlest': "var(--ds-background-accent-lime-subtlest, #EEFBDA)",
    'color.background.accent.lime.subtlest.hovered': "var(--ds-background-accent-lime-subtlest-hovered, #D3F1A7)",
    'color.background.accent.lime.subtlest.pressed': "var(--ds-background-accent-lime-subtlest-pressed, #B3DF72)",
    'color.background.accent.lime.subtler': "var(--ds-background-accent-lime-subtler, #D3F1A7)",
    'color.background.accent.lime.subtler.hovered': "var(--ds-background-accent-lime-subtler-hovered, #B3DF72)",
    'color.background.accent.lime.subtler.pressed': "var(--ds-background-accent-lime-subtler-pressed, #94C748)",
    'color.background.accent.lime.subtle': "var(--ds-background-accent-lime-subtle, #94C748)",
    'color.background.accent.lime.subtle.hovered': "var(--ds-background-accent-lime-subtle-hovered, #B3DF72)",
    'color.background.accent.lime.subtle.pressed': "var(--ds-background-accent-lime-subtle-pressed, #D3F1A7)",
    'color.background.accent.lime.bolder': "var(--ds-background-accent-lime-bolder, #5B7F24)",
    'color.background.accent.lime.bolder.hovered': "var(--ds-background-accent-lime-bolder-hovered, #37471F)",
    'color.background.accent.lime.bolder.pressed': "var(--ds-background-accent-lime-bolder-pressed, #37471F)",
    'color.background.accent.red.subtlest': "var(--ds-background-accent-red-subtlest, #FF8F73)",
    'color.background.accent.red.subtlest.hovered': "var(--ds-background-accent-red-subtlest-hovered, #FF7452)",
    'color.background.accent.red.subtlest.pressed': "var(--ds-background-accent-red-subtlest-pressed, #FF5630)",
    'color.background.accent.red.subtler': "var(--ds-background-accent-red-subtler, #FF7452)",
    'color.background.accent.red.subtler.hovered': "var(--ds-background-accent-red-subtler-hovered, #FF5630)",
    'color.background.accent.red.subtler.pressed': "var(--ds-background-accent-red-subtler-pressed, #DE350B)",
    'color.background.accent.red.subtle': "var(--ds-background-accent-red-subtle, #DE350B)",
    'color.background.accent.red.subtle.hovered': "var(--ds-background-accent-red-subtle-hovered, #FF5630)",
    'color.background.accent.red.subtle.pressed': "var(--ds-background-accent-red-subtle-pressed, #FF7452)",
    'color.background.accent.red.bolder': "var(--ds-background-accent-red-bolder, #DE350B)",
    'color.background.accent.red.bolder.hovered': "var(--ds-background-accent-red-bolder-hovered, #FF5630)",
    'color.background.accent.red.bolder.pressed': "var(--ds-background-accent-red-bolder-pressed, #FF7452)",
    'color.background.accent.orange.subtlest': "var(--ds-background-accent-orange-subtlest, #F18D13)",
    'color.background.accent.orange.subtlest.hovered': "var(--ds-background-accent-orange-subtlest-hovered, #FEC57B)",
    'color.background.accent.orange.subtlest.pressed': "var(--ds-background-accent-orange-subtlest-pressed, #FFE2BD)",
    'color.background.accent.orange.subtler': "var(--ds-background-accent-orange-subtler, #B65C02)",
    'color.background.accent.orange.subtler.hovered': "var(--ds-background-accent-orange-subtler-hovered, #F18D13)",
    'color.background.accent.orange.subtler.pressed': "var(--ds-background-accent-orange-subtler-pressed, #FEC57B)",
    'color.background.accent.orange.subtle': "var(--ds-background-accent-orange-subtle, #5F3811)",
    'color.background.accent.orange.subtle.hovered': "var(--ds-background-accent-orange-subtle-hovered, #974F0C)",
    'color.background.accent.orange.subtle.pressed': "var(--ds-background-accent-orange-subtle-pressed, #B65C02)",
    'color.background.accent.orange.bolder': "var(--ds-background-accent-orange-bolder, #43290F)",
    'color.background.accent.orange.bolder.hovered': "var(--ds-background-accent-orange-bolder-hovered, #5F3811)",
    'color.background.accent.orange.bolder.pressed': "var(--ds-background-accent-orange-bolder-pressed, #974F0C)",
    'color.background.accent.yellow.subtlest': "var(--ds-background-accent-yellow-subtlest, #FFE380)",
    'color.background.accent.yellow.subtlest.hovered': "var(--ds-background-accent-yellow-subtlest-hovered, #FFC400)",
    'color.background.accent.yellow.subtlest.pressed': "var(--ds-background-accent-yellow-subtlest-pressed, #FFAB00)",
    'color.background.accent.yellow.subtler': "var(--ds-background-accent-yellow-subtler, #FFC400)",
    'color.background.accent.yellow.subtler.hovered': "var(--ds-background-accent-yellow-subtler-hovered, #FFAB00)",
    'color.background.accent.yellow.subtler.pressed': "var(--ds-background-accent-yellow-subtler-pressed, #FF991F)",
    'color.background.accent.yellow.subtle': "var(--ds-background-accent-yellow-subtle, #FF991F)",
    'color.background.accent.yellow.subtle.hovered': "var(--ds-background-accent-yellow-subtle-hovered, #FFAB00)",
    'color.background.accent.yellow.subtle.pressed': "var(--ds-background-accent-yellow-subtle-pressed, #FFC400)",
    'color.background.accent.yellow.bolder': "var(--ds-background-accent-yellow-bolder, #FF991F)",
    'color.background.accent.yellow.bolder.hovered': "var(--ds-background-accent-yellow-bolder-hovered, #FFAB00)",
    'color.background.accent.yellow.bolder.pressed': "var(--ds-background-accent-yellow-bolder-pressed, #FFC400)",
    'color.background.accent.green.subtlest': "var(--ds-background-accent-green-subtlest, #79F2C0)",
    'color.background.accent.green.subtlest.hovered': "var(--ds-background-accent-green-subtlest-hovered, #57D9A3)",
    'color.background.accent.green.subtlest.pressed': "var(--ds-background-accent-green-subtlest-pressed, #36B37E)",
    'color.background.accent.green.subtler': "var(--ds-background-accent-green-subtler, #57D9A3)",
    'color.background.accent.green.subtler.hovered': "var(--ds-background-accent-green-subtler-hovered, #36B37E)",
    'color.background.accent.green.subtler.pressed': "var(--ds-background-accent-green-subtler-pressed, #00875A)",
    'color.background.accent.green.subtle': "var(--ds-background-accent-green-subtle, #00875A)",
    'color.background.accent.green.subtle.hovered': "var(--ds-background-accent-green-subtle-hovered, #36B37E)",
    'color.background.accent.green.subtle.pressed': "var(--ds-background-accent-green-subtle-pressed, #57D9A3)",
    'color.background.accent.green.bolder': "var(--ds-background-accent-green-bolder, #00875A)",
    'color.background.accent.green.bolder.hovered': "var(--ds-background-accent-green-bolder-hovered, #36B37E)",
    'color.background.accent.green.bolder.pressed': "var(--ds-background-accent-green-bolder-pressed, #57D9A3)",
    'color.background.accent.teal.subtlest': "var(--ds-background-accent-teal-subtlest, #79E2F2)",
    'color.background.accent.teal.subtlest.hovered': "var(--ds-background-accent-teal-subtlest-hovered, #00C7E6)",
    'color.background.accent.teal.subtlest.pressed': "var(--ds-background-accent-teal-subtlest-pressed, #00B8D9)",
    'color.background.accent.teal.subtler': "var(--ds-background-accent-teal-subtler, #00C7E6)",
    'color.background.accent.teal.subtler.hovered': "var(--ds-background-accent-teal-subtler-hovered, #00B8D9)",
    'color.background.accent.teal.subtler.pressed': "var(--ds-background-accent-teal-subtler-pressed, #00A3BF)",
    'color.background.accent.teal.subtle': "var(--ds-background-accent-teal-subtle, #00A3BF)",
    'color.background.accent.teal.subtle.hovered': "var(--ds-background-accent-teal-subtle-hovered, #00B8D9)",
    'color.background.accent.teal.subtle.pressed': "var(--ds-background-accent-teal-subtle-pressed, #00C7E6)",
    'color.background.accent.teal.bolder': "var(--ds-background-accent-teal-bolder, #00A3BF)",
    'color.background.accent.teal.bolder.hovered': "var(--ds-background-accent-teal-bolder-hovered, #00B8D9)",
    'color.background.accent.teal.bolder.pressed': "var(--ds-background-accent-teal-bolder-pressed, #00C7E6)",
    'color.background.accent.blue.subtlest': "var(--ds-background-accent-blue-subtlest, #4C9AFF)",
    'color.background.accent.blue.subtlest.hovered': "var(--ds-background-accent-blue-subtlest-hovered, #2684FF)",
    'color.background.accent.blue.subtlest.pressed': "var(--ds-background-accent-blue-subtlest-pressed, #0065FF)",
    'color.background.accent.blue.subtler': "var(--ds-background-accent-blue-subtler, #2684FF)",
    'color.background.accent.blue.subtler.hovered': "var(--ds-background-accent-blue-subtler-hovered, #0065FF)",
    'color.background.accent.blue.subtler.pressed': "var(--ds-background-accent-blue-subtler-pressed, #0052CC)",
    'color.background.accent.blue.subtle': "var(--ds-background-accent-blue-subtle, #0052CC)",
    'color.background.accent.blue.subtle.hovered': "var(--ds-background-accent-blue-subtle-hovered, #0065FF)",
    'color.background.accent.blue.subtle.pressed': "var(--ds-background-accent-blue-subtle-pressed, #2684FF)",
    'color.background.accent.blue.bolder': "var(--ds-background-accent-blue-bolder, #0052CC)",
    'color.background.accent.blue.bolder.hovered': "var(--ds-background-accent-blue-bolder-hovered, #0065FF)",
    'color.background.accent.blue.bolder.pressed': "var(--ds-background-accent-blue-bolder-pressed, #2684FF)",
    'color.background.accent.purple.subtlest': "var(--ds-background-accent-purple-subtlest, #998DD9)",
    'color.background.accent.purple.subtlest.hovered': "var(--ds-background-accent-purple-subtlest-hovered, #8777D9)",
    'color.background.accent.purple.subtlest.pressed': "var(--ds-background-accent-purple-subtlest-pressed, #6554C0)",
    'color.background.accent.purple.subtler': "var(--ds-background-accent-purple-subtler, #8777D9)",
    'color.background.accent.purple.subtler.hovered': "var(--ds-background-accent-purple-subtler-hovered, #6554C0)",
    'color.background.accent.purple.subtler.pressed': "var(--ds-background-accent-purple-subtler-pressed, #5243AA)",
    'color.background.accent.purple.subtle': "var(--ds-background-accent-purple-subtle, #5243AA)",
    'color.background.accent.purple.subtle.hovered': "var(--ds-background-accent-purple-subtle-hovered, #6554C0)",
    'color.background.accent.purple.subtle.pressed': "var(--ds-background-accent-purple-subtle-pressed, #8777D9)",
    'color.background.accent.purple.bolder': "var(--ds-background-accent-purple-bolder, #5243AA)",
    'color.background.accent.purple.bolder.hovered': "var(--ds-background-accent-purple-bolder-hovered, #6554C0)",
    'color.background.accent.purple.bolder.pressed': "var(--ds-background-accent-purple-bolder-pressed, #8777D9)",
    'color.background.accent.magenta.subtlest': "var(--ds-background-accent-magenta-subtlest, #FFECF8)",
    'color.background.accent.magenta.subtlest.hovered': "var(--ds-background-accent-magenta-subtlest-hovered, #FDD0EC)",
    'color.background.accent.magenta.subtlest.pressed': "var(--ds-background-accent-magenta-subtlest-pressed, #F797D2)",
    'color.background.accent.magenta.subtler': "var(--ds-background-accent-magenta-subtler, #FDD0EC)",
    'color.background.accent.magenta.subtler.hovered': "var(--ds-background-accent-magenta-subtler-hovered, #F797D2)",
    'color.background.accent.magenta.subtler.pressed': "var(--ds-background-accent-magenta-subtler-pressed, #E774BB)",
    'color.background.accent.magenta.subtle': "var(--ds-background-accent-magenta-subtle, #E774BB)",
    'color.background.accent.magenta.subtle.hovered': "var(--ds-background-accent-magenta-subtle-hovered, #F797D2)",
    'color.background.accent.magenta.subtle.pressed': "var(--ds-background-accent-magenta-subtle-pressed, #FDD0EC)",
    'color.background.accent.magenta.bolder': "var(--ds-background-accent-magenta-bolder, #AE4787)",
    'color.background.accent.magenta.bolder.hovered': "var(--ds-background-accent-magenta-bolder-hovered, #943D73)",
    'color.background.accent.magenta.bolder.pressed': "var(--ds-background-accent-magenta-bolder-pressed, #50253F)",
    'color.background.accent.gray.subtlest': "var(--ds-background-accent-gray-subtlest, #6B778C)",
    'color.background.accent.gray.subtlest.hovered': "var(--ds-background-accent-gray-subtlest-hovered, #5E6C84)",
    'color.background.accent.gray.subtlest.pressed': "var(--ds-background-accent-gray-subtlest-pressed, #505F79)",
    'color.background.accent.gray.subtler': "var(--ds-background-accent-gray-subtler, #5E6C84)",
    'color.background.accent.gray.subtler.hovered': "var(--ds-background-accent-gray-subtler-hovered, #505F79)",
    'color.background.accent.gray.subtler.pressed': "var(--ds-background-accent-gray-subtler-pressed, #42526E)",
    'color.background.accent.gray.subtle': "var(--ds-background-accent-gray-subtle, #505F79)",
    'color.background.accent.gray.subtle.hovered': "var(--ds-background-accent-gray-subtle-hovered, #5E6C84)",
    'color.background.accent.gray.subtle.pressed': "var(--ds-background-accent-gray-subtle-pressed, #6B778C)",
    'color.background.accent.gray.bolder': "var(--ds-background-accent-gray-bolder, #42526E)",
    'color.background.accent.gray.bolder.hovered': "var(--ds-background-accent-gray-bolder-hovered, #344563)",
    'color.background.accent.gray.bolder.pressed': "var(--ds-background-accent-gray-bolder-pressed, #253858)",
    'color.background.disabled': "var(--ds-background-disabled, #091e4289)",
    'color.background.input': "var(--ds-background-input, #FAFBFC)",
    'color.background.input.hovered': "var(--ds-background-input-hovered, #EBECF0)",
    'color.background.input.pressed': "var(--ds-background-input-pressed, #FFFFFF)",
    'color.background.inverse.subtle': "var(--ds-background-inverse-subtle, #00000029)",
    'color.background.inverse.subtle.hovered': "var(--ds-background-inverse-subtle-hovered, #0000003D)",
    'color.background.inverse.subtle.pressed': "var(--ds-background-inverse-subtle-pressed, #00000052)",
    'color.background.neutral': "var(--ds-background-neutral, #DFE1E6)",
    'color.background.neutral.hovered': "var(--ds-background-neutral-hovered, #091e4214)",
    'color.background.neutral.pressed': "var(--ds-background-neutral-pressed, #B3D4FF)",
    'color.background.neutral.subtle': "var(--ds-background-neutral-subtle, transparent)",
    'color.background.neutral.subtle.hovered': "var(--ds-background-neutral-subtle-hovered, #091e4214)",
    'color.background.neutral.subtle.pressed': "var(--ds-background-neutral-subtle-pressed, #B3D4FF)",
    'color.background.neutral.bold': "var(--ds-background-neutral-bold, #42526E)",
    'color.background.neutral.bold.hovered': "var(--ds-background-neutral-bold-hovered, #505F79)",
    'color.background.neutral.bold.pressed': "var(--ds-background-neutral-bold-pressed, #344563)",
    'color.background.selected': "var(--ds-background-selected, #DEEBFF)",
    'color.background.selected.hovered': "var(--ds-background-selected-hovered, #B3D4FF)",
    'color.background.selected.pressed': "var(--ds-background-selected-pressed, #4C9AFF)",
    'color.background.selected.bold': "var(--ds-background-selected-bold, #0052CC)",
    'color.background.selected.bold.hovered': "var(--ds-background-selected-bold-hovered, #2684FF)",
    'color.background.selected.bold.pressed': "var(--ds-background-selected-bold-pressed, #0052CC)",
    'color.background.brand.subtlest': "var(--ds-background-brand-subtlest, #B3D4FF)",
    'color.background.brand.subtlest.hovered': "var(--ds-background-brand-subtlest-hovered, #DEEBFF)",
    'color.background.brand.subtlest.pressed': "var(--ds-background-brand-subtlest-pressed, #4C9AFF)",
    'color.background.brand.bold': "var(--ds-background-brand-bold, #0052CC)",
    'color.background.brand.bold.hovered': "var(--ds-background-brand-bold-hovered, #0065FF)",
    'color.background.brand.bold.pressed': "var(--ds-background-brand-bold-pressed, #0747A6)",
    'color.background.brand.boldest': "var(--ds-background-brand-boldest, #0747A6)",
    'color.background.brand.boldest.hovered': "var(--ds-background-brand-boldest-hovered, #0052CC)",
    'color.background.brand.boldest.pressed': "var(--ds-background-brand-boldest-pressed, #0747A6)",
    'color.background.danger': "var(--ds-background-danger, #FFEBE6)",
    'color.background.danger.hovered': "var(--ds-background-danger-hovered, #FFBDAD)",
    'color.background.danger.pressed': "var(--ds-background-danger-pressed, #FF8F73)",
    'color.background.danger.subtler': "var(--ds-background-danger-subtler, #FFBDAD)",
    'color.background.danger.subtler.hovered': "var(--ds-background-danger-subtler-hovered, #FF8F73)",
    'color.background.danger.subtler.pressed': "var(--ds-background-danger-subtler-pressed, #FF7452)",
    'color.background.danger.bold': "var(--ds-background-danger-bold, #DE350B)",
    'color.background.danger.bold.hovered': "var(--ds-background-danger-bold-hovered, #FF5630)",
    'color.background.danger.bold.pressed': "var(--ds-background-danger-bold-pressed, #BF2600)",
    'color.background.warning': "var(--ds-background-warning, #FFFAE6)",
    'color.background.warning.hovered': "var(--ds-background-warning-hovered, #FFF0B3)",
    'color.background.warning.pressed': "var(--ds-background-warning-pressed, #FFE380)",
    'color.background.warning.subtler': "var(--ds-background-warning-subtler, #FFF0B3)",
    'color.background.warning.subtler.hovered': "var(--ds-background-warning-subtler-hovered, #FFE380)",
    'color.background.warning.subtler.pressed': "var(--ds-background-warning-subtler-pressed, #FFC400)",
    'color.background.warning.bold': "var(--ds-background-warning-bold, #FFAB00)",
    'color.background.warning.bold.hovered': "var(--ds-background-warning-bold-hovered, #FFC400)",
    'color.background.warning.bold.pressed': "var(--ds-background-warning-bold-pressed, #FF991F)",
    'color.background.success': "var(--ds-background-success, #E3FCEF)",
    'color.background.success.hovered': "var(--ds-background-success-hovered, #ABF5D1)",
    'color.background.success.pressed': "var(--ds-background-success-pressed, #79F2C0)",
    'color.background.success.subtler': "var(--ds-background-success-subtler, #ABF5D1)",
    'color.background.success.subtler.hovered': "var(--ds-background-success-subtler-hovered, #79F2C0)",
    'color.background.success.subtler.pressed': "var(--ds-background-success-subtler-pressed, #57D9A3)",
    'color.background.success.bold': "var(--ds-background-success-bold, #00875A)",
    'color.background.success.bold.hovered': "var(--ds-background-success-bold-hovered, #57D9A3)",
    'color.background.success.bold.pressed': "var(--ds-background-success-bold-pressed, #00875A)",
    'color.background.discovery': "var(--ds-background-discovery, #EAE6FF)",
    'color.background.discovery.hovered': "var(--ds-background-discovery-hovered, #C0B6F2)",
    'color.background.discovery.pressed': "var(--ds-background-discovery-pressed, #998DD9)",
    'color.background.discovery.subtler': "var(--ds-background-discovery-subtler, #C0B6F2)",
    'color.background.discovery.subtler.hovered': "var(--ds-background-discovery-subtler-hovered, #998DD9)",
    'color.background.discovery.subtler.pressed': "var(--ds-background-discovery-subtler-pressed, #8777D9)",
    'color.background.discovery.bold': "var(--ds-background-discovery-bold, #5243AA)",
    'color.background.discovery.bold.hovered': "var(--ds-background-discovery-bold-hovered, #8777D9)",
    'color.background.discovery.bold.pressed': "var(--ds-background-discovery-bold-pressed, #5243AA)",
    'color.background.information': "var(--ds-background-information, #DEEBFF)",
    'color.background.information.hovered': "var(--ds-background-information-hovered, #B3D4FF)",
    'color.background.information.pressed': "var(--ds-background-information-pressed, #4C9AFF)",
    'color.background.information.subtler': "var(--ds-background-information-subtler, #B3D4FF)",
    'color.background.information.subtler.hovered': "var(--ds-background-information-subtler-hovered, #4C9AFF)",
    'color.background.information.subtler.pressed': "var(--ds-background-information-subtler-pressed, #2684FF)",
    'color.background.information.bold': "var(--ds-background-information-bold, #0052CC)",
    'color.background.information.bold.hovered': "var(--ds-background-information-bold-hovered, #2684FF)",
    'color.background.information.bold.pressed': "var(--ds-background-information-bold-pressed, #0052CC)",
    'color.blanket': "var(--ds-blanket, #091e4289)",
    'color.blanket.selected': "var(--ds-blanket-selected, #388BFF14)",
    'color.blanket.danger': "var(--ds-blanket-danger, #EF5C4814)",
    'color.skeleton': "var(--ds-skeleton, #F4F5F7)",
    'color.skeleton.subtle': "var(--ds-skeleton-subtle, #091e420a)",
    'elevation.surface': "var(--ds-surface, #FFFFFF)",
    'elevation.surface.hovered': "var(--ds-surface-hovered, #FAFBFC)",
    'elevation.surface.pressed': "var(--ds-surface-pressed, #F4F5F7)",
    'elevation.surface.overlay': "var(--ds-surface-overlay, #FFFFFF)",
    'elevation.surface.overlay.hovered': "var(--ds-surface-overlay-hovered, #FAFBFC)",
    'elevation.surface.overlay.pressed': "var(--ds-surface-overlay-pressed, #F4F5F7)",
    'elevation.surface.raised': "var(--ds-surface-raised, #FFFFFF)",
    'elevation.surface.raised.hovered': "var(--ds-surface-raised-hovered, #FAFBFC)",
    'elevation.surface.raised.pressed': "var(--ds-surface-raised-pressed, #F4F5F7)",
    'elevation.surface.sunken': "var(--ds-surface-sunken, #F4F5F7)",
    'utility.elevation.surface.current': "var(--ds-elevation-surface-current, #FFFFFF)"
};
var $d5e441fb06e0ea7d$export$8473307aa00d6ea1 = {
    'color.text': "var(--ds-text, #172B4D)",
    'color.text.accent.lime': "var(--ds-text-accent-lime, #4C6B1F)",
    'color.text.accent.lime.bolder': "var(--ds-text-accent-lime-bolder, #37471F)",
    'color.text.accent.red': "var(--ds-text-accent-red, #DE350B)",
    'color.text.accent.red.bolder': "var(--ds-text-accent-red-bolder, #BF2600)",
    'color.text.accent.orange': "var(--ds-text-accent-orange, #F18D13)",
    'color.text.accent.orange.bolder': "var(--ds-text-accent-orange-bolder, #B65C02)",
    'color.text.accent.yellow': "var(--ds-text-accent-yellow, #FF991F)",
    'color.text.accent.yellow.bolder': "var(--ds-text-accent-yellow-bolder, #FF8B00)",
    'color.text.accent.green': "var(--ds-text-accent-green, #00875A)",
    'color.text.accent.green.bolder': "var(--ds-text-accent-green-bolder, #006644)",
    'color.text.accent.teal': "var(--ds-text-accent-teal, #00A3BF)",
    'color.text.accent.teal.bolder': "var(--ds-text-accent-teal-bolder, #008DA6)",
    'color.text.accent.blue': "var(--ds-text-accent-blue, #0052CC)",
    'color.text.accent.blue.bolder': "var(--ds-text-accent-blue-bolder, #0747A6)",
    'color.text.accent.purple': "var(--ds-text-accent-purple, #5243AA)",
    'color.text.accent.purple.bolder': "var(--ds-text-accent-purple-bolder, #403294)",
    'color.text.accent.magenta': "var(--ds-text-accent-magenta, #E774BB)",
    'color.text.accent.magenta.bolder': "var(--ds-text-accent-magenta-bolder, #DA62AC)",
    'color.text.accent.gray': "var(--ds-text-accent-gray, #505F79)",
    'color.text.accent.gray.bolder': "var(--ds-text-accent-gray-bolder, #172B4D)",
    'color.text.disabled': "var(--ds-text-disabled, #A5ADBA)",
    'color.text.inverse': "var(--ds-text-inverse, #FFFFFF)",
    'color.text.selected': "var(--ds-text-selected, #0052CC)",
    'color.text.brand': "var(--ds-text-brand, #0065FF)",
    'color.text.danger': "var(--ds-text-danger, #DE350B)",
    'color.text.danger.bolder': "var(--ds-text-danger-bolder, #BF2600)",
    'color.text.warning': "var(--ds-text-warning, #974F0C)",
    'color.text.warning.inverse': "var(--ds-text-warning-inverse, #172B4D)",
    'color.text.warning.bolder': "var(--ds-text-warning-bolder, #974F0C)",
    'color.text.success': "var(--ds-text-success, #006644)",
    'color.text.success.bolder': "var(--ds-text-success-bolder, #006644)",
    'color.text.discovery': "var(--ds-text-discovery, #403294)",
    'color.text.discovery.bolder': "var(--ds-text-discovery-bolder, #403294)",
    'color.text.information': "var(--ds-text-information, #0052CC)",
    'color.text.information.bolder': "var(--ds-text-information-bolder, #0747A6)",
    'color.text.subtlest': "var(--ds-text-subtlest, #7A869A)",
    'color.text.subtle': "var(--ds-text-subtle, #42526E)",
    'color.link': "var(--ds-link, #0052CC)",
    'color.link.pressed': "var(--ds-link-pressed, #0747A6)",
    'color.link.visited': "var(--ds-link-visited, #403294)",
    'color.link.visited.pressed': "var(--ds-link-visited-pressed, #403294)"
};
var $d5e441fb06e0ea7d$export$498780f74be9af68 = {
    'color.icon': "var(--ds-icon, #505F79)",
    'color.icon.accent.lime': "var(--ds-icon-accent-lime, #6A9A23)",
    'color.icon.accent.red': "var(--ds-icon-accent-red, #FF5630)",
    'color.icon.accent.orange': "var(--ds-icon-accent-orange, #D94008)",
    'color.icon.accent.yellow': "var(--ds-icon-accent-yellow, #FFAB00)",
    'color.icon.accent.green': "var(--ds-icon-accent-green, #36B37E)",
    'color.icon.accent.teal': "var(--ds-icon-accent-teal, #00B8D9)",
    'color.icon.accent.blue': "var(--ds-icon-accent-blue, #0065FF)",
    'color.icon.accent.purple': "var(--ds-icon-accent-purple, #6554C0)",
    'color.icon.accent.magenta': "var(--ds-icon-accent-magenta, #CD519D)",
    'color.icon.accent.gray': "var(--ds-icon-accent-gray, #5E6C84)",
    'color.icon.disabled': "var(--ds-icon-disabled, #8993A4)",
    'color.icon.inverse': "var(--ds-icon-inverse, #FFFFFF)",
    'color.icon.selected': "var(--ds-icon-selected, #0052CC)",
    'color.icon.brand': "var(--ds-icon-brand, #0065FF)",
    'color.icon.danger': "var(--ds-icon-danger, #DE350B)",
    'color.icon.warning': "var(--ds-icon-warning, #FFC400)",
    'color.icon.warning.inverse': "var(--ds-icon-warning-inverse, #253858)",
    'color.icon.success': "var(--ds-icon-success, #00875A)",
    'color.icon.discovery': "var(--ds-icon-discovery, #8777D9)",
    'color.icon.information': "var(--ds-icon-information, #0747A6)",
    'color.icon.subtlest': "var(--ds-icon-subtlest, #6B778C)",
    'color.icon.subtle': "var(--ds-icon-subtle, #6B778C)"
};
var $d5e441fb06e0ea7d$export$b5f31a7e431d2eab = {
    '1': 1,
    card: 100,
    navigation: 200,
    dialog: 300,
    layer: 400,
    blanket: 500,
    modal: 510,
    flag: 600,
    spotlight: 700,
    tooltip: 800
};
var $d5e441fb06e0ea7d$export$e1b83c5210c471b8 = {
    'border.width': "var(--ds-border-width, 1px)",
    'border.width.selected': "var(--ds-border-width-selected, 2px)",
    'border.width.focused': "var(--ds-border-width-focused, 2px)"
};
var $d5e441fb06e0ea7d$export$3c0a6c3e64bb180d = {
    'radius.xsmall': "var(--ds-radius-xsmall, 2px)",
    'radius.small': "var(--ds-radius-small, 3px)",
    'radius.medium': "var(--ds-radius-medium, 6px)",
    'radius.large': "var(--ds-radius-large, 8px)",
    'radius.xlarge': "var(--ds-radius-xlarge, 12px)",
    'radius.xxlarge': "var(--ds-radius-xxlarge, 16px)",
    'radius.full': "var(--ds-radius-full, 9999px)",
    'radius.tile': "var(--ds-radius-tile, 25%)"
};
var $d5e441fb06e0ea7d$export$6ffa317d5e70375 = {
    'font.body': "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.body.UNSAFE_small': "var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.body.large': "var(--ds-font-body-large, normal 400 16px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.body.small': "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.code': "var(--ds-font-code, normal 400 0.875em/1 ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)",
    'font.heading.large': "var(--ds-font-heading-large, normal 500 24px/28px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.heading.medium': "var(--ds-font-heading-medium, normal 500 20px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.heading.small': "var(--ds-font-heading-small, normal 600 16px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.heading.xlarge': "var(--ds-font-heading-xlarge, normal 600 29px/32px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.heading.xsmall': "var(--ds-font-heading-xsmall, normal 600 14px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.heading.xxlarge': "var(--ds-font-heading-xxlarge, normal 500 35px/40px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.heading.xxsmall': "var(--ds-font-heading-xxsmall, normal 600 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.metric.large': "var(--ds-font-metric-large, normal 653 28px/32px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.metric.medium': "var(--ds-font-metric-medium, normal 653 24px/28px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.metric.small': "var(--ds-font-metric-small, normal 653 16px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
};
var $d5e441fb06e0ea7d$export$303e322c6b1ed114 = {
    'font.weight.bold': "var(--ds-font-weight-bold, 700)",
    'font.weight.medium': "var(--ds-font-weight-medium, 500)",
    'font.weight.regular': "var(--ds-font-weight-regular, 400)",
    'font.weight.semibold': "var(--ds-font-weight-semibold, 600)"
};
var $d5e441fb06e0ea7d$export$3c7e9587132614b4 = {
    'font.family.body': "var(--ds-font-family-body, ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.family.brand.body': "var(--ds-font-family-brand-body, \"Charlie Text\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.family.brand.heading': "var(--ds-font-family-brand-heading, \"Charlie Display\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.family.code': "var(--ds-font-family-code, ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)",
    'font.family.heading': "var(--ds-font-family-heading, ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
};
var $d5e441fb06e0ea7d$export$236bfe3a33ef1292 = {
    medium: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    UNSAFE_small: "var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    large: "var(--ds-font-body-large, normal 400 16px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    small: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
};
var $d5e441fb06e0ea7d$export$855cfd311192d666 = {
    bold: "var(--ds-font-weight-bold, 700)",
    medium: "var(--ds-font-weight-medium, 500)",
    regular: "var(--ds-font-weight-regular, 400)",
    semibold: "var(--ds-font-weight-semibold, 600)"
};
var $d5e441fb06e0ea7d$export$b805719bc8cb376 = {
    large: "var(--ds-font-metric-large, normal 653 28px/32px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    medium: "var(--ds-font-metric-medium, normal 653 24px/28px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    small: "var(--ds-font-metric-small, normal 653 16px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
};
/**
 * @codegenEnd
 */ // Margin needs some bespoke types: https://atlassian.slack.com/archives/CKRHB23K8/p1712623192772909
// Generate maps for Box props. backgroundColor, padding, etc
var $d5e441fb06e0ea7d$var$spacingProperties = [
    // Used by Box
    'padding',
    'paddingBlock',
    'paddingBlockStart',
    'paddingBlockEnd',
    'paddingInline',
    'paddingInlineStart',
    'paddingInlineEnd',
    // Used by Inline and Stack
    'gap',
    'rowGap',
    'columnGap'
];
var $d5e441fb06e0ea7d$export$ca0f9c2de39ffed7 = function getSerializedStylesMap(cssProperty, tokenMap) {
    return Object.keys(tokenMap).reduce(function(emotionSpacingMap, token) {
        // eslint-disable-next-line @repo/internal/styles/no-exported-styles
        emotionSpacingMap[token] = (0, $74Zh5.css)((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, cssProperty, tokenMap[token]));
        return emotionSpacingMap;
    }, {});
};
var $d5e441fb06e0ea7d$export$e615f061ca585a6c = $d5e441fb06e0ea7d$var$spacingProperties.reduce(function(styleMap, spacingProperty) {
    styleMap[spacingProperty] = $d5e441fb06e0ea7d$export$ca0f9c2de39ffed7(spacingProperty, $d5e441fb06e0ea7d$export$958d0ae7f2977ae4);
    return styleMap;
}, {});
var $d5e441fb06e0ea7d$export$bf46c3f9eeafc71f = $d5e441fb06e0ea7d$var$spacingProperties.reduce(function(styleMap, spacingProperty) {
    styleMap[spacingProperty] = $d5e441fb06e0ea7d$export$ca0f9c2de39ffed7(spacingProperty, $d5e441fb06e0ea7d$export$958d0ae7f2977ae4);
    return styleMap;
}, {});
var $d5e441fb06e0ea7d$export$e7af83bafe7f9e63 = $d5e441fb06e0ea7d$export$ca0f9c2de39ffed7('backgroundColor', $d5e441fb06e0ea7d$export$d1d79bf68ac056bd);
var $d5e441fb06e0ea7d$export$3a1bcba60b23d7f0 = $d5e441fb06e0ea7d$export$ca0f9c2de39ffed7('color', $d5e441fb06e0ea7d$export$8473307aa00d6ea1);
var $d5e441fb06e0ea7d$export$45f3f4fe16f9f7d5 = $d5e441fb06e0ea7d$export$ca0f9c2de39ffed7('fontWeight', $d5e441fb06e0ea7d$export$303e322c6b1ed114);
var $d5e441fb06e0ea7d$export$68cc305da27dbaa4 = $d5e441fb06e0ea7d$export$ca0f9c2de39ffed7('fontFamily', $d5e441fb06e0ea7d$export$3c7e9587132614b4);
var $d5e441fb06e0ea7d$export$128f10c238242f83 = $d5e441fb06e0ea7d$export$ca0f9c2de39ffed7('font', $d5e441fb06e0ea7d$export$6ffa317d5e70375);
var $d5e441fb06e0ea7d$export$219d364c0da35ae4 = $d5e441fb06e0ea7d$export$ca0f9c2de39ffed7('font', $d5e441fb06e0ea7d$export$236bfe3a33ef1292);
var $d5e441fb06e0ea7d$export$38845ca010b93505 = $d5e441fb06e0ea7d$export$ca0f9c2de39ffed7('fontWeight', $d5e441fb06e0ea7d$export$855cfd311192d666);
var $d5e441fb06e0ea7d$export$ff257d957d48c421 = $d5e441fb06e0ea7d$export$ca0f9c2de39ffed7((0, $4bYmA.CURRENT_SURFACE_CSS_VAR), $d5e441fb06e0ea7d$export$41a358c9c2356760);
var $d5e441fb06e0ea7d$export$5e65a44e5b6ecadb = function isSurfaceColorToken(color) {
    return $d5e441fb06e0ea7d$export$41a358c9c2356760[color] !== undefined;
};
var $d5e441fb06e0ea7d$export$7001ce64d9ff7c7f = $d5e441fb06e0ea7d$export$ca0f9c2de39ffed7('font', $d5e441fb06e0ea7d$export$b805719bc8cb376);

});
parcelRegister("4bYmA", function(module, exports) {
$parcel$export(module.exports, "CURRENT_SURFACE_CSS_VAR", () => $30d7036c9fa736d7$export$9d7b58831ae93caa);
var $30d7036c9fa736d7$export$4ef52930e33717cd = 'data-theme';
var $30d7036c9fa736d7$export$a00eac3f8684bcd0 = 'data-color-mode';
var $30d7036c9fa736d7$export$2112803007239c61 = 'data-contrast-mode';
var $30d7036c9fa736d7$export$352e418ed5b6193a = 'data-custom-theme';
var $30d7036c9fa736d7$export$6f0c6fb8c80fcc92 = 'ds';
var $30d7036c9fa736d7$export$4d0c7bbf80185957 = [
    'opacity',
    'font',
    'space',
    'border',
    'radius'
];
var $30d7036c9fa736d7$export$dddac1532e822863 = "--".concat($30d7036c9fa736d7$export$6f0c6fb8c80fcc92, "-token-not-found");
var $30d7036c9fa736d7$export$9d7b58831ae93caa = "--".concat($30d7036c9fa736d7$export$6f0c6fb8c80fcc92, "-elevation-surface-current");

});


parcelRegister("8cni7", function(module, exports) {
$parcel$export(module.exports, "parseXcss", () => $5f8182df1abcde56$export$a9c84988c8f81f2d);
$parcel$export(module.exports, "xcss", () => $5f8182df1abcde56$export$f6c783d06584602c);

var $fC8ib = parcelRequire("fC8ib");

var $25nEq = parcelRequire("25nEq");

var $iYJcE = parcelRequire("iYJcE");

var $ekGgq = parcelRequire("ekGgq");

var $74Zh5 = parcelRequire("74Zh5");

var $imxuh = parcelRequire("imxuh");

var $3ZMUU = parcelRequire("3ZMUU");
function $5f8182df1abcde56$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $5f8182df1abcde56$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $5f8182df1abcde56$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $5f8182df1abcde56$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $5f8182df1abcde56$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $5f8182df1abcde56$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
var $5f8182df1abcde56$export$9a199fbafee0014e = {
    backgroundColor: (0, $imxuh.backgroundColorMap),
    blockSize: (0, $imxuh.dimensionMap),
    borderBlockColor: (0, $imxuh.borderColorMap),
    borderBlockEndColor: (0, $imxuh.borderColorMap),
    borderBlockEndWidth: (0, $imxuh.borderWidthMap),
    borderBlockStartColor: (0, $imxuh.borderColorMap),
    borderBlockStartWidth: (0, $imxuh.borderWidthMap),
    borderBlockWidth: (0, $imxuh.borderWidthMap),
    borderBottomColor: (0, $imxuh.borderColorMap),
    borderBottomLeftRadius: (0, $imxuh.borderRadiusMap),
    borderBottomRightRadius: (0, $imxuh.borderRadiusMap),
    borderBottomWidth: (0, $imxuh.borderWidthMap),
    borderColor: (0, $imxuh.borderColorMap),
    borderEndEndRadius: (0, $imxuh.borderRadiusMap),
    borderEndStartRadius: (0, $imxuh.borderRadiusMap),
    borderInlineColor: (0, $imxuh.borderColorMap),
    borderInlineEndColor: (0, $imxuh.borderColorMap),
    borderInlineEndWidth: (0, $imxuh.borderWidthMap),
    borderInlineStartColor: (0, $imxuh.borderColorMap),
    borderInlineStartWidth: (0, $imxuh.borderWidthMap),
    borderInlineWidth: (0, $imxuh.borderWidthMap),
    borderLeftColor: (0, $imxuh.borderColorMap),
    borderLeftWidth: (0, $imxuh.borderWidthMap),
    borderRadius: (0, $imxuh.borderRadiusMap),
    borderRightColor: (0, $imxuh.borderColorMap),
    borderRightWidth: (0, $imxuh.borderWidthMap),
    borderStartEndRadius: (0, $imxuh.borderRadiusMap),
    borderStartStartRadius: (0, $imxuh.borderRadiusMap),
    borderTopColor: (0, $imxuh.borderColorMap),
    borderTopLeftRadius: (0, $imxuh.borderRadiusMap),
    borderTopRightRadius: (0, $imxuh.borderRadiusMap),
    borderTopWidth: (0, $imxuh.borderWidthMap),
    borderWidth: (0, $imxuh.borderWidthMap),
    bottom: (0, $imxuh.allSpaceMap),
    boxShadow: (0, $imxuh.shadowMap),
    color: (0, $imxuh.textColorMap),
    columnGap: (0, $imxuh.positiveSpaceMap),
    font: (0, $imxuh.fontMap),
    fontFamily: (0, $imxuh.fontFamilyMap),
    fontWeight: (0, $imxuh.fontWeightMap),
    gap: (0, $imxuh.positiveSpaceMap),
    height: (0, $imxuh.dimensionMap),
    inlineSize: (0, $imxuh.dimensionMap),
    inset: (0, $imxuh.allSpaceMap),
    insetBlock: (0, $imxuh.allSpaceMap),
    insetBlockEnd: (0, $imxuh.allSpaceMap),
    insetBlockStart: (0, $imxuh.allSpaceMap),
    insetInline: (0, $imxuh.allSpaceMap),
    insetInlineEnd: (0, $imxuh.allSpaceMap),
    insetInlineStart: (0, $imxuh.allSpaceMap),
    left: (0, $imxuh.allSpaceMap),
    margin: (0, $imxuh.allSpaceMap),
    marginBlock: (0, $imxuh.allSpaceMap),
    marginBlockEnd: (0, $imxuh.allSpaceMap),
    marginBlockStart: (0, $imxuh.allSpaceMap),
    marginBottom: (0, $imxuh.allSpaceMap),
    marginInline: (0, $imxuh.allSpaceMap),
    marginInlineEnd: (0, $imxuh.allSpaceMap),
    marginInlineStart: (0, $imxuh.allSpaceMap),
    marginLeft: (0, $imxuh.allSpaceMap),
    marginRight: (0, $imxuh.allSpaceMap),
    marginTop: (0, $imxuh.allSpaceMap),
    maxBlockSize: (0, $imxuh.dimensionMap),
    maxHeight: (0, $imxuh.dimensionMap),
    maxInlineSize: (0, $imxuh.dimensionMap),
    maxWidth: (0, $imxuh.dimensionMap),
    minBlockSize: (0, $imxuh.dimensionMap),
    minHeight: (0, $imxuh.dimensionMap),
    minInlineSize: (0, $imxuh.dimensionMap),
    minWidth: (0, $imxuh.dimensionMap),
    opacity: (0, $imxuh.opacityMap),
    outlineColor: (0, $imxuh.borderColorMap),
    outlineOffset: (0, $imxuh.allSpaceMap),
    outlineWidth: (0, $imxuh.borderWidthMap),
    padding: (0, $imxuh.positiveSpaceMap),
    paddingBlock: (0, $imxuh.positiveSpaceMap),
    paddingBlockEnd: (0, $imxuh.positiveSpaceMap),
    paddingBlockStart: (0, $imxuh.positiveSpaceMap),
    paddingBottom: (0, $imxuh.positiveSpaceMap),
    paddingInline: (0, $imxuh.positiveSpaceMap),
    paddingInlineEnd: (0, $imxuh.positiveSpaceMap),
    paddingInlineStart: (0, $imxuh.positiveSpaceMap),
    paddingLeft: (0, $imxuh.positiveSpaceMap),
    paddingRight: (0, $imxuh.positiveSpaceMap),
    paddingTop: (0, $imxuh.positiveSpaceMap),
    right: (0, $imxuh.allSpaceMap),
    rowGap: (0, $imxuh.positiveSpaceMap),
    top: (0, $imxuh.allSpaceMap),
    width: (0, $imxuh.dimensionMap),
    zIndex: (0, $imxuh.layerMap)
};
var $5f8182df1abcde56$var$uniqueSymbol = Symbol('UNSAFE_INTERNAL_styles');
var $5f8182df1abcde56$var$isSafeEnvToThrow = function isSafeEnvToThrow() {
    return (typeof $3ZMUU === "undefined" ? "undefined" : (0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))($3ZMUU)) === 'object' && (0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))($3ZMUU.env) === 'object' && false;
};
var $5f8182df1abcde56$var$reNestedSelectors = /(\.|\s|&+|\*\>|#|\[.*\])/;
var $5f8182df1abcde56$var$safeSelectors = /^@media .*$|^::?.*$|^@supports .*$/;
var $5f8182df1abcde56$var$_transformStyles = function transformStyles(styleObj) {
    if (!styleObj || (0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(styleObj) !== 'object') return styleObj;
    // If styles are defined as a CSSObject[], recursively call on each element until we reach CSSObject
    if (Array.isArray(styleObj)) return styleObj.map($5f8182df1abcde56$var$_transformStyles);
    // Modifies styleObj in place. Be careful.
    Object.entries(styleObj).forEach(function(_ref) {
        var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_ref, 2), key = _ref2[0], value = _ref2[1];
        // If key is a pseudo class or a pseudo element, then value should be an object.
        // So, call transformStyles on the value
        if ((0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(value) === 'object' && $5f8182df1abcde56$var$safeSelectors.test(key)) {
            styleObj[key] = $5f8182df1abcde56$var$_transformStyles(value);
            return;
        }
        if ($5f8182df1abcde56$var$isSafeEnvToThrow()) {
            // We don't support `.class`, `[data-testid]`, `> *`, `#some-id`
            if ($5f8182df1abcde56$var$reNestedSelectors.test(key)) throw new Error("Styles not supported for key '".concat(key, "'."));
        }
        // We have now dealt with all the special cases, so,
        // check whether what remains is a style property
        // that can be transformed.
        if (!(key in $5f8182df1abcde56$export$9a199fbafee0014e)) return;
        var tokenValue = $5f8182df1abcde56$export$9a199fbafee0014e[key][value];
        styleObj[key] = tokenValue !== null && tokenValue !== void 0 ? tokenValue : value;
    });
    return styleObj;
};
var $5f8182df1abcde56$var$baseXcss = function baseXcss(style) {
    var transformedStyles = $5f8182df1abcde56$var$_transformStyles(style);
    return (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, $5f8182df1abcde56$var$uniqueSymbol, (0, $74Zh5.css)(transformedStyles));
};
/**
 * Picks out runtime XCSS objects and build-time XCSS strings. This is needed
 * to supported both Emotion and Compiled styles until we've fully migrated
 * to Compiled.
 *
 * @private
 * @deprecated
 */ var $5f8182df1abcde56$export$a9c84988c8f81f2d = function parseXcss(args) {
    if (Array.isArray(args)) {
        var emotion = [];
        var staticArr = [];
        var _iterator = $5f8182df1abcde56$var$_createForOfIteratorHelper(args), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var arg = _step.value;
                var result = $5f8182df1abcde56$export$a9c84988c8f81f2d(arg);
                if (result.emotion) emotion.push.apply(emotion, (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(result.emotion));
                if (result.static) staticArr.push(result.static);
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
        return {
            emotion: emotion,
            static: staticArr.join(' ')
        };
    }
    var objArgs = args;
    var _ref4 = objArgs || {}, styles = _ref4[$5f8182df1abcde56$var$uniqueSymbol];
    if (styles) return {
        emotion: [
            styles
        ]
    };
    if (args) {
        // We use string interpolation here instead of .toString() just
        // in case the resulting object doesn't have the method available.
        var stringifiedArgs = "".concat(args);
        if (stringifiedArgs) return {
            static: stringifiedArgs
        };
    }
    return {};
};
function $5f8182df1abcde56$export$f6c783d06584602c(style) {
    return $5f8182df1abcde56$var$baseXcss(style);
}

});


parcelRegister("83z99", function(module, exports) {
$parcel$export(module.exports, "CloseButton", () => $5dd9ddf25210aa84$export$de65de8213222d10);

var $5FkrB = parcelRequire("5FkrB");

var $5yfDB = parcelRequire("5yfDB");

var $j7gwl = parcelRequire("j7gwl");
var $5dd9ddf25210aa84$export$de65de8213222d10 = function CloseButton(_ref) {
    var label = _ref.label, onBlur = _ref.onBlur, onClick = _ref.onClick, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $5yfDB.default), {
        testId: testId && "".concat(testId, "--close-button"),
        appearance: "subtle",
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($j7gwl))),
        label: label || 'Close Modal',
        onBlur: onBlur,
        onClick: onClick
    });
};

});


parcelRegister("ayzaw", function(module, exports) {
$parcel$export(module.exports, "default", () => $7af85c26c1507548$export$2e2bcd8739ae039);
/* modal-title.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");

var $bwEq0 = parcelRequire("bwEq0");

var $k9qhj = parcelRequire("k9qhj");

var $k8Idm = parcelRequire("k8Idm");
var $7af85c26c1507548$var$iconColor = {
    danger: "var(--ds-icon-danger, #C9372C)",
    warning: "var(--ds-icon-warning, #E06C00)"
};
var $7af85c26c1507548$var$iconStyles = null;
var $7af85c26c1507548$var$titleStyles = null;
var $7af85c26c1507548$var$textStyles = null;
var $7af85c26c1507548$var$truncatedTextStyles = null;
var $7af85c26c1507548$var$TitleIcon = function TitleIcon(_ref) {
    var appearance = _ref.appearance;
    var Icon = appearance === 'danger' ? (0, (/*@__PURE__*/$parcel$interopDefault($bwEq0))) : (0, (/*@__PURE__*/$parcel$interopDefault($k9qhj)));
    return /*#__PURE__*/ $5FkrB.createElement("span", {
        className: (0, $970q7.default)([
            "_16jlidpf _1o9zidpf _i0dl1wug _syaz1kw7 _1wyb1kw7 _zg8l1kw7 _k48p1kw7 _1dyz1kw7 _vwz41kw7"
        ])
    }, /*#__PURE__*/ $5FkrB.createElement(Icon, {
        label: appearance,
        color: $7af85c26c1507548$var$iconColor[appearance],
        spacing: "spacious"
    }));
};
/**
 * __Modal title__
 *
 * A modal title is used to display a title within a modal.
 *
 * - [Examples](https://atlassian.design/components/modal-dialog/examples)
 * - [Code](https://atlassian.design/components/modal-dialog/code)
 * - [Usage](https://atlassian.design/components/modal-dialog/usage)
 */ var $7af85c26c1507548$var$ModalTitle = function ModalTitle(props) {
    var appearance = props.appearance, children = props.children, _props$isMultiline = props.isMultiline, isMultiline = _props$isMultiline === void 0 ? true : _props$isMultiline, userDefinedTestId = props.testId;
    var _useModal = (0, $k8Idm.useModal)(), titleId = _useModal.titleId, modalTestId = _useModal.testId;
    var testId = userDefinedTestId || modalTestId && "".concat(modalTestId, "--title");
    return /*#__PURE__*/ $5FkrB.createElement("h1", {
        "data-testid": testId,
        className: (0, $970q7.default)([
            "_zulpu2gc _11c8lodh _1e0c1txw _1ul9idpf _6rthze3t _1pfhze3t _12l2ze3t _ahbqze3t"
        ])
    }, appearance && /*#__PURE__*/ $5FkrB.createElement($7af85c26c1507548$var$TitleIcon, {
        appearance: appearance
    }), /*#__PURE__*/ $5FkrB.createElement("span", {
        id: titleId,
        "data-testid": testId && "".concat(testId, "-text"),
        className: (0, $970q7.default)([
            "_16jlkb7n _1o9zkb7n _i0dl1wug _1ul9idpf _slp31hna",
            !isMultiline && "_1reo15vq _18m915vq _1bto1l2s _o5721q9c"
        ])
    }, children));
};
var $7af85c26c1507548$export$2e2bcd8739ae039 = $7af85c26c1507548$var$ModalTitle;

});

parcelRegister("lh9Pt", function(module, exports) {
$parcel$export(module.exports, "default", () => $f7d2cf5bbc14db36$export$2e2bcd8739ae039);

var $5FkrB = parcelRequire("5FkrB");

var $9Et5g = parcelRequire("9Et5g");
/**
 * __Modal transition__
 *
 * A modal transition wraps a modal to provide a fluid transition upon opening and closing.
 *
 * - [Examples](https://atlassian.design/components/modal-dialog/examples)
 * - [Code](https://atlassian.design/components/modal-dialog/code)
 * - [Usage](https://atlassian.design/components/modal-dialog/usage)
 */ var $f7d2cf5bbc14db36$var$ModalTransition = function ModalTransition(props) {
    var _props$children;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $9Et5g.default), {
        appear: true
    }, (_props$children = props.children) !== null && _props$children !== void 0 ? _props$children : null);
};
var $f7d2cf5bbc14db36$export$2e2bcd8739ae039 = $f7d2cf5bbc14db36$var$ModalTransition;

});

parcelRegister("eLdEw", function(module, exports) {
$parcel$export(module.exports, "normalizeUrl", () => $abf00b9e405cfc2e$export$6535eb414fa2c8b6);
/**
 * This file has been partially duplicated in packages/editor/adf-schema/src/utils/url.ts
 * Any changes made here should be mirrored there until the duplicate behaviour is resolved
 * Ticket for dedeplication: https://product-fabric.atlassian.net/browse/EDM-7138
 * Ticket for fixing linkification of filename-like urls: https://product-fabric.atlassian.net/browse/EDM-7190
 */ 
var $840z9 = parcelRequire("840z9");
var $abf00b9e405cfc2e$var$linkify = (0, $840z9.default)();
$abf00b9e405cfc2e$var$linkify.add('sourcetree:', 'http:');
$abf00b9e405cfc2e$var$linkify.add('jamfselfservice:', 'http:');
$abf00b9e405cfc2e$var$linkify.add('notes:', 'http:');
var $abf00b9e405cfc2e$var$tlds = "biz|com|edu|gov|net|org|pro|web|xxx|aero|asia|coop|info|museum|name|shop|\u0440\u0444".split('|');
var $abf00b9e405cfc2e$var$tlds2Char = 'a[cdefgilmnoqrtuwxz]|b[abdefghijmnorstvwyz]|c[acdfghiklmnoruvwxyz]|d[ejkmoz]|e[cegrstu]|f[ijkmor]|g[abdefghilmnpqrstuwy]|h[kmnrtu]|i[delmnoqrst]|j[emop]|k[eghimnprwyz]|l[abcikrstuvy]|m[acdeghklmnopqrtuvwxyz]|n[acefgilopruz]|om|p[aefghkmnrtw]|qa|r[eosuw]|s[abcdegijklmnrtuvxyz]|t[cdfghjklmnortvwz]|u[agksyz]|v[aceginu]|w[fs]|y[et]|z[amw]';
$abf00b9e405cfc2e$var$tlds.push($abf00b9e405cfc2e$var$tlds2Char);
$abf00b9e405cfc2e$var$linkify.tlds($abf00b9e405cfc2e$var$tlds, false);
var $abf00b9e405cfc2e$var$whitelistedURLPatterns = [
    /^https?:\/\/[^\s]*$/im,
    /^ftps?:\/\//im,
    /^gopher:\/\//im,
    /^integrity:\/\//im,
    /^file:\/\//im,
    /^smb:\/\//im,
    /^dynamicsnav:\/\//im,
    /^jamfselfservice:\/\/[^\s]*$/im,
    /^\//im,
    /^mailto:/im,
    /^skype:/im,
    /^callto:[^\s]*$/im,
    /^facetime:[^\s]*$/im,
    /^git:/im,
    /^irc6?:/im,
    /^news:/im,
    /^nntp:/im,
    /^feed:/im,
    /^cvs:/im,
    /^svn:/im,
    /^mvn:/im,
    /^ssh:/im,
    /^scp:\/\//im,
    /^sftp:\/\//im,
    /^itms:/im,
    // This is not a valid notes link, but we support this pattern for backwards compatibility
    /^notes:/im,
    /^notes:\/\//im,
    /^hipchat:\/\//im,
    /^sourcetree:/im,
    /^urn:/im,
    /^tel:/im,
    /^xmpp:/im,
    /^telnet:/im,
    /^vnc:/im,
    /^rdp:/im,
    /^whatsapp:/im,
    /^slack:/im,
    /^sips?:/im,
    /^magnet:/im,
    /^foo:/im,
    /^#/im
];
var $abf00b9e405cfc2e$var$normaliseLinkHref = function normaliseLinkHref(url) {
    var match = $abf00b9e405cfc2e$var$getLinkMatch(url);
    return match && match.url || null;
};
var $abf00b9e405cfc2e$var$getLinkMatch = function getLinkMatch(str) {
    if (!str) return null;
    var match = $abf00b9e405cfc2e$var$linkifyMatch(str);
    if (!match.length) match = $abf00b9e405cfc2e$var$linkify.match(str);
    return match && match.length > 0 && match[0].index === 0 && match[0].lastIndex === str.trim().length ? match[0] : null;
};
var $abf00b9e405cfc2e$var$LINK_REGEXP = /(https?|ftp|jamfselfservice|gopher|dynamicsnav|integrity|file|smb):\/\/[^\s]+/;
var $abf00b9e405cfc2e$var$linkifyMatch = function linkifyMatch(text) {
    var matches = [];
    if (!$abf00b9e405cfc2e$var$LINK_REGEXP.test(text)) return matches;
    var startpos = 0;
    var substr;
    while(substr = text.substr(startpos)){
        var link = (substr.match($abf00b9e405cfc2e$var$LINK_REGEXP) || [
            ''
        ])[0];
        if (link) {
            var index = substr.search($abf00b9e405cfc2e$var$LINK_REGEXP);
            var start = index >= 0 ? index + startpos : index;
            var end = start + link.length;
            matches.push({
                index: start,
                lastIndex: end,
                raw: link,
                url: link,
                text: link,
                schema: ''
            });
            startpos += end;
        } else break;
    }
    return matches;
};
var $abf00b9e405cfc2e$export$c9f92f5469372e0f = function isSafeUrl(url) {
    var urlTrimmed = url.trim();
    return $abf00b9e405cfc2e$var$whitelistedURLPatterns.some(function(p) {
        return p.test(urlTrimmed);
    });
};
function $abf00b9e405cfc2e$export$6535eb414fa2c8b6(url) {
    if (!url) return '';
    var urlWithoutNewlines = url.replace(/[\r\n]+/g, '');
    if ($abf00b9e405cfc2e$export$c9f92f5469372e0f(urlWithoutNewlines)) return urlWithoutNewlines.trim();
    return $abf00b9e405cfc2e$var$normaliseLinkHref(urlWithoutNewlines);
}

});

parcelRegister("30Iuw", function(module, exports) {
$parcel$export(module.exports, "traverse", () => $2313e23966bbfa94$export$df3f009e3d155b20);

var $25nEq = parcelRequire("25nEq");
function $2313e23966bbfa94$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $2313e23966bbfa94$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $2313e23966bbfa94$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $2313e23966bbfa94$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $2313e23966bbfa94$export$735cfea22ce30f58(_visitors) {
    return true;
}
function $2313e23966bbfa94$export$df3f009e3d155b20(adf, visitors) {
    if (!$2313e23966bbfa94$export$735cfea22ce30f58(visitors)) throw new Error("Visitors are not valid: \"".concat(Object.keys(visitors).join(', '), "\""));
    return $2313e23966bbfa94$var$traverseNode(adf, {
        node: undefined
    }, visitors, 0, 0);
}
function $2313e23966bbfa94$var$traverseNode(adfNode, parent, visitors, index, depth) {
    var visitor = visitors[adfNode.type] || visitors['any'];
    var newNode = $2313e23966bbfa94$var$_objectSpread({}, adfNode);
    if (visitor) {
        var processedNode = visitor($2313e23966bbfa94$var$_objectSpread({}, newNode), parent, index, depth);
        if (processedNode === false) return false;
        newNode = processedNode || adfNode;
    }
    if (newNode.content) newNode.content = newNode.content.reduce(function(acc, node, idx) {
        if (!node) return acc;
        var processedNode = $2313e23966bbfa94$var$traverseNode(node, {
            node: newNode,
            parent: parent
        }, visitors, idx, depth + 1);
        if (processedNode !== false) acc.push(processedNode);
        return acc;
    }, []);
    return newNode;
}

});

parcelRegister("6TmbT", function(module, exports) {
$parcel$export(module.exports, "expValEqualsNoExposure", () => $504917c3c7aefe17$export$63eebf86443a0a61);

var $kE9E8 = parcelRequire("kE9E8");
function $504917c3c7aefe17$export$63eebf86443a0a61(experimentName, experimentParam, experimentExpectedValue) {
    var experimentDefaultValue = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
    return (0, $kE9E8.expValEqualsInternal)(experimentName, experimentParam, experimentExpectedValue, experimentDefaultValue, false);
}

});

parcelRegister("lknPo", function(module, exports) {
$parcel$export(module.exports, "getMediaClient", () => $f86df2f0f83a1bce$export$c9ecbc1b719fd417);

var $iAHg6 = parcelRequire("iAHg6");
var $f86df2f0f83a1bce$export$f92e83e86b03c398 = new Map();
var $f86df2f0f83a1bce$export$c9ecbc1b719fd417 = function getMediaClient(mediaClientConfig) {
    // The Provider defines mediaClientConfig as required,
    // but integrators may skip it when using Media Card to display external images
    // i.e. a Media Client is not needed.
    // An empty mediaClientConfig object `{}` won't fall into this case,
    // but that case is handled internally by Media Client.
    if (!mediaClientConfig) return new (0, $iAHg6.MediaClient)({
        authProvider: function authProvider() {
            return Promise.resolve({
                clientId: '',
                token: '',
                baseUrl: ''
            });
        }
    });
    var mediaClient = $f86df2f0f83a1bce$export$f92e83e86b03c398.get(mediaClientConfig);
    if (!mediaClient) {
        mediaClient = new (0, $iAHg6.MediaClient)(mediaClientConfig);
        $f86df2f0f83a1bce$export$f92e83e86b03c398.set(mediaClientConfig, mediaClient);
    }
    return mediaClient;
};

});
parcelRegister("iAHg6", function(module, exports) {
$parcel$export(module.exports, "MediaClient", () => $d88d25130167ba40$export$fba8b4ca6d386aec);

var $fL8KA = parcelRequire("fL8KA");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $6HG4S = parcelRequire("6HG4S");

var $fxEK3 = parcelRequire("fxEK3");
parcelRequire("l7fRX");
var $k9W36 = parcelRequire("k9W36");

var $ad5sk = parcelRequire("ad5sk");

var $8aYdd = parcelRequire("8aYdd");

var $hnP8m = parcelRequire("hnP8m");
parcelRequire("b6O22");
var $bhF0L = parcelRequire("bhF0L");

var $d88d25130167ba40$export$fba8b4ca6d386aec = /*#__PURE__*/ function() {
    // mobile upload is lazily loaded
    // Deprecated value introduced for backward compatibility with Context
    function MediaClient(mediaClientConfig) {
        var store = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (0, $bhF0L.mediaStore);
        var mediaApi = arguments.length > 2 ? arguments[2] : undefined;
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, MediaClient);
        this.mediaClientConfig = mediaClientConfig;
        this.store = store;
        this.mediaStore = mediaApi !== null && mediaApi !== void 0 ? mediaApi : new (0, $ad5sk.MediaStore)({
            authProvider: mediaClientConfig.authProvider,
            initialAuth: mediaClientConfig.initialAuth,
            chunkHashAlgorithm: (0, $k9W36.ChunkHashAlgorithm).Sha256,
            authProviderTimeout: mediaClientConfig.authProviderTimeoutMs
        });
        this.config = mediaClientConfig;
        this.file = new (0, $8aYdd.FileFetcherImpl)(this.mediaStore, this.store);
        this.eventEmitter = new (0, $fxEK3.EventEmitter2)();
        this.stargate = new (0, $hnP8m.StargateClient)(mediaClientConfig.stargateBaseUrl);
    }
    /**
   * @internal
   */ return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(MediaClient, [
        {
            key: "__DO_NOT_USE__getMediaStore",
            value: function __DO_NOT_USE__getMediaStore() {
                return this.store;
            }
        },
        {
            key: "getImage",
            value: function getImage(id, params, controller, fetchMaxRes, traceContext) {
                return this.mediaStore.getImage(id, params, controller, fetchMaxRes, traceContext);
            }
        },
        {
            key: "getImageUrl",
            value: function getImageUrl(id, params) {
                return this.mediaStore.getFileImageURL(id, params);
            }
        },
        {
            key: "getImageUrlSync",
            value: function getImageUrlSync(id, params) {
                return this.mediaStore.getFileImageURLSync(id, params);
            }
        },
        {
            key: "getImageMetadata",
            value: function() {
                var _getImageMetadata = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee(id, params) {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee$(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                _context.next = 2;
                                return this.mediaStore.getImageMetadata(id, params);
                            case 2:
                                return _context.abrupt("return", _context.sent.metadata);
                            case 3:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee, this);
                }));
                function getImageMetadata(_x, _x2) {
                    return _getImageMetadata.apply(this, arguments);
                }
                return getImageMetadata;
            }()
        },
        {
            key: "mobileUploadPromise",
            value: function() {
                var _mobileUploadPromise = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee2() {
                    var module;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee2$(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                if (!this.mobileUpload) {
                                    _context2.next = 2;
                                    break;
                                }
                                return _context2.abrupt("return", this.mobileUpload);
                            case 2:
                                _context2.next = 4;
                                return (parcelRequire("12BvN"));
                            case 4:
                                module = _context2.sent;
                                this.mobileUpload = new module.MobileUploadImpl(this.mediaStore, this.store);
                                return _context2.abrupt("return", this.mobileUpload);
                            case 7:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2, this);
                }));
                function mobileUploadPromise() {
                    return _mobileUploadPromise.apply(this, arguments);
                }
                return mobileUploadPromise;
            }()
        },
        {
            key: "removeFileFromCollection",
            value: function() {
                var _removeFileFromCollection = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee3(id, collectionName, occurrenceKey, traceContext) {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee3$(_context3) {
                        while(true)switch(_context3.prev = _context3.next){
                            case 0:
                                _context3.next = 2;
                                return this.mediaStore.removeCollectionFile(id, collectionName, occurrenceKey, traceContext);
                            case 2:
                            case "end":
                                return _context3.stop();
                        }
                    }, _callee3, this);
                }));
                function removeFileFromCollection(_x3, _x4, _x5, _x6) {
                    return _removeFileFromCollection.apply(this, arguments);
                }
                return removeFileFromCollection;
            }()
        },
        {
            key: "on",
            value: function on(event, listener) {
                this.eventEmitter.on(event, listener);
            }
        },
        {
            key: "off",
            value: function off(event, listener) {
                this.eventEmitter.off(event, listener);
            }
        },
        {
            key: "emit",
            value: function emit(event, payload) {
                return this.eventEmitter.emit(event, payload);
            }
        }
    ]);
}();

});
parcelRegister("l7fRX", function(module, exports) {
$parcel$export(module.exports, "mediaState", () => (parcelRequire("k5fWJ")).mediaState);
$parcel$export(module.exports, "isClientBasedAuth", () => (parcelRequire("pDaXe")).isClientBasedAuth);
$parcel$export(module.exports, "authToOwner", () => (parcelRequire("pDaXe")).authToOwner);
$parcel$export(module.exports, "ChunkHashAlgorithm", () => (parcelRequire("k9W36")).ChunkHashAlgorithm);
// WARNING! DO NOTE MOVE THIS EXPORT!
// mediaState should be exported BEFORE StreamsCache import later because
// StreamsCache will try to import mediaState from here.

var $k5fWJ = parcelRequire("k5fWJ");

var $pDaXe = parcelRequire("pDaXe");

var $k9W36 = parcelRequire("k9W36");

});
parcelRegister("k5fWJ", function(module, exports) {
$parcel$export(module.exports, "mediaState", () => $e9f0a4dca062f6d2$export$8cef61637918b288);

var $fxEK3 = parcelRequire("fxEK3");

var $eqZL4 = parcelRequire("eqZL4");
var $e9f0a4dca062f6d2$export$8cef61637918b288 = {
    streams: new (0, $eqZL4.LRUMap)(1000),
    stateDeferreds: new Map(),
    eventEmitter: new (0, $fxEK3.EventEmitter2)()
};

});
parcelRegister("eqZL4", function(module, exports) {
!function(g, c) {
    c(module.exports);
}(module.exports, function(g) {
    const c = Symbol("newer"), e = Symbol("older");
    class n {
        constructor(a, b){
            typeof a !== "number" && (b = a, a = 0), this.size = 0, this.limit = a, this.oldest = this.newest = void 0, this._keymap = new Map(), b && (this.assign(b), a < 1 && (this.limit = this.size));
        }
        _markEntryAsUsed(a) {
            if (a === this.newest) return;
            a[c] && (a === this.oldest && (this.oldest = a[c]), a[c][e] = a[e]), a[e] && (a[e][c] = a[c]), a[c] = void 0, a[e] = this.newest, this.newest && (this.newest[c] = a), this.newest = a;
        }
        assign(a) {
            let b, d = this.limit || Number.MAX_VALUE;
            this._keymap.clear();
            let m = a[Symbol.iterator]();
            for(let h = m.next(); !h.done; h = m.next()){
                let f = new l(h.value[0], h.value[1]);
                this._keymap.set(f.key, f), b ? (b[c] = f, f[e] = b) : this.oldest = f, b = f;
                if (d-- == 0) throw new Error("overflow");
            }
            this.newest = b, this.size = this._keymap.size;
        }
        get(a) {
            var b = this._keymap.get(a);
            return b ? (this._markEntryAsUsed(b), b.value) : void 0;
        }
        set(a, b) {
            var d = this._keymap.get(a);
            return d ? (d.value = b, this._markEntryAsUsed(d), this) : (this._keymap.set(a, d = new l(a, b)), this.newest ? (this.newest[c] = d, d[e] = this.newest) : this.oldest = d, this.newest = d, ++this.size, this.size > this.limit && this.shift(), this);
        }
        shift() {
            var a = this.oldest;
            if (a) return this.oldest[c] ? (this.oldest = this.oldest[c], this.oldest[e] = void 0) : (this.oldest = void 0, this.newest = void 0), a[c] = a[e] = void 0, this._keymap.delete(a.key), --this.size, [
                a.key,
                a.value
            ];
        }
        find(a) {
            let b = this._keymap.get(a);
            return b ? b.value : void 0;
        }
        has(a) {
            return this._keymap.has(a);
        }
        delete(a) {
            var b = this._keymap.get(a);
            return b ? (this._keymap.delete(b.key), b[c] && b[e] ? (b[e][c] = b[c], b[c][e] = b[e]) : b[c] ? (b[c][e] = void 0, this.oldest = b[c]) : b[e] ? (b[e][c] = void 0, this.newest = b[e]) : this.oldest = this.newest = void 0, this.size--, b.value) : void 0;
        }
        clear() {
            this.oldest = this.newest = void 0, this.size = 0, this._keymap.clear();
        }
        keys() {
            return new j(this.oldest);
        }
        values() {
            return new k(this.oldest);
        }
        entries() {
            return this;
        }
        [Symbol.iterator]() {
            return new i(this.oldest);
        }
        forEach(a, b) {
            typeof b !== "object" && (b = this);
            let d = this.oldest;
            for(; d;)a.call(b, d.value, d.key, this), d = d[c];
        }
        toJSON() {
            for(var a = new Array(this.size), b = 0, d = this.oldest; d;)a[b++] = {
                key: d.key,
                value: d.value
            }, d = d[c];
            return a;
        }
        toString() {
            for(var a = "", b = this.oldest; b;)a += String(b.key) + ":" + b.value, b = b[c], b && (a += " < ");
            return a;
        }
    }
    g.LRUMap = n;
    function l(a, b) {
        this.key = a, this.value = b, this[c] = void 0, this[e] = void 0;
    }
    function i(a) {
        this.entry = a;
    }
    i.prototype[Symbol.iterator] = function() {
        return this;
    }, i.prototype.next = function() {
        let a = this.entry;
        return a ? (this.entry = a[c], {
            done: !1,
            value: [
                a.key,
                a.value
            ]
        }) : {
            done: !0,
            value: void 0
        };
    };
    function j(a) {
        this.entry = a;
    }
    j.prototype[Symbol.iterator] = function() {
        return this;
    }, j.prototype.next = function() {
        let a = this.entry;
        return a ? (this.entry = a[c], {
            done: !1,
            value: a.key
        }) : {
            done: !0,
            value: void 0
        };
    };
    function k(a) {
        this.entry = a;
    }
    k.prototype[Symbol.iterator] = function() {
        return this;
    }, k.prototype.next = function() {
        let a = this.entry;
        return a ? (this.entry = a[c], {
            done: !1,
            value: a.value
        }) : {
            done: !0,
            value: void 0
        };
    };
});

});


parcelRegister("pDaXe", function(module, exports) {
$parcel$export(module.exports, "isClientBasedAuth", () => $04d0b963965d3335$export$6ba49fcac9c46e54);
$parcel$export(module.exports, "authToOwner", () => $04d0b963965d3335$export$17f6055767a8d96a);
function $04d0b963965d3335$export$6ba49fcac9c46e54(auth) {
    return !!auth.clientId;
}
function $04d0b963965d3335$export$af1ab14f2246ef72(auth) {
    return !!auth.asapIssuer;
}
var $04d0b963965d3335$export$17f6055767a8d96a = function authToOwner(auth) {
    if ($04d0b963965d3335$export$af1ab14f2246ef72(auth)) return auth;
    var clientAuth = {
        id: auth.clientId,
        baseUrl: auth.baseUrl,
        token: auth.token
    };
    return clientAuth;
};

});

parcelRegister("k9W36", function(module, exports) {
$parcel$export(module.exports, "ChunkHashAlgorithm", () => $ead1ad433ee1ff44$export$d3e73a50cc549c2e);
var $ead1ad433ee1ff44$export$d3e73a50cc549c2e = /*#__PURE__*/ function(ChunkHashAlgorithm) {
    ChunkHashAlgorithm["Sha256"] = "sha256";
    return ChunkHashAlgorithm;
}({});

});


parcelRegister("ad5sk", function(module, exports) {
$parcel$export(module.exports, "MediaStore", () => $76ef59ba7bd830a6$export$572b8a2a9fd7cbba);
$parcel$export(module.exports, "getMediaEnvironment", () => $76ef59ba7bd830a6$export$c8b741e18397852a);
$parcel$export(module.exports, "getMediaRegion", () => $76ef59ba7bd830a6$export$20f9315304dd6726);

var $fL8KA = parcelRequire("fL8KA");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $25nEq = parcelRequire("25nEq");

var $6HG4S = parcelRequire("6HG4S");
parcelRequire("l7fRX");
var $k9W36 = parcelRequire("k9W36");
var $pDaXe = parcelRequire("pDaXe");

var $cSavz = parcelRequire("cSavz");

var $lGGRS = parcelRequire("lGGRS");

var $7pWqR = parcelRequire("7pWqR");
var $4s8uz = parcelRequire("4s8uz");

var $5cK21 = parcelRequire("5cK21");

var $lHlAm = parcelRequire("lHlAm");

var $evRBH = parcelRequire("evRBH");

var $caJ08 = parcelRequire("caJ08");
function $76ef59ba7bd830a6$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $76ef59ba7bd830a6$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $76ef59ba7bd830a6$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $76ef59ba7bd830a6$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $76ef59ba7bd830a6$var$MEDIA_API_REGION = 'media-api-region';
var $76ef59ba7bd830a6$var$MEDIA_API_ENVIRONMENT = 'media-api-environment';
var $76ef59ba7bd830a6$var$extendImageParams = function extendImageParams(params) {
    var _params$maxAge, _params$allowAnimated, _params$mode;
    var fetchMaxRes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    return $76ef59ba7bd830a6$var$_objectSpread($76ef59ba7bd830a6$var$_objectSpread({}, params), {}, {
        'max-age': (_params$maxAge = params === null || params === void 0 ? void 0 : params['max-age']) !== null && _params$maxAge !== void 0 ? _params$maxAge : (0, $cSavz.FILE_CACHE_MAX_AGE),
        allowAnimated: (_params$allowAnimated = params === null || params === void 0 ? void 0 : params.allowAnimated) !== null && _params$allowAnimated !== void 0 ? _params$allowAnimated : true,
        mode: (_params$mode = params === null || params === void 0 ? void 0 : params.mode) !== null && _params$mode !== void 0 ? _params$mode : 'crop'
    }, fetchMaxRes ? {
        width: (0, $cSavz.MAX_RESOLUTION),
        height: (0, $cSavz.MAX_RESOLUTION)
    } : {});
};
var $76ef59ba7bd830a6$var$jsonHeaders = {
    Accept: 'application/json',
    'Content-Type': 'application/json'
};
var $76ef59ba7bd830a6$var$cdnFeatureFlag = function cdnFeatureFlag(endpoint) {
    var result = endpoint;
    if ((0, $lHlAm.isCDNEnabled)()) result += '/cdn';
    return result;
};
var $76ef59ba7bd830a6$export$572b8a2a9fd7cbba = /*#__PURE__*/ function() {
    function MediaStore(config) {
        var _this = this;
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, MediaStore);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "getArtifactBinary", /*#__PURE__*/ function() {
            var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee(artifacts, artifactName, _ref) {
                var collectionName, abortController, _ref$maxAge, maxAge, traceContext, metadata, extendedTraceContext, options, artifactUrl;
                return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee$(_context) {
                    while(true)switch(_context.prev = _context.next){
                        case 0:
                            collectionName = _ref.collectionName, abortController = _ref.abortController, _ref$maxAge = _ref.maxAge, maxAge = _ref$maxAge === void 0 ? (0, $cSavz.FILE_CACHE_MAX_AGE) : _ref$maxAge, traceContext = _ref.traceContext;
                            metadata = {
                                method: 'GET',
                                endpoint: "artifact-cdn-url"
                            };
                            extendedTraceContext = (0, $5cK21.extendTraceContext)(traceContext);
                            options = $76ef59ba7bd830a6$var$_objectSpread($76ef59ba7bd830a6$var$_objectSpread({}, metadata), {}, {
                                traceContext: extendedTraceContext
                            });
                            _context.next = 6;
                            return _this.getArtifactURL(artifacts, artifactName, collectionName, maxAge);
                        case 6:
                            artifactUrl = _context.sent;
                            return _context.abrupt("return", (0, $4s8uz.request)(artifactUrl, options, abortController).then((0, $5cK21.createMapResponseToBlob)(metadata)));
                        case 8:
                        case "end":
                            return _context.stop();
                    }
                }, _callee);
            }));
            return function(_x, _x2, _x3) {
                return _ref2.apply(this, arguments);
            };
        }());
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "uploadArtifact", /*#__PURE__*/ function() {
            var _ref3 = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee2(id, file, params, collectionName, traceContext) {
                var metadata, headers, extendedParams, authContext, options;
                return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee2$(_context2) {
                    while(true)switch(_context2.prev = _context2.next){
                        case 0:
                            metadata = {
                                method: 'POST',
                                endpoint: '/file/{fileId}/artifact/binary'
                            };
                            headers = {
                                Accept: 'application/json',
                                'Content-Type': file.type
                            };
                            extendedParams = $76ef59ba7bd830a6$var$_objectSpread($76ef59ba7bd830a6$var$_objectSpread({}, params), {}, {
                                name: file.name,
                                collection: collectionName
                            });
                            authContext = {
                                collectionName: collectionName,
                                access: [
                                    {
                                        type: 'file',
                                        id: id,
                                        actions: [
                                            'update'
                                        ]
                                    }
                                ]
                            };
                            options = $76ef59ba7bd830a6$var$_objectSpread($76ef59ba7bd830a6$var$_objectSpread({}, metadata), {}, {
                                authContext: authContext,
                                headers: headers,
                                params: extendedParams,
                                body: file,
                                traceContext: traceContext
                            });
                            return _context2.abrupt("return", _this.request("/file/".concat(id, "/artifact/binary"), options).then((0, $5cK21.createMapResponseToJson)(metadata)));
                        case 6:
                        case "end":
                            return _context2.stop();
                    }
                }, _callee2);
            }));
            return function(_x4, _x5, _x6, _x7, _x8) {
                return _ref3.apply(this, arguments);
            };
        }());
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "deleteArtifact", /*#__PURE__*/ function() {
            var _ref4 = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee3(id, artifactName, collectionName, traceContext) {
                var metadata, authContext, options;
                return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee3$(_context3) {
                    while(true)switch(_context3.prev = _context3.next){
                        case 0:
                            metadata = {
                                method: 'DELETE',
                                endpoint: '/file/{fileId}/artifact/{artifactName}'
                            };
                            authContext = {
                                collectionName: collectionName,
                                access: [
                                    {
                                        type: 'file',
                                        id: id,
                                        actions: [
                                            'update'
                                        ]
                                    }
                                ]
                            };
                            options = $76ef59ba7bd830a6$var$_objectSpread($76ef59ba7bd830a6$var$_objectSpread({}, metadata), {}, {
                                authContext: authContext,
                                traceContext: traceContext,
                                params: {
                                    collection: collectionName
                                }
                            });
                            _context3.next = 5;
                            return _this.request("/file/".concat(id, "/artifact/").concat(artifactName), options);
                        case 5:
                        case "end":
                            return _context3.stop();
                    }
                }, _callee3);
            }));
            return function(_x9, _x0, _x1, _x10) {
                return _ref4.apply(this, arguments);
            };
        }());
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "resolveAuth", function(authContext) {
            return (0, $evRBH.resolveAuth)(_this.config.authProvider, authContext, _this.config.authProviderTimeout);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "resolveInitialAuth", function() {
            return (0, $evRBH.resolveInitialAuth)(_this.config.initialAuth);
        });
        this.config = config;
        this._chunkHashAlgorithm = config.chunkHashAlgorithm || (0, $k9W36.ChunkHashAlgorithm).Sha256;
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(MediaStore, [
        {
            key: "removeCollectionFile",
            value: function() {
                var _removeCollectionFile = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee4(id, collectionName, occurrenceKey, traceContext) {
                    var metadata, body, options;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee4$(_context4) {
                        while(true)switch(_context4.prev = _context4.next){
                            case 0:
                                metadata = {
                                    method: 'PUT',
                                    endpoint: '/collection/{collectionName}'
                                };
                                body = {
                                    actions: [
                                        {
                                            action: 'remove',
                                            item: {
                                                type: 'file',
                                                id: id,
                                                occurrenceKey: occurrenceKey
                                            }
                                        }
                                    ]
                                };
                                options = $76ef59ba7bd830a6$var$_objectSpread($76ef59ba7bd830a6$var$_objectSpread({}, metadata), {}, {
                                    authContext: {
                                        collectionName: collectionName
                                    },
                                    headers: {
                                        Accept: 'application/json',
                                        'Content-Type': 'application/json'
                                    },
                                    body: JSON.stringify(body),
                                    traceContext: traceContext
                                });
                                _context4.next = 5;
                                return this.request("/collection/".concat(collectionName), options);
                            case 5:
                            case "end":
                                return _context4.stop();
                        }
                    }, _callee4, this);
                }));
                function removeCollectionFile(_x11, _x12, _x13, _x14) {
                    return _removeCollectionFile.apply(this, arguments);
                }
                return removeCollectionFile;
            }()
        },
        {
            key: "createUpload",
            value: function createUpload() {
                var createUpTo = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
                var collectionName = arguments.length > 1 ? arguments[1] : undefined;
                var traceContext = arguments.length > 2 ? arguments[2] : undefined;
                var metadata = {
                    method: 'POST',
                    endpoint: '/upload'
                };
                var options = $76ef59ba7bd830a6$var$_objectSpread($76ef59ba7bd830a6$var$_objectSpread({}, metadata), {}, {
                    authContext: {
                        collectionName: collectionName
                    },
                    params: {
                        createUpTo: createUpTo,
                        hashAlgorithm: this._chunkHashAlgorithm
                    },
                    headers: {
                        Accept: 'application/json'
                    },
                    traceContext: traceContext
                });
                return this.request("/upload", options).then((0, $5cK21.createMapResponseToJson)(metadata));
            }
        },
        {
            key: "uploadChunk",
            value: function() {
                var _uploadChunk = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee5(etag, blob, uploadId, partNumber, collectionName, traceContext) {
                    var metadata, options;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee5$(_context5) {
                        while(true)switch(_context5.prev = _context5.next){
                            case 0:
                                metadata = {
                                    method: 'PUT',
                                    endpoint: '/chunk/{etag}'
                                };
                                options = $76ef59ba7bd830a6$var$_objectSpread($76ef59ba7bd830a6$var$_objectSpread({}, metadata), {}, {
                                    params: {
                                        uploadId: uploadId,
                                        partNumber: partNumber
                                    },
                                    authContext: {
                                        collectionName: collectionName
                                    },
                                    body: blob,
                                    traceContext: traceContext
                                });
                                _context5.next = 4;
                                return this.request("/chunk/".concat(etag), options);
                            case 4:
                            case "end":
                                return _context5.stop();
                        }
                    }, _callee5, this);
                }));
                function uploadChunk(_x15, _x16, _x17, _x18, _x19, _x20) {
                    return _uploadChunk.apply(this, arguments);
                }
                return uploadChunk;
            }()
        },
        {
            key: "createFileFromUpload",
            value: function createFileFromUpload(body) {
                var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var traceContext = arguments.length > 2 ? arguments[2] : undefined;
                var metadata = {
                    method: 'POST',
                    endpoint: '/file/upload'
                };
                var options = $76ef59ba7bd830a6$var$_objectSpread($76ef59ba7bd830a6$var$_objectSpread({}, metadata), {}, {
                    authContext: {
                        collectionName: params.collection
                    },
                    params: params,
                    headers: $76ef59ba7bd830a6$var$jsonHeaders,
                    body: JSON.stringify(body),
                    traceContext: traceContext
                });
                return this.request('/file/upload', options).then((0, $5cK21.createMapResponseToJson)(metadata));
            }
        },
        {
            key: "getRejectedResponseFromDescriptor",
            value: function getRejectedResponseFromDescriptor(descriptor, limit) {
                return {
                    fileId: descriptor.fileId,
                    error: {
                        code: 'ExceedMaxFileSizeLimit',
                        title: 'The expected file size exceeded the maximum size limit.',
                        href: 'https://dt-api-filestore--app.ap-southeast-2.dev.atl-paas.net/api.html#BadRequest',
                        limit: limit,
                        size: descriptor.size
                    }
                };
            }
        },
        {
            key: "touchFiles",
            value: function() {
                var _touchFiles = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee6(body) {
                    var params, traceContext, metadata, options, _args6 = arguments;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee6$(_context6) {
                        while(true)switch(_context6.prev = _context6.next){
                            case 0:
                                params = _args6.length > 1 && _args6[1] !== undefined ? _args6[1] : {};
                                traceContext = _args6.length > 2 ? _args6[2] : undefined;
                                metadata = {
                                    method: 'POST',
                                    endpoint: '/upload/createWithFiles'
                                };
                                options = $76ef59ba7bd830a6$var$_objectSpread($76ef59ba7bd830a6$var$_objectSpread({}, metadata), {}, {
                                    authContext: {
                                        collectionName: params.collection
                                    },
                                    headers: $76ef59ba7bd830a6$var$jsonHeaders,
                                    body: JSON.stringify(body),
                                    traceContext: traceContext,
                                    params: {
                                        hashAlgorithm: this._chunkHashAlgorithm
                                    }
                                });
                                return _context6.abrupt("return", this.request('/upload/createWithFiles', options).then((0, $5cK21.createMapResponseToJson)(metadata)));
                            case 5:
                            case "end":
                                return _context6.stop();
                        }
                    }, _callee6, this);
                }));
                function touchFiles(_x21) {
                    return _touchFiles.apply(this, arguments);
                }
                return touchFiles;
            }()
        },
        {
            key: "getFile",
            value: function getFile(fileId) {
                var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var traceContext = arguments.length > 2 ? arguments[2] : undefined;
                var metadata = {
                    method: 'GET',
                    endpoint: '/file/{fileId}'
                };
                var options = $76ef59ba7bd830a6$var$_objectSpread($76ef59ba7bd830a6$var$_objectSpread({}, metadata), {}, {
                    authContext: {
                        collectionName: params.collection
                    },
                    params: params,
                    traceContext: traceContext
                });
                return this.request("/file/".concat(fileId), options).then((0, $5cK21.createMapResponseToJson)(metadata));
            }
        },
        {
            key: "getFileImageURL",
            value: function() {
                var _getFileImageURL = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee7(id, params) {
                    var _ref5, collectionName, auth;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee7$(_context7) {
                        while(true)switch(_context7.prev = _context7.next){
                            case 0:
                                _ref5 = params || {}, collectionName = _ref5.collection;
                                _context7.next = 3;
                                return this.resolveAuth({
                                    collectionName: collectionName
                                });
                            case 3:
                                auth = _context7.sent;
                                return _context7.abrupt("return", this.createFileImageURL(id, auth, params));
                            case 5:
                            case "end":
                                return _context7.stop();
                        }
                    }, _callee7, this);
                }));
                function getFileImageURL(_x22, _x23) {
                    return _getFileImageURL.apply(this, arguments);
                }
                return getFileImageURL;
            }() // TODO Create ticket in case Trace Id can be supported through query params
        },
        {
            key: "getFileImageURLSync",
            value: function getFileImageURLSync(id, params) {
                var auth = this.resolveInitialAuth();
                return this.createFileImageURL(id, auth, params);
            }
        },
        {
            key: "createFileImageURL",
            value: function createFileImageURL(id, auth, params) {
                var options = {
                    params: $76ef59ba7bd830a6$var$extendImageParams(params),
                    auth: auth
                };
                var imageEndpoint = $76ef59ba7bd830a6$var$cdnFeatureFlag('image');
                if ((0, $caJ08.isPathBasedEnabled)()) return (0, $caJ08.mapToPathBasedUrl)((0, $5cK21.createUrl)("".concat(auth.baseUrl, "/file/").concat(id, "/").concat(imageEndpoint), options));
                return (0, $lHlAm.mapToMediaCdnUrl)((0, $5cK21.createUrl)("".concat(auth.baseUrl, "/file/").concat(id, "/").concat(imageEndpoint), options), auth.token);
            }
        },
        {
            key: "getFileBinary",
            value: function() {
                var _getFileBinary = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee8(id, collectionName, abortController) {
                    var maxAge, headers, binaryEndpoint, metadata, options, _args8 = arguments;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee8$(_context8) {
                        while(true)switch(_context8.prev = _context8.next){
                            case 0:
                                maxAge = _args8.length > 3 && _args8[3] !== undefined ? _args8[3] : (0, $cSavz.FILE_CACHE_MAX_AGE);
                                headers = {};
                                binaryEndpoint = $76ef59ba7bd830a6$var$cdnFeatureFlag('binary');
                                metadata = {
                                    method: 'GET',
                                    endpoint: "/file/{fileId}/".concat(binaryEndpoint)
                                };
                                options = $76ef59ba7bd830a6$var$_objectSpread($76ef59ba7bd830a6$var$_objectSpread({}, metadata), {}, {
                                    authContext: {
                                        collectionName: collectionName
                                    },
                                    headers: headers,
                                    params: {
                                        collection: collectionName,
                                        'max-age': "".concat(maxAge)
                                    }
                                });
                                return _context8.abrupt("return", this.request("/file/".concat(id, "/").concat(binaryEndpoint), options, abortController, true).then((0, $5cK21.createMapResponseToBlob)(metadata)));
                            case 6:
                            case "end":
                                return _context8.stop();
                        }
                    }, _callee8, this);
                }));
                function getFileBinary(_x24, _x25, _x26) {
                    return _getFileBinary.apply(this, arguments);
                }
                return getFileBinary;
            }()
        },
        {
            key: "getFileBinaryURL",
            value: function() {
                var _getFileBinaryURL = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee9(id, collectionName) {
                    var maxAge, auth, options, binaryEndpoint, _args9 = arguments;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee9$(_context9) {
                        while(true)switch(_context9.prev = _context9.next){
                            case 0:
                                maxAge = _args9.length > 2 && _args9[2] !== undefined ? _args9[2] : (0, $cSavz.FILE_CACHE_MAX_AGE);
                                _context9.next = 3;
                                return this.resolveAuth({
                                    collectionName: collectionName
                                });
                            case 3:
                                auth = _context9.sent;
                                options = {
                                    params: {
                                        dl: true,
                                        collection: collectionName,
                                        'max-age': maxAge
                                    },
                                    auth: auth
                                };
                                binaryEndpoint = $76ef59ba7bd830a6$var$cdnFeatureFlag('binary');
                                if (!(0, $caJ08.isPathBasedEnabled)()) {
                                    _context9.next = 8;
                                    break;
                                }
                                return _context9.abrupt("return", (0, $caJ08.mapToPathBasedUrl)((0, $5cK21.createUrl)("".concat(auth.baseUrl, "/file/").concat(id, "/").concat(binaryEndpoint), options)));
                            case 8:
                                return _context9.abrupt("return", (0, $lHlAm.mapToMediaCdnUrl)((0, $5cK21.createUrl)("".concat(auth.baseUrl, "/file/").concat(id, "/").concat(binaryEndpoint), options), auth.token));
                            case 9:
                            case "end":
                                return _context9.stop();
                        }
                    }, _callee9, this);
                }));
                function getFileBinaryURL(_x27, _x28) {
                    return _getFileBinaryURL.apply(this, arguments);
                }
                return getFileBinaryURL;
            }()
        },
        {
            key: "getArtifactURL",
            value: function() {
                var _getArtifactURL = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee0(artifacts, artifactName, collectionName) {
                    var maxAge, artifactUrl, auth, options, url, _args0 = arguments;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee0$(_context0) {
                        while(true)switch(_context0.prev = _context0.next){
                            case 0:
                                maxAge = _args0.length > 3 && _args0[3] !== undefined ? _args0[3] : (0, $cSavz.FILE_CACHE_MAX_AGE);
                                // ----- WARNING ----------
                                // DO NOT USE!!!!!
                                // artifact.cdnUrl fails in Jira.
                                // ----------------------------------
                                // getArtifactURL returns a constructed url PATH, not the full Media/CDN Url.
                                // We use the provided cdnUrl from metadata first.
                                /* if (isCommercial() && fg('platform_media_cdn_delivery')) {
              	const cdnUrl = artifacts[artifactName]?.cdnUrl;
              	if (cdnUrl) {
              		return cdnUrl;
              	}
              } */ artifactUrl = (0, $lGGRS.getArtifactUrl)(artifacts, artifactName);
                                if (artifactUrl) {
                                    _context0.next = 4;
                                    break;
                                }
                                throw new Error("artifact ".concat(artifactName, " not found"));
                            case 4:
                                _context0.next = 6;
                                return this.resolveAuth({
                                    collectionName: collectionName
                                });
                            case 6:
                                auth = _context0.sent;
                                options = {
                                    params: {
                                        collection: collectionName,
                                        'max-age': maxAge
                                    },
                                    auth: auth
                                };
                                url = (0, $lHlAm.mapToMediaCdnUrl)((0, $5cK21.createUrl)("".concat(auth.baseUrl).concat(artifactUrl), options), auth.token);
                                if (!(0, $caJ08.isPathBasedEnabled)()) {
                                    _context0.next = 11;
                                    break;
                                }
                                return _context0.abrupt("return", (0, $caJ08.mapToPathBasedUrl)(url));
                            case 11:
                                return _context0.abrupt("return", url);
                            case 12:
                            case "end":
                                return _context0.stop();
                        }
                    }, _callee0, this);
                }));
                function getArtifactURL(_x29, _x30, _x31) {
                    return _getArtifactURL.apply(this, arguments);
                }
                return getArtifactURL;
            }()
        },
        {
            key: "getImage",
            value: function() {
                var _getImage = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee1(id, params, controller, fetchMaxRes, traceContext) {
                    var isWebpSupported, headers, imageEndpoint, metadata, options;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee1$(_context1) {
                        while(true)switch(_context1.prev = _context1.next){
                            case 0:
                                // TODO add checkWebpSupport() back https://product-fabric.atlassian.net/browse/MPT-584
                                isWebpSupported = false;
                                headers = {};
                                if (isWebpSupported) headers.accept = 'image/webp,image/*,*/*;q=0.8';
                                imageEndpoint = $76ef59ba7bd830a6$var$cdnFeatureFlag('image');
                                metadata = {
                                    method: 'GET',
                                    endpoint: "/file/{fileId}/".concat(imageEndpoint)
                                };
                                options = $76ef59ba7bd830a6$var$_objectSpread($76ef59ba7bd830a6$var$_objectSpread({}, metadata), {}, {
                                    authContext: {
                                        collectionName: params && params.collection
                                    },
                                    params: $76ef59ba7bd830a6$var$extendImageParams(params, fetchMaxRes),
                                    headers: headers,
                                    traceContext: traceContext,
                                    addMediaClientParam: true
                                });
                                return _context1.abrupt("return", this.request("/file/".concat(id, "/").concat(imageEndpoint), options, controller, true).then((0, $5cK21.createMapResponseToBlob)(metadata)));
                            case 7:
                            case "end":
                                return _context1.stop();
                        }
                    }, _callee1, this);
                }));
                function getImage(_x32, _x33, _x34, _x35, _x36) {
                    return _getImage.apply(this, arguments);
                }
                return getImage;
            }()
        },
        {
            key: "getItems",
            value: function() {
                var _getItems = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee10(ids, collectionName, traceContext, includeHashForDuplicateFiles) {
                    var descriptors, metadata, options;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee10$(_context10) {
                        while(true)switch(_context10.prev = _context10.next){
                            case 0:
                                descriptors = ids.map(function(id) {
                                    return {
                                        type: 'file',
                                        id: id,
                                        collection: collectionName
                                    };
                                });
                                metadata = {
                                    method: 'POST',
                                    endpoint: '/items'
                                };
                                options = $76ef59ba7bd830a6$var$_objectSpread($76ef59ba7bd830a6$var$_objectSpread({}, metadata), {}, {
                                    authContext: {
                                        collectionName: collectionName
                                    },
                                    headers: $76ef59ba7bd830a6$var$jsonHeaders,
                                    body: JSON.stringify({
                                        descriptors: descriptors,
                                        includeHashForDuplicateFiles: includeHashForDuplicateFiles
                                    }),
                                    traceContext: traceContext
                                });
                                return _context10.abrupt("return", this.request('/items', options).then((0, $5cK21.createMapResponseToJson)(metadata)));
                            case 4:
                            case "end":
                                return _context10.stop();
                        }
                    }, _callee10, this);
                }));
                function getItems(_x37, _x38, _x39, _x40) {
                    return _getItems.apply(this, arguments);
                }
                return getItems;
            }()
        },
        {
            key: "getImageMetadata",
            value: function() {
                var _getImageMetadata = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee11(id, params, traceContext) {
                    var metadata, options;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee11$(_context11) {
                        while(true)switch(_context11.prev = _context11.next){
                            case 0:
                                metadata = {
                                    method: 'GET',
                                    endpoint: '/file/{fileId}/image/metadata'
                                };
                                options = $76ef59ba7bd830a6$var$_objectSpread($76ef59ba7bd830a6$var$_objectSpread({}, metadata), {}, {
                                    authContext: {
                                        collectionName: params && params.collection
                                    },
                                    params: params,
                                    traceContext: traceContext
                                });
                                return _context11.abrupt("return", this.request("/file/".concat(id, "/image/metadata"), options).then((0, $5cK21.createMapResponseToJson)(metadata)));
                            case 3:
                            case "end":
                                return _context11.stop();
                        }
                    }, _callee11, this);
                }));
                function getImageMetadata(_x41, _x42, _x43) {
                    return _getImageMetadata.apply(this, arguments);
                }
                return getImageMetadata;
            }()
        },
        {
            key: "getDocumentContent",
            value: function() {
                var _getDocumentContent = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee12(id, options, traceContext) {
                    var shouldCache, endpoint, metadata, headers, requestOptions;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee12$(_context12) {
                        while(true)switch(_context12.prev = _context12.next){
                            case 0:
                                // when requesting for password protected document don't use CDN as it won't forward headers
                                // this is deliberate to avoid caching Password protected files
                                // Note: this should be removed once endpoint implements server side Cache-Control headers
                                shouldCache = !options.password;
                                endpoint = shouldCache ? $76ef59ba7bd830a6$var$cdnFeatureFlag('contents') : 'contents';
                                metadata = {
                                    method: 'GET',
                                    endpoint: "/file/{fileId}/document/".concat(endpoint)
                                };
                                headers = options.password ? {
                                    'x-document-authorization': "Basic ".concat(options.password)
                                } : {};
                                requestOptions = $76ef59ba7bd830a6$var$_objectSpread($76ef59ba7bd830a6$var$_objectSpread({}, metadata), {}, {
                                    authContext: {
                                        collectionName: options.collectionName
                                    },
                                    headers: headers,
                                    params: {
                                        collection: options.collectionName,
                                        pageStart: options.pageStart,
                                        pageEnd: options.pageEnd,
                                        'max-age': shouldCache ? (0, $cSavz.FILE_CACHE_MAX_AGE) : 0
                                    },
                                    traceContext: traceContext
                                });
                                return _context12.abrupt("return", this.request("/file/".concat(id, "/document/").concat(endpoint), requestOptions).then((0, $5cK21.createMapResponseToJson)(metadata)));
                            case 6:
                            case "end":
                                return _context12.stop();
                        }
                    }, _callee12, this);
                }));
                function getDocumentContent(_x44, _x45, _x46) {
                    return _getDocumentContent.apply(this, arguments);
                }
                return getDocumentContent;
            }()
        },
        {
            key: "getDocumentPageImage",
            value: function() {
                var _getDocumentPageImage = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee13(id, options, traceContext) {
                    var shouldCache, endpoint, metadata, headers, requestOptions;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee13$(_context13) {
                        while(true)switch(_context13.prev = _context13.next){
                            case 0:
                                // when requesting for password protected document don't use CDN as it won't forward headers
                                // this is deliberate to avoid caching Password protected files
                                // Note: this should be removed once endpoint implements server side Cache-Control headers
                                shouldCache = !options.password;
                                endpoint = shouldCache ? $76ef59ba7bd830a6$var$cdnFeatureFlag('page') : 'page';
                                metadata = {
                                    method: 'GET',
                                    endpoint: "/file/{fileId}/document/".concat(endpoint)
                                };
                                headers = options.password ? {
                                    'x-document-authorization': "Basic ".concat(options.password)
                                } : {};
                                requestOptions = $76ef59ba7bd830a6$var$_objectSpread($76ef59ba7bd830a6$var$_objectSpread({}, metadata), {}, {
                                    authContext: {
                                        collectionName: options.collectionName
                                    },
                                    headers: headers,
                                    params: {
                                        collection: options.collectionName,
                                        page: options.page,
                                        zoom: options.zoom,
                                        'max-age': shouldCache ? (0, $cSavz.FILE_CACHE_MAX_AGE) : 0
                                    },
                                    traceContext: traceContext
                                });
                                return _context13.abrupt("return", this.request("/file/".concat(id, "/document/").concat(endpoint), requestOptions).then((0, $5cK21.createMapResponseToBlob)(metadata)));
                            case 6:
                            case "end":
                                return _context13.stop();
                        }
                    }, _callee13, this);
                }));
                function getDocumentPageImage(_x47, _x48, _x49) {
                    return _getDocumentPageImage.apply(this, arguments);
                }
                return getDocumentPageImage;
            }()
        },
        {
            key: "appendChunksToUpload",
            value: function() {
                var _appendChunksToUpload = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee14(uploadId, body, collectionName, traceContext) {
                    var metadata, options;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee14$(_context14) {
                        while(true)switch(_context14.prev = _context14.next){
                            case 0:
                                metadata = {
                                    method: 'PUT',
                                    endpoint: '/upload/{uploadId}/chunks'
                                };
                                options = $76ef59ba7bd830a6$var$_objectSpread($76ef59ba7bd830a6$var$_objectSpread({}, metadata), {}, {
                                    authContext: {
                                        collectionName: collectionName
                                    },
                                    headers: $76ef59ba7bd830a6$var$jsonHeaders,
                                    body: JSON.stringify(body),
                                    traceContext: traceContext
                                });
                                _context14.next = 4;
                                return this.request("/upload/".concat(uploadId, "/chunks"), options);
                            case 4:
                            case "end":
                                return _context14.stop();
                        }
                    }, _callee14, this);
                }));
                function appendChunksToUpload(_x50, _x51, _x52, _x53) {
                    return _appendChunksToUpload.apply(this, arguments);
                }
                return appendChunksToUpload;
            }()
        },
        {
            key: "copyFileWithToken",
            value: function copyFileWithToken(body, params, traceContext) {
                var metadata = {
                    method: 'POST',
                    endpoint: '/file/copy/withToken'
                };
                var options = $76ef59ba7bd830a6$var$_objectSpread($76ef59ba7bd830a6$var$_objectSpread({}, metadata), {}, {
                    authContext: {
                        collectionName: params.collection
                    },
                    // Contains collection name to write to
                    params: params,
                    // Contains collection name to write to
                    headers: $76ef59ba7bd830a6$var$jsonHeaders,
                    body: JSON.stringify(body),
                    // Contains collection name to read from
                    traceContext: traceContext
                });
                return this.request('/file/copy/withToken', options).then((0, $5cK21.createMapResponseToJson)(metadata));
            }
        },
        {
            key: "copyFile",
            value: function copyFile(id, params, traceContext) {
                var metadata = {
                    method: 'POST',
                    endpoint: '/v2/file/copy'
                };
                var options = $76ef59ba7bd830a6$var$_objectSpread($76ef59ba7bd830a6$var$_objectSpread({}, metadata), {}, {
                    authContext: {
                        collectionName: params.collection
                    },
                    params: params,
                    headers: $76ef59ba7bd830a6$var$jsonHeaders,
                    body: JSON.stringify({
                        id: id
                    }),
                    traceContext: traceContext,
                    clientOptions: {
                        retryOptions: {
                            shouldRetryError: function shouldRetryError(err) {
                                var _err$metadata;
                                return (0, $5cK21.defaultShouldRetryError)(err) || (0, $7pWqR.isRequestError)(err) && (err === null || err === void 0 || (_err$metadata = err.metadata) === null || _err$metadata === void 0 ? void 0 : _err$metadata.statusCode) === 401;
                            }
                        }
                    }
                });
                return this.request('/v2/file/copy', options).then((0, $5cK21.createMapResponseToJson)(metadata));
            }
        },
        {
            key: "registerCopyIntents",
            value: function() {
                var _registerCopyIntents = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee15(files, traceContext, resolvedAuth) {
                    var metadata, options;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee15$(_context15) {
                        while(true)switch(_context15.prev = _context15.next){
                            case 0:
                                metadata = {
                                    method: 'POST',
                                    endpoint: '/file/copy/intents'
                                };
                                options = $76ef59ba7bd830a6$var$_objectSpread($76ef59ba7bd830a6$var$_objectSpread({}, metadata), {}, {
                                    headers: $76ef59ba7bd830a6$var$jsonHeaders,
                                    body: JSON.stringify({
                                        files: files
                                    }),
                                    traceContext: traceContext,
                                    resolvedAuth: resolvedAuth
                                });
                                _context15.next = 4;
                                return this.request('/file/copy/intents', options);
                            case 4:
                            case "end":
                                return _context15.stop();
                        }
                    }, _callee15, this);
                }));
                function registerCopyIntents(_x54, _x55, _x56) {
                    return _registerCopyIntents.apply(this, arguments);
                }
                return registerCopyIntents;
            }()
        },
        {
            key: "request",
            value: function() {
                var _request2 = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee16(path) {
                    var options, controller, useMediaCdn, method, endpoint, authContext, params, headers, body, clientOptions, traceContext, addMediaClientParam, resolvedAuth, auth, clientId, extendedTraceContext, extendedParams, url, response, _args16 = arguments;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee16$(_context16) {
                        while(true)switch(_context16.prev = _context16.next){
                            case 0:
                                options = _args16.length > 1 && _args16[1] !== undefined ? _args16[1] : {
                                    method: 'GET',
                                    endpoint: undefined,
                                    authContext: {}
                                };
                                controller = _args16.length > 2 ? _args16[2] : undefined;
                                useMediaCdn = _args16.length > 3 ? _args16[3] : undefined;
                                method = options.method, endpoint = options.endpoint, authContext = options.authContext, params = options.params, headers = options.headers, body = options.body, clientOptions = options.clientOptions, traceContext = options.traceContext, addMediaClientParam = options.addMediaClientParam, resolvedAuth = options.resolvedAuth;
                                if (!(resolvedAuth !== null && resolvedAuth !== void 0)) {
                                    _context16.next = 8;
                                    break;
                                }
                                _context16.t0 = resolvedAuth;
                                _context16.next = 11;
                                break;
                            case 8:
                                _context16.next = 10;
                                return this.resolveAuth(authContext);
                            case 10:
                                _context16.t0 = _context16.sent;
                            case 11:
                                auth = _context16.t0;
                                clientId = (0, $pDaXe.isClientBasedAuth)(auth) ? auth.clientId : undefined;
                                extendedTraceContext = (0, $5cK21.extendTraceContext)(traceContext);
                                extendedParams = addMediaClientParam ? $76ef59ba7bd830a6$var$_objectSpread($76ef59ba7bd830a6$var$_objectSpread({}, params), {}, {
                                    clientId: clientId
                                }) : params;
                                url = "".concat(auth.baseUrl).concat(path);
                                if (useMediaCdn) url = (0, $lHlAm.mapToMediaCdnUrl)(url, auth.token);
                                if ((0, $caJ08.isPathBasedEnabled)()) url = (0, $caJ08.mapToPathBasedUrl)(url);
                                _context16.next = 20;
                                return (0, $4s8uz.request)(url, {
                                    method: method,
                                    endpoint: endpoint,
                                    auth: auth,
                                    params: extendedParams,
                                    headers: headers,
                                    body: body,
                                    clientOptions: clientOptions,
                                    traceContext: extendedTraceContext
                                }, controller);
                            case 20:
                                response = _context16.sent;
                                $76ef59ba7bd830a6$var$setKeyValueInSessionStorage($76ef59ba7bd830a6$var$MEDIA_API_REGION, response.headers.get('x-media-region'));
                                $76ef59ba7bd830a6$var$setKeyValueInSessionStorage($76ef59ba7bd830a6$var$MEDIA_API_ENVIRONMENT, response.headers.get('x-media-env'));
                                return _context16.abrupt("return", response);
                            case 24:
                            case "end":
                                return _context16.stop();
                        }
                    }, _callee16, this);
                }));
                function request(_x57) {
                    return _request2.apply(this, arguments);
                }
                return request;
            }()
        },
        {
            key: "testUrl",
            value: function() {
                var _testUrl = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee17(url) {
                    var options, traceContext, _args17 = arguments;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee17$(_context17) {
                        while(true)switch(_context17.prev = _context17.next){
                            case 0:
                                options = _args17.length > 1 && _args17[1] !== undefined ? _args17[1] : {};
                                traceContext = options.traceContext;
                                _context17.next = 4;
                                return (0, $4s8uz.request)(url, {
                                    method: 'HEAD',
                                    traceContext: (0, $5cK21.extendTraceContext)(traceContext),
                                    clientOptions: {
                                        retryOptions: {
                                            maxAttempts: 1
                                        }
                                    }
                                });
                            case 4:
                            case "end":
                                return _context17.stop();
                        }
                    }, _callee17);
                }));
                function testUrl(_x58) {
                    return _testUrl.apply(this, arguments);
                }
                return testUrl;
            }()
        },
        {
            key: "chunkHashAlgorithm",
            get: function get() {
                return this._chunkHashAlgorithm;
            }
        }
    ]);
}();
var $76ef59ba7bd830a6$var$getValueFromSessionStorage = function getValueFromSessionStorage(key) {
    return window && window.sessionStorage && window.sessionStorage.getItem(key) || undefined;
};
var $76ef59ba7bd830a6$var$setKeyValueInSessionStorage = function setKeyValueInSessionStorage(key, value) {
    if (!value || !(window && window.sessionStorage)) return;
    var currentValue = window.sessionStorage.getItem(key);
    if (currentValue !== value) window.sessionStorage.setItem(key, value);
};
var $76ef59ba7bd830a6$export$c8b741e18397852a = function getMediaEnvironment() {
    return $76ef59ba7bd830a6$var$getValueFromSessionStorage($76ef59ba7bd830a6$var$MEDIA_API_ENVIRONMENT);
};
var $76ef59ba7bd830a6$export$20f9315304dd6726 = function getMediaRegion() {
    return $76ef59ba7bd830a6$var$getValueFromSessionStorage($76ef59ba7bd830a6$var$MEDIA_API_REGION);
};

});
parcelRegister("cSavz", function(module, exports) {
$parcel$export(module.exports, "RECENTS_COLLECTION", () => $95f2ade41aa8d6a4$export$860a16125e30000b);
$parcel$export(module.exports, "FILE_CACHE_MAX_AGE", () => $95f2ade41aa8d6a4$export$bd6e8fe09a90927b);
$parcel$export(module.exports, "MAX_RESOLUTION", () => $95f2ade41aa8d6a4$export$6e70f30e392bc53f);
$parcel$export(module.exports, "CHUNK_SIZE", () => $95f2ade41aa8d6a4$export$c1abb8bab1e615cd);
$parcel$export(module.exports, "PROCESSING_BATCH_SIZE", () => $95f2ade41aa8d6a4$export$3d5157f0def70e54);
$parcel$export(module.exports, "MAX_UPLOAD_FILE_SIZE", () => $95f2ade41aa8d6a4$export$f14f521f3d306044);

var $j9G0f = parcelRequire("j9G0f");
var $95f2ade41aa8d6a4$export$860a16125e30000b = 'recents';
var $95f2ade41aa8d6a4$export$bd6e8fe09a90927b = 2592000; // Retain for 30 days
var $95f2ade41aa8d6a4$export$6e70f30e392bc53f = 4096;
var $95f2ade41aa8d6a4$export$c1abb8bab1e615cd = 5 * (0, $j9G0f.DATA_UNIT).MB;
var $95f2ade41aa8d6a4$export$3d5157f0def70e54 = 1000;
var $95f2ade41aa8d6a4$export$f14f521f3d306044 = 2 * (0, $j9G0f.DATA_UNIT).TB;

});
parcelRegister("j9G0f", function(module, exports) {
$parcel$export(module.exports, "isNotFoundMediaItemDetails", () => $df1f70878b5751f3$export$fd27d7abbc4a746d);
$parcel$export(module.exports, "DATA_UNIT", () => $df1f70878b5751f3$export$76cfea4c354af843);
// Warning! You can't add new media file processing status!
// See packages/media/media-core/src/__tests__/cache-backward-compatibility.spec.ts
var $df1f70878b5751f3$export$350ede7b7a6acf99 = function isPreviewableType(type) {
    var defaultPreviewableTypes = [
        'audio',
        'video',
        'image',
        'doc'
    ];
    return defaultPreviewableTypes.indexOf(type) > -1;
};
var $df1f70878b5751f3$export$fd27d7abbc4a746d = function isNotFoundMediaItemDetails(itemDetails) {
    return 'type' in itemDetails && itemDetails.type === 'not-found';
};
var $df1f70878b5751f3$export$76cfea4c354af843 = /*#__PURE__*/ function(DATA_UNIT) {
    DATA_UNIT[DATA_UNIT["MB"] = 1048576] = "MB";
    DATA_UNIT[DATA_UNIT["GB"] = 1073741824] = "GB";
    DATA_UNIT[DATA_UNIT["TB"] = 1099511627776] = "TB";
    return DATA_UNIT;
}({});

});


parcelRegister("lGGRS", function(module, exports) {
$parcel$export(module.exports, "getArtifactUrl", () => $fc9ec5eb0f92b2bc$export$1cc24defa44e7f84);

var $lHlAm = parcelRequire("lHlAm");
var $fc9ec5eb0f92b2bc$export$1cc24defa44e7f84 = function getArtifactUrl(artifacts, prop) {
    var _artifacts$prop, _artifacts$prop3;
    // eslint-disable-next-line @atlaskit/platform/no-preconditioning
    if ((0, $lHlAm.isCDNEnabled)() && (_artifacts$prop = artifacts[prop]) !== null && _artifacts$prop !== void 0 && _artifacts$prop.url) {
        var _artifacts$prop2;
        return "".concat((_artifacts$prop2 = artifacts[prop]) === null || _artifacts$prop2 === void 0 ? void 0 : _artifacts$prop2.url, "/cdn");
    }
    return (_artifacts$prop3 = artifacts[prop]) === null || _artifacts$prop3 === void 0 ? void 0 : _artifacts$prop3.url;
};

});
parcelRegister("lHlAm", function(module, exports) {
$parcel$export(module.exports, "isCDNEnabled", () => $fcbe5b8b054531f6$export$3e47d0e609e44278);
$parcel$export(module.exports, "mapToMediaCdnUrl", () => $fcbe5b8b054531f6$export$fb88a576cf28364d);

var $9Zzpd = parcelRequire("9Zzpd");

var $k4tje = parcelRequire("k4tje");

var $KItDh = parcelRequire("KItDh");

var $caJ08 = parcelRequire("caJ08");
var $fcbe5b8b054531f6$export$8a9b6ab3569a543a = {
    'api.media.atlassian.com': 'media-cdn.atlassian.com',
    'media.staging.atl-paas.net': 'media-cdn.stg.atlassian.com'
};
// Cloudfront has a hard limit of 8,192 bytes
// https://docs.aws.amazon.com/AmazonCloudFront/latest/DeveloperGuide/cloudfront-limits.html
// Assuming other parts of the URL make up a max of ~1000 (in reality it's lower), the token can be ~7000
var $fcbe5b8b054531f6$var$MEDIA_TOKEN_LENGTH_LIMIT = 7000;
function $fcbe5b8b054531f6$export$3e47d0e609e44278() {
    return (0, $k4tje.isCommercial)() && !(0, $KItDh.isIsolatedCloud)() && (0, $9Zzpd.fg)('platform_media_cdn_delivery') && !(0, $caJ08.isPathBasedEnabled)();
}
function $fcbe5b8b054531f6$export$fb88a576cf28364d(url, token) {
    var _token$length;
    var tokenLength = (_token$length = token === null || token === void 0 ? void 0 : token.length) !== null && _token$length !== void 0 ? _token$length : 0;
    if (!$fcbe5b8b054531f6$export$3e47d0e609e44278() || tokenLength > $fcbe5b8b054531f6$var$MEDIA_TOKEN_LENGTH_LIMIT) return url;
    // eslint-disable-next-line @atlaskit/platform/no-preconditioning
    if ((0, $9Zzpd.fg)('platform_media_cdn_delivery') && (0, $9Zzpd.fg)('platform_media_cdn_single_host')) try {
        var parsedUrl = new URL(url);
        var cdnHost = $fcbe5b8b054531f6$export$8a9b6ab3569a543a[parsedUrl.host];
        // If no mapping is found, return the original URL
        if (!cdnHost) return url;
        // Replace the host with the CDN host in the original URL
        parsedUrl.host = cdnHost;
        return parsedUrl.toString();
    } catch (error) {
        return url;
    }
    return url;
}

});
parcelRegister("k4tje", function(module, exports) {
$parcel$export(module.exports, "isCommercial", () => $e9caea91b9ad0c02$export$df69ff6733e73e50);
function $e9caea91b9ad0c02$export$df69ff6733e73e50() {
    var _global$location;
    var global = globalThis;
    var perimeter = global.MICROS_PERIMETER || global.UNSAFE_ATL_CONTEXT_BOUNDARY;
    if (perimeter) // Note: reference to MICROS_PERIMETER can be found in: https://hello.atlassian.net/wiki/spaces/MICROS/pages/167212650/Runtime+configuration+environment+variables+and+adding+secrets#Micros-provided-variables
    return perimeter === 'commercial';
    // Return true if the current hostname does NOT match any of the forbidden patterns.
    return !((_global$location = global.location) !== null && _global$location !== void 0 && (_global$location = _global$location.hostname) !== null && _global$location !== void 0 && _global$location.match(/(atlassian-us-gov-mod\.(com|net)|atlassian-us-gov\.(com|net)|atlassian-fex\.(com|net)|atlassian-stg-fedm\.(com|net))/));
}

});

parcelRegister("caJ08", function(module, exports) {
$parcel$export(module.exports, "isPathBasedEnabled", () => $8dc95380583a282f$export$6de3392754e98e65);
$parcel$export(module.exports, "mapToPathBasedUrl", () => $8dc95380583a282f$export$774e2add1fbe26aa);
$parcel$export(module.exports, "mapRetryUrlToPathBasedUrl", () => $8dc95380583a282f$export$e71b0af0000b3cfa);

var $9Zzpd = parcelRequire("9Zzpd");

var $7L1D4 = parcelRequire("7L1D4");
var $8dc95380583a282f$var$mediaApiPathPrefix = '/media-api';
function $8dc95380583a282f$var$getRelativeUrl(absoluteUrl) {
    var url = new URL(absoluteUrl);
    return "".concat(url.pathname).concat(url.search).concat(url.hash);
}
function $8dc95380583a282f$export$6de3392754e98e65() {
    var _getDocument;
    var isLocalhost = ((_getDocument = (0, $7L1D4.default)()) === null || _getDocument === void 0 || (_getDocument = _getDocument.location) === null || _getDocument === void 0 ? void 0 : _getDocument.hostname) === 'localhost';
    return (0, $9Zzpd.fg)('platform_media_path_based_route') && !isLocalhost;
}
function $8dc95380583a282f$export$774e2add1fbe26aa(url) {
    if ($8dc95380583a282f$export$6de3392754e98e65()) {
        var _getDocument2;
        var parsedUrl = new URL(url);
        if (!parsedUrl.pathname.startsWith($8dc95380583a282f$var$mediaApiPathPrefix)) parsedUrl.pathname = "".concat($8dc95380583a282f$var$mediaApiPathPrefix).concat(parsedUrl.pathname);
        var location = (_getDocument2 = (0, $7L1D4.default)()) === null || _getDocument2 === void 0 ? void 0 : _getDocument2.location;
        // in this case we are most likely in SSR / a non browser environment so just return a relative URL
        if (!location) return $8dc95380583a282f$var$getRelativeUrl(parsedUrl.toString());
        parsedUrl.host = location.host;
        return parsedUrl.toString();
    }
    return url;
}
function $8dc95380583a282f$export$e71b0af0000b3cfa(url) {
    var _getDocument$location, _getDocument3;
    var parsedUrl = new URL(url);
    parsedUrl.host = (_getDocument$location = (_getDocument3 = (0, $7L1D4.default)()) === null || _getDocument3 === void 0 ? void 0 : _getDocument3.location.host) !== null && _getDocument$location !== void 0 ? _getDocument$location : '';
    // remove CDN from the URL for retry if it exists
    var pathname = parsedUrl.pathname;
    if (pathname.endsWith('/cdn')) parsedUrl.pathname = pathname.replace('/cdn', '');
    if (!parsedUrl.pathname.startsWith($8dc95380583a282f$var$mediaApiPathPrefix)) parsedUrl.pathname = "".concat($8dc95380583a282f$var$mediaApiPathPrefix).concat(parsedUrl.pathname);
    return parsedUrl;
}

});
parcelRegister("7L1D4", function(module, exports) {
$parcel$export(module.exports, "default", () => $5a5e2fbae1c5bf79$export$2e2bcd8739ae039);
var $5a5e2fbae1c5bf79$export$2e2bcd8739ae039 = function() {
    if (typeof window === 'undefined') return;
    if (typeof window.document === 'undefined') return;
    return window.document;
};

});




parcelRegister("7pWqR", function(module, exports) {
$parcel$export(module.exports, "RequestError", () => $566831a72c2ee254$export$43ee7d0e4f429743);
$parcel$export(module.exports, "isRequestError", () => $566831a72c2ee254$export$3717b1ffef4428ea);

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $kIXpt = parcelRequire("kIXpt");

var $cYPzS = parcelRequire("cYPzS");

var $eyuDe = parcelRequire("eyuDe");

var $8eaz3 = parcelRequire("8eaz3");
function $566831a72c2ee254$var$_callSuper(t, o, e) {
    return o = (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(o), (0, (/*@__PURE__*/$parcel$interopDefault($kIXpt)))(t, $566831a72c2ee254$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(t).constructor) : o.apply(t, e));
}
function $566831a72c2ee254$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($566831a72c2ee254$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $566831a72c2ee254$export$43ee7d0e4f429743 = /*#__PURE__*/ function(_BaseMediaClientError) {
    function RequestError(reason, metadata, innerError) {
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, RequestError);
        return $566831a72c2ee254$var$_callSuper(this, RequestError, [
            reason,
            metadata,
            innerError
        ]);
    }
    // TODO: Deprecate this getter https://product-fabric.atlassian.net/browse/CXP-4665
    /** Will be deprecated. Use the properties `reason` and `metadata` instead */ (0, (/*@__PURE__*/$parcel$interopDefault($eyuDe)))(RequestError, _BaseMediaClientError);
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(RequestError, [
        {
            key: "attributes",
            get: function get() {
                var reason = this.reason, _this$metadata = this.metadata, _this$metadata2 = _this$metadata === void 0 ? {} : _this$metadata, method = _this$metadata2.method, endpoint = _this$metadata2.endpoint, mediaRegion = _this$metadata2.mediaRegion, mediaEnv = _this$metadata2.mediaEnv, attempts = _this$metadata2.attempts, clientExhaustedRetries = _this$metadata2.clientExhaustedRetries, statusCode = _this$metadata2.statusCode, traceContext = _this$metadata2.traceContext, innerError = this.innerError;
                return {
                    reason: reason,
                    method: method,
                    endpoint: endpoint,
                    mediaRegion: mediaRegion,
                    mediaEnv: mediaEnv,
                    attempts: attempts,
                    clientExhaustedRetries: clientExhaustedRetries,
                    statusCode: statusCode,
                    metadata: {
                        traceContext: traceContext
                    },
                    innerError: innerError
                };
            }
        }
    ]);
}((0, $8eaz3.BaseMediaClientError));
function $566831a72c2ee254$export$3717b1ffef4428ea(err) {
    return err instanceof $566831a72c2ee254$export$43ee7d0e4f429743;
}

});
parcelRegister("8eaz3", function(module, exports) {
$parcel$export(module.exports, "BaseMediaClientError", () => $5fd7d36983ad7742$export$2b0aca14d61c3190);
$parcel$export(module.exports, "CommonMediaClientError", () => $5fd7d36983ad7742$export$e574d1724215079f);
$parcel$export(module.exports, "isCommonMediaClientError", () => $5fd7d36983ad7742$export$881f0f9bc813e1f3);
$parcel$export(module.exports, "toCommonMediaClientError", () => $5fd7d36983ad7742$export$a5db89cfc88eff9);
$parcel$export(module.exports, "fromCommonMediaClientError", () => $5fd7d36983ad7742$export$c2b89b9a32286816);

var $25nEq = parcelRequire("25nEq");

var $arMYe = parcelRequire("arMYe");

var $9P61R = parcelRequire("9P61R");

var $kIXpt = parcelRequire("kIXpt");

var $cYPzS = parcelRequire("cYPzS");

var $eyuDe = parcelRequire("eyuDe");

var $c7s0H = parcelRequire("c7s0H");

function $5fd7d36983ad7742$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $5fd7d36983ad7742$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $5fd7d36983ad7742$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $5fd7d36983ad7742$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $5fd7d36983ad7742$var$_callSuper(t, o, e) {
    return o = (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(o), (0, (/*@__PURE__*/$parcel$interopDefault($kIXpt)))(t, $5fd7d36983ad7742$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(t).constructor) : o.apply(t, e));
}
function $5fd7d36983ad7742$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($5fd7d36983ad7742$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $5fd7d36983ad7742$export$2b0aca14d61c3190 = /*#__PURE__*/ function(_Error) {
    function BaseMediaClientError(reason, metadata, innerError) {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, BaseMediaClientError);
        _this = $5fd7d36983ad7742$var$_callSuper(this, BaseMediaClientError, [
            reason
        ]);
        // https://www.typescriptlang.org/docs/handbook/release-notes/typescript-2-2.html#support-for-newtarget
        _this.reason = reason;
        _this.metadata = metadata;
        _this.innerError = innerError;
        Object.setPrototypeOf(_this, (this instanceof BaseMediaClientError ? this.constructor : void 0).prototype);
        // https://v8.dev/docs/stack-trace-api
        if ('captureStackTrace' in Error) Error.captureStackTrace(_this, this instanceof BaseMediaClientError ? this.constructor : void 0);
        return _this;
    }
    // TODO: Deprecate attributes getter https://product-fabric.atlassian.net/browse/CXP-4665
    (0, (/*@__PURE__*/$parcel$interopDefault($eyuDe)))(BaseMediaClientError, _Error);
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(BaseMediaClientError);
}(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($c7s0H)))(Error));
var $5fd7d36983ad7742$export$e574d1724215079f = /*#__PURE__*/ function(_BaseMediaClientError) {
    function CommonMediaClientError(reason, metadata, innerError) {
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, CommonMediaClientError);
        return $5fd7d36983ad7742$var$_callSuper(this, CommonMediaClientError, [
            reason,
            metadata,
            innerError
        ]);
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($eyuDe)))(CommonMediaClientError, _BaseMediaClientError);
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(CommonMediaClientError, [
        {
            key: "attributes",
            get: function get() {
                return {
                    reason: this.reason
                };
            }
        }
    ]);
}($5fd7d36983ad7742$export$2b0aca14d61c3190);
function $5fd7d36983ad7742$export$881f0f9bc813e1f3(error) {
    if (!error) return false;
    // Check if the error is an instance of Error
    if (error instanceof $5fd7d36983ad7742$export$e574d1724215079f) return true;
    return typeof error.reason === 'string' && ('metadata' in error || error.metadata === undefined) && ('innerError' in error || error.innerError === undefined);
}
var $5fd7d36983ad7742$export$a5db89cfc88eff9 = function toCommonMediaClientError(errorFileState) {
    var _errorFileState$detai;
    var error = (_errorFileState$detai = errorFileState.details) === null || _errorFileState$detai === void 0 ? void 0 : _errorFileState$detai.error;
    return new $5fd7d36983ad7742$export$e574d1724215079f((error === null || error === void 0 ? void 0 : error.reason) || 'unknown-reason', error === null || error === void 0 ? void 0 : error.metadata, error === null || error === void 0 ? void 0 : error.innerError);
};
var $5fd7d36983ad7742$export$c2b89b9a32286816 = function fromCommonMediaClientError(id, occurrenceKey, error) {
    return {
        status: 'error',
        id: id,
        occurrenceKey: occurrenceKey,
        reason: error.reason,
        details: $5fd7d36983ad7742$var$_objectSpread({
            /** Use this attr to translate back into CommonMediaClientError (toCommonMediaClientError) */ error: {
                reason: error === null || error === void 0 ? void 0 : error.reason,
                metadata: error === null || error === void 0 ? void 0 : error.metadata,
                innerError: error === null || error === void 0 ? void 0 : error.innerError
            }
        }, error === null || error === void 0 ? void 0 : error.attributes),
        message: error === null || error === void 0 ? void 0 : error.message
    };
};

});


parcelRegister("4s8uz", function(module, exports) {
$parcel$export(module.exports, "request", () => $33e05d4f2f153475$export$b5fe3f66a567bec0);

var $25nEq = parcelRequire("25nEq");

var $fL8KA = parcelRequire("fL8KA");

var $6HG4S = parcelRequire("6HG4S");

var $7pWqR = parcelRequire("7pWqR");

var $5cK21 = parcelRequire("5cK21");

var $9Zzpd = parcelRequire("9Zzpd");

var $caJ08 = parcelRequire("caJ08");

var $5seSP = parcelRequire("5seSP");
function $33e05d4f2f153475$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $33e05d4f2f153475$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $33e05d4f2f153475$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $33e05d4f2f153475$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $33e05d4f2f153475$export$b5fe3f66a567bec0(_x) {
    return $33e05d4f2f153475$var$_request.apply(this, arguments);
}
function $33e05d4f2f153475$var$_request() {
    $33e05d4f2f153475$var$_request = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee(url) {
        var options, controller, _options$method, method, endpoint, auth, params, headers, body, _options$clientOption, clientOptions, traceContext, retryOptions, metadata, doFetch, shouldRetryError, _getNavigator2, doFetchWithPathBasedUrl, _args = arguments;
        return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee$(_context) {
            while(true)switch(_context.prev = _context.next){
                case 0:
                    options = _args.length > 1 && _args[1] !== undefined ? _args[1] : {};
                    controller = _args.length > 2 ? _args[2] : undefined;
                    _options$method = options.method, method = _options$method === void 0 ? 'GET' : _options$method, endpoint = options.endpoint, auth = options.auth, params = options.params, headers = options.headers, body = options.body, _options$clientOption = options.clientOptions, clientOptions = _options$clientOption === void 0 ? {} : _options$clientOption, traceContext = options.traceContext;
                    retryOptions = clientOptions.retryOptions;
                    metadata = {
                        method: method,
                        endpoint: endpoint,
                        traceContext: traceContext
                    }; // TODO BMPT-918: add client timeout feature behing a FF (using clientOptions.clientTimeout + Promise.race)
                    doFetch = function doFetch() {
                        return fetch((0, $5cK21.createUrl)(url, {
                            params: params
                        }), {
                            method: method,
                            body: body,
                            headers: (0, $5cK21.extendHeaders)(headers, auth, traceContext),
                            signal: controller && controller.signal
                        }).then((0, $5cK21.createProcessFetchResponse)(metadata));
                    };
                    if (!(0, $9Zzpd.fg)('platform_media_retry_edge_error')) {
                        _context.next = 20;
                        break;
                    }
                    shouldRetryError = function shouldRetryError(err) {
                        var _getNavigator;
                        if ((0, $5cK21.isFetchNetworkError)(err) && (_getNavigator = (0, $5seSP.default)()) !== null && _getNavigator !== void 0 && _getNavigator.userAgent.includes('Edg/')) return false;
                        return (0, $5cK21.defaultShouldRetryError)(err);
                    };
                    _context.prev = 8;
                    _context.next = 11;
                    return (0, $5cK21.fetchRetry)(doFetch, metadata, $33e05d4f2f153475$var$_objectSpread($33e05d4f2f153475$var$_objectSpread({}, retryOptions), {}, {
                        shouldRetryError: shouldRetryError
                    }));
                case 11:
                    return _context.abrupt("return", _context.sent);
                case 14:
                    _context.prev = 14;
                    _context.t0 = _context["catch"](8);
                    if (!((0, $5cK21.isFetchNetworkError)(_context.t0) && (_getNavigator2 = (0, $5seSP.default)()) !== null && _getNavigator2 !== void 0 && _getNavigator2.userAgent.includes('Edg/'))) {
                        _context.next = 19;
                        break;
                    }
                    doFetchWithPathBasedUrl = function doFetchWithPathBasedUrl() {
                        return fetch((0, $5cK21.createUrl)((0, $caJ08.mapRetryUrlToPathBasedUrl)(url).toString(), {
                            params: params
                        }), {
                            method: method,
                            body: body,
                            headers: (0, $5cK21.extendHeaders)(headers, auth, traceContext),
                            signal: controller && controller.signal
                        }).then((0, $5cK21.createProcessFetchResponse)(metadata));
                    };
                    return _context.abrupt("return", (0, $5cK21.fetchRetry)(doFetchWithPathBasedUrl, metadata, retryOptions));
                case 19:
                    throw _context.t0;
                case 20:
                    return _context.abrupt("return", (0, $5cK21.fetchRetry)(doFetch, metadata, retryOptions));
                case 21:
                case "end":
                    return _context.stop();
            }
        }, _callee, null, [
            [
                8,
                14
            ]
        ]);
    }));
    return $33e05d4f2f153475$var$_request.apply(this, arguments);
}

});
parcelRegister("5cK21", function(module, exports) {
$parcel$export(module.exports, "isFetchNetworkError", () => $3ca1c7a287c9d841$export$ad8c5cf7dd4c3caf);
$parcel$export(module.exports, "extendTraceContext", () => $3ca1c7a287c9d841$export$ee24a95986dfd173);
$parcel$export(module.exports, "createUrl", () => $3ca1c7a287c9d841$export$7138c24907de3954);
$parcel$export(module.exports, "extendHeaders", () => $3ca1c7a287c9d841$export$18cfbabc415d771c);
$parcel$export(module.exports, "createMapResponseToJson", () => $3ca1c7a287c9d841$export$e0519b126b73efa6);
$parcel$export(module.exports, "createMapResponseToBlob", () => $3ca1c7a287c9d841$export$5cc7b0795397da86);
$parcel$export(module.exports, "defaultShouldRetryError", () => $3ca1c7a287c9d841$export$fee2242cbb339663);
$parcel$export(module.exports, "fetchRetry", () => $3ca1c7a287c9d841$export$782df2acbe10b22c);
$parcel$export(module.exports, "createProcessFetchResponse", () => $3ca1c7a287c9d841$export$6e2e477edb7d6032);

var $fL8KA = parcelRequire("fL8KA");

var $fC8ib = parcelRequire("fC8ib");

var $iYJcE = parcelRequire("iYJcE");

var $25nEq = parcelRequire("25nEq");

var $6HG4S = parcelRequire("6HG4S");
parcelRequire("l7fRX");
var $pDaXe = parcelRequire("pDaXe");

var $bVaC0 = parcelRequire("bVaC0");

var $a8AqD = parcelRequire("a8AqD");

var $7pWqR = parcelRequire("7pWqR");
function $3ca1c7a287c9d841$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $3ca1c7a287c9d841$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $3ca1c7a287c9d841$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $3ca1c7a287c9d841$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $3ca1c7a287c9d841$var$getStatusCode = function getStatusCode(error) {
    var _error$metadata;
    return (0, $7pWqR.isRequestError)(error) && ((_error$metadata = error.metadata) === null || _error$metadata === void 0 ? void 0 : _error$metadata.statusCode) && error.metadata.statusCode;
};
function $3ca1c7a287c9d841$export$80c51ea1e89203dd(timeout) {
    return new Promise(function(resolve) {
        return setTimeout(resolve, timeout);
    });
}
function $3ca1c7a287c9d841$export$de0b576cf7ce4a53(err) {
    return err instanceof Error && err.message === 'request_cancelled' || !!err && err.name === 'AbortError';
}
function $3ca1c7a287c9d841$export$ad8c5cf7dd4c3caf(err) {
    return err instanceof TypeError;
}
function $3ca1c7a287c9d841$export$bc96a6a479480590(error) {
    var statusCode = error && $3ca1c7a287c9d841$var$getStatusCode(error);
    return statusCode === 429 || !!error && !!error.message && error.message.includes('429');
}
var $3ca1c7a287c9d841$export$ee24a95986dfd173 = function extendTraceContext(traceContext) {
    return traceContext ? $3ca1c7a287c9d841$var$_objectSpread($3ca1c7a287c9d841$var$_objectSpread({}, traceContext), {}, {
        spanId: (traceContext === null || traceContext === void 0 ? void 0 : traceContext.spanId) || (0, $bVaC0.getRandomTelemetryId)()
    }) : undefined;
};
var $3ca1c7a287c9d841$export$922566b90d0535ce = {
    traceId: 'x-b3-traceid',
    spanId: 'x-b3-spanid',
    parentSpanId: 'x-b3-parentspanid',
    sampled: 'x-b3-sampled',
    flags: 'x-b3-flags'
};
var $3ca1c7a287c9d841$var$mapTraceIdToRequestHeaders = function mapTraceIdToRequestHeaders(traceContext) {
    return traceContext ? (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, $3ca1c7a287c9d841$export$922566b90d0535ce.traceId, traceContext.traceId), $3ca1c7a287c9d841$export$922566b90d0535ce.spanId, traceContext.spanId) : {};
};
function $3ca1c7a287c9d841$export$eaf4479116d2f925(auth) {
    if (!auth) return {};
    if ((0, $pDaXe.isClientBasedAuth)(auth)) return {
        'X-Client-Id': auth.clientId,
        Authorization: "Bearer ".concat(auth.token)
    };
    return {
        'X-Issuer': auth.asapIssuer,
        Authorization: "Bearer ".concat(auth.token)
    };
}
function $3ca1c7a287c9d841$export$7138c24907de3954(url, _ref2) {
    var params = _ref2.params, auth = _ref2.auth;
    var parsedUrl = new URL(url, auth === null || auth === void 0 ? void 0 : auth.baseUrl);
    var authParams = auth && (0, $a8AqD.mapAuthToQueryParameters)(auth) || {};
    var paramsToAppend = $3ca1c7a287c9d841$var$_objectSpread($3ca1c7a287c9d841$var$_objectSpread({}, params), authParams);
    Object.entries(paramsToAppend).filter(function(_ref3) {
        var _ref4 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_ref3, 2), _ = _ref4[0], value = _ref4[1];
        return value != null;
    }).forEach(function(pair) {
        var _parsedUrl$searchPara;
        (_parsedUrl$searchPara = parsedUrl.searchParams).set.apply(_parsedUrl$searchPara, (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(pair));
    });
    parsedUrl.searchParams.sort();
    return parsedUrl.toString();
}
function $3ca1c7a287c9d841$export$18cfbabc415d771c(headers, auth, traceContext) {
    if (!auth && !traceContext && !headers) return undefined;
    return $3ca1c7a287c9d841$var$_objectSpread($3ca1c7a287c9d841$var$_objectSpread($3ca1c7a287c9d841$var$_objectSpread({}, headers !== null && headers !== void 0 ? headers : {}), $3ca1c7a287c9d841$export$eaf4479116d2f925(auth)), $3ca1c7a287c9d841$var$mapTraceIdToRequestHeaders(traceContext));
}
function $3ca1c7a287c9d841$export$e0519b126b73efa6(metadata) {
    return /*#__PURE__*/ function() {
        var _ref5 = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee(response) {
            return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee$(_context) {
                while(true)switch(_context.prev = _context.next){
                    case 0:
                        _context.prev = 0;
                        _context.next = 3;
                        return response.json();
                    case 3:
                        return _context.abrupt("return", _context.sent);
                    case 6:
                        _context.prev = 6;
                        _context.t0 = _context["catch"](0);
                        throw new (0, $7pWqR.RequestError)('serverInvalidBody', $3ca1c7a287c9d841$var$_objectSpread($3ca1c7a287c9d841$var$_objectSpread($3ca1c7a287c9d841$var$_objectSpread({}, metadata), $3ca1c7a287c9d841$export$ea175c0c5497224(response)), {}, {
                            statusCode: response.status
                        }), _context.t0 instanceof Error ? _context.t0 : undefined);
                    case 9:
                    case "end":
                        return _context.stop();
                }
            }, _callee, null, [
                [
                    0,
                    6
                ]
            ]);
        }));
        return function(_x) {
            return _ref5.apply(this, arguments);
        };
    }();
}
function $3ca1c7a287c9d841$export$5cc7b0795397da86(metadata) {
    return /*#__PURE__*/ function() {
        var _ref6 = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee2(response) {
            return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee2$(_context2) {
                while(true)switch(_context2.prev = _context2.next){
                    case 0:
                        _context2.prev = 0;
                        _context2.next = 3;
                        return response.blob();
                    case 3:
                        return _context2.abrupt("return", _context2.sent);
                    case 6:
                        _context2.prev = 6;
                        _context2.t0 = _context2["catch"](0);
                        throw new (0, $7pWqR.RequestError)('serverInvalidBody', $3ca1c7a287c9d841$var$_objectSpread($3ca1c7a287c9d841$var$_objectSpread($3ca1c7a287c9d841$var$_objectSpread({}, metadata), $3ca1c7a287c9d841$export$ea175c0c5497224(response)), {}, {
                            statusCode: response.status
                        }), _context2.t0 instanceof Error ? _context2.t0 : undefined);
                    case 9:
                    case "end":
                        return _context2.stop();
                }
            }, _callee2, null, [
                [
                    0,
                    6
                ]
            ]);
        }));
        return function(_x2) {
            return _ref6.apply(this, arguments);
        };
    }();
}
var $3ca1c7a287c9d841$export$fee2242cbb339663 = function defaultShouldRetryError(err) {
    var statusCode = $3ca1c7a287c9d841$var$getStatusCode(err);
    return $3ca1c7a287c9d841$export$ad8c5cf7dd4c3caf(err) || (statusCode ? statusCode >= 500 : false);
};
var $3ca1c7a287c9d841$export$c65cfa70960d8fe5 = {
    startTimeoutInMs: 1000,
    // 1 second is generally a good timeout to start
    maxAttempts: 5,
    // Current test delay is 60s, so retries should finish before if a promise takes < 1s
    factor: 2 // Good for polling, which is out main use case
};
function $3ca1c7a287c9d841$export$359f19ca51f9eba1(error, extraMetadata) {
    var reason = error.reason, metadata = error.metadata, innerError = error.innerError;
    return new (0, $7pWqR.RequestError)(reason, $3ca1c7a287c9d841$var$_objectSpread($3ca1c7a287c9d841$var$_objectSpread({}, metadata), extraMetadata), innerError);
}
function $3ca1c7a287c9d841$export$782df2acbe10b22c(_x3, _x4) {
    return $3ca1c7a287c9d841$var$_fetchRetry.apply(this, arguments);
}
function $3ca1c7a287c9d841$var$_fetchRetry() {
    $3ca1c7a287c9d841$var$_fetchRetry = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee4(functionToRetry, metadata) {
        var overwriteOptions, options, startTimeoutInMs, maxAttempts, factor, _options$shouldRetryE, shouldRetryError, attempts, timeoutInMs, lastError, waitAndBumpTimeout, _args4 = arguments;
        return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee4$(_context4) {
            while(true)switch(_context4.prev = _context4.next){
                case 0:
                    overwriteOptions = _args4.length > 2 && _args4[2] !== undefined ? _args4[2] : {};
                    options = $3ca1c7a287c9d841$var$_objectSpread($3ca1c7a287c9d841$var$_objectSpread({}, $3ca1c7a287c9d841$export$c65cfa70960d8fe5), overwriteOptions);
                    startTimeoutInMs = options.startTimeoutInMs, maxAttempts = options.maxAttempts, factor = options.factor, _options$shouldRetryE = options.shouldRetryError, shouldRetryError = _options$shouldRetryE === void 0 ? $3ca1c7a287c9d841$export$fee2242cbb339663 : _options$shouldRetryE;
                    attempts = 0;
                    timeoutInMs = startTimeoutInMs;
                    waitAndBumpTimeout = /*#__PURE__*/ function() {
                        var _ref7 = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee3() {
                            return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee3$(_context3) {
                                while(true)switch(_context3.prev = _context3.next){
                                    case 0:
                                        _context3.next = 2;
                                        return $3ca1c7a287c9d841$export$80c51ea1e89203dd(timeoutInMs);
                                    case 2:
                                        timeoutInMs *= factor;
                                        attempts += 1;
                                    case 4:
                                    case "end":
                                        return _context3.stop();
                                }
                            }, _callee3);
                        }));
                        return function waitAndBumpTimeout() {
                            return _ref7.apply(this, arguments);
                        };
                    }();
                case 6:
                    if (!(attempts < maxAttempts)) {
                        _context4.next = 24;
                        break;
                    }
                    _context4.prev = 7;
                    _context4.next = 10;
                    return functionToRetry();
                case 10:
                    return _context4.abrupt("return", _context4.sent);
                case 13:
                    _context4.prev = 13;
                    _context4.t0 = _context4["catch"](7);
                    lastError = _context4.t0;
                    // don't retry if request was aborted by user
                    if (!$3ca1c7a287c9d841$export$de0b576cf7ce4a53(_context4.t0)) {
                        _context4.next = 18;
                        break;
                    }
                    throw new (0, $7pWqR.RequestError)('clientAbortedRequest', metadata, _context4.t0);
                case 18:
                    if (shouldRetryError(_context4.t0)) {
                        _context4.next = 20;
                        break;
                    }
                    throw _context4.t0;
                case 20:
                    _context4.next = 22;
                    return waitAndBumpTimeout();
                case 22:
                    _context4.next = 6;
                    break;
                case 24:
                    if (!(0, $7pWqR.isRequestError)(lastError)) {
                        _context4.next = 26;
                        break;
                    }
                    throw $3ca1c7a287c9d841$export$359f19ca51f9eba1(lastError, {
                        attempts: attempts,
                        clientExhaustedRetries: true
                    });
                case 26:
                    throw new (0, $7pWqR.RequestError)('serverUnexpectedError', $3ca1c7a287c9d841$var$_objectSpread($3ca1c7a287c9d841$var$_objectSpread({}, metadata), {}, {
                        attempts: attempts,
                        clientExhaustedRetries: true
                    }), lastError);
                case 27:
                case "end":
                    return _context4.stop();
            }
        }, _callee4, null, [
            [
                7,
                13
            ]
        ]);
    }));
    return $3ca1c7a287c9d841$var$_fetchRetry.apply(this, arguments);
}
function $3ca1c7a287c9d841$export$6397609af718d008(statusCode) {
    switch(statusCode){
        case 400:
            return 'serverBadRequest';
        case 401:
            return 'serverUnauthorized';
        case 403:
            return 'serverForbidden';
        case 404:
            return 'serverNotFound';
        case 422:
            return 'serverUnprocessableEntity';
        case 423:
            return 'serverEntityLocked';
        case 429:
            return 'serverRateLimited';
        case 500:
            return 'serverInternalError';
        case 502:
            return 'serverBadGateway';
        default:
            return 'serverUnexpectedError';
    }
}
function $3ca1c7a287c9d841$export$d171f49f6b4ddc33(metadata, response) {
    var statusCode = response.status;
    var reason = $3ca1c7a287c9d841$export$6397609af718d008(statusCode);
    return new (0, $7pWqR.RequestError)(reason, $3ca1c7a287c9d841$var$_objectSpread($3ca1c7a287c9d841$var$_objectSpread($3ca1c7a287c9d841$var$_objectSpread({}, metadata), $3ca1c7a287c9d841$export$ea175c0c5497224(response)), {}, {
        statusCode: statusCode
    }));
}
function $3ca1c7a287c9d841$export$6e2e477edb7d6032(metadata) {
    return function(response) {
        if (response.ok || response.status < 400) return response;
        var requestError = $3ca1c7a287c9d841$export$d171f49f6b4ddc33(metadata, response);
        throw requestError;
    };
}
function $3ca1c7a287c9d841$export$ea175c0c5497224(response) {
    var headers = response.headers;
    var mediaRegion = headers.get('x-media-region') || 'unknown';
    var mediaEnv = headers.get('x-media-env') || 'unknown';
    return {
        mediaRegion: mediaRegion,
        mediaEnv: mediaEnv
    };
}

});
parcelRegister("bVaC0", function(module, exports) {
$parcel$export(module.exports, "isUndefined", () => $8add3fe532423e8e$export$fce6876652108ab);
$parcel$export(module.exports, "omitBy", () => $8add3fe532423e8e$export$d7a617dda645b4e3);
$parcel$export(module.exports, "getRandomTelemetryId", () => $8add3fe532423e8e$export$2e36de8639bad0ad);

var $fC8ib = parcelRequire("fC8ib");

var $iYJcE = parcelRequire("iYJcE");
var $8add3fe532423e8e$export$fce6876652108ab = function isUndefined(value) {
    return value === undefined;
};
var $8add3fe532423e8e$export$357523c63a2253b9 = function pick(obj) {
    var keys = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    if (obj === undefined) return {};
    return Object.fromEntries(Object.entries(obj).filter(function(_ref) {
        var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_ref, 1), k = _ref2[0];
        return keys.includes(k);
    }));
};
var $8add3fe532423e8e$export$d7a617dda645b4e3 = function omitBy(obj, predicate) {
    return Object.fromEntries(Object.entries(obj).filter(function(_ref3) {
        var _ref4 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_ref3, 2), v = _ref4[1];
        return !predicate(v);
    }));
};
var $8add3fe532423e8e$export$61fc7d43ac8f84b0 = function debounce(func, wait) {
    var timeout;
    return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        clearTimeout(timeout);
        timeout = setTimeout(function() {
            return func.apply(void 0, args);
        }, wait);
    };
};
var $8add3fe532423e8e$export$de994efd351b291c = function matches(srcObj) {
    return function(obj) {
        var key;
        for(key in srcObj){
            if (obj[key] === undefined || obj[key] !== srcObj[key]) return false;
        }
        return true;
    };
};
function $8add3fe532423e8e$var$getRandomHexValues(byte) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(Array(byte * 2)).map(function() {
        return Math.floor(Math.random() * 16).toString(16);
    }).join('');
}
function $8add3fe532423e8e$export$456b25e3a9b4a843(byte) {
    var _window;
    var randomHex;
    if ((_window = window) !== null && _window !== void 0 && _window.crypto) try {
        randomHex = Array.from(window.crypto.getRandomValues(new Uint8Array(byte))).map(function(b) {
            return b.toString(16).padStart(2, '0');
        }).join('');
    } catch (e) {
        randomHex = $8add3fe532423e8e$var$getRandomHexValues(byte);
    }
    else randomHex = $8add3fe532423e8e$var$getRandomHexValues(byte);
    return randomHex;
}
function $8add3fe532423e8e$export$2e36de8639bad0ad() {
    return $8add3fe532423e8e$export$456b25e3a9b4a843(8);
}

});

parcelRegister("a8AqD", function(module, exports) {
$parcel$export(module.exports, "mapAuthToQueryParameters", () => $7616e8b55e60c6e0$export$6833b130611df767);
parcelRequire("l7fRX");
var $pDaXe = parcelRequire("pDaXe");
function $7616e8b55e60c6e0$export$6833b130611df767(auth) {
    if ((0, $pDaXe.isClientBasedAuth)(auth)) return {
        client: auth.clientId,
        token: auth.token
    };
    else return {
        issuer: auth.asapIssuer,
        token: auth.token
    };
}

});


parcelRegister("5seSP", function(module, exports) {
$parcel$export(module.exports, "default", () => $3f8b1cc8d4d8b9be$export$2e2bcd8739ae039);
var $3f8b1cc8d4d8b9be$export$2e2bcd8739ae039 = function() {
    if (typeof window === 'undefined') return;
    if (typeof window.navigator === 'undefined') return;
    return window.navigator;
};

});


parcelRegister("evRBH", function(module, exports) {
$parcel$export(module.exports, "resolveAuth", () => $a90d8b31b92bdfaa$export$4b4cec3dcdfce972);
$parcel$export(module.exports, "resolveInitialAuth", () => $a90d8b31b92bdfaa$export$5211e1371264aec3);

var $fL8KA = parcelRequire("fL8KA");

var $6HG4S = parcelRequire("6HG4S");

var $42X0n = parcelRequire("42X0n");

var $2R74t = parcelRequire("2R74t");
var $a90d8b31b92bdfaa$export$560085fe411c0660 = 10000;
var $a90d8b31b92bdfaa$export$4b4cec3dcdfce972 = /*#__PURE__*/ function() {
    var _ref = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee(authProvider, authContext) {
        var authProviderTimeout, auth, _args = arguments;
        return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee$(_context) {
            while(true)switch(_context.prev = _context.next){
                case 0:
                    authProviderTimeout = _args.length > 2 && _args[2] !== undefined ? _args[2] : $a90d8b31b92bdfaa$export$560085fe411c0660;
                    _context.prev = 1;
                    _context.next = 4;
                    return Promise.race([
                        authProvider(authContext),
                        (0, $2R74t.rejectTimeout)(authProviderTimeout, new (0, $42X0n.MediaStoreError)('authProviderTimedOut'))
                    ]);
                case 4:
                    auth = _context.sent;
                    _context.next = 12;
                    break;
                case 7:
                    _context.prev = 7;
                    _context.t0 = _context["catch"](1);
                    if (!(_context.t0 instanceof (0, $42X0n.MediaStoreError))) {
                        _context.next = 11;
                        break;
                    }
                    throw _context.t0;
                case 11:
                    throw new (0, $42X0n.MediaStoreError)('failedAuthProvider', _context.t0 instanceof Error ? _context.t0 : undefined);
                case 12:
                    if (auth) {
                        _context.next = 14;
                        break;
                    }
                    throw new (0, $42X0n.MediaStoreError)('emptyAuth');
                case 14:
                    return _context.abrupt("return", auth);
                case 15:
                case "end":
                    return _context.stop();
            }
        }, _callee, null, [
            [
                1,
                7
            ]
        ]);
    }));
    return function resolveAuth(_x, _x2) {
        return _ref.apply(this, arguments);
    };
}();
var $a90d8b31b92bdfaa$export$5211e1371264aec3 = function resolveInitialAuth(auth) {
    if (!auth) throw new (0, $42X0n.MediaStoreError)('missingInitialAuth');
    return auth;
};

});
parcelRegister("42X0n", function(module, exports) {
$parcel$export(module.exports, "MediaStoreError", () => $2f251e8119521fcb$export$b78480bd311630bc);

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $kIXpt = parcelRequire("kIXpt");

var $cYPzS = parcelRequire("cYPzS");

var $eyuDe = parcelRequire("eyuDe");

var $8eaz3 = parcelRequire("8eaz3");
function $2f251e8119521fcb$var$_callSuper(t, o, e) {
    return o = (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(o), (0, (/*@__PURE__*/$parcel$interopDefault($kIXpt)))(t, $2f251e8119521fcb$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(t).constructor) : o.apply(t, e));
}
function $2f251e8119521fcb$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($2f251e8119521fcb$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $2f251e8119521fcb$export$b78480bd311630bc = /*#__PURE__*/ function(_BaseMediaClientError) {
    function MediaStoreError(reason, innerError) {
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, MediaStoreError);
        return $2f251e8119521fcb$var$_callSuper(this, MediaStoreError, [
            reason,
            undefined,
            innerError
        ]);
    }
    // TODO: Deprecate this getter https://product-fabric.atlassian.net/browse/CXP-4665
    /** Will be deprecated. Use the properties `reason` and `metadata` instead */ (0, (/*@__PURE__*/$parcel$interopDefault($eyuDe)))(MediaStoreError, _BaseMediaClientError);
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(MediaStoreError, [
        {
            key: "attributes",
            get: function get() {
                var reason = this.reason, innerError = this.innerError;
                return {
                    reason: reason,
                    innerError: innerError
                };
            }
        }
    ]);
}((0, $8eaz3.BaseMediaClientError));
function $2f251e8119521fcb$export$8d2a9b675b2ce37a(err) {
    return err instanceof $2f251e8119521fcb$export$b78480bd311630bc;
}

});

parcelRegister("2R74t", function(module, exports) {
$parcel$export(module.exports, "rejectTimeout", () => $2146042fee7b8c0f$export$cf2d2a1124beacb2);
var $2146042fee7b8c0f$export$c30e7cea8bbec3c0 = function resolveTimeout(timeout, resolveWith) {
    return new Promise(function(resolve, _reject) {
        setTimeout(resolve, timeout, resolveWith);
    });
};
var $2146042fee7b8c0f$export$cf2d2a1124beacb2 = function rejectTimeout(timeout, rejectWith) {
    return new Promise(function(_resolve, reject) {
        setTimeout(reject, timeout, rejectWith);
    });
};

});



parcelRegister("8aYdd", function(module, exports) {
$parcel$export(module.exports, "FileFetcherImpl", () => $5f3df6c6603d1476$export$fe17eabf77aabacb);
$parcel$export(module.exports, "FileFetcherError", () => (parcelRequire("f8kvj")).FileFetcherError);

var $fL8KA = parcelRequire("fL8KA");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $25nEq = parcelRequire("25nEq");

var $6HG4S = parcelRequire("6HG4S");

var $lSgto = parcelRequire("lSgto");

var $blmL7 = parcelRequire("blmL7");

var $6JfQX = parcelRequire("6JfQX");
parcelRequire("l7fRX");
var $pDaXe = parcelRequire("pDaXe");

var $g7x2h = parcelRequire("g7x2h");

var $ad5sk = parcelRequire("ad5sk");

var $eBhvj = parcelRequire("eBhvj");

var $j9G0f = parcelRequire("j9G0f");

var $f8kvj = parcelRequire("f8kvj");

var $aaWoP = parcelRequire("aaWoP");

var $L8Ev2 = parcelRequire("L8Ev2");

var $iOlVT = parcelRequire("iOlVT");

var $cSavz = parcelRequire("cSavz");

var $j42Kg = parcelRequire("j42Kg");

var $9ilbX = parcelRequire("9ilbX");

var $dWcZd = parcelRequire("dWcZd");

var $kwu4A = parcelRequire("kwu4A");

var $deN8P = parcelRequire("deN8P");

var $hs0Ss = parcelRequire("hs0Ss");
var $7zwAj = parcelRequire("7zwAj");

var $9uFR7 = parcelRequire("9uFR7");

var $d9Gbq = parcelRequire("d9Gbq");

var $7VCF9 = parcelRequire("7VCF9");

var $bjt5J = parcelRequire("bjt5J");

var $1cqUo = parcelRequire("1cqUo");

var $e7FZ3 = parcelRequire("e7FZ3");
parcelRequire("b6O22");
var $bhF0L = parcelRequire("bhF0L");

var $6T1Sj = parcelRequire("6T1Sj");

var $5cK21 = parcelRequire("5cK21");

var $8eaz3 = parcelRequire("8eaz3");
function $5f3df6c6603d1476$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $5f3df6c6603d1476$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $5f3df6c6603d1476$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $5f3df6c6603d1476$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $5f3df6c6603d1476$var$isCopySourceFileWithToken = function isCopySourceFileWithToken(token) {
    return !!token.authProvider;
};
var $5f3df6c6603d1476$var$isCopyDestinationWithToken = function isCopyDestinationWithToken(token) {
    return !!token.authProvider;
};
var $5f3df6c6603d1476$export$fe17eabf77aabacb = /*#__PURE__*/ function() {
    function FileFetcherImpl(mediaApi) {
        var _this = this;
        var store = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (0, $bhF0L.mediaStore);
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, FileFetcherImpl);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "getErrorFileState", function(error, id, occurrenceKey) {
            if ((0, $8eaz3.isCommonMediaClientError)(error)) return (0, $8eaz3.fromCommonMediaClientError)(id, occurrenceKey, error);
            // ________________________________________________
            // Legacy serializers
            // We need to revisit all the incoming error types and ensure all the "reason" values are known
            // We need to change the input error: any for a known type.
            if (typeof error === 'string') {
                var err = new (0, $8eaz3.CommonMediaClientError)(error);
                return (0, $8eaz3.fromCommonMediaClientError)(id, occurrenceKey, err);
            } else {
                var _err2 = new (0, $8eaz3.CommonMediaClientError)((error === null || error === void 0 ? void 0 : error.reason) || 'unknown', error === null || error === void 0 ? void 0 : error.metadata, error === null || error === void 0 ? void 0 : error.innerError);
                return (0, $8eaz3.fromCommonMediaClientError)(id, occurrenceKey, _err2);
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "setFileState", function(id, fileState) {
            _this.store.setState(function(state) {
                state.files[id] = fileState;
            });
        });
        // TODO: ----- ADD TICKET TO PASS TRACE ID to this.dataloader.load
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "createDownloadFileStream", function(id, collectionName, occurrenceKey, includeHashForDuplicateFiles, forceRefresh) {
            var subject = (0, $d9Gbq.createMediaSubject)();
            var poll = new (0, $1cqUo.PollingFunction)();
            // ensure subject errors if polling exceeds max iterations or uncaught exception in executor
            poll.onError = function(error) {
                return subject.error(error);
            };
            poll.execute(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee() {
                var response, fileState;
                return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee$(_context) {
                    while(true)switch(_context.prev = _context.next){
                        case 0:
                            if (forceRefresh) _this.dataloader.clear({
                                id: id,
                                collectionName: collectionName,
                                includeHashForDuplicateFiles: includeHashForDuplicateFiles
                            });
                            _context.next = 3;
                            return _this.dataloader.load({
                                id: id,
                                collectionName: collectionName,
                                includeHashForDuplicateFiles: includeHashForDuplicateFiles
                            });
                        case 3:
                            response = _context.sent;
                            if (!(0, $j9G0f.isNotFoundMediaItemDetails)(response)) {
                                _context.next = 6;
                                break;
                            }
                            throw new (0, $f8kvj.FileFetcherError)('emptyItems', {
                                id: id,
                                collectionName: collectionName,
                                occurrenceKey: occurrenceKey,
                                traceContext: response.metadataTraceContext
                            });
                        case 6:
                            if (!(0, $e7FZ3.isEmptyFile)(response)) {
                                _context.next = 8;
                                break;
                            }
                            throw new (0, $f8kvj.FileFetcherError)('zeroVersionFile', {
                                id: id,
                                collectionName: collectionName,
                                occurrenceKey: occurrenceKey,
                                traceContext: response.metadataTraceContext
                            });
                        case 8:
                            fileState = (0, $eBhvj.mapMediaItemToFileState)(id, response);
                            subject.next(fileState);
                            _context.t0 = fileState.status;
                            _context.next = _context.t0 === 'processing' ? 13 : _context.t0 === 'processed' ? 15 : 17;
                            break;
                        case 13:
                            // the only case for continuing polling, otherwise this function is run once only
                            poll.next();
                            return _context.abrupt("break", 17);
                        case 15:
                            subject.complete();
                            return _context.abrupt("break", 17);
                        case 17:
                        case "end":
                            return _context.stop();
                    }
                }, _callee);
            })));
            return subject;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "getUploadingFileStateBase", function(file, upfrontId) {
            // TODO: DO not modify the input parameter 'content' attribute
            if (typeof file.content === 'string') file.content = (0, $deN8P.convertBase64ToBlob)(file.content);
            var content = file.content, _file$name = file.name, name = _file$name === void 0 ? '' : _file$name;
            var id = upfrontId.id, occurrenceKey = upfrontId.occurrenceKey;
            var preview;
            // TODO [MSW-796]: get file size for base64
            var size = 0;
            var mimeType = '';
            if (content instanceof Blob) {
                size = content.size;
                mimeType = content.type;
                preview = {
                    value: content,
                    origin: 'local'
                };
            }
            var mediaType = (0, $dWcZd.getMediaTypeFromUploadableFile)(file);
            return {
                id: id,
                occurrenceKey: occurrenceKey,
                name: name,
                size: size,
                mediaType: mediaType,
                mimeType: mimeType,
                preview: preview
            };
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "uploadArtifact", /*#__PURE__*/ function() {
            var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee2(id, file, params, collectionName, traceContext) {
                var _yield$_this$mediaApi, data, _yield$_this$mediaApi2, altData, itemDetails;
                return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee2$(_context2) {
                    while(true)switch(_context2.prev = _context2.next){
                        case 0:
                            _context2.next = 2;
                            return _this.mediaApi.uploadArtifact(id, file, params, collectionName, traceContext);
                        case 2:
                            _yield$_this$mediaApi = _context2.sent;
                            data = _yield$_this$mediaApi.data;
                            _context2.next = 6;
                            return _this.mediaApi.getItems([
                                id
                            ], collectionName, traceContext);
                        case 6:
                            _yield$_this$mediaApi2 = _context2.sent;
                            altData = _yield$_this$mediaApi2.data;
                            itemDetails = altData.items[0].details; // ------------------------------------------------------------
                            _this.setFileState(id, (0, $eBhvj.mapMediaItemToFileState)(id, itemDetails));
                            return _context2.abrupt("return", data);
                        case 11:
                        case "end":
                            return _context2.stop();
                    }
                }, _callee2);
            }));
            return function(_x, _x2, _x3, _x4, _x5) {
                return _ref2.apply(this, arguments);
            };
        }());
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "deleteArtifact", /*#__PURE__*/ function() {
            var _ref3 = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee3(id, artifactName, collectionName, traceContext) {
                var file, updatedArtifacts, updatedFileState;
                return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee3$(_context3) {
                    while(true)switch(_context3.prev = _context3.next){
                        case 0:
                            _context3.next = 2;
                            return _this.mediaApi.deleteArtifact(id, artifactName, collectionName, traceContext);
                        case 2:
                            // Manually remove the artifact from file state instead of re-requesting the entire payload.
                            file = _this.store.getState().files[id];
                            if (file && file.status === 'processed' && file.artifacts) {
                                updatedArtifacts = $5f3df6c6603d1476$var$_objectSpread({}, file.artifacts);
                                delete updatedArtifacts[artifactName];
                                updatedFileState = $5f3df6c6603d1476$var$_objectSpread($5f3df6c6603d1476$var$_objectSpread({}, file), {}, {
                                    artifacts: updatedArtifacts
                                });
                                _this.setFileState(id, updatedFileState);
                            }
                        case 4:
                        case "end":
                            return _context3.stop();
                    }
                }, _callee3);
            }));
            return function(_x6, _x7, _x8, _x9) {
                return _ref3.apply(this, arguments);
            };
        }());
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "getOrFetchFileState", /*#__PURE__*/ function() {
            var _ref4 = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee4(id, collectionName) {
                var fileState;
                return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee4$(_context4) {
                    while(true)switch(_context4.prev = _context4.next){
                        case 0:
                            fileState = _this.store.getState().files[id];
                            if (!(fileState !== null && fileState !== void 0)) {
                                _context4.next = 5;
                                break;
                            }
                            _context4.t0 = fileState;
                            _context4.next = 8;
                            break;
                        case 5:
                            _context4.next = 7;
                            return _this.getCurrentState(id, {
                                collectionName: collectionName
                            });
                        case 7:
                            _context4.t0 = _context4.sent;
                        case 8:
                            return _context4.abrupt("return", _context4.t0);
                        case 9:
                        case "end":
                            return _context4.stop();
                    }
                }, _callee4);
            }));
            return function(_x0, _x1) {
                return _ref4.apply(this, arguments);
            };
        }());
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "getDurationOfVideo", /*#__PURE__*/ function() {
            var _ref5 = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee5(id, collectionName) {
                var _fileState$mediaMetad;
                var fileState, artifactUrlString, artifactUrl, artifactPath, res, arrayBuffer, uint8Array, mvhdBytes, mvhdIndex, i, j, dataView, start, timeScale, duration, videoLength;
                return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee5$(_context5) {
                    while(true)switch(_context5.prev = _context5.next){
                        case 0:
                            _context5.next = 2;
                            return _this.getOrFetchFileState(id, collectionName);
                        case 2:
                            fileState = _context5.sent;
                            if (!(fileState.status !== 'processed' || fileState.mediaType !== 'video' || !fileState.artifacts['video.mp4'])) {
                                _context5.next = 5;
                                break;
                            }
                            throw new Error('File is not a video');
                        case 5:
                            if (!('mediaMetadata' in fileState && (_fileState$mediaMetad = fileState.mediaMetadata) !== null && _fileState$mediaMetad !== void 0 && _fileState$mediaMetad.duration)) {
                                _context5.next = 7;
                                break;
                            }
                            return _context5.abrupt("return", fileState.mediaMetadata.duration);
                        case 7:
                            _context5.next = 9;
                            return _this.getArtifactURL(fileState.artifacts, 'video.mp4', collectionName);
                        case 9:
                            artifactUrlString = _context5.sent;
                            artifactUrl = new URL(artifactUrlString);
                            artifactPath = "".concat(artifactUrl.pathname).concat(artifactUrl.search);
                            _context5.next = 14;
                            return _this.mediaApi.request(artifactPath, {
                                headers: {
                                    Range: 'bytes=0-199'
                                }
                            });
                        case 14:
                            res = _context5.sent;
                            _context5.next = 17;
                            return res.arrayBuffer();
                        case 17:
                            arrayBuffer = _context5.sent;
                            uint8Array = new Uint8Array(arrayBuffer);
                            mvhdBytes = new Uint8Array([
                                109,
                                118,
                                104,
                                100
                            ]); // "mvhd" in ASCII
                            mvhdIndex = -1;
                            i = 0;
                        case 22:
                            if (!(i <= uint8Array.length - mvhdBytes.length)) {
                                _context5.next = 37;
                                break;
                            }
                            mvhdIndex = i;
                            j = 0;
                        case 25:
                            if (!(j < mvhdBytes.length)) {
                                _context5.next = 32;
                                break;
                            }
                            if (!(uint8Array[i + j] !== mvhdBytes[j])) {
                                _context5.next = 29;
                                break;
                            }
                            mvhdIndex = -1;
                            return _context5.abrupt("break", 32);
                        case 29:
                            j++;
                            _context5.next = 25;
                            break;
                        case 32:
                            if (!(mvhdIndex !== -1)) {
                                _context5.next = 34;
                                break;
                            }
                            return _context5.abrupt("break", 37);
                        case 34:
                            i++;
                            _context5.next = 22;
                            break;
                        case 37:
                            if (!(mvhdIndex === -1)) {
                                _context5.next = 39;
                                break;
                            }
                            throw new Error('Unable to find mvhd bytes');
                        case 39:
                            // Create DataView for reading big-endian integers
                            dataView = new DataView(arrayBuffer);
                            start = mvhdIndex + 16; // Skip atom header and version/flags
                            // Check if we have enough bytes to read timescale and duration
                            if (!(start + 8 > arrayBuffer.byteLength)) {
                                _context5.next = 43;
                                break;
                            }
                            return _context5.abrupt("return", 0);
                        case 43:
                            // flase as second parameter indicates big-endian 32-bit integers
                            timeScale = dataView.getUint32(start, false);
                            duration = dataView.getUint32(start + 4, false);
                            if (!(timeScale === 0)) {
                                _context5.next = 47;
                                break;
                            }
                            throw new Error('Timescale is invalid');
                        case 47:
                            // get the video length in seconds
                            videoLength = Math.floor(duration / timeScale);
                            return _context5.abrupt("return", videoLength);
                        case 49:
                        case "end":
                            return _context5.stop();
                    }
                }, _callee5);
            }));
            return function(_x10, _x11) {
                return _ref5.apply(this, arguments);
            };
        }());
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "getVideoDurations", /*#__PURE__*/ function() {
            var _ref6 = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee7(files) {
                var promises, durations;
                return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee7$(_context7) {
                    while(true)switch(_context7.prev = _context7.next){
                        case 0:
                            // get all the duration promises
                            promises = files.map(/*#__PURE__*/ function() {
                                var _ref8 = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee6(_ref7) {
                                    var id, collectionName;
                                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee6$(_context6) {
                                        while(true)switch(_context6.prev = _context6.next){
                                            case 0:
                                                id = _ref7.id, collectionName = _ref7.collectionName;
                                                _context6.prev = 1;
                                                _context6.next = 4;
                                                return _this.getDurationOfVideo(id, collectionName);
                                            case 4:
                                                return _context6.abrupt("return", _context6.sent);
                                            case 7:
                                                _context6.prev = 7;
                                                _context6.t0 = _context6["catch"](1);
                                                return _context6.abrupt("return", -1);
                                            case 10:
                                            case "end":
                                                return _context6.stop();
                                        }
                                    }, _callee6, null, [
                                        [
                                            1,
                                            7
                                        ]
                                    ]);
                                }));
                                return function(_x13) {
                                    return _ref8.apply(this, arguments);
                                };
                            }());
                            _context7.next = 3;
                            return Promise.all(promises);
                        case 3:
                            durations = _context7.sent;
                            return _context7.abrupt("return", durations.reduce(function(acc, curr, i) {
                                if (curr !== -1) {
                                    var _id = files[i].id;
                                    acc[_id] = curr;
                                }
                                return acc;
                            }, {}));
                        case 5:
                        case "end":
                            return _context7.stop();
                    }
                }, _callee7);
            }));
            return function(_x12) {
                return _ref6.apply(this, arguments);
            };
        }());
        this.mediaApi = mediaApi;
        this.store = store;
        this.dataloader = (0, $9ilbX.createFileDataloader)(mediaApi);
        this.copyIntentRegisterationBatcher = (0, $6T1Sj.createCopyIntentRegisterationBatcher)(mediaApi);
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(FileFetcherImpl, [
        {
            key: "getFileState",
            value: function getFileState(id) {
                var _this2 = this;
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var collectionName = options.collectionName, occurrenceKey = options.occurrenceKey, includeHashForDuplicateFiles = options.includeHashForDuplicateFiles, forceRefresh = options.forceRefresh;
                if (!(0, (/*@__PURE__*/$parcel$interopDefault($j42Kg)))(id)) {
                    var subject = (0, $d9Gbq.createMediaSubject)();
                    var err = new (0, $f8kvj.FileFetcherError)('invalidFileId', {
                        id: id,
                        collectionName: collectionName,
                        occurrenceKey: occurrenceKey
                    });
                    var errorFileState = this.getErrorFileState(err, id, occurrenceKey);
                    subject.error(err);
                    this.setFileState(id, errorFileState);
                    return (0, $hs0Ss.fromObservable)(subject);
                }
                if (forceRefresh) (0, $L8Ev2.getFileStreamsCache)().remove(id);
                return (0, $hs0Ss.fromObservable)((0, $L8Ev2.getFileStreamsCache)().getOrInsert(id, function() {
                    var subject = _this2.createDownloadFileStream(id, collectionName, undefined, includeHashForDuplicateFiles, forceRefresh);
                    subject.subscribe({
                        next: function next(fileState) {
                            _this2.setFileState(id, fileState);
                        },
                        error: function error(err) {
                            var errorFileState = _this2.getErrorFileState(err, id, occurrenceKey);
                            _this2.setFileState(id, errorFileState);
                        }
                    });
                    return subject;
                }));
            }
        },
        {
            key: "getCurrentState",
            value: function getCurrentState(id, options) {
                return (0, $7zwAj.toPromise)(this.getFileState(id, options));
            }
        },
        {
            key: "getArtifactURL",
            value: function getArtifactURL(artifacts, artifactName, collectionName) {
                return this.mediaApi.getArtifactURL(artifacts, artifactName, collectionName);
            }
        },
        {
            key: "getFileBinaryURL",
            value: function getFileBinaryURL(id, collectionName, maxAge) {
                return this.mediaApi.getFileBinaryURL(id, collectionName, maxAge);
            }
        },
        {
            key: "touchFiles",
            value: function touchFiles(descriptors, collection, traceContext) {
                return this.mediaApi.touchFiles({
                    descriptors: descriptors
                }, {
                    collection: collection
                }, traceContext).then(function(_ref9) {
                    var data = _ref9.data;
                    return data;
                });
            }
        },
        {
            key: "generateUploadableFileUpfrontIds",
            value: function generateUploadableFileUpfrontIds(collection, traceContext) {
                // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
                var id = (0, $6JfQX.default)();
                // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
                var occurrenceKey = (0, $6JfQX.default)();
                var touchFileDescriptor = {
                    fileId: id,
                    occurrenceKey: occurrenceKey,
                    collection: collection
                };
                var deferredUploadId = this.touchFiles([
                    touchFileDescriptor
                ], collection, traceContext).then(function(touchedFiles) {
                    return touchedFiles.created[0].uploadId;
                });
                return {
                    id: id,
                    occurrenceKey: occurrenceKey,
                    deferredUploadId: deferredUploadId
                };
            }
        },
        {
            key: "uploadExternal",
            value: function() {
                var _uploadExternal = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee0(url, collection, traceContext) {
                    var _this3 = this;
                    var uploadableFileUpfrontIds, id, occurrenceKey, subject, deferredBlob, preview, name, fileState;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee0$(_context0) {
                        while(true)switch(_context0.prev = _context0.next){
                            case 0:
                                uploadableFileUpfrontIds = this.generateUploadableFileUpfrontIds(collection, traceContext);
                                id = uploadableFileUpfrontIds.id, occurrenceKey = uploadableFileUpfrontIds.occurrenceKey;
                                subject = (0, $d9Gbq.createMediaSubject)();
                                deferredBlob = fetch(url).then(function(response) {
                                    return response.blob();
                                }).catch(function() {
                                    return undefined;
                                });
                                preview = new Promise(/*#__PURE__*/ function() {
                                    var _ref0 = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee8(resolve, reject) {
                                        var blob;
                                        return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee8$(_context8) {
                                            while(true)switch(_context8.prev = _context8.next){
                                                case 0:
                                                    _context8.next = 2;
                                                    return deferredBlob;
                                                case 2:
                                                    blob = _context8.sent;
                                                    if (!blob) reject('Could not fetch the blob');
                                                    resolve({
                                                        value: blob,
                                                        origin: 'remote'
                                                    });
                                                case 5:
                                                case "end":
                                                    return _context8.stop();
                                            }
                                        }, _callee8);
                                    }));
                                    return function(_x17, _x18) {
                                        return _ref0.apply(this, arguments);
                                    };
                                }());
                                name = url.split('/').pop() || ''; // we create a initial fileState with the minimum info that we have at this point
                                fileState = {
                                    status: 'processing',
                                    name: name,
                                    size: 0,
                                    mediaType: 'unknown',
                                    mimeType: '',
                                    id: id,
                                    occurrenceKey: occurrenceKey,
                                    preview: preview
                                };
                                subject.next(fileState);
                                // we save it into the cache as soon as possible, in case someone subscribes
                                (0, $L8Ev2.getFileStreamsCache)().set(id, subject);
                                this.setFileState(id, fileState);
                                return _context0.abrupt("return", new Promise(/*#__PURE__*/ function() {
                                    var _ref1 = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee9(resolve, reject) {
                                        var blob, type, size, file, mediaType, dimensions;
                                        return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee9$(_context9) {
                                            while(true)switch(_context9.prev = _context9.next){
                                                case 0:
                                                    _context9.next = 2;
                                                    return deferredBlob;
                                                case 2:
                                                    blob = _context9.sent;
                                                    if (blob) {
                                                        _context9.next = 5;
                                                        break;
                                                    }
                                                    return _context9.abrupt("return", reject('Could not download remote file'));
                                                case 5:
                                                    type = blob.type, size = blob.size;
                                                    file = {
                                                        content: blob,
                                                        mimeType: type,
                                                        collection: collection,
                                                        name: name,
                                                        size: size
                                                    };
                                                    mediaType = (0, $7VCF9.getMediaTypeFromMimeType)(type); // we emit a richer state after the blob is fetched
                                                    subject.next({
                                                        status: 'processing',
                                                        name: name,
                                                        size: size,
                                                        mediaType: mediaType,
                                                        mimeType: type,
                                                        id: id,
                                                        occurrenceKey: occurrenceKey,
                                                        preview: preview
                                                    });
                                                    // we don't want to wait for the file to be upload
                                                    _this3.upload(file, undefined, uploadableFileUpfrontIds, traceContext);
                                                    _context9.prev = 10;
                                                    _context9.next = 13;
                                                    return (0, $9uFR7.getDimensionsFromBlob)(mediaType, blob);
                                                case 13:
                                                    dimensions = _context9.sent;
                                                    _context9.next = 20;
                                                    break;
                                                case 16:
                                                    _context9.prev = 16;
                                                    _context9.t0 = _context9["catch"](10);
                                                    reject(_context9.t0);
                                                    return _context9.abrupt("return");
                                                case 20:
                                                    resolve({
                                                        dimensions: dimensions,
                                                        mimeType: type,
                                                        uploadableFileUpfrontIds: uploadableFileUpfrontIds
                                                    });
                                                case 21:
                                                case "end":
                                                    return _context9.stop();
                                            }
                                        }, _callee9, null, [
                                            [
                                                10,
                                                16
                                            ]
                                        ]);
                                    }));
                                    return function(_x19, _x20) {
                                        return _ref1.apply(this, arguments);
                                    };
                                }()));
                            case 11:
                            case "end":
                                return _context0.stop();
                        }
                    }, _callee0, this);
                }));
                function uploadExternal(_x14, _x15, _x16) {
                    return _uploadExternal.apply(this, arguments);
                }
                return uploadExternal;
            }()
        },
        {
            key: "upload",
            value: function upload(file, controller, uploadableFileUpfrontIds, traceContext) {
                var _this4 = this;
                var collection = file.collection;
                var upfrontId = uploadableFileUpfrontIds || this.generateUploadableFileUpfrontIds(collection, traceContext);
                var id = upfrontId.id, occurrenceKey = upfrontId.occurrenceKey;
                var stateBase = this.getUploadingFileStateBase(file, upfrontId);
                var subject = (0, $d9Gbq.createMediaSubject)();
                (0, $L8Ev2.getFileStreamsCache)().set(id, subject);
                var onProgress = function onProgress(progress) {
                    var fileState = $5f3df6c6603d1476$var$_objectSpread($5f3df6c6603d1476$var$_objectSpread({
                        status: 'uploading'
                    }, stateBase), {}, {
                        progress: progress
                    });
                    subject.next(fileState);
                    _this4.setFileState(id, fileState);
                };
                var processingSubscription = new (0, $lSgto.Subscription)();
                var onUploadFinish = function onUploadFinish(error) {
                    if (error) {
                        var errorFileState = _this4.getErrorFileState(error, id, occurrenceKey);
                        _this4.setFileState(id, errorFileState);
                        return subject.error(error);
                    }
                    processingSubscription = _this4.createDownloadFileStream(id, collection, occurrenceKey).pipe((0, $blmL7.map)(function(remoteFileState) {
                        return $5f3df6c6603d1476$var$_objectSpread($5f3df6c6603d1476$var$_objectSpread($5f3df6c6603d1476$var$_objectSpread({}, stateBase), remoteFileState), (0, $kwu4A.overrideMediaTypeIfUnknown)(remoteFileState, stateBase.mediaType));
                    })).subscribe({
                        next: function next(fileState) {
                            subject.next(fileState);
                            _this4.setFileState(id, fileState);
                        },
                        error: function error(err) {
                            var errorFileState = _this4.getErrorFileState(err, id, occurrenceKey);
                            subject.error(err);
                            _this4.setFileState(id, errorFileState);
                        },
                        complete: subject.complete
                    });
                };
                var _uploadFile = (0, $aaWoP.uploadFile)(file, this.mediaApi, upfrontId, {
                    onUploadFinish: onUploadFinish,
                    onProgress: onProgress
                }, traceContext), cancel = _uploadFile.cancel;
                controller === null || controller === void 0 || controller.setAbort(function() {
                    cancel();
                    // TODO: filestate should turn to "Aborted" or something.
                    // Consider canceling an upload that is already finished
                    processingSubscription.unsubscribe();
                });
                // We should report progress asynchronously, since this is what consumer expects
                // (otherwise in newUploadService file-converting event will be emitted before files-added)
                setTimeout(onProgress, 0, 0);
                return (0, $hs0Ss.fromObservable)(subject);
            }
        },
        {
            key: "downloadBinary",
            value: function() {
                var _downloadBinary = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee1(id) {
                    var name, collectionName, traceContext, url, _args1 = arguments;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee1$(_context1) {
                        while(true)switch(_context1.prev = _context1.next){
                            case 0:
                                name = _args1.length > 1 && _args1[1] !== undefined ? _args1[1] : 'download';
                                collectionName = _args1.length > 2 ? _args1[2] : undefined;
                                traceContext = _args1.length > 3 ? _args1[3] : undefined;
                                _context1.next = 5;
                                return this.mediaApi.getFileBinaryURL(id, collectionName);
                            case 5:
                                url = _context1.sent;
                                (0, $g7x2h.downloadUrl)(url, {
                                    name: name
                                });
                                (0, $iOlVT.globalMediaEventEmitter).emit('media-viewed', {
                                    fileId: id,
                                    isUserCollection: collectionName === (0, $cSavz.RECENTS_COLLECTION),
                                    viewingLevel: 'download'
                                });
                                // Test the download after initiated the Browser process to catch any potential errors.
                                _context1.next = 10;
                                return this.mediaApi.testUrl(url, {
                                    traceContext: traceContext
                                });
                            case 10:
                            case "end":
                                return _context1.stop();
                        }
                    }, _callee1, this);
                }));
                function downloadBinary(_x21) {
                    return _downloadBinary.apply(this, arguments);
                }
                return downloadBinary;
            }()
        },
        {
            key: "registerCopyIntent",
            value: function() {
                var _registerCopyIntent = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee10(id, collectionName) {
                    var auth, key, error;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee10$(_context10) {
                        while(true)switch(_context10.prev = _context10.next){
                            case 0:
                                _context10.next = 2;
                                return this.mediaApi.resolveAuth({
                                    collectionName: collectionName
                                });
                            case 2:
                                auth = _context10.sent;
                                key = {
                                    id: id,
                                    collectionName: collectionName,
                                    resolvedAuth: auth
                                };
                                _context10.next = 6;
                                return this.copyIntentRegisterationBatcher.load(key);
                            case 6:
                                error = _context10.sent;
                                if (!error) {
                                    _context10.next = 10;
                                    break;
                                }
                                // if the error is retryable then it should not be cached
                                if ((0, $5cK21.defaultShouldRetryError)(error)) this.copyIntentRegisterationBatcher.clear(key);
                                throw error;
                            case 10:
                            case "end":
                                return _context10.stop();
                        }
                    }, _callee10, this);
                }));
                function registerCopyIntent(_x22, _x23) {
                    return _registerCopyIntent.apply(this, arguments);
                }
                return registerCopyIntent;
            }()
        },
        {
            key: "copyFileWithToken",
            value: function() {
                var _copyFileWithToken = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee11(source, destination, traceContext) {
                    var authProvider, sourceCollection, id, destinationAuthProvider, destinationCollectionName, replaceFileId, occurrenceKey, mediaStore, owner, body, params, _yield$mediaStore$cop, data;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee11$(_context11) {
                        while(true)switch(_context11.prev = _context11.next){
                            case 0:
                                authProvider = source.authProvider, sourceCollection = source.collection, id = source.id;
                                destinationAuthProvider = destination.authProvider, destinationCollectionName = destination.collection, replaceFileId = destination.replaceFileId, occurrenceKey = destination.occurrenceKey;
                                mediaStore = destination.mediaStore || new (0, $ad5sk.MediaStore)({
                                    authProvider: destinationAuthProvider
                                });
                                _context11.t0 = (0, $pDaXe.authToOwner);
                                _context11.next = 6;
                                return authProvider({
                                    collectionName: sourceCollection
                                });
                            case 6:
                                _context11.t1 = _context11.sent;
                                owner = (0, _context11.t0)(_context11.t1);
                                body = {
                                    sourceFile: {
                                        id: id,
                                        collection: sourceCollection,
                                        owner: owner
                                    }
                                };
                                params = {
                                    collection: destinationCollectionName,
                                    replaceFileId: replaceFileId,
                                    occurrenceKey: occurrenceKey
                                };
                                _context11.next = 12;
                                return mediaStore.copyFileWithToken(body, params, traceContext);
                            case 12:
                                _yield$mediaStore$cop = _context11.sent;
                                data = _yield$mediaStore$cop.data;
                                return _context11.abrupt("return", data);
                            case 15:
                            case "end":
                                return _context11.stop();
                        }
                    }, _callee11);
                }));
                function copyFileWithToken(_x24, _x25, _x26) {
                    return _copyFileWithToken.apply(this, arguments);
                }
                return copyFileWithToken;
            }()
        },
        {
            key: "copyFileWithIntent",
            value: function() {
                var _copyFileWithIntent = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee12(source, destination, traceContext) {
                    var res, data;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee12$(_context12) {
                        while(true)switch(_context12.prev = _context12.next){
                            case 0:
                                _context12.next = 2;
                                return this.mediaApi.copyFile(source.id, {
                                    sourceCollection: source.collection,
                                    collection: destination.collection,
                                    replaceFileId: destination.replaceFileId
                                }, traceContext);
                            case 2:
                                res = _context12.sent;
                                data = res.data;
                                return _context12.abrupt("return", data);
                            case 5:
                            case "end":
                                return _context12.stop();
                        }
                    }, _callee12, this);
                }));
                function copyFileWithIntent(_x27, _x28, _x29) {
                    return _copyFileWithIntent.apply(this, arguments);
                }
                return copyFileWithIntent;
            }()
        },
        {
            key: "copyFile",
            value: function() {
                var _copyFile = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee13(source, destination) {
                    var _this5 = this;
                    var options, traceContext, id, destinationCollectionName, replaceFileId, occurrenceKey, preview, mimeType, cache, processingSubscription, copiedFile, copiedFileWithMimeType, copiedId, copiedMimeType, mediaType, copiedFileState, fileCache, subject, previewOverride, fileState, _fileState, _fileCache, replaceFileState, key, errorFileState, _args13 = arguments;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee13$(_context13) {
                        while(true)switch(_context13.prev = _context13.next){
                            case 0:
                                options = _args13.length > 2 && _args13[2] !== undefined ? _args13[2] : {};
                                traceContext = _args13.length > 3 ? _args13[3] : undefined;
                                id = source.id;
                                destinationCollectionName = destination.collection, replaceFileId = destination.replaceFileId, occurrenceKey = destination.occurrenceKey;
                                preview = options.preview, mimeType = options.mimeType;
                                cache = (0, $L8Ev2.getFileStreamsCache)();
                                _context13.prev = 6;
                                if (!($5f3df6c6603d1476$var$isCopySourceFileWithToken(source) && $5f3df6c6603d1476$var$isCopyDestinationWithToken(destination))) {
                                    _context13.next = 13;
                                    break;
                                }
                                _context13.next = 10;
                                return this.copyFileWithToken(source, destination, traceContext);
                            case 10:
                                copiedFile = _context13.sent;
                                _context13.next = 16;
                                break;
                            case 13:
                                _context13.next = 15;
                                return this.copyFileWithIntent(source, destination, traceContext);
                            case 15:
                                copiedFile = _context13.sent;
                            case 16:
                                // if we were passed a "mimeType", we propagate it into copiedFileWithMimeType
                                copiedFileWithMimeType = $5f3df6c6603d1476$var$_objectSpread($5f3df6c6603d1476$var$_objectSpread({}, copiedFile), mimeType ? {
                                    mimeType: mimeType
                                } : undefined);
                                copiedId = copiedFileWithMimeType.id, copiedMimeType = copiedFileWithMimeType.mimeType; // backend may return an "unknown" mediaType just after the copy
                                // it's better to deduce it from "copiedMimeType" using getMediaTypeFromMimeType()
                                mediaType = copiedMimeType ? (0, $7VCF9.getMediaTypeFromMimeType)(copiedMimeType) : 'unknown';
                                copiedFileState = (0, $eBhvj.mapMediaFileToFileState)({
                                    data: copiedFileWithMimeType
                                });
                                fileCache = cache.get(copiedId);
                                subject = fileCache || (0, $d9Gbq.createMediaSubject)(); // if we were passed a "preview", we propagate it into the copiedFileState
                                previewOverride = !(0, $eBhvj.isErrorFileState)(copiedFileState) && !!preview ? {
                                    preview: preview
                                } : {};
                                _context13.t0 = !(0, $eBhvj.isFinalFileState)(copiedFileState) && // mimeType should always be returned by "copyFileWithToken"
                                // but in case it's not, we don't want to penalize "copyFile"
                                copiedMimeType;
                                if (!_context13.t0) {
                                    _context13.next = 28;
                                    break;
                                }
                                _context13.next = 27;
                                return (0, $bjt5J.shouldFetchRemoteFileStates)(mediaType, copiedMimeType, preview);
                            case 27:
                                _context13.t0 = _context13.sent;
                            case 28:
                                if (!_context13.t0) {
                                    _context13.next = 35;
                                    break;
                                }
                                fileState = $5f3df6c6603d1476$var$_objectSpread($5f3df6c6603d1476$var$_objectSpread($5f3df6c6603d1476$var$_objectSpread({}, copiedFileState), (0, $kwu4A.overrideMediaTypeIfUnknown)(copiedFileState, mediaType)), previewOverride);
                                subject.next(fileState);
                                this.setFileState(copiedId, fileState);
                                processingSubscription = this.createDownloadFileStream(copiedId, destinationCollectionName, occurrenceKey).subscribe({
                                    next: function next(remoteFileState) {
                                        var fileState = $5f3df6c6603d1476$var$_objectSpread($5f3df6c6603d1476$var$_objectSpread($5f3df6c6603d1476$var$_objectSpread({}, remoteFileState), (0, $kwu4A.overrideMediaTypeIfUnknown)(remoteFileState, mediaType)), !(0, $eBhvj.isErrorFileState)(remoteFileState) && previewOverride);
                                        _this5.setFileState(copiedId, fileState);
                                        return subject.next(fileState);
                                    },
                                    error: function error(err) {
                                        var errorFileState = _this5.getErrorFileState(err, id, occurrenceKey);
                                        _this5.setFileState(copiedId, errorFileState);
                                        return subject.error(err);
                                    },
                                    complete: function complete() {
                                        return subject.complete();
                                    }
                                });
                                _context13.next = 36;
                                break;
                            case 35:
                                if (!(0, $eBhvj.isProcessingFileState)(copiedFileState)) {
                                    _fileState = $5f3df6c6603d1476$var$_objectSpread($5f3df6c6603d1476$var$_objectSpread({}, copiedFileState), !(0, $eBhvj.isErrorFileState)(copiedFileState) && previewOverride);
                                    subject.next(_fileState);
                                    this.setFileState(copiedId, _fileState);
                                }
                            case 36:
                                if (!cache.has(copiedId)) (0, $L8Ev2.getFileStreamsCache)().set(copiedId, subject);
                                return _context13.abrupt("return", copiedFile);
                            case 40:
                                _context13.prev = 40;
                                _context13.t1 = _context13["catch"](6);
                                if (processingSubscription) processingSubscription.unsubscribe();
                                if (replaceFileId) {
                                    _fileCache = cache.get(replaceFileId);
                                    replaceFileState = this.store.getState().files[replaceFileId];
                                    if (_fileCache) _fileCache.error(_context13.t1);
                                    else // Create a new subject with the error state for new subscriptions
                                    cache.set(id, (0, $d9Gbq.createMediaSubject)(_context13.t1));
                                    key = replaceFileState ? replaceFileId : id;
                                    errorFileState = this.getErrorFileState(_context13.t1, id, occurrenceKey);
                                    this.setFileState(key, errorFileState);
                                }
                                throw _context13.t1;
                            case 45:
                            case "end":
                                return _context13.stop();
                        }
                    }, _callee13, this, [
                        [
                            6,
                            40
                        ]
                    ]);
                }));
                function copyFile(_x30, _x31) {
                    return _copyFile.apply(this, arguments);
                }
                return copyFile;
            }()
        }
    ]);
}();

});
parcelRegister("lSgto", function(module, exports) {
$parcel$export(module.exports, "Subscription", () => $fecb6b5a483b85f8$export$f55210826850c514, (v) => $fecb6b5a483b85f8$export$f55210826850c514 = v);
var $fecb6b5a483b85f8$export$f55210826850c514;
"use strict";

var $PE2Cj = parcelRequire("PE2Cj");

var $9DdIv = parcelRequire("9DdIv");

var $4u8sc = parcelRequire("4u8sc");

var $4kjY4 = parcelRequire("4kjY4");

var $98JVa = parcelRequire("98JVa");

var $03vNo = parcelRequire("03vNo");
/**
 * Represents a disposable resource, such as the execution of an Observable. A
 * Subscription has one important method, `unsubscribe`, that takes no argument
 * and just disposes the resource held by the subscription.
 *
 * Additionally, subscriptions may be grouped together through the `add()`
 * method, which will attach a child Subscription to the current Subscription.
 * When a Subscription is unsubscribed, all its children (and its grandchildren)
 * will be unsubscribed as well.
 *
 * @class Subscription
 */ var $fecb6b5a483b85f8$var$Subscription = function() {
    /**
     * @param {function(): void} [unsubscribe] A function describing how to
     * perform the disposal of resources when the `unsubscribe` method is called.
     */ function Subscription(unsubscribe) {
        /**
         * A flag to indicate whether this Subscription has already been unsubscribed.
         * @type {boolean}
         */ this.closed = false;
        this._parent = null;
        this._parents = null;
        this._subscriptions = null;
        if (unsubscribe) this._unsubscribe = unsubscribe;
    }
    /**
     * Disposes the resources held by the subscription. May, for instance, cancel
     * an ongoing Observable execution or cancel any other type of work that
     * started when the Subscription was created.
     * @return {void}
     */ Subscription.prototype.unsubscribe = function() {
        var hasErrors = false;
        var errors;
        if (this.closed) return;
        var _a = this, _parent = _a._parent, _parents = _a._parents, _unsubscribe = _a._unsubscribe, _subscriptions = _a._subscriptions;
        this.closed = true;
        this._parent = null;
        this._parents = null;
        // null out _subscriptions first so any child subscriptions that attempt
        // to remove themselves from this subscription will noop
        this._subscriptions = null;
        var index = -1;
        var len = _parents ? _parents.length : 0;
        // if this._parent is null, then so is this._parents, and we
        // don't have to remove ourselves from any parent subscriptions.
        while(_parent){
            _parent.remove(this);
            // if this._parents is null or index >= len,
            // then _parent is set to null, and the loop exits
            _parent = ++index < len && _parents[index] || null;
        }
        if ($4u8sc.isFunction(_unsubscribe)) {
            var trial = $4kjY4.tryCatch(_unsubscribe).call(this);
            if (trial === $98JVa.errorObject) {
                hasErrors = true;
                errors = errors || ($98JVa.errorObject.e instanceof $03vNo.UnsubscriptionError ? $fecb6b5a483b85f8$var$flattenUnsubscriptionErrors($98JVa.errorObject.e.errors) : [
                    $98JVa.errorObject.e
                ]);
            }
        }
        if ($PE2Cj.isArray(_subscriptions)) {
            index = -1;
            len = _subscriptions.length;
            while(++index < len){
                var sub = _subscriptions[index];
                if ($9DdIv.isObject(sub)) {
                    var trial = $4kjY4.tryCatch(sub.unsubscribe).call(sub);
                    if (trial === $98JVa.errorObject) {
                        hasErrors = true;
                        errors = errors || [];
                        var err = $98JVa.errorObject.e;
                        if (err instanceof $03vNo.UnsubscriptionError) errors = errors.concat($fecb6b5a483b85f8$var$flattenUnsubscriptionErrors(err.errors));
                        else errors.push(err);
                    }
                }
            }
        }
        if (hasErrors) throw new $03vNo.UnsubscriptionError(errors);
    };
    /**
     * Adds a tear down to be called during the unsubscribe() of this
     * Subscription.
     *
     * If the tear down being added is a subscription that is already
     * unsubscribed, is the same reference `add` is being called on, or is
     * `Subscription.EMPTY`, it will not be added.
     *
     * If this subscription is already in an `closed` state, the passed
     * tear down logic will be executed immediately.
     *
     * @param {TeardownLogic} teardown The additional logic to execute on
     * teardown.
     * @return {Subscription} Returns the Subscription used or created to be
     * added to the inner subscriptions list. This Subscription can be used with
     * `remove()` to remove the passed teardown logic from the inner subscriptions
     * list.
     */ Subscription.prototype.add = function(teardown) {
        if (!teardown || teardown === Subscription.EMPTY) return Subscription.EMPTY;
        if (teardown === this) return this;
        var subscription = teardown;
        switch(typeof teardown){
            case 'function':
                subscription = new Subscription(teardown);
            case 'object':
                if (subscription.closed || typeof subscription.unsubscribe !== 'function') return subscription;
                else if (this.closed) {
                    subscription.unsubscribe();
                    return subscription;
                } else if (typeof subscription._addParent !== 'function' /* quack quack */ ) {
                    var tmp = subscription;
                    subscription = new Subscription();
                    subscription._subscriptions = [
                        tmp
                    ];
                }
                break;
            default:
                throw new Error('unrecognized teardown ' + teardown + ' added to Subscription.');
        }
        var subscriptions = this._subscriptions || (this._subscriptions = []);
        subscriptions.push(subscription);
        subscription._addParent(this);
        return subscription;
    };
    /**
     * Removes a Subscription from the internal list of subscriptions that will
     * unsubscribe during the unsubscribe process of this Subscription.
     * @param {Subscription} subscription The subscription to remove.
     * @return {void}
     */ Subscription.prototype.remove = function(subscription) {
        var subscriptions = this._subscriptions;
        if (subscriptions) {
            var subscriptionIndex = subscriptions.indexOf(subscription);
            if (subscriptionIndex !== -1) subscriptions.splice(subscriptionIndex, 1);
        }
    };
    Subscription.prototype._addParent = function(parent) {
        var _a = this, _parent = _a._parent, _parents = _a._parents;
        if (!_parent || _parent === parent) // If we don't have a parent, or the new parent is the same as the
        // current parent, then set this._parent to the new parent.
        this._parent = parent;
        else if (!_parents) // If there's already one parent, but not multiple, allocate an Array to
        // store the rest of the parent Subscriptions.
        this._parents = [
            parent
        ];
        else if (_parents.indexOf(parent) === -1) // Only add the new parent to the _parents list if it's not already there.
        _parents.push(parent);
    };
    Subscription.EMPTY = function(empty) {
        empty.closed = true;
        return empty;
    }(new Subscription());
    return Subscription;
}();
$fecb6b5a483b85f8$export$f55210826850c514 = $fecb6b5a483b85f8$var$Subscription;
function $fecb6b5a483b85f8$var$flattenUnsubscriptionErrors(errors) {
    return errors.reduce(function(errs, err) {
        return errs.concat(err instanceof $03vNo.UnsubscriptionError ? err.errors : err);
    }, []);
}

});
parcelRegister("PE2Cj", function(module, exports) {
$parcel$export(module.exports, "isArray", () => $09b3d2e2894a2b38$export$43bee75e5e14138e, (v) => $09b3d2e2894a2b38$export$43bee75e5e14138e = v);
var $09b3d2e2894a2b38$export$43bee75e5e14138e;
"use strict";
$09b3d2e2894a2b38$export$43bee75e5e14138e = Array.isArray || function(x) {
    return x && typeof x.length === 'number';
};

});

parcelRegister("9DdIv", function(module, exports) {
$parcel$export(module.exports, "isObject", () => $7032657000ff8bfe$export$a6cdc56e425d0d0a, (v) => $7032657000ff8bfe$export$a6cdc56e425d0d0a = v);
var $7032657000ff8bfe$export$a6cdc56e425d0d0a;
"use strict";
function $7032657000ff8bfe$var$isObject(x) {
    return x != null && typeof x === 'object';
}
$7032657000ff8bfe$export$a6cdc56e425d0d0a = $7032657000ff8bfe$var$isObject;

});

parcelRegister("4u8sc", function(module, exports) {
$parcel$export(module.exports, "isFunction", () => $34408588c811449b$export$f6e2535fb5126e54, (v) => $34408588c811449b$export$f6e2535fb5126e54 = v);
var $34408588c811449b$export$f6e2535fb5126e54;
"use strict";
function $34408588c811449b$var$isFunction(x) {
    return typeof x === 'function';
}
$34408588c811449b$export$f6e2535fb5126e54 = $34408588c811449b$var$isFunction;

});

parcelRegister("4kjY4", function(module, exports) {
$parcel$export(module.exports, "tryCatch", () => $326884e25cd9b349$export$d234c058d1d4e435, (v) => $326884e25cd9b349$export$d234c058d1d4e435 = v);
var $326884e25cd9b349$export$d234c058d1d4e435;
"use strict";

var $98JVa = parcelRequire("98JVa");
var $326884e25cd9b349$var$tryCatchTarget;
function $326884e25cd9b349$var$tryCatcher() {
    try {
        return $326884e25cd9b349$var$tryCatchTarget.apply(this, arguments);
    } catch (e) {
        $98JVa.errorObject.e = e;
        return $98JVa.errorObject;
    }
}
function $326884e25cd9b349$var$tryCatch(fn) {
    $326884e25cd9b349$var$tryCatchTarget = fn;
    return $326884e25cd9b349$var$tryCatcher;
}
$326884e25cd9b349$export$d234c058d1d4e435 = $326884e25cd9b349$var$tryCatch;

});
parcelRegister("98JVa", function(module, exports) {
$parcel$export(module.exports, "errorObject", () => $6a787b60d5ba4151$export$fc504b39d7c1176, (v) => $6a787b60d5ba4151$export$fc504b39d7c1176 = v);
// typeof any so that it we don't have to cast when comparing a result to the error object
var $6a787b60d5ba4151$export$fc504b39d7c1176;
"use strict";
$6a787b60d5ba4151$export$fc504b39d7c1176 = {
    e: {}
};

});


parcelRegister("03vNo", function(module, exports) {
"use strict";
var $00a8f1e1504b13fc$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
/**
 * An error thrown when one or more errors have occurred during the
 * `unsubscribe` of a {@link Subscription}.
 */ var $00a8f1e1504b13fc$var$UnsubscriptionError = function(_super) {
    $00a8f1e1504b13fc$var$__extends(UnsubscriptionError, _super);
    function UnsubscriptionError(errors) {
        _super.call(this);
        this.errors = errors;
        var err = Error.call(this, errors ? errors.length + " errors occurred during unsubscription:\n  " + errors.map(function(err, i) {
            return i + 1 + ") " + err.toString();
        }).join('\n  ') : '');
        this.name = err.name = 'UnsubscriptionError';
        this.stack = err.stack;
        this.message = err.message;
    }
    return UnsubscriptionError;
}(Error);
module.exports.UnsubscriptionError = $00a8f1e1504b13fc$var$UnsubscriptionError;

});


parcelRegister("blmL7", function(module, exports) {
"use strict";
var $84234f52bc032053$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $deMDi = parcelRequire("deMDi");
/**
 * Applies a given `project` function to each value emitted by the source
 * Observable, and emits the resulting values as an Observable.
 *
 * <span class="informal">Like [Array.prototype.map()](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/map),
 * it passes each source value through a transformation function to get
 * corresponding output values.</span>
 *
 * <img src="./img/map.png" width="100%">
 *
 * Similar to the well known `Array.prototype.map` function, this operator
 * applies a projection to each value and emits that projection in the output
 * Observable.
 *
 * @example <caption>Map every click to the clientX position of that click</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var positions = clicks.map(ev => ev.clientX);
 * positions.subscribe(x => console.log(x));
 *
 * @see {@link mapTo}
 * @see {@link pluck}
 *
 * @param {function(value: T, index: number): R} project The function to apply
 * to each `value` emitted by the source Observable. The `index` parameter is
 * the number `i` for the i-th emission that has happened since the
 * subscription, starting from the number `0`.
 * @param {any} [thisArg] An optional argument to define what `this` is in the
 * `project` function.
 * @return {Observable<R>} An Observable that emits the values from the source
 * Observable transformed by the given `project` function.
 * @method map
 * @owner Observable
 */ function $84234f52bc032053$var$map(project, thisArg) {
    return function mapOperation(source) {
        if (typeof project !== 'function') throw new TypeError('argument is not a function. Are you looking for `mapTo()`?');
        return source.lift(new $84234f52bc032053$var$MapOperator(project, thisArg));
    };
}
module.exports.map = $84234f52bc032053$var$map;
var $84234f52bc032053$var$MapOperator = function() {
    function MapOperator(project, thisArg) {
        this.project = project;
        this.thisArg = thisArg;
    }
    MapOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $84234f52bc032053$var$MapSubscriber(subscriber, this.project, this.thisArg));
    };
    return MapOperator;
}();
module.exports.MapOperator = $84234f52bc032053$var$MapOperator;
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $84234f52bc032053$var$MapSubscriber = function(_super) {
    $84234f52bc032053$var$__extends(MapSubscriber, _super);
    function MapSubscriber(destination, project, thisArg) {
        _super.call(this, destination);
        this.project = project;
        this.count = 0;
        this.thisArg = thisArg || this;
    }
    // NOTE: This looks unoptimized, but it's actually purposefully NOT
    // using try/catch optimizations.
    MapSubscriber.prototype._next = function(value) {
        var result;
        try {
            result = this.project.call(this.thisArg, value, this.count++);
        } catch (err) {
            this.destination.error(err);
            return;
        }
        this.destination.next(result);
    };
    return MapSubscriber;
}($deMDi.Subscriber);

});
parcelRegister("deMDi", function(module, exports) {
"use strict";
var $9a324e9e88280ef4$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $4u8sc = parcelRequire("4u8sc");

var $lSgto = parcelRequire("lSgto");

var $5cSKU = parcelRequire("5cSKU");

var $efmvI = parcelRequire("efmvI");
/**
 * Implements the {@link Observer} interface and extends the
 * {@link Subscription} class. While the {@link Observer} is the public API for
 * consuming the values of an {@link Observable}, all Observers get converted to
 * a Subscriber, in order to provide Subscription-like capabilities such as
 * `unsubscribe`. Subscriber is a common type in RxJS, and crucial for
 * implementing operators, but it is rarely used as a public API.
 *
 * @class Subscriber<T>
 */ var $9a324e9e88280ef4$var$Subscriber = function(_super) {
    $9a324e9e88280ef4$var$__extends(Subscriber, _super);
    /**
     * @param {Observer|function(value: T): void} [destinationOrNext] A partially
     * defined Observer or a `next` callback function.
     * @param {function(e: ?any): void} [error] The `error` callback of an
     * Observer.
     * @param {function(): void} [complete] The `complete` callback of an
     * Observer.
     */ function Subscriber(destinationOrNext, error, complete) {
        _super.call(this);
        this.syncErrorValue = null;
        this.syncErrorThrown = false;
        this.syncErrorThrowable = false;
        this.isStopped = false;
        switch(arguments.length){
            case 0:
                this.destination = $5cSKU.empty;
                break;
            case 1:
                if (!destinationOrNext) {
                    this.destination = $5cSKU.empty;
                    break;
                }
                if (typeof destinationOrNext === 'object') {
                    // HACK(benlesh): To resolve an issue where Node users may have multiple
                    // copies of rxjs in their node_modules directory.
                    if ($9a324e9e88280ef4$var$isTrustedSubscriber(destinationOrNext)) {
                        var trustedSubscriber = destinationOrNext[$efmvI.rxSubscriber]();
                        this.syncErrorThrowable = trustedSubscriber.syncErrorThrowable;
                        this.destination = trustedSubscriber;
                        trustedSubscriber.add(this);
                    } else {
                        this.syncErrorThrowable = true;
                        this.destination = new $9a324e9e88280ef4$var$SafeSubscriber(this, destinationOrNext);
                    }
                    break;
                }
            default:
                this.syncErrorThrowable = true;
                this.destination = new $9a324e9e88280ef4$var$SafeSubscriber(this, destinationOrNext, error, complete);
                break;
        }
    }
    Subscriber.prototype[$efmvI.rxSubscriber] = function() {
        return this;
    };
    /**
     * A static factory for a Subscriber, given a (potentially partial) definition
     * of an Observer.
     * @param {function(x: ?T): void} [next] The `next` callback of an Observer.
     * @param {function(e: ?any): void} [error] The `error` callback of an
     * Observer.
     * @param {function(): void} [complete] The `complete` callback of an
     * Observer.
     * @return {Subscriber<T>} A Subscriber wrapping the (partially defined)
     * Observer represented by the given arguments.
     */ Subscriber.create = function(next, error, complete) {
        var subscriber = new Subscriber(next, error, complete);
        subscriber.syncErrorThrowable = false;
        return subscriber;
    };
    /**
     * The {@link Observer} callback to receive notifications of type `next` from
     * the Observable, with a value. The Observable may call this method 0 or more
     * times.
     * @param {T} [value] The `next` value.
     * @return {void}
     */ Subscriber.prototype.next = function(value) {
        if (!this.isStopped) this._next(value);
    };
    /**
     * The {@link Observer} callback to receive notifications of type `error` from
     * the Observable, with an attached {@link Error}. Notifies the Observer that
     * the Observable has experienced an error condition.
     * @param {any} [err] The `error` exception.
     * @return {void}
     */ Subscriber.prototype.error = function(err) {
        if (!this.isStopped) {
            this.isStopped = true;
            this._error(err);
        }
    };
    /**
     * The {@link Observer} callback to receive a valueless notification of type
     * `complete` from the Observable. Notifies the Observer that the Observable
     * has finished sending push-based notifications.
     * @return {void}
     */ Subscriber.prototype.complete = function() {
        if (!this.isStopped) {
            this.isStopped = true;
            this._complete();
        }
    };
    Subscriber.prototype.unsubscribe = function() {
        if (this.closed) return;
        this.isStopped = true;
        _super.prototype.unsubscribe.call(this);
    };
    Subscriber.prototype._next = function(value) {
        this.destination.next(value);
    };
    Subscriber.prototype._error = function(err) {
        this.destination.error(err);
        this.unsubscribe();
    };
    Subscriber.prototype._complete = function() {
        this.destination.complete();
        this.unsubscribe();
    };
    /** @deprecated internal use only */ Subscriber.prototype._unsubscribeAndRecycle = function() {
        var _a = this, _parent = _a._parent, _parents = _a._parents;
        this._parent = null;
        this._parents = null;
        this.unsubscribe();
        this.closed = false;
        this.isStopped = false;
        this._parent = _parent;
        this._parents = _parents;
        return this;
    };
    return Subscriber;
}($lSgto.Subscription);
module.exports.Subscriber = $9a324e9e88280ef4$var$Subscriber;
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $9a324e9e88280ef4$var$SafeSubscriber = function(_super) {
    $9a324e9e88280ef4$var$__extends(SafeSubscriber, _super);
    function SafeSubscriber(_parentSubscriber, observerOrNext, error, complete) {
        _super.call(this);
        this._parentSubscriber = _parentSubscriber;
        var next;
        var context = this;
        if ($4u8sc.isFunction(observerOrNext)) next = observerOrNext;
        else if (observerOrNext) {
            next = observerOrNext.next;
            error = observerOrNext.error;
            complete = observerOrNext.complete;
            if (observerOrNext !== $5cSKU.empty) {
                context = Object.create(observerOrNext);
                if ($4u8sc.isFunction(context.unsubscribe)) this.add(context.unsubscribe.bind(context));
                context.unsubscribe = this.unsubscribe.bind(this);
            }
        }
        this._context = context;
        this._next = next;
        this._error = error;
        this._complete = complete;
    }
    SafeSubscriber.prototype.next = function(value) {
        if (!this.isStopped && this._next) {
            var _parentSubscriber = this._parentSubscriber;
            if (!_parentSubscriber.syncErrorThrowable) this.__tryOrUnsub(this._next, value);
            else if (this.__tryOrSetError(_parentSubscriber, this._next, value)) this.unsubscribe();
        }
    };
    SafeSubscriber.prototype.error = function(err) {
        if (!this.isStopped) {
            var _parentSubscriber = this._parentSubscriber;
            if (this._error) {
                if (!_parentSubscriber.syncErrorThrowable) {
                    this.__tryOrUnsub(this._error, err);
                    this.unsubscribe();
                } else {
                    this.__tryOrSetError(_parentSubscriber, this._error, err);
                    this.unsubscribe();
                }
            } else if (!_parentSubscriber.syncErrorThrowable) {
                this.unsubscribe();
                throw err;
            } else {
                _parentSubscriber.syncErrorValue = err;
                _parentSubscriber.syncErrorThrown = true;
                this.unsubscribe();
            }
        }
    };
    SafeSubscriber.prototype.complete = function() {
        var _this = this;
        if (!this.isStopped) {
            var _parentSubscriber = this._parentSubscriber;
            if (this._complete) {
                var wrappedComplete = function() {
                    return _this._complete.call(_this._context);
                };
                if (!_parentSubscriber.syncErrorThrowable) {
                    this.__tryOrUnsub(wrappedComplete);
                    this.unsubscribe();
                } else {
                    this.__tryOrSetError(_parentSubscriber, wrappedComplete);
                    this.unsubscribe();
                }
            } else this.unsubscribe();
        }
    };
    SafeSubscriber.prototype.__tryOrUnsub = function(fn, value) {
        try {
            fn.call(this._context, value);
        } catch (err) {
            this.unsubscribe();
            throw err;
        }
    };
    SafeSubscriber.prototype.__tryOrSetError = function(parent, fn, value) {
        try {
            fn.call(this._context, value);
        } catch (err) {
            parent.syncErrorValue = err;
            parent.syncErrorThrown = true;
            return true;
        }
        return false;
    };
    /** @deprecated internal use only */ SafeSubscriber.prototype._unsubscribe = function() {
        var _parentSubscriber = this._parentSubscriber;
        this._context = null;
        this._parentSubscriber = null;
        _parentSubscriber.unsubscribe();
    };
    return SafeSubscriber;
}($9a324e9e88280ef4$var$Subscriber);
function $9a324e9e88280ef4$var$isTrustedSubscriber(obj) {
    return obj instanceof $9a324e9e88280ef4$var$Subscriber || 'syncErrorThrowable' in obj && obj[$efmvI.rxSubscriber];
}

});
parcelRegister("5cSKU", function(module, exports) {
$parcel$export(module.exports, "empty", () => $3ca88c0e07e3e3bc$export$6e22c362a0406a2c, (v) => $3ca88c0e07e3e3bc$export$6e22c362a0406a2c = v);
var $3ca88c0e07e3e3bc$export$6e22c362a0406a2c;
"use strict";
$3ca88c0e07e3e3bc$export$6e22c362a0406a2c = {
    closed: true,
    next: function(value) {},
    error: function(err) {
        throw err;
    },
    complete: function() {}
};

});

parcelRegister("efmvI", function(module, exports) {
$parcel$export(module.exports, "rxSubscriber", () => $a5f3ed876410bdb0$export$77f77496d7cade10, (v) => $a5f3ed876410bdb0$export$77f77496d7cade10 = v);
var $a5f3ed876410bdb0$export$77f77496d7cade10;
/**
 * @deprecated use rxSubscriber instead
 */ var $a5f3ed876410bdb0$export$4a2e07ff24d010f0;
"use strict";

var $gvBTr = parcelRequire("gvBTr");
var $a5f3ed876410bdb0$var$Symbol = $gvBTr.root.Symbol;
$a5f3ed876410bdb0$export$77f77496d7cade10 = typeof $a5f3ed876410bdb0$var$Symbol === 'function' && typeof $a5f3ed876410bdb0$var$Symbol.for === 'function' ? $a5f3ed876410bdb0$var$Symbol.for('rxSubscriber') : '@@rxSubscriber';
$a5f3ed876410bdb0$export$4a2e07ff24d010f0 = $a5f3ed876410bdb0$export$77f77496d7cade10;

});
parcelRegister("gvBTr", function(module, exports) {
$parcel$export(module.exports, "root", () => $c04cef60f79b79ed$export$e8e78c978b129247, (v) => $c04cef60f79b79ed$export$e8e78c978b129247 = v);
var $c04cef60f79b79ed$export$e8e78c978b129247;
"use strict";
// CommonJS / Node have global context exposed as "global" variable.
// We don't want to include the whole node.d.ts this this compilation unit so we'll just fake
// the global "global" var for now.
var $c04cef60f79b79ed$var$__window = typeof window !== 'undefined' && window;
var $c04cef60f79b79ed$var$__self = typeof self !== 'undefined' && typeof WorkerGlobalScope !== 'undefined' && self instanceof WorkerGlobalScope && self;
var $c04cef60f79b79ed$var$__global = typeof $parcel$global !== 'undefined' && $parcel$global;
var $c04cef60f79b79ed$var$_root = $c04cef60f79b79ed$var$__window || $c04cef60f79b79ed$var$__global || $c04cef60f79b79ed$var$__self;
$c04cef60f79b79ed$export$e8e78c978b129247 = $c04cef60f79b79ed$var$_root;
// Workaround Closure Compiler restriction: The body of a goog.module cannot use throw.
// This is needed when used with angular/tsickle which inserts a goog.module statement.
// Wrap in IIFE
(function() {
    if (!$c04cef60f79b79ed$var$_root) throw new Error('RxJS could not find any global context (window, self, global)');
})();

});




parcelRegister("g7x2h", function(module, exports) {
$parcel$export(module.exports, "downloadUrl", () => $bbc6ed0084190904$export$8a96edb1c96563f4);
var $bbc6ed0084190904$export$8a96edb1c96563f4 = function downloadUrl(url, options) {
    var isIE11 = !!window.MSInputMethodContext && !!document.documentMode;
    var isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    var iframeName = 'media-download-iframe';
    var link = document.createElement('a');
    var iframe = document.getElementById(iframeName);
    if (!iframe) {
        iframe = document.createElement('iframe');
        iframe.style.display = 'none';
        iframe.id = iframeName;
        iframe.name = iframeName;
        document.body.appendChild(iframe);
    }
    link.href = url;
    if (options && options.name) link.download = options.name;
    link.target = isIE11 || isSafari ? '_blank' : iframeName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
};

});

parcelRegister("eBhvj", function(module, exports) {
$parcel$export(module.exports, "isUploadingFileState", () => $aa12194f826dc2aa$export$70eb3481b487c668);
$parcel$export(module.exports, "isProcessingFileState", () => $aa12194f826dc2aa$export$5c30e6dd75278e66);
$parcel$export(module.exports, "isProcessedFileState", () => $aa12194f826dc2aa$export$1d17291aafa5f231);
$parcel$export(module.exports, "isErrorFileState", () => $aa12194f826dc2aa$export$f863e1e09c8a926);
$parcel$export(module.exports, "isFinalFileState", () => $aa12194f826dc2aa$export$270b3fc27120edd0);
$parcel$export(module.exports, "isNonErrorFinalFileState", () => $aa12194f826dc2aa$export$8f33148a37b0c72f);
$parcel$export(module.exports, "isImageRepresentationReady", () => $aa12194f826dc2aa$export$4e33ccde53b4f0bf);
$parcel$export(module.exports, "mapMediaFileToFileState", () => $aa12194f826dc2aa$export$ddfd67d20657322f);
$parcel$export(module.exports, "mapMediaItemToFileState", () => $aa12194f826dc2aa$export$ea3730792e8bebfb);

var $25nEq = parcelRequire("25nEq");
function $aa12194f826dc2aa$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $aa12194f826dc2aa$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $aa12194f826dc2aa$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $aa12194f826dc2aa$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $aa12194f826dc2aa$export$70eb3481b487c668 = function isUploadingFileState(fileState) {
    return fileState.status === 'uploading';
};
var $aa12194f826dc2aa$export$5c30e6dd75278e66 = function isProcessingFileState(fileState) {
    return fileState.status === 'processing';
};
var $aa12194f826dc2aa$export$1d17291aafa5f231 = function isProcessedFileState(fileState) {
    return fileState.status === 'processed';
};
var $aa12194f826dc2aa$export$f863e1e09c8a926 = function isErrorFileState(fileState) {
    return fileState.status === 'error';
};
var $aa12194f826dc2aa$export$92dd692b31e42e64 = function isPreviewableFileState(fileState) {
    return !$aa12194f826dc2aa$export$f863e1e09c8a926(fileState) && !!fileState.preview;
};
var $aa12194f826dc2aa$export$270b3fc27120edd0 = function isFinalFileState(fileState) {
    return [
        'processed',
        'failed-processing',
        'error'
    ].includes(fileState.status);
};
var $aa12194f826dc2aa$export$8f33148a37b0c72f = function isNonErrorFinalFileState(fileState) {
    return [
        'processed',
        'failed-processing'
    ].includes(fileState.status);
};
var $aa12194f826dc2aa$export$ecdf3dee1d148302 = function hasArtifacts(fileState) {
    return 'artifacts' in fileState && fileState.artifacts !== undefined;
};
var $aa12194f826dc2aa$export$4e33ccde53b4f0bf = function isImageRepresentationReady(fileState) {
    switch(fileState.status){
        case 'processing':
        case 'processed':
        case 'failed-processing':
            return !!(fileState.representations && fileState.representations.image);
        default:
            return false;
    }
};
var $aa12194f826dc2aa$export$ddfd67d20657322f = function mapMediaFileToFileState(mediaFile) {
    var _mediaFile$data = mediaFile.data, id = _mediaFile$data.id, name = _mediaFile$data.name, size = _mediaFile$data.size, processingStatus = _mediaFile$data.processingStatus, artifacts = _mediaFile$data.artifacts, mediaType = _mediaFile$data.mediaType, mimeType = _mediaFile$data.mimeType, representations = _mediaFile$data.representations, createdAt = _mediaFile$data.createdAt, metadataTraceContext = _mediaFile$data.metadataTraceContext, hash = _mediaFile$data.hash, abuseClassification = _mediaFile$data.abuseClassification, mediaMetadata = _mediaFile$data.mediaMetadata;
    var baseState = {
        id: id,
        name: name,
        size: size,
        mediaType: mediaType,
        mimeType: mimeType,
        artifacts: artifacts,
        representations: representations,
        createdAt: createdAt,
        hash: hash,
        metadataTraceContext: metadataTraceContext,
        abuseClassification: abuseClassification,
        mediaMetadata: mediaMetadata
    };
    switch(processingStatus){
        case 'pending':
        case undefined:
            return $aa12194f826dc2aa$var$_objectSpread($aa12194f826dc2aa$var$_objectSpread({}, baseState), {}, {
                status: 'processing'
            });
        case 'succeeded':
            return $aa12194f826dc2aa$var$_objectSpread($aa12194f826dc2aa$var$_objectSpread({}, baseState), {}, {
                status: 'processed'
            });
        case 'failed':
            return $aa12194f826dc2aa$var$_objectSpread($aa12194f826dc2aa$var$_objectSpread({}, baseState), {}, {
                status: 'failed-processing'
            });
    }
};
var $aa12194f826dc2aa$export$ea3730792e8bebfb = function mapMediaItemToFileState(id, item) {
    return $aa12194f826dc2aa$export$ddfd67d20657322f({
        data: $aa12194f826dc2aa$var$_objectSpread({
            id: id
        }, item)
    });
};

});

parcelRegister("f8kvj", function(module, exports) {
$parcel$export(module.exports, "FileFetcherError", () => $b0478212248f0882$export$e3e60f0dab8641de);

var $25nEq = parcelRequire("25nEq");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $kIXpt = parcelRequire("kIXpt");

var $cYPzS = parcelRequire("cYPzS");

var $eyuDe = parcelRequire("eyuDe");

var $8eaz3 = parcelRequire("8eaz3");
function $b0478212248f0882$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $b0478212248f0882$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $b0478212248f0882$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $b0478212248f0882$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $b0478212248f0882$var$_callSuper(t, o, e) {
    return o = (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(o), (0, (/*@__PURE__*/$parcel$interopDefault($kIXpt)))(t, $b0478212248f0882$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(t).constructor) : o.apply(t, e));
}
function $b0478212248f0882$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($b0478212248f0882$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $b0478212248f0882$export$e3e60f0dab8641de = /*#__PURE__*/ function(_BaseMediaClientError) {
    // Legacy Attribute. Should be removed
    function FileFetcherError(reason, metadata) {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, FileFetcherError);
        _this = $b0478212248f0882$var$_callSuper(this, FileFetcherError, [
            reason,
            metadata,
            undefined
        ]);
        _this.id = metadata.id;
        return _this;
    }
    // TODO: Deprecate this getter https://product-fabric.atlassian.net/browse/CXP-4665
    /** Will be deprecated. Use the properties `reason` and `metadata` instead */ (0, (/*@__PURE__*/$parcel$interopDefault($eyuDe)))(FileFetcherError, _BaseMediaClientError);
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(FileFetcherError, [
        {
            key: "attributes",
            get: function get() {
                var reason = this.reason, _this$metadata = this.metadata, id = _this$metadata.id, collectionName = _this$metadata.collectionName, occurrenceKey = _this$metadata.occurrenceKey, traceContext = _this$metadata.traceContext;
                return $b0478212248f0882$var$_objectSpread({
                    reason: reason,
                    id: id,
                    collectionName: collectionName,
                    occurrenceKey: occurrenceKey
                }, traceContext && {
                    metadata: {
                        traceContext: traceContext
                    }
                });
            }
        }
    ]);
}((0, $8eaz3.BaseMediaClientError));
function $b0478212248f0882$export$5c3435f75ce0ce70(err) {
    return err instanceof $b0478212248f0882$export$e3e60f0dab8641de;
}

});

parcelRegister("aaWoP", function(module, exports) {
$parcel$export(module.exports, "uploadFile", () => $76882378dfd87aab$export$a5575dbeeffdad98);

var $fL8KA = parcelRequire("fL8KA");

var $6HG4S = parcelRequire("6HG4S");

var $3Hq8H = parcelRequire("3Hq8H");

var $1zWpA = parcelRequire("1zWpA");

var $hU1R1 = parcelRequire("hU1R1");

var $cJOXG = parcelRequire("cJOXG");

var $7cA6T = parcelRequire("7cA6T");

var $cSavz = parcelRequire("cSavz");

var $hp5hn = parcelRequire("hp5hn");
// TODO: Allow to pass multiple files
var $76882378dfd87aab$var$_hashingFunction = /*#__PURE__*/ function() {
    var _ref = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee(blob, hashAlgorithm) {
        var hasher;
        return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee$(_context) {
            while(true)switch(_context.prev = _context.next){
                case 0:
                    _context.next = 2;
                    return (0, $cJOXG.createHasher)(hashAlgorithm);
                case 2:
                    hasher = _context.sent;
                    return _context.abrupt("return", hasher.hash(blob));
                case 4:
                case "end":
                    return _context.stop();
            }
        }, _callee);
    }));
    return function hashingFunction(_x, _x2) {
        return _ref.apply(this, arguments);
    };
}();
var $76882378dfd87aab$var$createUploadingFunction = function createUploadingFunction(store, deferredUploadId, collectionName, traceContext) {
    return /*#__PURE__*/ function() {
        var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee2(chunk) {
            return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee2$(_context2) {
                while(true)switch(_context2.prev = _context2.next){
                    case 0:
                        _context2.t0 = store;
                        _context2.t1 = chunk.hash;
                        _context2.t2 = chunk.blob;
                        _context2.next = 5;
                        return deferredUploadId;
                    case 5:
                        _context2.t3 = _context2.sent;
                        _context2.t4 = chunk.partNumber;
                        _context2.t5 = collectionName;
                        _context2.t6 = traceContext;
                        _context2.next = 11;
                        return _context2.t0.uploadChunk.call(_context2.t0, _context2.t1, _context2.t2, _context2.t3, _context2.t4, _context2.t5, _context2.t6);
                    case 11:
                        return _context2.abrupt("return", _context2.sent);
                    case 12:
                    case "end":
                        return _context2.stop();
                }
            }, _callee2);
        }));
        return function(_x3) {
            return _ref2.apply(this, arguments);
        };
    }();
};
var $76882378dfd87aab$var$createProcessingFunction = function createProcessingFunction(store, deferredUploadId, collection, traceContext) {
    var offset = 0;
    return /*#__PURE__*/ function() {
        var _ref3 = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee3(chunks) {
            return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee3$(_context3) {
                while(true)switch(_context3.prev = _context3.next){
                    case 0:
                        _context3.t0 = store;
                        _context3.next = 3;
                        return deferredUploadId;
                    case 3:
                        _context3.t1 = _context3.sent;
                        _context3.t2 = {
                            chunks: $76882378dfd87aab$var$hashedChunks(chunks),
                            offset: offset
                        };
                        _context3.t3 = collection;
                        _context3.t4 = traceContext;
                        _context3.next = 9;
                        return _context3.t0.appendChunksToUpload.call(_context3.t0, _context3.t1, _context3.t2, _context3.t3, _context3.t4);
                    case 9:
                        offset += chunks.length;
                    case 10:
                    case "end":
                        return _context3.stop();
                }
            }, _callee3);
        }));
        return function(_x4) {
            return _ref3.apply(this, arguments);
        };
    }();
};
var $76882378dfd87aab$var$createFileFromUpload = /*#__PURE__*/ function() {
    var _ref4 = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee4(file, store, uploadableFileUpfrontIds, uploadId, traceContext) {
        var collection, name, mimeType, id, occurrenceKey, body;
        return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee4$(_context4) {
            while(true)switch(_context4.prev = _context4.next){
                case 0:
                    collection = file.collection, name = file.name, mimeType = file.mimeType;
                    id = uploadableFileUpfrontIds.id, occurrenceKey = uploadableFileUpfrontIds.occurrenceKey;
                    body = file.size ? {
                        uploadId: uploadId,
                        name: name,
                        mimeType: mimeType,
                        conditions: {
                            size: file.size
                        }
                    } : {
                        uploadId: uploadId,
                        name: name,
                        mimeType: mimeType
                    };
                    return _context4.abrupt("return", store.createFileFromUpload(body, {
                        occurrenceKey: occurrenceKey,
                        collection: collection,
                        replaceFileId: id
                    }, traceContext));
                case 4:
                case "end":
                    return _context4.stop();
            }
        }, _callee4);
    }));
    return function createFileFromUpload(_x5, _x6, _x7, _x8, _x9) {
        return _ref4.apply(this, arguments);
    };
}();
var $76882378dfd87aab$export$a5575dbeeffdad98 = function uploadFile(file, store, uploadableFileUpfrontIds, callbacks, traceContext) {
    var content = file.content, collection = file.collection;
    var deferredUploadId = uploadableFileUpfrontIds.deferredUploadId, id = uploadableFileUpfrontIds.id, occurrenceKey = uploadableFileUpfrontIds.occurrenceKey;
    var chunkSize = (0, $cSavz.CHUNK_SIZE);
    try {
        if (content instanceof Blob) chunkSize = (0, $hp5hn.calculateChunkSize)(content.size);
    } catch (err) {
        if (err instanceof Error && err.message === (0, $hp5hn.fileSizeError)) callbacks === null || callbacks === void 0 || callbacks.onUploadFinish(new (0, $7cA6T.UploaderError)(err.message, {
            id: id,
            collectionName: collection,
            occurrenceKey: occurrenceKey
        }));
        return {
            cancel: function cancel() {
                callbacks === null || callbacks === void 0 || callbacks.onUploadFinish('canceled');
            }
        };
    }
    var chunkinatorObservable = (0, $3Hq8H.chunkinator)(content, {
        hashingFunction: function hashingFunction(blob) {
            return $76882378dfd87aab$var$_hashingFunction(blob, store.chunkHashAlgorithm);
        },
        hashingConcurrency: 5,
        chunkSize: chunkSize,
        uploadingConcurrency: 3,
        uploadingFunction: $76882378dfd87aab$var$createUploadingFunction(store, deferredUploadId, collection, traceContext),
        processingBatchSize: (0, $cSavz.PROCESSING_BATCH_SIZE),
        processingFunction: $76882378dfd87aab$var$createProcessingFunction(store, deferredUploadId, collection, traceContext)
    }, {
        onProgress: function onProgress(progress) {
            if (callbacks) callbacks.onProgress(progress);
        }
    });
    var onUploadFinish = callbacks && callbacks.onUploadFinish || function() {};
    var subscription = (0, $1zWpA.from)(deferredUploadId).pipe((0, $hU1R1.concatMap)(function(uploadId) {
        return chunkinatorObservable.pipe((0, $hU1R1.concatMap)(function() {
            return (0, $1zWpA.from)($76882378dfd87aab$var$createFileFromUpload(file, store, uploadableFileUpfrontIds, uploadId, traceContext));
        }));
    })).subscribe({
        error: function error(err) {
            return onUploadFinish(err);
        },
        complete: function complete() {
            return onUploadFinish();
        }
    });
    return {
        cancel: function cancel() {
            subscription.unsubscribe();
            onUploadFinish('canceled');
        }
    };
};
var $76882378dfd87aab$var$hashedChunks = function hashedChunks(chunks) {
    return chunks.map(function(chunk) {
        return chunk.hash;
    });
};

});
parcelRegister("3Hq8H", function(module, exports) {
$parcel$export(module.exports, "chunkinator", () => $2b19a9f4b2fd27c9$export$9ab6bef3838698f8);

var $kdSxl = parcelRequire("kdSxl");

var $hU1R1 = parcelRequire("hU1R1");

var $jmcbD = parcelRequire("jmcbD");

var $aG6Au = parcelRequire("aG6Au");

var $9zDuU = parcelRequire("9zDuU");

var $l4WxA = parcelRequire("l4WxA");

var $k2B16 = parcelRequire("k2B16");

var $govPu = parcelRequire("govPu");

var $2Hz6m = parcelRequire("2Hz6m");

var $1zWpA = parcelRequire("1zWpA");
var $2b19a9f4b2fd27c9$export$88e80b3a0bb31f63 = function getObservableFromFile(file, options, callbacks) {
    return (0, $aG6Au.fromPromise)((0, $2Hz6m.fetchBlob)(file)).pipe((0, $hU1R1.concatMap)(function(blob) {
        var chunkSize = options.chunkSize;
        var onProgress = callbacks.onProgress;
        var totalChunks = Math.ceil(blob.size / chunkSize);
        var slicenatedBlobs = (0, $9zDuU.slicenator)(blob, {
            size: chunkSize
        });
        var hashinatedBlobs = (0, $l4WxA.hashinator)(slicenatedBlobs, {
            concurrency: options.hashingConcurrency,
            hasher: options.hashingFunction
        });
        var uploadedChunks = 0;
        var uploadedBlobs = (0, $k2B16.uploadinator)(hashinatedBlobs, {
            concurrency: options.uploadingConcurrency,
            uploader: options.uploadingFunction
        });
        if (onProgress) uploadedBlobs = uploadedBlobs.pipe((0, $kdSxl.tap)(function() {
            uploadedChunks += 1;
            onProgress(uploadedChunks / totalChunks);
        }));
        return (0, $govPu.processinator)(uploadedBlobs, {
            batchSize: options.processingBatchSize,
            processor: options.processingFunction
        }).pipe((0, $hU1R1.concatMap)(function(batchedChunks) {
            return (0, $1zWpA.from)(batchedChunks);
        }), (0, $jmcbD.bufferCount)(totalChunks));
    }));
};
var $2b19a9f4b2fd27c9$export$9ab6bef3838698f8 = function chunkinator(file, options, callbacks) {
    return $2b19a9f4b2fd27c9$export$88e80b3a0bb31f63(file, options, callbacks);
};

});
parcelRegister("kdSxl", function(module, exports) {
"use strict";
var $eb8f536aea4d8728$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $deMDi = parcelRequire("deMDi");
/* tslint:enable:max-line-length */ /**
 * Perform a side effect for every emission on the source Observable, but return
 * an Observable that is identical to the source.
 *
 * <span class="informal">Intercepts each emission on the source and runs a
 * function, but returns an output which is identical to the source as long as errors don't occur.</span>
 *
 * <img src="./img/do.png" width="100%">
 *
 * Returns a mirrored Observable of the source Observable, but modified so that
 * the provided Observer is called to perform a side effect for every value,
 * error, and completion emitted by the source. Any errors that are thrown in
 * the aforementioned Observer or handlers are safely sent down the error path
 * of the output Observable.
 *
 * This operator is useful for debugging your Observables for the correct values
 * or performing other side effects.
 *
 * Note: this is different to a `subscribe` on the Observable. If the Observable
 * returned by `do` is not subscribed, the side effects specified by the
 * Observer will never happen. `do` therefore simply spies on existing
 * execution, it does not trigger an execution to happen like `subscribe` does.
 *
 * @example <caption>Map every click to the clientX position of that click, while also logging the click event</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var positions = clicks
 *   .do(ev => console.log(ev))
 *   .map(ev => ev.clientX);
 * positions.subscribe(x => console.log(x));
 *
 * @see {@link map}
 * @see {@link subscribe}
 *
 * @param {Observer|function} [nextOrObserver] A normal Observer object or a
 * callback for `next`.
 * @param {function} [error] Callback for errors in the source.
 * @param {function} [complete] Callback for the completion of the source.
 * @return {Observable} An Observable identical to the source, but runs the
 * specified Observer or callback(s) for each item.
 * @name tap
 */ function $eb8f536aea4d8728$var$tap(nextOrObserver, error, complete) {
    return function tapOperatorFunction(source) {
        return source.lift(new $eb8f536aea4d8728$var$DoOperator(nextOrObserver, error, complete));
    };
}
module.exports.tap = $eb8f536aea4d8728$var$tap;
var $eb8f536aea4d8728$var$DoOperator = function() {
    function DoOperator(nextOrObserver, error, complete) {
        this.nextOrObserver = nextOrObserver;
        this.error = error;
        this.complete = complete;
    }
    DoOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $eb8f536aea4d8728$var$DoSubscriber(subscriber, this.nextOrObserver, this.error, this.complete));
    };
    return DoOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $eb8f536aea4d8728$var$DoSubscriber = function(_super) {
    $eb8f536aea4d8728$var$__extends(DoSubscriber, _super);
    function DoSubscriber(destination, nextOrObserver, error, complete) {
        _super.call(this, destination);
        var safeSubscriber = new $deMDi.Subscriber(nextOrObserver, error, complete);
        safeSubscriber.syncErrorThrowable = true;
        this.add(safeSubscriber);
        this.safeSubscriber = safeSubscriber;
    }
    DoSubscriber.prototype._next = function(value) {
        var safeSubscriber = this.safeSubscriber;
        safeSubscriber.next(value);
        if (safeSubscriber.syncErrorThrown) this.destination.error(safeSubscriber.syncErrorValue);
        else this.destination.next(value);
    };
    DoSubscriber.prototype._error = function(err) {
        var safeSubscriber = this.safeSubscriber;
        safeSubscriber.error(err);
        if (safeSubscriber.syncErrorThrown) this.destination.error(safeSubscriber.syncErrorValue);
        else this.destination.error(err);
    };
    DoSubscriber.prototype._complete = function() {
        var safeSubscriber = this.safeSubscriber;
        safeSubscriber.complete();
        if (safeSubscriber.syncErrorThrown) this.destination.error(safeSubscriber.syncErrorValue);
        else this.destination.complete();
    };
    return DoSubscriber;
}($deMDi.Subscriber);

});

parcelRegister("hU1R1", function(module, exports) {
$parcel$export(module.exports, "concatMap", () => $d0891ad4f97b9723$export$c28c8388be0ab31a, (v) => $d0891ad4f97b9723$export$c28c8388be0ab31a = v);
var $d0891ad4f97b9723$export$c28c8388be0ab31a;
"use strict";

var $gJXF1 = parcelRequire("gJXF1");
/* tslint:enable:max-line-length */ /**
 * Projects each source value to an Observable which is merged in the output
 * Observable, in a serialized fashion waiting for each one to complete before
 * merging the next.
 *
 * <span class="informal">Maps each value to an Observable, then flattens all of
 * these inner Observables using {@link concatAll}.</span>
 *
 * <img src="./img/concatMap.png" width="100%">
 *
 * Returns an Observable that emits items based on applying a function that you
 * supply to each item emitted by the source Observable, where that function
 * returns an (so-called "inner") Observable. Each new inner Observable is
 * concatenated with the previous inner Observable.
 *
 * __Warning:__ if source values arrive endlessly and faster than their
 * corresponding inner Observables can complete, it will result in memory issues
 * as inner Observables amass in an unbounded buffer waiting for their turn to
 * be subscribed to.
 *
 * Note: `concatMap` is equivalent to `mergeMap` with concurrency parameter set
 * to `1`.
 *
 * @example <caption>For each click event, tick every second from 0 to 3, with no concurrency</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.concatMap(ev => Rx.Observable.interval(1000).take(4));
 * result.subscribe(x => console.log(x));
 *
 * // Results in the following:
 * // (results are not concurrent)
 * // For every click on the "document" it will emit values 0 to 3 spaced
 * // on a 1000ms interval
 * // one click = 1000ms-> 0 -1000ms-> 1 -1000ms-> 2 -1000ms-> 3
 *
 * @see {@link concat}
 * @see {@link concatAll}
 * @see {@link concatMapTo}
 * @see {@link exhaustMap}
 * @see {@link mergeMap}
 * @see {@link switchMap}
 *
 * @param {function(value: T, ?index: number): ObservableInput} project A function
 * that, when applied to an item emitted by the source Observable, returns an
 * Observable.
 * @param {function(outerValue: T, innerValue: I, outerIndex: number, innerIndex: number): any} [resultSelector]
 * A function to produce the value on the output Observable based on the values
 * and the indices of the source (outer) emission and the inner Observable
 * emission. The arguments passed to this function are:
 * - `outerValue`: the value that came from the source
 * - `innerValue`: the value that came from the projected Observable
 * - `outerIndex`: the "index" of the value that came from the source
 * - `innerIndex`: the "index" of the value from the projected Observable
 * @return {Observable} An Observable that emits the result of applying the
 * projection function (and the optional `resultSelector`) to each item emitted
 * by the source Observable and taking values from each projected inner
 * Observable sequentially.
 * @method concatMap
 * @owner Observable
 */ function $d0891ad4f97b9723$var$concatMap(project, resultSelector) {
    return $gJXF1.mergeMap(project, resultSelector, 1);
}
$d0891ad4f97b9723$export$c28c8388be0ab31a = $d0891ad4f97b9723$var$concatMap;

});
parcelRegister("gJXF1", function(module, exports) {
"use strict";
var $c2ff20ad66810fb7$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $5PwgB = parcelRequire("5PwgB");

var $jYuxp = parcelRequire("jYuxp");
/* tslint:enable:max-line-length */ /**
 * Projects each source value to an Observable which is merged in the output
 * Observable.
 *
 * <span class="informal">Maps each value to an Observable, then flattens all of
 * these inner Observables using {@link mergeAll}.</span>
 *
 * <img src="./img/mergeMap.png" width="100%">
 *
 * Returns an Observable that emits items based on applying a function that you
 * supply to each item emitted by the source Observable, where that function
 * returns an Observable, and then merging those resulting Observables and
 * emitting the results of this merger.
 *
 * @example <caption>Map and flatten each letter to an Observable ticking every 1 second</caption>
 * var letters = Rx.Observable.of('a', 'b', 'c');
 * var result = letters.mergeMap(x =>
 *   Rx.Observable.interval(1000).map(i => x+i)
 * );
 * result.subscribe(x => console.log(x));
 *
 * // Results in the following:
 * // a0
 * // b0
 * // c0
 * // a1
 * // b1
 * // c1
 * // continues to list a,b,c with respective ascending integers
 *
 * @see {@link concatMap}
 * @see {@link exhaustMap}
 * @see {@link merge}
 * @see {@link mergeAll}
 * @see {@link mergeMapTo}
 * @see {@link mergeScan}
 * @see {@link switchMap}
 *
 * @param {function(value: T, ?index: number): ObservableInput} project A function
 * that, when applied to an item emitted by the source Observable, returns an
 * Observable.
 * @param {function(outerValue: T, innerValue: I, outerIndex: number, innerIndex: number): any} [resultSelector]
 * A function to produce the value on the output Observable based on the values
 * and the indices of the source (outer) emission and the inner Observable
 * emission. The arguments passed to this function are:
 * - `outerValue`: the value that came from the source
 * - `innerValue`: the value that came from the projected Observable
 * - `outerIndex`: the "index" of the value that came from the source
 * - `innerIndex`: the "index" of the value from the projected Observable
 * @param {number} [concurrent=Number.POSITIVE_INFINITY] Maximum number of input
 * Observables being subscribed to concurrently.
 * @return {Observable} An Observable that emits the result of applying the
 * projection function (and the optional `resultSelector`) to each item emitted
 * by the source Observable and merging the results of the Observables obtained
 * from this transformation.
 * @method mergeMap
 * @owner Observable
 */ function $c2ff20ad66810fb7$var$mergeMap(project, resultSelector, concurrent) {
    if (concurrent === void 0) concurrent = Number.POSITIVE_INFINITY;
    return function mergeMapOperatorFunction(source) {
        if (typeof resultSelector === 'number') {
            concurrent = resultSelector;
            resultSelector = null;
        }
        return source.lift(new $c2ff20ad66810fb7$var$MergeMapOperator(project, resultSelector, concurrent));
    };
}
module.exports.mergeMap = $c2ff20ad66810fb7$var$mergeMap;
var $c2ff20ad66810fb7$var$MergeMapOperator = function() {
    function MergeMapOperator(project, resultSelector, concurrent) {
        if (concurrent === void 0) concurrent = Number.POSITIVE_INFINITY;
        this.project = project;
        this.resultSelector = resultSelector;
        this.concurrent = concurrent;
    }
    MergeMapOperator.prototype.call = function(observer, source) {
        return source.subscribe(new $c2ff20ad66810fb7$var$MergeMapSubscriber(observer, this.project, this.resultSelector, this.concurrent));
    };
    return MergeMapOperator;
}();
module.exports.MergeMapOperator = $c2ff20ad66810fb7$var$MergeMapOperator;
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $c2ff20ad66810fb7$var$MergeMapSubscriber = function(_super) {
    $c2ff20ad66810fb7$var$__extends(MergeMapSubscriber, _super);
    function MergeMapSubscriber(destination, project, resultSelector, concurrent) {
        if (concurrent === void 0) concurrent = Number.POSITIVE_INFINITY;
        _super.call(this, destination);
        this.project = project;
        this.resultSelector = resultSelector;
        this.concurrent = concurrent;
        this.hasCompleted = false;
        this.buffer = [];
        this.active = 0;
        this.index = 0;
    }
    MergeMapSubscriber.prototype._next = function(value) {
        if (this.active < this.concurrent) this._tryNext(value);
        else this.buffer.push(value);
    };
    MergeMapSubscriber.prototype._tryNext = function(value) {
        var result;
        var index = this.index++;
        try {
            result = this.project(value, index);
        } catch (err) {
            this.destination.error(err);
            return;
        }
        this.active++;
        this._innerSub(result, value, index);
    };
    MergeMapSubscriber.prototype._innerSub = function(ish, value, index) {
        this.add($5PwgB.subscribeToResult(this, ish, value, index));
    };
    MergeMapSubscriber.prototype._complete = function() {
        this.hasCompleted = true;
        if (this.active === 0 && this.buffer.length === 0) this.destination.complete();
    };
    MergeMapSubscriber.prototype.notifyNext = function(outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        if (this.resultSelector) this._notifyResultSelector(outerValue, innerValue, outerIndex, innerIndex);
        else this.destination.next(innerValue);
    };
    MergeMapSubscriber.prototype._notifyResultSelector = function(outerValue, innerValue, outerIndex, innerIndex) {
        var result;
        try {
            result = this.resultSelector(outerValue, innerValue, outerIndex, innerIndex);
        } catch (err) {
            this.destination.error(err);
            return;
        }
        this.destination.next(result);
    };
    MergeMapSubscriber.prototype.notifyComplete = function(innerSub) {
        var buffer = this.buffer;
        this.remove(innerSub);
        this.active--;
        if (buffer.length > 0) this._next(buffer.shift());
        else if (this.active === 0 && this.hasCompleted) this.destination.complete();
    };
    return MergeMapSubscriber;
}($jYuxp.OuterSubscriber);
module.exports.MergeMapSubscriber = $c2ff20ad66810fb7$var$MergeMapSubscriber;

});
parcelRegister("5PwgB", function(module, exports) {
$parcel$export(module.exports, "subscribeToResult", () => $43eabeb18a525937$export$d0604af3321cfb1b, (v) => $43eabeb18a525937$export$d0604af3321cfb1b = v);
var $43eabeb18a525937$export$d0604af3321cfb1b;
"use strict";

var $gvBTr = parcelRequire("gvBTr");

var $7ZlqO = parcelRequire("7ZlqO");

var $dA7Lt = parcelRequire("dA7Lt");

var $9DdIv = parcelRequire("9DdIv");

var $lryMy = parcelRequire("lryMy");

var $5DE9G = parcelRequire("5DE9G");

var $5RidA = parcelRequire("5RidA");

var $gZzrm = parcelRequire("gZzrm");
function $43eabeb18a525937$var$subscribeToResult(outerSubscriber, result, outerValue, outerIndex) {
    var destination = new $5RidA.InnerSubscriber(outerSubscriber, outerValue, outerIndex);
    if (destination.closed) return null;
    if (result instanceof $lryMy.Observable) {
        if (result._isScalar) {
            destination.next(result.value);
            destination.complete();
            return null;
        } else {
            destination.syncErrorThrowable = true;
            return result.subscribe(destination);
        }
    } else if ($7ZlqO.isArrayLike(result)) {
        for(var i = 0, len = result.length; i < len && !destination.closed; i++)destination.next(result[i]);
        if (!destination.closed) destination.complete();
    } else if ($dA7Lt.isPromise(result)) {
        result.then(function(value) {
            if (!destination.closed) {
                destination.next(value);
                destination.complete();
            }
        }, function(err) {
            return destination.error(err);
        }).then(null, function(err) {
            // Escaping the Promise trap: globally throw unhandled errors
            $gvBTr.root.setTimeout(function() {
                throw err;
            });
        });
        return destination;
    } else if (result && typeof result[$5DE9G.iterator] === 'function') {
        var iterator = result[$5DE9G.iterator]();
        do {
            var item = iterator.next();
            if (item.done) {
                destination.complete();
                break;
            }
            destination.next(item.value);
            if (destination.closed) break;
        }while (true);
    } else if (result && typeof result[$gZzrm.observable] === 'function') {
        var obs = result[$gZzrm.observable]();
        if (typeof obs.subscribe !== 'function') destination.error(new TypeError('Provided object does not correctly implement Symbol.observable'));
        else return obs.subscribe(new $5RidA.InnerSubscriber(outerSubscriber, outerValue, outerIndex));
    } else {
        var value = $9DdIv.isObject(result) ? 'an invalid object' : "'" + result + "'";
        var msg = "You provided " + value + " where a stream was expected." + ' You can provide an Observable, Promise, Array, or Iterable.';
        destination.error(new TypeError(msg));
    }
    return null;
}
$43eabeb18a525937$export$d0604af3321cfb1b = $43eabeb18a525937$var$subscribeToResult;

});
parcelRegister("7ZlqO", function(module, exports) {
$parcel$export(module.exports, "isArrayLike", () => $5d0edabddbea6c06$export$1e2f57719e155213, (v) => $5d0edabddbea6c06$export$1e2f57719e155213 = v);
var $5d0edabddbea6c06$export$1e2f57719e155213;
"use strict";
$5d0edabddbea6c06$export$1e2f57719e155213 = function(x) {
    return x && typeof x.length === 'number';
};

});

parcelRegister("dA7Lt", function(module, exports) {
$parcel$export(module.exports, "isPromise", () => $9e34a9139b36a2ee$export$4369c812aac99591, (v) => $9e34a9139b36a2ee$export$4369c812aac99591 = v);
var $9e34a9139b36a2ee$export$4369c812aac99591;
"use strict";
function $9e34a9139b36a2ee$var$isPromise(value) {
    return value && typeof value.subscribe !== 'function' && typeof value.then === 'function';
}
$9e34a9139b36a2ee$export$4369c812aac99591 = $9e34a9139b36a2ee$var$isPromise;

});

parcelRegister("lryMy", function(module, exports) {
$parcel$export(module.exports, "Observable", () => $f9c7199560ef97cf$export$77cea355fa80b5f4, (v) => $f9c7199560ef97cf$export$77cea355fa80b5f4 = v);
var $f9c7199560ef97cf$export$77cea355fa80b5f4;
"use strict";

var $gvBTr = parcelRequire("gvBTr");

var $l87q3 = parcelRequire("l87q3");

var $gZzrm = parcelRequire("gZzrm");

var $lKsX2 = parcelRequire("lKsX2");
/**
 * A representation of any set of values over any amount of time. This is the most basic building block
 * of RxJS.
 *
 * @class Observable<T>
 */ var $f9c7199560ef97cf$var$Observable = function() {
    /**
     * @constructor
     * @param {Function} subscribe the function that is called when the Observable is
     * initially subscribed to. This function is given a Subscriber, to which new values
     * can be `next`ed, or an `error` method can be called to raise an error, or
     * `complete` can be called to notify of a successful completion.
     */ function Observable(subscribe) {
        this._isScalar = false;
        if (subscribe) this._subscribe = subscribe;
    }
    /**
     * Creates a new Observable, with this Observable as the source, and the passed
     * operator defined as the new observable's operator.
     * @method lift
     * @param {Operator} operator the operator defining the operation to take on the observable
     * @return {Observable} a new observable with the Operator applied
     */ Observable.prototype.lift = function(operator) {
        var observable = new Observable();
        observable.source = this;
        observable.operator = operator;
        return observable;
    };
    /**
     * Invokes an execution of an Observable and registers Observer handlers for notifications it will emit.
     *
     * <span class="informal">Use it when you have all these Observables, but still nothing is happening.</span>
     *
     * `subscribe` is not a regular operator, but a method that calls Observable's internal `subscribe` function. It
     * might be for example a function that you passed to a {@link create} static factory, but most of the time it is
     * a library implementation, which defines what and when will be emitted by an Observable. This means that calling
     * `subscribe` is actually the moment when Observable starts its work, not when it is created, as it is often
     * thought.
     *
     * Apart from starting the execution of an Observable, this method allows you to listen for values
     * that an Observable emits, as well as for when it completes or errors. You can achieve this in two
     * following ways.
     *
     * The first way is creating an object that implements {@link Observer} interface. It should have methods
     * defined by that interface, but note that it should be just a regular JavaScript object, which you can create
     * yourself in any way you want (ES6 class, classic function constructor, object literal etc.). In particular do
     * not attempt to use any RxJS implementation details to create Observers - you don't need them. Remember also
     * that your object does not have to implement all methods. If you find yourself creating a method that doesn't
     * do anything, you can simply omit it. Note however, that if `error` method is not provided, all errors will
     * be left uncaught.
     *
     * The second way is to give up on Observer object altogether and simply provide callback functions in place of its methods.
     * This means you can provide three functions as arguments to `subscribe`, where first function is equivalent
     * of a `next` method, second of an `error` method and third of a `complete` method. Just as in case of Observer,
     * if you do not need to listen for something, you can omit a function, preferably by passing `undefined` or `null`,
     * since `subscribe` recognizes these functions by where they were placed in function call. When it comes
     * to `error` function, just as before, if not provided, errors emitted by an Observable will be thrown.
     *
     * Whatever style of calling `subscribe` you use, in both cases it returns a Subscription object.
     * This object allows you to call `unsubscribe` on it, which in turn will stop work that an Observable does and will clean
     * up all resources that an Observable used. Note that cancelling a subscription will not call `complete` callback
     * provided to `subscribe` function, which is reserved for a regular completion signal that comes from an Observable.
     *
     * Remember that callbacks provided to `subscribe` are not guaranteed to be called asynchronously.
     * It is an Observable itself that decides when these functions will be called. For example {@link of}
     * by default emits all its values synchronously. Always check documentation for how given Observable
     * will behave when subscribed and if its default behavior can be modified with a {@link Scheduler}.
     *
     * @example <caption>Subscribe with an Observer</caption>
     * const sumObserver = {
     *   sum: 0,
     *   next(value) {
     *     console.log('Adding: ' + value);
     *     this.sum = this.sum + value;
     *   },
     *   error() { // We actually could just remove this method,
     *   },        // since we do not really care about errors right now.
     *   complete() {
     *     console.log('Sum equals: ' + this.sum);
     *   }
     * };
     *
     * Rx.Observable.of(1, 2, 3) // Synchronously emits 1, 2, 3 and then completes.
     * .subscribe(sumObserver);
     *
     * // Logs:
     * // "Adding: 1"
     * // "Adding: 2"
     * // "Adding: 3"
     * // "Sum equals: 6"
     *
     *
     * @example <caption>Subscribe with functions</caption>
     * let sum = 0;
     *
     * Rx.Observable.of(1, 2, 3)
     * .subscribe(
     *   function(value) {
     *     console.log('Adding: ' + value);
     *     sum = sum + value;
     *   },
     *   undefined,
     *   function() {
     *     console.log('Sum equals: ' + sum);
     *   }
     * );
     *
     * // Logs:
     * // "Adding: 1"
     * // "Adding: 2"
     * // "Adding: 3"
     * // "Sum equals: 6"
     *
     *
     * @example <caption>Cancel a subscription</caption>
     * const subscription = Rx.Observable.interval(1000).subscribe(
     *   num => console.log(num),
     *   undefined,
     *   () => console.log('completed!') // Will not be called, even
     * );                                // when cancelling subscription
     *
     *
     * setTimeout(() => {
     *   subscription.unsubscribe();
     *   console.log('unsubscribed!');
     * }, 2500);
     *
     * // Logs:
     * // 0 after 1s
     * // 1 after 2s
     * // "unsubscribed!" after 2.5s
     *
     *
     * @param {Observer|Function} observerOrNext (optional) Either an observer with methods to be called,
     *  or the first of three possible handlers, which is the handler for each value emitted from the subscribed
     *  Observable.
     * @param {Function} error (optional) A handler for a terminal event resulting from an error. If no error handler is provided,
     *  the error will be thrown as unhandled.
     * @param {Function} complete (optional) A handler for a terminal event resulting from successful completion.
     * @return {ISubscription} a subscription reference to the registered handlers
     * @method subscribe
     */ Observable.prototype.subscribe = function(observerOrNext, error, complete) {
        var operator = this.operator;
        var sink = $l87q3.toSubscriber(observerOrNext, error, complete);
        if (operator) operator.call(sink, this.source);
        else sink.add(this.source || !sink.syncErrorThrowable ? this._subscribe(sink) : this._trySubscribe(sink));
        if (sink.syncErrorThrowable) {
            sink.syncErrorThrowable = false;
            if (sink.syncErrorThrown) throw sink.syncErrorValue;
        }
        return sink;
    };
    Observable.prototype._trySubscribe = function(sink) {
        try {
            return this._subscribe(sink);
        } catch (err) {
            sink.syncErrorThrown = true;
            sink.syncErrorValue = err;
            sink.error(err);
        }
    };
    /**
     * @method forEach
     * @param {Function} next a handler for each value emitted by the observable
     * @param {PromiseConstructor} [PromiseCtor] a constructor function used to instantiate the Promise
     * @return {Promise} a promise that either resolves on observable completion or
     *  rejects with the handled error
     */ Observable.prototype.forEach = function(next, PromiseCtor) {
        var _this = this;
        if (!PromiseCtor) {
            if ($gvBTr.root.Rx && $gvBTr.root.Rx.config && $gvBTr.root.Rx.config.Promise) PromiseCtor = $gvBTr.root.Rx.config.Promise;
            else if ($gvBTr.root.Promise) PromiseCtor = $gvBTr.root.Promise;
        }
        if (!PromiseCtor) throw new Error('no Promise impl found');
        return new PromiseCtor(function(resolve, reject) {
            // Must be declared in a separate statement to avoid a RefernceError when
            // accessing subscription below in the closure due to Temporal Dead Zone.
            var subscription;
            subscription = _this.subscribe(function(value) {
                if (subscription) // if there is a subscription, then we can surmise
                // the next handling is asynchronous. Any errors thrown
                // need to be rejected explicitly and unsubscribe must be
                // called manually
                try {
                    next(value);
                } catch (err) {
                    reject(err);
                    subscription.unsubscribe();
                }
                else // if there is NO subscription, then we're getting a nexted
                // value synchronously during subscription. We can just call it.
                // If it errors, Observable's `subscribe` will ensure the
                // unsubscription logic is called, then synchronously rethrow the error.
                // After that, Promise will trap the error and send it
                // down the rejection path.
                next(value);
            }, reject, resolve);
        });
    };
    /** @deprecated internal use only */ Observable.prototype._subscribe = function(subscriber) {
        return this.source.subscribe(subscriber);
    };
    /**
     * An interop point defined by the es7-observable spec https://github.com/zenparsing/es-observable
     * @method Symbol.observable
     * @return {Observable} this instance of the observable
     */ Observable.prototype[$gZzrm.observable] = function() {
        return this;
    };
    /* tslint:enable:max-line-length */ /**
     * Used to stitch together functional operators into a chain.
     * @method pipe
     * @return {Observable} the Observable result of all of the operators having
     * been called in the order they were passed in.
     *
     * @example
     *
     * import { map, filter, scan } from 'rxjs/operators';
     *
     * Rx.Observable.interval(1000)
     *   .pipe(
     *     filter(x => x % 2 === 0),
     *     map(x => x + x),
     *     scan((acc, x) => acc + x)
     *   )
     *   .subscribe(x => console.log(x))
     */ Observable.prototype.pipe = function() {
        var operations = [];
        for(var _i = 0; _i < arguments.length; _i++)operations[_i - 0] = arguments[_i];
        if (operations.length === 0) return this;
        return $lKsX2.pipeFromArray(operations)(this);
    };
    /* tslint:enable:max-line-length */ Observable.prototype.toPromise = function(PromiseCtor) {
        var _this = this;
        if (!PromiseCtor) {
            if ($gvBTr.root.Rx && $gvBTr.root.Rx.config && $gvBTr.root.Rx.config.Promise) PromiseCtor = $gvBTr.root.Rx.config.Promise;
            else if ($gvBTr.root.Promise) PromiseCtor = $gvBTr.root.Promise;
        }
        if (!PromiseCtor) throw new Error('no Promise impl found');
        return new PromiseCtor(function(resolve, reject) {
            var value;
            _this.subscribe(function(x) {
                return value = x;
            }, function(err) {
                return reject(err);
            }, function() {
                return resolve(value);
            });
        });
    };
    // HACK: Since TypeScript inherits static properties too, we have to
    // fight against TypeScript here so Subject can have a different static create signature
    /**
     * Creates a new cold Observable by calling the Observable constructor
     * @static true
     * @owner Observable
     * @method create
     * @param {Function} subscribe? the subscriber function to be passed to the Observable constructor
     * @return {Observable} a new cold observable
     */ Observable.create = function(subscribe) {
        return new Observable(subscribe);
    };
    return Observable;
}();
$f9c7199560ef97cf$export$77cea355fa80b5f4 = $f9c7199560ef97cf$var$Observable;

});
parcelRegister("l87q3", function(module, exports) {
$parcel$export(module.exports, "toSubscriber", () => $f62019a79f564d5a$export$2a12c2cebbfd1087, (v) => $f62019a79f564d5a$export$2a12c2cebbfd1087 = v);
var $f62019a79f564d5a$export$2a12c2cebbfd1087;
"use strict";

var $deMDi = parcelRequire("deMDi");

var $efmvI = parcelRequire("efmvI");

var $5cSKU = parcelRequire("5cSKU");
function $f62019a79f564d5a$var$toSubscriber(nextOrObserver, error, complete) {
    if (nextOrObserver) {
        if (nextOrObserver instanceof $deMDi.Subscriber) return nextOrObserver;
        if (nextOrObserver[$efmvI.rxSubscriber]) return nextOrObserver[$efmvI.rxSubscriber]();
    }
    if (!nextOrObserver && !error && !complete) return new $deMDi.Subscriber($5cSKU.empty);
    return new $deMDi.Subscriber(nextOrObserver, error, complete);
}
$f62019a79f564d5a$export$2a12c2cebbfd1087 = $f62019a79f564d5a$var$toSubscriber;

});

parcelRegister("gZzrm", function(module, exports) {
$parcel$export(module.exports, "observable", () => $c5edd58eaa5087c5$export$5ab46cbf6120b33a, (v) => $c5edd58eaa5087c5$export$5ab46cbf6120b33a = v);
var $c5edd58eaa5087c5$export$7e68bb2e8ecea8fe;
var $c5edd58eaa5087c5$export$5ab46cbf6120b33a;
/**
 * @deprecated use observable instead
 */ var $c5edd58eaa5087c5$export$a7c40509ff863847;
"use strict";

var $gvBTr = parcelRequire("gvBTr");
function $c5edd58eaa5087c5$var$getSymbolObservable(context) {
    var $$observable;
    var Symbol = context.Symbol;
    if (typeof Symbol === 'function') {
        if (Symbol.observable) $$observable = Symbol.observable;
        else {
            $$observable = Symbol('observable');
            Symbol.observable = $$observable;
        }
    } else $$observable = '@@observable';
    return $$observable;
}
$c5edd58eaa5087c5$export$7e68bb2e8ecea8fe = $c5edd58eaa5087c5$var$getSymbolObservable;
$c5edd58eaa5087c5$export$5ab46cbf6120b33a = $c5edd58eaa5087c5$var$getSymbolObservable($gvBTr.root);
$c5edd58eaa5087c5$export$a7c40509ff863847 = $c5edd58eaa5087c5$export$5ab46cbf6120b33a;

});

parcelRegister("lKsX2", function(module, exports) {
$parcel$export(module.exports, "pipe", () => $fd5459f2363759ca$export$a4627e546088548d, (v) => $fd5459f2363759ca$export$a4627e546088548d = v);
$parcel$export(module.exports, "pipeFromArray", () => $fd5459f2363759ca$export$71f88a61afaa14d7, (v) => $fd5459f2363759ca$export$71f88a61afaa14d7 = v);
var $fd5459f2363759ca$export$a4627e546088548d;
var $fd5459f2363759ca$export$71f88a61afaa14d7;
"use strict";

var $isVNb = parcelRequire("isVNb");
/* tslint:enable:max-line-length */ function $fd5459f2363759ca$var$pipe() {
    var fns = [];
    for(var _i = 0; _i < arguments.length; _i++)fns[_i - 0] = arguments[_i];
    return $fd5459f2363759ca$var$pipeFromArray(fns);
}
$fd5459f2363759ca$export$a4627e546088548d = $fd5459f2363759ca$var$pipe;
/* @internal */ function $fd5459f2363759ca$var$pipeFromArray(fns) {
    if (!fns) return $isVNb.noop;
    if (fns.length === 1) return fns[0];
    return function piped(input) {
        return fns.reduce(function(prev, fn) {
            return fn(prev);
        }, input);
    };
}
$fd5459f2363759ca$export$71f88a61afaa14d7 = $fd5459f2363759ca$var$pipeFromArray;

});
parcelRegister("isVNb", function(module, exports) {
$parcel$export(module.exports, "noop", () => $d717abe1e2078987$export$8793edee2d425525, (v) => $d717abe1e2078987$export$8793edee2d425525 = v);
var $d717abe1e2078987$export$8793edee2d425525;
"use strict";
/* tslint:disable:no-empty */ function $d717abe1e2078987$var$noop() {}
$d717abe1e2078987$export$8793edee2d425525 = $d717abe1e2078987$var$noop;

});



parcelRegister("5DE9G", function(module, exports) {
$parcel$export(module.exports, "iterator", () => $41afbe3e4eaf1cad$export$6f58e2338da23f4d, (v) => $41afbe3e4eaf1cad$export$6f58e2338da23f4d = v);
var $41afbe3e4eaf1cad$export$77b88d321d1c84c6;
var $41afbe3e4eaf1cad$export$6f58e2338da23f4d;
/**
 * @deprecated use iterator instead
 */ var $41afbe3e4eaf1cad$export$9785f547d3164dac;
"use strict";

var $gvBTr = parcelRequire("gvBTr");
function $41afbe3e4eaf1cad$var$symbolIteratorPonyfill(root) {
    var Symbol = root.Symbol;
    if (typeof Symbol === 'function') {
        if (!Symbol.iterator) Symbol.iterator = Symbol('iterator polyfill');
        return Symbol.iterator;
    } else {
        // [for Mozilla Gecko 27-35:](https://mzl.la/2ewE1zC)
        var Set_1 = root.Set;
        if (Set_1 && typeof new Set_1()['@@iterator'] === 'function') return '@@iterator';
        var Map_1 = root.Map;
        // required for compatability with es6-shim
        if (Map_1) {
            var keys = Object.getOwnPropertyNames(Map_1.prototype);
            for(var i = 0; i < keys.length; ++i){
                var key = keys[i];
                // according to spec, Map.prototype[@@iterator] and Map.orototype.entries must be equal.
                if (key !== 'entries' && key !== 'size' && Map_1.prototype[key] === Map_1.prototype['entries']) return key;
            }
        }
        return '@@iterator';
    }
}
$41afbe3e4eaf1cad$export$77b88d321d1c84c6 = $41afbe3e4eaf1cad$var$symbolIteratorPonyfill;
$41afbe3e4eaf1cad$export$6f58e2338da23f4d = $41afbe3e4eaf1cad$var$symbolIteratorPonyfill($gvBTr.root);
$41afbe3e4eaf1cad$export$9785f547d3164dac = $41afbe3e4eaf1cad$export$6f58e2338da23f4d;

});

parcelRegister("5RidA", function(module, exports) {
"use strict";
var $444008bbc306f96f$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $deMDi = parcelRequire("deMDi");
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $444008bbc306f96f$var$InnerSubscriber = function(_super) {
    $444008bbc306f96f$var$__extends(InnerSubscriber, _super);
    function InnerSubscriber(parent, outerValue, outerIndex) {
        _super.call(this);
        this.parent = parent;
        this.outerValue = outerValue;
        this.outerIndex = outerIndex;
        this.index = 0;
    }
    InnerSubscriber.prototype._next = function(value) {
        this.parent.notifyNext(this.outerValue, value, this.outerIndex, this.index++, this);
    };
    InnerSubscriber.prototype._error = function(error) {
        this.parent.notifyError(error, this);
        this.unsubscribe();
    };
    InnerSubscriber.prototype._complete = function() {
        this.parent.notifyComplete(this);
        this.unsubscribe();
    };
    return InnerSubscriber;
}($deMDi.Subscriber);
module.exports.InnerSubscriber = $444008bbc306f96f$var$InnerSubscriber;

});


parcelRegister("jYuxp", function(module, exports) {
"use strict";
var $e8ab4f1ec1b2af94$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $deMDi = parcelRequire("deMDi");
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $e8ab4f1ec1b2af94$var$OuterSubscriber = function(_super) {
    $e8ab4f1ec1b2af94$var$__extends(OuterSubscriber, _super);
    function OuterSubscriber() {
        _super.apply(this, arguments);
    }
    OuterSubscriber.prototype.notifyNext = function(outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        this.destination.next(innerValue);
    };
    OuterSubscriber.prototype.notifyError = function(error, innerSub) {
        this.destination.error(error);
    };
    OuterSubscriber.prototype.notifyComplete = function(innerSub) {
        this.destination.complete();
    };
    return OuterSubscriber;
}($deMDi.Subscriber);
module.exports.OuterSubscriber = $e8ab4f1ec1b2af94$var$OuterSubscriber;

});



parcelRegister("jmcbD", function(module, exports) {
"use strict";
var $e179866bda1f0b9e$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $deMDi = parcelRequire("deMDi");
/**
 * Buffers the source Observable values until the size hits the maximum
 * `bufferSize` given.
 *
 * <span class="informal">Collects values from the past as an array, and emits
 * that array only when its size reaches `bufferSize`.</span>
 *
 * <img src="./img/bufferCount.png" width="100%">
 *
 * Buffers a number of values from the source Observable by `bufferSize` then
 * emits the buffer and clears it, and starts a new buffer each
 * `startBufferEvery` values. If `startBufferEvery` is not provided or is
 * `null`, then new buffers are started immediately at the start of the source
 * and when each buffer closes and is emitted.
 *
 * @example <caption>Emit the last two click events as an array</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var buffered = clicks.bufferCount(2);
 * buffered.subscribe(x => console.log(x));
 *
 * @example <caption>On every click, emit the last two click events as an array</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var buffered = clicks.bufferCount(2, 1);
 * buffered.subscribe(x => console.log(x));
 *
 * @see {@link buffer}
 * @see {@link bufferTime}
 * @see {@link bufferToggle}
 * @see {@link bufferWhen}
 * @see {@link pairwise}
 * @see {@link windowCount}
 *
 * @param {number} bufferSize The maximum size of the buffer emitted.
 * @param {number} [startBufferEvery] Interval at which to start a new buffer.
 * For example if `startBufferEvery` is `2`, then a new buffer will be started
 * on every other value from the source. A new buffer is started at the
 * beginning of the source by default.
 * @return {Observable<T[]>} An Observable of arrays of buffered values.
 * @method bufferCount
 * @owner Observable
 */ function $e179866bda1f0b9e$var$bufferCount(bufferSize, startBufferEvery) {
    if (startBufferEvery === void 0) startBufferEvery = null;
    return function bufferCountOperatorFunction(source) {
        return source.lift(new $e179866bda1f0b9e$var$BufferCountOperator(bufferSize, startBufferEvery));
    };
}
module.exports.bufferCount = $e179866bda1f0b9e$var$bufferCount;
var $e179866bda1f0b9e$var$BufferCountOperator = function() {
    function BufferCountOperator(bufferSize, startBufferEvery) {
        this.bufferSize = bufferSize;
        this.startBufferEvery = startBufferEvery;
        if (!startBufferEvery || bufferSize === startBufferEvery) this.subscriberClass = $e179866bda1f0b9e$var$BufferCountSubscriber;
        else this.subscriberClass = $e179866bda1f0b9e$var$BufferSkipCountSubscriber;
    }
    BufferCountOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new this.subscriberClass(subscriber, this.bufferSize, this.startBufferEvery));
    };
    return BufferCountOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $e179866bda1f0b9e$var$BufferCountSubscriber = function(_super) {
    $e179866bda1f0b9e$var$__extends(BufferCountSubscriber, _super);
    function BufferCountSubscriber(destination, bufferSize) {
        _super.call(this, destination);
        this.bufferSize = bufferSize;
        this.buffer = [];
    }
    BufferCountSubscriber.prototype._next = function(value) {
        var buffer = this.buffer;
        buffer.push(value);
        if (buffer.length == this.bufferSize) {
            this.destination.next(buffer);
            this.buffer = [];
        }
    };
    BufferCountSubscriber.prototype._complete = function() {
        var buffer = this.buffer;
        if (buffer.length > 0) this.destination.next(buffer);
        _super.prototype._complete.call(this);
    };
    return BufferCountSubscriber;
}($deMDi.Subscriber);
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $e179866bda1f0b9e$var$BufferSkipCountSubscriber = function(_super) {
    $e179866bda1f0b9e$var$__extends(BufferSkipCountSubscriber, _super);
    function BufferSkipCountSubscriber(destination, bufferSize, startBufferEvery) {
        _super.call(this, destination);
        this.bufferSize = bufferSize;
        this.startBufferEvery = startBufferEvery;
        this.buffers = [];
        this.count = 0;
    }
    BufferSkipCountSubscriber.prototype._next = function(value) {
        var _a = this, bufferSize = _a.bufferSize, startBufferEvery = _a.startBufferEvery, buffers = _a.buffers, count = _a.count;
        this.count++;
        if (count % startBufferEvery === 0) buffers.push([]);
        for(var i = buffers.length; i--;){
            var buffer = buffers[i];
            buffer.push(value);
            if (buffer.length === bufferSize) {
                buffers.splice(i, 1);
                this.destination.next(buffer);
            }
        }
    };
    BufferSkipCountSubscriber.prototype._complete = function() {
        var _a = this, buffers = _a.buffers, destination = _a.destination;
        while(buffers.length > 0){
            var buffer = buffers.shift();
            if (buffer.length > 0) destination.next(buffer);
        }
        _super.prototype._complete.call(this);
    };
    return BufferSkipCountSubscriber;
}($deMDi.Subscriber);

});

parcelRegister("aG6Au", function(module, exports) {
$parcel$export(module.exports, "fromPromise", () => $7c62efc162992332$export$60f45028237c39d1, (v) => $7c62efc162992332$export$60f45028237c39d1 = v);
var $7c62efc162992332$export$60f45028237c39d1;
"use strict";

var $4aw8t = parcelRequire("4aw8t");
$7c62efc162992332$export$60f45028237c39d1 = $4aw8t.PromiseObservable.create;

});
parcelRegister("4aw8t", function(module, exports) {
"use strict";
var $3091060d93ffcfba$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $gvBTr = parcelRequire("gvBTr");

var $lryMy = parcelRequire("lryMy");
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @extends {Ignored}
 * @hide true
 */ var $3091060d93ffcfba$var$PromiseObservable = function(_super) {
    $3091060d93ffcfba$var$__extends(PromiseObservable, _super);
    function PromiseObservable(promise, scheduler) {
        _super.call(this);
        this.promise = promise;
        this.scheduler = scheduler;
    }
    /**
     * Converts a Promise to an Observable.
     *
     * <span class="informal">Returns an Observable that just emits the Promise's
     * resolved value, then completes.</span>
     *
     * Converts an ES2015 Promise or a Promises/A+ spec compliant Promise to an
     * Observable. If the Promise resolves with a value, the output Observable
     * emits that resolved value as a `next`, and then completes. If the Promise
     * is rejected, then the output Observable emits the corresponding Error.
     *
     * @example <caption>Convert the Promise returned by Fetch to an Observable</caption>
     * var result = Rx.Observable.fromPromise(fetch('http://myserver.com/'));
     * result.subscribe(x => console.log(x), e => console.error(e));
     *
     * @see {@link bindCallback}
     * @see {@link from}
     *
     * @param {PromiseLike<T>} promise The promise to be converted.
     * @param {Scheduler} [scheduler] An optional IScheduler to use for scheduling
     * the delivery of the resolved value (or the rejection).
     * @return {Observable<T>} An Observable which wraps the Promise.
     * @static true
     * @name fromPromise
     * @owner Observable
     */ PromiseObservable.create = function(promise, scheduler) {
        return new PromiseObservable(promise, scheduler);
    };
    /** @deprecated internal use only */ PromiseObservable.prototype._subscribe = function(subscriber) {
        var _this = this;
        var promise = this.promise;
        var scheduler = this.scheduler;
        if (scheduler == null) {
            if (this._isScalar) {
                if (!subscriber.closed) {
                    subscriber.next(this.value);
                    subscriber.complete();
                }
            } else promise.then(function(value) {
                _this.value = value;
                _this._isScalar = true;
                if (!subscriber.closed) {
                    subscriber.next(value);
                    subscriber.complete();
                }
            }, function(err) {
                if (!subscriber.closed) subscriber.error(err);
            }).then(null, function(err) {
                // escape the promise trap, throw unhandled errors
                $gvBTr.root.setTimeout(function() {
                    throw err;
                });
            });
        } else if (this._isScalar) {
            if (!subscriber.closed) return scheduler.schedule($3091060d93ffcfba$var$dispatchNext, 0, {
                value: this.value,
                subscriber: subscriber
            });
        } else promise.then(function(value) {
            _this.value = value;
            _this._isScalar = true;
            if (!subscriber.closed) subscriber.add(scheduler.schedule($3091060d93ffcfba$var$dispatchNext, 0, {
                value: value,
                subscriber: subscriber
            }));
        }, function(err) {
            if (!subscriber.closed) subscriber.add(scheduler.schedule($3091060d93ffcfba$var$dispatchError, 0, {
                err: err,
                subscriber: subscriber
            }));
        }).then(null, function(err) {
            // escape the promise trap, throw unhandled errors
            $gvBTr.root.setTimeout(function() {
                throw err;
            });
        });
    };
    return PromiseObservable;
}($lryMy.Observable);
module.exports.PromiseObservable = $3091060d93ffcfba$var$PromiseObservable;
function $3091060d93ffcfba$var$dispatchNext(arg) {
    var value = arg.value, subscriber = arg.subscriber;
    if (!subscriber.closed) {
        subscriber.next(value);
        subscriber.complete();
    }
}
function $3091060d93ffcfba$var$dispatchError(arg) {
    var err = arg.err, subscriber = arg.subscriber;
    if (!subscriber.closed) subscriber.error(err);
}

});


parcelRegister("9zDuU", function(module, exports) {
$parcel$export(module.exports, "slicenator", () => $6f8605540734d9d1$export$5b92d769f2f57509);

var $lKCed = parcelRequire("lKCed");

var $blmL7 = parcelRequire("blmL7");
var $6f8605540734d9d1$export$5b92d769f2f57509 = function slicenator(blob, _ref) {
    var chunkSize = _ref.size;
    var totalChunks = Math.ceil(blob.size / chunkSize);
    return (0, $lKCed.range)(0, totalChunks).pipe((0, $blmL7.map)(function(index) {
        return {
            partNumber: index + 1,
            blob: blob.slice(index * chunkSize, (index + 1) * chunkSize)
        };
    }));
};

});
parcelRegister("lKCed", function(module, exports) {
$parcel$export(module.exports, "range", () => $fd5b8c2d9cc59a77$export$d02631cccf789723, (v) => $fd5b8c2d9cc59a77$export$d02631cccf789723 = v);
var $fd5b8c2d9cc59a77$export$d02631cccf789723;
"use strict";

var $3Qhuq = parcelRequire("3Qhuq");
$fd5b8c2d9cc59a77$export$d02631cccf789723 = $3Qhuq.RangeObservable.create;

});
parcelRegister("3Qhuq", function(module, exports) {
"use strict";
var $2cc3cb82bf324c8e$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $lryMy = parcelRequire("lryMy");
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @extends {Ignored}
 * @hide true
 */ var $2cc3cb82bf324c8e$var$RangeObservable = function(_super) {
    $2cc3cb82bf324c8e$var$__extends(RangeObservable, _super);
    function RangeObservable(start, count, scheduler) {
        _super.call(this);
        this.start = start;
        this._count = count;
        this.scheduler = scheduler;
    }
    /**
     * Creates an Observable that emits a sequence of numbers within a specified
     * range.
     *
     * <span class="informal">Emits a sequence of numbers in a range.</span>
     *
     * <img src="./img/range.png" width="100%">
     *
     * `range` operator emits a range of sequential integers, in order, where you
     * select the `start` of the range and its `length`. By default, uses no
     * IScheduler and just delivers the notifications synchronously, but may use
     * an optional IScheduler to regulate those deliveries.
     *
     * @example <caption>Emits the numbers 1 to 10</caption>
     * var numbers = Rx.Observable.range(1, 10);
     * numbers.subscribe(x => console.log(x));
     *
     * @see {@link timer}
     * @see {@link interval}
     *
     * @param {number} [start=0] The value of the first integer in the sequence.
     * @param {number} [count=0] The number of sequential integers to generate.
     * @param {Scheduler} [scheduler] A {@link IScheduler} to use for scheduling
     * the emissions of the notifications.
     * @return {Observable} An Observable of numbers that emits a finite range of
     * sequential integers.
     * @static true
     * @name range
     * @owner Observable
     */ RangeObservable.create = function(start, count, scheduler) {
        if (start === void 0) start = 0;
        if (count === void 0) count = 0;
        return new RangeObservable(start, count, scheduler);
    };
    RangeObservable.dispatch = function(state) {
        var start = state.start, index = state.index, count = state.count, subscriber = state.subscriber;
        if (index >= count) {
            subscriber.complete();
            return;
        }
        subscriber.next(start);
        if (subscriber.closed) return;
        state.index = index + 1;
        state.start = start + 1;
        this.schedule(state);
    };
    /** @deprecated internal use only */ RangeObservable.prototype._subscribe = function(subscriber) {
        var index = 0;
        var start = this.start;
        var count = this._count;
        var scheduler = this.scheduler;
        if (scheduler) return scheduler.schedule(RangeObservable.dispatch, 0, {
            index: index,
            count: count,
            start: start,
            subscriber: subscriber
        });
        else do {
            if (index++ >= count) {
                subscriber.complete();
                break;
            }
            subscriber.next(start++);
            if (subscriber.closed) break;
        }while (true);
    };
    return RangeObservable;
}($lryMy.Observable);
module.exports.RangeObservable = $2cc3cb82bf324c8e$var$RangeObservable;

});



parcelRegister("l4WxA", function(module, exports) {
$parcel$export(module.exports, "hashinator", () => $f58761afa3859fc7$export$d5f5a550a38ec367);

var $2Hz6m = parcelRequire("2Hz6m");
var $f58761afa3859fc7$export$28a452a485721473 = function blobToHashedBlob(hasher) {
    return function(slicedBlob) {
        return hasher(slicedBlob.blob).then(function(hash) {
            return {
                blob: slicedBlob.blob,
                hash: "".concat(hash, "-").concat(slicedBlob.blob.size),
                partNumber: slicedBlob.partNumber
            };
        });
    };
};
var $f58761afa3859fc7$export$d5f5a550a38ec367 = function hashinator(blobs$, _ref) {
    var hasher = _ref.hasher, concurrency = _ref.concurrency;
    return (0, $2Hz6m.asyncMap)($f58761afa3859fc7$export$28a452a485721473(hasher), concurrency)(blobs$);
};

});
parcelRegister("2Hz6m", function(module, exports) {
$parcel$export(module.exports, "fetchBlob", () => $1f7ad3602a8fa95c$export$14e9cfd4a872cc1e);
$parcel$export(module.exports, "asyncMap", () => $1f7ad3602a8fa95c$export$707ee4c4c95d39e3);

var $fL8KA = parcelRequire("fL8KA");

var $6HG4S = parcelRequire("6HG4S");

var $lryMy = parcelRequire("lryMy");

var $gJXF1 = parcelRequire("gJXF1");
function $1f7ad3602a8fa95c$export$14e9cfd4a872cc1e(_x) {
    return $1f7ad3602a8fa95c$var$_fetchBlob.apply(this, arguments);
}
function $1f7ad3602a8fa95c$var$_fetchBlob() {
    $1f7ad3602a8fa95c$var$_fetchBlob = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee(file) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee$(_context) {
            while(true)switch(_context.prev = _context.next){
                case 0:
                    if (!(typeof file === 'string')) {
                        _context.next = 6;
                        break;
                    }
                    _context.next = 3;
                    return fetch(file).then(function(response) {
                        return response.blob();
                    });
                case 3:
                    return _context.abrupt("return", _context.sent);
                case 6:
                    return _context.abrupt("return", file);
                case 7:
                case "end":
                    return _context.stop();
            }
        }, _callee);
    }));
    return $1f7ad3602a8fa95c$var$_fetchBlob.apply(this, arguments);
}
var $1f7ad3602a8fa95c$var$notify = function notify(promise, observer, onReady) {
    var notifier = {
        notifyIfReady: function notifyIfReady() {
            return false;
        }
    };
    promise.then(function(value) {
        notifier.notifyIfReady = function() {
            observer.next(value);
            observer.complete();
            return true;
        };
        onReady(notifier);
    }, function(reason) {
        notifier.notifyIfReady = function() {
            observer.error(reason);
            return true;
        };
        onReady(notifier);
    });
    return notifier;
};
var $1f7ad3602a8fa95c$var$mapper = function mapper(project) {
    var notifiers = new Array();
    var onReady = function onReady() {
        // find the first non-ready notifier in the queue,
        // while invoking all ready notifiers that we encounter along the way
        var notReadyIdx = notifiers.findIndex(function(notifier) {
            return !notifier.notifyIfReady();
        });
        if (notReadyIdx > 0) // remove all the notifiers we invoked
        notifiers.splice(0, notReadyIdx);
    };
    return function(value) {
        return new (0, $lryMy.Observable)(function(sub) {
            notifiers.push($1f7ad3602a8fa95c$var$notify(project(value), sub, onReady));
        });
    };
};
var $1f7ad3602a8fa95c$export$707ee4c4c95d39e3 = function asyncMap(project, concurrent) {
    return (0, $gJXF1.mergeMap)($1f7ad3602a8fa95c$var$mapper(project), concurrent);
};

});


parcelRegister("k2B16", function(module, exports) {
$parcel$export(module.exports, "uploadinator", () => $e970b54ee8cc29c8$export$94ce0f3fcf999415);

var $2Hz6m = parcelRequire("2Hz6m");
var $e970b54ee8cc29c8$export$94ce0f3fcf999415 = function uploadinator(blobs$, options) {
    var upload = function upload(blob) {
        return options.uploader(blob).then(function() {
            return blob;
        });
    };
    return blobs$.pipe((0, $2Hz6m.asyncMap)(upload, options.concurrency));
};

});

parcelRegister("govPu", function(module, exports) {
$parcel$export(module.exports, "processinator", () => $bef793e3760d319a$export$2f21790600302ed);

var $jmcbD = parcelRequire("jmcbD");

var $hU1R1 = parcelRequire("hU1R1");
var $bef793e3760d319a$export$2f21790600302ed = function processinator(blobs$, options) {
    var process = function process(blobs) {
        if (options.processor) return options.processor(blobs).then(function() {
            return blobs;
        });
        else return Promise.resolve(blobs);
    };
    return blobs$.pipe((0, $jmcbD.bufferCount)(options.batchSize)).pipe((0, $hU1R1.concatMap)(process));
};

});

parcelRegister("1zWpA", function(module, exports) {
$parcel$export(module.exports, "from", () => $12665eaa35af72c8$export$6788812c4e6611e6, (v) => $12665eaa35af72c8$export$6788812c4e6611e6 = v);
var $12665eaa35af72c8$export$6788812c4e6611e6;
"use strict";

var $l7nhh = parcelRequire("l7nhh");
$12665eaa35af72c8$export$6788812c4e6611e6 = $l7nhh.FromObservable.create;

});
parcelRegister("l7nhh", function(module, exports) {
"use strict";
var $f5fc4ee3c0e1abb4$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $PE2Cj = parcelRequire("PE2Cj");

var $7ZlqO = parcelRequire("7ZlqO");

var $dA7Lt = parcelRequire("dA7Lt");

var $4aw8t = parcelRequire("4aw8t");

var $jb6uA = parcelRequire("jb6uA");

var $603ID = parcelRequire("603ID");

var $7yiVr = parcelRequire("7yiVr");

var $5DE9G = parcelRequire("5DE9G");

var $lryMy = parcelRequire("lryMy");

var $lPK1b = parcelRequire("lPK1b");

var $gZzrm = parcelRequire("gZzrm");
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @extends {Ignored}
 * @hide true
 */ var $f5fc4ee3c0e1abb4$var$FromObservable = function(_super) {
    $f5fc4ee3c0e1abb4$var$__extends(FromObservable, _super);
    function FromObservable(ish, scheduler) {
        _super.call(this, null);
        this.ish = ish;
        this.scheduler = scheduler;
    }
    /**
     * Creates an Observable from an Array, an array-like object, a Promise, an
     * iterable object, or an Observable-like object.
     *
     * <span class="informal">Converts almost anything to an Observable.</span>
     *
     * <img src="./img/from.png" width="100%">
     *
     * Convert various other objects and data types into Observables. `from`
     * converts a Promise or an array-like or an
     * [iterable](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Iteration_protocols#iterable)
     * object into an Observable that emits the items in that promise or array or
     * iterable. A String, in this context, is treated as an array of characters.
     * Observable-like objects (contains a function named with the ES2015 Symbol
     * for Observable) can also be converted through this operator.
     *
     * @example <caption>Converts an array to an Observable</caption>
     * var array = [10, 20, 30];
     * var result = Rx.Observable.from(array);
     * result.subscribe(x => console.log(x));
     *
     * // Results in the following:
     * // 10 20 30
     *
     * @example <caption>Convert an infinite iterable (from a generator) to an Observable</caption>
     * function* generateDoubles(seed) {
     *   var i = seed;
     *   while (true) {
     *     yield i;
     *     i = 2 * i; // double it
     *   }
     * }
     *
     * var iterator = generateDoubles(3);
     * var result = Rx.Observable.from(iterator).take(10);
     * result.subscribe(x => console.log(x));
     *
     * // Results in the following:
     * // 3 6 12 24 48 96 192 384 768 1536
     *
     * @see {@link create}
     * @see {@link fromEvent}
     * @see {@link fromEventPattern}
     * @see {@link fromPromise}
     *
     * @param {ObservableInput<T>} ish A subscribable object, a Promise, an
     * Observable-like, an Array, an iterable or an array-like object to be
     * converted.
     * @param {Scheduler} [scheduler] The scheduler on which to schedule the
     * emissions of values.
     * @return {Observable<T>} The Observable whose values are originally from the
     * input object that was converted.
     * @static true
     * @name from
     * @owner Observable
     */ FromObservable.create = function(ish, scheduler) {
        if (ish != null) {
            if (typeof ish[$gZzrm.observable] === 'function') {
                if (ish instanceof $lryMy.Observable && !scheduler) return ish;
                return new FromObservable(ish, scheduler);
            } else if ($PE2Cj.isArray(ish)) return new $603ID.ArrayObservable(ish, scheduler);
            else if ($dA7Lt.isPromise(ish)) return new $4aw8t.PromiseObservable(ish, scheduler);
            else if (typeof ish[$5DE9G.iterator] === 'function' || typeof ish === 'string') return new $jb6uA.IteratorObservable(ish, scheduler);
            else if ($7ZlqO.isArrayLike(ish)) return new $7yiVr.ArrayLikeObservable(ish, scheduler);
        }
        throw new TypeError((ish !== null && typeof ish || ish) + ' is not observable');
    };
    /** @deprecated internal use only */ FromObservable.prototype._subscribe = function(subscriber) {
        var ish = this.ish;
        var scheduler = this.scheduler;
        if (scheduler == null) return ish[$gZzrm.observable]().subscribe(subscriber);
        else return ish[$gZzrm.observable]().subscribe(new $lPK1b.ObserveOnSubscriber(subscriber, scheduler, 0));
    };
    return FromObservable;
}($lryMy.Observable);
module.exports.FromObservable = $f5fc4ee3c0e1abb4$var$FromObservable;

});
parcelRegister("jb6uA", function(module, exports) {
"use strict";
var $df6414a74b370c12$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $gvBTr = parcelRequire("gvBTr");

var $lryMy = parcelRequire("lryMy");

var $5DE9G = parcelRequire("5DE9G");
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @extends {Ignored}
 * @hide true
 */ var $df6414a74b370c12$var$IteratorObservable = function(_super) {
    $df6414a74b370c12$var$__extends(IteratorObservable, _super);
    function IteratorObservable(iterator, scheduler) {
        _super.call(this);
        this.scheduler = scheduler;
        if (iterator == null) throw new Error('iterator cannot be null.');
        this.iterator = $df6414a74b370c12$var$getIterator(iterator);
    }
    IteratorObservable.create = function(iterator, scheduler) {
        return new IteratorObservable(iterator, scheduler);
    };
    IteratorObservable.dispatch = function(state) {
        var index = state.index, hasError = state.hasError, iterator = state.iterator, subscriber = state.subscriber;
        if (hasError) {
            subscriber.error(state.error);
            return;
        }
        var result = iterator.next();
        if (result.done) {
            subscriber.complete();
            return;
        }
        subscriber.next(result.value);
        state.index = index + 1;
        if (subscriber.closed) {
            if (typeof iterator.return === 'function') iterator.return();
            return;
        }
        this.schedule(state);
    };
    /** @deprecated internal use only */ IteratorObservable.prototype._subscribe = function(subscriber) {
        var index = 0;
        var _a = this, iterator = _a.iterator, scheduler = _a.scheduler;
        if (scheduler) return scheduler.schedule(IteratorObservable.dispatch, 0, {
            index: index,
            iterator: iterator,
            subscriber: subscriber
        });
        else do {
            var result = iterator.next();
            if (result.done) {
                subscriber.complete();
                break;
            } else subscriber.next(result.value);
            if (subscriber.closed) {
                if (typeof iterator.return === 'function') iterator.return();
                break;
            }
        }while (true);
    };
    return IteratorObservable;
}($lryMy.Observable);
module.exports.IteratorObservable = $df6414a74b370c12$var$IteratorObservable;
var $df6414a74b370c12$var$StringIterator = function() {
    function StringIterator(str, idx, len) {
        if (idx === void 0) idx = 0;
        if (len === void 0) len = str.length;
        this.str = str;
        this.idx = idx;
        this.len = len;
    }
    StringIterator.prototype[$5DE9G.iterator] = function() {
        return this;
    };
    StringIterator.prototype.next = function() {
        return this.idx < this.len ? {
            done: false,
            value: this.str.charAt(this.idx++)
        } : {
            done: true,
            value: undefined
        };
    };
    return StringIterator;
}();
var $df6414a74b370c12$var$ArrayIterator = function() {
    function ArrayIterator(arr, idx, len) {
        if (idx === void 0) idx = 0;
        if (len === void 0) len = $df6414a74b370c12$var$toLength(arr);
        this.arr = arr;
        this.idx = idx;
        this.len = len;
    }
    ArrayIterator.prototype[$5DE9G.iterator] = function() {
        return this;
    };
    ArrayIterator.prototype.next = function() {
        return this.idx < this.len ? {
            done: false,
            value: this.arr[this.idx++]
        } : {
            done: true,
            value: undefined
        };
    };
    return ArrayIterator;
}();
function $df6414a74b370c12$var$getIterator(obj) {
    var i = obj[$5DE9G.iterator];
    if (!i && typeof obj === 'string') return new $df6414a74b370c12$var$StringIterator(obj);
    if (!i && obj.length !== undefined) return new $df6414a74b370c12$var$ArrayIterator(obj);
    if (!i) throw new TypeError('object is not iterable');
    return obj[$5DE9G.iterator]();
}
var $df6414a74b370c12$var$maxSafeInteger = Math.pow(2, 53) - 1;
function $df6414a74b370c12$var$toLength(o) {
    var len = +o.length;
    if (isNaN(len)) return 0;
    if (len === 0 || !$df6414a74b370c12$var$numberIsFinite(len)) return len;
    len = $df6414a74b370c12$var$sign(len) * Math.floor(Math.abs(len));
    if (len <= 0) return 0;
    if (len > $df6414a74b370c12$var$maxSafeInteger) return $df6414a74b370c12$var$maxSafeInteger;
    return len;
}
function $df6414a74b370c12$var$numberIsFinite(value) {
    return typeof value === 'number' && $gvBTr.root.isFinite(value);
}
function $df6414a74b370c12$var$sign(value) {
    var valueAsNumber = +value;
    if (valueAsNumber === 0) return valueAsNumber;
    if (isNaN(valueAsNumber)) return valueAsNumber;
    return valueAsNumber < 0 ? -1 : 1;
}

});

parcelRegister("603ID", function(module, exports) {
"use strict";
var $45e5a0aa2d991ac8$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $lryMy = parcelRequire("lryMy");

var $k88pL = parcelRequire("k88pL");

var $h0t5h = parcelRequire("h0t5h");

var $UR0Fu = parcelRequire("UR0Fu");
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @extends {Ignored}
 * @hide true
 */ var $45e5a0aa2d991ac8$var$ArrayObservable = function(_super) {
    $45e5a0aa2d991ac8$var$__extends(ArrayObservable, _super);
    function ArrayObservable(array, scheduler) {
        _super.call(this);
        this.array = array;
        this.scheduler = scheduler;
        if (!scheduler && array.length === 1) {
            this._isScalar = true;
            this.value = array[0];
        }
    }
    ArrayObservable.create = function(array, scheduler) {
        return new ArrayObservable(array, scheduler);
    };
    /**
     * Creates an Observable that emits some values you specify as arguments,
     * immediately one after the other, and then emits a complete notification.
     *
     * <span class="informal">Emits the arguments you provide, then completes.
     * </span>
     *
     * <img src="./img/of.png" width="100%">
     *
     * This static operator is useful for creating a simple Observable that only
     * emits the arguments given, and the complete notification thereafter. It can
     * be used for composing with other Observables, such as with {@link concat}.
     * By default, it uses a `null` IScheduler, which means the `next`
     * notifications are sent synchronously, although with a different IScheduler
     * it is possible to determine when those notifications will be delivered.
     *
     * @example <caption>Emit 10, 20, 30, then 'a', 'b', 'c', then start ticking every second.</caption>
     * var numbers = Rx.Observable.of(10, 20, 30);
     * var letters = Rx.Observable.of('a', 'b', 'c');
     * var interval = Rx.Observable.interval(1000);
     * var result = numbers.concat(letters).concat(interval);
     * result.subscribe(x => console.log(x));
     *
     * @see {@link create}
     * @see {@link empty}
     * @see {@link never}
     * @see {@link throw}
     *
     * @param {...T} values Arguments that represent `next` values to be emitted.
     * @param {Scheduler} [scheduler] A {@link IScheduler} to use for scheduling
     * the emissions of the `next` notifications.
     * @return {Observable<T>} An Observable that emits each given input value.
     * @static true
     * @name of
     * @owner Observable
     */ ArrayObservable.of = function() {
        var array = [];
        for(var _i = 0; _i < arguments.length; _i++)array[_i - 0] = arguments[_i];
        var scheduler = array[array.length - 1];
        if ($UR0Fu.isScheduler(scheduler)) array.pop();
        else scheduler = null;
        var len = array.length;
        if (len > 1) return new ArrayObservable(array, scheduler);
        else if (len === 1) return new $k88pL.ScalarObservable(array[0], scheduler);
        else return new $h0t5h.EmptyObservable(scheduler);
    };
    ArrayObservable.dispatch = function(state) {
        var array = state.array, index = state.index, count = state.count, subscriber = state.subscriber;
        if (index >= count) {
            subscriber.complete();
            return;
        }
        subscriber.next(array[index]);
        if (subscriber.closed) return;
        state.index = index + 1;
        this.schedule(state);
    };
    /** @deprecated internal use only */ ArrayObservable.prototype._subscribe = function(subscriber) {
        var index = 0;
        var array = this.array;
        var count = array.length;
        var scheduler = this.scheduler;
        if (scheduler) return scheduler.schedule(ArrayObservable.dispatch, 0, {
            array: array,
            index: index,
            count: count,
            subscriber: subscriber
        });
        else {
            for(var i = 0; i < count && !subscriber.closed; i++)subscriber.next(array[i]);
            subscriber.complete();
        }
    };
    return ArrayObservable;
}($lryMy.Observable);
module.exports.ArrayObservable = $45e5a0aa2d991ac8$var$ArrayObservable;

});
parcelRegister("k88pL", function(module, exports) {
"use strict";
var $ea7b14f9062cd5e8$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $lryMy = parcelRequire("lryMy");
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @extends {Ignored}
 * @hide true
 */ var $ea7b14f9062cd5e8$var$ScalarObservable = function(_super) {
    $ea7b14f9062cd5e8$var$__extends(ScalarObservable, _super);
    function ScalarObservable(value, scheduler) {
        _super.call(this);
        this.value = value;
        this.scheduler = scheduler;
        this._isScalar = true;
        if (scheduler) this._isScalar = false;
    }
    ScalarObservable.create = function(value, scheduler) {
        return new ScalarObservable(value, scheduler);
    };
    ScalarObservable.dispatch = function(state) {
        var done = state.done, value = state.value, subscriber = state.subscriber;
        if (done) {
            subscriber.complete();
            return;
        }
        subscriber.next(value);
        if (subscriber.closed) return;
        state.done = true;
        this.schedule(state);
    };
    /** @deprecated internal use only */ ScalarObservable.prototype._subscribe = function(subscriber) {
        var value = this.value;
        var scheduler = this.scheduler;
        if (scheduler) return scheduler.schedule(ScalarObservable.dispatch, 0, {
            done: false,
            value: value,
            subscriber: subscriber
        });
        else {
            subscriber.next(value);
            if (!subscriber.closed) subscriber.complete();
        }
    };
    return ScalarObservable;
}($lryMy.Observable);
module.exports.ScalarObservable = $ea7b14f9062cd5e8$var$ScalarObservable;

});

parcelRegister("h0t5h", function(module, exports) {
"use strict";
var $c618ff48902a2aae$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $lryMy = parcelRequire("lryMy");
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @extends {Ignored}
 * @hide true
 */ var $c618ff48902a2aae$var$EmptyObservable = function(_super) {
    $c618ff48902a2aae$var$__extends(EmptyObservable, _super);
    function EmptyObservable(scheduler) {
        _super.call(this);
        this.scheduler = scheduler;
    }
    /**
     * Creates an Observable that emits no items to the Observer and immediately
     * emits a complete notification.
     *
     * <span class="informal">Just emits 'complete', and nothing else.
     * </span>
     *
     * <img src="./img/empty.png" width="100%">
     *
     * This static operator is useful for creating a simple Observable that only
     * emits the complete notification. It can be used for composing with other
     * Observables, such as in a {@link mergeMap}.
     *
     * @example <caption>Emit the number 7, then complete.</caption>
     * var result = Rx.Observable.empty().startWith(7);
     * result.subscribe(x => console.log(x));
     *
     * @example <caption>Map and flatten only odd numbers to the sequence 'a', 'b', 'c'</caption>
     * var interval = Rx.Observable.interval(1000);
     * var result = interval.mergeMap(x =>
     *   x % 2 === 1 ? Rx.Observable.of('a', 'b', 'c') : Rx.Observable.empty()
     * );
     * result.subscribe(x => console.log(x));
     *
     * // Results in the following to the console:
     * // x is equal to the count on the interval eg(0,1,2,3,...)
     * // x will occur every 1000ms
     * // if x % 2 is equal to 1 print abc
     * // if x % 2 is not equal to 1 nothing will be output
     *
     * @see {@link create}
     * @see {@link never}
     * @see {@link of}
     * @see {@link throw}
     *
     * @param {Scheduler} [scheduler] A {@link IScheduler} to use for scheduling
     * the emission of the complete notification.
     * @return {Observable} An "empty" Observable: emits only the complete
     * notification.
     * @static true
     * @name empty
     * @owner Observable
     */ EmptyObservable.create = function(scheduler) {
        return new EmptyObservable(scheduler);
    };
    EmptyObservable.dispatch = function(arg) {
        var subscriber = arg.subscriber;
        subscriber.complete();
    };
    /** @deprecated internal use only */ EmptyObservable.prototype._subscribe = function(subscriber) {
        var scheduler = this.scheduler;
        if (scheduler) return scheduler.schedule(EmptyObservable.dispatch, 0, {
            subscriber: subscriber
        });
        else subscriber.complete();
    };
    return EmptyObservable;
}($lryMy.Observable);
module.exports.EmptyObservable = $c618ff48902a2aae$var$EmptyObservable;

});

parcelRegister("UR0Fu", function(module, exports) {
$parcel$export(module.exports, "isScheduler", () => $0aae59b6fd6752fb$export$187e35932e88c15c, (v) => $0aae59b6fd6752fb$export$187e35932e88c15c = v);
var $0aae59b6fd6752fb$export$187e35932e88c15c;
"use strict";
function $0aae59b6fd6752fb$var$isScheduler(value) {
    return value && typeof value.schedule === 'function';
}
$0aae59b6fd6752fb$export$187e35932e88c15c = $0aae59b6fd6752fb$var$isScheduler;

});


parcelRegister("7yiVr", function(module, exports) {
"use strict";
var $57fa63973fb2be8a$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $lryMy = parcelRequire("lryMy");

var $k88pL = parcelRequire("k88pL");

var $h0t5h = parcelRequire("h0t5h");
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @extends {Ignored}
 * @hide true
 */ var $57fa63973fb2be8a$var$ArrayLikeObservable = function(_super) {
    $57fa63973fb2be8a$var$__extends(ArrayLikeObservable, _super);
    function ArrayLikeObservable(arrayLike, scheduler) {
        _super.call(this);
        this.arrayLike = arrayLike;
        this.scheduler = scheduler;
        if (!scheduler && arrayLike.length === 1) {
            this._isScalar = true;
            this.value = arrayLike[0];
        }
    }
    ArrayLikeObservable.create = function(arrayLike, scheduler) {
        var length = arrayLike.length;
        if (length === 0) return new $h0t5h.EmptyObservable();
        else if (length === 1) return new $k88pL.ScalarObservable(arrayLike[0], scheduler);
        else return new ArrayLikeObservable(arrayLike, scheduler);
    };
    ArrayLikeObservable.dispatch = function(state) {
        var arrayLike = state.arrayLike, index = state.index, length = state.length, subscriber = state.subscriber;
        if (subscriber.closed) return;
        if (index >= length) {
            subscriber.complete();
            return;
        }
        subscriber.next(arrayLike[index]);
        state.index = index + 1;
        this.schedule(state);
    };
    /** @deprecated internal use only */ ArrayLikeObservable.prototype._subscribe = function(subscriber) {
        var index = 0;
        var _a = this, arrayLike = _a.arrayLike, scheduler = _a.scheduler;
        var length = arrayLike.length;
        if (scheduler) return scheduler.schedule(ArrayLikeObservable.dispatch, 0, {
            arrayLike: arrayLike,
            index: index,
            length: length,
            subscriber: subscriber
        });
        else {
            for(var i = 0; i < length && !subscriber.closed; i++)subscriber.next(arrayLike[i]);
            subscriber.complete();
        }
    };
    return ArrayLikeObservable;
}($lryMy.Observable);
module.exports.ArrayLikeObservable = $57fa63973fb2be8a$var$ArrayLikeObservable;

});

parcelRegister("lPK1b", function(module, exports) {
"use strict";
var $fe520e9f9d58cb68$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $deMDi = parcelRequire("deMDi");

var $2rXhC = parcelRequire("2rXhC");
/**
 *
 * Re-emits all notifications from source Observable with specified scheduler.
 *
 * <span class="informal">Ensure a specific scheduler is used, from outside of an Observable.</span>
 *
 * `observeOn` is an operator that accepts a scheduler as a first parameter, which will be used to reschedule
 * notifications emitted by the source Observable. It might be useful, if you do not have control over
 * internal scheduler of a given Observable, but want to control when its values are emitted nevertheless.
 *
 * Returned Observable emits the same notifications (nexted values, complete and error events) as the source Observable,
 * but rescheduled with provided scheduler. Note that this doesn't mean that source Observables internal
 * scheduler will be replaced in any way. Original scheduler still will be used, but when the source Observable emits
 * notification, it will be immediately scheduled again - this time with scheduler passed to `observeOn`.
 * An anti-pattern would be calling `observeOn` on Observable that emits lots of values synchronously, to split
 * that emissions into asynchronous chunks. For this to happen, scheduler would have to be passed into the source
 * Observable directly (usually into the operator that creates it). `observeOn` simply delays notifications a
 * little bit more, to ensure that they are emitted at expected moments.
 *
 * As a matter of fact, `observeOn` accepts second parameter, which specifies in milliseconds with what delay notifications
 * will be emitted. The main difference between {@link delay} operator and `observeOn` is that `observeOn`
 * will delay all notifications - including error notifications - while `delay` will pass through error
 * from source Observable immediately when it is emitted. In general it is highly recommended to use `delay` operator
 * for any kind of delaying of values in the stream, while using `observeOn` to specify which scheduler should be used
 * for notification emissions in general.
 *
 * @example <caption>Ensure values in subscribe are called just before browser repaint.</caption>
 * const intervals = Rx.Observable.interval(10); // Intervals are scheduled
 *                                               // with async scheduler by default...
 *
 * intervals
 * .observeOn(Rx.Scheduler.animationFrame)       // ...but we will observe on animationFrame
 * .subscribe(val => {                           // scheduler to ensure smooth animation.
 *   someDiv.style.height = val + 'px';
 * });
 *
 * @see {@link delay}
 *
 * @param {IScheduler} scheduler Scheduler that will be used to reschedule notifications from source Observable.
 * @param {number} [delay] Number of milliseconds that states with what delay every notification should be rescheduled.
 * @return {Observable<T>} Observable that emits the same notifications as the source Observable,
 * but with provided scheduler.
 *
 * @method observeOn
 * @owner Observable
 */ function $fe520e9f9d58cb68$var$observeOn(scheduler, delay) {
    if (delay === void 0) delay = 0;
    return function observeOnOperatorFunction(source) {
        return source.lift(new $fe520e9f9d58cb68$var$ObserveOnOperator(scheduler, delay));
    };
}
module.exports.observeOn = $fe520e9f9d58cb68$var$observeOn;
var $fe520e9f9d58cb68$var$ObserveOnOperator = function() {
    function ObserveOnOperator(scheduler, delay) {
        if (delay === void 0) delay = 0;
        this.scheduler = scheduler;
        this.delay = delay;
    }
    ObserveOnOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $fe520e9f9d58cb68$var$ObserveOnSubscriber(subscriber, this.scheduler, this.delay));
    };
    return ObserveOnOperator;
}();
module.exports.ObserveOnOperator = $fe520e9f9d58cb68$var$ObserveOnOperator;
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $fe520e9f9d58cb68$var$ObserveOnSubscriber = function(_super) {
    $fe520e9f9d58cb68$var$__extends(ObserveOnSubscriber, _super);
    function ObserveOnSubscriber(destination, scheduler, delay) {
        if (delay === void 0) delay = 0;
        _super.call(this, destination);
        this.scheduler = scheduler;
        this.delay = delay;
    }
    ObserveOnSubscriber.dispatch = function(arg) {
        var notification = arg.notification, destination = arg.destination;
        notification.observe(destination);
        this.unsubscribe();
    };
    ObserveOnSubscriber.prototype.scheduleMessage = function(notification) {
        this.add(this.scheduler.schedule(ObserveOnSubscriber.dispatch, this.delay, new $fe520e9f9d58cb68$var$ObserveOnMessage(notification, this.destination)));
    };
    ObserveOnSubscriber.prototype._next = function(value) {
        this.scheduleMessage($2rXhC.Notification.createNext(value));
    };
    ObserveOnSubscriber.prototype._error = function(err) {
        this.scheduleMessage($2rXhC.Notification.createError(err));
    };
    ObserveOnSubscriber.prototype._complete = function() {
        this.scheduleMessage($2rXhC.Notification.createComplete());
    };
    return ObserveOnSubscriber;
}($deMDi.Subscriber);
module.exports.ObserveOnSubscriber = $fe520e9f9d58cb68$var$ObserveOnSubscriber;
var $fe520e9f9d58cb68$var$ObserveOnMessage = function() {
    function ObserveOnMessage(notification, destination) {
        this.notification = notification;
        this.destination = destination;
    }
    return ObserveOnMessage;
}();
module.exports.ObserveOnMessage = $fe520e9f9d58cb68$var$ObserveOnMessage;

});
parcelRegister("2rXhC", function(module, exports) {
$parcel$export(module.exports, "Notification", () => $1c8c16c9263c2d23$export$14834abbfce3b8cd, (v) => $1c8c16c9263c2d23$export$14834abbfce3b8cd = v);
var $1c8c16c9263c2d23$export$14834abbfce3b8cd;
"use strict";

var $lryMy = parcelRequire("lryMy");
/**
 * Represents a push-based event or value that an {@link Observable} can emit.
 * This class is particularly useful for operators that manage notifications,
 * like {@link materialize}, {@link dematerialize}, {@link observeOn}, and
 * others. Besides wrapping the actual delivered value, it also annotates it
 * with metadata of, for instance, what type of push message it is (`next`,
 * `error`, or `complete`).
 *
 * @see {@link materialize}
 * @see {@link dematerialize}
 * @see {@link observeOn}
 *
 * @class Notification<T>
 */ var $1c8c16c9263c2d23$var$Notification = function() {
    function Notification(kind, value, error) {
        this.kind = kind;
        this.value = value;
        this.error = error;
        this.hasValue = kind === 'N';
    }
    /**
     * Delivers to the given `observer` the value wrapped by this Notification.
     * @param {Observer} observer
     * @return
     */ Notification.prototype.observe = function(observer) {
        switch(this.kind){
            case 'N':
                return observer.next && observer.next(this.value);
            case 'E':
                return observer.error && observer.error(this.error);
            case 'C':
                return observer.complete && observer.complete();
        }
    };
    /**
     * Given some {@link Observer} callbacks, deliver the value represented by the
     * current Notification to the correctly corresponding callback.
     * @param {function(value: T): void} next An Observer `next` callback.
     * @param {function(err: any): void} [error] An Observer `error` callback.
     * @param {function(): void} [complete] An Observer `complete` callback.
     * @return {any}
     */ Notification.prototype.do = function(next, error, complete) {
        var kind = this.kind;
        switch(kind){
            case 'N':
                return next && next(this.value);
            case 'E':
                return error && error(this.error);
            case 'C':
                return complete && complete();
        }
    };
    /**
     * Takes an Observer or its individual callback functions, and calls `observe`
     * or `do` methods accordingly.
     * @param {Observer|function(value: T): void} nextOrObserver An Observer or
     * the `next` callback.
     * @param {function(err: any): void} [error] An Observer `error` callback.
     * @param {function(): void} [complete] An Observer `complete` callback.
     * @return {any}
     */ Notification.prototype.accept = function(nextOrObserver, error, complete) {
        if (nextOrObserver && typeof nextOrObserver.next === 'function') return this.observe(nextOrObserver);
        else return this.do(nextOrObserver, error, complete);
    };
    /**
     * Returns a simple Observable that just delivers the notification represented
     * by this Notification instance.
     * @return {any}
     */ Notification.prototype.toObservable = function() {
        var kind = this.kind;
        switch(kind){
            case 'N':
                return $lryMy.Observable.of(this.value);
            case 'E':
                return $lryMy.Observable.throw(this.error);
            case 'C':
                return $lryMy.Observable.empty();
        }
        throw new Error('unexpected notification kind value');
    };
    /**
     * A shortcut to create a Notification instance of the type `next` from a
     * given value.
     * @param {T} value The `next` value.
     * @return {Notification<T>} The "next" Notification representing the
     * argument.
     */ Notification.createNext = function(value) {
        if (typeof value !== 'undefined') return new Notification('N', value);
        return Notification.undefinedValueNotification;
    };
    /**
     * A shortcut to create a Notification instance of the type `error` from a
     * given error.
     * @param {any} [err] The `error` error.
     * @return {Notification<T>} The "error" Notification representing the
     * argument.
     */ Notification.createError = function(err) {
        return new Notification('E', undefined, err);
    };
    /**
     * A shortcut to create a Notification instance of the type `complete`.
     * @return {Notification<any>} The valueless "complete" Notification.
     */ Notification.createComplete = function() {
        return Notification.completeNotification;
    };
    Notification.completeNotification = new Notification('C');
    Notification.undefinedValueNotification = new Notification('N', undefined);
    return Notification;
}();
$1c8c16c9263c2d23$export$14834abbfce3b8cd = $1c8c16c9263c2d23$var$Notification;

});





parcelRegister("cJOXG", function(module, exports) {
$parcel$export(module.exports, "createHasher", () => $946137eb19857517$export$14b114effbc08b6b);

var $fL8KA = parcelRequire("fL8KA");

var $6HG4S = parcelRequire("6HG4S");
parcelRequire("l7fRX");
var $k9W36 = parcelRequire("k9W36");
var $946137eb19857517$var$hasher = null;
var $946137eb19857517$var$sha256Hasher = null;
var $946137eb19857517$export$d9c9d11cd648a505 = function destroyHashers() {
    $946137eb19857517$var$hasher = null;
    $946137eb19857517$var$sha256Hasher = null;
};


var $946137eb19857517$export$14b114effbc08b6b = /*#__PURE__*/ function() {
    var _ref = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee(algorithm) {
        var _yield$import, _SimpleHasher, _yield$import2, SimpleHasher;
        return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee$(_context) {
            while(true)switch(_context.prev = _context.next){
                case 0:
                    _context.prev = 0;
                    if (!(algorithm === (0, $k9W36.ChunkHashAlgorithm).Sha256)) {
                        _context.next = 9;
                        break;
                    }
                    if ($946137eb19857517$var$sha256Hasher) {
                        _context.next = 8;
                        break;
                    }
                    _context.next = 5;
                    return (parcelRequire("c1aNV"));
                case 5:
                    _yield$import = _context.sent;
                    _SimpleHasher = _yield$import.SimpleHasher;
                    $946137eb19857517$var$sha256Hasher = new _SimpleHasher();
                case 8:
                    return _context.abrupt("return", $946137eb19857517$var$sha256Hasher);
                case 9:
                    _context.next = 13;
                    break;
                case 11:
                    _context.prev = 11;
                    _context.t0 = _context["catch"](0);
                case 13:
                    _context.next = 15;
                    return (parcelRequire("3cuTr"));
                case 15:
                    _yield$import2 = _context.sent;
                    SimpleHasher = _yield$import2.SimpleHasher;
                    $946137eb19857517$var$hasher = new SimpleHasher();
                    return _context.abrupt("return", $946137eb19857517$var$hasher);
                case 19:
                case "end":
                    return _context.stop();
            }
        }, _callee, null, [
            [
                0,
                11
            ]
        ]);
    }));
    return function createHasher(_x) {
        return _ref.apply(this, arguments);
    };
}();

});
parcelRegister("c1aNV", function(module, exports) {

var $iKwew = parcelRequire("iKwew");
module.exports = Promise.all([
    $iKwew("gWebb"),
    $iKwew("ZoLaQ")
]).then(()=>parcelRequire('6OfvV'));

});

parcelRegister("3cuTr", function(module, exports) {

var $iKwew = parcelRequire("iKwew");
module.exports = Promise.all([
    $iKwew("6v8xP"),
    $iKwew("l05Q4")
]).then(()=>parcelRequire('5kTFw'));

});


parcelRegister("7cA6T", function(module, exports) {
$parcel$export(module.exports, "UploaderError", () => $53e5aa1e6b2a9548$export$515240c3f059c807);

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $kIXpt = parcelRequire("kIXpt");

var $cYPzS = parcelRequire("cYPzS");

var $eyuDe = parcelRequire("eyuDe");

var $8eaz3 = parcelRequire("8eaz3");
function $53e5aa1e6b2a9548$var$_callSuper(t, o, e) {
    return o = (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(o), (0, (/*@__PURE__*/$parcel$interopDefault($kIXpt)))(t, $53e5aa1e6b2a9548$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(t).constructor) : o.apply(t, e));
}
function $53e5aa1e6b2a9548$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($53e5aa1e6b2a9548$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $53e5aa1e6b2a9548$export$515240c3f059c807 = /*#__PURE__*/ function(_BaseMediaClientError) {
    // Legacy Attribute. Should be removed
    function UploaderError(reason, metadata) {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, UploaderError);
        _this = $53e5aa1e6b2a9548$var$_callSuper(this, UploaderError, [
            reason,
            metadata,
            undefined
        ]);
        _this.id = metadata.id;
        return _this;
    }
    // TODO: Deprecate this getter https://product-fabric.atlassian.net/browse/CXP-4665
    /** Will be deprecated. Use the properties `reason` and `metadata` instead */ (0, (/*@__PURE__*/$parcel$interopDefault($eyuDe)))(UploaderError, _BaseMediaClientError);
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(UploaderError, [
        {
            key: "attributes",
            get: function get() {
                var reason = this.reason, _this$metadata = this.metadata, id = _this$metadata.id, collectionName = _this$metadata.collectionName, occurrenceKey = _this$metadata.occurrenceKey;
                return {
                    reason: reason,
                    id: id,
                    collectionName: collectionName,
                    occurrenceKey: occurrenceKey
                };
            }
        }
    ]);
}((0, $8eaz3.BaseMediaClientError));
function $53e5aa1e6b2a9548$export$80ee180172bc336(err) {
    return err instanceof $53e5aa1e6b2a9548$export$515240c3f059c807;
}

});

parcelRegister("hp5hn", function(module, exports) {
$parcel$export(module.exports, "fileSizeError", () => $cab8ddd3e5265b0d$export$b36239e4c33c2902);
$parcel$export(module.exports, "calculateChunkSize", () => $cab8ddd3e5265b0d$export$71f452e02035c1e2);

var $j9G0f = parcelRequire("j9G0f");

var $cSavz = parcelRequire("cSavz");
var $cab8ddd3e5265b0d$export$b36239e4c33c2902 = 'fileSizeExceedsLimit';
var $cab8ddd3e5265b0d$export$71f452e02035c1e2 = function calculateChunkSize(fileSize) {
    if (fileSize > (0, $cSavz.MAX_UPLOAD_FILE_SIZE)) throw new Error($cab8ddd3e5265b0d$export$b36239e4c33c2902);
    if (fileSize <= 5 * (0, $j9G0f.DATA_UNIT).GB) return 5 * (0, $j9G0f.DATA_UNIT).MB;
    if (fileSize > 5 * (0, $j9G0f.DATA_UNIT).GB && fileSize <= 50 * (0, $j9G0f.DATA_UNIT).GB) return 50 * (0, $j9G0f.DATA_UNIT).MB;
    if (fileSize > 50 * (0, $j9G0f.DATA_UNIT).GB && fileSize <= 0.95 * (0, $j9G0f.DATA_UNIT).TB) return 100 * (0, $j9G0f.DATA_UNIT).MB;
    return 210 * (0, $j9G0f.DATA_UNIT).MB;
};

});


parcelRegister("L8Ev2", function(module, exports) {
$parcel$export(module.exports, "getFileStreamsCache", () => $08db1a0d3d9876d4$export$f2f061938c1e6810);

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");
var $08db1a0d3d9876d4$export$4293896e79732236 = /*#__PURE__*/ function() {
    function StreamsCache(streams) {
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, StreamsCache);
        this.streams = streams;
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(StreamsCache, [
        {
            key: "has",
            value: function has(id) {
                return !!this.streams.find(id);
            }
        },
        {
            key: "set",
            value: function set(id, stream) {
                this.streams.set(id, stream);
            }
        },
        {
            key: "get",
            value: function get(id) {
                return this.streams.get(id);
            }
        },
        {
            key: "getOrInsert",
            value: function getOrInsert(id, callback) {
                if (!this.has(id)) this.set(id, callback());
                return this.get(id);
            }
        },
        {
            key: "removeAll",
            value: function removeAll() {
                this.streams.clear();
            }
        },
        {
            key: "remove",
            value: function remove(id) {
                this.streams.delete(id);
            }
        },
        {
            key: "size",
            get: function get() {
                return this.streams.size;
            }
        }
    ]);
}();
var $08db1a0d3d9876d4$var$streamCache;

var $08db1a0d3d9876d4$export$f2f061938c1e6810 = function getFileStreamsCache() {
    if (!$08db1a0d3d9876d4$var$streamCache) {
        // TODO: we can move this into a static import like
        // import {mediaState} from '@atlaskit/media-core'
        var mediaState = (parcelRequire("k5fWJ")).mediaState;
        $08db1a0d3d9876d4$var$streamCache = new $08db1a0d3d9876d4$export$4293896e79732236(mediaState.streams);
    }
    return $08db1a0d3d9876d4$var$streamCache;
};

});

parcelRegister("iOlVT", function(module, exports) {
$parcel$export(module.exports, "globalMediaEventEmitter", () => $db1de8e59957a16e$export$68d003d3105952ad);
parcelRequire("l7fRX");
var $k5fWJ = parcelRequire("k5fWJ");
var $db1de8e59957a16e$export$68d003d3105952ad = {
    on: function on(event, listener) {
        if ((0, $k5fWJ.mediaState).eventEmitter) (0, $k5fWJ.mediaState).eventEmitter.on(event, listener);
    },
    off: function off(event, listener) {
        if ((0, $k5fWJ.mediaState).eventEmitter) (0, $k5fWJ.mediaState).eventEmitter.off(event, listener);
    },
    emit: function emit(event, payload) {
        if ((0, $k5fWJ.mediaState).eventEmitter) return (0, $k5fWJ.mediaState).eventEmitter.emit(event, payload);
        return undefined;
    }
};

});

parcelRegister("j42Kg", function(module, exports) {
// Regular expression used for basic parsing of the uuid.

var $7KfP5 = parcelRequire("7KfP5");
var $de10852d9379c006$require$Buffer = $7KfP5.Buffer;
var $de10852d9379c006$var$pattern = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
/**
 * Unparses a UUID buffer to a string. From node-uuid:
 * https://github.com/defunctzombie/node-uuid/blob/master/uuid.js
 *
 * Copyright (c) 2010-2012 Robert Kieffer
 * MIT License - http://opensource.org/licenses/mit-license.php
 *
 * @param  {Buffer} buf
 * @param  {Number=0} offset
 * @return {String}
 */ var $de10852d9379c006$var$_byteToHex = [];
for(var $de10852d9379c006$var$i = 0; $de10852d9379c006$var$i < 256; $de10852d9379c006$var$i++)$de10852d9379c006$var$_byteToHex[$de10852d9379c006$var$i] = ($de10852d9379c006$var$i + 0x100).toString(16).substr(1);
function $de10852d9379c006$var$unparse(buf, offset) {
    var i = offset || 0, bth = $de10852d9379c006$var$_byteToHex;
    return bth[buf[i++]] + bth[buf[i++]] + bth[buf[i++]] + bth[buf[i++]] + '-' + bth[buf[i++]] + bth[buf[i++]] + '-' + bth[buf[i++]] + bth[buf[i++]] + '-' + bth[buf[i++]] + bth[buf[i++]] + '-' + bth[buf[i++]] + bth[buf[i++]] + bth[buf[i++]] + bth[buf[i++]] + bth[buf[i++]] + bth[buf[i++]];
}
/**
 * Determines whether the uuid is valid, converting
 * it from a buffer if necessary.
 *
 * @param  {String|Buffer}  uuid
 * @param  {Number=}  version
 * @return {Boolean}
 */ module.exports = function(uuid, version) {
    var parsedUuid;
    // If the uuid is a biffer, parse it...
    if ($de10852d9379c006$require$Buffer.isBuffer(uuid)) parsedUuid = $de10852d9379c006$var$unparse(uuid);
    else if (Object.prototype.toString.call(uuid) === '[object String]') parsedUuid = uuid;
    else return false;
    parsedUuid = parsedUuid.toLowerCase();
    // All UUIDs fit a basic schema. Match that.
    if (!$de10852d9379c006$var$pattern.test(parsedUuid)) return false;
    // Now extract the version...
    if (version === undefined) version = $de10852d9379c006$var$extractVersion(parsedUuid);
    else if ($de10852d9379c006$var$extractVersion(parsedUuid) !== version) return false;
    switch(version){
        // For certain versions, the checks we did up to this point are fine.
        case 1:
        case 2:
            return true;
        // For versions 3 and 4, they must specify a variant.
        case 3:
        case 4:
        case 5:
            return [
                '8',
                '9',
                'a',
                'b'
            ].indexOf(parsedUuid.charAt(19)) !== -1;
        default:
            // We should only be able to reach this if the consumer explicitly
            // provided an invalid version. Prior to extractVersion we check
            // that it's 1-4 in the regex.
            throw new Error('Invalid version provided.');
    }
};
/**
 * Extracts the version from the UUID, which is (by definition) the M in
 * xxxxxxxx-xxxx-Mxxx-Nxxx-xxxxxxxxxxxx
 *
 * @param  {String} uuid
 * @return {Number}
 */ var $de10852d9379c006$var$extractVersion = module.exports.version = function(uuid) {
    return uuid.charAt(14) | 0;
};

});

parcelRegister("9ilbX", function(module, exports) {
$parcel$export(module.exports, "createFileDataloader", () => $6c463bc8b84687f1$export$ae188fee39529b82);

var $fC8ib = parcelRequire("fC8ib");

var $fL8KA = parcelRequire("fL8KA");

var $25nEq = parcelRequire("25nEq");

var $6HG4S = parcelRequire("6HG4S");

var $8kmor = parcelRequire("8kmor");

var $bVaC0 = parcelRequire("bVaC0");
function $6c463bc8b84687f1$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $6c463bc8b84687f1$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $6c463bc8b84687f1$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $6c463bc8b84687f1$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $6c463bc8b84687f1$export$b79d95ee17a87a = 100;
var $6c463bc8b84687f1$var$isBatchLoadingErrorResult = function isBatchLoadingErrorResult(result) {
    return result.error instanceof Error;
};
var $6c463bc8b84687f1$var$isResponseFileItem = function isResponseFileItem(fileItem) {
    return 'details' in fileItem;
};
var $6c463bc8b84687f1$var$makeCacheKey = function makeCacheKey(id, collection) {
    return collection ? "".concat(id, "-").concat(collection) : id;
};
var $6c463bc8b84687f1$export$71cd2e8f8162d47b = function getItemsFromKeys(dataloaderKeys, fileItems) {
    var itemsByKey = fileItems.reduce(function(prev, fileItem) {
        var id = fileItem.id, collection = fileItem.collection;
        var key = $6c463bc8b84687f1$var$makeCacheKey(id, collection);
        if ($6c463bc8b84687f1$var$isBatchLoadingErrorResult(fileItem)) prev[key] = fileItem.error;
        else if ($6c463bc8b84687f1$var$isResponseFileItem(fileItem)) prev[key] = $6c463bc8b84687f1$var$_objectSpread($6c463bc8b84687f1$var$_objectSpread({}, fileItem.details), {}, {
            metadataTraceContext: fileItem.metadataTraceContext
        });
        else prev[key] = {
            id: id,
            collection: collection,
            type: 'not-found',
            metadataTraceContext: fileItem.metadataTraceContext
        };
        return prev;
    }, {});
    return dataloaderKeys.map(function(dataloaderKey) {
        var id = dataloaderKey.id, collectionName = dataloaderKey.collectionName;
        var key = $6c463bc8b84687f1$var$makeCacheKey(id, collectionName);
        return itemsByKey[key] || {
            id: id,
            type: 'not-found'
        };
    });
};
function $6c463bc8b84687f1$export$4a53beb129e8c49a(mediaStore) {
    return /*#__PURE__*/ function() {
        var _ref = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee2(keys) {
            var nonCollectionName, includeHashByCollection, fileIdsByCollection, items;
            return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee2$(_context2) {
                while(true)switch(_context2.prev = _context2.next){
                    case 0:
                        nonCollectionName = '__media-single-file-collection__';
                        includeHashByCollection = keys.reduce(function(acc, key) {
                            var collectionName = key.collectionName || nonCollectionName;
                            if (key.includeHashForDuplicateFiles) acc[collectionName] = key.includeHashForDuplicateFiles;
                            return acc;
                        }, {});
                        fileIdsByCollection = keys.reduce(function(acc, key) {
                            var collectionName = key.collectionName || nonCollectionName;
                            var fileIds = acc[collectionName] || [];
                            // de-duplicate ids in collection
                            if (fileIds.indexOf(key.id) === -1) fileIds.push(key.id);
                            acc[collectionName] = fileIds;
                            return acc;
                        }, {});
                        items = [];
                        _context2.next = 6;
                        return Promise.all(Object.keys(fileIdsByCollection).map(/*#__PURE__*/ function() {
                            var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee(collectionNameKey) {
                                var metadataTraceContext, fileIds, includeHashForDuplicateFiles, collectionName, response, itemsWithMetadataTraceContext, itemsIds, fileIdsNotFound;
                                return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee$(_context) {
                                    while(true)switch(_context.prev = _context.next){
                                        case 0:
                                            metadataTraceContext = {
                                                traceId: (0, $bVaC0.getRandomTelemetryId)(),
                                                spanId: (0, $bVaC0.getRandomTelemetryId)()
                                            };
                                            fileIds = fileIdsByCollection[collectionNameKey];
                                            includeHashForDuplicateFiles = includeHashByCollection[collectionNameKey];
                                            collectionName = collectionNameKey === nonCollectionName ? undefined : collectionNameKey;
                                            _context.prev = 4;
                                            _context.next = 7;
                                            return mediaStore.getItems(fileIds, collectionName, metadataTraceContext, includeHashForDuplicateFiles);
                                        case 7:
                                            response = _context.sent;
                                            itemsWithMetadataTraceContext = response.data.items.map(function(item) {
                                                return $6c463bc8b84687f1$var$_objectSpread($6c463bc8b84687f1$var$_objectSpread({}, item), {}, {
                                                    metadataTraceContext: metadataTraceContext
                                                });
                                            });
                                            items.push.apply(items, (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(itemsWithMetadataTraceContext));
                                            // add EmptyResponseFileItem for each file ID not included in /items response
                                            itemsIds = itemsWithMetadataTraceContext.map(function(item) {
                                                return item.id;
                                            });
                                            fileIdsNotFound = fileIds.filter(function(id) {
                                                return !itemsIds.includes(id);
                                            });
                                            fileIdsNotFound.forEach(function(fileId) {
                                                items.push({
                                                    id: fileId,
                                                    collection: collectionName,
                                                    type: 'not-found',
                                                    metadataTraceContext: metadataTraceContext
                                                });
                                            });
                                            _context.next = 18;
                                            break;
                                        case 15:
                                            _context.prev = 15;
                                            _context.t0 = _context["catch"](4);
                                            fileIds.forEach(function(fileId) {
                                                items.push({
                                                    id: fileId,
                                                    collection: collectionName,
                                                    error: _context.t0
                                                });
                                            });
                                        case 18:
                                        case "end":
                                            return _context.stop();
                                    }
                                }, _callee, null, [
                                    [
                                        4,
                                        15
                                    ]
                                ]);
                            }));
                            return function(_x2) {
                                return _ref2.apply(this, arguments);
                            };
                        }()));
                    case 6:
                        return _context2.abrupt("return", $6c463bc8b84687f1$export$71cd2e8f8162d47b(keys, items));
                    case 7:
                    case "end":
                        return _context2.stop();
                }
            }, _callee2);
        }));
        return function(_x) {
            return _ref.apply(this, arguments);
        };
    }();
}
function $6c463bc8b84687f1$export$ae188fee39529b82(mediaStore) {
    return new (0, (/*@__PURE__*/$parcel$interopDefault($8kmor)))($6c463bc8b84687f1$export$4a53beb129e8c49a(mediaStore), {
        maxBatchSize: $6c463bc8b84687f1$export$b79d95ee17a87a
    });
}

});
parcelRegister("8kmor", function(module, exports) {

var $3ZMUU = parcelRequire("3ZMUU");
"use strict";
/**
 * Copyright (c) 2019-present, GraphQL Foundation
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */ // A Function, which when given an Array of keys, returns a Promise of an Array
// of values or Errors.
// Optionally turn off batching or caching or provide a cache key function or a
// custom cache instance.
// If a custom cache is provided, it must be of this type (a subset of ES6 Map).
/**
 * A `DataLoader` creates a public API for loading data from a particular
 * data back-end with unique keys such as the `id` column of a SQL table or
 * document name in a MongoDB database, given a batch loading function.
 *
 * Each `DataLoader` instance contains a unique memoized cache. Use caution when
 * used in long-lived applications or those which serve many users with
 * different access permissions and consider creating a new instance per
 * web request.
 */ var $61018fcf031b9b93$var$DataLoader = /*#__PURE__*/ function() {
    function DataLoader(batchLoadFn, options) {
        if (typeof batchLoadFn !== 'function') throw new TypeError('DataLoader must be constructed with a function which accepts ' + ("Array<key> and returns Promise<Array<value>>, but got: " + batchLoadFn + "."));
        this._batchLoadFn = batchLoadFn;
        this._maxBatchSize = $61018fcf031b9b93$var$getValidMaxBatchSize(options);
        this._batchScheduleFn = $61018fcf031b9b93$var$getValidBatchScheduleFn(options);
        this._cacheKeyFn = $61018fcf031b9b93$var$getValidCacheKeyFn(options);
        this._cacheMap = $61018fcf031b9b93$var$getValidCacheMap(options);
        this._batch = null;
        this.name = $61018fcf031b9b93$var$getValidName(options);
    } // Private
    var _proto = DataLoader.prototype;
    /**
   * Loads a key, returning a `Promise` for the value represented by that key.
   */ _proto.load = function load(key) {
        if (key === null || key === undefined) throw new TypeError('The loader.load() function must be called with a value, ' + ("but got: " + String(key) + "."));
        var batch = $61018fcf031b9b93$var$getCurrentBatch(this);
        var cacheMap = this._cacheMap;
        var cacheKey; // If caching and there is a cache-hit, return cached Promise.
        if (cacheMap) {
            cacheKey = this._cacheKeyFn(key);
            var cachedPromise = cacheMap.get(cacheKey);
            if (cachedPromise) {
                var cacheHits = batch.cacheHits || (batch.cacheHits = []);
                return new Promise(function(resolve) {
                    cacheHits.push(function() {
                        resolve(cachedPromise);
                    });
                });
            }
        } // Otherwise, produce a new Promise for this key, and enqueue it to be
        // dispatched along with the current batch.
        batch.keys.push(key);
        var promise = new Promise(function(resolve, reject) {
            batch.callbacks.push({
                resolve: resolve,
                reject: reject
            });
        }); // If caching, cache this promise.
        if (cacheMap) cacheMap.set(cacheKey, promise);
        return promise;
    } /**
   * Loads multiple keys, promising an array of values:
   *
   *     var [ a, b ] = await myLoader.loadMany([ 'a', 'b' ]);
   *
   * This is similar to the more verbose:
   *
   *     var [ a, b ] = await Promise.all([
   *       myLoader.load('a'),
   *       myLoader.load('b')
   *     ]);
   *
   * However it is different in the case where any load fails. Where
   * Promise.all() would reject, loadMany() always resolves, however each result
   * is either a value or an Error instance.
   *
   *     var [ a, b, c ] = await myLoader.loadMany([ 'a', 'b', 'badkey' ]);
   *     // c instanceof Error
   *
   */ ;
    _proto.loadMany = function loadMany(keys) {
        if (!$61018fcf031b9b93$var$isArrayLike(keys)) throw new TypeError('The loader.loadMany() function must be called with Array<key> ' + ("but got: " + keys + "."));
         // Support ArrayLike by using only minimal property access
        var loadPromises = [];
        for(var i = 0; i < keys.length; i++)loadPromises.push(this.load(keys[i])["catch"](function(error) {
            return error;
        }));
        return Promise.all(loadPromises);
    } /**
   * Clears the value at `key` from the cache, if it exists. Returns itself for
   * method chaining.
   */ ;
    _proto.clear = function clear(key) {
        var cacheMap = this._cacheMap;
        if (cacheMap) {
            var cacheKey = this._cacheKeyFn(key);
            cacheMap["delete"](cacheKey);
        }
        return this;
    } /**
   * Clears the entire cache. To be used when some event results in unknown
   * invalidations across this particular `DataLoader`. Returns itself for
   * method chaining.
   */ ;
    _proto.clearAll = function clearAll() {
        var cacheMap = this._cacheMap;
        if (cacheMap) cacheMap.clear();
        return this;
    } /**
   * Adds the provided key and value to the cache. If the key already
   * exists, no change is made. Returns itself for method chaining.
   *
   * To prime the cache with an error at a key, provide an Error instance.
   */ ;
    _proto.prime = function prime(key, value) {
        var cacheMap = this._cacheMap;
        if (cacheMap) {
            var cacheKey = this._cacheKeyFn(key); // Only add the key if it does not already exist.
            if (cacheMap.get(cacheKey) === undefined) {
                // Cache a rejected promise if the value is an Error, in order to match
                // the behavior of load(key).
                var promise;
                if (value instanceof Error) {
                    promise = Promise.reject(value); // Since this is a case where an Error is intentionally being primed
                    // for a given key, we want to disable unhandled promise rejection.
                    promise["catch"](function() {});
                } else promise = Promise.resolve(value);
                cacheMap.set(cacheKey, promise);
            }
        }
        return this;
    } /**
   * The name given to this `DataLoader` instance. Useful for APM tools.
   *
   * Is `null` if not set in the constructor.
   */ ;
    return DataLoader;
}(); // Private: Enqueue a Job to be executed after all "PromiseJobs" Jobs.
//
// ES6 JavaScript uses the concepts Job and JobQueue to schedule work to occur
// after the current execution context has completed:
// http://www.ecma-international.org/ecma-262/6.0/#sec-jobs-and-job-queues
//
// Node.js uses the `process.nextTick` mechanism to implement the concept of a
// Job, maintaining a global FIFO JobQueue for all Jobs, which is flushed after
// the current call stack ends.
//
// When calling `then` on a Promise, it enqueues a Job on a specific
// "PromiseJobs" JobQueue which is flushed in Node as a single Job on the
// global JobQueue.
//
// DataLoader batches all loads which occur in a single frame of execution, but
// should include in the batch all loads which occur during the flushing of the
// "PromiseJobs" JobQueue after that same execution frame.
//
// In order to avoid the DataLoader dispatch Job occuring before "PromiseJobs",
// A Promise Job is created with the sole purpose of enqueuing a global Job,
// ensuring that it always occurs after "PromiseJobs" ends.
//
// Node.js's job queue is unique. Browsers do not have an equivalent mechanism
// for enqueuing a job to be performed after promise microtasks and before the
// next macrotask. For browser environments, a macrotask is used (via
// setImmediate or setTimeout) at a potential performance penalty.
var $61018fcf031b9b93$var$enqueuePostPromiseJob = typeof $3ZMUU === 'object' && typeof $3ZMUU.nextTick === 'function' ? function(fn) {
    if (!$61018fcf031b9b93$var$resolvedPromise) $61018fcf031b9b93$var$resolvedPromise = Promise.resolve();
    $61018fcf031b9b93$var$resolvedPromise.then(function() {
        $3ZMUU.nextTick(fn);
    });
} : typeof setImmediate === 'function' ? function(fn) {
    setImmediate(fn);
} : function(fn) {
    setTimeout(fn);
}; // Private: cached resolved Promise instance
var $61018fcf031b9b93$var$resolvedPromise; // Private: Describes a batch of requests
// Private: Either returns the current batch, or creates and schedules a
// dispatch of a new batch for the given loader.
function $61018fcf031b9b93$var$getCurrentBatch(loader) {
    // If there is an existing batch which has not yet dispatched and is within
    // the limit of the batch size, then return it.
    var existingBatch = loader._batch;
    if (existingBatch !== null && !existingBatch.hasDispatched && existingBatch.keys.length < loader._maxBatchSize) return existingBatch;
     // Otherwise, create a new batch for this loader.
    var newBatch = {
        hasDispatched: false,
        keys: [],
        callbacks: []
    }; // Store it on the loader so it may be reused.
    loader._batch = newBatch; // Then schedule a task to dispatch this batch of requests.
    loader._batchScheduleFn(function() {
        $61018fcf031b9b93$var$dispatchBatch(loader, newBatch);
    });
    return newBatch;
}
function $61018fcf031b9b93$var$dispatchBatch(loader, batch) {
    // Mark this batch as having been dispatched.
    batch.hasDispatched = true; // If there's nothing to load, resolve any cache hits and return early.
    if (batch.keys.length === 0) {
        $61018fcf031b9b93$var$resolveCacheHits(batch);
        return;
    } // Call the provided batchLoadFn for this loader with the batch's keys and
    // with the loader as the `this` context.
    var batchPromise;
    try {
        batchPromise = loader._batchLoadFn(batch.keys);
    } catch (e) {
        return $61018fcf031b9b93$var$failedDispatch(loader, batch, new TypeError("DataLoader must be constructed with a function which accepts Array<key> and returns Promise<Array<value>>, but the function " + ("errored synchronously: " + String(e) + ".")));
    } // Assert the expected response from batchLoadFn
    if (!batchPromise || typeof batchPromise.then !== 'function') return $61018fcf031b9b93$var$failedDispatch(loader, batch, new TypeError("DataLoader must be constructed with a function which accepts Array<key> and returns Promise<Array<value>>, but the function did " + ("not return a Promise: " + String(batchPromise) + ".")));
     // Await the resolution of the call to batchLoadFn.
    batchPromise.then(function(values) {
        // Assert the expected resolution from batchLoadFn.
        if (!$61018fcf031b9b93$var$isArrayLike(values)) throw new TypeError("DataLoader must be constructed with a function which accepts Array<key> and returns Promise<Array<value>>, but the function did " + ("not return a Promise of an Array: " + String(values) + "."));
        if (values.length !== batch.keys.length) throw new TypeError("DataLoader must be constructed with a function which accepts Array<key> and returns Promise<Array<value>>, but the function did not return a Promise of an Array of the same length as the Array of keys." + ("\n\nKeys:\n" + String(batch.keys)) + ("\n\nValues:\n" + String(values)));
         // Resolve all cache hits in the same micro-task as freshly loaded values.
        $61018fcf031b9b93$var$resolveCacheHits(batch); // Step through values, resolving or rejecting each Promise in the batch.
        for(var i = 0; i < batch.callbacks.length; i++){
            var _value = values[i];
            if (_value instanceof Error) batch.callbacks[i].reject(_value);
            else batch.callbacks[i].resolve(_value);
        }
    })["catch"](function(error) {
        $61018fcf031b9b93$var$failedDispatch(loader, batch, error);
    });
} // Private: do not cache individual loads if the entire batch dispatch fails,
// but still reject each request so they do not hang.
function $61018fcf031b9b93$var$failedDispatch(loader, batch, error) {
    // Cache hits are resolved, even though the batch failed.
    $61018fcf031b9b93$var$resolveCacheHits(batch);
    for(var i = 0; i < batch.keys.length; i++){
        loader.clear(batch.keys[i]);
        batch.callbacks[i].reject(error);
    }
} // Private: Resolves the Promises for any cache hits in this batch.
function $61018fcf031b9b93$var$resolveCacheHits(batch) {
    if (batch.cacheHits) for(var i = 0; i < batch.cacheHits.length; i++)batch.cacheHits[i]();
} // Private: given the DataLoader's options, produce a valid max batch size.
function $61018fcf031b9b93$var$getValidMaxBatchSize(options) {
    var shouldBatch = !options || options.batch !== false;
    if (!shouldBatch) return 1;
    var maxBatchSize = options && options.maxBatchSize;
    if (maxBatchSize === undefined) return Infinity;
    if (typeof maxBatchSize !== 'number' || maxBatchSize < 1) throw new TypeError("maxBatchSize must be a positive number: " + maxBatchSize);
    return maxBatchSize;
} // Private
function $61018fcf031b9b93$var$getValidBatchScheduleFn(options) {
    var batchScheduleFn = options && options.batchScheduleFn;
    if (batchScheduleFn === undefined) return $61018fcf031b9b93$var$enqueuePostPromiseJob;
    if (typeof batchScheduleFn !== 'function') throw new TypeError("batchScheduleFn must be a function: " + batchScheduleFn);
    return batchScheduleFn;
} // Private: given the DataLoader's options, produce a cache key function.
function $61018fcf031b9b93$var$getValidCacheKeyFn(options) {
    var cacheKeyFn = options && options.cacheKeyFn;
    if (cacheKeyFn === undefined) return function(key) {
        return key;
    };
    if (typeof cacheKeyFn !== 'function') throw new TypeError("cacheKeyFn must be a function: " + cacheKeyFn);
    return cacheKeyFn;
} // Private: given the DataLoader's options, produce a CacheMap to be used.
function $61018fcf031b9b93$var$getValidCacheMap(options) {
    var shouldCache = !options || options.cache !== false;
    if (!shouldCache) return null;
    var cacheMap = options && options.cacheMap;
    if (cacheMap === undefined) return new Map();
    if (cacheMap !== null) {
        var cacheFunctions = [
            'get',
            'set',
            'delete',
            'clear'
        ];
        var missingFunctions = cacheFunctions.filter(function(fnName) {
            return cacheMap && typeof cacheMap[fnName] !== 'function';
        });
        if (missingFunctions.length !== 0) throw new TypeError('Custom cacheMap missing methods: ' + missingFunctions.join(', '));
    }
    return cacheMap;
}
function $61018fcf031b9b93$var$getValidName(options) {
    if (options && options.name) return options.name;
    return null;
} // Private
function $61018fcf031b9b93$var$isArrayLike(x) {
    return typeof x === 'object' && x !== null && typeof x.length === 'number' && (x.length === 0 || x.length > 0 && Object.prototype.hasOwnProperty.call(x, x.length - 1));
}
module.exports = $61018fcf031b9b93$var$DataLoader;

});


parcelRegister("dWcZd", function(module, exports) {
$parcel$export(module.exports, "getMediaTypeFromUploadableFile", () => $a25ac3efdcf80d74$export$ac3214931ffd82af);

var $7VCF9 = parcelRequire("7VCF9");
var $a25ac3efdcf80d74$export$ac3214931ffd82af = function getMediaTypeFromUploadableFile(file) {
    if (file.content instanceof Blob) {
        var type = file.content.type;
        return (0, $7VCF9.getMediaTypeFromMimeType)(type);
    } else return 'unknown';
};

});
parcelRegister("7VCF9", function(module, exports) {
$parcel$export(module.exports, "getMediaTypeFromMimeType", () => $5c5bd8e603aea4f5$export$79e1dc0d1801e8ef);
$parcel$export(module.exports, "isImageMimeTypeSupportedByBrowser", () => (parcelRequire("keEas")).isImageMimeTypeSupportedByBrowser);
$parcel$export(module.exports, "isVideoMimeTypeSupportedByBrowser", () => (parcelRequire("keEas")).isVideoMimeTypeSupportedByBrowser);

var $d5qgj = parcelRequire("d5qgj");

var $keEas = parcelRequire("keEas");

var $aWDq9n = parcelRequire("aWDq9n");
var $5c5bd8e603aea4f5$export$79e1dc0d1801e8ef = function getMediaTypeFromMimeType(mimeType) {
    if ((0, $d5qgj.isArchive)(mimeType)) return 'archive';
    if ((0, $keEas.isImageMimeTypeSupportedByBrowser)(mimeType) || (0, $aWDq9n.isImageMimeTypeSupportedByServer)(mimeType)) return 'image';
    if ((0, $keEas.isDocumentMimeTypeSupportedByBrowser)(mimeType) || (0, $aWDq9n.isDocumentMimeTypeSupportedByServer)(mimeType)) return 'doc';
    if ((0, $keEas.isAudioMimeTypeSupportedByBrowser)(mimeType) || (0, $aWDq9n.isAudioMimeTypeSupportedByServer)(mimeType)) return 'audio';
    if ((0, $keEas.isVideoMimeTypeSupportedByBrowser)(mimeType) || (0, $aWDq9n.isVideoMimeTypeSupportedByServer)(mimeType)) return 'video';
    return 'unknown';
};

});
parcelRegister("d5qgj", function(module, exports) {
$parcel$export(module.exports, "isArchive", () => $98701d19cdee6fec$export$f47f3fe506e20fe6);
// Based on https://en.wikipedia.org/wiki/List_of_archive_formats
var $98701d19cdee6fec$export$f47f3fe506e20fe6 = function isArchive(mimeType) {
    return [
        'application/x-archive',
        'application/x-cpio',
        'application/x-shar',
        'application/x-iso9660-image',
        'application/x-sbx',
        'application/x-tar',
        'application/x-bzip2',
        'application/gzip',
        'application/x-gzip',
        'application/x-lzip',
        'application/x-lzma',
        'application/x-lzop',
        'application/x-snappy-framed',
        'application/x-xz',
        'application/x-compress',
        'application/zstd',
        'application/x-7z-compressed',
        'application/x-ace-compressed',
        'application/x-astrotite-afa',
        'application/x-alz-compressed',
        'application/vnd.android.package-archive',
        'application/x-freearc',
        'application/x-arj',
        'application/x-b1',
        'application/vnd.ms-cab-compressed',
        'application/x-cfs-compressed',
        'application/x-dar',
        'application/x-dgc-compressed',
        'application/x-apple-diskimage',
        'application/x-gca-compressed',
        'application/java-archive',
        'application/x-lzh',
        'application/x-lzx',
        'application/x-rar-compressed',
        'application/x-stuffit',
        'application/x-stuffitx',
        'application/x-gtar',
        'application/x-ms-wim',
        'application/x-xar',
        'application/zip',
        'application/x-zoo',
        'application/x-par2'
    ].indexOf(mimeType.toLowerCase()) > -1;
};

});

parcelRegister("keEas", function(module, exports) {
$parcel$export(module.exports, "isImageMimeTypeSupportedByBrowser", () => $ebb445eb9a9a60c5$export$c021f2623a75015f);
$parcel$export(module.exports, "isDocumentMimeTypeSupportedByBrowser", () => $ebb445eb9a9a60c5$export$74325e3c843a9555);
$parcel$export(module.exports, "isAudioMimeTypeSupportedByBrowser", () => $ebb445eb9a9a60c5$export$ff36075ea755a717);
$parcel$export(module.exports, "isVideoMimeTypeSupportedByBrowser", () => $ebb445eb9a9a60c5$export$87bf945cf31ec2d9);
$parcel$export(module.exports, "isMimeTypeSupportedByBrowser", () => $ebb445eb9a9a60c5$export$55ca6cdaf6093034);
// Based on https://developer.mozilla.org/en-US/docs/Web/Media/Formats/Image_types
var $ebb445eb9a9a60c5$export$c021f2623a75015f = function isImageMimeTypeSupportedByBrowser(mimeType) {
    return [
        'image/apng',
        'image/bmp',
        'image/gif',
        'image/x-icon',
        'image/jpeg',
        'image/png',
        'image/webp'
    ].indexOf(mimeType.toLowerCase()) > -1;
};
var $ebb445eb9a9a60c5$export$74325e3c843a9555 = function isDocumentMimeTypeSupportedByBrowser(mimeType) {
    return mimeType.toLowerCase() === 'application/pdf';
};
var $ebb445eb9a9a60c5$export$ff36075ea755a717 = function isAudioMimeTypeSupportedByBrowser(mimeType) {
    return [
        'audio/aac',
        'audio/flac',
        'audio/mp4',
        'audio/mpeg',
        'audio/ogg',
        'audio/x-ogg',
        'audio/wav',
        'audio/x-wav'
    ].indexOf(mimeType.toLowerCase()) > -1;
};
var $ebb445eb9a9a60c5$export$87bf945cf31ec2d9 = function isVideoMimeTypeSupportedByBrowser(mimeType) {
    return [
        'video/mp4',
        'video/quicktime'
    ].indexOf(mimeType.toLowerCase()) > -1;
};
var $ebb445eb9a9a60c5$export$55ca6cdaf6093034 = function isMimeTypeSupportedByBrowser(mimeType) {
    return $ebb445eb9a9a60c5$export$74325e3c843a9555(mimeType) || $ebb445eb9a9a60c5$export$c021f2623a75015f(mimeType) || $ebb445eb9a9a60c5$export$ff36075ea755a717(mimeType) || $ebb445eb9a9a60c5$export$87bf945cf31ec2d9(mimeType);
};

});

parcelRegister("aWDq9n", function(module, exports) {
$parcel$export(module.exports, "isImageMimeTypeSupportedByServer", () => $7f7de64dd417a83e$export$e9a065a80f76311e);
$parcel$export(module.exports, "isDocumentMimeTypeSupportedByServer", () => $7f7de64dd417a83e$export$86baad7a89d908e9);
$parcel$export(module.exports, "isAudioMimeTypeSupportedByServer", () => $7f7de64dd417a83e$export$8cba23825d020bbb);
$parcel$export(module.exports, "isVideoMimeTypeSupportedByServer", () => $7f7de64dd417a83e$export$9c2b4de5fdca2ce3);
$parcel$export(module.exports, "isMimeTypeSupportedByServer", () => $7f7de64dd417a83e$export$548d9148a80556a3);
// Based on https://developer.atlassian.com/platform/media/learning/file-previews/
var $7f7de64dd417a83e$export$e9a065a80f76311e = function isImageMimeTypeSupportedByServer(mimeType) {
    return [
        'image/bmp',
        'image/x-windows-bmp',
        'application/dicom',
        'image/gif',
        'image/jpeg',
        'image/jpg',
        'image/jp_',
        'application/jpg',
        'application/x-jpg',
        'image/png',
        'application/png',
        'application/x-png',
        'application/vnd.adobe.photoshop',
        'image/vnd.adobe.photoshop',
        'image/photoshop',
        'image/x-photoshop',
        'image/psd',
        'application/photoshop',
        'application/psd',
        'zz-application/zz-winassoc-psd',
        'image/tiff',
        'image/x-tif',
        'image/x-tiff',
        'application/tif',
        'application/x-tif',
        'application/tiff',
        'application/x-tiff',
        'image/svg+xml',
        'image/heif',
        'image/heif-sequence',
        'image/heic',
        'image/heic-sequence'
    ].indexOf(mimeType.toLowerCase()) > -1;
};
var $7f7de64dd417a83e$export$86baad7a89d908e9 = function isDocumentMimeTypeSupportedByServer(mimeType) {
    return [
        // Adobe PDF
        'application/pdf',
        'application/x-pdf',
        'application/acrobat',
        'applications/vnd.pdf',
        'text/pdf',
        'text/x-pdf',
        // Adobe Illustrator
        'application/vnd.adobe.illustrator',
        // Microsoft Office
        'application/vnd.ms-office',
        // Microsoft Word
        'application/msword',
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
        'application/vnd.openxmlformats-officedocument.wordprocessingml.template',
        'application/vnd.ms-word.document.macroenabled.12',
        'application/vnd.ms-word.template.macroenabled.12',
        // Microsoft Excel
        'application/vnd.ms-excel',
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        'application/vnd.openxmlformats-officedocument.spreadsheetml.template',
        'application/vnd.ms-excel.sheet.macroenabled.12',
        'application/vnd.ms-excel.template.macroenabled.12',
        'application/vnd.ms-excel.addin.macroenabled.12',
        'application/vnd.ms-excel.sheet.macroenabled',
        'application/vnd.ms-excel.template.macroenabled',
        'application/vnd.ms-excel.addin.macroenabled',
        // Microsoft Powerpoint
        'application/vnd.ms-powerpoint',
        'application/vnd.openxmlformats-officedocument.presentationml.presentation',
        'application/vnd.openxmlformats-officedocument.presentationml.template',
        'application/vnd.openxmlformats-officedocument.presentationml.slideshow',
        'application/vnd.ms-powerpoint.presentation.macroenabled.12',
        'application/vnd.ms-powerpoint.template.macroenabled.12',
        'application/vnd.ms-powerpoint.slideshow.macroenabled.12',
        // OpenOffice
        'application/vnd.sun.xml.writer',
        'application/vnd.sun.xml.writer.template',
        // OpenDocument
        'application/vnd.sun.xml.draw',
        'application/vnd.sun.xml.draw.template',
        'application/vnd.oasis.opendocument.graphics',
        'application/vnd.oasis.opendocument.presentation',
        'application/x-vnd.oasis.opendocument.presentation',
        'application/vnd.sun.xml.calc',
        'application/vnd.sun.xml.calc.template',
        'application/vnd.oasis.opendocument.spreadsheet',
        'application/x-vnd.oasis.opendocument.spreadsheet',
        'application/vnd.oasis.opendocument.spreadsheet-template',
        'application/vnd.oasis.opendocument.text',
        'application/vnd.oasis.opendocument.text-template',
        'application/vnd.oasis.opendocument.text-master',
        'application/x-vnd.oasis.opendocument.text',
        'application/x-vnd.oasis.opendocument.text-template',
        'application/x-vnd.oasis.opendocument.text-master',
        // WordPerfect
        'application/vnd.wordperfect',
        // Text files
        'text/csv',
        'text/x-diff',
        'text/x-perl',
        'text/x-python',
        'text/x-ruby',
        'text/rtf',
        'text/richtext',
        'text/plain',
        'application/txt',
        // Rich text
        'application/rtf',
        'application/x-rtf',
        // PostScript
        'application/postscript'
    ].indexOf(mimeType.toLowerCase()) > -1;
};
var $7f7de64dd417a83e$export$8cba23825d020bbb = function isAudioMimeTypeSupportedByServer(mimeType) {
    return [
        'audio/aac',
        'audio/x-hx-aac-adts',
        'audio/vnd.dolby.dd-raw',
        'audio/aiff',
        'audio/x-aiff',
        'audio/x-monkeys-audio',
        'audio/x-ape',
        'audio/basic',
        'audio/flac',
        'audio/mp4',
        'audio/midi',
        'audio/x-matroska',
        'audio/x-mod',
        'audio/mpeg',
        'audio/ogg',
        'audio/x-ogg',
        'audio/x-pn-realaudio',
        'audio/wav',
        'audio/x-wav',
        'audio/x-ms-wma'
    ].indexOf(mimeType.toLowerCase()) > -1;
};
var $7f7de64dd417a83e$export$9c2b4de5fdca2ce3 = function isVideoMimeTypeSupportedByServer(mimeType) {
    return [
        'video/3gpp',
        'video/3gpp2',
        'video/x-ms-asf',
        'video/avi',
        'video/msvideo',
        'video/x-msvideo',
        'video/x-dv',
        'video/x-flv',
        'video/m2ts',
        'video/x-m4v',
        'video/x-matroska',
        'video/quicktime',
        'video/mp4',
        'video/mpeg',
        'video/ogg',
        'video/x-ogg',
        'video/webm',
        'video/x-ms-wmv'
    ].indexOf(mimeType.toLowerCase()) > -1;
};
var $7f7de64dd417a83e$export$94e1479e01d2af53 = function isUnknownMimeTypeSupportedByServer(mimeType) {
    return [
        'binary/octet-stream'
    ].indexOf(mimeType.toLowerCase()) > -1;
};
var $7f7de64dd417a83e$export$548d9148a80556a3 = function isMimeTypeSupportedByServer(mimeType) {
    return $7f7de64dd417a83e$export$e9a065a80f76311e(mimeType) || $7f7de64dd417a83e$export$86baad7a89d908e9(mimeType) || $7f7de64dd417a83e$export$8cba23825d020bbb(mimeType) || $7f7de64dd417a83e$export$9c2b4de5fdca2ce3(mimeType) || $7f7de64dd417a83e$export$94e1479e01d2af53(mimeType);
};

});



parcelRegister("kwu4A", function(module, exports) {
$parcel$export(module.exports, "overrideMediaTypeIfUnknown", () => $ef0e1fa5cfb2a4d2$export$89097c0ec1e0dee1);

var $eBhvj = parcelRequire("eBhvj");
var $ef0e1fa5cfb2a4d2$export$89097c0ec1e0dee1 = function overrideMediaTypeIfUnknown(fileState, mediaType) {
    if (!(0, $eBhvj.isErrorFileState)(fileState) && fileState.mediaType === 'unknown') return {
        mediaType: mediaType
    };
    return {};
};

});

parcelRegister("deN8P", function(module, exports) {
$parcel$export(module.exports, "convertBase64ToBlob", () => $9a32b3a64d882a0a$export$ed17558b11b88056);
var $9a32b3a64d882a0a$export$ed17558b11b88056 = function convertBase64ToBlob(base64) {
    var sliceSize = 512;
    var base64Data = base64.split(',')[1];
    var byteCharacters = atob(base64Data);
    var byteArrays = [];
    var _loop = function _loop() {
        var slice = byteCharacters.slice(offset, offset + sliceSize);
        var byteNumbers = slice.split('').map(function(_, i) {
            return slice.charCodeAt(i);
        });
        var byteArray = new Uint8Array(byteNumbers);
        byteArrays.push(byteArray);
    };
    for(var offset = 0; offset < byteCharacters.length; offset += sliceSize)_loop();
    // @ts-ignore - TS2345 TypeScript 5.9.2 upgrade
    return new Blob(byteArrays, {
        type: 'image/jpeg'
    });
};

});

parcelRegister("hs0Ss", function(module, exports) {
$parcel$export(module.exports, "fromObservable", () => $cb45bb6543ea1be2$export$4b2432e2d8723823);

var $d9Gbq = parcelRequire("d9Gbq");
function $cb45bb6543ea1be2$export$4b2432e2d8723823(observable) {
    return {
        subscribe: function subscribe(observer) {
            var subscription = // This is needed to handle "subscribe" function overload.
            // It allows accepting a single "next" callback function as an argument.
            observer instanceof Function ? observable.subscribe(observer) : observable.subscribe(observer);
            return {
                unsubscribe: function unsubscribe() {
                    subscription.unsubscribe();
                }
            };
        }
    };
}
function $cb45bb6543ea1be2$export$8659d1f07d151381(item) {
    return $cb45bb6543ea1be2$export$4b2432e2d8723823((0, $d9Gbq.createMediaSubject)(item));
}

});
parcelRegister("d9Gbq", function(module, exports) {
$parcel$export(module.exports, "createMediaSubject", () => $993cd65cba4d6b10$export$bc76d51553fa5e35);

var $3XPX2 = parcelRequire("3XPX2");
function $993cd65cba4d6b10$export$bc76d51553fa5e35(initialState) {
    var subject = new (0, $3XPX2.ReplaySubject)(1);
    if (initialState instanceof Error) subject.error(initialState);
    else if (initialState) subject.next(initialState);
    return subject;
}

});
parcelRegister("3XPX2", function(module, exports) {
"use strict";
var $2e2f2e33bd28a05e$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $5r7W1 = parcelRequire("5r7W1");

var $KC2hG = parcelRequire("KC2hG");

var $lSgto = parcelRequire("lSgto");

var $lPK1b = parcelRequire("lPK1b");

var $gPIwV = parcelRequire("gPIwV");

var $58oCu = parcelRequire("58oCu");
/**
 * @class ReplaySubject<T>
 */ var $2e2f2e33bd28a05e$var$ReplaySubject = function(_super) {
    $2e2f2e33bd28a05e$var$__extends(ReplaySubject, _super);
    function ReplaySubject(bufferSize, windowTime, scheduler) {
        if (bufferSize === void 0) bufferSize = Number.POSITIVE_INFINITY;
        if (windowTime === void 0) windowTime = Number.POSITIVE_INFINITY;
        _super.call(this);
        this.scheduler = scheduler;
        this._events = [];
        this._bufferSize = bufferSize < 1 ? 1 : bufferSize;
        this._windowTime = windowTime < 1 ? 1 : windowTime;
    }
    ReplaySubject.prototype.next = function(value) {
        var now = this._getNow();
        this._events.push(new $2e2f2e33bd28a05e$var$ReplayEvent(now, value));
        this._trimBufferThenGetEvents();
        _super.prototype.next.call(this, value);
    };
    /** @deprecated internal use only */ ReplaySubject.prototype._subscribe = function(subscriber) {
        var _events = this._trimBufferThenGetEvents();
        var scheduler = this.scheduler;
        var subscription;
        if (this.closed) throw new $gPIwV.ObjectUnsubscribedError();
        else if (this.hasError) subscription = $lSgto.Subscription.EMPTY;
        else if (this.isStopped) subscription = $lSgto.Subscription.EMPTY;
        else {
            this.observers.push(subscriber);
            subscription = new $58oCu.SubjectSubscription(this, subscriber);
        }
        if (scheduler) subscriber.add(subscriber = new $lPK1b.ObserveOnSubscriber(subscriber, scheduler));
        var len = _events.length;
        for(var i = 0; i < len && !subscriber.closed; i++)subscriber.next(_events[i].value);
        if (this.hasError) subscriber.error(this.thrownError);
        else if (this.isStopped) subscriber.complete();
        return subscription;
    };
    ReplaySubject.prototype._getNow = function() {
        return (this.scheduler || $KC2hG.queue).now();
    };
    ReplaySubject.prototype._trimBufferThenGetEvents = function() {
        var now = this._getNow();
        var _bufferSize = this._bufferSize;
        var _windowTime = this._windowTime;
        var _events = this._events;
        var eventsCount = _events.length;
        var spliceCount = 0;
        // Trim events that fall out of the time window.
        // Start at the front of the list. Break early once
        // we encounter an event that falls within the window.
        while(spliceCount < eventsCount){
            if (now - _events[spliceCount].time < _windowTime) break;
            spliceCount++;
        }
        if (eventsCount > _bufferSize) spliceCount = Math.max(spliceCount, eventsCount - _bufferSize);
        if (spliceCount > 0) _events.splice(0, spliceCount);
        return _events;
    };
    return ReplaySubject;
}($5r7W1.Subject);
module.exports.ReplaySubject = $2e2f2e33bd28a05e$var$ReplaySubject;
var $2e2f2e33bd28a05e$var$ReplayEvent = function() {
    function ReplayEvent(time, value) {
        this.time = time;
        this.value = value;
    }
    return ReplayEvent;
}();

});
parcelRegister("5r7W1", function(module, exports) {
"use strict";
var $3f55a10ff19d0f31$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $lryMy = parcelRequire("lryMy");

var $deMDi = parcelRequire("deMDi");

var $lSgto = parcelRequire("lSgto");

var $gPIwV = parcelRequire("gPIwV");

var $58oCu = parcelRequire("58oCu");

var $efmvI = parcelRequire("efmvI");
/**
 * @class SubjectSubscriber<T>
 */ var $3f55a10ff19d0f31$var$SubjectSubscriber = function(_super) {
    $3f55a10ff19d0f31$var$__extends(SubjectSubscriber, _super);
    function SubjectSubscriber(destination) {
        _super.call(this, destination);
        this.destination = destination;
    }
    return SubjectSubscriber;
}($deMDi.Subscriber);
module.exports.SubjectSubscriber = $3f55a10ff19d0f31$var$SubjectSubscriber;
/**
 * @class Subject<T>
 */ var $3f55a10ff19d0f31$var$Subject = function(_super) {
    $3f55a10ff19d0f31$var$__extends(Subject, _super);
    function Subject() {
        _super.call(this);
        this.observers = [];
        this.closed = false;
        this.isStopped = false;
        this.hasError = false;
        this.thrownError = null;
    }
    Subject.prototype[$efmvI.rxSubscriber] = function() {
        return new $3f55a10ff19d0f31$var$SubjectSubscriber(this);
    };
    Subject.prototype.lift = function(operator) {
        var subject = new $3f55a10ff19d0f31$var$AnonymousSubject(this, this);
        subject.operator = operator;
        return subject;
    };
    Subject.prototype.next = function(value) {
        if (this.closed) throw new $gPIwV.ObjectUnsubscribedError();
        if (!this.isStopped) {
            var observers = this.observers;
            var len = observers.length;
            var copy = observers.slice();
            for(var i = 0; i < len; i++)copy[i].next(value);
        }
    };
    Subject.prototype.error = function(err) {
        if (this.closed) throw new $gPIwV.ObjectUnsubscribedError();
        this.hasError = true;
        this.thrownError = err;
        this.isStopped = true;
        var observers = this.observers;
        var len = observers.length;
        var copy = observers.slice();
        for(var i = 0; i < len; i++)copy[i].error(err);
        this.observers.length = 0;
    };
    Subject.prototype.complete = function() {
        if (this.closed) throw new $gPIwV.ObjectUnsubscribedError();
        this.isStopped = true;
        var observers = this.observers;
        var len = observers.length;
        var copy = observers.slice();
        for(var i = 0; i < len; i++)copy[i].complete();
        this.observers.length = 0;
    };
    Subject.prototype.unsubscribe = function() {
        this.isStopped = true;
        this.closed = true;
        this.observers = null;
    };
    Subject.prototype._trySubscribe = function(subscriber) {
        if (this.closed) throw new $gPIwV.ObjectUnsubscribedError();
        else return _super.prototype._trySubscribe.call(this, subscriber);
    };
    /** @deprecated internal use only */ Subject.prototype._subscribe = function(subscriber) {
        if (this.closed) throw new $gPIwV.ObjectUnsubscribedError();
        else if (this.hasError) {
            subscriber.error(this.thrownError);
            return $lSgto.Subscription.EMPTY;
        } else if (this.isStopped) {
            subscriber.complete();
            return $lSgto.Subscription.EMPTY;
        } else {
            this.observers.push(subscriber);
            return new $58oCu.SubjectSubscription(this, subscriber);
        }
    };
    Subject.prototype.asObservable = function() {
        var observable = new $lryMy.Observable();
        observable.source = this;
        return observable;
    };
    Subject.create = function(destination, source) {
        return new $3f55a10ff19d0f31$var$AnonymousSubject(destination, source);
    };
    return Subject;
}($lryMy.Observable);
module.exports.Subject = $3f55a10ff19d0f31$var$Subject;
/**
 * @class AnonymousSubject<T>
 */ var $3f55a10ff19d0f31$var$AnonymousSubject = function(_super) {
    $3f55a10ff19d0f31$var$__extends(AnonymousSubject, _super);
    function AnonymousSubject(destination, source) {
        _super.call(this);
        this.destination = destination;
        this.source = source;
    }
    AnonymousSubject.prototype.next = function(value) {
        var destination = this.destination;
        if (destination && destination.next) destination.next(value);
    };
    AnonymousSubject.prototype.error = function(err) {
        var destination = this.destination;
        if (destination && destination.error) this.destination.error(err);
    };
    AnonymousSubject.prototype.complete = function() {
        var destination = this.destination;
        if (destination && destination.complete) this.destination.complete();
    };
    /** @deprecated internal use only */ AnonymousSubject.prototype._subscribe = function(subscriber) {
        var source = this.source;
        if (source) return this.source.subscribe(subscriber);
        else return $lSgto.Subscription.EMPTY;
    };
    return AnonymousSubject;
}($3f55a10ff19d0f31$var$Subject);
module.exports.AnonymousSubject = $3f55a10ff19d0f31$var$AnonymousSubject;

});
parcelRegister("gPIwV", function(module, exports) {
"use strict";
var $c413f381f069d03f$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
/**
 * An error thrown when an action is invalid because the object has been
 * unsubscribed.
 *
 * @see {@link Subject}
 * @see {@link BehaviorSubject}
 *
 * @class ObjectUnsubscribedError
 */ var $c413f381f069d03f$var$ObjectUnsubscribedError = function(_super) {
    $c413f381f069d03f$var$__extends(ObjectUnsubscribedError, _super);
    function ObjectUnsubscribedError() {
        var err = _super.call(this, 'object unsubscribed');
        this.name = err.name = 'ObjectUnsubscribedError';
        this.stack = err.stack;
        this.message = err.message;
    }
    return ObjectUnsubscribedError;
}(Error);
module.exports.ObjectUnsubscribedError = $c413f381f069d03f$var$ObjectUnsubscribedError;

});

parcelRegister("58oCu", function(module, exports) {
"use strict";
var $3bd0cc1474300481$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $lSgto = parcelRequire("lSgto");
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $3bd0cc1474300481$var$SubjectSubscription = function(_super) {
    $3bd0cc1474300481$var$__extends(SubjectSubscription, _super);
    function SubjectSubscription(subject, subscriber) {
        _super.call(this);
        this.subject = subject;
        this.subscriber = subscriber;
        this.closed = false;
    }
    SubjectSubscription.prototype.unsubscribe = function() {
        if (this.closed) return;
        this.closed = true;
        var subject = this.subject;
        var observers = subject.observers;
        this.subject = null;
        if (!observers || observers.length === 0 || subject.isStopped || subject.closed) return;
        var subscriberIndex = observers.indexOf(this.subscriber);
        if (subscriberIndex !== -1) observers.splice(subscriberIndex, 1);
    };
    return SubjectSubscription;
}($lSgto.Subscription);
module.exports.SubjectSubscription = $3bd0cc1474300481$var$SubjectSubscription;

});


parcelRegister("KC2hG", function(module, exports) {
$parcel$export(module.exports, "queue", () => $08c1cd1e6b154c01$export$4f7fa46ff53e516f, (v) => $08c1cd1e6b154c01$export$4f7fa46ff53e516f = v);
/**
 *
 * Queue Scheduler
 *
 * <span class="informal">Put every next task on a queue, instead of executing it immediately</span>
 *
 * `queue` scheduler, when used with delay, behaves the same as {@link async} scheduler.
 *
 * When used without delay, it schedules given task synchronously - executes it right when
 * it is scheduled. However when called recursively, that is when inside the scheduled task,
 * another task is scheduled with queue scheduler, instead of executing immediately as well,
 * that task will be put on a queue and wait for current one to finish.
 *
 * This means that when you execute task with `queue` scheduler, you are sure it will end
 * before any other task scheduled with that scheduler will start.
 *
 * @examples <caption>Schedule recursively first, then do something</caption>
 *
 * Rx.Scheduler.queue.schedule(() => {
 *   Rx.Scheduler.queue.schedule(() => console.log('second')); // will not happen now, but will be put on a queue
 *
 *   console.log('first');
 * });
 *
 * // Logs:
 * // "first"
 * // "second"
 *
 *
 * @example <caption>Reschedule itself recursively</caption>
 *
 * Rx.Scheduler.queue.schedule(function(state) {
 *   if (state !== 0) {
 *     console.log('before', state);
 *     this.schedule(state - 1); // `this` references currently executing Action,
 *                               // which we reschedule with new state
 *     console.log('after', state);
 *   }
 * }, 0, 3);
 *
 * // In scheduler that runs recursively, you would expect:
 * // "before", 3
 * // "before", 2
 * // "before", 1
 * // "after", 1
 * // "after", 2
 * // "after", 3
 *
 * // But with queue it logs:
 * // "before", 3
 * // "after", 3
 * // "before", 2
 * // "after", 2
 * // "before", 1
 * // "after", 1
 *
 *
 * @static true
 * @name queue
 * @owner Scheduler
 */ var $08c1cd1e6b154c01$export$4f7fa46ff53e516f;
"use strict";

var $1lCaP = parcelRequire("1lCaP");

var $dabgw = parcelRequire("dabgw");
$08c1cd1e6b154c01$export$4f7fa46ff53e516f = new $dabgw.QueueScheduler($1lCaP.QueueAction);

});
parcelRegister("1lCaP", function(module, exports) {
"use strict";
var $0fb55d13da2025a8$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $1ydSg = parcelRequire("1ydSg");
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $0fb55d13da2025a8$var$QueueAction = function(_super) {
    $0fb55d13da2025a8$var$__extends(QueueAction, _super);
    function QueueAction(scheduler, work) {
        _super.call(this, scheduler, work);
        this.scheduler = scheduler;
        this.work = work;
    }
    QueueAction.prototype.schedule = function(state, delay) {
        if (delay === void 0) delay = 0;
        if (delay > 0) return _super.prototype.schedule.call(this, state, delay);
        this.delay = delay;
        this.state = state;
        this.scheduler.flush(this);
        return this;
    };
    QueueAction.prototype.execute = function(state, delay) {
        return delay > 0 || this.closed ? _super.prototype.execute.call(this, state, delay) : this._execute(state, delay);
    };
    QueueAction.prototype.requestAsyncId = function(scheduler, id, delay) {
        if (delay === void 0) delay = 0;
        // If delay exists and is greater than 0, or if the delay is null (the
        // action wasn't rescheduled) but was originally scheduled as an async
        // action, then recycle as an async action.
        if (delay !== null && delay > 0 || delay === null && this.delay > 0) return _super.prototype.requestAsyncId.call(this, scheduler, id, delay);
        // Otherwise flush the scheduler starting with this action.
        return scheduler.flush(this);
    };
    return QueueAction;
}($1ydSg.AsyncAction);
module.exports.QueueAction = $0fb55d13da2025a8$var$QueueAction;

});
parcelRegister("1ydSg", function(module, exports) {
"use strict";
var $1213ba871890f324$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $gvBTr = parcelRequire("gvBTr");

var $dkg3w = parcelRequire("dkg3w");
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $1213ba871890f324$var$AsyncAction = function(_super) {
    $1213ba871890f324$var$__extends(AsyncAction, _super);
    function AsyncAction(scheduler, work) {
        _super.call(this, scheduler, work);
        this.scheduler = scheduler;
        this.pending = false;
        this.work = work;
    }
    AsyncAction.prototype.schedule = function(state, delay) {
        if (delay === void 0) delay = 0;
        if (this.closed) return this;
        // Always replace the current state with the new state.
        this.state = state;
        // Set the pending flag indicating that this action has been scheduled, or
        // has recursively rescheduled itself.
        this.pending = true;
        var id = this.id;
        var scheduler = this.scheduler;
        //
        // Important implementation note:
        //
        // Actions only execute once by default, unless rescheduled from within the
        // scheduled callback. This allows us to implement single and repeat
        // actions via the same code path, without adding API surface area, as well
        // as mimic traditional recursion but across asynchronous boundaries.
        //
        // However, JS runtimes and timers distinguish between intervals achieved by
        // serial `setTimeout` calls vs. a single `setInterval` call. An interval of
        // serial `setTimeout` calls can be individually delayed, which delays
        // scheduling the next `setTimeout`, and so on. `setInterval` attempts to
        // guarantee the interval callback will be invoked more precisely to the
        // interval period, regardless of load.
        //
        // Therefore, we use `setInterval` to schedule single and repeat actions.
        // If the action reschedules itself with the same delay, the interval is not
        // canceled. If the action doesn't reschedule, or reschedules with a
        // different delay, the interval will be canceled after scheduled callback
        // execution.
        //
        if (id != null) this.id = this.recycleAsyncId(scheduler, id, delay);
        this.delay = delay;
        // If this action has already an async Id, don't request a new one.
        this.id = this.id || this.requestAsyncId(scheduler, this.id, delay);
        return this;
    };
    AsyncAction.prototype.requestAsyncId = function(scheduler, id, delay) {
        if (delay === void 0) delay = 0;
        return $gvBTr.root.setInterval(scheduler.flush.bind(scheduler, this), delay);
    };
    AsyncAction.prototype.recycleAsyncId = function(scheduler, id, delay) {
        if (delay === void 0) delay = 0;
        // If this action is rescheduled with the same delay time, don't clear the interval id.
        if (delay !== null && this.delay === delay && this.pending === false) return id;
        // Otherwise, if the action's delay time is different from the current delay,
        // or the action has been rescheduled before it's executed, clear the interval id
        return $gvBTr.root.clearInterval(id) && undefined, undefined;
    };
    /**
     * Immediately executes this action and the `work` it contains.
     * @return {any}
     */ AsyncAction.prototype.execute = function(state, delay) {
        if (this.closed) return new Error('executing a cancelled action');
        this.pending = false;
        var error = this._execute(state, delay);
        if (error) return error;
        else if (this.pending === false && this.id != null) // Dequeue if the action didn't reschedule itself. Don't call
        // unsubscribe(), because the action could reschedule later.
        // For example:
        // ```
        // scheduler.schedule(function doWork(counter) {
        //   /* ... I'm a busy worker bee ... */
        //   var originalAction = this;
        //   /* wait 100ms before rescheduling the action */
        //   setTimeout(function () {
        //     originalAction.schedule(counter + 1);
        //   }, 100);
        // }, 1000);
        // ```
        this.id = this.recycleAsyncId(this.scheduler, this.id, null);
    };
    AsyncAction.prototype._execute = function(state, delay) {
        var errored = false;
        var errorValue = undefined;
        try {
            this.work(state);
        } catch (e) {
            errored = true;
            errorValue = !!e && e || new Error(e);
        }
        if (errored) {
            this.unsubscribe();
            return errorValue;
        }
    };
    /** @deprecated internal use only */ AsyncAction.prototype._unsubscribe = function() {
        var id = this.id;
        var scheduler = this.scheduler;
        var actions = scheduler.actions;
        var index = actions.indexOf(this);
        this.work = null;
        this.state = null;
        this.pending = false;
        this.scheduler = null;
        if (index !== -1) actions.splice(index, 1);
        if (id != null) this.id = this.recycleAsyncId(scheduler, id, null);
        this.delay = null;
    };
    return AsyncAction;
}($dkg3w.Action);
module.exports.AsyncAction = $1213ba871890f324$var$AsyncAction;

});
parcelRegister("dkg3w", function(module, exports) {
"use strict";
var $9b3998f5fef37039$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $lSgto = parcelRequire("lSgto");
/**
 * A unit of work to be executed in a {@link Scheduler}. An action is typically
 * created from within a Scheduler and an RxJS user does not need to concern
 * themselves about creating and manipulating an Action.
 *
 * ```ts
 * class Action<T> extends Subscription {
 *   new (scheduler: Scheduler, work: (state?: T) => void);
 *   schedule(state?: T, delay: number = 0): Subscription;
 * }
 * ```
 *
 * @class Action<T>
 */ var $9b3998f5fef37039$var$Action = function(_super) {
    $9b3998f5fef37039$var$__extends(Action, _super);
    function Action(scheduler, work) {
        _super.call(this);
    }
    /**
     * Schedules this action on its parent Scheduler for execution. May be passed
     * some context object, `state`. May happen at some point in the future,
     * according to the `delay` parameter, if specified.
     * @param {T} [state] Some contextual data that the `work` function uses when
     * called by the Scheduler.
     * @param {number} [delay] Time to wait before executing the work, where the
     * time unit is implicit and defined by the Scheduler.
     * @return {void}
     */ Action.prototype.schedule = function(state, delay) {
        if (delay === void 0) delay = 0;
        return this;
    };
    return Action;
}($lSgto.Subscription);
module.exports.Action = $9b3998f5fef37039$var$Action;

});



parcelRegister("dabgw", function(module, exports) {
"use strict";
var $9954f2a10ad9c0de$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $eoP0B = parcelRequire("eoP0B");
var $9954f2a10ad9c0de$var$QueueScheduler = function(_super) {
    $9954f2a10ad9c0de$var$__extends(QueueScheduler, _super);
    function QueueScheduler() {
        _super.apply(this, arguments);
    }
    return QueueScheduler;
}($eoP0B.AsyncScheduler);
module.exports.QueueScheduler = $9954f2a10ad9c0de$var$QueueScheduler;

});
parcelRegister("eoP0B", function(module, exports) {
"use strict";
var $a7badfdc07b6ab7e$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $LPnGE = parcelRequire("LPnGE");
var $a7badfdc07b6ab7e$var$AsyncScheduler = function(_super) {
    $a7badfdc07b6ab7e$var$__extends(AsyncScheduler, _super);
    function AsyncScheduler() {
        _super.apply(this, arguments);
        this.actions = [];
        /**
         * A flag to indicate whether the Scheduler is currently executing a batch of
         * queued actions.
         * @type {boolean}
         */ this.active = false;
        /**
         * An internal ID used to track the latest asynchronous task such as those
         * coming from `setTimeout`, `setInterval`, `requestAnimationFrame`, and
         * others.
         * @type {any}
         */ this.scheduled = undefined;
    }
    AsyncScheduler.prototype.flush = function(action) {
        var actions = this.actions;
        if (this.active) {
            actions.push(action);
            return;
        }
        var error;
        this.active = true;
        do {
            if (error = action.execute(action.state, action.delay)) break;
        }while (action = actions.shift()); // exhaust the scheduler queue
        this.active = false;
        if (error) {
            while(action = actions.shift())action.unsubscribe();
            throw error;
        }
    };
    return AsyncScheduler;
}($LPnGE.Scheduler);
module.exports.AsyncScheduler = $a7badfdc07b6ab7e$var$AsyncScheduler;

});
parcelRegister("LPnGE", function(module, exports) {
$parcel$export(module.exports, "Scheduler", () => $08fc3f1b39f459ba$export$d3e54bb8584cda7c, (v) => $08fc3f1b39f459ba$export$d3e54bb8584cda7c = v);
var $08fc3f1b39f459ba$export$d3e54bb8584cda7c;
"use strict";
/**
 * An execution context and a data structure to order tasks and schedule their
 * execution. Provides a notion of (potentially virtual) time, through the
 * `now()` getter method.
 *
 * Each unit of work in a Scheduler is called an {@link Action}.
 *
 * ```ts
 * class Scheduler {
 *   now(): number;
 *   schedule(work, delay?, state?): Subscription;
 * }
 * ```
 *
 * @class Scheduler
 */ var $08fc3f1b39f459ba$var$Scheduler = function() {
    function Scheduler(SchedulerAction, now) {
        if (now === void 0) now = Scheduler.now;
        this.SchedulerAction = SchedulerAction;
        this.now = now;
    }
    /**
     * Schedules a function, `work`, for execution. May happen at some point in
     * the future, according to the `delay` parameter, if specified. May be passed
     * some context object, `state`, which will be passed to the `work` function.
     *
     * The given arguments will be processed an stored as an Action object in a
     * queue of actions.
     *
     * @param {function(state: ?T): ?Subscription} work A function representing a
     * task, or some unit of work to be executed by the Scheduler.
     * @param {number} [delay] Time to wait before executing the work, where the
     * time unit is implicit and defined by the Scheduler itself.
     * @param {T} [state] Some contextual data that the `work` function uses when
     * called by the Scheduler.
     * @return {Subscription} A subscription in order to be able to unsubscribe
     * the scheduled work.
     */ Scheduler.prototype.schedule = function(work, delay, state) {
        if (delay === void 0) delay = 0;
        return new this.SchedulerAction(this, work).schedule(state, delay);
    };
    Scheduler.now = Date.now ? Date.now : function() {
        return +new Date();
    };
    return Scheduler;
}();
$08fc3f1b39f459ba$export$d3e54bb8584cda7c = $08fc3f1b39f459ba$var$Scheduler;

});







parcelRegister("7zwAj", function(module, exports) {
$parcel$export(module.exports, "toPromise", () => $583513f3b45ac0cc$export$4dbaaf6c79705e6c);

var $lSgto = parcelRequire("lSgto");
var $583513f3b45ac0cc$export$4dbaaf6c79705e6c = function toPromise(mediaSubscribable) {
    var subscription = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new (0, $lSgto.Subscription)();
    return new Promise(function(resolve, reject) {
        return subscription.add(mediaSubscribable.subscribe({
            next: function next(state) {
                resolve(state);
                subscription.unsubscribe();
            },
            error: function error(_error) {
                reject(_error);
                subscription.unsubscribe();
            }
        }));
    });
};

});

parcelRegister("9uFR7", function(module, exports) {
$parcel$export(module.exports, "getDimensionsFromBlob", () => $6e976214a074bd25$export$71797c284d89a3e1);

var $fL8KA = parcelRequire("fL8KA");

var $6HG4S = parcelRequire("6HG4S");

var $1iBl7 = parcelRequire("1iBl7");

var $cHNI2 = parcelRequire("cHNI2");
var $6e976214a074bd25$export$71797c284d89a3e1 = /*#__PURE__*/ function() {
    var _ref = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee(mediaType, blob) {
        var url;
        return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee$(_context) {
            while(true)switch(_context.prev = _context.next){
                case 0:
                    _context.t0 = mediaType;
                    _context.next = _context.t0 === 'image' ? 3 : _context.t0 === 'video' ? 11 : 12;
                    break;
                case 3:
                    url = URL.createObjectURL(blob);
                    _context.prev = 4;
                    _context.next = 7;
                    return (0, $1iBl7.getImageDimensionsFromBlob)(url);
                case 7:
                    return _context.abrupt("return", _context.sent);
                case 8:
                    _context.prev = 8;
                    URL.revokeObjectURL(url);
                    return _context.finish(8);
                case 11:
                    return _context.abrupt("return", (0, $cHNI2.getVideoDimensionsFromBlob)(blob));
                case 12:
                    throw new Error("Can't extract dimensions from ".concat(mediaType));
                case 13:
                case "end":
                    return _context.stop();
            }
        }, _callee, null, [
            [
                4,
                ,
                8,
                11
            ]
        ]);
    }));
    return function getDimensionsFromBlob(_x, _x2) {
        return _ref.apply(this, arguments);
    };
}();

});
parcelRegister("1iBl7", function(module, exports) {
$parcel$export(module.exports, "getImageDimensionsFromBlob", () => $0f246fc53ea9afb1$export$a1c3205f28a20414);
var $0f246fc53ea9afb1$export$a1c3205f28a20414 = function getImageDimensionsFromBlob(url) {
    return new Promise(function(resolve, reject) {
        var img = new Image();
        img.src = url;
        img.onload = function() {
            return resolve({
                width: img.width,
                height: img.height
            });
        };
        img.onerror = reject;
    });
};

});

parcelRegister("cHNI2", function(module, exports) {
$parcel$export(module.exports, "getVideoDimensionsFromBlob", () => $94000f68456fb92d$export$62aabd5ff85d0451);

var $fL8KA = parcelRequire("fL8KA");

var $6HG4S = parcelRequire("6HG4S");
var $94000f68456fb92d$export$62aabd5ff85d0451 = /*#__PURE__*/ function() {
    var _ref = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee(blob) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee$(_context) {
            while(true)switch(_context.prev = _context.next){
                case 0:
                    return _context.abrupt("return", new Promise(function(resolve, reject) {
                        var url = URL.createObjectURL(blob);
                        var video = document.createElement('video');
                        video.preload = 'metadata';
                        video.src = url;
                        video.muted = true;
                        // loadedmetadata, loadeddata, play, playing
                        video.addEventListener('loadedmetadata', function timeupdateHandler() {
                            video.removeEventListener('loadedmetadata', timeupdateHandler);
                            resolve({
                                width: video.videoWidth,
                                height: video.videoHeight
                            });
                            URL.revokeObjectURL(url);
                        });
                        video.addEventListener('error', function() {
                            reject(new Error('failed to load video'));
                            URL.revokeObjectURL(url);
                        });
                    }));
                case 1:
                case "end":
                    return _context.stop();
            }
        }, _callee);
    }));
    return function getVideoDimensionsFromBlob(_x) {
        return _ref.apply(this, arguments);
    };
}();

});


parcelRegister("bjt5J", function(module, exports) {
$parcel$export(module.exports, "shouldFetchRemoteFileStates", () => $83c808ff666155d2$export$2ccdd6f9a9eba6a);

var $fL8KA = parcelRequire("fL8KA");

var $6HG4S = parcelRequire("6HG4S");

var $keEas = parcelRequire("keEas");
var $aWDq9n = parcelRequire("aWDq9n");

var $cHNI2 = parcelRequire("cHNI2");
function $83c808ff666155d2$export$2ccdd6f9a9eba6a(_x, _x2, _x3) {
    return $83c808ff666155d2$var$_shouldFetchRemoteFileStates.apply(this, arguments);
}
function $83c808ff666155d2$var$_shouldFetchRemoteFileStates() {
    $83c808ff666155d2$var$_shouldFetchRemoteFileStates = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee(mediaType, mimeType, preview) {
        var content, _yield$getVideoDimens, width, height;
        return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee$(_context) {
            while(true)switch(_context.prev = _context.next){
                case 0:
                    if (!((mediaType === 'doc' || !(0, $keEas.isMimeTypeSupportedByBrowser)(mimeType) || !preview) && (0, $aWDq9n.isMimeTypeSupportedByServer)(mimeType))) {
                        _context.next = 2;
                        break;
                    }
                    return _context.abrupt("return", true);
                case 2:
                    if (!(mediaType === 'video' && !!preview)) {
                        _context.next = 20;
                        break;
                    }
                    _context.next = 5;
                    return preview;
                case 5:
                    content = _context.sent.value;
                    if (content instanceof Blob) {
                        _context.next = 8;
                        break;
                    }
                    return _context.abrupt("return", false);
                case 8:
                    _context.prev = 8;
                    _context.next = 11;
                    return (0, $cHNI2.getVideoDimensionsFromBlob)(content);
                case 11:
                    _yield$getVideoDimens = _context.sent;
                    width = _yield$getVideoDimens.width;
                    height = _yield$getVideoDimens.height;
                    return _context.abrupt("return", !width && !height);
                case 17:
                    _context.prev = 17;
                    _context.t0 = _context["catch"](8);
                    return _context.abrupt("return", true);
                case 20:
                    return _context.abrupt("return", false);
                case 21:
                case "end":
                    return _context.stop();
            }
        }, _callee, null, [
            [
                8,
                17
            ]
        ]);
    }));
    return $83c808ff666155d2$var$_shouldFetchRemoteFileStates.apply(this, arguments);
}

});

parcelRegister("1cqUo", function(module, exports) {
$parcel$export(module.exports, "PollingFunction", () => $0dfbc8e47079b6a3$export$4c54d536f8e37dc2);

var $fL8KA = parcelRequire("fL8KA");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $25nEq = parcelRequire("25nEq");

var $6HG4S = parcelRequire("6HG4S");

var $22QgJ = parcelRequire("22QgJ");
function $0dfbc8e47079b6a3$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $0dfbc8e47079b6a3$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $0dfbc8e47079b6a3$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $0dfbc8e47079b6a3$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $0dfbc8e47079b6a3$export$9f15a162d6785fc9 = {
    poll_intervalMs: 3000,
    poll_maxAttempts: 30,
    poll_backoffFactor: 1.25,
    poll_maxIntervalMs: 200000
};
var $0dfbc8e47079b6a3$export$4c54d536f8e37dc2 = /*#__PURE__*/ function() {
    function PollingFunction(options) {
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, PollingFunction);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "poll_intervalMs", 0);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "attempt", 1);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "shouldIterate", true);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "timeoutId", 0);
        this.options = $0dfbc8e47079b6a3$var$_objectSpread($0dfbc8e47079b6a3$var$_objectSpread({}, $0dfbc8e47079b6a3$export$9f15a162d6785fc9), options);
        this.poll_intervalMs = this.options.poll_intervalMs;
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(PollingFunction, [
        {
            key: "execute",
            value: function() {
                var _execute = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee(executor) {
                    var _this = this;
                    var poll_maxAttempts;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee$(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                poll_maxAttempts = this.options.poll_maxAttempts;
                                if (!(poll_maxAttempts === 0)) {
                                    _context.next = 3;
                                    break;
                                }
                                return _context.abrupt("return", this.fail(new (0, $22QgJ.PollingError)('pollingMaxAttemptsExceeded', {
                                    attempts: this.attempt
                                })));
                            case 3:
                                _context.prev = 3;
                                // executor must explicitly call this.next() for triggering next iteration (pull)
                                this.shouldIterate = false;
                                _context.next = 7;
                                return executor();
                            case 7:
                                if (this.shouldIterate) {
                                    _context.next = 9;
                                    break;
                                }
                                return _context.abrupt("return");
                            case 9:
                                if (!(this.attempt >= poll_maxAttempts)) {
                                    _context.next = 11;
                                    break;
                                }
                                return _context.abrupt("return", this.fail(new (0, $22QgJ.PollingError)('pollingMaxAttemptsExceeded', {
                                    attempts: this.attempt
                                })));
                            case 11:
                                this.poll_intervalMs = this.getIntervalMsForIteration(this.attempt);
                                this.attempt++;
                                this.timeoutId = window.setTimeout(function() {
                                    return _this.execute(executor);
                                }, this.poll_intervalMs);
                                _context.next = 19;
                                break;
                            case 16:
                                _context.prev = 16;
                                _context.t0 = _context["catch"](3);
                                this.fail(_context.t0);
                            case 19:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee, this, [
                        [
                            3,
                            16
                        ]
                    ]);
                }));
                function execute(_x) {
                    return _execute.apply(this, arguments);
                }
                return execute;
            }()
        },
        {
            key: "fail",
            value: function fail(error) {
                var onError = this.onError;
                this.cancel();
                onError && onError(error);
            }
        },
        {
            key: "getIntervalMsForIteration",
            value: function getIntervalMsForIteration(iteration) {
                var poll_intervalMs = this.options.poll_intervalMs;
                if (iteration === 1) return poll_intervalMs;
                for(var i = 2; i <= iteration; i++)poll_intervalMs = poll_intervalMs * this.options.poll_backoffFactor;
                return Math.min(Math.round(poll_intervalMs), this.options.poll_maxIntervalMs);
            }
        },
        {
            key: "next",
            value: function next() {
                this.shouldIterate = true;
            }
        },
        {
            key: "cancel",
            value: function cancel() {
                window.clearTimeout(this.timeoutId);
                this.timeoutId = 0;
            }
        }
    ]);
}();

});
parcelRegister("22QgJ", function(module, exports) {
$parcel$export(module.exports, "PollingError", () => $17d45028f3db0614$export$c3748c310e92340a);

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $kIXpt = parcelRequire("kIXpt");

var $cYPzS = parcelRequire("cYPzS");

var $eyuDe = parcelRequire("eyuDe");

var $8eaz3 = parcelRequire("8eaz3");
function $17d45028f3db0614$var$_callSuper(t, o, e) {
    return o = (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(o), (0, (/*@__PURE__*/$parcel$interopDefault($kIXpt)))(t, $17d45028f3db0614$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(t).constructor) : o.apply(t, e));
}
function $17d45028f3db0614$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($17d45028f3db0614$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $17d45028f3db0614$export$c3748c310e92340a = /*#__PURE__*/ function(_BaseMediaClientError) {
    function PollingError(reason, metadata) {
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, PollingError);
        return $17d45028f3db0614$var$_callSuper(this, PollingError, [
            reason,
            metadata,
            undefined
        ]);
    }
    // TODO: Deprecate this getter https://product-fabric.atlassian.net/browse/CXP-4665
    /** Will be deprecated. Use the properties `reason` and `metadata` instead */ (0, (/*@__PURE__*/$parcel$interopDefault($eyuDe)))(PollingError, _BaseMediaClientError);
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(PollingError, [
        {
            key: "attributes",
            get: function get() {
                var reason = this.reason, attempts = this.metadata.attempts;
                return {
                    reason: reason,
                    attempts: attempts
                };
            }
        }
    ]);
}((0, $8eaz3.BaseMediaClientError));
function $17d45028f3db0614$export$541e3e52eea6fece(err) {
    return err instanceof $17d45028f3db0614$export$c3748c310e92340a;
}

});


parcelRegister("e7FZ3", function(module, exports) {
$parcel$export(module.exports, "isEmptyFile", () => $a4824938c3d59b26$export$728192ce8dd94659);
/**
 * EMPTY_FILE_HOURS_ELAPSED_TOLERANCE - how many hours since this file was
 * created until we give up on expecting metadata?
 *
 * Yes, this is not an exact science. Any value under this tolerance will
 * go undetected, however this is still suitable to catch the majority of
 * cases where empty (files which never finished upload) are being reloaded.
 *
 * Continuous bad renders of empty files will eat our card render SLIs, so until
 * there is a better response from backend we use this technique.
 *
 * Being encapsulated in this function, we can always improve the detection transparently.
 */ var $a4824938c3d59b26$export$d32fc52697b2ec92 = 43200000; /* 12 hours */ 
function $a4824938c3d59b26$export$728192ce8dd94659(fileDetails) {
    var now = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Date.now();
    var artifacts = fileDetails.artifacts, mediaType = fileDetails.mediaType, mimeType = fileDetails.mimeType, name = fileDetails.name, processingStatus = fileDetails.processingStatus, representations = fileDetails.representations, size = fileDetails.size, createdAt = fileDetails.createdAt;
    if (!artifacts && !mediaType && !mimeType && !name && !processingStatus && !representations && !size && typeof createdAt === 'number') {
        var msSinceFileCreation = now - createdAt;
        if (msSinceFileCreation > $a4824938c3d59b26$export$d32fc52697b2ec92) return true;
    }
    return false;
}

});

parcelRegister("b6O22", function(module, exports) {
$parcel$export(module.exports, "mediaStore", () => (parcelRequire("bhF0L")).mediaStore);

var $bhF0L = parcelRequire("bhF0L");

});
parcelRegister("bhF0L", function(module, exports) {
$parcel$export(module.exports, "mediaStore", () => $837118415b8f771e$export$5785580dea19518d);

var $25nEq = parcelRequire("25nEq");

var $bwahW = parcelRequire("bwahW");

var $iODEY = parcelRequire("iODEY");

var $hzmic = parcelRequire("hzmic");
function $837118415b8f771e$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $837118415b8f771e$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $837118415b8f771e$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $837118415b8f771e$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $837118415b8f771e$var$mediaStoreWithoutDevtools = (0, $hzmic.createStore)()((0, $bwahW.subscribeWithSelector)((0, $iODEY.immer)(function() {
    return {
        files: {}
    };
})));
var $837118415b8f771e$var$mediaStoreWithDevtools = (0, $hzmic.createStore)()((0, $bwahW.devtools)((0, $bwahW.subscribeWithSelector)((0, $iODEY.immer)(function() {
    return {
        files: {}
    };
}))));
var $837118415b8f771e$export$5785580dea19518d = $837118415b8f771e$var$mediaStoreWithoutDevtools;
var $837118415b8f771e$export$503459913a0dc356 = function createMediaStore(initialStore) {
    return (0, $hzmic.createStore)()((0, $bwahW.subscribeWithSelector)((0, $iODEY.immer)(function() {
        return $837118415b8f771e$var$_objectSpread({
            files: {}
        }, initialStore);
    })));
};

});
parcelRegister("bwahW", function(module, exports) {
$parcel$export(module.exports, "devtools", () => $862aa9eeacf6588d$export$6922d3b3a607469e, (v) => $862aa9eeacf6588d$export$6922d3b3a607469e = v);
$parcel$export(module.exports, "subscribeWithSelector", () => $862aa9eeacf6588d$export$5c593627aef9f076, (v) => $862aa9eeacf6588d$export$5c593627aef9f076 = v);
var $862aa9eeacf6588d$export$1be1fc439b849fdf;
var $862aa9eeacf6588d$export$95a3b7b12ab518f9;
var $862aa9eeacf6588d$export$6922d3b3a607469e;
var $862aa9eeacf6588d$export$9a6132153fba2e0;
var $862aa9eeacf6588d$export$4feba8a1bc8e9afd;
var $862aa9eeacf6588d$export$5c593627aef9f076;
'use strict';
function $862aa9eeacf6588d$var$_extends() {
    return $862aa9eeacf6588d$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $862aa9eeacf6588d$var$_extends.apply(null, arguments);
}
function $862aa9eeacf6588d$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.includes(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var $862aa9eeacf6588d$var$reduxImpl = function reduxImpl(reducer, initial) {
    return function(set, _get, api) {
        api.dispatch = function(action) {
            set(function(state) {
                return reducer(state, action);
            }, false, action);
            return action;
        };
        api.dispatchFromDevtools = true;
        return $862aa9eeacf6588d$var$_extends({
            dispatch: function dispatch() {
                var _ref;
                return (_ref = api).dispatch.apply(_ref, arguments);
            }
        }, initial);
    };
};
var $862aa9eeacf6588d$var$redux = $862aa9eeacf6588d$var$reduxImpl;
var $862aa9eeacf6588d$var$_excluded = [
    "enabled",
    "anonymousActionType",
    "store"
], $862aa9eeacf6588d$var$_excluded2 = [
    "connection"
];
var $862aa9eeacf6588d$var$trackedConnections = new Map();
var $862aa9eeacf6588d$var$getTrackedConnectionState = function getTrackedConnectionState(name) {
    var api = $862aa9eeacf6588d$var$trackedConnections.get(name);
    if (!api) return {};
    return Object.fromEntries(Object.entries(api.stores).map(function(_ref) {
        var key = _ref[0], api = _ref[1];
        return [
            key,
            api.getState()
        ];
    }));
};
var $862aa9eeacf6588d$var$extractConnectionInformation = function extractConnectionInformation(store, extensionConnector, options) {
    if (store === undefined) return {
        type: 'untracked',
        connection: extensionConnector.connect(options)
    };
    var existingConnection = $862aa9eeacf6588d$var$trackedConnections.get(options.name);
    if (existingConnection) return $862aa9eeacf6588d$var$_extends({
        type: 'tracked',
        store: store
    }, existingConnection);
    var newConnection = {
        connection: extensionConnector.connect(options),
        stores: {}
    };
    $862aa9eeacf6588d$var$trackedConnections.set(options.name, newConnection);
    return $862aa9eeacf6588d$var$_extends({
        type: 'tracked',
        store: store
    }, newConnection);
};
var $862aa9eeacf6588d$var$devtoolsImpl = function devtoolsImpl(fn, devtoolsOptions) {
    if (devtoolsOptions === void 0) devtoolsOptions = {};
    return function(set, get, api) {
        var _devtoolsOptions = devtoolsOptions, enabled = _devtoolsOptions.enabled, anonymousActionType = _devtoolsOptions.anonymousActionType, store = _devtoolsOptions.store, options = $862aa9eeacf6588d$var$_objectWithoutPropertiesLoose(_devtoolsOptions, $862aa9eeacf6588d$var$_excluded);
        var extensionConnector;
        try {
            extensionConnector = (enabled != null ? enabled : false) && window.__REDUX_DEVTOOLS_EXTENSION__;
        } catch (_e) {}
        if (!extensionConnector) return fn(set, get, api);
        var _extractConnectionInf = $862aa9eeacf6588d$var$extractConnectionInformation(store, extensionConnector, options), connection = _extractConnectionInf.connection, connectionInformation = $862aa9eeacf6588d$var$_objectWithoutPropertiesLoose(_extractConnectionInf, $862aa9eeacf6588d$var$_excluded2);
        var isRecording = true;
        api.setState = function(state, replace, nameOrAction) {
            var _extends2;
            var r = set(state, replace);
            if (!isRecording) return r;
            var action = nameOrAction === undefined ? {
                type: anonymousActionType || 'anonymous'
            } : typeof nameOrAction === 'string' ? {
                type: nameOrAction
            } : nameOrAction;
            if (store === undefined) {
                connection == null || connection.send(action, get());
                return r;
            }
            connection == null || connection.send($862aa9eeacf6588d$var$_extends({}, action, {
                type: store + "/" + action.type
            }), $862aa9eeacf6588d$var$_extends({}, $862aa9eeacf6588d$var$getTrackedConnectionState(options.name), (_extends2 = {}, _extends2[store] = api.getState(), _extends2)));
            return r;
        };
        var setStateFromDevtools = function setStateFromDevtools() {
            var originalIsRecording = isRecording;
            isRecording = false;
            set.apply(void 0, arguments);
            isRecording = originalIsRecording;
        };
        var initialState = fn(api.setState, get, api);
        if (connectionInformation.type === 'untracked') connection == null || connection.init(initialState);
        else {
            connectionInformation.stores[connectionInformation.store] = api;
            connection == null || connection.init(Object.fromEntries(Object.entries(connectionInformation.stores).map(function(_ref2) {
                var key = _ref2[0], store = _ref2[1];
                return [
                    key,
                    key === connectionInformation.store ? initialState : store.getState()
                ];
            })));
        }
        if (api.dispatchFromDevtools && typeof api.dispatch === 'function') {
            var didWarnAboutReservedActionType = false;
            var originalDispatch = api.dispatch;
            api.dispatch = function() {
                for(var _len = arguments.length, a = new Array(_len), _key = 0; _key < _len; _key++)a[_key] = arguments[_key];
                originalDispatch.apply(void 0, a);
            };
        }
        connection.subscribe(function(message) {
            switch(message.type){
                case 'ACTION':
                    if (typeof message.payload !== 'string') {
                        console.error('[zustand devtools middleware] Unsupported action format');
                        return;
                    }
                    return $862aa9eeacf6588d$var$parseJsonThen(message.payload, function(action) {
                        if (action.type === '__setState') {
                            if (store === undefined) {
                                setStateFromDevtools(action.state);
                                return;
                            }
                            if (Object.keys(action.state).length !== 1) console.error("\n                    [zustand devtools middleware] Unsupported __setState action format. \n                    When using 'store' option in devtools(), the 'state' should have only one key, which is a value of 'store' that was passed in devtools(),\n                    and value of this only key should be a state object. Example: { \"type\": \"__setState\", \"state\": { \"abc123Store\": { \"foo\": \"bar\" } } }\n                    ");
                            var stateFromDevtools = action.state[store];
                            if (stateFromDevtools === undefined || stateFromDevtools === null) return;
                            if (JSON.stringify(api.getState()) !== JSON.stringify(stateFromDevtools)) setStateFromDevtools(stateFromDevtools);
                            return;
                        }
                        if (!api.dispatchFromDevtools) return;
                        if (typeof api.dispatch !== 'function') return;
                        api.dispatch(action);
                    });
                case 'DISPATCH':
                    switch(message.payload.type){
                        case 'RESET':
                            setStateFromDevtools(initialState);
                            if (store === undefined) return connection == null ? void 0 : connection.init(api.getState());
                            return connection == null ? void 0 : connection.init($862aa9eeacf6588d$var$getTrackedConnectionState(options.name));
                        case 'COMMIT':
                            if (store === undefined) {
                                connection == null || connection.init(api.getState());
                                return;
                            }
                            return connection == null ? void 0 : connection.init($862aa9eeacf6588d$var$getTrackedConnectionState(options.name));
                        case 'ROLLBACK':
                            return $862aa9eeacf6588d$var$parseJsonThen(message.state, function(state) {
                                if (store === undefined) {
                                    setStateFromDevtools(state);
                                    connection == null || connection.init(api.getState());
                                    return;
                                }
                                setStateFromDevtools(state[store]);
                                connection == null || connection.init($862aa9eeacf6588d$var$getTrackedConnectionState(options.name));
                            });
                        case 'JUMP_TO_STATE':
                        case 'JUMP_TO_ACTION':
                            return $862aa9eeacf6588d$var$parseJsonThen(message.state, function(state) {
                                if (store === undefined) {
                                    setStateFromDevtools(state);
                                    return;
                                }
                                if (JSON.stringify(api.getState()) !== JSON.stringify(state[store])) setStateFromDevtools(state[store]);
                            });
                        case 'IMPORT_STATE':
                            var _nextLiftedState$comp;
                            var nextLiftedState = message.payload.nextLiftedState;
                            var lastComputedState = (_nextLiftedState$comp = nextLiftedState.computedStates.slice(-1)[0]) == null ? void 0 : _nextLiftedState$comp.state;
                            if (!lastComputedState) return;
                            if (store === undefined) setStateFromDevtools(lastComputedState);
                            else setStateFromDevtools(lastComputedState[store]);
                            connection == null || connection.send(null, nextLiftedState);
                            return;
                        case 'PAUSE_RECORDING':
                            return isRecording = !isRecording;
                    }
                    return;
            }
        });
        return initialState;
    };
};
var $862aa9eeacf6588d$var$devtools = $862aa9eeacf6588d$var$devtoolsImpl;
var $862aa9eeacf6588d$var$parseJsonThen = function parseJsonThen(stringified, f) {
    var parsed;
    try {
        parsed = JSON.parse(stringified);
    } catch (e) {
        console.error('[zustand devtools middleware] Could not parse the received json', e);
    }
    if (parsed !== undefined) f(parsed);
};
var $862aa9eeacf6588d$var$subscribeWithSelectorImpl = function subscribeWithSelectorImpl(fn) {
    return function(set, get, api) {
        var origSubscribe = api.subscribe;
        api.subscribe = function(selector, optListener, options) {
            var listener = selector;
            if (optListener) {
                var equalityFn = (options == null ? void 0 : options.equalityFn) || Object.is;
                var currentSlice = selector(api.getState());
                listener = function listener(state) {
                    var nextSlice = selector(state);
                    if (!equalityFn(currentSlice, nextSlice)) {
                        var previousSlice = currentSlice;
                        optListener(currentSlice = nextSlice, previousSlice);
                    }
                };
                if (options != null && options.fireImmediately) optListener(currentSlice, currentSlice);
            }
            return origSubscribe(listener);
        };
        var initialState = fn(set, get, api);
        return initialState;
    };
};
var $862aa9eeacf6588d$var$subscribeWithSelector = $862aa9eeacf6588d$var$subscribeWithSelectorImpl;
var $862aa9eeacf6588d$var$combine = function combine(initialState, create) {
    return function() {
        return Object.assign({}, initialState, create.apply(void 0, arguments));
    };
};
function $862aa9eeacf6588d$var$createJSONStorage(getStorage, options) {
    var storage;
    try {
        storage = getStorage();
    } catch (_e) {
        return;
    }
    var persistStorage = {
        getItem: function getItem(name) {
            var _getItem;
            var parse = function parse(str) {
                if (str === null) return null;
                return JSON.parse(str, options == null ? void 0 : options.reviver);
            };
            var str = (_getItem = storage.getItem(name)) != null ? _getItem : null;
            if (str instanceof Promise) return str.then(parse);
            return parse(str);
        },
        setItem: function setItem(name, newValue) {
            return storage.setItem(name, JSON.stringify(newValue, options == null ? void 0 : options.replacer));
        },
        removeItem: function removeItem(name) {
            return storage.removeItem(name);
        }
    };
    return persistStorage;
}
var $862aa9eeacf6588d$var$_toThenable = function toThenable(fn) {
    return function(input) {
        try {
            var result = fn(input);
            if (result instanceof Promise) return result;
            return {
                then: function then(onFulfilled) {
                    return $862aa9eeacf6588d$var$_toThenable(onFulfilled)(result);
                },
                catch: function _catch(_onRejected) {
                    return this;
                }
            };
        } catch (e) {
            return {
                then: function then(_onFulfilled) {
                    return this;
                },
                catch: function _catch(onRejected) {
                    return $862aa9eeacf6588d$var$_toThenable(onRejected)(e);
                }
            };
        }
    };
};
var $862aa9eeacf6588d$var$oldImpl = function oldImpl(config, baseOptions) {
    return function(set, get, api) {
        var options = $862aa9eeacf6588d$var$_extends({
            getStorage: function getStorage() {
                return localStorage;
            },
            serialize: JSON.stringify,
            deserialize: JSON.parse,
            partialize: function partialize(state) {
                return state;
            },
            version: 0,
            merge: function merge(persistedState, currentState) {
                return $862aa9eeacf6588d$var$_extends({}, currentState, persistedState);
            }
        }, baseOptions);
        var _hasHydrated = false;
        var hydrationListeners = new Set();
        var finishHydrationListeners = new Set();
        var storage;
        try {
            storage = options.getStorage();
        } catch (_e) {}
        if (!storage) return config(function() {
            console.warn("[zustand persist middleware] Unable to update item '" + options.name + "', the given storage is currently unavailable.");
            set.apply(void 0, arguments);
        }, get, api);
        var thenableSerialize = $862aa9eeacf6588d$var$_toThenable(options.serialize);
        var setItem = function setItem() {
            var state = options.partialize($862aa9eeacf6588d$var$_extends({}, get()));
            var errorInSync;
            var thenable = thenableSerialize({
                state: state,
                version: options.version
            }).then(function(serializedValue) {
                return storage.setItem(options.name, serializedValue);
            }).catch(function(e) {
                errorInSync = e;
            });
            if (errorInSync) throw errorInSync;
            return thenable;
        };
        var savedSetState = api.setState;
        api.setState = function(state, replace) {
            savedSetState(state, replace);
            setItem();
        };
        var configResult = config(function() {
            set.apply(void 0, arguments);
            setItem();
        }, get, api);
        var stateFromStorage;
        var hydrate = function hydrate() {
            if (!storage) return;
            _hasHydrated = false;
            hydrationListeners.forEach(function(cb) {
                return cb(get());
            });
            var postRehydrationCallback = (options.onRehydrateStorage == null ? void 0 : options.onRehydrateStorage(get())) || undefined;
            return $862aa9eeacf6588d$var$_toThenable(storage.getItem.bind(storage))(options.name).then(function(storageValue) {
                if (storageValue) return options.deserialize(storageValue);
            }).then(function(deserializedStorageValue) {
                if (deserializedStorageValue) {
                    if (typeof deserializedStorageValue.version === 'number' && deserializedStorageValue.version !== options.version) {
                        if (options.migrate) return options.migrate(deserializedStorageValue.state, deserializedStorageValue.version);
                        console.error("State loaded from storage couldn't be migrated since no migrate function was provided");
                    } else return deserializedStorageValue.state;
                }
            }).then(function(migratedState) {
                var _get;
                stateFromStorage = options.merge(migratedState, (_get = get()) != null ? _get : configResult);
                set(stateFromStorage, true);
                return setItem();
            }).then(function() {
                postRehydrationCallback == null || postRehydrationCallback(stateFromStorage, undefined);
                _hasHydrated = true;
                finishHydrationListeners.forEach(function(cb) {
                    return cb(stateFromStorage);
                });
            }).catch(function(e) {
                postRehydrationCallback == null || postRehydrationCallback(undefined, e);
            });
        };
        api.persist = {
            setOptions: function setOptions(newOptions) {
                options = $862aa9eeacf6588d$var$_extends({}, options, newOptions);
                if (newOptions.getStorage) storage = newOptions.getStorage();
            },
            clearStorage: function clearStorage() {
                var _storage;
                (_storage = storage) == null || _storage.removeItem(options.name);
            },
            getOptions: function getOptions() {
                return options;
            },
            rehydrate: function rehydrate() {
                return hydrate();
            },
            hasHydrated: function hasHydrated() {
                return _hasHydrated;
            },
            onHydrate: function onHydrate(cb) {
                hydrationListeners.add(cb);
                return function() {
                    hydrationListeners.delete(cb);
                };
            },
            onFinishHydration: function onFinishHydration(cb) {
                finishHydrationListeners.add(cb);
                return function() {
                    finishHydrationListeners.delete(cb);
                };
            }
        };
        hydrate();
        return stateFromStorage || configResult;
    };
};
var $862aa9eeacf6588d$var$newImpl = function newImpl(config, baseOptions) {
    return function(set, get, api) {
        var options = $862aa9eeacf6588d$var$_extends({
            storage: $862aa9eeacf6588d$var$createJSONStorage(function() {
                return localStorage;
            }),
            partialize: function partialize(state) {
                return state;
            },
            version: 0,
            merge: function merge(persistedState, currentState) {
                return $862aa9eeacf6588d$var$_extends({}, currentState, persistedState);
            }
        }, baseOptions);
        var _hasHydrated2 = false;
        var hydrationListeners = new Set();
        var finishHydrationListeners = new Set();
        var storage = options.storage;
        if (!storage) return config(function() {
            console.warn("[zustand persist middleware] Unable to update item '" + options.name + "', the given storage is currently unavailable.");
            set.apply(void 0, arguments);
        }, get, api);
        var setItem = function setItem() {
            var state = options.partialize($862aa9eeacf6588d$var$_extends({}, get()));
            return storage.setItem(options.name, {
                state: state,
                version: options.version
            });
        };
        var savedSetState = api.setState;
        api.setState = function(state, replace) {
            savedSetState(state, replace);
            setItem();
        };
        var configResult = config(function() {
            set.apply(void 0, arguments);
            setItem();
        }, get, api);
        api.getInitialState = function() {
            return configResult;
        };
        var stateFromStorage;
        var hydrate = function hydrate() {
            var _get3;
            if (!storage) return;
            _hasHydrated2 = false;
            hydrationListeners.forEach(function(cb) {
                var _get2;
                return cb((_get2 = get()) != null ? _get2 : configResult);
            });
            var postRehydrationCallback = (options.onRehydrateStorage == null ? void 0 : options.onRehydrateStorage((_get3 = get()) != null ? _get3 : configResult)) || undefined;
            return $862aa9eeacf6588d$var$_toThenable(storage.getItem.bind(storage))(options.name).then(function(deserializedStorageValue) {
                if (deserializedStorageValue) {
                    if (typeof deserializedStorageValue.version === 'number' && deserializedStorageValue.version !== options.version) {
                        if (options.migrate) return [
                            true,
                            options.migrate(deserializedStorageValue.state, deserializedStorageValue.version)
                        ];
                        console.error("State loaded from storage couldn't be migrated since no migrate function was provided");
                    } else return [
                        false,
                        deserializedStorageValue.state
                    ];
                }
                return [
                    false,
                    undefined
                ];
            }).then(function(migrationResult) {
                var _get4;
                var migrated = migrationResult[0], migratedState = migrationResult[1];
                stateFromStorage = options.merge(migratedState, (_get4 = get()) != null ? _get4 : configResult);
                set(stateFromStorage, true);
                if (migrated) return setItem();
            }).then(function() {
                postRehydrationCallback == null || postRehydrationCallback(stateFromStorage, undefined);
                stateFromStorage = get();
                _hasHydrated2 = true;
                finishHydrationListeners.forEach(function(cb) {
                    return cb(stateFromStorage);
                });
            }).catch(function(e) {
                postRehydrationCallback == null || postRehydrationCallback(undefined, e);
            });
        };
        api.persist = {
            setOptions: function setOptions(newOptions) {
                options = $862aa9eeacf6588d$var$_extends({}, options, newOptions);
                if (newOptions.storage) storage = newOptions.storage;
            },
            clearStorage: function clearStorage() {
                var _storage2;
                (_storage2 = storage) == null || _storage2.removeItem(options.name);
            },
            getOptions: function getOptions() {
                return options;
            },
            rehydrate: function rehydrate() {
                return hydrate();
            },
            hasHydrated: function hasHydrated() {
                return _hasHydrated2;
            },
            onHydrate: function onHydrate(cb) {
                hydrationListeners.add(cb);
                return function() {
                    hydrationListeners.delete(cb);
                };
            },
            onFinishHydration: function onFinishHydration(cb) {
                finishHydrationListeners.add(cb);
                return function() {
                    finishHydrationListeners.delete(cb);
                };
            }
        };
        if (!options.skipHydration) hydrate();
        return stateFromStorage || configResult;
    };
};
var $862aa9eeacf6588d$var$persistImpl = function persistImpl(config, baseOptions) {
    if ('getStorage' in baseOptions || 'serialize' in baseOptions || 'deserialize' in baseOptions) return $862aa9eeacf6588d$var$oldImpl(config, baseOptions);
    return $862aa9eeacf6588d$var$newImpl(config, baseOptions);
};
var $862aa9eeacf6588d$var$persist = $862aa9eeacf6588d$var$persistImpl;
$862aa9eeacf6588d$export$1be1fc439b849fdf = $862aa9eeacf6588d$var$combine;
$862aa9eeacf6588d$export$95a3b7b12ab518f9 = $862aa9eeacf6588d$var$createJSONStorage;
$862aa9eeacf6588d$export$6922d3b3a607469e = $862aa9eeacf6588d$var$devtools;
$862aa9eeacf6588d$export$9a6132153fba2e0 = $862aa9eeacf6588d$var$persist;
$862aa9eeacf6588d$export$4feba8a1bc8e9afd = $862aa9eeacf6588d$var$redux;
$862aa9eeacf6588d$export$5c593627aef9f076 = $862aa9eeacf6588d$var$subscribeWithSelector;

});

parcelRegister("iODEY", function(module, exports) {
$parcel$export(module.exports, "immer", () => $db2ba92673f2acbb$export$428de7ec69ac95c, (v) => $db2ba92673f2acbb$export$428de7ec69ac95c = v);
var $db2ba92673f2acbb$export$428de7ec69ac95c;
'use strict';

var $cEJXU = parcelRequire("cEJXU");
var $db2ba92673f2acbb$var$immerImpl = function immerImpl(initializer) {
    return function(set, get, store) {
        store.setState = function(updater, replace) {
            var nextState = typeof updater === 'function' ? $cEJXU.produce(updater) : updater;
            for(var _len = arguments.length, a = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)a[_key - 2] = arguments[_key];
            return set.apply(void 0, [
                nextState,
                replace
            ].concat(a));
        };
        return initializer(store.setState, get, store);
    };
};
var $db2ba92673f2acbb$var$immer = $db2ba92673f2acbb$var$immerImpl;
$db2ba92673f2acbb$export$428de7ec69ac95c = $db2ba92673f2acbb$var$immer;

});
parcelRegister("cEJXU", function(module, exports) {
$parcel$export(module.exports, "produce", () => $936ce038e559daa3$export$b46cabe22e78bc00);
var $936ce038e559daa3$var$__defProp = Object.defineProperty;
var $936ce038e559daa3$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $936ce038e559daa3$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $936ce038e559daa3$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $936ce038e559daa3$var$__defNormalProp = (obj, key, value)=>key in obj ? $936ce038e559daa3$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $936ce038e559daa3$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($936ce038e559daa3$var$__hasOwnProp.call(b, prop)) $936ce038e559daa3$var$__defNormalProp(a, prop, b[prop]);
    if ($936ce038e559daa3$var$__getOwnPropSymbols) {
        for (var prop of $936ce038e559daa3$var$__getOwnPropSymbols(b))if ($936ce038e559daa3$var$__propIsEnum.call(b, prop)) $936ce038e559daa3$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
// src/utils/env.ts
var $936ce038e559daa3$export$45b790e32b2810ee = Symbol.for("immer-nothing");
var $936ce038e559daa3$export$6ee2082928bcb0ee = Symbol.for("immer-draftable");
var $936ce038e559daa3$var$DRAFT_STATE = Symbol.for("immer-state");
// src/utils/errors.ts
var $936ce038e559daa3$var$errors = [];
function $936ce038e559daa3$var$die(error, ...args) {
    throw new Error(`[Immer] minified error nr: ${error}. Full error at: https://bit.ly/3cXEKWf`);
}
// src/utils/common.ts
var $936ce038e559daa3$var$O = Object;
var $936ce038e559daa3$var$getPrototypeOf = $936ce038e559daa3$var$O.getPrototypeOf;
var $936ce038e559daa3$var$CONSTRUCTOR = "constructor";
var $936ce038e559daa3$var$PROTOTYPE = "prototype";
var $936ce038e559daa3$var$CONFIGURABLE = "configurable";
var $936ce038e559daa3$var$ENUMERABLE = "enumerable";
var $936ce038e559daa3$var$WRITABLE = "writable";
var $936ce038e559daa3$var$VALUE = "value";
var $936ce038e559daa3$export$541ac630993a4c84 = (value)=>!!value && !!value[$936ce038e559daa3$var$DRAFT_STATE];
function $936ce038e559daa3$export$16e3aed3edb85946(value) {
    var _a;
    if (!value) return false;
    return $936ce038e559daa3$var$isPlainObject(value) || $936ce038e559daa3$var$isArray(value) || !!value[$936ce038e559daa3$export$6ee2082928bcb0ee] || !!((_a = value[$936ce038e559daa3$var$CONSTRUCTOR]) == null ? void 0 : _a[$936ce038e559daa3$export$6ee2082928bcb0ee]) || $936ce038e559daa3$var$isMap(value) || $936ce038e559daa3$var$isSet(value);
}
var $936ce038e559daa3$var$objectCtorString = $936ce038e559daa3$var$O[$936ce038e559daa3$var$PROTOTYPE][$936ce038e559daa3$var$CONSTRUCTOR].toString();
var $936ce038e559daa3$var$cachedCtorStrings = /* @__PURE__ */ new WeakMap();
function $936ce038e559daa3$var$isPlainObject(value) {
    if (!value || !$936ce038e559daa3$var$isObjectish(value)) return false;
    const proto = $936ce038e559daa3$var$getPrototypeOf(value);
    if (proto === null || proto === $936ce038e559daa3$var$O[$936ce038e559daa3$var$PROTOTYPE]) return true;
    const Ctor = $936ce038e559daa3$var$O.hasOwnProperty.call(proto, $936ce038e559daa3$var$CONSTRUCTOR) && proto[$936ce038e559daa3$var$CONSTRUCTOR];
    if (Ctor === Object) return true;
    if (!$936ce038e559daa3$var$isFunction(Ctor)) return false;
    let ctorString = $936ce038e559daa3$var$cachedCtorStrings.get(Ctor);
    if (ctorString === void 0) {
        ctorString = Function.toString.call(Ctor);
        $936ce038e559daa3$var$cachedCtorStrings.set(Ctor, ctorString);
    }
    return ctorString === $936ce038e559daa3$var$objectCtorString;
}
function $936ce038e559daa3$export$22e8af3f75a010e3(value) {
    if (!$936ce038e559daa3$export$541ac630993a4c84(value)) $936ce038e559daa3$var$die(15, value);
    return value[$936ce038e559daa3$var$DRAFT_STATE].base_;
}
function $936ce038e559daa3$var$each(obj, iter, strict = true) {
    if ($936ce038e559daa3$var$getArchtype(obj) === 0 /* Object */ ) {
        const keys = strict ? Reflect.ownKeys(obj) : $936ce038e559daa3$var$O.keys(obj);
        keys.forEach((key)=>{
            iter(key, obj[key], obj);
        });
    } else obj.forEach((entry, index)=>iter(index, entry, obj));
}
function $936ce038e559daa3$var$getArchtype(thing) {
    const state = thing[$936ce038e559daa3$var$DRAFT_STATE];
    return state ? state.type_ : $936ce038e559daa3$var$isArray(thing) ? 1 /* Array */  : $936ce038e559daa3$var$isMap(thing) ? 2 /* Map */  : $936ce038e559daa3$var$isSet(thing) ? 3 /* Set */  : 0 /* Object */ ;
}
var $936ce038e559daa3$var$has = (thing, prop, type = $936ce038e559daa3$var$getArchtype(thing))=>type === 2 /* Map */  ? thing.has(prop) : $936ce038e559daa3$var$O[$936ce038e559daa3$var$PROTOTYPE].hasOwnProperty.call(thing, prop);
var $936ce038e559daa3$var$get = (thing, prop, type = $936ce038e559daa3$var$getArchtype(thing))=>// @ts-ignore
    type === 2 /* Map */  ? thing.get(prop) : thing[prop];
var $936ce038e559daa3$var$set = (thing, propOrOldValue, value, type = $936ce038e559daa3$var$getArchtype(thing))=>{
    if (type === 2 /* Map */ ) thing.set(propOrOldValue, value);
    else if (type === 3 /* Set */ ) thing.add(value);
    else thing[propOrOldValue] = value;
};
function $936ce038e559daa3$var$is(x, y) {
    if (x === y) return x !== 0 || 1 / x === 1 / y;
    else return x !== x && y !== y;
}
var $936ce038e559daa3$var$isArray = Array.isArray;
var $936ce038e559daa3$var$isMap = (target)=>target instanceof Map;
var $936ce038e559daa3$var$isSet = (target)=>target instanceof Set;
var $936ce038e559daa3$var$isObjectish = (target)=>typeof target === "object";
var $936ce038e559daa3$var$isFunction = (target)=>typeof target === "function";
var $936ce038e559daa3$var$isBoolean = (target)=>typeof target === "boolean";
function $936ce038e559daa3$var$isArrayIndex(value) {
    const n = +value;
    return Number.isInteger(n) && String(n) === value;
}
var $936ce038e559daa3$var$getProxyDraft = (value)=>{
    if (!$936ce038e559daa3$var$isObjectish(value)) return null;
    return value == null ? void 0 : value[$936ce038e559daa3$var$DRAFT_STATE];
};
var $936ce038e559daa3$var$latest = (state)=>state.copy_ || state.base_;
var $936ce038e559daa3$var$getValue = (value)=>{
    var _a;
    const proxyDraft = $936ce038e559daa3$var$getProxyDraft(value);
    return proxyDraft ? (_a = proxyDraft.copy_) != null ? _a : proxyDraft.base_ : value;
};
var $936ce038e559daa3$var$getFinalValue = (state)=>state.modified_ ? state.copy_ : state.base_;
function $936ce038e559daa3$var$shallowCopy(base, strict) {
    if ($936ce038e559daa3$var$isMap(base)) return new Map(base);
    if ($936ce038e559daa3$var$isSet(base)) return new Set(base);
    if ($936ce038e559daa3$var$isArray(base)) return Array[$936ce038e559daa3$var$PROTOTYPE].slice.call(base);
    const isPlain = $936ce038e559daa3$var$isPlainObject(base);
    if (strict === true || strict === "class_only" && !isPlain) {
        const descriptors = $936ce038e559daa3$var$O.getOwnPropertyDescriptors(base);
        delete descriptors[$936ce038e559daa3$var$DRAFT_STATE];
        let keys = Reflect.ownKeys(descriptors);
        for(let i = 0; i < keys.length; i++){
            const key = keys[i];
            const desc = descriptors[key];
            if (desc[$936ce038e559daa3$var$WRITABLE] === false) {
                desc[$936ce038e559daa3$var$WRITABLE] = true;
                desc[$936ce038e559daa3$var$CONFIGURABLE] = true;
            }
            if (desc.get || desc.set) descriptors[key] = {
                [$936ce038e559daa3$var$CONFIGURABLE]: true,
                [$936ce038e559daa3$var$WRITABLE]: true,
                // could live with !!desc.set as well here...
                [$936ce038e559daa3$var$ENUMERABLE]: desc[$936ce038e559daa3$var$ENUMERABLE],
                [$936ce038e559daa3$var$VALUE]: base[key]
            };
        }
        return $936ce038e559daa3$var$O.create($936ce038e559daa3$var$getPrototypeOf(base), descriptors);
    } else {
        const proto = $936ce038e559daa3$var$getPrototypeOf(base);
        if (proto !== null && isPlain) return $936ce038e559daa3$var$__spreadValues({}, base);
        const obj = $936ce038e559daa3$var$O.create(proto);
        return $936ce038e559daa3$var$O.assign(obj, base);
    }
}
function $936ce038e559daa3$export$792f3d81ea979f55(obj, deep = false) {
    if ($936ce038e559daa3$var$isFrozen(obj) || $936ce038e559daa3$export$541ac630993a4c84(obj) || !$936ce038e559daa3$export$16e3aed3edb85946(obj)) return obj;
    if ($936ce038e559daa3$var$getArchtype(obj) > 1) $936ce038e559daa3$var$O.defineProperties(obj, {
        set: $936ce038e559daa3$var$dontMutateMethodOverride,
        add: $936ce038e559daa3$var$dontMutateMethodOverride,
        clear: $936ce038e559daa3$var$dontMutateMethodOverride,
        delete: $936ce038e559daa3$var$dontMutateMethodOverride
    });
    $936ce038e559daa3$var$O.freeze(obj);
    if (deep) $936ce038e559daa3$var$each(obj, (_key, value)=>{
        $936ce038e559daa3$export$792f3d81ea979f55(value, true);
    }, false);
    return obj;
}
function $936ce038e559daa3$var$dontMutateFrozenCollections() {
    $936ce038e559daa3$var$die(2);
}
var $936ce038e559daa3$var$dontMutateMethodOverride = {
    [$936ce038e559daa3$var$VALUE]: $936ce038e559daa3$var$dontMutateFrozenCollections
};
function $936ce038e559daa3$var$isFrozen(obj) {
    if (obj === null || !$936ce038e559daa3$var$isObjectish(obj)) return true;
    return $936ce038e559daa3$var$O.isFrozen(obj);
}
// src/utils/plugins.ts
var $936ce038e559daa3$var$PluginMapSet = "MapSet";
var $936ce038e559daa3$var$PluginPatches = "Patches";
var $936ce038e559daa3$var$PluginArrayMethods = "ArrayMethods";
var $936ce038e559daa3$var$plugins = {};
function $936ce038e559daa3$var$getPlugin(pluginKey) {
    const plugin = $936ce038e559daa3$var$plugins[pluginKey];
    if (!plugin) $936ce038e559daa3$var$die(0, pluginKey);
    return plugin;
}
var $936ce038e559daa3$var$isPluginLoaded = (pluginKey)=>!!$936ce038e559daa3$var$plugins[pluginKey];
function $936ce038e559daa3$var$loadPlugin(pluginKey, implementation) {
    if (!$936ce038e559daa3$var$plugins[pluginKey]) $936ce038e559daa3$var$plugins[pluginKey] = implementation;
}
// src/core/scope.ts
var $936ce038e559daa3$var$currentScope;
var $936ce038e559daa3$var$getCurrentScope = ()=>$936ce038e559daa3$var$currentScope;
var $936ce038e559daa3$var$createScope = (parent_, immer_)=>({
        drafts_: [],
        parent_: parent_,
        immer_: immer_,
        // Whenever the modified draft contains a draft from another scope, we
        // need to prevent auto-freezing so the unowned draft can be finalized.
        canAutoFreeze_: true,
        unfinalizedDrafts_: 0,
        handledSet_: /* @__PURE__ */ new Set(),
        processedForPatches_: /* @__PURE__ */ new Set(),
        mapSetPlugin_: $936ce038e559daa3$var$isPluginLoaded($936ce038e559daa3$var$PluginMapSet) ? $936ce038e559daa3$var$getPlugin($936ce038e559daa3$var$PluginMapSet) : void 0,
        arrayMethodsPlugin_: $936ce038e559daa3$var$isPluginLoaded($936ce038e559daa3$var$PluginArrayMethods) ? $936ce038e559daa3$var$getPlugin($936ce038e559daa3$var$PluginArrayMethods) : void 0
    });
function $936ce038e559daa3$var$usePatchesInScope(scope, patchListener) {
    if (patchListener) {
        scope.patchPlugin_ = $936ce038e559daa3$var$getPlugin($936ce038e559daa3$var$PluginPatches);
        scope.patches_ = [];
        scope.inversePatches_ = [];
        scope.patchListener_ = patchListener;
    }
}
function $936ce038e559daa3$var$revokeScope(scope) {
    $936ce038e559daa3$var$leaveScope(scope);
    scope.drafts_.forEach($936ce038e559daa3$var$revokeDraft);
    scope.drafts_ = null;
}
function $936ce038e559daa3$var$leaveScope(scope) {
    if (scope === $936ce038e559daa3$var$currentScope) $936ce038e559daa3$var$currentScope = scope.parent_;
}
var $936ce038e559daa3$var$enterScope = (immer2)=>$936ce038e559daa3$var$currentScope = $936ce038e559daa3$var$createScope($936ce038e559daa3$var$currentScope, immer2);
function $936ce038e559daa3$var$revokeDraft(draft) {
    const state = draft[$936ce038e559daa3$var$DRAFT_STATE];
    if (state.type_ === 0 /* Object */  || state.type_ === 1 /* Array */ ) state.revoke_();
    else state.revoked_ = true;
}
// src/core/finalize.ts
function $936ce038e559daa3$var$processResult(result, scope) {
    scope.unfinalizedDrafts_ = scope.drafts_.length;
    const baseDraft = scope.drafts_[0];
    const isReplaced = result !== void 0 && result !== baseDraft;
    if (isReplaced) {
        if (baseDraft[$936ce038e559daa3$var$DRAFT_STATE].modified_) {
            $936ce038e559daa3$var$revokeScope(scope);
            $936ce038e559daa3$var$die(4);
        }
        if ($936ce038e559daa3$export$16e3aed3edb85946(result)) result = $936ce038e559daa3$var$finalize(scope, result);
        const { patchPlugin_: patchPlugin_ } = scope;
        if (patchPlugin_) patchPlugin_.generateReplacementPatches_(baseDraft[$936ce038e559daa3$var$DRAFT_STATE].base_, result, scope);
    } else result = $936ce038e559daa3$var$finalize(scope, baseDraft);
    $936ce038e559daa3$var$maybeFreeze(scope, result, true);
    $936ce038e559daa3$var$revokeScope(scope);
    if (scope.patches_) scope.patchListener_(scope.patches_, scope.inversePatches_);
    return result !== $936ce038e559daa3$export$45b790e32b2810ee ? result : void 0;
}
function $936ce038e559daa3$var$finalize(rootScope, value) {
    if ($936ce038e559daa3$var$isFrozen(value)) return value;
    const state = value[$936ce038e559daa3$var$DRAFT_STATE];
    if (!state) {
        const finalValue = $936ce038e559daa3$var$handleValue(value, rootScope.handledSet_, rootScope);
        return finalValue;
    }
    if (!$936ce038e559daa3$var$isSameScope(state, rootScope)) return value;
    if (!state.modified_) return state.base_;
    if (!state.finalized_) {
        const { callbacks_: callbacks_ } = state;
        if (callbacks_) while(callbacks_.length > 0){
            const callback = callbacks_.pop();
            callback(rootScope);
        }
        $936ce038e559daa3$var$generatePatchesAndFinalize(state, rootScope);
    }
    return state.copy_;
}
function $936ce038e559daa3$var$maybeFreeze(scope, value, deep = false) {
    if (!scope.parent_ && scope.immer_.autoFreeze_ && scope.canAutoFreeze_) $936ce038e559daa3$export$792f3d81ea979f55(value, deep);
}
function $936ce038e559daa3$var$markStateFinalized(state) {
    state.finalized_ = true;
    state.scope_.unfinalizedDrafts_--;
}
var $936ce038e559daa3$var$isSameScope = (state, rootScope)=>state.scope_ === rootScope;
var $936ce038e559daa3$var$EMPTY_LOCATIONS_RESULT = [];
function $936ce038e559daa3$var$updateDraftInParent(parent, draftValue, finalizedValue, originalKey) {
    var _a;
    const parentCopy = $936ce038e559daa3$var$latest(parent);
    const parentType = parent.type_;
    if (originalKey !== void 0) {
        const currentValue = $936ce038e559daa3$var$get(parentCopy, originalKey, parentType);
        if (currentValue === draftValue) {
            $936ce038e559daa3$var$set(parentCopy, originalKey, finalizedValue, parentType);
            return;
        }
    }
    if (!parent.draftLocations_) {
        const draftLocations = parent.draftLocations_ = /* @__PURE__ */ new Map();
        $936ce038e559daa3$var$each(parentCopy, (key, value)=>{
            if ($936ce038e559daa3$export$541ac630993a4c84(value)) {
                const keys = draftLocations.get(value) || [];
                keys.push(key);
                draftLocations.set(value, keys);
            }
        });
    }
    const locations = (_a = parent.draftLocations_.get(draftValue)) != null ? _a : $936ce038e559daa3$var$EMPTY_LOCATIONS_RESULT;
    for (const location of locations)$936ce038e559daa3$var$set(parentCopy, location, finalizedValue, parentType);
}
function $936ce038e559daa3$var$registerChildFinalizationCallback(parent, child, key) {
    parent.callbacks_.push(function childCleanup(rootScope) {
        var _a, _b;
        const state = child;
        if (!state || !$936ce038e559daa3$var$isSameScope(state, rootScope)) return;
        (_a = rootScope.mapSetPlugin_) == null || _a.fixSetContents(state);
        const finalizedValue = $936ce038e559daa3$var$getFinalValue(state);
        $936ce038e559daa3$var$updateDraftInParent(parent, (_b = state.draft_) != null ? _b : state, finalizedValue, key);
        $936ce038e559daa3$var$generatePatchesAndFinalize(state, rootScope);
    });
}
function $936ce038e559daa3$var$generatePatchesAndFinalize(state, rootScope) {
    var _a, _b;
    const shouldFinalize = state.modified_ && !state.finalized_ && (state.type_ === 3 /* Set */  || state.type_ === 1 /* Array */  && state.allIndicesReassigned_ || ((_b = (_a = state.assigned_) == null ? void 0 : _a.size) != null ? _b : 0) > 0);
    if (shouldFinalize) {
        const { patchPlugin_: patchPlugin_ } = rootScope;
        if (patchPlugin_) {
            const basePath = patchPlugin_.getPath(state);
            if (basePath) patchPlugin_.generatePatches_(state, basePath, rootScope);
        }
        $936ce038e559daa3$var$markStateFinalized(state);
    }
}
function $936ce038e559daa3$var$handleCrossReference(target, key, value) {
    const { scope_: scope_ } = target;
    if ($936ce038e559daa3$export$541ac630993a4c84(value)) {
        const state = value[$936ce038e559daa3$var$DRAFT_STATE];
        if ($936ce038e559daa3$var$isSameScope(state, scope_)) state.callbacks_.push(function crossReferenceCleanup() {
            $936ce038e559daa3$var$prepareCopy(target);
            const finalizedValue = $936ce038e559daa3$var$getFinalValue(state);
            $936ce038e559daa3$var$updateDraftInParent(target, value, finalizedValue, key);
        });
    } else if ($936ce038e559daa3$export$16e3aed3edb85946(value)) target.callbacks_.push(function nestedDraftCleanup() {
        var _a;
        const targetCopy = $936ce038e559daa3$var$latest(target);
        if (target.type_ === 3 /* Set */ ) {
            if (targetCopy.has(value)) $936ce038e559daa3$var$handleValue(value, scope_.handledSet_, scope_);
        } else {
            if ($936ce038e559daa3$var$get(targetCopy, key, target.type_) === value) {
                if (scope_.drafts_.length > 1 && ((_a = target.assigned_.get(key)) != null ? _a : false) === true && target.copy_) $936ce038e559daa3$var$handleValue($936ce038e559daa3$var$get(target.copy_, key, target.type_), scope_.handledSet_, scope_);
            }
        }
    });
}
function $936ce038e559daa3$var$handleValue(target, handledSet, rootScope) {
    if (!rootScope.immer_.autoFreeze_ && rootScope.unfinalizedDrafts_ < 1) return target;
    if ($936ce038e559daa3$export$541ac630993a4c84(target) || handledSet.has(target) || !$936ce038e559daa3$export$16e3aed3edb85946(target) || $936ce038e559daa3$var$isFrozen(target)) return target;
    handledSet.add(target);
    $936ce038e559daa3$var$each(target, (key, value)=>{
        if ($936ce038e559daa3$export$541ac630993a4c84(value)) {
            const state = value[$936ce038e559daa3$var$DRAFT_STATE];
            if ($936ce038e559daa3$var$isSameScope(state, rootScope)) {
                const updatedValue = $936ce038e559daa3$var$getFinalValue(state);
                $936ce038e559daa3$var$set(target, key, updatedValue, target.type_);
                $936ce038e559daa3$var$markStateFinalized(state);
            }
        } else if ($936ce038e559daa3$export$16e3aed3edb85946(value)) $936ce038e559daa3$var$handleValue(value, handledSet, rootScope);
    });
    return target;
}
// src/core/proxy.ts
function $936ce038e559daa3$var$createProxyProxy(base, parent) {
    const baseIsArray = $936ce038e559daa3$var$isArray(base);
    const state = {
        type_: baseIsArray ? 1 /* Array */  : 0 /* Object */ ,
        // Track which produce call this is associated with.
        scope_: parent ? parent.scope_ : $936ce038e559daa3$var$getCurrentScope(),
        // True for both shallow and deep changes.
        modified_: false,
        // Used during finalization.
        finalized_: false,
        // Track which properties have been assigned (true) or deleted (false).
        // actually instantiated in `prepareCopy()`
        assigned_: void 0,
        // The parent draft state.
        parent_: parent,
        // The base state.
        base_: base,
        // The base proxy.
        draft_: null,
        // set below
        // The base copy with any updated values.
        copy_: null,
        // Called by the `produce` function.
        revoke_: null,
        isManual_: false,
        // `callbacks` actually gets assigned in `createProxy`
        callbacks_: void 0
    };
    let target = state;
    let traps = $936ce038e559daa3$var$objectTraps;
    if (baseIsArray) {
        target = [
            state
        ];
        traps = $936ce038e559daa3$var$arrayTraps;
    }
    const { revoke: revoke, proxy: proxy } = Proxy.revocable(target, traps);
    state.draft_ = proxy;
    state.revoke_ = revoke;
    return [
        proxy,
        state
    ];
}
var $936ce038e559daa3$var$objectTraps = {
    get (state, prop) {
        if (prop === $936ce038e559daa3$var$DRAFT_STATE) return state;
        let arrayPlugin = state.scope_.arrayMethodsPlugin_;
        const isArrayWithStringProp = state.type_ === 1 /* Array */  && typeof prop === "string";
        if (isArrayWithStringProp) {
            if (arrayPlugin == null ? void 0 : arrayPlugin.isArrayOperationMethod(prop)) return arrayPlugin.createMethodInterceptor(state, prop);
        }
        const source = $936ce038e559daa3$var$latest(state);
        if (!$936ce038e559daa3$var$has(source, prop, state.type_)) return $936ce038e559daa3$var$readPropFromProto(state, source, prop);
        const value = source[prop];
        if (state.finalized_ || !$936ce038e559daa3$export$16e3aed3edb85946(value)) return value;
        if (isArrayWithStringProp && state.operationMethod && (arrayPlugin == null ? void 0 : arrayPlugin.isMutatingArrayMethod(state.operationMethod)) && $936ce038e559daa3$var$isArrayIndex(prop)) return value;
        if (value === $936ce038e559daa3$var$peek(state.base_, prop)) {
            $936ce038e559daa3$var$prepareCopy(state);
            const childKey = state.type_ === 1 /* Array */  ? +prop : prop;
            const childDraft = $936ce038e559daa3$var$createProxy(state.scope_, value, state, childKey);
            return state.copy_[childKey] = childDraft;
        }
        return value;
    },
    has (state, prop) {
        return prop in $936ce038e559daa3$var$latest(state);
    },
    ownKeys (state) {
        return Reflect.ownKeys($936ce038e559daa3$var$latest(state));
    },
    set (state, prop, value) {
        const desc = $936ce038e559daa3$var$getDescriptorFromProto($936ce038e559daa3$var$latest(state), prop);
        if (desc == null ? void 0 : desc.set) {
            desc.set.call(state.draft_, value);
            return true;
        }
        if (!state.modified_) {
            const current2 = $936ce038e559daa3$var$peek($936ce038e559daa3$var$latest(state), prop);
            const currentState = current2 == null ? void 0 : current2[$936ce038e559daa3$var$DRAFT_STATE];
            if (currentState && currentState.base_ === value) {
                state.copy_[prop] = value;
                state.assigned_.set(prop, false);
                return true;
            }
            if ($936ce038e559daa3$var$is(value, current2) && (value !== void 0 || $936ce038e559daa3$var$has(state.base_, prop, state.type_))) return true;
            $936ce038e559daa3$var$prepareCopy(state);
            $936ce038e559daa3$var$markChanged(state);
        }
        if (state.copy_[prop] === value && // special case: handle new props with value 'undefined'
        (value !== void 0 || prop in state.copy_) || // special case: NaN
        Number.isNaN(value) && Number.isNaN(state.copy_[prop])) return true;
        state.copy_[prop] = value;
        state.assigned_.set(prop, true);
        $936ce038e559daa3$var$handleCrossReference(state, prop, value);
        return true;
    },
    deleteProperty (state, prop) {
        $936ce038e559daa3$var$prepareCopy(state);
        if ($936ce038e559daa3$var$peek(state.base_, prop) !== void 0 || prop in state.base_) {
            state.assigned_.set(prop, false);
            $936ce038e559daa3$var$markChanged(state);
        } else state.assigned_.delete(prop);
        if (state.copy_) delete state.copy_[prop];
        return true;
    },
    // Note: We never coerce `desc.value` into an Immer draft, because we can't make
    // the same guarantee in ES5 mode.
    getOwnPropertyDescriptor (state, prop) {
        const owner = $936ce038e559daa3$var$latest(state);
        const desc = Reflect.getOwnPropertyDescriptor(owner, prop);
        if (!desc) return desc;
        return {
            [$936ce038e559daa3$var$WRITABLE]: true,
            [$936ce038e559daa3$var$CONFIGURABLE]: state.type_ !== 1 /* Array */  || prop !== "length",
            [$936ce038e559daa3$var$ENUMERABLE]: desc[$936ce038e559daa3$var$ENUMERABLE],
            [$936ce038e559daa3$var$VALUE]: owner[prop]
        };
    },
    defineProperty () {
        $936ce038e559daa3$var$die(11);
    },
    getPrototypeOf (state) {
        return $936ce038e559daa3$var$getPrototypeOf(state.base_);
    },
    setPrototypeOf () {
        $936ce038e559daa3$var$die(12);
    }
};
var $936ce038e559daa3$var$arrayTraps = {};
for(let key in $936ce038e559daa3$var$objectTraps){
    let fn = $936ce038e559daa3$var$objectTraps[key];
    $936ce038e559daa3$var$arrayTraps[key] = function() {
        const args = arguments;
        args[0] = args[0][0];
        return fn.apply(this, args);
    };
}
$936ce038e559daa3$var$arrayTraps.deleteProperty = function(state, prop) {
    return $936ce038e559daa3$var$arrayTraps.set.call(this, state, prop, void 0);
};
$936ce038e559daa3$var$arrayTraps.set = function(state, prop, value) {
    return $936ce038e559daa3$var$objectTraps.set.call(this, state[0], prop, value, state[0]);
};
function $936ce038e559daa3$var$peek(draft, prop) {
    const state = draft[$936ce038e559daa3$var$DRAFT_STATE];
    const source = state ? $936ce038e559daa3$var$latest(state) : draft;
    return source[prop];
}
function $936ce038e559daa3$var$readPropFromProto(state, source, prop) {
    var _a;
    const desc = $936ce038e559daa3$var$getDescriptorFromProto(source, prop);
    return desc ? $936ce038e559daa3$var$VALUE in desc ? desc[$936ce038e559daa3$var$VALUE] : // This is a very special case, if the prop is a getter defined by the
    // prototype, we should invoke it with the draft as context!
    (_a = desc.get) == null ? void 0 : _a.call(state.draft_) : void 0;
}
function $936ce038e559daa3$var$getDescriptorFromProto(source, prop) {
    if (!(prop in source)) return void 0;
    let proto = $936ce038e559daa3$var$getPrototypeOf(source);
    while(proto){
        const desc = Object.getOwnPropertyDescriptor(proto, prop);
        if (desc) return desc;
        proto = $936ce038e559daa3$var$getPrototypeOf(proto);
    }
    return void 0;
}
function $936ce038e559daa3$var$markChanged(state) {
    if (!state.modified_) {
        state.modified_ = true;
        if (state.parent_) $936ce038e559daa3$var$markChanged(state.parent_);
    }
}
function $936ce038e559daa3$var$prepareCopy(state) {
    if (!state.copy_) {
        state.assigned_ = /* @__PURE__ */ new Map();
        state.copy_ = $936ce038e559daa3$var$shallowCopy(state.base_, state.scope_.immer_.useStrictShallowCopy_);
    }
}
// src/core/immerClass.ts
var $936ce038e559daa3$export$aaadc6ff0f822719 = class {
    constructor(config){
        this.autoFreeze_ = true;
        this.useStrictShallowCopy_ = false;
        this.useStrictIteration_ = false;
        /**
     * The `produce` function takes a value and a "recipe function" (whose
     * return value often depends on the base state). The recipe function is
     * free to mutate its first argument however it wants. All mutations are
     * only ever applied to a __copy__ of the base state.
     *
     * Pass only a function to create a "curried producer" which relieves you
     * from passing the recipe function every time.
     *
     * Only plain objects and arrays are made mutable. All other objects are
     * considered uncopyable.
     *
     * Note: This function is __bound__ to its `Immer` instance.
     *
     * @param {any} base - the initial state
     * @param {Function} recipe - function that receives a proxy of the base state as first argument and which can be freely modified
     * @param {Function} patchListener - optional function that will be called with all the patches produced here
     * @returns {any} a new state, or the initial state if nothing was modified
     */ this.produce = (base, recipe, patchListener)=>{
            if ($936ce038e559daa3$var$isFunction(base) && !$936ce038e559daa3$var$isFunction(recipe)) {
                const defaultBase = recipe;
                recipe = base;
                const self = this;
                return function curriedProduce(base2 = defaultBase, ...args) {
                    return self.produce(base2, (draft)=>recipe.call(this, draft, ...args));
                };
            }
            if (!$936ce038e559daa3$var$isFunction(recipe)) $936ce038e559daa3$var$die(6);
            if (patchListener !== void 0 && !$936ce038e559daa3$var$isFunction(patchListener)) $936ce038e559daa3$var$die(7);
            let result;
            if ($936ce038e559daa3$export$16e3aed3edb85946(base)) {
                const scope = $936ce038e559daa3$var$enterScope(this);
                const proxy = $936ce038e559daa3$var$createProxy(scope, base, void 0);
                let hasError = true;
                try {
                    result = recipe(proxy);
                    hasError = false;
                } finally{
                    if (hasError) $936ce038e559daa3$var$revokeScope(scope);
                    else $936ce038e559daa3$var$leaveScope(scope);
                }
                $936ce038e559daa3$var$usePatchesInScope(scope, patchListener);
                return $936ce038e559daa3$var$processResult(result, scope);
            } else if (!base || !$936ce038e559daa3$var$isObjectish(base)) {
                result = recipe(base);
                if (result === void 0) result = base;
                if (result === $936ce038e559daa3$export$45b790e32b2810ee) result = void 0;
                if (this.autoFreeze_) $936ce038e559daa3$export$792f3d81ea979f55(result, true);
                if (patchListener) {
                    const p = [];
                    const ip = [];
                    $936ce038e559daa3$var$getPlugin($936ce038e559daa3$var$PluginPatches).generateReplacementPatches_(base, result, {
                        patches_: p,
                        inversePatches_: ip
                    });
                    patchListener(p, ip);
                }
                return result;
            } else $936ce038e559daa3$var$die(1, base);
        };
        this.produceWithPatches = (base, recipe)=>{
            if ($936ce038e559daa3$var$isFunction(base)) return (state, ...args)=>this.produceWithPatches(state, (draft)=>base(draft, ...args));
            let patches, inversePatches;
            const result = this.produce(base, recipe, (p, ip)=>{
                patches = p;
                inversePatches = ip;
            });
            return [
                result,
                patches,
                inversePatches
            ];
        };
        if ($936ce038e559daa3$var$isBoolean(config == null ? void 0 : config.autoFreeze)) this.setAutoFreeze(config.autoFreeze);
        if ($936ce038e559daa3$var$isBoolean(config == null ? void 0 : config.useStrictShallowCopy)) this.setUseStrictShallowCopy(config.useStrictShallowCopy);
        if ($936ce038e559daa3$var$isBoolean(config == null ? void 0 : config.useStrictIteration)) this.setUseStrictIteration(config.useStrictIteration);
    }
    createDraft(base) {
        if (!$936ce038e559daa3$export$16e3aed3edb85946(base)) $936ce038e559daa3$var$die(8);
        if ($936ce038e559daa3$export$541ac630993a4c84(base)) base = $936ce038e559daa3$export$97aac956da55dae9(base);
        const scope = $936ce038e559daa3$var$enterScope(this);
        const proxy = $936ce038e559daa3$var$createProxy(scope, base, void 0);
        proxy[$936ce038e559daa3$var$DRAFT_STATE].isManual_ = true;
        $936ce038e559daa3$var$leaveScope(scope);
        return proxy;
    }
    finishDraft(draft, patchListener) {
        const state = draft && draft[$936ce038e559daa3$var$DRAFT_STATE];
        if (!state || !state.isManual_) $936ce038e559daa3$var$die(9);
        const { scope_: scope } = state;
        $936ce038e559daa3$var$usePatchesInScope(scope, patchListener);
        return $936ce038e559daa3$var$processResult(void 0, scope);
    }
    /**
   * Pass true to automatically freeze all copies created by Immer.
   *
   * By default, auto-freezing is enabled.
   */ setAutoFreeze(value) {
        this.autoFreeze_ = value;
    }
    /**
   * Pass true to enable strict shallow copy.
   *
   * By default, immer does not copy the object descriptors such as getter, setter and non-enumrable properties.
   */ setUseStrictShallowCopy(value) {
        this.useStrictShallowCopy_ = value;
    }
    /**
   * Pass false to use faster iteration that skips non-enumerable properties
   * but still handles symbols for compatibility.
   *
   * By default, strict iteration is enabled (includes all own properties).
   */ setUseStrictIteration(value) {
        this.useStrictIteration_ = value;
    }
    shouldUseStrictIteration() {
        return this.useStrictIteration_;
    }
    applyPatches(base, patches) {
        let i;
        for(i = patches.length - 1; i >= 0; i--){
            const patch = patches[i];
            if (patch.path.length === 0 && patch.op === "replace") {
                base = patch.value;
                break;
            }
        }
        if (i > -1) patches = patches.slice(i + 1);
        const applyPatchesImpl = $936ce038e559daa3$var$getPlugin($936ce038e559daa3$var$PluginPatches).applyPatches_;
        if ($936ce038e559daa3$export$541ac630993a4c84(base)) return applyPatchesImpl(base, patches);
        return this.produce(base, (draft)=>applyPatchesImpl(draft, patches));
    }
};
function $936ce038e559daa3$var$createProxy(rootScope, value, parent, key) {
    var _a, _b;
    const [draft, state] = $936ce038e559daa3$var$isMap(value) ? $936ce038e559daa3$var$getPlugin($936ce038e559daa3$var$PluginMapSet).proxyMap_(value, parent) : $936ce038e559daa3$var$isSet(value) ? $936ce038e559daa3$var$getPlugin($936ce038e559daa3$var$PluginMapSet).proxySet_(value, parent) : $936ce038e559daa3$var$createProxyProxy(value, parent);
    const scope = (_a = parent == null ? void 0 : parent.scope_) != null ? _a : $936ce038e559daa3$var$getCurrentScope();
    scope.drafts_.push(draft);
    state.callbacks_ = (_b = parent == null ? void 0 : parent.callbacks_) != null ? _b : [];
    state.key_ = key;
    if (parent && key !== void 0) $936ce038e559daa3$var$registerChildFinalizationCallback(parent, state, key);
    else state.callbacks_.push(function rootDraftCleanup(rootScope2) {
        var _a2;
        (_a2 = rootScope2.mapSetPlugin_) == null || _a2.fixSetContents(state);
        const { patchPlugin_: patchPlugin_ } = rootScope2;
        if (state.modified_ && patchPlugin_) patchPlugin_.generatePatches_(state, [], rootScope2);
    });
    return draft;
}
// src/core/current.ts
function $936ce038e559daa3$export$97aac956da55dae9(value) {
    if (!$936ce038e559daa3$export$541ac630993a4c84(value)) $936ce038e559daa3$var$die(10, value);
    return $936ce038e559daa3$var$currentImpl(value);
}
function $936ce038e559daa3$var$currentImpl(value) {
    if (!$936ce038e559daa3$export$16e3aed3edb85946(value) || $936ce038e559daa3$var$isFrozen(value)) return value;
    const state = value[$936ce038e559daa3$var$DRAFT_STATE];
    let copy;
    let strict = true;
    if (state) {
        if (!state.modified_) return state.base_;
        state.finalized_ = true;
        copy = $936ce038e559daa3$var$shallowCopy(value, state.scope_.immer_.useStrictShallowCopy_);
        strict = state.scope_.immer_.shouldUseStrictIteration();
    } else copy = $936ce038e559daa3$var$shallowCopy(value, true);
    $936ce038e559daa3$var$each(copy, (key, childValue)=>{
        $936ce038e559daa3$var$set(copy, key, $936ce038e559daa3$var$currentImpl(childValue));
    }, strict);
    if (state) state.finalized_ = false;
    return copy;
}
// src/plugins/patches.ts
function $936ce038e559daa3$export$d3a6659991a0696c() {
    const errorOffset = 16;
    function getPath(state, path = []) {
        var _a;
        if (state.key_ !== void 0) {
            const parentCopy = (_a = state.parent_.copy_) != null ? _a : state.parent_.base_;
            const proxyDraft = $936ce038e559daa3$var$getProxyDraft($936ce038e559daa3$var$get(parentCopy, state.key_));
            const valueAtKey = $936ce038e559daa3$var$get(parentCopy, state.key_);
            if (valueAtKey === void 0) return null;
            if (valueAtKey !== state.draft_ && valueAtKey !== state.base_ && valueAtKey !== state.copy_) return null;
            if (proxyDraft != null && proxyDraft.base_ !== state.base_) return null;
            const isSet2 = state.parent_.type_ === 3 /* Set */ ;
            let key;
            if (isSet2) {
                const setParent = state.parent_;
                key = Array.from(setParent.drafts_.keys()).indexOf(state.key_);
            } else key = state.key_;
            if (!(isSet2 && parentCopy.size > key || $936ce038e559daa3$var$has(parentCopy, key))) return null;
            path.push(key);
        }
        if (state.parent_) return getPath(state.parent_, path);
        path.reverse();
        try {
            resolvePath(state.copy_, path);
        } catch (e) {
            return null;
        }
        return path;
    }
    function resolvePath(base, path) {
        let current2 = base;
        for(let i = 0; i < path.length - 1; i++){
            const key = path[i];
            current2 = $936ce038e559daa3$var$get(current2, key);
            if (!$936ce038e559daa3$var$isObjectish(current2) || current2 === null) throw new Error(`Cannot resolve path at '${path.join("/")}'`);
        }
        return current2;
    }
    const REPLACE = "replace";
    const ADD = "add";
    const REMOVE = "remove";
    function generatePatches_(state, basePath, scope) {
        if (state.scope_.processedForPatches_.has(state)) return;
        state.scope_.processedForPatches_.add(state);
        const { patches_: patches_, inversePatches_: inversePatches_ } = scope;
        switch(state.type_){
            case 0 /* Object */ :
            case 2 /* Map */ :
                return generatePatchesFromAssigned(state, basePath, patches_, inversePatches_);
            case 1 /* Array */ :
                return generateArrayPatches(state, basePath, patches_, inversePatches_);
            case 3 /* Set */ :
                return generateSetPatches(state, basePath, patches_, inversePatches_);
        }
    }
    function generateArrayPatches(state, basePath, patches, inversePatches) {
        let { base_: base_, assigned_: assigned_ } = state;
        let copy_ = state.copy_;
        if (copy_.length < base_.length) {
            [base_, copy_] = [
                copy_,
                base_
            ];
            [patches, inversePatches] = [
                inversePatches,
                patches
            ];
        }
        const allReassigned = state.allIndicesReassigned_ === true;
        for(let i = 0; i < base_.length; i++){
            const copiedItem = copy_[i];
            const baseItem = base_[i];
            const isAssigned = allReassigned || (assigned_ == null ? void 0 : assigned_.get(i.toString()));
            if (isAssigned && copiedItem !== baseItem) {
                const childState = copiedItem == null ? void 0 : copiedItem[$936ce038e559daa3$var$DRAFT_STATE];
                if (childState && childState.modified_) continue;
                const path = basePath.concat([
                    i
                ]);
                patches.push({
                    op: REPLACE,
                    path: path,
                    // Need to maybe clone it, as it can in fact be the original value
                    // due to the base/copy inversion at the start of this function
                    value: clonePatchValueIfNeeded(copiedItem)
                });
                inversePatches.push({
                    op: REPLACE,
                    path: path,
                    value: clonePatchValueIfNeeded(baseItem)
                });
            }
        }
        for(let i = base_.length; i < copy_.length; i++){
            const path = basePath.concat([
                i
            ]);
            patches.push({
                op: ADD,
                path: path,
                // Need to maybe clone it, as it can in fact be the original value
                // due to the base/copy inversion at the start of this function
                value: clonePatchValueIfNeeded(copy_[i])
            });
        }
        for(let i = copy_.length - 1; base_.length <= i; --i){
            const path = basePath.concat([
                i
            ]);
            inversePatches.push({
                op: REMOVE,
                path: path
            });
        }
    }
    function generatePatchesFromAssigned(state, basePath, patches, inversePatches) {
        const { base_: base_, copy_: copy_, type_: type_ } = state;
        $936ce038e559daa3$var$each(state.assigned_, (key, assignedValue)=>{
            const origValue = $936ce038e559daa3$var$get(base_, key, type_);
            const value = $936ce038e559daa3$var$get(copy_, key, type_);
            const op = !assignedValue ? REMOVE : $936ce038e559daa3$var$has(base_, key) ? REPLACE : ADD;
            if (origValue === value && op === REPLACE) return;
            const path = basePath.concat(key);
            patches.push(op === REMOVE ? {
                op: op,
                path: path
            } : {
                op: op,
                path: path,
                value: clonePatchValueIfNeeded(value)
            });
            inversePatches.push(op === ADD ? {
                op: REMOVE,
                path: path
            } : op === REMOVE ? {
                op: ADD,
                path: path,
                value: clonePatchValueIfNeeded(origValue)
            } : {
                op: REPLACE,
                path: path,
                value: clonePatchValueIfNeeded(origValue)
            });
        });
    }
    function generateSetPatches(state, basePath, patches, inversePatches) {
        let { base_: base_, copy_: copy_ } = state;
        let i = 0;
        base_.forEach((value)=>{
            if (!copy_.has(value)) {
                const path = basePath.concat([
                    i
                ]);
                patches.push({
                    op: REMOVE,
                    path: path,
                    value: value
                });
                inversePatches.unshift({
                    op: ADD,
                    path: path,
                    value: value
                });
            }
            i++;
        });
        i = 0;
        copy_.forEach((value)=>{
            if (!base_.has(value)) {
                const path = basePath.concat([
                    i
                ]);
                patches.push({
                    op: ADD,
                    path: path,
                    value: value
                });
                inversePatches.unshift({
                    op: REMOVE,
                    path: path,
                    value: value
                });
            }
            i++;
        });
    }
    function generateReplacementPatches_(baseValue, replacement, scope) {
        const { patches_: patches_, inversePatches_: inversePatches_ } = scope;
        patches_.push({
            op: REPLACE,
            path: [],
            value: replacement === $936ce038e559daa3$export$45b790e32b2810ee ? void 0 : replacement
        });
        inversePatches_.push({
            op: REPLACE,
            path: [],
            value: baseValue
        });
    }
    function applyPatches_(draft, patches) {
        patches.forEach((patch)=>{
            const { path: path, op: op } = patch;
            let base = draft;
            for(let i = 0; i < path.length - 1; i++){
                const parentType = $936ce038e559daa3$var$getArchtype(base);
                let p = path[i];
                if (typeof p !== "string" && typeof p !== "number") p = "" + p;
                if ((parentType === 0 /* Object */  || parentType === 1 /* Array */ ) && (p === "__proto__" || p === $936ce038e559daa3$var$CONSTRUCTOR)) $936ce038e559daa3$var$die(errorOffset + 3);
                if ($936ce038e559daa3$var$isFunction(base) && p === $936ce038e559daa3$var$PROTOTYPE) $936ce038e559daa3$var$die(errorOffset + 3);
                base = $936ce038e559daa3$var$get(base, p);
                if (!$936ce038e559daa3$var$isObjectish(base)) $936ce038e559daa3$var$die(errorOffset + 2, path.join("/"));
            }
            const type = $936ce038e559daa3$var$getArchtype(base);
            const value = deepClonePatchValue(patch.value);
            const key = path[path.length - 1];
            switch(op){
                case REPLACE:
                    switch(type){
                        case 2 /* Map */ :
                            return base.set(key, value);
                        case 3 /* Set */ :
                            $936ce038e559daa3$var$die(errorOffset);
                        default:
                            return base[key] = value;
                    }
                case ADD:
                    switch(type){
                        case 1 /* Array */ :
                            return key === "-" ? base.push(value) : base.splice(key, 0, value);
                        case 2 /* Map */ :
                            return base.set(key, value);
                        case 3 /* Set */ :
                            return base.add(value);
                        default:
                            return base[key] = value;
                    }
                case REMOVE:
                    switch(type){
                        case 1 /* Array */ :
                            return base.splice(key, 1);
                        case 2 /* Map */ :
                            return base.delete(key);
                        case 3 /* Set */ :
                            return base.delete(patch.value);
                        default:
                            return delete base[key];
                    }
                default:
                    $936ce038e559daa3$var$die(errorOffset + 1, op);
            }
        });
        return draft;
    }
    function deepClonePatchValue(obj) {
        if (!$936ce038e559daa3$export$16e3aed3edb85946(obj)) return obj;
        if ($936ce038e559daa3$var$isArray(obj)) return obj.map(deepClonePatchValue);
        if ($936ce038e559daa3$var$isMap(obj)) return new Map(Array.from(obj.entries()).map(([k, v])=>[
                k,
                deepClonePatchValue(v)
            ]));
        if ($936ce038e559daa3$var$isSet(obj)) return new Set(Array.from(obj).map(deepClonePatchValue));
        const cloned = Object.create($936ce038e559daa3$var$getPrototypeOf(obj));
        for(const key in obj)cloned[key] = deepClonePatchValue(obj[key]);
        if ($936ce038e559daa3$var$has(obj, $936ce038e559daa3$export$6ee2082928bcb0ee)) cloned[$936ce038e559daa3$export$6ee2082928bcb0ee] = obj[$936ce038e559daa3$export$6ee2082928bcb0ee];
        return cloned;
    }
    function clonePatchValueIfNeeded(obj) {
        if ($936ce038e559daa3$export$541ac630993a4c84(obj)) return deepClonePatchValue(obj);
        else return obj;
    }
    $936ce038e559daa3$var$loadPlugin($936ce038e559daa3$var$PluginPatches, {
        applyPatches_: applyPatches_,
        generatePatches_: generatePatches_,
        generateReplacementPatches_: generateReplacementPatches_,
        getPath: getPath
    });
}
// src/plugins/mapset.ts
function $936ce038e559daa3$export$7d9f65390203b435() {
    class DraftMap extends Map {
        constructor(target, parent){
            super();
            this[$936ce038e559daa3$var$DRAFT_STATE] = {
                type_: 2 /* Map */ ,
                parent_: parent,
                scope_: parent ? parent.scope_ : $936ce038e559daa3$var$getCurrentScope(),
                modified_: false,
                finalized_: false,
                copy_: void 0,
                assigned_: void 0,
                base_: target,
                draft_: this,
                isManual_: false,
                revoked_: false,
                callbacks_: []
            };
        }
        get size() {
            return $936ce038e559daa3$var$latest(this[$936ce038e559daa3$var$DRAFT_STATE]).size;
        }
        has(key) {
            return $936ce038e559daa3$var$latest(this[$936ce038e559daa3$var$DRAFT_STATE]).has(key);
        }
        set(key, value) {
            const state = this[$936ce038e559daa3$var$DRAFT_STATE];
            assertUnrevoked(state);
            if (!$936ce038e559daa3$var$latest(state).has(key) || $936ce038e559daa3$var$latest(state).get(key) !== value) {
                prepareMapCopy(state);
                $936ce038e559daa3$var$markChanged(state);
                state.assigned_.set(key, true);
                state.copy_.set(key, value);
                state.assigned_.set(key, true);
                $936ce038e559daa3$var$handleCrossReference(state, key, value);
            }
            return this;
        }
        delete(key) {
            if (!this.has(key)) return false;
            const state = this[$936ce038e559daa3$var$DRAFT_STATE];
            assertUnrevoked(state);
            prepareMapCopy(state);
            $936ce038e559daa3$var$markChanged(state);
            if (state.base_.has(key)) state.assigned_.set(key, false);
            else state.assigned_.delete(key);
            state.copy_.delete(key);
            return true;
        }
        clear() {
            const state = this[$936ce038e559daa3$var$DRAFT_STATE];
            assertUnrevoked(state);
            if ($936ce038e559daa3$var$latest(state).size) {
                prepareMapCopy(state);
                $936ce038e559daa3$var$markChanged(state);
                state.assigned_ = /* @__PURE__ */ new Map();
                $936ce038e559daa3$var$each(state.base_, (key)=>{
                    state.assigned_.set(key, false);
                });
                state.copy_.clear();
            }
        }
        forEach(cb, thisArg) {
            const state = this[$936ce038e559daa3$var$DRAFT_STATE];
            $936ce038e559daa3$var$latest(state).forEach((_value, key, _map)=>{
                cb.call(thisArg, this.get(key), key, this);
            });
        }
        get(key) {
            const state = this[$936ce038e559daa3$var$DRAFT_STATE];
            assertUnrevoked(state);
            const value = $936ce038e559daa3$var$latest(state).get(key);
            if (state.finalized_ || !$936ce038e559daa3$export$16e3aed3edb85946(value)) return value;
            if (value !== state.base_.get(key)) return value;
            const draft = $936ce038e559daa3$var$createProxy(state.scope_, value, state, key);
            prepareMapCopy(state);
            state.copy_.set(key, draft);
            return draft;
        }
        keys() {
            return $936ce038e559daa3$var$latest(this[$936ce038e559daa3$var$DRAFT_STATE]).keys();
        }
        values() {
            const iterator = this.keys();
            return {
                [Symbol.iterator]: ()=>this.values(),
                next: ()=>{
                    const r = iterator.next();
                    if (r.done) return r;
                    const value = this.get(r.value);
                    return {
                        done: false,
                        value: value
                    };
                }
            };
        }
        entries() {
            const iterator = this.keys();
            return {
                [Symbol.iterator]: ()=>this.entries(),
                next: ()=>{
                    const r = iterator.next();
                    if (r.done) return r;
                    const value = this.get(r.value);
                    return {
                        done: false,
                        value: [
                            r.value,
                            value
                        ]
                    };
                }
            };
        }
        [($936ce038e559daa3$var$DRAFT_STATE, Symbol.iterator)]() {
            return this.entries();
        }
    }
    function proxyMap_(target, parent) {
        const map = new DraftMap(target, parent);
        return [
            map,
            map[$936ce038e559daa3$var$DRAFT_STATE]
        ];
    }
    function prepareMapCopy(state) {
        if (!state.copy_) {
            state.assigned_ = /* @__PURE__ */ new Map();
            state.copy_ = new Map(state.base_);
        }
    }
    class DraftSet extends Set {
        constructor(target, parent){
            super();
            this[$936ce038e559daa3$var$DRAFT_STATE] = {
                type_: 3 /* Set */ ,
                parent_: parent,
                scope_: parent ? parent.scope_ : $936ce038e559daa3$var$getCurrentScope(),
                modified_: false,
                finalized_: false,
                copy_: void 0,
                base_: target,
                draft_: this,
                drafts_: /* @__PURE__ */ new Map(),
                revoked_: false,
                isManual_: false,
                assigned_: void 0,
                callbacks_: []
            };
        }
        get size() {
            return $936ce038e559daa3$var$latest(this[$936ce038e559daa3$var$DRAFT_STATE]).size;
        }
        has(value) {
            const state = this[$936ce038e559daa3$var$DRAFT_STATE];
            assertUnrevoked(state);
            if (!state.copy_) return state.base_.has(value);
            if (state.copy_.has(value)) return true;
            if (state.drafts_.has(value) && state.copy_.has(state.drafts_.get(value))) return true;
            return false;
        }
        add(value) {
            const state = this[$936ce038e559daa3$var$DRAFT_STATE];
            assertUnrevoked(state);
            if (!this.has(value)) {
                prepareSetCopy(state);
                $936ce038e559daa3$var$markChanged(state);
                state.copy_.add(value);
                $936ce038e559daa3$var$handleCrossReference(state, value, value);
            }
            return this;
        }
        delete(value) {
            if (!this.has(value)) return false;
            const state = this[$936ce038e559daa3$var$DRAFT_STATE];
            assertUnrevoked(state);
            prepareSetCopy(state);
            $936ce038e559daa3$var$markChanged(state);
            return state.copy_.delete(value) || (state.drafts_.has(value) ? state.copy_.delete(state.drafts_.get(value)) : /* istanbul ignore next */ false);
        }
        clear() {
            const state = this[$936ce038e559daa3$var$DRAFT_STATE];
            assertUnrevoked(state);
            if ($936ce038e559daa3$var$latest(state).size) {
                prepareSetCopy(state);
                $936ce038e559daa3$var$markChanged(state);
                state.copy_.clear();
            }
        }
        values() {
            const state = this[$936ce038e559daa3$var$DRAFT_STATE];
            assertUnrevoked(state);
            prepareSetCopy(state);
            return state.copy_.values();
        }
        entries() {
            const state = this[$936ce038e559daa3$var$DRAFT_STATE];
            assertUnrevoked(state);
            prepareSetCopy(state);
            return state.copy_.entries();
        }
        keys() {
            return this.values();
        }
        [($936ce038e559daa3$var$DRAFT_STATE, Symbol.iterator)]() {
            return this.values();
        }
        forEach(cb, thisArg) {
            const iterator = this.values();
            let result = iterator.next();
            while(!result.done){
                cb.call(thisArg, result.value, result.value, this);
                result = iterator.next();
            }
        }
    }
    function proxySet_(target, parent) {
        const set2 = new DraftSet(target, parent);
        return [
            set2,
            set2[$936ce038e559daa3$var$DRAFT_STATE]
        ];
    }
    function prepareSetCopy(state) {
        if (!state.copy_) {
            state.copy_ = /* @__PURE__ */ new Set();
            state.base_.forEach((value)=>{
                if ($936ce038e559daa3$export$16e3aed3edb85946(value)) {
                    const draft = $936ce038e559daa3$var$createProxy(state.scope_, value, state, value);
                    state.drafts_.set(value, draft);
                    state.copy_.add(draft);
                } else state.copy_.add(value);
            });
        }
    }
    function assertUnrevoked(state) {
        if (state.revoked_) $936ce038e559daa3$var$die(3, JSON.stringify($936ce038e559daa3$var$latest(state)));
    }
    function fixSetContents(target) {
        if (target.type_ === 3 /* Set */  && target.copy_) {
            const copy = new Set(target.copy_);
            target.copy_.clear();
            copy.forEach((value)=>{
                target.copy_.add($936ce038e559daa3$var$getValue(value));
            });
        }
    }
    $936ce038e559daa3$var$loadPlugin($936ce038e559daa3$var$PluginMapSet, {
        proxyMap_: proxyMap_,
        proxySet_: proxySet_,
        fixSetContents: fixSetContents
    });
}
// src/plugins/arrayMethods.ts
function $936ce038e559daa3$export$5ecc5ed53f504cc5() {
    const SHIFTING_METHODS = /* @__PURE__ */ new Set([
        "shift",
        "unshift"
    ]);
    const QUEUE_METHODS = /* @__PURE__ */ new Set([
        "push",
        "pop"
    ]);
    const RESULT_RETURNING_METHODS = /* @__PURE__ */ new Set([
        ...QUEUE_METHODS,
        ...SHIFTING_METHODS
    ]);
    const REORDERING_METHODS = /* @__PURE__ */ new Set([
        "reverse",
        "sort"
    ]);
    const MUTATING_METHODS = /* @__PURE__ */ new Set([
        ...RESULT_RETURNING_METHODS,
        ...REORDERING_METHODS,
        "splice"
    ]);
    const FIND_METHODS = /* @__PURE__ */ new Set([
        "find",
        "findLast"
    ]);
    const NON_MUTATING_METHODS = /* @__PURE__ */ new Set([
        "filter",
        "slice",
        "concat",
        "flat",
        ...FIND_METHODS,
        "findIndex",
        "findLastIndex",
        "some",
        "every",
        "indexOf",
        "lastIndexOf",
        "includes",
        "join",
        "toString",
        "toLocaleString"
    ]);
    function isMutatingArrayMethod(method) {
        return MUTATING_METHODS.has(method);
    }
    function isNonMutatingArrayMethod(method) {
        return NON_MUTATING_METHODS.has(method);
    }
    function isArrayOperationMethod(method) {
        return isMutatingArrayMethod(method) || isNonMutatingArrayMethod(method);
    }
    function enterOperation(state, method) {
        state.operationMethod = method;
    }
    function exitOperation(state) {
        state.operationMethod = void 0;
    }
    function executeArrayMethod(state, operation, markLength = true) {
        $936ce038e559daa3$var$prepareCopy(state);
        const result = operation();
        $936ce038e559daa3$var$markChanged(state);
        if (markLength) state.assigned_.set("length", true);
        return result;
    }
    function markAllIndicesReassigned(state) {
        state.allIndicesReassigned_ = true;
    }
    function normalizeSliceIndex(index, length) {
        if (index < 0) return Math.max(length + index, 0);
        return Math.min(index, length);
    }
    function handleInsertedValues(state, startIndex, values) {
        for(let i = 0; i < values.length; i++){
            const index = startIndex + i;
            state.assigned_.set(index, true);
            $936ce038e559daa3$var$handleCrossReference(state, index, values[i]);
        }
    }
    function handleSimpleOperation(state, method, args) {
        return executeArrayMethod(state, ()=>{
            const lengthBefore = state.copy_.length;
            const result = state.copy_[method](...args);
            if (SHIFTING_METHODS.has(method)) markAllIndicesReassigned(state);
            if (method === "push" && args.length > 0) handleInsertedValues(state, lengthBefore, args);
            else if (method === "unshift" && args.length > 0) handleInsertedValues(state, 0, args);
            return RESULT_RETURNING_METHODS.has(method) ? result : state.draft_;
        });
    }
    function handleReorderingOperation(state, method, args) {
        return executeArrayMethod(state, ()=>{
            state.copy_[method](...args);
            markAllIndicesReassigned(state);
            return state.draft_;
        }, false);
    }
    function createMethodInterceptor(state, originalMethod) {
        return function interceptedMethod(...args) {
            var _a;
            const method = originalMethod;
            enterOperation(state, method);
            try {
                if (isMutatingArrayMethod(method)) {
                    if (RESULT_RETURNING_METHODS.has(method)) return handleSimpleOperation(state, method, args);
                    if (REORDERING_METHODS.has(method)) return handleReorderingOperation(state, method, args);
                    if (method === "splice") {
                        const res = executeArrayMethod(state, ()=>state.copy_.splice(...args));
                        markAllIndicesReassigned(state);
                        if (args.length > 2) {
                            const startIndex = normalizeSliceIndex((_a = args[0]) != null ? _a : 0, state.copy_.length);
                            handleInsertedValues(state, startIndex, args.slice(2));
                        }
                        return res;
                    }
                } else return handleNonMutatingOperation(state, method, args);
            } finally{
                exitOperation(state);
            }
        };
    }
    function handleNonMutatingOperation(state, method, args) {
        var _a, _b;
        const source = $936ce038e559daa3$var$latest(state);
        if (method === "filter") {
            const predicate = args[0];
            const result = [];
            for(let i = 0; i < source.length; i++)if (predicate(source[i], i, source)) result.push(state.draft_[i]);
            return result;
        }
        if (FIND_METHODS.has(method)) {
            const predicate = args[0];
            const isForward = method === "find";
            const step = isForward ? 1 : -1;
            const start = isForward ? 0 : source.length - 1;
            for(let i = start; i >= 0 && i < source.length; i += step){
                if (predicate(source[i], i, source)) return state.draft_[i];
            }
            return void 0;
        }
        if (method === "slice") {
            const rawStart = (_a = args[0]) != null ? _a : 0;
            const rawEnd = (_b = args[1]) != null ? _b : source.length;
            const start = normalizeSliceIndex(rawStart, source.length);
            const end = normalizeSliceIndex(rawEnd, source.length);
            const result = [];
            for(let i = start; i < end; i++)result.push(state.draft_[i]);
            return result;
        }
        return source[method](...args);
    }
    $936ce038e559daa3$var$loadPlugin($936ce038e559daa3$var$PluginArrayMethods, {
        createMethodInterceptor: createMethodInterceptor,
        isArrayOperationMethod: isArrayOperationMethod,
        isMutatingArrayMethod: isMutatingArrayMethod
    });
}
// src/immer.ts
var $936ce038e559daa3$var$immer = new $936ce038e559daa3$export$aaadc6ff0f822719();
var $936ce038e559daa3$export$b46cabe22e78bc00 = $936ce038e559daa3$var$immer.produce;
var $936ce038e559daa3$export$4da66d41c9492c78 = /* @__PURE__ */ $936ce038e559daa3$var$immer.produceWithPatches.bind($936ce038e559daa3$var$immer);
var $936ce038e559daa3$export$573f26f60825c493 = /* @__PURE__ */ $936ce038e559daa3$var$immer.setAutoFreeze.bind($936ce038e559daa3$var$immer);
var $936ce038e559daa3$export$333ce65961cbe047 = /* @__PURE__ */ $936ce038e559daa3$var$immer.setUseStrictShallowCopy.bind($936ce038e559daa3$var$immer);
var $936ce038e559daa3$export$1045b3be3904c489 = /* @__PURE__ */ $936ce038e559daa3$var$immer.setUseStrictIteration.bind($936ce038e559daa3$var$immer);
var $936ce038e559daa3$export$a8b8e03e6bbe5473 = /* @__PURE__ */ $936ce038e559daa3$var$immer.applyPatches.bind($936ce038e559daa3$var$immer);
var $936ce038e559daa3$export$3c3214997190395f = /* @__PURE__ */ $936ce038e559daa3$var$immer.createDraft.bind($936ce038e559daa3$var$immer);
var $936ce038e559daa3$export$c60f5e69c521b528 = /* @__PURE__ */ $936ce038e559daa3$var$immer.finishDraft.bind($936ce038e559daa3$var$immer);
var $936ce038e559daa3$export$c05b21e3257751e5 = (value)=>value;
var $936ce038e559daa3$export$20f911b3f8cf0b74 = (value)=>value;

});


parcelRegister("hzmic", function(module, exports) {
'use strict';
var $cca6ff6512463c21$var$createStoreImpl = function createStoreImpl(createState) {
    var state;
    var listeners = new Set();
    var setState = function setState(partial, replace) {
        var nextState = typeof partial === 'function' ? partial(state) : partial;
        if (!Object.is(nextState, state)) {
            var _previousState = state;
            state = (replace != null ? replace : typeof nextState !== 'object' || nextState === null) ? nextState : Object.assign({}, state, nextState);
            listeners.forEach(function(listener) {
                return listener(state, _previousState);
            });
        }
    };
    var getState = function getState() {
        return state;
    };
    var getInitialState = function getInitialState() {
        return initialState;
    };
    var subscribe = function subscribe(listener) {
        listeners.add(listener);
        return function() {
            return listeners.delete(listener);
        };
    };
    var destroy = function destroy() {
        listeners.clear();
    };
    var api = {
        setState: setState,
        getState: getState,
        getInitialState: getInitialState,
        subscribe: subscribe,
        destroy: destroy
    };
    var initialState = state = createState(setState, getState, api);
    return api;
};
var $cca6ff6512463c21$var$createStore = function createStore(createState) {
    return createState ? $cca6ff6512463c21$var$createStoreImpl(createState) : $cca6ff6512463c21$var$createStoreImpl;
};
var $cca6ff6512463c21$var$vanilla = function(createState) {
    return $cca6ff6512463c21$var$createStore(createState);
};
module.exports.createStore = $cca6ff6512463c21$var$createStore;
module.exports.default = $cca6ff6512463c21$var$vanilla;
module.exports = $cca6ff6512463c21$var$vanilla;
module.exports.createStore = $cca6ff6512463c21$var$createStore;
module.exports.default = module.exports;

});



parcelRegister("6T1Sj", function(module, exports) {
$parcel$export(module.exports, "createCopyIntentRegisterationBatcher", () => $503955786dbaf480$export$57945b6819e39246);

var $fL8KA = parcelRequire("fL8KA");

var $6HG4S = parcelRequire("6HG4S");

var $8kmor = parcelRequire("8kmor");

var $bVaC0 = parcelRequire("bVaC0");
var $503955786dbaf480$export$b79d95ee17a87a = 100;
/**
 * Returns a function that, given Array<DataloaderKey>, resolves to an array of same length containing either DataloaderResult or Error.
 * Such contract is formalised by Dataloader 1.0, @see https://github.com/graphql/dataloader
 *
 * If an Error is resolved in the results, it must be at same position then their corresponding key:
 * - Dataloader will re-throw that Error when accessing/loading that particular key
 *
 * @param mediaStore instance of MediaStore
 */ function $503955786dbaf480$var$createBatchCopyIntentRegisterationFunc(mediaStore) {
    return /*#__PURE__*/ function() {
        var _ref = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee2(keys) {
            var keysByToken, items;
            return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee2$(_context2) {
                while(true)switch(_context2.prev = _context2.next){
                    case 0:
                        keysByToken = keys.reduce(function(acc, key) {
                            var token = key.resolvedAuth.token;
                            acc[token] = acc[token] || [];
                            // de-duplicate ids in collection
                            var hasDuplicates = acc[token].some(function(_ref2) {
                                var id = _ref2.id, collectionName = _ref2.collectionName;
                                return key.id === id && collectionName === key.collectionName;
                            });
                            if (!hasDuplicates) acc[token].push(key);
                            return acc;
                        }, {});
                        items = [];
                        _context2.next = 4;
                        return Promise.all(Object.keys(keysByToken).map(/*#__PURE__*/ function() {
                            var _ref3 = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee(batchKey) {
                                var metadataTraceContext, files, resolvedAuth;
                                return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee$(_context) {
                                    while(true)switch(_context.prev = _context.next){
                                        case 0:
                                            metadataTraceContext = {
                                                traceId: (0, $bVaC0.getRandomTelemetryId)(),
                                                spanId: (0, $bVaC0.getRandomTelemetryId)()
                                            };
                                            files = keysByToken[batchKey].map(function(key) {
                                                return {
                                                    id: key.id,
                                                    collection: key.collectionName
                                                };
                                            }); // given these are batched by the token the assumption is that they have the same details.
                                            resolvedAuth = keysByToken[batchKey][0].resolvedAuth;
                                            _context.prev = 3;
                                            _context.next = 6;
                                            return mediaStore.registerCopyIntents(files, metadataTraceContext, resolvedAuth);
                                        case 6:
                                            _context.next = 11;
                                            break;
                                        case 8:
                                            _context.prev = 8;
                                            _context.t0 = _context["catch"](3);
                                            files.forEach(function(_ref4) {
                                                var id = _ref4.id, collection = _ref4.collection;
                                                items.push({
                                                    id: id,
                                                    collection: collection,
                                                    error: _context.t0
                                                });
                                            });
                                        case 11:
                                        case "end":
                                            return _context.stop();
                                    }
                                }, _callee, null, [
                                    [
                                        3,
                                        8
                                    ]
                                ]);
                            }));
                            return function(_x2) {
                                return _ref3.apply(this, arguments);
                            };
                        }()));
                    case 4:
                        return _context2.abrupt("return", keys.map(function(_ref5) {
                            var _items$find;
                            var id = _ref5.id, collectionName = _ref5.collectionName;
                            return (_items$find = items.find(function(item) {
                                return item.id === id && item.collection === collectionName;
                            })) === null || _items$find === void 0 ? void 0 : _items$find.error;
                        }));
                    case 5:
                    case "end":
                        return _context2.stop();
                }
            }, _callee2);
        }));
        return function(_x) {
            return _ref.apply(this, arguments);
        };
    }();
}
function $503955786dbaf480$export$57945b6819e39246(mediaStore) {
    return new (0, (/*@__PURE__*/$parcel$interopDefault($8kmor)))($503955786dbaf480$var$createBatchCopyIntentRegisterationFunc(mediaStore), {
        maxBatchSize: $503955786dbaf480$export$b79d95ee17a87a,
        cacheKeyFn: function cacheKeyFn(_ref6) {
            var id = _ref6.id, _ref6$collectionName = _ref6.collectionName, collectionName = _ref6$collectionName === void 0 ? 'default' : _ref6$collectionName, resolvedAuth = _ref6.resolvedAuth;
            return "".concat(id, "-").concat(collectionName, "-").concat(resolvedAuth.token);
        }
    });
}

});


parcelRegister("hnP8m", function(module, exports) {
$parcel$export(module.exports, "StargateClient", () => $ca7c3fbe45f96173$export$c66ca190f89caaac);

var $fL8KA = parcelRequire("fL8KA");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $6HG4S = parcelRequire("6HG4S");
var $ca7c3fbe45f96173$export$c66ca190f89caaac = /*#__PURE__*/ function() {
    function StargateClient(baseUrl) {
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, StargateClient);
        this.baseUrl = baseUrl || '/gateway/api';
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(StargateClient, [
        {
            key: "fetchToken",
            value: function() {
                var _fetchToken = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee(clientId) {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee$(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                _context.next = 2;
                                return fetch("".concat(this.baseUrl, "/media/auth/smartedge"), {
                                    credentials: 'include',
                                    headers: {
                                        'x-client-id': clientId
                                    }
                                });
                            case 2:
                                return _context.abrupt("return", _context.sent.json());
                            case 3:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee, this);
                }));
                function fetchToken(_x) {
                    return _fetchToken.apply(this, arguments);
                }
                return fetchToken;
            }()
        },
        {
            key: "isTokenExpired",
            value: function isTokenExpired(token) {
                var currentTimeInSeconds = new Date().getTime() / 1000;
                return token.data.iat + token.data.expiresIn - currentTimeInSeconds < 0;
            }
        }
    ]);
}();

});

parcelRegister("12BvN", function(module, exports) {

var $iKwew = parcelRequire("iKwew");
module.exports = Promise.all([
    $iKwew("luur8"),
    $iKwew("kipOH")
]).then(()=>parcelRequire('23Eem'));

});



parcelRegister("3cF57", function(module, exports) {
$parcel$export(module.exports, "MediaClientContext", () => $25525c0bf34b7183$export$ba5d7212f2b4619f);

var $5FkrB = parcelRequire("5FkrB");

var $lknPo = parcelRequire("lknPo");
var $25525c0bf34b7183$export$ba5d7212f2b4619f = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createContext(undefined);
var $25525c0bf34b7183$export$5bff351c86f56d97 = function MediaClientProvider(_ref) {
    var children = _ref.children, clientConfig = _ref.clientConfig;
    var mediaClient = (0, $5FkrB.useMemo)(function() {
        return (0, $lknPo.getMediaClient)(clientConfig);
    }, [
        clientConfig
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement($25525c0bf34b7183$export$ba5d7212f2b4619f.Provider, {
        value: mediaClient
    }, children);
};

});

parcelRegister("lVo0h", function(module, exports) {
$parcel$export(module.exports, "ActiveHeaderIdProvider", () => $ff618a72c80bcd34$export$20439b49fdd0d26c);
$parcel$export(module.exports, "ActiveHeaderIdConsumer", () => $ff618a72c80bcd34$export$cddc3c6ebe2d2cec);

var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");
var $ff618a72c80bcd34$var$_React$createContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createContext(undefined), $ff618a72c80bcd34$export$20439b49fdd0d26c = $ff618a72c80bcd34$var$_React$createContext.Provider, $ff618a72c80bcd34$var$Consumer = $ff618a72c80bcd34$var$_React$createContext.Consumer;
/**
 * We need to expose this abstraction on top of the native Consumer in order to control when
 * The consumer will get notified when a match has happened. If we use the Consumer directly in
 * Expand components without this inner state, everytime a new prop comes in, and the `newActiveHeaderId`
 * is the same as before, we will set the expand to true forever, until the active header id changes.
 * Thus, the user won't be able to collapse the expand.
 *
 * By exposing `onNestedHeaderIdMatch` here we can control when will consumers be notified:
 * only when a `newActiveHeaderId` comes in from the Provider and the list of header ids includes it.
 */ var $ff618a72c80bcd34$export$cddc3c6ebe2d2cec = function ActiveHeaderIdConsumer(_ref) {
    var nestedHeaderIds = _ref.nestedHeaderIds, onNestedHeaderIdMatch = _ref.onNestedHeaderIdMatch;
    var _useState = (0, $5FkrB.useState)(), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), activeHeaderId = _useState2[0], setActiveHeaderId = _useState2[1];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement($ff618a72c80bcd34$var$Consumer, null, function(newActiveHeaderId) {
        if (!newActiveHeaderId || !nestedHeaderIds.includes(newActiveHeaderId)) setActiveHeaderId(undefined);
        else if (newActiveHeaderId !== activeHeaderId && nestedHeaderIds.includes(newActiveHeaderId)) {
            setActiveHeaderId(newActiveHeaderId);
            onNestedHeaderIdMatch();
        }
        return null;
    });
};

});

parcelRegister("a4VNM", function(module, exports) {
$parcel$export(module.exports, "fileCardImageViewSelector", () => $75671d5fe47f5d71$export$7a6526d4be3b7eb3);
var $75671d5fe47f5d71$export$7a6526d4be3b7eb3 = 'media-file-card-view';
var $75671d5fe47f5d71$export$1b2a6cb6a124ba37 = 'media-file-card-view-selected';

});

parcelRegister("eTqtO", function(module, exports) {
$parcel$export(module.exports, "mediaViewerPopupClass", () => $ad7abe14c5c27837$export$42c8d07e41ed1e74);
/**
 * Classname for the media viewer popup that appears adjacent to the editor div. Use this to check
 * if the media viewer has appeared.
 */ var $ad7abe14c5c27837$export$42c8d07e41ed1e74 = 'media-viewer-popup';

});

parcelRegister("eqmEx", function(module, exports) {
$parcel$export(module.exports, "expValEqualsNoExposure", () => $a80510c2c27ddc5b$export$63eebf86443a0a61);

var $77PRV = parcelRequire("77PRV");
function $a80510c2c27ddc5b$export$63eebf86443a0a61(experimentName, experimentParam, experimentExpectedValue) {
    var experimentDefaultValue = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
    return (0, $77PRV.expValEqualsInternal)(experimentName, experimentParam, experimentExpectedValue, experimentDefaultValue, false);
}

});

parcelRegister("5qFVM", function(module, exports) {
$parcel$export(module.exports, "INLINE_IMAGE_WRAPPER_CLASS_NAME", () => $3f3fe80f1045fc8d$export$dd2e16f83ae6aa78);
$parcel$export(module.exports, "INLINE_IMAGE_ASPECT_RATIO_CSS_VAR_KEY", () => $3f3fe80f1045fc8d$export$7ab34e219ce6eef);
$parcel$export(module.exports, "INLINE_IMAGE_BORDER_SIZE_CSS_VAR_KEY", () => $3f3fe80f1045fc8d$export$263a8a844c370a89);
$parcel$export(module.exports, "INLINE_IMAGE_BORDER_COLOR_CSS_VAR_KEY", () => $3f3fe80f1045fc8d$export$b0d1f1e1fb3c4b46);
$parcel$export(module.exports, "wrapperStyle", () => $3f3fe80f1045fc8d$export$c4d4f06a25de97f);
$parcel$export(module.exports, "selectedStyle", () => $3f3fe80f1045fc8d$export$a7abb1b3dc25813f);
$parcel$export(module.exports, "borderStyle", () => $3f3fe80f1045fc8d$export$4d0a7f76ad443516);

var $lAD7C = parcelRequire("lAD7C");

var $74Zh5 = parcelRequire("74Zh5");

var $5gDus = parcelRequire("5gDus");
var $3f3fe80f1045fc8d$var$_templateObject, $3f3fe80f1045fc8d$var$_templateObject2;
var $3f3fe80f1045fc8d$export$dd2e16f83ae6aa78 = 'media-inline-image-wrapper';
var $3f3fe80f1045fc8d$export$7ab34e219ce6eef = '--editor-media-inline-image-aspect-ratio';
var $3f3fe80f1045fc8d$export$263a8a844c370a89 = '--editor-media-inline-image-border-size';
var $3f3fe80f1045fc8d$export$b0d1f1e1fb3c4b46 = '--editor-media-inline-image-border-color';
// We implemented such selectors to ensure specificity:
// eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- Nested and dynamic css calls are violations, needs manual remediation
var $3f3fe80f1045fc8d$var$inlineImageHeight = function inlineImageHeight(height) {
    var margin = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    return (0, $74Zh5.css)($3f3fe80f1045fc8d$var$_templateObject || ($3f3fe80f1045fc8d$var$_templateObject = (0, (/*@__PURE__*/$parcel$interopDefault($lAD7C)))([
        "\n\t/* Editor style */\n\t> .mediaInlineView-content-wrap > .",
        ",\n  > :is(a, span[data-mark-type='border']) .mediaInlineView-content-wrap > .",
        ",\n  /* Renderer style */\n  > .",
        ",\n  > :is(a, span[data-mark-type='border']) .",
        " {\n\t\theight: ",
        "px;\n\t\ttransform: translateY(",
        "px);\n\t}\n"
    ])), $3f3fe80f1045fc8d$export$dd2e16f83ae6aa78, $3f3fe80f1045fc8d$export$dd2e16f83ae6aa78, $3f3fe80f1045fc8d$export$dd2e16f83ae6aa78, $3f3fe80f1045fc8d$export$dd2e16f83ae6aa78, height, margin);
};
var $3f3fe80f1045fc8d$export$dee15762144889b7 = (0, $74Zh5.css)($3f3fe80f1045fc8d$var$_templateObject2 || ($3f3fe80f1045fc8d$var$_templateObject2 = (0, (/*@__PURE__*/$parcel$interopDefault($lAD7C)))([
    "\n\t/* p, h3, and action items */\n\t.",
    " {\n\t\theight: ",
    "px;\n\t\ttransform: translateY(-2px);\n\t}\n\n\th1 {\n\t\t",
    "\n\t}\n\n\th2 {\n\t\t",
    "\n\t}\n\n\th3 {\n\t\t",
    "\n\t}\n\n\th4 {\n\t\t",
    "\n\t}\n\n\th5 {\n\t\t",
    "\n\t}\n\n\th6 {\n\t\t",
    "\n\t}\n"
])), $3f3fe80f1045fc8d$export$dd2e16f83ae6aa78, (0, $5gDus.referenceHeights)['p'], $3f3fe80f1045fc8d$var$inlineImageHeight((0, $5gDus.referenceHeights)['h1'], -3), $3f3fe80f1045fc8d$var$inlineImageHeight((0, $5gDus.referenceHeights)['h2'], -3), $3f3fe80f1045fc8d$var$inlineImageHeight((0, $5gDus.referenceHeights)['h3'], -2), $3f3fe80f1045fc8d$var$inlineImageHeight((0, $5gDus.referenceHeights)['h4'], -2), $3f3fe80f1045fc8d$var$inlineImageHeight((0, $5gDus.referenceHeights)['h5'], -2), $3f3fe80f1045fc8d$var$inlineImageHeight((0, $5gDus.referenceHeights)['h6'], -2));
var $3f3fe80f1045fc8d$export$c4d4f06a25de97f = (0, $74Zh5.css)({
    display: 'inline-flex',
    cursor: 'pointer',
    justifyContent: 'center',
    alignItems: 'center',
    verticalAlign: 'middle',
    overflow: 'hidden',
    borderRadius: "var(--ds-radius-small, 3px)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    aspectRatio: "var(".concat($3f3fe80f1045fc8d$export$7ab34e219ce6eef, ", ").concat((0, $5gDus.DEFAULT_INLINE_IMAGE_ASPECT_RATIO), ")"),
    maxWidth: '100%'
});
var $3f3fe80f1045fc8d$export$a7abb1b3dc25813f = (0, $74Zh5.css)({
    boxShadow: "0 0 0 1px ".concat("var(--ds-border-selected, #1868DB)"),
    outline: 'none'
});
var $3f3fe80f1045fc8d$export$4d0a7f76ad443516 = (0, $74Zh5.css)({
    borderColor: "var(".concat($3f3fe80f1045fc8d$export$b0d1f1e1fb3c4b46, ")"),
    borderStyle: 'solid',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    borderRadius: "calc(var(".concat($3f3fe80f1045fc8d$export$263a8a844c370a89, ", ").concat((0, $5gDus.DEFAULT_INLINE_IMAGE_BORDER_SIZE), ") * 2px)"),
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    borderWidth: "calc(var(".concat($3f3fe80f1045fc8d$export$263a8a844c370a89, ", ").concat((0, $5gDus.DEFAULT_INLINE_IMAGE_BORDER_SIZE), ") * 1px)"),
    boxSizing: "border-box"
});

});
parcelRegister("5gDus", function(module, exports) {
$parcel$export(module.exports, "DEFAULT_INLINE_IMAGE_ASPECT_RATIO", () => $3d5d144fcea2bce0$export$286cf28b87ad4b4f);
$parcel$export(module.exports, "DEFAULT_INLINE_IMAGE_BORDER_SIZE", () => $3d5d144fcea2bce0$export$64fe09732fb8680);
$parcel$export(module.exports, "referenceHeights", () => $3d5d144fcea2bce0$export$c1317a9224e4d798);
var $3d5d144fcea2bce0$export$d722b7527b1834a8 = 250;
var $3d5d144fcea2bce0$export$da894f7669b4e67c = 200;
var $3d5d144fcea2bce0$export$286cf28b87ad4b4f = $3d5d144fcea2bce0$export$d722b7527b1834a8 / $3d5d144fcea2bce0$export$da894f7669b4e67c;
var $3d5d144fcea2bce0$export$64fe09732fb8680 = 0;
var $3d5d144fcea2bce0$export$c1317a9224e4d798 = {
    p: 22,
    h1: 36,
    h2: 31,
    h3: 25,
    h4: 23,
    h5: 20,
    h6: 18
};

});


parcelRegister("hyfkz", function(module, exports) {
$parcel$export(module.exports, "DateSharedCssClassName", () => $cc71810a0ba0d0fe$export$99cdf122d0bb9f95);
var $cc71810a0ba0d0fe$export$99cdf122d0bb9f95 = {
    DATE_WRAPPER: "date-lozenger-container",
    DATE_CONTAINER: 'dateView-content-wrap'
};

});

parcelRegister("7J4nJ", function(module, exports) {
$parcel$export(module.exports, "LightWeightCodeBlockCssClassName", () => $5a00227b8693b7ab$export$afbde0e7339bed51);
$parcel$export(module.exports, "default", () => $5a00227b8693b7ab$export$2e2bcd8739ae039);

var $lAD7C = parcelRequire("lAD7C");

var $25nEq = parcelRequire("25nEq");

var $5FkrB = parcelRequire("5FkrB");

var $74Zh5 = parcelRequire("74Zh5");

var $1LBcl = parcelRequire("1LBcl");
var $5wL5P = parcelRequire("5wL5P");

var $knSf2 = parcelRequire("knSf2");

var $6S1Go = parcelRequire("6S1Go");

var $53SBn = parcelRequire("53SBn");
var $5a00227b8693b7ab$var$_templateObject;
var $5a00227b8693b7ab$var$codeBlockSharedStyles = (0, $74Zh5.css)((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, ".".concat((0, $knSf2.CodeBlockSharedCssClassName).CODEBLOCK_CONTENT_WRAPPED, "\n\t\t> .").concat((0, $knSf2.CodeBlockSharedCssClassName).CODEBLOCK_CONTENT_WRAPPER, "\n\t\t> .").concat((0, $knSf2.CodeBlockSharedCssClassName).CODEBLOCK_CONTENT), {
    marginRight: "var(--ds-space-100, 8px)",
    code: {
        display: 'block',
        wordBreak: 'break-word',
        whiteSpace: 'pre-wrap'
    }
}), ".".concat((0, $knSf2.CodeBlockSharedCssClassName).CODEBLOCK_CONTENT_WRAPPER, "\n\t\t> .").concat((0, $knSf2.CodeBlockSharedCssClassName).CODEBLOCK_CONTENT), {
    display: 'flex',
    flex: 1,
    code: {
        flexGrow: 1,
        whiteSpace: 'pre'
    }
}), ".".concat((0, $knSf2.CodeBlockSharedCssClassName).CODEBLOCK_CONTAINER), (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({
    position: 'relative',
    backgroundColor: "var(--ds-surface-raised, #FFFFFF)",
    borderRadius: "var(--ds-radius-small, 3px)",
    margin: "".concat((0, $1LBcl.blockNodesVerticalMargin), " 0 0 0"),
    fontFamily: "var(--ds-font-family-code, ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)",
    minWidth: "".concat((0, $1LBcl.akEditorTableCellMinWidth), "px"),
    cursor: 'pointer',
    clear: 'both',
    '--ds--code--bg-color': 'transparent',
    '.code-block-gutter-pseudo-element::before': {
        content: '"attr(data-label)"'
    },
    /* This is necessary to allow for arrow key navigation in/out of code blocks in Firefox. */ whiteSpace: 'normal'
}, ".".concat((0, $knSf2.CodeBlockSharedCssClassName).CODEBLOCK_START), {
    position: 'absolute',
    visibility: 'hidden',
    height: '1.5rem',
    top: '0px',
    left: '0px'
}), "".concat((0, $knSf2.CodeBlockSharedCssClassName).CODEBLOCK_END), {
    position: 'absolute',
    visibility: 'hidden',
    height: '1.5rem',
    bottom: '0px',
    right: '0px'
}), ".".concat((0, $knSf2.CodeBlockSharedCssClassName).CODEBLOCK_CONTENT_WRAPPER), {
    position: 'relative',
    backgroundColor: "var(--ds-background-neutral, #0515240F)",
    display: 'flex',
    borderRadius: "var(--ds-radius-small, 3px)",
    width: '100%',
    counterReset: 'line',
    overflowX: 'auto',
    backgroundImage: 'var(--ak-renderer-codeblock-content-wrapper-bg-img)',
    backgroundRepeat: 'no-repeat',
    backgroundAttachment: 'local, local, local, local, scroll, scroll, scroll, scroll',
    backgroundSize: "var(--ds-space-300, 24px)".concat(" 100%,\n\t\t\t\t", "var(--ds-space-300, 24px)", " 100%,\n\t\t\t\t", "var(--ds-space-100, 8px)", " 100%,\n\t\t\t\t", "var(--ds-space-100, 8px)", " 100%,\n\t\t\t\t", "var(--ds-space-100, 8px)", " 100%,\n\t\t\t\t1px 100%,\n\t\t\t\t", "var(--ds-space-100, 8px)", " 100%,\n\t\t\t\t1px 100%"),
    backgroundPosition: "0 0,\n\t\t\t\t0 0,\n\t\t\t\t100% 0,\n\t\t\t\t100% 0,\n\t\t\t\t100% 0,\n\t\t\t\t100% 0,\n\t\t\t\t0 0,\n\t\t\t\t0 0",
    /* Be careful if refactoring this; it is needed to keep arrow key navigation in Firefox consistent with other browsers. */ overflowY: 'hidden'
}), ".".concat((0, $knSf2.CodeBlockSharedCssClassName).CODEBLOCK_LINE_NUMBER_GUTTER), {
    backgroundColor: "var(--ds-background-neutral, #0515240F)",
    position: 'relative',
    width: 'var(--lineNumberGutterWidth, 2rem)',
    padding: "var(--ds-space-100, 8px)",
    flexShrink: 0,
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    fontSize: "".concat(0.875, "rem"),
    boxSizing: 'content-box'
}), ".".concat((0, $knSf2.CodeBlockSharedCssClassName).CODEBLOCK_LINE_NUMBER_GUTTER, "::before"), {
    content: '"1"',
    visibility: 'hidden',
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    fontSize: "".concat(0.875, "rem"),
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: '1.5rem'
}), ".".concat((0, $knSf2.CodeBlockSharedCssClassName).CODEBLOCK_CONTENT), {
    code: {
        tabSize: 4,
        cursor: 'text',
        color: "var(--ds-text, #292A2E)",
        borderRadius: "var(--ds-radius-small, 3px)",
        margin: "var(--ds-space-100, 8px)",
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        fontSize: "".concat(0.875, "rem"),
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        lineHeight: '1.5rem'
    }
}), ".".concat((0, $knSf2.CodeBlockSharedCssClassName).CODEBLOCK_CONTAINER_LINE_NUMBER_WIDGET), {
    pointerEvents: 'none',
    userSelect: 'none',
    width: 'var(--lineNumberGutterWidth, 2rem)',
    left: 0,
    position: 'absolute',
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    fontSize: "".concat(0.875, "rem"),
    padding: "0px ".concat("var(--ds-space-100, 8px)"),
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: '1.5rem',
    textAlign: 'right',
    color: "var(--ds-text-subtlest, #505F79)",
    boxSizing: 'content-box'
})));
var $5a00227b8693b7ab$var$lightWeightCodeBlockStyles = (0, $74Zh5.css)((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, ".".concat((0, $knSf2.CodeBlockSharedCssClassName).CODEBLOCK_CONTAINER), {
    cursor: 'text'
}));
var $5a00227b8693b7ab$export$afbde0e7339bed51 = {
    CONTAINER: 'light-weight-code-block'
};
var $5a00227b8693b7ab$export$3f1ff491ca7c4c4a = function getLightWeightCodeBlockStylesForRootRendererStyleSheet() {
    // We overwrite the rule that clears margin-top for first nested codeblocks, as
    // our lightweight codeblock dom structure will always nest the codeblock inside
    // an extra container div which would constantly be targeted. Now, top-level
    // lightweight codeblock containers will not be targeted.
    // NOTE: This must be added after other .code-block styles in the root
    // Renderer stylesheet.
    // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- needs manual remediation
    return (0, $74Zh5.css)($5a00227b8693b7ab$var$_templateObject || ($5a00227b8693b7ab$var$_templateObject = (0, (/*@__PURE__*/$parcel$interopDefault($lAD7C)))([
        "\n\t\t.",
        "\n\t\t\t> .",
        "\n\t\t\t.",
        " {\n\t\t\tmargin-top: ",
        ";\n\t\t}\n\t"
    ])), (0, $53SBn.RendererCssClassName).DOCUMENT, $5a00227b8693b7ab$export$afbde0e7339bed51.CONTAINER, (0, $knSf2.CodeBlockSharedCssClassName).CODEBLOCK_CONTAINER, (0, $1LBcl.blockNodesVerticalMargin));
};
var $5a00227b8693b7ab$var$LightWeightCodeBlock = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function(_ref, ref) {
    var text = _ref.text, _ref$codeBidiWarningT = _ref.codeBidiWarningTooltipEnabled, codeBidiWarningTooltipEnabled = _ref$codeBidiWarningT === void 0 ? true : _ref$codeBidiWarningT, className = _ref.className;
    var textRows = (0, $5FkrB.useMemo)(function() {
        return (text !== null && text !== void 0 ? text : '').split('\n');
    }, [
        text
    ]);
    var _useBidiWarnings = (0, $6S1Go.useBidiWarnings)({
        enableWarningTooltip: codeBidiWarningTooltipEnabled
    }), renderBidiWarnings = _useBidiWarnings.renderBidiWarnings;
    var classNames = [
        $5a00227b8693b7ab$export$afbde0e7339bed51.CONTAINER,
        className
    ].join(' ');
    var codeBlockBackgroundImage = (0, $5wL5P.overflowShadow)({
        leftCoverWidth: "var(--ds-space-300, 24px)"
    });
    return (0, $74Zh5.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: classNames,
        ref: ref,
        css: [
            $5a00227b8693b7ab$var$codeBlockSharedStyles,
            $5a00227b8693b7ab$var$lightWeightCodeBlockStyles
        ],
        style: {
            '--ak-renderer-codeblock-content-wrapper-bg-img': codeBlockBackgroundImage
        }
    }, (0, $74Zh5.jsx)("div", {
        className: (0, $knSf2.CodeBlockSharedCssClassName).CODEBLOCK_CONTAINER
    }, (0, $74Zh5.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $knSf2.CodeBlockSharedCssClassName).CODEBLOCK_CONTENT_WRAPPER
    }, (0, $74Zh5.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $knSf2.CodeBlockSharedCssClassName).CODEBLOCK_LINE_NUMBER_GUTTER
    }, textRows.map(function(_, index) {
        return(// Ignored via go/ees005
        // eslint-disable-next-line react/no-array-index-key
        (0, $74Zh5.jsx)("span", {
            key: index
        }));
    })), (0, $74Zh5.jsx)("div", {
        className: (0, $knSf2.CodeBlockSharedCssClassName).CODEBLOCK_CONTENT
    }, (0, $74Zh5.jsx)("code", null, renderBidiWarnings(text))))));
});
var $5a00227b8693b7ab$export$2e2bcd8739ae039 = $5a00227b8693b7ab$var$LightWeightCodeBlock;

});
parcelRegister("6S1Go", function(module, exports) {
$parcel$export(module.exports, "useBidiWarnings", () => $50091766545dcc84$export$9fb9fe546a188c7b);

var $5FkrB = parcelRequire("5FkrB");

var $6Wx3K = parcelRequire("6Wx3K");

var $l23cj = parcelRequire("l23cj");

var $6qzXE = parcelRequire("6qzXE");

var $deLXP = parcelRequire("deLXP");

var $drUcN = parcelRequire("drUcN");
var $50091766545dcc84$export$9fb9fe546a188c7b = function useBidiWarnings(_ref) {
    var _ref$enableWarningToo = _ref.enableWarningTooltip, enableWarningTooltip = _ref$enableWarningToo === void 0 ? true : _ref$enableWarningToo;
    var intl = (0, $6Wx3K.default)();
    var warningLabel = intl.formatMessage((0, $6qzXE.codeBidiWarningMessages).label);
    var renderBidiWarnings = function renderBidiWarnings(text) {
        if ((0, $drUcN.expValEquals)('platform_editor_remove_bidi_char_warning', 'isEnabled', true)) return text;
        return (0, $deLXP.default)(text, function(_ref2) {
            var bidiCharacter = _ref2.bidiCharacter, index = _ref2.index;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $l23cj.default), {
                bidiCharacter: bidiCharacter,
                key: index,
                label: warningLabel,
                tooltipEnabled: enableWarningTooltip
            });
        });
    };
    return {
        renderBidiWarnings: renderBidiWarnings,
        warningLabel: warningLabel
    };
};

});


parcelRegister("9DPK6", function(module, exports) {
$parcel$export(module.exports, "customCategory", () => $704fe49252f7647d$export$5e4e3d1c3e43156a);
$parcel$export(module.exports, "frequentCategory", () => $704fe49252f7647d$export$78ccdc4be403c468);
$parcel$export(module.exports, "dataURLPrefix", () => $704fe49252f7647d$export$8ac325bfd32359b0);
$parcel$export(module.exports, "deleteEmojiLabel", () => $704fe49252f7647d$export$a330961542edfe6f);
$parcel$export(module.exports, "MAX_ORDINAL", () => $704fe49252f7647d$export$1a817f1886276c6d);
$parcel$export(module.exports, "scaledEmojiHeightH1", () => $704fe49252f7647d$export$2e7088017339c92);
$parcel$export(module.exports, "scaledEmojiHeightH2", () => $704fe49252f7647d$export$4cb591b57c224c0);
$parcel$export(module.exports, "scaledEmojiHeightH3", () => $704fe49252f7647d$export$b31a41e904161dc1);
$parcel$export(module.exports, "scaledEmojiHeightH4", () => $704fe49252f7647d$export$7dd039b460c61389);
$parcel$export(module.exports, "denseEmojiHeightH1", () => $704fe49252f7647d$export$96ee6614460413a0);
$parcel$export(module.exports, "denseEmojiHeightH2", () => $704fe49252f7647d$export$103771a4cd74af90);
$parcel$export(module.exports, "denseEmojiHeightH3", () => $704fe49252f7647d$export$5cc2afcf38309ce9);
$parcel$export(module.exports, "denseEmojiHeightH4", () => $704fe49252f7647d$export$9a9984214a4bd724);
$parcel$export(module.exports, "defaultEmojiHeight", () => $704fe49252f7647d$export$3f99ac31dc0406db);
$parcel$export(module.exports, "defaultDenseEmojiHeight", () => $704fe49252f7647d$export$8efb414216030943);
$parcel$export(module.exports, "localStoragePrefix", () => $704fe49252f7647d$export$e394a0c530ae5631);
$parcel$export(module.exports, "selectedToneStorageKey", () => $704fe49252f7647d$export$79ee4ef84c545f8f);
$parcel$export(module.exports, "defaultCategories", () => $704fe49252f7647d$export$d7ab74456f1aa1ad);
$parcel$export(module.exports, "KeyboardKeys", () => $704fe49252f7647d$export$70f9e5bc10d7eac);
$parcel$export(module.exports, "EMOJI_KEYBOARD_KEYS_SUPPORTED", () => $704fe49252f7647d$export$84b035f8d01101cc);
$parcel$export(module.exports, "SAMPLING_RATE_EMOJI_RENDERED_EXP", () => $704fe49252f7647d$export$83aab2ae64548423);
$parcel$export(module.exports, "SAMPLING_RATE_EMOJI_RESOURCE_FETCHED_EXP", () => $704fe49252f7647d$export$66cabad5e268b05e);
var $704fe49252f7647d$export$5e4e3d1c3e43156a = 'CUSTOM';
var $704fe49252f7647d$export$78ccdc4be403c468 = 'FREQUENT';
var $704fe49252f7647d$export$2c4b04c3aacdf1b3 = 'SITE';
var $704fe49252f7647d$export$1b0258512be88334 = 'SEARCH';
var $704fe49252f7647d$export$42b510423367f354 = 'USER_CUSTOM';
var $704fe49252f7647d$export$5d0f2d8ee50f86f5 = 'allUploadsCustomCategory';
var $704fe49252f7647d$export$1debc2f10cc69389 = 'userUploadsCustomCategory';
var $704fe49252f7647d$export$8ac325bfd32359b0 = 'data:';
var $704fe49252f7647d$export$a330961542edfe6f = 'delete-emoji';
var $704fe49252f7647d$export$1a817f1886276c6d = 100000;
var $704fe49252f7647d$export$2e7088017339c92 = 28;
var $704fe49252f7647d$export$4cb591b57c224c0 = 26;
var $704fe49252f7647d$export$b31a41e904161dc1 = 24;
var $704fe49252f7647d$export$7dd039b460c61389 = 22;
var $704fe49252f7647d$export$96ee6614460413a0 = 24.25;
var $704fe49252f7647d$export$103771a4cd74af90 = 22.25;
var $704fe49252f7647d$export$5cc2afcf38309ce9 = 20.25;
var $704fe49252f7647d$export$9a9984214a4bd724 = 18.25;
var $704fe49252f7647d$export$3f99ac31dc0406db = 20;
var $704fe49252f7647d$export$8efb414216030943 = 16.25;
var $704fe49252f7647d$export$d171dc12fee2b1da = 350;
var $704fe49252f7647d$export$c10ac8125a260041 = 80;
var $704fe49252f7647d$export$5248fb9e0cccc41f = 'medium';
var $704fe49252f7647d$export$94f75d625e7801d3 = 260;
var $704fe49252f7647d$export$7ed599d166d65aea = 295;
var $704fe49252f7647d$export$7722b8e9522021df = $704fe49252f7647d$export$7ed599d166d65aea - 58; // picker height - actions height
var $704fe49252f7647d$export$e218e5cb105a0e22 = 54;
var $704fe49252f7647d$export$e67f617938b111f1 = $704fe49252f7647d$export$7ed599d166d65aea + $704fe49252f7647d$export$e218e5cb105a0e22;
var $704fe49252f7647d$export$e394a0c530ae5631 = 'fabric.emoji';
var $704fe49252f7647d$export$79ee4ef84c545f8f = "".concat($704fe49252f7647d$export$e394a0c530ae5631, ".selectedTone");
var $704fe49252f7647d$export$d7ab74456f1aa1ad = [
    'PEOPLE',
    'NATURE',
    'FOODS',
    'ACTIVITY',
    'PLACES',
    'OBJECTS',
    'SYMBOLS',
    'FLAGS'
];
var $704fe49252f7647d$export$70f9e5bc10d7eac = /*#__PURE__*/ function(KeyboardKeys) {
    KeyboardKeys["ArrowLeft"] = "ArrowLeft";
    KeyboardKeys["ArrowRight"] = "ArrowRight";
    KeyboardKeys["ArrowUp"] = "ArrowUp";
    KeyboardKeys["ArrowDown"] = "ArrowDown";
    KeyboardKeys["PageUp"] = "PageUp";
    KeyboardKeys["PageDown"] = "PageDown";
    KeyboardKeys["Home"] = "Home";
    KeyboardKeys["End"] = "End";
    KeyboardKeys["Enter"] = "Enter";
    KeyboardKeys["Tab"] = "Tab";
    KeyboardKeys["Space"] = " ";
    KeyboardKeys["Backspace"] = "Backspace";
    return KeyboardKeys;
}({});
var $704fe49252f7647d$export$1c4f2adc1f8e19d3 = /*#__PURE__*/ function(KeyboardNavigationDirection) {
    KeyboardNavigationDirection["Down"] = "Down";
    KeyboardNavigationDirection["Up"] = "Up";
    KeyboardNavigationDirection["Left"] = "Left";
    KeyboardNavigationDirection["Right"] = "Right";
    return KeyboardNavigationDirection;
}({});
var $704fe49252f7647d$export$99130b698ea188ae = [
    $704fe49252f7647d$export$70f9e5bc10d7eac.ArrowRight,
    $704fe49252f7647d$export$70f9e5bc10d7eac.ArrowLeft,
    $704fe49252f7647d$export$70f9e5bc10d7eac.Home,
    $704fe49252f7647d$export$70f9e5bc10d7eac.End
];
var $704fe49252f7647d$export$84b035f8d01101cc = [
    $704fe49252f7647d$export$70f9e5bc10d7eac.Enter,
    $704fe49252f7647d$export$70f9e5bc10d7eac.Backspace,
    $704fe49252f7647d$export$70f9e5bc10d7eac.Space
];
var $704fe49252f7647d$export$e27d4e477c0cd4ec = [
    $704fe49252f7647d$export$70f9e5bc10d7eac.Enter,
    $704fe49252f7647d$export$70f9e5bc10d7eac.Tab,
    $704fe49252f7647d$export$70f9e5bc10d7eac.Space
];
var $704fe49252f7647d$export$97027974dc06eeee = [
    $704fe49252f7647d$export$70f9e5bc10d7eac.ArrowRight,
    $704fe49252f7647d$export$70f9e5bc10d7eac.ArrowLeft,
    $704fe49252f7647d$export$70f9e5bc10d7eac.Home,
    $704fe49252f7647d$export$70f9e5bc10d7eac.End,
    $704fe49252f7647d$export$70f9e5bc10d7eac.ArrowUp,
    $704fe49252f7647d$export$70f9e5bc10d7eac.ArrowDown,
    $704fe49252f7647d$export$70f9e5bc10d7eac.PageUp,
    $704fe49252f7647d$export$70f9e5bc10d7eac.PageDown
];
var $704fe49252f7647d$export$4f0ee90b28d6efc5 = 0;
var $704fe49252f7647d$export$9f7de4293d27f3aa = 50;
var $704fe49252f7647d$export$41388d9a435030e6 = 'hipchat_migration_emoticons';
var $704fe49252f7647d$export$273d18db3ba5f6b1 = 'atlassian.fabric.emoji.picker';
var $704fe49252f7647d$export$2829f3ec323f8ec0 = 8;
var $704fe49252f7647d$export$ce3a0e7d2d7d6ba2 = 5;
var $704fe49252f7647d$export$858e8dc100a97278 = 150;
var $704fe49252f7647d$export$83aab2ae64548423 = 20;
var $704fe49252f7647d$export$66cabad5e268b05e = 100;

});

parcelRegister("8Upo7", function(module, exports) {
$parcel$export(module.exports, "commonSelectedStyles", () => $67c73f3f32c78692$export$8633a0edef8e95dd);
$parcel$export(module.exports, "selectOnHoverStyles", () => $67c73f3f32c78692$export$860109dfd198259b);
$parcel$export(module.exports, "emojiSprite", () => $67c73f3f32c78692$export$1c10634420a08d8a);
$parcel$export(module.exports, "emojiNodeStyles", () => $67c73f3f32c78692$export$b06c4aab1d012063);
$parcel$export(module.exports, "emojiImage", () => $67c73f3f32c78692$export$da61cef1c8919f7c);
$parcel$export(module.exports, "emojiDeleteButton", () => $67c73f3f32c78692$export$b11fa39b56a371f6);
$parcel$export(module.exports, "emojiMainStyle", () => $67c73f3f32c78692$export$11462c0756c24ab6);
$parcel$export(module.exports, "deletableEmoji", () => $67c73f3f32c78692$export$22b19c311e9caa4);
$parcel$export(module.exports, "placeholder", () => $67c73f3f32c78692$export$c7187bbd1a7a9244);
var $67c73f3f32c78692$export$8633a0edef8e95dd = 'emoji-common-selected';
var $67c73f3f32c78692$export$860109dfd198259b = 'emoji-common-select-on-hover';
var $67c73f3f32c78692$export$1c10634420a08d8a = 'emoji-common-emoji-sprite';
var $67c73f3f32c78692$export$b06c4aab1d012063 = 'emoji-common-node';
var $67c73f3f32c78692$export$da61cef1c8919f7c = 'emoji-common-emoji-image';
var $67c73f3f32c78692$export$b11fa39b56a371f6 = 'emoji-common-deleteButton';
var $67c73f3f32c78692$export$11462c0756c24ab6 = 'emoji-common-main-styles';
var $67c73f3f32c78692$export$22b19c311e9caa4 = 'emoji-common-deletable';
var $67c73f3f32c78692$export$c7187bbd1a7a9244 = 'emoji-common-placeholder';
var $67c73f3f32c78692$export$b0fe756d87022806 = 'emoji-picker-add-emoji';

});

parcelRegister("aOpeL", function(module, exports) {
$parcel$export(module.exports, "PortalContext", () => $7df22672e154e506$export$60d741e20e0aa309);
$parcel$export(module.exports, "usePortal", () => $7df22672e154e506$export$b1072f43c67b540c);

var $5FkrB = parcelRequire("5FkrB");
var $7df22672e154e506$export$60d741e20e0aa309 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createContext(undefined);
function $7df22672e154e506$export$b1072f43c67b540c(props) {
    var portalFromContext = (0, $5FkrB.useContext)($7df22672e154e506$export$60d741e20e0aa309);
    return (props === null || props === void 0 ? void 0 : props.portal) || portalFromContext;
}

});

parcelRegister("c4Up0", function(module, exports) {
"use strict";
var $8cb19c1afc4eedec$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.useExperimentValue = module.exports.useFeatureGate = void 0;

var $5FkrB = parcelRequire("5FkrB");

const $8cb19c1afc4eedec$var$feature_gate_js_client_1 = $8cb19c1afc4eedec$var$__importDefault((parcelRequire("jcX3Q")));
const $8cb19c1afc4eedec$var$useFeatureGate = (gateName, options = {})=>{
    const [gate, setGate] = (0, $5FkrB.useState)(()=>$8cb19c1afc4eedec$var$feature_gate_js_client_1.default.checkGate(gateName, options));
    (0, $5FkrB.useEffect)(()=>{
        const onGateChange = (newValue)=>setGate(newValue);
        return $8cb19c1afc4eedec$var$feature_gate_js_client_1.default.onGateUpdated(gateName, onGateChange, options);
    }, [
        gateName,
        options
    ]);
    return gate;
};
module.exports.useFeatureGate = $8cb19c1afc4eedec$var$useFeatureGate;
// eslint-disable-next-line @typescript-eslint/no-unnecessary-type-constraint
const $8cb19c1afc4eedec$var$useExperimentValue = (experimentName, parameterName, defaultValue, options = {})=>{
    const [experimentValue, setExperimentValue] = (0, $5FkrB.useState)(()=>$8cb19c1afc4eedec$var$feature_gate_js_client_1.default.getExperimentValue(experimentName, parameterName, defaultValue, options));
    (0, $5FkrB.useEffect)(()=>{
        const onExperimentValueChange = (newValue)=>setExperimentValue(newValue);
        return $8cb19c1afc4eedec$var$feature_gate_js_client_1.default.onExperimentValueUpdated(experimentName, parameterName, defaultValue, onExperimentValueChange, options);
    }, [
        experimentName,
        parameterName,
        defaultValue,
        options
    ]);
    return experimentValue;
};
module.exports.useExperimentValue = $8cb19c1afc4eedec$var$useExperimentValue;

});
parcelRegister("jcX3Q", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => (parcelRequire("ISKn7")).default);
$parcel$export(module.exports, "FeatureGateEnvironment", () => (parcelRequire("hiARP")).FeatureGateEnvironment);
$parcel$export(module.exports, "PerimeterType", () => (parcelRequire("hiARP")).PerimeterType);
$parcel$export(module.exports, "CLIENT_VERSION", () => (parcelRequire("7HOhT")).CLIENT_VERSION);
$parcel$export(module.exports, "DynamicConfig", () => (parcelRequire("kkQZA")).DynamicConfig);
$parcel$export(module.exports, "Layer", () => (parcelRequire("eVlof")).Layer);
$parcel$export(module.exports, "EvaluationReason", () => (parcelRequire("48eYA")).EvaluationReason);
parcelRequire("ISKn7");
var $7HOhT = parcelRequire("7HOhT");
var $ISKn7 = parcelRequire("ISKn7");
var $hiARP = parcelRequire("hiARP");

var $kkQZA = parcelRequire("kkQZA");

var $eVlof = parcelRequire("eVlof");

var $48eYA = parcelRequire("48eYA");

});


parcelRegister("fb6VX", function(module, exports) {
"use strict";
var $b0cd42ffbfb0b3a7$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.FeatureGatesInitialization = void 0;

var $5FkrB = parcelRequire("5FkrB");

const $b0cd42ffbfb0b3a7$var$feature_gate_js_client_1 = $b0cd42ffbfb0b3a7$var$__importDefault((parcelRequire("jcX3Q")));

var $14MvJ = parcelRequire("14MvJ");
/**
 * This component initializes the @atlassian/feature-flag-js-client by fetching the gate and experiment
 * evaluations for the given user, and blocks rendering of the children until the rendering is complete.
 */ const $b0cd42ffbfb0b3a7$var$FeatureGatesInitialization = ({ children: children, enabled: enabled = true, identifiers: identifiers, customAttributes: customAttributes, options: options, initializingComponent: initializingComponent, overrides: overrides, onReady: onReady })=>{
    // Rather than checking the state of all overrides, we can just assume that if overrides are provided
    // then some sort of update will need to be performed, and hold off rendering until the useEffect is run.
    const [isInitialized, setInitialized] = (0, $5FkrB.useState)(!overrides && (0, $14MvJ.isClientAlreadyInCorrectState)(identifiers, customAttributes));
    // Use a ref for the options, so that we can use them within the following useEffect
    // without adding options as a dependency.
    // This avoids the user updating every time an option is changed.
    const optionsRef = (0, $5FkrB.useRef)(options);
    (0, $5FkrB.useEffect)(()=>{
        optionsRef.current = options;
    }, [
        options
    ]);
    (0, $5FkrB.useEffect)(()=>{
        if (enabled) {
            if ((0, $14MvJ.isClientAlreadyInCorrectState)(identifiers, customAttributes)) {
                (0, $14MvJ.applyOverrides)(overrides);
                setInitialized(true);
                onReady === null || onReady === void 0 || onReady();
            } else {
                setInitialized(false);
                const initPromise = $b0cd42ffbfb0b3a7$var$feature_gate_js_client_1.default.initializeCalled() ? $b0cd42ffbfb0b3a7$var$feature_gate_js_client_1.default.updateUser(optionsRef.current, identifiers, customAttributes) : $b0cd42ffbfb0b3a7$var$feature_gate_js_client_1.default.initialize(optionsRef.current, identifiers, customAttributes);
                initPromise.catch((err)=>(0, $14MvJ.toError)(err)).then((err)=>{
                    setInitialized(true);
                    (0, $14MvJ.applyOverrides)(overrides);
                    onReady === null || onReady === void 0 || onReady(err || undefined);
                });
            }
        } else {
            setInitialized(true);
            onReady === null || onReady === void 0 || onReady();
        }
        return ()=>(0, $14MvJ.clearOverrides)(overrides);
    }, [
        enabled,
        identifiers,
        customAttributes,
        overrides
    ]);
    return (0, $14MvJ.pickChildToRender)(enabled, isInitialized, children, initializingComponent);
};
module.exports.FeatureGatesInitialization = $b0cd42ffbfb0b3a7$var$FeatureGatesInitialization;
module.exports.default = module.exports.FeatureGatesInitialization;

});
parcelRegister("14MvJ", function(module, exports) {
"use strict";
var $0c8bcb631f9fa522$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isClientAlreadyInCorrectState = $0c8bcb631f9fa522$var$isClientAlreadyInCorrectState;
module.exports.pickChildToRender = $0c8bcb631f9fa522$var$pickChildToRender;
module.exports.toError = $0c8bcb631f9fa522$var$toError;
module.exports.applyOverrides = $0c8bcb631f9fa522$var$applyOverrides;
module.exports.clearOverrides = $0c8bcb631f9fa522$var$clearOverrides;

const $0c8bcb631f9fa522$var$react_1 = $0c8bcb631f9fa522$var$__importDefault((parcelRequire("5FkrB")));

const $0c8bcb631f9fa522$var$feature_gate_js_client_1 = $0c8bcb631f9fa522$var$__importDefault((parcelRequire("jcX3Q")));
let $0c8bcb631f9fa522$var$hasWarnedAboutMissingOverrideSupport = false;
function $0c8bcb631f9fa522$var$isClientAlreadyInCorrectState(identifiers, customAttributes) {
    var _a, _b;
    // If either of these methods don't exist (ie. if the product is using <v4.2.0), then this method will always return false
    return ((_a = $0c8bcb631f9fa522$var$feature_gate_js_client_1.default.initializeCompleted) === null || _a === void 0 ? void 0 : _a.call($0c8bcb631f9fa522$var$feature_gate_js_client_1.default)) && ((_b = $0c8bcb631f9fa522$var$feature_gate_js_client_1.default.isCurrentUser) === null || _b === void 0 ? void 0 : _b.call($0c8bcb631f9fa522$var$feature_gate_js_client_1.default, identifiers, customAttributes));
}
function $0c8bcb631f9fa522$var$pickChildToRender(enabled, isInitialized, children, initializingComponent) {
    if (!enabled || isInitialized) return $0c8bcb631f9fa522$var$react_1.default.createElement($0c8bcb631f9fa522$var$react_1.default.Fragment, null, children);
    if (initializingComponent != null) return $0c8bcb631f9fa522$var$react_1.default.createElement($0c8bcb631f9fa522$var$react_1.default.Fragment, null, initializingComponent);
    return null;
}
function $0c8bcb631f9fa522$var$toError(err) {
    if (err instanceof Error) return err;
    return new Error(err === null || err === void 0 ? void 0 : err.toString());
}
function $0c8bcb631f9fa522$var$applyOverrides(overrides) {
    // Allow newer versions of the React SDK to be used with older v3.x JS client versions,
    // provided the caller does not try to leverage the overrides which were introduced in v4.
    if (overrides && (!$0c8bcb631f9fa522$var$feature_gate_js_client_1.default.overrideGate || !$0c8bcb631f9fa522$var$feature_gate_js_client_1.default.overrideConfig)) {
        if (!$0c8bcb631f9fa522$var$hasWarnedAboutMissingOverrideSupport) {
            console.warn('Overrides are only supported in @atlaskit/feature-gate-js-client v4.0.0+');
            $0c8bcb631f9fa522$var$hasWarnedAboutMissingOverrideSupport = true;
        }
        return;
    }
    Object.entries((overrides === null || overrides === void 0 ? void 0 : overrides.gates) || {}).forEach(([gateName, value])=>{
        var _a;
        (_a = $0c8bcb631f9fa522$var$feature_gate_js_client_1.default.overrideGate) === null || _a === void 0 || _a.call($0c8bcb631f9fa522$var$feature_gate_js_client_1.default, gateName, value);
    });
    Object.entries((overrides === null || overrides === void 0 ? void 0 : overrides.configs) || {}).forEach(([configName, values])=>{
        var _a;
        (_a = $0c8bcb631f9fa522$var$feature_gate_js_client_1.default.overrideConfig) === null || _a === void 0 || _a.call($0c8bcb631f9fa522$var$feature_gate_js_client_1.default, configName, values);
    });
}
function $0c8bcb631f9fa522$var$clearOverrides(overrides) {
    Object.keys((overrides === null || overrides === void 0 ? void 0 : overrides.gates) || {}).forEach((gateName)=>{
        var _a;
        (_a = $0c8bcb631f9fa522$var$feature_gate_js_client_1.default.clearGateOverride) === null || _a === void 0 || _a.call($0c8bcb631f9fa522$var$feature_gate_js_client_1.default, gateName);
    });
    Object.keys((overrides === null || overrides === void 0 ? void 0 : overrides.configs) || {}).forEach((configName)=>{
        var _a;
        (_a = $0c8bcb631f9fa522$var$feature_gate_js_client_1.default.clearConfigOverride) === null || _a === void 0 || _a.call($0c8bcb631f9fa522$var$feature_gate_js_client_1.default, configName);
    });
}

});


parcelRegister("jlxKU", function(module, exports) {
"use strict";
var $e15a29a50c470b63$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.FeatureGatesInitializationWithProvider = void 0;

var $5FkrB = parcelRequire("5FkrB");

const $e15a29a50c470b63$var$feature_gate_js_client_1 = $e15a29a50c470b63$var$__importDefault((parcelRequire("jcX3Q")));

var $14MvJ = parcelRequire("14MvJ");
/**
 * This component initializes the @atlassian/feature-flag-js-client by fetching the gate and experiment
 * evaluations for the given user, and blocks rendering of the children until the rendering is complete.
 */ const $e15a29a50c470b63$var$FeatureGatesInitializationWithProvider = ({ children: children, enabled: enabled = true, identifiers: identifiers, customAttributes: customAttributes, options: options, initializingComponent: initializingComponent, overrides: overrides, onReady: onReady, provider: provider })=>{
    // Rather than checking the state of all overrides, we can just assume that if overrides are provided
    // then some sort of update will need to be performed, and hold off rendering until the useEffect is run.
    const [isInitialized, setInitialized] = (0, $5FkrB.useState)(!overrides && (0, $14MvJ.isClientAlreadyInCorrectState)(identifiers, customAttributes));
    // Use a ref for the options and provider, so that we can use them within the following useEffect
    // without adding options and provider as dependencies.
    // This avoids the user updating every time an option or provider is attempted to be changed.
    const optionsRef = (0, $5FkrB.useRef)(options);
    const providerRef = (0, $5FkrB.useRef)(provider);
    (0, $5FkrB.useEffect)(()=>{
        optionsRef.current = options;
        providerRef.current = provider;
    }, [
        options,
        provider
    ]);
    (0, $5FkrB.useEffect)(()=>{
        if (enabled) {
            if ((0, $14MvJ.isClientAlreadyInCorrectState)(identifiers, customAttributes)) {
                (0, $14MvJ.applyOverrides)(overrides);
                setInitialized(true);
                onReady === null || onReady === void 0 || onReady();
            } else {
                setInitialized(false);
                const initPromise = $e15a29a50c470b63$var$feature_gate_js_client_1.default.initializeCalled() ? $e15a29a50c470b63$var$feature_gate_js_client_1.default.updateUserWithProvider(identifiers, customAttributes) : $e15a29a50c470b63$var$feature_gate_js_client_1.default.initializeWithProvider(options, provider, identifiers, customAttributes);
                initPromise.catch((err)=>(0, $14MvJ.toError)(err)).then((err)=>{
                    setInitialized(true);
                    (0, $14MvJ.applyOverrides)(overrides);
                    onReady === null || onReady === void 0 || onReady(err || undefined);
                });
            }
        } else {
            setInitialized(true);
            onReady === null || onReady === void 0 || onReady();
        }
        return ()=>(0, $14MvJ.clearOverrides)(overrides);
    }, [
        enabled,
        identifiers,
        customAttributes,
        overrides
    ]);
    return (0, $14MvJ.pickChildToRender)(enabled, isInitialized, children, initializingComponent);
};
module.exports.FeatureGatesInitializationWithProvider = $e15a29a50c470b63$var$FeatureGatesInitializationWithProvider;
module.exports.default = module.exports.FeatureGatesInitializationWithProvider;

});

parcelRegister("glblS", function(module, exports) {
"use strict";
var $be5769be92103314$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.FeatureGatesInitializationWithDefaults = void 0;

var $5FkrB = parcelRequire("5FkrB");

const $be5769be92103314$var$feature_gate_js_client_1 = $be5769be92103314$var$__importDefault((parcelRequire("jcX3Q")));

var $14MvJ = parcelRequire("14MvJ");
/**
 * This component initializes the @atlassian/feature-flag-js-client by fetching the gate and experiment
 * evaluations for the given user, and blocks rendering of the children until the rendering is complete.
 */ const $be5769be92103314$var$FeatureGatesInitializationWithDefaults = ({ children: children, enabled: enabled = true, identifiers: identifiers, customAttributes: customAttributes, options: options, overrides: overrides, onReady: onReady })=>{
    // Rather than checking the state of all overrides, we can just assume that if overrides are provided
    // then some sort of update will need to be performed, and hold off rendering until the useEffect is run.
    const [isInitialized, setInitialized] = (0, $5FkrB.useState)(!overrides && (0, $14MvJ.isClientAlreadyInCorrectState)(identifiers, customAttributes));
    // Use a ref for the options, so that we can use them within the following useEffect
    // without adding options as a dependency.
    // This avoids the user updating every time an option is changed.
    const optionsRef = (0, $5FkrB.useRef)(options);
    (0, $5FkrB.useEffect)(()=>{
        optionsRef.current = options;
    }, [
        options
    ]);
    (0, $5FkrB.useEffect)(()=>{
        if (enabled) {
            if ((0, $14MvJ.isClientAlreadyInCorrectState)(identifiers, customAttributes)) {
                (0, $14MvJ.applyOverrides)(overrides);
                setInitialized(true);
                onReady === null || onReady === void 0 || onReady();
            } else {
                setInitialized(false);
                const initPromise = $be5769be92103314$var$feature_gate_js_client_1.default.initializeCalled() ? $be5769be92103314$var$feature_gate_js_client_1.default.updateUserWithValues(identifiers, customAttributes) : $be5769be92103314$var$feature_gate_js_client_1.default.initializeFromValues(Object.assign({
                    sdkKey: 'client-default-key'
                }, optionsRef.current || {}), identifiers, customAttributes);
                initPromise.catch((err)=>(0, $14MvJ.toError)(err)).then((err)=>{
                    setInitialized(true);
                    (0, $14MvJ.applyOverrides)(overrides);
                    onReady === null || onReady === void 0 || onReady(err || undefined);
                });
            }
        } else {
            setInitialized(true);
            onReady === null || onReady === void 0 || onReady();
        }
        return ()=>(0, $14MvJ.clearOverrides)(overrides);
    }, [
        enabled,
        identifiers,
        customAttributes,
        overrides
    ]);
    return (0, $14MvJ.pickChildToRender)(enabled, isInitialized, children);
};
module.exports.FeatureGatesInitializationWithDefaults = $be5769be92103314$var$FeatureGatesInitializationWithDefaults;
module.exports.default = module.exports.FeatureGatesInitializationWithDefaults;

});

parcelRegister("hn1YZ", function(module, exports) {
"use strict";
var $ca561f5aec499d8d$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.FeatureGatesInitializationWithValues = void 0;

var $5FkrB = parcelRequire("5FkrB");

const $ca561f5aec499d8d$var$feature_gate_js_client_1 = $ca561f5aec499d8d$var$__importDefault((parcelRequire("jcX3Q")));

var $14MvJ = parcelRequire("14MvJ");
/**
 * This component initializes the @atlassian/feature-flag-js-client by fetching the gate and experiment
 * evaluations for the given user, and blocks rendering of the children until the rendering is complete.
 */ const $ca561f5aec499d8d$var$FeatureGatesInitializationWithValues = ({ children: children, enabled: enabled = true, identifiers: identifiers, customAttributes: customAttributes, options: options, initializeValues: initializeValues, overrides: overrides, onReady: onReady })=>{
    // Rather than checking the state of all overrides, we can just assume that if overrides are provided
    // then some sort of update will need to be performed, and hold off rendering until the useEffect is run.
    const [isInitialized, setInitialized] = (0, $5FkrB.useState)(!overrides && (0, $14MvJ.isClientAlreadyInCorrectState)(identifiers, customAttributes));
    // Use a ref for the options, so that we can use them within the following useEffect
    // without adding options as a dependency.
    // This avoids the user updating every time an option is changed.
    const optionsRef = (0, $5FkrB.useRef)(options);
    (0, $5FkrB.useEffect)(()=>{
        optionsRef.current = options;
    }, [
        options
    ]);
    (0, $5FkrB.useEffect)(()=>{
        if (enabled) {
            if ((0, $14MvJ.isClientAlreadyInCorrectState)(identifiers, customAttributes)) {
                (0, $14MvJ.applyOverrides)(overrides);
                setInitialized(true);
                onReady === null || onReady === void 0 || onReady();
            } else {
                setInitialized(false);
                const initPromise = $ca561f5aec499d8d$var$feature_gate_js_client_1.default.initializeCalled() ? $ca561f5aec499d8d$var$feature_gate_js_client_1.default.updateUserWithValues(identifiers, customAttributes, initializeValues) : $ca561f5aec499d8d$var$feature_gate_js_client_1.default.initializeFromValues(optionsRef.current, identifiers, customAttributes, initializeValues);
                initPromise.catch((err)=>(0, $14MvJ.toError)(err)).then((err)=>{
                    setInitialized(true);
                    (0, $14MvJ.applyOverrides)(overrides);
                    onReady === null || onReady === void 0 || onReady(err || undefined);
                });
            }
        } else {
            setInitialized(true);
            onReady === null || onReady === void 0 || onReady();
        }
        return ()=>(0, $14MvJ.clearOverrides)(overrides);
    }, [
        enabled,
        identifiers,
        customAttributes,
        initializeValues,
        overrides
    ]);
    return (0, $14MvJ.pickChildToRender)(enabled, isInitialized, children);
};
module.exports.FeatureGatesInitializationWithValues = $ca561f5aec499d8d$var$FeatureGatesInitializationWithValues;
module.exports.default = module.exports.FeatureGatesInitializationWithValues;

});

parcelRegister("6ohtU", function(module, exports) {
$parcel$export(module.exports, "startLighthouseObserver", () => $4a728b6427091ead$export$5ecf2aafafee3e0);
$parcel$export(module.exports, "getLighthouseMetrics", () => $4a728b6427091ead$export$b46cecdf698e4bb5);

var $7yDQB = parcelRequire("7yDQB");

var $6ldPa = parcelRequire("6ldPa");

var $1KOuk = parcelRequire("1KOuk");

var $cIS95 = parcelRequire("cIS95");

var $1YC37 = parcelRequire("1YC37");
function $4a728b6427091ead$export$5ecf2aafafee3e0() {
    (0, $1YC37.startLSObserver)();
    (0, $1YC37.startLTObserver)();
}
function $4a728b6427091ead$export$b46cecdf698e4bb5(_ref) {
    var start = _ref.start, stop = _ref.stop;
    var tbt = (0, $1KOuk.getTBT)(start, stop, (0, $cIS95.EntriesBuffer)[(0, $6ldPa.PerformanceObserverEntryTypes).LongTask]);
    // no round as CLS is usually 0-1
    var cls = (0, $7yDQB.getCLS)(start, stop, (0, $cIS95.EntriesBuffer)[(0, $6ldPa.PerformanceObserverEntryTypes).LayoutShift]);
    return {
        'metric:tbt': Math.round(tbt.total),
        'metric:tbt:observed': Math.round(tbt.observed),
        'metric:cls': cls
    };
}

});
parcelRegister("7yDQB", function(module, exports) {
$parcel$export(module.exports, "getCLS", () => $580a9e43cae8e230$export$fc6227831ee7c7);

var $9Zzpd = parcelRequire("9Zzpd");
function $580a9e43cae8e230$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $580a9e43cae8e230$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $580a9e43cae8e230$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $580a9e43cae8e230$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $580a9e43cae8e230$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $580a9e43cae8e230$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $580a9e43cae8e230$var$isSameRects(rect1, rect2) {
    return rect1.x === rect2.x && rect1.y === rect2.y && rect1.width === rect2.width && rect1.height === rect2.height && rect1.top === rect2.top && rect1.right === rect2.right && rect1.bottom === rect2.bottom && rect1.left === rect2.left;
}
function $580a9e43cae8e230$export$fc6227831ee7c7(start, stop, buffer) {
    var layoutShifts = buffer.getAll().filter(function(_entry) {
        var entry = _entry;
        var isWithinObservationWindow = entry.startTime >= start && entry.startTime <= stop;
        if ((0, $9Zzpd.fg)('platform_ufo_filter_cls_logs_same_rects_positions')) {
            var _entry$sources;
            var allSourcesHaveSameRects = entry === null || entry === void 0 || (_entry$sources = entry.sources) === null || _entry$sources === void 0 ? void 0 : _entry$sources.every(function(_ref) {
                var previousRect = _ref.previousRect, currentRect = _ref.currentRect;
                return $580a9e43cae8e230$var$isSameRects(previousRect, currentRect);
            });
            return isWithinObservationWindow && !allSourcesHaveSameRects;
        }
        return isWithinObservationWindow;
    });
    var sessionWindows = [];
    var currentWindow = null;
    // Group layout shifts into session windows
    var _iterator = $580a9e43cae8e230$var$_createForOfIteratorHelper(layoutShifts), _step;
    try {
        for(_iterator.s(); !(_step = _iterator.n()).done;){
            var shift = _step.value;
            var startTime = shift.startTime;
            var endTime = shift.startTime + shift.duration;
            var score = shift.value;
            if (currentWindow === null || startTime - currentWindow.endTime > 1000 || endTime - currentWindow.startTime > 5000) {
                // Start a new session window
                currentWindow = {
                    startTime: startTime,
                    endTime: endTime,
                    score: score
                };
                sessionWindows.push(currentWindow);
            } else {
                // Add layout shift to current session window
                currentWindow.endTime = endTime;
                currentWindow.score += score;
            }
        }
    // Find session window with highest cumulative score
    } catch (err) {
        _iterator.e(err);
    } finally{
        _iterator.f();
    }
    var maxScore = sessionWindows.reduce(function(max, sessionWindow) {
        return sessionWindow.score > max ? sessionWindow.score : max;
    }, 0);
    // Return score of largest burst as CLS metric
    return Math.round(maxScore * 10000) / 10000;
}

});

parcelRegister("6ldPa", function(module, exports) {
$parcel$export(module.exports, "PerformanceObserverEntryTypes", () => $49df6d75f4092ae2$export$a4def92db6fc8e17);
var $49df6d75f4092ae2$export$a4def92db6fc8e17 = {
    LayoutShift: 'layout-shift',
    LongTask: 'longtask'
};

});

parcelRegister("1KOuk", function(module, exports) {
$parcel$export(module.exports, "getTBT", () => $147140398b934b43$export$2d6e933b35bd3407);
var $147140398b934b43$var$MAX_ACCEPTABLE_TASK_DURATION = 50;
function $147140398b934b43$export$2d6e933b35bd3407(start, stop, buffer) {
    return buffer.getAll().filter(function(entry) {
        return entry.startTime <= stop && entry.duration > $147140398b934b43$var$MAX_ACCEPTABLE_TASK_DURATION && (entry.startTime >= start || entry.startTime + entry.duration >= start || entry.startTime <= start && entry.startTime + entry.duration >= stop);
    }).reduce(function(tbt, entry) {
        var longTaskStop = entry.startTime + entry.duration;
        var intersectStart = Math.max(entry.startTime + $147140398b934b43$var$MAX_ACCEPTABLE_TASK_DURATION, start);
        var intersectStop = Math.min(longTaskStop, stop);
        var longTaskIncluded = Math.max(intersectStop - intersectStart, 0);
        // eslint-disable-next-line no-param-reassign
        tbt.observed += entry.duration - $147140398b934b43$var$MAX_ACCEPTABLE_TASK_DURATION;
        // eslint-disable-next-line no-param-reassign
        tbt.total += longTaskIncluded;
        return tbt;
    }, {
        total: 0,
        observed: 0
    });
}

});

parcelRegister("cIS95", function(module, exports) {
$parcel$export(module.exports, "EntriesBuffer", () => $94339846ca1d299e$export$f7dc16cbd16f7bbe);

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $25nEq = parcelRequire("25nEq");

var $6ldPa = parcelRequire("6ldPa");
var $94339846ca1d299e$export$2c6e86519c9e8188 = /*#__PURE__*/ function() {
    function BufferWithMaxLength() {
        var maxLength = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1000;
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, BufferWithMaxLength);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "buffer", []);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "full", false);
        this.maxLength = maxLength;
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(BufferWithMaxLength, [
        {
            key: "push",
            value: function push(item) {
                if (this.full || this.maxLength === this.buffer.length) {
                    this.full = true;
                    this.buffer.shift();
                }
                this.buffer.push(item);
            }
        },
        {
            key: "getAll",
            value: function getAll() {
                return this.buffer;
            }
        }
    ]);
}();
var $94339846ca1d299e$export$f7dc16cbd16f7bbe = (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, (0, $6ldPa.PerformanceObserverEntryTypes).LongTask, new $94339846ca1d299e$export$2c6e86519c9e8188()), (0, $6ldPa.PerformanceObserverEntryTypes).LayoutShift, new $94339846ca1d299e$export$2c6e86519c9e8188());

});

parcelRegister("1YC37", function(module, exports) {
$parcel$export(module.exports, "startLSObserver", () => $1708e8dc2515347f$export$768ccc3ab7bac3ea);
$parcel$export(module.exports, "startLTObserver", () => $1708e8dc2515347f$export$54fb8b6aaf70ec9c);

var $6ldPa = parcelRequire("6ldPa");

var $cIS95 = parcelRequire("cIS95");
var $1708e8dc2515347f$var$pe = null;
function $1708e8dc2515347f$var$getObserver() {
    if (typeof PerformanceObserver !== 'function') // Only instantiate the IntersectionObserver if it's supported
    return null;
    if ($1708e8dc2515347f$var$pe !== null) return $1708e8dc2515347f$var$pe;
    var performanceObserverCallback = function performanceObserverCallback(list) {
        list.getEntries().forEach(function(entry) {
            if (entry.entryType === (0, $6ldPa.PerformanceObserverEntryTypes).LayoutShift) (0, $cIS95.EntriesBuffer)[(0, $6ldPa.PerformanceObserverEntryTypes).LayoutShift].push(entry);
            if (entry.entryType === (0, $6ldPa.PerformanceObserverEntryTypes).LongTask) (0, $cIS95.EntriesBuffer)[(0, $6ldPa.PerformanceObserverEntryTypes).LongTask].push(entry);
        });
    };
    $1708e8dc2515347f$var$pe = new PerformanceObserver(performanceObserverCallback);
    return $1708e8dc2515347f$var$pe;
}
function $1708e8dc2515347f$export$768ccc3ab7bac3ea() {
    var _getObserver;
    (_getObserver = $1708e8dc2515347f$var$getObserver()) === null || _getObserver === void 0 || _getObserver.observe({
        type: (0, $6ldPa.PerformanceObserverEntryTypes).LayoutShift,
        buffered: true
    });
}
function $1708e8dc2515347f$export$54fb8b6aaf70ec9c() {
    var _getObserver2;
    (_getObserver2 = $1708e8dc2515347f$var$getObserver()) === null || _getObserver2 === void 0 || _getObserver2.observe({
        type: (0, $6ldPa.PerformanceObserverEntryTypes).LongTask,
        buffered: true
    });
}

});


parcelRegister("1gQdg", function(module, exports) {
$parcel$export(module.exports, "createPressureStateReport", () => $0ecfc97a8169a0bc$export$1f0ff35da084986e);
$parcel$export(module.exports, "createMemoryStateReport", () => $0ecfc97a8169a0bc$export$3b47ebb9832b4e24);
$parcel$export(module.exports, "initialisePressureObserver", () => $0ecfc97a8169a0bc$export$117ebc554c6e9f2f);
$parcel$export(module.exports, "initialiseMemoryObserver", () => $0ecfc97a8169a0bc$export$a3271f53e91faab7);

var $fC8ib = parcelRequire("fC8ib");
var $0ecfc97a8169a0bc$var$BUFFER_MAX_LENGTH = 1000; // ensure we don't blow up this buffer
var $0ecfc97a8169a0bc$var$pressureRecordBuffer = [];
var $0ecfc97a8169a0bc$var$pressureObserver = null;
var $0ecfc97a8169a0bc$var$memoryRecordBuffer = [];
var $0ecfc97a8169a0bc$var$memoryInterval;
function $0ecfc97a8169a0bc$export$6c1060bed5fea050() {
    $0ecfc97a8169a0bc$var$pressureRecordBuffer.length = 0;
}
function $0ecfc97a8169a0bc$export$aa672c7221b183b0() {
    $0ecfc97a8169a0bc$var$memoryRecordBuffer.length = 0;
}
function $0ecfc97a8169a0bc$export$ec86686c1d2e65bc(filter) {
    $0ecfc97a8169a0bc$var$pressureRecordBuffer = $0ecfc97a8169a0bc$var$pressureRecordBuffer.filter(function(_ref) {
        var time = _ref.time;
        return time > filter;
    });
}
function $0ecfc97a8169a0bc$export$c0142ac82f5d0c28(filter) {
    $0ecfc97a8169a0bc$var$memoryRecordBuffer = $0ecfc97a8169a0bc$var$memoryRecordBuffer.filter(function(_ref2) {
        var time = _ref2.time;
        return time > filter;
    });
}
function $0ecfc97a8169a0bc$export$1f0ff35da084986e(start, end) {
    try {
        // To differentiate between the API not available, vs no PressureRecords added
        if (!('PressureObserver' in globalThis)) return null;
        var pressureStateCount = $0ecfc97a8169a0bc$var$pressureRecordBuffer.reduce(function(pressureReport, _ref3) {
            var time = _ref3.time, state = _ref3.state;
            if (time >= start && time <= end) pressureReport[state] += 1;
            return pressureReport;
        }, {
            nominal: 0,
            fair: 0,
            serious: 0,
            critical: 0
        });
        var pressureStateTotal = Object.values(pressureStateCount).reduce(function(total, count) {
            return total + count;
        }) || 1;
        $0ecfc97a8169a0bc$export$ec86686c1d2e65bc(end);
        return {
            count: pressureStateCount,
            percentage: {
                nominal: Math.round(pressureStateCount.nominal / pressureStateTotal * 100),
                fair: Math.round(pressureStateCount.fair / pressureStateTotal * 100),
                serious: Math.round(pressureStateCount.serious / pressureStateTotal * 100),
                critical: Math.round(pressureStateCount.critical / pressureStateTotal * 100)
            }
        };
    } catch (_unused) {
        return null;
    }
}
function $0ecfc97a8169a0bc$var$convertBytesToMegabytes(bytes) {
    return Math.round(Math.round(bytes / 1048576 * 100) / 100);
}
function $0ecfc97a8169a0bc$export$3b47ebb9832b4e24(start, end) {
    try {
        if (!('memory' in performance)) return null;
        var accumulatedMemoryUsage = $0ecfc97a8169a0bc$var$memoryRecordBuffer.reduce(function(acc, snapshot) {
            if (snapshot.time >= start && snapshot.time <= end) {
                acc.totalJSHeapSize += snapshot.totalJSHeapSize;
                acc.usedJSHeapSize += snapshot.usedJSHeapSize;
                acc.snapshotCount += 1;
            }
            return acc;
        }, {
            totalJSHeapSize: 0,
            usedJSHeapSize: 0,
            snapshotCount: 0
        });
        var memoryStateReport = {
            jsHeapSizeLimitInMB: $0ecfc97a8169a0bc$var$convertBytesToMegabytes($0ecfc97a8169a0bc$var$memoryRecordBuffer[0].jsHeapSizeLimit),
            // just use the first record, since this value always remains the same over time
            avgTotalJSHeapSizeInMB: $0ecfc97a8169a0bc$var$convertBytesToMegabytes(accumulatedMemoryUsage.totalJSHeapSize / accumulatedMemoryUsage.snapshotCount),
            avgUsedJSHeapSizeInMB: $0ecfc97a8169a0bc$var$convertBytesToMegabytes(accumulatedMemoryUsage.usedJSHeapSize / accumulatedMemoryUsage.snapshotCount)
        };
        $0ecfc97a8169a0bc$export$c0142ac82f5d0c28(end);
        return memoryStateReport;
    } catch (_unused2) {
        return null;
    }
}
function $0ecfc97a8169a0bc$export$117ebc554c6e9f2f() {
    try {
        if ('PressureObserver' in globalThis) {
            $0ecfc97a8169a0bc$var$pressureObserver = new PressureObserver(function(records) {
                if ($0ecfc97a8169a0bc$var$pressureRecordBuffer.length + records.length <= $0ecfc97a8169a0bc$var$BUFFER_MAX_LENGTH) {
                    var _pressureRecordBuffer;
                    (_pressureRecordBuffer = $0ecfc97a8169a0bc$var$pressureRecordBuffer).push.apply(_pressureRecordBuffer, (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(records));
                }
            });
            $0ecfc97a8169a0bc$var$pressureObserver.observe('cpu', {
                sampleInterval: 100
            }).catch(function() {
            // Silently handle permission policy restrictions or other observe failures
            // This prevents unhandled promise rejections from being reported to Sentry
            });
        }
    } catch (err) {
    /* do nothing, this is a best efforts metric */ }
}
function $0ecfc97a8169a0bc$export$a3271f53e91faab7() {
    try {
        // only set up the interval if `performance.memory` is available in the browser
        if ('memory' in performance) $0ecfc97a8169a0bc$var$memoryInterval = setInterval(function() {
            // another check of `performance.memory` availability to satisfy typescript
            if ('memory' in performance) {
                var memory = performance.memory;
                if ($0ecfc97a8169a0bc$var$memoryRecordBuffer.length <= $0ecfc97a8169a0bc$var$BUFFER_MAX_LENGTH) $0ecfc97a8169a0bc$var$memoryRecordBuffer.push({
                    time: performance.now(),
                    jsHeapSizeLimit: memory.jsHeapSizeLimit,
                    totalJSHeapSize: memory.totalJSHeapSize,
                    usedJSHeapSize: memory.usedJSHeapSize
                });
            }
        }, 100);
    } catch (_unused3) {
    /* do nothing, this is a best efforts metric */ }
}
function $0ecfc97a8169a0bc$export$10899ada382f2ae3() {
    clearInterval($0ecfc97a8169a0bc$var$memoryInterval);
}
function $0ecfc97a8169a0bc$export$b9fdd785f0fc1d40() {
    var _pressureObserver;
    (_pressureObserver = $0ecfc97a8169a0bc$var$pressureObserver) === null || _pressureObserver === void 0 || _pressureObserver.disconnect();
}

});

parcelRegister("LUkQI", function(module, exports) {

var $iKwew = parcelRequire("iKwew");
module.exports = Promise.all([
    $iKwew("gyasr"),
    $iKwew("2sAUK")
]).then(()=>parcelRequire('iSCGu'));

});

parcelRegister("gyFaN", function(module, exports) {

var $iKwew = parcelRequire("iKwew");
module.exports = $iKwew("jcyZO").then(()=>parcelRequire('7YvAm'));

});

parcelRegister("7nmeJ", function(module, exports) {

var $iKwew = parcelRequire("iKwew");
module.exports = Promise.all([
    $iKwew("gyasr"),
    $iKwew("5J79V")
]).then(()=>parcelRequire('f5AfP'));

});

var $faf30355a80342e4$exports = {};
'use strict';

$faf30355a80342e4$exports = (parcelRequire("eumjn"));


var $94347cf79186e453$export$882461b6382ed46c;
var $94347cf79186e453$export$757ceba2d55c277e;
'use strict';

var $aLeHs = parcelRequire("aLeHs");
var $94347cf79186e453$var$i;
$94347cf79186e453$export$882461b6382ed46c = $aLeHs.createRoot;
$94347cf79186e453$export$757ceba2d55c277e = $aLeHs.hydrateRoot;



var $N6ReQ = parcelRequire("N6ReQ");

var $iYJcE = parcelRequire("iYJcE");

var $9Zzpd = parcelRequire("9Zzpd");

var $25nEq = parcelRequire("25nEq");

var $9Zzpd = parcelRequire("9Zzpd");

var $9AP5g = parcelRequire("9AP5g");

var $N6ReQ = parcelRequire("N6ReQ");

var $ekGgq = parcelRequire("ekGgq");

var $iYJcE = parcelRequire("iYJcE");

var $N6ReQ = parcelRequire("N6ReQ");
var $17575ea5656bb0a2$var$themeKinds = [
    'light',
    'dark',
    'spacing',
    'typography',
    'shape',
    'motion'
];
var $17575ea5656bb0a2$var$customThemeOptions = 'UNSAFE_themeOptions';
var $17575ea5656bb0a2$var$isThemeKind = function isThemeKind(themeKind) {
    return $17575ea5656bb0a2$var$themeKinds.find(function(kind) {
        return kind === themeKind;
    }) !== undefined;
};
var $17575ea5656bb0a2$var$isThemeIds = function isThemeIds(themeId) {
    return (0, $N6ReQ.themeIds).find(function(id) {
        return id === themeId;
    }) !== undefined;
};
var $17575ea5656bb0a2$var$isColorMode = function isColorMode(modeId) {
    return [
        'light',
        'dark',
        'auto'
    ].includes(modeId);
};
var $17575ea5656bb0a2$export$f19b488f7c0547ee = function themeStringToObject(themeState) {
    return themeState.split(' ')// @ts-ignore - TS1501 TypeScript 5.9.2 upgrade
    .map(function(theme) {
        return theme.split(/:([^]*)/);
    }).reduce(function(themeObject, _ref) {
        var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_ref, 2), kind = _ref2[0], id = _ref2[1];
        if (kind === 'colorMode' && $17575ea5656bb0a2$var$isColorMode(id)) themeObject[kind] = id;
        if ($17575ea5656bb0a2$var$isThemeKind(kind) && $17575ea5656bb0a2$var$isThemeIds(id)) // @ts-expect-error FIXME - this is a valid ts error
        themeObject[kind] = id;
        if (kind === $17575ea5656bb0a2$var$customThemeOptions) try {
            themeObject[$17575ea5656bb0a2$var$customThemeOptions] = JSON.parse(id);
        } catch (_unused) {
            new Error('Invalid custom theme string');
        }
        return themeObject;
    }, {});
};
var $17575ea5656bb0a2$export$62c37ab81302621a = function themeObjectToString(themeState) {
    return Object.entries(themeState).reduce(function(themeString, _ref3) {
        var _ref4 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_ref3, 2), kind = _ref4[0], id = _ref4[1];
        if (// colorMode theme state
        kind === 'colorMode' && typeof id === 'string' && $17575ea5656bb0a2$var$isColorMode(id) || // custom theme state
        kind === $17575ea5656bb0a2$var$customThemeOptions && (0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(id) === 'object' || // other theme states
        $17575ea5656bb0a2$var$isThemeKind(kind) && typeof id === 'string' && $17575ea5656bb0a2$var$isThemeIds(id)) return themeString + "".concat(themeString ? ' ' : '') + "".concat(kind, ":").concat((0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(id) === 'object' ? JSON.stringify(id) : id);
        return themeString;
    }, '');
};



var $a4ocu = parcelRequire("a4ocu");

var $3ENxc = parcelRequire("3ENxc");
function $ec4eb29d91d718cb$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $ec4eb29d91d718cb$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $ec4eb29d91d718cb$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $ec4eb29d91d718cb$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $ec4eb29d91d718cb$var$defaultColorMode = 'light';
var $ec4eb29d91d718cb$var$defaultContrastMode = 'no-preference';
/**
 * Server-side rendering utility. Generates the valid HTML attributes for a given theme.
 * Note: this utility does not handle automatic theme switching.
 *
 * @param {Object<string, string>} themeOptions - Theme options object
 * @param {string} themeState.colorMode Determines which color theme is applied. If set to `auto`, the theme applied will be determined by the OS setting.
 * @param {string} themeState.dark The color theme to be applied when the color mode resolves to 'dark'.
 * @param {string} themeState.light The color theme to be applied when the color mode resolves to 'light'.
 * @param {string} themeState.motion The motion theme to be applied.
 * @param {string} themeState.spacing The spacing theme to be applied.
 * @param {string} themeState.typography The typography theme to be applied.
 * @param {Object} themeState.UNSAFE_themeOptions The custom branding options to be used for custom theme generation
 *
 * @returns {Object} Object of HTML attributes to be applied to the document root
 */ var $ec4eb29d91d718cb$var$getThemeHtmlAttrs = function getThemeHtmlAttrs() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, _ref$colorMode = _ref.colorMode, colorMode = _ref$colorMode === void 0 ? (0, $N6ReQ.themeStateDefaults)['colorMode'] : _ref$colorMode, _ref$dark = _ref.dark, dark = _ref$dark === void 0 ? (0, $N6ReQ.themeStateDefaults)['dark'] : _ref$dark, _ref$light = _ref.light, light = _ref$light === void 0 ? (0, $N6ReQ.themeStateDefaults)['light'] : _ref$light, _ref$contrastMode = _ref.contrastMode, contrastMode = _ref$contrastMode === void 0 ? (0, $N6ReQ.themeStateDefaults)['contrastMode'] : _ref$contrastMode, _ref$motion = _ref.motion, motion = _ref$motion === void 0 ? (0, $N6ReQ.themeStateDefaults)['motion']() : _ref$motion, _ref$shape = _ref.shape, shape = _ref$shape === void 0 ? (0, $N6ReQ.themeStateDefaults)['shape']() : _ref$shape, _ref$spacing = _ref.spacing, spacing = _ref$spacing === void 0 ? (0, $N6ReQ.themeStateDefaults)['spacing'] : _ref$spacing, _ref$typography = _ref.typography, typography = _ref$typography === void 0 ? (0, $N6ReQ.themeStateDefaults)['typography'] : _ref$typography, _ref$UNSAFE_themeOpti = _ref.UNSAFE_themeOptions, UNSAFE_themeOptions = _ref$UNSAFE_themeOpti === void 0 ? (0, $N6ReQ.themeStateDefaults)['UNSAFE_themeOptions'] : _ref$UNSAFE_themeOpti;
    var themeAttribute = (0, $17575ea5656bb0a2$export$62c37ab81302621a)({
        dark: dark,
        light: light,
        motion: motion,
        shape: shape,
        spacing: spacing,
        typography: typography
    });
    var result = (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, (0, $9AP5g.THEME_DATA_ATTRIBUTE), themeAttribute), (0, $9AP5g.COLOR_MODE_ATTRIBUTE), colorMode === 'auto' ? $ec4eb29d91d718cb$var$defaultColorMode : colorMode);
    if ((0, $9Zzpd.fg)('platform_increased-contrast-themes')) result = $ec4eb29d91d718cb$var$_objectSpread($ec4eb29d91d718cb$var$_objectSpread({}, result), {}, (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, (0, $9AP5g.CONTRAST_MODE_ATTRIBUTE), contrastMode === 'auto' ? $ec4eb29d91d718cb$var$defaultContrastMode : contrastMode));
    if (UNSAFE_themeOptions && (0, $a4ocu.isValidBrandHex)(UNSAFE_themeOptions.brandColor)) {
        var optionString = JSON.stringify(UNSAFE_themeOptions);
        var uniqueId = (0, $3ENxc.hash)(optionString);
        result[0, $9AP5g.CUSTOM_THEME_ATTRIBUTE] = uniqueId;
    }
    return result;
};
var $ec4eb29d91d718cb$export$2e2bcd8739ae039 = $ec4eb29d91d718cb$var$getThemeHtmlAttrs;



var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $25nEq = parcelRequire("25nEq");

var $7QpUe = parcelRequire("7QpUe");

var $9AP5g = parcelRequire("9AP5g");

var $fL8KA = parcelRequire("fL8KA");

var $6HG4S = parcelRequire("6HG4S");
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 *
 * This file contains a dynamic import for each theme this package exports.
 * Themes are loaded asynchronously at runtime to minimise the amount of CSS we send to the client.
 * This allows users to compose their themes and only use the tokens that are requested.
 * When a new theme is created, the import should automatically be added to the map
 *
 * @codegen <<SignedSource::a20c72d683b08b594c5be4160eec5f78>>
 * @codegenCommand yarn build tokens
 */ 









var $16ea0866e540b1ea$var$themeImportsMap = {
    'light': function light() {
        return (parcelRequire("bDSDt"));
    },
    'light-future': function lightFuture() {
        return (parcelRequire("8SV4m"));
    },
    'light-increased-contrast': function lightIncreasedContrast() {
        return (parcelRequire("10OzB"));
    },
    'dark': function dark() {
        return (parcelRequire("8Ul61"));
    },
    'dark-future': function darkFuture() {
        return (parcelRequire("fUMDb"));
    },
    'dark-increased-contrast': function darkIncreasedContrast() {
        return (parcelRequire("5r8Y4"));
    },
    'spacing': function spacing() {
        return (parcelRequire("9aLgs"));
    },
    'typography': function typography() {
        return (parcelRequire("b3HFs"));
    },
    'shape': function shape() {
        return (parcelRequire("2BLfh"));
    },
    'motion': function motion() {
        return (parcelRequire("j7Ivm"));
    }
};
var $16ea0866e540b1ea$export$2e2bcd8739ae039 = $16ea0866e540b1ea$var$themeImportsMap;



var $9AP5g = parcelRequire("9AP5g");
var $e00715b6e459a098$export$26cd7ae85c7144e5 = /*#__PURE__*/ function() {
    var _ref = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee(themeId) {
        var themeCss, style;
        return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee$(_context) {
            while(true)switch(_context.prev = _context.next){
                case 0:
                    if (!document.head.querySelector("style[".concat((0, $9AP5g.THEME_DATA_ATTRIBUTE), "=\"").concat(themeId, "\"]:not([").concat((0, $9AP5g.CUSTOM_THEME_ATTRIBUTE), "])"))) {
                        _context.next = 2;
                        break;
                    }
                    return _context.abrupt("return");
                case 2:
                    if (themeId) {
                        _context.next = 4;
                        break;
                    }
                    return _context.abrupt("return");
                case 4:
                    _context.next = 6;
                    return $e00715b6e459a098$export$8a48286ed7df6720(themeId);
                case 6:
                    themeCss = _context.sent;
                    style = document.createElement('style');
                    style.textContent = themeCss;
                    style.dataset.theme = themeId;
                    document.head.appendChild(style);
                case 11:
                case "end":
                    return _context.stop();
            }
        }, _callee);
    }));
    return function loadAndAppendThemeCss(_x) {
        return _ref.apply(this, arguments);
    };
}();
var $e00715b6e459a098$export$8a48286ed7df6720 = /*#__PURE__*/ function() {
    var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee2(themeId) {
        var _yield$themeImportMap, themeCss;
        return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee2$(_context2) {
            while(true)switch(_context2.prev = _context2.next){
                case 0:
                    _context2.next = 2;
                    return (0, $16ea0866e540b1ea$export$2e2bcd8739ae039)[themeId]();
                case 2:
                    _yield$themeImportMap = _context2.sent;
                    themeCss = _yield$themeImportMap.default;
                    return _context2.abrupt("return", themeCss);
                case 5:
                case "end":
                    return _context2.stop();
            }
        }, _callee2);
    }));
    return function loadThemeCss(_x2) {
        return _ref2.apply(this, arguments);
    };
}();
var $e00715b6e459a098$export$bb1e815119d30f8b = '(prefers-color-scheme: dark)';
var $e00715b6e459a098$export$8662df6937d86fcb = '(prefers-contrast: more)';


var $983d5a90f967f7fe$var$isMatchMediaAvailable = typeof window !== 'undefined' && 'matchMedia' in window;
/**
 * Updates the current theme when the system theme changes. Should be bound
 * to an event listener listening on the '(prefers-color-scheme: dark)' query
 * @param e The event representing a change in system theme.
 */ function $983d5a90f967f7fe$var$checkNativeListener(e) {
    var element = document.documentElement;
    element.setAttribute((0, $9AP5g.COLOR_MODE_ATTRIBUTE), e.matches ? 'dark' : 'light');
}
var $983d5a90f967f7fe$var$darkModeMql = $983d5a90f967f7fe$var$isMatchMediaAvailable && window.matchMedia((0, $e00715b6e459a098$export$bb1e815119d30f8b));
var $983d5a90f967f7fe$var$ColorModeObserver = /*#__PURE__*/ function() {
    function ColorModeObserver() {
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, ColorModeObserver);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "unbindThemeChangeListener", null);
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(ColorModeObserver, [
        {
            key: "getColorMode",
            value: function getColorMode() {
                if (!$983d5a90f967f7fe$var$darkModeMql) return 'light';
                return $983d5a90f967f7fe$var$darkModeMql !== null && $983d5a90f967f7fe$var$darkModeMql !== void 0 && $983d5a90f967f7fe$var$darkModeMql.matches ? 'dark' : 'light';
            }
        },
        {
            key: "bind",
            value: function bind() {
                if ($983d5a90f967f7fe$var$darkModeMql && this.unbindThemeChangeListener === null) this.unbindThemeChangeListener = (0, $7QpUe.bind)($983d5a90f967f7fe$var$darkModeMql, {
                    type: 'change',
                    listener: $983d5a90f967f7fe$var$checkNativeListener
                });
            }
        },
        {
            key: "unbind",
            value: function unbind() {
                if (this.unbindThemeChangeListener) {
                    this.unbindThemeChangeListener();
                    this.unbindThemeChangeListener = null;
                }
            }
        }
    ]);
}();
/**
 * A singleton color mode observer - binds "auto" switching logic to a single `mediaQueryList` listener
 * that can be unbound by any consumer when no longer needed.
 */ var $983d5a90f967f7fe$var$SingletonColorModeObserver = new $983d5a90f967f7fe$var$ColorModeObserver();
var $983d5a90f967f7fe$export$2e2bcd8739ae039 = $983d5a90f967f7fe$var$SingletonColorModeObserver;



var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $25nEq = parcelRequire("25nEq");

var $7QpUe = parcelRequire("7QpUe");

var $9AP5g = parcelRequire("9AP5g");

var $fd913e28a40792b4$var$isMatchMediaAvailable = typeof window !== 'undefined' && 'matchMedia' in window;
/**
 * Updates the current theme when the system contrast preference changes. Should be bound
 * to an event listener listening on the '(prefers-contrast: more)' query
 * @param e The event representing a change in system theme.
 */ function $fd913e28a40792b4$var$checkNativeListener(e) {
    var element = document.documentElement;
    element.setAttribute((0, $9AP5g.CONTRAST_MODE_ATTRIBUTE), e.matches ? 'more' : 'no-preference');
}
var $fd913e28a40792b4$var$contrastModeMql = $fd913e28a40792b4$var$isMatchMediaAvailable && window.matchMedia((0, $e00715b6e459a098$export$8662df6937d86fcb));
var $fd913e28a40792b4$var$ContrastModeObserver = /*#__PURE__*/ function() {
    function ContrastModeObserver() {
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, ContrastModeObserver);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "unbindContrastChangeListener", null);
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(ContrastModeObserver, [
        {
            key: "getContrastMode",
            value: function getContrastMode() {
                if (!$fd913e28a40792b4$var$contrastModeMql) return 'no-preference';
                return $fd913e28a40792b4$var$contrastModeMql !== null && $fd913e28a40792b4$var$contrastModeMql !== void 0 && $fd913e28a40792b4$var$contrastModeMql.matches ? 'more' : 'no-preference';
            }
        },
        {
            key: "bind",
            value: function bind() {
                if ($fd913e28a40792b4$var$contrastModeMql && this.unbindContrastChangeListener === null) this.unbindContrastChangeListener = (0, $7QpUe.bind)($fd913e28a40792b4$var$contrastModeMql, {
                    type: 'change',
                    listener: $fd913e28a40792b4$var$checkNativeListener
                });
            }
        },
        {
            key: "unbind",
            value: function unbind() {
                if (this.unbindContrastChangeListener) {
                    this.unbindContrastChangeListener();
                    this.unbindContrastChangeListener = null;
                }
            }
        }
    ]);
}();
/**
 * A singleton contrast mode observer - binds "auto" switching logic to a single `mediaQueryList` listener
 * that can be unbound by any consumer when no longer needed.
 */ var $fd913e28a40792b4$var$SingletonContrastModeObserver = new $fd913e28a40792b4$var$ContrastModeObserver();
var $fd913e28a40792b4$export$2e2bcd8739ae039 = $fd913e28a40792b4$var$SingletonContrastModeObserver;


function $7ffc6e39b7f2dd73$export$2e2bcd8739ae039(themeState) {
    if (themeState.colorMode === 'auto') {
        // Set colorMode based on the user preference
        themeState.colorMode = (0, $983d5a90f967f7fe$export$2e2bcd8739ae039).getColorMode();
        // Bind a listener (if one doesn't already exist) to keep colorMode updated
        (0, $983d5a90f967f7fe$export$2e2bcd8739ae039).bind();
    } else (0, $983d5a90f967f7fe$export$2e2bcd8739ae039).unbind();
    if ((0, $9Zzpd.fg)('platform_increased-contrast-themes')) {
        if (themeState.contrastMode === 'auto') {
            // Set contrastMode based on the user preference
            themeState.contrastMode = (0, $fd913e28a40792b4$export$2e2bcd8739ae039).getContrastMode();
            // Bind a listener (if one doesn't already exist) to keep contrastMode updated
            (0, $fd913e28a40792b4$export$2e2bcd8739ae039).bind();
        } else (0, $fd913e28a40792b4$export$2e2bcd8739ae039).unbind();
    }
    var themeAttributes = (0, $ec4eb29d91d718cb$export$2e2bcd8739ae039)(themeState);
    Object.entries(themeAttributes).forEach(function(_ref) {
        var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_ref, 2), key = _ref2[0], value = _ref2[1];
        document.documentElement.setAttribute(key, value);
    });
    return function() {
        (0, $983d5a90f967f7fe$export$2e2bcd8739ae039).unbind();
        if ((0, $9Zzpd.fg)('platform_increased-contrast-themes')) (0, $fd913e28a40792b4$export$2e2bcd8739ae039).unbind();
    };
}



var $fC8ib = parcelRequire("fC8ib");

var $9Zzpd = parcelRequire("9Zzpd");

var $iYJcE = parcelRequire("iYJcE");

var $N6ReQ = parcelRequire("N6ReQ");
function $a673407db681c464$export$2e2bcd8739ae039(themeId) {
    var _Object$entries$find;
    return (_Object$entries$find = Object.entries((0, $N6ReQ.default)).find(function(_ref) {
        var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_ref, 2), increasesContrastFor = _ref2[1].increasesContrastFor;
        return increasesContrastFor === themeId;
    })) === null || _Object$entries$find === void 0 ? void 0 : _Object$entries$find[1].id;
}


var $2a0bd88b2a46cb27$export$dd6aeb7c823fc03d = function getThemePreferences(themeState) {
    var colorMode = themeState.colorMode, contrastMode = themeState.contrastMode, dark = themeState.dark, light = themeState.light, shape = themeState.shape, spacing = themeState.spacing, typography = themeState.typography, motion = themeState.motion;
    var autoColorModeThemes = [
        light,
        dark
    ];
    var themePreferences = [];
    if (colorMode === 'auto') {
        if (contrastMode !== 'no-preference' && (0, $9Zzpd.fg)('platform_increased-contrast-themes')) autoColorModeThemes.forEach(function(normalTheme) {
            var increasedContrastTheme = (0, $a673407db681c464$export$2e2bcd8739ae039)(normalTheme);
            if (increasedContrastTheme) autoColorModeThemes.push(increasedContrastTheme);
        });
        themePreferences.push.apply(themePreferences, autoColorModeThemes);
    } else {
        themePreferences.push(themeState[colorMode]);
        if (contrastMode !== 'no-preference' && (0, $9Zzpd.fg)('platform_increased-contrast-themes')) {
            var increasedContrastTheme = (0, $a673407db681c464$export$2e2bcd8739ae039)(themeState[colorMode]);
            if (increasedContrastTheme) themePreferences.push(increasedContrastTheme);
        }
    }
    [
        shape,
        spacing,
        typography,
        motion
    ].forEach(function(themeId) {
        if (themeId) themePreferences.push(themeId);
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(new Set(themePreferences));
};
var $2a0bd88b2a46cb27$export$5d76d7014f4a5d08 = function getThemeOverridePreferences(_themeState) {
    var themeOverridePreferences = [];
    return (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(new Set(themeOverridePreferences));
};


/**
 * Synchronously sets the theme globally at runtime. Themes are not loaded;
 * use `getThemeStyles` and other server-side utilities to generate and load them.
 *
 * @param {Object<string, string>} themeState The themes and color mode that should be applied.
 * @param {string} themeState.colorMode Determines which color theme is applied. If set to `auto`, the theme applied will be determined by the OS setting.
 * @param {string} themeState.dark The color theme to be applied when the color mode resolves to 'dark'.
 * @param {string} themeState.light The color theme to be applied when the color mode resolves to 'light'.
 * @param {string} themeState.motion The motion theme to be applied.
 * @param {string} themeState.shape The shape theme to be applied.
 * @param {string} themeState.spacing The spacing theme to be applied.
 * @param {string} themeState.typography The typography theme to be applied.
 * @param {Object} themeState.UNSAFE_themeOptions The custom branding options to be used for custom theme generation
 * @param {function} themeLoader Callback function used to override the default theme loading functionality.
 *
 * @returns An unbind function, that can be used to stop listening for changes to system theme.
 *
 * @example
 * ```
 * enableGlobalTheme({colorMode: 'auto', light: 'light', dark: 'dark', spacing: 'spacing'});
 * ```
 */ var $f17f0f6b501ed4b1$var$enableGlobalTheme = function enableGlobalTheme() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, _ref$colorMode = _ref.colorMode, colorMode = _ref$colorMode === void 0 ? (0, $N6ReQ.themeStateDefaults)['colorMode'] : _ref$colorMode, _ref$contrastMode = _ref.contrastMode, contrastMode = _ref$contrastMode === void 0 ? (0, $N6ReQ.themeStateDefaults)['contrastMode'] : _ref$contrastMode, _ref$dark = _ref.dark, dark = _ref$dark === void 0 ? (0, $N6ReQ.themeStateDefaults)['dark'] : _ref$dark, _ref$light = _ref.light, light = _ref$light === void 0 ? (0, $N6ReQ.themeStateDefaults)['light'] : _ref$light, _ref$motion = _ref.motion, motion = _ref$motion === void 0 ? (0, $N6ReQ.themeStateDefaults)['motion']() : _ref$motion, _ref$shape = _ref.shape, shape = _ref$shape === void 0 ? (0, $N6ReQ.themeStateDefaults)['shape']() : _ref$shape, _ref$spacing = _ref.spacing, spacing = _ref$spacing === void 0 ? (0, $N6ReQ.themeStateDefaults)['spacing'] : _ref$spacing, _ref$typography = _ref.typography, typography = _ref$typography === void 0 ? (0, $N6ReQ.themeStateDefaults)['typography'] : _ref$typography, _ref$UNSAFE_themeOpti = _ref.UNSAFE_themeOptions, UNSAFE_themeOptions = _ref$UNSAFE_themeOpti === void 0 ? (0, $N6ReQ.themeStateDefaults)['UNSAFE_themeOptions'] : _ref$UNSAFE_themeOpti;
    var themeLoader = arguments.length > 1 ? arguments[1] : undefined;
    var themeState = {
        colorMode: colorMode,
        contrastMode: contrastMode,
        dark: dark,
        light: light,
        motion: motion,
        shape: shape,
        spacing: spacing,
        typography: typography,
        UNSAFE_themeOptions: themeLoader ? undefined : UNSAFE_themeOptions
    };
    // Determine what to load and call theme loader
    var themePreferences = (0, $2a0bd88b2a46cb27$export$dd6aeb7c823fc03d)(themeState);
    if (themeLoader) themePreferences.map(function(themeId) {
        return themeLoader(themeId);
    });
    var autoUnbind = (0, $7ffc6e39b7f2dd73$export$2e2bcd8739ae039)(themeState);
    return autoUnbind;
};
var $f17f0f6b501ed4b1$export$2e2bcd8739ae039 = $f17f0f6b501ed4b1$var$enableGlobalTheme;


var $fC8ib = parcelRequire("fC8ib");

var $fL8KA = parcelRequire("fL8KA");

var $6HG4S = parcelRequire("6HG4S");

var $9Zzpd = parcelRequire("9Zzpd");

var $N6ReQ = parcelRequire("N6ReQ");

var $a4ocu = parcelRequire("a4ocu");



/**
 * Takes an object containing theme preferences, and returns an array of objects for use in applying styles to the document head.
 * Only supplies the color themes necessary for initial render, based on the current themeState. I.e. if in light mode, dark mode themes are not returned.
 *
 * @param {Object<string, string>} themeState The themes and color mode that should be applied.
 * @param {string} themeState.colorMode Determines which color theme is applied. If set to `auto`, the theme applied will be determined by the OS setting.
 * @param {string} themeState.dark The color theme to be applied when the color mode resolves to 'dark'.
 * @param {string} themeState.light The color theme to be applied when the color mode resolves to 'light'.
 * @param {string} themeState.motion The motion theme to be applied.
 * @param {string} themeState.shape The shape theme to be applied.
 * @param {string} themeState.spacing The spacing theme to be applied.
 * @param {string} themeState.typography The typography theme to be applied.
 * @param {Object} themeState.UNSAFE_themeOptions The custom branding options to be used for custom theme generation
 *
 * @returns A Promise of an object array, containing theme IDs, data-attributes to attach to the theme, and the theme CSS.
 * If an error is encountered while loading themes, the themes array will be empty.
 */ var $9e4e6a70439714f4$var$getThemeStyles = /*#__PURE__*/ function() {
    var _ref = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee3(preferences) {
        var themePreferences, themeOverridePreferences, themeState, results;
        return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee3$(_context3) {
            while(true)switch(_context3.prev = _context3.next){
                case 0:
                    themeOverridePreferences = [];
                    if (preferences === 'all') {
                        themePreferences = (0, $N6ReQ.themeIdsWithOverrides);
                        // CLEANUP: Remove
                        if (!(0, $9Zzpd.fg)('platform_increased-contrast-themes')) themePreferences = themePreferences.filter(function(n) {
                            return n !== 'light-increased-contrast' && n !== 'dark-increased-contrast';
                        });
                    } else {
                        themeState = {
                            colorMode: (preferences === null || preferences === void 0 ? void 0 : preferences.colorMode) || (0, $N6ReQ.themeStateDefaults)['colorMode'],
                            contrastMode: (preferences === null || preferences === void 0 ? void 0 : preferences.contrastMode) || (0, $N6ReQ.themeStateDefaults)['contrastMode'],
                            dark: (preferences === null || preferences === void 0 ? void 0 : preferences.dark) || (0, $N6ReQ.themeStateDefaults)['dark'],
                            light: (preferences === null || preferences === void 0 ? void 0 : preferences.light) || (0, $N6ReQ.themeStateDefaults)['light'],
                            motion: (preferences === null || preferences === void 0 ? void 0 : preferences.motion) || (0, $N6ReQ.themeStateDefaults)['motion'](),
                            shape: (preferences === null || preferences === void 0 ? void 0 : preferences.shape) || (0, $N6ReQ.themeStateDefaults)['shape'](),
                            spacing: (preferences === null || preferences === void 0 ? void 0 : preferences.spacing) || (0, $N6ReQ.themeStateDefaults)['spacing'],
                            typography: (preferences === null || preferences === void 0 ? void 0 : preferences.typography) || (0, $N6ReQ.themeStateDefaults)['typography']
                        };
                        themePreferences = (0, $2a0bd88b2a46cb27$export$dd6aeb7c823fc03d)(themeState);
                        themeOverridePreferences = (0, $2a0bd88b2a46cb27$export$5d76d7014f4a5d08)(themeState);
                    }
                    _context3.next = 4;
                    return Promise.all([].concat((0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))([].concat((0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(themePreferences), (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(themeOverridePreferences)).map(/*#__PURE__*/ function() {
                        var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee(themeId) {
                            var css;
                            return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee$(_context) {
                                while(true)switch(_context.prev = _context.next){
                                    case 0:
                                        _context.prev = 0;
                                        _context.next = 3;
                                        return (0, $e00715b6e459a098$export$8a48286ed7df6720)(themeId);
                                    case 3:
                                        css = _context.sent;
                                        return _context.abrupt("return", {
                                            id: themeId,
                                            attrs: {
                                                'data-theme': themeId
                                            },
                                            css: css
                                        });
                                    case 7:
                                        _context.prev = 7;
                                        _context.t0 = _context["catch"](0);
                                        return _context.abrupt("return", undefined);
                                    case 10:
                                    case "end":
                                        return _context.stop();
                                }
                            }, _callee, null, [
                                [
                                    0,
                                    7
                                ]
                            ]);
                        }));
                        return function(_x2) {
                            return _ref2.apply(this, arguments);
                        };
                    }())), [
                        // Add custom themes if they're present
                        (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee2() {
                            var _preferences$UNSAFE_t;
                            var _yield$import, getCustomThemeStyles, customThemeStyles;
                            return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee2$(_context2) {
                                while(true)switch(_context2.prev = _context2.next){
                                    case 0:
                                        if (!(preferences !== 'all' && preferences !== null && preferences !== void 0 && preferences.UNSAFE_themeOptions && (0, $a4ocu.isValidBrandHex)(preferences === null || preferences === void 0 || (_preferences$UNSAFE_t = preferences.UNSAFE_themeOptions) === null || _preferences$UNSAFE_t === void 0 ? void 0 : _preferences$UNSAFE_t.brandColor))) {
                                            _context2.next = 15;
                                            break;
                                        }
                                        _context2.prev = 1;
                                        _context2.next = 4;
                                        return (parcelRequire("6OciX"));
                                    case 4:
                                        _yield$import = _context2.sent;
                                        getCustomThemeStyles = _yield$import.getCustomThemeStyles;
                                        _context2.next = 8;
                                        return getCustomThemeStyles({
                                            colorMode: (preferences === null || preferences === void 0 ? void 0 : preferences.colorMode) || (0, $N6ReQ.themeStateDefaults)['colorMode'],
                                            UNSAFE_themeOptions: preferences === null || preferences === void 0 ? void 0 : preferences.UNSAFE_themeOptions
                                        });
                                    case 8:
                                        customThemeStyles = _context2.sent;
                                        return _context2.abrupt("return", customThemeStyles);
                                    case 12:
                                        _context2.prev = 12;
                                        _context2.t0 = _context2["catch"](1);
                                        return _context2.abrupt("return", undefined);
                                    case 15:
                                        return _context2.abrupt("return", undefined);
                                    case 16:
                                    case "end":
                                        return _context2.stop();
                                }
                            }, _callee2, null, [
                                [
                                    1,
                                    12
                                ]
                            ]);
                        }))()
                    ]));
                case 4:
                    results = _context3.sent;
                    return _context3.abrupt("return", results.flat().filter(function(theme) {
                        return theme !== undefined;
                    }));
                case 6:
                case "end":
                    return _context3.stop();
            }
        }, _callee3);
    }));
    return function getThemeStyles(_x) {
        return _ref.apply(this, arguments);
    };
}();
var $9e4e6a70439714f4$export$2e2bcd8739ae039 = $9e4e6a70439714f4$var$getThemeStyles;




var $5FkrB = parcelRequire("5FkrB");

var $2DGGf = parcelRequire("2DGGf");

var $5FkrB = parcelRequire("5FkrB");

"use client";
var $a0fe68b284b4365c$export$da112d31b0149f31 = $5FkrB.createContext(void 0);
var $a0fe68b284b4365c$export$22e77b9572c4fded = (queryClient)=>{
    const client = $5FkrB.useContext($a0fe68b284b4365c$export$da112d31b0149f31);
    if (queryClient) return queryClient;
    if (!client) throw new Error("No QueryClient set, use QueryClientProvider to set one");
    return client;
};
var $a0fe68b284b4365c$export$45604f0cc8ae667b = ({ client: client, children: children })=>{
    $5FkrB.useEffect(()=>{
        client.mount();
        return ()=>{
            client.unmount();
        };
    }, [
        client
    ]);
    return /* @__PURE__ */ (0, $faf30355a80342e4$exports.jsx)($a0fe68b284b4365c$export$da112d31b0149f31.Provider, {
        value: client,
        children: children
    });
};


/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled, @typescript-eslint/consistent-type-imports

var $74Zh5 = parcelRequire("74Zh5");
// dimension vars
var $efd2be1bf5c3a2eb$export$cbfb0f5b2869b17b = 'leftPanelWidth';
var $efd2be1bf5c3a2eb$export$a30f2e00489a8957 = 'leftSidebarWidth';
var $efd2be1bf5c3a2eb$export$c103b605cd368aed = 'rightSidebarWidth';
var $efd2be1bf5c3a2eb$export$fa34f417972d6341 = 'rightPanelWidth';
var $efd2be1bf5c3a2eb$export$3a6a779d9181047c = 'topNavigationHeight';
var $efd2be1bf5c3a2eb$export$bcd94a6a792e7f96 = 'bannerHeight';
var $efd2be1bf5c3a2eb$export$b6744d31294864fd = 'leftSidebarFlyoutWidth';
var $efd2be1bf5c3a2eb$export$344062f7cfc9528e = 'left-panel';
var $efd2be1bf5c3a2eb$export$c7139cc2d6110b5f = 'right-panel';
var $efd2be1bf5c3a2eb$export$238d30785c4bca84 = 'banner';
var $efd2be1bf5c3a2eb$export$bec6dca2e63de4ae = 'top-navigation';
var $efd2be1bf5c3a2eb$export$d1213e82613ff4df = 'content';
var $efd2be1bf5c3a2eb$export$be83e7118304b28e = 56;
var $efd2be1bf5c3a2eb$export$4a98ee0bd1ae362 = 56;
var $efd2be1bf5c3a2eb$export$539e68c09584883a = 240;
var $efd2be1bf5c3a2eb$export$b92df8810d2fcd01 = 280;
var $efd2be1bf5c3a2eb$export$c3e41153b9288bcf = 368;
var $efd2be1bf5c3a2eb$export$c4d6152f86ea28f6 = 368;
var $efd2be1bf5c3a2eb$export$46acf8758e9e2636 = 20;
var $efd2be1bf5c3a2eb$export$70740f5ad8360a78 = 16;
var $efd2be1bf5c3a2eb$export$991d5285ad765a3d = 240;
var $efd2be1bf5c3a2eb$export$6949d4f32b161684 = 200;
var $efd2be1bf5c3a2eb$export$d6e7e8af042815bb = 350;
var $efd2be1bf5c3a2eb$export$3749e1104328fde4 = 300;
var $efd2be1bf5c3a2eb$export$1074d925b0b82be5 = 200;
var $efd2be1bf5c3a2eb$export$451e84a45a9e4a75 = 'DS_PAGE_LAYOUT_UI_STATE';
var $efd2be1bf5c3a2eb$export$802bb2c050f3db5c = 'data-is-sidebar-dragging';
var $efd2be1bf5c3a2eb$export$5e5e1875c3fd8f4f = 'data-is-sidebar-collapsing';
var $efd2be1bf5c3a2eb$export$70c702a8c5895f03 = 'data-grab-area-line';
var $efd2be1bf5c3a2eb$export$48a43f91e4becf4e = 'data-grab-area';
var $efd2be1bf5c3a2eb$export$dac2fb31a9f6844d = 'data-resize-button';
var $efd2be1bf5c3a2eb$export$9ecd22db14e6c70e = 'data-resize-control';
var $efd2be1bf5c3a2eb$export$5253dd9707b8c3ba = 'data-ds--page-layout--slot';
var $efd2be1bf5c3a2eb$export$206a08f7f8beb554 = 'Skip to:';
var $efd2be1bf5c3a2eb$export$659ee746b31b360d = 'data-layout-container';
var $efd2be1bf5c3a2eb$export$f963aecf2d4465bd = "var(--".concat($efd2be1bf5c3a2eb$export$cbfb0f5b2869b17b, ", 0px)");
var $efd2be1bf5c3a2eb$export$750459958906793 = "var(--".concat($efd2be1bf5c3a2eb$export$fa34f417972d6341, ", 0px)");
var $efd2be1bf5c3a2eb$export$f897e1ed9f8ed251 = "var(--".concat($efd2be1bf5c3a2eb$export$a30f2e00489a8957, ", 0px)");
var $efd2be1bf5c3a2eb$export$b44ab66843c05a69 = "var(--".concat($efd2be1bf5c3a2eb$export$c103b605cd368aed, ", 0px)");
var $efd2be1bf5c3a2eb$export$aeff86a16f13529 = "var(--".concat($efd2be1bf5c3a2eb$export$3a6a779d9181047c, ", 0px)");
var $efd2be1bf5c3a2eb$export$ed7cc0d417ee89e = "var(--".concat($efd2be1bf5c3a2eb$export$bcd94a6a792e7f96, ", 0px)");
var $efd2be1bf5c3a2eb$export$d2fa14f05b61e66 = "var(--".concat($efd2be1bf5c3a2eb$export$b6744d31294864fd, ", ").concat($efd2be1bf5c3a2eb$export$991d5285ad765a3d, "px)");


var $0b354a69a2959049$var$contentStyles = (0, $74Zh5.css)({
    display: 'flex',
    height: '100%',
    position: 'relative',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    gridArea: (0, $efd2be1bf5c3a2eb$export$d1213e82613ff4df)
});
/**
 * __Content__
 *
 * Provides a slot for your application content within the PageLayout.
 *
 * - [Examples](https://atlassian.design/components/page-layout/examples)
 * - [Code](https://atlassian.design/components/page-layout/code)
 */ var $0b354a69a2959049$var$Content = function Content(props) {
    var children = props.children, testId = props.testId;
    return (0, $74Zh5.jsx)("div", {
        "data-testid": testId,
        css: $0b354a69a2959049$var$contentStyles
    }, children);
};
var $0b354a69a2959049$export$2e2bcd8739ae039 = $0b354a69a2959049$var$Content;



var $kqp0i = parcelRequire("kqp0i");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");

var $74Zh5 = parcelRequire("74Zh5");

var $5FkrB = parcelRequire("5FkrB");
var $6aab085817c2aae8$export$1ca2a26fecb070ae = /*#__PURE__*/ (0, $5FkrB.createContext)('elevation.surface');
var $6aab085817c2aae8$export$1aeb4f6b93c4540d = function useSurface() {
    return (0, $5FkrB.useContext)($6aab085817c2aae8$export$1ca2a26fecb070ae);
};
$6aab085817c2aae8$export$1ca2a26fecb070ae.displayName = 'SurfaceProvider';



var $25nEq = parcelRequire("25nEq");

var $74Zh5 = parcelRequire("74Zh5");

var $9AP5g = parcelRequire("9AP5g");
function $e955727b9ac9b5b6$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $e955727b9ac9b5b6$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $e955727b9ac9b5b6$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $e955727b9ac9b5b6$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $e955727b9ac9b5b6$export$6ccdbebca2ee545f = {
    '100%': '100%',
    'size.100': '1rem',
    'size.200': '1.5rem',
    'size.300': '2rem',
    'size.400': '2.5rem',
    'size.500': '3rem',
    'size.600': '6rem',
    'size.1000': '12rem'
};
var $e955727b9ac9b5b6$export$958d0ae7f2977ae4 = {
    'space.0': "var(--ds-space-0, 0px)",
    'space.025': "var(--ds-space-025, 2px)",
    'space.050': "var(--ds-space-050, 4px)",
    'space.075': "var(--ds-space-075, 6px)",
    'space.100': "var(--ds-space-100, 8px)",
    'space.150': "var(--ds-space-150, 12px)",
    'space.200': "var(--ds-space-200, 16px)",
    'space.250': "var(--ds-space-250, 20px)",
    'space.300': "var(--ds-space-300, 24px)",
    'space.400': "var(--ds-space-400, 32px)",
    'space.500': "var(--ds-space-500, 40px)",
    'space.600': "var(--ds-space-600, 48px)",
    'space.800': "var(--ds-space-800, 64px)",
    'space.1000': "var(--ds-space-1000, 80px)"
};
var $e955727b9ac9b5b6$export$d2dc61f58390201c = {
    'space.negative.025': "var(--ds-space-negative-025, -2px)",
    'space.negative.050': "var(--ds-space-negative-050, -4px)",
    'space.negative.075': "var(--ds-space-negative-075, -6px)",
    'space.negative.100': "var(--ds-space-negative-100, -8px)",
    'space.negative.150': "var(--ds-space-negative-150, -12px)",
    'space.negative.200': "var(--ds-space-negative-200, -16px)",
    'space.negative.250': "var(--ds-space-negative-250, -20px)",
    'space.negative.300': "var(--ds-space-negative-300, -24px)",
    'space.negative.400': "var(--ds-space-negative-400, -32px)"
};
var $e955727b9ac9b5b6$export$632685d741f3dbbf = $e955727b9ac9b5b6$var$_objectSpread($e955727b9ac9b5b6$var$_objectSpread({}, $e955727b9ac9b5b6$export$958d0ae7f2977ae4), $e955727b9ac9b5b6$export$d2dc61f58390201c);
var $e955727b9ac9b5b6$export$2185ce37f9bdd963 = {
    'color.background.neutral.bold': 'color.text.inverse',
    'color.background.neutral.bold.hovered': 'color.text.inverse',
    'color.background.neutral.bold.pressed': 'color.text.inverse',
    'color.background.selected.bold': 'color.text.inverse',
    'color.background.selected.bold.hovered': 'color.text.inverse',
    'color.background.selected.bold.pressed': 'color.text.inverse',
    'color.background.brand.bold': 'color.text.inverse',
    'color.background.brand.bold.hovered': 'color.text.inverse',
    'color.background.brand.bold.pressed': 'color.text.inverse',
    'color.background.brand.boldest': 'color.text.inverse',
    'color.background.brand.boldest.hovered': 'color.text.inverse',
    'color.background.brand.boldest.pressed': 'color.text.inverse',
    'color.background.danger.bold': 'color.text.inverse',
    'color.background.danger.bold.hovered': 'color.text.inverse',
    'color.background.danger.bold.pressed': 'color.text.inverse',
    'color.background.warning.bold': 'color.text.warning.inverse',
    'color.background.warning.bold.hovered': 'color.text.warning.inverse',
    'color.background.warning.bold.pressed': 'color.text.warning.inverse',
    'color.background.success.bold': 'color.text.inverse',
    'color.background.success.bold.hovered': 'color.text.inverse',
    'color.background.success.bold.pressed': 'color.text.inverse',
    'color.background.discovery.bold': 'color.text.inverse',
    'color.background.discovery.bold.hovered': 'color.text.inverse',
    'color.background.discovery.bold.pressed': 'color.text.inverse',
    'color.background.information.bold': 'color.text.inverse',
    'color.background.information.bold.hovered': 'color.text.inverse',
    'color.background.information.bold.pressed': 'color.text.inverse'
};
var $e955727b9ac9b5b6$export$daf94a976c798b4f = {
    'opacity.disabled': "var(--ds-opacity-disabled, 0.4)",
    'opacity.loading': "var(--ds-opacity-loading, 0.2)"
};
var $e955727b9ac9b5b6$export$7aff6e7ba39bb774 = {
    'elevation.shadow.overflow': "var(--ds-shadow-overflow, 0px 0px 8px #1E1F21, 0px 0px 1px #1E1F21)",
    'elevation.shadow.overflow.perimeter': "var(--ds-shadow-overflow-perimeter, #1E1F211f)",
    'elevation.shadow.overflow.spread': "var(--ds-shadow-overflow-spread, #1E1F2129)",
    'elevation.shadow.overlay': "var(--ds-shadow-overlay, 0px 8px 12px #1E1F21, 0px 0px 1px #1E1F21)",
    'elevation.shadow.raised': "var(--ds-shadow-raised, 0px 1px 1px #1E1F21, 0px 0px 1px #1E1F21)"
};
var $e955727b9ac9b5b6$export$41a358c9c2356760 = {
    'elevation.surface': "var(--ds-surface, #FFFFFF)",
    'elevation.surface.hovered': "var(--ds-surface-hovered, #F0F1F2)",
    'elevation.surface.pressed': "var(--ds-surface-pressed, #DDDEE1)",
    'elevation.surface.overlay': "var(--ds-surface-overlay, #FFFFFF)",
    'elevation.surface.overlay.hovered': "var(--ds-surface-overlay-hovered, #F0F1F2)",
    'elevation.surface.overlay.pressed': "var(--ds-surface-overlay-pressed, #DDDEE1)",
    'elevation.surface.raised': "var(--ds-surface-raised, #FFFFFF)",
    'elevation.surface.raised.hovered': "var(--ds-surface-raised-hovered, #F0F1F2)",
    'elevation.surface.raised.pressed': "var(--ds-surface-raised-pressed, #DDDEE1)",
    'elevation.surface.sunken': "var(--ds-surface-sunken, #F8F8F8)"
};
var $e955727b9ac9b5b6$export$1531ad5bb3fbedac = {
    'color.border': "var(--ds-border, #0B120E24)",
    'color.border.accent.lime': "var(--ds-border-accent-lime, #6A9A23)",
    'color.border.accent.red': "var(--ds-border-accent-red, #E2483D)",
    'color.border.accent.orange': "var(--ds-border-accent-orange, #E06C00)",
    'color.border.accent.yellow': "var(--ds-border-accent-yellow, #B38600)",
    'color.border.accent.green': "var(--ds-border-accent-green, #22A06B)",
    'color.border.accent.teal': "var(--ds-border-accent-teal, #2898BD)",
    'color.border.accent.blue': "var(--ds-border-accent-blue, #357DE8)",
    'color.border.accent.purple': "var(--ds-border-accent-purple, #AF59E1)",
    'color.border.accent.magenta': "var(--ds-border-accent-magenta, #CD519D)",
    'color.border.accent.gray': "var(--ds-border-accent-gray, #7D818A)",
    'color.border.disabled': "var(--ds-border-disabled, #0515240F)",
    'color.border.focused': "var(--ds-border-focused, #4688EC)",
    'color.border.input': "var(--ds-border-input, #8C8F97)",
    'color.border.inverse': "var(--ds-border-inverse, #FFFFFF)",
    'color.border.selected': "var(--ds-border-selected, #1868DB)",
    'color.border.brand': "var(--ds-border-brand, #1868DB)",
    'color.border.danger': "var(--ds-border-danger, #E2483D)",
    'color.border.warning': "var(--ds-border-warning, #E06C00)",
    'color.border.success': "var(--ds-border-success, #6A9A23)",
    'color.border.discovery': "var(--ds-border-discovery, #AF59E1)",
    'color.border.information': "var(--ds-border-information, #357DE8)",
    'color.border.bold': "var(--ds-border-bold, #7D818A)"
};
var $e955727b9ac9b5b6$export$d1d79bf68ac056bd = {
    'color.background.accent.lime.subtlest': "var(--ds-background-accent-lime-subtlest, #EFFFD6)",
    'color.background.accent.lime.subtlest.hovered': "var(--ds-background-accent-lime-subtlest-hovered, #D3F1A7)",
    'color.background.accent.lime.subtlest.pressed': "var(--ds-background-accent-lime-subtlest-pressed, #BDE97C)",
    'color.background.accent.lime.subtler': "var(--ds-background-accent-lime-subtler, #D3F1A7)",
    'color.background.accent.lime.subtler.hovered': "var(--ds-background-accent-lime-subtler-hovered, #BDE97C)",
    'color.background.accent.lime.subtler.pressed': "var(--ds-background-accent-lime-subtler-pressed, #B3DF72)",
    'color.background.accent.lime.subtle': "var(--ds-background-accent-lime-subtle, #94C748)",
    'color.background.accent.lime.subtle.hovered': "var(--ds-background-accent-lime-subtle-hovered, #B3DF72)",
    'color.background.accent.lime.subtle.pressed': "var(--ds-background-accent-lime-subtle-pressed, #BDE97C)",
    'color.background.accent.lime.bolder': "var(--ds-background-accent-lime-bolder, #5B7F24)",
    'color.background.accent.lime.bolder.hovered': "var(--ds-background-accent-lime-bolder-hovered, #4C6B1F)",
    'color.background.accent.lime.bolder.pressed': "var(--ds-background-accent-lime-bolder-pressed, #3F5224)",
    'color.background.accent.red.subtlest': "var(--ds-background-accent-red-subtlest, #FFECEB)",
    'color.background.accent.red.subtlest.hovered': "var(--ds-background-accent-red-subtlest-hovered, #FFD5D2)",
    'color.background.accent.red.subtlest.pressed': "var(--ds-background-accent-red-subtlest-pressed, #FFB8B2)",
    'color.background.accent.red.subtler': "var(--ds-background-accent-red-subtler, #FFD5D2)",
    'color.background.accent.red.subtler.hovered': "var(--ds-background-accent-red-subtler-hovered, #FFB8B2)",
    'color.background.accent.red.subtler.pressed': "var(--ds-background-accent-red-subtler-pressed, #FD9891)",
    'color.background.accent.red.subtle': "var(--ds-background-accent-red-subtle, #F87168)",
    'color.background.accent.red.subtle.hovered': "var(--ds-background-accent-red-subtle-hovered, #FD9891)",
    'color.background.accent.red.subtle.pressed': "var(--ds-background-accent-red-subtle-pressed, #FFB8B2)",
    'color.background.accent.red.bolder': "var(--ds-background-accent-red-bolder, #C9372C)",
    'color.background.accent.red.bolder.hovered': "var(--ds-background-accent-red-bolder-hovered, #AE2E24)",
    'color.background.accent.red.bolder.pressed': "var(--ds-background-accent-red-bolder-pressed, #872821)",
    'color.background.accent.orange.subtlest': "var(--ds-background-accent-orange-subtlest, #FFF5DB)",
    'color.background.accent.orange.subtlest.hovered': "var(--ds-background-accent-orange-subtlest-hovered, #FCE4A6)",
    'color.background.accent.orange.subtlest.pressed': "var(--ds-background-accent-orange-subtlest-pressed, #FBD779)",
    'color.background.accent.orange.subtler': "var(--ds-background-accent-orange-subtler, #FCE4A6)",
    'color.background.accent.orange.subtler.hovered': "var(--ds-background-accent-orange-subtler-hovered, #FBD779)",
    'color.background.accent.orange.subtler.pressed': "var(--ds-background-accent-orange-subtler-pressed, #FBC828)",
    'color.background.accent.orange.subtle': "var(--ds-background-accent-orange-subtle, #FCA700)",
    'color.background.accent.orange.subtle.hovered': "var(--ds-background-accent-orange-subtle-hovered, #FBC828)",
    'color.background.accent.orange.subtle.pressed': "var(--ds-background-accent-orange-subtle-pressed, #FBD779)",
    'color.background.accent.orange.bolder': "var(--ds-background-accent-orange-bolder, #BD5B00)",
    'color.background.accent.orange.bolder.hovered': "var(--ds-background-accent-orange-bolder-hovered, #9E4C00)",
    'color.background.accent.orange.bolder.pressed': "var(--ds-background-accent-orange-bolder-pressed, #7A3B00)",
    'color.background.accent.yellow.subtlest': "var(--ds-background-accent-yellow-subtlest, #FEF7C8)",
    'color.background.accent.yellow.subtlest.hovered': "var(--ds-background-accent-yellow-subtlest-hovered, #F5E989)",
    'color.background.accent.yellow.subtlest.pressed': "var(--ds-background-accent-yellow-subtlest-pressed, #EFDD4E)",
    'color.background.accent.yellow.subtler': "var(--ds-background-accent-yellow-subtler, #F5E989)",
    'color.background.accent.yellow.subtler.hovered': "var(--ds-background-accent-yellow-subtler-hovered, #EFDD4E)",
    'color.background.accent.yellow.subtler.pressed': "var(--ds-background-accent-yellow-subtler-pressed, #EED12B)",
    'color.background.accent.yellow.subtle': "var(--ds-background-accent-yellow-subtle, #EED12B)",
    'color.background.accent.yellow.subtle.hovered': "var(--ds-background-accent-yellow-subtle-hovered, #DDB30E)",
    'color.background.accent.yellow.subtle.pressed': "var(--ds-background-accent-yellow-subtle-pressed, #EFDD4E)",
    'color.background.accent.yellow.bolder': "var(--ds-background-accent-yellow-bolder, #946F00)",
    'color.background.accent.yellow.bolder.hovered': "var(--ds-background-accent-yellow-bolder-hovered, #7F5F01)",
    'color.background.accent.yellow.bolder.pressed': "var(--ds-background-accent-yellow-bolder-pressed, #614A05)",
    'color.background.accent.green.subtlest': "var(--ds-background-accent-green-subtlest, #DCFFF1)",
    'color.background.accent.green.subtlest.hovered': "var(--ds-background-accent-green-subtlest-hovered, #BAF3DB)",
    'color.background.accent.green.subtlest.pressed': "var(--ds-background-accent-green-subtlest-pressed, #97EDC9)",
    'color.background.accent.green.subtler': "var(--ds-background-accent-green-subtler, #BAF3DB)",
    'color.background.accent.green.subtler.hovered': "var(--ds-background-accent-green-subtler-hovered, #97EDC9)",
    'color.background.accent.green.subtler.pressed': "var(--ds-background-accent-green-subtler-pressed, #7EE2B8)",
    'color.background.accent.green.subtle': "var(--ds-background-accent-green-subtle, #4BCE97)",
    'color.background.accent.green.subtle.hovered': "var(--ds-background-accent-green-subtle-hovered, #7EE2B8)",
    'color.background.accent.green.subtle.pressed': "var(--ds-background-accent-green-subtle-pressed, #97EDC9)",
    'color.background.accent.green.bolder': "var(--ds-background-accent-green-bolder, #1F845A)",
    'color.background.accent.green.bolder.hovered': "var(--ds-background-accent-green-bolder-hovered, #216E4E)",
    'color.background.accent.green.bolder.pressed': "var(--ds-background-accent-green-bolder-pressed, #19573D)",
    'color.background.accent.teal.subtlest': "var(--ds-background-accent-teal-subtlest, #E7F9FF)",
    'color.background.accent.teal.subtlest.hovered': "var(--ds-background-accent-teal-subtlest-hovered, #C6EDFB)",
    'color.background.accent.teal.subtlest.pressed': "var(--ds-background-accent-teal-subtlest-pressed, #B1E4F7)",
    'color.background.accent.teal.subtler': "var(--ds-background-accent-teal-subtler, #C6EDFB)",
    'color.background.accent.teal.subtler.hovered': "var(--ds-background-accent-teal-subtler-hovered, #B1E4F7)",
    'color.background.accent.teal.subtler.pressed': "var(--ds-background-accent-teal-subtler-pressed, #9DD9EE)",
    'color.background.accent.teal.subtle': "var(--ds-background-accent-teal-subtle, #6CC3E0)",
    'color.background.accent.teal.subtle.hovered': "var(--ds-background-accent-teal-subtle-hovered, #9DD9EE)",
    'color.background.accent.teal.subtle.pressed': "var(--ds-background-accent-teal-subtle-pressed, #B1E4F7)",
    'color.background.accent.teal.bolder': "var(--ds-background-accent-teal-bolder, #227D9B)",
    'color.background.accent.teal.bolder.hovered': "var(--ds-background-accent-teal-bolder-hovered, #206A83)",
    'color.background.accent.teal.bolder.pressed': "var(--ds-background-accent-teal-bolder-pressed, #1A5265)",
    'color.background.accent.blue.subtlest': "var(--ds-background-accent-blue-subtlest, #E9F2FE)",
    'color.background.accent.blue.subtlest.hovered': "var(--ds-background-accent-blue-subtlest-hovered, #CFE1FD)",
    'color.background.accent.blue.subtlest.pressed': "var(--ds-background-accent-blue-subtlest-pressed, #ADCBFB)",
    'color.background.accent.blue.subtler': "var(--ds-background-accent-blue-subtler, #CFE1FD)",
    'color.background.accent.blue.subtler.hovered': "var(--ds-background-accent-blue-subtler-hovered, #ADCBFB)",
    'color.background.accent.blue.subtler.pressed': "var(--ds-background-accent-blue-subtler-pressed, #8FB8F6)",
    'color.background.accent.blue.subtle': "var(--ds-background-accent-blue-subtle, #669DF1)",
    'color.background.accent.blue.subtle.hovered': "var(--ds-background-accent-blue-subtle-hovered, #8FB8F6)",
    'color.background.accent.blue.subtle.pressed': "var(--ds-background-accent-blue-subtle-pressed, #ADCBFB)",
    'color.background.accent.blue.bolder': "var(--ds-background-accent-blue-bolder, #1868DB)",
    'color.background.accent.blue.bolder.hovered': "var(--ds-background-accent-blue-bolder-hovered, #1558BC)",
    'color.background.accent.blue.bolder.pressed': "var(--ds-background-accent-blue-bolder-pressed, #144794)",
    'color.background.accent.purple.subtlest': "var(--ds-background-accent-purple-subtlest, #F8EEFE)",
    'color.background.accent.purple.subtlest.hovered': "var(--ds-background-accent-purple-subtlest-hovered, #EED7FC)",
    'color.background.accent.purple.subtlest.pressed': "var(--ds-background-accent-purple-subtlest-pressed, #E3BDFA)",
    'color.background.accent.purple.subtler': "var(--ds-background-accent-purple-subtler, #EED7FC)",
    'color.background.accent.purple.subtler.hovered': "var(--ds-background-accent-purple-subtler-hovered, #E3BDFA)",
    'color.background.accent.purple.subtler.pressed': "var(--ds-background-accent-purple-subtler-pressed, #D8A0F7)",
    'color.background.accent.purple.subtle': "var(--ds-background-accent-purple-subtle, #C97CF4)",
    'color.background.accent.purple.subtle.hovered': "var(--ds-background-accent-purple-subtle-hovered, #D8A0F7)",
    'color.background.accent.purple.subtle.pressed': "var(--ds-background-accent-purple-subtle-pressed, #E3BDFA)",
    'color.background.accent.purple.bolder': "var(--ds-background-accent-purple-bolder, #964AC0)",
    'color.background.accent.purple.bolder.hovered': "var(--ds-background-accent-purple-bolder-hovered, #803FA5)",
    'color.background.accent.purple.bolder.pressed': "var(--ds-background-accent-purple-bolder-pressed, #673286)",
    'color.background.accent.magenta.subtlest': "var(--ds-background-accent-magenta-subtlest, #FFECF8)",
    'color.background.accent.magenta.subtlest.hovered': "var(--ds-background-accent-magenta-subtlest-hovered, #FDD0EC)",
    'color.background.accent.magenta.subtlest.pressed': "var(--ds-background-accent-magenta-subtlest-pressed, #FCB6E1)",
    'color.background.accent.magenta.subtler': "var(--ds-background-accent-magenta-subtler, #FDD0EC)",
    'color.background.accent.magenta.subtler.hovered': "var(--ds-background-accent-magenta-subtler-hovered, #FCB6E1)",
    'color.background.accent.magenta.subtler.pressed': "var(--ds-background-accent-magenta-subtler-pressed, #F797D2)",
    'color.background.accent.magenta.subtle': "var(--ds-background-accent-magenta-subtle, #E774BB)",
    'color.background.accent.magenta.subtle.hovered': "var(--ds-background-accent-magenta-subtle-hovered, #F797D2)",
    'color.background.accent.magenta.subtle.pressed': "var(--ds-background-accent-magenta-subtle-pressed, #FCB6E1)",
    'color.background.accent.magenta.bolder': "var(--ds-background-accent-magenta-bolder, #AE4787)",
    'color.background.accent.magenta.bolder.hovered': "var(--ds-background-accent-magenta-bolder-hovered, #943D73)",
    'color.background.accent.magenta.bolder.pressed': "var(--ds-background-accent-magenta-bolder-pressed, #77325B)",
    'color.background.accent.gray.subtlest': "var(--ds-background-accent-gray-subtlest, #F0F1F2)",
    'color.background.accent.gray.subtlest.hovered': "var(--ds-background-accent-gray-subtlest-hovered, #DDDEE1)",
    'color.background.accent.gray.subtlest.pressed': "var(--ds-background-accent-gray-subtlest-pressed, #B7B9BE)",
    'color.background.accent.gray.subtler': "var(--ds-background-accent-gray-subtler, #DDDEE1)",
    'color.background.accent.gray.subtler.hovered': "var(--ds-background-accent-gray-subtler-hovered, #B7B9BE)",
    'color.background.accent.gray.subtler.pressed': "var(--ds-background-accent-gray-subtler-pressed, #8C8F97)",
    'color.background.accent.gray.subtle': "var(--ds-background-accent-gray-subtle, #8C8F97)",
    'color.background.accent.gray.subtle.hovered': "var(--ds-background-accent-gray-subtle-hovered, #B7B9BE)",
    'color.background.accent.gray.subtle.pressed': "var(--ds-background-accent-gray-subtle-pressed, #DDDEE1)",
    'color.background.accent.gray.bolder': "var(--ds-background-accent-gray-bolder, #6B6E76)",
    'color.background.accent.gray.bolder.hovered': "var(--ds-background-accent-gray-bolder-hovered, #505258)",
    'color.background.accent.gray.bolder.pressed': "var(--ds-background-accent-gray-bolder-pressed, #3B3D42)",
    'color.background.disabled': "var(--ds-background-disabled, #17171708)",
    'color.background.input': "var(--ds-background-input, #FFFFFF)",
    'color.background.input.hovered': "var(--ds-background-input-hovered, #F8F8F8)",
    'color.background.input.pressed': "var(--ds-background-input-pressed, #FFFFFF)",
    'color.background.inverse.subtle': "var(--ds-background-inverse-subtle, #00000029)",
    'color.background.inverse.subtle.hovered': "var(--ds-background-inverse-subtle-hovered, #0000003D)",
    'color.background.inverse.subtle.pressed': "var(--ds-background-inverse-subtle-pressed, #00000052)",
    'color.background.neutral': "var(--ds-background-neutral, #0515240F)",
    'color.background.neutral.hovered': "var(--ds-background-neutral-hovered, #0B120E24)",
    'color.background.neutral.pressed': "var(--ds-background-neutral-pressed, #080F214A)",
    'color.background.neutral.subtle': "var(--ds-background-neutral-subtle, #00000000)",
    'color.background.neutral.subtle.hovered': "var(--ds-background-neutral-subtle-hovered, #0515240F)",
    'color.background.neutral.subtle.pressed': "var(--ds-background-neutral-subtle-pressed, #0B120E24)",
    'color.background.neutral.bold': "var(--ds-background-neutral-bold, #292A2E)",
    'color.background.neutral.bold.hovered': "var(--ds-background-neutral-bold-hovered, #3B3D42)",
    'color.background.neutral.bold.pressed': "var(--ds-background-neutral-bold-pressed, #505258)",
    'color.background.selected': "var(--ds-background-selected, #E9F2FE)",
    'color.background.selected.hovered': "var(--ds-background-selected-hovered, #CFE1FD)",
    'color.background.selected.pressed': "var(--ds-background-selected-pressed, #8FB8F6)",
    'color.background.selected.bold': "var(--ds-background-selected-bold, #1868DB)",
    'color.background.selected.bold.hovered': "var(--ds-background-selected-bold-hovered, #1558BC)",
    'color.background.selected.bold.pressed': "var(--ds-background-selected-bold-pressed, #123263)",
    'color.background.brand.subtlest': "var(--ds-background-brand-subtlest, #E9F2FE)",
    'color.background.brand.subtlest.hovered': "var(--ds-background-brand-subtlest-hovered, #CFE1FD)",
    'color.background.brand.subtlest.pressed': "var(--ds-background-brand-subtlest-pressed, #ADCBFB)",
    'color.background.brand.bold': "var(--ds-background-brand-bold, #1868DB)",
    'color.background.brand.bold.hovered': "var(--ds-background-brand-bold-hovered, #1558BC)",
    'color.background.brand.bold.pressed': "var(--ds-background-brand-bold-pressed, #144794)",
    'color.background.brand.boldest': "var(--ds-background-brand-boldest, #1C2B42)",
    'color.background.brand.boldest.hovered': "var(--ds-background-brand-boldest-hovered, #123263)",
    'color.background.brand.boldest.pressed': "var(--ds-background-brand-boldest-pressed, #144794)",
    'color.background.danger': "var(--ds-background-danger, #FFECEB)",
    'color.background.danger.hovered': "var(--ds-background-danger-hovered, #FFD5D2)",
    'color.background.danger.pressed': "var(--ds-background-danger-pressed, #FFB8B2)",
    'color.background.danger.subtler': "var(--ds-background-danger-subtler, #FFD5D2)",
    'color.background.danger.subtler.hovered': "var(--ds-background-danger-subtler-hovered, #FFB8B2)",
    'color.background.danger.subtler.pressed': "var(--ds-background-danger-subtler-pressed, #FD9891)",
    'color.background.danger.bold': "var(--ds-background-danger-bold, #C9372C)",
    'color.background.danger.bold.hovered': "var(--ds-background-danger-bold-hovered, #AE2E24)",
    'color.background.danger.bold.pressed': "var(--ds-background-danger-bold-pressed, #872821)",
    'color.background.warning': "var(--ds-background-warning, #FFF5DB)",
    'color.background.warning.hovered': "var(--ds-background-warning-hovered, #FCE4A6)",
    'color.background.warning.pressed': "var(--ds-background-warning-pressed, #FBD779)",
    'color.background.warning.subtler': "var(--ds-background-warning-subtler, #FCE4A6)",
    'color.background.warning.subtler.hovered': "var(--ds-background-warning-subtler-hovered, #FBD779)",
    'color.background.warning.subtler.pressed': "var(--ds-background-warning-subtler-pressed, #FBC828)",
    'color.background.warning.bold': "var(--ds-background-warning-bold, #FBC828)",
    'color.background.warning.bold.hovered': "var(--ds-background-warning-bold-hovered, #FCA700)",
    'color.background.warning.bold.pressed': "var(--ds-background-warning-bold-pressed, #F68909)",
    'color.background.success': "var(--ds-background-success, #EFFFD6)",
    'color.background.success.hovered': "var(--ds-background-success-hovered, #D3F1A7)",
    'color.background.success.pressed': "var(--ds-background-success-pressed, #BDE97C)",
    'color.background.success.subtler': "var(--ds-background-success-subtler, #D3F1A7)",
    'color.background.success.subtler.hovered': "var(--ds-background-success-subtler-hovered, #BDE97C)",
    'color.background.success.subtler.pressed': "var(--ds-background-success-subtler-pressed, #B3DF72)",
    'color.background.success.bold': "var(--ds-background-success-bold, #5B7F24)",
    'color.background.success.bold.hovered': "var(--ds-background-success-bold-hovered, #4C6B1F)",
    'color.background.success.bold.pressed': "var(--ds-background-success-bold-pressed, #3F5224)",
    'color.background.discovery': "var(--ds-background-discovery, #F8EEFE)",
    'color.background.discovery.hovered': "var(--ds-background-discovery-hovered, #EED7FC)",
    'color.background.discovery.pressed': "var(--ds-background-discovery-pressed, #E3BDFA)",
    'color.background.discovery.subtler': "var(--ds-background-discovery-subtler, #EED7FC)",
    'color.background.discovery.subtler.hovered': "var(--ds-background-discovery-subtler-hovered, #E3BDFA)",
    'color.background.discovery.subtler.pressed': "var(--ds-background-discovery-subtler-pressed, #D8A0F7)",
    'color.background.discovery.bold': "var(--ds-background-discovery-bold, #964AC0)",
    'color.background.discovery.bold.hovered': "var(--ds-background-discovery-bold-hovered, #803FA5)",
    'color.background.discovery.bold.pressed': "var(--ds-background-discovery-bold-pressed, #673286)",
    'color.background.information': "var(--ds-background-information, #E9F2FE)",
    'color.background.information.hovered': "var(--ds-background-information-hovered, #CFE1FD)",
    'color.background.information.pressed': "var(--ds-background-information-pressed, #ADCBFB)",
    'color.background.information.subtler': "var(--ds-background-information-subtler, #CFE1FD)",
    'color.background.information.subtler.hovered': "var(--ds-background-information-subtler-hovered, #ADCBFB)",
    'color.background.information.subtler.pressed': "var(--ds-background-information-subtler-pressed, #8FB8F6)",
    'color.background.information.bold': "var(--ds-background-information-bold, #1868DB)",
    'color.background.information.bold.hovered': "var(--ds-background-information-bold-hovered, #1558BC)",
    'color.background.information.bold.pressed': "var(--ds-background-information-bold-pressed, #144794)",
    'color.blanket': "var(--ds-blanket, #050C1F75)",
    'color.blanket.selected': "var(--ds-blanket-selected, #388BFF14)",
    'color.blanket.danger': "var(--ds-blanket-danger, #EF5C4814)",
    'color.skeleton': "var(--ds-skeleton, #0515240F)",
    'color.skeleton.subtle': "var(--ds-skeleton-subtle, #17171708)",
    'elevation.surface': "var(--ds-surface, #FFFFFF)",
    'elevation.surface.hovered': "var(--ds-surface-hovered, #F0F1F2)",
    'elevation.surface.pressed': "var(--ds-surface-pressed, #DDDEE1)",
    'elevation.surface.overlay': "var(--ds-surface-overlay, #FFFFFF)",
    'elevation.surface.overlay.hovered': "var(--ds-surface-overlay-hovered, #F0F1F2)",
    'elevation.surface.overlay.pressed': "var(--ds-surface-overlay-pressed, #DDDEE1)",
    'elevation.surface.raised': "var(--ds-surface-raised, #FFFFFF)",
    'elevation.surface.raised.hovered': "var(--ds-surface-raised-hovered, #F0F1F2)",
    'elevation.surface.raised.pressed': "var(--ds-surface-raised-pressed, #DDDEE1)",
    'elevation.surface.sunken': "var(--ds-surface-sunken, #F8F8F8)",
    'utility.elevation.surface.current': "var(--ds-elevation-surface-current, #FFFFFF)"
};
var $e955727b9ac9b5b6$export$8473307aa00d6ea1 = {
    'color.text': "var(--ds-text, #292A2E)",
    'color.text.accent.lime': "var(--ds-text-accent-lime, #4C6B1F)",
    'color.text.accent.lime.bolder': "var(--ds-text-accent-lime-bolder, #37471F)",
    'color.text.accent.red': "var(--ds-text-accent-red, #AE2E24)",
    'color.text.accent.red.bolder': "var(--ds-text-accent-red-bolder, #5D1F1A)",
    'color.text.accent.orange': "var(--ds-text-accent-orange, #9E4C00)",
    'color.text.accent.orange.bolder': "var(--ds-text-accent-orange-bolder, #693200)",
    'color.text.accent.yellow': "var(--ds-text-accent-yellow, #7F5F01)",
    'color.text.accent.yellow.bolder': "var(--ds-text-accent-yellow-bolder, #533F04)",
    'color.text.accent.green': "var(--ds-text-accent-green, #216E4E)",
    'color.text.accent.green.bolder': "var(--ds-text-accent-green-bolder, #164B35)",
    'color.text.accent.teal': "var(--ds-text-accent-teal, #206A83)",
    'color.text.accent.teal.bolder': "var(--ds-text-accent-teal-bolder, #164555)",
    'color.text.accent.blue': "var(--ds-text-accent-blue, #1558BC)",
    'color.text.accent.blue.bolder': "var(--ds-text-accent-blue-bolder, #123263)",
    'color.text.accent.purple': "var(--ds-text-accent-purple, #803FA5)",
    'color.text.accent.purple.bolder': "var(--ds-text-accent-purple-bolder, #48245D)",
    'color.text.accent.magenta': "var(--ds-text-accent-magenta, #943D73)",
    'color.text.accent.magenta.bolder': "var(--ds-text-accent-magenta-bolder, #50253F)",
    'color.text.accent.gray': "var(--ds-text-accent-gray, #505258)",
    'color.text.accent.gray.bolder': "var(--ds-text-accent-gray-bolder, #1E1F21)",
    'color.text.disabled': "var(--ds-text-disabled, #080F214A)",
    'color.text.inverse': "var(--ds-text-inverse, #FFFFFF)",
    'color.text.selected': "var(--ds-text-selected, #1868DB)",
    'color.text.brand': "var(--ds-text-brand, #1868DB)",
    'color.text.danger': "var(--ds-text-danger, #AE2E24)",
    'color.text.danger.bolder': "var(--ds-text-danger-bolder, #5D1F1A)",
    'color.text.warning': "var(--ds-text-warning, #9E4C00)",
    'color.text.warning.inverse': "var(--ds-text-warning-inverse, #292A2E)",
    'color.text.warning.bolder': "var(--ds-text-warning-bolder, #693200)",
    'color.text.success': "var(--ds-text-success, #4C6B1F)",
    'color.text.success.bolder': "var(--ds-text-success-bolder, #37471F)",
    'color.text.discovery': "var(--ds-text-discovery, #803FA5)",
    'color.text.discovery.bolder': "var(--ds-text-discovery-bolder, #48245D)",
    'color.text.information': "var(--ds-text-information, #1558BC)",
    'color.text.information.bolder': "var(--ds-text-information-bolder, #123263)",
    'color.text.subtlest': "var(--ds-text-subtlest, #6B6E76)",
    'color.text.subtle': "var(--ds-text-subtle, #505258)",
    'color.link': "var(--ds-link, #1868DB)",
    'color.link.pressed': "var(--ds-link-pressed, #1558BC)",
    'color.link.visited': "var(--ds-link-visited, #803FA5)",
    'color.link.visited.pressed': "var(--ds-link-visited-pressed, #48245D)"
};
var $e955727b9ac9b5b6$export$498780f74be9af68 = {
    'color.icon': "var(--ds-icon, #292A2E)",
    'color.icon.accent.lime': "var(--ds-icon-accent-lime, #6A9A23)",
    'color.icon.accent.red': "var(--ds-icon-accent-red, #C9372C)",
    'color.icon.accent.orange': "var(--ds-icon-accent-orange, #E06C00)",
    'color.icon.accent.yellow': "var(--ds-icon-accent-yellow, #B38600)",
    'color.icon.accent.green': "var(--ds-icon-accent-green, #22A06B)",
    'color.icon.accent.teal': "var(--ds-icon-accent-teal, #2898BD)",
    'color.icon.accent.blue': "var(--ds-icon-accent-blue, #357DE8)",
    'color.icon.accent.purple': "var(--ds-icon-accent-purple, #AF59E1)",
    'color.icon.accent.magenta': "var(--ds-icon-accent-magenta, #CD519D)",
    'color.icon.accent.gray': "var(--ds-icon-accent-gray, #7D818A)",
    'color.icon.disabled': "var(--ds-icon-disabled, #080F214A)",
    'color.icon.inverse': "var(--ds-icon-inverse, #FFFFFF)",
    'color.icon.selected': "var(--ds-icon-selected, #1868DB)",
    'color.icon.brand': "var(--ds-icon-brand, #1868DB)",
    'color.icon.danger': "var(--ds-icon-danger, #C9372C)",
    'color.icon.warning': "var(--ds-icon-warning, #E06C00)",
    'color.icon.warning.inverse': "var(--ds-icon-warning-inverse, #292A2E)",
    'color.icon.success': "var(--ds-icon-success, #6A9A23)",
    'color.icon.discovery': "var(--ds-icon-discovery, #AF59E1)",
    'color.icon.information': "var(--ds-icon-information, #357DE8)",
    'color.icon.subtlest': "var(--ds-icon-subtlest, #6B6E76)",
    'color.icon.subtle': "var(--ds-icon-subtle, #505258)"
};
var $e955727b9ac9b5b6$export$b5f31a7e431d2eab = {
    '1': 1,
    card: 100,
    navigation: 200,
    dialog: 300,
    layer: 400,
    blanket: 500,
    modal: 510,
    flag: 600,
    spotlight: 700,
    tooltip: 800
};
var $e955727b9ac9b5b6$export$e1b83c5210c471b8 = {
    'border.width': "var(--ds-border-width, 1px)",
    'border.width.selected': "var(--ds-border-width-selected, 2px)",
    'border.width.focused': "var(--ds-border-width-focused, 2px)"
};
var $e955727b9ac9b5b6$export$3c0a6c3e64bb180d = {
    'radius.xsmall': "var(--ds-radius-xsmall, 2px)",
    'radius.small': "var(--ds-radius-small, 3px)",
    'radius.medium': "var(--ds-radius-medium, 6px)",
    'radius.large': "var(--ds-radius-large, 8px)",
    'radius.xlarge': "var(--ds-radius-xlarge, 12px)",
    'radius.xxlarge': "var(--ds-radius-xxlarge, 16px)",
    'radius.full': "var(--ds-radius-full, 9999px)",
    'radius.tile': "var(--ds-radius-tile, 25%)"
};
var $e955727b9ac9b5b6$export$6ffa317d5e70375 = {
    'font.body': "var(--ds-font-body, normal 400 14px/20px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.body.large': "var(--ds-font-body-large, normal 400 16px/24px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.body.small': "var(--ds-font-body-small, normal 400 12px/16px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.code': "var(--ds-font-code, normal 400 0.875em/1 \"Atlassian Mono\", ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)",
    'font.heading.large': "var(--ds-font-heading-large, normal 653 24px/28px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.heading.medium': "var(--ds-font-heading-medium, normal 653 20px/24px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.heading.small': "var(--ds-font-heading-small, normal 653 16px/20px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.heading.xlarge': "var(--ds-font-heading-xlarge, normal 653 28px/32px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.heading.xsmall': "var(--ds-font-heading-xsmall, normal 653 14px/20px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.heading.xxlarge': "var(--ds-font-heading-xxlarge, normal 653 32px/36px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.heading.xxsmall': "var(--ds-font-heading-xxsmall, normal 653 12px/16px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.metric.large': "var(--ds-font-metric-large, normal 653 28px/32px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.metric.medium': "var(--ds-font-metric-medium, normal 653 24px/28px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.metric.small': "var(--ds-font-metric-small, normal 653 16px/20px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
};
var $e955727b9ac9b5b6$export$303e322c6b1ed114 = {
    'font.weight.bold': "var(--ds-font-weight-bold, 653)",
    'font.weight.medium': "var(--ds-font-weight-medium, 500)",
    'font.weight.regular': "var(--ds-font-weight-regular, 400)",
    'font.weight.semibold': "var(--ds-font-weight-semibold, 600)"
};
var $e955727b9ac9b5b6$export$3c7e9587132614b4 = {
    'font.family.body': "var(--ds-font-family-body, \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.family.brand.body': "var(--ds-font-family-brand-body, \"Charlie Text\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.family.brand.heading': "var(--ds-font-family-brand-heading, \"Charlie Display\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.family.code': "var(--ds-font-family-code, \"Atlassian Mono\", ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)",
    'font.family.heading': "var(--ds-font-family-heading, \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
};
var $e955727b9ac9b5b6$export$236bfe3a33ef1292 = {
    medium: "var(--ds-font-body, normal 400 14px/20px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    large: "var(--ds-font-body-large, normal 400 16px/24px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    small: "var(--ds-font-body-small, normal 400 12px/16px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
};
var $e955727b9ac9b5b6$export$855cfd311192d666 = {
    bold: "var(--ds-font-weight-bold, 653)",
    medium: "var(--ds-font-weight-medium, 500)",
    regular: "var(--ds-font-weight-regular, 400)",
    semibold: "var(--ds-font-weight-semibold, 600)"
};
var $e955727b9ac9b5b6$export$b805719bc8cb376 = {
    large: "var(--ds-font-metric-large, normal 653 28px/32px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    medium: "var(--ds-font-metric-medium, normal 653 24px/28px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    small: "var(--ds-font-metric-small, normal 653 16px/20px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
};
/**
 * @codegenEnd
 */ // Margin needs some bespoke types: https://atlassian.slack.com/archives/CKRHB23K8/p1712623192772909
/**
 * Token functions are currently allowed for borderRadius in xcss to ease migration.
 * Because 'radius.small' defaults to 3px, we need a mechanism to allow for 4px values to be provided:
 * This is done by calling the token function - token('radius.small')
 *
 * TODO: Remove once shape them is rolled out and fg platform-dst-shape-theme-default removed
 */ // Generate maps for Box props. backgroundColor, padding, etc
var $e955727b9ac9b5b6$var$spacingProperties = [
    // Used by Box
    'padding',
    'paddingBlock',
    'paddingBlockStart',
    'paddingBlockEnd',
    'paddingInline',
    'paddingInlineStart',
    'paddingInlineEnd',
    // Used by Inline and Stack
    'gap',
    'rowGap',
    'columnGap'
];
var $e955727b9ac9b5b6$export$ca0f9c2de39ffed7 = function getSerializedStylesMap(cssProperty, tokenMap) {
    return Object.keys(tokenMap).reduce(function(emotionSpacingMap, token) {
        // eslint-disable-next-line @repo/internal/styles/no-exported-styles
        emotionSpacingMap[token] = (0, $74Zh5.css)((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, cssProperty, tokenMap[token]));
        return emotionSpacingMap;
    }, {});
};
var $e955727b9ac9b5b6$export$e615f061ca585a6c = $e955727b9ac9b5b6$var$spacingProperties.reduce(function(styleMap, spacingProperty) {
    styleMap[spacingProperty] = $e955727b9ac9b5b6$export$ca0f9c2de39ffed7(spacingProperty, $e955727b9ac9b5b6$export$958d0ae7f2977ae4);
    return styleMap;
}, {});
var $e955727b9ac9b5b6$export$bf46c3f9eeafc71f = $e955727b9ac9b5b6$var$spacingProperties.reduce(function(styleMap, spacingProperty) {
    styleMap[spacingProperty] = $e955727b9ac9b5b6$export$ca0f9c2de39ffed7(spacingProperty, $e955727b9ac9b5b6$export$958d0ae7f2977ae4);
    return styleMap;
}, {});
var $e955727b9ac9b5b6$export$e7af83bafe7f9e63 = $e955727b9ac9b5b6$export$ca0f9c2de39ffed7('backgroundColor', $e955727b9ac9b5b6$export$d1d79bf68ac056bd);
var $e955727b9ac9b5b6$export$3a1bcba60b23d7f0 = $e955727b9ac9b5b6$export$ca0f9c2de39ffed7('color', $e955727b9ac9b5b6$export$8473307aa00d6ea1);
var $e955727b9ac9b5b6$export$45f3f4fe16f9f7d5 = $e955727b9ac9b5b6$export$ca0f9c2de39ffed7('fontWeight', $e955727b9ac9b5b6$export$303e322c6b1ed114);
var $e955727b9ac9b5b6$export$68cc305da27dbaa4 = $e955727b9ac9b5b6$export$ca0f9c2de39ffed7('fontFamily', $e955727b9ac9b5b6$export$3c7e9587132614b4);
var $e955727b9ac9b5b6$export$128f10c238242f83 = $e955727b9ac9b5b6$export$ca0f9c2de39ffed7('font', $e955727b9ac9b5b6$export$6ffa317d5e70375);
var $e955727b9ac9b5b6$export$219d364c0da35ae4 = $e955727b9ac9b5b6$export$ca0f9c2de39ffed7('font', $e955727b9ac9b5b6$export$236bfe3a33ef1292);
var $e955727b9ac9b5b6$export$38845ca010b93505 = $e955727b9ac9b5b6$export$ca0f9c2de39ffed7('fontWeight', $e955727b9ac9b5b6$export$855cfd311192d666);
var $e955727b9ac9b5b6$export$ff257d957d48c421 = $e955727b9ac9b5b6$export$ca0f9c2de39ffed7((0, $9AP5g.CURRENT_SURFACE_CSS_VAR), $e955727b9ac9b5b6$export$41a358c9c2356760);
var $e955727b9ac9b5b6$export$5e65a44e5b6ecadb = function isSurfaceColorToken(color) {
    return $e955727b9ac9b5b6$export$41a358c9c2356760[color] !== undefined;
};
var $e955727b9ac9b5b6$export$7001ce64d9ff7c7f = $e955727b9ac9b5b6$export$ca0f9c2de39ffed7('font', $e955727b9ac9b5b6$export$b805719bc8cb376);



var $fC8ib = parcelRequire("fC8ib");

var $25nEq = parcelRequire("25nEq");

var $iYJcE = parcelRequire("iYJcE");

var $ekGgq = parcelRequire("ekGgq");

var $74Zh5 = parcelRequire("74Zh5");


var $3ZMUU = parcelRequire("3ZMUU");
function $c1bec583fa49072f$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $c1bec583fa49072f$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $c1bec583fa49072f$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $c1bec583fa49072f$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $c1bec583fa49072f$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $c1bec583fa49072f$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
var $c1bec583fa49072f$export$9a199fbafee0014e = {
    backgroundColor: (0, $e955727b9ac9b5b6$export$d1d79bf68ac056bd),
    blockSize: (0, $e955727b9ac9b5b6$export$6ccdbebca2ee545f),
    borderBlockColor: (0, $e955727b9ac9b5b6$export$1531ad5bb3fbedac),
    borderBlockEndColor: (0, $e955727b9ac9b5b6$export$1531ad5bb3fbedac),
    borderBlockEndWidth: (0, $e955727b9ac9b5b6$export$e1b83c5210c471b8),
    borderBlockStartColor: (0, $e955727b9ac9b5b6$export$1531ad5bb3fbedac),
    borderBlockStartWidth: (0, $e955727b9ac9b5b6$export$e1b83c5210c471b8),
    borderBlockWidth: (0, $e955727b9ac9b5b6$export$e1b83c5210c471b8),
    borderBottomColor: (0, $e955727b9ac9b5b6$export$1531ad5bb3fbedac),
    borderBottomLeftRadius: (0, $e955727b9ac9b5b6$export$3c0a6c3e64bb180d),
    borderBottomRightRadius: (0, $e955727b9ac9b5b6$export$3c0a6c3e64bb180d),
    borderBottomWidth: (0, $e955727b9ac9b5b6$export$e1b83c5210c471b8),
    borderColor: (0, $e955727b9ac9b5b6$export$1531ad5bb3fbedac),
    borderEndEndRadius: (0, $e955727b9ac9b5b6$export$3c0a6c3e64bb180d),
    borderEndStartRadius: (0, $e955727b9ac9b5b6$export$3c0a6c3e64bb180d),
    borderInlineColor: (0, $e955727b9ac9b5b6$export$1531ad5bb3fbedac),
    borderInlineEndColor: (0, $e955727b9ac9b5b6$export$1531ad5bb3fbedac),
    borderInlineEndWidth: (0, $e955727b9ac9b5b6$export$e1b83c5210c471b8),
    borderInlineStartColor: (0, $e955727b9ac9b5b6$export$1531ad5bb3fbedac),
    borderInlineStartWidth: (0, $e955727b9ac9b5b6$export$e1b83c5210c471b8),
    borderInlineWidth: (0, $e955727b9ac9b5b6$export$e1b83c5210c471b8),
    borderLeftColor: (0, $e955727b9ac9b5b6$export$1531ad5bb3fbedac),
    borderLeftWidth: (0, $e955727b9ac9b5b6$export$e1b83c5210c471b8),
    borderRadius: (0, $e955727b9ac9b5b6$export$3c0a6c3e64bb180d),
    borderRightColor: (0, $e955727b9ac9b5b6$export$1531ad5bb3fbedac),
    borderRightWidth: (0, $e955727b9ac9b5b6$export$e1b83c5210c471b8),
    borderStartEndRadius: (0, $e955727b9ac9b5b6$export$3c0a6c3e64bb180d),
    borderStartStartRadius: (0, $e955727b9ac9b5b6$export$3c0a6c3e64bb180d),
    borderTopColor: (0, $e955727b9ac9b5b6$export$1531ad5bb3fbedac),
    borderTopLeftRadius: (0, $e955727b9ac9b5b6$export$3c0a6c3e64bb180d),
    borderTopRightRadius: (0, $e955727b9ac9b5b6$export$3c0a6c3e64bb180d),
    borderTopWidth: (0, $e955727b9ac9b5b6$export$e1b83c5210c471b8),
    borderWidth: (0, $e955727b9ac9b5b6$export$e1b83c5210c471b8),
    bottom: (0, $e955727b9ac9b5b6$export$632685d741f3dbbf),
    boxShadow: (0, $e955727b9ac9b5b6$export$7aff6e7ba39bb774),
    color: (0, $e955727b9ac9b5b6$export$8473307aa00d6ea1),
    columnGap: (0, $e955727b9ac9b5b6$export$958d0ae7f2977ae4),
    font: (0, $e955727b9ac9b5b6$export$6ffa317d5e70375),
    fontFamily: (0, $e955727b9ac9b5b6$export$3c7e9587132614b4),
    fontWeight: (0, $e955727b9ac9b5b6$export$303e322c6b1ed114),
    gap: (0, $e955727b9ac9b5b6$export$958d0ae7f2977ae4),
    height: (0, $e955727b9ac9b5b6$export$6ccdbebca2ee545f),
    inlineSize: (0, $e955727b9ac9b5b6$export$6ccdbebca2ee545f),
    inset: (0, $e955727b9ac9b5b6$export$632685d741f3dbbf),
    insetBlock: (0, $e955727b9ac9b5b6$export$632685d741f3dbbf),
    insetBlockEnd: (0, $e955727b9ac9b5b6$export$632685d741f3dbbf),
    insetBlockStart: (0, $e955727b9ac9b5b6$export$632685d741f3dbbf),
    insetInline: (0, $e955727b9ac9b5b6$export$632685d741f3dbbf),
    insetInlineEnd: (0, $e955727b9ac9b5b6$export$632685d741f3dbbf),
    insetInlineStart: (0, $e955727b9ac9b5b6$export$632685d741f3dbbf),
    left: (0, $e955727b9ac9b5b6$export$632685d741f3dbbf),
    margin: (0, $e955727b9ac9b5b6$export$632685d741f3dbbf),
    marginBlock: (0, $e955727b9ac9b5b6$export$632685d741f3dbbf),
    marginBlockEnd: (0, $e955727b9ac9b5b6$export$632685d741f3dbbf),
    marginBlockStart: (0, $e955727b9ac9b5b6$export$632685d741f3dbbf),
    marginBottom: (0, $e955727b9ac9b5b6$export$632685d741f3dbbf),
    marginInline: (0, $e955727b9ac9b5b6$export$632685d741f3dbbf),
    marginInlineEnd: (0, $e955727b9ac9b5b6$export$632685d741f3dbbf),
    marginInlineStart: (0, $e955727b9ac9b5b6$export$632685d741f3dbbf),
    marginLeft: (0, $e955727b9ac9b5b6$export$632685d741f3dbbf),
    marginRight: (0, $e955727b9ac9b5b6$export$632685d741f3dbbf),
    marginTop: (0, $e955727b9ac9b5b6$export$632685d741f3dbbf),
    maxBlockSize: (0, $e955727b9ac9b5b6$export$6ccdbebca2ee545f),
    maxHeight: (0, $e955727b9ac9b5b6$export$6ccdbebca2ee545f),
    maxInlineSize: (0, $e955727b9ac9b5b6$export$6ccdbebca2ee545f),
    maxWidth: (0, $e955727b9ac9b5b6$export$6ccdbebca2ee545f),
    minBlockSize: (0, $e955727b9ac9b5b6$export$6ccdbebca2ee545f),
    minHeight: (0, $e955727b9ac9b5b6$export$6ccdbebca2ee545f),
    minInlineSize: (0, $e955727b9ac9b5b6$export$6ccdbebca2ee545f),
    minWidth: (0, $e955727b9ac9b5b6$export$6ccdbebca2ee545f),
    opacity: (0, $e955727b9ac9b5b6$export$daf94a976c798b4f),
    outlineColor: (0, $e955727b9ac9b5b6$export$1531ad5bb3fbedac),
    outlineOffset: (0, $e955727b9ac9b5b6$export$632685d741f3dbbf),
    outlineWidth: (0, $e955727b9ac9b5b6$export$e1b83c5210c471b8),
    padding: (0, $e955727b9ac9b5b6$export$958d0ae7f2977ae4),
    paddingBlock: (0, $e955727b9ac9b5b6$export$958d0ae7f2977ae4),
    paddingBlockEnd: (0, $e955727b9ac9b5b6$export$958d0ae7f2977ae4),
    paddingBlockStart: (0, $e955727b9ac9b5b6$export$958d0ae7f2977ae4),
    paddingBottom: (0, $e955727b9ac9b5b6$export$958d0ae7f2977ae4),
    paddingInline: (0, $e955727b9ac9b5b6$export$958d0ae7f2977ae4),
    paddingInlineEnd: (0, $e955727b9ac9b5b6$export$958d0ae7f2977ae4),
    paddingInlineStart: (0, $e955727b9ac9b5b6$export$958d0ae7f2977ae4),
    paddingLeft: (0, $e955727b9ac9b5b6$export$958d0ae7f2977ae4),
    paddingRight: (0, $e955727b9ac9b5b6$export$958d0ae7f2977ae4),
    paddingTop: (0, $e955727b9ac9b5b6$export$958d0ae7f2977ae4),
    right: (0, $e955727b9ac9b5b6$export$632685d741f3dbbf),
    rowGap: (0, $e955727b9ac9b5b6$export$958d0ae7f2977ae4),
    top: (0, $e955727b9ac9b5b6$export$632685d741f3dbbf),
    width: (0, $e955727b9ac9b5b6$export$6ccdbebca2ee545f),
    zIndex: (0, $e955727b9ac9b5b6$export$b5f31a7e431d2eab)
};
var $c1bec583fa49072f$var$uniqueSymbol = Symbol('UNSAFE_INTERNAL_styles');
var $c1bec583fa49072f$var$isSafeEnvToThrow = function isSafeEnvToThrow() {
    return (typeof $3ZMUU === "undefined" ? "undefined" : (0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))($3ZMUU)) === 'object' && (0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))($3ZMUU.env) === 'object' && false;
};
var $c1bec583fa49072f$var$reNestedSelectors = /(\.|\s|&+|\*\>|#|\[.*\])/;
var $c1bec583fa49072f$var$safeSelectors = /^@media .*$|^::?.*$|^@supports .*$/;
var $c1bec583fa49072f$var$_transformStyles = function transformStyles(styleObj) {
    if (!styleObj || (0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(styleObj) !== 'object') return styleObj;
    // If styles are defined as a CSSObject[], recursively call on each element until we reach CSSObject
    if (Array.isArray(styleObj)) return styleObj.map($c1bec583fa49072f$var$_transformStyles);
    // Modifies styleObj in place. Be careful.
    Object.entries(styleObj).forEach(function(_ref) {
        var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_ref, 2), key = _ref2[0], value = _ref2[1];
        // If key is a pseudo class or a pseudo element, then value should be an object.
        // So, call transformStyles on the value
        if ((0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(value) === 'object' && $c1bec583fa49072f$var$safeSelectors.test(key)) {
            styleObj[key] = $c1bec583fa49072f$var$_transformStyles(value);
            return;
        }
        if ($c1bec583fa49072f$var$isSafeEnvToThrow()) {
            // We don't support `.class`, `[data-testid]`, `> *`, `#some-id`
            if ($c1bec583fa49072f$var$reNestedSelectors.test(key)) throw new Error("Styles not supported for key '".concat(key, "'."));
        }
        // We have now dealt with all the special cases, so,
        // check whether what remains is a style property
        // that can be transformed.
        if (!(key in $c1bec583fa49072f$export$9a199fbafee0014e)) return;
        var tokenValue = $c1bec583fa49072f$export$9a199fbafee0014e[key][value];
        styleObj[key] = tokenValue !== null && tokenValue !== void 0 ? tokenValue : value;
    });
    return styleObj;
};
var $c1bec583fa49072f$var$baseXcss = function baseXcss(style) {
    var transformedStyles = $c1bec583fa49072f$var$_transformStyles(style);
    return (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, $c1bec583fa49072f$var$uniqueSymbol, (0, $74Zh5.css)(transformedStyles));
};
/**
 * Picks out runtime XCSS objects and build-time XCSS strings. This is needed
 * to supported both Emotion and Compiled styles until we've fully migrated
 * to Compiled.
 *
 * @private
 * @deprecated
 */ var $c1bec583fa49072f$export$a9c84988c8f81f2d = function parseXcss(args) {
    if (Array.isArray(args)) {
        var emotion = [];
        var staticArr = [];
        var _iterator = $c1bec583fa49072f$var$_createForOfIteratorHelper(args), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var arg = _step.value;
                var result = $c1bec583fa49072f$export$a9c84988c8f81f2d(arg);
                if (result.emotion) emotion.push.apply(emotion, (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(result.emotion));
                if (result.static) staticArr.push(result.static);
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
        return {
            emotion: emotion,
            static: staticArr.join(' ')
        };
    }
    var objArgs = args;
    var _ref4 = objArgs || {}, styles = _ref4[$c1bec583fa49072f$var$uniqueSymbol];
    if (styles) return {
        emotion: [
            styles
        ]
    };
    if (args) {
        // We use string interpolation here instead of .toString() just
        // in case the resulting object doesn't have the method available.
        var stringifiedArgs = "".concat(args);
        if (stringifiedArgs) return {
            static: stringifiedArgs
        };
    }
    return {};
};
function $c1bec583fa49072f$export$f6c783d06584602c(style) {
    return $c1bec583fa49072f$var$baseXcss(style);
}


var $383dd904a5a5e5b0$var$_excluded = [
    "as",
    "children",
    "backgroundColor",
    "padding",
    "paddingBlock",
    "paddingBlockStart",
    "paddingBlockEnd",
    "paddingInline",
    "paddingInlineStart",
    "paddingInlineEnd",
    "style",
    "testId",
    "xcss"
], $383dd904a5a5e5b0$var$_excluded2 = [
    "className"
];
var $383dd904a5a5e5b0$export$e71c4d32a2263218 = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? 'div' : _ref$as, children = _ref.children, backgroundColor = _ref.backgroundColor, padding = _ref.padding, paddingBlock = _ref.paddingBlock, paddingBlockStart = _ref.paddingBlockStart, paddingBlockEnd = _ref.paddingBlockEnd, paddingInline = _ref.paddingInline, paddingInlineStart = _ref.paddingInlineStart, paddingInlineEnd = _ref.paddingInlineEnd, style = _ref.style, testId = _ref.testId, xcss = _ref.xcss, htmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $383dd904a5a5e5b0$var$_excluded);
    // This is to remove className from safeHtmlAttributes
    // @ts-ignore -- not using expect since it causes issues with help-center local consumption - className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(htmlAttributes, $383dd904a5a5e5b0$var$_excluded2);
    var resolvedStyles = (0, $c1bec583fa49072f$export$a9c84988c8f81f2d)(xcss);
    var node = // @ts-expect-error Expression produces a union type that is too complex to represent. I think this is unavoidable
    (0, $74Zh5.jsx)(Component, (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        style: style,
        ref: ref,
        className: resolvedStyles.static
    }, safeHtmlAttributes, {
        css: [
            $383dd904a5a5e5b0$var$baseStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            backgroundColor && (0, $e955727b9ac9b5b6$export$e7af83bafe7f9e63)[backgroundColor],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $e955727b9ac9b5b6$export$5e65a44e5b6ecadb)(backgroundColor) && (0, $e955727b9ac9b5b6$export$ff257d957d48c421)[backgroundColor],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            padding && (0, $e955727b9ac9b5b6$export$e615f061ca585a6c).padding[padding],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlock && (0, $e955727b9ac9b5b6$export$e615f061ca585a6c).paddingBlock[paddingBlock],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlockStart && (0, $e955727b9ac9b5b6$export$e615f061ca585a6c).paddingBlockStart[paddingBlockStart],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlockEnd && (0, $e955727b9ac9b5b6$export$e615f061ca585a6c).paddingBlockEnd[paddingBlockEnd],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInline && (0, $e955727b9ac9b5b6$export$e615f061ca585a6c).paddingInline[paddingInline],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInlineStart && (0, $e955727b9ac9b5b6$export$e615f061ca585a6c).paddingInlineStart[paddingInlineStart],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInlineEnd && (0, $e955727b9ac9b5b6$export$e615f061ca585a6c).paddingInlineEnd[paddingInlineEnd],
            resolvedStyles.emotion
        ],
        "data-testid": testId
    }), children);
    return backgroundColor ? (0, $74Zh5.jsx)((0, $6aab085817c2aae8$export$1ca2a26fecb070ae).Provider, {
        value: backgroundColor
    }, node) : node;
});
var $383dd904a5a5e5b0$export$2e2bcd8739ae039 = $383dd904a5a5e5b0$export$e71c4d32a2263218;
var $383dd904a5a5e5b0$var$baseStyles = (0, $74Zh5.css)({
    boxSizing: 'border-box',
    appearance: 'none',
    border: 'none'
});


var $fC8ib = parcelRequire("fC8ib");

var $5FkrB = parcelRequire("5FkrB");

var $74Zh5 = parcelRequire("74Zh5");


var $1b254ba6a068f2f1$var$justifyContentMap = {
    start: (0, $74Zh5.css)({
        justifyContent: 'start'
    }),
    center: (0, $74Zh5.css)({
        justifyContent: 'center'
    }),
    end: (0, $74Zh5.css)({
        justifyContent: 'end'
    }),
    'space-between': (0, $74Zh5.css)({
        justifyContent: 'space-between'
    }),
    'space-around': (0, $74Zh5.css)({
        justifyContent: 'space-around'
    }),
    'space-evenly': (0, $74Zh5.css)({
        justifyContent: 'space-evenly'
    }),
    stretch: (0, $74Zh5.css)({
        justifyContent: 'stretch'
    })
};
var $1b254ba6a068f2f1$var$flexDirectionMap = {
    column: (0, $74Zh5.css)({
        flexDirection: 'column'
    }),
    row: (0, $74Zh5.css)({
        flexDirection: 'row'
    })
};
var $1b254ba6a068f2f1$var$flexWrapMap = {
    wrap: (0, $74Zh5.css)({
        flexWrap: 'wrap'
    }),
    nowrap: (0, $74Zh5.css)({
        flexWrap: 'nowrap'
    })
};
var $1b254ba6a068f2f1$var$alignItemsMap = {
    start: (0, $74Zh5.css)({
        alignItems: 'start'
    }),
    center: (0, $74Zh5.css)({
        alignItems: 'center'
    }),
    baseline: (0, $74Zh5.css)({
        alignItems: 'baseline'
    }),
    end: (0, $74Zh5.css)({
        alignItems: 'end'
    }),
    stretch: (0, $74Zh5.css)({
        alignItems: 'stretch'
    })
};
var $1b254ba6a068f2f1$var$baseStyles = (0, $74Zh5.css)({
    display: 'flex',
    boxSizing: 'border-box'
});
/**
 * __Flex__
 *
 * `Flex` is a primitive component that implements the CSS Flexbox API.
 *
 * - [Examples](https://atlassian.design/components/primitives/flex/examples)
 * - [Code](https://atlassian.design/components/primitives/flex/code)
 *
 * @example
 * ```tsx
 * // eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
 * import { Flex, Box } from '@atlaskit/primitives'
 *
 * const Component = () => (
 *   <Flex direction="column">
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *   </Flex>
 * )
 * ```
 */ var $1b254ba6a068f2f1$var$Flex = /*#__PURE__*/ (0, $5FkrB.memo)(/*#__PURE__*/ (0, $5FkrB.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? 'div' : _ref$as, role = _ref.role, alignItems = _ref.alignItems, justifyContent = _ref.justifyContent, gap = _ref.gap, columnGap = _ref.columnGap, rowGap = _ref.rowGap, children = _ref.children, testId = _ref.testId, direction = _ref.direction, wrap = _ref.wrap, xcss = _ref.xcss, id = _ref.id;
    var resolvedStyles = (0, $c1bec583fa49072f$export$a9c84988c8f81f2d)(xcss);
    return (0, $74Zh5.jsx)(Component, {
        id: id,
        role: role,
        className: resolvedStyles.static,
        css: [
            $1b254ba6a068f2f1$var$baseStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            gap && (0, $e955727b9ac9b5b6$export$bf46c3f9eeafc71f).gap[gap],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            columnGap && (0, $e955727b9ac9b5b6$export$bf46c3f9eeafc71f).columnGap[columnGap],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            rowGap && (0, $e955727b9ac9b5b6$export$bf46c3f9eeafc71f).rowGap[rowGap],
            alignItems && $1b254ba6a068f2f1$var$alignItemsMap[alignItems],
            direction && $1b254ba6a068f2f1$var$flexDirectionMap[direction],
            justifyContent && $1b254ba6a068f2f1$var$justifyContentMap[justifyContent],
            wrap && $1b254ba6a068f2f1$var$flexWrapMap[wrap]
        ].concat((0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(resolvedStyles.emotion || [])),
        "data-testid": testId,
        ref: ref
    }, children);
}));
$1b254ba6a068f2f1$var$Flex.displayName = 'Flex';
var $1b254ba6a068f2f1$export$2e2bcd8739ae039 = $1b254ba6a068f2f1$var$Flex;



var $9ztDu = parcelRequire("9ztDu");

var $d1G9Q = parcelRequire("d1G9Q");
/**
 * Actions represent the type of change to a location value.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#action
 */ var $c29d101a2cf08ade$export$e19cd5f9376f8cee;
(function(Action) {
    /**
   * A POP indicates a change to an arbitrary index in the history stack, such
   * as a back or forward navigation. It does not describe the direction of the
   * navigation, only that the current index changed.
   *
   * Note: This is the default action for newly created history objects.
   */ Action["Pop"] = "POP";
    /**
   * A PUSH indicates a new entry being added to the history stack, such as when
   * a link is clicked and a new page loads. When this happens, all subsequent
   * entries in the stack are lost.
   */ Action["Push"] = "PUSH";
    /**
   * A REPLACE indicates the entry at the current index in the history stack
   * being replaced by a new one.
   */ Action["Replace"] = "REPLACE";
})($c29d101a2cf08ade$export$e19cd5f9376f8cee || ($c29d101a2cf08ade$export$e19cd5f9376f8cee = {}));
var $c29d101a2cf08ade$var$readOnly = function(obj) {
    return obj;
};
function $c29d101a2cf08ade$var$warning(cond, message) {
    if (!cond) {
        // eslint-disable-next-line no-console
        if (typeof console !== 'undefined') console.warn(message);
        try {
            // Welcome to debugging history!
            //
            // This error is thrown as a convenience so you can more easily
            // find the source for a warning that appears in the console by
            // enabling "pause on exceptions" in your JavaScript debugger.
            throw new Error(message); // eslint-disable-next-line no-empty
        } catch (e) {}
    }
}
var $c29d101a2cf08ade$var$BeforeUnloadEventType = 'beforeunload';
var $c29d101a2cf08ade$var$HashChangeEventType = 'hashchange';
var $c29d101a2cf08ade$var$PopStateEventType = 'popstate';
/**
 * Browser history stores the location in regular URLs. This is the standard for
 * most web apps, but it requires some configuration on the server to ensure you
 * serve the same app at multiple URLs.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createbrowserhistory
 */ function $c29d101a2cf08ade$export$719fc203c4e16dee(options) {
    if (options === void 0) options = {};
    var _options = options, _options$window = _options.window, window = _options$window === void 0 ? document.defaultView : _options$window;
    var globalHistory = window.history;
    function getIndexAndLocation() {
        var _window$location = window.location, pathname = _window$location.pathname, search = _window$location.search, hash = _window$location.hash;
        var state = globalHistory.state || {};
        return [
            state.idx,
            $c29d101a2cf08ade$var$readOnly({
                pathname: pathname,
                search: search,
                hash: hash,
                state: state.usr || null,
                key: state.key || 'default'
            })
        ];
    }
    var blockedPopTx = null;
    function handlePop() {
        if (blockedPopTx) {
            blockers.call(blockedPopTx);
            blockedPopTx = null;
        } else {
            var nextAction = $c29d101a2cf08ade$export$e19cd5f9376f8cee.Pop;
            var _getIndexAndLocation = getIndexAndLocation(), nextIndex = _getIndexAndLocation[0], nextLocation = _getIndexAndLocation[1];
            if (blockers.length) {
                if (nextIndex != null) {
                    var delta = index - nextIndex;
                    if (delta) {
                        // Revert the POP
                        blockedPopTx = {
                            action: nextAction,
                            location: nextLocation,
                            retry: function retry() {
                                go(delta * -1);
                            }
                        };
                        go(delta);
                    }
                }
            } else applyTx(nextAction);
        }
    }
    window.addEventListener($c29d101a2cf08ade$var$PopStateEventType, handlePop);
    var action = $c29d101a2cf08ade$export$e19cd5f9376f8cee.Pop;
    var _getIndexAndLocation2 = getIndexAndLocation(), index = _getIndexAndLocation2[0], location = _getIndexAndLocation2[1];
    var listeners = $c29d101a2cf08ade$var$createEvents();
    var blockers = $c29d101a2cf08ade$var$createEvents();
    if (index == null) {
        index = 0;
        globalHistory.replaceState((0, $d1G9Q.default)({}, globalHistory.state, {
            idx: index
        }), '');
    }
    function createHref(to) {
        return typeof to === 'string' ? to : $c29d101a2cf08ade$export$fe53371bee54353d(to);
    } // state defaults to `null` because `window.history.state` does
    function getNextLocation(to, state) {
        if (state === void 0) state = null;
        return $c29d101a2cf08ade$var$readOnly((0, $d1G9Q.default)({
            pathname: location.pathname,
            hash: '',
            search: ''
        }, typeof to === 'string' ? $c29d101a2cf08ade$export$8ccf933b0513f8d0(to) : to, {
            state: state,
            key: $c29d101a2cf08ade$var$createKey()
        }));
    }
    function getHistoryStateAndUrl(nextLocation, index) {
        return [
            {
                usr: nextLocation.state,
                key: nextLocation.key,
                idx: index
            },
            createHref(nextLocation)
        ];
    }
    function allowTx(action, location, retry) {
        return !blockers.length || (blockers.call({
            action: action,
            location: location,
            retry: retry
        }), false);
    }
    function applyTx(nextAction) {
        action = nextAction;
        var _getIndexAndLocation3 = getIndexAndLocation();
        index = _getIndexAndLocation3[0];
        location = _getIndexAndLocation3[1];
        listeners.call({
            action: action,
            location: location
        });
    }
    function push(to, state) {
        var nextAction = $c29d101a2cf08ade$export$e19cd5f9376f8cee.Push;
        var nextLocation = getNextLocation(to, state);
        function retry() {
            push(to, state);
        }
        if (allowTx(nextAction, nextLocation, retry)) {
            var _getHistoryStateAndUr = getHistoryStateAndUrl(nextLocation, index + 1), historyState = _getHistoryStateAndUr[0], url = _getHistoryStateAndUr[1]; // TODO: Support forced reloading
            // try...catch because iOS limits us to 100 pushState calls :/
            try {
                globalHistory.pushState(historyState, '', url);
            } catch (error) {
                // They are going to lose state here, but there is no real
                // way to warn them about it since the page will refresh...
                window.location.assign(url);
            }
            applyTx(nextAction);
        }
    }
    function replace(to, state) {
        var nextAction = $c29d101a2cf08ade$export$e19cd5f9376f8cee.Replace;
        var nextLocation = getNextLocation(to, state);
        function retry() {
            replace(to, state);
        }
        if (allowTx(nextAction, nextLocation, retry)) {
            var _getHistoryStateAndUr2 = getHistoryStateAndUrl(nextLocation, index), historyState = _getHistoryStateAndUr2[0], url = _getHistoryStateAndUr2[1]; // TODO: Support forced reloading
            globalHistory.replaceState(historyState, '', url);
            applyTx(nextAction);
        }
    }
    function go(delta) {
        globalHistory.go(delta);
    }
    var history = {
        get action () {
            return action;
        },
        get location () {
            return location;
        },
        createHref: createHref,
        push: push,
        replace: replace,
        go: go,
        back: function back() {
            go(-1);
        },
        forward: function forward() {
            go(1);
        },
        listen: function listen(listener) {
            return listeners.push(listener);
        },
        block: function block(blocker) {
            var unblock = blockers.push(blocker);
            if (blockers.length === 1) window.addEventListener($c29d101a2cf08ade$var$BeforeUnloadEventType, $c29d101a2cf08ade$var$promptBeforeUnload);
            return function() {
                unblock(); // Remove the beforeunload listener so the document may
                // still be salvageable in the pagehide event.
                // See https://html.spec.whatwg.org/#unloading-documents
                if (!blockers.length) window.removeEventListener($c29d101a2cf08ade$var$BeforeUnloadEventType, $c29d101a2cf08ade$var$promptBeforeUnload);
            };
        }
    };
    return history;
}
/**
 * Hash history stores the location in window.location.hash. This makes it ideal
 * for situations where you don't want to send the location to the server for
 * some reason, either because you do cannot configure it or the URL space is
 * reserved for something else.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createhashhistory
 */ function $c29d101a2cf08ade$export$b71fdd3798280242(options) {
    if (options === void 0) options = {};
    var _options2 = options, _options2$window = _options2.window, window = _options2$window === void 0 ? document.defaultView : _options2$window;
    var globalHistory = window.history;
    function getIndexAndLocation() {
        var _parsePath = $c29d101a2cf08ade$export$8ccf933b0513f8d0(window.location.hash.substr(1)), _parsePath$pathname = _parsePath.pathname, pathname = _parsePath$pathname === void 0 ? '/' : _parsePath$pathname, _parsePath$search = _parsePath.search, search = _parsePath$search === void 0 ? '' : _parsePath$search, _parsePath$hash = _parsePath.hash, hash = _parsePath$hash === void 0 ? '' : _parsePath$hash;
        var state = globalHistory.state || {};
        return [
            state.idx,
            $c29d101a2cf08ade$var$readOnly({
                pathname: pathname,
                search: search,
                hash: hash,
                state: state.usr || null,
                key: state.key || 'default'
            })
        ];
    }
    var blockedPopTx = null;
    function handlePop() {
        if (blockedPopTx) {
            blockers.call(blockedPopTx);
            blockedPopTx = null;
        } else {
            var nextAction = $c29d101a2cf08ade$export$e19cd5f9376f8cee.Pop;
            var _getIndexAndLocation4 = getIndexAndLocation(), nextIndex = _getIndexAndLocation4[0], nextLocation = _getIndexAndLocation4[1];
            if (blockers.length) {
                if (nextIndex != null) {
                    var delta = index - nextIndex;
                    if (delta) {
                        // Revert the POP
                        blockedPopTx = {
                            action: nextAction,
                            location: nextLocation,
                            retry: function retry() {
                                go(delta * -1);
                            }
                        };
                        go(delta);
                    }
                }
            } else applyTx(nextAction);
        }
    }
    window.addEventListener($c29d101a2cf08ade$var$PopStateEventType, handlePop); // popstate does not fire on hashchange in IE 11 and old (trident) Edge
    // https://developer.mozilla.org/de/docs/Web/API/Window/popstate_event
    window.addEventListener($c29d101a2cf08ade$var$HashChangeEventType, function() {
        var _getIndexAndLocation5 = getIndexAndLocation(), nextLocation = _getIndexAndLocation5[1]; // Ignore extraneous hashchange events.
        if ($c29d101a2cf08ade$export$fe53371bee54353d(nextLocation) !== $c29d101a2cf08ade$export$fe53371bee54353d(location)) handlePop();
    });
    var action = $c29d101a2cf08ade$export$e19cd5f9376f8cee.Pop;
    var _getIndexAndLocation6 = getIndexAndLocation(), index = _getIndexAndLocation6[0], location = _getIndexAndLocation6[1];
    var listeners = $c29d101a2cf08ade$var$createEvents();
    var blockers = $c29d101a2cf08ade$var$createEvents();
    if (index == null) {
        index = 0;
        globalHistory.replaceState((0, $d1G9Q.default)({}, globalHistory.state, {
            idx: index
        }), '');
    }
    function getBaseHref() {
        var base = document.querySelector('base');
        var href = '';
        if (base && base.getAttribute('href')) {
            var url = window.location.href;
            var hashIndex = url.indexOf('#');
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href;
    }
    function createHref(to) {
        return getBaseHref() + '#' + (typeof to === 'string' ? to : $c29d101a2cf08ade$export$fe53371bee54353d(to));
    }
    function getNextLocation(to, state) {
        if (state === void 0) state = null;
        return $c29d101a2cf08ade$var$readOnly((0, $d1G9Q.default)({
            pathname: location.pathname,
            hash: '',
            search: ''
        }, typeof to === 'string' ? $c29d101a2cf08ade$export$8ccf933b0513f8d0(to) : to, {
            state: state,
            key: $c29d101a2cf08ade$var$createKey()
        }));
    }
    function getHistoryStateAndUrl(nextLocation, index) {
        return [
            {
                usr: nextLocation.state,
                key: nextLocation.key,
                idx: index
            },
            createHref(nextLocation)
        ];
    }
    function allowTx(action, location, retry) {
        return !blockers.length || (blockers.call({
            action: action,
            location: location,
            retry: retry
        }), false);
    }
    function applyTx(nextAction) {
        action = nextAction;
        var _getIndexAndLocation7 = getIndexAndLocation();
        index = _getIndexAndLocation7[0];
        location = _getIndexAndLocation7[1];
        listeners.call({
            action: action,
            location: location
        });
    }
    function push(to, state) {
        var nextAction = $c29d101a2cf08ade$export$e19cd5f9376f8cee.Push;
        var nextLocation = getNextLocation(to, state);
        function retry() {
            push(to, state);
        }
        if (allowTx(nextAction, nextLocation, retry)) {
            var _getHistoryStateAndUr3 = getHistoryStateAndUrl(nextLocation, index + 1), historyState = _getHistoryStateAndUr3[0], url = _getHistoryStateAndUr3[1]; // TODO: Support forced reloading
            // try...catch because iOS limits us to 100 pushState calls :/
            try {
                globalHistory.pushState(historyState, '', url);
            } catch (error) {
                // They are going to lose state here, but there is no real
                // way to warn them about it since the page will refresh...
                window.location.assign(url);
            }
            applyTx(nextAction);
        }
    }
    function replace(to, state) {
        var nextAction = $c29d101a2cf08ade$export$e19cd5f9376f8cee.Replace;
        var nextLocation = getNextLocation(to, state);
        function retry() {
            replace(to, state);
        }
        if (allowTx(nextAction, nextLocation, retry)) {
            var _getHistoryStateAndUr4 = getHistoryStateAndUrl(nextLocation, index), historyState = _getHistoryStateAndUr4[0], url = _getHistoryStateAndUr4[1]; // TODO: Support forced reloading
            globalHistory.replaceState(historyState, '', url);
            applyTx(nextAction);
        }
    }
    function go(delta) {
        globalHistory.go(delta);
    }
    var history = {
        get action () {
            return action;
        },
        get location () {
            return location;
        },
        createHref: createHref,
        push: push,
        replace: replace,
        go: go,
        back: function back() {
            go(-1);
        },
        forward: function forward() {
            go(1);
        },
        listen: function listen(listener) {
            return listeners.push(listener);
        },
        block: function block(blocker) {
            var unblock = blockers.push(blocker);
            if (blockers.length === 1) window.addEventListener($c29d101a2cf08ade$var$BeforeUnloadEventType, $c29d101a2cf08ade$var$promptBeforeUnload);
            return function() {
                unblock(); // Remove the beforeunload listener so the document may
                // still be salvageable in the pagehide event.
                // See https://html.spec.whatwg.org/#unloading-documents
                if (!blockers.length) window.removeEventListener($c29d101a2cf08ade$var$BeforeUnloadEventType, $c29d101a2cf08ade$var$promptBeforeUnload);
            };
        }
    };
    return history;
}
/**
 * Memory history stores the current location in memory. It is designed for use
 * in stateful non-browser environments like tests and React Native.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#creatememoryhistory
 */ function $c29d101a2cf08ade$export$2b76ad033c6e6d08(options) {
    if (options === void 0) options = {};
    var _options3 = options, _options3$initialEntr = _options3.initialEntries, initialEntries = _options3$initialEntr === void 0 ? [
        '/'
    ] : _options3$initialEntr, initialIndex = _options3.initialIndex;
    var entries = initialEntries.map(function(entry) {
        var location = $c29d101a2cf08ade$var$readOnly((0, $d1G9Q.default)({
            pathname: '/',
            search: '',
            hash: '',
            state: null,
            key: $c29d101a2cf08ade$var$createKey()
        }, typeof entry === 'string' ? $c29d101a2cf08ade$export$8ccf933b0513f8d0(entry) : entry));
        return location;
    });
    var index = $c29d101a2cf08ade$var$clamp(initialIndex == null ? entries.length - 1 : initialIndex, 0, entries.length - 1);
    var action = $c29d101a2cf08ade$export$e19cd5f9376f8cee.Pop;
    var location = entries[index];
    var listeners = $c29d101a2cf08ade$var$createEvents();
    var blockers = $c29d101a2cf08ade$var$createEvents();
    function createHref(to) {
        return typeof to === 'string' ? to : $c29d101a2cf08ade$export$fe53371bee54353d(to);
    }
    function getNextLocation(to, state) {
        if (state === void 0) state = null;
        return $c29d101a2cf08ade$var$readOnly((0, $d1G9Q.default)({
            pathname: location.pathname,
            search: '',
            hash: ''
        }, typeof to === 'string' ? $c29d101a2cf08ade$export$8ccf933b0513f8d0(to) : to, {
            state: state,
            key: $c29d101a2cf08ade$var$createKey()
        }));
    }
    function allowTx(action, location, retry) {
        return !blockers.length || (blockers.call({
            action: action,
            location: location,
            retry: retry
        }), false);
    }
    function applyTx(nextAction, nextLocation) {
        action = nextAction;
        location = nextLocation;
        listeners.call({
            action: action,
            location: location
        });
    }
    function push(to, state) {
        var nextAction = $c29d101a2cf08ade$export$e19cd5f9376f8cee.Push;
        var nextLocation = getNextLocation(to, state);
        function retry() {
            push(to, state);
        }
        if (allowTx(nextAction, nextLocation, retry)) {
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            applyTx(nextAction, nextLocation);
        }
    }
    function replace(to, state) {
        var nextAction = $c29d101a2cf08ade$export$e19cd5f9376f8cee.Replace;
        var nextLocation = getNextLocation(to, state);
        function retry() {
            replace(to, state);
        }
        if (allowTx(nextAction, nextLocation, retry)) {
            entries[index] = nextLocation;
            applyTx(nextAction, nextLocation);
        }
    }
    function go(delta) {
        var nextIndex = $c29d101a2cf08ade$var$clamp(index + delta, 0, entries.length - 1);
        var nextAction = $c29d101a2cf08ade$export$e19cd5f9376f8cee.Pop;
        var nextLocation = entries[nextIndex];
        function retry() {
            go(delta);
        }
        if (allowTx(nextAction, nextLocation, retry)) {
            index = nextIndex;
            applyTx(nextAction, nextLocation);
        }
    }
    var history = {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return location;
        },
        createHref: createHref,
        push: push,
        replace: replace,
        go: go,
        back: function back() {
            go(-1);
        },
        forward: function forward() {
            go(1);
        },
        listen: function listen(listener) {
            return listeners.push(listener);
        },
        block: function block(blocker) {
            return blockers.push(blocker);
        }
    };
    return history;
} ////////////////////////////////////////////////////////////////////////////////
// UTILS
////////////////////////////////////////////////////////////////////////////////
function $c29d101a2cf08ade$var$clamp(n, lowerBound, upperBound) {
    return Math.min(Math.max(n, lowerBound), upperBound);
}
function $c29d101a2cf08ade$var$promptBeforeUnload(event) {
    // Cancel the event.
    event.preventDefault(); // Chrome (and legacy IE) requires returnValue to be set.
    event.returnValue = '';
}
function $c29d101a2cf08ade$var$createEvents() {
    var handlers = [];
    return {
        get length () {
            return handlers.length;
        },
        push: function push(fn) {
            handlers.push(fn);
            return function() {
                handlers = handlers.filter(function(handler) {
                    return handler !== fn;
                });
            };
        },
        call: function call(arg) {
            handlers.forEach(function(fn) {
                return fn && fn(arg);
            });
        }
    };
}
function $c29d101a2cf08ade$var$createKey() {
    return Math.random().toString(36).substr(2, 8);
}
/**
 * Creates a string URL path from the given pathname, search, and hash components.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createpath
 */ function $c29d101a2cf08ade$export$fe53371bee54353d(_ref) {
    var _ref$pathname = _ref.pathname, pathname = _ref$pathname === void 0 ? '/' : _ref$pathname, _ref$search = _ref.search, search = _ref$search === void 0 ? '' : _ref$search, _ref$hash = _ref.hash, hash = _ref$hash === void 0 ? '' : _ref$hash;
    if (search && search !== '?') pathname += search.charAt(0) === '?' ? search : '?' + search;
    if (hash && hash !== '#') pathname += hash.charAt(0) === '#' ? hash : '#' + hash;
    return pathname;
}
/**
 * Parses a string URL path into its separate pathname, search, and hash components.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#parsepath
 */ function $c29d101a2cf08ade$export$8ccf933b0513f8d0(path) {
    var parsedPath = {};
    if (path) {
        var hashIndex = path.indexOf('#');
        if (hashIndex >= 0) {
            parsedPath.hash = path.substr(hashIndex);
            path = path.substr(0, hashIndex);
        }
        var searchIndex = path.indexOf('?');
        if (searchIndex >= 0) {
            parsedPath.search = path.substr(searchIndex);
            path = path.substr(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}



var $kqp0i = parcelRequire("kqp0i");

var $25nEq = parcelRequire("25nEq");


var $5FkrB = parcelRequire("5FkrB");

var $kqp0i = parcelRequire("kqp0i");

var $065a7de35543dd84$exports = {};
/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ /** Used as the `TypeError` message for "Functions" methods. */ var $065a7de35543dd84$var$FUNC_ERROR_TEXT = 'Expected a function';
/** Used as references for various `Number` constants. */ var $065a7de35543dd84$var$NAN = 0 / 0;
/** `Object#toString` result references. */ var $065a7de35543dd84$var$symbolTag = '[object Symbol]';
/** Used to match leading and trailing whitespace. */ var $065a7de35543dd84$var$reTrim = /^\s+|\s+$/g;
/** Used to detect bad signed hexadecimal string values. */ var $065a7de35543dd84$var$reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
/** Used to detect binary string values. */ var $065a7de35543dd84$var$reIsBinary = /^0b[01]+$/i;
/** Used to detect octal string values. */ var $065a7de35543dd84$var$reIsOctal = /^0o[0-7]+$/i;
/** Built-in method references without a dependency on `root`. */ var $065a7de35543dd84$var$freeParseInt = parseInt;
/** Detect free variable `global` from Node.js. */ var $065a7de35543dd84$var$freeGlobal = typeof $parcel$global == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
/** Detect free variable `self`. */ var $065a7de35543dd84$var$freeSelf = typeof self == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $065a7de35543dd84$var$root = $065a7de35543dd84$var$freeGlobal || $065a7de35543dd84$var$freeSelf || Function('return this')();
/** Used for built-in method references. */ var $065a7de35543dd84$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $065a7de35543dd84$var$objectToString = $065a7de35543dd84$var$objectProto.toString;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $065a7de35543dd84$var$nativeMax = Math.max, $065a7de35543dd84$var$nativeMin = Math.min;
/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */ var $065a7de35543dd84$var$now = function() {
    return $065a7de35543dd84$var$root.Date.now();
};
/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */ function $065a7de35543dd84$var$debounce(func, wait, options) {
    var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
    if (typeof func != 'function') throw new TypeError($065a7de35543dd84$var$FUNC_ERROR_TEXT);
    wait = $065a7de35543dd84$var$toNumber(wait) || 0;
    if ($065a7de35543dd84$var$isObject(options)) {
        leading = !!options.leading;
        maxing = 'maxWait' in options;
        maxWait = maxing ? $065a7de35543dd84$var$nativeMax($065a7de35543dd84$var$toNumber(options.maxWait) || 0, wait) : maxWait;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
    }
    function invokeFunc(time) {
        var args = lastArgs, thisArg = lastThis;
        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
    }
    function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
    }
    function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, result = wait - timeSinceLastCall;
        return maxing ? $065a7de35543dd84$var$nativeMin(result, maxWait - timeSinceLastInvoke) : result;
    }
    function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
    }
    function timerExpired() {
        var time = $065a7de35543dd84$var$now();
        if (shouldInvoke(time)) return trailingEdge(time);
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
    }
    function trailingEdge(time) {
        timerId = undefined;
        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) return invokeFunc(time);
        lastArgs = lastThis = undefined;
        return result;
    }
    function cancel() {
        if (timerId !== undefined) clearTimeout(timerId);
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
    }
    function flush() {
        return timerId === undefined ? result : trailingEdge($065a7de35543dd84$var$now());
    }
    function debounced() {
        var time = $065a7de35543dd84$var$now(), isInvoking = shouldInvoke(time);
        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;
        if (isInvoking) {
            if (timerId === undefined) return leadingEdge(lastCallTime);
            if (maxing) {
                // Handle invocations in a tight loop.
                timerId = setTimeout(timerExpired, wait);
                return invokeFunc(lastCallTime);
            }
        }
        if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
        return result;
    }
    debounced.cancel = cancel;
    debounced.flush = flush;
    return debounced;
}
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $065a7de35543dd84$var$isObject(value) {
    var type = typeof value;
    return !!value && (type == 'object' || type == 'function');
}
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $065a7de35543dd84$var$isObjectLike(value) {
    return !!value && typeof value == 'object';
}
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $065a7de35543dd84$var$isSymbol(value) {
    return typeof value == 'symbol' || $065a7de35543dd84$var$isObjectLike(value) && $065a7de35543dd84$var$objectToString.call(value) == $065a7de35543dd84$var$symbolTag;
}
/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */ function $065a7de35543dd84$var$toNumber(value) {
    if (typeof value == 'number') return value;
    if ($065a7de35543dd84$var$isSymbol(value)) return $065a7de35543dd84$var$NAN;
    if ($065a7de35543dd84$var$isObject(value)) {
        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
        value = $065a7de35543dd84$var$isObject(other) ? other + '' : other;
    }
    if (typeof value != 'string') return value === 0 ? value : +value;
    value = value.replace($065a7de35543dd84$var$reTrim, '');
    var isBinary = $065a7de35543dd84$var$reIsBinary.test(value);
    return isBinary || $065a7de35543dd84$var$reIsOctal.test(value) ? $065a7de35543dd84$var$freeParseInt(value.slice(2), isBinary ? 2 : 8) : $065a7de35543dd84$var$reIsBadHex.test(value) ? $065a7de35543dd84$var$NAN : +value;
}
$065a7de35543dd84$exports = $065a7de35543dd84$var$debounce;


var $0ae6c8b81570b5e1$exports = {};
/**
 * lodash 3.0.1 (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize include="noop" exports="npm" -o ./foo`
 * Copyright 2012-2016 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2016 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */ /**
 * A no-operation function that returns `undefined` regardless of the
 * arguments it receives.
 *
 * @static
 * @memberOf _
 * @category Util
 * @example
 *
 * var object = { 'user': 'fred' };
 *
 * _.noop(object) === undefined;
 * // => true
 */ function $0ae6c8b81570b5e1$var$noop() {
// No operation performed.
}
$0ae6c8b81570b5e1$exports = $0ae6c8b81570b5e1$var$noop;


const $9d4782ee5a008819$var$hasWindow = ()=>typeof window !== 'undefined';
const $9d4782ee5a008819$var$methodsPlaceholders = {
    push: (0, (/*@__PURE__*/$parcel$interopDefault($0ae6c8b81570b5e1$exports))),
    replace: (0, (/*@__PURE__*/$parcel$interopDefault($0ae6c8b81570b5e1$exports))),
    goBack: (0, (/*@__PURE__*/$parcel$interopDefault($0ae6c8b81570b5e1$exports))),
    goForward: (0, (/*@__PURE__*/$parcel$interopDefault($0ae6c8b81570b5e1$exports))),
    listen: ()=>(0, (/*@__PURE__*/$parcel$interopDefault($0ae6c8b81570b5e1$exports))),
    block: ()=>(0, (/*@__PURE__*/$parcel$interopDefault($0ae6c8b81570b5e1$exports)))
};
const $9d4782ee5a008819$var$getLocation = ()=>{
    // todo - don't force non-optional search and hash
    const { pathname: pathname = '', search: search = '', hash: hash = '' } = $9d4782ee5a008819$var$hasWindow() && window.location || {};
    return {
        pathname: pathname,
        search: search,
        hash: hash
    };
};
const $9d4782ee5a008819$var$createLegacyListener = (updateExposedLocation)=>{
    const node = document.querySelector('#content');
    let prevHref = window.location.href;
    let listeners = [];
    const historyStack = [
        prevHref
    ];
    // note: window.history.length is capped at 50 entries
    let prevHistoryLength = window.history.length;
    let historyIndex = 0;
    const getAction = ()=>{
        const currentHref = window.location.href;
        if (prevHistoryLength === window.history.length) {
            if (historyStack[historyIndex - 1] === currentHref) {
                historyIndex -= 1;
                return 'POP';
            }
            if (historyStack[historyIndex + 1] === currentHref) {
                historyIndex += 1;
                return 'POP';
            }
            historyStack[historyStack.length - 1] = currentHref;
            return 'REPLACE';
        }
        historyStack.push(currentHref);
        historyIndex += 1;
        prevHistoryLength = window.history.length;
        return 'PUSH';
    };
    const onNodeChanges = (0, (/*@__PURE__*/$parcel$interopDefault($065a7de35543dd84$exports)))(()=>{
        if (prevHref !== window.location.href) {
            const newLocation = $9d4782ee5a008819$var$getLocation();
            const action = getAction();
            updateExposedLocation(newLocation, action);
            listeners.forEach((listener)=>listener(newLocation, action));
            prevHref = window.location.href;
        }
    }, 50);
    if (node) {
        const observer = new window.MutationObserver(onNodeChanges);
        observer.observe(node, {
            childList: true,
            subtree: true,
            attributes: true,
            characterData: true
        });
    }
    return (listener)=>{
        listeners = listeners.concat(listener);
        return ()=>{
            listeners = listeners.filter((lst)=>lst !== listener);
        };
    };
};
const $9d4782ee5a008819$export$883c3f3b6c000133 = ()=>{
    let currentLocation = $9d4782ee5a008819$var$getLocation();
    let currentAction = 'PUSH';
    const updateExposedLocation = (v, a)=>{
        currentLocation = v;
        currentAction = a;
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        get location () {
            return currentLocation;
        },
        get length () {
            return $9d4782ee5a008819$var$hasWindow() ? window.history.length : 1; // default length is 1
        },
        get action () {
            return currentAction;
        }
    }, $9d4782ee5a008819$var$hasWindow() ? {
        push: (path)=>window.location.assign(typeof path === 'string' ? path : (0, $c29d101a2cf08ade$export$fe53371bee54353d)(path || {})),
        replace: (path)=>window.history.replaceState({}, document.title, typeof path === 'string' ? path : (0, $c29d101a2cf08ade$export$fe53371bee54353d)(path || {})),
        goBack: ()=>window.history.back(),
        goForward: ()=>window.history.forward(),
        listen: $9d4782ee5a008819$var$createLegacyListener(updateExposedLocation),
        block: ()=>(0, (/*@__PURE__*/$parcel$interopDefault($0ae6c8b81570b5e1$exports))),
        createHref: (location)=>(0, $c29d101a2cf08ade$export$fe53371bee54353d)(location)
    } : $9d4782ee5a008819$var$methodsPlaceholders);
};


/**
 * Tokenize input string.
 */ function $6a0a05a9da8f05fd$var$lexer(str) {
    var tokens = [];
    var i = 0;
    while(i < str.length){
        var char = str[i];
        if (char === "*" || char === "+" || char === "?") {
            tokens.push({
                type: "MODIFIER",
                index: i,
                value: str[i++]
            });
            continue;
        }
        if (char === "\\") {
            tokens.push({
                type: "ESCAPED_CHAR",
                index: i++,
                value: str[i++]
            });
            continue;
        }
        if (char === "{") {
            tokens.push({
                type: "OPEN",
                index: i,
                value: str[i++]
            });
            continue;
        }
        if (char === "}") {
            tokens.push({
                type: "CLOSE",
                index: i,
                value: str[i++]
            });
            continue;
        }
        if (char === ":") {
            var name = "";
            var j = i + 1;
            while(j < str.length){
                var code = str.charCodeAt(j);
                if (// `0-9`
                code >= 48 && code <= 57 || // `A-Z`
                code >= 65 && code <= 90 || // `a-z`
                code >= 97 && code <= 122 || // `_`
                code === 95) {
                    name += str[j++];
                    continue;
                }
                break;
            }
            if (!name) throw new TypeError("Missing parameter name at ".concat(i));
            tokens.push({
                type: "NAME",
                index: i,
                value: name
            });
            i = j;
            continue;
        }
        if (char === "(") {
            var count = 1;
            var pattern = "";
            var j = i + 1;
            if (str[j] === "?") throw new TypeError("Pattern cannot start with \"?\" at ".concat(j));
            while(j < str.length){
                if (str[j] === "\\") {
                    pattern += str[j++] + str[j++];
                    continue;
                }
                if (str[j] === ")") {
                    count--;
                    if (count === 0) {
                        j++;
                        break;
                    }
                } else if (str[j] === "(") {
                    count++;
                    if (str[j + 1] !== "?") throw new TypeError("Capturing groups are not allowed at ".concat(j));
                }
                pattern += str[j++];
            }
            if (count) throw new TypeError("Unbalanced pattern at ".concat(i));
            if (!pattern) throw new TypeError("Missing pattern at ".concat(i));
            tokens.push({
                type: "PATTERN",
                index: i,
                value: pattern
            });
            i = j;
            continue;
        }
        tokens.push({
            type: "CHAR",
            index: i,
            value: str[i++]
        });
    }
    tokens.push({
        type: "END",
        index: i,
        value: ""
    });
    return tokens;
}
function $6a0a05a9da8f05fd$export$98e6a39c04603d36(str, options) {
    if (options === void 0) options = {};
    var tokens = $6a0a05a9da8f05fd$var$lexer(str);
    var _a = options.prefixes, prefixes = _a === void 0 ? "./" : _a, _b = options.delimiter, delimiter = _b === void 0 ? "/#?" : _b;
    var result = [];
    var key = 0;
    var i = 0;
    var path = "";
    var tryConsume = function(type) {
        if (i < tokens.length && tokens[i].type === type) return tokens[i++].value;
    };
    var mustConsume = function(type) {
        var value = tryConsume(type);
        if (value !== undefined) return value;
        var _a = tokens[i], nextType = _a.type, index = _a.index;
        throw new TypeError("Unexpected ".concat(nextType, " at ").concat(index, ", expected ").concat(type));
    };
    var consumeText = function() {
        var result = "";
        var value;
        while(value = tryConsume("CHAR") || tryConsume("ESCAPED_CHAR"))result += value;
        return result;
    };
    var isSafe = function(value) {
        for(var _i = 0, delimiter_1 = delimiter; _i < delimiter_1.length; _i++){
            var char = delimiter_1[_i];
            if (value.indexOf(char) > -1) return true;
        }
        return false;
    };
    var safePattern = function(prefix) {
        var prev = result[result.length - 1];
        var prevText = prefix || (prev && typeof prev === "string" ? prev : "");
        if (prev && !prevText) throw new TypeError("Must have text between two parameters, missing text after \"".concat(prev.name, "\""));
        if (!prevText || isSafe(prevText)) return "[^".concat($6a0a05a9da8f05fd$var$escapeString(delimiter), "]+?");
        return "(?:(?!".concat($6a0a05a9da8f05fd$var$escapeString(prevText), ")[^").concat($6a0a05a9da8f05fd$var$escapeString(delimiter), "])+?");
    };
    while(i < tokens.length){
        var char = tryConsume("CHAR");
        var name = tryConsume("NAME");
        var pattern = tryConsume("PATTERN");
        if (name || pattern) {
            var prefix = char || "";
            if (prefixes.indexOf(prefix) === -1) {
                path += prefix;
                prefix = "";
            }
            if (path) {
                result.push(path);
                path = "";
            }
            result.push({
                name: name || key++,
                prefix: prefix,
                suffix: "",
                pattern: pattern || safePattern(prefix),
                modifier: tryConsume("MODIFIER") || ""
            });
            continue;
        }
        var value = char || tryConsume("ESCAPED_CHAR");
        if (value) {
            path += value;
            continue;
        }
        if (path) {
            result.push(path);
            path = "";
        }
        var open = tryConsume("OPEN");
        if (open) {
            var prefix = consumeText();
            var name_1 = tryConsume("NAME") || "";
            var pattern_1 = tryConsume("PATTERN") || "";
            var suffix = consumeText();
            mustConsume("CLOSE");
            result.push({
                name: name_1 || (pattern_1 ? key++ : ""),
                pattern: name_1 && !pattern_1 ? safePattern(prefix) : pattern_1,
                prefix: prefix,
                suffix: suffix,
                modifier: tryConsume("MODIFIER") || ""
            });
            continue;
        }
        mustConsume("END");
    }
    return result;
}
function $6a0a05a9da8f05fd$export$ef7acd7185315e22(str, options) {
    return $6a0a05a9da8f05fd$export$5b9bad9e403cf3d9($6a0a05a9da8f05fd$export$98e6a39c04603d36(str, options), options);
}
function $6a0a05a9da8f05fd$export$5b9bad9e403cf3d9(tokens, options) {
    if (options === void 0) options = {};
    var reFlags = $6a0a05a9da8f05fd$var$flags(options);
    var _a = options.encode, encode = _a === void 0 ? function(x) {
        return x;
    } : _a, _b = options.validate, validate = _b === void 0 ? true : _b;
    // Compile all the tokens into regexps.
    var matches = tokens.map(function(token) {
        if (typeof token === "object") return new RegExp("^(?:".concat(token.pattern, ")$"), reFlags);
    });
    return function(data) {
        var path = "";
        for(var i = 0; i < tokens.length; i++){
            var token = tokens[i];
            if (typeof token === "string") {
                path += token;
                continue;
            }
            var value = data ? data[token.name] : undefined;
            var optional = token.modifier === "?" || token.modifier === "*";
            var repeat = token.modifier === "*" || token.modifier === "+";
            if (Array.isArray(value)) {
                if (!repeat) throw new TypeError("Expected \"".concat(token.name, "\" to not repeat, but got an array"));
                if (value.length === 0) {
                    if (optional) continue;
                    throw new TypeError("Expected \"".concat(token.name, "\" to not be empty"));
                }
                for(var j = 0; j < value.length; j++){
                    var segment = encode(value[j], token);
                    if (validate && !matches[i].test(segment)) throw new TypeError("Expected all \"".concat(token.name, "\" to match \"").concat(token.pattern, "\", but got \"").concat(segment, "\""));
                    path += token.prefix + segment + token.suffix;
                }
                continue;
            }
            if (typeof value === "string" || typeof value === "number") {
                var segment = encode(String(value), token);
                if (validate && !matches[i].test(segment)) throw new TypeError("Expected \"".concat(token.name, "\" to match \"").concat(token.pattern, "\", but got \"").concat(segment, "\""));
                path += token.prefix + segment + token.suffix;
                continue;
            }
            if (optional) continue;
            var typeOfMessage = repeat ? "an array" : "a string";
            throw new TypeError("Expected \"".concat(token.name, "\" to be ").concat(typeOfMessage));
        }
        return path;
    };
}
function $6a0a05a9da8f05fd$export$4659b591c19bdf3d(str, options) {
    var keys = [];
    var re = $6a0a05a9da8f05fd$export$71304158c7e35877(str, keys, options);
    return $6a0a05a9da8f05fd$export$968e97c88708237a(re, keys, options);
}
function $6a0a05a9da8f05fd$export$968e97c88708237a(re, keys, options) {
    if (options === void 0) options = {};
    var _a = options.decode, decode = _a === void 0 ? function(x) {
        return x;
    } : _a;
    return function(pathname) {
        var m = re.exec(pathname);
        if (!m) return false;
        var path = m[0], index = m.index;
        var params = Object.create(null);
        var _loop_1 = function(i) {
            if (m[i] === undefined) return "continue";
            var key = keys[i - 1];
            if (key.modifier === "*" || key.modifier === "+") params[key.name] = m[i].split(key.prefix + key.suffix).map(function(value) {
                return decode(value, key);
            });
            else params[key.name] = decode(m[i], key);
        };
        for(var i = 1; i < m.length; i++)_loop_1(i);
        return {
            path: path,
            index: index,
            params: params
        };
    };
}
/**
 * Escape a regular expression string.
 */ function $6a0a05a9da8f05fd$var$escapeString(str) {
    return str.replace(/([.+*?=^!:${}()[\]|/\\])/g, "\\$1");
}
/**
 * Get the flags for a regexp from the options.
 */ function $6a0a05a9da8f05fd$var$flags(options) {
    return options && options.sensitive ? "" : "i";
}
/**
 * Pull out keys from a regexp.
 */ function $6a0a05a9da8f05fd$var$regexpToRegexp(path, keys) {
    if (!keys) return path;
    var groupsRegex = /\((?:\?<(.*?)>)?(?!\?)/g;
    var index = 0;
    var execResult = groupsRegex.exec(path.source);
    while(execResult){
        keys.push({
            // Use parenthesized substring match if available, index otherwise
            name: execResult[1] || index++,
            prefix: "",
            suffix: "",
            modifier: "",
            pattern: ""
        });
        execResult = groupsRegex.exec(path.source);
    }
    return path;
}
/**
 * Transform an array into a regexp.
 */ function $6a0a05a9da8f05fd$var$arrayToRegexp(paths, keys, options) {
    var parts = paths.map(function(path) {
        return $6a0a05a9da8f05fd$export$71304158c7e35877(path, keys, options).source;
    });
    return new RegExp("(?:".concat(parts.join("|"), ")"), $6a0a05a9da8f05fd$var$flags(options));
}
/**
 * Create a path regexp from string input.
 */ function $6a0a05a9da8f05fd$var$stringToRegexp(path, keys, options) {
    return $6a0a05a9da8f05fd$export$9a9303716def6456($6a0a05a9da8f05fd$export$98e6a39c04603d36(path, options), keys, options);
}
function $6a0a05a9da8f05fd$export$9a9303716def6456(tokens, keys, options) {
    if (options === void 0) options = {};
    var _a = options.strict, strict = _a === void 0 ? false : _a, _b = options.start, start = _b === void 0 ? true : _b, _c = options.end, end = _c === void 0 ? true : _c, _d = options.encode, encode = _d === void 0 ? function(x) {
        return x;
    } : _d, _e = options.delimiter, delimiter = _e === void 0 ? "/#?" : _e, _f = options.endsWith, endsWith = _f === void 0 ? "" : _f;
    var endsWithRe = "[".concat($6a0a05a9da8f05fd$var$escapeString(endsWith), "]|$");
    var delimiterRe = "[".concat($6a0a05a9da8f05fd$var$escapeString(delimiter), "]");
    var route = start ? "^" : "";
    // Iterate over the tokens and create our regexp string.
    for(var _i = 0, tokens_1 = tokens; _i < tokens_1.length; _i++){
        var token = tokens_1[_i];
        if (typeof token === "string") route += $6a0a05a9da8f05fd$var$escapeString(encode(token));
        else {
            var prefix = $6a0a05a9da8f05fd$var$escapeString(encode(token.prefix));
            var suffix = $6a0a05a9da8f05fd$var$escapeString(encode(token.suffix));
            if (token.pattern) {
                if (keys) keys.push(token);
                if (prefix || suffix) {
                    if (token.modifier === "+" || token.modifier === "*") {
                        var mod = token.modifier === "*" ? "?" : "";
                        route += "(?:".concat(prefix, "((?:").concat(token.pattern, ")(?:").concat(suffix).concat(prefix, "(?:").concat(token.pattern, "))*)").concat(suffix, ")").concat(mod);
                    } else route += "(?:".concat(prefix, "(").concat(token.pattern, ")").concat(suffix, ")").concat(token.modifier);
                } else {
                    if (token.modifier === "+" || token.modifier === "*") throw new TypeError("Can not repeat \"".concat(token.name, "\" without a prefix and suffix"));
                    route += "(".concat(token.pattern, ")").concat(token.modifier);
                }
            } else route += "(?:".concat(prefix).concat(suffix, ")").concat(token.modifier);
        }
    }
    if (end) {
        if (!strict) route += "".concat(delimiterRe, "?");
        route += !options.endsWith ? "$" : "(?=".concat(endsWithRe, ")");
    } else {
        var endToken = tokens[tokens.length - 1];
        var isEndDelimited = typeof endToken === "string" ? delimiterRe.indexOf(endToken[endToken.length - 1]) > -1 : endToken === undefined;
        if (!strict) route += "(?:".concat(delimiterRe, "(?=").concat(endsWithRe, "))?");
        if (!isEndDelimited) route += "(?=".concat(delimiterRe, "|").concat(endsWithRe, ")");
    }
    return new RegExp(route, $6a0a05a9da8f05fd$var$flags(options));
}
function $6a0a05a9da8f05fd$export$71304158c7e35877(path, keys, options) {
    if (path instanceof RegExp) return $6a0a05a9da8f05fd$var$regexpToRegexp(path, keys);
    if (Array.isArray(path)) return $6a0a05a9da8f05fd$var$arrayToRegexp(path, keys, options);
    return $6a0a05a9da8f05fd$var$stringToRegexp(path, keys, options);
}


var $deb424f7a075f200$exports = {};
'use strict';
var $5654768c7acee223$exports = {};
'use strict';
/**
 * Check if we're required to add a port number.
 *
 * @see https://url.spec.whatwg.org/#default-port
 * @param {Number|String} port Port number we need to check
 * @param {String} protocol Protocol we need to check against.
 * @returns {Boolean} Is it a default port for the given protocol
 * @api private
 */ $5654768c7acee223$exports = function required(port, protocol) {
    protocol = protocol.split(':')[0];
    port = +port;
    if (!port) return false;
    switch(protocol){
        case 'http':
        case 'ws':
            return port !== 80;
        case 'https':
        case 'wss':
            return port !== 443;
        case 'ftp':
            return port !== 21;
        case 'gopher':
            return port !== 70;
        case 'file':
            return false;
    }
    return port !== 0;
};


var $3092e7c4432aeccb$exports = {};
$parcel$export($3092e7c4432aeccb$exports, "stringify", () => $3092e7c4432aeccb$export$fac44ee5b035f737, (v) => $3092e7c4432aeccb$export$fac44ee5b035f737 = v);
$parcel$export($3092e7c4432aeccb$exports, "parse", () => $3092e7c4432aeccb$export$98e6a39c04603d36, (v) => $3092e7c4432aeccb$export$98e6a39c04603d36 = v);
//
// Expose the module.
//
var $3092e7c4432aeccb$export$fac44ee5b035f737;
var $3092e7c4432aeccb$export$98e6a39c04603d36;
'use strict';
var $3092e7c4432aeccb$var$has = Object.prototype.hasOwnProperty, $3092e7c4432aeccb$var$undef;
/**
 * Decode a URI encoded string.
 *
 * @param {String} input The URI encoded string.
 * @returns {String|Null} The decoded string.
 * @api private
 */ function $3092e7c4432aeccb$var$decode(input) {
    try {
        return decodeURIComponent(input.replace(/\+/g, ' '));
    } catch (e) {
        return null;
    }
}
/**
 * Attempts to encode a given input.
 *
 * @param {String} input The string that needs to be encoded.
 * @returns {String|Null} The encoded string.
 * @api private
 */ function $3092e7c4432aeccb$var$encode(input) {
    try {
        return encodeURIComponent(input);
    } catch (e) {
        return null;
    }
}
/**
 * Simple query string parser.
 *
 * @param {String} query The query string that needs to be parsed.
 * @returns {Object}
 * @api public
 */ function $3092e7c4432aeccb$var$querystring(query) {
    var parser = /([^=?#&]+)=?([^&]*)/g, result = {}, part;
    while(part = parser.exec(query)){
        var key = $3092e7c4432aeccb$var$decode(part[1]), value = $3092e7c4432aeccb$var$decode(part[2]);
        //
        // Prevent overriding of existing properties. This ensures that build-in
        // methods like `toString` or __proto__ are not overriden by malicious
        // querystrings.
        //
        // In the case if failed decoding, we want to omit the key/value pairs
        // from the result.
        //
        if (key === null || value === null || key in result) continue;
        result[key] = value;
    }
    return result;
}
/**
 * Transform a query string to an object.
 *
 * @param {Object} obj Object that should be transformed.
 * @param {String} prefix Optional prefix.
 * @returns {String}
 * @api public
 */ function $3092e7c4432aeccb$var$querystringify(obj, prefix) {
    prefix = prefix || '';
    var pairs = [], value, key;
    //
    // Optionally prefix with a '?' if needed
    //
    if ('string' !== typeof prefix) prefix = '?';
    for(key in obj)if ($3092e7c4432aeccb$var$has.call(obj, key)) {
        value = obj[key];
        //
        // Edge cases where we actually want to encode the value to an empty
        // string instead of the stringified value.
        //
        if (!value && (value === null || value === $3092e7c4432aeccb$var$undef || isNaN(value))) value = '';
        key = $3092e7c4432aeccb$var$encode(key);
        value = $3092e7c4432aeccb$var$encode(value);
        //
        // If we failed to encode the strings, we should bail out as we don't
        // want to add invalid strings to the query.
        //
        if (key === null || value === null) continue;
        pairs.push(key + '=' + value);
    }
    return pairs.length ? prefix + pairs.join('&') : '';
}
$3092e7c4432aeccb$export$fac44ee5b035f737 = $3092e7c4432aeccb$var$querystringify;
$3092e7c4432aeccb$export$98e6a39c04603d36 = $3092e7c4432aeccb$var$querystring;


var $deb424f7a075f200$var$controlOrWhitespace = /^[\x00-\x20\u00a0\u1680\u2000-\u200a\u2028\u2029\u202f\u205f\u3000\ufeff]+/, $deb424f7a075f200$var$CRHTLF = /[\n\r\t]/g, $deb424f7a075f200$var$slashes = /^[A-Za-z][A-Za-z0-9+-.]*:\/\//, $deb424f7a075f200$var$port = /:\d+$/, $deb424f7a075f200$var$protocolre = /^([a-z][a-z0-9.+-]*:)?(\/\/)?([\\/]+)?([\S\s]*)/i, $deb424f7a075f200$var$windowsDriveLetter = /^[a-zA-Z]:/;
/**
 * Remove control characters and whitespace from the beginning of a string.
 *
 * @param {Object|String} str String to trim.
 * @returns {String} A new string representing `str` stripped of control
 *     characters and whitespace from its beginning.
 * @public
 */ function $deb424f7a075f200$var$trimLeft(str) {
    return (str ? str : '').toString().replace($deb424f7a075f200$var$controlOrWhitespace, '');
}
/**
 * These are the parse rules for the URL parser, it informs the parser
 * about:
 *
 * 0. The char it Needs to parse, if it's a string it should be done using
 *    indexOf, RegExp using exec and NaN means set as current value.
 * 1. The property we should set when parsing this value.
 * 2. Indication if it's backwards or forward parsing, when set as number it's
 *    the value of extra chars that should be split off.
 * 3. Inherit from location if non existing in the parser.
 * 4. `toLowerCase` the resulting value.
 */ var $deb424f7a075f200$var$rules = [
    [
        '#',
        'hash'
    ],
    [
        '?',
        'query'
    ],
    function sanitize(address, url) {
        return $deb424f7a075f200$var$isSpecial(url.protocol) ? address.replace(/\\/g, '/') : address;
    },
    [
        '/',
        'pathname'
    ],
    [
        '@',
        'auth',
        1
    ],
    [
        NaN,
        'host',
        undefined,
        1,
        1
    ],
    [
        /:(\d*)$/,
        'port',
        undefined,
        1
    ],
    [
        NaN,
        'hostname',
        undefined,
        1,
        1
    ] // Set left over.
];
/**
 * These properties should not be copied or inherited from. This is only needed
 * for all non blob URL's as a blob URL does not include a hash, only the
 * origin.
 *
 * @type {Object}
 * @private
 */ var $deb424f7a075f200$var$ignore = {
    hash: 1,
    query: 1
};
/**
 * The location object differs when your code is loaded through a normal page,
 * Worker or through a worker using a blob. And with the blobble begins the
 * trouble as the location object will contain the URL of the blob, not the
 * location of the page where our code is loaded in. The actual origin is
 * encoded in the `pathname` so we can thankfully generate a good "default"
 * location from it so we can generate proper relative URL's again.
 *
 * @param {Object|String} loc Optional default location object.
 * @returns {Object} lolcation object.
 * @public
 */ function $deb424f7a075f200$var$lolcation(loc) {
    var globalVar;
    if (typeof window !== 'undefined') globalVar = window;
    else if (typeof $parcel$global !== 'undefined') globalVar = $parcel$global;
    else if (typeof self !== 'undefined') globalVar = self;
    else globalVar = {};
    var location = globalVar.location || {};
    loc = loc || location;
    var finaldestination = {}, type = typeof loc, key;
    if ('blob:' === loc.protocol) finaldestination = new $deb424f7a075f200$var$Url(unescape(loc.pathname), {});
    else if ('string' === type) {
        finaldestination = new $deb424f7a075f200$var$Url(loc, {});
        for(key in $deb424f7a075f200$var$ignore)delete finaldestination[key];
    } else if ('object' === type) {
        for(key in loc){
            if (key in $deb424f7a075f200$var$ignore) continue;
            finaldestination[key] = loc[key];
        }
        if (finaldestination.slashes === undefined) finaldestination.slashes = $deb424f7a075f200$var$slashes.test(loc.href);
    }
    return finaldestination;
}
/**
 * Check whether a protocol scheme is special.
 *
 * @param {String} The protocol scheme of the URL
 * @return {Boolean} `true` if the protocol scheme is special, else `false`
 * @private
 */ function $deb424f7a075f200$var$isSpecial(scheme) {
    return scheme === 'file:' || scheme === 'ftp:' || scheme === 'http:' || scheme === 'https:' || scheme === 'ws:' || scheme === 'wss:';
}
/**
 * @typedef ProtocolExtract
 * @type Object
 * @property {String} protocol Protocol matched in the URL, in lowercase.
 * @property {Boolean} slashes `true` if protocol is followed by "//", else `false`.
 * @property {String} rest Rest of the URL that is not part of the protocol.
 */ /**
 * Extract protocol information from a URL with/without double slash ("//").
 *
 * @param {String} address URL we want to extract from.
 * @param {Object} location
 * @return {ProtocolExtract} Extracted information.
 * @private
 */ function $deb424f7a075f200$var$extractProtocol(address, location) {
    address = $deb424f7a075f200$var$trimLeft(address);
    address = address.replace($deb424f7a075f200$var$CRHTLF, '');
    location = location || {};
    var match = $deb424f7a075f200$var$protocolre.exec(address);
    var protocol = match[1] ? match[1].toLowerCase() : '';
    var forwardSlashes = !!match[2];
    var otherSlashes = !!match[3];
    var slashesCount = 0;
    var rest;
    if (forwardSlashes) {
        if (otherSlashes) {
            rest = match[2] + match[3] + match[4];
            slashesCount = match[2].length + match[3].length;
        } else {
            rest = match[2] + match[4];
            slashesCount = match[2].length;
        }
    } else if (otherSlashes) {
        rest = match[3] + match[4];
        slashesCount = match[3].length;
    } else rest = match[4];
    if (protocol === 'file:') {
        if (slashesCount >= 2) rest = rest.slice(2);
    } else if ($deb424f7a075f200$var$isSpecial(protocol)) rest = match[4];
    else if (protocol) {
        if (forwardSlashes) rest = rest.slice(2);
    } else if (slashesCount >= 2 && $deb424f7a075f200$var$isSpecial(location.protocol)) rest = match[4];
    return {
        protocol: protocol,
        slashes: forwardSlashes || $deb424f7a075f200$var$isSpecial(protocol),
        slashesCount: slashesCount,
        rest: rest
    };
}
/**
 * Resolve a relative URL pathname against a base URL pathname.
 *
 * @param {String} relative Pathname of the relative URL.
 * @param {String} base Pathname of the base URL.
 * @return {String} Resolved pathname.
 * @private
 */ function $deb424f7a075f200$var$resolve(relative, base) {
    if (relative === '') return base;
    var path = (base || '/').split('/').slice(0, -1).concat(relative.split('/')), i = path.length, last = path[i - 1], unshift = false, up = 0;
    while(i--){
        if (path[i] === '.') path.splice(i, 1);
        else if (path[i] === '..') {
            path.splice(i, 1);
            up++;
        } else if (up) {
            if (i === 0) unshift = true;
            path.splice(i, 1);
            up--;
        }
    }
    if (unshift) path.unshift('');
    if (last === '.' || last === '..') path.push('');
    return path.join('/');
}
/**
 * The actual URL instance. Instead of returning an object we've opted-in to
 * create an actual constructor as it's much more memory efficient and
 * faster and it pleases my OCD.
 *
 * It is worth noting that we should not use `URL` as class name to prevent
 * clashes with the global URL instance that got introduced in browsers.
 *
 * @constructor
 * @param {String} address URL we want to parse.
 * @param {Object|String} [location] Location defaults for relative paths.
 * @param {Boolean|Function} [parser] Parser for the query string.
 * @private
 */ function $deb424f7a075f200$var$Url(address, location, parser) {
    address = $deb424f7a075f200$var$trimLeft(address);
    address = address.replace($deb424f7a075f200$var$CRHTLF, '');
    if (!(this instanceof $deb424f7a075f200$var$Url)) return new $deb424f7a075f200$var$Url(address, location, parser);
    var relative, extracted, parse, instruction, index, key, instructions = $deb424f7a075f200$var$rules.slice(), type = typeof location, url = this, i = 0;
    //
    // The following if statements allows this module two have compatibility with
    // 2 different API:
    //
    // 1. Node.js's `url.parse` api which accepts a URL, boolean as arguments
    //    where the boolean indicates that the query string should also be parsed.
    //
    // 2. The `URL` interface of the browser which accepts a URL, object as
    //    arguments. The supplied object will be used as default values / fall-back
    //    for relative paths.
    //
    if ('object' !== type && 'string' !== type) {
        parser = location;
        location = null;
    }
    if (parser && 'function' !== typeof parser) parser = $3092e7c4432aeccb$exports.parse;
    location = $deb424f7a075f200$var$lolcation(location);
    //
    // Extract protocol information before running the instructions.
    //
    extracted = $deb424f7a075f200$var$extractProtocol(address || '', location);
    relative = !extracted.protocol && !extracted.slashes;
    url.slashes = extracted.slashes || relative && location.slashes;
    url.protocol = extracted.protocol || location.protocol || '';
    address = extracted.rest;
    //
    // When the authority component is absent the URL starts with a path
    // component.
    //
    if (extracted.protocol === 'file:' && (extracted.slashesCount !== 2 || $deb424f7a075f200$var$windowsDriveLetter.test(address)) || !extracted.slashes && (extracted.protocol || extracted.slashesCount < 2 || !$deb424f7a075f200$var$isSpecial(url.protocol))) instructions[3] = [
        /(.*)/,
        'pathname'
    ];
    for(; i < instructions.length; i++){
        instruction = instructions[i];
        if (typeof instruction === 'function') {
            address = instruction(address, url);
            continue;
        }
        parse = instruction[0];
        key = instruction[1];
        if (parse !== parse) url[key] = address;
        else if ('string' === typeof parse) {
            index = parse === '@' ? address.lastIndexOf(parse) : address.indexOf(parse);
            if (~index) {
                if ('number' === typeof instruction[2]) {
                    url[key] = address.slice(0, index);
                    address = address.slice(index + instruction[2]);
                } else {
                    url[key] = address.slice(index);
                    address = address.slice(0, index);
                }
            }
        } else if (index = parse.exec(address)) {
            url[key] = index[1];
            address = address.slice(0, index.index);
        }
        url[key] = url[key] || (relative && instruction[3] ? location[key] || '' : '');
        //
        // Hostname, host and protocol should be lowercased so they can be used to
        // create a proper `origin`.
        //
        if (instruction[4]) url[key] = url[key].toLowerCase();
    }
    //
    // Also parse the supplied query string in to an object. If we're supplied
    // with a custom parser as function use that instead of the default build-in
    // parser.
    //
    if (parser) url.query = parser(url.query);
    //
    // If the URL is relative, resolve the pathname against the base URL.
    //
    if (relative && location.slashes && url.pathname.charAt(0) !== '/' && (url.pathname !== '' || location.pathname !== '')) url.pathname = $deb424f7a075f200$var$resolve(url.pathname, location.pathname);
    //
    // Default to a / for pathname if none exists. This normalizes the URL
    // to always have a /
    //
    if (url.pathname.charAt(0) !== '/' && $deb424f7a075f200$var$isSpecial(url.protocol)) url.pathname = '/' + url.pathname;
    //
    // We should not add port numbers if they are already the default port number
    // for a given protocol. As the host also contains the port number we're going
    // override it with the hostname which contains no port number.
    //
    if (!$5654768c7acee223$exports(url.port, url.protocol)) {
        url.host = url.hostname;
        url.port = '';
    }
    //
    // Parse down the `auth` for the username and password.
    //
    url.username = url.password = '';
    if (url.auth) {
        index = url.auth.indexOf(':');
        if (~index) {
            url.username = url.auth.slice(0, index);
            url.username = encodeURIComponent(decodeURIComponent(url.username));
            url.password = url.auth.slice(index + 1);
            url.password = encodeURIComponent(decodeURIComponent(url.password));
        } else url.username = encodeURIComponent(decodeURIComponent(url.auth));
        url.auth = url.password ? url.username + ':' + url.password : url.username;
    }
    url.origin = url.protocol !== 'file:' && $deb424f7a075f200$var$isSpecial(url.protocol) && url.host ? url.protocol + '//' + url.host : 'null';
    //
    // The href is just the compiled result.
    //
    url.href = url.toString();
}
/**
 * This is convenience method for changing properties in the URL instance to
 * insure that they all propagate correctly.
 *
 * @param {String} part          Property we need to adjust.
 * @param {Mixed} value          The newly assigned value.
 * @param {Boolean|Function} fn  When setting the query, it will be the function
 *                               used to parse the query.
 *                               When setting the protocol, double slash will be
 *                               removed from the final url if it is true.
 * @returns {URL} URL instance for chaining.
 * @public
 */ function $deb424f7a075f200$var$set(part, value, fn) {
    var url = this;
    switch(part){
        case 'query':
            if ('string' === typeof value && value.length) value = (fn || $3092e7c4432aeccb$exports.parse)(value);
            url[part] = value;
            break;
        case 'port':
            url[part] = value;
            if (!$5654768c7acee223$exports(value, url.protocol)) {
                url.host = url.hostname;
                url[part] = '';
            } else if (value) url.host = url.hostname + ':' + value;
            break;
        case 'hostname':
            url[part] = value;
            if (url.port) value += ':' + url.port;
            url.host = value;
            break;
        case 'host':
            url[part] = value;
            if ($deb424f7a075f200$var$port.test(value)) {
                value = value.split(':');
                url.port = value.pop();
                url.hostname = value.join(':');
            } else {
                url.hostname = value;
                url.port = '';
            }
            break;
        case 'protocol':
            url.protocol = value.toLowerCase();
            url.slashes = !fn;
            break;
        case 'pathname':
        case 'hash':
            if (value) {
                var char = part === 'pathname' ? '/' : '#';
                url[part] = value.charAt(0) !== char ? char + value : value;
            } else url[part] = value;
            break;
        case 'username':
        case 'password':
            url[part] = encodeURIComponent(value);
            break;
        case 'auth':
            var index = value.indexOf(':');
            if (~index) {
                url.username = value.slice(0, index);
                url.username = encodeURIComponent(decodeURIComponent(url.username));
                url.password = value.slice(index + 1);
                url.password = encodeURIComponent(decodeURIComponent(url.password));
            } else url.username = encodeURIComponent(decodeURIComponent(value));
    }
    for(var i = 0; i < $deb424f7a075f200$var$rules.length; i++){
        var ins = $deb424f7a075f200$var$rules[i];
        if (ins[4]) url[ins[1]] = url[ins[1]].toLowerCase();
    }
    url.auth = url.password ? url.username + ':' + url.password : url.username;
    url.origin = url.protocol !== 'file:' && $deb424f7a075f200$var$isSpecial(url.protocol) && url.host ? url.protocol + '//' + url.host : 'null';
    url.href = url.toString();
    return url;
}
/**
 * Transform the properties back in to a valid and full URL string.
 *
 * @param {Function} stringify Optional query stringify function.
 * @returns {String} Compiled version of the URL.
 * @public
 */ function $deb424f7a075f200$var$toString(stringify) {
    if (!stringify || 'function' !== typeof stringify) stringify = $3092e7c4432aeccb$exports.stringify;
    var query, url = this, host = url.host, protocol = url.protocol;
    if (protocol && protocol.charAt(protocol.length - 1) !== ':') protocol += ':';
    var result = protocol + (url.protocol && url.slashes || $deb424f7a075f200$var$isSpecial(url.protocol) ? '//' : '');
    if (url.username) {
        result += url.username;
        if (url.password) result += ':' + url.password;
        result += '@';
    } else if (url.password) {
        result += ':' + url.password;
        result += '@';
    } else if (url.protocol !== 'file:' && $deb424f7a075f200$var$isSpecial(url.protocol) && !host && url.pathname !== '/') //
    // Add back the empty userinfo, otherwise the original invalid URL
    // might be transformed into a valid one with `url.pathname` as host.
    //
    result += '@';
    //
    // Trailing colon is removed from `url.host` when it is parsed. If it still
    // ends with a colon, then add back the trailing colon that was removed. This
    // prevents an invalid URL from being transformed into a valid one.
    //
    if (host[host.length - 1] === ':' || $deb424f7a075f200$var$port.test(url.hostname) && !url.port) host += ':';
    result += host + url.pathname;
    query = 'object' === typeof url.query ? stringify(url.query) : url.query;
    if (query) result += '?' !== query.charAt(0) ? '?' + query : query;
    if (url.hash) result += url.hash;
    return result;
}
$deb424f7a075f200$var$Url.prototype = {
    set: $deb424f7a075f200$var$set,
    toString: $deb424f7a075f200$var$toString
};
//
// Expose the URL parser and some additional properties that might be useful for
// others or testing.
//
$deb424f7a075f200$var$Url.extractProtocol = $deb424f7a075f200$var$extractProtocol;
$deb424f7a075f200$var$Url.location = $deb424f7a075f200$var$lolcation;
$deb424f7a075f200$var$Url.trimLeft = $deb424f7a075f200$var$trimLeft;
$deb424f7a075f200$var$Url.qs = $3092e7c4432aeccb$exports;
$deb424f7a075f200$exports = $deb424f7a075f200$var$Url;


function $768d36b334678dfa$export$37e0729cc751960b(pattern = '/', options = {}) {
    const { params: params = {}, query: query = {}, basePath: basePath = '' } = options;
    // @ts-ignore stringify accepts two params but it's type doesn't say so
    const stringifiedQuery = (0, $deb424f7a075f200$exports.qs).stringify(query, true);
    const pathname = pattern === '/' ? pattern : (0, $6a0a05a9da8f05fd$export$ef7acd7185315e22)(pattern)(params);
    return {
        pathname: `${basePath}${pathname}`,
        search: stringifiedQuery,
        hash: ''
    };
}



const $de4d1e4f61a87867$export$82476f982757e71e = (pattern = '/', params)=>pattern === '/' ? pattern : (0, $6a0a05a9da8f05fd$export$ef7acd7185315e22)(pattern)(params);


/**
 * @see https://github.com/jsdom/jsdom/releases/tag/12.0.0
 * @see https://github.com/jsdom/jsdom/issues/1537
 */ 
var $3ZMUU = parcelRequire("3ZMUU");
const $f9f42a63082f8b8d$var$isJsDomEnvironment = ()=>{
    var _navigator, _navigator2;
    return window.name === 'nodejs' || ((_navigator = navigator) == null ? void 0 : _navigator.userAgent.includes('Node.js')) || ((_navigator2 = navigator) == null ? void 0 : _navigator2.userAgent.includes('jsdom'));
};
const $f9f42a63082f8b8d$export$455cc18296abe008 = ()=>{
    if (typeof window === 'undefined' || typeof $3ZMUU !== 'undefined' && $3ZMUU.versions != null && $3ZMUU.versions.node != null) return true;
    if ($f9f42a63082f8b8d$var$isJsDomEnvironment()) return true;
    return false;
};




var $kqp0i = parcelRequire("kqp0i");
// TAKEN FROM https://github.com/ReactTraining/react-router/blob/master/packages/react-router/modules/matchPath.js

const $e7a9aee364b5805f$var$cache = {};
const $e7a9aee364b5805f$var$cacheLimit = 10000;
let $e7a9aee364b5805f$var$cacheCount = 0;
function $e7a9aee364b5805f$var$compilePath(path, options) {
    const cacheKey = `${options.end}${options.strict}${options.sensitive}`;
    const pathCache = $e7a9aee364b5805f$var$cache[cacheKey] || ($e7a9aee364b5805f$var$cache[cacheKey] = {});
    if (pathCache[path]) return pathCache[path];
    const keys = [];
    const regexp = (0, $6a0a05a9da8f05fd$export$71304158c7e35877)(path, keys, options);
    const result = {
        regexp: regexp,
        keys: keys
    };
    if ($e7a9aee364b5805f$var$cacheCount < $e7a9aee364b5805f$var$cacheLimit) {
        pathCache[path] = result;
        $e7a9aee364b5805f$var$cacheCount++;
    }
    return result;
}
/**
 * Public API for matching a URL pathname to a path.
 * TODO: reduce returns Array<never>
 */ function $e7a9aee364b5805f$var$matchPath(pathname, options = {}) {
    if (typeof options === 'string' || Array.isArray(options)) options = {
        path: options
    };
    const { path: p, exact: exact = false, strict: strict = false, sensitive: sensitive = false, basePath: basePath = '' } = options;
    const paths = [].concat(basePath + p);
    return paths.reduce((matched, path)=>{
        if (!path && path !== '') return null;
        if (matched) return matched;
        const { regexp: regexp, keys: keys } = $e7a9aee364b5805f$var$compilePath(path, {
            end: exact,
            strict: strict,
            sensitive: sensitive
        });
        const match = regexp.exec(pathname);
        if (!match) return null;
        const [url, ...values] = match;
        const isExact = pathname === url;
        if (exact && !isExact) return null;
        return {
            path: path,
            // the path used to match
            url: path === '/' && url === '' ? '/' : url,
            isExact: // the matched portion of the URL
            isExact,
            // whether or not we matched exactly
            params: keys.reduce((memo, key, index)=>{
                memo[key.name] = values[index];
                return memo;
            }, {})
        };
    }, null);
}
var $e7a9aee364b5805f$export$2e2bcd8739ae039 = $e7a9aee364b5805f$var$matchPath;



var $kqp0i = parcelRequire("kqp0i");
/**
 * Matches `queryStr` against config stored in `queryConfig`.
 *
 * Returns `pathMatch` with an additional query prop with query params if the match succeeds,
 * otherwise returns null.
 *
 */ function $3dd31f20fffa4bf7$var$matchQuery(queryConfig, queryParams, pathMatch) {
    const queryMatch = {};
    const isMatchingQuery = queryConfig.every((query)=>{
        // eslint-disable-next-line prefer-const
        let [names, value] = query.split('=');
        let negation = false;
        /* Check if negative matching query param (eg 'foo!=1') */ if (query.includes('!=')) {
            names = names.substring(0, names.length - 1);
            negation = true;
        }
        /* Allow alternate query params presence (eg 'foo|bar') */ const matched = names.split('|').map((name)=>{
            let isOptional = false;
            /* Check if optional query param (eg 'foo?') */ if (name.includes('?')) {
                // eslint-disable-next-line no-param-reassign
                name = name.substring(0, name.length - 1);
                isOptional = true;
            }
            /* First check if queryParams contains the relevant param */ let match = Object.prototype.hasOwnProperty.call(queryParams, name);
            /* Save actual value so we expose it as part of match object */ if (match) queryMatch[name] = queryParams[name] || '';
            /* If no value matching required or it is optional and the param is missing */ if (!value || isOptional && !match) return isOptional || match;
            if (value.startsWith('(')) /* Handle value being a regexp eg 's=(\\d+)' */ match = new RegExp(`^${value}$`).test(queryParams[name] || '');
            else /* Handle value exact matching eg 's=123' */ match = queryParams[name] === value;
            return negation ? !match : match;
        });
        /* If at least one of alternate query params matches then it is a match */ return matched.includes(true);
    });
    return isMatchingQuery ? (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, pathMatch, {
        query: queryMatch
    }) : null;
}
var $3dd31f20fffa4bf7$export$2e2bcd8739ae039 = $3dd31f20fffa4bf7$var$matchQuery;


/* This should match what react-router does to compute a root match. */ const $f9b6403fcc99d44d$var$computeRootMatch = (pathname)=>({
        path: '/',
        url: '/',
        params: {},
        isExact: pathname === '/',
        query: {}
    });
function $f9b6403fcc99d44d$var$execRouteMatching(route, pathname, queryObj, basePath) {
    const pathMatch = route.path ? (0, $e7a9aee364b5805f$export$2e2bcd8739ae039)(pathname, {
        path: route.path,
        exact: route.exact,
        basePath: basePath
    }) : $f9b6403fcc99d44d$var$computeRootMatch(pathname);
    let match = pathMatch;
    if (pathMatch && route.query) match = (0, $3dd31f20fffa4bf7$export$2e2bcd8739ae039)(route.query, queryObj, pathMatch);
    else if (pathMatch) match = (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, pathMatch, {
        query: {}
    });
    if (match) return {
        match: match,
        route: route
    };
    return null;
}
var $f9b6403fcc99d44d$export$2e2bcd8739ae039 = $f9b6403fcc99d44d$var$execRouteMatching;


const $5945d60cd4066b5d$var$hasOwnProperty = Object.prototype.hasOwnProperty;
const $5945d60cd4066b5d$var$MAX_CACHE_SIZE = 1000;
function $5945d60cd4066b5d$var$shallowEqual(objA, objB) {
    if (objA === objB) return true;
    if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) return false;
    const keysA = Object.keys(objA);
    const keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    // Test for A's keys different from B.
    for(let i = 0; i < keysA.length; i++){
        if (!$5945d60cd4066b5d$var$hasOwnProperty.call(objB, keysA[i]) || objA[keysA[i]] !== objB[keysA[i]]) return false;
    }
    return true;
}
const $5945d60cd4066b5d$export$f594abf16a5ad948 = {
    cache: new Map(),
    get (pathname, queryObj, basePath) {
        const pathCache = this.cache.get(basePath + pathname);
        if (pathCache) for (const [key, value] of pathCache){
            if ($5945d60cd4066b5d$var$shallowEqual(key, queryObj)) return value;
        }
    },
    set (pathname, queryObj, basePath, matchRoute) {
        if (this.cache.size > $5945d60cd4066b5d$var$MAX_CACHE_SIZE) this.cache.clear();
        const pathCache = this.cache.get(basePath + pathname);
        if (pathCache) {
            if (pathCache.size > $5945d60cd4066b5d$var$MAX_CACHE_SIZE / 10) pathCache.clear();
            pathCache.set(queryObj, matchRoute);
        } else this.cache.set(basePath + pathname, new Map([
            [
                queryObj,
                matchRoute
            ]
        ]));
    }
};


/**
 * Does the given `pathname` and `queryStr` match a route in `routes`.
 *
 * Heavily based on https://github.com/ReactTraining/react-router/blob/master/packages/react-router-config/modules/matchRoute.js
 *
 * Note: This does not support nested routes at this stage.
 */ const $e7f860d2e0e9373c$var$matchRoute = (routes, pathname, queryParams = {}, basePath = '')=>{
    // if navigating to to `/` or just basePath, then do not append basePath
    const updatedBasePath = [
        '/',
        basePath
    ].includes(pathname) ? '' : basePath;
    const queryParamObject = typeof queryParams === 'string' ? (0, $deb424f7a075f200$exports.qs).parse(queryParams) : queryParams;
    const cachedMatch = (0, $5945d60cd4066b5d$export$f594abf16a5ad948).get(pathname, queryParamObject, updatedBasePath);
    if (cachedMatch && routes.includes(cachedMatch.route)) return cachedMatch;
    for(let i = 0; i < routes.length; i++){
        const matchedRoute = (0, $f9b6403fcc99d44d$export$2e2bcd8739ae039)(routes[i], pathname, queryParamObject, updatedBasePath);
        if (matchedRoute) {
            (0, $5945d60cd4066b5d$export$f594abf16a5ad948).set(pathname, queryParamObject, updatedBasePath, matchedRoute);
            return matchedRoute;
        }
    }
    return null;
};
const $e7f860d2e0e9373c$export$ce5b73cebfeaa567 = (routes, pathname, queryParams, basePath = '')=>$e7f860d2e0e9373c$var$matchRoute(routes, pathname, queryParams, basePath);
const $e7f860d2e0e9373c$export$4e76f1d455ef7c95 = (route, pathname, queryParams, basePath = '')=>{
    $e7f860d2e0e9373c$var$matchRoute([
        route
    ], pathname, queryParams, basePath);
};
var $e7f860d2e0e9373c$export$2e2bcd8739ae039 = (routes, pathname, queryParams, basePath = '')=>$e7f860d2e0e9373c$var$matchRoute(routes, pathname, queryParams, basePath);





const $0100e5f4b4767f2b$export$7c22f8f9552f689e = {
    pathname: '',
    search: '',
    hash: ''
};
const $0100e5f4b4767f2b$export$2de13e891a662beb = {
    params: {},
    isExact: false,
    path: '',
    url: '',
    query: {}
};
const $0100e5f4b4767f2b$export$4eadc79233226325 = {
    path: '',
    component: ()=>null,
    name: ''
};
const $0100e5f4b4767f2b$export$39607c9878cf5148 = (0, $9d4782ee5a008819$export$883c3f3b6c000133)();
const $0100e5f4b4767f2b$export$1515254c8c90bebb = {
    location: $0100e5f4b4767f2b$export$7c22f8f9552f689e,
    push: (0, (/*@__PURE__*/$parcel$interopDefault($0ae6c8b81570b5e1$exports))),
    replace: (0, (/*@__PURE__*/$parcel$interopDefault($0ae6c8b81570b5e1$exports))),
    goBack: (0, (/*@__PURE__*/$parcel$interopDefault($0ae6c8b81570b5e1$exports))),
    goForward: (0, (/*@__PURE__*/$parcel$interopDefault($0ae6c8b81570b5e1$exports))),
    listen: (0, (/*@__PURE__*/$parcel$interopDefault($0ae6c8b81570b5e1$exports))),
    block: (0, (/*@__PURE__*/$parcel$interopDefault($0ae6c8b81570b5e1$exports))),
    createHref: (0, (/*@__PURE__*/$parcel$interopDefault($0ae6c8b81570b5e1$exports)))
};
const $0100e5f4b4767f2b$export$fa440ddf675c8a93 = 'POP';




const $10a8bc47d57825ec$export$faed15f35ddc6f99 = (route, options = {})=>{
    const { params: params = {}, query: query = {}, basePath: basePath = '' } = options;
    const pathname = (0, $de4d1e4f61a87867$export$82476f982757e71e)(route.path, params);
    const matchedRoute = (0, $e7f860d2e0e9373c$export$2e2bcd8739ae039)([
        route
    ], pathname, query, basePath);
    return {
        route: route,
        match: matchedRoute ? matchedRoute.match : (0, $0100e5f4b4767f2b$export$2de13e891a662beb),
        query: query
    };
};
const $10a8bc47d57825ec$export$a0bd0313cbeabd49 = (routes, options)=>{
    const { location: location, basePath: basePath = '' } = options;
    const { pathname: pathname, search: search } = location;
    const query = (0, $deb424f7a075f200$exports.qs).parse(search);
    const matchedRoute = (0, $e7f860d2e0e9373c$export$2e2bcd8739ae039)(routes, pathname, query, basePath);
    return {
        query: query,
        route: matchedRoute ? matchedRoute.route : (0, $0100e5f4b4767f2b$export$4eadc79233226325),
        match: matchedRoute ? matchedRoute.match : (0, $0100e5f4b4767f2b$export$2de13e891a662beb)
    };
};


const $31916272644d9021$var$isShallowEqual = (o1, o2)=>{
    const objKeys1 = Object.keys(o1);
    const objKeys2 = Object.keys(o2);
    if (objKeys1.length !== objKeys2.length) return false;
    return objKeys1.every((key)=>o1[key] === o2[key]);
};
const $31916272644d9021$export$5997e70fc4543270 = ({ prevContextMatch: prevContextMatch, nextContextMatch: nextContextMatch })=>prevContextMatch.path === nextContextMatch.path && $31916272644d9021$var$isShallowEqual(prevContextMatch.query, nextContextMatch.query) && $31916272644d9021$var$isShallowEqual(prevContextMatch.params, nextContextMatch.params);





var $kqp0i = parcelRequire("kqp0i");


var $6lPP6 = parcelRequire("6lPP6");
var $gNUZr = parcelRequire("gNUZr");
var $dWq0h = parcelRequire("dWq0h");
var $1uA8D = parcelRequire("1uA8D");
var $8i0MQ = parcelRequire("8i0MQ");




const $c21e9538f0e35012$var$stripTrailingSlash = (path)=>path.charAt(path.length - 1) === '/' ? path.slice(0, -1) : path;
const $c21e9538f0e35012$var$addLeadingSlash = (path)=>path.charAt(0) === '/' ? path : '/' + path;
const $c21e9538f0e35012$export$b8ce2e8154d1dff1 = (path, prefix = '')=>{
    if (prefix) {
        prefix = $c21e9538f0e35012$var$stripTrailingSlash(prefix);
        prefix = $c21e9538f0e35012$var$addLeadingSlash(prefix);
        path = $c21e9538f0e35012$var$addLeadingSlash(path);
    }
    return prefix + path;
};
const $c21e9538f0e35012$export$e83e3719fc818ee5 = (path)=>{
    const regex = new RegExp('^([a-z]+://|//)', 'i');
    return regex.test(path);
};
const $c21e9538f0e35012$export$2fa6dede99f181e5 = (path)=>{
    if (typeof path !== 'string' || !$c21e9538f0e35012$export$e83e3719fc818ee5(path)) return false;
    const pathHostname = new (0, (/*@__PURE__*/$parcel$interopDefault($deb424f7a075f200$exports)))(path).hostname;
    const currentHostname = new (0, (/*@__PURE__*/$parcel$interopDefault($deb424f7a075f200$exports)))(window.location.href).hostname;
    return pathHostname !== currentHostname;
};
const $c21e9538f0e35012$export$ae9fda833d91ed65 = (path, prefix = '')=>{
    if (typeof path !== 'string') return path;
    if (!$c21e9538f0e35012$export$e83e3719fc818ee5(path)) {
        path = $c21e9538f0e35012$export$b8ce2e8154d1dff1(path, prefix);
        return path;
    }
    const url = new (0, (/*@__PURE__*/$parcel$interopDefault($deb424f7a075f200$exports)))(path);
    return `${url.pathname}${url.query}${url.hash}`;
};
const $c21e9538f0e35012$export$92377f461a797888 = (location, query)=>{
    // @ts-ignore stringify accepts two params but it's type doesn't say so
    const stringifiedQuery = (0, $deb424f7a075f200$exports.qs).stringify(query, true);
    return `${location.pathname}${stringifiedQuery}${location.hash}`;
};
const $c21e9538f0e35012$export$9ae1c7c875ef309d = (location)=>{
    return `${location.pathname}${location.search}${location.hash}`;
};
const $c21e9538f0e35012$export$c9237620ff7fdf7c = ({ context: context, prevContext: prevContext, pluginId: pluginId })=>{
    const sameRoute = (0, $31916272644d9021$export$5997e70fc4543270)({
        prevContextMatch: prevContext.match,
        nextContextMatch: context.match
    });
    // keep old behaviour for Resources plugin
    // load Route only if path/query/params changed, and ignore the rest of query-params
    const defaultShouldReload = pluginId === 'resources-plugin' || !sameRoute;
    if (context.route === prevContext.route && context.route.EXPERIMENTAL__shouldReload) {
        const routeChoice = context.route.EXPERIMENTAL__shouldReload({
            context: context,
            prevContext: prevContext,
            pluginId: pluginId,
            defaultShouldReload: defaultShouldReload
        });
        if (typeof routeChoice === 'boolean') return routeChoice;
    }
    return defaultShouldReload;
};


const $1ddaa6502d719738$export$36d128238e6b60f5 = {
    action: (0, $0100e5f4b4767f2b$export$fa440ddf675c8a93),
    basePath: '',
    location: (0, $0100e5f4b4767f2b$export$39607c9878cf5148).location,
    history: (0, $0100e5f4b4767f2b$export$39607c9878cf5148),
    match: (0, $0100e5f4b4767f2b$export$2de13e891a662beb),
    onPrefetch: undefined,
    query: {},
    route: (0, $0100e5f4b4767f2b$export$4eadc79233226325),
    routes: [],
    unlisten: null,
    plugins: []
};
const $1ddaa6502d719738$var$actions = {
    /**
   * Bootstraps the store with initial data.
   *
   */ bootstrapStore: (props)=>({ setState: setState, dispatch: dispatch })=>{
            const { basePath: basePath = '', history: history, initialRoute: initialRoute, onPrefetch: onPrefetch, routes: routes, plugins: plugins } = props;
            const routerContext = (0, $10a8bc47d57825ec$export$a0bd0313cbeabd49)(initialRoute ? [
                initialRoute
            ] : routes, {
                location: history.location,
                basePath: basePath
            });
            setState((0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, routerContext, {
                basePath: basePath,
                history: history,
                onPrefetch: onPrefetch,
                routes: routes,
                location: history.location,
                action: history.action,
                plugins: plugins
            }));
            if (!(0, $f9f42a63082f8b8d$export$455cc18296abe008)()) dispatch($1ddaa6502d719738$var$actions.listen());
        },
    /**
   * Starts listening to browser history and sets the unlisten function in state.
   * Will request route resources on route change.
   *
   */ listen: ()=>({ getState: getState, setState: setState })=>{
            const { history: history, unlisten: unlisten } = getState();
            if (unlisten) unlisten();
            const stopListening = history.listen((...update)=>{
                const location = update.length === 2 ? update[0] : update[0].location;
                const action = update.length === 2 ? update[1] : update[0].action;
                const { plugins: plugins, routes: routes, basePath: basePath, match: currentMatch, route: currentRoute, query: currentQuery } = getState();
                const nextContext = (0, $10a8bc47d57825ec$export$a0bd0313cbeabd49)(routes, {
                    location: location,
                    basePath: basePath
                });
                const prevContext = {
                    route: currentRoute,
                    match: currentMatch,
                    query: currentQuery
                };
                const shouldReloadByPlugin = new Map(plugins.map((plugin)=>[
                        plugin.id,
                        (0, $c21e9538f0e35012$export$c9237620ff7fdf7c)({
                            context: nextContext,
                            prevContext: prevContext,
                            pluginId: plugin.id
                        })
                    ]));
                /* Explicitly batch update
       * as we need resources cleaned + route changed + resource fetch started together
       * If we do not batch, React might be re-render when route changes but resource
       * fetching has not started yet, making the app render with data null */ (0, $6lPP6.batch)(()=>{
                    plugins.forEach((p)=>{
                        if (shouldReloadByPlugin.get(p.id)) p.beforeRouteLoad == null || p.beforeRouteLoad({
                            context: prevContext,
                            nextContext: nextContext
                        });
                    });
                    setState((0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, nextContext, {
                        location: location,
                        action: action
                    }));
                    plugins.forEach((p)=>{
                        if (shouldReloadByPlugin.get(p.id)) p.routeLoad == null || p.routeLoad({
                            context: nextContext,
                            prevContext: prevContext
                        });
                    });
                });
            });
            setState({
                unlisten: stopListening
            });
        },
    push: (path, state)=>({ getState: getState })=>{
            const { history: history, basePath: basePath } = getState();
            if ((0, $c21e9538f0e35012$export$2fa6dede99f181e5)(path)) window.location.assign(path);
            else history.push((0, $c21e9538f0e35012$export$ae9fda833d91ed65)(path, basePath), state);
        },
    pushTo: (route, attributes = {})=>({ getState: getState })=>{
            const { history: history, basePath: basePath } = getState();
            const location = (0, $768d36b334678dfa$export$37e0729cc751960b)(route.path, (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, attributes, {
                basePath: basePath
            }));
            (0, $e7f860d2e0e9373c$export$4e76f1d455ef7c95)(route, location.pathname, attributes.query, basePath);
            history.push(location, attributes == null ? void 0 : attributes.state);
        },
    replace: (path, state)=>({ getState: getState })=>{
            const { history: history, basePath: basePath } = getState();
            if ((0, $c21e9538f0e35012$export$2fa6dede99f181e5)(path)) window.location.replace(path);
            else history.replace((0, $c21e9538f0e35012$export$ae9fda833d91ed65)(path, basePath), state);
        },
    replaceTo: (route, attributes = {})=>({ getState: getState })=>{
            const { history: history, basePath: basePath } = getState();
            const location = (0, $768d36b334678dfa$export$37e0729cc751960b)(route.path, (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, attributes, {
                basePath: basePath
            }));
            (0, $e7f860d2e0e9373c$export$4e76f1d455ef7c95)(route, location.pathname, attributes.query, basePath);
            history.replace(location, attributes == null ? void 0 : attributes.state);
        },
    goBack: ()=>({ getState: getState })=>{
            const { history: history } = getState();
            // history@4 uses goBack(), history@5 uses back()
            if ('goBack' in history) history.goBack();
            else if ('back' in history) history.back();
            else throw new Error('History does not support goBack');
        },
    goForward: ()=>({ getState: getState })=>{
            const { history: history } = getState();
            // history@4 uses goForward(), history@5 uses forward()
            if ('goForward' in history) history.goForward();
            else if ('forward' in history) history.forward();
            else throw new Error('History does not support goForward');
        },
    registerBlock: (blocker)=>({ getState: getState })=>{
            const { history: history } = getState();
            return history.block(blocker);
        },
    getContext: ()=>({ getState: getState })=>{
            const { query: query, route: route, match: match } = getState();
            return {
                query: query,
                route: route,
                match: match
            };
        },
    getBasePath: ()=>({ getState: getState })=>{
            const { basePath: basePath } = getState();
            return basePath;
        },
    updateQueryParam: (params, updateType = 'push')=>({ getState: getState })=>{
            const { query: existingQueryParams, history: history, location: location } = getState();
            const updatedQueryParams = (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, existingQueryParams, params);
            // remove undefined keys
            Object.keys(updatedQueryParams).forEach((key)=>updatedQueryParams[key] === undefined && delete updatedQueryParams[key]);
            const existingPath = (0, $c21e9538f0e35012$export$92377f461a797888)(location, existingQueryParams);
            const updatedPath = (0, $c21e9538f0e35012$export$92377f461a797888)(location, updatedQueryParams);
            if (updatedPath !== existingPath) history[updateType](updatedPath);
        },
    updatePathParam: (params, updateType = 'push')=>({ getState: getState })=>{
            const { history: history, location: location, route: { path: path }, match: { params: existingPathParams }, basePath: basePath } = getState();
            const pathWithBasePath = basePath + path;
            const updatedPathParams = (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, existingPathParams, params);
            const updatedPath = (0, $de4d1e4f61a87867$export$82476f982757e71e)(pathWithBasePath, updatedPathParams);
            const updatedLocation = (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, location, {
                pathname: updatedPath
            });
            const existingRelativePath = (0, $c21e9538f0e35012$export$9ae1c7c875ef309d)(location);
            const updatedRelativePath = (0, $c21e9538f0e35012$export$9ae1c7c875ef309d)(updatedLocation);
            if (updatedRelativePath !== existingRelativePath) history[updateType](updatedRelativePath);
        },
    loadPlugins: ()=>({ getState: getState })=>{
            const { plugins: plugins, match: match, query: query, route: route } = getState();
            plugins.forEach((p)=>p.routeLoad == null ? void 0 : p.routeLoad({
                    context: {
                        match: match,
                        query: query,
                        route: route
                    }
                }));
        },
    prefetchRoute: (path, nextContext)=>({ getState: getState })=>{
            const { plugins: plugins, routes: routes, basePath: basePath, onPrefetch: onPrefetch } = getState();
            const { route: route, match: match, query: query } = $1ddaa6502d719738$export$ebf37f7e180b13a9();
            if (!nextContext && !(0, $c21e9538f0e35012$export$2fa6dede99f181e5)(path)) {
                const location = (0, $c29d101a2cf08ade$export$8ccf933b0513f8d0)((0, $c21e9538f0e35012$export$ae9fda833d91ed65)(path, basePath));
                nextContext = (0, $10a8bc47d57825ec$export$a0bd0313cbeabd49)(routes, {
                    location: location,
                    basePath: basePath
                });
            }
            if (nextContext == null) return;
            const nextLocationContext = nextContext;
            (0, $6lPP6.batch)(()=>{
                plugins.forEach((p)=>p.routePrefetch == null ? void 0 : p.routePrefetch({
                        context: {
                            route: route,
                            match: match,
                            query: query
                        },
                        nextContext: nextLocationContext
                    }));
                if (onPrefetch) onPrefetch(nextLocationContext);
            });
        }
};
const $1ddaa6502d719738$export$1cf0ecab63b1963c = (0, $1uA8D.createStore)({
    initialState: $1ddaa6502d719738$export$36d128238e6b60f5,
    actions: $1ddaa6502d719738$var$actions,
    name: 'router'
});
const $1ddaa6502d719738$export$d6b817abe7a77ea5 = (0, $dWq0h.createContainer)($1ddaa6502d719738$export$1cf0ecab63b1963c, {
    displayName: 'RouterContainer',
    onInit: ()=>({ dispatch: dispatch }, props)=>{
            dispatch($1ddaa6502d719738$var$actions.bootstrapStore(props));
            !(0, $f9f42a63082f8b8d$export$455cc18296abe008)() && dispatch($1ddaa6502d719738$var$actions.loadPlugins());
        },
    onCleanup: ()=>(state)=>{
            if (!(0, $f9f42a63082f8b8d$export$455cc18296abe008)()) {
                const { unlisten: unlisten } = state.getState();
                unlisten && unlisten();
            }
        }
});
const $1ddaa6502d719738$export$9569010eab09ae9e = (0, $gNUZr.createHook)($1ddaa6502d719738$export$1cf0ecab63b1963c);
const $1ddaa6502d719738$export$ada49399abf7a3a1 = (0, $gNUZr.createActionsHook)($1ddaa6502d719738$export$1cf0ecab63b1963c);
function $1ddaa6502d719738$export$95ab46bba7ea7a22(selector) {
    const useHook = (0, $gNUZr.createHook)($1ddaa6502d719738$export$1cf0ecab63b1963c, {
        selector: selector
    });
    return function useRouterSelector(...args) {
        return useHook(...args)[0];
    };
}
const $1ddaa6502d719738$export$5ccad187366c8494 = ()=>// @ts-ignore calling `getStore` without providing a scopeId
    (0, $8i0MQ.defaultRegistry).getStore($1ddaa6502d719738$export$1cf0ecab63b1963c);
const $1ddaa6502d719738$export$ebf37f7e180b13a9 = ()=>$1ddaa6502d719738$export$5ccad187366c8494().storeState.getState();


const $b421c015f5018cd0$export$9a302a45f65d0572 = (0, $1ddaa6502d719738$export$9569010eab09ae9e);


class $d60bad8df7964b6c$var$Redirector extends (0, $5FkrB.Component) {
    componentDidMount() {
        const { to: to, location: location, push: push, params: params, query: query, actions: actions } = this.props;
        const routeAttributes = {
            params: params,
            query: query,
            basePath: actions.getBasePath()
        };
        const newPath = typeof to === 'object' ? 'path' in to ? (0, $c29d101a2cf08ade$export$fe53371bee54353d)((0, $768d36b334678dfa$export$37e0729cc751960b)(to.path, routeAttributes)) : (0, $c29d101a2cf08ade$export$fe53371bee54353d)(to) : to;
        const currentPath = (0, $c29d101a2cf08ade$export$fe53371bee54353d)(location);
        const action = push ? actions.push : actions.replace;
        if (currentPath === newPath) return;
        action(newPath);
    }
    render() {
        return null;
    }
}
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($d60bad8df7964b6c$var$Redirector, "defaultProps", {
    push: false
});
const $d60bad8df7964b6c$export$2d8d895a0a0f636e = (props)=>{
    const [{ location: location }, actions] = (0, $b421c015f5018cd0$export$9a302a45f65d0572)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement($d60bad8df7964b6c$var$Redirector, (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        actions: actions,
        location: location
    }, props));
};



var $kqp0i = parcelRequire("kqp0i");


var $5FkrB = parcelRequire("5FkrB");

const $ddc1dbf2b1f7581e$export$55185c17a0fcbe46 = ({ basePath: basePath, children: children, history: history, initialRoute: initialRoute, isGlobal: isGlobal = true, plugins: plugins, onPrefetch: onPrefetch, routes: routes })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $1ddaa6502d719738$export$d6b817abe7a77ea5), {
        basePath: basePath,
        history: history,
        initialRoute: initialRoute,
        isGlobal: isGlobal,
        onPrefetch: onPrefetch,
        plugins: plugins != null ? plugins : [],
        routes: routes
    }, children);
};
function $ddc1dbf2b1f7581e$export$ae46f04cfaffe093(props) {
    var _props$plugins;
    const history = (0, $5FkrB.useMemo)(()=>(0, $c29d101a2cf08ade$export$2b76ad033c6e6d08)(props.location ? {
            initialEntries: [
                props.location
            ]
        } : {}), [
        props.location
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement($ddc1dbf2b1f7581e$export$55185c17a0fcbe46, (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, props, {
        history: history,
        isGlobal: false,
        plugins: (_props$plugins = props == null ? void 0 : props.plugins) != null ? _props$plugins : []
    }));
}



var $5FkrB = parcelRequire("5FkrB");

const $7ffd4dfc86b29f7d$export$402e82ff1b20594b = (0, $1ddaa6502d719738$export$ada49399abf7a3a1);


const $f38a5098ae6c30bf$export$b371fa9cf762ad06 = ({ children: children })=>{
    const actions = (0, $7ffd4dfc86b29f7d$export$402e82ff1b20594b)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).Fragment, null, children(actions));
};
$f38a5098ae6c30bf$export$b371fa9cf762ad06.displayName = 'RouterActions';



var $19a0g = parcelRequire("19a0g");

var $5FkrB = parcelRequire("5FkrB");


const $a22a4d51e8ac3bb8$var$_excluded = [
    "listen"
];
const $a22a4d51e8ac3bb8$export$672d721d310ff5f0 = ({ children: children })=>{
    const [state, _ref] = (0, $1ddaa6502d719738$export$9569010eab09ae9e)();
    const { listen: listen } = _ref, actions = (0, (/*@__PURE__*/$parcel$interopDefault($19a0g)))(_ref, $a22a4d51e8ac3bb8$var$_excluded);
    if (!state.unlisten && !(0, $f9f42a63082f8b8d$export$455cc18296abe008)()) listen();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).Fragment, null, children(state, actions));
};




var $5FkrB = parcelRequire("5FkrB");

var $gNUZr = parcelRequire("gNUZr");

const $5b08526dd1b3cd91$var$createPathParamHook = (0, $gNUZr.createHook)((0, $1ddaa6502d719738$export$1cf0ecab63b1963c), {
    selector: ({ match: { params: params } }, { paramKey: paramKey })=>params[paramKey]
});
const $5b08526dd1b3cd91$export$8c8591dcd57728e6 = (paramKey)=>{
    const [paramVal, routerActions] = $5b08526dd1b3cd91$var$createPathParamHook({
        paramKey: paramKey
    });
    const setPathParam = (0, $5FkrB.useCallback)((newValue, updateType)=>{
        routerActions.updatePathParam({
            [paramKey]: newValue
        }, updateType);
    }, [
        paramKey,
        routerActions
    ]);
    return [
        paramVal,
        setPathParam
    ];
};



var $5FkrB = parcelRequire("5FkrB");

var $gNUZr = parcelRequire("gNUZr");

const $a137eec8ff4dd5ae$var$createQueryParamHook = (0, $gNUZr.createHook)((0, $1ddaa6502d719738$export$1cf0ecab63b1963c), {
    selector: ({ query: query }, { paramKey: paramKey })=>query[paramKey]
});
const $a137eec8ff4dd5ae$export$ae316f0eeb712a36 = (paramKey)=>{
    const [paramVal, routerActions] = $a137eec8ff4dd5ae$var$createQueryParamHook({
        paramKey: paramKey
    });
    const setQueryParam = (0, $5FkrB.useCallback)((newValue, updateType)=>{
        routerActions.updateQueryParam({
            [paramKey]: newValue
        }, updateType);
    }, [
        paramKey,
        routerActions
    ]);
    return [
        paramVal,
        setQueryParam
    ];
};





var $kqp0i = parcelRequire("kqp0i");

var $5FkrB = parcelRequire("5FkrB");

const $f541dcf8f1a6c6da$var$getWrappedComponentDisplayName = (component)=>{
    let componentDisplayName = 'UNDEFINED';
    const { displayName: displayName, name: name } = component;
    if (displayName) componentDisplayName = displayName;
    if (name) componentDisplayName = name;
    return `withRouter(${componentDisplayName})`;
};
const $f541dcf8f1a6c6da$export$369b6b2b30582e8e = (WrappedComponent)=>{
    const displayName = $f541dcf8f1a6c6da$var$getWrappedComponentDisplayName(WrappedComponent);
    const Component = WrappedComponent;
    const ComponentWithRouter = (props)=>{
        const [{ action: action, history: history, location: location, match: match, query: query, route: route }, { push: push, replace: replace }] = (0, $1ddaa6502d719738$export$9569010eab09ae9e)();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(Component, (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, props, {
            action: action,
            history: history,
            location: location,
            match: match,
            push: push,
            query: query,
            replace: replace,
            route: route
        }));
    };
    ComponentWithRouter.displayName = displayName;
    return ComponentWithRouter;
};





var $kqp0i = parcelRequire("kqp0i");

var $19a0g = parcelRequire("19a0g");


var $5FkrB = parcelRequire("5FkrB");



var $5FkrB = parcelRequire("5FkrB");
const $816a5189e752f4e6$export$d8e6abf214c9ec0f = (delay)=>{
    const timeoutId = (0, $5FkrB.useRef)();
    const schedule = (0, $5FkrB.useCallback)((callback)=>{
        if (timeoutId.current) clearTimeout(timeoutId.current);
        timeoutId.current = setTimeout(callback, delay);
    }, [
        delay
    ]);
    const cancel = (0, $5FkrB.useCallback)(()=>{
        clearTimeout(timeoutId.current);
    }, []);
    return {
        schedule: schedule,
        cancel: cancel
    };
};


const $39281ff350272ced$var$VALID_LINK_TYPES = [
    'a',
    'button'
];
const $39281ff350272ced$export$855ece989b15eb57 = (type)=>$39281ff350272ced$var$VALID_LINK_TYPES.includes(type) ? type : 'a';


const $f169e8fd2c308647$export$642c6f14f6d4bbd5 = (event)=>!!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
const $f169e8fd2c308647$export$130b789831072f4c = (event)=>[
        'keypress',
        'keydown',
        'keyup'
    ].includes(event.type);


const $05c5e447ce24817b$export$706ad1af8096e280 = (event, { onClick: onClick, target: target, replace: replace, routerActions: routerActions, href: href, to: to, state: state })=>{
    if ((0, $f169e8fd2c308647$export$130b789831072f4c)(event) && event.key !== 'Enter') return;
    onClick && onClick(event);
    if (!event.defaultPrevented && // onClick prevented default
    ((0, $f169e8fd2c308647$export$130b789831072f4c)(event) && event.key === 'Enter' || event.button === 0) && // ignore everything but left clicks and Enter key
    (!target || target === '_self') && // let browser handle "target=_blank" etc.
    !(0, $f169e8fd2c308647$export$642c6f14f6d4bbd5)(event) // ignore clicks with modifier keys
    ) {
        event.preventDefault();
        if (to) {
            const method = replace ? routerActions.replaceTo : routerActions.pushTo;
            method(...to, state);
        } else {
            const method = replace ? routerActions.replace : routerActions.push;
            method(href, state);
        }
    }
};




const $dba17dfd00ae7d8f$var$_excluded = [
    "children",
    "target",
    "replace",
    "href",
    "to",
    "onClick",
    "onMouseEnter",
    "onMouseLeave",
    "onPointerDown",
    "onFocus",
    "onBlur",
    "type",
    "params",
    "query",
    "prefetch",
    "state"
];
const $dba17dfd00ae7d8f$var$PREFETCH_DELAY = 225;
const $dba17dfd00ae7d8f$var$Link = /*#__PURE__*/ (0, $5FkrB.forwardRef)((_ref, ref)=>{
    let { children: children, target: target = '_self', replace: replace = false, href: href, to: to, onClick: onClick, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onPointerDown: onPointerDown, onFocus: onFocus, onBlur: onBlur, type: linkType = 'a', params: params, query: query, prefetch: prefetch = false, state: state } = _ref, rest = (0, (/*@__PURE__*/$parcel$interopDefault($19a0g)))(_ref, $dba17dfd00ae7d8f$var$_excluded);
    const routerActions = (0, $1ddaa6502d719738$export$ada49399abf7a3a1)();
    const { schedule: schedule, cancel: cancel } = (0, $816a5189e752f4e6$export$d8e6abf214c9ec0f)($dba17dfd00ae7d8f$var$PREFETCH_DELAY);
    const validLinkType = (0, $39281ff350272ced$export$855ece989b15eb57)(linkType);
    const [route, setRoute] = (0, $5FkrB.useState)(()=>{
        if (to && typeof to !== 'string') {
            if ('then' in to) to.then((r)=>setRoute('default' in r ? r.default : r));
            else return to;
        }
    });
    const routeAttributes = {
        params: params,
        query: query,
        basePath: routerActions.getBasePath()
    };
    const linkDestination = href != null ? href : typeof to !== 'string' ? route && (0, $c29d101a2cf08ade$export$fe53371bee54353d)((0, $768d36b334678dfa$export$37e0729cc751960b)(route.path, routeAttributes)) || '' : to;
    const IS_ABSOLUTE_LINK_REGEX = /^((?:(http|https):\/\/)|\/\/)/;
    const staticBasePath = href != null && !IS_ABSOLUTE_LINK_REGEX.test(href) || typeof to === 'string' ? routeAttributes.basePath : '';
    const triggerPrefetch = (0, $5FkrB.useCallback)(()=>{
        // ignore if async route not ready yet
        if (typeof to !== 'string' && !route) return;
        const context = typeof to !== 'string' && route ? (0, $10a8bc47d57825ec$export$faed15f35ddc6f99)(route, {
            params: params,
            query: query
        }) : null;
        routerActions.prefetchRoute(linkDestination, context);
    // omit params & query as already in linkDestination
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        route,
        linkDestination,
        routerActions
    ]);
    (0, $5FkrB.useEffect)(()=>{
        if (prefetch === 'mount') schedule(triggerPrefetch);
        return cancel;
    }, [
        prefetch,
        schedule,
        cancel,
        triggerPrefetch
    ]);
    const handleLinkPress = (e)=>(0, $05c5e447ce24817b$export$706ad1af8096e280)(e, {
            onClick: onClick,
            target: target,
            replace: replace,
            routerActions: routerActions,
            href: linkDestination,
            to: route && [
                route,
                {
                    params: params,
                    query: query
                }
            ],
            state: state
        });
    const handleMouseEnter = (e)=>{
        if (prefetch === 'hover') schedule(triggerPrefetch);
        onMouseEnter && onMouseEnter(e);
    };
    const handleMouseLeave = (e)=>{
        if (prefetch === 'hover') cancel();
        onMouseLeave && onMouseLeave(e);
    };
    const handleFocus = (e)=>{
        if (prefetch === 'hover') schedule(triggerPrefetch);
        onFocus && onFocus(e);
    };
    const handleBlur = (e)=>{
        if (prefetch === 'hover') cancel();
        onBlur && onBlur(e);
    };
    const handlePointerDown = (e)=>{
        if (prefetch === 'hover') {
            cancel();
            triggerPrefetch();
        }
        onPointerDown && onPointerDown(e);
    };
    return /*#__PURE__*/ (0, $5FkrB.createElement)(validLinkType, (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, rest, {
        href: `${staticBasePath}${linkDestination}`,
        target: target,
        onClick: handleLinkPress,
        onKeyDown: handleLinkPress,
        onMouseEnter: handleMouseEnter,
        onMouseLeave: handleMouseLeave,
        onFocus: handleFocus,
        onBlur: handleBlur,
        onPointerDown: handlePointerDown,
        ref: ref
    }), children);
});
$dba17dfd00ae7d8f$var$Link.displayName = 'Link';
var $dba17dfd00ae7d8f$export$2e2bcd8739ae039 = $dba17dfd00ae7d8f$var$Link;



var $5FkrB = parcelRequire("5FkrB");

const $56c1ff970910c658$export$7903e4b73fc7d6c3 = ()=>{
    const [{ action: action, location: location, match: match, query: query, route: route }] = (0, $b421c015f5018cd0$export$9a302a45f65d0572)();
    if (!route || !route.component) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(route.component, {
        action: action,
        location: location,
        match: match,
        query: query,
        route: route
    });
};






const $5b11c5222dd8637d$export$c36ce69a82764756 = (plugins, { routes: routes, history: history, basePath: basePath })=>{
    const context = (0, $10a8bc47d57825ec$export$a0bd0313cbeabd49)(routes, {
        location: history.location,
        basePath: basePath
    });
    plugins.forEach((p)=>{
        p.routeLoad == null || p.routeLoad({
            context: context
        });
    });
};





var $kqp0i = parcelRequire("kqp0i");

var $19a0g = parcelRequire("19a0g");

var $gNUZr = parcelRequire("gNUZr");
var $dWq0h = parcelRequire("dWq0h");
var $1uA8D = parcelRequire("1uA8D");
var $gNUZr = parcelRequire("gNUZr");
const $56dfe361b58eb7b7$var$_excluded = [
    "children"
];
function $56dfe361b58eb7b7$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $56dfe361b58eb7b7$var$hasAdditionalProps(props) {
    for(let i in props)return true;
    return false;
}
function $56dfe361b58eb7b7$export$48f338a7e080595c(Store, _temp) {
    let { selector: selector, displayName: displayName = '' } = _temp === void 0 ? {} : _temp;
    const useStore = (0, $gNUZr.createHook)(Store, {
        selector: selector
    });
    const Subscriber = function Subscriber(_ref) {
        let { children: children } = _ref, rest = $56dfe361b58eb7b7$var$_objectWithoutPropertiesLoose(_ref, $56dfe361b58eb7b7$var$_excluded);
        const api = useStore($56dfe361b58eb7b7$var$hasAdditionalProps(rest) ? rest : undefined);
        return children(...api);
    };
    Subscriber.displayName = displayName || `Subscriber(${Store.key.split('__')[0]})`;
    return Subscriber;
}


var $8i0MQ = parcelRequire("8i0MQ");


var $kqp0i = parcelRequire("kqp0i");
const $5d57ecbfe3b77e12$export$9ccb639b7a119f61 = ()=>Date.now();



var $kqp0i = parcelRequire("kqp0i");
const $bcec6d01a9b8b822$export$881d135f98d8d7d0 = 100;
const $bcec6d01a9b8b822$export$9ab5bdcb8a1d6c34 = false;
const $bcec6d01a9b8b822$export$12c1dc38ea1692da = 0;



var $kqp0i = parcelRequire("kqp0i");
const $77fa9025423fc23c$export$b65d7ba7fbf150f1 = (maxAge)=>Date.now() + maxAge;
const $77fa9025423fc23c$export$18d1d420fd588368 = (slice, maxAge)=>slice.expiresAt === null ? (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, slice, {
        expiresAt: $77fa9025423fc23c$export$b65d7ba7fbf150f1(maxAge)
    }) : slice;


const $108ac836d0c63e52$export$58634b3a58ae66b7 = (duration)=>{
    const promiseState = {
        timerId: null,
        isPending: true,
        promise: undefined
    };
    promiseState.promise = new Promise((r)=>{
        const timerId = setTimeout(()=>{
            promiseState.isPending = false;
            r();
        }, duration);
        promiseState.timerId = timerId;
    });
    return promiseState;
};


class $7f0f2ac24b55a8af$export$66d311bf29d5c89c extends Error {
    constructor(message){
        super('Resource timed out: ' + message);
        this.name = 'TimeoutError';
    }
}


const $ac913cdf516a6c19$export$37d3126be6549b13 = 10000;


function $9f82c6853cb9305f$export$dc62515c8f0b52dd({ context: context, dependencies: dependencies, options: options, resource: resource, routerStoreContext: routerStoreContext }) {
    var _promiseOrData, _resource$maxAge;
    const { type: type, getData: getData } = resource;
    const { prefetch: prefetch, timeout: timeout } = options;
    // hard errors in dependencies or getData are converted into softer async error
    let promiseOrData;
    try {
        promiseOrData = getData((0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, routerStoreContext, {
            isPrefetch: !!prefetch,
            dependencies: dependencies()
        }), context);
    } catch (error) {
        promiseOrData = Promise.reject(error);
    }
    // ensure the promise includes any timeout error
    const timeoutGuard = timeout ? (0, $108ac836d0c63e52$export$58634b3a58ae66b7)(timeout) : null;
    // check if getData was sync, by looking for a Promise-like shape
    const data = typeof ((_promiseOrData = promiseOrData) == null ? void 0 : _promiseOrData.then) === 'function' ? undefined : promiseOrData;
    const promise = timeout ? Promise.race([
        promiseOrData,
        timeoutGuard == null ? void 0 : timeoutGuard.promise
    ]).then((maybeData)=>{
        if (timeoutGuard && !timeoutGuard.isPending) throw new (0, $7f0f2ac24b55a8af$export$66d311bf29d5c89c)(type);
        (timeoutGuard == null ? void 0 : timeoutGuard.timerId) && clearTimeout(timeoutGuard.timerId);
        return maybeData;
    }) : // if we already have a result, wrap it so consumers can access it via same API
    data !== undefined ? Promise.resolve(data) : promiseOrData;
    const resourceMaxAge = (0, $77fa9025423fc23c$export$b65d7ba7fbf150f1)((_resource$maxAge = resource.maxAge) != null ? _resource$maxAge : (0, $bcec6d01a9b8b822$export$12c1dc38ea1692da));
    return {
        promise: promise,
        data: data,
        expiresAt: prefetch ? Math.max(resourceMaxAge, (0, $77fa9025423fc23c$export$b65d7ba7fbf150f1)((0, $ac913cdf516a6c19$export$37d3126be6549b13))) : resourceMaxAge
    };
}



/**
 * Utility method to created async versions of getData functions
 */ const $7b970af4b8ce2c1d$var$handleGetDataLoader = (asyncImport)=>async (...args)=>{
        const { default: getDataFn } = await asyncImport();
        return getDataFn(...args);
    };
const $7b970af4b8ce2c1d$export$edd172c6c83c39cc = (arg)=>{
    var _getData, _arg$depends;
    return {
        type: arg.type,
        getKey: arg.getKey,
        getData: (_getData = arg.getData) != null ? _getData : $7b970af4b8ce2c1d$var$handleGetDataLoader(arg.getDataLoader),
        maxAge: typeof arg.maxAge === 'number' ? arg.maxAge : (0, $bcec6d01a9b8b822$export$12c1dc38ea1692da),
        maxCache: typeof arg.maxCache === 'number' ? arg.maxCache : (0, $bcec6d01a9b8b822$export$881d135f98d8d7d0),
        isBrowserOnly: typeof arg.isBrowserOnly === 'boolean' ? arg.isBrowserOnly : (0, $bcec6d01a9b8b822$export$9ab5bdcb8a1d6c34),
        depends: (_arg$depends = arg.depends) != null ? _arg$depends : null
    };
};



var $kqp0i = parcelRequire("kqp0i");

var $kqp0i = parcelRequire("kqp0i");



/**
 * The base defaults which should be fed into any factory that needs to derive other props.
 */ const $2fd0617e74ae762e$export$2df85a734ff5ed27 = {
    data: null,
    error: null,
    loading: false,
    promise: null
};


const $11ddcb99c77f2a5f$export$fa8e33c3301e2e94 = ()=>(0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, (0, $2fd0617e74ae762e$export$2df85a734ff5ed27), {
        expiresAt: (0, $77fa9025423fc23c$export$b65d7ba7fbf150f1)((0, $bcec6d01a9b8b822$export$12c1dc38ea1692da)),
        accessedAt: (0, $5d57ecbfe3b77e12$export$9ccb639b7a119f61)()
    });



var $19a0g = parcelRequire("19a0g");

var $kqp0i = parcelRequire("kqp0i");
function $c2289db837328500$var$_toPropertyKey(t) {
    var i = $c2289db837328500$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : String(i);
}
function $c2289db837328500$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
const $c2289db837328500$export$11374758be89e40 = (type, key)=>({ getState: getState })=>{
        var _prefetching$type;
        const { prefetching: prefetching } = getState();
        const slice = prefetching == null || (_prefetching$type = prefetching[type]) == null ? void 0 : _prefetching$type[key];
        // check if slice is still fresh
        if (slice && Date.now() < Number(slice.expiresAt)) return slice;
        return undefined;
    };
const $c2289db837328500$export$1e32615dc8354436 = (type, key, slice)=>({ setState: setState, getState: getState })=>{
        var _prefetching$type2, _slice$promise;
        const { prefetching: prefetching } = getState();
        // avoid doing extra set if same value
        if ((prefetching == null || (_prefetching$type2 = prefetching[type]) == null ? void 0 : _prefetching$type2[key]) === slice) return;
        // cheap optimisation to provide prefetched result syncronously
        slice == null || (_slice$promise = slice.promise) == null || _slice$promise.then((maybeData)=>slice.data = maybeData);
        setState({
            prefetching: (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, prefetching, {
                [type]: (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, prefetching == null ? void 0 : prefetching[type], {
                    [key]: slice
                })
            })
        });
    };
const $c2289db837328500$export$704f800f263b050e = (type, key, state)=>({ setState: setState, getState: getState, dispatch: dispatch })=>{
        const { data: data } = getState();
        // every time we override a resource we kill its prefetched
        dispatch($c2289db837328500$export$1e32615dc8354436(type, key, undefined));
        setState({
            data: (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, data, {
                [type]: (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, data[type] || {}, {
                    [key]: state
                })
            })
        });
    };
const $c2289db837328500$export$5fc90c33b03fffb = (type, key)=>({ getState: getState })=>{
        const { data: { [type]: resourceDataForType } } = getState();
        return resourceDataForType == null ? void 0 : resourceDataForType[key];
    };
const $c2289db837328500$export$d40f35dc5952864b = (type, key)=>({ getState: getState, setState: setState })=>{
        const { data: data } = getState();
        const { [type]: resourceForType } = data, remainingData = (0, (/*@__PURE__*/$parcel$interopDefault($19a0g)))(data, [
            type
        ].map($c2289db837328500$var$_toPropertyKey));
        if (key === undefined) setState({
            data: remainingData
        });
        else if (resourceForType) {
            const remainingForType = (0, (/*@__PURE__*/$parcel$interopDefault($19a0g)))(resourceForType, [
                key
            ].map($c2289db837328500$var$_toPropertyKey));
            setState({
                data: (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, remainingData, {
                    [type]: remainingForType
                })
            });
        }
    };


var $1114b4ff1105d34f$var$_Object$fromEntries;
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/fromEntries
const $1114b4ff1105d34f$var$fromEntries = ($1114b4ff1105d34f$var$_Object$fromEntries = Object.fromEntries) != null ? $1114b4ff1105d34f$var$_Object$fromEntries : (entries)=>Object.assign({}, ...entries.map(([k, v])=>({
            [k]: v
        })));
const $1114b4ff1105d34f$var$matchType = (a)=>(b)=>{
        const [{ type: typeA }] = Array.isArray(a) ? a : [
            a
        ];
        const [{ type: typeB }] = Array.isArray(b) ? b : [
            b
        ];
        return typeA === typeB;
    };
class $1114b4ff1105d34f$export$492ad57edfe1e919 extends Error {
    constructor(message){
        super(message);
        this.name = 'ResourceDependencyError';
    }
}
const $1114b4ff1105d34f$export$12600f2e0e7fb2cc = (routeResources, tuples)=>({ getState: getState, setState: setState, dispatch: dispatch })=>{
        var _routeResources$some;
        if (getState().executing) throw new Error('execution is already in progress');
        // check if there are resources and if so if there are any resources with dependencies
        const hasDependentResources = (_routeResources$some = routeResources == null ? void 0 : routeResources.some(({ depends: depends })=>depends == null ? void 0 : depends.length)) != null ? _routeResources$some : false;
        if (!hasDependentResources) return tuples.map(([, action])=>dispatch(action));
        // some resources might not be listed on the route resources so must be dispatched separate from executing state
        const listedTuples = tuples.filter(([resource])=>routeResources == null ? void 0 : routeResources.some($1114b4ff1105d34f$var$matchType(resource)));
        if (listedTuples.length === 0) return tuples.map(([, action])=>dispatch(action));
        // accumulate the dependency types for all executing resources
        // find downstream resources that may also execute and include their dependencies too
        // include the resource type as well in the list
        // we don't validate that these are legal dependencies
        const [dependentTypes] = routeResources.reduce((acc, { type: type, depends: depends })=>{
            const [dependencies, executableTypes] = acc;
            const isExecutable = executableTypes.includes(type) || !!(depends != null && depends.some((dependency)=>executableTypes.includes(dependency)));
            return isExecutable ? [
                depends ? [
                    ...dependencies,
                    ...depends,
                    type
                ] : dependencies,
                [
                    ...executableTypes,
                    type
                ]
            ] : acc;
        }, [
            [],
            listedTuples.map(([{ type: type }])=>type)
        ]).filter((v, i, a)=>a.indexOf(v) === i);
        // resources that are completely independent are preferable to be dispatched separate from executing state
        const dependentTuples = listedTuples.filter(([{ type: type }])=>dependentTypes.includes(type));
        if (dependentTuples.length === 0) return tuples.map(([, action])=>dispatch(action));
        // additionally find all direct dependencies of these executing or possibly executing resources
        // we don't validate that these are legal dependencies
        const dependentAndDependencyTypes = routeResources.filter(({ type: type })=>dependentTypes.includes(type)).reduce((acc, { type: type, depends: depends })=>depends ? [
                ...acc,
                ...depends,
                type
            ] : [
                ...acc,
                type
            ], []).filter((v, i, a)=>a.indexOf(v) === i);
        // setup executing tuples in route resource order
        // this state allows actions to call executeForDependents() to influence actions that follow
        // the list includes dependency resources so that getDependencies() may validate without needing route resources
        // we use the resource definition of the given tuple where present or otherwise the definition from route resources
        const executingTuples = routeResources.filter(({ type: type })=>dependentAndDependencyTypes.includes(type)).map((resource)=>{
            var _tuples$find;
            return (_tuples$find = tuples.find($1114b4ff1105d34f$var$matchType(resource))) != null ? _tuples$find : [
                resource,
                null
            ];
        });
        setState({
            executing: executingTuples
        });
        // dispatch sequentially during which executeForDependents() can cause tuples to change
        const executedResults = executingTuples.map(([{ type: expectedType }], i)=>{
            var _getState$executing;
            const latestTuple = (_getState$executing = getState().executing) == null ? void 0 : _getState$executing[i];
            const [{ type: latestType }, maybeAction] = latestTuple != null ? latestTuple : [
                {}
            ];
            if (latestType !== expectedType) {
                setState({
                    executing: null
                });
                throw new Error('execution reached an inconsistent state');
            }
            return maybeAction ? dispatch(maybeAction) : undefined;
        });
        setState({
            executing: null
        });
        // pick existing execution result or dispatch any remaining independent actions
        return tuples.map(([resource, action])=>{
            const index = executingTuples.findIndex($1114b4ff1105d34f$var$matchType(resource));
            return index < 0 ? dispatch(action) : executedResults[index];
        });
    };
const $1114b4ff1105d34f$export$5f7e1fd85734e71e = (routeResources, resource, action)=>({ dispatch: dispatch })=>dispatch($1114b4ff1105d34f$export$12600f2e0e7fb2cc(routeResources, [
            [
                resource,
                action
            ]
        ]))[0];
const $1114b4ff1105d34f$export$f71a65c89c987a02 = (routeResources, resources, actionCreator)=>$1114b4ff1105d34f$export$12600f2e0e7fb2cc(routeResources, resources.map((resource)=>[
            resource,
            actionCreator(resource)
        ]));
const $1114b4ff1105d34f$export$7d1ffac63c68405d = (resource, actionCreator)=>({ getState: getState, setState: setState })=>{
        var _tuples$findIndex;
        const { executing: tuples } = getState();
        // find the given resource in the currently executing tuples
        const indexForResource = (_tuples$findIndex = tuples == null ? void 0 : tuples.findIndex($1114b4ff1105d34f$var$matchType(resource))) != null ? _tuples$findIndex : -1;
        if (indexForResource < 0) return;
        // find dependent resources following given resource and revise their action
        const executing = tuples.map((tuple, i)=>{
            var _tupleResource$depend;
            const [tupleResource] = tuple;
            return i > indexForResource && (_tupleResource$depend = tupleResource.depends) != null && _tupleResource$depend.includes(resource.type) ? [
                tupleResource,
                actionCreator(tupleResource)
            ] : tuple;
        });
        setState({
            executing: executing
        });
    };
const $1114b4ff1105d34f$export$75915f81f2a6540a = (resource, routerStoreContext, options)=>({ getState: getState, dispatch: dispatch })=>{
        var _tuples$findIndex2;
        const { type: type, depends: depends } = resource;
        // optimise the case of no dependencies
        if (!(depends != null && depends.length)) return {};
        const { executing: tuples, context: resourceStoreContext } = getState();
        // dependent resource cannot be called outside execution state
        // find the given resource type in the currently executing tuples
        const indexForResource = (_tuples$findIndex2 = tuples == null ? void 0 : tuples.findIndex($1114b4ff1105d34f$var$matchType(resource))) != null ? _tuples$findIndex2 : -1;
        if (indexForResource < 0) throw new $1114b4ff1105d34f$export$492ad57edfe1e919(`Missing resource: "${type}" has dependencies so must not be missing`);
        // find tuples index for all the dependency elements
        const dependencyIndexTuples = depends.map((dependency)=>[
                dependency,
                tuples.findIndex($1114b4ff1105d34f$var$matchType({
                    type: dependency
                }))
            ]);
        // we rely on executing tuples including all dependencies of the caller resource
        dependencyIndexTuples.forEach(([dependency, index])=>{
            if (index < 0) throw new $1114b4ff1105d34f$export$492ad57edfe1e919(`Missing resource: "${type}" depends "${dependency}" which is missing`);
            if (index > indexForResource) throw new $1114b4ff1105d34f$export$492ad57edfe1e919(`Illegal dependency: "${type}" depends "${dependency}" so "${dependency}" must precede "${type}"`);
        });
        return $1114b4ff1105d34f$var$fromEntries(dependencyIndexTuples.map(([dependencyType, index])=>{
            const { getKey: getKey } = tuples[index][0];
            const key = getKey(routerStoreContext, resourceStoreContext);
            let slice = dispatch((0, $c2289db837328500$export$5fc90c33b03fffb)(dependencyType, key)) || (0, $11ddcb99c77f2a5f$export$fa8e33c3301e2e94)();
            // when prefetching we provide only the promise to dependands
            const prefetchSlice = options.prefetch ? dispatch((0, $c2289db837328500$export$11374758be89e40)(dependencyType, key)) : undefined;
            if (prefetchSlice) slice = (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, slice, {
                // not spreading prefetchSlice to persist previous slice data
                promise: prefetchSlice.promise,
                expiresAt: prefetchSlice.expiresAt,
                loading: true
            });
            return [
                dependencyType,
                slice
            ];
        }));
    };





const $8f855b3c85bfcd50$export$c616b176adf9ad4a = (resource, routerStoreContext, resourceStoreContext)=>{
    const { type: type, getKey: getKey } = resource;
    const key = getKey(routerStoreContext, resourceStoreContext);
    return `${type}/${key}`;
};
const $8f855b3c85bfcd50$export$cd7fbe7e979df558 = (resources, routerStoreContext, resourceStoreContext)=>resources.map((resource)=>$8f855b3c85bfcd50$export$c616b176adf9ad4a(resource, routerStoreContext, resourceStoreContext));



const $7ae785bb12efd361$export$740886389191c640 = (route)=>!!(route && route.resources && route.resources.length > 0);
const $7ae785bb12efd361$export$221027ff1aa38f82 = (prev, next)=>prev.name !== next.name || prev.path !== next.path;


const $22771f91a0427f12$export$7cbbc763e2f3d65d = (prevRouterStoreContext, nextRouterStoreContext, resourceStoreContext)=>{
    const { route: prevRoute } = prevRouterStoreContext;
    const { resources: prevResources = [] } = prevRoute || {};
    const { route: nextRoute } = nextRouterStoreContext;
    const { resources: nextResources = [] } = nextRoute || {};
    if (!(0, $7ae785bb12efd361$export$740886389191c640)(nextRoute)) return [];
    if ((0, $7ae785bb12efd361$export$221027ff1aa38f82)(prevRoute, nextRoute)) return nextResources;
    const prevResourceIdentifiers = (0, $8f855b3c85bfcd50$export$cd7fbe7e979df558)(prevResources, prevRouterStoreContext, resourceStoreContext);
    return nextResources.filter((resource)=>!prevResourceIdentifiers.includes((0, $8f855b3c85bfcd50$export$c616b176adf9ad4a)(resource, nextRouterStoreContext, resourceStoreContext)));
};



const $e5451870b07c58fa$export$65824bf86829963 = (routeResourceDataForType, currentKey)=>Object.keys(routeResourceDataForType).filter((resourceDataKey)=>{
        const { [resourceDataKey]: { expiresAt: expiresAt } } = routeResourceDataForType;
        return resourceDataKey !== currentKey && expiresAt && expiresAt <= Date.now();
    });
const $e5451870b07c58fa$export$6288d3096045088f = (maxCache, resourceDataForType, currentKey)=>{
    if (maxCache === Infinity || maxCache < 1) return null;
    const resourceDataKeys = Object.keys(resourceDataForType);
    if (resourceDataKeys.length < maxCache) return null;
    const expiredResourceDataKeys = $e5451870b07c58fa$export$65824bf86829963(resourceDataForType, currentKey);
    if (expiredResourceDataKeys.length > 0) return expiredResourceDataKeys[0];
    return resourceDataKeys.reduce((leastRecentKey, key)=>{
        const { [key]: { accessedAt: accessedAt }, [leastRecentKey]: { accessedAt: leastRecentAccessedAt } } = resourceDataForType;
        if (accessedAt && leastRecentAccessedAt && accessedAt < leastRecentAccessedAt) return key;
        return leastRecentKey;
    }, resourceDataKeys[0]);
};
const $e5451870b07c58fa$export$89440b7623c2c75c = (resource, key)=>({ getState: getState, dispatch: dispatch })=>{
        const { type: type, maxCache: maxCache } = resource;
        const { data: { [type]: resourceDataForType } } = getState();
        if (!resourceDataForType) return;
        const keyTobeDeleted = $e5451870b07c58fa$export$6288d3096045088f(maxCache, resourceDataForType, key);
        if (!keyTobeDeleted) return;
        dispatch((0, $c2289db837328500$export$d40f35dc5952864b)(type, keyTobeDeleted));
    };




// NOTE! This has been copy pasted from https://github.com/sindresorhus/serialize-error/blob/master/index.js
// When the router moves to its own package, this must become a dependency
// For now, we have put it here so that we don't need to get it included in Jira's vendor bundle
class $a501e17e10f67e01$var$NonError extends Error {
    constructor(message){
        super(message);
        this.name = 'NonError';
        if (Error.captureStackTrace) Error.captureStackTrace(this, $a501e17e10f67e01$var$NonError);
    }
}
const $a501e17e10f67e01$var$commonProperties = [
    'name',
    'message',
    'stack',
    'code'
];
const $a501e17e10f67e01$var$destroyCircular = (from, seen, to_)=>{
    const to = to_ || (Array.isArray(from) ? [] : {});
    seen.push(from);
    for (const [key, value] of Object.entries(from)){
        if (typeof value === 'function') continue;
        if (!value || typeof value !== 'object') {
            to[key] = value;
            continue;
        }
        if (!seen.includes(from[key])) {
            to[key] = $a501e17e10f67e01$var$destroyCircular(from[key], seen.slice());
            continue;
        }
        to[key] = '[Circular]';
    }
    for (const property of $a501e17e10f67e01$var$commonProperties)if (typeof from[property] === 'string') to[property] = from[property];
    return to;
};
const $a501e17e10f67e01$export$46ff38bc6bdea8fb = (value)=>{
    if (typeof value === 'object' && value !== null) return $a501e17e10f67e01$var$destroyCircular(value, []);
    // People sometimes throw things besides Error objects…
    if (typeof value === 'function') // `JSON.stringify()` discards functions. We do too, unless a function is thrown directly.
    return `[Function: ${value.name || 'anonymous'}]`;
    return value;
};
const $a501e17e10f67e01$export$64cddc1e268e9046 = (value)=>{
    if (value instanceof Error) return value;
    if (typeof value === 'object' && value !== null && !Array.isArray(value)) {
        const newError = new Error();
        $a501e17e10f67e01$var$destroyCircular(value, [], newError);
        return newError;
    }
    return new $a501e17e10f67e01$var$NonError(value);
};


const $2f8d085a7807db31$export$b25d2963b8a3488a = ({ expiresAt: expiresAt })=>expiresAt === null;
const $2f8d085a7807db31$var$isFresh = (resource)=>{
    if ($2f8d085a7807db31$export$b25d2963b8a3488a(resource)) return true;
    return Date.now() < Number(resource.expiresAt);
};
const $2f8d085a7807db31$export$399de8c43d0ece3c = (resource)=>{
    var _resource$error;
    if ((resource == null || (_resource$error = resource.error) == null ? void 0 : _resource$error.name) === 'TimeoutError') return false;
    if (resource.loading) return true;
    if ($2f8d085a7807db31$var$isFresh(resource)) return true;
    return false;
};



var $kqp0i = parcelRequire("kqp0i");
const $4798122614ec3b45$export$2e4da1b414980956 = (slice)=>slice.promise === null ? (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, slice, {
        promise: Promise.resolve(slice.data)
    }) : slice;



const $9de411b0b18cf8f2$export$3ceb62baab058c6b = (data, transformer)=>Object.keys(data).reduce((acc, type)=>{
        if (!acc[type]) acc[type] = {};
        Object.keys(data[type]).forEach((key)=>{
            const slice = data[type][key];
            acc[type][key] = transformer(slice);
        });
        return acc;
    }, {});




const $c80879d114529b7c$export$c9ed509724feb827 = (state, props)=>{
    const { type: type, key: key } = props;
    const slice = state.data[type] && state.data[type][key];
    return slice ? (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, slice) : (0, $11ddcb99c77f2a5f$export$fa8e33c3301e2e94)();
};
const $c80879d114529b7c$export$6a0b1779210de0ee = (state)=>state.context;



const $325bbf8ea5f9a12e$var$_excluded = [
    "context"
], $325bbf8ea5f9a12e$var$_excluded2 = [
    "error",
    "expiresAt",
    "loading"
];
const $325bbf8ea5f9a12e$export$3f1be494d407b77a = {
    /**
   * Clears a resource for the current key, or where context is not provided all keys.
   */ clearResource: (resource, routerStoreContext)=>({ getState: getState, dispatch: dispatch })=>{
            const { type: type, getKey: getKey } = resource;
            const { context: context } = getState();
            if (routerStoreContext) {
                const key = getKey(routerStoreContext, context);
                dispatch((0, $c2289db837328500$export$d40f35dc5952864b)(type, key));
                dispatch((0, $1114b4ff1105d34f$export$7d1ffac63c68405d)(resource, (dependentResource)=>$325bbf8ea5f9a12e$export$3f1be494d407b77a.clearResource(dependentResource, routerStoreContext)));
            } else dispatch((0, $c2289db837328500$export$d40f35dc5952864b)(type));
        },
    /**
   * Update the data property for a resource in the cache and reset expiresAt based
   * on maxAge.
   */ updateResourceState: (resource, routerStoreContext, getNewSliceData)=>({ getState: getState, dispatch: dispatch })=>{
            const { type: type, getKey: getKey, maxAge: maxAge } = resource;
            const _getState = getState(), { context: context } = _getState, resourceStoreState = (0, (/*@__PURE__*/$parcel$interopDefault($19a0g)))(_getState, $325bbf8ea5f9a12e$var$_excluded);
            const key = getKey(routerStoreContext, context);
            const prevSlice = (0, $c80879d114529b7c$export$c9ed509724feb827)(resourceStoreState, {
                type: type,
                key: key
            });
            const data = getNewSliceData(prevSlice.data);
            const changes = prevSlice.loading ? {
                data: data,
                error: null,
                loading: true
            } : {
                data: data,
                error: null,
                loading: false,
                promise: Promise.resolve(data)
            };
            const newSlice = (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, prevSlice, changes, {
                expiresAt: (0, $77fa9025423fc23c$export$b65d7ba7fbf150f1)(maxAge),
                accessedAt: (0, $5d57ecbfe3b77e12$export$9ccb639b7a119f61)()
            });
            dispatch((0, $c2289db837328500$export$704f800f263b050e)(type, key, newSlice));
            // trigger dependent resources on change
            if (newSlice.data !== prevSlice.data) dispatch((0, $1114b4ff1105d34f$export$7d1ffac63c68405d)(resource, (dependentResource)=>$325bbf8ea5f9a12e$export$3f1be494d407b77a.getResourceFromRemote(dependentResource, routerStoreContext, {})));
        },
    /**
   * Get a single resource, either from the cache if it exists and has not expired, or
   * the remote if it has expired.
   */ getResource: (resource, routerStoreContext, options)=>async ({ getState: getState, dispatch: dispatch })=>{
            const { type: type, getKey: getKey, maxAge: maxAge } = resource;
            const { context: context } = getState();
            const key = getKey(routerStoreContext, context);
            let cached = dispatch((0, $c2289db837328500$export$5fc90c33b03fffb)(type, key));
            if (cached && (0, $2f8d085a7807db31$export$399de8c43d0ece3c)(cached)) {
                if ((0, $2f8d085a7807db31$export$b25d2963b8a3488a)(cached)) {
                    const withResolvedPromise = (0, $4798122614ec3b45$export$2e4da1b414980956)(cached);
                    cached = (0, $77fa9025423fc23c$export$18d1d420fd588368)(withResolvedPromise, maxAge);
                }
                cached.accessedAt = (0, $5d57ecbfe3b77e12$export$9ccb639b7a119f61)();
                dispatch((0, $c2289db837328500$export$704f800f263b050e)(type, key, cached));
                return cached;
            }
            return dispatch($325bbf8ea5f9a12e$export$3f1be494d407b77a.getResourceFromRemote(resource, routerStoreContext, options));
        },
    /**
   * Request a single resource and update the resource cache.
   */ getResourceFromRemote: (resource, routerStoreContext, options)=>async ({ getState: getState, dispatch: dispatch })=>{
            const { type: type, getKey: getKey, maxAge: maxAge } = resource;
            const { context: context } = getState();
            const key = getKey(routerStoreContext, context);
            const prevSlice = dispatch((0, $c2289db837328500$export$5fc90c33b03fffb)(type, key)) || (0, $11ddcb99c77f2a5f$export$fa8e33c3301e2e94)();
            // abort request if already in flight
            if (prevSlice.loading) return prevSlice;
            dispatch((0, $e5451870b07c58fa$export$89440b7623c2c75c)(resource, key));
            const loadingSlice = dispatch((0, $c2289db837328500$export$11374758be89e40)(type, key)) || (0, $9f82c6853cb9305f$export$dc62515c8f0b52dd)({
                context: context,
                dependencies: ()=>dispatch((0, $1114b4ff1105d34f$export$75915f81f2a6540a)(resource, routerStoreContext, options)),
                options: options,
                resource: resource,
                routerStoreContext: routerStoreContext
            });
            let resolvedSlice;
            if (loadingSlice.data === prevSlice.data) // same data (by reference) means nothing has changed and we can avoid loading state
            resolvedSlice = {};
            else {
                // enter loading state
                dispatch((0, $c2289db837328500$export$704f800f263b050e)(type, key, (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, prevSlice, loadingSlice, {
                    data: maxAge === 0 ? null : prevSlice.data,
                    error: maxAge === 0 ? null : prevSlice.error,
                    loading: true,
                    accessedAt: (0, $5d57ecbfe3b77e12$export$9ccb639b7a119f61)()
                })));
                // trigger dependent resources to also load
                dispatch((0, $1114b4ff1105d34f$export$7d1ffac63c68405d)(resource, (dependentResource)=>$325bbf8ea5f9a12e$export$3f1be494d407b77a.getResourceFromRemote(dependentResource, routerStoreContext, options)));
                // in case another action occurred while loading promise may not be the one we started with
                // we need to re-assign promise consistent with error/data that we are assigning here
                try {
                    var _loadingSlice$data;
                    const data = (_loadingSlice$data = loadingSlice.data) != null ? _loadingSlice$data : await loadingSlice.promise;
                    resolvedSlice = {
                        data: data,
                        error: null,
                        // any existing error is cleared
                        loading: false,
                        promise: loadingSlice.promise
                    };
                } catch (error) {
                    if (error instanceof (0, $7f0f2ac24b55a8af$export$66d311bf29d5c89c)) resolvedSlice = {
                        error: // data: do not replace existing data
                        error,
                        loading: true,
                        // this condition cannot recover so must only be present in static/server router
                        promise: null // special case for timeout
                    };
                    else resolvedSlice = {
                        error: // data: do not replace existing data
                        // @ts-ignore
                        error,
                        loading: false,
                        promise: loadingSlice.promise
                    };
                }
            }
            // ensure most recent data when return occurs
            const recentSlice = dispatch((0, $c2289db837328500$export$5fc90c33b03fffb)(type, key));
            const finalSlice = (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, recentSlice || prevSlice, resolvedSlice, {
                accessedAt: (0, $5d57ecbfe3b77e12$export$9ccb639b7a119f61)(),
                expiresAt: (0, $77fa9025423fc23c$export$b65d7ba7fbf150f1)(maxAge)
            });
            // protect against race conditions: if resources get cleared while await happens, we discard the result
            if (recentSlice || loadingSlice.data !== undefined) dispatch((0, $c2289db837328500$export$704f800f263b050e)(type, key, finalSlice));
            return finalSlice;
        },
    /**
   * Prefetch a single resource and store in the prefetch cache.
   */ prefetchResourceFromRemote: (resource, routerStoreContext, options)=>async ({ getState: getState, dispatch: dispatch })=>{
            const { type: type, getKey: getKey } = resource;
            const { context: context } = getState();
            const key = getKey(routerStoreContext, context);
            const loadingSlice = dispatch((0, $c2289db837328500$export$11374758be89e40)(type, key)) || (0, $9f82c6853cb9305f$export$dc62515c8f0b52dd)({
                context: context,
                dependencies: ()=>dispatch((0, $1114b4ff1105d34f$export$75915f81f2a6540a)(resource, routerStoreContext, options)),
                options: options,
                resource: resource,
                routerStoreContext: routerStoreContext
            });
            // save deferred value to be used also by dependants
            dispatch((0, $c2289db837328500$export$1e32615dc8354436)(type, key, loadingSlice));
            // trigger dependent resources to also prefetch
            dispatch((0, $1114b4ff1105d34f$export$7d1ffac63c68405d)(resource, (dependentResource)=>$325bbf8ea5f9a12e$export$3f1be494d407b77a.prefetchResourceFromRemote(dependentResource, routerStoreContext, options)));
        }
};
const $325bbf8ea5f9a12e$export$e324594224ef24da = {
    /**
   * Clears a resource for the current key, or where context is not provided all keys.
   * Execute such that dependencies on current route will be cleared.
   */ clearResource: (resource, routerStoreContext)=>{
        var _routerStoreContext$r;
        return (0, $1114b4ff1105d34f$export$5f7e1fd85734e71e)(routerStoreContext == null || (_routerStoreContext$r = routerStoreContext.route) == null ? void 0 : _routerStoreContext$r.resources, resource, $325bbf8ea5f9a12e$export$3f1be494d407b77a.clearResource(resource, routerStoreContext != null ? routerStoreContext : null));
    },
    /**
   * Update the data property for a resource in the cache and reset expiresAt based
   * on maxAge.
   * Execute such that dependencies on current route will be updated.
   */ updateResourceState: (resource, routerStoreContext, getNewSliceData)=>(0, $1114b4ff1105d34f$export$5f7e1fd85734e71e)(routerStoreContext.route.resources, resource, $325bbf8ea5f9a12e$export$3f1be494d407b77a.updateResourceState(resource, routerStoreContext, getNewSliceData)),
    /**
   * Get a single resource, either from the cache if it exists and has not expired, or
   * the remote if it has expired.
   * Execute such that dependencies on current route will be updated.
   */ getResource: (resource, routerStoreContext, options)=>(0, $1114b4ff1105d34f$export$5f7e1fd85734e71e)(routerStoreContext.route.resources, resource, $325bbf8ea5f9a12e$export$3f1be494d407b77a.getResource(resource, routerStoreContext, options)),
    /**
   * Request a single resource and update the resource cache.
   * Execute such that dependencies on current route will be updated.
   */ getResourceFromRemote: (resource, routerStoreContext, options)=>(0, $1114b4ff1105d34f$export$5f7e1fd85734e71e)(routerStoreContext.route.resources, resource, $325bbf8ea5f9a12e$export$3f1be494d407b77a.getResourceFromRemote(resource, routerStoreContext, options)),
    /**
   * Request all resources.
   */ requestAllResources: (routerStoreContext, options = {})=>({ dispatch: dispatch })=>{
            const { route: routeDefault } = routerStoreContext || {};
            const route = routeDefault;
            if (!route || !route.resources) return Promise.all([]);
            return Promise.all(dispatch($325bbf8ea5f9a12e$export$e324594224ef24da.requestResources(route.resources, routerStoreContext, options)));
        },
    /**
   * Cleans expired resources and resets them back to their initial state.
   * We need to do this when transitioning into a route.
   */ cleanExpiredResources: (resources, routerStoreContext)=>({ getState: getState, dispatch: dispatch })=>{
            const { context: resourceContext } = getState();
            resources.forEach((resource)=>{
                const { type: type, getKey: getKey } = resource;
                const key = getKey(routerStoreContext, resourceContext);
                const slice = dispatch((0, $c2289db837328500$export$5fc90c33b03fffb)(type, key));
                if (slice && (!slice.expiresAt || slice.expiresAt < Date.now())) dispatch((0, $c2289db837328500$export$d40f35dc5952864b)(type, key));
            });
        },
    /**
   * Requests a specific set of resources.
   */ requestResources: (resources, routerStoreContext, options)=>{
        var _resources;
        const predicate = (0, $f9f42a63082f8b8d$export$455cc18296abe008)() ? ({ isBrowserOnly: isBrowserOnly })=>!isBrowserOnly : ()=>true;
        return (0, $1114b4ff1105d34f$export$f71a65c89c987a02)((_resources = routerStoreContext.route.resources) == null ? void 0 : _resources.filter(predicate), resources.filter(predicate), (resource)=>$325bbf8ea5f9a12e$export$3f1be494d407b77a.getResource(resource, routerStoreContext, options));
    },
    /**
   * Prefetch a specific set of resources.
   */ prefetchResources: (resources, routerStoreContext, options)=>(0, $1114b4ff1105d34f$export$f71a65c89c987a02)(routerStoreContext.route.resources, resources, (resource)=>$325bbf8ea5f9a12e$export$3f1be494d407b77a.prefetchResourceFromRemote(resource, routerStoreContext, (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, options, {
                prefetch: true
            }))),
    /**
   * Hydrates the store with state.
   * Will not override pre-hydrated state.
   */ hydrate: ({ resourceData: resourceData, resourceContext: resourceContext })=>({ getState: getState, setState: setState })=>{
            const { data: data, context: context } = getState();
            function getNextStateValue(prev, next) {
                if (!Object.keys(prev).length && next && Object.keys(next).length) return next;
                return prev;
            }
            const hydratedData = (0, $9de411b0b18cf8f2$export$3ceb62baab058c6b)(getNextStateValue(data, resourceData), (_ref)=>{
                let { error: error, expiresAt: expiresAt, loading: loading } = _ref, rest = (0, (/*@__PURE__*/$parcel$interopDefault($19a0g)))(_ref, $325bbf8ea5f9a12e$var$_excluded2);
                const deserializedError = !error ? null : (0, $a501e17e10f67e01$export$64cddc1e268e9046)(error);
                const isTimeoutError = (deserializedError == null ? void 0 : deserializedError.name) === 'TimeoutError';
                return (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, rest, {
                    expiresAt: isTimeoutError ? Date.now() - 1 : expiresAt,
                    loading: isTimeoutError ? false : loading,
                    error: deserializedError
                });
            });
            setState({
                data: hydratedData,
                context: getNextStateValue(context, resourceContext)
            });
        },
    /**
   * Gets the store's context
   */ getContext: ()=>({ getState: getState })=>getState().context,
    /**
   * Returns safe, portable and rehydratable data.
   */ getSafeData: ()=>({ getState: getState })=>(0, $9de411b0b18cf8f2$export$3ceb62baab058c6b)(getState().data, ({ data: data, key: key, error: error, loading: loading })=>({
                    data: data,
                    key: key,
                    promise: null,
                    expiresAt: null,
                    accessedAt: null,
                    error: !error ? null : (0, $a501e17e10f67e01$export$46ff38bc6bdea8fb)(error instanceof Error ? error : new Error(JSON.stringify(error))),
                    loading: error instanceof (0, $7f0f2ac24b55a8af$export$66d311bf29d5c89c) ? loading : false
                }))
};
const $325bbf8ea5f9a12e$export$94f50dade551bd01 = (0, $1uA8D.createStore)({
    initialState: {
        data: {},
        context: {},
        executing: null,
        prefetching: null
    },
    actions: $325bbf8ea5f9a12e$export$e324594224ef24da,
    name: 'router-resources'
});
const $325bbf8ea5f9a12e$export$cc90fb9c37c5589d = (0, $dWq0h.createContainer)($325bbf8ea5f9a12e$export$94f50dade551bd01, {
    displayName: 'ResourceContainer'
});
const $325bbf8ea5f9a12e$export$fee1a6213543bd78 = (0, $56dfe361b58eb7b7$export$48f338a7e080595c)($325bbf8ea5f9a12e$export$94f50dade551bd01, {
    displayName: 'ResourceSelectorSubscriber',
    selector: (state, props)=>(0, $c80879d114529b7c$export$c9ed509724feb827)(state, {
            type: props.resourceType,
            key: props.resourceKey
        })
});
const $325bbf8ea5f9a12e$export$6f6057d42352becb = ()=>// @ts-ignore not providing a scopeId param
    (0, $8i0MQ.defaultRegistry).getStore($325bbf8ea5f9a12e$export$94f50dade551bd01);
const $325bbf8ea5f9a12e$export$ac3608e0bb357c7 = (0, $gNUZr.createHook)($325bbf8ea5f9a12e$export$94f50dade551bd01, {
    selector: (0, $c80879d114529b7c$export$c9ed509724feb827)
});
const $325bbf8ea5f9a12e$export$98e41a62c9bef75e = (0, $gNUZr.createActionsHook)($325bbf8ea5f9a12e$export$94f50dade551bd01);
const $325bbf8ea5f9a12e$export$e59f52df235ac7b3 = (0, $gNUZr.createHook)($325bbf8ea5f9a12e$export$94f50dade551bd01, {
    selector: (0, $c80879d114529b7c$export$6a0b1779210de0ee)
});



const $f97bd143060a0c12$export$a9bc0bb87abc2c4c = 'resources-plugin';
const $f97bd143060a0c12$var$loadOnUrlChange = (context, prevContext)=>{
    const { requestResources: requestResources, getContext: getResourceStoreContext } = (0, $325bbf8ea5f9a12e$export$6f6057d42352becb)().actions;
    const nextResources = (0, $22771f91a0427f12$export$7cbbc763e2f3d65d)(prevContext, context, getResourceStoreContext());
    return Promise.all(requestResources(nextResources, context, {}));
};
const $f97bd143060a0c12$var$beforeLoad = ({ context: context, nextContext: nextContext })=>{
    const { cleanExpiredResources: cleanExpiredResources, getContext: getResourceStoreContext } = (0, $325bbf8ea5f9a12e$export$6f6057d42352becb)().actions;
    const nextResources = (0, $22771f91a0427f12$export$7cbbc763e2f3d65d)(context, nextContext, getResourceStoreContext());
    cleanExpiredResources(nextResources, nextContext);
};
const $f97bd143060a0c12$export$23ed892c481a96fe = ({ context: initialResourceContext, resourceData: initialResourceData, timeout: timeout })=>{
    let latestLoadedResources = Promise.resolve([]);
    (0, $325bbf8ea5f9a12e$export$6f6057d42352becb)().actions.hydrate({
        resourceContext: initialResourceContext,
        resourceData: initialResourceData
    });
    return {
        id: $f97bd143060a0c12$export$a9bc0bb87abc2c4c,
        beforeRouteLoad: $f97bd143060a0c12$var$beforeLoad,
        routeLoad: ({ context: context, prevContext: prevContext })=>{
            const { route: route, match: match, query: query } = context;
            // TODO: in next refactoring add `if (route.resources)` check
            // For now requesting resources for every route even if `resources` prop is missing on Route
            if (prevContext) latestLoadedResources = $f97bd143060a0c12$var$loadOnUrlChange(context, prevContext);
            else latestLoadedResources = (0, $325bbf8ea5f9a12e$export$6f6057d42352becb)().actions.requestAllResources({
                route: route,
                match: match,
                query: query
            }, {
                timeout: timeout
            });
        },
        routePrefetch: ({ context: context, nextContext: nextContext })=>{
            const { prefetchResources: prefetchResources, getContext: getResourceStoreContext } = (0, $325bbf8ea5f9a12e$export$6f6057d42352becb)().actions;
            const nextResources = (0, $22771f91a0427f12$export$7cbbc763e2f3d65d)(context, nextContext, getResourceStoreContext());
            return {
                resources: prefetchResources(nextResources, nextContext, {})
            };
        },
        getLatestResources: ()=>latestLoadedResources,
        getSerializedResources: async ()=>{
            await latestLoadedResources;
            return (0, $325bbf8ea5f9a12e$export$6f6057d42352becb)().actions.getSafeData();
        }
    };
};



var $5FkrB = parcelRequire("5FkrB");

var $kqp0i = parcelRequire("kqp0i");

var $5FkrB = parcelRequire("5FkrB");

var $gNUZr = parcelRequire("gNUZr");


const $5c5601e773daa875$export$9f6abfd74295843b = (resource, options)=>{
    const actions = (0, $325bbf8ea5f9a12e$export$98e41a62c9bef75e)();
    const { getContext: getRouterContext } = (0, $1ddaa6502d719738$export$ada49399abf7a3a1)();
    // Dynamically generate a router subscriber based on the resource:
    // makes the component re-render only when key changes instead of
    // after every route change
    const useKey = (0, $5FkrB.useMemo)(()=>(0, $gNUZr.createHook)((0, $1ddaa6502d719738$export$1cf0ecab63b1963c), {
            selector: ({ match: match, query: query, route: route }, keyArg)=>resource.getKey(keyArg != null ? keyArg : {
                    match: match,
                    query: query,
                    route: route
                }, actions.getContext())
        }), [
        resource,
        actions
    ]);
    // eslint-disable-next-line @typescript-eslint/no-non-null-asserted-optional-chain
    const key = useKey(options == null ? void 0 : options.routerContext)[0];
    const [slice] = (0, $325bbf8ea5f9a12e$export$ac3608e0bb357c7)({
        type: resource.type,
        key: key
    });
    // we keep route context bound to key, so route context won't refresh
    // unless key changes. This allows refresh to be called on effect cleanup
    // or asynchronously, when route context might already have changed
    const routerContext = (0, $5FkrB.useMemo)(// eslint-disable-next-line @typescript-eslint/no-non-null-asserted-optional-chain
    ()=>(options == null ? void 0 : options.routerContext) || getRouterContext(), // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        key
    ]);
    const update = (0, $5FkrB.useCallback)((updater)=>{
        actions.updateResourceState(resource, routerContext, updater);
    }, [
        resource,
        routerContext,
        actions
    ]);
    const clear = (0, $5FkrB.useCallback)(()=>{
        actions.clearResource(resource, routerContext);
    }, [
        resource,
        routerContext,
        actions
    ]);
    const clearAll = (0, $5FkrB.useCallback)(()=>{
        actions.clearResource(resource);
    }, [
        resource,
        actions
    ]);
    const refresh = (0, $5FkrB.useCallback)(()=>{
        actions.getResourceFromRemote(resource, routerContext, {
            prefetch: false
        });
    }, [
        resource,
        routerContext,
        actions
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, slice, {
        update: update,
        key: key,
        refresh: refresh,
        clear: clear,
        clearAll: clearAll
    });
};


const $b4ab5dace00b8583$export$fee1a6213543bd78 = ({ children: children, resource: resource, options: options })=>{
    const result = (0, $5c5601e773daa875$export$9f6abfd74295843b)(resource, options);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).Fragment, null, children(result));
};




const $57615bd5aef4bc45$export$dee7bf9fc0ff48c3 = (fn)=>(0, $325bbf8ea5f9a12e$export$6f6057d42352becb)().storeState.subscribe(fn);




const $57d0234526918c1c$export$d4864d13105dc5ed = {
    loading: false,
    error: null,
    data: {
        foo: 'bar'
    },
    promise: null,
    expiresAt: Date.now(),
    accessedAt: Date.now(),
    key: ''
};






// Internationalization configuration skeleton
// This file intentionally does not wire into the app yet.
const $9bc4aff2ff299440$export$d7f512c98c859244 = 'en';
const $9bc4aff2ff299440$export$94d2d72df36bbb16 = [
    'en'
];
const $9bc4aff2ff299440$export$5aae9b6b3e0e7094 = {
    locale: 'locale'
};
const $9bc4aff2ff299440$export$5cc733ac2d215929 = {
};


var $eeccb061c66729e2$exports = {};
$eeccb061c66729e2$exports = JSON.parse('{"navigation.title":"What\'s new across Atlassian","app.updates.title":"What\'s new across Atlassian","app.updates.subtitle":"Discover new cloud features designed to unleash your team\'s potential and see how our latest updates can power your work today.","app.updates.browserTabTitle":"Release Notes | Atlassian Community","appUpdatesDetails.backAction":"Back to release notes","appUpdatesDetails.browserTabTitleSuffix":"Release Notes | Atlassian Community","appUpdatesDetails.notFound":"This release note could not be found. Use the back button to return to release notes.","appUpdatesDetails.error":"Unable to load this release note. Use the back button to return and try again.","appUpdatesDetails.loading":"Loading release note\u2026","appUpdatesDetails.summary":"Summary","appUpdatesDetails.keyChanges":"Key changes","appUpdatesDetails.benefits":"Benefits","appUpdatesDetails.reasonForChange":"Reason for the change","appUpdatesDetails.prepareForChange":"How to prepare for the change","appUpdatesDetails.getStarted":"Getting started","appUpdatesDetails.changelog.release":"Release","appUpdatesDetails.changelog.scheduledStatus":"Scheduled","appUpdatesDetails.changelog.rollingOutStatus":"Rolling Out","appUpdatesDetails.changelog.completedStatus":"Completed","appUpdatesDetails.sidebar.appsImpactedTitle":"Apps impacted","appUpdatesDetails.sidebar.impactRatingTitle":"Change impact","appUpdatesDetails.sidebar.changeTypeTitle":"Contextual tags","appUpdatesDetails.sidebar.impactHigh":"High","appUpdatesDetails.sidebar.impactMedium":"Medium","appUpdatesDetails.sidebar.impactLow":"Low","appUpdates.filters.impactRating.label":"Impact rating","appUpdates.filters.impactRating.high":"High","appUpdates.filters.impactRating.medium":"Medium","appUpdates.filters.impactRating.low":"Low","appUpdates.filters.tags.label":"Contextual tags","appUpdatesTable.column.impactRating":"Impact","appUpdatesTable.column.changeType":"Change type","appUpdatesTable.column.contextualTags":"Contextual tags","appUpdatesTable.impactRating.high":"High","appUpdatesTable.impactRating.medium":"Medium","appUpdatesTable.impactRating.low":"Low","appUpdatesDetails.changelog.changeType":"Change type","appUpdatesDetails.changelog.changeImpact":"Change impact","appUpdatesDetails.changelog.contextualTags":"Contextual tags","appUpdates.aiDisclaimer.beta":"Beta","appUpdates.aiDisclaimer.tooltipText":"Uses AI. Verify results.","appUpdatesDetails.changelog.rolloutSchedule":"Rollout schedule","appUpdatesDetails.changelog.status":"Status","appUpdates.rolloutScheduleCallout.text":"For rollout schedules specific to your organization, visit <appUpdatesLink>App updates</appUpdatesLink> in <adminLink>Atlassian Administration</adminLink>. Organization admin access required.","appUpdatesTable.adminCallout.text":"For rollout schedules specific to your organization, visit <appUpdatesLink>App updates</appUpdatesLink> in <adminLink>Atlassian Administration</adminLink>. Organization admin access required.","app-updates-table.unread-dot.mark-as-read":"Mark as read"}');


var $033860fe7bfd25af$exports = {};
$parcel$export($033860fe7bfd25af$exports, "init", () => $c3b6349452077e3f$export$2cd8252107eb640b);
$parcel$export($033860fe7bfd25af$exports, "captureReactException", () => $d73ec427c982e9ee$export$270be4195468cda9);
$parcel$export($033860fe7bfd25af$exports, "reactErrorHandler", () => $d73ec427c982e9ee$export$1e6f045b27b3cfb1);
$parcel$export($033860fe7bfd25af$exports, "Profiler", () => $eeb2a38f5ea169f2$export$e2c29f18771995cb);
$parcel$export($033860fe7bfd25af$exports, "useProfiler", () => $eeb2a38f5ea169f2$export$972a52cbfaf8cf13);
$parcel$export($033860fe7bfd25af$exports, "withProfiler", () => $eeb2a38f5ea169f2$export$e1e354213dd1a8a7);
$parcel$export($033860fe7bfd25af$exports, "ErrorBoundary", () => $d86fddd54af16059$export$e926676385687eaf);
$parcel$export($033860fe7bfd25af$exports, "withErrorBoundary", () => $d86fddd54af16059$export$f0c7a449e0cfaec7);
$parcel$export($033860fe7bfd25af$exports, "createReduxEnhancer", () => $18b37302a7d113fe$export$c4506dd2040faa8a);
$parcel$export($033860fe7bfd25af$exports, "reactRouterV3BrowserTracingIntegration", () => $31664e4a36abe457$export$8a5d05e8905d7257);
$parcel$export($033860fe7bfd25af$exports, "tanstackRouterBrowserTracingIntegration", () => $9351852664295212$export$6405014438b98f22);
$parcel$export($033860fe7bfd25af$exports, "reactRouterV4BrowserTracingIntegration", () => $19a7bc5e65e39b8b$export$474cac1fc5ec6ff8);
$parcel$export($033860fe7bfd25af$exports, "reactRouterV5BrowserTracingIntegration", () => $19a7bc5e65e39b8b$export$1c913d0c067ca14f);
$parcel$export($033860fe7bfd25af$exports, "withSentryRouting", () => $19a7bc5e65e39b8b$export$51a414dfd89dd222);
$parcel$export($033860fe7bfd25af$exports, "reactRouterV6BrowserTracingIntegration", () => $c159a67177be6b02$export$47113a480541ff59);
$parcel$export($033860fe7bfd25af$exports, "withSentryReactRouterV6Routing", () => $c159a67177be6b02$export$c6111e8561a02a8b);
$parcel$export($033860fe7bfd25af$exports, "wrapCreateBrowserRouterV6", () => $c159a67177be6b02$export$bd33b81dece50867);
$parcel$export($033860fe7bfd25af$exports, "wrapCreateMemoryRouterV6", () => $c159a67177be6b02$export$e61a765bf2bfccdc);
$parcel$export($033860fe7bfd25af$exports, "wrapUseRoutesV6", () => $c159a67177be6b02$export$1ffd7287c0e61f32);
$parcel$export($033860fe7bfd25af$exports, "reactRouterV7BrowserTracingIntegration", () => $5bb87f6d8535ae7e$export$8c58a21c71b0a1de);
$parcel$export($033860fe7bfd25af$exports, "withSentryReactRouterV7Routing", () => $5bb87f6d8535ae7e$export$1d21f1c69f33ffe5);
$parcel$export($033860fe7bfd25af$exports, "wrapCreateBrowserRouterV7", () => $5bb87f6d8535ae7e$export$b070baa27381b3d3);
$parcel$export($033860fe7bfd25af$exports, "wrapCreateMemoryRouterV7", () => $5bb87f6d8535ae7e$export$6d8f60accec7deae);
$parcel$export($033860fe7bfd25af$exports, "wrapUseRoutesV7", () => $5bb87f6d8535ae7e$export$54f60524efa5c3b2);
var $054fa894e15f1de5$exports = {};
$parcel$export($054fa894e15f1de5$exports, "feedbackAsyncIntegration", () => $367c450e8ba35148$export$21eeae83e17be6ea);
$parcel$export($054fa894e15f1de5$exports, "feedbackIntegration", () => $3b83570998c5a022$export$4bf8b7bb0f0086df);
$parcel$export($054fa894e15f1de5$exports, "feedbackSyncIntegration", () => $3b83570998c5a022$export$4bf8b7bb0f0086df);
$parcel$export($054fa894e15f1de5$exports, "MULTIPLEXED_TRANSPORT_EXTRA_KEY", () => $5ad689bd228113be$export$8e279000b0e1318);
$parcel$export($054fa894e15f1de5$exports, "SDK_VERSION", () => $dcd58747d787136d$export$31499a9cd224b78c);
$parcel$export($054fa894e15f1de5$exports, "SEMANTIC_ATTRIBUTE_SENTRY_OP", () => $f337c80285f06f80$export$1a413bd9a88fdb09);
$parcel$export($054fa894e15f1de5$exports, "SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN", () => $f337c80285f06f80$export$cca8dd30f57f805e);
$parcel$export($054fa894e15f1de5$exports, "SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE", () => $f337c80285f06f80$export$ccfe0a40627cc34b);
$parcel$export($054fa894e15f1de5$exports, "SEMANTIC_ATTRIBUTE_SENTRY_SOURCE", () => $f337c80285f06f80$export$d7a7d984b0791405);
$parcel$export($054fa894e15f1de5$exports, "Scope", () => $dd23bca0e7d7618a$export$775b6bb06e53a214);
$parcel$export($054fa894e15f1de5$exports, "addBreadcrumb", () => $777cacbd1bed0b63$export$efda9a273d7a036d);
$parcel$export($054fa894e15f1de5$exports, "addEventProcessor", () => $6918c722b531ff18$export$9aac0b9f77928fbf);
$parcel$export($054fa894e15f1de5$exports, "addIntegration", () => $cbb2da6c78246e45$export$2d8f5188773bcddd);
$parcel$export($054fa894e15f1de5$exports, "captureConsoleIntegration", () => $83472dc082cc4dfa$export$caa9b6c4a4144db4);
$parcel$export($054fa894e15f1de5$exports, "captureEvent", () => $6918c722b531ff18$export$1462b974fdcf6ba2);
$parcel$export($054fa894e15f1de5$exports, "captureException", () => $6918c722b531ff18$export$f5282963edea4a68);
$parcel$export($054fa894e15f1de5$exports, "captureFeedback", () => $81078705bdbfb4a3$export$3b07f81befe2dd0a);
$parcel$export($054fa894e15f1de5$exports, "captureMessage", () => $6918c722b531ff18$export$45654777c133ae80);
$parcel$export($054fa894e15f1de5$exports, "captureSession", () => $6918c722b531ff18$export$667e7b4d445d566b);
$parcel$export($054fa894e15f1de5$exports, "close", () => $6918c722b531ff18$export$8360e631d277ea4d);
$parcel$export($054fa894e15f1de5$exports, "consoleLoggingIntegration", () => $12a826797062327b$export$63e034b6c5b5b12a);
$parcel$export($054fa894e15f1de5$exports, "continueTrace", () => $c9161b67125aefc1$export$d2ee9b39b25437b3);
$parcel$export($054fa894e15f1de5$exports, "createConsolaReporter", () => $13c01856bb23ea1b$export$3c37de547377f70b);
$parcel$export($054fa894e15f1de5$exports, "createLangChainCallbackHandler", () => $0aca44b63e3bce0d$export$f1a67aef86776bb5);
$parcel$export($054fa894e15f1de5$exports, "createTransport", () => $46ddc25216d7985b$export$d09f50d9ab7f7b69);
$parcel$export($054fa894e15f1de5$exports, "dedupeIntegration", () => $09e731d6cf47db44$export$6d39aa44cd0c7567);
$parcel$export($054fa894e15f1de5$exports, "endSession", () => $6918c722b531ff18$export$17a5be43989a0bc1);
$parcel$export($054fa894e15f1de5$exports, "eventFiltersIntegration", () => $ed46e39d92a37c80$export$9a84f518c163c552);
$parcel$export($054fa894e15f1de5$exports, "extraErrorDataIntegration", () => $2c574489696f76a6$export$6e0872131894301d);
$parcel$export($054fa894e15f1de5$exports, "featureFlagsIntegration", () => $e7c5c9e2c68c679d$export$82a435367bc83944);
$parcel$export($054fa894e15f1de5$exports, "flush", () => $6918c722b531ff18$export$4909b86c8034bf73);
$parcel$export($054fa894e15f1de5$exports, "functionToStringIntegration", () => $c17712dd9960287e$export$7918117e9202e4fb);
$parcel$export($054fa894e15f1de5$exports, "getActiveSpan", () => $bb9b6447bf4caedb$export$1be426a8e585c83e);
$parcel$export($054fa894e15f1de5$exports, "getClient", () => $7d48e1ed9f699a01$export$6bb76d6eba7e258c);
$parcel$export($054fa894e15f1de5$exports, "getCurrentScope", () => $7d48e1ed9f699a01$export$c7be4b0125a10cba);
$parcel$export($054fa894e15f1de5$exports, "getGlobalScope", () => $7d48e1ed9f699a01$export$aa55d5ab8e05984f);
$parcel$export($054fa894e15f1de5$exports, "getIsolationScope", () => $7d48e1ed9f699a01$export$68f3af03034c9e90);
$parcel$export($054fa894e15f1de5$exports, "getRootSpan", () => $bb9b6447bf4caedb$export$c4c6a79b1260ca1b);
$parcel$export($054fa894e15f1de5$exports, "getSpanDescendants", () => $bb9b6447bf4caedb$export$340c5c8a13ffc680);
$parcel$export($054fa894e15f1de5$exports, "getSpanStatusFromHttpCode", () => $fda37f10dc06a152$export$5fd4dc48a2131589);
$parcel$export($054fa894e15f1de5$exports, "getTraceData", () => $9086b800c08a7b68$export$dec8f001b9d982cb);
$parcel$export($054fa894e15f1de5$exports, "inboundFiltersIntegration", () => $ed46e39d92a37c80$export$cb3c5c2ceb9818ba);
$parcel$export($054fa894e15f1de5$exports, "instrumentAnthropicAiClient", () => $a28471a03541153d$export$242eaf446eac1fc8);
$parcel$export($054fa894e15f1de5$exports, "instrumentGoogleGenAIClient", () => $6dc281ceafe4c8ab$export$c76b70488372d10f);
$parcel$export($054fa894e15f1de5$exports, "instrumentLangGraph", () => $6b39ec4ad60d2ce5$export$85d9e3bf20f67098);
$parcel$export($054fa894e15f1de5$exports, "instrumentOpenAiClient", () => $eb0cfc8c9d413cf3$export$f7dad3b0c0584a13);
$parcel$export($054fa894e15f1de5$exports, "instrumentSupabaseClient", () => $eb131015662833f2$export$a286d61fd33c7083);
$parcel$export($054fa894e15f1de5$exports, "isEnabled", () => $6918c722b531ff18$export$3b029eb57ac4d562);
$parcel$export($054fa894e15f1de5$exports, "isInitialized", () => $6918c722b531ff18$export$3f95c6f800b78024);
$parcel$export($054fa894e15f1de5$exports, "lastEventId", () => $6918c722b531ff18$export$5d4e9fd7fac8e617);
$parcel$export($054fa894e15f1de5$exports, "logger", () => $429304b17eb78491$exports);
$parcel$export($054fa894e15f1de5$exports, "makeMultiplexedTransport", () => $5ad689bd228113be$export$53bbcd410607e756);
$parcel$export($054fa894e15f1de5$exports, "metrics", () => $240914cce3cb7287$exports);
$parcel$export($054fa894e15f1de5$exports, "moduleMetadataIntegration", () => $aaf675b3037a7689$export$b3b128c3ae01ded0);
$parcel$export($054fa894e15f1de5$exports, "parameterize", () => $7c398daf82b5cdeb$export$4cb5eb704d6ec224);
$parcel$export($054fa894e15f1de5$exports, "registerSpanErrorInstrumentation", () => $154c5a3196d0f5d1$export$b0914730ee1f6c80);
$parcel$export($054fa894e15f1de5$exports, "rewriteFramesIntegration", () => $502d06ce7800152d$export$5ed0db6416cb6ea2);
$parcel$export($054fa894e15f1de5$exports, "setContext", () => $6918c722b531ff18$export$2f04de43fe27971a);
$parcel$export($054fa894e15f1de5$exports, "setConversationId", () => $6918c722b531ff18$export$58213391a19e392);
$parcel$export($054fa894e15f1de5$exports, "setCurrentClient", () => $bdb6894cd2fc2f4a$export$ecb76f41d43c0e43);
$parcel$export($054fa894e15f1de5$exports, "setExtra", () => $6918c722b531ff18$export$8e8e7789d42ed61d);
$parcel$export($054fa894e15f1de5$exports, "setExtras", () => $6918c722b531ff18$export$bb4922da0dd51b92);
$parcel$export($054fa894e15f1de5$exports, "setHttpStatus", () => $fda37f10dc06a152$export$2ad6630ec8164254);
$parcel$export($054fa894e15f1de5$exports, "setMeasurement", () => $dbcaa70aa380aaa2$export$7cc31b475d33a706);
$parcel$export($054fa894e15f1de5$exports, "setTag", () => $6918c722b531ff18$export$a37d07ee78eb4569);
$parcel$export($054fa894e15f1de5$exports, "setTags", () => $6918c722b531ff18$export$74a8fb34822092e6);
$parcel$export($054fa894e15f1de5$exports, "setUser", () => $6918c722b531ff18$export$8b6bb3dd62a01be2);
$parcel$export($054fa894e15f1de5$exports, "spanToBaggageHeader", () => $09fae5ef8120e803$export$95cf936fdacaff7b);
$parcel$export($054fa894e15f1de5$exports, "spanToJSON", () => $bb9b6447bf4caedb$export$92d8c23565496537);
$parcel$export($054fa894e15f1de5$exports, "spanToTraceHeader", () => $bb9b6447bf4caedb$export$7e9f8ae9e4a328ab);
$parcel$export($054fa894e15f1de5$exports, "startInactiveSpan", () => $c9161b67125aefc1$export$63dbba021a6b4047);
$parcel$export($054fa894e15f1de5$exports, "startNewTrace", () => $c9161b67125aefc1$export$f90b03291402f553);
$parcel$export($054fa894e15f1de5$exports, "startSession", () => $6918c722b531ff18$export$c0d84948cecf78d8);
$parcel$export($054fa894e15f1de5$exports, "startSpan", () => $c9161b67125aefc1$export$a1bd95187356f372);
$parcel$export($054fa894e15f1de5$exports, "startSpanManual", () => $c9161b67125aefc1$export$c10292ad04b92aea);
$parcel$export($054fa894e15f1de5$exports, "supabaseIntegration", () => $eb131015662833f2$export$856ced54ce86f97e);
$parcel$export($054fa894e15f1de5$exports, "suppressTracing", () => $c9161b67125aefc1$export$869298f9835abc68);
$parcel$export($054fa894e15f1de5$exports, "thirdPartyErrorFilterIntegration", () => $6ff5d94fa4398112$export$be5f345197c66e53);
$parcel$export($054fa894e15f1de5$exports, "updateSpanName", () => $bb9b6447bf4caedb$export$5b72d3169c1be715);
$parcel$export($054fa894e15f1de5$exports, "withActiveSpan", () => $c9161b67125aefc1$export$e57ac09b143d92a2);
$parcel$export($054fa894e15f1de5$exports, "withIsolationScope", () => $7d48e1ed9f699a01$export$9a4fed82c350c2bd);
$parcel$export($054fa894e15f1de5$exports, "withScope", () => $7d48e1ed9f699a01$export$ec58d9285c204497);
$parcel$export($054fa894e15f1de5$exports, "zodErrorsIntegration", () => $241378d1257bd050$export$a9e1d9bd14830dfb);
$parcel$export($054fa894e15f1de5$exports, "WINDOW", () => $e62dec891f31852b$export$56d8a8a25bd48b81);
$parcel$export($054fa894e15f1de5$exports, "BrowserClient", () => $4e1ce061c21a5e69$export$1df9218a526d318d);
$parcel$export($054fa894e15f1de5$exports, "makeFetchTransport", () => $366021d20f9daad3$export$b2311068c46d7cc8);
$parcel$export($054fa894e15f1de5$exports, "uiProfiler", () => $61e522e7948b3efb$export$c7cf24e2253024f3);
$parcel$export($054fa894e15f1de5$exports, "chromeStackLineParser", () => $5c2a6884ada474e9$export$263a749fff749872);
$parcel$export($054fa894e15f1de5$exports, "defaultStackLineParsers", () => $5c2a6884ada474e9$export$7197c0fe6554c079);
$parcel$export($054fa894e15f1de5$exports, "defaultStackParser", () => $5c2a6884ada474e9$export$2b2b997d81bf3907);
$parcel$export($054fa894e15f1de5$exports, "geckoStackLineParser", () => $5c2a6884ada474e9$export$cdba47a5dd2804d);
$parcel$export($054fa894e15f1de5$exports, "opera10StackLineParser", () => $5c2a6884ada474e9$export$f892b52c880ffc7a);
$parcel$export($054fa894e15f1de5$exports, "opera11StackLineParser", () => $5c2a6884ada474e9$export$af11af13f09fb0dc);
$parcel$export($054fa894e15f1de5$exports, "winjsStackLineParser", () => $5c2a6884ada474e9$export$179460296da408e8);
$parcel$export($054fa894e15f1de5$exports, "eventFromException", () => $934e8a4b0ce930b6$export$ea3ec7e569b823fc);
$parcel$export($054fa894e15f1de5$exports, "eventFromMessage", () => $934e8a4b0ce930b6$export$5425b53185d13d6c);
$parcel$export($054fa894e15f1de5$exports, "exceptionFromError", () => $934e8a4b0ce930b6$export$a6c2d27607295951);
$parcel$export($054fa894e15f1de5$exports, "createUserFeedbackEnvelope", () => $b80b1f8b91224d00$export$24a4dfcb686ee5bf);
$parcel$export($054fa894e15f1de5$exports, "forceLoad", () => $14d7809dba5d50b0$export$a3f323d81eede727);
$parcel$export($054fa894e15f1de5$exports, "getDefaultIntegrations", () => $14d7809dba5d50b0$export$5783b2920b1d62b9);
$parcel$export($054fa894e15f1de5$exports, "init", () => $14d7809dba5d50b0$export$2cd8252107eb640b);
$parcel$export($054fa894e15f1de5$exports, "onLoad", () => $14d7809dba5d50b0$export$4e4d8b287d028b6b);
$parcel$export($054fa894e15f1de5$exports, "showReportDialog", () => $c145e0c6ce486f3a$export$3a8fd680da42627b);
$parcel$export($054fa894e15f1de5$exports, "breadcrumbsIntegration", () => $0ad9abad7f8d2d66$export$c079d904b326663a);
$parcel$export($054fa894e15f1de5$exports, "globalHandlersIntegration", () => $f1959cdcacc276d1$export$66acc70e8cf2b71a);
$parcel$export($054fa894e15f1de5$exports, "httpContextIntegration", () => $2fcda6dfa3c250e9$export$1378794447170364);
$parcel$export($054fa894e15f1de5$exports, "linkedErrorsIntegration", () => $ce07fe89a71836e2$export$ebabb00eb7f3a395);
$parcel$export($054fa894e15f1de5$exports, "browserApiErrorsIntegration", () => $fa3dc958cc9f40d6$export$59bfe9f1c76150e);
$parcel$export($054fa894e15f1de5$exports, "browserSessionIntegration", () => $9bfd264dc60b3ee5$export$1baa7880e357371c);
$parcel$export($054fa894e15f1de5$exports, "lazyLoadIntegration", () => $3fc94f2ac1572f6d$export$6da56f3ddf2bd0c1);
$parcel$export($054fa894e15f1de5$exports, "reportingObserverIntegration", () => $a0ba0212b29c7bfc$export$609cccfa9f328cc5);
$parcel$export($054fa894e15f1de5$exports, "httpClientIntegration", () => $899ee8298ebc75fb$export$8a3b7aeb379b3907);
$parcel$export($054fa894e15f1de5$exports, "contextLinesIntegration", () => $e5ba3b05859a226d$export$74173d114ed4f354);
$parcel$export($054fa894e15f1de5$exports, "graphqlClientIntegration", () => $09df6a71d9392bb9$export$a934e57cd817247a);
$parcel$export($054fa894e15f1de5$exports, "getReplay", () => $604631306887a81e$export$b28310b2f161456b);
$parcel$export($054fa894e15f1de5$exports, "replayIntegration", () => $604631306887a81e$export$d7706faf7ab354bf);
$parcel$export($054fa894e15f1de5$exports, "replayCanvasIntegration", () => $ea445dd6c112133e$export$71ba62165d5c834d);
$parcel$export($054fa894e15f1de5$exports, "getFeedback", () => $106dcbf01d17d3b7$export$ed85ee0b85ce96e1);
$parcel$export($054fa894e15f1de5$exports, "sendFeedback", () => $106dcbf01d17d3b7$export$a65d69dd22caceda);
$parcel$export($054fa894e15f1de5$exports, "defaultRequestInstrumentationOptions", () => $b3e0e430d6ae504d$export$cc17fb3c0bc95cd7);
$parcel$export($054fa894e15f1de5$exports, "instrumentOutgoingRequests", () => $b3e0e430d6ae504d$export$864489cb3478db3e);
$parcel$export($054fa894e15f1de5$exports, "browserTracingIntegration", () => $7b5f2a588355dc11$export$b4109253475213e9);
$parcel$export($054fa894e15f1de5$exports, "startBrowserTracingNavigationSpan", () => $7b5f2a588355dc11$export$7d159749bd9969ad);
$parcel$export($054fa894e15f1de5$exports, "startBrowserTracingPageLoadSpan", () => $7b5f2a588355dc11$export$aa44a07f82af519f);
$parcel$export($054fa894e15f1de5$exports, "reportPageLoaded", () => $e3f9649a5fcc80c1$export$9e8f428c76bd6d1b);
$parcel$export($054fa894e15f1de5$exports, "setActiveSpanInBrowser", () => $40d8570c26789de3$export$4519ca486fe8649b);
$parcel$export($054fa894e15f1de5$exports, "makeBrowserOfflineTransport", () => $c405876784a7ff78$export$79c8882827636cf2);
$parcel$export($054fa894e15f1de5$exports, "browserProfilingIntegration", () => $ddc68b5832e965a7$export$2c7b5d6dd5622f23);
$parcel$export($054fa894e15f1de5$exports, "spotlightBrowserIntegration", () => $75c15b1f5f212f04$export$a05c07c0f32f730a);
$parcel$export($054fa894e15f1de5$exports, "cultureContextIntegration", () => $5784fbfdd799cccf$export$ec5976aacdc85985);
$parcel$export($054fa894e15f1de5$exports, "buildLaunchDarklyFlagUsedHandler", () => $2849f1c84e195cf6$export$f97714c0986edb0);
$parcel$export($054fa894e15f1de5$exports, "launchDarklyIntegration", () => $2849f1c84e195cf6$export$7cd9c18538ed792e);
$parcel$export($054fa894e15f1de5$exports, "OpenFeatureIntegrationHook", () => $6878dd2c72de26fa$export$f399add65bfd388e);
$parcel$export($054fa894e15f1de5$exports, "openFeatureIntegration", () => $6878dd2c72de26fa$export$a41102cd52abbd1b);
$parcel$export($054fa894e15f1de5$exports, "unleashIntegration", () => $d2291f482b064e01$export$e753ab651e68430d);
$parcel$export($054fa894e15f1de5$exports, "growthbookIntegration", () => $382b31aa5714bdd4$export$c8399a95701fbc9f);
$parcel$export($054fa894e15f1de5$exports, "statsigIntegration", () => $cd57e45df1dff5a4$export$473918ef9c3b2ab7);
$parcel$export($054fa894e15f1de5$exports, "diagnoseSdkConnectivity", () => $7819adec6ec21508$export$fecc80c9f0e9c1b2);
$parcel$export($054fa894e15f1de5$exports, "registerWebWorker", () => $907c5ffa3e02c638$export$86daa8bd1fb8c346);
$parcel$export($054fa894e15f1de5$exports, "webWorkerIntegration", () => $907c5ffa3e02c638$export$88896133e37bd4db);
// This is a magic string replaced by rollup
const $dcd58747d787136d$export$31499a9cd224b78c = "10.45.0";


/** Internal global with common properties and Sentry extensions  */ /** Get's the global object for the current JavaScript runtime */ const $736a69486c86d36c$export$f1a6cdb1459e81d1 = globalThis;


/**
 * An object that contains globally accessible properties and maintains a scope stack.
 * @hidden
 */ /**
 * Returns the global shim registry.
 *
 * FIXME: This function is problematic, because despite always returning a valid Carrier,
 * it has an optional `__SENTRY__` property, which then in turn requires us to always perform an unnecessary check
 * at the call-site. We always access the carrier through this function, so we can guarantee that `__SENTRY__` is there.
 **/ function $e4c75fb63b040566$export$19eade501500c6c1() {
    // This ensures a Sentry carrier exists
    $e4c75fb63b040566$export$c8bfa33e4e8ae492((0, $736a69486c86d36c$export$f1a6cdb1459e81d1));
    return 0, $736a69486c86d36c$export$f1a6cdb1459e81d1;
}
/** Will either get the existing sentry carrier, or create a new one. */ function $e4c75fb63b040566$export$c8bfa33e4e8ae492(carrier) {
    const __SENTRY__ = carrier.__SENTRY__ = carrier.__SENTRY__ || {};
    // For now: First SDK that sets the .version property wins
    __SENTRY__.version = __SENTRY__.version || (0, $dcd58747d787136d$export$31499a9cd224b78c);
    // Intentionally populating and returning the version of "this" SDK instance
    // rather than what's set in .version so that "this" SDK always gets its carrier
    return __SENTRY__[0, $dcd58747d787136d$export$31499a9cd224b78c] = __SENTRY__[0, $dcd58747d787136d$export$31499a9cd224b78c] || {};
}
/**
 * Returns a global singleton contained in the global `__SENTRY__[]` object.
 *
 * If the singleton doesn't already exist in `__SENTRY__`, it will be created using the given factory
 * function and added to the `__SENTRY__` object.
 *
 * @param name name of the global singleton on __SENTRY__
 * @param creator creator Factory function to create the singleton if it doesn't already exist on `__SENTRY__`
 * @param obj (Optional) The global object on which to look for `__SENTRY__`, if not `GLOBAL_OBJ`'s return value
 * @returns the singleton
 */ function $e4c75fb63b040566$export$7e223ec222791509(name, creator, obj = (0, $736a69486c86d36c$export$f1a6cdb1459e81d1)) {
    const __SENTRY__ = obj.__SENTRY__ = obj.__SENTRY__ || {};
    const carrier = __SENTRY__[0, $dcd58747d787136d$export$31499a9cd224b78c] = __SENTRY__[0, $dcd58747d787136d$export$31499a9cd224b78c] || {};
    // Note: We do not want to set `carrier.version` here, as this may be called before any `init` is called, e.g. for the default scopes
    return carrier[name] || (carrier[name] = creator());
}



/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $19fdbaf7f0830971$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__;



// eslint-disable-next-line @typescript-eslint/unbound-method
const $13cf2ed412f405fa$var$objectToString = Object.prototype.toString;
/**
 * Checks whether given value's type is one of a few Error or Error-like
 * {@link isError}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $13cf2ed412f405fa$export$e6127cc7fe7395c3(wat) {
    switch($13cf2ed412f405fa$var$objectToString.call(wat)){
        case '[object Error]':
        case '[object Exception]':
        case '[object DOMException]':
        case '[object WebAssembly.Exception]':
            return true;
        default:
            return $13cf2ed412f405fa$export$49034edbe6b62415(wat, Error);
    }
}
/**
 * Checks whether given value is an instance of the given built-in class.
 *
 * @param wat The value to be checked
 * @param className
 * @returns A boolean representing the result.
 */ function $13cf2ed412f405fa$var$isBuiltin(wat, className) {
    return $13cf2ed412f405fa$var$objectToString.call(wat) === `[object ${className}]`;
}
/**
 * Checks whether given value's type is ErrorEvent
 * {@link isErrorEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $13cf2ed412f405fa$export$9f9636d330b71954(wat) {
    return $13cf2ed412f405fa$var$isBuiltin(wat, 'ErrorEvent');
}
/**
 * Checks whether given value's type is DOMError
 * {@link isDOMError}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $13cf2ed412f405fa$export$ef9e2056653f0c8e(wat) {
    return $13cf2ed412f405fa$var$isBuiltin(wat, 'DOMError');
}
/**
 * Checks whether given value's type is DOMException
 * {@link isDOMException}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $13cf2ed412f405fa$export$12e869b2a583f783(wat) {
    return $13cf2ed412f405fa$var$isBuiltin(wat, 'DOMException');
}
/**
 * Checks whether given value's type is a string
 * {@link isString}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $13cf2ed412f405fa$export$844ec244b1367d54(wat) {
    return $13cf2ed412f405fa$var$isBuiltin(wat, 'String');
}
/**
 * Checks whether given string is parameterized
 * {@link isParameterizedString}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $13cf2ed412f405fa$export$dbcbffa59149b824(wat) {
    return typeof wat === 'object' && wat !== null && '__sentry_template_string__' in wat && '__sentry_template_values__' in wat;
}
/**
 * Checks whether given value is a primitive (undefined, null, number, boolean, string, bigint, symbol)
 * {@link isPrimitive}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $13cf2ed412f405fa$export$c3825b437cbdea5c(wat) {
    return wat === null || $13cf2ed412f405fa$export$dbcbffa59149b824(wat) || typeof wat !== 'object' && typeof wat !== 'function';
}
/**
 * Checks whether given value's type is an object literal, or a class instance.
 * {@link isPlainObject}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $13cf2ed412f405fa$export$53b83ca8eaab0383(wat) {
    return $13cf2ed412f405fa$var$isBuiltin(wat, 'Object');
}
/**
 * Checks whether given value's type is an Event instance
 * {@link isEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $13cf2ed412f405fa$export$9671ea99bd126ace(wat) {
    return typeof Event !== 'undefined' && $13cf2ed412f405fa$export$49034edbe6b62415(wat, Event);
}
/**
 * Checks whether given value's type is an Element instance
 * {@link isElement}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $13cf2ed412f405fa$export$45a5e7f76e0caa8d(wat) {
    return typeof Element !== 'undefined' && $13cf2ed412f405fa$export$49034edbe6b62415(wat, Element);
}
/**
 * Checks whether given value's type is an regexp
 * {@link isRegExp}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $13cf2ed412f405fa$export$49841c62b9eff15(wat) {
    return $13cf2ed412f405fa$var$isBuiltin(wat, 'RegExp');
}
/**
 * Checks whether given value has a then function.
 * @param wat A value to be checked.
 */ function $13cf2ed412f405fa$export$f5b060c2914b97c8(wat) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return Boolean(wat?.then && typeof wat.then === 'function');
}
/**
 * Checks whether given value's type is a SyntheticEvent
 * {@link isSyntheticEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $13cf2ed412f405fa$export$bc2894c7158efbac(wat) {
    return $13cf2ed412f405fa$export$53b83ca8eaab0383(wat) && 'nativeEvent' in wat && 'preventDefault' in wat && 'stopPropagation' in wat;
}
/**
 * Checks whether given value's type is an instance of provided constructor.
 * {@link isInstanceOf}.
 *
 * @param wat A value to be checked.
 * @param base A constructor to be used in a check.
 * @returns A boolean representing the result.
 */ // TODO: fix in v11, convert any to unknown
// export function isInstanceOf<T>(wat: unknown, base: { new (...args: any[]): T }): wat is T {
function $13cf2ed412f405fa$export$49034edbe6b62415(wat, base) {
    try {
        return wat instanceof base;
    } catch  {
        return false;
    }
}
/**
 * Checks whether given value's type is a Vue ViewModel or a VNode.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $13cf2ed412f405fa$export$7916fad0ebc23f48(wat) {
    // Not using Object.prototype.toString because in Vue 3 it would read the instance's Symbol(Symbol.toStringTag) property.
    // We also need to check for __v_isVNode because Vue 3 component render instances have an internal __v_isVNode property.
    return !!(typeof wat === 'object' && wat !== null && (wat.__isVue || wat._isVue || wat.__v_isVNode));
}
/**
 * Checks whether the given parameter is a Standard Web API Request instance.
 *
 * Returns false if Request is not available in the current runtime.
 */ function $13cf2ed412f405fa$export$6d3d1f317d7cda57(request) {
    return typeof Request !== 'undefined' && $13cf2ed412f405fa$export$49034edbe6b62415(request, Request);
}



const $caac489b9d8395b2$var$WINDOW = (0, $736a69486c86d36c$export$f1a6cdb1459e81d1);
const $caac489b9d8395b2$var$DEFAULT_MAX_STRING_LENGTH = 80;
/**
 * Given a child DOM element, returns a query-selector statement describing that
 * and its ancestors
 * e.g. [HTMLElement] => body > div > input#foo.btn[name=baz]
 * @returns generated DOM path
 */ function $caac489b9d8395b2$export$5647df6b7814ac86(elem, options = {}) {
    if (!elem) return '<unknown>';
    // try/catch both:
    // - accessing event.target (see getsentry/raven-js#838, #768)
    // - `htmlTreeAsString` because it's complex, and just accessing the DOM incorrectly
    // - can throw an exception in some circumstances.
    try {
        let currentElem = elem;
        const MAX_TRAVERSE_HEIGHT = 5;
        const out = [];
        let height = 0;
        let len = 0;
        const separator = ' > ';
        const sepLength = separator.length;
        let nextStr;
        const keyAttrs = Array.isArray(options) ? options : options.keyAttrs;
        const maxStringLength = !Array.isArray(options) && options.maxStringLength || $caac489b9d8395b2$var$DEFAULT_MAX_STRING_LENGTH;
        while(currentElem && height++ < MAX_TRAVERSE_HEIGHT){
            nextStr = $caac489b9d8395b2$var$_htmlElementAsString(currentElem, keyAttrs);
            // bail out if
            // - nextStr is the 'html' element
            // - the length of the string that would be created exceeds maxStringLength
            //   (ignore this limit if we are on the first iteration)
            if (nextStr === 'html' || height > 1 && len + out.length * sepLength + nextStr.length >= maxStringLength) break;
            out.push(nextStr);
            len += nextStr.length;
            currentElem = currentElem.parentNode;
        }
        return out.reverse().join(separator);
    } catch  {
        return '<unknown>';
    }
}
/**
 * Returns a simple, query-selector representation of a DOM element
 * e.g. [HTMLElement] => input#foo.btn[name=baz]
 * @returns generated DOM path
 */ function $caac489b9d8395b2$var$_htmlElementAsString(el, keyAttrs) {
    const elem = el;
    const out = [];
    if (!elem?.tagName) return '';
    // @ts-expect-error WINDOW has HTMLElement
    if ($caac489b9d8395b2$var$WINDOW.HTMLElement) // If using the component name annotation plugin, this value may be available on the DOM node
    {
        if (elem instanceof HTMLElement && elem.dataset) {
            if (elem.dataset['sentryComponent']) return elem.dataset['sentryComponent'];
            if (elem.dataset['sentryElement']) return elem.dataset['sentryElement'];
        }
    }
    out.push(elem.tagName.toLowerCase());
    // Pairs of attribute keys defined in `serializeAttribute` and their values on element.
    const keyAttrPairs = keyAttrs?.length ? keyAttrs.filter((keyAttr)=>elem.getAttribute(keyAttr)).map((keyAttr)=>[
            keyAttr,
            elem.getAttribute(keyAttr)
        ]) : null;
    if (keyAttrPairs?.length) keyAttrPairs.forEach((keyAttrPair)=>{
        out.push(`[${keyAttrPair[0]}="${keyAttrPair[1]}"]`);
    });
    else {
        if (elem.id) out.push(`#${elem.id}`);
        const className = elem.className;
        if (className && (0, $13cf2ed412f405fa$export$844ec244b1367d54)(className)) {
            const classes = className.split(/\s+/);
            for (const c of classes)out.push(`.${c}`);
        }
    }
    for (const k of [
        'aria-label',
        'type',
        'name',
        'title',
        'alt'
    ]){
        const attr = elem.getAttribute(k);
        if (attr) out.push(`[${k}="${attr}"]`);
    }
    return out.join('');
}
/**
 * A safe form of location.href
 */ function $caac489b9d8395b2$export$1cfafeee2987818b() {
    try {
        return $caac489b9d8395b2$var$WINDOW.document.location.href;
    } catch  {
        return '';
    }
}
/**
 * Given a DOM element, traverses up the tree until it finds the first ancestor node
 * that has the `data-sentry-component` or `data-sentry-element` attribute with `data-sentry-component` taking
 * precedence. This attribute is added at build-time by projects that have the component name annotation plugin installed.
 *
 * @returns a string representation of the component for the provided DOM element, or `null` if not found
 */ function $caac489b9d8395b2$export$26727cfcc4d7e0fc(elem) {
    // @ts-expect-error WINDOW has HTMLElement
    if (!$caac489b9d8395b2$var$WINDOW.HTMLElement) return null;
    let currentElem = elem;
    const MAX_TRAVERSE_HEIGHT = 5;
    for(let i = 0; i < MAX_TRAVERSE_HEIGHT; i++){
        if (!currentElem) return null;
        if (currentElem instanceof HTMLElement) {
            if (currentElem.dataset['sentryComponent']) return currentElem.dataset['sentryComponent'];
            if (currentElem.dataset['sentryElement']) return currentElem.dataset['sentryElement'];
        }
        currentElem = currentElem.parentNode;
    }
    return null;
}





const $d11ed0b3cdda6b8d$export$2a2b1d2252a69ecb = [
    'debug',
    'info',
    'warn',
    'error',
    'log',
    'assert',
    'trace'
];
/** Prefix for logging strings */ const $d11ed0b3cdda6b8d$var$PREFIX = 'Sentry Logger ';
/** This may be mutated by the console instrumentation. */ const $d11ed0b3cdda6b8d$export$77c4ce905194557b = {};
/**
 * Temporarily disable sentry console instrumentations.
 *
 * @param callback The function to run against the original `console` messages
 * @returns The results of the callback
 */ function $d11ed0b3cdda6b8d$export$cda52e2a8927a2ca(callback) {
    if (!('console' in (0, $736a69486c86d36c$export$f1a6cdb1459e81d1))) return callback();
    const console = (0, $736a69486c86d36c$export$f1a6cdb1459e81d1).console;
    const wrappedFuncs = {};
    const wrappedLevels = Object.keys($d11ed0b3cdda6b8d$export$77c4ce905194557b);
    // Restore all wrapped console methods
    wrappedLevels.forEach((level)=>{
        const originalConsoleMethod = $d11ed0b3cdda6b8d$export$77c4ce905194557b[level];
        wrappedFuncs[level] = console[level];
        console[level] = originalConsoleMethod;
    });
    try {
        return callback();
    } finally{
        // Revert restoration to wrapped state
        wrappedLevels.forEach((level)=>{
            console[level] = wrappedFuncs[level];
        });
    }
}
function $d11ed0b3cdda6b8d$var$enable() {
    $d11ed0b3cdda6b8d$var$_getLoggerSettings().enabled = true;
}
function $d11ed0b3cdda6b8d$var$disable() {
    $d11ed0b3cdda6b8d$var$_getLoggerSettings().enabled = false;
}
function $d11ed0b3cdda6b8d$var$isEnabled() {
    return $d11ed0b3cdda6b8d$var$_getLoggerSettings().enabled;
}
function $d11ed0b3cdda6b8d$var$log(...args) {
    $d11ed0b3cdda6b8d$var$_maybeLog('log', ...args);
}
function $d11ed0b3cdda6b8d$var$warn(...args) {
    $d11ed0b3cdda6b8d$var$_maybeLog('warn', ...args);
}
function $d11ed0b3cdda6b8d$var$error(...args) {
    $d11ed0b3cdda6b8d$var$_maybeLog('error', ...args);
}
function $d11ed0b3cdda6b8d$var$_maybeLog(level, ...args) {
    if (!(0, $19fdbaf7f0830971$export$16a28057038b10ef)) return;
    if ($d11ed0b3cdda6b8d$var$isEnabled()) $d11ed0b3cdda6b8d$export$cda52e2a8927a2ca(()=>{
        (0, $736a69486c86d36c$export$f1a6cdb1459e81d1).console[level](`${$d11ed0b3cdda6b8d$var$PREFIX}[${level}]:`, ...args);
    });
}
function $d11ed0b3cdda6b8d$var$_getLoggerSettings() {
    if (!(0, $19fdbaf7f0830971$export$16a28057038b10ef)) return {
        enabled: false
    };
    return (0, $e4c75fb63b040566$export$7e223ec222791509)('loggerSettings', ()=>({
            enabled: false
        }));
}
/**
 * This is a logger singleton which either logs things or no-ops if logging is not enabled.
 */ const $d11ed0b3cdda6b8d$export$1c9f709888824e05 = {
    enable: /** Enable logging. */ $d11ed0b3cdda6b8d$var$enable,
    disable: /** Disable logging. */ $d11ed0b3cdda6b8d$var$disable,
    isEnabled: /** Check if logging is enabled. */ $d11ed0b3cdda6b8d$var$isEnabled,
    log: /** Log a message. */ $d11ed0b3cdda6b8d$var$log,
    warn: /** Log a warning. */ $d11ed0b3cdda6b8d$var$warn,
    error: /** Log an error. */ $d11ed0b3cdda6b8d$var$error
};



/* eslint-disable @typescript-eslint/no-explicit-any */ /**
 * Replace a method in an object with a wrapped version of itself.
 *
 * If the method on the passed object is not a function, the wrapper will not be applied.
 *
 * @param source An object that contains a method to be wrapped.
 * @param name The name of the method to be wrapped.
 * @param replacementFactory A higher-order function that takes the original version of the given method and returns a
 * wrapped version. Note: The function returned by `replacementFactory` needs to be a non-arrow function, in order to
 * preserve the correct value of `this`, and the original method must be called using `origMethod.call(this, <other
 * args>)` or `origMethod.apply(this, [<other args>])` (rather than being called directly), again to preserve `this`.
 * @returns void
 */ function $269eeb69635ed414$export$9563e054e6f787fb(source, name, replacementFactory) {
    if (!(name in source)) return;
    // explicitly casting to unknown because we don't know the type of the method initially at all
    const original = source[name];
    if (typeof original !== 'function') return;
    const wrapped = replacementFactory(original);
    // Make sure it's a function first, as we need to attach an empty prototype for `defineProperties` to work
    // otherwise it'll throw "TypeError: Object.defineProperties called on non-object"
    if (typeof wrapped === 'function') $269eeb69635ed414$export$5c1499e2e5d010ae(wrapped, original);
    try {
        source[name] = wrapped;
    } catch  {
        (0, $19fdbaf7f0830971$export$16a28057038b10ef) && (0, $d11ed0b3cdda6b8d$export$1c9f709888824e05).log(`Failed to replace method "${name}" in object`, source);
    }
}
/**
 * Defines a non-enumerable property on the given object.
 *
 * @param obj The object on which to set the property
 * @param name The name of the property to be set
 * @param value The value to which to set the property
 */ function $269eeb69635ed414$export$e73679ffaf56810e(obj, name, value) {
    try {
        Object.defineProperty(obj, name, {
            value: // enumerable: false, // the default, so we can save on bundle size by not explicitly setting it
            value,
            writable: true,
            configurable: true
        });
    } catch  {
        (0, $19fdbaf7f0830971$export$16a28057038b10ef) && (0, $d11ed0b3cdda6b8d$export$1c9f709888824e05).log(`Failed to add non-enumerable property "${name}" to object`, obj);
    }
}
/**
 * Remembers the original function on the wrapped function and
 * patches up the prototype.
 *
 * @param wrapped the wrapper function
 * @param original the original function that gets wrapped
 */ function $269eeb69635ed414$export$5c1499e2e5d010ae(wrapped, original) {
    try {
        const proto = original.prototype || {};
        wrapped.prototype = original.prototype = proto;
        $269eeb69635ed414$export$e73679ffaf56810e(wrapped, '__sentry_original__', original);
    } catch  {} // eslint-disable-line no-empty
}
/**
 * This extracts the original function if available.  See
 * `markFunctionWrapped` for more information.
 *
 * @param func the function to unwrap
 * @returns the unwrapped version of the function if available.
 */ // eslint-disable-next-line @typescript-eslint/ban-types
function $269eeb69635ed414$export$e6cc1e135e2092e5(func) {
    return func.__sentry_original__;
}
/**
 * Transforms any `Error` or `Event` into a plain object with all of their enumerable properties, and some of their
 * non-enumerable properties attached.
 *
 * @param value Initial source that we have to transform in order for it to be usable by the serializer
 * @returns An Event or Error turned into an object - or the value argument itself, when value is neither an Event nor
 *  an Error.
 */ function $269eeb69635ed414$export$62ff257738bf57f5(value) {
    if ((0, $13cf2ed412f405fa$export$e6127cc7fe7395c3)(value)) return {
        message: value.message,
        name: value.name,
        stack: value.stack,
        ...$269eeb69635ed414$var$getOwnProperties(value)
    };
    else if ((0, $13cf2ed412f405fa$export$9671ea99bd126ace)(value)) {
        const newObj = {
            type: value.type,
            target: $269eeb69635ed414$var$serializeEventTarget(value.target),
            currentTarget: $269eeb69635ed414$var$serializeEventTarget(value.currentTarget),
            ...$269eeb69635ed414$var$getOwnProperties(value)
        };
        if (typeof CustomEvent !== 'undefined' && (0, $13cf2ed412f405fa$export$49034edbe6b62415)(value, CustomEvent)) newObj.detail = value.detail;
        return newObj;
    } else return value;
}
/** Creates a string representation of the target of an `Event` object */ function $269eeb69635ed414$var$serializeEventTarget(target) {
    try {
        return (0, $13cf2ed412f405fa$export$45a5e7f76e0caa8d)(target) ? (0, $caac489b9d8395b2$export$5647df6b7814ac86)(target) : Object.prototype.toString.call(target);
    } catch  {
        return '<unknown>';
    }
}
/** Filters out all but an object's own properties */ function $269eeb69635ed414$var$getOwnProperties(obj) {
    if (typeof obj === 'object' && obj !== null) return Object.fromEntries(Object.entries(obj));
    return {};
}
/**
 * Given any captured exception, extract its keys and create a sorted
 * and truncated list that will be used inside the event message.
 * eg. `Non-error exception captured with keys: foo, bar, baz`
 */ function $269eeb69635ed414$export$b0244d5063c0b61b(exception) {
    const keys = Object.keys($269eeb69635ed414$export$62ff257738bf57f5(exception));
    keys.sort();
    return !keys[0] ? '[object has no keys]' : keys.join(', ');
}
/**
 * Given any object, return a new object having removed all fields whose value was `undefined`.
 * Works recursively on objects and arrays.
 *
 * Attention: This function keeps circular references in the returned object.
 *
 * @deprecated This function is no longer used by the SDK and will be removed in a future major version.
 */ function $269eeb69635ed414$export$d25f2688db1bb433(inputValue) {
    // This map keeps track of what already visited nodes map to.
    // Our Set - based memoBuilder doesn't work here because we want to the output object to have the same circular
    // references as the input object.
    const memoizationMap = new Map();
    // This function just proxies `_dropUndefinedKeys` to keep the `memoBuilder` out of this function's API
    return $269eeb69635ed414$var$_dropUndefinedKeys(inputValue, memoizationMap);
}
function $269eeb69635ed414$var$_dropUndefinedKeys(inputValue, memoizationMap) {
    // Early return for primitive values
    if (inputValue === null || typeof inputValue !== 'object') return inputValue;
    // Check memo map first for all object types
    const memoVal = memoizationMap.get(inputValue);
    if (memoVal !== undefined) return memoVal;
    // handle arrays
    if (Array.isArray(inputValue)) {
        const returnValue = [];
        // Store mapping to handle circular references
        memoizationMap.set(inputValue, returnValue);
        inputValue.forEach((value)=>{
            returnValue.push($269eeb69635ed414$var$_dropUndefinedKeys(value, memoizationMap));
        });
        return returnValue;
    }
    if ($269eeb69635ed414$var$isPojo(inputValue)) {
        const returnValue = {};
        // Store mapping to handle circular references
        memoizationMap.set(inputValue, returnValue);
        const keys = Object.keys(inputValue);
        keys.forEach((key)=>{
            const val = inputValue[key];
            if (val !== undefined) returnValue[key] = $269eeb69635ed414$var$_dropUndefinedKeys(val, memoizationMap);
        });
        return returnValue;
    }
    // For other object types, return as is
    return inputValue;
}
function $269eeb69635ed414$var$isPojo(input) {
    // Plain objects have Object as constructor or no constructor
    const constructor = input.constructor;
    return constructor === Object || constructor === undefined;
}
/**
 * Ensure that something is an object.
 *
 * Turns `undefined` and `null` into `String`s and all other primitives into instances of their respective wrapper
 * classes (String, Boolean, Number, etc.). Acts as the identity function on non-primitives.
 *
 * @param wat The subject of the objectification
 * @returns A version of `wat` which can safely be used with `Object` class methods
 */ function $269eeb69635ed414$export$92b78acdbe066b6b(wat) {
    let objectified;
    switch(true){
        // this will catch both undefined and null
        case wat == undefined:
            objectified = new String(wat);
            break;
        // Though symbols and bigints do have wrapper classes (`Symbol` and `BigInt`, respectively), for whatever reason
        // those classes don't have constructors which can be used with the `new` keyword. We therefore need to cast each as
        // an object in order to wrap it.
        case typeof wat === 'symbol' || typeof wat === 'bigint':
            objectified = Object(wat);
            break;
        // this will catch the remaining primitives: `String`, `Number`, and `Boolean`
        case (0, $13cf2ed412f405fa$export$c3825b437cbdea5c)(wat):
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            objectified = new wat.constructor(wat);
            break;
        // by process of elimination, at this point we know that `wat` must already be an object
        default:
            objectified = wat;
            break;
    }
    return objectified;
}



// undefined = not yet resolved, null = no runner found, function = runner found
let $c80d7f6644a3b50b$var$RESOLVED_RUNNER;
/**
 * Simple wrapper that allows SDKs to *secretly* set context wrapper to generate safe random IDs in cache components contexts
 */ function $c80d7f6644a3b50b$export$ff239213cb80e2da(cb) {
    // Skips future symbol lookups if we've already resolved (or attempted to resolve) the runner once
    if ($c80d7f6644a3b50b$var$RESOLVED_RUNNER !== undefined) return $c80d7f6644a3b50b$var$RESOLVED_RUNNER ? $c80d7f6644a3b50b$var$RESOLVED_RUNNER(cb) : cb();
    const sym = Symbol.for('__SENTRY_SAFE_RANDOM_ID_WRAPPER__');
    const globalWithSymbol = (0, $736a69486c86d36c$export$f1a6cdb1459e81d1);
    if (sym in globalWithSymbol && typeof globalWithSymbol[sym] === 'function') {
        $c80d7f6644a3b50b$var$RESOLVED_RUNNER = globalWithSymbol[sym];
        return $c80d7f6644a3b50b$var$RESOLVED_RUNNER(cb);
    }
    $c80d7f6644a3b50b$var$RESOLVED_RUNNER = null;
    return cb();
}
/**
 * Identical to Math.random() but wrapped in withRandomSafeContext
 * to ensure safe random number generation in certain contexts (e.g., Next.js Cache Components).
 */ function $c80d7f6644a3b50b$export$9869d72de32a3917() {
    return $c80d7f6644a3b50b$export$ff239213cb80e2da(()=>Math.random());
}
/**
 * Identical to Date.now() but wrapped in withRandomSafeContext
 * to ensure safe time value generation in certain contexts (e.g., Next.js Cache Components).
 */ function $c80d7f6644a3b50b$export$65b1bada40c91b34() {
    return $c80d7f6644a3b50b$export$ff239213cb80e2da(()=>Date.now());
}



const $9ed2cf4edd0b2db9$var$STACKTRACE_FRAME_LIMIT = 50;
const $9ed2cf4edd0b2db9$export$27c7e15d453fc0ac = '?';
// Used to sanitize webpack (error: *) wrapped stack errors
const $9ed2cf4edd0b2db9$var$WEBPACK_ERROR_REGEXP = /\(error: (.*)\)/;
const $9ed2cf4edd0b2db9$var$STRIP_FRAME_REGEXP = /captureMessage|captureException/;
/**
 * Creates a stack parser with the supplied line parsers
 *
 * StackFrames are returned in the correct order for Sentry Exception
 * frames and with Sentry SDK internal frames removed from the top and bottom
 *
 */ function $9ed2cf4edd0b2db9$export$a5739666fb2d03d4(...parsers) {
    const sortedParsers = parsers.sort((a, b)=>a[0] - b[0]).map((p)=>p[1]);
    return (stack, skipFirstLines = 0, framesToPop = 0)=>{
        const frames = [];
        const lines = stack.split('\n');
        for(let i = skipFirstLines; i < lines.length; i++){
            let line = lines[i];
            // Truncate lines over 1kb because many of the regular expressions use
            // backtracking which results in run time that increases exponentially
            // with input size. Huge strings can result in hangs/Denial of Service:
            // https://github.com/getsentry/sentry-javascript/issues/2286
            if (line.length > 1024) line = line.slice(0, 1024);
            // https://github.com/getsentry/sentry-javascript/issues/5459
            // Remove webpack (error: *) wrappers
            const cleanedLine = $9ed2cf4edd0b2db9$var$WEBPACK_ERROR_REGEXP.test(line) ? line.replace($9ed2cf4edd0b2db9$var$WEBPACK_ERROR_REGEXP, '$1') : line;
            // https://github.com/getsentry/sentry-javascript/issues/7813
            // Skip Error: lines
            if (cleanedLine.match(/\S*Error: /)) continue;
            for (const parser of sortedParsers){
                const frame = parser(cleanedLine);
                if (frame) {
                    frames.push(frame);
                    break;
                }
            }
            if (frames.length >= $9ed2cf4edd0b2db9$var$STACKTRACE_FRAME_LIMIT + framesToPop) break;
        }
        return $9ed2cf4edd0b2db9$export$c55c24c0eeba0205(frames.slice(framesToPop));
    };
}
/**
 * Gets a stack parser implementation from Options.stackParser
 * @see Options
 *
 * If options contains an array of line parsers, it is converted into a parser
 */ function $9ed2cf4edd0b2db9$export$1d5cf88b347146d4(stackParser) {
    if (Array.isArray(stackParser)) return $9ed2cf4edd0b2db9$export$a5739666fb2d03d4(...stackParser);
    return stackParser;
}
/**
 * Removes Sentry frames from the top and bottom of the stack if present and enforces a limit of max number of frames.
 * Assumes stack input is ordered from top to bottom and returns the reverse representation so call site of the
 * function that caused the crash is the last frame in the array.
 * @hidden
 */ function $9ed2cf4edd0b2db9$export$c55c24c0eeba0205(stack) {
    if (!stack.length) return [];
    const localStack = Array.from(stack);
    // If stack starts with one of our API calls, remove it (starts, meaning it's the top of the stack - aka last call)
    if (/sentryWrapped/.test($9ed2cf4edd0b2db9$var$getLastStackFrame(localStack).function || '')) localStack.pop();
    // Reversing in the middle of the procedure allows us to just pop the values off the stack
    localStack.reverse();
    // If stack ends with one of our internal API calls, remove it (ends, meaning it's the bottom of the stack - aka top-most call)
    if ($9ed2cf4edd0b2db9$var$STRIP_FRAME_REGEXP.test($9ed2cf4edd0b2db9$var$getLastStackFrame(localStack).function || '')) {
        localStack.pop();
        // When using synthetic events, we will have a 2 levels deep stack, as `new Error('Sentry syntheticException')`
        // is produced within the scope itself, making it:
        //
        //   Sentry.captureException()
        //   scope.captureException()
        //
        // instead of just the top `Sentry` call itself.
        // This forces us to possibly strip an additional frame in the exact same was as above.
        if ($9ed2cf4edd0b2db9$var$STRIP_FRAME_REGEXP.test($9ed2cf4edd0b2db9$var$getLastStackFrame(localStack).function || '')) localStack.pop();
    }
    return localStack.slice(0, $9ed2cf4edd0b2db9$var$STACKTRACE_FRAME_LIMIT).map((frame)=>({
            ...frame,
            filename: frame.filename || $9ed2cf4edd0b2db9$var$getLastStackFrame(localStack).filename,
            function: frame.function || $9ed2cf4edd0b2db9$export$27c7e15d453fc0ac
        }));
}
function $9ed2cf4edd0b2db9$var$getLastStackFrame(arr) {
    return arr[arr.length - 1] || {};
}
const $9ed2cf4edd0b2db9$var$defaultFunctionName = '<anonymous>';
/**
 * Safely extract function name from itself
 */ function $9ed2cf4edd0b2db9$export$aad197c7121a6651(fn) {
    try {
        if (!fn || typeof fn !== 'function') return $9ed2cf4edd0b2db9$var$defaultFunctionName;
        return fn.name || $9ed2cf4edd0b2db9$var$defaultFunctionName;
    } catch  {
        // Just accessing custom props in some Selenium environments
        // can cause a "Permission denied" exception (see raven-js#495).
        return $9ed2cf4edd0b2db9$var$defaultFunctionName;
    }
}
/**
 * Get's stack frames from an event without needing to check for undefined properties.
 */ function $9ed2cf4edd0b2db9$export$91d8ca51bd9f6a47(event) {
    const exception = event.exception;
    if (exception) {
        const frames = [];
        try {
            // @ts-expect-error Object could be undefined
            exception.values.forEach((value)=>{
                // @ts-expect-error Value could be undefined
                if (value.stacktrace.frames) // @ts-expect-error Value could be undefined
                frames.push(...value.stacktrace.frames);
            });
            return frames;
        } catch  {
            return undefined;
        }
    }
    return undefined;
}
/**
 * Get the internal name of an internal Vue value, to represent it in a stacktrace.
 *
 * @param value The value to get the internal name of.
 */ function $9ed2cf4edd0b2db9$export$b6d9c5eb2330759f(value) {
    // Check if it's a VNode (has __v_isVNode) or a component instance (has _isVue/__isVue)
    const isVNode = '__v_isVNode' in value && value.__v_isVNode;
    return isVNode ? '[VueVNode]' : '[VueViewModel]';
}
/**
 * Normalizes stack line paths by removing file:// prefix and leading slashes for Windows paths
 */ function $9ed2cf4edd0b2db9$export$60c0d6c8e038267a(path) {
    let filename = path?.startsWith('file://') ? path.slice(7) : path;
    // If it's a Windows path, trim the leading slash so that `/C:/foo` becomes `C:/foo`
    if (filename?.match(/\/[A-Z]:/)) filename = filename.slice(1);
    return filename;
}


/**
 * Truncates given string to the maximum characters count
 *
 * @param str An object that contains serializable values
 * @param max Maximum number of characters in truncated string (0 = unlimited)
 * @returns string Encoded
 */ function $e534db390d1e4996$export$6a506b36fdea397d(str, max = 0) {
    if (typeof str !== 'string' || max === 0) return str;
    return str.length <= max ? str : `${str.slice(0, max)}...`;
}
/**
 * This is basically just `trim_line` from
 * https://github.com/getsentry/sentry/blob/master/src/sentry/lang/javascript/processor.py#L67
 *
 * @param str An object that contains serializable values
 * @param max Maximum number of characters in truncated string
 * @returns string Encoded
 */ function $e534db390d1e4996$export$4215662d762d6f9d(line, colno) {
    let newLine = line;
    const lineLength = newLine.length;
    if (lineLength <= 150) return newLine;
    if (colno > lineLength) // eslint-disable-next-line no-param-reassign
    colno = lineLength;
    let start = Math.max(colno - 60, 0);
    if (start < 5) start = 0;
    let end = Math.min(start + 140, lineLength);
    if (end > lineLength - 5) end = lineLength;
    if (end === lineLength) start = Math.max(end - 140, 0);
    newLine = newLine.slice(start, end);
    if (start > 0) newLine = `'{snip} ${newLine}`;
    if (end < lineLength) newLine += ' {snip}';
    return newLine;
}
/**
 * Join values in array
 * @param input array of values to be joined together
 * @param delimiter string to be placed in-between values
 * @returns Joined values
 */ function $e534db390d1e4996$export$465e9d514283d4fd(input, delimiter) {
    if (!Array.isArray(input)) return '';
    const output = [];
    // eslint-disable-next-line typescript/prefer-for-of
    for(let i = 0; i < input.length; i++){
        const value = input[i];
        try {
            // This is a hack to fix a Vue3-specific bug that causes an infinite loop of
            // console warnings. This happens when a Vue template is rendered with
            // an undeclared variable, which we try to stringify, ultimately causing
            // Vue to issue another warning which repeats indefinitely.
            // see: https://github.com/getsentry/sentry-javascript/pull/8981
            if ((0, $13cf2ed412f405fa$export$7916fad0ebc23f48)(value)) output.push((0, $9ed2cf4edd0b2db9$export$b6d9c5eb2330759f)(value));
            else output.push(String(value));
        } catch  {
            output.push('[value cannot be serialized]');
        }
    }
    return output.join(delimiter);
}
/**
 * Checks if the given value matches a regex or string
 *
 * @param value The string to test
 * @param pattern Either a regex or a string against which `value` will be matched
 * @param requireExactStringMatch If true, `value` must match `pattern` exactly. If false, `value` will match
 * `pattern` if it contains `pattern`. Only applies to string-type patterns.
 */ function $e534db390d1e4996$export$cdded5b28a5f8c6d(value, pattern, requireExactStringMatch = false) {
    if (!(0, $13cf2ed412f405fa$export$844ec244b1367d54)(value)) return false;
    if ((0, $13cf2ed412f405fa$export$49841c62b9eff15)(pattern)) return pattern.test(value);
    if ((0, $13cf2ed412f405fa$export$844ec244b1367d54)(pattern)) return requireExactStringMatch ? value === pattern : value.includes(pattern);
    return false;
}
/**
 * Test the given string against an array of strings and regexes. By default, string matching is done on a
 * substring-inclusion basis rather than a strict equality basis
 *
 * @param testString The string to test
 * @param patterns The patterns against which to test the string
 * @param requireExactStringMatch If true, `testString` must match one of the given string patterns exactly in order to
 * count. If false, `testString` will match a string pattern if it contains that pattern.
 * @returns
 */ function $e534db390d1e4996$export$a7a5ec66062ea5d(testString, patterns = [], requireExactStringMatch = false) {
    return patterns.some((pattern)=>$e534db390d1e4996$export$cdded5b28a5f8c6d(testString, pattern, requireExactStringMatch));
}



function $cc262db35458e4b3$var$getCrypto() {
    const gbl = (0, $736a69486c86d36c$export$f1a6cdb1459e81d1);
    return gbl.crypto || gbl.msCrypto;
}
let $cc262db35458e4b3$var$emptyUuid;
function $cc262db35458e4b3$var$getRandomByte() {
    return (0, $c80d7f6644a3b50b$export$9869d72de32a3917)() * 16;
}
/**
 * UUID4 generator
 * @param crypto Object that provides the crypto API.
 * @returns string Generated UUID4.
 */ function $cc262db35458e4b3$export$19f53698e68b2496(crypto = $cc262db35458e4b3$var$getCrypto()) {
    try {
        if (crypto?.randomUUID) // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        return (0, $c80d7f6644a3b50b$export$ff239213cb80e2da)(()=>crypto.randomUUID()).replace(/-/g, '');
    } catch  {
    // some runtimes can crash invoking crypto
    // https://github.com/getsentry/sentry-javascript/issues/8935
    }
    if (!$cc262db35458e4b3$var$emptyUuid) // http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript/2117523#2117523
    // Concatenating the following numbers as strings results in '10000000100040008000100000000000'
    $cc262db35458e4b3$var$emptyUuid = "10000000100040008000100000000000";
    return $cc262db35458e4b3$var$emptyUuid.replace(/[018]/g, (c)=>// eslint-disable-next-line no-bitwise
        (c ^ ($cc262db35458e4b3$var$getRandomByte() & 15) >> c / 4).toString(16));
}
function $cc262db35458e4b3$var$getFirstException(event) {
    return event.exception?.values?.[0];
}
/**
 * Extracts either message or type+value from an event that can be used for user-facing logs
 * @returns event's description
 */ function $cc262db35458e4b3$export$4157119e2b157127(event) {
    const { message: message, event_id: eventId } = event;
    if (message) return message;
    const firstException = $cc262db35458e4b3$var$getFirstException(event);
    if (firstException) {
        if (firstException.type && firstException.value) return `${firstException.type}: ${firstException.value}`;
        return firstException.type || firstException.value || eventId || '<unknown>';
    }
    return eventId || '<unknown>';
}
/**
 * Adds exception values, type and value to an synthetic Exception.
 * @param event The event to modify.
 * @param value Value of the exception.
 * @param type Type of the exception.
 * @hidden
 */ function $cc262db35458e4b3$export$f26508487bf83ee7(event, value, type) {
    const exception = event.exception = event.exception || {};
    const values = exception.values = exception.values || [];
    const firstException = values[0] = values[0] || {};
    if (!firstException.value) firstException.value = value || '';
    if (!firstException.type) firstException.type = type || 'Error';
}
/**
 * Adds exception mechanism data to a given event. Uses defaults if the second parameter is not passed.
 *
 * @param event The event to modify.
 * @param newMechanism Mechanism data to add to the event.
 * @hidden
 */ function $cc262db35458e4b3$export$c69a9a0313b03bb1(event, newMechanism) {
    const firstException = $cc262db35458e4b3$var$getFirstException(event);
    if (!firstException) return;
    const defaultMechanism = {
        type: 'generic',
        handled: true
    };
    const currentMechanism = firstException.mechanism;
    firstException.mechanism = {
        ...defaultMechanism,
        ...currentMechanism,
        ...newMechanism
    };
    if (newMechanism && 'data' in newMechanism) {
        const mergedData = {
            ...currentMechanism?.data,
            ...newMechanism.data
        };
        firstException.mechanism.data = mergedData;
    }
}
// https://semver.org/#is-there-a-suggested-regular-expression-regex-to-check-a-semver-string
const $cc262db35458e4b3$var$SEMVER_REGEXP = /^(0|[1-9]\d*)\.(0|[1-9]\d*)\.(0|[1-9]\d*)(?:-((?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*)(?:\.(?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*))*))?(?:\+([0-9a-zA-Z-]+(?:\.[0-9a-zA-Z-]+)*))?$/;
/**
 * Represents Semantic Versioning object
 */ function $cc262db35458e4b3$var$_parseInt(input) {
    return parseInt(input || '', 10);
}
/**
 * Parses input into a SemVer interface
 * @param input string representation of a semver version
 */ function $cc262db35458e4b3$export$d364f2020ab30578(input) {
    const match = input.match($cc262db35458e4b3$var$SEMVER_REGEXP) || [];
    const major = $cc262db35458e4b3$var$_parseInt(match[1]);
    const minor = $cc262db35458e4b3$var$_parseInt(match[2]);
    const patch = $cc262db35458e4b3$var$_parseInt(match[3]);
    return {
        buildmetadata: match[5],
        major: isNaN(major) ? undefined : major,
        minor: isNaN(minor) ? undefined : minor,
        patch: isNaN(patch) ? undefined : patch,
        prerelease: match[4]
    };
}
/**
 * This function adds context (pre/post/line) lines to the provided frame
 *
 * @param lines string[] containing all lines
 * @param frame StackFrame that will be mutated
 * @param linesOfContext number of context lines we want to add pre/post
 */ function $cc262db35458e4b3$export$ec2291bfc64632f0(lines, frame, linesOfContext = 5) {
    // When there is no line number in the frame, attaching context is nonsensical and will even break grouping
    if (frame.lineno === undefined) return;
    const maxLines = lines.length;
    const sourceLine = Math.max(Math.min(maxLines - 1, frame.lineno - 1), 0);
    frame.pre_context = lines.slice(Math.max(0, sourceLine - linesOfContext), sourceLine).map((line)=>(0, $e534db390d1e4996$export$4215662d762d6f9d)(line, 0));
    // We guard here to ensure this is not larger than the existing number of lines
    const lineIndex = Math.min(maxLines - 1, sourceLine);
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    frame.context_line = (0, $e534db390d1e4996$export$4215662d762d6f9d)(lines[lineIndex], frame.colno || 0);
    frame.post_context = lines.slice(Math.min(sourceLine + 1, maxLines), sourceLine + 1 + linesOfContext).map((line)=>(0, $e534db390d1e4996$export$4215662d762d6f9d)(line, 0));
}
/**
 * Checks whether or not we've already captured the given exception (note: not an identical exception - the very object
 * in question), and marks it captured if not.
 *
 * This is useful because it's possible for an error to get captured by more than one mechanism. After we intercept and
 * record an error, we rethrow it (assuming we've intercepted it before it's reached the top-level global handlers), so
 * that we don't interfere with whatever effects the error might have had were the SDK not there. At that point, because
 * the error has been rethrown, it's possible for it to bubble up to some other code we've instrumented. If it's not
 * caught after that, it will bubble all the way up to the global handlers (which of course we also instrument). This
 * function helps us ensure that even if we encounter the same error more than once, we only record it the first time we
 * see it.
 *
 * Note: It will ignore primitives (always return `false` and not mark them as seen), as properties can't be set on
 * them. {@link: Object.objectify} can be used on exceptions to convert any that are primitives into their equivalent
 * object wrapper forms so that this check will always work. However, because we need to flag the exact object which
 * will get rethrown, and because that rethrowing happens outside of the event processing pipeline, the objectification
 * must be done before the exception captured.
 *
 * @param A thrown exception to check or flag as having been seen
 * @returns `true` if the exception has already been captured, `false` if not (with the side effect of marking it seen)
 */ function $cc262db35458e4b3$export$6de4ffac6a2f1098(exception) {
    if ($cc262db35458e4b3$export$4a38e013f66150b(exception)) return true;
    try {
        // set it this way rather than by assignment so that it's not ennumerable and therefore isn't recorded by the
        // `ExtraErrorData` integration
        (0, $269eeb69635ed414$export$e73679ffaf56810e)(exception, '__sentry_captured__', true);
    } catch  {
    // `exception` is a primitive, so we can't mark it seen
    }
    return false;
}
/**
 * Checks whether we've already captured the given exception (note: not an identical exception - the very object).
 * It is considered already captured if it has the `__sentry_captured__` property set to `true`.
 *
 * @internal Only considered for internal usage
 */ function $cc262db35458e4b3$export$4a38e013f66150b(exception) {
    try {
        return exception.__sentry_captured__;
    } catch  {} // eslint-disable-line no-empty
}




const $bc81602376c48fa6$var$ONE_SECOND_IN_MS = 1000;
/**
 * A partial definition of the [Performance Web API]{@link https://developer.mozilla.org/en-US/docs/Web/API/Performance}
 * for accessing a high-resolution monotonic clock.
 */ /**
 * Returns a timestamp in seconds since the UNIX epoch using the Date API.
 */ function $bc81602376c48fa6$export$7740643b9eeaf0c4() {
    return (0, $c80d7f6644a3b50b$export$65b1bada40c91b34)() / $bc81602376c48fa6$var$ONE_SECOND_IN_MS;
}
/**
 * Returns a wrapper around the native Performance API browser implementation, or undefined for browsers that do not
 * support the API.
 *
 * Wrapping the native API works around differences in behavior from different browsers.
 */ function $bc81602376c48fa6$var$createUnixTimestampInSecondsFunc() {
    const { performance: performance } = (0, $736a69486c86d36c$export$f1a6cdb1459e81d1);
    // Some browser and environments don't have a performance or timeOrigin, so we fallback to
    // using Date.now() to compute the starting time.
    if (!performance?.now || !performance.timeOrigin) return $bc81602376c48fa6$export$7740643b9eeaf0c4;
    const timeOrigin = performance.timeOrigin;
    // performance.now() is a monotonic clock, which means it starts at 0 when the process begins. To get the current
    // wall clock time (actual UNIX timestamp), we need to add the starting time origin and the current time elapsed.
    //
    // TODO: This does not account for the case where the monotonic clock that powers performance.now() drifts from the
    // wall clock time, which causes the returned timestamp to be inaccurate. We should investigate how to detect and
    // correct for this.
    // See: https://github.com/getsentry/sentry-javascript/issues/2590
    // See: https://github.com/mdn/content/issues/4713
    // See: https://dev.to/noamr/when-a-millisecond-is-not-a-millisecond-3h6
    return ()=>{
        return (timeOrigin + (0, $c80d7f6644a3b50b$export$ff239213cb80e2da)(()=>performance.now())) / $bc81602376c48fa6$var$ONE_SECOND_IN_MS;
    };
}
let $bc81602376c48fa6$var$_cachedTimestampInSeconds;
/**
 * Returns a timestamp in seconds since the UNIX epoch using either the Performance or Date APIs, depending on the
 * availability of the Performance API.
 *
 * BUG: Note that because of how browsers implement the Performance API, the clock might stop when the computer is
 * asleep. This creates a skew between `dateTimestampInSeconds` and `timestampInSeconds`. The
 * skew can grow to arbitrary amounts like days, weeks or months.
 * See https://github.com/getsentry/sentry-javascript/issues/2590.
 */ function $bc81602376c48fa6$export$ee52dced521e3e18() {
    // We store this in a closure so that we don't have to create a new function every time this is called.
    const func = $bc81602376c48fa6$var$_cachedTimestampInSeconds ?? ($bc81602376c48fa6$var$_cachedTimestampInSeconds = $bc81602376c48fa6$var$createUnixTimestampInSecondsFunc());
    return func();
}
/**
 * Cached result of getBrowserTimeOrigin.
 */ let $bc81602376c48fa6$var$cachedTimeOrigin = null;
/**
 * Gets the time origin and the mode used to determine it.
 *
 * Unfortunately browsers may report an inaccurate time origin data, through either performance.timeOrigin or
 * performance.timing.navigationStart, which results in poor results in performance data. We only treat time origin
 * data as reliable if they are within a reasonable threshold of the current time.
 *
 * TODO: move to `@sentry/browser-utils` package.
 */ function $bc81602376c48fa6$var$getBrowserTimeOrigin() {
    const { performance: performance } = (0, $736a69486c86d36c$export$f1a6cdb1459e81d1);
    if (!performance?.now) return undefined;
    const threshold = 300000; // 5 minutes in milliseconds
    const performanceNow = (0, $c80d7f6644a3b50b$export$ff239213cb80e2da)(()=>performance.now());
    const dateNow = (0, $c80d7f6644a3b50b$export$65b1bada40c91b34)();
    const timeOrigin = performance.timeOrigin;
    if (typeof timeOrigin === 'number') {
        const timeOriginDelta = Math.abs(timeOrigin + performanceNow - dateNow);
        if (timeOriginDelta < threshold) return timeOrigin;
    }
    // TODO: Remove all code related to `performance.timing.navigationStart` once we drop support for Safari 14.
    // `performance.timeSince` is available in Safari 15.
    // see: https://caniuse.com/mdn-api_performance_timeorigin
    // While performance.timing.navigationStart is deprecated in favor of performance.timeOrigin, performance.timeOrigin
    // is not as widely supported. Namely, performance.timeOrigin is undefined in Safari as of writing.
    // Also as of writing, performance.timing is not available in Web Workers in mainstream browsers, so it is not always
    // a valid fallback. In the absence of an initial time provided by the browser, fallback to the current time from the
    // Date API.
    // eslint-disable-next-line deprecation/deprecation
    const navigationStart = performance.timing?.navigationStart;
    if (typeof navigationStart === 'number') {
        const navigationStartDelta = Math.abs(navigationStart + performanceNow - dateNow);
        if (navigationStartDelta < threshold) return navigationStart;
    }
    // Either both timeOrigin and navigationStart are skewed or neither is available, fallback to subtracting
    // `performance.now()` from `Date.now()`.
    return dateNow - performanceNow;
}
/**
 * The number of milliseconds since the UNIX epoch. This value is only usable in a browser, and only when the
 * performance API is available.
 */ function $bc81602376c48fa6$export$baf075a948ffc0bf() {
    if ($bc81602376c48fa6$var$cachedTimeOrigin === null) $bc81602376c48fa6$var$cachedTimeOrigin = $bc81602376c48fa6$var$getBrowserTimeOrigin();
    return $bc81602376c48fa6$var$cachedTimeOrigin;
}


/**
 * Creates a new `Session` object by setting certain default parameters. If optional @param context
 * is passed, the passed properties are applied to the session object.
 *
 * @param context (optional) additional properties to be applied to the returned session object
 *
 * @returns a new `Session` object
 */ function $e6ef9757665bd407$export$14a186326edbb264(context) {
    // Both timestamp and started are in seconds since the UNIX epoch.
    const startingTime = (0, $bc81602376c48fa6$export$ee52dced521e3e18)();
    const session = {
        sid: (0, $cc262db35458e4b3$export$19f53698e68b2496)(),
        init: true,
        timestamp: startingTime,
        started: startingTime,
        duration: 0,
        status: 'ok',
        errors: 0,
        ignoreDuration: false,
        toJSON: ()=>$e6ef9757665bd407$var$sessionToJSON(session)
    };
    if (context) $e6ef9757665bd407$export$531818e825e774db(session, context);
    return session;
}
/**
 * Updates a session object with the properties passed in the context.
 *
 * Note that this function mutates the passed object and returns void.
 * (Had to do this instead of returning a new and updated session because closing and sending a session
 * makes an update to the session after it was passed to the sending logic.
 * @see Client.captureSession )
 *
 * @param session the `Session` to update
 * @param context the `SessionContext` holding the properties that should be updated in @param session
 */ // eslint-disable-next-line complexity
function $e6ef9757665bd407$export$531818e825e774db(session, context = {}) {
    if (context.user) {
        if (!session.ipAddress && context.user.ip_address) session.ipAddress = context.user.ip_address;
        if (!session.did && !context.did) session.did = context.user.id || context.user.email || context.user.username;
    }
    session.timestamp = context.timestamp || (0, $bc81602376c48fa6$export$ee52dced521e3e18)();
    if (context.abnormal_mechanism) session.abnormal_mechanism = context.abnormal_mechanism;
    if (context.ignoreDuration) session.ignoreDuration = context.ignoreDuration;
    if (context.sid) // Good enough uuid validation. — Kamil
    session.sid = context.sid.length === 32 ? context.sid : (0, $cc262db35458e4b3$export$19f53698e68b2496)();
    if (context.init !== undefined) session.init = context.init;
    if (!session.did && context.did) session.did = `${context.did}`;
    if (typeof context.started === 'number') session.started = context.started;
    if (session.ignoreDuration) session.duration = undefined;
    else if (typeof context.duration === 'number') session.duration = context.duration;
    else {
        const duration = session.timestamp - session.started;
        session.duration = duration >= 0 ? duration : 0;
    }
    if (context.release) session.release = context.release;
    if (context.environment) session.environment = context.environment;
    if (!session.ipAddress && context.ipAddress) session.ipAddress = context.ipAddress;
    if (!session.userAgent && context.userAgent) session.userAgent = context.userAgent;
    if (typeof context.errors === 'number') session.errors = context.errors;
    if (context.status) session.status = context.status;
}
/**
 * Closes a session by setting its status and updating the session object with it.
 * Internally calls `updateSession` to update the passed session object.
 *
 * Note that this function mutates the passed session (@see updateSession for explanation).
 *
 * @param session the `Session` object to be closed
 * @param status the `SessionStatus` with which the session was closed. If you don't pass a status,
 *               this function will keep the previously set status, unless it was `'ok'` in which case
 *               it is changed to `'exited'`.
 */ function $e6ef9757665bd407$export$56521d9ba90f62ee(session, status) {
    let context = {};
    if (status) context = {
        status: status
    };
    else if (session.status === 'ok') context = {
        status: 'exited'
    };
    $e6ef9757665bd407$export$531818e825e774db(session, context);
}
/**
 * Serializes a passed session object to a JSON object with a slightly different structure.
 * This is necessary because the Sentry backend requires a slightly different schema of a session
 * than the one the JS SDKs use internally.
 *
 * @param session the session to be converted
 *
 * @returns a JSON object of the passed session
 */ function $e6ef9757665bd407$var$sessionToJSON(session) {
    return {
        sid: `${session.sid}`,
        init: session.init,
        // Make sure that sec is converted to ms for date constructor
        started: new Date(session.started * 1000).toISOString(),
        timestamp: new Date(session.timestamp * 1000).toISOString(),
        status: session.status,
        errors: session.errors,
        did: typeof session.did === 'number' || typeof session.did === 'string' ? `${session.did}` : undefined,
        duration: session.duration,
        abnormal_mechanism: session.abnormal_mechanism,
        attrs: {
            release: session.release,
            environment: session.environment,
            ip_address: session.ipAddress,
            user_agent: session.userAgent
        }
    };
}




/**
 * Shallow merge two objects.
 * Does not mutate the passed in objects.
 * Undefined/empty values in the merge object will overwrite existing values.
 *
 * By default, this merges 2 levels deep.
 */ function $40b0d31022c415bf$export$4950aa0f605343fb(initialObj, mergeObj, levels = 2) {
    // If the merge value is not an object, or we have no merge levels left,
    // we just set the value to the merge value
    if (!mergeObj || typeof mergeObj !== 'object' || levels <= 0) return mergeObj;
    // If the merge object is an empty object, and the initial object is not undefined, we return the initial object
    if (initialObj && Object.keys(mergeObj).length === 0) return initialObj;
    // Clone object
    const output = {
        ...initialObj
    };
    // Merge values into output, resursively
    for(const key in mergeObj)if (Object.prototype.hasOwnProperty.call(mergeObj, key)) output[key] = $40b0d31022c415bf$export$4950aa0f605343fb(output[key], mergeObj[key], levels - 1);
    return output;
}




/**
 * Generate a random, valid trace ID.
 */ function $ece9bac57decbcb8$export$dc6d7ea554bcce10() {
    return (0, $cc262db35458e4b3$export$19f53698e68b2496)();
}
/**
 * Generate a random, valid span ID.
 */ function $ece9bac57decbcb8$export$295213bc4d0c54ad() {
    return (0, $cc262db35458e4b3$export$19f53698e68b2496)().substring(16);
}




const $dab1970d0c142a42$var$SCOPE_SPAN_FIELD = '_sentrySpan';
/**
 * Set the active span for a given scope.
 * NOTE: This should NOT be used directly, but is only used internally by the trace methods.
 */ function $dab1970d0c142a42$export$3f25fa50c18e20ca(scope, span) {
    if (span) (0, $269eeb69635ed414$export$e73679ffaf56810e)(scope, $dab1970d0c142a42$var$SCOPE_SPAN_FIELD, span);
    else // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
    delete scope[$dab1970d0c142a42$var$SCOPE_SPAN_FIELD];
}
/**
 * Get the active span for a given scope.
 * NOTE: This should NOT be used directly, but is only used internally by the trace methods.
 */ function $dab1970d0c142a42$export$91f063ebb8eff307(scope) {
    return scope[$dab1970d0c142a42$var$SCOPE_SPAN_FIELD];
}




/**
 * Default value for maximum number of breadcrumbs added to an event.
 */ const $dd23bca0e7d7618a$var$DEFAULT_MAX_BREADCRUMBS = 100;
/**
 * A context to be used for capturing an event.
 * This can either be a Scope, or a partial ScopeContext,
 * or a callback that receives the current scope and returns a new scope to use.
 */ /**
 * Holds additional event information.
 */ class $dd23bca0e7d7618a$export$775b6bb06e53a214 {
    /** Flag if notifying is happening. */ /** Callback for client to receive scope changes. */ /** Callback list that will be called during event processing. */ /** Array of breadcrumbs. */ /** User */ /** Tags */ /** Attributes */ /** Extra */ /** Contexts */ /** Attachments */ /** Propagation Context for distributed tracing */ /**
   * A place to stash data which is needed at some point in the SDK's event processing pipeline but which shouldn't get
   * sent to Sentry
   */ /** Fingerprint */ /** Severity */ /**
   * Transaction Name
   *
   * IMPORTANT: The transaction name on the scope has nothing to do with root spans/transaction objects.
   * It's purpose is to assign a transaction to the scope that's added to non-transaction events.
   */ /** Session */ /** The client on this scope */ /** Contains the last event id of a captured event.  */ /** Conversation ID */ // NOTE: Any field which gets added here should get added not only to the constructor but also to the `clone` method.
    constructor(){
        this._notifyingListeners = false;
        this._scopeListeners = [];
        this._eventProcessors = [];
        this._breadcrumbs = [];
        this._attachments = [];
        this._user = {};
        this._tags = {};
        this._attributes = {};
        this._extra = {};
        this._contexts = {};
        this._sdkProcessingMetadata = {};
        this._propagationContext = {
            traceId: (0, $ece9bac57decbcb8$export$dc6d7ea554bcce10)(),
            sampleRand: (0, $c80d7f6644a3b50b$export$9869d72de32a3917)()
        };
    }
    /**
   * Clone all data from this scope into a new scope.
   */ clone() {
        const newScope = new $dd23bca0e7d7618a$export$775b6bb06e53a214();
        newScope._breadcrumbs = [
            ...this._breadcrumbs
        ];
        newScope._tags = {
            ...this._tags
        };
        newScope._attributes = {
            ...this._attributes
        };
        newScope._extra = {
            ...this._extra
        };
        newScope._contexts = {
            ...this._contexts
        };
        if (this._contexts.flags) // We need to copy the `values` array so insertions on a cloned scope
        // won't affect the original array.
        newScope._contexts.flags = {
            values: [
                ...this._contexts.flags.values
            ]
        };
        newScope._user = this._user;
        newScope._level = this._level;
        newScope._session = this._session;
        newScope._transactionName = this._transactionName;
        newScope._fingerprint = this._fingerprint;
        newScope._eventProcessors = [
            ...this._eventProcessors
        ];
        newScope._attachments = [
            ...this._attachments
        ];
        newScope._sdkProcessingMetadata = {
            ...this._sdkProcessingMetadata
        };
        newScope._propagationContext = {
            ...this._propagationContext
        };
        newScope._client = this._client;
        newScope._lastEventId = this._lastEventId;
        newScope._conversationId = this._conversationId;
        (0, $dab1970d0c142a42$export$3f25fa50c18e20ca)(newScope, (0, $dab1970d0c142a42$export$91f063ebb8eff307)(this));
        return newScope;
    }
    /**
   * Update the client assigned to this scope.
   * Note that not every scope will have a client assigned - isolation scopes & the global scope will generally not have a client,
   * as well as manually created scopes.
   */ setClient(client) {
        this._client = client;
    }
    /**
   * Set the ID of the last captured error event.
   * This is generally only captured on the isolation scope.
   */ setLastEventId(lastEventId) {
        this._lastEventId = lastEventId;
    }
    /**
   * Get the client assigned to this scope.
   */ getClient() {
        return this._client;
    }
    /**
   * Get the ID of the last captured error event.
   * This is generally only available on the isolation scope.
   */ lastEventId() {
        return this._lastEventId;
    }
    /**
   * @inheritDoc
   */ addScopeListener(callback) {
        this._scopeListeners.push(callback);
    }
    /**
   * Add an event processor that will be called before an event is sent.
   */ addEventProcessor(callback) {
        this._eventProcessors.push(callback);
        return this;
    }
    /**
   * Set the user for this scope.
   * Set to `null` to unset the user.
   */ setUser(user) {
        // If null is passed we want to unset everything, but still define keys,
        // so that later down in the pipeline any existing values are cleared.
        this._user = user || {
            email: undefined,
            id: undefined,
            ip_address: undefined,
            username: undefined
        };
        if (this._session) (0, $e6ef9757665bd407$export$531818e825e774db)(this._session, {
            user: user
        });
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Get the user from this scope.
   */ getUser() {
        return this._user;
    }
    /**
   * Set the conversation ID for this scope.
   * Set to `null` to unset the conversation ID.
   */ setConversationId(conversationId) {
        this._conversationId = conversationId || undefined;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Set an object that will be merged into existing tags on the scope,
   * and will be sent as tags data with the event.
   */ setTags(tags) {
        this._tags = {
            ...this._tags,
            ...tags
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Set a single tag that will be sent as tags data with the event.
   */ setTag(key, value) {
        return this.setTags({
            [key]: value
        });
    }
    /**
   * Sets attributes onto the scope.
   *
   * These attributes are currently applied to logs and metrics.
   * In the future, they will also be applied to spans.
   *
   * Important: For now, only strings, numbers and boolean attributes are supported, despite types allowing for
   * more complex attribute types. We'll add this support in the future but already specify the wider type to
   * avoid a breaking change in the future.
   *
   * @param newAttributes - The attributes to set on the scope. You can either pass in key-value pairs, or
   * an object with a `value` and an optional `unit` (if applicable to your attribute).
   *
   * @example
   * ```typescript
   * scope.setAttributes({
   *   is_admin: true,
   *   payment_selection: 'credit_card',
   *   render_duration: { value: 'render_duration', unit: 'ms' },
   * });
   * ```
   */ setAttributes(newAttributes) {
        this._attributes = {
            ...this._attributes,
            ...newAttributes
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Sets an attribute onto the scope.
   *
   * These attributes are currently applied to logs and metrics.
   * In the future, they will also be applied to spans.
   *
   * Important: For now, only strings, numbers and boolean attributes are supported, despite types allowing for
   * more complex attribute types. We'll add this support in the future but already specify the wider type to
   * avoid a breaking change in the future.
   *
   * @param key - The attribute key.
   * @param value - the attribute value. You can either pass in a raw value, or an attribute
   * object with a `value` and an optional `unit` (if applicable to your attribute).
   *
   * @example
   * ```typescript
   * scope.setAttribute('is_admin', true);
   * scope.setAttribute('render_duration', { value: 'render_duration', unit: 'ms' });
   * ```
   */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    setAttribute(key, value) {
        return this.setAttributes({
            [key]: value
        });
    }
    /**
   * Removes the attribute with the given key from the scope.
   *
   * @param key - The attribute key.
   *
   * @example
   * ```typescript
   * scope.removeAttribute('is_admin');
   * ```
   */ removeAttribute(key) {
        if (key in this._attributes) {
            // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
            delete this._attributes[key];
            this._notifyScopeListeners();
        }
        return this;
    }
    /**
   * Set an object that will be merged into existing extra on the scope,
   * and will be sent as extra data with the event.
   */ setExtras(extras) {
        this._extra = {
            ...this._extra,
            ...extras
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Set a single key:value extra entry that will be sent as extra data with the event.
   */ setExtra(key, extra) {
        this._extra = {
            ...this._extra,
            [key]: extra
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Sets the fingerprint on the scope to send with the events.
   * @param {string[]} fingerprint Fingerprint to group events in Sentry.
   */ setFingerprint(fingerprint) {
        this._fingerprint = fingerprint;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Sets the level on the scope for future events.
   */ setLevel(level) {
        this._level = level;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Sets the transaction name on the scope so that the name of e.g. taken server route or
   * the page location is attached to future events.
   *
   * IMPORTANT: Calling this function does NOT change the name of the currently active
   * root span. If you want to change the name of the active root span, use
   * `Sentry.updateSpanName(rootSpan, 'new name')` instead.
   *
   * By default, the SDK updates the scope's transaction name automatically on sensible
   * occasions, such as a page navigation or when handling a new request on the server.
   */ setTransactionName(name) {
        this._transactionName = name;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Sets context data with the given name.
   * Data passed as context will be normalized. You can also pass `null` to unset the context.
   * Note that context data will not be merged - calling `setContext` will overwrite an existing context with the same key.
   */ setContext(key, context) {
        if (context === null) // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
        delete this._contexts[key];
        else this._contexts[key] = context;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Set the session for the scope.
   */ setSession(session) {
        if (!session) delete this._session;
        else this._session = session;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Get the session from the scope.
   */ getSession() {
        return this._session;
    }
    /**
   * Updates the scope with provided data. Can work in three variations:
   * - plain object containing updatable attributes
   * - Scope instance that'll extract the attributes from
   * - callback function that'll receive the current scope as an argument and allow for modifications
   */ update(captureContext) {
        if (!captureContext) return this;
        const scopeToMerge = typeof captureContext === 'function' ? captureContext(this) : captureContext;
        const scopeInstance = scopeToMerge instanceof $dd23bca0e7d7618a$export$775b6bb06e53a214 ? scopeToMerge.getScopeData() : (0, $13cf2ed412f405fa$export$53b83ca8eaab0383)(scopeToMerge) ? captureContext : undefined;
        const { tags: tags, attributes: attributes, extra: extra, user: user, contexts: contexts, level: level, fingerprint: fingerprint = [], propagationContext: propagationContext, conversationId: conversationId } = scopeInstance || {};
        this._tags = {
            ...this._tags,
            ...tags
        };
        this._attributes = {
            ...this._attributes,
            ...attributes
        };
        this._extra = {
            ...this._extra,
            ...extra
        };
        this._contexts = {
            ...this._contexts,
            ...contexts
        };
        if (user && Object.keys(user).length) this._user = user;
        if (level) this._level = level;
        if (fingerprint.length) this._fingerprint = fingerprint;
        if (propagationContext) this._propagationContext = propagationContext;
        if (conversationId) this._conversationId = conversationId;
        return this;
    }
    /**
   * Clears the current scope and resets its properties.
   * Note: The client will not be cleared.
   */ clear() {
        // client is not cleared here on purpose!
        this._breadcrumbs = [];
        this._tags = {};
        this._attributes = {};
        this._extra = {};
        this._user = {};
        this._contexts = {};
        this._level = undefined;
        this._transactionName = undefined;
        this._fingerprint = undefined;
        this._session = undefined;
        this._conversationId = undefined;
        (0, $dab1970d0c142a42$export$3f25fa50c18e20ca)(this, undefined);
        this._attachments = [];
        this.setPropagationContext({
            traceId: (0, $ece9bac57decbcb8$export$dc6d7ea554bcce10)(),
            sampleRand: (0, $c80d7f6644a3b50b$export$9869d72de32a3917)()
        });
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Adds a breadcrumb to the scope.
   * By default, the last 100 breadcrumbs are kept.
   */ addBreadcrumb(breadcrumb, maxBreadcrumbs) {
        const maxCrumbs = typeof maxBreadcrumbs === 'number' ? maxBreadcrumbs : $dd23bca0e7d7618a$var$DEFAULT_MAX_BREADCRUMBS;
        // No data has been changed, so don't notify scope listeners
        if (maxCrumbs <= 0) return this;
        const mergedBreadcrumb = {
            timestamp: (0, $bc81602376c48fa6$export$7740643b9eeaf0c4)(),
            ...breadcrumb,
            // Breadcrumb messages can theoretically be infinitely large and they're held in memory so we truncate them not to leak (too much) memory
            message: breadcrumb.message ? (0, $e534db390d1e4996$export$6a506b36fdea397d)(breadcrumb.message, 2048) : breadcrumb.message
        };
        this._breadcrumbs.push(mergedBreadcrumb);
        if (this._breadcrumbs.length > maxCrumbs) {
            this._breadcrumbs = this._breadcrumbs.slice(-maxCrumbs);
            this._client?.recordDroppedEvent('buffer_overflow', 'log_item');
        }
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Get the last breadcrumb of the scope.
   */ getLastBreadcrumb() {
        return this._breadcrumbs[this._breadcrumbs.length - 1];
    }
    /**
   * Clear all breadcrumbs from the scope.
   */ clearBreadcrumbs() {
        this._breadcrumbs = [];
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Add an attachment to the scope.
   */ addAttachment(attachment) {
        this._attachments.push(attachment);
        return this;
    }
    /**
   * Clear all attachments from the scope.
   */ clearAttachments() {
        this._attachments = [];
        return this;
    }
    /**
   * Get the data of this scope, which should be applied to an event during processing.
   */ getScopeData() {
        return {
            breadcrumbs: this._breadcrumbs,
            attachments: this._attachments,
            contexts: this._contexts,
            tags: this._tags,
            attributes: this._attributes,
            extra: this._extra,
            user: this._user,
            level: this._level,
            fingerprint: this._fingerprint || [],
            eventProcessors: this._eventProcessors,
            propagationContext: this._propagationContext,
            sdkProcessingMetadata: this._sdkProcessingMetadata,
            transactionName: this._transactionName,
            span: (0, $dab1970d0c142a42$export$91f063ebb8eff307)(this),
            conversationId: this._conversationId
        };
    }
    /**
   * Add data which will be accessible during event processing but won't get sent to Sentry.
   */ setSDKProcessingMetadata(newData) {
        this._sdkProcessingMetadata = (0, $40b0d31022c415bf$export$4950aa0f605343fb)(this._sdkProcessingMetadata, newData, 2);
        return this;
    }
    /**
   * Add propagation context to the scope, used for distributed tracing
   */ setPropagationContext(context) {
        this._propagationContext = context;
        return this;
    }
    /**
   * Get propagation context from the scope, used for distributed tracing
   */ getPropagationContext() {
        return this._propagationContext;
    }
    /**
   * Capture an exception for this scope.
   *
   * @returns {string} The id of the captured Sentry event.
   */ captureException(exception, hint) {
        const eventId = hint?.event_id || (0, $cc262db35458e4b3$export$19f53698e68b2496)();
        if (!this._client) {
            (0, $19fdbaf7f0830971$export$16a28057038b10ef) && (0, $d11ed0b3cdda6b8d$export$1c9f709888824e05).warn('No client configured on scope - will not capture exception!');
            return eventId;
        }
        const syntheticException = new Error('Sentry syntheticException');
        this._client.captureException(exception, {
            originalException: exception,
            syntheticException: syntheticException,
            ...hint,
            event_id: eventId
        }, this);
        return eventId;
    }
    /**
   * Capture a message for this scope.
   *
   * @returns {string} The id of the captured message.
   */ captureMessage(message, level, hint) {
        const eventId = hint?.event_id || (0, $cc262db35458e4b3$export$19f53698e68b2496)();
        if (!this._client) {
            (0, $19fdbaf7f0830971$export$16a28057038b10ef) && (0, $d11ed0b3cdda6b8d$export$1c9f709888824e05).warn('No client configured on scope - will not capture message!');
            return eventId;
        }
        const syntheticException = hint?.syntheticException ?? new Error(message);
        this._client.captureMessage(message, level, {
            originalException: message,
            syntheticException: syntheticException,
            ...hint,
            event_id: eventId
        }, this);
        return eventId;
    }
    /**
   * Capture a Sentry event for this scope.
   *
   * @returns {string} The id of the captured event.
   */ captureEvent(event, hint) {
        const eventId = event.event_id || hint?.event_id || (0, $cc262db35458e4b3$export$19f53698e68b2496)();
        if (!this._client) {
            (0, $19fdbaf7f0830971$export$16a28057038b10ef) && (0, $d11ed0b3cdda6b8d$export$1c9f709888824e05).warn('No client configured on scope - will not capture event!');
            return eventId;
        }
        this._client.captureEvent(event, {
            ...hint,
            event_id: eventId
        }, this);
        return eventId;
    }
    /**
   * This will be called on every set call.
   */ _notifyScopeListeners() {
        // We need this check for this._notifyingListeners to be able to work on scope during updates
        // If this check is not here we'll produce endless recursion when something is done with the scope
        // during the callback.
        if (!this._notifyingListeners) {
            this._notifyingListeners = true;
            this._scopeListeners.forEach((callback)=>{
                callback(this);
            });
            this._notifyingListeners = false;
        }
    }
}


/** Get the default current scope. */ function $11e49251e9b07646$export$6f1b9191db9c4d5() {
    return (0, $e4c75fb63b040566$export$7e223ec222791509)('defaultCurrentScope', ()=>new (0, $dd23bca0e7d7618a$export$775b6bb06e53a214)());
}
/** Get the default isolation scope. */ function $11e49251e9b07646$export$de9862929b76bf57() {
    return (0, $e4c75fb63b040566$export$7e223ec222791509)('defaultIsolationScope', ()=>new (0, $dd23bca0e7d7618a$export$775b6bb06e53a214)());
}





/**
 * This is an object that holds a stack of scopes.
 */ class $ca6289cc8b8b8640$export$d36ec451f120cfba {
    constructor(scope, isolationScope){
        let assignedScope;
        if (!scope) assignedScope = new (0, $dd23bca0e7d7618a$export$775b6bb06e53a214)();
        else assignedScope = scope;
        let assignedIsolationScope;
        if (!isolationScope) assignedIsolationScope = new (0, $dd23bca0e7d7618a$export$775b6bb06e53a214)();
        else assignedIsolationScope = isolationScope;
        // scope stack for domains or the process
        this._stack = [
            {
                scope: assignedScope
            }
        ];
        this._isolationScope = assignedIsolationScope;
    }
    /**
   * Fork a scope for the stack.
   */ withScope(callback) {
        const scope = this._pushScope();
        let maybePromiseResult;
        try {
            maybePromiseResult = callback(scope);
        } catch (e) {
            this._popScope();
            throw e;
        }
        if ((0, $13cf2ed412f405fa$export$f5b060c2914b97c8)(maybePromiseResult)) // @ts-expect-error - isThenable returns the wrong type
        return maybePromiseResult.then((res)=>{
            this._popScope();
            return res;
        }, (e)=>{
            this._popScope();
            throw e;
        });
        this._popScope();
        return maybePromiseResult;
    }
    /**
   * Get the client of the stack.
   */ getClient() {
        return this.getStackTop().client;
    }
    /**
   * Returns the scope of the top stack.
   */ getScope() {
        return this.getStackTop().scope;
    }
    /**
   * Get the isolation scope for the stack.
   */ getIsolationScope() {
        return this._isolationScope;
    }
    /**
   * Returns the topmost scope layer in the order domain > local > process.
   */ getStackTop() {
        return this._stack[this._stack.length - 1];
    }
    /**
   * Push a scope to the stack.
   */ _pushScope() {
        // We want to clone the content of prev scope
        const scope = this.getScope().clone();
        this._stack.push({
            client: this.getClient(),
            scope: scope
        });
        return scope;
    }
    /**
   * Pop a scope from the stack.
   */ _popScope() {
        if (this._stack.length <= 1) return false;
        return !!this._stack.pop();
    }
}
/**
 * Get the global async context stack.
 * This will be removed during the v8 cycle and is only here to make migration easier.
 */ function $ca6289cc8b8b8640$var$getAsyncContextStack() {
    const registry = (0, $e4c75fb63b040566$export$19eade501500c6c1)();
    const sentry = (0, $e4c75fb63b040566$export$c8bfa33e4e8ae492)(registry);
    return sentry.stack = sentry.stack || new $ca6289cc8b8b8640$export$d36ec451f120cfba((0, $11e49251e9b07646$export$6f1b9191db9c4d5)(), (0, $11e49251e9b07646$export$de9862929b76bf57)());
}
function $ca6289cc8b8b8640$var$withScope(callback) {
    return $ca6289cc8b8b8640$var$getAsyncContextStack().withScope(callback);
}
function $ca6289cc8b8b8640$var$withSetScope(scope, callback) {
    const stack = $ca6289cc8b8b8640$var$getAsyncContextStack();
    return stack.withScope(()=>{
        stack.getStackTop().scope = scope;
        return callback(scope);
    });
}
function $ca6289cc8b8b8640$var$withIsolationScope(callback) {
    return $ca6289cc8b8b8640$var$getAsyncContextStack().withScope(()=>{
        return callback($ca6289cc8b8b8640$var$getAsyncContextStack().getIsolationScope());
    });
}
/**
 * Get the stack-based async context strategy.
 */ function $ca6289cc8b8b8640$export$329d4d4d54e42710() {
    return {
        withIsolationScope: $ca6289cc8b8b8640$var$withIsolationScope,
        withScope: $ca6289cc8b8b8640$var$withScope,
        withSetScope: $ca6289cc8b8b8640$var$withSetScope,
        withSetIsolationScope: (_isolationScope, callback)=>{
            return $ca6289cc8b8b8640$var$withIsolationScope(callback);
        },
        getCurrentScope: ()=>$ca6289cc8b8b8640$var$getAsyncContextStack().getScope(),
        getIsolationScope: ()=>$ca6289cc8b8b8640$var$getAsyncContextStack().getIsolationScope()
    };
}


/**
 * @private Private API with no semver guarantees!
 *
 * Sets the global async context strategy
 */ function $a8b8acc568359454$export$774ae0e6b6e444ca(strategy) {
    // Get main carrier (global for every environment)
    const registry = (0, $e4c75fb63b040566$export$19eade501500c6c1)();
    const sentry = (0, $e4c75fb63b040566$export$c8bfa33e4e8ae492)(registry);
    sentry.acs = strategy;
}
/**
 * Get the current async context strategy.
 * If none has been setup, the default will be used.
 */ function $a8b8acc568359454$export$f639b0c2752203be(carrier) {
    const sentry = (0, $e4c75fb63b040566$export$c8bfa33e4e8ae492)(carrier);
    if (sentry.acs) return sentry.acs;
    // Otherwise, use the default one (stack)
    return (0, $ca6289cc8b8b8640$export$329d4d4d54e42710)();
}





/**
 * Get the currently active scope.
 */ function $7d48e1ed9f699a01$export$c7be4b0125a10cba() {
    const carrier = (0, $e4c75fb63b040566$export$19eade501500c6c1)();
    const acs = (0, $a8b8acc568359454$export$f639b0c2752203be)(carrier);
    return acs.getCurrentScope();
}
/**
 * Get the currently active isolation scope.
 * The isolation scope is active for the current execution context.
 */ function $7d48e1ed9f699a01$export$68f3af03034c9e90() {
    const carrier = (0, $e4c75fb63b040566$export$19eade501500c6c1)();
    const acs = (0, $a8b8acc568359454$export$f639b0c2752203be)(carrier);
    return acs.getIsolationScope();
}
/**
 * Get the global scope.
 * This scope is applied to _all_ events.
 */ function $7d48e1ed9f699a01$export$aa55d5ab8e05984f() {
    return (0, $e4c75fb63b040566$export$7e223ec222791509)('globalScope', ()=>new (0, $dd23bca0e7d7618a$export$775b6bb06e53a214)());
}
/**
 * Creates a new scope with and executes the given operation within.
 * The scope is automatically removed once the operation
 * finishes or throws.
 */ /**
 * Either creates a new active scope, or sets the given scope as active scope in the given callback.
 */ function $7d48e1ed9f699a01$export$ec58d9285c204497(...rest) {
    const carrier = (0, $e4c75fb63b040566$export$19eade501500c6c1)();
    const acs = (0, $a8b8acc568359454$export$f639b0c2752203be)(carrier);
    // If a scope is defined, we want to make this the active scope instead of the default one
    if (rest.length === 2) {
        const [scope, callback] = rest;
        if (!scope) return acs.withScope(callback);
        return acs.withSetScope(scope, callback);
    }
    return acs.withScope(rest[0]);
}
/**
 * Attempts to fork the current isolation scope and the current scope based on the current async context strategy. If no
 * async context strategy is set, the isolation scope and the current scope will not be forked (this is currently the
 * case, for example, in the browser).
 *
 * Usage of this function in environments without async context strategy is discouraged and may lead to unexpected behaviour.
 *
 * This function is intended for Sentry SDK and SDK integration development. It is not recommended to be used in "normal"
 * applications directly because it comes with pitfalls. Use at your own risk!
 */ /**
 * Either creates a new active isolation scope, or sets the given isolation scope as active scope in the given callback.
 */ function $7d48e1ed9f699a01$export$9a4fed82c350c2bd(...rest) {
    const carrier = (0, $e4c75fb63b040566$export$19eade501500c6c1)();
    const acs = (0, $a8b8acc568359454$export$f639b0c2752203be)(carrier);
    // If a scope is defined, we want to make this the active scope instead of the default one
    if (rest.length === 2) {
        const [isolationScope, callback] = rest;
        if (!isolationScope) return acs.withIsolationScope(callback);
        return acs.withSetIsolationScope(isolationScope, callback);
    }
    return acs.withIsolationScope(rest[0]);
}
/**
 * Get the currently active client.
 */ function $7d48e1ed9f699a01$export$6bb76d6eba7e258c() {
    return $7d48e1ed9f699a01$export$c7be4b0125a10cba().getClient();
}
/**
 * Get a trace context for the given scope.
 */ function $7d48e1ed9f699a01$export$1e83db7ee4876dc4(scope) {
    const propagationContext = scope.getPropagationContext();
    const { traceId: traceId, parentSpanId: parentSpanId, propagationSpanId: propagationSpanId } = propagationContext;
    const traceContext = {
        trace_id: traceId,
        span_id: propagationSpanId || (0, $ece9bac57decbcb8$export$295213bc4d0c54ad)()
    };
    if (parentSpanId) traceContext.parent_span_id = parentSpanId;
    return traceContext;
}




const $cbb2da6c78246e45$export$b14a8888f80a0b3e = [];
/** Map of integrations assigned to a client */ /**
 * Remove duplicates from the given array, preferring the last instance of any duplicate. Not guaranteed to
 * preserve the order of integrations in the array.
 *
 * @private
 */ function $cbb2da6c78246e45$var$filterDuplicates(integrations) {
    const integrationsByName = {};
    integrations.forEach((currentInstance)=>{
        const { name: name } = currentInstance;
        const existingInstance = integrationsByName[name];
        // We want integrations later in the array to overwrite earlier ones of the same type, except that we never want a
        // default instance to overwrite an existing user instance
        if (existingInstance && !existingInstance.isDefaultInstance && currentInstance.isDefaultInstance) return;
        integrationsByName[name] = currentInstance;
    });
    return Object.values(integrationsByName);
}
/** Gets integrations to install */ function $cbb2da6c78246e45$export$68bc4c01ab8ae766(options) {
    const defaultIntegrations = options.defaultIntegrations || [];
    const userIntegrations = options.integrations;
    // We flag default instances, so that later we can tell them apart from any user-created instances of the same class
    defaultIntegrations.forEach((integration)=>{
        integration.isDefaultInstance = true;
    });
    let integrations;
    if (Array.isArray(userIntegrations)) integrations = [
        ...defaultIntegrations,
        ...userIntegrations
    ];
    else if (typeof userIntegrations === 'function') {
        const resolvedUserIntegrations = userIntegrations(defaultIntegrations);
        integrations = Array.isArray(resolvedUserIntegrations) ? resolvedUserIntegrations : [
            resolvedUserIntegrations
        ];
    } else integrations = defaultIntegrations;
    return $cbb2da6c78246e45$var$filterDuplicates(integrations);
}
/**
 * Given a list of integration instances this installs them all. When `withDefaults` is set to `true` then all default
 * integrations are added unless they were already provided before.
 * @param integrations array of integration instances
 * @param withDefault should enable default integrations
 */ function $cbb2da6c78246e45$export$51abed9797baa598(client, integrations) {
    const integrationIndex = {};
    integrations.forEach((integration)=>{
        // guard against empty provided integrations
        if (integration) $cbb2da6c78246e45$export$e7390a03b70a6f2f(client, integration, integrationIndex);
    });
    return integrationIndex;
}
/**
 * Execute the `afterAllSetup` hooks of the given integrations.
 */ function $cbb2da6c78246e45$export$35abcfd71227c6ca(client, integrations) {
    for (const integration of integrations)// guard against empty provided integrations
    if (integration?.afterAllSetup) integration.afterAllSetup(client);
}
/** Setup a single integration.  */ function $cbb2da6c78246e45$export$e7390a03b70a6f2f(client, integration, integrationIndex) {
    if (integrationIndex[integration.name]) {
        (0, $19fdbaf7f0830971$export$16a28057038b10ef) && (0, $d11ed0b3cdda6b8d$export$1c9f709888824e05).log(`Integration skipped because it was already installed: ${integration.name}`);
        return;
    }
    integrationIndex[integration.name] = integration;
    // `setupOnce` is only called the first time
    if (!$cbb2da6c78246e45$export$b14a8888f80a0b3e.includes(integration.name) && typeof integration.setupOnce === 'function') {
        integration.setupOnce();
        $cbb2da6c78246e45$export$b14a8888f80a0b3e.push(integration.name);
    }
    // `setup` is run for each client
    if (integration.setup && typeof integration.setup === 'function') integration.setup(client);
    if (typeof integration.preprocessEvent === 'function') {
        const callback = integration.preprocessEvent.bind(integration);
        client.on('preprocessEvent', (event, hint)=>callback(event, hint, client));
    }
    if (typeof integration.processEvent === 'function') {
        const callback = integration.processEvent.bind(integration);
        const processor = Object.assign((event, hint)=>callback(event, hint, client), {
            id: integration.name
        });
        client.addEventProcessor(processor);
    }
    (0, $19fdbaf7f0830971$export$16a28057038b10ef) && (0, $d11ed0b3cdda6b8d$export$1c9f709888824e05).log(`Integration installed: ${integration.name}`);
}
/** Add an integration to the current scope's client. */ function $cbb2da6c78246e45$export$2d8f5188773bcddd(integration) {
    const client = (0, $7d48e1ed9f699a01$export$6bb76d6eba7e258c)();
    if (!client) {
        (0, $19fdbaf7f0830971$export$16a28057038b10ef) && (0, $d11ed0b3cdda6b8d$export$1c9f709888824e05).warn(`Cannot add integration "${integration.name}" because no SDK Client is available.`);
        return;
    }
    client.addIntegration(integration);
}
/**
 * Define an integration function that can be used to create an integration instance.
 * Note that this by design hides the implementation details of the integration, as they are considered internal.
 */ function $cbb2da6c78246e45$export$2323046b9414659f(fn) {
    return fn;
}


/**
 * Send user feedback to Sentry.
 */ function $81078705bdbfb4a3$export$3b07f81befe2dd0a(params, hint = {}, scope = (0, $7d48e1ed9f699a01$export$c7be4b0125a10cba)()) {
    const { message: message, name: name, email: email, url: url, source: source, associatedEventId: associatedEventId, tags: tags } = params;
    const feedbackEvent = {
        contexts: {
            feedback: {
                contact_email: email,
                name: name,
                message: message,
                url: url,
                source: source,
                associated_event_id: associatedEventId
            }
        },
        type: 'feedback',
        level: 'info',
        tags: tags
    };
    const client = scope?.getClient() || (0, $7d48e1ed9f699a01$export$6bb76d6eba7e258c)();
    if (client) client.emit('beforeSendFeedback', feedbackEvent, hint);
    const eventId = scope.captureEvent(feedbackEvent, hint);
    return eventId;
}


var $5zmEe = parcelRequire("5zmEe");

/**
 * Returns true if we are in the browser.
 */ function $b1c1ca6bb415cfb2$export$4e09c449d6c407f7() {
    // eslint-disable-next-line no-restricted-globals
    return typeof window !== 'undefined' && (!(0, $5zmEe.isNodeEnv)() || $b1c1ca6bb415cfb2$var$isElectronNodeRenderer());
}
// Electron renderers with nodeIntegration enabled are detected as Node.js so we specifically test for them
function $b1c1ca6bb415cfb2$var$isElectronNodeRenderer() {
    const process = (0, $736a69486c86d36c$export$f1a6cdb1459e81d1).process;
    return process?.type === 'renderer';
}


// exporting a separate copy of `WINDOW` rather than exporting the one from `@sentry/browser`
// prevents the browser package from being bundled in the CDN bundle, and avoids a
// circular dependency between the browser and feedback packages
const $106dcbf01d17d3b7$var$WINDOW = (0, $736a69486c86d36c$export$f1a6cdb1459e81d1);
const $106dcbf01d17d3b7$var$DOCUMENT = $106dcbf01d17d3b7$var$WINDOW.document;
const $106dcbf01d17d3b7$var$NAVIGATOR = $106dcbf01d17d3b7$var$WINDOW.navigator;
const $106dcbf01d17d3b7$var$TRIGGER_LABEL = 'Report a Bug';
const $106dcbf01d17d3b7$var$CANCEL_BUTTON_LABEL = 'Cancel';
const $106dcbf01d17d3b7$var$SUBMIT_BUTTON_LABEL = 'Send Bug Report';
const $106dcbf01d17d3b7$var$CONFIRM_BUTTON_LABEL = 'Confirm';
const $106dcbf01d17d3b7$var$FORM_TITLE = 'Report a Bug';
const $106dcbf01d17d3b7$var$EMAIL_PLACEHOLDER = 'your.email@example.org';
const $106dcbf01d17d3b7$var$EMAIL_LABEL = 'Email';
const $106dcbf01d17d3b7$var$MESSAGE_PLACEHOLDER = "What's the bug? What did you expect?";
const $106dcbf01d17d3b7$var$MESSAGE_LABEL = 'Description';
const $106dcbf01d17d3b7$var$NAME_PLACEHOLDER = 'Your Name';
const $106dcbf01d17d3b7$var$NAME_LABEL = 'Name';
const $106dcbf01d17d3b7$var$SUCCESS_MESSAGE_TEXT = 'Thank you for your report!';
const $106dcbf01d17d3b7$var$IS_REQUIRED_LABEL = '(required)';
const $106dcbf01d17d3b7$var$ADD_SCREENSHOT_LABEL = 'Add a screenshot';
const $106dcbf01d17d3b7$var$REMOVE_SCREENSHOT_LABEL = 'Remove screenshot';
const $106dcbf01d17d3b7$var$HIGHLIGHT_TOOL_TEXT = 'Highlight';
const $106dcbf01d17d3b7$var$HIDE_TOOL_TEXT = 'Hide';
const $106dcbf01d17d3b7$var$REMOVE_HIGHLIGHT_TEXT = 'Remove';
const $106dcbf01d17d3b7$var$FEEDBACK_WIDGET_SOURCE = 'widget';
const $106dcbf01d17d3b7$var$FEEDBACK_API_SOURCE = 'api';
const $106dcbf01d17d3b7$var$SUCCESS_MESSAGE_TIMEOUT = 5000;
/**
 * Public API to send a Feedback item to Sentry
 */ const $106dcbf01d17d3b7$export$a65d69dd22caceda = (params, hint = {
    includeReplay: true
})=>{
    if (!params.message) throw new Error('Unable to submit feedback with empty message');
    // We want to wait for the feedback to be sent (or not)
    const client = (0, $7d48e1ed9f699a01$export$6bb76d6eba7e258c)();
    if (!client) throw new Error('No client setup, cannot send feedback.');
    if (params.tags && Object.keys(params.tags).length) (0, $7d48e1ed9f699a01$export$c7be4b0125a10cba)().setTags(params.tags);
    const eventId = (0, $81078705bdbfb4a3$export$3b07f81befe2dd0a)({
        source: $106dcbf01d17d3b7$var$FEEDBACK_API_SOURCE,
        url: (0, $caac489b9d8395b2$export$1cfafeee2987818b)(),
        ...params
    }, hint);
    // We want to wait for the feedback to be sent (or not)
    return new Promise((resolve, reject)=>{
        // After 30s, we want to clear anyhow
        const timeout = setTimeout(()=>reject('Unable to determine if Feedback was correctly sent.'), 30000);
        const cleanup = client.on('afterSendEvent', (event, response)=>{
            if (event.event_id !== eventId) return;
            clearTimeout(timeout);
            cleanup();
            // Require valid status codes, otherwise can assume feedback was not sent successfully
            if (response?.statusCode && response.statusCode >= 200 && response.statusCode < 300) return resolve(eventId);
            if (response?.statusCode === 403) return reject('Unable to send feedback. This could be because this domain is not in your list of allowed domains.');
            return reject('Unable to send feedback. This could be because of network issues, or because you are using an ad-blocker.');
        });
    });
};
/*
 * For reference, the fully built event looks something like this:
 * {
 *     "type": "feedback",
 *     "event_id": "d2132d31b39445f1938d7e21b6bf0ec4",
 *     "timestamp": 1597977777.6189718,
 *     "dist": "1.12",
 *     "platform": "javascript",
 *     "environment": "production",
 *     "release": 42,
 *     "tags": {"transaction": "/organizations/:orgId/performance/:eventSlug/"},
 *     "sdk": {"name": "name", "version": "version"},
 *     "user": {
 *         "id": "123",
 *         "username": "user",
 *         "email": "user@site.com",
 *         "ip_address": "192.168.11.12",
 *     },
 *     "request": {
 *         "url": None,
 *         "headers": {
 *             "user-Agent": "Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_7) AppleWebKit/605.1.15 (KHTML, like Gecko) Version/15.5 Safari/605.1.15"
 *         },
 *     },
 *     "contexts": {
 *         "feedback": {
 *             "message": "test message",
 *             "contact_email": "test@example.com",
 *             "type": "feedback",
 *         },
 *         "trace": {
 *             "trace_id": "4C79F60C11214EB38604F4AE0781BFB2",
 *             "span_id": "FA90FDEAD5F74052",
 *             "type": "trace",
 *         },
 *         "replay": {
 *             "replay_id": "e2d42047b1c5431c8cba85ee2a8ab25d",
 *         },
 *     },
 *   }
 */ /**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $106dcbf01d17d3b7$var$DEBUG_BUILD = typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__;
/**
 * Mobile browsers do not support `mediaDevices.getDisplayMedia` even though they have the api implemented
 * Instead they return things like `NotAllowedError` when called.
 *
 * It's simpler for us to browser sniff first, and avoid loading the integration if we can.
 *
 * https://stackoverflow.com/a/58879212
 * https://stackoverflow.com/a/3540295
 *
 * `mediaDevices.getDisplayMedia` is also only supported in secure contexts, and return a `mediaDevices is not supported` error, so we should also avoid loading the integration if we can.
 *
 * https://developer.mozilla.org/en-US/docs/Web/API/MediaDevices/getDisplayMedia
 */ function $106dcbf01d17d3b7$var$isScreenshotSupported() {
    if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test($106dcbf01d17d3b7$var$NAVIGATOR.userAgent)) return false;
    /**
   * User agent on iPads show as Macintosh, so we need extra checks
   *
   * https://forums.developer.apple.com/forums/thread/119186
   * https://stackoverflow.com/questions/60482650/how-to-detect-ipad-useragent-on-safari-browser
   */ if (/Macintosh/i.test($106dcbf01d17d3b7$var$NAVIGATOR.userAgent) && $106dcbf01d17d3b7$var$NAVIGATOR.maxTouchPoints && $106dcbf01d17d3b7$var$NAVIGATOR.maxTouchPoints > 1) return false;
    if (!isSecureContext) return false;
    return true;
}
/**
 * Quick and dirty deep merge for the Feedback integration options
 */ function $106dcbf01d17d3b7$var$mergeOptions(defaultOptions, optionOverrides) {
    return {
        ...defaultOptions,
        ...optionOverrides,
        tags: {
            ...defaultOptions.tags,
            ...optionOverrides.tags
        },
        onFormOpen: ()=>{
            optionOverrides.onFormOpen?.();
            defaultOptions.onFormOpen?.();
        },
        onFormClose: ()=>{
            optionOverrides.onFormClose?.();
            defaultOptions.onFormClose?.();
        },
        onSubmitSuccess: (data, eventId)=>{
            optionOverrides.onSubmitSuccess?.(data, eventId);
            defaultOptions.onSubmitSuccess?.(data, eventId);
        },
        onSubmitError: (error)=>{
            optionOverrides.onSubmitError?.(error);
            defaultOptions.onSubmitError?.(error);
        },
        onFormSubmitted: ()=>{
            optionOverrides.onFormSubmitted?.();
            defaultOptions.onFormSubmitted?.();
        },
        themeDark: {
            ...defaultOptions.themeDark,
            ...optionOverrides.themeDark
        },
        themeLight: {
            ...defaultOptions.themeLight,
            ...optionOverrides.themeLight
        }
    };
}
/**
 * Creates <style> element for widget actor (button that opens the dialog)
 */ function $106dcbf01d17d3b7$var$createActorStyles(styleNonce) {
    const style = $106dcbf01d17d3b7$var$DOCUMENT.createElement('style');
    style.textContent = `
.widget__actor {
  position: fixed;
  z-index: var(--z-index);
  margin: var(--page-margin);
  inset: var(--actor-inset);

  display: flex;
  align-items: center;
  gap: 8px;
  padding: 16px;

  font-family: inherit;
  font-size: var(--font-size);
  font-weight: 600;
  line-height: 1.14em;
  text-decoration: none;

  background: var(--actor-background, var(--background));
  border-radius: var(--actor-border-radius, 1.7em/50%);
  border: var(--actor-border, var(--border));
  box-shadow: var(--actor-box-shadow, var(--box-shadow));
  color: var(--actor-color, var(--foreground));
  fill: var(--actor-color, var(--foreground));
  cursor: pointer;
  opacity: 1;
  transition: transform 0.2s ease-in-out;
  transform: translate(0, 0) scale(1);
}
.widget__actor[aria-hidden="true"] {
  opacity: 0;
  pointer-events: none;
  visibility: hidden;
  transform: translate(0, 16px) scale(0.98);
}

.widget__actor:hover {
  background: var(--actor-hover-background, var(--background));
  filter: var(--interactive-filter);
}

.widget__actor svg {
  width: 1.14em;
  height: 1.14em;
}

@media (max-width: 600px) {
  .widget__actor span {
    display: none;
  }
}
`;
    if (styleNonce) style.setAttribute('nonce', styleNonce);
    return style;
}
/**
 * Helper function to set a dict of attributes on element (w/ specified namespace)
 */ function $106dcbf01d17d3b7$var$setAttributesNS(el, attributes) {
    Object.entries(attributes).forEach(([key, val])=>{
        el.setAttributeNS(null, key, val);
    });
    return el;
}
const $106dcbf01d17d3b7$var$SIZE = 20;
const $106dcbf01d17d3b7$var$XMLNS$2 = 'http://www.w3.org/2000/svg';
/**
 * Feedback Icon
 */ function $106dcbf01d17d3b7$var$FeedbackIcon() {
    const createElementNS = (tagName)=>$106dcbf01d17d3b7$var$WINDOW.document.createElementNS($106dcbf01d17d3b7$var$XMLNS$2, tagName);
    const svg = $106dcbf01d17d3b7$var$setAttributesNS(createElementNS('svg'), {
        width: `${$106dcbf01d17d3b7$var$SIZE}`,
        height: `${$106dcbf01d17d3b7$var$SIZE}`,
        viewBox: `0 0 ${$106dcbf01d17d3b7$var$SIZE} ${$106dcbf01d17d3b7$var$SIZE}`,
        fill: 'var(--actor-color, var(--foreground))'
    });
    const g = $106dcbf01d17d3b7$var$setAttributesNS(createElementNS('g'), {
        clipPath: 'url(#clip0_57_80)'
    });
    const path = $106dcbf01d17d3b7$var$setAttributesNS(createElementNS('path'), {
        ['fill-rule']: 'evenodd',
        ['clip-rule']: 'evenodd',
        d: 'M15.6622 15H12.3997C12.2129 14.9959 12.031 14.9396 11.8747 14.8375L8.04965 12.2H7.49956V19.1C7.4875 19.3348 7.3888 19.5568 7.22256 19.723C7.05632 19.8892 6.83435 19.9879 6.59956 20H2.04956C1.80193 19.9968 1.56535 19.8969 1.39023 19.7218C1.21511 19.5467 1.1153 19.3101 1.11206 19.0625V12.2H0.949652C0.824431 12.2017 0.700142 12.1783 0.584123 12.1311C0.468104 12.084 0.362708 12.014 0.274155 11.9255C0.185602 11.8369 0.115689 11.7315 0.0685419 11.6155C0.0213952 11.4995 -0.00202913 11.3752 -0.00034808 11.25V3.75C-0.00900498 3.62067 0.0092504 3.49095 0.0532651 3.36904C0.0972798 3.24712 0.166097 3.13566 0.255372 3.04168C0.344646 2.94771 0.452437 2.87327 0.571937 2.82307C0.691437 2.77286 0.82005 2.74798 0.949652 2.75H8.04965L11.8747 0.1625C12.031 0.0603649 12.2129 0.00407221 12.3997 0H15.6622C15.9098 0.00323746 16.1464 0.103049 16.3215 0.278167C16.4966 0.453286 16.5964 0.689866 16.5997 0.9375V3.25269C17.3969 3.42959 18.1345 3.83026 18.7211 4.41679C19.5322 5.22788 19.9878 6.32796 19.9878 7.47502C19.9878 8.62209 19.5322 9.72217 18.7211 10.5333C18.1345 11.1198 17.3969 11.5205 16.5997 11.6974V14.0125C16.6047 14.1393 16.5842 14.2659 16.5395 14.3847C16.4948 14.5035 16.4268 14.6121 16.3394 14.7042C16.252 14.7962 16.147 14.8698 16.0307 14.9206C15.9144 14.9714 15.7891 14.9984 15.6622 15ZM1.89695 10.325H1.88715V4.625H8.33715C8.52423 4.62301 8.70666 4.56654 8.86215 4.4625L12.6872 1.875H14.7247V13.125H12.6872L8.86215 10.4875C8.70666 10.3835 8.52423 10.327 8.33715 10.325H2.20217C2.15205 10.3167 2.10102 10.3125 2.04956 10.3125C1.9981 10.3125 1.94708 10.3167 1.89695 10.325ZM2.98706 12.2V18.1625H5.66206V12.2H2.98706ZM16.5997 9.93612V5.01393C16.6536 5.02355 16.7072 5.03495 16.7605 5.04814C17.1202 5.13709 17.4556 5.30487 17.7425 5.53934C18.0293 5.77381 18.2605 6.06912 18.4192 6.40389C18.578 6.73866 18.6603 7.10452 18.6603 7.47502C18.6603 7.84552 18.578 8.21139 18.4192 8.54616C18.2605 8.88093 18.0293 9.17624 17.7425 9.41071C17.4556 9.64518 17.1202 9.81296 16.7605 9.90191C16.7072 9.91509 16.6536 9.9265 16.5997 9.93612Z'
    });
    svg.appendChild(g).appendChild(path);
    const speakerDefs = createElementNS('defs');
    const speakerClipPathDef = $106dcbf01d17d3b7$var$setAttributesNS(createElementNS('clipPath'), {
        id: 'clip0_57_80'
    });
    const speakerRect = $106dcbf01d17d3b7$var$setAttributesNS(createElementNS('rect'), {
        width: `${$106dcbf01d17d3b7$var$SIZE}`,
        height: `${$106dcbf01d17d3b7$var$SIZE}`,
        fill: 'white'
    });
    speakerClipPathDef.appendChild(speakerRect);
    speakerDefs.appendChild(speakerClipPathDef);
    svg.appendChild(speakerDefs).appendChild(speakerClipPathDef).appendChild(speakerRect);
    return svg;
}
/**
 * The sentry-provided button to open the feedback modal
 */ function $106dcbf01d17d3b7$var$Actor({ triggerLabel: triggerLabel, triggerAriaLabel: triggerAriaLabel, shadow: shadow, styleNonce: styleNonce }) {
    const el = $106dcbf01d17d3b7$var$DOCUMENT.createElement('button');
    el.type = 'button';
    el.className = 'widget__actor';
    el.ariaHidden = 'false';
    el.ariaLabel = triggerAriaLabel || triggerLabel || $106dcbf01d17d3b7$var$TRIGGER_LABEL;
    el.appendChild($106dcbf01d17d3b7$var$FeedbackIcon());
    if (triggerLabel) {
        const label = $106dcbf01d17d3b7$var$DOCUMENT.createElement('span');
        label.appendChild($106dcbf01d17d3b7$var$DOCUMENT.createTextNode(triggerLabel));
        el.appendChild(label);
    }
    const style = $106dcbf01d17d3b7$var$createActorStyles(styleNonce);
    return {
        el: el,
        appendToDom () {
            shadow.appendChild(style);
            shadow.appendChild(el);
        },
        removeFromDom () {
            el.remove();
            style.remove();
        },
        show () {
            el.ariaHidden = 'false';
        },
        hide () {
            el.ariaHidden = 'true';
        }
    };
}
const $106dcbf01d17d3b7$var$PURPLE = 'rgba(88, 74, 192, 1)';
const $106dcbf01d17d3b7$var$DEFAULT_LIGHT = {
    foreground: '#2b2233',
    background: '#ffffff',
    accentForeground: 'white',
    accentBackground: $106dcbf01d17d3b7$var$PURPLE,
    successColor: '#268d75',
    errorColor: '#df3338',
    border: '1.5px solid rgba(41, 35, 47, 0.13)',
    boxShadow: '0px 4px 24px 0px rgba(43, 34, 51, 0.12)',
    outline: '1px auto var(--accent-background)',
    interactiveFilter: 'brightness(95%)'
};
const $106dcbf01d17d3b7$var$DEFAULT_DARK = {
    foreground: '#ebe6ef',
    background: '#29232f',
    accentForeground: 'white',
    accentBackground: $106dcbf01d17d3b7$var$PURPLE,
    successColor: '#2da98c',
    errorColor: '#f55459',
    border: '1.5px solid rgba(235, 230, 239, 0.15)',
    boxShadow: '0px 4px 24px 0px rgba(43, 34, 51, 0.12)',
    outline: '1px auto var(--accent-background)',
    interactiveFilter: 'brightness(150%)'
};
function $106dcbf01d17d3b7$var$getThemedCssVariables(theme) {
    return `
  --foreground: ${theme.foreground};
  --background: ${theme.background};
  --accent-foreground: ${theme.accentForeground};
  --accent-background: ${theme.accentBackground};
  --success-color: ${theme.successColor};
  --error-color: ${theme.errorColor};
  --border: ${theme.border};
  --box-shadow: ${theme.boxShadow};
  --outline: ${theme.outline};
  --interactive-filter: ${theme.interactiveFilter};
  `;
}
/**
 * Creates <style> element for widget actor (button that opens the dialog)
 */ function $106dcbf01d17d3b7$var$createMainStyles({ colorScheme: colorScheme, themeDark: themeDark, themeLight: themeLight, styleNonce: styleNonce }) {
    const style = $106dcbf01d17d3b7$var$DOCUMENT.createElement('style');
    style.textContent = `
:host {
  --font-family: system-ui, 'Helvetica Neue', Arial, sans-serif;
  --font-size: 14px;
  --z-index: 100000;

  --page-margin: 16px;
  --inset: auto 0 0 auto;
  --actor-inset: var(--inset);

  font-family: var(--font-family);
  font-size: var(--font-size);

  ${colorScheme !== 'system' ? `color-scheme: only ${colorScheme};` : ''}

  ${$106dcbf01d17d3b7$var$getThemedCssVariables(colorScheme === 'dark' ? {
        ...$106dcbf01d17d3b7$var$DEFAULT_DARK,
        ...themeDark
    } : {
        ...$106dcbf01d17d3b7$var$DEFAULT_LIGHT,
        ...themeLight
    })}
}

${colorScheme === 'system' ? `
@media (prefers-color-scheme: dark) {
  :host {
    color-scheme: only dark;

    ${$106dcbf01d17d3b7$var$getThemedCssVariables({
        ...$106dcbf01d17d3b7$var$DEFAULT_DARK,
        ...themeDark
    })}
  }
}` : ''}
`;
    if (styleNonce) style.setAttribute('nonce', styleNonce);
    return style;
}
const $106dcbf01d17d3b7$export$13a9e5a543258f97 = ({ lazyLoadIntegration: lazyLoadIntegration, getModalIntegration: getModalIntegration, getScreenshotIntegration: getScreenshotIntegration })=>{
    const feedbackIntegration = ({ id: // FeedbackGeneralConfiguration
    id = 'sentry-feedback', autoInject: autoInject = true, showBranding: showBranding = true, isEmailRequired: isEmailRequired = false, isNameRequired: isNameRequired = false, showEmail: showEmail = true, showName: showName = true, enableScreenshot: enableScreenshot = true, useSentryUser: useSentryUser = {
        email: 'email',
        name: 'username'
    }, tags: tags, styleNonce: styleNonce, scriptNonce: scriptNonce, colorScheme: // FeedbackThemeConfiguration
    colorScheme = 'system', themeLight: themeLight = {}, themeDark: themeDark = {}, addScreenshotButtonLabel: // FeedbackTextConfiguration
    addScreenshotButtonLabel = $106dcbf01d17d3b7$var$ADD_SCREENSHOT_LABEL, cancelButtonLabel: cancelButtonLabel = $106dcbf01d17d3b7$var$CANCEL_BUTTON_LABEL, confirmButtonLabel: confirmButtonLabel = $106dcbf01d17d3b7$var$CONFIRM_BUTTON_LABEL, emailLabel: emailLabel = $106dcbf01d17d3b7$var$EMAIL_LABEL, emailPlaceholder: emailPlaceholder = $106dcbf01d17d3b7$var$EMAIL_PLACEHOLDER, formTitle: formTitle = $106dcbf01d17d3b7$var$FORM_TITLE, isRequiredLabel: isRequiredLabel = $106dcbf01d17d3b7$var$IS_REQUIRED_LABEL, messageLabel: messageLabel = $106dcbf01d17d3b7$var$MESSAGE_LABEL, messagePlaceholder: messagePlaceholder = $106dcbf01d17d3b7$var$MESSAGE_PLACEHOLDER, nameLabel: nameLabel = $106dcbf01d17d3b7$var$NAME_LABEL, namePlaceholder: namePlaceholder = $106dcbf01d17d3b7$var$NAME_PLACEHOLDER, removeScreenshotButtonLabel: removeScreenshotButtonLabel = $106dcbf01d17d3b7$var$REMOVE_SCREENSHOT_LABEL, submitButtonLabel: submitButtonLabel = $106dcbf01d17d3b7$var$SUBMIT_BUTTON_LABEL, successMessageText: successMessageText = $106dcbf01d17d3b7$var$SUCCESS_MESSAGE_TEXT, triggerLabel: triggerLabel = $106dcbf01d17d3b7$var$TRIGGER_LABEL, triggerAriaLabel: triggerAriaLabel = '', highlightToolText: highlightToolText = $106dcbf01d17d3b7$var$HIGHLIGHT_TOOL_TEXT, hideToolText: hideToolText = $106dcbf01d17d3b7$var$HIDE_TOOL_TEXT, removeHighlightText: removeHighlightText = $106dcbf01d17d3b7$var$REMOVE_HIGHLIGHT_TEXT, onFormOpen: // FeedbackCallbacks
    onFormOpen, onFormClose: onFormClose, onSubmitSuccess: onSubmitSuccess, onSubmitError: onSubmitError, onFormSubmitted: onFormSubmitted } = {})=>{
        const _options = {
            id: id,
            autoInject: autoInject,
            showBranding: showBranding,
            isEmailRequired: isEmailRequired,
            isNameRequired: isNameRequired,
            showEmail: showEmail,
            showName: showName,
            enableScreenshot: enableScreenshot,
            useSentryUser: useSentryUser,
            tags: tags,
            styleNonce: styleNonce,
            scriptNonce: scriptNonce,
            colorScheme: colorScheme,
            themeDark: themeDark,
            themeLight: themeLight,
            triggerLabel: triggerLabel,
            triggerAriaLabel: triggerAriaLabel,
            cancelButtonLabel: cancelButtonLabel,
            submitButtonLabel: submitButtonLabel,
            confirmButtonLabel: confirmButtonLabel,
            formTitle: formTitle,
            emailLabel: emailLabel,
            emailPlaceholder: emailPlaceholder,
            messageLabel: messageLabel,
            messagePlaceholder: messagePlaceholder,
            nameLabel: nameLabel,
            namePlaceholder: namePlaceholder,
            successMessageText: successMessageText,
            isRequiredLabel: isRequiredLabel,
            addScreenshotButtonLabel: addScreenshotButtonLabel,
            removeScreenshotButtonLabel: removeScreenshotButtonLabel,
            highlightToolText: highlightToolText,
            hideToolText: hideToolText,
            removeHighlightText: removeHighlightText,
            onFormClose: onFormClose,
            onFormOpen: onFormOpen,
            onSubmitError: onSubmitError,
            onSubmitSuccess: onSubmitSuccess,
            onFormSubmitted: onFormSubmitted
        };
        let _shadow = null;
        let _mainStyle = null;
        let _subscriptions = [];
        /**
     * Get the shadow root where we will append css
     */ const _createShadow = (options)=>{
            if (!_shadow) {
                const host = $106dcbf01d17d3b7$var$DOCUMENT.createElement('div');
                host.id = String(options.id);
                $106dcbf01d17d3b7$var$DOCUMENT.body.appendChild(host);
                _shadow = host.attachShadow({
                    mode: 'open'
                });
                _mainStyle = $106dcbf01d17d3b7$var$createMainStyles(options);
                _shadow.appendChild(_mainStyle);
            }
            return _shadow;
        };
        const _loadAndRenderDialog = async (options)=>{
            const screenshotRequired = options.enableScreenshot && $106dcbf01d17d3b7$var$isScreenshotSupported();
            let modalIntegration;
            let screenshotIntegration;
            try {
                const modalIntegrationFn = getModalIntegration ? getModalIntegration() : await lazyLoadIntegration('feedbackModalIntegration', scriptNonce);
                modalIntegration = modalIntegrationFn();
                (0, $cbb2da6c78246e45$export$2d8f5188773bcddd)(modalIntegration);
            } catch  {
                $106dcbf01d17d3b7$var$DEBUG_BUILD && (0, $d11ed0b3cdda6b8d$export$1c9f709888824e05).error('[Feedback] Error when trying to load feedback integrations. Try using `feedbackSyncIntegration` in your `Sentry.init`.');
                throw new Error('[Feedback] Missing feedback modal integration!');
            }
            try {
                const screenshotIntegrationFn = screenshotRequired ? getScreenshotIntegration ? getScreenshotIntegration() : await lazyLoadIntegration('feedbackScreenshotIntegration', scriptNonce) : undefined;
                if (screenshotIntegrationFn) {
                    screenshotIntegration = screenshotIntegrationFn();
                    (0, $cbb2da6c78246e45$export$2d8f5188773bcddd)(screenshotIntegration);
                }
            } catch  {
                $106dcbf01d17d3b7$var$DEBUG_BUILD && (0, $d11ed0b3cdda6b8d$export$1c9f709888824e05).error('[Feedback] Missing feedback screenshot integration. Proceeding without screenshots.');
            }
            const dialog = modalIntegration.createDialog({
                options: {
                    ...options,
                    onFormClose: ()=>{
                        dialog?.close();
                        options.onFormClose?.();
                    },
                    onFormSubmitted: ()=>{
                        dialog?.close();
                        options.onFormSubmitted?.();
                    }
                },
                screenshotIntegration: screenshotIntegration,
                sendFeedback: $106dcbf01d17d3b7$export$a65d69dd22caceda,
                shadow: _createShadow(options)
            });
            return dialog;
        };
        const _attachTo = (el, optionOverrides = {})=>{
            const mergedOptions = $106dcbf01d17d3b7$var$mergeOptions(_options, optionOverrides);
            const targetEl = typeof el === 'string' ? $106dcbf01d17d3b7$var$DOCUMENT.querySelector(el) : typeof el.addEventListener === 'function' ? el : null;
            if (!targetEl) {
                $106dcbf01d17d3b7$var$DEBUG_BUILD && (0, $d11ed0b3cdda6b8d$export$1c9f709888824e05).error('[Feedback] Unable to attach to target element');
                throw new Error('Unable to attach to target element');
            }
            let dialog = null;
            const handleClick = async ()=>{
                if (!dialog) dialog = await _loadAndRenderDialog({
                    ...mergedOptions,
                    onFormSubmitted: ()=>{
                        dialog?.removeFromDom();
                        mergedOptions.onFormSubmitted?.();
                    }
                });
                dialog.appendToDom();
                dialog.open();
            };
            targetEl.addEventListener('click', handleClick);
            const unsubscribe = ()=>{
                _subscriptions = _subscriptions.filter((sub)=>sub !== unsubscribe);
                dialog?.removeFromDom();
                dialog = null;
                targetEl.removeEventListener('click', handleClick);
            };
            _subscriptions.push(unsubscribe);
            return unsubscribe;
        };
        const _createActor = (optionOverrides = {})=>{
            const mergedOptions = $106dcbf01d17d3b7$var$mergeOptions(_options, optionOverrides);
            const shadow = _createShadow(mergedOptions);
            const actor = $106dcbf01d17d3b7$var$Actor({
                triggerLabel: mergedOptions.triggerLabel,
                triggerAriaLabel: mergedOptions.triggerAriaLabel,
                shadow: shadow,
                styleNonce: styleNonce
            });
            _attachTo(actor.el, {
                ...mergedOptions,
                onFormOpen () {
                    actor.hide();
                },
                onFormClose () {
                    actor.show();
                },
                onFormSubmitted () {
                    actor.show();
                }
            });
            return actor;
        };
        return {
            name: 'Feedback',
            setupOnce () {
                if (!(0, $b1c1ca6bb415cfb2$export$4e09c449d6c407f7)() || !_options.autoInject) return;
                if ($106dcbf01d17d3b7$var$DOCUMENT.readyState === 'loading') $106dcbf01d17d3b7$var$DOCUMENT.addEventListener('DOMContentLoaded', ()=>_createActor().appendToDom());
                else _createActor().appendToDom();
            },
            /**
       * Adds click listener to the element to open a feedback dialog
       *
       * The returned function can be used to remove the click listener
       */ attachTo: _attachTo,
            /**
       * Creates a new widget which is composed of a Button which triggers a Dialog.
       * Accepts partial options to override any options passed to constructor.
       */ createWidget (optionOverrides = {}) {
                const actor = _createActor($106dcbf01d17d3b7$var$mergeOptions(_options, optionOverrides));
                actor.appendToDom();
                return actor;
            },
            /**
       * Creates a new Form which you can
       * Accepts partial options to override any options passed to constructor.
       */ async createForm (optionOverrides = {}) {
                return _loadAndRenderDialog($106dcbf01d17d3b7$var$mergeOptions(_options, optionOverrides));
            },
            /**
       * Updates the color scheme of the feedback widget at runtime.
       */ setTheme (colorScheme) {
                _options.colorScheme = colorScheme;
                if (_shadow) {
                    const newStyle = $106dcbf01d17d3b7$var$createMainStyles(_options);
                    if (_mainStyle) _shadow.replaceChild(newStyle, _mainStyle);
                    else _shadow.prepend(newStyle);
                    _mainStyle = newStyle;
                }
            },
            /**
       * Removes the Feedback integration (including host, shadow DOM, and all widgets)
       */ remove () {
                if (_shadow) {
                    _shadow.parentElement?.remove();
                    _shadow = null;
                    _mainStyle = null;
                }
                // Remove any lingering subscriptions
                _subscriptions.forEach((sub)=>sub());
                _subscriptions = [];
            }
        };
    };
    return feedbackIntegration;
};
/**
 * This is a small utility to get a type-safe instance of the Feedback integration.
 */ function $106dcbf01d17d3b7$export$ed85ee0b85ce96e1() {
    const client = (0, $7d48e1ed9f699a01$export$6bb76d6eba7e258c)();
    return client?.getIntegrationByName('Feedback');
}
var $106dcbf01d17d3b7$var$n, $106dcbf01d17d3b7$var$l$1, $106dcbf01d17d3b7$var$u$1, $106dcbf01d17d3b7$var$i$1, $106dcbf01d17d3b7$var$o$1, $106dcbf01d17d3b7$var$r$1, $106dcbf01d17d3b7$var$f$1, $106dcbf01d17d3b7$var$c$1 = {}, $106dcbf01d17d3b7$var$s$1 = [], $106dcbf01d17d3b7$var$a$1 = /acit|ex(?:s|g|n|p|$)|rph|grid|ows|mnc|ntw|ine[ch]|zoo|^ord|itera/i, $106dcbf01d17d3b7$var$h$1 = Array.isArray;
function $106dcbf01d17d3b7$var$v$1(n, l) {
    for(var u in l)n[u] = l[u];
    return n;
}
function $106dcbf01d17d3b7$var$p$1(n) {
    var l = n.parentNode;
    l && l.removeChild(n);
}
function $106dcbf01d17d3b7$var$y$1(l, u, t) {
    var i, o, r, f = {};
    for(r in u)"key" == r ? i = u[r] : "ref" == r ? o = u[r] : f[r] = u[r];
    if (arguments.length > 2 && (f.children = arguments.length > 3 ? $106dcbf01d17d3b7$var$n.call(arguments, 2) : t), "function" == typeof l && null != l.defaultProps) for(r in l.defaultProps)void 0 === f[r] && (f[r] = l.defaultProps[r]);
    return $106dcbf01d17d3b7$var$d$1(l, f, i, o, null);
}
function $106dcbf01d17d3b7$var$d$1(n, t, i, o, r) {
    var f = {
        type: n,
        props: t,
        key: i,
        ref: o,
        __k: null,
        __: null,
        __b: 0,
        __e: null,
        __d: void 0,
        __c: null,
        constructor: void 0,
        __v: null == r ? ++$106dcbf01d17d3b7$var$u$1 : r,
        __i: -1,
        __u: 0
    };
    return null == r && null != $106dcbf01d17d3b7$var$l$1.vnode && $106dcbf01d17d3b7$var$l$1.vnode(f), f;
}
function $106dcbf01d17d3b7$var$g$1(n) {
    return n.children;
}
function $106dcbf01d17d3b7$var$b$1(n, l) {
    this.props = n, this.context = l;
}
function $106dcbf01d17d3b7$var$m$1(n, l) {
    if (null == l) return n.__ ? $106dcbf01d17d3b7$var$m$1(n.__, n.__i + 1) : null;
    for(var u; l < n.__k.length; l++)if (null != (u = n.__k[l]) && null != u.__e) return u.__e;
    return "function" == typeof n.type ? $106dcbf01d17d3b7$var$m$1(n) : null;
}
function $106dcbf01d17d3b7$var$w$1(n, u, t) {
    var i, o = n.__v, r = o.__e, f = n.__P;
    if (f) return (i = $106dcbf01d17d3b7$var$v$1({}, o)).__v = o.__v + 1, $106dcbf01d17d3b7$var$l$1.vnode && $106dcbf01d17d3b7$var$l$1.vnode(i), $106dcbf01d17d3b7$var$M(f, i, o, n.__n, void 0 !== f.ownerSVGElement, 32 & o.__u ? [
        r
    ] : null, u, null == r ? $106dcbf01d17d3b7$var$m$1(o) : r, !!(32 & o.__u), t), i.__.__k[i.__i] = i, i.__d = void 0, i.__e != r && $106dcbf01d17d3b7$var$k$1(i), i;
}
function $106dcbf01d17d3b7$var$k$1(n) {
    var l, u;
    if (null != (n = n.__) && null != n.__c) {
        for(n.__e = n.__c.base = null, l = 0; l < n.__k.length; l++)if (null != (u = n.__k[l]) && null != u.__e) {
            n.__e = n.__c.base = u.__e;
            break;
        }
        return $106dcbf01d17d3b7$var$k$1(n);
    }
}
function $106dcbf01d17d3b7$var$x$1(n) {
    (!n.__d && (n.__d = true) && $106dcbf01d17d3b7$var$i$1.push(n) && !$106dcbf01d17d3b7$var$C$1.__r++ || $106dcbf01d17d3b7$var$o$1 !== $106dcbf01d17d3b7$var$l$1.debounceRendering) && (($106dcbf01d17d3b7$var$o$1 = $106dcbf01d17d3b7$var$l$1.debounceRendering) || $106dcbf01d17d3b7$var$r$1)($106dcbf01d17d3b7$var$C$1);
}
function $106dcbf01d17d3b7$var$C$1() {
    var n, u, t, o = [], r = [];
    for($106dcbf01d17d3b7$var$i$1.sort($106dcbf01d17d3b7$var$f$1); n = $106dcbf01d17d3b7$var$i$1.shift();)n.__d && (t = $106dcbf01d17d3b7$var$i$1.length, u = $106dcbf01d17d3b7$var$w$1(n, o, r) || u, 0 === t || $106dcbf01d17d3b7$var$i$1.length > t ? ($106dcbf01d17d3b7$var$j$1(o, u, r), r.length = o.length = 0, u = void 0, $106dcbf01d17d3b7$var$i$1.sort($106dcbf01d17d3b7$var$f$1)) : u && $106dcbf01d17d3b7$var$l$1.__c && $106dcbf01d17d3b7$var$l$1.__c(u, $106dcbf01d17d3b7$var$s$1));
    u && $106dcbf01d17d3b7$var$j$1(o, u, r), $106dcbf01d17d3b7$var$C$1.__r = 0;
}
function $106dcbf01d17d3b7$var$P$1(n, l, u, t, i, o, r, f, e, a, h) {
    var v, p, y, d, _, g = t && t.__k || $106dcbf01d17d3b7$var$s$1, b = l.length;
    for(u.__d = e, $106dcbf01d17d3b7$var$S(u, l, g), e = u.__d, v = 0; v < b; v++)null != (y = u.__k[v]) && "boolean" != typeof y && "function" != typeof y && (p = -1 === y.__i ? $106dcbf01d17d3b7$var$c$1 : g[y.__i] || $106dcbf01d17d3b7$var$c$1, y.__i = v, $106dcbf01d17d3b7$var$M(n, y, p, i, o, r, f, e, a, h), d = y.__e, y.ref && p.ref != y.ref && (p.ref && $106dcbf01d17d3b7$var$N(p.ref, null, y), h.push(y.ref, y.__c || d, y)), null == _ && null != d && (_ = d), 65536 & y.__u || p.__k === y.__k ? e = $106dcbf01d17d3b7$var$$(y, e, n) : "function" == typeof y.type && void 0 !== y.__d ? e = y.__d : d && (e = d.nextSibling), y.__d = void 0, y.__u &= -196609);
    u.__d = e, u.__e = _;
}
function $106dcbf01d17d3b7$var$S(n, l, u) {
    var t, i, o, r, f, e = l.length, c = u.length, s = c, a = 0;
    for(n.__k = [], t = 0; t < e; t++)null != (i = n.__k[t] = null == (i = l[t]) || "boolean" == typeof i || "function" == typeof i ? null : "string" == typeof i || "number" == typeof i || "bigint" == typeof i || i.constructor == String ? $106dcbf01d17d3b7$var$d$1(null, i, null, null, i) : $106dcbf01d17d3b7$var$h$1(i) ? $106dcbf01d17d3b7$var$d$1($106dcbf01d17d3b7$var$g$1, {
        children: i
    }, null, null, null) : void 0 === i.constructor && i.__b > 0 ? $106dcbf01d17d3b7$var$d$1(i.type, i.props, i.key, i.ref ? i.ref : null, i.__v) : i) ? (i.__ = n, i.__b = n.__b + 1, f = $106dcbf01d17d3b7$var$I(i, u, r = t + a, s), i.__i = f, o = null, -1 !== f && (s--, (o = u[f]) && (o.__u |= 131072)), null == o || null === o.__v ? (-1 == f && a--, "function" != typeof i.type && (i.__u |= 65536)) : f !== r && (f === r + 1 ? a++ : f > r ? s > e - r ? a += f - r : a-- : a = f < r && f == r - 1 ? f - r : 0, f !== t + a && (i.__u |= 65536))) : (o = u[t]) && null == o.key && o.__e && (o.__e == n.__d && (n.__d = $106dcbf01d17d3b7$var$m$1(o)), $106dcbf01d17d3b7$var$O(o, o, false), u[t] = null, s--);
    if (s) for(t = 0; t < c; t++)null != (o = u[t]) && 0 == (131072 & o.__u) && (o.__e == n.__d && (n.__d = $106dcbf01d17d3b7$var$m$1(o)), $106dcbf01d17d3b7$var$O(o, o));
}
function $106dcbf01d17d3b7$var$$(n, l, u) {
    var t, i;
    if ("function" == typeof n.type) {
        for(t = n.__k, i = 0; t && i < t.length; i++)t[i] && (t[i].__ = n, l = $106dcbf01d17d3b7$var$$(t[i], l, u));
        return l;
    }
    n.__e != l && (u.insertBefore(n.__e, l || null), l = n.__e);
    do l = l && l.nextSibling;
    while (null != l && 8 === l.nodeType);
    return l;
}
function $106dcbf01d17d3b7$var$I(n, l, u, t) {
    var i = n.key, o = n.type, r = u - 1, f = u + 1, e = l[u];
    if (null === e || e && i == e.key && o === e.type) return u;
    if (t > (null != e && 0 == (131072 & e.__u) ? 1 : 0)) for(; r >= 0 || f < l.length;){
        if (r >= 0) {
            if ((e = l[r]) && 0 == (131072 & e.__u) && i == e.key && o === e.type) return r;
            r--;
        }
        if (f < l.length) {
            if ((e = l[f]) && 0 == (131072 & e.__u) && i == e.key && o === e.type) return f;
            f++;
        }
    }
    return -1;
}
function $106dcbf01d17d3b7$var$T$1(n, l, u) {
    "-" === l[0] ? n.setProperty(l, null == u ? "" : u) : n[l] = null == u ? "" : "number" != typeof u || $106dcbf01d17d3b7$var$a$1.test(l) ? u : u + "px";
}
function $106dcbf01d17d3b7$var$A$1(n, l, u, t, i) {
    var o;
    n: if ("style" === l) {
        if ("string" == typeof u) n.style.cssText = u;
        else {
            if ("string" == typeof t && (n.style.cssText = t = ""), t) for(l in t)u && l in u || $106dcbf01d17d3b7$var$T$1(n.style, l, "");
            if (u) for(l in u)t && u[l] === t[l] || $106dcbf01d17d3b7$var$T$1(n.style, l, u[l]);
        }
    } else if ("o" === l[0] && "n" === l[1]) o = l !== (l = l.replace(/(PointerCapture)$|Capture$/i, "$1")), l = l.toLowerCase() in n ? l.toLowerCase().slice(2) : l.slice(2), n.l || (n.l = {}), n.l[l + o] = u, u ? t ? u.u = t.u : (u.u = Date.now(), n.addEventListener(l, o ? $106dcbf01d17d3b7$var$L : $106dcbf01d17d3b7$var$D$1, o)) : n.removeEventListener(l, o ? $106dcbf01d17d3b7$var$L : $106dcbf01d17d3b7$var$D$1, o);
    else {
        if (i) l = l.replace(/xlink(H|:h)/, "h").replace(/sName$/, "s");
        else if ("width" !== l && "height" !== l && "href" !== l && "list" !== l && "form" !== l && "tabIndex" !== l && "download" !== l && "rowSpan" !== l && "colSpan" !== l && "role" !== l && l in n) try {
            n[l] = null == u ? "" : u;
            break n;
        } catch (n) {}
        "function" == typeof u || (null == u || false === u && "-" !== l[4] ? n.removeAttribute(l) : n.setAttribute(l, u));
    }
}
function $106dcbf01d17d3b7$var$D$1(n) {
    if (this.l) {
        var u = this.l[n.type + false];
        if (n.t) {
            if (n.t <= u.u) return;
        } else n.t = Date.now();
        return u($106dcbf01d17d3b7$var$l$1.event ? $106dcbf01d17d3b7$var$l$1.event(n) : n);
    }
}
function $106dcbf01d17d3b7$var$L(n) {
    if (this.l) return this.l[n.type + true]($106dcbf01d17d3b7$var$l$1.event ? $106dcbf01d17d3b7$var$l$1.event(n) : n);
}
function $106dcbf01d17d3b7$var$M(n, u, t, i, o, r, f, e, c, s) {
    var a, p, y, d, _, m, w, k, x, C, S, $, H, I, T, A = u.type;
    if (void 0 !== u.constructor) return null;
    128 & t.__u && (c = !!(32 & t.__u), r = [
        e = u.__e = t.__e
    ]), (a = $106dcbf01d17d3b7$var$l$1.__b) && a(u);
    n: if ("function" == typeof A) try {
        if (k = u.props, x = (a = A.contextType) && i[a.__c], C = a ? x ? x.props.value : a.__ : i, t.__c ? w = (p = u.__c = t.__c).__ = p.__E : ("prototype" in A && A.prototype.render ? u.__c = p = new A(k, C) : (u.__c = p = new $106dcbf01d17d3b7$var$b$1(k, C), p.constructor = A, p.render = $106dcbf01d17d3b7$var$q$1), x && x.sub(p), p.props = k, p.state || (p.state = {}), p.context = C, p.__n = i, y = p.__d = !0, p.__h = [], p._sb = []), null == p.__s && (p.__s = p.state), null != A.getDerivedStateFromProps && (p.__s == p.state && (p.__s = $106dcbf01d17d3b7$var$v$1({}, p.__s)), $106dcbf01d17d3b7$var$v$1(p.__s, A.getDerivedStateFromProps(k, p.__s))), d = p.props, _ = p.state, p.__v = u, y) null == A.getDerivedStateFromProps && null != p.componentWillMount && p.componentWillMount(), null != p.componentDidMount && p.__h.push(p.componentDidMount);
        else {
            if (null == A.getDerivedStateFromProps && k !== d && null != p.componentWillReceiveProps && p.componentWillReceiveProps(k, C), !p.__e && (null != p.shouldComponentUpdate && !1 === p.shouldComponentUpdate(k, p.__s, C) || u.__v === t.__v)) {
                for(u.__v !== t.__v && (p.props = k, p.state = p.__s, p.__d = !1), u.__e = t.__e, u.__k = t.__k, u.__k.forEach(function(n) {
                    n && (n.__ = u);
                }), S = 0; S < p._sb.length; S++)p.__h.push(p._sb[S]);
                p._sb = [], p.__h.length && f.push(p);
                break n;
            }
            null != p.componentWillUpdate && p.componentWillUpdate(k, p.__s, C), null != p.componentDidUpdate && p.__h.push(function() {
                p.componentDidUpdate(d, _, m);
            });
        }
        if (p.context = C, p.props = k, p.__P = n, p.__e = !1, $ = $106dcbf01d17d3b7$var$l$1.__r, H = 0, "prototype" in A && A.prototype.render) {
            for(p.state = p.__s, p.__d = !1, $ && $(u), a = p.render(p.props, p.state, p.context), I = 0; I < p._sb.length; I++)p.__h.push(p._sb[I]);
            p._sb = [];
        } else do p.__d = !1, $ && $(u), a = p.render(p.props, p.state, p.context), p.state = p.__s;
        while (p.__d && ++H < 25);
        p.state = p.__s, null != p.getChildContext && (i = $106dcbf01d17d3b7$var$v$1($106dcbf01d17d3b7$var$v$1({}, i), p.getChildContext())), y || null == p.getSnapshotBeforeUpdate || (m = p.getSnapshotBeforeUpdate(d, _)), $106dcbf01d17d3b7$var$P$1(n, $106dcbf01d17d3b7$var$h$1(T = null != a && a.type === $106dcbf01d17d3b7$var$g$1 && null == a.key ? a.props.children : a) ? T : [
            T
        ], u, t, i, o, r, f, e, c, s), p.base = u.__e, u.__u &= -161, p.__h.length && f.push(p), w && (p.__E = p.__ = null);
    } catch (n) {
        u.__v = null, c || null != r ? (u.__e = e, u.__u |= c ? 160 : 32, r[r.indexOf(e)] = null) : (u.__e = t.__e, u.__k = t.__k), $106dcbf01d17d3b7$var$l$1.__e(n, u, t);
    }
    else null == r && u.__v === t.__v ? (u.__k = t.__k, u.__e = t.__e) : u.__e = $106dcbf01d17d3b7$var$z$1(t.__e, u, t, i, o, r, f, c, s);
    (a = $106dcbf01d17d3b7$var$l$1.diffed) && a(u);
}
function $106dcbf01d17d3b7$var$j$1(n, u, t) {
    for(var i = 0; i < t.length; i++)$106dcbf01d17d3b7$var$N(t[i], t[++i], t[++i]);
    $106dcbf01d17d3b7$var$l$1.__c && $106dcbf01d17d3b7$var$l$1.__c(u, n), n.some(function(u) {
        try {
            n = u.__h, u.__h = [], n.some(function(n) {
                n.call(u);
            });
        } catch (n) {
            $106dcbf01d17d3b7$var$l$1.__e(n, u.__v);
        }
    });
}
function $106dcbf01d17d3b7$var$z$1(l, u, t, i, o, r, f, e, s) {
    var a, v, y, d, _, g, b, w = t.props, k = u.props, x = u.type;
    if ("svg" === x && (o = true), null != r) {
        for(a = 0; a < r.length; a++)if ((_ = r[a]) && "setAttribute" in _ == !!x && (x ? _.localName === x : 3 === _.nodeType)) {
            l = _, r[a] = null;
            break;
        }
    }
    if (null == l) {
        if (null === x) return document.createTextNode(k);
        l = o ? document.createElementNS("http://www.w3.org/2000/svg", x) : document.createElement(x, k.is && k), r = null, e = false;
    }
    if (null === x) w === k || e && l.data === k || (l.data = k);
    else {
        if (r = r && $106dcbf01d17d3b7$var$n.call(l.childNodes), w = t.props || $106dcbf01d17d3b7$var$c$1, !e && null != r) for(w = {}, a = 0; a < l.attributes.length; a++)w[(_ = l.attributes[a]).name] = _.value;
        for(a in w)_ = w[a], "children" == a || ("dangerouslySetInnerHTML" == a ? y = _ : "key" === a || a in k || $106dcbf01d17d3b7$var$A$1(l, a, null, _, o));
        for(a in k)_ = k[a], "children" == a ? d = _ : "dangerouslySetInnerHTML" == a ? v = _ : "value" == a ? g = _ : "checked" == a ? b = _ : "key" === a || e && "function" != typeof _ || w[a] === _ || $106dcbf01d17d3b7$var$A$1(l, a, _, w[a], o);
        if (v) e || y && (v.__html === y.__html || v.__html === l.innerHTML) || (l.innerHTML = v.__html), u.__k = [];
        else if (y && (l.innerHTML = ""), $106dcbf01d17d3b7$var$P$1(l, $106dcbf01d17d3b7$var$h$1(d) ? d : [
            d
        ], u, t, i, o && "foreignObject" !== x, r, f, r ? r[0] : t.__k && $106dcbf01d17d3b7$var$m$1(t, 0), e, s), null != r) for(a = r.length; a--;)null != r[a] && $106dcbf01d17d3b7$var$p$1(r[a]);
        e || (a = "value", void 0 !== g && (g !== l[a] || "progress" === x && !g || "option" === x && g !== w[a]) && $106dcbf01d17d3b7$var$A$1(l, a, g, w[a], false), a = "checked", void 0 !== b && b !== l[a] && $106dcbf01d17d3b7$var$A$1(l, a, b, w[a], false));
    }
    return l;
}
function $106dcbf01d17d3b7$var$N(n, u, t) {
    try {
        "function" == typeof n ? n(u) : n.current = u;
    } catch (n) {
        $106dcbf01d17d3b7$var$l$1.__e(n, t);
    }
}
function $106dcbf01d17d3b7$var$O(n, u, t) {
    var i, o;
    if ($106dcbf01d17d3b7$var$l$1.unmount && $106dcbf01d17d3b7$var$l$1.unmount(n), (i = n.ref) && (i.current && i.current !== n.__e || $106dcbf01d17d3b7$var$N(i, null, u)), null != (i = n.__c)) {
        if (i.componentWillUnmount) try {
            i.componentWillUnmount();
        } catch (n) {
            $106dcbf01d17d3b7$var$l$1.__e(n, u);
        }
        i.base = i.__P = null, n.__c = void 0;
    }
    if (i = n.__k) for(o = 0; o < i.length; o++)i[o] && $106dcbf01d17d3b7$var$O(i[o], u, t || "function" != typeof n.type);
    t || null == n.__e || $106dcbf01d17d3b7$var$p$1(n.__e), n.__ = n.__e = n.__d = void 0;
}
function $106dcbf01d17d3b7$var$q$1(n, l, u) {
    return this.constructor(n, u);
}
function $106dcbf01d17d3b7$var$B$1(u, t, i) {
    var o, r, f, e;
    $106dcbf01d17d3b7$var$l$1.__ && $106dcbf01d17d3b7$var$l$1.__(u, t), r = (o = false, t.__k), f = [], e = [], $106dcbf01d17d3b7$var$M(t, u = t.__k = $106dcbf01d17d3b7$var$y$1($106dcbf01d17d3b7$var$g$1, null, [
        u
    ]), r || $106dcbf01d17d3b7$var$c$1, $106dcbf01d17d3b7$var$c$1, void 0 !== t.ownerSVGElement, r ? null : t.firstChild ? $106dcbf01d17d3b7$var$n.call(t.childNodes) : null, f, r ? r.__e : t.firstChild, o, e), u.__d = void 0, $106dcbf01d17d3b7$var$j$1(f, u, e);
}
$106dcbf01d17d3b7$var$n = $106dcbf01d17d3b7$var$s$1.slice, $106dcbf01d17d3b7$var$l$1 = {
    __e: function(n, l, u, t) {
        for(var i, o, r; l = l.__;)if ((i = l.__c) && !i.__) try {
            if ((o = i.constructor) && null != o.getDerivedStateFromError && (i.setState(o.getDerivedStateFromError(n)), r = i.__d), null != i.componentDidCatch && (i.componentDidCatch(n, t || {}), r = i.__d), r) return i.__E = i;
        } catch (l) {
            n = l;
        }
        throw n;
    }
}, $106dcbf01d17d3b7$var$u$1 = 0, $106dcbf01d17d3b7$var$b$1.prototype.setState = function(n, l) {
    var u;
    u = null != this.__s && this.__s !== this.state ? this.__s : this.__s = $106dcbf01d17d3b7$var$v$1({}, this.state), "function" == typeof n && (n = n($106dcbf01d17d3b7$var$v$1({}, u), this.props)), n && $106dcbf01d17d3b7$var$v$1(u, n), null != n && this.__v && (l && this._sb.push(l), $106dcbf01d17d3b7$var$x$1(this));
}, $106dcbf01d17d3b7$var$b$1.prototype.forceUpdate = function(n) {
    this.__v && (this.__e = true, n && this.__h.push(n), $106dcbf01d17d3b7$var$x$1(this));
}, $106dcbf01d17d3b7$var$b$1.prototype.render = $106dcbf01d17d3b7$var$g$1, $106dcbf01d17d3b7$var$i$1 = [], $106dcbf01d17d3b7$var$r$1 = "function" == typeof Promise ? Promise.prototype.then.bind(Promise.resolve()) : setTimeout, $106dcbf01d17d3b7$var$f$1 = function(n, l) {
    return n.__v.__b - l.__v.__b;
}, $106dcbf01d17d3b7$var$C$1.__r = 0;
var $106dcbf01d17d3b7$var$t, $106dcbf01d17d3b7$var$r, $106dcbf01d17d3b7$var$u, $106dcbf01d17d3b7$var$i, $106dcbf01d17d3b7$var$o = 0, $106dcbf01d17d3b7$var$f = [], $106dcbf01d17d3b7$var$c = [], $106dcbf01d17d3b7$var$e = $106dcbf01d17d3b7$var$l$1, $106dcbf01d17d3b7$var$a = $106dcbf01d17d3b7$var$e.__b, $106dcbf01d17d3b7$var$v = $106dcbf01d17d3b7$var$e.__r, $106dcbf01d17d3b7$var$l = $106dcbf01d17d3b7$var$e.diffed, $106dcbf01d17d3b7$var$m = $106dcbf01d17d3b7$var$e.__c, $106dcbf01d17d3b7$var$s = $106dcbf01d17d3b7$var$e.unmount, $106dcbf01d17d3b7$var$d = $106dcbf01d17d3b7$var$e.__;
function $106dcbf01d17d3b7$var$h(n, t) {
    $106dcbf01d17d3b7$var$e.__h && $106dcbf01d17d3b7$var$e.__h($106dcbf01d17d3b7$var$r, n, $106dcbf01d17d3b7$var$o || t), $106dcbf01d17d3b7$var$o = 0;
    var u = $106dcbf01d17d3b7$var$r.__H || ($106dcbf01d17d3b7$var$r.__H = {
        __: [],
        __h: []
    });
    return n >= u.__.length && u.__.push({
        __V: $106dcbf01d17d3b7$var$c
    }), u.__[n];
}
function $106dcbf01d17d3b7$var$p(n) {
    return $106dcbf01d17d3b7$var$o = 1, $106dcbf01d17d3b7$var$y($106dcbf01d17d3b7$var$D, n);
}
function $106dcbf01d17d3b7$var$y(n, u, i) {
    var o = $106dcbf01d17d3b7$var$h($106dcbf01d17d3b7$var$t++, 2);
    if (o.t = n, !o.__c && (o.__ = [
        i ? i(u) : $106dcbf01d17d3b7$var$D(void 0, u),
        function(n) {
            var t = o.__N ? o.__N[0] : o.__[0], r = o.t(t, n);
            t !== r && (o.__N = [
                r,
                o.__[1]
            ], o.__c.setState({}));
        }
    ], o.__c = $106dcbf01d17d3b7$var$r, !$106dcbf01d17d3b7$var$r.u)) {
        var f = function(n, t, r) {
            if (!o.__c.__H) return true;
            var u = o.__c.__H.__.filter(function(n) {
                return !!n.__c;
            });
            if (u.every(function(n) {
                return !n.__N;
            })) return !c || c.call(this, n, t, r);
            var i = false;
            return u.forEach(function(n) {
                if (n.__N) {
                    var t = n.__[0];
                    n.__ = n.__N, n.__N = void 0, t !== n.__[0] && (i = true);
                }
            }), !(!i && o.__c.props === n) && (!c || c.call(this, n, t, r));
        };
        $106dcbf01d17d3b7$var$r.u = true;
        var c = $106dcbf01d17d3b7$var$r.shouldComponentUpdate, e = $106dcbf01d17d3b7$var$r.componentWillUpdate;
        $106dcbf01d17d3b7$var$r.componentWillUpdate = function(n, t, r) {
            if (this.__e) {
                var u = c;
                c = void 0, f(n, t, r), c = u;
            }
            e && e.call(this, n, t, r);
        }, $106dcbf01d17d3b7$var$r.shouldComponentUpdate = f;
    }
    return o.__N || o.__;
}
function $106dcbf01d17d3b7$var$_(n, u) {
    var i = $106dcbf01d17d3b7$var$h($106dcbf01d17d3b7$var$t++, 3);
    !$106dcbf01d17d3b7$var$e.__s && $106dcbf01d17d3b7$var$C(i.__H, u) && (i.__ = n, i.i = u, $106dcbf01d17d3b7$var$r.__H.__h.push(i));
}
function $106dcbf01d17d3b7$var$A(n, u) {
    var i = $106dcbf01d17d3b7$var$h($106dcbf01d17d3b7$var$t++, 4);
    !$106dcbf01d17d3b7$var$e.__s && $106dcbf01d17d3b7$var$C(i.__H, u) && (i.__ = n, i.i = u, $106dcbf01d17d3b7$var$r.__h.push(i));
}
function $106dcbf01d17d3b7$var$F(n) {
    return $106dcbf01d17d3b7$var$o = 5, $106dcbf01d17d3b7$var$q(function() {
        return {
            current: n
        };
    }, []);
}
function $106dcbf01d17d3b7$var$T(n, t, r) {
    $106dcbf01d17d3b7$var$o = 6, $106dcbf01d17d3b7$var$A(function() {
        return "function" == typeof n ? (n(t()), function() {
            return n(null);
        }) : n ? (n.current = t(), function() {
            return n.current = null;
        }) : void 0;
    }, null == r ? r : r.concat(n));
}
function $106dcbf01d17d3b7$var$q(n, r) {
    var u = $106dcbf01d17d3b7$var$h($106dcbf01d17d3b7$var$t++, 7);
    return $106dcbf01d17d3b7$var$C(u.__H, r) ? (u.__V = n(), u.i = r, u.__h = n, u.__V) : u.__;
}
function $106dcbf01d17d3b7$var$x(n, t) {
    return $106dcbf01d17d3b7$var$o = 8, $106dcbf01d17d3b7$var$q(function() {
        return n;
    }, t);
}
function $106dcbf01d17d3b7$var$P(n) {
    var u = $106dcbf01d17d3b7$var$r.context[n.__c], i = $106dcbf01d17d3b7$var$h($106dcbf01d17d3b7$var$t++, 9);
    return i.c = n, u ? (null == i.__ && (i.__ = true, u.sub($106dcbf01d17d3b7$var$r)), u.props.value) : n.__;
}
function $106dcbf01d17d3b7$var$V(n, t) {
    $106dcbf01d17d3b7$var$e.useDebugValue && $106dcbf01d17d3b7$var$e.useDebugValue(t ? t(n) : n);
}
function $106dcbf01d17d3b7$var$b(n) {
    var u = $106dcbf01d17d3b7$var$h($106dcbf01d17d3b7$var$t++, 10), i = $106dcbf01d17d3b7$var$p();
    return u.__ = n, $106dcbf01d17d3b7$var$r.componentDidCatch || ($106dcbf01d17d3b7$var$r.componentDidCatch = function(n, t) {
        u.__ && u.__(n, t), i[1](n);
    }), [
        i[0],
        function() {
            i[1](void 0);
        }
    ];
}
function $106dcbf01d17d3b7$var$g() {
    var n = $106dcbf01d17d3b7$var$h($106dcbf01d17d3b7$var$t++, 11);
    if (!n.__) {
        for(var u = $106dcbf01d17d3b7$var$r.__v; null !== u && !u.__m && null !== u.__;)u = u.__;
        var i = u.__m || (u.__m = [
            0,
            0
        ]);
        n.__ = "P" + i[0] + "-" + i[1]++;
    }
    return n.__;
}
function $106dcbf01d17d3b7$var$j() {
    for(var n; n = $106dcbf01d17d3b7$var$f.shift();)if (n.__P && n.__H) try {
        n.__H.__h.forEach($106dcbf01d17d3b7$var$z), n.__H.__h.forEach($106dcbf01d17d3b7$var$B), n.__H.__h = [];
    } catch (t) {
        n.__H.__h = [], $106dcbf01d17d3b7$var$e.__e(t, n.__v);
    }
}
$106dcbf01d17d3b7$var$e.__b = function(n) {
    $106dcbf01d17d3b7$var$r = null, $106dcbf01d17d3b7$var$a && $106dcbf01d17d3b7$var$a(n);
}, $106dcbf01d17d3b7$var$e.__ = function(n, t) {
    t.__k && t.__k.__m && (n.__m = t.__k.__m), $106dcbf01d17d3b7$var$d && $106dcbf01d17d3b7$var$d(n, t);
}, $106dcbf01d17d3b7$var$e.__r = function(n) {
    $106dcbf01d17d3b7$var$v && $106dcbf01d17d3b7$var$v(n), $106dcbf01d17d3b7$var$t = 0;
    var i = ($106dcbf01d17d3b7$var$r = n.__c).__H;
    i && ($106dcbf01d17d3b7$var$u === $106dcbf01d17d3b7$var$r ? (i.__h = [], $106dcbf01d17d3b7$var$r.__h = [], i.__.forEach(function(n) {
        n.__N && (n.__ = n.__N), n.__V = $106dcbf01d17d3b7$var$c, n.__N = n.i = void 0;
    })) : (i.__h.forEach($106dcbf01d17d3b7$var$z), i.__h.forEach($106dcbf01d17d3b7$var$B), i.__h = [], $106dcbf01d17d3b7$var$t = 0)), $106dcbf01d17d3b7$var$u = $106dcbf01d17d3b7$var$r;
}, $106dcbf01d17d3b7$var$e.diffed = function(n) {
    $106dcbf01d17d3b7$var$l && $106dcbf01d17d3b7$var$l(n);
    var t = n.__c;
    t && t.__H && (t.__H.__h.length && (1 !== $106dcbf01d17d3b7$var$f.push(t) && $106dcbf01d17d3b7$var$i === $106dcbf01d17d3b7$var$e.requestAnimationFrame || (($106dcbf01d17d3b7$var$i = $106dcbf01d17d3b7$var$e.requestAnimationFrame) || $106dcbf01d17d3b7$var$w)($106dcbf01d17d3b7$var$j)), t.__H.__.forEach(function(n) {
        n.i && (n.__H = n.i), n.__V !== $106dcbf01d17d3b7$var$c && (n.__ = n.__V), n.i = void 0, n.__V = $106dcbf01d17d3b7$var$c;
    })), $106dcbf01d17d3b7$var$u = $106dcbf01d17d3b7$var$r = null;
}, $106dcbf01d17d3b7$var$e.__c = function(n, t) {
    t.some(function(n) {
        try {
            n.__h.forEach($106dcbf01d17d3b7$var$z), n.__h = n.__h.filter(function(n) {
                return !n.__ || $106dcbf01d17d3b7$var$B(n);
            });
        } catch (r) {
            t.some(function(n) {
                n.__h && (n.__h = []);
            }), t = [], $106dcbf01d17d3b7$var$e.__e(r, n.__v);
        }
    }), $106dcbf01d17d3b7$var$m && $106dcbf01d17d3b7$var$m(n, t);
}, $106dcbf01d17d3b7$var$e.unmount = function(n) {
    $106dcbf01d17d3b7$var$s && $106dcbf01d17d3b7$var$s(n);
    var t, r = n.__c;
    r && r.__H && (r.__H.__.forEach(function(n) {
        try {
            $106dcbf01d17d3b7$var$z(n);
        } catch (n) {
            t = n;
        }
    }), r.__H = void 0, t && $106dcbf01d17d3b7$var$e.__e(t, r.__v));
};
var $106dcbf01d17d3b7$var$k = "function" == typeof requestAnimationFrame;
function $106dcbf01d17d3b7$var$w(n) {
    var t, r = function() {
        clearTimeout(u), $106dcbf01d17d3b7$var$k && cancelAnimationFrame(t), setTimeout(n);
    }, u = setTimeout(r, 100);
    $106dcbf01d17d3b7$var$k && (t = requestAnimationFrame(r));
}
function $106dcbf01d17d3b7$var$z(n) {
    var t = $106dcbf01d17d3b7$var$r, u = n.__c;
    "function" == typeof u && (n.__c = void 0, u()), $106dcbf01d17d3b7$var$r = t;
}
function $106dcbf01d17d3b7$var$B(n) {
    var t = $106dcbf01d17d3b7$var$r;
    n.__c = n.__(), $106dcbf01d17d3b7$var$r = t;
}
function $106dcbf01d17d3b7$var$C(n, t) {
    return !n || n.length !== t.length || t.some(function(t, r) {
        return t !== n[r];
    });
}
function $106dcbf01d17d3b7$var$D(n, t) {
    return "function" == typeof t ? t(n) : t;
}
const $106dcbf01d17d3b7$var$hooks = /*#__PURE__*/ Object.defineProperty({
    __proto__: null,
    useCallback: $106dcbf01d17d3b7$var$x,
    useContext: $106dcbf01d17d3b7$var$P,
    useDebugValue: $106dcbf01d17d3b7$var$V,
    useEffect: $106dcbf01d17d3b7$var$_,
    useErrorBoundary: $106dcbf01d17d3b7$var$b,
    useId: $106dcbf01d17d3b7$var$g,
    useImperativeHandle: $106dcbf01d17d3b7$var$T,
    useLayoutEffect: $106dcbf01d17d3b7$var$A,
    useMemo: $106dcbf01d17d3b7$var$q,
    useReducer: $106dcbf01d17d3b7$var$y,
    useRef: $106dcbf01d17d3b7$var$F,
    useState: $106dcbf01d17d3b7$var$p
}, Symbol.toStringTag, {
    value: 'Module'
});
const $106dcbf01d17d3b7$var$XMLNS$1 = 'http://www.w3.org/2000/svg';
/**
 * Sentry Logo
 */ function $106dcbf01d17d3b7$var$SentryLogo() {
    const createElementNS = (tagName)=>$106dcbf01d17d3b7$var$DOCUMENT.createElementNS($106dcbf01d17d3b7$var$XMLNS$1, tagName);
    const svg = $106dcbf01d17d3b7$var$setAttributesNS(createElementNS('svg'), {
        width: '32',
        height: '30',
        viewBox: '0 0 72 66',
        fill: 'inherit'
    });
    const path = $106dcbf01d17d3b7$var$setAttributesNS(createElementNS('path'), {
        transform: 'translate(11, 11)',
        d: 'M29,2.26a4.67,4.67,0,0,0-8,0L14.42,13.53A32.21,32.21,0,0,1,32.17,40.19H27.55A27.68,27.68,0,0,0,12.09,17.47L6,28a15.92,15.92,0,0,1,9.23,12.17H4.62A.76.76,0,0,1,4,39.06l2.94-5a10.74,10.74,0,0,0-3.36-1.9l-2.91,5a4.54,4.54,0,0,0,1.69,6.24A4.66,4.66,0,0,0,4.62,44H19.15a19.4,19.4,0,0,0-8-17.31l2.31-4A23.87,23.87,0,0,1,23.76,44H36.07a35.88,35.88,0,0,0-16.41-31.8l4.67-8a.77.77,0,0,1,1.05-.27c.53.29,20.29,34.77,20.66,35.17a.76.76,0,0,1-.68,1.13H40.6q.09,1.91,0,3.81h4.78A4.59,4.59,0,0,0,50,39.43a4.49,4.49,0,0,0-.62-2.28Z'
    });
    svg.appendChild(path);
    return svg;
}
function $106dcbf01d17d3b7$var$DialogHeader({ options: options }) {
    const logoHtml = $106dcbf01d17d3b7$var$q(()=>({
            __html: $106dcbf01d17d3b7$var$SentryLogo().outerHTML
        }), []);
    return $106dcbf01d17d3b7$var$y$1('h2', {
        class: "dialog__header"
    }, $106dcbf01d17d3b7$var$y$1('span', {
        class: "dialog__title"
    }, options.formTitle), options.showBranding ? $106dcbf01d17d3b7$var$y$1('a', {
        class: "brand-link",
        target: "_blank",
        href: "https://sentry.io/welcome/",
        title: "Powered by Sentry",
        rel: "noopener noreferrer",
        dangerouslySetInnerHTML: logoHtml
    }) : null);
}
/**
 * Validate that a given feedback submission has the required fields
 */ function $106dcbf01d17d3b7$var$getMissingFields(feedback, props) {
    const emptyFields = [];
    if (props.isNameRequired && !feedback.name) emptyFields.push(props.nameLabel);
    if (props.isEmailRequired && !feedback.email) emptyFields.push(props.emailLabel);
    if (!feedback.message) emptyFields.push(props.messageLabel);
    return emptyFields;
}
function $106dcbf01d17d3b7$var$retrieveStringValue(formData, key) {
    const value = formData.get(key);
    if (typeof value === 'string') return value.trim();
    return '';
}
function $106dcbf01d17d3b7$var$Form({ options: options, defaultEmail: defaultEmail, defaultName: defaultName, onFormClose: onFormClose, onSubmit: onSubmit, onSubmitSuccess: onSubmitSuccess, onSubmitError: onSubmitError, showEmail: showEmail, showName: showName, screenshotInput: screenshotInput }) {
    const { tags: tags, addScreenshotButtonLabel: addScreenshotButtonLabel, removeScreenshotButtonLabel: removeScreenshotButtonLabel, cancelButtonLabel: cancelButtonLabel, emailLabel: emailLabel, emailPlaceholder: emailPlaceholder, isEmailRequired: isEmailRequired, isNameRequired: isNameRequired, messageLabel: messageLabel, messagePlaceholder: messagePlaceholder, nameLabel: nameLabel, namePlaceholder: namePlaceholder, submitButtonLabel: submitButtonLabel, isRequiredLabel: isRequiredLabel } = options;
    const [isSubmitting, setIsSubmitting] = $106dcbf01d17d3b7$var$p(false);
    // TODO: set a ref on the form, and whenever an input changes call processForm() and setError()
    const [error, setError] = $106dcbf01d17d3b7$var$p(null);
    const [showScreenshotInput, setShowScreenshotInput] = $106dcbf01d17d3b7$var$p(false);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const ScreenshotInputComponent = screenshotInput?.input;
    const [screenshotError, setScreenshotError] = $106dcbf01d17d3b7$var$p(null);
    const onScreenshotError = $106dcbf01d17d3b7$var$x((error)=>{
        setScreenshotError(error);
        setShowScreenshotInput(false);
    }, []);
    const hasAllRequiredFields = $106dcbf01d17d3b7$var$x((data)=>{
        const missingFields = $106dcbf01d17d3b7$var$getMissingFields(data, {
            emailLabel: emailLabel,
            isEmailRequired: isEmailRequired,
            isNameRequired: isNameRequired,
            messageLabel: messageLabel,
            nameLabel: nameLabel
        });
        if (missingFields.length > 0) setError(`Please enter in the following required fields: ${missingFields.join(', ')}`);
        else setError(null);
        return missingFields.length === 0;
    }, [
        emailLabel,
        isEmailRequired,
        isNameRequired,
        messageLabel,
        nameLabel
    ]);
    const handleSubmit = $106dcbf01d17d3b7$var$x(async (e)=>{
        setIsSubmitting(true);
        try {
            e.preventDefault();
            if (!(e.target instanceof HTMLFormElement)) return;
            const formData = new FormData(e.target);
            const attachment = await (screenshotInput && showScreenshotInput ? screenshotInput.value() : undefined);
            const data = {
                name: $106dcbf01d17d3b7$var$retrieveStringValue(formData, 'name'),
                email: $106dcbf01d17d3b7$var$retrieveStringValue(formData, 'email'),
                message: $106dcbf01d17d3b7$var$retrieveStringValue(formData, 'message'),
                attachments: attachment ? [
                    attachment
                ] : undefined
            };
            if (!hasAllRequiredFields(data)) return;
            try {
                const eventId = await onSubmit({
                    name: data.name,
                    email: data.email,
                    message: data.message,
                    source: $106dcbf01d17d3b7$var$FEEDBACK_WIDGET_SOURCE,
                    tags: tags
                }, {
                    attachments: data.attachments
                });
                onSubmitSuccess(data, eventId);
            } catch (error) {
                $106dcbf01d17d3b7$var$DEBUG_BUILD && (0, $d11ed0b3cdda6b8d$export$1c9f709888824e05).error(error);
                setError(error);
                onSubmitError(error);
            }
        } finally{
            setIsSubmitting(false);
        }
    }, [
        screenshotInput && showScreenshotInput,
        onSubmitSuccess,
        onSubmitError
    ]);
    return $106dcbf01d17d3b7$var$y$1('form', {
        class: "form",
        onSubmit: handleSubmit
    }, ScreenshotInputComponent && showScreenshotInput ? $106dcbf01d17d3b7$var$y$1(ScreenshotInputComponent, {
        onError: onScreenshotError
    }) : null, $106dcbf01d17d3b7$var$y$1('fieldset', {
        class: "form__right",
        'data-sentry-feedback': true,
        disabled: isSubmitting
    }, $106dcbf01d17d3b7$var$y$1('div', {
        class: "form__top"
    }, error ? $106dcbf01d17d3b7$var$y$1('div', {
        class: "form__error-container"
    }, error) : null, showName ? $106dcbf01d17d3b7$var$y$1('label', {
        for: "name",
        class: "form__label"
    }, $106dcbf01d17d3b7$var$y$1($106dcbf01d17d3b7$var$LabelText, {
        label: nameLabel,
        isRequiredLabel: isRequiredLabel,
        isRequired: isNameRequired
    }), $106dcbf01d17d3b7$var$y$1('input', {
        class: "form__input",
        defaultValue: defaultName,
        id: "name",
        name: "name",
        placeholder: namePlaceholder,
        required: isNameRequired,
        type: "text"
    })) : $106dcbf01d17d3b7$var$y$1('input', {
        'aria-hidden': true,
        value: defaultName,
        name: "name",
        type: "hidden"
    }), showEmail ? $106dcbf01d17d3b7$var$y$1('label', {
        for: "email",
        class: "form__label"
    }, $106dcbf01d17d3b7$var$y$1($106dcbf01d17d3b7$var$LabelText, {
        label: emailLabel,
        isRequiredLabel: isRequiredLabel,
        isRequired: isEmailRequired
    }), $106dcbf01d17d3b7$var$y$1('input', {
        class: "form__input",
        defaultValue: defaultEmail,
        id: "email",
        name: "email",
        placeholder: emailPlaceholder,
        required: isEmailRequired,
        type: "email"
    })) : $106dcbf01d17d3b7$var$y$1('input', {
        'aria-hidden': true,
        value: defaultEmail,
        name: "email",
        type: "hidden"
    }), $106dcbf01d17d3b7$var$y$1('label', {
        for: "message",
        class: "form__label"
    }, $106dcbf01d17d3b7$var$y$1($106dcbf01d17d3b7$var$LabelText, {
        label: messageLabel,
        isRequiredLabel: isRequiredLabel,
        isRequired: true
    }), $106dcbf01d17d3b7$var$y$1('textarea', {
        autoFocus: true,
        class: "form__input form__input--textarea",
        id: "message",
        name: "message",
        placeholder: messagePlaceholder,
        required: true,
        rows: 5
    })), ScreenshotInputComponent ? $106dcbf01d17d3b7$var$y$1('label', {
        for: "screenshot",
        class: "form__label"
    }, $106dcbf01d17d3b7$var$y$1('button', {
        class: "btn btn--default",
        disabled: isSubmitting,
        type: "button",
        onClick: ()=>{
            setScreenshotError(null);
            setShowScreenshotInput((prev)=>!prev);
        }
    }, showScreenshotInput ? removeScreenshotButtonLabel : addScreenshotButtonLabel), screenshotError ? $106dcbf01d17d3b7$var$y$1('div', {
        class: "form__error-container"
    }, screenshotError.message) : null) : null), $106dcbf01d17d3b7$var$y$1('div', {
        class: "btn-group"
    }, $106dcbf01d17d3b7$var$y$1('button', {
        class: "btn btn--primary",
        disabled: isSubmitting,
        type: "submit"
    }, submitButtonLabel), $106dcbf01d17d3b7$var$y$1('button', {
        class: "btn btn--default",
        disabled: isSubmitting,
        type: "button",
        onClick: onFormClose
    }, cancelButtonLabel))));
}
function $106dcbf01d17d3b7$var$LabelText({ label: label, isRequired: isRequired, isRequiredLabel: isRequiredLabel }) {
    return $106dcbf01d17d3b7$var$y$1('span', {
        class: "form__label__text"
    }, label, isRequired && $106dcbf01d17d3b7$var$y$1('span', {
        class: "form__label__text--required"
    }, isRequiredLabel));
}
const $106dcbf01d17d3b7$var$WIDTH = 16;
const $106dcbf01d17d3b7$var$HEIGHT = 17;
const $106dcbf01d17d3b7$var$XMLNS = 'http://www.w3.org/2000/svg';
/**
 * Success Icon (checkmark)
 */ function $106dcbf01d17d3b7$var$SuccessIcon() {
    const createElementNS = (tagName)=>$106dcbf01d17d3b7$var$WINDOW.document.createElementNS($106dcbf01d17d3b7$var$XMLNS, tagName);
    const svg = $106dcbf01d17d3b7$var$setAttributesNS(createElementNS('svg'), {
        width: `${$106dcbf01d17d3b7$var$WIDTH}`,
        height: `${$106dcbf01d17d3b7$var$HEIGHT}`,
        viewBox: `0 0 ${$106dcbf01d17d3b7$var$WIDTH} ${$106dcbf01d17d3b7$var$HEIGHT}`,
        fill: 'inherit'
    });
    const g = $106dcbf01d17d3b7$var$setAttributesNS(createElementNS('g'), {
        clipPath: 'url(#clip0_57_156)'
    });
    const path2 = $106dcbf01d17d3b7$var$setAttributesNS(createElementNS('path'), {
        ['fill-rule']: 'evenodd',
        ['clip-rule']: 'evenodd',
        d: 'M3.55544 15.1518C4.87103 16.0308 6.41775 16.5 8 16.5C10.1217 16.5 12.1566 15.6571 13.6569 14.1569C15.1571 12.6566 16 10.6217 16 8.5C16 6.91775 15.5308 5.37103 14.6518 4.05544C13.7727 2.73985 12.5233 1.71447 11.0615 1.10897C9.59966 0.503466 7.99113 0.34504 6.43928 0.653721C4.88743 0.962403 3.46197 1.72433 2.34315 2.84315C1.22433 3.96197 0.462403 5.38743 0.153721 6.93928C-0.15496 8.49113 0.00346625 10.0997 0.608967 11.5615C1.21447 13.0233 2.23985 14.2727 3.55544 15.1518ZM4.40546 3.1204C5.46945 2.40946 6.72036 2.03 8 2.03C9.71595 2.03 11.3616 2.71166 12.575 3.92502C13.7883 5.13838 14.47 6.78405 14.47 8.5C14.47 9.77965 14.0905 11.0306 13.3796 12.0945C12.6687 13.1585 11.6582 13.9878 10.476 14.4775C9.29373 14.9672 7.99283 15.0953 6.73777 14.8457C5.48271 14.596 4.32987 13.9798 3.42502 13.075C2.52018 12.1701 1.90397 11.0173 1.65432 9.76224C1.40468 8.50718 1.5328 7.20628 2.0225 6.02404C2.5122 4.8418 3.34148 3.83133 4.40546 3.1204Z'
    });
    const path = $106dcbf01d17d3b7$var$setAttributesNS(createElementNS('path'), {
        d: 'M6.68775 12.4297C6.78586 12.4745 6.89218 12.4984 7 12.5C7.11275 12.4955 7.22315 12.4664 7.32337 12.4145C7.4236 12.3627 7.51121 12.2894 7.58 12.2L12 5.63999C12.0848 5.47724 12.1071 5.28902 12.0625 5.11098C12.0178 4.93294 11.9095 4.77744 11.7579 4.67392C11.6064 4.57041 11.4221 4.52608 11.24 4.54931C11.0579 4.57254 10.8907 4.66173 10.77 4.79999L6.88 10.57L5.13 8.56999C5.06508 8.49566 4.98613 8.43488 4.89768 8.39111C4.80922 8.34735 4.713 8.32148 4.61453 8.31498C4.51605 8.30847 4.41727 8.32147 4.32382 8.35322C4.23038 8.38497 4.14413 8.43484 4.07 8.49999C3.92511 8.63217 3.83692 8.81523 3.82387 9.01092C3.81083 9.2066 3.87393 9.39976 4 9.54999L6.43 12.24C6.50187 12.3204 6.58964 12.385 6.68775 12.4297Z'
    });
    svg.appendChild(g).append(path, path2);
    const speakerDefs = createElementNS('defs');
    const speakerClipPathDef = $106dcbf01d17d3b7$var$setAttributesNS(createElementNS('clipPath'), {
        id: 'clip0_57_156'
    });
    const speakerRect = $106dcbf01d17d3b7$var$setAttributesNS(createElementNS('rect'), {
        width: `${$106dcbf01d17d3b7$var$WIDTH}`,
        height: `${$106dcbf01d17d3b7$var$WIDTH}`,
        fill: 'white',
        transform: 'translate(0 0.5)'
    });
    speakerClipPathDef.appendChild(speakerRect);
    speakerDefs.appendChild(speakerClipPathDef);
    svg.appendChild(speakerDefs).appendChild(speakerClipPathDef).appendChild(speakerRect);
    return svg;
}
function $106dcbf01d17d3b7$var$Dialog({ open: open, onFormSubmitted: onFormSubmitted, ...props }) {
    const options = props.options;
    const successIconHtml = $106dcbf01d17d3b7$var$q(()=>({
            __html: $106dcbf01d17d3b7$var$SuccessIcon().outerHTML
        }), []);
    const [timeoutId, setTimeoutId] = $106dcbf01d17d3b7$var$p(null);
    const handleOnSuccessClick = $106dcbf01d17d3b7$var$x(()=>{
        if (timeoutId) {
            clearTimeout(timeoutId);
            setTimeoutId(null);
        }
        onFormSubmitted();
    }, [
        timeoutId
    ]);
    const onSubmitSuccess = $106dcbf01d17d3b7$var$x((data, eventId)=>{
        props.onSubmitSuccess(data, eventId);
        setTimeoutId(setTimeout(()=>{
            onFormSubmitted();
            setTimeoutId(null);
        }, $106dcbf01d17d3b7$var$SUCCESS_MESSAGE_TIMEOUT));
    }, [
        onFormSubmitted
    ]);
    return $106dcbf01d17d3b7$var$y$1($106dcbf01d17d3b7$var$g$1, null, timeoutId ? $106dcbf01d17d3b7$var$y$1('div', {
        class: "success__position",
        onClick: handleOnSuccessClick
    }, $106dcbf01d17d3b7$var$y$1('div', {
        class: "success__content"
    }, options.successMessageText, $106dcbf01d17d3b7$var$y$1('span', {
        class: "success__icon",
        dangerouslySetInnerHTML: successIconHtml
    }))) : $106dcbf01d17d3b7$var$y$1('dialog', {
        class: "dialog",
        onClick: options.onFormClose,
        open: open
    }, $106dcbf01d17d3b7$var$y$1('div', {
        class: "dialog__position"
    }, $106dcbf01d17d3b7$var$y$1('div', {
        class: "dialog__content",
        onClick: (e)=>{
            // Stop event propagation so clicks on content modal do not propagate to dialog (which will close dialog)
            e.stopPropagation();
        }
    }, $106dcbf01d17d3b7$var$y$1($106dcbf01d17d3b7$var$DialogHeader, {
        options: options
    }), $106dcbf01d17d3b7$var$y$1($106dcbf01d17d3b7$var$Form, {
        ...props,
        onSubmitSuccess: onSubmitSuccess
    })))));
}
const $106dcbf01d17d3b7$var$DIALOG = `
.dialog {
  position: fixed;
  z-index: var(--z-index);
  margin: 0;
  inset: 0;

  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  height: 100vh;
  width: 100vw;

  color: var(--dialog-color, var(--foreground));
  fill: var(--dialog-color, var(--foreground));
  line-height: 1.75em;

  background-color: rgba(0, 0, 0, 0.05);
  border: none;
  inset: 0;
  opacity: 1;
  transition: opacity 0.2s ease-in-out;
}

.dialog__position {
  position: fixed;
  z-index: var(--z-index);
  inset: var(--dialog-inset);
  padding: var(--page-margin);
  display: flex;
  max-height: calc(100vh - (2 * var(--page-margin)));
}
@media (max-width: 600px) {
  .dialog__position {
    inset: var(--page-margin);
    padding: 0;
  }
}

.dialog__position:has(.editor) {
  inset: var(--page-margin);
  padding: 0;
}

.dialog:not([open]) {
  opacity: 0;
  pointer-events: none;
  visibility: hidden;
}
.dialog:not([open]) .dialog__content {
  transform: translate(0, -16px) scale(0.98);
}

.dialog__content {
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: var(--dialog-padding, 24px);
  max-width: 100%;
  width: 100%;
  max-height: 100%;
  overflow: auto;

  background: var(--dialog-background, var(--background));
  border-radius: var(--dialog-border-radius, 20px);
  border: var(--dialog-border, var(--border));
  box-shadow: var(--dialog-box-shadow, var(--box-shadow));
  transform: translate(0, 0) scale(1);
  transition: transform 0.2s ease-in-out;
}

`;
const $106dcbf01d17d3b7$var$DIALOG_HEADER = `
.dialog__header {
  display: flex;
  gap: 4px;
  justify-content: space-between;
  font-weight: var(--dialog-header-weight, 600);
  margin: 0;
}
.dialog__title {
  align-self: center;
  width: var(--form-width, 272px);
}

@media (max-width: 600px) {
  .dialog__title {
    width: auto;
  }
}

.dialog__position:has(.editor) .dialog__title {
  width: auto;
}


.brand-link {
  display: inline-flex;
}
.brand-link:focus-visible {
  outline: var(--outline);
}
`;
const $106dcbf01d17d3b7$var$FORM = `
.form {
  display: flex;
  overflow: auto;
  flex-direction: row;
  gap: 16px;
  flex: 1 0;
}

.form fieldset {
  border: none;
  margin: 0;
  padding: 0;
}

.form__right {
  flex: 0 0 auto;
  display: flex;
  overflow: auto;
  flex-direction: column;
  justify-content: space-between;
  gap: 20px;
  width: var(--form-width, 100%);
}

.dialog__position:has(.editor) .form__right {
  width: var(--form-width, 272px);
}

.form__top {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.form__error-container {
  color: var(--error-color);
  fill: var(--error-color);
}

.form__label {
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin: 0px;
}

.form__label__text {
  display: flex;
  gap: 4px;
  align-items: center;
}

.form__label__text--required {
  font-size: 0.85em;
}

.form__input {
  font-family: inherit;
  line-height: inherit;
  background: transparent;
  box-sizing: border-box;
  border: var(--input-border, var(--border));
  border-radius: var(--input-border-radius, 6px);
  color: var(--input-color, inherit);
  fill: var(--input-color, inherit);
  font-size: var(--input-font-size, inherit);
  font-weight: var(--input-font-weight, 500);
  padding: 6px 12px;
}

.form__input::placeholder {
  opacity: 0.65;
  color: var(--input-placeholder-color, inherit);
  filter: var(--interactive-filter);
}

.form__input:focus-visible {
  outline: var(--input-focus-outline, var(--outline));
}

.form__input--textarea {
  font-family: inherit;
  resize: vertical;
}

.error {
  color: var(--error-color);
  fill: var(--error-color);
}
`;
const $106dcbf01d17d3b7$var$BUTTON = `
.btn-group {
  display: grid;
  gap: 8px;
}

.btn {
  line-height: inherit;
  border: var(--button-border, var(--border));
  border-radius: var(--button-border-radius, 6px);
  cursor: pointer;
  font-family: inherit;
  font-size: var(--button-font-size, inherit);
  font-weight: var(--button-font-weight, 600);
  padding: var(--button-padding, 6px 16px);
}
.btn[disabled] {
  opacity: 0.6;
  pointer-events: none;
}

.btn--primary {
  color: var(--button-primary-color, var(--accent-foreground));
  fill: var(--button-primary-color, var(--accent-foreground));
  background: var(--button-primary-background, var(--accent-background));
  border: var(--button-primary-border, var(--border));
  border-radius: var(--button-primary-border-radius, 6px);
  font-weight: var(--button-primary-font-weight, 500);
}
.btn--primary:hover {
  color: var(--button-primary-hover-color, var(--accent-foreground));
  fill: var(--button-primary-hover-color, var(--accent-foreground));
  background: var(--button-primary-hover-background, var(--accent-background));
  filter: var(--interactive-filter);
}
.btn--primary:focus-visible {
  background: var(--button-primary-hover-background, var(--accent-background));
  filter: var(--interactive-filter);
  outline: var(--button-primary-focus-outline, var(--outline));
}

.btn--default {
  color: var(--button-color, var(--foreground));
  fill: var(--button-color, var(--foreground));
  background: var(--button-background, var(--background));
  border: var(--button-border, var(--border));
  border-radius: var(--button-border-radius, 6px);
  font-weight: var(--button-font-weight, 500);
}
.btn--default:hover {
  color: var(--button-color, var(--foreground));
  fill: var(--button-color, var(--foreground));
  background: var(--button-hover-background, var(--background));
  filter: var(--interactive-filter);
}
.btn--default:focus-visible {
  background: var(--button-hover-background, var(--background));
  filter: var(--interactive-filter);
  outline: var(--button-focus-outline, var(--outline));
}
`;
const $106dcbf01d17d3b7$var$SUCCESS = `
.success__position {
  position: fixed;
  inset: var(--dialog-inset);
  padding: var(--page-margin);
  z-index: var(--z-index);
}
.success__content {
  background: var(--success-background, var(--background));
  border: var(--success-border, var(--border));
  border-radius: var(--success-border-radius, 1.7em/50%);
  box-shadow: var(--success-box-shadow, var(--box-shadow));
  font-weight: var(--success-font-weight, 600);
  color: var(--success-color);
  fill: var(--success-color);
  padding: 12px 24px;
  line-height: 1.75em;

  display: grid;
  align-items: center;
  grid-auto-flow: column;
  gap: 6px;
  cursor: default;
}

.success__icon {
  display: flex;
}
`;
/**
 * Creates <style> element for widget dialog
 */ function $106dcbf01d17d3b7$var$createDialogStyles(styleNonce) {
    const style = $106dcbf01d17d3b7$var$DOCUMENT.createElement('style');
    style.textContent = `
:host {
  --dialog-inset: var(--inset);
}

${$106dcbf01d17d3b7$var$DIALOG}
${$106dcbf01d17d3b7$var$DIALOG_HEADER}
${$106dcbf01d17d3b7$var$FORM}
${$106dcbf01d17d3b7$var$BUTTON}
${$106dcbf01d17d3b7$var$SUCCESS}
`;
    if (styleNonce) style.setAttribute('nonce', styleNonce);
    return style;
}
function $106dcbf01d17d3b7$var$getUser() {
    const currentUser = (0, $7d48e1ed9f699a01$export$c7be4b0125a10cba)().getUser();
    const isolationUser = (0, $7d48e1ed9f699a01$export$68f3af03034c9e90)().getUser();
    const globalUser = (0, $7d48e1ed9f699a01$export$aa55d5ab8e05984f)().getUser();
    if (currentUser && Object.keys(currentUser).length) return currentUser;
    if (isolationUser && Object.keys(isolationUser).length) return isolationUser;
    return globalUser;
}
const $106dcbf01d17d3b7$export$2ed486683e133d58 = ()=>{
    return {
        name: 'FeedbackModal',
        setupOnce () {},
        createDialog: ({ options: options, screenshotIntegration: screenshotIntegration, sendFeedback: sendFeedback, shadow: shadow })=>{
            const shadowRoot = shadow;
            const userKey = options.useSentryUser;
            const user = $106dcbf01d17d3b7$var$getUser();
            const el = $106dcbf01d17d3b7$var$DOCUMENT.createElement('div');
            const style = $106dcbf01d17d3b7$var$createDialogStyles(options.styleNonce);
            let originalOverflow = '';
            const dialog = {
                get el () {
                    return el;
                },
                appendToDom () {
                    if (!shadowRoot.contains(style) && !shadowRoot.contains(el)) {
                        shadowRoot.appendChild(style);
                        shadowRoot.appendChild(el);
                    }
                },
                removeFromDom () {
                    el.remove();
                    style.remove();
                    $106dcbf01d17d3b7$var$DOCUMENT.body.style.overflow = originalOverflow;
                },
                open () {
                    renderContent(true);
                    options.onFormOpen?.();
                    (0, $7d48e1ed9f699a01$export$6bb76d6eba7e258c)()?.emit('openFeedbackWidget');
                    originalOverflow = $106dcbf01d17d3b7$var$DOCUMENT.body.style.overflow;
                    $106dcbf01d17d3b7$var$DOCUMENT.body.style.overflow = 'hidden';
                },
                close () {
                    renderContent(false);
                    $106dcbf01d17d3b7$var$DOCUMENT.body.style.overflow = originalOverflow;
                }
            };
            const screenshotInput = screenshotIntegration?.createInput({
                h: $106dcbf01d17d3b7$var$y$1,
                hooks: $106dcbf01d17d3b7$var$hooks,
                dialog: dialog,
                options: options
            });
            const renderContent = (open)=>{
                $106dcbf01d17d3b7$var$B$1($106dcbf01d17d3b7$var$y$1($106dcbf01d17d3b7$var$Dialog, {
                    options: options,
                    screenshotInput: screenshotInput,
                    showName: options.showName || options.isNameRequired,
                    showEmail: options.showEmail || options.isEmailRequired,
                    defaultName: String(userKey && user?.[userKey.name] || ''),
                    defaultEmail: String(userKey && user?.[userKey.email] || ''),
                    onFormClose: ()=>{
                        renderContent(false);
                        options.onFormClose?.();
                    },
                    onSubmit: sendFeedback,
                    onSubmitSuccess: (data, eventId)=>{
                        renderContent(false);
                        options.onSubmitSuccess?.(data, eventId);
                    },
                    onSubmitError: (error)=>{
                        options.onSubmitError?.(error);
                    },
                    onFormSubmitted: ()=>{
                        options.onFormSubmitted?.();
                    },
                    open: open
                }), el);
            };
            return dialog;
        }
    };
};
function $106dcbf01d17d3b7$var$IconCloseFactory({ h: h }) {
    return function IconClose() {
        return h('svg', {
            'data-test-id': "icon-close",
            viewBox: "0 0 16 16",
            fill: "#2B2233",
            height: "25px",
            width: "25px"
        }, h('circle', {
            r: "7",
            cx: "8",
            cy: "8",
            fill: "white"
        }), h('path', {
            strokeWidth: "1.5",
            d: "M8,16a8,8,0,1,1,8-8A8,8,0,0,1,8,16ZM8,1.53A6.47,6.47,0,1,0,14.47,8,6.47,6.47,0,0,0,8,1.53Z"
        }), h('path', {
            strokeWidth: "1.5",
            d: "M5.34,11.41a.71.71,0,0,1-.53-.22.74.74,0,0,1,0-1.06l5.32-5.32a.75.75,0,0,1,1.06,1.06L5.87,11.19A.74.74,0,0,1,5.34,11.41Z"
        }), h('path', {
            strokeWidth: "1.5",
            d: "M10.66,11.41a.74.74,0,0,1-.53-.22L4.81,5.87A.75.75,0,0,1,5.87,4.81l5.32,5.32a.74.74,0,0,1,0,1.06A.71.71,0,0,1,10.66,11.41Z"
        }));
    };
}
/**
 * Creates <style> element for widget dialog
 */ function $106dcbf01d17d3b7$var$createScreenshotInputStyles(styleNonce) {
    const style = $106dcbf01d17d3b7$var$DOCUMENT.createElement('style');
    const surface200 = '#1A141F';
    const gray100 = '#302735';
    style.textContent = `
.editor {
  display: flex;
  flex-grow: 1;
  flex-direction: column;
}

.editor__image-container {
  justify-items: center;
  padding: 15px;
  position: relative;
  height: 100%;
  border-radius: var(--menu-border-radius, 6px);

  background-color: ${surface200};
  background-image: repeating-linear-gradient(
      -145deg,
      transparent,
      transparent 8px,
      ${surface200} 8px,
      ${surface200} 11px
    ),
    repeating-linear-gradient(
      -45deg,
      transparent,
      transparent 15px,
      ${gray100} 15px,
      ${gray100} 16px
    );
}

.editor__canvas-container {
  width: 100%;
  height: 100%;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
}

.editor__canvas-container > * {
  object-fit: contain;
  position: absolute;
}

.editor__tool-container {
  padding-top: 8px;
  display: flex;
  justify-content: center;
}

.editor__tool-bar {
  display: flex;
  gap: 8px;
}

.editor__tool {
  display: flex;
  padding: 8px 12px;
  justify-content: center;
  align-items: center;
  border: var(--button-border, var(--border));
  border-radius: var(--button-border-radius, 6px);
  background: var(--button-background, var(--background));
  color: var(--button-color, var(--foreground));
}

.editor__tool--active {
  background: var(--button-primary-background, var(--accent-background));
  color: var(--button-primary-color, var(--accent-foreground));
}

.editor__rect {
  position: absolute;
  z-index: 2;
}

.editor__rect button {
  opacity: 0;
  position: absolute;
  top: -12px;
  right: -12px;
  cursor: pointer;
  padding: 0;
  z-index: 3;
  border: none;
  background: none;
}

.editor__rect:hover button {
  opacity: 1;
}
`;
    if (styleNonce) style.setAttribute('nonce', styleNonce);
    return style;
}
function $106dcbf01d17d3b7$var$ToolbarFactory({ h: h }) {
    return function Toolbar({ action: action, setAction: setAction, options: options }) {
        return h('div', {
            class: "editor__tool-container"
        }, h('div', {
            class: "editor__tool-bar"
        }, h('button', {
            type: "button",
            class: `editor__tool ${action === 'highlight' ? 'editor__tool--active' : ''}`,
            onClick: ()=>{
                setAction(action === 'highlight' ? '' : 'highlight');
            }
        }, options.highlightToolText), h('button', {
            type: "button",
            class: `editor__tool ${action === 'hide' ? 'editor__tool--active' : ''}`,
            onClick: ()=>{
                setAction(action === 'hide' ? '' : 'hide');
            }
        }, options.hideToolText)));
    };
}
function $106dcbf01d17d3b7$var$useTakeScreenshotFactory({ hooks: hooks }) {
    function useDpi() {
        const [dpi, setDpi] = hooks.useState($106dcbf01d17d3b7$var$WINDOW.devicePixelRatio ?? 1);
        hooks.useEffect(()=>{
            const onChange = ()=>{
                setDpi($106dcbf01d17d3b7$var$WINDOW.devicePixelRatio);
            };
            const media = matchMedia(`(resolution: ${$106dcbf01d17d3b7$var$WINDOW.devicePixelRatio}dppx)`);
            media.addEventListener('change', onChange);
            return ()=>{
                media.removeEventListener('change', onChange);
            };
        }, []);
        return dpi;
    }
    return function useTakeScreenshot({ onBeforeScreenshot: onBeforeScreenshot, onScreenshot: onScreenshot, onAfterScreenshot: onAfterScreenshot, onError: onError }) {
        const dpi = useDpi();
        hooks.useEffect(()=>{
            const takeScreenshot = async ()=>{
                onBeforeScreenshot();
                // Chrome will animate a top-bar which can shrink the window height by a
                // few pixels. The exact amount depends on how fast it takes to exec
                // the onloadedmetadata callback.
                // https://stackoverflow.com/q/75833049
                const stream = await $106dcbf01d17d3b7$var$NAVIGATOR.mediaDevices.getDisplayMedia({
                    video: {
                        width: $106dcbf01d17d3b7$var$WINDOW.innerWidth * dpi,
                        height: $106dcbf01d17d3b7$var$WINDOW.innerHeight * dpi
                    },
                    audio: false,
                    // @ts-expect-error experimental flags: https://developer.mozilla.org/en-US/docs/Web/API/MediaDevices/getDisplayMedia#prefercurrenttab
                    monitorTypeSurfaces: 'exclude',
                    preferCurrentTab: true,
                    selfBrowserSurface: 'include',
                    surfaceSwitching: 'exclude'
                });
                const video = $106dcbf01d17d3b7$var$DOCUMENT.createElement('video');
                await new Promise((resolve, reject)=>{
                    video.srcObject = stream;
                    video.onloadedmetadata = ()=>{
                        onScreenshot(video, dpi);
                        stream.getTracks().forEach((track)=>track.stop());
                        resolve();
                    };
                    video.play().catch(reject);
                });
                onAfterScreenshot();
            };
            takeScreenshot().catch(onError);
        }, []);
    };
}
function $106dcbf01d17d3b7$var$drawRect(command, ctx, color) {
    switch(command.type){
        case 'highlight':
            // creates a shadow around
            ctx.shadowColor = 'rgba(0, 0, 0, 0.7)';
            ctx.shadowBlur = 50;
            // draws a rectangle first with a shadow
            ctx.fillStyle = color;
            ctx.fillRect(command.x - 1, command.y - 1, command.w + 2, command.h + 2);
            // cut out the inside of the rectangle
            ctx.clearRect(command.x, command.y, command.w, command.h);
            break;
        case 'hide':
            ctx.fillStyle = 'rgb(0, 0, 0)';
            ctx.fillRect(command.x, command.y, command.w, command.h);
            break;
    }
}
function $106dcbf01d17d3b7$var$with2dContext(canvas, options, callback) {
    if (!canvas) return;
    const ctx = canvas.getContext('2d', options);
    if (!ctx) return;
    callback(canvas, ctx);
}
function $106dcbf01d17d3b7$var$paintImage(maybeDest, source) {
    $106dcbf01d17d3b7$var$with2dContext(maybeDest, {
        alpha: true
    }, (destCanvas, destCtx)=>{
        destCtx.drawImage(source, 0, 0, source.width, source.height, 0, 0, destCanvas.width, destCanvas.height);
    });
}
// Paint the array of drawCommands into a canvas.
// Assuming this is the canvas foreground, and the background is cleaned.
function $106dcbf01d17d3b7$var$paintForeground(maybeCanvas, strokeColor, drawCommands) {
    $106dcbf01d17d3b7$var$with2dContext(maybeCanvas, {
        alpha: true
    }, (canvas, ctx)=>{
        // If there's anything to draw, then we'll first clear the canvas with
        // a transparent grey background
        if (drawCommands.length) {
            ctx.fillStyle = 'rgba(0, 0, 0, 0.25)';
            ctx.fillRect(0, 0, canvas.width, canvas.height);
        }
        drawCommands.forEach((command)=>{
            $106dcbf01d17d3b7$var$drawRect(command, ctx, strokeColor);
        });
    });
}
function $106dcbf01d17d3b7$var$ScreenshotEditorFactory({ h: h, hooks: hooks, outputBuffer: outputBuffer, dialog: dialog, options: options }) {
    const useTakeScreenshot = $106dcbf01d17d3b7$var$useTakeScreenshotFactory({
        hooks: hooks
    });
    const Toolbar = $106dcbf01d17d3b7$var$ToolbarFactory({
        h: h
    });
    const IconClose = $106dcbf01d17d3b7$var$IconCloseFactory({
        h: h
    });
    const editorStyleInnerText = {
        __html: $106dcbf01d17d3b7$var$createScreenshotInputStyles(options.styleNonce).innerText
    };
    const dialogStyle = dialog.el.style;
    const ScreenshotEditor = ({ screenshot: screenshot })=>{
        // Data for rendering:
        const [action, setAction] = hooks.useState('highlight');
        const [drawCommands, setDrawCommands] = hooks.useState([]);
        // Refs to our html components:
        const measurementRef = hooks.useRef(null);
        const backgroundRef = hooks.useRef(null);
        const foregroundRef = hooks.useRef(null);
        const mouseRef = hooks.useRef(null);
        // The size of our window, relative to the imageSource
        const [scaleFactor, setScaleFactor] = hooks.useState(1);
        const strokeColor = hooks.useMemo(()=>{
            const sentryFeedback = $106dcbf01d17d3b7$var$DOCUMENT.getElementById(options.id);
            if (!sentryFeedback) return 'white';
            const computedStyle = getComputedStyle(sentryFeedback);
            return computedStyle.getPropertyValue('--button-primary-background') || computedStyle.getPropertyValue('--accent-background');
        }, [
            options.id
        ]);
        // The initial resize, to measure the area and set the children to the correct size
        hooks.useLayoutEffect(()=>{
            const handleResize = ()=>{
                const measurementDiv = measurementRef.current;
                if (!measurementDiv) return;
                $106dcbf01d17d3b7$var$with2dContext(screenshot.canvas, {
                    alpha: false
                }, (canvas)=>{
                    const scale = Math.min(measurementDiv.clientWidth / canvas.width, measurementDiv.clientHeight / canvas.height);
                    setScaleFactor(scale);
                });
                // For Firefox, the canvas is not yet measured, so we need to wait for it to get the correct size
                if (measurementDiv.clientHeight === 0 || measurementDiv.clientWidth === 0) setTimeout(handleResize, 0);
            };
            handleResize();
            $106dcbf01d17d3b7$var$WINDOW.addEventListener('resize', handleResize);
            return ()=>{
                $106dcbf01d17d3b7$var$WINDOW.removeEventListener('resize', handleResize);
            };
        }, [
            screenshot
        ]);
        // Set the size of the canvas element to match our screenshot
        const setCanvasSize = hooks.useCallback((maybeCanvas, scale)=>{
            $106dcbf01d17d3b7$var$with2dContext(maybeCanvas, {
                alpha: true
            }, (canvas, ctx)=>{
                // Must call `scale()` before setting `width` & `height`
                ctx.scale(scale, scale);
                canvas.width = screenshot.canvas.width;
                canvas.height = screenshot.canvas.height;
            });
        }, [
            screenshot
        ]);
        // Draw the screenshot into the background
        hooks.useEffect(()=>{
            setCanvasSize(backgroundRef.current, screenshot.dpi);
            $106dcbf01d17d3b7$var$paintImage(backgroundRef.current, screenshot.canvas);
        }, [
            screenshot
        ]);
        // Draw the commands into the foreground
        hooks.useEffect(()=>{
            setCanvasSize(foregroundRef.current, screenshot.dpi);
            $106dcbf01d17d3b7$var$with2dContext(foregroundRef.current, {
                alpha: true
            }, (canvas, ctx)=>{
                ctx.clearRect(0, 0, canvas.width, canvas.height);
            });
            $106dcbf01d17d3b7$var$paintForeground(foregroundRef.current, strokeColor, drawCommands);
        }, [
            drawCommands,
            strokeColor
        ]);
        // Draw into the output outputBuffer
        hooks.useEffect(()=>{
            setCanvasSize(outputBuffer, screenshot.dpi);
            $106dcbf01d17d3b7$var$paintImage(outputBuffer, screenshot.canvas);
            $106dcbf01d17d3b7$var$with2dContext($106dcbf01d17d3b7$var$DOCUMENT.createElement('canvas'), {
                alpha: true
            }, (foreground, ctx)=>{
                ctx.scale(screenshot.dpi, screenshot.dpi); // The scale needs to be set before we set the width/height and paint
                foreground.width = screenshot.canvas.width;
                foreground.height = screenshot.canvas.height;
                $106dcbf01d17d3b7$var$paintForeground(foreground, strokeColor, drawCommands);
                $106dcbf01d17d3b7$var$paintImage(outputBuffer, foreground);
            });
        }, [
            drawCommands,
            screenshot,
            strokeColor
        ]);
        const handleMouseDown = (e)=>{
            if (!action || !mouseRef.current) return;
            const boundingRect = mouseRef.current.getBoundingClientRect();
            const startingPoint = {
                type: action,
                x: e.offsetX / scaleFactor,
                y: e.offsetY / scaleFactor
            };
            const getDrawCommand = (startingPoint, e)=>{
                const x = (e.clientX - boundingRect.x) / scaleFactor;
                const y = (e.clientY - boundingRect.y) / scaleFactor;
                return {
                    type: startingPoint.type,
                    x: Math.min(startingPoint.x, x),
                    y: Math.min(startingPoint.y, y),
                    w: Math.abs(x - startingPoint.x),
                    h: Math.abs(y - startingPoint.y)
                };
            };
            const handleMouseMove = (e)=>{
                $106dcbf01d17d3b7$var$with2dContext(foregroundRef.current, {
                    alpha: true
                }, (canvas, ctx)=>{
                    ctx.clearRect(0, 0, canvas.width, canvas.height);
                });
                $106dcbf01d17d3b7$var$paintForeground(foregroundRef.current, strokeColor, [
                    ...drawCommands,
                    getDrawCommand(startingPoint, e)
                ]);
            };
            const handleMouseUp = (e)=>{
                const drawCommand = getDrawCommand(startingPoint, e);
                // Prevent just clicking onto the canvas, mouse has to move at least 1 pixel
                if (drawCommand.w * scaleFactor >= 1 && drawCommand.h * scaleFactor >= 1) setDrawCommands((prev)=>[
                        ...prev,
                        drawCommand
                    ]);
                $106dcbf01d17d3b7$var$DOCUMENT.removeEventListener('mousemove', handleMouseMove);
                $106dcbf01d17d3b7$var$DOCUMENT.removeEventListener('mouseup', handleMouseUp);
            };
            $106dcbf01d17d3b7$var$DOCUMENT.addEventListener('mousemove', handleMouseMove);
            $106dcbf01d17d3b7$var$DOCUMENT.addEventListener('mouseup', handleMouseUp);
        };
        const deleteRect = hooks.useCallback((index)=>{
            return (e)=>{
                e.preventDefault();
                e.stopPropagation();
                setDrawCommands((prev)=>{
                    const updatedRects = [
                        ...prev
                    ];
                    updatedRects.splice(index, 1);
                    return updatedRects;
                });
            };
        }, []);
        const dimensions = {
            width: `${screenshot.canvas.width * scaleFactor}px`,
            height: `${screenshot.canvas.height * scaleFactor}px`
        };
        const handleStopPropagation = (e)=>{
            e.stopPropagation();
        };
        return h('div', {
            class: "editor"
        }, h('style', {
            nonce: options.styleNonce,
            dangerouslySetInnerHTML: editorStyleInnerText
        }), h('div', {
            class: "editor__image-container"
        }, h('div', {
            class: "editor__canvas-container",
            ref: measurementRef
        }, h('canvas', {
            ref: backgroundRef,
            id: "background",
            style: dimensions
        }), h('canvas', {
            ref: foregroundRef,
            id: "foreground",
            style: dimensions
        }), h('div', {
            ref: mouseRef,
            onMouseDown: handleMouseDown,
            style: dimensions
        }, drawCommands.map((rect, index)=>h('div', {
                key: index,
                class: "editor__rect",
                style: {
                    top: `${rect.y * scaleFactor}px`,
                    left: `${rect.x * scaleFactor}px`,
                    width: `${rect.w * scaleFactor}px`,
                    height: `${rect.h * scaleFactor}px`
                }
            }, h('button', {
                'aria-label': options.removeHighlightText,
                onClick: deleteRect(index),
                onMouseDown: handleStopPropagation,
                onMouseUp: handleStopPropagation,
                type: "button"
            }, h(IconClose, null))))))), h(Toolbar, {
            options: options,
            action: action,
            setAction: setAction
        }));
    };
    return function Wrapper({ onError: onError }) {
        const [screenshot, setScreenshot] = hooks.useState();
        useTakeScreenshot({
            onBeforeScreenshot: hooks.useCallback(()=>{
                dialogStyle.display = 'none';
            }, []),
            onScreenshot: hooks.useCallback((screenshotVideo, dpi)=>{
                // Stash the original screenshot image so we can (re)draw it multiple times
                $106dcbf01d17d3b7$var$with2dContext($106dcbf01d17d3b7$var$DOCUMENT.createElement('canvas'), {
                    alpha: false
                }, (canvas, ctx)=>{
                    ctx.scale(dpi, dpi); // The scale needs to be set before we set the width/height and paint
                    canvas.width = screenshotVideo.videoWidth;
                    canvas.height = screenshotVideo.videoHeight;
                    ctx.drawImage(screenshotVideo, 0, 0, canvas.width, canvas.height);
                    setScreenshot({
                        canvas: canvas,
                        dpi: dpi
                    });
                });
                // The output buffer, we only need to set the width/height on this once, it stays the same forever
                outputBuffer.width = screenshotVideo.videoWidth;
                outputBuffer.height = screenshotVideo.videoHeight;
            }, []),
            onAfterScreenshot: hooks.useCallback(()=>{
                dialogStyle.display = 'block';
            }, []),
            onError: hooks.useCallback((error)=>{
                dialogStyle.display = 'block';
                onError(error);
            }, [])
        });
        if (screenshot) return h(ScreenshotEditor, {
            screenshot: screenshot
        });
        return h('div', null);
    };
}
const $106dcbf01d17d3b7$export$fd00458861e48ab4 = ()=>{
    return {
        name: 'FeedbackScreenshot',
        setupOnce () {},
        createInput: ({ h: h, hooks: hooks, dialog: dialog, options: options })=>{
            const outputBuffer = $106dcbf01d17d3b7$var$DOCUMENT.createElement('canvas');
            return {
                input: $106dcbf01d17d3b7$var$ScreenshotEditorFactory({
                    h: h,
                    hooks: hooks,
                    outputBuffer: outputBuffer,
                    dialog: dialog,
                    options: options
                }),
                value: async ()=>{
                    const blob = await new Promise((resolve)=>{
                        outputBuffer.toBlob(resolve, 'image/png');
                    });
                    if (blob) {
                        const data = new Uint8Array(await blob.arrayBuffer());
                        const attachment = {
                            data: data,
                            filename: 'screenshot.png',
                            contentType: 'application/png'
                        };
                        return attachment;
                    }
                    return undefined;
                }
            };
        }
    };
};










/**
 * Use this attribute to represent the source of a span.
 * Should be one of: custom, url, route, view, component, task, unknown
 *
 */ const $f337c80285f06f80$export$d7a7d984b0791405 = 'sentry.source';
/**
 * Attributes that holds the sample rate that was locally applied to a span.
 * If this attribute is not defined, it means that the span inherited a sampling decision.
 *
 * NOTE: Is only defined on root spans.
 */ const $f337c80285f06f80$export$ccfe0a40627cc34b = 'sentry.sample_rate';
/**
 * Attribute holding the sample rate of the previous trace.
 * This is used to sample consistently across subsequent traces in the browser SDK.
 *
 * Note: Only defined on root spans, if opted into consistent sampling
 */ const $f337c80285f06f80$export$889fb736668e1ecc = 'sentry.previous_trace_sample_rate';
/**
 * Use this attribute to represent the operation of a span.
 */ const $f337c80285f06f80$export$1a413bd9a88fdb09 = 'sentry.op';
/**
 * Use this attribute to represent the origin of a span.
 */ const $f337c80285f06f80$export$cca8dd30f57f805e = 'sentry.origin';
/** The reason why an idle span finished. */ const $f337c80285f06f80$export$ba73f34502b7a3b3 = 'sentry.idle_span_finish_reason';
/** The unit of a measurement, which may be stored as a TimedEvent. */ const $f337c80285f06f80$export$f5f95cff026507b5 = 'sentry.measurement_unit';
/** The value of a measurement, which may be stored as a TimedEvent. */ const $f337c80285f06f80$export$69cd5c610c7bb96a = 'sentry.measurement_value';
/**
 * A custom span name set by users guaranteed to be taken over any automatically
 * inferred name. This attribute is removed before the span is sent.
 *
 * @internal only meant for internal SDK usage
 * @hidden
 */ const $f337c80285f06f80$export$165ce9a229f6f050 = 'sentry.custom_span_name';
/**
 * The id of the profile that this span occurred in.
 */ const $f337c80285f06f80$export$1efec95406bbe327 = 'sentry.profile_id';
const $f337c80285f06f80$export$fea48ba9f4550879 = 'sentry.exclusive_time';
const $f337c80285f06f80$export$b016f89ac1066ec = 'cache.hit';
const $f337c80285f06f80$export$3110e4c3f4386399 = 'cache.key';
const $f337c80285f06f80$export$86be76deee227ff2 = 'cache.item_size';
/** TODO: Remove these once we update to latest semantic conventions */ const $f337c80285f06f80$export$be7a251980e7e946 = 'http.request.method';
const $f337c80285f06f80$export$25dfd73e0e32c6e1 = 'url.full';
/**
 * A span link attribute to mark the link as a special span link.
 *
 * Known values:
 * - `previous_trace`: The span links to the frontend root span of the previous trace.
 * - `next_trace`: The span links to the frontend root span of the next trace. (Not set by the SDK)
 *
 * Other values may be set as appropriate.
 * @see https://develop.sentry.dev/sdk/telemetry/traces/span-links/#link-types
 */ const $f337c80285f06f80$export$ff77b5fd5b2d627b = 'sentry.link.type';
/**
 * =============================================================================
 * GEN AI ATTRIBUTES
 * Based on OpenTelemetry Semantic Conventions for Generative AI
 * @see https://opentelemetry.io/docs/specs/semconv/gen-ai/
 * =============================================================================
 */ /**
 * The conversation ID for linking messages across API calls.
 * For OpenAI Assistants API: thread_id
 * For LangGraph: configurable.thread_id
 */ const $f337c80285f06f80$export$71a4a707257f2774 = 'gen_ai.conversation.id';





const $8ef2851bd0adcf53$export$6e69537d67fa20f = 'sentry-';
const $8ef2851bd0adcf53$export$eb0401070c617ea5 = /^sentry-/;
/**
 * Max length of a serialized baggage string
 *
 * https://www.w3.org/TR/baggage/#limits
 */ const $8ef2851bd0adcf53$export$bdd844ddb2def819 = 8192;
/**
 * Takes a baggage header and turns it into Dynamic Sampling Context, by extracting all the "sentry-" prefixed values
 * from it.
 *
 * @param baggageHeader A very bread definition of a baggage header as it might appear in various frameworks.
 * @returns The Dynamic Sampling Context that was found on `baggageHeader`, if there was any, `undefined` otherwise.
 */ function $8ef2851bd0adcf53$export$5b96ee2c8421f107(// Very liberal definition of what any incoming header might look like
baggageHeader) {
    const baggageObject = $8ef2851bd0adcf53$export$397de414d189db00(baggageHeader);
    if (!baggageObject) return undefined;
    // Read all "sentry-" prefixed values out of the baggage object and put it onto a dynamic sampling context object.
    const dynamicSamplingContext = Object.entries(baggageObject).reduce((acc, [key, value])=>{
        if (key.startsWith($8ef2851bd0adcf53$export$6e69537d67fa20f)) {
            const nonPrefixedKey = key.slice($8ef2851bd0adcf53$export$6e69537d67fa20f.length);
            acc[nonPrefixedKey] = value;
        }
        return acc;
    }, {});
    // Only return a dynamic sampling context object if there are keys in it.
    // A keyless object means there were no sentry values on the header, which means that there is no DSC.
    if (Object.keys(dynamicSamplingContext).length > 0) return dynamicSamplingContext;
    else return undefined;
}
/**
 * Turns a Dynamic Sampling Object into a baggage header by prefixing all the keys on the object with "sentry-".
 *
 * @param dynamicSamplingContext The Dynamic Sampling Context to turn into a header. For convenience and compatibility
 * with the `getDynamicSamplingContext` method on the Transaction class ,this argument can also be `undefined`. If it is
 * `undefined` the function will return `undefined`.
 * @returns a baggage header, created from `dynamicSamplingContext`, or `undefined` either if `dynamicSamplingContext`
 * was `undefined`, or if `dynamicSamplingContext` didn't contain any values.
 */ function $8ef2851bd0adcf53$export$56766feef403f365(// this also takes undefined for convenience and bundle size in other places
dynamicSamplingContext) {
    if (!dynamicSamplingContext) return undefined;
    // Prefix all DSC keys with "sentry-" and put them into a new object
    const sentryPrefixedDSC = Object.entries(dynamicSamplingContext).reduce((acc, [dscKey, dscValue])=>{
        if (dscValue) acc[`${$8ef2851bd0adcf53$export$6e69537d67fa20f}${dscKey}`] = dscValue;
        return acc;
    }, {});
    return $8ef2851bd0adcf53$export$12a7349a29a6e3c2(sentryPrefixedDSC);
}
/**
 * Take a baggage header and parse it into an object.
 */ function $8ef2851bd0adcf53$export$397de414d189db00(baggageHeader) {
    if (!baggageHeader || !(0, $13cf2ed412f405fa$export$844ec244b1367d54)(baggageHeader) && !Array.isArray(baggageHeader)) return undefined;
    if (Array.isArray(baggageHeader)) // Combine all baggage headers into one object containing the baggage values so we can later read the Sentry-DSC-values from it
    return baggageHeader.reduce((acc, curr)=>{
        const currBaggageObject = $8ef2851bd0adcf53$var$baggageHeaderToObject(curr);
        Object.entries(currBaggageObject).forEach(([key, value])=>{
            acc[key] = value;
        });
        return acc;
    }, {});
    return $8ef2851bd0adcf53$var$baggageHeaderToObject(baggageHeader);
}
/**
 * Will parse a baggage header, which is a simple key-value map, into a flat object.
 *
 * @param baggageHeader The baggage header to parse.
 * @returns a flat object containing all the key-value pairs from `baggageHeader`.
 */ function $8ef2851bd0adcf53$var$baggageHeaderToObject(baggageHeader) {
    return baggageHeader.split(',').map((baggageEntry)=>{
        const eqIdx = baggageEntry.indexOf('=');
        if (eqIdx === -1) // Likely an invalid entry
        return [];
        const key = baggageEntry.slice(0, eqIdx);
        const value = baggageEntry.slice(eqIdx + 1);
        return [
            key,
            value
        ].map((keyOrValue)=>{
            try {
                return decodeURIComponent(keyOrValue.trim());
            } catch  {
                // We ignore errors here, e.g. if the value cannot be URL decoded.
                // This will then be skipped in the next step
                return;
            }
        });
    }).reduce((acc, [key, value])=>{
        if (key && value) acc[key] = value;
        return acc;
    }, {});
}
/**
 * Turns a flat object (key-value pairs) into a baggage header, which is also just key-value pairs.
 *
 * @param object The object to turn into a baggage header.
 * @returns a baggage header string, or `undefined` if the object didn't have any values, since an empty baggage header
 * is not spec compliant.
 */ function $8ef2851bd0adcf53$export$12a7349a29a6e3c2(object) {
    if (Object.keys(object).length === 0) // An empty baggage header is not spec compliant: We return undefined.
    return undefined;
    return Object.entries(object).reduce((baggageHeader, [objectKey, objectValue], currentIndex)=>{
        const baggageEntry = `${encodeURIComponent(objectKey)}=${encodeURIComponent(objectValue)}`;
        const newBaggageHeader = currentIndex === 0 ? baggageEntry : `${baggageHeader},${baggageEntry}`;
        if (newBaggageHeader.length > $8ef2851bd0adcf53$export$bdd844ddb2def819) {
            (0, $19fdbaf7f0830971$export$16a28057038b10ef) && (0, $d11ed0b3cdda6b8d$export$1c9f709888824e05).warn(`Not adding key: ${objectKey} with val: ${objectValue} to baggage header due to exceeding baggage size limits.`);
            return baggageHeader;
        } else return newBaggageHeader;
    }, '');
}




/* eslint-disable */ // Vendor "Awaited" in to be TS 3.8 compatible
/**
 * Wrap a callback function with error handling.
 * If an error is thrown, it will be passed to the `onError` callback and re-thrown.
 *
 * If the return value of the function is a promise, it will be handled with `maybeHandlePromiseRejection`.
 *
 * If an `onFinally` callback is provided, this will be called when the callback has finished
 * - so if it returns a promise, once the promise resolved/rejected,
 * else once the callback has finished executing.
 * The `onFinally` callback will _always_ be called, no matter if an error was thrown or not.
 */ function $2c3cb4034c24252d$export$18ce21a8b7efd7e9(fn, onError, onFinally = ()=>{}, onSuccess = ()=>{}) {
    let maybePromiseResult;
    try {
        maybePromiseResult = fn();
    } catch (e) {
        onError(e);
        onFinally();
        throw e;
    }
    return $2c3cb4034c24252d$var$maybeHandlePromiseRejection(maybePromiseResult, onError, onFinally, onSuccess);
}
/**
 * Maybe handle a promise rejection.
 * This expects to be given a value that _may_ be a promise, or any other value.
 * If it is a promise, and it rejects, it will call the `onError` callback.
 * Other than this, it will generally return the given value as-is.
 */ function $2c3cb4034c24252d$var$maybeHandlePromiseRejection(value, onError, onFinally, onSuccess) {
    if ((0, $13cf2ed412f405fa$export$f5b060c2914b97c8)(value)) // @ts-expect-error - the isThenable check returns the "wrong" type here
    return value.then((res)=>{
        onFinally();
        onSuccess(res);
        return res;
    }, (e)=>{
        onError(e);
        onFinally();
        throw e;
    });
    onFinally();
    onSuccess(value);
    return value;
}



// Treeshakable guard to remove all code related to tracing
/**
 * Determines if span recording is currently enabled.
 *
 * Spans are recorded when at least one of `tracesSampleRate` and `tracesSampler`
 * is defined in the SDK config. This function does not make any assumption about
 * sampling decisions, it only checks if the SDK is configured to record spans.
 *
 * Important: This function only determines if span recording is enabled. Trace
 * continuation and propagation is separately controlled and not covered by this function.
 * If this function returns `false`, traces can still be propagated (which is what
 * we refer to by "Tracing without Performance")
 * @see https://develop.sentry.dev/sdk/telemetry/traces/tracing-without-performance/
 *
 * @param maybeOptions An SDK options object to be passed to this function.
 * If this option is not provided, the function will use the current client's options.
 */ function $e3827447d651dfc5$export$1f70765132c3c225(maybeOptions) {
    if (typeof __SENTRY_TRACING__ === 'boolean' && !__SENTRY_TRACING__) return false;
    const options = maybeOptions || (0, $7d48e1ed9f699a01$export$6bb76d6eba7e258c)()?.getOptions();
    return !!options && // Note: This check is `!= null`, meaning "nullish". `0` is not "nullish", `undefined` and `null` are. (This comment was brought to you by 15 minutes of questioning life)
    (options.tracesSampleRate != null || !!options.tracesSampler);
}


/**
 * Parse a sample rate from a given value.
 * This will either return a boolean or number sample rate, if the sample rate is valid (between 0 and 1).
 * If a string is passed, we try to convert it to a number.
 *
 * Any invalid sample rate will return `undefined`.
 */ function $921fe5f527b40422$export$a5bd2d81656d9546(sampleRate) {
    if (typeof sampleRate === 'boolean') return Number(sampleRate);
    const rate = typeof sampleRate === 'string' ? parseFloat(sampleRate) : sampleRate;
    if (typeof rate !== 'number' || isNaN(rate) || rate < 0 || rate > 1) return undefined;
    return rate;
}









const $fda37f10dc06a152$export$136e25984ba4a383 = 0;
const $fda37f10dc06a152$export$58f7963109c806fc = 1;
const $fda37f10dc06a152$export$f966a0446ece71e = 2;
/**
 * Converts a HTTP status code into a sentry status with a message.
 *
 * @param httpStatus The HTTP response status code.
 * @returns The span status or internal_error.
 */ // https://develop.sentry.dev/sdk/event-payloads/span/
function $fda37f10dc06a152$export$5fd4dc48a2131589(httpStatus) {
    if (httpStatus < 400 && httpStatus >= 100) return {
        code: $fda37f10dc06a152$export$58f7963109c806fc
    };
    if (httpStatus >= 400 && httpStatus < 500) switch(httpStatus){
        case 401:
            return {
                code: $fda37f10dc06a152$export$f966a0446ece71e,
                message: 'unauthenticated'
            };
        case 403:
            return {
                code: $fda37f10dc06a152$export$f966a0446ece71e,
                message: 'permission_denied'
            };
        case 404:
            return {
                code: $fda37f10dc06a152$export$f966a0446ece71e,
                message: 'not_found'
            };
        case 409:
            return {
                code: $fda37f10dc06a152$export$f966a0446ece71e,
                message: 'already_exists'
            };
        case 413:
            return {
                code: $fda37f10dc06a152$export$f966a0446ece71e,
                message: 'failed_precondition'
            };
        case 429:
            return {
                code: $fda37f10dc06a152$export$f966a0446ece71e,
                message: 'resource_exhausted'
            };
        case 499:
            return {
                code: $fda37f10dc06a152$export$f966a0446ece71e,
                message: 'cancelled'
            };
        default:
            return {
                code: $fda37f10dc06a152$export$f966a0446ece71e,
                message: 'invalid_argument'
            };
    }
    if (httpStatus >= 500 && httpStatus < 600) switch(httpStatus){
        case 501:
            return {
                code: $fda37f10dc06a152$export$f966a0446ece71e,
                message: 'unimplemented'
            };
        case 503:
            return {
                code: $fda37f10dc06a152$export$f966a0446ece71e,
                message: 'unavailable'
            };
        case 504:
            return {
                code: $fda37f10dc06a152$export$f966a0446ece71e,
                message: 'deadline_exceeded'
            };
        default:
            return {
                code: $fda37f10dc06a152$export$f966a0446ece71e,
                message: 'internal_error'
            };
    }
    return {
        code: $fda37f10dc06a152$export$f966a0446ece71e,
        message: 'internal_error'
    };
}
/**
 * Sets the Http status attributes on the current span based on the http code.
 * Additionally, the span's status is updated, depending on the http code.
 */ function $fda37f10dc06a152$export$2ad6630ec8164254(span, httpStatus) {
    span.setAttribute('http.response.status_code', httpStatus);
    const spanStatus = $fda37f10dc06a152$export$5fd4dc48a2131589(httpStatus);
    if (spanStatus.message !== 'unknown_error') span.setStatus(spanStatus);
}




const $e54da191c628b5f0$var$SCOPE_ON_START_SPAN_FIELD = '_sentryScope';
const $e54da191c628b5f0$var$ISOLATION_SCOPE_ON_START_SPAN_FIELD = '_sentryIsolationScope';
/** Wrap a scope with a WeakRef if available, falling back to a direct scope. */ function $e54da191c628b5f0$var$wrapScopeWithWeakRef(scope) {
    try {
        // @ts-expect-error - WeakRef is not available in all environments
        const WeakRefClass = (0, $736a69486c86d36c$export$f1a6cdb1459e81d1).WeakRef;
        if (typeof WeakRefClass === 'function') return new WeakRefClass(scope);
    } catch  {
    // WeakRef not available or failed to create
    // We'll fall back to a direct scope
    }
    return scope;
}
/** Try to unwrap a scope from a potential WeakRef wrapper. */ function $e54da191c628b5f0$var$unwrapScopeFromWeakRef(scopeRef) {
    if (!scopeRef) return undefined;
    if (typeof scopeRef === 'object' && 'deref' in scopeRef && typeof scopeRef.deref === 'function') try {
        return scopeRef.deref();
    } catch  {
        return undefined;
    }
    // Fallback to a direct scope
    return scopeRef;
}
/** Store the scope & isolation scope for a span, which can the be used when it is finished. */ function $e54da191c628b5f0$export$cddb4027e3b0dd66(span, scope, isolationScope) {
    if (span) {
        (0, $269eeb69635ed414$export$e73679ffaf56810e)(span, $e54da191c628b5f0$var$ISOLATION_SCOPE_ON_START_SPAN_FIELD, $e54da191c628b5f0$var$wrapScopeWithWeakRef(isolationScope));
        // We don't wrap the scope with a WeakRef here because webkit aggressively garbage collects
        // and scopes are not held in memory for long periods of time.
        (0, $269eeb69635ed414$export$e73679ffaf56810e)(span, $e54da191c628b5f0$var$SCOPE_ON_START_SPAN_FIELD, scope);
    }
}
/**
 * Grabs the scope and isolation scope off a span that were active when the span was started.
 * If WeakRef was used and scopes have been garbage collected, returns undefined for those scopes.
 */ function $e54da191c628b5f0$export$c08fbc656a245d03(span) {
    const spanWithScopes = span;
    return {
        scope: spanWithScopes[$e54da191c628b5f0$var$SCOPE_ON_START_SPAN_FIELD],
        isolationScope: $e54da191c628b5f0$var$unwrapScopeFromWeakRef(spanWithScopes[$e54da191c628b5f0$var$ISOLATION_SCOPE_ON_START_SPAN_FIELD])
    };
}









/** Regular expression used to extract org ID from a DSN host. */ const $1e1399eeae328b26$var$ORG_ID_REGEX = /^o(\d+)\./;
/** Regular expression used to parse a Dsn. */ const $1e1399eeae328b26$var$DSN_REGEX = /^(?:(\w+):)\/\/(?:(\w+)(?::(\w+)?)?@)((?:\[[:.%\w]+\]|[\w.-]+))(?::(\d+))?\/(.+)/;
function $1e1399eeae328b26$var$isValidProtocol(protocol) {
    return protocol === 'http' || protocol === 'https';
}
/**
 * Renders the string representation of this Dsn.
 *
 * By default, this will render the public representation without the password
 * component. To get the deprecated private representation, set `withPassword`
 * to true.
 *
 * @param withPassword When set to true, the password will be included.
 */ function $1e1399eeae328b26$export$44d472fbb931a776(dsn, withPassword = false) {
    const { host: host, path: path, pass: pass, port: port, projectId: projectId, protocol: protocol, publicKey: publicKey } = dsn;
    return `${protocol}://${publicKey}${withPassword && pass ? `:${pass}` : ''}` + `@${host}${port ? `:${port}` : ''}/${path ? `${path}/` : path}${projectId}`;
}
/**
 * Parses a Dsn from a given string.
 *
 * @param str A Dsn as string
 * @returns Dsn as DsnComponents or undefined if @param str is not a valid DSN string
 */ function $1e1399eeae328b26$export$b892860177f70a30(str) {
    const match = $1e1399eeae328b26$var$DSN_REGEX.exec(str);
    if (!match) {
        // This should be logged to the console
        (0, $d11ed0b3cdda6b8d$export$cda52e2a8927a2ca)(()=>{
            // eslint-disable-next-line no-console
            console.error(`Invalid Sentry Dsn: ${str}`);
        });
        return undefined;
    }
    const [protocol, publicKey, pass = '', host = '', port = '', lastPath = ''] = match.slice(1);
    let path = '';
    let projectId = lastPath;
    const split = projectId.split('/');
    if (split.length > 1) {
        path = split.slice(0, -1).join('/');
        projectId = split.pop();
    }
    if (projectId) {
        const projectMatch = projectId.match(/^\d+/);
        if (projectMatch) projectId = projectMatch[0];
    }
    return $1e1399eeae328b26$var$dsnFromComponents({
        host: host,
        pass: pass,
        path: path,
        projectId: projectId,
        port: port,
        protocol: protocol,
        publicKey: publicKey
    });
}
function $1e1399eeae328b26$var$dsnFromComponents(components) {
    return {
        protocol: components.protocol,
        publicKey: components.publicKey || '',
        pass: components.pass || '',
        host: components.host,
        port: components.port || '',
        path: components.path || '',
        projectId: components.projectId
    };
}
function $1e1399eeae328b26$var$validateDsn(dsn) {
    if (!(0, $19fdbaf7f0830971$export$16a28057038b10ef)) return true;
    const { port: port, projectId: projectId, protocol: protocol } = dsn;
    const requiredComponents = [
        'protocol',
        'publicKey',
        'host',
        'projectId'
    ];
    const hasMissingRequiredComponent = requiredComponents.find((component)=>{
        if (!dsn[component]) {
            (0, $d11ed0b3cdda6b8d$export$1c9f709888824e05).error(`Invalid Sentry Dsn: ${component} missing`);
            return true;
        }
        return false;
    });
    if (hasMissingRequiredComponent) return false;
    if (!projectId.match(/^\d+$/)) {
        (0, $d11ed0b3cdda6b8d$export$1c9f709888824e05).error(`Invalid Sentry Dsn: Invalid projectId ${projectId}`);
        return false;
    }
    if (!$1e1399eeae328b26$var$isValidProtocol(protocol)) {
        (0, $d11ed0b3cdda6b8d$export$1c9f709888824e05).error(`Invalid Sentry Dsn: Invalid protocol ${protocol}`);
        return false;
    }
    if (port && isNaN(parseInt(port, 10))) {
        (0, $d11ed0b3cdda6b8d$export$1c9f709888824e05).error(`Invalid Sentry Dsn: Invalid port ${port}`);
        return false;
    }
    return true;
}
/**
 * Extract the org ID from a DSN host.
 *
 * @param host The host from a DSN
 * @returns The org ID if found, undefined otherwise
 */ function $1e1399eeae328b26$export$5914f4e7748c29c9(host) {
    const match = host.match($1e1399eeae328b26$var$ORG_ID_REGEX);
    return match?.[1];
}
/**
 *  Returns the organization ID of the client.
 *
 *  The organization ID is extracted from the DSN. If the client options include a `orgId`, this will always take precedence.
 */ function $1e1399eeae328b26$export$b7ac9b8efa4bb595(client) {
    const options = client.getOptions();
    const { host: host } = client.getDsn() || {};
    let org_id;
    if (options.orgId) org_id = String(options.orgId);
    else if (host) org_id = $1e1399eeae328b26$export$5914f4e7748c29c9(host);
    return org_id;
}
/**
 * Creates a valid Sentry Dsn object, identifying a Sentry instance and project.
 * @returns a valid DsnComponents object or `undefined` if @param from is an invalid DSN source
 */ function $1e1399eeae328b26$export$128827c3562ec0cb(from) {
    const components = typeof from === 'string' ? $1e1399eeae328b26$export$b892860177f70a30(from) : $1e1399eeae328b26$var$dsnFromComponents(from);
    if (!components || !$1e1399eeae328b26$var$validateDsn(components)) return undefined;
    return components;
}





// oxlint-disable-next-line sdk/no-regexp-constructor -- RegExp is used for readability here
const $bcc4fe773b74e41d$export$394a210812ba3012 = new RegExp("^[ \\t]*([0-9a-f]{32})?-?([0-9a-f]{16})?-?([01])?[ \\t]*$");
/**
 * Extract transaction context data from a `sentry-trace` header.
 *
 * This is terrible naming but the function has nothing to do with the W3C traceparent header.
 * It can only parse the `sentry-trace` header and extract the "trace parent" data.
 *
 * @param traceparent Traceparent string
 *
 * @returns Object containing data from the header, or undefined if traceparent string is malformed
 */ function $bcc4fe773b74e41d$export$8e9a29865c0a1226(traceparent) {
    if (!traceparent) return undefined;
    const matches = traceparent.match($bcc4fe773b74e41d$export$394a210812ba3012);
    if (!matches) return undefined;
    let parentSampled;
    if (matches[3] === '1') parentSampled = true;
    else if (matches[3] === '0') parentSampled = false;
    return {
        traceId: matches[1],
        parentSampled: parentSampled,
        parentSpanId: matches[2]
    };
}
/**
 * Create a propagation context from incoming headers or
 * creates a minimal new one if the headers are undefined.
 */ function $bcc4fe773b74e41d$export$261f383d16a93e39(sentryTrace, baggage) {
    const traceparentData = $bcc4fe773b74e41d$export$8e9a29865c0a1226(sentryTrace);
    const dynamicSamplingContext = (0, $8ef2851bd0adcf53$export$5b96ee2c8421f107)(baggage);
    if (!traceparentData?.traceId) return {
        traceId: (0, $ece9bac57decbcb8$export$dc6d7ea554bcce10)(),
        sampleRand: (0, $c80d7f6644a3b50b$export$9869d72de32a3917)()
    };
    const sampleRand = $bcc4fe773b74e41d$var$getSampleRandFromTraceparentAndDsc(traceparentData, dynamicSamplingContext);
    // The sample_rand on the DSC needs to be generated based on traceparent + baggage.
    if (dynamicSamplingContext) dynamicSamplingContext.sample_rand = sampleRand.toString();
    const { traceId: traceId, parentSpanId: parentSpanId, parentSampled: parentSampled } = traceparentData;
    return {
        traceId: traceId,
        parentSpanId: parentSpanId,
        sampled: parentSampled,
        dsc: dynamicSamplingContext || {},
        sampleRand: sampleRand
    };
}
/**
 * Create sentry-trace header from span context values.
 */ function $bcc4fe773b74e41d$export$f35d907436da45cf(traceId = (0, $ece9bac57decbcb8$export$dc6d7ea554bcce10)(), spanId = (0, $ece9bac57decbcb8$export$295213bc4d0c54ad)(), sampled) {
    let sampledString = '';
    if (sampled !== undefined) sampledString = sampled ? '-1' : '-0';
    return `${traceId}-${spanId}${sampledString}`;
}
/**
 * Creates a W3C traceparent header from the given trace and span ids.
 */ function $bcc4fe773b74e41d$export$1aff3752542747dd(traceId = (0, $ece9bac57decbcb8$export$dc6d7ea554bcce10)(), spanId = (0, $ece9bac57decbcb8$export$295213bc4d0c54ad)(), sampled) {
    return `00-${traceId}-${spanId}-${sampled ? '01' : '00'}`;
}
/**
 * Given any combination of an incoming trace, generate a sample rand based on its defined semantics.
 *
 * Read more: https://develop.sentry.dev/sdk/telemetry/traces/#propagated-random-value
 */ function $bcc4fe773b74e41d$var$getSampleRandFromTraceparentAndDsc(traceparentData, dsc) {
    // When there is an incoming sample rand use it.
    const parsedSampleRand = (0, $921fe5f527b40422$export$a5bd2d81656d9546)(dsc?.sample_rand);
    if (parsedSampleRand !== undefined) return parsedSampleRand;
    // Otherwise, if there is an incoming sampling decision + sample rate, generate a sample rand that would lead to the same sampling decision.
    const parsedSampleRate = (0, $921fe5f527b40422$export$a5bd2d81656d9546)(dsc?.sample_rate);
    if (parsedSampleRate && traceparentData?.parentSampled !== undefined) return traceparentData.parentSampled ? (0, $c80d7f6644a3b50b$export$9869d72de32a3917)() * parsedSampleRate : parsedSampleRate + (0, $c80d7f6644a3b50b$export$9869d72de32a3917)() * (1 - parsedSampleRate);
    else // If nothing applies, return a random sample rand.
    return (0, $c80d7f6644a3b50b$export$9869d72de32a3917)();
}
/**
 * Determines whether a new trace should be continued based on the provided baggage org ID and the client's `strictTraceContinuation` option.
 * If the trace should not be continued, a new trace will be started.
 *
 * The result is dependent on the `strictTraceContinuation` option in the client.
 * See https://develop.sentry.dev/sdk/telemetry/traces/#stricttracecontinuation
 */ function $bcc4fe773b74e41d$export$18811bc99eefceaa(client, baggageOrgId) {
    const clientOrgId = (0, $1e1399eeae328b26$export$b7ac9b8efa4bb595)(client);
    // Case: baggage orgID and Client orgID don't match - always start new trace
    if (baggageOrgId && clientOrgId && baggageOrgId !== clientOrgId) {
        (0, $d11ed0b3cdda6b8d$export$1c9f709888824e05).log(`Won't continue trace because org IDs don't match (incoming baggage: ${baggageOrgId}, SDK options: ${clientOrgId})`);
        return false;
    }
    const strictTraceContinuation = client.getOptions().strictTraceContinuation || false; // default for `strictTraceContinuation` is `false`
    if (strictTraceContinuation) // With strict continuation enabled, don't continue trace if:
    // - Baggage has orgID, but Client doesn't have one
    // - Client has orgID, but baggage doesn't have one
    {
        if (baggageOrgId && !clientOrgId || !baggageOrgId && clientOrgId) {
            (0, $d11ed0b3cdda6b8d$export$1c9f709888824e05).log(`Starting a new trace because strict trace continuation is enabled but one org ID is missing (incoming baggage: ${baggageOrgId}, Sentry client: ${clientOrgId})`);
            return false;
        }
    }
    return true;
}




// These are aligned with OpenTelemetry trace flags
const $bb9b6447bf4caedb$export$208d5b368507fb8b = 0x0;
const $bb9b6447bf4caedb$export$eb571cd9b5d98de8 = 0x1;
let $bb9b6447bf4caedb$var$hasShownSpanDropWarning = false;
/**
 * Convert a span to a trace context, which can be sent as the `trace` context in an event.
 * By default, this will only include trace_id, span_id & parent_span_id.
 * If `includeAllData` is true, it will also include data, op, status & origin.
 */ function $bb9b6447bf4caedb$export$4c3967a8a2f6bbd6(span) {
    const { spanId: span_id, traceId: trace_id } = span.spanContext();
    const { data: data, op: op, parent_span_id: parent_span_id, status: status, origin: origin, links: links } = $bb9b6447bf4caedb$export$92d8c23565496537(span);
    return {
        parent_span_id: parent_span_id,
        span_id: span_id,
        trace_id: trace_id,
        data: data,
        op: op,
        status: status,
        origin: origin,
        links: links
    };
}
/**
 * Convert a span to a trace context, which can be sent as the `trace` context in a non-transaction event.
 */ function $bb9b6447bf4caedb$export$46c6fbd1d265ebf0(span) {
    const { spanId: spanId, traceId: trace_id, isRemote: isRemote } = span.spanContext();
    // If the span is remote, we use a random/virtual span as span_id to the trace context,
    // and the remote span as parent_span_id
    const parent_span_id = isRemote ? spanId : $bb9b6447bf4caedb$export$92d8c23565496537(span).parent_span_id;
    const scope = (0, $e54da191c628b5f0$export$c08fbc656a245d03)(span).scope;
    const span_id = isRemote ? scope?.getPropagationContext().propagationSpanId || (0, $ece9bac57decbcb8$export$295213bc4d0c54ad)() : spanId;
    return {
        parent_span_id: parent_span_id,
        span_id: span_id,
        trace_id: trace_id
    };
}
/**
 * Convert a Span to a Sentry trace header.
 */ function $bb9b6447bf4caedb$export$7e9f8ae9e4a328ab(span) {
    const { traceId: traceId, spanId: spanId } = span.spanContext();
    const sampled = $bb9b6447bf4caedb$export$5caecac1caaf3a71(span);
    return (0, $bcc4fe773b74e41d$export$f35d907436da45cf)(traceId, spanId, sampled);
}
/**
 * Convert a Span to a W3C traceparent header.
 */ function $bb9b6447bf4caedb$export$cda58d87bc594e9f(span) {
    const { traceId: traceId, spanId: spanId } = span.spanContext();
    const sampled = $bb9b6447bf4caedb$export$5caecac1caaf3a71(span);
    return (0, $bcc4fe773b74e41d$export$1aff3752542747dd)(traceId, spanId, sampled);
}
/**
 *  Converts the span links array to a flattened version to be sent within an envelope.
 *
 *  If the links array is empty, it returns `undefined` so the empty value can be dropped before it's sent.
 */ function $bb9b6447bf4caedb$export$cb3e3a12e0eec16c(links) {
    if (links && links.length > 0) return links.map(({ context: { spanId: spanId, traceId: traceId, traceFlags: traceFlags, ...restContext }, attributes: attributes })=>({
            span_id: spanId,
            trace_id: traceId,
            sampled: traceFlags === $bb9b6447bf4caedb$export$eb571cd9b5d98de8,
            attributes: attributes,
            ...restContext
        }));
    else return undefined;
}
/**
 * Convert a span time input into a timestamp in seconds.
 */ function $bb9b6447bf4caedb$export$3f7581298f56c6d7(input) {
    if (typeof input === 'number') return $bb9b6447bf4caedb$var$ensureTimestampInSeconds(input);
    if (Array.isArray(input)) // See {@link HrTime} for the array-based time format
    return input[0] + input[1] / 1e9;
    if (input instanceof Date) return $bb9b6447bf4caedb$var$ensureTimestampInSeconds(input.getTime());
    return (0, $bc81602376c48fa6$export$ee52dced521e3e18)();
}
/**
 * Converts a timestamp to second, if it was in milliseconds, or keeps it as second.
 */ function $bb9b6447bf4caedb$var$ensureTimestampInSeconds(timestamp) {
    const isMs = timestamp > 9999999999;
    return isMs ? timestamp / 1000 : timestamp;
}
/**
 * Convert a span to a JSON representation.
 */ // Note: Because of this, we currently have a circular type dependency (which we opted out of in package.json).
// This is not avoidable as we need `spanToJSON` in `spanUtils.ts`, which in turn is needed by `span.ts` for backwards compatibility.
// And `spanToJSON` needs the Span class from `span.ts` to check here.
function $bb9b6447bf4caedb$export$92d8c23565496537(span) {
    if ($bb9b6447bf4caedb$var$spanIsSentrySpan(span)) return span.getSpanJSON();
    const { spanId: span_id, traceId: trace_id } = span.spanContext();
    // Handle a span from @opentelemetry/sdk-base-trace's `Span` class
    if ($bb9b6447bf4caedb$var$spanIsOpenTelemetrySdkTraceBaseSpan(span)) {
        const { attributes: attributes, startTime: startTime, name: name, endTime: endTime, status: status, links: links } = span;
        // In preparation for the next major of OpenTelemetry, we want to support
        // looking up the parent span id according to the new API
        // In OTel v1, the parent span id is accessed as `parentSpanId`
        // In OTel v2, the parent span id is accessed as `spanId` on the `parentSpanContext`
        const parentSpanId = 'parentSpanId' in span ? span.parentSpanId : 'parentSpanContext' in span ? span.parentSpanContext?.spanId : undefined;
        return {
            span_id: span_id,
            trace_id: trace_id,
            data: attributes,
            description: name,
            parent_span_id: parentSpanId,
            start_timestamp: $bb9b6447bf4caedb$export$3f7581298f56c6d7(startTime),
            // This is [0,0] by default in OTEL, in which case we want to interpret this as no end time
            timestamp: $bb9b6447bf4caedb$export$3f7581298f56c6d7(endTime) || undefined,
            status: $bb9b6447bf4caedb$export$e238a77ea3a8cd66(status),
            op: attributes[0, $f337c80285f06f80$export$1a413bd9a88fdb09],
            origin: attributes[0, $f337c80285f06f80$export$cca8dd30f57f805e],
            links: $bb9b6447bf4caedb$export$cb3e3a12e0eec16c(links)
        };
    }
    // Finally, at least we have `spanContext()`....
    // This should not actually happen in reality, but we need to handle it for type safety.
    return {
        span_id: span_id,
        trace_id: trace_id,
        start_timestamp: 0,
        data: {}
    };
}
function $bb9b6447bf4caedb$var$spanIsOpenTelemetrySdkTraceBaseSpan(span) {
    const castSpan = span;
    return !!castSpan.attributes && !!castSpan.startTime && !!castSpan.name && !!castSpan.endTime && !!castSpan.status;
}
/** Exported only for tests. */ /**
 * Sadly, due to circular dependency checks we cannot actually import the Span class here and check for instanceof.
 * :( So instead we approximate this by checking if it has the `getSpanJSON` method.
 */ function $bb9b6447bf4caedb$var$spanIsSentrySpan(span) {
    return typeof span.getSpanJSON === 'function';
}
/**
 * Returns true if a span is sampled.
 * In most cases, you should just use `span.isRecording()` instead.
 * However, this has a slightly different semantic, as it also returns false if the span is finished.
 * So in the case where this distinction is important, use this method.
 */ function $bb9b6447bf4caedb$export$5caecac1caaf3a71(span) {
    // We align our trace flags with the ones OpenTelemetry use
    // So we also check for sampled the same way they do.
    const { traceFlags: traceFlags } = span.spanContext();
    return traceFlags === $bb9b6447bf4caedb$export$eb571cd9b5d98de8;
}
/** Get the status message to use for a JSON representation of a span. */ function $bb9b6447bf4caedb$export$e238a77ea3a8cd66(status) {
    if (!status || status.code === (0, $fda37f10dc06a152$export$136e25984ba4a383)) return undefined;
    if (status.code === (0, $fda37f10dc06a152$export$58f7963109c806fc)) return 'ok';
    return status.message || 'internal_error';
}
const $bb9b6447bf4caedb$var$CHILD_SPANS_FIELD = '_sentryChildSpans';
const $bb9b6447bf4caedb$var$ROOT_SPAN_FIELD = '_sentryRootSpan';
/**
 * Adds an opaque child span reference to a span.
 */ function $bb9b6447bf4caedb$export$81397d924722cc65(span, childSpan) {
    // We store the root span reference on the child span
    // We need this for `getRootSpan()` to work
    const rootSpan = span[$bb9b6447bf4caedb$var$ROOT_SPAN_FIELD] || span;
    (0, $269eeb69635ed414$export$e73679ffaf56810e)(childSpan, $bb9b6447bf4caedb$var$ROOT_SPAN_FIELD, rootSpan);
    // We store a list of child spans on the parent span
    // We need this for `getSpanDescendants()` to work
    if (span[$bb9b6447bf4caedb$var$CHILD_SPANS_FIELD]) span[$bb9b6447bf4caedb$var$CHILD_SPANS_FIELD].add(childSpan);
    else (0, $269eeb69635ed414$export$e73679ffaf56810e)(span, $bb9b6447bf4caedb$var$CHILD_SPANS_FIELD, new Set([
        childSpan
    ]));
}
/** This is only used internally by Idle Spans. */ function $bb9b6447bf4caedb$export$c2a0c9438bb89d91(span, childSpan) {
    if (span[$bb9b6447bf4caedb$var$CHILD_SPANS_FIELD]) span[$bb9b6447bf4caedb$var$CHILD_SPANS_FIELD].delete(childSpan);
}
/**
 * Returns an array of the given span and all of its descendants.
 */ function $bb9b6447bf4caedb$export$340c5c8a13ffc680(span) {
    const resultSet = new Set();
    function addSpanChildren(span) {
        // This exit condition is required to not infinitely loop in case of a circular dependency.
        if (resultSet.has(span)) return;
        else if ($bb9b6447bf4caedb$export$5caecac1caaf3a71(span)) {
            resultSet.add(span);
            const childSpans = span[$bb9b6447bf4caedb$var$CHILD_SPANS_FIELD] ? Array.from(span[$bb9b6447bf4caedb$var$CHILD_SPANS_FIELD]) : [];
            for (const childSpan of childSpans)addSpanChildren(childSpan);
        }
    }
    addSpanChildren(span);
    return Array.from(resultSet);
}
/**
 * Returns the root span of a given span.
 */ function $bb9b6447bf4caedb$export$c4c6a79b1260ca1b(span) {
    return span[$bb9b6447bf4caedb$var$ROOT_SPAN_FIELD] || span;
}
/**
 * Returns the currently active span.
 */ function $bb9b6447bf4caedb$export$1be426a8e585c83e() {
    const carrier = (0, $e4c75fb63b040566$export$19eade501500c6c1)();
    const acs = (0, $a8b8acc568359454$export$f639b0c2752203be)(carrier);
    if (acs.getActiveSpan) return acs.getActiveSpan();
    return (0, $dab1970d0c142a42$export$91f063ebb8eff307)((0, $7d48e1ed9f699a01$export$c7be4b0125a10cba)());
}
/**
 * Logs a warning once if `beforeSendSpan` is used to drop spans.
 */ function $bb9b6447bf4caedb$export$d11691ff45a3e535() {
    if (!$bb9b6447bf4caedb$var$hasShownSpanDropWarning) {
        (0, $d11ed0b3cdda6b8d$export$cda52e2a8927a2ca)(()=>{
            // eslint-disable-next-line no-console
            console.warn('[Sentry] Returning null from `beforeSendSpan` is disallowed. To drop certain spans, configure the respective integrations directly or use `ignoreSpans`.');
        });
        $bb9b6447bf4caedb$var$hasShownSpanDropWarning = true;
    }
}
/**
 * Updates the name of the given span and ensures that the span name is not
 * overwritten by the Sentry SDK.
 *
 * Use this function instead of `span.updateName()` if you want to make sure that
 * your name is kept. For some spans, for example root `http.server` spans the
 * Sentry SDK would otherwise overwrite the span name with a high-quality name
 * it infers when the span ends.
 *
 * Use this function in server code or when your span is started on the server
 * and on the client (browser). If you only update a span name on the client,
 * you can also use `span.updateName()` the SDK does not overwrite the name.
 *
 * @param span - The span to update the name of.
 * @param name - The name to set on the span.
 */ function $bb9b6447bf4caedb$export$5b72d3169c1be715(span, name) {
    span.updateName(name);
    span.setAttributes({
        [(0, $f337c80285f06f80$export$d7a7d984b0791405)]: 'custom',
        [(0, $f337c80285f06f80$export$165ce9a229f6f050)]: name
    });
}



const $4e93b773a0d3a86a$export$849dbeeeda01ae98 = 'production';
const $4e93b773a0d3a86a$export$6829f580e78306fa = 'development';










/**
 * If you change this value, also update the terser plugin config to
 * avoid minification of the object property!
 */ const $09fae5ef8120e803$var$FROZEN_DSC_FIELD = '_frozenDsc';
/**
 * Freeze the given DSC on the given span.
 */ function $09fae5ef8120e803$export$7398c93e763ca9fd(span, dsc) {
    const spanWithMaybeDsc = span;
    (0, $269eeb69635ed414$export$e73679ffaf56810e)(spanWithMaybeDsc, $09fae5ef8120e803$var$FROZEN_DSC_FIELD, dsc);
}
/**
 * Creates a dynamic sampling context from a client.
 *
 * Dispatches the `createDsc` lifecycle hook as a side effect.
 */ function $09fae5ef8120e803$export$366bad00d6815eed(trace_id, client) {
    const options = client.getOptions();
    const { publicKey: public_key } = client.getDsn() || {};
    // Instead of conditionally adding non-undefined values, we add them and then remove them if needed
    // otherwise, the order of baggage entries changes, which "breaks" a bunch of tests etc.
    const dsc = {
        environment: options.environment || (0, $4e93b773a0d3a86a$export$849dbeeeda01ae98),
        release: options.release,
        public_key: public_key,
        trace_id: trace_id,
        org_id: (0, $1e1399eeae328b26$export$b7ac9b8efa4bb595)(client)
    };
    client.emit('createDsc', dsc);
    return dsc;
}
/**
 * Get the dynamic sampling context for the currently active scopes.
 */ function $09fae5ef8120e803$export$89ef1736f08c6b2b(client, scope) {
    const propagationContext = scope.getPropagationContext();
    return propagationContext.dsc || $09fae5ef8120e803$export$366bad00d6815eed(propagationContext.traceId, client);
}
/**
 * Creates a dynamic sampling context from a span (and client and scope)
 *
 * @param span the span from which a few values like the root span name and sample rate are extracted.
 *
 * @returns a dynamic sampling context
 */ function $09fae5ef8120e803$export$a117f995597e25df(span) {
    const client = (0, $7d48e1ed9f699a01$export$6bb76d6eba7e258c)();
    if (!client) return {};
    const rootSpan = (0, $bb9b6447bf4caedb$export$c4c6a79b1260ca1b)(span);
    const rootSpanJson = (0, $bb9b6447bf4caedb$export$92d8c23565496537)(rootSpan);
    const rootSpanAttributes = rootSpanJson.data;
    const traceState = rootSpan.spanContext().traceState;
    // The span sample rate that was locally applied to the root span should also always be applied to the DSC, even if the DSC is frozen.
    // This is so that the downstream traces/services can use parentSampleRate in their `tracesSampler` to make consistent sampling decisions across the entire trace.
    const rootSpanSampleRate = traceState?.get('sentry.sample_rate') ?? rootSpanAttributes[0, $f337c80285f06f80$export$ccfe0a40627cc34b] ?? rootSpanAttributes[0, $f337c80285f06f80$export$889fb736668e1ecc];
    function applyLocalSampleRateToDsc(dsc) {
        if (typeof rootSpanSampleRate === 'number' || typeof rootSpanSampleRate === 'string') dsc.sample_rate = `${rootSpanSampleRate}`;
        return dsc;
    }
    // For core implementation, we freeze the DSC onto the span as a non-enumerable property
    const frozenDsc = rootSpan[$09fae5ef8120e803$var$FROZEN_DSC_FIELD];
    if (frozenDsc) return applyLocalSampleRateToDsc(frozenDsc);
    // For OpenTelemetry, we freeze the DSC on the trace state
    const traceStateDsc = traceState?.get('sentry.dsc');
    // If the span has a DSC, we want it to take precedence
    const dscOnTraceState = traceStateDsc && (0, $8ef2851bd0adcf53$export$5b96ee2c8421f107)(traceStateDsc);
    if (dscOnTraceState) return applyLocalSampleRateToDsc(dscOnTraceState);
    // Else, we generate it from the span
    const dsc = $09fae5ef8120e803$export$366bad00d6815eed(span.spanContext().traceId, client);
    // We don't want to have a transaction name in the DSC if the source is "url" because URLs might contain PII
    const source = rootSpanAttributes[0, $f337c80285f06f80$export$d7a7d984b0791405];
    // after JSON conversion, txn.name becomes jsonSpan.description
    const name = rootSpanJson.description;
    if (source !== 'url' && name) dsc.transaction = name;
    // How can we even land here with hasSpansEnabled() returning false?
    // Otel creates a Non-recording span in Tracing Without Performance mode when handling incoming requests
    // So we end up with an active span that is not sampled (neither positively nor negatively)
    if ((0, $e3827447d651dfc5$export$1f70765132c3c225)()) {
        dsc.sampled = String((0, $bb9b6447bf4caedb$export$5caecac1caaf3a71)(rootSpan));
        dsc.sample_rand = // In OTEL we store the sample rand on the trace state because we cannot access scopes for NonRecordingSpans
        // The Sentry OTEL SpanSampler takes care of writing the sample rand on the root span
        traceState?.get('sentry.sample_rand') ?? // On all other platforms we can actually get the scopes from a root span (we use this as a fallback)
        (0, $e54da191c628b5f0$export$c08fbc656a245d03)(rootSpan).scope?.getPropagationContext().sampleRand.toString();
    }
    applyLocalSampleRateToDsc(dsc);
    client.emit('createDsc', dsc, rootSpan);
    return dsc;
}
/**
 * Convert a Span to a baggage header.
 */ function $09fae5ef8120e803$export$95cf936fdacaff7b(span) {
    const dsc = $09fae5ef8120e803$export$a117f995597e25df(span);
    return (0, $8ef2851bd0adcf53$export$56766feef403f365)(dsc);
}





/**
 * Print a log message for a started span.
 */ function $33f11695c2072059$export$2f3d84e767c9592b(span) {
    if (!(0, $19fdbaf7f0830971$export$16a28057038b10ef)) return;
    const { description: description = '< unknown name >', op: op = '< unknown op >', parent_span_id: parentSpanId } = (0, $bb9b6447bf4caedb$export$92d8c23565496537)(span);
    const { spanId: spanId } = span.spanContext();
    const sampled = (0, $bb9b6447bf4caedb$export$5caecac1caaf3a71)(span);
    const rootSpan = (0, $bb9b6447bf4caedb$export$c4c6a79b1260ca1b)(span);
    const isRootSpan = rootSpan === span;
    const header = `[Tracing] Starting ${sampled ? 'sampled' : 'unsampled'} ${isRootSpan ? 'root ' : ''}span`;
    const infoParts = [
        `op: ${op}`,
        `name: ${description}`,
        `ID: ${spanId}`
    ];
    if (parentSpanId) infoParts.push(`parent ID: ${parentSpanId}`);
    if (!isRootSpan) {
        const { op: op, description: description } = (0, $bb9b6447bf4caedb$export$92d8c23565496537)(rootSpan);
        infoParts.push(`root ID: ${rootSpan.spanContext().spanId}`);
        if (op) infoParts.push(`root op: ${op}`);
        if (description) infoParts.push(`root description: ${description}`);
    }
    (0, $d11ed0b3cdda6b8d$export$1c9f709888824e05).log(`${header}
  ${infoParts.join('\n  ')}`);
}
/**
 * Print a log message for an ended span.
 */ function $33f11695c2072059$export$b77c830667a4d630(span) {
    if (!(0, $19fdbaf7f0830971$export$16a28057038b10ef)) return;
    const { description: description = '< unknown name >', op: op = '< unknown op >' } = (0, $bb9b6447bf4caedb$export$92d8c23565496537)(span);
    const { spanId: spanId } = span.spanContext();
    const rootSpan = (0, $bb9b6447bf4caedb$export$c4c6a79b1260ca1b)(span);
    const isRootSpan = rootSpan === span;
    const msg = `[Tracing] Finishing "${op}" ${isRootSpan ? 'root ' : ''}span "${description}" with ID ${spanId}`;
    (0, $d11ed0b3cdda6b8d$export$1c9f709888824e05).log(msg);
}






/**
 * Makes a sampling decision for the given options.
 *
 * Called every time a root span is created. Only root spans which emerge with a `sampled` value of `true` will be
 * sent to Sentry.
 */ function $ff32a69e7fdcf77e$export$5f833db634b217bb(options, samplingContext, sampleRand) {
    // nothing to do if span recording is not enabled
    if (!(0, $e3827447d651dfc5$export$1f70765132c3c225)(options)) return [
        false
    ];
    let localSampleRateWasApplied = undefined;
    // we would have bailed already if neither `tracesSampler` nor `tracesSampleRate` were defined, so one of these should
    // work; prefer the hook if so
    let sampleRate;
    if (typeof options.tracesSampler === 'function') {
        sampleRate = options.tracesSampler({
            ...samplingContext,
            inheritOrSampleWith: (fallbackSampleRate)=>{
                // If we have an incoming parent sample rate, we'll just use that one.
                // The sampling decision will be inherited because of the sample_rand that was generated when the trace reached the incoming boundaries of the SDK.
                if (typeof samplingContext.parentSampleRate === 'number') return samplingContext.parentSampleRate;
                // Fallback if parent sample rate is not on the incoming trace (e.g. if there is no baggage)
                // This is to provide backwards compatibility if there are incoming traces from older SDKs that don't send a parent sample rate or a sample rand. In these cases we just want to force either a sampling decision on the downstream traces via the sample rate.
                if (typeof samplingContext.parentSampled === 'boolean') return Number(samplingContext.parentSampled);
                return fallbackSampleRate;
            }
        });
        localSampleRateWasApplied = true;
    } else if (samplingContext.parentSampled !== undefined) sampleRate = samplingContext.parentSampled;
    else if (typeof options.tracesSampleRate !== 'undefined') {
        sampleRate = options.tracesSampleRate;
        localSampleRateWasApplied = true;
    }
    // Since this is coming from the user (or from a function provided by the user), who knows what we might get.
    // (The only valid values are booleans or numbers between 0 and 1.)
    const parsedSampleRate = (0, $921fe5f527b40422$export$a5bd2d81656d9546)(sampleRate);
    if (parsedSampleRate === undefined) {
        (0, $19fdbaf7f0830971$export$16a28057038b10ef) && (0, $d11ed0b3cdda6b8d$export$1c9f709888824e05).warn(`[Tracing] Discarding root span because of invalid sample rate. Sample rate must be a boolean or a number between 0 and 1. Got ${JSON.stringify(sampleRate)} of type ${JSON.stringify(typeof sampleRate)}.`);
        return [
            false
        ];
    }
    // if the function returned 0 (or false), or if `tracesSampleRate` is 0, it's a sign the transaction should be dropped
    if (!parsedSampleRate) {
        (0, $19fdbaf7f0830971$export$16a28057038b10ef) && (0, $d11ed0b3cdda6b8d$export$1c9f709888824e05).log(`[Tracing] Discarding transaction because ${typeof options.tracesSampler === 'function' ? 'tracesSampler returned 0 or false' : 'a negative sampling decision was inherited or tracesSampleRate is set to 0'}`);
        return [
            false,
            parsedSampleRate,
            localSampleRateWasApplied
        ];
    }
    // We always compare the sample rand for the current execution context against the chosen sample rate.
    // Read more: https://develop.sentry.dev/sdk/telemetry/traces/#propagated-random-value
    const shouldSample = sampleRand < parsedSampleRate;
    // if we're not going to keep it, we're done
    if (!shouldSample) (0, $19fdbaf7f0830971$export$16a28057038b10ef) && (0, $d11ed0b3cdda6b8d$export$1c9f709888824e05).log(`[Tracing] Discarding transaction because it's not included in the random sample (sampling rate = ${Number(sampleRate)})`);
    return [
        shouldSample,
        parsedSampleRate,
        localSampleRateWasApplied
    ];
}




/**
 * A Sentry Span that is non-recording, meaning it will not be sent to Sentry.
 */ class $057104436ef6f1c5$export$d6636b700b76c516 {
    constructor(spanContext = {}){
        this._traceId = spanContext.traceId || (0, $ece9bac57decbcb8$export$dc6d7ea554bcce10)();
        this._spanId = spanContext.spanId || (0, $ece9bac57decbcb8$export$295213bc4d0c54ad)();
    }
    /** @inheritdoc */ spanContext() {
        return {
            spanId: this._spanId,
            traceId: this._traceId,
            traceFlags: (0, $bb9b6447bf4caedb$export$208d5b368507fb8b)
        };
    }
    /** @inheritdoc */ end(_timestamp) {}
    /** @inheritdoc */ setAttribute(_key, _value) {
        return this;
    }
    /** @inheritdoc */ setAttributes(_values) {
        return this;
    }
    /** @inheritdoc */ setStatus(_status) {
        return this;
    }
    /** @inheritdoc */ updateName(_name) {
        return this;
    }
    /** @inheritdoc */ isRecording() {
        return false;
    }
    /** @inheritdoc */ addEvent(_name, _attributesOrStartTime, _startTime) {
        return this;
    }
    /** @inheritDoc */ addLink(_link) {
        return this;
    }
    /** @inheritDoc */ addLinks(_links) {
        return this;
    }
    /**
   * This should generally not be used,
   * but we need it for being compliant with the OTEL Span interface.
   *
   * @hidden
   * @internal
   */ recordException(_exception, _time) {
    // noop
    }
}











/**
 * Recursively normalizes the given object.
 *
 * - Creates a copy to prevent original input mutation
 * - Skips non-enumerable properties
 * - When stringifying, calls `toJSON` if implemented
 * - Removes circular references
 * - Translates non-serializable values (`undefined`/`NaN`/functions) to serializable format
 * - Translates known global objects/classes to a string representations
 * - Takes care of `Error` object serialization
 * - Optionally limits depth of final output
 * - Optionally limits number of properties/elements included in any single object/array
 *
 * @param input The object to be normalized.
 * @param depth The max depth to which to normalize the object. (Anything deeper stringified whole.)
 * @param maxProperties The max number of elements or properties to be included in any single array or
 * object in the normalized output.
 * @returns A normalized version of the object, or `"**non-serializable**"` if any errors are thrown during normalization.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $2d7134eeb4bc669b$export$a3295358bff77e(input, depth = 100, maxProperties = Infinity) {
    try {
        // since we're at the outermost level, we don't provide a key
        return $2d7134eeb4bc669b$var$visit('', input, depth, maxProperties);
    } catch (err) {
        return {
            ERROR: `**non-serializable** (${err})`
        };
    }
}
/** JSDoc */ function $2d7134eeb4bc669b$export$23fbbb20bed71033(// eslint-disable-next-line @typescript-eslint/no-explicit-any
object, // Default Node.js REPL depth
depth = 3, // 100kB, as 200kB is max payload size, so half sounds reasonable
maxSize = 102400) {
    const normalized = $2d7134eeb4bc669b$export$a3295358bff77e(object, depth);
    if ($2d7134eeb4bc669b$var$jsonSize(normalized) > maxSize) return $2d7134eeb4bc669b$export$23fbbb20bed71033(object, depth - 1, maxSize);
    return normalized;
}
/**
 * Visits a node to perform normalization on it
 *
 * @param key The key corresponding to the given node
 * @param value The node to be visited
 * @param depth Optional number indicating the maximum recursion depth
 * @param maxProperties Optional maximum number of properties/elements included in any single object/array
 * @param memo Optional Memo class handling decycling
 */ function $2d7134eeb4bc669b$var$visit(key, value, depth = Infinity, maxProperties = Infinity, memo = $2d7134eeb4bc669b$var$memoBuilder()) {
    const [memoize, unmemoize] = memo;
    // Get the simple cases out of the way first
    if (value == null || // this matches null and undefined -> eqeq not eqeqeq
    [
        'boolean',
        'string'
    ].includes(typeof value) || typeof value === 'number' && Number.isFinite(value)) return value;
    const stringified = $2d7134eeb4bc669b$var$stringifyValue(key, value);
    // Anything we could potentially dig into more (objects or arrays) will have come back as `"[object XXXX]"`.
    // Everything else will have already been serialized, so if we don't see that pattern, we're done.
    if (!stringified.startsWith('[object ')) return stringified;
    // From here on, we can assert that `value` is either an object or an array.
    // Do not normalize objects that we know have already been normalized. As a general rule, the
    // "__sentry_skip_normalization__" property should only be used sparingly and only should only be set on objects that
    // have already been normalized.
    if (value['__sentry_skip_normalization__']) return value;
    // We can set `__sentry_override_normalization_depth__` on an object to ensure that from there
    // We keep a certain amount of depth.
    // This should be used sparingly, e.g. we use it for the redux integration to ensure we get a certain amount of state.
    const remainingDepth = typeof value['__sentry_override_normalization_depth__'] === 'number' ? value['__sentry_override_normalization_depth__'] : depth;
    // We're also done if we've reached the max depth
    if (remainingDepth === 0) // At this point we know `serialized` is a string of the form `"[object XXXX]"`. Clean it up so it's just `"[XXXX]"`.
    return stringified.replace('object ', '');
    // If we've already visited this branch, bail out, as it's circular reference. If not, note that we're seeing it now.
    if (memoize(value)) return '[Circular ~]';
    // If the value has a `toJSON` method, we call it to extract more information
    const valueWithToJSON = value;
    if (valueWithToJSON && typeof valueWithToJSON.toJSON === 'function') try {
        const jsonValue = valueWithToJSON.toJSON();
        // We need to normalize the return value of `.toJSON()` in case it has circular references
        return $2d7134eeb4bc669b$var$visit('', jsonValue, remainingDepth - 1, maxProperties, memo);
    } catch  {
    // pass (The built-in `toJSON` failed, but we can still try to do it ourselves)
    }
    // At this point we know we either have an object or an array, we haven't seen it before, and we're going to recurse
    // because we haven't yet reached the max depth. Create an accumulator to hold the results of visiting each
    // property/entry, and keep track of the number of items we add to it.
    const normalized = Array.isArray(value) ? [] : {};
    let numAdded = 0;
    // Before we begin, convert`Error` and`Event` instances into plain objects, since some of each of their relevant
    // properties are non-enumerable and otherwise would get missed.
    const visitable = (0, $269eeb69635ed414$export$62ff257738bf57f5)(value);
    for(const visitKey in visitable){
        // Avoid iterating over fields in the prototype if they've somehow been exposed to enumeration.
        if (!Object.prototype.hasOwnProperty.call(visitable, visitKey)) continue;
        if (numAdded >= maxProperties) {
            normalized[visitKey] = '[MaxProperties ~]';
            break;
        }
        // Recursively visit all the child nodes
        const visitValue = visitable[visitKey];
        normalized[visitKey] = $2d7134eeb4bc669b$var$visit(visitKey, visitValue, remainingDepth - 1, maxProperties, memo);
        numAdded++;
    }
    // Once we've visited all the branches, remove the parent from memo storage
    unmemoize(value);
    // Return accumulated values
    return normalized;
}
/* eslint-disable complexity */ /**
 * Stringify the given value. Handles various known special values and types.
 *
 * Not meant to be used on simple primitives which already have a string representation, as it will, for example, turn
 * the number 1231 into "[Object Number]", nor on `null`, as it will throw.
 *
 * @param value The value to stringify
 * @returns A stringified representation of the given value
 */ function $2d7134eeb4bc669b$var$stringifyValue(key, // this type is a tiny bit of a cheat, since this function does handle NaN (which is technically a number), but for
// our internal use, it'll do
value) {
    try {
        if (key === 'domain' && value && typeof value === 'object' && value._events) return '[Domain]';
        if (key === 'domainEmitter') return '[DomainEmitter]';
        // It's safe to use `global`, `window`, and `document` here in this manner, as we are asserting using `typeof` first
        // which won't throw if they are not present.
        if (typeof $parcel$global !== 'undefined' && value === $parcel$global) return '[Global]';
        // eslint-disable-next-line no-restricted-globals
        if (typeof window !== 'undefined' && value === window) return '[Window]';
        // eslint-disable-next-line no-restricted-globals
        if (typeof document !== 'undefined' && value === document) return '[Document]';
        if ((0, $13cf2ed412f405fa$export$7916fad0ebc23f48)(value)) return (0, $9ed2cf4edd0b2db9$export$b6d9c5eb2330759f)(value);
        // React's SyntheticEvent thingy
        if ((0, $13cf2ed412f405fa$export$bc2894c7158efbac)(value)) return '[SyntheticEvent]';
        if (typeof value === 'number' && !Number.isFinite(value)) return `[${value}]`;
        if (typeof value === 'function') return `[Function: ${(0, $9ed2cf4edd0b2db9$export$aad197c7121a6651)(value)}]`;
        if (typeof value === 'symbol') return `[${String(value)}]`;
        // stringified BigInts are indistinguishable from regular numbers, so we need to label them to avoid confusion
        if (typeof value === 'bigint') return `[BigInt: ${String(value)}]`;
        // Now that we've knocked out all the special cases and the primitives, all we have left are objects. Simply casting
        // them to strings means that instances of classes which haven't defined their `toStringTag` will just come out as
        // `"[object Object]"`. If we instead look at the constructor's name (which is the same as the name of the class),
        // we can make sure that only plain objects come out that way.
        const objName = $2d7134eeb4bc669b$var$getConstructorName(value);
        // Handle HTML Elements
        if (/^HTML(\w*)Element$/.test(objName)) return `[HTMLElement: ${objName}]`;
        return `[object ${objName}]`;
    } catch (err) {
        return `**non-serializable** (${err})`;
    }
}
/* eslint-enable complexity */ function $2d7134eeb4bc669b$var$getConstructorName(value) {
    const prototype = Object.getPrototypeOf(value);
    return prototype?.constructor ? prototype.constructor.name : 'null prototype';
}
/** Calculates bytes size of input string */ function $2d7134eeb4bc669b$var$utf8Length(value) {
    // eslint-disable-next-line no-bitwise
    return ~-encodeURI(value).split(/%..|./).length;
}
/** Calculates bytes size of input object */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $2d7134eeb4bc669b$var$jsonSize(value) {
    return $2d7134eeb4bc669b$var$utf8Length(JSON.stringify(value));
}
/**
 * Normalizes URLs in exceptions and stacktraces to a base path so Sentry can fingerprint
 * across platforms and working directory.
 *
 * @param url The URL to be normalized.
 * @param basePath The application base path.
 * @returns The normalized URL.
 */ function $2d7134eeb4bc669b$export$472b29734be05be3(url, basePath) {
    const escapedBase = basePath// Backslash to forward
    .replace(/\\/g, '/')// Escape RegExp special characters
    .replace(/[|\\{}()[\]^$+*?.]/g, '\\$&');
    let newUrl = url;
    try {
        newUrl = decodeURI(url);
    } catch  {
    // Sometime this breaks
    }
    return newUrl.replace(/\\/g, '/').replace(/webpack:\/?/g, '') // Remove intermediate base path
    // oxlint-disable-next-line sdk/no-regexp-constructor
    .replace(new RegExp(`(file://)?/*${escapedBase}/*`, 'ig'), 'app:///');
}
/**
 * Helper to decycle json objects
 */ function $2d7134eeb4bc669b$var$memoBuilder() {
    const inner = new WeakSet();
    function memoize(obj) {
        if (inner.has(obj)) return true;
        inner.add(obj);
        return false;
    }
    function unmemoize(obj) {
        inner.delete(obj);
    }
    return [
        memoize,
        unmemoize
    ];
}



/**
 * Creates an envelope.
 * Make sure to always explicitly provide the generic to this function
 * so that the envelope types resolve correctly.
 */ function $bb063ad93c8b79c7$export$f93f7f385160c44e(headers, items = []) {
    return [
        headers,
        items
    ];
}
/**
 * Add an item to an envelope.
 * Make sure to always explicitly provide the generic to this function
 * so that the envelope types resolve correctly.
 */ function $bb063ad93c8b79c7$export$d650323442802f6f(envelope, newItem) {
    const [headers, items] = envelope;
    return [
        headers,
        [
            ...items,
            newItem
        ]
    ];
}
/**
 * Convenience function to loop through the items and item types of an envelope.
 * (This function was mostly created because working with envelope types is painful at the moment)
 *
 * If the callback returns true, the rest of the items will be skipped.
 */ function $bb063ad93c8b79c7$export$c56c55acf0136fd3(envelope, callback) {
    const envelopeItems = envelope[1];
    for (const envelopeItem of envelopeItems){
        const envelopeItemType = envelopeItem[0].type;
        const result = callback(envelopeItem, envelopeItemType);
        if (result) return true;
    }
    return false;
}
/**
 * Returns true if the envelope contains any of the given envelope item types
 */ function $bb063ad93c8b79c7$export$604a45d95a155e2b(envelope, types) {
    return $bb063ad93c8b79c7$export$c56c55acf0136fd3(envelope, (_, type)=>types.includes(type));
}
/**
 * Encode a string to UTF8 array.
 */ function $bb063ad93c8b79c7$var$encodeUTF8(input) {
    const carrier = (0, $e4c75fb63b040566$export$c8bfa33e4e8ae492)((0, $736a69486c86d36c$export$f1a6cdb1459e81d1));
    return carrier.encodePolyfill ? carrier.encodePolyfill(input) : new TextEncoder().encode(input);
}
/**
 * Decode a UTF8 array to string.
 */ function $bb063ad93c8b79c7$var$decodeUTF8(input) {
    const carrier = (0, $e4c75fb63b040566$export$c8bfa33e4e8ae492)((0, $736a69486c86d36c$export$f1a6cdb1459e81d1));
    return carrier.decodePolyfill ? carrier.decodePolyfill(input) : new TextDecoder().decode(input);
}
/**
 * Serializes an envelope.
 */ function $bb063ad93c8b79c7$export$32f9b428425aac85(envelope) {
    const [envHeaders, items] = envelope;
    // Initially we construct our envelope as a string and only convert to binary chunks if we encounter binary data
    let parts = JSON.stringify(envHeaders);
    function append(next) {
        if (typeof parts === 'string') parts = typeof next === 'string' ? parts + next : [
            $bb063ad93c8b79c7$var$encodeUTF8(parts),
            next
        ];
        else parts.push(typeof next === 'string' ? $bb063ad93c8b79c7$var$encodeUTF8(next) : next);
    }
    for (const item of items){
        const [itemHeaders, payload] = item;
        append(`\n${JSON.stringify(itemHeaders)}\n`);
        if (typeof payload === 'string' || payload instanceof Uint8Array) append(payload);
        else {
            let stringifiedPayload;
            try {
                stringifiedPayload = JSON.stringify(payload);
            } catch  {
                // In case, despite all our efforts to keep `payload` circular-dependency-free, `JSON.stringify()` still
                // fails, we try again after normalizing it again with infinite normalization depth. This of course has a
                // performance impact but in this case a performance hit is better than throwing.
                stringifiedPayload = JSON.stringify((0, $2d7134eeb4bc669b$export$a3295358bff77e)(payload));
            }
            append(stringifiedPayload);
        }
    }
    return typeof parts === 'string' ? parts : $bb063ad93c8b79c7$var$concatBuffers(parts);
}
function $bb063ad93c8b79c7$var$concatBuffers(buffers) {
    const totalLength = buffers.reduce((acc, buf)=>acc + buf.length, 0);
    const merged = new Uint8Array(totalLength);
    let offset = 0;
    for (const buffer of buffers){
        merged.set(buffer, offset);
        offset += buffer.length;
    }
    return merged;
}
/**
 * Parses an envelope
 */ function $bb063ad93c8b79c7$export$3338d0c7b6e17a2b(env) {
    let buffer = typeof env === 'string' ? $bb063ad93c8b79c7$var$encodeUTF8(env) : env;
    function readBinary(length) {
        const bin = buffer.subarray(0, length);
        // Replace the buffer with the remaining data excluding trailing newline
        buffer = buffer.subarray(length + 1);
        return bin;
    }
    function readJson() {
        let i = buffer.indexOf(0xa);
        // If we couldn't find a newline, we must have found the end of the buffer
        if (i < 0) i = buffer.length;
        return JSON.parse($bb063ad93c8b79c7$var$decodeUTF8(readBinary(i)));
    }
    const envelopeHeader = readJson();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const items = [];
    while(buffer.length){
        const itemHeader = readJson();
        const binaryLength = typeof itemHeader.length === 'number' ? itemHeader.length : undefined;
        items.push([
            itemHeader,
            binaryLength ? readBinary(binaryLength) : readJson()
        ]);
    }
    return [
        envelopeHeader,
        items
    ];
}
/**
 * Creates envelope item for a single span
 */ function $bb063ad93c8b79c7$export$655cf139bc8b8afd(spanJson) {
    const spanHeaders = {
        type: 'span'
    };
    return [
        spanHeaders,
        spanJson
    ];
}
/**
 * Creates attachment envelope items
 */ function $bb063ad93c8b79c7$export$d8fc80952cc31fa4(attachment) {
    const buffer = typeof attachment.data === 'string' ? $bb063ad93c8b79c7$var$encodeUTF8(attachment.data) : attachment.data;
    return [
        {
            type: 'attachment',
            length: buffer.length,
            filename: attachment.filename,
            content_type: attachment.contentType,
            attachment_type: attachment.attachmentType
        },
        buffer
    ];
}
// Map of envelope item types to data categories where the category differs from the type.
// Types that map to themselves (session, attachment, transaction, profile, feedback, span, metric) fall through.
const $bb063ad93c8b79c7$var$DATA_CATEGORY_OVERRIDES = {
    sessions: 'session',
    event: 'error',
    client_report: 'internal',
    user_report: 'default',
    profile_chunk: 'profile',
    replay_event: 'replay',
    replay_recording: 'replay',
    check_in: 'monitor',
    raw_security: 'security',
    log: 'log_item',
    trace_metric: 'metric'
};
function $bb063ad93c8b79c7$var$_isOverriddenType(type) {
    return type in $bb063ad93c8b79c7$var$DATA_CATEGORY_OVERRIDES;
}
/**
 * Maps the type of an envelope item to a data category.
 */ function $bb063ad93c8b79c7$export$b11169581eeaf237(type) {
    return $bb063ad93c8b79c7$var$_isOverriddenType(type) ? $bb063ad93c8b79c7$var$DATA_CATEGORY_OVERRIDES[type] : type;
}
/** Extracts the minimal SDK info from the metadata or an events */ function $bb063ad93c8b79c7$export$d369f3b2758f6743(metadataOrEvent) {
    if (!metadataOrEvent?.sdk) return;
    const { name: name, version: version } = metadataOrEvent.sdk;
    return {
        name: name,
        version: version
    };
}
/**
 * Creates event envelope headers, based on event, sdk info and tunnel
 * Note: This function was extracted from the core package to make it available in Replay
 */ function $bb063ad93c8b79c7$export$92b6093782fe661b(event, sdkInfo, tunnel, dsn) {
    const dynamicSamplingContext = event.sdkProcessingMetadata?.dynamicSamplingContext;
    return {
        event_id: event.event_id,
        sent_at: new Date().toISOString(),
        ...sdkInfo && {
            sdk: sdkInfo
        },
        ...!!tunnel && dsn && {
            dsn: (0, $1e1399eeae328b26$export$44d472fbb931a776)(dsn)
        },
        ...dynamicSamplingContext && {
            trace: dynamicSamplingContext
        }
    };
}





function $18bf74fc9ecc8708$var$logIgnoredSpan(droppedSpan) {
    (0, $d11ed0b3cdda6b8d$export$1c9f709888824e05).log(`Ignoring span ${droppedSpan.op} - ${droppedSpan.description} because it matches \`ignoreSpans\`.`);
}
/**
 * Check if a span should be ignored based on the ignoreSpans configuration.
 */ function $18bf74fc9ecc8708$export$5d569ac97c389400(span, ignoreSpans) {
    if (!ignoreSpans?.length || !span.description) return false;
    for (const pattern of ignoreSpans){
        if ($18bf74fc9ecc8708$var$isStringOrRegExp(pattern)) {
            if ((0, $e534db390d1e4996$export$cdded5b28a5f8c6d)(span.description, pattern)) {
                (0, $19fdbaf7f0830971$export$16a28057038b10ef) && $18bf74fc9ecc8708$var$logIgnoredSpan(span);
                return true;
            }
            continue;
        }
        if (!pattern.name && !pattern.op) continue;
        const nameMatches = pattern.name ? (0, $e534db390d1e4996$export$cdded5b28a5f8c6d)(span.description, pattern.name) : true;
        const opMatches = pattern.op ? span.op && (0, $e534db390d1e4996$export$cdded5b28a5f8c6d)(span.op, pattern.op) : true;
        // This check here is only correct because we can guarantee that we ran `isMatchingPattern`
        // for at least one of `nameMatches` and `opMatches`. So in contrary to how this looks,
        // not both op and name actually have to match. This is the most efficient way to check
        // for all combinations of name and op patterns.
        if (nameMatches && opMatches) {
            (0, $19fdbaf7f0830971$export$16a28057038b10ef) && $18bf74fc9ecc8708$var$logIgnoredSpan(span);
            return true;
        }
    }
    return false;
}
/**
 * Takes a list of spans, and a span that was dropped, and re-parents the child spans of the dropped span to the parent of the dropped span, if possible.
 * This mutates the spans array in place!
 */ function $18bf74fc9ecc8708$export$ddf57376e818b444(spans, dropSpan) {
    const droppedSpanParentId = dropSpan.parent_span_id;
    const droppedSpanId = dropSpan.span_id;
    // This should generally not happen, as we do not apply this on root spans
    // but to be safe, we just bail in this case
    if (!droppedSpanParentId) return;
    for (const span of spans)if (span.parent_span_id === droppedSpanId) span.parent_span_id = droppedSpanParentId;
}
function $18bf74fc9ecc8708$var$isStringOrRegExp(value) {
    return typeof value === 'string' || value instanceof RegExp;
}



/**
 * Apply SdkInfo (name, version, packages, integrations) to the corresponding event key.
 * Merge with existing data if any.
 *
 * @internal, exported only for testing
 **/ function $50a1e2eac2a45b83$export$8a6cdb6116a9fd2b(event, newSdkInfo) {
    if (!newSdkInfo) return event;
    const eventSdkInfo = event.sdk || {};
    event.sdk = {
        ...eventSdkInfo,
        name: eventSdkInfo.name || newSdkInfo.name,
        version: eventSdkInfo.version || newSdkInfo.version,
        integrations: [
            ...event.sdk?.integrations || [],
            ...newSdkInfo.integrations || []
        ],
        packages: [
            ...event.sdk?.packages || [],
            ...newSdkInfo.packages || []
        ],
        settings: event.sdk?.settings || newSdkInfo.settings ? {
            ...event.sdk?.settings,
            ...newSdkInfo.settings
        } : undefined
    };
    return event;
}
/** Creates an envelope from a Session */ function $50a1e2eac2a45b83$export$124b03c077baa2f3(session, dsn, metadata, tunnel) {
    const sdkInfo = (0, $bb063ad93c8b79c7$export$d369f3b2758f6743)(metadata);
    const envelopeHeaders = {
        sent_at: new Date().toISOString(),
        ...sdkInfo && {
            sdk: sdkInfo
        },
        ...!!tunnel && dsn && {
            dsn: (0, $1e1399eeae328b26$export$44d472fbb931a776)(dsn)
        }
    };
    const envelopeItem = 'aggregates' in session ? [
        {
            type: 'sessions'
        },
        session
    ] : [
        {
            type: 'session'
        },
        session.toJSON()
    ];
    return (0, $bb063ad93c8b79c7$export$f93f7f385160c44e)(envelopeHeaders, [
        envelopeItem
    ]);
}
/**
 * Create an Envelope from an event.
 */ function $50a1e2eac2a45b83$export$c31057337a18010f(event, dsn, metadata, tunnel) {
    const sdkInfo = (0, $bb063ad93c8b79c7$export$d369f3b2758f6743)(metadata);
    /*
    Note: Due to TS, event.type may be `replay_event`, theoretically.
    In practice, we never call `createEventEnvelope` with `replay_event` type,
    and we'd have to adjust a looot of types to make this work properly.
    We want to avoid casting this around, as that could lead to bugs (e.g. when we add another type)
    So the safe choice is to really guard against the replay_event type here.
  */ const eventType = event.type && event.type !== 'replay_event' ? event.type : 'event';
    $50a1e2eac2a45b83$export$8a6cdb6116a9fd2b(event, metadata?.sdk);
    const envelopeHeaders = (0, $bb063ad93c8b79c7$export$92b6093782fe661b)(event, sdkInfo, tunnel, dsn);
    // Prevent this data (which, if it exists, was used in earlier steps in the processing pipeline) from being sent to
    // sentry. (Note: Our use of this property comes and goes with whatever we might be debugging, whatever hacks we may
    // have temporarily added, etc. Even if we don't happen to be using it at some point in the future, let's not get rid
    // of this `delete`, lest we miss putting it back in the next time the property is in use.)
    delete event.sdkProcessingMetadata;
    const eventItem = [
        {
            type: eventType
        },
        event
    ];
    return (0, $bb063ad93c8b79c7$export$f93f7f385160c44e)(envelopeHeaders, [
        eventItem
    ]);
}
/**
 * Create envelope from Span item.
 *
 * Takes an optional client and runs spans through `beforeSendSpan` if available.
 */ function $50a1e2eac2a45b83$export$19a0081d4b39d77(spans, client) {
    function dscHasRequiredProps(dsc) {
        return !!dsc.trace_id && !!dsc.public_key;
    }
    // For the moment we'll obtain the DSC from the first span in the array
    // This might need to be changed if we permit sending multiple spans from
    // different segments in one envelope
    const dsc = (0, $09fae5ef8120e803$export$a117f995597e25df)(spans[0]);
    const dsn = client?.getDsn();
    const tunnel = client?.getOptions().tunnel;
    const headers = {
        sent_at: new Date().toISOString(),
        ...dscHasRequiredProps(dsc) && {
            trace: dsc
        },
        ...!!tunnel && dsn && {
            dsn: (0, $1e1399eeae328b26$export$44d472fbb931a776)(dsn)
        }
    };
    const { beforeSendSpan: beforeSendSpan, ignoreSpans: ignoreSpans } = client?.getOptions() || {};
    const filteredSpans = ignoreSpans?.length ? spans.filter((span)=>!(0, $18bf74fc9ecc8708$export$5d569ac97c389400)((0, $bb9b6447bf4caedb$export$92d8c23565496537)(span), ignoreSpans)) : spans;
    const droppedSpans = spans.length - filteredSpans.length;
    if (droppedSpans) client?.recordDroppedEvent('before_send', 'span', droppedSpans);
    const convertToSpanJSON = beforeSendSpan ? (span)=>{
        const spanJson = (0, $bb9b6447bf4caedb$export$92d8c23565496537)(span);
        const processedSpan = beforeSendSpan(spanJson);
        if (!processedSpan) {
            (0, $bb9b6447bf4caedb$export$d11691ff45a3e535)();
            return spanJson;
        }
        return processedSpan;
    } : (0, $bb9b6447bf4caedb$export$92d8c23565496537);
    const items = [];
    for (const span of filteredSpans){
        const spanJson = convertToSpanJSON(span);
        if (spanJson) items.push((0, $bb063ad93c8b79c7$export$655cf139bc8b8afd)(spanJson));
    }
    return (0, $bb063ad93c8b79c7$export$f93f7f385160c44e)(headers, items);
}













/**
 * Adds a measurement to the active transaction on the current global scope. You can optionally pass in a different span
 * as the 4th parameter.
 */ function $dbcaa70aa380aaa2$export$7cc31b475d33a706(name, value, unit, activeSpan = (0, $bb9b6447bf4caedb$export$1be426a8e585c83e)()) {
    const rootSpan = activeSpan && (0, $bb9b6447bf4caedb$export$c4c6a79b1260ca1b)(activeSpan);
    if (rootSpan) {
        (0, $19fdbaf7f0830971$export$16a28057038b10ef) && (0, $d11ed0b3cdda6b8d$export$1c9f709888824e05).log(`[Measurement] Setting measurement on root span: ${name} = ${value} ${unit}`);
        rootSpan.addEvent(name, {
            [(0, $f337c80285f06f80$export$69cd5c610c7bb96a)]: value,
            [(0, $f337c80285f06f80$export$f5f95cff026507b5)]: unit
        });
    }
}
/**
 * Convert timed events to measurements.
 */ function $dbcaa70aa380aaa2$export$487db6fcdf36893e(events) {
    if (!events || events.length === 0) return undefined;
    const measurements = {};
    events.forEach((event)=>{
        const attributes = event.attributes || {};
        const unit = attributes[0, $f337c80285f06f80$export$f5f95cff026507b5];
        const value = attributes[0, $f337c80285f06f80$export$69cd5c610c7bb96a];
        if (typeof unit === 'string' && typeof value === 'number') measurements[event.name] = {
            value: value,
            unit: unit
        };
    });
    return measurements;
}



const $32284c1a43c550a4$var$MAX_SPAN_COUNT = 1000;
/**
 * Span contains all data about a span
 */ class $32284c1a43c550a4$export$a92149b045260d9f {
    /** Epoch timestamp in seconds when the span started. */ /** Epoch timestamp in seconds when the span ended. */ /** Internal keeper of the status */ /** The timed events added to this span. */ /** if true, treat span as a standalone span (not part of a transaction) */ /**
   * You should never call the constructor manually, always use `Sentry.startSpan()`
   * or other span methods.
   * @internal
   * @hideconstructor
   * @hidden
   */ constructor(spanContext = {}){
        this._traceId = spanContext.traceId || (0, $ece9bac57decbcb8$export$dc6d7ea554bcce10)();
        this._spanId = spanContext.spanId || (0, $ece9bac57decbcb8$export$295213bc4d0c54ad)();
        this._startTime = spanContext.startTimestamp || (0, $bc81602376c48fa6$export$ee52dced521e3e18)();
        this._links = spanContext.links;
        this._attributes = {};
        this.setAttributes({
            [(0, $f337c80285f06f80$export$cca8dd30f57f805e)]: 'manual',
            [(0, $f337c80285f06f80$export$1a413bd9a88fdb09)]: spanContext.op,
            ...spanContext.attributes
        });
        this._name = spanContext.name;
        if (spanContext.parentSpanId) this._parentSpanId = spanContext.parentSpanId;
        // We want to include booleans as well here
        if ('sampled' in spanContext) this._sampled = spanContext.sampled;
        if (spanContext.endTimestamp) this._endTime = spanContext.endTimestamp;
        this._events = [];
        this._isStandaloneSpan = spanContext.isStandalone;
        // If the span is already ended, ensure we finalize the span immediately
        if (this._endTime) this._onSpanEnded();
    }
    /** @inheritDoc */ addLink(link) {
        if (this._links) this._links.push(link);
        else this._links = [
            link
        ];
        return this;
    }
    /** @inheritDoc */ addLinks(links) {
        if (this._links) this._links.push(...links);
        else this._links = links;
        return this;
    }
    /**
   * This should generally not be used,
   * but it is needed for being compliant with the OTEL Span interface.
   *
   * @hidden
   * @internal
   */ recordException(_exception, _time) {
    // noop
    }
    /** @inheritdoc */ spanContext() {
        const { _spanId: spanId, _traceId: traceId, _sampled: sampled } = this;
        return {
            spanId: spanId,
            traceId: traceId,
            traceFlags: sampled ? (0, $bb9b6447bf4caedb$export$eb571cd9b5d98de8) : (0, $bb9b6447bf4caedb$export$208d5b368507fb8b)
        };
    }
    /** @inheritdoc */ setAttribute(key, value) {
        if (value === undefined) // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
        delete this._attributes[key];
        else this._attributes[key] = value;
        return this;
    }
    /** @inheritdoc */ setAttributes(attributes) {
        Object.keys(attributes).forEach((key)=>this.setAttribute(key, attributes[key]));
        return this;
    }
    /**
   * This should generally not be used,
   * but we need it for browser tracing where we want to adjust the start time afterwards.
   * USE THIS WITH CAUTION!
   *
   * @hidden
   * @internal
   */ updateStartTime(timeInput) {
        this._startTime = (0, $bb9b6447bf4caedb$export$3f7581298f56c6d7)(timeInput);
    }
    /**
   * @inheritDoc
   */ setStatus(value) {
        this._status = value;
        return this;
    }
    /**
   * @inheritDoc
   */ updateName(name) {
        this._name = name;
        this.setAttribute((0, $f337c80285f06f80$export$d7a7d984b0791405), 'custom');
        return this;
    }
    /** @inheritdoc */ end(endTimestamp) {
        // If already ended, skip
        if (this._endTime) return;
        this._endTime = (0, $bb9b6447bf4caedb$export$3f7581298f56c6d7)(endTimestamp);
        (0, $33f11695c2072059$export$b77c830667a4d630)(this);
        this._onSpanEnded();
    }
    /**
   * Get JSON representation of this span.
   *
   * @hidden
   * @internal This method is purely for internal purposes and should not be used outside
   * of SDK code. If you need to get a JSON representation of a span,
   * use `spanToJSON(span)` instead.
   */ getSpanJSON() {
        return {
            data: this._attributes,
            description: this._name,
            op: this._attributes[0, $f337c80285f06f80$export$1a413bd9a88fdb09],
            parent_span_id: this._parentSpanId,
            span_id: this._spanId,
            start_timestamp: this._startTime,
            status: (0, $bb9b6447bf4caedb$export$e238a77ea3a8cd66)(this._status),
            timestamp: this._endTime,
            trace_id: this._traceId,
            origin: this._attributes[0, $f337c80285f06f80$export$cca8dd30f57f805e],
            profile_id: this._attributes[0, $f337c80285f06f80$export$1efec95406bbe327],
            exclusive_time: this._attributes[0, $f337c80285f06f80$export$fea48ba9f4550879],
            measurements: (0, $dbcaa70aa380aaa2$export$487db6fcdf36893e)(this._events),
            is_segment: this._isStandaloneSpan && (0, $bb9b6447bf4caedb$export$c4c6a79b1260ca1b)(this) === this || undefined,
            segment_id: this._isStandaloneSpan ? (0, $bb9b6447bf4caedb$export$c4c6a79b1260ca1b)(this).spanContext().spanId : undefined,
            links: (0, $bb9b6447bf4caedb$export$cb3e3a12e0eec16c)(this._links)
        };
    }
    /** @inheritdoc */ isRecording() {
        return !this._endTime && !!this._sampled;
    }
    /**
   * @inheritdoc
   */ addEvent(name, attributesOrStartTime, startTime) {
        (0, $19fdbaf7f0830971$export$16a28057038b10ef) && (0, $d11ed0b3cdda6b8d$export$1c9f709888824e05).log('[Tracing] Adding an event to span:', name);
        const time = $32284c1a43c550a4$var$isSpanTimeInput(attributesOrStartTime) ? attributesOrStartTime : startTime || (0, $bc81602376c48fa6$export$ee52dced521e3e18)();
        const attributes = $32284c1a43c550a4$var$isSpanTimeInput(attributesOrStartTime) ? {} : attributesOrStartTime || {};
        const event = {
            name: name,
            time: (0, $bb9b6447bf4caedb$export$3f7581298f56c6d7)(time),
            attributes: attributes
        };
        this._events.push(event);
        return this;
    }
    /**
   * This method should generally not be used,
   * but for now we need a way to publicly check if the `_isStandaloneSpan` flag is set.
   * USE THIS WITH CAUTION!
   * @internal
   * @hidden
   * @experimental
   */ isStandaloneSpan() {
        return !!this._isStandaloneSpan;
    }
    /** Emit `spanEnd` when the span is ended. */ _onSpanEnded() {
        const client = (0, $7d48e1ed9f699a01$export$6bb76d6eba7e258c)();
        if (client) client.emit('spanEnd', this);
        // A segment span is basically the root span of a local span tree.
        // So for now, this is either what we previously refer to as the root span,
        // or a standalone span.
        const isSegmentSpan = this._isStandaloneSpan || this === (0, $bb9b6447bf4caedb$export$c4c6a79b1260ca1b)(this);
        if (!isSegmentSpan) return;
        // if this is a standalone span, we send it immediately
        if (this._isStandaloneSpan) {
            if (this._sampled) $32284c1a43c550a4$var$sendSpanEnvelope((0, $50a1e2eac2a45b83$export$19a0081d4b39d77)([
                this
            ], client));
            else {
                (0, $19fdbaf7f0830971$export$16a28057038b10ef) && (0, $d11ed0b3cdda6b8d$export$1c9f709888824e05).log('[Tracing] Discarding standalone span because its trace was not chosen to be sampled.');
                if (client) client.recordDroppedEvent('sample_rate', 'span');
            }
            return;
        }
        const transactionEvent = this._convertSpanToTransaction();
        if (transactionEvent) {
            const scope = (0, $e54da191c628b5f0$export$c08fbc656a245d03)(this).scope || (0, $7d48e1ed9f699a01$export$c7be4b0125a10cba)();
            scope.captureEvent(transactionEvent);
        }
    }
    /**
   * Finish the transaction & prepare the event to send to Sentry.
   */ _convertSpanToTransaction() {
        // We can only convert finished spans
        if (!$32284c1a43c550a4$var$isFullFinishedSpan((0, $bb9b6447bf4caedb$export$92d8c23565496537)(this))) return undefined;
        if (!this._name) {
            (0, $19fdbaf7f0830971$export$16a28057038b10ef) && (0, $d11ed0b3cdda6b8d$export$1c9f709888824e05).warn('Transaction has no name, falling back to `<unlabeled transaction>`.');
            this._name = '<unlabeled transaction>';
        }
        const { scope: capturedSpanScope, isolationScope: capturedSpanIsolationScope } = (0, $e54da191c628b5f0$export$c08fbc656a245d03)(this);
        const normalizedRequest = capturedSpanScope?.getScopeData().sdkProcessingMetadata?.normalizedRequest;
        if (this._sampled !== true) return undefined;
        // The transaction span itself as well as any potential standalone spans should be filtered out
        const finishedSpans = (0, $bb9b6447bf4caedb$export$340c5c8a13ffc680)(this).filter((span)=>span !== this && !$32284c1a43c550a4$var$isStandaloneSpan(span));
        const spans = finishedSpans.map((span)=>(0, $bb9b6447bf4caedb$export$92d8c23565496537)(span)).filter($32284c1a43c550a4$var$isFullFinishedSpan);
        const source = this._attributes[0, $f337c80285f06f80$export$d7a7d984b0791405];
        // remove internal root span attributes we don't need to send.
        /* eslint-disable @typescript-eslint/no-dynamic-delete */ delete this._attributes[0, $f337c80285f06f80$export$165ce9a229f6f050];
        spans.forEach((span)=>{
            delete span.data[0, $f337c80285f06f80$export$165ce9a229f6f050];
        });
        // eslint-enabled-next-line @typescript-eslint/no-dynamic-delete
        const transaction = {
            contexts: {
                trace: (0, $bb9b6447bf4caedb$export$4c3967a8a2f6bbd6)(this)
            },
            spans: // spans.sort() mutates the array, but `spans` is already a copy so we can safely do this here
            // we do not use spans anymore after this point
            spans.length > $32284c1a43c550a4$var$MAX_SPAN_COUNT ? spans.sort((a, b)=>a.start_timestamp - b.start_timestamp).slice(0, $32284c1a43c550a4$var$MAX_SPAN_COUNT) : spans,
            start_timestamp: this._startTime,
            timestamp: this._endTime,
            transaction: this._name,
            type: 'transaction',
            sdkProcessingMetadata: {
                capturedSpanScope: capturedSpanScope,
                capturedSpanIsolationScope: capturedSpanIsolationScope,
                dynamicSamplingContext: (0, $09fae5ef8120e803$export$a117f995597e25df)(this)
            },
            request: normalizedRequest,
            ...source && {
                transaction_info: {
                    source: source
                }
            }
        };
        const measurements = (0, $dbcaa70aa380aaa2$export$487db6fcdf36893e)(this._events);
        const hasMeasurements = measurements && Object.keys(measurements).length;
        if (hasMeasurements) {
            (0, $19fdbaf7f0830971$export$16a28057038b10ef) && (0, $d11ed0b3cdda6b8d$export$1c9f709888824e05).log('[Measurements] Adding measurements to transaction event', JSON.stringify(measurements, undefined, 2));
            transaction.measurements = measurements;
        }
        return transaction;
    }
}
function $32284c1a43c550a4$var$isSpanTimeInput(value) {
    return value && typeof value === 'number' || value instanceof Date || Array.isArray(value);
}
// We want to filter out any incomplete SpanJSON objects
function $32284c1a43c550a4$var$isFullFinishedSpan(input) {
    return !!input.start_timestamp && !!input.timestamp && !!input.span_id && !!input.trace_id;
}
/** `SentrySpan`s can be sent as a standalone span rather than belonging to a transaction */ function $32284c1a43c550a4$var$isStandaloneSpan(span) {
    return span instanceof $32284c1a43c550a4$export$a92149b045260d9f && span.isStandaloneSpan();
}
/**
 * Sends a `SpanEnvelope`.
 *
 * Note: If the envelope's spans are dropped, e.g. via `beforeSendSpan`,
 * the envelope will not be sent either.
 */ function $32284c1a43c550a4$var$sendSpanEnvelope(envelope) {
    const client = (0, $7d48e1ed9f699a01$export$6bb76d6eba7e258c)();
    if (!client) return;
    const spanItems = envelope[1];
    if (!spanItems || spanItems.length === 0) {
        client.recordDroppedEvent('before_send', 'span');
        return;
    }
    // sendEnvelope should not throw
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    client.sendEnvelope(envelope);
}




/* eslint-disable max-lines */ const $c9161b67125aefc1$var$SUPPRESS_TRACING_KEY = '__SENTRY_SUPPRESS_TRACING__';
/**
 * Wraps a function with a transaction/span and finishes the span after the function is done.
 * The created span is the active span and will be used as parent by other spans created inside the function
 * and can be accessed via `Sentry.getActiveSpan()`, as long as the function is executed while the scope is active.
 *
 * If you want to create a span that is not set as active, use {@link startInactiveSpan}.
 *
 * You'll always get a span passed to the callback,
 * it may just be a non-recording span if the span is not sampled or if tracing is disabled.
 */ function $c9161b67125aefc1$export$a1bd95187356f372(options, callback) {
    const acs = $c9161b67125aefc1$var$getAcs();
    if (acs.startSpan) return acs.startSpan(options, callback);
    const spanArguments = $c9161b67125aefc1$var$parseSentrySpanArguments(options);
    const { forceTransaction: forceTransaction, parentSpan: customParentSpan, scope: customScope } = options;
    // We still need to fork a potentially passed scope, as we set the active span on it
    // and we need to ensure that it is cleaned up properly once the span ends.
    const customForkedScope = customScope?.clone();
    return (0, $7d48e1ed9f699a01$export$ec58d9285c204497)(customForkedScope, ()=>{
        // If `options.parentSpan` is defined, we want to wrap the callback in `withActiveSpan`
        const wrapper = $c9161b67125aefc1$var$getActiveSpanWrapper(customParentSpan);
        return wrapper(()=>{
            const scope = (0, $7d48e1ed9f699a01$export$c7be4b0125a10cba)();
            const parentSpan = $c9161b67125aefc1$var$getParentSpan(scope, customParentSpan);
            const shouldSkipSpan = options.onlyIfParent && !parentSpan;
            const activeSpan = shouldSkipSpan ? new (0, $057104436ef6f1c5$export$d6636b700b76c516)() : $c9161b67125aefc1$var$createChildOrRootSpan({
                parentSpan: parentSpan,
                spanArguments: spanArguments,
                forceTransaction: forceTransaction,
                scope: scope
            });
            (0, $dab1970d0c142a42$export$3f25fa50c18e20ca)(scope, activeSpan);
            return (0, $2c3cb4034c24252d$export$18ce21a8b7efd7e9)(()=>callback(activeSpan), ()=>{
                // Only update the span status if it hasn't been changed yet, and the span is not yet finished
                const { status: status } = (0, $bb9b6447bf4caedb$export$92d8c23565496537)(activeSpan);
                if (activeSpan.isRecording() && (!status || status === 'ok')) activeSpan.setStatus({
                    code: (0, $fda37f10dc06a152$export$f966a0446ece71e),
                    message: 'internal_error'
                });
            }, ()=>{
                activeSpan.end();
            });
        });
    });
}
/**
 * Similar to `Sentry.startSpan`. Wraps a function with a transaction/span, but does not finish the span
 * after the function is done automatically. Use `span.end()` to end the span.
 *
 * The created span is the active span and will be used as parent by other spans created inside the function
 * and can be accessed via `Sentry.getActiveSpan()`, as long as the function is executed while the scope is active.
 *
 * You'll always get a span passed to the callback,
 * it may just be a non-recording span if the span is not sampled or if tracing is disabled.
 */ function $c9161b67125aefc1$export$c10292ad04b92aea(options, callback) {
    const acs = $c9161b67125aefc1$var$getAcs();
    if (acs.startSpanManual) return acs.startSpanManual(options, callback);
    const spanArguments = $c9161b67125aefc1$var$parseSentrySpanArguments(options);
    const { forceTransaction: forceTransaction, parentSpan: customParentSpan, scope: customScope } = options;
    const customForkedScope = customScope?.clone();
    return (0, $7d48e1ed9f699a01$export$ec58d9285c204497)(customForkedScope, ()=>{
        // If `options.parentSpan` is defined, we want to wrap the callback in `withActiveSpan`
        const wrapper = $c9161b67125aefc1$var$getActiveSpanWrapper(customParentSpan);
        return wrapper(()=>{
            const scope = (0, $7d48e1ed9f699a01$export$c7be4b0125a10cba)();
            const parentSpan = $c9161b67125aefc1$var$getParentSpan(scope, customParentSpan);
            const shouldSkipSpan = options.onlyIfParent && !parentSpan;
            const activeSpan = shouldSkipSpan ? new (0, $057104436ef6f1c5$export$d6636b700b76c516)() : $c9161b67125aefc1$var$createChildOrRootSpan({
                parentSpan: parentSpan,
                spanArguments: spanArguments,
                forceTransaction: forceTransaction,
                scope: scope
            });
            (0, $dab1970d0c142a42$export$3f25fa50c18e20ca)(scope, activeSpan);
            return (0, $2c3cb4034c24252d$export$18ce21a8b7efd7e9)(// We pass the `finish` function to the callback, so the user can finish the span manually
            // this is mainly here for historic purposes because previously, we instructed users to call
            // `finish` instead of `span.end()` to also clean up the scope. Nowadays, calling `span.end()`
            // or `finish` has the same effect and we simply leave it here to avoid breaking user code.
            ()=>callback(activeSpan, ()=>activeSpan.end()), ()=>{
                // Only update the span status if it hasn't been changed yet, and the span is not yet finished
                const { status: status } = (0, $bb9b6447bf4caedb$export$92d8c23565496537)(activeSpan);
                if (activeSpan.isRecording() && (!status || status === 'ok')) activeSpan.setStatus({
                    code: (0, $fda37f10dc06a152$export$f966a0446ece71e),
                    message: 'internal_error'
                });
            });
        });
    });
}
/**
 * Creates a span. This span is not set as active, so will not get automatic instrumentation spans
 * as children or be able to be accessed via `Sentry.getActiveSpan()`.
 *
 * If you want to create a span that is set as active, use {@link startSpan}.
 *
 * This function will always return a span,
 * it may just be a non-recording span if the span is not sampled or if tracing is disabled.
 */ function $c9161b67125aefc1$export$63dbba021a6b4047(options) {
    const acs = $c9161b67125aefc1$var$getAcs();
    if (acs.startInactiveSpan) return acs.startInactiveSpan(options);
    const spanArguments = $c9161b67125aefc1$var$parseSentrySpanArguments(options);
    const { forceTransaction: forceTransaction, parentSpan: customParentSpan } = options;
    // If `options.scope` is defined, we use this as as a wrapper,
    // If `options.parentSpan` is defined, we want to wrap the callback in `withActiveSpan`
    const wrapper = options.scope ? (callback)=>(0, $7d48e1ed9f699a01$export$ec58d9285c204497)(options.scope, callback) : customParentSpan !== undefined ? (callback)=>$c9161b67125aefc1$export$e57ac09b143d92a2(customParentSpan, callback) : (callback)=>callback();
    return wrapper(()=>{
        const scope = (0, $7d48e1ed9f699a01$export$c7be4b0125a10cba)();
        const parentSpan = $c9161b67125aefc1$var$getParentSpan(scope, customParentSpan);
        const shouldSkipSpan = options.onlyIfParent && !parentSpan;
        if (shouldSkipSpan) return new (0, $057104436ef6f1c5$export$d6636b700b76c516)();
        return $c9161b67125aefc1$var$createChildOrRootSpan({
            parentSpan: parentSpan,
            spanArguments: spanArguments,
            forceTransaction: forceTransaction,
            scope: scope
        });
    });
}
/**
 * Continue a trace from `sentry-trace` and `baggage` values.
 * These values can be obtained from incoming request headers, or in the browser from `<meta name="sentry-trace">`
 * and `<meta name="baggage">` HTML tags.
 *
 * Spans started with `startSpan`, `startSpanManual` and `startInactiveSpan`, within the callback will automatically
 * be attached to the incoming trace.
 */ const $c9161b67125aefc1$export$d2ee9b39b25437b3 = (options, callback)=>{
    const carrier = (0, $e4c75fb63b040566$export$19eade501500c6c1)();
    const acs = (0, $a8b8acc568359454$export$f639b0c2752203be)(carrier);
    if (acs.continueTrace) return acs.continueTrace(options, callback);
    const { sentryTrace: sentryTrace, baggage: baggage } = options;
    const client = (0, $7d48e1ed9f699a01$export$6bb76d6eba7e258c)();
    const incomingDsc = (0, $8ef2851bd0adcf53$export$5b96ee2c8421f107)(baggage);
    if (client && !(0, $bcc4fe773b74e41d$export$18811bc99eefceaa)(client, incomingDsc?.org_id)) return $c9161b67125aefc1$export$f90b03291402f553(callback);
    return (0, $7d48e1ed9f699a01$export$ec58d9285c204497)((scope)=>{
        const propagationContext = (0, $bcc4fe773b74e41d$export$261f383d16a93e39)(sentryTrace, baggage);
        scope.setPropagationContext(propagationContext);
        (0, $dab1970d0c142a42$export$3f25fa50c18e20ca)(scope, undefined);
        return callback();
    });
};
/**
 * Forks the current scope and sets the provided span as active span in the context of the provided callback. Can be
 * passed `null` to start an entirely new span tree.
 *
 * @param span Spans started in the context of the provided callback will be children of this span. If `null` is passed,
 * spans started within the callback will not be attached to a parent span.
 * @param callback Execution context in which the provided span will be active. Is passed the newly forked scope.
 * @returns the value returned from the provided callback function.
 */ function $c9161b67125aefc1$export$e57ac09b143d92a2(span, callback) {
    const acs = $c9161b67125aefc1$var$getAcs();
    if (acs.withActiveSpan) return acs.withActiveSpan(span, callback);
    return (0, $7d48e1ed9f699a01$export$ec58d9285c204497)((scope)=>{
        (0, $dab1970d0c142a42$export$3f25fa50c18e20ca)(scope, span || undefined);
        return callback(scope);
    });
}
/** Suppress tracing in the given callback, ensuring no spans are generated inside of it. */ function $c9161b67125aefc1$export$869298f9835abc68(callback) {
    const acs = $c9161b67125aefc1$var$getAcs();
    if (acs.suppressTracing) return acs.suppressTracing(callback);
    return (0, $7d48e1ed9f699a01$export$ec58d9285c204497)((scope)=>{
        // Note: We do not wait for the callback to finish before we reset the metadata
        // the reason for this is that otherwise, in the browser this can lead to very weird behavior
        // as there is only a single top scope, if the callback takes longer to finish,
        // other, unrelated spans may also be suppressed, which we do not want
        // so instead, we only suppress tracing synchronoysly in the browser
        scope.setSDKProcessingMetadata({
            [$c9161b67125aefc1$var$SUPPRESS_TRACING_KEY]: true
        });
        const res = callback();
        scope.setSDKProcessingMetadata({
            [$c9161b67125aefc1$var$SUPPRESS_TRACING_KEY]: undefined
        });
        return res;
    });
}
/**
 * Starts a new trace for the duration of the provided callback. Spans started within the
 * callback will be part of the new trace instead of a potentially previously started trace.
 *
 * Important: Only use this function if you want to override the default trace lifetime and
 * propagation mechanism of the SDK for the duration and scope of the provided callback.
 * The newly created trace will also be the root of a new distributed trace, for example if
 * you make http requests within the callback.
 * This function might be useful if the operation you want to instrument should not be part
 * of a potentially ongoing trace.
 *
 * Default behavior:
 * - Server-side: A new trace is started for each incoming request.
 * - Browser: A new trace is started for each page our route. Navigating to a new route
 *            or page will automatically create a new trace.
 */ function $c9161b67125aefc1$export$f90b03291402f553(callback) {
    return (0, $7d48e1ed9f699a01$export$ec58d9285c204497)((scope)=>{
        scope.setPropagationContext({
            traceId: (0, $ece9bac57decbcb8$export$dc6d7ea554bcce10)(),
            sampleRand: (0, $c80d7f6644a3b50b$export$9869d72de32a3917)()
        });
        (0, $19fdbaf7f0830971$export$16a28057038b10ef) && (0, $d11ed0b3cdda6b8d$export$1c9f709888824e05).log(`Starting a new trace with id ${scope.getPropagationContext().traceId}`);
        return $c9161b67125aefc1$export$e57ac09b143d92a2(null, callback);
    });
}
function $c9161b67125aefc1$var$createChildOrRootSpan({ parentSpan: parentSpan, spanArguments: spanArguments, forceTransaction: forceTransaction, scope: scope }) {
    if (!(0, $e3827447d651dfc5$export$1f70765132c3c225)()) {
        const span = new (0, $057104436ef6f1c5$export$d6636b700b76c516)();
        // If this is a root span, we ensure to freeze a DSC
        // So we can have at least partial data here
        if (forceTransaction || !parentSpan) {
            const dsc = {
                sampled: 'false',
                sample_rate: '0',
                transaction: spanArguments.name,
                ...(0, $09fae5ef8120e803$export$a117f995597e25df)(span)
            };
            (0, $09fae5ef8120e803$export$7398c93e763ca9fd)(span, dsc);
        }
        return span;
    }
    const isolationScope = (0, $7d48e1ed9f699a01$export$68f3af03034c9e90)();
    let span;
    if (parentSpan && !forceTransaction) {
        span = $c9161b67125aefc1$var$_startChildSpan(parentSpan, scope, spanArguments);
        (0, $bb9b6447bf4caedb$export$81397d924722cc65)(parentSpan, span);
    } else if (parentSpan) {
        // If we forced a transaction but have a parent span, make sure to continue from the parent span, not the scope
        const dsc = (0, $09fae5ef8120e803$export$a117f995597e25df)(parentSpan);
        const { traceId: traceId, spanId: parentSpanId } = parentSpan.spanContext();
        const parentSampled = (0, $bb9b6447bf4caedb$export$5caecac1caaf3a71)(parentSpan);
        span = $c9161b67125aefc1$var$_startRootSpan({
            traceId: traceId,
            parentSpanId: parentSpanId,
            ...spanArguments
        }, scope, parentSampled);
        (0, $09fae5ef8120e803$export$7398c93e763ca9fd)(span, dsc);
    } else {
        const { traceId: traceId, dsc: dsc, parentSpanId: parentSpanId, sampled: parentSampled } = {
            ...isolationScope.getPropagationContext(),
            ...scope.getPropagationContext()
        };
        span = $c9161b67125aefc1$var$_startRootSpan({
            traceId: traceId,
            parentSpanId: parentSpanId,
            ...spanArguments
        }, scope, parentSampled);
        if (dsc) (0, $09fae5ef8120e803$export$7398c93e763ca9fd)(span, dsc);
    }
    (0, $33f11695c2072059$export$2f3d84e767c9592b)(span);
    (0, $e54da191c628b5f0$export$cddb4027e3b0dd66)(span, scope, isolationScope);
    return span;
}
/**
 * This converts StartSpanOptions to SentrySpanArguments.
 * For the most part (for now) we accept the same options,
 * but some of them need to be transformed.
 */ function $c9161b67125aefc1$var$parseSentrySpanArguments(options) {
    const exp = options.experimental || {};
    const initialCtx = {
        isStandalone: exp.standalone,
        ...options
    };
    if (options.startTime) {
        const ctx = {
            ...initialCtx
        };
        ctx.startTimestamp = (0, $bb9b6447bf4caedb$export$3f7581298f56c6d7)(options.startTime);
        delete ctx.startTime;
        return ctx;
    }
    return initialCtx;
}
function $c9161b67125aefc1$var$getAcs() {
    const carrier = (0, $e4c75fb63b040566$export$19eade501500c6c1)();
    return (0, $a8b8acc568359454$export$f639b0c2752203be)(carrier);
}
function $c9161b67125aefc1$var$_startRootSpan(spanArguments, scope, parentSampled) {
    const client = (0, $7d48e1ed9f699a01$export$6bb76d6eba7e258c)();
    const options = client?.getOptions() || {};
    const { name: name = '' } = spanArguments;
    const mutableSpanSamplingData = {
        spanAttributes: {
            ...spanArguments.attributes
        },
        spanName: name,
        parentSampled: parentSampled
    };
    // we don't care about the decision for the moment; this is just a placeholder
    client?.emit('beforeSampling', mutableSpanSamplingData, {
        decision: false
    });
    // If hook consumers override the parentSampled flag, we will use that value instead of the actual one
    const finalParentSampled = mutableSpanSamplingData.parentSampled ?? parentSampled;
    const finalAttributes = mutableSpanSamplingData.spanAttributes;
    const currentPropagationContext = scope.getPropagationContext();
    const [sampled, sampleRate, localSampleRateWasApplied] = scope.getScopeData().sdkProcessingMetadata[$c9161b67125aefc1$var$SUPPRESS_TRACING_KEY] ? [
        false
    ] : (0, $ff32a69e7fdcf77e$export$5f833db634b217bb)(options, {
        name: name,
        parentSampled: finalParentSampled,
        attributes: finalAttributes,
        parentSampleRate: (0, $921fe5f527b40422$export$a5bd2d81656d9546)(currentPropagationContext.dsc?.sample_rate)
    }, currentPropagationContext.sampleRand);
    const rootSpan = new (0, $32284c1a43c550a4$export$a92149b045260d9f)({
        ...spanArguments,
        attributes: {
            [(0, $f337c80285f06f80$export$d7a7d984b0791405)]: 'custom',
            [(0, $f337c80285f06f80$export$ccfe0a40627cc34b)]: sampleRate !== undefined && localSampleRateWasApplied ? sampleRate : undefined,
            ...finalAttributes
        },
        sampled: sampled
    });
    if (!sampled && client) {
        (0, $19fdbaf7f0830971$export$16a28057038b10ef) && (0, $d11ed0b3cdda6b8d$export$1c9f709888824e05).log('[Tracing] Discarding root span because its trace was not chosen to be sampled.');
        client.recordDroppedEvent('sample_rate', 'transaction');
    }
    if (client) client.emit('spanStart', rootSpan);
    return rootSpan;
}
/**
 * Creates a new `Span` while setting the current `Span.id` as `parentSpanId`.
 * This inherits the sampling decision from the parent span.
 */ function $c9161b67125aefc1$var$_startChildSpan(parentSpan, scope, spanArguments) {
    const { spanId: spanId, traceId: traceId } = parentSpan.spanContext();
    const sampled = scope.getScopeData().sdkProcessingMetadata[$c9161b67125aefc1$var$SUPPRESS_TRACING_KEY] ? false : (0, $bb9b6447bf4caedb$export$5caecac1caaf3a71)(parentSpan);
    const childSpan = sampled ? new (0, $32284c1a43c550a4$export$a92149b045260d9f)({
        ...spanArguments,
        parentSpanId: spanId,
        traceId: traceId,
        sampled: sampled
    }) : new (0, $057104436ef6f1c5$export$d6636b700b76c516)({
        traceId: traceId
    });
    (0, $bb9b6447bf4caedb$export$81397d924722cc65)(parentSpan, childSpan);
    const client = (0, $7d48e1ed9f699a01$export$6bb76d6eba7e258c)();
    if (client) {
        client.emit('spanStart', childSpan);
        // If it has an endTimestamp, it's already ended
        if (spanArguments.endTimestamp) client.emit('spanEnd', childSpan);
    }
    return childSpan;
}
function $c9161b67125aefc1$var$getParentSpan(scope, customParentSpan) {
    // always use the passed in span directly
    if (customParentSpan) return customParentSpan;
    // This is different from `undefined` as it means the user explicitly wants no parent span
    if (customParentSpan === null) return undefined;
    const span = (0, $dab1970d0c142a42$export$91f063ebb8eff307)(scope);
    if (!span) return undefined;
    const client = (0, $7d48e1ed9f699a01$export$6bb76d6eba7e258c)();
    const options = client ? client.getOptions() : {};
    if (options.parentSpanIsAlwaysRootSpan) return (0, $bb9b6447bf4caedb$export$c4c6a79b1260ca1b)(span);
    return span;
}
function $c9161b67125aefc1$var$getActiveSpanWrapper(parentSpan) {
    return parentSpan !== undefined ? (callback)=>{
        return $c9161b67125aefc1$export$e57ac09b143d92a2(parentSpan, callback);
    } : (callback)=>callback();
}










/* eslint-disable @typescript-eslint/no-explicit-any */ /** SyncPromise internal states */ const $e9661cd6d20ea7e7$var$STATE_PENDING = 0;
const $e9661cd6d20ea7e7$var$STATE_RESOLVED = 1;
const $e9661cd6d20ea7e7$var$STATE_REJECTED = 2;
/**
 * Creates a resolved sync promise.
 *
 * @param value the value to resolve the promise with
 * @returns the resolved sync promise
 */ function $e9661cd6d20ea7e7$export$1fda8aa4d135f8aa(value) {
    return new $e9661cd6d20ea7e7$export$6f292d4960313241((resolve)=>{
        resolve(value);
    });
}
/**
 * Creates a rejected sync promise.
 *
 * @param value the value to reject the promise with
 * @returns the rejected sync promise
 */ function $e9661cd6d20ea7e7$export$78e43115b553f358(reason) {
    return new $e9661cd6d20ea7e7$export$6f292d4960313241((_, reject)=>{
        reject(reason);
    });
}
/**
 * Thenable class that behaves like a Promise and follows it's interface
 * but is not async internally
 */ class $e9661cd6d20ea7e7$export$6f292d4960313241 {
    constructor(executor){
        this._state = $e9661cd6d20ea7e7$var$STATE_PENDING;
        this._handlers = [];
        this._runExecutor(executor);
    }
    /** @inheritdoc */ then(onfulfilled, onrejected) {
        return new $e9661cd6d20ea7e7$export$6f292d4960313241((resolve, reject)=>{
            this._handlers.push([
                false,
                (result)=>{
                    if (!onfulfilled) // TODO: ¯\_(ツ)_/¯
                    // TODO: FIXME
                    resolve(result);
                    else try {
                        resolve(onfulfilled(result));
                    } catch (e) {
                        reject(e);
                    }
                },
                (reason)=>{
                    if (!onrejected) reject(reason);
                    else try {
                        resolve(onrejected(reason));
                    } catch (e) {
                        reject(e);
                    }
                }
            ]);
            this._executeHandlers();
        });
    }
    /** @inheritdoc */ catch(onrejected) {
        return this.then((val)=>val, onrejected);
    }
    /** @inheritdoc */ finally(onfinally) {
        return new $e9661cd6d20ea7e7$export$6f292d4960313241((resolve, reject)=>{
            let val;
            let isRejected;
            return this.then((value)=>{
                isRejected = false;
                val = value;
                if (onfinally) onfinally();
            }, (reason)=>{
                isRejected = true;
                val = reason;
                if (onfinally) onfinally();
            }).then(()=>{
                if (isRejected) {
                    reject(val);
                    return;
                }
                resolve(val);
            });
        });
    }
    /** Excute the resolve/reject handlers. */ _executeHandlers() {
        if (this._state === $e9661cd6d20ea7e7$var$STATE_PENDING) return;
        const cachedHandlers = this._handlers.slice();
        this._handlers = [];
        cachedHandlers.forEach((handler)=>{
            if (handler[0]) return;
            if (this._state === $e9661cd6d20ea7e7$var$STATE_RESOLVED) handler[1](this._value);
            if (this._state === $e9661cd6d20ea7e7$var$STATE_REJECTED) handler[2](this._value);
            handler[0] = true;
        });
    }
    /** Run the executor for the SyncPromise. */ _runExecutor(executor) {
        const setResult = (state, value)=>{
            if (this._state !== $e9661cd6d20ea7e7$var$STATE_PENDING) return;
            if ((0, $13cf2ed412f405fa$export$f5b060c2914b97c8)(value)) {
                value.then(resolve, reject);
                return;
            }
            this._state = state;
            this._value = value;
            this._executeHandlers();
        };
        const resolve = (value)=>{
            setResult($e9661cd6d20ea7e7$var$STATE_RESOLVED, value);
        };
        const reject = (reason)=>{
            setResult($e9661cd6d20ea7e7$var$STATE_REJECTED, reason);
        };
        try {
            executor(resolve, reject);
        } catch (e) {
            reject(e);
        }
    }
}


/**
 * Process an array of event processors, returning the processed event (or `null` if the event was dropped).
 */ function $516ccaba9c9cf262$export$bf2a096c3e883e79(processors, event, hint, index = 0) {
    try {
        const result = $516ccaba9c9cf262$var$_notifyEventProcessors(event, hint, processors, index);
        return (0, $13cf2ed412f405fa$export$f5b060c2914b97c8)(result) ? result : (0, $e9661cd6d20ea7e7$export$1fda8aa4d135f8aa)(result);
    } catch (error) {
        return (0, $e9661cd6d20ea7e7$export$78e43115b553f358)(error);
    }
}
function $516ccaba9c9cf262$var$_notifyEventProcessors(event, hint, processors, index) {
    const processor = processors[index];
    if (!event || !processor) return event;
    const result = processor({
        ...event
    }, hint);
    (0, $19fdbaf7f0830971$export$16a28057038b10ef) && result === null && (0, $d11ed0b3cdda6b8d$export$1c9f709888824e05).log(`Event processor "${processor.id || '?'}" dropped event`);
    if ((0, $13cf2ed412f405fa$export$f5b060c2914b97c8)(result)) return result.then((final)=>$516ccaba9c9cf262$var$_notifyEventProcessors(final, hint, processors, index + 1));
    return $516ccaba9c9cf262$var$_notifyEventProcessors(result, hint, processors, index + 1);
}





let $16a85e60da95d694$var$parsedStackResults;
let $16a85e60da95d694$var$lastSentryKeysCount;
let $16a85e60da95d694$var$lastNativeKeysCount;
let $16a85e60da95d694$var$cachedFilenameDebugIds;
/**
 * Returns a map of filenames to debug identifiers.
 * Supports both proprietary _sentryDebugIds and native _debugIds (e.g., from Vercel) formats.
 */ function $16a85e60da95d694$export$e069fee9c632ed00(stackParser) {
    const sentryDebugIdMap = (0, $736a69486c86d36c$export$f1a6cdb1459e81d1)._sentryDebugIds;
    const nativeDebugIdMap = (0, $736a69486c86d36c$export$f1a6cdb1459e81d1)._debugIds;
    if (!sentryDebugIdMap && !nativeDebugIdMap) return {};
    const sentryDebugIdKeys = sentryDebugIdMap ? Object.keys(sentryDebugIdMap) : [];
    const nativeDebugIdKeys = nativeDebugIdMap ? Object.keys(nativeDebugIdMap) : [];
    // If the count of registered globals hasn't changed since the last call, we
    // can just return the cached result.
    if ($16a85e60da95d694$var$cachedFilenameDebugIds && sentryDebugIdKeys.length === $16a85e60da95d694$var$lastSentryKeysCount && nativeDebugIdKeys.length === $16a85e60da95d694$var$lastNativeKeysCount) return $16a85e60da95d694$var$cachedFilenameDebugIds;
    $16a85e60da95d694$var$lastSentryKeysCount = sentryDebugIdKeys.length;
    $16a85e60da95d694$var$lastNativeKeysCount = nativeDebugIdKeys.length;
    // Build a map of filename -> debug_id from both sources
    $16a85e60da95d694$var$cachedFilenameDebugIds = {};
    if (!$16a85e60da95d694$var$parsedStackResults) $16a85e60da95d694$var$parsedStackResults = {};
    const processDebugIds = (debugIdKeys, debugIdMap)=>{
        for (const key of debugIdKeys){
            const debugId = debugIdMap[key];
            const result = $16a85e60da95d694$var$parsedStackResults?.[key];
            if (result && $16a85e60da95d694$var$cachedFilenameDebugIds && debugId) {
                // Use cached filename but update with current debug ID
                $16a85e60da95d694$var$cachedFilenameDebugIds[result[0]] = debugId;
                // Update cached result with new debug ID
                if ($16a85e60da95d694$var$parsedStackResults) $16a85e60da95d694$var$parsedStackResults[key] = [
                    result[0],
                    debugId
                ];
            } else if (debugId) {
                const parsedStack = stackParser(key);
                for(let i = parsedStack.length - 1; i >= 0; i--){
                    const stackFrame = parsedStack[i];
                    const filename = stackFrame?.filename;
                    if (filename && $16a85e60da95d694$var$cachedFilenameDebugIds && $16a85e60da95d694$var$parsedStackResults) {
                        $16a85e60da95d694$var$cachedFilenameDebugIds[filename] = debugId;
                        $16a85e60da95d694$var$parsedStackResults[key] = [
                            filename,
                            debugId
                        ];
                        break;
                    }
                }
            }
        }
    };
    if (sentryDebugIdMap) processDebugIds(sentryDebugIdKeys, sentryDebugIdMap);
    // Native _debugIds will override _sentryDebugIds if same file
    if (nativeDebugIdMap) processDebugIds(nativeDebugIdKeys, nativeDebugIdMap);
    return $16a85e60da95d694$var$cachedFilenameDebugIds;
}
/**
 * Returns a list of debug images for the given resources.
 */ function $16a85e60da95d694$export$5a7368330d9ee6e3(stackParser, resource_paths) {
    const filenameDebugIdMap = $16a85e60da95d694$export$e069fee9c632ed00(stackParser);
    if (!filenameDebugIdMap) return [];
    const images = [];
    for (const path of resource_paths){
        const normalizedPath = (0, $9ed2cf4edd0b2db9$export$60c0d6c8e038267a)(path);
        if (normalizedPath && filenameDebugIdMap[normalizedPath]) images.push({
            type: 'sourcemap',
            code_file: path,
            debug_id: filenameDebugIdMap[normalizedPath]
        });
    }
    return images;
}








/**
 * Applies data from the scope to the event and runs all event processors on it.
 */ function $9a2c488a2b943a4e$export$43988bc651a80216(event, data) {
    const { fingerprint: fingerprint, span: span, breadcrumbs: breadcrumbs, sdkProcessingMetadata: sdkProcessingMetadata } = data;
    // Apply general data
    $9a2c488a2b943a4e$var$applyDataToEvent(event, data);
    // We want to set the trace context for normal events only if there isn't already
    // a trace context on the event. There is a product feature in place where we link
    // errors with transaction and it relies on that.
    if (span) $9a2c488a2b943a4e$var$applySpanToEvent(event, span);
    $9a2c488a2b943a4e$var$applyFingerprintToEvent(event, fingerprint);
    $9a2c488a2b943a4e$var$applyBreadcrumbsToEvent(event, breadcrumbs);
    $9a2c488a2b943a4e$var$applySdkMetadataToEvent(event, sdkProcessingMetadata);
}
/** Merge data of two scopes together. */ function $9a2c488a2b943a4e$export$25ac7e259a513db4(data, mergeData) {
    const { extra: extra, tags: tags, attributes: attributes, user: user, contexts: contexts, level: level, sdkProcessingMetadata: sdkProcessingMetadata, breadcrumbs: breadcrumbs, fingerprint: fingerprint, eventProcessors: eventProcessors, attachments: attachments, propagationContext: propagationContext, transactionName: transactionName, span: span } = mergeData;
    $9a2c488a2b943a4e$export$b1a120a2871faa46(data, 'extra', extra);
    $9a2c488a2b943a4e$export$b1a120a2871faa46(data, 'tags', tags);
    $9a2c488a2b943a4e$export$b1a120a2871faa46(data, 'attributes', attributes);
    $9a2c488a2b943a4e$export$b1a120a2871faa46(data, 'user', user);
    $9a2c488a2b943a4e$export$b1a120a2871faa46(data, 'contexts', contexts);
    data.sdkProcessingMetadata = (0, $40b0d31022c415bf$export$4950aa0f605343fb)(data.sdkProcessingMetadata, sdkProcessingMetadata, 2);
    if (level) data.level = level;
    if (transactionName) data.transactionName = transactionName;
    if (span) data.span = span;
    if (breadcrumbs.length) data.breadcrumbs = [
        ...data.breadcrumbs,
        ...breadcrumbs
    ];
    if (fingerprint.length) data.fingerprint = [
        ...data.fingerprint,
        ...fingerprint
    ];
    if (eventProcessors.length) data.eventProcessors = [
        ...data.eventProcessors,
        ...eventProcessors
    ];
    if (attachments.length) data.attachments = [
        ...data.attachments,
        ...attachments
    ];
    data.propagationContext = {
        ...data.propagationContext,
        ...propagationContext
    };
}
/**
 * Merges certain scope data. Undefined values will overwrite any existing values.
 * Exported only for tests.
 */ function $9a2c488a2b943a4e$export$b1a120a2871faa46(data, prop, mergeVal) {
    data[prop] = (0, $40b0d31022c415bf$export$4950aa0f605343fb)(data[prop], mergeVal, 1);
}
/**
 * Get the scope data for the current scope after merging with the
 * global scope and isolation scope.
 *
 * @param currentScope - The current scope.
 * @returns The scope data.
 */ function $9a2c488a2b943a4e$export$cc422922fcbb91c6(isolationScope, currentScope) {
    const scopeData = (0, $7d48e1ed9f699a01$export$aa55d5ab8e05984f)().getScopeData();
    isolationScope && $9a2c488a2b943a4e$export$25ac7e259a513db4(scopeData, isolationScope.getScopeData());
    currentScope && $9a2c488a2b943a4e$export$25ac7e259a513db4(scopeData, currentScope.getScopeData());
    return scopeData;
}
function $9a2c488a2b943a4e$var$applyDataToEvent(event, data) {
    const { extra: extra, tags: tags, user: user, contexts: contexts, level: level, transactionName: transactionName } = data;
    if (Object.keys(extra).length) event.extra = {
        ...extra,
        ...event.extra
    };
    if (Object.keys(tags).length) event.tags = {
        ...tags,
        ...event.tags
    };
    if (Object.keys(user).length) event.user = {
        ...user,
        ...event.user
    };
    if (Object.keys(contexts).length) event.contexts = {
        ...contexts,
        ...event.contexts
    };
    if (level) event.level = level;
    // transaction events get their `transaction` from the root span name
    if (transactionName && event.type !== 'transaction') event.transaction = transactionName;
}
function $9a2c488a2b943a4e$var$applyBreadcrumbsToEvent(event, breadcrumbs) {
    const mergedBreadcrumbs = [
        ...event.breadcrumbs || [],
        ...breadcrumbs
    ];
    event.breadcrumbs = mergedBreadcrumbs.length ? mergedBreadcrumbs : undefined;
}
function $9a2c488a2b943a4e$var$applySdkMetadataToEvent(event, sdkProcessingMetadata) {
    event.sdkProcessingMetadata = {
        ...event.sdkProcessingMetadata,
        ...sdkProcessingMetadata
    };
}
function $9a2c488a2b943a4e$var$applySpanToEvent(event, span) {
    event.contexts = {
        trace: (0, $bb9b6447bf4caedb$export$46c6fbd1d265ebf0)(span),
        ...event.contexts
    };
    event.sdkProcessingMetadata = {
        dynamicSamplingContext: (0, $09fae5ef8120e803$export$a117f995597e25df)(span),
        ...event.sdkProcessingMetadata
    };
    const rootSpan = (0, $bb9b6447bf4caedb$export$c4c6a79b1260ca1b)(span);
    const transactionName = (0, $bb9b6447bf4caedb$export$92d8c23565496537)(rootSpan).description;
    if (transactionName && !event.transaction && event.type === 'transaction') event.transaction = transactionName;
}
/**
 * Applies fingerprint from the scope to the event if there's one,
 * uses message if there's one instead or get rid of empty fingerprint
 */ function $9a2c488a2b943a4e$var$applyFingerprintToEvent(event, fingerprint) {
    // Make sure it's an array first and we actually have something in place
    event.fingerprint = event.fingerprint ? Array.isArray(event.fingerprint) ? event.fingerprint : [
        event.fingerprint
    ] : [];
    // If we have something on the scope, then merge it with event
    if (fingerprint) event.fingerprint = event.fingerprint.concat(fingerprint);
    // If we have no data at all, remove empty array default
    if (!event.fingerprint.length) delete event.fingerprint;
}





/**
 * This type makes sure that we get either a CaptureContext, OR an EventHint.
 * It does not allow mixing them, which could lead to unexpected outcomes, e.g. this is disallowed:
 * { user: { id: '123' }, mechanism: { handled: false } }
 */ /**
 * Adds common information to events.
 *
 * The information includes release and environment from `options`,
 * breadcrumbs and context (extra, tags and user) from the scope.
 *
 * Information that is already present in the event is never overwritten. For
 * nested objects, such as the context, keys are merged.
 *
 * @param event The original event.
 * @param hint May contain additional information about the original exception.
 * @param scope A scope containing event metadata.
 * @returns A new event with more information.
 * @hidden
 */ function $e98f8a40c7329053$export$2d67fb380bd11267(options, event, hint, scope, client, isolationScope) {
    const { normalizeDepth: normalizeDepth = 3, normalizeMaxBreadth: normalizeMaxBreadth = 1000 } = options;
    const prepared = {
        ...event,
        event_id: event.event_id || hint.event_id || (0, $cc262db35458e4b3$export$19f53698e68b2496)(),
        timestamp: event.timestamp || (0, $bc81602376c48fa6$export$7740643b9eeaf0c4)()
    };
    const integrations = hint.integrations || options.integrations.map((i)=>i.name);
    $e98f8a40c7329053$export$d7e04067a6fbc882(prepared, options);
    $e98f8a40c7329053$var$applyIntegrationsMetadata(prepared, integrations);
    if (client) client.emit('applyFrameMetadata', event);
    // Only put debug IDs onto frames for error events.
    if (event.type === undefined) $e98f8a40c7329053$export$63042efc86f043e7(prepared, options.stackParser);
    // If we have scope given to us, use it as the base for further modifications.
    // This allows us to prevent unnecessary copying of data if `captureContext` is not provided.
    const finalScope = $e98f8a40c7329053$var$getFinalScope(scope, hint.captureContext);
    if (hint.mechanism) (0, $cc262db35458e4b3$export$c69a9a0313b03bb1)(prepared, hint.mechanism);
    const clientEventProcessors = client ? client.getEventProcessors() : [];
    // This should be the last thing called, since we want that
    // {@link Scope.addEventProcessor} gets the finished prepared event.
    // Merge scope data together
    const data = (0, $9a2c488a2b943a4e$export$cc422922fcbb91c6)(isolationScope, finalScope);
    const attachments = [
        ...hint.attachments || [],
        ...data.attachments
    ];
    if (attachments.length) hint.attachments = attachments;
    (0, $9a2c488a2b943a4e$export$43988bc651a80216)(prepared, data);
    const eventProcessors = [
        ...clientEventProcessors,
        // Run scope event processors _after_ all other processors
        ...data.eventProcessors
    ];
    // Skip event processors for internal exceptions to prevent recursion
    // oxlint-disable-next-line typescript/prefer-optional-chain
    const isInternalException = hint.data && hint.data.__sentry__ === true;
    const result = isInternalException ? (0, $e9661cd6d20ea7e7$export$1fda8aa4d135f8aa)(prepared) : (0, $516ccaba9c9cf262$export$bf2a096c3e883e79)(eventProcessors, prepared, hint);
    return result.then((evt)=>{
        if (evt) // We apply the debug_meta field only after all event processors have ran, so that if any event processors modified
        // file names (e.g.the RewriteFrames integration) the filename -> debug ID relationship isn't destroyed.
        // This should not cause any PII issues, since we're only moving data that is already on the event and not adding
        // any new data
        $e98f8a40c7329053$export$1be657ba8ef44ff0(evt);
        if (typeof normalizeDepth === 'number' && normalizeDepth > 0) return $e98f8a40c7329053$var$normalizeEvent(evt, normalizeDepth, normalizeMaxBreadth);
        return evt;
    });
}
/**
 * Enhances event using the client configuration.
 * It takes care of all "static" values like environment, release and `dist`,
 * as well as truncating overly long values.
 *
 * Only exported for tests.
 *
 * @param event event instance to be enhanced
 */ function $e98f8a40c7329053$export$d7e04067a6fbc882(event, options) {
    const { environment: environment, release: release, dist: dist, maxValueLength: maxValueLength } = options;
    // empty strings do not make sense for environment, release, and dist
    // so we handle them the same as if they were not provided
    event.environment = event.environment || environment || (0, $4e93b773a0d3a86a$export$849dbeeeda01ae98);
    if (!event.release && release) event.release = release;
    if (!event.dist && dist) event.dist = dist;
    const request = event.request;
    if (request?.url && maxValueLength) request.url = (0, $e534db390d1e4996$export$6a506b36fdea397d)(request.url, maxValueLength);
    if (maxValueLength) event.exception?.values?.forEach((exception)=>{
        if (exception.value) // Truncates error messages
        exception.value = (0, $e534db390d1e4996$export$6a506b36fdea397d)(exception.value, maxValueLength);
    });
}
/**
 * Puts debug IDs into the stack frames of an error event.
 */ function $e98f8a40c7329053$export$63042efc86f043e7(event, stackParser) {
    // Build a map of filename -> debug_id
    const filenameDebugIdMap = (0, $16a85e60da95d694$export$e069fee9c632ed00)(stackParser);
    event.exception?.values?.forEach((exception)=>{
        exception.stacktrace?.frames?.forEach((frame)=>{
            if (frame.filename) frame.debug_id = filenameDebugIdMap[frame.filename];
        });
    });
}
/**
 * Moves debug IDs from the stack frames of an error event into the debug_meta field.
 */ function $e98f8a40c7329053$export$1be657ba8ef44ff0(event) {
    // Extract debug IDs and filenames from the stack frames on the event.
    const filenameDebugIdMap = {};
    event.exception?.values?.forEach((exception)=>{
        exception.stacktrace?.frames?.forEach((frame)=>{
            if (frame.debug_id) {
                if (frame.abs_path) filenameDebugIdMap[frame.abs_path] = frame.debug_id;
                else if (frame.filename) filenameDebugIdMap[frame.filename] = frame.debug_id;
                delete frame.debug_id;
            }
        });
    });
    if (Object.keys(filenameDebugIdMap).length === 0) return;
    // Fill debug_meta information
    event.debug_meta = event.debug_meta || {};
    event.debug_meta.images = event.debug_meta.images || [];
    const images = event.debug_meta.images;
    Object.entries(filenameDebugIdMap).forEach(([filename, debug_id])=>{
        images.push({
            type: 'sourcemap',
            code_file: filename,
            debug_id: debug_id
        });
    });
}
/**
 * This function adds all used integrations to the SDK info in the event.
 * @param event The event that will be filled with all integrations.
 */ function $e98f8a40c7329053$var$applyIntegrationsMetadata(event, integrationNames) {
    if (integrationNames.length > 0) {
        event.sdk = event.sdk || {};
        event.sdk.integrations = [
            ...event.sdk.integrations || [],
            ...integrationNames
        ];
    }
}
/**
 * Applies `normalize` function on necessary `Event` attributes to make them safe for serialization.
 * Normalized keys:
 * - `breadcrumbs.data`
 * - `user`
 * - `contexts`
 * - `extra`
 * @param event Event
 * @returns Normalized event
 */ function $e98f8a40c7329053$var$normalizeEvent(event, depth, maxBreadth) {
    if (!event) return null;
    const normalized = {
        ...event,
        ...event.breadcrumbs && {
            breadcrumbs: event.breadcrumbs.map((b)=>({
                    ...b,
                    ...b.data && {
                        data: (0, $2d7134eeb4bc669b$export$a3295358bff77e)(b.data, depth, maxBreadth)
                    }
                }))
        },
        ...event.user && {
            user: (0, $2d7134eeb4bc669b$export$a3295358bff77e)(event.user, depth, maxBreadth)
        },
        ...event.contexts && {
            contexts: (0, $2d7134eeb4bc669b$export$a3295358bff77e)(event.contexts, depth, maxBreadth)
        },
        ...event.extra && {
            extra: (0, $2d7134eeb4bc669b$export$a3295358bff77e)(event.extra, depth, maxBreadth)
        }
    };
    // event.contexts.trace stores information about a Transaction. Similarly,
    // event.spans[] stores information about child Spans. Given that a
    // Transaction is conceptually a Span, normalization should apply to both
    // Transactions and Spans consistently.
    // For now the decision is to skip normalization of Transactions and Spans,
    // so this block overwrites the normalized event to add back the original
    // Transaction information prior to normalization.
    if (event.contexts?.trace && normalized.contexts) {
        normalized.contexts.trace = event.contexts.trace;
        // event.contexts.trace.data may contain circular/dangerous data so we need to normalize it
        if (event.contexts.trace.data) normalized.contexts.trace.data = (0, $2d7134eeb4bc669b$export$a3295358bff77e)(event.contexts.trace.data, depth, maxBreadth);
    }
    // event.spans[].data may contain circular/dangerous data so we need to normalize it
    if (event.spans) normalized.spans = event.spans.map((span)=>{
        return {
            ...span,
            ...span.data && {
                data: (0, $2d7134eeb4bc669b$export$a3295358bff77e)(span.data, depth, maxBreadth)
            }
        };
    });
    // event.contexts.flags (FeatureFlagContext) stores context for our feature
    // flag integrations. It has a greater nesting depth than our other typed
    // Contexts, so we re-normalize with a fixed depth of 3 here. We do not want
    // to skip this in case of conflicting, user-provided context.
    if (event.contexts?.flags && normalized.contexts) normalized.contexts.flags = (0, $2d7134eeb4bc669b$export$a3295358bff77e)(event.contexts.flags, 3, maxBreadth);
    return normalized;
}
function $e98f8a40c7329053$var$getFinalScope(scope, captureContext) {
    if (!captureContext) return scope;
    const finalScope = scope ? scope.clone() : new (0, $dd23bca0e7d7618a$export$775b6bb06e53a214)();
    finalScope.update(captureContext);
    return finalScope;
}
/**
 * Parse either an `EventHint` directly, or convert a `CaptureContext` to an `EventHint`.
 * This is used to allow to update method signatures that used to accept a `CaptureContext` but should now accept an `EventHint`.
 */ function $e98f8a40c7329053$export$76b5f966996d1653(hint) {
    if (!hint) return undefined;
    // If you pass a Scope or `() => Scope` as CaptureContext, we just return this as captureContext
    if ($e98f8a40c7329053$var$hintIsScopeOrFunction(hint)) return {
        captureContext: hint
    };
    if ($e98f8a40c7329053$var$hintIsScopeContext(hint)) return {
        captureContext: hint
    };
    return hint;
}
function $e98f8a40c7329053$var$hintIsScopeOrFunction(hint) {
    return hint instanceof (0, $dd23bca0e7d7618a$export$775b6bb06e53a214) || typeof hint === 'function';
}
const $e98f8a40c7329053$var$captureContextKeys = [
    'user',
    'level',
    'extra',
    'contexts',
    'tags',
    'fingerprint',
    'propagationContext'
];
function $e98f8a40c7329053$var$hintIsScopeContext(hint) {
    return Object.keys(hint).some((key)=>$e98f8a40c7329053$var$captureContextKeys.includes(key));
}





/**
 * Captures an exception event and sends it to Sentry.
 *
 * @param exception The exception to capture.
 * @param hint Optional additional data to attach to the Sentry event.
 * @returns the id of the captured Sentry event.
 */ function $6918c722b531ff18$export$f5282963edea4a68(exception, hint) {
    return (0, $7d48e1ed9f699a01$export$c7be4b0125a10cba)().captureException(exception, (0, $e98f8a40c7329053$export$76b5f966996d1653)(hint));
}
/**
 * Captures a message event and sends it to Sentry.
 *
 * @param message The message to send to Sentry.
 * @param captureContext Define the level of the message or pass in additional data to attach to the message.
 * @returns the id of the captured message.
 */ function $6918c722b531ff18$export$45654777c133ae80(message, captureContext) {
    // This is necessary to provide explicit scopes upgrade, without changing the original
    // arity of the `captureMessage(message, level)` method.
    const level = typeof captureContext === 'string' ? captureContext : undefined;
    const hint = typeof captureContext !== 'string' ? {
        captureContext: captureContext
    } : undefined;
    return (0, $7d48e1ed9f699a01$export$c7be4b0125a10cba)().captureMessage(message, level, hint);
}
/**
 * Captures a manually created event and sends it to Sentry.
 *
 * @param event The event to send to Sentry.
 * @param hint Optional additional data to attach to the Sentry event.
 * @returns the id of the captured event.
 */ function $6918c722b531ff18$export$1462b974fdcf6ba2(event, hint) {
    return (0, $7d48e1ed9f699a01$export$c7be4b0125a10cba)().captureEvent(event, hint);
}
/**
 * Sets context data with the given name.
 * @param name of the context
 * @param context Any kind of data. This data will be normalized.
 */ function $6918c722b531ff18$export$2f04de43fe27971a(name, context) {
    (0, $7d48e1ed9f699a01$export$68f3af03034c9e90)().setContext(name, context);
}
/**
 * Set an object that will be merged sent as extra data with the event.
 * @param extras Extras object to merge into current context.
 */ function $6918c722b531ff18$export$bb4922da0dd51b92(extras) {
    (0, $7d48e1ed9f699a01$export$68f3af03034c9e90)().setExtras(extras);
}
/**
 * Set key:value that will be sent as extra data with the event.
 * @param key String of extra
 * @param extra Any kind of data. This data will be normalized.
 */ function $6918c722b531ff18$export$8e8e7789d42ed61d(key, extra) {
    (0, $7d48e1ed9f699a01$export$68f3af03034c9e90)().setExtra(key, extra);
}
/**
 * Set an object that will be merged sent as tags data with the event.
 * @param tags Tags context object to merge into current context.
 */ function $6918c722b531ff18$export$74a8fb34822092e6(tags) {
    (0, $7d48e1ed9f699a01$export$68f3af03034c9e90)().setTags(tags);
}
/**
 * Set key:value that will be sent as tags data with the event.
 *
 * Can also be used to unset a tag, by passing `undefined`.
 *
 * @param key String key of tag
 * @param value Value of tag
 */ function $6918c722b531ff18$export$a37d07ee78eb4569(key, value) {
    (0, $7d48e1ed9f699a01$export$68f3af03034c9e90)().setTag(key, value);
}
/**
 * Updates user context information for future events.
 *
 * @param user User context object to be set in the current context. Pass `null` to unset the user.
 */ function $6918c722b531ff18$export$8b6bb3dd62a01be2(user) {
    (0, $7d48e1ed9f699a01$export$68f3af03034c9e90)().setUser(user);
}
/**
 * Sets the conversation ID for the current isolation scope.
 *
 * @param conversationId The conversation ID to set. Pass `null` or `undefined` to unset the conversation ID.
 */ function $6918c722b531ff18$export$58213391a19e392(conversationId) {
    (0, $7d48e1ed9f699a01$export$68f3af03034c9e90)().setConversationId(conversationId);
}
/**
 * The last error event id of the isolation scope.
 *
 * Warning: This function really returns the last recorded error event id on the current
 * isolation scope. If you call this function after handling a certain error and another error
 * is captured in between, the last one is returned instead of the one you might expect.
 * Also, ids of events that were never sent to Sentry (for example because
 * they were dropped in `beforeSend`) could be returned.
 *
 * @returns The last event id of the isolation scope.
 */ function $6918c722b531ff18$export$5d4e9fd7fac8e617() {
    return (0, $7d48e1ed9f699a01$export$68f3af03034c9e90)().lastEventId();
}
/**
 * Create a cron monitor check in and send it to Sentry.
 *
 * @param checkIn An object that describes a check in.
 * @param upsertMonitorConfig An optional object that describes a monitor config. Use this if you want
 * to create a monitor automatically when sending a check in.
 */ function $6918c722b531ff18$export$413528111fbc67c(checkIn, upsertMonitorConfig) {
    const scope = (0, $7d48e1ed9f699a01$export$c7be4b0125a10cba)();
    const client = (0, $7d48e1ed9f699a01$export$6bb76d6eba7e258c)();
    if (!client) (0, $19fdbaf7f0830971$export$16a28057038b10ef) && (0, $d11ed0b3cdda6b8d$export$1c9f709888824e05).warn('Cannot capture check-in. No client defined.');
    else if (!client.captureCheckIn) (0, $19fdbaf7f0830971$export$16a28057038b10ef) && (0, $d11ed0b3cdda6b8d$export$1c9f709888824e05).warn('Cannot capture check-in. Client does not support sending check-ins.');
    else return client.captureCheckIn(checkIn, upsertMonitorConfig, scope);
    return (0, $cc262db35458e4b3$export$19f53698e68b2496)();
}
/**
 * Wraps a callback with a cron monitor check in. The check in will be sent to Sentry when the callback finishes.
 *
 * @param monitorSlug The distinct slug of the monitor.
 * @param callback Callback to be monitored
 * @param upsertMonitorConfig An optional object that describes a monitor config. Use this if you want
 * to create a monitor automatically when sending a check in.
 */ function $6918c722b531ff18$export$553526fc5f03c0b1(monitorSlug, callback, upsertMonitorConfig) {
    function runCallback() {
        const checkInId = $6918c722b531ff18$export$413528111fbc67c({
            monitorSlug: monitorSlug,
            status: 'in_progress'
        }, upsertMonitorConfig);
        const now = (0, $bc81602376c48fa6$export$ee52dced521e3e18)();
        function finishCheckIn(status) {
            $6918c722b531ff18$export$413528111fbc67c({
                monitorSlug: monitorSlug,
                status: status,
                checkInId: checkInId,
                duration: (0, $bc81602376c48fa6$export$ee52dced521e3e18)() - now
            });
        }
        // Default behavior without isolateTrace
        let maybePromiseResult;
        try {
            maybePromiseResult = callback();
        } catch (e) {
            finishCheckIn('error');
            throw e;
        }
        if ((0, $13cf2ed412f405fa$export$f5b060c2914b97c8)(maybePromiseResult)) return maybePromiseResult.then((r)=>{
            finishCheckIn('ok');
            return r;
        }, (e)=>{
            finishCheckIn('error');
            throw e;
        });
        finishCheckIn('ok');
        return maybePromiseResult;
    }
    return (0, $7d48e1ed9f699a01$export$9a4fed82c350c2bd)(()=>upsertMonitorConfig?.isolateTrace ? (0, $c9161b67125aefc1$export$f90b03291402f553)(runCallback) : runCallback());
}
/**
 * Call `flush()` on the current client, if there is one. See {@link Client.flush}.
 *
 * @param timeout Maximum time in ms the client should wait to flush its event queue. Omitting this parameter will cause
 * the client to wait until all events are sent before resolving the promise.
 * @returns A promise which resolves to `true` if the queue successfully drains before the timeout, or `false` if it
 * doesn't (or if there's no client defined).
 */ async function $6918c722b531ff18$export$4909b86c8034bf73(timeout) {
    const client = (0, $7d48e1ed9f699a01$export$6bb76d6eba7e258c)();
    if (client) return client.flush(timeout);
    (0, $19fdbaf7f0830971$export$16a28057038b10ef) && (0, $d11ed0b3cdda6b8d$export$1c9f709888824e05).warn('Cannot flush events. No client defined.');
    return Promise.resolve(false);
}
/**
 * Call `close()` on the current client, if there is one. See {@link Client.close}.
 *
 * @param timeout Maximum time in ms the client should wait to flush its event queue before shutting down. Omitting this
 * parameter will cause the client to wait until all events are sent before disabling itself.
 * @returns A promise which resolves to `true` if the queue successfully drains before the timeout, or `false` if it
 * doesn't (or if there's no client defined).
 */ async function $6918c722b531ff18$export$8360e631d277ea4d(timeout) {
    const client = (0, $7d48e1ed9f699a01$export$6bb76d6eba7e258c)();
    if (client) return client.close(timeout);
    (0, $19fdbaf7f0830971$export$16a28057038b10ef) && (0, $d11ed0b3cdda6b8d$export$1c9f709888824e05).warn('Cannot flush events and disable SDK. No client defined.');
    return Promise.resolve(false);
}
/**
 * Returns true if Sentry has been properly initialized.
 */ function $6918c722b531ff18$export$3f95c6f800b78024() {
    return !!(0, $7d48e1ed9f699a01$export$6bb76d6eba7e258c)();
}
/** If the SDK is initialized & enabled. */ function $6918c722b531ff18$export$3b029eb57ac4d562() {
    const client = (0, $7d48e1ed9f699a01$export$6bb76d6eba7e258c)();
    return client?.getOptions().enabled !== false && !!client?.getTransport();
}
/**
 * Add an event processor.
 * This will be added to the current isolation scope, ensuring any event that is processed in the current execution
 * context will have the processor applied.
 */ function $6918c722b531ff18$export$9aac0b9f77928fbf(callback) {
    (0, $7d48e1ed9f699a01$export$68f3af03034c9e90)().addEventProcessor(callback);
}
/**
 * Start a session on the current isolation scope.
 *
 * @param context (optional) additional properties to be applied to the returned session object
 *
 * @returns the new active session
 */ function $6918c722b531ff18$export$c0d84948cecf78d8(context) {
    const isolationScope = (0, $7d48e1ed9f699a01$export$68f3af03034c9e90)();
    const { user: user } = (0, $9a2c488a2b943a4e$export$cc422922fcbb91c6)(isolationScope, (0, $7d48e1ed9f699a01$export$c7be4b0125a10cba)());
    // Will fetch userAgent if called from browser sdk
    const { userAgent: userAgent } = (0, $736a69486c86d36c$export$f1a6cdb1459e81d1).navigator || {};
    const session = (0, $e6ef9757665bd407$export$14a186326edbb264)({
        user: user,
        ...userAgent && {
            userAgent: userAgent
        },
        ...context
    });
    // End existing session if there's one
    const currentSession = isolationScope.getSession();
    if (currentSession?.status === 'ok') (0, $e6ef9757665bd407$export$531818e825e774db)(currentSession, {
        status: 'exited'
    });
    $6918c722b531ff18$export$17a5be43989a0bc1();
    // Afterwards we set the new session on the scope
    isolationScope.setSession(session);
    return session;
}
/**
 * End the session on the current isolation scope.
 */ function $6918c722b531ff18$export$17a5be43989a0bc1() {
    const isolationScope = (0, $7d48e1ed9f699a01$export$68f3af03034c9e90)();
    const currentScope = (0, $7d48e1ed9f699a01$export$c7be4b0125a10cba)();
    const session = currentScope.getSession() || isolationScope.getSession();
    if (session) (0, $e6ef9757665bd407$export$56521d9ba90f62ee)(session);
    $6918c722b531ff18$var$_sendSessionUpdate();
    // the session is over; take it off of the scope
    isolationScope.setSession();
}
/**
 * Sends the current Session on the scope
 */ function $6918c722b531ff18$var$_sendSessionUpdate() {
    const isolationScope = (0, $7d48e1ed9f699a01$export$68f3af03034c9e90)();
    const client = (0, $7d48e1ed9f699a01$export$6bb76d6eba7e258c)();
    const session = isolationScope.getSession();
    if (session && client) client.captureSession(session);
}
/**
 * Sends the current session on the scope to Sentry
 *
 * @param end If set the session will be marked as exited and removed from the scope.
 *            Defaults to `false`.
 */ function $6918c722b531ff18$export$667e7b4d445d566b(end = false) {
    // both send the update and pull the session from the scope
    if (end) {
        $6918c722b531ff18$export$17a5be43989a0bc1();
        return;
    }
    // only send the update
    $6918c722b531ff18$var$_sendSessionUpdate();
}


const $e62dec891f31852b$export$56d8a8a25bd48b81 = (0, $736a69486c86d36c$export$f1a6cdb1459e81d1);
let $e62dec891f31852b$var$ignoreOnError = 0;
/**
 * @hidden
 */ function $e62dec891f31852b$export$b79738ab10c590b2() {
    return $e62dec891f31852b$var$ignoreOnError > 0;
}
/**
 * @hidden
 */ function $e62dec891f31852b$export$1265a142ff5ba165() {
    // onerror should trigger before setTimeout
    $e62dec891f31852b$var$ignoreOnError++;
    setTimeout(()=>{
        $e62dec891f31852b$var$ignoreOnError--;
    });
}
// eslint-disable-next-line @typescript-eslint/ban-types
/**
 * Instruments the given function and sends an event to Sentry every time the
 * function throws an exception.
 *
 * @param fn A function to wrap. It is generally safe to pass an unbound function, because the returned wrapper always
 * has a correct `this` context.
 * @returns The wrapped function.
 * @hidden
 */ function $e62dec891f31852b$export$4997ffc0176396a6(fn, options = {}) {
    // for future readers what this does is wrap a function and then create
    // a bi-directional wrapping between them.
    //
    // example: wrapped = wrap(original);
    //  original.__sentry_wrapped__ -> wrapped
    //  wrapped.__sentry_original__ -> original
    function isFunction(fn) {
        return typeof fn === 'function';
    }
    if (!isFunction(fn)) return fn;
    try {
        // if we're dealing with a function that was previously wrapped, return
        // the original wrapper.
        const wrapper = fn.__sentry_wrapped__;
        if (wrapper) {
            if (typeof wrapper === 'function') return wrapper;
            else // If we find that the `__sentry_wrapped__` function is not a function at the time of accessing it, it means
            // that something messed with it. In that case we want to return the originally passed function.
            return fn;
        }
        // We don't wanna wrap it twice
        if ((0, $269eeb69635ed414$export$e6cc1e135e2092e5)(fn)) return fn;
    } catch  {
        // Just accessing custom props in some Selenium environments
        // can cause a "Permission denied" exception (see raven-js#495).
        // Bail on wrapping and return the function as-is (defers to window.onerror).
        return fn;
    }
    // Wrap the function itself
    // It is important that `sentryWrapped` is not an arrow function to preserve the context of `this`
    const sentryWrapped = function(...args) {
        try {
            // Also wrap arguments that are themselves functions
            const wrappedArguments = args.map((arg)=>$e62dec891f31852b$export$4997ffc0176396a6(arg, options));
            // Attempt to invoke user-land function
            // NOTE: If you are a Sentry user, and you are seeing this stack frame, it
            //       means the sentry.javascript SDK caught an error invoking your application code. This
            //       is expected behavior and NOT indicative of a bug with sentry.javascript.
            return fn.apply(this, wrappedArguments);
        } catch (ex) {
            $e62dec891f31852b$export$1265a142ff5ba165();
            (0, $7d48e1ed9f699a01$export$ec58d9285c204497)((scope)=>{
                scope.addEventProcessor((event)=>{
                    if (options.mechanism) {
                        (0, $cc262db35458e4b3$export$f26508487bf83ee7)(event, undefined, undefined);
                        (0, $cc262db35458e4b3$export$c69a9a0313b03bb1)(event, options.mechanism);
                    }
                    event.extra = {
                        ...event.extra,
                        arguments: args
                    };
                    return event;
                });
                // no need to add a mechanism here, we already add it via an event processor above
                (0, $6918c722b531ff18$export$f5282963edea4a68)(ex);
            });
            throw ex;
        }
    };
    // Wrap the wrapped function in a proxy, to ensure any other properties of the original function remain available
    try {
        for(const property in fn)if (Object.prototype.hasOwnProperty.call(fn, property)) sentryWrapped[property] = fn[property];
    } catch  {
    // Accessing some objects may throw
    // ref: https://github.com/getsentry/sentry-javascript/issues/1168
    }
    // Signal that this function has been wrapped/filled already
    // for both debugging and to prevent it to being wrapped/filled twice
    (0, $269eeb69635ed414$export$5c1499e2e5d010ae)(sentryWrapped, fn);
    (0, $269eeb69635ed414$export$e73679ffaf56810e)(fn, '__sentry_wrapped__', sentryWrapped);
    // Restore original function name (not all browsers allow that)
    try {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const descriptor = Object.getOwnPropertyDescriptor(sentryWrapped, 'name');
        if (descriptor.configurable) Object.defineProperty(sentryWrapped, 'name', {
            get () {
                return fn.name;
            }
        });
    } catch  {
    // This may throw if e.g. the descriptor does not exist, or a browser does not allow redefining `name`.
    // to save some bytes we simply try-catch this
    }
    return sentryWrapped;
}
/**
 * Get HTTP request data from the current page.
 */ function $e62dec891f31852b$export$a3c4a8453e8936f0() {
    // grab as much info as exists and add it to the event
    const url = (0, $caac489b9d8395b2$export$1cfafeee2987818b)();
    const { referrer: referrer } = $e62dec891f31852b$export$56d8a8a25bd48b81.document || {};
    const { userAgent: userAgent } = $e62dec891f31852b$export$56d8a8a25bd48b81.navigator || {};
    const headers = {
        ...referrer && {
            Referer: referrer
        },
        ...userAgent && {
            'User-Agent': userAgent
        }
    };
    const request = {
        url: url,
        headers: headers
    };
    return request;
}


// This is a map of integration function method to bundle file name.
const $3fc94f2ac1572f6d$var$LazyLoadableIntegrations = {
    replayIntegration: 'replay',
    replayCanvasIntegration: 'replay-canvas',
    feedbackIntegration: 'feedback',
    feedbackModalIntegration: 'feedback-modal',
    feedbackScreenshotIntegration: 'feedback-screenshot',
    captureConsoleIntegration: 'captureconsole',
    contextLinesIntegration: 'contextlines',
    linkedErrorsIntegration: 'linkederrors',
    dedupeIntegration: 'dedupe',
    extraErrorDataIntegration: 'extraerrordata',
    graphqlClientIntegration: 'graphqlclient',
    httpClientIntegration: 'httpclient',
    reportingObserverIntegration: 'reportingobserver',
    rewriteFramesIntegration: 'rewriteframes',
    browserProfilingIntegration: 'browserprofiling',
    moduleMetadataIntegration: 'modulemetadata',
    instrumentAnthropicAiClient: 'instrumentanthropicaiclient',
    instrumentOpenAiClient: 'instrumentopenaiclient',
    instrumentGoogleGenAIClient: 'instrumentgooglegenaiclient',
    instrumentLangGraph: 'instrumentlanggraph',
    createLangChainCallbackHandler: 'createlangchaincallbackhandler'
};
const $3fc94f2ac1572f6d$var$WindowWithMaybeIntegration = (0, $e62dec891f31852b$export$56d8a8a25bd48b81);
/**
 * Lazy load an integration from the CDN.
 * Rejects if the integration cannot be loaded.
 */ async function $3fc94f2ac1572f6d$export$6da56f3ddf2bd0c1(name, scriptNonce) {
    const bundle = $3fc94f2ac1572f6d$var$LazyLoadableIntegrations[name];
    // `window.Sentry` is only set when using a CDN bundle, but this method can also be used via the NPM package
    const sentryOnWindow = $3fc94f2ac1572f6d$var$WindowWithMaybeIntegration.Sentry = $3fc94f2ac1572f6d$var$WindowWithMaybeIntegration.Sentry || {};
    if (!bundle) throw new Error(`Cannot lazy load integration: ${name}`);
    // Bail if the integration already exists
    const existing = sentryOnWindow[name];
    // The `feedbackIntegration` is loaded by default in the CDN bundles,
    // so we need to differentiate between the real integration and the shim.
    // if only the shim exists, we still want to lazy load the real integration.
    if (typeof existing === 'function' && !('_isShim' in existing)) return existing;
    const url = $3fc94f2ac1572f6d$var$getScriptURL(bundle);
    const script = (0, $e62dec891f31852b$export$56d8a8a25bd48b81).document.createElement('script');
    script.src = url;
    script.crossOrigin = 'anonymous';
    script.referrerPolicy = 'strict-origin';
    if (scriptNonce) script.setAttribute('nonce', scriptNonce);
    const waitForLoad = new Promise((resolve, reject)=>{
        script.addEventListener('load', ()=>resolve());
        script.addEventListener('error', reject);
    });
    const currentScript = (0, $e62dec891f31852b$export$56d8a8a25bd48b81).document.currentScript;
    const parent = (0, $e62dec891f31852b$export$56d8a8a25bd48b81).document.body || (0, $e62dec891f31852b$export$56d8a8a25bd48b81).document.head || currentScript?.parentElement;
    if (parent) parent.appendChild(script);
    else throw new Error(`Could not find parent element to insert lazy-loaded ${name} script`);
    try {
        await waitForLoad;
    } catch  {
        throw new Error(`Error when loading integration: ${name}`);
    }
    const integrationFn = sentryOnWindow[name];
    if (typeof integrationFn !== 'function') throw new Error(`Could not load integration: ${name}`);
    return integrationFn;
}
function $3fc94f2ac1572f6d$var$getScriptURL(bundle) {
    const client = (0, $7d48e1ed9f699a01$export$6bb76d6eba7e258c)();
    const baseURL = client?.getOptions()?.cdnBaseUrl || 'https://browser.sentry-cdn.com';
    return new URL(`/${(0, $dcd58747d787136d$export$31499a9cd224b78c)}/${bundle}.min.js`, baseURL).toString();
}


/**
 * An integration to add user feedback to your application,
 * while loading most of the code lazily only when it's needed.
 */ const $367c450e8ba35148$export$21eeae83e17be6ea = (0, $106dcbf01d17d3b7$export$13a9e5a543258f97)({
    lazyLoadIntegration: $3fc94f2ac1572f6d$export$6da56f3ddf2bd0c1
});



/** Add a widget to capture user feedback to your application. */ const $3b83570998c5a022$export$4bf8b7bb0f0086df = (0, $106dcbf01d17d3b7$export$13a9e5a543258f97)({
    getModalIntegration: ()=>(0, $106dcbf01d17d3b7$export$2ed486683e133d58),
    getScreenshotIntegration: ()=>(0, $106dcbf01d17d3b7$export$fd00458861e48ab4)
});





/**
 * Default maximum number of breadcrumbs added to an event. Can be overwritten
 * with {@link Options.maxBreadcrumbs}.
 */ const $777cacbd1bed0b63$var$DEFAULT_BREADCRUMBS = 100;
/**
 * Records a new breadcrumb which will be attached to future events.
 *
 * Breadcrumbs will be added to subsequent events to provide more context on
 * user's actions prior to an error or crash.
 */ function $777cacbd1bed0b63$export$efda9a273d7a036d(breadcrumb, hint) {
    const client = (0, $7d48e1ed9f699a01$export$6bb76d6eba7e258c)();
    const isolationScope = (0, $7d48e1ed9f699a01$export$68f3af03034c9e90)();
    if (!client) return;
    const { beforeBreadcrumb: beforeBreadcrumb = null, maxBreadcrumbs: maxBreadcrumbs = $777cacbd1bed0b63$var$DEFAULT_BREADCRUMBS } = client.getOptions();
    if (maxBreadcrumbs <= 0) return;
    const timestamp = (0, $bc81602376c48fa6$export$7740643b9eeaf0c4)();
    const mergedBreadcrumb = {
        timestamp: timestamp,
        ...breadcrumb
    };
    const finalBreadcrumb = beforeBreadcrumb ? (0, $d11ed0b3cdda6b8d$export$cda52e2a8927a2ca)(()=>beforeBreadcrumb(mergedBreadcrumb, hint)) : mergedBreadcrumb;
    if (finalBreadcrumb === null) return;
    if (client.emit) client.emit('beforeAddBreadcrumb', finalBreadcrumb, hint);
    isolationScope.addBreadcrumb(finalBreadcrumb, maxBreadcrumbs);
}









// We keep the handlers globally
const $7b0ad3366f177c67$var$handlers = {};
const $7b0ad3366f177c67$var$instrumented = {};
/** Add a handler function. */ function $7b0ad3366f177c67$export$a4e09611e30da72e(type, handler) {
    $7b0ad3366f177c67$var$handlers[type] = $7b0ad3366f177c67$var$handlers[type] || [];
    $7b0ad3366f177c67$var$handlers[type].push(handler);
}
/**
 * Reset all instrumentation handlers.
 * This can be used by tests to ensure we have a clean slate of instrumentation handlers.
 */ function $7b0ad3366f177c67$export$b17eab759a1cb5fe() {
    Object.keys($7b0ad3366f177c67$var$handlers).forEach((key)=>{
        $7b0ad3366f177c67$var$handlers[key] = undefined;
    });
}
/** Maybe run an instrumentation function, unless it was already called. */ function $7b0ad3366f177c67$export$e18d6c5462c01368(type, instrumentFn) {
    if (!$7b0ad3366f177c67$var$instrumented[type]) {
        $7b0ad3366f177c67$var$instrumented[type] = true;
        try {
            instrumentFn();
        } catch (e) {
            (0, $19fdbaf7f0830971$export$16a28057038b10ef) && (0, $d11ed0b3cdda6b8d$export$1c9f709888824e05).error(`Error while instrumenting ${type}`, e);
        }
    }
}
/** Trigger handlers for a given instrumentation type. */ function $7b0ad3366f177c67$export$b18c893e424d3127(type, data) {
    const typeHandlers = type && $7b0ad3366f177c67$var$handlers[type];
    if (!typeHandlers) return;
    for (const handler of typeHandlers)try {
        handler(data);
    } catch (e) {
        (0, $19fdbaf7f0830971$export$16a28057038b10ef) && (0, $d11ed0b3cdda6b8d$export$1c9f709888824e05).error(`Error while triggering instrumentation handler.\nType: ${type}\nName: ${(0, $9ed2cf4edd0b2db9$export$aad197c7121a6651)(handler)}\nError:`, e);
    }
}


/**
 * Add an instrumentation handler for when a console.xxx method is called.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $46dfef45d2fe6e84$export$1d6e0d073f9e6723(handler) {
    const type = 'console';
    (0, $7b0ad3366f177c67$export$a4e09611e30da72e)(type, handler);
    (0, $7b0ad3366f177c67$export$e18d6c5462c01368)(type, $46dfef45d2fe6e84$var$instrumentConsole);
}
function $46dfef45d2fe6e84$var$instrumentConsole() {
    if (!('console' in (0, $736a69486c86d36c$export$f1a6cdb1459e81d1))) return;
    (0, $d11ed0b3cdda6b8d$export$2a2b1d2252a69ecb).forEach(function(level) {
        if (!(level in (0, $736a69486c86d36c$export$f1a6cdb1459e81d1).console)) return;
        (0, $269eeb69635ed414$export$9563e054e6f787fb)((0, $736a69486c86d36c$export$f1a6cdb1459e81d1).console, level, function(originalConsoleMethod) {
            (0, $d11ed0b3cdda6b8d$export$77c4ce905194557b)[level] = originalConsoleMethod;
            return function(...args) {
                const handlerData = {
                    args: args,
                    level: level
                };
                (0, $7b0ad3366f177c67$export$b18c893e424d3127)('console', handlerData);
                const log = (0, $d11ed0b3cdda6b8d$export$77c4ce905194557b)[level];
                log?.apply((0, $736a69486c86d36c$export$f1a6cdb1459e81d1).console, args);
            };
        });
    });
}





/**
 * Converts a string-based level into a `SeverityLevel`, normalizing it along the way.
 *
 * @param level String representation of desired `SeverityLevel`.
 * @returns The `SeverityLevel` corresponding to the given string, or 'log' if the string isn't a valid level.
 */ function $9e4658f0600c3fda$export$d771ef054122c30a(level) {
    return level === 'warn' ? 'warning' : [
        'fatal',
        'error',
        'warning',
        'log',
        'info',
        'debug'
    ].includes(level) ? level : 'log';
}




const $83472dc082cc4dfa$var$INTEGRATION_NAME = 'CaptureConsole';
const $83472dc082cc4dfa$var$_captureConsoleIntegration = (options = {})=>{
    const levels = options.levels || (0, $d11ed0b3cdda6b8d$export$2a2b1d2252a69ecb);
    const handled = options.handled ?? true;
    return {
        name: $83472dc082cc4dfa$var$INTEGRATION_NAME,
        setup (client) {
            if (!('console' in (0, $736a69486c86d36c$export$f1a6cdb1459e81d1))) return;
            (0, $46dfef45d2fe6e84$export$1d6e0d073f9e6723)(({ args: args, level: level })=>{
                if ((0, $7d48e1ed9f699a01$export$6bb76d6eba7e258c)() !== client || !levels.includes(level)) return;
                $83472dc082cc4dfa$var$consoleHandler(args, level, handled);
            });
        }
    };
};
/**
 * Send Console API calls as Sentry Events.
 */ const $83472dc082cc4dfa$export$caa9b6c4a4144db4 = (0, $cbb2da6c78246e45$export$2323046b9414659f)($83472dc082cc4dfa$var$_captureConsoleIntegration);
function $83472dc082cc4dfa$var$consoleHandler(args, level, handled) {
    const severityLevel = (0, $9e4658f0600c3fda$export$d771ef054122c30a)(level);
    /*
    We create this error here already to attach a stack trace to captured messages,
    if users set `attachStackTrace` to `true` in Sentry.init.
    We do this here already because we want to minimize the number of Sentry SDK stack frames
    within the error. Technically, Client.captureMessage will also do it but this happens several
    stack frames deeper.
  */ const syntheticException = new Error();
    const captureContext = {
        level: (0, $9e4658f0600c3fda$export$d771ef054122c30a)(level),
        extra: {
            arguments: args
        }
    };
    (0, $7d48e1ed9f699a01$export$ec58d9285c204497)((scope)=>{
        scope.addEventProcessor((event)=>{
            event.logger = 'console';
            (0, $cc262db35458e4b3$export$c69a9a0313b03bb1)(event, {
                handled: handled,
                type: 'auto.core.capture_console'
            });
            return event;
        });
        if (level === 'assert') {
            if (!args[0]) {
                const message = `Assertion failed: ${(0, $e534db390d1e4996$export$465e9d514283d4fd)(args.slice(1), ' ') || 'console.assert'}`;
                scope.setExtra('arguments', args.slice(1));
                scope.captureMessage(message, severityLevel, {
                    captureContext: captureContext,
                    syntheticException: syntheticException
                });
            }
            return;
        }
        const error = args.find((arg)=>arg instanceof Error);
        if (error) {
            (0, $6918c722b531ff18$export$f5282963edea4a68)(error, captureContext);
            return;
        }
        const message = (0, $e534db390d1e4996$export$465e9d514283d4fd)(args, ' ');
        scope.captureMessage(message, severityLevel, {
            captureContext: captureContext,
            syntheticException: syntheticException
        });
    });
}







/**
 * Type-guard: The attribute object has the shape the official attribute object (value, type, unit).
 * https://develop.sentry.dev/sdk/telemetry/scopes/#setting-attributes
 */ function $930f69313cc0b0d6$export$f5706f332d297c38(maybeObj) {
    return typeof maybeObj === 'object' && maybeObj != null && !Array.isArray(maybeObj) && Object.keys(maybeObj).includes('value');
}
/**
 * Converts an attribute value to a typed attribute value.
 *
 * For now, we intentionally only support primitive values and attribute objects with primitive values.
 * If @param useFallback is true, we stringify non-primitive values to a string attribute value. Otherwise
 * we return `undefined` for unsupported values.
 *
 * @param value - The value of the passed attribute.
 * @param useFallback - If true, unsupported values will be stringified to a string attribute value.
 *                      Defaults to false. In this case, `undefined` is returned for unsupported values.
 * @returns The typed attribute.
 */ function $930f69313cc0b0d6$export$f18f8779fed6dfa(rawValue, useFallback) {
    const { value: value, unit: unit } = $930f69313cc0b0d6$export$f5706f332d297c38(rawValue) ? rawValue : {
        value: rawValue,
        unit: undefined
    };
    const attributeValue = $930f69313cc0b0d6$var$getTypedAttributeValue(value);
    const checkedUnit = unit && typeof unit === 'string' ? {
        unit: unit
    } : {};
    if (attributeValue) return {
        ...attributeValue,
        ...checkedUnit
    };
    if (!useFallback || useFallback === 'skip-undefined' && value === undefined) return;
    // Fallback: stringify the value
    // TODO(v11): be smarter here and use String constructor if stringify fails
    // (this is a breaking change for already existing attribute values)
    let stringValue = '';
    try {
        stringValue = JSON.stringify(value) ?? '';
    } catch  {
    // Do nothing
    }
    return {
        value: stringValue,
        type: 'string',
        ...checkedUnit
    };
}
/**
 * Serializes raw attributes to typed attributes as expected in our envelopes.
 *
 * @param attributes The raw attributes to serialize.
 * @param fallback   If true, unsupported values will be stringified to a string attribute value.
 *                   Defaults to false. In this case, `undefined` is returned for unsupported values.
 *
 * @returns The serialized attributes.
 */ function $930f69313cc0b0d6$export$4954cae66e755861(attributes, fallback = false) {
    const serializedAttributes = {};
    for (const [key, value] of Object.entries(attributes ?? {})){
        const typedValue = $930f69313cc0b0d6$export$f18f8779fed6dfa(value, fallback);
        if (typedValue) serializedAttributes[key] = typedValue;
    }
    return serializedAttributes;
}
/**
 * NOTE: We intentionally do not return anything for non-primitive values:
 *  - array support will come in the future but if we stringify arrays now,
 *    sending arrays (unstringified) later will be a subtle breaking change.
 *  - Objects are not supported yet and product support is still TBD.
 *  - We still keep the type signature for TypedAttributeValue wider to avoid a
 *    breaking change once we add support for non-primitive values.
 *  - Once we go back to supporting arrays and stringifying all other values,
 *    we already implemented the serialization logic here:
 *    https://github.com/getsentry/sentry-javascript/pull/18165
 */ function $930f69313cc0b0d6$var$getTypedAttributeValue(value) {
    const primitiveType = typeof value === 'string' ? 'string' : typeof value === 'boolean' ? 'boolean' : typeof value === 'number' && !Number.isNaN(value) ? Number.isInteger(value) ? 'integer' : 'double' : null;
    if (primitiveType) // @ts-expect-error - TS complains because {@link TypedAttributeValue} is strictly typed to
    // avoid setting the wrong `type` on the attribute value.
    // In this case, getPrimitiveType already does the check but TS doesn't know that.
    // The "clean" alternative is to return an object per `typeof value` case
    // but that would require more bundle size
    // Therefore, we ignore it.
    return {
        value: value,
        type: primitiveType
    };
}










const $443993e122065548$var$SEQUENCE_ATTR_KEY = 'sentry.timestamp.sequence';
let $443993e122065548$var$_sequenceNumber = 0;
let $443993e122065548$var$_previousTimestampMs;
/**
 * Returns the `sentry.timestamp.sequence` attribute entry for a serialized telemetry item.
 *
 * The sequence number starts at 0 and increments by 1 for each item captured.
 * It resets to 0 when the current item's integer millisecond timestamp differs
 * from the previous item's integer millisecond timestamp.
 *
 * @param timestampInSeconds - The timestamp of the telemetry item in seconds.
 */ function $443993e122065548$export$63ada7b125d23ef9(timestampInSeconds) {
    const nowMs = Math.floor(timestampInSeconds * 1000);
    if ($443993e122065548$var$_previousTimestampMs !== undefined && nowMs !== $443993e122065548$var$_previousTimestampMs) $443993e122065548$var$_sequenceNumber = 0;
    const value = $443993e122065548$var$_sequenceNumber;
    $443993e122065548$var$_sequenceNumber++;
    $443993e122065548$var$_previousTimestampMs = nowMs;
    return {
        key: $443993e122065548$var$SEQUENCE_ATTR_KEY,
        value: {
            value: value,
            type: 'integer'
        }
    };
}





/** Extract trace information from scope */ function $79fd34a78625a040$export$fb7d833b3fdedf5f(client, scope) {
    if (!scope) return [
        undefined,
        undefined
    ];
    return (0, $7d48e1ed9f699a01$export$ec58d9285c204497)(scope, ()=>{
        const span = (0, $bb9b6447bf4caedb$export$1be426a8e585c83e)();
        const traceContext = span ? (0, $bb9b6447bf4caedb$export$46c6fbd1d265ebf0)(span) : (0, $7d48e1ed9f699a01$export$1e83db7ee4876dc4)(scope);
        const dynamicSamplingContext = span ? (0, $09fae5ef8120e803$export$a117f995597e25df)(span) : (0, $09fae5ef8120e803$export$89ef1736f08c6b2b)(client, scope);
        return [
            dynamicSamplingContext,
            traceContext
        ];
    });
}


/**
 * Maps a log severity level to a log severity number.
 *
 * @see LogSeverityLevel
 */ const $e50fab46197143c9$export$4fb50c0840d636d1 = {
    trace: 1,
    debug: 5,
    info: 9,
    warn: 13,
    error: 17,
    fatal: 21
};




/**
 * Creates a log container envelope item for a list of logs.
 *
 * @param items - The logs to include in the envelope.
 * @returns The created log container envelope item.
 */ function $991af6bdb1848bee$export$efdf3b13edb1118e(items) {
    return [
        {
            type: 'log',
            item_count: items.length,
            content_type: 'application/vnd.sentry.items.log+json'
        },
        {
            items: items
        }
    ];
}
/**
 * Creates an envelope for a list of logs.
 *
 * Logs from multiple traces can be included in the same envelope.
 *
 * @param logs - The logs to include in the envelope.
 * @param metadata - The metadata to include in the envelope.
 * @param tunnel - The tunnel to include in the envelope.
 * @param dsn - The DSN to include in the envelope.
 * @returns The created envelope.
 */ function $991af6bdb1848bee$export$cdcd668e6516443f(logs, metadata, tunnel, dsn) {
    const headers = {};
    if (metadata?.sdk) headers.sdk = {
        name: metadata.sdk.name,
        version: metadata.sdk.version
    };
    if (!!tunnel && !!dsn) headers.dsn = (0, $1e1399eeae328b26$export$44d472fbb931a776)(dsn);
    return (0, $bb063ad93c8b79c7$export$f93f7f385160c44e)(headers, [
        $991af6bdb1848bee$export$efdf3b13edb1118e(logs)
    ]);
}


const $aedf2f5a49662da4$var$MAX_LOG_BUFFER_SIZE = 100;
/**
 * Sets a log attribute if the value exists and the attribute key is not already present.
 *
 * @param logAttributes - The log attributes object to modify.
 * @param key - The attribute key to set.
 * @param value - The value to set (only sets if truthy and key not present).
 * @param setEvenIfPresent - Whether to set the attribute if it is present. Defaults to true.
 */ function $aedf2f5a49662da4$var$setLogAttribute(logAttributes, key, value, setEvenIfPresent = true) {
    if (value && (!logAttributes[key] || setEvenIfPresent)) logAttributes[key] = value;
}
/**
 * Captures a serialized log event and adds it to the log buffer for the given client.
 *
 * @param client - A client. Uses the current client if not provided.
 * @param serializedLog - The serialized log event to capture.
 *
 * @experimental This method will experience breaking changes. This is not yet part of
 * the stable Sentry SDK API and can be changed or removed without warning.
 */ function $aedf2f5a49662da4$export$743ba6f7ec19225f(client, serializedLog) {
    const bufferMap = $aedf2f5a49662da4$var$_getBufferMap();
    const logBuffer = $aedf2f5a49662da4$export$5365c9902fb9e770(client);
    if (logBuffer === undefined) bufferMap.set(client, [
        serializedLog
    ]);
    else if (logBuffer.length >= $aedf2f5a49662da4$var$MAX_LOG_BUFFER_SIZE) {
        $aedf2f5a49662da4$export$f8ed83d3b6a0b504(client, logBuffer);
        bufferMap.set(client, [
            serializedLog
        ]);
    } else bufferMap.set(client, [
        ...logBuffer,
        serializedLog
    ]);
}
/**
 * Captures a log event and sends it to Sentry.
 *
 * @param log - The log event to capture.
 * @param scope - A scope. Uses the current scope if not provided.
 * @param client - A client. Uses the current client if not provided.
 * @param captureSerializedLog - A function to capture the serialized log.
 *
 * @experimental This method will experience breaking changes. This is not yet part of
 * the stable Sentry SDK API and can be changed or removed without warning.
 */ function $aedf2f5a49662da4$export$3ab3d16b9eebd986(beforeLog, currentScope = (0, $7d48e1ed9f699a01$export$c7be4b0125a10cba)(), captureSerializedLog = $aedf2f5a49662da4$export$743ba6f7ec19225f) {
    const client = currentScope?.getClient() ?? (0, $7d48e1ed9f699a01$export$6bb76d6eba7e258c)();
    if (!client) {
        (0, $19fdbaf7f0830971$export$16a28057038b10ef) && (0, $d11ed0b3cdda6b8d$export$1c9f709888824e05).warn('No client available to capture log.');
        return;
    }
    const { release: release, environment: environment, enableLogs: enableLogs = false, beforeSendLog: beforeSendLog } = client.getOptions();
    if (!enableLogs) {
        (0, $19fdbaf7f0830971$export$16a28057038b10ef) && (0, $d11ed0b3cdda6b8d$export$1c9f709888824e05).warn('logging option not enabled, log will not be captured.');
        return;
    }
    const [, traceContext] = (0, $79fd34a78625a040$export$fb7d833b3fdedf5f)(client, currentScope);
    const processedLogAttributes = {
        ...beforeLog.attributes
    };
    const { user: { id: id, email: email, username: username }, attributes: scopeAttributes = {} } = (0, $9a2c488a2b943a4e$export$cc422922fcbb91c6)((0, $7d48e1ed9f699a01$export$68f3af03034c9e90)(), currentScope);
    $aedf2f5a49662da4$var$setLogAttribute(processedLogAttributes, 'user.id', id, false);
    $aedf2f5a49662da4$var$setLogAttribute(processedLogAttributes, 'user.email', email, false);
    $aedf2f5a49662da4$var$setLogAttribute(processedLogAttributes, 'user.name', username, false);
    $aedf2f5a49662da4$var$setLogAttribute(processedLogAttributes, 'sentry.release', release);
    $aedf2f5a49662da4$var$setLogAttribute(processedLogAttributes, 'sentry.environment', environment);
    const { name: name, version: version } = client.getSdkMetadata()?.sdk ?? {};
    $aedf2f5a49662da4$var$setLogAttribute(processedLogAttributes, 'sentry.sdk.name', name);
    $aedf2f5a49662da4$var$setLogAttribute(processedLogAttributes, 'sentry.sdk.version', version);
    const replay = client.getIntegrationByName('Replay');
    const replayId = replay?.getReplayId(true);
    $aedf2f5a49662da4$var$setLogAttribute(processedLogAttributes, 'sentry.replay_id', replayId);
    if (replayId && replay?.getRecordingMode() === 'buffer') // We send this so we can identify cases where the replayId is attached but the replay itself might not have been sent to Sentry
    $aedf2f5a49662da4$var$setLogAttribute(processedLogAttributes, 'sentry._internal.replay_is_buffering', true);
    const beforeLogMessage = beforeLog.message;
    if ((0, $13cf2ed412f405fa$export$dbcbffa59149b824)(beforeLogMessage)) {
        const { __sentry_template_string__: __sentry_template_string__, __sentry_template_values__: __sentry_template_values__ = [] } = beforeLogMessage;
        if (__sentry_template_values__?.length) processedLogAttributes['sentry.message.template'] = __sentry_template_string__;
        __sentry_template_values__.forEach((param, index)=>{
            processedLogAttributes[`sentry.message.parameter.${index}`] = param;
        });
    }
    const span = (0, $dab1970d0c142a42$export$91f063ebb8eff307)(currentScope);
    // Add the parent span ID to the log attributes for trace context
    $aedf2f5a49662da4$var$setLogAttribute(processedLogAttributes, 'sentry.trace.parent_span_id', span?.spanContext().spanId);
    const processedLog = {
        ...beforeLog,
        attributes: processedLogAttributes
    };
    client.emit('beforeCaptureLog', processedLog);
    // We need to wrap this in `consoleSandbox` to avoid recursive calls to `beforeSendLog`
    const log = beforeSendLog ? (0, $d11ed0b3cdda6b8d$export$cda52e2a8927a2ca)(()=>beforeSendLog(processedLog)) : processedLog;
    if (!log) {
        client.recordDroppedEvent('before_send', 'log_item', 1);
        (0, $19fdbaf7f0830971$export$16a28057038b10ef) && (0, $d11ed0b3cdda6b8d$export$1c9f709888824e05).warn('beforeSendLog returned null, log will not be captured.');
        return;
    }
    const { level: level, message: message, attributes: logAttributes = {}, severityNumber: severityNumber } = log;
    const timestamp = (0, $bc81602376c48fa6$export$ee52dced521e3e18)();
    const sequenceAttr = (0, $443993e122065548$export$63ada7b125d23ef9)(timestamp);
    const serializedLog = {
        timestamp: timestamp,
        level: level,
        body: message,
        trace_id: traceContext?.trace_id,
        severity_number: severityNumber ?? (0, $e50fab46197143c9$export$4fb50c0840d636d1)[level],
        attributes: {
            ...(0, $930f69313cc0b0d6$export$4954cae66e755861)(scopeAttributes),
            ...(0, $930f69313cc0b0d6$export$4954cae66e755861)(logAttributes, true),
            [sequenceAttr.key]: sequenceAttr.value
        }
    };
    captureSerializedLog(client, serializedLog);
    client.emit('afterCaptureLog', log);
}
/**
 * Flushes the logs buffer to Sentry.
 *
 * @param client - A client.
 * @param maybeLogBuffer - A log buffer. Uses the log buffer for the given client if not provided.
 *
 * @experimental This method will experience breaking changes. This is not yet part of
 * the stable Sentry SDK API and can be changed or removed without warning.
 */ function $aedf2f5a49662da4$export$f8ed83d3b6a0b504(client, maybeLogBuffer) {
    const logBuffer = maybeLogBuffer ?? $aedf2f5a49662da4$export$5365c9902fb9e770(client) ?? [];
    if (logBuffer.length === 0) return;
    const clientOptions = client.getOptions();
    const envelope = (0, $991af6bdb1848bee$export$cdcd668e6516443f)(logBuffer, clientOptions._metadata, clientOptions.tunnel, client.getDsn());
    // Clear the log buffer after envelopes have been constructed.
    $aedf2f5a49662da4$var$_getBufferMap().set(client, []);
    client.emit('flushLogs');
    // sendEnvelope should not throw
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    client.sendEnvelope(envelope);
}
/**
 * Returns the log buffer for a given client.
 *
 * Exported for testing purposes.
 *
 * @param client - The client to get the log buffer for.
 * @returns The log buffer for the given client.
 */ function $aedf2f5a49662da4$export$5365c9902fb9e770(client) {
    return $aedf2f5a49662da4$var$_getBufferMap().get(client);
}
function $aedf2f5a49662da4$var$_getBufferMap() {
    // The reference to the Client <> LogBuffer map is stored on the carrier to ensure it's always the same
    return (0, $e4c75fb63b040566$export$7e223ec222791509)('clientToLogBufferMap', ()=>new WeakMap());
}





/**
 * Formats the given values into a string.
 *
 * @param values - The values to format.
 * @param normalizeDepth - The depth to normalize the values.
 * @param normalizeMaxBreadth - The max breadth to normalize the values.
 * @returns The formatted string.
 */ function $586b05957314ce98$export$685fa2ac963d3401(values, normalizeDepth, normalizeMaxBreadth) {
    return 'util' in (0, $736a69486c86d36c$export$f1a6cdb1459e81d1) && typeof (0, $736a69486c86d36c$export$f1a6cdb1459e81d1).util.format === 'function' ? (0, $736a69486c86d36c$export$f1a6cdb1459e81d1).util.format(...values) : $586b05957314ce98$export$c0f6d13f2f9c0ad9(values, normalizeDepth, normalizeMaxBreadth);
}
/**
 * Joins the given values into a string.
 *
 * @param values - The values to join.
 * @param normalizeDepth - The depth to normalize the values.
 * @param normalizeMaxBreadth - The max breadth to normalize the values.
 * @returns The joined string.
 */ function $586b05957314ce98$export$c0f6d13f2f9c0ad9(values, normalizeDepth, normalizeMaxBreadth) {
    return values.map((value)=>(0, $13cf2ed412f405fa$export$c3825b437cbdea5c)(value) ? String(value) : JSON.stringify((0, $2d7134eeb4bc669b$export$a3295358bff77e)(value, normalizeDepth, normalizeMaxBreadth))).join(' ');
}
/**
 * Checks if a string contains console substitution patterns like %s, %d, %i, %f, %o, %O, %c.
 *
 * @param str - The string to check
 * @returns true if the string contains console substitution patterns
 */ function $586b05957314ce98$export$fd7d986bffc85771(str) {
    // Match console substitution patterns: %s, %d, %i, %f, %o, %O, %c
    return /%[sdifocO]/.test(str);
}
/**
 * Creates template attributes for multiple console arguments.
 *
 * @param args - The console arguments
 * @returns An object with template and parameter attributes
 */ function $586b05957314ce98$export$a85dac26b5c120d1(firstArg, followingArgs) {
    const attributes = {};
    // Create template with placeholders for each argument
    const template = new Array(followingArgs.length).fill('{}').join(' ');
    attributes['sentry.message.template'] = `${firstArg} ${template}`;
    // Add each argument as a parameter
    followingArgs.forEach((arg, index)=>{
        attributes[`sentry.message.parameter.${index}`] = arg;
    });
    return attributes;
}


const $12a826797062327b$var$INTEGRATION_NAME = 'ConsoleLogs';
const $12a826797062327b$var$DEFAULT_ATTRIBUTES = {
    [(0, $f337c80285f06f80$export$cca8dd30f57f805e)]: 'auto.log.console'
};
const $12a826797062327b$var$_consoleLoggingIntegration = (options = {})=>{
    const levels = options.levels || (0, $d11ed0b3cdda6b8d$export$2a2b1d2252a69ecb);
    return {
        name: $12a826797062327b$var$INTEGRATION_NAME,
        setup (client) {
            const { enableLogs: enableLogs, normalizeDepth: normalizeDepth = 3, normalizeMaxBreadth: normalizeMaxBreadth = 1000 } = client.getOptions();
            if (!enableLogs) {
                (0, $19fdbaf7f0830971$export$16a28057038b10ef) && (0, $d11ed0b3cdda6b8d$export$1c9f709888824e05).warn('`enableLogs` is not enabled, ConsoleLogs integration disabled');
                return;
            }
            (0, $46dfef45d2fe6e84$export$1d6e0d073f9e6723)(({ args: args, level: level })=>{
                if ((0, $7d48e1ed9f699a01$export$6bb76d6eba7e258c)() !== client || !levels.includes(level)) return;
                const firstArg = args[0];
                const followingArgs = args.slice(1);
                if (level === 'assert') {
                    if (!firstArg) {
                        const assertionMessage = followingArgs.length > 0 ? `Assertion failed: ${(0, $586b05957314ce98$export$685fa2ac963d3401)(followingArgs, normalizeDepth, normalizeMaxBreadth)}` : 'Assertion failed';
                        (0, $aedf2f5a49662da4$export$3ab3d16b9eebd986)({
                            level: 'error',
                            message: assertionMessage,
                            attributes: $12a826797062327b$var$DEFAULT_ATTRIBUTES
                        });
                    }
                    return;
                }
                const isLevelLog = level === 'log';
                const shouldGenerateTemplate = args.length > 1 && typeof args[0] === 'string' && !(0, $586b05957314ce98$export$fd7d986bffc85771)(args[0]);
                const attributes = {
                    ...$12a826797062327b$var$DEFAULT_ATTRIBUTES,
                    ...shouldGenerateTemplate ? (0, $586b05957314ce98$export$a85dac26b5c120d1)(firstArg, followingArgs) : {}
                };
                (0, $aedf2f5a49662da4$export$3ab3d16b9eebd986)({
                    level: isLevelLog ? 'info' : level,
                    message: (0, $586b05957314ce98$export$685fa2ac963d3401)(args, normalizeDepth, normalizeMaxBreadth),
                    severityNumber: isLevelLog ? 10 : undefined,
                    attributes: attributes
                });
            });
        }
    };
};
/**
 * Captures calls to the `console` API as logs in Sentry. Requires the `enableLogs` option to be enabled.
 *
 * @experimental This feature is experimental and may be changed or removed in future versions.
 *
 * By default the integration instruments `console.debug`, `console.info`, `console.warn`, `console.error`,
 * `console.log`, `console.trace`, and `console.assert`. You can use the `levels` option to customize which
 * levels are captured.
 *
 * @example
 *
 * ```ts
 * import * as Sentry from '@sentry/browser';
 *
 * Sentry.init({
 *   enableLogs: true,
 *   integrations: [Sentry.consoleLoggingIntegration({ levels: ['error', 'warn'] })],
 * });
 * ```
 */ const $12a826797062327b$export$63e034b6c5b5b12a = (0, $cbb2da6c78246e45$export$2323046b9414659f)($12a826797062327b$var$_consoleLoggingIntegration);






/**
 * Result of extracting structured attributes from console arguments.
 */ const $13c01856bb23ea1b$var$DEFAULT_CAPTURED_LEVELS = [
    'trace',
    'debug',
    'info',
    'warn',
    'error',
    'fatal'
];
/**
 * Creates a new Sentry reporter for Consola that forwards logs to Sentry. Requires the `enableLogs` option to be enabled.
 *
 * **Note: This integration supports Consola v3.x only.** The reporter interface and log object structure
 * may differ in other versions of Consola.
 *
 * @param options - Configuration options for the reporter.
 * @returns A Consola reporter that can be added to consola instances.
 *
 * @example
 * ```ts
 * import * as Sentry from '@sentry/node';
 * import { consola } from 'consola';
 *
 * Sentry.init({
 *   enableLogs: true,
 * });
 *
 * const sentryReporter = Sentry.createConsolaReporter({
 *   // Optional: filter levels to capture
 *   levels: ['error', 'warn', 'info'],
 * });
 *
 * consola.addReporter(sentryReporter);
 *
 * // Now consola logs will be captured by Sentry
 * consola.info('This will be sent to Sentry');
 * consola.error('This error will also be sent to Sentry');
 * ```
 */ function $13c01856bb23ea1b$export$3c37de547377f70b(options = {}) {
    const levels = new Set(options.levels ?? $13c01856bb23ea1b$var$DEFAULT_CAPTURED_LEVELS);
    const providedClient = options.client;
    return {
        log (logObj) {
            // We need to exclude certain known properties from being added as additional attributes
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            const { type: type, level: level, message: consolaMessage, args: args, tag: tag, date: _date, ...rest } = logObj;
            // Get client - use provided client or current client
            const client = providedClient || (0, $7d48e1ed9f699a01$export$6bb76d6eba7e258c)();
            if (!client) return;
            // Determine the log severity level
            const logSeverityLevel = $13c01856bb23ea1b$var$getLogSeverityLevel(type, level);
            // Early exit if this level should not be captured
            if (!levels.has(logSeverityLevel)) return;
            const { normalizeDepth: normalizeDepth = 3, normalizeMaxBreadth: normalizeMaxBreadth = 1000 } = client.getOptions();
            const attributes = {};
            // Build attributes
            for (const [key, value] of Object.entries(rest))attributes[key] = (0, $2d7134eeb4bc669b$export$a3295358bff77e)(value, normalizeDepth, normalizeMaxBreadth);
            attributes['sentry.origin'] = 'auto.log.consola';
            if (tag) attributes['consola.tag'] = tag;
            if (type) attributes['consola.type'] = type;
            // Only add level if it's a valid number (not null/undefined)
            if (level != null && typeof level === 'number') attributes['consola.level'] = level;
            const extractionResult = $13c01856bb23ea1b$var$processExtractedAttributes($13c01856bb23ea1b$var$defaultExtractAttributes(args, normalizeDepth, normalizeMaxBreadth), normalizeDepth, normalizeMaxBreadth);
            if (extractionResult?.attributes) Object.assign(attributes, extractionResult.attributes);
            (0, $aedf2f5a49662da4$export$3ab3d16b9eebd986)({
                level: logSeverityLevel,
                message: extractionResult?.message || consolaMessage || args && (0, $586b05957314ce98$export$685fa2ac963d3401)(args, normalizeDepth, normalizeMaxBreadth) || '',
                attributes: attributes
            });
        }
    };
}
// Mapping from consola log types to Sentry log severity levels
const $13c01856bb23ea1b$var$CONSOLA_TYPE_TO_LOG_SEVERITY_LEVEL_MAP = {
    // Consola built-in types
    silent: 'trace',
    fatal: 'fatal',
    error: 'error',
    warn: 'warn',
    log: 'info',
    info: 'info',
    success: 'info',
    fail: 'error',
    ready: 'info',
    start: 'info',
    box: 'info',
    debug: 'debug',
    trace: 'trace',
    verbose: 'debug',
    // Custom types that might exist
    critical: 'fatal',
    notice: 'info'
};
// Mapping from consola log levels (numbers) to Sentry log severity levels
const $13c01856bb23ea1b$var$CONSOLA_LEVEL_TO_LOG_SEVERITY_LEVEL_MAP = {
    0: 'fatal',
    1: 'warn',
    2: 'info',
    3: 'info',
    4: 'debug',
    5: 'trace'
};
/**
 * Determines the log severity level from Consola type and level.
 *
 * @param type - The Consola log type (e.g., 'error', 'warn', 'info')
 * @param level - The Consola numeric log level (0-5) or null for some types like 'verbose'
 * @returns The corresponding Sentry log severity level
 */ function $13c01856bb23ea1b$var$getLogSeverityLevel(type, level) {
    // Handle special case for verbose logs (level can be null with infinite level in Consola)
    if (type === 'verbose') return 'debug';
    // Handle silent logs - these should be at trace level
    if (type === 'silent') return 'trace';
    // First try to map by type (more specific)
    if (type) {
        const mappedLevel = $13c01856bb23ea1b$var$CONSOLA_TYPE_TO_LOG_SEVERITY_LEVEL_MAP[type];
        if (mappedLevel) return mappedLevel;
    }
    // Fallback to level mapping (handle null level)
    if (typeof level === 'number') {
        const mappedLevel = $13c01856bb23ea1b$var$CONSOLA_LEVEL_TO_LOG_SEVERITY_LEVEL_MAP[level];
        if (mappedLevel) return mappedLevel;
    }
    // Default fallback
    return 'info';
}
/**
 * Extracts structured attributes from console arguments. If the first argument is a plain object, its properties are extracted as attributes.
 */ function $13c01856bb23ea1b$var$defaultExtractAttributes(args, normalizeDepth, normalizeMaxBreadth) {
    if (!args?.length) return {
        message: ''
    };
    // Message looks like how consola logs the message to the console (all args stringified and joined)
    const message = (0, $586b05957314ce98$export$685fa2ac963d3401)(args, normalizeDepth, normalizeMaxBreadth);
    const firstArg = args[0];
    if ((0, $13cf2ed412f405fa$export$53b83ca8eaab0383)(firstArg)) {
        // Remaining args start from index 2 i f we used second arg as message, otherwise from index 1
        const remainingArgsStartIndex = typeof args[1] === 'string' ? 2 : 1;
        const remainingArgs = args.slice(remainingArgsStartIndex);
        return {
            message: message,
            // Object content from first arg is added as attributes
            attributes: firstArg,
            // Add remaining args as message parameters
            messageParameters: remainingArgs
        };
    } else {
        const followingArgs = args.slice(1);
        const shouldAddTemplateAttr = followingArgs.length > 0 && typeof firstArg === 'string' && !(0, $586b05957314ce98$export$fd7d986bffc85771)(firstArg);
        return {
            message: message,
            messageTemplate: shouldAddTemplateAttr ? firstArg : undefined,
            messageParameters: shouldAddTemplateAttr ? followingArgs : undefined
        };
    }
}
/**
 * Processes extracted attributes by normalizing them and preparing message parameter attributes if a template is present.
 */ function $13c01856bb23ea1b$var$processExtractedAttributes(extractionResult, normalizeDepth, normalizeMaxBreadth) {
    const { message: message, attributes: attributes, messageTemplate: messageTemplate, messageParameters: messageParameters } = extractionResult;
    const messageParamAttributes = {};
    if (messageTemplate && messageParameters) {
        const templateAttrs = (0, $586b05957314ce98$export$a85dac26b5c120d1)(messageTemplate, messageParameters);
        for (const [key, value] of Object.entries(templateAttrs))messageParamAttributes[key] = key.startsWith('sentry.message.parameter.') ? (0, $2d7134eeb4bc669b$export$a3295358bff77e)(value, normalizeDepth, normalizeMaxBreadth) : value;
    } else if (messageParameters && messageParameters.length > 0) messageParameters.forEach((arg, index)=>{
        messageParamAttributes[`sentry.message.parameter.${index}`] = (0, $2d7134eeb4bc669b$export$a3295358bff77e)(arg, normalizeDepth, normalizeMaxBreadth);
    });
    return {
        message: message,
        attributes: {
            ...(0, $2d7134eeb4bc669b$export$a3295358bff77e)(attributes, normalizeDepth, normalizeMaxBreadth),
            ...messageParamAttributes
        }
    };
}





/**
 * OpenAI Integration Telemetry Attributes
 * Based on OpenTelemetry Semantic Conventions for Generative AI
 * @see https://opentelemetry.io/docs/specs/semconv/gen-ai/
 */ // =============================================================================
// OPENTELEMETRY SEMANTIC CONVENTIONS FOR GENAI
// =============================================================================
/**
 * The input messages sent to the model
 */ const $69c5419d32efeaea$export$7c08d2884b5eed2e = 'gen_ai.prompt';
/**
 * The Generative AI system being used
 * For OpenAI, this should always be "openai"
 */ const $69c5419d32efeaea$export$234b82df5670ccbb = 'gen_ai.system';
/**
 * The name of the model as requested
 * Examples: "gpt-4", "gpt-3.5-turbo"
 */ const $69c5419d32efeaea$export$e3834bc5d4a6f8a5 = 'gen_ai.request.model';
/**
 * Whether streaming was enabled for the request
 */ const $69c5419d32efeaea$export$f8a1e9006f7a3c18 = 'gen_ai.request.stream';
/**
 * The temperature setting for the model request
 */ const $69c5419d32efeaea$export$84ab1c0a4a1402ec = 'gen_ai.request.temperature';
/**
 * The maximum number of tokens requested
 */ const $69c5419d32efeaea$export$6affc15741e97c5c = 'gen_ai.request.max_tokens';
/**
 * The frequency penalty setting for the model request
 */ const $69c5419d32efeaea$export$58b9b1cd46b4bb5e = 'gen_ai.request.frequency_penalty';
/**
 * The presence penalty setting for the model request
 */ const $69c5419d32efeaea$export$66b1150b23e1da44 = 'gen_ai.request.presence_penalty';
/**
 * The top_p (nucleus sampling) setting for the model request
 */ const $69c5419d32efeaea$export$be752be64ca500f6 = 'gen_ai.request.top_p';
/**
 * The top_k setting for the model request
 */ const $69c5419d32efeaea$export$ff1aa255ac4733b = 'gen_ai.request.top_k';
/**
 * The encoding format for the model request
 */ const $69c5419d32efeaea$export$b0a0c7768ed27b96 = 'gen_ai.request.encoding_format';
/**
 * The dimensions for the model request
 */ const $69c5419d32efeaea$export$4c4b39f46c2c0dd0 = 'gen_ai.request.dimensions';
/**
 * Array of reasons why the model stopped generating tokens
 */ const $69c5419d32efeaea$export$8778ccf58aa04820 = 'gen_ai.response.finish_reasons';
/**
 * The name of the model that generated the response
 */ const $69c5419d32efeaea$export$91aa8d4aaebb3840 = 'gen_ai.response.model';
/**
 * The unique identifier for the response
 */ const $69c5419d32efeaea$export$1e55ab213eb8e5dc = 'gen_ai.response.id';
/**
 * The reason why the model stopped generating tokens
 */ const $69c5419d32efeaea$export$39c7eee451583755 = 'gen_ai.response.stop_reason';
/**
 * The number of tokens used in the prompt
 */ const $69c5419d32efeaea$export$ad91d91220026940 = 'gen_ai.usage.input_tokens';
/**
 * The number of tokens used in the response
 */ const $69c5419d32efeaea$export$84cd977981922116 = 'gen_ai.usage.output_tokens';
/**
 * The total number of tokens used (input + output)
 */ const $69c5419d32efeaea$export$60599e5371c06255 = 'gen_ai.usage.total_tokens';
/**
 * The operation name
 */ const $69c5419d32efeaea$export$d4b9e945d503aff = 'gen_ai.operation.name';
/**
 * Original length of messages array, used to indicate truncations had occured
 */ const $69c5419d32efeaea$export$ca7610de76ac1c3f = 'sentry.sdk_meta.gen_ai.input.messages.original_length';
/**
 * The prompt messages
 * Only recorded when recordInputs is enabled
 */ const $69c5419d32efeaea$export$b36434f4adcd5fb0 = 'gen_ai.input.messages';
/**
 * The model's response messages including text and tool calls
 * Only recorded when recordOutputs is enabled
 * Format: stringified array of message objects with role, parts, and finish_reason
 * @see https://opentelemetry.io/docs/specs/semconv/registry/attributes/gen-ai/#gen-ai-output-messages
 */ const $69c5419d32efeaea$export$8457a0184a6719e7 = 'gen_ai.output.messages';
/**
 * The system instructions extracted from system messages
 * Only recorded when recordInputs is enabled
 * According to OpenTelemetry spec: https://opentelemetry.io/docs/specs/semconv/registry/attributes/gen-ai/#gen-ai-system-instructions
 */ const $69c5419d32efeaea$export$461510d48ed1f51d = 'gen_ai.system_instructions';
/**
 * The response text
 * Only recorded when recordOutputs is enabled
 */ const $69c5419d32efeaea$export$2478fd72313ce319 = 'gen_ai.response.text';
/**
 * The available tools from incoming request
 * Only recorded when recordInputs is enabled
 */ const $69c5419d32efeaea$export$b84797a509e2c15 = 'gen_ai.request.available_tools';
/**
 * Whether the response is a streaming response
 */ const $69c5419d32efeaea$export$e7360a81bbfe9c78 = 'gen_ai.response.streaming';
/**
 * The tool calls from the response
 * Only recorded when recordOutputs is enabled
 */ const $69c5419d32efeaea$export$c6bace6b76d93a0 = 'gen_ai.response.tool_calls';
/**
 * The agent name
 */ const $69c5419d32efeaea$export$9866e099aafe0dac = 'gen_ai.agent.name';
/**
 * The pipeline name
 */ const $69c5419d32efeaea$export$bbe84fd1655fc573 = 'gen_ai.pipeline.name';
/**
 * The conversation ID for linking messages across API calls
 * For OpenAI Assistants API: thread_id
 * For LangGraph: configurable.thread_id
 */ const $69c5419d32efeaea$export$71a4a707257f2774 = 'gen_ai.conversation.id';
/**
 * The number of cache creation input tokens used
 */ const $69c5419d32efeaea$export$a8acd4baf0e184e3 = 'gen_ai.usage.cache_creation_input_tokens';
/**
 * The number of cache read input tokens used
 */ const $69c5419d32efeaea$export$b8f4e352e71d9b83 = 'gen_ai.usage.cache_read_input_tokens';
/**
 * The number of cache write input tokens used
 */ const $69c5419d32efeaea$export$8eabb6590230f96e = 'gen_ai.usage.input_tokens.cache_write';
/**
 * The number of cached input tokens that were used
 */ const $69c5419d32efeaea$export$3821eaee4840e096 = 'gen_ai.usage.input_tokens.cached';
/**
 * The span operation name for invoking an agent
 */ const $69c5419d32efeaea$export$1c9f3b468cd7d455 = 'gen_ai.invoke_agent';
/**
 * The span operation name for generating text
 */ const $69c5419d32efeaea$export$8f3c6f3f7f006230 = 'gen_ai.generate_text';
/**
 * The span operation name for streaming text
 */ const $69c5419d32efeaea$export$f370b1b94b583d74 = 'gen_ai.stream_text';
/**
 * The span operation name for generating object
 */ const $69c5419d32efeaea$export$5dbb463710c5ee1a = 'gen_ai.generate_object';
/**
 * The span operation name for streaming object
 */ const $69c5419d32efeaea$export$4093ae55a02c9478 = 'gen_ai.stream_object';
/**
 * The embeddings input
 * Only recorded when recordInputs is enabled
 */ const $69c5419d32efeaea$export$844e723b3a342d78 = 'gen_ai.embeddings.input';
/**
 * The span operation name for embedding
 */ const $69c5419d32efeaea$export$57514b9288772a9d = 'gen_ai.embeddings';
/**
 * The span operation name for embedding many
 */ const $69c5419d32efeaea$export$d600223ab78ef71f = 'gen_ai.embeddings';
/**
 * The span operation name for reranking
 */ const $69c5419d32efeaea$export$335271a1e7d0ed5e = 'gen_ai.rerank';
/**
 * The span operation name for executing a tool
 */ const $69c5419d32efeaea$export$b1f35ac4aa945e84 = 'gen_ai.execute_tool';
/**
 * The tool name for tool call spans
 */ const $69c5419d32efeaea$export$51cd34bcdf696c21 = 'gen_ai.tool.name';
/**
 * The tool call ID
 */ const $69c5419d32efeaea$export$45118df5de4c7d1b = 'gen_ai.tool.call.id';
/**
 * The tool type (e.g., 'function')
 */ const $69c5419d32efeaea$export$79731e4988fa82cc = 'gen_ai.tool.type';
/**
 * The tool input/arguments
 */ const $69c5419d32efeaea$export$eb2b5e3f072ecbad = 'gen_ai.tool.input';
/**
 * The tool output/result
 */ const $69c5419d32efeaea$export$e768cd7668ffb4c9 = 'gen_ai.tool.output';
/**
 * The description of the tool being used
 * @see https://opentelemetry.io/docs/specs/semconv/registry/attributes/gen-ai/#gen-ai-tool-description
 */ const $69c5419d32efeaea$export$cc9604eb6f43e13 = 'gen_ai.tool.description';
// =============================================================================
// OPENAI-SPECIFIC ATTRIBUTES
// =============================================================================
/**
 * The response ID from OpenAI
 */ const $69c5419d32efeaea$export$8adff427c4daccb6 = 'openai.response.id';
/**
 * The response model from OpenAI
 */ const $69c5419d32efeaea$export$1c7a697dcd8f0fc0 = 'openai.response.model';
/**
 * The response timestamp from OpenAI (ISO string)
 */ const $69c5419d32efeaea$export$44332d54ca9318b7 = 'openai.response.timestamp';
/**
 * The number of completion tokens used
 */ const $69c5419d32efeaea$export$29098909ce8eb523 = 'openai.usage.completion_tokens';
/**
 * The number of prompt tokens used
 */ const $69c5419d32efeaea$export$c81e5735e96e0997 = 'openai.usage.prompt_tokens';
// =============================================================================
// OPENAI OPERATIONS
// =============================================================================
/**
 * OpenAI API operations following OpenTelemetry semantic conventions
 * @see https://opentelemetry.io/docs/specs/semconv/gen-ai/gen-ai-spans/#llm-request-spans
 */ const $69c5419d32efeaea$export$4deb19a2b9875d96 = {
    CHAT: 'chat',
    EMBEDDINGS: 'embeddings'
};
// =============================================================================
// ANTHROPIC AI OPERATIONS
// =============================================================================
/**
 * The response timestamp from Anthropic AI (ISO string)
 */ const $69c5419d32efeaea$export$edffc94e6f22e963 = 'anthropic.response.timestamp';




/**
 * Inline media content source, with a potentially very large base64
 * blob or data: uri.
 */ /**
 * Check if a content part is an OpenAI/Anthropic media source
 */ function $48605d195f6f3132$export$37be2cb4b8ef44ca(part) {
    if (!part || typeof part !== 'object') return false;
    return $48605d195f6f3132$var$isContentMediaSource(part) || $48605d195f6f3132$var$hasInlineData(part) || $48605d195f6f3132$var$hasImageUrl(part) || $48605d195f6f3132$var$hasInputAudio(part) || $48605d195f6f3132$var$hasFileData(part) || $48605d195f6f3132$var$hasMediaTypeData(part) || $48605d195f6f3132$var$hasVercelFileData(part) || $48605d195f6f3132$var$hasVercelImageData(part) || $48605d195f6f3132$var$hasBlobOrBase64Type(part) || $48605d195f6f3132$var$hasB64Json(part) || $48605d195f6f3132$var$hasImageGenerationResult(part) || $48605d195f6f3132$var$hasDataUri(part);
}
function $48605d195f6f3132$var$hasImageUrl(part) {
    if (!('image_url' in part)) return false;
    if (typeof part.image_url === 'string') return part.image_url.startsWith('data:');
    return $48605d195f6f3132$var$hasNestedImageUrl(part);
}
function $48605d195f6f3132$var$hasNestedImageUrl(part) {
    return 'image_url' in part && !!part.image_url && typeof part.image_url === 'object' && 'url' in part.image_url && typeof part.image_url.url === 'string' && part.image_url.url.startsWith('data:');
}
function $48605d195f6f3132$var$isContentMediaSource(part) {
    return 'type' in part && typeof part.type === 'string' && 'source' in part && $48605d195f6f3132$export$37be2cb4b8ef44ca(part.source);
}
function $48605d195f6f3132$var$hasInlineData(part) {
    return 'inlineData' in part && !!part.inlineData && typeof part.inlineData === 'object' && 'data' in part.inlineData && typeof part.inlineData.data === 'string';
}
function $48605d195f6f3132$var$hasInputAudio(part) {
    return 'type' in part && part.type === 'input_audio' && 'input_audio' in part && !!part.input_audio && typeof part.input_audio === 'object' && 'data' in part.input_audio && typeof part.input_audio.data === 'string';
}
function $48605d195f6f3132$var$hasFileData(part) {
    return 'type' in part && part.type === 'file' && 'file' in part && !!part.file && typeof part.file === 'object' && 'file_data' in part.file && typeof part.file.file_data === 'string';
}
function $48605d195f6f3132$var$hasMediaTypeData(part) {
    return 'media_type' in part && typeof part.media_type === 'string' && 'data' in part;
}
/**
 * Check for Vercel AI SDK file format: { type: "file", mediaType: "...", data: "..." }
 * Only matches base64/binary data, not HTTP/HTTPS URLs (which should be preserved).
 */ function $48605d195f6f3132$var$hasVercelFileData(part) {
    return 'type' in part && part.type === 'file' && 'mediaType' in part && typeof part.mediaType === 'string' && 'data' in part && typeof part.data === 'string' && // Only strip base64/binary data, not HTTP/HTTPS URLs which should be preserved as references
    !part.data.startsWith('http://') && !part.data.startsWith('https://');
}
/**
 * Check for Vercel AI SDK image format: { type: "image", image: "base64...", mimeType?: "..." }
 * Only matches base64/data URIs, not HTTP/HTTPS URLs (which should be preserved).
 * Note: mimeType is optional in Vercel AI SDK image parts.
 */ function $48605d195f6f3132$var$hasVercelImageData(part) {
    return 'type' in part && part.type === 'image' && 'image' in part && typeof part.image === 'string' && // Only strip base64/data URIs, not HTTP/HTTPS URLs which should be preserved as references
    !part.image.startsWith('http://') && !part.image.startsWith('https://');
}
function $48605d195f6f3132$var$hasBlobOrBase64Type(part) {
    return 'type' in part && (part.type === 'blob' || part.type === 'base64');
}
function $48605d195f6f3132$var$hasB64Json(part) {
    return 'b64_json' in part;
}
function $48605d195f6f3132$var$hasImageGenerationResult(part) {
    return 'type' in part && 'result' in part && part.type === 'image_generation';
}
function $48605d195f6f3132$var$hasDataUri(part) {
    return 'uri' in part && typeof part.uri === 'string' && part.uri.startsWith('data:');
}
const $48605d195f6f3132$var$REMOVED_STRING = '[Blob substitute]';
const $48605d195f6f3132$var$MEDIA_FIELDS = [
    'image_url',
    'data',
    'content',
    'b64_json',
    'result',
    'uri',
    'image'
];
/**
 * Replace inline binary data in a single media content part with a placeholder.
 */ function $48605d195f6f3132$export$69745de611b47810(part) {
    const strip = {
        ...part
    };
    if ($48605d195f6f3132$export$37be2cb4b8ef44ca(strip.source)) strip.source = $48605d195f6f3132$export$69745de611b47810(strip.source);
    if ($48605d195f6f3132$var$hasInlineData(part)) strip.inlineData = {
        ...part.inlineData,
        data: $48605d195f6f3132$var$REMOVED_STRING
    };
    if ($48605d195f6f3132$var$hasNestedImageUrl(part)) strip.image_url = {
        ...part.image_url,
        url: $48605d195f6f3132$var$REMOVED_STRING
    };
    if ($48605d195f6f3132$var$hasInputAudio(part)) strip.input_audio = {
        ...part.input_audio,
        data: $48605d195f6f3132$var$REMOVED_STRING
    };
    if ($48605d195f6f3132$var$hasFileData(part)) strip.file = {
        ...part.file,
        file_data: $48605d195f6f3132$var$REMOVED_STRING
    };
    for (const field of $48605d195f6f3132$var$MEDIA_FIELDS)if (typeof strip[field] === 'string') strip[field] = $48605d195f6f3132$var$REMOVED_STRING;
    return strip;
}


/**
 * Default maximum size in bytes for GenAI messages.
 * Messages exceeding this limit will be truncated.
 */ const $b86a786ebedea812$export$e6b4dddd87c4d228 = 20000;
/**
 * Message format used by OpenAI and Anthropic APIs.
 */ /**
 * Calculate the UTF-8 byte length of a string.
 */ const $b86a786ebedea812$var$utf8Bytes = (text)=>{
    return new TextEncoder().encode(text).length;
};
/**
 * Calculate the UTF-8 byte length of a value's JSON representation.
 */ const $b86a786ebedea812$var$jsonBytes = (value)=>{
    return $b86a786ebedea812$var$utf8Bytes(JSON.stringify(value));
};
/**
 * Truncate a string to fit within maxBytes (inclusive) when encoded as UTF-8.
 * Uses binary search for efficiency with multi-byte characters.
 *
 * @param text - The string to truncate
 * @param maxBytes - Maximum byte length (inclusive, UTF-8 encoded)
 * @returns Truncated string whose UTF-8 byte length is at most maxBytes
 */ function $b86a786ebedea812$var$truncateTextByBytes(text, maxBytes) {
    if ($b86a786ebedea812$var$utf8Bytes(text) <= maxBytes) return text;
    let low = 0;
    let high = text.length;
    let bestFit = '';
    while(low <= high){
        const mid = Math.floor((low + high) / 2);
        const candidate = text.slice(0, mid);
        const byteSize = $b86a786ebedea812$var$utf8Bytes(candidate);
        if (byteSize <= maxBytes) {
            bestFit = candidate;
            low = mid + 1;
        } else high = mid - 1;
    }
    return bestFit;
}
/**
 * Extract text content from a Google GenAI message part.
 * Parts are either plain strings or objects with a text property.
 *
 * @returns The text content
 */ function $b86a786ebedea812$var$getPartText(part) {
    if (typeof part === 'string') return part;
    if ('text' in part) return part.text;
    return '';
}
/**
 * Create a new part with updated text content while preserving the original structure.
 *
 * @param part - Original part (string or object)
 * @param text - New text content
 * @returns New part with updated text
 */ function $b86a786ebedea812$var$withPartText(part, text) {
    if (typeof part === 'string') return text;
    return {
        ...part,
        text: text
    };
}
/**
 * Check if a message has the OpenAI/Anthropic content format.
 */ function $b86a786ebedea812$var$isContentMessage(message) {
    return message !== null && typeof message === 'object' && 'content' in message && typeof message.content === 'string';
}
/**
 * Check if a message has the OpenAI/Anthropic content array format.
 */ function $b86a786ebedea812$var$isContentArrayMessage(message) {
    return message !== null && typeof message === 'object' && 'content' in message && Array.isArray(message.content);
}
/**
 * Check if a message has the Google GenAI parts format.
 */ function $b86a786ebedea812$var$isPartsMessage(message) {
    return message !== null && typeof message === 'object' && 'parts' in message && Array.isArray(message.parts) && message.parts.length > 0;
}
/**
 * Truncate a message with `content: string` format (OpenAI/Anthropic).
 *
 * @param message - Message with content property
 * @param maxBytes - Maximum byte limit
 * @returns Array with truncated message, or empty array if it doesn't fit
 */ function $b86a786ebedea812$var$truncateContentMessage(message, maxBytes) {
    // Calculate overhead (message structure without content)
    const emptyMessage = {
        ...message,
        content: ''
    };
    const overhead = $b86a786ebedea812$var$jsonBytes(emptyMessage);
    const availableForContent = maxBytes - overhead;
    if (availableForContent <= 0) return [];
    const truncatedContent = $b86a786ebedea812$var$truncateTextByBytes(message.content, availableForContent);
    return [
        {
            ...message,
            content: truncatedContent
        }
    ];
}
/**
 * Truncate a message with `parts: [...]` format (Google GenAI).
 * Keeps as many complete parts as possible, only truncating the first part if needed.
 *
 * @param message - Message with parts array
 * @param maxBytes - Maximum byte limit
 * @returns Array with truncated message, or empty array if it doesn't fit
 */ function $b86a786ebedea812$var$truncatePartsMessage(message, maxBytes) {
    const { parts: parts } = message;
    // Calculate overhead by creating empty text parts
    const emptyParts = parts.map((part)=>$b86a786ebedea812$var$withPartText(part, ''));
    const overhead = $b86a786ebedea812$var$jsonBytes({
        ...message,
        parts: emptyParts
    });
    let remainingBytes = maxBytes - overhead;
    if (remainingBytes <= 0) return [];
    // Include parts until we run out of space
    const includedParts = [];
    for (const part of parts){
        const text = $b86a786ebedea812$var$getPartText(part);
        const textSize = $b86a786ebedea812$var$utf8Bytes(text);
        if (textSize <= remainingBytes) {
            // Part fits: include it as-is
            includedParts.push(part);
            remainingBytes -= textSize;
        } else if (includedParts.length === 0) {
            // First part doesn't fit: truncate it
            const truncated = $b86a786ebedea812$var$truncateTextByBytes(text, remainingBytes);
            if (truncated) includedParts.push($b86a786ebedea812$var$withPartText(part, truncated));
            break;
        } else break;
    }
    /* c8 ignore start
   * for type safety only, algorithm guarantees SOME text included */ if (includedParts.length <= 0) return [];
    else /* c8 ignore stop */ return [
        {
            ...message,
            parts: includedParts
        }
    ];
}
/**
 * Truncate a single message to fit within maxBytes.
 *
 * Supports three message formats:
 * - OpenAI/Anthropic: `{ ..., content: string }`
 * - Vercel AI/OpenAI multimodal: `{ ..., content: Array<{type, text?, ...}> }`
 * - Google GenAI: `{ ..., parts: Array<string | {text: string} | non-text> }`
 *
 * @param message - The message to truncate
 * @param maxBytes - Maximum byte limit for the message
 * @returns Array containing the truncated message, or empty array if truncation fails
 */ function $b86a786ebedea812$var$truncateSingleMessage(message, maxBytes) {
    if (!message) return [];
    // Handle plain strings (e.g., embeddings input)
    if (typeof message === 'string') {
        const truncated = $b86a786ebedea812$var$truncateTextByBytes(message, maxBytes);
        return truncated ? [
            truncated
        ] : [];
    }
    if (typeof message !== 'object') return [];
    if ($b86a786ebedea812$var$isContentMessage(message)) return $b86a786ebedea812$var$truncateContentMessage(message, maxBytes);
    if ($b86a786ebedea812$var$isContentArrayMessage(message)) // Content array messages are returned as-is without truncation
    return [
        message
    ];
    if ($b86a786ebedea812$var$isPartsMessage(message)) return $b86a786ebedea812$var$truncatePartsMessage(message, maxBytes);
    // Unknown message format: cannot truncate safely
    return [];
}
/**
 * Strip the inline media from message arrays.
 *
 * This returns a stripped message. We do NOT want to mutate the data in place,
 * because of course we still want the actual API/client to handle the media.
 */ function $b86a786ebedea812$var$stripInlineMediaFromMessages(messages) {
    const stripped = messages.map((message)=>{
        let newMessage = undefined;
        if (!!message && typeof message === 'object') {
            if ($b86a786ebedea812$var$isContentArrayMessage(message)) newMessage = {
                ...message,
                content: $b86a786ebedea812$var$stripInlineMediaFromMessages(message.content)
            };
            else if ('content' in message && (0, $48605d195f6f3132$export$37be2cb4b8ef44ca)(message.content)) newMessage = {
                ...message,
                content: (0, $48605d195f6f3132$export$69745de611b47810)(message.content)
            };
            if ($b86a786ebedea812$var$isPartsMessage(message)) newMessage = {
                // might have to strip content AND parts
                ...newMessage ?? message,
                parts: $b86a786ebedea812$var$stripInlineMediaFromMessages(message.parts)
            };
            if ((0, $48605d195f6f3132$export$37be2cb4b8ef44ca)(newMessage)) newMessage = (0, $48605d195f6f3132$export$69745de611b47810)(newMessage);
            else if ((0, $48605d195f6f3132$export$37be2cb4b8ef44ca)(message)) newMessage = (0, $48605d195f6f3132$export$69745de611b47810)(message);
        }
        return newMessage ?? message;
    });
    return stripped;
}
/**
 * Truncate an array of messages to fit within a byte limit.
 *
 * Strategy:
 * - Always keeps only the last (newest) message
 * - Strips inline media from the message
 * - Truncates the message content if it exceeds the byte limit
 *
 * @param messages - Array of messages to truncate
 * @param maxBytes - Maximum total byte limit for the message
 * @returns Array containing only the last message (possibly truncated)
 *
 * @example
 * ```ts
 * const messages = [msg1, msg2, msg3, msg4]; // newest is msg4
 * const truncated = truncateMessagesByBytes(messages, 10000);
 * // Returns [msg4] (truncated if needed)
 * ```
 */ function $b86a786ebedea812$var$truncateMessagesByBytes(messages, maxBytes) {
    // Early return for empty or invalid input
    if (!Array.isArray(messages) || messages.length === 0) return messages;
    // The result is always a single-element array that callers wrap with
    // JSON.stringify([message]), so subtract the 2-byte array wrapper ("["  and "]")
    // to ensure the final serialized value stays under the limit.
    const effectiveMaxBytes = maxBytes - 2;
    // Always keep only the last message
    const lastMessage = messages[messages.length - 1];
    // Strip inline media from the single message
    const stripped = $b86a786ebedea812$var$stripInlineMediaFromMessages([
        lastMessage
    ]);
    const strippedMessage = stripped[0];
    // Check if it fits
    const messageBytes = $b86a786ebedea812$var$jsonBytes(strippedMessage);
    if (messageBytes <= effectiveMaxBytes) return stripped;
    // Truncate the single message if needed
    return $b86a786ebedea812$var$truncateSingleMessage(strippedMessage, effectiveMaxBytes);
}
/**
 * Truncate GenAI messages using the default byte limit.
 *
 * Convenience wrapper around `truncateMessagesByBytes` with the default limit.
 *
 * @param messages - Array of messages to truncate
 * @returns Truncated array of messages
 */ function $b86a786ebedea812$export$7f5d498f0a32d006(messages) {
    return $b86a786ebedea812$var$truncateMessagesByBytes(messages, $b86a786ebedea812$export$e6b4dddd87c4d228);
}
/**
 * Truncate GenAI string input using the default byte limit.
 *
 * @param input - The string to truncate
 * @returns Truncated string
 */ function $b86a786ebedea812$export$7c57015e24a62698(input) {
    return $b86a786ebedea812$var$truncateTextByBytes(input, $b86a786ebedea812$export$e6b4dddd87c4d228);
}


/**
 * Shared utils for AI integrations (OpenAI, Anthropic, Verce.AI, etc.)
 */ /**
 * Resolves AI recording options by falling back to the client's `sendDefaultPii` setting.
 * Precedence: explicit option > sendDefaultPii > false
 */ function $33812c936a44f60e$export$ac4bb282bdbe5b74(options) {
    const sendDefaultPii = Boolean((0, $7d48e1ed9f699a01$export$6bb76d6eba7e258c)()?.getOptions().sendDefaultPii);
    return {
        ...options,
        recordInputs: options?.recordInputs ?? sendDefaultPii,
        recordOutputs: options?.recordOutputs ?? sendDefaultPii
    };
}
/**
 * Maps AI method paths to OpenTelemetry semantic convention operation names
 * @see https://opentelemetry.io/docs/specs/semconv/gen-ai/gen-ai-spans/#llm-request-spans
 */ function $33812c936a44f60e$export$101a096156a912de(methodPath) {
    if (methodPath.includes('messages')) return 'chat';
    if (methodPath.includes('completions')) return 'text_completion';
    // Google GenAI: models.generateContent* -> generate_content (actually generates AI responses)
    if (methodPath.includes('generateContent')) return 'generate_content';
    // Anthropic: models.get/retrieve -> models (metadata retrieval only)
    if (methodPath.includes('models')) return 'models';
    if (methodPath.includes('chat')) return 'chat';
    return methodPath.split('.').pop() || 'unknown';
}
/**
 * Get the span operation for AI methods
 * Following Sentry's convention: "gen_ai.{operation_name}"
 */ function $33812c936a44f60e$export$5e8bff7a65941113(methodPath) {
    return `gen_ai.${$33812c936a44f60e$export$101a096156a912de(methodPath)}`;
}
/**
 * Build method path from current traversal
 */ function $33812c936a44f60e$export$d7a5998392457f14(currentPath, prop) {
    return currentPath ? `${currentPath}.${prop}` : prop;
}
/**
 * Set token usage attributes
 * @param span - The span to add attributes to
 * @param promptTokens - The number of prompt tokens
 * @param completionTokens - The number of completion tokens
 * @param cachedInputTokens - The number of cached input tokens
 * @param cachedOutputTokens - The number of cached output tokens
 */ function $33812c936a44f60e$export$8130c966fa864943(span, promptTokens, completionTokens, cachedInputTokens, cachedOutputTokens) {
    if (promptTokens !== undefined) span.setAttributes({
        [(0, $69c5419d32efeaea$export$ad91d91220026940)]: promptTokens
    });
    if (completionTokens !== undefined) span.setAttributes({
        [(0, $69c5419d32efeaea$export$84cd977981922116)]: completionTokens
    });
    if (promptTokens !== undefined || completionTokens !== undefined || cachedInputTokens !== undefined || cachedOutputTokens !== undefined) {
        /**
     * Total input tokens in a request is the summation of `input_tokens`,
     * `cache_creation_input_tokens`, and `cache_read_input_tokens`.
     */ const totalTokens = (promptTokens ?? 0) + (completionTokens ?? 0) + (cachedInputTokens ?? 0) + (cachedOutputTokens ?? 0);
        span.setAttributes({
            [(0, $69c5419d32efeaea$export$60599e5371c06255)]: totalTokens
        });
    }
}
/**
 * Get the truncated JSON string for a string or array of strings.
 *
 * @param value - The string or array of strings to truncate
 * @returns The truncated JSON string
 */ function $33812c936a44f60e$export$5b065884ce77f65e(value) {
    if (typeof value === 'string') // Some values are already JSON strings, so we don't need to duplicate the JSON parsing
    return (0, $b86a786ebedea812$export$7c57015e24a62698)(value);
    if (Array.isArray(value)) {
        // truncateGenAiMessages returns an array of strings, so we need to stringify it
        const truncatedMessages = (0, $b86a786ebedea812$export$7f5d498f0a32d006)(value);
        return JSON.stringify(truncatedMessages);
    }
    // value is an object, so we need to stringify it
    return JSON.stringify(value);
}
/**
 * Extract system instructions from messages array.
 * Finds the first system message and formats it according to OpenTelemetry semantic conventions.
 *
 * @param messages - Array of messages to extract system instructions from
 * @returns systemInstructions (JSON string) and filteredMessages (without system message)
 */ function $33812c936a44f60e$export$d259f1ba7bd7cfce(messages) {
    if (!Array.isArray(messages)) return {
        systemInstructions: undefined,
        filteredMessages: messages
    };
    const systemMessageIndex = messages.findIndex((msg)=>msg && typeof msg === 'object' && 'role' in msg && msg.role === 'system');
    if (systemMessageIndex === -1) return {
        systemInstructions: undefined,
        filteredMessages: messages
    };
    const systemMessage = messages[systemMessageIndex];
    const systemContent = typeof systemMessage.content === 'string' ? systemMessage.content : systemMessage.content !== undefined ? JSON.stringify(systemMessage.content) : undefined;
    if (!systemContent) return {
        systemInstructions: undefined,
        filteredMessages: messages
    };
    const systemInstructions = JSON.stringify([
        {
            type: 'text',
            content: systemContent
        }
    ]);
    const filteredMessages = [
        ...messages.slice(0, systemMessageIndex),
        ...messages.slice(systemMessageIndex + 1)
    ];
    return {
        systemInstructions: systemInstructions,
        filteredMessages: filteredMessages
    };
}


const $467772c99d757ceb$export$8e71a6f462a7a3e3 = 'LangChain';
const $467772c99d757ceb$export$a087638a38a41762 = 'auto.ai.langchain';
const $467772c99d757ceb$export$92fd81ef7ff13e0c = {
    human: 'user',
    ai: 'assistant',
    assistant: 'assistant',
    system: 'system',
    function: 'function',
    tool: 'tool'
};








/**
 * Assigns an attribute only when the value is neither `undefined` nor `null`.
 *
 * We keep this tiny helper because call sites are repetitive and easy to miswrite.
 * It also preserves falsy-but-valid values like `0` and `""`.
 */ const $4041fb1e5e189765$var$setIfDefined = (target, key, value)=>{
    if (value != null) target[key] = value;
};
/**
 * Like `setIfDefined`, but converts the value with `Number()` and skips only when the
 * result is `NaN`. This ensures numeric 0 makes it through (unlike truthy checks).
 */ const $4041fb1e5e189765$var$setNumberIfDefined = (target, key, value)=>{
    const n = Number(value);
    if (!Number.isNaN(n)) target[key] = n;
};
/**
 * Converts a value to a string. Avoids double-quoted JSON strings where a plain
 * string is desired, but still handles objects/arrays safely.
 */ function $4041fb1e5e189765$var$asString(v) {
    if (typeof v === 'string') return v;
    try {
        return JSON.stringify(v);
    } catch  {
        return String(v);
    }
}
/**
 * Converts message content to a string, stripping inline media (base64 images, audio, etc.)
 * from multimodal content before stringification so downstream media stripping can't miss it.
 *
 * @example
 * // String content passes through unchanged:
 * normalizeContent("Hello") // => "Hello"
 *
 * // Multimodal array content — media is replaced with "[Blob substitute]" before JSON.stringify:
 * normalizeContent([
 *   { type: "text", text: "What color?" },
 *   { type: "image_url", image_url: { url: "data:image/png;base64,iVBOR..." } }
 * ])
 * // => '[{"type":"text","text":"What color?"},{"type":"image_url","image_url":{"url":"[Blob substitute]"}}]'
 *
 * // Without this, asString() would JSON.stringify the raw array and the base64 blob
 * // would end up in span attributes, since downstream stripping only works on objects.
 */ function $4041fb1e5e189765$var$normalizeContent(v) {
    if (Array.isArray(v)) try {
        const stripped = v.map((part)=>part && typeof part === 'object' && (0, $48605d195f6f3132$export$37be2cb4b8ef44ca)(part) ? (0, $48605d195f6f3132$export$69745de611b47810)(part) : part);
        return JSON.stringify(stripped);
    } catch  {
        return String(v);
    }
    return $4041fb1e5e189765$var$asString(v);
}
/**
 * Normalizes a single role token to our canonical set.
 *
 * @param role Incoming role value (free-form, any casing)
 * @returns Canonical role: 'user' | 'assistant' | 'system' | 'function' | 'tool' | <passthrough>
 */ function $4041fb1e5e189765$var$normalizeMessageRole(role) {
    const normalized = role.toLowerCase();
    return (0, $467772c99d757ceb$export$92fd81ef7ff13e0c)[normalized] ?? normalized;
}
/**
 * Infers a role from a LangChain message constructor name.
 *
 * Checks for substrings like "System", "Human", "AI", etc.
 */ function $4041fb1e5e189765$var$normalizeRoleNameFromCtor(name) {
    if (name.includes('System')) return 'system';
    if (name.includes('Human')) return 'user';
    if (name.includes('AI') || name.includes('Assistant')) return 'assistant';
    if (name.includes('Function')) return 'function';
    if (name.includes('Tool')) return 'tool';
    return 'user';
}
/**
 * Returns invocation params from a LangChain `tags` object.
 *
 * LangChain often passes runtime parameters (model, temperature, etc.) via the
 * `tags.invocation_params` bag. If `tags` is an array (LangChain sometimes uses
 * string tags), we return `undefined`.
 *
 * @param tags LangChain tags (string[] or record)
 * @returns The `invocation_params` object, if present
 */ function $4041fb1e5e189765$export$f0c34f999f2b1e42(tags) {
    if (!tags || Array.isArray(tags)) return undefined;
    return tags.invocation_params;
}
/**
 * Normalizes a heterogeneous set of LangChain messages to `{ role, content }`.
 *
 * Why so many branches? LangChain messages can arrive in several shapes:
 *  - Message classes with `_getType()` (most reliable)
 *  - Classes with meaningful constructor names (e.g. `SystemMessage`)
 *  - Plain objects with `type`, or `{ role, content }`
 *  - Serialized format with `{ lc: 1, id: [...], kwargs: { content } }`
 * We preserve the prioritization to minimize behavioral drift.
 *
 * @param messages Mixed LangChain messages
 * @returns Array of normalized `{ role, content }`
 */ function $4041fb1e5e189765$export$50238a3d0dec74d4(messages) {
    return messages.map((message)=>{
        // 1) Prefer _getType() when present
        const maybeGetType = message._getType;
        if (typeof maybeGetType === 'function') {
            const messageType = maybeGetType.call(message);
            return {
                role: $4041fb1e5e189765$var$normalizeMessageRole(messageType),
                content: $4041fb1e5e189765$var$normalizeContent(message.content)
            };
        }
        // 2) Serialized LangChain format (lc: 1) - check before constructor name
        // This is more reliable than constructor.name which can be lost during serialization
        if (message.lc === 1 && message.kwargs) {
            const id = message.id;
            const messageType = Array.isArray(id) && id.length > 0 ? id[id.length - 1] : '';
            const role = typeof messageType === 'string' ? $4041fb1e5e189765$var$normalizeRoleNameFromCtor(messageType) : 'user';
            return {
                role: $4041fb1e5e189765$var$normalizeMessageRole(role),
                content: $4041fb1e5e189765$var$normalizeContent(message.kwargs?.content)
            };
        }
        // 3) Then objects with `type`
        if (message.type) {
            const role = String(message.type).toLowerCase();
            return {
                role: $4041fb1e5e189765$var$normalizeMessageRole(role),
                content: $4041fb1e5e189765$var$normalizeContent(message.content)
            };
        }
        // 4) Then objects with `{ role, content }` - check before constructor name
        // Plain objects have constructor.name="Object" which would incorrectly default to "user"
        if (message.role) return {
            role: $4041fb1e5e189765$var$normalizeMessageRole(String(message.role)),
            content: $4041fb1e5e189765$var$normalizeContent(message.content)
        };
        // 5) Then try constructor name (SystemMessage / HumanMessage / ...)
        // Only use this if we haven't matched a more specific case
        const ctor = message.constructor?.name;
        if (ctor && ctor !== 'Object') return {
            role: $4041fb1e5e189765$var$normalizeMessageRole($4041fb1e5e189765$var$normalizeRoleNameFromCtor(ctor)),
            content: $4041fb1e5e189765$var$normalizeContent(message.content)
        };
        // 6) Fallback: treat as user text
        return {
            role: 'user',
            content: $4041fb1e5e189765$var$normalizeContent(message.content)
        };
    });
}
/**
 * Extracts request attributes common to both LLM and ChatModel invocations.
 *
 * Source precedence:
 * 1) `invocationParams` (highest)
 * 2) `langSmithMetadata`
 *
 * Numeric values are set even when 0 (e.g. `temperature: 0`), but skipped if `NaN`.
 */ function $4041fb1e5e189765$var$extractCommonRequestAttributes(serialized, invocationParams, langSmithMetadata) {
    const attrs = {};
    // Get kwargs if available (from constructor type)
    const kwargs = 'kwargs' in serialized ? serialized.kwargs : undefined;
    const temperature = invocationParams?.temperature ?? langSmithMetadata?.ls_temperature ?? kwargs?.temperature;
    $4041fb1e5e189765$var$setNumberIfDefined(attrs, (0, $69c5419d32efeaea$export$84ab1c0a4a1402ec), temperature);
    const maxTokens = invocationParams?.max_tokens ?? langSmithMetadata?.ls_max_tokens ?? kwargs?.max_tokens;
    $4041fb1e5e189765$var$setNumberIfDefined(attrs, (0, $69c5419d32efeaea$export$6affc15741e97c5c), maxTokens);
    const topP = invocationParams?.top_p ?? kwargs?.top_p;
    $4041fb1e5e189765$var$setNumberIfDefined(attrs, (0, $69c5419d32efeaea$export$be752be64ca500f6), topP);
    const frequencyPenalty = invocationParams?.frequency_penalty;
    $4041fb1e5e189765$var$setNumberIfDefined(attrs, (0, $69c5419d32efeaea$export$58b9b1cd46b4bb5e), frequencyPenalty);
    const presencePenalty = invocationParams?.presence_penalty;
    $4041fb1e5e189765$var$setNumberIfDefined(attrs, (0, $69c5419d32efeaea$export$66b1150b23e1da44), presencePenalty);
    // LangChain uses `stream`. We only set the attribute if the key actually exists
    // (some callbacks report `false` even on streamed requests, this stems from LangChain's callback handler).
    if (invocationParams && 'stream' in invocationParams) $4041fb1e5e189765$var$setIfDefined(attrs, (0, $69c5419d32efeaea$export$f8a1e9006f7a3c18), Boolean(invocationParams.stream));
    return attrs;
}
/**
 * Small helper to assemble boilerplate attributes shared by both request extractors.
 * Always uses 'chat' as the operation type for all LLM and chat model operations.
 */ function $4041fb1e5e189765$var$baseRequestAttributes(system, modelName, serialized, invocationParams, langSmithMetadata) {
    return {
        [(0, $69c5419d32efeaea$export$234b82df5670ccbb)]: $4041fb1e5e189765$var$asString(system ?? 'langchain'),
        [(0, $69c5419d32efeaea$export$d4b9e945d503aff)]: 'chat',
        [(0, $69c5419d32efeaea$export$e3834bc5d4a6f8a5)]: $4041fb1e5e189765$var$asString(modelName),
        [(0, $f337c80285f06f80$export$cca8dd30f57f805e)]: (0, $467772c99d757ceb$export$a087638a38a41762),
        ...$4041fb1e5e189765$var$extractCommonRequestAttributes(serialized, invocationParams, langSmithMetadata)
    };
}
/**
 * Extracts attributes for plain LLM invocations (string prompts).
 *
 * - Operation is tagged as `chat` following OpenTelemetry semantic conventions.
 *   LangChain LLM operations are treated as chat operations.
 * - When `recordInputs` is true, string prompts are wrapped into `{role:"user"}`
 *   messages to align with the chat schema used elsewhere.
 */ function $4041fb1e5e189765$export$b2af4de09d0dd27(llm, prompts, recordInputs, invocationParams, langSmithMetadata) {
    const system = langSmithMetadata?.ls_provider;
    const modelName = invocationParams?.model ?? langSmithMetadata?.ls_model_name ?? 'unknown';
    const attrs = $4041fb1e5e189765$var$baseRequestAttributes(system, modelName, llm, invocationParams, langSmithMetadata);
    if (recordInputs && Array.isArray(prompts) && prompts.length > 0) {
        $4041fb1e5e189765$var$setIfDefined(attrs, (0, $69c5419d32efeaea$export$ca7610de76ac1c3f), prompts.length);
        const messages = prompts.map((p)=>({
                role: 'user',
                content: p
            }));
        $4041fb1e5e189765$var$setIfDefined(attrs, (0, $69c5419d32efeaea$export$b36434f4adcd5fb0), $4041fb1e5e189765$var$asString(messages));
    }
    return attrs;
}
/**
 * Extracts attributes for ChatModel invocations (array-of-arrays of messages).
 *
 * - Operation is tagged as `chat` following OpenTelemetry semantic conventions.
 *   LangChain chat model operations are chat operations.
 * - We flatten LangChain's `LangChainMessage[][]` and normalize shapes into a
 *   consistent `{ role, content }` array when `recordInputs` is true.
 * - Provider system value falls back to `serialized.id?.[2]`.
 */ function $4041fb1e5e189765$export$2bdbe1822ff47652(llm, langChainMessages, recordInputs, invocationParams, langSmithMetadata) {
    const system = langSmithMetadata?.ls_provider ?? llm.id?.[2];
    const modelName = invocationParams?.model ?? langSmithMetadata?.ls_model_name ?? 'unknown';
    const attrs = $4041fb1e5e189765$var$baseRequestAttributes(system, modelName, llm, invocationParams, langSmithMetadata);
    if (recordInputs && Array.isArray(langChainMessages) && langChainMessages.length > 0) {
        const normalized = $4041fb1e5e189765$export$50238a3d0dec74d4(langChainMessages.flat());
        const { systemInstructions: systemInstructions, filteredMessages: filteredMessages } = (0, $33812c936a44f60e$export$d259f1ba7bd7cfce)(normalized);
        if (systemInstructions) $4041fb1e5e189765$var$setIfDefined(attrs, (0, $69c5419d32efeaea$export$461510d48ed1f51d), systemInstructions);
        const filteredLength = Array.isArray(filteredMessages) ? filteredMessages.length : 0;
        $4041fb1e5e189765$var$setIfDefined(attrs, (0, $69c5419d32efeaea$export$ca7610de76ac1c3f), filteredLength);
        const truncated = (0, $b86a786ebedea812$export$7f5d498f0a32d006)(filteredMessages);
        $4041fb1e5e189765$var$setIfDefined(attrs, (0, $69c5419d32efeaea$export$b36434f4adcd5fb0), $4041fb1e5e189765$var$asString(truncated));
    }
    return attrs;
}
/**
 * Scans generations for Anthropic-style `tool_use` items and records them.
 *
 * LangChain represents some provider messages (e.g., Anthropic) with a `message.content`
 * array that may include objects `{ type: 'tool_use', ... }`. We collect and attach
 * them as a JSON array on `gen_ai.response.tool_calls` for downstream consumers.
 */ function $4041fb1e5e189765$var$addToolCallsAttributes(generations, attrs) {
    const toolCalls = [];
    const flatGenerations = generations.flat();
    for (const gen of flatGenerations){
        const content = gen.message?.content;
        if (Array.isArray(content)) for (const item of content){
            const t = item;
            if (t.type === 'tool_use') toolCalls.push(t);
        }
    }
    if (toolCalls.length > 0) $4041fb1e5e189765$var$setIfDefined(attrs, (0, $69c5419d32efeaea$export$c6bace6b76d93a0), $4041fb1e5e189765$var$asString(toolCalls));
}
/**
 * Adds token usage attributes, supporting both OpenAI (`tokenUsage`) and Anthropic (`usage`) formats.
 * - Preserve zero values (0 tokens) by avoiding truthy checks.
 * - Compute a total for Anthropic when not explicitly provided.
 * - Include cache token metrics when present.
 */ function $4041fb1e5e189765$var$addTokenUsageAttributes(llmOutput, attrs) {
    if (!llmOutput) return;
    const tokenUsage = llmOutput.tokenUsage;
    const anthropicUsage = llmOutput.usage;
    if (tokenUsage) {
        $4041fb1e5e189765$var$setNumberIfDefined(attrs, (0, $69c5419d32efeaea$export$ad91d91220026940), tokenUsage.promptTokens);
        $4041fb1e5e189765$var$setNumberIfDefined(attrs, (0, $69c5419d32efeaea$export$84cd977981922116), tokenUsage.completionTokens);
        $4041fb1e5e189765$var$setNumberIfDefined(attrs, (0, $69c5419d32efeaea$export$60599e5371c06255), tokenUsage.totalTokens);
    } else if (anthropicUsage) {
        $4041fb1e5e189765$var$setNumberIfDefined(attrs, (0, $69c5419d32efeaea$export$ad91d91220026940), anthropicUsage.input_tokens);
        $4041fb1e5e189765$var$setNumberIfDefined(attrs, (0, $69c5419d32efeaea$export$84cd977981922116), anthropicUsage.output_tokens);
        // Compute total when not provided by the provider.
        const input = Number(anthropicUsage.input_tokens);
        const output = Number(anthropicUsage.output_tokens);
        const total = (Number.isNaN(input) ? 0 : input) + (Number.isNaN(output) ? 0 : output);
        if (total > 0) $4041fb1e5e189765$var$setNumberIfDefined(attrs, (0, $69c5419d32efeaea$export$60599e5371c06255), total);
        // Extra Anthropic cache metrics (present only when caching is enabled)
        if (anthropicUsage.cache_creation_input_tokens !== undefined) $4041fb1e5e189765$var$setNumberIfDefined(attrs, (0, $69c5419d32efeaea$export$a8acd4baf0e184e3), anthropicUsage.cache_creation_input_tokens);
        if (anthropicUsage.cache_read_input_tokens !== undefined) $4041fb1e5e189765$var$setNumberIfDefined(attrs, (0, $69c5419d32efeaea$export$b8f4e352e71d9b83), anthropicUsage.cache_read_input_tokens);
    }
}
/**
 * Extracts response-related attributes based on a `LangChainLLMResult`.
 *
 * - Records finish reasons when present on generations (e.g., OpenAI)
 * - When `recordOutputs` is true, captures textual response content and any
 *   tool calls.
 * - Also propagates model name (`model_name` or `model`), response `id`, and
 *   `stop_reason` (for providers that use it).
 */ function $4041fb1e5e189765$export$886d263c65778449(llmResult, recordOutputs) {
    if (!llmResult) return;
    const attrs = {};
    if (Array.isArray(llmResult.generations)) {
        const finishReasons = llmResult.generations.flat().map((g)=>{
            // v1 uses generationInfo.finish_reason
            if (g.generationInfo?.finish_reason) return g.generationInfo.finish_reason;
            // v0.3+ uses generation_info.finish_reason
            if (g.generation_info?.finish_reason) return g.generation_info.finish_reason;
            return null;
        }).filter((r)=>typeof r === 'string');
        if (finishReasons.length > 0) $4041fb1e5e189765$var$setIfDefined(attrs, (0, $69c5419d32efeaea$export$8778ccf58aa04820), $4041fb1e5e189765$var$asString(finishReasons));
        // Tool calls metadata (names, IDs) are not PII, so capture them regardless of recordOutputs
        $4041fb1e5e189765$var$addToolCallsAttributes(llmResult.generations, attrs);
        if (recordOutputs) {
            const texts = llmResult.generations.flat().map((gen)=>gen.text ?? gen.message?.content).filter((t)=>typeof t === 'string');
            if (texts.length > 0) $4041fb1e5e189765$var$setIfDefined(attrs, (0, $69c5419d32efeaea$export$2478fd72313ce319), $4041fb1e5e189765$var$asString(texts));
        }
    }
    $4041fb1e5e189765$var$addTokenUsageAttributes(llmResult.llmOutput, attrs);
    const llmOutput = llmResult.llmOutput;
    // Extract from v1 generations structure if available
    const firstGeneration = llmResult.generations?.[0]?.[0];
    const v1Message = firstGeneration?.message;
    // Provider model identifier: `model_name` (OpenAI-style) or `model` (others)
    // v1 stores this in message.response_metadata.model_name
    const modelName = llmOutput?.model_name ?? llmOutput?.model ?? v1Message?.response_metadata?.model_name;
    if (modelName) $4041fb1e5e189765$var$setIfDefined(attrs, (0, $69c5419d32efeaea$export$91aa8d4aaebb3840), modelName);
    // Response ID: v1 stores this in message.id
    const responseId = llmOutput?.id ?? v1Message?.id;
    if (responseId) $4041fb1e5e189765$var$setIfDefined(attrs, (0, $69c5419d32efeaea$export$1e55ab213eb8e5dc), responseId);
    // Stop reason: v1 stores this in message.response_metadata.finish_reason
    const stopReason = llmOutput?.stop_reason ?? v1Message?.response_metadata?.finish_reason;
    if (stopReason) $4041fb1e5e189765$var$setIfDefined(attrs, (0, $69c5419d32efeaea$export$39c7eee451583755), $4041fb1e5e189765$var$asString(stopReason));
    return attrs;
}


/**
 * Creates a Sentry callback handler for LangChain
 * Returns a plain object that LangChain will call via duck-typing
 *
 * This is a stateful handler that tracks spans across multiple LangChain executions.
 */ function $0aca44b63e3bce0d$export$f1a67aef86776bb5(options = {}) {
    const { recordInputs: recordInputs, recordOutputs: recordOutputs } = (0, $33812c936a44f60e$export$ac4bb282bdbe5b74)(options);
    // Internal state - single instance tracks all spans
    const spanMap = new Map();
    /**
   * Exit a span and clean up
   */ const exitSpan = (runId)=>{
        const span = spanMap.get(runId);
        if (span?.isRecording()) {
            span.end();
            spanMap.delete(runId);
        }
    };
    /**
   * Handler for LLM Start
   * This handler will be called by LangChain's callback handler when an LLM event is detected.
   */ const handler = {
        // Required LangChain BaseCallbackHandler properties
        lc_serializable: false,
        lc_namespace: [
            'langchain_core',
            'callbacks',
            'sentry'
        ],
        lc_secrets: undefined,
        lc_attributes: undefined,
        lc_aliases: undefined,
        lc_serializable_keys: undefined,
        lc_id: [
            'langchain_core',
            'callbacks',
            'sentry'
        ],
        lc_kwargs: {},
        name: 'SentryCallbackHandler',
        // BaseCallbackHandlerInput boolean flags
        ignoreLLM: false,
        ignoreChain: false,
        ignoreAgent: false,
        ignoreRetriever: false,
        ignoreCustomEvent: false,
        raiseError: false,
        awaitHandlers: true,
        handleLLMStart (llm, prompts, runId, _parentRunId, _extraParams, tags, metadata, _runName) {
            const invocationParams = (0, $4041fb1e5e189765$export$f0c34f999f2b1e42)(tags);
            const attributes = (0, $4041fb1e5e189765$export$b2af4de09d0dd27)(llm, prompts, recordInputs, invocationParams, metadata);
            const modelName = attributes[0, $69c5419d32efeaea$export$e3834bc5d4a6f8a5];
            const operationName = attributes[0, $69c5419d32efeaea$export$d4b9e945d503aff];
            (0, $c9161b67125aefc1$export$c10292ad04b92aea)({
                name: `${operationName} ${modelName}`,
                op: 'gen_ai.chat',
                attributes: {
                    ...attributes,
                    [(0, $f337c80285f06f80$export$1a413bd9a88fdb09)]: 'gen_ai.chat'
                }
            }, (span)=>{
                spanMap.set(runId, span);
                return span;
            });
        },
        // Chat Model Start Handler
        handleChatModelStart (llm, messages, runId, _parentRunId, _extraParams, tags, metadata, _runName) {
            const invocationParams = (0, $4041fb1e5e189765$export$f0c34f999f2b1e42)(tags);
            const attributes = (0, $4041fb1e5e189765$export$2bdbe1822ff47652)(llm, messages, recordInputs, invocationParams, metadata);
            const modelName = attributes[0, $69c5419d32efeaea$export$e3834bc5d4a6f8a5];
            const operationName = attributes[0, $69c5419d32efeaea$export$d4b9e945d503aff];
            (0, $c9161b67125aefc1$export$c10292ad04b92aea)({
                name: `${operationName} ${modelName}`,
                op: 'gen_ai.chat',
                attributes: {
                    ...attributes,
                    [(0, $f337c80285f06f80$export$1a413bd9a88fdb09)]: 'gen_ai.chat'
                }
            }, (span)=>{
                spanMap.set(runId, span);
                return span;
            });
        },
        // LLM End Handler - note: handleLLMEnd with capital LLM (used by both LLMs and chat models!)
        handleLLMEnd (output, runId, _parentRunId, _tags, _extraParams) {
            const span = spanMap.get(runId);
            if (span?.isRecording()) {
                const attributes = (0, $4041fb1e5e189765$export$886d263c65778449)(output, recordOutputs);
                if (attributes) span.setAttributes(attributes);
                exitSpan(runId);
            }
        },
        // LLM Error Handler - note: handleLLMError with capital LLM
        handleLLMError (error, runId) {
            const span = spanMap.get(runId);
            if (span?.isRecording()) {
                span.setStatus({
                    code: (0, $fda37f10dc06a152$export$f966a0446ece71e),
                    message: 'internal_error'
                });
                exitSpan(runId);
            }
            (0, $6918c722b531ff18$export$f5282963edea4a68)(error, {
                mechanism: {
                    handled: false,
                    type: `${(0, $467772c99d757ceb$export$a087638a38a41762)}.llm_error_handler`
                }
            });
        },
        // Chain Start Handler
        handleChainStart (chain, inputs, runId, _parentRunId, _tags, _metadata, _runType, runName) {
            const chainName = runName || chain.name || 'unknown_chain';
            const attributes = {
                [(0, $f337c80285f06f80$export$cca8dd30f57f805e)]: 'auto.ai.langchain',
                'langchain.chain.name': chainName
            };
            // Add inputs if recordInputs is enabled
            if (recordInputs) attributes['langchain.chain.inputs'] = JSON.stringify(inputs);
            (0, $c9161b67125aefc1$export$c10292ad04b92aea)({
                name: `chain ${chainName}`,
                op: 'gen_ai.invoke_agent',
                attributes: {
                    ...attributes,
                    [(0, $f337c80285f06f80$export$1a413bd9a88fdb09)]: 'gen_ai.invoke_agent'
                }
            }, (span)=>{
                spanMap.set(runId, span);
                return span;
            });
        },
        // Chain End Handler
        handleChainEnd (outputs, runId) {
            const span = spanMap.get(runId);
            if (span?.isRecording()) {
                // Add outputs if recordOutputs is enabled
                if (recordOutputs) span.setAttributes({
                    'langchain.chain.outputs': JSON.stringify(outputs)
                });
                exitSpan(runId);
            }
        },
        // Chain Error Handler
        handleChainError (error, runId) {
            const span = spanMap.get(runId);
            if (span?.isRecording()) {
                span.setStatus({
                    code: (0, $fda37f10dc06a152$export$f966a0446ece71e),
                    message: 'internal_error'
                });
                exitSpan(runId);
            }
            (0, $6918c722b531ff18$export$f5282963edea4a68)(error, {
                mechanism: {
                    handled: false,
                    type: `${(0, $467772c99d757ceb$export$a087638a38a41762)}.chain_error_handler`
                }
            });
        },
        // Tool Start Handler
        handleToolStart (tool, input, runId, _parentRunId) {
            const toolName = tool.name || 'unknown_tool';
            const attributes = {
                [(0, $f337c80285f06f80$export$cca8dd30f57f805e)]: (0, $467772c99d757ceb$export$a087638a38a41762),
                [(0, $69c5419d32efeaea$export$51cd34bcdf696c21)]: toolName
            };
            // Add input if recordInputs is enabled
            if (recordInputs) attributes[0, $69c5419d32efeaea$export$eb2b5e3f072ecbad] = input;
            (0, $c9161b67125aefc1$export$c10292ad04b92aea)({
                name: `execute_tool ${toolName}`,
                op: 'gen_ai.execute_tool',
                attributes: {
                    ...attributes,
                    [(0, $f337c80285f06f80$export$1a413bd9a88fdb09)]: 'gen_ai.execute_tool'
                }
            }, (span)=>{
                spanMap.set(runId, span);
                return span;
            });
        },
        // Tool End Handler
        handleToolEnd (output, runId) {
            const span = spanMap.get(runId);
            if (span?.isRecording()) {
                // Add output if recordOutputs is enabled
                if (recordOutputs) span.setAttributes({
                    [(0, $69c5419d32efeaea$export$e768cd7668ffb4c9)]: JSON.stringify(output)
                });
                exitSpan(runId);
            }
        },
        // Tool Error Handler
        handleToolError (error, runId) {
            const span = spanMap.get(runId);
            if (span?.isRecording()) {
                span.setStatus({
                    code: (0, $fda37f10dc06a152$export$f966a0446ece71e),
                    message: 'internal_error'
                });
                exitSpan(runId);
            }
            (0, $6918c722b531ff18$export$f5282963edea4a68)(error, {
                mechanism: {
                    handled: false,
                    type: `${(0, $467772c99d757ceb$export$a087638a38a41762)}.tool_error_handler`
                }
            });
        },
        // LangChain BaseCallbackHandler required methods
        copy () {
            return handler;
        },
        toJSON () {
            return {
                lc: 1,
                type: 'not_implemented',
                id: handler.lc_id
            };
        },
        toJSONNotImplemented () {
            return {
                lc: 1,
                type: 'not_implemented',
                id: handler.lc_id
            };
        }
    };
    return handler;
}





/**
 * Calls `unref` on a timer, if the method is available on @param timer.
 *
 * `unref()` is used to allow processes to exit immediately, even if the timer
 * is still running and hasn't resolved yet.
 *
 * Use this in places where code can run on browser or server, since browsers
 * do not support `unref`.
 */ function $eb2fc1cbe65ebe8f$export$630056cb83d87863(timer) {
    if (typeof timer === 'object' && typeof timer.unref === 'function') timer.unref();
    return timer;
}


const $1407141ba4ddb36d$export$c8667f1887a128dc = Symbol.for('SentryBufferFullError');
/**
 * Creates an new PromiseBuffer object with the specified limit
 * @param limit max number of promises that can be stored in the buffer
 */ function $1407141ba4ddb36d$export$85a4f67f852183e6(limit = 100) {
    const buffer = new Set();
    function isReady() {
        return buffer.size < limit;
    }
    /**
   * Remove a promise from the queue.
   *
   * @param task Can be any PromiseLike<T>
   * @returns Removed promise.
   */ function remove(task) {
        buffer.delete(task);
    }
    /**
   * Add a promise (representing an in-flight action) to the queue, and set it to remove itself on fulfillment.
   *
   * @param taskProducer A function producing any PromiseLike<T>; In previous versions this used to be `task:
   *        PromiseLike<T>`, but under that model, Promises were instantly created on the call-site and their executor
   *        functions therefore ran immediately. Thus, even if the buffer was full, the action still happened. By
   *        requiring the promise to be wrapped in a function, we can defer promise creation until after the buffer
   *        limit check.
   * @returns The original promise.
   */ function add(taskProducer) {
        if (!isReady()) return (0, $e9661cd6d20ea7e7$export$78e43115b553f358)($1407141ba4ddb36d$export$c8667f1887a128dc);
        // start the task and add its promise to the queue
        const task = taskProducer();
        buffer.add(task);
        task.then(()=>remove(task), ()=>remove(task));
        return task;
    }
    /**
   * Wait for all promises in the queue to resolve or for timeout to expire, whichever comes first.
   *
   * @param timeout The time, in ms, after which to resolve to `false` if the queue is still non-empty. Passing `0` (or
   * not passing anything) will make the promise wait as long as it takes for the queue to drain before resolving to
   * `true`.
   * @returns A promise which will resolve to `true` if the queue is already empty or drains before the timeout, and
   * `false` otherwise
   */ function drain(timeout) {
        if (!buffer.size) return (0, $e9661cd6d20ea7e7$export$1fda8aa4d135f8aa)(true);
        // We want to resolve even if one of the promises rejects
        const drainPromise = Promise.allSettled(Array.from(buffer)).then(()=>true);
        if (!timeout) return drainPromise;
        const promises = [
            drainPromise,
            new Promise((resolve)=>(0, $eb2fc1cbe65ebe8f$export$630056cb83d87863)(setTimeout(()=>resolve(false), timeout)))
        ];
        return Promise.race(promises);
    }
    return {
        get $ () {
            return Array.from(buffer);
        },
        add: add,
        drain: drain
    };
}



// Intentionally keeping the key broad, as we don't know for sure what rate limit headers get returned from backend
const $33414f31f3554c40$export$b09ce39faaeb1e7c = 60000; // 60 seconds
/**
 * Extracts Retry-After value from the request header or returns default value
 * @param header string representation of 'Retry-After' header
 * @param now current unix timestamp
 *
 */ function $33414f31f3554c40$export$615352e17ed7741(header, now = (0, $c80d7f6644a3b50b$export$65b1bada40c91b34)()) {
    const headerDelay = parseInt(`${header}`, 10);
    if (!isNaN(headerDelay)) return headerDelay * 1000;
    const headerDate = Date.parse(`${header}`);
    if (!isNaN(headerDate)) return headerDate - now;
    return $33414f31f3554c40$export$b09ce39faaeb1e7c;
}
/**
 * Gets the time that the given category is disabled until for rate limiting.
 * In case no category-specific limit is set but a general rate limit across all categories is active,
 * that time is returned.
 *
 * @return the time in ms that the category is disabled until or 0 if there's no active rate limit.
 */ function $33414f31f3554c40$export$b89fc7b2e4c799e7(limits, dataCategory) {
    return limits[dataCategory] || limits.all || 0;
}
/**
 * Checks if a category is rate limited
 */ function $33414f31f3554c40$export$6c91fec22056810a(limits, dataCategory, now = (0, $c80d7f6644a3b50b$export$65b1bada40c91b34)()) {
    return $33414f31f3554c40$export$b89fc7b2e4c799e7(limits, dataCategory) > now;
}
/**
 * Update ratelimits from incoming headers.
 *
 * @return the updated RateLimits object.
 */ function $33414f31f3554c40$export$699aff705e0d49d4(limits, { statusCode: statusCode, headers: headers }, now = (0, $c80d7f6644a3b50b$export$65b1bada40c91b34)()) {
    const updatedRateLimits = {
        ...limits
    };
    // "The name is case-insensitive."
    // https://developer.mozilla.org/en-US/docs/Web/API/Headers/get
    const rateLimitHeader = headers?.['x-sentry-rate-limits'];
    const retryAfterHeader = headers?.['retry-after'];
    if (rateLimitHeader) /**
     * rate limit headers are of the form
     *     <header>,<header>,..
     * where each <header> is of the form
     *     <retry_after>: <categories>: <scope>: <reason_code>: <namespaces>
     * where
     *     <retry_after> is a delay in seconds
     *     <categories> is the event type(s) (error, transaction, etc) being rate limited and is of the form
     *         <category>;<category>;...
     *     <scope> is what's being limited (org, project, or key) - ignored by SDK
     *     <reason_code> is an arbitrary string like "org_quota" - ignored by SDK
     *     <namespaces> Semicolon-separated list of metric namespace identifiers. Defines which namespace(s) will be affected.
     *         Only present if rate limit applies to the metric_bucket data category.
     */ for (const limit of rateLimitHeader.trim().split(',')){
        const [retryAfter, categories, , , namespaces] = limit.split(':', 5);
        const headerDelay = parseInt(retryAfter, 10);
        const delay = (!isNaN(headerDelay) ? headerDelay : 60) * 1000; // 60sec default
        if (!categories) updatedRateLimits.all = now + delay;
        else for (const category of categories.split(';')){
            if (category === 'metric_bucket') // namespaces will be present when category === 'metric_bucket'
            {
                if (!namespaces || namespaces.split(';').includes('custom')) updatedRateLimits[category] = now + delay;
            } else updatedRateLimits[category] = now + delay;
        }
    }
    else if (retryAfterHeader) updatedRateLimits.all = now + $33414f31f3554c40$export$615352e17ed7741(retryAfterHeader, now);
    else if (statusCode === 429) updatedRateLimits.all = now + 60000;
    return updatedRateLimits;
}


const $46ddc25216d7985b$export$e515cf6dfd2f98b8 = 64;
/**
 * Creates an instance of a Sentry `Transport`
 *
 * @param options
 * @param makeRequest
 */ function $46ddc25216d7985b$export$d09f50d9ab7f7b69(options, makeRequest, buffer = (0, $1407141ba4ddb36d$export$85a4f67f852183e6)(options.bufferSize || $46ddc25216d7985b$export$e515cf6dfd2f98b8)) {
    let rateLimits = {};
    const flush = (timeout)=>buffer.drain(timeout);
    function send(envelope) {
        const filteredEnvelopeItems = [];
        // Drop rate limited items from envelope
        (0, $bb063ad93c8b79c7$export$c56c55acf0136fd3)(envelope, (item, type)=>{
            const dataCategory = (0, $bb063ad93c8b79c7$export$b11169581eeaf237)(type);
            if ((0, $33414f31f3554c40$export$6c91fec22056810a)(rateLimits, dataCategory)) options.recordDroppedEvent('ratelimit_backoff', dataCategory);
            else filteredEnvelopeItems.push(item);
        });
        // Skip sending if envelope is empty after filtering out rate limited events
        if (filteredEnvelopeItems.length === 0) return Promise.resolve({});
        const filteredEnvelope = (0, $bb063ad93c8b79c7$export$f93f7f385160c44e)(envelope[0], filteredEnvelopeItems);
        // Creates client report for each item in an envelope
        const recordEnvelopeLoss = (reason)=>{
            // Don't record outcomes for client reports - we don't want to create a feedback loop if client reports themselves fail to send
            if ((0, $bb063ad93c8b79c7$export$604a45d95a155e2b)(filteredEnvelope, [
                'client_report'
            ])) {
                (0, $19fdbaf7f0830971$export$16a28057038b10ef) && (0, $d11ed0b3cdda6b8d$export$1c9f709888824e05).warn(`Dropping client report. Will not send outcomes (reason: ${reason}).`);
                return;
            }
            (0, $bb063ad93c8b79c7$export$c56c55acf0136fd3)(filteredEnvelope, (item, type)=>{
                options.recordDroppedEvent(reason, (0, $bb063ad93c8b79c7$export$b11169581eeaf237)(type));
            });
        };
        const requestTask = ()=>makeRequest({
                body: (0, $bb063ad93c8b79c7$export$32f9b428425aac85)(filteredEnvelope)
            }).then((response)=>{
                // Handle 413 Content Too Large
                // Loss of envelope content is expected so we record a send_error client report
                // https://develop.sentry.dev/sdk/expected-features/#dealing-with-network-failures
                if (response.statusCode === 413) {
                    (0, $19fdbaf7f0830971$export$16a28057038b10ef) && (0, $d11ed0b3cdda6b8d$export$1c9f709888824e05).error('Sentry responded with status code 413. Envelope was discarded due to exceeding size limits.');
                    recordEnvelopeLoss('send_error');
                    return response;
                }
                // We don't want to throw on NOK responses, but we want to at least log them
                if ((0, $19fdbaf7f0830971$export$16a28057038b10ef) && response.statusCode !== undefined && (response.statusCode < 200 || response.statusCode >= 300)) (0, $d11ed0b3cdda6b8d$export$1c9f709888824e05).warn(`Sentry responded with status code ${response.statusCode} to sent event.`);
                rateLimits = (0, $33414f31f3554c40$export$699aff705e0d49d4)(rateLimits, response);
                return response;
            }, (error)=>{
                recordEnvelopeLoss('network_error');
                (0, $19fdbaf7f0830971$export$16a28057038b10ef) && (0, $d11ed0b3cdda6b8d$export$1c9f709888824e05).error('Encountered error running transport request:', error);
                throw error;
            });
        return buffer.add(requestTask).then((result)=>result, (error)=>{
            if (error === (0, $1407141ba4ddb36d$export$c8667f1887a128dc)) {
                (0, $19fdbaf7f0830971$export$16a28057038b10ef) && (0, $d11ed0b3cdda6b8d$export$1c9f709888824e05).error('Skipped sending event because buffer is full.');
                recordEnvelopeLoss('queue_overflow');
                return Promise.resolve({});
            } else throw error;
        });
    }
    return {
        send: send,
        flush: flush
    };
}





const $09e731d6cf47db44$var$INTEGRATION_NAME = 'Dedupe';
const $09e731d6cf47db44$var$_dedupeIntegration = ()=>{
    let previousEvent;
    return {
        name: $09e731d6cf47db44$var$INTEGRATION_NAME,
        processEvent (currentEvent) {
            // We want to ignore any non-error type events, e.g. transactions or replays
            // These should never be deduped, and also not be compared against as _previousEvent.
            if (currentEvent.type) return currentEvent;
            // Juuust in case something goes wrong
            try {
                if ($09e731d6cf47db44$export$3c6361fddf6cd929(currentEvent, previousEvent)) {
                    (0, $19fdbaf7f0830971$export$16a28057038b10ef) && (0, $d11ed0b3cdda6b8d$export$1c9f709888824e05).warn('Event dropped due to being a duplicate of previously captured event.');
                    return null;
                }
            } catch  {} // eslint-disable-line no-empty
            return previousEvent = currentEvent;
        }
    };
};
/**
 * Deduplication filter.
 */ const $09e731d6cf47db44$export$6d39aa44cd0c7567 = (0, $cbb2da6c78246e45$export$2323046b9414659f)($09e731d6cf47db44$var$_dedupeIntegration);
/** only exported for tests. */ function $09e731d6cf47db44$export$3c6361fddf6cd929(currentEvent, previousEvent) {
    if (!previousEvent) return false;
    if ($09e731d6cf47db44$var$_isSameMessageEvent(currentEvent, previousEvent)) return true;
    if ($09e731d6cf47db44$var$_isSameExceptionEvent(currentEvent, previousEvent)) return true;
    return false;
}
function $09e731d6cf47db44$var$_isSameMessageEvent(currentEvent, previousEvent) {
    const currentMessage = currentEvent.message;
    const previousMessage = previousEvent.message;
    // If neither event has a message property, they were both exceptions, so bail out
    if (!currentMessage && !previousMessage) return false;
    // If only one event has a stacktrace, but not the other one, they are not the same
    if (currentMessage && !previousMessage || !currentMessage && previousMessage) return false;
    if (currentMessage !== previousMessage) return false;
    if (!$09e731d6cf47db44$var$_isSameFingerprint(currentEvent, previousEvent)) return false;
    if (!$09e731d6cf47db44$var$_isSameStacktrace(currentEvent, previousEvent)) return false;
    return true;
}
function $09e731d6cf47db44$var$_isSameExceptionEvent(currentEvent, previousEvent) {
    const previousException = $09e731d6cf47db44$var$_getExceptionFromEvent(previousEvent);
    const currentException = $09e731d6cf47db44$var$_getExceptionFromEvent(currentEvent);
    if (!previousException || !currentException) return false;
    if (previousException.type !== currentException.type || previousException.value !== currentException.value) return false;
    if (!$09e731d6cf47db44$var$_isSameFingerprint(currentEvent, previousEvent)) return false;
    if (!$09e731d6cf47db44$var$_isSameStacktrace(currentEvent, previousEvent)) return false;
    return true;
}
function $09e731d6cf47db44$var$_isSameStacktrace(currentEvent, previousEvent) {
    let currentFrames = (0, $9ed2cf4edd0b2db9$export$91d8ca51bd9f6a47)(currentEvent);
    let previousFrames = (0, $9ed2cf4edd0b2db9$export$91d8ca51bd9f6a47)(previousEvent);
    // If neither event has a stacktrace, they are assumed to be the same
    if (!currentFrames && !previousFrames) return true;
    // If only one event has a stacktrace, but not the other one, they are not the same
    if (currentFrames && !previousFrames || !currentFrames && previousFrames) return false;
    currentFrames;
    previousFrames;
    // If number of frames differ, they are not the same
    if (previousFrames.length !== currentFrames.length) return false;
    // Otherwise, compare the two
    for(let i = 0; i < previousFrames.length; i++){
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const frameA = previousFrames[i];
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const frameB = currentFrames[i];
        if (frameA.filename !== frameB.filename || frameA.lineno !== frameB.lineno || frameA.colno !== frameB.colno || frameA.function !== frameB.function) return false;
    }
    return true;
}
function $09e731d6cf47db44$var$_isSameFingerprint(currentEvent, previousEvent) {
    let currentFingerprint = currentEvent.fingerprint;
    let previousFingerprint = previousEvent.fingerprint;
    // If neither event has a fingerprint, they are assumed to be the same
    if (!currentFingerprint && !previousFingerprint) return true;
    // If only one event has a fingerprint, but not the other one, they are not the same
    if (currentFingerprint && !previousFingerprint || !currentFingerprint && previousFingerprint) return false;
    currentFingerprint;
    previousFingerprint;
    // Otherwise, compare the two
    try {
        return !!(currentFingerprint.join('') === previousFingerprint.join(''));
    } catch  {
        return false;
    }
}
function $09e731d6cf47db44$var$_getExceptionFromEvent(event) {
    return event.exception?.values?.[0];
}




/**
 * Get a list of possible event messages from a Sentry event.
 */ function $ac8e718335e141d5$export$d55a97c329cacfcc(event) {
    const possibleMessages = [];
    if (event.message) possibleMessages.push(event.message);
    try {
        // @ts-expect-error Try catching to save bundle size
        const lastException = event.exception.values[event.exception.values.length - 1];
        if (lastException?.value) {
            possibleMessages.push(lastException.value);
            if (lastException.type) possibleMessages.push(`${lastException.type}: ${lastException.value}`);
        }
    } catch  {
    // ignore errors here
    }
    return possibleMessages;
}




// "Script error." is hard coded into browsers for errors that it can't read.
// this is the result of a script being pulled in from an external domain and CORS.
const $ed46e39d92a37c80$var$DEFAULT_IGNORE_ERRORS = [
    /^Script error\.?$/,
    /^Javascript error: Script error\.? on line 0$/,
    /^ResizeObserver loop completed with undelivered notifications.$/,
    /^Cannot redefine property: googletag$/,
    /^Can't find variable: gmo$/,
    /^undefined is not an object \(evaluating 'a\.[A-Z]'\)$/,
    /can't redefine non-configurable property "solana"/,
    /vv\(\)\.getRestrictions is not a function/,
    /Can't find variable: _AutofillCallbackHandler/,
    /Object Not Found Matching Id:\d+, MethodName:simulateEvent/,
    /^Java exception was raised during method invocation$/
];
/** Options for the EventFilters integration */ const $ed46e39d92a37c80$var$INTEGRATION_NAME = 'EventFilters';
/**
 * An integration that filters out events (errors and transactions) based on:
 *
 * - (Errors) A curated list of known low-value or irrelevant errors (see {@link DEFAULT_IGNORE_ERRORS})
 * - (Errors) A list of error messages or urls/filenames passed in via
 *   - Top level Sentry.init options (`ignoreErrors`, `denyUrls`, `allowUrls`)
 *   - The same options passed to the integration directly via @param options
 * - (Transactions/Spans) A list of root span (transaction) names passed in via
 *   - Top level Sentry.init option (`ignoreTransactions`)
 *   - The same option passed to the integration directly via @param options
 *
 * Events filtered by this integration will not be sent to Sentry.
 */ const $ed46e39d92a37c80$export$9a84f518c163c552 = (0, $cbb2da6c78246e45$export$2323046b9414659f)((options = {})=>{
    let mergedOptions;
    return {
        name: $ed46e39d92a37c80$var$INTEGRATION_NAME,
        setup (client) {
            const clientOptions = client.getOptions();
            mergedOptions = $ed46e39d92a37c80$var$_mergeOptions(options, clientOptions);
        },
        processEvent (event, _hint, client) {
            if (!mergedOptions) {
                const clientOptions = client.getOptions();
                mergedOptions = $ed46e39d92a37c80$var$_mergeOptions(options, clientOptions);
            }
            return $ed46e39d92a37c80$var$_shouldDropEvent(event, mergedOptions) ? null : event;
        }
    };
});
/**
 * An integration that filters out events (errors and transactions) based on:
 *
 * - (Errors) A curated list of known low-value or irrelevant errors (see {@link DEFAULT_IGNORE_ERRORS})
 * - (Errors) A list of error messages or urls/filenames passed in via
 *   - Top level Sentry.init options (`ignoreErrors`, `denyUrls`, `allowUrls`)
 *   - The same options passed to the integration directly via @param options
 * - (Transactions/Spans) A list of root span (transaction) names passed in via
 *   - Top level Sentry.init option (`ignoreTransactions`)
 *   - The same option passed to the integration directly via @param options
 *
 * Events filtered by this integration will not be sent to Sentry.
 *
 * @deprecated this integration was renamed and will be removed in a future major version.
 * Use `eventFiltersIntegration` instead.
 */ const $ed46e39d92a37c80$export$cb3c5c2ceb9818ba = (0, $cbb2da6c78246e45$export$2323046b9414659f)((options = {})=>{
    return {
        ...$ed46e39d92a37c80$export$9a84f518c163c552(options),
        name: 'InboundFilters'
    };
});
function $ed46e39d92a37c80$var$_mergeOptions(internalOptions = {}, clientOptions = {}) {
    return {
        allowUrls: [
            ...internalOptions.allowUrls || [],
            ...clientOptions.allowUrls || []
        ],
        denyUrls: [
            ...internalOptions.denyUrls || [],
            ...clientOptions.denyUrls || []
        ],
        ignoreErrors: [
            ...internalOptions.ignoreErrors || [],
            ...clientOptions.ignoreErrors || [],
            ...internalOptions.disableErrorDefaults ? [] : $ed46e39d92a37c80$var$DEFAULT_IGNORE_ERRORS
        ],
        ignoreTransactions: [
            ...internalOptions.ignoreTransactions || [],
            ...clientOptions.ignoreTransactions || []
        ]
    };
}
function $ed46e39d92a37c80$var$_shouldDropEvent(event, options) {
    if (!event.type) {
        // Filter errors
        if ($ed46e39d92a37c80$var$_isIgnoredError(event, options.ignoreErrors)) {
            (0, $19fdbaf7f0830971$export$16a28057038b10ef) && (0, $d11ed0b3cdda6b8d$export$1c9f709888824e05).warn(`Event dropped due to being matched by \`ignoreErrors\` option.\nEvent: ${(0, $cc262db35458e4b3$export$4157119e2b157127)(event)}`);
            return true;
        }
        if ($ed46e39d92a37c80$var$_isUselessError(event)) {
            (0, $19fdbaf7f0830971$export$16a28057038b10ef) && (0, $d11ed0b3cdda6b8d$export$1c9f709888824e05).warn(`Event dropped due to not having an error message, error type or stacktrace.\nEvent: ${(0, $cc262db35458e4b3$export$4157119e2b157127)(event)}`);
            return true;
        }
        if ($ed46e39d92a37c80$var$_isDeniedUrl(event, options.denyUrls)) {
            (0, $19fdbaf7f0830971$export$16a28057038b10ef) && (0, $d11ed0b3cdda6b8d$export$1c9f709888824e05).warn(`Event dropped due to being matched by \`denyUrls\` option.\nEvent: ${(0, $cc262db35458e4b3$export$4157119e2b157127)(event)}.\nUrl: ${$ed46e39d92a37c80$var$_getEventFilterUrl(event)}`);
            return true;
        }
        if (!$ed46e39d92a37c80$var$_isAllowedUrl(event, options.allowUrls)) {
            (0, $19fdbaf7f0830971$export$16a28057038b10ef) && (0, $d11ed0b3cdda6b8d$export$1c9f709888824e05).warn(`Event dropped due to not being matched by \`allowUrls\` option.\nEvent: ${(0, $cc262db35458e4b3$export$4157119e2b157127)(event)}.\nUrl: ${$ed46e39d92a37c80$var$_getEventFilterUrl(event)}`);
            return true;
        }
    } else if (event.type === 'transaction') // Filter transactions
    {
        if ($ed46e39d92a37c80$var$_isIgnoredTransaction(event, options.ignoreTransactions)) {
            (0, $19fdbaf7f0830971$export$16a28057038b10ef) && (0, $d11ed0b3cdda6b8d$export$1c9f709888824e05).warn(`Event dropped due to being matched by \`ignoreTransactions\` option.\nEvent: ${(0, $cc262db35458e4b3$export$4157119e2b157127)(event)}`);
            return true;
        }
    }
    return false;
}
function $ed46e39d92a37c80$var$_isIgnoredError(event, ignoreErrors) {
    if (!ignoreErrors?.length) return false;
    return (0, $ac8e718335e141d5$export$d55a97c329cacfcc)(event).some((message)=>(0, $e534db390d1e4996$export$a7a5ec66062ea5d)(message, ignoreErrors));
}
function $ed46e39d92a37c80$var$_isIgnoredTransaction(event, ignoreTransactions) {
    if (!ignoreTransactions?.length) return false;
    const name = event.transaction;
    return name ? (0, $e534db390d1e4996$export$a7a5ec66062ea5d)(name, ignoreTransactions) : false;
}
function $ed46e39d92a37c80$var$_isDeniedUrl(event, denyUrls) {
    if (!denyUrls?.length) return false;
    const url = $ed46e39d92a37c80$var$_getEventFilterUrl(event);
    return !url ? false : (0, $e534db390d1e4996$export$a7a5ec66062ea5d)(url, denyUrls);
}
function $ed46e39d92a37c80$var$_isAllowedUrl(event, allowUrls) {
    if (!allowUrls?.length) return true;
    const url = $ed46e39d92a37c80$var$_getEventFilterUrl(event);
    return !url ? true : (0, $e534db390d1e4996$export$a7a5ec66062ea5d)(url, allowUrls);
}
function $ed46e39d92a37c80$var$_getLastValidUrl(frames = []) {
    for(let i = frames.length - 1; i >= 0; i--){
        const frame = frames[i];
        if (frame && frame.filename !== '<anonymous>' && frame.filename !== '[native code]') return frame.filename || null;
    }
    return null;
}
function $ed46e39d92a37c80$var$_getEventFilterUrl(event) {
    try {
        // If there are linked exceptions or exception aggregates we only want to match against the top frame of the "root" (the main exception)
        // The root always comes last in linked exceptions
        const rootException = [
            ...event.exception?.values ?? []
        ].reverse().find((value)=>value.mechanism?.parent_id === undefined && value.stacktrace?.frames?.length);
        const frames = rootException?.stacktrace?.frames;
        return frames ? $ed46e39d92a37c80$var$_getLastValidUrl(frames) : null;
    } catch  {
        (0, $19fdbaf7f0830971$export$16a28057038b10ef) && (0, $d11ed0b3cdda6b8d$export$1c9f709888824e05).error(`Cannot extract url for event ${(0, $cc262db35458e4b3$export$4157119e2b157127)(event)}`);
        return null;
    }
}
function $ed46e39d92a37c80$var$_isUselessError(event) {
    // We only want to consider events for dropping that actually have recorded exception values.
    if (!event.exception?.values?.length) return false;
    return(// No top-level message
    !event.message && // There are no exception values that have a stacktrace, a non-generic-Error type or value
    !event.exception.values.some((value)=>value.stacktrace || value.type && value.type !== 'Error' || value.value));
}








const $2c574489696f76a6$var$INTEGRATION_NAME = 'ExtraErrorData';
/**
 * Extract additional data for from original exceptions.
 */ const $2c574489696f76a6$var$_extraErrorDataIntegration = (options = {})=>{
    const { depth: depth = 3, captureErrorCause: captureErrorCause = true } = options;
    return {
        name: $2c574489696f76a6$var$INTEGRATION_NAME,
        processEvent (event, hint, client) {
            const { maxValueLength: maxValueLength } = client.getOptions();
            return $2c574489696f76a6$var$_enhanceEventWithErrorData(event, hint, depth, captureErrorCause, maxValueLength);
        }
    };
};
const $2c574489696f76a6$export$6e0872131894301d = (0, $cbb2da6c78246e45$export$2323046b9414659f)($2c574489696f76a6$var$_extraErrorDataIntegration);
function $2c574489696f76a6$var$_enhanceEventWithErrorData(event, hint = {}, depth, captureErrorCause, maxValueLength) {
    if (!hint.originalException || !(0, $13cf2ed412f405fa$export$e6127cc7fe7395c3)(hint.originalException)) return event;
    const exceptionName = hint.originalException.name || hint.originalException.constructor.name;
    const errorData = $2c574489696f76a6$var$_extractErrorData(hint.originalException, captureErrorCause, maxValueLength);
    if (errorData) {
        const contexts = {
            ...event.contexts
        };
        const normalizedErrorData = (0, $2d7134eeb4bc669b$export$a3295358bff77e)(errorData, depth);
        if ((0, $13cf2ed412f405fa$export$53b83ca8eaab0383)(normalizedErrorData)) {
            // We mark the error data as "already normalized" here, because we don't want other normalization procedures to
            // potentially truncate the data we just already normalized, with a certain depth setting.
            (0, $269eeb69635ed414$export$e73679ffaf56810e)(normalizedErrorData, '__sentry_skip_normalization__', true);
            contexts[exceptionName] = normalizedErrorData;
        }
        return {
            ...event,
            contexts: contexts
        };
    }
    return event;
}
/**
 * Extract extra information from the Error object
 */ function $2c574489696f76a6$var$_extractErrorData(error, captureErrorCause, maxValueLength) {
    // We are trying to enhance already existing event, so no harm done if it won't succeed
    try {
        const nativeKeys = [
            'name',
            'message',
            'stack',
            'line',
            'column',
            'fileName',
            'lineNumber',
            'columnNumber',
            'toJSON'
        ];
        const extraErrorInfo = {};
        // We want only enumerable properties, thus `getOwnPropertyNames` is redundant here, as we filter keys anyway.
        for (const key of Object.keys(error)){
            if (nativeKeys.indexOf(key) !== -1) continue;
            const value = error[key];
            extraErrorInfo[key] = (0, $13cf2ed412f405fa$export$e6127cc7fe7395c3)(value) || typeof value === 'string' ? maxValueLength ? (0, $e534db390d1e4996$export$6a506b36fdea397d)(`${value}`, maxValueLength) : `${value}` : value;
        }
        // Error.cause is a standard property that is non enumerable, we therefore need to access it separately.
        // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Error/cause
        if (captureErrorCause && error.cause !== undefined) {
            if ((0, $13cf2ed412f405fa$export$e6127cc7fe7395c3)(error.cause)) {
                const errorName = error.cause.name || error.cause.constructor.name;
                extraErrorInfo.cause = {
                    [errorName]: $2c574489696f76a6$var$_extractErrorData(error.cause, false, maxValueLength)
                };
            } else extraErrorInfo.cause = error.cause;
        }
        // Check if someone attached `toJSON` method to grab even more properties (eg. axios is doing that)
        if (typeof error.toJSON === 'function') {
            const serializedError = error.toJSON();
            for (const key of Object.keys(serializedError)){
                const value = serializedError[key];
                extraErrorInfo[key] = (0, $13cf2ed412f405fa$export$e6127cc7fe7395c3)(value) ? value.toString() : value;
            }
        }
        return extraErrorInfo;
    } catch (oO) {
        (0, $19fdbaf7f0830971$export$16a28057038b10ef) && (0, $d11ed0b3cdda6b8d$export$1c9f709888824e05).error('Unable to extract extra data from the Error object:', oO);
    }
    return null;
}






/**
 * Ordered LRU cache for storing feature flags in the scope context. The name
 * of each flag in the buffer is unique, and the output of getAll() is ordered
 * from oldest to newest.
 */ /**
 * Max size of the LRU flag buffer stored in Sentry scope and event contexts.
 */ const $bd39ef1eacd6c04b$export$55ae3ce75ec4a8a5 = 100;
/**
 * Max number of flag evaluations to record per span.
 */ const $bd39ef1eacd6c04b$export$d742b64c913238d0 = 10;
const $bd39ef1eacd6c04b$var$SPAN_FLAG_ATTRIBUTE_PREFIX = 'flag.evaluation.';
/**
 * Copies feature flags that are in current scope context to the event context
 */ function $bd39ef1eacd6c04b$export$bbaa51f7b5642e0f(event) {
    const scope = (0, $7d48e1ed9f699a01$export$c7be4b0125a10cba)();
    const flagContext = scope.getScopeData().contexts.flags;
    const flagBuffer = flagContext ? flagContext.values : [];
    if (!flagBuffer.length) return event;
    if (event.contexts === undefined) event.contexts = {};
    event.contexts.flags = {
        values: [
            ...flagBuffer
        ]
    };
    return event;
}
/**
 * Inserts a flag into the current scope's context while maintaining ordered LRU properties.
 * Not thread-safe. After inserting:
 * - The flag buffer is sorted in order of recency, with the newest evaluation at the end.
 * - The names in the buffer are always unique.
 * - The length of the buffer never exceeds `maxSize`.
 *
 * @param name     Name of the feature flag to insert.
 * @param value    Value of the feature flag.
 * @param maxSize  Max number of flags the buffer should store. Default value should always be used in production.
 */ function $bd39ef1eacd6c04b$export$8eeb712c9ea5b068(name, value, maxSize = $bd39ef1eacd6c04b$export$55ae3ce75ec4a8a5) {
    const scopeContexts = (0, $7d48e1ed9f699a01$export$c7be4b0125a10cba)().getScopeData().contexts;
    if (!scopeContexts.flags) scopeContexts.flags = {
        values: []
    };
    const flags = scopeContexts.flags.values;
    $bd39ef1eacd6c04b$export$4d53a5a3dfb988d2(flags, name, value, maxSize);
}
/**
 * Exported for tests only. Currently only accepts boolean values (otherwise no-op).
 * Inserts a flag into a FeatureFlag array while maintaining the following properties:
 * - Flags are sorted in order of recency, with the newest evaluation at the end.
 * - The flag names are always unique.
 * - The length of the array never exceeds `maxSize`.
 *
 * @param flags      The buffer to insert the flag into.
 * @param name       Name of the feature flag to insert.
 * @param value      Value of the feature flag.
 * @param maxSize    Max number of flags the buffer should store. Default value should always be used in production.
 */ function $bd39ef1eacd6c04b$export$4d53a5a3dfb988d2(flags, name, value, maxSize) {
    if (typeof value !== 'boolean') return;
    if (flags.length > maxSize) {
        (0, $19fdbaf7f0830971$export$16a28057038b10ef) && (0, $d11ed0b3cdda6b8d$export$1c9f709888824e05).error(`[Feature Flags] insertToFlagBuffer called on a buffer larger than maxSize=${maxSize}`);
        return;
    }
    // Check if the flag is already in the buffer - O(n)
    const index = flags.findIndex((f)=>f.flag === name);
    if (index !== -1) // The flag was found, remove it from its current position - O(n)
    flags.splice(index, 1);
    if (flags.length === maxSize) // If at capacity, pop the earliest flag - O(n)
    flags.shift();
    // Push the flag to the end - O(1)
    flags.push({
        flag: name,
        result: value
    });
}
/**
 * Records a feature flag evaluation for the active span. This is a no-op for non-boolean values.
 * The flag and its value is stored in span attributes with the `flag.evaluation` prefix. Once the
 * unique flags for a span reaches maxFlagsPerSpan, subsequent flags are dropped.
 *
 * @param name             Name of the feature flag.
 * @param value            Value of the feature flag. Non-boolean values are ignored.
 * @param maxFlagsPerSpan  Max number of flags a buffer should store. Default value should always be used in production.
 */ function $bd39ef1eacd6c04b$export$4de324656d9a2858(name, value, maxFlagsPerSpan = $bd39ef1eacd6c04b$export$d742b64c913238d0) {
    if (typeof value !== 'boolean') return;
    const span = (0, $bb9b6447bf4caedb$export$1be426a8e585c83e)();
    if (!span) return;
    const attributes = (0, $bb9b6447bf4caedb$export$92d8c23565496537)(span).data;
    // If the flag already exists, always update it
    if (`${$bd39ef1eacd6c04b$var$SPAN_FLAG_ATTRIBUTE_PREFIX}${name}` in attributes) {
        span.setAttribute(`${$bd39ef1eacd6c04b$var$SPAN_FLAG_ATTRIBUTE_PREFIX}${name}`, value);
        return;
    }
    // Else, add the flag to the span if we have not reached the max number of flags
    const numOfAddedFlags = Object.keys(attributes).filter((key)=>key.startsWith($bd39ef1eacd6c04b$var$SPAN_FLAG_ATTRIBUTE_PREFIX)).length;
    if (numOfAddedFlags < maxFlagsPerSpan) span.setAttribute(`${$bd39ef1eacd6c04b$var$SPAN_FLAG_ATTRIBUTE_PREFIX}${name}`, value);
}


/**
 * Sentry integration for buffering feature flag evaluations manually with an API, and
 * capturing them on error events and spans.
 *
 * See the [feature flag documentation](https://develop.sentry.dev/sdk/expected-features/#feature-flags) for more information.
 *
 * @example
 * ```
 * import * as Sentry from '@sentry/browser';
 * import { type FeatureFlagsIntegration } from '@sentry/browser';
 *
 * // Setup
 * Sentry.init(..., integrations: [Sentry.featureFlagsIntegration()])
 *
 * // Verify
 * const flagsIntegration = Sentry.getClient()?.getIntegrationByName<FeatureFlagsIntegration>('FeatureFlags');
 * if (flagsIntegration) {
 *   flagsIntegration.addFeatureFlag('my-flag', true);
 * } else {
 *   // check your setup
 * }
 * Sentry.captureException(Exception('broke')); // 'my-flag' should be captured to this Sentry event.
 * ```
 */ const $e7c5c9e2c68c679d$export$82a435367bc83944 = (0, $cbb2da6c78246e45$export$2323046b9414659f)(()=>{
    return {
        name: 'FeatureFlags',
        processEvent (event, _hint, _client) {
            return (0, $bd39ef1eacd6c04b$export$bbaa51f7b5642e0f)(event);
        },
        addFeatureFlag (name, value) {
            (0, $bd39ef1eacd6c04b$export$8eeb712c9ea5b068)(name, value);
            (0, $bd39ef1eacd6c04b$export$4de324656d9a2858)(name, value);
        }
    };
});




let $c17712dd9960287e$var$originalFunctionToString;
const $c17712dd9960287e$var$INTEGRATION_NAME = 'FunctionToString';
const $c17712dd9960287e$var$SETUP_CLIENTS = new WeakMap();
const $c17712dd9960287e$var$_functionToStringIntegration = ()=>{
    return {
        name: $c17712dd9960287e$var$INTEGRATION_NAME,
        setupOnce () {
            // eslint-disable-next-line @typescript-eslint/unbound-method
            $c17712dd9960287e$var$originalFunctionToString = Function.prototype.toString;
            // intrinsics (like Function.prototype) might be immutable in some environments
            // e.g. Node with --frozen-intrinsics, XS (an embedded JavaScript engine) or SES (a JavaScript proposal)
            try {
                Function.prototype.toString = function(...args) {
                    const originalFunction = (0, $269eeb69635ed414$export$e6cc1e135e2092e5)(this);
                    const context = $c17712dd9960287e$var$SETUP_CLIENTS.has((0, $7d48e1ed9f699a01$export$6bb76d6eba7e258c)()) && originalFunction !== undefined ? originalFunction : this;
                    return $c17712dd9960287e$var$originalFunctionToString.apply(context, args);
                };
            } catch  {
            // ignore errors here, just don't patch this
            }
        },
        setup (client) {
            $c17712dd9960287e$var$SETUP_CLIENTS.set(client, true);
        }
    };
};
/**
 * Patch toString calls to return proper name for wrapped functions.
 *
 * ```js
 * Sentry.init({
 *   integrations: [
 *     functionToStringIntegration(),
 *   ],
 * });
 * ```
 */ const $c17712dd9960287e$export$7918117e9202e4fb = (0, $cbb2da6c78246e45$export$2323046b9414659f)($c17712dd9960287e$var$_functionToStringIntegration);










/**
 * Extracts trace propagation data from the current span or from the client's scope (via transaction or propagation
 * context) and serializes it to `sentry-trace` and `baggage` values. These values can be used to propagate
 * a trace via our tracing Http headers or Html `<meta>` tags.
 *
 * This function also applies some validation to the generated sentry-trace and baggage values to ensure that
 * only valid strings are returned.
 *
 * If (@param options.propagateTraceparent) is `true`, the function will also generate a `traceparent` value,
 * following the W3C traceparent header format.
 *
 * @returns an object with the tracing data values. The object keys are the name of the tracing key to be used as header
 * or meta tag name.
 */ function $9086b800c08a7b68$export$dec8f001b9d982cb(options = {}) {
    const client = options.client || (0, $7d48e1ed9f699a01$export$6bb76d6eba7e258c)();
    if (!(0, $6918c722b531ff18$export$3b029eb57ac4d562)() || !client) return {};
    const carrier = (0, $e4c75fb63b040566$export$19eade501500c6c1)();
    const acs = (0, $a8b8acc568359454$export$f639b0c2752203be)(carrier);
    if (acs.getTraceData) return acs.getTraceData(options);
    const scope = options.scope || (0, $7d48e1ed9f699a01$export$c7be4b0125a10cba)();
    const span = options.span || (0, $bb9b6447bf4caedb$export$1be426a8e585c83e)();
    const sentryTrace = span ? (0, $bb9b6447bf4caedb$export$7e9f8ae9e4a328ab)(span) : $9086b800c08a7b68$var$scopeToTraceHeader(scope);
    const dsc = span ? (0, $09fae5ef8120e803$export$a117f995597e25df)(span) : (0, $09fae5ef8120e803$export$89ef1736f08c6b2b)(client, scope);
    const baggage = (0, $8ef2851bd0adcf53$export$56766feef403f365)(dsc);
    const isValidSentryTraceHeader = (0, $bcc4fe773b74e41d$export$394a210812ba3012).test(sentryTrace);
    if (!isValidSentryTraceHeader) {
        (0, $d11ed0b3cdda6b8d$export$1c9f709888824e05).warn('Invalid sentry-trace data. Cannot generate trace data');
        return {};
    }
    const traceData = {
        'sentry-trace': sentryTrace,
        baggage: baggage
    };
    if (options.propagateTraceparent) traceData.traceparent = span ? (0, $bb9b6447bf4caedb$export$cda58d87bc594e9f)(span) : $9086b800c08a7b68$var$scopeToTraceparentHeader(scope);
    return traceData;
}
/**
 * Get a sentry-trace header value for the given scope.
 */ function $9086b800c08a7b68$var$scopeToTraceHeader(scope) {
    const { traceId: traceId, sampled: sampled, propagationSpanId: propagationSpanId } = scope.getPropagationContext();
    return (0, $bcc4fe773b74e41d$export$f35d907436da45cf)(traceId, propagationSpanId, sampled);
}
function $9086b800c08a7b68$var$scopeToTraceparentHeader(scope) {
    const { traceId: traceId, sampled: sampled, propagationSpanId: propagationSpanId } = scope.getPropagationContext();
    return (0, $bcc4fe773b74e41d$export$1aff3752542747dd)(traceId, propagationSpanId, sampled);
}
















const $d9b30917cc8d6cd3$export$68e9bbb16d93c936 = 'Anthropic_AI';
// https://docs.anthropic.com/en/api/messages
// https://docs.anthropic.com/en/api/models-list
const $d9b30917cc8d6cd3$export$47a8318acb3cba38 = [
    'messages.create',
    'messages.stream',
    'messages.countTokens',
    'models.get',
    'completions.create',
    'models.retrieve',
    'beta.messages.create'
];


/**
 * Check if a method path should be instrumented
 */ function $2b0e24f3cd716568$export$f5188c19ec4120e7(methodPath) {
    return (0, $d9b30917cc8d6cd3$export$47a8318acb3cba38).includes(methodPath);
}
/**
 * Set the messages and messages original length attributes.
 * Extracts system instructions before truncation.
 */ function $2b0e24f3cd716568$export$a7ddbb31eff84968(span, messages) {
    if (Array.isArray(messages) && messages.length === 0) return;
    const { systemInstructions: systemInstructions, filteredMessages: filteredMessages } = (0, $33812c936a44f60e$export$d259f1ba7bd7cfce)(messages);
    if (systemInstructions) span.setAttributes({
        [(0, $69c5419d32efeaea$export$461510d48ed1f51d)]: systemInstructions
    });
    const filteredLength = Array.isArray(filteredMessages) ? filteredMessages.length : 1;
    span.setAttributes({
        [(0, $69c5419d32efeaea$export$b36434f4adcd5fb0)]: (0, $33812c936a44f60e$export$5b065884ce77f65e)(filteredMessages),
        [(0, $69c5419d32efeaea$export$ca7610de76ac1c3f)]: filteredLength
    });
}
const $2b0e24f3cd716568$var$ANTHROPIC_ERROR_TYPE_TO_SPAN_STATUS = {
    invalid_request_error: 'invalid_argument',
    authentication_error: 'unauthenticated',
    permission_error: 'permission_denied',
    not_found_error: 'not_found',
    request_too_large: 'failed_precondition',
    rate_limit_error: 'resource_exhausted',
    api_error: 'internal_error',
    overloaded_error: 'unavailable'
};
/**
 * Map an Anthropic API error type to a SpanStatusType value.
 * @see https://docs.anthropic.com/en/api/errors#error-shapes
 */ function $2b0e24f3cd716568$export$a59805468c3f8483(errorType) {
    if (!errorType) return 'internal_error';
    return $2b0e24f3cd716568$var$ANTHROPIC_ERROR_TYPE_TO_SPAN_STATUS[errorType] || 'internal_error';
}
/**
 * Capture error information from the response
 * @see https://docs.anthropic.com/en/api/errors#error-shapes
 */ function $2b0e24f3cd716568$export$1a2565ab2f8c2ac2(span, response) {
    if (response.error) {
        span.setStatus({
            code: (0, $fda37f10dc06a152$export$f966a0446ece71e),
            message: $2b0e24f3cd716568$export$a59805468c3f8483(response.error.type)
        });
        (0, $6918c722b531ff18$export$f5282963edea4a68)(response.error, {
            mechanism: {
                handled: false,
                type: 'auto.ai.anthropic.anthropic_error'
            }
        });
    }
}
/**
 * Include the system prompt in the messages list, if available
 */ function $2b0e24f3cd716568$export$549a0734c9de367c(params) {
    const { system: system, messages: messages, input: input } = params;
    const systemMessages = typeof system === 'string' ? [
        {
            role: 'system',
            content: params.system
        }
    ] : [];
    const inputParamMessages = Array.isArray(input) ? input : input != null ? [
        input
    ] : undefined;
    const messagesParamMessages = Array.isArray(messages) ? messages : messages != null ? [
        messages
    ] : [];
    const userMessages = inputParamMessages ?? messagesParamMessages;
    return [
        ...systemMessages,
        ...userMessages
    ];
}


/**
 * State object used to accumulate information from a stream of Anthropic AI events.
 */ /**
 * Checks if an event is an error event
 * @param event - The event to process
 * @param state - The state of the streaming process
 * @param recordOutputs - Whether to record outputs
 * @param span - The span to update
 * @returns Whether an error occurred
 */ function $2635b2658404f0e2$var$isErrorEvent(event, span) {
    if ('type' in event && typeof event.type === 'string') // If the event is an error, set the span status and capture the error
    // These error events are not rejected by the API by default, but are sent as metadata of the response
    {
        if (event.type === 'error') {
            span.setStatus({
                code: (0, $fda37f10dc06a152$export$f966a0446ece71e),
                message: (0, $2b0e24f3cd716568$export$a59805468c3f8483)(event.error?.type)
            });
            (0, $6918c722b531ff18$export$f5282963edea4a68)(event.error, {
                mechanism: {
                    handled: false,
                    type: 'auto.ai.anthropic.anthropic_error'
                }
            });
            return true;
        }
    }
    return false;
}
/**
 * Processes the message metadata of an event
 * @param event - The event to process
 * @param state - The state of the streaming process
 */ function $2635b2658404f0e2$var$handleMessageMetadata(event, state) {
    // The token counts shown in the usage field of the message_delta event are cumulative.
    // @see https://docs.anthropic.com/en/docs/build-with-claude/streaming#event-types
    if (event.type === 'message_delta' && event.usage) {
        if ('output_tokens' in event.usage && typeof event.usage.output_tokens === 'number') state.completionTokens = event.usage.output_tokens;
    }
    if (event.message) {
        const message = event.message;
        if (message.id) state.responseId = message.id;
        if (message.model) state.responseModel = message.model;
        if (message.stop_reason) state.finishReasons.push(message.stop_reason);
        if (message.usage) {
            if (typeof message.usage.input_tokens === 'number') state.promptTokens = message.usage.input_tokens;
            if (typeof message.usage.cache_creation_input_tokens === 'number') state.cacheCreationInputTokens = message.usage.cache_creation_input_tokens;
            if (typeof message.usage.cache_read_input_tokens === 'number') state.cacheReadInputTokens = message.usage.cache_read_input_tokens;
        }
    }
}
/**
 * Handle start of a content block (e.g., tool_use)
 */ function $2635b2658404f0e2$var$handleContentBlockStart(event, state) {
    if (event.type !== 'content_block_start' || typeof event.index !== 'number' || !event.content_block) return;
    if (event.content_block.type === 'tool_use' || event.content_block.type === 'server_tool_use') state.activeToolBlocks[event.index] = {
        id: event.content_block.id,
        name: event.content_block.name,
        inputJsonParts: []
    };
}
/**
 * Handle deltas of a content block, including input_json_delta for tool_use
 */ function $2635b2658404f0e2$var$handleContentBlockDelta(event, state, recordOutputs) {
    if (event.type !== 'content_block_delta' || !event.delta) return;
    // Accumulate tool_use input JSON deltas only when we have an index and an active tool block
    if (typeof event.index === 'number' && 'partial_json' in event.delta && typeof event.delta.partial_json === 'string') {
        const active = state.activeToolBlocks[event.index];
        if (active) active.inputJsonParts.push(event.delta.partial_json);
    }
    // Accumulate streamed response text regardless of index
    if (recordOutputs && typeof event.delta.text === 'string') state.responseTexts.push(event.delta.text);
}
/**
 * Handle stop of a content block; finalize tool_use entries
 */ function $2635b2658404f0e2$var$handleContentBlockStop(event, state) {
    if (event.type !== 'content_block_stop' || typeof event.index !== 'number') return;
    const active = state.activeToolBlocks[event.index];
    if (!active) return;
    const raw = active.inputJsonParts.join('');
    let parsedInput;
    try {
        parsedInput = raw ? JSON.parse(raw) : {};
    } catch  {
        parsedInput = {
            __unparsed: raw
        };
    }
    state.toolCalls.push({
        type: 'tool_use',
        id: active.id,
        name: active.name,
        input: parsedInput
    });
    // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
    delete state.activeToolBlocks[event.index];
}
/**
 * Processes an event
 * @param event - The event to process
 * @param state - The state of the streaming process
 * @param recordOutputs - Whether to record outputs
 * @param span - The span to update
 */ function $2635b2658404f0e2$var$processEvent(event, state, recordOutputs, span) {
    if (!(event && typeof event === 'object')) return;
    const isError = $2635b2658404f0e2$var$isErrorEvent(event, span);
    if (isError) return;
    $2635b2658404f0e2$var$handleMessageMetadata(event, state);
    // Tool call events are sent via 3 separate events:
    // - content_block_start (start of the tool call)
    // - content_block_delta (delta aka input of the tool call)
    // - content_block_stop (end of the tool call)
    // We need to handle them all to capture the full tool call.
    $2635b2658404f0e2$var$handleContentBlockStart(event, state);
    $2635b2658404f0e2$var$handleContentBlockDelta(event, state, recordOutputs);
    $2635b2658404f0e2$var$handleContentBlockStop(event, state);
}
/**
 * Finalizes span attributes when stream processing completes
 */ function $2635b2658404f0e2$var$finalizeStreamSpan(state, span, recordOutputs) {
    if (!span.isRecording()) return;
    // Set common response attributes if available
    if (state.responseId) span.setAttributes({
        [(0, $69c5419d32efeaea$export$1e55ab213eb8e5dc)]: state.responseId
    });
    if (state.responseModel) span.setAttributes({
        [(0, $69c5419d32efeaea$export$91aa8d4aaebb3840)]: state.responseModel
    });
    (0, $33812c936a44f60e$export$8130c966fa864943)(span, state.promptTokens, state.completionTokens, state.cacheCreationInputTokens, state.cacheReadInputTokens);
    span.setAttributes({
        [(0, $69c5419d32efeaea$export$e7360a81bbfe9c78)]: true
    });
    if (state.finishReasons.length > 0) span.setAttributes({
        [(0, $69c5419d32efeaea$export$8778ccf58aa04820)]: JSON.stringify(state.finishReasons)
    });
    if (recordOutputs && state.responseTexts.length > 0) span.setAttributes({
        [(0, $69c5419d32efeaea$export$2478fd72313ce319)]: state.responseTexts.join('')
    });
    // Set tool calls if any were captured
    if (recordOutputs && state.toolCalls.length > 0) span.setAttributes({
        [(0, $69c5419d32efeaea$export$c6bace6b76d93a0)]: JSON.stringify(state.toolCalls)
    });
    span.end();
}
/**
 * Instruments an async iterable stream of Anthropic events, updates the span with
 * streaming attributes and (optionally) the aggregated output text, and yields
 * each event from the input stream unchanged.
 */ async function* $2635b2658404f0e2$export$fbf12b1f0370a6ef(stream, span, recordOutputs) {
    const state = {
        responseTexts: [],
        finishReasons: [],
        responseId: '',
        responseModel: '',
        promptTokens: undefined,
        completionTokens: undefined,
        cacheCreationInputTokens: undefined,
        cacheReadInputTokens: undefined,
        toolCalls: [],
        activeToolBlocks: {}
    };
    try {
        for await (const event of stream){
            $2635b2658404f0e2$var$processEvent(event, state, recordOutputs, span);
            yield event;
        }
    } finally{
        // Set common response attributes if available
        if (state.responseId) span.setAttributes({
            [(0, $69c5419d32efeaea$export$1e55ab213eb8e5dc)]: state.responseId
        });
        if (state.responseModel) span.setAttributes({
            [(0, $69c5419d32efeaea$export$91aa8d4aaebb3840)]: state.responseModel
        });
        (0, $33812c936a44f60e$export$8130c966fa864943)(span, state.promptTokens, state.completionTokens, state.cacheCreationInputTokens, state.cacheReadInputTokens);
        span.setAttributes({
            [(0, $69c5419d32efeaea$export$e7360a81bbfe9c78)]: true
        });
        if (state.finishReasons.length > 0) span.setAttributes({
            [(0, $69c5419d32efeaea$export$8778ccf58aa04820)]: JSON.stringify(state.finishReasons)
        });
        if (recordOutputs && state.responseTexts.length > 0) span.setAttributes({
            [(0, $69c5419d32efeaea$export$2478fd72313ce319)]: state.responseTexts.join('')
        });
        // Set tool calls if any were captured
        if (recordOutputs && state.toolCalls.length > 0) span.setAttributes({
            [(0, $69c5419d32efeaea$export$c6bace6b76d93a0)]: JSON.stringify(state.toolCalls)
        });
        span.end();
    }
}
/**
 * Instruments a MessageStream by registering event handlers and preserving the original stream API.
 */ function $2635b2658404f0e2$export$9c6295bd2b777e7(stream, span, recordOutputs) {
    const state = {
        responseTexts: [],
        finishReasons: [],
        responseId: '',
        responseModel: '',
        promptTokens: undefined,
        completionTokens: undefined,
        cacheCreationInputTokens: undefined,
        cacheReadInputTokens: undefined,
        toolCalls: [],
        activeToolBlocks: {}
    };
    stream.on('streamEvent', (event)=>{
        $2635b2658404f0e2$var$processEvent(event, state, recordOutputs, span);
    });
    // The event fired when a message is done being streamed by the API. Corresponds to the message_stop SSE event.
    // @see https://github.com/anthropics/anthropic-sdk-typescript/blob/d3be31f5a4e6ebb4c0a2f65dbb8f381ae73a9166/helpers.md?plain=1#L42-L44
    stream.on('message', ()=>{
        $2635b2658404f0e2$var$finalizeStreamSpan(state, span, recordOutputs);
    });
    stream.on('error', (error)=>{
        (0, $6918c722b531ff18$export$f5282963edea4a68)(error, {
            mechanism: {
                handled: false,
                type: 'auto.ai.anthropic.stream_error'
            }
        });
        if (span.isRecording()) {
            span.setStatus({
                code: (0, $fda37f10dc06a152$export$f966a0446ece71e),
                message: 'internal_error'
            });
            span.end();
        }
    });
    return stream;
}



/**
 * Extract request attributes from method arguments
 */ function $a28471a03541153d$var$extractRequestAttributes(args, methodPath) {
    const attributes = {
        [(0, $69c5419d32efeaea$export$234b82df5670ccbb)]: 'anthropic',
        [(0, $69c5419d32efeaea$export$d4b9e945d503aff)]: (0, $33812c936a44f60e$export$101a096156a912de)(methodPath),
        [(0, $f337c80285f06f80$export$cca8dd30f57f805e)]: 'auto.ai.anthropic'
    };
    if (args.length > 0 && typeof args[0] === 'object' && args[0] !== null) {
        const params = args[0];
        if (params.tools && Array.isArray(params.tools)) attributes[0, $69c5419d32efeaea$export$b84797a509e2c15] = JSON.stringify(params.tools);
        attributes[0, $69c5419d32efeaea$export$e3834bc5d4a6f8a5] = params.model ?? 'unknown';
        if ('temperature' in params) attributes[0, $69c5419d32efeaea$export$84ab1c0a4a1402ec] = params.temperature;
        if ('top_p' in params) attributes[0, $69c5419d32efeaea$export$be752be64ca500f6] = params.top_p;
        if ('stream' in params) attributes[0, $69c5419d32efeaea$export$f8a1e9006f7a3c18] = params.stream;
        if ('top_k' in params) attributes[0, $69c5419d32efeaea$export$ff1aa255ac4733b] = params.top_k;
        if ('frequency_penalty' in params) attributes[0, $69c5419d32efeaea$export$58b9b1cd46b4bb5e] = params.frequency_penalty;
        if ('max_tokens' in params) attributes[0, $69c5419d32efeaea$export$6affc15741e97c5c] = params.max_tokens;
    } else if (methodPath === 'models.retrieve' || methodPath === 'models.get') // models.retrieve(model-id) and models.get(model-id)
    attributes[0, $69c5419d32efeaea$export$e3834bc5d4a6f8a5] = args[0];
    else attributes[0, $69c5419d32efeaea$export$e3834bc5d4a6f8a5] = 'unknown';
    return attributes;
}
/**
 * Add private request attributes to spans.
 * This is only recorded if recordInputs is true.
 */ function $a28471a03541153d$var$addPrivateRequestAttributes(span, params) {
    const messages = (0, $2b0e24f3cd716568$export$549a0734c9de367c)(params);
    (0, $2b0e24f3cd716568$export$a7ddbb31eff84968)(span, messages);
    if ('prompt' in params) span.setAttributes({
        [(0, $69c5419d32efeaea$export$7c08d2884b5eed2e)]: JSON.stringify(params.prompt)
    });
}
/**
 * Add content attributes when recordOutputs is enabled
 */ function $a28471a03541153d$var$addContentAttributes(span, response) {
    // Messages.create
    if ('content' in response) {
        if (Array.isArray(response.content)) {
            span.setAttributes({
                [(0, $69c5419d32efeaea$export$2478fd72313ce319)]: response.content.map((item)=>item.text).filter((text)=>!!text).join('')
            });
            const toolCalls = [];
            for (const item of response.content)if (item.type === 'tool_use' || item.type === 'server_tool_use') toolCalls.push(item);
            if (toolCalls.length > 0) span.setAttributes({
                [(0, $69c5419d32efeaea$export$c6bace6b76d93a0)]: JSON.stringify(toolCalls)
            });
        }
    }
    // Completions.create
    if ('completion' in response) span.setAttributes({
        [(0, $69c5419d32efeaea$export$2478fd72313ce319)]: response.completion
    });
    // Models.countTokens
    if ('input_tokens' in response) span.setAttributes({
        [(0, $69c5419d32efeaea$export$2478fd72313ce319)]: JSON.stringify(response.input_tokens)
    });
}
/**
 * Add basic metadata attributes from the response
 */ function $a28471a03541153d$var$addMetadataAttributes(span, response) {
    if ('id' in response && 'model' in response) {
        span.setAttributes({
            [(0, $69c5419d32efeaea$export$1e55ab213eb8e5dc)]: response.id,
            [(0, $69c5419d32efeaea$export$91aa8d4aaebb3840)]: response.model
        });
        if ('created' in response && typeof response.created === 'number') span.setAttributes({
            [(0, $69c5419d32efeaea$export$edffc94e6f22e963)]: new Date(response.created * 1000).toISOString()
        });
        if ('created_at' in response && typeof response.created_at === 'number') span.setAttributes({
            [(0, $69c5419d32efeaea$export$edffc94e6f22e963)]: new Date(response.created_at * 1000).toISOString()
        });
        if ('usage' in response && response.usage) (0, $33812c936a44f60e$export$8130c966fa864943)(span, response.usage.input_tokens, response.usage.output_tokens, response.usage.cache_creation_input_tokens, response.usage.cache_read_input_tokens);
    }
}
/**
 * Add response attributes to spans
 */ function $a28471a03541153d$var$addResponseAttributes(span, response, recordOutputs) {
    if (!response || typeof response !== 'object') return;
    // capture error, do not add attributes if error (they shouldn't exist)
    if ('type' in response && response.type === 'error') {
        (0, $2b0e24f3cd716568$export$1a2565ab2f8c2ac2)(span, response);
        return;
    }
    // Private response attributes that are only recorded if recordOutputs is true.
    if (recordOutputs) $a28471a03541153d$var$addContentAttributes(span, response);
    // Add basic metadata attributes
    $a28471a03541153d$var$addMetadataAttributes(span, response);
}
/**
 * Handle common error catching and reporting for streaming requests
 */ function $a28471a03541153d$var$handleStreamingError(error, span, methodPath) {
    (0, $6918c722b531ff18$export$f5282963edea4a68)(error, {
        mechanism: {
            handled: false,
            type: 'auto.ai.anthropic',
            data: {
                function: methodPath
            }
        }
    });
    if (span.isRecording()) {
        span.setStatus({
            code: (0, $fda37f10dc06a152$export$f966a0446ece71e),
            message: 'internal_error'
        });
        span.end();
    }
    throw error;
}
/**
 * Handle streaming cases with common logic
 */ function $a28471a03541153d$var$handleStreamingRequest(originalMethod, target, context, args, requestAttributes, operationName, methodPath, params, options, isStreamRequested, isStreamingMethod) {
    const model = requestAttributes[0, $69c5419d32efeaea$export$e3834bc5d4a6f8a5] ?? 'unknown';
    const spanConfig = {
        name: `${operationName} ${model}`,
        op: (0, $33812c936a44f60e$export$5e8bff7a65941113)(methodPath),
        attributes: requestAttributes
    };
    // messages.stream() always returns a sync MessageStream, even with stream: true param
    if (isStreamRequested && !isStreamingMethod) return (0, $c9161b67125aefc1$export$c10292ad04b92aea)(spanConfig, async (span)=>{
        try {
            if (options.recordInputs && params) $a28471a03541153d$var$addPrivateRequestAttributes(span, params);
            const result = await originalMethod.apply(context, args);
            return (0, $2635b2658404f0e2$export$fbf12b1f0370a6ef)(result, span, options.recordOutputs ?? false);
        } catch (error) {
            return $a28471a03541153d$var$handleStreamingError(error, span, methodPath);
        }
    });
    else return (0, $c9161b67125aefc1$export$c10292ad04b92aea)(spanConfig, (span)=>{
        try {
            if (options.recordInputs && params) $a28471a03541153d$var$addPrivateRequestAttributes(span, params);
            const messageStream = target.apply(context, args);
            return (0, $2635b2658404f0e2$export$9c6295bd2b777e7)(messageStream, span, options.recordOutputs ?? false);
        } catch (error) {
            return $a28471a03541153d$var$handleStreamingError(error, span, methodPath);
        }
    });
}
/**
 * Instrument a method with Sentry spans
 * Following Sentry AI Agents Manual Instrumentation conventions
 * @see https://docs.sentry.io/platforms/javascript/guides/node/tracing/instrumentation/ai-agents-module/#manual-instrumentation
 */ function $a28471a03541153d$var$instrumentMethod(originalMethod, methodPath, context, options) {
    return new Proxy(originalMethod, {
        apply (target, thisArg, args) {
            const requestAttributes = $a28471a03541153d$var$extractRequestAttributes(args, methodPath);
            const model = requestAttributes[0, $69c5419d32efeaea$export$e3834bc5d4a6f8a5] ?? 'unknown';
            const operationName = (0, $33812c936a44f60e$export$101a096156a912de)(methodPath);
            const params = typeof args[0] === 'object' ? args[0] : undefined;
            const isStreamRequested = Boolean(params?.stream);
            const isStreamingMethod = methodPath === 'messages.stream';
            if (isStreamRequested || isStreamingMethod) return $a28471a03541153d$var$handleStreamingRequest(originalMethod, target, context, args, requestAttributes, operationName, methodPath, params, options, isStreamRequested, isStreamingMethod);
            return (0, $c9161b67125aefc1$export$a1bd95187356f372)({
                name: `${operationName} ${model}`,
                op: (0, $33812c936a44f60e$export$5e8bff7a65941113)(methodPath),
                attributes: requestAttributes
            }, (span)=>{
                if (options.recordInputs && params) $a28471a03541153d$var$addPrivateRequestAttributes(span, params);
                return (0, $2c3cb4034c24252d$export$18ce21a8b7efd7e9)(()=>target.apply(context, args), (error)=>{
                    (0, $6918c722b531ff18$export$f5282963edea4a68)(error, {
                        mechanism: {
                            handled: false,
                            type: 'auto.ai.anthropic',
                            data: {
                                function: methodPath
                            }
                        }
                    });
                }, ()=>{}, (result)=>$a28471a03541153d$var$addResponseAttributes(span, result, options.recordOutputs));
            });
        }
    });
}
/**
 * Create a deep proxy for Anthropic AI client instrumentation
 */ function $a28471a03541153d$var$createDeepProxy(target, currentPath = '', options) {
    return new Proxy(target, {
        get (obj, prop) {
            const value = obj[prop];
            const methodPath = (0, $33812c936a44f60e$export$d7a5998392457f14)(currentPath, String(prop));
            if (typeof value === 'function' && (0, $2b0e24f3cd716568$export$f5188c19ec4120e7)(methodPath)) return $a28471a03541153d$var$instrumentMethod(value, methodPath, obj, options);
            if (typeof value === 'function') // Bind non-instrumented functions to preserve the original `this` context,
            return value.bind(obj);
            if (value && typeof value === 'object') return $a28471a03541153d$var$createDeepProxy(value, methodPath, options);
            return value;
        }
    });
}
/**
 * Instrument an Anthropic AI client with Sentry tracing
 * Can be used across Node.js, Cloudflare Workers, and Vercel Edge
 *
 * @template T - The type of the client that extends object
 * @param client - The Anthropic AI client to instrument
 * @param options - Optional configuration for recording inputs and outputs
 * @returns The instrumented client with the same type as the input
 */ function $a28471a03541153d$export$242eaf446eac1fc8(anthropicAiClient, options) {
    return $a28471a03541153d$var$createDeepProxy(anthropicAiClient, '', (0, $33812c936a44f60e$export$ac4bb282bdbe5b74)(options));
}









const $a3fd0a07386c007c$export$6992028415038645 = 'Google_GenAI';
// https://ai.google.dev/api/rest/v1/models/generateContent
// https://ai.google.dev/api/rest/v1/chats/sendMessage
// https://googleapis.github.io/js-genai/release_docs/classes/models.Models.html#generatecontentstream
// https://googleapis.github.io/js-genai/release_docs/classes/chats.Chat.html#sendmessagestream
const $a3fd0a07386c007c$export$ae5188e516897e32 = [
    'models.generateContent',
    'models.generateContentStream',
    'chats.create',
    'sendMessage',
    'sendMessageStream'
];
// Constants for internal use
const $a3fd0a07386c007c$export$62167d33504987c = 'google_genai';
const $a3fd0a07386c007c$export$7e1ce396edc0ad57 = 'chats.create';
const $a3fd0a07386c007c$export$54306dc3a5fddc77 = 'chat';





/**
 * State object used to accumulate information from a stream of Google GenAI events.
 */ /**
 * Checks if a response chunk contains an error
 * @param chunk - The response chunk to check
 * @param span - The span to update if error is found
 * @returns Whether an error occurred
 */ function $03fcd49778c67e56$var$isErrorChunk(chunk, span) {
    const feedback = chunk?.promptFeedback;
    if (feedback?.blockReason) {
        const message = feedback.blockReasonMessage ?? feedback.blockReason;
        span.setStatus({
            code: (0, $fda37f10dc06a152$export$f966a0446ece71e),
            message: 'internal_error'
        });
        (0, $6918c722b531ff18$export$f5282963edea4a68)(`Content blocked: ${message}`, {
            mechanism: {
                handled: false,
                type: 'auto.ai.google_genai'
            }
        });
        return true;
    }
    return false;
}
/**
 * Processes response metadata from a chunk
 * @param chunk - The response chunk to process
 * @param state - The state of the streaming process
 */ function $03fcd49778c67e56$var$handleResponseMetadata(chunk, state) {
    if (typeof chunk.responseId === 'string') state.responseId = chunk.responseId;
    if (typeof chunk.modelVersion === 'string') state.responseModel = chunk.modelVersion;
    const usage = chunk.usageMetadata;
    if (usage) {
        if (typeof usage.promptTokenCount === 'number') state.promptTokens = usage.promptTokenCount;
        if (typeof usage.candidatesTokenCount === 'number') state.completionTokens = usage.candidatesTokenCount;
        if (typeof usage.totalTokenCount === 'number') state.totalTokens = usage.totalTokenCount;
    }
}
/**
 * Processes candidate content from a response chunk
 * @param chunk - The response chunk to process
 * @param state - The state of the streaming process
 * @param recordOutputs - Whether to record outputs
 */ function $03fcd49778c67e56$var$handleCandidateContent(chunk, state, recordOutputs) {
    if (Array.isArray(chunk.functionCalls)) state.toolCalls.push(...chunk.functionCalls);
    for (const candidate of chunk.candidates ?? []){
        if (candidate?.finishReason && !state.finishReasons.includes(candidate.finishReason)) state.finishReasons.push(candidate.finishReason);
        for (const part of candidate?.content?.parts ?? []){
            if (recordOutputs && part.text) state.responseTexts.push(part.text);
            if (part.functionCall) state.toolCalls.push({
                type: 'function',
                id: part.functionCall.id,
                name: part.functionCall.name,
                arguments: part.functionCall.args
            });
        }
    }
}
/**
 * Processes a single chunk from the Google GenAI stream
 * @param chunk - The chunk to process
 * @param state - The state of the streaming process
 * @param recordOutputs - Whether to record outputs
 * @param span - The span to update
 */ function $03fcd49778c67e56$var$processChunk(chunk, state, recordOutputs, span) {
    if (!chunk || $03fcd49778c67e56$var$isErrorChunk(chunk, span)) return;
    $03fcd49778c67e56$var$handleResponseMetadata(chunk, state);
    $03fcd49778c67e56$var$handleCandidateContent(chunk, state, recordOutputs);
}
/**
 * Instruments an async iterable stream of Google GenAI response chunks, updates the span with
 * streaming attributes and (optionally) the aggregated output text, and yields
 * each chunk from the input stream unchanged.
 */ async function* $03fcd49778c67e56$export$b764c730176bd1aa(stream, span, recordOutputs) {
    const state = {
        responseTexts: [],
        finishReasons: [],
        toolCalls: []
    };
    try {
        for await (const chunk of stream){
            $03fcd49778c67e56$var$processChunk(chunk, state, recordOutputs, span);
            yield chunk;
        }
    } finally{
        const attrs = {
            [(0, $69c5419d32efeaea$export$e7360a81bbfe9c78)]: true
        };
        if (state.responseId) attrs[0, $69c5419d32efeaea$export$1e55ab213eb8e5dc] = state.responseId;
        if (state.responseModel) attrs[0, $69c5419d32efeaea$export$91aa8d4aaebb3840] = state.responseModel;
        if (state.promptTokens !== undefined) attrs[0, $69c5419d32efeaea$export$ad91d91220026940] = state.promptTokens;
        if (state.completionTokens !== undefined) attrs[0, $69c5419d32efeaea$export$84cd977981922116] = state.completionTokens;
        if (state.totalTokens !== undefined) attrs[0, $69c5419d32efeaea$export$60599e5371c06255] = state.totalTokens;
        if (state.finishReasons.length) attrs[0, $69c5419d32efeaea$export$8778ccf58aa04820] = JSON.stringify(state.finishReasons);
        if (recordOutputs && state.responseTexts.length) attrs[0, $69c5419d32efeaea$export$2478fd72313ce319] = state.responseTexts.join('');
        if (recordOutputs && state.toolCalls.length) attrs[0, $69c5419d32efeaea$export$c6bace6b76d93a0] = JSON.stringify(state.toolCalls);
        span.setAttributes(attrs);
        span.end();
    }
}



/**
 * Check if a method path should be instrumented
 */ function $669894d989309123$export$f5188c19ec4120e7(methodPath) {
    // Check for exact matches first (like 'models.generateContent')
    if ((0, $a3fd0a07386c007c$export$ae5188e516897e32).includes(methodPath)) return true;
    // Check for method name matches (like 'sendMessage' from chat instances)
    const methodName = methodPath.split('.').pop();
    return (0, $a3fd0a07386c007c$export$ae5188e516897e32).includes(methodName);
}
/**
 * Check if a method is a streaming method
 */ function $669894d989309123$export$b4dd0280e89e6f73(methodPath) {
    return methodPath.includes('Stream');
}
// Copied from https://googleapis.github.io/js-genai/release_docs/index.html
/**
 *
 */ function $669894d989309123$export$f28e49b6692abcb6(content, role = 'user') {
    if (typeof content === 'string') return [
        {
            role: role,
            content: content
        }
    ];
    if (Array.isArray(content)) return content.flatMap((content)=>$669894d989309123$export$f28e49b6692abcb6(content, role));
    if (typeof content !== 'object' || !content) return [];
    if ('role' in content && typeof content.role === 'string') return [
        content
    ];
    if ('parts' in content) return [
        {
            ...content,
            role: role
        }
    ];
    return [
        {
            role: role,
            content: content
        }
    ];
}


/**
 * Extract model from parameters or chat context object
 * For chat instances, the model is available on the chat object as 'model' (older versions) or 'modelVersion' (newer versions)
 */ function $6dc281ceafe4c8ab$export$6ce6ed2df35aa8ea(params, context) {
    if ('model' in params && typeof params.model === 'string') return params.model;
    // Try to get model from chat context object (chat instance has model property)
    if (context && typeof context === 'object') {
        const contextObj = context;
        // Check for 'model' property (older versions, and streaming)
        if ('model' in contextObj && typeof contextObj.model === 'string') return contextObj.model;
        // Check for 'modelVersion' property (newer versions)
        if ('modelVersion' in contextObj && typeof contextObj.modelVersion === 'string') return contextObj.modelVersion;
    }
    return 'unknown';
}
/**
 * Extract generation config parameters
 */ function $6dc281ceafe4c8ab$var$extractConfigAttributes(config) {
    const attributes = {};
    if ('temperature' in config && typeof config.temperature === 'number') attributes[0, $69c5419d32efeaea$export$84ab1c0a4a1402ec] = config.temperature;
    if ('topP' in config && typeof config.topP === 'number') attributes[0, $69c5419d32efeaea$export$be752be64ca500f6] = config.topP;
    if ('topK' in config && typeof config.topK === 'number') attributes[0, $69c5419d32efeaea$export$ff1aa255ac4733b] = config.topK;
    if ('maxOutputTokens' in config && typeof config.maxOutputTokens === 'number') attributes[0, $69c5419d32efeaea$export$6affc15741e97c5c] = config.maxOutputTokens;
    if ('frequencyPenalty' in config && typeof config.frequencyPenalty === 'number') attributes[0, $69c5419d32efeaea$export$58b9b1cd46b4bb5e] = config.frequencyPenalty;
    if ('presencePenalty' in config && typeof config.presencePenalty === 'number') attributes[0, $69c5419d32efeaea$export$66b1150b23e1da44] = config.presencePenalty;
    return attributes;
}
/**
 * Extract request attributes from method arguments
 * Builds the base attributes for span creation including system info, model, and config
 */ function $6dc281ceafe4c8ab$var$extractRequestAttributes(methodPath, params, context) {
    const attributes = {
        [(0, $69c5419d32efeaea$export$234b82df5670ccbb)]: (0, $a3fd0a07386c007c$export$62167d33504987c),
        [(0, $69c5419d32efeaea$export$d4b9e945d503aff)]: (0, $33812c936a44f60e$export$101a096156a912de)(methodPath),
        [(0, $f337c80285f06f80$export$cca8dd30f57f805e)]: 'auto.ai.google_genai'
    };
    if (params) {
        attributes[0, $69c5419d32efeaea$export$e3834bc5d4a6f8a5] = $6dc281ceafe4c8ab$export$6ce6ed2df35aa8ea(params, context);
        // Extract generation config parameters
        if ('config' in params && typeof params.config === 'object' && params.config) {
            const config = params.config;
            Object.assign(attributes, $6dc281ceafe4c8ab$var$extractConfigAttributes(config));
            // Extract available tools from config
            if ('tools' in config && Array.isArray(config.tools)) {
                const functionDeclarations = config.tools.flatMap((tool)=>tool.functionDeclarations);
                attributes[0, $69c5419d32efeaea$export$b84797a509e2c15] = JSON.stringify(functionDeclarations);
            }
        }
    } else attributes[0, $69c5419d32efeaea$export$e3834bc5d4a6f8a5] = $6dc281ceafe4c8ab$export$6ce6ed2df35aa8ea({}, context);
    return attributes;
}
/**
 * Add private request attributes to spans.
 * This is only recorded if recordInputs is true.
 * Handles different parameter formats for different Google GenAI methods.
 */ function $6dc281ceafe4c8ab$var$addPrivateRequestAttributes(span, params) {
    const messages = [];
    // config.systemInstruction: ContentUnion
    if ('config' in params && params.config && typeof params.config === 'object' && 'systemInstruction' in params.config && params.config.systemInstruction) messages.push(...(0, $669894d989309123$export$f28e49b6692abcb6)(params.config.systemInstruction, 'system'));
    // For chats.create: history contains the conversation history
    if ('history' in params) messages.push(...(0, $669894d989309123$export$f28e49b6692abcb6)(params.history, 'user'));
    // For models.generateContent: ContentListUnion
    if ('contents' in params) messages.push(...(0, $669894d989309123$export$f28e49b6692abcb6)(params.contents, 'user'));
    // For chat.sendMessage: message can be PartListUnion
    if ('message' in params) messages.push(...(0, $669894d989309123$export$f28e49b6692abcb6)(params.message, 'user'));
    if (Array.isArray(messages) && messages.length) {
        const { systemInstructions: systemInstructions, filteredMessages: filteredMessages } = (0, $33812c936a44f60e$export$d259f1ba7bd7cfce)(messages);
        if (systemInstructions) span.setAttribute((0, $69c5419d32efeaea$export$461510d48ed1f51d), systemInstructions);
        const filteredLength = Array.isArray(filteredMessages) ? filteredMessages.length : 0;
        span.setAttributes({
            [(0, $69c5419d32efeaea$export$ca7610de76ac1c3f)]: filteredLength,
            [(0, $69c5419d32efeaea$export$b36434f4adcd5fb0)]: JSON.stringify((0, $b86a786ebedea812$export$7f5d498f0a32d006)(filteredMessages))
        });
    }
}
/**
 * Add response attributes from the Google GenAI response
 * @see https://github.com/googleapis/js-genai/blob/v1.19.0/src/types.ts#L2313
 */ function $6dc281ceafe4c8ab$var$addResponseAttributes(span, response, recordOutputs) {
    if (!response || typeof response !== 'object') return;
    if (response.modelVersion) span.setAttribute((0, $69c5419d32efeaea$export$91aa8d4aaebb3840), response.modelVersion);
    // Add usage metadata if present
    if (response.usageMetadata && typeof response.usageMetadata === 'object') {
        const usage = response.usageMetadata;
        if (typeof usage.promptTokenCount === 'number') span.setAttributes({
            [(0, $69c5419d32efeaea$export$ad91d91220026940)]: usage.promptTokenCount
        });
        if (typeof usage.candidatesTokenCount === 'number') span.setAttributes({
            [(0, $69c5419d32efeaea$export$84cd977981922116)]: usage.candidatesTokenCount
        });
        if (typeof usage.totalTokenCount === 'number') span.setAttributes({
            [(0, $69c5419d32efeaea$export$60599e5371c06255)]: usage.totalTokenCount
        });
    }
    // Add response text if recordOutputs is enabled
    if (recordOutputs && Array.isArray(response.candidates) && response.candidates.length > 0) {
        const responseTexts = response.candidates.map((candidate)=>{
            if (candidate.content?.parts && Array.isArray(candidate.content.parts)) return candidate.content.parts.map((part)=>typeof part.text === 'string' ? part.text : '').filter((text)=>text.length > 0).join('');
            return '';
        }).filter((text)=>text.length > 0);
        if (responseTexts.length > 0) span.setAttributes({
            [(0, $69c5419d32efeaea$export$2478fd72313ce319)]: responseTexts.join('')
        });
    }
    // Add tool calls if recordOutputs is enabled
    if (recordOutputs && response.functionCalls) {
        const functionCalls = response.functionCalls;
        if (Array.isArray(functionCalls) && functionCalls.length > 0) span.setAttributes({
            [(0, $69c5419d32efeaea$export$c6bace6b76d93a0)]: JSON.stringify(functionCalls)
        });
    }
}
/**
 * Instrument any async or synchronous genai method with Sentry spans
 * Handles operations like models.generateContent and chat.sendMessage and chats.create
 * @see https://docs.sentry.io/platforms/javascript/guides/node/tracing/instrumentation/ai-agents-module/#manual-instrumentation
 */ function $6dc281ceafe4c8ab$var$instrumentMethod(originalMethod, methodPath, context, options) {
    const isSyncCreate = methodPath === (0, $a3fd0a07386c007c$export$7e1ce396edc0ad57);
    return new Proxy(originalMethod, {
        apply (target, _, args) {
            const params = args[0];
            const requestAttributes = $6dc281ceafe4c8ab$var$extractRequestAttributes(methodPath, params, context);
            const model = requestAttributes[0, $69c5419d32efeaea$export$e3834bc5d4a6f8a5] ?? 'unknown';
            const operationName = (0, $33812c936a44f60e$export$101a096156a912de)(methodPath);
            // Check if this is a streaming method
            if ((0, $669894d989309123$export$b4dd0280e89e6f73)(methodPath)) // Use startSpanManual for streaming methods to control span lifecycle
            return (0, $c9161b67125aefc1$export$c10292ad04b92aea)({
                name: `${operationName} ${model}`,
                op: (0, $33812c936a44f60e$export$5e8bff7a65941113)(methodPath),
                attributes: requestAttributes
            }, async (span)=>{
                try {
                    if (options.recordInputs && params) $6dc281ceafe4c8ab$var$addPrivateRequestAttributes(span, params);
                    const stream = await target.apply(context, args);
                    return (0, $03fcd49778c67e56$export$b764c730176bd1aa)(stream, span, Boolean(options.recordOutputs));
                } catch (error) {
                    span.setStatus({
                        code: (0, $fda37f10dc06a152$export$f966a0446ece71e),
                        message: 'internal_error'
                    });
                    (0, $6918c722b531ff18$export$f5282963edea4a68)(error, {
                        mechanism: {
                            handled: false,
                            type: 'auto.ai.google_genai',
                            data: {
                                function: methodPath
                            }
                        }
                    });
                    span.end();
                    throw error;
                }
            });
            // Single span for both sync and async operations
            return (0, $c9161b67125aefc1$export$a1bd95187356f372)({
                name: isSyncCreate ? `${operationName} ${model} create` : `${operationName} ${model}`,
                op: (0, $33812c936a44f60e$export$5e8bff7a65941113)(methodPath),
                attributes: requestAttributes
            }, (span)=>{
                if (options.recordInputs && params) $6dc281ceafe4c8ab$var$addPrivateRequestAttributes(span, params);
                return (0, $2c3cb4034c24252d$export$18ce21a8b7efd7e9)(()=>target.apply(context, args), (error)=>{
                    (0, $6918c722b531ff18$export$f5282963edea4a68)(error, {
                        mechanism: {
                            handled: false,
                            type: 'auto.ai.google_genai',
                            data: {
                                function: methodPath
                            }
                        }
                    });
                }, ()=>{}, (result)=>{
                    // Only add response attributes for content-producing methods, not for chats.create
                    if (!isSyncCreate) $6dc281ceafe4c8ab$var$addResponseAttributes(span, result, options.recordOutputs);
                });
            });
        }
    });
}
/**
 * Create a deep proxy for Google GenAI client instrumentation
 * Recursively instruments methods and handles special cases like chats.create
 */ function $6dc281ceafe4c8ab$var$createDeepProxy(target, currentPath = '', options) {
    return new Proxy(target, {
        get: (t, prop, receiver)=>{
            const value = Reflect.get(t, prop, receiver);
            const methodPath = (0, $33812c936a44f60e$export$d7a5998392457f14)(currentPath, String(prop));
            if (typeof value === 'function' && (0, $669894d989309123$export$f5188c19ec4120e7)(methodPath)) {
                // Special case: chats.create is synchronous but needs both instrumentation AND result proxying
                if (methodPath === (0, $a3fd0a07386c007c$export$7e1ce396edc0ad57)) {
                    const instrumentedMethod = $6dc281ceafe4c8ab$var$instrumentMethod(value, methodPath, t, options);
                    return function instrumentedAndProxiedCreate(...args) {
                        const result = instrumentedMethod(...args);
                        // If the result is an object (like a chat instance), proxy it too
                        if (result && typeof result === 'object') return $6dc281ceafe4c8ab$var$createDeepProxy(result, (0, $a3fd0a07386c007c$export$54306dc3a5fddc77), options);
                        return result;
                    };
                }
                return $6dc281ceafe4c8ab$var$instrumentMethod(value, methodPath, t, options);
            }
            if (typeof value === 'function') // Bind non-instrumented functions to preserve the original `this` context
            return value.bind(t);
            if (value && typeof value === 'object') return $6dc281ceafe4c8ab$var$createDeepProxy(value, methodPath, options);
            return value;
        }
    });
}
/**
 * Instrument a Google GenAI client with Sentry tracing
 * Can be used across Node.js, Cloudflare Workers, and Vercel Edge
 *
 * @template T - The type of the client that extends client object
 * @param client - The Google GenAI client to instrument
 * @param options - Optional configuration for recording inputs and outputs
 * @returns The instrumented client with the same type as the input
 *
 * @example
 * ```typescript
 * import { GoogleGenAI } from '@google/genai';
 * import { instrumentGoogleGenAIClient } from '@sentry/core';
 *
 * const genAI = new GoogleGenAI({ apiKey: process.env.GOOGLE_GENAI_API_KEY });
 * const instrumentedClient = instrumentGoogleGenAIClient(genAI);
 *
 * // Now both chats.create and sendMessage will be instrumented
 * const chat = instrumentedClient.chats.create({ model: 'gemini-1.5-pro' });
 * const response = await chat.sendMessage({ message: 'Hello' });
 * ```
 */ function $6dc281ceafe4c8ab$export$c76b70488372d10f(client, options) {
    return $6dc281ceafe4c8ab$var$createDeepProxy(client, '', (0, $33812c936a44f60e$export$ac4bb282bdbe5b74)(options));
}









const $8cc2f8b7fd7039a4$export$4721706936a00880 = 'LangGraph';
const $8cc2f8b7fd7039a4$export$65645e8baf47a6da = 'auto.ai.langgraph';




/**
 * Extract tool calls from messages
 */ function $9fa8e5aa7ca2d79e$export$9fb461f0e7b49513(messages) {
    if (!messages || messages.length === 0) return null;
    const toolCalls = [];
    for (const message of messages)if (message && typeof message === 'object') {
        const msgToolCalls = message.tool_calls;
        if (msgToolCalls && Array.isArray(msgToolCalls)) toolCalls.push(...msgToolCalls);
    }
    return toolCalls.length > 0 ? toolCalls : null;
}
/**
 * Extract token usage from a message's usage_metadata or response_metadata
 * Returns token counts without setting span attributes
 */ function $9fa8e5aa7ca2d79e$export$3fae3612753d7992(message) {
    const msg = message;
    let inputTokens = 0;
    let outputTokens = 0;
    let totalTokens = 0;
    // Extract from usage_metadata (newer format)
    if (msg.usage_metadata && typeof msg.usage_metadata === 'object') {
        const usage = msg.usage_metadata;
        if (typeof usage.input_tokens === 'number') inputTokens = usage.input_tokens;
        if (typeof usage.output_tokens === 'number') outputTokens = usage.output_tokens;
        if (typeof usage.total_tokens === 'number') totalTokens = usage.total_tokens;
        return {
            inputTokens: inputTokens,
            outputTokens: outputTokens,
            totalTokens: totalTokens
        };
    }
    // Fallback: Extract from response_metadata.tokenUsage
    if (msg.response_metadata && typeof msg.response_metadata === 'object') {
        const metadata = msg.response_metadata;
        if (metadata.tokenUsage && typeof metadata.tokenUsage === 'object') {
            const tokenUsage = metadata.tokenUsage;
            if (typeof tokenUsage.promptTokens === 'number') inputTokens = tokenUsage.promptTokens;
            if (typeof tokenUsage.completionTokens === 'number') outputTokens = tokenUsage.completionTokens;
            if (typeof tokenUsage.totalTokens === 'number') totalTokens = tokenUsage.totalTokens;
        }
    }
    return {
        inputTokens: inputTokens,
        outputTokens: outputTokens,
        totalTokens: totalTokens
    };
}
/**
 * Extract model and finish reason from a message's response_metadata
 */ function $9fa8e5aa7ca2d79e$export$de40caefd47c6161(span, message) {
    const msg = message;
    if (msg.response_metadata && typeof msg.response_metadata === 'object') {
        const metadata = msg.response_metadata;
        if (metadata.model_name && typeof metadata.model_name === 'string') span.setAttribute((0, $69c5419d32efeaea$export$91aa8d4aaebb3840), metadata.model_name);
        if (metadata.finish_reason && typeof metadata.finish_reason === 'string') span.setAttribute((0, $69c5419d32efeaea$export$8778ccf58aa04820), [
            metadata.finish_reason
        ]);
    }
}
/**
 * Extract tools from compiled graph structure
 *
 * Tools are stored in: compiledGraph.builder.nodes.tools.runnable.tools
 */ function $9fa8e5aa7ca2d79e$export$23d0bf7277b5a1d3(compiledGraph) {
    if (!compiledGraph.builder?.nodes?.tools?.runnable?.tools) return null;
    const tools = compiledGraph.builder?.nodes?.tools?.runnable?.tools;
    if (!tools || !Array.isArray(tools) || tools.length === 0) return null;
    // Extract name, description, and schema from each tool's lc_kwargs
    return tools.map((tool)=>({
            name: tool.lc_kwargs?.name,
            description: tool.lc_kwargs?.description,
            schema: tool.lc_kwargs?.schema
        }));
}
/**
 * Set response attributes on the span
 */ function $9fa8e5aa7ca2d79e$export$865a2492724b1d88(span, inputMessages, result) {
    // Extract messages from result
    const resultObj = result;
    const outputMessages = resultObj?.messages;
    if (!outputMessages || !Array.isArray(outputMessages)) return;
    // Get new messages (delta between input and output)
    const inputCount = inputMessages?.length ?? 0;
    const newMessages = outputMessages.length > inputCount ? outputMessages.slice(inputCount) : [];
    if (newMessages.length === 0) return;
    // Extract and set tool calls from new messages BEFORE normalization
    // (normalization strips tool_calls, so we need to extract them first)
    const toolCalls = $9fa8e5aa7ca2d79e$export$9fb461f0e7b49513(newMessages);
    if (toolCalls) span.setAttribute((0, $69c5419d32efeaea$export$c6bace6b76d93a0), JSON.stringify(toolCalls));
    // Normalize the new messages
    const normalizedNewMessages = (0, $4041fb1e5e189765$export$50238a3d0dec74d4)(newMessages);
    span.setAttribute((0, $69c5419d32efeaea$export$2478fd72313ce319), JSON.stringify(normalizedNewMessages));
    // Accumulate token usage across all messages
    let totalInputTokens = 0;
    let totalOutputTokens = 0;
    let totalTokens = 0;
    // Extract metadata from messages
    for (const message of newMessages){
        // Accumulate token usage
        const tokens = $9fa8e5aa7ca2d79e$export$3fae3612753d7992(message);
        totalInputTokens += tokens.inputTokens;
        totalOutputTokens += tokens.outputTokens;
        totalTokens += tokens.totalTokens;
        // Extract model metadata (last message's metadata wins for model/finish_reason)
        $9fa8e5aa7ca2d79e$export$de40caefd47c6161(span, message);
    }
    // Set accumulated token usage on span
    if (totalInputTokens > 0) span.setAttribute((0, $69c5419d32efeaea$export$ad91d91220026940), totalInputTokens);
    if (totalOutputTokens > 0) span.setAttribute((0, $69c5419d32efeaea$export$84cd977981922116), totalOutputTokens);
    if (totalTokens > 0) span.setAttribute((0, $69c5419d32efeaea$export$60599e5371c06255), totalTokens);
}


/**
 * Instruments StateGraph's compile method to create spans for agent creation and invocation
 *
 * Wraps the compile() method to:
 * - Create a `gen_ai.create_agent` span when compile() is called
 * - Automatically wrap the invoke() method on the returned compiled graph with a `gen_ai.invoke_agent` span
 *
 */ function $6b39ec4ad60d2ce5$export$4b2145c836f0dbeb(originalCompile, options) {
    return new Proxy(originalCompile, {
        apply (target, thisArg, args) {
            return (0, $c9161b67125aefc1$export$a1bd95187356f372)({
                op: 'gen_ai.create_agent',
                name: 'create_agent',
                attributes: {
                    [(0, $f337c80285f06f80$export$cca8dd30f57f805e)]: (0, $8cc2f8b7fd7039a4$export$65645e8baf47a6da),
                    [(0, $f337c80285f06f80$export$1a413bd9a88fdb09)]: 'gen_ai.create_agent',
                    [(0, $69c5419d32efeaea$export$d4b9e945d503aff)]: 'create_agent'
                }
            }, (span)=>{
                try {
                    const compiledGraph = Reflect.apply(target, thisArg, args);
                    const compileOptions = args.length > 0 ? args[0] : {};
                    // Extract graph name
                    if (compileOptions?.name && typeof compileOptions.name === 'string') {
                        span.setAttribute((0, $69c5419d32efeaea$export$9866e099aafe0dac), compileOptions.name);
                        span.updateName(`create_agent ${compileOptions.name}`);
                    }
                    // Instrument agent invoke method on the compiled graph
                    const originalInvoke = compiledGraph.invoke;
                    if (originalInvoke && typeof originalInvoke === 'function') compiledGraph.invoke = $6b39ec4ad60d2ce5$var$instrumentCompiledGraphInvoke(originalInvoke.bind(compiledGraph), compiledGraph, compileOptions, options);
                    return compiledGraph;
                } catch (error) {
                    span.setStatus({
                        code: (0, $fda37f10dc06a152$export$f966a0446ece71e),
                        message: 'internal_error'
                    });
                    (0, $6918c722b531ff18$export$f5282963edea4a68)(error, {
                        mechanism: {
                            handled: false,
                            type: 'auto.ai.langgraph.error'
                        }
                    });
                    throw error;
                }
            });
        }
    });
}
/**
 * Instruments CompiledGraph's invoke method to create spans for agent invocation
 *
 * Creates a `gen_ai.invoke_agent` span when invoke() is called
 */ function $6b39ec4ad60d2ce5$var$instrumentCompiledGraphInvoke(originalInvoke, graphInstance, compileOptions, options) {
    return new Proxy(originalInvoke, {
        apply (target, thisArg, args) {
            return (0, $c9161b67125aefc1$export$a1bd95187356f372)({
                op: 'gen_ai.invoke_agent',
                name: 'invoke_agent',
                attributes: {
                    [(0, $f337c80285f06f80$export$cca8dd30f57f805e)]: (0, $8cc2f8b7fd7039a4$export$65645e8baf47a6da),
                    [(0, $f337c80285f06f80$export$1a413bd9a88fdb09)]: (0, $69c5419d32efeaea$export$1c9f3b468cd7d455),
                    [(0, $69c5419d32efeaea$export$d4b9e945d503aff)]: 'invoke_agent'
                }
            }, async (span)=>{
                try {
                    const graphName = compileOptions?.name;
                    if (graphName && typeof graphName === 'string') {
                        span.setAttribute((0, $69c5419d32efeaea$export$bbe84fd1655fc573), graphName);
                        span.setAttribute((0, $69c5419d32efeaea$export$9866e099aafe0dac), graphName);
                        span.updateName(`invoke_agent ${graphName}`);
                    }
                    // Extract thread_id from the config (second argument)
                    // LangGraph uses config.configurable.thread_id for conversation/session linking
                    const config = args.length > 1 ? args[1] : undefined;
                    const configurable = config?.configurable;
                    const threadId = configurable?.thread_id;
                    if (threadId && typeof threadId === 'string') span.setAttribute((0, $69c5419d32efeaea$export$71a4a707257f2774), threadId);
                    // Extract available tools from the graph instance
                    const tools = (0, $9fa8e5aa7ca2d79e$export$23d0bf7277b5a1d3)(graphInstance);
                    if (tools) span.setAttribute((0, $69c5419d32efeaea$export$b84797a509e2c15), JSON.stringify(tools));
                    // Parse input messages
                    const recordInputs = options.recordInputs;
                    const recordOutputs = options.recordOutputs;
                    const inputMessages = args.length > 0 ? args[0]?.messages ?? [] : [];
                    if (inputMessages && recordInputs) {
                        const normalizedMessages = (0, $4041fb1e5e189765$export$50238a3d0dec74d4)(inputMessages);
                        const { systemInstructions: systemInstructions, filteredMessages: filteredMessages } = (0, $33812c936a44f60e$export$d259f1ba7bd7cfce)(normalizedMessages);
                        if (systemInstructions) span.setAttribute((0, $69c5419d32efeaea$export$461510d48ed1f51d), systemInstructions);
                        const truncatedMessages = (0, $b86a786ebedea812$export$7f5d498f0a32d006)(filteredMessages);
                        const filteredLength = Array.isArray(filteredMessages) ? filteredMessages.length : 0;
                        span.setAttributes({
                            [(0, $69c5419d32efeaea$export$b36434f4adcd5fb0)]: JSON.stringify(truncatedMessages),
                            [(0, $69c5419d32efeaea$export$ca7610de76ac1c3f)]: filteredLength
                        });
                    }
                    // Call original invoke
                    const result = await Reflect.apply(target, thisArg, args);
                    // Set response attributes
                    if (recordOutputs) (0, $9fa8e5aa7ca2d79e$export$865a2492724b1d88)(span, inputMessages ?? null, result);
                    return result;
                } catch (error) {
                    span.setStatus({
                        code: (0, $fda37f10dc06a152$export$f966a0446ece71e),
                        message: 'internal_error'
                    });
                    (0, $6918c722b531ff18$export$f5282963edea4a68)(error, {
                        mechanism: {
                            handled: false,
                            type: 'auto.ai.langgraph.error'
                        }
                    });
                    throw error;
                }
            });
        }
    });
}
/**
 * Directly instruments a StateGraph instance to add tracing spans
 *
 * This function can be used to manually instrument LangGraph StateGraph instances
 * in environments where automatic instrumentation is not available or desired.
 *
 * @param stateGraph - The StateGraph instance to instrument
 * @param options - Optional configuration for recording inputs/outputs
 *
 * @example
 * ```typescript
 * import { instrumentLangGraph } from '@sentry/cloudflare';
 * import { StateGraph } from '@langchain/langgraph';
 *
 * const graph = new StateGraph(MessagesAnnotation)
 *   .addNode('agent', mockLlm)
 *   .addEdge(START, 'agent')
 *   .addEdge('agent', END);
 *
 * instrumentLangGraph(graph, { recordInputs: true, recordOutputs: true });
 * const compiled = graph.compile({ name: 'my_agent' });
 * ```
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $6b39ec4ad60d2ce5$export$85d9e3bf20f67098(stateGraph, options) {
    stateGraph.compile = $6b39ec4ad60d2ce5$export$4b2145c836f0dbeb(stateGraph.compile, (0, $33812c936a44f60e$export$ac4bb282bdbe5b74)(options));
    return stateGraph;
}













const $ef5105b4a766e80b$export$5e7ca1fca79e6a2f = 'OpenAI';
// https://platform.openai.com/docs/quickstart?api-mode=responses
// https://platform.openai.com/docs/quickstart?api-mode=chat
// https://platform.openai.com/docs/api-reference/conversations
const $ef5105b4a766e80b$export$8ee0f0664530a3dd = [
    'responses.create',
    'chat.completions.create',
    'embeddings.create',
    // Conversations API - for conversation state management
    // https://platform.openai.com/docs/guides/conversation-state
    'conversations.create'
];
const $ef5105b4a766e80b$export$1d236e7185e22d35 = [
    'response.output_item.added',
    'response.function_call_arguments.delta',
    'response.function_call_arguments.done',
    'response.output_item.done'
];
const $ef5105b4a766e80b$export$5107c6050b0a4f8b = [
    'response.created',
    'response.in_progress',
    'response.failed',
    'response.completed',
    'response.incomplete',
    'response.queued',
    'response.output_text.delta',
    ...$ef5105b4a766e80b$export$1d236e7185e22d35
];




/**
 * Maps OpenAI method paths to OpenTelemetry semantic convention operation names
 * @see https://opentelemetry.io/docs/specs/semconv/gen-ai/gen-ai-spans/#llm-request-spans
 */ function $82ea5b14697578b2$export$41bca9dc6871dd4e(methodPath) {
    if (methodPath.includes('chat.completions')) return (0, $69c5419d32efeaea$export$4deb19a2b9875d96).CHAT;
    if (methodPath.includes('responses')) return (0, $69c5419d32efeaea$export$4deb19a2b9875d96).CHAT;
    if (methodPath.includes('embeddings')) return (0, $69c5419d32efeaea$export$4deb19a2b9875d96).EMBEDDINGS;
    if (methodPath.includes('conversations')) return (0, $69c5419d32efeaea$export$4deb19a2b9875d96).CHAT;
    return methodPath.split('.').pop() || 'unknown';
}
/**
 * Get the span operation for OpenAI methods
 * Following Sentry's convention: "gen_ai.{operation_name}"
 */ function $82ea5b14697578b2$export$5e8bff7a65941113(methodPath) {
    return `gen_ai.${$82ea5b14697578b2$export$41bca9dc6871dd4e(methodPath)}`;
}
/**
 * Check if a method path should be instrumented
 */ function $82ea5b14697578b2$export$f5188c19ec4120e7(methodPath) {
    return (0, $ef5105b4a766e80b$export$8ee0f0664530a3dd).includes(methodPath);
}
/**
 * Build method path from current traversal
 */ function $82ea5b14697578b2$export$d7a5998392457f14(currentPath, prop) {
    return currentPath ? `${currentPath}.${prop}` : prop;
}
/**
 * Check if response is a Chat Completion object
 */ function $82ea5b14697578b2$export$b17d8694d76123c7(response) {
    return response !== null && typeof response === 'object' && 'object' in response && response.object === 'chat.completion';
}
/**
 * Check if response is a Responses API object
 */ function $82ea5b14697578b2$export$e80d5f45e9c5cb3a(response) {
    return response !== null && typeof response === 'object' && 'object' in response && response.object === 'response';
}
/**
 * Check if response is an Embeddings API object
 */ function $82ea5b14697578b2$export$4d82228a921f844e(response) {
    if (response === null || typeof response !== 'object' || !('object' in response)) return false;
    const responseObject = response;
    return responseObject.object === 'list' && typeof responseObject.model === 'string' && responseObject.model.toLowerCase().includes('embedding');
}
/**
 * Check if response is a Conversations API object
 * @see https://platform.openai.com/docs/api-reference/conversations
 */ function $82ea5b14697578b2$export$74a4938b87217813(response) {
    return response !== null && typeof response === 'object' && 'object' in response && response.object === 'conversation';
}
/**
 * Check if streaming event is from the Responses API
 */ function $82ea5b14697578b2$export$cff12a37427894a8(event) {
    return event !== null && typeof event === 'object' && 'type' in event && typeof event.type === 'string' && event.type.startsWith('response.');
}
/**
 * Check if streaming event is a chat completion chunk
 */ function $82ea5b14697578b2$export$7b89db6363813385(event) {
    return event !== null && typeof event === 'object' && 'object' in event && event.object === 'chat.completion.chunk';
}
/**
 * Add attributes for Chat Completion responses
 */ function $82ea5b14697578b2$export$88418c5939ee7286(span, response, recordOutputs) {
    $82ea5b14697578b2$export$aca7323b513f7c6a(span, response.id, response.model, response.created);
    if (response.usage) $82ea5b14697578b2$export$8130c966fa864943(span, response.usage.prompt_tokens, response.usage.completion_tokens, response.usage.total_tokens);
    if (Array.isArray(response.choices)) {
        const finishReasons = response.choices.map((choice)=>choice.finish_reason).filter((reason)=>reason !== null);
        if (finishReasons.length > 0) span.setAttributes({
            [(0, $69c5419d32efeaea$export$8778ccf58aa04820)]: JSON.stringify(finishReasons)
        });
        // Extract tool calls from all choices (only if recordOutputs is true)
        if (recordOutputs) {
            const toolCalls = response.choices.map((choice)=>choice.message?.tool_calls).filter((calls)=>Array.isArray(calls) && calls.length > 0).flat();
            if (toolCalls.length > 0) span.setAttributes({
                [(0, $69c5419d32efeaea$export$c6bace6b76d93a0)]: JSON.stringify(toolCalls)
            });
        }
    }
}
/**
 * Add attributes for Responses API responses
 */ function $82ea5b14697578b2$export$ab3c1d9e219904e5(span, response, recordOutputs) {
    $82ea5b14697578b2$export$aca7323b513f7c6a(span, response.id, response.model, response.created_at);
    if (response.status) span.setAttributes({
        [(0, $69c5419d32efeaea$export$8778ccf58aa04820)]: JSON.stringify([
            response.status
        ])
    });
    if (response.usage) $82ea5b14697578b2$export$8130c966fa864943(span, response.usage.input_tokens, response.usage.output_tokens, response.usage.total_tokens);
    // Extract function calls from output (only if recordOutputs is true)
    if (recordOutputs) {
        const responseWithOutput = response;
        if (Array.isArray(responseWithOutput.output) && responseWithOutput.output.length > 0) {
            // Filter for function_call type objects in the output array
            const functionCalls = responseWithOutput.output.filter((item)=>// oxlint-disable-next-line typescript/prefer-optional-chain
                typeof item === 'object' && item !== null && item.type === 'function_call');
            if (functionCalls.length > 0) span.setAttributes({
                [(0, $69c5419d32efeaea$export$c6bace6b76d93a0)]: JSON.stringify(functionCalls)
            });
        }
    }
}
/**
 * Add attributes for Embeddings API responses
 */ function $82ea5b14697578b2$export$94d7f1a80ea369b4(span, response) {
    span.setAttributes({
        [(0, $69c5419d32efeaea$export$1c7a697dcd8f0fc0)]: response.model,
        [(0, $69c5419d32efeaea$export$91aa8d4aaebb3840)]: response.model
    });
    if (response.usage) $82ea5b14697578b2$export$8130c966fa864943(span, response.usage.prompt_tokens, undefined, response.usage.total_tokens);
}
/**
 * Add attributes for Conversations API responses
 * @see https://platform.openai.com/docs/api-reference/conversations
 */ function $82ea5b14697578b2$export$1fff33ea171cf9df(span, response) {
    const { id: id, created_at: created_at } = response;
    span.setAttributes({
        [(0, $69c5419d32efeaea$export$8adff427c4daccb6)]: id,
        [(0, $69c5419d32efeaea$export$1e55ab213eb8e5dc)]: id,
        // The conversation id is used to link messages across API calls
        [(0, $69c5419d32efeaea$export$71a4a707257f2774)]: id
    });
    if (created_at) span.setAttributes({
        [(0, $69c5419d32efeaea$export$44332d54ca9318b7)]: new Date(created_at * 1000).toISOString()
    });
}
/**
 * Set token usage attributes
 * @param span - The span to add attributes to
 * @param promptTokens - The number of prompt tokens
 * @param completionTokens - The number of completion tokens
 * @param totalTokens - The number of total tokens
 */ function $82ea5b14697578b2$export$8130c966fa864943(span, promptTokens, completionTokens, totalTokens) {
    if (promptTokens !== undefined) span.setAttributes({
        [(0, $69c5419d32efeaea$export$c81e5735e96e0997)]: promptTokens,
        [(0, $69c5419d32efeaea$export$ad91d91220026940)]: promptTokens
    });
    if (completionTokens !== undefined) span.setAttributes({
        [(0, $69c5419d32efeaea$export$29098909ce8eb523)]: completionTokens,
        [(0, $69c5419d32efeaea$export$84cd977981922116)]: completionTokens
    });
    if (totalTokens !== undefined) span.setAttributes({
        [(0, $69c5419d32efeaea$export$60599e5371c06255)]: totalTokens
    });
}
/**
 * Set common response attributes
 * @param span - The span to add attributes to
 * @param id - The response id
 * @param model - The response model
 * @param timestamp - The response timestamp
 */ function $82ea5b14697578b2$export$aca7323b513f7c6a(span, id, model, timestamp) {
    span.setAttributes({
        [(0, $69c5419d32efeaea$export$8adff427c4daccb6)]: id,
        [(0, $69c5419d32efeaea$export$1e55ab213eb8e5dc)]: id
    });
    span.setAttributes({
        [(0, $69c5419d32efeaea$export$1c7a697dcd8f0fc0)]: model,
        [(0, $69c5419d32efeaea$export$91aa8d4aaebb3840)]: model
    });
    span.setAttributes({
        [(0, $69c5419d32efeaea$export$44332d54ca9318b7)]: new Date(timestamp * 1000).toISOString()
    });
}
/**
 * Extract conversation ID from request parameters
 * Supports both Conversations API and previous_response_id chaining
 * @see https://platform.openai.com/docs/guides/conversation-state
 */ function $82ea5b14697578b2$var$extractConversationId(params) {
    // Conversations API: conversation parameter (e.g., "conv_...")
    if ('conversation' in params && typeof params.conversation === 'string') return params.conversation;
    // Responses chaining: previous_response_id links to parent response
    if ('previous_response_id' in params && typeof params.previous_response_id === 'string') return params.previous_response_id;
    return undefined;
}
/**
 * Extract request parameters including model settings and conversation context
 */ function $82ea5b14697578b2$export$d9f57620322fdb25(params) {
    const attributes = {
        [(0, $69c5419d32efeaea$export$e3834bc5d4a6f8a5)]: params.model ?? 'unknown'
    };
    if ('temperature' in params) attributes[0, $69c5419d32efeaea$export$84ab1c0a4a1402ec] = params.temperature;
    if ('top_p' in params) attributes[0, $69c5419d32efeaea$export$be752be64ca500f6] = params.top_p;
    if ('frequency_penalty' in params) attributes[0, $69c5419d32efeaea$export$58b9b1cd46b4bb5e] = params.frequency_penalty;
    if ('presence_penalty' in params) attributes[0, $69c5419d32efeaea$export$66b1150b23e1da44] = params.presence_penalty;
    if ('stream' in params) attributes[0, $69c5419d32efeaea$export$f8a1e9006f7a3c18] = params.stream;
    if ('encoding_format' in params) attributes[0, $69c5419d32efeaea$export$b0a0c7768ed27b96] = params.encoding_format;
    if ('dimensions' in params) attributes[0, $69c5419d32efeaea$export$4c4b39f46c2c0dd0] = params.dimensions;
    // Capture conversation ID for linking messages across API calls
    const conversationId = $82ea5b14697578b2$var$extractConversationId(params);
    if (conversationId) attributes[0, $69c5419d32efeaea$export$71a4a707257f2774] = conversationId;
    return attributes;
}


/**
 * State object used to accumulate information from a stream of OpenAI events/chunks.
 */ /**
 * Processes tool calls from a chat completion chunk delta.
 * Follows the pattern: accumulate by index, then convert to array at the end.
 *
 * @param toolCalls - Array of tool calls from the delta.
 * @param state - The current streaming state to update.
 *
 *  @see https://platform.openai.com/docs/guides/function-calling#streaming
 */ function $f8f7be6c0cd677cd$var$processChatCompletionToolCalls(toolCalls, state) {
    for (const toolCall of toolCalls){
        const index = toolCall.index;
        if (index === undefined || !toolCall.function) continue;
        // Initialize tool call if this is the first chunk for this index
        if (!(index in state.chatCompletionToolCalls)) state.chatCompletionToolCalls[index] = {
            ...toolCall,
            function: {
                name: toolCall.function.name,
                arguments: toolCall.function.arguments || ''
            }
        };
        else {
            // Accumulate function arguments from subsequent chunks
            const existingToolCall = state.chatCompletionToolCalls[index];
            if (toolCall.function.arguments && existingToolCall?.function) existingToolCall.function.arguments += toolCall.function.arguments;
        }
    }
}
/**
 * Processes a single OpenAI ChatCompletionChunk event, updating the streaming state.
 *
 * @param chunk - The ChatCompletionChunk event to process.
 * @param state - The current streaming state to update.
 * @param recordOutputs - Whether to record output text fragments.
 */ function $f8f7be6c0cd677cd$var$processChatCompletionChunk(chunk, state, recordOutputs) {
    state.responseId = chunk.id ?? state.responseId;
    state.responseModel = chunk.model ?? state.responseModel;
    state.responseTimestamp = chunk.created ?? state.responseTimestamp;
    if (chunk.usage) {
        // For stream responses, the input tokens remain constant across all events in the stream.
        // Output tokens, however, are only finalized in the last event.
        // Since we can't guarantee that the last event will include usage data or even be a typed event,
        // we update the output token values on every event that includes them.
        // This ensures that output token usage is always set, even if the final event lacks it.
        state.promptTokens = chunk.usage.prompt_tokens;
        state.completionTokens = chunk.usage.completion_tokens;
        state.totalTokens = chunk.usage.total_tokens;
    }
    for (const choice of chunk.choices ?? []){
        if (recordOutputs) {
            if (choice.delta?.content) state.responseTexts.push(choice.delta.content);
            // Handle tool calls from delta
            if (choice.delta?.tool_calls) $f8f7be6c0cd677cd$var$processChatCompletionToolCalls(choice.delta.tool_calls, state);
        }
        if (choice.finish_reason) state.finishReasons.push(choice.finish_reason);
    }
}
/**
 * Processes a single OpenAI Responses API streaming event, updating the streaming state and span.
 *
 * @param streamEvent - The event to process (may be an error or unknown object).
 * @param state - The current streaming state to update.
 * @param recordOutputs - Whether to record output text fragments.
 * @param span - The span to update with error status if needed.
 */ function $f8f7be6c0cd677cd$var$processResponsesApiEvent(streamEvent, state, recordOutputs, span) {
    if (!(streamEvent && typeof streamEvent === 'object')) {
        state.eventTypes.push('unknown:non-object');
        return;
    }
    if (streamEvent instanceof Error) {
        span.setStatus({
            code: (0, $fda37f10dc06a152$export$f966a0446ece71e),
            message: 'internal_error'
        });
        (0, $6918c722b531ff18$export$f5282963edea4a68)(streamEvent, {
            mechanism: {
                handled: false,
                type: 'auto.ai.openai.stream-response'
            }
        });
        return;
    }
    if (!('type' in streamEvent)) return;
    const event = streamEvent;
    if (!(0, $ef5105b4a766e80b$export$5107c6050b0a4f8b).includes(event.type)) {
        state.eventTypes.push(event.type);
        return;
    }
    // Handle output text delta
    if (recordOutputs) {
        // Handle tool call events for Responses API
        if (event.type === 'response.output_item.done' && 'item' in event) state.responsesApiToolCalls.push(event.item);
        if (event.type === 'response.output_text.delta' && 'delta' in event && event.delta) {
            state.responseTexts.push(event.delta);
            return;
        }
    }
    if ('response' in event) {
        const { response: response } = event;
        state.responseId = response.id ?? state.responseId;
        state.responseModel = response.model ?? state.responseModel;
        state.responseTimestamp = response.created_at ?? state.responseTimestamp;
        if (response.usage) {
            // For stream responses, the input tokens remain constant across all events in the stream.
            // Output tokens, however, are only finalized in the last event.
            // Since we can't guarantee that the last event will include usage data or even be a typed event,
            // we update the output token values on every event that includes them.
            // This ensures that output token usage is always set, even if the final event lacks it.
            state.promptTokens = response.usage.input_tokens;
            state.completionTokens = response.usage.output_tokens;
            state.totalTokens = response.usage.total_tokens;
        }
        if (response.status) state.finishReasons.push(response.status);
        if (recordOutputs && response.output_text) state.responseTexts.push(response.output_text);
    }
}
/**
 * Instruments a stream of OpenAI events, updating the provided span with relevant attributes and
 * optionally recording output text. This function yields each event from the input stream as it is processed.
 *
 * @template T - The type of events in the stream.
 * @param stream - The async iterable stream of events to instrument.
 * @param span - The span to add attributes to and to finish at the end of the stream.
 * @param recordOutputs - Whether to record output text fragments in the span.
 * @returns An async generator yielding each event from the input stream.
 */ async function* $f8f7be6c0cd677cd$export$b764c730176bd1aa(stream, span, recordOutputs) {
    const state = {
        eventTypes: [],
        responseTexts: [],
        finishReasons: [],
        responseId: '',
        responseModel: '',
        responseTimestamp: 0,
        promptTokens: undefined,
        completionTokens: undefined,
        totalTokens: undefined,
        chatCompletionToolCalls: {},
        responsesApiToolCalls: []
    };
    try {
        for await (const event of stream){
            if ((0, $82ea5b14697578b2$export$7b89db6363813385)(event)) $f8f7be6c0cd677cd$var$processChatCompletionChunk(event, state, recordOutputs);
            else if ((0, $82ea5b14697578b2$export$cff12a37427894a8)(event)) $f8f7be6c0cd677cd$var$processResponsesApiEvent(event, state, recordOutputs, span);
            yield event;
        }
    } finally{
        (0, $82ea5b14697578b2$export$aca7323b513f7c6a)(span, state.responseId, state.responseModel, state.responseTimestamp);
        (0, $82ea5b14697578b2$export$8130c966fa864943)(span, state.promptTokens, state.completionTokens, state.totalTokens);
        span.setAttributes({
            [(0, $69c5419d32efeaea$export$e7360a81bbfe9c78)]: true
        });
        if (state.finishReasons.length) span.setAttributes({
            [(0, $69c5419d32efeaea$export$8778ccf58aa04820)]: JSON.stringify(state.finishReasons)
        });
        if (recordOutputs && state.responseTexts.length) span.setAttributes({
            [(0, $69c5419d32efeaea$export$2478fd72313ce319)]: state.responseTexts.join('')
        });
        // Set tool calls attribute if any were accumulated
        const chatCompletionToolCallsArray = Object.values(state.chatCompletionToolCalls);
        const allToolCalls = [
            ...chatCompletionToolCallsArray,
            ...state.responsesApiToolCalls
        ];
        if (allToolCalls.length > 0) span.setAttributes({
            [(0, $69c5419d32efeaea$export$c6bace6b76d93a0)]: JSON.stringify(allToolCalls)
        });
        span.end();
    }
}



/**
 * Extract available tools from request parameters
 */ function $eb0cfc8c9d413cf3$var$extractAvailableTools(params) {
    const tools = Array.isArray(params.tools) ? params.tools : [];
    const hasWebSearchOptions = params.web_search_options && typeof params.web_search_options === 'object';
    const webSearchOptions = hasWebSearchOptions ? [
        {
            type: 'web_search_options',
            ...params.web_search_options
        }
    ] : [];
    const availableTools = [
        ...tools,
        ...webSearchOptions
    ];
    if (availableTools.length === 0) return undefined;
    try {
        return JSON.stringify(availableTools);
    } catch (error) {
        (0, $19fdbaf7f0830971$export$16a28057038b10ef) && (0, $d11ed0b3cdda6b8d$export$1c9f709888824e05).error('Failed to serialize OpenAI tools:', error);
        return undefined;
    }
}
/**
 * Extract request attributes from method arguments
 */ function $eb0cfc8c9d413cf3$var$extractRequestAttributes(args, methodPath) {
    const attributes = {
        [(0, $69c5419d32efeaea$export$234b82df5670ccbb)]: 'openai',
        [(0, $69c5419d32efeaea$export$d4b9e945d503aff)]: (0, $82ea5b14697578b2$export$41bca9dc6871dd4e)(methodPath),
        [(0, $f337c80285f06f80$export$cca8dd30f57f805e)]: 'auto.ai.openai'
    };
    if (args.length > 0 && typeof args[0] === 'object' && args[0] !== null) {
        const params = args[0];
        const availableTools = $eb0cfc8c9d413cf3$var$extractAvailableTools(params);
        if (availableTools) attributes[0, $69c5419d32efeaea$export$b84797a509e2c15] = availableTools;
        Object.assign(attributes, (0, $82ea5b14697578b2$export$d9f57620322fdb25)(params));
    } else attributes[0, $69c5419d32efeaea$export$e3834bc5d4a6f8a5] = 'unknown';
    return attributes;
}
/**
 * Add response attributes to spans
 * This supports Chat Completion, Responses API, Embeddings, and Conversations API responses
 */ function $eb0cfc8c9d413cf3$var$addResponseAttributes(span, result, recordOutputs) {
    if (!result || typeof result !== 'object') return;
    const response = result;
    if ((0, $82ea5b14697578b2$export$b17d8694d76123c7)(response)) {
        (0, $82ea5b14697578b2$export$88418c5939ee7286)(span, response, recordOutputs);
        if (recordOutputs && response.choices?.length) {
            const responseTexts = response.choices.map((choice)=>choice.message?.content || '');
            span.setAttributes({
                [(0, $69c5419d32efeaea$export$2478fd72313ce319)]: JSON.stringify(responseTexts)
            });
        }
    } else if ((0, $82ea5b14697578b2$export$e80d5f45e9c5cb3a)(response)) {
        (0, $82ea5b14697578b2$export$ab3c1d9e219904e5)(span, response, recordOutputs);
        if (recordOutputs && response.output_text) span.setAttributes({
            [(0, $69c5419d32efeaea$export$2478fd72313ce319)]: response.output_text
        });
    } else if ((0, $82ea5b14697578b2$export$4d82228a921f844e)(response)) (0, $82ea5b14697578b2$export$94d7f1a80ea369b4)(span, response);
    else if ((0, $82ea5b14697578b2$export$74a4938b87217813)(response)) (0, $82ea5b14697578b2$export$1fff33ea171cf9df)(span, response);
}
// Extract and record AI request inputs, if present. This is intentionally separate from response attributes.
function $eb0cfc8c9d413cf3$var$addRequestAttributes(span, params, operationName) {
    // Store embeddings input on a separate attribute and do not truncate it
    if (operationName === (0, $69c5419d32efeaea$export$4deb19a2b9875d96).EMBEDDINGS && 'input' in params) {
        const input = params.input;
        // No input provided
        if (input == null) return;
        // Empty input string
        if (typeof input === 'string' && input.length === 0) return;
        // Empty array input
        if (Array.isArray(input) && input.length === 0) return;
        // Store strings as-is, arrays/objects as JSON
        span.setAttribute((0, $69c5419d32efeaea$export$844e723b3a342d78), typeof input === 'string' ? input : JSON.stringify(input));
        return;
    }
    const src = 'input' in params ? params.input : 'messages' in params ? params.messages : undefined;
    if (!src) return;
    if (Array.isArray(src) && src.length === 0) return;
    const { systemInstructions: systemInstructions, filteredMessages: filteredMessages } = (0, $33812c936a44f60e$export$d259f1ba7bd7cfce)(src);
    if (systemInstructions) span.setAttribute((0, $69c5419d32efeaea$export$461510d48ed1f51d), systemInstructions);
    const truncatedInput = (0, $33812c936a44f60e$export$5b065884ce77f65e)(filteredMessages);
    span.setAttribute((0, $69c5419d32efeaea$export$b36434f4adcd5fb0), truncatedInput);
    if (Array.isArray(filteredMessages)) span.setAttribute((0, $69c5419d32efeaea$export$ca7610de76ac1c3f), filteredMessages.length);
    else span.setAttribute((0, $69c5419d32efeaea$export$ca7610de76ac1c3f), 1);
}
/**
 * Creates a wrapped version of .withResponse() that replaces the data field
 * with the instrumented result while preserving metadata (response, request_id).
 */ async function $eb0cfc8c9d413cf3$var$createWithResponseWrapper(originalWithResponse, instrumentedPromise) {
    // Attach catch handler to originalWithResponse immediately to prevent unhandled rejection
    // If instrumentedPromise rejects first, we still need this handled
    const safeOriginalWithResponse = originalWithResponse.catch((error)=>{
        (0, $6918c722b531ff18$export$f5282963edea4a68)(error, {
            mechanism: {
                handled: false,
                type: 'auto.ai.openai'
            }
        });
        throw error;
    });
    const instrumentedResult = await instrumentedPromise;
    const originalWrapper = await safeOriginalWithResponse;
    // Combine instrumented result with original metadata
    if (originalWrapper && typeof originalWrapper === 'object' && 'data' in originalWrapper) return {
        ...originalWrapper,
        data: instrumentedResult
    };
    return instrumentedResult;
}
/**
 * Wraps a promise-like object to preserve additional methods (like .withResponse())
 */ function $eb0cfc8c9d413cf3$var$wrapPromiseWithMethods(originalPromiseLike, instrumentedPromise) {
    // If the original result is not thenable, return the instrumented promise
    // Should not happen with current OpenAI SDK instrumented methods, but just in case.
    if (!(0, $13cf2ed412f405fa$export$f5b060c2914b97c8)(originalPromiseLike)) return instrumentedPromise;
    // Create a proxy that forwards Promise methods to instrumentedPromise
    // and preserves additional methods from the original result
    return new Proxy(originalPromiseLike, {
        get (target, prop) {
            // For standard Promise methods (.then, .catch, .finally, Symbol.toStringTag),
            // use instrumentedPromise to preserve Sentry instrumentation.
            // For custom methods (like .withResponse()), use the original target.
            const useInstrumentedPromise = prop in Promise.prototype || prop === Symbol.toStringTag;
            const source = useInstrumentedPromise ? instrumentedPromise : target;
            const value = Reflect.get(source, prop);
            // Special handling for .withResponse() to preserve instrumentation
            // .withResponse() returns { data: T, response: Response, request_id: string }
            if (prop === 'withResponse' && typeof value === 'function') return function wrappedWithResponse() {
                const originalWithResponse = value.call(target);
                return $eb0cfc8c9d413cf3$var$createWithResponseWrapper(originalWithResponse, instrumentedPromise);
            };
            return typeof value === 'function' ? value.bind(source) : value;
        }
    });
}
/**
 * Instrument a method with Sentry spans
 * Following Sentry AI Agents Manual Instrumentation conventions
 * @see https://docs.sentry.io/platforms/javascript/guides/node/tracing/instrumentation/ai-agents-module/#manual-instrumentation
 */ function $eb0cfc8c9d413cf3$var$instrumentMethod(originalMethod, methodPath, context, options) {
    return function instrumentedMethod(...args) {
        const requestAttributes = $eb0cfc8c9d413cf3$var$extractRequestAttributes(args, methodPath);
        const model = requestAttributes[0, $69c5419d32efeaea$export$e3834bc5d4a6f8a5] || 'unknown';
        const operationName = (0, $82ea5b14697578b2$export$41bca9dc6871dd4e)(methodPath);
        const params = args[0];
        const isStreamRequested = params && typeof params === 'object' && params.stream === true;
        const spanConfig = {
            name: `${operationName} ${model}`,
            op: (0, $82ea5b14697578b2$export$5e8bff7a65941113)(methodPath),
            attributes: requestAttributes
        };
        if (isStreamRequested) {
            let originalResult;
            const instrumentedPromise = (0, $c9161b67125aefc1$export$c10292ad04b92aea)(spanConfig, (span)=>{
                originalResult = originalMethod.apply(context, args);
                if (options.recordInputs && params) $eb0cfc8c9d413cf3$var$addRequestAttributes(span, params, operationName);
                // Return async processing
                return (async ()=>{
                    try {
                        const result = await originalResult;
                        return (0, $f8f7be6c0cd677cd$export$b764c730176bd1aa)(result, span, options.recordOutputs ?? false);
                    } catch (error) {
                        span.setStatus({
                            code: (0, $fda37f10dc06a152$export$f966a0446ece71e),
                            message: 'internal_error'
                        });
                        (0, $6918c722b531ff18$export$f5282963edea4a68)(error, {
                            mechanism: {
                                handled: false,
                                type: 'auto.ai.openai.stream',
                                data: {
                                    function: methodPath
                                }
                            }
                        });
                        span.end();
                        throw error;
                    }
                })();
            });
            return $eb0cfc8c9d413cf3$var$wrapPromiseWithMethods(originalResult, instrumentedPromise);
        }
        // Non-streaming
        let originalResult;
        const instrumentedPromise = (0, $c9161b67125aefc1$export$a1bd95187356f372)(spanConfig, (span)=>{
            // Call synchronously to capture the promise
            originalResult = originalMethod.apply(context, args);
            if (options.recordInputs && params) $eb0cfc8c9d413cf3$var$addRequestAttributes(span, params, operationName);
            return originalResult.then((result)=>{
                $eb0cfc8c9d413cf3$var$addResponseAttributes(span, result, options.recordOutputs);
                return result;
            }, (error)=>{
                (0, $6918c722b531ff18$export$f5282963edea4a68)(error, {
                    mechanism: {
                        handled: false,
                        type: 'auto.ai.openai',
                        data: {
                            function: methodPath
                        }
                    }
                });
                throw error;
            });
        });
        return $eb0cfc8c9d413cf3$var$wrapPromiseWithMethods(originalResult, instrumentedPromise);
    };
}
/**
 * Create a deep proxy for OpenAI client instrumentation
 */ function $eb0cfc8c9d413cf3$var$createDeepProxy(target, currentPath = '', options) {
    return new Proxy(target, {
        get (obj, prop) {
            const value = obj[prop];
            const methodPath = (0, $82ea5b14697578b2$export$d7a5998392457f14)(currentPath, String(prop));
            if (typeof value === 'function' && (0, $82ea5b14697578b2$export$f5188c19ec4120e7)(methodPath)) return $eb0cfc8c9d413cf3$var$instrumentMethod(value, methodPath, obj, options);
            if (typeof value === 'function') // Bind non-instrumented functions to preserve the original `this` context,
            // which is required for accessing private class fields (e.g. #baseURL) in OpenAI SDK v5.
            return value.bind(obj);
            if (value && typeof value === 'object') return $eb0cfc8c9d413cf3$var$createDeepProxy(value, methodPath, options);
            return value;
        }
    });
}
/**
 * Instrument an OpenAI client with Sentry tracing
 * Can be used across Node.js, Cloudflare Workers, and Vercel Edge
 */ function $eb0cfc8c9d413cf3$export$f7dad3b0c0584a13(client, options) {
    return $eb0cfc8c9d413cf3$var$createDeepProxy(client, '', (0, $33812c936a44f60e$export$ac4bb282bdbe5b74)(options));
}











// Based on Kamil Ogórek's work on:
// https://github.com/supabase-community/sentry-integration-js
const $eb131015662833f2$var$AUTH_OPERATIONS_TO_INSTRUMENT = [
    'reauthenticate',
    'signInAnonymously',
    'signInWithOAuth',
    'signInWithIdToken',
    'signInWithOtp',
    'signInWithPassword',
    'signInWithSSO',
    'signOut',
    'signUp',
    'verifyOtp'
];
const $eb131015662833f2$var$AUTH_ADMIN_OPERATIONS_TO_INSTRUMENT = [
    'createUser',
    'deleteUser',
    'listUsers',
    'getUserById',
    'updateUserById',
    'inviteUserByEmail'
];
const $eb131015662833f2$export$d0904ca37147fb52 = {
    eq: 'eq',
    neq: 'neq',
    gt: 'gt',
    gte: 'gte',
    lt: 'lt',
    lte: 'lte',
    like: 'like',
    'like(all)': 'likeAllOf',
    'like(any)': 'likeAnyOf',
    ilike: 'ilike',
    'ilike(all)': 'ilikeAllOf',
    'ilike(any)': 'ilikeAnyOf',
    is: 'is',
    in: 'in',
    cs: 'contains',
    cd: 'containedBy',
    sr: 'rangeGt',
    nxl: 'rangeGte',
    sl: 'rangeLt',
    nxr: 'rangeLte',
    adj: 'rangeAdjacent',
    ov: 'overlaps',
    fts: '',
    plfts: 'plain',
    phfts: 'phrase',
    wfts: 'websearch',
    not: 'not'
};
const $eb131015662833f2$export$31e06e7dfa7807a2 = [
    'select',
    'insert',
    'upsert',
    'update',
    'delete'
];
function $eb131015662833f2$var$markAsInstrumented(fn) {
    try {
        fn.__SENTRY_INSTRUMENTED__ = true;
    } catch  {
    // ignore errors here
    }
}
function $eb131015662833f2$var$isInstrumented(fn) {
    try {
        return fn.__SENTRY_INSTRUMENTED__;
    } catch  {
        return false;
    }
}
/**
 * Extracts the database operation type from the HTTP method and headers
 * @param method - The HTTP method of the request
 * @param headers - The request headers
 * @returns The database operation type ('select', 'insert', 'upsert', 'update', or 'delete')
 */ function $eb131015662833f2$export$f22380eda758c19d(method, headers = {}) {
    switch(method){
        case 'GET':
            return 'select';
        case 'POST':
            if (headers['Prefer']?.includes('resolution=')) return 'upsert';
            else return 'insert';
        case 'PATCH':
            return 'update';
        case 'DELETE':
            return 'delete';
        default:
            return '<unknown-op>';
    }
}
/**
 * Translates Supabase filter parameters into readable method names for tracing
 * @param key - The filter key from the URL search parameters
 * @param query - The filter value from the URL search parameters
 * @returns A string representation of the filter as a method call
 */ function $eb131015662833f2$export$d75b19044f24c22b(key, query) {
    if (query === '' || query === '*') return 'select(*)';
    if (key === 'select') return `select(${query})`;
    if (key === 'or' || key.endsWith('.or')) return `${key}${query}`;
    const [filter, ...value] = query.split('.');
    let method;
    // Handle optional `configPart` of the filter
    if (filter?.startsWith('fts')) method = 'textSearch';
    else if (filter?.startsWith('plfts')) method = 'textSearch[plain]';
    else if (filter?.startsWith('phfts')) method = 'textSearch[phrase]';
    else if (filter?.startsWith('wfts')) method = 'textSearch[websearch]';
    else method = filter && $eb131015662833f2$export$d0904ca37147fb52[filter] || 'filter';
    return `${method}(${key}, ${value.join('.')})`;
}
function $eb131015662833f2$var$instrumentAuthOperation(operation, isAdmin = false) {
    return new Proxy(operation, {
        apply (target, thisArg, argumentsList) {
            return (0, $c9161b67125aefc1$export$a1bd95187356f372)({
                name: `auth ${isAdmin ? '(admin) ' : ''}${operation.name}`,
                attributes: {
                    [(0, $f337c80285f06f80$export$cca8dd30f57f805e)]: 'auto.db.supabase',
                    [(0, $f337c80285f06f80$export$1a413bd9a88fdb09)]: 'db',
                    'db.system': 'postgresql',
                    'db.operation': `auth.${isAdmin ? 'admin.' : ''}${operation.name}`
                }
            }, (span)=>{
                return Reflect.apply(target, thisArg, argumentsList).then((res)=>{
                    if (res && typeof res === 'object' && 'error' in res && res.error) {
                        span.setStatus({
                            code: (0, $fda37f10dc06a152$export$f966a0446ece71e)
                        });
                        (0, $6918c722b531ff18$export$f5282963edea4a68)(res.error, {
                            mechanism: {
                                handled: false,
                                type: 'auto.db.supabase.auth'
                            }
                        });
                    } else span.setStatus({
                        code: (0, $fda37f10dc06a152$export$58f7963109c806fc)
                    });
                    span.end();
                    return res;
                }).catch((err)=>{
                    span.setStatus({
                        code: (0, $fda37f10dc06a152$export$f966a0446ece71e)
                    });
                    span.end();
                    (0, $6918c722b531ff18$export$f5282963edea4a68)(err, {
                        mechanism: {
                            handled: false,
                            type: 'auto.db.supabase.auth'
                        }
                    });
                    throw err;
                }).then(...argumentsList);
            });
        }
    });
}
function $eb131015662833f2$var$instrumentSupabaseAuthClient(supabaseClientInstance) {
    const auth = supabaseClientInstance.auth;
    if (!auth || $eb131015662833f2$var$isInstrumented(supabaseClientInstance.auth)) return;
    for (const operation of $eb131015662833f2$var$AUTH_OPERATIONS_TO_INSTRUMENT){
        const authOperation = auth[operation];
        if (!authOperation) continue;
        if (typeof supabaseClientInstance.auth[operation] === 'function') supabaseClientInstance.auth[operation] = $eb131015662833f2$var$instrumentAuthOperation(authOperation);
    }
    for (const operation of $eb131015662833f2$var$AUTH_ADMIN_OPERATIONS_TO_INSTRUMENT){
        const authOperation = auth.admin[operation];
        if (!authOperation) continue;
        if (typeof supabaseClientInstance.auth.admin[operation] === 'function') supabaseClientInstance.auth.admin[operation] = $eb131015662833f2$var$instrumentAuthOperation(authOperation, true);
    }
    $eb131015662833f2$var$markAsInstrumented(supabaseClientInstance.auth);
}
function $eb131015662833f2$var$instrumentSupabaseClientConstructor(SupabaseClient) {
    if ($eb131015662833f2$var$isInstrumented(SupabaseClient.prototype.from)) return;
    SupabaseClient.prototype.from = new Proxy(SupabaseClient.prototype.from, {
        apply (target, thisArg, argumentsList) {
            const rv = Reflect.apply(target, thisArg, argumentsList);
            const PostgRESTQueryBuilder = rv.constructor;
            $eb131015662833f2$var$instrumentPostgRESTQueryBuilder(PostgRESTQueryBuilder);
            return rv;
        }
    });
    $eb131015662833f2$var$markAsInstrumented(SupabaseClient.prototype.from);
}
function $eb131015662833f2$var$instrumentPostgRESTFilterBuilder(PostgRESTFilterBuilder) {
    if ($eb131015662833f2$var$isInstrumented(PostgRESTFilterBuilder.prototype.then)) return;
    PostgRESTFilterBuilder.prototype.then = new Proxy(PostgRESTFilterBuilder.prototype.then, {
        apply (target, thisArg, argumentsList) {
            const operations = $eb131015662833f2$export$31e06e7dfa7807a2;
            const typedThis = thisArg;
            const operation = $eb131015662833f2$export$f22380eda758c19d(typedThis.method, typedThis.headers);
            if (!operations.includes(operation)) return Reflect.apply(target, thisArg, argumentsList);
            if (!typedThis?.url?.pathname || typeof typedThis.url.pathname !== 'string') return Reflect.apply(target, thisArg, argumentsList);
            const pathParts = typedThis.url.pathname.split('/');
            const table = pathParts.length > 0 ? pathParts[pathParts.length - 1] : '';
            const queryItems = [];
            for (const [key, value] of typedThis.url.searchParams.entries())// It's possible to have multiple entries for the same key, eg. `id=eq.7&id=eq.3`,
            // so we need to use array instead of object to collect them.
            queryItems.push($eb131015662833f2$export$d75b19044f24c22b(key, value));
            const body = Object.create(null);
            if ((0, $13cf2ed412f405fa$export$53b83ca8eaab0383)(typedThis.body)) for (const [key, value] of Object.entries(typedThis.body))body[key] = value;
            // Adding operation to the beginning of the description if it's not a `select` operation
            // For example, it can be an `insert` or `update` operation but the query can be `select(...)`
            // For `select` operations, we don't need repeat it in the description
            const description = `${operation === 'select' ? '' : `${operation}${body ? '(...) ' : ''}`}${queryItems.join(' ')} from(${table})`;
            const attributes = {
                'db.table': table,
                'db.schema': typedThis.schema,
                'db.url': typedThis.url.origin,
                'db.sdk': typedThis.headers['X-Client-Info'],
                'db.system': 'postgresql',
                'db.operation': operation,
                [(0, $f337c80285f06f80$export$cca8dd30f57f805e)]: 'auto.db.supabase',
                [(0, $f337c80285f06f80$export$1a413bd9a88fdb09)]: 'db'
            };
            if (queryItems.length) attributes['db.query'] = queryItems;
            if (Object.keys(body).length) attributes['db.body'] = body;
            return (0, $c9161b67125aefc1$export$a1bd95187356f372)({
                name: description,
                attributes: attributes
            }, (span)=>{
                return Reflect.apply(target, thisArg, []).then((res)=>{
                    if (span) {
                        if (res && typeof res === 'object' && 'status' in res) (0, $fda37f10dc06a152$export$2ad6630ec8164254)(span, res.status || 500);
                        span.end();
                    }
                    if (res.error) {
                        const err = new Error(res.error.message);
                        if (res.error.code) err.code = res.error.code;
                        if (res.error.details) err.details = res.error.details;
                        const supabaseContext = {};
                        if (queryItems.length) supabaseContext.query = queryItems;
                        if (Object.keys(body).length) supabaseContext.body = body;
                        (0, $6918c722b531ff18$export$f5282963edea4a68)(err, (scope)=>{
                            scope.addEventProcessor((e)=>{
                                (0, $cc262db35458e4b3$export$c69a9a0313b03bb1)(e, {
                                    handled: false,
                                    type: 'auto.db.supabase.postgres'
                                });
                                return e;
                            });
                            scope.setContext('supabase', supabaseContext);
                            return scope;
                        });
                    }
                    const breadcrumb = {
                        type: 'supabase',
                        category: `db.${operation}`,
                        message: description
                    };
                    const data = {};
                    if (queryItems.length) data.query = queryItems;
                    if (Object.keys(body).length) data.body = body;
                    if (Object.keys(data).length) breadcrumb.data = data;
                    (0, $777cacbd1bed0b63$export$efda9a273d7a036d)(breadcrumb);
                    return res;
                }, (err)=>{
                    // TODO: shouldn't we capture this error?
                    if (span) {
                        (0, $fda37f10dc06a152$export$2ad6630ec8164254)(span, 500);
                        span.end();
                    }
                    throw err;
                }).then(...argumentsList);
            });
        }
    });
    $eb131015662833f2$var$markAsInstrumented(PostgRESTFilterBuilder.prototype.then);
}
function $eb131015662833f2$var$instrumentPostgRESTQueryBuilder(PostgRESTQueryBuilder) {
    // We need to wrap _all_ operations despite them sharing the same `PostgRESTFilterBuilder`
    // constructor, as we don't know which method will be called first, and we don't want to miss any calls.
    for (const operation of $eb131015662833f2$export$31e06e7dfa7807a2){
        if ($eb131015662833f2$var$isInstrumented(PostgRESTQueryBuilder.prototype[operation])) continue;
        PostgRESTQueryBuilder.prototype[operation] = new Proxy(PostgRESTQueryBuilder.prototype[operation], {
            apply (target, thisArg, argumentsList) {
                const rv = Reflect.apply(target, thisArg, argumentsList);
                const PostgRESTFilterBuilder = rv.constructor;
                (0, $19fdbaf7f0830971$export$16a28057038b10ef) && (0, $d11ed0b3cdda6b8d$export$1c9f709888824e05).log(`Instrumenting ${operation} operation's PostgRESTFilterBuilder`);
                $eb131015662833f2$var$instrumentPostgRESTFilterBuilder(PostgRESTFilterBuilder);
                return rv;
            }
        });
        $eb131015662833f2$var$markAsInstrumented(PostgRESTQueryBuilder.prototype[operation]);
    }
}
const $eb131015662833f2$export$a286d61fd33c7083 = (supabaseClient)=>{
    if (!supabaseClient) {
        (0, $19fdbaf7f0830971$export$16a28057038b10ef) && (0, $d11ed0b3cdda6b8d$export$1c9f709888824e05).warn('Supabase integration was not installed because no Supabase client was provided.');
        return;
    }
    const SupabaseClientConstructor = supabaseClient.constructor === Function ? supabaseClient : supabaseClient.constructor;
    $eb131015662833f2$var$instrumentSupabaseClientConstructor(SupabaseClientConstructor);
    $eb131015662833f2$var$instrumentSupabaseAuthClient(supabaseClient);
};
const $eb131015662833f2$var$INTEGRATION_NAME = 'Supabase';
const $eb131015662833f2$var$_supabaseIntegration = (supabaseClient)=>{
    return {
        setupOnce () {
            $eb131015662833f2$export$a286d61fd33c7083(supabaseClient);
        },
        name: $eb131015662833f2$var$INTEGRATION_NAME
    };
};
const $eb131015662833f2$export$856ced54ce86f97e = (0, $cbb2da6c78246e45$export$2323046b9414659f)((options)=>{
    return $eb131015662833f2$var$_supabaseIntegration(options.supabaseClient);
});

var $429304b17eb78491$exports = {};
$parcel$export($429304b17eb78491$exports, "trace", () => $429304b17eb78491$export$357889f174732d38);
$parcel$export($429304b17eb78491$exports, "debug", () => $429304b17eb78491$export$1c9f709888824e05);
$parcel$export($429304b17eb78491$exports, "info", () => $429304b17eb78491$export$a80b3bd66acc52ff);
$parcel$export($429304b17eb78491$exports, "warn", () => $429304b17eb78491$export$c106dd0671a0fc2d);
$parcel$export($429304b17eb78491$exports, "error", () => $429304b17eb78491$export$a3bc9b8ed74fc);
$parcel$export($429304b17eb78491$exports, "fatal", () => $429304b17eb78491$export$570101a5202fba29);
$parcel$export($429304b17eb78491$exports, "fmt", () => $7c398daf82b5cdeb$export$bc71a178fd8db0f);

/**
 * Tagged template function which returns parameterized representation of the message
 * For example: parameterize`This is a log statement with ${x} and ${y} params`, would return:
 * "__sentry_template_string__": 'This is a log statement with %s and %s params',
 * "__sentry_template_values__": ['first', 'second']
 *
 * @param strings An array of string values splitted between expressions
 * @param values Expressions extracted from template string
 *
 * @returns A `ParameterizedString` object that can be passed into `captureMessage` or Sentry.logger.X methods.
 */ function $7c398daf82b5cdeb$export$4cb5eb704d6ec224(strings, ...values) {
    const formatted = new String(String.raw(strings, ...values));
    formatted.__sentry_template_string__ = strings.join('\x00').replace(/%/g, '%%').replace(/\0/g, '%s');
    formatted.__sentry_template_values__ = values;
    return formatted;
}
/**
 * Tagged template function which returns parameterized representation of the message.
 *
 * @param strings An array of string values splitted between expressions
 * @param values Expressions extracted from template string
 * @returns A `ParameterizedString` object that can be passed into `captureMessage` or Sentry.logger.X methods.
 */ const $7c398daf82b5cdeb$export$bc71a178fd8db0f = $7c398daf82b5cdeb$export$4cb5eb704d6ec224;


/**
 * Capture a log with the given level.
 *
 * @param level - The level of the log.
 * @param message - The message to log.
 * @param attributes - Arbitrary structured data that stores information about the log - e.g., userId: 100.
 * @param scope - The scope to capture the log with.
 * @param severityNumber - The severity number of the log.
 */ function $429304b17eb78491$var$captureLog(level, message, attributes, scope, severityNumber) {
    (0, $aedf2f5a49662da4$export$3ab3d16b9eebd986)({
        level: level,
        message: message,
        attributes: attributes,
        severityNumber: severityNumber
    }, scope);
}
/**
 * Additional metadata to capture the log with.
 */ /**
 * @summary Capture a log with the `trace` level. Requires the `enableLogs` option to be enabled.
 *
 * @param message - The message to log.
 * @param attributes - Arbitrary structured data that stores information about the log - e.g., { userId: 100, route: '/dashboard' }.
 * @param metadata - additional metadata to capture the log with.
 *
 * @example
 *
 * ```
 * Sentry.logger.trace('User clicked submit button', {
 *   buttonId: 'submit-form',
 *   formId: 'user-profile',
 *   timestamp: Date.now()
 * });
 * ```
 *
 * @example With template strings
 *
 * ```
 * Sentry.logger.trace(Sentry.logger.fmt`User ${user} navigated to ${page}`, {
 *   userId: '123',
 *   sessionId: 'abc-xyz'
 * });
 * ```
 */ function $429304b17eb78491$export$357889f174732d38(message, attributes, { scope: scope } = {}) {
    $429304b17eb78491$var$captureLog('trace', message, attributes, scope);
}
/**
 * @summary Capture a log with the `debug` level. Requires the `enableLogs` option to be enabled.
 *
 * @param message - The message to log.
 * @param attributes - Arbitrary structured data that stores information about the log - e.g., { component: 'Header', state: 'loading' }.
 * @param metadata - additional metadata to capture the log with.
 *
 * @example
 *
 * ```
 * Sentry.logger.debug('Component mounted', {
 *   component: 'UserProfile',
 *   props: { userId: 123 },
 *   renderTime: 150
 * });
 * ```
 *
 * @example With template strings
 *
 * ```
 * Sentry.logger.debug(Sentry.logger.fmt`API request to ${endpoint} failed`, {
 *   statusCode: 404,
 *   requestId: 'req-123',
 *   duration: 250
 * });
 * ```
 */ function $429304b17eb78491$export$1c9f709888824e05(message, attributes, { scope: scope } = {}) {
    $429304b17eb78491$var$captureLog('debug', message, attributes, scope);
}
/**
 * @summary Capture a log with the `info` level. Requires the `enableLogs` option to be enabled.
 *
 * @param message - The message to log.
 * @param attributes - Arbitrary structured data that stores information about the log - e.g., { feature: 'checkout', status: 'completed' }.
 * @param metadata - additional metadata to capture the log with.
 *
 * @example
 *
 * ```
 * Sentry.logger.info('User completed checkout', {
 *   orderId: 'order-123',
 *   amount: 99.99,
 *   paymentMethod: 'credit_card'
 * });
 * ```
 *
 * @example With template strings
 *
 * ```
 * Sentry.logger.info(Sentry.logger.fmt`User ${user} updated profile picture`, {
 *   userId: 'user-123',
 *   imageSize: '2.5MB',
 *   timestamp: Date.now()
 * });
 * ```
 */ function $429304b17eb78491$export$a80b3bd66acc52ff(message, attributes, { scope: scope } = {}) {
    $429304b17eb78491$var$captureLog('info', message, attributes, scope);
}
/**
 * @summary Capture a log with the `warn` level. Requires the `enableLogs` option to be enabled.
 *
 * @param message - The message to log.
 * @param attributes - Arbitrary structured data that stores information about the log - e.g., { browser: 'Chrome', version: '91.0' }.
 * @param metadata - additional metadata to capture the log with.
 *
 * @example
 *
 * ```
 * Sentry.logger.warn('Browser compatibility issue detected', {
 *   browser: 'Safari',
 *   version: '14.0',
 *   feature: 'WebRTC',
 *   fallback: 'enabled'
 * });
 * ```
 *
 * @example With template strings
 *
 * ```
 * Sentry.logger.warn(Sentry.logger.fmt`API endpoint ${endpoint} is deprecated`, {
 *   recommendedEndpoint: '/api/v2/users',
 *   sunsetDate: '2024-12-31',
 *   clientVersion: '1.2.3'
 * });
 * ```
 */ function $429304b17eb78491$export$c106dd0671a0fc2d(message, attributes, { scope: scope } = {}) {
    $429304b17eb78491$var$captureLog('warn', message, attributes, scope);
}
/**
 * @summary Capture a log with the `error` level. Requires the `enableLogs` option to be enabled.
 *
 * @param message - The message to log.
 * @param attributes - Arbitrary structured data that stores information about the log - e.g., { error: 'NetworkError', url: '/api/data' }.
 * @param metadata - additional metadata to capture the log with.
 *
 * @example
 *
 * ```
 * Sentry.logger.error('Failed to load user data', {
 *   error: 'NetworkError',
 *   url: '/api/users/123',
 *   statusCode: 500,
 *   retryCount: 3
 * });
 * ```
 *
 * @example With template strings
 *
 * ```
 * Sentry.logger.error(Sentry.logger.fmt`Payment processing failed for order ${orderId}`, {
 *   error: 'InsufficientFunds',
 *   amount: 100.00,
 *   currency: 'USD',
 *   userId: 'user-456'
 * });
 * ```
 */ function $429304b17eb78491$export$a3bc9b8ed74fc(message, attributes, { scope: scope } = {}) {
    $429304b17eb78491$var$captureLog('error', message, attributes, scope);
}
/**
 * @summary Capture a log with the `fatal` level. Requires the `enableLogs` option to be enabled.
 *
 * @param message - The message to log.
 * @param attributes - Arbitrary structured data that stores information about the log - e.g., { appState: 'corrupted', sessionId: 'abc-123' }.
 * @param metadata - additional metadata to capture the log with.
 *
 * @example
 *
 * ```
 * Sentry.logger.fatal('Application state corrupted', {
 *   lastKnownState: 'authenticated',
 *   sessionId: 'session-123',
 *   timestamp: Date.now(),
 *   recoveryAttempted: true
 * });
 * ```
 *
 * @example With template strings
 *
 * ```
 * Sentry.logger.fatal(Sentry.logger.fmt`Critical system failure in ${service}`, {
 *   service: 'payment-processor',
 *   errorCode: 'CRITICAL_FAILURE',
 *   affectedUsers: 150,
 *   timestamp: Date.now()
 * });
 * ```
 */ function $429304b17eb78491$export$570101a5202fba29(message, attributes, { scope: scope } = {}) {
    $429304b17eb78491$var$captureLog('fatal', message, attributes, scope);
}


const $95bd43db10a47155$var$SENTRY_API_VERSION = '7';
/** Returns the prefix to construct Sentry ingestion API endpoints. */ function $95bd43db10a47155$var$getBaseApiEndpoint(dsn) {
    const protocol = dsn.protocol ? `${dsn.protocol}:` : '';
    const port = dsn.port ? `:${dsn.port}` : '';
    return `${protocol}//${dsn.host}${port}${dsn.path ? `/${dsn.path}` : ''}/api/`;
}
/** Returns the ingest API endpoint for target. */ function $95bd43db10a47155$var$_getIngestEndpoint(dsn) {
    return `${$95bd43db10a47155$var$getBaseApiEndpoint(dsn)}${dsn.projectId}/envelope/`;
}
/** Returns a URL-encoded string with auth config suitable for a query string. */ function $95bd43db10a47155$var$_encodedAuth(dsn, sdkInfo) {
    const params = {
        sentry_version: $95bd43db10a47155$var$SENTRY_API_VERSION
    };
    if (dsn.publicKey) // We send only the minimum set of required information. See
    // https://github.com/getsentry/sentry-javascript/issues/2572.
    params.sentry_key = dsn.publicKey;
    if (sdkInfo) params.sentry_client = `${sdkInfo.name}/${sdkInfo.version}`;
    return new URLSearchParams(params).toString();
}
/**
 * Returns the envelope endpoint URL with auth in the query string.
 *
 * Sending auth as part of the query string and not as custom HTTP headers avoids CORS preflight requests.
 */ function $95bd43db10a47155$export$9964600bfe84e6a3(dsn, tunnel, sdkInfo) {
    return tunnel ? tunnel : `${$95bd43db10a47155$var$_getIngestEndpoint(dsn)}?${$95bd43db10a47155$var$_encodedAuth(dsn, sdkInfo)}`;
}
/** Returns the url to the report dialog endpoint. */ function $95bd43db10a47155$export$671c7ed8e40a7a57(dsnLike, dialogOptions) {
    const dsn = (0, $1e1399eeae328b26$export$128827c3562ec0cb)(dsnLike);
    if (!dsn) return '';
    const endpoint = `${$95bd43db10a47155$var$getBaseApiEndpoint(dsn)}embed/error-page/`;
    let encodedOptions = `dsn=${(0, $1e1399eeae328b26$export$44d472fbb931a776)(dsn)}`;
    for(const key in dialogOptions){
        if (key === 'dsn') continue;
        if (key === 'onClose') continue;
        if (key === 'user') {
            const user = dialogOptions.user;
            if (!user) continue;
            if (user.name) encodedOptions += `&name=${encodeURIComponent(user.name)}`;
            if (user.email) encodedOptions += `&email=${encodeURIComponent(user.email)}`;
        } else encodedOptions += `&${encodeURIComponent(key)}=${encodeURIComponent(dialogOptions[key])}`;
    }
    return `${endpoint}?${encodedOptions}`;
}




/**
 * Key used in event.extra to provide routing information for the multiplexed transport.
 * Should contain an array of `{ dsn: string, release?: string }` objects.
 */ const $5ad689bd228113be$export$8e279000b0e1318 = 'MULTIPLEXED_TRANSPORT_EXTRA_KEY';
/**
 * Gets an event from an envelope.
 *
 * This is only exported for use in the tests
 */ function $5ad689bd228113be$export$b92f55f7516d9100(env, types) {
    let event;
    (0, $bb063ad93c8b79c7$export$c56c55acf0136fd3)(env, (item, type)=>{
        if (types.includes(type)) event = Array.isArray(item) ? item[1] : undefined;
        // bail out if we found an event
        return !!event;
    });
    return event;
}
/**
 * Creates a transport that overrides the release on all events.
 */ function $5ad689bd228113be$var$makeOverrideReleaseTransport(createTransport, release) {
    return (options)=>{
        const transport = createTransport(options);
        return {
            ...transport,
            send: async (envelope)=>{
                const event = $5ad689bd228113be$export$b92f55f7516d9100(envelope, [
                    'event',
                    'transaction',
                    'profile',
                    'replay_event'
                ]);
                if (event) event.release = release;
                return transport.send(envelope);
            }
        };
    };
}
/** Overrides the DSN in the envelope header  */ function $5ad689bd228113be$var$overrideDsn(envelope, dsn) {
    return (0, $bb063ad93c8b79c7$export$f93f7f385160c44e)(dsn ? {
        ...envelope[0],
        dsn: dsn
    } : envelope[0], envelope[1]);
}
/**
 * Creates a transport that can send events to different DSNs depending on the envelope contents.
 *
 * If no matcher is provided, the transport will look for routing information in
 * `event.extra[MULTIPLEXED_TRANSPORT_EXTRA_KEY]`, which should contain
 * an array of `{ dsn: string, release?: string }` objects.
 */ function $5ad689bd228113be$export$53bbcd410607e756(createTransport, matcher) {
    return (options)=>{
        const fallbackTransport = createTransport(options);
        const otherTransports = new Map();
        // Use provided matcher or default to simple multiplexed transport behavior
        const actualMatcher = matcher || ((args)=>{
            const event = args.getEvent();
            if (event?.extra?.[$5ad689bd228113be$export$8e279000b0e1318] && Array.isArray(event.extra[$5ad689bd228113be$export$8e279000b0e1318])) return event.extra[$5ad689bd228113be$export$8e279000b0e1318];
            return [];
        });
        function getTransport(dsn, release) {
            // We create a transport for every unique dsn/release combination as there may be code from multiple releases in
            // use at the same time
            const key = release ? `${dsn}:${release}` : dsn;
            let transport = otherTransports.get(key);
            if (!transport) {
                const validatedDsn = (0, $1e1399eeae328b26$export$b892860177f70a30)(dsn);
                if (!validatedDsn) return undefined;
                const url = (0, $95bd43db10a47155$export$9964600bfe84e6a3)(validatedDsn, options.tunnel);
                transport = release ? $5ad689bd228113be$var$makeOverrideReleaseTransport(createTransport, release)({
                    ...options,
                    url: url
                }) : createTransport({
                    ...options,
                    url: url
                });
                otherTransports.set(key, transport);
            }
            return [
                dsn,
                transport
            ];
        }
        async function send(envelope) {
            function getEvent(types) {
                const eventTypes = types?.length ? types : [
                    'event'
                ];
                return $5ad689bd228113be$export$b92f55f7516d9100(envelope, eventTypes);
            }
            const transports = actualMatcher({
                envelope: envelope,
                getEvent: getEvent
            }).map((result)=>{
                if (typeof result === 'string') return getTransport(result, undefined);
                else return getTransport(result.dsn, result.release);
            }).filter((t)=>!!t);
            // If we have no transports to send to, use the fallback transport
            // Don't override the DSN in the header for the fallback transport. '' is falsy
            const transportsWithFallback = transports.length ? transports : [
                [
                    '',
                    fallbackTransport
                ]
            ];
            const results = await Promise.all(transportsWithFallback.map(([dsn, transport])=>transport.send($5ad689bd228113be$var$overrideDsn(envelope, dsn))));
            return results[0];
        }
        async function flush(timeout) {
            const allTransports = [
                ...otherTransports.values(),
                fallbackTransport
            ];
            const results = await Promise.all(allTransports.map((transport)=>transport.flush(timeout)));
            return results.every((r)=>r);
        }
        return {
            send: send,
            flush: flush
        };
    };
}

var $240914cce3cb7287$exports = {};
$parcel$export($240914cce3cb7287$exports, "count", () => $240914cce3cb7287$export$85b9a36db797e02b);
$parcel$export($240914cce3cb7287$exports, "gauge", () => $240914cce3cb7287$export$b0660673397c6c28);
$parcel$export($240914cce3cb7287$exports, "distribution", () => $240914cce3cb7287$export$fd8e353f0040520a);












/**
 * Creates a metric container envelope item for a list of metrics.
 *
 * @param items - The metrics to include in the envelope.
 * @returns The created metric container envelope item.
 */ function $1921770c7aa60e48$export$58e45eb52ad1077d(items) {
    return [
        {
            type: 'trace_metric',
            item_count: items.length,
            content_type: 'application/vnd.sentry.items.trace-metric+json'
        },
        {
            items: items
        }
    ];
}
/**
 * Creates an envelope for a list of metrics.
 *
 * Metrics from multiple traces can be included in the same envelope.
 *
 * @param metrics - The metrics to include in the envelope.
 * @param metadata - The metadata to include in the envelope.
 * @param tunnel - The tunnel to include in the envelope.
 * @param dsn - The DSN to include in the envelope.
 * @returns The created envelope.
 */ function $1921770c7aa60e48$export$f23eb96e33154901(metrics, metadata, tunnel, dsn) {
    const headers = {};
    if (metadata?.sdk) headers.sdk = {
        name: metadata.sdk.name,
        version: metadata.sdk.version
    };
    if (!!tunnel && !!dsn) headers.dsn = (0, $1e1399eeae328b26$export$44d472fbb931a776)(dsn);
    return (0, $bb063ad93c8b79c7$export$f93f7f385160c44e)(headers, [
        $1921770c7aa60e48$export$58e45eb52ad1077d(metrics)
    ]);
}


const $8ed8fd97ec1f999f$var$MAX_METRIC_BUFFER_SIZE = 1000;
/**
 * Sets a metric attribute if the value exists and the attribute key is not already present.
 *
 * @param metricAttributes - The metric attributes object to modify.
 * @param key - The attribute key to set.
 * @param value - The value to set (only sets if truthy and key not present).
 * @param setEvenIfPresent - Whether to set the attribute if it is present. Defaults to true.
 */ function $8ed8fd97ec1f999f$var$setMetricAttribute(metricAttributes, key, value, setEvenIfPresent = true) {
    if (value && (setEvenIfPresent || !(key in metricAttributes))) metricAttributes[key] = value;
}
/**
 * Captures a serialized metric event and adds it to the metric buffer for the given client.
 *
 * @param client - A client. Uses the current client if not provided.
 * @param serializedMetric - The serialized metric event to capture.
 *
 * @experimental This method will experience breaking changes. This is not yet part of
 * the stable Sentry SDK API and can be changed or removed without warning.
 */ function $8ed8fd97ec1f999f$export$84661fd26e6cac96(client, serializedMetric) {
    const bufferMap = $8ed8fd97ec1f999f$var$_getBufferMap();
    const metricBuffer = $8ed8fd97ec1f999f$export$49385134251b08ff(client);
    if (metricBuffer === undefined) bufferMap.set(client, [
        serializedMetric
    ]);
    else if (metricBuffer.length >= $8ed8fd97ec1f999f$var$MAX_METRIC_BUFFER_SIZE) {
        $8ed8fd97ec1f999f$export$91c9ef254b7d0f67(client, metricBuffer);
        bufferMap.set(client, [
            serializedMetric
        ]);
    } else bufferMap.set(client, [
        ...metricBuffer,
        serializedMetric
    ]);
}
/**
 * Options for capturing a metric internally.
 */ /**
 * Enriches metric with all contextual attributes (user, SDK metadata, replay, etc.)
 */ function $8ed8fd97ec1f999f$var$_enrichMetricAttributes(beforeMetric, client, user) {
    const { release: release, environment: environment } = client.getOptions();
    const processedMetricAttributes = {
        ...beforeMetric.attributes
    };
    // Add user attributes
    $8ed8fd97ec1f999f$var$setMetricAttribute(processedMetricAttributes, 'user.id', user.id, false);
    $8ed8fd97ec1f999f$var$setMetricAttribute(processedMetricAttributes, 'user.email', user.email, false);
    $8ed8fd97ec1f999f$var$setMetricAttribute(processedMetricAttributes, 'user.name', user.username, false);
    // Add Sentry metadata
    $8ed8fd97ec1f999f$var$setMetricAttribute(processedMetricAttributes, 'sentry.release', release);
    $8ed8fd97ec1f999f$var$setMetricAttribute(processedMetricAttributes, 'sentry.environment', environment);
    // Add SDK metadata
    const { name: name, version: version } = client.getSdkMetadata()?.sdk ?? {};
    $8ed8fd97ec1f999f$var$setMetricAttribute(processedMetricAttributes, 'sentry.sdk.name', name);
    $8ed8fd97ec1f999f$var$setMetricAttribute(processedMetricAttributes, 'sentry.sdk.version', version);
    // Add replay metadata
    const replay = client.getIntegrationByName('Replay');
    const replayId = replay?.getReplayId(true);
    $8ed8fd97ec1f999f$var$setMetricAttribute(processedMetricAttributes, 'sentry.replay_id', replayId);
    if (replayId && replay?.getRecordingMode() === 'buffer') $8ed8fd97ec1f999f$var$setMetricAttribute(processedMetricAttributes, 'sentry._internal.replay_is_buffering', true);
    return {
        ...beforeMetric,
        attributes: processedMetricAttributes
    };
}
/**
 * Creates a serialized metric ready to be sent to Sentry.
 */ function $8ed8fd97ec1f999f$var$_buildSerializedMetric(metric, client, currentScope, scopeAttributes) {
    // Get trace context
    const [, traceContext] = (0, $79fd34a78625a040$export$fb7d833b3fdedf5f)(client, currentScope);
    const span = (0, $dab1970d0c142a42$export$91f063ebb8eff307)(currentScope);
    const traceId = span ? span.spanContext().traceId : traceContext?.trace_id;
    const spanId = span ? span.spanContext().spanId : undefined;
    const timestamp = (0, $bc81602376c48fa6$export$ee52dced521e3e18)();
    const sequenceAttr = (0, $443993e122065548$export$63ada7b125d23ef9)(timestamp);
    return {
        timestamp: timestamp,
        trace_id: traceId ?? '',
        span_id: spanId,
        name: metric.name,
        type: metric.type,
        unit: metric.unit,
        value: metric.value,
        attributes: {
            ...(0, $930f69313cc0b0d6$export$4954cae66e755861)(scopeAttributes),
            ...(0, $930f69313cc0b0d6$export$4954cae66e755861)(metric.attributes, 'skip-undefined'),
            [sequenceAttr.key]: sequenceAttr.value
        }
    };
}
/**
 * Captures a metric event and sends it to Sentry.
 *
 * @param metric - The metric event to capture.
 * @param options - Options for capturing the metric.
 *
 * @experimental This method will experience breaking changes. This is not yet part of
 * the stable Sentry SDK API and can be changed or removed without warning.
 */ function $8ed8fd97ec1f999f$export$288d896e6652e0c4(beforeMetric, options) {
    const currentScope = options?.scope ?? (0, $7d48e1ed9f699a01$export$c7be4b0125a10cba)();
    const captureSerializedMetric = options?.captureSerializedMetric ?? $8ed8fd97ec1f999f$export$84661fd26e6cac96;
    const client = currentScope?.getClient() ?? (0, $7d48e1ed9f699a01$export$6bb76d6eba7e258c)();
    if (!client) {
        (0, $19fdbaf7f0830971$export$16a28057038b10ef) && (0, $d11ed0b3cdda6b8d$export$1c9f709888824e05).warn('No client available to capture metric.');
        return;
    }
    const { _experiments: _experiments, enableMetrics: enableMetrics, beforeSendMetric: beforeSendMetric } = client.getOptions();
    // todo(v11): Remove the experimental flag
    // eslint-disable-next-line deprecation/deprecation
    const metricsEnabled = enableMetrics ?? _experiments?.enableMetrics ?? true;
    if (!metricsEnabled) {
        (0, $19fdbaf7f0830971$export$16a28057038b10ef) && (0, $d11ed0b3cdda6b8d$export$1c9f709888824e05).warn('metrics option not enabled, metric will not be captured.');
        return;
    }
    // Enrich metric with contextual attributes
    const { user: user, attributes: scopeAttributes } = (0, $9a2c488a2b943a4e$export$cc422922fcbb91c6)((0, $7d48e1ed9f699a01$export$68f3af03034c9e90)(), currentScope);
    const enrichedMetric = $8ed8fd97ec1f999f$var$_enrichMetricAttributes(beforeMetric, client, user);
    client.emit('processMetric', enrichedMetric);
    // todo(v11): Remove the experimental `beforeSendMetric`
    // eslint-disable-next-line deprecation/deprecation
    const beforeSendCallback = beforeSendMetric || _experiments?.beforeSendMetric;
    const processedMetric = beforeSendCallback ? beforeSendCallback(enrichedMetric) : enrichedMetric;
    if (!processedMetric) {
        (0, $19fdbaf7f0830971$export$16a28057038b10ef) && (0, $d11ed0b3cdda6b8d$export$1c9f709888824e05).log('`beforeSendMetric` returned `null`, will not send metric.');
        return;
    }
    const serializedMetric = $8ed8fd97ec1f999f$var$_buildSerializedMetric(processedMetric, client, currentScope, scopeAttributes);
    (0, $19fdbaf7f0830971$export$16a28057038b10ef) && (0, $d11ed0b3cdda6b8d$export$1c9f709888824e05).log('[Metric]', serializedMetric);
    captureSerializedMetric(client, serializedMetric);
    client.emit('afterCaptureMetric', processedMetric);
}
/**
 * Flushes the metrics buffer to Sentry.
 *
 * @param client - A client.
 * @param maybeMetricBuffer - A metric buffer. Uses the metric buffer for the given client if not provided.
 *
 * @experimental This method will experience breaking changes. This is not yet part of
 * the stable Sentry SDK API and can be changed or removed without warning.
 */ function $8ed8fd97ec1f999f$export$91c9ef254b7d0f67(client, maybeMetricBuffer) {
    const metricBuffer = maybeMetricBuffer ?? $8ed8fd97ec1f999f$export$49385134251b08ff(client) ?? [];
    if (metricBuffer.length === 0) return;
    const clientOptions = client.getOptions();
    const envelope = (0, $1921770c7aa60e48$export$f23eb96e33154901)(metricBuffer, clientOptions._metadata, clientOptions.tunnel, client.getDsn());
    // Clear the metric buffer after envelopes have been constructed.
    $8ed8fd97ec1f999f$var$_getBufferMap().set(client, []);
    client.emit('flushMetrics');
    // sendEnvelope should not throw
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    client.sendEnvelope(envelope);
}
/**
 * Returns the metric buffer for a given client.
 *
 * Exported for testing purposes.
 *
 * @param client - The client to get the metric buffer for.
 * @returns The metric buffer for the given client.
 */ function $8ed8fd97ec1f999f$export$49385134251b08ff(client) {
    return $8ed8fd97ec1f999f$var$_getBufferMap().get(client);
}
function $8ed8fd97ec1f999f$var$_getBufferMap() {
    // The reference to the Client <> MetricBuffer map is stored on the carrier to ensure it's always the same
    return (0, $e4c75fb63b040566$export$7e223ec222791509)('clientToMetricBufferMap', ()=>new WeakMap());
}


/**
 * Options for capturing a metric.
 */ /**
 * Capture a metric with the given type, name, and value.
 *
 * @param type - The type of the metric.
 * @param name - The name of the metric.
 * @param value - The value of the metric.
 * @param options - Options for capturing the metric.
 */ function $240914cce3cb7287$var$captureMetric(type, name, value, options) {
    (0, $8ed8fd97ec1f999f$export$288d896e6652e0c4)({
        type: type,
        name: name,
        value: value,
        unit: options?.unit,
        attributes: options?.attributes
    }, {
        scope: options?.scope
    });
}
/**
 * @summary Increment a counter metric.
 *
 * @param name - The name of the counter metric.
 * @param value - The value to increment by (defaults to 1).
 * @param options - Options for capturing the metric.
 *
 * @example
 *
 * ```
 * Sentry.metrics.count('api.requests', 1, {
 *   attributes: {
 *     endpoint: '/api/users',
 *     method: 'GET',
 *     status: 200
 *   }
 * });
 * ```
 *
 * @example With custom value
 *
 * ```
 * Sentry.metrics.count('items.processed', 5, {
 *   attributes: {
 *     processor: 'batch-processor',
 *     queue: 'high-priority'
 *   }
 * });
 * ```
 */ function $240914cce3cb7287$export$85b9a36db797e02b(name, value = 1, options) {
    $240914cce3cb7287$var$captureMetric('counter', name, value, options);
}
/**
 * @summary Set a gauge metric to a specific value.
 *
 * @param name - The name of the gauge metric.
 * @param value - The current value of the gauge.
 * @param options - Options for capturing the metric.
 *
 * @example
 *
 * ```
 * Sentry.metrics.gauge('memory.usage', 1024, {
 *   unit: 'megabyte',
 *   attributes: {
 *     process: 'web-server',
 *     region: 'us-east-1'
 *   }
 * });
 * ```
 *
 * @example Without unit
 *
 * ```
 * Sentry.metrics.gauge('active.connections', 42, {
 *   attributes: {
 *     server: 'api-1',
 *     protocol: 'websocket'
 *   }
 * });
 * ```
 */ function $240914cce3cb7287$export$b0660673397c6c28(name, value, options) {
    $240914cce3cb7287$var$captureMetric('gauge', name, value, options);
}
/**
 * @summary Record a value in a distribution metric.
 *
 * @param name - The name of the distribution metric.
 * @param value - The value to record in the distribution.
 * @param options - Options for capturing the metric.
 *
 * @example
 *
 * ```
 * Sentry.metrics.distribution('task.duration', 500, {
 *   unit: 'millisecond',
 *   attributes: {
 *     task: 'data-processing',
 *     priority: 'high'
 *   }
 * });
 * ```
 *
 * @example Without unit
 *
 * ```
 * Sentry.metrics.distribution('batch.size', 100, {
 *   attributes: {
 *     processor: 'batch-1',
 *     type: 'async'
 *   }
 * });
 * ```
 */ function $240914cce3cb7287$export$fd8e353f0040520a(name, value, options) {
    $240914cce3cb7287$var$captureMetric('distribution', name, value, options);
}



/** Keys are source filename/url, values are metadata objects. */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
const $6a12befaf2e5f886$var$filenameMetadataMap = new Map();
/** Set of stack strings that have already been parsed. */ const $6a12befaf2e5f886$var$parsedStacks = new Set();
/**
 * Builds a map of filenames to module metadata from the global _sentryModuleMetadata object.
 * This is useful for forwarding metadata from web workers to the main thread.
 *
 * @param parser - Stack parser to use for extracting filenames from stack traces
 * @returns A map of filename to metadata object
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $6a12befaf2e5f886$export$7393e28464503428(parser) {
    if (!(0, $736a69486c86d36c$export$f1a6cdb1459e81d1)._sentryModuleMetadata) return {};
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const filenameMap = {};
    for (const stack of Object.keys((0, $736a69486c86d36c$export$f1a6cdb1459e81d1)._sentryModuleMetadata)){
        const metadata = (0, $736a69486c86d36c$export$f1a6cdb1459e81d1)._sentryModuleMetadata[stack];
        const frames = parser(stack);
        for (const frame of frames.reverse())if (frame.filename) {
            filenameMap[frame.filename] = metadata;
            break;
        }
    }
    return filenameMap;
}
function $6a12befaf2e5f886$var$ensureMetadataStacksAreParsed(parser) {
    if (!(0, $736a69486c86d36c$export$f1a6cdb1459e81d1)._sentryModuleMetadata) return;
    for (const stack of Object.keys((0, $736a69486c86d36c$export$f1a6cdb1459e81d1)._sentryModuleMetadata)){
        const metadata = (0, $736a69486c86d36c$export$f1a6cdb1459e81d1)._sentryModuleMetadata[stack];
        if ($6a12befaf2e5f886$var$parsedStacks.has(stack)) continue;
        // Ensure this stack doesn't get parsed again
        $6a12befaf2e5f886$var$parsedStacks.add(stack);
        const frames = parser(stack);
        // Go through the frames starting from the top of the stack and find the first one with a filename
        for (const frame of frames.reverse())if (frame.filename) {
            // Save the metadata for this filename
            $6a12befaf2e5f886$var$filenameMetadataMap.set(frame.filename, metadata);
            break;
        }
    }
}
/**
 * Retrieve metadata for a specific JavaScript file URL.
 *
 * Metadata is injected by the Sentry bundler plugins using the `_experiments.moduleMetadata` config option.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $6a12befaf2e5f886$export$fb4062399a51f94a(parser, filename) {
    $6a12befaf2e5f886$var$ensureMetadataStacksAreParsed(parser);
    return $6a12befaf2e5f886$var$filenameMetadataMap.get(filename);
}
/**
 * Adds metadata to stack frames.
 *
 * Metadata is injected by the Sentry bundler plugins using the `_experiments.moduleMetadata` config option.
 */ function $6a12befaf2e5f886$export$94b52ecabddf6844(parser, event) {
    event.exception?.values?.forEach((exception)=>{
        exception.stacktrace?.frames?.forEach((frame)=>{
            if (!frame.filename || frame.module_metadata) return;
            const metadata = $6a12befaf2e5f886$export$fb4062399a51f94a(parser, frame.filename);
            if (metadata) frame.module_metadata = metadata;
        });
    });
}
/**
 * Strips metadata from stack frames.
 */ function $6a12befaf2e5f886$export$5d4932fac9735eed(event) {
    event.exception?.values?.forEach((exception)=>{
        exception.stacktrace?.frames?.forEach((frame)=>{
            delete frame.module_metadata;
        });
    });
}



/**
 * Adds module metadata to stack frames.
 *
 * Metadata can be injected by the Sentry bundler plugins using the `moduleMetadata` config option.
 *
 * When this integration is added, the metadata passed to the bundler plugin is added to the stack frames of all events
 * under the `module_metadata` property. This can be used to help in tagging or routing of events from different teams
 * our sources
 */ const $aaf675b3037a7689$export$b3b128c3ae01ded0 = (0, $cbb2da6c78246e45$export$2323046b9414659f)(()=>{
    return {
        name: 'ModuleMetadata',
        setup (client) {
            // We need to strip metadata from stack frames before sending them to Sentry since these are client side only.
            client.on('beforeEnvelope', (envelope)=>{
                (0, $bb063ad93c8b79c7$export$c56c55acf0136fd3)(envelope, (item, type)=>{
                    if (type === 'event') {
                        const event = Array.isArray(item) ? item[1] : undefined;
                        if (event) {
                            (0, $6a12befaf2e5f886$export$5d4932fac9735eed)(event);
                            item[1] = event;
                        }
                    }
                });
            });
            client.on('applyFrameMetadata', (event)=>{
                // Only apply stack frame metadata to error events
                if (event.type) return;
                const stackParser = client.getOptions().stackParser;
                (0, $6a12befaf2e5f886$export$94b52ecabddf6844)(stackParser, event);
            });
        }
    };
});




let $092d3122136c38a4$var$_oldOnErrorHandler = null;
/**
 * Add an instrumentation handler for when an error is captured by the global error handler.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $092d3122136c38a4$export$55b5c3ba2194f0c6(handler) {
    const type = 'error';
    (0, $7b0ad3366f177c67$export$a4e09611e30da72e)(type, handler);
    (0, $7b0ad3366f177c67$export$e18d6c5462c01368)(type, $092d3122136c38a4$var$instrumentError);
}
function $092d3122136c38a4$var$instrumentError() {
    $092d3122136c38a4$var$_oldOnErrorHandler = (0, $736a69486c86d36c$export$f1a6cdb1459e81d1).onerror;
    // Note: The reason we are doing window.onerror instead of window.addEventListener('error')
    // is that we are using this handler in the Loader Script, to handle buffered errors consistently
    (0, $736a69486c86d36c$export$f1a6cdb1459e81d1).onerror = function(msg, url, line, column, error) {
        const handlerData = {
            column: column,
            error: error,
            line: line,
            msg: msg,
            url: url
        };
        (0, $7b0ad3366f177c67$export$b18c893e424d3127)('error', handlerData);
        if ($092d3122136c38a4$var$_oldOnErrorHandler) // eslint-disable-next-line prefer-rest-params
        return $092d3122136c38a4$var$_oldOnErrorHandler.apply(this, arguments);
        return false;
    };
    (0, $736a69486c86d36c$export$f1a6cdb1459e81d1).onerror.__SENTRY_INSTRUMENTED__ = true;
}




let $4db3540f511ca554$var$_oldOnUnhandledRejectionHandler = null;
/**
 * Add an instrumentation handler for when an unhandled promise rejection is captured.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $4db3540f511ca554$export$8bf4fc6858821a4e(handler) {
    const type = 'unhandledrejection';
    (0, $7b0ad3366f177c67$export$a4e09611e30da72e)(type, handler);
    (0, $7b0ad3366f177c67$export$e18d6c5462c01368)(type, $4db3540f511ca554$var$instrumentUnhandledRejection);
}
function $4db3540f511ca554$var$instrumentUnhandledRejection() {
    $4db3540f511ca554$var$_oldOnUnhandledRejectionHandler = (0, $736a69486c86d36c$export$f1a6cdb1459e81d1).onunhandledrejection;
    // Note: The reason we are doing window.onunhandledrejection instead of window.addEventListener('unhandledrejection')
    // is that we are using this handler in the Loader Script, to handle buffered rejections consistently
    (0, $736a69486c86d36c$export$f1a6cdb1459e81d1).onunhandledrejection = function(e) {
        const handlerData = e;
        (0, $7b0ad3366f177c67$export$b18c893e424d3127)('unhandledrejection', handlerData);
        if ($4db3540f511ca554$var$_oldOnUnhandledRejectionHandler) // eslint-disable-next-line prefer-rest-params
        return $4db3540f511ca554$var$_oldOnUnhandledRejectionHandler.apply(this, arguments);
        return true;
    };
    (0, $736a69486c86d36c$export$f1a6cdb1459e81d1).onunhandledrejection.__SENTRY_INSTRUMENTED__ = true;
}





let $154c5a3196d0f5d1$var$errorsInstrumented = false;
/**
 * Ensure that global errors automatically set the active span status.
 */ function $154c5a3196d0f5d1$export$b0914730ee1f6c80() {
    if ($154c5a3196d0f5d1$var$errorsInstrumented) return;
    /**
   * If an error or unhandled promise occurs, we mark the active root span as failed
   */ function errorCallback() {
        const activeSpan = (0, $bb9b6447bf4caedb$export$1be426a8e585c83e)();
        const rootSpan = activeSpan && (0, $bb9b6447bf4caedb$export$c4c6a79b1260ca1b)(activeSpan);
        if (rootSpan) {
            const message = 'internal_error';
            (0, $19fdbaf7f0830971$export$16a28057038b10ef) && (0, $d11ed0b3cdda6b8d$export$1c9f709888824e05).log(`[Tracing] Root span: ${message} -> Global error occurred`);
            rootSpan.setStatus({
                code: (0, $fda37f10dc06a152$export$f966a0446ece71e),
                message: message
            });
        }
    }
    // The function name will be lost when bundling but we need to be able to identify this listener later to maintain the
    // node.js default exit behaviour
    errorCallback.tag = 'sentry_tracingErrorCallback';
    $154c5a3196d0f5d1$var$errorsInstrumented = true;
    (0, $092d3122136c38a4$export$55b5c3ba2194f0c6)(errorCallback);
    (0, $4db3540f511ca554$export$8bf4fc6858821a4e)(errorCallback);
}


// Slightly modified (no IE8 support, ES6) and transcribed to TypeScript
// https://github.com/calvinmetcalf/rollup-plugin-node-builtins/blob/63ab8aacd013767445ca299e468d9a60a95328d7/src/es6/path.js
//
// Copyright Joyent, Inc.and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
/** JSDoc */ function $5f61c4616bba2475$var$normalizeArray(parts, allowAboveRoot) {
    // if the path tries to go above the root, `up` ends up > 0
    let up = 0;
    for(let i = parts.length - 1; i >= 0; i--){
        const last = parts[i];
        if (last === '.') parts.splice(i, 1);
        else if (last === '..') {
            parts.splice(i, 1);
            up++;
        } else if (up) {
            parts.splice(i, 1);
            up--;
        }
    }
    // if the path is allowed to go above the root, restore leading ..s
    if (allowAboveRoot) for(; up--; up)parts.unshift('..');
    return parts;
}
// Split a filename into [root, dir, basename, ext], unix version
// 'root' is just a slash, or nothing.
const $5f61c4616bba2475$var$splitPathRe = /^(\S+:\\|\/?)([\s\S]*?)((?:\.{1,2}|[^/\\]+?|)(\.[^./\\]*|))(?:[/\\]*)$/;
/** JSDoc */ function $5f61c4616bba2475$var$splitPath(filename) {
    // Truncate files names greater than 1024 characters to avoid regex dos
    // https://github.com/getsentry/sentry-javascript/pull/8737#discussion_r1285719172
    const truncated = filename.length > 1024 ? `<truncated>${filename.slice(-1024)}` : filename;
    const parts = $5f61c4616bba2475$var$splitPathRe.exec(truncated);
    return parts ? parts.slice(1) : [];
}
// path.resolve([from ...], to)
// posix version
/** JSDoc */ function $5f61c4616bba2475$export$f7ad0328861e2f03(...args) {
    let resolvedPath = '';
    let resolvedAbsolute = false;
    for(let i = args.length - 1; i >= -1 && !resolvedAbsolute; i--){
        const path = i >= 0 ? args[i] : '/';
        // Skip empty entries
        if (!path) continue;
        resolvedPath = `${path}/${resolvedPath}`;
        resolvedAbsolute = path.charAt(0) === '/';
    }
    // At this point the path should be resolved to a full absolute path, but
    // handle relative paths to be safe (might happen when process.cwd() fails)
    // Normalize the path
    resolvedPath = $5f61c4616bba2475$var$normalizeArray(resolvedPath.split('/').filter((p)=>!!p), !resolvedAbsolute).join('/');
    return (resolvedAbsolute ? '/' : '') + resolvedPath || '.';
}
/** JSDoc */ function $5f61c4616bba2475$var$trim(arr) {
    let start = 0;
    for(; start < arr.length; start++){
        if (arr[start] !== '') break;
    }
    let end = arr.length - 1;
    for(; end >= 0; end--){
        if (arr[end] !== '') break;
    }
    if (start > end) return [];
    return arr.slice(start, end - start + 1);
}
// path.relative(from, to)
// posix version
/** JSDoc */ function $5f61c4616bba2475$export$f0e7d1106eeabbe6(from, to) {
    /* eslint-disable no-param-reassign */ from = $5f61c4616bba2475$export$f7ad0328861e2f03(from).slice(1);
    to = $5f61c4616bba2475$export$f7ad0328861e2f03(to).slice(1);
    /* eslint-enable no-param-reassign */ const fromParts = $5f61c4616bba2475$var$trim(from.split('/'));
    const toParts = $5f61c4616bba2475$var$trim(to.split('/'));
    const length = Math.min(fromParts.length, toParts.length);
    let samePartsLength = length;
    for(let i = 0; i < length; i++)if (fromParts[i] !== toParts[i]) {
        samePartsLength = i;
        break;
    }
    let outputParts = [];
    for(let i = samePartsLength; i < fromParts.length; i++)outputParts.push('..');
    outputParts = outputParts.concat(toParts.slice(samePartsLength));
    return outputParts.join('/');
}
// path.normalize(path)
// posix version
/** JSDoc */ function $5f61c4616bba2475$export$6af368f973c74c5(path) {
    const isPathAbsolute = $5f61c4616bba2475$export$e434c7255acda994(path);
    const trailingSlash = path.slice(-1) === '/';
    // Normalize the path
    let normalizedPath = $5f61c4616bba2475$var$normalizeArray(path.split('/').filter((p)=>!!p), !isPathAbsolute).join('/');
    if (!normalizedPath && !isPathAbsolute) normalizedPath = '.';
    if (normalizedPath && trailingSlash) normalizedPath += '/';
    return (isPathAbsolute ? '/' : '') + normalizedPath;
}
// posix version
/** JSDoc */ function $5f61c4616bba2475$export$e434c7255acda994(path) {
    return path.charAt(0) === '/';
}
// posix version
/** JSDoc */ function $5f61c4616bba2475$export$f7e2c8231c57a8bd(...args) {
    return $5f61c4616bba2475$export$6af368f973c74c5(args.join('/'));
}
/** JSDoc */ function $5f61c4616bba2475$export$7f7b8152cc673abe(path) {
    const result = $5f61c4616bba2475$var$splitPath(path);
    const root = result[0] || '';
    let dir = result[1];
    if (!root && !dir) // No dirname whatsoever
    return '.';
    if (dir) // It has a dirname, strip trailing slash
    dir = dir.slice(0, dir.length - 1);
    return root + dir;
}
/** JSDoc */ function $5f61c4616bba2475$export$9bf319d8f74f51d1(path, ext) {
    let f = $5f61c4616bba2475$var$splitPath(path)[2] || '';
    if (ext && f.slice(ext.length * -1) === ext) f = f.slice(0, f.length - ext.length);
    return f;
}



const $502d06ce7800152d$var$INTEGRATION_NAME = 'RewriteFrames';
/**
 * Rewrite event frames paths.
 */ const $502d06ce7800152d$export$5ed0db6416cb6ea2 = (0, $cbb2da6c78246e45$export$2323046b9414659f)((options = {})=>{
    const root = options.root;
    const prefix = options.prefix || 'app:///';
    const isBrowser = 'window' in (0, $736a69486c86d36c$export$f1a6cdb1459e81d1) && !!(0, $736a69486c86d36c$export$f1a6cdb1459e81d1).window;
    const iteratee = options.iteratee || $502d06ce7800152d$export$96f9867e17282d04({
        isBrowser: isBrowser,
        root: root,
        prefix: prefix
    });
    /** Process an exception event. */ function _processExceptionsEvent(event) {
        try {
            return {
                ...event,
                exception: {
                    ...event.exception,
                    // The check for this is performed inside `process` call itself, safe to skip here
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    values: event.exception.values.map((value)=>({
                            ...value,
                            ...value.stacktrace && {
                                stacktrace: _processStacktrace(value.stacktrace)
                            }
                        }))
                }
            };
        } catch  {
            return event;
        }
    }
    /** Process a stack trace. */ function _processStacktrace(stacktrace) {
        return {
            ...stacktrace,
            frames: stacktrace?.frames?.map((f)=>iteratee(f))
        };
    }
    return {
        name: $502d06ce7800152d$var$INTEGRATION_NAME,
        processEvent (originalEvent) {
            let processedEvent = originalEvent;
            if (originalEvent.exception && Array.isArray(originalEvent.exception.values)) processedEvent = _processExceptionsEvent(processedEvent);
            return processedEvent;
        }
    };
});
/**
 * Exported only for tests.
 */ function $502d06ce7800152d$export$96f9867e17282d04({ isBrowser: isBrowser, root: root, prefix: prefix }) {
    return (frame)=>{
        if (!frame.filename) return frame;
        // Determine if this is a Windows frame by checking for a Windows-style prefix such as `C:\`
        const isWindowsFrame = /^[a-zA-Z]:\\/.test(frame.filename) || // or the presence of a backslash without a forward slash (which are not allowed on Windows)
        frame.filename.includes('\\') && !frame.filename.includes('/');
        // Check if the frame filename begins with `/`
        const startsWithSlash = /^\//.test(frame.filename);
        if (isBrowser) {
            if (root) {
                const oldFilename = frame.filename;
                if (oldFilename.indexOf(root) === 0) frame.filename = oldFilename.replace(root, prefix);
            }
        } else if (isWindowsFrame || startsWithSlash) {
            const filename = isWindowsFrame ? frame.filename.replace(/^[a-zA-Z]:/, '') // remove Windows-style prefix
            .replace(/\\/g, '/') // replace all `\\` instances with `/`
             : frame.filename;
            const base = root ? (0, $5f61c4616bba2475$export$f0e7d1106eeabbe6)(root, filename) : (0, $5f61c4616bba2475$export$9bf319d8f74f51d1)(filename);
            frame.filename = `${prefix}${base}`;
        }
        return frame;
    };
}




/** A class object that can instantiate Client objects. */ /**
 * Internal function to create a new SDK client instance. The client is
 * installed and then bound to the current scope.
 *
 * @param clientClass The client class to instantiate.
 * @param options Options to pass to the client.
 */ function $bdb6894cd2fc2f4a$export$5333c3f1c58d9bc1(clientClass, options) {
    if (options.debug === true) {
        if (0, $19fdbaf7f0830971$export$16a28057038b10ef) (0, $d11ed0b3cdda6b8d$export$1c9f709888824e05).enable();
        else // use `console.warn` rather than `debug.warn` since by non-debug bundles have all `debug.x` statements stripped
        (0, $d11ed0b3cdda6b8d$export$cda52e2a8927a2ca)(()=>{
            // eslint-disable-next-line no-console
            console.warn('[Sentry] Cannot initialize SDK with `debug` option using a non-debug bundle.');
        });
    }
    const scope = (0, $7d48e1ed9f699a01$export$c7be4b0125a10cba)();
    scope.update(options.initialScope);
    const client = new clientClass(options);
    $bdb6894cd2fc2f4a$export$ecb76f41d43c0e43(client);
    client.init();
    return client;
}
/**
 * Make the given client the current client.
 */ function $bdb6894cd2fc2f4a$export$ecb76f41d43c0e43(client) {
    (0, $7d48e1ed9f699a01$export$c7be4b0125a10cba)().setClient(client);
}





/**
 * This integration allows you to filter out, or tag error events that do not come from user code marked with a bundle key via the Sentry bundler plugins.
 */ const $6ff5d94fa4398112$export$be5f345197c66e53 = (0, $cbb2da6c78246e45$export$2323046b9414659f)((options)=>{
    return {
        name: 'ThirdPartyErrorsFilter',
        setup (client) {
            // We need to strip metadata from stack frames before sending them to Sentry since these are client side only.
            client.on('beforeEnvelope', (envelope)=>{
                (0, $bb063ad93c8b79c7$export$c56c55acf0136fd3)(envelope, (item, type)=>{
                    if (type === 'event') {
                        const event = Array.isArray(item) ? item[1] : undefined;
                        if (event) {
                            (0, $6a12befaf2e5f886$export$5d4932fac9735eed)(event);
                            item[1] = event;
                        }
                    }
                });
            });
            client.on('applyFrameMetadata', (event)=>{
                // Only apply stack frame metadata to error events
                if (event.type) return;
                const stackParser = client.getOptions().stackParser;
                (0, $6a12befaf2e5f886$export$94b52ecabddf6844)(stackParser, event);
            });
        },
        processEvent (event) {
            const frameKeys = $6ff5d94fa4398112$var$getBundleKeysForAllFramesWithFilenames(event, options.ignoreSentryInternalFrames);
            if (frameKeys) {
                const arrayMethod = options.behaviour === 'drop-error-if-contains-third-party-frames' || options.behaviour === 'apply-tag-if-contains-third-party-frames' ? 'some' : 'every';
                const behaviourApplies = frameKeys[arrayMethod]((keys)=>!keys.some((key)=>options.filterKeys.includes(key)));
                if (behaviourApplies) {
                    const shouldDrop = options.behaviour === 'drop-error-if-contains-third-party-frames' || options.behaviour === 'drop-error-if-exclusively-contains-third-party-frames';
                    if (shouldDrop) return null;
                    else event.tags = {
                        ...event.tags,
                        third_party_code: true
                    };
                }
            }
            return event;
        }
    };
});
/**
 * Checks if a stack frame is a Sentry internal frame by strictly matching:
 * 1. The frame must be the last frame in the stack
 * 2. The filename must indicate the internal helpers file
 * 3. The context_line must contain the exact pattern "fn.apply(this, wrappedArguments)"
 * 4. The comment pattern "Attempt to invoke user-land function" must be present in pre_context
 *
 */ function $6ff5d94fa4398112$var$isSentryInternalFrame(frame, frameIndex) {
    // Only match the last frame (index 0 in reversed stack)
    if (frameIndex !== 0 || !frame.context_line || !frame.filename) return false;
    if (!frame.filename.includes('sentry') || !frame.filename.includes('helpers') || // Filename would look something like this: 'node_modules/@sentry/browser/build/npm/esm/helpers.js'
    !frame.context_line.includes($6ff5d94fa4398112$var$SENTRY_INTERNAL_FN_APPLY) // Must have context_line with the exact fn.apply pattern
    ) return false;
    // Check pre_context array for comment pattern
    if (frame.pre_context) {
        const len = frame.pre_context.length;
        for(let i = 0; i < len; i++){
            if (frame.pre_context[i]?.includes($6ff5d94fa4398112$var$SENTRY_INTERNAL_COMMENT)) return true;
        }
    }
    return false;
}
function $6ff5d94fa4398112$var$getBundleKeysForAllFramesWithFilenames(event, ignoreSentryInternalFrames) {
    const frames = (0, $9ed2cf4edd0b2db9$export$91d8ca51bd9f6a47)(event);
    if (!frames) return undefined;
    return frames.filter((frame, index)=>{
        // Exclude frames without a filename
        if (!frame.filename) return false;
        // Exclude frames without location info, since these are likely native code or built-ins.
        // JS frames have lineno/colno, WASM frames have instruction_addr instead.
        if (frame.lineno == null && frame.colno == null && frame.instruction_addr == null) return false;
        // Optionally ignore Sentry internal frames
        return !ignoreSentryInternalFrames || !$6ff5d94fa4398112$var$isSentryInternalFrame(frame, index);
    }).map((frame)=>{
        if (!frame.module_metadata) return [];
        return Object.keys(frame.module_metadata).filter((key)=>key.startsWith($6ff5d94fa4398112$var$BUNDLER_PLUGIN_APP_KEY_PREFIX)).map((key)=>key.slice($6ff5d94fa4398112$var$BUNDLER_PLUGIN_APP_KEY_PREFIX.length));
    });
}
const $6ff5d94fa4398112$var$BUNDLER_PLUGIN_APP_KEY_PREFIX = '_sentryBundlerPluginAppKey:';
const $6ff5d94fa4398112$var$SENTRY_INTERNAL_COMMENT = 'Attempt to invoke user-land function';
const $6ff5d94fa4398112$var$SENTRY_INTERNAL_FN_APPLY = 'fn.apply(this, wrappedArguments)';




const $241378d1257bd050$var$DEFAULT_LIMIT = 10;
const $241378d1257bd050$var$INTEGRATION_NAME = 'ZodErrors';
/**
 * Simplified ZodIssue type definition
 */ function $241378d1257bd050$var$originalExceptionIsZodError(originalException) {
    return (0, $13cf2ed412f405fa$export$e6127cc7fe7395c3)(originalException) && originalException.name === 'ZodError' && Array.isArray(originalException.issues);
}
/**
 * Formats child objects or arrays to a string
 * that is preserved when sent to Sentry.
 *
 * Without this, we end up with something like this in Sentry:
 *
 * [
 *  [Object],
 *  [Object],
 *  [Object],
 *  [Object]
 * ]
 */ function $241378d1257bd050$export$aca8f6f436c2ad07(issue) {
    return {
        ...issue,
        path: 'path' in issue && Array.isArray(issue.path) ? issue.path.join('.') : undefined,
        keys: 'keys' in issue ? JSON.stringify(issue.keys) : undefined,
        unionErrors: 'unionErrors' in issue ? JSON.stringify(issue.unionErrors) : undefined
    };
}
/**
 * Takes ZodError issue path array and returns a flattened version as a string.
 * This makes it easier to display paths within a Sentry error message.
 *
 * Array indexes are normalized to reduce duplicate entries
 *
 * @param path ZodError issue path
 * @returns flattened path
 *
 * @example
 * flattenIssuePath([0, 'foo', 1, 'bar']) // -> '<array>.foo.<array>.bar'
 */ function $241378d1257bd050$export$64ff46cc0375df3e(path) {
    return path.map((p)=>{
        if (typeof p === 'number') return '<array>';
        else return p;
    }).join('.');
}
/**
 * Zod error message is a stringified version of ZodError.issues
 * This doesn't display well in the Sentry UI. Replace it with something shorter.
 */ function $241378d1257bd050$export$c1fdbb35d2a2db0e(zodError) {
    const errorKeyMap = new Set();
    for (const iss of zodError.issues){
        const issuePath = $241378d1257bd050$export$64ff46cc0375df3e(iss.path);
        if (issuePath.length > 0) errorKeyMap.add(issuePath);
    }
    const errorKeys = Array.from(errorKeyMap);
    if (errorKeys.length === 0) {
        // If there are no keys, then we're likely validating the root
        // variable rather than a key within an object. This attempts
        // to extract what type it was that failed to validate.
        // For example, z.string().parse(123) would return "string" here.
        let rootExpectedType = 'variable';
        if (zodError.issues.length > 0) {
            const iss = zodError.issues[0];
            if (iss !== undefined && 'expected' in iss && typeof iss.expected === 'string') rootExpectedType = iss.expected;
        }
        return `Failed to validate ${rootExpectedType}`;
    }
    return `Failed to validate keys: ${(0, $e534db390d1e4996$export$6a506b36fdea397d)(errorKeys.join(', '), 100)}`;
}
/**
 * Applies ZodError issues to an event extra and replaces the error message
 */ function $241378d1257bd050$export$a392eb5ca0ee57d9(limit, saveZodIssuesAsAttachment = false, event, hint) {
    if (!event.exception?.values || !hint.originalException || !$241378d1257bd050$var$originalExceptionIsZodError(hint.originalException) || hint.originalException.issues.length === 0) return event;
    try {
        const issuesToFlatten = saveZodIssuesAsAttachment ? hint.originalException.issues : hint.originalException.issues.slice(0, limit);
        const flattenedIssues = issuesToFlatten.map($241378d1257bd050$export$aca8f6f436c2ad07);
        if (saveZodIssuesAsAttachment) {
            // Sometimes having the full error details can be helpful.
            // Attachments have much higher limits, so we can include the full list of issues.
            if (!Array.isArray(hint.attachments)) hint.attachments = [];
            hint.attachments.push({
                filename: 'zod_issues.json',
                data: JSON.stringify({
                    issues: flattenedIssues
                })
            });
        }
        return {
            ...event,
            exception: {
                ...event.exception,
                values: [
                    {
                        ...event.exception.values[0],
                        value: $241378d1257bd050$export$c1fdbb35d2a2db0e(hint.originalException)
                    },
                    ...event.exception.values.slice(1)
                ]
            },
            extra: {
                ...event.extra,
                'zoderror.issues': flattenedIssues.slice(0, limit)
            }
        };
    } catch (e) {
        // Hopefully we never throw errors here, but record it
        // with the event just in case.
        return {
            ...event,
            extra: {
                ...event.extra,
                'zoderrors sentry integration parse error': {
                    message: 'an exception was thrown while processing ZodError within applyZodErrorsToEvent()',
                    error: e instanceof Error ? `${e.name}: ${e.message}\n${e.stack}` : 'unknown'
                }
            }
        };
    }
}
const $241378d1257bd050$var$_zodErrorsIntegration = (options = {})=>{
    const limit = options.limit ?? $241378d1257bd050$var$DEFAULT_LIMIT;
    return {
        name: $241378d1257bd050$var$INTEGRATION_NAME,
        processEvent (originalEvent, hint) {
            const processedEvent = $241378d1257bd050$export$a392eb5ca0ee57d9(limit, options.saveZodIssuesAsAttachment, originalEvent, hint);
            return processedEvent;
        }
    };
};
/**
 * Sentry integration to process Zod errors, making them easier to work with in Sentry.
 */ const $241378d1257bd050$export$a9e1d9bd14830dfb = (0, $cbb2da6c78246e45$export$2323046b9414659f)($241378d1257bd050$var$_zodErrorsIntegration);



// By default, we want to infer the IP address, unless this is explicitly set to `null`
// We do this after all other processing is done
// If `ip_address` is explicitly set to `null` or a value, we leave it as is
/**
 * @internal
 * @deprecated -- set ip inferral via via SDK metadata options on client instead.
 */ function $05ea44818da90d4b$export$3e12ad68afa434ac(objWithMaybeUser) {
    if (objWithMaybeUser.user?.ip_address === undefined) objWithMaybeUser.user = {
        ...objWithMaybeUser.user,
        ip_address: '{{auto}}'
    };
}
/**
 * @internal
 */ function $05ea44818da90d4b$export$e8e2d07ba63e2b6c(session) {
    if ('aggregates' in session) {
        if (session.attrs?.['ip_address'] === undefined) session.attrs = {
            ...session.attrs,
            ip_address: '{{auto}}'
        };
    } else if (session.ipAddress === undefined) session.ipAddress = '{{auto}}';
}


/**
 * A builder for the SDK metadata in the options for the SDK initialization.
 *
 * Note: This function is identical to `buildMetadata` in Remix and NextJS and SvelteKit.
 * We don't extract it for bundle size reasons.
 * @see https://github.com/getsentry/sentry-javascript/pull/7404
 * @see https://github.com/getsentry/sentry-javascript/pull/4196
 *
 * If you make changes to this function consider updating the others as well.
 *
 * @param options SDK options object that gets mutated
 * @param names list of package names
 */ function $4379b47e31368aa0$export$b9f95b027256052c(options, name, names = [
    name
], source = 'npm') {
    const sdk = (options._metadata = options._metadata || {}).sdk = options._metadata.sdk || {};
    if (!sdk.name) {
        sdk.name = `sentry.javascript.${name}`;
        sdk.packages = names.map((name)=>({
                name: `${source}:@sentry/${name}`,
                version: (0, $dcd58747d787136d$export$31499a9cd224b78c)
            }));
        sdk.version = (0, $dcd58747d787136d$export$31499a9cd224b78c);
    }
}














/**
 * Creates client report envelope
 * @param discarded_events An array of discard events
 * @param dsn A DSN that can be set on the header. Optional.
 */ function $1503c20c7cf56625$export$f3b9ed77c03eeb00(discarded_events, dsn, timestamp) {
    const clientReportItem = [
        {
            type: 'client_report'
        },
        {
            timestamp: timestamp || (0, $bc81602376c48fa6$export$7740643b9eeaf0c4)(),
            discarded_events: discarded_events
        }
    ];
    return (0, $bb063ad93c8b79c7$export$f93f7f385160c44e)(dsn ? {
        dsn: dsn
    } : {}, [
        clientReportItem
    ]);
}


















/**
 * Converts a transaction event to a span JSON object.
 */ function $d50d2811fbb82a76$export$d9c6b2464b0a687e(event) {
    const { trace_id: trace_id, parent_span_id: parent_span_id, span_id: span_id, status: status, origin: origin, data: data, op: op } = event.contexts?.trace ?? {};
    return {
        data: data ?? {},
        description: event.transaction,
        op: op,
        parent_span_id: parent_span_id,
        span_id: span_id ?? '',
        start_timestamp: event.start_timestamp ?? 0,
        status: status,
        timestamp: event.timestamp,
        trace_id: trace_id ?? '',
        origin: origin,
        profile_id: data?.[0, $f337c80285f06f80$export$1efec95406bbe327],
        exclusive_time: data?.[0, $f337c80285f06f80$export$fea48ba9f4550879],
        measurements: event.measurements,
        is_segment: true
    };
}
/**
 * Converts a span JSON object to a transaction event.
 */ function $d50d2811fbb82a76$export$f2d8fce5ae150e92(span) {
    return {
        type: 'transaction',
        timestamp: span.timestamp,
        start_timestamp: span.start_timestamp,
        transaction: span.description,
        contexts: {
            trace: {
                trace_id: span.trace_id,
                span_id: span.span_id,
                parent_span_id: span.parent_span_id,
                op: span.op,
                status: span.status,
                origin: span.origin,
                data: {
                    ...span.data,
                    ...span.profile_id && {
                        [(0, $f337c80285f06f80$export$1efec95406bbe327)]: span.profile_id
                    },
                    ...span.exclusive_time && {
                        [(0, $f337c80285f06f80$export$fea48ba9f4550879)]: span.exclusive_time
                    }
                }
            }
        },
        measurements: span.measurements
    };
}


/* eslint-disable max-lines */ const $13e8a14cd93782c3$var$ALREADY_SEEN_ERROR = "Not capturing exception because it's already been captured.";
const $13e8a14cd93782c3$var$MISSING_RELEASE_FOR_SESSION_ERROR = 'Discarded session because of missing or non-string release';
const $13e8a14cd93782c3$var$INTERNAL_ERROR_SYMBOL = Symbol.for('SentryInternalError');
const $13e8a14cd93782c3$var$DO_NOT_SEND_EVENT_SYMBOL = Symbol.for('SentryDoNotSendEventError');
// Default interval for flushing logs and metrics (5 seconds)
const $13e8a14cd93782c3$var$DEFAULT_FLUSH_INTERVAL = 5000;
function $13e8a14cd93782c3$var$_makeInternalError(message) {
    return {
        message: message,
        [$13e8a14cd93782c3$var$INTERNAL_ERROR_SYMBOL]: true
    };
}
function $13e8a14cd93782c3$var$_makeDoNotSendEventError(message) {
    return {
        message: message,
        [$13e8a14cd93782c3$var$DO_NOT_SEND_EVENT_SYMBOL]: true
    };
}
function $13e8a14cd93782c3$var$_isInternalError(error) {
    return !!error && typeof error === 'object' && $13e8a14cd93782c3$var$INTERNAL_ERROR_SYMBOL in error;
}
function $13e8a14cd93782c3$var$_isDoNotSendEventError(error) {
    return !!error && typeof error === 'object' && $13e8a14cd93782c3$var$DO_NOT_SEND_EVENT_SYMBOL in error;
}
/**
 * Sets up weight-based flushing for logs or metrics.
 * This helper function encapsulates the common pattern of:
 * 1. Tracking accumulated weight of items
 * 2. Flushing when weight exceeds threshold (800KB)
 * 3. Flushing after timeout period from the first item
 *
 * Uses closure variables to track weight and timeout state.
 */ function $13e8a14cd93782c3$var$setupWeightBasedFlushing(client, afterCaptureHook, flushHook, estimateSizeFn, flushFn) {
    // Track weight and timeout in closure variables
    let weight = 0;
    let flushTimeout;
    let isTimerActive = false;
    // @ts-expect-error - TypeScript can't narrow generic hook types to match specific overloads, but we know this is type-safe
    client.on(flushHook, ()=>{
        weight = 0;
        clearTimeout(flushTimeout);
        isTimerActive = false;
    });
    // @ts-expect-error - TypeScript can't narrow generic hook types to match specific overloads, but we know this is type-safe
    client.on(afterCaptureHook, (item)=>{
        weight += estimateSizeFn(item);
        // We flush the buffer if it exceeds 0.8 MB
        // The weight is a rough estimate, so we flush way before the payload gets too big.
        if (weight >= 800000) flushFn(client);
        else if (!isTimerActive) {
            // Only start timer if one isn't already running.
            // This prevents flushing being delayed by items that arrive close to the timeout limit
            // and thus resetting the flushing timeout and delaying items being flushed.
            isTimerActive = true;
            // Use safeUnref so the timer doesn't prevent the process from exiting
            flushTimeout = (0, $eb2fc1cbe65ebe8f$export$630056cb83d87863)(setTimeout(()=>{
                flushFn(client);
            // Note: isTimerActive is reset by the flushHook handler above, not here,
            // to avoid race conditions when new items arrive during the flush.
            }, $13e8a14cd93782c3$var$DEFAULT_FLUSH_INTERVAL));
        }
    });
    client.on('flush', ()=>{
        flushFn(client);
    });
}
/**
 * Base implementation for all JavaScript SDK clients.
 *
 * Call the constructor with the corresponding options
 * specific to the client subclass. To access these options later, use
 * {@link Client.getOptions}.
 *
 * If a Dsn is specified in the options, it will be parsed and stored. Use
 * {@link Client.getDsn} to retrieve the Dsn at any moment. In case the Dsn is
 * invalid, the constructor will throw a {@link SentryException}. Note that
 * without a valid Dsn, the SDK will not send any events to Sentry.
 *
 * Before sending an event, it is passed through
 * {@link Client._prepareEvent} to add SDK information and scope data
 * (breadcrumbs and context). To add more custom information, override this
 * method and extend the resulting prepared event.
 *
 * To issue automatically created events (e.g. via instrumentation), use
 * {@link Client.captureEvent}. It will prepare the event and pass it through
 * the callback lifecycle. To issue auto-breadcrumbs, use
 * {@link Client.addBreadcrumb}.
 *
 * @example
 * class NodeClient extends Client<NodeOptions> {
 *   public constructor(options: NodeOptions) {
 *     super(options);
 *   }
 *
 *   // ...
 * }
 */ class $13e8a14cd93782c3$export$1f2bb630327ac4b6 {
    /** Options passed to the SDK. */ /** The client Dsn, if specified in options. Without this Dsn, the SDK will be disabled. */ /** Array of set up integrations. */ /** Number of calls being processed */ /** Holds flushable  */ // eslint-disable-next-line @typescript-eslint/ban-types
    /**
   * Initializes this client instance.
   *
   * @param options Options for the client.
   */ constructor(options){
        this._options = options;
        this._integrations = {};
        this._numProcessing = 0;
        this._outcomes = {};
        this._hooks = {};
        this._eventProcessors = [];
        this._promiseBuffer = (0, $1407141ba4ddb36d$export$85a4f67f852183e6)(options.transportOptions?.bufferSize ?? (0, $46ddc25216d7985b$export$e515cf6dfd2f98b8));
        if (options.dsn) this._dsn = (0, $1e1399eeae328b26$export$128827c3562ec0cb)(options.dsn);
        else (0, $19fdbaf7f0830971$export$16a28057038b10ef) && (0, $d11ed0b3cdda6b8d$export$1c9f709888824e05).warn('No DSN provided, client will not send events.');
        if (this._dsn) {
            const url = (0, $95bd43db10a47155$export$9964600bfe84e6a3)(this._dsn, options.tunnel, options._metadata ? options._metadata.sdk : undefined);
            this._transport = options.transport({
                tunnel: this._options.tunnel,
                recordDroppedEvent: this.recordDroppedEvent.bind(this),
                ...options.transportOptions,
                url: url
            });
        }
        // Backfill enableLogs option from _experiments.enableLogs
        // TODO(v11): Remove or change default value
        // eslint-disable-next-line deprecation/deprecation
        this._options.enableLogs = this._options.enableLogs ?? this._options._experiments?.enableLogs;
        // Setup log flushing with weight and timeout tracking
        if (this._options.enableLogs) $13e8a14cd93782c3$var$setupWeightBasedFlushing(this, 'afterCaptureLog', 'flushLogs', $13e8a14cd93782c3$var$estimateLogSizeInBytes, (0, $aedf2f5a49662da4$export$f8ed83d3b6a0b504));
        // todo(v11): Remove the experimental flag
        // eslint-disable-next-line deprecation/deprecation
        const enableMetrics = this._options.enableMetrics ?? this._options._experiments?.enableMetrics ?? true;
        // Setup metric flushing with weight and timeout tracking
        if (enableMetrics) $13e8a14cd93782c3$var$setupWeightBasedFlushing(this, 'afterCaptureMetric', 'flushMetrics', $13e8a14cd93782c3$var$estimateMetricSizeInBytes, (0, $8ed8fd97ec1f999f$export$91c9ef254b7d0f67));
    }
    /**
   * Captures an exception event and sends it to Sentry.
   *
   * Unlike `captureException` exported from every SDK, this method requires that you pass it the current scope.
   */ captureException(exception, hint, scope) {
        const eventId = (0, $cc262db35458e4b3$export$19f53698e68b2496)();
        // ensure we haven't captured this very object before
        if ((0, $cc262db35458e4b3$export$6de4ffac6a2f1098)(exception)) {
            (0, $19fdbaf7f0830971$export$16a28057038b10ef) && (0, $d11ed0b3cdda6b8d$export$1c9f709888824e05).log($13e8a14cd93782c3$var$ALREADY_SEEN_ERROR);
            return eventId;
        }
        const hintWithEventId = {
            event_id: eventId,
            ...hint
        };
        this._process(()=>this.eventFromException(exception, hintWithEventId).then((event)=>this._captureEvent(event, hintWithEventId, scope)).then((res)=>res), 'error');
        return hintWithEventId.event_id;
    }
    /**
   * Captures a message event and sends it to Sentry.
   *
   * Unlike `captureMessage` exported from every SDK, this method requires that you pass it the current scope.
   */ captureMessage(message, level, hint, currentScope) {
        const hintWithEventId = {
            event_id: (0, $cc262db35458e4b3$export$19f53698e68b2496)(),
            ...hint
        };
        const eventMessage = (0, $13cf2ed412f405fa$export$dbcbffa59149b824)(message) ? message : String(message);
        const isMessage = (0, $13cf2ed412f405fa$export$c3825b437cbdea5c)(message);
        const promisedEvent = isMessage ? this.eventFromMessage(eventMessage, level, hintWithEventId) : this.eventFromException(message, hintWithEventId);
        this._process(()=>promisedEvent.then((event)=>this._captureEvent(event, hintWithEventId, currentScope)), isMessage ? 'unknown' : 'error');
        return hintWithEventId.event_id;
    }
    /**
   * Captures a manually created event and sends it to Sentry.
   *
   * Unlike `captureEvent` exported from every SDK, this method requires that you pass it the current scope.
   */ captureEvent(event, hint, currentScope) {
        const eventId = (0, $cc262db35458e4b3$export$19f53698e68b2496)();
        // ensure we haven't captured this very object before
        if (hint?.originalException && (0, $cc262db35458e4b3$export$6de4ffac6a2f1098)(hint.originalException)) {
            (0, $19fdbaf7f0830971$export$16a28057038b10ef) && (0, $d11ed0b3cdda6b8d$export$1c9f709888824e05).log($13e8a14cd93782c3$var$ALREADY_SEEN_ERROR);
            return eventId;
        }
        const hintWithEventId = {
            event_id: eventId,
            ...hint
        };
        const sdkProcessingMetadata = event.sdkProcessingMetadata || {};
        const capturedSpanScope = sdkProcessingMetadata.capturedSpanScope;
        const capturedSpanIsolationScope = sdkProcessingMetadata.capturedSpanIsolationScope;
        const dataCategory = $13e8a14cd93782c3$var$getDataCategoryByType(event.type);
        this._process(()=>this._captureEvent(event, hintWithEventId, capturedSpanScope || currentScope, capturedSpanIsolationScope), dataCategory);
        return hintWithEventId.event_id;
    }
    /**
   * Captures a session.
   */ captureSession(session) {
        this.sendSession(session);
        // After sending, we set init false to indicate it's not the first occurrence
        (0, $e6ef9757665bd407$export$531818e825e774db)(session, {
            init: false
        });
    }
    /**
   * Create a cron monitor check in and send it to Sentry. This method is not available on all clients.
   *
   * @param checkIn An object that describes a check in.
   * @param upsertMonitorConfig An optional object that describes a monitor config. Use this if you want
   * to create a monitor automatically when sending a check in.
   * @param scope An optional scope containing event metadata.
   * @returns A string representing the id of the check in.
   */ /**
   * Get the current Dsn.
   */ getDsn() {
        return this._dsn;
    }
    /**
   * Get the current options.
   */ getOptions() {
        return this._options;
    }
    /**
   * Get the SDK metadata.
   * @see SdkMetadata
   */ getSdkMetadata() {
        return this._options._metadata;
    }
    /**
   * Returns the transport that is used by the client.
   * Please note that the transport gets lazy initialized so it will only be there once the first event has been sent.
   */ getTransport() {
        return this._transport;
    }
    /**
   * Wait for all events to be sent or the timeout to expire, whichever comes first.
   *
   * @param timeout Maximum time in ms the client should wait for events to be flushed. Omitting this parameter will
   *   cause the client to wait until all events are sent before resolving the promise.
   * @returns A promise that will resolve with `true` if all events are sent before the timeout, or `false` if there are
   * still events in the queue when the timeout is reached.
   */ // @ts-expect-error - PromiseLike is a subset of Promise
    async flush(timeout) {
        const transport = this._transport;
        if (!transport) return true;
        this.emit('flush');
        const clientFinished = await this._isClientDoneProcessing(timeout);
        const transportFlushed = await transport.flush(timeout);
        return clientFinished && transportFlushed;
    }
    /**
   * Flush the event queue and set the client to `enabled = false`. See {@link Client.flush}.
   *
   * @param {number} timeout Maximum time in ms the client should wait before shutting down. Omitting this parameter will cause
   *   the client to wait until all events are sent before disabling itself.
   * @returns {Promise<boolean>} A promise which resolves to `true` if the flush completes successfully before the timeout, or `false` if
   * it doesn't.
   */ // @ts-expect-error - PromiseLike is a subset of Promise
    async close(timeout) {
        (0, $aedf2f5a49662da4$export$f8ed83d3b6a0b504)(this);
        const result = await this.flush(timeout);
        this.getOptions().enabled = false;
        this.emit('close');
        return result;
    }
    /**
   * Get all installed event processors.
   */ getEventProcessors() {
        return this._eventProcessors;
    }
    /**
   * Adds an event processor that applies to any event processed by this client.
   */ addEventProcessor(eventProcessor) {
        this._eventProcessors.push(eventProcessor);
    }
    /**
   * Initialize this client.
   * Call this after the client was set on a scope.
   */ init() {
        if (this._isEnabled() || // Force integrations to be setup even if no DSN was set when we have
        // Spotlight enabled. This is particularly important for browser as we
        // don't support the `spotlight` option there and rely on the users
        // adding the `spotlightBrowserIntegration()` to their integrations which
        // wouldn't get initialized with the check below when there's no DSN set.
        this._options.integrations.some(({ name: name })=>name.startsWith('Spotlight'))) this._setupIntegrations();
    }
    /**
   * Gets an installed integration by its name.
   *
   * @returns {Integration|undefined} The installed integration or `undefined` if no integration with that `name` was installed.
   */ getIntegrationByName(integrationName) {
        return this._integrations[integrationName];
    }
    /**
   * Add an integration to the client.
   * This can be used to e.g. lazy load integrations.
   * In most cases, this should not be necessary,
   * and you're better off just passing the integrations via `integrations: []` at initialization time.
   * However, if you find the need to conditionally load & add an integration, you can use `addIntegration` to do so.
   */ addIntegration(integration) {
        const isAlreadyInstalled = this._integrations[integration.name];
        // This hook takes care of only installing if not already installed
        (0, $cbb2da6c78246e45$export$e7390a03b70a6f2f)(this, integration, this._integrations);
        // Here we need to check manually to make sure to not run this multiple times
        if (!isAlreadyInstalled) (0, $cbb2da6c78246e45$export$35abcfd71227c6ca)(this, [
            integration
        ]);
    }
    /**
   * Send a fully prepared event to Sentry.
   */ sendEvent(event, hint = {}) {
        this.emit('beforeSendEvent', event, hint);
        let env = (0, $50a1e2eac2a45b83$export$c31057337a18010f)(event, this._dsn, this._options._metadata, this._options.tunnel);
        for (const attachment of hint.attachments || [])env = (0, $bb063ad93c8b79c7$export$d650323442802f6f)(env, (0, $bb063ad93c8b79c7$export$d8fc80952cc31fa4)(attachment));
        // sendEnvelope should not throw
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.sendEnvelope(env).then((sendResponse)=>this.emit('afterSendEvent', event, sendResponse));
    }
    /**
   * Send a session or session aggregrates to Sentry.
   */ sendSession(session) {
        // Backfill release and environment on session
        const { release: clientReleaseOption, environment: clientEnvironmentOption = (0, $4e93b773a0d3a86a$export$849dbeeeda01ae98) } = this._options;
        if ('aggregates' in session) {
            const sessionAttrs = session.attrs || {};
            if (!sessionAttrs.release && !clientReleaseOption) {
                (0, $19fdbaf7f0830971$export$16a28057038b10ef) && (0, $d11ed0b3cdda6b8d$export$1c9f709888824e05).warn($13e8a14cd93782c3$var$MISSING_RELEASE_FOR_SESSION_ERROR);
                return;
            }
            sessionAttrs.release = sessionAttrs.release || clientReleaseOption;
            sessionAttrs.environment = sessionAttrs.environment || clientEnvironmentOption;
            session.attrs = sessionAttrs;
        } else {
            if (!session.release && !clientReleaseOption) {
                (0, $19fdbaf7f0830971$export$16a28057038b10ef) && (0, $d11ed0b3cdda6b8d$export$1c9f709888824e05).warn($13e8a14cd93782c3$var$MISSING_RELEASE_FOR_SESSION_ERROR);
                return;
            }
            session.release = session.release || clientReleaseOption;
            session.environment = session.environment || clientEnvironmentOption;
        }
        this.emit('beforeSendSession', session);
        const env = (0, $50a1e2eac2a45b83$export$124b03c077baa2f3)(session, this._dsn, this._options._metadata, this._options.tunnel);
        // sendEnvelope should not throw
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.sendEnvelope(env);
    }
    /**
   * Record on the client that an event got dropped (ie, an event that will not be sent to Sentry).
   */ recordDroppedEvent(reason, category, count = 1) {
        if (this._options.sendClientReports) {
            // We want to track each category (error, transaction, session, replay_event) separately
            // but still keep the distinction between different type of outcomes.
            // We could use nested maps, but it's much easier to read and type this way.
            // A correct type for map-based implementation if we want to go that route
            // would be `Partial<Record<SentryRequestType, Partial<Record<Outcome, number>>>>`
            // With typescript 4.1 we could even use template literal types
            const key = `${reason}:${category}`;
            (0, $19fdbaf7f0830971$export$16a28057038b10ef) && (0, $d11ed0b3cdda6b8d$export$1c9f709888824e05).log(`Recording outcome: "${key}"${count > 1 ? ` (${count} times)` : ''}`);
            this._outcomes[key] = (this._outcomes[key] || 0) + count;
        }
    }
    /* eslint-disable @typescript-eslint/unified-signatures */ /**
   * Register a callback for whenever a span is started.
   * Receives the span as argument.
   * @returns {() => void} A function that, when executed, removes the registered callback.
   */ /**
   * Register a hook on this client.
   */ on(hook, callback) {
        const hookCallbacks = this._hooks[hook] = this._hooks[hook] || new Set();
        // Wrap the callback in a function so that registering the same callback instance multiple
        // times results in the callback being called multiple times.
        // @ts-expect-error - The `callback` type is correct and must be a function due to the
        // individual, specific overloads of this function.
        // eslint-disable-next-line @typescript-eslint/ban-types
        const uniqueCallback = (...args)=>callback(...args);
        hookCallbacks.add(uniqueCallback);
        // This function returns a callback execution handler that, when invoked,
        // deregisters a callback. This is crucial for managing instances where callbacks
        // need to be unregistered to prevent self-referencing in callback closures,
        // ensuring proper garbage collection.
        return ()=>{
            hookCallbacks.delete(uniqueCallback);
        };
    }
    /** Fire a hook whenever a span starts. */ /**
   * Emit a hook that was previously registered via `on()`.
   */ emit(hook, ...rest) {
        const callbacks = this._hooks[hook];
        if (callbacks) callbacks.forEach((callback)=>callback(...rest));
    }
    /**
   * Send an envelope to Sentry.
   */ // @ts-expect-error - PromiseLike is a subset of Promise
    async sendEnvelope(envelope) {
        this.emit('beforeEnvelope', envelope);
        if (this._isEnabled() && this._transport) try {
            return await this._transport.send(envelope);
        } catch (reason) {
            (0, $19fdbaf7f0830971$export$16a28057038b10ef) && (0, $d11ed0b3cdda6b8d$export$1c9f709888824e05).error('Error while sending envelope:', reason);
            return {};
        }
        (0, $19fdbaf7f0830971$export$16a28057038b10ef) && (0, $d11ed0b3cdda6b8d$export$1c9f709888824e05).error('Transport disabled');
        return {};
    }
    /**
   * Disposes of the client and releases all resources.
   *
   * Subclasses should override this method to clean up their own resources.
   * After calling dispose(), the client should not be used anymore.
   */ dispose() {
    // Base class has no cleanup logic - subclasses implement their own
    }
    /* eslint-enable @typescript-eslint/unified-signatures */ /** Setup integrations for this client. */ _setupIntegrations() {
        const { integrations: integrations } = this._options;
        this._integrations = (0, $cbb2da6c78246e45$export$51abed9797baa598)(this, integrations);
        (0, $cbb2da6c78246e45$export$35abcfd71227c6ca)(this, integrations);
    }
    /** Updates existing session based on the provided event */ _updateSessionFromEvent(session, event) {
        // initially, set `crashed` based on the event level and update from exceptions if there are any later on
        let crashed = event.level === 'fatal';
        let errored = false;
        const exceptions = event.exception?.values;
        if (exceptions) {
            errored = true;
            // reset crashed to false if there are exceptions, to ensure `mechanism.handled` is respected.
            crashed = false;
            for (const ex of exceptions)if (ex.mechanism?.handled === false) {
                crashed = true;
                break;
            }
        }
        // A session is updated and that session update is sent in only one of the two following scenarios:
        // 1. Session with non terminal status and 0 errors + an error occurred -> Will set error count to 1 and send update
        // 2. Session with non terminal status and 1 error + a crash occurred -> Will set status crashed and send update
        const sessionNonTerminal = session.status === 'ok';
        const shouldUpdateAndSend = sessionNonTerminal && session.errors === 0 || sessionNonTerminal && crashed;
        if (shouldUpdateAndSend) {
            (0, $e6ef9757665bd407$export$531818e825e774db)(session, {
                ...crashed && {
                    status: 'crashed'
                },
                errors: session.errors || Number(errored || crashed)
            });
            this.captureSession(session);
        }
    }
    /**
   * Determine if the client is finished processing. Returns a promise because it will wait `timeout` ms before saying
   * "no" (resolving to `false`) in order to give the client a chance to potentially finish first.
   *
   * @param timeout The time, in ms, after which to resolve to `false` if the client is still busy. Passing `0` (or not
   * passing anything) will make the promise wait as long as it takes for processing to finish before resolving to
   * `true`.
   * @returns A promise which will resolve to `true` if processing is already done or finishes before the timeout, and
   * `false` otherwise
   */ async _isClientDoneProcessing(timeout) {
        let ticked = 0;
        while(!timeout || ticked < timeout){
            await new Promise((resolve)=>setTimeout(resolve, 1));
            if (!this._numProcessing) return true;
            ticked++;
        }
        return false;
    }
    /** Determines whether this SDK is enabled and a transport is present. */ _isEnabled() {
        return this.getOptions().enabled !== false && this._transport !== undefined;
    }
    /**
   * Adds common information to events.
   *
   * The information includes release and environment from `options`,
   * breadcrumbs and context (extra, tags and user) from the scope.
   *
   * Information that is already present in the event is never overwritten. For
   * nested objects, such as the context, keys are merged.
   *
   * @param event The original event.
   * @param hint May contain additional information about the original exception.
   * @param currentScope A scope containing event metadata.
   * @returns A new event with more information.
   */ _prepareEvent(event, hint, currentScope, isolationScope) {
        const options = this.getOptions();
        const integrations = Object.keys(this._integrations);
        if (!hint.integrations && integrations?.length) hint.integrations = integrations;
        this.emit('preprocessEvent', event, hint);
        if (!event.type) isolationScope.setLastEventId(event.event_id || hint.event_id);
        return (0, $e98f8a40c7329053$export$2d67fb380bd11267)(options, event, hint, currentScope, this, isolationScope).then((evt)=>{
            if (evt === null) return evt;
            this.emit('postprocessEvent', evt, hint);
            evt.contexts = {
                trace: {
                    ...evt.contexts?.trace,
                    ...(0, $7d48e1ed9f699a01$export$1e83db7ee4876dc4)(currentScope)
                },
                ...evt.contexts
            };
            const dynamicSamplingContext = (0, $09fae5ef8120e803$export$89ef1736f08c6b2b)(this, currentScope);
            evt.sdkProcessingMetadata = {
                dynamicSamplingContext: dynamicSamplingContext,
                ...evt.sdkProcessingMetadata
            };
            return evt;
        });
    }
    /**
   * Processes the event and logs an error in case of rejection
   * @param event
   * @param hint
   * @param scope
   */ _captureEvent(event, hint = {}, currentScope = (0, $7d48e1ed9f699a01$export$c7be4b0125a10cba)(), isolationScope = (0, $7d48e1ed9f699a01$export$68f3af03034c9e90)()) {
        if ((0, $19fdbaf7f0830971$export$16a28057038b10ef) && $13e8a14cd93782c3$var$isErrorEvent(event)) (0, $d11ed0b3cdda6b8d$export$1c9f709888824e05).log(`Captured error event \`${(0, $ac8e718335e141d5$export$d55a97c329cacfcc)(event)[0] || '<unknown>'}\``);
        return this._processEvent(event, hint, currentScope, isolationScope).then((finalEvent)=>{
            return finalEvent.event_id;
        }, (reason)=>{
            if (0, $19fdbaf7f0830971$export$16a28057038b10ef) {
                if ($13e8a14cd93782c3$var$_isDoNotSendEventError(reason)) (0, $d11ed0b3cdda6b8d$export$1c9f709888824e05).log(reason.message);
                else if ($13e8a14cd93782c3$var$_isInternalError(reason)) (0, $d11ed0b3cdda6b8d$export$1c9f709888824e05).warn(reason.message);
                else (0, $d11ed0b3cdda6b8d$export$1c9f709888824e05).warn(reason);
            }
            return undefined;
        });
    }
    /**
   * Processes an event (either error or message) and sends it to Sentry.
   *
   * This also adds breadcrumbs and context information to the event. However,
   * platform specific meta data (such as the User's IP address) must be added
   * by the SDK implementor.
   *
   *
   * @param event The event to send to Sentry.
   * @param hint May contain additional information about the original exception.
   * @param currentScope A scope containing event metadata.
   * @returns A SyncPromise that resolves with the event or rejects in case event was/will not be send.
   */ _processEvent(event, hint, currentScope, isolationScope) {
        const options = this.getOptions();
        const { sampleRate: sampleRate } = options;
        const isTransaction = $13e8a14cd93782c3$var$isTransactionEvent(event);
        const isError = $13e8a14cd93782c3$var$isErrorEvent(event);
        const eventType = event.type || 'error';
        const beforeSendLabel = `before send for type \`${eventType}\``;
        // 1.0 === 100% events are sent
        // 0.0 === 0% events are sent
        // Sampling for transaction happens somewhere else
        const parsedSampleRate = typeof sampleRate === 'undefined' ? undefined : (0, $921fe5f527b40422$export$a5bd2d81656d9546)(sampleRate);
        if (isError && typeof parsedSampleRate === 'number' && (0, $c80d7f6644a3b50b$export$9869d72de32a3917)() > parsedSampleRate) {
            this.recordDroppedEvent('sample_rate', 'error');
            return (0, $e9661cd6d20ea7e7$export$78e43115b553f358)($13e8a14cd93782c3$var$_makeDoNotSendEventError(`Discarding event because it's not included in the random sample (sampling rate = ${sampleRate})`));
        }
        const dataCategory = $13e8a14cd93782c3$var$getDataCategoryByType(event.type);
        return this._prepareEvent(event, hint, currentScope, isolationScope).then((prepared)=>{
            if (prepared === null) {
                this.recordDroppedEvent('event_processor', dataCategory);
                throw $13e8a14cd93782c3$var$_makeDoNotSendEventError('An event processor returned `null`, will not send event.');
            }
            const isInternalException = hint.data?.__sentry__ === true;
            if (isInternalException) return prepared;
            const result = $13e8a14cd93782c3$var$processBeforeSend(this, options, prepared, hint);
            return $13e8a14cd93782c3$var$_validateBeforeSendResult(result, beforeSendLabel);
        }).then((processedEvent)=>{
            if (processedEvent === null) {
                this.recordDroppedEvent('before_send', dataCategory);
                if (isTransaction) {
                    const spans = event.spans || [];
                    // the transaction itself counts as one span, plus all the child spans that are added
                    const spanCount = 1 + spans.length;
                    this.recordDroppedEvent('before_send', 'span', spanCount);
                }
                throw $13e8a14cd93782c3$var$_makeDoNotSendEventError(`${beforeSendLabel} returned \`null\`, will not send event.`);
            }
            const session = currentScope.getSession() || isolationScope.getSession();
            if (isError && session) this._updateSessionFromEvent(session, processedEvent);
            if (isTransaction) {
                const spanCountBefore = processedEvent.sdkProcessingMetadata?.spanCountBeforeProcessing || 0;
                const spanCountAfter = processedEvent.spans ? processedEvent.spans.length : 0;
                const droppedSpanCount = spanCountBefore - spanCountAfter;
                if (droppedSpanCount > 0) this.recordDroppedEvent('before_send', 'span', droppedSpanCount);
            }
            // None of the Sentry built event processor will update transaction name,
            // so if the transaction name has been changed by an event processor, we know
            // it has to come from custom event processor added by a user
            const transactionInfo = processedEvent.transaction_info;
            if (isTransaction && transactionInfo && processedEvent.transaction !== event.transaction) {
                const source = 'custom';
                processedEvent.transaction_info = {
                    ...transactionInfo,
                    source: source
                };
            }
            this.sendEvent(processedEvent, hint);
            return processedEvent;
        }).then(null, (reason)=>{
            if ($13e8a14cd93782c3$var$_isDoNotSendEventError(reason) || $13e8a14cd93782c3$var$_isInternalError(reason)) throw reason;
            this.captureException(reason, {
                mechanism: {
                    handled: false,
                    type: 'internal'
                },
                data: {
                    __sentry__: true
                },
                originalException: reason
            });
            throw $13e8a14cd93782c3$var$_makeInternalError(`Event processing pipeline threw an error, original event will not be sent. Details have been sent as a new event.\nReason: ${reason}`);
        });
    }
    /**
   * Occupies the client with processing and event
   */ _process(taskProducer, dataCategory) {
        this._numProcessing++;
        this._promiseBuffer.add(taskProducer).then((value)=>{
            this._numProcessing--;
            return value;
        }, (reason)=>{
            this._numProcessing--;
            if (reason === (0, $1407141ba4ddb36d$export$c8667f1887a128dc)) this.recordDroppedEvent('queue_overflow', dataCategory);
            return reason;
        });
    }
    /**
   * Clears outcomes on this client and returns them.
   */ _clearOutcomes() {
        const outcomes = this._outcomes;
        this._outcomes = {};
        return Object.entries(outcomes).map(([key, quantity])=>{
            const [reason, category] = key.split(':');
            return {
                reason: reason,
                category: category,
                quantity: quantity
            };
        });
    }
    /**
   * Sends client reports as an envelope.
   */ _flushOutcomes() {
        (0, $19fdbaf7f0830971$export$16a28057038b10ef) && (0, $d11ed0b3cdda6b8d$export$1c9f709888824e05).log('Flushing outcomes...');
        const outcomes = this._clearOutcomes();
        if (outcomes.length === 0) {
            (0, $19fdbaf7f0830971$export$16a28057038b10ef) && (0, $d11ed0b3cdda6b8d$export$1c9f709888824e05).log('No outcomes to send');
            return;
        }
        // This is really the only place where we want to check for a DSN and only send outcomes then
        if (!this._dsn) {
            (0, $19fdbaf7f0830971$export$16a28057038b10ef) && (0, $d11ed0b3cdda6b8d$export$1c9f709888824e05).log('No dsn provided, will not send outcomes');
            return;
        }
        (0, $19fdbaf7f0830971$export$16a28057038b10ef) && (0, $d11ed0b3cdda6b8d$export$1c9f709888824e05).log('Sending outcomes:', outcomes);
        const envelope = (0, $1503c20c7cf56625$export$f3b9ed77c03eeb00)(outcomes, this._options.tunnel && (0, $1e1399eeae328b26$export$44d472fbb931a776)(this._dsn));
        // sendEnvelope should not throw
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.sendEnvelope(envelope);
    }
}
function $13e8a14cd93782c3$var$getDataCategoryByType(type) {
    return type === 'replay_event' ? 'replay' : type || 'error';
}
/**
 * Verifies that return value of configured `beforeSend` or `beforeSendTransaction` is of expected type, and returns the value if so.
 */ function $13e8a14cd93782c3$var$_validateBeforeSendResult(beforeSendResult, beforeSendLabel) {
    const invalidValueError = `${beforeSendLabel} must return \`null\` or a valid event.`;
    if ((0, $13cf2ed412f405fa$export$f5b060c2914b97c8)(beforeSendResult)) return beforeSendResult.then((event)=>{
        if (!(0, $13cf2ed412f405fa$export$53b83ca8eaab0383)(event) && event !== null) throw $13e8a14cd93782c3$var$_makeInternalError(invalidValueError);
        return event;
    }, (e)=>{
        throw $13e8a14cd93782c3$var$_makeInternalError(`${beforeSendLabel} rejected with ${e}`);
    });
    else if (!(0, $13cf2ed412f405fa$export$53b83ca8eaab0383)(beforeSendResult) && beforeSendResult !== null) throw $13e8a14cd93782c3$var$_makeInternalError(invalidValueError);
    return beforeSendResult;
}
/**
 * Process the matching `beforeSendXXX` callback.
 */ function $13e8a14cd93782c3$var$processBeforeSend(client, options, event, hint) {
    const { beforeSend: beforeSend, beforeSendTransaction: beforeSendTransaction, beforeSendSpan: beforeSendSpan, ignoreSpans: ignoreSpans } = options;
    let processedEvent = event;
    if ($13e8a14cd93782c3$var$isErrorEvent(processedEvent) && beforeSend) return beforeSend(processedEvent, hint);
    if ($13e8a14cd93782c3$var$isTransactionEvent(processedEvent)) {
        // Avoid processing if we don't have to
        if (beforeSendSpan || ignoreSpans) {
            // 1. Process root span
            const rootSpanJson = (0, $d50d2811fbb82a76$export$d9c6b2464b0a687e)(processedEvent);
            // 1.1 If the root span should be ignored, drop the whole transaction
            if (ignoreSpans?.length && (0, $18bf74fc9ecc8708$export$5d569ac97c389400)(rootSpanJson, ignoreSpans)) // dropping the whole transaction!
            return null;
            // 1.2 If a `beforeSendSpan` callback is defined, process the root span
            if (beforeSendSpan) {
                const processedRootSpanJson = beforeSendSpan(rootSpanJson);
                if (!processedRootSpanJson) (0, $bb9b6447bf4caedb$export$d11691ff45a3e535)();
                else // update event with processed root span values
                processedEvent = (0, $40b0d31022c415bf$export$4950aa0f605343fb)(event, (0, $d50d2811fbb82a76$export$f2d8fce5ae150e92)(processedRootSpanJson));
            }
            // 2. Process child spans
            if (processedEvent.spans) {
                const processedSpans = [];
                const initialSpans = processedEvent.spans;
                for (const span of initialSpans){
                    // 2.a If the child span should be ignored, reparent it to the root span
                    if (ignoreSpans?.length && (0, $18bf74fc9ecc8708$export$5d569ac97c389400)(span, ignoreSpans)) {
                        (0, $18bf74fc9ecc8708$export$ddf57376e818b444)(initialSpans, span);
                        continue;
                    }
                    // 2.b If a `beforeSendSpan` callback is defined, process the child span
                    if (beforeSendSpan) {
                        const processedSpan = beforeSendSpan(span);
                        if (!processedSpan) {
                            (0, $bb9b6447bf4caedb$export$d11691ff45a3e535)();
                            processedSpans.push(span);
                        } else processedSpans.push(processedSpan);
                    } else processedSpans.push(span);
                }
                const droppedSpans = processedEvent.spans.length - processedSpans.length;
                if (droppedSpans) client.recordDroppedEvent('before_send', 'span', droppedSpans);
                processedEvent.spans = processedSpans;
            }
        }
        if (beforeSendTransaction) {
            if (processedEvent.spans) {
                // We store the # of spans before processing in SDK metadata,
                // so we can compare it afterwards to determine how many spans were dropped
                const spanCountBefore = processedEvent.spans.length;
                processedEvent.sdkProcessingMetadata = {
                    ...event.sdkProcessingMetadata,
                    spanCountBeforeProcessing: spanCountBefore
                };
            }
            return beforeSendTransaction(processedEvent, hint);
        }
    }
    return processedEvent;
}
function $13e8a14cd93782c3$var$isErrorEvent(event) {
    return event.type === undefined;
}
function $13e8a14cd93782c3$var$isTransactionEvent(event) {
    return event.type === 'transaction';
}
/**
 * Estimate the size of a metric in bytes.
 *
 * @param metric - The metric to estimate the size of.
 * @returns The estimated size of the metric in bytes.
 */ function $13e8a14cd93782c3$var$estimateMetricSizeInBytes(metric) {
    let weight = 0;
    // Estimate byte size of 2 bytes per character. This is a rough estimate JS strings are stored as UTF-16.
    if (metric.name) weight += metric.name.length * 2;
    // Add weight for number
    weight += 8;
    return weight + $13e8a14cd93782c3$var$estimateAttributesSizeInBytes(metric.attributes);
}
/**
 * Estimate the size of a log in bytes.
 *
 * @param log - The log to estimate the size of.
 * @returns The estimated size of the log in bytes.
 */ function $13e8a14cd93782c3$var$estimateLogSizeInBytes(log) {
    let weight = 0;
    // Estimate byte size of 2 bytes per character. This is a rough estimate JS strings are stored as UTF-16.
    if (log.message) weight += log.message.length * 2;
    return weight + $13e8a14cd93782c3$var$estimateAttributesSizeInBytes(log.attributes);
}
/**
 * Estimate the size of attributes in bytes.
 *
 * @param attributes - The attributes object to estimate the size of.
 * @returns The estimated size of the attributes in bytes.
 */ function $13e8a14cd93782c3$var$estimateAttributesSizeInBytes(attributes) {
    if (!attributes) return 0;
    let weight = 0;
    Object.values(attributes).forEach((value)=>{
        if (Array.isArray(value)) weight += value.length * $13e8a14cd93782c3$var$estimatePrimitiveSizeInBytes(value[0]);
        else if ((0, $13cf2ed412f405fa$export$c3825b437cbdea5c)(value)) weight += $13e8a14cd93782c3$var$estimatePrimitiveSizeInBytes(value);
        else // For objects values, we estimate the size of the object as 100 bytes
        weight += 100;
    });
    return weight;
}
function $13e8a14cd93782c3$var$estimatePrimitiveSizeInBytes(value) {
    if (typeof value === 'string') return value.length * 2;
    else if (typeof value === 'number') return 8;
    else if (typeof value === 'boolean') return 4;
    return 0;
}


var $7V87c = parcelRequire("7V87c");




/**
 * Extracts stack frames from the error.stack string
 */ function $bab2d68b07ac0c47$export$d478b2c12fbcfdda(stackParser, error) {
    return stackParser(error.stack || '', 1);
}
function $bab2d68b07ac0c47$var$hasSentryFetchUrlHost(error) {
    return (0, $13cf2ed412f405fa$export$e6127cc7fe7395c3)(error) && '__sentry_fetch_url_host__' in error && typeof error.__sentry_fetch_url_host__ === 'string';
}
/**
 * Enhances the error message with the hostname for better Sentry error reporting.
 * This allows third-party packages to still match on the original error message,
 * while Sentry gets the enhanced version with context.
 *
 * Only used internally
 * @hidden
 */ function $bab2d68b07ac0c47$export$35a730c8874c1024(error) {
    // If the error has a __sentry_fetch_url_host__ property (added by fetch instrumentation),
    // enhance the error message with the hostname.
    if ($bab2d68b07ac0c47$var$hasSentryFetchUrlHost(error)) return `${error.message} (${error.__sentry_fetch_url_host__})`;
    return error.message;
}
/**
 * Extracts stack frames from the error and builds a Sentry Exception
 */ function $bab2d68b07ac0c47$export$a6c2d27607295951(stackParser, error) {
    const exception = {
        type: error.name || error.constructor.name,
        value: $bab2d68b07ac0c47$export$35a730c8874c1024(error)
    };
    const frames = $bab2d68b07ac0c47$export$d478b2c12fbcfdda(stackParser, error);
    if (frames.length) exception.stacktrace = {
        frames: frames
    };
    return exception;
}
/** If a plain object has a property that is an `Error`, return this error. */ function $bab2d68b07ac0c47$var$getErrorPropertyFromObject(obj) {
    for(const prop in obj)if (Object.prototype.hasOwnProperty.call(obj, prop)) {
        const value = obj[prop];
        if (value instanceof Error) return value;
    }
    return undefined;
}
function $bab2d68b07ac0c47$var$getMessageForObject(exception) {
    if ('name' in exception && typeof exception.name === 'string') {
        let message = `'${exception.name}' captured as exception`;
        if ('message' in exception && typeof exception.message === 'string') message += ` with message '${exception.message}'`;
        return message;
    } else if ('message' in exception && typeof exception.message === 'string') return exception.message;
    const keys = (0, $269eeb69635ed414$export$b0244d5063c0b61b)(exception);
    // Some ErrorEvent instances do not have an `error` property, which is why they are not handled before
    // We still want to try to get a decent message for these cases
    if ((0, $13cf2ed412f405fa$export$9f9636d330b71954)(exception)) return `Event \`ErrorEvent\` captured as exception with message \`${exception.message}\``;
    const className = $bab2d68b07ac0c47$var$getObjectClassName(exception);
    return `${className && className !== 'Object' ? `'${className}'` : 'Object'} captured as exception with keys: ${keys}`;
}
function $bab2d68b07ac0c47$var$getObjectClassName(obj) {
    try {
        const prototype = Object.getPrototypeOf(obj);
        return prototype ? prototype.constructor.name : undefined;
    } catch  {
    // ignore errors here
    }
}
function $bab2d68b07ac0c47$var$getException(client, mechanism, exception, hint) {
    if ((0, $13cf2ed412f405fa$export$e6127cc7fe7395c3)(exception)) return [
        exception,
        undefined
    ];
    // Mutate this!
    mechanism.synthetic = true;
    if ((0, $13cf2ed412f405fa$export$53b83ca8eaab0383)(exception)) {
        const normalizeDepth = client?.getOptions().normalizeDepth;
        const extras = {
            ['__serialized__']: (0, $2d7134eeb4bc669b$export$23fbbb20bed71033)(exception, normalizeDepth)
        };
        const errorFromProp = $bab2d68b07ac0c47$var$getErrorPropertyFromObject(exception);
        if (errorFromProp) return [
            errorFromProp,
            extras
        ];
        const message = $bab2d68b07ac0c47$var$getMessageForObject(exception);
        const ex = hint?.syntheticException || new Error(message);
        ex.message = message;
        return [
            ex,
            extras
        ];
    }
    // This handles when someone does: `throw "something awesome";`
    // We use synthesized Error here so we can extract a (rough) stack trace.
    const ex = hint?.syntheticException || new Error(exception);
    ex.message = `${exception}`;
    return [
        ex,
        undefined
    ];
}
/**
 * Builds and Event from a Exception
 * @hidden
 */ function $bab2d68b07ac0c47$export$9dd56ed1ef0c3420(client, stackParser, exception, hint) {
    const providedMechanism = hint?.data && hint.data.mechanism;
    const mechanism = providedMechanism || {
        handled: true,
        type: 'generic'
    };
    const [ex, extras] = $bab2d68b07ac0c47$var$getException(client, mechanism, exception, hint);
    const event = {
        exception: {
            values: [
                $bab2d68b07ac0c47$export$a6c2d27607295951(stackParser, ex)
            ]
        }
    };
    if (extras) event.extra = extras;
    (0, $cc262db35458e4b3$export$f26508487bf83ee7)(event, undefined, undefined);
    (0, $cc262db35458e4b3$export$c69a9a0313b03bb1)(event, mechanism);
    return {
        ...event,
        event_id: hint?.event_id
    };
}
/**
 * Builds and Event from a Message
 * @hidden
 */ function $bab2d68b07ac0c47$export$5425b53185d13d6c(stackParser, message, level = 'info', hint, attachStacktrace) {
    const event = {
        event_id: hint?.event_id,
        level: level
    };
    if (attachStacktrace && hint?.syntheticException) {
        const frames = $bab2d68b07ac0c47$export$d478b2c12fbcfdda(stackParser, hint.syntheticException);
        if (frames.length) {
            event.exception = {
                values: [
                    {
                        value: message,
                        stacktrace: {
                            frames: frames
                        }
                    }
                ]
            };
            (0, $cc262db35458e4b3$export$c69a9a0313b03bb1)(event, {
                synthetic: true
            });
        }
    }
    if ((0, $13cf2ed412f405fa$export$dbcbffa59149b824)(message)) {
        const { __sentry_template_string__: __sentry_template_string__, __sentry_template_values__: __sentry_template_values__ } = message;
        event.logentry = {
            message: __sentry_template_string__,
            params: __sentry_template_values__
        };
        return event;
    }
    event.message = message;
    return event;
}


/**
 * This function creates an exception from a JavaScript Error
 */ function $934e8a4b0ce930b6$export$a6c2d27607295951(stackParser, ex) {
    // Get the frames first since Opera can lose the stack if we touch anything else first
    const frames = $934e8a4b0ce930b6$var$parseStackFrames(stackParser, ex);
    const exception = {
        type: $934e8a4b0ce930b6$export$2e9ae379995d99e3(ex),
        value: $934e8a4b0ce930b6$export$86005d1b62804363(ex)
    };
    if (frames.length) exception.stacktrace = {
        frames: frames
    };
    if (exception.type === undefined && exception.value === '') exception.value = 'Unrecoverable error caught';
    return exception;
}
function $934e8a4b0ce930b6$var$eventFromPlainObject(stackParser, exception, syntheticException, isUnhandledRejection) {
    const client = (0, $7d48e1ed9f699a01$export$6bb76d6eba7e258c)();
    const normalizeDepth = client?.getOptions().normalizeDepth;
    // If we can, we extract an exception from the object properties
    const errorFromProp = $934e8a4b0ce930b6$var$getErrorPropertyFromObject(exception);
    const extra = {
        __serialized__: (0, $2d7134eeb4bc669b$export$23fbbb20bed71033)(exception, normalizeDepth)
    };
    if (errorFromProp) return {
        exception: {
            values: [
                $934e8a4b0ce930b6$export$a6c2d27607295951(stackParser, errorFromProp)
            ]
        },
        extra: extra
    };
    const event = {
        exception: {
            values: [
                {
                    type: (0, $13cf2ed412f405fa$export$9671ea99bd126ace)(exception) ? exception.constructor.name : isUnhandledRejection ? 'UnhandledRejection' : 'Error',
                    value: $934e8a4b0ce930b6$var$getNonErrorObjectExceptionValue(exception, {
                        isUnhandledRejection: isUnhandledRejection
                    })
                }
            ]
        },
        extra: extra
    };
    if (syntheticException) {
        const frames = $934e8a4b0ce930b6$var$parseStackFrames(stackParser, syntheticException);
        if (frames.length) // event.exception.values[0] has been set above
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        event.exception.values[0].stacktrace = {
            frames: frames
        };
    }
    return event;
}
function $934e8a4b0ce930b6$var$eventFromError(stackParser, ex) {
    return {
        exception: {
            values: [
                $934e8a4b0ce930b6$export$a6c2d27607295951(stackParser, ex)
            ]
        }
    };
}
/** Parses stack frames from an error */ function $934e8a4b0ce930b6$var$parseStackFrames(stackParser, ex) {
    // Access and store the stacktrace property before doing ANYTHING
    // else to it because Opera is not very good at providing it
    // reliably in other circumstances.
    const stacktrace = ex.stacktrace || ex.stack || '';
    const skipLines = $934e8a4b0ce930b6$var$getSkipFirstStackStringLines(ex);
    const framesToPop = $934e8a4b0ce930b6$var$getPopFirstTopFrames(ex);
    try {
        return stackParser(stacktrace, skipLines, framesToPop);
    } catch  {
    // no-empty
    }
    return [];
}
// Based on our own mapping pattern - https://github.com/getsentry/sentry/blob/9f08305e09866c8bd6d0c24f5b0aabdd7dd6c59c/src/sentry/lang/javascript/errormapping.py#L83-L108
const $934e8a4b0ce930b6$var$reactMinifiedRegexp = /Minified React error #\d+;/i;
/**
 * Certain known React errors contain links that would be falsely
 * parsed as frames. This function check for these errors and
 * returns number of the stack string lines to skip.
 */ function $934e8a4b0ce930b6$var$getSkipFirstStackStringLines(ex) {
    if (ex && $934e8a4b0ce930b6$var$reactMinifiedRegexp.test(ex.message)) return 1;
    return 0;
}
/**
 * If error has `framesToPop` property, it means that the
 * creator tells us the first x frames will be useless
 * and should be discarded. Typically error from wrapper function
 * which don't point to the actual location in the developer's code.
 *
 * Example: https://github.com/zertosh/invariant/blob/master/invariant.js#L46
 */ function $934e8a4b0ce930b6$var$getPopFirstTopFrames(ex) {
    if (typeof ex.framesToPop === 'number') return ex.framesToPop;
    return 0;
}
// https://developer.mozilla.org/en-US/docs/WebAssembly/JavaScript_interface/Exception
// @ts-expect-error - WebAssembly.Exception is a valid class
function $934e8a4b0ce930b6$var$isWebAssemblyException(exception) {
    // Check for support
    // @ts-expect-error - WebAssembly.Exception is a valid class
    // oxlint-disable-next-line typescript/prefer-optional-chain
    if (typeof WebAssembly !== 'undefined' && typeof WebAssembly.Exception !== 'undefined') // @ts-expect-error - WebAssembly.Exception is a valid class
    return exception instanceof WebAssembly.Exception;
    else return false;
}
/**
 * Extracts from errors what we use as the exception `type` in error events.
 *
 * Usually, this is the `name` property on Error objects but WASM errors need to be treated differently.
 */ function $934e8a4b0ce930b6$export$2e9ae379995d99e3(ex) {
    const name = ex?.name;
    // The name for WebAssembly.Exception Errors needs to be extracted differently.
    // Context: https://github.com/getsentry/sentry-javascript/issues/13787
    if (!name && $934e8a4b0ce930b6$var$isWebAssemblyException(ex)) {
        // Emscripten sets array[type, message] to the "message" property on the WebAssembly.Exception object
        const hasTypeInMessage = ex.message && Array.isArray(ex.message) && ex.message.length == 2;
        return hasTypeInMessage ? ex.message[0] : 'WebAssembly.Exception';
    }
    return name;
}
/**
 * There are cases where stacktrace.message is an Event object
 * https://github.com/getsentry/sentry-javascript/issues/1949
 * In this specific case we try to extract stacktrace.message.error.message
 */ function $934e8a4b0ce930b6$export$86005d1b62804363(ex) {
    const message = ex?.message;
    if ($934e8a4b0ce930b6$var$isWebAssemblyException(ex)) {
        // For Node 18, Emscripten sets array[type, message] to the "message" property on the WebAssembly.Exception object
        if (Array.isArray(ex.message) && ex.message.length == 2) return ex.message[1];
        return 'wasm exception';
    }
    if (!message) return 'No error message';
    if (message.error && typeof message.error.message === 'string') return (0, $bab2d68b07ac0c47$export$35a730c8874c1024)(message.error);
    return (0, $bab2d68b07ac0c47$export$35a730c8874c1024)(ex);
}
/**
 * Creates an {@link Event} from all inputs to `captureException` and non-primitive inputs to `captureMessage`.
 * @hidden
 */ function $934e8a4b0ce930b6$export$ea3ec7e569b823fc(stackParser, exception, hint, attachStacktrace) {
    const syntheticException = hint?.syntheticException || undefined;
    const event = $934e8a4b0ce930b6$export$9dd56ed1ef0c3420(stackParser, exception, syntheticException, attachStacktrace);
    (0, $cc262db35458e4b3$export$c69a9a0313b03bb1)(event); // defaults to { type: 'generic', handled: true }
    event.level = 'error';
    if (hint?.event_id) event.event_id = hint.event_id;
    return (0, $e9661cd6d20ea7e7$export$1fda8aa4d135f8aa)(event);
}
/**
 * Builds and Event from a Message
 * @hidden
 */ function $934e8a4b0ce930b6$export$5425b53185d13d6c(stackParser, message, level = 'info', hint, attachStacktrace) {
    const syntheticException = hint?.syntheticException || undefined;
    const event = $934e8a4b0ce930b6$var$eventFromString(stackParser, message, syntheticException, attachStacktrace);
    event.level = level;
    if (hint?.event_id) event.event_id = hint.event_id;
    return (0, $e9661cd6d20ea7e7$export$1fda8aa4d135f8aa)(event);
}
/**
 * @hidden
 */ function $934e8a4b0ce930b6$export$9dd56ed1ef0c3420(stackParser, exception, syntheticException, attachStacktrace, isUnhandledRejection) {
    let event;
    if ((0, $13cf2ed412f405fa$export$9f9636d330b71954)(exception) && exception.error) {
        // If it is an ErrorEvent with `error` property, extract it to get actual Error
        const errorEvent = exception;
        return $934e8a4b0ce930b6$var$eventFromError(stackParser, errorEvent.error);
    }
    // If it is a `DOMError` (which is a legacy API, but still supported in some browsers) then we just extract the name
    // and message, as it doesn't provide anything else. According to the spec, all `DOMExceptions` should also be
    // `Error`s, but that's not the case in IE11, so in that case we treat it the same as we do a `DOMError`.
    //
    // https://developer.mozilla.org/en-US/docs/Web/API/DOMError
    // https://developer.mozilla.org/en-US/docs/Web/API/DOMException
    // https://webidl.spec.whatwg.org/#es-DOMException-specialness
    if ((0, $13cf2ed412f405fa$export$ef9e2056653f0c8e)(exception) || (0, $13cf2ed412f405fa$export$12e869b2a583f783)(exception)) {
        const domException = exception;
        if ('stack' in exception) event = $934e8a4b0ce930b6$var$eventFromError(stackParser, exception);
        else {
            const name = domException.name || ((0, $13cf2ed412f405fa$export$ef9e2056653f0c8e)(domException) ? 'DOMError' : 'DOMException');
            const message = domException.message ? `${name}: ${domException.message}` : name;
            event = $934e8a4b0ce930b6$var$eventFromString(stackParser, message, syntheticException, attachStacktrace);
            (0, $cc262db35458e4b3$export$f26508487bf83ee7)(event, message);
        }
        if ('code' in domException) // eslint-disable-next-line deprecation/deprecation
        event.tags = {
            ...event.tags,
            'DOMException.code': `${domException.code}`
        };
        return event;
    }
    if ((0, $13cf2ed412f405fa$export$e6127cc7fe7395c3)(exception)) // we have a real Error object, do nothing
    return $934e8a4b0ce930b6$var$eventFromError(stackParser, exception);
    if ((0, $13cf2ed412f405fa$export$53b83ca8eaab0383)(exception) || (0, $13cf2ed412f405fa$export$9671ea99bd126ace)(exception)) {
        // If it's a plain object or an instance of `Event` (the built-in JS kind, not this SDK's `Event` type), serialize
        // it manually. This will allow us to group events based on top-level keys which is much better than creating a new
        // group on any key/value change.
        const objectException = exception;
        event = $934e8a4b0ce930b6$var$eventFromPlainObject(stackParser, objectException, syntheticException, isUnhandledRejection);
        (0, $cc262db35458e4b3$export$c69a9a0313b03bb1)(event, {
            synthetic: true
        });
        return event;
    }
    // If none of previous checks were valid, then it means that it's not:
    // - an instance of DOMError
    // - an instance of DOMException
    // - an instance of Event
    // - an instance of Error
    // - a valid ErrorEvent (one with an error property)
    // - a plain Object
    //
    // So bail out and capture it as a simple message:
    event = $934e8a4b0ce930b6$var$eventFromString(stackParser, exception, syntheticException, attachStacktrace);
    (0, $cc262db35458e4b3$export$f26508487bf83ee7)(event, `${exception}`, undefined);
    (0, $cc262db35458e4b3$export$c69a9a0313b03bb1)(event, {
        synthetic: true
    });
    return event;
}
function $934e8a4b0ce930b6$var$eventFromString(stackParser, message, syntheticException, attachStacktrace) {
    const event = {};
    if (attachStacktrace && syntheticException) {
        const frames = $934e8a4b0ce930b6$var$parseStackFrames(stackParser, syntheticException);
        if (frames.length) event.exception = {
            values: [
                {
                    value: message,
                    stacktrace: {
                        frames: frames
                    }
                }
            ]
        };
        (0, $cc262db35458e4b3$export$c69a9a0313b03bb1)(event, {
            synthetic: true
        });
    }
    if ((0, $13cf2ed412f405fa$export$dbcbffa59149b824)(message)) {
        const { __sentry_template_string__: __sentry_template_string__, __sentry_template_values__: __sentry_template_values__ } = message;
        event.logentry = {
            message: __sentry_template_string__,
            params: __sentry_template_values__
        };
        return event;
    }
    event.message = message;
    return event;
}
function $934e8a4b0ce930b6$var$getNonErrorObjectExceptionValue(exception, { isUnhandledRejection: isUnhandledRejection }) {
    const keys = (0, $269eeb69635ed414$export$b0244d5063c0b61b)(exception);
    const captureType = isUnhandledRejection ? 'promise rejection' : 'exception';
    // Some ErrorEvent instances do not have an `error` property, which is why they are not handled before
    // We still want to try to get a decent message for these cases
    if ((0, $13cf2ed412f405fa$export$9f9636d330b71954)(exception)) return `Event \`ErrorEvent\` captured as ${captureType} with message \`${exception.message}\``;
    if ((0, $13cf2ed412f405fa$export$9671ea99bd126ace)(exception)) {
        const className = $934e8a4b0ce930b6$var$getObjectClassName(exception);
        return `Event \`${className}\` (type=${exception.type}) captured as ${captureType}`;
    }
    return `Object captured as ${captureType} with keys: ${keys}`;
}
function $934e8a4b0ce930b6$var$getObjectClassName(obj) {
    try {
        const prototype = Object.getPrototypeOf(obj);
        return prototype ? prototype.constructor.name : undefined;
    } catch  {
    // ignore errors here
    }
}
/** If a plain object has a property that is an `Error`, return this error. */ function $934e8a4b0ce930b6$var$getErrorPropertyFromObject(obj) {
    for(const prop in obj)if (Object.prototype.hasOwnProperty.call(obj, prop)) {
        const value = obj[prop];
        if (value instanceof Error) return value;
    }
    return undefined;
}



/**
 * A magic string that build tooling can leverage in order to inject a release value into the SDK.
 */ /**
 * The Sentry Browser SDK Client.
 *
 * @see BrowserOptions for documentation on configuration options.
 * @see SentryClient for usage documentation.
 */ class $4e1ce061c21a5e69$export$1df9218a526d318d extends (0, $13e8a14cd93782c3$export$1f2bb630327ac4b6) {
    /**
   * Creates a new Browser SDK instance.
   *
   * @param options Configuration options for this SDK.
   */ constructor(options){
        const opts = $4e1ce061c21a5e69$export$4e107b20a7f977(options);
        const sdkSource = (0, $e62dec891f31852b$export$56d8a8a25bd48b81).SENTRY_SDK_SOURCE || (0, $7V87c.getSDKSource)();
        (0, $4379b47e31368aa0$export$b9f95b027256052c)(opts, 'browser', [
            'browser'
        ], sdkSource);
        // Only allow IP inferral by Relay if sendDefaultPii is true
        if (opts._metadata?.sdk) opts._metadata.sdk.settings = {
            infer_ip: opts.sendDefaultPii ? 'auto' : 'never',
            // purposefully allowing already passed settings to override the default
            ...opts._metadata.sdk.settings
        };
        super(opts);
        const { sendDefaultPii: sendDefaultPii, sendClientReports: sendClientReports, enableLogs: enableLogs, _experiments: _experiments, enableMetrics: enableMetricsOption } = this._options;
        // todo(v11): Remove the experimental flag
        // eslint-disable-next-line deprecation/deprecation
        const enableMetrics = enableMetricsOption ?? _experiments?.enableMetrics ?? true;
        // Flush logs and metrics when page becomes hidden (e.g., tab switch, navigation)
        // todo(v11): Remove the experimental flag
        if ((0, $e62dec891f31852b$export$56d8a8a25bd48b81).document && (sendClientReports || enableLogs || enableMetrics)) (0, $e62dec891f31852b$export$56d8a8a25bd48b81).document.addEventListener('visibilitychange', ()=>{
            if ((0, $e62dec891f31852b$export$56d8a8a25bd48b81).document.visibilityState === 'hidden') {
                if (sendClientReports) this._flushOutcomes();
                if (enableLogs) (0, $aedf2f5a49662da4$export$f8ed83d3b6a0b504)(this);
                if (enableMetrics) (0, $8ed8fd97ec1f999f$export$91c9ef254b7d0f67)(this);
            }
        });
        if (sendDefaultPii) this.on('beforeSendSession', (0, $05ea44818da90d4b$export$e8e2d07ba63e2b6c));
    }
    /**
   * @inheritDoc
   */ eventFromException(exception, hint) {
        return (0, $934e8a4b0ce930b6$export$ea3ec7e569b823fc)(this._options.stackParser, exception, hint, this._options.attachStacktrace);
    }
    /**
   * @inheritDoc
   */ eventFromMessage(message, level = 'info', hint) {
        return (0, $934e8a4b0ce930b6$export$5425b53185d13d6c)(this._options.stackParser, message, level, hint, this._options.attachStacktrace);
    }
    /**
   * @inheritDoc
   */ _prepareEvent(event, hint, currentScope, isolationScope) {
        event.platform = event.platform || 'javascript';
        return super._prepareEvent(event, hint, currentScope, isolationScope);
    }
}
/** Exported only for tests. */ function $4e1ce061c21a5e69$export$4e107b20a7f977(optionsArg) {
    return {
        release: typeof __SENTRY_RELEASE__ === 'string' // This allows build tooling to find-and-replace __SENTRY_RELEASE__ to inject a release value
         ? __SENTRY_RELEASE__ : (0, $e62dec891f31852b$export$56d8a8a25bd48b81).SENTRY_RELEASE?.id,
        sendClientReports: true,
        // We default this to true, as it is the safer scenario
        parentSpanIsAlwaysRootSpan: true,
        ...optionsArg
    };
}






const $133087f5c0803d70$var$WINDOW = (0, $736a69486c86d36c$export$f1a6cdb1459e81d1);
/**
 * Tells whether current environment supports ErrorEvent objects
 * {@link supportsErrorEvent}.
 *
 * @returns Answer to the given question.
 */ function $133087f5c0803d70$export$caa710b4d7f9cadf() {
    try {
        new ErrorEvent('');
        return true;
    } catch  {
        return false;
    }
}
/**
 * Tells whether current environment supports DOMError objects
 * {@link supportsDOMError}.
 *
 * @returns Answer to the given question.
 */ function $133087f5c0803d70$export$1c08bd1a7eb3c472() {
    try {
        // Chrome: VM89:1 Uncaught TypeError: Failed to construct 'DOMError':
        // 1 argument required, but only 0 present.
        // @ts-expect-error It really needs 1 argument, not 0.
        new DOMError('');
        return true;
    } catch  {
        return false;
    }
}
/**
 * Tells whether current environment supports DOMException objects
 * {@link supportsDOMException}.
 *
 * @returns Answer to the given question.
 */ function $133087f5c0803d70$export$ab12a5d056f1d3a() {
    try {
        new DOMException('');
        return true;
    } catch  {
        return false;
    }
}
/**
 * Tells whether current environment supports History API
 * {@link supportsHistory}.
 *
 * @returns Answer to the given question.
 */ function $133087f5c0803d70$export$67fc34576016d6ec() {
    return 'history' in $133087f5c0803d70$var$WINDOW && !!$133087f5c0803d70$var$WINDOW.history;
}
/**
 * Tells whether current environment supports Fetch API
 * {@link supportsFetch}.
 *
 * @returns Answer to the given question.
 * @deprecated This is no longer used and will be removed in a future major version.
 */ const $133087f5c0803d70$export$edf3cb81fd7d2a3e = $133087f5c0803d70$var$_isFetchSupported;
function $133087f5c0803d70$var$_isFetchSupported() {
    if (!('fetch' in $133087f5c0803d70$var$WINDOW)) return false;
    try {
        new Headers();
        // Deno requires a valid URL so '' cannot be used as an argument
        new Request('data:,');
        new Response();
        return true;
    } catch  {
        return false;
    }
}
/**
 * isNative checks if the given function is a native implementation
 */ // eslint-disable-next-line @typescript-eslint/ban-types
function $133087f5c0803d70$export$d5f608b368e73f38(func) {
    return func && /^function\s+\w+\(\)\s+\{\s+\[native code\]\s+\}$/.test(func.toString());
}
/**
 * Tells whether current environment supports Fetch API natively
 * {@link supportsNativeFetch}.
 *
 * @returns true if `window.fetch` is natively implemented, false otherwise
 */ function $133087f5c0803d70$export$c82d238e23c40b21() {
    if (typeof EdgeRuntime === 'string') return true;
    if (!$133087f5c0803d70$var$_isFetchSupported()) return false;
    // Fast path to avoid DOM I/O
    // eslint-disable-next-line @typescript-eslint/unbound-method
    if ($133087f5c0803d70$export$d5f608b368e73f38($133087f5c0803d70$var$WINDOW.fetch)) return true;
    // window.fetch is implemented, but is polyfilled or already wrapped (e.g: by a chrome extension)
    // so create a "pure" iframe to see if that has native fetch
    let result = false;
    const doc = $133087f5c0803d70$var$WINDOW.document;
    // eslint-disable-next-line deprecation/deprecation
    if (doc && typeof doc.createElement === 'function') try {
        const sandbox = doc.createElement('iframe');
        sandbox.hidden = true;
        doc.head.appendChild(sandbox);
        if (sandbox.contentWindow?.fetch) // eslint-disable-next-line @typescript-eslint/unbound-method
        result = $133087f5c0803d70$export$d5f608b368e73f38(sandbox.contentWindow.fetch);
        doc.head.removeChild(sandbox);
    } catch (err) {
        (0, $19fdbaf7f0830971$export$16a28057038b10ef) && (0, $d11ed0b3cdda6b8d$export$1c9f709888824e05).warn('Could not create sandbox iframe for pure fetch check, bailing to window.fetch: ', err);
    }
    return result;
}
/**
 * Tells whether current environment supports ReportingObserver API
 * {@link supportsReportingObserver}.
 *
 * @returns Answer to the given question.
 */ function $133087f5c0803d70$export$531055a6c684a70a() {
    return 'ReportingObserver' in $133087f5c0803d70$var$WINDOW;
}
/**
 * Tells whether current environment supports Referrer Policy API
 * {@link supportsReferrerPolicy}.
 *
 * @returns Answer to the given question.
 * @deprecated This is no longer used and will be removed in a future major version.
 */ function $133087f5c0803d70$export$2d308b428295192f() {
    // Despite all stars in the sky saying that Edge supports old draft syntax, aka 'never', 'always', 'origin' and 'default'
    // (see https://caniuse.com/#feat=referrer-policy),
    // it doesn't. And it throws an exception instead of ignoring this parameter...
    // REF: https://github.com/getsentry/raven-js/issues/1233
    if (!$133087f5c0803d70$var$_isFetchSupported()) return false;
    try {
        new Request('_', {
            referrerPolicy: 'origin'
        });
        return true;
    } catch  {
        return false;
    }
}


/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $52f4069f580f537e$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__;



const $a279eed6bc86f03b$export$56d8a8a25bd48b81 = (0, $736a69486c86d36c$export$f1a6cdb1459e81d1);


/**
 * We generally want to use window.fetch / window.setTimeout.
 * However, in some cases this may be wrapped (e.g. by Zone.js for Angular),
 * so we try to get an unpatched version of this from a sandboxed iframe.
 */ const $a11db510f5040b04$var$cachedImplementations = {};
/**
 * Get the native implementation of a browser function.
 *
 * This can be used to ensure we get an unwrapped version of a function, in cases where a wrapped function can lead to problems.
 *
 * The following methods can be retrieved:
 * - `setTimeout`: This can be wrapped by e.g. Angular, causing change detection to be triggered.
 * - `fetch`: This can be wrapped by e.g. ad-blockers, causing an infinite loop when a request is blocked.
 */ function $a11db510f5040b04$export$e464f4a514ac28a8(name) {
    const cached = $a11db510f5040b04$var$cachedImplementations[name];
    if (cached) return cached;
    let impl = (0, $a279eed6bc86f03b$export$56d8a8a25bd48b81)[name];
    // Fast path to avoid DOM I/O
    if ((0, $133087f5c0803d70$export$d5f608b368e73f38)(impl)) return $a11db510f5040b04$var$cachedImplementations[name] = impl.bind((0, $a279eed6bc86f03b$export$56d8a8a25bd48b81));
    const document = (0, $a279eed6bc86f03b$export$56d8a8a25bd48b81).document;
    // eslint-disable-next-line deprecation/deprecation
    if (document && typeof document.createElement === 'function') try {
        const sandbox = document.createElement('iframe');
        sandbox.hidden = true;
        document.head.appendChild(sandbox);
        const contentWindow = sandbox.contentWindow;
        if (contentWindow?.[name]) impl = contentWindow[name];
        document.head.removeChild(sandbox);
    } catch (e) {
        // Could not create sandbox iframe, just use window.xxx
        (0, $52f4069f580f537e$export$16a28057038b10ef) && (0, $d11ed0b3cdda6b8d$export$1c9f709888824e05).warn(`Could not create sandbox iframe for ${name} check, bailing to window.${name}: `, e);
    }
    // Sanity check: This _should_ not happen, but if it does, we just skip caching...
    // This can happen e.g. in tests where fetch may not be available in the env, or similar.
    if (!impl) return impl;
    return $a11db510f5040b04$var$cachedImplementations[name] = impl.bind((0, $a279eed6bc86f03b$export$56d8a8a25bd48b81));
}
/** Clear a cached implementation. */ function $a11db510f5040b04$export$8aa36702e8c8978(name) {
    $a11db510f5040b04$var$cachedImplementations[name] = undefined;
}
/**
 * A special usecase for incorrectly wrapped Fetch APIs in conjunction with ad-blockers.
 * Whenever someone wraps the Fetch API and returns the wrong promise chain,
 * this chain becomes orphaned and there is no possible way to capture it's rejections
 * other than allowing it bubble up to this very handler. eg.
 *
 * const f = window.fetch;
 * window.fetch = function () {
 *   const p = f.apply(this, arguments);
 *
 *   p.then(function() {
 *     console.log('hi.');
 *   });
 *
 *   return p;
 * }
 *
 * `p.then(function () { ... })` is producing a completely separate promise chain,
 * however, what's returned is `p` - the result of original `fetch` call.
 *
 * This mean, that whenever we use the Fetch API to send our own requests, _and_
 * some ad-blocker blocks it, this orphaned chain will _always_ reject,
 * effectively causing another event to be captured.
 * This makes a whole process become an infinite loop, which we need to somehow
 * deal with, and break it in one way or another.
 *
 * To deal with this issue, we are making sure that we _always_ use the real
 * browser Fetch API, instead of relying on what `window.fetch` exposes.
 * The only downside to this would be missing our own requests as breadcrumbs,
 * but because we are already not doing this, it should be just fine.
 *
 * Possible failed fetch error messages per-browser:
 *
 * Chrome:  Failed to fetch
 * Edge:    Failed to Fetch
 * Firefox: NetworkError when attempting to fetch resource
 * Safari:  resource blocked by content blocker
 */ function $a11db510f5040b04$export$e7aa7bc5c1b3cfb3(...rest) {
    return $a11db510f5040b04$export$e464f4a514ac28a8('fetch')(...rest);
}
/**
 * Get an unwrapped `setTimeout` method.
 * This ensures that even if e.g. Angular wraps `setTimeout`, we get the native implementation,
 * avoiding triggering change detection.
 */ function $a11db510f5040b04$export$831dc9f2ab0a617b(...rest) {
    return $a11db510f5040b04$export$e464f4a514ac28a8('setTimeout')(...rest);
}


const $366021d20f9daad3$var$DEFAULT_BROWSER_TRANSPORT_BUFFER_SIZE = 40;
/**
 * Creates a Transport that uses the Fetch API to send events to Sentry.
 */ function $366021d20f9daad3$export$b2311068c46d7cc8(options, nativeFetch = (0, $a11db510f5040b04$export$e464f4a514ac28a8)('fetch')) {
    let pendingBodySize = 0;
    let pendingCount = 0;
    async function makeRequest(request) {
        const requestSize = request.body.length;
        pendingBodySize += requestSize;
        pendingCount++;
        const requestOptions = {
            body: request.body,
            method: 'POST',
            referrerPolicy: 'strict-origin',
            headers: options.headers,
            // Outgoing requests are usually cancelled when navigating to a different page, causing a "TypeError: Failed to
            // fetch" error and sending a "network_error" client-outcome - in Chrome, the request status shows "(cancelled)".
            // The `keepalive` flag keeps outgoing requests alive, even when switching pages. We want this since we're
            // frequently sending events right before the user is switching pages (eg. when finishing navigation transactions).
            // Gotchas:
            // - `keepalive` isn't supported by Firefox
            // - As per spec (https://fetch.spec.whatwg.org/#http-network-or-cache-fetch):
            //   If the sum of contentLength and inflightKeepaliveBytes is greater than 64 kibibytes, then return a network error.
            //   We will therefore only activate the flag when we're below that limit.
            // There is also a limit of requests that can be open at the same time, so we also limit this to 15
            // See https://github.com/getsentry/sentry-javascript/pull/7553 for details
            keepalive: pendingBodySize <= 60000 && pendingCount < 15,
            ...options.fetchOptions
        };
        try {
            // Note: We do not need to suppress tracing here, because we are using the native fetch, instead of our wrapped one.
            const response = await nativeFetch(options.url, requestOptions);
            return {
                statusCode: response.status,
                headers: {
                    'x-sentry-rate-limits': response.headers.get('X-Sentry-Rate-Limits'),
                    'retry-after': response.headers.get('Retry-After')
                }
            };
        } catch (e) {
            (0, $a11db510f5040b04$export$8aa36702e8c8978)('fetch');
            throw e;
        } finally{
            pendingBodySize -= requestSize;
            pendingCount--;
        }
    }
    return (0, $46ddc25216d7985b$export$d09f50d9ab7f7b69)(options, makeRequest, (0, $1407141ba4ddb36d$export$85a4f67f852183e6)(options.bufferSize || $366021d20f9daad3$var$DEFAULT_BROWSER_TRANSPORT_BUFFER_SIZE));
}



/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $6e9d48dbcf18d05a$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__;


/**
 * Starts the Sentry UI profiler.
 * This mode is exclusive with the transaction profiler and will only work if the profilesSampleRate is set to a falsy value.
 * In UI profiling mode, the profiler will keep reporting profile chunks to Sentry until it is stopped, which allows for continuous profiling of the application.
 */ function $61e522e7948b3efb$var$startProfiler() {
    const client = (0, $7d48e1ed9f699a01$export$6bb76d6eba7e258c)();
    if (!client) {
        (0, $6e9d48dbcf18d05a$export$16a28057038b10ef) && (0, $d11ed0b3cdda6b8d$export$1c9f709888824e05).warn('No Sentry client available, profiling is not started');
        return;
    }
    const integration = client.getIntegrationByName('BrowserProfiling');
    if (!integration) {
        (0, $6e9d48dbcf18d05a$export$16a28057038b10ef) && (0, $d11ed0b3cdda6b8d$export$1c9f709888824e05).warn('BrowserProfiling integration is not available');
        return;
    }
    client.emit('startUIProfiler');
}
/**
 * Stops the Sentry UI profiler.
 * Calls to stop will stop the profiler and flush the currently collected profile data to Sentry.
 */ function $61e522e7948b3efb$var$stopProfiler() {
    const client = (0, $7d48e1ed9f699a01$export$6bb76d6eba7e258c)();
    if (!client) {
        (0, $6e9d48dbcf18d05a$export$16a28057038b10ef) && (0, $d11ed0b3cdda6b8d$export$1c9f709888824e05).warn('No Sentry client available, profiling is not started');
        return;
    }
    const integration = client.getIntegrationByName('BrowserProfiling');
    if (!integration) {
        (0, $6e9d48dbcf18d05a$export$16a28057038b10ef) && (0, $d11ed0b3cdda6b8d$export$1c9f709888824e05).warn('ProfilingIntegration is not available');
        return;
    }
    client.emit('stopUIProfiler');
}
/**
 * Profiler namespace for controlling the JS profiler in 'manual' mode.
 *
 * Requires the `browserProfilingIntegration` from the `@sentry/browser` package.
 */ const $61e522e7948b3efb$export$c7cf24e2253024f3 = {
    startProfiler: $61e522e7948b3efb$var$startProfiler,
    stopProfiler: $61e522e7948b3efb$var$stopProfiler
};



const $5c2a6884ada474e9$var$OPERA10_PRIORITY = 10;
const $5c2a6884ada474e9$var$OPERA11_PRIORITY = 20;
const $5c2a6884ada474e9$var$CHROME_PRIORITY = 30;
const $5c2a6884ada474e9$var$WINJS_PRIORITY = 40;
const $5c2a6884ada474e9$var$GECKO_PRIORITY = 50;
function $5c2a6884ada474e9$var$createFrame(filename, func, lineno, colno) {
    const frame = {
        filename: filename,
        function: func === '<anonymous>' ? (0, $9ed2cf4edd0b2db9$export$27c7e15d453fc0ac) : func,
        in_app: true
    };
    if (lineno !== undefined) frame.lineno = lineno;
    if (colno !== undefined) frame.colno = colno;
    return frame;
}
// This regex matches frames that have no function name (ie. are at the top level of a module).
// For example "at http://localhost:5000//script.js:1:126"
// Frames _with_ function names usually look as follows: "at commitLayoutEffects (react-dom.development.js:23426:1)"
const $5c2a6884ada474e9$var$chromeRegexNoFnName = /^\s*at (\S+?)(?::(\d+))(?::(\d+))\s*$/i;
// This regex matches all the frames that have a function name.
const $5c2a6884ada474e9$var$chromeRegex = /^\s*at (?:(.+?\)(?: \[.+\])?|.*?) ?\((?:address at )?)?(?:async )?((?:<anonymous>|[-a-z]+:|.*bundle|\/)?.*?)(?::(\d+))?(?::(\d+))?\)?\s*$/i;
const $5c2a6884ada474e9$var$chromeEvalRegex = /\((\S*)(?::(\d+))(?::(\d+))\)/;
// Matches stack frames with data URIs instead of filename so we can still get the function name
// Example: "at dynamicFn (data:application/javascript,export function dynamicFn() {..."
const $5c2a6884ada474e9$var$chromeDataUriRegex = /at (.+?) ?\(data:(.+?),/;
// Chromium based browsers: Chrome, Brave, new Opera, new Edge
// We cannot call this variable `chrome` because it can conflict with global `chrome` variable in certain environments
// See: https://github.com/getsentry/sentry-javascript/issues/6880
const $5c2a6884ada474e9$var$chromeStackParserFn = (line)=>{
    const dataUriMatch = line.match($5c2a6884ada474e9$var$chromeDataUriRegex);
    if (dataUriMatch) return {
        filename: `<data:${dataUriMatch[2]}>`,
        function: dataUriMatch[1]
    };
    // If the stack line has no function name, we need to parse it differently
    const noFnParts = $5c2a6884ada474e9$var$chromeRegexNoFnName.exec(line);
    if (noFnParts) {
        const [, filename, line, col] = noFnParts;
        return $5c2a6884ada474e9$var$createFrame(filename, (0, $9ed2cf4edd0b2db9$export$27c7e15d453fc0ac), +line, +col);
    }
    const parts = $5c2a6884ada474e9$var$chromeRegex.exec(line);
    if (parts) {
        const isEval = parts[2]?.indexOf('eval') === 0; // start of line
        if (isEval) {
            const subMatch = $5c2a6884ada474e9$var$chromeEvalRegex.exec(parts[2]);
            if (subMatch) {
                // throw out eval line/column and use top-most line/column number
                parts[2] = subMatch[1]; // url
                parts[3] = subMatch[2]; // line
                parts[4] = subMatch[3]; // column
            }
        }
        // Kamil: One more hack won't hurt us right? Understanding and adding more rules on top of these regexps right now
        // would be way too time consuming. (TODO: Rewrite whole RegExp to be more readable)
        const [func, filename] = $5c2a6884ada474e9$var$extractSafariExtensionDetails(parts[1] || (0, $9ed2cf4edd0b2db9$export$27c7e15d453fc0ac), parts[2]);
        return $5c2a6884ada474e9$var$createFrame(filename, func, parts[3] ? +parts[3] : undefined, parts[4] ? +parts[4] : undefined);
    }
    return;
};
const $5c2a6884ada474e9$export$263a749fff749872 = [
    $5c2a6884ada474e9$var$CHROME_PRIORITY,
    $5c2a6884ada474e9$var$chromeStackParserFn
];
// gecko regex: `(?:bundle|\d+\.js)`: `bundle` is for react native, `\d+\.js` also but specifically for ram bundles because it
// generates filenames without a prefix like `file://` the filenames in the stacktrace are just 42.js
// We need this specific case for now because we want no other regex to match.
const $5c2a6884ada474e9$var$geckoREgex = /^\s*(.*?)(?:\((.*?)\))?(?:^|@)?((?:[-a-z]+)?:\/.*?|\[native code\]|[^@]*(?:bundle|\d+\.js)|\/[\w\-. /=]+)(?::(\d+))?(?::(\d+))?\s*$/i;
const $5c2a6884ada474e9$var$geckoEvalRegex = /(\S+) line (\d+)(?: > eval line \d+)* > eval/i;
const $5c2a6884ada474e9$var$gecko = (line)=>{
    const parts = $5c2a6884ada474e9$var$geckoREgex.exec(line);
    if (parts) {
        const isEval = parts[3] && parts[3].indexOf(' > eval') > -1;
        if (isEval) {
            const subMatch = $5c2a6884ada474e9$var$geckoEvalRegex.exec(parts[3]);
            if (subMatch) {
                // throw out eval line/column and use top-most line number
                parts[1] = parts[1] || 'eval';
                parts[3] = subMatch[1];
                parts[4] = subMatch[2];
                parts[5] = ''; // no column when eval
            }
        }
        let filename = parts[3];
        let func = parts[1] || (0, $9ed2cf4edd0b2db9$export$27c7e15d453fc0ac);
        [func, filename] = $5c2a6884ada474e9$var$extractSafariExtensionDetails(func, filename);
        return $5c2a6884ada474e9$var$createFrame(filename, func, parts[4] ? +parts[4] : undefined, parts[5] ? +parts[5] : undefined);
    }
    return;
};
const $5c2a6884ada474e9$export$cdba47a5dd2804d = [
    $5c2a6884ada474e9$var$GECKO_PRIORITY,
    $5c2a6884ada474e9$var$gecko
];
const $5c2a6884ada474e9$var$winjsRegex = /^\s*at (?:((?:\[object object\])?.+) )?\(?((?:[-a-z]+):.*?):(\d+)(?::(\d+))?\)?\s*$/i;
const $5c2a6884ada474e9$var$winjs = (line)=>{
    const parts = $5c2a6884ada474e9$var$winjsRegex.exec(line);
    return parts ? $5c2a6884ada474e9$var$createFrame(parts[2], parts[1] || (0, $9ed2cf4edd0b2db9$export$27c7e15d453fc0ac), +parts[3], parts[4] ? +parts[4] : undefined) : undefined;
};
const $5c2a6884ada474e9$export$179460296da408e8 = [
    $5c2a6884ada474e9$var$WINJS_PRIORITY,
    $5c2a6884ada474e9$var$winjs
];
const $5c2a6884ada474e9$var$opera10Regex = / line (\d+).*script (?:in )?(\S+)(?:: in function (\S+))?$/i;
const $5c2a6884ada474e9$var$opera10 = (line)=>{
    const parts = $5c2a6884ada474e9$var$opera10Regex.exec(line);
    return parts ? $5c2a6884ada474e9$var$createFrame(parts[2], parts[3] || (0, $9ed2cf4edd0b2db9$export$27c7e15d453fc0ac), +parts[1]) : undefined;
};
const $5c2a6884ada474e9$export$f892b52c880ffc7a = [
    $5c2a6884ada474e9$var$OPERA10_PRIORITY,
    $5c2a6884ada474e9$var$opera10
];
const $5c2a6884ada474e9$var$opera11Regex = / line (\d+), column (\d+)\s*(?:in (?:<anonymous function: ([^>]+)>|([^)]+))\(.*\))? in (.*):\s*$/i;
const $5c2a6884ada474e9$var$opera11 = (line)=>{
    const parts = $5c2a6884ada474e9$var$opera11Regex.exec(line);
    return parts ? $5c2a6884ada474e9$var$createFrame(parts[5], parts[3] || parts[4] || (0, $9ed2cf4edd0b2db9$export$27c7e15d453fc0ac), +parts[1], +parts[2]) : undefined;
};
const $5c2a6884ada474e9$export$af11af13f09fb0dc = [
    $5c2a6884ada474e9$var$OPERA11_PRIORITY,
    $5c2a6884ada474e9$var$opera11
];
const $5c2a6884ada474e9$export$7197c0fe6554c079 = [
    $5c2a6884ada474e9$export$263a749fff749872,
    $5c2a6884ada474e9$export$cdba47a5dd2804d
];
const $5c2a6884ada474e9$export$2b2b997d81bf3907 = (0, $9ed2cf4edd0b2db9$export$a5739666fb2d03d4)(...$5c2a6884ada474e9$export$7197c0fe6554c079);
/**
 * Safari web extensions, starting version unknown, can produce "frames-only" stacktraces.
 * What it means, is that instead of format like:
 *
 * Error: wat
 *   at function@url:row:col
 *   at function@url:row:col
 *   at function@url:row:col
 *
 * it produces something like:
 *
 *   function@url:row:col
 *   function@url:row:col
 *   function@url:row:col
 *
 * Because of that, it won't be captured by `chrome` RegExp and will fall into `Gecko` branch.
 * This function is extracted so that we can use it in both places without duplicating the logic.
 * Unfortunately "just" changing RegExp is too complicated now and making it pass all tests
 * and fix this case seems like an impossible, or at least way too time-consuming task.
 */ const $5c2a6884ada474e9$var$extractSafariExtensionDetails = (func, filename)=>{
    const isSafariExtension = func.indexOf('safari-extension') !== -1;
    const isSafariWebExtension = func.indexOf('safari-web-extension') !== -1;
    return isSafariExtension || isSafariWebExtension ? [
        func.indexOf('@') !== -1 ? func.split('@')[0] : (0, $9ed2cf4edd0b2db9$export$27c7e15d453fc0ac),
        isSafariExtension ? `safari-extension:${filename}` : `safari-web-extension:${filename}`
    ] : [
        func,
        filename
    ];
};




/**
 * Creates an envelope from a user feedback.
 */ function $b80b1f8b91224d00$export$24a4dfcb686ee5bf(feedback, { metadata: metadata, tunnel: tunnel, dsn: dsn }) {
    const headers = {
        event_id: feedback.event_id,
        sent_at: new Date().toISOString(),
        ...metadata?.sdk && {
            sdk: {
                name: metadata.sdk.name,
                version: metadata.sdk.version
            }
        },
        ...!!tunnel && !!dsn && {
            dsn: (0, $1e1399eeae328b26$export$44d472fbb931a776)(dsn)
        }
    };
    const item = $b80b1f8b91224d00$var$createUserFeedbackEnvelopeItem(feedback);
    return (0, $bb063ad93c8b79c7$export$f93f7f385160c44e)(headers, [
        item
    ]);
}
function $b80b1f8b91224d00$var$createUserFeedbackEnvelopeItem(feedback) {
    const feedbackHeaders = {
        type: 'user_report'
    };
    return [
        feedbackHeaders,
        feedback
    ];
}





const $de0065ae4a0cfe96$var$INTEGRATION_NAME = 'ConversationId';
const $de0065ae4a0cfe96$var$_conversationIdIntegration = ()=>{
    return {
        name: $de0065ae4a0cfe96$var$INTEGRATION_NAME,
        setup (client) {
            client.on('spanStart', (span)=>{
                const scopeData = (0, $7d48e1ed9f699a01$export$c7be4b0125a10cba)().getScopeData();
                const isolationScopeData = (0, $7d48e1ed9f699a01$export$68f3af03034c9e90)().getScopeData();
                const conversationId = scopeData.conversationId || isolationScopeData.conversationId;
                if (conversationId) span.setAttribute((0, $f337c80285f06f80$export$71a4a707257f2774), conversationId);
            });
        }
    };
};
/**
 * Automatically applies conversation ID from scope to spans.
 *
 * This integration reads the conversation ID from the current or isolation scope
 * and applies it to spans when they start. This ensures the conversation ID is
 * available for all AI-related operations.
 */ const $de0065ae4a0cfe96$export$97457a453081a5b3 = (0, $cbb2da6c78246e45$export$2323046b9414659f)($de0065ae4a0cfe96$var$_conversationIdIntegration);










/* eslint-disable @typescript-eslint/no-explicit-any */ /**
 * Add an instrumentation handler for when a fetch request happens.
 * The handler function is called once when the request starts and once when it ends,
 * which can be identified by checking if it has an `endTimestamp`.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $d5ff33466750b470$export$f75d3c772c923df0(handler, skipNativeFetchCheck) {
    const type = 'fetch';
    (0, $7b0ad3366f177c67$export$a4e09611e30da72e)(type, handler);
    (0, $7b0ad3366f177c67$export$e18d6c5462c01368)(type, ()=>$d5ff33466750b470$var$instrumentFetch(undefined, skipNativeFetchCheck));
}
/**
 * Add an instrumentation handler for long-lived fetch requests, like consuming server-sent events (SSE) via fetch.
 * The handler will resolve the request body and emit the actual `endTimestamp`, so that the
 * span can be updated accordingly.
 *
 * Only used internally
 * @hidden
 */ function $d5ff33466750b470$export$1a79663eb318fe6a(handler) {
    const type = 'fetch-body-resolved';
    (0, $7b0ad3366f177c67$export$a4e09611e30da72e)(type, handler);
    (0, $7b0ad3366f177c67$export$e18d6c5462c01368)(type, ()=>$d5ff33466750b470$var$instrumentFetch($d5ff33466750b470$var$streamHandler));
}
function $d5ff33466750b470$var$instrumentFetch(onFetchResolved, skipNativeFetchCheck = false) {
    if (skipNativeFetchCheck && !(0, $133087f5c0803d70$export$c82d238e23c40b21)()) return;
    (0, $269eeb69635ed414$export$9563e054e6f787fb)((0, $736a69486c86d36c$export$f1a6cdb1459e81d1), 'fetch', function(originalFetch) {
        return function(...args) {
            // We capture the error right here and not in the Promise error callback because Safari (and probably other
            // browsers too) will wipe the stack trace up to this point, only leaving us with this file which is useless.
            // NOTE: If you are a Sentry user, and you are seeing this stack frame,
            //       it means the error, that was caused by your fetch call did not
            //       have a stack trace, so the SDK backfilled the stack trace so
            //       you can see which fetch call failed.
            const virtualError = new Error();
            const { method: method, url: url } = $d5ff33466750b470$export$f7a71163cc309d9a(args);
            const handlerData = {
                args: args,
                fetchData: {
                    method: method,
                    url: url
                },
                startTimestamp: (0, $bc81602376c48fa6$export$ee52dced521e3e18)() * 1000,
                virtualError: // // Adding the error to be able to fingerprint the failed fetch event in HttpClient instrumentation
                virtualError,
                headers: $d5ff33466750b470$var$getHeadersFromFetchArgs(args)
            };
            // if there is no callback, fetch is instrumented directly
            if (!onFetchResolved) (0, $7b0ad3366f177c67$export$b18c893e424d3127)('fetch', {
                ...handlerData
            });
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            return originalFetch.apply((0, $736a69486c86d36c$export$f1a6cdb1459e81d1), args).then(async (response)=>{
                if (onFetchResolved) onFetchResolved(response);
                else (0, $7b0ad3366f177c67$export$b18c893e424d3127)('fetch', {
                    ...handlerData,
                    endTimestamp: (0, $bc81602376c48fa6$export$ee52dced521e3e18)() * 1000,
                    response: response
                });
                return response;
            }, (error)=>{
                (0, $7b0ad3366f177c67$export$b18c893e424d3127)('fetch', {
                    ...handlerData,
                    endTimestamp: (0, $bc81602376c48fa6$export$ee52dced521e3e18)() * 1000,
                    error: error
                });
                if ((0, $13cf2ed412f405fa$export$e6127cc7fe7395c3)(error) && error.stack === undefined) {
                    // NOTE: If you are a Sentry user, and you are seeing this stack frame,
                    //       it means the error, that was caused by your fetch call did not
                    //       have a stack trace, so the SDK backfilled the stack trace so
                    //       you can see which fetch call failed.
                    error.stack = virtualError.stack;
                    (0, $269eeb69635ed414$export$e73679ffaf56810e)(error, 'framesToPop', 1);
                }
                // We enhance fetch error messages with hostname information based on the configuration.
                // Possible messages we handle here:
                // * "Failed to fetch" (chromium)
                // * "Load failed" (webkit)
                // * "NetworkError when attempting to fetch resource." (firefox)
                const client = (0, $7d48e1ed9f699a01$export$6bb76d6eba7e258c)();
                const enhanceOption = client?.getOptions().enhanceFetchErrorMessages ?? 'always';
                const shouldEnhance = enhanceOption !== false;
                if (shouldEnhance && error instanceof TypeError && (error.message === 'Failed to fetch' || error.message === 'Load failed' || error.message === 'NetworkError when attempting to fetch resource.')) try {
                    const url = new URL(handlerData.fetchData.url);
                    const hostname = url.host;
                    if (enhanceOption === 'always') // Modify the error message directly
                    error.message = `${error.message} (${hostname})`;
                    else // Store hostname as non-enumerable property for Sentry-only enhancement
                    // This preserves the original error message for third-party packages
                    (0, $269eeb69635ed414$export$e73679ffaf56810e)(error, '__sentry_fetch_url_host__', hostname);
                } catch  {
                // ignore it if errors happen here
                }
                // NOTE: If you are a Sentry user, and you are seeing this stack frame,
                //       it means the sentry.javascript SDK caught an error invoking your application code.
                //       This is expected behavior and NOT indicative of a bug with sentry.javascript.
                throw error;
            });
        };
    });
}
async function $d5ff33466750b470$var$resolveResponse(res, onFinishedResolving) {
    if (res?.body) {
        const body = res.body;
        const responseReader = body.getReader();
        // Define a maximum duration after which we just cancel
        const maxFetchDurationTimeout = setTimeout(()=>{
            body.cancel().then(null, ()=>{
            // noop
            });
        }, 90000);
        let readingActive = true;
        while(readingActive){
            let chunkTimeout;
            try {
                // abort reading if read op takes more than 5s
                chunkTimeout = setTimeout(()=>{
                    body.cancel().then(null, ()=>{
                    // noop on error
                    });
                }, 5000);
                // This .read() call will reject/throw when we abort due to timeouts through `body.cancel()`
                const { done: done } = await responseReader.read();
                clearTimeout(chunkTimeout);
                if (done) {
                    onFinishedResolving();
                    readingActive = false;
                }
            } catch  {
                readingActive = false;
            } finally{
                clearTimeout(chunkTimeout);
            }
        }
        clearTimeout(maxFetchDurationTimeout);
        responseReader.releaseLock();
        body.cancel().then(null, ()=>{
        // noop on error
        });
    }
}
function $d5ff33466750b470$var$streamHandler(response) {
    // clone response for awaiting stream
    let clonedResponseForResolving;
    try {
        clonedResponseForResolving = response.clone();
    } catch  {
        return;
    }
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    $d5ff33466750b470$var$resolveResponse(clonedResponseForResolving, ()=>{
        (0, $7b0ad3366f177c67$export$b18c893e424d3127)('fetch-body-resolved', {
            endTimestamp: (0, $bc81602376c48fa6$export$ee52dced521e3e18)() * 1000,
            response: response
        });
    });
}
function $d5ff33466750b470$var$hasProp(obj, prop) {
    return !!obj && typeof obj === 'object' && !!obj[prop];
}
function $d5ff33466750b470$var$getUrlFromResource(resource) {
    if (typeof resource === 'string') return resource;
    if (!resource) return '';
    if ($d5ff33466750b470$var$hasProp(resource, 'url')) return resource.url;
    if (resource.toString) return resource.toString();
    return '';
}
/**
 * Parses the fetch arguments to find the used Http method and the url of the request.
 * Exported for tests only.
 */ function $d5ff33466750b470$export$f7a71163cc309d9a(fetchArgs) {
    if (fetchArgs.length === 0) return {
        method: 'GET',
        url: ''
    };
    if (fetchArgs.length === 2) {
        const [resource, options] = fetchArgs;
        return {
            url: $d5ff33466750b470$var$getUrlFromResource(resource),
            method: $d5ff33466750b470$var$hasProp(options, 'method') ? String(options.method).toUpperCase() : (0, $13cf2ed412f405fa$export$6d3d1f317d7cda57)(resource) && $d5ff33466750b470$var$hasProp(resource, 'method') ? String(resource.method).toUpperCase() : 'GET'
        };
    }
    const arg = fetchArgs[0];
    return {
        url: $d5ff33466750b470$var$getUrlFromResource(arg),
        method: $d5ff33466750b470$var$hasProp(arg, 'method') ? String(arg.method).toUpperCase() : 'GET'
    };
}
function $d5ff33466750b470$var$getHeadersFromFetchArgs(fetchArgs) {
    const [requestArgument, optionsArgument] = fetchArgs;
    try {
        if (typeof optionsArgument === 'object' && optionsArgument !== null && 'headers' in optionsArgument && optionsArgument.headers) return new Headers(optionsArgument.headers);
        if ((0, $13cf2ed412f405fa$export$6d3d1f317d7cda57)(requestArgument)) return new Headers(requestArgument.headers);
    } catch  {
    // noop
    }
    return;
}

/**
 * Determine a breadcrumb's log level (only `warning` or `error`) based on an HTTP status code.
 */ function $d3b8bcdfb9869d62$export$b8cfcc4175694bcc(statusCode) {
    // NOTE: undefined defaults to 'info' in Sentry
    if (statusCode === undefined) return undefined;
    else if (statusCode >= 400 && statusCode < 500) return 'warning';
    else if (statusCode >= 500) return 'error';
    else return undefined;
}


// Curious about `thismessage:/`? See: https://www.rfc-editor.org/rfc/rfc2557.html
//  > When the methods above do not yield an absolute URI, a base URL
//  > of "thismessage:/" MUST be employed. This base URL has been
//  > defined for the sole purpose of resolving relative references
//  > within a multipart/related structure when no other base URI is
//  > specified.
//
// We need to provide a base URL to `parseStringToURLObject` because the fetch API gives us a
// relative URL sometimes.
//
// This is the only case where we need to provide a base URL to `parseStringToURLObject`
// because the relative URL is not valid on its own.
const $0c1b93525a804899$var$DEFAULT_BASE_URL = 'thismessage:/';
/**
 * Checks if the URL object is relative
 *
 * @param url - The URL object to check
 * @returns True if the URL object is relative, false otherwise
 */ function $0c1b93525a804899$export$e258e13805402ba7(url) {
    return 'isRelative' in url;
}
/**
 * Parses string to a URL object
 *
 * @param url - The URL to parse
 * @returns The parsed URL object or undefined if the URL is invalid
 */ function $0c1b93525a804899$export$2004d912a9ead694(url, urlBase) {
    const isRelative = url.indexOf('://') <= 0 && url.indexOf('//') !== 0;
    const base = urlBase ?? (isRelative ? $0c1b93525a804899$var$DEFAULT_BASE_URL : undefined);
    try {
        // Use `canParse` to short-circuit the URL constructor if it's not a valid URL
        // This is faster than trying to construct the URL and catching the error
        // Node 20+, Chrome 120+, Firefox 115+, Safari 17+
        if ('canParse' in URL && !URL.canParse(url, base)) return undefined;
        const fullUrlObject = new URL(url, base);
        if (isRelative) // Because we used a fake base URL, we need to return a relative URL object.
        // We cannot return anything about the origin, host, etc. because it will refer to the fake base URL.
        return {
            isRelative: isRelative,
            pathname: fullUrlObject.pathname,
            search: fullUrlObject.search,
            hash: fullUrlObject.hash
        };
        return fullUrlObject;
    } catch  {
    // empty body
    }
    return undefined;
}
/**
 * Takes a URL object and returns a sanitized string which is safe to use as span name
 * see: https://develop.sentry.dev/sdk/data-handling/#structuring-data
 */ function $0c1b93525a804899$export$5339fcdc8e2a427c(url) {
    if ($0c1b93525a804899$export$e258e13805402ba7(url)) return url.pathname;
    const newUrl = new URL(url);
    newUrl.search = '';
    newUrl.hash = '';
    if ([
        '80',
        '443'
    ].includes(newUrl.port)) newUrl.port = '';
    if (newUrl.password) newUrl.password = '%filtered%';
    if (newUrl.username) newUrl.username = '%filtered%';
    return newUrl.toString();
}
function $0c1b93525a804899$var$getHttpSpanNameFromUrlObject(urlObject, kind, request, routeName) {
    const method = request?.method?.toUpperCase() ?? 'GET';
    const route = routeName ? routeName : urlObject ? kind === 'client' ? $0c1b93525a804899$export$5339fcdc8e2a427c(urlObject) : urlObject.pathname : '/';
    return `${method} ${route}`;
}
/**
 * Takes a parsed URL object and returns a set of attributes for the span
 * that represents the HTTP request for that url. This is used for both server
 * and client http spans.
 *
 * Follows https://opentelemetry.io/docs/specs/semconv/http/.
 *
 * @param urlObject - see {@link parseStringToURLObject}
 * @param kind - The type of HTTP operation (server or client)
 * @param spanOrigin - The origin of the span
 * @param request - The request object, see {@link PartialRequest}
 * @param routeName - The name of the route, must be low cardinality
 * @returns The span name and attributes for the HTTP operation
 */ function $0c1b93525a804899$export$c37a41544f3c180c(urlObject, kind, spanOrigin, request, routeName) {
    const attributes = {
        [(0, $f337c80285f06f80$export$cca8dd30f57f805e)]: spanOrigin,
        [(0, $f337c80285f06f80$export$d7a7d984b0791405)]: 'url'
    };
    if (routeName) {
        // This is based on https://opentelemetry.io/docs/specs/semconv/http/http-spans/#name
        attributes[kind === 'server' ? 'http.route' : 'url.template'] = routeName;
        attributes[0, $f337c80285f06f80$export$d7a7d984b0791405] = 'route';
    }
    if (request?.method) attributes[0, $f337c80285f06f80$export$be7a251980e7e946] = request.method.toUpperCase();
    if (urlObject) {
        if (urlObject.search) attributes['url.query'] = urlObject.search;
        if (urlObject.hash) attributes['url.fragment'] = urlObject.hash;
        if (urlObject.pathname) {
            attributes['url.path'] = urlObject.pathname;
            if (urlObject.pathname === '/') attributes[0, $f337c80285f06f80$export$d7a7d984b0791405] = 'route';
        }
        if (!$0c1b93525a804899$export$e258e13805402ba7(urlObject)) {
            attributes[0, $f337c80285f06f80$export$25dfd73e0e32c6e1] = urlObject.href;
            if (urlObject.port) attributes['url.port'] = urlObject.port;
            if (urlObject.protocol) attributes['url.scheme'] = urlObject.protocol;
            if (urlObject.hostname) attributes[kind === 'server' ? 'server.address' : 'url.domain'] = urlObject.hostname;
        }
    }
    return [
        $0c1b93525a804899$var$getHttpSpanNameFromUrlObject(urlObject, kind, request, routeName),
        attributes
    ];
}
/**
 * Parses string form of URL into an object
 * // borrowed from https://tools.ietf.org/html/rfc3986#appendix-B
 * // intentionally using regex and not <a/> href parsing trick because React Native and other
 * // environments where DOM might not be available
 * @returns parsed URL object
 */ function $0c1b93525a804899$export$7a5253c0f62e0150(url) {
    if (!url) return {};
    const match = url.match(/^(([^:/?#]+):)?(\/\/([^/?#]*))?([^?#]*)(\?([^#]*))?(#(.*))?$/);
    if (!match) return {};
    // coerce to undefined values to empty string so we don't get 'undefined'
    const query = match[6] || '';
    const fragment = match[8] || '';
    return {
        host: match[4],
        path: match[5],
        protocol: match[2],
        search: query,
        hash: fragment,
        relative: match[5] + query + fragment
    };
}
/**
 * Strip the query string and fragment off of a given URL or path (if present)
 *
 * @param urlPath Full URL or path, including possible query string and/or fragment
 * @returns URL or path without query string or fragment
 */ function $0c1b93525a804899$export$ce084c78234bd35(urlPath) {
    return urlPath.split(/[?#]/, 1)[0];
}
/**
 * Takes a URL object and returns a sanitized string which is safe to use as span name
 * see: https://develop.sentry.dev/sdk/data-handling/#structuring-data
 */ function $0c1b93525a804899$export$e0ba26c9e23e1fe0(url) {
    const { protocol: protocol, host: host, path: path } = url;
    const filteredHost = host?.replace(/^.*@/, '[filtered]:[filtered]@').replace(/(:80)$/, '').replace(/(:443)$/, '') || '';
    return `${protocol ? `${protocol}://` : ''}${filteredHost}${path}`;
}
/**
 * Strips the content from a data URL, returning a placeholder with the MIME type.
 *
 * Data URLs can be very long (e.g. base64 encoded scripts for Web Workers),
 * with little valuable information, often leading to envelopes getting dropped due
 * to size limit violations. Therefore, we strip data URLs and replace them with a
 * placeholder.
 *
 * @param url - The URL to process
 * @param includeDataPrefix - If true, includes the first 10 characters of the data stream
 *                            for debugging (e.g., to identify magic bytes like WASM's AGFzbQ).
 *                            Defaults to true.
 * @returns For data URLs, returns a short format like `data:text/javascript;base64,SGVsbG8gV2... [truncated]`.
 *          For non-data URLs, returns the original URL unchanged.
 */ function $0c1b93525a804899$export$8abd806fcaf234fa(url, includeDataPrefix = true) {
    if (url.startsWith('data:')) {
        // Match the MIME type (everything after 'data:' until the first ';' or ',')
        const match = url.match(/^data:([^;,]+)/);
        const mimeType = match ? match[1] : 'text/plain';
        const isBase64 = url.includes(';base64,');
        // Find where the actual data starts (after the comma)
        const dataStart = url.indexOf(',');
        let dataPrefix = '';
        if (includeDataPrefix && dataStart !== -1) {
            const data = url.slice(dataStart + 1);
            // Include first 10 chars of data to help identify content (e.g., magic bytes)
            dataPrefix = data.length > 10 ? `${data.slice(0, 10)}... [truncated]` : data;
        }
        return `data:${mimeType}${isBase64 ? ',base64' : ''}${dataPrefix ? `,${dataPrefix}` : ''}`;
    }
    return url;
}




const $16987639200114e3$var$DEBOUNCE_DURATION = 1000;
let $16987639200114e3$var$debounceTimerID;
let $16987639200114e3$var$lastCapturedEventType;
let $16987639200114e3$var$lastCapturedEventTargetId;
/**
 * Add an instrumentation handler for when a click or a keypress happens.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $16987639200114e3$export$5aeffd3db2cf9df7(handler) {
    const type = 'dom';
    (0, $7b0ad3366f177c67$export$a4e09611e30da72e)(type, handler);
    (0, $7b0ad3366f177c67$export$e18d6c5462c01368)(type, $16987639200114e3$export$3014bbf0af0e1d4a);
}
/** Exported for tests only. */ function $16987639200114e3$export$3014bbf0af0e1d4a() {
    if (!(0, $a279eed6bc86f03b$export$56d8a8a25bd48b81).document) return;
    // Make it so that any click or keypress that is unhandled / bubbled up all the way to the document triggers our dom
    // handlers. (Normally we have only one, which captures a breadcrumb for each click or keypress.) Do this before
    // we instrument `addEventListener` so that we don't end up attaching this handler twice.
    const triggerDOMHandler = (0, $7b0ad3366f177c67$export$b18c893e424d3127).bind(null, 'dom');
    const globalDOMEventHandler = $16987639200114e3$var$makeDOMEventHandler(triggerDOMHandler, true);
    (0, $a279eed6bc86f03b$export$56d8a8a25bd48b81).document.addEventListener('click', globalDOMEventHandler, false);
    (0, $a279eed6bc86f03b$export$56d8a8a25bd48b81).document.addEventListener('keypress', globalDOMEventHandler, false);
    // After hooking into click and keypress events bubbled up to `document`, we also hook into user-handled
    // clicks & keypresses, by adding an event listener of our own to any element to which they add a listener. That
    // way, whenever one of their handlers is triggered, ours will be, too. (This is needed because their handler
    // could potentially prevent the event from bubbling up to our global listeners. This way, our handler are still
    // guaranteed to fire at least once.)
    [
        'EventTarget',
        'Node'
    ].forEach((target)=>{
        const globalObject = (0, $a279eed6bc86f03b$export$56d8a8a25bd48b81);
        const proto = globalObject[target]?.prototype;
        // eslint-disable-next-line no-prototype-builtins
        if (!proto?.hasOwnProperty?.('addEventListener')) return;
        (0, $269eeb69635ed414$export$9563e054e6f787fb)(proto, 'addEventListener', function(originalAddEventListener) {
            return function(type, listener, options) {
                if (type === 'click' || type == 'keypress') try {
                    const handlers = this.__sentry_instrumentation_handlers__ = this.__sentry_instrumentation_handlers__ || {};
                    const handlerForType = handlers[type] = handlers[type] || {
                        refCount: 0
                    };
                    if (!handlerForType.handler) {
                        const handler = $16987639200114e3$var$makeDOMEventHandler(triggerDOMHandler);
                        handlerForType.handler = handler;
                        originalAddEventListener.call(this, type, handler, options);
                    }
                    handlerForType.refCount++;
                } catch  {
                // Accessing dom properties is always fragile.
                // Also allows us to skip `addEventListeners` calls with no proper `this` context.
                }
                return originalAddEventListener.call(this, type, listener, options);
            };
        });
        (0, $269eeb69635ed414$export$9563e054e6f787fb)(proto, 'removeEventListener', function(originalRemoveEventListener) {
            return function(type, listener, options) {
                if (type === 'click' || type == 'keypress') try {
                    const handlers = this.__sentry_instrumentation_handlers__ || {};
                    const handlerForType = handlers[type];
                    if (handlerForType) {
                        handlerForType.refCount--;
                        // If there are no longer any custom handlers of the current type on this element, we can remove ours, too.
                        if (handlerForType.refCount <= 0) {
                            originalRemoveEventListener.call(this, type, handlerForType.handler, options);
                            handlerForType.handler = undefined;
                            delete handlers[type]; // eslint-disable-line @typescript-eslint/no-dynamic-delete
                        }
                        // If there are no longer any custom handlers of any type on this element, cleanup everything.
                        if (Object.keys(handlers).length === 0) delete this.__sentry_instrumentation_handlers__;
                    }
                } catch  {
                // Accessing dom properties is always fragile.
                // Also allows us to skip `addEventListeners` calls with no proper `this` context.
                }
                return originalRemoveEventListener.call(this, type, listener, options);
            };
        });
    });
}
/**
 * Check whether the event is similar to the last captured one. For example, two click events on the same button.
 */ function $16987639200114e3$var$isSimilarToLastCapturedEvent(event) {
    // If both events have different type, then user definitely performed two separate actions. e.g. click + keypress.
    if (event.type !== $16987639200114e3$var$lastCapturedEventType) return false;
    try {
        // If both events have the same type, it's still possible that actions were performed on different targets.
        // e.g. 2 clicks on different buttons.
        if (!event.target || event.target._sentryId !== $16987639200114e3$var$lastCapturedEventTargetId) return false;
    } catch  {
    // just accessing `target` property can throw an exception in some rare circumstances
    // see: https://github.com/getsentry/sentry-javascript/issues/838
    }
    // If both events have the same type _and_ same `target` (an element which triggered an event, _not necessarily_
    // to which an event listener was attached), we treat them as the same action, as we want to capture
    // only one breadcrumb. e.g. multiple clicks on the same button, or typing inside a user input box.
    return true;
}
/**
 * Decide whether an event should be captured.
 * @param event event to be captured
 */ function $16987639200114e3$var$shouldSkipDOMEvent(eventType, target) {
    // We are only interested in filtering `keypress` events for now.
    if (eventType !== 'keypress') return false;
    if (!target?.tagName) return true;
    // Only consider keypress events on actual input elements. This will disregard keypresses targeting body
    // e.g.tabbing through elements, hotkeys, etc.
    if (target.tagName === 'INPUT' || target.tagName === 'TEXTAREA' || target.isContentEditable) return false;
    return true;
}
/**
 * Wraps addEventListener to capture UI breadcrumbs
 */ function $16987639200114e3$var$makeDOMEventHandler(handler, globalListener = false) {
    return (event)=>{
        // It's possible this handler might trigger multiple times for the same
        // event (e.g. event propagation through node ancestors).
        // Ignore if we've already captured that event.
        if (!event || event['_sentryCaptured']) return;
        const target = $16987639200114e3$var$getEventTarget(event);
        // We always want to skip _some_ events.
        if ($16987639200114e3$var$shouldSkipDOMEvent(event.type, target)) return;
        // Mark event as "seen"
        (0, $269eeb69635ed414$export$e73679ffaf56810e)(event, '_sentryCaptured', true);
        if (target && !target._sentryId) // Add UUID to event target so we can identify if
        (0, $269eeb69635ed414$export$e73679ffaf56810e)(target, '_sentryId', (0, $cc262db35458e4b3$export$19f53698e68b2496)());
        const name = event.type === 'keypress' ? 'input' : event.type;
        // If there is no last captured event, it means that we can safely capture the new event and store it for future comparisons.
        // If there is a last captured event, see if the new event is different enough to treat it as a unique one.
        // If that's the case, emit the previous event and store locally the newly-captured DOM event.
        if (!$16987639200114e3$var$isSimilarToLastCapturedEvent(event)) {
            const handlerData = {
                event: event,
                name: name,
                global: globalListener
            };
            handler(handlerData);
            $16987639200114e3$var$lastCapturedEventType = event.type;
            $16987639200114e3$var$lastCapturedEventTargetId = target ? target._sentryId : undefined;
        }
        // Start a new debounce timer that will prevent us from capturing multiple events that should be grouped together.
        clearTimeout($16987639200114e3$var$debounceTimerID);
        $16987639200114e3$var$debounceTimerID = (0, $a279eed6bc86f03b$export$56d8a8a25bd48b81).setTimeout(()=>{
            $16987639200114e3$var$lastCapturedEventTargetId = undefined;
            $16987639200114e3$var$lastCapturedEventType = undefined;
        }, $16987639200114e3$var$DEBOUNCE_DURATION);
    };
}
function $16987639200114e3$var$getEventTarget(event) {
    try {
        return event.target;
    } catch  {
        // just accessing `target` property can throw an exception in some rare circumstances
        // see: https://github.com/getsentry/sentry-javascript/issues/838
        return null;
    }
}



let $56137aac5362694e$var$lastHref;
/**
 * Add an instrumentation handler for when a fetch request happens.
 * The handler function is called once when the request starts and once when it ends,
 * which can be identified by checking if it has an `endTimestamp`.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $56137aac5362694e$export$3f18c56c58114e75(handler) {
    const type = 'history';
    (0, $7b0ad3366f177c67$export$a4e09611e30da72e)(type, handler);
    (0, $7b0ad3366f177c67$export$e18d6c5462c01368)(type, $56137aac5362694e$export$d9b613a6254a184e);
}
/**
 * Exported just for testing
 */ function $56137aac5362694e$export$d9b613a6254a184e() {
    // The `popstate` event may also be triggered on `pushState`, but it may not always reliably be emitted by the browser
    // Which is why we also monkey-patch methods below, in addition to this
    (0, $a279eed6bc86f03b$export$56d8a8a25bd48b81).addEventListener('popstate', ()=>{
        const to = (0, $a279eed6bc86f03b$export$56d8a8a25bd48b81).location.href;
        // keep track of the current URL state, as we always receive only the updated state
        const from = $56137aac5362694e$var$lastHref;
        $56137aac5362694e$var$lastHref = to;
        if (from === to) return;
        const handlerData = {
            from: from,
            to: to
        };
        (0, $7b0ad3366f177c67$export$b18c893e424d3127)('history', handlerData);
    });
    // Just guard against this not being available, in weird environments
    if (!(0, $133087f5c0803d70$export$67fc34576016d6ec)()) return;
    function historyReplacementFunction(originalHistoryFunction) {
        return function(...args) {
            const url = args.length > 2 ? args[2] : undefined;
            if (url) {
                const from = $56137aac5362694e$var$lastHref;
                // Ensure the URL is absolute
                // this can be either a path, then it is relative to the current origin
                // or a full URL of the current origin - other origins are not allowed
                // See: https://developer.mozilla.org/en-US/docs/Web/API/History/pushState#url
                // coerce to string (this is what pushState does)
                const to = $56137aac5362694e$var$getAbsoluteUrl(String(url));
                // keep track of the current URL state, as we always receive only the updated state
                $56137aac5362694e$var$lastHref = to;
                if (from === to) return originalHistoryFunction.apply(this, args);
                const handlerData = {
                    from: from,
                    to: to
                };
                (0, $7b0ad3366f177c67$export$b18c893e424d3127)('history', handlerData);
            }
            return originalHistoryFunction.apply(this, args);
        };
    }
    (0, $269eeb69635ed414$export$9563e054e6f787fb)((0, $a279eed6bc86f03b$export$56d8a8a25bd48b81).history, 'pushState', historyReplacementFunction);
    (0, $269eeb69635ed414$export$9563e054e6f787fb)((0, $a279eed6bc86f03b$export$56d8a8a25bd48b81).history, 'replaceState', historyReplacementFunction);
}
function $56137aac5362694e$var$getAbsoluteUrl(urlOrPath) {
    try {
        const url = new URL(urlOrPath, (0, $a279eed6bc86f03b$export$56d8a8a25bd48b81).location.origin);
        return url.toString();
    } catch  {
        // fallback, just do nothing
        return urlOrPath;
    }
}



const $a83999f742846a08$export$55b6bb1e45c6cf59 = '__sentry_xhr_v3__';
/**
 * Add an instrumentation handler for when an XHR request happens.
 * The handler function is called once when the request starts and once when it ends,
 * which can be identified by checking if it has an `endTimestamp`.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $a83999f742846a08$export$26ace48dd54c9aea(handler) {
    const type = 'xhr';
    (0, $7b0ad3366f177c67$export$a4e09611e30da72e)(type, handler);
    (0, $7b0ad3366f177c67$export$e18d6c5462c01368)(type, $a83999f742846a08$export$c67d533bf77cbf54);
}
/** Exported only for tests. */ function $a83999f742846a08$export$c67d533bf77cbf54() {
    if (!(0, $a279eed6bc86f03b$export$56d8a8a25bd48b81).XMLHttpRequest) return;
    const xhrproto = XMLHttpRequest.prototype;
    // eslint-disable-next-line @typescript-eslint/unbound-method
    xhrproto.open = new Proxy(xhrproto.open, {
        apply (originalOpen, xhrOpenThisArg, xhrOpenArgArray) {
            // NOTE: If you are a Sentry user, and you are seeing this stack frame,
            //       it means the error, that was caused by your XHR call did not
            //       have a stack trace. If you are using HttpClient integration,
            //       this is the expected behavior, as we are using this virtual error to capture
            //       the location of your XHR call, and group your HttpClient events accordingly.
            const virtualError = new Error();
            const startTimestamp = (0, $bc81602376c48fa6$export$ee52dced521e3e18)() * 1000;
            // open() should always be called with two or more arguments
            // But to be on the safe side, we actually validate this and bail out if we don't have a method & url
            const method = (0, $13cf2ed412f405fa$export$844ec244b1367d54)(xhrOpenArgArray[0]) ? xhrOpenArgArray[0].toUpperCase() : undefined;
            const url = $a83999f742846a08$var$parseXhrUrlArg(xhrOpenArgArray[1]);
            if (!method || !url) return originalOpen.apply(xhrOpenThisArg, xhrOpenArgArray);
            xhrOpenThisArg[$a83999f742846a08$export$55b6bb1e45c6cf59] = {
                method: method,
                url: url,
                request_headers: {}
            };
            // if Sentry key appears in URL, don't capture it as a request
            if (method === 'POST' && url.match(/sentry_key/)) xhrOpenThisArg.__sentry_own_request__ = true;
            const onreadystatechangeHandler = ()=>{
                // For whatever reason, this is not the same instance here as from the outer method
                const xhrInfo = xhrOpenThisArg[$a83999f742846a08$export$55b6bb1e45c6cf59];
                if (!xhrInfo) return;
                if (xhrOpenThisArg.readyState === 4) {
                    try {
                        // touching statusCode in some platforms throws
                        // an exception
                        xhrInfo.status_code = xhrOpenThisArg.status;
                    } catch  {
                    /* do nothing */ }
                    const handlerData = {
                        endTimestamp: (0, $bc81602376c48fa6$export$ee52dced521e3e18)() * 1000,
                        startTimestamp: startTimestamp,
                        xhr: xhrOpenThisArg,
                        virtualError: virtualError
                    };
                    (0, $7b0ad3366f177c67$export$b18c893e424d3127)('xhr', handlerData);
                }
            };
            if ('onreadystatechange' in xhrOpenThisArg && typeof xhrOpenThisArg.onreadystatechange === 'function') xhrOpenThisArg.onreadystatechange = new Proxy(xhrOpenThisArg.onreadystatechange, {
                apply (originalOnreadystatechange, onreadystatechangeThisArg, onreadystatechangeArgArray) {
                    onreadystatechangeHandler();
                    return originalOnreadystatechange.apply(onreadystatechangeThisArg, onreadystatechangeArgArray);
                }
            });
            else xhrOpenThisArg.addEventListener('readystatechange', onreadystatechangeHandler);
            // Intercepting `setRequestHeader` to access the request headers of XHR instance.
            // This will only work for user/library defined headers, not for the default/browser-assigned headers.
            // Request cookies are also unavailable for XHR, as `Cookie` header can't be defined by `setRequestHeader`.
            xhrOpenThisArg.setRequestHeader = new Proxy(xhrOpenThisArg.setRequestHeader, {
                apply (originalSetRequestHeader, setRequestHeaderThisArg, setRequestHeaderArgArray) {
                    const [header, value] = setRequestHeaderArgArray;
                    const xhrInfo = setRequestHeaderThisArg[$a83999f742846a08$export$55b6bb1e45c6cf59];
                    if (xhrInfo && (0, $13cf2ed412f405fa$export$844ec244b1367d54)(header) && (0, $13cf2ed412f405fa$export$844ec244b1367d54)(value)) xhrInfo.request_headers[header.toLowerCase()] = value;
                    return originalSetRequestHeader.apply(setRequestHeaderThisArg, setRequestHeaderArgArray);
                }
            });
            return originalOpen.apply(xhrOpenThisArg, xhrOpenArgArray);
        }
    });
    // eslint-disable-next-line @typescript-eslint/unbound-method
    xhrproto.send = new Proxy(xhrproto.send, {
        apply (originalSend, sendThisArg, sendArgArray) {
            const sentryXhrData = sendThisArg[$a83999f742846a08$export$55b6bb1e45c6cf59];
            if (!sentryXhrData) return originalSend.apply(sendThisArg, sendArgArray);
            if (sendArgArray[0] !== undefined) sentryXhrData.body = sendArgArray[0];
            const handlerData = {
                startTimestamp: (0, $bc81602376c48fa6$export$ee52dced521e3e18)() * 1000,
                xhr: sendThisArg
            };
            (0, $7b0ad3366f177c67$export$b18c893e424d3127)('xhr', handlerData);
            return originalSend.apply(sendThisArg, sendArgArray);
        }
    });
}
/**
 * Parses the URL argument of a XHR method to a string.
 *
 * See: https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest/open#url
 * url: A string or any other object with a stringifier — including a URL object — that provides the URL of the resource to send the request to.
 *
 * @param url - The URL argument of an XHR method
 * @returns The parsed URL string or undefined if the URL is invalid
 */ function $a83999f742846a08$var$parseXhrUrlArg(url) {
    if ((0, $13cf2ed412f405fa$export$844ec244b1367d54)(url)) return url;
    try {
        // If the passed in argument is not a string, it should have a `toString` method as a stringifier.
        // If that fails, we just return undefined (like in IE11 where URL is not available)
        return url.toString();
    } catch  {} // eslint-disable-line no-empty
    return undefined;
}




/** maxStringLength gets capped to prevent 100 breadcrumbs exceeding 1MB event payload size */ const $0ad9abad7f8d2d66$var$MAX_ALLOWED_STRING_LENGTH = 1024;
const $0ad9abad7f8d2d66$var$INTEGRATION_NAME = 'Breadcrumbs';
const $0ad9abad7f8d2d66$var$_breadcrumbsIntegration = (options = {})=>{
    const _options = {
        console: true,
        dom: true,
        fetch: true,
        history: true,
        sentry: true,
        xhr: true,
        ...options
    };
    return {
        name: $0ad9abad7f8d2d66$var$INTEGRATION_NAME,
        setup (client) {
            // TODO(v11): Remove this functionality and use `consoleIntegration` from @sentry/core instead.
            if (_options.console) (0, $46dfef45d2fe6e84$export$1d6e0d073f9e6723)($0ad9abad7f8d2d66$var$_getConsoleBreadcrumbHandler(client));
            if (_options.dom) (0, $16987639200114e3$export$5aeffd3db2cf9df7)($0ad9abad7f8d2d66$var$_getDomBreadcrumbHandler(client, _options.dom));
            if (_options.xhr) (0, $a83999f742846a08$export$26ace48dd54c9aea)($0ad9abad7f8d2d66$var$_getXhrBreadcrumbHandler(client));
            if (_options.fetch) (0, $d5ff33466750b470$export$f75d3c772c923df0)($0ad9abad7f8d2d66$var$_getFetchBreadcrumbHandler(client));
            if (_options.history) (0, $56137aac5362694e$export$3f18c56c58114e75)($0ad9abad7f8d2d66$var$_getHistoryBreadcrumbHandler(client));
            if (_options.sentry) client.on('beforeSendEvent', $0ad9abad7f8d2d66$var$_getSentryBreadcrumbHandler(client));
        }
    };
};
const $0ad9abad7f8d2d66$export$c079d904b326663a = (0, $cbb2da6c78246e45$export$2323046b9414659f)($0ad9abad7f8d2d66$var$_breadcrumbsIntegration);
/**
 * Adds a breadcrumb for Sentry events or transactions if this option is enabled.
 */ function $0ad9abad7f8d2d66$var$_getSentryBreadcrumbHandler(client) {
    return function addSentryBreadcrumb(event) {
        if ((0, $7d48e1ed9f699a01$export$6bb76d6eba7e258c)() !== client) return;
        (0, $777cacbd1bed0b63$export$efda9a273d7a036d)({
            category: `sentry.${event.type === 'transaction' ? 'transaction' : 'event'}`,
            event_id: event.event_id,
            level: event.level,
            message: (0, $cc262db35458e4b3$export$4157119e2b157127)(event)
        }, {
            event: event
        });
    };
}
/**
 * A HOC that creates a function that creates breadcrumbs from DOM API calls.
 * This is a HOC so that we get access to dom options in the closure.
 */ function $0ad9abad7f8d2d66$var$_getDomBreadcrumbHandler(client, dom) {
    return function _innerDomBreadcrumb(handlerData) {
        if ((0, $7d48e1ed9f699a01$export$6bb76d6eba7e258c)() !== client) return;
        let target;
        let componentName;
        let keyAttrs = typeof dom === 'object' ? dom.serializeAttribute : undefined;
        let maxStringLength = typeof dom === 'object' && typeof dom.maxStringLength === 'number' ? dom.maxStringLength : undefined;
        if (maxStringLength && maxStringLength > $0ad9abad7f8d2d66$var$MAX_ALLOWED_STRING_LENGTH) {
            (0, $6e9d48dbcf18d05a$export$16a28057038b10ef) && (0, $d11ed0b3cdda6b8d$export$1c9f709888824e05).warn(`\`dom.maxStringLength\` cannot exceed ${$0ad9abad7f8d2d66$var$MAX_ALLOWED_STRING_LENGTH}, but a value of ${maxStringLength} was configured. Sentry will use ${$0ad9abad7f8d2d66$var$MAX_ALLOWED_STRING_LENGTH} instead.`);
            maxStringLength = $0ad9abad7f8d2d66$var$MAX_ALLOWED_STRING_LENGTH;
        }
        if (typeof keyAttrs === 'string') keyAttrs = [
            keyAttrs
        ];
        // Accessing event.target can throw (see getsentry/raven-js#838, #768)
        try {
            const event = handlerData.event;
            const element = $0ad9abad7f8d2d66$var$_isEvent(event) ? event.target : event;
            target = (0, $caac489b9d8395b2$export$5647df6b7814ac86)(element, {
                keyAttrs: keyAttrs,
                maxStringLength: maxStringLength
            });
            componentName = (0, $caac489b9d8395b2$export$26727cfcc4d7e0fc)(element);
        } catch  {
            target = '<unknown>';
        }
        if (target.length === 0) return;
        const breadcrumb = {
            category: `ui.${handlerData.name}`,
            message: target
        };
        if (componentName) breadcrumb.data = {
            'ui.component_name': componentName
        };
        (0, $777cacbd1bed0b63$export$efda9a273d7a036d)(breadcrumb, {
            event: handlerData.event,
            name: handlerData.name,
            global: handlerData.global
        });
    };
}
/**
 * Creates breadcrumbs from console API calls
 */ function $0ad9abad7f8d2d66$var$_getConsoleBreadcrumbHandler(client) {
    return function _consoleBreadcrumb(handlerData) {
        if ((0, $7d48e1ed9f699a01$export$6bb76d6eba7e258c)() !== client) return;
        const breadcrumb = {
            category: 'console',
            data: {
                arguments: handlerData.args,
                logger: 'console'
            },
            level: (0, $9e4658f0600c3fda$export$d771ef054122c30a)(handlerData.level),
            message: (0, $e534db390d1e4996$export$465e9d514283d4fd)(handlerData.args, ' ')
        };
        if (handlerData.level === 'assert') {
            if (handlerData.args[0] === false) {
                breadcrumb.message = `Assertion failed: ${(0, $e534db390d1e4996$export$465e9d514283d4fd)(handlerData.args.slice(1), ' ') || 'console.assert'}`;
                breadcrumb.data.arguments = handlerData.args.slice(1);
            } else // Don't capture a breadcrumb for passed assertions
            return;
        }
        (0, $777cacbd1bed0b63$export$efda9a273d7a036d)(breadcrumb, {
            input: handlerData.args,
            level: handlerData.level
        });
    };
}
/**
 * Creates breadcrumbs from XHR API calls
 */ function $0ad9abad7f8d2d66$var$_getXhrBreadcrumbHandler(client) {
    return function _xhrBreadcrumb(handlerData) {
        if ((0, $7d48e1ed9f699a01$export$6bb76d6eba7e258c)() !== client) return;
        const { startTimestamp: startTimestamp, endTimestamp: endTimestamp } = handlerData;
        const sentryXhrData = handlerData.xhr[0, $a83999f742846a08$export$55b6bb1e45c6cf59];
        // We only capture complete, non-sentry requests
        if (!startTimestamp || !endTimestamp || !sentryXhrData) return;
        const { method: method, url: url, status_code: status_code, body: body } = sentryXhrData;
        const data = {
            method: method,
            url: url,
            status_code: status_code
        };
        const hint = {
            xhr: handlerData.xhr,
            input: body,
            startTimestamp: startTimestamp,
            endTimestamp: endTimestamp
        };
        const breadcrumb = {
            category: 'xhr',
            data: data,
            type: 'http',
            level: (0, $d3b8bcdfb9869d62$export$b8cfcc4175694bcc)(status_code)
        };
        client.emit('beforeOutgoingRequestBreadcrumb', breadcrumb, hint);
        (0, $777cacbd1bed0b63$export$efda9a273d7a036d)(breadcrumb, hint);
    };
}
/**
 * Creates breadcrumbs from fetch API calls
 */ function $0ad9abad7f8d2d66$var$_getFetchBreadcrumbHandler(client) {
    return function _fetchBreadcrumb(handlerData) {
        if ((0, $7d48e1ed9f699a01$export$6bb76d6eba7e258c)() !== client) return;
        const { startTimestamp: startTimestamp, endTimestamp: endTimestamp } = handlerData;
        // We only capture complete fetch requests
        if (!endTimestamp) return;
        if (handlerData.fetchData.url.match(/sentry_key/) && handlerData.fetchData.method === 'POST') // We will not create breadcrumbs for fetch requests that contain `sentry_key` (internal sentry requests)
        return;
        handlerData.fetchData.method, handlerData.fetchData.url;
        if (handlerData.error) {
            const data = handlerData.fetchData;
            const hint = {
                data: handlerData.error,
                input: handlerData.args,
                startTimestamp: startTimestamp,
                endTimestamp: endTimestamp
            };
            const breadcrumb = {
                category: 'fetch',
                data: data,
                level: 'error',
                type: 'http'
            };
            client.emit('beforeOutgoingRequestBreadcrumb', breadcrumb, hint);
            (0, $777cacbd1bed0b63$export$efda9a273d7a036d)(breadcrumb, hint);
        } else {
            const response = handlerData.response;
            const data = {
                ...handlerData.fetchData,
                status_code: response?.status
            };
            handlerData.fetchData.request_body_size;
            handlerData.fetchData.response_body_size;
            response?.status;
            const hint = {
                input: handlerData.args,
                response: response,
                startTimestamp: startTimestamp,
                endTimestamp: endTimestamp
            };
            const breadcrumb = {
                category: 'fetch',
                data: data,
                type: 'http',
                level: (0, $d3b8bcdfb9869d62$export$b8cfcc4175694bcc)(data.status_code)
            };
            client.emit('beforeOutgoingRequestBreadcrumb', breadcrumb, hint);
            (0, $777cacbd1bed0b63$export$efda9a273d7a036d)(breadcrumb, hint);
        }
    };
}
/**
 * Creates breadcrumbs from history API calls
 */ function $0ad9abad7f8d2d66$var$_getHistoryBreadcrumbHandler(client) {
    return function _historyBreadcrumb(handlerData) {
        if ((0, $7d48e1ed9f699a01$export$6bb76d6eba7e258c)() !== client) return;
        let from = handlerData.from;
        let to = handlerData.to;
        const parsedLoc = (0, $0c1b93525a804899$export$7a5253c0f62e0150)((0, $e62dec891f31852b$export$56d8a8a25bd48b81).location.href);
        let parsedFrom = from ? (0, $0c1b93525a804899$export$7a5253c0f62e0150)(from) : undefined;
        const parsedTo = (0, $0c1b93525a804899$export$7a5253c0f62e0150)(to);
        // Initial pushState doesn't provide `from` information
        if (!parsedFrom?.path) parsedFrom = parsedLoc;
        // Use only the path component of the URL if the URL matches the current
        // document (almost all the time when using pushState)
        if (parsedLoc.protocol === parsedTo.protocol && parsedLoc.host === parsedTo.host) to = parsedTo.relative;
        if (parsedLoc.protocol === parsedFrom.protocol && parsedLoc.host === parsedFrom.host) from = parsedFrom.relative;
        (0, $777cacbd1bed0b63$export$efda9a273d7a036d)({
            category: 'navigation',
            data: {
                from: from,
                to: to
            }
        });
    };
}
function $0ad9abad7f8d2d66$var$_isEvent(event) {
    return !!event && !!event.target;
}




const $fa3dc958cc9f40d6$var$DEFAULT_EVENT_TARGET = [
    'EventTarget',
    'Window',
    'Node',
    'ApplicationCache',
    'AudioTrackList',
    'BroadcastChannel',
    'ChannelMergerNode',
    'CryptoOperation',
    'EventSource',
    'FileReader',
    'HTMLUnknownElement',
    'IDBDatabase',
    'IDBRequest',
    'IDBTransaction',
    'KeyOperation',
    'MediaController',
    'MessagePort',
    'ModalWindow',
    'Notification',
    'SVGElementInstance',
    'Screen',
    'SharedWorker',
    'TextTrack',
    'TextTrackCue',
    'TextTrackList',
    'WebSocket',
    'WebSocketWorker',
    'Worker',
    'XMLHttpRequest',
    'XMLHttpRequestEventTarget',
    'XMLHttpRequestUpload'
];
const $fa3dc958cc9f40d6$var$INTEGRATION_NAME = 'BrowserApiErrors';
const $fa3dc958cc9f40d6$var$_browserApiErrorsIntegration = (options = {})=>{
    const _options = {
        XMLHttpRequest: true,
        eventTarget: true,
        requestAnimationFrame: true,
        setInterval: true,
        setTimeout: true,
        unregisterOriginalCallbacks: false,
        ...options
    };
    return {
        name: $fa3dc958cc9f40d6$var$INTEGRATION_NAME,
        // TODO: This currently only works for the first client this is setup
        // We may want to adjust this to check for client etc.
        setupOnce () {
            if (_options.setTimeout) (0, $269eeb69635ed414$export$9563e054e6f787fb)((0, $e62dec891f31852b$export$56d8a8a25bd48b81), 'setTimeout', $fa3dc958cc9f40d6$var$_wrapTimeFunction);
            if (_options.setInterval) (0, $269eeb69635ed414$export$9563e054e6f787fb)((0, $e62dec891f31852b$export$56d8a8a25bd48b81), 'setInterval', $fa3dc958cc9f40d6$var$_wrapTimeFunction);
            if (_options.requestAnimationFrame) (0, $269eeb69635ed414$export$9563e054e6f787fb)((0, $e62dec891f31852b$export$56d8a8a25bd48b81), 'requestAnimationFrame', $fa3dc958cc9f40d6$var$_wrapRAF);
            if (_options.XMLHttpRequest && 'XMLHttpRequest' in (0, $e62dec891f31852b$export$56d8a8a25bd48b81)) (0, $269eeb69635ed414$export$9563e054e6f787fb)(XMLHttpRequest.prototype, 'send', $fa3dc958cc9f40d6$var$_wrapXHR);
            const eventTargetOption = _options.eventTarget;
            if (eventTargetOption) {
                const eventTarget = Array.isArray(eventTargetOption) ? eventTargetOption : $fa3dc958cc9f40d6$var$DEFAULT_EVENT_TARGET;
                eventTarget.forEach((target)=>$fa3dc958cc9f40d6$var$_wrapEventTarget(target, _options));
            }
        }
    };
};
/**
 * Wrap timer functions and event targets to catch errors and provide better meta data.
 */ const $fa3dc958cc9f40d6$export$59bfe9f1c76150e = (0, $cbb2da6c78246e45$export$2323046b9414659f)($fa3dc958cc9f40d6$var$_browserApiErrorsIntegration);
function $fa3dc958cc9f40d6$var$_wrapTimeFunction(original) {
    return function(...args) {
        const originalCallback = args[0];
        args[0] = (0, $e62dec891f31852b$export$4997ffc0176396a6)(originalCallback, {
            mechanism: {
                handled: false,
                type: `auto.browser.browserapierrors.${(0, $9ed2cf4edd0b2db9$export$aad197c7121a6651)(original)}`
            }
        });
        return original.apply(this, args);
    };
}
function $fa3dc958cc9f40d6$var$_wrapRAF(original) {
    return function(callback) {
        return original.apply(this, [
            (0, $e62dec891f31852b$export$4997ffc0176396a6)(callback, {
                mechanism: {
                    data: {
                        handler: (0, $9ed2cf4edd0b2db9$export$aad197c7121a6651)(original)
                    },
                    handled: false,
                    type: 'auto.browser.browserapierrors.requestAnimationFrame'
                }
            })
        ]);
    };
}
function $fa3dc958cc9f40d6$var$_wrapXHR(originalSend) {
    return function(...args) {
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        const xhr = this;
        const xmlHttpRequestProps = [
            'onload',
            'onerror',
            'onprogress',
            'onreadystatechange'
        ];
        xmlHttpRequestProps.forEach((prop)=>{
            if (prop in xhr && typeof xhr[prop] === 'function') (0, $269eeb69635ed414$export$9563e054e6f787fb)(xhr, prop, function(original) {
                const wrapOptions = {
                    mechanism: {
                        data: {
                            handler: (0, $9ed2cf4edd0b2db9$export$aad197c7121a6651)(original)
                        },
                        handled: false,
                        type: `auto.browser.browserapierrors.xhr.${prop}`
                    }
                };
                // If Instrument integration has been called before BrowserApiErrors, get the name of original function
                const originalFunction = (0, $269eeb69635ed414$export$e6cc1e135e2092e5)(original);
                if (originalFunction) wrapOptions.mechanism.data.handler = (0, $9ed2cf4edd0b2db9$export$aad197c7121a6651)(originalFunction);
                // Otherwise wrap directly
                return (0, $e62dec891f31852b$export$4997ffc0176396a6)(original, wrapOptions);
            });
        });
        return originalSend.apply(this, args);
    };
}
function $fa3dc958cc9f40d6$var$_wrapEventTarget(target, integrationOptions) {
    const globalObject = (0, $e62dec891f31852b$export$56d8a8a25bd48b81);
    const proto = globalObject[target]?.prototype;
    // eslint-disable-next-line no-prototype-builtins
    if (!proto?.hasOwnProperty?.('addEventListener')) return;
    (0, $269eeb69635ed414$export$9563e054e6f787fb)(proto, 'addEventListener', function(original) {
        return function(eventName, fn, options) {
            try {
                if ($fa3dc958cc9f40d6$var$isEventListenerObject(fn)) // ESlint disable explanation:
                //  First, it is generally safe to call `wrap` with an unbound function. Furthermore, using `.bind()` would
                //  introduce a bug here, because bind returns a new function that doesn't have our
                //  flags(like __sentry_original__) attached. `wrap` checks for those flags to avoid unnecessary wrapping.
                //  Without those flags, every call to addEventListener wraps the function again, causing a memory leak.
                // eslint-disable-next-line @typescript-eslint/unbound-method
                fn.handleEvent = (0, $e62dec891f31852b$export$4997ffc0176396a6)(fn.handleEvent, {
                    mechanism: {
                        data: {
                            handler: (0, $9ed2cf4edd0b2db9$export$aad197c7121a6651)(fn),
                            target: target
                        },
                        handled: false,
                        type: 'auto.browser.browserapierrors.handleEvent'
                    }
                });
            } catch  {
            // can sometimes get 'Permission denied to access property "handle Event'
            }
            if (integrationOptions.unregisterOriginalCallbacks) $fa3dc958cc9f40d6$var$unregisterOriginalCallback(this, eventName, fn);
            return original.apply(this, [
                eventName,
                (0, $e62dec891f31852b$export$4997ffc0176396a6)(fn, {
                    mechanism: {
                        data: {
                            handler: (0, $9ed2cf4edd0b2db9$export$aad197c7121a6651)(fn),
                            target: target
                        },
                        handled: false,
                        type: 'auto.browser.browserapierrors.addEventListener'
                    }
                }),
                options
            ]);
        };
    });
    (0, $269eeb69635ed414$export$9563e054e6f787fb)(proto, 'removeEventListener', function(originalRemoveEventListener) {
        return function(eventName, fn, options) {
            /**
       * There are 2 possible scenarios here:
       *
       * 1. Someone passes a callback, which was attached prior to Sentry initialization, or by using unmodified
       * method, eg. `document.addEventListener.call(el, name, handler). In this case, we treat this function
       * as a pass-through, and call original `removeEventListener` with it.
       *
       * 2. Someone passes a callback, which was attached after Sentry was initialized, which means that it was using
       * our wrapped version of `addEventListener`, which internally calls `wrap` helper.
       * This helper "wraps" whole callback inside a try/catch statement, and attached appropriate metadata to it,
       * in order for us to make a distinction between wrapped/non-wrapped functions possible.
       * If a function was wrapped, it has additional property of `__sentry_wrapped__`, holding the handler.
       *
       * When someone adds a handler prior to initialization, and then do it again, but after,
       * then we have to detach both of them. Otherwise, if we'd detach only wrapped one, it'd be impossible
       * to get rid of the initial handler and it'd stick there forever.
       */ try {
                const originalEventHandler = fn.__sentry_wrapped__;
                if (originalEventHandler) originalRemoveEventListener.call(this, eventName, originalEventHandler, options);
            } catch  {
            // ignore, accessing __sentry_wrapped__ will throw in some Selenium environments
            }
            return originalRemoveEventListener.call(this, eventName, fn, options);
        };
    });
}
function $fa3dc958cc9f40d6$var$isEventListenerObject(obj) {
    return typeof obj.handleEvent === 'function';
}
function $fa3dc958cc9f40d6$var$unregisterOriginalCallback(target, eventName, fn) {
    if (target && typeof target === 'object' && 'removeEventListener' in target && typeof target.removeEventListener === 'function') target.removeEventListener(eventName, fn);
}






/**
 * When added, automatically creates sessions which allow you to track adoption and crashes (crash free rate) in your Releases in Sentry.
 * More information: https://docs.sentry.io/product/releases/health/
 *
 * Note: In order for session tracking to work, you need to set up Releases: https://docs.sentry.io/product/releases/
 */ const $9bfd264dc60b3ee5$export$1baa7880e357371c = (0, $cbb2da6c78246e45$export$2323046b9414659f)((options = {})=>{
    const lifecycle = options.lifecycle ?? 'route';
    return {
        name: 'BrowserSession',
        setupOnce () {
            if (typeof (0, $e62dec891f31852b$export$56d8a8a25bd48b81).document === 'undefined') {
                (0, $6e9d48dbcf18d05a$export$16a28057038b10ef) && (0, $d11ed0b3cdda6b8d$export$1c9f709888824e05).warn('Using the `browserSessionIntegration` in non-browser environments is not supported.');
                return;
            }
            // The session duration for browser sessions does not track a meaningful
            // concept that can be used as a metric.
            // Automatically captured sessions are akin to page views, and thus we
            // discard their duration.
            (0, $6918c722b531ff18$export$c0d84948cecf78d8)({
                ignoreDuration: true
            });
            (0, $6918c722b531ff18$export$667e7b4d445d566b)();
            // User data can be set at any time, for example async after Sentry.init has run and the initial session
            // envelope was already sent, but still on the initial page.
            // Therefore, we have to update the ongoing session with the new user data if it exists, to send the `did`.
            // In theory, sessions, as well as user data is always put onto the isolation scope. So we listen to the
            // isolation scope for changes and update the session with the new user data if it exists.
            // This will not catch users set onto other scopes, like the current scope. For now, we'll accept this limitation.
            // The alternative is to update and capture the session from within the scope. This could be too costly or would not
            // play well with session aggregates on the server side. Since this happens in the scope class, we'd need change
            // scope behaviour in the browser.
            const isolationScope = (0, $7d48e1ed9f699a01$export$68f3af03034c9e90)();
            let previousUser = isolationScope.getUser();
            isolationScope.addScopeListener((scope)=>{
                const maybeNewUser = scope.getUser();
                // sessions only care about user id and ip address, so we only need to capture the session if the user has changed
                if (previousUser?.id !== maybeNewUser?.id || previousUser?.ip_address !== maybeNewUser?.ip_address) {
                    // the scope class already writes the user to its session, so we only need to capture the session here
                    (0, $6918c722b531ff18$export$667e7b4d445d566b)();
                    previousUser = maybeNewUser;
                }
            });
            if (lifecycle === 'route') // We want to create a session for every navigation as well
            (0, $56137aac5362694e$export$3f18c56c58114e75)(({ from: from, to: to })=>{
                // Don't create an additional session for the initial route or if the location did not change
                if (from !== to) {
                    (0, $6918c722b531ff18$export$c0d84948cecf78d8)({
                        ignoreDuration: true
                    });
                    (0, $6918c722b531ff18$export$667e7b4d445d566b)();
                }
            });
        }
    };
});




const $5784fbfdd799cccf$var$INTEGRATION_NAME = 'CultureContext';
const $5784fbfdd799cccf$var$_cultureContextIntegration = ()=>{
    return {
        name: $5784fbfdd799cccf$var$INTEGRATION_NAME,
        preprocessEvent (event) {
            const culture = $5784fbfdd799cccf$var$getCultureContext();
            if (culture) event.contexts = {
                ...event.contexts,
                culture: {
                    ...culture,
                    ...event.contexts?.culture
                }
            };
        }
    };
};
/**
 * Captures culture context from the browser.
 *
 * Enabled by default.
 *
 * @example
 * ```js
 * import * as Sentry from '@sentry/browser';
 *
 * Sentry.init({
 *   integrations: [Sentry.cultureContextIntegration()],
 * });
 * ```
 */ const $5784fbfdd799cccf$export$ec5976aacdc85985 = (0, $cbb2da6c78246e45$export$2323046b9414659f)($5784fbfdd799cccf$var$_cultureContextIntegration);
/**
 * Returns the culture context from the browser's Intl API.
 */ function $5784fbfdd799cccf$var$getCultureContext() {
    try {
        const intl = (0, $e62dec891f31852b$export$56d8a8a25bd48b81).Intl;
        if (!intl) return undefined;
        const options = intl.DateTimeFormat().resolvedOptions();
        return {
            locale: options.locale,
            timezone: options.timeZone,
            calendar: options.calendar
        };
    } catch  {
        // Ignore errors
        return undefined;
    }
}






const $f1959cdcacc276d1$var$INTEGRATION_NAME = 'GlobalHandlers';
const $f1959cdcacc276d1$var$_globalHandlersIntegration = (options = {})=>{
    const _options = {
        onerror: true,
        onunhandledrejection: true,
        ...options
    };
    return {
        name: $f1959cdcacc276d1$var$INTEGRATION_NAME,
        setupOnce () {
            Error.stackTraceLimit = 50;
        },
        setup (client) {
            if (_options.onerror) {
                $f1959cdcacc276d1$var$_installGlobalOnErrorHandler(client);
                $f1959cdcacc276d1$var$globalHandlerLog('onerror');
            }
            if (_options.onunhandledrejection) {
                $f1959cdcacc276d1$var$_installGlobalOnUnhandledRejectionHandler(client);
                $f1959cdcacc276d1$var$globalHandlerLog('onunhandledrejection');
            }
        }
    };
};
const $f1959cdcacc276d1$export$66acc70e8cf2b71a = (0, $cbb2da6c78246e45$export$2323046b9414659f)($f1959cdcacc276d1$var$_globalHandlersIntegration);
function $f1959cdcacc276d1$var$_installGlobalOnErrorHandler(client) {
    (0, $092d3122136c38a4$export$55b5c3ba2194f0c6)((data)=>{
        const { stackParser: stackParser, attachStacktrace: attachStacktrace } = $f1959cdcacc276d1$var$getOptions();
        if ((0, $7d48e1ed9f699a01$export$6bb76d6eba7e258c)() !== client || (0, $e62dec891f31852b$export$b79738ab10c590b2)()) return;
        const { msg: msg, url: url, line: line, column: column, error: error } = data;
        const event = $f1959cdcacc276d1$var$_enhanceEventWithInitialFrame((0, $934e8a4b0ce930b6$export$9dd56ed1ef0c3420)(stackParser, error || msg, undefined, attachStacktrace, false), url, line, column);
        event.level = 'error';
        (0, $6918c722b531ff18$export$1462b974fdcf6ba2)(event, {
            originalException: error,
            mechanism: {
                handled: false,
                type: 'auto.browser.global_handlers.onerror'
            }
        });
    });
}
function $f1959cdcacc276d1$var$_installGlobalOnUnhandledRejectionHandler(client) {
    (0, $4db3540f511ca554$export$8bf4fc6858821a4e)((e)=>{
        const { stackParser: stackParser, attachStacktrace: attachStacktrace } = $f1959cdcacc276d1$var$getOptions();
        if ((0, $7d48e1ed9f699a01$export$6bb76d6eba7e258c)() !== client || (0, $e62dec891f31852b$export$b79738ab10c590b2)()) return;
        const error = $f1959cdcacc276d1$export$b2cc40fa8241780(e);
        const event = (0, $13cf2ed412f405fa$export$c3825b437cbdea5c)(error) ? $f1959cdcacc276d1$export$1353b5b36844a9ed(error) : (0, $934e8a4b0ce930b6$export$9dd56ed1ef0c3420)(stackParser, error, undefined, attachStacktrace, true);
        event.level = 'error';
        (0, $6918c722b531ff18$export$1462b974fdcf6ba2)(event, {
            originalException: error,
            mechanism: {
                handled: false,
                type: 'auto.browser.global_handlers.onunhandledrejection'
            }
        });
    });
}
/**
 *
 */ function $f1959cdcacc276d1$export$b2cc40fa8241780(error) {
    if ((0, $13cf2ed412f405fa$export$c3825b437cbdea5c)(error)) return error;
    // dig the object of the rejection out of known event types
    try {
        // PromiseRejectionEvents store the object of the rejection under 'reason'
        // see https://developer.mozilla.org/en-US/docs/Web/API/PromiseRejectionEvent
        if ('reason' in error) return error.reason;
        // something, somewhere, (likely a browser extension) effectively casts PromiseRejectionEvents
        // to CustomEvents, moving the `promise` and `reason` attributes of the PRE into
        // the CustomEvent's `detail` attribute, since they're not part of CustomEvent's spec
        // see https://developer.mozilla.org/en-US/docs/Web/API/CustomEvent and
        // https://github.com/getsentry/sentry-javascript/issues/2380
        if ('detail' in error && 'reason' in error.detail) return error.detail.reason;
    } catch  {} // eslint-disable-line no-empty
    return error;
}
/**
 * Create an event from a promise rejection where the `reason` is a primitive.
 *
 * @param reason: The `reason` property of the promise rejection
 * @returns An Event object with an appropriate `exception` value
 */ function $f1959cdcacc276d1$export$1353b5b36844a9ed(reason) {
    return {
        exception: {
            values: [
                {
                    type: 'UnhandledRejection',
                    // String() is needed because the Primitive type includes symbols (which can't be automatically stringified)
                    value: `Non-Error promise rejection captured with value: ${String(reason)}`
                }
            ]
        }
    };
}
function $f1959cdcacc276d1$var$_enhanceEventWithInitialFrame(event, url, line, column) {
    // event.exception
    const e = event.exception = event.exception || {};
    // event.exception.values
    const ev = e.values = e.values || [];
    // event.exception.values[0]
    const ev0 = ev[0] = ev[0] || {};
    // event.exception.values[0].stacktrace
    const ev0s = ev0.stacktrace = ev0.stacktrace || {};
    // event.exception.values[0].stacktrace.frames
    const ev0sf = ev0s.frames = ev0s.frames || [];
    const colno = column;
    const lineno = line;
    const filename = $f1959cdcacc276d1$var$getFilenameFromUrl(url) ?? (0, $caac489b9d8395b2$export$1cfafeee2987818b)();
    // event.exception.values[0].stacktrace.frames
    if (ev0sf.length === 0) ev0sf.push({
        colno: colno,
        filename: filename,
        function: (0, $9ed2cf4edd0b2db9$export$27c7e15d453fc0ac),
        in_app: true,
        lineno: lineno
    });
    return event;
}
function $f1959cdcacc276d1$var$globalHandlerLog(type) {
    (0, $6e9d48dbcf18d05a$export$16a28057038b10ef) && (0, $d11ed0b3cdda6b8d$export$1c9f709888824e05).log(`Global Handler attached: ${type}`);
}
function $f1959cdcacc276d1$var$getOptions() {
    const client = (0, $7d48e1ed9f699a01$export$6bb76d6eba7e258c)();
    const options = client?.getOptions() || {
        stackParser: ()=>[],
        attachStacktrace: false
    };
    return options;
}
function $f1959cdcacc276d1$var$getFilenameFromUrl(url) {
    if (!(0, $13cf2ed412f405fa$export$844ec244b1367d54)(url) || url.length === 0) return undefined;
    // Strip data URL content to avoid long base64 strings in stack frames
    // (e.g. when initializing a Worker with a base64 encoded script)
    // Don't include data prefix for filenames as it's not useful for stack traces
    // Wrap with < > to indicate it's a placeholder
    if (url.startsWith('data:')) return `<${(0, $0c1b93525a804899$export$8abd806fcaf234fa)(url, false)}>`;
    return url;
}




/**
 * Collects information about HTTP request headers and
 * attaches them to the event.
 */ const $2fcda6dfa3c250e9$export$1378794447170364 = (0, $cbb2da6c78246e45$export$2323046b9414659f)(()=>{
    return {
        name: 'HttpContext',
        preprocessEvent (event) {
            // if none of the information we want exists, don't bother
            if (!(0, $e62dec891f31852b$export$56d8a8a25bd48b81).navigator && !(0, $e62dec891f31852b$export$56d8a8a25bd48b81).location && !(0, $e62dec891f31852b$export$56d8a8a25bd48b81).document) return;
            const reqData = (0, $e62dec891f31852b$export$a3c4a8453e8936f0)();
            const headers = {
                ...reqData.headers,
                ...event.request?.headers
            };
            event.request = {
                ...reqData,
                ...event.request,
                headers: headers
            };
        }
    };
});



/**
 * Creates exceptions inside `event.exception.values` for errors that are nested on properties based on the `key` parameter.
 */ function $b378ed56067f6272$export$b91c38ed7d8ae9b2(exceptionFromErrorImplementation, parser, key, limit, event, hint) {
    if (!event.exception?.values || !hint || !(0, $13cf2ed412f405fa$export$49034edbe6b62415)(hint.originalException, Error)) return;
    // Generally speaking the last item in `event.exception.values` is the exception originating from the original Error
    const originalException = event.exception.values.length > 0 ? event.exception.values[event.exception.values.length - 1] : undefined;
    // We only create exception grouping if there is an exception in the event.
    if (originalException) event.exception.values = $b378ed56067f6272$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, hint.originalException, key, event.exception.values, originalException, 0);
}
function $b378ed56067f6272$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, error, key, prevExceptions, exception, exceptionId) {
    if (prevExceptions.length >= limit + 1) return prevExceptions;
    let newExceptions = [
        ...prevExceptions
    ];
    // Recursively call this function in order to walk down a chain of errors
    if ((0, $13cf2ed412f405fa$export$49034edbe6b62415)(error[key], Error)) {
        $b378ed56067f6272$var$applyExceptionGroupFieldsForParentException(exception, exceptionId, error);
        const newException = exceptionFromErrorImplementation(parser, error[key]);
        const newExceptionId = newExceptions.length;
        $b378ed56067f6272$var$applyExceptionGroupFieldsForChildException(newException, key, newExceptionId, exceptionId);
        newExceptions = $b378ed56067f6272$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, error[key], key, [
            newException,
            ...newExceptions
        ], newException, newExceptionId);
    }
    // This will create exception grouping for AggregateErrors
    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/AggregateError
    if ($b378ed56067f6272$var$isExceptionGroup(error)) error.errors.forEach((childError, i)=>{
        if ((0, $13cf2ed412f405fa$export$49034edbe6b62415)(childError, Error)) {
            $b378ed56067f6272$var$applyExceptionGroupFieldsForParentException(exception, exceptionId, error);
            const newException = exceptionFromErrorImplementation(parser, childError);
            const newExceptionId = newExceptions.length;
            $b378ed56067f6272$var$applyExceptionGroupFieldsForChildException(newException, `errors[${i}]`, newExceptionId, exceptionId);
            newExceptions = $b378ed56067f6272$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, childError, key, [
                newException,
                ...newExceptions
            ], newException, newExceptionId);
        }
    });
    return newExceptions;
}
function $b378ed56067f6272$var$isExceptionGroup(error) {
    return Array.isArray(error.errors);
}
function $b378ed56067f6272$var$applyExceptionGroupFieldsForParentException(exception, exceptionId, error) {
    exception.mechanism = {
        handled: true,
        type: 'auto.core.linked_errors',
        ...$b378ed56067f6272$var$isExceptionGroup(error) && {
            is_exception_group: true
        },
        ...exception.mechanism,
        exception_id: exceptionId
    };
}
function $b378ed56067f6272$var$applyExceptionGroupFieldsForChildException(exception, source, exceptionId, parentId) {
    exception.mechanism = {
        handled: true,
        ...exception.mechanism,
        type: 'chained',
        source: source,
        exception_id: exceptionId,
        parent_id: parentId
    };
}



const $ce07fe89a71836e2$var$DEFAULT_KEY = 'cause';
const $ce07fe89a71836e2$var$DEFAULT_LIMIT = 5;
const $ce07fe89a71836e2$var$INTEGRATION_NAME = 'LinkedErrors';
const $ce07fe89a71836e2$var$_linkedErrorsIntegration = (options = {})=>{
    const limit = options.limit || $ce07fe89a71836e2$var$DEFAULT_LIMIT;
    const key = options.key || $ce07fe89a71836e2$var$DEFAULT_KEY;
    return {
        name: $ce07fe89a71836e2$var$INTEGRATION_NAME,
        preprocessEvent (event, hint, client) {
            const options = client.getOptions();
            (0, $b378ed56067f6272$export$b91c38ed7d8ae9b2)(// This differs from the LinkedErrors integration in core by using a different exceptionFromError function
            (0, $934e8a4b0ce930b6$export$a6c2d27607295951), options.stackParser, key, limit, event, hint);
        }
    };
};
/**
 * Aggregrate linked errors in an event.
 */ const $ce07fe89a71836e2$export$ebabb00eb7f3a395 = (0, $cbb2da6c78246e45$export$2323046b9414659f)($ce07fe89a71836e2$var$_linkedErrorsIntegration);








/**
 * Returns true if the SDK is running in an embedded browser extension.
 * Stand-alone browser extensions (which do not share the same data as the main browser page) are fine.
 */ function $b8730b3801b0c1f4$export$dc236a86065879fc() {
    if ($b8730b3801b0c1f4$var$_isEmbeddedBrowserExtension()) {
        if (0, $6e9d48dbcf18d05a$export$16a28057038b10ef) (0, $d11ed0b3cdda6b8d$export$cda52e2a8927a2ca)(()=>{
            // eslint-disable-next-line no-console
            console.error('[Sentry] You cannot use Sentry.init() in a browser extension, see: https://docs.sentry.io/platforms/javascript/best-practices/browser-extensions/');
        });
        return true;
    }
    return false;
}
function $b8730b3801b0c1f4$var$_isEmbeddedBrowserExtension() {
    if (typeof (0, $e62dec891f31852b$export$56d8a8a25bd48b81).window === 'undefined') // No need to show the error if we're not in a browser window environment (e.g. service workers)
    return false;
    const _window = (0, $e62dec891f31852b$export$56d8a8a25bd48b81);
    // Running the SDK in NW.js, which appears like a browser extension but isn't, is also fine
    // see: https://github.com/getsentry/sentry-javascript/issues/12668
    if (_window.nw) return false;
    const extensionObject = _window['chrome'] || _window['browser'];
    if (!extensionObject?.runtime?.id) return false;
    const href = (0, $caac489b9d8395b2$export$1cfafeee2987818b)();
    const extensionProtocols = [
        'chrome-extension',
        'moz-extension',
        'ms-browser-extension',
        'safari-web-extension'
    ];
    // Running the SDK in a dedicated extension page and calling Sentry.init is fine; no risk of data leakage
    const isDedicatedExtensionPage = (0, $e62dec891f31852b$export$56d8a8a25bd48b81) === (0, $e62dec891f31852b$export$56d8a8a25bd48b81).top && extensionProtocols.some((protocol)=>href.startsWith(`${protocol}://`));
    return !isDedicatedExtensionPage;
}


/** Get the default integrations for the browser SDK. */ function $14d7809dba5d50b0$export$5783b2920b1d62b9(_options) {
    /**
   * Note: Please make sure this stays in sync with Angular SDK, which re-exports
   * `getDefaultIntegrations` but with an adjusted set of integrations.
   */ return [
        // TODO(v11): Replace with `eventFiltersIntegration` once we remove the deprecated `inboundFiltersIntegration`
        // eslint-disable-next-line deprecation/deprecation
        (0, $ed46e39d92a37c80$export$cb3c5c2ceb9818ba)(),
        (0, $c17712dd9960287e$export$7918117e9202e4fb)(),
        (0, $de0065ae4a0cfe96$export$97457a453081a5b3)(),
        (0, $fa3dc958cc9f40d6$export$59bfe9f1c76150e)(),
        (0, $0ad9abad7f8d2d66$export$c079d904b326663a)(),
        (0, $f1959cdcacc276d1$export$66acc70e8cf2b71a)(),
        (0, $ce07fe89a71836e2$export$ebabb00eb7f3a395)(),
        (0, $09e731d6cf47db44$export$6d39aa44cd0c7567)(),
        (0, $2fcda6dfa3c250e9$export$1378794447170364)(),
        (0, $5784fbfdd799cccf$export$ec5976aacdc85985)(),
        (0, $9bfd264dc60b3ee5$export$1baa7880e357371c)()
    ];
}
/**
 * The Sentry Browser SDK Client.
 *
 * To use this SDK, call the {@link init} function as early as possible when
 * loading the web page. To set context information or send manual events, use
 * the provided methods.
 *
 * @example
 *
 * ```
 *
 * import { init } from '@sentry/browser';
 *
 * init({
 *   dsn: '__DSN__',
 *   // ...
 * });
 * ```
 *
 * @example
 * ```
 *
 * import { addBreadcrumb } from '@sentry/browser';
 * addBreadcrumb({
 *   message: 'My Breadcrumb',
 *   // ...
 * });
 * ```
 *
 * @example
 *
 * ```
 *
 * import * as Sentry from '@sentry/browser';
 * Sentry.captureMessage('Hello, world!');
 * Sentry.captureException(new Error('Good bye'));
 * Sentry.captureEvent({
 *   message: 'Manual',
 *   stacktrace: [
 *     // ...
 *   ],
 * });
 * ```
 *
 * @see {@link BrowserOptions} for documentation on configuration options.
 */ function $14d7809dba5d50b0$export$2cd8252107eb640b(options = {}) {
    const shouldDisableBecauseIsBrowserExtenstion = !options.skipBrowserExtensionCheck && (0, $b8730b3801b0c1f4$export$dc236a86065879fc)();
    let defaultIntegrations = options.defaultIntegrations == null ? $14d7809dba5d50b0$export$5783b2920b1d62b9() : options.defaultIntegrations;
    const clientOptions = {
        ...options,
        enabled: shouldDisableBecauseIsBrowserExtenstion ? false : options.enabled,
        stackParser: (0, $9ed2cf4edd0b2db9$export$1d5cf88b347146d4)(options.stackParser || (0, $5c2a6884ada474e9$export$2b2b997d81bf3907)),
        integrations: (0, $cbb2da6c78246e45$export$68bc4c01ab8ae766)({
            integrations: options.integrations,
            defaultIntegrations: defaultIntegrations
        }),
        transport: options.transport || (0, $366021d20f9daad3$export$b2311068c46d7cc8)
    };
    return (0, $bdb6894cd2fc2f4a$export$5333c3f1c58d9bc1)((0, $4e1ce061c21a5e69$export$1df9218a526d318d), clientOptions);
}
/**
 * This function is here to be API compatible with the loader.
 * @hidden
 */ function $14d7809dba5d50b0$export$a3f323d81eede727() {
// Noop
}
/**
 * This function is here to be API compatible with the loader.
 * @hidden
 */ function $14d7809dba5d50b0$export$4e4d8b287d028b6b(callback) {
    callback();
}





/**
 * Present the user with a report dialog.
 *
 * @param options Everything is optional, we try to fetch all info need from the current scope.
 */ function $c145e0c6ce486f3a$export$3a8fd680da42627b(options = {}) {
    const optionalDocument = (0, $e62dec891f31852b$export$56d8a8a25bd48b81).document;
    const injectionPoint = optionalDocument?.head || optionalDocument?.body;
    // doesn't work without a document (React Native)
    if (!injectionPoint) {
        (0, $6e9d48dbcf18d05a$export$16a28057038b10ef) && (0, $d11ed0b3cdda6b8d$export$1c9f709888824e05).error('[showReportDialog] Global document not defined');
        return;
    }
    const scope = (0, $7d48e1ed9f699a01$export$c7be4b0125a10cba)();
    const client = (0, $7d48e1ed9f699a01$export$6bb76d6eba7e258c)();
    const dsn = client?.getDsn();
    if (!dsn) {
        (0, $6e9d48dbcf18d05a$export$16a28057038b10ef) && (0, $d11ed0b3cdda6b8d$export$1c9f709888824e05).error('[showReportDialog] DSN not configured');
        return;
    }
    const mergedOptions = {
        ...options,
        user: {
            ...scope.getUser(),
            ...options.user
        },
        eventId: options.eventId || (0, $6918c722b531ff18$export$5d4e9fd7fac8e617)()
    };
    const script = (0, $e62dec891f31852b$export$56d8a8a25bd48b81).document.createElement('script');
    script.async = true;
    script.crossOrigin = 'anonymous';
    script.src = (0, $95bd43db10a47155$export$671c7ed8e40a7a57)(dsn, mergedOptions);
    const { onLoad: onLoad, onClose: onClose } = mergedOptions;
    if (onLoad) script.onload = onLoad;
    if (onClose) {
        const reportDialogClosedMessageHandler = (event)=>{
            if (event.data === '__sentry_reportdialog_closed__') try {
                onClose();
            } finally{
                (0, $e62dec891f31852b$export$56d8a8a25bd48b81).removeEventListener('message', reportDialogClosedMessageHandler);
            }
        };
        (0, $e62dec891f31852b$export$56d8a8a25bd48b81).addEventListener('message', reportDialogClosedMessageHandler);
    }
    injectionPoint.appendChild(script);
}










const $a0ba0212b29c7bfc$var$WINDOW = (0, $736a69486c86d36c$export$f1a6cdb1459e81d1);
const $a0ba0212b29c7bfc$var$INTEGRATION_NAME = 'ReportingObserver';
const $a0ba0212b29c7bfc$var$SETUP_CLIENTS = new WeakMap();
const $a0ba0212b29c7bfc$var$_reportingObserverIntegration = (options = {})=>{
    const types = options.types || [
        'crash',
        'deprecation',
        'intervention'
    ];
    /** Handler for the reporting observer. */ function handler(reports) {
        if (!$a0ba0212b29c7bfc$var$SETUP_CLIENTS.has((0, $7d48e1ed9f699a01$export$6bb76d6eba7e258c)())) return;
        for (const report of reports)(0, $7d48e1ed9f699a01$export$ec58d9285c204497)((scope)=>{
            scope.setExtra('url', report.url);
            const label = `ReportingObserver [${report.type}]`;
            let details = 'No details available';
            if (report.body) {
                // Object.keys doesn't work on ReportBody, as all properties are inherited
                const plainBody = {};
                // eslint-disable-next-line guard-for-in
                for(const prop in report.body)plainBody[prop] = report.body[prop];
                scope.setExtra('body', plainBody);
                if (report.type === 'crash') {
                    const body = report.body;
                    // A fancy way to create a message out of crashId OR reason OR both OR fallback
                    details = [
                        body.crashId || '',
                        body.reason || ''
                    ].join(' ').trim() || details;
                } else {
                    const body = report.body;
                    details = body.message || details;
                }
            }
            (0, $6918c722b531ff18$export$45654777c133ae80)(`${label}: ${details}`);
        });
    }
    return {
        name: $a0ba0212b29c7bfc$var$INTEGRATION_NAME,
        setupOnce () {
            if (!(0, $133087f5c0803d70$export$531055a6c684a70a)()) return;
            const observer = new $a0ba0212b29c7bfc$var$WINDOW.ReportingObserver(handler, {
                buffered: true,
                types: types
            });
            observer.observe();
        },
        setup (client) {
            $a0ba0212b29c7bfc$var$SETUP_CLIENTS.set(client, true);
        }
    };
};
/**
 * Reporting API integration - https://w3c.github.io/reporting/
 */ const $a0ba0212b29c7bfc$export$609cccfa9f328cc5 = (0, $cbb2da6c78246e45$export$2323046b9414659f)($a0ba0212b29c7bfc$var$_reportingObserverIntegration);



/**
 * Checks whether given url points to Sentry server
 *
 * @param url url to verify
 */ function $7b9954de727fbe52$export$d92e61f5600202af(url, client) {
    const dsn = client?.getDsn();
    const tunnel = client?.getOptions().tunnel;
    return $7b9954de727fbe52$var$checkDsn(url, dsn) || $7b9954de727fbe52$var$checkTunnel(url, tunnel);
}
function $7b9954de727fbe52$var$checkTunnel(url, tunnel) {
    if (!tunnel) return false;
    return $7b9954de727fbe52$var$removeTrailingSlash(url) === $7b9954de727fbe52$var$removeTrailingSlash(tunnel);
}
function $7b9954de727fbe52$var$checkDsn(url, dsn) {
    // Requests to Sentry's ingest endpoint must have a `sentry_key` in the query string
    // This is equivalent to the public_key which is required in the DSN
    // see https://develop.sentry.dev/sdk/overview/#parsing-the-dsn
    // Therefore, a request to the same host and with a `sentry_key` in the query string
    // can be considered a request to the ingest endpoint.
    const urlParts = (0, $0c1b93525a804899$export$2004d912a9ead694)(url);
    if (!urlParts || (0, $0c1b93525a804899$export$e258e13805402ba7)(urlParts)) return false;
    return dsn ? urlParts.host.includes(dsn.host) && /(^|&|\?)sentry_key=/.test(urlParts.search) : false;
}
function $7b9954de727fbe52$var$removeTrailingSlash(str) {
    return str[str.length - 1] === '/' ? str.slice(0, -1) : str;
}




const $899ee8298ebc75fb$var$INTEGRATION_NAME = 'HttpClient';
const $899ee8298ebc75fb$var$_httpClientIntegration = (options = {})=>{
    const _options = {
        failedRequestStatusCodes: [
            [
                500,
                599
            ]
        ],
        failedRequestTargets: [
            /.*/
        ],
        ...options
    };
    return {
        name: $899ee8298ebc75fb$var$INTEGRATION_NAME,
        setup (client) {
            $899ee8298ebc75fb$var$_wrapFetch(client, _options);
            $899ee8298ebc75fb$var$_wrapXHR(client, _options);
        }
    };
};
/**
 * Create events for failed client side HTTP requests.
 */ const $899ee8298ebc75fb$export$8a3b7aeb379b3907 = (0, $cbb2da6c78246e45$export$2323046b9414659f)($899ee8298ebc75fb$var$_httpClientIntegration);
/**
 * Interceptor function for fetch requests
 *
 * @param requestInfo The Fetch API request info
 * @param response The Fetch API response
 * @param requestInit The request init object
 */ function $899ee8298ebc75fb$var$_fetchResponseHandler(options, requestInfo, response, requestInit, error) {
    if ($899ee8298ebc75fb$var$_shouldCaptureResponse(options, response.status, response.url)) {
        const request = $899ee8298ebc75fb$var$_getRequest(requestInfo, requestInit);
        let requestHeaders, responseHeaders, requestCookies, responseCookies;
        if ($899ee8298ebc75fb$var$_shouldSendDefaultPii()) {
            [requestHeaders, requestCookies] = $899ee8298ebc75fb$var$_parseCookieHeaders('Cookie', request);
            [responseHeaders, responseCookies] = $899ee8298ebc75fb$var$_parseCookieHeaders('Set-Cookie', response);
        }
        const event = $899ee8298ebc75fb$var$_createEvent({
            url: request.url,
            method: request.method,
            status: response.status,
            requestHeaders: requestHeaders,
            responseHeaders: responseHeaders,
            requestCookies: requestCookies,
            responseCookies: responseCookies,
            error: error,
            type: 'fetch'
        });
        (0, $6918c722b531ff18$export$1462b974fdcf6ba2)(event);
    }
}
function $899ee8298ebc75fb$var$_parseCookieHeaders(cookieHeader, obj) {
    const headers = $899ee8298ebc75fb$var$_extractFetchHeaders(obj.headers);
    let cookies;
    try {
        const cookieString = headers[cookieHeader] || headers[cookieHeader.toLowerCase()] || undefined;
        if (cookieString) cookies = $899ee8298ebc75fb$var$_parseCookieString(cookieString);
    } catch  {
    // ignore it if parsing fails
    }
    return [
        headers,
        cookies
    ];
}
/**
 * Interceptor function for XHR requests
 *
 * @param xhr The XHR request
 * @param method The HTTP method
 * @param headers The HTTP headers
 */ function $899ee8298ebc75fb$var$_xhrResponseHandler(options, xhr, method, headers, error) {
    if ($899ee8298ebc75fb$var$_shouldCaptureResponse(options, xhr.status, xhr.responseURL)) {
        let requestHeaders, responseCookies, responseHeaders;
        if ($899ee8298ebc75fb$var$_shouldSendDefaultPii()) {
            try {
                const cookieString = xhr.getResponseHeader('Set-Cookie') || xhr.getResponseHeader('set-cookie') || undefined;
                if (cookieString) responseCookies = $899ee8298ebc75fb$var$_parseCookieString(cookieString);
            } catch  {
            // ignore it if parsing fails
            }
            try {
                responseHeaders = $899ee8298ebc75fb$var$_getXHRResponseHeaders(xhr);
            } catch  {
            // ignore it if parsing fails
            }
            requestHeaders = headers;
        }
        const event = $899ee8298ebc75fb$var$_createEvent({
            url: xhr.responseURL,
            method: method,
            status: xhr.status,
            requestHeaders: requestHeaders,
            responseHeaders: // Can't access request cookies from XHR
            responseHeaders,
            responseCookies: responseCookies,
            error: error,
            type: 'xhr'
        });
        (0, $6918c722b531ff18$export$1462b974fdcf6ba2)(event);
    }
}
/**
 * Extracts response size from `Content-Length` header when possible
 *
 * @param headers
 * @returns The response size in bytes or undefined
 */ function $899ee8298ebc75fb$var$_getResponseSizeFromHeaders(headers) {
    if (headers) {
        const contentLength = headers['Content-Length'] || headers['content-length'];
        if (contentLength) return parseInt(contentLength, 10);
    }
    return undefined;
}
/**
 * Creates an object containing cookies from the given cookie string
 *
 * @param cookieString The cookie string to parse
 * @returns The parsed cookies
 */ function $899ee8298ebc75fb$var$_parseCookieString(cookieString) {
    return cookieString.split('; ').reduce((acc, cookie)=>{
        const [key, value] = cookie.split('=');
        if (key && value) acc[key] = value;
        return acc;
    }, {});
}
/**
 * Extracts the headers as an object from the given Fetch API request or response object
 *
 * @param headers The headers to extract
 * @returns The extracted headers as an object
 */ function $899ee8298ebc75fb$var$_extractFetchHeaders(headers) {
    const result = {};
    headers.forEach((value, key)=>{
        result[key] = value;
    });
    return result;
}
/**
 * Extracts the response headers as an object from the given XHR object
 *
 * @param xhr The XHR object to extract the response headers from
 * @returns The response headers as an object
 */ function $899ee8298ebc75fb$var$_getXHRResponseHeaders(xhr) {
    const headers = xhr.getAllResponseHeaders();
    if (!headers) return {};
    return headers.split('\r\n').reduce((acc, line)=>{
        const [key, value] = line.split(': ');
        if (key && value) acc[key] = value;
        return acc;
    }, {});
}
/**
 * Checks if the given target url is in the given list of targets
 *
 * @param target The target url to check
 * @returns true if the target url is in the given list of targets, false otherwise
 */ function $899ee8298ebc75fb$var$_isInGivenRequestTargets(failedRequestTargets, target) {
    return failedRequestTargets.some((givenRequestTarget)=>{
        if (typeof givenRequestTarget === 'string') return target.includes(givenRequestTarget);
        return givenRequestTarget.test(target);
    });
}
/**
 * Checks if the given status code is in the given range
 *
 * @param status The status code to check
 * @returns true if the status code is in the given range, false otherwise
 */ function $899ee8298ebc75fb$var$_isInGivenStatusRanges(failedRequestStatusCodes, status) {
    return failedRequestStatusCodes.some((range)=>{
        if (typeof range === 'number') return range === status;
        return status >= range[0] && status <= range[1];
    });
}
/**
 * Wraps `fetch` function to capture request and response data
 */ function $899ee8298ebc75fb$var$_wrapFetch(client, options) {
    if (!(0, $133087f5c0803d70$export$c82d238e23c40b21)()) return;
    (0, $d5ff33466750b470$export$f75d3c772c923df0)((handlerData)=>{
        if ((0, $7d48e1ed9f699a01$export$6bb76d6eba7e258c)() !== client) return;
        const { response: response, args: args, error: error, virtualError: virtualError } = handlerData;
        const [requestInfo, requestInit] = args;
        if (!response) return;
        $899ee8298ebc75fb$var$_fetchResponseHandler(options, requestInfo, response, requestInit, error || virtualError);
    }, false);
}
/**
 * Wraps XMLHttpRequest to capture request and response data
 */ function $899ee8298ebc75fb$var$_wrapXHR(client, options) {
    if (!('XMLHttpRequest' in (0, $736a69486c86d36c$export$f1a6cdb1459e81d1))) return;
    (0, $a83999f742846a08$export$26ace48dd54c9aea)((handlerData)=>{
        if ((0, $7d48e1ed9f699a01$export$6bb76d6eba7e258c)() !== client) return;
        const { error: error, virtualError: virtualError } = handlerData;
        const xhr = handlerData.xhr;
        const sentryXhrData = xhr[0, $a83999f742846a08$export$55b6bb1e45c6cf59];
        if (!sentryXhrData) return;
        const { method: method, request_headers: headers } = sentryXhrData;
        try {
            $899ee8298ebc75fb$var$_xhrResponseHandler(options, xhr, method, headers, error || virtualError);
        } catch (e) {
            (0, $6e9d48dbcf18d05a$export$16a28057038b10ef) && (0, $d11ed0b3cdda6b8d$export$1c9f709888824e05).warn('Error while extracting response event form XHR response', e);
        }
    });
}
/**
 * Checks whether to capture given response as an event
 *
 * @param status response status code
 * @param url response url
 */ function $899ee8298ebc75fb$var$_shouldCaptureResponse(options, status, url) {
    return $899ee8298ebc75fb$var$_isInGivenStatusRanges(options.failedRequestStatusCodes, status) && $899ee8298ebc75fb$var$_isInGivenRequestTargets(options.failedRequestTargets, url) && !(0, $7b9954de727fbe52$export$d92e61f5600202af)(url, (0, $7d48e1ed9f699a01$export$6bb76d6eba7e258c)());
}
/**
 * Creates a synthetic Sentry event from given response data
 *
 * @param data response data
 * @returns event
 */ function $899ee8298ebc75fb$var$_createEvent(data) {
    const client = (0, $7d48e1ed9f699a01$export$6bb76d6eba7e258c)();
    const virtualStackTrace = client && data.error && data.error instanceof Error ? data.error.stack : undefined;
    // Remove the first frame from the stack as it's the HttpClient call
    const stack = virtualStackTrace && client ? client.getOptions().stackParser(virtualStackTrace, 0, 1) : undefined;
    const message = `HTTP Client Error with status code: ${data.status}`;
    const event = {
        message: message,
        exception: {
            values: [
                {
                    type: 'Error',
                    value: message,
                    stacktrace: stack ? {
                        frames: stack
                    } : undefined
                }
            ]
        },
        request: {
            url: data.url,
            method: data.method,
            headers: data.requestHeaders,
            cookies: data.requestCookies
        },
        contexts: {
            response: {
                status_code: data.status,
                headers: data.responseHeaders,
                cookies: data.responseCookies,
                body_size: $899ee8298ebc75fb$var$_getResponseSizeFromHeaders(data.responseHeaders)
            }
        }
    };
    (0, $cc262db35458e4b3$export$c69a9a0313b03bb1)(event, {
        type: `auto.http.client.${data.type}`,
        handled: false
    });
    return event;
}
function $899ee8298ebc75fb$var$_getRequest(requestInfo, requestInit) {
    if (!requestInit && requestInfo instanceof Request) return requestInfo;
    // If both are set, we try to construct a new Request with the given arguments
    // However, if e.g. the original request has a `body`, this will throw an error because it was already accessed
    // In this case, as a fallback, we just use the original request - using both is rather an edge case
    if (requestInfo instanceof Request && requestInfo.bodyUsed) return requestInfo;
    return new Request(requestInfo, requestInit);
}
function $899ee8298ebc75fb$var$_shouldSendDefaultPii() {
    const client = (0, $7d48e1ed9f699a01$export$6bb76d6eba7e258c)();
    return client ? Boolean(client.getOptions().sendDefaultPii) : false;
}



const $e5ba3b05859a226d$var$WINDOW = (0, $736a69486c86d36c$export$f1a6cdb1459e81d1);
const $e5ba3b05859a226d$var$DEFAULT_LINES_OF_CONTEXT = 7;
const $e5ba3b05859a226d$var$INTEGRATION_NAME = 'ContextLines';
const $e5ba3b05859a226d$var$_contextLinesIntegration = (options = {})=>{
    const contextLines = options.frameContextLines != null ? options.frameContextLines : $e5ba3b05859a226d$var$DEFAULT_LINES_OF_CONTEXT;
    return {
        name: $e5ba3b05859a226d$var$INTEGRATION_NAME,
        processEvent (event) {
            return $e5ba3b05859a226d$var$addSourceContext(event, contextLines);
        }
    };
};
/**
 * Collects source context lines around the lines of stackframes pointing to JS embedded in
 * the current page's HTML.
 *
 * This integration DOES NOT work for stack frames pointing to JS files that are loaded by the browser.
 * For frames pointing to files, context lines are added during ingestion and symbolication
 * by attempting to download the JS files to the Sentry backend.
 *
 * Use this integration if you have inline JS code in HTML pages that can't be accessed
 * by our backend (e.g. due to a login-protected page).
 */ const $e5ba3b05859a226d$export$74173d114ed4f354 = (0, $cbb2da6c78246e45$export$2323046b9414659f)($e5ba3b05859a226d$var$_contextLinesIntegration);
/**
 * Processes an event and adds context lines.
 */ function $e5ba3b05859a226d$var$addSourceContext(event, contextLines) {
    const doc = $e5ba3b05859a226d$var$WINDOW.document;
    const htmlFilename = $e5ba3b05859a226d$var$WINDOW.location && (0, $0c1b93525a804899$export$ce084c78234bd35)($e5ba3b05859a226d$var$WINDOW.location.href);
    if (!doc || !htmlFilename) return event;
    const exceptions = event.exception?.values;
    if (!exceptions?.length) return event;
    const html = doc.documentElement.innerHTML;
    if (!html) return event;
    const htmlLines = [
        '<!DOCTYPE html>',
        '<html>',
        ...html.split('\n'),
        '</html>'
    ];
    exceptions.forEach((exception)=>{
        const stacktrace = exception.stacktrace;
        if (stacktrace?.frames) stacktrace.frames = stacktrace.frames.map((frame)=>$e5ba3b05859a226d$export$cf59ef3dc46bd2e1(frame, htmlLines, htmlFilename, contextLines));
    });
    return event;
}
/**
 * Only exported for testing
 */ function $e5ba3b05859a226d$export$cf59ef3dc46bd2e1(frame, htmlLines, htmlFilename, linesOfContext) {
    if (frame.filename !== htmlFilename || !frame.lineno || !htmlLines.length) return frame;
    (0, $cc262db35458e4b3$export$ec2291bfc64632f0)(htmlLines, frame, linesOfContext);
    return frame;
}





// Symbol used by e.g. the Replay integration to store original body on Request objects
const $e82a9c6161ef9dbd$export$363d064b9116000e = Symbol.for('sentry__originalRequestBody');
/**
 * Serializes FormData.
 *
 * This is a bit simplified, but gives us a decent estimate.
 * This converts e.g. { name: 'Anne Smith', age: 13 } to 'name=Anne+Smith&age=13'.
 *
 */ function $e82a9c6161ef9dbd$export$2f1b0f57f243f270(formData) {
    // @ts-expect-error passing FormData to URLSearchParams actually works
    return new URLSearchParams(formData).toString();
}
/** Get the string representation of a body. */ function $e82a9c6161ef9dbd$export$945a2d5364608d5(body, _debug = (0, $d11ed0b3cdda6b8d$export$1c9f709888824e05)) {
    try {
        if (typeof body === 'string') return [
            body
        ];
        if (body instanceof URLSearchParams) return [
            body.toString()
        ];
        if (body instanceof FormData) return [
            $e82a9c6161ef9dbd$export$2f1b0f57f243f270(body)
        ];
        if (!body) return [
            undefined
        ];
    } catch (error) {
        (0, $52f4069f580f537e$export$16a28057038b10ef) && _debug.error(error, 'Failed to serialize body', body);
        return [
            undefined,
            'BODY_PARSE_ERROR'
        ];
    }
    (0, $52f4069f580f537e$export$16a28057038b10ef) && _debug.log('Skipping network body because of body type', body);
    return [
        undefined,
        'UNPARSEABLE_BODY_TYPE'
    ];
}
/**
 * Parses the fetch arguments to extract the request payload.
 *
 * In case of a Request object, this function attempts to retrieve the original body by looking for a Sentry-patched symbol.
 */ function $e82a9c6161ef9dbd$export$ad44edf8012ec314(fetchArgs = []) {
    // Second argument with body options takes precedence
    if (fetchArgs.length >= 2 && fetchArgs[1] && typeof fetchArgs[1] === 'object' && 'body' in fetchArgs[1]) return fetchArgs[1].body;
    if (fetchArgs.length >= 1 && fetchArgs[0] instanceof Request) {
        const request = fetchArgs[0];
        /* The Request interface's body is a ReadableStream, which we cannot directly access.
       Some integrations (e.g. Replay) patch the Request object to store the original body. */ // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-member-access
        const originalBody = request[$e82a9c6161ef9dbd$export$363d064b9116000e];
        if (originalBody !== undefined) return originalBody;
        return undefined; // Fall back to returning undefined (as we don't want to return a ReadableStream)
    }
    return undefined;
}
/**
 * Parses XMLHttpRequest response headers into a Record.
 * Extracted from replay internals to be reusable.
 */ function $e82a9c6161ef9dbd$export$ce71c337afb62ea(xhr) {
    let headers;
    try {
        headers = xhr.getAllResponseHeaders();
    } catch (error) {
        (0, $52f4069f580f537e$export$16a28057038b10ef) && (0, $d11ed0b3cdda6b8d$export$1c9f709888824e05).error(error, 'Failed to get xhr response headers', xhr);
        return {};
    }
    if (!headers) return {};
    return headers.split('\r\n').reduce((acc, line)=>{
        const [key, value] = line.split(': ');
        if (value) acc[key.toLowerCase()] = value;
        return acc;
    }, {});
}


const $09df6a71d9392bb9$var$INTEGRATION_NAME = 'GraphQLClient';
const $09df6a71d9392bb9$var$_graphqlClientIntegration = (options)=>{
    return {
        name: $09df6a71d9392bb9$var$INTEGRATION_NAME,
        setup (client) {
            $09df6a71d9392bb9$var$_updateSpanWithGraphQLData(client, options);
            $09df6a71d9392bb9$var$_updateBreadcrumbWithGraphQLData(client, options);
        }
    };
};
function $09df6a71d9392bb9$var$_updateSpanWithGraphQLData(client, options) {
    client.on('beforeOutgoingRequestSpan', (span, hint)=>{
        const spanJSON = (0, $bb9b6447bf4caedb$export$92d8c23565496537)(span);
        const spanAttributes = spanJSON.data || {};
        const spanOp = spanAttributes[0, $f337c80285f06f80$export$1a413bd9a88fdb09];
        const isHttpClientSpan = spanOp === 'http.client';
        if (!isHttpClientSpan) return;
        const httpUrl = spanAttributes[0, $f337c80285f06f80$export$25dfd73e0e32c6e1] || spanAttributes['http.url'];
        const httpMethod = spanAttributes[0, $f337c80285f06f80$export$be7a251980e7e946] || spanAttributes['http.method'];
        if (!(0, $13cf2ed412f405fa$export$844ec244b1367d54)(httpUrl) || !(0, $13cf2ed412f405fa$export$844ec244b1367d54)(httpMethod)) return;
        const { endpoints: endpoints } = options;
        const isTracedGraphqlEndpoint = (0, $e534db390d1e4996$export$a7a5ec66062ea5d)(httpUrl, endpoints);
        const payload = $09df6a71d9392bb9$export$ab01d0edbd10f3e8(hint);
        if (isTracedGraphqlEndpoint && payload) {
            const graphqlBody = $09df6a71d9392bb9$export$8a91006ab73e3ea(payload);
            if (graphqlBody) {
                const operationInfo = $09df6a71d9392bb9$export$cac3929c3e0f021b(graphqlBody);
                span.updateName(`${httpMethod} ${httpUrl} (${operationInfo})`);
                // Handle standard requests - always capture the query document
                if ($09df6a71d9392bb9$var$isStandardRequest(graphqlBody)) span.setAttribute('graphql.document', graphqlBody.query);
                // Handle persisted operations - capture hash for debugging
                if ($09df6a71d9392bb9$var$isPersistedRequest(graphqlBody)) {
                    span.setAttribute('graphql.persisted_query.hash.sha256', graphqlBody.extensions.persistedQuery.sha256Hash);
                    span.setAttribute('graphql.persisted_query.version', graphqlBody.extensions.persistedQuery.version);
                }
            }
        }
    });
}
function $09df6a71d9392bb9$var$_updateBreadcrumbWithGraphQLData(client, options) {
    client.on('beforeOutgoingRequestBreadcrumb', (breadcrumb, handlerData)=>{
        const { category: category, type: type, data: data } = breadcrumb;
        const isFetch = category === 'fetch';
        const isXhr = category === 'xhr';
        const isHttpBreadcrumb = type === 'http';
        if (isHttpBreadcrumb && (isFetch || isXhr)) {
            const httpUrl = data?.url;
            const { endpoints: endpoints } = options;
            const isTracedGraphqlEndpoint = (0, $e534db390d1e4996$export$a7a5ec66062ea5d)(httpUrl, endpoints);
            const payload = $09df6a71d9392bb9$export$ab01d0edbd10f3e8(handlerData);
            if (isTracedGraphqlEndpoint && data && payload) {
                const graphqlBody = $09df6a71d9392bb9$export$8a91006ab73e3ea(payload);
                if (!data.graphql && graphqlBody) {
                    const operationInfo = $09df6a71d9392bb9$export$cac3929c3e0f021b(graphqlBody);
                    data['graphql.operation'] = operationInfo;
                    if ($09df6a71d9392bb9$var$isStandardRequest(graphqlBody)) data['graphql.document'] = graphqlBody.query;
                    if ($09df6a71d9392bb9$var$isPersistedRequest(graphqlBody)) {
                        data['graphql.persisted_query.hash.sha256'] = graphqlBody.extensions.persistedQuery.sha256Hash;
                        data['graphql.persisted_query.version'] = graphqlBody.extensions.persistedQuery.version;
                    }
                }
            }
        }
    });
}
/**
 * @param requestBody - GraphQL request
 * @returns A formatted version of the request: 'TYPE NAME' or 'TYPE' or 'persisted NAME'
 */ function $09df6a71d9392bb9$export$cac3929c3e0f021b(requestBody) {
    // Handle persisted operations
    if ($09df6a71d9392bb9$var$isPersistedRequest(requestBody)) return `persisted ${requestBody.operationName}`;
    // Handle standard GraphQL requests
    if ($09df6a71d9392bb9$var$isStandardRequest(requestBody)) {
        const { query: graphqlQuery, operationName: graphqlOperationName } = requestBody;
        const { operationName: operationName = graphqlOperationName, operationType: operationType } = $09df6a71d9392bb9$export$cf7a144a1fa44ed4(graphqlQuery);
        const operationInfo = operationName ? `${operationType} ${operationName}` : `${operationType}`;
        return operationInfo;
    }
    // Fallback for unknown request types
    return 'unknown';
}
/**
 * Get the request body/payload based on the shape of the hint.
 *
 * Exported for tests only.
 */ function $09df6a71d9392bb9$export$ab01d0edbd10f3e8(hint) {
    const isXhr = 'xhr' in hint;
    let body;
    if (isXhr) {
        const sentryXhrData = hint.xhr[0, $a83999f742846a08$export$55b6bb1e45c6cf59];
        body = sentryXhrData && (0, $e82a9c6161ef9dbd$export$945a2d5364608d5)(sentryXhrData.body)[0];
    } else {
        const sentryFetchData = (0, $e82a9c6161ef9dbd$export$ad44edf8012ec314)(hint.input);
        body = (0, $e82a9c6161ef9dbd$export$945a2d5364608d5)(sentryFetchData)[0];
    }
    return body;
}
/**
 * Extract the name and type of the operation from the GraphQL query.
 *
 * Exported for tests only.
 */ function $09df6a71d9392bb9$export$cf7a144a1fa44ed4(query) {
    const namedQueryRe = /^(?:\s*)(query|mutation|subscription)(?:\s*)(\w+)(?:\s*)[{(]/;
    const unnamedQueryRe = /^(?:\s*)(query|mutation|subscription)(?:\s*)[{(]/;
    const namedMatch = query.match(namedQueryRe);
    if (namedMatch) return {
        operationType: namedMatch[1],
        operationName: namedMatch[2]
    };
    const unnamedMatch = query.match(unnamedQueryRe);
    if (unnamedMatch) return {
        operationType: unnamedMatch[1],
        operationName: undefined
    };
    return {
        operationType: undefined,
        operationName: undefined
    };
}
/**
 * Helper to safely check if a value is a non-null object
 */ function $09df6a71d9392bb9$var$isObject(value) {
    return typeof value === 'object' && value !== null;
}
/**
 * Type guard to check if a request is a standard GraphQL request
 */ function $09df6a71d9392bb9$var$isStandardRequest(payload) {
    return $09df6a71d9392bb9$var$isObject(payload) && typeof payload.query === 'string';
}
/**
 * Type guard to check if a request is a persisted operation request
 */ function $09df6a71d9392bb9$var$isPersistedRequest(payload) {
    return $09df6a71d9392bb9$var$isObject(payload) && typeof payload.operationName === 'string' && $09df6a71d9392bb9$var$isObject(payload.extensions) && $09df6a71d9392bb9$var$isObject(payload.extensions.persistedQuery) && typeof payload.extensions.persistedQuery.sha256Hash === 'string' && typeof payload.extensions.persistedQuery.version === 'number';
}
/**
 * Extract the payload of a request if it's GraphQL.
 * Exported for tests only.
 * @param payload - A valid JSON string
 * @returns A POJO or undefined
 */ function $09df6a71d9392bb9$export$8a91006ab73e3ea(payload) {
    try {
        const requestBody = JSON.parse(payload);
        // Return any valid GraphQL request (standard, persisted, or APQ retry with both)
        if ($09df6a71d9392bb9$var$isStandardRequest(requestBody) || $09df6a71d9392bb9$var$isPersistedRequest(requestBody)) return requestBody;
        // Not a GraphQL request
        return undefined;
    } catch  {
        // Invalid JSON
        return undefined;
    }
}
/**
 * This integration ensures that GraphQL requests made in the browser
 * have their GraphQL-specific data captured and attached to spans and breadcrumbs.
 */ const $09df6a71d9392bb9$export$a934e57cd817247a = (0, $cbb2da6c78246e45$export$2323046b9414659f)($09df6a71d9392bb9$var$_graphqlClientIntegration);


/**
 * Heavily simplified debounce function based on lodash.debounce.
 *
 * This function takes a callback function (@param fun) and delays its invocation
 * by @param wait milliseconds. Optionally, a maxWait can be specified in @param options,
 * which ensures that the callback is invoked at least once after the specified max. wait time.
 *
 * @param func the function whose invocation is to be debounced
 * @param wait the minimum time until the function is invoked after it was called once
 * @param options the options object, which can contain the `maxWait` property
 *
 * @returns the debounced version of the function, which needs to be called at least once to start the
 *          debouncing process. Subsequent calls will reset the debouncing timer and, in case @paramfunc
 *          was already invoked in the meantime, return @param func's return value.
 *          The debounced function has two additional properties:
 *          - `flush`: Invokes the debounced function immediately and returns its return value
 *          - `cancel`: Cancels the debouncing process and resets the debouncing timer
 */ function $b98d2b6f6f2e87bf$export$61fc7d43ac8f84b0(func, wait, options) {
    let callbackReturnValue;
    let timerId;
    let maxTimerId;
    const maxWait = options?.maxWait ? Math.max(options.maxWait, wait) : 0;
    const setTimeoutImpl = options?.setTimeoutImpl || setTimeout;
    function invokeFunc() {
        cancelTimers();
        callbackReturnValue = func();
        return callbackReturnValue;
    }
    function cancelTimers() {
        timerId !== undefined && clearTimeout(timerId);
        maxTimerId !== undefined && clearTimeout(maxTimerId);
        timerId = maxTimerId = undefined;
    }
    function flush() {
        if (timerId !== undefined || maxTimerId !== undefined) return invokeFunc();
        return callbackReturnValue;
    }
    function debounced() {
        if (timerId) clearTimeout(timerId);
        timerId = setTimeoutImpl(invokeFunc, wait);
        if (maxWait && maxTimerId === undefined) maxTimerId = setTimeoutImpl(invokeFunc, maxWait);
        return callbackReturnValue;
    }
    debounced.cancel = cancelTimers;
    debounced.flush = flush;
    return debounced;
}





const $7e76489bb98b9510$var$getRating = (value, thresholds)=>{
    if (value > thresholds[1]) return 'poor';
    if (value > thresholds[0]) return 'needs-improvement';
    return 'good';
};
const $7e76489bb98b9510$export$17679dccdd551979 = (callback, metric, thresholds, reportAllChanges)=>{
    let prevValue;
    let delta;
    return (forceReport)=>{
        if (metric.value >= 0) {
            if (forceReport || reportAllChanges) {
                delta = metric.value - (prevValue ?? 0);
                // Report the metric if there's a non-zero delta or if no previous
                // value exists (which can happen in the case of the document becoming
                // hidden when the metric value is 0).
                // See: https://github.com/GoogleChrome/web-vitals/issues/14
                if (delta || prevValue === undefined) {
                    prevValue = metric.value;
                    metric.delta = delta;
                    metric.rating = $7e76489bb98b9510$var$getRating(metric.value, thresholds);
                    callback(metric);
                }
            }
        }
    };
};




/*
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // sentry-specific change:
// add optional param to not check for responseStart (see comment below)
const $ced02df875855c4b$export$6431553786c94949 = (checkResponseStart = true)=>{
    const navigationEntry = (0, $a279eed6bc86f03b$export$56d8a8a25bd48b81).performance?.getEntriesByType?.('navigation')[0];
    // Check to ensure the `responseStart` property is present and valid.
    // In some cases a zero value is reported by the browser (for
    // privacy/security reasons), and in other cases (bugs) the value is
    // negative or is larger than the current page time. Ignore these cases:
    // - https://github.com/GoogleChrome/web-vitals/issues/137
    // - https://github.com/GoogleChrome/web-vitals/issues/162
    // - https://github.com/GoogleChrome/web-vitals/issues/275
    if (// sentry-specific change:
    // We don't want to check for responseStart for our own use of `getNavigationEntry`
    !checkResponseStart || navigationEntry && navigationEntry.responseStart > 0 && navigationEntry.responseStart < performance.now()) return navigationEntry;
};


/*
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $395b26100bb9afc9$export$d3e828b3c7b5b845 = ()=>{
    const navEntry = (0, $ced02df875855c4b$export$6431553786c94949)();
    return navEntry?.activationStart ?? 0;
};



/**
 * web-vitals 5.1.0 switched listeners to be added on the window rather than the document.
 * Instead of having to check for window/document every time we add a listener, we can use this function.
 */ function $c7a41d5152be2585$export$26d3d892edc56833(type, listener, options) {
    if ((0, $a279eed6bc86f03b$export$56d8a8a25bd48b81).document) (0, $a279eed6bc86f03b$export$56d8a8a25bd48b81).addEventListener(type, listener, options);
}
/**
 * web-vitals 5.1.0 switched listeners to be removed from the window rather than the document.
 * Instead of having to check for window/document every time we remove a listener, we can use this function.
 */ function $c7a41d5152be2585$export$324d7b4b46528191(type, listener, options) {
    if ((0, $a279eed6bc86f03b$export$56d8a8a25bd48b81).document) (0, $a279eed6bc86f03b$export$56d8a8a25bd48b81).removeEventListener(type, listener, options);
}


/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ let $3e2a3037c0664e80$var$firstHiddenTime = -1;
const $3e2a3037c0664e80$var$onHiddenFunctions = new Set();
const $3e2a3037c0664e80$var$initHiddenTime = ()=>{
    // If the document is hidden when this code runs, assume it was always
    // hidden and the page was loaded in the background, with the one exception
    // that visibility state is always 'hidden' during prerendering, so we have
    // to ignore that case until prerendering finishes (see: `prerenderingchange`
    // event logic below).
    return (0, $a279eed6bc86f03b$export$56d8a8a25bd48b81).document?.visibilityState === 'hidden' && !(0, $a279eed6bc86f03b$export$56d8a8a25bd48b81).document?.prerendering ? 0 : Infinity;
};
const $3e2a3037c0664e80$var$onVisibilityUpdate = (event)=>{
    // Handle changes to hidden state
    if ($3e2a3037c0664e80$var$isPageHidden(event) && $3e2a3037c0664e80$var$firstHiddenTime > -1) {
        // Sentry-specific change: Also call onHidden callbacks for pagehide events
        // to support older browsers (Safari <14.4) that don't properly fire visibilitychange
        if (event.type === 'visibilitychange' || event.type === 'pagehide') for (const onHiddenFunction of $3e2a3037c0664e80$var$onHiddenFunctions)onHiddenFunction();
        // If the document is 'hidden' and no previous hidden timestamp has been
        // set (so is infinity), update it based on the current event data.
        if (!isFinite($3e2a3037c0664e80$var$firstHiddenTime)) {
            // If the event is a 'visibilitychange' event, it means the page was
            // visible prior to this change, so the event timestamp is the first
            // hidden time.
            // However, if the event is not a 'visibilitychange' event, then it must
            // be a 'prerenderingchange' or 'pagehide' event, and the fact that the document is
            // still 'hidden' from the above check means the tab was activated
            // in a background state and so has always been hidden.
            $3e2a3037c0664e80$var$firstHiddenTime = event.type === 'visibilitychange' ? event.timeStamp : 0;
            // We no longer need the `prerenderingchange` event listener now we've
            // set an initial init time so remove that
            // (we'll keep the visibilitychange and pagehide ones for onHiddenFunction above)
            (0, $c7a41d5152be2585$export$324d7b4b46528191)('prerenderingchange', $3e2a3037c0664e80$var$onVisibilityUpdate, true);
        }
    }
};
const $3e2a3037c0664e80$export$443f86b2c77012c4 = ()=>{
    if ((0, $a279eed6bc86f03b$export$56d8a8a25bd48b81).document && $3e2a3037c0664e80$var$firstHiddenTime < 0) {
        // Check if we have a previous hidden `visibility-state` performance entry.
        const activationStart = (0, $395b26100bb9afc9$export$d3e828b3c7b5b845)();
        const firstVisibilityStateHiddenTime = !(0, $a279eed6bc86f03b$export$56d8a8a25bd48b81).document.prerendering ? globalThis.performance.getEntriesByType('visibility-state').filter((e)=>e.name === 'hidden' && e.startTime > activationStart)[0]?.startTime : undefined;
        // Prefer that, but if it's not available and the document is hidden when
        // this code runs, assume it was hidden since navigation start. This isn't
        // a perfect heuristic, but it's the best we can do until the
        // `visibility-state` performance entry becomes available in all browsers.
        $3e2a3037c0664e80$var$firstHiddenTime = firstVisibilityStateHiddenTime ?? $3e2a3037c0664e80$var$initHiddenTime();
        // Listen for visibility changes so we can handle things like bfcache
        // restores and/or prerender without having to examine individual
        // timestamps in detail and also for onHidden function calls.
        (0, $c7a41d5152be2585$export$26d3d892edc56833)('visibilitychange', $3e2a3037c0664e80$var$onVisibilityUpdate, true);
        // Sentry-specific change: Some browsers have buggy implementations of visibilitychange,
        // so we use pagehide in addition, just to be safe. This is also required for older
        // Safari versions (<14.4) that we still support.
        (0, $c7a41d5152be2585$export$26d3d892edc56833)('pagehide', $3e2a3037c0664e80$var$onVisibilityUpdate, true);
        // IMPORTANT: when a page is prerendering, its `visibilityState` is
        // 'hidden', so in order to account for cases where this module checks for
        // visibility during prerendering, an additional check after prerendering
        // completes is also required.
        (0, $c7a41d5152be2585$export$26d3d892edc56833)('prerenderingchange', $3e2a3037c0664e80$var$onVisibilityUpdate, true);
    }
    return {
        get firstHiddenTime () {
            return $3e2a3037c0664e80$var$firstHiddenTime;
        },
        onHidden (cb) {
            $3e2a3037c0664e80$var$onHiddenFunctions.add(cb);
        }
    };
};
/**
 * Check if the page is hidden, uses the `pagehide` event for older browsers support that we used to have in `onHidden` function.
 * Some browsers we still support (Safari <14.4) don't fully support `visibilitychange`
 * or have known bugs w.r.t the `visibilitychange` event.
 * // TODO (v11): If we decide to drop support for Safari 14.4, we can use the logic from web-vitals 4.2.4
 */ function $3e2a3037c0664e80$var$isPageHidden(event) {
    return event.type === 'pagehide' || (0, $a279eed6bc86f03b$export$56d8a8a25bd48b81).document?.visibilityState === 'hidden';
}



/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Performantly generate a unique, 30-char string by combining a version
 * number, the current timestamp with a 13-digit number integer.
 * @return {string}
 */ const $801925fe485249d3$export$407ea409d1f3b539 = ()=>{
    return `v5-${Date.now()}-${Math.floor(Math.random() * (9e12 - 1)) + 1e12}`;
};




/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $f634b733a78aecc9$export$3c29b44508a0612b = (name, value = -1)=>{
    const navEntry = (0, $ced02df875855c4b$export$6431553786c94949)();
    let navigationType = 'navigate';
    if (navEntry) {
        if ((0, $a279eed6bc86f03b$export$56d8a8a25bd48b81).document?.prerendering || (0, $395b26100bb9afc9$export$d3e828b3c7b5b845)() > 0) navigationType = 'prerender';
        else if ((0, $a279eed6bc86f03b$export$56d8a8a25bd48b81).document?.wasDiscarded) navigationType = 'restore';
        else if (navEntry.type) navigationType = navEntry.type.replace(/_/g, '-');
    }
    // Use `entries` type specific for the metric.
    const entries = [];
    return {
        name: name,
        value: value,
        rating: 'good',
        delta: 0,
        entries: entries,
        id: (0, $801925fe485249d3$export$407ea409d1f3b539)(),
        navigationType: navigationType
    };
};


/*
 * Copyright 2024 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $562a47eb7944d4a2$var$instanceMap = new WeakMap();
/**
 * A function that accepts and identity object and a class object and returns
 * either a new instance of that class or an existing instance, if the
 * identity object was previously used.
 */ function $562a47eb7944d4a2$export$7c74c9b2462ddb3c(identityObj, ClassObj) {
    try {
        if (!$562a47eb7944d4a2$var$instanceMap.get(identityObj)) $562a47eb7944d4a2$var$instanceMap.set(identityObj, new ClassObj());
        return $562a47eb7944d4a2$var$instanceMap.get(identityObj);
    } catch (_e) {
        // --- START Sentry-custom code (try/catch wrapping) ---
        // Fix for cases where identityObj is not a valid key for WeakMap (sometimes a problem in Safari)
        // Just return a new instance without caching it in instanceMap
        return new ClassObj();
    }
// --- END Sentry-custom code ---
}


/* eslint-disable jsdoc/require-jsdoc */ /*
 * Copyright 2024 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $8b1c070dba404708$export$4050f7f955e19aa0 {
    constructor(){
        $8b1c070dba404708$export$4050f7f955e19aa0.prototype.__init.call(this);
        $8b1c070dba404708$export$4050f7f955e19aa0.prototype.__init2.call(this);
    }
    // eslint-disable-next-line @typescript-eslint/explicit-member-accessibility
    // oxlint-disable-next-line sdk/no-class-field-initializers
    __init() {
        this._sessionValue = 0;
    }
    // oxlint-disable-next-line sdk/no-class-field-initializers
    __init2() {
        this._sessionEntries = [];
    }
    // eslint-disable-next-line @typescript-eslint/explicit-member-accessibility
    _processEntry(entry) {
        // Only count layout shifts without recent user input.
        if (entry.hadRecentInput) return;
        const firstSessionEntry = this._sessionEntries[0];
        // This previously used `this._sessionEntries.at(-1)` but that is ES2022. We support ES2021 and earlier.
        const lastSessionEntry = this._sessionEntries[this._sessionEntries.length - 1];
        // If the entry occurred less than 1 second after the previous entry
        // and less than 5 seconds after the first entry in the session,
        // include the entry in the current session. Otherwise, start a new
        // session.
        if (this._sessionValue && firstSessionEntry && lastSessionEntry && entry.startTime - lastSessionEntry.startTime < 1000 && entry.startTime - firstSessionEntry.startTime < 5000) {
            this._sessionValue += entry.value;
            this._sessionEntries.push(entry);
        } else {
            this._sessionValue = entry.value;
            this._sessionEntries = [
                entry
            ];
        }
        this._onAfterProcessingUnexpectedShift?.(entry);
    }
}


/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Takes a performance entry type and a callback function, and creates a
 * `PerformanceObserver` instance that will observe the specified entry type
 * with buffering enabled and call the callback _for each entry_.
 *
 * This function also feature-detects entry support and wraps the logic in a
 * try/catch to avoid errors in unsupporting browsers.
 */ const $ecc8777a2b236759$export$d1203567a167490e = (type, callback, opts = {})=>{
    try {
        if (PerformanceObserver.supportedEntryTypes.includes(type)) {
            const po = new PerformanceObserver((list)=>{
                // Delay by a microtask to workaround a bug in Safari where the
                // callback is invoked immediately, rather than in a separate task.
                // See: https://github.com/GoogleChrome/web-vitals/issues/277
                // eslint-disable-next-line @typescript-eslint/no-floating-promises
                Promise.resolve().then(()=>{
                    callback(list.getEntries());
                });
            });
            po.observe({
                type: type,
                buffered: true,
                ...opts
            });
            return po;
        }
    } catch  {
    // Do nothing.
    }
    return;
};


/*
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $ca34144485b28b4e$export$b841d51e31c12bab = (cb)=>{
    let called = false;
    return ()=>{
        if (!called) {
            cb();
            called = true;
        }
    };
};








/*
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $16d35c41811bf47b$export$8bdb38a5671b594e = (callback)=>{
    if ((0, $a279eed6bc86f03b$export$56d8a8a25bd48b81).document?.prerendering) addEventListener('prerenderingchange', ()=>callback(), true);
    else callback();
};


/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Thresholds for FCP. See https://web.dev/articles/fcp#what_is_a_good_fcp_score */ const $4b951e2562932a74$export$e610c735b5510cec = [
    1800,
    3000
];
/**
 * Calculates the [FCP](https://web.dev/articles/fcp) value for the current page and
 * calls the `callback` function once the value is ready, along with the
 * relevant `paint` performance entry used to determine the value. The reported
 * value is a `DOMHighResTimeStamp`.
 */ const $4b951e2562932a74$export$fe3c86b74e15d5de = (onReport, opts = {})=>{
    (0, $16d35c41811bf47b$export$8bdb38a5671b594e)(()=>{
        const visibilityWatcher = (0, $3e2a3037c0664e80$export$443f86b2c77012c4)();
        const metric = (0, $f634b733a78aecc9$export$3c29b44508a0612b)('FCP');
        let report;
        const handleEntries = (entries)=>{
            for (const entry of entries)if (entry.name === 'first-contentful-paint') {
                po.disconnect();
                // Only report if the page wasn't hidden prior to the first paint.
                if (entry.startTime < visibilityWatcher.firstHiddenTime) {
                    // The activationStart reference is used because FCP should be
                    // relative to page activation rather than navigation start if the
                    // page was prerendered. But in cases where `activationStart` occurs
                    // after the FCP, this time should be clamped at 0.
                    metric.value = Math.max(entry.startTime - (0, $395b26100bb9afc9$export$d3e828b3c7b5b845)(), 0);
                    metric.entries.push(entry);
                    report(true);
                }
            }
        };
        const po = (0, $ecc8777a2b236759$export$d1203567a167490e)('paint', handleEntries);
        if (po) report = (0, $7e76489bb98b9510$export$17679dccdd551979)(onReport, metric, $4b951e2562932a74$export$e610c735b5510cec, opts.reportAllChanges);
    });
};


/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Thresholds for CLS. See https://web.dev/articles/cls#what_is_a_good_cls_score */ const $3b0ae498edf88447$export$3f20d8e089ac35b2 = [
    0.1,
    0.25
];
/**
 * Calculates the [CLS](https://web.dev/articles/cls) value for the current page and
 * calls the `callback` function once the value is ready to be reported, along
 * with all `layout-shift` performance entries that were used in the metric
 * value calculation. The reported value is a `double` (corresponding to a
 * [layout shift score](https://web.dev/articles/cls#layout_shift_score)).
 *
 * If the `reportAllChanges` configuration option is set to `true`, the
 * `callback` function will be called as soon as the value is initially
 * determined as well as any time the value changes throughout the page
 * lifespan.
 *
 * _**Important:** CLS should be continually monitored for changes throughout
 * the entire lifespan of a page—including if the user returns to the page after
 * it's been hidden/backgrounded. However, since browsers often [will not fire
 * additional callbacks once the user has backgrounded a
 * page](https://developer.chrome.com/blog/page-lifecycle-api/#advice-hidden),
 * `callback` is always called when the page's visibility state changes to
 * hidden. As a result, the `callback` function might be called multiple times
 * during the same page load._
 */ const $3b0ae498edf88447$export$a7873055838e5ad8 = (onReport, opts = {})=>{
    // Start monitoring FCP so we can only report CLS if FCP is also reported.
    // Note: this is done to match the current behavior of CrUX.
    (0, $4b951e2562932a74$export$fe3c86b74e15d5de)((0, $ca34144485b28b4e$export$b841d51e31c12bab)(()=>{
        const metric = (0, $f634b733a78aecc9$export$3c29b44508a0612b)('CLS', 0);
        let report;
        const visibilityWatcher = (0, $3e2a3037c0664e80$export$443f86b2c77012c4)();
        const layoutShiftManager = (0, $562a47eb7944d4a2$export$7c74c9b2462ddb3c)(opts, (0, $8b1c070dba404708$export$4050f7f955e19aa0));
        const handleEntries = (entries)=>{
            for (const entry of entries)layoutShiftManager._processEntry(entry);
            // If the current session value is larger than the current CLS value,
            // update CLS and the entries contributing to it.
            if (layoutShiftManager._sessionValue > metric.value) {
                metric.value = layoutShiftManager._sessionValue;
                metric.entries = layoutShiftManager._sessionEntries;
                report();
            }
        };
        const po = (0, $ecc8777a2b236759$export$d1203567a167490e)('layout-shift', handleEntries);
        if (po) {
            report = (0, $7e76489bb98b9510$export$17679dccdd551979)(onReport, metric, $3b0ae498edf88447$export$3f20d8e089ac35b2, opts.reportAllChanges);
            visibilityWatcher.onHidden(()=>{
                handleEntries(po.takeRecords());
                report(true);
            });
            // Queue a task to report (if nothing else triggers a report first).
            // This allows CLS to be reported as soon as FCP fires when
            // `reportAllChanges` is true.
            (0, $a279eed6bc86f03b$export$56d8a8a25bd48b81)?.setTimeout?.(report);
        }
    }));
};







/*
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ let $16638558ec8f8b88$var$interactionCountEstimate = 0;
let $16638558ec8f8b88$var$minKnownInteractionId = Infinity;
let $16638558ec8f8b88$var$maxKnownInteractionId = 0;
const $16638558ec8f8b88$var$updateEstimate = (entries)=>{
    entries.forEach((e)=>{
        if (e.interactionId) {
            $16638558ec8f8b88$var$minKnownInteractionId = Math.min($16638558ec8f8b88$var$minKnownInteractionId, e.interactionId);
            $16638558ec8f8b88$var$maxKnownInteractionId = Math.max($16638558ec8f8b88$var$maxKnownInteractionId, e.interactionId);
            $16638558ec8f8b88$var$interactionCountEstimate = $16638558ec8f8b88$var$maxKnownInteractionId ? ($16638558ec8f8b88$var$maxKnownInteractionId - $16638558ec8f8b88$var$minKnownInteractionId) / 7 + 1 : 0;
        }
    });
};
let $16638558ec8f8b88$var$po;
/**
 * Returns the `interactionCount` value using the native API (if available)
 * or the polyfill estimate in this module.
 */ const $16638558ec8f8b88$export$8a962f2683a476d1 = ()=>{
    return $16638558ec8f8b88$var$po ? $16638558ec8f8b88$var$interactionCountEstimate : performance.interactionCount || 0;
};
/**
 * Feature detects native support or initializes the polyfill if needed.
 */ const $16638558ec8f8b88$export$67d90cda6b78a2eb = ()=>{
    if ('interactionCount' in performance || $16638558ec8f8b88$var$po) return;
    $16638558ec8f8b88$var$po = (0, $ecc8777a2b236759$export$d1203567a167490e)('event', $16638558ec8f8b88$var$updateEstimate, {
        type: 'event',
        buffered: true,
        durationThreshold: 0
    });
};


/*
 * Copyright 2024 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // To prevent unnecessary memory usage on pages with lots of interactions,
// store at most 10 of the longest interactions to consider as INP candidates.
const $beb2e8960a7c7aff$var$MAX_INTERACTIONS_TO_CONSIDER = 10;
// Used to store the interaction count after a bfcache restore, since p98
// interaction latencies should only consider the current navigation.
let $beb2e8960a7c7aff$var$prevInteractionCount = 0;
/**
 * Returns the interaction count since the last bfcache restore (or for the
 * full page lifecycle if there were no bfcache restores).
 */ const $beb2e8960a7c7aff$var$getInteractionCountForNavigation = ()=>{
    return (0, $16638558ec8f8b88$export$8a962f2683a476d1)() - $beb2e8960a7c7aff$var$prevInteractionCount;
};
/**
 *
 */ class $beb2e8960a7c7aff$export$aaa80641d584351c {
    constructor(){
        $beb2e8960a7c7aff$export$aaa80641d584351c.prototype.__init.call(this);
        $beb2e8960a7c7aff$export$aaa80641d584351c.prototype.__init2.call(this);
    }
    /**
   * A list of longest interactions on the page (by latency) sorted so the
   * longest one is first. The list is at most MAX_INTERACTIONS_TO_CONSIDER
   * long.
   */ // oxlint-disable-next-line sdk/no-class-field-initializers
    __init() {
        this._longestInteractionList = [];
    }
    /**
   * A mapping of longest interactions by their interaction ID.
   * This is used for faster lookup.
   */ // oxlint-disable-next-line sdk/no-class-field-initializers
    __init2() {
        this._longestInteractionMap = new Map();
    }
    // eslint-disable-next-line @typescript-eslint/explicit-member-accessibility
    // eslint-disable-next-line @typescript-eslint/explicit-member-accessibility
    // eslint-disable-next-line @typescript-eslint/explicit-member-accessibility, jsdoc/require-jsdoc
    _resetInteractions() {
        $beb2e8960a7c7aff$var$prevInteractionCount = (0, $16638558ec8f8b88$export$8a962f2683a476d1)();
        this._longestInteractionList.length = 0;
        this._longestInteractionMap.clear();
    }
    /**
   * Returns the estimated p98 longest interaction based on the stored
   * interaction candidates and the interaction count for the current page.
   */ // eslint-disable-next-line @typescript-eslint/explicit-member-accessibility
    _estimateP98LongestInteraction() {
        const candidateInteractionIndex = Math.min(this._longestInteractionList.length - 1, Math.floor($beb2e8960a7c7aff$var$getInteractionCountForNavigation() / 50));
        return this._longestInteractionList[candidateInteractionIndex];
    }
    /**
   * Takes a performance entry and adds it to the list of worst interactions
   * if its duration is long enough to make it among the worst. If the
   * entry is part of an existing interaction, it is merged and the latency
   * and entries list is updated as needed.
   */ // eslint-disable-next-line @typescript-eslint/explicit-member-accessibility
    _processEntry(entry) {
        this._onBeforeProcessingEntry?.(entry);
        // Skip further processing for entries that cannot be INP candidates.
        if (!(entry.interactionId || entry.entryType === 'first-input')) return;
        // The least-long of the 10 longest interactions.
        const minLongestInteraction = this._longestInteractionList.at(-1);
        let interaction = this._longestInteractionMap.get(entry.interactionId);
        // Only process the entry if it's possibly one of the ten longest,
        // or if it's part of an existing interaction.
        if (interaction || this._longestInteractionList.length < $beb2e8960a7c7aff$var$MAX_INTERACTIONS_TO_CONSIDER || // If the above conditions are false, `minLongestInteraction` will be set.
        entry.duration > minLongestInteraction._latency) {
            // If the interaction already exists, update it. Otherwise create one.
            if (interaction) {
                // If the new entry has a longer duration, replace the old entries,
                // otherwise add to the array.
                if (entry.duration > interaction._latency) {
                    interaction.entries = [
                        entry
                    ];
                    interaction._latency = entry.duration;
                } else if (entry.duration === interaction._latency && entry.startTime === interaction.entries[0].startTime) interaction.entries.push(entry);
            } else {
                interaction = {
                    id: entry.interactionId,
                    entries: [
                        entry
                    ],
                    _latency: entry.duration
                };
                this._longestInteractionMap.set(interaction.id, interaction);
                this._longestInteractionList.push(interaction);
            }
            // Sort the entries by latency (descending) and keep only the top ten.
            this._longestInteractionList.sort((a, b)=>b._latency - a._latency);
            if (this._longestInteractionList.length > $beb2e8960a7c7aff$var$MAX_INTERACTIONS_TO_CONSIDER) {
                const removedInteractions = this._longestInteractionList.splice($beb2e8960a7c7aff$var$MAX_INTERACTIONS_TO_CONSIDER);
                for (const interaction of removedInteractions)this._longestInteractionMap.delete(interaction.id);
            }
            // Call any post-processing on the interaction
            this._onAfterProcessingINPCandidate?.(interaction);
        }
    }
}








/*
 * Copyright 2024 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Runs the passed callback during the next idle period, or immediately
 * if the browser's visibility state is (or becomes) hidden.
 */ const $4d5cffef49b632e0$export$d3314d5863fc1fef = (cb)=>{
    const rIC = (0, $a279eed6bc86f03b$export$56d8a8a25bd48b81).requestIdleCallback || (0, $a279eed6bc86f03b$export$56d8a8a25bd48b81).setTimeout;
    // If the document is hidden, run the callback immediately, otherwise
    // race an idle callback with the next `visibilitychange` event.
    if ((0, $a279eed6bc86f03b$export$56d8a8a25bd48b81).document?.visibilityState === 'hidden') cb();
    else {
        // eslint-disable-next-line no-param-reassign
        cb = (0, $ca34144485b28b4e$export$b841d51e31c12bab)(cb);
        (0, $c7a41d5152be2585$export$26d3d892edc56833)('visibilitychange', cb, {
            once: true,
            capture: true
        });
        // sentry: we use pagehide instead of directly listening to visibilitychange
        // because some browsers we still support (Safari <14.4) don't fully support
        // `visibilitychange` or have known bugs w.r.t the `visibilitychange` event.
        // TODO(v11): remove this once we drop support for Safari <14.4
        (0, $c7a41d5152be2585$export$26d3d892edc56833)('pagehide', cb, {
            once: true,
            capture: true
        });
        rIC(()=>{
            cb();
            // Remove the above event listener since no longer required.
            // See: https://github.com/GoogleChrome/web-vitals/issues/622
            (0, $c7a41d5152be2585$export$324d7b4b46528191)('visibilitychange', cb, {
                capture: true
            });
            // TODO(v11): remove this once we drop support for Safari <14.4
            (0, $c7a41d5152be2585$export$324d7b4b46528191)('pagehide', cb, {
                capture: true
            });
        });
    }
};


/*
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Thresholds for INP. See https://web.dev/articles/inp#what_is_a_good_inp_score */ const $11029ef4a3f15692$export$7f4cb060ded9173c = [
    200,
    500
];
// The default `durationThreshold` used across this library for observing
// `event` entries via PerformanceObserver.
const $11029ef4a3f15692$var$DEFAULT_DURATION_THRESHOLD = 40;
/**
 * Calculates the [INP](https://web.dev/articles/inp) value for the current
 * page and calls the `callback` function once the value is ready, along with
 * the `event` performance entries reported for that interaction. The reported
 * value is a `DOMHighResTimeStamp`.
 *
 * A custom `durationThreshold` configuration option can optionally be passed
 * to control what `event-timing` entries are considered for INP reporting. The
 * default threshold is `40`, which means INP scores of less than 40 will not
 * be reported. To avoid reporting no interactions in these cases, the library
 * will fall back to the input delay of the first interaction. Note that this
 * will not affect your 75th percentile INP value unless that value is also
 * less than 40 (well below the recommended
 * [good](https://web.dev/articles/inp#what_is_a_good_inp_score) threshold).
 *
 * If the `reportAllChanges` configuration option is set to `true`, the
 * `callback` function will be called as soon as the value is initially
 * determined as well as any time the value changes throughout the page
 * lifespan.
 *
 * _**Important:** INP should be continually monitored for changes throughout
 * the entire lifespan of a page—including if the user returns to the page after
 * it's been hidden/backgrounded. However, since browsers often [will not fire
 * additional callbacks once the user has backgrounded a
 * page](https://developer.chrome.com/blog/page-lifecycle-api/#advice-hidden),
 * `callback` is always called when the page's visibility state changes to
 * hidden. As a result, the `callback` function might be called multiple times
 * during the same page load._
 */ const $11029ef4a3f15692$export$7df4b36ecaed99e1 = (onReport, opts = {})=>{
    // Return if the browser doesn't support all APIs needed to measure INP.
    if (!(globalThis.PerformanceEventTiming && 'interactionId' in PerformanceEventTiming.prototype)) return;
    const visibilityWatcher = (0, $3e2a3037c0664e80$export$443f86b2c77012c4)();
    (0, $16d35c41811bf47b$export$8bdb38a5671b594e)(()=>{
        // TODO(philipwalton): remove once the polyfill is no longer needed.
        (0, $16638558ec8f8b88$export$67d90cda6b78a2eb)();
        const metric = (0, $f634b733a78aecc9$export$3c29b44508a0612b)('INP');
        // eslint-disable-next-line prefer-const
        let report;
        const interactionManager = (0, $562a47eb7944d4a2$export$7c74c9b2462ddb3c)(opts, (0, $beb2e8960a7c7aff$export$aaa80641d584351c));
        const handleEntries = (entries)=>{
            // Queue the `handleEntries()` callback in the next idle task.
            // This is needed to increase the chances that all event entries that
            // occurred between the user interaction and the next paint
            // have been dispatched. Note: there is currently an experiment
            // running in Chrome (EventTimingKeypressAndCompositionInteractionId)
            // 123+ that if rolled out fully may make this no longer necessary.
            (0, $4d5cffef49b632e0$export$d3314d5863fc1fef)(()=>{
                for (const entry of entries)interactionManager._processEntry(entry);
                const inp = interactionManager._estimateP98LongestInteraction();
                if (inp && inp._latency !== metric.value) {
                    metric.value = inp._latency;
                    metric.entries = inp.entries;
                    report();
                }
            });
        };
        const po = (0, $ecc8777a2b236759$export$d1203567a167490e)('event', handleEntries, {
            // Event Timing entries have their durations rounded to the nearest 8ms,
            // so a duration of 40ms would be any event that spans 2.5 or more frames
            // at 60Hz. This threshold is chosen to strike a balance between usefulness
            // and performance. Running this callback for any interaction that spans
            // just one or two frames is likely not worth the insight that could be
            // gained.
            durationThreshold: opts.durationThreshold ?? $11029ef4a3f15692$var$DEFAULT_DURATION_THRESHOLD
        });
        report = (0, $7e76489bb98b9510$export$17679dccdd551979)(onReport, metric, $11029ef4a3f15692$export$7f4cb060ded9173c, opts.reportAllChanges);
        if (po) {
            // Also observe entries of type `first-input`. This is useful in cases
            // where the first interaction is less than the `durationThreshold`.
            po.observe({
                type: 'first-input',
                buffered: true
            });
            visibilityWatcher.onHidden(()=>{
                handleEntries(po.takeRecords());
                report(true);
            });
        }
    });
};








/*
 * Copyright 2024 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // eslint-disable-next-line jsdoc/require-jsdoc
class $40d006a9c2aeabba$export$6a641ef2a067ec62 {
    // eslint-disable-next-line @typescript-eslint/explicit-member-accessibility
    // eslint-disable-next-line @typescript-eslint/explicit-member-accessibility, jsdoc/require-jsdoc
    _processEntry(entry) {
        this._onBeforeProcessingEntry?.(entry);
    }
}






/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Thresholds for LCP. See https://web.dev/articles/lcp#what_is_a_good_lcp_score */ const $d4b80976117d82a4$export$948521ca5b0e1b17 = [
    2500,
    4000
];
/**
 * Calculates the [LCP](https://web.dev/articles/lcp) value for the current page and
 * calls the `callback` function once the value is ready (along with the
 * relevant `largest-contentful-paint` performance entry used to determine the
 * value). The reported value is a `DOMHighResTimeStamp`.
 *
 * If the `reportAllChanges` configuration option is set to `true`, the
 * `callback` function will be called any time a new `largest-contentful-paint`
 * performance entry is dispatched, or once the final value of the metric has
 * been determined.
 */ const $d4b80976117d82a4$export$947b1626ab8d5632 = (onReport, opts = {})=>{
    (0, $16d35c41811bf47b$export$8bdb38a5671b594e)(()=>{
        const visibilityWatcher = (0, $3e2a3037c0664e80$export$443f86b2c77012c4)();
        const metric = (0, $f634b733a78aecc9$export$3c29b44508a0612b)('LCP');
        let report;
        const lcpEntryManager = (0, $562a47eb7944d4a2$export$7c74c9b2462ddb3c)(opts, (0, $40d006a9c2aeabba$export$6a641ef2a067ec62));
        const handleEntries = (entries)=>{
            // If reportAllChanges is set then call this function for each entry,
            // otherwise only consider the last one.
            if (!opts.reportAllChanges) // eslint-disable-next-line no-param-reassign
            entries = entries.slice(-1);
            for (const entry of entries){
                lcpEntryManager._processEntry(entry);
                // Only report if the page wasn't hidden prior to LCP.
                if (entry.startTime < visibilityWatcher.firstHiddenTime) {
                    // The startTime attribute returns the value of the renderTime if it is
                    // not 0, and the value of the loadTime otherwise. The activationStart
                    // reference is used because LCP should be relative to page activation
                    // rather than navigation start if the page was prerendered. But in cases
                    // where `activationStart` occurs after the LCP, this time should be
                    // clamped at 0.
                    metric.value = Math.max(entry.startTime - (0, $395b26100bb9afc9$export$d3e828b3c7b5b845)(), 0);
                    metric.entries = [
                        entry
                    ];
                    report();
                }
            }
        };
        const po = (0, $ecc8777a2b236759$export$d1203567a167490e)('largest-contentful-paint', handleEntries);
        if (po) {
            report = (0, $7e76489bb98b9510$export$17679dccdd551979)(onReport, metric, $d4b80976117d82a4$export$948521ca5b0e1b17, opts.reportAllChanges);
            // Ensure this logic only runs once, since it can be triggered from
            // any of three different event listeners below.
            const stopListening = (0, $ca34144485b28b4e$export$b841d51e31c12bab)(()=>{
                handleEntries(po.takeRecords());
                po.disconnect();
                report(true);
            });
            // Need a separate wrapper to ensure the `runOnce` function above is
            // common for all three functions
            const stopListeningWrapper = (event)=>{
                if (event.isTrusted) {
                    // Wrap the listener in an idle callback so it's run in a separate
                    // task to reduce potential INP impact.
                    // https://github.com/GoogleChrome/web-vitals/issues/383
                    (0, $4d5cffef49b632e0$export$d3314d5863fc1fef)(stopListening);
                    (0, $c7a41d5152be2585$export$324d7b4b46528191)(event.type, stopListeningWrapper, {
                        capture: true
                    });
                }
            };
            // Stop listening after input or visibilitychange.
            // Note: while scrolling is an input that stops LCP observation, it's
            // unreliable since it can be programmatically generated.
            // See: https://github.com/GoogleChrome/web-vitals/issues/75
            for (const type of [
                'keydown',
                'click',
                'visibilitychange'
            ])(0, $c7a41d5152be2585$export$26d3d892edc56833)(type, stopListeningWrapper, {
                capture: true
            });
        }
    });
};









/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Thresholds for TTFB. See https://web.dev/articles/ttfb#what_is_a_good_ttfb_score */ const $aed125f7fa85695b$export$65c59ea8064668fc = [
    800,
    1800
];
/**
 * Runs in the next task after the page is done loading and/or prerendering.
 * @param callback
 */ const $aed125f7fa85695b$var$whenReady = (callback)=>{
    if ((0, $a279eed6bc86f03b$export$56d8a8a25bd48b81).document?.prerendering) (0, $16d35c41811bf47b$export$8bdb38a5671b594e)(()=>$aed125f7fa85695b$var$whenReady(callback));
    else if ((0, $a279eed6bc86f03b$export$56d8a8a25bd48b81).document?.readyState !== 'complete') addEventListener('load', ()=>$aed125f7fa85695b$var$whenReady(callback), true);
    else // Queue a task so the callback runs after `loadEventEnd`.
    setTimeout(callback);
};
/**
 * Calculates the [TTFB](https://web.dev/articles/ttfb) value for the
 * current page and calls the `callback` function once the page has loaded,
 * along with the relevant `navigation` performance entry used to determine the
 * value. The reported value is a `DOMHighResTimeStamp`.
 *
 * Note, this function waits until after the page is loaded to call `callback`
 * in order to ensure all properties of the `navigation` entry are populated.
 * This is useful if you want to report on other metrics exposed by the
 * [Navigation Timing API](https://w3c.github.io/navigation-timing/). For
 * example, the TTFB metric starts from the page's [time
 * origin](https://www.w3.org/TR/hr-time-2/#sec-time-origin), which means it
 * includes time spent on DNS lookup, connection negotiation, network latency,
 * and server processing time.
 */ const $aed125f7fa85695b$export$33a01e6c5f2c7e33 = (onReport, opts = {})=>{
    const metric = (0, $f634b733a78aecc9$export$3c29b44508a0612b)('TTFB');
    const report = (0, $7e76489bb98b9510$export$17679dccdd551979)(onReport, metric, $aed125f7fa85695b$export$65c59ea8064668fc, opts.reportAllChanges);
    $aed125f7fa85695b$var$whenReady(()=>{
        const navigationEntry = (0, $ced02df875855c4b$export$6431553786c94949)();
        if (navigationEntry) {
            // The activationStart reference is used because TTFB should be
            // relative to page activation rather than navigation start if the
            // page was prerendered. But in cases where `activationStart` occurs
            // after the first byte is received, this time should be clamped at 0.
            metric.value = Math.max(navigationEntry.responseStart - (0, $395b26100bb9afc9$export$d3e828b3c7b5b845)(), 0);
            metric.entries = [
                navigationEntry
            ];
            report(true);
        }
    });
};


const $f28dee024a5f97b7$var$handlers = {};
const $f28dee024a5f97b7$var$instrumented = {};
let $f28dee024a5f97b7$var$_previousCls;
let $f28dee024a5f97b7$var$_previousLcp;
let $f28dee024a5f97b7$var$_previousTtfb;
let $f28dee024a5f97b7$var$_previousInp;
/**
 * Add a callback that will be triggered when a CLS metric is available.
 * Returns a cleanup callback which can be called to remove the instrumentation handler.
 *
 * Pass `stopOnCallback = true` to stop listening for CLS when the cleanup callback is called.
 * This will lead to the CLS being finalized and frozen.
 */ function $f28dee024a5f97b7$export$861b82818b37ba5b(callback, stopOnCallback = false) {
    return $f28dee024a5f97b7$var$addMetricObserver('cls', callback, $f28dee024a5f97b7$var$instrumentCls, $f28dee024a5f97b7$var$_previousCls, stopOnCallback);
}
/**
 * Add a callback that will be triggered when a LCP metric is available.
 * Returns a cleanup callback which can be called to remove the instrumentation handler.
 *
 * Pass `stopOnCallback = true` to stop listening for LCP when the cleanup callback is called.
 * This will lead to the LCP being finalized and frozen.
 */ function $f28dee024a5f97b7$export$3fd4b53331200102(callback, stopOnCallback = false) {
    return $f28dee024a5f97b7$var$addMetricObserver('lcp', callback, $f28dee024a5f97b7$var$instrumentLcp, $f28dee024a5f97b7$var$_previousLcp, stopOnCallback);
}
/**
 * Add a callback that will be triggered when a TTFD metric is available.
 */ function $f28dee024a5f97b7$export$699d9529c099a797(callback) {
    return $f28dee024a5f97b7$var$addMetricObserver('ttfb', callback, $f28dee024a5f97b7$var$instrumentTtfb, $f28dee024a5f97b7$var$_previousTtfb);
}
/**
 * Add a callback that will be triggered when a INP metric is available.
 * Returns a cleanup callback which can be called to remove the instrumentation handler.
 */ function $f28dee024a5f97b7$export$da3b76aa2022cbd7(callback) {
    return $f28dee024a5f97b7$var$addMetricObserver('inp', callback, $f28dee024a5f97b7$var$instrumentInp, $f28dee024a5f97b7$var$_previousInp);
}
/**
 * Add a callback that will be triggered when a performance observer is triggered,
 * and receives the entries of the observer.
 * Returns a cleanup callback which can be called to remove the instrumentation handler.
 */ function $f28dee024a5f97b7$export$69816c1a049f8db6(type, callback) {
    $f28dee024a5f97b7$var$addHandler(type, callback);
    if (!$f28dee024a5f97b7$var$instrumented[type]) {
        $f28dee024a5f97b7$var$instrumentPerformanceObserver(type);
        $f28dee024a5f97b7$var$instrumented[type] = true;
    }
    return $f28dee024a5f97b7$var$getCleanupCallback(type, callback);
}
/** Trigger all handlers of a given type. */ function $f28dee024a5f97b7$var$triggerHandlers(type, data) {
    const typeHandlers = $f28dee024a5f97b7$var$handlers[type];
    if (!typeHandlers?.length) return;
    for (const handler of typeHandlers)try {
        handler(data);
    } catch (e) {
        (0, $52f4069f580f537e$export$16a28057038b10ef) && (0, $d11ed0b3cdda6b8d$export$1c9f709888824e05).error(`Error while triggering instrumentation handler.\nType: ${type}\nName: ${(0, $9ed2cf4edd0b2db9$export$aad197c7121a6651)(handler)}\nError:`, e);
    }
}
function $f28dee024a5f97b7$var$instrumentCls() {
    return (0, $3b0ae498edf88447$export$a7873055838e5ad8)((metric)=>{
        $f28dee024a5f97b7$var$triggerHandlers('cls', {
            metric: metric
        });
        $f28dee024a5f97b7$var$_previousCls = metric;
    }, // We want the callback to be called whenever the CLS value updates.
    // By default, the callback is only called when the tab goes to the background.
    {
        reportAllChanges: true
    });
}
function $f28dee024a5f97b7$var$instrumentLcp() {
    return (0, $d4b80976117d82a4$export$947b1626ab8d5632)((metric)=>{
        $f28dee024a5f97b7$var$triggerHandlers('lcp', {
            metric: metric
        });
        $f28dee024a5f97b7$var$_previousLcp = metric;
    }, // We want the callback to be called whenever the LCP value updates.
    // By default, the callback is only called when the tab goes to the background.
    {
        reportAllChanges: true
    });
}
function $f28dee024a5f97b7$var$instrumentTtfb() {
    return (0, $aed125f7fa85695b$export$33a01e6c5f2c7e33)((metric)=>{
        $f28dee024a5f97b7$var$triggerHandlers('ttfb', {
            metric: metric
        });
        $f28dee024a5f97b7$var$_previousTtfb = metric;
    });
}
function $f28dee024a5f97b7$var$instrumentInp() {
    return (0, $11029ef4a3f15692$export$7df4b36ecaed99e1)((metric)=>{
        $f28dee024a5f97b7$var$triggerHandlers('inp', {
            metric: metric
        });
        $f28dee024a5f97b7$var$_previousInp = metric;
    });
}
function $f28dee024a5f97b7$var$addMetricObserver(type, callback, instrumentFn, previousValue, stopOnCallback = false) {
    $f28dee024a5f97b7$var$addHandler(type, callback);
    let stopListening;
    if (!$f28dee024a5f97b7$var$instrumented[type]) {
        stopListening = instrumentFn();
        $f28dee024a5f97b7$var$instrumented[type] = true;
    }
    if (previousValue) callback({
        metric: previousValue
    });
    return $f28dee024a5f97b7$var$getCleanupCallback(type, callback, stopOnCallback ? stopListening : undefined);
}
function $f28dee024a5f97b7$var$instrumentPerformanceObserver(type) {
    const options = {};
    // Special per-type options we want to use
    if (type === 'event') options.durationThreshold = 0;
    (0, $ecc8777a2b236759$export$d1203567a167490e)(type, (entries)=>{
        $f28dee024a5f97b7$var$triggerHandlers(type, {
            entries: entries
        });
    }, options);
}
function $f28dee024a5f97b7$var$addHandler(type, handler) {
    $f28dee024a5f97b7$var$handlers[type] = $f28dee024a5f97b7$var$handlers[type] || [];
    $f28dee024a5f97b7$var$handlers[type].push(handler);
}
// Get a callback which can be called to remove the instrumentation handler
function $f28dee024a5f97b7$var$getCleanupCallback(type, callback, stopListening) {
    return ()=>{
        if (stopListening) stopListening();
        const typeHandlers = $f28dee024a5f97b7$var$handlers[type];
        if (!typeHandlers) return;
        const index = typeHandlers.indexOf(callback);
        if (index !== -1) typeHandlers.splice(index, 1);
    };
}
/**
 * Check if a PerformanceEntry is a PerformanceEventTiming by checking for the `duration` property.
 */ function $f28dee024a5f97b7$export$7affb50b622d8714(entry) {
    return 'duration' in entry;
}


// exporting a separate copy of `WINDOW` rather than exporting the one from `@sentry/browser`
// prevents the browser package from being bundled in the CDN bundle, and avoids a
// circular dependency between the browser and replay packages should `@sentry/browser` import
// from `@sentry/replay` in the future
const $604631306887a81e$var$WINDOW = (0, $736a69486c86d36c$export$f1a6cdb1459e81d1);
const $604631306887a81e$var$REPLAY_SESSION_KEY = 'sentryReplaySession';
const $604631306887a81e$var$REPLAY_EVENT_NAME = 'replay_event';
const $604631306887a81e$var$UNABLE_TO_SEND_REPLAY = 'Unable to send Replay';
// The idle limit for a session after which recording is paused.
const $604631306887a81e$var$SESSION_IDLE_PAUSE_DURATION = 300000; // 5 minutes in ms
// The idle limit for a session after which the session expires.
const $604631306887a81e$var$SESSION_IDLE_EXPIRE_DURATION = 900000; // 15 minutes in ms
/** Default flush delays */ const $604631306887a81e$var$DEFAULT_FLUSH_MIN_DELAY = 5000;
// XXX: Temp fix for our debounce logic where `maxWait` would never occur if it
// was the same as `wait`
const $604631306887a81e$var$DEFAULT_FLUSH_MAX_DELAY = 5500;
/* How long to wait for error checkouts */ const $604631306887a81e$var$BUFFER_CHECKOUT_TIME = 60000;
const $604631306887a81e$var$RETRY_BASE_INTERVAL = 5000;
const $604631306887a81e$var$RETRY_MAX_COUNT = 3;
/* The max (uncompressed) size in bytes of a network body. Any body larger than this will be truncated. */ const $604631306887a81e$var$NETWORK_BODY_MAX_SIZE = 150000;
/* The max size of a single console arg that is captured. Any arg larger than this will be truncated. */ const $604631306887a81e$var$CONSOLE_ARG_MAX_SIZE = 5000;
/* Min. time to wait before we consider something a slow click. */ const $604631306887a81e$var$SLOW_CLICK_THRESHOLD = 3000;
/* For scroll actions after a click, we only look for a very short time period to detect programmatic scrolling. */ const $604631306887a81e$var$SLOW_CLICK_SCROLL_TIMEOUT = 300;
/** When encountering a total segment size exceeding this size, stop the replay (as we cannot properly ingest it). */ const $604631306887a81e$var$REPLAY_MAX_EVENT_BUFFER_SIZE = 20000000; // ~20MB
/** Replays must be min. 5s long before we send them. */ const $604631306887a81e$var$MIN_REPLAY_DURATION = 4999;
/*
The max. allowed value that the minReplayDuration can be set to.
This needs to be below 60s, so we don't unintentionally drop buffered replays that are longer than 60s.
*/ const $604631306887a81e$var$MIN_REPLAY_DURATION_LIMIT = 50000;
/** The max. length of a replay. */ const $604631306887a81e$var$MAX_REPLAY_DURATION = 3600000; // 60 minutes in ms;
var $604631306887a81e$var$__defProp$1 = Object.defineProperty;
var $604631306887a81e$var$__defNormalProp$1 = (obj, key, value)=>key in obj ? $604631306887a81e$var$__defProp$1(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $604631306887a81e$var$__publicField$1 = (obj, key, value)=>$604631306887a81e$var$__defNormalProp$1(obj, typeof key !== "symbol" ? key + "" : key, value);
var $604631306887a81e$var$NodeType$2 = /* @__PURE__ */ ((NodeType2)=>{
    NodeType2[NodeType2["Document"] = 0] = "Document";
    NodeType2[NodeType2["DocumentType"] = 1] = "DocumentType";
    NodeType2[NodeType2["Element"] = 2] = "Element";
    NodeType2[NodeType2["Text"] = 3] = "Text";
    NodeType2[NodeType2["CDATA"] = 4] = "CDATA";
    NodeType2[NodeType2["Comment"] = 5] = "Comment";
    return NodeType2;
})($604631306887a81e$var$NodeType$2 || {});
function $604631306887a81e$var$isElement$1(n2) {
    return n2.nodeType === n2.ELEMENT_NODE;
}
function $604631306887a81e$var$isShadowRoot(n2) {
    const host = n2?.host;
    return Boolean(host?.shadowRoot === n2);
}
function $604631306887a81e$var$isNativeShadowDom(shadowRoot) {
    return Object.prototype.toString.call(shadowRoot) === "[object ShadowRoot]";
}
function $604631306887a81e$var$fixBrowserCompatibilityIssuesInCSS(cssText) {
    if (cssText.includes(" background-clip: text;") && !cssText.includes(" -webkit-background-clip: text;")) cssText = cssText.replace(/\sbackground-clip:\s*text;/g, " -webkit-background-clip: text; background-clip: text;");
    return cssText;
}
function $604631306887a81e$var$escapeImportStatement(rule) {
    const { cssText: cssText } = rule;
    if (cssText.split('"').length < 3) return cssText;
    const statement = [
        "@import",
        `url(${JSON.stringify(rule.href)})`
    ];
    if (rule.layerName === "") statement.push(`layer`);
    else if (rule.layerName) statement.push(`layer(${rule.layerName})`);
    if (rule.supportsText) statement.push(`supports(${rule.supportsText})`);
    if (rule.media.length) statement.push(rule.media.mediaText);
    return statement.join(" ") + ";";
}
function $604631306887a81e$var$stringifyStylesheet(s2) {
    try {
        const rules2 = s2.rules || s2.cssRules;
        return rules2 ? $604631306887a81e$var$fixBrowserCompatibilityIssuesInCSS(Array.from(rules2, $604631306887a81e$var$stringifyRule).join("")) : null;
    } catch (error) {
        return null;
    }
}
function $604631306887a81e$var$fixAllCssProperty(rule) {
    let styles = "";
    for(let i2 = 0; i2 < rule.style.length; i2++){
        const styleDeclaration = rule.style;
        const attribute = styleDeclaration[i2];
        const isImportant = styleDeclaration.getPropertyPriority(attribute);
        styles += `${attribute}:${styleDeclaration.getPropertyValue(attribute)}${isImportant ? ` !important` : ""};`;
    }
    return `${rule.selectorText} { ${styles} }`;
}
function $604631306887a81e$var$stringifyRule(rule) {
    let importStringified;
    if ($604631306887a81e$var$isCSSImportRule(rule)) try {
        importStringified = // we can access the imported stylesheet rules directly
        $604631306887a81e$var$stringifyStylesheet(rule.styleSheet) || // work around browser issues with the raw string `@import url(...)` statement
        $604631306887a81e$var$escapeImportStatement(rule);
    } catch (error) {}
    else if ($604631306887a81e$var$isCSSStyleRule(rule)) {
        let cssText = rule.cssText;
        const needsSafariColonFix = rule.selectorText.includes(":");
        const needsAllFix = typeof rule.style["all"] === "string" && rule.style["all"];
        if (needsAllFix) cssText = $604631306887a81e$var$fixAllCssProperty(rule);
        if (needsSafariColonFix) cssText = $604631306887a81e$var$fixSafariColons(cssText);
        if (needsSafariColonFix || needsAllFix) return cssText;
    }
    return importStringified || rule.cssText;
}
function $604631306887a81e$var$fixSafariColons(cssStringified) {
    const regex = /(\[(?:[\w-]+)[^\\])(:(?:[\w-]+)\])/gm;
    return cssStringified.replace(regex, "$1\\$2");
}
function $604631306887a81e$var$isCSSImportRule(rule) {
    return "styleSheet" in rule;
}
function $604631306887a81e$var$isCSSStyleRule(rule) {
    return "selectorText" in rule;
}
class $604631306887a81e$var$Mirror {
    constructor(){
        $604631306887a81e$var$__publicField$1(this, "idNodeMap", /* @__PURE__ */ new Map());
        $604631306887a81e$var$__publicField$1(this, "nodeMetaMap", /* @__PURE__ */ new WeakMap());
    }
    getId(n2) {
        if (!n2) return -1;
        const id = this.getMeta(n2)?.id;
        return id ?? -1;
    }
    getNode(id) {
        return this.idNodeMap.get(id) || null;
    }
    getIds() {
        return Array.from(this.idNodeMap.keys());
    }
    getMeta(n2) {
        return this.nodeMetaMap.get(n2) || null;
    }
    // removes the node from idNodeMap
    // doesn't remove the node from nodeMetaMap
    removeNodeFromMap(n2) {
        const id = this.getId(n2);
        this.idNodeMap.delete(id);
        if (n2.childNodes) n2.childNodes.forEach((childNode)=>this.removeNodeFromMap(childNode));
    }
    has(id) {
        return this.idNodeMap.has(id);
    }
    hasNode(node) {
        return this.nodeMetaMap.has(node);
    }
    add(n2, meta) {
        const id = meta.id;
        this.idNodeMap.set(id, n2);
        this.nodeMetaMap.set(n2, meta);
    }
    replace(id, n2) {
        const oldNode = this.getNode(id);
        if (oldNode) {
            const meta = this.nodeMetaMap.get(oldNode);
            if (meta) this.nodeMetaMap.set(n2, meta);
        }
        this.idNodeMap.set(id, n2);
    }
    reset() {
        this.idNodeMap = /* @__PURE__ */ new Map();
        this.nodeMetaMap = /* @__PURE__ */ new WeakMap();
    }
}
function $604631306887a81e$var$createMirror$2() {
    return new $604631306887a81e$var$Mirror();
}
function $604631306887a81e$var$shouldMaskInput({ maskInputOptions: maskInputOptions, tagName: tagName, type: type }) {
    if (tagName === "OPTION") tagName = "SELECT";
    return Boolean(maskInputOptions[tagName.toLowerCase()] || type && maskInputOptions[type] || type === "password" || // Default to "text" option for inputs without a "type" attribute defined
    tagName === "INPUT" && !type && maskInputOptions["text"]);
}
function $604631306887a81e$var$maskInputValue({ isMasked: isMasked, element: element, value: value, maskInputFn: maskInputFn }) {
    let text = value || "";
    if (!isMasked) return text;
    if (maskInputFn) text = maskInputFn(text, element);
    return "*".repeat(text.length);
}
function $604631306887a81e$var$toLowerCase(str) {
    return str.toLowerCase();
}
function $604631306887a81e$var$toUpperCase(str) {
    return str.toUpperCase();
}
const $604631306887a81e$var$ORIGINAL_ATTRIBUTE_NAME = "__rrweb_original__";
function $604631306887a81e$var$is2DCanvasBlank(canvas) {
    const ctx = canvas.getContext("2d");
    if (!ctx) return true;
    const chunkSize = 50;
    for(let x = 0; x < canvas.width; x += chunkSize)for(let y = 0; y < canvas.height; y += chunkSize){
        const getImageData = ctx.getImageData;
        const originalGetImageData = $604631306887a81e$var$ORIGINAL_ATTRIBUTE_NAME in getImageData ? getImageData[$604631306887a81e$var$ORIGINAL_ATTRIBUTE_NAME] : getImageData;
        const pixelBuffer = new Uint32Array(// eslint-disable-next-line @typescript-eslint/no-unsafe-argument, @typescript-eslint/no-unsafe-member-access
        originalGetImageData.call(ctx, x, y, Math.min(chunkSize, canvas.width - x), Math.min(chunkSize, canvas.height - y)).data.buffer);
        if (pixelBuffer.some((pixel)=>pixel !== 0)) return false;
    }
    return true;
}
function $604631306887a81e$var$getInputType(element) {
    const type = element.type;
    return element.hasAttribute("data-rr-is-password") ? "password" : type ? // eslint-disable-next-line @typescript-eslint/no-unnecessary-type-assertion
    $604631306887a81e$var$toLowerCase(type) : null;
}
function $604631306887a81e$var$getInputValue(el, tagName, type) {
    if (tagName === "INPUT" && (type === "radio" || type === "checkbox")) return el.getAttribute("value") || "";
    return el.value;
}
function $604631306887a81e$var$extractFileExtension(path, baseURL) {
    let url;
    try {
        url = new URL(path, baseURL ?? window.location.href);
    } catch (err) {
        return null;
    }
    const regex = /\.([0-9a-z]+)(?:$)/i;
    const match = url.pathname.match(regex);
    return match?.[1] ?? null;
}
const $604631306887a81e$var$cachedImplementations$1 = {};
function $604631306887a81e$var$getImplementation$1(name) {
    const cached = $604631306887a81e$var$cachedImplementations$1[name];
    if (cached) return cached;
    const document2 = window.document;
    let impl = window[name];
    if (document2 && typeof document2.createElement === "function") try {
        const sandbox = document2.createElement("iframe");
        sandbox.hidden = true;
        document2.head.appendChild(sandbox);
        const contentWindow = sandbox.contentWindow;
        if (contentWindow && contentWindow[name]) impl = contentWindow[name];
        document2.head.removeChild(sandbox);
    } catch (e2) {}
    return $604631306887a81e$var$cachedImplementations$1[name] = impl.bind(window);
}
function $604631306887a81e$var$setTimeout$2(...rest) {
    return $604631306887a81e$var$getImplementation$1("setTimeout")(...rest);
}
function $604631306887a81e$var$clearTimeout$1(...rest) {
    return $604631306887a81e$var$getImplementation$1("clearTimeout")(...rest);
}
function $604631306887a81e$var$getIframeContentDocument(iframe) {
    try {
        return iframe.contentDocument;
    } catch (e2) {}
}
let $604631306887a81e$var$_id = 1;
const $604631306887a81e$var$tagNameRegex = new RegExp("[^a-z0-9-_:]");
const $604631306887a81e$var$IGNORED_NODE = -2;
function $604631306887a81e$var$genId() {
    return $604631306887a81e$var$_id++;
}
function $604631306887a81e$var$getValidTagName$1(element) {
    if (element instanceof HTMLFormElement) return "form";
    const processedTagName = $604631306887a81e$var$toLowerCase(element.tagName);
    if ($604631306887a81e$var$tagNameRegex.test(processedTagName)) return "div";
    return processedTagName;
}
function $604631306887a81e$var$extractOrigin(url) {
    let origin = "";
    if (url.indexOf("//") > -1) origin = url.split("/").slice(0, 3).join("/");
    else origin = url.split("/")[0];
    origin = origin.split("?")[0];
    return origin;
}
let $604631306887a81e$var$canvasService;
let $604631306887a81e$var$canvasCtx;
const $604631306887a81e$var$URL_IN_CSS_REF = /url\((?:(')([^']*)'|(")(.*?)"|([^)]*))\)/gm;
const $604631306887a81e$var$URL_PROTOCOL_MATCH = /^(?:[a-z+]+:)?\/\//i;
const $604631306887a81e$var$URL_WWW_MATCH = /^www\..*/i;
const $604631306887a81e$var$DATA_URI = /^(data:)([^,]*),(.*)/i;
function $604631306887a81e$var$filterCSSPropertiesFromInlineStyle(cssText, ignoredProperties) {
    if (!cssText || ignoredProperties.size === 0) return cssText;
    try {
        const properties = cssText.split(";");
        const filteredProperties = [];
        for (let property of properties){
            property = property.trim();
            if (!property) continue;
            const colonIndex = property.indexOf(":");
            if (colonIndex === -1) {
                filteredProperties.push(property);
                continue;
            }
            const propertyName = property.slice(0, colonIndex).trim();
            if (!ignoredProperties.has(propertyName)) filteredProperties.push(property);
        }
        return filteredProperties.join("; ") + (filteredProperties.length > 0 && cssText.endsWith(";") ? ";" : "");
    } catch (error) {
        console.warn("Error filtering CSS properties:", error);
        return cssText;
    }
}
function $604631306887a81e$var$absoluteToStylesheet(cssText, href) {
    return (cssText || "").replace($604631306887a81e$var$URL_IN_CSS_REF, (origin, quote1, path1, quote2, path2, path3)=>{
        const filePath = path1 || path2 || path3;
        const maybeQuote = quote1 || quote2 || "";
        if (!filePath) return origin;
        if ($604631306887a81e$var$URL_PROTOCOL_MATCH.test(filePath) || $604631306887a81e$var$URL_WWW_MATCH.test(filePath)) return `url(${maybeQuote}${filePath}${maybeQuote})`;
        if ($604631306887a81e$var$DATA_URI.test(filePath)) return `url(${maybeQuote}${filePath}${maybeQuote})`;
        if (filePath[0] === "/") return `url(${maybeQuote}${$604631306887a81e$var$extractOrigin(href) + filePath}${maybeQuote})`;
        const stack = href.split("/");
        const parts = filePath.split("/");
        stack.pop();
        for (const part of parts){
            if (part === ".") continue;
            else if (part === "..") stack.pop();
            else stack.push(part);
        }
        return `url(${maybeQuote}${stack.join("/")}${maybeQuote})`;
    });
}
const $604631306887a81e$var$SRCSET_NOT_SPACES = /^[^ \t\n\r\u000c]+/;
const $604631306887a81e$var$SRCSET_COMMAS_OR_SPACES = /^[, \t\n\r\u000c]+/;
function $604631306887a81e$var$getAbsoluteSrcsetString(doc, attributeValue) {
    if (attributeValue.trim() === "") return attributeValue;
    let pos = 0;
    function collectCharacters(regEx) {
        let chars2;
        const match = regEx.exec(attributeValue.substring(pos));
        if (match) {
            chars2 = match[0];
            pos += chars2.length;
            return chars2;
        }
        return "";
    }
    const output = [];
    while(true){
        collectCharacters($604631306887a81e$var$SRCSET_COMMAS_OR_SPACES);
        if (pos >= attributeValue.length) break;
        let url = collectCharacters($604631306887a81e$var$SRCSET_NOT_SPACES);
        if (url.slice(-1) === ",") {
            url = $604631306887a81e$var$absoluteToDoc(doc, url.substring(0, url.length - 1));
            output.push(url);
        } else {
            let descriptorsStr = "";
            url = $604631306887a81e$var$absoluteToDoc(doc, url);
            let inParens = false;
            while(true){
                const c2 = attributeValue.charAt(pos);
                if (c2 === "") {
                    output.push((url + descriptorsStr).trim());
                    break;
                } else if (!inParens) {
                    if (c2 === ",") {
                        pos += 1;
                        output.push((url + descriptorsStr).trim());
                        break;
                    } else if (c2 === "(") inParens = true;
                } else if (c2 === ")") inParens = false;
                descriptorsStr += c2;
                pos += 1;
            }
        }
    }
    return output.join(", ");
}
const $604631306887a81e$var$cachedDocument = /* @__PURE__ */ new WeakMap();
function $604631306887a81e$var$absoluteToDoc(doc, attributeValue) {
    if (!attributeValue || attributeValue.trim() === "") return attributeValue;
    return $604631306887a81e$var$getHref(doc, attributeValue);
}
function $604631306887a81e$var$isSVGElement(el) {
    return Boolean(el.tagName === "svg" || el.ownerSVGElement);
}
function $604631306887a81e$var$getHref(doc, customHref) {
    let a2 = $604631306887a81e$var$cachedDocument.get(doc);
    if (!a2) {
        a2 = doc.createElement("a");
        $604631306887a81e$var$cachedDocument.set(doc, a2);
    }
    if (!customHref) customHref = "";
    else if (customHref.startsWith("blob:") || customHref.startsWith("data:")) return customHref;
    a2.setAttribute("href", customHref);
    return a2.href;
}
function $604631306887a81e$var$transformAttribute(doc, tagName, name, value, element, maskAttributeFn, ignoreCSSAttributes) {
    if (!value) return value;
    if (name === "src" || name === "href" && !(tagName === "use" && value[0] === "#")) return $604631306887a81e$var$absoluteToDoc(doc, value);
    else if (name === "xlink:href" && value[0] !== "#") return $604631306887a81e$var$absoluteToDoc(doc, value);
    else if (name === "background" && (tagName === "table" || tagName === "td" || tagName === "th")) return $604631306887a81e$var$absoluteToDoc(doc, value);
    else if (name === "srcset") return $604631306887a81e$var$getAbsoluteSrcsetString(doc, value);
    else if (name === "style") {
        let processedStyle = $604631306887a81e$var$absoluteToStylesheet(value, $604631306887a81e$var$getHref(doc));
        if (ignoreCSSAttributes && ignoreCSSAttributes.size > 0) processedStyle = $604631306887a81e$var$filterCSSPropertiesFromInlineStyle(processedStyle, ignoreCSSAttributes);
        return processedStyle;
    } else if (tagName === "object" && name === "data") return $604631306887a81e$var$absoluteToDoc(doc, value);
    if (typeof maskAttributeFn === "function") return maskAttributeFn(name, value, element);
    return value;
}
function $604631306887a81e$var$ignoreAttribute(tagName, name, _value) {
    return (tagName === "video" || tagName === "audio") && name === "autoplay";
}
function $604631306887a81e$var$_isBlockedElement(element, blockClass, blockSelector, unblockSelector) {
    try {
        if (unblockSelector && element.matches(unblockSelector)) return false;
        if (typeof blockClass === "string") {
            if (element.classList.contains(blockClass)) return true;
        } else for(let eIndex = element.classList.length; eIndex--;){
            const className = element.classList[eIndex];
            if (blockClass.test(className)) return true;
        }
        if (blockSelector) return element.matches(blockSelector);
    } catch (e2) {}
    return false;
}
function $604631306887a81e$var$elementClassMatchesRegex(el, regex) {
    for(let eIndex = el.classList.length; eIndex--;){
        const className = el.classList[eIndex];
        if (regex.test(className)) return true;
    }
    return false;
}
function $604631306887a81e$var$distanceToMatch(node, matchPredicate, limit = Infinity, distance = 0) {
    if (!node) return -1;
    if (node.nodeType !== node.ELEMENT_NODE) return -1;
    if (distance > limit) return -1;
    if (matchPredicate(node)) return distance;
    return $604631306887a81e$var$distanceToMatch(node.parentNode, matchPredicate, limit, distance + 1);
}
function $604631306887a81e$var$createMatchPredicate(className, selector) {
    return (node)=>{
        const el = node;
        if (el === null) return false;
        try {
            if (className) {
                if (typeof className === "string") {
                    if (el.matches(`.${className}`)) return true;
                } else if ($604631306887a81e$var$elementClassMatchesRegex(el, className)) return true;
            }
            if (selector && el.matches(selector)) return true;
            return false;
        } catch  {
            return false;
        }
    };
}
function $604631306887a81e$var$needMaskingText(node, maskTextClass, maskTextSelector, unmaskTextClass, unmaskTextSelector, maskAllText) {
    try {
        const el = node.nodeType === node.ELEMENT_NODE ? node : node.parentElement;
        if (el === null) return false;
        if (el.tagName === "INPUT") {
            const autocomplete = el.getAttribute("autocomplete");
            const disallowedAutocompleteValues = [
                "current-password",
                "new-password",
                "cc-number",
                "cc-exp",
                "cc-exp-month",
                "cc-exp-year",
                "cc-csc"
            ];
            if (disallowedAutocompleteValues.includes(autocomplete)) return true;
        }
        let maskDistance = -1;
        let unmaskDistance = -1;
        if (maskAllText) {
            unmaskDistance = $604631306887a81e$var$distanceToMatch(el, $604631306887a81e$var$createMatchPredicate(unmaskTextClass, unmaskTextSelector));
            if (unmaskDistance < 0) return true;
            maskDistance = $604631306887a81e$var$distanceToMatch(el, $604631306887a81e$var$createMatchPredicate(maskTextClass, maskTextSelector), unmaskDistance >= 0 ? unmaskDistance : Infinity);
        } else {
            maskDistance = $604631306887a81e$var$distanceToMatch(el, $604631306887a81e$var$createMatchPredicate(maskTextClass, maskTextSelector));
            if (maskDistance < 0) return false;
            unmaskDistance = $604631306887a81e$var$distanceToMatch(el, $604631306887a81e$var$createMatchPredicate(unmaskTextClass, unmaskTextSelector), maskDistance >= 0 ? maskDistance : Infinity);
        }
        return maskDistance >= 0 ? unmaskDistance >= 0 ? maskDistance <= unmaskDistance : true : unmaskDistance >= 0 ? false : !!maskAllText;
    } catch (e2) {}
    return !!maskAllText;
}
function $604631306887a81e$var$onceIframeLoaded(iframeEl, listener, iframeLoadTimeout) {
    const win = iframeEl.contentWindow;
    if (!win) return;
    let fired = false;
    let readyState;
    try {
        readyState = win.document.readyState;
    } catch (error) {
        return;
    }
    if (readyState !== "complete") {
        const timer = $604631306887a81e$var$setTimeout$2(()=>{
            if (!fired) {
                listener();
                fired = true;
            }
        }, iframeLoadTimeout);
        iframeEl.addEventListener("load", ()=>{
            $604631306887a81e$var$clearTimeout$1(timer);
            fired = true;
            listener();
        });
        return;
    }
    const blankUrl = "about:blank";
    if (win.location.href !== blankUrl || iframeEl.src === blankUrl || iframeEl.src === "") {
        $604631306887a81e$var$setTimeout$2(listener, 0);
        return iframeEl.addEventListener("load", listener);
    }
    iframeEl.addEventListener("load", listener);
}
function $604631306887a81e$var$onceStylesheetLoaded(link, listener, styleSheetLoadTimeout) {
    let fired = false;
    let styleSheetLoaded;
    try {
        styleSheetLoaded = link.sheet;
    } catch (error) {
        return;
    }
    if (styleSheetLoaded) return;
    const timer = $604631306887a81e$var$setTimeout$2(()=>{
        if (!fired) {
            listener();
            fired = true;
        }
    }, styleSheetLoadTimeout);
    link.addEventListener("load", ()=>{
        $604631306887a81e$var$clearTimeout$1(timer);
        fired = true;
        listener();
    });
}
function $604631306887a81e$var$serializeNode(n2, options) {
    const { doc: doc, mirror: mirror2, blockClass: blockClass, blockSelector: blockSelector, unblockSelector: unblockSelector, maskAllText: maskAllText, maskAttributeFn: maskAttributeFn, maskTextClass: maskTextClass, unmaskTextClass: unmaskTextClass, maskTextSelector: maskTextSelector, unmaskTextSelector: unmaskTextSelector, inlineStylesheet: inlineStylesheet, maskInputOptions: maskInputOptions = {}, maskTextFn: maskTextFn, maskInputFn: maskInputFn, dataURLOptions: dataURLOptions = {}, inlineImages: inlineImages, recordCanvas: recordCanvas, keepIframeSrcFn: keepIframeSrcFn, newlyAddedElement: newlyAddedElement = false, ignoreCSSAttributes: ignoreCSSAttributes } = options;
    const rootId = $604631306887a81e$var$getRootId(doc, mirror2);
    switch(n2.nodeType){
        case n2.DOCUMENT_NODE:
            if (n2.compatMode !== "CSS1Compat") return {
                type: $604631306887a81e$var$NodeType$2.Document,
                childNodes: [],
                compatMode: n2.compatMode
            };
            else return {
                type: $604631306887a81e$var$NodeType$2.Document,
                childNodes: []
            };
        case n2.DOCUMENT_TYPE_NODE:
            return {
                type: $604631306887a81e$var$NodeType$2.DocumentType,
                name: n2.name,
                publicId: n2.publicId,
                systemId: n2.systemId,
                rootId: rootId
            };
        case n2.ELEMENT_NODE:
            return $604631306887a81e$var$serializeElementNode(n2, {
                doc: doc,
                blockClass: blockClass,
                blockSelector: blockSelector,
                unblockSelector: unblockSelector,
                inlineStylesheet: inlineStylesheet,
                maskAttributeFn: maskAttributeFn,
                maskInputOptions: maskInputOptions,
                maskInputFn: maskInputFn,
                dataURLOptions: dataURLOptions,
                inlineImages: inlineImages,
                recordCanvas: recordCanvas,
                keepIframeSrcFn: keepIframeSrcFn,
                newlyAddedElement: newlyAddedElement,
                rootId: rootId,
                maskTextClass: maskTextClass,
                unmaskTextClass: unmaskTextClass,
                maskTextSelector: maskTextSelector,
                unmaskTextSelector: unmaskTextSelector,
                ignoreCSSAttributes: ignoreCSSAttributes
            });
        case n2.TEXT_NODE:
            return $604631306887a81e$var$serializeTextNode(n2, {
                doc: doc,
                maskAllText: maskAllText,
                maskTextClass: maskTextClass,
                unmaskTextClass: unmaskTextClass,
                maskTextSelector: maskTextSelector,
                unmaskTextSelector: unmaskTextSelector,
                maskTextFn: maskTextFn,
                maskInputOptions: maskInputOptions,
                maskInputFn: maskInputFn,
                rootId: rootId
            });
        case n2.CDATA_SECTION_NODE:
            return {
                type: $604631306887a81e$var$NodeType$2.CDATA,
                textContent: "",
                rootId: rootId
            };
        case n2.COMMENT_NODE:
            return {
                type: $604631306887a81e$var$NodeType$2.Comment,
                textContent: n2.textContent || "",
                rootId: rootId
            };
        default:
            return false;
    }
}
function $604631306887a81e$var$getRootId(doc, mirror2) {
    if (!mirror2.hasNode(doc)) return void 0;
    const docId = mirror2.getId(doc);
    return docId === 1 ? void 0 : docId;
}
function $604631306887a81e$var$serializeTextNode(n2, options) {
    const { maskAllText: maskAllText, maskTextClass: maskTextClass, unmaskTextClass: unmaskTextClass, maskTextSelector: maskTextSelector, unmaskTextSelector: unmaskTextSelector, maskTextFn: maskTextFn, maskInputOptions: maskInputOptions, maskInputFn: maskInputFn, rootId: rootId } = options;
    const parentTagName = n2.parentNode && n2.parentNode.tagName;
    let textContent = n2.textContent;
    const isStyle = parentTagName === "STYLE" ? true : void 0;
    const isScript = parentTagName === "SCRIPT" ? true : void 0;
    const isTextarea = parentTagName === "TEXTAREA" ? true : void 0;
    if (isStyle && textContent) {
        try {
            if (n2.nextSibling || n2.previousSibling) ;
            else if (n2.parentNode.sheet?.cssRules) textContent = $604631306887a81e$var$stringifyStylesheet(n2.parentNode.sheet);
        } catch (err) {
            console.warn(`Cannot get CSS styles from text's parentNode. Error: ${err}`, n2);
        }
        textContent = $604631306887a81e$var$absoluteToStylesheet(textContent, $604631306887a81e$var$getHref(options.doc));
    }
    if (isScript) textContent = "SCRIPT_PLACEHOLDER";
    const forceMask = $604631306887a81e$var$needMaskingText(n2, maskTextClass, maskTextSelector, unmaskTextClass, unmaskTextSelector, maskAllText);
    if (!isStyle && !isScript && !isTextarea && textContent && forceMask) textContent = maskTextFn ? maskTextFn(textContent, n2.parentElement) : textContent.replace(/[\S]/g, "*");
    if (isTextarea && textContent && (maskInputOptions.textarea || forceMask)) textContent = maskInputFn ? maskInputFn(textContent, n2.parentNode) : textContent.replace(/[\S]/g, "*");
    if (parentTagName === "OPTION" && textContent) {
        const isInputMasked = $604631306887a81e$var$shouldMaskInput({
            type: null,
            tagName: parentTagName,
            maskInputOptions: maskInputOptions
        });
        textContent = $604631306887a81e$var$maskInputValue({
            isMasked: $604631306887a81e$var$needMaskingText(n2, maskTextClass, maskTextSelector, unmaskTextClass, unmaskTextSelector, isInputMasked),
            element: n2,
            value: textContent,
            maskInputFn: maskInputFn
        });
    }
    return {
        type: $604631306887a81e$var$NodeType$2.Text,
        textContent: textContent || "",
        isStyle: isStyle,
        rootId: rootId
    };
}
function $604631306887a81e$var$serializeElementNode(n2, options) {
    const { doc: doc, blockClass: blockClass, blockSelector: blockSelector, unblockSelector: unblockSelector, inlineStylesheet: inlineStylesheet, maskInputOptions: maskInputOptions = {}, maskAttributeFn: maskAttributeFn, maskInputFn: maskInputFn, dataURLOptions: dataURLOptions = {}, inlineImages: inlineImages, recordCanvas: recordCanvas, keepIframeSrcFn: keepIframeSrcFn, newlyAddedElement: newlyAddedElement = false, rootId: rootId, maskTextClass: maskTextClass, unmaskTextClass: unmaskTextClass, maskTextSelector: maskTextSelector, unmaskTextSelector: unmaskTextSelector, ignoreCSSAttributes: ignoreCSSAttributes } = options;
    const needBlock = $604631306887a81e$var$_isBlockedElement(n2, blockClass, blockSelector, unblockSelector);
    const tagName = $604631306887a81e$var$getValidTagName$1(n2);
    let attributes2 = {};
    const len = n2.attributes.length;
    for(let i2 = 0; i2 < len; i2++){
        const attr = n2.attributes[i2];
        if (attr.name && !$604631306887a81e$var$ignoreAttribute(tagName, attr.name, attr.value)) attributes2[attr.name] = $604631306887a81e$var$transformAttribute(doc, tagName, $604631306887a81e$var$toLowerCase(attr.name), attr.value, n2, maskAttributeFn, ignoreCSSAttributes);
    }
    if (tagName === "link" && inlineStylesheet) {
        const stylesheet = Array.from(doc.styleSheets).find((s2)=>{
            return s2.href === n2.href;
        });
        let cssText = null;
        if (stylesheet) cssText = $604631306887a81e$var$stringifyStylesheet(stylesheet);
        if (cssText) {
            attributes2.rel = null;
            attributes2.href = null;
            attributes2.crossorigin = null;
            attributes2._cssText = $604631306887a81e$var$absoluteToStylesheet(cssText, stylesheet.href);
        }
    }
    if (tagName === "style" && n2.sheet && // TODO: Currently we only try to get dynamic stylesheet when it is an empty style element
    !(n2.innerText || n2.textContent || "").trim().length) {
        const cssText = $604631306887a81e$var$stringifyStylesheet(n2.sheet);
        if (cssText) attributes2._cssText = $604631306887a81e$var$absoluteToStylesheet(cssText, $604631306887a81e$var$getHref(doc));
    }
    if (tagName === "input" || tagName === "textarea" || tagName === "select" || tagName === "option") {
        const el = n2;
        const type = $604631306887a81e$var$getInputType(el);
        const value = $604631306887a81e$var$getInputValue(el, $604631306887a81e$var$toUpperCase(tagName), type);
        const checked = el.checked;
        if (type !== "submit" && type !== "button" && value) {
            const forceMask = $604631306887a81e$var$needMaskingText(el, maskTextClass, maskTextSelector, unmaskTextClass, unmaskTextSelector, $604631306887a81e$var$shouldMaskInput({
                type: type,
                tagName: $604631306887a81e$var$toUpperCase(tagName),
                maskInputOptions: maskInputOptions
            }));
            attributes2.value = $604631306887a81e$var$maskInputValue({
                isMasked: forceMask,
                element: el,
                value: value,
                maskInputFn: maskInputFn
            });
        }
        if (checked) attributes2.checked = checked;
    }
    if (tagName === "option") {
        if (n2.selected && !maskInputOptions["select"]) attributes2.selected = true;
        else delete attributes2.selected;
    }
    if (tagName === "canvas" && recordCanvas) {
        if (n2.__context === "2d") {
            if (!$604631306887a81e$var$is2DCanvasBlank(n2)) attributes2.rr_dataURL = n2.toDataURL(dataURLOptions.type, dataURLOptions.quality);
        } else if (!("__context" in n2)) {
            const canvasDataURL = n2.toDataURL(dataURLOptions.type, dataURLOptions.quality);
            const blankCanvas = doc.createElement("canvas");
            blankCanvas.width = n2.width;
            blankCanvas.height = n2.height;
            const blankCanvasDataURL = blankCanvas.toDataURL(dataURLOptions.type, dataURLOptions.quality);
            if (canvasDataURL !== blankCanvasDataURL) attributes2.rr_dataURL = canvasDataURL;
        }
    }
    if (tagName === "img" && inlineImages) {
        if (!$604631306887a81e$var$canvasService) {
            $604631306887a81e$var$canvasService = doc.createElement("canvas");
            $604631306887a81e$var$canvasCtx = $604631306887a81e$var$canvasService.getContext("2d");
        }
        const image = n2;
        const imageSrc = image.currentSrc || image.getAttribute("src") || "<unknown-src>";
        const priorCrossOrigin = image.crossOrigin;
        const recordInlineImage = ()=>{
            image.removeEventListener("load", recordInlineImage);
            try {
                $604631306887a81e$var$canvasService.width = image.naturalWidth;
                $604631306887a81e$var$canvasService.height = image.naturalHeight;
                $604631306887a81e$var$canvasCtx.drawImage(image, 0, 0);
                attributes2.rr_dataURL = $604631306887a81e$var$canvasService.toDataURL(dataURLOptions.type, dataURLOptions.quality);
            } catch (err) {
                if (image.crossOrigin !== "anonymous") {
                    image.crossOrigin = "anonymous";
                    if (image.complete && image.naturalWidth !== 0) recordInlineImage();
                    else image.addEventListener("load", recordInlineImage);
                    return;
                } else console.warn(`Cannot inline img src=${imageSrc}! Error: ${err}`);
            }
            if (image.crossOrigin === "anonymous") priorCrossOrigin ? attributes2.crossOrigin = priorCrossOrigin : image.removeAttribute("crossorigin");
        };
        if (image.complete && image.naturalWidth !== 0) recordInlineImage();
        else image.addEventListener("load", recordInlineImage);
    }
    if (tagName === "audio" || tagName === "video") {
        attributes2.rr_mediaState = n2.paused ? "paused" : "played";
        attributes2.rr_mediaCurrentTime = n2.currentTime;
    }
    if (!newlyAddedElement) {
        if (n2.scrollLeft) attributes2.rr_scrollLeft = n2.scrollLeft;
        if (n2.scrollTop) attributes2.rr_scrollTop = n2.scrollTop;
    }
    if (needBlock) {
        const { width: width, height: height } = n2.getBoundingClientRect();
        attributes2 = {
            class: attributes2.class,
            rr_width: `${width}px`,
            rr_height: `${height}px`
        };
    }
    if (tagName === "iframe" && !keepIframeSrcFn(attributes2.src)) {
        if (!needBlock && !$604631306887a81e$var$getIframeContentDocument(n2)) attributes2.rr_src = attributes2.src;
        delete attributes2.src;
    }
    let isCustomElement;
    try {
        if (customElements.get(tagName)) isCustomElement = true;
    } catch (e2) {}
    return {
        type: $604631306887a81e$var$NodeType$2.Element,
        tagName: tagName,
        attributes: attributes2,
        childNodes: [],
        isSVG: $604631306887a81e$var$isSVGElement(n2) || void 0,
        needBlock: needBlock,
        rootId: rootId,
        isCustom: isCustomElement
    };
}
function $604631306887a81e$var$lowerIfExists(maybeAttr) {
    if (maybeAttr === void 0 || maybeAttr === null) return "";
    else return maybeAttr.toLowerCase();
}
function $604631306887a81e$var$slimDOMExcluded(sn, slimDOMOptions) {
    if (slimDOMOptions.comment && sn.type === $604631306887a81e$var$NodeType$2.Comment) return true;
    else if (sn.type === $604631306887a81e$var$NodeType$2.Element) {
        if (slimDOMOptions.script && // script tag
        (sn.tagName === "script" || // (module)preload link
        sn.tagName === "link" && (sn.attributes.rel === "preload" || sn.attributes.rel === "modulepreload") || // prefetch link
        sn.tagName === "link" && sn.attributes.rel === "prefetch" && typeof sn.attributes.href === "string" && $604631306887a81e$var$extractFileExtension(sn.attributes.href) === "js")) return true;
        else if (slimDOMOptions.headFavicon && (sn.tagName === "link" && sn.attributes.rel === "shortcut icon" || sn.tagName === "meta" && ($604631306887a81e$var$lowerIfExists(sn.attributes.name).match(/^msapplication-tile(image|color)$/) || $604631306887a81e$var$lowerIfExists(sn.attributes.name) === "application-name" || $604631306887a81e$var$lowerIfExists(sn.attributes.rel) === "icon" || $604631306887a81e$var$lowerIfExists(sn.attributes.rel) === "apple-touch-icon" || $604631306887a81e$var$lowerIfExists(sn.attributes.rel) === "shortcut icon"))) return true;
        else if (sn.tagName === "meta") {
            if (slimDOMOptions.headMetaDescKeywords && $604631306887a81e$var$lowerIfExists(sn.attributes.name).match(/^description|keywords$/)) return true;
            else if (slimDOMOptions.headMetaSocial && ($604631306887a81e$var$lowerIfExists(sn.attributes.property).match(/^(og|twitter|fb):/) || // og = opengraph (facebook)
            $604631306887a81e$var$lowerIfExists(sn.attributes.name).match(/^(og|twitter):/) || $604631306887a81e$var$lowerIfExists(sn.attributes.name) === "pinterest")) return true;
            else if (slimDOMOptions.headMetaRobots && ($604631306887a81e$var$lowerIfExists(sn.attributes.name) === "robots" || $604631306887a81e$var$lowerIfExists(sn.attributes.name) === "googlebot" || $604631306887a81e$var$lowerIfExists(sn.attributes.name) === "bingbot")) return true;
            else if (slimDOMOptions.headMetaHttpEquiv && sn.attributes["http-equiv"] !== void 0) return true;
            else if (slimDOMOptions.headMetaAuthorship && ($604631306887a81e$var$lowerIfExists(sn.attributes.name) === "author" || $604631306887a81e$var$lowerIfExists(sn.attributes.name) === "generator" || $604631306887a81e$var$lowerIfExists(sn.attributes.name) === "framework" || $604631306887a81e$var$lowerIfExists(sn.attributes.name) === "publisher" || $604631306887a81e$var$lowerIfExists(sn.attributes.name) === "progid" || $604631306887a81e$var$lowerIfExists(sn.attributes.property).match(/^article:/) || $604631306887a81e$var$lowerIfExists(sn.attributes.property).match(/^product:/))) return true;
            else if (slimDOMOptions.headMetaVerification && ($604631306887a81e$var$lowerIfExists(sn.attributes.name) === "google-site-verification" || $604631306887a81e$var$lowerIfExists(sn.attributes.name) === "yandex-verification" || $604631306887a81e$var$lowerIfExists(sn.attributes.name) === "csrf-token" || $604631306887a81e$var$lowerIfExists(sn.attributes.name) === "p:domain_verify" || $604631306887a81e$var$lowerIfExists(sn.attributes.name) === "verify-v1" || $604631306887a81e$var$lowerIfExists(sn.attributes.name) === "verification" || $604631306887a81e$var$lowerIfExists(sn.attributes.name) === "shopify-checkout-api-token")) return true;
        }
    }
    return false;
}
function $604631306887a81e$var$serializeNodeWithId(n2, options) {
    const { doc: doc, mirror: mirror2, blockClass: blockClass, blockSelector: blockSelector, unblockSelector: unblockSelector, maskAllText: maskAllText, maskTextClass: maskTextClass, unmaskTextClass: unmaskTextClass, maskTextSelector: maskTextSelector, unmaskTextSelector: unmaskTextSelector, skipChild: skipChild = false, inlineStylesheet: inlineStylesheet = true, maskInputOptions: maskInputOptions = {}, maskAttributeFn: maskAttributeFn, maskTextFn: maskTextFn, maskInputFn: maskInputFn, slimDOMOptions: slimDOMOptions, dataURLOptions: dataURLOptions = {}, inlineImages: inlineImages = false, recordCanvas: recordCanvas = false, onSerialize: onSerialize, onIframeLoad: onIframeLoad, iframeLoadTimeout: iframeLoadTimeout = 5e3, onBlockedImageLoad: onBlockedImageLoad, onStylesheetLoad: onStylesheetLoad, stylesheetLoadTimeout: stylesheetLoadTimeout = 5e3, keepIframeSrcFn: keepIframeSrcFn = ()=>false, newlyAddedElement: newlyAddedElement = false, ignoreCSSAttributes: ignoreCSSAttributes } = options;
    let { preserveWhiteSpace: preserveWhiteSpace = true } = options;
    const _serializedNode = $604631306887a81e$var$serializeNode(n2, {
        doc: doc,
        mirror: mirror2,
        blockClass: blockClass,
        blockSelector: blockSelector,
        maskAllText: maskAllText,
        unblockSelector: unblockSelector,
        maskTextClass: maskTextClass,
        unmaskTextClass: unmaskTextClass,
        maskTextSelector: maskTextSelector,
        unmaskTextSelector: unmaskTextSelector,
        inlineStylesheet: inlineStylesheet,
        maskInputOptions: maskInputOptions,
        maskAttributeFn: maskAttributeFn,
        maskTextFn: maskTextFn,
        maskInputFn: maskInputFn,
        dataURLOptions: dataURLOptions,
        inlineImages: inlineImages,
        recordCanvas: recordCanvas,
        keepIframeSrcFn: keepIframeSrcFn,
        newlyAddedElement: newlyAddedElement,
        ignoreCSSAttributes: ignoreCSSAttributes
    });
    if (!_serializedNode) {
        console.warn(n2, "not serialized");
        return null;
    }
    let id;
    if (mirror2.hasNode(n2)) id = mirror2.getId(n2);
    else if ($604631306887a81e$var$slimDOMExcluded(_serializedNode, slimDOMOptions) || !preserveWhiteSpace && _serializedNode.type === $604631306887a81e$var$NodeType$2.Text && !_serializedNode.isStyle && !_serializedNode.textContent.replace(/^\s+|\s+$/gm, "").length) id = $604631306887a81e$var$IGNORED_NODE;
    else id = $604631306887a81e$var$genId();
    const serializedNode2 = Object.assign(_serializedNode, {
        id: id
    });
    mirror2.add(n2, serializedNode2);
    if (id === $604631306887a81e$var$IGNORED_NODE) return null;
    if (onSerialize) onSerialize(n2);
    let recordChild = !skipChild;
    if (serializedNode2.type === $604631306887a81e$var$NodeType$2.Element) {
        recordChild = recordChild && !serializedNode2.needBlock;
        const shadowRoot = n2.shadowRoot;
        if (shadowRoot && $604631306887a81e$var$isNativeShadowDom(shadowRoot)) serializedNode2.isShadowHost = true;
    }
    if ((serializedNode2.type === $604631306887a81e$var$NodeType$2.Document || serializedNode2.type === $604631306887a81e$var$NodeType$2.Element) && recordChild) {
        if (slimDOMOptions.headWhitespace && serializedNode2.type === $604631306887a81e$var$NodeType$2.Element && serializedNode2.tagName === "head") preserveWhiteSpace = false;
        const bypassOptions = {
            doc: doc,
            mirror: mirror2,
            blockClass: blockClass,
            blockSelector: blockSelector,
            maskAllText: maskAllText,
            unblockSelector: unblockSelector,
            maskTextClass: maskTextClass,
            unmaskTextClass: unmaskTextClass,
            maskTextSelector: maskTextSelector,
            unmaskTextSelector: unmaskTextSelector,
            skipChild: skipChild,
            inlineStylesheet: inlineStylesheet,
            maskInputOptions: maskInputOptions,
            maskAttributeFn: maskAttributeFn,
            maskTextFn: maskTextFn,
            maskInputFn: maskInputFn,
            slimDOMOptions: slimDOMOptions,
            dataURLOptions: dataURLOptions,
            inlineImages: inlineImages,
            recordCanvas: recordCanvas,
            preserveWhiteSpace: preserveWhiteSpace,
            onSerialize: onSerialize,
            onIframeLoad: onIframeLoad,
            iframeLoadTimeout: iframeLoadTimeout,
            onBlockedImageLoad: onBlockedImageLoad,
            onStylesheetLoad: onStylesheetLoad,
            stylesheetLoadTimeout: stylesheetLoadTimeout,
            keepIframeSrcFn: keepIframeSrcFn,
            ignoreCSSAttributes: ignoreCSSAttributes
        };
        const childNodes = n2.childNodes ? Array.from(n2.childNodes) : [];
        for (const childN of childNodes){
            const serializedChildNode = $604631306887a81e$var$serializeNodeWithId(childN, bypassOptions);
            if (serializedChildNode) serializedNode2.childNodes.push(serializedChildNode);
        }
        if ($604631306887a81e$var$isElement$1(n2) && n2.shadowRoot) for (const childN of Array.from(n2.shadowRoot.childNodes)){
            const serializedChildNode = $604631306887a81e$var$serializeNodeWithId(childN, bypassOptions);
            if (serializedChildNode) {
                $604631306887a81e$var$isNativeShadowDom(n2.shadowRoot) && (serializedChildNode.isShadow = true);
                serializedNode2.childNodes.push(serializedChildNode);
            }
        }
    }
    if (n2.parentNode && $604631306887a81e$var$isShadowRoot(n2.parentNode) && $604631306887a81e$var$isNativeShadowDom(n2.parentNode)) serializedNode2.isShadow = true;
    if (serializedNode2.type === $604631306887a81e$var$NodeType$2.Element && serializedNode2.tagName === "iframe" && !serializedNode2.needBlock) $604631306887a81e$var$onceIframeLoaded(n2, ()=>{
        const iframeDoc = $604631306887a81e$var$getIframeContentDocument(n2);
        if (iframeDoc && onIframeLoad) {
            const serializedIframeNode = $604631306887a81e$var$serializeNodeWithId(iframeDoc, {
                doc: iframeDoc,
                mirror: mirror2,
                blockClass: blockClass,
                blockSelector: blockSelector,
                unblockSelector: unblockSelector,
                maskAllText: maskAllText,
                maskTextClass: maskTextClass,
                unmaskTextClass: unmaskTextClass,
                maskTextSelector: maskTextSelector,
                unmaskTextSelector: unmaskTextSelector,
                skipChild: false,
                inlineStylesheet: inlineStylesheet,
                maskInputOptions: maskInputOptions,
                maskAttributeFn: maskAttributeFn,
                maskTextFn: maskTextFn,
                maskInputFn: maskInputFn,
                slimDOMOptions: slimDOMOptions,
                dataURLOptions: dataURLOptions,
                inlineImages: inlineImages,
                recordCanvas: recordCanvas,
                preserveWhiteSpace: preserveWhiteSpace,
                onSerialize: onSerialize,
                onIframeLoad: onIframeLoad,
                iframeLoadTimeout: iframeLoadTimeout,
                onStylesheetLoad: onStylesheetLoad,
                stylesheetLoadTimeout: stylesheetLoadTimeout,
                keepIframeSrcFn: keepIframeSrcFn,
                ignoreCSSAttributes: ignoreCSSAttributes
            });
            if (serializedIframeNode) onIframeLoad(n2, serializedIframeNode);
        }
    }, iframeLoadTimeout);
    if (serializedNode2.type === $604631306887a81e$var$NodeType$2.Element && serializedNode2.tagName === "img" && !n2.complete && serializedNode2.needBlock) {
        const image = n2;
        const updateImageDimensions = ()=>{
            if (image.isConnected && !image.complete && onBlockedImageLoad) try {
                const rect = image.getBoundingClientRect();
                if (rect.width > 0 && rect.height > 0) onBlockedImageLoad(image, serializedNode2, rect);
            } catch (error) {}
            image.removeEventListener("load", updateImageDimensions);
        };
        if (image.isConnected) image.addEventListener("load", updateImageDimensions);
    }
    if (serializedNode2.type === $604631306887a81e$var$NodeType$2.Element && serializedNode2.tagName === "link" && typeof serializedNode2.attributes.rel === "string" && (serializedNode2.attributes.rel === "stylesheet" || serializedNode2.attributes.rel === "preload" && typeof serializedNode2.attributes.href === "string" && $604631306887a81e$var$extractFileExtension(serializedNode2.attributes.href) === "css")) $604631306887a81e$var$onceStylesheetLoaded(n2, ()=>{
        if (onStylesheetLoad) {
            const serializedLinkNode = $604631306887a81e$var$serializeNodeWithId(n2, {
                doc: doc,
                mirror: mirror2,
                blockClass: blockClass,
                blockSelector: blockSelector,
                unblockSelector: unblockSelector,
                maskAllText: maskAllText,
                maskTextClass: maskTextClass,
                unmaskTextClass: unmaskTextClass,
                maskTextSelector: maskTextSelector,
                unmaskTextSelector: unmaskTextSelector,
                skipChild: false,
                inlineStylesheet: inlineStylesheet,
                maskInputOptions: maskInputOptions,
                maskAttributeFn: maskAttributeFn,
                maskTextFn: maskTextFn,
                maskInputFn: maskInputFn,
                slimDOMOptions: slimDOMOptions,
                dataURLOptions: dataURLOptions,
                inlineImages: inlineImages,
                recordCanvas: recordCanvas,
                preserveWhiteSpace: preserveWhiteSpace,
                onSerialize: onSerialize,
                onIframeLoad: onIframeLoad,
                iframeLoadTimeout: iframeLoadTimeout,
                onStylesheetLoad: onStylesheetLoad,
                stylesheetLoadTimeout: stylesheetLoadTimeout,
                keepIframeSrcFn: keepIframeSrcFn,
                ignoreCSSAttributes: ignoreCSSAttributes
            });
            if (serializedLinkNode) onStylesheetLoad(n2, serializedLinkNode);
        }
    }, stylesheetLoadTimeout);
    if (serializedNode2.type === $604631306887a81e$var$NodeType$2.Element) delete serializedNode2.needBlock;
    return serializedNode2;
}
function $604631306887a81e$var$snapshot(n2, options) {
    const { mirror: mirror2 = new $604631306887a81e$var$Mirror(), blockClass: blockClass = "rr-block", blockSelector: blockSelector = null, unblockSelector: unblockSelector = null, maskAllText: maskAllText = false, maskTextClass: maskTextClass = "rr-mask", unmaskTextClass: unmaskTextClass = null, maskTextSelector: maskTextSelector = null, unmaskTextSelector: unmaskTextSelector = null, inlineStylesheet: inlineStylesheet = true, inlineImages: inlineImages = false, recordCanvas: recordCanvas = false, maskAllInputs: maskAllInputs = false, maskAttributeFn: maskAttributeFn, maskTextFn: maskTextFn, maskInputFn: maskInputFn, slimDOM: slimDOM = false, dataURLOptions: dataURLOptions, preserveWhiteSpace: preserveWhiteSpace, onSerialize: onSerialize, onIframeLoad: onIframeLoad, iframeLoadTimeout: iframeLoadTimeout, onBlockedImageLoad: onBlockedImageLoad, onStylesheetLoad: onStylesheetLoad, stylesheetLoadTimeout: stylesheetLoadTimeout, keepIframeSrcFn: keepIframeSrcFn = ()=>false, ignoreCSSAttributes: ignoreCSSAttributes = /* @__PURE__ */ new Set([]) } = options || {};
    const maskInputOptions = maskAllInputs === true ? {
        color: true,
        date: true,
        "datetime-local": true,
        email: true,
        month: true,
        number: true,
        range: true,
        search: true,
        tel: true,
        text: true,
        time: true,
        url: true,
        week: true,
        textarea: true,
        select: true
    } : maskAllInputs === false ? {} : maskAllInputs;
    const slimDOMOptions = slimDOM === true || slimDOM === "all" ? // if true: set of sensible options that should not throw away any information
    {
        script: true,
        comment: true,
        headFavicon: true,
        headWhitespace: true,
        headMetaDescKeywords: slimDOM === "all",
        // destructive
        headMetaSocial: true,
        headMetaRobots: true,
        headMetaHttpEquiv: true,
        headMetaAuthorship: true,
        headMetaVerification: true
    } : slimDOM === false ? {} : slimDOM;
    return $604631306887a81e$var$serializeNodeWithId(n2, {
        doc: n2,
        mirror: mirror2,
        blockClass: blockClass,
        blockSelector: blockSelector,
        unblockSelector: unblockSelector,
        maskAllText: maskAllText,
        maskTextClass: maskTextClass,
        unmaskTextClass: unmaskTextClass,
        maskTextSelector: maskTextSelector,
        unmaskTextSelector: unmaskTextSelector,
        skipChild: false,
        inlineStylesheet: inlineStylesheet,
        maskInputOptions: maskInputOptions,
        maskAttributeFn: maskAttributeFn,
        maskTextFn: maskTextFn,
        maskInputFn: maskInputFn,
        slimDOMOptions: slimDOMOptions,
        dataURLOptions: dataURLOptions,
        inlineImages: inlineImages,
        recordCanvas: recordCanvas,
        preserveWhiteSpace: preserveWhiteSpace,
        onSerialize: onSerialize,
        onIframeLoad: onIframeLoad,
        iframeLoadTimeout: iframeLoadTimeout,
        onBlockedImageLoad: onBlockedImageLoad,
        onStylesheetLoad: onStylesheetLoad,
        stylesheetLoadTimeout: stylesheetLoadTimeout,
        keepIframeSrcFn: keepIframeSrcFn,
        newlyAddedElement: false,
        ignoreCSSAttributes: ignoreCSSAttributes
    });
}
function $604631306887a81e$var$on(type, fn, target = document) {
    const options = {
        capture: true,
        passive: true
    };
    target.addEventListener(type, fn, options);
    return ()=>target.removeEventListener(type, fn, options);
}
const $604631306887a81e$var$DEPARTED_MIRROR_ACCESS_WARNING = "Please stop import mirror directly. Instead of that,\r\nnow you can use replayer.getMirror() to access the mirror instance of a replayer,\r\nor you can use record.mirror to access the mirror instance during recording.";
let $604631306887a81e$var$_mirror = {
    map: {},
    getId () {
        console.error($604631306887a81e$var$DEPARTED_MIRROR_ACCESS_WARNING);
        return -1;
    },
    getNode () {
        console.error($604631306887a81e$var$DEPARTED_MIRROR_ACCESS_WARNING);
        return null;
    },
    removeNodeFromMap () {
        console.error($604631306887a81e$var$DEPARTED_MIRROR_ACCESS_WARNING);
    },
    has () {
        console.error($604631306887a81e$var$DEPARTED_MIRROR_ACCESS_WARNING);
        return false;
    },
    reset () {
        console.error($604631306887a81e$var$DEPARTED_MIRROR_ACCESS_WARNING);
    }
};
if (typeof window !== "undefined" && window.Proxy && window.Reflect) $604631306887a81e$var$_mirror = new Proxy($604631306887a81e$var$_mirror, {
    get (target, prop, receiver) {
        if (prop === "map") console.error($604631306887a81e$var$DEPARTED_MIRROR_ACCESS_WARNING);
        return Reflect.get(target, prop, receiver);
    }
});
function $604631306887a81e$var$throttle$1(func, wait, options = {}) {
    let timeout = null;
    let previous = 0;
    return function(...args) {
        const now = Date.now();
        if (!previous && options.leading === false) previous = now;
        const remaining = wait - (now - previous);
        const context = this;
        if (remaining <= 0 || remaining > wait) {
            if (timeout) {
                $604631306887a81e$var$clearTimeout$2(timeout);
                timeout = null;
            }
            previous = now;
            func.apply(context, args);
        } else if (!timeout && options.trailing !== false) timeout = $604631306887a81e$var$setTimeout$1(()=>{
            previous = options.leading === false ? 0 : Date.now();
            timeout = null;
            func.apply(context, args);
        }, remaining);
    };
}
function $604631306887a81e$var$hookSetter(target, key, d, isRevoked, win = window) {
    const original = win.Object.getOwnPropertyDescriptor(target, key);
    win.Object.defineProperty(target, key, isRevoked ? d : {
        set (value) {
            $604631306887a81e$var$setTimeout$1(()=>{
                d.set.call(this, value);
            }, 0);
            if (original && original.set) original.set.call(this, value);
        }
    });
    return ()=>$604631306887a81e$var$hookSetter(target, key, original || {}, true);
}
function $604631306887a81e$var$patch(source, name, replacement) {
    try {
        if (!(name in source)) return ()=>{};
        const original = source[name];
        const wrapped = replacement(original);
        if (typeof wrapped === "function") {
            wrapped.prototype = wrapped.prototype || {};
            Object.defineProperties(wrapped, {
                __rrweb_original__: {
                    enumerable: false,
                    value: original
                }
            });
        }
        source[name] = wrapped;
        return ()=>{
            source[name] = original;
        };
    } catch  {
        return ()=>{};
    }
}
let $604631306887a81e$var$nowTimestamp = Date.now;
if (!/* @__PURE__ */ /[1-9][0-9]{12}/.test(Date.now().toString())) $604631306887a81e$var$nowTimestamp = ()=>/* @__PURE__ */ new Date().getTime();
function $604631306887a81e$var$getWindowScroll(win) {
    const doc = win.document;
    return {
        left: doc.scrollingElement ? doc.scrollingElement.scrollLeft : win.pageXOffset !== void 0 ? win.pageXOffset : doc?.documentElement.scrollLeft || doc?.body?.parentElement?.scrollLeft || doc?.body?.scrollLeft || 0,
        top: doc.scrollingElement ? doc.scrollingElement.scrollTop : win.pageYOffset !== void 0 ? win.pageYOffset : doc?.documentElement.scrollTop || doc?.body?.parentElement?.scrollTop || doc?.body?.scrollTop || 0
    };
}
function $604631306887a81e$var$getWindowHeight() {
    return window.innerHeight || document.documentElement && document.documentElement.clientHeight || document.body && document.body.clientHeight;
}
function $604631306887a81e$var$getWindowWidth() {
    return window.innerWidth || document.documentElement && document.documentElement.clientWidth || document.body && document.body.clientWidth;
}
function $604631306887a81e$var$closestElementOfNode$1(node) {
    if (!node) return null;
    try {
        const el = node.nodeType === node.ELEMENT_NODE ? node : node.parentElement;
        return el;
    } catch (error) {
        return null;
    }
}
function $604631306887a81e$var$isBlocked(node, blockClass, blockSelector, unblockSelector, checkAncestors) {
    if (!node) return false;
    const el = $604631306887a81e$var$closestElementOfNode$1(node);
    if (!el) return false;
    const blockedPredicate = $604631306887a81e$var$createMatchPredicate(blockClass, blockSelector);
    if (!checkAncestors) {
        const isUnblocked = unblockSelector && el.matches(unblockSelector);
        return blockedPredicate(el) && !isUnblocked;
    }
    const blockDistance = $604631306887a81e$var$distanceToMatch(el, blockedPredicate);
    let unblockDistance = -1;
    if (blockDistance < 0) return false;
    if (unblockSelector) unblockDistance = $604631306887a81e$var$distanceToMatch(el, $604631306887a81e$var$createMatchPredicate(null, unblockSelector));
    if (blockDistance > -1 && unblockDistance < 0) return true;
    return blockDistance < unblockDistance;
}
function $604631306887a81e$var$isSerialized(n2, mirror2) {
    return mirror2.getId(n2) !== -1;
}
function $604631306887a81e$var$isIgnored(n2, mirror2) {
    return mirror2.getId(n2) === $604631306887a81e$var$IGNORED_NODE;
}
function $604631306887a81e$var$isAncestorRemoved(target, mirror2) {
    if ($604631306887a81e$var$isShadowRoot(target)) return false;
    const id = mirror2.getId(target);
    if (!mirror2.has(id)) return true;
    if (target.parentNode && target.parentNode.nodeType === target.DOCUMENT_NODE) return false;
    if (!target.parentNode) return true;
    return $604631306887a81e$var$isAncestorRemoved(target.parentNode, mirror2);
}
function $604631306887a81e$var$legacy_isTouchEvent(event) {
    return Boolean(event.changedTouches);
}
function $604631306887a81e$var$polyfill$1(win = window) {
    if ("NodeList" in win && !win.NodeList.prototype.forEach) win.NodeList.prototype.forEach = Array.prototype.forEach;
    if ("DOMTokenList" in win && !win.DOMTokenList.prototype.forEach) win.DOMTokenList.prototype.forEach = Array.prototype.forEach;
    if (!Node.prototype.contains) Node.prototype.contains = (...args)=>{
        let node = args[0];
        if (!(0 in args)) throw new TypeError("1 argument is required");
        do {
            if (this === node) return true;
        }while (node = node && node.parentNode);
        return false;
    };
}
function $604631306887a81e$var$isSerializedIframe(n2, mirror2) {
    return Boolean(n2.nodeName === "IFRAME" && mirror2.getMeta(n2));
}
function $604631306887a81e$var$isSerializedStylesheet(n2, mirror2) {
    return Boolean(n2.nodeName === "LINK" && n2.nodeType === n2.ELEMENT_NODE && n2.getAttribute && n2.getAttribute("rel") === "stylesheet" && mirror2.getMeta(n2));
}
function $604631306887a81e$var$hasShadowRoot(n2) {
    return Boolean(n2?.shadowRoot);
}
class $604631306887a81e$var$StyleSheetMirror {
    constructor(){
        this.id = 1;
        this.styleIDMap = /* @__PURE__ */ new WeakMap();
        this.idStyleMap = /* @__PURE__ */ new Map();
    }
    getId(stylesheet) {
        return this.styleIDMap.get(stylesheet) ?? -1;
    }
    has(stylesheet) {
        return this.styleIDMap.has(stylesheet);
    }
    /**
   * @returns If the stylesheet is in the mirror, returns the id of the stylesheet. If not, return the new assigned id.
   */ add(stylesheet, id) {
        if (this.has(stylesheet)) return this.getId(stylesheet);
        let newId;
        if (id === void 0) newId = this.id++;
        else newId = id;
        this.styleIDMap.set(stylesheet, newId);
        this.idStyleMap.set(newId, stylesheet);
        return newId;
    }
    getStyle(id) {
        return this.idStyleMap.get(id) || null;
    }
    reset() {
        this.styleIDMap = /* @__PURE__ */ new WeakMap();
        this.idStyleMap = /* @__PURE__ */ new Map();
        this.id = 1;
    }
    generateId() {
        return this.id++;
    }
}
function $604631306887a81e$var$getShadowHost(n2) {
    let shadowHost = null;
    if (n2.getRootNode?.()?.nodeType === Node.DOCUMENT_FRAGMENT_NODE && n2.getRootNode().host) shadowHost = n2.getRootNode().host;
    return shadowHost;
}
function $604631306887a81e$var$getRootShadowHost(n2) {
    let rootShadowHost = n2;
    let shadowHost;
    while(shadowHost = $604631306887a81e$var$getShadowHost(rootShadowHost))rootShadowHost = shadowHost;
    return rootShadowHost;
}
function $604631306887a81e$var$shadowHostInDom(n2) {
    const doc = n2.ownerDocument;
    if (!doc) return false;
    const shadowHost = $604631306887a81e$var$getRootShadowHost(n2);
    return doc.contains(shadowHost);
}
function $604631306887a81e$var$inDom(n2) {
    const doc = n2.ownerDocument;
    if (!doc) return false;
    return doc.contains(n2) || $604631306887a81e$var$shadowHostInDom(n2);
}
const $604631306887a81e$var$cachedImplementations = {};
function $604631306887a81e$var$getImplementation(name) {
    const cached = $604631306887a81e$var$cachedImplementations[name];
    if (cached) return cached;
    const document2 = window.document;
    let impl = window[name];
    if (document2 && typeof document2.createElement === "function") try {
        const sandbox = document2.createElement("iframe");
        sandbox.hidden = true;
        document2.head.appendChild(sandbox);
        const contentWindow = sandbox.contentWindow;
        if (contentWindow && contentWindow[name]) impl = contentWindow[name];
        document2.head.removeChild(sandbox);
    } catch (e2) {}
    return $604631306887a81e$var$cachedImplementations[name] = impl.bind(window);
}
function $604631306887a81e$var$onRequestAnimationFrame(...rest) {
    return $604631306887a81e$var$getImplementation("requestAnimationFrame")(...rest);
}
function $604631306887a81e$var$setTimeout$1(...rest) {
    return $604631306887a81e$var$getImplementation("setTimeout")(...rest);
}
function $604631306887a81e$var$clearTimeout$2(...rest) {
    return $604631306887a81e$var$getImplementation("clearTimeout")(...rest);
}
var $604631306887a81e$var$EventType = /* @__PURE__ */ ((EventType2)=>{
    EventType2[EventType2["DomContentLoaded"] = 0] = "DomContentLoaded";
    EventType2[EventType2["Load"] = 1] = "Load";
    EventType2[EventType2["FullSnapshot"] = 2] = "FullSnapshot";
    EventType2[EventType2["IncrementalSnapshot"] = 3] = "IncrementalSnapshot";
    EventType2[EventType2["Meta"] = 4] = "Meta";
    EventType2[EventType2["Custom"] = 5] = "Custom";
    EventType2[EventType2["Plugin"] = 6] = "Plugin";
    return EventType2;
})($604631306887a81e$var$EventType || {});
var $604631306887a81e$var$IncrementalSource = /* @__PURE__ */ ((IncrementalSource2)=>{
    IncrementalSource2[IncrementalSource2["Mutation"] = 0] = "Mutation";
    IncrementalSource2[IncrementalSource2["MouseMove"] = 1] = "MouseMove";
    IncrementalSource2[IncrementalSource2["MouseInteraction"] = 2] = "MouseInteraction";
    IncrementalSource2[IncrementalSource2["Scroll"] = 3] = "Scroll";
    IncrementalSource2[IncrementalSource2["ViewportResize"] = 4] = "ViewportResize";
    IncrementalSource2[IncrementalSource2["Input"] = 5] = "Input";
    IncrementalSource2[IncrementalSource2["TouchMove"] = 6] = "TouchMove";
    IncrementalSource2[IncrementalSource2["MediaInteraction"] = 7] = "MediaInteraction";
    IncrementalSource2[IncrementalSource2["StyleSheetRule"] = 8] = "StyleSheetRule";
    IncrementalSource2[IncrementalSource2["CanvasMutation"] = 9] = "CanvasMutation";
    IncrementalSource2[IncrementalSource2["Font"] = 10] = "Font";
    IncrementalSource2[IncrementalSource2["Log"] = 11] = "Log";
    IncrementalSource2[IncrementalSource2["Drag"] = 12] = "Drag";
    IncrementalSource2[IncrementalSource2["StyleDeclaration"] = 13] = "StyleDeclaration";
    IncrementalSource2[IncrementalSource2["Selection"] = 14] = "Selection";
    IncrementalSource2[IncrementalSource2["AdoptedStyleSheet"] = 15] = "AdoptedStyleSheet";
    IncrementalSource2[IncrementalSource2["CustomElement"] = 16] = "CustomElement";
    return IncrementalSource2;
})($604631306887a81e$var$IncrementalSource || {});
var $604631306887a81e$var$MouseInteractions = /* @__PURE__ */ ((MouseInteractions2)=>{
    MouseInteractions2[MouseInteractions2["MouseUp"] = 0] = "MouseUp";
    MouseInteractions2[MouseInteractions2["MouseDown"] = 1] = "MouseDown";
    MouseInteractions2[MouseInteractions2["Click"] = 2] = "Click";
    MouseInteractions2[MouseInteractions2["ContextMenu"] = 3] = "ContextMenu";
    MouseInteractions2[MouseInteractions2["DblClick"] = 4] = "DblClick";
    MouseInteractions2[MouseInteractions2["Focus"] = 5] = "Focus";
    MouseInteractions2[MouseInteractions2["Blur"] = 6] = "Blur";
    MouseInteractions2[MouseInteractions2["TouchStart"] = 7] = "TouchStart";
    MouseInteractions2[MouseInteractions2["TouchMove_Departed"] = 8] = "TouchMove_Departed";
    MouseInteractions2[MouseInteractions2["TouchEnd"] = 9] = "TouchEnd";
    MouseInteractions2[MouseInteractions2["TouchCancel"] = 10] = "TouchCancel";
    return MouseInteractions2;
})($604631306887a81e$var$MouseInteractions || {});
var $604631306887a81e$var$PointerTypes = /* @__PURE__ */ ((PointerTypes2)=>{
    PointerTypes2[PointerTypes2["Mouse"] = 0] = "Mouse";
    PointerTypes2[PointerTypes2["Pen"] = 1] = "Pen";
    PointerTypes2[PointerTypes2["Touch"] = 2] = "Touch";
    return PointerTypes2;
})($604631306887a81e$var$PointerTypes || {});
var $604631306887a81e$var$MediaInteractions = /* @__PURE__ */ ((MediaInteractions2)=>{
    MediaInteractions2[MediaInteractions2["Play"] = 0] = "Play";
    MediaInteractions2[MediaInteractions2["Pause"] = 1] = "Pause";
    MediaInteractions2[MediaInteractions2["Seeked"] = 2] = "Seeked";
    MediaInteractions2[MediaInteractions2["VolumeChange"] = 3] = "VolumeChange";
    MediaInteractions2[MediaInteractions2["RateChange"] = 4] = "RateChange";
    return MediaInteractions2;
})($604631306887a81e$var$MediaInteractions || {});
function $604631306887a81e$var$getIFrameContentDocument(iframe) {
    try {
        return iframe.contentDocument;
    } catch (e2) {}
}
function $604631306887a81e$var$getIFrameContentWindow(iframe) {
    try {
        return iframe.contentWindow;
    } catch (e2) {}
}
function $604631306887a81e$var$isNodeInLinkedList(n2) {
    return "__ln" in n2;
}
class $604631306887a81e$var$DoubleLinkedList {
    constructor(){
        this.length = 0;
        this.head = null;
        this.tail = null;
    }
    get(position) {
        if (position >= this.length) throw new Error("Position outside of list range");
        let current = this.head;
        for(let index = 0; index < position; index++)current = current?.next || null;
        return current;
    }
    addNode(n2) {
        const node = {
            value: n2,
            previous: null,
            next: null
        };
        n2.__ln = node;
        if (n2.previousSibling && $604631306887a81e$var$isNodeInLinkedList(n2.previousSibling)) {
            const current = n2.previousSibling.__ln.next;
            node.next = current;
            node.previous = n2.previousSibling.__ln;
            n2.previousSibling.__ln.next = node;
            if (current) current.previous = node;
        } else if (n2.nextSibling && $604631306887a81e$var$isNodeInLinkedList(n2.nextSibling) && n2.nextSibling.__ln.previous) {
            const current = n2.nextSibling.__ln.previous;
            node.previous = current;
            node.next = n2.nextSibling.__ln;
            n2.nextSibling.__ln.previous = node;
            if (current) current.next = node;
        } else {
            if (this.head) this.head.previous = node;
            node.next = this.head;
            this.head = node;
        }
        if (node.next === null) this.tail = node;
        this.length++;
    }
    removeNode(n2) {
        const current = n2.__ln;
        if (!this.head) return;
        if (!current.previous) {
            this.head = current.next;
            if (this.head) this.head.previous = null;
            else this.tail = null;
        } else {
            current.previous.next = current.next;
            if (current.next) current.next.previous = current.previous;
            else this.tail = current.previous;
        }
        if (n2.__ln) delete n2.__ln;
        this.length--;
    }
}
const $604631306887a81e$var$moveKey = (id, parentId)=>`${id}@${parentId}`;
class $604631306887a81e$var$MutationBuffer {
    constructor(){
        this.frozen = false;
        this.locked = false;
        this.texts = [];
        this.attributes = [];
        this.attributeMap = /* @__PURE__ */ new WeakMap();
        this.removes = [];
        this.mapRemoves = [];
        this.movedMap = {};
        this.addedSet = /* @__PURE__ */ new Set();
        this.movedSet = /* @__PURE__ */ new Set();
        this.droppedSet = /* @__PURE__ */ new Set();
        this.processMutations = (mutations)=>{
            mutations.forEach(this.processMutation);
            this.emit();
        };
        this.emit = ()=>{
            if (this.frozen || this.locked) return;
            const adds = [];
            const addedIds = /* @__PURE__ */ new Set();
            const addList = new $604631306887a81e$var$DoubleLinkedList();
            const getNextId = (n2)=>{
                let ns = n2;
                let nextId = $604631306887a81e$var$IGNORED_NODE;
                while(nextId === $604631306887a81e$var$IGNORED_NODE){
                    ns = ns && ns.nextSibling;
                    nextId = ns && this.mirror.getId(ns);
                }
                return nextId;
            };
            const pushAdd = (n2)=>{
                if (!n2.parentNode || !$604631306887a81e$var$inDom(n2)) return;
                const parentId = $604631306887a81e$var$isShadowRoot(n2.parentNode) ? this.mirror.getId($604631306887a81e$var$getShadowHost(n2)) : this.mirror.getId(n2.parentNode);
                const nextId = getNextId(n2);
                if (parentId === -1 || nextId === -1) return addList.addNode(n2);
                const sn = $604631306887a81e$var$serializeNodeWithId(n2, {
                    doc: this.doc,
                    mirror: this.mirror,
                    blockClass: this.blockClass,
                    blockSelector: this.blockSelector,
                    maskAllText: this.maskAllText,
                    unblockSelector: this.unblockSelector,
                    maskTextClass: this.maskTextClass,
                    unmaskTextClass: this.unmaskTextClass,
                    maskTextSelector: this.maskTextSelector,
                    unmaskTextSelector: this.unmaskTextSelector,
                    skipChild: true,
                    newlyAddedElement: true,
                    inlineStylesheet: this.inlineStylesheet,
                    maskInputOptions: this.maskInputOptions,
                    maskAttributeFn: this.maskAttributeFn,
                    maskTextFn: this.maskTextFn,
                    maskInputFn: this.maskInputFn,
                    slimDOMOptions: this.slimDOMOptions,
                    dataURLOptions: this.dataURLOptions,
                    recordCanvas: this.recordCanvas,
                    inlineImages: this.inlineImages,
                    onSerialize: (currentN)=>{
                        if ($604631306887a81e$var$isSerializedIframe(currentN, this.mirror) && !$604631306887a81e$var$isBlocked(currentN, this.blockClass, this.blockSelector, this.unblockSelector, false)) this.iframeManager.addIframe(currentN);
                        if ($604631306887a81e$var$isSerializedStylesheet(currentN, this.mirror)) this.stylesheetManager.trackLinkElement(currentN);
                        if ($604631306887a81e$var$hasShadowRoot(n2)) this.shadowDomManager.addShadowRoot(n2.shadowRoot, this.doc);
                    },
                    onIframeLoad: (iframe, childSn)=>{
                        if ($604631306887a81e$var$isBlocked(iframe, this.blockClass, this.blockSelector, this.unblockSelector, false)) return;
                        this.iframeManager.attachIframe(iframe, childSn);
                        if (iframe.contentWindow) this.canvasManager.addWindow(iframe.contentWindow);
                        this.shadowDomManager.observeAttachShadow(iframe);
                    },
                    onStylesheetLoad: (link, childSn)=>{
                        this.stylesheetManager.attachLinkElement(link, childSn);
                    },
                    onBlockedImageLoad: (_imageEl, serializedNode, { width: width, height: height })=>{
                        this.mutationCb({
                            adds: [],
                            removes: [],
                            texts: [],
                            attributes: [
                                {
                                    id: serializedNode.id,
                                    attributes: {
                                        style: {
                                            width: `${width}px`,
                                            height: `${height}px`
                                        }
                                    }
                                }
                            ]
                        });
                    },
                    ignoreCSSAttributes: this.ignoreCSSAttributes
                });
                if (sn) {
                    adds.push({
                        parentId: parentId,
                        nextId: nextId,
                        node: sn
                    });
                    addedIds.add(sn.id);
                }
            };
            while(this.mapRemoves.length)this.mirror.removeNodeFromMap(this.mapRemoves.shift());
            for (const n2 of this.movedSet){
                if ($604631306887a81e$var$isParentRemoved(this.removes, n2, this.mirror) && !this.movedSet.has(n2.parentNode)) continue;
                pushAdd(n2);
            }
            for (const n2 of this.addedSet){
                if (!$604631306887a81e$var$isAncestorInSet(this.droppedSet, n2) && !$604631306887a81e$var$isParentRemoved(this.removes, n2, this.mirror)) pushAdd(n2);
                else if ($604631306887a81e$var$isAncestorInSet(this.movedSet, n2)) pushAdd(n2);
                else this.droppedSet.add(n2);
            }
            let candidate = null;
            while(addList.length){
                let node = null;
                if (candidate) {
                    const parentId = this.mirror.getId(candidate.value.parentNode);
                    const nextId = getNextId(candidate.value);
                    if (parentId !== -1 && nextId !== -1) node = candidate;
                }
                if (!node) {
                    let tailNode = addList.tail;
                    while(tailNode){
                        const _node = tailNode;
                        tailNode = tailNode.previous;
                        if (_node) {
                            const parentId = this.mirror.getId(_node.value.parentNode);
                            const nextId = getNextId(_node.value);
                            if (nextId === -1) continue;
                            else if (parentId !== -1) {
                                node = _node;
                                break;
                            } else {
                                const unhandledNode = _node.value;
                                if (unhandledNode.parentNode && unhandledNode.parentNode.nodeType === Node.DOCUMENT_FRAGMENT_NODE) {
                                    const shadowHost = unhandledNode.parentNode.host;
                                    const parentId2 = this.mirror.getId(shadowHost);
                                    if (parentId2 !== -1) {
                                        node = _node;
                                        break;
                                    }
                                }
                            }
                        }
                    }
                }
                if (!node) {
                    while(addList.head)addList.removeNode(addList.head.value);
                    break;
                }
                candidate = node.previous;
                addList.removeNode(node.value);
                pushAdd(node.value);
            }
            const payload = {
                texts: this.texts.map((text)=>({
                        id: this.mirror.getId(text.node),
                        value: text.value
                    })).filter((text)=>!addedIds.has(text.id)).filter((text)=>this.mirror.has(text.id)),
                attributes: this.attributes.map((attribute)=>{
                    const { attributes: attributes } = attribute;
                    if (typeof attributes.style === "string") {
                        const diffAsStr = JSON.stringify(attribute.styleDiff);
                        const unchangedAsStr = JSON.stringify(attribute._unchangedStyles);
                        if (diffAsStr.length < attributes.style.length) {
                            if ((diffAsStr + unchangedAsStr).split("var(").length === attributes.style.split("var(").length) attributes.style = attribute.styleDiff;
                        }
                    }
                    return {
                        id: this.mirror.getId(attribute.node),
                        attributes: attributes
                    };
                }).filter((attribute)=>!addedIds.has(attribute.id)).filter((attribute)=>this.mirror.has(attribute.id)),
                removes: this.removes,
                adds: adds
            };
            if (!payload.texts.length && !payload.attributes.length && !payload.removes.length && !payload.adds.length) return;
            this.texts = [];
            this.attributes = [];
            this.attributeMap = /* @__PURE__ */ new WeakMap();
            this.removes = [];
            this.addedSet = /* @__PURE__ */ new Set();
            this.movedSet = /* @__PURE__ */ new Set();
            this.droppedSet = /* @__PURE__ */ new Set();
            this.movedMap = {};
            this.mutationCb(payload);
        };
        this.processMutation = (m)=>{
            if ($604631306887a81e$var$isIgnored(m.target, this.mirror)) return;
            switch(m.type){
                case "characterData":
                    {
                        const value = m.target.textContent;
                        if (!$604631306887a81e$var$isBlocked(m.target, this.blockClass, this.blockSelector, this.unblockSelector, false) && value !== m.oldValue) this.texts.push({
                            value: $604631306887a81e$var$needMaskingText(m.target, this.maskTextClass, this.maskTextSelector, this.unmaskTextClass, this.unmaskTextSelector, this.maskAllText) && value ? this.maskTextFn ? this.maskTextFn(value, $604631306887a81e$var$closestElementOfNode$1(m.target)) : value.replace(/[\S]/g, "*") : value,
                            node: m.target
                        });
                        break;
                    }
                case "attributes":
                    {
                        const target = m.target;
                        let attributeName = m.attributeName;
                        let value = m.target.getAttribute(attributeName);
                        if (attributeName === "value") {
                            const type = $604631306887a81e$var$getInputType(target);
                            const tagName = target.tagName;
                            value = $604631306887a81e$var$getInputValue(target, tagName, type);
                            const isInputMasked = $604631306887a81e$var$shouldMaskInput({
                                maskInputOptions: this.maskInputOptions,
                                tagName: tagName,
                                type: type
                            });
                            const forceMask = $604631306887a81e$var$needMaskingText(m.target, this.maskTextClass, this.maskTextSelector, this.unmaskTextClass, this.unmaskTextSelector, isInputMasked);
                            value = $604631306887a81e$var$maskInputValue({
                                isMasked: forceMask,
                                element: target,
                                value: value,
                                maskInputFn: this.maskInputFn
                            });
                        }
                        if ($604631306887a81e$var$isBlocked(m.target, this.blockClass, this.blockSelector, this.unblockSelector, false) || value === m.oldValue) return;
                        let item = this.attributeMap.get(m.target);
                        if (target.tagName === "IFRAME" && attributeName === "src" && !this.keepIframeSrcFn(value)) {
                            const iframeDoc = $604631306887a81e$var$getIFrameContentDocument(target);
                            if (!iframeDoc) attributeName = "rr_src";
                            else return;
                        }
                        if (!item) {
                            item = {
                                node: m.target,
                                attributes: {},
                                styleDiff: {},
                                _unchangedStyles: {}
                            };
                            this.attributes.push(item);
                            this.attributeMap.set(m.target, item);
                        }
                        if (attributeName === "type" && target.tagName === "INPUT" && (m.oldValue || "").toLowerCase() === "password") target.setAttribute("data-rr-is-password", "true");
                        if (!$604631306887a81e$var$ignoreAttribute(target.tagName, attributeName)) {
                            item.attributes[attributeName] = $604631306887a81e$var$transformAttribute(this.doc, $604631306887a81e$var$toLowerCase(target.tagName), $604631306887a81e$var$toLowerCase(attributeName), value, target, this.maskAttributeFn);
                            if (attributeName === "style") {
                                if (!this.unattachedDoc) try {
                                    this.unattachedDoc = document.implementation.createHTMLDocument();
                                } catch (e2) {
                                    this.unattachedDoc = this.doc;
                                }
                                const old = this.unattachedDoc.createElement("span");
                                if (m.oldValue) old.setAttribute("style", m.oldValue);
                                for (const pname of Array.from(target.style)){
                                    const newValue = target.style.getPropertyValue(pname);
                                    const newPriority = target.style.getPropertyPriority(pname);
                                    if (newValue !== old.style.getPropertyValue(pname) || newPriority !== old.style.getPropertyPriority(pname)) {
                                        if (newPriority === "") item.styleDiff[pname] = newValue;
                                        else item.styleDiff[pname] = [
                                            newValue,
                                            newPriority
                                        ];
                                    } else item._unchangedStyles[pname] = [
                                        newValue,
                                        newPriority
                                    ];
                                }
                                for (const pname of Array.from(old.style))if (target.style.getPropertyValue(pname) === "") item.styleDiff[pname] = false;
                            }
                        }
                        break;
                    }
                case "childList":
                    if ($604631306887a81e$var$isBlocked(m.target, this.blockClass, this.blockSelector, this.unblockSelector, true)) return;
                    m.addedNodes.forEach((n2)=>this.genAdds(n2, m.target));
                    m.removedNodes.forEach((n2)=>{
                        const nodeId = this.mirror.getId(n2);
                        const parentId = $604631306887a81e$var$isShadowRoot(m.target) ? this.mirror.getId(m.target.host) : this.mirror.getId(m.target);
                        if ($604631306887a81e$var$isBlocked(m.target, this.blockClass, this.blockSelector, this.unblockSelector, false) || $604631306887a81e$var$isIgnored(n2, this.mirror) || !$604631306887a81e$var$isSerialized(n2, this.mirror)) return;
                        if (this.addedSet.has(n2)) {
                            $604631306887a81e$var$deepDelete(this.addedSet, n2);
                            this.droppedSet.add(n2);
                        } else if (this.addedSet.has(m.target) && nodeId === -1) ;
                        else if ($604631306887a81e$var$isAncestorRemoved(m.target, this.mirror)) ;
                        else if (this.movedSet.has(n2) && this.movedMap[$604631306887a81e$var$moveKey(nodeId, parentId)]) $604631306887a81e$var$deepDelete(this.movedSet, n2);
                        else this.removes.push({
                            parentId: parentId,
                            id: nodeId,
                            isShadow: $604631306887a81e$var$isShadowRoot(m.target) && $604631306887a81e$var$isNativeShadowDom(m.target) ? true : void 0
                        });
                        this.mapRemoves.push(n2);
                    });
                    break;
            }
        };
        this.genAdds = (n2, target)=>{
            if (this.processedNodeManager.inOtherBuffer(n2, this)) return;
            if (this.addedSet.has(n2) || this.movedSet.has(n2)) return;
            if (this.mirror.hasNode(n2)) {
                if ($604631306887a81e$var$isIgnored(n2, this.mirror)) return;
                this.movedSet.add(n2);
                let targetId = null;
                if (target && this.mirror.hasNode(target)) targetId = this.mirror.getId(target);
                if (targetId && targetId !== -1) this.movedMap[$604631306887a81e$var$moveKey(this.mirror.getId(n2), targetId)] = true;
            } else {
                this.addedSet.add(n2);
                this.droppedSet.delete(n2);
            }
            if (!$604631306887a81e$var$isBlocked(n2, this.blockClass, this.blockSelector, this.unblockSelector, false)) {
                if (n2.childNodes) n2.childNodes.forEach((childN)=>this.genAdds(childN));
                if ($604631306887a81e$var$hasShadowRoot(n2)) n2.shadowRoot.childNodes.forEach((childN)=>{
                    this.processedNodeManager.add(childN, this);
                    this.genAdds(childN, n2);
                });
            }
        };
    }
    init(options) {
        [
            "mutationCb",
            "blockClass",
            "blockSelector",
            "unblockSelector",
            "maskAllText",
            "maskTextClass",
            "unmaskTextClass",
            "maskTextSelector",
            "unmaskTextSelector",
            "inlineStylesheet",
            "maskInputOptions",
            "maskAttributeFn",
            "maskTextFn",
            "maskInputFn",
            "keepIframeSrcFn",
            "recordCanvas",
            "inlineImages",
            "slimDOMOptions",
            "dataURLOptions",
            "doc",
            "mirror",
            "iframeManager",
            "stylesheetManager",
            "shadowDomManager",
            "canvasManager",
            "processedNodeManager",
            "ignoreCSSAttributes"
        ].forEach((key)=>{
            this[key] = options[key];
        });
    }
    freeze() {
        this.frozen = true;
        this.canvasManager.freeze();
    }
    unfreeze() {
        this.frozen = false;
        this.canvasManager.unfreeze();
        this.emit();
    }
    isFrozen() {
        return this.frozen;
    }
    lock() {
        this.locked = true;
        this.canvasManager.lock();
    }
    unlock() {
        this.locked = false;
        this.canvasManager.unlock();
        this.emit();
    }
    reset() {
        this.shadowDomManager.reset();
        this.canvasManager.reset();
    }
}
function $604631306887a81e$var$deepDelete(addsSet, n2) {
    addsSet.delete(n2);
    n2.childNodes?.forEach((childN)=>$604631306887a81e$var$deepDelete(addsSet, childN));
}
function $604631306887a81e$var$isParentRemoved(removes, n2, mirror2) {
    if (removes.length === 0) return false;
    return $604631306887a81e$var$_isParentRemoved(removes, n2, mirror2);
}
function $604631306887a81e$var$_isParentRemoved(removes, n2, mirror2) {
    let node = n2.parentNode;
    while(node){
        const parentId = mirror2.getId(node);
        if (removes.some((r2)=>r2.id === parentId)) return true;
        node = node.parentNode;
    }
    return false;
}
function $604631306887a81e$var$isAncestorInSet(set, n2) {
    if (set.size === 0) return false;
    return $604631306887a81e$var$_isAncestorInSet(set, n2);
}
function $604631306887a81e$var$_isAncestorInSet(set, n2) {
    const { parentNode: parentNode } = n2;
    if (!parentNode) return false;
    if (set.has(parentNode)) return true;
    return $604631306887a81e$var$_isAncestorInSet(set, parentNode);
}
let $604631306887a81e$var$errorHandler;
function $604631306887a81e$var$registerErrorHandler(handler) {
    $604631306887a81e$var$errorHandler = handler;
}
function $604631306887a81e$var$unregisterErrorHandler() {
    $604631306887a81e$var$errorHandler = void 0;
}
const $604631306887a81e$var$callbackWrapper = (cb)=>{
    if (!$604631306887a81e$var$errorHandler) return cb;
    const rrwebWrapped = (...rest)=>{
        try {
            return cb(...rest);
        } catch (error) {
            if ($604631306887a81e$var$errorHandler && $604631306887a81e$var$errorHandler(error) === true) return ()=>{};
            throw error;
        }
    };
    return rrwebWrapped;
};
const $604631306887a81e$var$mutationBuffers = [];
function $604631306887a81e$var$getEventTarget(event) {
    try {
        if ("composedPath" in event) {
            const path = event.composedPath();
            if (path.length) return path[0];
        } else if ("path" in event && event.path.length) return event.path[0];
    } catch  {}
    return event && event.target;
}
function $604631306887a81e$var$initMutationObserver(options, rootEl) {
    const mutationBuffer = new $604631306887a81e$var$MutationBuffer();
    $604631306887a81e$var$mutationBuffers.push(mutationBuffer);
    mutationBuffer.init(options);
    let mutationObserverCtor = window.MutationObserver || /**
  * Some websites may disable MutationObserver by removing it from the window object.
  * If someone is using rrweb to build a browser extention or things like it, they
  * could not change the website's code but can have an opportunity to inject some
  * code before the website executing its JS logic.
  * Then they can do this to store the native MutationObserver:
  * window.__rrMutationObserver = MutationObserver
  */ window.__rrMutationObserver;
    const angularZoneSymbol = window?.Zone?.__symbol__?.("MutationObserver");
    if (angularZoneSymbol && window[angularZoneSymbol]) mutationObserverCtor = window[angularZoneSymbol];
    const observer = new mutationObserverCtor($604631306887a81e$var$callbackWrapper((mutations)=>{
        if (options.onMutation && options.onMutation(mutations) === false) return;
        mutationBuffer.processMutations.bind(mutationBuffer)(mutations);
    }));
    observer.observe(rootEl, {
        attributes: true,
        attributeOldValue: true,
        characterData: true,
        characterDataOldValue: true,
        childList: true,
        subtree: true
    });
    return observer;
}
function $604631306887a81e$var$initMoveObserver({ mousemoveCb: mousemoveCb, sampling: sampling, doc: doc, mirror: mirror2 }) {
    if (sampling.mousemove === false) return ()=>{};
    const threshold = typeof sampling.mousemove === "number" ? sampling.mousemove : 50;
    const callbackThreshold = typeof sampling.mousemoveCallback === "number" ? sampling.mousemoveCallback : 500;
    let positions = [];
    let timeBaseline;
    const wrappedCb = $604631306887a81e$var$throttle$1($604631306887a81e$var$callbackWrapper((source)=>{
        const totalOffset = Date.now() - timeBaseline;
        mousemoveCb(positions.map((p)=>{
            p.timeOffset -= totalOffset;
            return p;
        }), source);
        positions = [];
        timeBaseline = null;
    }), callbackThreshold);
    const updatePosition = $604631306887a81e$var$callbackWrapper($604631306887a81e$var$throttle$1($604631306887a81e$var$callbackWrapper((evt)=>{
        const target = $604631306887a81e$var$getEventTarget(evt);
        const { clientX: clientX, clientY: clientY } = $604631306887a81e$var$legacy_isTouchEvent(evt) ? evt.changedTouches[0] : evt;
        if (!timeBaseline) timeBaseline = $604631306887a81e$var$nowTimestamp();
        positions.push({
            x: clientX,
            y: clientY,
            id: mirror2.getId(target),
            timeOffset: $604631306887a81e$var$nowTimestamp() - timeBaseline
        });
        wrappedCb(typeof DragEvent !== "undefined" && evt instanceof DragEvent ? $604631306887a81e$var$IncrementalSource.Drag : evt instanceof MouseEvent ? $604631306887a81e$var$IncrementalSource.MouseMove : $604631306887a81e$var$IncrementalSource.TouchMove);
    }), threshold, {
        trailing: false
    }));
    const handlers = [
        $604631306887a81e$var$on("mousemove", updatePosition, doc),
        $604631306887a81e$var$on("touchmove", updatePosition, doc),
        $604631306887a81e$var$on("drag", updatePosition, doc)
    ];
    return $604631306887a81e$var$callbackWrapper(()=>{
        handlers.forEach((h)=>h());
    });
}
function $604631306887a81e$var$initMouseInteractionObserver({ mouseInteractionCb: mouseInteractionCb, doc: doc, mirror: mirror2, blockClass: blockClass, blockSelector: blockSelector, unblockSelector: unblockSelector, sampling: sampling }) {
    if (sampling.mouseInteraction === false) return ()=>{};
    const disableMap = sampling.mouseInteraction === true || sampling.mouseInteraction === void 0 ? {} : sampling.mouseInteraction;
    const handlers = [];
    let currentPointerType = null;
    const getHandler = (eventKey)=>{
        return (event)=>{
            const target = $604631306887a81e$var$getEventTarget(event);
            if ($604631306887a81e$var$isBlocked(target, blockClass, blockSelector, unblockSelector, true)) return;
            let pointerType = null;
            let thisEventKey = eventKey;
            if ("pointerType" in event) {
                switch(event.pointerType){
                    case "mouse":
                        pointerType = $604631306887a81e$var$PointerTypes.Mouse;
                        break;
                    case "touch":
                        pointerType = $604631306887a81e$var$PointerTypes.Touch;
                        break;
                    case "pen":
                        pointerType = $604631306887a81e$var$PointerTypes.Pen;
                        break;
                }
                if (pointerType === $604631306887a81e$var$PointerTypes.Touch) {
                    if ($604631306887a81e$var$MouseInteractions[eventKey] === $604631306887a81e$var$MouseInteractions.MouseDown) thisEventKey = "TouchStart";
                    else if ($604631306887a81e$var$MouseInteractions[eventKey] === $604631306887a81e$var$MouseInteractions.MouseUp) thisEventKey = "TouchEnd";
                } else $604631306887a81e$var$PointerTypes.Pen;
            } else if ($604631306887a81e$var$legacy_isTouchEvent(event)) pointerType = $604631306887a81e$var$PointerTypes.Touch;
            if (pointerType !== null) {
                currentPointerType = pointerType;
                if (thisEventKey.startsWith("Touch") && pointerType === $604631306887a81e$var$PointerTypes.Touch || thisEventKey.startsWith("Mouse") && pointerType === $604631306887a81e$var$PointerTypes.Mouse) pointerType = null;
            } else if ($604631306887a81e$var$MouseInteractions[eventKey] === $604631306887a81e$var$MouseInteractions.Click) {
                pointerType = currentPointerType;
                currentPointerType = null;
            }
            const e2 = $604631306887a81e$var$legacy_isTouchEvent(event) ? event.changedTouches[0] : event;
            if (!e2) return;
            const id = mirror2.getId(target);
            const { clientX: clientX, clientY: clientY } = e2;
            $604631306887a81e$var$callbackWrapper(mouseInteractionCb)({
                type: $604631306887a81e$var$MouseInteractions[thisEventKey],
                id: id,
                x: clientX,
                y: clientY,
                ...pointerType !== null && {
                    pointerType: pointerType
                }
            });
        };
    };
    Object.keys($604631306887a81e$var$MouseInteractions).filter((key)=>Number.isNaN(Number(key)) && !key.endsWith("_Departed") && disableMap[key] !== false).forEach((eventKey)=>{
        let eventName = $604631306887a81e$var$toLowerCase(eventKey);
        const handler = getHandler(eventKey);
        if (window.PointerEvent) switch($604631306887a81e$var$MouseInteractions[eventKey]){
            case $604631306887a81e$var$MouseInteractions.MouseDown:
            case $604631306887a81e$var$MouseInteractions.MouseUp:
                eventName = eventName.replace("mouse", "pointer");
                break;
            case $604631306887a81e$var$MouseInteractions.TouchStart:
            case $604631306887a81e$var$MouseInteractions.TouchEnd:
                return;
        }
        handlers.push($604631306887a81e$var$on(eventName, handler, doc));
    });
    return $604631306887a81e$var$callbackWrapper(()=>{
        handlers.forEach((h)=>h());
    });
}
function $604631306887a81e$var$initScrollObserver({ scrollCb: scrollCb, doc: doc, mirror: mirror2, blockClass: blockClass, blockSelector: blockSelector, unblockSelector: unblockSelector, sampling: sampling }) {
    const updatePosition = $604631306887a81e$var$callbackWrapper($604631306887a81e$var$throttle$1($604631306887a81e$var$callbackWrapper((evt)=>{
        const target = $604631306887a81e$var$getEventTarget(evt);
        if (!target || $604631306887a81e$var$isBlocked(target, blockClass, blockSelector, unblockSelector, true)) return;
        const id = mirror2.getId(target);
        if (target === doc && doc.defaultView) {
            const scrollLeftTop = $604631306887a81e$var$getWindowScroll(doc.defaultView);
            scrollCb({
                id: id,
                x: scrollLeftTop.left,
                y: scrollLeftTop.top
            });
        } else scrollCb({
            id: id,
            x: target.scrollLeft,
            y: target.scrollTop
        });
    }), sampling.scroll || 100));
    return $604631306887a81e$var$on("scroll", updatePosition, doc);
}
function $604631306887a81e$var$initViewportResizeObserver({ viewportResizeCb: viewportResizeCb }, { win: win }) {
    let lastH = -1;
    let lastW = -1;
    const updateDimension = $604631306887a81e$var$callbackWrapper($604631306887a81e$var$throttle$1($604631306887a81e$var$callbackWrapper(()=>{
        const height = $604631306887a81e$var$getWindowHeight();
        const width = $604631306887a81e$var$getWindowWidth();
        if (lastH !== height || lastW !== width) {
            viewportResizeCb({
                width: Number(width),
                height: Number(height)
            });
            lastH = height;
            lastW = width;
        }
    }), 200));
    return $604631306887a81e$var$on("resize", updateDimension, win);
}
const $604631306887a81e$var$INPUT_TAGS = [
    "INPUT",
    "TEXTAREA",
    "SELECT"
];
const $604631306887a81e$var$lastInputValueMap = /* @__PURE__ */ new WeakMap();
function $604631306887a81e$var$initInputObserver({ inputCb: inputCb, doc: doc, mirror: mirror2, blockClass: blockClass, blockSelector: blockSelector, unblockSelector: unblockSelector, ignoreClass: ignoreClass, ignoreSelector: ignoreSelector, maskInputOptions: maskInputOptions, maskInputFn: maskInputFn, sampling: sampling, userTriggeredOnInput: userTriggeredOnInput, maskTextClass: maskTextClass, unmaskTextClass: unmaskTextClass, maskTextSelector: maskTextSelector, unmaskTextSelector: unmaskTextSelector }) {
    function eventHandler(event) {
        let target = $604631306887a81e$var$getEventTarget(event);
        const userTriggered = event.isTrusted;
        const tagName = target && $604631306887a81e$var$toUpperCase(target.tagName);
        if (tagName === "OPTION") target = target.parentElement;
        if (!target || !tagName || $604631306887a81e$var$INPUT_TAGS.indexOf(tagName) < 0 || $604631306887a81e$var$isBlocked(target, blockClass, blockSelector, unblockSelector, true)) return;
        const el = target;
        if (el.classList.contains(ignoreClass) || ignoreSelector && el.matches(ignoreSelector)) return;
        const type = $604631306887a81e$var$getInputType(target);
        let text = $604631306887a81e$var$getInputValue(el, tagName, type);
        let isChecked = false;
        const isInputMasked = $604631306887a81e$var$shouldMaskInput({
            maskInputOptions: maskInputOptions,
            tagName: tagName,
            type: type
        });
        const forceMask = $604631306887a81e$var$needMaskingText(target, maskTextClass, maskTextSelector, unmaskTextClass, unmaskTextSelector, isInputMasked);
        if (type === "radio" || type === "checkbox") isChecked = target.checked;
        text = $604631306887a81e$var$maskInputValue({
            isMasked: forceMask,
            element: target,
            value: text,
            maskInputFn: maskInputFn
        });
        cbWithDedup(target, userTriggeredOnInput ? {
            text: text,
            isChecked: isChecked,
            userTriggered: userTriggered
        } : {
            text: text,
            isChecked: isChecked
        });
        const name = target.name;
        if (type === "radio" && name && isChecked) doc.querySelectorAll(`input[type="radio"][name="${name}"]`).forEach((el2)=>{
            if (el2 !== target) {
                const text2 = $604631306887a81e$var$maskInputValue({
                    // share mask behavior of `target`
                    isMasked: forceMask,
                    element: el2,
                    value: $604631306887a81e$var$getInputValue(el2, tagName, type),
                    maskInputFn: maskInputFn
                });
                cbWithDedup(el2, userTriggeredOnInput ? {
                    text: text2,
                    isChecked: !isChecked,
                    userTriggered: false
                } : {
                    text: text2,
                    isChecked: !isChecked
                });
            }
        });
    }
    function cbWithDedup(target, v2) {
        const lastInputValue = $604631306887a81e$var$lastInputValueMap.get(target);
        if (!lastInputValue || lastInputValue.text !== v2.text || lastInputValue.isChecked !== v2.isChecked) {
            $604631306887a81e$var$lastInputValueMap.set(target, v2);
            const id = mirror2.getId(target);
            $604631306887a81e$var$callbackWrapper(inputCb)({
                ...v2,
                id: id
            });
        }
    }
    const events = sampling.input === "last" ? [
        "change"
    ] : [
        "input",
        "change"
    ];
    const handlers = events.map((eventName)=>$604631306887a81e$var$on(eventName, $604631306887a81e$var$callbackWrapper(eventHandler), doc));
    const currentWindow = doc.defaultView;
    if (!currentWindow) return ()=>{
        handlers.forEach((h)=>h());
    };
    const propertyDescriptor = currentWindow.Object.getOwnPropertyDescriptor(currentWindow.HTMLInputElement.prototype, "value");
    const hookProperties = [
        [
            currentWindow.HTMLInputElement.prototype,
            "value"
        ],
        [
            currentWindow.HTMLInputElement.prototype,
            "checked"
        ],
        [
            currentWindow.HTMLSelectElement.prototype,
            "value"
        ],
        [
            currentWindow.HTMLTextAreaElement.prototype,
            "value"
        ],
        // Some UI library use selectedIndex to set select value
        [
            currentWindow.HTMLSelectElement.prototype,
            "selectedIndex"
        ],
        [
            currentWindow.HTMLOptionElement.prototype,
            "selected"
        ]
    ];
    if (propertyDescriptor && propertyDescriptor.set) handlers.push(...hookProperties.map((p)=>$604631306887a81e$var$hookSetter(p[0], p[1], {
            set () {
                $604631306887a81e$var$callbackWrapper(eventHandler)({
                    target: this,
                    isTrusted: false
                });
            }
        }, false, currentWindow)));
    return $604631306887a81e$var$callbackWrapper(()=>{
        handlers.forEach((h)=>h());
    });
}
function $604631306887a81e$var$getNestedCSSRulePositions(rule) {
    const positions = [];
    function recurse(childRule, pos) {
        if ($604631306887a81e$var$hasNestedCSSRule("CSSGroupingRule") && childRule.parentRule instanceof CSSGroupingRule || $604631306887a81e$var$hasNestedCSSRule("CSSMediaRule") && childRule.parentRule instanceof CSSMediaRule || $604631306887a81e$var$hasNestedCSSRule("CSSSupportsRule") && childRule.parentRule instanceof CSSSupportsRule || $604631306887a81e$var$hasNestedCSSRule("CSSConditionRule") && childRule.parentRule instanceof CSSConditionRule) {
            const rules2 = Array.from(childRule.parentRule.cssRules);
            const index = rules2.indexOf(childRule);
            pos.unshift(index);
        } else if (childRule.parentStyleSheet) {
            const rules2 = Array.from(childRule.parentStyleSheet.cssRules);
            const index = rules2.indexOf(childRule);
            pos.unshift(index);
        }
        return pos;
    }
    return recurse(rule, positions);
}
function $604631306887a81e$var$getIdAndStyleId(sheet, mirror2, styleMirror) {
    let id, styleId;
    if (!sheet) return {};
    if (sheet.ownerNode) id = mirror2.getId(sheet.ownerNode);
    else styleId = styleMirror.getId(sheet);
    return {
        styleId: styleId,
        id: id
    };
}
function $604631306887a81e$var$initStyleSheetObserver({ styleSheetRuleCb: styleSheetRuleCb, mirror: mirror2, stylesheetManager: stylesheetManager }, { win: win }) {
    if (!win.CSSStyleSheet || !win.CSSStyleSheet.prototype) return ()=>{};
    const insertRule = win.CSSStyleSheet.prototype.insertRule;
    win.CSSStyleSheet.prototype.insertRule = new Proxy(insertRule, {
        apply: $604631306887a81e$var$callbackWrapper((target, thisArg, argumentsList)=>{
            const [rule, index] = argumentsList;
            const { id: id, styleId: styleId } = $604631306887a81e$var$getIdAndStyleId(thisArg, mirror2, stylesheetManager.styleMirror);
            if (id && id !== -1 || styleId && styleId !== -1) styleSheetRuleCb({
                id: id,
                styleId: styleId,
                adds: [
                    {
                        rule: rule,
                        index: index
                    }
                ]
            });
            return target.apply(thisArg, argumentsList);
        })
    });
    const deleteRule = win.CSSStyleSheet.prototype.deleteRule;
    win.CSSStyleSheet.prototype.deleteRule = new Proxy(deleteRule, {
        apply: $604631306887a81e$var$callbackWrapper((target, thisArg, argumentsList)=>{
            const [index] = argumentsList;
            const { id: id, styleId: styleId } = $604631306887a81e$var$getIdAndStyleId(thisArg, mirror2, stylesheetManager.styleMirror);
            if (id && id !== -1 || styleId && styleId !== -1) styleSheetRuleCb({
                id: id,
                styleId: styleId,
                removes: [
                    {
                        index: index
                    }
                ]
            });
            return target.apply(thisArg, argumentsList);
        })
    });
    let replace;
    if (win.CSSStyleSheet.prototype.replace) {
        replace = win.CSSStyleSheet.prototype.replace;
        win.CSSStyleSheet.prototype.replace = new Proxy(replace, {
            apply: $604631306887a81e$var$callbackWrapper((target, thisArg, argumentsList)=>{
                const [text] = argumentsList;
                const { id: id, styleId: styleId } = $604631306887a81e$var$getIdAndStyleId(thisArg, mirror2, stylesheetManager.styleMirror);
                if (id && id !== -1 || styleId && styleId !== -1) styleSheetRuleCb({
                    id: id,
                    styleId: styleId,
                    replace: text
                });
                return target.apply(thisArg, argumentsList);
            })
        });
    }
    let replaceSync;
    if (win.CSSStyleSheet.prototype.replaceSync) {
        replaceSync = win.CSSStyleSheet.prototype.replaceSync;
        win.CSSStyleSheet.prototype.replaceSync = new Proxy(replaceSync, {
            apply: $604631306887a81e$var$callbackWrapper((target, thisArg, argumentsList)=>{
                const [text] = argumentsList;
                const { id: id, styleId: styleId } = $604631306887a81e$var$getIdAndStyleId(thisArg, mirror2, stylesheetManager.styleMirror);
                if (id && id !== -1 || styleId && styleId !== -1) styleSheetRuleCb({
                    id: id,
                    styleId: styleId,
                    replaceSync: text
                });
                return target.apply(thisArg, argumentsList);
            })
        });
    }
    const supportedNestedCSSRuleTypes = {};
    if ($604631306887a81e$var$canMonkeyPatchNestedCSSRule("CSSGroupingRule")) supportedNestedCSSRuleTypes.CSSGroupingRule = win.CSSGroupingRule;
    else {
        if ($604631306887a81e$var$canMonkeyPatchNestedCSSRule("CSSMediaRule")) supportedNestedCSSRuleTypes.CSSMediaRule = win.CSSMediaRule;
        if ($604631306887a81e$var$canMonkeyPatchNestedCSSRule("CSSConditionRule")) supportedNestedCSSRuleTypes.CSSConditionRule = win.CSSConditionRule;
        if ($604631306887a81e$var$canMonkeyPatchNestedCSSRule("CSSSupportsRule")) supportedNestedCSSRuleTypes.CSSSupportsRule = win.CSSSupportsRule;
    }
    const unmodifiedFunctions = {};
    Object.entries(supportedNestedCSSRuleTypes).forEach(([typeKey, type])=>{
        unmodifiedFunctions[typeKey] = {
            // eslint-disable-next-line @typescript-eslint/unbound-method
            insertRule: type.prototype.insertRule,
            // eslint-disable-next-line @typescript-eslint/unbound-method
            deleteRule: type.prototype.deleteRule
        };
        type.prototype.insertRule = new Proxy(unmodifiedFunctions[typeKey].insertRule, {
            apply: $604631306887a81e$var$callbackWrapper((target, thisArg, argumentsList)=>{
                const [rule, index] = argumentsList;
                const { id: id, styleId: styleId } = $604631306887a81e$var$getIdAndStyleId(thisArg.parentStyleSheet, mirror2, stylesheetManager.styleMirror);
                if (id && id !== -1 || styleId && styleId !== -1) styleSheetRuleCb({
                    id: id,
                    styleId: styleId,
                    adds: [
                        {
                            rule: rule,
                            index: [
                                ...$604631306887a81e$var$getNestedCSSRulePositions(thisArg),
                                index || 0
                            ]
                        }
                    ]
                });
                return target.apply(thisArg, argumentsList);
            })
        });
        type.prototype.deleteRule = new Proxy(unmodifiedFunctions[typeKey].deleteRule, {
            apply: $604631306887a81e$var$callbackWrapper((target, thisArg, argumentsList)=>{
                const [index] = argumentsList;
                const { id: id, styleId: styleId } = $604631306887a81e$var$getIdAndStyleId(thisArg.parentStyleSheet, mirror2, stylesheetManager.styleMirror);
                if (id && id !== -1 || styleId && styleId !== -1) styleSheetRuleCb({
                    id: id,
                    styleId: styleId,
                    removes: [
                        {
                            index: [
                                ...$604631306887a81e$var$getNestedCSSRulePositions(thisArg),
                                index
                            ]
                        }
                    ]
                });
                return target.apply(thisArg, argumentsList);
            })
        });
    });
    return $604631306887a81e$var$callbackWrapper(()=>{
        win.CSSStyleSheet.prototype.insertRule = insertRule;
        win.CSSStyleSheet.prototype.deleteRule = deleteRule;
        replace && (win.CSSStyleSheet.prototype.replace = replace);
        replaceSync && (win.CSSStyleSheet.prototype.replaceSync = replaceSync);
        Object.entries(supportedNestedCSSRuleTypes).forEach(([typeKey, type])=>{
            type.prototype.insertRule = unmodifiedFunctions[typeKey].insertRule;
            type.prototype.deleteRule = unmodifiedFunctions[typeKey].deleteRule;
        });
    });
}
function $604631306887a81e$var$initAdoptedStyleSheetObserver({ mirror: mirror2, stylesheetManager: stylesheetManager }, host) {
    let hostId = null;
    if (host.nodeName === "#document") hostId = mirror2.getId(host);
    else hostId = mirror2.getId(host.host);
    const patchTarget = host.nodeName === "#document" ? host.defaultView?.Document : host.ownerDocument?.defaultView?.ShadowRoot;
    const originalPropertyDescriptor = patchTarget?.prototype ? Object.getOwnPropertyDescriptor(patchTarget?.prototype, "adoptedStyleSheets") : void 0;
    if (hostId === null || hostId === -1 || !patchTarget || !originalPropertyDescriptor) return ()=>{};
    Object.defineProperty(host, "adoptedStyleSheets", {
        configurable: originalPropertyDescriptor.configurable,
        enumerable: originalPropertyDescriptor.enumerable,
        get () {
            return originalPropertyDescriptor.get?.call(this);
        },
        set (sheets) {
            const result = originalPropertyDescriptor.set?.call(this, sheets);
            if (hostId !== null && hostId !== -1) try {
                stylesheetManager.adoptStyleSheets(sheets, hostId);
            } catch (e2) {}
            return result;
        }
    });
    return $604631306887a81e$var$callbackWrapper(()=>{
        Object.defineProperty(host, "adoptedStyleSheets", {
            configurable: originalPropertyDescriptor.configurable,
            enumerable: originalPropertyDescriptor.enumerable,
            // eslint-disable-next-line @typescript-eslint/unbound-method
            get: originalPropertyDescriptor.get,
            // eslint-disable-next-line @typescript-eslint/unbound-method
            set: originalPropertyDescriptor.set
        });
    });
}
function $604631306887a81e$var$initStyleDeclarationObserver({ styleDeclarationCb: styleDeclarationCb, mirror: mirror2, ignoreCSSAttributes: ignoreCSSAttributes, stylesheetManager: stylesheetManager }, { win: win }) {
    const setProperty = win.CSSStyleDeclaration.prototype.setProperty;
    win.CSSStyleDeclaration.prototype.setProperty = new Proxy(setProperty, {
        apply: $604631306887a81e$var$callbackWrapper((target, thisArg, argumentsList)=>{
            const [property, value, priority] = argumentsList;
            if (ignoreCSSAttributes.has(property)) return setProperty.apply(thisArg, [
                property,
                value,
                priority
            ]);
            const { id: id, styleId: styleId } = $604631306887a81e$var$getIdAndStyleId(thisArg.parentRule?.parentStyleSheet, mirror2, stylesheetManager.styleMirror);
            if (id && id !== -1 || styleId && styleId !== -1) styleDeclarationCb({
                id: id,
                styleId: styleId,
                set: {
                    property: property,
                    value: value,
                    priority: priority
                },
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                index: $604631306887a81e$var$getNestedCSSRulePositions(thisArg.parentRule)
            });
            return target.apply(thisArg, argumentsList);
        })
    });
    const removeProperty = win.CSSStyleDeclaration.prototype.removeProperty;
    win.CSSStyleDeclaration.prototype.removeProperty = new Proxy(removeProperty, {
        apply: $604631306887a81e$var$callbackWrapper((target, thisArg, argumentsList)=>{
            const [property] = argumentsList;
            if (ignoreCSSAttributes.has(property)) return removeProperty.apply(thisArg, [
                property
            ]);
            const { id: id, styleId: styleId } = $604631306887a81e$var$getIdAndStyleId(thisArg.parentRule?.parentStyleSheet, mirror2, stylesheetManager.styleMirror);
            if (id && id !== -1 || styleId && styleId !== -1) styleDeclarationCb({
                id: id,
                styleId: styleId,
                remove: {
                    property: property
                },
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                index: $604631306887a81e$var$getNestedCSSRulePositions(thisArg.parentRule)
            });
            return target.apply(thisArg, argumentsList);
        })
    });
    return $604631306887a81e$var$callbackWrapper(()=>{
        win.CSSStyleDeclaration.prototype.setProperty = setProperty;
        win.CSSStyleDeclaration.prototype.removeProperty = removeProperty;
    });
}
function $604631306887a81e$var$initMediaInteractionObserver({ mediaInteractionCb: mediaInteractionCb, blockClass: blockClass, blockSelector: blockSelector, unblockSelector: unblockSelector, mirror: mirror2, sampling: sampling, doc: doc }) {
    const handler = $604631306887a81e$var$callbackWrapper((type)=>$604631306887a81e$var$throttle$1($604631306887a81e$var$callbackWrapper((event)=>{
            const target = $604631306887a81e$var$getEventTarget(event);
            if (!target || $604631306887a81e$var$isBlocked(target, blockClass, blockSelector, unblockSelector, true)) return;
            const { currentTime: currentTime, volume: volume, muted: muted, playbackRate: playbackRate } = target;
            mediaInteractionCb({
                type: type,
                id: mirror2.getId(target),
                currentTime: currentTime,
                volume: volume,
                muted: muted,
                playbackRate: playbackRate
            });
        }), sampling.media || 500));
    const handlers = [
        $604631306887a81e$var$on("play", handler($604631306887a81e$var$MediaInteractions.Play), doc),
        $604631306887a81e$var$on("pause", handler($604631306887a81e$var$MediaInteractions.Pause), doc),
        $604631306887a81e$var$on("seeked", handler($604631306887a81e$var$MediaInteractions.Seeked), doc),
        $604631306887a81e$var$on("volumechange", handler($604631306887a81e$var$MediaInteractions.VolumeChange), doc),
        $604631306887a81e$var$on("ratechange", handler($604631306887a81e$var$MediaInteractions.RateChange), doc)
    ];
    return $604631306887a81e$var$callbackWrapper(()=>{
        handlers.forEach((h)=>h());
    });
}
function $604631306887a81e$var$initFontObserver({ fontCb: fontCb, doc: doc }) {
    const win = doc.defaultView;
    if (!win) return ()=>{};
    const handlers = [];
    const fontMap = /* @__PURE__ */ new WeakMap();
    const originalFontFace = win.FontFace;
    win.FontFace = function FontFace2(family, source, descriptors) {
        const fontFace = new originalFontFace(family, source, descriptors);
        fontMap.set(fontFace, {
            family: family,
            buffer: typeof source !== "string",
            descriptors: descriptors,
            fontSource: typeof source === "string" ? source : JSON.stringify(Array.from(new Uint8Array(source)))
        });
        return fontFace;
    };
    const restoreHandler = $604631306887a81e$var$patch(doc.fonts, "add", function(original) {
        return function(fontFace) {
            $604631306887a81e$var$setTimeout$1($604631306887a81e$var$callbackWrapper(()=>{
                const p = fontMap.get(fontFace);
                if (p) {
                    fontCb(p);
                    fontMap.delete(fontFace);
                }
            }), 0);
            return original.apply(this, [
                fontFace
            ]);
        };
    });
    handlers.push(()=>{
        win.FontFace = originalFontFace;
    });
    handlers.push(restoreHandler);
    return $604631306887a81e$var$callbackWrapper(()=>{
        handlers.forEach((h)=>h());
    });
}
function $604631306887a81e$var$initSelectionObserver(param) {
    const { doc: doc, mirror: mirror2, blockClass: blockClass, blockSelector: blockSelector, unblockSelector: unblockSelector, selectionCb: selectionCb } = param;
    let collapsed = true;
    const updateSelection = $604631306887a81e$var$callbackWrapper(()=>{
        const selection = doc.getSelection();
        if (!selection || collapsed && selection?.isCollapsed) return;
        collapsed = selection.isCollapsed || false;
        const ranges = [];
        const count = selection.rangeCount || 0;
        for(let i2 = 0; i2 < count; i2++){
            const range = selection.getRangeAt(i2);
            const { startContainer: startContainer, startOffset: startOffset, endContainer: endContainer, endOffset: endOffset } = range;
            const blocked = $604631306887a81e$var$isBlocked(startContainer, blockClass, blockSelector, unblockSelector, true) || $604631306887a81e$var$isBlocked(endContainer, blockClass, blockSelector, unblockSelector, true);
            if (blocked) continue;
            ranges.push({
                start: mirror2.getId(startContainer),
                startOffset: startOffset,
                end: mirror2.getId(endContainer),
                endOffset: endOffset
            });
        }
        selectionCb({
            ranges: ranges
        });
    });
    updateSelection();
    return $604631306887a81e$var$on("selectionchange", updateSelection);
}
function $604631306887a81e$var$initCustomElementObserver({ doc: doc, customElementCb: customElementCb }) {
    const win = doc.defaultView;
    if (!win || !win.customElements) return ()=>{};
    const restoreHandler = $604631306887a81e$var$patch(win.customElements, "define", function(original) {
        return function(name, constructor, options) {
            try {
                customElementCb({
                    define: {
                        name: name
                    }
                });
            } catch (e2) {}
            return original.apply(this, [
                name,
                constructor,
                options
            ]);
        };
    });
    return restoreHandler;
}
function $604631306887a81e$var$initObservers(o2, _hooks = {}) {
    const currentWindow = o2.doc.defaultView;
    if (!currentWindow) return ()=>{};
    let mutationObserver;
    if (o2.recordDOM) mutationObserver = $604631306887a81e$var$initMutationObserver(o2, o2.doc);
    const mousemoveHandler = $604631306887a81e$var$initMoveObserver(o2);
    const mouseInteractionHandler = $604631306887a81e$var$initMouseInteractionObserver(o2);
    const scrollHandler = $604631306887a81e$var$initScrollObserver(o2);
    const viewportResizeHandler = $604631306887a81e$var$initViewportResizeObserver(o2, {
        win: currentWindow
    });
    const inputHandler = $604631306887a81e$var$initInputObserver(o2);
    const mediaInteractionHandler = $604631306887a81e$var$initMediaInteractionObserver(o2);
    let styleSheetObserver = ()=>{};
    let adoptedStyleSheetObserver = ()=>{};
    let styleDeclarationObserver = ()=>{};
    let fontObserver = ()=>{};
    if (o2.recordDOM) {
        styleSheetObserver = $604631306887a81e$var$initStyleSheetObserver(o2, {
            win: currentWindow
        });
        adoptedStyleSheetObserver = $604631306887a81e$var$initAdoptedStyleSheetObserver(o2, o2.doc);
        styleDeclarationObserver = $604631306887a81e$var$initStyleDeclarationObserver(o2, {
            win: currentWindow
        });
        if (o2.collectFonts) fontObserver = $604631306887a81e$var$initFontObserver(o2);
    }
    const selectionObserver = $604631306887a81e$var$initSelectionObserver(o2);
    const customElementObserver = $604631306887a81e$var$initCustomElementObserver(o2);
    const pluginHandlers = [];
    for (const plugin of o2.plugins)pluginHandlers.push(plugin.observer(plugin.callback, currentWindow, plugin.options));
    return $604631306887a81e$var$callbackWrapper(()=>{
        $604631306887a81e$var$mutationBuffers.forEach((b)=>b.reset());
        mutationObserver?.disconnect();
        mousemoveHandler();
        mouseInteractionHandler();
        scrollHandler();
        viewportResizeHandler();
        inputHandler();
        mediaInteractionHandler();
        styleSheetObserver();
        adoptedStyleSheetObserver();
        styleDeclarationObserver();
        fontObserver();
        selectionObserver();
        customElementObserver();
        pluginHandlers.forEach((h)=>h());
    });
}
function $604631306887a81e$var$hasNestedCSSRule(prop) {
    return typeof window[prop] !== "undefined";
}
function $604631306887a81e$var$canMonkeyPatchNestedCSSRule(prop) {
    return Boolean(typeof window[prop] !== "undefined" && // Note: Generally, this check _shouldn't_ be necessary
    // However, in some scenarios (e.g. jsdom) this can sometimes fail, so we check for it here
    window[prop].prototype && "insertRule" in window[prop].prototype && "deleteRule" in window[prop].prototype);
}
class $604631306887a81e$var$CrossOriginIframeMirror {
    constructor(generateIdFn){
        this.generateIdFn = generateIdFn;
        this.iframeIdToRemoteIdMap = /* @__PURE__ */ new WeakMap();
        this.iframeRemoteIdToIdMap = /* @__PURE__ */ new WeakMap();
    }
    getId(iframe, remoteId, idToRemoteMap, remoteToIdMap) {
        const idToRemoteIdMap = idToRemoteMap || this.getIdToRemoteIdMap(iframe);
        const remoteIdToIdMap = remoteToIdMap || this.getRemoteIdToIdMap(iframe);
        let id = idToRemoteIdMap.get(remoteId);
        if (!id) {
            id = this.generateIdFn();
            idToRemoteIdMap.set(remoteId, id);
            remoteIdToIdMap.set(id, remoteId);
        }
        return id;
    }
    getIds(iframe, remoteId) {
        const idToRemoteIdMap = this.getIdToRemoteIdMap(iframe);
        const remoteIdToIdMap = this.getRemoteIdToIdMap(iframe);
        return remoteId.map((id)=>this.getId(iframe, id, idToRemoteIdMap, remoteIdToIdMap));
    }
    getRemoteId(iframe, id, map) {
        const remoteIdToIdMap = map || this.getRemoteIdToIdMap(iframe);
        if (typeof id !== "number") return id;
        const remoteId = remoteIdToIdMap.get(id);
        if (!remoteId) return -1;
        return remoteId;
    }
    getRemoteIds(iframe, ids) {
        const remoteIdToIdMap = this.getRemoteIdToIdMap(iframe);
        return ids.map((id)=>this.getRemoteId(iframe, id, remoteIdToIdMap));
    }
    reset(iframe) {
        if (!iframe) {
            this.iframeIdToRemoteIdMap = /* @__PURE__ */ new WeakMap();
            this.iframeRemoteIdToIdMap = /* @__PURE__ */ new WeakMap();
            return;
        }
        this.iframeIdToRemoteIdMap.delete(iframe);
        this.iframeRemoteIdToIdMap.delete(iframe);
    }
    getIdToRemoteIdMap(iframe) {
        let idToRemoteIdMap = this.iframeIdToRemoteIdMap.get(iframe);
        if (!idToRemoteIdMap) {
            idToRemoteIdMap = /* @__PURE__ */ new Map();
            this.iframeIdToRemoteIdMap.set(iframe, idToRemoteIdMap);
        }
        return idToRemoteIdMap;
    }
    getRemoteIdToIdMap(iframe) {
        let remoteIdToIdMap = this.iframeRemoteIdToIdMap.get(iframe);
        if (!remoteIdToIdMap) {
            remoteIdToIdMap = /* @__PURE__ */ new Map();
            this.iframeRemoteIdToIdMap.set(iframe, remoteIdToIdMap);
        }
        return remoteIdToIdMap;
    }
}
class $604631306887a81e$var$IframeManagerNoop {
    constructor(){
        this.crossOriginIframeMirror = new $604631306887a81e$var$CrossOriginIframeMirror($604631306887a81e$var$genId);
        this.crossOriginIframeRootIdMap = /* @__PURE__ */ new WeakMap();
    }
    addIframe() {}
    addLoadListener() {}
    attachIframe() {}
}
class $604631306887a81e$var$IframeManager {
    constructor(options){
        this.iframes = /* @__PURE__ */ new WeakMap();
        this.crossOriginIframeMap = /* @__PURE__ */ new WeakMap();
        this.crossOriginIframeMirror = new $604631306887a81e$var$CrossOriginIframeMirror($604631306887a81e$var$genId);
        this.crossOriginIframeRootIdMap = /* @__PURE__ */ new WeakMap();
        this.mutationCb = options.mutationCb;
        this.wrappedEmit = options.wrappedEmit;
        this.stylesheetManager = options.stylesheetManager;
        this.recordCrossOriginIframes = options.recordCrossOriginIframes;
        this.crossOriginIframeStyleMirror = new $604631306887a81e$var$CrossOriginIframeMirror(this.stylesheetManager.styleMirror.generateId.bind(this.stylesheetManager.styleMirror));
        this.mirror = options.mirror;
        if (this.recordCrossOriginIframes) window.addEventListener("message", this.handleMessage.bind(this));
    }
    addIframe(iframeEl) {
        this.iframes.set(iframeEl, true);
        if (iframeEl.contentWindow) this.crossOriginIframeMap.set(iframeEl.contentWindow, iframeEl);
    }
    addLoadListener(cb) {
        this.loadListener = cb;
    }
    attachIframe(iframeEl, childSn) {
        this.mutationCb({
            adds: [
                {
                    parentId: this.mirror.getId(iframeEl),
                    nextId: null,
                    node: childSn
                }
            ],
            removes: [],
            texts: [],
            attributes: [],
            isAttachIframe: true
        });
        if (this.recordCrossOriginIframes) iframeEl.contentWindow?.addEventListener("message", this.handleMessage.bind(this));
        this.loadListener?.(iframeEl);
        const iframeDoc = $604631306887a81e$var$getIFrameContentDocument(iframeEl);
        if (iframeDoc && iframeDoc.adoptedStyleSheets && iframeDoc.adoptedStyleSheets.length > 0) this.stylesheetManager.adoptStyleSheets(iframeDoc.adoptedStyleSheets, this.mirror.getId(iframeDoc));
    }
    handleMessage(message) {
        const crossOriginMessageEvent = message;
        if (crossOriginMessageEvent.data.type !== "rrweb" || // To filter out the rrweb messages which are forwarded by some sites.
        crossOriginMessageEvent.origin !== crossOriginMessageEvent.data.origin) return;
        const iframeSourceWindow = message.source;
        if (!iframeSourceWindow) return;
        const iframeEl = this.crossOriginIframeMap.get(message.source);
        if (!iframeEl) return;
        const transformedEvent = this.transformCrossOriginEvent(iframeEl, crossOriginMessageEvent.data.event);
        if (transformedEvent) this.wrappedEmit(transformedEvent, crossOriginMessageEvent.data.isCheckout);
    }
    transformCrossOriginEvent(iframeEl, e2) {
        switch(e2.type){
            case $604631306887a81e$var$EventType.FullSnapshot:
                {
                    this.crossOriginIframeMirror.reset(iframeEl);
                    this.crossOriginIframeStyleMirror.reset(iframeEl);
                    this.replaceIdOnNode(e2.data.node, iframeEl);
                    const rootId = e2.data.node.id;
                    this.crossOriginIframeRootIdMap.set(iframeEl, rootId);
                    this.patchRootIdOnNode(e2.data.node, rootId);
                    return {
                        timestamp: e2.timestamp,
                        type: $604631306887a81e$var$EventType.IncrementalSnapshot,
                        data: {
                            source: $604631306887a81e$var$IncrementalSource.Mutation,
                            adds: [
                                {
                                    parentId: this.mirror.getId(iframeEl),
                                    nextId: null,
                                    node: e2.data.node
                                }
                            ],
                            removes: [],
                            texts: [],
                            attributes: [],
                            isAttachIframe: true
                        }
                    };
                }
            case $604631306887a81e$var$EventType.Meta:
            case $604631306887a81e$var$EventType.Load:
            case $604631306887a81e$var$EventType.DomContentLoaded:
                return false;
            case $604631306887a81e$var$EventType.Plugin:
                return e2;
            case $604631306887a81e$var$EventType.Custom:
                this.replaceIds(e2.data.payload, iframeEl, [
                    "id",
                    "parentId",
                    "previousId",
                    "nextId"
                ]);
                return e2;
            case $604631306887a81e$var$EventType.IncrementalSnapshot:
                switch(e2.data.source){
                    case $604631306887a81e$var$IncrementalSource.Mutation:
                        e2.data.adds.forEach((n2)=>{
                            this.replaceIds(n2, iframeEl, [
                                "parentId",
                                "nextId",
                                "previousId"
                            ]);
                            this.replaceIdOnNode(n2.node, iframeEl);
                            const rootId = this.crossOriginIframeRootIdMap.get(iframeEl);
                            rootId && this.patchRootIdOnNode(n2.node, rootId);
                        });
                        e2.data.removes.forEach((n2)=>{
                            this.replaceIds(n2, iframeEl, [
                                "parentId",
                                "id"
                            ]);
                        });
                        e2.data.attributes.forEach((n2)=>{
                            this.replaceIds(n2, iframeEl, [
                                "id"
                            ]);
                        });
                        e2.data.texts.forEach((n2)=>{
                            this.replaceIds(n2, iframeEl, [
                                "id"
                            ]);
                        });
                        return e2;
                    case $604631306887a81e$var$IncrementalSource.Drag:
                    case $604631306887a81e$var$IncrementalSource.TouchMove:
                    case $604631306887a81e$var$IncrementalSource.MouseMove:
                        e2.data.positions.forEach((p)=>{
                            this.replaceIds(p, iframeEl, [
                                "id"
                            ]);
                        });
                        return e2;
                    case $604631306887a81e$var$IncrementalSource.ViewportResize:
                        return false;
                    case $604631306887a81e$var$IncrementalSource.MediaInteraction:
                    case $604631306887a81e$var$IncrementalSource.MouseInteraction:
                    case $604631306887a81e$var$IncrementalSource.Scroll:
                    case $604631306887a81e$var$IncrementalSource.CanvasMutation:
                    case $604631306887a81e$var$IncrementalSource.Input:
                        this.replaceIds(e2.data, iframeEl, [
                            "id"
                        ]);
                        return e2;
                    case $604631306887a81e$var$IncrementalSource.StyleSheetRule:
                    case $604631306887a81e$var$IncrementalSource.StyleDeclaration:
                        this.replaceIds(e2.data, iframeEl, [
                            "id"
                        ]);
                        this.replaceStyleIds(e2.data, iframeEl, [
                            "styleId"
                        ]);
                        return e2;
                    case $604631306887a81e$var$IncrementalSource.Font:
                        return e2;
                    case $604631306887a81e$var$IncrementalSource.Selection:
                        e2.data.ranges.forEach((range)=>{
                            this.replaceIds(range, iframeEl, [
                                "start",
                                "end"
                            ]);
                        });
                        return e2;
                    case $604631306887a81e$var$IncrementalSource.AdoptedStyleSheet:
                        this.replaceIds(e2.data, iframeEl, [
                            "id"
                        ]);
                        this.replaceStyleIds(e2.data, iframeEl, [
                            "styleIds"
                        ]);
                        e2.data.styles?.forEach((style)=>{
                            this.replaceStyleIds(style, iframeEl, [
                                "styleId"
                            ]);
                        });
                        return e2;
                }
        }
        return false;
    }
    replace(iframeMirror, obj, iframeEl, keys) {
        for (const key of keys){
            if (!Array.isArray(obj[key]) && typeof obj[key] !== "number") continue;
            if (Array.isArray(obj[key])) obj[key] = iframeMirror.getIds(iframeEl, obj[key]);
            else obj[key] = iframeMirror.getId(iframeEl, obj[key]);
        }
        return obj;
    }
    replaceIds(obj, iframeEl, keys) {
        return this.replace(this.crossOriginIframeMirror, obj, iframeEl, keys);
    }
    replaceStyleIds(obj, iframeEl, keys) {
        return this.replace(this.crossOriginIframeStyleMirror, obj, iframeEl, keys);
    }
    replaceIdOnNode(node, iframeEl) {
        this.replaceIds(node, iframeEl, [
            "id",
            "rootId"
        ]);
        if ("childNodes" in node) node.childNodes.forEach((child)=>{
            this.replaceIdOnNode(child, iframeEl);
        });
    }
    patchRootIdOnNode(node, rootId) {
        if (node.type !== $604631306887a81e$var$NodeType$2.Document && !node.rootId) node.rootId = rootId;
        if ("childNodes" in node) node.childNodes.forEach((child)=>{
            this.patchRootIdOnNode(child, rootId);
        });
    }
}
class $604631306887a81e$var$ShadowDomManagerNoop {
    init() {}
    addShadowRoot() {}
    observeAttachShadow() {}
    reset() {}
}
class $604631306887a81e$var$ShadowDomManager {
    constructor(options){
        this.shadowDoms = /* @__PURE__ */ new WeakSet();
        this.restoreHandlers = [];
        this.mutationCb = options.mutationCb;
        this.scrollCb = options.scrollCb;
        this.bypassOptions = options.bypassOptions;
        this.mirror = options.mirror;
        this.init();
    }
    init() {
        this.reset();
        this.patchAttachShadow(Element, document);
    }
    addShadowRoot(shadowRoot, doc) {
        if (!$604631306887a81e$var$isNativeShadowDom(shadowRoot)) return;
        if (this.shadowDoms.has(shadowRoot)) return;
        this.shadowDoms.add(shadowRoot);
        this.bypassOptions.canvasManager.addShadowRoot(shadowRoot);
        const observer = $604631306887a81e$var$initMutationObserver({
            ...this.bypassOptions,
            doc: doc,
            mutationCb: this.mutationCb,
            mirror: this.mirror,
            shadowDomManager: this
        }, shadowRoot);
        this.restoreHandlers.push(()=>observer.disconnect());
        this.restoreHandlers.push($604631306887a81e$var$initScrollObserver({
            ...this.bypassOptions,
            scrollCb: this.scrollCb,
            // https://gist.github.com/praveenpuglia/0832da687ed5a5d7a0907046c9ef1813
            // scroll is not allowed to pass the boundary, so we need to listen the shadow document
            doc: shadowRoot,
            mirror: this.mirror
        }));
        $604631306887a81e$var$setTimeout$1(()=>{
            if (shadowRoot.adoptedStyleSheets && shadowRoot.adoptedStyleSheets.length > 0) this.bypassOptions.stylesheetManager.adoptStyleSheets(shadowRoot.adoptedStyleSheets, this.mirror.getId(shadowRoot.host));
            this.restoreHandlers.push($604631306887a81e$var$initAdoptedStyleSheetObserver({
                mirror: this.mirror,
                stylesheetManager: this.bypassOptions.stylesheetManager
            }, shadowRoot));
        }, 0);
    }
    /**
   * Monkey patch 'attachShadow' of an IFrameElement to observe newly added shadow doms.
   */ observeAttachShadow(iframeElement) {
        const iframeDoc = $604631306887a81e$var$getIFrameContentDocument(iframeElement);
        const iframeWindow = $604631306887a81e$var$getIFrameContentWindow(iframeElement);
        if (!iframeDoc || !iframeWindow) return;
        this.patchAttachShadow(iframeWindow.Element, iframeDoc);
    }
    /**
   * Patch 'attachShadow' to observe newly added shadow doms.
   */ patchAttachShadow(element, doc) {
        const manager = this;
        this.restoreHandlers.push($604631306887a81e$var$patch(element.prototype, "attachShadow", function(original) {
            return function(option) {
                const shadowRoot = original.call(this, option);
                if (this.shadowRoot && $604631306887a81e$var$inDom(this)) manager.addShadowRoot(this.shadowRoot, doc);
                return shadowRoot;
            };
        }));
    }
    reset() {
        this.restoreHandlers.forEach((handler)=>{
            try {
                handler();
            } catch (e2) {}
        });
        this.restoreHandlers = [];
        this.shadowDoms = /* @__PURE__ */ new WeakSet();
        this.bypassOptions.canvasManager.resetShadowRoots();
    }
}
var $604631306887a81e$var$chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
var $604631306887a81e$var$lookup = typeof Uint8Array === "undefined" ? [] : new Uint8Array(256);
for(var $604631306887a81e$var$i$1 = 0; $604631306887a81e$var$i$1 < $604631306887a81e$var$chars.length; $604631306887a81e$var$i$1++)$604631306887a81e$var$lookup[$604631306887a81e$var$chars.charCodeAt($604631306887a81e$var$i$1)] = $604631306887a81e$var$i$1;
class $604631306887a81e$var$CanvasManagerNoop {
    reset() {}
    freeze() {}
    unfreeze() {}
    lock() {}
    unlock() {}
    snapshot() {}
    addWindow() {}
    addShadowRoot() {}
    resetShadowRoots() {}
}
class $604631306887a81e$var$StylesheetManager {
    constructor(options){
        this.trackedLinkElements = /* @__PURE__ */ new WeakSet();
        this.styleMirror = new $604631306887a81e$var$StyleSheetMirror();
        this.mutationCb = options.mutationCb;
        this.adoptedStyleSheetCb = options.adoptedStyleSheetCb;
    }
    attachLinkElement(linkEl, childSn) {
        if ("_cssText" in childSn.attributes) this.mutationCb({
            adds: [],
            removes: [],
            texts: [],
            attributes: [
                {
                    id: childSn.id,
                    attributes: childSn.attributes
                }
            ]
        });
        this.trackLinkElement(linkEl);
    }
    trackLinkElement(linkEl) {
        if (this.trackedLinkElements.has(linkEl)) return;
        this.trackedLinkElements.add(linkEl);
        this.trackStylesheetInLinkElement(linkEl);
    }
    adoptStyleSheets(sheets, hostId) {
        if (sheets.length === 0) return;
        const adoptedStyleSheetData = {
            id: hostId,
            styleIds: []
        };
        const styles = [];
        for (const sheet of sheets){
            let styleId;
            if (!this.styleMirror.has(sheet)) {
                styleId = this.styleMirror.add(sheet);
                styles.push({
                    styleId: styleId,
                    rules: Array.from(sheet.rules || CSSRule, (r2, index)=>({
                            rule: $604631306887a81e$var$stringifyRule(r2),
                            index: index
                        }))
                });
            } else styleId = this.styleMirror.getId(sheet);
            adoptedStyleSheetData.styleIds.push(styleId);
        }
        if (styles.length > 0) adoptedStyleSheetData.styles = styles;
        this.adoptedStyleSheetCb(adoptedStyleSheetData);
    }
    reset() {
        this.styleMirror.reset();
        this.trackedLinkElements = /* @__PURE__ */ new WeakSet();
    }
    // TODO: take snapshot on stylesheet reload by applying event listener
    trackStylesheetInLinkElement(_linkEl) {}
}
class $604631306887a81e$var$ProcessedNodeManager {
    constructor(){
        this.nodeMap = /* @__PURE__ */ new WeakMap();
        this.active = false;
    }
    inOtherBuffer(node, thisBuffer) {
        const buffers = this.nodeMap.get(node);
        return buffers && Array.from(buffers).some((buffer)=>buffer !== thisBuffer);
    }
    add(node, buffer) {
        if (!this.active) {
            this.active = true;
            $604631306887a81e$var$onRequestAnimationFrame(()=>{
                this.nodeMap = /* @__PURE__ */ new WeakMap();
                this.active = false;
            });
        }
        this.nodeMap.set(node, (this.nodeMap.get(node) || /* @__PURE__ */ new Set()).add(buffer));
    }
    destroy() {}
}
let $604631306887a81e$var$wrappedEmit;
let $604631306887a81e$var$_takeFullSnapshot;
try {
    if (Array.from([
        1
    ], (x)=>x * 2)[0] !== 2) {
        const cleanFrame = document.createElement("iframe");
        document.body.appendChild(cleanFrame);
        Array.from = cleanFrame.contentWindow?.Array.from || Array.from;
        document.body.removeChild(cleanFrame);
    }
} catch (err) {
    console.debug("Unable to override Array.from", err);
}
const $604631306887a81e$var$mirror = $604631306887a81e$var$createMirror$2();
function $604631306887a81e$var$record(options = {}) {
    const { emit: emit, checkoutEveryNms: checkoutEveryNms, checkoutEveryNth: checkoutEveryNth, blockClass: blockClass = "rr-block", blockSelector: blockSelector = null, unblockSelector: unblockSelector = null, ignoreClass: ignoreClass = "rr-ignore", ignoreSelector: ignoreSelector = null, maskAllText: maskAllText = false, maskTextClass: maskTextClass = "rr-mask", unmaskTextClass: unmaskTextClass = null, maskTextSelector: maskTextSelector = null, unmaskTextSelector: unmaskTextSelector = null, inlineStylesheet: inlineStylesheet = true, maskAllInputs: maskAllInputs, maskInputOptions: _maskInputOptions, slimDOMOptions: _slimDOMOptions, maskAttributeFn: maskAttributeFn, maskInputFn: maskInputFn, maskTextFn: maskTextFn, maxCanvasSize: maxCanvasSize = null, packFn: packFn, sampling: sampling = {}, dataURLOptions: dataURLOptions = {}, mousemoveWait: mousemoveWait, recordDOM: recordDOM = true, recordCanvas: recordCanvas = false, recordCrossOriginIframes: recordCrossOriginIframes = false, recordAfter: recordAfter = options.recordAfter === "DOMContentLoaded" ? options.recordAfter : "load", userTriggeredOnInput: userTriggeredOnInput = false, collectFonts: collectFonts = false, inlineImages: inlineImages = false, plugins: plugins, keepIframeSrcFn: keepIframeSrcFn = ()=>false, ignoreCSSAttributes: ignoreCSSAttributes = /* @__PURE__ */ new Set([]), errorHandler: errorHandler2, onMutation: onMutation, getCanvasManager: getCanvasManager } = options;
    $604631306887a81e$var$registerErrorHandler(errorHandler2);
    const inEmittingFrame = recordCrossOriginIframes ? window.parent === window : true;
    let passEmitsToParent = false;
    if (!inEmittingFrame) try {
        if (window.parent.document) passEmitsToParent = false;
    } catch (e2) {
        passEmitsToParent = true;
    }
    if (inEmittingFrame && !emit) throw new Error("emit function is required");
    if (!inEmittingFrame && !passEmitsToParent) return ()=>{};
    if (mousemoveWait !== void 0 && sampling.mousemove === void 0) sampling.mousemove = mousemoveWait;
    $604631306887a81e$var$mirror.reset();
    const maskInputOptions = maskAllInputs === true ? {
        color: true,
        date: true,
        "datetime-local": true,
        email: true,
        month: true,
        number: true,
        range: true,
        search: true,
        tel: true,
        text: true,
        time: true,
        url: true,
        week: true,
        textarea: true,
        select: true,
        radio: true,
        checkbox: true
    } : _maskInputOptions !== void 0 ? _maskInputOptions : {};
    const slimDOMOptions = _slimDOMOptions === true || _slimDOMOptions === "all" ? {
        script: true,
        comment: true,
        headFavicon: true,
        headWhitespace: true,
        headMetaSocial: true,
        headMetaRobots: true,
        headMetaHttpEquiv: true,
        headMetaVerification: true,
        // the following are off for slimDOMOptions === true,
        // as they destroy some (hidden) info:
        headMetaAuthorship: _slimDOMOptions === "all",
        headMetaDescKeywords: _slimDOMOptions === "all"
    } : _slimDOMOptions ? _slimDOMOptions : {};
    $604631306887a81e$var$polyfill$1();
    let lastFullSnapshotEvent;
    let incrementalSnapshotCount = 0;
    const eventProcessor = (e2)=>{
        for (const plugin of plugins || [])if (plugin.eventProcessor) e2 = plugin.eventProcessor(e2);
        if (packFn && // Disable packing events which will be emitted to parent frames.
        !passEmitsToParent) e2 = packFn(e2);
        return e2;
    };
    $604631306887a81e$var$wrappedEmit = (r2, isCheckout)=>{
        const e2 = r2;
        e2.timestamp = $604631306887a81e$var$nowTimestamp();
        if ($604631306887a81e$var$mutationBuffers[0]?.isFrozen() && e2.type !== $604631306887a81e$var$EventType.FullSnapshot && !(e2.type === $604631306887a81e$var$EventType.IncrementalSnapshot && e2.data.source === $604631306887a81e$var$IncrementalSource.Mutation)) $604631306887a81e$var$mutationBuffers.forEach((buf)=>buf.unfreeze());
        if (inEmittingFrame) emit?.(eventProcessor(e2), isCheckout);
        else if (passEmitsToParent) {
            const message = {
                type: "rrweb",
                event: eventProcessor(e2),
                origin: window.location.origin,
                isCheckout: isCheckout
            };
            window.parent.postMessage(message, "*");
        }
        if (e2.type === $604631306887a81e$var$EventType.FullSnapshot) {
            lastFullSnapshotEvent = e2;
            incrementalSnapshotCount = 0;
        } else if (e2.type === $604631306887a81e$var$EventType.IncrementalSnapshot) {
            if (e2.data.source === $604631306887a81e$var$IncrementalSource.Mutation && e2.data.isAttachIframe) return;
            incrementalSnapshotCount++;
            const exceedCount = checkoutEveryNth && incrementalSnapshotCount >= checkoutEveryNth;
            const exceedTime = checkoutEveryNms && lastFullSnapshotEvent && e2.timestamp - lastFullSnapshotEvent.timestamp > checkoutEveryNms;
            if (exceedCount || exceedTime) takeFullSnapshot2(true);
        }
    };
    const wrappedMutationEmit = (m)=>{
        $604631306887a81e$var$wrappedEmit({
            type: $604631306887a81e$var$EventType.IncrementalSnapshot,
            data: {
                source: $604631306887a81e$var$IncrementalSource.Mutation,
                ...m
            }
        });
    };
    const wrappedScrollEmit = (p)=>$604631306887a81e$var$wrappedEmit({
            type: $604631306887a81e$var$EventType.IncrementalSnapshot,
            data: {
                source: $604631306887a81e$var$IncrementalSource.Scroll,
                ...p
            }
        });
    const wrappedCanvasMutationEmit = (p)=>$604631306887a81e$var$wrappedEmit({
            type: $604631306887a81e$var$EventType.IncrementalSnapshot,
            data: {
                source: $604631306887a81e$var$IncrementalSource.CanvasMutation,
                ...p
            }
        });
    const wrappedAdoptedStyleSheetEmit = (a2)=>$604631306887a81e$var$wrappedEmit({
            type: $604631306887a81e$var$EventType.IncrementalSnapshot,
            data: {
                source: $604631306887a81e$var$IncrementalSource.AdoptedStyleSheet,
                ...a2
            }
        });
    const stylesheetManager = new $604631306887a81e$var$StylesheetManager({
        mutationCb: wrappedMutationEmit,
        adoptedStyleSheetCb: wrappedAdoptedStyleSheetEmit
    });
    const iframeManager = typeof __RRWEB_EXCLUDE_IFRAME__ === "boolean" && __RRWEB_EXCLUDE_IFRAME__ ? new $604631306887a81e$var$IframeManagerNoop() : new $604631306887a81e$var$IframeManager({
        mirror: $604631306887a81e$var$mirror,
        mutationCb: wrappedMutationEmit,
        stylesheetManager: stylesheetManager,
        recordCrossOriginIframes: recordCrossOriginIframes,
        wrappedEmit: $604631306887a81e$var$wrappedEmit
    });
    for (const plugin of plugins || [])if (plugin.getMirror) plugin.getMirror({
        nodeMirror: $604631306887a81e$var$mirror,
        crossOriginIframeMirror: iframeManager.crossOriginIframeMirror,
        crossOriginIframeStyleMirror: iframeManager.crossOriginIframeStyleMirror
    });
    const processedNodeManager = new $604631306887a81e$var$ProcessedNodeManager();
    const canvasManager = $604631306887a81e$var$_getCanvasManager(getCanvasManager, {
        mirror: $604631306887a81e$var$mirror,
        win: window,
        mutationCb: (p)=>$604631306887a81e$var$wrappedEmit({
                type: $604631306887a81e$var$EventType.IncrementalSnapshot,
                data: {
                    source: $604631306887a81e$var$IncrementalSource.CanvasMutation,
                    ...p
                }
            }),
        recordCanvas: recordCanvas,
        blockClass: blockClass,
        blockSelector: blockSelector,
        unblockSelector: unblockSelector,
        maxCanvasSize: maxCanvasSize,
        sampling: sampling["canvas"],
        dataURLOptions: dataURLOptions,
        errorHandler: errorHandler2
    });
    const shadowDomManager = typeof __RRWEB_EXCLUDE_SHADOW_DOM__ === "boolean" && __RRWEB_EXCLUDE_SHADOW_DOM__ ? new $604631306887a81e$var$ShadowDomManagerNoop() : new $604631306887a81e$var$ShadowDomManager({
        mutationCb: wrappedMutationEmit,
        scrollCb: wrappedScrollEmit,
        bypassOptions: {
            onMutation: onMutation,
            blockClass: blockClass,
            blockSelector: blockSelector,
            unblockSelector: unblockSelector,
            maskAllText: maskAllText,
            maskTextClass: maskTextClass,
            unmaskTextClass: unmaskTextClass,
            maskTextSelector: maskTextSelector,
            unmaskTextSelector: unmaskTextSelector,
            inlineStylesheet: inlineStylesheet,
            maskInputOptions: maskInputOptions,
            dataURLOptions: dataURLOptions,
            maskAttributeFn: maskAttributeFn,
            maskTextFn: maskTextFn,
            maskInputFn: maskInputFn,
            recordCanvas: recordCanvas,
            inlineImages: inlineImages,
            sampling: sampling,
            slimDOMOptions: slimDOMOptions,
            iframeManager: iframeManager,
            stylesheetManager: stylesheetManager,
            canvasManager: canvasManager,
            keepIframeSrcFn: keepIframeSrcFn,
            processedNodeManager: processedNodeManager,
            ignoreCSSAttributes: ignoreCSSAttributes
        },
        mirror: $604631306887a81e$var$mirror
    });
    const takeFullSnapshot2 = (isCheckout = false)=>{
        if (!recordDOM) return;
        $604631306887a81e$var$wrappedEmit({
            type: $604631306887a81e$var$EventType.Meta,
            data: {
                href: window.location.href,
                width: $604631306887a81e$var$getWindowWidth(),
                height: $604631306887a81e$var$getWindowHeight()
            }
        }, isCheckout);
        stylesheetManager.reset();
        shadowDomManager.init();
        $604631306887a81e$var$mutationBuffers.forEach((buf)=>buf.lock());
        const node = $604631306887a81e$var$snapshot(document, {
            mirror: $604631306887a81e$var$mirror,
            blockClass: blockClass,
            blockSelector: blockSelector,
            unblockSelector: unblockSelector,
            maskAllText: maskAllText,
            maskTextClass: maskTextClass,
            unmaskTextClass: unmaskTextClass,
            maskTextSelector: maskTextSelector,
            unmaskTextSelector: unmaskTextSelector,
            inlineStylesheet: inlineStylesheet,
            maskAllInputs: maskInputOptions,
            maskAttributeFn: maskAttributeFn,
            maskInputFn: maskInputFn,
            maskTextFn: maskTextFn,
            slimDOM: slimDOMOptions,
            dataURLOptions: dataURLOptions,
            recordCanvas: recordCanvas,
            inlineImages: inlineImages,
            onSerialize: (n2)=>{
                if ($604631306887a81e$var$isSerializedIframe(n2, $604631306887a81e$var$mirror)) iframeManager.addIframe(n2);
                if ($604631306887a81e$var$isSerializedStylesheet(n2, $604631306887a81e$var$mirror)) stylesheetManager.trackLinkElement(n2);
                if ($604631306887a81e$var$hasShadowRoot(n2)) shadowDomManager.addShadowRoot(n2.shadowRoot, document);
            },
            onIframeLoad: (iframe, childSn)=>{
                iframeManager.attachIframe(iframe, childSn);
                if (iframe.contentWindow) canvasManager.addWindow(iframe.contentWindow);
                shadowDomManager.observeAttachShadow(iframe);
            },
            onStylesheetLoad: (linkEl, childSn)=>{
                stylesheetManager.attachLinkElement(linkEl, childSn);
            },
            onBlockedImageLoad: (_imageEl, serializedNode, { width: width, height: height })=>{
                wrappedMutationEmit({
                    adds: [],
                    removes: [],
                    texts: [],
                    attributes: [
                        {
                            id: serializedNode.id,
                            attributes: {
                                style: {
                                    width: `${width}px`,
                                    height: `${height}px`
                                }
                            }
                        }
                    ]
                });
            },
            keepIframeSrcFn: keepIframeSrcFn,
            ignoreCSSAttributes: ignoreCSSAttributes
        });
        if (!node) return console.warn("Failed to snapshot the document");
        $604631306887a81e$var$wrappedEmit({
            type: $604631306887a81e$var$EventType.FullSnapshot,
            data: {
                node: node,
                initialOffset: $604631306887a81e$var$getWindowScroll(window)
            }
        });
        $604631306887a81e$var$mutationBuffers.forEach((buf)=>buf.unlock());
        if (document.adoptedStyleSheets && document.adoptedStyleSheets.length > 0) stylesheetManager.adoptStyleSheets(document.adoptedStyleSheets, $604631306887a81e$var$mirror.getId(document));
    };
    $604631306887a81e$var$_takeFullSnapshot = takeFullSnapshot2;
    try {
        const handlers = [];
        const observe = (doc)=>{
            return $604631306887a81e$var$callbackWrapper($604631306887a81e$var$initObservers)({
                onMutation: onMutation,
                mutationCb: wrappedMutationEmit,
                mousemoveCb: (positions, source)=>$604631306887a81e$var$wrappedEmit({
                        type: $604631306887a81e$var$EventType.IncrementalSnapshot,
                        data: {
                            source: source,
                            positions: positions
                        }
                    }),
                mouseInteractionCb: (d)=>$604631306887a81e$var$wrappedEmit({
                        type: $604631306887a81e$var$EventType.IncrementalSnapshot,
                        data: {
                            source: $604631306887a81e$var$IncrementalSource.MouseInteraction,
                            ...d
                        }
                    }),
                scrollCb: wrappedScrollEmit,
                viewportResizeCb: (d)=>$604631306887a81e$var$wrappedEmit({
                        type: $604631306887a81e$var$EventType.IncrementalSnapshot,
                        data: {
                            source: $604631306887a81e$var$IncrementalSource.ViewportResize,
                            ...d
                        }
                    }),
                inputCb: (v2)=>$604631306887a81e$var$wrappedEmit({
                        type: $604631306887a81e$var$EventType.IncrementalSnapshot,
                        data: {
                            source: $604631306887a81e$var$IncrementalSource.Input,
                            ...v2
                        }
                    }),
                mediaInteractionCb: (p)=>$604631306887a81e$var$wrappedEmit({
                        type: $604631306887a81e$var$EventType.IncrementalSnapshot,
                        data: {
                            source: $604631306887a81e$var$IncrementalSource.MediaInteraction,
                            ...p
                        }
                    }),
                styleSheetRuleCb: (r2)=>$604631306887a81e$var$wrappedEmit({
                        type: $604631306887a81e$var$EventType.IncrementalSnapshot,
                        data: {
                            source: $604631306887a81e$var$IncrementalSource.StyleSheetRule,
                            ...r2
                        }
                    }),
                styleDeclarationCb: (r2)=>$604631306887a81e$var$wrappedEmit({
                        type: $604631306887a81e$var$EventType.IncrementalSnapshot,
                        data: {
                            source: $604631306887a81e$var$IncrementalSource.StyleDeclaration,
                            ...r2
                        }
                    }),
                canvasMutationCb: wrappedCanvasMutationEmit,
                fontCb: (p)=>$604631306887a81e$var$wrappedEmit({
                        type: $604631306887a81e$var$EventType.IncrementalSnapshot,
                        data: {
                            source: $604631306887a81e$var$IncrementalSource.Font,
                            ...p
                        }
                    }),
                selectionCb: (p)=>{
                    $604631306887a81e$var$wrappedEmit({
                        type: $604631306887a81e$var$EventType.IncrementalSnapshot,
                        data: {
                            source: $604631306887a81e$var$IncrementalSource.Selection,
                            ...p
                        }
                    });
                },
                customElementCb: (c2)=>{
                    $604631306887a81e$var$wrappedEmit({
                        type: $604631306887a81e$var$EventType.IncrementalSnapshot,
                        data: {
                            source: $604631306887a81e$var$IncrementalSource.CustomElement,
                            ...c2
                        }
                    });
                },
                blockClass: blockClass,
                ignoreClass: ignoreClass,
                ignoreSelector: ignoreSelector,
                maskAllText: maskAllText,
                maskTextClass: maskTextClass,
                unmaskTextClass: unmaskTextClass,
                maskTextSelector: maskTextSelector,
                unmaskTextSelector: unmaskTextSelector,
                maskInputOptions: maskInputOptions,
                inlineStylesheet: inlineStylesheet,
                sampling: sampling,
                recordDOM: recordDOM,
                recordCanvas: recordCanvas,
                inlineImages: inlineImages,
                userTriggeredOnInput: userTriggeredOnInput,
                collectFonts: collectFonts,
                doc: doc,
                maskAttributeFn: maskAttributeFn,
                maskInputFn: maskInputFn,
                maskTextFn: maskTextFn,
                keepIframeSrcFn: keepIframeSrcFn,
                blockSelector: blockSelector,
                unblockSelector: unblockSelector,
                slimDOMOptions: slimDOMOptions,
                dataURLOptions: dataURLOptions,
                mirror: $604631306887a81e$var$mirror,
                iframeManager: iframeManager,
                stylesheetManager: stylesheetManager,
                shadowDomManager: shadowDomManager,
                processedNodeManager: processedNodeManager,
                canvasManager: canvasManager,
                ignoreCSSAttributes: ignoreCSSAttributes,
                plugins: plugins?.filter((p)=>p.observer)?.map((p)=>({
                        observer: p.observer,
                        options: p.options,
                        callback: (payload)=>$604631306887a81e$var$wrappedEmit({
                                type: $604631306887a81e$var$EventType.Plugin,
                                data: {
                                    plugin: p.name,
                                    payload: payload
                                }
                            })
                    })) || []
            }, {});
        };
        iframeManager.addLoadListener((iframeEl)=>{
            try {
                handlers.push(observe(iframeEl.contentDocument));
            } catch (error) {
                console.warn(error);
            }
        });
        const init = ()=>{
            takeFullSnapshot2();
            handlers.push(observe(document));
        };
        if (document.readyState === "interactive" || document.readyState === "complete") init();
        else {
            handlers.push($604631306887a81e$var$on("DOMContentLoaded", ()=>{
                $604631306887a81e$var$wrappedEmit({
                    type: $604631306887a81e$var$EventType.DomContentLoaded,
                    data: {}
                });
                if (recordAfter === "DOMContentLoaded") init();
            }));
            handlers.push($604631306887a81e$var$on("load", ()=>{
                $604631306887a81e$var$wrappedEmit({
                    type: $604631306887a81e$var$EventType.Load,
                    data: {}
                });
                if (recordAfter === "load") init();
            }, window));
        }
        return ()=>{
            handlers.forEach((h)=>h());
            processedNodeManager.destroy();
            $604631306887a81e$var$_takeFullSnapshot = void 0;
            $604631306887a81e$var$unregisterErrorHandler();
        };
    } catch (error) {
        console.warn(error);
    }
}
function $604631306887a81e$var$takeFullSnapshot(isCheckout) {
    if (!$604631306887a81e$var$_takeFullSnapshot) throw new Error("please take full snapshot after start recording");
    $604631306887a81e$var$_takeFullSnapshot(isCheckout);
}
$604631306887a81e$var$record.mirror = $604631306887a81e$var$mirror;
$604631306887a81e$var$record.takeFullSnapshot = $604631306887a81e$var$takeFullSnapshot;
function $604631306887a81e$var$_getCanvasManager(getCanvasManagerFn, options) {
    try {
        return getCanvasManagerFn ? getCanvasManagerFn(options) : new $604631306887a81e$var$CanvasManagerNoop();
    } catch  {
        console.warn("Unable to initialize CanvasManager");
        return new $604631306887a81e$var$CanvasManagerNoop();
    }
}
var $604631306887a81e$var$n;
!function(t2) {
    t2[t2.NotStarted = 0] = "NotStarted", t2[t2.Running = 1] = "Running", t2[t2.Stopped = 2] = "Stopped";
}($604631306887a81e$var$n || ($604631306887a81e$var$n = {}));
const $604631306887a81e$var$ReplayEventTypeIncrementalSnapshot = 3;
const $604631306887a81e$var$ReplayEventTypeCustom = 5;
/**
 * Converts a timestamp to ms, if it was in s, or keeps it as ms.
 */ function $604631306887a81e$var$timestampToMs(timestamp) {
    const isMs = timestamp > 9999999999;
    return isMs ? timestamp : timestamp * 1000;
}
/**
 * Converts a timestamp to s, if it was in ms, or keeps it as s.
 */ function $604631306887a81e$var$timestampToS(timestamp) {
    const isMs = timestamp > 9999999999;
    return isMs ? timestamp / 1000 : timestamp;
}
/**
 * Add a breadcrumb event to replay.
 */ function $604631306887a81e$var$addBreadcrumbEvent(replay, breadcrumb) {
    if (breadcrumb.category === 'sentry.transaction') return;
    if ([
        'ui.click',
        'ui.input'
    ].includes(breadcrumb.category)) replay.triggerUserActivity();
    else replay.checkAndHandleExpiredSession();
    replay.addUpdate(()=>{
        // This should never reject
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        replay.throttledAddEvent({
            type: $604631306887a81e$var$EventType.Custom,
            // TODO: We were converting from ms to seconds for breadcrumbs, spans,
            // but maybe we should just keep them as milliseconds
            timestamp: (breadcrumb.timestamp || 0) * 1000,
            data: {
                tag: 'breadcrumb',
                // normalize to max. 10 depth and 1_000 properties per object
                payload: (0, $2d7134eeb4bc669b$export$a3295358bff77e)(breadcrumb, 10, 1000)
            }
        });
        // Do not flush after console log messages
        return breadcrumb.category === 'console';
    });
}
const $604631306887a81e$var$INTERACTIVE_SELECTOR = 'button,a';
/** Get the closest interactive parent element, or else return the given element. */ function $604631306887a81e$var$getClosestInteractive(element) {
    const closestInteractive = element.closest($604631306887a81e$var$INTERACTIVE_SELECTOR);
    return closestInteractive || element;
}
/**
 * For clicks, we check if the target is inside of a button or link
 * If so, we use this as the target instead
 * This is useful because if you click on the image in <button><img></button>,
 * The target will be the image, not the button, which we don't want here
 */ function $604631306887a81e$var$getClickTargetNode(event) {
    const target = $604631306887a81e$var$getTargetNode(event);
    if (!target || !(target instanceof Element)) return target;
    return $604631306887a81e$var$getClosestInteractive(target);
}
/** Get the event target node. */ function $604631306887a81e$var$getTargetNode(event) {
    if ($604631306887a81e$var$isEventWithTarget(event)) return event.target;
    return event;
}
function $604631306887a81e$var$isEventWithTarget(event) {
    return typeof event === 'object' && !!event && 'target' in event;
}
let $604631306887a81e$var$handlers;
/**
 * Register a handler to be called when `window.open()` is called.
 * Returns a cleanup function.
 */ function $604631306887a81e$var$onWindowOpen(cb) {
    // Ensure to only register this once
    if (!$604631306887a81e$var$handlers) {
        $604631306887a81e$var$handlers = [];
        $604631306887a81e$var$monkeyPatchWindowOpen();
    }
    $604631306887a81e$var$handlers.push(cb);
    return ()=>{
        const pos = $604631306887a81e$var$handlers ? $604631306887a81e$var$handlers.indexOf(cb) : -1;
        if (pos > -1) $604631306887a81e$var$handlers.splice(pos, 1);
    };
}
function $604631306887a81e$var$monkeyPatchWindowOpen() {
    (0, $269eeb69635ed414$export$9563e054e6f787fb)($604631306887a81e$var$WINDOW, 'open', function(originalWindowOpen) {
        return function(...args) {
            if ($604631306887a81e$var$handlers) try {
                $604631306887a81e$var$handlers.forEach((handler)=>handler());
            } catch  {
            // ignore errors in here
            }
            return originalWindowOpen.apply($604631306887a81e$var$WINDOW, args);
        };
    });
}
/** Any IncrementalSource for rrweb that we interpret as a kind of mutation. */ const $604631306887a81e$var$IncrementalMutationSources = new Set([
    $604631306887a81e$var$IncrementalSource.Mutation,
    $604631306887a81e$var$IncrementalSource.StyleSheetRule,
    $604631306887a81e$var$IncrementalSource.StyleDeclaration,
    $604631306887a81e$var$IncrementalSource.AdoptedStyleSheet,
    $604631306887a81e$var$IncrementalSource.CanvasMutation,
    $604631306887a81e$var$IncrementalSource.Selection,
    $604631306887a81e$var$IncrementalSource.MediaInteraction
]);
/** Handle a click. */ function $604631306887a81e$var$handleClick(clickDetector, clickBreadcrumb, node) {
    clickDetector.handleClick(clickBreadcrumb, node);
}
/** A click detector class that can be used to detect slow or rage clicks on elements. */ class $604631306887a81e$var$ClickDetector {
    // protected for testing
    constructor(replay, slowClickConfig, // Just for easier testing
    _addBreadcrumbEvent = $604631306887a81e$var$addBreadcrumbEvent){
        this._lastMutation = 0;
        this._lastScroll = 0;
        this._clicks = [];
        // We want everything in s, but options are in ms
        this._timeout = slowClickConfig.timeout / 1000;
        this._threshold = slowClickConfig.threshold / 1000;
        this._scrollTimeout = slowClickConfig.scrollTimeout / 1000;
        this._replay = replay;
        this._ignoreSelector = slowClickConfig.ignoreSelector;
        this._addBreadcrumbEvent = _addBreadcrumbEvent;
    }
    /** Register click detection handlers on mutation or scroll. */ addListeners() {
        const cleanupWindowOpen = $604631306887a81e$var$onWindowOpen(()=>{
            // Treat window.open as mutation
            this._lastMutation = $604631306887a81e$var$nowInSeconds();
        });
        this._teardown = ()=>{
            cleanupWindowOpen();
            this._clicks = [];
            this._lastMutation = 0;
            this._lastScroll = 0;
        };
    }
    /** Clean up listeners. */ removeListeners() {
        if (this._teardown) this._teardown();
        if (this._checkClickTimeout) clearTimeout(this._checkClickTimeout);
    }
    /** @inheritDoc */ handleClick(breadcrumb, node) {
        if ($604631306887a81e$var$ignoreElement(node, this._ignoreSelector) || !$604631306887a81e$var$isClickBreadcrumb(breadcrumb)) return;
        const newClick = {
            timestamp: $604631306887a81e$var$timestampToS(breadcrumb.timestamp),
            clickBreadcrumb: breadcrumb,
            // Set this to 0 so we know it originates from the click breadcrumb
            clickCount: 0,
            node: node
        };
        // If there was a click in the last 1s on the same element, ignore it - only keep a single reference per second
        if (this._clicks.some((click)=>click.node === newClick.node && Math.abs(click.timestamp - newClick.timestamp) < 1)) return;
        this._clicks.push(newClick);
        // If this is the first new click, set a timeout to check for multi clicks
        if (this._clicks.length === 1) this._scheduleCheckClicks();
    }
    /** @inheritDoc */ registerMutation(timestamp = Date.now()) {
        this._lastMutation = $604631306887a81e$var$timestampToS(timestamp);
    }
    /** @inheritDoc */ registerScroll(timestamp = Date.now()) {
        this._lastScroll = $604631306887a81e$var$timestampToS(timestamp);
    }
    /** @inheritDoc */ registerClick(element) {
        const node = $604631306887a81e$var$getClosestInteractive(element);
        this._handleMultiClick(node);
    }
    /** Count multiple clicks on elements. */ _handleMultiClick(node) {
        this._getClicks(node).forEach((click)=>{
            click.clickCount++;
        });
    }
    /** Get all pending clicks for a given node. */ _getClicks(node) {
        return this._clicks.filter((click)=>click.node === node);
    }
    /** Check the clicks that happened. */ _checkClicks() {
        const timedOutClicks = [];
        const now = $604631306887a81e$var$nowInSeconds();
        this._clicks.forEach((click)=>{
            if (!click.mutationAfter && this._lastMutation) click.mutationAfter = click.timestamp <= this._lastMutation ? this._lastMutation - click.timestamp : undefined;
            if (!click.scrollAfter && this._lastScroll) click.scrollAfter = click.timestamp <= this._lastScroll ? this._lastScroll - click.timestamp : undefined;
            // All of these are in seconds!
            if (click.timestamp + this._timeout <= now) timedOutClicks.push(click);
        });
        // Remove "old" clicks
        for (const click of timedOutClicks){
            const pos = this._clicks.indexOf(click);
            if (pos > -1) {
                this._generateBreadcrumbs(click);
                this._clicks.splice(pos, 1);
            }
        }
        // Trigger new check, unless no clicks left
        if (this._clicks.length) this._scheduleCheckClicks();
    }
    /** Generate matching breadcrumb(s) for the click. */ _generateBreadcrumbs(click) {
        const replay = this._replay;
        const hadScroll = click.scrollAfter && click.scrollAfter <= this._scrollTimeout;
        const hadMutation = click.mutationAfter && click.mutationAfter <= this._threshold;
        const isSlowClick = !hadScroll && !hadMutation;
        const { clickCount: clickCount, clickBreadcrumb: clickBreadcrumb } = click;
        // Slow click
        if (isSlowClick) {
            // If `mutationAfter` is set, it means a mutation happened after the threshold, but before the timeout
            // If not, it means we just timed out without scroll & mutation
            const timeAfterClickMs = Math.min(click.mutationAfter || this._timeout, this._timeout) * 1000;
            const endReason = timeAfterClickMs < this._timeout * 1000 ? 'mutation' : 'timeout';
            const breadcrumb = {
                type: 'default',
                message: clickBreadcrumb.message,
                timestamp: clickBreadcrumb.timestamp,
                category: 'ui.slowClickDetected',
                data: {
                    ...clickBreadcrumb.data,
                    url: $604631306887a81e$var$WINDOW.location.href,
                    route: replay.getCurrentRoute(),
                    timeAfterClickMs: timeAfterClickMs,
                    endReason: endReason,
                    // If clickCount === 0, it means multiClick was not correctly captured here
                    // - we still want to send 1 in this case
                    clickCount: clickCount || 1
                }
            };
            this._addBreadcrumbEvent(replay, breadcrumb);
            return;
        }
        // Multi click
        if (clickCount > 1) {
            const breadcrumb = {
                type: 'default',
                message: clickBreadcrumb.message,
                timestamp: clickBreadcrumb.timestamp,
                category: 'ui.multiClick',
                data: {
                    ...clickBreadcrumb.data,
                    url: $604631306887a81e$var$WINDOW.location.href,
                    route: replay.getCurrentRoute(),
                    clickCount: clickCount,
                    metric: true
                }
            };
            this._addBreadcrumbEvent(replay, breadcrumb);
        }
    }
    /** Schedule to check current clicks. */ _scheduleCheckClicks() {
        if (this._checkClickTimeout) clearTimeout(this._checkClickTimeout);
        this._checkClickTimeout = (0, $a11db510f5040b04$export$831dc9f2ab0a617b)(()=>this._checkClicks(), 1000);
    }
}
const $604631306887a81e$var$SLOW_CLICK_TAGS = [
    'A',
    'BUTTON',
    'INPUT'
];
/** exported for tests only */ function $604631306887a81e$var$ignoreElement(node, ignoreSelector) {
    if (!$604631306887a81e$var$SLOW_CLICK_TAGS.includes(node.tagName)) return true;
    // If <input> tag, we only want to consider input[type='submit'] & input[type='button']
    if (node.tagName === 'INPUT' && ![
        'submit',
        'button'
    ].includes(node.getAttribute('type') || '')) return true;
    // If <a> tag, detect special variants that may not lead to an action
    // If target !== _self, we may open the link somewhere else, which would lead to no action
    // Also, when downloading a file, we may not leave the page, but still not trigger an action
    if (node.tagName === 'A' && (node.hasAttribute('download') || node.hasAttribute('target') && node.getAttribute('target') !== '_self')) return true;
    if (ignoreSelector && node.matches(ignoreSelector)) return true;
    return false;
}
function $604631306887a81e$var$isClickBreadcrumb(breadcrumb) {
    return !!(breadcrumb.data && typeof breadcrumb.data.nodeId === 'number' && breadcrumb.timestamp);
}
// This is good enough for us, and is easier to test/mock than `timestampInSeconds`
function $604631306887a81e$var$nowInSeconds() {
    return Date.now() / 1000;
}
/** Update the click detector based on a recording event of rrweb. */ function $604631306887a81e$var$updateClickDetectorForRecordingEvent(clickDetector, event) {
    try {
        // note: We only consider incremental snapshots here
        // This means that any full snapshot is ignored for mutation detection - the reason is that we simply cannot know if a mutation happened here.
        // E.g. think that we are buffering, an error happens and we take a full snapshot because we switched to session mode -
        // in this scenario, we would not know if a dead click happened because of the error, which is a key dead click scenario.
        // Instead, by ignoring full snapshots, we have the risk that we generate a false positive
        // (if a mutation _did_ happen but was "swallowed" by the full snapshot)
        // But this should be more unlikely as we'd generally capture the incremental snapshot right away
        if (!$604631306887a81e$var$isIncrementalEvent(event)) return;
        const { source: source } = event.data;
        if ($604631306887a81e$var$IncrementalMutationSources.has(source)) clickDetector.registerMutation(event.timestamp);
        if (source === $604631306887a81e$var$IncrementalSource.Scroll) clickDetector.registerScroll(event.timestamp);
        if ($604631306887a81e$var$isIncrementalMouseInteraction(event)) {
            const { type: type, id: id } = event.data;
            const node = $604631306887a81e$var$record.mirror.getNode(id);
            if (node instanceof HTMLElement && type === $604631306887a81e$var$MouseInteractions.Click) clickDetector.registerClick(node);
        }
    } catch  {
    // ignore errors here, e.g. if accessing something that does not exist
    }
}
function $604631306887a81e$var$isIncrementalEvent(event) {
    return event.type === $604631306887a81e$var$ReplayEventTypeIncrementalSnapshot;
}
function $604631306887a81e$var$isIncrementalMouseInteraction(event) {
    return event.data.source === $604631306887a81e$var$IncrementalSource.MouseInteraction;
}
/**
 * Create a breadcrumb for a replay.
 */ function $604631306887a81e$var$createBreadcrumb(breadcrumb) {
    return {
        timestamp: Date.now() / 1000,
        type: 'default',
        ...breadcrumb
    };
}
var $604631306887a81e$var$NodeType = /* @__PURE__ */ ((NodeType2)=>{
    NodeType2[NodeType2["Document"] = 0] = "Document";
    NodeType2[NodeType2["DocumentType"] = 1] = "DocumentType";
    NodeType2[NodeType2["Element"] = 2] = "Element";
    NodeType2[NodeType2["Text"] = 3] = "Text";
    NodeType2[NodeType2["CDATA"] = 4] = "CDATA";
    NodeType2[NodeType2["Comment"] = 5] = "Comment";
    return NodeType2;
})($604631306887a81e$var$NodeType || {});
// Note that these are the serialized attributes and not attributes directly on
// the DOM Node. Attributes we are interested in:
const $604631306887a81e$var$ATTRIBUTES_TO_RECORD = new Set([
    'id',
    'class',
    'aria-label',
    'role',
    'name',
    'alt',
    'title',
    'data-test-id',
    'data-testid',
    'disabled',
    'aria-disabled',
    'data-sentry-component'
]);
/**
 * Inclusion list of attributes that we want to record from the DOM element
 */ function $604631306887a81e$var$getAttributesToRecord(attributes) {
    const obj = {};
    if (!attributes['data-sentry-component'] && attributes['data-sentry-element']) attributes['data-sentry-component'] = attributes['data-sentry-element'];
    for(const key in attributes)if ($604631306887a81e$var$ATTRIBUTES_TO_RECORD.has(key)) {
        let normalizedKey = key;
        if (key === 'data-testid' || key === 'data-test-id') normalizedKey = 'testId';
        obj[normalizedKey] = attributes[key];
    }
    return obj;
}
const $604631306887a81e$var$handleDomListener = (replay)=>{
    return (handlerData)=>{
        if (!replay.isEnabled()) return;
        const result = $604631306887a81e$var$handleDom(handlerData);
        if (!result) return;
        const isClick = handlerData.name === 'click';
        const event = isClick ? handlerData.event : undefined;
        // Ignore clicks if ctrl/alt/meta/shift keys are held down as they alter behavior of clicks (e.g. open in new tab)
        if (isClick && replay.clickDetector && event?.target && !event.altKey && !event.metaKey && !event.ctrlKey && !event.shiftKey) $604631306887a81e$var$handleClick(replay.clickDetector, result, $604631306887a81e$var$getClickTargetNode(handlerData.event));
        $604631306887a81e$var$addBreadcrumbEvent(replay, result);
    };
};
/** Get the base DOM breadcrumb. */ function $604631306887a81e$var$getBaseDomBreadcrumb(target, message) {
    const nodeId = $604631306887a81e$var$record.mirror.getId(target);
    const node = nodeId && $604631306887a81e$var$record.mirror.getNode(nodeId);
    const meta = node && $604631306887a81e$var$record.mirror.getMeta(node);
    const element = meta && $604631306887a81e$var$isElement(meta) ? meta : null;
    return {
        message: message,
        data: element ? {
            nodeId: nodeId,
            node: {
                id: nodeId,
                tagName: element.tagName,
                textContent: Array.from(element.childNodes).map((node)=>node.type === $604631306887a81e$var$NodeType.Text && node.textContent).filter(Boolean) // filter out empty values
                .map((text)=>text.trim()).join(''),
                attributes: $604631306887a81e$var$getAttributesToRecord(element.attributes)
            }
        } : {}
    };
}
/**
 * An event handler to react to DOM events.
 * Exported for tests.
 */ function $604631306887a81e$var$handleDom(handlerData) {
    const { target: target, message: message } = $604631306887a81e$var$getDomTarget(handlerData);
    return $604631306887a81e$var$createBreadcrumb({
        category: `ui.${handlerData.name}`,
        ...$604631306887a81e$var$getBaseDomBreadcrumb(target, message)
    });
}
function $604631306887a81e$var$getDomTarget(handlerData) {
    const isClick = handlerData.name === 'click';
    let message;
    let target = null;
    // Accessing event.target can throw (see getsentry/raven-js#838, #768)
    try {
        target = isClick ? $604631306887a81e$var$getClickTargetNode(handlerData.event) : $604631306887a81e$var$getTargetNode(handlerData.event);
        message = (0, $caac489b9d8395b2$export$5647df6b7814ac86)(target, {
            maxStringLength: 200
        }) || '<unknown>';
    } catch  {
        message = '<unknown>';
    }
    return {
        target: target,
        message: message
    };
}
function $604631306887a81e$var$isElement(node) {
    return node.type === $604631306887a81e$var$NodeType.Element;
}
/** Handle keyboard events & create breadcrumbs. */ function $604631306887a81e$var$handleKeyboardEvent(replay, event) {
    if (!replay.isEnabled()) return;
    // Update user activity, but do not restart recording as it can create
    // noisy/low-value replays (e.g. user comes back from idle, hits alt-tab, new
    // session with a single "keydown" breadcrumb is created)
    replay.updateUserActivity();
    const breadcrumb = $604631306887a81e$var$getKeyboardBreadcrumb(event);
    if (!breadcrumb) return;
    $604631306887a81e$var$addBreadcrumbEvent(replay, breadcrumb);
}
/** exported only for tests */ function $604631306887a81e$var$getKeyboardBreadcrumb(event) {
    const { metaKey: metaKey, shiftKey: shiftKey, ctrlKey: ctrlKey, altKey: altKey, key: key, target: target } = event;
    // never capture for input fields
    if (!target || $604631306887a81e$var$isInputElement(target) || !key) return null;
    // Note: We do not consider shift here, as that means "uppercase"
    const hasModifierKey = metaKey || ctrlKey || altKey;
    const isCharacterKey = key.length === 1; // other keys like Escape, Tab, etc have a longer length
    // Do not capture breadcrumb if only a word key is pressed
    // This could leak e.g. user input
    if (!hasModifierKey && isCharacterKey) return null;
    const message = (0, $caac489b9d8395b2$export$5647df6b7814ac86)(target, {
        maxStringLength: 200
    }) || '<unknown>';
    const baseBreadcrumb = $604631306887a81e$var$getBaseDomBreadcrumb(target, message);
    return $604631306887a81e$var$createBreadcrumb({
        category: 'ui.keyDown',
        message: message,
        data: {
            ...baseBreadcrumb.data,
            metaKey: metaKey,
            shiftKey: shiftKey,
            ctrlKey: ctrlKey,
            altKey: altKey,
            key: key
        }
    });
}
function $604631306887a81e$var$isInputElement(target) {
    return target.tagName === 'INPUT' || target.tagName === 'TEXTAREA' || target.isContentEditable;
}
// Map entryType -> function to normalize data for event
const $604631306887a81e$var$ENTRY_TYPES = {
    // @ts-expect-error TODO: entry type does not fit the create* functions entry type
    resource: $604631306887a81e$var$createResourceEntry,
    paint: $604631306887a81e$var$createPaintEntry,
    // @ts-expect-error TODO: entry type does not fit the create* functions entry type
    navigation: $604631306887a81e$var$createNavigationEntry
};
/**
 * Handler creater for web vitals
 */ function $604631306887a81e$var$webVitalHandler(getter, replay) {
    return ({ metric: metric })=>void replay.replayPerformanceEntries.push(getter(metric));
}
/**
 * Create replay performance entries from the browser performance entries.
 */ function $604631306887a81e$var$createPerformanceEntries(entries) {
    return entries.map($604631306887a81e$var$createPerformanceEntry).filter(Boolean);
}
function $604631306887a81e$var$createPerformanceEntry(entry) {
    const entryType = $604631306887a81e$var$ENTRY_TYPES[entry.entryType];
    if (!entryType) return null;
    return entryType(entry);
}
function $604631306887a81e$var$getAbsoluteTime(time) {
    // browserPerformanceTimeOrigin can be undefined if `performance` or
    // `performance.now` doesn't exist, but this is already checked by this integration
    return (((0, $bc81602376c48fa6$export$baf075a948ffc0bf)() || $604631306887a81e$var$WINDOW.performance.timeOrigin) + time) / 1000;
}
function $604631306887a81e$var$createPaintEntry(entry) {
    const { duration: duration, entryType: entryType, name: name, startTime: startTime } = entry;
    const start = $604631306887a81e$var$getAbsoluteTime(startTime);
    return {
        type: entryType,
        name: name,
        start: start,
        end: start + duration,
        data: undefined
    };
}
function $604631306887a81e$var$createNavigationEntry(entry) {
    const { entryType: entryType, name: name, decodedBodySize: decodedBodySize, duration: duration, domComplete: domComplete, encodedBodySize: encodedBodySize, domContentLoadedEventStart: domContentLoadedEventStart, domContentLoadedEventEnd: domContentLoadedEventEnd, domInteractive: domInteractive, loadEventStart: loadEventStart, loadEventEnd: loadEventEnd, redirectCount: redirectCount, startTime: startTime, transferSize: transferSize, type: type } = entry;
    // Ignore entries with no duration, they do not seem to be useful and cause dupes
    if (duration === 0) return null;
    return {
        type: `${entryType}.${type}`,
        start: $604631306887a81e$var$getAbsoluteTime(startTime),
        end: $604631306887a81e$var$getAbsoluteTime(domComplete),
        name: name,
        data: {
            size: transferSize,
            decodedBodySize: decodedBodySize,
            encodedBodySize: encodedBodySize,
            duration: duration,
            domInteractive: domInteractive,
            domContentLoadedEventStart: domContentLoadedEventStart,
            domContentLoadedEventEnd: domContentLoadedEventEnd,
            loadEventStart: loadEventStart,
            loadEventEnd: loadEventEnd,
            domComplete: domComplete,
            redirectCount: redirectCount
        }
    };
}
function $604631306887a81e$var$createResourceEntry(entry) {
    const { entryType: entryType, initiatorType: initiatorType, name: name, responseEnd: responseEnd, startTime: startTime, decodedBodySize: decodedBodySize, encodedBodySize: encodedBodySize, responseStatus: responseStatus, transferSize: transferSize } = entry;
    // Core SDK handles these
    if ([
        'fetch',
        'xmlhttprequest'
    ].includes(initiatorType)) return null;
    return {
        type: `${entryType}.${initiatorType}`,
        start: $604631306887a81e$var$getAbsoluteTime(startTime),
        end: $604631306887a81e$var$getAbsoluteTime(responseEnd),
        name: name,
        data: {
            size: transferSize,
            statusCode: responseStatus,
            decodedBodySize: decodedBodySize,
            encodedBodySize: encodedBodySize
        }
    };
}
/**
 * Add a LCP event to the replay based on a LCP metric.
 */ function $604631306887a81e$var$getLargestContentfulPaint(metric) {
    const lastEntry = metric.entries[metric.entries.length - 1];
    const node = lastEntry?.element ? [
        lastEntry.element
    ] : undefined;
    return $604631306887a81e$var$getWebVital(metric, 'largest-contentful-paint', node);
}
function $604631306887a81e$var$isLayoutShift(entry) {
    return entry.sources !== undefined;
}
/**
 * Add a CLS event to the replay based on a CLS metric.
 */ function $604631306887a81e$var$getCumulativeLayoutShift(metric) {
    const layoutShifts = [];
    const nodes = [];
    for (const entry of metric.entries)if ($604631306887a81e$var$isLayoutShift(entry)) {
        const nodeIds = [];
        for (const source of entry.sources)if (source.node) {
            nodes.push(source.node);
            const nodeId = $604631306887a81e$var$record.mirror.getId(source.node);
            if (nodeId) nodeIds.push(nodeId);
        }
        layoutShifts.push({
            value: entry.value,
            nodeIds: nodeIds.length ? nodeIds : undefined
        });
    }
    return $604631306887a81e$var$getWebVital(metric, 'cumulative-layout-shift', nodes, layoutShifts);
}
/**
 * Add an INP event to the replay based on an INP metric.
 */ function $604631306887a81e$var$getInteractionToNextPaint(metric) {
    const lastEntry = metric.entries[metric.entries.length - 1];
    const node = lastEntry?.target ? [
        lastEntry.target
    ] : undefined;
    return $604631306887a81e$var$getWebVital(metric, 'interaction-to-next-paint', node);
}
/**
 * Add an web vital event to the replay based on the web vital metric.
 */ function $604631306887a81e$var$getWebVital(metric, name, nodes, attributions) {
    const value = metric.value;
    const rating = metric.rating;
    const end = $604631306887a81e$var$getAbsoluteTime(value);
    return {
        type: 'web-vital',
        name: name,
        start: end,
        end: end,
        data: {
            value: value,
            size: value,
            rating: rating,
            nodeIds: nodes ? nodes.map((node)=>$604631306887a81e$var$record.mirror.getId(node)) : undefined,
            attributions: attributions
        }
    };
}
/**
 * Sets up a PerformanceObserver to listen to all performance entry types.
 * Returns a callback to stop observing.
 */ function $604631306887a81e$var$setupPerformanceObserver(replay) {
    function addPerformanceEntry(entry) {
        // It is possible for entries to come up multiple times
        if (!replay.performanceEntries.includes(entry)) replay.performanceEntries.push(entry);
    }
    function onEntries({ entries: entries }) {
        entries.forEach(addPerformanceEntry);
    }
    const clearCallbacks = [];
    [
        'navigation',
        'paint',
        'resource'
    ].forEach((type)=>{
        clearCallbacks.push((0, $f28dee024a5f97b7$export$69816c1a049f8db6)(type, onEntries));
    });
    clearCallbacks.push((0, $f28dee024a5f97b7$export$3fd4b53331200102)($604631306887a81e$var$webVitalHandler($604631306887a81e$var$getLargestContentfulPaint, replay)), (0, $f28dee024a5f97b7$export$861b82818b37ba5b)($604631306887a81e$var$webVitalHandler($604631306887a81e$var$getCumulativeLayoutShift, replay)), (0, $f28dee024a5f97b7$export$da3b76aa2022cbd7)($604631306887a81e$var$webVitalHandler($604631306887a81e$var$getInteractionToNextPaint, replay)));
    // A callback to cleanup all handlers
    return ()=>{
        clearCallbacks.forEach((clearCallback)=>clearCallback());
    };
}
/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $604631306887a81e$var$DEBUG_BUILD = typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__;
const $604631306887a81e$var$r = `var t=Uint8Array,n=Uint16Array,r=Int32Array,e=new t([0,0,0,0,0,0,0,0,1,1,1,1,2,2,2,2,3,3,3,3,4,4,4,4,5,5,5,5,0,0,0,0]),i=new t([0,0,0,0,1,1,2,2,3,3,4,4,5,5,6,6,7,7,8,8,9,9,10,10,11,11,12,12,13,13,0,0]),s=new t([16,17,18,0,8,7,9,6,10,5,11,4,12,3,13,2,14,1,15]),a=function(t,e){for(var i=new n(31),s=0;s<31;++s)i[s]=e+=1<<t[s-1];var a=new r(i[30]);for(s=1;s<30;++s)for(var o=i[s];o<i[s+1];++o)a[o]=o-i[s]<<5|s;return{b:i,r:a}},o=a(e,2),h=o.b,f=o.r;h[28]=258,f[258]=28;for(var l=a(i,0).r,u=new n(32768),c=0;c<32768;++c){var v=(43690&c)>>1|(21845&c)<<1;v=(61680&(v=(52428&v)>>2|(13107&v)<<2))>>4|(3855&v)<<4,u[c]=((65280&v)>>8|(255&v)<<8)>>1}var d=function(t,r,e){for(var i=t.length,s=0,a=new n(r);s<i;++s)t[s]&&++a[t[s]-1];var o,h=new n(r);for(s=1;s<r;++s)h[s]=h[s-1]+a[s-1]<<1;if(e){o=new n(1<<r);var f=15-r;for(s=0;s<i;++s)if(t[s])for(var l=s<<4|t[s],c=r-t[s],v=h[t[s]-1]++<<c,d=v|(1<<c)-1;v<=d;++v)o[u[v]>>f]=l}else for(o=new n(i),s=0;s<i;++s)t[s]&&(o[s]=u[h[t[s]-1]++]>>15-t[s]);return o},p=new t(288);for(c=0;c<144;++c)p[c]=8;for(c=144;c<256;++c)p[c]=9;for(c=256;c<280;++c)p[c]=7;for(c=280;c<288;++c)p[c]=8;var g=new t(32);for(c=0;c<32;++c)g[c]=5;var w=d(p,9,0),y=d(g,5,0),m=function(t){return(t+7)/8|0},b=function(n,r,e){return(null==e||e>n.length)&&(e=n.length),new t(n.subarray(r,e))},M=["unexpected EOF","invalid block type","invalid length/literal","invalid distance","stream finished","no stream handler",,"no callback","invalid UTF-8 data","extra field too long","date not in range 1980-2099","filename too long","stream finishing","invalid zip data"],E=function(t,n,r){var e=new Error(n||M[t]);if(e.code=t,Error.captureStackTrace&&Error.captureStackTrace(e,E),!r)throw e;return e},z=function(t,n,r){r<<=7&n;var e=n/8|0;t[e]|=r,t[e+1]|=r>>8},_=function(t,n,r){r<<=7&n;var e=n/8|0;t[e]|=r,t[e+1]|=r>>8,t[e+2]|=r>>16},x=function(r,e){for(var i=[],s=0;s<r.length;++s)r[s]&&i.push({s:s,f:r[s]});var a=i.length,o=i.slice();if(!a)return{t:F,l:0};if(1==a){var h=new t(i[0].s+1);return h[i[0].s]=1,{t:h,l:1}}i.sort(function(t,n){return t.f-n.f}),i.push({s:-1,f:25001});var f=i[0],l=i[1],u=0,c=1,v=2;for(i[0]={s:-1,f:f.f+l.f,l:f,r:l};c!=a-1;)f=i[i[u].f<i[v].f?u++:v++],l=i[u!=c&&i[u].f<i[v].f?u++:v++],i[c++]={s:-1,f:f.f+l.f,l:f,r:l};var d=o[0].s;for(s=1;s<a;++s)o[s].s>d&&(d=o[s].s);var p=new n(d+1),g=A(i[c-1],p,0);if(g>e){s=0;var w=0,y=g-e,m=1<<y;for(o.sort(function(t,n){return p[n.s]-p[t.s]||t.f-n.f});s<a;++s){var b=o[s].s;if(!(p[b]>e))break;w+=m-(1<<g-p[b]),p[b]=e}for(w>>=y;w>0;){var M=o[s].s;p[M]<e?w-=1<<e-p[M]++-1:++s}for(;s>=0&&w;--s){var E=o[s].s;p[E]==e&&(--p[E],++w)}g=e}return{t:new t(p),l:g}},A=function(t,n,r){return-1==t.s?Math.max(A(t.l,n,r+1),A(t.r,n,r+1)):n[t.s]=r},D=function(t){for(var r=t.length;r&&!t[--r];);for(var e=new n(++r),i=0,s=t[0],a=1,o=function(t){e[i++]=t},h=1;h<=r;++h)if(t[h]==s&&h!=r)++a;else{if(!s&&a>2){for(;a>138;a-=138)o(32754);a>2&&(o(a>10?a-11<<5|28690:a-3<<5|12305),a=0)}else if(a>3){for(o(s),--a;a>6;a-=6)o(8304);a>2&&(o(a-3<<5|8208),a=0)}for(;a--;)o(s);a=1,s=t[h]}return{c:e.subarray(0,i),n:r}},T=function(t,n){for(var r=0,e=0;e<n.length;++e)r+=t[e]*n[e];return r},k=function(t,n,r){var e=r.length,i=m(n+2);t[i]=255&e,t[i+1]=e>>8,t[i+2]=255^t[i],t[i+3]=255^t[i+1];for(var s=0;s<e;++s)t[i+s+4]=r[s];return 8*(i+4+e)},U=function(t,r,a,o,h,f,l,u,c,v,m){z(r,m++,a),++h[256];for(var b=x(h,15),M=b.t,E=b.l,A=x(f,15),U=A.t,C=A.l,F=D(M),I=F.c,S=F.n,L=D(U),O=L.c,j=L.n,q=new n(19),B=0;B<I.length;++B)++q[31&I[B]];for(B=0;B<O.length;++B)++q[31&O[B]];for(var G=x(q,7),H=G.t,J=G.l,K=19;K>4&&!H[s[K-1]];--K);var N,P,Q,R,V=v+5<<3,W=T(h,p)+T(f,g)+l,X=T(h,M)+T(f,U)+l+14+3*K+T(q,H)+2*q[16]+3*q[17]+7*q[18];if(c>=0&&V<=W&&V<=X)return k(r,m,t.subarray(c,c+v));if(z(r,m,1+(X<W)),m+=2,X<W){N=d(M,E,0),P=M,Q=d(U,C,0),R=U;var Y=d(H,J,0);z(r,m,S-257),z(r,m+5,j-1),z(r,m+10,K-4),m+=14;for(B=0;B<K;++B)z(r,m+3*B,H[s[B]]);m+=3*K;for(var Z=[I,O],$=0;$<2;++$){var tt=Z[$];for(B=0;B<tt.length;++B){var nt=31&tt[B];z(r,m,Y[nt]),m+=H[nt],nt>15&&(z(r,m,tt[B]>>5&127),m+=tt[B]>>12)}}}else N=w,P=p,Q=y,R=g;for(B=0;B<u;++B){var rt=o[B];if(rt>255){_(r,m,N[(nt=rt>>18&31)+257]),m+=P[nt+257],nt>7&&(z(r,m,rt>>23&31),m+=e[nt]);var et=31&rt;_(r,m,Q[et]),m+=R[et],et>3&&(_(r,m,rt>>5&8191),m+=i[et])}else _(r,m,N[rt]),m+=P[rt]}return _(r,m,N[256]),m+P[256]},C=new r([65540,131080,131088,131104,262176,1048704,1048832,2114560,2117632]),F=new t(0),I=function(){for(var t=new Int32Array(256),n=0;n<256;++n){for(var r=n,e=9;--e;)r=(1&r&&-306674912)^r>>>1;t[n]=r}return t}(),S=function(){var t=1,n=0;return{p:function(r){for(var e=t,i=n,s=0|r.length,a=0;a!=s;){for(var o=Math.min(a+2655,s);a<o;++a)i+=e+=r[a];e=(65535&e)+15*(e>>16),i=(65535&i)+15*(i>>16)}t=e,n=i},d:function(){return(255&(t%=65521))<<24|(65280&t)<<8|(255&(n%=65521))<<8|n>>8}}},L=function(s,a,o,h,u){if(!u&&(u={l:1},a.dictionary)){var c=a.dictionary.subarray(-32768),v=new t(c.length+s.length);v.set(c),v.set(s,c.length),s=v,u.w=c.length}return function(s,a,o,h,u,c){var v=c.z||s.length,d=new t(h+v+5*(1+Math.ceil(v/7e3))+u),p=d.subarray(h,d.length-u),g=c.l,w=7&(c.r||0);if(a){w&&(p[0]=c.r>>3);for(var y=C[a-1],M=y>>13,E=8191&y,z=(1<<o)-1,_=c.p||new n(32768),x=c.h||new n(z+1),A=Math.ceil(o/3),D=2*A,T=function(t){return(s[t]^s[t+1]<<A^s[t+2]<<D)&z},F=new r(25e3),I=new n(288),S=new n(32),L=0,O=0,j=c.i||0,q=0,B=c.w||0,G=0;j+2<v;++j){var H=T(j),J=32767&j,K=x[H];if(_[J]=K,x[H]=J,B<=j){var N=v-j;if((L>7e3||q>24576)&&(N>423||!g)){w=U(s,p,0,F,I,S,O,q,G,j-G,w),q=L=O=0,G=j;for(var P=0;P<286;++P)I[P]=0;for(P=0;P<30;++P)S[P]=0}var Q=2,R=0,V=E,W=J-K&32767;if(N>2&&H==T(j-W))for(var X=Math.min(M,N)-1,Y=Math.min(32767,j),Z=Math.min(258,N);W<=Y&&--V&&J!=K;){if(s[j+Q]==s[j+Q-W]){for(var $=0;$<Z&&s[j+$]==s[j+$-W];++$);if($>Q){if(Q=$,R=W,$>X)break;var tt=Math.min(W,$-2),nt=0;for(P=0;P<tt;++P){var rt=j-W+P&32767,et=rt-_[rt]&32767;et>nt&&(nt=et,K=rt)}}}W+=(J=K)-(K=_[J])&32767}if(R){F[q++]=268435456|f[Q]<<18|l[R];var it=31&f[Q],st=31&l[R];O+=e[it]+i[st],++I[257+it],++S[st],B=j+Q,++L}else F[q++]=s[j],++I[s[j]]}}for(j=Math.max(j,B);j<v;++j)F[q++]=s[j],++I[s[j]];w=U(s,p,g,F,I,S,O,q,G,j-G,w),g||(c.r=7&w|p[w/8|0]<<3,w-=7,c.h=x,c.p=_,c.i=j,c.w=B)}else{for(j=c.w||0;j<v+g;j+=65535){var at=j+65535;at>=v&&(p[w/8|0]=g,at=v),w=k(p,w+1,s.subarray(j,at))}c.i=v}return b(d,0,h+m(w)+u)}(s,null==a.level?6:a.level,null==a.mem?u.l?Math.ceil(1.5*Math.max(8,Math.min(13,Math.log(s.length)))):20:12+a.mem,o,h,u)},O=function(t,n,r){for(;r;++n)t[n]=r,r>>>=8},j=function(){function n(n,r){if("function"==typeof n&&(r=n,n={}),this.ondata=r,this.o=n||{},this.s={l:0,i:32768,w:32768,z:32768},this.b=new t(98304),this.o.dictionary){var e=this.o.dictionary.subarray(-32768);this.b.set(e,32768-e.length),this.s.i=32768-e.length}}return n.prototype.p=function(t,n){this.ondata(L(t,this.o,0,0,this.s),n)},n.prototype.push=function(n,r){this.ondata||E(5),this.s.l&&E(4);var e=n.length+this.s.z;if(e>this.b.length){if(e>2*this.b.length-32768){var i=new t(-32768&e);i.set(this.b.subarray(0,this.s.z)),this.b=i}var s=this.b.length-this.s.z;this.b.set(n.subarray(0,s),this.s.z),this.s.z=this.b.length,this.p(this.b,!1),this.b.set(this.b.subarray(-32768)),this.b.set(n.subarray(s),32768),this.s.z=n.length-s+32768,this.s.i=32766,this.s.w=32768}else this.b.set(n,this.s.z),this.s.z+=n.length;this.s.l=1&r,(this.s.z>this.s.w+8191||r)&&(this.p(this.b,r||!1),this.s.w=this.s.i,this.s.i-=2)},n.prototype.flush=function(){this.ondata||E(5),this.s.l&&E(4),this.p(this.b,!1),this.s.w=this.s.i,this.s.i-=2},n}();function q(t,n){n||(n={});var r=function(){var t=-1;return{p:function(n){for(var r=t,e=0;e<n.length;++e)r=I[255&r^n[e]]^r>>>8;t=r},d:function(){return~t}}}(),e=t.length;r.p(t);var i,s=L(t,n,10+((i=n).filename?i.filename.length+1:0),8),a=s.length;return function(t,n){var r=n.filename;if(t[0]=31,t[1]=139,t[2]=8,t[8]=n.level<2?4:9==n.level?2:0,t[9]=3,0!=n.mtime&&O(t,4,Math.floor(new Date(n.mtime||Date.now())/1e3)),r){t[3]=8;for(var e=0;e<=r.length;++e)t[e+10]=r.charCodeAt(e)}}(s,n),O(s,a-8,r.d()),O(s,a-4,e),s}var B=function(){function t(t,n){this.c=S(),this.v=1,j.call(this,t,n)}return t.prototype.push=function(t,n){this.c.p(t),j.prototype.push.call(this,t,n)},t.prototype.p=function(t,n){var r=L(t,this.o,this.v&&(this.o.dictionary?6:2),n&&4,this.s);this.v&&(function(t,n){var r=n.level,e=0==r?0:r<6?1:9==r?3:2;if(t[0]=120,t[1]=e<<6|(n.dictionary&&32),t[1]|=31-(t[0]<<8|t[1])%31,n.dictionary){var i=S();i.p(n.dictionary),O(t,2,i.d())}}(r,this.o),this.v=0),n&&O(r,r.length-4,this.c.d()),this.ondata(r,n)},t.prototype.flush=function(){j.prototype.flush.call(this)},t}(),G="undefined"!=typeof TextEncoder&&new TextEncoder,H="undefined"!=typeof TextDecoder&&new TextDecoder;try{H.decode(F,{stream:!0})}catch(t){}var J=function(){function t(t){this.ondata=t}return t.prototype.push=function(t,n){this.ondata||E(5),this.d&&E(4),this.ondata(K(t),this.d=n||!1)},t}();function K(n,r){if(G)return G.encode(n);for(var e=n.length,i=new t(n.length+(n.length>>1)),s=0,a=function(t){i[s++]=t},o=0;o<e;++o){if(s+5>i.length){var h=new t(s+8+(e-o<<1));h.set(i),i=h}var f=n.charCodeAt(o);f<128||r?a(f):f<2048?(a(192|f>>6),a(128|63&f)):f>55295&&f<57344?(a(240|(f=65536+(1047552&f)|1023&n.charCodeAt(++o))>>18),a(128|f>>12&63),a(128|f>>6&63),a(128|63&f)):(a(224|f>>12),a(128|f>>6&63),a(128|63&f))}return b(i,0,s)}const N=new class{constructor(){this._init()}clear(){this._init()}addEvent(t){if(!t)throw new Error("Adding invalid event");const n=this._hasEvents?",":"";this.stream.push(n+t),this._hasEvents=!0}finish(){this.stream.push("]",!0);const t=function(t){let n=0;for(const r of t)n+=r.length;const r=new Uint8Array(n);for(let n=0,e=0,i=t.length;n<i;n++){const i=t[n];r.set(i,e),e+=i.length}return r}(this._deflatedData);return this._init(),t}_init(){this._hasEvents=!1,this._deflatedData=[],this.deflate=new B,this.deflate.ondata=(t,n)=>{this._deflatedData.push(t)},this.stream=new J((t,n)=>{this.deflate.push(t,n)}),this.stream.push("[")}},P={clear:()=>{N.clear()},addEvent:t=>N.addEvent(t),finish:()=>N.finish(),compress:t=>function(t){return q(K(t))}(t)};addEventListener("message",function(t){const n=t.data.method,r=t.data.id,e=t.data.arg;if(n in P&&"function"==typeof P[n])try{const t=P[n](e);postMessage({id:r,method:n,success:!0,response:t})}catch(t){postMessage({id:r,method:n,success:!1,response:t.message}),console.error(t)}}),postMessage({id:void 0,method:"init",success:!0,response:void 0});`;
function $604631306887a81e$var$e() {
    const e = new Blob([
        $604631306887a81e$var$r
    ]);
    return URL.createObjectURL(e);
}
const $604631306887a81e$var$CONSOLE_LEVELS = [
    'log',
    'warn',
    'error'
];
const $604631306887a81e$var$PREFIX = '[Replay] ';
function $604631306887a81e$var$_addBreadcrumb(message, level = 'info') {
    (0, $777cacbd1bed0b63$export$efda9a273d7a036d)({
        category: 'console',
        data: {
            logger: 'replay'
        },
        level: level,
        message: `${$604631306887a81e$var$PREFIX}${message}`
    }, {
        level: level
    });
}
function $604631306887a81e$var$makeReplayDebugLogger() {
    let _capture = false;
    let _trace = false;
    const _debug = {
        exception: ()=>undefined,
        infoTick: ()=>undefined,
        setConfig: (opts)=>{
            _capture = !!opts.captureExceptions;
            _trace = !!opts.traceInternals;
        }
    };
    if ($604631306887a81e$var$DEBUG_BUILD) {
        $604631306887a81e$var$CONSOLE_LEVELS.forEach((name)=>{
            _debug[name] = (...args)=>{
                (0, $d11ed0b3cdda6b8d$export$1c9f709888824e05)[name]($604631306887a81e$var$PREFIX, ...args);
                if (_trace) $604631306887a81e$var$_addBreadcrumb(args.join(''), (0, $9e4658f0600c3fda$export$d771ef054122c30a)(name));
            };
        });
        _debug.exception = (error, ...message)=>{
            if (message.length && _debug.error) _debug.error(...message);
            (0, $d11ed0b3cdda6b8d$export$1c9f709888824e05).error($604631306887a81e$var$PREFIX, error);
            if (_capture) (0, $6918c722b531ff18$export$f5282963edea4a68)(error, {
                mechanism: {
                    handled: true,
                    type: 'auto.function.replay.debug'
                }
            });
            else if (_trace) // No need for a breadcrumb if `_capture` is enabled since it should be
            // captured as an exception
            $604631306887a81e$var$_addBreadcrumb(error, 'error');
        };
        _debug.infoTick = (...args)=>{
            (0, $d11ed0b3cdda6b8d$export$1c9f709888824e05).log($604631306887a81e$var$PREFIX, ...args);
            if (_trace) // Wait a tick here to avoid race conditions for some initial logs
            // which may be added before replay is initialized
            setTimeout(()=>$604631306887a81e$var$_addBreadcrumb(args[0]), 0);
        };
    } else $604631306887a81e$var$CONSOLE_LEVELS.forEach((name)=>{
        _debug[name] = ()=>undefined;
    });
    return _debug;
}
const $604631306887a81e$var$debug = $604631306887a81e$var$makeReplayDebugLogger();
/** This error indicates that the event buffer size exceeded the limit.. */ class $604631306887a81e$var$EventBufferSizeExceededError extends Error {
    constructor(){
        super(`Event buffer exceeded maximum size of ${$604631306887a81e$var$REPLAY_MAX_EVENT_BUFFER_SIZE}.`);
    }
}
/**
 * A basic event buffer that does not do any compression.
 * Used as fallback if the compression worker cannot be loaded or is disabled.
 */ class $604631306887a81e$var$EventBufferArray {
    /** All the events that are buffered to be sent. */ /** @inheritdoc */ /** @inheritdoc */ constructor(){
        this.events = [];
        this._totalSize = 0;
        this.hasCheckout = false;
        this.waitForCheckout = false;
    }
    /** @inheritdoc */ get hasEvents() {
        return this.events.length > 0;
    }
    /** @inheritdoc */ get type() {
        return 'sync';
    }
    /** @inheritdoc */ destroy() {
        this.events = [];
    }
    /** @inheritdoc */ async addEvent(event) {
        const eventSize = JSON.stringify(event).length;
        this._totalSize += eventSize;
        if (this._totalSize > $604631306887a81e$var$REPLAY_MAX_EVENT_BUFFER_SIZE) throw new $604631306887a81e$var$EventBufferSizeExceededError();
        this.events.push(event);
    }
    /** @inheritdoc */ finish() {
        return new Promise((resolve)=>{
            // Make a copy of the events array reference and immediately clear the
            // events member so that we do not lose new events while uploading
            // attachment.
            const eventsRet = this.events;
            this.clear();
            resolve(JSON.stringify(eventsRet));
        });
    }
    /** @inheritdoc */ clear() {
        this.events = [];
        this._totalSize = 0;
        this.hasCheckout = false;
    }
    /** @inheritdoc */ getEarliestTimestamp() {
        const timestamp = this.events.map((event)=>event.timestamp).sort()[0];
        if (!timestamp) return null;
        return $604631306887a81e$var$timestampToMs(timestamp);
    }
}
/**
 * Event buffer that uses a web worker to compress events.
 * Exported only for testing.
 */ class $604631306887a81e$var$WorkerHandler {
    constructor(worker){
        this._worker = worker;
        this._id = 0;
    }
    /**
   * Ensure the worker is ready (or not).
   * This will either resolve when the worker is ready, or reject if an error occurred.
   */ ensureReady() {
        // Ensure we only check once
        if (this._ensureReadyPromise) return this._ensureReadyPromise;
        this._ensureReadyPromise = new Promise((resolve, reject)=>{
            this._worker.addEventListener('message', ({ data: data })=>{
                if (data.success) resolve();
                else {
                    $604631306887a81e$var$DEBUG_BUILD && $604631306887a81e$var$debug.warn('Received worker message with unsuccessful status', data);
                    reject(new Error('Received worker message with unsuccessful status'));
                }
            }, {
                once: true
            });
            this._worker.addEventListener('error', (error)=>{
                $604631306887a81e$var$DEBUG_BUILD && $604631306887a81e$var$debug.warn('Failed to load Replay compression worker', error);
                reject(new Error(`Failed to load Replay compression worker: ${error instanceof ErrorEvent && error.message ? error.message : 'Unknown error. This can happen due to CSP policy restrictions, network issues, or the worker script failing to load.'}`));
            }, {
                once: true
            });
        });
        return this._ensureReadyPromise;
    }
    /**
   * Destroy the worker.
   */ destroy() {
        $604631306887a81e$var$DEBUG_BUILD && $604631306887a81e$var$debug.log('Destroying compression worker');
        this._worker.terminate();
    }
    /**
   * Post message to worker and wait for response before resolving promise.
   */ postMessage(method, arg) {
        const id = this._getAndIncrementId();
        return new Promise((resolve, reject)=>{
            const listener = ({ data: data })=>{
                const response = data;
                if (response.method !== method) return;
                // There can be multiple listeners for a single method, the id ensures
                // that the response matches the caller.
                if (response.id !== id) return;
                // At this point, we'll always want to remove listener regardless of result status
                this._worker.removeEventListener('message', listener);
                if (!response.success) {
                    // TODO: Do some error handling, not sure what
                    $604631306887a81e$var$DEBUG_BUILD && $604631306887a81e$var$debug.error('Error in compression worker: ', response.response);
                    reject(new Error('Error in compression worker'));
                    return;
                }
                resolve(response.response);
            };
            // Note: we can't use `once` option because it's possible it needs to
            // listen to multiple messages
            this._worker.addEventListener('message', listener);
            this._worker.postMessage({
                id: id,
                method: method,
                arg: arg
            });
        });
    }
    /** Get the current ID and increment it for the next call. */ _getAndIncrementId() {
        return this._id++;
    }
}
/**
 * Event buffer that uses a web worker to compress events.
 * Exported only for testing.
 */ class $604631306887a81e$var$EventBufferCompressionWorker {
    /** @inheritdoc */ /** @inheritdoc */ constructor(worker){
        this._worker = new $604631306887a81e$var$WorkerHandler(worker);
        this._earliestTimestamp = null;
        this._totalSize = 0;
        this.hasCheckout = false;
        this.waitForCheckout = false;
    }
    /** @inheritdoc */ get hasEvents() {
        return !!this._earliestTimestamp;
    }
    /** @inheritdoc */ get type() {
        return 'worker';
    }
    /**
   * Ensure the worker is ready (or not).
   * This will either resolve when the worker is ready, or reject if an error occurred.
   */ ensureReady() {
        return this._worker.ensureReady();
    }
    /**
   * Destroy the event buffer.
   */ destroy() {
        this._worker.destroy();
    }
    /**
   * Add an event to the event buffer.
   *
   * Returns true if event was successfully received and processed by worker.
   */ addEvent(event) {
        const timestamp = $604631306887a81e$var$timestampToMs(event.timestamp);
        if (!this._earliestTimestamp || timestamp < this._earliestTimestamp) this._earliestTimestamp = timestamp;
        const data = JSON.stringify(event);
        this._totalSize += data.length;
        if (this._totalSize > $604631306887a81e$var$REPLAY_MAX_EVENT_BUFFER_SIZE) return Promise.reject(new $604631306887a81e$var$EventBufferSizeExceededError());
        return this._sendEventToWorker(data);
    }
    /**
   * Finish the event buffer and return the compressed data.
   */ finish() {
        return this._finishRequest();
    }
    /** @inheritdoc */ clear() {
        this._earliestTimestamp = null;
        this._totalSize = 0;
        this.hasCheckout = false;
        // We do not wait on this, as we assume the order of messages is consistent for the worker
        this._worker.postMessage('clear').then(null, (e)=>{
            $604631306887a81e$var$DEBUG_BUILD && $604631306887a81e$var$debug.exception(e, 'Sending "clear" message to worker failed', e);
        });
    }
    /** @inheritdoc */ getEarliestTimestamp() {
        return this._earliestTimestamp;
    }
    /**
   * Send the event to the worker.
   */ _sendEventToWorker(data) {
        return this._worker.postMessage('addEvent', data);
    }
    /**
   * Finish the request and return the compressed data from the worker.
   */ async _finishRequest() {
        const response = await this._worker.postMessage('finish');
        this._earliestTimestamp = null;
        this._totalSize = 0;
        return response;
    }
}
/**
 * This proxy will try to use the compression worker, and fall back to use the simple buffer if an error occurs there.
 * This can happen e.g. if the worker cannot be loaded.
 * Exported only for testing.
 */ class $604631306887a81e$var$EventBufferProxy {
    constructor(worker){
        this._fallback = new $604631306887a81e$var$EventBufferArray();
        this._compression = new $604631306887a81e$var$EventBufferCompressionWorker(worker);
        this._used = this._fallback;
        this._ensureWorkerIsLoadedPromise = this._ensureWorkerIsLoaded();
    }
    /** @inheritdoc */ get waitForCheckout() {
        return this._used.waitForCheckout;
    }
    /** @inheritdoc */ get type() {
        return this._used.type;
    }
    /** @inheritDoc */ get hasEvents() {
        return this._used.hasEvents;
    }
    /** @inheritdoc */ get hasCheckout() {
        return this._used.hasCheckout;
    }
    /** @inheritdoc */ set hasCheckout(value) {
        this._used.hasCheckout = value;
    }
    /** @inheritdoc */ // eslint-disable-next-line @typescript-eslint/adjacent-overload-signatures
    set waitForCheckout(value) {
        this._used.waitForCheckout = value;
    }
    /** @inheritDoc */ destroy() {
        this._fallback.destroy();
        this._compression.destroy();
    }
    /** @inheritdoc */ clear() {
        return this._used.clear();
    }
    /** @inheritdoc */ getEarliestTimestamp() {
        return this._used.getEarliestTimestamp();
    }
    /**
   * Add an event to the event buffer.
   *
   * Returns true if event was successfully added.
   */ addEvent(event) {
        return this._used.addEvent(event);
    }
    /** @inheritDoc */ async finish() {
        // Ensure the worker is loaded, so the sent event is compressed
        await this.ensureWorkerIsLoaded();
        return this._used.finish();
    }
    /** Ensure the worker has loaded. */ ensureWorkerIsLoaded() {
        return this._ensureWorkerIsLoadedPromise;
    }
    /** Actually check if the worker has been loaded. */ async _ensureWorkerIsLoaded() {
        try {
            await this._compression.ensureReady();
        } catch (error) {
            // If the worker fails to load, we fall back to the simple buffer.
            // Nothing more to do from our side here
            $604631306887a81e$var$DEBUG_BUILD && $604631306887a81e$var$debug.exception(error, 'Failed to load the compression worker, falling back to simple buffer');
            return;
        }
        // Now we need to switch over the array buffer to the compression worker
        await this._switchToCompressionWorker();
    }
    /** Switch the used buffer to the compression worker. */ async _switchToCompressionWorker() {
        const { events: events, hasCheckout: hasCheckout, waitForCheckout: waitForCheckout } = this._fallback;
        const addEventPromises = [];
        for (const event of events)addEventPromises.push(this._compression.addEvent(event));
        this._compression.hasCheckout = hasCheckout;
        this._compression.waitForCheckout = waitForCheckout;
        // We switch over to the new buffer immediately - any further events will be added
        // after the previously buffered ones
        this._used = this._compression;
        // Wait for original events to be re-added before resolving
        try {
            await Promise.all(addEventPromises);
            // Can now clear fallback buffer as it's no longer necessary
            this._fallback.clear();
        } catch (error) {
            $604631306887a81e$var$DEBUG_BUILD && $604631306887a81e$var$debug.exception(error, 'Failed to add events when switching buffers.');
        }
    }
}
/**
 * Create an event buffer for replays.
 */ function $604631306887a81e$var$createEventBuffer({ useCompression: useCompression, workerUrl: customWorkerUrl }) {
    if (useCompression && // eslint-disable-next-line no-restricted-globals
    window.Worker) {
        const worker = $604631306887a81e$var$_loadWorker(customWorkerUrl);
        if (worker) return worker;
    }
    $604631306887a81e$var$DEBUG_BUILD && $604631306887a81e$var$debug.log('Using simple buffer');
    return new $604631306887a81e$var$EventBufferArray();
}
function $604631306887a81e$var$_loadWorker(customWorkerUrl) {
    try {
        const workerUrl = customWorkerUrl || $604631306887a81e$var$_getWorkerUrl();
        if (!workerUrl) return;
        $604631306887a81e$var$DEBUG_BUILD && $604631306887a81e$var$debug.log(`Using compression worker${customWorkerUrl ? ` from ${customWorkerUrl}` : ''}`);
        const worker = new Worker(workerUrl);
        return new $604631306887a81e$var$EventBufferProxy(worker);
    } catch (error) {
        $604631306887a81e$var$DEBUG_BUILD && $604631306887a81e$var$debug.exception(error, 'Failed to create compression worker');
    // Fall back to use simple event buffer array
    }
}
function $604631306887a81e$var$_getWorkerUrl() {
    if (typeof __SENTRY_EXCLUDE_REPLAY_WORKER__ === 'undefined' || !__SENTRY_EXCLUDE_REPLAY_WORKER__) return $604631306887a81e$var$e();
    return '';
}
/** If sessionStorage is available. */ function $604631306887a81e$var$hasSessionStorage() {
    try {
        // This can throw, e.g. when being accessed in a sandboxed iframe
        return 'sessionStorage' in $604631306887a81e$var$WINDOW && !!$604631306887a81e$var$WINDOW.sessionStorage;
    } catch  {
        return false;
    }
}
/**
 * Removes the session from Session Storage and unsets session in replay instance
 */ function $604631306887a81e$var$clearSession(replay) {
    $604631306887a81e$var$deleteSession();
    replay.session = undefined;
}
/**
 * Deletes a session from storage
 */ function $604631306887a81e$var$deleteSession() {
    if (!$604631306887a81e$var$hasSessionStorage()) return;
    try {
        $604631306887a81e$var$WINDOW.sessionStorage.removeItem($604631306887a81e$var$REPLAY_SESSION_KEY);
    } catch  {
    // Ignore potential SecurityError exceptions
    }
}
/**
 * Given a sample rate, returns true if replay should be sampled.
 *
 * 1.0 = 100% sampling
 * 0.0 = 0% sampling
 */ function $604631306887a81e$var$isSampled(sampleRate) {
    if (sampleRate === undefined) return false;
    // Math.random() returns a number in range of 0 to 1 (inclusive of 0, but not 1)
    return Math.random() < sampleRate;
}
/**
 * Save a session to session storage.
 */ function $604631306887a81e$var$saveSession(session) {
    if (!$604631306887a81e$var$hasSessionStorage()) return;
    try {
        $604631306887a81e$var$WINDOW.sessionStorage.setItem($604631306887a81e$var$REPLAY_SESSION_KEY, JSON.stringify(session));
    } catch  {
    // Ignore potential SecurityError exceptions
    }
}
/**
 * Get a session with defaults & applied sampling.
 */ function $604631306887a81e$var$makeSession(session) {
    const now = Date.now();
    const id = session.id || (0, $cc262db35458e4b3$export$19f53698e68b2496)();
    // Note that this means we cannot set a started/lastActivity of `0`, but this should not be relevant outside of tests.
    const started = session.started || now;
    const lastActivity = session.lastActivity || now;
    const segmentId = session.segmentId || 0;
    const sampled = session.sampled;
    const previousSessionId = session.previousSessionId;
    const dirty = session.dirty || false;
    return {
        id: id,
        started: started,
        lastActivity: lastActivity,
        segmentId: segmentId,
        sampled: sampled,
        previousSessionId: previousSessionId,
        dirty: dirty
    };
}
/**
 * Get the sampled status for a session based on sample rates & current sampled status.
 */ function $604631306887a81e$var$getSessionSampleType(sessionSampleRate, allowBuffering) {
    return $604631306887a81e$var$isSampled(sessionSampleRate) ? 'session' : allowBuffering ? 'buffer' : false;
}
/**
 * Create a new session, which in its current implementation is a Sentry event
 * that all replays will be saved to as attachments. Currently, we only expect
 * one of these Sentry events per "replay session".
 */ function $604631306887a81e$var$createSession({ sessionSampleRate: sessionSampleRate, allowBuffering: allowBuffering, stickySession: stickySession = false }, { previousSessionId: previousSessionId } = {}) {
    const sampled = $604631306887a81e$var$getSessionSampleType(sessionSampleRate, allowBuffering);
    const session = $604631306887a81e$var$makeSession({
        sampled: sampled,
        previousSessionId: previousSessionId
    });
    if (stickySession) $604631306887a81e$var$saveSession(session);
    return session;
}
/**
 * Fetches a session from storage
 */ function $604631306887a81e$var$fetchSession() {
    if (!$604631306887a81e$var$hasSessionStorage()) return null;
    try {
        // This can throw if cookies are disabled
        const sessionStringFromStorage = $604631306887a81e$var$WINDOW.sessionStorage.getItem($604631306887a81e$var$REPLAY_SESSION_KEY);
        if (!sessionStringFromStorage) return null;
        const sessionObj = JSON.parse(sessionStringFromStorage);
        $604631306887a81e$var$DEBUG_BUILD && $604631306887a81e$var$debug.infoTick('Loading existing session');
        return $604631306887a81e$var$makeSession(sessionObj);
    } catch  {
        return null;
    }
}
/**
 * Given an initial timestamp and an expiry duration, checks to see if current
 * time should be considered as expired.
 */ function $604631306887a81e$var$isExpired(initialTime, expiry, targetTime = +new Date()) {
    // Always expired if < 0
    if (initialTime === null || expiry === undefined || expiry < 0) return true;
    // Never expires if == 0
    if (expiry === 0) return false;
    return initialTime + expiry <= targetTime;
}
/**
 * Checks to see if session is expired
 */ function $604631306887a81e$var$isSessionExpired(session, { maxReplayDuration: maxReplayDuration, sessionIdleExpire: sessionIdleExpire, targetTime: targetTime = Date.now() }) {
    return(// First, check that maximum session length has not been exceeded
    $604631306887a81e$var$isExpired(session.started, maxReplayDuration, targetTime) || // check that the idle timeout has not been exceeded (i.e. user has
    // performed an action within the last `sessionIdleExpire` ms)
    $604631306887a81e$var$isExpired(session.lastActivity, sessionIdleExpire, targetTime));
}
/** If the session should be refreshed or not. */ function $604631306887a81e$var$shouldRefreshSession(session, { sessionIdleExpire: sessionIdleExpire, maxReplayDuration: maxReplayDuration }) {
    // If not expired, all good, just keep the session
    if (!$604631306887a81e$var$isSessionExpired(session, {
        sessionIdleExpire: sessionIdleExpire,
        maxReplayDuration: maxReplayDuration
    })) return false;
    // If we are buffering & haven't ever flushed yet, always continue
    if (session.sampled === 'buffer' && session.segmentId === 0) return false;
    return true;
}
/**
 * Get or create a session, when initializing the replay.
 * Returns a session that may be unsampled.
 */ function $604631306887a81e$var$loadOrCreateSession({ sessionIdleExpire: sessionIdleExpire, maxReplayDuration: maxReplayDuration, previousSessionId: previousSessionId }, sessionOptions) {
    const existingSession = sessionOptions.stickySession && $604631306887a81e$var$fetchSession();
    // No session exists yet, just create a new one
    if (!existingSession) {
        $604631306887a81e$var$DEBUG_BUILD && $604631306887a81e$var$debug.infoTick('Creating new session');
        return $604631306887a81e$var$createSession(sessionOptions, {
            previousSessionId: previousSessionId
        });
    }
    if (!$604631306887a81e$var$shouldRefreshSession(existingSession, {
        sessionIdleExpire: sessionIdleExpire,
        maxReplayDuration: maxReplayDuration
    })) return existingSession;
    $604631306887a81e$var$DEBUG_BUILD && $604631306887a81e$var$debug.infoTick('Session in sessionStorage is expired, creating new one...');
    return $604631306887a81e$var$createSession(sessionOptions, {
        previousSessionId: existingSession.id
    });
}
function $604631306887a81e$var$isCustomEvent(event) {
    return event.type === $604631306887a81e$var$EventType.Custom;
}
/**
 * Add an event to the event buffer.
 * In contrast to `addEvent`, this does not return a promise & does not wait for the adding of the event to succeed/fail.
 * Instead this returns `true` if we tried to add the event, else false.
 * It returns `false` e.g. if we are paused, disabled, or out of the max replay duration.
 *
 * `isCheckout` is true if this is either the very first event, or an event triggered by `checkoutEveryNms`.
 */ function $604631306887a81e$var$addEventSync(replay, event, isCheckout) {
    if (!$604631306887a81e$var$shouldAddEvent(replay, event)) return false;
    // This should never reject
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    $604631306887a81e$var$_addEvent(replay, event, isCheckout);
    return true;
}
/**
 * Add an event to the event buffer.
 * Resolves to `null` if no event was added, else to `void`.
 *
 * `isCheckout` is true if this is either the very first event, or an event triggered by `checkoutEveryNms`.
 */ function $604631306887a81e$var$addEvent(replay, event, isCheckout) {
    if (!$604631306887a81e$var$shouldAddEvent(replay, event)) return Promise.resolve(null);
    return $604631306887a81e$var$_addEvent(replay, event, isCheckout);
}
async function $604631306887a81e$var$_addEvent(replay, event, isCheckout) {
    const { eventBuffer: eventBuffer } = replay;
    if (!eventBuffer || eventBuffer.waitForCheckout && !isCheckout) return null;
    const isBufferMode = replay.recordingMode === 'buffer';
    try {
        if (isCheckout && isBufferMode) eventBuffer.clear();
        if (isCheckout) {
            eventBuffer.hasCheckout = true;
            eventBuffer.waitForCheckout = false;
        }
        const replayOptions = replay.getOptions();
        const eventAfterPossibleCallback = $604631306887a81e$var$maybeApplyCallback(event, replayOptions.beforeAddRecordingEvent);
        if (!eventAfterPossibleCallback) return;
        return await eventBuffer.addEvent(eventAfterPossibleCallback);
    } catch (error) {
        const isExceeded = error && error instanceof $604631306887a81e$var$EventBufferSizeExceededError;
        const reason = isExceeded ? 'addEventSizeExceeded' : 'addEvent';
        const client = (0, $7d48e1ed9f699a01$export$6bb76d6eba7e258c)();
        if (client) {
            // We are limited in the drop reasons:
            // https://github.com/getsentry/snuba/blob/6c73be60716c2fb1c30ca627883207887c733cbd/rust_snuba/src/processors/outcomes.rs#L39
            const dropReason = isExceeded ? 'buffer_overflow' : 'internal_sdk_error';
            client.recordDroppedEvent(dropReason, 'replay');
        }
        if (isExceeded && isBufferMode) {
            // Clear buffer and wait for next checkout
            eventBuffer.clear();
            eventBuffer.waitForCheckout = true;
            return null;
        }
        replay.handleException(error);
        await replay.stop({
            reason: reason
        });
    }
}
/** Exported only for tests. */ function $604631306887a81e$var$shouldAddEvent(replay, event) {
    if (!replay.eventBuffer || replay.isPaused() || !replay.isEnabled()) return false;
    const timestampInMs = $604631306887a81e$var$timestampToMs(event.timestamp);
    // Throw out events that happen more than 5 minutes ago. This can happen if
    // page has been left open and idle for a long period of time and user
    // comes back to trigger a new session. The performance entries rely on
    // `performance.timeOrigin`, which is when the page first opened.
    if (timestampInMs + replay.timeouts.sessionIdlePause < Date.now()) return false;
    // Throw out events that are +60min from the initial timestamp
    if (timestampInMs > replay.getContext().initialTimestamp + replay.getOptions().maxReplayDuration) {
        $604631306887a81e$var$DEBUG_BUILD && $604631306887a81e$var$debug.infoTick(`Skipping event with timestamp ${timestampInMs} because it is after maxReplayDuration`);
        return false;
    }
    return true;
}
function $604631306887a81e$var$maybeApplyCallback(event, callback) {
    try {
        if (typeof callback === 'function' && $604631306887a81e$var$isCustomEvent(event)) return callback(event);
    } catch (error) {
        $604631306887a81e$var$DEBUG_BUILD && $604631306887a81e$var$debug.exception(error, 'An error occurred in the `beforeAddRecordingEvent` callback, skipping the event...');
        return null;
    }
    return event;
}
/** If the event is an error event */ function $604631306887a81e$var$isErrorEvent(event) {
    return !event.type;
}
/** If the event is a transaction event */ function $604631306887a81e$var$isTransactionEvent(event) {
    return event.type === 'transaction';
}
/** If the event is an replay event */ function $604631306887a81e$var$isReplayEvent(event) {
    return event.type === 'replay_event';
}
/** If the event is a feedback event */ function $604631306887a81e$var$isFeedbackEvent(event) {
    return event.type === 'feedback';
}
/**
 * Returns a listener to be added to `client.on('afterSendErrorEvent, listener)`.
 */ function $604631306887a81e$var$handleAfterSendEvent(replay) {
    return (event, sendResponse)=>{
        if (!replay.isEnabled() || !$604631306887a81e$var$isErrorEvent(event) && !$604631306887a81e$var$isTransactionEvent(event)) return;
        const statusCode = sendResponse.statusCode;
        // We only want to do stuff on successful error sending, otherwise you get error replays without errors attached
        // We skip if we encountered an non-OK status code
        if (!statusCode || statusCode < 200 || statusCode >= 300) return;
        if ($604631306887a81e$var$isTransactionEvent(event)) {
            $604631306887a81e$var$handleTransactionEvent(replay, event);
            return;
        }
        $604631306887a81e$var$handleErrorEvent(replay, event);
    };
}
function $604631306887a81e$var$handleTransactionEvent(replay, event) {
    const replayContext = replay.getContext();
    // Collect traceIds in _context regardless of `recordingMode`
    // In error mode, _context gets cleared on every checkout
    // We limit to max. 100 transactions linked
    if (event.contexts?.trace?.trace_id && replayContext.traceIds.size < 100) replayContext.traceIds.add(event.contexts.trace.trace_id);
}
function $604631306887a81e$var$handleErrorEvent(replay, event) {
    const replayContext = replay.getContext();
    // Add error to list of errorIds of replay. This is ok to do even if not
    // sampled because context will get reset at next checkout.
    // XXX: There is also a race condition where it's possible to capture an
    // error to Sentry before Replay SDK has loaded, but response returns after
    // it was loaded, and this gets called.
    // We limit to max. 100 errors linked
    if (event.event_id && replayContext.errorIds.size < 100) replayContext.errorIds.add(event.event_id);
    // If error event is tagged with replay id it means it was sampled (when in buffer mode)
    // Need to be very careful that this does not cause an infinite loop
    if (replay.recordingMode !== 'buffer' || !event.tags?.replayId) return;
    const { beforeErrorSampling: beforeErrorSampling } = replay.getOptions();
    if (typeof beforeErrorSampling === 'function' && !beforeErrorSampling(event)) return;
    (0, $a11db510f5040b04$export$831dc9f2ab0a617b)(async ()=>{
        try {
            // Capture current event buffer as new replay
            await replay.sendBufferedReplayOrFlush();
        } catch (err) {
            replay.handleException(err);
        }
    });
}
/**
 * Returns a listener to be added to `client.on('afterSendErrorEvent, listener)`.
 */ function $604631306887a81e$var$handleBeforeSendEvent(replay) {
    return (event)=>{
        if (!replay.isEnabled() || !$604631306887a81e$var$isErrorEvent(event)) return;
        $604631306887a81e$var$handleHydrationError(replay, event);
    };
}
function $604631306887a81e$var$handleHydrationError(replay, event) {
    const exceptionValue = event.exception?.values?.[0]?.value;
    if (typeof exceptionValue !== 'string') return;
    if (// Only matches errors in production builds of react-dom
    // Example https://reactjs.org/docs/error-decoder.html?invariant=423
    // With newer React versions, the messages changed to a different website https://react.dev/errors/418
    exceptionValue.match(/(reactjs\.org\/docs\/error-decoder\.html\?invariant=|react\.dev\/errors\/)(418|419|422|423|425)/) || // Development builds of react-dom
    // Error 1: Hydration failed because the initial UI does not match what was rendered on the server.
    // Error 2: Text content does not match server-rendered HTML. Warning: Text content did not match.
    exceptionValue.match(/(does not match server-rendered HTML|Hydration failed because)/i)) {
        const breadcrumb = $604631306887a81e$var$createBreadcrumb({
            category: 'replay.hydrate-error',
            data: {
                url: (0, $caac489b9d8395b2$export$1cfafeee2987818b)()
            }
        });
        $604631306887a81e$var$addBreadcrumbEvent(replay, breadcrumb);
    }
}
/**
 * Handle breadcrumbs that Sentry captures, and make sure to capture relevant breadcrumbs to Replay as well.
 */ function $604631306887a81e$var$handleBreadcrumbs(replay) {
    const client = (0, $7d48e1ed9f699a01$export$6bb76d6eba7e258c)();
    if (!client) return;
    client.on('beforeAddBreadcrumb', (breadcrumb)=>$604631306887a81e$var$beforeAddBreadcrumb(replay, breadcrumb));
}
function $604631306887a81e$var$beforeAddBreadcrumb(replay, breadcrumb) {
    if (!replay.isEnabled() || !$604631306887a81e$var$isBreadcrumbWithCategory(breadcrumb)) return;
    const result = $604631306887a81e$var$normalizeBreadcrumb(breadcrumb);
    if (result) $604631306887a81e$var$addBreadcrumbEvent(replay, result);
}
/** Exported only for tests. */ function $604631306887a81e$var$normalizeBreadcrumb(breadcrumb) {
    if (!$604631306887a81e$var$isBreadcrumbWithCategory(breadcrumb) || [
        // fetch & xhr are handled separately,in handleNetworkBreadcrumbs
        'fetch',
        'xhr',
        // These two are breadcrumbs for emitted sentry events, we don't care about them
        'sentry.event',
        'sentry.transaction'
    ].includes(breadcrumb.category) || // We capture UI breadcrumbs separately
    breadcrumb.category.startsWith('ui.')) return null;
    if (breadcrumb.category === 'console') return $604631306887a81e$var$normalizeConsoleBreadcrumb(breadcrumb);
    return $604631306887a81e$var$createBreadcrumb(breadcrumb);
}
/** exported for tests only */ function $604631306887a81e$var$normalizeConsoleBreadcrumb(breadcrumb) {
    const args = breadcrumb.data?.arguments;
    if (!Array.isArray(args) || args.length === 0) return $604631306887a81e$var$createBreadcrumb(breadcrumb);
    let isTruncated = false;
    // Avoid giant args captures
    const normalizedArgs = args.map((arg)=>{
        if (!arg) return arg;
        if (typeof arg === 'string') {
            if (arg.length > $604631306887a81e$var$CONSOLE_ARG_MAX_SIZE) {
                isTruncated = true;
                return `${arg.slice(0, $604631306887a81e$var$CONSOLE_ARG_MAX_SIZE)}\u{2026}`;
            }
            return arg;
        }
        if (typeof arg === 'object') try {
            const normalizedArg = (0, $2d7134eeb4bc669b$export$a3295358bff77e)(arg, 7);
            const stringified = JSON.stringify(normalizedArg);
            if (stringified.length > $604631306887a81e$var$CONSOLE_ARG_MAX_SIZE) {
                isTruncated = true;
                // We use the pretty printed JSON string here as a base
                return `${JSON.stringify(normalizedArg, null, 2).slice(0, $604631306887a81e$var$CONSOLE_ARG_MAX_SIZE)}\u{2026}`;
            }
            return normalizedArg;
        } catch  {
        // fall back to default
        }
        return arg;
    });
    return $604631306887a81e$var$createBreadcrumb({
        ...breadcrumb,
        data: {
            ...breadcrumb.data,
            arguments: normalizedArgs,
            ...isTruncated ? {
                _meta: {
                    warnings: [
                        'CONSOLE_ARG_TRUNCATED'
                    ]
                }
            } : {}
        }
    });
}
function $604631306887a81e$var$isBreadcrumbWithCategory(breadcrumb) {
    return !!breadcrumb.category;
}
/**
 * Returns true if we think the given event is an error originating inside of rrweb.
 */ function $604631306887a81e$var$isRrwebError(event, hint) {
    if (event.type || !event.exception?.values?.length) return false;
    // @ts-expect-error this may be set by rrweb when it finds errors
    if (hint.originalException?.__rrweb__) return true;
    return false;
}
/**
 * Reset the `replay_id` field on the DSC.
 */ function $604631306887a81e$var$resetReplayIdOnDynamicSamplingContext() {
    // Reset DSC on the current scope, if there is one
    const dsc = (0, $7d48e1ed9f699a01$export$c7be4b0125a10cba)().getPropagationContext().dsc;
    if (dsc) delete dsc.replay_id;
    // Clear it from frozen DSC on the active span
    const activeSpan = (0, $bb9b6447bf4caedb$export$1be426a8e585c83e)();
    if (activeSpan) {
        const dsc = (0, $09fae5ef8120e803$export$a117f995597e25df)(activeSpan);
        delete dsc.replay_id;
    }
}
/**
 * Add a feedback breadcrumb event to replay.
 */ function $604631306887a81e$var$addFeedbackBreadcrumb(replay, event) {
    replay.triggerUserActivity();
    replay.addUpdate(()=>{
        if (!event.timestamp) // Ignore events that don't have timestamps (this shouldn't happen, more of a typing issue)
        // Return true here so that we don't flush
        return true;
        // This should never reject
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        replay.throttledAddEvent({
            type: $604631306887a81e$var$EventType.Custom,
            timestamp: event.timestamp * 1000,
            data: {
                tag: 'breadcrumb',
                payload: {
                    timestamp: event.timestamp,
                    type: 'default',
                    category: 'sentry.feedback',
                    data: {
                        feedbackId: event.event_id
                    }
                }
            }
        });
        return false;
    });
}
/**
 * Determine if event should be sampled (only applies in buffer mode).
 * When an event is captured by `handleGlobalEvent`, when in buffer mode
 * we determine if we want to sample the error or not.
 */ function $604631306887a81e$var$shouldSampleForBufferEvent(replay, event) {
    if (replay.recordingMode !== 'buffer') return false;
    // ignore this error because otherwise we could loop indefinitely with
    // trying to capture replay and failing
    if (event.message === $604631306887a81e$var$UNABLE_TO_SEND_REPLAY) return false;
    // Require the event to be an error event & to have an exception
    if (!event.exception || event.type) return false;
    return $604631306887a81e$var$isSampled(replay.getOptions().errorSampleRate);
}
/**
 * Returns a listener to be added to `addEventProcessor(listener)`.
 */ function $604631306887a81e$var$handleGlobalEventListener(replay) {
    return Object.assign((event, hint)=>{
        // Do nothing if replay has been disabled or paused
        if (!replay.isEnabled() || replay.isPaused()) return event;
        if ($604631306887a81e$var$isReplayEvent(event)) {
            // Replays have separate set of breadcrumbs, do not include breadcrumbs
            // from core SDK
            delete event.breadcrumbs;
            return event;
        }
        // We only want to handle errors, transactions, and feedbacks, nothing else
        if (!$604631306887a81e$var$isErrorEvent(event) && !$604631306887a81e$var$isTransactionEvent(event) && !$604631306887a81e$var$isFeedbackEvent(event)) return event;
        // Ensure we do not add replay_id if the session is expired
        const isSessionActive = replay.checkAndHandleExpiredSession();
        if (!isSessionActive) {
            // prevent exceeding replay durations by removing the expired replayId from the DSC
            $604631306887a81e$var$resetReplayIdOnDynamicSamplingContext();
            return event;
        }
        if ($604631306887a81e$var$isFeedbackEvent(event)) {
            // This should never reject
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            replay.flush();
            event.contexts.feedback.replay_id = replay.getSessionId();
            // Add a replay breadcrumb for this piece of feedback
            $604631306887a81e$var$addFeedbackBreadcrumb(replay, event);
            return event;
        }
        // Unless `captureExceptions` is enabled, we want to ignore errors coming from rrweb
        // As there can be a bunch of stuff going wrong in internals there, that we don't want to bubble up to users
        if ($604631306887a81e$var$isRrwebError(event, hint) && !replay.getOptions()._experiments.captureExceptions) {
            $604631306887a81e$var$DEBUG_BUILD && $604631306887a81e$var$debug.log('Ignoring error from rrweb internals', event);
            return null;
        }
        // When in buffer mode, we decide to sample here.
        // Later, in `handleAfterSendEvent`, if the replayId is set, we know that we sampled
        // And convert the buffer session to a full session
        const isErrorEventSampled = $604631306887a81e$var$shouldSampleForBufferEvent(replay, event);
        // Tag errors if it has been sampled in buffer mode, or if it is session mode
        // Only tag transactions if in session mode
        const shouldTagReplayId = isErrorEventSampled || replay.recordingMode === 'session';
        if (shouldTagReplayId) event.tags = {
            ...event.tags,
            replayId: replay.getSessionId()
        };
        // If we sampled this error in buffer mode, immediately mark the session as "sampled"
        // by changing the sampled state from 'buffer' to 'session'. Otherwise, if the application is interrupte
        // before `afterSendEvent` occurs, then the session would remain as "buffer" but we have an error event
        // that is tagged with a replay id. This could end up creating replays w/ excessive durations because
        // of the linked error.
        if (isErrorEventSampled && replay.recordingMode === 'buffer' && replay.session?.sampled === 'buffer') {
            const session = replay.session;
            session.dirty = true;
            // Save the session if sticky sessions are enabled to persist the state change
            if (replay.getOptions().stickySession) $604631306887a81e$var$saveSession(session);
        }
        return event;
    }, {
        id: 'Replay'
    });
}
/**
 * Create a "span" for each performance entry.
 */ function $604631306887a81e$var$createPerformanceSpans(replay, entries) {
    return entries.map(({ type: type, start: start, end: end, name: name, data: data })=>{
        const response = replay.throttledAddEvent({
            type: $604631306887a81e$var$EventType.Custom,
            timestamp: start,
            data: {
                tag: 'performanceSpan',
                payload: {
                    op: type,
                    description: name,
                    startTimestamp: start,
                    endTimestamp: end,
                    data: data
                }
            }
        });
        // If response is a string, it means its either THROTTLED or SKIPPED
        return typeof response === 'string' ? Promise.resolve(null) : response;
    });
}
function $604631306887a81e$var$handleHistory(handlerData) {
    const { from: from, to: to } = handlerData;
    const now = Date.now() / 1000;
    return {
        type: 'navigation.push',
        start: now,
        end: now,
        name: to,
        data: {
            previous: from
        }
    };
}
/**
 * Returns a listener to be added to `addHistoryInstrumentationHandler(listener)`.
 */ function $604631306887a81e$var$handleHistorySpanListener(replay) {
    return (handlerData)=>{
        if (!replay.isEnabled()) return;
        const result = $604631306887a81e$var$handleHistory(handlerData);
        if (result === null) return;
        // Need to collect visited URLs
        replay.getContext().urls.push(result.name);
        replay.triggerUserActivity();
        replay.addUpdate(()=>{
            // oxlint-disable-next-line typescript/no-floating-promises
            $604631306887a81e$var$createPerformanceSpans(replay, [
                result
            ]);
            // Returning false to flush
            return false;
        });
    };
}
/**
 * Check whether a given request URL should be filtered out. This is so we
 * don't log Sentry ingest requests.
 */ function $604631306887a81e$var$shouldFilterRequest(replay, url) {
    // If we enabled the `traceInternals` experiment, we want to trace everything
    if ($604631306887a81e$var$DEBUG_BUILD && replay.getOptions()._experiments.traceInternals) return false;
    return (0, $7b9954de727fbe52$export$d92e61f5600202af)(url, (0, $7d48e1ed9f699a01$export$6bb76d6eba7e258c)());
}
/** Add a performance entry breadcrumb */ function $604631306887a81e$var$addNetworkBreadcrumb(replay, result) {
    if (!replay.isEnabled()) return;
    if (result === null) return;
    if ($604631306887a81e$var$shouldFilterRequest(replay, result.name)) return;
    replay.addUpdate(()=>{
        // oxlint-disable-next-line typescript/no-floating-promises
        $604631306887a81e$var$createPerformanceSpans(replay, [
            result
        ]);
        // Returning true will cause `addUpdate` to not flush
        // We do not want network requests to cause a flush. This will prevent
        // recurring/polling requests from keeping the replay session alive.
        return true;
    });
}
/** Get the size of a body. */ function $604631306887a81e$var$getBodySize(body) {
    if (!body) return undefined;
    const textEncoder = new TextEncoder();
    try {
        if (typeof body === 'string') return textEncoder.encode(body).length;
        if (body instanceof URLSearchParams) return textEncoder.encode(body.toString()).length;
        if (body instanceof FormData) {
            const formDataStr = (0, $e82a9c6161ef9dbd$export$2f1b0f57f243f270)(body);
            return textEncoder.encode(formDataStr).length;
        }
        if (body instanceof Blob) return body.size;
        if (body instanceof ArrayBuffer) return body.byteLength;
    // Currently unhandled types: ArrayBufferView, ReadableStream
    } catch  {
    // just return undefined
    }
    return undefined;
}
/** Convert a Content-Length header to number/undefined.  */ function $604631306887a81e$var$parseContentLengthHeader(header) {
    if (!header) return undefined;
    const size = parseInt(header, 10);
    return isNaN(size) ? undefined : size;
}
/** Merge a warning into an existing network request/response. */ function $604631306887a81e$var$mergeWarning(info, warning) {
    if (!info) return {
        headers: {},
        size: undefined,
        _meta: {
            warnings: [
                warning
            ]
        }
    };
    const newMeta = {
        ...info._meta
    };
    const existingWarnings = newMeta.warnings || [];
    newMeta.warnings = [
        ...existingWarnings,
        warning
    ];
    info._meta = newMeta;
    return info;
}
/** Convert ReplayNetworkRequestData to a PerformanceEntry. */ function $604631306887a81e$var$makeNetworkReplayBreadcrumb(type, data) {
    if (!data) return null;
    const { startTimestamp: startTimestamp, endTimestamp: endTimestamp, url: url, method: method, statusCode: statusCode, request: request, response: response } = data;
    const result = {
        type: type,
        start: startTimestamp / 1000,
        end: endTimestamp / 1000,
        name: url,
        data: {
            method: method,
            statusCode: statusCode,
            request: request,
            response: response
        }
    };
    return result;
}
/** Build the request or response part of a replay network breadcrumb that was skipped. */ function $604631306887a81e$var$buildSkippedNetworkRequestOrResponse(bodySize) {
    return {
        headers: {},
        size: bodySize,
        _meta: {
            warnings: [
                'URL_SKIPPED'
            ]
        }
    };
}
/** Build the request or response part of a replay network breadcrumb. */ function $604631306887a81e$var$buildNetworkRequestOrResponse(headers, bodySize, body) {
    if (!bodySize && Object.keys(headers).length === 0) return undefined;
    if (!bodySize) return {
        headers: headers
    };
    if (!body) return {
        headers: headers,
        size: bodySize
    };
    const info = {
        headers: headers,
        size: bodySize
    };
    const { body: normalizedBody, warnings: warnings } = $604631306887a81e$var$normalizeNetworkBody(body);
    info.body = normalizedBody;
    if (warnings?.length) info._meta = {
        warnings: warnings
    };
    return info;
}
/** Filter a set of headers */ function $604631306887a81e$var$getAllowedHeaders(headers, allowedHeaders) {
    return Object.entries(headers).reduce((filteredHeaders, [key, value])=>{
        const normalizedKey = key.toLowerCase();
        // Avoid putting empty strings into the headers
        if (allowedHeaders.includes(normalizedKey) && headers[key]) filteredHeaders[normalizedKey] = value;
        return filteredHeaders;
    }, {});
}
function $604631306887a81e$var$normalizeNetworkBody(body) {
    if (!body || typeof body !== 'string') return {
        body: body
    };
    const exceedsSizeLimit = body.length > $604631306887a81e$var$NETWORK_BODY_MAX_SIZE;
    const isProbablyJson = $604631306887a81e$var$_strIsProbablyJson(body);
    if (exceedsSizeLimit) {
        const truncatedBody = body.slice(0, $604631306887a81e$var$NETWORK_BODY_MAX_SIZE);
        if (isProbablyJson) return {
            body: truncatedBody,
            warnings: [
                'MAYBE_JSON_TRUNCATED'
            ]
        };
        return {
            body: `${truncatedBody}\u{2026}`,
            warnings: [
                'TEXT_TRUNCATED'
            ]
        };
    }
    if (isProbablyJson) try {
        const jsonBody = JSON.parse(body);
        return {
            body: jsonBody
        };
    } catch  {
    // fall back to just send the body as string
    }
    return {
        body: body
    };
}
function $604631306887a81e$var$_strIsProbablyJson(str) {
    const first = str[0];
    const last = str[str.length - 1];
    // Simple check: If this does not start & end with {} or [], it's not JSON
    return first === '[' && last === ']' || first === '{' && last === '}';
}
/** Match an URL against a list of strings/Regex. */ function $604631306887a81e$var$urlMatches(url, urls) {
    const fullUrl = $604631306887a81e$var$getFullUrl(url);
    return (0, $e534db390d1e4996$export$a7a5ec66062ea5d)(fullUrl, urls);
}
/** exported for tests */ function $604631306887a81e$var$getFullUrl(url, baseURI = $604631306887a81e$var$WINDOW.document.baseURI) {
    // Short circuit for common cases:
    if (url.startsWith('http://') || url.startsWith('https://') || url.startsWith($604631306887a81e$var$WINDOW.location.origin)) return url;
    const fixedUrl = new URL(url, baseURI);
    // If these do not match, we are not dealing with a relative URL, so just return it
    if (fixedUrl.origin !== new URL(baseURI).origin) return url;
    const fullUrl = fixedUrl.href;
    // Remove trailing slashes, if they don't match the original URL
    if (!url.endsWith('/') && fullUrl.endsWith('/')) return fullUrl.slice(0, -1);
    return fullUrl;
}
/**
 * Capture a fetch breadcrumb to a replay.
 * This adds additional data (where appropriate).
 */ async function $604631306887a81e$var$captureFetchBreadcrumbToReplay(breadcrumb, hint, options) {
    try {
        const data = await $604631306887a81e$var$_prepareFetchData(breadcrumb, hint, options);
        // Create a replay performance entry from this breadcrumb
        const result = $604631306887a81e$var$makeNetworkReplayBreadcrumb('resource.fetch', data);
        $604631306887a81e$var$addNetworkBreadcrumb(options.replay, result);
    } catch (error) {
        $604631306887a81e$var$DEBUG_BUILD && $604631306887a81e$var$debug.exception(error, 'Failed to capture fetch breadcrumb');
    }
}
/**
 * Enrich a breadcrumb with additional data.
 * This has to be sync & mutate the given breadcrumb,
 * as the breadcrumb is afterwards consumed by other handlers.
 */ function $604631306887a81e$var$enrichFetchBreadcrumb(breadcrumb, hint) {
    const { input: input, response: response } = hint;
    const body = input ? (0, $e82a9c6161ef9dbd$export$ad44edf8012ec314)(input) : undefined;
    const reqSize = $604631306887a81e$var$getBodySize(body);
    const resSize = response ? $604631306887a81e$var$parseContentLengthHeader(response.headers.get('content-length')) : undefined;
    if (reqSize !== undefined) breadcrumb.data.request_body_size = reqSize;
    if (resSize !== undefined) breadcrumb.data.response_body_size = resSize;
}
async function $604631306887a81e$var$_prepareFetchData(breadcrumb, hint, options) {
    const now = Date.now();
    const { startTimestamp: startTimestamp = now, endTimestamp: endTimestamp = now } = hint;
    const { url: url, method: method, status_code: statusCode = 0, request_body_size: requestBodySize, response_body_size: responseBodySize } = breadcrumb.data;
    const captureDetails = $604631306887a81e$var$urlMatches(url, options.networkDetailAllowUrls) && !$604631306887a81e$var$urlMatches(url, options.networkDetailDenyUrls);
    const request = captureDetails ? $604631306887a81e$var$_getRequestInfo(options, hint.input, requestBodySize) : $604631306887a81e$var$buildSkippedNetworkRequestOrResponse(requestBodySize);
    const response = await $604631306887a81e$var$_getResponseInfo(captureDetails, options, hint.response, responseBodySize);
    return {
        startTimestamp: startTimestamp,
        endTimestamp: endTimestamp,
        url: url,
        method: method,
        statusCode: statusCode,
        request: request,
        response: response
    };
}
function $604631306887a81e$var$_getRequestInfo({ networkCaptureBodies: networkCaptureBodies, networkRequestHeaders: networkRequestHeaders }, input, requestBodySize) {
    const headers = input ? $604631306887a81e$var$getRequestHeaders(input, networkRequestHeaders) : {};
    if (!networkCaptureBodies) return $604631306887a81e$var$buildNetworkRequestOrResponse(headers, requestBodySize, undefined);
    // We only want to transmit string or string-like bodies
    const requestBody = (0, $e82a9c6161ef9dbd$export$ad44edf8012ec314)(input);
    const [bodyStr, warning] = (0, $e82a9c6161ef9dbd$export$945a2d5364608d5)(requestBody, $604631306887a81e$var$debug);
    const data = $604631306887a81e$var$buildNetworkRequestOrResponse(headers, requestBodySize, bodyStr);
    if (warning) return $604631306887a81e$var$mergeWarning(data, warning);
    return data;
}
/** Exported only for tests. */ async function $604631306887a81e$var$_getResponseInfo(captureDetails, { networkCaptureBodies: networkCaptureBodies, networkResponseHeaders: networkResponseHeaders }, response, responseBodySize) {
    if (!captureDetails && responseBodySize !== undefined) return $604631306887a81e$var$buildSkippedNetworkRequestOrResponse(responseBodySize);
    const headers = response ? $604631306887a81e$var$getAllHeaders(response.headers, networkResponseHeaders) : {};
    if (!response || !networkCaptureBodies && responseBodySize !== undefined) return $604631306887a81e$var$buildNetworkRequestOrResponse(headers, responseBodySize, undefined);
    const [bodyText, warning] = await $604631306887a81e$var$_parseFetchResponseBody(response);
    const result = $604631306887a81e$var$getResponseData(bodyText, {
        networkCaptureBodies: networkCaptureBodies,
        responseBodySize: responseBodySize,
        captureDetails: captureDetails,
        headers: headers
    });
    if (warning) return $604631306887a81e$var$mergeWarning(result, warning);
    return result;
}
function $604631306887a81e$var$getResponseData(bodyText, { networkCaptureBodies: networkCaptureBodies, responseBodySize: responseBodySize, captureDetails: captureDetails, headers: headers }) {
    try {
        const size = bodyText?.length && responseBodySize === undefined ? $604631306887a81e$var$getBodySize(bodyText) : responseBodySize;
        if (!captureDetails) return $604631306887a81e$var$buildSkippedNetworkRequestOrResponse(size);
        if (networkCaptureBodies) return $604631306887a81e$var$buildNetworkRequestOrResponse(headers, size, bodyText);
        return $604631306887a81e$var$buildNetworkRequestOrResponse(headers, size, undefined);
    } catch (error) {
        $604631306887a81e$var$DEBUG_BUILD && $604631306887a81e$var$debug.exception(error, 'Failed to serialize response body');
        // fallback
        return $604631306887a81e$var$buildNetworkRequestOrResponse(headers, responseBodySize, undefined);
    }
}
async function $604631306887a81e$var$_parseFetchResponseBody(response) {
    const res = $604631306887a81e$var$_tryCloneResponse(response);
    if (!res) return [
        undefined,
        'BODY_PARSE_ERROR'
    ];
    try {
        const text = await $604631306887a81e$var$_tryGetResponseText(res);
        return [
            text
        ];
    } catch (error) {
        if (error instanceof Error && error.message.indexOf('Timeout') > -1) {
            $604631306887a81e$var$DEBUG_BUILD && $604631306887a81e$var$debug.warn('Parsing text body from response timed out');
            return [
                undefined,
                'BODY_PARSE_TIMEOUT'
            ];
        }
        $604631306887a81e$var$DEBUG_BUILD && $604631306887a81e$var$debug.exception(error, 'Failed to get text body from response');
        return [
            undefined,
            'BODY_PARSE_ERROR'
        ];
    }
}
function $604631306887a81e$var$getAllHeaders(headers, allowedHeaders) {
    const allHeaders = {};
    allowedHeaders.forEach((header)=>{
        if (headers.get(header)) allHeaders[header] = headers.get(header);
    });
    return allHeaders;
}
function $604631306887a81e$var$getRequestHeaders(fetchArgs, allowedHeaders) {
    if (fetchArgs.length === 1 && typeof fetchArgs[0] !== 'string') return $604631306887a81e$var$getHeadersFromOptions(fetchArgs[0], allowedHeaders);
    if (fetchArgs.length === 2) return $604631306887a81e$var$getHeadersFromOptions(fetchArgs[1], allowedHeaders);
    return {};
}
function $604631306887a81e$var$getHeadersFromOptions(input, allowedHeaders) {
    if (!input) return {};
    const headers = input.headers;
    if (!headers) return {};
    if (headers instanceof Headers) return $604631306887a81e$var$getAllHeaders(headers, allowedHeaders);
    // We do not support this, as it is not really documented (anymore?)
    if (Array.isArray(headers)) return {};
    return $604631306887a81e$var$getAllowedHeaders(headers, allowedHeaders);
}
function $604631306887a81e$var$_tryCloneResponse(response) {
    try {
        // We have to clone this, as the body can only be read once
        return response.clone();
    } catch (error) {
        // this can throw if the response was already consumed before
        $604631306887a81e$var$DEBUG_BUILD && $604631306887a81e$var$debug.exception(error, 'Failed to clone response body');
    }
}
/**
 * Get the response body of a fetch request, or timeout after 500ms.
 * Fetch can return a streaming body, that may not resolve (or not for a long time).
 * If that happens, we rather abort after a short time than keep waiting for this.
 */ function $604631306887a81e$var$_tryGetResponseText(response) {
    return new Promise((resolve, reject)=>{
        const timeout = (0, $a11db510f5040b04$export$831dc9f2ab0a617b)(()=>reject(new Error('Timeout while trying to read response body')), 500);
        $604631306887a81e$var$_getResponseText(response).then((txt)=>resolve(txt), (reason)=>reject(reason)).finally(()=>clearTimeout(timeout));
    });
}
async function $604631306887a81e$var$_getResponseText(response) {
    // Force this to be a promise, just to be safe
    // eslint-disable-next-line no-return-await
    return await response.text();
}
/**
 * Capture an XHR breadcrumb to a replay.
 * This adds additional data (where appropriate).
 */ async function $604631306887a81e$var$captureXhrBreadcrumbToReplay(breadcrumb, hint, options) {
    try {
        const data = $604631306887a81e$var$_prepareXhrData(breadcrumb, hint, options);
        // Create a replay performance entry from this breadcrumb
        const result = $604631306887a81e$var$makeNetworkReplayBreadcrumb('resource.xhr', data);
        $604631306887a81e$var$addNetworkBreadcrumb(options.replay, result);
    } catch (error) {
        $604631306887a81e$var$DEBUG_BUILD && $604631306887a81e$var$debug.exception(error, 'Failed to capture xhr breadcrumb');
    }
}
/**
 * Enrich a breadcrumb with additional data.
 * This has to be sync & mutate the given breadcrumb,
 * as the breadcrumb is afterwards consumed by other handlers.
 */ function $604631306887a81e$var$enrichXhrBreadcrumb(breadcrumb, hint) {
    const { xhr: xhr, input: input } = hint;
    if (!xhr) return;
    const reqSize = $604631306887a81e$var$getBodySize(input);
    const resSize = xhr.getResponseHeader('content-length') ? $604631306887a81e$var$parseContentLengthHeader(xhr.getResponseHeader('content-length')) : $604631306887a81e$var$_getBodySize(xhr.response, xhr.responseType);
    if (reqSize !== undefined) breadcrumb.data.request_body_size = reqSize;
    if (resSize !== undefined) breadcrumb.data.response_body_size = resSize;
}
function $604631306887a81e$var$_prepareXhrData(breadcrumb, hint, options) {
    const now = Date.now();
    const { startTimestamp: startTimestamp = now, endTimestamp: endTimestamp = now, input: input, xhr: xhr } = hint;
    const { url: url, method: method, status_code: statusCode = 0, request_body_size: requestBodySize, response_body_size: responseBodySize } = breadcrumb.data;
    if (!url) return null;
    if (!xhr || !$604631306887a81e$var$urlMatches(url, options.networkDetailAllowUrls) || $604631306887a81e$var$urlMatches(url, options.networkDetailDenyUrls)) {
        const request = $604631306887a81e$var$buildSkippedNetworkRequestOrResponse(requestBodySize);
        const response = $604631306887a81e$var$buildSkippedNetworkRequestOrResponse(responseBodySize);
        return {
            startTimestamp: startTimestamp,
            endTimestamp: endTimestamp,
            url: url,
            method: method,
            statusCode: statusCode,
            request: request,
            response: response
        };
    }
    // ---- This additional network data below is only captured for URLs defined in `networkDetailAllowUrls` ----
    const xhrInfo = xhr[0, $a83999f742846a08$export$55b6bb1e45c6cf59];
    const networkRequestHeaders = xhrInfo ? $604631306887a81e$var$getAllowedHeaders(xhrInfo.request_headers, options.networkRequestHeaders) : {};
    const networkResponseHeaders = $604631306887a81e$var$getAllowedHeaders((0, $e82a9c6161ef9dbd$export$ce71c337afb62ea)(xhr), options.networkResponseHeaders);
    const [requestBody, requestWarning] = options.networkCaptureBodies ? (0, $e82a9c6161ef9dbd$export$945a2d5364608d5)(input, $604631306887a81e$var$debug) : [
        undefined
    ];
    const [responseBody, responseWarning] = options.networkCaptureBodies ? $604631306887a81e$var$_getXhrResponseBody(xhr) : [
        undefined
    ];
    const request = $604631306887a81e$var$buildNetworkRequestOrResponse(networkRequestHeaders, requestBodySize, requestBody);
    const response = $604631306887a81e$var$buildNetworkRequestOrResponse(networkResponseHeaders, responseBodySize, responseBody);
    return {
        startTimestamp: startTimestamp,
        endTimestamp: endTimestamp,
        url: url,
        method: method,
        statusCode: statusCode,
        request: requestWarning ? $604631306887a81e$var$mergeWarning(request, requestWarning) : request,
        response: responseWarning ? $604631306887a81e$var$mergeWarning(response, responseWarning) : response
    };
}
function $604631306887a81e$var$_getXhrResponseBody(xhr) {
    // We collect errors that happen, but only log them if we can't get any response body
    const errors = [];
    try {
        return [
            xhr.responseText
        ];
    } catch (e) {
        errors.push(e);
    }
    // Try to manually parse the response body, if responseText fails
    try {
        return $604631306887a81e$var$_parseXhrResponse(xhr.response, xhr.responseType);
    } catch (e) {
        errors.push(e);
    }
    $604631306887a81e$var$DEBUG_BUILD && $604631306887a81e$var$debug.warn('Failed to get xhr response body', ...errors);
    return [
        undefined
    ];
}
/**
 * Get the string representation of the XHR response.
 * Based on MDN, these are the possible types of the response:
 * string
 * ArrayBuffer
 * Blob
 * Document
 * POJO
 *
 * Exported only for tests.
 */ function $604631306887a81e$var$_parseXhrResponse(body, responseType) {
    try {
        if (typeof body === 'string') return [
            body
        ];
        if (body instanceof Document) return [
            body.body.outerHTML
        ];
        if (responseType === 'json' && body && typeof body === 'object') return [
            JSON.stringify(body)
        ];
        if (!body) return [
            undefined
        ];
    } catch (error) {
        $604631306887a81e$var$DEBUG_BUILD && $604631306887a81e$var$debug.exception(error, 'Failed to serialize body', body);
        return [
            undefined,
            'BODY_PARSE_ERROR'
        ];
    }
    $604631306887a81e$var$DEBUG_BUILD && $604631306887a81e$var$debug.log('Skipping network body because of body type', body);
    return [
        undefined,
        'UNPARSEABLE_BODY_TYPE'
    ];
}
function $604631306887a81e$var$_getBodySize(body, responseType) {
    try {
        const bodyStr = responseType === 'json' && body && typeof body === 'object' ? JSON.stringify(body) : body;
        return $604631306887a81e$var$getBodySize(bodyStr);
    } catch  {
        return undefined;
    }
}
/**
 * This method does two things:
 * - It enriches the regular XHR/fetch breadcrumbs with request/response size data
 * - It captures the XHR/fetch breadcrumbs to the replay
 *   (enriching it with further data that is _not_ added to the regular breadcrumbs)
 */ function $604631306887a81e$var$handleNetworkBreadcrumbs(replay) {
    const client = (0, $7d48e1ed9f699a01$export$6bb76d6eba7e258c)();
    try {
        const { networkDetailAllowUrls: networkDetailAllowUrls, networkDetailDenyUrls: networkDetailDenyUrls, networkCaptureBodies: networkCaptureBodies, networkRequestHeaders: networkRequestHeaders, networkResponseHeaders: networkResponseHeaders } = replay.getOptions();
        const options = {
            replay: replay,
            networkDetailAllowUrls: networkDetailAllowUrls,
            networkDetailDenyUrls: networkDetailDenyUrls,
            networkCaptureBodies: networkCaptureBodies,
            networkRequestHeaders: networkRequestHeaders,
            networkResponseHeaders: networkResponseHeaders
        };
        if (client) client.on('beforeAddBreadcrumb', (breadcrumb, hint)=>$604631306887a81e$var$beforeAddNetworkBreadcrumb(options, breadcrumb, hint));
    } catch  {
    // Do nothing
    }
}
/** just exported for tests */ function $604631306887a81e$var$beforeAddNetworkBreadcrumb(options, breadcrumb, hint) {
    if (!breadcrumb.data) return;
    try {
        if ($604631306887a81e$var$_isXhrBreadcrumb(breadcrumb) && $604631306887a81e$var$_isXhrHint(hint)) {
            // This has to be sync, as we need to ensure the breadcrumb is enriched in the same tick
            // Because the hook runs synchronously, and the breadcrumb is afterwards passed on
            // So any async mutations to it will not be reflected in the final breadcrumb
            $604631306887a81e$var$enrichXhrBreadcrumb(breadcrumb, hint);
            // This call should not reject
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            $604631306887a81e$var$captureXhrBreadcrumbToReplay(breadcrumb, hint, options);
        }
        if ($604631306887a81e$var$_isFetchBreadcrumb(breadcrumb) && $604631306887a81e$var$_isFetchHint(hint)) {
            // This has to be sync, as we need to ensure the breadcrumb is enriched in the same tick
            // Because the hook runs synchronously, and the breadcrumb is afterwards passed on
            // So any async mutations to it will not be reflected in the final breadcrumb
            $604631306887a81e$var$enrichFetchBreadcrumb(breadcrumb, hint);
            // This call should not reject
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            $604631306887a81e$var$captureFetchBreadcrumbToReplay(breadcrumb, hint, options);
        }
    } catch (e) {
        $604631306887a81e$var$DEBUG_BUILD && $604631306887a81e$var$debug.exception(e, 'Error when enriching network breadcrumb');
    }
}
function $604631306887a81e$var$_isXhrBreadcrumb(breadcrumb) {
    return breadcrumb.category === 'xhr';
}
function $604631306887a81e$var$_isFetchBreadcrumb(breadcrumb) {
    return breadcrumb.category === 'fetch';
}
function $604631306887a81e$var$_isXhrHint(hint) {
    return hint?.xhr;
}
function $604631306887a81e$var$_isFetchHint(hint) {
    return hint?.response;
}
/**
 * Add global listeners that cannot be removed.
 */ function $604631306887a81e$var$addGlobalListeners(replay) {
    // Listeners from core SDK //
    const client = (0, $7d48e1ed9f699a01$export$6bb76d6eba7e258c)();
    (0, $16987639200114e3$export$5aeffd3db2cf9df7)($604631306887a81e$var$handleDomListener(replay));
    (0, $56137aac5362694e$export$3f18c56c58114e75)($604631306887a81e$var$handleHistorySpanListener(replay));
    $604631306887a81e$var$handleBreadcrumbs(replay);
    $604631306887a81e$var$handleNetworkBreadcrumbs(replay);
    // Tag all (non replay) events that get sent to Sentry with the current
    // replay ID so that we can reference them later in the UI
    const eventProcessor = $604631306887a81e$var$handleGlobalEventListener(replay);
    (0, $6918c722b531ff18$export$9aac0b9f77928fbf)(eventProcessor);
    // If a custom client has no hooks yet, we continue to use the "old" implementation
    if (client) {
        client.on('beforeSendEvent', $604631306887a81e$var$handleBeforeSendEvent(replay));
        client.on('afterSendEvent', $604631306887a81e$var$handleAfterSendEvent(replay));
        client.on('createDsc', (dsc)=>{
            const replayId = replay.getSessionId();
            // We do not want to set the DSC when in buffer mode, as that means the replay has not been sent (yet)
            if (replayId && replay.isEnabled() && replay.recordingMode === 'session') {
                // Ensure to check that the session is still active - it could have expired in the meanwhile
                const isSessionActive = replay.checkAndHandleExpiredSession();
                if (isSessionActive) dsc.replay_id = replayId;
            }
        });
        client.on('spanStart', (span)=>{
            replay.lastActiveSpan = span;
        });
        // We may be missing the initial spanStart due to timing issues,
        // so we capture it on finish again.
        client.on('spanEnd', (span)=>{
            replay.lastActiveSpan = span;
        });
        // We want to attach the replay id to the feedback event
        client.on('beforeSendFeedback', async (feedbackEvent, options)=>{
            const replayId = replay.getSessionId();
            if (options?.includeReplay && replay.isEnabled() && replayId && feedbackEvent.contexts?.feedback) {
                // In case the feedback is sent via API and not through our widget, we want to flush replay
                if (feedbackEvent.contexts.feedback.source === 'api') await replay.sendBufferedReplayOrFlush();
                feedbackEvent.contexts.feedback.replay_id = replayId;
            }
        });
        client.on('openFeedbackWidget', async ()=>{
            await replay.sendBufferedReplayOrFlush();
        });
    }
}
/**
 * Create a "span" for the total amount of memory being used by JS objects
 * (including v8 internal objects).
 */ async function $604631306887a81e$var$addMemoryEntry(replay) {
    // window.performance.memory is a non-standard API and doesn't work on all browsers, so we try-catch this
    try {
        return Promise.all($604631306887a81e$var$createPerformanceSpans(replay, [
            // @ts-expect-error memory doesn't exist on type Performance as the API is non-standard (we check that it exists above)
            $604631306887a81e$var$createMemoryEntry($604631306887a81e$var$WINDOW.performance.memory)
        ]));
    } catch  {
        // Do nothing
        return [];
    }
}
function $604631306887a81e$var$createMemoryEntry(memoryEntry) {
    const { jsHeapSizeLimit: jsHeapSizeLimit, totalJSHeapSize: totalJSHeapSize, usedJSHeapSize: usedJSHeapSize } = memoryEntry;
    // we don't want to use `getAbsoluteTime` because it adds the event time to the
    // time origin, so we get the current timestamp instead
    const time = Date.now() / 1000;
    return {
        type: 'memory',
        name: 'memory',
        start: time,
        end: time,
        data: {
            memory: {
                jsHeapSizeLimit: jsHeapSizeLimit,
                totalJSHeapSize: totalJSHeapSize,
                usedJSHeapSize: usedJSHeapSize
            }
        }
    };
}
/**
 * Heavily simplified debounce function based on lodash.debounce.
 *
 * This function takes a callback function (@param fun) and delays its invocation
 * by @param wait milliseconds. Optionally, a maxWait can be specified in @param options,
 * which ensures that the callback is invoked at least once after the specified max. wait time.
 *
 * @param func the function whose invocation is to be debounced
 * @param wait the minimum time until the function is invoked after it was called once
 * @param options the options object, which can contain the `maxWait` property
 *
 * @returns the debounced version of the function, which needs to be called at least once to start the
 *          debouncing process. Subsequent calls will reset the debouncing timer and, in case @paramfunc
 *          was already invoked in the meantime, return @param func's return value.
 *          The debounced function has two additional properties:
 *          - `flush`: Invokes the debounced function immediately and returns its return value
 *          - `cancel`: Cancels the debouncing process and resets the debouncing timer
 */ function $604631306887a81e$var$debounce(func, wait, options) {
    return (0, $b98d2b6f6f2e87bf$export$61fc7d43ac8f84b0)(func, wait, {
        ...options,
        // @ts-expect-error - Not quite sure why these types do not match, but this is fine
        setTimeoutImpl: (0, $a11db510f5040b04$export$831dc9f2ab0a617b)
    });
}
const $604631306887a81e$var$NAVIGATOR = (0, $736a69486c86d36c$export$f1a6cdb1459e81d1).navigator;
/**
 *  Disable sampling mousemove events on iOS browsers as this can cause blocking the main thread
 *  https://github.com/getsentry/sentry-javascript/issues/14534
 */ function $604631306887a81e$var$getRecordingSamplingOptions() {
    if (/iPhone|iPad|iPod/i.test($604631306887a81e$var$NAVIGATOR?.userAgent ?? '') || /Macintosh/i.test($604631306887a81e$var$NAVIGATOR?.userAgent ?? '') && $604631306887a81e$var$NAVIGATOR?.maxTouchPoints && $604631306887a81e$var$NAVIGATOR?.maxTouchPoints > 1) return {
        sampling: {
            mousemove: false
        }
    };
    return {};
}
/**
 * Handler for recording events.
 *
 * Adds to event buffer, and has varying flushing behaviors if the event was a checkout.
 */ function $604631306887a81e$var$getHandleRecordingEmit(replay) {
    let hadFirstEvent = false;
    return (event, _isCheckout)=>{
        // If this is false, it means session is expired, create and a new session and wait for checkout
        if (!replay.checkAndHandleExpiredSession()) {
            $604631306887a81e$var$DEBUG_BUILD && $604631306887a81e$var$debug.warn('Received replay event after session expired.');
            return;
        }
        // `_isCheckout` is only set when the checkout is due to `checkoutEveryNms`
        // We also want to treat the first event as a checkout, so we handle this specifically here
        const isCheckout = _isCheckout || !hadFirstEvent;
        hadFirstEvent = true;
        if (replay.clickDetector) $604631306887a81e$var$updateClickDetectorForRecordingEvent(replay.clickDetector, event);
        // The handler returns `true` if we do not want to trigger debounced flush, `false` if we want to debounce flush.
        replay.addUpdate(()=>{
            // The session is always started immediately on pageload/init, but for
            // error-only replays, it should reflect the most recent checkout
            // when an error occurs. Clear any state that happens before this current
            // checkout. This needs to happen before `addEvent()` which updates state
            // dependent on this reset.
            if (replay.recordingMode === 'buffer' && isCheckout) replay.setInitialState();
            // If the event is not added (e.g. due to being paused, disabled, or out of the max replay duration),
            // Skip all further steps
            if (!$604631306887a81e$var$addEventSync(replay, event, isCheckout)) // Return true to skip scheduling a debounced flush
            return true;
            // Different behavior for full snapshots (type=2), ignore other event types
            // See https://github.com/rrweb-io/rrweb/blob/d8f9290ca496712aa1e7d472549480c4e7876594/packages/rrweb/src/types.ts#L16
            if (!isCheckout) return false;
            const session = replay.session;
            // Additionally, create a meta event that will capture certain SDK settings.
            // In order to handle buffer mode, this needs to either be done when we
            // receive checkout events or at flush time. We have an experimental mode
            // to perform multiple checkouts a session (the idea is to improve
            // seeking during playback), so also only include if segmentId is 0
            // (handled in `addSettingsEvent`).
            //
            // `isCheckout` is always true, but want to be explicit that it should
            // only be added for checkouts
            $604631306887a81e$var$addSettingsEvent(replay, isCheckout);
            // When in buffer mode, make sure we adjust the session started date to the current earliest event of the buffer
            // this should usually be the timestamp of the checkout event, but to be safe...
            if (replay.recordingMode === 'buffer' && session && replay.eventBuffer && !session.dirty) {
                const earliestEvent = replay.eventBuffer.getEarliestTimestamp();
                if (earliestEvent) {
                    $604631306887a81e$var$DEBUG_BUILD && $604631306887a81e$var$debug.log(`Updating session start time to earliest event in buffer to ${new Date(earliestEvent)}`);
                    session.started = earliestEvent;
                    if (replay.getOptions().stickySession) $604631306887a81e$var$saveSession(session);
                }
            }
            // If there is a previousSessionId after a full snapshot occurs, then
            // the replay session was started due to session expiration. The new session
            // is started before triggering a new checkout and contains the id
            // of the previous session. Do not immediately flush in this case
            // to avoid capturing only the checkout and instead the replay will
            // be captured if they perform any follow-up actions.
            if (session?.previousSessionId) return true;
            if (replay.recordingMode === 'session') // If the full snapshot is due to an initial load, we will not have
            // a previous session ID. In this case, we want to buffer events
            // for a set amount of time before flushing. This can help avoid
            // capturing replays of users that immediately close the window.
            // This should never reject
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            replay.flush();
            return true;
        });
    };
}
/**
 * Exported for tests
 */ function $604631306887a81e$var$createOptionsEvent(replay) {
    const options = replay.getOptions();
    return {
        type: $604631306887a81e$var$EventType.Custom,
        timestamp: Date.now(),
        data: {
            tag: 'options',
            payload: {
                shouldRecordCanvas: replay.isRecordingCanvas(),
                sessionSampleRate: options.sessionSampleRate,
                errorSampleRate: options.errorSampleRate,
                useCompressionOption: options.useCompression,
                blockAllMedia: options.blockAllMedia,
                maskAllText: options.maskAllText,
                maskAllInputs: options.maskAllInputs,
                useCompression: replay.eventBuffer ? replay.eventBuffer.type === 'worker' : false,
                networkDetailHasUrls: options.networkDetailAllowUrls.length > 0,
                networkCaptureBodies: options.networkCaptureBodies,
                networkRequestHasHeaders: options.networkRequestHeaders.length > 0,
                networkResponseHasHeaders: options.networkResponseHeaders.length > 0
            }
        }
    };
}
/**
 * Add a "meta" event that contains a simplified view on current configuration
 * options. This should only be included on the first segment of a recording.
 */ function $604631306887a81e$var$addSettingsEvent(replay, isCheckout) {
    // Only need to add this event when sending the first segment
    if (!isCheckout || replay.session?.segmentId !== 0) return;
    $604631306887a81e$var$addEventSync(replay, $604631306887a81e$var$createOptionsEvent(replay), false);
}
/**
 * Vendored in from @sentry-internal/rrweb.
 *
 * This is a copy of the function from rrweb, it is not nicely exported there.
 */ function $604631306887a81e$var$closestElementOfNode(node) {
    if (!node) return null;
    // Catch access to node properties to avoid Firefox "permission denied" errors
    try {
        const el = node.nodeType === node.ELEMENT_NODE ? node : node.parentElement;
        return el;
    } catch  {
        return null;
    }
}
/**
 * Create a replay envelope ready to be sent.
 * This includes both the replay event, as well as the recording data.
 */ function $604631306887a81e$var$createReplayEnvelope(replayEvent, recordingData, dsn, tunnel) {
    return (0, $bb063ad93c8b79c7$export$f93f7f385160c44e)((0, $bb063ad93c8b79c7$export$92b6093782fe661b)(replayEvent, (0, $bb063ad93c8b79c7$export$d369f3b2758f6743)(replayEvent), tunnel, dsn), [
        [
            {
                type: 'replay_event'
            },
            replayEvent
        ],
        [
            {
                type: 'replay_recording',
                // If string then we need to encode to UTF8, otherwise will have
                // wrong size. TextEncoder has similar browser support to
                // MutationObserver, although it does not accept IE11.
                length: typeof recordingData === 'string' ? new TextEncoder().encode(recordingData).length : recordingData.length
            },
            recordingData
        ]
    ]);
}
/**
 * Prepare the recording data ready to be sent.
 */ function $604631306887a81e$var$prepareRecordingData({ recordingData: recordingData, headers: headers }) {
    let payloadWithSequence;
    // XXX: newline is needed to separate sequence id from events
    const replayHeaders = `${JSON.stringify(headers)}
`;
    if (typeof recordingData === 'string') payloadWithSequence = `${replayHeaders}${recordingData}`;
    else {
        const enc = new TextEncoder();
        // XXX: newline is needed to separate sequence id from events
        const sequence = enc.encode(replayHeaders);
        // Merge the two Uint8Arrays
        payloadWithSequence = new Uint8Array(sequence.length + recordingData.length);
        payloadWithSequence.set(sequence);
        payloadWithSequence.set(recordingData, sequence.length);
    }
    return payloadWithSequence;
}
/**
 * Prepare a replay event & enrich it with the SDK metadata.
 */ async function $604631306887a81e$var$prepareReplayEvent({ client: client, scope: scope, replayId: event_id, event: event }) {
    const integrations = typeof client['_integrations'] === 'object' && client['_integrations'] !== null && !Array.isArray(client['_integrations']) ? Object.keys(client['_integrations']) : undefined;
    const eventHint = {
        event_id: event_id,
        integrations: integrations
    };
    client.emit('preprocessEvent', event, eventHint);
    const preparedEvent = await (0, $e98f8a40c7329053$export$2d67fb380bd11267)(client.getOptions(), event, eventHint, scope, client, (0, $7d48e1ed9f699a01$export$68f3af03034c9e90)());
    // If e.g. a global event processor returned null
    if (!preparedEvent) return null;
    client.emit('postprocessEvent', preparedEvent, eventHint);
    // This normally happens in browser client "_prepareEvent"
    // but since we do not use this private method from the client, but rather the plain import
    // we need to do this manually.
    preparedEvent.platform = preparedEvent.platform || 'javascript';
    // extract the SDK name because `client._prepareEvent` doesn't add it to the event
    const metadata = client.getSdkMetadata();
    const { name: name, version: version, settings: settings } = metadata?.sdk || {};
    preparedEvent.sdk = {
        ...preparedEvent.sdk,
        name: name || 'sentry.javascript.unknown',
        version: version || '0.0.0',
        settings: settings
    };
    return preparedEvent;
}
/**
 * Send replay attachment using `fetch()`
 */ async function $604631306887a81e$var$sendReplayRequest({ recordingData: recordingData, replayId: replayId, segmentId: segment_id, eventContext: eventContext, timestamp: timestamp, session: session }) {
    const preparedRecordingData = $604631306887a81e$var$prepareRecordingData({
        recordingData: recordingData,
        headers: {
            segment_id: segment_id
        }
    });
    const { urls: urls, errorIds: errorIds, traceIds: traceIds, initialTimestamp: initialTimestamp } = eventContext;
    const client = (0, $7d48e1ed9f699a01$export$6bb76d6eba7e258c)();
    const scope = (0, $7d48e1ed9f699a01$export$c7be4b0125a10cba)();
    const transport = client?.getTransport();
    const dsn = client?.getDsn();
    if (!client || !transport || !dsn || !session.sampled) return Promise.resolve({});
    const baseEvent = {
        type: $604631306887a81e$var$REPLAY_EVENT_NAME,
        replay_start_timestamp: initialTimestamp / 1000,
        timestamp: timestamp / 1000,
        error_ids: errorIds,
        trace_ids: traceIds,
        urls: urls,
        replay_id: replayId,
        segment_id: segment_id,
        replay_type: session.sampled
    };
    const replayEvent = await $604631306887a81e$var$prepareReplayEvent({
        scope: scope,
        client: client,
        replayId: replayId,
        event: baseEvent
    });
    if (!replayEvent) {
        // Taken from baseclient's `_processEvent` method, where this is handled for errors/transactions
        client.recordDroppedEvent('event_processor', 'replay');
        $604631306887a81e$var$DEBUG_BUILD && $604631306887a81e$var$debug.log('An event processor returned `null`, will not send event.');
        return Promise.resolve({});
    }
    /*
  For reference, the fully built event looks something like this:
  {
      "type": "replay_event",
      "timestamp": 1670837008.634,
      "error_ids": [
          "errorId"
      ],
      "trace_ids": [
          "traceId"
      ],
      "urls": [
          "https://example.com"
      ],
      "replay_id": "eventId",
      "segment_id": 3,
      "replay_type": "error",
      "platform": "javascript",
      "event_id": "eventId",
      "environment": "production",
      "sdk": {
          "integrations": [
              "BrowserTracing",
              "Replay"
          ],
          "name": "sentry.javascript.browser",
          "version": "7.25.0"
      },
      "sdkProcessingMetadata": {},
      "contexts": {
      },
  }
  */ // Prevent this data (which, if it exists, was used in earlier steps in the processing pipeline) from being sent to
    // sentry. (Note: Our use of this property comes and goes with whatever we might be debugging, whatever hacks we may
    // have temporarily added, etc. Even if we don't happen to be using it at some point in the future, let's not get rid
    // of this `delete`, lest we miss putting it back in the next time the property is in use.)
    delete replayEvent.sdkProcessingMetadata;
    const envelope = $604631306887a81e$var$createReplayEnvelope(replayEvent, preparedRecordingData, dsn, client.getOptions().tunnel);
    let response;
    try {
        response = await transport.send(envelope);
    } catch (err) {
        const error = new Error($604631306887a81e$var$UNABLE_TO_SEND_REPLAY);
        try {
            // In case browsers don't allow this property to be writable
            // @ts-expect-error This needs lib es2022 and newer
            error.cause = err;
        } catch  {
        // nothing to do
        }
        throw error;
    }
    // Check for rate limiting first (handles 429 and rate limit headers)
    const rateLimits = (0, $33414f31f3554c40$export$699aff705e0d49d4)({}, response);
    if ((0, $33414f31f3554c40$export$6c91fec22056810a)(rateLimits, 'replay')) throw new $604631306887a81e$var$RateLimitError(rateLimits);
    // If the status code is invalid, we want to immediately stop & not retry
    if (typeof response.statusCode === 'number' && (response.statusCode < 200 || response.statusCode >= 300)) throw new $604631306887a81e$var$TransportStatusCodeError(response.statusCode);
    return response;
}
/**
 * This error indicates that the transport returned an invalid status code.
 */ class $604631306887a81e$var$TransportStatusCodeError extends Error {
    constructor(statusCode){
        super(`Transport returned status code ${statusCode}`);
    }
}
/**
 * This error indicates that we hit a rate limit API error.
 */ class $604631306887a81e$var$RateLimitError extends Error {
    constructor(rateLimits){
        super('Rate limit hit');
        this.rateLimits = rateLimits;
    }
}
/**
 * This error indicates that the replay duration limit was exceeded and the session is too long.
 *
 */ class $604631306887a81e$var$ReplayDurationLimitError extends Error {
    constructor(){
        super('Session is too long, not sending replay');
    }
}
/**
 * Finalize and send the current replay event to Sentry
 */ async function $604631306887a81e$var$sendReplay(replayData, retryConfig = {
    count: 0,
    interval: $604631306887a81e$var$RETRY_BASE_INTERVAL
}) {
    const { recordingData: recordingData, onError: onError } = replayData;
    // short circuit if there's no events to upload (this shouldn't happen as _runFlush makes this check)
    if (!recordingData.length) return;
    try {
        await $604631306887a81e$var$sendReplayRequest(replayData);
        return true;
    } catch (err) {
        if (err instanceof $604631306887a81e$var$TransportStatusCodeError || err instanceof $604631306887a81e$var$RateLimitError) throw err;
        // Capture error for every failed replay
        (0, $6918c722b531ff18$export$2f04de43fe27971a)('Replays', {
            _retryCount: retryConfig.count
        });
        if (onError) onError(err);
        // If an error happened here, it's likely that uploading the attachment
        // failed, we'll can retry with the same events payload
        if (retryConfig.count >= $604631306887a81e$var$RETRY_MAX_COUNT) {
            const error = new Error(`${$604631306887a81e$var$UNABLE_TO_SEND_REPLAY} - max retries exceeded`);
            try {
                // In case browsers don't allow this property to be writable
                // @ts-expect-error This needs lib es2022 and newer
                error.cause = err;
            } catch  {
            // nothing to do
            }
            throw error;
        }
        // will retry in intervals of 5, 10, 30
        retryConfig.interval *= ++retryConfig.count;
        return new Promise((resolve, reject)=>{
            (0, $a11db510f5040b04$export$831dc9f2ab0a617b)(async ()=>{
                try {
                    await $604631306887a81e$var$sendReplay(replayData, retryConfig);
                    resolve(true);
                } catch (err) {
                    reject(err);
                }
            }, retryConfig.interval);
        });
    }
}
const $604631306887a81e$var$THROTTLED = '__THROTTLED';
const $604631306887a81e$var$SKIPPED = '__SKIPPED';
/**
 * Create a throttled function off a given function.
 * When calling the throttled function, it will call the original function only
 * if it hasn't been called more than `maxCount` times in the last `durationSeconds`.
 *
 * Returns `THROTTLED` if throttled for the first time, after that `SKIPPED`,
 * or else the return value of the original function.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $604631306887a81e$var$throttle(fn, maxCount, durationSeconds) {
    const counter = new Map();
    const _cleanup = (now)=>{
        const threshold = now - durationSeconds;
        counter.forEach((_value, key)=>{
            if (key < threshold) counter.delete(key);
        });
    };
    const _getTotalCount = ()=>{
        return [
            ...counter.values()
        ].reduce((a, b)=>a + b, 0);
    };
    let isThrottled = false;
    return (...rest)=>{
        // Date in second-precision, which we use as basis for the throttling
        const now = Math.floor(Date.now() / 1000);
        // First, make sure to delete any old entries
        _cleanup(now);
        // If already over limit, do nothing
        if (_getTotalCount() >= maxCount) {
            const wasThrottled = isThrottled;
            isThrottled = true;
            return wasThrottled ? $604631306887a81e$var$SKIPPED : $604631306887a81e$var$THROTTLED;
        }
        isThrottled = false;
        const count = counter.get(now) || 0;
        counter.set(now, count + 1);
        return fn(...rest);
    };
}
/**
 * The main replay container class, which holds all the state and methods for recording and sending replays.
 */ class $604631306887a81e$var$ReplayContainer {
    /**
   * Recording can happen in one of two modes:
   *   - session: Record the whole session, sending it continuously
   *   - buffer: Always keep the last 60s of recording, requires:
   *     - having replaysOnErrorSampleRate > 0 to capture replay when an error occurs
   *     - or calling `flush()` to send the replay
   */ /**
   * The current or last active span.
   * This is only available when performance is enabled.
   */ /**
   * These are here so we can overwrite them in tests etc.
   * @hidden
   */ /** The replay has to be manually started, because no sample rate (neither session or error) was provided. */ /**
   * Options to pass to `rrweb.record()`
   */ /**
   * Timestamp of the last user activity. This lives across sessions.
   */ /**
   * Is the integration currently active?
   */ /**
   * Paused is a state where:
   * - DOM Recording is not listening at all
   * - Nothing will be added to event buffer (e.g. core SDK events)
   */ /**
   * Have we attached listeners to the core SDK?
   * Note we have to track this as there is no way to remove instrumentation handlers.
   */ /**
   * Function to stop recording
   */ /**
   * Internal use for canvas recording options
   */ /**
   * Handle when visibility of the page content changes. Opening a new tab will
   * cause the state to change to hidden because of content of current page will
   * be hidden. Likewise, moving a different window to cover the contents of the
   * page will also trigger a change to a hidden state.
   */ /**
   * Handle when page is blurred
   */ /**
   * Handle when page is focused
   */ /** Ensure page remains active when a key is pressed. */ constructor({ options: options, recordingOptions: recordingOptions }){
        this.eventBuffer = null;
        this.performanceEntries = [];
        this.replayPerformanceEntries = [];
        this.recordingMode = 'session';
        this.timeouts = {
            sessionIdlePause: $604631306887a81e$var$SESSION_IDLE_PAUSE_DURATION,
            sessionIdleExpire: $604631306887a81e$var$SESSION_IDLE_EXPIRE_DURATION
        };
        this._lastActivity = Date.now();
        this._isEnabled = false;
        this._isPaused = false;
        this._requiresManualStart = false;
        this._hasInitializedCoreListeners = false;
        this._context = {
            errorIds: new Set(),
            traceIds: new Set(),
            urls: [],
            initialTimestamp: Date.now(),
            initialUrl: ''
        };
        this._recordingOptions = recordingOptions;
        this._options = options;
        this._debouncedFlush = $604631306887a81e$var$debounce(()=>this._flush(), this._options.flushMinDelay, {
            maxWait: this._options.flushMaxDelay
        });
        this._throttledAddEvent = $604631306887a81e$var$throttle((event, isCheckout)=>$604631306887a81e$var$addEvent(this, event, isCheckout), // Max 300 events...
        300, // ... per 5s
        5);
        const { slowClickTimeout: slowClickTimeout, slowClickIgnoreSelectors: slowClickIgnoreSelectors } = this.getOptions();
        const slowClickConfig = slowClickTimeout ? {
            threshold: Math.min($604631306887a81e$var$SLOW_CLICK_THRESHOLD, slowClickTimeout),
            timeout: slowClickTimeout,
            scrollTimeout: $604631306887a81e$var$SLOW_CLICK_SCROLL_TIMEOUT,
            ignoreSelector: slowClickIgnoreSelectors ? slowClickIgnoreSelectors.join(',') : ''
        } : undefined;
        if (slowClickConfig) this.clickDetector = new $604631306887a81e$var$ClickDetector(this, slowClickConfig);
        // Configure replay debug logger w/ experimental options
        if ($604631306887a81e$var$DEBUG_BUILD) {
            const experiments = options._experiments;
            $604631306887a81e$var$debug.setConfig({
                captureExceptions: !!experiments.captureExceptions,
                traceInternals: !!experiments.traceInternals
            });
        }
        // We set these handler properties as class properties, to make binding/unbinding them easier
        this._handleVisibilityChange = ()=>{
            if ($604631306887a81e$var$WINDOW.document.visibilityState === 'visible') this._doChangeToForegroundTasks();
            else this._doChangeToBackgroundTasks();
        };
        /**
     * Handle when page is blurred
     */ this._handleWindowBlur = ()=>{
            const breadcrumb = $604631306887a81e$var$createBreadcrumb({
                category: 'ui.blur'
            });
            // Do not count blur as a user action -- it's part of the process of them
            // leaving the page
            this._doChangeToBackgroundTasks(breadcrumb);
        };
        this._handleWindowFocus = ()=>{
            const breadcrumb = $604631306887a81e$var$createBreadcrumb({
                category: 'ui.focus'
            });
            // Do not count focus as a user action -- instead wait until they focus and
            // interactive with page
            this._doChangeToForegroundTasks(breadcrumb);
        };
        /** Ensure page remains active when a key is pressed. */ this._handleKeyboardEvent = (event)=>{
            $604631306887a81e$var$handleKeyboardEvent(this, event);
        };
    }
    /** Get the event context. */ getContext() {
        return this._context;
    }
    /** If recording is currently enabled. */ isEnabled() {
        return this._isEnabled;
    }
    /** If recording is currently paused. */ isPaused() {
        return this._isPaused;
    }
    /**
   * Determine if canvas recording is enabled
   */ isRecordingCanvas() {
        return Boolean(this._canvas);
    }
    /** Get the replay integration options. */ getOptions() {
        return this._options;
    }
    /** A wrapper to conditionally capture exceptions. */ handleException(error) {
        $604631306887a81e$var$DEBUG_BUILD && $604631306887a81e$var$debug.exception(error);
        if (this._options.onError) this._options.onError(error);
    }
    /**
   * Initializes the plugin based on sampling configuration. Should not be
   * called outside of constructor.
   */ initializeSampling(previousSessionId) {
        const { errorSampleRate: errorSampleRate, sessionSampleRate: sessionSampleRate } = this._options;
        // If neither sample rate is > 0, then do nothing - user will need to call one of
        // `start()` or `startBuffering` themselves.
        const requiresManualStart = errorSampleRate <= 0 && sessionSampleRate <= 0;
        this._requiresManualStart = requiresManualStart;
        if (requiresManualStart) return;
        // Otherwise if there is _any_ sample rate set, try to load an existing
        // session, or create a new one.
        this._initializeSessionForSampling(previousSessionId);
        if (!this.session) {
            // This should not happen, something wrong has occurred
            $604631306887a81e$var$DEBUG_BUILD && $604631306887a81e$var$debug.exception(new Error('Unable to initialize and create session'));
            return;
        }
        if (this.session.sampled === false) // This should only occur if `errorSampleRate` is 0 and was unsampled for
        // session-based replay. In this case there is nothing to do.
        return;
        // If segmentId > 0, it means we've previously already captured this session
        // In this case, we still want to continue in `session` recording mode
        this.recordingMode = this.session.sampled === 'buffer' && this.session.segmentId === 0 ? 'buffer' : 'session';
        $604631306887a81e$var$DEBUG_BUILD && $604631306887a81e$var$debug.infoTick(`Starting replay in ${this.recordingMode} mode`);
        this._initializeRecording();
    }
    /**
   * Start a replay regardless of sampling rate. Calling this will always
   * create a new session. Will log a message if replay is already in progress.
   *
   * Creates or loads a session, attaches listeners to varying events (DOM,
   * _performanceObserver, Recording, Sentry SDK, etc)
   */ start() {
        if (this._isEnabled && this.recordingMode === 'session') {
            $604631306887a81e$var$DEBUG_BUILD && $604631306887a81e$var$debug.log('Recording is already in progress');
            return;
        }
        if (this._isEnabled && this.recordingMode === 'buffer') {
            $604631306887a81e$var$DEBUG_BUILD && $604631306887a81e$var$debug.log('Buffering is in progress, call `flush()` to save the replay');
            return;
        }
        $604631306887a81e$var$DEBUG_BUILD && $604631306887a81e$var$debug.infoTick('Starting replay in session mode');
        // Required as user activity is initially set in
        // constructor, so if `start()` is called after
        // session idle expiration, a replay will not be
        // created due to an idle timeout.
        this._updateUserActivity();
        const session = $604631306887a81e$var$loadOrCreateSession({
            maxReplayDuration: this._options.maxReplayDuration,
            sessionIdleExpire: this.timeouts.sessionIdleExpire
        }, {
            stickySession: this._options.stickySession,
            // This is intentional: create a new session-based replay when calling `start()`
            sessionSampleRate: 1,
            allowBuffering: false
        });
        this.session = session;
        this.recordingMode = 'session';
        this._initializeRecording();
    }
    /**
   * Start replay buffering. Buffers until `flush()` is called or, if
   * `replaysOnErrorSampleRate` > 0, an error occurs.
   */ startBuffering() {
        if (this._isEnabled) {
            $604631306887a81e$var$DEBUG_BUILD && $604631306887a81e$var$debug.log('Buffering is in progress, call `flush()` to save the replay');
            return;
        }
        $604631306887a81e$var$DEBUG_BUILD && $604631306887a81e$var$debug.infoTick('Starting replay in buffer mode');
        const session = $604631306887a81e$var$loadOrCreateSession({
            sessionIdleExpire: this.timeouts.sessionIdleExpire,
            maxReplayDuration: this._options.maxReplayDuration
        }, {
            stickySession: this._options.stickySession,
            sessionSampleRate: 0,
            allowBuffering: true
        });
        this.session = session;
        this.recordingMode = 'buffer';
        this._initializeRecording();
    }
    /**
   * Start recording.
   *
   * Note that this will cause a new DOM checkout
   */ startRecording() {
        try {
            const canvasOptions = this._canvas;
            this._stopRecording = $604631306887a81e$var$record({
                ...this._recordingOptions,
                // When running in error sampling mode, we need to overwrite `checkoutEveryNms`
                // Without this, it would record forever, until an error happens, which we don't want
                // instead, we'll always keep the last 60 seconds of replay before an error happened
                ...this.recordingMode === 'buffer' ? {
                    checkoutEveryNms: $604631306887a81e$var$BUFFER_CHECKOUT_TIME
                } : // This is to improve playback seeking as there could potentially be
                // less mutations to process in the worse cases.
                //
                // checkout by "N" events is probably ideal, but means we have less
                // control about the number of checkouts we make (which generally
                // increases replay size)
                this._options._experiments.continuousCheckout && {
                    // Minimum checkout time is 6 minutes
                    checkoutEveryNms: Math.max(360000, this._options._experiments.continuousCheckout)
                },
                emit: $604631306887a81e$var$getHandleRecordingEmit(this),
                ...$604631306887a81e$var$getRecordingSamplingOptions(),
                onMutation: this._onMutationHandler.bind(this),
                ...canvasOptions ? {
                    recordCanvas: canvasOptions.recordCanvas,
                    getCanvasManager: canvasOptions.getCanvasManager,
                    sampling: canvasOptions.sampling,
                    dataURLOptions: canvasOptions.dataURLOptions
                } : {}
            });
        } catch (err) {
            this.handleException(err);
        }
    }
    /**
   * Stops the recording, if it was running.
   *
   * Returns true if it was previously stopped, or is now stopped,
   * otherwise false.
   */ stopRecording() {
        try {
            if (this._stopRecording) {
                this._stopRecording();
                this._stopRecording = undefined;
            }
            return true;
        } catch (err) {
            this.handleException(err);
            return false;
        }
    }
    /**
   * Currently, this needs to be manually called (e.g. for tests). Sentry SDK
   * does not support a teardown
   */ async stop({ forceFlush: forceFlush = false, reason: reason } = {}) {
        if (!this._isEnabled) return;
        // We can't move `_isEnabled` after awaiting a flush, otherwise we can
        // enter into an infinite loop when `stop()` is called while flushing.
        this._isEnabled = false;
        // Make sure to reset `recordingMode` to `buffer` to avoid any additional
        // breadcrumbs to trigger a flush (e.g. in `addUpdate()`)
        this.recordingMode = 'buffer';
        try {
            $604631306887a81e$var$DEBUG_BUILD && $604631306887a81e$var$debug.log(`Stopping Replay${reason ? ` triggered by ${reason}` : ''}`);
            $604631306887a81e$var$resetReplayIdOnDynamicSamplingContext();
            this._removeListeners();
            this.stopRecording();
            this._debouncedFlush.cancel();
            // See comment above re: `_isEnabled`, we "force" a flush, ignoring the
            // `_isEnabled` state of the plugin since it was disabled above.
            if (forceFlush) await this._flush({
                force: true
            });
            // After flush, destroy event buffer
            this.eventBuffer?.destroy();
            this.eventBuffer = null;
            // Clear session from session storage, note this means if a new session
            // is started after, it will not have `previousSessionId`
            $604631306887a81e$var$clearSession(this);
        } catch (err) {
            this.handleException(err);
        }
    }
    /**
   * Pause some replay functionality. See comments for `_isPaused`.
   * This differs from stop as this only stops DOM recording, it is
   * not as thorough of a shutdown as `stop()`.
   */ pause() {
        if (this._isPaused) return;
        this._isPaused = true;
        this.stopRecording();
        $604631306887a81e$var$DEBUG_BUILD && $604631306887a81e$var$debug.log('Pausing replay');
    }
    /**
   * Resumes recording, see notes for `pause().
   *
   * Note that calling `startRecording()` here will cause a
   * new DOM checkout.`
   */ resume() {
        if (!this._isPaused || !this._checkSession()) return;
        this._isPaused = false;
        this.startRecording();
        $604631306887a81e$var$DEBUG_BUILD && $604631306887a81e$var$debug.log('Resuming replay');
    }
    /**
   * If not in "session" recording mode, flush event buffer which will create a new replay.
   * Unless `continueRecording` is false, the replay will continue to record and
   * behave as a "session"-based replay.
   *
   * Otherwise, queue up a flush.
   */ async sendBufferedReplayOrFlush({ continueRecording: continueRecording = true } = {}) {
        if (this.recordingMode === 'session') return this.flushImmediate();
        const activityTime = Date.now();
        $604631306887a81e$var$DEBUG_BUILD && $604631306887a81e$var$debug.log('Converting buffer to session');
        // Allow flush to complete before resuming as a session recording, otherwise
        // the checkout from `startRecording` may be included in the payload.
        // Prefer to keep the error replay as a separate (and smaller) segment
        // than the session replay.
        await this.flushImmediate();
        const hasStoppedRecording = this.stopRecording();
        if (!continueRecording || !hasStoppedRecording) return;
        // To avoid race conditions where this is called multiple times, we check here again that we are still buffering
        if (this.recordingMode === 'session') return;
        // Re-start recording in session-mode
        this.recordingMode = 'session';
        // Once this session ends, we do not want to refresh it
        if (this.session) {
            this.session.dirty = false;
            this._updateUserActivity(activityTime);
            this._updateSessionActivity(activityTime);
            this._maybeSaveSession();
        }
        this.startRecording();
    }
    /**
   * We want to batch uploads of replay events. Save events only if
   * `<flushMinDelay>` milliseconds have elapsed since the last event
   * *OR* if `<flushMaxDelay>` milliseconds have elapsed.
   *
   * Accepts a callback to perform side-effects and returns true to stop batch
   * processing and hand back control to caller.
   */ addUpdate(cb) {
        // We need to always run `cb` (e.g. in the case of `this.recordingMode == 'buffer'`)
        const cbResult = cb();
        // If this option is turned on then we will only want to call `flush`
        // explicitly
        if (this.recordingMode === 'buffer' || !this._isEnabled) return;
        // If callback is true, we do not want to continue with flushing -- the
        // caller will need to handle it.
        if (cbResult === true) return;
        // addUpdate is called quite frequently - use _debouncedFlush so that it
        // respects the flush delays and does not flush immediately
        this._debouncedFlush();
    }
    /**
   * Updates the user activity timestamp and resumes recording. This should be
   * called in an event handler for a user action that we consider as the user
   * being "active" (e.g. a mouse click).
   */ triggerUserActivity() {
        this._updateUserActivity();
        // This case means that recording was once stopped due to inactivity.
        // Ensure that recording is resumed.
        if (!this._stopRecording) {
            // Create a new session, otherwise when the user action is flushed, it
            // will get rejected due to an expired session.
            if (!this._checkSession()) return;
            // Note: This will cause a new DOM checkout
            this.resume();
            return;
        }
        // Otherwise... recording was never suspended, continue as normalish
        this.checkAndHandleExpiredSession();
        this._updateSessionActivity();
    }
    /**
   * Updates the user activity timestamp *without* resuming
   * recording. Some user events (e.g. keydown) can be create
   * low-value replays that only contain the keypress as a
   * breadcrumb. Instead this would require other events to
   * create a new replay after a session has expired.
   */ updateUserActivity() {
        this._updateUserActivity();
        this._updateSessionActivity();
    }
    /**
   * Only flush if `this.recordingMode === 'session'`
   */ conditionalFlush() {
        if (this.recordingMode === 'buffer') return Promise.resolve();
        return this.flushImmediate();
    }
    /**
   * Flush using debounce flush
   */ flush() {
        return this._debouncedFlush();
    }
    /**
   * Always flush via `_debouncedFlush` so that we do not have flushes triggered
   * from calling both `flush` and `_debouncedFlush`. Otherwise, there could be
   * cases of multiple flushes happening closely together.
   */ flushImmediate() {
        this._debouncedFlush();
        // `.flush` is provided by the debounced function, analogously to lodash.debounce
        return this._debouncedFlush.flush();
    }
    /**
   * Cancels queued up flushes.
   */ cancelFlush() {
        this._debouncedFlush.cancel();
    }
    /** Get the current session (=replay) ID
   *
   * @param onlyIfSampled - If true, will only return the session ID if the session is sampled.
   */ getSessionId(onlyIfSampled) {
        if (onlyIfSampled && this.session?.sampled === false) return undefined;
        return this.session?.id;
    }
    /**
   * Checks if recording should be stopped due to user inactivity. Otherwise
   * check if session is expired and create a new session if so. Triggers a new
   * full snapshot on new session.
   *
   * Returns true if session is not expired, false otherwise.
   * @hidden
   */ checkAndHandleExpiredSession() {
        // Prevent starting a new session if the last user activity is older than
        // SESSION_IDLE_PAUSE_DURATION. Otherwise non-user activity can trigger a new
        // session+recording. This creates noisy replays that do not have much
        // content in them.
        if (this._lastActivity && $604631306887a81e$var$isExpired(this._lastActivity, this.timeouts.sessionIdlePause) && this.session?.sampled === 'session') {
            // Pause recording only for session-based replays. Otherwise, resuming
            // will create a new replay and will conflict with users who only choose
            // to record error-based replays only. (e.g. the resumed replay will not
            // contain a reference to an error)
            this.pause();
            return;
        }
        // --- There is recent user activity --- //
        // This will create a new session if expired, based on expiry length
        if (!this._checkSession()) // Check session handles the refreshing itself
        return false;
        return true;
    }
    /**
   * Capture some initial state that can change throughout the lifespan of the
   * replay. This is required because otherwise they would be captured at the
   * first flush.
   */ setInitialState() {
        const urlPath = `${$604631306887a81e$var$WINDOW.location.pathname}${$604631306887a81e$var$WINDOW.location.hash}${$604631306887a81e$var$WINDOW.location.search}`;
        const url = `${$604631306887a81e$var$WINDOW.location.origin}${urlPath}`;
        this.performanceEntries = [];
        this.replayPerformanceEntries = [];
        // Reset _context as well
        this._clearContext();
        this._context.initialUrl = url;
        this._context.initialTimestamp = Date.now();
        this._context.urls.push(url);
    }
    /**
   * Add a breadcrumb event, that may be throttled.
   * If it was throttled, we add a custom breadcrumb to indicate that.
   */ throttledAddEvent(event, isCheckout) {
        const res = this._throttledAddEvent(event, isCheckout);
        // If this is THROTTLED, it means we have throttled the event for the first time
        // In this case, we want to add a breadcrumb indicating that something was skipped
        if (res === $604631306887a81e$var$THROTTLED) {
            const breadcrumb = $604631306887a81e$var$createBreadcrumb({
                category: 'replay.throttled'
            });
            this.addUpdate(()=>{
                // Return `false` if the event _was_ added, as that means we schedule a flush
                return !$604631306887a81e$var$addEventSync(this, {
                    type: $604631306887a81e$var$ReplayEventTypeCustom,
                    timestamp: breadcrumb.timestamp || 0,
                    data: {
                        tag: 'breadcrumb',
                        payload: breadcrumb,
                        metric: true
                    }
                });
            });
        }
        return res;
    }
    /**
   * This will get the parametrized route name of the current page.
   * This is only available if performance is enabled, and if an instrumented router is used.
   */ getCurrentRoute() {
        const lastActiveSpan = this.lastActiveSpan || (0, $bb9b6447bf4caedb$export$1be426a8e585c83e)();
        const lastRootSpan = lastActiveSpan && (0, $bb9b6447bf4caedb$export$c4c6a79b1260ca1b)(lastActiveSpan);
        const attributes = lastRootSpan && (0, $bb9b6447bf4caedb$export$92d8c23565496537)(lastRootSpan).data || {};
        const source = attributes[0, $f337c80285f06f80$export$d7a7d984b0791405];
        if (!lastRootSpan || !source || ![
            'route',
            'custom'
        ].includes(source)) return undefined;
        return (0, $bb9b6447bf4caedb$export$92d8c23565496537)(lastRootSpan).description;
    }
    /**
   * Initialize and start all listeners to varying events (DOM,
   * Performance Observer, Recording, Sentry SDK, etc)
   */ _initializeRecording() {
        this.setInitialState();
        // this method is generally called on page load or manually - in both cases
        // we should treat it as an activity
        this._updateSessionActivity();
        this.eventBuffer = $604631306887a81e$var$createEventBuffer({
            useCompression: this._options.useCompression,
            workerUrl: this._options.workerUrl
        });
        this._removeListeners();
        this._addListeners();
        // Need to set as enabled before we start recording, as `record()` can trigger a flush with a new checkout
        this._isEnabled = true;
        this._isPaused = false;
        this.startRecording();
    }
    /**
   * Loads (or refreshes) the current session.
   */ _initializeSessionForSampling(previousSessionId) {
        // Whenever there is _any_ error sample rate, we always allow buffering
        // Because we decide on sampling when an error occurs, we need to buffer at all times if sampling for errors
        const allowBuffering = this._options.errorSampleRate > 0;
        const session = $604631306887a81e$var$loadOrCreateSession({
            sessionIdleExpire: this.timeouts.sessionIdleExpire,
            maxReplayDuration: this._options.maxReplayDuration,
            previousSessionId: previousSessionId
        }, {
            stickySession: this._options.stickySession,
            sessionSampleRate: this._options.sessionSampleRate,
            allowBuffering: allowBuffering
        });
        this.session = session;
    }
    /**
   * Checks and potentially refreshes the current session.
   * Returns false if session is not recorded.
   */ _checkSession() {
        // If there is no session yet, we do not want to refresh anything
        // This should generally not happen, but to be safe....
        if (!this.session) return false;
        const currentSession = this.session;
        if ($604631306887a81e$var$shouldRefreshSession(currentSession, {
            sessionIdleExpire: this.timeouts.sessionIdleExpire,
            maxReplayDuration: this._options.maxReplayDuration
        })) {
            // This should never reject
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            this._refreshSession(currentSession);
            return false;
        }
        return true;
    }
    /**
   * Refresh a session with a new one.
   * This stops the current session (without forcing a flush, as that would never work since we are expired),
   * and then does a new sampling based on the refreshed session.
   */ async _refreshSession(session) {
        if (!this._isEnabled) return;
        await this.stop({
            reason: 'refresh session'
        });
        this.initializeSampling(session.id);
    }
    /**
   * Adds listeners to record events for the replay
   */ _addListeners() {
        try {
            $604631306887a81e$var$WINDOW.document.addEventListener('visibilitychange', this._handleVisibilityChange);
            $604631306887a81e$var$WINDOW.addEventListener('blur', this._handleWindowBlur);
            $604631306887a81e$var$WINDOW.addEventListener('focus', this._handleWindowFocus);
            $604631306887a81e$var$WINDOW.addEventListener('keydown', this._handleKeyboardEvent);
            if (this.clickDetector) this.clickDetector.addListeners();
            // There is no way to remove these listeners, so ensure they are only added once
            if (!this._hasInitializedCoreListeners) {
                $604631306887a81e$var$addGlobalListeners(this);
                this._hasInitializedCoreListeners = true;
            }
        } catch (err) {
            this.handleException(err);
        }
        this._performanceCleanupCallback = $604631306887a81e$var$setupPerformanceObserver(this);
    }
    /**
   * Cleans up listeners that were created in `_addListeners`
   */ _removeListeners() {
        try {
            $604631306887a81e$var$WINDOW.document.removeEventListener('visibilitychange', this._handleVisibilityChange);
            $604631306887a81e$var$WINDOW.removeEventListener('blur', this._handleWindowBlur);
            $604631306887a81e$var$WINDOW.removeEventListener('focus', this._handleWindowFocus);
            $604631306887a81e$var$WINDOW.removeEventListener('keydown', this._handleKeyboardEvent);
            if (this.clickDetector) this.clickDetector.removeListeners();
            if (this._performanceCleanupCallback) this._performanceCleanupCallback();
        } catch (err) {
            this.handleException(err);
        }
    }
    /**
   * Tasks to run when we consider a page to be hidden (via blurring and/or visibility)
   */ _doChangeToBackgroundTasks(breadcrumb) {
        if (!this.session) return;
        const expired = $604631306887a81e$var$isSessionExpired(this.session, {
            maxReplayDuration: this._options.maxReplayDuration,
            sessionIdleExpire: this.timeouts.sessionIdleExpire
        });
        if (expired) return;
        if (breadcrumb) this._createCustomBreadcrumb(breadcrumb);
        // Send replay when the page/tab becomes hidden. There is no reason to send
        // replay if it becomes visible, since no actions we care about were done
        // while it was hidden
        // This should never reject
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.conditionalFlush();
    }
    /**
   * Tasks to run when we consider a page to be visible (via focus and/or visibility)
   */ _doChangeToForegroundTasks(breadcrumb) {
        if (!this.session) return;
        const isSessionActive = this.checkAndHandleExpiredSession();
        if (!isSessionActive) {
            // If the user has come back to the page within SESSION_IDLE_PAUSE_DURATION
            // ms, we will re-use the existing session, otherwise create a new
            // session
            $604631306887a81e$var$DEBUG_BUILD && $604631306887a81e$var$debug.log('Document has become active, but session has expired');
            return;
        }
        if (breadcrumb) this._createCustomBreadcrumb(breadcrumb);
    }
    /**
   * Update user activity (across session lifespans)
   */ _updateUserActivity(_lastActivity = Date.now()) {
        this._lastActivity = _lastActivity;
    }
    /**
   * Updates the session's last activity timestamp
   */ _updateSessionActivity(_lastActivity = Date.now()) {
        if (this.session) {
            this.session.lastActivity = _lastActivity;
            this._maybeSaveSession();
        }
    }
    /**
   * Helper to create (and buffer) a replay breadcrumb from a core SDK breadcrumb
   */ _createCustomBreadcrumb(breadcrumb) {
        this.addUpdate(()=>{
            // This should never reject
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            this.throttledAddEvent({
                type: $604631306887a81e$var$EventType.Custom,
                timestamp: breadcrumb.timestamp || 0,
                data: {
                    tag: 'breadcrumb',
                    payload: breadcrumb
                }
            });
        });
    }
    /**
   * Observed performance events are added to `this.performanceEntries`. These
   * are included in the replay event before it is finished and sent to Sentry.
   */ _addPerformanceEntries() {
        let performanceEntries = $604631306887a81e$var$createPerformanceEntries(this.performanceEntries).concat(this.replayPerformanceEntries);
        this.performanceEntries = [];
        this.replayPerformanceEntries = [];
        // If we are manually starting, we want to ensure we only include performance entries
        // that are after the initial timestamp
        // The reason for this is that we may have performance entries from the page load, but may decide to start
        // the replay later on, in which case we do not want to include these entries.
        // without this, manually started replays can have events long before the actual replay recording starts,
        // which messes with the timeline etc.
        if (this._requiresManualStart) {
            const initialTimestampInSeconds = this._context.initialTimestamp / 1000;
            performanceEntries = performanceEntries.filter((entry)=>entry.start >= initialTimestampInSeconds);
        }
        return Promise.all($604631306887a81e$var$createPerformanceSpans(this, performanceEntries));
    }
    /**
   * Clear _context
   */ _clearContext() {
        // XXX: `initialTimestamp` and `initialUrl` do not get cleared
        this._context.errorIds.clear();
        this._context.traceIds.clear();
        this._context.urls = [];
    }
    /** Update the initial timestamp based on the buffer content. */ _updateInitialTimestampFromEventBuffer() {
        const { session: session, eventBuffer: eventBuffer } = this;
        // If replay was started manually (=no sample rate was given),
        // We do not want to back-port the initial timestamp
        if (!session || !eventBuffer || this._requiresManualStart) return;
        // we only ever update this on the initial segment
        if (session.segmentId) return;
        const earliestEvent = eventBuffer.getEarliestTimestamp();
        if (earliestEvent && earliestEvent < this._context.initialTimestamp) this._context.initialTimestamp = earliestEvent;
    }
    /**
   * Return and clear _context
   */ _popEventContext() {
        const _context = {
            initialTimestamp: this._context.initialTimestamp,
            initialUrl: this._context.initialUrl,
            errorIds: Array.from(this._context.errorIds),
            traceIds: Array.from(this._context.traceIds),
            urls: this._context.urls
        };
        this._clearContext();
        return _context;
    }
    /**
   * Flushes replay event buffer to Sentry.
   *
   * Performance events are only added right before flushing - this is
   * due to the buffered performance observer events.
   *
   * Should never be called directly, only by `flush`
   */ async _runFlush() {
        const replayId = this.getSessionId();
        if (!this.session || !this.eventBuffer || !replayId) {
            $604631306887a81e$var$DEBUG_BUILD && $604631306887a81e$var$debug.error('No session or eventBuffer found to flush.');
            return;
        }
        await this._addPerformanceEntries();
        // Check eventBuffer again, as it could have been stopped in the meanwhile
        if (!this.eventBuffer?.hasEvents) return;
        // Only attach memory event if eventBuffer is not empty
        await $604631306887a81e$var$addMemoryEntry(this);
        // Check eventBuffer again, as it could have been stopped in the meanwhile
        if (!this.eventBuffer) return;
        // if this changed in the meanwhile, e.g. because the session was refreshed or similar, we abort here
        if (replayId !== this.getSessionId()) return;
        try {
            // This uses the data from the eventBuffer, so we need to call this before `finish()
            this._updateInitialTimestampFromEventBuffer();
            const timestamp = Date.now();
            // Check total duration again, to avoid sending outdated stuff
            // We leave 30s wiggle room to accommodate late flushing etc.
            // This _could_ happen when the browser is suspended during flushing, in which case we just want to stop
            if (timestamp - this._context.initialTimestamp > this._options.maxReplayDuration + 30000) throw new $604631306887a81e$var$ReplayDurationLimitError();
            const eventContext = this._popEventContext();
            // Always increment segmentId regardless of outcome of sending replay
            const segmentId = this.session.segmentId++;
            this._maybeSaveSession();
            // Note this empties the event buffer regardless of outcome of sending replay
            const recordingData = await this.eventBuffer.finish();
            await $604631306887a81e$var$sendReplay({
                replayId: replayId,
                recordingData: recordingData,
                segmentId: segmentId,
                eventContext: eventContext,
                session: this.session,
                timestamp: timestamp,
                onError: (err)=>this.handleException(err)
            });
        } catch (err) {
            this.handleException(err);
            // This means we retried 3 times and all of them failed,
            // or we ran into a problem we don't want to retry, like rate limiting.
            // In this case, we want to completely stop the replay - otherwise, we may get inconsistent segments
            // This should never reject
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            this.stop({
                reason: 'sendReplay'
            });
            const client = (0, $7d48e1ed9f699a01$export$6bb76d6eba7e258c)();
            if (client) {
                let dropReason;
                if (err instanceof $604631306887a81e$var$RateLimitError) dropReason = 'ratelimit_backoff';
                else if (err instanceof $604631306887a81e$var$ReplayDurationLimitError) dropReason = 'invalid';
                else dropReason = 'send_error';
                client.recordDroppedEvent(dropReason, 'replay');
            }
        }
    }
    /**
   * Flush recording data to Sentry. Creates a lock so that only a single flush
   * can be active at a time. Do not call this directly.
   */ async _flush({ force: force = false } = {}) {
        if (!this._isEnabled && !force) // This can happen if e.g. the replay was stopped because of exceeding the retry limit
        return;
        if (!this.checkAndHandleExpiredSession()) {
            $604631306887a81e$var$DEBUG_BUILD && $604631306887a81e$var$debug.error('Attempting to finish replay event after session expired.');
            return;
        }
        if (!this.session) // should never happen, as we would have bailed out before
        return;
        const start = this.session.started;
        const now = Date.now();
        const duration = now - start;
        // A flush is about to happen, cancel any queued flushes
        this._debouncedFlush.cancel();
        // If session is too short, or too long (allow some wiggle room over maxReplayDuration), do not send it
        // This _should_ not happen, but it may happen if flush is triggered due to a page activity change or similar
        const tooShort = duration < this._options.minReplayDuration;
        const tooLong = duration > this._options.maxReplayDuration + 5000;
        if (tooShort || tooLong) {
            $604631306887a81e$var$DEBUG_BUILD && $604631306887a81e$var$debug.log(`Session duration (${Math.floor(duration / 1000)}s) is too ${tooShort ? 'short' : 'long'}, not sending replay.`);
            if (tooShort) this._debouncedFlush();
            return;
        }
        const eventBuffer = this.eventBuffer;
        if (eventBuffer && this.session.segmentId === 0 && !eventBuffer.hasCheckout) $604631306887a81e$var$DEBUG_BUILD && $604631306887a81e$var$debug.log('Flushing initial segment without checkout.');
        const _flushInProgress = !!this._flushLock;
        // this._flushLock acts as a lock so that future calls to `_flush()` will
        // be blocked until current flush is finished (i.e. this promise resolves)
        if (!this._flushLock) this._flushLock = this._runFlush();
        try {
            await this._flushLock;
        } catch (err) {
            this.handleException(err);
        } finally{
            this._flushLock = undefined;
            if (_flushInProgress) // Wait for previous flush to finish, then call the debounced
            // `_flush()`. It's possible there are other flush requests queued and
            // waiting for it to resolve. We want to reduce all outstanding
            // requests (as well as any new flush requests that occur within a
            // second of the locked flush completing) into a single flush.
            this._debouncedFlush();
        }
    }
    /** Save the session, if it is sticky */ _maybeSaveSession() {
        if (this.session && this._options.stickySession) $604631306887a81e$var$saveSession(this.session);
    }
    /** Handler for rrweb.record.onMutation */ _onMutationHandler(mutations) {
        const { ignoreMutations: ignoreMutations } = this._options._experiments;
        if (ignoreMutations?.length) {
            if (mutations.some((mutation)=>{
                const el = $604631306887a81e$var$closestElementOfNode(mutation.target);
                const selector = ignoreMutations.join(',');
                return el?.matches(selector);
            })) return false;
        }
        const count = mutations.length;
        const mutationLimit = this._options.mutationLimit;
        const mutationBreadcrumbLimit = this._options.mutationBreadcrumbLimit;
        const overMutationLimit = mutationLimit && count > mutationLimit;
        // Create a breadcrumb if a lot of mutations happen at the same time
        // We can show this in the UI as an information with potential performance improvements
        if (count > mutationBreadcrumbLimit || overMutationLimit) {
            const breadcrumb = $604631306887a81e$var$createBreadcrumb({
                category: 'replay.mutations',
                data: {
                    count: count,
                    limit: overMutationLimit
                }
            });
            this._createCustomBreadcrumb(breadcrumb);
        }
        // Stop replay if over the mutation limit
        if (overMutationLimit) {
            // This should never reject
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            this.stop({
                reason: 'mutationLimit',
                forceFlush: this.recordingMode === 'session'
            });
            return false;
        }
        // `true` means we use the regular mutation handling by rrweb
        return true;
    }
}
function $604631306887a81e$var$getOption(selectors, defaultSelectors) {
    return [
        ...selectors,
        // sentry defaults
        ...defaultSelectors
    ].join(',');
}
/**
 * Returns privacy related configuration for use in rrweb
 */ function $604631306887a81e$var$getPrivacyOptions({ mask: mask, unmask: unmask, block: block, unblock: unblock, ignore: ignore }) {
    const defaultBlockedElements = [
        'base',
        'iframe[srcdoc]:not([src])'
    ];
    const maskSelector = $604631306887a81e$var$getOption(mask, [
        '.sentry-mask',
        '[data-sentry-mask]'
    ]);
    const unmaskSelector = $604631306887a81e$var$getOption(unmask, []);
    const options = {
        // We are making the decision to make text and input selectors the same
        maskTextSelector: maskSelector,
        unmaskTextSelector: unmaskSelector,
        blockSelector: $604631306887a81e$var$getOption(block, [
            '.sentry-block',
            '[data-sentry-block]',
            ...defaultBlockedElements
        ]),
        unblockSelector: $604631306887a81e$var$getOption(unblock, []),
        ignoreSelector: $604631306887a81e$var$getOption(ignore, [
            '.sentry-ignore',
            '[data-sentry-ignore]',
            'input[type="file"]'
        ])
    };
    return options;
}
/**
 * Masks an attribute if necessary, otherwise return attribute value as-is.
 */ function $604631306887a81e$var$maskAttribute({ el: el, key: key, maskAttributes: maskAttributes, maskAllText: maskAllText, privacyOptions: privacyOptions, value: value }) {
    // We only mask attributes if `maskAllText` is true
    if (!maskAllText) return value;
    // unmaskTextSelector takes precedence
    if (privacyOptions.unmaskTextSelector && el.matches(privacyOptions.unmaskTextSelector)) return value;
    if (maskAttributes.includes(key) || // Need to mask `value` attribute for `<input>` if it's a button-like
    // type
    key === 'value' && el.tagName === 'INPUT' && [
        'submit',
        'button'
    ].includes(el.getAttribute('type') || '')) return value.replace(/[\S]/g, '*');
    return value;
}
const $604631306887a81e$var$MEDIA_SELECTORS = 'img,image,svg,video,object,picture,embed,map,audio,link[rel="icon"],link[rel="apple-touch-icon"]';
const $604631306887a81e$var$DEFAULT_NETWORK_HEADERS = [
    'content-length',
    'content-type',
    'accept'
];
// Symbol to store the original body on Request objects
const $604631306887a81e$var$ORIGINAL_BODY = Symbol.for('sentry__originalRequestBody');
let $604631306887a81e$var$_initialized = false;
let $604631306887a81e$var$_isRequestInstrumented = false;
/**
 * Instruments the global Request constructor to store the original body.
 * This allows us to retrieve the original body value later, since Request
 * converts string bodies to ReadableStreams.
 */ function $604631306887a81e$var$_INTERNAL_instrumentRequestInterface() {
    if (typeof Request === 'undefined' || $604631306887a81e$var$_isRequestInstrumented) return;
    const OriginalRequest = Request;
    try {
        const SentryRequest = function(input, init) {
            const request = new OriginalRequest(input, init);
            if (init?.body != null) // eslint-disable-next-line @typescript-eslint/no-explicit-any,@typescript-eslint/no-unsafe-member-access
            request[$604631306887a81e$var$ORIGINAL_BODY] = init.body;
            return request;
        };
        SentryRequest.prototype = OriginalRequest.prototype;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any,@typescript-eslint/no-unsafe-member-access
        (0, $736a69486c86d36c$export$f1a6cdb1459e81d1).Request = SentryRequest;
        $604631306887a81e$var$_isRequestInstrumented = true;
    } catch  {
    // Fail silently if Request is frozen
    }
}
/**
 * Sentry integration for [Session Replay](https://sentry.io/for/session-replay/).
 *
 * See the [Replay documentation](https://docs.sentry.io/platforms/javascript/guides/session-replay/) for more information.
 *
 * @example
 *
 * ```
 * Sentry.init({
 *   dsn: '__DSN__',
 *   integrations: [Sentry.replayIntegration()],
 * });
 * ```
 */ const $604631306887a81e$export$d7706faf7ab354bf = (options)=>{
    return new $604631306887a81e$var$Replay(options);
};
/**
 * Replay integration
 */ class $604631306887a81e$var$Replay {
    /**
   * @inheritDoc
   */ /**
   * Options to pass to `rrweb.record()`
   */ /**
   * Initial options passed to the replay integration, merged with default values.
   * Note: `sessionSampleRate` and `errorSampleRate` are not required here, as they
   * can only be finally set when setupOnce() is called.
   *
   * @private
   */ constructor({ flushMinDelay: flushMinDelay = $604631306887a81e$var$DEFAULT_FLUSH_MIN_DELAY, flushMaxDelay: flushMaxDelay = $604631306887a81e$var$DEFAULT_FLUSH_MAX_DELAY, minReplayDuration: minReplayDuration = $604631306887a81e$var$MIN_REPLAY_DURATION, maxReplayDuration: maxReplayDuration = $604631306887a81e$var$MAX_REPLAY_DURATION, stickySession: stickySession = true, useCompression: useCompression = true, workerUrl: workerUrl, _experiments: _experiments = {}, maskAllText: maskAllText = true, maskAllInputs: maskAllInputs = true, blockAllMedia: blockAllMedia = true, mutationBreadcrumbLimit: mutationBreadcrumbLimit = 750, mutationLimit: mutationLimit = 10000, slowClickTimeout: slowClickTimeout = 7000, slowClickIgnoreSelectors: slowClickIgnoreSelectors = [], networkDetailAllowUrls: networkDetailAllowUrls = [], networkDetailDenyUrls: networkDetailDenyUrls = [], networkCaptureBodies: networkCaptureBodies = true, networkRequestHeaders: networkRequestHeaders = [], networkResponseHeaders: networkResponseHeaders = [], mask: mask = [], maskAttributes: maskAttributes = [
        'title',
        'placeholder',
        'aria-label'
    ], unmask: unmask = [], block: block = [], unblock: unblock = [], ignore: ignore = [], maskFn: maskFn, beforeAddRecordingEvent: beforeAddRecordingEvent, beforeErrorSampling: beforeErrorSampling, onError: onError, attachRawBodyFromRequest: attachRawBodyFromRequest = false } = {}){
        this.name = 'Replay';
        const privacyOptions = $604631306887a81e$var$getPrivacyOptions({
            mask: mask,
            unmask: unmask,
            block: block,
            unblock: unblock,
            ignore: ignore
        });
        this._recordingOptions = {
            maskAllInputs: maskAllInputs,
            maskAllText: maskAllText,
            maskInputOptions: {
                password: true
            },
            maskTextFn: maskFn,
            maskInputFn: maskFn,
            maskAttributeFn: (key, value, el)=>$604631306887a81e$var$maskAttribute({
                    maskAttributes: maskAttributes,
                    maskAllText: maskAllText,
                    privacyOptions: privacyOptions,
                    key: key,
                    value: value,
                    el: el
                }),
            ...privacyOptions,
            // Our defaults
            slimDOMOptions: 'all',
            inlineStylesheet: true,
            // Disable inline images as it will increase segment/replay size
            inlineImages: false,
            // collect fonts, but be aware that `sentry.io` needs to be an allowed
            // origin for playback
            collectFonts: true,
            errorHandler: (err)=>{
                try {
                    err.__rrweb__ = true;
                } catch  {
                // ignore errors here
                // this can happen if the error is frozen or does not allow mutation for other reasons
                }
            },
            // experimental support for recording iframes from different origins
            recordCrossOriginIframes: Boolean(_experiments.recordCrossOriginIframes)
        };
        this._initialOptions = {
            flushMinDelay: flushMinDelay,
            flushMaxDelay: flushMaxDelay,
            minReplayDuration: Math.min(minReplayDuration, $604631306887a81e$var$MIN_REPLAY_DURATION_LIMIT),
            maxReplayDuration: Math.min(maxReplayDuration, $604631306887a81e$var$MAX_REPLAY_DURATION),
            stickySession: stickySession,
            useCompression: useCompression,
            workerUrl: workerUrl,
            blockAllMedia: blockAllMedia,
            maskAllInputs: maskAllInputs,
            maskAllText: maskAllText,
            mutationBreadcrumbLimit: mutationBreadcrumbLimit,
            mutationLimit: mutationLimit,
            slowClickTimeout: slowClickTimeout,
            slowClickIgnoreSelectors: slowClickIgnoreSelectors,
            networkDetailAllowUrls: networkDetailAllowUrls,
            networkDetailDenyUrls: networkDetailDenyUrls,
            networkCaptureBodies: networkCaptureBodies,
            networkRequestHeaders: $604631306887a81e$var$_getMergedNetworkHeaders(networkRequestHeaders),
            networkResponseHeaders: $604631306887a81e$var$_getMergedNetworkHeaders(networkResponseHeaders),
            beforeAddRecordingEvent: beforeAddRecordingEvent,
            beforeErrorSampling: beforeErrorSampling,
            onError: onError,
            attachRawBodyFromRequest: attachRawBodyFromRequest,
            _experiments: _experiments
        };
        if (this._initialOptions.blockAllMedia) {
            // `blockAllMedia` is a more user friendly option to configure blocking
            // embedded media elements
            this._recordingOptions.blockSelector = !this._recordingOptions.blockSelector ? $604631306887a81e$var$MEDIA_SELECTORS : `${this._recordingOptions.blockSelector},${$604631306887a81e$var$MEDIA_SELECTORS}`;
            this._recordingOptions.ignoreCSSAttributes = new Set([
                'background-image'
            ]);
        }
        if (this._isInitialized && (0, $b1c1ca6bb415cfb2$export$4e09c449d6c407f7)()) throw new Error('Multiple Sentry Session Replay instances are not supported');
        this._isInitialized = true;
    }
    /** If replay has already been initialized */ get _isInitialized() {
        return $604631306887a81e$var$_initialized;
    }
    /** Update _isInitialized */ set _isInitialized(value) {
        $604631306887a81e$var$_initialized = value;
    }
    /**
   * Setup and initialize replay container
   */ afterAllSetup(client) {
        if (!(0, $b1c1ca6bb415cfb2$export$4e09c449d6c407f7)() || this._replay) return;
        if (this._initialOptions.attachRawBodyFromRequest) $604631306887a81e$var$_INTERNAL_instrumentRequestInterface();
        this._setup(client);
        this._initialize(client);
    }
    /**
   * Start a replay regardless of sampling rate. Calling this will always
   * create a new session. Will log a message if replay is already in progress.
   *
   * Creates or loads a session, attaches listeners to varying events (DOM,
   * PerformanceObserver, Recording, Sentry SDK, etc)
   */ start() {
        if (!this._replay) return;
        this._replay.start();
    }
    /**
   * Start replay buffering. Buffers until `flush()` is called or, if
   * `replaysOnErrorSampleRate` > 0, until an error occurs.
   */ startBuffering() {
        if (!this._replay) return;
        this._replay.startBuffering();
    }
    /**
   * Currently, this needs to be manually called (e.g. for tests). Sentry SDK
   * does not support a teardown
   */ stop() {
        if (!this._replay) return Promise.resolve();
        return this._replay.stop({
            forceFlush: this._replay.recordingMode === 'session'
        });
    }
    /**
   * If not in "session" recording mode, flush event buffer which will create a new replay.
   * If replay is not enabled, a new session replay is started.
   * Unless `continueRecording` is false, the replay will continue to record and
   * behave as a "session"-based replay.
   *
   * Otherwise, queue up a flush.
   */ flush(options) {
        if (!this._replay) return Promise.resolve();
        // assuming a session should be recorded in this case
        if (!this._replay.isEnabled()) {
            this._replay.start();
            return Promise.resolve();
        }
        return this._replay.sendBufferedReplayOrFlush(options);
    }
    /**
   * Get the current session ID.
   *
   * @param onlyIfSampled - If true, will only return the session ID if the session is sampled.
   *
   */ getReplayId(onlyIfSampled) {
        if (!this._replay?.isEnabled()) return;
        return this._replay.getSessionId(onlyIfSampled);
    }
    /**
   * Get the current recording mode. This can be either `session` or `buffer`.
   *
   * `session`: Recording the whole session, sending it continuously
   * `buffer`: Always keeping the last 60s of recording, requires:
   *   - having replaysOnErrorSampleRate > 0 to capture replay when an error occurs
   *   - or calling `flush()` to send the replay
   */ getRecordingMode() {
        if (!this._replay?.isEnabled()) return;
        return this._replay.recordingMode;
    }
    /**
   * Initializes replay.
   */ _initialize(client) {
        if (!this._replay) return;
        this._maybeLoadFromReplayCanvasIntegration(client);
        this._replay.initializeSampling();
    }
    /** Setup the integration. */ _setup(client) {
        // Client is not available in constructor, so we need to wait until setupOnce
        const finalOptions = $604631306887a81e$var$loadReplayOptionsFromClient(this._initialOptions, client);
        this._replay = new $604631306887a81e$var$ReplayContainer({
            options: finalOptions,
            recordingOptions: this._recordingOptions
        });
    }
    /** Get canvas options from ReplayCanvas integration, if it is also added. */ _maybeLoadFromReplayCanvasIntegration(client) {
        // To save bundle size, we skip checking for stuff here
        // and instead just try-catch everything - as generally this should all be defined
        /* eslint-disable @typescript-eslint/no-non-null-assertion */ try {
            const canvasIntegration = client.getIntegrationByName('ReplayCanvas');
            if (!canvasIntegration) return;
            this._replay['_canvas'] = canvasIntegration.getOptions();
        } catch  {
        // ignore errors here
        }
    /* eslint-enable @typescript-eslint/no-non-null-assertion */ }
}
/** Parse Replay-related options from SDK options */ function $604631306887a81e$var$loadReplayOptionsFromClient(initialOptions, client) {
    const opt = client.getOptions();
    const finalOptions = {
        sessionSampleRate: 0,
        errorSampleRate: 0,
        ...initialOptions
    };
    const replaysSessionSampleRate = (0, $921fe5f527b40422$export$a5bd2d81656d9546)(opt.replaysSessionSampleRate);
    const replaysOnErrorSampleRate = (0, $921fe5f527b40422$export$a5bd2d81656d9546)(opt.replaysOnErrorSampleRate);
    if (replaysSessionSampleRate == null && replaysOnErrorSampleRate == null) (0, $d11ed0b3cdda6b8d$export$cda52e2a8927a2ca)(()=>{
        // eslint-disable-next-line no-console
        console.warn('Replay is disabled because neither `replaysSessionSampleRate` nor `replaysOnErrorSampleRate` are set.');
    });
    if (replaysSessionSampleRate != null) finalOptions.sessionSampleRate = replaysSessionSampleRate;
    if (replaysOnErrorSampleRate != null) finalOptions.errorSampleRate = replaysOnErrorSampleRate;
    return finalOptions;
}
function $604631306887a81e$var$_getMergedNetworkHeaders(headers) {
    return [
        ...$604631306887a81e$var$DEFAULT_NETWORK_HEADERS,
        ...headers.map((header)=>header.toLowerCase())
    ];
}
/**
 * This is a small utility to get a type-safe instance of the Replay integration.
 */ function $604631306887a81e$export$b28310b2f161456b() {
    const client = (0, $7d48e1ed9f699a01$export$6bb76d6eba7e258c)();
    return client?.getIntegrationByName('Replay');
}



var $ea445dd6c112133e$var$__defProp$1 = Object.defineProperty;
var $ea445dd6c112133e$var$__defNormalProp$1 = (obj, key, value)=>key in obj ? $ea445dd6c112133e$var$__defProp$1(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $ea445dd6c112133e$var$__publicField$1 = (obj, key, value)=>$ea445dd6c112133e$var$__defNormalProp$1(obj, typeof key !== "symbol" ? key + "" : key, value);
class $ea445dd6c112133e$var$Mirror {
    constructor(){
        $ea445dd6c112133e$var$__publicField$1(this, "idNodeMap", /* @__PURE__ */ new Map());
        $ea445dd6c112133e$var$__publicField$1(this, "nodeMetaMap", /* @__PURE__ */ new WeakMap());
    }
    getId(n2) {
        if (!n2) return -1;
        const id = this.getMeta(n2)?.id;
        return id ?? -1;
    }
    getNode(id) {
        return this.idNodeMap.get(id) || null;
    }
    getIds() {
        return Array.from(this.idNodeMap.keys());
    }
    getMeta(n2) {
        return this.nodeMetaMap.get(n2) || null;
    }
    // removes the node from idNodeMap
    // doesn't remove the node from nodeMetaMap
    removeNodeFromMap(n2) {
        const id = this.getId(n2);
        this.idNodeMap.delete(id);
        if (n2.childNodes) n2.childNodes.forEach((childNode)=>this.removeNodeFromMap(childNode));
    }
    has(id) {
        return this.idNodeMap.has(id);
    }
    hasNode(node) {
        return this.nodeMetaMap.has(node);
    }
    add(n2, meta) {
        const id = meta.id;
        this.idNodeMap.set(id, n2);
        this.nodeMetaMap.set(n2, meta);
    }
    replace(id, n2) {
        const oldNode = this.getNode(id);
        if (oldNode) {
            const meta = this.nodeMetaMap.get(oldNode);
            if (meta) this.nodeMetaMap.set(n2, meta);
        }
        this.idNodeMap.set(id, n2);
    }
    reset() {
        this.idNodeMap = /* @__PURE__ */ new Map();
        this.nodeMetaMap = /* @__PURE__ */ new WeakMap();
    }
}
function $ea445dd6c112133e$var$createMirror$2() {
    return new $ea445dd6c112133e$var$Mirror();
}
function $ea445dd6c112133e$var$elementClassMatchesRegex(el, regex) {
    for(let eIndex = el.classList.length; eIndex--;){
        const className = el.classList[eIndex];
        if (regex.test(className)) return true;
    }
    return false;
}
function $ea445dd6c112133e$var$distanceToMatch(node, matchPredicate, limit = Infinity, distance = 0) {
    if (!node) return -1;
    if (node.nodeType !== node.ELEMENT_NODE) return -1;
    if (distance > limit) return -1;
    if (matchPredicate(node)) return distance;
    return $ea445dd6c112133e$var$distanceToMatch(node.parentNode, matchPredicate, limit, distance + 1);
}
function $ea445dd6c112133e$var$createMatchPredicate(className, selector) {
    return (node)=>{
        const el = node;
        if (el === null) return false;
        try {
            if (className) {
                if (typeof className === "string") {
                    if (el.matches(`.${className}`)) return true;
                } else if ($ea445dd6c112133e$var$elementClassMatchesRegex(el, className)) return true;
            }
            if (selector && el.matches(selector)) return true;
            return false;
        } catch  {
            return false;
        }
    };
}
const $ea445dd6c112133e$var$DEPARTED_MIRROR_ACCESS_WARNING = "Please stop import mirror directly. Instead of that,\r\nnow you can use replayer.getMirror() to access the mirror instance of a replayer,\r\nor you can use record.mirror to access the mirror instance during recording.";
let $ea445dd6c112133e$var$_mirror = {
    map: {},
    getId () {
        console.error($ea445dd6c112133e$var$DEPARTED_MIRROR_ACCESS_WARNING);
        return -1;
    },
    getNode () {
        console.error($ea445dd6c112133e$var$DEPARTED_MIRROR_ACCESS_WARNING);
        return null;
    },
    removeNodeFromMap () {
        console.error($ea445dd6c112133e$var$DEPARTED_MIRROR_ACCESS_WARNING);
    },
    has () {
        console.error($ea445dd6c112133e$var$DEPARTED_MIRROR_ACCESS_WARNING);
        return false;
    },
    reset () {
        console.error($ea445dd6c112133e$var$DEPARTED_MIRROR_ACCESS_WARNING);
    }
};
if (typeof window !== "undefined" && window.Proxy && window.Reflect) $ea445dd6c112133e$var$_mirror = new Proxy($ea445dd6c112133e$var$_mirror, {
    get (target, prop, receiver) {
        if (prop === "map") console.error($ea445dd6c112133e$var$DEPARTED_MIRROR_ACCESS_WARNING);
        return Reflect.get(target, prop, receiver);
    }
});
function $ea445dd6c112133e$var$hookSetter(target, key, d, isRevoked, win = window) {
    const original = win.Object.getOwnPropertyDescriptor(target, key);
    win.Object.defineProperty(target, key, isRevoked ? d : {
        set (value) {
            $ea445dd6c112133e$var$setTimeout$1(()=>{
                d.set.call(this, value);
            }, 0);
            if (original && original.set) original.set.call(this, value);
        }
    });
    return ()=>$ea445dd6c112133e$var$hookSetter(target, key, original || {}, true);
}
function $ea445dd6c112133e$var$patch(source, name, replacement) {
    try {
        if (!(name in source)) return ()=>{};
        const original = source[name];
        const wrapped = replacement(original);
        if (typeof wrapped === "function") {
            wrapped.prototype = wrapped.prototype || {};
            Object.defineProperties(wrapped, {
                __rrweb_original__: {
                    enumerable: false,
                    value: original
                }
            });
        }
        source[name] = wrapped;
        return ()=>{
            source[name] = original;
        };
    } catch  {
        return ()=>{};
    }
}
/* @__PURE__ */ /[1-9][0-9]{12}/.test(Date.now().toString());
function $ea445dd6c112133e$var$closestElementOfNode(node) {
    if (!node) return null;
    try {
        const el = node.nodeType === node.ELEMENT_NODE ? node : node.parentElement;
        return el;
    } catch (error) {
        return null;
    }
}
function $ea445dd6c112133e$var$isBlocked(node, blockClass, blockSelector, unblockSelector, checkAncestors) {
    if (!node) return false;
    const el = $ea445dd6c112133e$var$closestElementOfNode(node);
    if (!el) return false;
    const blockedPredicate = $ea445dd6c112133e$var$createMatchPredicate(blockClass, blockSelector);
    if (!checkAncestors) {
        const isUnblocked = unblockSelector && el.matches(unblockSelector);
        return blockedPredicate(el) && !isUnblocked;
    }
    const blockDistance = $ea445dd6c112133e$var$distanceToMatch(el, blockedPredicate);
    let unblockDistance = -1;
    if (blockDistance < 0) return false;
    if (unblockSelector) unblockDistance = $ea445dd6c112133e$var$distanceToMatch(el, $ea445dd6c112133e$var$createMatchPredicate(null, unblockSelector));
    if (blockDistance > -1 && unblockDistance < 0) return true;
    return blockDistance < unblockDistance;
}
const $ea445dd6c112133e$var$cachedImplementations = {};
function $ea445dd6c112133e$var$getImplementation(name) {
    const cached = $ea445dd6c112133e$var$cachedImplementations[name];
    if (cached) return cached;
    const document2 = window.document;
    let impl = window[name];
    if (document2 && typeof document2.createElement === "function") try {
        const sandbox = document2.createElement("iframe");
        sandbox.hidden = true;
        document2.head.appendChild(sandbox);
        const contentWindow = sandbox.contentWindow;
        if (contentWindow && contentWindow[name]) impl = contentWindow[name];
        document2.head.removeChild(sandbox);
    } catch (e2) {}
    return $ea445dd6c112133e$var$cachedImplementations[name] = impl.bind(window);
}
function $ea445dd6c112133e$var$onRequestAnimationFrame(...rest) {
    return $ea445dd6c112133e$var$getImplementation("requestAnimationFrame")(...rest);
}
function $ea445dd6c112133e$var$setTimeout$1(...rest) {
    return $ea445dd6c112133e$var$getImplementation("setTimeout")(...rest);
}
var $ea445dd6c112133e$var$CanvasContext = /* @__PURE__ */ ((CanvasContext2)=>{
    CanvasContext2[CanvasContext2["2D"] = 0] = "2D";
    CanvasContext2[CanvasContext2["WebGL"] = 1] = "WebGL";
    CanvasContext2[CanvasContext2["WebGL2"] = 2] = "WebGL2";
    return CanvasContext2;
})($ea445dd6c112133e$var$CanvasContext || {});
let $ea445dd6c112133e$var$errorHandler;
function $ea445dd6c112133e$var$registerErrorHandler(handler) {
    $ea445dd6c112133e$var$errorHandler = handler;
}
const $ea445dd6c112133e$var$callbackWrapper = (cb)=>{
    if (!$ea445dd6c112133e$var$errorHandler) return cb;
    const rrwebWrapped = (...rest)=>{
        try {
            return cb(...rest);
        } catch (error) {
            if ($ea445dd6c112133e$var$errorHandler && $ea445dd6c112133e$var$errorHandler(error) === true) return ()=>{};
            throw error;
        }
    };
    return rrwebWrapped;
};
var $ea445dd6c112133e$var$chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
var $ea445dd6c112133e$var$lookup = typeof Uint8Array === "undefined" ? [] : new Uint8Array(256);
for(var $ea445dd6c112133e$var$i$1 = 0; $ea445dd6c112133e$var$i$1 < $ea445dd6c112133e$var$chars.length; $ea445dd6c112133e$var$i$1++)$ea445dd6c112133e$var$lookup[$ea445dd6c112133e$var$chars.charCodeAt($ea445dd6c112133e$var$i$1)] = $ea445dd6c112133e$var$i$1;
var $ea445dd6c112133e$var$encode = function(arraybuffer) {
    var bytes = new Uint8Array(arraybuffer), i2, len = bytes.length, base64 = "";
    for(i2 = 0; i2 < len; i2 += 3){
        base64 += $ea445dd6c112133e$var$chars[bytes[i2] >> 2];
        base64 += $ea445dd6c112133e$var$chars[(bytes[i2] & 3) << 4 | bytes[i2 + 1] >> 4];
        base64 += $ea445dd6c112133e$var$chars[(bytes[i2 + 1] & 15) << 2 | bytes[i2 + 2] >> 6];
        base64 += $ea445dd6c112133e$var$chars[bytes[i2 + 2] & 63];
    }
    if (len % 3 === 2) base64 = base64.substring(0, base64.length - 1) + "=";
    else if (len % 3 === 1) base64 = base64.substring(0, base64.length - 2) + "==";
    return base64;
};
const $ea445dd6c112133e$var$canvasVarMap = /* @__PURE__ */ new Map();
function $ea445dd6c112133e$var$variableListFor$1(ctx, ctor) {
    let contextMap = $ea445dd6c112133e$var$canvasVarMap.get(ctx);
    if (!contextMap) {
        contextMap = /* @__PURE__ */ new Map();
        $ea445dd6c112133e$var$canvasVarMap.set(ctx, contextMap);
    }
    if (!contextMap.has(ctor)) contextMap.set(ctor, []);
    return contextMap.get(ctor);
}
const $ea445dd6c112133e$var$saveWebGLVar = (value, win, ctx)=>{
    if (!value || !($ea445dd6c112133e$var$isInstanceOfWebGLObject(value, win) || typeof value === "object")) return;
    const name = value.constructor.name;
    const list = $ea445dd6c112133e$var$variableListFor$1(ctx, name);
    let index = list.indexOf(value);
    if (index === -1) {
        index = list.length;
        list.push(value);
    }
    return index;
};
function $ea445dd6c112133e$var$serializeArg(value, win, ctx) {
    if (value instanceof Array) return value.map((arg)=>$ea445dd6c112133e$var$serializeArg(arg, win, ctx));
    else if (value === null) return value;
    else if (value instanceof Float32Array || value instanceof Float64Array || value instanceof Int32Array || value instanceof Uint32Array || value instanceof Uint8Array || value instanceof Uint16Array || value instanceof Int16Array || value instanceof Int8Array || value instanceof Uint8ClampedArray) {
        const name = value.constructor.name;
        return {
            rr_type: name,
            args: [
                Object.values(value)
            ]
        };
    } else if (// SharedArrayBuffer disabled on most browsers due to spectre.
    // More info: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/SharedArrayBuffer/SharedArrayBuffer
    // value instanceof SharedArrayBuffer ||
    value instanceof ArrayBuffer) {
        const name = value.constructor.name;
        const base64 = $ea445dd6c112133e$var$encode(value);
        return {
            rr_type: name,
            base64: base64
        };
    } else if (value instanceof DataView) {
        const name = value.constructor.name;
        return {
            rr_type: name,
            args: [
                $ea445dd6c112133e$var$serializeArg(value.buffer, win, ctx),
                value.byteOffset,
                value.byteLength
            ]
        };
    } else if (value instanceof HTMLImageElement) {
        const name = value.constructor.name;
        const { src: src } = value;
        return {
            rr_type: name,
            src: src
        };
    } else if (value instanceof HTMLCanvasElement) {
        const name = "HTMLImageElement";
        const src = value.toDataURL();
        return {
            rr_type: name,
            src: src
        };
    } else if (value instanceof ImageData) {
        const name = value.constructor.name;
        return {
            rr_type: name,
            args: [
                $ea445dd6c112133e$var$serializeArg(value.data, win, ctx),
                value.width,
                value.height
            ]
        };
    } else if ($ea445dd6c112133e$var$isInstanceOfWebGLObject(value, win) || typeof value === "object") {
        const name = value.constructor.name;
        const index = $ea445dd6c112133e$var$saveWebGLVar(value, win, ctx);
        return {
            rr_type: name,
            index: index
        };
    }
    return value;
}
const $ea445dd6c112133e$var$serializeArgs = (args, win, ctx)=>{
    return args.map((arg)=>$ea445dd6c112133e$var$serializeArg(arg, win, ctx));
};
const $ea445dd6c112133e$var$isInstanceOfWebGLObject = (value, win)=>{
    const webGLConstructorNames = [
        "WebGLActiveInfo",
        "WebGLBuffer",
        "WebGLFramebuffer",
        "WebGLProgram",
        "WebGLRenderbuffer",
        "WebGLShader",
        "WebGLShaderPrecisionFormat",
        "WebGLTexture",
        "WebGLUniformLocation",
        "WebGLVertexArrayObject",
        // In old Chrome versions, value won't be an instanceof WebGLVertexArrayObject.
        "WebGLVertexArrayObjectOES"
    ];
    const supportedWebGLConstructorNames = webGLConstructorNames.filter((name)=>typeof win[name] === "function");
    return Boolean(supportedWebGLConstructorNames.find((name)=>value instanceof win[name]));
};
function $ea445dd6c112133e$var$initCanvas2DMutationObserver(cb, win, blockClass2, blockSelector, unblockSelector) {
    const handlers = [];
    const props2D = Object.getOwnPropertyNames(win.CanvasRenderingContext2D.prototype);
    for (const prop of props2D)try {
        if (typeof win.CanvasRenderingContext2D.prototype[prop] !== "function") continue;
        const restoreHandler = $ea445dd6c112133e$var$patch(win.CanvasRenderingContext2D.prototype, prop, function(original) {
            return function(...args) {
                if (!$ea445dd6c112133e$var$isBlocked(this.canvas, blockClass2, blockSelector, unblockSelector, true)) $ea445dd6c112133e$var$setTimeout$1(()=>{
                    const recordArgs = $ea445dd6c112133e$var$serializeArgs(args, win, this);
                    cb(this.canvas, {
                        type: $ea445dd6c112133e$var$CanvasContext["2D"],
                        property: prop,
                        args: recordArgs
                    });
                }, 0);
                return original.apply(this, args);
            };
        });
        handlers.push(restoreHandler);
    } catch  {
        const hookHandler = $ea445dd6c112133e$var$hookSetter(win.CanvasRenderingContext2D.prototype, prop, {
            set (v2) {
                cb(this.canvas, {
                    type: $ea445dd6c112133e$var$CanvasContext["2D"],
                    property: prop,
                    args: [
                        v2
                    ],
                    setter: true
                });
            }
        });
        handlers.push(hookHandler);
    }
    return ()=>{
        handlers.forEach((h)=>h());
    };
}
function $ea445dd6c112133e$var$getNormalizedContextName(contextType) {
    return contextType === "experimental-webgl" ? "webgl" : contextType;
}
function $ea445dd6c112133e$var$initCanvasContextObserver(win, blockClass, blockSelector, unblockSelector, setPreserveDrawingBufferToTrue) {
    const handlers = [];
    try {
        const restoreHandler = $ea445dd6c112133e$var$patch(win.HTMLCanvasElement.prototype, "getContext", function(original) {
            return function(contextType, ...args) {
                if (!$ea445dd6c112133e$var$isBlocked(this, blockClass, blockSelector, unblockSelector, true)) {
                    const ctxName = $ea445dd6c112133e$var$getNormalizedContextName(contextType);
                    if (!("__context" in this)) this.__context = ctxName;
                    if (setPreserveDrawingBufferToTrue && [
                        "webgl",
                        "webgl2"
                    ].includes(ctxName)) {
                        if (args[0] && typeof args[0] === "object") {
                            const contextAttributes = args[0];
                            if (!contextAttributes.preserveDrawingBuffer) contextAttributes.preserveDrawingBuffer = true;
                        } else args.splice(0, 1, {
                            preserveDrawingBuffer: true
                        });
                    }
                }
                return original.apply(this, [
                    contextType,
                    ...args
                ]);
            };
        });
        handlers.push(restoreHandler);
    } catch  {
        console.error("failed to patch HTMLCanvasElement.prototype.getContext");
    }
    return ()=>{
        handlers.forEach((h)=>h());
    };
}
function $ea445dd6c112133e$var$patchGLPrototype(prototype, type, cb, blockClass2, blockSelector, unblockSelector, _mirror2, win) {
    const handlers = [];
    const props = Object.getOwnPropertyNames(prototype);
    for (const prop of props){
        if (//prop.startsWith('get') ||  // e.g. getProgramParameter, but too risky
        [
            "isContextLost",
            "canvas",
            "drawingBufferWidth",
            "drawingBufferHeight"
        ].includes(prop)) continue;
        try {
            if (typeof prototype[prop] !== "function") continue;
            const restoreHandler = $ea445dd6c112133e$var$patch(prototype, prop, function(original) {
                return function(...args) {
                    const result = original.apply(this, args);
                    $ea445dd6c112133e$var$saveWebGLVar(result, win, this);
                    if ("tagName" in this.canvas && !$ea445dd6c112133e$var$isBlocked(this.canvas, blockClass2, blockSelector, unblockSelector, true)) {
                        const recordArgs = $ea445dd6c112133e$var$serializeArgs(args, win, this);
                        const mutation = {
                            type: type,
                            property: prop,
                            args: recordArgs
                        };
                        cb(this.canvas, mutation);
                    }
                    return result;
                };
            });
            handlers.push(restoreHandler);
        } catch  {
            const hookHandler = $ea445dd6c112133e$var$hookSetter(prototype, prop, {
                set (v2) {
                    cb(this.canvas, {
                        type: type,
                        property: prop,
                        args: [
                            v2
                        ],
                        setter: true
                    });
                }
            });
            handlers.push(hookHandler);
        }
    }
    return handlers;
}
function $ea445dd6c112133e$var$initCanvasWebGLMutationObserver(cb, win, blockClass2, blockSelector, unblockSelector, mirror2) {
    const handlers = [];
    handlers.push(...$ea445dd6c112133e$var$patchGLPrototype(win.WebGLRenderingContext.prototype, $ea445dd6c112133e$var$CanvasContext.WebGL, cb, blockClass2, blockSelector, unblockSelector, mirror2, win));
    if (typeof win.WebGL2RenderingContext !== "undefined") handlers.push(...$ea445dd6c112133e$var$patchGLPrototype(win.WebGL2RenderingContext.prototype, $ea445dd6c112133e$var$CanvasContext.WebGL2, cb, blockClass2, blockSelector, unblockSelector, mirror2, win));
    return ()=>{
        handlers.forEach((h)=>h());
    };
}
const $ea445dd6c112133e$var$r$1 = `for(var e="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/",t="undefined"==typeof Uint8Array?[]:new Uint8Array(256),a=0;a<64;a++)t[e.charCodeAt(a)]=a;var n=function(t){var a,n=new Uint8Array(t),r=n.length,s="";for(a=0;a<r;a+=3)s+=e[n[a]>>2],s+=e[(3&n[a])<<4|n[a+1]>>4],s+=e[(15&n[a+1])<<2|n[a+2]>>6],s+=e[63&n[a+2]];return r%3==2?s=s.substring(0,s.length-1)+"=":r%3==1&&(s=s.substring(0,s.length-2)+"=="),s};const r=new Map,s=new Map;const i=self;i.onmessage=async function(e){if(!("OffscreenCanvas"in globalThis))return i.postMessage({id:e.data.id});{const{id:t,bitmap:a,width:o,height:f,maxCanvasSize:c,dataURLOptions:g}=e.data,u=async function(e,t,a){const r=e+"-"+t;if("OffscreenCanvas"in globalThis){if(s.has(r))return s.get(r);const i=new OffscreenCanvas(e,t);i.getContext("2d");const o=await i.convertToBlob(a),f=await o.arrayBuffer(),c=n(f);return s.set(r,c),c}return""}(o,f,g),[h,d]=function(e,t,a){if(!a)return[e,t];const[n,r]=a;if(e<=n&&t<=r)return[e,t];let s=e,i=t;return s>n&&(i=Math.floor(n*t/e),s=n),i>r&&(s=Math.floor(r*e/t),i=r),[s,i]}(o,f,c),l=new OffscreenCanvas(h,d),w=l.getContext("bitmaprenderer"),p=h===o&&d===f?a:await createImageBitmap(a,{resizeWidth:h,resizeHeight:d,resizeQuality:"low"});w?.transferFromImageBitmap(p),a.close();const y=await l.convertToBlob(g),v=y.type,b=await y.arrayBuffer(),m=n(b);if(p.close(),!r.has(t)&&await u===m)return r.set(t,m),i.postMessage({id:t});if(r.get(t)===m)return i.postMessage({id:t});i.postMessage({id:t,type:v,base64:m,width:o,height:f}),r.set(t,m)}};`;
function $ea445dd6c112133e$var$t$1() {
    const t2 = new Blob([
        $ea445dd6c112133e$var$r$1
    ]);
    return URL.createObjectURL(t2);
}
class $ea445dd6c112133e$var$CanvasManager {
    constructor(options){
        this.pendingCanvasMutations = /* @__PURE__ */ new Map();
        this.rafStamps = {
            latestId: 0,
            invokeId: null
        };
        this.shadowDoms = /* @__PURE__ */ new Set();
        this.windowsSet = /* @__PURE__ */ new WeakSet();
        this.windows = [];
        this.restoreHandlers = [];
        this.frozen = false;
        this.locked = false;
        this.snapshotInProgressMap = /* @__PURE__ */ new Map();
        this.worker = null;
        this.lastSnapshotTime = 0;
        this.processMutation = (target, mutation)=>{
            const newFrame = this.rafStamps.invokeId && this.rafStamps.latestId !== this.rafStamps.invokeId;
            if (newFrame || !this.rafStamps.invokeId) this.rafStamps.invokeId = this.rafStamps.latestId;
            if (!this.pendingCanvasMutations.has(target)) this.pendingCanvasMutations.set(target, []);
            this.pendingCanvasMutations.get(target).push(mutation);
        };
        const { enableManualSnapshot: enableManualSnapshot, sampling: sampling = "all", win: win, recordCanvas: recordCanvas, errorHandler: errorHandler2 } = options;
        options.sampling = sampling;
        this.mutationCb = options.mutationCb;
        this.mirror = options.mirror;
        this.options = options;
        if (errorHandler2) $ea445dd6c112133e$var$registerErrorHandler(errorHandler2);
        if (recordCanvas && typeof sampling === "number" || enableManualSnapshot) this.worker = this.initFPSWorker();
        this.addWindow(win);
        if (enableManualSnapshot) return;
        $ea445dd6c112133e$var$callbackWrapper(()=>{
            if (recordCanvas && sampling === "all") {
                this.startRAFTimestamping();
                this.startPendingCanvasMutationFlusher();
            }
            if (recordCanvas && typeof sampling === "number") this.initCanvasFPSObserver();
        })();
    }
    reset() {
        this.pendingCanvasMutations.clear();
        this.restoreHandlers.forEach((handler)=>{
            try {
                handler();
            } catch (e2) {}
        });
        this.restoreHandlers = [];
        this.windowsSet = /* @__PURE__ */ new WeakSet();
        this.windows = [];
        this.shadowDoms = /* @__PURE__ */ new Set();
        this.worker?.terminate();
        this.worker = null;
        this.snapshotInProgressMap = /* @__PURE__ */ new Map();
    }
    freeze() {
        this.frozen = true;
    }
    unfreeze() {
        this.frozen = false;
    }
    lock() {
        this.locked = true;
    }
    unlock() {
        this.locked = false;
    }
    addWindow(win) {
        const { sampling: sampling = "all", blockClass: blockClass, blockSelector: blockSelector, unblockSelector: unblockSelector, recordCanvas: recordCanvas, enableManualSnapshot: enableManualSnapshot } = this.options;
        if (this.windowsSet.has(win)) return;
        if (enableManualSnapshot) {
            this.windowsSet.add(win);
            this.windows.push(new WeakRef(win));
            return;
        }
        $ea445dd6c112133e$var$callbackWrapper(()=>{
            if (recordCanvas && sampling === "all") this.initCanvasMutationObserver(win, blockClass, blockSelector, unblockSelector);
            if (recordCanvas && typeof sampling === "number") {
                const canvasContextReset = $ea445dd6c112133e$var$initCanvasContextObserver(win, blockClass, blockSelector, unblockSelector, true);
                this.restoreHandlers.push(()=>{
                    canvasContextReset();
                });
            }
        })();
        this.windowsSet.add(win);
        this.windows.push(new WeakRef(win));
    }
    addShadowRoot(shadowRoot) {
        this.shadowDoms.add(new WeakRef(shadowRoot));
    }
    resetShadowRoots() {
        this.shadowDoms = /* @__PURE__ */ new Set();
    }
    snapshot(canvasElement, options) {
        if (options?.skipRequestAnimationFrame) {
            this.takeSnapshot(performance.now(), true, canvasElement);
            return;
        }
        $ea445dd6c112133e$var$onRequestAnimationFrame((timestamp)=>this.takeSnapshot(timestamp, true, canvasElement));
    }
    initFPSWorker() {
        const worker = new Worker($ea445dd6c112133e$var$t$1());
        worker.onmessage = (e2)=>{
            const data = e2.data;
            const { id: id } = data;
            this.snapshotInProgressMap.set(id, false);
            if (!("base64" in data)) return;
            const { base64: base64, type: type, width: width, height: height } = data;
            this.mutationCb({
                id: id,
                type: $ea445dd6c112133e$var$CanvasContext["2D"],
                commands: [
                    {
                        property: "clearRect",
                        // wipe canvas
                        args: [
                            0,
                            0,
                            width,
                            height
                        ]
                    },
                    {
                        property: "drawImage",
                        // draws (semi-transparent) image
                        args: [
                            {
                                rr_type: "ImageBitmap",
                                args: [
                                    {
                                        rr_type: "Blob",
                                        data: [
                                            {
                                                rr_type: "ArrayBuffer",
                                                base64: base64
                                            }
                                        ],
                                        type: type
                                    }
                                ]
                            },
                            0,
                            0,
                            // The below args are needed if we enforce a max size, we want to
                            // retain the original size when drawing the image (which should be smaller)
                            width,
                            height
                        ]
                    }
                ]
            });
        };
        return worker;
    }
    initCanvasFPSObserver() {
        let rafId;
        if (!this.windows.length && !this.shadowDoms.size) return;
        const rafCallback = (timestamp)=>{
            this.takeSnapshot(timestamp, false);
            rafId = $ea445dd6c112133e$var$onRequestAnimationFrame(rafCallback);
        };
        rafId = $ea445dd6c112133e$var$onRequestAnimationFrame(rafCallback);
        this.restoreHandlers.push(()=>{
            if (rafId) cancelAnimationFrame(rafId);
        });
    }
    initCanvasMutationObserver(win, blockClass, blockSelector, unblockSelector) {
        const canvasContextReset = $ea445dd6c112133e$var$initCanvasContextObserver(win, blockClass, blockSelector, unblockSelector, false);
        const canvas2DReset = $ea445dd6c112133e$var$initCanvas2DMutationObserver(this.processMutation.bind(this), win, blockClass, blockSelector, unblockSelector);
        const canvasWebGL1and2Reset = $ea445dd6c112133e$var$initCanvasWebGLMutationObserver(this.processMutation.bind(this), win, blockClass, blockSelector, unblockSelector, this.mirror);
        this.restoreHandlers.push(()=>{
            canvasContextReset();
            canvas2DReset();
            canvasWebGL1and2Reset();
        });
    }
    /**
   * Returns all `canvas` elements that are not blocked by the given selectors. Searches all windows and shadow roots.
   */ getCanvasElements(blockClass, blockSelector, unblockSelector) {
        const matchedCanvas = [];
        const searchCanvas = (root)=>{
            root.querySelectorAll("canvas").forEach((canvas)=>{
                if (!$ea445dd6c112133e$var$isBlocked(canvas, blockClass, blockSelector, unblockSelector, true)) matchedCanvas.push(canvas);
            });
        };
        for (const item of this.windows){
            const window2 = item.deref();
            let _document;
            try {
                _document = window2 && window2.document;
            } catch  {}
            if (_document) searchCanvas(_document);
        }
        for (const item of this.shadowDoms){
            const shadowRoot = item.deref();
            if (shadowRoot) searchCanvas(shadowRoot);
        }
        return matchedCanvas;
    }
    /**
   * Takes a snapshot of the provided canvas element, or will search all windows/shadow roots for canvases. Will self-throttle based on `options.sampling`.
   *
   * @returns `true` if the snapshot was taken, `false` if it was throttled.
   */ takeSnapshot(timestamp, isManualSnapshot, canvasElement) {
        const { sampling: sampling, blockClass: blockClass, blockSelector: blockSelector, unblockSelector: unblockSelector, dataURLOptions: dataURLOptions, maxCanvasSize: maxCanvasSize } = this.options;
        const fps = sampling === "all" ? 2 : sampling || 2;
        const timeBetweenSnapshots = 1e3 / fps;
        const shouldThrottle = this.lastSnapshotTime && timestamp - this.lastSnapshotTime < timeBetweenSnapshots;
        if (shouldThrottle) return false;
        this.lastSnapshotTime = timestamp;
        const canvases = canvasElement ? [
            canvasElement
        ] : this.getCanvasElements(blockClass, blockSelector, unblockSelector);
        canvases.forEach((canvas)=>{
            const id = this.mirror.getId(canvas);
            if (!this.mirror.hasNode(canvas) || !canvas.width || !canvas.height || this.snapshotInProgressMap.get(id)) return;
            this.snapshotInProgressMap.set(id, true);
            if (!isManualSnapshot && [
                "webgl",
                "webgl2"
            ].includes(canvas.__context)) {
                const context = canvas.getContext(canvas.__context);
                if (context?.getContextAttributes()?.preserveDrawingBuffer === false) context.clear(context.COLOR_BUFFER_BIT);
            }
            createImageBitmap(canvas).then((bitmap)=>{
                this.worker?.postMessage({
                    id: id,
                    bitmap: bitmap,
                    width: canvas.width,
                    height: canvas.height,
                    dataURLOptions: dataURLOptions,
                    maxCanvasSize: maxCanvasSize
                }, [
                    bitmap
                ]);
            }).catch((error)=>{
                $ea445dd6c112133e$var$callbackWrapper(()=>{
                    this.snapshotInProgressMap.delete(id);
                    throw error;
                })();
            });
        });
        return true;
    }
    startPendingCanvasMutationFlusher() {
        $ea445dd6c112133e$var$onRequestAnimationFrame(()=>this.flushPendingCanvasMutations());
    }
    startRAFTimestamping() {
        const setLatestRAFTimestamp = (timestamp)=>{
            this.rafStamps.latestId = timestamp;
            $ea445dd6c112133e$var$onRequestAnimationFrame(setLatestRAFTimestamp);
        };
        $ea445dd6c112133e$var$onRequestAnimationFrame(setLatestRAFTimestamp);
    }
    flushPendingCanvasMutations() {
        this.pendingCanvasMutations.forEach((_values, canvas)=>{
            const id = this.mirror.getId(canvas);
            this.flushPendingCanvasMutationFor(canvas, id);
        });
        $ea445dd6c112133e$var$onRequestAnimationFrame(()=>this.flushPendingCanvasMutations());
    }
    flushPendingCanvasMutationFor(canvas, id) {
        if (this.frozen || this.locked) return;
        const valuesWithType = this.pendingCanvasMutations.get(canvas);
        if (!valuesWithType || id === -1) return;
        const values = valuesWithType.map((value)=>{
            const { type: type2, ...rest } = value;
            return rest;
        });
        const { type: type } = valuesWithType[0];
        this.mutationCb({
            id: id,
            type: type,
            commands: values
        });
        this.pendingCanvasMutations.delete(canvas);
    }
}
try {
    if (Array.from([
        1
    ], (x)=>x * 2)[0] !== 2) {
        const cleanFrame = document.createElement("iframe");
        document.body.appendChild(cleanFrame);
        Array.from = cleanFrame.contentWindow?.Array.from || Array.from;
        document.body.removeChild(cleanFrame);
    }
} catch (err) {
    console.debug("Unable to override Array.from", err);
}
$ea445dd6c112133e$var$createMirror$2();
var $ea445dd6c112133e$var$n;
!function(t2) {
    t2[t2.NotStarted = 0] = "NotStarted", t2[t2.Running = 1] = "Running", t2[t2.Stopped = 2] = "Stopped";
}($ea445dd6c112133e$var$n || ($ea445dd6c112133e$var$n = {}));
const $ea445dd6c112133e$var$CANVAS_QUALITY = {
    low: {
        sampling: {
            canvas: 1
        },
        dataURLOptions: {
            type: 'image/webp',
            quality: 0.25
        }
    },
    medium: {
        sampling: {
            canvas: 2
        },
        dataURLOptions: {
            type: 'image/webp',
            quality: 0.4
        }
    },
    high: {
        sampling: {
            canvas: 4
        },
        dataURLOptions: {
            type: 'image/webp',
            quality: 0.5
        }
    }
};
const $ea445dd6c112133e$var$INTEGRATION_NAME = 'ReplayCanvas';
const $ea445dd6c112133e$var$DEFAULT_MAX_CANVAS_SIZE = 1280;
/** Exported only for type safe tests. */ const $ea445dd6c112133e$var$_replayCanvasIntegration = (options = {})=>{
    const [maxCanvasWidth, maxCanvasHeight] = options.maxCanvasSize || [];
    const _canvasOptions = {
        quality: options.quality || 'medium',
        enableManualSnapshot: options.enableManualSnapshot,
        maxCanvasSize: [
            maxCanvasWidth ? Math.min(maxCanvasWidth, $ea445dd6c112133e$var$DEFAULT_MAX_CANVAS_SIZE) : $ea445dd6c112133e$var$DEFAULT_MAX_CANVAS_SIZE,
            maxCanvasHeight ? Math.min(maxCanvasHeight, $ea445dd6c112133e$var$DEFAULT_MAX_CANVAS_SIZE) : $ea445dd6c112133e$var$DEFAULT_MAX_CANVAS_SIZE
        ]
    };
    let currentCanvasManager;
    let canvasManagerResolve;
    const _canvasManager = new Promise((resolve)=>canvasManagerResolve = resolve);
    return {
        name: $ea445dd6c112133e$var$INTEGRATION_NAME,
        getOptions () {
            const { quality: quality, enableManualSnapshot: enableManualSnapshot, maxCanvasSize: maxCanvasSize } = _canvasOptions;
            return {
                enableManualSnapshot: enableManualSnapshot,
                recordCanvas: true,
                getCanvasManager: (getCanvasManagerOptions)=>{
                    const manager = new $ea445dd6c112133e$var$CanvasManager({
                        ...getCanvasManagerOptions,
                        enableManualSnapshot: enableManualSnapshot,
                        maxCanvasSize: maxCanvasSize,
                        errorHandler: (err)=>{
                            try {
                                if (typeof err === 'object') err.__rrweb__ = true;
                            } catch  {
                            // ignore errors here
                            // this can happen if the error is frozen or does not allow mutation for other reasons
                            }
                        }
                    });
                    currentCanvasManager = manager;
                    // Resolve promise on first call for backward compatibility
                    canvasManagerResolve(manager);
                    return manager;
                },
                ...$ea445dd6c112133e$var$CANVAS_QUALITY[quality] || $ea445dd6c112133e$var$CANVAS_QUALITY.medium
            };
        },
        async snapshot (canvasElement, options) {
            const canvasManager = currentCanvasManager || await _canvasManager;
            canvasManager.snapshot(canvasElement, options);
        }
    };
};
/**
 * Add this in addition to `replayIntegration()` to enable canvas recording.
 */ const $ea445dd6c112133e$export$71ba62165d5c834d = (0, $cbb2da6c78246e45$export$2323046b9414659f)($ea445dd6c112133e$var$_replayCanvasIntegration);














/**
 * Create and track fetch request spans for usage in combination with `addFetchInstrumentationHandler`.
 *
 * @returns Span if a span was created, otherwise void.
 */ function $0ce265c2131fdf7a$export$6d73c62358c655be(handlerData, shouldCreateSpan, shouldAttachHeaders, spans, spanOriginOrOptions) {
    if (!handlerData.fetchData) return undefined;
    const { method: method, url: url } = handlerData.fetchData;
    const shouldCreateSpanResult = (0, $e3827447d651dfc5$export$1f70765132c3c225)() && shouldCreateSpan(url);
    if (handlerData.endTimestamp) {
        const spanId = handlerData.fetchData.__span;
        if (!spanId) return;
        const span = spans[spanId];
        if (span) {
            // Only end the span and call hooks if we're actually recording
            if (shouldCreateSpanResult) {
                $0ce265c2131fdf7a$var$endSpan(span, handlerData);
                $0ce265c2131fdf7a$export$740b7cef1e5753d5(span, handlerData, spanOriginOrOptions);
            }
            // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
            delete spans[spanId];
        }
        return undefined;
    }
    // Backwards-compatible with the old signature. Needed to introduce the combined optional parameter
    // to avoid API breakage for anyone calling this function with the optional spanOrigin parameter
    // TODO (v11): remove this backwards-compatible code and only accept the options parameter
    const { spanOrigin: spanOrigin = 'auto.http.browser', propagateTraceparent: propagateTraceparent = false } = typeof spanOriginOrOptions === 'object' ? spanOriginOrOptions : {
        spanOrigin: spanOriginOrOptions
    };
    const hasParent = !!(0, $bb9b6447bf4caedb$export$1be426a8e585c83e)();
    const span = shouldCreateSpanResult && hasParent ? (0, $c9161b67125aefc1$export$63dbba021a6b4047)($0ce265c2131fdf7a$var$getSpanStartOptions(url, method, spanOrigin)) : new (0, $057104436ef6f1c5$export$d6636b700b76c516)();
    handlerData.fetchData.__span = span.spanContext().spanId;
    spans[span.spanContext().spanId] = span;
    if (shouldAttachHeaders(handlerData.fetchData.url)) {
        const request = handlerData.args[0];
        // Shallow clone the options object to avoid mutating the original user-provided object
        // Examples: users re-using same options object for multiple fetch calls, frozen objects
        const options = {
            ...handlerData.args[1] || {}
        };
        const headers = $0ce265c2131fdf7a$export$eab8901e1b084464(request, options, // If performance is disabled (TWP) or there's no active root span (pageload/navigation/interaction),
        // we do not want to use the span as base for the trace headers,
        // which means that the headers will be generated from the scope and the sampling decision is deferred
        (0, $e3827447d651dfc5$export$1f70765132c3c225)() && hasParent ? span : undefined, propagateTraceparent);
        if (headers) {
            // Ensure this is actually set, if no options have been passed previously
            handlerData.args[1] = options;
            options.headers = headers;
        }
    }
    const client = (0, $7d48e1ed9f699a01$export$6bb76d6eba7e258c)();
    if (client) {
        const fetchHint = {
            input: handlerData.args,
            response: handlerData.response,
            startTimestamp: handlerData.startTimestamp,
            endTimestamp: handlerData.endTimestamp
        };
        client.emit('beforeOutgoingRequestSpan', span, fetchHint);
    }
    return span;
}
/**
 * Calls the onRequestSpanEnd callback if it is defined.
 */ function $0ce265c2131fdf7a$export$740b7cef1e5753d5(span, handlerData, spanOriginOrOptions) {
    const onRequestSpanEnd = typeof spanOriginOrOptions === 'object' && spanOriginOrOptions !== null ? spanOriginOrOptions.onRequestSpanEnd : undefined;
    onRequestSpanEnd?.(span, {
        headers: handlerData.response?.headers,
        error: handlerData.error
    });
}
/**
 * Adds sentry-trace and baggage headers to the various forms of fetch headers.
 * exported only for testing purposes
 *
 * When we determine if we should add a baggage header, there are 3 cases:
 * 1. No previous baggage header -> add baggage
 * 2. Previous baggage header has no sentry baggage values -> add our baggage
 * 3. Previous baggage header has sentry baggage values -> do nothing (might have been added manually by users)
 */ // eslint-disable-next-line complexity -- yup it's this complicated :(
function $0ce265c2131fdf7a$export$eab8901e1b084464(request, fetchOptionsObj, span, propagateTraceparent) {
    const traceHeaders = (0, $9086b800c08a7b68$export$dec8f001b9d982cb)({
        span: span,
        propagateTraceparent: propagateTraceparent
    });
    const sentryTrace = traceHeaders['sentry-trace'];
    const baggage = traceHeaders.baggage;
    const traceparent = traceHeaders.traceparent;
    // Nothing to do, when we return undefined here, the original headers will be used
    if (!sentryTrace) return undefined;
    const originalHeaders = fetchOptionsObj.headers || ((0, $13cf2ed412f405fa$export$6d3d1f317d7cda57)(request) ? request.headers : undefined);
    if (!originalHeaders) return {
        ...traceHeaders
    };
    else if ($0ce265c2131fdf7a$var$isHeaders(originalHeaders)) {
        const newHeaders = new Headers(originalHeaders);
        // We don't want to override manually added sentry headers
        if (!newHeaders.get('sentry-trace')) newHeaders.set('sentry-trace', sentryTrace);
        if (propagateTraceparent && traceparent && !newHeaders.get('traceparent')) newHeaders.set('traceparent', traceparent);
        if (baggage) {
            const prevBaggageHeader = newHeaders.get('baggage');
            if (!prevBaggageHeader) newHeaders.set('baggage', baggage);
            else if (!$0ce265c2131fdf7a$var$baggageHeaderHasSentryBaggageValues(prevBaggageHeader)) newHeaders.set('baggage', `${prevBaggageHeader},${baggage}`);
        }
        return newHeaders;
    } else if (Array.isArray(originalHeaders)) {
        const newHeaders = [
            ...originalHeaders
        ];
        if (!originalHeaders.find((header)=>header[0] === 'sentry-trace')) newHeaders.push([
            'sentry-trace',
            sentryTrace
        ]);
        if (propagateTraceparent && traceparent && !originalHeaders.find((header)=>header[0] === 'traceparent')) newHeaders.push([
            'traceparent',
            traceparent
        ]);
        const prevBaggageHeaderWithSentryValues = originalHeaders.find((header)=>header[0] === 'baggage' && $0ce265c2131fdf7a$var$baggageHeaderHasSentryBaggageValues(header[1]));
        if (baggage && !prevBaggageHeaderWithSentryValues) // If there are multiple entries with the same key, the browser will merge the values into a single request header.
        // Its therefore safe to simply push a "baggage" entry, even though there might already be another baggage header.
        newHeaders.push([
            'baggage',
            baggage
        ]);
        return newHeaders;
    } else {
        const existingSentryTraceHeader = 'sentry-trace' in originalHeaders ? originalHeaders['sentry-trace'] : undefined;
        const existingTraceparentHeader = 'traceparent' in originalHeaders ? originalHeaders.traceparent : undefined;
        const existingBaggageHeader = 'baggage' in originalHeaders ? originalHeaders.baggage : undefined;
        const newBaggageHeaders = existingBaggageHeader ? Array.isArray(existingBaggageHeader) ? [
            ...existingBaggageHeader
        ] : [
            existingBaggageHeader
        ] : [];
        const prevBaggageHeaderWithSentryValues = existingBaggageHeader && (Array.isArray(existingBaggageHeader) ? existingBaggageHeader.find((headerItem)=>$0ce265c2131fdf7a$var$baggageHeaderHasSentryBaggageValues(headerItem)) : $0ce265c2131fdf7a$var$baggageHeaderHasSentryBaggageValues(existingBaggageHeader));
        if (baggage && !prevBaggageHeaderWithSentryValues) newBaggageHeaders.push(baggage);
        const newHeaders = {
            ...originalHeaders,
            'sentry-trace': existingSentryTraceHeader ?? sentryTrace,
            baggage: newBaggageHeaders.length > 0 ? newBaggageHeaders.join(',') : undefined
        };
        if (propagateTraceparent && traceparent && !existingTraceparentHeader) newHeaders.traceparent = traceparent;
        return newHeaders;
    }
}
function $0ce265c2131fdf7a$var$endSpan(span, handlerData) {
    if (handlerData.response) {
        (0, $fda37f10dc06a152$export$2ad6630ec8164254)(span, handlerData.response.status);
        const contentLength = handlerData.response?.headers?.get('content-length');
        if (contentLength) {
            const contentLengthNum = parseInt(contentLength);
            if (contentLengthNum > 0) span.setAttribute('http.response_content_length', contentLengthNum);
        }
    } else if (handlerData.error) span.setStatus({
        code: (0, $fda37f10dc06a152$export$f966a0446ece71e),
        message: 'internal_error'
    });
    span.end();
}
function $0ce265c2131fdf7a$var$baggageHeaderHasSentryBaggageValues(baggageHeader) {
    return baggageHeader.split(',').some((baggageEntry)=>baggageEntry.trim().startsWith((0, $8ef2851bd0adcf53$export$6e69537d67fa20f)));
}
function $0ce265c2131fdf7a$var$isHeaders(headers) {
    return typeof Headers !== 'undefined' && (0, $13cf2ed412f405fa$export$49034edbe6b62415)(headers, Headers);
}
function $0ce265c2131fdf7a$var$getSpanStartOptions(url, method, spanOrigin) {
    // Data URLs need special handling because parseStringToURLObject treats them as "relative"
    // (no "://"), causing getSanitizedUrlStringFromUrlObject to return just the pathname
    // without the "data:" prefix, making later stripDataUrlContent calls ineffective.
    // So for data URLs, we strip the content first and use that directly.
    if (url.startsWith('data:')) {
        const sanitizedUrl = (0, $0c1b93525a804899$export$8abd806fcaf234fa)(url);
        return {
            name: `${method} ${sanitizedUrl}`,
            attributes: $0ce265c2131fdf7a$var$getFetchSpanAttributes(url, undefined, method, spanOrigin)
        };
    }
    const parsedUrl = (0, $0c1b93525a804899$export$2004d912a9ead694)(url);
    const sanitizedUrl = parsedUrl ? (0, $0c1b93525a804899$export$5339fcdc8e2a427c)(parsedUrl) : url;
    return {
        name: `${method} ${sanitizedUrl}`,
        attributes: $0ce265c2131fdf7a$var$getFetchSpanAttributes(url, parsedUrl, method, spanOrigin)
    };
}
function $0ce265c2131fdf7a$var$getFetchSpanAttributes(url, parsedUrl, method, spanOrigin) {
    const attributes = {
        url: (0, $0c1b93525a804899$export$8abd806fcaf234fa)(url),
        type: 'fetch',
        'http.method': method,
        [(0, $f337c80285f06f80$export$cca8dd30f57f805e)]: spanOrigin,
        [(0, $f337c80285f06f80$export$1a413bd9a88fdb09)]: 'http.client'
    };
    if (parsedUrl) {
        if (!(0, $0c1b93525a804899$export$e258e13805402ba7)(parsedUrl)) {
            attributes['http.url'] = (0, $0c1b93525a804899$export$8abd806fcaf234fa)(parsedUrl.href);
            attributes['server.address'] = parsedUrl.host;
        }
        if (parsedUrl.search) attributes['http.query'] = parsedUrl.search;
        if (parsedUrl.hash) attributes['http.fragment'] = parsedUrl.hash;
    }
    return attributes;
}







/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Sentry-specific change:
 *
 * This function's logic was NOT updated to web-vitals 4.2.4 or 5.x but we continue
 * to use the web-vitals 3.5.2 version due to having stricter browser support.
 *
 * PR with context that made the changes:
 * https://github.com/GoogleChrome/web-vitals/pull/442/files#r1530492402
 *
 * The PR removed listening to the `pagehide` event, in favour of only listening to
 * the `visibilitychange` event. This is "more correct" but some browsers we still
 * support (Safari <14.4) don't fully support `visibilitychange` or have known bugs
 * with respect to the `visibilitychange` event.
 *
 * TODO (v11): If we decide to drop support for Safari 14.4, we can use the logic
 * from web-vitals 4.2.4. In this case, we also need to update the integration tests
 * that currently trigger the `pagehide` event to simulate the page being hidden.
 *
 * @param {OnHiddenCallback} cb - Callback to be executed when the page is hidden or unloaded.
 *
 * @deprecated use `whenIdleOrHidden` or `addPageListener('visibilitychange')` instead
 */ const $88341307c4ec6bb4$export$91ec2be6fdd8f1b4 = (cb)=>{
    const onHiddenOrPageHide = (event)=>{
        if (event.type === 'pagehide' || (0, $a279eed6bc86f03b$export$56d8a8a25bd48b81).document?.visibilityState === 'hidden') cb(event);
    };
    (0, $c7a41d5152be2585$export$26d3d892edc56833)('visibilitychange', onHiddenOrPageHide, {
        capture: true,
        once: true
    });
    // Some browsers have buggy implementations of visibilitychange,
    // so we use pagehide in addition, just to be safe.
    (0, $c7a41d5152be2585$export$26d3d892edc56833)('pagehide', onHiddenOrPageHide, {
        capture: true,
        once: true
    });
};


/**
 * Checks if a given value is a valid measurement value.
 */ function $4cc83a6143615466$export$27169ccae1b439e3(value) {
    return typeof value === 'number' && isFinite(value);
}
/**
 * Helper function to start child on transactions. This function will make sure that the transaction will
 * use the start timestamp of the created child span if it is earlier than the transactions actual
 * start timestamp.
 */ function $4cc83a6143615466$export$7567a67bdb69a23d(parentSpan, startTimeInSeconds, endTime, { ...ctx }) {
    const parentStartTime = (0, $bb9b6447bf4caedb$export$92d8c23565496537)(parentSpan).start_timestamp;
    if (parentStartTime && parentStartTime > startTimeInSeconds) // We can only do this for SentrySpans...
    {
        if (typeof parentSpan.updateStartTime === 'function') parentSpan.updateStartTime(startTimeInSeconds);
    }
    // The return value only exists for tests
    return (0, $c9161b67125aefc1$export$e57ac09b143d92a2)(parentSpan, ()=>{
        const span = (0, $c9161b67125aefc1$export$63dbba021a6b4047)({
            startTime: startTimeInSeconds,
            ...ctx
        });
        if (span) span.end(endTime);
        return span;
    });
}
/**
 * Starts an inactive, standalone span used to send web vital values to Sentry.
 * DO NOT use this for arbitrary spans, as these spans require special handling
 * during ingestion to extract metrics.
 *
 * This function adds a bunch of attributes and data to the span that's shared
 * by all web vital standalone spans. However, you need to take care of adding
 * the actual web vital value as an event to the span. Also, you need to assign
 * a transaction name and some other values that are specific to the web vital.
 *
 * Ultimately, you also need to take care of ending the span to send it off.
 *
 * @param options
 *
 * @returns an inactive, standalone and NOT YET ended span
 */ function $4cc83a6143615466$export$b71b9c7b60c5a4aa(options) {
    const client = (0, $7d48e1ed9f699a01$export$6bb76d6eba7e258c)();
    if (!client) return;
    const { name: name, transaction: transaction, attributes: passedAttributes, startTime: startTime } = options;
    const { release: release, environment: environment, sendDefaultPii: sendDefaultPii } = client.getOptions();
    // We need to get the replay, user, and activeTransaction from the current scope
    // so that we can associate replay id, profile id, and a user display to the span
    const replay = client.getIntegrationByName('Replay');
    const replayId = replay?.getReplayId();
    const scope = (0, $7d48e1ed9f699a01$export$c7be4b0125a10cba)();
    const user = scope.getUser();
    const userDisplay = user !== undefined ? user.email || user.id || user.ip_address : undefined;
    let profileId;
    try {
        // @ts-expect-error skip optional chaining to save bundle size with try catch
        profileId = scope.getScopeData().contexts.profile.profile_id;
    } catch  {
    // do nothing
    }
    const attributes = {
        release: release,
        environment: environment,
        user: userDisplay || undefined,
        profile_id: profileId || undefined,
        replay_id: replayId || undefined,
        transaction: transaction,
        // Web vital score calculation relies on the user agent to account for different
        // browsers setting different thresholds for what is considered a good/meh/bad value.
        // For example: Chrome vs. Chrome Mobile
        'user_agent.original': (0, $a279eed6bc86f03b$export$56d8a8a25bd48b81).navigator?.userAgent,
        // This tells Sentry to infer the IP address from the request
        'client.address': sendDefaultPii ? '{{auto}}' : undefined,
        ...passedAttributes
    };
    return (0, $c9161b67125aefc1$export$63dbba021a6b4047)({
        name: name,
        attributes: attributes,
        startTime: startTime,
        experimental: {
            standalone: true
        }
    });
}
/** Get the browser performance API. */ function $4cc83a6143615466$export$f72a13c439a30cab() {
    // @ts-expect-error we want to make sure all of these are available, even if TS is sure they are
    return (0, $a279eed6bc86f03b$export$56d8a8a25bd48b81).addEventListener && (0, $a279eed6bc86f03b$export$56d8a8a25bd48b81).performance;
}
/**
 * Converts from milliseconds to seconds
 * @param time time in ms
 */ function $4cc83a6143615466$export$b4785dbd4a81b33f(time) {
    return time / 1000;
}
/**
 * Converts ALPN protocol ids to name and version.
 *
 * (https://www.iana.org/assignments/tls-extensiontype-values/tls-extensiontype-values.xhtml#alpn-protocol-ids)
 * @param nextHopProtocol PerformanceResourceTiming.nextHopProtocol
 */ function $4cc83a6143615466$export$57c6f824442f9fe1(nextHopProtocol) {
    let name = 'unknown';
    let version = 'unknown';
    let _name = '';
    for (const char of nextHopProtocol){
        // http/1.1 etc.
        if (char === '/') {
            [name, version] = nextHopProtocol.split('/');
            break;
        }
        // h2, h3 etc.
        if (!isNaN(Number(char))) {
            name = _name === 'h' ? 'http' : _name;
            version = nextHopProtocol.split(_name)[1];
            break;
        }
        _name += char;
    }
    if (_name === nextHopProtocol) // webrtc, ftp, etc.
    name = _name;
    return {
        name: name,
        version: version
    };
}
/**
 * Generic support check for web vitals
 */ function $4cc83a6143615466$export$c7533a7b4a9f2e94(entryType) {
    try {
        return PerformanceObserver.supportedEntryTypes.includes(entryType);
    } catch  {
        return false;
    }
}
/**
 * Listens for events on which we want to collect a previously accumulated web vital value.
 * Currently, this includes:
 *
 * - pagehide (i.e. user minimizes browser window, hides tab, etc)
 * - soft navigation (we only care about the vital of the initially loaded route)
 *
 * As a "side-effect", this function will also collect the span id of the pageload span.
 *
 * @param collectorCallback the callback to be called when the first of these events is triggered. Parameters:
 * - event: the event that triggered the reporting of the web vital value.
 * - pageloadSpanId: the span id of the pageload span. This is used to link the web vital span to the pageload span.
 */ function $4cc83a6143615466$export$382ad360b45665ab(client, collectorCallback) {
    let pageloadSpanId;
    let collected = false;
    function _runCollectorCallbackOnce(event) {
        if (!collected && pageloadSpanId) collectorCallback(event, pageloadSpanId);
        collected = true;
    }
    // eslint-disable-next-line deprecation/deprecation
    (0, $88341307c4ec6bb4$export$91ec2be6fdd8f1b4)(()=>{
        _runCollectorCallbackOnce('pagehide');
    });
    const unsubscribeStartNavigation = client.on('beforeStartNavigationSpan', (_, options)=>{
        // we only want to collect LCP if we actually navigate. Redirects should be ignored.
        if (!options?.isRedirect) {
            _runCollectorCallbackOnce('navigation');
            unsubscribeStartNavigation();
            unsubscribeAfterStartPageLoadSpan();
        }
    });
    const unsubscribeAfterStartPageLoadSpan = client.on('afterStartPageLoadSpan', (span)=>{
        pageloadSpanId = span.spanContext().spanId;
        unsubscribeAfterStartPageLoadSpan();
    });
}


function $7d1a2f038f0232fd$var$getAbsoluteTime(time) {
    // falsy values should be preserved so that we can later on drop undefined values and
    // preserve 0 vals for cross-origin resources without proper `Timing-Allow-Origin` header.
    return time ? (((0, $bc81602376c48fa6$export$baf075a948ffc0bf)() || performance.timeOrigin) + time) / 1000 : time;
}
/**
 * Converts a PerformanceResourceTiming entry to span data for the resource span. Most importantly,
 * it converts the timing values from timestamps relative to the `performance.timeOrigin` to absolute timestamps
 * in seconds.
 *
 * @see https://developer.mozilla.org/en-US/docs/Web/API/PerformanceResourceTiming#timestamps
 *
 * @param resourceTiming
 * @returns An array where the first element is the attribute name and the second element is the attribute value.
 */ function $7d1a2f038f0232fd$export$ec50b091612e7e00(resourceTiming) {
    const timingSpanData = {};
    // Checking for only `undefined` and `null` is intentional because it's
    // valid for `nextHopProtocol` to be an empty string.
    if (resourceTiming.nextHopProtocol != undefined) {
        const { name: name, version: version } = (0, $4cc83a6143615466$export$57c6f824442f9fe1)(resourceTiming.nextHopProtocol);
        timingSpanData['network.protocol.version'] = version;
        timingSpanData['network.protocol.name'] = name;
    }
    if (!((0, $bc81602376c48fa6$export$baf075a948ffc0bf)() || (0, $4cc83a6143615466$export$f72a13c439a30cab)()?.timeOrigin)) return timingSpanData;
    return $7d1a2f038f0232fd$var$dropUndefinedKeysFromObject({
        ...timingSpanData,
        'http.request.redirect_start': $7d1a2f038f0232fd$var$getAbsoluteTime(resourceTiming.redirectStart),
        'http.request.redirect_end': $7d1a2f038f0232fd$var$getAbsoluteTime(resourceTiming.redirectEnd),
        'http.request.worker_start': $7d1a2f038f0232fd$var$getAbsoluteTime(resourceTiming.workerStart),
        'http.request.fetch_start': $7d1a2f038f0232fd$var$getAbsoluteTime(resourceTiming.fetchStart),
        'http.request.domain_lookup_start': $7d1a2f038f0232fd$var$getAbsoluteTime(resourceTiming.domainLookupStart),
        'http.request.domain_lookup_end': $7d1a2f038f0232fd$var$getAbsoluteTime(resourceTiming.domainLookupEnd),
        'http.request.connect_start': $7d1a2f038f0232fd$var$getAbsoluteTime(resourceTiming.connectStart),
        'http.request.secure_connection_start': $7d1a2f038f0232fd$var$getAbsoluteTime(resourceTiming.secureConnectionStart),
        'http.request.connection_end': $7d1a2f038f0232fd$var$getAbsoluteTime(resourceTiming.connectEnd),
        'http.request.request_start': $7d1a2f038f0232fd$var$getAbsoluteTime(resourceTiming.requestStart),
        'http.request.response_start': $7d1a2f038f0232fd$var$getAbsoluteTime(resourceTiming.responseStart),
        'http.request.response_end': $7d1a2f038f0232fd$var$getAbsoluteTime(resourceTiming.responseEnd),
        // For TTFB we actually want the relative time from timeOrigin to responseStart
        // This way, TTFB always measures the "first page load" experience.
        // see: https://web.dev/articles/ttfb#measure-resource-requests
        'http.request.time_to_first_byte': resourceTiming.responseStart != null ? resourceTiming.responseStart / 1000 : undefined
    });
}
/**
 * Remove properties with `undefined` as value from an object.
 * In contrast to `dropUndefinedKeys` in core this funciton only works on first-level
 * key-value objects and does not recursively go into object properties or arrays.
 */ function $7d1a2f038f0232fd$var$dropUndefinedKeysFromObject(attrs) {
    return Object.fromEntries(Object.entries(attrs).filter(([, value])=>value != null));
}



/**
 * Checks if the baggage header has Sentry values.
 */ function $ddee3d8e773cae02$export$8193ac587e359dc0(baggageHeader) {
    return baggageHeader.split(',').some((value)=>value.trim().startsWith('sentry-'));
}
/**
 * Gets the full URL from a given URL string.
 */ function $ddee3d8e773cae02$export$f2a087db7564c909(url) {
    try {
        // By adding a base URL to new URL(), this will also work for relative urls
        // If `url` is a full URL, the base URL is ignored anyhow
        const parsed = new URL(url, (0, $e62dec891f31852b$export$56d8a8a25bd48b81).location.origin);
        return parsed.href;
    } catch  {
        return undefined;
    }
}
/**
 * Checks if the entry is a PerformanceResourceTiming.
 */ function $ddee3d8e773cae02$export$5803eedf1027ce61(entry) {
    return entry.entryType === 'resource' && 'initiatorType' in entry && typeof entry.nextHopProtocol === 'string' && (entry.initiatorType === 'fetch' || entry.initiatorType === 'xmlhttprequest');
}
/**
 * Creates a Headers object from a record of string key-value pairs, and returns undefined if it fails.
 */ function $ddee3d8e773cae02$export$9dc5b8b2fb320da0(headers) {
    try {
        return new Headers(headers);
    } catch  {
        // noop
        return undefined;
    }
}


/** Options for Request Instrumentation */ const $b3e0e430d6ae504d$var$responseToSpanId = new WeakMap();
const $b3e0e430d6ae504d$var$spanIdToEndTimestamp = new Map();
const $b3e0e430d6ae504d$export$cc17fb3c0bc95cd7 = {
    traceFetch: true,
    traceXHR: true,
    enableHTTPTimings: true,
    trackFetchStreamPerformance: false
};
/** Registers span creators for xhr and fetch requests  */ function $b3e0e430d6ae504d$export$864489cb3478db3e(client, _options) {
    const { traceFetch: traceFetch, traceXHR: traceXHR, trackFetchStreamPerformance: trackFetchStreamPerformance, shouldCreateSpanForRequest: shouldCreateSpanForRequest, enableHTTPTimings: enableHTTPTimings, tracePropagationTargets: tracePropagationTargets, onRequestSpanStart: onRequestSpanStart, onRequestSpanEnd: onRequestSpanEnd } = {
        ...$b3e0e430d6ae504d$export$cc17fb3c0bc95cd7,
        ..._options
    };
    const shouldCreateSpan = typeof shouldCreateSpanForRequest === 'function' ? shouldCreateSpanForRequest : (_)=>true;
    const shouldAttachHeadersWithTargets = (url)=>$b3e0e430d6ae504d$export$c260386ab3f0b3dd(url, tracePropagationTargets);
    const spans = {};
    const propagateTraceparent = client.getOptions().propagateTraceparent;
    if (traceFetch) {
        // Keeping track of http requests, whose body payloads resolved later than the initial resolved request
        // e.g. streaming using server sent events (SSE)
        client.addEventProcessor((event)=>{
            if (event.type === 'transaction' && event.spans) event.spans.forEach((span)=>{
                if (span.op === 'http.client') {
                    const updatedTimestamp = $b3e0e430d6ae504d$var$spanIdToEndTimestamp.get(span.span_id);
                    if (updatedTimestamp) {
                        span.timestamp = updatedTimestamp / 1000;
                        $b3e0e430d6ae504d$var$spanIdToEndTimestamp.delete(span.span_id);
                    }
                }
            });
            return event;
        });
        if (trackFetchStreamPerformance) (0, $d5ff33466750b470$export$1a79663eb318fe6a)((handlerData)=>{
            if (handlerData.response) {
                const span = $b3e0e430d6ae504d$var$responseToSpanId.get(handlerData.response);
                if (span && handlerData.endTimestamp) $b3e0e430d6ae504d$var$spanIdToEndTimestamp.set(span, handlerData.endTimestamp);
            }
        });
        (0, $d5ff33466750b470$export$f75d3c772c923df0)((handlerData)=>{
            const createdSpan = (0, $0ce265c2131fdf7a$export$6d73c62358c655be)(handlerData, shouldCreateSpan, shouldAttachHeadersWithTargets, spans, {
                propagateTraceparent: propagateTraceparent,
                onRequestSpanEnd: onRequestSpanEnd
            });
            if (handlerData.response && handlerData.fetchData.__span) $b3e0e430d6ae504d$var$responseToSpanId.set(handlerData.response, handlerData.fetchData.__span);
            // We cannot use `window.location` in the generic fetch instrumentation,
            // but we need it for reliable `server.address` attribute.
            // so we extend this in here
            if (createdSpan) {
                const fullUrl = (0, $ddee3d8e773cae02$export$f2a087db7564c909)(handlerData.fetchData.url);
                const host = fullUrl ? (0, $0c1b93525a804899$export$7a5253c0f62e0150)(fullUrl).host : undefined;
                createdSpan.setAttributes({
                    'http.url': fullUrl ? (0, $0c1b93525a804899$export$8abd806fcaf234fa)(fullUrl) : undefined,
                    'server.address': host
                });
                if (enableHTTPTimings) $b3e0e430d6ae504d$var$addHTTPTimings(createdSpan);
                onRequestSpanStart?.(createdSpan, {
                    headers: handlerData.headers
                });
            }
        });
    }
    if (traceXHR) (0, $a83999f742846a08$export$26ace48dd54c9aea)((handlerData)=>{
        const createdSpan = $b3e0e430d6ae504d$var$xhrCallback(handlerData, shouldCreateSpan, shouldAttachHeadersWithTargets, spans, propagateTraceparent, onRequestSpanEnd);
        if (createdSpan) {
            if (enableHTTPTimings) $b3e0e430d6ae504d$var$addHTTPTimings(createdSpan);
            onRequestSpanStart?.(createdSpan, {
                headers: (0, $ddee3d8e773cae02$export$9dc5b8b2fb320da0)(handlerData.xhr.__sentry_xhr_v3__?.request_headers)
            });
        }
    });
}
/**
 * Creates a temporary observer to listen to the next fetch/xhr resourcing timings,
 * so that when timings hit their per-browser limit they don't need to be removed.
 *
 * @param span A span that has yet to be finished, must contain `url` on data.
 */ function $b3e0e430d6ae504d$var$addHTTPTimings(span) {
    const { url: url } = (0, $bb9b6447bf4caedb$export$92d8c23565496537)(span).data;
    if (!url || typeof url !== 'string') return;
    const cleanup = (0, $f28dee024a5f97b7$export$69816c1a049f8db6)('resource', ({ entries: entries })=>{
        entries.forEach((entry)=>{
            if ((0, $ddee3d8e773cae02$export$5803eedf1027ce61)(entry) && entry.name.endsWith(url)) {
                span.setAttributes((0, $7d1a2f038f0232fd$export$ec50b091612e7e00)(entry));
                // In the next tick, clean this handler up
                // We have to wait here because otherwise this cleans itself up before it is fully done
                setTimeout(cleanup);
            }
        });
    });
}
/**
 * A function that determines whether to attach tracing headers to a request.
 * We only export this function for testing purposes.
 */ function $b3e0e430d6ae504d$export$c260386ab3f0b3dd(targetUrl, tracePropagationTargets) {
    // window.location.href not being defined is an edge case in the browser but we need to handle it.
    // Potentially dangerous situations where it may not be defined: Browser Extensions, Web Workers, patching of the location obj
    const href = (0, $caac489b9d8395b2$export$1cfafeee2987818b)();
    if (!href) {
        // If there is no window.location.origin, we default to only attaching tracing headers to relative requests, i.e. ones that start with `/`
        // BIG DISCLAIMER: Users can call URLs with a double slash (fetch("//example.com/api")), this is a shorthand for "send to the same protocol",
        // so we need a to exclude those requests, because they might be cross origin.
        const isRelativeSameOriginRequest = !!targetUrl.match(/^\/(?!\/)/);
        if (!tracePropagationTargets) return isRelativeSameOriginRequest;
        else return (0, $e534db390d1e4996$export$a7a5ec66062ea5d)(targetUrl, tracePropagationTargets);
    } else {
        let resolvedUrl;
        let currentOrigin;
        // URL parsing may fail, we default to not attaching trace headers in that case.
        try {
            resolvedUrl = new URL(targetUrl, href);
            currentOrigin = new URL(href).origin;
        } catch  {
            return false;
        }
        const isSameOriginRequest = resolvedUrl.origin === currentOrigin;
        if (!tracePropagationTargets) return isSameOriginRequest;
        else return (0, $e534db390d1e4996$export$a7a5ec66062ea5d)(resolvedUrl.toString(), tracePropagationTargets) || isSameOriginRequest && (0, $e534db390d1e4996$export$a7a5ec66062ea5d)(resolvedUrl.pathname, tracePropagationTargets);
    }
}
/**
 * Create and track xhr request spans
 *
 * @returns Span if a span was created, otherwise void.
 */ function $b3e0e430d6ae504d$var$xhrCallback(handlerData, shouldCreateSpan, shouldAttachHeaders, spans, propagateTraceparent, onRequestSpanEnd) {
    const xhr = handlerData.xhr;
    const sentryXhrData = xhr?.[0, $a83999f742846a08$export$55b6bb1e45c6cf59];
    if (!xhr || xhr.__sentry_own_request__ || !sentryXhrData) return undefined;
    const { url: url, method: method } = sentryXhrData;
    const shouldCreateSpanResult = (0, $e3827447d651dfc5$export$1f70765132c3c225)() && shouldCreateSpan(url);
    // Handle XHR completion - clean up spans from the record
    if (handlerData.endTimestamp) {
        const spanId = xhr.__sentry_xhr_span_id__;
        if (!spanId) return;
        const span = spans[spanId];
        if (span) {
            if (shouldCreateSpanResult && sentryXhrData.status_code !== undefined) {
                (0, $fda37f10dc06a152$export$2ad6630ec8164254)(span, sentryXhrData.status_code);
                span.end();
                onRequestSpanEnd?.(span, {
                    headers: (0, $ddee3d8e773cae02$export$9dc5b8b2fb320da0)((0, $e82a9c6161ef9dbd$export$ce71c337afb62ea)(xhr)),
                    error: handlerData.error
                });
            }
            // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
            delete spans[spanId];
        }
        return undefined;
    }
    const fullUrl = (0, $ddee3d8e773cae02$export$f2a087db7564c909)(url);
    const parsedUrl = fullUrl ? (0, $0c1b93525a804899$export$7a5253c0f62e0150)(fullUrl) : (0, $0c1b93525a804899$export$7a5253c0f62e0150)(url);
    const urlForSpanName = (0, $0c1b93525a804899$export$8abd806fcaf234fa)((0, $0c1b93525a804899$export$ce084c78234bd35)(url));
    const hasParent = !!(0, $bb9b6447bf4caedb$export$1be426a8e585c83e)();
    const span = shouldCreateSpanResult && hasParent ? (0, $c9161b67125aefc1$export$63dbba021a6b4047)({
        name: `${method} ${urlForSpanName}`,
        attributes: {
            url: (0, $0c1b93525a804899$export$8abd806fcaf234fa)(url),
            type: 'xhr',
            'http.method': method,
            'http.url': fullUrl ? (0, $0c1b93525a804899$export$8abd806fcaf234fa)(fullUrl) : undefined,
            'server.address': parsedUrl?.host,
            [(0, $f337c80285f06f80$export$cca8dd30f57f805e)]: 'auto.http.browser',
            [(0, $f337c80285f06f80$export$1a413bd9a88fdb09)]: 'http.client',
            ...parsedUrl?.search && {
                'http.query': parsedUrl?.search
            },
            ...parsedUrl?.hash && {
                'http.fragment': parsedUrl?.hash
            }
        }
    }) : new (0, $057104436ef6f1c5$export$d6636b700b76c516)();
    xhr.__sentry_xhr_span_id__ = span.spanContext().spanId;
    spans[xhr.__sentry_xhr_span_id__] = span;
    if (shouldAttachHeaders(url)) $b3e0e430d6ae504d$var$addTracingHeadersToXhrRequest(xhr, // If performance is disabled (TWP) or there's no active root span (pageload/navigation/interaction),
    // we do not want to use the span as base for the trace headers,
    // which means that the headers will be generated from the scope and the sampling decision is deferred
    (0, $e3827447d651dfc5$export$1f70765132c3c225)() && hasParent ? span : undefined, propagateTraceparent);
    const client = (0, $7d48e1ed9f699a01$export$6bb76d6eba7e258c)();
    if (client) client.emit('beforeOutgoingRequestSpan', span, handlerData);
    return span;
}
function $b3e0e430d6ae504d$var$addTracingHeadersToXhrRequest(xhr, span, propagateTraceparent) {
    const { 'sentry-trace': sentryTrace, baggage: baggage, traceparent: traceparent } = (0, $9086b800c08a7b68$export$dec8f001b9d982cb)({
        span: span,
        propagateTraceparent: propagateTraceparent
    });
    if (sentryTrace) $b3e0e430d6ae504d$var$setHeaderOnXhr(xhr, sentryTrace, baggage, traceparent);
}
function $b3e0e430d6ae504d$var$setHeaderOnXhr(xhr, sentryTraceHeader, sentryBaggageHeader, traceparentHeader) {
    const originalHeaders = xhr.__sentry_xhr_v3__?.request_headers;
    if (originalHeaders?.['sentry-trace'] || !xhr.setRequestHeader) // bail if a sentry-trace header is already set
    return;
    try {
        xhr.setRequestHeader('sentry-trace', sentryTraceHeader);
        if (traceparentHeader && !originalHeaders?.['traceparent']) xhr.setRequestHeader('traceparent', traceparentHeader);
        if (sentryBaggageHeader) {
            // only add our headers if
            // - no pre-existing baggage header exists
            // - or it is set and doesn't yet contain sentry values
            const originalBaggageHeader = originalHeaders?.['baggage'];
            if (!originalBaggageHeader || !(0, $ddee3d8e773cae02$export$8193ac587e359dc0)(originalBaggageHeader)) // From MDN: "If this method is called several times with the same header, the values are merged into one single request header."
            // We can therefore simply set a baggage header without checking what was there before
            // https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest/setRequestHeader
            xhr.setRequestHeader('baggage', sentryBaggageHeader);
        }
    } catch  {
    // Error: InvalidStateError: Failed to execute 'setRequestHeader' on 'XMLHttpRequest': The object's state must be OPENED.
    }
}
















const $136666061888e579$export$809a2b7987fd5306 = {
    idleTimeout: 1000,
    finalTimeout: 30000,
    childSpanTimeout: 15000
};
const $136666061888e579$var$FINISH_REASON_HEARTBEAT_FAILED = 'heartbeatFailed';
const $136666061888e579$var$FINISH_REASON_IDLE_TIMEOUT = 'idleTimeout';
const $136666061888e579$var$FINISH_REASON_FINAL_TIMEOUT = 'finalTimeout';
const $136666061888e579$var$FINISH_REASON_EXTERNAL_FINISH = 'externalFinish';
/**
 * An idle span is a span that automatically finishes. It does this by tracking child spans as activities.
 * An idle span is always the active span.
 */ function $136666061888e579$export$901bffd97bd52797(startSpanOptions, options = {}) {
    // Activities store a list of active spans
    const activities = new Map();
    // We should not use heartbeat if we finished a span
    let _finished = false;
    // Timer that tracks idleTimeout
    let _idleTimeoutID;
    // The reason why the span was finished
    let _finishReason = $136666061888e579$var$FINISH_REASON_EXTERNAL_FINISH;
    let _autoFinishAllowed = !options.disableAutoFinish;
    const _cleanupHooks = [];
    const { idleTimeout: idleTimeout = $136666061888e579$export$809a2b7987fd5306.idleTimeout, finalTimeout: finalTimeout = $136666061888e579$export$809a2b7987fd5306.finalTimeout, childSpanTimeout: childSpanTimeout = $136666061888e579$export$809a2b7987fd5306.childSpanTimeout, beforeSpanEnd: beforeSpanEnd, trimIdleSpanEndTimestamp: trimIdleSpanEndTimestamp = true } = options;
    const client = (0, $7d48e1ed9f699a01$export$6bb76d6eba7e258c)();
    if (!client || !(0, $e3827447d651dfc5$export$1f70765132c3c225)()) {
        const span = new (0, $057104436ef6f1c5$export$d6636b700b76c516)();
        const dsc = {
            sample_rate: '0',
            sampled: 'false',
            ...(0, $09fae5ef8120e803$export$a117f995597e25df)(span)
        };
        (0, $09fae5ef8120e803$export$7398c93e763ca9fd)(span, dsc);
        return span;
    }
    const scope = (0, $7d48e1ed9f699a01$export$c7be4b0125a10cba)();
    const previousActiveSpan = (0, $bb9b6447bf4caedb$export$1be426a8e585c83e)();
    const span = $136666061888e579$var$_startIdleSpan(startSpanOptions);
    // We patch span.end to ensure we can run some things before the span is ended
    // eslint-disable-next-line @typescript-eslint/unbound-method
    span.end = new Proxy(span.end, {
        apply (target, thisArg, args) {
            if (beforeSpanEnd) beforeSpanEnd(span);
            // If the span is non-recording, nothing more to do here...
            // This is the case if tracing is enabled but this specific span was not sampled
            if (thisArg instanceof (0, $057104436ef6f1c5$export$d6636b700b76c516)) return;
            // Just ensuring that this keeps working, even if we ever have more arguments here
            const [definedEndTimestamp, ...rest] = args;
            const timestamp = definedEndTimestamp || (0, $bc81602376c48fa6$export$ee52dced521e3e18)();
            const spanEndTimestamp = (0, $bb9b6447bf4caedb$export$3f7581298f56c6d7)(timestamp);
            // Ensure we end with the last span timestamp, if possible
            const spans = (0, $bb9b6447bf4caedb$export$340c5c8a13ffc680)(span).filter((child)=>child !== span);
            const spanJson = (0, $bb9b6447bf4caedb$export$92d8c23565496537)(span);
            // If we have no spans, we just end, nothing else to do here
            // Likewise, if users explicitly ended the span, we simply end the span without timestamp adjustment
            if (!spans.length || !trimIdleSpanEndTimestamp) {
                onIdleSpanEnded(spanEndTimestamp);
                return Reflect.apply(target, thisArg, [
                    spanEndTimestamp,
                    ...rest
                ]);
            }
            const ignoreSpans = client.getOptions().ignoreSpans;
            const latestSpanEndTimestamp = spans?.reduce((acc, current)=>{
                const currentSpanJson = (0, $bb9b6447bf4caedb$export$92d8c23565496537)(current);
                if (!currentSpanJson.timestamp) return acc;
                // Ignored spans will get dropped later (in the client) but since we already adjust
                // the idle span end timestamp here, we can already take to-be-ignored spans out of
                // the calculation here.
                if (ignoreSpans && (0, $18bf74fc9ecc8708$export$5d569ac97c389400)(currentSpanJson, ignoreSpans)) return acc;
                return acc ? Math.max(acc, currentSpanJson.timestamp) : currentSpanJson.timestamp;
            }, undefined);
            // In reality this should always exist here, but type-wise it may be undefined...
            const spanStartTimestamp = spanJson.start_timestamp;
            // The final endTimestamp should:
            // * Never be before the span start timestamp
            // * Be the latestSpanEndTimestamp, if there is one, and it is smaller than the passed span end timestamp
            // * Otherwise be the passed end timestamp
            // Final timestamp can never be after finalTimeout
            const endTimestamp = Math.min(spanStartTimestamp ? spanStartTimestamp + finalTimeout / 1000 : Infinity, Math.max(spanStartTimestamp || -Infinity, Math.min(spanEndTimestamp, latestSpanEndTimestamp || Infinity)));
            onIdleSpanEnded(endTimestamp);
            return Reflect.apply(target, thisArg, [
                endTimestamp,
                ...rest
            ]);
        }
    });
    /**
   * Cancels the existing idle timeout, if there is one.
   */ function _cancelIdleTimeout() {
        if (_idleTimeoutID) {
            clearTimeout(_idleTimeoutID);
            _idleTimeoutID = undefined;
        }
    }
    /**
   * Restarts idle timeout, if there is no running idle timeout it will start one.
   */ function _restartIdleTimeout(endTimestamp) {
        _cancelIdleTimeout();
        _idleTimeoutID = setTimeout(()=>{
            if (!_finished && activities.size === 0 && _autoFinishAllowed) {
                _finishReason = $136666061888e579$var$FINISH_REASON_IDLE_TIMEOUT;
                span.end(endTimestamp);
            }
        }, idleTimeout);
    }
    /**
   * Restarts child span timeout, if there is none running it will start one.
   */ function _restartChildSpanTimeout(endTimestamp) {
        _idleTimeoutID = setTimeout(()=>{
            if (!_finished && _autoFinishAllowed) {
                _finishReason = $136666061888e579$var$FINISH_REASON_HEARTBEAT_FAILED;
                span.end(endTimestamp);
            }
        }, childSpanTimeout);
    }
    /**
   * Start tracking a specific activity.
   * @param spanId The span id that represents the activity
   */ function _pushActivity(spanId) {
        _cancelIdleTimeout();
        activities.set(spanId, true);
        const endTimestamp = (0, $bc81602376c48fa6$export$ee52dced521e3e18)();
        // We need to add the timeout here to have the real endtimestamp of the idle span
        // Remember timestampInSeconds is in seconds, timeout is in ms
        _restartChildSpanTimeout(endTimestamp + childSpanTimeout / 1000);
    }
    /**
   * Remove an activity from usage
   * @param spanId The span id that represents the activity
   */ function _popActivity(spanId) {
        if (activities.has(spanId)) activities.delete(spanId);
        if (activities.size === 0) {
            const endTimestamp = (0, $bc81602376c48fa6$export$ee52dced521e3e18)();
            // We need to add the timeout here to have the real endtimestamp of the idle span
            // Remember timestampInSeconds is in seconds, timeout is in ms
            _restartIdleTimeout(endTimestamp + idleTimeout / 1000);
        }
    }
    function onIdleSpanEnded(endTimestamp) {
        _finished = true;
        activities.clear();
        _cleanupHooks.forEach((cleanup)=>cleanup());
        (0, $dab1970d0c142a42$export$3f25fa50c18e20ca)(scope, previousActiveSpan);
        const spanJSON = (0, $bb9b6447bf4caedb$export$92d8c23565496537)(span);
        const { start_timestamp: startTimestamp } = spanJSON;
        // This should never happen, but to make TS happy...
        if (!startTimestamp) return;
        const attributes = spanJSON.data;
        if (!attributes[0, $f337c80285f06f80$export$ba73f34502b7a3b3]) span.setAttribute((0, $f337c80285f06f80$export$ba73f34502b7a3b3), _finishReason);
        // Set span status to 'ok' if it hasn't been explicitly set to an error status
        const currentStatus = spanJSON.status;
        if (!currentStatus || currentStatus === 'unknown') span.setStatus({
            code: (0, $fda37f10dc06a152$export$58f7963109c806fc)
        });
        (0, $d11ed0b3cdda6b8d$export$1c9f709888824e05).log(`[Tracing] Idle span "${spanJSON.op}" finished`);
        const childSpans = (0, $bb9b6447bf4caedb$export$340c5c8a13ffc680)(span).filter((child)=>child !== span);
        let discardedSpans = 0;
        childSpans.forEach((childSpan)=>{
            // We cancel all pending spans with status "cancelled" to indicate the idle span was finished early
            if (childSpan.isRecording()) {
                childSpan.setStatus({
                    code: (0, $fda37f10dc06a152$export$f966a0446ece71e),
                    message: 'cancelled'
                });
                childSpan.end(endTimestamp);
                (0, $19fdbaf7f0830971$export$16a28057038b10ef) && (0, $d11ed0b3cdda6b8d$export$1c9f709888824e05).log('[Tracing] Cancelling span since span ended early', JSON.stringify(childSpan, undefined, 2));
            }
            const childSpanJSON = (0, $bb9b6447bf4caedb$export$92d8c23565496537)(childSpan);
            const { timestamp: childEndTimestamp = 0, start_timestamp: childStartTimestamp = 0 } = childSpanJSON;
            const spanStartedBeforeIdleSpanEnd = childStartTimestamp <= endTimestamp;
            // Add a delta with idle timeout so that we prevent false positives
            const timeoutWithMarginOfError = (finalTimeout + idleTimeout) / 1000;
            const spanEndedBeforeFinalTimeout = childEndTimestamp - childStartTimestamp <= timeoutWithMarginOfError;
            if (0, $19fdbaf7f0830971$export$16a28057038b10ef) {
                const stringifiedSpan = JSON.stringify(childSpan, undefined, 2);
                if (!spanStartedBeforeIdleSpanEnd) (0, $d11ed0b3cdda6b8d$export$1c9f709888824e05).log('[Tracing] Discarding span since it happened after idle span was finished', stringifiedSpan);
                else if (!spanEndedBeforeFinalTimeout) (0, $d11ed0b3cdda6b8d$export$1c9f709888824e05).log('[Tracing] Discarding span since it finished after idle span final timeout', stringifiedSpan);
            }
            if (!spanEndedBeforeFinalTimeout || !spanStartedBeforeIdleSpanEnd) {
                (0, $bb9b6447bf4caedb$export$c2a0c9438bb89d91)(span, childSpan);
                discardedSpans++;
            }
        });
        if (discardedSpans > 0) span.setAttribute('sentry.idle_span_discarded_spans', discardedSpans);
    }
    _cleanupHooks.push(client.on('spanStart', (startedSpan)=>{
        // If we already finished the idle span,
        // or if this is the idle span itself being started,
        // or if the started span has already been closed,
        // we don't care about it for activity
        if (_finished || startedSpan === span || !!(0, $bb9b6447bf4caedb$export$92d8c23565496537)(startedSpan).timestamp || startedSpan instanceof (0, $32284c1a43c550a4$export$a92149b045260d9f) && startedSpan.isStandaloneSpan()) return;
        const allSpans = (0, $bb9b6447bf4caedb$export$340c5c8a13ffc680)(span);
        // If the span that was just started is a child of the idle span, we should track it
        if (allSpans.includes(startedSpan)) _pushActivity(startedSpan.spanContext().spanId);
    }));
    _cleanupHooks.push(client.on('spanEnd', (endedSpan)=>{
        if (_finished) return;
        _popActivity(endedSpan.spanContext().spanId);
    }));
    _cleanupHooks.push(client.on('idleSpanEnableAutoFinish', (spanToAllowAutoFinish)=>{
        if (spanToAllowAutoFinish === span) {
            _autoFinishAllowed = true;
            _restartIdleTimeout();
            if (activities.size) _restartChildSpanTimeout();
        }
    }));
    // We only start the initial idle timeout if we are not delaying the auto finish
    if (!options.disableAutoFinish) _restartIdleTimeout();
    setTimeout(()=>{
        if (!_finished) {
            span.setStatus({
                code: (0, $fda37f10dc06a152$export$f966a0446ece71e),
                message: 'deadline_exceeded'
            });
            _finishReason = $136666061888e579$var$FINISH_REASON_FINAL_TIMEOUT;
            span.end();
        }
    }, finalTimeout);
    return span;
}
function $136666061888e579$var$_startIdleSpan(options) {
    const span = (0, $c9161b67125aefc1$export$63dbba021a6b4047)(options);
    (0, $dab1970d0c142a42$export$3f25fa50c18e20ca)((0, $7d48e1ed9f699a01$export$c7be4b0125a10cba)(), span);
    (0, $19fdbaf7f0830971$export$16a28057038b10ef) && (0, $d11ed0b3cdda6b8d$export$1c9f709888824e05).log('[Tracing] Started span is an idle span');
    return span;
}








/**
 * Starts tracking the Cumulative Layout Shift on the current page and collects the value once
 *
 * - the page visibility is hidden
 * - a navigation span is started (to stop CLS measurement for SPA soft navigations)
 *
 * Once either of these events triggers, the CLS value is sent as a standalone span and we stop
 * measuring CLS.
 */ function $4f9ee141a350e957$export$585bab03c6c18c45(client) {
    let standaloneCLsValue = 0;
    let standaloneClsEntry;
    if (!(0, $4cc83a6143615466$export$c7533a7b4a9f2e94)('layout-shift')) return;
    const cleanupClsHandler = (0, $f28dee024a5f97b7$export$861b82818b37ba5b)(({ metric: metric })=>{
        const entry = metric.entries[metric.entries.length - 1];
        if (!entry) return;
        standaloneCLsValue = metric.value;
        standaloneClsEntry = entry;
    }, true);
    (0, $4cc83a6143615466$export$382ad360b45665ab)(client, (reportEvent, pageloadSpanId)=>{
        $4f9ee141a350e957$export$910bd4e865129f07(standaloneCLsValue, standaloneClsEntry, pageloadSpanId, reportEvent);
        cleanupClsHandler();
    });
}
/**
 * Exported only for testing!
 */ function $4f9ee141a350e957$export$910bd4e865129f07(clsValue, entry, pageloadSpanId, reportEvent) {
    (0, $52f4069f580f537e$export$16a28057038b10ef) && (0, $d11ed0b3cdda6b8d$export$1c9f709888824e05).log(`Sending CLS span (${clsValue})`);
    const startTime = entry ? (0, $4cc83a6143615466$export$b4785dbd4a81b33f)(((0, $bc81602376c48fa6$export$baf075a948ffc0bf)() || 0) + entry.startTime) : (0, $bc81602376c48fa6$export$ee52dced521e3e18)();
    const routeName = (0, $7d48e1ed9f699a01$export$c7be4b0125a10cba)().getScopeData().transactionName;
    const name = entry ? (0, $caac489b9d8395b2$export$5647df6b7814ac86)(entry.sources[0]?.node) : 'Layout shift';
    const attributes = {
        [(0, $f337c80285f06f80$export$cca8dd30f57f805e)]: 'auto.http.browser.cls',
        [(0, $f337c80285f06f80$export$1a413bd9a88fdb09)]: 'ui.webvital.cls',
        [(0, $f337c80285f06f80$export$fea48ba9f4550879)]: 0,
        // attach the pageload span id to the CLS span so that we can link them in the UI
        'sentry.pageload.span_id': pageloadSpanId,
        // describes what triggered the web vital to be reported
        'sentry.report_event': reportEvent
    };
    // Add CLS sources as span attributes to help with debugging layout shifts
    // See: https://developer.mozilla.org/en-US/docs/Web/API/LayoutShift/sources
    if (entry?.sources) entry.sources.forEach((source, index)=>{
        attributes[`cls.source.${index + 1}`] = (0, $caac489b9d8395b2$export$5647df6b7814ac86)(source.node);
    });
    const span = (0, $4cc83a6143615466$export$b71b9c7b60c5a4aa)({
        name: name,
        transaction: routeName,
        attributes: attributes,
        startTime: startTime
    });
    if (span) {
        span.addEvent('cls', {
            [(0, $f337c80285f06f80$export$f5f95cff026507b5)]: '',
            [(0, $f337c80285f06f80$export$69cd5c610c7bb96a)]: clsValue
        });
        // LayoutShift performance entries always have a duration of 0, so we don't need to add `entry.duration` here
        // see: https://developer.mozilla.org/en-US/docs/Web/API/PerformanceEntry/duration
        span.end(startTime);
    }
}







/**
 * Starts tracking the Largest Contentful Paint on the current page and collects the value once
 *
 * - the page visibility is hidden
 * - a navigation span is started (to stop LCP measurement for SPA soft navigations)
 *
 * Once either of these events triggers, the LCP value is sent as a standalone span and we stop
 * measuring LCP for subsequent routes.
 */ function $91505762751dec1a$export$485112b2cb5f79dc(client) {
    let standaloneLcpValue = 0;
    let standaloneLcpEntry;
    if (!(0, $4cc83a6143615466$export$c7533a7b4a9f2e94)('largest-contentful-paint')) return;
    const cleanupLcpHandler = (0, $f28dee024a5f97b7$export$3fd4b53331200102)(({ metric: metric })=>{
        const entry = metric.entries[metric.entries.length - 1];
        if (!entry) return;
        standaloneLcpValue = metric.value;
        standaloneLcpEntry = entry;
    }, true);
    (0, $4cc83a6143615466$export$382ad360b45665ab)(client, (reportEvent, pageloadSpanId)=>{
        $91505762751dec1a$export$1c28dab7ad4ec937(standaloneLcpValue, standaloneLcpEntry, pageloadSpanId, reportEvent);
        cleanupLcpHandler();
    });
}
/**
 * Exported only for testing!
 */ function $91505762751dec1a$export$1c28dab7ad4ec937(lcpValue, entry, pageloadSpanId, reportEvent) {
    (0, $52f4069f580f537e$export$16a28057038b10ef) && (0, $d11ed0b3cdda6b8d$export$1c9f709888824e05).log(`Sending LCP span (${lcpValue})`);
    const startTime = (0, $4cc83a6143615466$export$b4785dbd4a81b33f)(((0, $bc81602376c48fa6$export$baf075a948ffc0bf)() || 0) + (entry?.startTime || 0));
    const routeName = (0, $7d48e1ed9f699a01$export$c7be4b0125a10cba)().getScopeData().transactionName;
    const name = entry ? (0, $caac489b9d8395b2$export$5647df6b7814ac86)(entry.element) : 'Largest contentful paint';
    const attributes = {
        [(0, $f337c80285f06f80$export$cca8dd30f57f805e)]: 'auto.http.browser.lcp',
        [(0, $f337c80285f06f80$export$1a413bd9a88fdb09)]: 'ui.webvital.lcp',
        [(0, $f337c80285f06f80$export$fea48ba9f4550879)]: 0,
        // attach the pageload span id to the LCP span so that we can link them in the UI
        'sentry.pageload.span_id': pageloadSpanId,
        // describes what triggered the web vital to be reported
        'sentry.report_event': reportEvent
    };
    if (entry) {
        entry.element && (attributes['lcp.element'] = (0, $caac489b9d8395b2$export$5647df6b7814ac86)(entry.element));
        entry.id && (attributes['lcp.id'] = entry.id);
        entry.url && (attributes['lcp.url'] = entry.url);
        // loadTime is the time of LCP that's related to receiving the LCP element response..
        entry.loadTime != null && (attributes['lcp.loadTime'] = entry.loadTime);
        // renderTime is loadTime + rendering time
        // it's 0 if the LCP element is loaded from a 3rd party origin that doesn't send the
        // `Timing-Allow-Origin` header.
        entry.renderTime != null && (attributes['lcp.renderTime'] = entry.renderTime);
        entry.size != null && (attributes['lcp.size'] = entry.size);
    }
    const span = (0, $4cc83a6143615466$export$b71b9c7b60c5a4aa)({
        name: name,
        transaction: routeName,
        attributes: attributes,
        startTime: startTime
    });
    if (span) {
        span.addEvent('lcp', {
            [(0, $f337c80285f06f80$export$f5f95cff026507b5)]: 'millisecond',
            [(0, $f337c80285f06f80$export$69cd5c610c7bb96a)]: lcpValue
        });
        // LCP is a point-in-time metric, so we end the span immediately
        span.end(startTime);
    }
}







const $540e2256a3cced48$var$MAX_INT_AS_BYTES = 2147483647;
let $540e2256a3cced48$var$_performanceCursor = 0;
let $540e2256a3cced48$var$_measurements = {};
let $540e2256a3cced48$var$_lcpEntry;
let $540e2256a3cced48$var$_clsEntry;
/**
 * Start tracking web vitals.
 * The callback returned by this function can be used to stop tracking & ensure all measurements are final & captured.
 *
 * @returns A function that forces web vitals collection
 */ function $540e2256a3cced48$export$7c69f0412d101b88({ recordClsStandaloneSpans: recordClsStandaloneSpans, recordLcpStandaloneSpans: recordLcpStandaloneSpans, client: client }) {
    const performance = (0, $4cc83a6143615466$export$f72a13c439a30cab)();
    if (performance && (0, $bc81602376c48fa6$export$baf075a948ffc0bf)()) {
        // @ts-expect-error we want to make sure all of these are available, even if TS is sure they are
        if (performance.mark) (0, $a279eed6bc86f03b$export$56d8a8a25bd48b81).performance.mark('sentry-tracing-init');
        const lcpCleanupCallback = recordLcpStandaloneSpans ? (0, $91505762751dec1a$export$485112b2cb5f79dc)(client) : $540e2256a3cced48$var$_trackLCP();
        const ttfbCleanupCallback = $540e2256a3cced48$var$_trackTtfb();
        const clsCleanupCallback = recordClsStandaloneSpans ? (0, $4f9ee141a350e957$export$585bab03c6c18c45)(client) : $540e2256a3cced48$var$_trackCLS();
        return ()=>{
            lcpCleanupCallback?.();
            ttfbCleanupCallback();
            clsCleanupCallback?.();
        };
    }
    return ()=>undefined;
}
/**
 * Start tracking long tasks.
 */ function $540e2256a3cced48$export$f396d19077034ad2() {
    (0, $f28dee024a5f97b7$export$69816c1a049f8db6)('longtask', ({ entries: entries })=>{
        const parent = (0, $bb9b6447bf4caedb$export$1be426a8e585c83e)();
        if (!parent) return;
        const { op: parentOp, start_timestamp: parentStartTimestamp } = (0, $bb9b6447bf4caedb$export$92d8c23565496537)(parent);
        for (const entry of entries){
            const startTime = (0, $4cc83a6143615466$export$b4785dbd4a81b33f)((0, $bc81602376c48fa6$export$baf075a948ffc0bf)() + entry.startTime);
            const duration = (0, $4cc83a6143615466$export$b4785dbd4a81b33f)(entry.duration);
            if (parentOp === 'navigation' && parentStartTimestamp && startTime < parentStartTimestamp) continue;
            (0, $4cc83a6143615466$export$7567a67bdb69a23d)(parent, startTime, startTime + duration, {
                name: 'Main UI thread blocked',
                op: 'ui.long-task',
                attributes: {
                    [(0, $f337c80285f06f80$export$cca8dd30f57f805e)]: 'auto.ui.browser.metrics'
                }
            });
        }
    });
}
/**
 * Start tracking long animation frames.
 */ function $540e2256a3cced48$export$5b823ab2ccbc801d() {
    // NOTE: the current web-vitals version (3.5.2) does not support long-animation-frame, so
    // we directly observe `long-animation-frame` events instead of through the web-vitals
    // `observe` helper function.
    const observer = new PerformanceObserver((list)=>{
        const parent = (0, $bb9b6447bf4caedb$export$1be426a8e585c83e)();
        if (!parent) return;
        for (const entry of list.getEntries()){
            if (!entry.scripts[0]) continue;
            const startTime = (0, $4cc83a6143615466$export$b4785dbd4a81b33f)((0, $bc81602376c48fa6$export$baf075a948ffc0bf)() + entry.startTime);
            const { start_timestamp: parentStartTimestamp, op: parentOp } = (0, $bb9b6447bf4caedb$export$92d8c23565496537)(parent);
            if (parentOp === 'navigation' && parentStartTimestamp && startTime < parentStartTimestamp) continue;
            const duration = (0, $4cc83a6143615466$export$b4785dbd4a81b33f)(entry.duration);
            const attributes = {
                [(0, $f337c80285f06f80$export$cca8dd30f57f805e)]: 'auto.ui.browser.metrics'
            };
            const initialScript = entry.scripts[0];
            const { invoker: invoker, invokerType: invokerType, sourceURL: sourceURL, sourceFunctionName: sourceFunctionName, sourceCharPosition: sourceCharPosition } = initialScript;
            attributes['browser.script.invoker'] = invoker;
            attributes['browser.script.invoker_type'] = invokerType;
            if (sourceURL) attributes['code.filepath'] = sourceURL;
            if (sourceFunctionName) attributes['code.function'] = sourceFunctionName;
            if (sourceCharPosition !== -1) attributes['browser.script.source_char_position'] = sourceCharPosition;
            (0, $4cc83a6143615466$export$7567a67bdb69a23d)(parent, startTime, startTime + duration, {
                name: 'Main UI thread blocked',
                op: 'ui.long-animation-frame',
                attributes: attributes
            });
        }
    });
    observer.observe({
        type: 'long-animation-frame',
        buffered: true
    });
}
/**
 * Start tracking interaction events.
 */ function $540e2256a3cced48$export$e27543e0976315e4() {
    (0, $f28dee024a5f97b7$export$69816c1a049f8db6)('event', ({ entries: entries })=>{
        const parent = (0, $bb9b6447bf4caedb$export$1be426a8e585c83e)();
        if (!parent) return;
        for (const entry of entries)if (entry.name === 'click') {
            const startTime = (0, $4cc83a6143615466$export$b4785dbd4a81b33f)((0, $bc81602376c48fa6$export$baf075a948ffc0bf)() + entry.startTime);
            const duration = (0, $4cc83a6143615466$export$b4785dbd4a81b33f)(entry.duration);
            const spanOptions = {
                name: (0, $caac489b9d8395b2$export$5647df6b7814ac86)(entry.target),
                op: `ui.interaction.${entry.name}`,
                startTime: startTime,
                attributes: {
                    [(0, $f337c80285f06f80$export$cca8dd30f57f805e)]: 'auto.ui.browser.metrics'
                }
            };
            const componentName = (0, $caac489b9d8395b2$export$26727cfcc4d7e0fc)(entry.target);
            if (componentName) spanOptions.attributes['ui.component_name'] = componentName;
            (0, $4cc83a6143615466$export$7567a67bdb69a23d)(parent, startTime, startTime + duration, spanOptions);
        }
    });
}
/**
 * Starts tracking the Cumulative Layout Shift on the current page and collects the value and last entry
 * to the `_measurements` object which ultimately is applied to the pageload span's measurements.
 */ function $540e2256a3cced48$var$_trackCLS() {
    return (0, $f28dee024a5f97b7$export$861b82818b37ba5b)(({ metric: metric })=>{
        const entry = metric.entries[metric.entries.length - 1];
        if (!entry) return;
        $540e2256a3cced48$var$_measurements['cls'] = {
            value: metric.value,
            unit: ''
        };
        $540e2256a3cced48$var$_clsEntry = entry;
    }, true);
}
/** Starts tracking the Largest Contentful Paint on the current page. */ function $540e2256a3cced48$var$_trackLCP() {
    return (0, $f28dee024a5f97b7$export$3fd4b53331200102)(({ metric: metric })=>{
        const entry = metric.entries[metric.entries.length - 1];
        if (!entry) return;
        $540e2256a3cced48$var$_measurements['lcp'] = {
            value: metric.value,
            unit: 'millisecond'
        };
        $540e2256a3cced48$var$_lcpEntry = entry;
    }, true);
}
function $540e2256a3cced48$var$_trackTtfb() {
    return (0, $f28dee024a5f97b7$export$699d9529c099a797)(({ metric: metric })=>{
        const entry = metric.entries[metric.entries.length - 1];
        if (!entry) return;
        $540e2256a3cced48$var$_measurements['ttfb'] = {
            value: metric.value,
            unit: 'millisecond'
        };
    });
}
/** Add performance related spans to a transaction */ function $540e2256a3cced48$export$5f8fa6b3467a7443(span, options) {
    const performance = (0, $4cc83a6143615466$export$f72a13c439a30cab)();
    const origin = (0, $bc81602376c48fa6$export$baf075a948ffc0bf)();
    if (!performance?.getEntries || !origin) // Gatekeeper if performance API not available
    return;
    const timeOrigin = (0, $4cc83a6143615466$export$b4785dbd4a81b33f)(origin);
    const performanceEntries = performance.getEntries();
    const { op: op, start_timestamp: transactionStartTime } = (0, $bb9b6447bf4caedb$export$92d8c23565496537)(span);
    performanceEntries.slice($540e2256a3cced48$var$_performanceCursor).forEach((entry)=>{
        const startTime = (0, $4cc83a6143615466$export$b4785dbd4a81b33f)(entry.startTime);
        const duration = (0, $4cc83a6143615466$export$b4785dbd4a81b33f)(// Inexplicably, Chrome sometimes emits a negative duration. We need to work around this.
        // There is a SO post attempting to explain this, but it leaves one with open questions: https://stackoverflow.com/questions/23191918/peformance-getentries-and-negative-duration-display
        // The way we clamp the value is probably not accurate, since we have observed this happen for things that may take a while to load, like for example the replay worker.
        // TODO: Investigate why this happens and how to properly mitigate. For now, this is a workaround to prevent transactions being dropped due to negative duration spans.
        Math.max(0, entry.duration));
        if (op === 'navigation' && transactionStartTime && timeOrigin + startTime < transactionStartTime) return;
        switch(entry.entryType){
            case 'navigation':
                $540e2256a3cced48$export$90a8fd571ed9a1bc(span, entry, timeOrigin);
                break;
            case 'mark':
            case 'paint':
            case 'measure':
                {
                    $540e2256a3cced48$export$bc93b84e4d45912d(span, entry, startTime, duration, timeOrigin, options.ignorePerformanceApiSpans);
                    // capture web vitals
                    const firstHidden = (0, $3e2a3037c0664e80$export$443f86b2c77012c4)();
                    // Only report if the page wasn't hidden prior to the web vital.
                    const shouldRecord = entry.startTime < firstHidden.firstHiddenTime;
                    if (entry.name === 'first-paint' && shouldRecord) $540e2256a3cced48$var$_measurements['fp'] = {
                        value: entry.startTime,
                        unit: 'millisecond'
                    };
                    if (entry.name === 'first-contentful-paint' && shouldRecord) $540e2256a3cced48$var$_measurements['fcp'] = {
                        value: entry.startTime,
                        unit: 'millisecond'
                    };
                    break;
                }
            case 'resource':
                $540e2256a3cced48$export$c82fe1a70634f317(span, entry, entry.name, startTime, duration, timeOrigin, options.ignoreResourceSpans);
                break;
        }
    });
    $540e2256a3cced48$var$_performanceCursor = Math.max(performanceEntries.length - 1, 0);
    $540e2256a3cced48$var$_trackNavigator(span);
    // Measurements are only available for pageload transactions
    if (op === 'pageload') {
        $540e2256a3cced48$var$_addTtfbRequestTimeToMeasurements($540e2256a3cced48$var$_measurements);
        // If CLS standalone spans are enabled, don't record CLS as a measurement
        if (!options.recordClsOnPageloadSpan) delete $540e2256a3cced48$var$_measurements.cls;
        // If LCP standalone spans are enabled, don't record LCP as a measurement
        if (!options.recordLcpOnPageloadSpan) delete $540e2256a3cced48$var$_measurements.lcp;
        Object.entries($540e2256a3cced48$var$_measurements).forEach(([measurementName, measurement])=>{
            (0, $dbcaa70aa380aaa2$export$7cc31b475d33a706)(measurementName, measurement.value, measurement.unit);
        });
        // Set timeOrigin which denotes the timestamp which to base the LCP/FCP/FP/TTFB measurements on
        span.setAttribute('performance.timeOrigin', timeOrigin);
        // In prerendering scenarios, where a page might be prefetched and pre-rendered before the user clicks the link,
        // the navigation starts earlier than when the user clicks it. Web Vitals should always be based on the
        // user-perceived time, so they are not reported from the actual start of the navigation, but rather from the
        // time where the user actively started the navigation, for example by clicking a link.
        // This is user action is called "activation" and the time between navigation and activation is stored in
        // the `activationStart` attribute of the "navigation" PerformanceEntry.
        span.setAttribute('performance.activationStart', (0, $395b26100bb9afc9$export$d3e828b3c7b5b845)());
        $540e2256a3cced48$var$_setWebVitalAttributes(span, options);
    }
    $540e2256a3cced48$var$_lcpEntry = undefined;
    $540e2256a3cced48$var$_clsEntry = undefined;
    $540e2256a3cced48$var$_measurements = {};
}
/**
 * React 19.2+ creates performance.measure entries for component renders.
 * We can identify them by the `detail.devtools.track` property being set to 'Components ⚛'.
 * see: https://react.dev/reference/dev-tools/react-performance-tracks
 * see: https://github.com/facebook/react/blob/06fcc8f380c6a905c7bc18d94453f623cf8cbc81/packages/react-reconciler/src/ReactFiberPerformanceTrack.js#L454-L473
 */ function $540e2256a3cced48$var$isReact19MeasureEntry(entry) {
    if (entry?.entryType !== 'measure') return;
    try {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        return entry.detail.devtools.track === "Components \u269B";
    } catch  {
        return;
    }
}
/**
 * Create measure related spans.
 * Exported only for tests.
 */ function $540e2256a3cced48$export$bc93b84e4d45912d(span, entry, startTime, duration, timeOrigin, ignorePerformanceApiSpans) {
    if ($540e2256a3cced48$var$isReact19MeasureEntry(entry)) return;
    if ([
        'mark',
        'measure'
    ].includes(entry.entryType) && (0, $e534db390d1e4996$export$a7a5ec66062ea5d)(entry.name, ignorePerformanceApiSpans)) return;
    const navEntry = (0, $ced02df875855c4b$export$6431553786c94949)(false);
    const requestTime = (0, $4cc83a6143615466$export$b4785dbd4a81b33f)(navEntry ? navEntry.requestStart : 0);
    // Because performance.measure accepts arbitrary timestamps it can produce
    // spans that happen before the browser even makes a request for the page.
    //
    // An example of this is the automatically generated Next.js-before-hydration
    // spans created by the Next.js framework.
    //
    // To prevent this we will pin the start timestamp to the request start time
    // This does make duration inaccurate, so if this does happen, we will add
    // an attribute to the span
    const measureStartTimestamp = timeOrigin + Math.max(startTime, requestTime);
    const startTimeStamp = timeOrigin + startTime;
    const measureEndTimestamp = startTimeStamp + duration;
    const attributes = {
        [(0, $f337c80285f06f80$export$cca8dd30f57f805e)]: 'auto.resource.browser.metrics'
    };
    if (measureStartTimestamp !== startTimeStamp) {
        attributes['sentry.browser.measure_happened_before_request'] = true;
        attributes['sentry.browser.measure_start_time'] = measureStartTimestamp;
    }
    $540e2256a3cced48$var$_addDetailToSpanAttributes(attributes, entry);
    // Measurements from third parties can be off, which would create invalid spans, dropping transactions in the process.
    if (measureStartTimestamp <= measureEndTimestamp) (0, $4cc83a6143615466$export$7567a67bdb69a23d)(span, measureStartTimestamp, measureEndTimestamp, {
        name: entry.name,
        op: entry.entryType,
        attributes: attributes
    });
}
function $540e2256a3cced48$var$_addDetailToSpanAttributes(attributes, performanceMeasure) {
    try {
        // Accessing detail might throw in some browsers (e.g., Firefox) due to security restrictions
        const detail = performanceMeasure.detail;
        if (!detail) return;
        // Process detail based on its type
        if (typeof detail === 'object') {
            // Handle object details
            for (const [key, value] of Object.entries(detail)){
                if (value && (0, $13cf2ed412f405fa$export$c3825b437cbdea5c)(value)) attributes[`sentry.browser.measure.detail.${key}`] = value;
                else if (value !== undefined) try {
                    // This is user defined so we can't guarantee it's serializable
                    attributes[`sentry.browser.measure.detail.${key}`] = JSON.stringify(value);
                } catch  {
                // Skip values that can't be stringified
                }
            }
            return;
        }
        if ((0, $13cf2ed412f405fa$export$c3825b437cbdea5c)(detail)) {
            // Handle primitive details
            attributes['sentry.browser.measure.detail'] = detail;
            return;
        }
        try {
            attributes['sentry.browser.measure.detail'] = JSON.stringify(detail);
        } catch  {
        // Skip if stringification fails
        }
    } catch  {
    // Silently ignore any errors when accessing detail
    // This handles the Firefox "Permission denied to access object" error
    }
}
/**
 * Instrument navigation entries
 * exported only for tests
 */ function $540e2256a3cced48$export$90a8fd571ed9a1bc(span, entry, timeOrigin) {
    [
        'unloadEvent',
        'redirect',
        'domContentLoadedEvent',
        'loadEvent',
        'connect'
    ].forEach((event)=>{
        $540e2256a3cced48$var$_addPerformanceNavigationTiming(span, entry, event, timeOrigin);
    });
    $540e2256a3cced48$var$_addPerformanceNavigationTiming(span, entry, 'secureConnection', timeOrigin, 'TLS/SSL');
    $540e2256a3cced48$var$_addPerformanceNavigationTiming(span, entry, 'fetch', timeOrigin, 'cache');
    $540e2256a3cced48$var$_addPerformanceNavigationTiming(span, entry, 'domainLookup', timeOrigin, 'DNS');
    $540e2256a3cced48$var$_addRequest(span, entry, timeOrigin);
}
/** Create performance navigation related spans */ function $540e2256a3cced48$var$_addPerformanceNavigationTiming(span, entry, event, timeOrigin, name = event) {
    const eventEnd = $540e2256a3cced48$var$_getEndPropertyNameForNavigationTiming(event);
    const end = entry[eventEnd];
    const start = entry[`${event}Start`];
    if (!start || !end) return;
    (0, $4cc83a6143615466$export$7567a67bdb69a23d)(span, timeOrigin + (0, $4cc83a6143615466$export$b4785dbd4a81b33f)(start), timeOrigin + (0, $4cc83a6143615466$export$b4785dbd4a81b33f)(end), {
        op: `browser.${name}`,
        name: entry.name,
        attributes: {
            [(0, $f337c80285f06f80$export$cca8dd30f57f805e)]: 'auto.ui.browser.metrics',
            ...event === 'redirect' && entry.redirectCount != null ? {
                'http.redirect_count': entry.redirectCount
            } : {}
        }
    });
}
function $540e2256a3cced48$var$_getEndPropertyNameForNavigationTiming(event) {
    if (event === 'secureConnection') return 'connectEnd';
    if (event === 'fetch') return 'domainLookupStart';
    return `${event}End`;
}
/** Create request and response related spans */ function $540e2256a3cced48$var$_addRequest(span, entry, timeOrigin) {
    const requestStartTimestamp = timeOrigin + (0, $4cc83a6143615466$export$b4785dbd4a81b33f)(entry.requestStart);
    const responseEndTimestamp = timeOrigin + (0, $4cc83a6143615466$export$b4785dbd4a81b33f)(entry.responseEnd);
    const responseStartTimestamp = timeOrigin + (0, $4cc83a6143615466$export$b4785dbd4a81b33f)(entry.responseStart);
    if (entry.responseEnd) {
        // It is possible that we are collecting these metrics when the page hasn't finished loading yet, for example when the HTML slowly streams in.
        // In this case, ie. when the document request hasn't finished yet, `entry.responseEnd` will be 0.
        // In order not to produce faulty spans, where the end timestamp is before the start timestamp, we will only collect
        // these spans when the responseEnd value is available. The backend (Relay) would drop the entire span if it contained faulty spans.
        (0, $4cc83a6143615466$export$7567a67bdb69a23d)(span, requestStartTimestamp, responseEndTimestamp, {
            op: 'browser.request',
            name: entry.name,
            attributes: {
                [(0, $f337c80285f06f80$export$cca8dd30f57f805e)]: 'auto.ui.browser.metrics'
            }
        });
        (0, $4cc83a6143615466$export$7567a67bdb69a23d)(span, responseStartTimestamp, responseEndTimestamp, {
            op: 'browser.response',
            name: entry.name,
            attributes: {
                [(0, $f337c80285f06f80$export$cca8dd30f57f805e)]: 'auto.ui.browser.metrics'
            }
        });
    }
}
/**
 * Create resource-related spans.
 * Exported only for tests.
 */ function $540e2256a3cced48$export$c82fe1a70634f317(span, entry, resourceUrl, startTime, duration, timeOrigin, ignoredResourceSpanOps) {
    // we already instrument based on fetch and xhr, so we don't need to
    // duplicate spans here.
    if (entry.initiatorType === 'xmlhttprequest' || entry.initiatorType === 'fetch') return;
    const op = entry.initiatorType ? `resource.${entry.initiatorType}` : 'resource.other';
    if (ignoredResourceSpanOps?.includes(op)) return;
    const attributes = {
        [(0, $f337c80285f06f80$export$cca8dd30f57f805e)]: 'auto.resource.browser.metrics'
    };
    const parsedUrl = (0, $0c1b93525a804899$export$7a5253c0f62e0150)(resourceUrl);
    if (parsedUrl.protocol) attributes['url.scheme'] = parsedUrl.protocol.split(':').pop(); // the protocol returned by parseUrl includes a :, but OTEL spec does not, so we remove it.
    if (parsedUrl.host) attributes['server.address'] = parsedUrl.host;
    attributes['url.same_origin'] = resourceUrl.includes((0, $a279eed6bc86f03b$export$56d8a8a25bd48b81).location.origin);
    $540e2256a3cced48$export$6ce741ceee01ab2f(entry, attributes, [
        // https://developer.mozilla.org/en-US/docs/Web/API/PerformanceResourceTiming/responseStatus
        [
            'responseStatus',
            'http.response.status_code'
        ],
        [
            'transferSize',
            'http.response_transfer_size'
        ],
        [
            'encodedBodySize',
            'http.response_content_length'
        ],
        [
            'decodedBodySize',
            'http.decoded_response_content_length'
        ],
        // https://developer.mozilla.org/en-US/docs/Web/API/PerformanceResourceTiming/renderBlockingStatus
        [
            'renderBlockingStatus',
            'resource.render_blocking_status'
        ],
        // https://developer.mozilla.org/en-US/docs/Web/API/PerformanceResourceTiming/deliveryType
        [
            'deliveryType',
            'http.response_delivery_type'
        ]
    ]);
    const attributesWithResourceTiming = {
        ...attributes,
        ...(0, $7d1a2f038f0232fd$export$ec50b091612e7e00)(entry)
    };
    const startTimestamp = timeOrigin + startTime;
    const endTimestamp = startTimestamp + duration;
    (0, $4cc83a6143615466$export$7567a67bdb69a23d)(span, startTimestamp, endTimestamp, {
        name: resourceUrl.replace((0, $a279eed6bc86f03b$export$56d8a8a25bd48b81).location.origin, ''),
        op: op,
        attributes: attributesWithResourceTiming
    });
}
/**
 * Capture the information of the user agent.
 */ function $540e2256a3cced48$var$_trackNavigator(span) {
    const navigator = (0, $a279eed6bc86f03b$export$56d8a8a25bd48b81).navigator;
    if (!navigator) return;
    // track network connectivity
    const connection = navigator.connection;
    if (connection) {
        if (connection.effectiveType) span.setAttribute('effectiveConnectionType', connection.effectiveType);
        if (connection.type) span.setAttribute('connectionType', connection.type);
        if ((0, $4cc83a6143615466$export$27169ccae1b439e3)(connection.rtt)) $540e2256a3cced48$var$_measurements['connection.rtt'] = {
            value: connection.rtt,
            unit: 'millisecond'
        };
    }
    if ((0, $4cc83a6143615466$export$27169ccae1b439e3)(navigator.deviceMemory)) span.setAttribute('deviceMemory', `${navigator.deviceMemory} GB`);
    if ((0, $4cc83a6143615466$export$27169ccae1b439e3)(navigator.hardwareConcurrency)) span.setAttribute('hardwareConcurrency', String(navigator.hardwareConcurrency));
}
/** Add LCP / CLS data to span to allow debugging */ function $540e2256a3cced48$var$_setWebVitalAttributes(span, options) {
    // Only add LCP attributes if LCP is being recorded on the pageload span
    if ($540e2256a3cced48$var$_lcpEntry && options.recordLcpOnPageloadSpan) {
        // Capture Properties of the LCP element that contributes to the LCP.
        if ($540e2256a3cced48$var$_lcpEntry.element) span.setAttribute('lcp.element', (0, $caac489b9d8395b2$export$5647df6b7814ac86)($540e2256a3cced48$var$_lcpEntry.element));
        if ($540e2256a3cced48$var$_lcpEntry.id) span.setAttribute('lcp.id', $540e2256a3cced48$var$_lcpEntry.id);
        if ($540e2256a3cced48$var$_lcpEntry.url) // Trim URL to the first 200 characters.
        span.setAttribute('lcp.url', $540e2256a3cced48$var$_lcpEntry.url.trim().slice(0, 200));
        if ($540e2256a3cced48$var$_lcpEntry.loadTime != null) // loadTime is the time of LCP that's related to receiving the LCP element response..
        span.setAttribute('lcp.loadTime', $540e2256a3cced48$var$_lcpEntry.loadTime);
        if ($540e2256a3cced48$var$_lcpEntry.renderTime != null) // renderTime is loadTime + rendering time
        // it's 0 if the LCP element is loaded from a 3rd party origin that doesn't send the
        // `Timing-Allow-Origin` header.
        span.setAttribute('lcp.renderTime', $540e2256a3cced48$var$_lcpEntry.renderTime);
        span.setAttribute('lcp.size', $540e2256a3cced48$var$_lcpEntry.size);
    }
    // Only add CLS attributes if CLS is being recorded on the pageload span
    if ($540e2256a3cced48$var$_clsEntry?.sources && options.recordClsOnPageloadSpan) $540e2256a3cced48$var$_clsEntry.sources.forEach((source, index)=>span.setAttribute(`cls.source.${index + 1}`, (0, $caac489b9d8395b2$export$5647df6b7814ac86)(source.node)));
}
/**
 * Use this to set any attributes we can take directly form the PerformanceResourceTiming entry.
 *
 * This is just a mapping function for entry->attribute to keep bundle-size minimal.
 * Experimental properties are also accepted (see {@link ExperimentalResourceTimingProperty}).
 * Assumes that all entry properties might be undefined for browser-specific differences.
 * Only accepts string and number values for now and also sets 0-values.
 */ function $540e2256a3cced48$export$6ce741ceee01ab2f(entry, attributes, properties) {
    properties.forEach(([entryKey, attributeKey])=>{
        const entryVal = entry[entryKey];
        if (entryVal != null && (typeof entryVal === 'number' && entryVal < $540e2256a3cced48$var$MAX_INT_AS_BYTES || typeof entryVal === 'string')) attributes[attributeKey] = entryVal;
    });
}
/**
 * Add ttfb request time information to measurements.
 *
 * ttfb information is added via vendored web vitals library.
 */ function $540e2256a3cced48$var$_addTtfbRequestTimeToMeasurements(_measurements) {
    const navEntry = (0, $ced02df875855c4b$export$6431553786c94949)(false);
    if (!navEntry) return;
    const { responseStart: responseStart, requestStart: requestStart } = navEntry;
    if (requestStart <= responseStart) _measurements['ttfb.requestTime'] = {
        value: responseStart - requestStart,
        unit: 'millisecond'
    };
}





const $1f65e1a74bae63ce$var$LAST_INTERACTIONS = [];
const $1f65e1a74bae63ce$var$INTERACTIONS_SPAN_MAP = new Map();
// Map to store element names by timestamp, since we get the DOM event before the PerformanceObserver entry
const $1f65e1a74bae63ce$var$ELEMENT_NAME_TIMESTAMP_MAP = new Map();
/**
 * 60 seconds is the maximum for a plausible INP value
 * (source: Me)
 */ const $1f65e1a74bae63ce$var$MAX_PLAUSIBLE_INP_DURATION = 60;
/**
 * Start tracking INP webvital events.
 */ function $1f65e1a74bae63ce$export$f17d06681a4744a3() {
    const performance = (0, $4cc83a6143615466$export$f72a13c439a30cab)();
    if (performance && (0, $bc81602376c48fa6$export$baf075a948ffc0bf)()) {
        const inpCallback = $1f65e1a74bae63ce$export$eeab203db0ed99a9();
        return ()=>{
            inpCallback();
        };
    }
    return ()=>undefined;
}
const $1f65e1a74bae63ce$var$INP_ENTRY_MAP = {
    click: 'click',
    pointerdown: 'click',
    pointerup: 'click',
    mousedown: 'click',
    mouseup: 'click',
    touchstart: 'click',
    touchend: 'click',
    mouseover: 'hover',
    mouseout: 'hover',
    mouseenter: 'hover',
    mouseleave: 'hover',
    pointerover: 'hover',
    pointerout: 'hover',
    pointerenter: 'hover',
    pointerleave: 'hover',
    dragstart: 'drag',
    dragend: 'drag',
    drag: 'drag',
    dragenter: 'drag',
    dragleave: 'drag',
    dragover: 'drag',
    drop: 'drag',
    keydown: 'press',
    keyup: 'press',
    keypress: 'press',
    input: 'press'
};
/** Starts tracking the Interaction to Next Paint on the current page. #
 * exported only for testing
 */ function $1f65e1a74bae63ce$export$eeab203db0ed99a9() {
    return (0, $f28dee024a5f97b7$export$da3b76aa2022cbd7)($1f65e1a74bae63ce$export$7bcb98fe01441521);
}
/**
 * exported only for testing
 */ const $1f65e1a74bae63ce$export$7bcb98fe01441521 = ({ metric: metric })=>{
    if (metric.value == undefined) return;
    const duration = (0, $4cc83a6143615466$export$b4785dbd4a81b33f)(metric.value);
    // We received occasional reports of hour-long INP values.
    // Therefore, we add a sanity check to avoid creating spans for
    // unrealistically long INP durations.
    if (duration > $1f65e1a74bae63ce$var$MAX_PLAUSIBLE_INP_DURATION) return;
    const entry = metric.entries.find((entry)=>entry.duration === metric.value && $1f65e1a74bae63ce$var$INP_ENTRY_MAP[entry.name]);
    if (!entry) return;
    const { interactionId: interactionId } = entry;
    const interactionType = $1f65e1a74bae63ce$var$INP_ENTRY_MAP[entry.name];
    /** Build the INP span, create an envelope from the span, and then send the envelope */ const startTime = (0, $4cc83a6143615466$export$b4785dbd4a81b33f)((0, $bc81602376c48fa6$export$baf075a948ffc0bf)() + entry.startTime);
    const activeSpan = (0, $bb9b6447bf4caedb$export$1be426a8e585c83e)();
    const rootSpan = activeSpan ? (0, $bb9b6447bf4caedb$export$c4c6a79b1260ca1b)(activeSpan) : undefined;
    // We first try to lookup the interaction context from our INTERACTIONS_SPAN_MAP,
    // where we cache the route and element name per interactionId
    const cachedInteractionContext = interactionId != null ? $1f65e1a74bae63ce$var$INTERACTIONS_SPAN_MAP.get(interactionId) : undefined;
    const spanToUse = cachedInteractionContext?.span || rootSpan;
    // Else, we try to use the active span.
    // Finally, we fall back to look at the transactionName on the scope
    const routeName = spanToUse ? (0, $bb9b6447bf4caedb$export$92d8c23565496537)(spanToUse).description : (0, $7d48e1ed9f699a01$export$c7be4b0125a10cba)().getScopeData().transactionName;
    const name = cachedInteractionContext?.elementName || (0, $caac489b9d8395b2$export$5647df6b7814ac86)(entry.target);
    const attributes = {
        [(0, $f337c80285f06f80$export$cca8dd30f57f805e)]: 'auto.http.browser.inp',
        [(0, $f337c80285f06f80$export$1a413bd9a88fdb09)]: `ui.interaction.${interactionType}`,
        [(0, $f337c80285f06f80$export$fea48ba9f4550879)]: entry.duration
    };
    const span = (0, $4cc83a6143615466$export$b71b9c7b60c5a4aa)({
        name: name,
        transaction: routeName,
        attributes: attributes,
        startTime: startTime
    });
    if (span) {
        span.addEvent('inp', {
            [(0, $f337c80285f06f80$export$f5f95cff026507b5)]: 'millisecond',
            [(0, $f337c80285f06f80$export$69cd5c610c7bb96a)]: metric.value
        });
        span.end(startTime + duration);
    }
};
/**
 * Register a listener to cache route information for INP interactions.
 */ function $1f65e1a74bae63ce$export$e4e04d43e223cce2() {
    // Listen for all interaction events that could contribute to INP
    const interactionEvents = Object.keys($1f65e1a74bae63ce$var$INP_ENTRY_MAP);
    if ((0, $b1c1ca6bb415cfb2$export$4e09c449d6c407f7)()) interactionEvents.forEach((eventType)=>{
        (0, $a279eed6bc86f03b$export$56d8a8a25bd48b81).addEventListener(eventType, captureElementFromEvent, {
            capture: true,
            passive: true
        });
    });
    /**
   * Captures the element name from a DOM event and stores it in the ELEMENT_NAME_TIMESTAMP_MAP.
   */ function captureElementFromEvent(event) {
        const target = event.target;
        if (!target) return;
        const elementName = (0, $caac489b9d8395b2$export$5647df6b7814ac86)(target);
        const timestamp = Math.round(event.timeStamp);
        // Store the element name by timestamp so we can match it with the PerformanceEntry
        $1f65e1a74bae63ce$var$ELEMENT_NAME_TIMESTAMP_MAP.set(timestamp, elementName);
        // Clean up old
        if ($1f65e1a74bae63ce$var$ELEMENT_NAME_TIMESTAMP_MAP.size > 50) {
            const firstKey = $1f65e1a74bae63ce$var$ELEMENT_NAME_TIMESTAMP_MAP.keys().next().value;
            if (firstKey !== undefined) $1f65e1a74bae63ce$var$ELEMENT_NAME_TIMESTAMP_MAP.delete(firstKey);
        }
    }
    /**
   * Tries to get the element name from the timestamp map.
   */ function resolveElementNameFromEntry(entry) {
        const timestamp = Math.round(entry.startTime);
        let elementName = $1f65e1a74bae63ce$var$ELEMENT_NAME_TIMESTAMP_MAP.get(timestamp);
        // try nearby timestamps (±5ms)
        if (!elementName) for(let offset = -5; offset <= 5; offset++){
            const nearbyName = $1f65e1a74bae63ce$var$ELEMENT_NAME_TIMESTAMP_MAP.get(timestamp + offset);
            if (nearbyName) {
                elementName = nearbyName;
                break;
            }
        }
        return elementName || '<unknown>';
    }
    const handleEntries = ({ entries: entries })=>{
        const activeSpan = (0, $bb9b6447bf4caedb$export$1be426a8e585c83e)();
        const activeRootSpan = activeSpan && (0, $bb9b6447bf4caedb$export$c4c6a79b1260ca1b)(activeSpan);
        entries.forEach((entry)=>{
            if (!(0, $f28dee024a5f97b7$export$7affb50b622d8714)(entry)) return;
            const interactionId = entry.interactionId;
            if (interactionId == null) return;
            // If the interaction was already recorded before, nothing more to do
            if ($1f65e1a74bae63ce$var$INTERACTIONS_SPAN_MAP.has(interactionId)) return;
            const elementName = entry.target ? (0, $caac489b9d8395b2$export$5647df6b7814ac86)(entry.target) : resolveElementNameFromEntry(entry);
            // We keep max. 10 interactions in the list, then remove the oldest one & clean up
            if ($1f65e1a74bae63ce$var$LAST_INTERACTIONS.length > 10) {
                const last = $1f65e1a74bae63ce$var$LAST_INTERACTIONS.shift();
                $1f65e1a74bae63ce$var$INTERACTIONS_SPAN_MAP.delete(last);
            }
            // We add the interaction to the list of recorded interactions
            // and store both the span and element name for this interaction
            $1f65e1a74bae63ce$var$LAST_INTERACTIONS.push(interactionId);
            $1f65e1a74bae63ce$var$INTERACTIONS_SPAN_MAP.set(interactionId, {
                span: activeRootSpan,
                elementName: elementName
            });
        });
    };
    (0, $f28dee024a5f97b7$export$69816c1a049f8db6)('event', handleEntries);
    (0, $f28dee024a5f97b7$export$69816c1a049f8db6)('first-input', handleEntries);
}




// ElementTiming interface based on the W3C spec
/**
 * Start tracking ElementTiming performance entries.
 */ function $c5102c8a625aa6b3$export$c9ffcf7e2b5ec1b3() {
    const performance = (0, $4cc83a6143615466$export$f72a13c439a30cab)();
    if (performance && (0, $bc81602376c48fa6$export$baf075a948ffc0bf)()) return (0, $f28dee024a5f97b7$export$69816c1a049f8db6)('element', $c5102c8a625aa6b3$export$2f1fb99ea19ed53a);
    return ()=>undefined;
}
/**
 * exported only for testing
 */ const $c5102c8a625aa6b3$export$2f1fb99ea19ed53a = ({ entries: entries })=>{
    const activeSpan = (0, $bb9b6447bf4caedb$export$1be426a8e585c83e)();
    const rootSpan = activeSpan ? (0, $bb9b6447bf4caedb$export$c4c6a79b1260ca1b)(activeSpan) : undefined;
    const transactionName = rootSpan ? (0, $bb9b6447bf4caedb$export$92d8c23565496537)(rootSpan).description : (0, $7d48e1ed9f699a01$export$c7be4b0125a10cba)().getScopeData().transactionName;
    entries.forEach((entry)=>{
        const elementEntry = entry;
        // Skip entries without identifier (elementtiming attribute)
        if (!elementEntry.identifier) return;
        // `name` contains the type of the element paint. Can be `'image-paint'` or `'text-paint'`.
        // https://developer.mozilla.org/en-US/docs/Web/API/PerformanceElementTiming#instance_properties
        const paintType = elementEntry.name;
        const renderTime = elementEntry.renderTime;
        const loadTime = elementEntry.loadTime;
        // starting the span at:
        // - `loadTime` if available (should be available for all "image-paint" entries, 0 otherwise)
        // - `renderTime` if available (available for all entries, except 3rd party images, but these should be covered by `loadTime`, 0 otherwise)
        // - `timestampInSeconds()` as a safeguard
        // see https://developer.mozilla.org/en-US/docs/Web/API/PerformanceElementTiming/renderTime#cross-origin_image_render_time
        const [spanStartTime, spanStartTimeSource] = loadTime ? [
            (0, $4cc83a6143615466$export$b4785dbd4a81b33f)(loadTime),
            'load-time'
        ] : renderTime ? [
            (0, $4cc83a6143615466$export$b4785dbd4a81b33f)(renderTime),
            'render-time'
        ] : [
            (0, $bc81602376c48fa6$export$ee52dced521e3e18)(),
            'entry-emission'
        ];
        const duration = paintType === 'image-paint' ? // and `renderTime`. `loadTime` is the time when the image finished loading and `renderTime` is the
        // time when the image finished rendering.
        (0, $4cc83a6143615466$export$b4785dbd4a81b33f)(Math.max(0, (renderTime ?? 0) - (loadTime ?? 0))) : 0;
        const attributes = {
            [(0, $f337c80285f06f80$export$cca8dd30f57f805e)]: 'auto.ui.browser.elementtiming',
            [(0, $f337c80285f06f80$export$1a413bd9a88fdb09)]: 'ui.elementtiming',
            // name must be user-entered, so we can assume low cardinality
            [(0, $f337c80285f06f80$export$d7a7d984b0791405)]: 'component',
            // recording the source of the span start time, as it varies depending on available data
            'sentry.span_start_time_source': spanStartTimeSource,
            'sentry.transaction_name': transactionName,
            'element.id': elementEntry.id,
            'element.type': elementEntry.element?.tagName?.toLowerCase() || 'unknown',
            'element.size': elementEntry.naturalWidth && elementEntry.naturalHeight ? `${elementEntry.naturalWidth}x${elementEntry.naturalHeight}` : undefined,
            'element.render_time': renderTime,
            'element.load_time': loadTime,
            // `url` is `0`(number) for text paints (hence we fall back to undefined)
            'element.url': elementEntry.url || undefined,
            'element.identifier': elementEntry.identifier,
            'element.paint_type': paintType
        };
        (0, $c9161b67125aefc1$export$a1bd95187356f372)({
            name: `element[${elementEntry.identifier}]`,
            attributes: attributes,
            startTime: spanStartTime,
            onlyIfParent: true
        }, (span)=>{
            span.end(spanStartTime + duration);
        });
    });
};







/**
 * Add a listener that cancels and finishes a transaction when the global
 * document is hidden.
 */ function $e2a93f4a13ed6e48$export$6f18f55521af71a1() {
    if ((0, $e62dec891f31852b$export$56d8a8a25bd48b81).document) (0, $e62dec891f31852b$export$56d8a8a25bd48b81).document.addEventListener('visibilitychange', ()=>{
        const activeSpan = (0, $bb9b6447bf4caedb$export$1be426a8e585c83e)();
        if (!activeSpan) return;
        const rootSpan = (0, $bb9b6447bf4caedb$export$c4c6a79b1260ca1b)(activeSpan);
        if ((0, $e62dec891f31852b$export$56d8a8a25bd48b81).document.hidden && rootSpan) {
            const cancelledStatus = 'cancelled';
            const { op: op, status: status } = (0, $bb9b6447bf4caedb$export$92d8c23565496537)(rootSpan);
            if (0, $6e9d48dbcf18d05a$export$16a28057038b10ef) (0, $d11ed0b3cdda6b8d$export$1c9f709888824e05).log(`[Tracing] Transaction: ${cancelledStatus} -> since tab moved to the background, op: ${op}`);
            // We should not set status if it is already set, this prevent important statuses like
            // error or data loss from being overwritten on transaction.
            if (!status) rootSpan.setStatus({
                code: (0, $fda37f10dc06a152$export$f966a0446ece71e),
                message: cancelledStatus
            });
            rootSpan.setAttribute('sentry.cancellation_reason', 'document.hidden');
            rootSpan.end();
        }
    });
    else (0, $6e9d48dbcf18d05a$export$16a28057038b10ef) && (0, $d11ed0b3cdda6b8d$export$1c9f709888824e05).warn('[Tracing] Could not set up background tab detection due to lack of global document');
}















// 1h in seconds
const $708fd5b70f5584b2$export$c8d616af96ac729f = 3600;
// session storage key
const $708fd5b70f5584b2$export$16b6aa13b3c0f075 = 'sentry_previous_trace';
const $708fd5b70f5584b2$export$237518aee8726f02 = 'sentry.previous_trace';
/**
 * Takes care of linking traces and applying the (consistent) sampling behavoiour based on the passed options
 * @param options - options for linking traces and consistent trace sampling (@see BrowserTracingOptions)
 * @param client - Sentry client
 */ function $708fd5b70f5584b2$export$830d9ee659c6e4c4(client, { linkPreviousTrace: linkPreviousTrace, consistentTraceSampling: consistentTraceSampling }) {
    const useSessionStorage = linkPreviousTrace === 'session-storage';
    let inMemoryPreviousTraceInfo = useSessionStorage ? $708fd5b70f5584b2$export$ef546bba8a402d99() : undefined;
    client.on('spanStart', (span)=>{
        if ((0, $bb9b6447bf4caedb$export$c4c6a79b1260ca1b)(span) !== span) return;
        const oldPropagationContext = (0, $7d48e1ed9f699a01$export$c7be4b0125a10cba)().getPropagationContext();
        inMemoryPreviousTraceInfo = $708fd5b70f5584b2$export$ae31cf84cbfc630e(inMemoryPreviousTraceInfo, span, oldPropagationContext);
        if (useSessionStorage) $708fd5b70f5584b2$export$e3dcc2666496dd96(inMemoryPreviousTraceInfo);
    });
    let isFirstTraceOnPageload = true;
    if (consistentTraceSampling) /*
    When users opt into `consistentTraceSampling`, we need to ensure that we propagate
    the previous trace's sample rate and rand to the current trace. This is necessary because otherwise, span
    metric extrapolation is inaccurate, as we'd propagate too high of a sample rate for the subsequent traces.

    So therefore, we pretend that the previous trace was the parent trace of the newly started trace. To do that,
    we mutate the propagation context of the current trace and set the sample rate and sample rand of the previous trace.
    Timing-wise, it is fine because it happens before we even sample the root span.

    @see https://github.com/getsentry/sentry-javascript/issues/15754
    */ client.on('beforeSampling', (mutableSamplingContextData)=>{
        if (!inMemoryPreviousTraceInfo) return;
        const scope = (0, $7d48e1ed9f699a01$export$c7be4b0125a10cba)();
        const currentPropagationContext = scope.getPropagationContext();
        // We do not want to force-continue the sampling decision if we continue a trace
        // that was started on the backend. Most prominently, this will happen in MPAs where
        // users hard-navigate between pages. In this case, the sampling decision of a potentially
        // started trace on the server takes precedence.
        // Why? We want to prioritize inter-trace consistency over intra-trace consistency.
        if (isFirstTraceOnPageload && currentPropagationContext.parentSpanId) {
            isFirstTraceOnPageload = false;
            return;
        }
        scope.setPropagationContext({
            ...currentPropagationContext,
            dsc: {
                ...currentPropagationContext.dsc,
                sample_rate: String(inMemoryPreviousTraceInfo.sampleRate),
                sampled: String($708fd5b70f5584b2$export$f394c5f143a7b597(inMemoryPreviousTraceInfo.spanContext))
            },
            sampleRand: inMemoryPreviousTraceInfo.sampleRand
        });
        mutableSamplingContextData.parentSampled = $708fd5b70f5584b2$export$f394c5f143a7b597(inMemoryPreviousTraceInfo.spanContext);
        mutableSamplingContextData.parentSampleRate = inMemoryPreviousTraceInfo.sampleRate;
        mutableSamplingContextData.spanAttributes = {
            ...mutableSamplingContextData.spanAttributes,
            [(0, $f337c80285f06f80$export$889fb736668e1ecc)]: inMemoryPreviousTraceInfo.sampleRate
        };
    });
}
/**
 * Adds a previous_trace span link to the passed span if the passed
 * previousTraceInfo is still valid.
 *
 * @returns the updated previous trace info (based on the current span/trace) to
 * be used on the next call
 */ function $708fd5b70f5584b2$export$ae31cf84cbfc630e(previousTraceInfo, span, oldPropagationContext) {
    const spanJson = (0, $bb9b6447bf4caedb$export$92d8c23565496537)(span);
    function getSampleRate() {
        try {
            return Number(oldPropagationContext.dsc?.sample_rate) ?? Number(spanJson.data?.[0, $f337c80285f06f80$export$ccfe0a40627cc34b]);
        } catch  {
            return 0;
        }
    }
    const updatedPreviousTraceInfo = {
        spanContext: span.spanContext(),
        startTimestamp: spanJson.start_timestamp,
        sampleRate: getSampleRate(),
        sampleRand: oldPropagationContext.sampleRand
    };
    if (!previousTraceInfo) return updatedPreviousTraceInfo;
    const previousTraceSpanCtx = previousTraceInfo.spanContext;
    if (previousTraceSpanCtx.traceId === spanJson.trace_id) // This means, we're still in the same trace so let's not update the previous trace info
    // or add a link to the current span.
    // Once we move away from the long-lived, route-based trace model, we can remove this cases
    return previousTraceInfo;
    // Only add the link if the startTimeStamp of the previous trace's root span is within
    // PREVIOUS_TRACE_MAX_DURATION (1h) of the current root span's startTimestamp
    // This is done to
    // - avoid adding links to "stale" traces
    // - enable more efficient querying for previous/next traces in Sentry
    if (Date.now() / 1000 - previousTraceInfo.startTimestamp <= $708fd5b70f5584b2$export$c8d616af96ac729f) {
        if (0, $6e9d48dbcf18d05a$export$16a28057038b10ef) (0, $d11ed0b3cdda6b8d$export$1c9f709888824e05).log(`Adding previous_trace \`${JSON.stringify(previousTraceSpanCtx)}\` link to span \`${JSON.stringify({
            op: spanJson.op,
            ...span.spanContext()
        })}\``);
        span.addLink({
            context: previousTraceSpanCtx,
            attributes: {
                [(0, $f337c80285f06f80$export$ff77b5fd5b2d627b)]: 'previous_trace'
            }
        });
        // TODO: Remove this once EAP can store span links. We currently only set this attribute so that we
        // can obtain the previous trace information from the EAP store. Long-term, EAP will handle
        // span links and then we should remove this again. Also throwing in a TODO(v11), to remind us
        // to check this at v11 time :)
        span.setAttribute($708fd5b70f5584b2$export$237518aee8726f02, `${previousTraceSpanCtx.traceId}-${previousTraceSpanCtx.spanId}-${$708fd5b70f5584b2$export$f394c5f143a7b597(previousTraceSpanCtx) ? 1 : 0}`);
    }
    return updatedPreviousTraceInfo;
}
/**
 * Stores @param previousTraceInfo in sessionStorage.
 */ function $708fd5b70f5584b2$export$e3dcc2666496dd96(previousTraceInfo) {
    try {
        (0, $e62dec891f31852b$export$56d8a8a25bd48b81).sessionStorage.setItem($708fd5b70f5584b2$export$16b6aa13b3c0f075, JSON.stringify(previousTraceInfo));
    } catch (e) {
        // Ignore potential errors (e.g. if sessionStorage is not available)
        (0, $6e9d48dbcf18d05a$export$16a28057038b10ef) && (0, $d11ed0b3cdda6b8d$export$1c9f709888824e05).warn('Could not store previous trace in sessionStorage', e);
    }
}
/**
 * Retrieves the previous trace from sessionStorage if available.
 */ function $708fd5b70f5584b2$export$ef546bba8a402d99() {
    try {
        const previousTraceInfo = (0, $e62dec891f31852b$export$56d8a8a25bd48b81).sessionStorage?.getItem($708fd5b70f5584b2$export$16b6aa13b3c0f075);
        // @ts-expect-error - intentionally risking JSON.parse throwing when previousTraceInfo is null to save bundle size
        return JSON.parse(previousTraceInfo);
    } catch  {
        return undefined;
    }
}
/**
 * see {@link import('@sentry/core').spanIsSampled}
 */ function $708fd5b70f5584b2$export$f394c5f143a7b597(ctx) {
    return ctx.traceFlags === 0x1;
}



const $7b5f2a588355dc11$export$bbd2089f30bd3708 = 'BrowserTracing';
/**
 * We don't want to start a bunch of idle timers and PerformanceObservers
 * for web crawlers, as they may prevent the page from being seen as "idle"
 * by the crawler's rendering engine (e.g. Googlebot's headless Chromium).
 */ const $7b5f2a588355dc11$var$BOT_USER_AGENT_RE = /Googlebot|Google-InspectionTool|Storebot-Google|Bingbot|Slurp|DuckDuckBot|Baiduspider|YandexBot|Facebot|facebookexternalhit|LinkedInBot|Twitterbot|Applebot/i;
function $7b5f2a588355dc11$var$_isBotUserAgent() {
    const nav = (0, $e62dec891f31852b$export$56d8a8a25bd48b81).navigator;
    if (!nav?.userAgent) return false;
    return $7b5f2a588355dc11$var$BOT_USER_AGENT_RE.test(nav.userAgent);
}
const $7b5f2a588355dc11$var$DEFAULT_BROWSER_TRACING_OPTIONS = {
    ...(0, $136666061888e579$export$809a2b7987fd5306),
    instrumentNavigation: true,
    instrumentPageLoad: true,
    markBackgroundSpan: true,
    enableLongTask: true,
    enableLongAnimationFrame: true,
    enableInp: true,
    enableElementTiming: true,
    ignoreResourceSpans: [],
    ignorePerformanceApiSpans: [],
    detectRedirects: true,
    linkPreviousTrace: 'in-memory',
    consistentTraceSampling: false,
    enableReportPageLoaded: false,
    _experiments: {},
    ...(0, $b3e0e430d6ae504d$export$cc17fb3c0bc95cd7)
};
/**
 * The Browser Tracing integration automatically instruments browser pageload/navigation
 * actions as transactions, and captures requests, metrics and errors as spans.
 *
 * The integration can be configured with a variety of options, and can be extended to use
 * any routing library.
 *
 * We explicitly export the proper type here, as this has to be extended in some cases.
 */ const $7b5f2a588355dc11$export$b4109253475213e9 = (options = {})=>{
    const latestRoute = {
        name: undefined,
        source: undefined
    };
    /**
   * This is just a small wrapper that makes `document` optional.
   * We want to be extra-safe and always check that this exists, to ensure weird environments do not blow up.
   */ const optionalWindowDocument = (0, $e62dec891f31852b$export$56d8a8a25bd48b81).document;
    const { enableInp: enableInp, enableElementTiming: enableElementTiming, enableLongTask: enableLongTask, enableLongAnimationFrame: enableLongAnimationFrame, _experiments: { enableInteractions: enableInteractions, enableStandaloneClsSpans: enableStandaloneClsSpans, enableStandaloneLcpSpans: enableStandaloneLcpSpans }, beforeStartSpan: beforeStartSpan, idleTimeout: idleTimeout, finalTimeout: finalTimeout, childSpanTimeout: childSpanTimeout, markBackgroundSpan: markBackgroundSpan, traceFetch: traceFetch, traceXHR: traceXHR, trackFetchStreamPerformance: trackFetchStreamPerformance, shouldCreateSpanForRequest: shouldCreateSpanForRequest, enableHTTPTimings: enableHTTPTimings, ignoreResourceSpans: ignoreResourceSpans, ignorePerformanceApiSpans: ignorePerformanceApiSpans, instrumentPageLoad: instrumentPageLoad, instrumentNavigation: instrumentNavigation, detectRedirects: detectRedirects, linkPreviousTrace: linkPreviousTrace, consistentTraceSampling: consistentTraceSampling, enableReportPageLoaded: enableReportPageLoaded, onRequestSpanStart: onRequestSpanStart, onRequestSpanEnd: onRequestSpanEnd } = {
        ...$7b5f2a588355dc11$var$DEFAULT_BROWSER_TRACING_OPTIONS,
        ...options
    };
    const _isBot = $7b5f2a588355dc11$var$_isBotUserAgent();
    let _collectWebVitals;
    let lastInteractionTimestamp;
    let _pageloadSpan;
    /** Create routing idle transaction. */ function _createRouteSpan(client, startSpanOptions, makeActive = true) {
        const isPageloadSpan = startSpanOptions.op === 'pageload';
        const initialSpanName = startSpanOptions.name;
        const finalStartSpanOptions = beforeStartSpan ? beforeStartSpan(startSpanOptions) : startSpanOptions;
        const attributes = finalStartSpanOptions.attributes || {};
        // If `finalStartSpanOptions.name` is different than `startSpanOptions.name`
        // it is because `beforeStartSpan` set a custom name. Therefore we set the source to 'custom'.
        if (initialSpanName !== finalStartSpanOptions.name) {
            attributes[0, $f337c80285f06f80$export$d7a7d984b0791405] = 'custom';
            finalStartSpanOptions.attributes = attributes;
        }
        if (!makeActive) {
            // We want to ensure this has 0s duration
            const now = (0, $bc81602376c48fa6$export$7740643b9eeaf0c4)();
            (0, $c9161b67125aefc1$export$63dbba021a6b4047)({
                ...finalStartSpanOptions,
                startTime: now
            }).end(now);
            return;
        }
        latestRoute.name = finalStartSpanOptions.name;
        latestRoute.source = attributes[0, $f337c80285f06f80$export$d7a7d984b0791405];
        const idleSpan = (0, $136666061888e579$export$901bffd97bd52797)(finalStartSpanOptions, {
            idleTimeout: idleTimeout,
            finalTimeout: finalTimeout,
            childSpanTimeout: childSpanTimeout,
            // should wait for finish signal if it's a pageload transaction
            disableAutoFinish: isPageloadSpan,
            beforeSpanEnd: (span)=>{
                // This will generally always be defined here, because it is set in `setup()` of the integration
                // but technically, it is optional, so we guard here to be extra safe
                _collectWebVitals?.();
                (0, $540e2256a3cced48$export$5f8fa6b3467a7443)(span, {
                    recordClsOnPageloadSpan: !enableStandaloneClsSpans,
                    recordLcpOnPageloadSpan: !enableStandaloneLcpSpans,
                    ignoreResourceSpans: ignoreResourceSpans,
                    ignorePerformanceApiSpans: ignorePerformanceApiSpans
                });
                $7b5f2a588355dc11$var$setActiveIdleSpan(client, undefined);
                // A trace should stay consistent over the entire timespan of one route - even after the pageload/navigation ended.
                // Only when another navigation happens, we want to create a new trace.
                // This way, e.g. errors that occur after the pageload span ended are still associated to the pageload trace.
                const scope = (0, $7d48e1ed9f699a01$export$c7be4b0125a10cba)();
                const oldPropagationContext = scope.getPropagationContext();
                scope.setPropagationContext({
                    ...oldPropagationContext,
                    traceId: idleSpan.spanContext().traceId,
                    sampled: (0, $bb9b6447bf4caedb$export$5caecac1caaf3a71)(idleSpan),
                    dsc: (0, $09fae5ef8120e803$export$a117f995597e25df)(span)
                });
                if (isPageloadSpan) // clean up the stored pageload span on the intergration.
                _pageloadSpan = undefined;
            },
            trimIdleSpanEndTimestamp: !enableReportPageLoaded
        });
        if (isPageloadSpan && enableReportPageLoaded) _pageloadSpan = idleSpan;
        $7b5f2a588355dc11$var$setActiveIdleSpan(client, idleSpan);
        function emitFinish() {
            if (optionalWindowDocument && [
                'interactive',
                'complete'
            ].includes(optionalWindowDocument.readyState)) client.emit('idleSpanEnableAutoFinish', idleSpan);
        }
        // Enable auto finish of the pageload span if users are not explicitly ending it
        if (isPageloadSpan && !enableReportPageLoaded && optionalWindowDocument) {
            optionalWindowDocument.addEventListener('readystatechange', ()=>{
                emitFinish();
            });
            emitFinish();
        }
    }
    return {
        name: $7b5f2a588355dc11$export$bbd2089f30bd3708,
        setup (client) {
            if (_isBot) {
                (0, $6e9d48dbcf18d05a$export$16a28057038b10ef) && (0, $d11ed0b3cdda6b8d$export$1c9f709888824e05).log('[Tracing] Skipping browserTracingIntegration setup for bot user agent.');
                return;
            }
            (0, $154c5a3196d0f5d1$export$b0914730ee1f6c80)();
            _collectWebVitals = (0, $540e2256a3cced48$export$7c69f0412d101b88)({
                recordClsStandaloneSpans: enableStandaloneClsSpans || false,
                recordLcpStandaloneSpans: enableStandaloneLcpSpans || false,
                client: client
            });
            if (enableInp) (0, $1f65e1a74bae63ce$export$f17d06681a4744a3)();
            if (enableElementTiming) (0, $c5102c8a625aa6b3$export$c9ffcf7e2b5ec1b3)();
            if (enableLongAnimationFrame && (0, $736a69486c86d36c$export$f1a6cdb1459e81d1).PerformanceObserver && PerformanceObserver.supportedEntryTypes?.includes('long-animation-frame')) (0, $540e2256a3cced48$export$5b823ab2ccbc801d)();
            else if (enableLongTask) (0, $540e2256a3cced48$export$f396d19077034ad2)();
            if (enableInteractions) (0, $540e2256a3cced48$export$e27543e0976315e4)();
            if (detectRedirects && optionalWindowDocument) {
                const interactionHandler = ()=>{
                    lastInteractionTimestamp = (0, $bc81602376c48fa6$export$ee52dced521e3e18)();
                };
                addEventListener('click', interactionHandler, {
                    capture: true
                });
                addEventListener('keydown', interactionHandler, {
                    capture: true,
                    passive: true
                });
            }
            function maybeEndActiveSpan() {
                const activeSpan = $7b5f2a588355dc11$var$getActiveIdleSpan(client);
                if (activeSpan && !(0, $bb9b6447bf4caedb$export$92d8c23565496537)(activeSpan).timestamp) {
                    (0, $6e9d48dbcf18d05a$export$16a28057038b10ef) && (0, $d11ed0b3cdda6b8d$export$1c9f709888824e05).log(`[Tracing] Finishing current active span with op: ${(0, $bb9b6447bf4caedb$export$92d8c23565496537)(activeSpan).op}`);
                    // If there's an open active span, we need to finish it before creating an new one.
                    activeSpan.setAttribute((0, $f337c80285f06f80$export$ba73f34502b7a3b3), 'cancelled');
                    activeSpan.end();
                }
            }
            client.on('startNavigationSpan', (startSpanOptions, navigationOptions)=>{
                if ((0, $7d48e1ed9f699a01$export$6bb76d6eba7e258c)() !== client) return;
                if (navigationOptions?.isRedirect) {
                    (0, $6e9d48dbcf18d05a$export$16a28057038b10ef) && (0, $d11ed0b3cdda6b8d$export$1c9f709888824e05).warn('[Tracing] Detected redirect, navigation span will not be the root span, but a child span.');
                    _createRouteSpan(client, {
                        op: 'navigation.redirect',
                        ...startSpanOptions
                    }, false);
                    return;
                }
                // Reset the last interaction timestamp since we now start a new navigation.
                // Any subsequent navigation span starts could again be a redirect, so we
                // should reset our heuristic detectors.
                lastInteractionTimestamp = undefined;
                maybeEndActiveSpan();
                (0, $7d48e1ed9f699a01$export$68f3af03034c9e90)().setPropagationContext({
                    traceId: (0, $ece9bac57decbcb8$export$dc6d7ea554bcce10)(),
                    sampleRand: Math.random(),
                    propagationSpanId: (0, $e3827447d651dfc5$export$1f70765132c3c225)() ? undefined : (0, $ece9bac57decbcb8$export$295213bc4d0c54ad)()
                });
                const scope = (0, $7d48e1ed9f699a01$export$c7be4b0125a10cba)();
                scope.setPropagationContext({
                    traceId: (0, $ece9bac57decbcb8$export$dc6d7ea554bcce10)(),
                    sampleRand: Math.random(),
                    propagationSpanId: (0, $e3827447d651dfc5$export$1f70765132c3c225)() ? undefined : (0, $ece9bac57decbcb8$export$295213bc4d0c54ad)()
                });
                // We reset this to ensure we do not have lingering incorrect data here
                // places that call this hook may set this where appropriate - else, the URL at span sending time is used
                scope.setSDKProcessingMetadata({
                    normalizedRequest: undefined
                });
                _createRouteSpan(client, {
                    op: 'navigation',
                    ...startSpanOptions,
                    // Navigation starts a new trace and is NOT parented under any active interaction (e.g. ui.action.click)
                    parentSpan: null,
                    forceTransaction: true
                });
            });
            client.on('startPageLoadSpan', (startSpanOptions, traceOptions = {})=>{
                if ((0, $7d48e1ed9f699a01$export$6bb76d6eba7e258c)() !== client) return;
                maybeEndActiveSpan();
                const sentryTrace = traceOptions.sentryTrace || $7b5f2a588355dc11$export$f147b32b03c9cf11('sentry-trace') || $7b5f2a588355dc11$export$5bb9693b37f7c2ae('sentry-trace');
                const baggage = traceOptions.baggage || $7b5f2a588355dc11$export$f147b32b03c9cf11('baggage') || $7b5f2a588355dc11$export$5bb9693b37f7c2ae('baggage');
                const propagationContext = (0, $bcc4fe773b74e41d$export$261f383d16a93e39)(sentryTrace, baggage);
                const scope = (0, $7d48e1ed9f699a01$export$c7be4b0125a10cba)();
                scope.setPropagationContext(propagationContext);
                if (!(0, $e3827447d651dfc5$export$1f70765132c3c225)()) // for browser, we wanna keep the spanIds consistent during the entire lifetime of the trace
                // this works by setting the propagationSpanId to a random spanId so that we have a consistent
                // span id to propagate in TwP mode (!hasSpansEnabled())
                scope.getPropagationContext().propagationSpanId = (0, $ece9bac57decbcb8$export$295213bc4d0c54ad)();
                // We store the normalized request data on the scope, so we get the request data at time of span creation
                // otherwise, the URL etc. may already be of the following navigation, and we'd report the wrong URL
                scope.setSDKProcessingMetadata({
                    normalizedRequest: (0, $e62dec891f31852b$export$a3c4a8453e8936f0)()
                });
                _createRouteSpan(client, {
                    op: 'pageload',
                    ...startSpanOptions
                });
            });
            client.on('endPageloadSpan', ()=>{
                if (enableReportPageLoaded && _pageloadSpan) {
                    _pageloadSpan.setAttribute((0, $f337c80285f06f80$export$ba73f34502b7a3b3), 'reportPageLoaded');
                    _pageloadSpan.end();
                }
            });
        },
        afterAllSetup (client) {
            if (_isBot) return;
            let startingUrl = (0, $caac489b9d8395b2$export$1cfafeee2987818b)();
            if (linkPreviousTrace !== 'off') (0, $708fd5b70f5584b2$export$830d9ee659c6e4c4)(client, {
                linkPreviousTrace: linkPreviousTrace,
                consistentTraceSampling: consistentTraceSampling
            });
            if ((0, $e62dec891f31852b$export$56d8a8a25bd48b81).location) {
                if (instrumentPageLoad) {
                    const origin = (0, $bc81602376c48fa6$export$baf075a948ffc0bf)();
                    $7b5f2a588355dc11$export$aa44a07f82af519f(client, {
                        name: (0, $e62dec891f31852b$export$56d8a8a25bd48b81).location.pathname,
                        // pageload should always start at timeOrigin (and needs to be in s, not ms)
                        startTime: origin ? origin / 1000 : undefined,
                        attributes: {
                            [(0, $f337c80285f06f80$export$d7a7d984b0791405)]: 'url',
                            [(0, $f337c80285f06f80$export$cca8dd30f57f805e)]: 'auto.pageload.browser'
                        }
                    });
                }
                if (instrumentNavigation) (0, $56137aac5362694e$export$3f18c56c58114e75)(({ to: to, from: from })=>{
                    /**
             * This early return is there to account for some cases where a navigation transaction starts right after
             * long-running pageload. We make sure that if `from` is undefined and a valid `startingURL` exists, we don't
             * create an uneccessary navigation transaction.
             *
             * This was hard to duplicate, but this behavior stopped as soon as this fix was applied. This issue might also
             * only be caused in certain development environments where the usage of a hot module reloader is causing
             * errors.
             */ if (from === undefined && startingUrl?.indexOf(to) !== -1) {
                        startingUrl = undefined;
                        return;
                    }
                    startingUrl = undefined;
                    const parsed = (0, $0c1b93525a804899$export$2004d912a9ead694)(to);
                    const activeSpan = $7b5f2a588355dc11$var$getActiveIdleSpan(client);
                    const navigationIsRedirect = activeSpan && detectRedirects && $7b5f2a588355dc11$var$isRedirect(activeSpan, lastInteractionTimestamp);
                    $7b5f2a588355dc11$export$7d159749bd9969ad(client, {
                        name: parsed?.pathname || (0, $e62dec891f31852b$export$56d8a8a25bd48b81).location.pathname,
                        attributes: {
                            [(0, $f337c80285f06f80$export$d7a7d984b0791405)]: 'url',
                            [(0, $f337c80285f06f80$export$cca8dd30f57f805e)]: 'auto.navigation.browser'
                        }
                    }, {
                        url: to,
                        isRedirect: navigationIsRedirect
                    });
                });
            }
            if (markBackgroundSpan) (0, $e2a93f4a13ed6e48$export$6f18f55521af71a1)();
            if (enableInteractions) $7b5f2a588355dc11$var$registerInteractionListener(client, idleTimeout, finalTimeout, childSpanTimeout, latestRoute);
            if (enableInp) (0, $1f65e1a74bae63ce$export$e4e04d43e223cce2)();
            (0, $b3e0e430d6ae504d$export$864489cb3478db3e)(client, {
                traceFetch: traceFetch,
                traceXHR: traceXHR,
                trackFetchStreamPerformance: trackFetchStreamPerformance,
                tracePropagationTargets: client.getOptions().tracePropagationTargets,
                shouldCreateSpanForRequest: shouldCreateSpanForRequest,
                enableHTTPTimings: enableHTTPTimings,
                onRequestSpanStart: onRequestSpanStart,
                onRequestSpanEnd: onRequestSpanEnd
            });
        }
    };
};
/**
 * Manually start a page load span.
 * This will only do something if a browser tracing integration integration has been setup.
 *
 * If you provide a custom `traceOptions` object, it will be used to continue the trace
 * instead of the default behavior, which is to look it up on the <meta> tags.
 */ function $7b5f2a588355dc11$export$aa44a07f82af519f(client, spanOptions, traceOptions) {
    client.emit('startPageLoadSpan', spanOptions, traceOptions);
    (0, $7d48e1ed9f699a01$export$c7be4b0125a10cba)().setTransactionName(spanOptions.name);
    const pageloadSpan = $7b5f2a588355dc11$var$getActiveIdleSpan(client);
    if (pageloadSpan) client.emit('afterStartPageLoadSpan', pageloadSpan);
    return pageloadSpan;
}
/**
 * Manually start a navigation span.
 * This will only do something if a browser tracing integration has been setup.
 */ function $7b5f2a588355dc11$export$7d159749bd9969ad(client, spanOptions, options) {
    const { url: url, isRedirect: isRedirect } = options || {};
    client.emit('beforeStartNavigationSpan', spanOptions, {
        isRedirect: isRedirect
    });
    client.emit('startNavigationSpan', spanOptions, {
        isRedirect: isRedirect
    });
    const scope = (0, $7d48e1ed9f699a01$export$c7be4b0125a10cba)();
    scope.setTransactionName(spanOptions.name);
    // We store the normalized request data on the scope, so we get the request data at time of span creation
    // otherwise, the URL etc. may already be of the following navigation, and we'd report the wrong URL
    if (url && !isRedirect) scope.setSDKProcessingMetadata({
        normalizedRequest: {
            ...(0, $e62dec891f31852b$export$a3c4a8453e8936f0)(),
            url: url
        }
    });
    return $7b5f2a588355dc11$var$getActiveIdleSpan(client);
}
/** Returns the value of a meta tag */ function $7b5f2a588355dc11$export$f147b32b03c9cf11(metaName) {
    /**
   * This is just a small wrapper that makes `document` optional.
   * We want to be extra-safe and always check that this exists, to ensure weird environments do not blow up.
   */ const optionalWindowDocument = (0, $e62dec891f31852b$export$56d8a8a25bd48b81).document;
    const metaTag = optionalWindowDocument?.querySelector(`meta[name=${metaName}]`);
    return metaTag?.getAttribute('content') || undefined;
}
/** Returns the description of a server timing entry */ function $7b5f2a588355dc11$export$5bb9693b37f7c2ae(name) {
    const navigation = (0, $e62dec891f31852b$export$56d8a8a25bd48b81).performance?.getEntriesByType?.('navigation')[0];
    const entry = navigation?.serverTiming?.find((entry)=>entry.name === name);
    return entry?.description;
}
/** Start listener for interaction transactions */ function $7b5f2a588355dc11$var$registerInteractionListener(client, idleTimeout, finalTimeout, childSpanTimeout, latestRoute) {
    /**
   * This is just a small wrapper that makes `document` optional.
   * We want to be extra-safe and always check that this exists, to ensure weird environments do not blow up.
   */ const optionalWindowDocument = (0, $e62dec891f31852b$export$56d8a8a25bd48b81).document;
    let inflightInteractionSpan;
    const registerInteractionTransaction = ()=>{
        const op = 'ui.action.click';
        const activeIdleSpan = $7b5f2a588355dc11$var$getActiveIdleSpan(client);
        if (activeIdleSpan) {
            const currentRootSpanOp = (0, $bb9b6447bf4caedb$export$92d8c23565496537)(activeIdleSpan).op;
            if ([
                'navigation',
                'pageload'
            ].includes(currentRootSpanOp)) {
                (0, $6e9d48dbcf18d05a$export$16a28057038b10ef) && (0, $d11ed0b3cdda6b8d$export$1c9f709888824e05).warn(`[Tracing] Did not create ${op} span because a pageload or navigation span is in progress.`);
                return undefined;
            }
        }
        if (inflightInteractionSpan) {
            inflightInteractionSpan.setAttribute((0, $f337c80285f06f80$export$ba73f34502b7a3b3), 'interactionInterrupted');
            inflightInteractionSpan.end();
            inflightInteractionSpan = undefined;
        }
        if (!latestRoute.name) {
            (0, $6e9d48dbcf18d05a$export$16a28057038b10ef) && (0, $d11ed0b3cdda6b8d$export$1c9f709888824e05).warn(`[Tracing] Did not create ${op} transaction because _latestRouteName is missing.`);
            return undefined;
        }
        inflightInteractionSpan = (0, $136666061888e579$export$901bffd97bd52797)({
            name: latestRoute.name,
            op: op,
            attributes: {
                [(0, $f337c80285f06f80$export$d7a7d984b0791405)]: latestRoute.source || 'url'
            }
        }, {
            idleTimeout: idleTimeout,
            finalTimeout: finalTimeout,
            childSpanTimeout: childSpanTimeout
        });
    };
    if (optionalWindowDocument) addEventListener('click', registerInteractionTransaction, {
        capture: true
    });
}
// We store the active idle span on the client object, so we can access it from exported functions
const $7b5f2a588355dc11$var$ACTIVE_IDLE_SPAN_PROPERTY = '_sentry_idleSpan';
function $7b5f2a588355dc11$var$getActiveIdleSpan(client) {
    return client[$7b5f2a588355dc11$var$ACTIVE_IDLE_SPAN_PROPERTY];
}
function $7b5f2a588355dc11$var$setActiveIdleSpan(client, span) {
    (0, $269eeb69635ed414$export$e73679ffaf56810e)(client, $7b5f2a588355dc11$var$ACTIVE_IDLE_SPAN_PROPERTY, span);
}
// The max. time in seconds between two pageload/navigation spans that makes us consider the second one a redirect
const $7b5f2a588355dc11$var$REDIRECT_THRESHOLD = 1.5;
function $7b5f2a588355dc11$var$isRedirect(activeSpan, lastInteractionTimestamp) {
    const spanData = (0, $bb9b6447bf4caedb$export$92d8c23565496537)(activeSpan);
    const now = (0, $bc81602376c48fa6$export$7740643b9eeaf0c4)();
    // More than REDIRECT_THRESHOLD seconds since last navigation/pageload span?
    // --> never consider this a redirect
    const startTimestamp = spanData.start_timestamp;
    if (now - startTimestamp > $7b5f2a588355dc11$var$REDIRECT_THRESHOLD) return false;
    // A click happened in the last REDIRECT_THRESHOLD seconds?
    // --> never consider this a redirect
    if (lastInteractionTimestamp && now - lastInteractionTimestamp <= $7b5f2a588355dc11$var$REDIRECT_THRESHOLD) return false;
    return true;
}



/**
 * Manually report the end of the page load, resulting in the SDK ending the pageload span.
 * This only works if {@link BrowserTracingOptions.enableReportPageLoaded} is set to `true`.
 * Otherwise, the pageload span will end itself based on the {@link BrowserTracingOptions.finalTimeout},
 * {@link BrowserTracingOptions.idleTimeout} and {@link BrowserTracingOptions.childSpanTimeout}.
 *
 * @param client - The client to use. If not provided, the global client will be used.
 */ function $e3f9649a5fcc80c1$export$9e8f428c76bd6d1b(client = (0, $7d48e1ed9f699a01$export$6bb76d6eba7e258c)()) {
    client?.emit('endPageloadSpan');
}



/**
 * Sets an inactive span active on the current scope.
 *
 * This is useful in browser applications, if you want to create a span that cannot be finished
 * within its callback. Any spans started while the given span is active, will be children of the span.
 *
 * If there already was an active span on the scope prior to calling this function, it is replaced
 * with the given span and restored after the span ended. Otherwise, the span will simply be
 * removed, resulting in no active span on the scope.
 *
 * IMPORTANT: This function can ONLY be used in the browser! Calling this function in a server
 * environment (for example in a server-side rendered component) will result in undefined behaviour
 * and is not supported.
 * You MUST call `span.end()` manually, otherwise the span will never be finished.
 *
 * @example
 * ```js
 * let checkoutSpan;
 *
 * on('checkoutStarted', () => {
 *  checkoutSpan = Sentry.startInactiveSpan({ name: 'checkout-flow' });
 *  Sentry.setActiveSpanInBrowser(checkoutSpan);
 * })
 *
 * // during this time, any spans started will be children of `checkoutSpan`:
 * Sentry.startSpan({ name: 'checkout-step-1' }, () => {
 *  // ... `
 * })
 *
 * on('checkoutCompleted', () => {
 *  checkoutSpan?.end();
 * })
 * ```
 *
 * @param span - the span to set active
 */ function $40d8570c26789de3$export$4519ca486fe8649b(span) {
    const maybePreviousActiveSpan = (0, $bb9b6447bf4caedb$export$1be426a8e585c83e)();
    // If the span is already active, there's no need to double-patch or set it again.
    // This also guards against users (for whatever reason) calling setActiveSpanInBrowser on SDK-started
    // idle spans like pageload or navigation spans. These will already be handled correctly by the SDK.
    // For nested situations, we have to double-patch to ensure we restore the correct previous span (see tests)
    if (maybePreviousActiveSpan === span) return;
    const scope = (0, $7d48e1ed9f699a01$export$c7be4b0125a10cba)();
    // Putting a small patch onto the span.end method to ensure we
    // remove the span from the scope when it ends.
    // eslint-disable-next-line @typescript-eslint/unbound-method
    span.end = new Proxy(span.end, {
        apply (target, thisArg, args) {
            (0, $dab1970d0c142a42$export$3f25fa50c18e20ca)(scope, maybePreviousActiveSpan);
            return Reflect.apply(target, thisArg, args);
        }
    });
    (0, $dab1970d0c142a42$export$3f25fa50c18e20ca)(scope, span);
}







const $8267ed1c9b820dee$export$638fddefcf0452da = 100; // 100 ms
const $8267ed1c9b820dee$export$998db03eaf5cf3f3 = 5000; // 5 seconds
const $8267ed1c9b820dee$var$MAX_DELAY = 3.6e6; // 1 hour
/**
 * Wraps a transport and stores and retries events when they fail to send.
 *
 * @param createTransport The transport to wrap.
 */ function $8267ed1c9b820dee$export$405ec66a0e87547a(createTransport) {
    function log(...args) {
        (0, $19fdbaf7f0830971$export$16a28057038b10ef) && (0, $d11ed0b3cdda6b8d$export$1c9f709888824e05).log('[Offline]:', ...args);
    }
    return (options)=>{
        const transport = createTransport(options);
        if (!options.createStore) throw new Error('No `createStore` function was provided');
        const store = options.createStore(options);
        let retryDelay = $8267ed1c9b820dee$export$998db03eaf5cf3f3;
        let flushTimer;
        function shouldQueue(env, error, retryDelay) {
            // We want to drop client reports because they can be generated when we retry sending events while offline.
            if ((0, $bb063ad93c8b79c7$export$604a45d95a155e2b)(env, [
                'client_report'
            ])) return false;
            if (options.shouldStore) return options.shouldStore(env, error, retryDelay);
            return true;
        }
        function flushIn(delay) {
            if (flushTimer) clearTimeout(flushTimer);
            // We need to unref the timer in node.js, otherwise the node process never exit.
            flushTimer = (0, $eb2fc1cbe65ebe8f$export$630056cb83d87863)(setTimeout(async ()=>{
                flushTimer = undefined;
                const found = await store.shift();
                if (found) {
                    log('Attempting to send previously queued event');
                    // We should to update the sent_at timestamp to the current time.
                    found[0].sent_at = new Date().toISOString();
                    send(found, true).catch((e)=>{
                        log('Failed to retry sending', e);
                    });
                }
            }, delay));
        }
        function flushWithBackOff() {
            if (flushTimer) return;
            flushIn(retryDelay);
            retryDelay = Math.min(retryDelay * 2, $8267ed1c9b820dee$var$MAX_DELAY);
        }
        async function send(envelope, isRetry = false) {
            // We queue all replay envelopes to avoid multiple replay envelopes being sent at the same time. If one fails, we
            // need to retry them in order.
            if (!isRetry && (0, $bb063ad93c8b79c7$export$604a45d95a155e2b)(envelope, [
                'replay_event',
                'replay_recording'
            ])) {
                await store.push(envelope);
                flushIn($8267ed1c9b820dee$export$638fddefcf0452da);
                return {};
            }
            try {
                if (options.shouldSend && await options.shouldSend(envelope) === false) throw new Error('Envelope not sent because `shouldSend` callback returned false');
                const result = await transport.send(envelope);
                let delay = $8267ed1c9b820dee$export$638fddefcf0452da;
                if (result) {
                    // If there's a retry-after header, use that as the next delay.
                    if (result.headers?.['retry-after']) delay = (0, $33414f31f3554c40$export$615352e17ed7741)(result.headers['retry-after']);
                    else if (result.headers?.['x-sentry-rate-limits']) delay = 60000; // 60 seconds
                    else if ((result.statusCode || 0) >= 400) return result;
                }
                flushIn(delay);
                retryDelay = $8267ed1c9b820dee$export$998db03eaf5cf3f3;
                return result;
            } catch (e) {
                if (await shouldQueue(envelope, e, retryDelay)) {
                    // If this envelope was a retry, we want to add it to the front of the queue so it's retried again first.
                    if (isRetry) await store.unshift(envelope);
                    else await store.push(envelope);
                    flushWithBackOff();
                    log('Error sending. Event queued.', e);
                    return {};
                } else throw e;
            }
        }
        if (options.flushAtStartup) flushWithBackOff();
        return {
            send: send,
            flush: (timeout)=>{
                // If there's no timeout, we should attempt to flush the offline queue.
                if (timeout === undefined) {
                    retryDelay = $8267ed1c9b820dee$export$998db03eaf5cf3f3;
                    flushIn($8267ed1c9b820dee$export$638fddefcf0452da);
                }
                return transport.flush(timeout);
            }
        };
    };
}




// 'Store', 'promisifyRequest' and 'createStore' were originally copied from the 'idb-keyval' package before being
// modified and simplified: https://github.com/jakearchibald/idb-keyval
//
// At commit: 0420a704fd6cbb4225429c536b1f61112d012fca
// Original license:
// Copyright 2016, Jake Archibald
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//   http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
function $c405876784a7ff78$var$promisifyRequest(request) {
    return new Promise((resolve, reject)=>{
        // @ts-expect-error - file size hacks
        request.oncomplete = request.onsuccess = ()=>resolve(request.result);
        // @ts-expect-error - file size hacks
        request.onabort = request.onerror = ()=>reject(request.error);
    });
}
/** Create or open an IndexedDb store */ function $c405876784a7ff78$export$f51a9068ac82ea43(dbName, storeName) {
    const request = indexedDB.open(dbName);
    request.onupgradeneeded = ()=>request.result.createObjectStore(storeName);
    const dbp = $c405876784a7ff78$var$promisifyRequest(request);
    return (callback)=>dbp.then((db)=>callback(db.transaction(storeName, 'readwrite').objectStore(storeName)));
}
function $c405876784a7ff78$var$keys(store) {
    return $c405876784a7ff78$var$promisifyRequest(store.getAllKeys());
}
/** Insert into the end of the store */ function $c405876784a7ff78$export$4cbf152802aa238(store, value, maxQueueSize) {
    return store((store)=>{
        return $c405876784a7ff78$var$keys(store).then((keys)=>{
            if (keys.length >= maxQueueSize) return;
            // We insert with an incremented key so that the entries are popped in order
            store.put(value, Math.max(...keys, 0) + 1);
            return $c405876784a7ff78$var$promisifyRequest(store.transaction);
        });
    });
}
/** Insert into the front of the store */ function $c405876784a7ff78$export$37cdb546b806ae87(store, value, maxQueueSize) {
    return store((store)=>{
        return $c405876784a7ff78$var$keys(store).then((keys)=>{
            if (keys.length >= maxQueueSize) return;
            // We insert with an decremented key so that the entries are popped in order
            store.put(value, Math.min(...keys, 0) - 1);
            return $c405876784a7ff78$var$promisifyRequest(store.transaction);
        });
    });
}
/** Pop the oldest value from the store */ function $c405876784a7ff78$export$fba63a578e423eb(store) {
    return store((store)=>{
        return $c405876784a7ff78$var$keys(store).then((keys)=>{
            const firstKey = keys[0];
            if (firstKey == null) return undefined;
            return $c405876784a7ff78$var$promisifyRequest(store.get(firstKey)).then((value)=>{
                store.delete(firstKey);
                return $c405876784a7ff78$var$promisifyRequest(store.transaction).then(()=>value);
            });
        });
    });
}
function $c405876784a7ff78$var$createIndexedDbStore(options) {
    let store;
    // Lazily create the store only when it's needed
    function getStore() {
        if (store == undefined) store = $c405876784a7ff78$export$f51a9068ac82ea43(options.dbName || 'sentry-offline', options.storeName || 'queue');
        return store;
    }
    return {
        push: async (env)=>{
            try {
                const serialized = (0, $bb063ad93c8b79c7$export$32f9b428425aac85)(env);
                await $c405876784a7ff78$export$4cbf152802aa238(getStore(), serialized, options.maxQueueSize || 30);
            } catch  {
            //
            }
        },
        unshift: async (env)=>{
            try {
                const serialized = (0, $bb063ad93c8b79c7$export$32f9b428425aac85)(env);
                await $c405876784a7ff78$export$37cdb546b806ae87(getStore(), serialized, options.maxQueueSize || 30);
            } catch  {
            //
            }
        },
        shift: async ()=>{
            try {
                const deserialized = await $c405876784a7ff78$export$fba63a578e423eb(getStore());
                if (deserialized) return (0, $bb063ad93c8b79c7$export$3338d0c7b6e17a2b)(deserialized);
            } catch  {
            //
            }
            return undefined;
        }
    };
}
function $c405876784a7ff78$var$makeIndexedDbOfflineTransport(createTransport) {
    return (options)=>{
        const transport = createTransport({
            ...options,
            createStore: $c405876784a7ff78$var$createIndexedDbStore
        });
        (0, $e62dec891f31852b$export$56d8a8a25bd48b81).addEventListener('online', async (_)=>{
            await transport.flush();
        });
        return transport;
    };
}
/**
 * Creates a transport that uses IndexedDb to store events when offline.
 */ function $c405876784a7ff78$export$79c8882827636cf2(createTransport = (0, $366021d20f9daad3$export$b2311068c46d7cc8)) {
    return $c405876784a7ff78$var$makeIndexedDbOfflineTransport((0, $8267ed1c9b820dee$export$405ec66a0e87547a)(createTransport));
}











const $831515ad7ad113dc$var$MS_TO_NS = 1e6;
// Checking if we are in Main or Worker thread: `self` (not `window`) is the `globalThis` in Web Workers and `importScripts` are only available in Web Workers
const $831515ad7ad113dc$var$isMainThread = 'window' in (0, $736a69486c86d36c$export$f1a6cdb1459e81d1) && (0, $736a69486c86d36c$export$f1a6cdb1459e81d1).window === (0, $736a69486c86d36c$export$f1a6cdb1459e81d1) && typeof importScripts === 'undefined';
// Setting ID to 0 as we cannot get an ID from Web Workers
const $831515ad7ad113dc$export$fa7490a9fefa3701 = String(0);
const $831515ad7ad113dc$export$71a451cfb2c2816 = $831515ad7ad113dc$var$isMainThread ? 'main' : 'worker';
// We force make this optional to be on the safe side...
const $831515ad7ad113dc$var$navigator = (0, $e62dec891f31852b$export$56d8a8a25bd48b81).navigator;
// Machine properties (eval only once)
let $831515ad7ad113dc$var$OS_PLATFORM = '';
let $831515ad7ad113dc$var$OS_PLATFORM_VERSION = '';
let $831515ad7ad113dc$var$OS_ARCH = '';
let $831515ad7ad113dc$var$OS_BROWSER = $831515ad7ad113dc$var$navigator?.userAgent || '';
let $831515ad7ad113dc$var$OS_MODEL = '';
const $831515ad7ad113dc$var$OS_LOCALE = $831515ad7ad113dc$var$navigator?.language || $831515ad7ad113dc$var$navigator?.languages?.[0] || '';
function $831515ad7ad113dc$var$isUserAgentData(data) {
    return typeof data === 'object' && data !== null && 'getHighEntropyValues' in data;
}
// @ts-expect-error userAgentData is not part of the navigator interface yet
const $831515ad7ad113dc$var$userAgentData = $831515ad7ad113dc$var$navigator?.userAgentData;
if ($831515ad7ad113dc$var$isUserAgentData($831515ad7ad113dc$var$userAgentData)) $831515ad7ad113dc$var$userAgentData.getHighEntropyValues([
    'architecture',
    'model',
    'platform',
    'platformVersion',
    'fullVersionList'
]).then((ua)=>{
    $831515ad7ad113dc$var$OS_PLATFORM = ua.platform || '';
    $831515ad7ad113dc$var$OS_ARCH = ua.architecture || '';
    $831515ad7ad113dc$var$OS_MODEL = ua.model || '';
    $831515ad7ad113dc$var$OS_PLATFORM_VERSION = ua.platformVersion || '';
    if (ua.fullVersionList?.length) {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const firstUa = ua.fullVersionList[ua.fullVersionList.length - 1];
        $831515ad7ad113dc$var$OS_BROWSER = `${firstUa.brand} ${firstUa.version}`;
    }
}).catch((e)=>void 0);
function $831515ad7ad113dc$var$isProcessedJSSelfProfile(profile) {
    return !('thread_metadata' in profile);
}
// Enriches the profile with threadId of the current thread.
// This is done in node as we seem to not be able to get the info from C native code.
/**
 *
 */ function $831515ad7ad113dc$export$7cbe6c4f12ea8325(profile) {
    if (!$831515ad7ad113dc$var$isProcessedJSSelfProfile(profile)) return profile;
    return $831515ad7ad113dc$export$f4122c775dfac1c2(profile);
}
// Profile is marked as optional because it is deleted from the metadata
// by the integration before the event is processed by other integrations.
function $831515ad7ad113dc$var$getTraceId(event) {
    const traceId = event.contexts?.trace?.trace_id;
    // Log a warning if the profile has an invalid traceId (should be uuidv4).
    // All profiles and transactions are rejected if this is the case and we want to
    // warn users that this is happening if they enable debug flag
    if (typeof traceId === 'string' && traceId.length !== 32) {
        if (0, $6e9d48dbcf18d05a$export$16a28057038b10ef) (0, $d11ed0b3cdda6b8d$export$1c9f709888824e05).log(`[Profiling] Invalid traceId: ${traceId} on profiled event`);
    }
    if (typeof traceId !== 'string') return '';
    return traceId;
}
/**
 * Creates a profiling event envelope from a Sentry event. If profile does not pass
 * validation, returns null.
 * @param event
 * @param dsn
 * @param metadata
 * @param tunnel
 * @returns {EventEnvelope | null}
 */ /**
 * Creates a profiling event envelope from a Sentry event.
 */ function $831515ad7ad113dc$export$5c9f6e262288b7db(profile_id, start_timestamp, processed_profile, event) {
    if (event.type !== 'transaction') // createProfilingEventEnvelope should only be called for transactions,
    // we type guard this behavior with isProfiledTransactionEvent.
    throw new TypeError('Profiling events may only be attached to transactions, this should never occur.');
    if (processed_profile === undefined || processed_profile === null) throw new TypeError(`Cannot construct profiling event envelope without a valid profile. Got ${processed_profile} instead.`);
    const traceId = $831515ad7ad113dc$var$getTraceId(event);
    const enrichedThreadProfile = $831515ad7ad113dc$export$7cbe6c4f12ea8325(processed_profile);
    const transactionStartMs = start_timestamp ? start_timestamp : typeof event.start_timestamp === 'number' ? event.start_timestamp * 1000 : (0, $bc81602376c48fa6$export$ee52dced521e3e18)() * 1000;
    const transactionEndMs = typeof event.timestamp === 'number' ? event.timestamp * 1000 : (0, $bc81602376c48fa6$export$ee52dced521e3e18)() * 1000;
    const profile = {
        event_id: profile_id,
        timestamp: new Date(transactionStartMs).toISOString(),
        platform: 'javascript',
        version: '1',
        release: event.release || '',
        environment: event.environment || (0, $4e93b773a0d3a86a$export$849dbeeeda01ae98),
        runtime: {
            name: 'javascript',
            version: (0, $e62dec891f31852b$export$56d8a8a25bd48b81).navigator.userAgent
        },
        os: {
            name: $831515ad7ad113dc$var$OS_PLATFORM,
            version: $831515ad7ad113dc$var$OS_PLATFORM_VERSION,
            build_number: $831515ad7ad113dc$var$OS_BROWSER
        },
        device: {
            locale: $831515ad7ad113dc$var$OS_LOCALE,
            model: $831515ad7ad113dc$var$OS_MODEL,
            manufacturer: $831515ad7ad113dc$var$OS_BROWSER,
            architecture: $831515ad7ad113dc$var$OS_ARCH,
            is_emulator: false
        },
        debug_meta: {
            images: $831515ad7ad113dc$export$4c0b0d8ee0d018b5(processed_profile.resources)
        },
        profile: enrichedThreadProfile,
        transactions: [
            {
                name: event.transaction || '',
                id: event.event_id || (0, $cc262db35458e4b3$export$19f53698e68b2496)(),
                trace_id: traceId,
                active_thread_id: $831515ad7ad113dc$export$fa7490a9fefa3701,
                relative_start_ns: '0',
                relative_end_ns: ((transactionEndMs - transactionStartMs) * 1e6).toFixed(0)
            }
        ]
    };
    return profile;
}
/**
 * Create a profile chunk envelope item
 */ function $831515ad7ad113dc$export$4684f29184e0c876(jsSelfProfile, client, profilerId) {
    // only == to catch null and undefined
    if (jsSelfProfile == null) throw new TypeError(`Cannot construct profiling event envelope without a valid profile. Got ${jsSelfProfile} instead.`);
    const continuousProfile = $831515ad7ad113dc$var$convertToContinuousProfile(jsSelfProfile);
    const options = client.getOptions();
    const sdk = client.getSdkMetadata?.()?.sdk;
    return {
        chunk_id: (0, $cc262db35458e4b3$export$19f53698e68b2496)(),
        client_sdk: {
            name: sdk?.name ?? 'sentry.javascript.browser',
            version: sdk?.version ?? '0.0.0'
        },
        profiler_id: profilerId || (0, $cc262db35458e4b3$export$19f53698e68b2496)(),
        platform: 'javascript',
        version: '2',
        release: options.release ?? '',
        environment: options.environment ?? 'production',
        debug_meta: {
            // function name obfuscation
            images: $831515ad7ad113dc$export$4c0b0d8ee0d018b5(jsSelfProfile.resources)
        },
        profile: continuousProfile
    };
}
/**
 * Validate a profile chunk against the Sample Format V2 requirements.
 * https://develop.sentry.dev/sdk/telemetry/profiles/sample-format-v2/
 * - Presence of samples, stacks, frames
 * - Required metadata fields
 */ function $831515ad7ad113dc$export$706bf24a90edd468(chunk) {
    try {
        // Required metadata
        if (!chunk || typeof chunk !== 'object') return {
            reason: 'chunk is not an object'
        };
        // profiler_id and chunk_id must be 32 lowercase hex chars
        const isHex32 = (val)=>typeof val === 'string' && /^[a-f0-9]{32}$/.test(val);
        if (!isHex32(chunk.profiler_id)) return {
            reason: 'missing or invalid profiler_id'
        };
        if (!isHex32(chunk.chunk_id)) return {
            reason: 'missing or invalid chunk_id'
        };
        if (!chunk.client_sdk) return {
            reason: 'missing client_sdk metadata'
        };
        // Profile data must have frames, stacks, samples
        const profile = chunk.profile;
        if (!profile) return {
            reason: 'missing profile data'
        };
        if (!Array.isArray(profile.frames) || !profile.frames.length) return {
            reason: 'profile has no frames'
        };
        if (!Array.isArray(profile.stacks) || !profile.stacks.length) return {
            reason: 'profile has no stacks'
        };
        if (!Array.isArray(profile.samples) || !profile.samples.length) return {
            reason: 'profile has no samples'
        };
        return {
            valid: true
        };
    } catch (e) {
        return {
            reason: `unknown validation error: ${e}`
        };
    }
}
/**
 * Convert from JSSelfProfile format to ContinuousThreadCpuProfile format.
 */ function $831515ad7ad113dc$var$convertToContinuousProfile(input) {
    // Frames map 1:1 by index; fill only when present to avoid sparse writes
    const frames = [];
    for(let i = 0; i < input.frames.length; i++){
        const frame = input.frames[i];
        if (!frame) continue;
        frames[i] = {
            function: frame.name,
            abs_path: typeof frame.resourceId === 'number' ? input.resources[frame.resourceId] : undefined,
            lineno: frame.line,
            colno: frame.column
        };
    }
    // Build stacks by following parent links, top->down order (root last)
    const stacks = [];
    for(let i = 0; i < input.stacks.length; i++){
        const stackHead = input.stacks[i];
        if (!stackHead) continue;
        const list = [];
        let current = stackHead;
        while(current){
            list.push(current.frameId);
            current = current.parentId === undefined ? undefined : input.stacks[current.parentId];
        }
        stacks[i] = list;
    }
    // Align timestamps to SDK time origin to match span/event timelines
    const perfOrigin = (0, $bc81602376c48fa6$export$baf075a948ffc0bf)();
    const origin = typeof performance.timeOrigin === 'number' ? performance.timeOrigin : perfOrigin || 0;
    const adjustForOriginChange = origin - (perfOrigin || origin);
    const samples = [];
    for(let i = 0; i < input.samples.length; i++){
        const sample = input.samples[i];
        if (!sample) continue;
        // Convert ms to seconds epoch-based timestamp
        const timestampSeconds = (origin + (sample.timestamp - adjustForOriginChange)) / 1000;
        samples[i] = {
            stack_id: sample.stackId ?? 0,
            thread_id: $831515ad7ad113dc$export$fa7490a9fefa3701,
            timestamp: timestampSeconds
        };
    }
    return {
        frames: frames,
        stacks: stacks,
        samples: samples,
        thread_metadata: {
            [$831515ad7ad113dc$export$fa7490a9fefa3701]: {
                name: $831515ad7ad113dc$export$71a451cfb2c2816
            }
        }
    };
}
/*
  See packages/browser-utils/src/browser/router.ts
*/ /**
 *
 */ function $831515ad7ad113dc$export$563404c5f9ee31f6(span) {
    return (0, $bb9b6447bf4caedb$export$92d8c23565496537)(span).op === 'pageload';
}
/**
 * Converts a JSSelfProfile to a our sampled format.
 * Does not currently perform stack indexing.
 */ function $831515ad7ad113dc$export$f4122c775dfac1c2(input) {
    let EMPTY_STACK_ID = undefined;
    let STACK_ID = 0;
    // Initialize the profile that we will fill with data
    const profile = {
        samples: [],
        stacks: [],
        frames: [],
        thread_metadata: {
            [$831515ad7ad113dc$export$fa7490a9fefa3701]: {
                name: $831515ad7ad113dc$export$71a451cfb2c2816
            }
        }
    };
    const firstSample = input.samples[0];
    if (!firstSample) return profile;
    // We assert samples.length > 0 above and timestamp should always be present
    const start = firstSample.timestamp;
    // The JS SDK might change it's time origin based on some heuristic (see See packages/utils/src/time.ts)
    // when that happens, we need to ensure we are correcting the profile timings so the two timelines stay in sync.
    // Since JS self profiling time origin is always initialized to performance.timeOrigin, we need to adjust for
    // the drift between the SDK selected value and our profile time origin.
    const perfOrigin = (0, $bc81602376c48fa6$export$baf075a948ffc0bf)();
    const origin = typeof performance.timeOrigin === 'number' ? performance.timeOrigin : perfOrigin || 0;
    const adjustForOriginChange = origin - (perfOrigin || origin);
    input.samples.forEach((jsSample, i)=>{
        // If sample has no stack, add an empty sample
        if (jsSample.stackId === undefined) {
            if (EMPTY_STACK_ID === undefined) {
                EMPTY_STACK_ID = STACK_ID;
                profile.stacks[EMPTY_STACK_ID] = [];
                STACK_ID++;
            }
            profile['samples'][i] = {
                // convert ms timestamp to ns
                elapsed_since_start_ns: ((jsSample.timestamp + adjustForOriginChange - start) * $831515ad7ad113dc$var$MS_TO_NS).toFixed(0),
                stack_id: EMPTY_STACK_ID,
                thread_id: $831515ad7ad113dc$export$fa7490a9fefa3701
            };
            return;
        }
        let stackTop = input.stacks[jsSample.stackId];
        // Functions in top->down order (root is last)
        // We follow the stackTop.parentId trail and collect each visited frameId
        const stack = [];
        while(stackTop){
            stack.push(stackTop.frameId);
            const frame = input.frames[stackTop.frameId];
            // If our frame has not been indexed yet, index it
            if (frame && profile.frames[stackTop.frameId] === undefined) profile.frames[stackTop.frameId] = {
                function: frame.name,
                abs_path: typeof frame.resourceId === 'number' ? input.resources[frame.resourceId] : undefined,
                lineno: frame.line,
                colno: frame.column
            };
            stackTop = stackTop.parentId === undefined ? undefined : input.stacks[stackTop.parentId];
        }
        const sample = {
            // convert ms timestamp to ns
            elapsed_since_start_ns: ((jsSample.timestamp + adjustForOriginChange - start) * $831515ad7ad113dc$var$MS_TO_NS).toFixed(0),
            stack_id: STACK_ID,
            thread_id: $831515ad7ad113dc$export$fa7490a9fefa3701
        };
        profile['stacks'][STACK_ID] = stack;
        profile['samples'][i] = sample;
        STACK_ID++;
    });
    return profile;
}
/**
 * Adds items to envelope if they are not already present - mutates the envelope.
 * @param envelope
 */ function $831515ad7ad113dc$export$4df36760a75f76bc(envelope, profiles) {
    if (!profiles.length) return envelope;
    for (const profile of profiles)envelope[1].push([
        {
            type: 'profile'
        },
        profile
    ]);
    return envelope;
}
/**
 * Finds transactions with profile_id context in the envelope
 * @param envelope
 * @returns
 */ function $831515ad7ad113dc$export$df9bb0fc214ff8cd(envelope) {
    const events = [];
    (0, $bb063ad93c8b79c7$export$c56c55acf0136fd3)(envelope, (item, type)=>{
        if (type !== 'transaction') return;
        for(let j = 1; j < item.length; j++){
            const event = item[j];
            if (event?.contexts?.profile?.profile_id) events.push(item[j]);
        }
    });
    return events;
}
/**
 * Applies debug meta data to an event from a list of paths to resources (sourcemaps)
 */ function $831515ad7ad113dc$export$4c0b0d8ee0d018b5(resource_paths) {
    const client = (0, $7d48e1ed9f699a01$export$6bb76d6eba7e258c)();
    const options = client?.getOptions();
    const stackParser = options?.stackParser;
    if (!stackParser) return [];
    return (0, $16a85e60da95d694$export$5a7368330d9ee6e3)(stackParser, resource_paths);
}
/**
 * Checks the given sample rate to make sure it is valid type and value (a boolean, or a number between 0 and 1).
 */ function $831515ad7ad113dc$export$2603c8d332a51c42(rate) {
    // we need to check NaN explicitly because it's of type 'number' and therefore wouldn't get caught by this typecheck
    if (typeof rate !== 'number' && typeof rate !== 'boolean' || typeof rate === 'number' && isNaN(rate)) {
        (0, $6e9d48dbcf18d05a$export$16a28057038b10ef) && (0, $d11ed0b3cdda6b8d$export$1c9f709888824e05).warn(`[Profiling] Invalid sample rate. Sample rate must be a boolean or a number between 0 and 1. Got ${JSON.stringify(rate)} of type ${JSON.stringify(typeof rate)}.`);
        return false;
    }
    // Boolean sample rates are always valid
    if (rate === true || rate === false) return true;
    // in case sampleRate is a boolean, it will get automatically cast to 1 if it's true and 0 if it's false
    if (rate < 0 || rate > 1) {
        (0, $6e9d48dbcf18d05a$export$16a28057038b10ef) && (0, $d11ed0b3cdda6b8d$export$1c9f709888824e05).warn(`[Profiling] Invalid sample rate. Sample rate must be between 0 and 1. Got ${rate}.`);
        return false;
    }
    return true;
}
function $831515ad7ad113dc$var$isValidProfile(profile) {
    if (profile.samples.length < 2) {
        if (0, $6e9d48dbcf18d05a$export$16a28057038b10ef) // Log a warning if the profile has less than 2 samples so users can know why
        // they are not seeing any profiling data and we cant avoid the back and forth
        // of asking them to provide us with a dump of the profile data.
        (0, $d11ed0b3cdda6b8d$export$1c9f709888824e05).log('[Profiling] Discarding profile because it contains less than 2 samples');
        return false;
    }
    if (!profile.frames.length) {
        if (0, $6e9d48dbcf18d05a$export$16a28057038b10ef) (0, $d11ed0b3cdda6b8d$export$1c9f709888824e05).log('[Profiling] Discarding profile because it contains no frames');
        return false;
    }
    return true;
}
// Keep a flag value to avoid re-initializing the profiler constructor. If it fails
// once, it will always fail and this allows us to early return.
let $831515ad7ad113dc$var$PROFILING_CONSTRUCTOR_FAILED = false;
const $831515ad7ad113dc$export$8640c0b5c7d98a81 = 30000;
/**
 * Check if profiler constructor is available.
 * @param maybeProfiler
 */ function $831515ad7ad113dc$var$isJSProfilerSupported(maybeProfiler) {
    return typeof maybeProfiler === 'function';
}
/**
 * Starts the profiler and returns the profiler instance.
 */ function $831515ad7ad113dc$export$9f4f648547a4284f() {
    // Feature support check first
    const JSProfilerConstructor = (0, $e62dec891f31852b$export$56d8a8a25bd48b81).Profiler;
    if (!$831515ad7ad113dc$var$isJSProfilerSupported(JSProfilerConstructor)) {
        if (0, $6e9d48dbcf18d05a$export$16a28057038b10ef) (0, $d11ed0b3cdda6b8d$export$1c9f709888824e05).log('[Profiling] Profiling is not supported by this browser, Profiler interface missing on window object.');
        return;
    }
    // From initial testing, it seems that the minimum value for sampleInterval is 10ms.
    const samplingIntervalMS = 10;
    // Start the profiler
    const maxSamples = Math.floor($831515ad7ad113dc$export$8640c0b5c7d98a81 / samplingIntervalMS);
    // Attempt to initialize the profiler constructor, if it fails, we disable profiling for the current user session.
    // This is likely due to a missing 'Document-Policy': 'js-profiling' header. We do not want to throw an error if this happens
    // as we risk breaking the user's application, so just disable profiling and log an error.
    try {
        return new JSProfilerConstructor({
            sampleInterval: samplingIntervalMS,
            maxBufferSize: maxSamples
        });
    } catch (_e) {
        if (0, $6e9d48dbcf18d05a$export$16a28057038b10ef) {
            (0, $d11ed0b3cdda6b8d$export$1c9f709888824e05).log("[Profiling] Failed to initialize the Profiling constructor, this is likely due to a missing 'Document-Policy': 'js-profiling' header.");
            (0, $d11ed0b3cdda6b8d$export$1c9f709888824e05).log('[Profiling] Disabling profiling for current user session.');
        }
        $831515ad7ad113dc$var$PROFILING_CONSTRUCTOR_FAILED = true;
    }
    return;
}
/**
 * Determine if a profile should be profiled.
 */ function $831515ad7ad113dc$export$a3f4959190b2ff33(span) {
    // If constructor failed once, it will always fail, so we can early return.
    if ($831515ad7ad113dc$var$PROFILING_CONSTRUCTOR_FAILED) {
        if (0, $6e9d48dbcf18d05a$export$16a28057038b10ef) (0, $d11ed0b3cdda6b8d$export$1c9f709888824e05).log('[Profiling] Profiling has been disabled for the duration of the current user session.');
        return false;
    }
    if (!span.isRecording()) {
        (0, $6e9d48dbcf18d05a$export$16a28057038b10ef) && (0, $d11ed0b3cdda6b8d$export$1c9f709888824e05).log('[Profiling] Discarding profile because root span was not sampled.');
        return false;
    }
    const client = (0, $7d48e1ed9f699a01$export$6bb76d6eba7e258c)();
    const options = client?.getOptions();
    if (!options) {
        (0, $6e9d48dbcf18d05a$export$16a28057038b10ef) && (0, $d11ed0b3cdda6b8d$export$1c9f709888824e05).log('[Profiling] Profiling disabled, no options found.');
        return false;
    }
    // eslint-disable-next-line deprecation/deprecation
    const profilesSampleRate = options.profilesSampleRate;
    // Since this is coming from the user (or from a function provided by the user), who knows what we might get. (The
    // only valid values are booleans or numbers between 0 and 1.)
    if (!$831515ad7ad113dc$export$2603c8d332a51c42(profilesSampleRate)) {
        (0, $6e9d48dbcf18d05a$export$16a28057038b10ef) && (0, $d11ed0b3cdda6b8d$export$1c9f709888824e05).warn('[Profiling] Discarding profile because of invalid sample rate.');
        return false;
    }
    // if the function returned 0 (or false), or if `profileSampleRate` is 0, it's a sign the profile should be dropped
    if (!profilesSampleRate) {
        (0, $6e9d48dbcf18d05a$export$16a28057038b10ef) && (0, $d11ed0b3cdda6b8d$export$1c9f709888824e05).log('[Profiling] Discarding profile because a negative sampling decision was inherited or profileSampleRate is set to 0');
        return false;
    }
    // Now we roll the dice. Math.random is inclusive of 0, but not of 1, so strict < is safe here. In case sampleRate is
    // a boolean, the < comparison will cause it to be automatically cast to 1 if it's true and 0 if it's false.
    const sampled = profilesSampleRate === true ? true : Math.random() < profilesSampleRate;
    // Check if we should sample this profile
    if (!sampled) {
        (0, $6e9d48dbcf18d05a$export$16a28057038b10ef) && (0, $d11ed0b3cdda6b8d$export$1c9f709888824e05).log(`[Profiling] Discarding profile because it's not included in the random sample (sampling rate = ${Number(profilesSampleRate)})`);
        return false;
    }
    return true;
}
/**
 * Determine if a profile should be created for the current session.
 */ function $831515ad7ad113dc$export$32ef4798a567c0ec(options) {
    // If constructor failed once, it will always fail, so we can early return.
    if ($831515ad7ad113dc$var$PROFILING_CONSTRUCTOR_FAILED) {
        if (0, $6e9d48dbcf18d05a$export$16a28057038b10ef) (0, $d11ed0b3cdda6b8d$export$1c9f709888824e05).log('[Profiling] Profiling has been disabled for the duration of the current user session as the JS Profiler could not be started.');
        return false;
    }
    if (options.profileLifecycle !== 'trace' && options.profileLifecycle !== 'manual') {
        (0, $6e9d48dbcf18d05a$export$16a28057038b10ef) && (0, $d11ed0b3cdda6b8d$export$1c9f709888824e05).warn('[Profiling] Session not sampled. Invalid `profileLifecycle` option.');
        return false;
    }
    //  Session sampling: profileSessionSampleRate gates whether profiling is enabled for this session
    const profileSessionSampleRate = options.profileSessionSampleRate;
    if (!$831515ad7ad113dc$export$2603c8d332a51c42(profileSessionSampleRate)) {
        (0, $6e9d48dbcf18d05a$export$16a28057038b10ef) && (0, $d11ed0b3cdda6b8d$export$1c9f709888824e05).warn('[Profiling] Discarding profile because of invalid profileSessionSampleRate.');
        return false;
    }
    if (!profileSessionSampleRate) {
        (0, $6e9d48dbcf18d05a$export$16a28057038b10ef) && (0, $d11ed0b3cdda6b8d$export$1c9f709888824e05).log('[Profiling] Discarding profile because profileSessionSampleRate is not defined or set to 0');
        return false;
    }
    return Math.random() <= profileSessionSampleRate;
}
/**
 * Checks if legacy profiling is configured.
 */ function $831515ad7ad113dc$export$9fb56f964fbe825f(options) {
    // eslint-disable-next-line deprecation/deprecation
    return typeof options.profilesSampleRate !== 'undefined';
}
/**
 * Creates a profiling envelope item, if the profile does not pass validation, returns null.
 * @param event
 * @returns {Profile | null}
 */ function $831515ad7ad113dc$export$5c2c5e805edd874f(profile_id, start_timestamp, profile, event) {
    if (!$831515ad7ad113dc$var$isValidProfile(profile)) return null;
    return $831515ad7ad113dc$export$5c9f6e262288b7db(profile_id, start_timestamp, profile, event);
}
// TODO (v8): We need to obtain profile ids in @sentry-internal/tracing,
// but we don't have access to this map because importing this map would
// cause a circular dependency. We need to resolve this in v8.
const $831515ad7ad113dc$var$PROFILE_MAP = new Map();
/**
 *
 */ function $831515ad7ad113dc$export$9d723f414195854a() {
    return $831515ad7ad113dc$var$PROFILE_MAP.size;
}
/**
 * Retrieves profile from global cache and removes it.
 */ function $831515ad7ad113dc$export$6285310796363de1(profile_id) {
    const profile = $831515ad7ad113dc$var$PROFILE_MAP.get(profile_id);
    if (profile) $831515ad7ad113dc$var$PROFILE_MAP.delete(profile_id);
    return profile;
}
/**
 * Adds profile to global cache and evicts the oldest profile if the cache is full.
 */ function $831515ad7ad113dc$export$7ddae68097f7e530(profile_id, profile) {
    $831515ad7ad113dc$var$PROFILE_MAP.set(profile_id, profile);
    if ($831515ad7ad113dc$var$PROFILE_MAP.size > 30) {
        const last = $831515ad7ad113dc$var$PROFILE_MAP.keys().next().value;
        if (last !== undefined) $831515ad7ad113dc$var$PROFILE_MAP.delete(last);
    }
}
/**
 * Attaches the profiled thread information to the event's trace context.
 */ function $831515ad7ad113dc$export$c188a2df0a0b7d8d(event) {
    if (!event?.contexts?.profile) return event;
    if (!event.contexts) return event;
    // Only mutate the trace context when it already has a trace_id — that
    // guarantees `applySpanToEvent` has already run, and we are not creating a partial trace context from scratch.
    if (event.contexts.trace?.trace_id) event.contexts.trace = {
        ...event.contexts.trace,
        data: {
            ...event.contexts.trace.data ?? {},
            ['thread.id']: $831515ad7ad113dc$export$fa7490a9fefa3701,
            ['thread.name']: $831515ad7ad113dc$export$71a451cfb2c2816
        }
    };
    // Attach thread info to individual spans so that spans can be associated with the profiled thread on the UI even if contexts are missing.
    event.spans?.forEach((span)=>{
        span.data = {
            ...span.data || {},
            ['thread.id']: $831515ad7ad113dc$export$fa7490a9fefa3701,
            ['thread.name']: $831515ad7ad113dc$export$71a451cfb2c2816
        };
    });
    return event;
}


/**
 * Wraps startTransaction and stopTransaction with profiling related logic.
 * startProfileForTransaction is called after the call to startTransaction in order to avoid our own code from
 * being profiled. Because of that same reason, stopProfiling is called before the call to stopTransaction.
 */ function $c7adc874b6bb695a$export$83bcc43b6a2cf5e7(span) {
    // Start the profiler and get the profiler instance.
    let startTimestamp;
    if ((0, $831515ad7ad113dc$export$563404c5f9ee31f6)(span)) startTimestamp = (0, $bc81602376c48fa6$export$ee52dced521e3e18)() * 1000;
    const profiler = (0, $831515ad7ad113dc$export$9f4f648547a4284f)();
    // We failed to construct the profiler, so we skip.
    // No need to log anything as this has already been logged in startProfile.
    if (!profiler) return;
    if (0, $6e9d48dbcf18d05a$export$16a28057038b10ef) (0, $d11ed0b3cdda6b8d$export$1c9f709888824e05).log(`[Profiling] started profiling span: ${(0, $bb9b6447bf4caedb$export$92d8c23565496537)(span).description}`);
    // We create "unique" span names to avoid concurrent spans with same names
    // from being ignored by the profiler. From here on, only this span name should be used when
    // calling the profiler methods. Note: we log the original name to the user to avoid confusion.
    const profileId = (0, $cc262db35458e4b3$export$19f53698e68b2496)();
    // A couple of important things to note here:
    // `CpuProfilerBindings.stopProfiling` will be scheduled to run in 30seconds in order to exceed max profile duration.
    // Whichever of the two (span.finish/timeout) is first to run, the profiling will be stopped and the gathered profile
    // will be processed when the original span is finished. Since onProfileHandler can be invoked multiple times in the
    // event of an error or user mistake (calling span.finish multiple times), it is important that the behavior of onProfileHandler
    // is idempotent as we do not want any timings or profiles to be overridden by the last call to onProfileHandler.
    // After the original finish method is called, the event will be reported through the integration and delegated to transport.
    let processedProfile = null;
    (0, $7d48e1ed9f699a01$export$c7be4b0125a10cba)().setContext('profile', {
        profile_id: profileId,
        start_timestamp: startTimestamp
    });
    /**
   * Idempotent handler for profile stop
   */ async function onProfileHandler() {
        // Check if the profile exists and return it the behavior has to be idempotent as users may call span.finish multiple times.
        if (!span) return;
        // Satisfy the type checker, but profiler will always be defined here.
        if (!profiler) return;
        if (processedProfile) {
            if (0, $6e9d48dbcf18d05a$export$16a28057038b10ef) (0, $d11ed0b3cdda6b8d$export$1c9f709888824e05).log('[Profiling] profile for:', (0, $bb9b6447bf4caedb$export$92d8c23565496537)(span).description, 'already exists, returning early');
            return;
        }
        return profiler.stop().then((profile)=>{
            if (maxDurationTimeoutID) {
                (0, $e62dec891f31852b$export$56d8a8a25bd48b81).clearTimeout(maxDurationTimeoutID);
                maxDurationTimeoutID = undefined;
            }
            if (0, $6e9d48dbcf18d05a$export$16a28057038b10ef) (0, $d11ed0b3cdda6b8d$export$1c9f709888824e05).log(`[Profiling] stopped profiling of span: ${(0, $bb9b6447bf4caedb$export$92d8c23565496537)(span).description}`);
            // In case of an overlapping span, stopProfiling may return null and silently ignore the overlapping profile.
            if (!profile) {
                if (0, $6e9d48dbcf18d05a$export$16a28057038b10ef) (0, $d11ed0b3cdda6b8d$export$1c9f709888824e05).log(`[Profiling] profiler returned null profile for: ${(0, $bb9b6447bf4caedb$export$92d8c23565496537)(span).description}`, 'this may indicate an overlapping span or a call to stopProfiling with a profile title that was never started');
                return;
            }
            processedProfile = profile;
            (0, $831515ad7ad113dc$export$7ddae68097f7e530)(profileId, profile);
        }).catch((error)=>{
            if (0, $6e9d48dbcf18d05a$export$16a28057038b10ef) (0, $d11ed0b3cdda6b8d$export$1c9f709888824e05).log('[Profiling] error while stopping profiler:', error);
        });
    }
    // Enqueue a timeout to prevent profiles from running over max duration.
    let maxDurationTimeoutID = (0, $e62dec891f31852b$export$56d8a8a25bd48b81).setTimeout(()=>{
        if (0, $6e9d48dbcf18d05a$export$16a28057038b10ef) (0, $d11ed0b3cdda6b8d$export$1c9f709888824e05).log('[Profiling] max profile duration elapsed, stopping profiling for:', (0, $bb9b6447bf4caedb$export$92d8c23565496537)(span).description);
        // If the timeout exceeds, we want to stop profiling, but not finish the span
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        onProfileHandler();
    }, (0, $831515ad7ad113dc$export$8640c0b5c7d98a81));
    // We need to reference the original end call to avoid creating an infinite loop
    const originalEnd = span.end.bind(span);
    /**
   * Wraps span `end()` with profiling related logic.
   * startProfiling is called after the call to spanStart in order to avoid our own code from
   * being profiled. Because of that same reason, stopProfiling is called before the call to spanEnd.
   */ function profilingWrappedSpanEnd() {
        if (!span) return originalEnd();
        // onProfileHandler should always return the same profile even if this is called multiple times.
        // Always call onProfileHandler to ensure stopProfiling is called and the timeout is cleared.
        onProfileHandler().then(()=>{
            originalEnd();
        }, ()=>{
            // If onProfileHandler fails, we still want to call the original finish method.
            originalEnd();
        });
        return span;
    }
    span.end = profilingWrappedSpanEnd;
}





const $b01975b7be737c0e$var$CHUNK_INTERVAL_MS = 60000; // 1 minute
// Maximum length for trace lifecycle profiling per root span (e.g. if spanEnd never fires)
const $b01975b7be737c0e$var$MAX_ROOT_SPAN_PROFILE_MS = 300000; // 5 minutes max per root span in trace mode
/**
 * UIProfiler (Profiling V2):
 * Supports two lifecycle modes:
 *  - 'manual': controlled explicitly via start()/stop()
 *  - 'trace': automatically runs while there are active sampled root spans
 *
 * Profiles are emitted as standalone `profile_chunk` envelopes either when:
 * - there are no more sampled root spans, or
 * - the 60s chunk timer elapses while profiling is running.
 */ class $b01975b7be737c0e$export$20020d6e2aeade43 {
    // Manual + Trace
    // one per Profiler session
    // current profiler instance active flag
    // sampling decision for entire session
    // Trace-only
    constructor(){
        this._client = undefined;
        this._profiler = undefined;
        this._chunkTimer = undefined;
        this._profilerId = undefined;
        this._isRunning = false;
        this._sessionSampled = false;
        this._lifecycleMode = undefined;
        this._activeRootSpanIds = new Set();
        this._rootSpanTimeouts = new Map();
    }
    /**
   * Initialize the profiler with client, session sampling and lifecycle mode.
   */ initialize(client) {
        const lifecycleMode = client.getOptions().profileLifecycle;
        const sessionSampled = (0, $831515ad7ad113dc$export$32ef4798a567c0ec)(client.getOptions());
        (0, $6e9d48dbcf18d05a$export$16a28057038b10ef) && (0, $d11ed0b3cdda6b8d$export$1c9f709888824e05).log(`[Profiling] Initializing profiler (lifecycle='${lifecycleMode}').`);
        if (!sessionSampled) (0, $6e9d48dbcf18d05a$export$16a28057038b10ef) && (0, $d11ed0b3cdda6b8d$export$1c9f709888824e05).log('[Profiling] Session not sampled. Skipping lifecycle profiler initialization.');
        // One Profiler ID per profiling session (user session)
        this._profilerId = (0, $cc262db35458e4b3$export$19f53698e68b2496)();
        this._client = client;
        this._sessionSampled = sessionSampled;
        this._lifecycleMode = lifecycleMode;
        if (lifecycleMode === 'trace') this._setupTraceLifecycleListeners(client);
    }
    /** Starts UI profiling (only effective in 'manual' mode and when sampled). */ start() {
        if (this._lifecycleMode === 'trace') {
            (0, $6e9d48dbcf18d05a$export$16a28057038b10ef) && (0, $d11ed0b3cdda6b8d$export$1c9f709888824e05).warn('[Profiling] `profileLifecycle` is set to "trace". Calls to `uiProfiler.start()` are ignored in trace mode.');
            return;
        }
        if (this._isRunning) {
            (0, $6e9d48dbcf18d05a$export$16a28057038b10ef) && (0, $d11ed0b3cdda6b8d$export$1c9f709888824e05).warn('[Profiling] Profile session is already running, `uiProfiler.start()` is a no-op.');
            return;
        }
        if (!this._sessionSampled) {
            (0, $6e9d48dbcf18d05a$export$16a28057038b10ef) && (0, $d11ed0b3cdda6b8d$export$1c9f709888824e05).warn('[Profiling] Session is not sampled, `uiProfiler.start()` is a no-op.');
            return;
        }
        this._beginProfiling();
    }
    /** Stops UI profiling (only effective in 'manual' mode). */ stop() {
        if (this._lifecycleMode === 'trace') {
            (0, $6e9d48dbcf18d05a$export$16a28057038b10ef) && (0, $d11ed0b3cdda6b8d$export$1c9f709888824e05).warn('[Profiling] `profileLifecycle` is set to "trace". Calls to `uiProfiler.stop()` are ignored in trace mode.');
            return;
        }
        if (!this._isRunning) {
            (0, $6e9d48dbcf18d05a$export$16a28057038b10ef) && (0, $d11ed0b3cdda6b8d$export$1c9f709888824e05).warn('[Profiling] Profiler is not running, `uiProfiler.stop()` is a no-op.');
            return;
        }
        this._endProfiling();
    }
    /** Handle an already-active root span at integration setup time (used only in trace mode). */ notifyRootSpanActive(rootSpan) {
        if (this._lifecycleMode !== 'trace' || !this._sessionSampled) return;
        const spanId = rootSpan.spanContext().spanId;
        if (!spanId || this._activeRootSpanIds.has(spanId)) return;
        this._registerTraceRootSpan(spanId);
        const rootSpanCount = this._activeRootSpanIds.size;
        if (rootSpanCount === 1) {
            (0, $6e9d48dbcf18d05a$export$16a28057038b10ef) && (0, $d11ed0b3cdda6b8d$export$1c9f709888824e05).log('[Profiling] Detected already active root span during setup. Active root spans now:', rootSpanCount);
            this._beginProfiling();
        }
    }
    /**
   * Begin profiling if not already running.
   */ _beginProfiling() {
        if (this._isRunning) return;
        this._isRunning = true;
        (0, $6e9d48dbcf18d05a$export$16a28057038b10ef) && (0, $d11ed0b3cdda6b8d$export$1c9f709888824e05).log('[Profiling] Started profiling with profiler ID:', this._profilerId);
        // Expose profiler_id to match root spans with profiles
        (0, $7d48e1ed9f699a01$export$aa55d5ab8e05984f)().setContext('profile', {
            profiler_id: this._profilerId
        });
        this._startProfilerInstance();
        if (!this._profiler) {
            (0, $6e9d48dbcf18d05a$export$16a28057038b10ef) && (0, $d11ed0b3cdda6b8d$export$1c9f709888824e05).log('[Profiling] Failed to start JS Profiler; stopping.');
            this._resetProfilerInfo();
            return;
        }
        this._startPeriodicChunking();
    }
    /** End profiling session; final chunk will be collected and sent. */ _endProfiling() {
        if (!this._isRunning) return;
        this._isRunning = false;
        if (this._chunkTimer) {
            clearTimeout(this._chunkTimer);
            this._chunkTimer = undefined;
        }
        this._clearAllRootSpanTimeouts();
        // Collect whatever was currently recording
        this._collectCurrentChunk().catch((e)=>{
            (0, $6e9d48dbcf18d05a$export$16a28057038b10ef) && (0, $d11ed0b3cdda6b8d$export$1c9f709888824e05).error('[Profiling] Failed to collect current profile chunk on `stop()`:', e);
        });
        // Manual: Clear profiling context so spans outside start()/stop() aren't marked as profiled
        // Trace: Profile context is kept for the whole session duration
        if (this._lifecycleMode === 'manual') (0, $7d48e1ed9f699a01$export$aa55d5ab8e05984f)().setContext('profile', {});
    }
    /** Trace-mode: attach spanStart/spanEnd listeners. */ _setupTraceLifecycleListeners(client) {
        client.on('spanStart', (span)=>{
            if (!this._sessionSampled) {
                (0, $6e9d48dbcf18d05a$export$16a28057038b10ef) && (0, $d11ed0b3cdda6b8d$export$1c9f709888824e05).log('[Profiling] Span not profiled because of negative sampling decision for user session.');
                return;
            }
            if (span !== (0, $bb9b6447bf4caedb$export$c4c6a79b1260ca1b)(span)) return; // only care about root spans
            // Only count sampled root spans
            if (!span.isRecording()) {
                (0, $6e9d48dbcf18d05a$export$16a28057038b10ef) && (0, $d11ed0b3cdda6b8d$export$1c9f709888824e05).log('[Profiling] Discarding profile because root span was not sampled.');
                return;
            }
            const spanId = span.spanContext().spanId;
            if (!spanId || this._activeRootSpanIds.has(spanId)) return;
            this._registerTraceRootSpan(spanId);
            const rootSpanCount = this._activeRootSpanIds.size;
            if (rootSpanCount === 1) {
                (0, $6e9d48dbcf18d05a$export$16a28057038b10ef) && (0, $d11ed0b3cdda6b8d$export$1c9f709888824e05).log(`[Profiling] Root span ${spanId} started. Profiling active while there are active root spans (count=${rootSpanCount}).`);
                this._beginProfiling();
            }
        });
        client.on('spanEnd', (span)=>{
            if (!this._sessionSampled) return;
            const spanId = span.spanContext().spanId;
            if (!spanId || !this._activeRootSpanIds.has(spanId)) return;
            this._activeRootSpanIds.delete(spanId);
            const rootSpanCount = this._activeRootSpanIds.size;
            (0, $6e9d48dbcf18d05a$export$16a28057038b10ef) && (0, $d11ed0b3cdda6b8d$export$1c9f709888824e05).log(`[Profiling] Root span with ID ${spanId} ended. Will continue profiling for as long as there are active root spans (currently: ${rootSpanCount}).`);
            if (rootSpanCount === 0) {
                this._collectCurrentChunk().catch((e)=>{
                    (0, $6e9d48dbcf18d05a$export$16a28057038b10ef) && (0, $d11ed0b3cdda6b8d$export$1c9f709888824e05).error('[Profiling] Failed to collect current profile chunk on last `spanEnd`:', e);
                });
                this._endProfiling();
            }
        });
    }
    /**
   * Resets profiling information from scope and resets running state (used on failure)
   */ _resetProfilerInfo() {
        this._isRunning = false;
        (0, $7d48e1ed9f699a01$export$aa55d5ab8e05984f)().setContext('profile', {});
    }
    /**
   * Clear and reset all per-root-span timeouts.
   */ _clearAllRootSpanTimeouts() {
        this._rootSpanTimeouts.forEach((timeout)=>clearTimeout(timeout));
        this._rootSpanTimeouts.clear();
    }
    /** Keep track of root spans and schedule safeguard timeout (trace mode). */ _registerTraceRootSpan(spanId) {
        this._activeRootSpanIds.add(spanId);
        const timeout = setTimeout(()=>this._onRootSpanTimeout(spanId), $b01975b7be737c0e$var$MAX_ROOT_SPAN_PROFILE_MS);
        this._rootSpanTimeouts.set(spanId, timeout);
    }
    /**
   * Start a profiler instance if needed.
   */ _startProfilerInstance() {
        if (this._profiler?.stopped === false) return; // already running
        const profiler = (0, $831515ad7ad113dc$export$9f4f648547a4284f)();
        if (!profiler) {
            (0, $6e9d48dbcf18d05a$export$16a28057038b10ef) && (0, $d11ed0b3cdda6b8d$export$1c9f709888824e05).log('[Profiling] Failed to start JS Profiler.');
            return;
        }
        this._profiler = profiler;
    }
    /**
   * Schedule the next 60s chunk while running.
   * Each tick collects a chunk and restarts the profiler.
   * A chunk should be closed when there are no active root spans anymore OR when the maximum chunk interval is reached.
   */ _startPeriodicChunking() {
        if (!this._isRunning) return;
        this._chunkTimer = setTimeout(()=>{
            this._collectCurrentChunk().catch((e)=>{
                (0, $6e9d48dbcf18d05a$export$16a28057038b10ef) && (0, $d11ed0b3cdda6b8d$export$1c9f709888824e05).error('[Profiling] Failed to collect current profile chunk during periodic chunking:', e);
            });
            if (this._isRunning) {
                this._startProfilerInstance();
                if (!this._profiler) {
                    // If restart failed, stop scheduling further chunks and reset context.
                    this._resetProfilerInfo();
                    return;
                }
                this._startPeriodicChunking();
            }
        }, $b01975b7be737c0e$var$CHUNK_INTERVAL_MS);
    }
    /**
   * Handle timeout for a specific root span ID to avoid indefinitely running profiler if `spanEnd` never fires.
   * If this was the last active root span, collect the current chunk and stop profiling.
   */ _onRootSpanTimeout(rootSpanId) {
        // If span already ended, ignore
        if (!this._rootSpanTimeouts.has(rootSpanId)) return;
        this._rootSpanTimeouts.delete(rootSpanId);
        if (!this._activeRootSpanIds.has(rootSpanId)) return;
        (0, $6e9d48dbcf18d05a$export$16a28057038b10ef) && (0, $d11ed0b3cdda6b8d$export$1c9f709888824e05).log(`[Profiling] Reached 5-minute timeout for root span ${rootSpanId}. You likely started a manual root span that never called \`.end()\`.`);
        this._activeRootSpanIds.delete(rootSpanId);
        if (this._activeRootSpanIds.size === 0) this._endProfiling();
    }
    /**
   * Stop current profiler instance, convert profile to chunk & send.
   */ async _collectCurrentChunk() {
        const prevProfiler = this._profiler;
        this._profiler = undefined;
        if (!prevProfiler) return;
        try {
            const profile = await prevProfiler.stop();
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            const chunk = (0, $831515ad7ad113dc$export$4684f29184e0c876)(profile, this._client, this._profilerId);
            // Validate chunk before sending
            const validationReturn = (0, $831515ad7ad113dc$export$706bf24a90edd468)(chunk);
            if ('reason' in validationReturn) {
                (0, $6e9d48dbcf18d05a$export$16a28057038b10ef) && (0, $d11ed0b3cdda6b8d$export$1c9f709888824e05).log('[Profiling] Discarding invalid profile chunk (this is probably a bug in the SDK):', validationReturn.reason);
                return;
            }
            this._sendProfileChunk(chunk);
            (0, $6e9d48dbcf18d05a$export$16a28057038b10ef) && (0, $d11ed0b3cdda6b8d$export$1c9f709888824e05).log('[Profiling] Collected browser profile chunk.');
        } catch (e) {
            (0, $6e9d48dbcf18d05a$export$16a28057038b10ef) && (0, $d11ed0b3cdda6b8d$export$1c9f709888824e05).log('[Profiling] Error while stopping JS Profiler for chunk:', e);
        }
    }
    /**
   * Send a profile chunk as a standalone envelope.
   */ _sendProfileChunk(chunk) {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const client = this._client;
        const sdkInfo = (0, $bb063ad93c8b79c7$export$d369f3b2758f6743)(client.getSdkMetadata?.());
        const dsn = client.getDsn();
        const tunnel = client.getOptions().tunnel;
        const envelope = (0, $bb063ad93c8b79c7$export$f93f7f385160c44e)({
            event_id: (0, $cc262db35458e4b3$export$19f53698e68b2496)(),
            sent_at: new Date().toISOString(),
            ...sdkInfo && {
                sdk: sdkInfo
            },
            ...!!tunnel && dsn && {
                dsn: (0, $1e1399eeae328b26$export$44d472fbb931a776)(dsn)
            }
        }, [
            [
                {
                    type: 'profile_chunk',
                    platform: 'javascript'
                },
                chunk
            ]
        ]);
        client.sendEnvelope(envelope).then(null, (reason)=>{
            (0, $6e9d48dbcf18d05a$export$16a28057038b10ef) && (0, $d11ed0b3cdda6b8d$export$1c9f709888824e05).error('Error while sending profile chunk envelope:', reason);
        });
    }
}



const $ddc68b5832e965a7$var$INTEGRATION_NAME = 'BrowserProfiling';
const $ddc68b5832e965a7$var$_browserProfilingIntegration = ()=>{
    return {
        name: $ddc68b5832e965a7$var$INTEGRATION_NAME,
        setup (client) {
            const options = client.getOptions();
            const profiler = new (0, $b01975b7be737c0e$export$20020d6e2aeade43)();
            if (!(0, $831515ad7ad113dc$export$9fb56f964fbe825f)(options) && !options.profileLifecycle) // Set default lifecycle mode
            options.profileLifecycle = 'manual';
            // eslint-disable-next-line deprecation/deprecation
            if ((0, $831515ad7ad113dc$export$9fb56f964fbe825f)(options) && !options.profilesSampleRate) {
                (0, $6e9d48dbcf18d05a$export$16a28057038b10ef) && (0, $d11ed0b3cdda6b8d$export$1c9f709888824e05).log('[Profiling] Profiling disabled, no profiling options found.');
                return;
            }
            const activeSpan = (0, $bb9b6447bf4caedb$export$1be426a8e585c83e)();
            const rootSpan = activeSpan && (0, $bb9b6447bf4caedb$export$c4c6a79b1260ca1b)(activeSpan);
            if ((0, $831515ad7ad113dc$export$9fb56f964fbe825f)(options) && options.profileSessionSampleRate !== undefined) (0, $6e9d48dbcf18d05a$export$16a28057038b10ef) && (0, $d11ed0b3cdda6b8d$export$1c9f709888824e05).warn('[Profiling] Both legacy profiling (`profilesSampleRate`) and UI profiling settings are defined. `profileSessionSampleRate` has no effect when legacy profiling is enabled.');
            // UI PROFILING (Profiling V2)
            if (!(0, $831515ad7ad113dc$export$9fb56f964fbe825f)(options)) {
                const lifecycleMode = options.profileLifecycle;
                // Registering hooks in all lifecycle modes to be able to notify users in case they want to start/stop the profiler manually in `trace` mode
                client.on('startUIProfiler', ()=>profiler.start());
                client.on('stopUIProfiler', ()=>profiler.stop());
                if (lifecycleMode === 'manual') profiler.initialize(client);
                else if (lifecycleMode === 'trace') {
                    if (!(0, $e3827447d651dfc5$export$1f70765132c3c225)(options)) {
                        (0, $6e9d48dbcf18d05a$export$16a28057038b10ef) && (0, $d11ed0b3cdda6b8d$export$1c9f709888824e05).warn("[Profiling] `profileLifecycle` is 'trace' but tracing is disabled. Set a `tracesSampleRate` or `tracesSampler` to enable span tracing.");
                        return;
                    }
                    profiler.initialize(client);
                    // If there is an active, sampled root span already, notify the profiler
                    if (rootSpan) profiler.notifyRootSpanActive(rootSpan);
                    // In case rootSpan is created slightly after setup -> schedule microtask to re-check and notify.
                    (0, $e62dec891f31852b$export$56d8a8a25bd48b81).setTimeout(()=>{
                        const laterActiveSpan = (0, $bb9b6447bf4caedb$export$1be426a8e585c83e)();
                        const laterRootSpan = laterActiveSpan && (0, $bb9b6447bf4caedb$export$c4c6a79b1260ca1b)(laterActiveSpan);
                        if (laterRootSpan) profiler.notifyRootSpanActive(laterRootSpan);
                    }, 0);
                }
            } else {
                // LEGACY PROFILING (v1)
                if (rootSpan && (0, $831515ad7ad113dc$export$563404c5f9ee31f6)(rootSpan)) {
                    if ((0, $831515ad7ad113dc$export$a3f4959190b2ff33)(rootSpan)) (0, $c7adc874b6bb695a$export$83bcc43b6a2cf5e7)(rootSpan);
                }
                client.on('spanStart', (span)=>{
                    if (span === (0, $bb9b6447bf4caedb$export$c4c6a79b1260ca1b)(span) && (0, $831515ad7ad113dc$export$a3f4959190b2ff33)(span)) (0, $c7adc874b6bb695a$export$83bcc43b6a2cf5e7)(span);
                });
                client.on('beforeEnvelope', (envelope)=>{
                    // if not profiles are in queue, there is nothing to add to the envelope.
                    if (!(0, $831515ad7ad113dc$export$9d723f414195854a)()) return;
                    const profiledTransactionEvents = (0, $831515ad7ad113dc$export$df9bb0fc214ff8cd)(envelope);
                    if (!profiledTransactionEvents.length) return;
                    const profilesToAddToEnvelope = [];
                    for (const profiledTransaction of profiledTransactionEvents){
                        const context = profiledTransaction?.contexts;
                        const profile_id = context?.profile?.['profile_id'];
                        const start_timestamp = context?.profile?.['start_timestamp'];
                        if (typeof profile_id !== 'string') {
                            (0, $6e9d48dbcf18d05a$export$16a28057038b10ef) && (0, $d11ed0b3cdda6b8d$export$1c9f709888824e05).log('[Profiling] cannot find profile for a span without a profile context');
                            continue;
                        }
                        if (!profile_id) {
                            (0, $6e9d48dbcf18d05a$export$16a28057038b10ef) && (0, $d11ed0b3cdda6b8d$export$1c9f709888824e05).log('[Profiling] cannot find profile for a span without a profile context');
                            continue;
                        }
                        // Remove the profile from the span context before sending, relay will take care of the rest.
                        if (context?.profile) delete context.profile;
                        const profile = (0, $831515ad7ad113dc$export$6285310796363de1)(profile_id);
                        if (!profile) {
                            (0, $6e9d48dbcf18d05a$export$16a28057038b10ef) && (0, $d11ed0b3cdda6b8d$export$1c9f709888824e05).log(`[Profiling] Could not retrieve profile for span: ${profile_id}`);
                            continue;
                        }
                        const profileEvent = (0, $831515ad7ad113dc$export$5c2c5e805edd874f)(profile_id, start_timestamp, profile, profiledTransaction);
                        if (profileEvent) profilesToAddToEnvelope.push(profileEvent);
                    }
                    (0, $831515ad7ad113dc$export$4df36760a75f76bc)(envelope, profilesToAddToEnvelope);
                });
            }
        },
        processEvent (event) {
            return (0, $831515ad7ad113dc$export$c188a2df0a0b7d8d)(event);
        }
    };
};
const $ddc68b5832e965a7$export$2c7b5d6dd5622f23 = (0, $cbb2da6c78246e45$export$2323046b9414659f)($ddc68b5832e965a7$var$_browserProfilingIntegration);





const $75c15b1f5f212f04$export$63196314a6cfeb0f = 'SpotlightBrowser';
const $75c15b1f5f212f04$var$_spotlightIntegration = (options = {})=>{
    const sidecarUrl = options.sidecarUrl || 'http://localhost:8969/stream';
    return {
        name: $75c15b1f5f212f04$export$63196314a6cfeb0f,
        setup: ()=>{
            (0, $6e9d48dbcf18d05a$export$16a28057038b10ef) && (0, $d11ed0b3cdda6b8d$export$1c9f709888824e05).log('Using Sidecar URL', sidecarUrl);
        },
        // We don't want to send interaction transactions/root spans created from
        // clicks within Spotlight to Sentry. Neither do we want them to be sent to
        // spotlight.
        processEvent: (event)=>$75c15b1f5f212f04$export$23b74ddf1b93645b(event) ? null : event,
        afterAllSetup: (client)=>{
            $75c15b1f5f212f04$var$setupSidecarForwarding(client, sidecarUrl);
        }
    };
};
function $75c15b1f5f212f04$var$setupSidecarForwarding(client, sidecarUrl) {
    const makeFetch = (0, $a11db510f5040b04$export$e464f4a514ac28a8)('fetch');
    let failCount = 0;
    client.on('beforeEnvelope', (envelope)=>{
        if (failCount > 3) {
            (0, $d11ed0b3cdda6b8d$export$1c9f709888824e05).warn('[Spotlight] Disabled Sentry -> Spotlight integration due to too many failed requests:', failCount);
            return;
        }
        makeFetch(sidecarUrl, {
            method: 'POST',
            body: (0, $bb063ad93c8b79c7$export$32f9b428425aac85)(envelope),
            headers: {
                'Content-Type': 'application/x-sentry-envelope'
            },
            mode: 'cors'
        }).then((res)=>{
            if (res.status >= 200 && res.status < 400) // Reset failed requests counter on success
            failCount = 0;
        }, (err)=>{
            failCount++;
            (0, $d11ed0b3cdda6b8d$export$1c9f709888824e05).error("Sentry SDK can't connect to Sidecar is it running? See: https://spotlightjs.com/sidecar/npx/", err);
        });
    });
}
/**
 * Use this integration to send errors and transactions to Spotlight.
 *
 * Learn more about spotlight at https://spotlightjs.com
 */ const $75c15b1f5f212f04$export$a05c07c0f32f730a = (0, $cbb2da6c78246e45$export$2323046b9414659f)($75c15b1f5f212f04$var$_spotlightIntegration);
/**
 * Flags if the event is a transaction created from an interaction with the spotlight UI.
 */ function $75c15b1f5f212f04$export$23b74ddf1b93645b(event) {
    return Boolean(event.type === 'transaction' && event.spans && event.contexts?.trace && event.contexts.trace.op === 'ui.action.click' && event.spans.some(({ description: description })=>description?.includes('#sentry-spotlight')));
}




/**
 * Sentry integration for capturing feature flag evaluations from LaunchDarkly.
 *
 * See the [feature flag documentation](https://develop.sentry.dev/sdk/expected-features/#feature-flags) for more information.
 *
 * @example
 * ```
 * import * as Sentry from '@sentry/browser';
 * import {launchDarklyIntegration, buildLaunchDarklyFlagUsedInspector} from '@sentry/browser';
 * import * as LaunchDarkly from 'launchdarkly-js-client-sdk';
 *
 * Sentry.init(..., integrations: [launchDarklyIntegration()])
 * const ldClient = LaunchDarkly.initialize(..., {inspectors: [buildLaunchDarklyFlagUsedHandler()]});
 * ```
 */ const $2849f1c84e195cf6$export$7cd9c18538ed792e = (0, $cbb2da6c78246e45$export$2323046b9414659f)(()=>{
    return {
        name: 'LaunchDarkly',
        processEvent (event, _hint, _client) {
            return (0, $bd39ef1eacd6c04b$export$bbaa51f7b5642e0f)(event);
        }
    };
});
/**
 * LaunchDarkly hook to listen for and buffer flag evaluations. This needs to
 * be registered as an 'inspector' in LaunchDarkly initialize() options,
 * separately from `launchDarklyIntegration`. Both the hook and the integration
 * are needed to capture LaunchDarkly flags.
 */ function $2849f1c84e195cf6$export$f97714c0986edb0() {
    return {
        name: 'sentry-flag-auditor',
        type: 'flag-used',
        synchronous: true,
        /**
     * Handle a flag evaluation by storing its name and value on the current scope.
     */ method: (flagKey, flagDetail, _context)=>{
            (0, $bd39ef1eacd6c04b$export$8eeb712c9ea5b068)(flagKey, flagDetail.value);
            (0, $bd39ef1eacd6c04b$export$4de324656d9a2858)(flagKey, flagDetail.value);
        }
    };
}



const $6878dd2c72de26fa$export$a41102cd52abbd1b = (0, $cbb2da6c78246e45$export$2323046b9414659f)(()=>{
    return {
        name: 'OpenFeature',
        processEvent (event, _hint, _client) {
            return (0, $bd39ef1eacd6c04b$export$bbaa51f7b5642e0f)(event);
        }
    };
});
/**
 * OpenFeature Hook class implementation.
 */ class $6878dd2c72de26fa$export$f399add65bfd388e {
    /**
   * Successful evaluation result.
   */ after(_hookContext, evaluationDetails) {
        (0, $bd39ef1eacd6c04b$export$8eeb712c9ea5b068)(evaluationDetails.flagKey, evaluationDetails.value);
        (0, $bd39ef1eacd6c04b$export$4de324656d9a2858)(evaluationDetails.flagKey, evaluationDetails.value);
    }
    /**
   * On error evaluation result.
   */ error(hookContext, _error, _hookHints) {
        (0, $bd39ef1eacd6c04b$export$8eeb712c9ea5b068)(hookContext.flagKey, hookContext.defaultValue);
        (0, $bd39ef1eacd6c04b$export$4de324656d9a2858)(hookContext.flagKey, hookContext.defaultValue);
    }
}




/**
 * Sentry integration for capturing feature flag evaluations from the Unleash SDK.
 *
 * See the [feature flag documentation](https://develop.sentry.dev/sdk/expected-features/#feature-flags) for more information.
 *
 * @example
 * ```
 * import { UnleashClient } from 'unleash-proxy-client';
 * import * as Sentry from '@sentry/browser';
 *
 * Sentry.init({
 *   dsn: '___PUBLIC_DSN___',
 *   integrations: [Sentry.unleashIntegration({featureFlagClientClass: UnleashClient})],
 * });
 *
 * const unleash = new UnleashClient(...);
 * unleash.start();
 *
 * unleash.isEnabled('my-feature');
 * Sentry.captureException(new Error('something went wrong'));
 * ```
 */ const $d2291f482b064e01$export$e753ab651e68430d = (0, $cbb2da6c78246e45$export$2323046b9414659f)(({ featureFlagClientClass: unleashClientClass })=>{
    return {
        name: 'Unleash',
        setupOnce () {
            const unleashClientPrototype = unleashClientClass.prototype;
            (0, $269eeb69635ed414$export$9563e054e6f787fb)(unleashClientPrototype, 'isEnabled', $d2291f482b064e01$var$_wrappedIsEnabled);
        },
        processEvent (event, _hint, _client) {
            return (0, $bd39ef1eacd6c04b$export$bbaa51f7b5642e0f)(event);
        }
    };
});
/**
 * Wraps the UnleashClient.isEnabled method to capture feature flag evaluations. Its only side effect is writing to Sentry scope.
 *
 * This wrapper is safe for all isEnabled signatures. If the signature does not match (this: UnleashClient, toggleName: string, ...args: unknown[]) => boolean,
 * we log an error and return the original result.
 *
 * @param original - The original method.
 * @returns Wrapped method. Results should match the original.
 */ function $d2291f482b064e01$var$_wrappedIsEnabled(original) {
    return function(...args) {
        const toggleName = args[0];
        const result = original.apply(this, args);
        if (typeof toggleName === 'string' && typeof result === 'boolean') {
            (0, $bd39ef1eacd6c04b$export$8eeb712c9ea5b068)(toggleName, result);
            (0, $bd39ef1eacd6c04b$export$4de324656d9a2858)(toggleName, result);
        } else if (0, $6e9d48dbcf18d05a$export$16a28057038b10ef) (0, $d11ed0b3cdda6b8d$export$1c9f709888824e05).error(`[Feature Flags] UnleashClient.isEnabled does not match expected signature. arg0: ${toggleName} (${typeof toggleName}), result: ${result} (${typeof result})`);
        return result;
    };
}





/**
 * Sentry integration for capturing feature flag evaluations from GrowthBook.
 *
 * Only boolean results are captured at this time.
 *
 * @example
 * ```typescript
 * import { GrowthBook } from '@growthbook/growthbook';
 * import * as Sentry from '@sentry/browser'; // or '@sentry/node'
 *
 * Sentry.init({
 *   dsn: 'your-dsn',
 *   integrations: [
 *     Sentry.growthbookIntegration({ growthbookClass: GrowthBook })
 *   ]
 * });
 * ```
 */ const $1626df8570d7e40c$export$c8399a95701fbc9f = (0, $cbb2da6c78246e45$export$2323046b9414659f)(({ growthbookClass: growthbookClass })=>{
    return {
        name: 'GrowthBook',
        setupOnce () {
            const proto = growthbookClass.prototype;
            // Type guard and wrap isOn
            if (typeof proto.isOn === 'function') (0, $269eeb69635ed414$export$9563e054e6f787fb)(proto, 'isOn', $1626df8570d7e40c$var$_wrapAndCaptureBooleanResult);
            // Type guard and wrap getFeatureValue
            if (typeof proto.getFeatureValue === 'function') (0, $269eeb69635ed414$export$9563e054e6f787fb)(proto, 'getFeatureValue', $1626df8570d7e40c$var$_wrapAndCaptureBooleanResult);
        },
        processEvent (event, _hint, _client) {
            return (0, $bd39ef1eacd6c04b$export$bbaa51f7b5642e0f)(event);
        }
    };
});
function $1626df8570d7e40c$var$_wrapAndCaptureBooleanResult(original) {
    return function(...args) {
        const flagName = args[0];
        const result = original.apply(this, args);
        if (typeof flagName === 'string' && typeof result === 'boolean') {
            (0, $bd39ef1eacd6c04b$export$8eeb712c9ea5b068)(flagName, result);
            (0, $bd39ef1eacd6c04b$export$4de324656d9a2858)(flagName, result);
        }
        return result;
    };
}


/**
 * Sentry integration for capturing feature flag evaluations from GrowthBook.
 *
 * See the feature flag documentation: https://develop.sentry.dev/sdk/expected-features/#feature-flags
 *
 * @example
 * ```
 * import { GrowthBook } from '@growthbook/growthbook';
 * import * as Sentry from '@sentry/browser';
 *
 * Sentry.init({
 *   dsn: '___PUBLIC_DSN___',
 *   integrations: [Sentry.growthbookIntegration({ growthbookClass: GrowthBook })],
 * });
 *
 * const gb = new GrowthBook();
 * gb.isOn('my-feature');
 * Sentry.captureException(new Error('something went wrong'));
 * ```
 */ const $382b31aa5714bdd4$export$c8399a95701fbc9f = ({ growthbookClass: growthbookClass })=>(0, $1626df8570d7e40c$export$c8399a95701fbc9f)({
        growthbookClass: growthbookClass
    });



/**
 * Sentry integration for capturing feature flag evaluations from the Statsig js-client SDK.
 *
 * See the [feature flag documentation](https://develop.sentry.dev/sdk/expected-features/#feature-flags) for more information.
 *
 * @example
 * ```
 * import { StatsigClient } from '@statsig/js-client';
 * import * as Sentry from '@sentry/browser';
 *
 * const statsigClient = new StatsigClient();
 *
 * Sentry.init({
 *   dsn: '___PUBLIC_DSN___',
 *   integrations: [Sentry.statsigIntegration({featureFlagClient: statsigClient})],
 * });
 *
 * await statsigClient.initializeAsync();  // or statsigClient.initializeSync();
 *
 * const result = statsigClient.checkGate('my-feature-gate');
 * Sentry.captureException(new Error('something went wrong'));
 * ```
 */ const $cd57e45df1dff5a4$export$473918ef9c3b2ab7 = (0, $cbb2da6c78246e45$export$2323046b9414659f)(({ featureFlagClient: statsigClient })=>{
    return {
        name: 'Statsig',
        setup (_client) {
            statsigClient.on('gate_evaluation', (event)=>{
                (0, $bd39ef1eacd6c04b$export$8eeb712c9ea5b068)(event.gate.name, event.gate.value);
                (0, $bd39ef1eacd6c04b$export$4de324656d9a2858)(event.gate.name, event.gate.value);
            });
        },
        processEvent (event, _hint, _client) {
            return (0, $bd39ef1eacd6c04b$export$bbaa51f7b5642e0f)(event);
        }
    };
});



/**
 * A function to diagnose why the SDK might not be successfully sending data.
 *
 * Possible return values wrapped in a Promise:
 * - `"no-client-active"` - There was no active client when the function was called. This possibly means that the SDK was not initialized yet.
 * - `"sentry-unreachable"` - The Sentry SaaS servers were not reachable. This likely means that there is an ad blocker active on the page or that there are other connection issues.
 *
 * If the function doesn't detect an issue it resolves to `undefined`.
 */ async function $7819adec6ec21508$export$fecc80c9f0e9c1b2() {
    const client = (0, $7d48e1ed9f699a01$export$6bb76d6eba7e258c)();
    if (!client) return 'no-client-active';
    if (!client.getDsn()) return 'no-dsn-configured';
    // Check if a tunnel is configured and use it if available
    const tunnel = client.getOptions().tunnel;
    // We are using the
    // - "sentry-sdks" org with id 447951 not to pollute any actual organizations.
    // - "diagnose-sdk-connectivity" project with id 4509632503087104
    // - the public key of said org/project, which is disabled in the project settings
    // => this DSN: https://c1dfb07d783ad5325c245c1fd3725390@o447951.ingest.us.sentry.io/4509632503087104 (i.e. disabled)
    const defaultUrl = 'https://o447951.ingest.sentry.io/api/4509632503087104/envelope/?sentry_version=7&sentry_key=c1dfb07d783ad5325c245c1fd3725390&sentry_client=sentry.javascript.browser%2F1.33.7';
    const url = tunnel || defaultUrl;
    try {
        await (0, $c9161b67125aefc1$export$869298f9835abc68)(()=>// If fetch throws, there is likely an ad blocker active or there are other connective issues.
            fetch(url, {
                body: '{}',
                method: 'POST',
                mode: 'cors',
                credentials: 'omit'
            }));
    } catch  {
        return 'sentry-unreachable';
    }
}







const $907c5ffa3e02c638$export$63196314a6cfeb0f = 'WebWorker';
/**
 * Use this integration to set up Sentry with web workers.
 *
 * IMPORTANT: This integration must be added **before** you start listening to
 * any messages from the worker. Otherwise, your message handlers will receive
 * messages from the Sentry SDK which you need to ignore.
 *
 * This integration only has an effect, if you call `Sentry.registerWebWorker(self)`
 * from within the worker(s) you're adding to the integration.
 *
 * Given that you want to initialize the SDK as early as possible, you most likely
 * want to add this integration **after** initializing the SDK:
 *
 * @example:
 * ```ts filename={main.js}
 * import * as Sentry from '@sentry/<your-sdk>';
 *
 * // some time earlier:
 * Sentry.init(...)
 *
 * // 1. Initialize the worker
 * const worker = new Worker(new URL('./worker.ts', import.meta.url));
 *
 * // 2. Add the integration
 * const webWorkerIntegration = Sentry.webWorkerIntegration({ worker });
 * Sentry.addIntegration(webWorkerIntegration);
 *
 * // 3. Register message listeners on the worker
 * worker.addEventListener('message', event => {
 *  // ...
 * });
 * ```
 *
 * If you initialize multiple workers at the same time, you can also pass an array of workers
 * to the integration:
 *
 * ```ts filename={main.js}
 * const webWorkerIntegration = Sentry.webWorkerIntegration({ worker: [worker1, worker2] });
 * Sentry.addIntegration(webWorkerIntegration);
 * ```
 *
 * If you have any additional workers that you initialize at a later point,
 * you can add them to the integration as follows:
 *
 * ```ts filename={main.js}
 * const webWorkerIntegration = Sentry.webWorkerIntegration({ worker: worker1 });
 * Sentry.addIntegration(webWorkerIntegration);
 *
 * // sometime later:
 * webWorkerIntegration.addWorker(worker2);
 * ```
 *
 * Of course, you can also directly add the integration in Sentry.init:
 * ```ts filename={main.js}
 * import * as Sentry from '@sentry/<your-sdk>';
 *
 * // 1. Initialize the worker
 * const worker = new Worker(new URL('./worker.ts', import.meta.url));
 *
 * // 2. Initialize the SDK
 * Sentry.init({
 *  integrations: [Sentry.webWorkerIntegration({ worker })]
 * });
 *
 * // 3. Register message listeners on the worker
 * worker.addEventListener('message', event => {
 *  // ...
 * });
 * ```
 *
 * @param options {WebWorkerIntegrationOptions} Integration options:
 *   - `worker`: The worker instance.
 */ const $907c5ffa3e02c638$export$88896133e37bd4db = (0, $cbb2da6c78246e45$export$2323046b9414659f)(({ worker: worker })=>({
        name: $907c5ffa3e02c638$export$63196314a6cfeb0f,
        setupOnce: ()=>{
            (Array.isArray(worker) ? worker : [
                worker
            ]).forEach((w)=>$907c5ffa3e02c638$var$listenForSentryMessages(w));
        },
        addWorker: (worker)=>$907c5ffa3e02c638$var$listenForSentryMessages(worker)
    }));
function $907c5ffa3e02c638$var$listenForSentryMessages(worker) {
    worker.addEventListener('message', (event)=>{
        if ($907c5ffa3e02c638$var$isSentryMessage(event.data)) {
            event.stopImmediatePropagation(); // other listeners should not receive this message
            // Handle debug IDs
            if (event.data._sentryDebugIds) {
                (0, $6e9d48dbcf18d05a$export$16a28057038b10ef) && (0, $d11ed0b3cdda6b8d$export$1c9f709888824e05).log('Sentry debugId web worker message received', event.data);
                (0, $e62dec891f31852b$export$56d8a8a25bd48b81)._sentryDebugIds = {
                    ...event.data._sentryDebugIds,
                    // debugIds of the main thread have precedence over the worker's in case of a collision.
                    ...(0, $e62dec891f31852b$export$56d8a8a25bd48b81)._sentryDebugIds
                };
            }
            // Handle module metadata
            if (event.data._sentryModuleMetadata) {
                (0, $6e9d48dbcf18d05a$export$16a28057038b10ef) && (0, $d11ed0b3cdda6b8d$export$1c9f709888824e05).log('Sentry module metadata web worker message received', event.data);
                // Merge worker's raw metadata into the global object
                // It will be parsed lazily when needed by getMetadataForUrl
                (0, $e62dec891f31852b$export$56d8a8a25bd48b81)._sentryModuleMetadata = {
                    ...event.data._sentryModuleMetadata,
                    // Module metadata of the main thread have precedence over the worker's in case of a collision.
                    ...(0, $e62dec891f31852b$export$56d8a8a25bd48b81)._sentryModuleMetadata
                };
            }
            // Handle WASM images from worker
            if (event.data._sentryWasmImages) {
                (0, $6e9d48dbcf18d05a$export$16a28057038b10ef) && (0, $d11ed0b3cdda6b8d$export$1c9f709888824e05).log('Sentry WASM images web worker message received', event.data);
                const existingImages = (0, $e62dec891f31852b$export$56d8a8a25bd48b81)._sentryWasmImages || [];
                const newImages = event.data._sentryWasmImages.filter((newImg)=>(0, $13cf2ed412f405fa$export$53b83ca8eaab0383)(newImg) && typeof newImg.code_file === 'string' && !existingImages.some((existing)=>existing.code_file === newImg.code_file));
                (0, $e62dec891f31852b$export$56d8a8a25bd48b81)._sentryWasmImages = [
                    ...existingImages,
                    ...newImages
                ];
            }
            // Handle unhandled rejections forwarded from worker
            if (event.data._sentryWorkerError) {
                (0, $6e9d48dbcf18d05a$export$16a28057038b10ef) && (0, $d11ed0b3cdda6b8d$export$1c9f709888824e05).log('Sentry worker rejection message received', event.data._sentryWorkerError);
                $907c5ffa3e02c638$var$handleForwardedWorkerRejection(event.data._sentryWorkerError);
            }
        }
    });
}
function $907c5ffa3e02c638$var$handleForwardedWorkerRejection(workerError) {
    const client = (0, $7d48e1ed9f699a01$export$6bb76d6eba7e258c)();
    if (!client) return;
    const stackParser = client.getOptions().stackParser;
    const attachStacktrace = client.getOptions().attachStacktrace;
    const error = workerError.reason;
    // Follow same pattern as globalHandlers for unhandledrejection
    // Handle both primitives and errors the same way
    const event = (0, $13cf2ed412f405fa$export$c3825b437cbdea5c)(error) ? (0, $f1959cdcacc276d1$export$1353b5b36844a9ed)(error) : (0, $934e8a4b0ce930b6$export$9dd56ed1ef0c3420)(stackParser, error, undefined, attachStacktrace, true);
    event.level = 'error';
    // Add worker-specific context
    if (workerError.filename) event.contexts = {
        ...event.contexts,
        worker: {
            filename: workerError.filename
        }
    };
    (0, $6918c722b531ff18$export$1462b974fdcf6ba2)(event, {
        originalException: error,
        mechanism: {
            handled: false,
            type: 'auto.browser.web_worker.onunhandledrejection'
        }
    });
    (0, $6e9d48dbcf18d05a$export$16a28057038b10ef) && (0, $d11ed0b3cdda6b8d$export$1c9f709888824e05).log('Captured worker unhandled rejection', error);
}
/**
 * Minimal interface for DedicatedWorkerGlobalScope, only requiring the postMessage method.
 * (which is the only thing we need from the worker's global object)
 *
 * @see https://developer.mozilla.org/en-US/docs/Web/API/DedicatedWorkerGlobalScope
 *
 * We can't use the actual type because it breaks everyone who doesn't have {"lib": ["WebWorker"]}
 * but uses {"skipLibCheck": true} in their tsconfig.json.
 */ /**
 * Use this function to register the worker with the Sentry SDK.
 *
 * This function will:
 * - Send debug IDs to the parent thread
 * - Send module metadata to the parent thread (for thirdPartyErrorFilterIntegration)
 * - Set up a handler for unhandled rejections in the worker
 * - Forward unhandled rejections to the parent thread for capture
 *
 * Note: Synchronous errors in workers are already captured by globalHandlers.
 * This only handles unhandled promise rejections which don't bubble to the parent.
 *
 * @example
 * ```ts filename={worker.js}
 * import * as Sentry from '@sentry/<your-sdk>';
 *
 * // Do this as early as possible in your worker.
 * Sentry.registerWebWorker({ self });
 *
 * // continue setting up your worker
 * self.postMessage(...)
 * ```
 * @param options {RegisterWebWorkerOptions} Integration options:
 *   - `self`: The worker instance you're calling this function from (self).
 */ function $907c5ffa3e02c638$export$86daa8bd1fb8c346({ self: self }) {
    // Send debug IDs and raw module metadata to parent thread
    // The metadata will be parsed lazily on the main thread when needed
    self.postMessage({
        _sentryMessage: true,
        _sentryDebugIds: self._sentryDebugIds ?? undefined,
        _sentryModuleMetadata: self._sentryModuleMetadata ?? undefined
    });
    // Set up unhandledrejection handler inside the worker
    // Following the same pattern as globalHandlers
    // unhandled rejections don't bubble to the parent thread, so we need to handle them here
    self.addEventListener('unhandledrejection', (event)=>{
        const reason = (0, $f1959cdcacc276d1$export$b2cc40fa8241780)(event);
        // Forward the raw reason to parent thread
        // The parent will handle primitives vs errors the same way globalHandlers does
        const serializedError = {
            reason: reason,
            filename: self.location?.href
        };
        // Forward to parent thread
        self.postMessage({
            _sentryMessage: true,
            _sentryWorkerError: serializedError
        });
        (0, $6e9d48dbcf18d05a$export$16a28057038b10ef) && (0, $d11ed0b3cdda6b8d$export$1c9f709888824e05).log('[Sentry Worker] Forwarding unhandled rejection to parent', serializedError);
    });
    (0, $6e9d48dbcf18d05a$export$16a28057038b10ef) && (0, $d11ed0b3cdda6b8d$export$1c9f709888824e05).log('[Sentry Worker] Registered worker with unhandled rejection handling');
}
function $907c5ffa3e02c638$var$isSentryMessage(eventData) {
    if (!(0, $13cf2ed412f405fa$export$53b83ca8eaab0383)(eventData) || eventData._sentryMessage !== true) return false;
    // Must have at least one of: debug IDs, module metadata, worker error, or WASM images
    const hasDebugIds = '_sentryDebugIds' in eventData;
    const hasModuleMetadata = '_sentryModuleMetadata' in eventData;
    const hasWorkerError = '_sentryWorkerError' in eventData;
    const hasWasmImages = '_sentryWasmImages' in eventData;
    if (!hasDebugIds && !hasModuleMetadata && !hasWorkerError && !hasWasmImages) return false;
    // Validate debug IDs if present
    if (hasDebugIds && !((0, $13cf2ed412f405fa$export$53b83ca8eaab0383)(eventData._sentryDebugIds) || eventData._sentryDebugIds === undefined)) return false;
    // Validate module metadata if present
    if (hasModuleMetadata && !((0, $13cf2ed412f405fa$export$53b83ca8eaab0383)(eventData._sentryModuleMetadata) || eventData._sentryModuleMetadata === undefined)) return false;
    // Validate worker error if present
    if (hasWorkerError && !(0, $13cf2ed412f405fa$export$53b83ca8eaab0383)(eventData._sentryWorkerError)) return false;
    // Validate WASM images if present
    if (hasWasmImages && (!Array.isArray(eventData._sentryWasmImages) || !eventData._sentryWasmImages.every((img)=>(0, $13cf2ed412f405fa$export$53b83ca8eaab0383)(img) && typeof img.code_file === 'string'))) return false;
    return true;
}







var $5FkrB = parcelRequire("5FkrB");
/**
 * Inits the React SDK
 */ function $c3b6349452077e3f$export$2cd8252107eb640b(options) {
    const opts = {
        ...options
    };
    (0, $4379b47e31368aa0$export$b9f95b027256052c)(opts, 'react');
    (0, $6918c722b531ff18$export$2f04de43fe27971a)('react', {
        version: $5FkrB.version
    });
    return (0, $14d7809dba5d50b0$export$2cd8252107eb640b)(opts);
}





var $5FkrB = parcelRequire("5FkrB");
/**
 * See if React major version is 17+ by parsing version string.
 */ function $d73ec427c982e9ee$export$a87138b73900f5b(reactVersion) {
    const reactMajor = reactVersion.match(/^([^.]+)/);
    return reactMajor !== null && parseInt(reactMajor[0]) >= 17;
}
/**
 * Recurse through `error.cause` chain to set cause on an error.
 */ function $d73ec427c982e9ee$export$bc95048bc211a673(error, cause) {
    const seenErrors = new WeakSet();
    function recurse(error, cause) {
        // If we've already seen the error, there is a recursive loop somewhere in the error's
        // cause chain. Let's just bail out then to prevent a stack overflow.
        if (seenErrors.has(error)) return;
        if (error.cause) {
            seenErrors.add(error);
            return recurse(error.cause, cause);
        }
        error.cause = cause;
    }
    recurse(error, cause);
}
/**
 * Captures an error that was thrown by a React ErrorBoundary or React root.
 *
 * @param error The error to capture.
 * @param errorInfo The errorInfo provided by React.
 * @param hint Optional additional data to attach to the Sentry event.
 * @returns the id of the captured Sentry event.
 */ function $d73ec427c982e9ee$export$270be4195468cda9(// eslint-disable-next-line @typescript-eslint/no-explicit-any
error, { componentStack: componentStack }, hint) {
    // If on React version >= 17, create stack trace from componentStack param and links
    // to to the original error using `error.cause` otherwise relies on error param for stacktrace.
    // Linking errors requires the `LinkedErrors` integration be enabled.
    // See: https://reactjs.org/blog/2020/08/10/react-v17-rc.html#native-component-stacks
    //
    // Although `componentDidCatch` is typed to accept an `Error` object, it can also be invoked
    // with non-error objects. This is why we need to check if the error is an error-like object.
    // See: https://github.com/getsentry/sentry-javascript/issues/6167
    if ($d73ec427c982e9ee$export$a87138b73900f5b((0, $5FkrB.version)) && (0, $13cf2ed412f405fa$export$e6127cc7fe7395c3)(error) && componentStack) {
        const errorBoundaryError = new Error(error.message);
        errorBoundaryError.name = `React ErrorBoundary ${error.name}`;
        errorBoundaryError.stack = componentStack;
        // Using the `LinkedErrors` integration to link the errors together.
        $d73ec427c982e9ee$export$bc95048bc211a673(error, errorBoundaryError);
    }
    return (0, $7d48e1ed9f699a01$export$ec58d9285c204497)((scope)=>{
        scope.setContext('react', {
            componentStack: componentStack
        });
        return (0, $6918c722b531ff18$export$f5282963edea4a68)(error, hint);
    });
}
/**
 * Creates an error handler that can be used with the `onCaughtError`, `onUncaughtError`,
 * and `onRecoverableError` options in `createRoot` and `hydrateRoot` React DOM methods.
 *
 * @param callback An optional callback that will be called after the error is captured.
 * Use this to add custom handling for errors.
 *
 * @example
 *
 * ```JavaScript
 * const root = createRoot(container, {
 *  onCaughtError: Sentry.reactErrorHandler(),
 *  onUncaughtError: Sentry.reactErrorHandler((error, errorInfo) => {
 *    console.warn('Caught error', error, errorInfo.componentStack);
 *  });
 * });
 * ```
 */ function $d73ec427c982e9ee$export$1e6f045b27b3cfb1(// eslint-disable-next-line @typescript-eslint/no-explicit-any
callback) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return (error, errorInfo)=>{
        const hasCallback = !!callback;
        const eventId = $d73ec427c982e9ee$export$270be4195468cda9(error, errorInfo, {
            mechanism: {
                handled: hasCallback,
                type: 'auto.function.react.error_handler'
            }
        });
        if (hasCallback) callback(error, errorInfo, eventId);
    };
}





var $5FkrB = parcelRequire("5FkrB");
const $4a33d92877504aad$export$a5a94ea2f791dca1 = 'ui.react.render';
const $4a33d92877504aad$export$ee0f1075b9437852 = 'ui.react.update';
const $4a33d92877504aad$export$2c5aa1bf688e9ea1 = 'ui.react.mount';


/**
 * React statics that should not be hoisted
 */ const $2015f24f5be0bafb$var$REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
/**
 * Known JavaScript function statics that should not be hoisted
 */ const $2015f24f5be0bafb$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
/**
 * Statics specific to ForwardRef components
 */ const $2015f24f5be0bafb$var$FORWARD_REF_STATICS = {
    $$typeof: true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
/**
 * Statics specific to Memo components
 */ const $2015f24f5be0bafb$var$MEMO_STATICS = {
    $$typeof: true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
/**
 * Inlined react-is utilities
 * We only need to detect ForwardRef and Memo types
 */ const $2015f24f5be0bafb$var$ForwardRefType = Symbol.for('react.forward_ref');
const $2015f24f5be0bafb$var$MemoType = Symbol.for('react.memo');
/**
 * Check if a component is a Memo component
 */ function $2015f24f5be0bafb$var$isMemo(component) {
    return typeof component === 'object' && component !== null && component.$$typeof === $2015f24f5be0bafb$var$MemoType;
}
/**
 * Map of React component types to their specific statics
 */ const $2015f24f5be0bafb$var$TYPE_STATICS = {};
$2015f24f5be0bafb$var$TYPE_STATICS[$2015f24f5be0bafb$var$ForwardRefType] = $2015f24f5be0bafb$var$FORWARD_REF_STATICS;
$2015f24f5be0bafb$var$TYPE_STATICS[$2015f24f5be0bafb$var$MemoType] = $2015f24f5be0bafb$var$MEMO_STATICS;
/**
 * Get the appropriate statics object for a given component
 */ function $2015f24f5be0bafb$var$getStatics(component) {
    // React v16.11 and below
    if ($2015f24f5be0bafb$var$isMemo(component)) return $2015f24f5be0bafb$var$MEMO_STATICS;
    // React v16.12 and above
    const componentType = component.$$typeof;
    return componentType && $2015f24f5be0bafb$var$TYPE_STATICS[componentType] || $2015f24f5be0bafb$var$REACT_STATICS;
}
const $2015f24f5be0bafb$var$defineProperty = Object.defineProperty.bind(Object);
const $2015f24f5be0bafb$var$getOwnPropertyNames = Object.getOwnPropertyNames.bind(Object);
const $2015f24f5be0bafb$var$getOwnPropertySymbols = Object.getOwnPropertySymbols?.bind(Object);
const $2015f24f5be0bafb$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor.bind(Object);
const $2015f24f5be0bafb$var$getPrototypeOf = Object.getPrototypeOf.bind(Object);
const $2015f24f5be0bafb$var$objectPrototype = Object.prototype;
/**
 * Copies non-react specific statics from a child component to a parent component.
 * Similar to Object.assign, but copies all static properties from source to target,
 * excluding React-specific statics and known JavaScript statics.
 *
 * @param targetComponent - The component to copy statics to
 * @param sourceComponent - The component to copy statics from
 * @param excludelist - An optional object of keys to exclude from hoisting
 * @returns The target component with hoisted statics
 */ function $2015f24f5be0bafb$export$6c1f0397687d8b2(targetComponent, sourceComponent, excludelist) {
    if (typeof sourceComponent !== 'string') {
        // Don't hoist over string (html) components
        if ($2015f24f5be0bafb$var$objectPrototype) {
            const inheritedComponent = $2015f24f5be0bafb$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $2015f24f5be0bafb$var$objectPrototype) $2015f24f5be0bafb$export$6c1f0397687d8b2(targetComponent, inheritedComponent);
        }
        let keys = $2015f24f5be0bafb$var$getOwnPropertyNames(sourceComponent);
        if ($2015f24f5be0bafb$var$getOwnPropertySymbols) keys = keys.concat($2015f24f5be0bafb$var$getOwnPropertySymbols(sourceComponent));
        const targetStatics = $2015f24f5be0bafb$var$getStatics(targetComponent);
        const sourceStatics = $2015f24f5be0bafb$var$getStatics(sourceComponent);
        for (const key of keys)// Use key directly - String(key) throws for Symbols if minified to '' + key (#18966)
        if (!$2015f24f5be0bafb$var$KNOWN_STATICS[key] && true && !sourceStatics?.[key] && !targetStatics?.[key] && !$2015f24f5be0bafb$var$getOwnPropertyDescriptor(targetComponent, key) // Don't overwrite existing properties
        ) {
            const descriptor = $2015f24f5be0bafb$var$getOwnPropertyDescriptor(sourceComponent, key);
            if (descriptor) try {
                // Avoid failures from read-only properties
                $2015f24f5be0bafb$var$defineProperty(targetComponent, key, descriptor);
            } catch (_e) {
            // Silently ignore errors
            }
        }
    }
    return targetComponent;
}


const $eeb2a38f5ea169f2$export$6ef4c0367e27f2d5 = 'unknown';
/**
 * The Profiler component leverages Sentry's Tracing integration to generate
 * spans based on component lifecycles.
 */ class $eeb2a38f5ea169f2$export$e2c29f18771995cb extends $5FkrB.Component {
    /**
   * The span of the mount activity
   * Made protected for the React Native SDK to access
   */ /**
   * The span that represents the duration of time between shouldComponentUpdate and componentDidUpdate
   */ constructor(props){
        super(props);
        const { name: name, disabled: disabled = false } = this.props;
        if (disabled) return;
        this._mountSpan = (0, $c9161b67125aefc1$export$63dbba021a6b4047)({
            name: `<${name}>`,
            onlyIfParent: true,
            op: (0, $4a33d92877504aad$export$2c5aa1bf688e9ea1),
            attributes: {
                [(0, $f337c80285f06f80$export$cca8dd30f57f805e)]: 'auto.ui.react.profiler',
                'ui.component_name': name
            }
        });
    }
    // If a component mounted, we can finish the mount activity.
    componentDidMount() {
        if (this._mountSpan) this._mountSpan.end();
    }
    shouldComponentUpdate({ updateProps: updateProps, includeUpdates: includeUpdates = true }) {
        // Only generate an update span if includeUpdates is true, if there is a valid mountSpan,
        // and if the updateProps have changed. It is ok to not do a deep equality check here as it is expensive.
        // We are just trying to give baseline clues for further investigation.
        if (includeUpdates && this._mountSpan && updateProps !== this.props.updateProps) {
            // See what props have changed between the previous props, and the current props. This is
            // set as data on the span. We just store the prop keys as the values could be potentially very large.
            const changedProps = Object.keys(updateProps).filter((k)=>updateProps[k] !== this.props.updateProps[k]);
            if (changedProps.length > 0) {
                const now = (0, $bc81602376c48fa6$export$ee52dced521e3e18)();
                this._updateSpan = (0, $c9161b67125aefc1$export$e57ac09b143d92a2)(this._mountSpan, ()=>{
                    return (0, $c9161b67125aefc1$export$63dbba021a6b4047)({
                        name: `<${this.props.name}>`,
                        onlyIfParent: true,
                        op: (0, $4a33d92877504aad$export$ee0f1075b9437852),
                        startTime: now,
                        attributes: {
                            [(0, $f337c80285f06f80$export$cca8dd30f57f805e)]: 'auto.ui.react.profiler',
                            'ui.component_name': this.props.name,
                            'ui.react.changed_props': changedProps
                        }
                    });
                });
            }
        }
        return true;
    }
    componentDidUpdate() {
        if (this._updateSpan) {
            this._updateSpan.end();
            this._updateSpan = undefined;
        }
    }
    // If a component is unmounted, we can say it is no longer on the screen.
    // This means we can finish the span representing the component render.
    componentWillUnmount() {
        const endTimestamp = (0, $bc81602376c48fa6$export$ee52dced521e3e18)();
        const { name: name, includeRender: includeRender = true } = this.props;
        if (this._mountSpan && includeRender) {
            const startTime = (0, $bb9b6447bf4caedb$export$92d8c23565496537)(this._mountSpan).timestamp;
            (0, $c9161b67125aefc1$export$e57ac09b143d92a2)(this._mountSpan, ()=>{
                const renderSpan = (0, $c9161b67125aefc1$export$63dbba021a6b4047)({
                    onlyIfParent: true,
                    name: `<${name}>`,
                    op: (0, $4a33d92877504aad$export$a5a94ea2f791dca1),
                    startTime: startTime,
                    attributes: {
                        [(0, $f337c80285f06f80$export$cca8dd30f57f805e)]: 'auto.ui.react.profiler',
                        'ui.component_name': name
                    }
                });
                if (renderSpan) // Have to cast to Span because the type of _mountSpan is Span | undefined
                // and not getting narrowed properly
                renderSpan.end(endTimestamp);
            });
        }
    }
    render() {
        return this.props.children;
    }
}
// React.Component default props are defined as static property on the class
Object.assign($eeb2a38f5ea169f2$export$e2c29f18771995cb, {
    defaultProps: {
        disabled: false,
        includeRender: true,
        includeUpdates: true
    }
});
/**
 * withProfiler is a higher order component that wraps a
 * component in a {@link Profiler} component. It is recommended that
 * the higher order component be used over the regular {@link Profiler} component.
 *
 * @param WrappedComponent component that is wrapped by Profiler
 * @param options the {@link ProfilerProps} you can pass into the Profiler
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $eeb2a38f5ea169f2$export$e1e354213dd1a8a7(WrappedComponent, // We do not want to have `updateProps` given in options, it is instead filled through the HOC.
options) {
    const componentDisplayName = options?.name || WrappedComponent.displayName || WrappedComponent.name || $eeb2a38f5ea169f2$export$6ef4c0367e27f2d5;
    const Wrapped = (props)=>$5FkrB.createElement($eeb2a38f5ea169f2$export$e2c29f18771995cb, {
            ...options,
            name: componentDisplayName,
            updateProps: props
        }, $5FkrB.createElement(WrappedComponent, {
            ...props
        }));
    Wrapped.displayName = `profiler(${componentDisplayName})`;
    // Copy over static methods from Wrapped component to Profiler HOC
    // See: https://reactjs.org/docs/higher-order-components.html#static-methods-must-be-copied-over
    (0, $2015f24f5be0bafb$export$6c1f0397687d8b2)(Wrapped, WrappedComponent);
    return Wrapped;
}
/**
 *
 * `useProfiler` is a React hook that profiles a React component.
 *
 * Requires React 16.8 or above.
 * @param name displayName of component being profiled
 */ function $eeb2a38f5ea169f2$export$972a52cbfaf8cf13(name, options = {
    disabled: false,
    hasRenderSpan: true
}) {
    const [mountSpan] = $5FkrB.useState(()=>{
        if (options?.disabled) return undefined;
        return (0, $c9161b67125aefc1$export$63dbba021a6b4047)({
            name: `<${name}>`,
            onlyIfParent: true,
            op: (0, $4a33d92877504aad$export$2c5aa1bf688e9ea1),
            attributes: {
                [(0, $f337c80285f06f80$export$cca8dd30f57f805e)]: 'auto.ui.react.profiler',
                'ui.component_name': name
            }
        });
    });
    $5FkrB.useEffect(()=>{
        if (mountSpan) mountSpan.end();
        return ()=>{
            if (mountSpan && options.hasRenderSpan) {
                const startTime = (0, $bb9b6447bf4caedb$export$92d8c23565496537)(mountSpan).timestamp;
                const endTimestamp = (0, $bc81602376c48fa6$export$ee52dced521e3e18)();
                const renderSpan = (0, $c9161b67125aefc1$export$63dbba021a6b4047)({
                    name: `<${name}>`,
                    onlyIfParent: true,
                    op: (0, $4a33d92877504aad$export$a5a94ea2f791dca1),
                    startTime: startTime,
                    attributes: {
                        [(0, $f337c80285f06f80$export$cca8dd30f57f805e)]: 'auto.ui.react.profiler',
                        'ui.component_name': name
                    }
                });
                if (renderSpan) // Have to cast to Span because the type of _mountSpan is Span | undefined
                // and not getting narrowed properly
                renderSpan.end(endTimestamp);
            }
        };
    // We only want this to run once.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
}





var $5FkrB = parcelRequire("5FkrB");
/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $0ee57f62053fbbae$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__;




const $d86fddd54af16059$export$6ef4c0367e27f2d5 = 'unknown';
const $d86fddd54af16059$var$INITIAL_STATE = {
    componentStack: null,
    error: null,
    eventId: null
};
/**
 * A ErrorBoundary component that logs errors to Sentry.
 * NOTE: If you are a Sentry user, and you are seeing this stack frame, it means the
 * Sentry React SDK ErrorBoundary caught an error invoking your application code. This
 * is expected behavior and NOT indicative of a bug with the Sentry React SDK.
 */ class $d86fddd54af16059$export$e926676385687eaf extends $5FkrB.Component {
    constructor(props){
        super(props);
        this.state = $d86fddd54af16059$var$INITIAL_STATE;
        this._openFallbackReportDialog = true;
        const client = (0, $7d48e1ed9f699a01$export$6bb76d6eba7e258c)();
        if (client && props.showDialog) {
            this._openFallbackReportDialog = false;
            this._cleanupHook = client.on('afterSendEvent', (event)=>{
                if (!event.type && this._lastEventId && event.event_id === this._lastEventId) (0, $c145e0c6ce486f3a$export$3a8fd680da42627b)({
                    ...props.dialogOptions,
                    eventId: this._lastEventId
                });
            });
        }
    }
    componentDidCatch(error, errorInfo) {
        const { componentStack: componentStack } = errorInfo;
        const { beforeCapture: beforeCapture, onError: onError, showDialog: showDialog, dialogOptions: dialogOptions } = this.props;
        (0, $7d48e1ed9f699a01$export$ec58d9285c204497)((scope)=>{
            if (beforeCapture) beforeCapture(scope, error, componentStack);
            const handled = this.props.handled != null ? this.props.handled : !!this.props.fallback;
            const eventId = (0, $d73ec427c982e9ee$export$270be4195468cda9)(error, errorInfo, {
                mechanism: {
                    handled: handled,
                    type: 'auto.function.react.error_boundary'
                }
            });
            if (onError) onError(error, componentStack, eventId);
            if (showDialog) {
                this._lastEventId = eventId;
                if (this._openFallbackReportDialog) (0, $c145e0c6ce486f3a$export$3a8fd680da42627b)({
                    ...dialogOptions,
                    eventId: eventId
                });
            }
            // componentDidCatch is used over getDerivedStateFromError
            // so that componentStack is accessible through state.
            this.setState({
                error: error,
                componentStack: componentStack,
                eventId: eventId
            });
        });
    }
    componentDidMount() {
        const { onMount: onMount } = this.props;
        if (onMount) onMount();
    }
    componentWillUnmount() {
        const { error: error, componentStack: componentStack, eventId: eventId } = this.state;
        const { onUnmount: onUnmount } = this.props;
        if (onUnmount) {
            if (this.state === $d86fddd54af16059$var$INITIAL_STATE) // If the error boundary never encountered an error, call onUnmount with null values
            onUnmount(null, null, null);
            else // `componentStack` and `eventId` are guaranteed to be non-null here because `onUnmount` is only called
            // when the error boundary has already encountered an error.
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            onUnmount(error, componentStack, eventId);
        }
        if (this._cleanupHook) {
            this._cleanupHook();
            this._cleanupHook = undefined;
        }
    }
    resetErrorBoundary() {
        const { onReset: onReset } = this.props;
        const { error: error, componentStack: componentStack, eventId: eventId } = this.state;
        if (onReset) // `componentStack` and `eventId` are guaranteed to be non-null here because `onReset` is only called
        // when the error boundary has already encountered an error.
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        onReset(error, componentStack, eventId);
        this.setState($d86fddd54af16059$var$INITIAL_STATE);
    }
    render() {
        const { fallback: fallback, children: children } = this.props;
        const state = this.state;
        // `componentStack` is only null in the initial state, when no error has been captured.
        // If an error has been captured, `componentStack` will be a string.
        // We cannot check `state.error` because null can be thrown as an error.
        if (state.componentStack === null) return typeof children === 'function' ? children() : children;
        const element = typeof fallback === 'function' ? $5FkrB.createElement(fallback, {
            error: state.error,
            componentStack: state.componentStack,
            resetError: ()=>this.resetErrorBoundary(),
            eventId: state.eventId
        }) : fallback;
        if ($5FkrB.isValidElement(element)) return element;
        if (fallback) (0, $0ee57f62053fbbae$export$16a28057038b10ef) && (0, $d11ed0b3cdda6b8d$export$1c9f709888824e05).warn('fallback did not produce a valid ReactElement');
        // Fail gracefully if no fallback provided or is not valid
        return null;
    }
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $d86fddd54af16059$export$f0c7a449e0cfaec7(WrappedComponent, errorBoundaryOptions) {
    const componentDisplayName = WrappedComponent.displayName || WrappedComponent.name || $d86fddd54af16059$export$6ef4c0367e27f2d5;
    const Wrapped = $5FkrB.memo((props)=>$5FkrB.createElement($d86fddd54af16059$export$e926676385687eaf, {
            ...errorBoundaryOptions
        }, $5FkrB.createElement(WrappedComponent, {
            ...props
        })));
    Wrapped.displayName = `errorBoundary(${componentDisplayName})`;
    // Copy over static methods from Wrapped component to Profiler HOC
    // See: https://reactjs.org/docs/higher-order-components.html#static-methods-must-be-copied-over
    (0, $2015f24f5be0bafb$export$6c1f0397687d8b2)(Wrapped, WrappedComponent);
    return Wrapped;
}



const $18b37302a7d113fe$var$ACTION_BREADCRUMB_CATEGORY = 'redux.action';
const $18b37302a7d113fe$var$ACTION_BREADCRUMB_TYPE = 'info';
const $18b37302a7d113fe$var$defaultOptions = {
    attachReduxState: true,
    actionTransformer: (action)=>action,
    stateTransformer: (state)=>state || null
};
/**
 * Creates an enhancer that would be passed to Redux's createStore to log actions and the latest state to Sentry.
 *
 * @param enhancerOptions Options to pass to the enhancer
 */ function $18b37302a7d113fe$export$c4506dd2040faa8a(enhancerOptions) {
    // Note: We return an any type as to not have type conflicts.
    const options = {
        ...$18b37302a7d113fe$var$defaultOptions,
        ...enhancerOptions
    };
    return (next)=>(reducer, initialState)=>{
            options.attachReduxState && (0, $7d48e1ed9f699a01$export$aa55d5ab8e05984f)().addEventProcessor((event, hint)=>{
                try {
                    // @ts-expect-error try catch to reduce bundle size
                    if (event.type === undefined && event.contexts.state.state.type === 'redux') hint.attachments = [
                        ...hint.attachments || [],
                        // @ts-expect-error try catch to reduce bundle size
                        {
                            filename: 'redux_state.json',
                            data: JSON.stringify(event.contexts.state.state.value)
                        }
                    ];
                } catch  {
                // empty
                }
                return event;
            });
            function sentryWrapReducer(reducer) {
                return (state, action)=>{
                    const newState = reducer(state, action);
                    const scope = (0, $7d48e1ed9f699a01$export$c7be4b0125a10cba)();
                    /* Action breadcrumbs */ const transformedAction = options.actionTransformer(action);
                    if (typeof transformedAction !== 'undefined' && transformedAction !== null) (0, $777cacbd1bed0b63$export$efda9a273d7a036d)({
                        category: $18b37302a7d113fe$var$ACTION_BREADCRUMB_CATEGORY,
                        data: transformedAction,
                        type: $18b37302a7d113fe$var$ACTION_BREADCRUMB_TYPE
                    });
                    /* Set latest state to scope */ const transformedState = options.stateTransformer(newState);
                    if (typeof transformedState !== 'undefined' && transformedState !== null) {
                        const client = (0, $7d48e1ed9f699a01$export$6bb76d6eba7e258c)();
                        const options = client?.getOptions();
                        const normalizationDepth = options?.normalizeDepth || 3; // default state normalization depth to 3
                        // Set the normalization depth of the redux state to the configured `normalizeDepth` option or a sane number as a fallback
                        const newStateContext = {
                            state: {
                                type: 'redux',
                                value: transformedState
                            }
                        };
                        (0, $269eeb69635ed414$export$e73679ffaf56810e)(newStateContext, '__sentry_override_normalization_depth__', 3 + // 3 layers for `state.value.transformedState`
                        normalizationDepth);
                        scope.setContext('state', newStateContext);
                    } else scope.setContext('state', null);
                    /* Allow user to configure scope with latest state */ const { configureScopeWithState: configureScopeWithState } = options;
                    if (typeof configureScopeWithState === 'function') configureScopeWithState(scope, newState);
                    return newState;
                };
            }
            const store = next(sentryWrapReducer(reducer), initialState);
            // eslint-disable-next-line @typescript-eslint/unbound-method
            store.replaceReducer = new Proxy(store.replaceReducer, {
                apply: function(target, thisArg, args) {
                    target.apply(thisArg, [
                        sentryWrapReducer(args[0])
                    ]);
                }
            });
            return store;
        };
}




// Many of the types below had to be mocked out to prevent typescript issues
// these types are required for correct functionality.
/**
 * A browser tracing integration that uses React Router v3 to instrument navigations.
 * Expects `history` (and optionally `routes` and `matchPath`) to be passed as options.
 */ function $31664e4a36abe457$export$8a5d05e8905d7257(options) {
    const integration = (0, $7b5f2a588355dc11$export$b4109253475213e9)({
        ...options,
        instrumentPageLoad: false,
        instrumentNavigation: false
    });
    const { history: history, routes: routes, match: match, instrumentPageLoad: instrumentPageLoad = true, instrumentNavigation: instrumentNavigation = true } = options;
    return {
        ...integration,
        afterAllSetup (client) {
            integration.afterAllSetup(client);
            if (instrumentPageLoad && (0, $e62dec891f31852b$export$56d8a8a25bd48b81).location) $31664e4a36abe457$var$normalizeTransactionName(routes, (0, $e62dec891f31852b$export$56d8a8a25bd48b81).location, match, (localName, source = 'url')=>{
                (0, $7b5f2a588355dc11$export$aa44a07f82af519f)(client, {
                    name: localName,
                    attributes: {
                        [(0, $f337c80285f06f80$export$1a413bd9a88fdb09)]: 'pageload',
                        [(0, $f337c80285f06f80$export$cca8dd30f57f805e)]: 'auto.pageload.react.reactrouter_v3',
                        [(0, $f337c80285f06f80$export$d7a7d984b0791405)]: source
                    }
                });
            });
            if (instrumentNavigation && history.listen) history.listen((location)=>{
                if (location.action === 'PUSH' || location.action === 'POP') $31664e4a36abe457$var$normalizeTransactionName(routes, location, match, (localName, source = 'url')=>{
                    (0, $7b5f2a588355dc11$export$7d159749bd9969ad)(client, {
                        name: localName,
                        attributes: {
                            [(0, $f337c80285f06f80$export$1a413bd9a88fdb09)]: 'navigation',
                            [(0, $f337c80285f06f80$export$cca8dd30f57f805e)]: 'auto.navigation.react.reactrouter_v3',
                            [(0, $f337c80285f06f80$export$d7a7d984b0791405)]: source
                        }
                    });
                });
            });
        }
    };
}
/**
 * Normalize transaction names using `Router.match`
 */ function $31664e4a36abe457$var$normalizeTransactionName(appRoutes, location, match, callback) {
    let name = location.pathname;
    match({
        location: location,
        routes: appRoutes
    }, (error, _redirectLocation, renderProps)=>{
        if (error || !renderProps) return callback(name);
        const routePath = $31664e4a36abe457$var$getRouteStringFromRoutes(renderProps.routes || []);
        if (routePath.length === 0 || routePath === '/*') return callback(name);
        name = routePath;
        return callback(name, 'route');
    });
}
/**
 * Generate route name from array of routes
 */ function $31664e4a36abe457$var$getRouteStringFromRoutes(routes) {
    if (!Array.isArray(routes) || routes.length === 0) return '';
    const routesWithPaths = routes.filter((route)=>!!route.path);
    let index = -1;
    for(let x = routesWithPaths.length - 1; x >= 0; x--){
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const route = routesWithPaths[x];
        if (route.path?.startsWith('/')) {
            index = x;
            break;
        }
    }
    return routesWithPaths.slice(index).reduce((acc, { path: path })=>{
        const pathSegment = acc === '/' || acc === '' ? path : `/${path}`;
        return `${acc}${pathSegment}`;
    }, '');
}




/**
 * A custom browser tracing integration for TanStack Router.
 *
 * The minimum compatible version of `@tanstack/react-router` is `1.64.0`.
 *
 * @param router A TanStack Router `Router` instance that should be used for routing instrumentation.
 * @param options Sentry browser tracing configuration.
 */ function $9351852664295212$export$6405014438b98f22(// eslint-disable-next-line @typescript-eslint/no-explicit-any
router, options = {}) {
    const castRouterInstance = router;
    const browserTracingIntegrationInstance = (0, $7b5f2a588355dc11$export$b4109253475213e9)({
        ...options,
        instrumentNavigation: false,
        instrumentPageLoad: false
    });
    const { instrumentPageLoad: instrumentPageLoad = true, instrumentNavigation: instrumentNavigation = true } = options;
    return {
        ...browserTracingIntegrationInstance,
        afterAllSetup (client) {
            browserTracingIntegrationInstance.afterAllSetup(client);
            const initialWindowLocation = (0, $e62dec891f31852b$export$56d8a8a25bd48b81).location;
            if (instrumentPageLoad && initialWindowLocation) {
                const matchedRoutes = castRouterInstance.matchRoutes(initialWindowLocation.pathname, castRouterInstance.options.parseSearch(initialWindowLocation.search), {
                    preload: false,
                    throwOnError: false
                });
                const lastMatch = matchedRoutes[matchedRoutes.length - 1];
                // If we only match __root__, we ended up not matching any route at all, so
                // we fall back to the pathname.
                const routeMatch = lastMatch?.routeId !== '__root__' ? lastMatch : undefined;
                (0, $7b5f2a588355dc11$export$aa44a07f82af519f)(client, {
                    name: routeMatch ? routeMatch.routeId : initialWindowLocation.pathname,
                    attributes: {
                        [(0, $f337c80285f06f80$export$1a413bd9a88fdb09)]: 'pageload',
                        [(0, $f337c80285f06f80$export$cca8dd30f57f805e)]: 'auto.pageload.react.tanstack_router',
                        [(0, $f337c80285f06f80$export$d7a7d984b0791405)]: routeMatch ? 'route' : 'url',
                        ...$9351852664295212$var$routeMatchToParamSpanAttributes(routeMatch)
                    }
                });
            }
            if (instrumentNavigation) // The onBeforeNavigate hook is called at the very beginning of a navigation and is only called once per navigation, even when the user is redirected
            castRouterInstance.subscribe('onBeforeNavigate', (onBeforeNavigateArgs)=>{
                // onBeforeNavigate is called during pageloads. We can avoid creating navigation spans by:
                // 1. Checking if there's no fromLocation (initial pageload)
                // 2. Comparing the states of the to and from arguments
                if (!onBeforeNavigateArgs.fromLocation || onBeforeNavigateArgs.toLocation.state === onBeforeNavigateArgs.fromLocation.state) return;
                const matchedRoutesOnBeforeNavigate = castRouterInstance.matchRoutes(onBeforeNavigateArgs.toLocation.pathname, onBeforeNavigateArgs.toLocation.search, {
                    preload: false,
                    throwOnError: false
                });
                const onBeforeNavigateLastMatch = matchedRoutesOnBeforeNavigate[matchedRoutesOnBeforeNavigate.length - 1];
                const onBeforeNavigateRouteMatch = onBeforeNavigateLastMatch?.routeId !== '__root__' ? onBeforeNavigateLastMatch : undefined;
                const navigationLocation = (0, $e62dec891f31852b$export$56d8a8a25bd48b81).location;
                const navigationSpan = (0, $7b5f2a588355dc11$export$7d159749bd9969ad)(client, {
                    name: onBeforeNavigateRouteMatch ? onBeforeNavigateRouteMatch.routeId : navigationLocation.pathname,
                    attributes: {
                        [(0, $f337c80285f06f80$export$1a413bd9a88fdb09)]: 'navigation',
                        [(0, $f337c80285f06f80$export$cca8dd30f57f805e)]: 'auto.navigation.react.tanstack_router',
                        [(0, $f337c80285f06f80$export$d7a7d984b0791405)]: onBeforeNavigateRouteMatch ? 'route' : 'url'
                    }
                });
                // In case the user is redirected during navigation we want to update the span with the right value.
                const unsubscribeOnResolved = castRouterInstance.subscribe('onResolved', (onResolvedArgs)=>{
                    unsubscribeOnResolved();
                    if (navigationSpan) {
                        const matchedRoutesOnResolved = castRouterInstance.matchRoutes(onResolvedArgs.toLocation.pathname, onResolvedArgs.toLocation.search, {
                            preload: false,
                            throwOnError: false
                        });
                        const onResolvedLastMatch = matchedRoutesOnResolved[matchedRoutesOnResolved.length - 1];
                        const onResolvedRouteMatch = onResolvedLastMatch?.routeId !== '__root__' ? onResolvedLastMatch : undefined;
                        if (onResolvedRouteMatch) {
                            navigationSpan.updateName(onResolvedRouteMatch.routeId);
                            navigationSpan.setAttribute((0, $f337c80285f06f80$export$d7a7d984b0791405), 'route');
                            navigationSpan.setAttributes($9351852664295212$var$routeMatchToParamSpanAttributes(onResolvedRouteMatch));
                        }
                    }
                });
            });
        }
    };
}
function $9351852664295212$var$routeMatchToParamSpanAttributes(match) {
    if (!match) return {};
    const paramAttributes = {};
    Object.entries(match.params).forEach(([key, value])=>{
        paramAttributes[`url.path.params.${key}`] = value; // TODO(v11): remove attribute which does not adhere to Sentry's semantic convention
        paramAttributes[`url.path.parameter.${key}`] = value;
        paramAttributes[`params.${key}`] = value; // params.[key] is an alias
    });
    return paramAttributes;
}





var $5FkrB = parcelRequire("5FkrB");

// We need to disable eslint no-explicit-any because any is required for the
// react-router typings.
/**
 * A browser tracing integration that uses React Router v4 to instrument navigations.
 * Expects `history` (and optionally `routes` and `matchPath`) to be passed as options.
 */ function $19a7bc5e65e39b8b$export$474cac1fc5ec6ff8(options) {
    const integration = (0, $7b5f2a588355dc11$export$b4109253475213e9)({
        ...options,
        instrumentPageLoad: false,
        instrumentNavigation: false
    });
    const { history: history, routes: routes, matchPath: matchPath, instrumentPageLoad: instrumentPageLoad = true, instrumentNavigation: instrumentNavigation = true } = options;
    return {
        ...integration,
        afterAllSetup (client) {
            integration.afterAllSetup(client);
            $19a7bc5e65e39b8b$var$instrumentReactRouter(client, instrumentPageLoad, instrumentNavigation, history, 'reactrouter_v4', routes, matchPath);
        }
    };
}
/**
 * A browser tracing integration that uses React Router v5 to instrument navigations.
 * Expects `history` (and optionally `routes` and `matchPath`) to be passed as options.
 */ function $19a7bc5e65e39b8b$export$1c913d0c067ca14f(options) {
    const integration = (0, $7b5f2a588355dc11$export$b4109253475213e9)({
        ...options,
        instrumentPageLoad: false,
        instrumentNavigation: false
    });
    const { history: history, routes: routes, matchPath: matchPath, instrumentPageLoad: instrumentPageLoad = true, instrumentNavigation: instrumentNavigation = true } = options;
    return {
        ...integration,
        afterAllSetup (client) {
            integration.afterAllSetup(client);
            $19a7bc5e65e39b8b$var$instrumentReactRouter(client, instrumentPageLoad, instrumentNavigation, history, 'reactrouter_v5', routes, matchPath);
        }
    };
}
function $19a7bc5e65e39b8b$var$instrumentReactRouter(client, instrumentPageLoad, instrumentNavigation, history, instrumentationName, allRoutes = [], matchPath) {
    function getInitPathName() {
        if (history.location) return history.location.pathname;
        if ((0, $e62dec891f31852b$export$56d8a8a25bd48b81).location) return (0, $e62dec891f31852b$export$56d8a8a25bd48b81).location.pathname;
        return undefined;
    }
    /**
   * Normalizes a transaction name. Returns the new name as well as the
   * source of the transaction.
   *
   * @param pathname The initial pathname we normalize
   */ function normalizeTransactionName(pathname) {
        if (allRoutes.length === 0 || !matchPath) return [
            pathname,
            'url'
        ];
        const branches = $19a7bc5e65e39b8b$var$matchRoutes(allRoutes, pathname, matchPath);
        for (const branch of branches){
            if (branch.match.isExact) return [
                branch.match.path,
                'route'
            ];
        }
        return [
            pathname,
            'url'
        ];
    }
    if (instrumentPageLoad) {
        const initPathName = getInitPathName();
        if (initPathName) {
            const [name, source] = normalizeTransactionName(initPathName);
            (0, $7b5f2a588355dc11$export$aa44a07f82af519f)(client, {
                name: name,
                attributes: {
                    [(0, $f337c80285f06f80$export$1a413bd9a88fdb09)]: 'pageload',
                    [(0, $f337c80285f06f80$export$cca8dd30f57f805e)]: `auto.pageload.react.${instrumentationName}`,
                    [(0, $f337c80285f06f80$export$d7a7d984b0791405)]: source
                }
            });
        }
    }
    if (instrumentNavigation && history.listen) history.listen((location, action)=>{
        if (action && (action === 'PUSH' || action === 'POP')) {
            const [name, source] = normalizeTransactionName(location.pathname);
            (0, $7b5f2a588355dc11$export$7d159749bd9969ad)(client, {
                name: name,
                attributes: {
                    [(0, $f337c80285f06f80$export$1a413bd9a88fdb09)]: 'navigation',
                    [(0, $f337c80285f06f80$export$cca8dd30f57f805e)]: `auto.navigation.react.${instrumentationName}`,
                    [(0, $f337c80285f06f80$export$d7a7d984b0791405)]: source
                }
            });
        }
    });
}
/**
 * Matches a set of routes to a pathname
 * Based on implementation from
 */ function $19a7bc5e65e39b8b$var$matchRoutes(routes, pathname, matchPath, branch = []) {
    routes.some((route)=>{
        const match = route.path ? matchPath(pathname, route) : branch.length ? branch[branch.length - 1].match // use parent match
         : $19a7bc5e65e39b8b$var$computeRootMatch(pathname); // use default "root" match
        if (match) {
            branch.push({
                route: route,
                match: match
            });
            if (route.routes) $19a7bc5e65e39b8b$var$matchRoutes(route.routes, pathname, matchPath, branch);
        }
        return !!match;
    });
    return branch;
}
function $19a7bc5e65e39b8b$var$computeRootMatch(pathname) {
    return {
        path: '/',
        url: '/',
        params: {},
        isExact: pathname === '/'
    };
}
/* eslint-disable @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-member-access */ function $19a7bc5e65e39b8b$export$51a414dfd89dd222(Route) {
    const componentDisplayName = Route.displayName || Route.name;
    const WrappedRoute = (props)=>{
        if (props?.computedMatch?.isExact) {
            const route = props.computedMatch.path;
            const activeRootSpan = $19a7bc5e65e39b8b$var$getActiveRootSpan();
            (0, $7d48e1ed9f699a01$export$c7be4b0125a10cba)().setTransactionName(route);
            if (activeRootSpan) {
                activeRootSpan.updateName(route);
                activeRootSpan.setAttribute((0, $f337c80285f06f80$export$d7a7d984b0791405), 'route');
            }
        }
        // @ts-expect-error Setting more specific React Component typing for `R` generic above
        // will break advanced type inference done by react router params:
        // https://github.com/DefinitelyTyped/DefinitelyTyped/blob/13dc4235c069e25fe7ee16e11f529d909f9f3ff8/types/react-router/index.d.ts#L154-L164
        return $5FkrB.createElement(Route, {
            ...props
        });
    };
    WrappedRoute.displayName = `sentryRoute(${componentDisplayName})`;
    (0, $2015f24f5be0bafb$export$6c1f0397687d8b2)(WrappedRoute, Route);
    // @ts-expect-error Setting more specific React Component typing for `R` generic above
    // will break advanced type inference done by react router params:
    // https://github.com/DefinitelyTyped/DefinitelyTyped/blob/13dc4235c069e25fe7ee16e11f529d909f9f3ff8/types/react-router/index.d.ts#L154-L164
    return WrappedRoute;
}
/* eslint-enable @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-member-access */ function $19a7bc5e65e39b8b$var$getActiveRootSpan() {
    const span = (0, $bb9b6447bf4caedb$export$1be426a8e585c83e)();
    const rootSpan = span && (0, $bb9b6447bf4caedb$export$c4c6a79b1260ca1b)(span);
    if (!rootSpan) return undefined;
    const op = (0, $bb9b6447bf4caedb$export$92d8c23565496537)(rootSpan).op;
    // Only use this root span if it is a pageload or navigation span
    return op === 'navigation' || op === 'pageload' ? rootSpan : undefined;
}





var $5FkrB = parcelRequire("5FkrB");









/**
 * Strip the basename from a pathname if exists.
 *
 * Vendored and modified from `react-router`
 * https://github.com/remix-run/react-router/blob/462bb712156a3f739d6139a0f14810b76b002df6/packages/router/utils.ts#L1038
 */ function $875b239877162636$export$7d73ab767c2c99ca(pathname, basename) {
    if (!basename || basename === '/') return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return pathname;
    // We want to leave trailing slash behavior in the user's control, so if they
    // specify a basename with a trailing slash, we should support it
    const startIndex = basename.endsWith('/') ? basename.length - 1 : basename.length;
    const nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== '/') // pathname does not start with basename/
    return pathname;
    return pathname.slice(startIndex) || '/';
}
// Cache for sorted manifests - keyed by manifest array reference
const $875b239877162636$var$SORTED_MANIFEST_CACHE = new WeakMap();
/**
 * Matches a pathname against a route manifest and returns the matching pattern.
 * Optionally strips a basename prefix before matching.
 */ function $875b239877162636$export$b350ee9894336a9c(pathname, manifest, basename) {
    if (!pathname || !manifest?.length) return null;
    const normalizedPathname = basename ? $875b239877162636$export$7d73ab767c2c99ca(pathname, basename) : pathname;
    let sorted = $875b239877162636$var$SORTED_MANIFEST_CACHE.get(manifest);
    if (!sorted) {
        sorted = $875b239877162636$var$sortBySpecificity(manifest);
        $875b239877162636$var$SORTED_MANIFEST_CACHE.set(manifest, sorted);
        (0, $0ee57f62053fbbae$export$16a28057038b10ef) && (0, $d11ed0b3cdda6b8d$export$1c9f709888824e05).log('[React Router] Sorted route manifest by specificity:', sorted.length, 'patterns');
    }
    for (const pattern of sorted)if ($875b239877162636$var$matchesPattern(normalizedPathname, pattern)) {
        (0, $0ee57f62053fbbae$export$16a28057038b10ef) && (0, $d11ed0b3cdda6b8d$export$1c9f709888824e05).log('[React Router] Matched pathname', normalizedPathname, 'to pattern', pattern);
        return pattern;
    }
    (0, $0ee57f62053fbbae$export$16a28057038b10ef) && (0, $d11ed0b3cdda6b8d$export$1c9f709888824e05).log('[React Router] No manifest match found for pathname:', normalizedPathname);
    return null;
}
/**
 * Checks if a pathname matches a route pattern.
 */ function $875b239877162636$var$matchesPattern(pathname, pattern) {
    // Handle root path special case
    if (pattern === '/') return pathname === '/' || pathname === '';
    const pathSegments = $875b239877162636$var$splitPath(pathname);
    const patternSegments = $875b239877162636$var$splitPath(pattern);
    // Handle wildcard at end
    const hasWildcard = patternSegments.length > 0 && patternSegments[patternSegments.length - 1] === '*';
    if (hasWildcard) {
        // Pattern with wildcard: path must have at least as many segments as pattern (minus wildcard)
        const patternSegmentsWithoutWildcard = patternSegments.slice(0, -1);
        if (pathSegments.length < patternSegmentsWithoutWildcard.length) return false;
        for (const [i, patternSegment] of patternSegmentsWithoutWildcard.entries()){
            if (!$875b239877162636$var$segmentMatches(pathSegments[i], patternSegment)) return false;
        }
        return true;
    }
    // Exact segment count match required
    if (pathSegments.length !== patternSegments.length) return false;
    for (const [i, patternSegment] of patternSegments.entries()){
        if (!$875b239877162636$var$segmentMatches(pathSegments[i], patternSegment)) return false;
    }
    return true;
}
/**
 * Checks if a path segment matches a pattern segment.
 */ function $875b239877162636$var$segmentMatches(pathSegment, patternSegment) {
    if (pathSegment === undefined || patternSegment === undefined) return false;
    // Parameter matches anything
    if ($875b239877162636$var$PARAM_RE.test(patternSegment)) return true;
    // Literal must match exactly
    return pathSegment === patternSegment;
}
/**
 * Splits a path into segments, filtering out empty strings.
 */ function $875b239877162636$var$splitPath(path) {
    return path.split('/').filter(Boolean);
}
/**
 * React Router scoring weights and param detection.
 * https://github.com/remix-run/react-router/blob/main/packages/react-router/lib/router/utils.ts
 */ const $875b239877162636$var$PARAM_RE = /^:[\w-]+$/;
const $875b239877162636$var$STATIC_SEGMENT_SCORE = 10;
const $875b239877162636$var$DYNAMIC_SEGMENT_SCORE = 3;
const $875b239877162636$var$EMPTY_SEGMENT_SCORE = 1;
const $875b239877162636$var$SPLAT_PENALTY = -2;
/**
 * Computes a specificity score for a route pattern.
 * Matches React Router's computeScore() algorithm exactly.
 */ function $875b239877162636$var$computeScore(pattern) {
    const segments = pattern.split('/');
    // Base score is segment count (including empty segment from leading slash)
    let score = segments.length;
    // Apply splat penalty once if pattern contains wildcard
    if (segments.includes('*')) score += $875b239877162636$var$SPLAT_PENALTY;
    for (const segment of segments){
        if (segment === '*') continue;
        else if ($875b239877162636$var$PARAM_RE.test(segment)) score += $875b239877162636$var$DYNAMIC_SEGMENT_SCORE;
        else if (segment === '') score += $875b239877162636$var$EMPTY_SEGMENT_SCORE;
        else score += $875b239877162636$var$STATIC_SEGMENT_SCORE;
    }
    return score;
}
/**
 * Sorts route patterns by specificity (most specific first).
 * Implements React Router's ranking algorithm from computeScore():
 * https://github.com/remix-run/react-router/blob/main/packages/react-router/lib/router/utils.ts
 *
 * React Router scoring: base=segments.length, static=+10, dynamic=+3, empty=+1, splat=-2 (once)
 * Higher score = more specific pattern.
 * Equal scores preserve manifest order (same as React Router).
 *
 * Note: Users should order their manifest from most specific to least specific
 * when patterns have equal specificity (e.g., `/users/:id/settings` and `/:type/123/settings`).
 */ function $875b239877162636$var$sortBySpecificity(manifest) {
    return [
        ...manifest
    ].sort((a, b)=>{
        const aScore = $875b239877162636$var$computeScore(a);
        const bScore = $875b239877162636$var$computeScore(b);
        return bScore - aScore;
    });
}


// Global variables that these utilities depend on
let $4487fbe2e1371231$var$_matchRoutes;
let $4487fbe2e1371231$var$_stripBasename = false;
// Navigation context stack for nested/concurrent patchRoutesOnNavigation calls.
// Required because window.location hasn't updated yet when handlers are invoked.
const $4487fbe2e1371231$var$_navigationContextStack = [];
const $4487fbe2e1371231$var$MAX_CONTEXT_STACK_SIZE = 10;
/**
 * Pushes a navigation context and returns a unique token for cleanup.
 * The token uses object identity for uniqueness (no counter needed).
 */ function $4487fbe2e1371231$export$49f239a397357a7c(targetPath, span) {
    const token = {};
    // Prevent unbounded stack growth - oldest (likely stale) contexts are evicted first
    if ($4487fbe2e1371231$var$_navigationContextStack.length >= $4487fbe2e1371231$var$MAX_CONTEXT_STACK_SIZE) {
        (0, $0ee57f62053fbbae$export$16a28057038b10ef) && (0, $d11ed0b3cdda6b8d$export$1c9f709888824e05).warn('[React Router] Navigation context stack overflow - removing oldest context');
        $4487fbe2e1371231$var$_navigationContextStack.shift();
    }
    $4487fbe2e1371231$var$_navigationContextStack.push({
        token: token,
        targetPath: targetPath,
        span: span
    });
    return token;
}
/**
 * Clears the navigation context if it's on top of the stack (LIFO).
 * If our context is not on top (out-of-order completion), we leave it -
 * it will be cleaned up by overflow protection when the stack fills up.
 */ function $4487fbe2e1371231$export$44ec4f5e487fad8c(token) {
    const top = $4487fbe2e1371231$var$_navigationContextStack[$4487fbe2e1371231$var$_navigationContextStack.length - 1];
    if (top?.token === token) $4487fbe2e1371231$var$_navigationContextStack.pop();
}
/** Gets the current (most recent) navigation context if inside a patchRoutesOnNavigation call. */ function $4487fbe2e1371231$export$c51ee4fdd2c5321d() {
    const length = $4487fbe2e1371231$var$_navigationContextStack.length;
    // The `?? null` converts undefined (from array access) to null to match return type
    return length > 0 ? $4487fbe2e1371231$var$_navigationContextStack[length - 1] ?? null : null;
}
/**
 * Initialize function to set dependencies that the router utilities need.
 * Must be called before using any of the exported utility functions.
 */ function $4487fbe2e1371231$export$d5deab901a3788fa(matchRoutes, stripBasename = false) {
    $4487fbe2e1371231$var$_matchRoutes = matchRoutes;
    $4487fbe2e1371231$var$_stripBasename = stripBasename;
}
// Helper functions
function $4487fbe2e1371231$var$pickPath(match) {
    return $4487fbe2e1371231$var$trimWildcard(match.route.path || '');
}
function $4487fbe2e1371231$var$pickSplat(match) {
    return match.params['*'] || '';
}
function $4487fbe2e1371231$var$trimWildcard(path) {
    return path[path.length - 1] === '*' ? path.slice(0, -1) : path;
}
function $4487fbe2e1371231$var$trimSlash(path) {
    return path[path.length - 1] === '/' ? path.slice(0, -1) : path;
}
/**
 * Checks if a path ends with a wildcard character (*).
 */ function $4487fbe2e1371231$export$3112bc7a3fd7a30f(path) {
    return path.endsWith('*');
}
/** Checks if transaction name has wildcard (/* or ends with *). */ function $4487fbe2e1371231$export$73bbd8f1d410fc7c(name) {
    return name.includes('/*') || name.endsWith('*');
}
/**
 * Checks if a path is a wildcard and has child routes.
 */ function $4487fbe2e1371231$export$e45475f5937f105e(path, branch) {
    return $4487fbe2e1371231$export$3112bc7a3fd7a30f(path) && !!branch.route.children?.length || false;
}
/** Check if route is in descendant route (<Routes> within <Routes>) */ function $4487fbe2e1371231$export$2d13d7df6cdaeba4(route) {
    return !!(!route.children && route.element && route.path?.endsWith('/*'));
}
function $4487fbe2e1371231$var$sendIndexPath(pathBuilder, pathname, basename) {
    const reconstructedPath = pathBuilder && pathBuilder.length > 0 ? pathBuilder : $4487fbe2e1371231$var$_stripBasename ? (0, $875b239877162636$export$7d73ab767c2c99ca)(pathname, basename) : pathname;
    let formattedPath = // If the path ends with a wildcard suffix, remove both the slash and the asterisk
    reconstructedPath.slice(-2) === '/*' ? reconstructedPath.slice(0, -2) : reconstructedPath;
    // If the path ends with a slash, remove it (but keep single '/')
    if (formattedPath.length > 1 && formattedPath[formattedPath.length - 1] === '/') formattedPath = formattedPath.slice(0, -1);
    return [
        formattedPath,
        'route'
    ];
}
/**
 * Returns the number of URL segments in the given URL string.
 * Splits at '/' or '\/' to handle regex URLs correctly.
 *
 * @param url - The URL string to segment.
 * @returns The number of segments in the URL.
 */ function $4487fbe2e1371231$export$69dd85280a8d374c(url) {
    // split at '/' or at '\/' to split regex urls correctly
    return url.split(/\\?\//).filter((s)=>s.length > 0 && s !== ',').length;
}
// Exported utility functions
/**
 * Ensures a path string starts with a forward slash.
 */ function $4487fbe2e1371231$export$dbbc39b1314b6a40(path) {
    return path[0] === '/' ? path : `/${path}`;
}
/**
 * Rebuilds the route path from all available routes by matching against the current location.
 */ function $4487fbe2e1371231$export$c1f7ff5899bfbd37(allRoutes, location) {
    const matchedRoutes = $4487fbe2e1371231$var$_matchRoutes(allRoutes, location);
    if (!matchedRoutes || matchedRoutes.length === 0) return '';
    for (const match of matchedRoutes)if (match.route.path && match.route.path !== '*') {
        const path = $4487fbe2e1371231$var$pickPath(match);
        const strippedPath = (0, $875b239877162636$export$7d73ab767c2c99ca)(location.pathname, $4487fbe2e1371231$export$dbbc39b1314b6a40(match.pathnameBase));
        if (location.pathname === strippedPath) return $4487fbe2e1371231$var$trimSlash(strippedPath);
        return $4487fbe2e1371231$var$trimSlash($4487fbe2e1371231$var$trimSlash(path || '') + $4487fbe2e1371231$export$dbbc39b1314b6a40($4487fbe2e1371231$export$c1f7ff5899bfbd37(allRoutes.filter((route)=>route !== match.route), {
            pathname: strippedPath
        })));
    }
    return '';
}
/**
 * Checks if the current location is inside a descendant route (route with splat parameter).
 */ function $4487fbe2e1371231$export$35be733d25e64e5a(location, routes) {
    const matchedRoutes = $4487fbe2e1371231$var$_matchRoutes(routes, location);
    if (matchedRoutes) for (const match of matchedRoutes){
        if ($4487fbe2e1371231$export$2d13d7df6cdaeba4(match.route) && $4487fbe2e1371231$var$pickSplat(match)) return true;
    }
    return false;
}
/**
 * Returns a fallback transaction name from location pathname.
 */ function $4487fbe2e1371231$var$getFallbackTransactionName(location, basename) {
    return $4487fbe2e1371231$var$_stripBasename ? (0, $875b239877162636$export$7d73ab767c2c99ca)(location.pathname, basename) : location.pathname || '';
}
/**
 * Gets a normalized route name and transaction source from the current routes and location.
 */ function $4487fbe2e1371231$export$b75af9192fcde169(routes, location, branches, basename = '') {
    if (!routes || routes.length === 0) return [
        $4487fbe2e1371231$var$_stripBasename ? (0, $875b239877162636$export$7d73ab767c2c99ca)(location.pathname, basename) : location.pathname,
        'url'
    ];
    if (!branches) return [
        $4487fbe2e1371231$var$getFallbackTransactionName(location, basename),
        'url'
    ];
    let pathBuilder = '';
    for (const branch of branches){
        const route = branch.route;
        if (!route) continue;
        // Early return for index routes
        if (route.index) return $4487fbe2e1371231$var$sendIndexPath(pathBuilder, branch.pathname, basename);
        const path = route.path;
        if (!path || $4487fbe2e1371231$export$e45475f5937f105e(path, branch)) continue;
        // Build the route path
        const newPath = path[0] === '/' || pathBuilder[pathBuilder.length - 1] === '/' ? path : `/${path}`;
        pathBuilder = $4487fbe2e1371231$var$trimSlash(pathBuilder) + $4487fbe2e1371231$export$dbbc39b1314b6a40(newPath);
        // Check if this path matches the current location
        if ($4487fbe2e1371231$var$trimSlash(location.pathname) !== $4487fbe2e1371231$var$trimSlash(basename + branch.pathname)) continue;
        // Check if this is a parameterized route like /stores/:storeId/products/:productId
        if ($4487fbe2e1371231$export$69dd85280a8d374c(pathBuilder) !== $4487fbe2e1371231$export$69dd85280a8d374c(branch.pathname) && !$4487fbe2e1371231$export$3112bc7a3fd7a30f(pathBuilder)) return [
            ($4487fbe2e1371231$var$_stripBasename ? '' : basename) + newPath,
            'route'
        ];
        // Handle wildcard routes with children - strip trailing wildcard
        if ($4487fbe2e1371231$export$e45475f5937f105e(pathBuilder, branch)) pathBuilder = pathBuilder.slice(0, -1);
        return [
            ($4487fbe2e1371231$var$_stripBasename ? '' : basename) + pathBuilder,
            'route'
        ];
    }
    // Fallback when no matching route found
    return [
        $4487fbe2e1371231$var$getFallbackTransactionName(location, basename),
        'url'
    ];
}
/**
 * Shared helper function to resolve route name and source
 */ function $4487fbe2e1371231$export$d0d5aab0e629ad63(location, routes, allRoutes, branches, basename = '', lazyRouteManifest, enableAsyncRouteHandlers) {
    // When lazy route manifest is provided, use it as the primary source for transaction names
    if (enableAsyncRouteHandlers && lazyRouteManifest && lazyRouteManifest.length > 0) {
        const manifestMatch = (0, $875b239877162636$export$b350ee9894336a9c)(location.pathname, lazyRouteManifest, basename);
        if (manifestMatch) return [
            ($4487fbe2e1371231$var$_stripBasename ? '' : basename) + manifestMatch,
            'route'
        ];
    }
    // Fall back to React Router route matching
    let name;
    let source = 'url';
    const isInDescendantRoute = $4487fbe2e1371231$export$35be733d25e64e5a(location, allRoutes);
    if (isInDescendantRoute) {
        name = $4487fbe2e1371231$export$dbbc39b1314b6a40($4487fbe2e1371231$export$c1f7ff5899bfbd37(allRoutes, location));
        source = 'route';
    }
    if (!isInDescendantRoute || !name) [name, source] = $4487fbe2e1371231$export$b75af9192fcde169(routes, location, branches, basename);
    return [
        name || location.pathname,
        source
    ];
}
/**
 * Gets the active root span if it's a pageload or navigation span.
 */ function $4487fbe2e1371231$export$6d46479e35ff5f30() {
    const span = (0, $bb9b6447bf4caedb$export$1be426a8e585c83e)();
    const rootSpan = span ? (0, $bb9b6447bf4caedb$export$c4c6a79b1260ca1b)(span) : undefined;
    if (!rootSpan) return undefined;
    const op = (0, $bb9b6447bf4caedb$export$92d8c23565496537)(rootSpan).op;
    // Only use this root span if it is a pageload or navigation span
    return op === 'navigation' || op === 'pageload' ? rootSpan : undefined;
}


/**
 * Captures location at invocation time. Prefers navigation context over window.location
 * since window.location hasn't updated yet when async handlers are invoked.
 *
 * When inside a patchRoutesOnNavigation call, uses the captured targetPath. If targetPath
 * is undefined (patchRoutesOnNavigation can be invoked without a path argument), returns
 * null rather than falling back to WINDOW.location which could be stale/wrong after the
 * user navigated away during async loading. Returning null causes the span name update
 * to be skipped, which is safer than using incorrect location data.
 */ function $eb2165c92b8d4b57$var$captureCurrentLocation() {
    const navContext = (0, $4487fbe2e1371231$export$c51ee4fdd2c5321d)();
    if (navContext) {
        if (navContext.targetPath) return {
            pathname: navContext.targetPath,
            search: '',
            hash: '',
            state: null,
            key: 'default'
        };
        // Don't fall back to potentially stale WINDOW.location
        return null;
    }
    if (typeof (0, $e62dec891f31852b$export$56d8a8a25bd48b81) !== 'undefined') try {
        const windowLocation = (0, $e62dec891f31852b$export$56d8a8a25bd48b81).location;
        if (windowLocation) return {
            pathname: windowLocation.pathname,
            search: windowLocation.search || '',
            hash: windowLocation.hash || '',
            state: null,
            key: 'default'
        };
    } catch  {
        (0, $0ee57f62053fbbae$export$16a28057038b10ef) && (0, $d11ed0b3cdda6b8d$export$1c9f709888824e05).warn('[React Router] Could not access window.location');
    }
    return null;
}
/**
 * Captures the active span at invocation time. Prefers navigation context span
 * to ensure we update the correct span even if another navigation starts.
 */ function $eb2165c92b8d4b57$var$captureActiveSpan() {
    const navContext = (0, $4487fbe2e1371231$export$c51ee4fdd2c5321d)();
    if (navContext) return navContext.span;
    return (0, $4487fbe2e1371231$export$6d46479e35ff5f30)();
}
/**
 * Creates a proxy wrapper for an async handler function.
 * Captures both the location and the active span at invocation time to ensure
 * the correct span is updated when the handler resolves.
 */ function $eb2165c92b8d4b57$export$ae31fcaba1cddbd8(originalFunction, route, handlerKey, processResolvedRoutes) {
    const proxy = new Proxy(originalFunction, {
        apply (target, thisArg, argArray) {
            const locationAtInvocation = $eb2165c92b8d4b57$var$captureCurrentLocation();
            const spanAtInvocation = $eb2165c92b8d4b57$var$captureActiveSpan();
            const result = target.apply(thisArg, argArray);
            $eb2165c92b8d4b57$export$182dc63b40030b75(result, route, handlerKey, processResolvedRoutes, locationAtInvocation, spanAtInvocation);
            return result;
        }
    });
    (0, $269eeb69635ed414$export$e73679ffaf56810e)(proxy, '__sentry_proxied__', true);
    return proxy;
}
/**
 * Handles the result of an async handler function call.
 * Passes the captured span through to ensure the correct span is updated.
 */ function $eb2165c92b8d4b57$export$182dc63b40030b75(result, route, handlerKey, processResolvedRoutes, currentLocation, capturedSpan) {
    if ((0, $13cf2ed412f405fa$export$f5b060c2914b97c8)(result)) result.then((resolvedRoutes)=>{
        if (Array.isArray(resolvedRoutes)) processResolvedRoutes(resolvedRoutes, route, currentLocation ?? undefined, capturedSpan);
    }).catch((e)=>{
        (0, $0ee57f62053fbbae$export$16a28057038b10ef) && (0, $d11ed0b3cdda6b8d$export$1c9f709888824e05).warn(`Error resolving async handler '${handlerKey}' for route`, route, e);
    });
    else if (Array.isArray(result)) processResolvedRoutes(result, route, currentLocation ?? undefined, capturedSpan);
}
/**
 * Recursively checks a route for async handlers and sets up Proxies to add discovered child routes to allRoutes when called.
 */ function $eb2165c92b8d4b57$export$e9262e29e117b830(route, processResolvedRoutes) {
    // Set up proxies for any functions in the route's handle
    if (route.handle && typeof route.handle === 'object') for (const key of Object.keys(route.handle)){
        const maybeFn = route.handle[key];
        if (typeof maybeFn === 'function' && !maybeFn.__sentry_proxied__) route.handle[key] = $eb2165c92b8d4b57$export$ae31fcaba1cddbd8(maybeFn, route, key, processResolvedRoutes);
    }
    // Recursively check child routes
    if (Array.isArray(route.children)) for (const child of route.children)$eb2165c92b8d4b57$export$e9262e29e117b830(child, processResolvedRoutes);
}



/* eslint-disable max-lines */ // Inspired from Donnie McNeal's solution:
// https://gist.github.com/wontondon/e8c4bdf2888875e4c755712e99279536
let $8097daeff2c3b7c8$var$_useEffect;
let $8097daeff2c3b7c8$var$_useLocation;
let $8097daeff2c3b7c8$var$_useNavigationType;
let $8097daeff2c3b7c8$var$_createRoutesFromChildren;
let $8097daeff2c3b7c8$var$_matchRoutes;
let $8097daeff2c3b7c8$var$_enableAsyncRouteHandlers = false;
let $8097daeff2c3b7c8$var$_lazyRouteTimeout = 3000;
let $8097daeff2c3b7c8$var$_lazyRouteManifest;
let $8097daeff2c3b7c8$var$_basename = '';
const $8097daeff2c3b7c8$var$CLIENTS_WITH_INSTRUMENT_NAVIGATION = new WeakSet();
// Prevents duplicate spans when router.subscribe fires multiple times
const $8097daeff2c3b7c8$var$activeNavigationSpans = new WeakMap();
// Exported for testing only
const $8097daeff2c3b7c8$export$3ef6d4da8160fa32 = new Set();
// Tracks lazy route loads to wait before finalizing span names
const $8097daeff2c3b7c8$var$pendingLazyRouteLoads = new WeakMap();
// Tracks deferred lazy route promises that can be resolved when patchRoutesOnNavigation is called
const $8097daeff2c3b7c8$var$deferredLazyRouteResolvers = new WeakMap();
/**
 * Schedules a callback using requestAnimationFrame when available (browser),
 * or falls back to setTimeout for SSR environments (Node.js, createMemoryRouter tests).
 */ function $8097daeff2c3b7c8$var$scheduleCallback(callback) {
    if ((0, $e62dec891f31852b$export$56d8a8a25bd48b81)?.requestAnimationFrame) return (0, $e62dec891f31852b$export$56d8a8a25bd48b81).requestAnimationFrame(callback);
    return setTimeout(callback, 0);
}
/**
 * Cancels a scheduled callback, handling both RAF (browser) and timeout (SSR) IDs.
 */ function $8097daeff2c3b7c8$var$cancelScheduledCallback(id) {
    if ((0, $e62dec891f31852b$export$56d8a8a25bd48b81)?.cancelAnimationFrame) (0, $e62dec891f31852b$export$56d8a8a25bd48b81).cancelAnimationFrame(id);
    else clearTimeout(id);
}
/**
 * Computes location key for duplicate detection. Normalizes undefined/null to empty strings.
 * Exported for testing.
 */ function $8097daeff2c3b7c8$export$6da138630728824c(location) {
    return `${location.pathname}${location.search || ''}${location.hash || ''}`;
}
/**
 * Checks if a route name is parameterized (contains route parameters like :id or wildcards like *)
 * vs a raw URL path.
 */ function $8097daeff2c3b7c8$var$isParameterizedRoute(routeName) {
    return routeName.includes(':') || routeName.includes('*');
}
/**
 * Determines if a navigation should be skipped as a duplicate, and if an existing span should be updated.
 * Exported for testing.
 *
 * @returns An object with:
 *   - skip: boolean - Whether to skip creating a new span
 *   - shouldUpdate: boolean - Whether to update the existing span name (wildcard upgrade)
 */ function $8097daeff2c3b7c8$export$74ccc56dfa81ef20(trackedNav, locationKey, proposedName, spanHasEnded) {
    if (!trackedNav) return {
        skip: false,
        shouldUpdate: false
    };
    // Check if this is a duplicate navigation (same location)
    // 1. If it's a placeholder, it's always a duplicate (we're waiting for the real one)
    // 2. If it's a real span, it's a duplicate only if it hasn't ended yet
    const isDuplicate = trackedNav.locationKey === locationKey && (trackedNav.isPlaceholder || !spanHasEnded);
    if (isDuplicate) {
        // Check if we should update the span name with a better route
        // Allow updates if:
        // 1. Current has wildcard and new doesn't (wildcard → parameterized upgrade)
        // 2. Current is raw path and new is parameterized (raw → parameterized upgrade)
        // 3. New name is different and more specific (longer, indicating nested routes resolved)
        const currentHasWildcard = !!trackedNav.routeName && (0, $4487fbe2e1371231$export$73bbd8f1d410fc7c)(trackedNav.routeName);
        const proposedHasWildcard = (0, $4487fbe2e1371231$export$73bbd8f1d410fc7c)(proposedName);
        const currentIsParameterized = !!trackedNav.routeName && $8097daeff2c3b7c8$var$isParameterizedRoute(trackedNav.routeName);
        const proposedIsParameterized = $8097daeff2c3b7c8$var$isParameterizedRoute(proposedName);
        const isWildcardUpgrade = currentHasWildcard && !proposedHasWildcard;
        const isRawToParameterized = !currentIsParameterized && proposedIsParameterized;
        const isMoreSpecific = proposedName !== trackedNav.routeName && proposedName.length > (trackedNav.routeName?.length || 0) && !proposedHasWildcard;
        const shouldUpdate = !!(trackedNav.routeName && (isWildcardUpgrade || isRawToParameterized || isMoreSpecific));
        return {
            skip: true,
            shouldUpdate: shouldUpdate
        };
    }
    return {
        skip: false,
        shouldUpdate: false
    };
}
function $8097daeff2c3b7c8$export$d443af17fae6e7aa(resolvedRoutes, parentRoute) {
    const existingChildren = parentRoute.children || [];
    const newRoutes = resolvedRoutes.filter((newRoute)=>!existingChildren.some((existing)=>existing === newRoute || newRoute.path && existing.path === newRoute.path || newRoute.id && existing.id === newRoute.id));
    if (newRoutes.length > 0) parentRoute.children = [
        ...existingChildren,
        ...newRoutes
    ];
}
/** Registers a pending lazy route load promise for a span. */ function $8097daeff2c3b7c8$var$trackLazyRouteLoad(span, promise) {
    let promises = $8097daeff2c3b7c8$var$pendingLazyRouteLoads.get(span);
    if (!promises) {
        promises = new Set();
        $8097daeff2c3b7c8$var$pendingLazyRouteLoads.set(span, promises);
    }
    promises.add(promise);
    // Clean up when promise resolves/rejects
    // oxlint-disable-next-line typescript/no-floating-promises
    promise.finally(()=>{
        const currentPromises = $8097daeff2c3b7c8$var$pendingLazyRouteLoads.get(span);
        if (currentPromises) currentPromises.delete(promise);
    });
}
/**
 * Creates a deferred promise for a span that will be resolved when patchRoutesOnNavigation is called.
 * This ensures that patchedEnd waits for patchRoutesOnNavigation to be called before ending the span.
 */ function $8097daeff2c3b7c8$var$createDeferredLazyRoutePromise(span) {
    const deferredPromise = new Promise((resolve)=>{
        $8097daeff2c3b7c8$var$deferredLazyRouteResolvers.set(span, resolve);
    });
    $8097daeff2c3b7c8$var$trackLazyRouteLoad(span, deferredPromise);
}
/**
 * Resolves the deferred lazy route promise for a span.
 * Called when patchRoutesOnNavigation is invoked.
 */ function $8097daeff2c3b7c8$var$resolveDeferredLazyRoutePromise(span) {
    const resolver = $8097daeff2c3b7c8$var$deferredLazyRouteResolvers.get(span);
    if (resolver) {
        resolver();
        $8097daeff2c3b7c8$var$deferredLazyRouteResolvers.delete(span);
        // Clear the flag so patchSpanEnd doesn't wait unnecessarily for routes that have already loaded
        if (span.__sentry_may_have_lazy_routes__) span.__sentry_may_have_lazy_routes__ = false;
    }
}
/**
 * Processes resolved routes by adding them to allRoutes and checking for nested async handlers.
 * When capturedSpan is provided, updates that specific span instead of the current active span.
 * This prevents race conditions where a lazy handler resolves after the user has navigated away.
 */ function $8097daeff2c3b7c8$export$b18942cbaf6837a6(resolvedRoutes, parentRoute, currentLocation = null, capturedSpan) {
    resolvedRoutes.forEach((child)=>{
        $8097daeff2c3b7c8$export$3ef6d4da8160fa32.add(child);
        // Only check for async handlers if the feature is enabled
        if ($8097daeff2c3b7c8$var$_enableAsyncRouteHandlers) (0, $eb2165c92b8d4b57$export$e9262e29e117b830)(child, $8097daeff2c3b7c8$export$b18942cbaf6837a6);
    });
    if (parentRoute) // If a parent route is provided, add the resolved routes as children to the parent route
    $8097daeff2c3b7c8$export$d443af17fae6e7aa(resolvedRoutes, parentRoute);
    // Use captured span if provided, otherwise fall back to current active span
    const targetSpan = capturedSpan ?? (0, $4487fbe2e1371231$export$6d46479e35ff5f30)();
    if (targetSpan) {
        const spanJson = (0, $bb9b6447bf4caedb$export$92d8c23565496537)(targetSpan);
        // Skip update if span has already ended (timestamp is set when span.end() is called)
        if (spanJson.timestamp) {
            (0, $0ee57f62053fbbae$export$16a28057038b10ef) && (0, $d11ed0b3cdda6b8d$export$1c9f709888824e05).warn('[React Router] Lazy handler resolved after span ended - skipping update');
            return;
        }
        const spanOp = spanJson.op;
        // Use captured location for route matching (ensures we match against the correct route)
        // Fall back to window.location only if no captured location and no captured span
        // (i.e., this is not from an async handler)
        let location = currentLocation;
        if (!location && !capturedSpan) {
            if (typeof (0, $e62dec891f31852b$export$56d8a8a25bd48b81) !== 'undefined') {
                const globalLocation = (0, $e62dec891f31852b$export$56d8a8a25bd48b81).location;
                if (globalLocation?.pathname) location = {
                    pathname: globalLocation.pathname
                };
            }
        }
        if (location) {
            if (spanOp === 'pageload') // Re-run the pageload transaction update with the newly loaded routes
            $8097daeff2c3b7c8$var$updatePageloadTransaction({
                activeRootSpan: targetSpan,
                location: {
                    pathname: location.pathname
                },
                routes: Array.from($8097daeff2c3b7c8$export$3ef6d4da8160fa32),
                allRoutes: Array.from($8097daeff2c3b7c8$export$3ef6d4da8160fa32)
            });
            else if (spanOp === 'navigation') // For navigation spans, update the name with the newly loaded routes
            $8097daeff2c3b7c8$export$8e00428fd5aa3427(targetSpan, location, Array.from($8097daeff2c3b7c8$export$3ef6d4da8160fa32), false, $8097daeff2c3b7c8$var$_matchRoutes);
        }
    }
}
/**
 * Updates a navigation span with the correct route name after lazy routes have been loaded.
 */ function $8097daeff2c3b7c8$export$8e00428fd5aa3427(activeRootSpan, location, allRoutes, forceUpdate = false, matchRoutes) {
    const spanJson = (0, $bb9b6447bf4caedb$export$92d8c23565496537)(activeRootSpan);
    const currentName = spanJson.description;
    const hasBeenNamed = activeRootSpan?.__sentry_navigation_name_set__;
    const currentNameHasWildcard = currentName && (0, $4487fbe2e1371231$export$73bbd8f1d410fc7c)(currentName);
    const shouldUpdate = !hasBeenNamed || forceUpdate || currentNameHasWildcard;
    if (shouldUpdate && !spanJson.timestamp) {
        const currentBranches = matchRoutes(allRoutes, location);
        const [name, source] = (0, $4487fbe2e1371231$export$d0d5aab0e629ad63)(location, allRoutes, allRoutes, currentBranches || [], $8097daeff2c3b7c8$var$_basename, $8097daeff2c3b7c8$var$_lazyRouteManifest, $8097daeff2c3b7c8$var$_enableAsyncRouteHandlers);
        const currentSource = spanJson.data?.[0, $f337c80285f06f80$export$d7a7d984b0791405];
        const isImprovement = name && (!currentName || // No current name - always set
        !hasBeenNamed && (currentSource !== 'route' || source === 'route') || // Not finalized - allow unless downgrading route→url
        currentSource !== 'route' && source === 'route' || // URL → route upgrade
        currentSource === 'route' && source === 'route' && currentNameHasWildcard); // Route → better route (only if current has wildcard)
        if (isImprovement) {
            activeRootSpan.updateName(name);
            activeRootSpan.setAttribute((0, $f337c80285f06f80$export$d7a7d984b0791405), source);
            // Only mark as finalized for non-wildcard route names (allows URL→route upgrades).
            if (!(0, $4487fbe2e1371231$export$73bbd8f1d410fc7c)(name) && source === 'route') (0, $269eeb69635ed414$export$e73679ffaf56810e)(activeRootSpan, '__sentry_navigation_name_set__', true);
        }
    }
}
function $8097daeff2c3b7c8$var$setupRouterSubscription(router, routes, version, basename, activeRootSpan) {
    let isInitialPageloadComplete = false;
    let hasSeenPageloadSpan = !!activeRootSpan && (0, $bb9b6447bf4caedb$export$92d8c23565496537)(activeRootSpan).op === 'pageload';
    let hasSeenPopAfterPageload = false;
    let scheduledNavigationHandler = null;
    let lastHandledPathname = null;
    router.subscribe((state)=>{
        if (!isInitialPageloadComplete) {
            const currentRootSpan = (0, $4487fbe2e1371231$export$6d46479e35ff5f30)();
            const isCurrentlyInPageload = currentRootSpan && (0, $bb9b6447bf4caedb$export$92d8c23565496537)(currentRootSpan).op === 'pageload';
            if (isCurrentlyInPageload) hasSeenPageloadSpan = true;
            else if (hasSeenPageloadSpan) {
                if (state.historyAction === 'POP' && !hasSeenPopAfterPageload) hasSeenPopAfterPageload = true;
                else isInitialPageloadComplete = true;
            }
        }
        const shouldHandleNavigation = state.historyAction === 'PUSH' || state.historyAction === 'POP' && isInitialPageloadComplete;
        if (shouldHandleNavigation) {
            // Include search and hash to allow query/hash-only navigations
            // Use computeLocationKey() to ensure undefined/null values are normalized to empty strings
            const currentLocationKey = $8097daeff2c3b7c8$export$6da138630728824c(state.location);
            const navigationHandler = ()=>{
                // Prevent multiple calls for the same location within the same navigation cycle
                if (lastHandledPathname === currentLocationKey) return;
                lastHandledPathname = currentLocationKey;
                scheduledNavigationHandler = null;
                $8097daeff2c3b7c8$export$706ad1af8096e280({
                    location: state.location,
                    routes: routes,
                    navigationType: state.historyAction,
                    version: version,
                    basename: basename,
                    allRoutes: Array.from($8097daeff2c3b7c8$export$3ef6d4da8160fa32)
                });
            };
            if (state.navigation.state !== 'idle') {
                // Navigation in progress - reset if location changed
                if (lastHandledPathname !== currentLocationKey) lastHandledPathname = null;
                // Cancel any previously scheduled handler to avoid duplicates
                if (scheduledNavigationHandler !== null) $8097daeff2c3b7c8$var$cancelScheduledCallback(scheduledNavigationHandler);
                scheduledNavigationHandler = $8097daeff2c3b7c8$var$scheduleCallback(navigationHandler);
            } else {
                // Navigation completed - cancel scheduled handler if any, then call immediately
                if (scheduledNavigationHandler !== null) {
                    $8097daeff2c3b7c8$var$cancelScheduledCallback(scheduledNavigationHandler);
                    scheduledNavigationHandler = null;
                }
                navigationHandler();
            // Don't reset - next navigation cycle resets to prevent duplicates within same cycle.
            }
        }
    });
}
/**
 * Creates a wrapCreateBrowserRouter function that can be used with all React Router v6 compatible versions.
 */ function $8097daeff2c3b7c8$export$6f08ca2914060d3f(createRouterFunction, version) {
    if (!$8097daeff2c3b7c8$var$_useEffect || !$8097daeff2c3b7c8$var$_useLocation || !$8097daeff2c3b7c8$var$_useNavigationType || !$8097daeff2c3b7c8$var$_matchRoutes) {
        (0, $0ee57f62053fbbae$export$16a28057038b10ef) && (0, $d11ed0b3cdda6b8d$export$1c9f709888824e05).warn(`reactRouterV${version}Instrumentation was unable to wrap the \`createRouter\` function because of one or more missing parameters.`);
        return createRouterFunction;
    }
    return function(routes, opts) {
        $8097daeff2c3b7c8$export$e8ecdda469a42a59(routes);
        if ($8097daeff2c3b7c8$var$_enableAsyncRouteHandlers) for (const route of routes)(0, $eb2165c92b8d4b57$export$e9262e29e117b830)(route, $8097daeff2c3b7c8$export$b18942cbaf6837a6);
        // Capture the active span BEFORE creating the router.
        // This is important because the span might end (due to idle timeout) before
        // patchRoutesOnNavigation is called by React Router.
        const activeRootSpan = (0, $4487fbe2e1371231$export$6d46479e35ff5f30)();
        // If patchRoutesOnNavigation is provided and we have an active span,
        // mark the span as having potential lazy routes and create a deferred promise.
        const hasPatchRoutesOnNavigation = opts && 'patchRoutesOnNavigation' in opts && typeof opts.patchRoutesOnNavigation === 'function';
        if (hasPatchRoutesOnNavigation && activeRootSpan) {
            // Mark the span as potentially having lazy routes
            (0, $269eeb69635ed414$export$e73679ffaf56810e)(activeRootSpan, '__sentry_may_have_lazy_routes__', true);
            $8097daeff2c3b7c8$var$createDeferredLazyRoutePromise(activeRootSpan);
        }
        // Pass the captured span to wrapPatchRoutesOnNavigation so it uses the same span
        // even if the span has ended by the time patchRoutesOnNavigation is called.
        const wrappedOpts = $8097daeff2c3b7c8$var$wrapPatchRoutesOnNavigation(opts, false, activeRootSpan);
        const router = createRouterFunction(routes, wrappedOpts);
        const basename = opts?.basename;
        if (router.state.historyAction === 'POP' && activeRootSpan) $8097daeff2c3b7c8$var$updatePageloadTransaction({
            activeRootSpan: activeRootSpan,
            location: router.state.location,
            routes: routes,
            basename: basename,
            allRoutes: Array.from($8097daeff2c3b7c8$export$3ef6d4da8160fa32)
        });
        // Store basename for use in updateNavigationSpan
        $8097daeff2c3b7c8$var$_basename = basename || '';
        $8097daeff2c3b7c8$var$setupRouterSubscription(router, routes, version, basename, activeRootSpan);
        return router;
    };
}
/**
 * Creates a wrapCreateMemoryRouter function that can be used with all React Router v6 compatible versions.
 */ function $8097daeff2c3b7c8$export$ce6d63af7f6f9771(createRouterFunction, version) {
    if (!$8097daeff2c3b7c8$var$_useEffect || !$8097daeff2c3b7c8$var$_useLocation || !$8097daeff2c3b7c8$var$_useNavigationType || !$8097daeff2c3b7c8$var$_matchRoutes) {
        (0, $0ee57f62053fbbae$export$16a28057038b10ef) && (0, $d11ed0b3cdda6b8d$export$1c9f709888824e05).warn(`reactRouterV${version}Instrumentation was unable to wrap the \`createMemoryRouter\` function because of one or more missing parameters.`);
        return createRouterFunction;
    }
    return function(routes, opts) {
        $8097daeff2c3b7c8$export$e8ecdda469a42a59(routes);
        if ($8097daeff2c3b7c8$var$_enableAsyncRouteHandlers) for (const route of routes)(0, $eb2165c92b8d4b57$export$e9262e29e117b830)(route, $8097daeff2c3b7c8$export$b18942cbaf6837a6);
        // Capture the active span BEFORE creating the router (same as browser router)
        const memoryActiveRootSpanEarly = (0, $4487fbe2e1371231$export$6d46479e35ff5f30)();
        // If patchRoutesOnNavigation is provided and we have an active span,
        // mark the span as having potential lazy routes and create a deferred promise.
        const hasPatchRoutesOnNavigation = opts && 'patchRoutesOnNavigation' in opts && typeof opts.patchRoutesOnNavigation === 'function';
        if (hasPatchRoutesOnNavigation && memoryActiveRootSpanEarly) {
            (0, $269eeb69635ed414$export$e73679ffaf56810e)(memoryActiveRootSpanEarly, '__sentry_may_have_lazy_routes__', true);
            $8097daeff2c3b7c8$var$createDeferredLazyRoutePromise(memoryActiveRootSpanEarly);
        }
        const wrappedOpts = $8097daeff2c3b7c8$var$wrapPatchRoutesOnNavigation(opts, true, memoryActiveRootSpanEarly);
        const router = createRouterFunction(routes, wrappedOpts);
        const basename = opts?.basename;
        let initialEntry = undefined;
        const initialEntries = opts?.initialEntries;
        const initialIndex = opts?.initialIndex;
        const hasOnlyOneInitialEntry = initialEntries?.length === 1;
        const hasIndexedEntry = initialIndex !== undefined && initialEntries?.[initialIndex];
        initialEntry = hasOnlyOneInitialEntry ? initialEntries[0] : hasIndexedEntry ? initialEntries[initialIndex] : undefined;
        const location = initialEntry ? typeof initialEntry === 'string' ? {
            pathname: initialEntry
        } : initialEntry : router.state.location;
        const memoryActiveRootSpan = (0, $4487fbe2e1371231$export$6d46479e35ff5f30)();
        if (router.state.historyAction === 'POP' && memoryActiveRootSpan) $8097daeff2c3b7c8$var$updatePageloadTransaction({
            activeRootSpan: memoryActiveRootSpan,
            location: location,
            routes: routes,
            basename: basename,
            allRoutes: Array.from($8097daeff2c3b7c8$export$3ef6d4da8160fa32)
        });
        // Store basename for use in updateNavigationSpan
        $8097daeff2c3b7c8$var$_basename = basename || '';
        $8097daeff2c3b7c8$var$setupRouterSubscription(router, routes, version, basename, memoryActiveRootSpan);
        return router;
    };
}
/**
 * Creates a browser tracing integration that can be used with all React Router v6 compatible versions.
 */ function $8097daeff2c3b7c8$export$7e5bbc7e32f3c098(options, version) {
    const integration = (0, $7b5f2a588355dc11$export$b4109253475213e9)({
        ...options,
        instrumentPageLoad: false,
        instrumentNavigation: false
    });
    const { useEffect: useEffect, useLocation: useLocation, useNavigationType: useNavigationType, createRoutesFromChildren: createRoutesFromChildren, matchRoutes: matchRoutes, stripBasename: stripBasename, enableAsyncRouteHandlers: enableAsyncRouteHandlers = false, instrumentPageLoad: instrumentPageLoad = true, instrumentNavigation: instrumentNavigation = true, lazyRouteTimeout: lazyRouteTimeout, lazyRouteManifest: lazyRouteManifest } = options;
    return {
        ...integration,
        setup (client) {
            integration.setup(client);
            const finalTimeout = options.finalTimeout ?? 30000;
            const defaultMaxWait = (options.idleTimeout ?? 1000) * 3;
            const configuredMaxWait = lazyRouteTimeout ?? defaultMaxWait;
            // Cap Infinity at finalTimeout to prevent indefinite hangs
            if (configuredMaxWait === Infinity) {
                $8097daeff2c3b7c8$var$_lazyRouteTimeout = finalTimeout;
                (0, $0ee57f62053fbbae$export$16a28057038b10ef) && (0, $d11ed0b3cdda6b8d$export$1c9f709888824e05).log('[React Router] lazyRouteTimeout set to Infinity, capping at finalTimeout:', finalTimeout, 'ms to prevent indefinite hangs');
            } else if (Number.isNaN(configuredMaxWait)) {
                (0, $0ee57f62053fbbae$export$16a28057038b10ef) && (0, $d11ed0b3cdda6b8d$export$1c9f709888824e05).warn('[React Router] lazyRouteTimeout must be a number, falling back to default:', defaultMaxWait);
                $8097daeff2c3b7c8$var$_lazyRouteTimeout = defaultMaxWait;
            } else if (configuredMaxWait < 0) {
                (0, $0ee57f62053fbbae$export$16a28057038b10ef) && (0, $d11ed0b3cdda6b8d$export$1c9f709888824e05).warn('[React Router] lazyRouteTimeout must be non-negative or Infinity, got:', configuredMaxWait, 'falling back to:', defaultMaxWait);
                $8097daeff2c3b7c8$var$_lazyRouteTimeout = defaultMaxWait;
            } else $8097daeff2c3b7c8$var$_lazyRouteTimeout = configuredMaxWait;
            $8097daeff2c3b7c8$var$_useEffect = useEffect;
            $8097daeff2c3b7c8$var$_useLocation = useLocation;
            $8097daeff2c3b7c8$var$_useNavigationType = useNavigationType;
            $8097daeff2c3b7c8$var$_matchRoutes = matchRoutes;
            $8097daeff2c3b7c8$var$_createRoutesFromChildren = createRoutesFromChildren;
            $8097daeff2c3b7c8$var$_enableAsyncRouteHandlers = enableAsyncRouteHandlers;
            $8097daeff2c3b7c8$var$_lazyRouteManifest = lazyRouteManifest;
            // Initialize the router utils with the required dependencies
            (0, $4487fbe2e1371231$export$d5deab901a3788fa)(matchRoutes, stripBasename || false);
        },
        afterAllSetup (client) {
            integration.afterAllSetup(client);
            const initPathName = (0, $e62dec891f31852b$export$56d8a8a25bd48b81).location?.pathname;
            if (instrumentPageLoad && initPathName) (0, $7b5f2a588355dc11$export$aa44a07f82af519f)(client, {
                name: initPathName,
                attributes: {
                    [(0, $f337c80285f06f80$export$d7a7d984b0791405)]: 'url',
                    [(0, $f337c80285f06f80$export$1a413bd9a88fdb09)]: 'pageload',
                    [(0, $f337c80285f06f80$export$cca8dd30f57f805e)]: `auto.pageload.react.reactrouter_v${version}`
                }
            });
            if (instrumentNavigation) $8097daeff2c3b7c8$var$CLIENTS_WITH_INSTRUMENT_NAVIGATION.add(client);
        }
    };
}
function $8097daeff2c3b7c8$export$3881404ad6870e59(origUseRoutes, version) {
    if (!$8097daeff2c3b7c8$var$_useEffect || !$8097daeff2c3b7c8$var$_useLocation || !$8097daeff2c3b7c8$var$_useNavigationType || !$8097daeff2c3b7c8$var$_matchRoutes) {
        (0, $0ee57f62053fbbae$export$16a28057038b10ef) && (0, $d11ed0b3cdda6b8d$export$1c9f709888824e05).warn('reactRouterV6Instrumentation was unable to wrap `useRoutes` because of one or more missing parameters.');
        return origUseRoutes;
    }
    const SentryRoutes = (props)=>{
        const isMountRenderPass = $5FkrB.useRef(true);
        const { routes: routes, locationArg: locationArg } = props;
        const Routes = origUseRoutes(routes, locationArg);
        const location = $8097daeff2c3b7c8$var$_useLocation();
        const navigationType = $8097daeff2c3b7c8$var$_useNavigationType();
        // A value with stable identity to either pick `locationArg` if available or `location` if not
        const stableLocationParam = typeof locationArg === 'string' || locationArg?.pathname ? locationArg : location;
        $8097daeff2c3b7c8$var$_useEffect(()=>{
            const normalizedLocation = typeof stableLocationParam === 'string' ? {
                pathname: stableLocationParam
            } : stableLocationParam;
            if (isMountRenderPass.current) {
                $8097daeff2c3b7c8$export$e8ecdda469a42a59(routes);
                $8097daeff2c3b7c8$var$updatePageloadTransaction({
                    activeRootSpan: (0, $4487fbe2e1371231$export$6d46479e35ff5f30)(),
                    location: normalizedLocation,
                    routes: routes,
                    allRoutes: Array.from($8097daeff2c3b7c8$export$3ef6d4da8160fa32)
                });
                isMountRenderPass.current = false;
            } else // Note: Component-based routes don't support lazy route tracking via lazyRouteTimeout
            // because React.lazy() loads happen at the component level, not the router level.
            // Use createBrowserRouter with patchRoutesOnNavigation for lazy route tracking.
            $8097daeff2c3b7c8$export$706ad1af8096e280({
                location: normalizedLocation,
                routes: routes,
                navigationType: navigationType,
                version: version,
                allRoutes: Array.from($8097daeff2c3b7c8$export$3ef6d4da8160fa32)
            });
        }, [
            navigationType,
            stableLocationParam
        ]);
        return Routes;
    };
    // eslint-disable-next-line react/display-name
    return (routes, locationArg)=>{
        return $5FkrB.createElement(SentryRoutes, {
            routes: routes,
            locationArg: locationArg
        });
    };
}
function $8097daeff2c3b7c8$var$wrapPatchRoutesOnNavigation(opts, isMemoryRouter = false, capturedSpan) {
    if (!opts || !('patchRoutesOnNavigation' in opts) || typeof opts.patchRoutesOnNavigation !== 'function') return opts || {};
    const originalPatchRoutes = opts.patchRoutesOnNavigation;
    return {
        ...opts,
        patchRoutesOnNavigation: async (args)=>{
            // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-member-access
            const targetPath = args?.path;
            // Use current active span if available, otherwise fall back to captured span (from router creation time).
            // This ensures navigation spans use their own span (not the stale pageload span), while still
            // supporting pageload spans that may have ended before patchRoutesOnNavigation is called.
            const activeRootSpan = (0, $4487fbe2e1371231$export$6d46479e35ff5f30)() ?? capturedSpan;
            if (!isMemoryRouter) {
                // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-member-access
                const originalPatch = args?.patch;
                // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-member-access
                const matches = args?.matches;
                if (originalPatch) // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-member-access
                args.patch = (routeId, children)=>{
                    $8097daeff2c3b7c8$export$e8ecdda469a42a59(children);
                    // Find the parent route from matches and attach children to it in allRoutes.
                    // React Router's patch attaches children to its internal route copies, but we need
                    // to update the route objects in our allRoutes Set for proper route matching.
                    if (matches && matches.length > 0) {
                        const leafMatch = matches[matches.length - 1];
                        const leafRoute = leafMatch?.route;
                        if (leafRoute) {
                            // Find the matching route in allRoutes by id, reference, or path
                            const matchingRoute = Array.from($8097daeff2c3b7c8$export$3ef6d4da8160fa32).find((route)=>{
                                const idMatches = route.id !== undefined && route.id === routeId;
                                const referenceMatches = route === leafRoute;
                                const pathMatches = route.path !== undefined && leafRoute.path !== undefined && route.path === leafRoute.path;
                                return idMatches || referenceMatches || pathMatches;
                            });
                            if (matchingRoute) $8097daeff2c3b7c8$export$d443af17fae6e7aa(children, matchingRoute);
                        }
                    }
                    // Use the captured activeRootSpan instead of getActiveRootSpan() to avoid race conditions
                    // where user navigates away during lazy route loading and we'd update the wrong span
                    const spanJson = activeRootSpan ? (0, $bb9b6447bf4caedb$export$92d8c23565496537)(activeRootSpan) : undefined;
                    // Only update if we have a valid targetPath (patchRoutesOnNavigation can be called without path),
                    // the captured span exists, hasn't ended, and is a navigation span
                    if (targetPath && activeRootSpan && spanJson && !spanJson.timestamp && // Span hasn't ended yet
                    spanJson.op === 'navigation') $8097daeff2c3b7c8$export$8e00428fd5aa3427(activeRootSpan, {
                        pathname: targetPath,
                        search: '',
                        hash: '',
                        state: null,
                        key: 'default'
                    }, Array.from($8097daeff2c3b7c8$export$3ef6d4da8160fa32), true, $8097daeff2c3b7c8$var$_matchRoutes);
                    return originalPatch(routeId, children);
                };
            }
            const lazyLoadPromise = (async ()=>{
                // Set context so async handlers can access correct targetPath and span
                const contextToken = (0, $4487fbe2e1371231$export$49f239a397357a7c)(targetPath, activeRootSpan);
                let result;
                try {
                    result = await originalPatchRoutes(args);
                } finally{
                    (0, $4487fbe2e1371231$export$44ec4f5e487fad8c)(contextToken);
                    // Resolve the deferred promise now that patchRoutesOnNavigation has completed.
                    // This ensures patchedEnd has waited long enough for the lazy routes to load.
                    if (activeRootSpan) $8097daeff2c3b7c8$var$resolveDeferredLazyRoutePromise(activeRootSpan);
                }
                // Use the captured activeRootSpan instead of getActiveRootSpan() to avoid race conditions
                // where user navigates away during lazy route loading and we'd update the wrong span
                const spanJson = activeRootSpan ? (0, $bb9b6447bf4caedb$export$92d8c23565496537)(activeRootSpan) : undefined;
                if (activeRootSpan && spanJson && !spanJson.timestamp && // Span hasn't ended yet
                spanJson.op === 'navigation') {
                    // Use targetPath consistently - don't fall back to WINDOW.location which may have changed
                    // if the user navigated away during async loading
                    const pathname = targetPath;
                    if (pathname) $8097daeff2c3b7c8$export$8e00428fd5aa3427(activeRootSpan, {
                        pathname: pathname,
                        search: '',
                        hash: '',
                        state: null,
                        key: 'default'
                    }, Array.from($8097daeff2c3b7c8$export$3ef6d4da8160fa32), false, $8097daeff2c3b7c8$var$_matchRoutes);
                }
                return result;
            })();
            if (activeRootSpan) $8097daeff2c3b7c8$var$trackLazyRouteLoad(activeRootSpan, lazyLoadPromise);
            return lazyLoadPromise;
        }
    };
}
// eslint-disable-next-line complexity
function $8097daeff2c3b7c8$export$706ad1af8096e280(opts) {
    const { location: location, routes: routes, navigationType: navigationType, version: version, matches: matches, basename: basename, allRoutes: allRoutes } = opts;
    const branches = Array.isArray(matches) ? matches : $8097daeff2c3b7c8$var$_matchRoutes(allRoutes || routes, location, basename);
    const client = (0, $7d48e1ed9f699a01$export$6bb76d6eba7e258c)();
    if (!client || !$8097daeff2c3b7c8$var$CLIENTS_WITH_INSTRUMENT_NAVIGATION.has(client)) return;
    const activeRootSpan = (0, $4487fbe2e1371231$export$6d46479e35ff5f30)();
    if (activeRootSpan && (0, $bb9b6447bf4caedb$export$92d8c23565496537)(activeRootSpan).op === 'pageload' && navigationType === 'POP') return;
    if ((navigationType === 'PUSH' || navigationType === 'POP') && branches) {
        const [name, source] = (0, $4487fbe2e1371231$export$d0d5aab0e629ad63)(location, allRoutes || routes, allRoutes || routes, branches, basename, $8097daeff2c3b7c8$var$_lazyRouteManifest, $8097daeff2c3b7c8$var$_enableAsyncRouteHandlers);
        const locationKey = $8097daeff2c3b7c8$export$6da138630728824c(location);
        const trackedNav = $8097daeff2c3b7c8$var$activeNavigationSpans.get(client);
        // Determine if this navigation should be skipped as a duplicate
        const trackedSpanHasEnded = trackedNav && !trackedNav.isPlaceholder ? !!(0, $bb9b6447bf4caedb$export$92d8c23565496537)(trackedNav.span).timestamp : false;
        const { skip: skip, shouldUpdate: shouldUpdate } = $8097daeff2c3b7c8$export$74ccc56dfa81ef20(trackedNav, locationKey, name, trackedSpanHasEnded);
        if (skip) {
            if (shouldUpdate && trackedNav) {
                const oldName = trackedNav.routeName;
                if (trackedNav.isPlaceholder) {
                    // Update placeholder's route name - the real span will be created with this name
                    trackedNav.routeName = name;
                    (0, $0ee57f62053fbbae$export$16a28057038b10ef) && (0, $d11ed0b3cdda6b8d$export$1c9f709888824e05).log(`[Tracing] Updated placeholder navigation name from "${oldName}" to "${name}" (will apply to real span)`);
                } else {
                    // Update existing real span from wildcard to parameterized route name
                    trackedNav.span.updateName(name);
                    trackedNav.span.setAttribute((0, $f337c80285f06f80$export$d7a7d984b0791405), source);
                    (0, $269eeb69635ed414$export$e73679ffaf56810e)(trackedNav.span, '__sentry_navigation_name_set__', true);
                    trackedNav.routeName = name;
                    (0, $0ee57f62053fbbae$export$16a28057038b10ef) && (0, $d11ed0b3cdda6b8d$export$1c9f709888824e05).log(`[Tracing] Updated navigation span name from "${oldName}" to "${name}"`);
                }
            } else (0, $0ee57f62053fbbae$export$16a28057038b10ef) && (0, $d11ed0b3cdda6b8d$export$1c9f709888824e05).log(`[Tracing] Skipping duplicate navigation for location: ${locationKey}`);
            return;
        }
        // Create new navigation span (first navigation or legitimate new navigation)
        // Reserve the spot in the map first to prevent race conditions
        // Mark as placeholder to prevent concurrent handleNavigation calls from creating duplicates
        const placeholderSpan = {
            end: ()=>{}
        };
        const placeholderEntry = {
            span: placeholderSpan,
            routeName: name,
            pathname: location.pathname,
            locationKey: locationKey,
            isPlaceholder: true
        };
        $8097daeff2c3b7c8$var$activeNavigationSpans.set(client, placeholderEntry);
        let navigationSpan;
        try {
            navigationSpan = (0, $7b5f2a588355dc11$export$7d159749bd9969ad)(client, {
                name: placeholderEntry.routeName,
                attributes: {
                    [(0, $f337c80285f06f80$export$d7a7d984b0791405)]: source,
                    [(0, $f337c80285f06f80$export$1a413bd9a88fdb09)]: 'navigation',
                    [(0, $f337c80285f06f80$export$cca8dd30f57f805e)]: `auto.navigation.react.reactrouter_v${version}`
                }
            });
        } catch (e) {
            // If span creation fails, remove the placeholder so we don't block future navigations
            $8097daeff2c3b7c8$var$activeNavigationSpans.delete(client);
            throw e;
        }
        if (navigationSpan) {
            // Update the map with the real span (isPlaceholder omitted, defaults to false)
            $8097daeff2c3b7c8$var$activeNavigationSpans.set(client, {
                span: navigationSpan,
                routeName: placeholderEntry.routeName,
                pathname: location.pathname,
                locationKey: locationKey
            });
            $8097daeff2c3b7c8$var$patchSpanEnd(navigationSpan, location, routes, basename, 'navigation');
        } else // If no span was created, remove the placeholder
        $8097daeff2c3b7c8$var$activeNavigationSpans.delete(client);
    }
}
/* Only exported for testing purposes */ function $8097daeff2c3b7c8$export$e8ecdda469a42a59(routes) {
    routes.forEach((route)=>{
        const extractedChildRoutes = $8097daeff2c3b7c8$var$getChildRoutesRecursively(route);
        extractedChildRoutes.forEach((r)=>{
            $8097daeff2c3b7c8$export$3ef6d4da8160fa32.add(r);
        });
    });
}
function $8097daeff2c3b7c8$var$getChildRoutesRecursively(route, allRoutes = new Set()) {
    if (!allRoutes.has(route)) {
        allRoutes.add(route);
        if (route.children && !route.index) route.children.forEach((child)=>{
            const childRoutes = $8097daeff2c3b7c8$var$getChildRoutesRecursively(child, allRoutes);
            childRoutes.forEach((r)=>{
                allRoutes.add(r);
            });
        });
    }
    return allRoutes;
}
function $8097daeff2c3b7c8$var$updatePageloadTransaction({ activeRootSpan: activeRootSpan, location: location, routes: routes, matches: matches, basename: basename, allRoutes: allRoutes }) {
    const branches = Array.isArray(matches) ? matches : $8097daeff2c3b7c8$var$_matchRoutes(allRoutes || routes, location, basename);
    if (branches) {
        const [name, source] = (0, $4487fbe2e1371231$export$d0d5aab0e629ad63)(location, allRoutes || routes, allRoutes || routes, branches, basename, $8097daeff2c3b7c8$var$_lazyRouteManifest, $8097daeff2c3b7c8$var$_enableAsyncRouteHandlers);
        (0, $7d48e1ed9f699a01$export$c7be4b0125a10cba)().setTransactionName(name || '/');
        if (activeRootSpan) {
            activeRootSpan.updateName(name);
            activeRootSpan.setAttribute((0, $f337c80285f06f80$export$d7a7d984b0791405), source);
            // Patch span.end() to ensure we update the name one last time before the span is sent
            $8097daeff2c3b7c8$var$patchSpanEnd(activeRootSpan, location, routes, basename, 'pageload');
        }
    } else if (activeRootSpan) // Even if branches is null (can happen when lazy routes haven't loaded yet),
    // we still need to patch span.end() so that when lazy routes load and the span ends,
    // we can update the transaction name correctly.
    $8097daeff2c3b7c8$var$patchSpanEnd(activeRootSpan, location, routes, basename, 'pageload');
}
/**
 * Determines if a span name should be updated during wildcard route resolution.
 *
 * Update conditions (in priority order):
 * 1. No current name + allowNoCurrentName: true → always update (pageload spans)
 * 2. Current name has wildcard + new is route without wildcard → upgrade (e.g., "/users/*" → "/users/:id")
 * 3. Current source is not 'route' + new source is 'route' → upgrade (e.g., URL → parameterized route)
 *
 * @param currentName - The current span name (may be undefined)
 * @param currentSource - The current span source ('route', 'url', or undefined)
 * @param newName - The proposed new span name
 * @param newSource - The proposed new span source
 * @param allowNoCurrentName - If true, allow updates when there's no current name (for pageload spans)
 * @returns true if the span name should be updated
 */ function $8097daeff2c3b7c8$var$shouldUpdateWildcardSpanName(currentName, currentSource, newName, newSource, allowNoCurrentName = false) {
    if (!newName) return false;
    if (!currentName && allowNoCurrentName) return true;
    const hasWildcard = currentName && (0, $4487fbe2e1371231$export$73bbd8f1d410fc7c)(currentName);
    if (hasWildcard && newSource === 'route' && !(0, $4487fbe2e1371231$export$73bbd8f1d410fc7c)(newName)) return true;
    if (currentSource !== 'route' && newSource === 'route') return true;
    return false;
}
function $8097daeff2c3b7c8$var$tryUpdateSpanNameBeforeEnd(span, spanJson, currentName, location, routes, basename, spanType, allRoutes) {
    try {
        const currentSource = spanJson.data?.[0, $f337c80285f06f80$export$d7a7d984b0791405];
        if (currentSource === 'route' && currentName && !(0, $4487fbe2e1371231$export$73bbd8f1d410fc7c)(currentName)) return;
        const currentAllRoutes = Array.from(allRoutes);
        const routesToUse = currentAllRoutes.length > 0 ? currentAllRoutes : routes;
        const branches = $8097daeff2c3b7c8$var$_matchRoutes(routesToUse, location, basename);
        if (!branches) return;
        const [name, source] = (0, $4487fbe2e1371231$export$d0d5aab0e629ad63)(location, routesToUse, routesToUse, branches, basename, $8097daeff2c3b7c8$var$_lazyRouteManifest, $8097daeff2c3b7c8$var$_enableAsyncRouteHandlers);
        const isImprovement = $8097daeff2c3b7c8$var$shouldUpdateWildcardSpanName(currentName, currentSource, name, source, true);
        const spanNotEnded = spanType === 'pageload' || !spanJson.timestamp;
        if (isImprovement && spanNotEnded) {
            span.updateName(name);
            span.setAttribute((0, $f337c80285f06f80$export$d7a7d984b0791405), source);
        }
    } catch (error) {
        (0, $0ee57f62053fbbae$export$16a28057038b10ef) && (0, $d11ed0b3cdda6b8d$export$1c9f709888824e05).warn(`Error updating span details before ending: ${error}`);
    }
}
/**
 * Patches the span.end() method to update the transaction name one last time before the span is sent.
 * This handles cases where the span is cancelled early (e.g., document.hidden) before lazy routes have finished loading.
 */ function $8097daeff2c3b7c8$var$patchSpanEnd(span, location, routes, basename, spanType) {
    const patchedPropertyName = `__sentry_${spanType}_end_patched__`;
    const hasEndBeenPatched = span?.[patchedPropertyName];
    if (hasEndBeenPatched || !span.end) return;
    // Uses global allRoutes to access lazy-loaded routes added after this function was called.
    const originalEnd = span.end.bind(span);
    let endCalled = false;
    span.end = function patchedEnd(...args) {
        if (endCalled) return;
        endCalled = true;
        // Capture timestamp immediately to avoid delay from async operations
        // If no timestamp was provided, capture the current time now
        const endTimestamp = args.length > 0 ? args[0] : Date.now() / 1000;
        const spanJson = (0, $bb9b6447bf4caedb$export$92d8c23565496537)(span);
        const currentName = spanJson.description;
        const currentSource = spanJson.data?.[0, $f337c80285f06f80$export$d7a7d984b0791405];
        // Helper to clean up activeNavigationSpans after span ends
        const cleanupNavigationSpan = ()=>{
            const client = (0, $7d48e1ed9f699a01$export$6bb76d6eba7e258c)();
            if (client && spanType === 'navigation') {
                const trackedNav = $8097daeff2c3b7c8$var$activeNavigationSpans.get(client);
                if (trackedNav && trackedNav.span === span) $8097daeff2c3b7c8$var$activeNavigationSpans.delete(client);
            }
        };
        const pendingPromises = $8097daeff2c3b7c8$var$pendingLazyRouteLoads.get(span);
        const mayHaveLazyRoutes = span.__sentry_may_have_lazy_routes__;
        // Wait for lazy routes if:
        // 1. (There are pending promises OR the span was marked as potentially having lazy routes) AND
        // 2. Current name exists AND
        // 3. Either the name has a wildcard OR the source is not 'route' (URL-based names)
        const hasPendingOrMayHaveLazyRoutes = pendingPromises && pendingPromises.size > 0 || mayHaveLazyRoutes;
        const shouldWaitForLazyRoutes = hasPendingOrMayHaveLazyRoutes && currentName && ((0, $4487fbe2e1371231$export$73bbd8f1d410fc7c)(currentName) || currentSource !== 'route');
        if (shouldWaitForLazyRoutes) {
            if ($8097daeff2c3b7c8$var$_lazyRouteTimeout === 0) {
                $8097daeff2c3b7c8$var$tryUpdateSpanNameBeforeEnd(span, spanJson, currentName, location, routes, basename, spanType, $8097daeff2c3b7c8$export$3ef6d4da8160fa32);
                cleanupNavigationSpan();
                originalEnd(endTimestamp);
                return;
            }
            // If we have pending promises, wait for them. Otherwise, just wait for the timeout.
            // This handles the case where we know lazy routes might load but patchRoutesOnNavigation
            // hasn't been called yet.
            const timeoutPromise = new Promise((r)=>setTimeout(r, $8097daeff2c3b7c8$var$_lazyRouteTimeout));
            let waitPromise;
            if (pendingPromises && pendingPromises.size > 0) {
                const allSettled = Promise.allSettled(pendingPromises).then(()=>{});
                waitPromise = $8097daeff2c3b7c8$var$_lazyRouteTimeout === Infinity ? allSettled : Promise.race([
                    allSettled,
                    timeoutPromise
                ]);
            } else // No pending promises yet, but we know lazy routes might load
            // Wait for the timeout to give React Router time to call patchRoutesOnNavigation
            waitPromise = timeoutPromise;
            waitPromise.then(()=>{
                const updatedSpanJson = (0, $bb9b6447bf4caedb$export$92d8c23565496537)(span);
                $8097daeff2c3b7c8$var$tryUpdateSpanNameBeforeEnd(span, updatedSpanJson, updatedSpanJson.description, location, routes, basename, spanType, $8097daeff2c3b7c8$export$3ef6d4da8160fa32);
                cleanupNavigationSpan();
                originalEnd(endTimestamp);
            }).catch(()=>{
                cleanupNavigationSpan();
                originalEnd(endTimestamp);
            });
            return;
        }
        $8097daeff2c3b7c8$var$tryUpdateSpanNameBeforeEnd(span, spanJson, currentName, location, routes, basename, spanType, $8097daeff2c3b7c8$export$3ef6d4da8160fa32);
        cleanupNavigationSpan();
        originalEnd(endTimestamp);
    };
    (0, $269eeb69635ed414$export$e73679ffaf56810e)(span, patchedPropertyName, true);
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $8097daeff2c3b7c8$export$b90e0c8f3b3b5df0(Routes, version) {
    if (!$8097daeff2c3b7c8$var$_useEffect || !$8097daeff2c3b7c8$var$_useLocation || !$8097daeff2c3b7c8$var$_useNavigationType || !$8097daeff2c3b7c8$var$_createRoutesFromChildren || !$8097daeff2c3b7c8$var$_matchRoutes) {
        (0, $0ee57f62053fbbae$export$16a28057038b10ef) && (0, $d11ed0b3cdda6b8d$export$1c9f709888824e05).warn(`reactRouterV6Instrumentation was unable to wrap Routes because of one or more missing parameters.
      useEffect: ${$8097daeff2c3b7c8$var$_useEffect}. useLocation: ${$8097daeff2c3b7c8$var$_useLocation}. useNavigationType: ${$8097daeff2c3b7c8$var$_useNavigationType}.
      createRoutesFromChildren: ${$8097daeff2c3b7c8$var$_createRoutesFromChildren}. matchRoutes: ${$8097daeff2c3b7c8$var$_matchRoutes}.`);
        return Routes;
    }
    const SentryRoutes = (props)=>{
        const isMountRenderPass = $5FkrB.useRef(true);
        const location = $8097daeff2c3b7c8$var$_useLocation();
        const navigationType = $8097daeff2c3b7c8$var$_useNavigationType();
        $8097daeff2c3b7c8$var$_useEffect(()=>{
            const routes = $8097daeff2c3b7c8$var$_createRoutesFromChildren(props.children);
            if (isMountRenderPass.current) {
                $8097daeff2c3b7c8$export$e8ecdda469a42a59(routes);
                $8097daeff2c3b7c8$var$updatePageloadTransaction({
                    activeRootSpan: (0, $4487fbe2e1371231$export$6d46479e35ff5f30)(),
                    location: location,
                    routes: routes,
                    allRoutes: Array.from($8097daeff2c3b7c8$export$3ef6d4da8160fa32)
                });
                isMountRenderPass.current = false;
            } else // Note: Component-based routes don't support lazy route tracking via lazyRouteTimeout
            // because React.lazy() loads happen at the component level, not the router level.
            // Use createBrowserRouter with patchRoutesOnNavigation for lazy route tracking.
            $8097daeff2c3b7c8$export$706ad1af8096e280({
                location: location,
                routes: routes,
                navigationType: navigationType,
                version: version,
                allRoutes: Array.from($8097daeff2c3b7c8$export$3ef6d4da8160fa32)
            });
        }, // Re-run only on location/navigation changes, not children changes
        [
            location,
            navigationType
        ]);
        // @ts-expect-error Setting more specific React Component typing for `R` generic above
        // will break advanced type inference done by react router params
        return $5FkrB.createElement(Routes, {
            ...props
        });
    };
    (0, $2015f24f5be0bafb$export$6c1f0397687d8b2)(SentryRoutes, Routes);
    // @ts-expect-error Setting more specific React Component typing for `R` generic above
    // will break advanced type inference done by react router params
    return SentryRoutes;
}




/**
 * A browser tracing integration that uses React Router v6 to instrument navigations.
 * Expects `useEffect`, `useLocation`, `useNavigationType`, `createRoutesFromChildren` and `matchRoutes` to be passed as options.
 */ function $c159a67177be6b02$export$47113a480541ff59(options) {
    return (0, $8097daeff2c3b7c8$export$7e5bbc7e32f3c098)(options, '6');
}
/**
 * A wrapper function that adds Sentry routing instrumentation to a React Router v6 useRoutes hook.
 * This is used to automatically capture route changes as transactions when using the useRoutes hook.
 */ function $c159a67177be6b02$export$1ffd7287c0e61f32(origUseRoutes) {
    return (0, $8097daeff2c3b7c8$export$3881404ad6870e59)(origUseRoutes, '6');
}
/**
 * A wrapper function that adds Sentry routing instrumentation to a React Router v6 createBrowserRouter function.
 * This is used to automatically capture route changes as transactions when using the createBrowserRouter API.
 */ function $c159a67177be6b02$export$bd33b81dece50867(createRouterFunction) {
    return (0, $8097daeff2c3b7c8$export$6f08ca2914060d3f)(createRouterFunction, '6');
}
/**
 * A wrapper function that adds Sentry routing instrumentation to a React Router v6 createMemoryRouter function.
 * This is used to automatically capture route changes as transactions when using the createMemoryRouter API.
 * The difference between createBrowserRouter and createMemoryRouter is that with createMemoryRouter,
 * optional `initialEntries` are also taken into account.
 */ function $c159a67177be6b02$export$e61a765bf2bfccdc(createMemoryRouterFunction) {
    return (0, $8097daeff2c3b7c8$export$ce6d63af7f6f9771)(createMemoryRouterFunction, '6');
}
/**
 * A higher-order component that adds Sentry routing instrumentation to a React Router v6 Route component.
 * This is used to automatically capture route changes as transactions.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $c159a67177be6b02$export$c6111e8561a02a8b(routes) {
    return (0, $8097daeff2c3b7c8$export$b90e0c8f3b3b5df0)(routes, '6');
}





/**
 * A browser tracing integration that uses React Router v7 to instrument navigations.
 * Expects `useEffect`, `useLocation`, `useNavigationType`, `createRoutesFromChildren` and `matchRoutes` to be passed as options.
 */ function $5bb87f6d8535ae7e$export$8c58a21c71b0a1de(options) {
    return (0, $8097daeff2c3b7c8$export$7e5bbc7e32f3c098)(options, '7');
}
/**
 * A higher-order component that adds Sentry routing instrumentation to a React Router v7 Route component.
 * This is used to automatically capture route changes as transactions.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $5bb87f6d8535ae7e$export$1d21f1c69f33ffe5(routes) {
    return (0, $8097daeff2c3b7c8$export$b90e0c8f3b3b5df0)(routes, '7');
}
/**
 * A wrapper function that adds Sentry routing instrumentation to a React Router v7 createBrowserRouter function.
 * This is used to automatically capture route changes as transactions when using the createBrowserRouter API.
 */ function $5bb87f6d8535ae7e$export$b070baa27381b3d3(createRouterFunction) {
    return (0, $8097daeff2c3b7c8$export$6f08ca2914060d3f)(createRouterFunction, '7');
}
/**
 * A wrapper function that adds Sentry routing instrumentation to a React Router v7 createMemoryRouter function.
 * This is used to automatically capture route changes as transactions when using the createMemoryRouter API.
 * The difference between createBrowserRouter and createMemoryRouter is that with createMemoryRouter,
 * optional `initialEntries` are also taken into account.
 */ function $5bb87f6d8535ae7e$export$6d8f60accec7deae(createMemoryRouterFunction) {
    return (0, $8097daeff2c3b7c8$export$ce6d63af7f6f9771)(createMemoryRouterFunction, '7');
}
/**
 * A wrapper function that adds Sentry routing instrumentation to a React Router v7 useRoutes hook.
 * This is used to automatically capture route changes as transactions when using the useRoutes hook.
 */ function $5bb87f6d8535ae7e$export$54f60524efa5c3b2(origUseRoutes) {
    return (0, $8097daeff2c3b7c8$export$3881404ad6870e59)(origUseRoutes, '7');
}


$parcel$exportWildcard($033860fe7bfd25af$exports, $054fa894e15f1de5$exports);


function $09e3b90497c94454$export$57570b1603cf6adb() {
    // Use REACT_APP_ENVI env variable to determine the environment.
    const envi = "production";
    if (envi === 'production') return 'production';
    if (envi === 'staging') return 'staging';
    if (envi === 'development') return 'development';
    return 'development';
}
function $09e3b90497c94454$export$bf2f12fe2bb5fabe() {
    return "https://community.atlassian.com" ?? 'https://community.atlassian.com';
}
function $09e3b90497c94454$export$2d47ce6f15e624e5(url) {
    window.location.replace(url);
}
function $09e3b90497c94454$export$e6ab37cc923d2afa() {
    const env = $09e3b90497c94454$export$57570b1603cf6adb();
    if (env === 'development') return 'staging';
    return env;
}



var $3ZMUU = parcelRequire("3ZMUU");
const $9654b596cdf679bc$var$getReleaseIdentifier = ()=>{
    const shortRev = $3ZMUU?.env?.BITBUCKET_COMMIT?.substring(0, 10);
    const buildNumber = $3ZMUU?.env?.BITBUCKET_BUILD_NUMBER;
    if (shortRev && buildNumber) return `${buildNumber}-${shortRev}`;
    if (buildNumber) return buildNumber;
    if (shortRev) return shortRev;
    // Return a stable fallback when CI env vars are absent (e.g. local dev / test)
    // so the release string never contains a literal "undefined".
    return 'local';
};
const $9654b596cdf679bc$export$6c52693ff10aea16 = {
    dsn: 'https://5b81abb385f760bd950717459f42c2d3@o55978.ingest.us.sentry.io/4511072889864192',
    integrations: [
        $7b5f2a588355dc11$export$b4109253475213e9(),
        $604631306887a81e$export$d7706faf7ab354bf()
    ],
    release: `app-updates-frontend@1.0.0-build.${$9654b596cdf679bc$var$getReleaseIdentifier()}`,
    // Tracing
    tracesSampleRate: 0.01,
    // Session Replay
    replaysSessionSampleRate: 0.01,
    replaysOnErrorSampleRate: 1.0
};
const $9654b596cdf679bc$var$captureMessage = (message, severityLevel)=>{
    if ($6918c722b531ff18$export$3f95c6f800b78024()) $6918c722b531ff18$export$45654777c133ae80(message, severityLevel);
};
const $9654b596cdf679bc$export$17d576c8a9d09daa = (environment, config = $9654b596cdf679bc$export$6c52693ff10aea16)=>{
    if (environment === 'development') return {
        tracesSampleRate: 0,
        replaysSessionSampleRate: 0,
        replaysOnErrorSampleRate: 0
    };
    if (environment === 'staging') return {
        // All sample rates are halved for staging, including replay-on-error
        tracesSampleRate: (config.tracesSampleRate ?? $9654b596cdf679bc$export$6c52693ff10aea16.tracesSampleRate) / 2,
        replaysSessionSampleRate: (config.replaysSessionSampleRate ?? $9654b596cdf679bc$export$6c52693ff10aea16.replaysSessionSampleRate) / 2,
        replaysOnErrorSampleRate: (config.replaysOnErrorSampleRate ?? $9654b596cdf679bc$export$6c52693ff10aea16.replaysOnErrorSampleRate) / 2
    };
    // Prod: use the config values directly, falling back to sentryConfig defaults
    // if an explicit `undefined` was passed in a partial override.
    return {
        tracesSampleRate: config.tracesSampleRate ?? $9654b596cdf679bc$export$6c52693ff10aea16.tracesSampleRate,
        replaysSessionSampleRate: config.replaysSessionSampleRate ?? $9654b596cdf679bc$export$6c52693ff10aea16.replaysSessionSampleRate,
        replaysOnErrorSampleRate: config.replaysOnErrorSampleRate ?? $9654b596cdf679bc$export$6c52693ff10aea16.replaysOnErrorSampleRate
    };
};
const $9654b596cdf679bc$export$f5ae3c4820871661 = (config = {})=>{
    const environment = (0, $09e3b90497c94454$export$57570b1603cf6adb)();
    const resolvedConfig = {
        ...$9654b596cdf679bc$export$6c52693ff10aea16,
        ...config
    };
    if (resolvedConfig.dsn) $c3b6349452077e3f$export$2cd8252107eb640b({
        ...resolvedConfig,
        environment: environment,
        ...$9654b596cdf679bc$export$17d576c8a9d09daa(environment, resolvedConfig),
        // In development, drop all events to prevent any data from being sent
        ...environment === 'development' && {
            beforeSend: ()=>null,
            beforeSendTransaction: ()=>null
        },
        // In all other environments, filter out known third-party library noise
        // that causes no visible user impact. These TypeErrors originate from
        // @atlassian/paginated-filter's bundled react-select when handling touch
        // events on mobile browsers, where DOM ref methods like .contains() and
        // .closest() are unexpectedly unavailable on the ref target.
        ...environment !== 'development' && {
            beforeSend: (event, hint)=>{
                const error = hint?.originalException;
                if (error instanceof TypeError) {
                    const msg = error.message;
                    if (msg.includes('controlRef.contains is not a function') || msg.includes('.closest is not a function')) return null;
                }
                return event;
            }
        }
    });
};
var /**
 * Sentry Logger singleton for error tracking and reporting
 *
 * Example usage:
 *
 * import SentryLogger from '@app/sentry';
 * const error = new Error('Something terrible has happened');
 * SentryLogger.error(error, {
 *   extra: {
 *     userId: '123',
 *     action: 'button-click',
 *   },
 * });
 */ $9654b596cdf679bc$export$2e2bcd8739ae039 = {
    info: (message)=>{
        $9654b596cdf679bc$var$captureMessage(message, 'info');
    },
    warn: (message)=>{
        $9654b596cdf679bc$var$captureMessage(message, 'warning');
    },
    debug: (message)=>{
        $9654b596cdf679bc$var$captureMessage(message, 'debug');
    },
    error: (exception, ...args)=>{
        if ($6918c722b531ff18$export$3f95c6f800b78024()) $6918c722b531ff18$export$f5282963edea4a68(exception, ...args);
    }
};





var $rxpl9 = parcelRequire("rxpl9");
parcelRequire("5FkrB");
parcelRequire("bR2Nz");
parcelRequire("kqp0i");
parcelRequire("1QNjI");

parcelRequire("knBeW");
parcelRequire("eP8dQ");
parcelRequire("ckRFu");
parcelRequire("5qnXH");
var $6bec4f26b2cb3094$export$ffb0004e005737fa = $faf30355a80342e4$exports.Fragment;
var $6bec4f26b2cb3094$export$34b9dba7ce09269b = function jsx(type, props, key) {
    if (!(0, $rxpl9.h).call(props, 'css')) return $faf30355a80342e4$exports.jsx(type, props, key);
    return $faf30355a80342e4$exports.jsx((0, $rxpl9.E), (0, $rxpl9.c)(type, props), key);
};
var $6bec4f26b2cb3094$export$25062201e9e25d76 = function jsxs(type, props, key) {
    if (!(0, $rxpl9.h).call(props, 'css')) return $faf30355a80342e4$exports.jsxs(type, props, key);
    return $faf30355a80342e4$exports.jsxs((0, $rxpl9.E), (0, $rxpl9.c)(type, props), key);
};




/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::db26fca19e3969bcba2e77bc6fe6eb89>>
 * @codegenCommand yarn build tokens
 */ var $31b0c47840c659bb$var$tokens = {
    'color.text': '--ds-text',
    'color.text.accent.lime': '--ds-text-accent-lime',
    'color.text.accent.lime.bolder': '--ds-text-accent-lime-bolder',
    'color.text.accent.red': '--ds-text-accent-red',
    'color.text.accent.red.bolder': '--ds-text-accent-red-bolder',
    'color.text.accent.orange': '--ds-text-accent-orange',
    'color.text.accent.orange.bolder': '--ds-text-accent-orange-bolder',
    'color.text.accent.yellow': '--ds-text-accent-yellow',
    'color.text.accent.yellow.bolder': '--ds-text-accent-yellow-bolder',
    'color.text.accent.green': '--ds-text-accent-green',
    'color.text.accent.green.bolder': '--ds-text-accent-green-bolder',
    'color.text.accent.teal': '--ds-text-accent-teal',
    'color.text.accent.teal.bolder': '--ds-text-accent-teal-bolder',
    'color.text.accent.blue': '--ds-text-accent-blue',
    'color.text.accent.blue.bolder': '--ds-text-accent-blue-bolder',
    'color.text.accent.purple': '--ds-text-accent-purple',
    'color.text.accent.purple.bolder': '--ds-text-accent-purple-bolder',
    'color.text.accent.magenta': '--ds-text-accent-magenta',
    'color.text.accent.magenta.bolder': '--ds-text-accent-magenta-bolder',
    'color.text.accent.gray': '--ds-text-accent-gray',
    'color.text.accent.gray.bolder': '--ds-text-accent-gray-bolder',
    'color.text.disabled': '--ds-text-disabled',
    'color.text.inverse': '--ds-text-inverse',
    'color.text.selected': '--ds-text-selected',
    'color.text.brand': '--ds-text-brand',
    'color.text.danger': '--ds-text-danger',
    'color.text.warning': '--ds-text-warning',
    'color.text.warning.inverse': '--ds-text-warning-inverse',
    'color.text.success': '--ds-text-success',
    'color.text.discovery': '--ds-text-discovery',
    'color.text.information': '--ds-text-information',
    'color.text.subtlest': '--ds-text-subtlest',
    'color.text.subtle': '--ds-text-subtle',
    'color.link': '--ds-link',
    'color.link.pressed': '--ds-link-pressed',
    'color.link.visited': '--ds-link-visited',
    'color.link.visited.pressed': '--ds-link-visited-pressed',
    'color.icon': '--ds-icon',
    'color.icon.accent.lime': '--ds-icon-accent-lime',
    'color.icon.accent.red': '--ds-icon-accent-red',
    'color.icon.accent.orange': '--ds-icon-accent-orange',
    'color.icon.accent.yellow': '--ds-icon-accent-yellow',
    'color.icon.accent.green': '--ds-icon-accent-green',
    'color.icon.accent.teal': '--ds-icon-accent-teal',
    'color.icon.accent.blue': '--ds-icon-accent-blue',
    'color.icon.accent.purple': '--ds-icon-accent-purple',
    'color.icon.accent.magenta': '--ds-icon-accent-magenta',
    'color.icon.accent.gray': '--ds-icon-accent-gray',
    'color.icon.disabled': '--ds-icon-disabled',
    'color.icon.inverse': '--ds-icon-inverse',
    'color.icon.selected': '--ds-icon-selected',
    'color.icon.brand': '--ds-icon-brand',
    'color.icon.danger': '--ds-icon-danger',
    'color.icon.warning': '--ds-icon-warning',
    'color.icon.warning.inverse': '--ds-icon-warning-inverse',
    'color.icon.success': '--ds-icon-success',
    'color.icon.discovery': '--ds-icon-discovery',
    'color.icon.information': '--ds-icon-information',
    'color.icon.subtlest': '--ds-icon-subtlest',
    'color.icon.subtle': '--ds-icon-subtle',
    'color.border': '--ds-border',
    'color.border.accent.lime': '--ds-border-accent-lime',
    'color.border.accent.red': '--ds-border-accent-red',
    'color.border.accent.orange': '--ds-border-accent-orange',
    'color.border.accent.yellow': '--ds-border-accent-yellow',
    'color.border.accent.green': '--ds-border-accent-green',
    'color.border.accent.teal': '--ds-border-accent-teal',
    'color.border.accent.blue': '--ds-border-accent-blue',
    'color.border.accent.purple': '--ds-border-accent-purple',
    'color.border.accent.magenta': '--ds-border-accent-magenta',
    'color.border.accent.gray': '--ds-border-accent-gray',
    'color.border.disabled': '--ds-border-disabled',
    'color.border.focused': '--ds-border-focused',
    'color.border.input': '--ds-border-input',
    'color.border.inverse': '--ds-border-inverse',
    'color.border.selected': '--ds-border-selected',
    'color.border.brand': '--ds-border-brand',
    'color.border.danger': '--ds-border-danger',
    'color.border.warning': '--ds-border-warning',
    'color.border.success': '--ds-border-success',
    'color.border.discovery': '--ds-border-discovery',
    'color.border.information': '--ds-border-information',
    'color.border.bold': '--ds-border-bold',
    'color.background.accent.lime.subtlest': '--ds-background-accent-lime-subtlest',
    'color.background.accent.lime.subtlest.hovered': '--ds-background-accent-lime-subtlest-hovered',
    'color.background.accent.lime.subtlest.pressed': '--ds-background-accent-lime-subtlest-pressed',
    'color.background.accent.lime.subtler': '--ds-background-accent-lime-subtler',
    'color.background.accent.lime.subtler.hovered': '--ds-background-accent-lime-subtler-hovered',
    'color.background.accent.lime.subtler.pressed': '--ds-background-accent-lime-subtler-pressed',
    'color.background.accent.lime.subtle': '--ds-background-accent-lime-subtle',
    'color.background.accent.lime.subtle.hovered': '--ds-background-accent-lime-subtle-hovered',
    'color.background.accent.lime.subtle.pressed': '--ds-background-accent-lime-subtle-pressed',
    'color.background.accent.lime.bolder': '--ds-background-accent-lime-bolder',
    'color.background.accent.lime.bolder.hovered': '--ds-background-accent-lime-bolder-hovered',
    'color.background.accent.lime.bolder.pressed': '--ds-background-accent-lime-bolder-pressed',
    'color.background.accent.red.subtlest': '--ds-background-accent-red-subtlest',
    'color.background.accent.red.subtlest.hovered': '--ds-background-accent-red-subtlest-hovered',
    'color.background.accent.red.subtlest.pressed': '--ds-background-accent-red-subtlest-pressed',
    'color.background.accent.red.subtler': '--ds-background-accent-red-subtler',
    'color.background.accent.red.subtler.hovered': '--ds-background-accent-red-subtler-hovered',
    'color.background.accent.red.subtler.pressed': '--ds-background-accent-red-subtler-pressed',
    'color.background.accent.red.subtle': '--ds-background-accent-red-subtle',
    'color.background.accent.red.subtle.hovered': '--ds-background-accent-red-subtle-hovered',
    'color.background.accent.red.subtle.pressed': '--ds-background-accent-red-subtle-pressed',
    'color.background.accent.red.bolder': '--ds-background-accent-red-bolder',
    'color.background.accent.red.bolder.hovered': '--ds-background-accent-red-bolder-hovered',
    'color.background.accent.red.bolder.pressed': '--ds-background-accent-red-bolder-pressed',
    'color.background.accent.orange.subtlest': '--ds-background-accent-orange-subtlest',
    'color.background.accent.orange.subtlest.hovered': '--ds-background-accent-orange-subtlest-hovered',
    'color.background.accent.orange.subtlest.pressed': '--ds-background-accent-orange-subtlest-pressed',
    'color.background.accent.orange.subtler': '--ds-background-accent-orange-subtler',
    'color.background.accent.orange.subtler.hovered': '--ds-background-accent-orange-subtler-hovered',
    'color.background.accent.orange.subtler.pressed': '--ds-background-accent-orange-subtler-pressed',
    'color.background.accent.orange.subtle': '--ds-background-accent-orange-subtle',
    'color.background.accent.orange.subtle.hovered': '--ds-background-accent-orange-subtle-hovered',
    'color.background.accent.orange.subtle.pressed': '--ds-background-accent-orange-subtle-pressed',
    'color.background.accent.orange.bolder': '--ds-background-accent-orange-bolder',
    'color.background.accent.orange.bolder.hovered': '--ds-background-accent-orange-bolder-hovered',
    'color.background.accent.orange.bolder.pressed': '--ds-background-accent-orange-bolder-pressed',
    'color.background.accent.yellow.subtlest': '--ds-background-accent-yellow-subtlest',
    'color.background.accent.yellow.subtlest.hovered': '--ds-background-accent-yellow-subtlest-hovered',
    'color.background.accent.yellow.subtlest.pressed': '--ds-background-accent-yellow-subtlest-pressed',
    'color.background.accent.yellow.subtler': '--ds-background-accent-yellow-subtler',
    'color.background.accent.yellow.subtler.hovered': '--ds-background-accent-yellow-subtler-hovered',
    'color.background.accent.yellow.subtler.pressed': '--ds-background-accent-yellow-subtler-pressed',
    'color.background.accent.yellow.subtle': '--ds-background-accent-yellow-subtle',
    'color.background.accent.yellow.subtle.hovered': '--ds-background-accent-yellow-subtle-hovered',
    'color.background.accent.yellow.subtle.pressed': '--ds-background-accent-yellow-subtle-pressed',
    'color.background.accent.yellow.bolder': '--ds-background-accent-yellow-bolder',
    'color.background.accent.yellow.bolder.hovered': '--ds-background-accent-yellow-bolder-hovered',
    'color.background.accent.yellow.bolder.pressed': '--ds-background-accent-yellow-bolder-pressed',
    'color.background.accent.green.subtlest': '--ds-background-accent-green-subtlest',
    'color.background.accent.green.subtlest.hovered': '--ds-background-accent-green-subtlest-hovered',
    'color.background.accent.green.subtlest.pressed': '--ds-background-accent-green-subtlest-pressed',
    'color.background.accent.green.subtler': '--ds-background-accent-green-subtler',
    'color.background.accent.green.subtler.hovered': '--ds-background-accent-green-subtler-hovered',
    'color.background.accent.green.subtler.pressed': '--ds-background-accent-green-subtler-pressed',
    'color.background.accent.green.subtle': '--ds-background-accent-green-subtle',
    'color.background.accent.green.subtle.hovered': '--ds-background-accent-green-subtle-hovered',
    'color.background.accent.green.subtle.pressed': '--ds-background-accent-green-subtle-pressed',
    'color.background.accent.green.bolder': '--ds-background-accent-green-bolder',
    'color.background.accent.green.bolder.hovered': '--ds-background-accent-green-bolder-hovered',
    'color.background.accent.green.bolder.pressed': '--ds-background-accent-green-bolder-pressed',
    'color.background.accent.teal.subtlest': '--ds-background-accent-teal-subtlest',
    'color.background.accent.teal.subtlest.hovered': '--ds-background-accent-teal-subtlest-hovered',
    'color.background.accent.teal.subtlest.pressed': '--ds-background-accent-teal-subtlest-pressed',
    'color.background.accent.teal.subtler': '--ds-background-accent-teal-subtler',
    'color.background.accent.teal.subtler.hovered': '--ds-background-accent-teal-subtler-hovered',
    'color.background.accent.teal.subtler.pressed': '--ds-background-accent-teal-subtler-pressed',
    'color.background.accent.teal.subtle': '--ds-background-accent-teal-subtle',
    'color.background.accent.teal.subtle.hovered': '--ds-background-accent-teal-subtle-hovered',
    'color.background.accent.teal.subtle.pressed': '--ds-background-accent-teal-subtle-pressed',
    'color.background.accent.teal.bolder': '--ds-background-accent-teal-bolder',
    'color.background.accent.teal.bolder.hovered': '--ds-background-accent-teal-bolder-hovered',
    'color.background.accent.teal.bolder.pressed': '--ds-background-accent-teal-bolder-pressed',
    'color.background.accent.blue.subtlest': '--ds-background-accent-blue-subtlest',
    'color.background.accent.blue.subtlest.hovered': '--ds-background-accent-blue-subtlest-hovered',
    'color.background.accent.blue.subtlest.pressed': '--ds-background-accent-blue-subtlest-pressed',
    'color.background.accent.blue.subtler': '--ds-background-accent-blue-subtler',
    'color.background.accent.blue.subtler.hovered': '--ds-background-accent-blue-subtler-hovered',
    'color.background.accent.blue.subtler.pressed': '--ds-background-accent-blue-subtler-pressed',
    'color.background.accent.blue.subtle': '--ds-background-accent-blue-subtle',
    'color.background.accent.blue.subtle.hovered': '--ds-background-accent-blue-subtle-hovered',
    'color.background.accent.blue.subtle.pressed': '--ds-background-accent-blue-subtle-pressed',
    'color.background.accent.blue.bolder': '--ds-background-accent-blue-bolder',
    'color.background.accent.blue.bolder.hovered': '--ds-background-accent-blue-bolder-hovered',
    'color.background.accent.blue.bolder.pressed': '--ds-background-accent-blue-bolder-pressed',
    'color.background.accent.purple.subtlest': '--ds-background-accent-purple-subtlest',
    'color.background.accent.purple.subtlest.hovered': '--ds-background-accent-purple-subtlest-hovered',
    'color.background.accent.purple.subtlest.pressed': '--ds-background-accent-purple-subtlest-pressed',
    'color.background.accent.purple.subtler': '--ds-background-accent-purple-subtler',
    'color.background.accent.purple.subtler.hovered': '--ds-background-accent-purple-subtler-hovered',
    'color.background.accent.purple.subtler.pressed': '--ds-background-accent-purple-subtler-pressed',
    'color.background.accent.purple.subtle': '--ds-background-accent-purple-subtle',
    'color.background.accent.purple.subtle.hovered': '--ds-background-accent-purple-subtle-hovered',
    'color.background.accent.purple.subtle.pressed': '--ds-background-accent-purple-subtle-pressed',
    'color.background.accent.purple.bolder': '--ds-background-accent-purple-bolder',
    'color.background.accent.purple.bolder.hovered': '--ds-background-accent-purple-bolder-hovered',
    'color.background.accent.purple.bolder.pressed': '--ds-background-accent-purple-bolder-pressed',
    'color.background.accent.magenta.subtlest': '--ds-background-accent-magenta-subtlest',
    'color.background.accent.magenta.subtlest.hovered': '--ds-background-accent-magenta-subtlest-hovered',
    'color.background.accent.magenta.subtlest.pressed': '--ds-background-accent-magenta-subtlest-pressed',
    'color.background.accent.magenta.subtler': '--ds-background-accent-magenta-subtler',
    'color.background.accent.magenta.subtler.hovered': '--ds-background-accent-magenta-subtler-hovered',
    'color.background.accent.magenta.subtler.pressed': '--ds-background-accent-magenta-subtler-pressed',
    'color.background.accent.magenta.subtle': '--ds-background-accent-magenta-subtle',
    'color.background.accent.magenta.subtle.hovered': '--ds-background-accent-magenta-subtle-hovered',
    'color.background.accent.magenta.subtle.pressed': '--ds-background-accent-magenta-subtle-pressed',
    'color.background.accent.magenta.bolder': '--ds-background-accent-magenta-bolder',
    'color.background.accent.magenta.bolder.hovered': '--ds-background-accent-magenta-bolder-hovered',
    'color.background.accent.magenta.bolder.pressed': '--ds-background-accent-magenta-bolder-pressed',
    'color.background.accent.gray.subtlest': '--ds-background-accent-gray-subtlest',
    'color.background.accent.gray.subtlest.hovered': '--ds-background-accent-gray-subtlest-hovered',
    'color.background.accent.gray.subtlest.pressed': '--ds-background-accent-gray-subtlest-pressed',
    'color.background.accent.gray.subtler': '--ds-background-accent-gray-subtler',
    'color.background.accent.gray.subtler.hovered': '--ds-background-accent-gray-subtler-hovered',
    'color.background.accent.gray.subtler.pressed': '--ds-background-accent-gray-subtler-pressed',
    'color.background.accent.gray.subtle': '--ds-background-accent-gray-subtle',
    'color.background.accent.gray.subtle.hovered': '--ds-background-accent-gray-subtle-hovered',
    'color.background.accent.gray.subtle.pressed': '--ds-background-accent-gray-subtle-pressed',
    'color.background.accent.gray.bolder': '--ds-background-accent-gray-bolder',
    'color.background.accent.gray.bolder.hovered': '--ds-background-accent-gray-bolder-hovered',
    'color.background.accent.gray.bolder.pressed': '--ds-background-accent-gray-bolder-pressed',
    'color.background.disabled': '--ds-background-disabled',
    'color.background.input': '--ds-background-input',
    'color.background.input.hovered': '--ds-background-input-hovered',
    'color.background.input.pressed': '--ds-background-input-pressed',
    'color.background.inverse.subtle': '--ds-background-inverse-subtle',
    'color.background.inverse.subtle.hovered': '--ds-background-inverse-subtle-hovered',
    'color.background.inverse.subtle.pressed': '--ds-background-inverse-subtle-pressed',
    'color.background.neutral': '--ds-background-neutral',
    'color.background.neutral.hovered': '--ds-background-neutral-hovered',
    'color.background.neutral.pressed': '--ds-background-neutral-pressed',
    'color.background.neutral.subtle': '--ds-background-neutral-subtle',
    'color.background.neutral.subtle.hovered': '--ds-background-neutral-subtle-hovered',
    'color.background.neutral.subtle.pressed': '--ds-background-neutral-subtle-pressed',
    'color.background.neutral.bold': '--ds-background-neutral-bold',
    'color.background.neutral.bold.hovered': '--ds-background-neutral-bold-hovered',
    'color.background.neutral.bold.pressed': '--ds-background-neutral-bold-pressed',
    'color.background.selected': '--ds-background-selected',
    'color.background.selected.hovered': '--ds-background-selected-hovered',
    'color.background.selected.pressed': '--ds-background-selected-pressed',
    'color.background.selected.bold': '--ds-background-selected-bold',
    'color.background.selected.bold.hovered': '--ds-background-selected-bold-hovered',
    'color.background.selected.bold.pressed': '--ds-background-selected-bold-pressed',
    'color.background.brand.subtlest': '--ds-background-brand-subtlest',
    'color.background.brand.subtlest.hovered': '--ds-background-brand-subtlest-hovered',
    'color.background.brand.subtlest.pressed': '--ds-background-brand-subtlest-pressed',
    'color.background.brand.bold': '--ds-background-brand-bold',
    'color.background.brand.bold.hovered': '--ds-background-brand-bold-hovered',
    'color.background.brand.bold.pressed': '--ds-background-brand-bold-pressed',
    'color.background.brand.boldest': '--ds-background-brand-boldest',
    'color.background.brand.boldest.hovered': '--ds-background-brand-boldest-hovered',
    'color.background.brand.boldest.pressed': '--ds-background-brand-boldest-pressed',
    'color.background.danger': '--ds-background-danger',
    'color.background.danger.hovered': '--ds-background-danger-hovered',
    'color.background.danger.pressed': '--ds-background-danger-pressed',
    'color.background.danger.bold': '--ds-background-danger-bold',
    'color.background.danger.bold.hovered': '--ds-background-danger-bold-hovered',
    'color.background.danger.bold.pressed': '--ds-background-danger-bold-pressed',
    'color.background.warning': '--ds-background-warning',
    'color.background.warning.hovered': '--ds-background-warning-hovered',
    'color.background.warning.pressed': '--ds-background-warning-pressed',
    'color.background.warning.bold': '--ds-background-warning-bold',
    'color.background.warning.bold.hovered': '--ds-background-warning-bold-hovered',
    'color.background.warning.bold.pressed': '--ds-background-warning-bold-pressed',
    'color.background.success': '--ds-background-success',
    'color.background.success.hovered': '--ds-background-success-hovered',
    'color.background.success.pressed': '--ds-background-success-pressed',
    'color.background.success.bold': '--ds-background-success-bold',
    'color.background.success.bold.hovered': '--ds-background-success-bold-hovered',
    'color.background.success.bold.pressed': '--ds-background-success-bold-pressed',
    'color.background.discovery': '--ds-background-discovery',
    'color.background.discovery.hovered': '--ds-background-discovery-hovered',
    'color.background.discovery.pressed': '--ds-background-discovery-pressed',
    'color.background.discovery.bold': '--ds-background-discovery-bold',
    'color.background.discovery.bold.hovered': '--ds-background-discovery-bold-hovered',
    'color.background.discovery.bold.pressed': '--ds-background-discovery-bold-pressed',
    'color.background.information': '--ds-background-information',
    'color.background.information.hovered': '--ds-background-information-hovered',
    'color.background.information.pressed': '--ds-background-information-pressed',
    'color.background.information.bold': '--ds-background-information-bold',
    'color.background.information.bold.hovered': '--ds-background-information-bold-hovered',
    'color.background.information.bold.pressed': '--ds-background-information-bold-pressed',
    'color.blanket': '--ds-blanket',
    'color.blanket.selected': '--ds-blanket-selected',
    'color.blanket.danger': '--ds-blanket-danger',
    'color.interaction.hovered': '--ds-interaction-hovered',
    'color.interaction.pressed': '--ds-interaction-pressed',
    'color.skeleton': '--ds-skeleton',
    'color.skeleton.subtle': '--ds-skeleton-subtle',
    'color.chart.categorical.1': '--ds-chart-categorical-1',
    'color.chart.categorical.1.hovered': '--ds-chart-categorical-1-hovered',
    'color.chart.categorical.2': '--ds-chart-categorical-2',
    'color.chart.categorical.2.hovered': '--ds-chart-categorical-2-hovered',
    'color.chart.categorical.3': '--ds-chart-categorical-3',
    'color.chart.categorical.3.hovered': '--ds-chart-categorical-3-hovered',
    'color.chart.categorical.4': '--ds-chart-categorical-4',
    'color.chart.categorical.4.hovered': '--ds-chart-categorical-4-hovered',
    'color.chart.categorical.5': '--ds-chart-categorical-5',
    'color.chart.categorical.5.hovered': '--ds-chart-categorical-5-hovered',
    'color.chart.categorical.6': '--ds-chart-categorical-6',
    'color.chart.categorical.6.hovered': '--ds-chart-categorical-6-hovered',
    'color.chart.categorical.7': '--ds-chart-categorical-7',
    'color.chart.categorical.7.hovered': '--ds-chart-categorical-7-hovered',
    'color.chart.categorical.8': '--ds-chart-categorical-8',
    'color.chart.categorical.8.hovered': '--ds-chart-categorical-8-hovered',
    'color.chart.lime.bold': '--ds-chart-lime-bold',
    'color.chart.lime.bold.hovered': '--ds-chart-lime-bold-hovered',
    'color.chart.lime.bolder': '--ds-chart-lime-bolder',
    'color.chart.lime.bolder.hovered': '--ds-chart-lime-bolder-hovered',
    'color.chart.lime.boldest': '--ds-chart-lime-boldest',
    'color.chart.lime.boldest.hovered': '--ds-chart-lime-boldest-hovered',
    'color.chart.neutral': '--ds-chart-neutral',
    'color.chart.neutral.hovered': '--ds-chart-neutral-hovered',
    'color.chart.red.bold': '--ds-chart-red-bold',
    'color.chart.red.bold.hovered': '--ds-chart-red-bold-hovered',
    'color.chart.red.bolder': '--ds-chart-red-bolder',
    'color.chart.red.bolder.hovered': '--ds-chart-red-bolder-hovered',
    'color.chart.red.boldest': '--ds-chart-red-boldest',
    'color.chart.red.boldest.hovered': '--ds-chart-red-boldest-hovered',
    'color.chart.orange.bold': '--ds-chart-orange-bold',
    'color.chart.orange.bold.hovered': '--ds-chart-orange-bold-hovered',
    'color.chart.orange.bolder': '--ds-chart-orange-bolder',
    'color.chart.orange.bolder.hovered': '--ds-chart-orange-bolder-hovered',
    'color.chart.orange.boldest': '--ds-chart-orange-boldest',
    'color.chart.orange.boldest.hovered': '--ds-chart-orange-boldest-hovered',
    'color.chart.yellow.bold': '--ds-chart-yellow-bold',
    'color.chart.yellow.bold.hovered': '--ds-chart-yellow-bold-hovered',
    'color.chart.yellow.bolder': '--ds-chart-yellow-bolder',
    'color.chart.yellow.bolder.hovered': '--ds-chart-yellow-bolder-hovered',
    'color.chart.yellow.boldest': '--ds-chart-yellow-boldest',
    'color.chart.yellow.boldest.hovered': '--ds-chart-yellow-boldest-hovered',
    'color.chart.green.bold': '--ds-chart-green-bold',
    'color.chart.green.bold.hovered': '--ds-chart-green-bold-hovered',
    'color.chart.green.bolder': '--ds-chart-green-bolder',
    'color.chart.green.bolder.hovered': '--ds-chart-green-bolder-hovered',
    'color.chart.green.boldest': '--ds-chart-green-boldest',
    'color.chart.green.boldest.hovered': '--ds-chart-green-boldest-hovered',
    'color.chart.teal.bold': '--ds-chart-teal-bold',
    'color.chart.teal.bold.hovered': '--ds-chart-teal-bold-hovered',
    'color.chart.teal.bolder': '--ds-chart-teal-bolder',
    'color.chart.teal.bolder.hovered': '--ds-chart-teal-bolder-hovered',
    'color.chart.teal.boldest': '--ds-chart-teal-boldest',
    'color.chart.teal.boldest.hovered': '--ds-chart-teal-boldest-hovered',
    'color.chart.blue.bold': '--ds-chart-blue-bold',
    'color.chart.blue.bold.hovered': '--ds-chart-blue-bold-hovered',
    'color.chart.blue.bolder': '--ds-chart-blue-bolder',
    'color.chart.blue.bolder.hovered': '--ds-chart-blue-bolder-hovered',
    'color.chart.blue.boldest': '--ds-chart-blue-boldest',
    'color.chart.blue.boldest.hovered': '--ds-chart-blue-boldest-hovered',
    'color.chart.purple.bold': '--ds-chart-purple-bold',
    'color.chart.purple.bold.hovered': '--ds-chart-purple-bold-hovered',
    'color.chart.purple.bolder': '--ds-chart-purple-bolder',
    'color.chart.purple.bolder.hovered': '--ds-chart-purple-bolder-hovered',
    'color.chart.purple.boldest': '--ds-chart-purple-boldest',
    'color.chart.purple.boldest.hovered': '--ds-chart-purple-boldest-hovered',
    'color.chart.magenta.bold': '--ds-chart-magenta-bold',
    'color.chart.magenta.bold.hovered': '--ds-chart-magenta-bold-hovered',
    'color.chart.magenta.bolder': '--ds-chart-magenta-bolder',
    'color.chart.magenta.bolder.hovered': '--ds-chart-magenta-bolder-hovered',
    'color.chart.magenta.boldest': '--ds-chart-magenta-boldest',
    'color.chart.magenta.boldest.hovered': '--ds-chart-magenta-boldest-hovered',
    'color.chart.gray.bold': '--ds-chart-gray-bold',
    'color.chart.gray.bold.hovered': '--ds-chart-gray-bold-hovered',
    'color.chart.gray.bolder': '--ds-chart-gray-bolder',
    'color.chart.gray.bolder.hovered': '--ds-chart-gray-bolder-hovered',
    'color.chart.gray.boldest': '--ds-chart-gray-boldest',
    'color.chart.gray.boldest.hovered': '--ds-chart-gray-boldest-hovered',
    'color.chart.brand': '--ds-chart-brand',
    'color.chart.brand.hovered': '--ds-chart-brand-hovered',
    'color.chart.danger': '--ds-chart-danger',
    'color.chart.danger.hovered': '--ds-chart-danger-hovered',
    'color.chart.danger.bold': '--ds-chart-danger-bold',
    'color.chart.danger.bold.hovered': '--ds-chart-danger-bold-hovered',
    'color.chart.warning': '--ds-chart-warning',
    'color.chart.warning.hovered': '--ds-chart-warning-hovered',
    'color.chart.warning.bold': '--ds-chart-warning-bold',
    'color.chart.warning.bold.hovered': '--ds-chart-warning-bold-hovered',
    'color.chart.success': '--ds-chart-success',
    'color.chart.success.hovered': '--ds-chart-success-hovered',
    'color.chart.success.bold': '--ds-chart-success-bold',
    'color.chart.success.bold.hovered': '--ds-chart-success-bold-hovered',
    'color.chart.discovery': '--ds-chart-discovery',
    'color.chart.discovery.hovered': '--ds-chart-discovery-hovered',
    'color.chart.discovery.bold': '--ds-chart-discovery-bold',
    'color.chart.discovery.bold.hovered': '--ds-chart-discovery-bold-hovered',
    'color.chart.information': '--ds-chart-information',
    'color.chart.information.hovered': '--ds-chart-information-hovered',
    'color.chart.information.bold': '--ds-chart-information-bold',
    'color.chart.information.bold.hovered': '--ds-chart-information-bold-hovered',
    'elevation.surface': '--ds-surface',
    'elevation.surface.hovered': '--ds-surface-hovered',
    'elevation.surface.pressed': '--ds-surface-pressed',
    'elevation.surface.overlay': '--ds-surface-overlay',
    'elevation.surface.overlay.hovered': '--ds-surface-overlay-hovered',
    'elevation.surface.overlay.pressed': '--ds-surface-overlay-pressed',
    'elevation.surface.raised': '--ds-surface-raised',
    'elevation.surface.raised.hovered': '--ds-surface-raised-hovered',
    'elevation.surface.raised.pressed': '--ds-surface-raised-pressed',
    'elevation.surface.sunken': '--ds-surface-sunken',
    'elevation.shadow.overflow': '--ds-shadow-overflow',
    'elevation.shadow.overflow.perimeter': '--ds-shadow-overflow-perimeter',
    'elevation.shadow.overflow.spread': '--ds-shadow-overflow-spread',
    'elevation.shadow.overlay': '--ds-shadow-overlay',
    'elevation.shadow.raised': '--ds-shadow-raised',
    'opacity.disabled': '--ds-opacity-disabled',
    'opacity.loading': '--ds-opacity-loading',
    'utility.UNSAFE.textTransformUppercase': '--ds-UNSAFE-textTransformUppercase',
    'utility.UNSAFE.transparent': '--ds-UNSAFE-transparent',
    'utility.elevation.surface.current': '--ds-elevation-surface-current',
    'border.radius.050': '--ds-border-radius-050',
    'border.radius': '--ds-border-radius',
    'border.radius.100': '--ds-border-radius-100',
    'border.radius.200': '--ds-border-radius-200',
    'border.radius.300': '--ds-border-radius-300',
    'border.radius.400': '--ds-border-radius-400',
    'border.radius.circle': '--ds-border-radius-circle',
    'border.width': '--ds-border-width',
    'border.width.0': '--ds-border-width-0',
    'border.width.indicator': '--ds-border-width-indicator',
    'border.width.outline': '--ds-border-width-outline',
    'space.0': '--ds-space-0',
    'space.025': '--ds-space-025',
    'space.050': '--ds-space-050',
    'space.075': '--ds-space-075',
    'space.100': '--ds-space-100',
    'space.150': '--ds-space-150',
    'space.200': '--ds-space-200',
    'space.250': '--ds-space-250',
    'space.300': '--ds-space-300',
    'space.400': '--ds-space-400',
    'space.500': '--ds-space-500',
    'space.600': '--ds-space-600',
    'space.800': '--ds-space-800',
    'space.1000': '--ds-space-1000',
    'space.negative.025': '--ds-space-negative-025',
    'space.negative.050': '--ds-space-negative-050',
    'space.negative.075': '--ds-space-negative-075',
    'space.negative.100': '--ds-space-negative-100',
    'space.negative.150': '--ds-space-negative-150',
    'space.negative.200': '--ds-space-negative-200',
    'space.negative.250': '--ds-space-negative-250',
    'space.negative.300': '--ds-space-negative-300',
    'space.negative.400': '--ds-space-negative-400',
    'font.letterSpacing.0': '--ds-font-letterSpacing-0',
    'font.letterSpacing.100': '--ds-font-letterSpacing-100',
    'font.letterSpacing.200': '--ds-font-letterSpacing-200',
    'font.letterSpacing.300': '--ds-font-letterSpacing-300',
    'font.letterSpacing.400': '--ds-font-letterSpacing-400',
    'font.heading.xxlarge': '--ds-font-heading-xxlarge',
    'font.heading.xlarge': '--ds-font-heading-xlarge',
    'font.heading.large': '--ds-font-heading-large',
    'font.heading.medium': '--ds-font-heading-medium',
    'font.heading.small': '--ds-font-heading-small',
    'font.heading.xsmall': '--ds-font-heading-xsmall',
    'font.heading.xxsmall': '--ds-font-heading-xxsmall',
    'font.body.large': '--ds-font-body-large',
    'font.body': '--ds-font-body',
    'font.body.small': '--ds-font-body-small',
    'font.body.UNSAFE_small': '--ds-font-body-UNSAFE_small',
    'font.code': '--ds-font-code',
    'font.weight.regular': '--ds-font-weight-regular',
    'font.weight.medium': '--ds-font-weight-medium',
    'font.weight.semibold': '--ds-font-weight-semibold',
    'font.weight.bold': '--ds-font-weight-bold',
    'font.family.heading': '--ds-font-family-heading',
    'font.family.body': '--ds-font-family-body',
    'font.family.code': '--ds-font-family-code',
    'font.family.monospace': '--ds-font-family-monospace',
    'font.family.sans': '--ds-font-family-sans',
    'font.family.brand.heading': '--ds-font-family-brand-heading',
    'font.family.brand.body': '--ds-font-family-brand-body',
    'font.size.050': '--ds-font-size-050',
    'font.size.075': '--ds-font-size-075',
    'font.size.100': '--ds-font-size-100',
    'font.size.200': '--ds-font-size-200',
    'font.size.300': '--ds-font-size-300',
    'font.size.400': '--ds-font-size-400',
    'font.size.500': '--ds-font-size-500',
    'font.size.600': '--ds-font-size-600',
    'font.lineHeight.1': '--ds-font-lineHeight-1',
    'font.lineHeight.100': '--ds-font-lineHeight-100',
    'font.lineHeight.200': '--ds-font-lineHeight-200',
    'font.lineHeight.300': '--ds-font-lineHeight-300',
    'font.lineHeight.400': '--ds-font-lineHeight-400',
    'font.lineHeight.500': '--ds-font-lineHeight-500',
    'font.lineHeight.600': '--ds-font-lineHeight-600'
};
var $31b0c47840c659bb$export$2e2bcd8739ae039 = $31b0c47840c659bb$var$tokens;


var $59e7965bd64289a3$export$4ef52930e33717cd = 'data-theme';
var $59e7965bd64289a3$export$a00eac3f8684bcd0 = 'data-color-mode';
var $59e7965bd64289a3$export$2112803007239c61 = 'data-contrast-mode';
var $59e7965bd64289a3$export$352e418ed5b6193a = 'data-custom-theme';
var $59e7965bd64289a3$export$2faeed762aac6741 = 'light';
var $59e7965bd64289a3$export$6f0c6fb8c80fcc92 = 'ds';
var $59e7965bd64289a3$export$4d0c7bbf80185957 = [
    'opacity',
    'font',
    'space',
    'border'
];
var $59e7965bd64289a3$export$dddac1532e822863 = "--".concat($59e7965bd64289a3$export$6f0c6fb8c80fcc92, "-token-not-found");
var $59e7965bd64289a3$export$9d7b58831ae93caa = "--".concat($59e7965bd64289a3$export$6f0c6fb8c80fcc92, "-elevation-surface-current");



var $3ZMUU = parcelRequire("3ZMUU");
/**
 * Takes a dot-separated token name and an optional fallback, and returns the CSS custom property for the corresponding token.
 * This should be used to implement design decisions throughout your application.
 *
 * Note: With `@atlaskit/babel-plugin-tokens`, this function can be pre-compiled and a fallback value automatically inserted.
 *
 * @param {string} path - A dot-separated token name (example: `'color.background.brand'` or `'spacing.scale.100'`).
 * @param {string} [fallback] - The fallback value that should render when token CSS is not present in your app.
 *
 * @example
 * ```
 * <div
 *   css={{
 *     backgroundColor: token('elevation.surface.raised', N0),
 *     boxShadow: token('elevation.shadow.raised', `0 20px 32px -8px ${N50A}, 0 0 1px ${N60A}`),
 *     padding: token('spacing.scale.100', '8px'),
 *     fontWeight: token('font.weight.regular', '400'),
 *   }}
 * />
 * ```
 *
 */ function $1ff81f2c5a4c494e$var$token(path, fallback) {
    var token = (0, $31b0c47840c659bb$export$2e2bcd8739ae039)[path];
    typeof $3ZMUU;
    // if the token is not found - replacing it with variable name without any value, to avoid it being undefined which would result in invalid css
    if (!token) token = (0, $59e7965bd64289a3$export$dddac1532e822863);
    var tokenCall = fallback ? "var(".concat(token, ", ").concat(fallback, ")") : "var(".concat(token, ")");
    return tokenCall;
}
var $1ff81f2c5a4c494e$export$2e2bcd8739ae039 = $1ff81f2c5a4c494e$var$token;



var $74Zh5 = parcelRequire("74Zh5");

var $5FkrB = parcelRequire("5FkrB");

var $kqp0i = parcelRequire("kqp0i");

var $iYJcE = parcelRequire("iYJcE");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");

var $eVb4V = parcelRequire("eVb4V");

var $kqp0i = parcelRequire("kqp0i");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");

var $74Zh5 = parcelRequire("74Zh5");

var $25nEq = parcelRequire("25nEq");

var $5FkrB = parcelRequire("5FkrB");

var $dLGML = parcelRequire("dLGML");

var $fC8ib = parcelRequire("fC8ib");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $kIXpt = parcelRequire("kIXpt");

var $cYPzS = parcelRequire("cYPzS");

var $lwlXp = parcelRequire("lwlXp");

var $eyuDe = parcelRequire("eyuDe");

var $25nEq = parcelRequire("25nEq");

var $ekGgq = parcelRequire("ekGgq");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $25nEq = parcelRequire("25nEq");
function $76c9b15f8f2dbc0b$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $76c9b15f8f2dbc0b$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $76c9b15f8f2dbc0b$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $76c9b15f8f2dbc0b$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $76c9b15f8f2dbc0b$export$ad4be5c2ec28cecf = function isAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $76c9b15f8f2dbc0b$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === 'AnalyticsEvent';
};
var $76c9b15f8f2dbc0b$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function AnalyticsEvent(props) {
        var _this = this;
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, AnalyticsEvent);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "_isAnalyticsEvent", true);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "clone", function() {
            // just a shallow clone, don't change sub refs unless you want to
            // affect the original's too
            var payload = $76c9b15f8f2dbc0b$var$_objectSpread({}, _this.payload);
            return new AnalyticsEvent({
                payload: payload
            });
        });
        this.payload = props.payload;
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(AnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (typeof updater === 'function') this.payload = updater(this.payload);
                if ((0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(updater) === 'object') this.payload = $76c9b15f8f2dbc0b$var$_objectSpread($76c9b15f8f2dbc0b$var$_objectSpread({}, this.payload), updater);
                return this;
            }
        }
    ]);
}();


function $259b5f12cf1e9dca$var$_callSuper(t, o, e) {
    return o = (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(o), (0, (/*@__PURE__*/$parcel$interopDefault($kIXpt)))(t, $259b5f12cf1e9dca$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(t).constructor) : o.apply(t, e));
}
function $259b5f12cf1e9dca$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($259b5f12cf1e9dca$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $259b5f12cf1e9dca$var$_superPropGet(t, o, e, r) {
    var p = (0, (/*@__PURE__*/$parcel$interopDefault($lwlXp)))((0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(1 & r ? t.prototype : t), o, e);
    return 2 & r && "function" == typeof p ? function(t) {
        return p.apply(e, t);
    } : p;
}
var $259b5f12cf1e9dca$export$35f8383928ba8d7 = function isUIAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $259b5f12cf1e9dca$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isUIAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === 'UIAnalyticsEvent';
};
var $259b5f12cf1e9dca$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_AnalyticsEvent) {
    function UIAnalyticsEvent(props) {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, UIAnalyticsEvent);
        _this = $259b5f12cf1e9dca$var$_callSuper(this, UIAnalyticsEvent, [
            props
        ]);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "_isUIAnalyticsEvent", true);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "clone", function() {
            if (_this.hasFired) return null;
            var context = (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(_this.context);
            var handlers = (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(_this.handlers);
            /**
       * A hacky "deep clone" of the object. This is limited in that it wont
       * support functions, regexs, Maps, Sets, etc, but none of those need to
       * be represented in our payload.
       */ var payload = JSON.parse(JSON.stringify(_this.payload));
            return new UIAnalyticsEvent({
                context: context,
                handlers: handlers,
                payload: payload
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "fire", function(channel) {
            if (_this.hasFired) return;
            _this.handlers.forEach(function(handler) {
                return handler(_this, channel);
            });
            _this.hasFired = true;
        });
        _this.context = props.context || [];
        _this.handlers = props.handlers || [];
        _this.hasFired = false;
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($eyuDe)))(UIAnalyticsEvent, _AnalyticsEvent);
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(UIAnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (this.hasFired) return this;
                return $259b5f12cf1e9dca$var$_superPropGet(UIAnalyticsEvent, "update", this, 3)([
                    updater
                ]);
            }
        }
    ]);
}((0, $76c9b15f8f2dbc0b$export$2e2bcd8739ae039));



var $5FkrB = parcelRequire("5FkrB");

var $iyyOp = parcelRequire("iyyOp");
var $198cc46d8348dafa$export$d1f587f82ad51c4 = function useAnalyticsContext() {
    return (0, $5FkrB.useContext)((0, $iyyOp.default));
};


function $57689e08a4ac98d0$export$5bf35293e545f20c() {
    var analyticsContext = (0, $198cc46d8348dafa$export$d1f587f82ad51c4)();
    var createAnalyticsEvent = (0, $dLGML.useCallbackOne)(function(payload) {
        return new (0, $259b5f12cf1e9dca$export$2e2bcd8739ae039)({
            context: analyticsContext.getAtlaskitAnalyticsContext(),
            handlers: analyticsContext.getAtlaskitAnalyticsEventHandlers(),
            payload: payload
        });
    }, [
        analyticsContext
    ]);
    return {
        createAnalyticsEvent: createAnalyticsEvent
    };
}



var $5FkrB = parcelRequire("5FkrB");
var $bc093c0471a9c62c$export$1d27a74659855e44 = function useTrackedRef(value) {
    var ref = (0, $5FkrB.useRef)(value);
    ref.current = value;
    return ref;
};


function $e2c415d6ac5c0326$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $e2c415d6ac5c0326$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $e2c415d6ac5c0326$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $e2c415d6ac5c0326$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $e2c415d6ac5c0326$export$a4687b0234b40e28(_ref) {
    var fn = _ref.fn, action = _ref.action, componentName = _ref.componentName, actionSubject = _ref.actionSubject, packageName = _ref.packageName, packageVersion = _ref.packageVersion, analyticsData = _ref.analyticsData;
    var _useAnalyticsEvents = (0, $57689e08a4ac98d0$export$5bf35293e545f20c)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
    // We put analyticsData and fn in a ref so that we don't need to break
    // memoization.
    // Generally these could be defined by consumers inline
    // and so we do this to avoid breaking memoization of useCallback
    var dataRef = (0, $bc093c0471a9c62c$export$1d27a74659855e44)(analyticsData);
    var fnRef = (0, $bc093c0471a9c62c$export$1d27a74659855e44)(fn);
    var handler = (0, $5FkrB.useCallback)(function(value) {
        var analyticsEvent = createAnalyticsEvent({
            action: action,
            actionSubject: actionSubject || componentName,
            attributes: {
                componentName: componentName,
                packageName: packageName,
                packageVersion: packageVersion
            }
        });
        // To avoid wrapping this component in AnalyticsContext we manually
        // push the parent context's meta data into the context.
        // Note: this new 'context'
        var context = $e2c415d6ac5c0326$var$_objectSpread({
            componentName: componentName,
            packageName: packageName,
            packageVersion: packageVersion
        }, dataRef.current);
        analyticsEvent.context.push(context);
        // fire an event on the atlaskit channel
        var clone = analyticsEvent.clone();
        if (clone) clone.fire('atlaskit');
        fnRef.current(value, analyticsEvent);
    }, [
        // These are strings and won't change
        action,
        componentName,
        actionSubject,
        packageName,
        packageVersion,
        // This function is memoized in the context
        createAnalyticsEvent,
        // these are a stable ref because of the useTrackedRef hook
        dataRef,
        fnRef
    ]);
    return handler;
}



var $eVb4V = parcelRequire("eVb4V");

var $gpUQB = parcelRequire("gpUQB");

var $eYQvF = parcelRequire("eYQvF");

var $eqVaP = parcelRequire("eqVaP");
// Reds
var $ff202c3f7afe2fd4$export$4b84fd0e2c617bd = '#FFEBE6';
var $ff202c3f7afe2fd4$export$b34b069eff244586 = '#FFBDAD';
var $ff202c3f7afe2fd4$export$be802dd0d8b57f35 = '#FF8F73';
var $ff202c3f7afe2fd4$export$60847d42f9da92a6 = '#FF7452';
var $ff202c3f7afe2fd4$export$4a7404f376229999 = '#FF5630';
var $ff202c3f7afe2fd4$export$2010d0fb4295b346 = '#DE350B';
var $ff202c3f7afe2fd4$export$2837b5a1a71d5c02 = '#BF2600';
var $ff202c3f7afe2fd4$export$8d9596b529bbb9cf = '#FFFAE6';
var $ff202c3f7afe2fd4$export$41060a744ab0b7ae = '#FFF0B3';
var $ff202c3f7afe2fd4$export$1cc05bbbf340e559 = '#FFE380';
var $ff202c3f7afe2fd4$export$5aae31392d72caaa = '#FFC400';
var $ff202c3f7afe2fd4$export$c6930421db9fa514 = '#FFAB00';
var $ff202c3f7afe2fd4$export$59619663aa6500fb = '#FF991F';
var $ff202c3f7afe2fd4$export$874739ea9e379ab6 = '#FF8B00';
var $ff202c3f7afe2fd4$export$8a6341c32b6a3ee6 = '#E3FCEF';
var $ff202c3f7afe2fd4$export$69a3bf21b9686c2b = '#ABF5D1';
var $ff202c3f7afe2fd4$export$afbce1382ec95f73 = '#79F2C0';
var $ff202c3f7afe2fd4$export$747d86715d4175de = '#57D9A3';
var $ff202c3f7afe2fd4$export$940e1f69e873f202 = '#36B37E';
var $ff202c3f7afe2fd4$export$a49394138f7b8e85 = '#00875A';
var $ff202c3f7afe2fd4$export$6fa04827ac68a4fb = '#006644';
var $ff202c3f7afe2fd4$export$226de0355ed012f8 = '#DEEBFF';
var $ff202c3f7afe2fd4$export$8c13c2ee36917869 = '#B3D4FF';
var $ff202c3f7afe2fd4$export$ecfc1dff386a3e7a = '#4C9AFF';
var $ff202c3f7afe2fd4$export$215b7063051591f1 = '#2684FF';
var $ff202c3f7afe2fd4$export$e62e8919cca44969 = '#0065FF';
var $ff202c3f7afe2fd4$export$b3de0ae08da2ce64 = '#0052CC';
var $ff202c3f7afe2fd4$export$a6ee3d71bc067634 = '#0747A6';
var $ff202c3f7afe2fd4$export$67f15409e87642a1 = '#669DF1';
var $ff202c3f7afe2fd4$export$f0539dbc42dbb067 = '#8FB8F6';
var $ff202c3f7afe2fd4$export$363e4475840015bb = '#EAE6FF';
var $ff202c3f7afe2fd4$export$4b0a4417ed59760f = '#C0B6F2';
var $ff202c3f7afe2fd4$export$6011520a64d9a187 = '#998DD9';
var $ff202c3f7afe2fd4$export$a7175d4e9206bc80 = '#8777D9';
var $ff202c3f7afe2fd4$export$b48405b95304b5a1 = '#6554C0';
var $ff202c3f7afe2fd4$export$c71e4279dd54a18d = '#5243AA';
var $ff202c3f7afe2fd4$export$147899de772240ec = '#403294';
var $ff202c3f7afe2fd4$export$2cf711fe14c66f06 = '#E6FCFF';
var $ff202c3f7afe2fd4$export$7a8f4d33f6f9772c = '#B3F5FF';
var $ff202c3f7afe2fd4$export$776c9c497ef08533 = '#79E2F2';
var $ff202c3f7afe2fd4$export$69cb3ca10c1e330e = '#00C7E6';
var $ff202c3f7afe2fd4$export$9dc1ef0f3f48059b = '#00B8D9';
var $ff202c3f7afe2fd4$export$7c835c78b6fcdef8 = '#00A3BF';
var $ff202c3f7afe2fd4$export$6036577f95c3877e = '#008DA6';
var $ff202c3f7afe2fd4$export$29a4f05edc054374 = '#FFFFFF';
var $ff202c3f7afe2fd4$export$e655ef011c4aa1a2 = '#FAFBFC';
var $ff202c3f7afe2fd4$export$9fdfb749e33cdf97 = '#F4F5F7';
var $ff202c3f7afe2fd4$export$3e51e8f1440314ba = '#EBECF0';
var $ff202c3f7afe2fd4$export$1ce2d1575d444ceb = '#DFE1E6';
var $ff202c3f7afe2fd4$export$8754fc7e6d8b3000 = '#C1C7D0';
var $ff202c3f7afe2fd4$export$c2e91cbeada39b8b = '#B3BAC5';
var $ff202c3f7afe2fd4$export$5f71e19f3a7ad9de = '#A5ADBA';
var $ff202c3f7afe2fd4$export$eaa8c8a70ac22806 = '#97A0AF';
var $ff202c3f7afe2fd4$export$7c87d337fb91a97d = '#8993A4';
var $ff202c3f7afe2fd4$export$d6447c357493214f = '#7A869A';
var $ff202c3f7afe2fd4$export$f563ee71e9ee74cd = '#6B778C';
var $ff202c3f7afe2fd4$export$e2ef2124cf4024b1 = '#5E6C84';
var $ff202c3f7afe2fd4$export$eece5f492e429f08 = '#505F79';
var $ff202c3f7afe2fd4$export$c39c0fe0f26207ae = '#42526E';
var $ff202c3f7afe2fd4$export$7090862dc3038a9f = '#344563';
var $ff202c3f7afe2fd4$export$ad0bacf983b7ddaa = '#253858';
var $ff202c3f7afe2fd4$export$7d61b15e0da132af = '#172B4D';
var $ff202c3f7afe2fd4$export$fbda843f0a27fe96 = '#091E42';
var $ff202c3f7afe2fd4$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
var $ff202c3f7afe2fd4$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
var $ff202c3f7afe2fd4$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
var $ff202c3f7afe2fd4$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
var $ff202c3f7afe2fd4$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
var $ff202c3f7afe2fd4$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
var $ff202c3f7afe2fd4$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
var $ff202c3f7afe2fd4$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
var $ff202c3f7afe2fd4$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
var $ff202c3f7afe2fd4$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
var $ff202c3f7afe2fd4$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
var $ff202c3f7afe2fd4$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
var $ff202c3f7afe2fd4$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
var $ff202c3f7afe2fd4$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
var $ff202c3f7afe2fd4$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
var $ff202c3f7afe2fd4$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
var $ff202c3f7afe2fd4$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
var $ff202c3f7afe2fd4$export$2f6319cf7d736c2a = '#E6EDFA';
var $ff202c3f7afe2fd4$export$95126bc8884d6634 = '#DCE5F5';
var $ff202c3f7afe2fd4$export$8338d8c35d44ff1 = '#CED9EB';
var $ff202c3f7afe2fd4$export$5368d76ae4fbbda7 = '#B8C7E0';
var $ff202c3f7afe2fd4$export$9f0a771d16ec8d36 = '#ABBBD6';
var $ff202c3f7afe2fd4$export$abcf8c38338b4aa5 = '#9FB0CC';
var $ff202c3f7afe2fd4$export$97e81faa16a182c7 = '#8C9CB8';
var $ff202c3f7afe2fd4$export$bfe21c59123ecf33 = '#7988A3';
var $ff202c3f7afe2fd4$export$ee82aa2ea6a1558 = '#67758F';
var $ff202c3f7afe2fd4$export$682927c6ed76be02 = '#56637A';
var $ff202c3f7afe2fd4$export$91fd9994c5be9757 = '#455166';
var $ff202c3f7afe2fd4$export$d281fbfe3cff2df6 = '#3B475C';
var $ff202c3f7afe2fd4$export$3902c91d8b98a753 = '#313D52';
var $ff202c3f7afe2fd4$export$8e8133c1ba5845b5 = '#283447';
var $ff202c3f7afe2fd4$export$33ff357f6620b39 = '#202B3D';
var $ff202c3f7afe2fd4$export$633847cf062b69e0 = '#1B2638';
var $ff202c3f7afe2fd4$export$9776a6e503bdbf76 = '#121A29';
var $ff202c3f7afe2fd4$export$6c813d5160dff5db = '#0E1624';
var $ff202c3f7afe2fd4$export$3d4f271a500072a = '#0D1424';
var $ff202c3f7afe2fd4$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
var $ff202c3f7afe2fd4$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
var $ff202c3f7afe2fd4$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
var $ff202c3f7afe2fd4$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
var $ff202c3f7afe2fd4$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
var $ff202c3f7afe2fd4$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
var $ff202c3f7afe2fd4$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
var $ff202c3f7afe2fd4$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
var $ff202c3f7afe2fd4$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
var $ff202c3f7afe2fd4$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
var $ff202c3f7afe2fd4$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
var $ff202c3f7afe2fd4$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
var $ff202c3f7afe2fd4$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
var $ff202c3f7afe2fd4$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
var $ff202c3f7afe2fd4$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
var $ff202c3f7afe2fd4$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
var $ff202c3f7afe2fd4$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';
var $ff202c3f7afe2fd4$export$d2adc5dedf09fced = '#292A2E';
var $ff202c3f7afe2fd4$export$f51762073d2bb381 = '#94C748';
var $ff202c3f7afe2fd4$export$95e26d54def96891 = '#B3DF72';


function $e347e1889cb6b8cb$var$abort(event) {
    event.preventDefault();
    event.stopPropagation();
}
var $e347e1889cb6b8cb$var$tabKeyCode = 9;
function $e347e1889cb6b8cb$var$onKey(event) {
    // Allowing tab so that a user can move focus away
    if (event.keyCode === $e347e1889cb6b8cb$var$tabKeyCode) return;
    $e347e1889cb6b8cb$var$abort(event);
}
var $e347e1889cb6b8cb$var$block = {
    onMouseDownCapture: $e347e1889cb6b8cb$var$abort,
    onMouseUpCapture: $e347e1889cb6b8cb$var$abort,
    // because we have tabIndex = -1 when disabled,
    // keyboard events can only occur when there is an overlay
    onKeyDownCapture: $e347e1889cb6b8cb$var$onKey,
    onKeyUpCapture: $e347e1889cb6b8cb$var$onKey,
    onTouchStartCapture: $e347e1889cb6b8cb$var$abort,
    onTouchEndCapture: $e347e1889cb6b8cb$var$abort,
    onPointerDownCapture: $e347e1889cb6b8cb$var$abort,
    onPointerUpCapture: $e347e1889cb6b8cb$var$abort,
    onClickCapture: $e347e1889cb6b8cb$var$abort,
    // Just smashing the existing onClick for good measure
    onClick: $e347e1889cb6b8cb$var$abort
};
var $e347e1889cb6b8cb$var$doNotBlock = {};
function $e347e1889cb6b8cb$export$2e2bcd8739ae039(_ref) {
    var isInteractive = _ref.isInteractive;
    return isInteractive ? $e347e1889cb6b8cb$var$doNotBlock : $e347e1889cb6b8cb$var$block;
}



var $25nEq = parcelRequire("25nEq");

var $74Zh5 = parcelRequire("74Zh5");

var $dU8Y3 = parcelRequire("dU8Y3");
function $d23014872ae5fd6e$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $d23014872ae5fd6e$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $d23014872ae5fd6e$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $d23014872ae5fd6e$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $d23014872ae5fd6e$var$gridSize = 8;
var $d23014872ae5fd6e$var$HAS_DISABLED_BACKGROUND = [
    'default',
    'primary',
    'danger',
    'warning'
];
// ## Button layout
//
// /------------------------------------------------------------------------------------------------------------------\
// |       →  |  ←      |          |      →  |  ←      |           |      →  |  ←      |         |      →  |  ←       |
// |  10px →  |  ← 2px  |   icon   |  2px →  |  ← 2px  |           |  2px →  |  ← 2px  |  icon   |  2px →  |  ← 10px  |
// |  padding |  margin |  before  |  margin |  margin |  content  |  margin |  margin |  after  |  margin |  padding |
// |    (12px total)    |          |    (4px total)    |           |    (4px total)    |         |    (12px total)    |
// |       →  |  ←      |          |      →  |  ←      |           |      →  |  ←      |         |      →  |  ←       |
// \------------------------------------------------------------------------------------------------------------------/
//                                           ↑                               ↑
//                                        Margins don't collapse with inline-flex
//
var $d23014872ae5fd6e$var$heights = {
    default: "".concat(32 / 14, "em"),
    // 32px
    compact: "".concat(24 / 14, "em"),
    none: 'auto'
};
var $d23014872ae5fd6e$var$lineHeights = {
    default: $d23014872ae5fd6e$var$heights.default,
    compact: $d23014872ae5fd6e$var$heights.compact,
    none: 'inherit'
};
var $d23014872ae5fd6e$var$padding = {
    // 10px gutter
    default: "0 ".concat($d23014872ae5fd6e$var$gridSize + $d23014872ae5fd6e$var$gridSize / 4, "px"),
    compact: "0 ".concat($d23014872ae5fd6e$var$gridSize + $d23014872ae5fd6e$var$gridSize / 4, "px"),
    none: '0'
};
var $d23014872ae5fd6e$var$singleIconPadding = {
    // 2px gutter
    compact: "0 ".concat($d23014872ae5fd6e$var$gridSize / 4, "px"),
    default: "0 ".concat($d23014872ae5fd6e$var$gridSize / 4, "px"),
    none: '0'
};
var $d23014872ae5fd6e$var$verticalAlign = {
    default: 'middle',
    compact: 'middle',
    none: 'baseline'
};
var $d23014872ae5fd6e$var$innerMargin = {
    content: "0 ".concat($d23014872ae5fd6e$var$gridSize / 4, "px"),
    icon: "0 ".concat($d23014872ae5fd6e$var$gridSize / 4, "px")
};
var $d23014872ae5fd6e$var$defaultAfterStyles = {
    borderRadius: 'inherit',
    inset: "var(--ds-space-0, 0px)",
    borderStyle: 'solid',
    borderWidth: "var(--ds-border-width, 1px)",
    pointerEvents: 'none',
    position: 'absolute'
};
var $d23014872ae5fd6e$var$defaultStyles = {
    background: "var(--ds-background-neutral-subtle, #00000000)",
    color: "var(--ds-text, #292A2E)",
    '&::after': $d23014872ae5fd6e$var$_objectSpread($d23014872ae5fd6e$var$_objectSpread({}, $d23014872ae5fd6e$var$defaultAfterStyles), {}, {
        content: '""',
        borderColor: "var(--ds-border, #0B120E24)"
    }),
    '&:hover': {
        background: "var(--ds-background-neutral-hovered, #0B120E24)"
    },
    '&:active': {
        background: "var(--ds-background-neutral-pressed, #080F214A)"
    },
    '&[data-has-overlay="true"]:not([disabled]):hover': {
        background: "var(--ds-background-neutral-subtle, #00000000)"
    },
    '&:disabled[disabled]': {
        background: "var(--ds-background-neutral-subtle, #00000000)"
    },
    '&:disabled[disabled]:hover': {
        background: "var(--ds-background-neutral-subtle, #00000000)"
    },
    '&:disabled[disabled]:active': {
        background: "var(--ds-background-neutral-subtle, #00000000)"
    }
};
var $d23014872ae5fd6e$var$primaryStyles = {
    background: "var(--ds-background-brand-bold, #1868DB)",
    color: "var(--ds-text-inverse, #FFFFFF)",
    '&:hover': {
        background: "var(--ds-background-brand-bold-hovered, #1558BC)"
    },
    '&:active': {
        background: "var(--ds-background-brand-bold-pressed, #144794)"
    },
    '&[data-has-overlay="true"]:not([disabled]):hover': {
        background: "var(--ds-background-brand-bold, #1868DB)"
    }
};
var $d23014872ae5fd6e$var$linkStyles = {
    background: 'transparent',
    color: "var(--ds-link, #1868DB)",
    '&:hover': {
        color: "var(--ds-link, #1868DB)",
        textDecoration: 'underline'
    },
    '&:active': {
        color: "var(--ds-link-pressed, #1558BC)",
        textDecoration: 'underline'
    }
};
var $d23014872ae5fd6e$var$subtleStyles = {
    background: 'transparent',
    color: "var(--ds-text-subtle, #505258)",
    '&:hover': {
        background: "var(--ds-background-neutral-subtle-hovered, #0515240F)"
    },
    '&:active': {
        background: "var(--ds-background-neutral-subtle-pressed, #0B120E24)"
    },
    '&[data-has-overlay="true"]:not([disabled]):hover': {
        background: 'transparent'
    }
};
var $d23014872ae5fd6e$var$subtleLinkStyles = {
    background: 'transparent',
    color: "var(--ds-text-subtle, #505258)",
    '&:hover': {
        background: 'transparent',
        color: "var(--ds-text-subtle, #505258)",
        textDecoration: 'underline'
    },
    '&:active': {
        background: 'transparent',
        color: "var(--ds-text, #292A2E)",
        textDecoration: 'underline'
    }
};
var $d23014872ae5fd6e$var$warningStyles = {
    background: "var(--ds-background-warning-bold, #FBC828)",
    color: "var(--ds-text-warning-inverse, #292A2E)",
    '&:hover': {
        background: "var(--ds-background-warning-bold-hovered, #FCA700)"
    },
    '&:active': {
        background: "var(--ds-background-warning-bold-pressed, #F68909)"
    },
    '&[data-has-overlay="true"]:not([disabled]):hover': {
        background: "var(--ds-background-warning-bold, #FBC828)"
    }
};
var $d23014872ae5fd6e$var$dangerStyles = {
    background: "var(--ds-background-danger-bold, #C9372C)",
    color: "var(--ds-text-inverse, #FFFFFF)",
    '&:hover': {
        background: "var(--ds-background-danger-bold-hovered, #AE2E24)"
    },
    '&:active': {
        background: "var(--ds-background-danger-bold-pressed, #872821)"
    },
    '&[data-has-overlay="true"]:not([disabled]):hover': {
        background: "var(--ds-background-danger-bold, #C9372C)"
    }
};
var $d23014872ae5fd6e$var$selectedStyles = {
    background: "var(--ds-background-selected, #E9F2FE)",
    color: "var(--ds-text-selected, #1868DB)",
    '&:not([disabled])::after': $d23014872ae5fd6e$var$_objectSpread($d23014872ae5fd6e$var$_objectSpread({}, $d23014872ae5fd6e$var$defaultAfterStyles), {}, {
        content: '""',
        borderColor: "var(--ds-border-selected, #1868DB)"
    })
};
var $d23014872ae5fd6e$var$hasOverlayStyles = {
    '&[data-has-overlay="true"]': {
        cursor: 'default',
        textDecoration: 'none'
    }
};
function $d23014872ae5fd6e$export$955358618f994a11(_ref) {
    var appearance = _ref.appearance, spacing = _ref.spacing, isSelected = _ref.isSelected, shouldFitContainer = _ref.shouldFitContainer, isOnlySingleIcon = _ref.isOnlySingleIcon;
    return $d23014872ae5fd6e$var$_objectSpread($d23014872ae5fd6e$var$_objectSpread({
        // 0px margin added to css-reset
        alignItems: 'baseline',
        borderWidth: 0,
        borderRadius: (0, $dU8Y3.fg)('platform-dst-shape-theme-default') ? "var(--ds-radius-medium, 6px)" : "var(--ds-radius-small, 3px)",
        boxSizing: 'border-box',
        display: 'inline-flex',
        fontSize: 'inherit',
        fontStyle: 'normal',
        // Chrome recently changed button so that they use 'arial' as the font family
        fontFamily: 'inherit',
        fontWeight: "var(--ds-font-weight-medium, 500)",
        // margin for button has been applied to css reset
        maxWidth: '100%',
        // Needed to position overlay
        position: 'relative',
        textAlign: 'center',
        textDecoration: 'none',
        transition: 'background 0.1s ease-out, box-shadow 0.15s cubic-bezier(0.47, 0.03, 0.49, 1.38)',
        whiteSpace: 'nowrap',
        cursor: 'pointer',
        height: $d23014872ae5fd6e$var$heights[spacing],
        lineHeight: $d23014872ae5fd6e$var$lineHeights[spacing],
        padding: isOnlySingleIcon ? $d23014872ae5fd6e$var$singleIconPadding[spacing] : $d23014872ae5fd6e$var$padding[spacing],
        verticalAlign: $d23014872ae5fd6e$var$verticalAlign[spacing],
        width: shouldFitContainer ? '100%' : 'auto',
        // justifyContent required for shouldFitContainer buttons with an icon inside
        justifyContent: 'center'
    }, isSelected ? $d23014872ae5fd6e$var$selectedStyles : $d23014872ae5fd6e$var$_objectSpread($d23014872ae5fd6e$var$_objectSpread($d23014872ae5fd6e$var$_objectSpread($d23014872ae5fd6e$var$_objectSpread($d23014872ae5fd6e$var$_objectSpread($d23014872ae5fd6e$var$_objectSpread($d23014872ae5fd6e$var$_objectSpread($d23014872ae5fd6e$var$_objectSpread({}, appearance === 'default' && $d23014872ae5fd6e$var$defaultStyles), appearance === 'primary' && $d23014872ae5fd6e$var$primaryStyles), appearance === 'link' && $d23014872ae5fd6e$var$linkStyles), appearance === 'subtle' && $d23014872ae5fd6e$var$subtleStyles), appearance === 'subtle-link' && $d23014872ae5fd6e$var$subtleLinkStyles), appearance === 'warning' && $d23014872ae5fd6e$var$warningStyles), appearance === 'danger' && $d23014872ae5fd6e$var$dangerStyles), {}, {
        '&[disabled]': {
            color: "var(--ds-text-disabled, #080F214A)",
            backgroundColor: $d23014872ae5fd6e$var$HAS_DISABLED_BACKGROUND.includes(appearance) ? "var(--ds-background-disabled, #17171708)" : 'transparent',
            cursor: 'not-allowed',
            textDecoration: 'none',
            '&:hovered': {
                backgroundColor: $d23014872ae5fd6e$var$HAS_DISABLED_BACKGROUND.includes(appearance) ? "var(--ds-background-disabled, #17171708)" : 'transparent'
            },
            '&:active': {
                backgroundColor: $d23014872ae5fd6e$var$HAS_DISABLED_BACKGROUND.includes(appearance) ? "var(--ds-background-disabled, #17171708)" : 'transparent'
            }
        }
    }, $d23014872ae5fd6e$var$hasOverlayStyles)), {}, {
        '&::-moz-focus-inner': {
            border: 0,
            margin: 0,
            padding: 0
        }
    });
}
function $d23014872ae5fd6e$export$864eea3f4ec3368f(_ref2) {
    var spacing = _ref2.spacing;
    return (0, $74Zh5.css)({
        display: 'flex',
        // icon size cannot grow and shrink
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        margin: spacing === 'none' ? 0 : $d23014872ae5fd6e$var$innerMargin.icon,
        flexGrow: 0,
        flexShrink: 0,
        alignSelf: 'center',
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        fontSize: 0,
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        lineHeight: 0,
        userSelect: 'none'
    });
}
function $d23014872ae5fd6e$export$7ad0316cc0dd65a(_ref3) {
    var spacing = _ref3.spacing;
    return (0, $74Zh5.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        margin: spacing === 'none' ? 0 : $d23014872ae5fd6e$var$innerMargin.content,
        // content can grow and shrink
        flexGrow: 1,
        flexShrink: 1,
        // ellipsis for overflow text
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap'
    });
}
function $d23014872ae5fd6e$export$1b5827d324e945b1(_ref4) {
    var hasOverlay = _ref4.hasOverlay;
    return (0, $74Zh5.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        opacity: hasOverlay ? 0 : 1,
        transition: 'opacity 0.3s'
    });
}
var $d23014872ae5fd6e$export$1a9fe1b84c876bb5 = {
    // stretching to full width / height of button
    // this is important as we need it to still block
    // event if clicking in the button's own padding
    position: 'absolute',
    left: 0,
    top: 0,
    right: 0,
    bottom: 0,
    // Putting all children in the center
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
};



var $5FkrB = parcelRequire("5FkrB");
/* visually-hidden.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");
var $e3573d3717f44b5e$var$visuallyHiddenStyles = null;
/**
 * __Visually hidden__
 *
 * A composable element to apply a visually hidden effect to children.
 * Useful for accessibility compliance.
 *
 * @example
 * ```jsx
 * import VisuallyHidden from '@atlaskit/visually-hidden';
 *
 * export default () => (
 *   <div style={{ border: '1px solid black' }}>
 *      There is text hidden between the brackets [
 *      <VisuallyHidden>Can't see me!</VisuallyHidden>]
 *   </div>
 * );
 * ```
 */ var $e3573d3717f44b5e$var$VisuallyHidden = function VisuallyHidden(_ref) {
    var children = _ref.children, testId = _ref.testId, role = _ref.role, id = _ref.id;
    return /*#__PURE__*/ $5FkrB.createElement("span", {
        id: id,
        "data-testid": testId,
        role: role,
        className: (0, $970q7.default)([
            "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19itidpf _1reo15vq _18m915vq _1bsbt94y _4t3it94y _kqswstnw _ogto7mnp _uiztglyw _o5721q9c"
        ])
    }, children);
};
var $e3573d3717f44b5e$export$2e2bcd8739ae039 = $e3573d3717f44b5e$var$VisuallyHidden;


var $27c271557a878882$export$20bbd2efb0d734c4 = function getIfVisuallyHiddenChildren(children) {
    return children && /*#__PURE__*/ (0, $5FkrB.isValidElement)(children) && children.type === (0, $e3573d3717f44b5e$export$2e2bcd8739ae039);
};


var $f4d0d83b41e20f96$var$_excluded = [
    "analyticsContext",
    "appearance",
    "autoFocus",
    "buttonCss",
    "children",
    "className",
    "href",
    "component",
    "iconAfter",
    "iconBefore",
    "interactionName",
    "isDisabled",
    "isSelected",
    "onBlur",
    "onClick",
    "onFocus",
    "onMouseDown",
    "overlay",
    "shouldFitContainer",
    "spacing",
    "tabIndex",
    "type",
    "testId"
];
// Disabled buttons will still publish events for nested elements in webkit.
// We are disabling pointer events on child elements so that
// the button will always be the target of events
// Note: firefox does not have this behaviour for child elements
var $f4d0d83b41e20f96$var$noPointerEventsOnChildrenCss = {
    '> *': {
        pointerEvents: 'none'
    }
};
/**
 * These CSS variables consumed by the new icons, to allow them to have appropriate
 * padding inside Button while also maintaining spacing for the existing icons.
 *
 * These styles can be removed once the new icons are fully rolled out, feature flag
 * platform-visual-refresh-icons is cleaned up,
 * and we bump Button to set padding based on the new icons.
 */ var $f4d0d83b41e20f96$var$iconBeforeSpacingFixStyle = (0, $74Zh5.css)({
    '--ds--button--new-icon-padding-end': "var(--ds-space-025, 2px)",
    '--ds--button--new-icon-padding-start': "var(--ds-space-050, 4px)",
    marginInlineStart: "var(--ds-space-negative-025, -2px)"
});
var $f4d0d83b41e20f96$var$iconAfterSpacingFixStyle = (0, $74Zh5.css)({
    '--ds--button--new-icon-padding-end': "var(--ds-space-050, 4px)",
    '--ds--button--new-icon-padding-start': "var(--ds-space-025, 2px)",
    marginInlineEnd: "var(--ds-space-negative-025, -2px)"
});
var $f4d0d83b41e20f96$var$getSpacingFix = function getSpacingFix(children, spacingStyles) {
    if (!children || (0, $27c271557a878882$export$20bbd2efb0d734c4)(children)) return null;
    return spacingStyles;
};
var $f4d0d83b41e20f96$var$getChildren = function getChildren(children, childrenStyles) {
    if ((0, $27c271557a878882$export$20bbd2efb0d734c4)(children)) return children;
    return children ? (0, $74Zh5.jsx)("span", {
        css: childrenStyles
    }, children) : null;
};
var $f4d0d83b41e20f96$var$ButtonBase = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).forwardRef(function ButtonBase(props, ref) {
    var analyticsContext = props.analyticsContext, _props$appearance = props.appearance, appearance = _props$appearance === void 0 ? 'default' : _props$appearance, _props$autoFocus = props.autoFocus, autoFocus = _props$autoFocus === void 0 ? false : _props$autoFocus, buttonCss = props.buttonCss, children = props.children, className = props.className, href = props.href, _props$component = props.component, Component = _props$component === void 0 ? href ? 'a' : 'button' : _props$component, iconAfter = props.iconAfter, iconBefore = props.iconBefore, interactionName = props.interactionName, _props$isDisabled = props.isDisabled, isDisabled = _props$isDisabled === void 0 ? false : _props$isDisabled, _props$isSelected = props.isSelected, isSelected = _props$isSelected === void 0 ? false : _props$isSelected, onBlur = props.onBlur, _props$onClick = props.onClick, providedOnClick = _props$onClick === void 0 ? (0, $eVb4V.default) : _props$onClick, onFocus = props.onFocus, _props$onMouseDown = props.onMouseDown, providedOnMouseDown = _props$onMouseDown === void 0 ? (0, $eVb4V.default) : _props$onMouseDown, overlay = props.overlay, shouldFitContainer = props.shouldFitContainer, _props$spacing = props.spacing, spacing = _props$spacing === void 0 ? 'default' : _props$spacing, _props$tabIndex = props.tabIndex, tabIndex = _props$tabIndex === void 0 ? 0 : _props$tabIndex, _props$type = props.type, type = _props$type === void 0 ? !href ? 'button' : undefined : _props$type, testId = props.testId, rest = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(props, $f4d0d83b41e20f96$var$_excluded);
    var ourRef = (0, $5FkrB.useRef)();
    var setRef = (0, $5FkrB.useCallback)(function(node) {
        ourRef.current = node;
        if (ref == null) return;
        if (typeof ref === 'function') {
            ref(node);
            return;
        }
        // We can write to ref's `current` property, but Typescript does not like it.
        // @ts-ignore
        ref.current = node;
    }, [
        ourRef,
        ref
    ]);
    // Cross browser auto focusing is pretty broken, so we are doing it ourselves
    (0, $gpUQB.default)(ourRef, autoFocus);
    var interactionContext = (0, $5FkrB.useContext)((0, $eqVaP.default));
    var handleClick = (0, $5FkrB.useCallback)(function(e, analyticsEvent) {
        interactionContext && interactionContext.tracePress(interactionName, e.timeStamp);
        providedOnClick(e, analyticsEvent);
    }, [
        providedOnClick,
        interactionContext,
        interactionName
    ]);
    var onClick = (0, $e2c415d6ac5c0326$export$a4687b0234b40e28)({
        fn: handleClick,
        action: 'clicked',
        componentName: 'button',
        packageName: "@atlaskit/button",
        packageVersion: "0.0.0-development",
        analyticsData: analyticsContext
    });
    // Button currently calls preventDefault, which is not standard button behaviour
    var onMouseDown = (0, $5FkrB.useCallback)(function(event) {
        event.preventDefault();
        providedOnMouseDown(event);
    }, [
        providedOnMouseDown
    ]);
    // Lose focus when becoming disabled (standard button behaviour)
    (0, $5FkrB.useEffect)(function() {
        var el = ourRef.current;
        if (isDisabled && el && el === document.activeElement) el.blur();
    }, [
        isDisabled
    ]);
    // we are 'disabling' input with a button when there is an overlay
    var hasOverlay = Boolean(overlay);
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    var fadeStyles = (0, $74Zh5.css)((0, $d23014872ae5fd6e$export$1b5827d324e945b1)({
        hasOverlay: hasOverlay
    }));
    var isInteractive = !isDisabled && !hasOverlay;
    /**
   * HACK: Spinner needs to have different colours in the "new" tokens design compared to the old design.
   * For now, while we support both, these styles reach into Spinner when a theme is set, applies the right color.
   * Ticket to remove: https://product-fabric.atlassian.net/browse/DSP-2067.
   */ var spinnerHackCss = {};
    if (isSelected || isDisabled || appearance === 'warning') spinnerHackCss = {
        '[data-theme] & circle': {
            stroke: "".concat(isSelected || isDisabled ? "var(--ds-icon-subtle, ".concat((0, $ff202c3f7afe2fd4$export$c39c0fe0f26207ae), ")") : "var(--ds-icon-warning-inverse, ".concat((0, $ff202c3f7afe2fd4$export$c39c0fe0f26207ae), ")"), " !important")
        }
    };
    return (0, $74Zh5.jsx)((0, $eYQvF.default), null, (0, $74Zh5.jsx)(Component, (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, rest, {
        ref: setRef,
        className: className,
        css: [
            buttonCss,
            isInteractive ? null : $f4d0d83b41e20f96$var$noPointerEventsOnChildrenCss
        ],
        "data-has-overlay": hasOverlay ? true : undefined,
        "data-testid": testId,
        disabled: isDisabled,
        href: isInteractive ? href : undefined,
        onBlur: onBlur,
        onClick: onClick,
        onFocus: onFocus,
        onMouseDown: onMouseDown,
        tabIndex: isDisabled ? -1 : tabIndex,
        type: type
    }, (0, $e347e1889cb6b8cb$export$2e2bcd8739ae039)({
        isInteractive: isInteractive
    })), iconBefore ? (0, $74Zh5.jsx)("span", {
        css: [
            fadeStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $d23014872ae5fd6e$export$864eea3f4ec3368f)({
                spacing: spacing
            }),
            $f4d0d83b41e20f96$var$getSpacingFix(children, $f4d0d83b41e20f96$var$iconBeforeSpacingFixStyle)
        ]
    }, iconBefore) : null, $f4d0d83b41e20f96$var$getChildren(children, [
        fadeStyles,
        (0, $d23014872ae5fd6e$export$7ad0316cc0dd65a)({
            spacing: spacing
        })
    ]), iconAfter ? (0, $74Zh5.jsx)("span", {
        css: [
            fadeStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $d23014872ae5fd6e$export$864eea3f4ec3368f)({
                spacing: spacing
            }),
            $f4d0d83b41e20f96$var$getSpacingFix(children, $f4d0d83b41e20f96$var$iconAfterSpacingFixStyle)
        ]
    }, iconAfter) : null, overlay ? (0, $74Zh5.jsx)("span", {
        css: [
            (0, $d23014872ae5fd6e$export$1a9fe1b84c876bb5),
            spinnerHackCss
        ]
    }, overlay) : null));
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$f4d0d83b41e20f96$export$2e2bcd8739ae039 = $f4d0d83b41e20f96$var$ButtonBase;




function $6d24198731b5a9a6$export$2e2bcd8739ae039(_ref) {
    var children = _ref.children, iconBefore = _ref.iconBefore, iconAfter = _ref.iconAfter;
    if ((0, $27c271557a878882$export$20bbd2efb0d734c4)(children)) return true;
    if (children) return false;
    if (iconBefore && !iconAfter) return true;
    if (!iconBefore && iconAfter) return true;
    return false;
}


var $e015d36248b70172$var$_excluded = [
    "appearance",
    "children",
    "iconBefore",
    "iconAfter",
    "isSelected",
    "onMouseDown",
    "onMouseUp",
    "shouldFitContainer",
    "spacing"
];
var $e015d36248b70172$var$isFirefox = typeof navigator !== 'undefined' && navigator.userAgent.toLowerCase().indexOf('firefox') > -1;
/**
 * __Button__
 *
 * @deprecated Legacy buttons are deprecated and will be removed from `atlaskit/button` in an upcoming major release. Please use the new Button components from `@atlaskit/button/new`
 *
 * Please refer to the [migration guide](https://atlassian.design/components/button/button-legacy/migration-guide) for further details.
 *
 * A button triggers an event or action. They let users know what will happen next.
 *
 * - [Examples](https://atlassian.design/components/button/button-legacy/examples)
 * - [Code](https://atlassian.design/components/button/button-legacy/code)
 * - [Usage](https://atlassian.design/components/button/button-legacy/usage)
 */ var $e015d36248b70172$var$Button = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).forwardRef(function Button(_ref, ref) {
    var _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'default' : _ref$appearance, children = _ref.children, iconBefore = _ref.iconBefore, iconAfter = _ref.iconAfter, _ref$isSelected = _ref.isSelected, isSelected = _ref$isSelected === void 0 ? false : _ref$isSelected, _ref$onMouseDown = _ref.onMouseDown, providedOnMouseDown = _ref$onMouseDown === void 0 ? (0, $eVb4V.default) : _ref$onMouseDown, _ref$onMouseUp = _ref.onMouseUp, providedOnMouseUp = _ref$onMouseUp === void 0 ? (0, $eVb4V.default) : _ref$onMouseUp, _ref$shouldFitContain = _ref.shouldFitContainer, shouldFitContainer = _ref$shouldFitContain === void 0 ? false : _ref$shouldFitContain, _ref$spacing = _ref.spacing, spacing = _ref$spacing === void 0 ? 'default' : _ref$spacing, rest = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $e015d36248b70172$var$_excluded);
    var isOnlySingleIcon = (0, $6d24198731b5a9a6$export$2e2bcd8739ae039)({
        children: children,
        iconBefore: iconBefore,
        iconAfter: iconAfter
    });
    var _useState = (0, $5FkrB.useState)(false), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), isActive = _useState2[0], setIsActive = _useState2[1];
    // Wrap onMouseDown / onMouseUp to manually trigger active state
    //  in Firefox
    var onMouseDown = (0, $5FkrB.useCallback)(function(event) {
        providedOnMouseDown(event);
        if ($e015d36248b70172$var$isFirefox) setIsActive(true);
    }, [
        providedOnMouseDown,
        setIsActive
    ]);
    var onMouseUp = (0, $5FkrB.useCallback)(function(event) {
        providedOnMouseUp(event);
        if ($e015d36248b70172$var$isFirefox) setIsActive(false);
    }, [
        providedOnMouseUp,
        setIsActive
    ]);
    var buttonCss = (0, $5FkrB.useMemo)(function() {
        return (0, $d23014872ae5fd6e$export$955358618f994a11)({
            appearance: appearance,
            spacing: spacing,
            isSelected: isSelected,
            shouldFitContainer: shouldFitContainer,
            isOnlySingleIcon: isOnlySingleIcon
        });
    }, [
        appearance,
        spacing,
        isSelected,
        shouldFitContainer,
        isOnlySingleIcon
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $f4d0d83b41e20f96$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, rest, {
        ref: ref,
        appearance: appearance,
        buttonCss: buttonCss,
        children: children,
        "data-firefox-is-active": isActive ? true : undefined,
        iconAfter: iconAfter,
        iconBefore: iconBefore,
        isSelected: isSelected,
        onMouseDown: onMouseDown,
        onMouseUp: onMouseUp,
        spacing: spacing
    }));
}));
// Tools including enzyme rely on components having a display name
$e015d36248b70172$var$Button.displayName = 'Button';
var $e015d36248b70172$export$2e2bcd8739ae039 = $e015d36248b70172$var$Button;


var $kqp0i = parcelRequire("kqp0i");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");


var $5FkrB = parcelRequire("5FkrB");
/* spinner.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $970q7 = parcelRequire("970q7");

var $5FkrB = parcelRequire("5FkrB");

var $eqVaP = parcelRequire("eqVaP");
// Reds
var $9feaa76ab5dbebb4$export$4b84fd0e2c617bd = '#FFEBE6';
var $9feaa76ab5dbebb4$export$b34b069eff244586 = '#FFBDAD';
var $9feaa76ab5dbebb4$export$be802dd0d8b57f35 = '#FF8F73';
var $9feaa76ab5dbebb4$export$60847d42f9da92a6 = '#FF7452';
var $9feaa76ab5dbebb4$export$4a7404f376229999 = '#FF5630';
var $9feaa76ab5dbebb4$export$2010d0fb4295b346 = '#DE350B';
var $9feaa76ab5dbebb4$export$2837b5a1a71d5c02 = '#BF2600';
var $9feaa76ab5dbebb4$export$8d9596b529bbb9cf = '#FFFAE6';
var $9feaa76ab5dbebb4$export$41060a744ab0b7ae = '#FFF0B3';
var $9feaa76ab5dbebb4$export$1cc05bbbf340e559 = '#FFE380';
var $9feaa76ab5dbebb4$export$5aae31392d72caaa = '#FFC400';
var $9feaa76ab5dbebb4$export$c6930421db9fa514 = '#FFAB00';
var $9feaa76ab5dbebb4$export$59619663aa6500fb = '#FF991F';
var $9feaa76ab5dbebb4$export$874739ea9e379ab6 = '#FF8B00';
var $9feaa76ab5dbebb4$export$8a6341c32b6a3ee6 = '#E3FCEF';
var $9feaa76ab5dbebb4$export$69a3bf21b9686c2b = '#ABF5D1';
var $9feaa76ab5dbebb4$export$afbce1382ec95f73 = '#79F2C0';
var $9feaa76ab5dbebb4$export$747d86715d4175de = '#57D9A3';
var $9feaa76ab5dbebb4$export$940e1f69e873f202 = '#36B37E';
var $9feaa76ab5dbebb4$export$a49394138f7b8e85 = '#00875A';
var $9feaa76ab5dbebb4$export$6fa04827ac68a4fb = '#006644';
var $9feaa76ab5dbebb4$export$226de0355ed012f8 = '#DEEBFF';
var $9feaa76ab5dbebb4$export$8c13c2ee36917869 = '#B3D4FF';
var $9feaa76ab5dbebb4$export$ecfc1dff386a3e7a = '#4C9AFF';
var $9feaa76ab5dbebb4$export$215b7063051591f1 = '#2684FF';
var $9feaa76ab5dbebb4$export$e62e8919cca44969 = '#0065FF';
var $9feaa76ab5dbebb4$export$b3de0ae08da2ce64 = '#0052CC';
var $9feaa76ab5dbebb4$export$a6ee3d71bc067634 = '#0747A6';
var $9feaa76ab5dbebb4$export$67f15409e87642a1 = '#669DF1';
var $9feaa76ab5dbebb4$export$f0539dbc42dbb067 = '#8FB8F6';
var $9feaa76ab5dbebb4$export$363e4475840015bb = '#EAE6FF';
var $9feaa76ab5dbebb4$export$4b0a4417ed59760f = '#C0B6F2';
var $9feaa76ab5dbebb4$export$6011520a64d9a187 = '#998DD9';
var $9feaa76ab5dbebb4$export$a7175d4e9206bc80 = '#8777D9';
var $9feaa76ab5dbebb4$export$b48405b95304b5a1 = '#6554C0';
var $9feaa76ab5dbebb4$export$c71e4279dd54a18d = '#5243AA';
var $9feaa76ab5dbebb4$export$147899de772240ec = '#403294';
var $9feaa76ab5dbebb4$export$2cf711fe14c66f06 = '#E6FCFF';
var $9feaa76ab5dbebb4$export$7a8f4d33f6f9772c = '#B3F5FF';
var $9feaa76ab5dbebb4$export$776c9c497ef08533 = '#79E2F2';
var $9feaa76ab5dbebb4$export$69cb3ca10c1e330e = '#00C7E6';
var $9feaa76ab5dbebb4$export$9dc1ef0f3f48059b = '#00B8D9';
var $9feaa76ab5dbebb4$export$7c835c78b6fcdef8 = '#00A3BF';
var $9feaa76ab5dbebb4$export$6036577f95c3877e = '#008DA6';
var $9feaa76ab5dbebb4$export$29a4f05edc054374 = '#FFFFFF';
var $9feaa76ab5dbebb4$export$e655ef011c4aa1a2 = '#FAFBFC';
var $9feaa76ab5dbebb4$export$9fdfb749e33cdf97 = '#F4F5F7';
var $9feaa76ab5dbebb4$export$3e51e8f1440314ba = '#EBECF0';
var $9feaa76ab5dbebb4$export$1ce2d1575d444ceb = '#DFE1E6';
var $9feaa76ab5dbebb4$export$8754fc7e6d8b3000 = '#C1C7D0';
var $9feaa76ab5dbebb4$export$c2e91cbeada39b8b = '#B3BAC5';
var $9feaa76ab5dbebb4$export$5f71e19f3a7ad9de = '#A5ADBA';
var $9feaa76ab5dbebb4$export$eaa8c8a70ac22806 = '#97A0AF';
var $9feaa76ab5dbebb4$export$7c87d337fb91a97d = '#8993A4';
var $9feaa76ab5dbebb4$export$d6447c357493214f = '#7A869A';
var $9feaa76ab5dbebb4$export$f563ee71e9ee74cd = '#6B778C';
var $9feaa76ab5dbebb4$export$e2ef2124cf4024b1 = '#5E6C84';
var $9feaa76ab5dbebb4$export$eece5f492e429f08 = '#505F79';
var $9feaa76ab5dbebb4$export$c39c0fe0f26207ae = '#42526E';
var $9feaa76ab5dbebb4$export$7090862dc3038a9f = '#344563';
var $9feaa76ab5dbebb4$export$ad0bacf983b7ddaa = '#253858';
var $9feaa76ab5dbebb4$export$7d61b15e0da132af = '#172B4D';
var $9feaa76ab5dbebb4$export$fbda843f0a27fe96 = '#091E42';
var $9feaa76ab5dbebb4$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
var $9feaa76ab5dbebb4$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
var $9feaa76ab5dbebb4$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
var $9feaa76ab5dbebb4$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
var $9feaa76ab5dbebb4$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
var $9feaa76ab5dbebb4$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
var $9feaa76ab5dbebb4$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
var $9feaa76ab5dbebb4$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
var $9feaa76ab5dbebb4$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
var $9feaa76ab5dbebb4$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
var $9feaa76ab5dbebb4$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
var $9feaa76ab5dbebb4$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
var $9feaa76ab5dbebb4$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
var $9feaa76ab5dbebb4$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
var $9feaa76ab5dbebb4$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
var $9feaa76ab5dbebb4$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
var $9feaa76ab5dbebb4$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
var $9feaa76ab5dbebb4$export$2f6319cf7d736c2a = '#E6EDFA';
var $9feaa76ab5dbebb4$export$95126bc8884d6634 = '#DCE5F5';
var $9feaa76ab5dbebb4$export$8338d8c35d44ff1 = '#CED9EB';
var $9feaa76ab5dbebb4$export$5368d76ae4fbbda7 = '#B8C7E0';
var $9feaa76ab5dbebb4$export$9f0a771d16ec8d36 = '#ABBBD6';
var $9feaa76ab5dbebb4$export$abcf8c38338b4aa5 = '#9FB0CC';
var $9feaa76ab5dbebb4$export$97e81faa16a182c7 = '#8C9CB8';
var $9feaa76ab5dbebb4$export$bfe21c59123ecf33 = '#7988A3';
var $9feaa76ab5dbebb4$export$ee82aa2ea6a1558 = '#67758F';
var $9feaa76ab5dbebb4$export$682927c6ed76be02 = '#56637A';
var $9feaa76ab5dbebb4$export$91fd9994c5be9757 = '#455166';
var $9feaa76ab5dbebb4$export$d281fbfe3cff2df6 = '#3B475C';
var $9feaa76ab5dbebb4$export$3902c91d8b98a753 = '#313D52';
var $9feaa76ab5dbebb4$export$8e8133c1ba5845b5 = '#283447';
var $9feaa76ab5dbebb4$export$33ff357f6620b39 = '#202B3D';
var $9feaa76ab5dbebb4$export$633847cf062b69e0 = '#1B2638';
var $9feaa76ab5dbebb4$export$9776a6e503bdbf76 = '#121A29';
var $9feaa76ab5dbebb4$export$6c813d5160dff5db = '#0E1624';
var $9feaa76ab5dbebb4$export$3d4f271a500072a = '#0D1424';
var $9feaa76ab5dbebb4$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
var $9feaa76ab5dbebb4$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
var $9feaa76ab5dbebb4$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
var $9feaa76ab5dbebb4$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
var $9feaa76ab5dbebb4$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
var $9feaa76ab5dbebb4$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
var $9feaa76ab5dbebb4$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
var $9feaa76ab5dbebb4$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
var $9feaa76ab5dbebb4$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
var $9feaa76ab5dbebb4$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
var $9feaa76ab5dbebb4$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
var $9feaa76ab5dbebb4$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
var $9feaa76ab5dbebb4$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
var $9feaa76ab5dbebb4$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
var $9feaa76ab5dbebb4$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
var $9feaa76ab5dbebb4$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
var $9feaa76ab5dbebb4$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';
var $9feaa76ab5dbebb4$export$d2adc5dedf09fced = '#292A2E';
var $9feaa76ab5dbebb4$export$f51762073d2bb381 = '#94C748';
var $9feaa76ab5dbebb4$export$95e26d54def96891 = '#B3DF72';


var $c8ef00d2e61af903$export$4e9f1640bbe7a1a8 = {
    xsmall: 12,
    small: 16,
    medium: 24,
    large: 48,
    xlarge: 96
};


/**
 * Returns the appropriate circle stroke color.
 */ function $3595ac2db996a99a$var$getStrokeColor(appearance) {
    return appearance === 'inherit' ? "var(--ds-icon-subtle, ".concat((0, $9feaa76ab5dbebb4$export$c39c0fe0f26207ae), ")") : "var(--ds-icon-inverse, ".concat((0, $9feaa76ab5dbebb4$export$29a4f05edc054374), ")");
}
var $3595ac2db996a99a$var$rotate = null;
/**
 * There are three parts to the load in animation:
 * 1. Accelerated spin
 * 2. Stretch the spinner line
 */ var $3595ac2db996a99a$var$loadIn = null;
var $3595ac2db996a99a$var$styles = {
    rotateStyles: "_j7hqsf8s _5sag12kz _tip812c5 _1pgl2qsq _8hrz1h6o",
    loadInStyles: "_j7hq1ky6 _5sag9cwz _1pgl1ytf _1o51q7pw",
    wrapperStyles: "_1e0c116y _s7n4nkob",
    circleStyles: "_lswuglyw _7ljx1dhp _1snbbs82 _jcxd7g3v _1tjm1onz"
};
/**
 * `useLayoutEffect` is being used in SSR safe form. On the server, this work doesn’t need to run.
 * `useEffect` is used in-place, because `useEffect` is not run on the server and it matches types
 * which makes things simpler than doing an `isServer` check or a `null` check.
 *
 * @see https://hello.atlassian.net/wiki/spaces/DST/pages/2081696628/DSTDACI-010+-+Interaction+Tracing+hooks+in+DS+components
 */ var $3595ac2db996a99a$var$useLayoutEffect = typeof window === 'undefined' ? (0, $5FkrB.useEffect) : (0, $5FkrB.useLayoutEffect);
/**
 * __Spinner__
 *
 * A spinner is an animated spinning icon that lets users know content is being loaded.
 *
 * - [Examples](https://atlassian.design/components/spinner/examples)
 * - [Code](https://atlassian.design/components/spinner/code)
 * - [Usage](https://atlassian.design/components/spinner/usage)
 */ var $3595ac2db996a99a$var$Spinner = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).forwardRef(function Spinner(_ref, ref) {
    var _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'inherit' : _ref$appearance, _ref$delay = _ref.delay, delay = _ref$delay === void 0 ? 0 : _ref$delay, interactionName = _ref.interactionName, label = _ref.label, _ref$size = _ref.size, providedSize = _ref$size === void 0 ? 'medium' : _ref$size, testId = _ref.testId;
    var size = typeof providedSize === 'number' ? providedSize : (0, $c8ef00d2e61af903$export$4e9f1640bbe7a1a8)[providedSize];
    var animationDelay = "".concat(delay, "ms");
    var stroke = $3595ac2db996a99a$var$getStrokeColor(appearance);
    var context = (0, $5FkrB.useContext)((0, $eqVaP.default));
    $3595ac2db996a99a$var$useLayoutEffect(function() {
        if (context != null) return context.hold(interactionName);
    }, [
        context,
        interactionName
    ]);
    /**
   * The Spinner animation uses a combination of two
   * css animations on two separate elements.
   */ return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("span", {
        "data-testid": testId ? "".concat(testId, "-wrapper") : 'spinner-wrapper',
        style: {
            animationDelay: animationDelay,
            width: size,
            height: size
        },
        className: (0, $970q7.default)([
            $3595ac2db996a99a$var$styles.wrapperStyles,
            $3595ac2db996a99a$var$styles.rotateStyles
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("svg", {
        height: size,
        width: size,
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg",
        "data-testid": testId,
        ref: ref,
        "aria-label": label || undefined,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            animationDelay: animationDelay
        },
        role: label ? 'img' : 'none',
        className: (0, $970q7.default)([
            $3595ac2db996a99a$var$styles.loadInStyles
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("circle", {
        cx: "8",
        cy: "8",
        r: "7",
        style: {
            stroke: stroke
        },
        className: (0, $970q7.default)([
            $3595ac2db996a99a$var$styles.circleStyles
        ])
    })));
}));
var $3595ac2db996a99a$export$2e2bcd8739ae039 = $3595ac2db996a99a$var$Spinner;


function $dd510204f6d75704$var$getSpinnerAppearance(_ref) {
    var appearance = _ref.appearance, isDisabled = _ref.isDisabled, isSelected = _ref.isSelected;
    if (isDisabled) return 'inherit';
    if (isSelected) return 'invert';
    if (appearance === 'primary' || appearance === 'danger') return 'invert';
    return 'inherit';
}
function $dd510204f6d75704$export$2e2bcd8739ae039(_ref2) {
    var appearance = _ref2.appearance, isDisabled = _ref2.isDisabled, isSelected = _ref2.isSelected, _ref2$spacing = _ref2.spacing, spacing = _ref2$spacing === void 0 ? 'default' : _ref2$spacing;
    var size = spacing === 'default' ? 'medium' : 'small';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $3595ac2db996a99a$export$2e2bcd8739ae039), {
        size: size,
        label: ", Loading",
        appearance: $dd510204f6d75704$var$getSpinnerAppearance({
            appearance: appearance,
            isDisabled: isDisabled,
            isSelected: isSelected
        })
    });
}


var $a60eb1e63addc72a$var$_excluded = [
    "appearance",
    "isDisabled",
    "isSelected",
    "isLoading",
    "spacing"
];
/**
 * __Loading button__
 *
 * @deprecated Legacy loading buttons are deprecated and will be removed from `atlaskit/button` in an upcoming major release. Please use the new Button components from `@atlaskit/button/new` with the `isLoading` prop.
 *
 * Please refer to the [migration guide](https://atlassian.design/components/button/button-legacy/migration-guide) for further details.
 *
 * A small wrapper around Button that allows you to show an @atlaskit/spinner as an overlay on the button when you set an isLoading prop to true.
 *
 * - [Examples](https://atlassian.design/components/button/examples#loading-button)
 */ var $a60eb1e63addc72a$var$LoadingButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).forwardRef(function LoadingButton(_ref, ref) {
    var appearance = _ref.appearance, isDisabled = _ref.isDisabled, isSelected = _ref.isSelected, _ref$isLoading = _ref.isLoading, isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading, spacing = _ref.spacing, rest = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $a60eb1e63addc72a$var$_excluded);
    // Button already has React.memo, so just leaning on that
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $e015d36248b70172$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, rest, {
        ref: ref,
        appearance: appearance,
        "aria-disabled": isLoading || undefined,
        isDisabled: isDisabled,
        isSelected: isSelected,
        overlay: isLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $dd510204f6d75704$export$2e2bcd8739ae039), {
            spacing: spacing,
            appearance: appearance,
            isDisabled: isDisabled,
            isSelected: isSelected
        }) : null,
        spacing: spacing
    }));
});
// Tools including enzyme rely on components having a display name
$a60eb1e63addc72a$var$LoadingButton.displayName = 'LoadingButton';
var $a60eb1e63addc72a$export$2e2bcd8739ae039 = $a60eb1e63addc72a$var$LoadingButton;


/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5FkrB = parcelRequire("5FkrB");

var $74Zh5 = parcelRequire("74Zh5");

var $5FkrB = parcelRequire("5FkrB");
var $c78d6c98f7283ff6$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $5FkrB.createContext)(null);


/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ // Reds
var $b5e0fe981809a87d$export$4b84fd0e2c617bd = '#FFEBE6';
var $b5e0fe981809a87d$export$b34b069eff244586 = '#FFBDAD';
var $b5e0fe981809a87d$export$be802dd0d8b57f35 = '#FF8F73';
var $b5e0fe981809a87d$export$60847d42f9da92a6 = '#FF7452';
var $b5e0fe981809a87d$export$4a7404f376229999 = '#FF5630';
var $b5e0fe981809a87d$export$2010d0fb4295b346 = '#DE350B';
var $b5e0fe981809a87d$export$2837b5a1a71d5c02 = '#BF2600';
var $b5e0fe981809a87d$export$8d9596b529bbb9cf = '#FFFAE6';
var $b5e0fe981809a87d$export$41060a744ab0b7ae = '#FFF0B3';
var $b5e0fe981809a87d$export$1cc05bbbf340e559 = '#FFE380';
var $b5e0fe981809a87d$export$5aae31392d72caaa = '#FFC400';
var $b5e0fe981809a87d$export$c6930421db9fa514 = '#FFAB00';
var $b5e0fe981809a87d$export$59619663aa6500fb = '#FF991F';
var $b5e0fe981809a87d$export$874739ea9e379ab6 = '#FF8B00';
var $b5e0fe981809a87d$export$8a6341c32b6a3ee6 = '#E3FCEF';
var $b5e0fe981809a87d$export$69a3bf21b9686c2b = '#ABF5D1';
var $b5e0fe981809a87d$export$afbce1382ec95f73 = '#79F2C0';
var $b5e0fe981809a87d$export$747d86715d4175de = '#57D9A3';
var $b5e0fe981809a87d$export$940e1f69e873f202 = '#36B37E';
var $b5e0fe981809a87d$export$a49394138f7b8e85 = '#00875A';
var $b5e0fe981809a87d$export$6fa04827ac68a4fb = '#006644';
var $b5e0fe981809a87d$export$226de0355ed012f8 = '#DEEBFF';
var $b5e0fe981809a87d$export$8c13c2ee36917869 = '#B3D4FF';
var $b5e0fe981809a87d$export$ecfc1dff386a3e7a = '#4C9AFF';
var $b5e0fe981809a87d$export$215b7063051591f1 = '#2684FF';
var $b5e0fe981809a87d$export$e62e8919cca44969 = '#0065FF';
var $b5e0fe981809a87d$export$b3de0ae08da2ce64 = '#0052CC';
var $b5e0fe981809a87d$export$a6ee3d71bc067634 = '#0747A6';
var $b5e0fe981809a87d$export$67f15409e87642a1 = '#669DF1';
var $b5e0fe981809a87d$export$f0539dbc42dbb067 = '#8FB8F6';
var $b5e0fe981809a87d$export$363e4475840015bb = '#EAE6FF';
var $b5e0fe981809a87d$export$4b0a4417ed59760f = '#C0B6F2';
var $b5e0fe981809a87d$export$6011520a64d9a187 = '#998DD9';
var $b5e0fe981809a87d$export$a7175d4e9206bc80 = '#8777D9';
var $b5e0fe981809a87d$export$b48405b95304b5a1 = '#6554C0';
var $b5e0fe981809a87d$export$c71e4279dd54a18d = '#5243AA';
var $b5e0fe981809a87d$export$147899de772240ec = '#403294';
var $b5e0fe981809a87d$export$2cf711fe14c66f06 = '#E6FCFF';
var $b5e0fe981809a87d$export$7a8f4d33f6f9772c = '#B3F5FF';
var $b5e0fe981809a87d$export$776c9c497ef08533 = '#79E2F2';
var $b5e0fe981809a87d$export$69cb3ca10c1e330e = '#00C7E6';
var $b5e0fe981809a87d$export$9dc1ef0f3f48059b = '#00B8D9';
var $b5e0fe981809a87d$export$7c835c78b6fcdef8 = '#00A3BF';
var $b5e0fe981809a87d$export$6036577f95c3877e = '#008DA6';
var $b5e0fe981809a87d$export$29a4f05edc054374 = '#FFFFFF';
var $b5e0fe981809a87d$export$e655ef011c4aa1a2 = '#FAFBFC';
var $b5e0fe981809a87d$export$9fdfb749e33cdf97 = '#F4F5F7';
var $b5e0fe981809a87d$export$3e51e8f1440314ba = '#EBECF0';
var $b5e0fe981809a87d$export$1ce2d1575d444ceb = '#DFE1E6';
var $b5e0fe981809a87d$export$8754fc7e6d8b3000 = '#C1C7D0';
var $b5e0fe981809a87d$export$c2e91cbeada39b8b = '#B3BAC5';
var $b5e0fe981809a87d$export$5f71e19f3a7ad9de = '#A5ADBA';
var $b5e0fe981809a87d$export$eaa8c8a70ac22806 = '#97A0AF';
var $b5e0fe981809a87d$export$7c87d337fb91a97d = '#8993A4';
var $b5e0fe981809a87d$export$d6447c357493214f = '#7A869A';
var $b5e0fe981809a87d$export$f563ee71e9ee74cd = '#6B778C';
var $b5e0fe981809a87d$export$e2ef2124cf4024b1 = '#5E6C84';
var $b5e0fe981809a87d$export$eece5f492e429f08 = '#505F79';
var $b5e0fe981809a87d$export$c39c0fe0f26207ae = '#42526E';
var $b5e0fe981809a87d$export$7090862dc3038a9f = '#344563';
var $b5e0fe981809a87d$export$ad0bacf983b7ddaa = '#253858';
var $b5e0fe981809a87d$export$7d61b15e0da132af = '#172B4D';
var $b5e0fe981809a87d$export$fbda843f0a27fe96 = '#091E42';
var $b5e0fe981809a87d$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
var $b5e0fe981809a87d$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
var $b5e0fe981809a87d$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
var $b5e0fe981809a87d$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
var $b5e0fe981809a87d$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
var $b5e0fe981809a87d$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
var $b5e0fe981809a87d$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
var $b5e0fe981809a87d$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
var $b5e0fe981809a87d$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
var $b5e0fe981809a87d$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
var $b5e0fe981809a87d$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
var $b5e0fe981809a87d$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
var $b5e0fe981809a87d$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
var $b5e0fe981809a87d$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
var $b5e0fe981809a87d$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
var $b5e0fe981809a87d$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
var $b5e0fe981809a87d$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
var $b5e0fe981809a87d$export$2f6319cf7d736c2a = '#E6EDFA';
var $b5e0fe981809a87d$export$95126bc8884d6634 = '#DCE5F5';
var $b5e0fe981809a87d$export$8338d8c35d44ff1 = '#CED9EB';
var $b5e0fe981809a87d$export$5368d76ae4fbbda7 = '#B8C7E0';
var $b5e0fe981809a87d$export$9f0a771d16ec8d36 = '#ABBBD6';
var $b5e0fe981809a87d$export$abcf8c38338b4aa5 = '#9FB0CC';
var $b5e0fe981809a87d$export$97e81faa16a182c7 = '#8C9CB8';
var $b5e0fe981809a87d$export$bfe21c59123ecf33 = '#7988A3';
var $b5e0fe981809a87d$export$ee82aa2ea6a1558 = '#67758F';
var $b5e0fe981809a87d$export$682927c6ed76be02 = '#56637A';
var $b5e0fe981809a87d$export$91fd9994c5be9757 = '#455166';
var $b5e0fe981809a87d$export$d281fbfe3cff2df6 = '#3B475C';
var $b5e0fe981809a87d$export$3902c91d8b98a753 = '#313D52';
var $b5e0fe981809a87d$export$8e8133c1ba5845b5 = '#283447';
var $b5e0fe981809a87d$export$33ff357f6620b39 = '#202B3D';
var $b5e0fe981809a87d$export$633847cf062b69e0 = '#1B2638';
var $b5e0fe981809a87d$export$9776a6e503bdbf76 = '#121A29';
var $b5e0fe981809a87d$export$6c813d5160dff5db = '#0E1624';
var $b5e0fe981809a87d$export$3d4f271a500072a = '#0D1424';
var $b5e0fe981809a87d$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
var $b5e0fe981809a87d$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
var $b5e0fe981809a87d$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
var $b5e0fe981809a87d$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
var $b5e0fe981809a87d$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
var $b5e0fe981809a87d$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
var $b5e0fe981809a87d$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
var $b5e0fe981809a87d$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
var $b5e0fe981809a87d$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
var $b5e0fe981809a87d$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
var $b5e0fe981809a87d$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
var $b5e0fe981809a87d$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
var $b5e0fe981809a87d$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
var $b5e0fe981809a87d$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
var $b5e0fe981809a87d$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
var $b5e0fe981809a87d$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
var $b5e0fe981809a87d$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';
var $b5e0fe981809a87d$export$d2adc5dedf09fced = '#292A2E';
var $b5e0fe981809a87d$export$f51762073d2bb381 = '#94C748';
var $b5e0fe981809a87d$export$95e26d54def96891 = '#B3DF72';


var $1cedf8f2f776e1fc$export$4e9f1640bbe7a1a8 = {
    xsmall: 8,
    small: 16,
    medium: 24,
    large: 48,
    xlarge: 96
};


/**
 * Returns the appropriate circle stroke color.
 */ function $e9bb9e7afd1cf629$var$getStrokeColor(appearance) {
    return appearance === 'inherit' ? "var(--ds-icon-subtle, ".concat((0, $b5e0fe981809a87d$export$c39c0fe0f26207ae), ")") : "var(--ds-icon-inverse, ".concat((0, $b5e0fe981809a87d$export$29a4f05edc054374), ")");
}
var $e9bb9e7afd1cf629$var$rotate = (0, $74Zh5.keyframes)({
    to: {
        transform: 'rotate(360deg)'
    }
});
var $e9bb9e7afd1cf629$var$rotateStyles = (0, $74Zh5.css)({
    animation: "".concat($e9bb9e7afd1cf629$var$rotate, " 0.86s infinite"),
    animationTimingFunction: 'cubic-bezier(0.4, 0.15, 0.6, 0.85)',
    transformOrigin: 'center'
});
/**
 * There are three parts to the load in animation:
 * 1. Fade in
 * 2. Accelerated spin
 * 3. Stretch the spinner line
 */ var $e9bb9e7afd1cf629$var$loadIn = (0, $74Zh5.keyframes)({
    from: {
        transform: 'rotate(50deg)',
        opacity: 0,
        strokeDashoffset: 60
    },
    to: {
        transform: 'rotate(230deg)',
        opacity: 1,
        strokeDashoffset: 50
    }
});
var $e9bb9e7afd1cf629$var$loadInStyles = (0, $74Zh5.css)({
    animation: "".concat($e9bb9e7afd1cf629$var$loadIn, " 1s ease-in-out"),
    /**
   * When the animation completes, stay at the last frame of the animation.
   */ animationFillMode: 'forwards',
    /**
   * We are going to animate this in.
   */ opacity: 0
});
var $e9bb9e7afd1cf629$var$wrapperStyles = (0, $74Zh5.css)({
    display: 'inline-flex',
    /**
   * Align better inline with text.
   */ verticalAlign: 'middle'
});
var $e9bb9e7afd1cf629$var$circleStyles = (0, $74Zh5.css)({
    fill: 'none',
    strokeDasharray: 60,
    strokeDashoffset: 'inherit',
    strokeLinecap: 'round',
    strokeWidth: 1.5,
    '@media screen and (forced-colors: active)': {
        filter: 'grayscale(100%)',
        stroke: 'CanvasText'
    }
});
/**
 * `useLayoutEffect` is being used in SSR safe form. On the server, this work doesn’t need to run.
 * `useEffect` is used in-place, because `useEffect` is not run on the server and it matches types
 * which makes things simpler than doing an `isServer` check or a `null` check.
 *
 * @see https://hello.atlassian.net/wiki/spaces/DST/pages/2081696628/DSTDACI-010+-+Interaction+Tracing+hooks+in+DS+components
 */ var $e9bb9e7afd1cf629$var$useLayoutEffect = typeof window === 'undefined' ? (0, $5FkrB.useEffect) : (0, $5FkrB.useLayoutEffect);
/**
 * __Spinner__
 *
 * A spinner is an animated spinning icon that lets users know content is being loaded.
 *
 * - [Examples](https://atlassian.design/components/spinner/examples)
 * - [Code](https://atlassian.design/components/spinner/code)
 * - [Usage](https://atlassian.design/components/spinner/usage)
 */ var $e9bb9e7afd1cf629$var$Spinner = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).forwardRef(function Spinner(_ref, ref) {
    var _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'inherit' : _ref$appearance, _ref$delay = _ref.delay, delay = _ref$delay === void 0 ? 0 : _ref$delay, interactionName = _ref.interactionName, label = _ref.label, _ref$size = _ref.size, providedSize = _ref$size === void 0 ? 'medium' : _ref$size, testId = _ref.testId;
    var size = typeof providedSize === 'number' ? providedSize : (0, $1cedf8f2f776e1fc$export$4e9f1640bbe7a1a8)[providedSize];
    var animationDelay = "".concat(delay, "ms");
    var stroke = $e9bb9e7afd1cf629$var$getStrokeColor(appearance);
    var context = (0, $5FkrB.useContext)((0, $c78d6c98f7283ff6$export$2e2bcd8739ae039));
    $e9bb9e7afd1cf629$var$useLayoutEffect(function() {
        if (context != null) return context.hold(interactionName);
    }, [
        context,
        interactionName
    ]);
    /**
   * The Spinner animation uses a combination of two
   * css animations on two separate elements.
   */ return (0, $74Zh5.jsx)("span", {
        /**
     * This span exists to off-load animations from the circle element,
     * which were causing performance issues (style recalculations)
     * on Safari and older versions of Chrome.
     *
     * This can be removed and styles placed back on the circle element once
     * Safari fixes this bug and off-loads rendering to the GPU from the CPU.
     */ css: [
            $e9bb9e7afd1cf629$var$wrapperStyles,
            $e9bb9e7afd1cf629$var$rotateStyles
        ],
        "data-testid": testId && "".concat(testId, "-wrapper"),
        style: {
            animationDelay: animationDelay,
            width: size,
            height: size
        }
    }, (0, $74Zh5.jsx)("svg", {
        height: size,
        width: size,
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg",
        "data-testid": testId,
        ref: ref,
        "aria-label": label || undefined,
        css: $e9bb9e7afd1cf629$var$loadInStyles,
        style: {
            animationDelay: animationDelay
        },
        role: label ? 'img' : 'none'
    }, (0, $74Zh5.jsx)("circle", {
        cx: "8",
        cy: "8",
        r: "7",
        css: $e9bb9e7afd1cf629$var$circleStyles,
        style: {
            stroke: stroke
        }
    })));
}));
var $e9bb9e7afd1cf629$export$2e2bcd8739ae039 = $e9bb9e7afd1cf629$var$Spinner;



var $kqp0i = parcelRequire("kqp0i");

var $iYJcE = parcelRequire("iYJcE");

var $25nEq = parcelRequire("25nEq");

var $5FkrB = parcelRequire("5FkrB");

var $7QpUe = parcelRequire("7QpUe");

var $25nEq = parcelRequire("25nEq");

var $5FkrB = parcelRequire("5FkrB");

var $dLGML = parcelRequire("dLGML");

var $fC8ib = parcelRequire("fC8ib");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $kIXpt = parcelRequire("kIXpt");

var $cYPzS = parcelRequire("cYPzS");

var $lwlXp = parcelRequire("lwlXp");

var $eyuDe = parcelRequire("eyuDe");

var $25nEq = parcelRequire("25nEq");

var $ekGgq = parcelRequire("ekGgq");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $25nEq = parcelRequire("25nEq");
function $c78ea150e2ee1656$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $c78ea150e2ee1656$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $c78ea150e2ee1656$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $c78ea150e2ee1656$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $c78ea150e2ee1656$export$ad4be5c2ec28cecf = function isAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $c78ea150e2ee1656$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === 'AnalyticsEvent';
};
var $c78ea150e2ee1656$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function AnalyticsEvent(props) {
        var _this = this;
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, AnalyticsEvent);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "_isAnalyticsEvent", true);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "clone", function() {
            // just a shallow clone, don't change sub refs unless you want to
            // affect the original's too
            var payload = $c78ea150e2ee1656$var$_objectSpread({}, _this.payload);
            return new AnalyticsEvent({
                payload: payload
            });
        });
        this.payload = props.payload;
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(AnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (typeof updater === 'function') this.payload = updater(this.payload);
                if ((0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(updater) === 'object') this.payload = $c78ea150e2ee1656$var$_objectSpread($c78ea150e2ee1656$var$_objectSpread({}, this.payload), updater);
                return this;
            }
        }
    ]);
}();


function $0d0d1b8249bb995c$var$_callSuper(t, o, e) {
    return o = (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(o), (0, (/*@__PURE__*/$parcel$interopDefault($kIXpt)))(t, $0d0d1b8249bb995c$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(t).constructor) : o.apply(t, e));
}
function $0d0d1b8249bb995c$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($0d0d1b8249bb995c$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $0d0d1b8249bb995c$var$_superPropGet(t, o, e, r) {
    var p = (0, (/*@__PURE__*/$parcel$interopDefault($lwlXp)))((0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(1 & r ? t.prototype : t), o, e);
    return 2 & r && "function" == typeof p ? function(t) {
        return p.apply(e, t);
    } : p;
}
var $0d0d1b8249bb995c$export$35f8383928ba8d7 = function isUIAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $0d0d1b8249bb995c$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isUIAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === 'UIAnalyticsEvent';
};
var $0d0d1b8249bb995c$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_AnalyticsEvent) {
    function UIAnalyticsEvent(props) {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, UIAnalyticsEvent);
        _this = $0d0d1b8249bb995c$var$_callSuper(this, UIAnalyticsEvent, [
            props
        ]);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "_isUIAnalyticsEvent", true);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "clone", function() {
            if (_this.hasFired) return null;
            var context = (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(_this.context);
            var handlers = (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(_this.handlers);
            /**
       * A hacky "deep clone" of the object. This is limited in that it wont
       * support functions, regexs, Maps, Sets, etc, but none of those need to
       * be represented in our payload.
       */ var payload = JSON.parse(JSON.stringify(_this.payload));
            return new UIAnalyticsEvent({
                context: context,
                handlers: handlers,
                payload: payload
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "fire", function(channel) {
            if (_this.hasFired) return;
            _this.handlers.forEach(function(handler) {
                return handler(_this, channel);
            });
            _this.hasFired = true;
        });
        _this.context = props.context || [];
        _this.handlers = props.handlers || [];
        _this.hasFired = false;
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($eyuDe)))(UIAnalyticsEvent, _AnalyticsEvent);
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(UIAnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (this.hasFired) return this;
                return $0d0d1b8249bb995c$var$_superPropGet(UIAnalyticsEvent, "update", this, 3)([
                    updater
                ]);
            }
        }
    ]);
}((0, $c78ea150e2ee1656$export$2e2bcd8739ae039));



var $5FkrB = parcelRequire("5FkrB");

var $iyyOp = parcelRequire("iyyOp");
var $d4bb7d144175351d$export$d1f587f82ad51c4 = function useAnalyticsContext() {
    return (0, $5FkrB.useContext)((0, $iyyOp.default));
};


function $d5aceb938b608b4c$export$5bf35293e545f20c() {
    var analyticsContext = (0, $d4bb7d144175351d$export$d1f587f82ad51c4)();
    var createAnalyticsEvent = (0, $dLGML.useCallbackOne)(function(payload) {
        return new (0, $0d0d1b8249bb995c$export$2e2bcd8739ae039)({
            context: analyticsContext.getAtlaskitAnalyticsContext(),
            handlers: analyticsContext.getAtlaskitAnalyticsEventHandlers(),
            payload: payload
        });
    }, [
        analyticsContext
    ]);
    return {
        createAnalyticsEvent: createAnalyticsEvent
    };
}



var $5FkrB = parcelRequire("5FkrB");
var $22dc53065038106d$export$1d27a74659855e44 = function useTrackedRef(value) {
    var ref = (0, $5FkrB.useRef)(value);
    ref.current = value;
    return ref;
};


function $ff1b37318b494b6a$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $ff1b37318b494b6a$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $ff1b37318b494b6a$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $ff1b37318b494b6a$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $ff1b37318b494b6a$export$1a04351537078b55(_ref) {
    var fn = _ref.fn, action = _ref.action, componentName = _ref.componentName, packageName = _ref.packageName, packageVersion = _ref.packageVersion, analyticsData = _ref.analyticsData;
    var _useAnalyticsEvents = (0, $d5aceb938b608b4c$export$5bf35293e545f20c)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
    // We put analyticsData and fn in a ref so that we don't need to break
    // memoization.
    // Generally these could be defined by consumers inline
    // and so we do this to avoid breaking memoization of useCallback
    var dataRef = (0, $22dc53065038106d$export$1d27a74659855e44)(analyticsData);
    var fnRef = (0, $22dc53065038106d$export$1d27a74659855e44)(fn);
    var handler = (0, $5FkrB.useCallback)(function() {
        var analyticsEvent = createAnalyticsEvent({
            action: action,
            actionSubject: componentName,
            attributes: {
                componentName: componentName,
                packageName: packageName,
                packageVersion: packageVersion
            }
        });
        // To avoid wrapping this component in AnalyticsContext we manually
        // push the parent context's meta data into the context.
        // Note: this new 'context'
        var context = $ff1b37318b494b6a$var$_objectSpread({
            componentName: componentName,
            packageName: packageName,
            packageVersion: packageVersion
        }, dataRef.current);
        analyticsEvent.context.push(context);
        // fire an event on the atlaskit channel
        var clone = analyticsEvent.clone();
        if (clone) clone.fire('atlaskit');
        fnRef.current(analyticsEvent);
    }, [
        // These are strings and won't change
        action,
        componentName,
        packageName,
        packageVersion,
        // This function is memoized in the context
        createAnalyticsEvent,
        // these are a stable ref because of the useTrackedRef hook
        dataRef,
        fnRef
    ]);
    return handler;
}


/**
 * An empty function which does nothing.
 */ // eslint-disable-next-line @repo/internal/react/use-noop
function $f55684cf1f3dca29$export$2e2bcd8739ae039() {}



var $5FkrB = parcelRequire("5FkrB");

var $7QpUe = parcelRequire("7QpUe");
/**
 * Character key codes which can be used in keyboard events.
 */ var $24cbc83a816d03dc$export$390330c10ff2b9a1 = 'ArrowUp';
var $24cbc83a816d03dc$export$a80636c6f41931fe = 'ArrowDown';
var $24cbc83a816d03dc$export$4af703091671bc = 'Home';
var $24cbc83a816d03dc$export$e2bc30913faa5db7 = 'End';
var $24cbc83a816d03dc$export$10f6869ed0a7d75b = 'Tab';
var $24cbc83a816d03dc$export$8152f929a25a0ff4 = 'Enter';
var $24cbc83a816d03dc$export$e51a3576c045c8d5 = 'Space';
var $24cbc83a816d03dc$export$2bb790b9008907b4 = 'Escape';


function $29facb65b1c1eae8$export$2e2bcd8739ae039(_ref) {
    var onClose = _ref.onClose, isDisabled = _ref.isDisabled;
    var escapePressed = (0, $5FkrB.useRef)(false);
    var onKeyDown = (0, $5FkrB.useCallback)(function(e) {
        if (isDisabled || escapePressed.current || e.key !== (0, $24cbc83a816d03dc$export$2bb790b9008907b4)) // We're either already handling the key down event or it's not escape.
        // Bail early!
        return;
        escapePressed.current = true;
        onClose(e);
    }, [
        onClose,
        isDisabled
    ]);
    var onKeyUp = (0, $5FkrB.useCallback)(function() {
        escapePressed.current = false;
    }, []);
    (0, $5FkrB.useEffect)(function() {
        return (0, $7QpUe.bindAll)(document, [
            {
                type: 'keydown',
                listener: onKeyDown
            },
            {
                type: 'keyup',
                listener: onKeyUp
            }
        ], {
            capture: false
        });
    }, [
        onKeyDown,
        onKeyUp
    ]);
}



var $5FkrB = parcelRequire("5FkrB");
function $3410b820897135a6$export$2e2bcd8739ae039(value) {
    var ref = (0, $5FkrB.useRef)(value);
    (0, $5FkrB.useEffect)(function() {
        ref.current = value;
    }, [
        value
    ]);
    return ref;
}



var $5FkrB = parcelRequire("5FkrB");

var $5FkrB = parcelRequire("5FkrB");
var $375d8fb92f1b53ed$export$5fbf4d7fae6cdc00 = /*#__PURE__*/ (0, $5FkrB.createContext)(null);


function $3d52fdcb58caf93d$export$469bb693f11edc7f() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, _ref$isOpen = _ref.isOpen, isOpen = _ref$isOpen === void 0 ? true : _ref$isOpen;
    var context = (0, $5FkrB.useContext)((0, $375d8fb92f1b53ed$export$5fbf4d7fae6cdc00));
    (0, $5FkrB.useEffect)(function() {
        if (context === null) return;
        if (!isOpen) return;
        context.increment();
        return function() {
            context.decrement();
        };
    }, [
        context,
        isOpen
    ]);
}



var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");

var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");

var $7QpUe = parcelRequire("7QpUe");
var $88b27043491c379a$var$isMatchMediaAvailable = function isMatchMediaAvailable() {
    return typeof window !== 'undefined' && 'matchMedia' in window;
};
var $88b27043491c379a$export$b7baf7667a68d87c = function isReducedMotion() {
    if (!$88b27043491c379a$var$isMatchMediaAvailable()) return false;
    var _window$matchMedia = window.matchMedia('(prefers-reduced-motion: reduce)'), matches = _window$matchMedia.matches;
    return matches;
};
var $88b27043491c379a$export$c537e63161742ce3 = function useIsReducedMotion() {
    var _useState = (0, $5FkrB.useState)($88b27043491c379a$export$b7baf7667a68d87c), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), prefersReducedMotion = _useState2[0], setPrefersReducedMotion = _useState2[1];
    (0, $5FkrB.useEffect)(function() {
        if (!$88b27043491c379a$var$isMatchMediaAvailable()) return;
        var mediaQueryList = window.matchMedia('(prefers-reduced-motion: reduce)');
        var onChange = function onChange(event) {
            return setPrefersReducedMotion(event.matches);
        };
        return (0, $7QpUe.bind)(mediaQueryList, {
            type: 'change',
            listener: onChange
        });
    }, []);
    return prefersReducedMotion;
};
var $88b27043491c379a$export$f0f789643ba5a83c = {
    '@media (prefers-reduced-motion: reduce)': {
        animation: 'none',
        transition: 'none'
    }
};
var $88b27043491c379a$export$ff7706047246b98b = function prefersReducedMotion() {
    return $88b27043491c379a$export$f0f789643ba5a83c;
};


/**
 * Internally we will be playing with an element that will always have a key defined.
 */ /**
 * Internal data passed to child motions.
 */ // We define empty context here so the object doesn't change.
var $279dc552abf8fdf8$var$emptyContext = {
    // Motions will always appear if not inside a exiting persistence component.
    appear: true,
    isExiting: false
};
/**
 * __Exiting context__
 *
 * An exiting context.
 */ var $279dc552abf8fdf8$var$ExitingContext = /*#__PURE__*/ (0, $5FkrB.createContext)($279dc552abf8fdf8$var$emptyContext);
/**
 * This method will wrap any React element with a context provider. We're using context (instead of
 * cloneElement) so we can communicate between multiple elements without the need of prop drilling
 * (results in a better API for consumers).
 */ var $279dc552abf8fdf8$var$wrapChildWithContextProvider = function wrapChildWithContextProvider(child) {
    var value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $279dc552abf8fdf8$var$emptyContext;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement($279dc552abf8fdf8$var$ExitingContext.Provider, {
        key: "".concat(child.key, "-provider"),
        value: value
    }, child);
};
/**
 * This function will convert all children types to an array while also filtering out non-valid React elements.
 */ var $279dc552abf8fdf8$var$childrenToArray = function childrenToArray(children) {
    var childrenAsArray = [];
    // We convert children to an array using this helper method as it will add keys to children that do not
    // have them, such as when we have hardcoded children that are conditionally rendered.
    (0, $5FkrB.Children).toArray(children).forEach(function(child) {
        // We ignore any boolean children to make our code a little more simple later on,
        // and also filter out any falsies (empty strings, nulls, and undefined).
        if (typeof child !== 'boolean' && Boolean(child)) // Children WILL have a key after being forced into an array using the React.Children helper.
        childrenAsArray.push(child);
    });
    return childrenAsArray;
};
var $279dc552abf8fdf8$var$spliceNewElementsIntoPrevious = function spliceNewElementsIntoPrevious(current, previous) {
    var splicedChildren = previous.concat([]);
    var previousMap = $279dc552abf8fdf8$var$childrenToObj(previous);
    for(var i = 0; i < current.length; i++){
        var child = current[i];
        var childIsNew = !previousMap[child.key];
        if (childIsNew) // This will insert the new element after the previous element.
        splicedChildren.splice(i + 1, 0, child);
    }
    return splicedChildren;
};
var $279dc552abf8fdf8$var$childrenToObj = function childrenToObj(children) {
    return children.reduce(function(acc, child) {
        acc[child.key] = child;
        return acc;
    }, {});
};
var $279dc552abf8fdf8$var$getMissingKeys = function getMissingKeys(current, previous) {
    var currentMapKeys = new Set(current.map(function(child) {
        return child.key;
    }));
    var missing = new Set();
    for(var i = 0; i < previous.length; i++){
        var element = previous[i];
        var _key = element.key;
        if (!currentMapKeys.has(_key)) missing.add(_key);
    }
    return missing;
};
/**
 * __ExitingPersistence__
 *
 * Useful for enabling elements to persist and animate away when they are removed from the DOM.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/motion/docs/entering-motions)
 */ var $279dc552abf8fdf8$var$ExitingPersistence = /*#__PURE__*/ (0, $5FkrB.memo)(function(_ref) {
    var _ref$appear = _ref.appear, appear = _ref$appear === void 0 ? false : _ref$appear, children = _ref.children, exitThenEnter = _ref.exitThenEnter;
    var _useState = (0, $5FkrB.useState)([
        null,
        children
    ]), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), stateChildren = _useState2[0], setChildren = _useState2[1];
    var _useState3 = (0, $5FkrB.useState)([]), _useState4 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState3, 2), exitingChildren = _useState4[0], setExitingChildren = _useState4[1];
    var _useState5 = (0, $5FkrB.useState)(function() {
        return {
            appear: appear,
            isExiting: false
        };
    }), _useState6 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState5, 2), defaultContext = _useState6[0], setDefaultContext = _useState6[1];
    (0, $5FkrB.useEffect)(function() {
        if (!defaultContext.appear) setDefaultContext({
            appear: true,
            isExiting: false
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    if ((0, $88b27043491c379a$export$b7baf7667a68d87c)()) return children;
    /**
   * NOTE: This is a workaround for the test case written in Jira where the stateChildren is a boolean value because
   * useState is mocked to return a boolean value.
   */ if (typeof stateChildren === 'boolean') return children;
    var _stateChildren = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(stateChildren, 2), previousChildren = _stateChildren[0], currentChildren = _stateChildren[1];
    var previous = $279dc552abf8fdf8$var$childrenToArray(previousChildren);
    var current = $279dc552abf8fdf8$var$childrenToArray(currentChildren);
    if (currentChildren !== children) setChildren([
        currentChildren,
        children
    ]);
    var missingKeys = $279dc552abf8fdf8$var$getMissingKeys(current, previous);
    var isSomeChildRemoved = !!missingKeys.size;
    var visibleChildren = current;
    if (isSomeChildRemoved) visibleChildren = $279dc552abf8fdf8$var$spliceNewElementsIntoPrevious(current, previous);
    if (exitThenEnter) {
        if (exitingChildren.length) visibleChildren = exitingChildren;
        else {
            var nextExitingChildren = visibleChildren.filter(function(child) {
                return missingKeys.has(child.key);
            });
            if (nextExitingChildren.length) setExitingChildren(nextExitingChildren);
        }
    }
    if (missingKeys.size) visibleChildren = visibleChildren.map(function(child) {
        var isExiting = missingKeys.has(child.key);
        return $279dc552abf8fdf8$var$wrapChildWithContextProvider(child, {
            appear: true,
            isExiting: isExiting,
            onFinish: isExiting ? function() {
                missingKeys.delete(child.key);
                if (missingKeys.size === 0) {
                    setChildren([
                        null,
                        children
                    ]);
                    setExitingChildren([]);
                }
            } : undefined
        });
    });
    else visibleChildren = visibleChildren.map(function(child) {
        return $279dc552abf8fdf8$var$wrapChildWithContextProvider(child, defaultContext);
    });
    return visibleChildren;
});
var $279dc552abf8fdf8$export$3b6f38abbdcbd000 = function useExitingPersistence() {
    return (0, $5FkrB.useContext)($279dc552abf8fdf8$var$ExitingContext);
};
$279dc552abf8fdf8$var$ExitingPersistence.displayName = 'ExitingPersistence';
var $279dc552abf8fdf8$export$2e2bcd8739ae039 = $279dc552abf8fdf8$var$ExitingPersistence;


var $25nEq = parcelRequire("25nEq");

var $5FkrB = parcelRequire("5FkrB");

var $25nEq = parcelRequire("25nEq");

var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");

var $74Zh5 = parcelRequire("74Zh5");

/**
 * Think of this as the motion equivalent of the @atlaskit/theme `grid()`.
 */ var $b632dc1fe882e141$export$368bacef0dacbe05 = 25;
var $b632dc1fe882e141$export$38b928a7167ce124 = {
    none: 0,
    small: 100,
    medium: 350,
    large: 700
};
/**
 * Used to multiply the initial duration for exiting motions.
 */ var $b632dc1fe882e141$var$EXITING_MOTION_MULTIPLIER = 0.5;
var $b632dc1fe882e141$export$30fa1a2e62ae150c = {
    none: $b632dc1fe882e141$export$38b928a7167ce124.none,
    small: $b632dc1fe882e141$export$38b928a7167ce124.small * $b632dc1fe882e141$var$EXITING_MOTION_MULTIPLIER,
    medium: $b632dc1fe882e141$export$38b928a7167ce124.medium * $b632dc1fe882e141$var$EXITING_MOTION_MULTIPLIER,
    large: $b632dc1fe882e141$export$38b928a7167ce124.large * $b632dc1fe882e141$var$EXITING_MOTION_MULTIPLIER
};



var $5FkrB = parcelRequire("5FkrB");
var $35f084c9aaa02784$var$getHookDeps = function getHookDeps(opts) {
    switch(opts.cleanup){
        case 'next-effect':
            return undefined;
        case 'unmount':
        default:
            return [];
    }
};
var $35f084c9aaa02784$export$1775f27e7c8051ca = function useRequestAnimationFrame() {
    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        cleanup: 'unmount'
    };
    var frames = (0, $5FkrB.useRef)([]);
    (0, $5FkrB.useEffect)(function() {
        return function() {
            if (frames.current.length) {
                frames.current.forEach(function(id) {
                    return cancelAnimationFrame(id);
                });
                frames.current = [];
            }
        };
    // We dynamically set this so we either clean up on the next effect - or on unmount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, $35f084c9aaa02784$var$getHookDeps(opts));
    return (0, $5FkrB.useCallback)(function(handler) {
        var id = requestAnimationFrame(function(time) {
            frames.current = frames.current.filter(function(frameId) {
                return frameId !== id;
            });
            handler(time);
        });
        frames.current.push(id);
    }, []);
};
var $35f084c9aaa02784$export$4f34107a2b00f39c = function useSetTimeout() {
    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        cleanup: 'unmount'
    };
    var timeouts = (0, $5FkrB.useRef)([]);
    (0, $5FkrB.useEffect)(function() {
        return function() {
            if (timeouts.current.length) {
                timeouts.current.forEach(function(id) {
                    return clearTimeout(id);
                });
                timeouts.current = [];
            }
        };
    // We dynamically set this so we either clean up on the next effect - or on unmount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, $35f084c9aaa02784$var$getHookDeps(opts));
    return (0, $5FkrB.useCallback)(function(handler, timeout) {
        for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)args[_key - 2] = arguments[_key];
        var id = setTimeout.apply(void 0, [
            function() {
                timeouts.current = timeouts.current.filter(function(timeoutId) {
                    return timeoutId !== id;
                });
                handler();
            },
            timeout
        ].concat(args));
        timeouts.current.push(id);
    }, []);
};




var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");


var $5FkrB = parcelRequire("5FkrB");
var $f54de321827ec3b8$export$e5c5a5f917a5871c = typeof window === 'undefined' ? (0, $5FkrB.useEffect) : (0, $5FkrB.useLayoutEffect);


/* eslint-disable @repo/internal/react/disallow-unstable-values */ 
var $5FkrB = parcelRequire("5FkrB");
function $3c84ce5e603ab806$export$c485849f2e393253() {
    var identifier = (0, $5FkrB.useRef)('');
    if (!identifier.current) identifier.current = '_' + (Number(String(Math.random()).slice(2)) + Date.now() + Math.round(performance.now())).toString(36);
    return identifier.current;
}


var $fa4d83632ab91076$var$StaggeredEntranceContext = /*#__PURE__*/ (0, $5FkrB.createContext)(function() {
    return {
        isReady: true,
        delay: 0,
        ref: (0, $f55684cf1f3dca29$export$2e2bcd8739ae039)
    };
});
var $fa4d83632ab91076$export$25c7213fc07ec080 = function useStaggeredEntrance() {
    var indentifier = (0, $3c84ce5e603ab806$export$c485849f2e393253)();
    var context = (0, $5FkrB.useContext)($fa4d83632ab91076$var$StaggeredEntranceContext);
    return context(indentifier);
};
/**
 * For a list of elements that need to animate in,
 * this should be used in conjunction with entering components.
 * This does not need Javascript to execute so it will run immediately for any SSR rendered React apps before the JS has executed.
 *
 * Will dynamically add delay to each child entering component.
 * Unfortunately all entering components _NEED_ to be a direct descendant.
 */ var $fa4d83632ab91076$var$StaggeredEntrance = function StaggeredEntrance(_ref) {
    var children = _ref.children, column = _ref.column, _ref$columns = _ref.columns, columns = _ref$columns === void 0 ? 'responsive' : _ref$columns, _ref$delayStep = _ref.delayStep, delayStep = _ref$delayStep === void 0 ? 50 : _ref$delayStep;
    var elementRefs = (0, $5FkrB.useRef)([]);
    var indexes = [];
    var _useState = (0, $5FkrB.useState)(function() {
        if (typeof columns === 'number') // A hardcoded columns is set so bail out and set it to that!
        return columns;
        if (typeof column === 'number') // A hardcoded column is set so we will set actualColumns to be 1.
        return 1;
        // We are in "responsive" mode.
        // So we will be calculating when the Javascript executes on the client how many columns there will be.
        return 0;
    }), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), actualColumns = _useState2[0], setActualColumns = _useState2[1];
    (0, $f54de321827ec3b8$export$e5c5a5f917a5871c)(function() {
        // We want to only run this code when we are in "responsive" mode.
        // It is assumed we are in responsive mode if `columns` is "responsive",
        // we have children element refs ready to be read (i.e. if there are no children this won't run as well)
        // and finally that `actualColumns` is `0` - this is because for the first render cycle `actualColumns` will be `0` (set above)
        // and then after this layout effect runs the value for `actualColumns` will then be calculated and set.
        if (columns === 'responsive' && elementRefs.current.length && actualColumns === 0) {
            var currentTop = 0;
            var numberColumns = 0;
            if (elementRefs.current.length <= 1) {
                setActualColumns(1);
                return;
            }
            // We set the current top to the first elements.
            // We will be comparing this and incrementing the column count
            // until we hit an element that has a different offset top (or we run out of elements).
            currentTop = elementRefs.current[0] ? elementRefs.current[0].offsetTop : 0;
            for(var i = 0; i < elementRefs.current.length; i++){
                var child = elementRefs.current[i];
                if (!child) break;
                if (currentTop === child.offsetTop) {
                    numberColumns += 1;
                    if (elementRefs.current.length - 1 === i) setActualColumns(numberColumns);
                    continue;
                }
                setActualColumns(numberColumns);
                break;
            }
        }
    // We only want this effect to run once - on initial mount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement($fa4d83632ab91076$var$StaggeredEntranceContext.Provider, {
        value: function value(id) {
            if (!indexes.includes(id)) indexes.push(id);
            var isReady = actualColumns > 0;
            var index = indexes.indexOf(id);
            var currentColumn = column || index % actualColumns;
            var currentRow = Math.floor(index / actualColumns);
            var distanceFromTopLeftElement = currentRow + currentColumn;
            // We don't want loads of elements to have the same staggered delay as it ends up looking slow for users.
            // To get around that we calculate the logarithm using `distanceFromTopLeftElement` which ends making
            // elements appear faster the further away from the top left element.
            var delay = Math.ceil(Math.log(distanceFromTopLeftElement + 1) * delayStep * 1.5) || 0;
            return {
                delay: delay,
                isReady: isReady,
                ref: function ref(element) {
                    return elementRefs.current[index] = element;
                }
            };
        }
    }, children);
};
var $fa4d83632ab91076$export$2e2bcd8739ae039 = $fa4d83632ab91076$var$StaggeredEntrance;


function $1d16079d945cd06c$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $1d16079d945cd06c$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $1d16079d945cd06c$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $1d16079d945cd06c$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
/**
 * These are props that motions should use as their external props for consumers.
 * See [FadeIn](packages/helpers/motion/src/entering/fade-in.tsx) for an example usage.
 */ /**
 * This is the base INTERNAL component used for all other entering motions.
 * This does not need Javascript to execute on the client so it will run immediately
 * for any SSR rendered React apps before the JS has executed.
 */ var $1d16079d945cd06c$var$EnteringMotion = function EnteringMotion(_ref) {
    var children = _ref.children, animationTimingFunction = _ref.animationTimingFunction, _ref$animationTimingF = _ref.animationTimingFunctionExiting, animationTimingFunctionExiting = _ref$animationTimingF === void 0 ? animationTimingFunction : _ref$animationTimingF, enteringAnimation = _ref.enteringAnimation, _ref$exitingAnimation = _ref.exitingAnimation, exitingAnimation = _ref$exitingAnimation === void 0 ? enteringAnimation : _ref$exitingAnimation, isPaused = _ref.isPaused, onFinishMotion = _ref.onFinish, _ref$duration = _ref.duration, duration = _ref$duration === void 0 ? 'large' : _ref$duration;
    var staggered = (0, $fa4d83632ab91076$export$25c7213fc07ec080)();
    var _useExitingPersistenc = (0, $279dc552abf8fdf8$export$3b6f38abbdcbd000)(), isExiting = _useExitingPersistenc.isExiting, onExitFinished = _useExitingPersistenc.onFinish, appear = _useExitingPersistenc.appear;
    var setTimeout = (0, $35f084c9aaa02784$export$4f34107a2b00f39c)();
    var paused = isPaused || !staggered.isReady;
    var delay = isExiting ? 0 : staggered.delay;
    var state = isExiting ? 'exiting' : 'entering';
    var _useState = (0, $5FkrB.useState)(appear), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), hasAnimationStyles = _useState2[0], setHasAnimationStyles = _useState2[1];
    (0, $5FkrB.useEffect)(function() {
        // Tracking this to prevent changing state on an unmounted component
        var isCancelled = false;
        if (paused) return;
        // On initial mount if elements aren't set to animate on appear, we return early and callback
        if (!appear) {
            onFinishMotion && onFinishMotion(state);
            return;
        }
        // Elements may need animation styles back after initial mount (they could animate out)
        setHasAnimationStyles(true);
        setTimeout(function() {
            if (state === 'exiting') onExitFinished && onExitFinished();
            if (!isCancelled) setHasAnimationStyles(false);
            onFinishMotion && onFinishMotion(state);
        }, isExiting ? (0, $b632dc1fe882e141$export$30fa1a2e62ae150c)[duration] : (0, $b632dc1fe882e141$export$38b928a7167ce124)[duration] + delay);
        return function() {
            isCancelled = true;
        };
    // We ignore this for onFinishMotion as consumers could potentially inline the function
    // which would then trigger this effect every re-render.
    // We want to make it easier for consumers so we go down this path unfortunately.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        onExitFinished,
        state,
        isExiting,
        duration,
        delay,
        paused,
        setTimeout
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $74Zh5.ClassNames), null, function(_ref2) {
        var css = _ref2.css, cx = _ref2.cx;
        return children({
            ref: staggered.ref,
            className: hasAnimationStyles ? cx(css($1d16079d945cd06c$var$_objectSpread($1d16079d945cd06c$var$_objectSpread({}, (0, $88b27043491c379a$export$f0f789643ba5a83c)), {}, {
                animationDelay: "".concat(delay, "ms"),
                animationFillMode: 'backwards',
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
                animationName: (0, $74Zh5.keyframes)(enteringAnimation),
                animationPlayState: 'running'
            })), paused && css({
                animationPlayState: 'paused'
            }), duration === 'small' && css({
                animationDuration: '100ms'
            }), duration === 'medium' && css({
                animationDuration: '350ms'
            }), duration === 'large' && css({
                animationDuration: '700ms'
            }), isExiting && duration === 'small' && css({
                animationDuration: '50ms'
            }), isExiting && duration === 'medium' && css({
                animationDuration: '175ms'
            }), isExiting && duration === 'large' && css({
                animationDuration: '350ms'
            }), isExiting && css({
                animationDelay: '0ms',
                animationFillMode: 'forwards',
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
                animationName: (0, $74Zh5.keyframes)(exitingAnimation)
            }), !isExiting && animationTimingFunction === 'linear' && css({
                animationTimingFunction: 'cubic-bezier(0,0,1,1)'
            }), !isExiting && animationTimingFunction === 'ease-out' && css({
                animationTimingFunction: 'cubic-bezier(0.2,0,0,1)'
            }), !isExiting && animationTimingFunction === 'ease-in' && css({
                animationTimingFunction: 'cubic-bezier(0.8,0,0,0.8)'
            }), !isExiting && animationTimingFunction === 'ease-in-out' && css({
                animationTimingFunction: 'cubic-bezier(0.15,1,0.3,1)'
            }), isExiting && animationTimingFunction === 'linear' && css({
                animationTimingFunction: 'cubic-bezier(0,0,1,1)'
            }), isExiting && animationTimingFunctionExiting === 'ease-out' && css({
                animationTimingFunction: 'cubic-bezier(0.2,0,0,1)'
            }), isExiting && animationTimingFunctionExiting === 'ease-in' && css({
                animationTimingFunction: 'cubic-bezier(0.8,0,0,0.8)'
            }), isExiting && animationTimingFunctionExiting === 'ease-in-out' && css({
                animationTimingFunction: 'cubic-bezier(0.15,1,0.3,1)'
            })) : ''
        }, state);
    });
};
var $1d16079d945cd06c$export$2e2bcd8739ae039 = $1d16079d945cd06c$var$EnteringMotion;


function $bfc9e4af75d9628a$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $bfc9e4af75d9628a$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $bfc9e4af75d9628a$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $bfc9e4af75d9628a$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $bfc9e4af75d9628a$var$directionMotions = {
    proportional: {
        bottom: 'translate3d(0, calc(5% + 4px), 0)',
        left: 'translate3d(calc(-5% - 4px), 0, 0)',
        right: 'translate3d(calc(5% + 4px), 0, 0)',
        top: 'translate3d(0, calc(-5% - 4px), 0)'
    },
    constant: {
        bottom: 'translate3d(0, 4px, 0)',
        left: 'translate3d(-4px, 0, 0)',
        right: 'translate3d(4px, 0, 0)',
        top: 'translate3d(0, -4px, 0)'
    }
};
var $bfc9e4af75d9628a$var$invertedDirection = {
    top: 'bottom',
    bottom: 'top',
    left: 'right',
    right: 'left'
};
var $bfc9e4af75d9628a$export$8497679fcaaeceb = function fadeInAnimation(direction) {
    var distance = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'proportional';
    return {
        from: $bfc9e4af75d9628a$var$_objectSpread({
            opacity: 0
        }, direction !== undefined && {
            transform: $bfc9e4af75d9628a$var$directionMotions[distance][direction]
        }),
        '50%': {
            opacity: 1
        },
        to: {
            transform: direction !== undefined ? 'none' : undefined
        }
    };
};
var $bfc9e4af75d9628a$export$c9190c6659ea755b = function fadeOutAnimation(direction) {
    var distance = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'proportional';
    return {
        from: {
            opacity: 1,
            transform: direction !== undefined ? 'translate3d(0, 0, 0)' : undefined
        },
        to: $bfc9e4af75d9628a$var$_objectSpread({
            opacity: 0
        }, direction !== undefined && {
            transform: $bfc9e4af75d9628a$var$directionMotions[distance][direction]
        })
    };
};
/**
 * Props for controlling the behavior of the FadeIn animation
 */ /**
 * __FadeIn__
 *
 * Useful for fading in one or more elements.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/motion/docs/entering-motions)
 */ var $bfc9e4af75d9628a$var$FadeIn = function FadeIn(_ref) {
    var children = _ref.children, _ref$duration = _ref.duration, duration = _ref$duration === void 0 ? 'large' : _ref$duration, entranceDirection = _ref.entranceDirection, exitDirection = _ref.exitDirection, _ref$distance = _ref.distance, distance = _ref$distance === void 0 ? 'proportional' : _ref$distance, onFinish = _ref.onFinish, isPaused = _ref.isPaused;
    var invertedEntranceDirection = entranceDirection && $bfc9e4af75d9628a$var$invertedDirection[entranceDirection];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $1d16079d945cd06c$export$2e2bcd8739ae039), {
        duration: duration,
        enteringAnimation: $bfc9e4af75d9628a$export$8497679fcaaeceb(entranceDirection, distance),
        exitingAnimation: $bfc9e4af75d9628a$export$c9190c6659ea755b(exitDirection || invertedEntranceDirection, distance),
        animationTimingFunction: "ease-in-out",
        onFinish: onFinish,
        isPaused: isPaused
    }, children);
};
var $bfc9e4af75d9628a$export$2e2bcd8739ae039 = $bfc9e4af75d9628a$var$FadeIn;



var $fC8ib = parcelRequire("fC8ib");

var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");

var $lsgol = parcelRequire("lsgol");

var $iYJcE = parcelRequire("iYJcE");
function $89f22c4eb4801c64$export$6d8c2b45c99d6e3f(_ref) {
    var viewportPadding = _ref.viewportPadding;
    return [
        {
            /**
     * Performing DOM measurements in the 'read' phase,
     * which is the convention for popper modifiers
     */ name: 'maxSizeData',
            enabled: true,
            phase: 'read',
            fn: function fn(_ref2) {
                var state = _ref2.state, name = _ref2.name;
                if (!window.visualViewport) return;
                state.modifiersData[name] = {
                    viewport: {
                        width: window.visualViewport.width,
                        height: window.visualViewport.height
                    }
                };
            }
        },
        {
            /**
     * Applying max size CSS
     */ name: 'maxSize',
            enabled: true,
            phase: 'beforeWrite',
            requiresIfExists: [
                'offset',
                'preventOverflow',
                'flip'
            ],
            fn: function fn(_ref3) {
                var _data$viewport, _data$viewport2, _state$modifiersData$2, _state$modifiersData;
                var state = _ref3.state;
                var data = state.modifiersData.maxSizeData;
                if (typeof (data === null || data === void 0 || (_data$viewport = data.viewport) === null || _data$viewport === void 0 ? void 0 : _data$viewport.width) !== 'number' || typeof (data === null || data === void 0 || (_data$viewport2 = data.viewport) === null || _data$viewport2 === void 0 ? void 0 : _data$viewport2.height) !== 'number') // This shouldn't occur in a real browser but might in non-browser test environments
                return;
                var viewport = data.viewport;
                var _state$modifiersData$ = state.modifiersData.popperOffsets, popperOffsets = _state$modifiersData$ === void 0 ? {
                    x: 0,
                    y: 0
                } : _state$modifiersData$;
                var _state$placement$spli = state.placement.split('-'), _state$placement$spli2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_state$placement$spli, 1), basePlacement = _state$placement$spli2[0];
                var placementOffset = (_state$modifiersData$2 = (_state$modifiersData = state.modifiersData) === null || _state$modifiersData === void 0 || (_state$modifiersData = _state$modifiersData.offset) === null || _state$modifiersData === void 0 ? void 0 : _state$modifiersData[state.placement]) !== null && _state$modifiersData$2 !== void 0 ? _state$modifiersData$2 : {
                    x: 0,
                    y: 0
                };
                // By default we set these to the entire viewport (minus padding)
                // Each placement direction will overwrite one of these
                var maxWidth = viewport.width - 2 * viewportPadding;
                var maxHeight = viewport.height - 2 * viewportPadding;
                if (basePlacement === 'top') maxHeight = state.rects.reference.y + // Viewport-relative position of reference element
                placementOffset.y - // Space between popper and reference
                viewportPadding;
                if (basePlacement === 'bottom') maxHeight = viewport.height - popperOffsets.y - // Viewport-relative position of popper
                viewportPadding;
                if (basePlacement === 'left') maxWidth = state.rects.reference.x + // Viewport-relative position of reference element
                placementOffset.x - // Space between popper and reference
                viewportPadding;
                if (basePlacement === 'right') maxWidth = viewport.width - popperOffsets.x - // Viewport-relative position of popper
                viewportPadding;
                state.styles.popper.maxWidth = "".concat(maxWidth, "px");
                state.styles.popper.maxHeight = "".concat(maxHeight, "px");
            }
        }
    ];
}



// Export types from PopperJS / React Popper
var $67f08545af890619$var$viewportPadding = 5;
var $67f08545af890619$var$constantModifiers = [
    {
        name: 'flip',
        options: {
            flipVariations: false,
            padding: $67f08545af890619$var$viewportPadding,
            boundary: 'clippingParents',
            rootBoundary: 'viewport'
        }
    }
];
function $67f08545af890619$var$defaultChildrenFn() {
    return null;
}
var $67f08545af890619$var$defaultOffset = [
    0,
    8
];
function $67f08545af890619$export$badac9ada3a0bdf9(_ref) {
    var _ref$children = _ref.children, children = _ref$children === void 0 ? $67f08545af890619$var$defaultChildrenFn : _ref$children, _ref$offset = _ref.offset, offset = _ref$offset === void 0 ? $67f08545af890619$var$defaultOffset : _ref$offset, _ref$placement = _ref.placement, placement = _ref$placement === void 0 ? 'bottom-start' : _ref$placement, _ref$referenceElement = _ref.referenceElement, referenceElement = _ref$referenceElement === void 0 ? undefined : _ref$referenceElement, modifiers = _ref.modifiers, _ref$strategy = _ref.strategy, strategy = _ref$strategy === void 0 ? 'fixed' : _ref$strategy, _ref$shouldFitViewpor = _ref.shouldFitViewport, shouldFitViewport = _ref$shouldFitViewpor === void 0 ? false : _ref$shouldFitViewpor;
    var _offset = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(offset, 2), offsetX = _offset[0], offsetY = _offset[1];
    var internalModifiers = (0, $5FkrB.useMemo)(function() {
        var preventOverflowModifier = {
            name: 'preventOverflow',
            options: {
                padding: $67f08545af890619$var$viewportPadding,
                rootBoundary: shouldFitViewport ? 'viewport' : 'document'
            }
        };
        var offsetModifier = {
            name: 'offset',
            options: {
                offset: [
                    offsetX,
                    offsetY
                ]
            }
        };
        var maxSizeModifiers = shouldFitViewport ? (0, $89f22c4eb4801c64$export$6d8c2b45c99d6e3f)({
            viewportPadding: $67f08545af890619$var$viewportPadding
        }) : [];
        // @ts-ignore Type errors from incompatible @popperjs/core versions between Jira and AFM Platform... we are using ts-ignore here because ts-expect-error will cause an "Unused '@ts-expect-error' directive." error
        return [].concat($67f08545af890619$var$constantModifiers, [
            preventOverflowModifier,
            offsetModifier
        ], (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(maxSizeModifiers));
    }, [
        offsetX,
        offsetY,
        shouldFitViewport
    ]);
    // Merge custom props and memoize
    var mergedModifiers = (0, $5FkrB.useMemo)(function() {
        if (modifiers == null) return internalModifiers;
        return [].concat((0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(internalModifiers), (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(modifiers));
    }, [
        internalModifiers,
        modifiers
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $lsgol.Popper), {
        modifiers: mergedModifiers,
        placement: placement,
        strategy: strategy,
        referenceElement: referenceElement
    }, children);
}



var $5FkrB = parcelRequire("5FkrB");

var $dU8Y3 = parcelRequire("dU8Y3");

var $5FkrB = parcelRequire("5FkrB");

var $aLeHs = parcelRequire("aLeHs");
var $8ced1cbfbab48b97$export$e4c79eb95c23a0da = 'atlaskit-portal-container';
var $8ced1cbfbab48b97$export$72f415121273627e = 'body > .atlaskit-portal-container';
var $8ced1cbfbab48b97$export$13f57c02915787b3 = 'atlaskit-portal';


var $b1a359bb51796e07$export$26ae5ca175b4ec5a = function createContainer(zIndex) {
    var container = document.createElement('div');
    container.className = (0, $8ced1cbfbab48b97$export$13f57c02915787b3);
    container.style.zIndex = "".concat(zIndex);
    return container;
};
/**
 * Returns document body element
 * @return {number} - The document body element
 */ var $b1a359bb51796e07$var$getBody = function getBody() {
    return document.body;
};
/**
 * Returns portal parent container. If no container exists already then it creates a new container with class name 'atlaskit-portal-container'
 * @return {Element} - The portal parent container div element
 */ var $b1a359bb51796e07$var$getPortalParent = function getPortalParent() {
    var parentElement = document.querySelector((0, $8ced1cbfbab48b97$export$72f415121273627e));
    if (!parentElement) {
        var _getBody;
        var parent = document.createElement('div');
        parent.className = (0, $8ced1cbfbab48b97$export$e4c79eb95c23a0da);
        // we are setting display to flex because we want each portal to create a new stacking context
        // See https://developer.mozilla.org/en-US/docs/Web/CSS/CSS_Positioning/Understanding_z_index/The_stacking_context
        parent.style.display = 'flex';
        (_getBody = $b1a359bb51796e07$var$getBody()) === null || _getBody === void 0 || _getBody.appendChild(parent);
        return parent;
    }
    return parentElement;
};
var $b1a359bb51796e07$export$da99f98bf3fe55b3 = function removePortalContainer(container) {
    $b1a359bb51796e07$var$getPortalParent().removeChild(container);
};
var $b1a359bb51796e07$export$c582005add11e141 = function appendPortalContainerIfNotAppended(container) {
    if (!container.parentElement) $b1a359bb51796e07$var$getPortalParent().appendChild(container);
};
var $b1a359bb51796e07$export$842dfe7a9f24298 = function isDocumentDefined() {
    return document !== undefined;
};
var $b1a359bb51796e07$export$fef014d7cef9e543 = function createAtlaskitPortal(zIndex) {
    //atlaskit-portal div
    if ($b1a359bb51796e07$export$842dfe7a9f24298()) {
        var atlaskitportal = document.createElement('div');
        atlaskitportal.className = (0, $8ced1cbfbab48b97$export$13f57c02915787b3);
        atlaskitportal.style.zIndex = "".concat(zIndex);
        return atlaskitportal;
    }
};
var $b1a359bb51796e07$export$95029ca7aca2989e = function createPortalParent() {
    //atlaskit-portal-container div
    if ($b1a359bb51796e07$export$842dfe7a9f24298()) {
        var parentElement = document.querySelector((0, $8ced1cbfbab48b97$export$72f415121273627e));
        if (!parentElement) {
            var _getBody2;
            var parent = document.createElement('div');
            parent.className = (0, $8ced1cbfbab48b97$export$e4c79eb95c23a0da);
            parent.style.display = 'flex';
            (_getBody2 = $b1a359bb51796e07$var$getBody()) === null || _getBody2 === void 0 || _getBody2.appendChild(parent);
            return parent;
        }
        return parentElement;
    }
};


function $e5023abaeee4ba33$export$2e2bcd8739ae039(props) {
    var zIndex = props.zIndex, children = props.children;
    var container = (0, $5FkrB.useMemo)(function() {
        return (0, $b1a359bb51796e07$export$26ae5ca175b4ec5a)(zIndex);
    }, [
        zIndex
    ]);
    // This is in the render method instead of useEffect so that
    // the portal will be added to the DOM before the children render.
    // For any further changes, ensure that the container does not have a
    // parent besides the portal parent.
    (0, $b1a359bb51796e07$export$c582005add11e141)(container);
    (0, $5FkrB.useEffect)(function() {
        return function() {
            (0, $b1a359bb51796e07$export$da99f98bf3fe55b3)(container);
        };
    }, [
        container
    ]);
    return /*#__PURE__*/ (0, $aLeHs.createPortal)(children, container);
}



var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");

var $aLeHs = parcelRequire("aLeHs");

var $dU8Y3 = parcelRequire("dU8Y3");

var $5FkrB = parcelRequire("5FkrB");
var $4e2565acf34bbb18$export$700979bc83e7db82 = typeof window !== 'undefined' ? (0, $5FkrB.useLayoutEffect) : (0, $5FkrB.useEffect);



function $0eed6db587c19fc5$export$2e2bcd8739ae039(props) {
    var zIndex = props.zIndex, children = props.children;
    var _useState = (0, $5FkrB.useState)(null), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), atlaskitPortal = _useState2[0], setAtlaskitPortal = _useState2[1];
    (0, $4e2565acf34bbb18$export$700979bc83e7db82)(function() {
        var tempPortalContainer = (0, $b1a359bb51796e07$export$fef014d7cef9e543)(zIndex);
        setAtlaskitPortal(tempPortalContainer);
        var portalParent = (0, $b1a359bb51796e07$export$95029ca7aca2989e)();
        if (!tempPortalContainer || !portalParent) return;
        portalParent.appendChild(tempPortalContainer);
        return function() {
            if (tempPortalContainer) portalParent.removeChild(tempPortalContainer);
            setAtlaskitPortal(null);
        };
    }, [
        zIndex
    ]);
    /**
   * Conditionally wrap ALL portal children with Suspense behind a feature gate for safe rollout.
   *
   * This is here because in React 18 concurrent, if you suspend from _within_ a portal to a
   * suspense boundary _outside_ a portal, our portal gets in an infinite loop of re-rendering.
   */ var conditionallySuspendedChildren = (0, $dU8Y3.fg)('platform_design_system_suspend_portal_children') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $5FkrB.Suspense), {
        fallback: null
    }, children) : children;
    return atlaskitPortal ? /*#__PURE__*/ (0, $aLeHs.createPortal)(conditionallySuspendedChildren, atlaskitPortal) : null;
}



var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");

var $eadbc0490deeb437$var$useIsSubsequentRender = function useIsSubsequentRender(mountStrategy) {
    var _useState = (0, $5FkrB.useState)(false), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), isSubsequentRender = _useState2[0], setIsSubsequentRender = _useState2[1];
    var _useState3 = (0, $5FkrB.useState)(function() {
        return mountStrategy === 'layoutEffect' ? (0, $4e2565acf34bbb18$export$700979bc83e7db82) : (0, $5FkrB.useEffect);
    }), _useState4 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState3, 1), useMountEffect = _useState4[0];
    useMountEffect(function() {
        setIsSubsequentRender(true);
    }, []);
    return isSubsequentRender;
};
var $eadbc0490deeb437$export$2e2bcd8739ae039 = $eadbc0490deeb437$var$useIsSubsequentRender;



var $5FkrB = parcelRequire("5FkrB");
var $97476f5805d5f9eb$export$ed5835cc67e87f72 = 'akPortalMount';
var $97476f5805d5f9eb$export$80816bd900e5bd00 = 'akPortalUnmount';


var $cbee376d381659b5$var$zIndexToName = {
    100: 'card',
    200: 'navigation',
    300: 'dialog',
    400: 'layer',
    500: 'blanket',
    510: 'modal',
    600: 'flag',
    700: 'spotlight',
    9999: 'tooltip'
};
/**
 * return layer name in Atlassian design system corresponding to given z-index
 * @param {number} zIndex - z-index value for which layer name is needed
 * @returns {LayerName | null} - The layer name for given z-index. If layer name is not found then null is returned
 */ var $cbee376d381659b5$var$getLayerName = function getLayerName(zIndex) {
    return $cbee376d381659b5$var$zIndexToName.hasOwnProperty(zIndex) ? $cbee376d381659b5$var$zIndexToName[zIndex] : null;
};
/**
 * Creates a PortalEvent object with given eventName, given zIndex and corresponding layer
 * @param {string} eventName - either of Mount or Unmount event name
 * @param {number} zIndex - z-index value which will be included in the event to be dispatched
 * @returns {PortalEvent} - The newly created PortalEvent object
 */ var $cbee376d381659b5$var$getEvent = function getEvent(eventName, zIndex) {
    var detail = {
        layer: $cbee376d381659b5$var$getLayerName(Number(zIndex)),
        zIndex: zIndex
    };
    return new CustomEvent(eventName, {
        detail: detail
    });
};
function $cbee376d381659b5$export$2e2bcd8739ae039(eventName, zIndex) {
    var event = $cbee376d381659b5$var$getEvent(eventName, zIndex);
    window.dispatchEvent(event);
}


var $f78cecffec987430$var$useFirePortalEvent = function useFirePortalEvent(zIndex) {
    var zIndexNumber = Number(zIndex);
    (0, $5FkrB.useEffect)(function() {
        (0, $cbee376d381659b5$export$2e2bcd8739ae039)((0, $97476f5805d5f9eb$export$ed5835cc67e87f72), zIndexNumber);
        return function() {
            (0, $cbee376d381659b5$export$2e2bcd8739ae039)((0, $97476f5805d5f9eb$export$80816bd900e5bd00), zIndexNumber);
        };
    }, [
        zIndexNumber
    ]);
};
var $f78cecffec987430$export$2e2bcd8739ae039 = $f78cecffec987430$var$useFirePortalEvent;


function $b4317fbf92c4744e$export$2e2bcd8739ae039(_ref) {
    var _ref$zIndex = _ref.zIndex, zIndex = _ref$zIndex === void 0 ? 0 : _ref$zIndex, children = _ref.children, _ref$mountStrategy = _ref.mountStrategy, mountStrategy = _ref$mountStrategy === void 0 ? 'effect' : _ref$mountStrategy;
    var isSubsequentRender = (0, $eadbc0490deeb437$export$2e2bcd8739ae039)(mountStrategy);
    (0, $f78cecffec987430$export$2e2bcd8739ae039)(zIndex);
    // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
    return !(0, $dU8Y3.fg)('platform_design_system_team_portal_logic_r18_fix') ? isSubsequentRender ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $e5023abaeee4ba33$export$2e2bcd8739ae039), {
        zIndex: zIndex
    }, children) : null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $0eed6db587c19fc5$export$2e2bcd8739ae039), {
        zIndex: zIndex
    }, children);
}


/* eslint-disable no-console */ var $b3e12cd82bd89e1a$var$printed = {};
function $b3e12cd82bd89e1a$export$2e2bcd8739ae039(message) {
    if ($b3e12cd82bd89e1a$var$printed[message]) return;
    $b3e12cd82bd89e1a$var$printed[message] = true;
    if (typeof window !== 'undefined') console.warn(message);
}



var $3ZMUU = parcelRequire("3ZMUU");
function $3e78f3b7a8138316$export$2e2bcd8739ae039(packageName, api, additionalMessage) {
    (0, $b3e12cd82bd89e1a$export$2e2bcd8739ae039)("[".concat(packageName, "]: The ").concat(api, " is deprecated.").concat(additionalMessage && " ".concat(additionalMessage)));
}
function $3e78f3b7a8138316$export$eb1decd851a5ae56(packageName, propName, predicate, deprecationAnnouncementOnDAC) {
    typeof $3ZMUU;
}


/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ // Reds
var $4748d5438bd47003$export$4b84fd0e2c617bd = '#FFEBE6';
var $4748d5438bd47003$export$b34b069eff244586 = '#FFBDAD';
var $4748d5438bd47003$export$be802dd0d8b57f35 = '#FF8F73';
var $4748d5438bd47003$export$60847d42f9da92a6 = '#FF7452';
var $4748d5438bd47003$export$4a7404f376229999 = '#FF5630';
var $4748d5438bd47003$export$2010d0fb4295b346 = '#DE350B';
var $4748d5438bd47003$export$2837b5a1a71d5c02 = '#BF2600';
var $4748d5438bd47003$export$8d9596b529bbb9cf = '#FFFAE6';
var $4748d5438bd47003$export$41060a744ab0b7ae = '#FFF0B3';
var $4748d5438bd47003$export$1cc05bbbf340e559 = '#FFE380';
var $4748d5438bd47003$export$5aae31392d72caaa = '#FFC400';
var $4748d5438bd47003$export$c6930421db9fa514 = '#FFAB00';
var $4748d5438bd47003$export$59619663aa6500fb = '#FF991F';
var $4748d5438bd47003$export$874739ea9e379ab6 = '#FF8B00';
var $4748d5438bd47003$export$8a6341c32b6a3ee6 = '#E3FCEF';
var $4748d5438bd47003$export$69a3bf21b9686c2b = '#ABF5D1';
var $4748d5438bd47003$export$afbce1382ec95f73 = '#79F2C0';
var $4748d5438bd47003$export$747d86715d4175de = '#57D9A3';
var $4748d5438bd47003$export$940e1f69e873f202 = '#36B37E';
var $4748d5438bd47003$export$a49394138f7b8e85 = '#00875A';
var $4748d5438bd47003$export$6fa04827ac68a4fb = '#006644';
var $4748d5438bd47003$export$226de0355ed012f8 = '#DEEBFF';
var $4748d5438bd47003$export$8c13c2ee36917869 = '#B3D4FF';
var $4748d5438bd47003$export$ecfc1dff386a3e7a = '#4C9AFF';
var $4748d5438bd47003$export$215b7063051591f1 = '#2684FF';
var $4748d5438bd47003$export$e62e8919cca44969 = '#0065FF';
var $4748d5438bd47003$export$b3de0ae08da2ce64 = '#0052CC';
var $4748d5438bd47003$export$a6ee3d71bc067634 = '#0747A6';
var $4748d5438bd47003$export$67f15409e87642a1 = '#669DF1';
var $4748d5438bd47003$export$f0539dbc42dbb067 = '#8FB8F6';
var $4748d5438bd47003$export$363e4475840015bb = '#EAE6FF';
var $4748d5438bd47003$export$4b0a4417ed59760f = '#C0B6F2';
var $4748d5438bd47003$export$6011520a64d9a187 = '#998DD9';
var $4748d5438bd47003$export$a7175d4e9206bc80 = '#8777D9';
var $4748d5438bd47003$export$b48405b95304b5a1 = '#6554C0';
var $4748d5438bd47003$export$c71e4279dd54a18d = '#5243AA';
var $4748d5438bd47003$export$147899de772240ec = '#403294';
var $4748d5438bd47003$export$2cf711fe14c66f06 = '#E6FCFF';
var $4748d5438bd47003$export$7a8f4d33f6f9772c = '#B3F5FF';
var $4748d5438bd47003$export$776c9c497ef08533 = '#79E2F2';
var $4748d5438bd47003$export$69cb3ca10c1e330e = '#00C7E6';
var $4748d5438bd47003$export$9dc1ef0f3f48059b = '#00B8D9';
var $4748d5438bd47003$export$7c835c78b6fcdef8 = '#00A3BF';
var $4748d5438bd47003$export$6036577f95c3877e = '#008DA6';
var $4748d5438bd47003$export$29a4f05edc054374 = '#FFFFFF';
var $4748d5438bd47003$export$e655ef011c4aa1a2 = '#FAFBFC';
var $4748d5438bd47003$export$9fdfb749e33cdf97 = '#F4F5F7';
var $4748d5438bd47003$export$3e51e8f1440314ba = '#EBECF0';
var $4748d5438bd47003$export$1ce2d1575d444ceb = '#DFE1E6';
var $4748d5438bd47003$export$8754fc7e6d8b3000 = '#C1C7D0';
var $4748d5438bd47003$export$c2e91cbeada39b8b = '#B3BAC5';
var $4748d5438bd47003$export$5f71e19f3a7ad9de = '#A5ADBA';
var $4748d5438bd47003$export$eaa8c8a70ac22806 = '#97A0AF';
var $4748d5438bd47003$export$7c87d337fb91a97d = '#8993A4';
var $4748d5438bd47003$export$d6447c357493214f = '#7A869A';
var $4748d5438bd47003$export$f563ee71e9ee74cd = '#6B778C';
var $4748d5438bd47003$export$e2ef2124cf4024b1 = '#5E6C84';
var $4748d5438bd47003$export$eece5f492e429f08 = '#505F79';
var $4748d5438bd47003$export$c39c0fe0f26207ae = '#42526E';
var $4748d5438bd47003$export$7090862dc3038a9f = '#344563';
var $4748d5438bd47003$export$ad0bacf983b7ddaa = '#253858';
var $4748d5438bd47003$export$7d61b15e0da132af = '#172B4D';
var $4748d5438bd47003$export$fbda843f0a27fe96 = '#091E42';
var $4748d5438bd47003$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
var $4748d5438bd47003$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
var $4748d5438bd47003$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
var $4748d5438bd47003$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
var $4748d5438bd47003$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
var $4748d5438bd47003$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
var $4748d5438bd47003$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
var $4748d5438bd47003$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
var $4748d5438bd47003$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
var $4748d5438bd47003$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
var $4748d5438bd47003$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
var $4748d5438bd47003$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
var $4748d5438bd47003$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
var $4748d5438bd47003$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
var $4748d5438bd47003$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
var $4748d5438bd47003$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
var $4748d5438bd47003$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
var $4748d5438bd47003$export$2f6319cf7d736c2a = '#E6EDFA';
var $4748d5438bd47003$export$95126bc8884d6634 = '#DCE5F5';
var $4748d5438bd47003$export$8338d8c35d44ff1 = '#CED9EB';
var $4748d5438bd47003$export$5368d76ae4fbbda7 = '#B8C7E0';
var $4748d5438bd47003$export$9f0a771d16ec8d36 = '#ABBBD6';
var $4748d5438bd47003$export$abcf8c38338b4aa5 = '#9FB0CC';
var $4748d5438bd47003$export$97e81faa16a182c7 = '#8C9CB8';
var $4748d5438bd47003$export$bfe21c59123ecf33 = '#7988A3';
var $4748d5438bd47003$export$ee82aa2ea6a1558 = '#67758F';
var $4748d5438bd47003$export$682927c6ed76be02 = '#56637A';
var $4748d5438bd47003$export$91fd9994c5be9757 = '#455166';
var $4748d5438bd47003$export$d281fbfe3cff2df6 = '#3B475C';
var $4748d5438bd47003$export$3902c91d8b98a753 = '#313D52';
var $4748d5438bd47003$export$8e8133c1ba5845b5 = '#283447';
var $4748d5438bd47003$export$33ff357f6620b39 = '#202B3D';
var $4748d5438bd47003$export$633847cf062b69e0 = '#1B2638';
var $4748d5438bd47003$export$9776a6e503bdbf76 = '#121A29';
var $4748d5438bd47003$export$6c813d5160dff5db = '#0E1624';
var $4748d5438bd47003$export$3d4f271a500072a = '#0D1424';
var $4748d5438bd47003$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
var $4748d5438bd47003$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
var $4748d5438bd47003$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
var $4748d5438bd47003$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
var $4748d5438bd47003$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
var $4748d5438bd47003$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
var $4748d5438bd47003$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
var $4748d5438bd47003$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
var $4748d5438bd47003$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
var $4748d5438bd47003$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
var $4748d5438bd47003$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
var $4748d5438bd47003$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
var $4748d5438bd47003$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
var $4748d5438bd47003$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
var $4748d5438bd47003$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
var $4748d5438bd47003$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
var $4748d5438bd47003$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';
var $4748d5438bd47003$export$d2adc5dedf09fced = '#292A2E';
var $4748d5438bd47003$export$f51762073d2bb381 = '#94C748';
var $4748d5438bd47003$export$95e26d54def96891 = '#B3DF72';


var $0c8e19e93cb2da94$export$44ffba16bd48dac6 = '__ATLASKIT_THEME__';
var $0c8e19e93cb2da94$export$c93026a968943f95 = 'light';
var $0c8e19e93cb2da94$export$6ba72c8346b4c57e = [
    'light',
    'dark'
];
var $0c8e19e93cb2da94$export$7a57f79000377ca2 = function borderRadius() {
    return 3;
};
var $0c8e19e93cb2da94$export$6d8204c2cb2e06b8 = function gridSize() {
    return 8;
};
var $0c8e19e93cb2da94$export$8e24544ddba725ee = function focusRing() {
    var color = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "var(--ds-border-focused, ".concat((0, $4748d5438bd47003$export$215b7063051591f1), ")");
    var outlineWidth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $0c8e19e93cb2da94$export$6d8204c2cb2e06b8() / 4;
    (0, $3e78f3b7a8138316$export$2e2bcd8739ae039)('@atlaskit/theme', 'focus ring mixin', 'Please use `@atlaskit/focus-ring` instead.');
    return "\n  &:focus {\n    outline: none;\n    box-shadow: 0px 0px 0px ".concat(outlineWidth, "px ").concat(color, ";\n  }\n");
};
var $0c8e19e93cb2da94$export$c0dd343266bc3261 = function noFocusRing() {
    return "\n  box-shadow: none;\n";
};
var $0c8e19e93cb2da94$export$7be255094ccdc533 = {
    card: function card() {
        return 100;
    },
    navigation: function navigation() {
        return 200;
    },
    dialog: function dialog() {
        return 300;
    },
    layer: function layer() {
        return 400;
    },
    blanket: function blanket() {
        return 500;
    },
    modal: function modal() {
        return 510;
    },
    flag: function flag() {
        return 600;
    },
    spotlight: function spotlight() {
        return 700;
    },
    tooltip: function tooltip() {
        return 9999;
    }
};
var $0c8e19e93cb2da94$export$a1b3edb637fb4f35 = function visuallyHidden() {
    (0, $3e78f3b7a8138316$export$2e2bcd8739ae039)('@atlaskit/theme', 'visually hidden mixin', 'Please use `@atlaskit/visually-hidden` instead.');
    return {
        border: '0 !important',
        clip: 'rect(1px, 1px, 1px, 1px) !important',
        height: '1px !important',
        overflow: 'hidden !important',
        padding: '0 !important',
        position: 'absolute !important',
        width: '1px !important',
        whiteSpace: 'nowrap !important'
    };
};
var $0c8e19e93cb2da94$export$ba1d834b86d72a09 = $0c8e19e93cb2da94$export$a1b3edb637fb4f35;
var $0c8e19e93cb2da94$export$e497e856b4f89fcd = function skeletonShimmer() {
    return {
        css: {
            backgroundColor: "var(--ds-skeleton, ".concat((0, $4748d5438bd47003$export$8d43898f60b96a82), ")"),
            animationDuration: '1.5s',
            animationIterationCount: 'infinite',
            animationTimingFunction: 'linear',
            animationDirection: 'alternate'
        },
        keyframes: {
            from: {
                backgroundColor: "var(--ds-skeleton, ".concat((0, $4748d5438bd47003$export$8d43898f60b96a82), ")")
            },
            to: {
                backgroundColor: "var(--ds-skeleton-subtle, ".concat((0, $4748d5438bd47003$export$920c0d5c49070351), ")")
            }
        }
    };
};


/* eslint-disable @atlaskit/design-system/no-direct-use-of-web-platform-drag-and-drop */ /**
 * We are listening directly to drag events instead of using a monitor from
 * `@atlaskit/pragmatic-drag-and-drop` to avoid the bundle size cost, as it
 * would affect almost every view in every product.
 *
 * We can reconsider this choice in the future.
 */ 
var $7QpUe = parcelRequire("7QpUe");
var $3fb05a65cf6cee28$var$registrations = new Set();
var $3fb05a65cf6cee28$var$cleanupEndEventListeners = null;
function $3fb05a65cf6cee28$var$onDragStart() {
    if ($3fb05a65cf6cee28$var$cleanupEndEventListeners) // If the cleanup function exists then we've already run this
    return;
    $3fb05a65cf6cee28$var$cleanupEndEventListeners = (0, $7QpUe.bindAll)(window, [
        {
            type: 'dragend',
            listener: $3fb05a65cf6cee28$var$onDragEnd
        },
        {
            type: 'pointerdown',
            listener: $3fb05a65cf6cee28$var$onDragEnd
        },
        {
            type: 'pointermove',
            listener: function() {
                var callCount = 0;
                return function listener() {
                    // Using 20 as it is far bigger than the most observed (3)
                    if (callCount < 20) {
                        callCount++;
                        return;
                    }
                    $3fb05a65cf6cee28$var$onDragEnd();
                };
            }()
        }
    ]);
    var clone = Array.from($3fb05a65cf6cee28$var$registrations);
    clone.forEach(function(subscriber) {
        subscriber.onDragStart();
    });
}
function $3fb05a65cf6cee28$var$onDragEnd() {
    var _cleanupEndEventListe;
    (_cleanupEndEventListe = $3fb05a65cf6cee28$var$cleanupEndEventListeners) === null || _cleanupEndEventListe === void 0 || _cleanupEndEventListe();
    $3fb05a65cf6cee28$var$cleanupEndEventListeners = null;
    var clone = Array.from($3fb05a65cf6cee28$var$registrations);
    clone.forEach(function(subscriber) {
        subscriber.onDragEnd();
    });
}
function $3fb05a65cf6cee28$var$bindStartEvents() {
    return (0, $7QpUe.bindAll)(window, [
        {
            type: 'dragstart',
            listener: $3fb05a65cf6cee28$var$onDragStart
        },
        {
            type: 'dragenter',
            listener: $3fb05a65cf6cee28$var$onDragStart
        }
    ]);
}
var $3fb05a65cf6cee28$var$cleanupStartEventListeners = null;
function $3fb05a65cf6cee28$export$6503ec6e8aabbaf(registration) {
    // if first registration, bind event listeners
    if (!$3fb05a65cf6cee28$var$cleanupStartEventListeners) // note: currently never unbinding these event listeners
    $3fb05a65cf6cee28$var$cleanupStartEventListeners = $3fb05a65cf6cee28$var$bindStartEvents();
    $3fb05a65cf6cee28$var$registrations.add(registration);
    /**
   * The reasoning for this behavior is so that if a tooltip mounts during
   * a drag it can still be suppressed.
   *
   * We use a separate callback instead of onDragStart to avoid infinite loops.
   */ registration.onRegister({
        isDragging: $3fb05a65cf6cee28$var$cleanupEndEventListeners !== null
    });
    return function unregister() {
        $3fb05a65cf6cee28$var$registrations.delete(registration);
        if ($3fb05a65cf6cee28$var$registrations.size === 0) {
            var _cleanupStartEventLis;
            (_cleanupStartEventLis = $3fb05a65cf6cee28$var$cleanupStartEventListeners) === null || _cleanupStartEventLis === void 0 || _cleanupStartEventLis();
            $3fb05a65cf6cee28$var$cleanupStartEventListeners = null;
        }
    };
}


var $70aecbd0a333968d$var$delayId = null;
function $70aecbd0a333968d$export$eaf678f6f93f5250() {
    if ($70aecbd0a333968d$var$delayId != null) {
        window.clearTimeout($70aecbd0a333968d$var$delayId);
        $70aecbd0a333968d$var$delayId = null;
    }
}
function $70aecbd0a333968d$export$5f4d6617421d489b(fn, delay) {
    $70aecbd0a333968d$export$eaf678f6f93f5250();
    $70aecbd0a333968d$var$delayId = window.setTimeout(function() {
        $70aecbd0a333968d$var$delayId = null;
        fn();
    }, delay);
}


// This file is a singleton for managing tooltips
var $5515db908e246707$var$active = null;
function $5515db908e246707$export$57bf213be019eeb0(entry) {
    var phase = 'waiting-to-show';
    function isActive() {
        return Boolean($5515db908e246707$var$active && $5515db908e246707$var$active.entry === entry);
    }
    function cleanup() {
        if (isActive()) {
            (0, $70aecbd0a333968d$export$eaf678f6f93f5250)();
            $5515db908e246707$var$active = null;
        }
    }
    function done() {
        if (isActive()) entry.done();
        phase = 'done';
        cleanup();
    }
    function immediatelyHideAndDone() {
        if (isActive()) entry.hide({
            isImmediate: true
        });
        done();
    }
    function keep() {
        if (!isActive()) return;
        // aborting a wait to hide
        if (phase === 'waiting-to-hide') {
            phase = 'shown';
            (0, $70aecbd0a333968d$export$eaf678f6f93f5250)();
            return;
        }
        // aborting hide animation
        if (phase === 'hide-animating') {
            phase = 'shown';
            (0, $70aecbd0a333968d$export$eaf678f6f93f5250)();
            entry.show({
                isImmediate: false
            });
            return;
        }
    }
    function requestHide(_ref) {
        var isImmediate = _ref.isImmediate;
        if (!isActive()) return;
        // If we were not showing yet anyway; finish straight away
        if (phase === 'waiting-to-show') {
            immediatelyHideAndDone();
            return;
        }
        // already waiting to hide
        if (phase === 'waiting-to-hide') return;
        if (isImmediate) {
            immediatelyHideAndDone();
            return;
        }
        phase = 'waiting-to-hide';
        (0, $70aecbd0a333968d$export$5f4d6617421d489b)(function() {
            phase = 'hide-animating';
            entry.hide({
                isImmediate: false
            });
        }, entry.delay);
    }
    function finishHideAnimation() {
        if (isActive() && phase === 'hide-animating') done();
    }
    function isVisible() {
        return phase === 'shown' || phase === 'waiting-to-hide' || phase === 'hide-animating';
    }
    function getInitialMouse() {
        if (entry.source.type === 'mouse') return entry.source.mouse;
        return null;
    }
    function start() {
        var showImmediately = Boolean($5515db908e246707$var$active && $5515db908e246707$var$active.isVisible());
        // If there was an active tooltip; we tell it to remove itself at once!
        if ($5515db908e246707$var$active) {
            (0, $70aecbd0a333968d$export$eaf678f6f93f5250)();
            $5515db908e246707$var$active.entry.hide({
                isImmediate: true
            });
            $5515db908e246707$var$active.entry.done();
            $5515db908e246707$var$active = null;
        }
        // this tooltip is now the active tooltip
        $5515db908e246707$var$active = {
            entry: entry,
            isVisible: isVisible
        };
        function show() {
            phase = 'shown';
            entry.show({
                isImmediate: showImmediately
            });
        }
        if (showImmediately) {
            show();
            return;
        }
        phase = 'waiting-to-show';
        (0, $70aecbd0a333968d$export$5f4d6617421d489b)(show, entry.delay);
    }
    // let's get started!
    start();
    var result = {
        keep: keep,
        abort: cleanup,
        isActive: isActive,
        requestHide: requestHide,
        finishHideAnimation: finishHideAnimation,
        mousePosition: getInitialMouse()
    };
    return result;
}



var $ekGgq = parcelRequire("ekGgq");

var $5FkrB = parcelRequire("5FkrB");

var $b5lkZ = parcelRequire("b5lkZ");

var $9dOvm = parcelRequire("9dOvm");
var $3086cdb06a0dbda2$var$_process, $3086cdb06a0dbda2$var$_process2;
// We can't rely on NODE_ENV === 'test' if its value is already configured by the consumer to some other value, so better to use JEST_WORKER_ID
// https://jestjs.io/docs/environment-variables#jest_worker_id
var $3086cdb06a0dbda2$var$TESTS_MODE = (globalThis === null || globalThis === void 0 || ($3086cdb06a0dbda2$var$_process = globalThis.process) === null || $3086cdb06a0dbda2$var$_process === void 0 || ($3086cdb06a0dbda2$var$_process = $3086cdb06a0dbda2$var$_process.env) === null || $3086cdb06a0dbda2$var$_process === void 0 ? void 0 : $3086cdb06a0dbda2$var$_process.JEST_WORKER_ID) !== undefined;
var $3086cdb06a0dbda2$var$DEBUG_MODE = !$3086cdb06a0dbda2$var$TESTS_MODE && (globalThis === null || globalThis === void 0 || ($3086cdb06a0dbda2$var$_process2 = globalThis.process) === null || $3086cdb06a0dbda2$var$_process2 === void 0 || ($3086cdb06a0dbda2$var$_process2 = $3086cdb06a0dbda2$var$_process2.env) === null || $3086cdb06a0dbda2$var$_process2 === void 0 ? void 0 : $3086cdb06a0dbda2$var$_process2.NODE_ENV) !== 'production';
var $3086cdb06a0dbda2$export$1c9f709888824e05 = function debug() {
    var _console;
    if (!$3086cdb06a0dbda2$var$DEBUG_MODE) return;
    // eslint-disable-next-line no-console
    (_console = console).debug.apply(_console, arguments);
};



var $3ZMUU = parcelRequire("3ZMUU");
var $48f7fa40660cf714$var$pkgName = '@atlaskit/platform-feature-flags';
var $48f7fa40660cf714$export$7e41b1b2bdee3f98 = '__PLATFORM_FEATURE_FLAGS__';
var $48f7fa40660cf714$var$hasProcessEnv = typeof $3ZMUU !== 'undefined' && typeof $3ZMUU.env !== 'undefined';
// FF global overrides can be configured by test runners or Storybook
var $48f7fa40660cf714$var$ENV_ENABLE_PLATFORM_FF = $48f7fa40660cf714$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
// STORYBOOK_ENABLE_PLATFORM_FF is included as storybook only allows env vars prefixed with STORYBOOK
// https://github.com/storybookjs/storybook/issues/12270
var $48f7fa40660cf714$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF = $48f7fa40660cf714$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
var $48f7fa40660cf714$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE = $48f7fa40660cf714$var$ENV_ENABLE_PLATFORM_FF || $48f7fa40660cf714$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF;
var $48f7fa40660cf714$var$DEFAULT_PFF_GLOBAL = {
    booleanResolver: undefined
};
var $48f7fa40660cf714$var$globalVar = typeof window !== 'undefined' ? window : globalThis;
$48f7fa40660cf714$var$globalVar[$48f7fa40660cf714$export$7e41b1b2bdee3f98] = $48f7fa40660cf714$var$globalVar[$48f7fa40660cf714$export$7e41b1b2bdee3f98] || $48f7fa40660cf714$var$DEFAULT_PFF_GLOBAL;
function $48f7fa40660cf714$export$f2b591175b3e424c(resolver) {
    $48f7fa40660cf714$var$globalVar[$48f7fa40660cf714$export$7e41b1b2bdee3f98].booleanResolver = resolver;
}
function $48f7fa40660cf714$export$6333b6aff9fc6275(flagKey) {
    if ($48f7fa40660cf714$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE) {
        (0, $3086cdb06a0dbda2$export$1c9f709888824e05)('[%s]: The feature flags were enabled while running tests. The flag "%s" will be always enabled.', $48f7fa40660cf714$var$pkgName, flagKey);
        return true;
    }
    try {
        var _globalVar$PFF_GLOBAL, _globalVar$PFF_GLOBAL2, _globalVar$PFF_GLOBAL3;
        // booleanResolver will be empty for products like Trello, Elevate, Recruit etc.
        // Currently only Confluence, Jira and Bitbucket has set it.
        if (((_globalVar$PFF_GLOBAL = $48f7fa40660cf714$var$globalVar[$48f7fa40660cf714$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL === void 0 ? void 0 : _globalVar$PFF_GLOBAL.booleanResolver) === undefined || ((_globalVar$PFF_GLOBAL2 = $48f7fa40660cf714$var$globalVar[$48f7fa40660cf714$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL2 === void 0 ? void 0 : _globalVar$PFF_GLOBAL2.booleanResolver) === null) // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
        return (0, $9dOvm.default).checkGate(flagKey);
        var result = (_globalVar$PFF_GLOBAL3 = $48f7fa40660cf714$var$globalVar[$48f7fa40660cf714$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL3 === void 0 ? void 0 : _globalVar$PFF_GLOBAL3.booleanResolver(flagKey);
        if (typeof result !== 'boolean') {
            // eslint-disable-next-line no-console
            console.warn("".concat(flagKey, " resolved to a non-boolean value, returning false for safety"));
            return false;
        }
        return result;
    } catch (e) {
        return false;
    }
}


function $298a5bdd94ca2101$export$ba05d765b8392e5e(flagResolver) {
    (0, $48f7fa40660cf714$export$f2b591175b3e424c)(flagResolver);
}
function $298a5bdd94ca2101$export$470e5c2be1411c89(name) {
    return (0, $48f7fa40660cf714$export$6333b6aff9fc6275)(name);
}
function $298a5bdd94ca2101$export$b40ec24ac8275656(name) {
    return (0, $48f7fa40660cf714$export$6333b6aff9fc6275)(name);
}


var $525e27f050c3aec7$var$_React$useId;
// Type copied from https://github.com/thearnica/react-uid/blob/0f507fbbdb1ab84acf477ec32698afe3d2191e49/src/hooks.ts#L12
// Copied rather than inferred to make the type transparent
// @ts-ignore - useId is not accessible in React 16
var $525e27f050c3aec7$var$react18UseId = ($525e27f050c3aec7$var$_React$useId = (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).useId) !== null && $525e27f050c3aec7$var$_React$useId !== void 0 ? $525e27f050c3aec7$var$_React$useId : undefined;
function $525e27f050c3aec7$export$f680877a34711e37() {
    if ($525e27f050c3aec7$var$react18UseId && (0, $298a5bdd94ca2101$export$b40ec24ac8275656)('platform.design-system-team.react-18-use-id_mn8q4')) // eslint-disable-next-line react-hooks/rules-of-hooks
    return $525e27f050c3aec7$var$react18UseId();
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return "uid".concat((0, $b5lkZ.useUID)());
}
var $525e27f050c3aec7$export$6be90bcb437e928f = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function(_ref, ref) {
    var children = _ref.children, _ref$postfix = _ref.postfix, postfix = _ref$postfix === void 0 ? '' : _ref$postfix, _ref$prefix = _ref.prefix, prefix = _ref$prefix === void 0 ? '' : _ref$prefix;
    var id = "".concat(prefix).concat($525e27f050c3aec7$export$f680877a34711e37()).concat(postfix);
    (0, $5FkrB.useEffect)(function() {
        if (!ref) return;
        switch((0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(ref)){
            case 'function':
                ref(id);
                break;
            case 'object':
                ref.current = id;
                break;
            default:
                throw new Error("Unreachable case for unsupported type of ref \"".concat((0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(ref), "\""));
        }
    }, [
        id,
        ref
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).Fragment, null, typeof children === 'function' ? children({
        id: id
    }) : children);
});
function $525e27f050c3aec7$export$6ee17796e3d70de2() {
    if ($525e27f050c3aec7$var$react18UseId && (0, $298a5bdd94ca2101$export$b40ec24ac8275656)('platform.design-system-team.react-18-use-id_mn8q4')) {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        var uid = $525e27f050c3aec7$var$react18UseId();
        return function(id) {
            return "".concat(uid, "-").concat(id.toString());
        };
    }
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return (0, $b5lkZ.useUIDSeed)();
}


function $7fff18844a4532fa$export$2e2bcd8739ae039(prefix, shouldRenderId) {
    var seed = (0, $525e27f050c3aec7$export$6ee17796e3d70de2)();
    return shouldRenderId ? "".concat(seed(prefix)) : undefined;
}


/* tooltip-container.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $25nEq = parcelRequire("25nEq");

var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");
var $cAVP0 = parcelRequire("cAVP0");


var $25nEq = parcelRequire("25nEq");

var $5FkrB = parcelRequire("5FkrB");

var $74Zh5 = parcelRequire("74Zh5");

function $b541aaa6481d2a8e$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $b541aaa6481d2a8e$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $b541aaa6481d2a8e$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $b541aaa6481d2a8e$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $b541aaa6481d2a8e$var$VAR_PRIMITIVE_ZINDEX = 'tooltipPrimitiveZindex';
var $b541aaa6481d2a8e$var$primitiveStyles = (0, $74Zh5.css)({
    zindex: "var(".concat($b541aaa6481d2a8e$var$VAR_PRIMITIVE_ZINDEX, ")"),
    cursor: "default"
});
/**
 * The lower level component for rendering a tooltip.
 */ var $b541aaa6481d2a8e$var$TooltipPrimitive = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function TooltipPrimitive(_ref, ref) {
    var style = _ref.style, className = _ref.className, children = _ref.children, placement = _ref.placement, testId = _ref.testId, onMouseOut = _ref.onMouseOut, onMouseOver = _ref.onMouseOver, id = _ref.id;
    var styleWithZIndex = $b541aaa6481d2a8e$var$_objectSpread($b541aaa6481d2a8e$var$_objectSpread({}, style), {}, (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, $b541aaa6481d2a8e$var$VAR_PRIMITIVE_ZINDEX, (0, $0c8e19e93cb2da94$export$7be255094ccdc533).tooltip()));
    return (0, $74Zh5.jsx)("div", {
        ref: ref,
        style: styleWithZIndex,
        "data-testid": testId ? "".concat(testId, "--wrapper") : undefined
    }, (0, $74Zh5.jsx)("div", {
        role: "tooltip",
        className: className,
        onMouseOut: onMouseOut,
        onMouseOver: onMouseOver,
        css: $b541aaa6481d2a8e$var$primitiveStyles,
        "data-placement": placement,
        "data-testid": testId,
        id: id
    }, children));
});
$b541aaa6481d2a8e$var$TooltipPrimitive.displayName = 'TooltipPrimitive';
var $b541aaa6481d2a8e$export$2e2bcd8739ae039 = $b541aaa6481d2a8e$var$TooltipPrimitive;


function $f1cc677f1dc309ad$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $f1cc677f1dc309ad$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $f1cc677f1dc309ad$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $f1cc677f1dc309ad$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $f1cc677f1dc309ad$var$baseStyles = null;
var $f1cc677f1dc309ad$var$truncateStyles = null;
/**
 * Used as the default tooltip container component for the exported `Tooltip` component.
 * Adds some styles to the tooltip primitive.
 */ var $f1cc677f1dc309ad$var$TooltipContainer = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function TooltipContainer(_ref, ref) {
    var style = _ref.style, className = _ref.className, children = _ref.children, truncate = _ref.truncate, placement = _ref.placement, testId = _ref.testId, onMouseOut = _ref.onMouseOut, onMouseOver = _ref.onMouseOver, id = _ref.id;
    return /*#__PURE__*/ $5FkrB.createElement((0, $b541aaa6481d2a8e$export$2e2bcd8739ae039), {
        ref: ref,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $970q7.default)([
            "_2rko1sit _11c8qk37 _vchhusvi _p12fp3fh _bfhkpioe _syaz1i9p _152tze3t _1e02ze3t _1i4q1hna _85i5v77o _1q51v77o _y4ti12x7 _bozg12x7 _slp31hna",
            truncate && "_1reo15vq _18m915vq _p12f1pna _1bto1l2s _o5721q9c",
            className
        ]),
        placement: placement,
        testId: testId,
        id: id,
        onMouseOut: onMouseOut,
        onMouseOver: onMouseOver,
        style: $f1cc677f1dc309ad$var$_objectSpread($f1cc677f1dc309ad$var$_objectSpread({}, style), {}, {
            "--_yr7xfv": (0, $cAVP0.default)("var(--ds-background-neutral-bold, ".concat((0, $4748d5438bd47003$export$7d61b15e0da132af), ")")),
            "--_ywovvi": (0, $cAVP0.default)("var(--ds-text-inverse, ".concat((0, $4748d5438bd47003$export$29a4f05edc054374), ")"))
        })
    }, children);
});
$f1cc677f1dc309ad$var$TooltipContainer.displayName = 'TooltipContainer';
var $f1cc677f1dc309ad$export$2e2bcd8739ae039 = $f1cc677f1dc309ad$var$TooltipContainer;


function $ed200d612346c171$export$642213d516a9b928(mouseCoordinates) {
    var safeMouse = mouseCoordinates || {
        top: 0,
        left: 0
    };
    var getBoundingClientRect = function getBoundingClientRect() {
        return {
            top: safeMouse.top,
            left: safeMouse.left,
            bottom: safeMouse.top,
            right: safeMouse.left,
            width: 0,
            height: 0
        };
    };
    return {
        getBoundingClientRect: getBoundingClientRect,
        clientWidth: 0,
        clientHeight: 0
    };
}


function $1ee6819d2d8fb6a1$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $1ee6819d2d8fb6a1$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $1ee6819d2d8fb6a1$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $1ee6819d2d8fb6a1$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $1ee6819d2d8fb6a1$var$tooltipZIndex = (0, $0c8e19e93cb2da94$export$7be255094ccdc533).tooltip();
var $1ee6819d2d8fb6a1$var$analyticsAttributes = {
    componentName: 'tooltip',
    packageName: "@atlaskit/tooltip",
    packageVersion: "19.2.0"
};
// Inverts motion direction
var $1ee6819d2d8fb6a1$var$invertedDirection = {
    top: 'bottom',
    bottom: 'top',
    left: 'right',
    right: 'left'
};
/**
 * Converts a Popper placement to it's general direction.
 *
 * @param placement - Popper Placement value, e.g. 'top-start'
 * @returns Popper Direction, e.g. 'top'
 */ var $1ee6819d2d8fb6a1$var$getDirectionFromPlacement = function getDirectionFromPlacement(placement) {
    return placement.split('-')[0];
};
/**
 * __Tooltip__
 *
 * A tooltip is a floating, non-actionable label used to explain a user interface element or feature.
 */ function $1ee6819d2d8fb6a1$var$Tooltip(_ref) {
    var children = _ref.children, _ref$position = _ref.position, position = _ref$position === void 0 ? 'bottom' : _ref$position, _ref$mousePosition = _ref.mousePosition, mousePosition = _ref$mousePosition === void 0 ? 'bottom' : _ref$mousePosition, content = _ref.content, _ref$truncate = _ref.truncate, truncate = _ref$truncate === void 0 ? false : _ref$truncate, _ref$component = _ref.component, Container = _ref$component === void 0 ? (0, $f1cc677f1dc309ad$export$2e2bcd8739ae039) : _ref$component, _ref$tag = _ref.tag, TargetContainer = _ref$tag === void 0 ? 'div' : _ref$tag, testId = _ref.testId, _ref$delay = _ref.delay, delay = _ref$delay === void 0 ? 300 : _ref$delay, _ref$onShow = _ref.onShow, onShow = _ref$onShow === void 0 ? (0, $f55684cf1f3dca29$export$2e2bcd8739ae039) : _ref$onShow, _ref$onHide = _ref.onHide, onHide = _ref$onHide === void 0 ? (0, $f55684cf1f3dca29$export$2e2bcd8739ae039) : _ref$onHide, canAppear = _ref.canAppear, _ref$hideTooltipOnCli = _ref.hideTooltipOnClick, hideTooltipOnClick = _ref$hideTooltipOnCli === void 0 ? false : _ref$hideTooltipOnCli, _ref$hideTooltipOnMou = _ref.hideTooltipOnMouseDown, hideTooltipOnMouseDown = _ref$hideTooltipOnMou === void 0 ? false : _ref$hideTooltipOnMou, analyticsContext = _ref.analyticsContext, _ref$strategy = _ref.strategy, strategy = _ref$strategy === void 0 ? 'fixed' : _ref$strategy, _ref$ignoreTooltipPoi = _ref.ignoreTooltipPointerEvents, ignoreTooltipPointerEvents = _ref$ignoreTooltipPoi === void 0 ? false : _ref$ignoreTooltipPoi, _ref$isScreenReaderAn = _ref.isScreenReaderAnnouncementDisabled, isScreenReaderAnnouncementDisabled = _ref$isScreenReaderAn === void 0 ? false : _ref$isScreenReaderAn;
    var tooltipPosition = position === 'mouse' ? mousePosition : position;
    var onShowHandler = (0, $ff1b37318b494b6a$export$1a04351537078b55)($1ee6819d2d8fb6a1$var$_objectSpread({
        fn: onShow,
        action: 'displayed',
        analyticsData: analyticsContext
    }, $1ee6819d2d8fb6a1$var$analyticsAttributes));
    var onHideHandler = (0, $ff1b37318b494b6a$export$1a04351537078b55)($1ee6819d2d8fb6a1$var$_objectSpread({
        fn: onHide,
        action: 'hidden',
        analyticsData: analyticsContext
    }, $1ee6819d2d8fb6a1$var$analyticsAttributes));
    var apiRef = (0, $5FkrB.useRef)(null);
    var _useState = (0, $5FkrB.useState)('hide'), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), state = _useState2[0], setState = _useState2[1];
    var targetRef = (0, $5FkrB.useRef)(null);
    var containerRef = (0, $5FkrB.useRef)(null);
    // This function is deliberately _not_ memoized as it needs to re-run every render
    // to pick up any child ref changes. If you use render props you don't have this issue.
    var setImplicitRefFromChildren = function setImplicitRefFromChildren(node) {
        containerRef.current = node;
        targetRef.current = node ? node.firstElementChild : null;
    };
    // This is memoized and passed into the render props callback.
    var setDirectRef = (0, $5FkrB.useCallback)(function(node) {
        targetRef.current = node;
    }, []);
    // Putting a few things into refs so that we don't have to break memoization
    var stableState = (0, $3410b820897135a6$export$2e2bcd8739ae039)(state);
    // These props are placed in separate refs instead of a single object to reduce memory usage.
    // Placing them in the same object previously caused an increase in the number of JavaScript event listeners
    // before garbage collection.
    var onShowHandlerStable = (0, $3410b820897135a6$export$2e2bcd8739ae039)(onShowHandler);
    var onHideHandlerStable = (0, $3410b820897135a6$export$2e2bcd8739ae039)(onHideHandler);
    var delayStable = (0, $3410b820897135a6$export$2e2bcd8739ae039)(delay);
    var canAppearStable = (0, $3410b820897135a6$export$2e2bcd8739ae039)(canAppear);
    var hasCalledShowHandler = (0, $5FkrB.useRef)(false);
    var start = (0, $5FkrB.useCallback)(function(api) {
        // @ts-ignore
        apiRef.current = api;
        hasCalledShowHandler.current = false;
    }, []);
    var done = (0, $5FkrB.useCallback)(function() {
        if (!apiRef.current) return;
        // Only call onHideHandler if we have called onShowHandler
        if (hasCalledShowHandler.current) onHideHandlerStable.current();
        // @ts-ignore
        apiRef.current = null;
        // @ts-ignore
        hasCalledShowHandler.current = false;
        // just in case
        setState('hide');
    }, [
        onHideHandlerStable
    ]);
    var abort = (0, $5FkrB.useCallback)(function() {
        if (!apiRef.current) return;
        apiRef.current.abort();
        // Only call onHideHandler if we have called onShowHandler
        if (hasCalledShowHandler.current) onHideHandlerStable.current();
        // @ts-ignore
        apiRef.current = null;
    }, [
        onHideHandlerStable
    ]);
    (0, $5FkrB.useEffect)(function mount() {
        return function unmount() {
            if (apiRef.current) abort();
        };
    }, [
        abort
    ]);
    var isDraggingRef = (0, $5FkrB.useRef)(false);
    (0, $5FkrB.useEffect)(function() {
        return (0, $3fb05a65cf6cee28$export$6503ec6e8aabbaf)({
            onRegister: function onRegister(_ref2) {
                var isDragging = _ref2.isDragging;
                isDraggingRef.current = isDragging;
            },
            onDragStart: function onDragStart() {
                var _apiRef$current;
                /**
         * Hiding any visible tooltips when a drag starts because otherwise it
         * looks janky (disappears and reappears), and is not required.
         */ (_apiRef$current = apiRef.current) === null || _apiRef$current === void 0 || _apiRef$current.requestHide({
                    isImmediate: true
                });
                isDraggingRef.current = true;
            },
            onDragEnd: function onDragEnd() {
                isDraggingRef.current = false;
            }
        });
    }, []);
    var tryShowTooltip = (0, $5FkrB.useCallback)(function(source) {
        var _canAppearStable$curr;
        /**
     * Prevent tooltips from being shown during a drag. This can occur with
     * the native drag and drop API, where some pointer events can fire
     * when they should not and lead to jank with tooltips.
     */ if (isDraggingRef.current) return;
        // Another tooltip is has been active but we still have the old `api`
        // around. We need to finish up the last usage.
        // Note: just being safe - this should not happen
        if (apiRef.current && !apiRef.current.isActive()) abort();
        // This tooltip is already active, we can exit
        if (apiRef.current && apiRef.current.isActive()) {
            apiRef.current.keep();
            return;
        }
        /**
     * Check if tooltip is allowed to show.
     *
     * Once a tooltip has started, or has scheduled to start
     * we won't be checking `canAppear` again.
     *
     * - We don't want tooltips to disappear once they are shown
     * - For consistency, we start after a single positive `canAppear`.
     *   Otherwise the amount of times we ask consumers would depend on
     *   how many times we get a "mousemove", which _could_ lead to situations
     *   where moving the mouse could result in a different outcome to if
     *   the mouse was not moved.
     */ if (canAppearStable.current && !((_canAppearStable$curr = canAppearStable.current) !== null && _canAppearStable$curr !== void 0 && _canAppearStable$curr.call(canAppearStable))) return;
        var entry = {
            source: source,
            delay: delayStable.current,
            show: function show(_ref3) {
                var isImmediate = _ref3.isImmediate;
                // Call the onShow handler if it hasn't been called yet
                if (!hasCalledShowHandler.current) {
                    hasCalledShowHandler.current = true;
                    onShowHandlerStable.current();
                }
                setState(isImmediate ? 'show-immediate' : 'fade-in');
            },
            hide: function hide(_ref4) {
                var isImmediate = _ref4.isImmediate;
                if (isImmediate) setState('hide');
                else setState('before-fade-out');
            },
            done: done
        };
        var api = (0, $5515db908e246707$export$57bf213be019eeb0)(entry);
        start(api);
    }, [
        canAppearStable,
        delayStable,
        done,
        start,
        abort,
        onShowHandlerStable
    ]);
    var hideTooltipOnEsc = (0, $5FkrB.useCallback)(function() {
        var _apiRef$current2;
        (_apiRef$current2 = apiRef.current) === null || _apiRef$current2 === void 0 || _apiRef$current2.requestHide({
            isImmediate: true
        });
    }, [
        apiRef
    ]);
    (0, $29facb65b1c1eae8$export$2e2bcd8739ae039)({
        onClose: hideTooltipOnEsc,
        isDisabled: state === 'hide' || state === 'fade-out'
    });
    (0, $5FkrB.useEffect)(function() {
        if (state === 'hide') return 0, $f55684cf1f3dca29$export$2e2bcd8739ae039;
        if (state === 'before-fade-out') setState('fade-out');
        var unbind = (0, $7QpUe.bind)(window, {
            type: 'scroll',
            listener: function listener() {
                if (apiRef.current) apiRef.current.requestHide({
                    isImmediate: true
                });
            },
            options: {
                capture: true,
                passive: true,
                once: true
            }
        });
        return unbind;
    }, [
        state
    ]);
    var onMouseDown = (0, $5FkrB.useCallback)(function() {
        if (hideTooltipOnMouseDown && apiRef.current) apiRef.current.requestHide({
            isImmediate: true
        });
    }, [
        hideTooltipOnMouseDown
    ]);
    var onClick = (0, $5FkrB.useCallback)(function() {
        if (hideTooltipOnClick && apiRef.current) apiRef.current.requestHide({
            isImmediate: true
        });
    }, [
        hideTooltipOnClick
    ]);
    // Ideally we would be using onMouseEnter here, but
    // because we are binding the event to the target parent
    // we need to listen for the mouseover of all sub elements
    // This means when moving along a tooltip we are quickly toggling
    // between api.requestHide and api.keep. This it not ideal
    var onMouseOver = (0, $5FkrB.useCallback)(function(event) {
        // Ignoring events from the container ref
        if (containerRef.current && event.target === containerRef.current) return;
        // Using prevent default as a signal that parent tooltips
        if (event.defaultPrevented) return;
        event.preventDefault();
        var source = position === 'mouse' ? {
            type: 'mouse',
            // TODO: ideally not recalculating this object each time
            mouse: (0, $ed200d612346c171$export$642213d516a9b928)({
                left: event.clientX,
                top: event.clientY
            })
        } : {
            type: 'keyboard'
        };
        tryShowTooltip(source);
    }, [
        position,
        tryShowTooltip
    ]);
    // Ideally we would be using onMouseEnter here, but
    // because we are binding the event to the target parent
    // we need to listen for the mouseout of all sub elements
    // This means when moving along a tooltip we are quickly toggling
    // between api.requestHide and api.keep. This it not ideal
    var onMouseOut = (0, $5FkrB.useCallback)(function(event) {
        // Ignoring events from the container ref
        if (containerRef.current && event.target === containerRef.current) return;
        // Using prevent default as a signal that parent tooltips
        if (event.defaultPrevented) return;
        event.preventDefault();
        if (apiRef.current) apiRef.current.requestHide({
            isImmediate: false
        });
    }, []);
    var onMouseMove = position === 'mouse' ? function(event) {
        var _apiRef$current3;
        if ((_apiRef$current3 = apiRef.current) !== null && _apiRef$current3 !== void 0 && _apiRef$current3.isActive()) apiRef.current.mousePosition = (0, $ed200d612346c171$export$642213d516a9b928)({
            left: event.clientX,
            top: event.clientY
        });
    } : undefined;
    var onMouseOverTooltip = (0, $5FkrB.useCallback)(function() {
        if (apiRef.current && apiRef.current.isActive()) {
            apiRef.current.keep();
            return;
        }
    }, []);
    var onFocus = (0, $5FkrB.useCallback)(function() {
        // TODO: this does not play well with `hideTooltipOnMouseDown`
        // as "focus" will occur after the "mousedown".
        tryShowTooltip({
            type: 'keyboard'
        });
    }, [
        tryShowTooltip
    ]);
    var onBlur = (0, $5FkrB.useCallback)(function() {
        if (apiRef.current) apiRef.current.requestHide({
            isImmediate: false
        });
    }, []);
    var onAnimationFinished = (0, $5FkrB.useCallback)(function(transition) {
        // Using lastState here because motion is not picking up the latest value
        if (transition === 'exiting' && stableState.current === 'fade-out' && apiRef.current) // @ts-ignore: refs are writeable
        apiRef.current.finishHideAnimation();
    }, [
        stableState
    ]);
    // Doing a cast because typescript is struggling to narrow the type
    var CastTargetContainer = TargetContainer;
    var shouldRenderTooltipPopup = state !== 'hide' && Boolean(content);
    var shouldRenderHiddenContent = !isScreenReaderAnnouncementDisabled && shouldRenderTooltipPopup;
    var shouldRenderTooltipChildren = state !== 'hide' && state !== 'fade-out';
    (0, $3d52fdcb58caf93d$export$469bb693f11edc7f)({
        isOpen: shouldRenderTooltipPopup
    });
    var getReferenceElement = function getReferenceElement() {
        var _apiRef$current4;
        if (position === 'mouse' && (_apiRef$current4 = apiRef.current) !== null && _apiRef$current4 !== void 0 && _apiRef$current4.mousePosition) {
            var _apiRef$current5;
            return (_apiRef$current5 = apiRef.current) === null || _apiRef$current5 === void 0 ? void 0 : _apiRef$current5.mousePosition;
        }
        return targetRef.current || undefined;
    };
    var tooltipIdForHiddenContent = (0, $7fff18844a4532fa$export$2e2bcd8739ae039)('tooltip', shouldRenderHiddenContent);
    var tooltipTriggerProps = {
        onMouseOver: onMouseOver,
        onMouseOut: onMouseOut,
        onMouseMove: onMouseMove,
        onMouseDown: onMouseDown,
        onClick: onClick,
        onFocus: onFocus,
        onBlur: onBlur
    };
    // Don't set `data-testid` unless it's defined, as it's not in the interface.
    if (testId) // @ts-expect-error - Adding `data-testid` to the TriggerProps interface breaks Buttons.
    tooltipTriggerProps['data-testid'] = "".concat(testId, "--container");
    // This useEffect is purely for managing the aria attribute when using the
    // wrapped children approach.
    var isChildrenAFunction = typeof children === 'function';
    (0, $5FkrB.useEffect)(function() {
        if (isChildrenAFunction) return;
        // If `children` is _not_ a function, we are stepping outside of the public
        // API to add a `aria-describedby` attribute.
        var target = targetRef.current;
        if (!target || !tooltipIdForHiddenContent) return;
        target.setAttribute('aria-describedby', tooltipIdForHiddenContent);
        return function() {
            return target.removeAttribute('aria-describedby');
        };
    }, [
        isChildrenAFunction,
        tooltipIdForHiddenContent
    ]);
    var hiddenContent = shouldRenderHiddenContent ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("span", {
        "data-testid": testId ? "".concat(testId, "-hidden") : undefined,
        hidden: true,
        id: tooltipIdForHiddenContent
    }, typeof content === 'function' ? content({}) : content) : null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).Fragment, null, typeof children === 'function' ? /*#__PURE__*/ // once we deprecate the wrapped approach, we can put the aria
    // attribute back into the tooltipTriggerProps and make it required
    // instead of optional in `types`
    (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).Fragment, null, children($1ee6819d2d8fb6a1$var$_objectSpread($1ee6819d2d8fb6a1$var$_objectSpread({}, tooltipTriggerProps), {}, {
        'aria-describedby': tooltipIdForHiddenContent,
        ref: setDirectRef
    })), hiddenContent) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(CastTargetContainer, (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, tooltipTriggerProps, {
        ref: setImplicitRefFromChildren,
        role: "presentation"
    }), children, hiddenContent), shouldRenderTooltipPopup ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $b4317fbf92c4744e$export$2e2bcd8739ae039), {
        zIndex: $1ee6819d2d8fb6a1$var$tooltipZIndex
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $67f08545af890619$export$badac9ada3a0bdf9), {
        placement: tooltipPosition,
        referenceElement: getReferenceElement(),
        strategy: strategy
    }, function(_ref5) {
        var ref = _ref5.ref, style = _ref5.style, update = _ref5.update, placement = _ref5.placement;
        // Invert the entrance and exit directions.
        // E.g. a tooltip's position is on the 'right', it should enter from and exit to the 'left'
        // This gives the effect the tooltip is appearing from the target
        var direction = position === 'mouse' ? undefined : $1ee6819d2d8fb6a1$var$invertedDirection[$1ee6819d2d8fb6a1$var$getDirectionFromPlacement(placement)];
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $279dc552abf8fdf8$export$2e2bcd8739ae039), {
            appear: true
        }, shouldRenderTooltipChildren && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $bfc9e4af75d9628a$export$2e2bcd8739ae039), {
            distance: "constant",
            entranceDirection: direction,
            exitDirection: direction,
            onFinish: onAnimationFinished,
            duration: state !== 'show-immediate' ? 'medium' : 'none'
        }, function(_ref6) {
            var className = _ref6.className;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(Container, {
                ref: ref,
                className: "Tooltip ".concat(className),
                style: $1ee6819d2d8fb6a1$var$_objectSpread($1ee6819d2d8fb6a1$var$_objectSpread({}, style), ignoreTooltipPointerEvents && {
                    pointerEvents: 'none'
                }),
                truncate: truncate,
                placement: tooltipPosition,
                testId: getReferenceElement() ? testId : testId && "".concat(testId, "--unresolved"),
                onMouseOut: onMouseOut,
                onMouseOver: onMouseOverTooltip
            }, typeof content === 'function' ? content({
                update: update
            }) : content);
        }));
    })) : null);
}
$1ee6819d2d8fb6a1$var$Tooltip.displayName = 'Tooltip';
var $1ee6819d2d8fb6a1$export$2e2bcd8739ae039 = $1ee6819d2d8fb6a1$var$Tooltip;



var $kqp0i = parcelRequire("kqp0i");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");

var $74Zh5 = parcelRequire("74Zh5");

var $25nEq = parcelRequire("25nEq");

var $74Zh5 = parcelRequire("74Zh5");

function $11472afca28cc3f2$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $11472afca28cc3f2$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $11472afca28cc3f2$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $11472afca28cc3f2$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $11472afca28cc3f2$export$6ccdbebca2ee545f = {
    '100%': '100%',
    'size.100': '1rem',
    'size.200': '1.5rem',
    'size.300': '2rem',
    'size.400': '2.5rem',
    'size.500': '3rem',
    'size.600': '6rem',
    'size.1000': '12rem'
};
var $11472afca28cc3f2$export$958d0ae7f2977ae4 = {
    'space.0': "var(--ds-space-0, 0px)",
    'space.025': "var(--ds-space-025, 2px)",
    'space.050': "var(--ds-space-050, 4px)",
    'space.075': "var(--ds-space-075, 6px)",
    'space.100': "var(--ds-space-100, 8px)",
    'space.150': "var(--ds-space-150, 12px)",
    'space.200': "var(--ds-space-200, 16px)",
    'space.250': "var(--ds-space-250, 20px)",
    'space.300': "var(--ds-space-300, 24px)",
    'space.400': "var(--ds-space-400, 32px)",
    'space.500': "var(--ds-space-500, 40px)",
    'space.600': "var(--ds-space-600, 48px)",
    'space.800': "var(--ds-space-800, 64px)",
    'space.1000': "var(--ds-space-1000, 80px)"
};
var $11472afca28cc3f2$export$d2dc61f58390201c = {
    'space.negative.025': "var(--ds-space-negative-025, -2px)",
    'space.negative.050': "var(--ds-space-negative-050, -4px)",
    'space.negative.075': "var(--ds-space-negative-075, -6px)",
    'space.negative.100': "var(--ds-space-negative-100, -8px)",
    'space.negative.150': "var(--ds-space-negative-150, -12px)",
    'space.negative.200': "var(--ds-space-negative-200, -16px)",
    'space.negative.250': "var(--ds-space-negative-250, -20px)",
    'space.negative.300': "var(--ds-space-negative-300, -24px)",
    'space.negative.400': "var(--ds-space-negative-400, -32px)"
};
var $11472afca28cc3f2$export$632685d741f3dbbf = $11472afca28cc3f2$var$_objectSpread($11472afca28cc3f2$var$_objectSpread({}, $11472afca28cc3f2$export$958d0ae7f2977ae4), $11472afca28cc3f2$export$d2dc61f58390201c);
var $11472afca28cc3f2$export$2185ce37f9bdd963 = {
    'color.background.neutral.bold': 'color.text.inverse',
    'color.background.neutral.bold.hovered': 'color.text.inverse',
    'color.background.neutral.bold.pressed': 'color.text.inverse',
    'color.background.selected.bold': 'color.text.inverse',
    'color.background.selected.bold.hovered': 'color.text.inverse',
    'color.background.selected.bold.pressed': 'color.text.inverse',
    'color.background.brand.bold': 'color.text.inverse',
    'color.background.brand.bold.hovered': 'color.text.inverse',
    'color.background.brand.bold.pressed': 'color.text.inverse',
    'color.background.brand.boldest': 'color.text.inverse',
    'color.background.brand.boldest.hovered': 'color.text.inverse',
    'color.background.brand.boldest.pressed': 'color.text.inverse',
    'color.background.danger.bold': 'color.text.inverse',
    'color.background.danger.bold.hovered': 'color.text.inverse',
    'color.background.danger.bold.pressed': 'color.text.inverse',
    'color.background.warning.bold': 'color.text.warning.inverse',
    'color.background.warning.bold.hovered': 'color.text.warning.inverse',
    'color.background.warning.bold.pressed': 'color.text.warning.inverse',
    'color.background.success.bold': 'color.text.inverse',
    'color.background.success.bold.hovered': 'color.text.inverse',
    'color.background.success.bold.pressed': 'color.text.inverse',
    'color.background.discovery.bold': 'color.text.inverse',
    'color.background.discovery.bold.hovered': 'color.text.inverse',
    'color.background.discovery.bold.pressed': 'color.text.inverse',
    'color.background.information.bold': 'color.text.inverse',
    'color.background.information.bold.hovered': 'color.text.inverse',
    'color.background.information.bold.pressed': 'color.text.inverse'
};
var $11472afca28cc3f2$export$daf94a976c798b4f = {
    'opacity.disabled': "var(--ds-opacity-disabled, 0.4)",
    'opacity.loading': "var(--ds-opacity-loading, 0.2)"
};
var $11472afca28cc3f2$export$7aff6e7ba39bb774 = {
    'elevation.shadow.overflow': "var(--ds-shadow-overflow, 0px 0px 8px #091e423f, 0px 0px 1px #091e424f)",
    'elevation.shadow.overflow.perimeter': "var(--ds-shadow-overflow-perimeter, #091e421f)",
    'elevation.shadow.overflow.spread': "var(--ds-shadow-overflow-spread, #091e4229)",
    'elevation.shadow.overlay': "var(--ds-shadow-overlay, 0px 8px 12px #091e423f, 0px 0px 1px #091e424f)",
    'elevation.shadow.raised': "var(--ds-shadow-raised, 0px 1px 1px #091e423f, 0px 0px 1px #091e4221)"
};
var $11472afca28cc3f2$export$41a358c9c2356760 = {
    'elevation.surface': "var(--ds-surface, #FFFFFF)",
    'elevation.surface.hovered': "var(--ds-surface-hovered, #FAFBFC)",
    'elevation.surface.pressed': "var(--ds-surface-pressed, #F4F5F7)",
    'elevation.surface.overlay': "var(--ds-surface-overlay, #FFFFFF)",
    'elevation.surface.overlay.hovered': "var(--ds-surface-overlay-hovered, #FAFBFC)",
    'elevation.surface.overlay.pressed': "var(--ds-surface-overlay-pressed, #F4F5F7)",
    'elevation.surface.raised': "var(--ds-surface-raised, #FFFFFF)",
    'elevation.surface.raised.hovered': "var(--ds-surface-raised-hovered, #FAFBFC)",
    'elevation.surface.raised.pressed': "var(--ds-surface-raised-pressed, #F4F5F7)",
    'elevation.surface.sunken': "var(--ds-surface-sunken, #F4F5F7)"
};
var $11472afca28cc3f2$export$1531ad5bb3fbedac = {
    'color.border': "var(--ds-border, #091e4221)",
    'color.border.accent.lime': "var(--ds-border-accent-lime, #6A9A23)",
    'color.border.accent.red': "var(--ds-border-accent-red, #FF5630)",
    'color.border.accent.orange': "var(--ds-border-accent-orange, #D94008)",
    'color.border.accent.yellow': "var(--ds-border-accent-yellow, #FFAB00)",
    'color.border.accent.green': "var(--ds-border-accent-green, #36B37E)",
    'color.border.accent.teal': "var(--ds-border-accent-teal, #00B8D9)",
    'color.border.accent.blue': "var(--ds-border-accent-blue, #0065FF)",
    'color.border.accent.purple': "var(--ds-border-accent-purple, #6554C0)",
    'color.border.accent.magenta': "var(--ds-border-accent-magenta, #CD519D)",
    'color.border.accent.gray': "var(--ds-border-accent-gray, #5E6C84)",
    'color.border.disabled': "var(--ds-border-disabled, #FAFBFC)",
    'color.border.focused': "var(--ds-border-focused, #2684FF)",
    'color.border.input': "var(--ds-border-input, #FAFBFC)",
    'color.border.inverse': "var(--ds-border-inverse, #FFFFFF)",
    'color.border.selected': "var(--ds-border-selected, #0052CC)",
    'color.border.brand': "var(--ds-border-brand, #0052CC)",
    'color.border.danger': "var(--ds-border-danger, #FF5630)",
    'color.border.warning': "var(--ds-border-warning, #FFC400)",
    'color.border.success': "var(--ds-border-success, #00875A)",
    'color.border.discovery': "var(--ds-border-discovery, #998DD9)",
    'color.border.information': "var(--ds-border-information, #0065FF)",
    'color.border.bold': "var(--ds-border-bold, #344563)"
};
var $11472afca28cc3f2$export$d1d79bf68ac056bd = {
    'color.background.accent.lime.subtlest': "var(--ds-background-accent-lime-subtlest, #EEFBDA)",
    'color.background.accent.lime.subtlest.hovered': "var(--ds-background-accent-lime-subtlest-hovered, #D3F1A7)",
    'color.background.accent.lime.subtlest.pressed': "var(--ds-background-accent-lime-subtlest-pressed, #B3DF72)",
    'color.background.accent.lime.subtler': "var(--ds-background-accent-lime-subtler, #D3F1A7)",
    'color.background.accent.lime.subtler.hovered': "var(--ds-background-accent-lime-subtler-hovered, #B3DF72)",
    'color.background.accent.lime.subtler.pressed': "var(--ds-background-accent-lime-subtler-pressed, #94C748)",
    'color.background.accent.lime.subtle': "var(--ds-background-accent-lime-subtle, #94C748)",
    'color.background.accent.lime.subtle.hovered': "var(--ds-background-accent-lime-subtle-hovered, #B3DF72)",
    'color.background.accent.lime.subtle.pressed': "var(--ds-background-accent-lime-subtle-pressed, #D3F1A7)",
    'color.background.accent.lime.bolder': "var(--ds-background-accent-lime-bolder, #5B7F24)",
    'color.background.accent.lime.bolder.hovered': "var(--ds-background-accent-lime-bolder-hovered, #37471F)",
    'color.background.accent.lime.bolder.pressed': "var(--ds-background-accent-lime-bolder-pressed, #37471F)",
    'color.background.accent.red.subtlest': "var(--ds-background-accent-red-subtlest, #FF8F73)",
    'color.background.accent.red.subtlest.hovered': "var(--ds-background-accent-red-subtlest-hovered, #FF7452)",
    'color.background.accent.red.subtlest.pressed': "var(--ds-background-accent-red-subtlest-pressed, #FF5630)",
    'color.background.accent.red.subtler': "var(--ds-background-accent-red-subtler, #FF7452)",
    'color.background.accent.red.subtler.hovered': "var(--ds-background-accent-red-subtler-hovered, #FF5630)",
    'color.background.accent.red.subtler.pressed': "var(--ds-background-accent-red-subtler-pressed, #DE350B)",
    'color.background.accent.red.subtle': "var(--ds-background-accent-red-subtle, #DE350B)",
    'color.background.accent.red.subtle.hovered': "var(--ds-background-accent-red-subtle-hovered, #FF5630)",
    'color.background.accent.red.subtle.pressed': "var(--ds-background-accent-red-subtle-pressed, #FF7452)",
    'color.background.accent.red.bolder': "var(--ds-background-accent-red-bolder, #DE350B)",
    'color.background.accent.red.bolder.hovered': "var(--ds-background-accent-red-bolder-hovered, #FF5630)",
    'color.background.accent.red.bolder.pressed': "var(--ds-background-accent-red-bolder-pressed, #FF7452)",
    'color.background.accent.orange.subtlest': "var(--ds-background-accent-orange-subtlest, #F18D13)",
    'color.background.accent.orange.subtlest.hovered': "var(--ds-background-accent-orange-subtlest-hovered, #FEC57B)",
    'color.background.accent.orange.subtlest.pressed': "var(--ds-background-accent-orange-subtlest-pressed, #FFE2BD)",
    'color.background.accent.orange.subtler': "var(--ds-background-accent-orange-subtler, #B65C02)",
    'color.background.accent.orange.subtler.hovered': "var(--ds-background-accent-orange-subtler-hovered, #F18D13)",
    'color.background.accent.orange.subtler.pressed': "var(--ds-background-accent-orange-subtler-pressed, #FEC57B)",
    'color.background.accent.orange.subtle': "var(--ds-background-accent-orange-subtle, #5F3811)",
    'color.background.accent.orange.subtle.hovered': "var(--ds-background-accent-orange-subtle-hovered, #974F0C)",
    'color.background.accent.orange.subtle.pressed': "var(--ds-background-accent-orange-subtle-pressed, #B65C02)",
    'color.background.accent.orange.bolder': "var(--ds-background-accent-orange-bolder, #43290F)",
    'color.background.accent.orange.bolder.hovered': "var(--ds-background-accent-orange-bolder-hovered, #5F3811)",
    'color.background.accent.orange.bolder.pressed': "var(--ds-background-accent-orange-bolder-pressed, #974F0C)",
    'color.background.accent.yellow.subtlest': "var(--ds-background-accent-yellow-subtlest, #FFE380)",
    'color.background.accent.yellow.subtlest.hovered': "var(--ds-background-accent-yellow-subtlest-hovered, #FFC400)",
    'color.background.accent.yellow.subtlest.pressed': "var(--ds-background-accent-yellow-subtlest-pressed, #FFAB00)",
    'color.background.accent.yellow.subtler': "var(--ds-background-accent-yellow-subtler, #FFC400)",
    'color.background.accent.yellow.subtler.hovered': "var(--ds-background-accent-yellow-subtler-hovered, #FFAB00)",
    'color.background.accent.yellow.subtler.pressed': "var(--ds-background-accent-yellow-subtler-pressed, #FF991F)",
    'color.background.accent.yellow.subtle': "var(--ds-background-accent-yellow-subtle, #FF991F)",
    'color.background.accent.yellow.subtle.hovered': "var(--ds-background-accent-yellow-subtle-hovered, #FFAB00)",
    'color.background.accent.yellow.subtle.pressed': "var(--ds-background-accent-yellow-subtle-pressed, #FFC400)",
    'color.background.accent.yellow.bolder': "var(--ds-background-accent-yellow-bolder, #FF991F)",
    'color.background.accent.yellow.bolder.hovered': "var(--ds-background-accent-yellow-bolder-hovered, #FFAB00)",
    'color.background.accent.yellow.bolder.pressed': "var(--ds-background-accent-yellow-bolder-pressed, #FFC400)",
    'color.background.accent.green.subtlest': "var(--ds-background-accent-green-subtlest, #79F2C0)",
    'color.background.accent.green.subtlest.hovered': "var(--ds-background-accent-green-subtlest-hovered, #57D9A3)",
    'color.background.accent.green.subtlest.pressed': "var(--ds-background-accent-green-subtlest-pressed, #36B37E)",
    'color.background.accent.green.subtler': "var(--ds-background-accent-green-subtler, #57D9A3)",
    'color.background.accent.green.subtler.hovered': "var(--ds-background-accent-green-subtler-hovered, #36B37E)",
    'color.background.accent.green.subtler.pressed': "var(--ds-background-accent-green-subtler-pressed, #00875A)",
    'color.background.accent.green.subtle': "var(--ds-background-accent-green-subtle, #00875A)",
    'color.background.accent.green.subtle.hovered': "var(--ds-background-accent-green-subtle-hovered, #36B37E)",
    'color.background.accent.green.subtle.pressed': "var(--ds-background-accent-green-subtle-pressed, #57D9A3)",
    'color.background.accent.green.bolder': "var(--ds-background-accent-green-bolder, #00875A)",
    'color.background.accent.green.bolder.hovered': "var(--ds-background-accent-green-bolder-hovered, #36B37E)",
    'color.background.accent.green.bolder.pressed': "var(--ds-background-accent-green-bolder-pressed, #57D9A3)",
    'color.background.accent.teal.subtlest': "var(--ds-background-accent-teal-subtlest, #79E2F2)",
    'color.background.accent.teal.subtlest.hovered': "var(--ds-background-accent-teal-subtlest-hovered, #00C7E6)",
    'color.background.accent.teal.subtlest.pressed': "var(--ds-background-accent-teal-subtlest-pressed, #00B8D9)",
    'color.background.accent.teal.subtler': "var(--ds-background-accent-teal-subtler, #00C7E6)",
    'color.background.accent.teal.subtler.hovered': "var(--ds-background-accent-teal-subtler-hovered, #00B8D9)",
    'color.background.accent.teal.subtler.pressed': "var(--ds-background-accent-teal-subtler-pressed, #00A3BF)",
    'color.background.accent.teal.subtle': "var(--ds-background-accent-teal-subtle, #00A3BF)",
    'color.background.accent.teal.subtle.hovered': "var(--ds-background-accent-teal-subtle-hovered, #00B8D9)",
    'color.background.accent.teal.subtle.pressed': "var(--ds-background-accent-teal-subtle-pressed, #00C7E6)",
    'color.background.accent.teal.bolder': "var(--ds-background-accent-teal-bolder, #00A3BF)",
    'color.background.accent.teal.bolder.hovered': "var(--ds-background-accent-teal-bolder-hovered, #00B8D9)",
    'color.background.accent.teal.bolder.pressed': "var(--ds-background-accent-teal-bolder-pressed, #00C7E6)",
    'color.background.accent.blue.subtlest': "var(--ds-background-accent-blue-subtlest, #4C9AFF)",
    'color.background.accent.blue.subtlest.hovered': "var(--ds-background-accent-blue-subtlest-hovered, #2684FF)",
    'color.background.accent.blue.subtlest.pressed': "var(--ds-background-accent-blue-subtlest-pressed, #0065FF)",
    'color.background.accent.blue.subtler': "var(--ds-background-accent-blue-subtler, #2684FF)",
    'color.background.accent.blue.subtler.hovered': "var(--ds-background-accent-blue-subtler-hovered, #0065FF)",
    'color.background.accent.blue.subtler.pressed': "var(--ds-background-accent-blue-subtler-pressed, #0052CC)",
    'color.background.accent.blue.subtle': "var(--ds-background-accent-blue-subtle, #0052CC)",
    'color.background.accent.blue.subtle.hovered': "var(--ds-background-accent-blue-subtle-hovered, #0065FF)",
    'color.background.accent.blue.subtle.pressed': "var(--ds-background-accent-blue-subtle-pressed, #2684FF)",
    'color.background.accent.blue.bolder': "var(--ds-background-accent-blue-bolder, #0052CC)",
    'color.background.accent.blue.bolder.hovered': "var(--ds-background-accent-blue-bolder-hovered, #0065FF)",
    'color.background.accent.blue.bolder.pressed': "var(--ds-background-accent-blue-bolder-pressed, #2684FF)",
    'color.background.accent.purple.subtlest': "var(--ds-background-accent-purple-subtlest, #998DD9)",
    'color.background.accent.purple.subtlest.hovered': "var(--ds-background-accent-purple-subtlest-hovered, #8777D9)",
    'color.background.accent.purple.subtlest.pressed': "var(--ds-background-accent-purple-subtlest-pressed, #6554C0)",
    'color.background.accent.purple.subtler': "var(--ds-background-accent-purple-subtler, #8777D9)",
    'color.background.accent.purple.subtler.hovered': "var(--ds-background-accent-purple-subtler-hovered, #6554C0)",
    'color.background.accent.purple.subtler.pressed': "var(--ds-background-accent-purple-subtler-pressed, #5243AA)",
    'color.background.accent.purple.subtle': "var(--ds-background-accent-purple-subtle, #5243AA)",
    'color.background.accent.purple.subtle.hovered': "var(--ds-background-accent-purple-subtle-hovered, #6554C0)",
    'color.background.accent.purple.subtle.pressed': "var(--ds-background-accent-purple-subtle-pressed, #8777D9)",
    'color.background.accent.purple.bolder': "var(--ds-background-accent-purple-bolder, #5243AA)",
    'color.background.accent.purple.bolder.hovered': "var(--ds-background-accent-purple-bolder-hovered, #6554C0)",
    'color.background.accent.purple.bolder.pressed': "var(--ds-background-accent-purple-bolder-pressed, #8777D9)",
    'color.background.accent.magenta.subtlest': "var(--ds-background-accent-magenta-subtlest, #FFECF8)",
    'color.background.accent.magenta.subtlest.hovered': "var(--ds-background-accent-magenta-subtlest-hovered, #FDD0EC)",
    'color.background.accent.magenta.subtlest.pressed': "var(--ds-background-accent-magenta-subtlest-pressed, #F797D2)",
    'color.background.accent.magenta.subtler': "var(--ds-background-accent-magenta-subtler, #FDD0EC)",
    'color.background.accent.magenta.subtler.hovered': "var(--ds-background-accent-magenta-subtler-hovered, #F797D2)",
    'color.background.accent.magenta.subtler.pressed': "var(--ds-background-accent-magenta-subtler-pressed, #E774BB)",
    'color.background.accent.magenta.subtle': "var(--ds-background-accent-magenta-subtle, #E774BB)",
    'color.background.accent.magenta.subtle.hovered': "var(--ds-background-accent-magenta-subtle-hovered, #F797D2)",
    'color.background.accent.magenta.subtle.pressed': "var(--ds-background-accent-magenta-subtle-pressed, #FDD0EC)",
    'color.background.accent.magenta.bolder': "var(--ds-background-accent-magenta-bolder, #AE4787)",
    'color.background.accent.magenta.bolder.hovered': "var(--ds-background-accent-magenta-bolder-hovered, #943D73)",
    'color.background.accent.magenta.bolder.pressed': "var(--ds-background-accent-magenta-bolder-pressed, #50253F)",
    'color.background.accent.gray.subtlest': "var(--ds-background-accent-gray-subtlest, #6B778C)",
    'color.background.accent.gray.subtlest.hovered': "var(--ds-background-accent-gray-subtlest-hovered, #5E6C84)",
    'color.background.accent.gray.subtlest.pressed': "var(--ds-background-accent-gray-subtlest-pressed, #505F79)",
    'color.background.accent.gray.subtler': "var(--ds-background-accent-gray-subtler, #5E6C84)",
    'color.background.accent.gray.subtler.hovered': "var(--ds-background-accent-gray-subtler-hovered, #505F79)",
    'color.background.accent.gray.subtler.pressed': "var(--ds-background-accent-gray-subtler-pressed, #42526E)",
    'color.background.accent.gray.subtle': "var(--ds-background-accent-gray-subtle, #505F79)",
    'color.background.accent.gray.subtle.hovered': "var(--ds-background-accent-gray-subtle-hovered, #5E6C84)",
    'color.background.accent.gray.subtle.pressed': "var(--ds-background-accent-gray-subtle-pressed, #6B778C)",
    'color.background.accent.gray.bolder': "var(--ds-background-accent-gray-bolder, #42526E)",
    'color.background.accent.gray.bolder.hovered': "var(--ds-background-accent-gray-bolder-hovered, #344563)",
    'color.background.accent.gray.bolder.pressed': "var(--ds-background-accent-gray-bolder-pressed, #253858)",
    'color.background.disabled': "var(--ds-background-disabled, #091e4289)",
    'color.background.input': "var(--ds-background-input, #FAFBFC)",
    'color.background.input.hovered': "var(--ds-background-input-hovered, #EBECF0)",
    'color.background.input.pressed': "var(--ds-background-input-pressed, #FFFFFF)",
    'color.background.inverse.subtle': "var(--ds-background-inverse-subtle, #00000029)",
    'color.background.inverse.subtle.hovered': "var(--ds-background-inverse-subtle-hovered, #0000003D)",
    'color.background.inverse.subtle.pressed': "var(--ds-background-inverse-subtle-pressed, #00000052)",
    'color.background.neutral': "var(--ds-background-neutral, #DFE1E6)",
    'color.background.neutral.hovered': "var(--ds-background-neutral-hovered, #091e4214)",
    'color.background.neutral.pressed': "var(--ds-background-neutral-pressed, #B3D4FF)",
    'color.background.neutral.subtle': "var(--ds-background-neutral-subtle, transparent)",
    'color.background.neutral.subtle.hovered': "var(--ds-background-neutral-subtle-hovered, #091e4214)",
    'color.background.neutral.subtle.pressed': "var(--ds-background-neutral-subtle-pressed, #B3D4FF)",
    'color.background.neutral.bold': "var(--ds-background-neutral-bold, #42526E)",
    'color.background.neutral.bold.hovered': "var(--ds-background-neutral-bold-hovered, #505F79)",
    'color.background.neutral.bold.pressed': "var(--ds-background-neutral-bold-pressed, #344563)",
    'color.background.selected': "var(--ds-background-selected, #DEEBFF)",
    'color.background.selected.hovered': "var(--ds-background-selected-hovered, #B3D4FF)",
    'color.background.selected.pressed': "var(--ds-background-selected-pressed, #4C9AFF)",
    'color.background.selected.bold': "var(--ds-background-selected-bold, #0052CC)",
    'color.background.selected.bold.hovered': "var(--ds-background-selected-bold-hovered, #2684FF)",
    'color.background.selected.bold.pressed': "var(--ds-background-selected-bold-pressed, #0052CC)",
    'color.background.brand.subtlest': "var(--ds-background-brand-subtlest, #B3D4FF)",
    'color.background.brand.subtlest.hovered': "var(--ds-background-brand-subtlest-hovered, #DEEBFF)",
    'color.background.brand.subtlest.pressed': "var(--ds-background-brand-subtlest-pressed, #4C9AFF)",
    'color.background.brand.bold': "var(--ds-background-brand-bold, #0052CC)",
    'color.background.brand.bold.hovered': "var(--ds-background-brand-bold-hovered, #0065FF)",
    'color.background.brand.bold.pressed': "var(--ds-background-brand-bold-pressed, #0747A6)",
    'color.background.brand.boldest': "var(--ds-background-brand-boldest, #0747A6)",
    'color.background.brand.boldest.hovered': "var(--ds-background-brand-boldest-hovered, #0052CC)",
    'color.background.brand.boldest.pressed': "var(--ds-background-brand-boldest-pressed, #0747A6)",
    'color.background.danger': "var(--ds-background-danger, #FFEBE6)",
    'color.background.danger.hovered': "var(--ds-background-danger-hovered, #FFBDAD)",
    'color.background.danger.pressed': "var(--ds-background-danger-pressed, #FF8F73)",
    'color.background.danger.bold': "var(--ds-background-danger-bold, #DE350B)",
    'color.background.danger.bold.hovered': "var(--ds-background-danger-bold-hovered, #FF5630)",
    'color.background.danger.bold.pressed': "var(--ds-background-danger-bold-pressed, #BF2600)",
    'color.background.warning': "var(--ds-background-warning, #FFFAE6)",
    'color.background.warning.hovered': "var(--ds-background-warning-hovered, #FFF0B3)",
    'color.background.warning.pressed': "var(--ds-background-warning-pressed, #FFE380)",
    'color.background.warning.bold': "var(--ds-background-warning-bold, #FFAB00)",
    'color.background.warning.bold.hovered': "var(--ds-background-warning-bold-hovered, #FFC400)",
    'color.background.warning.bold.pressed': "var(--ds-background-warning-bold-pressed, #FF991F)",
    'color.background.success': "var(--ds-background-success, #E3FCEF)",
    'color.background.success.hovered': "var(--ds-background-success-hovered, #ABF5D1)",
    'color.background.success.pressed': "var(--ds-background-success-pressed, #79F2C0)",
    'color.background.success.bold': "var(--ds-background-success-bold, #00875A)",
    'color.background.success.bold.hovered': "var(--ds-background-success-bold-hovered, #57D9A3)",
    'color.background.success.bold.pressed': "var(--ds-background-success-bold-pressed, #00875A)",
    'color.background.discovery': "var(--ds-background-discovery, #EAE6FF)",
    'color.background.discovery.hovered': "var(--ds-background-discovery-hovered, #C0B6F2)",
    'color.background.discovery.pressed': "var(--ds-background-discovery-pressed, #998DD9)",
    'color.background.discovery.bold': "var(--ds-background-discovery-bold, #5243AA)",
    'color.background.discovery.bold.hovered': "var(--ds-background-discovery-bold-hovered, #8777D9)",
    'color.background.discovery.bold.pressed': "var(--ds-background-discovery-bold-pressed, #5243AA)",
    'color.background.information': "var(--ds-background-information, #DEEBFF)",
    'color.background.information.hovered': "var(--ds-background-information-hovered, #B3D4FF)",
    'color.background.information.pressed': "var(--ds-background-information-pressed, #4C9AFF)",
    'color.background.information.bold': "var(--ds-background-information-bold, #0052CC)",
    'color.background.information.bold.hovered': "var(--ds-background-information-bold-hovered, #2684FF)",
    'color.background.information.bold.pressed': "var(--ds-background-information-bold-pressed, #0052CC)",
    'color.blanket': "var(--ds-blanket, #091e4289)",
    'color.blanket.selected': "var(--ds-blanket-selected, #388BFF14)",
    'color.blanket.danger': "var(--ds-blanket-danger, #EF5C4814)",
    'elevation.surface': "var(--ds-surface, #FFFFFF)",
    'elevation.surface.hovered': "var(--ds-surface-hovered, #FAFBFC)",
    'elevation.surface.pressed': "var(--ds-surface-pressed, #F4F5F7)",
    'elevation.surface.overlay': "var(--ds-surface-overlay, #FFFFFF)",
    'elevation.surface.overlay.hovered': "var(--ds-surface-overlay-hovered, #FAFBFC)",
    'elevation.surface.overlay.pressed': "var(--ds-surface-overlay-pressed, #F4F5F7)",
    'elevation.surface.raised': "var(--ds-surface-raised, #FFFFFF)",
    'elevation.surface.raised.hovered': "var(--ds-surface-raised-hovered, #FAFBFC)",
    'elevation.surface.raised.pressed': "var(--ds-surface-raised-pressed, #F4F5F7)",
    'elevation.surface.sunken': "var(--ds-surface-sunken, #F4F5F7)",
    'utility.elevation.surface.current': "var(--ds-elevation-surface-current, #FFFFFF)"
};
var $11472afca28cc3f2$export$8473307aa00d6ea1 = {
    'color.text': "var(--ds-text, #172B4D)",
    'color.text.accent.lime': "var(--ds-text-accent-lime, #4C6B1F)",
    'color.text.accent.lime.bolder': "var(--ds-text-accent-lime-bolder, #37471F)",
    'color.text.accent.red': "var(--ds-text-accent-red, #DE350B)",
    'color.text.accent.red.bolder': "var(--ds-text-accent-red-bolder, #BF2600)",
    'color.text.accent.orange': "var(--ds-text-accent-orange, #F18D13)",
    'color.text.accent.orange.bolder': "var(--ds-text-accent-orange-bolder, #B65C02)",
    'color.text.accent.yellow': "var(--ds-text-accent-yellow, #FF991F)",
    'color.text.accent.yellow.bolder': "var(--ds-text-accent-yellow-bolder, #FF8B00)",
    'color.text.accent.green': "var(--ds-text-accent-green, #00875A)",
    'color.text.accent.green.bolder': "var(--ds-text-accent-green-bolder, #006644)",
    'color.text.accent.teal': "var(--ds-text-accent-teal, #00A3BF)",
    'color.text.accent.teal.bolder': "var(--ds-text-accent-teal-bolder, #008DA6)",
    'color.text.accent.blue': "var(--ds-text-accent-blue, #0052CC)",
    'color.text.accent.blue.bolder': "var(--ds-text-accent-blue-bolder, #0747A6)",
    'color.text.accent.purple': "var(--ds-text-accent-purple, #5243AA)",
    'color.text.accent.purple.bolder': "var(--ds-text-accent-purple-bolder, #403294)",
    'color.text.accent.magenta': "var(--ds-text-accent-magenta, #E774BB)",
    'color.text.accent.magenta.bolder': "var(--ds-text-accent-magenta-bolder, #DA62AC)",
    'color.text.accent.gray': "var(--ds-text-accent-gray, #505F79)",
    'color.text.accent.gray.bolder': "var(--ds-text-accent-gray-bolder, #172B4D)",
    'color.text.disabled': "var(--ds-text-disabled, #A5ADBA)",
    'color.text.inverse': "var(--ds-text-inverse, #FFFFFF)",
    'color.text.selected': "var(--ds-text-selected, #0052CC)",
    'color.text.brand': "var(--ds-text-brand, #0065FF)",
    'color.text.danger': "var(--ds-text-danger, #DE350B)",
    'color.text.warning': "var(--ds-text-warning, #974F0C)",
    'color.text.warning.inverse': "var(--ds-text-warning-inverse, #172B4D)",
    'color.text.success': "var(--ds-text-success, #006644)",
    'color.text.discovery': "var(--ds-text-discovery, #403294)",
    'color.text.information': "var(--ds-text-information, #0052CC)",
    'color.text.subtlest': "var(--ds-text-subtlest, #7A869A)",
    'color.text.subtle': "var(--ds-text-subtle, #42526E)",
    'color.link': "var(--ds-link, #0052CC)",
    'color.link.pressed': "var(--ds-link-pressed, #0747A6)",
    'color.link.visited': "var(--ds-link-visited, #403294)",
    'color.link.visited.pressed': "var(--ds-link-visited-pressed, #403294)"
};
var $11472afca28cc3f2$export$498780f74be9af68 = {
    'color.icon': "var(--ds-icon, #505F79)",
    'color.icon.accent.lime': "var(--ds-icon-accent-lime, #6A9A23)",
    'color.icon.accent.red': "var(--ds-icon-accent-red, #FF5630)",
    'color.icon.accent.orange': "var(--ds-icon-accent-orange, #D94008)",
    'color.icon.accent.yellow': "var(--ds-icon-accent-yellow, #FFAB00)",
    'color.icon.accent.green': "var(--ds-icon-accent-green, #36B37E)",
    'color.icon.accent.teal': "var(--ds-icon-accent-teal, #00B8D9)",
    'color.icon.accent.blue': "var(--ds-icon-accent-blue, #0065FF)",
    'color.icon.accent.purple': "var(--ds-icon-accent-purple, #6554C0)",
    'color.icon.accent.magenta': "var(--ds-icon-accent-magenta, #CD519D)",
    'color.icon.accent.gray': "var(--ds-icon-accent-gray, #5E6C84)",
    'color.icon.disabled': "var(--ds-icon-disabled, #8993A4)",
    'color.icon.inverse': "var(--ds-icon-inverse, #FFFFFF)",
    'color.icon.selected': "var(--ds-icon-selected, #0052CC)",
    'color.icon.brand': "var(--ds-icon-brand, #0065FF)",
    'color.icon.danger': "var(--ds-icon-danger, #DE350B)",
    'color.icon.warning': "var(--ds-icon-warning, #FFC400)",
    'color.icon.warning.inverse': "var(--ds-icon-warning-inverse, #253858)",
    'color.icon.success': "var(--ds-icon-success, #00875A)",
    'color.icon.discovery': "var(--ds-icon-discovery, #8777D9)",
    'color.icon.information': "var(--ds-icon-information, #0747A6)",
    'color.icon.subtle': "var(--ds-icon-subtle, #6B778C)"
};
var $11472afca28cc3f2$export$b5f31a7e431d2eab = {
    card: 100,
    navigation: 200,
    dialog: 300,
    layer: 400,
    blanket: 500,
    modal: 510,
    flag: 600,
    spotlight: 700,
    tooltip: 800
};
var $11472afca28cc3f2$export$e1b83c5210c471b8 = {
    'border.width': "var(--ds-border-width, 1px)",
    'border.width.0': "var(--ds-border-width-0, 0px)",
    'border.width.indicator': "var(--ds-border-width-indicator, 3px)",
    'border.width.outline': "var(--ds-border-width-outline, 2px)"
};
var $11472afca28cc3f2$export$3c0a6c3e64bb180d = {
    'border.radius.050': "var(--ds-border-radius-050, 2px)",
    'border.radius': "var(--ds-border-radius, 3px)",
    'border.radius.100': "var(--ds-border-radius-100, 3px)",
    'border.radius.200': "var(--ds-border-radius-200, 8px)",
    'border.radius.300': "var(--ds-border-radius-300, 12px)",
    'border.radius.400': "var(--ds-border-radius-400, 16px)",
    'border.radius.circle': "var(--ds-border-radius-circle, 32032px)"
};
var $11472afca28cc3f2$export$6cc560b4dedf3816 = {
    medium: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    UNSAFE_small: "var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    large: "var(--ds-font-body-large, normal 400 16px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    small: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)"
};
var $11472afca28cc3f2$export$303e322c6b1ed114 = {
    bold: "var(--ds-font-weight-bold, 700)",
    medium: "var(--ds-font-weight-medium, 500)",
    regular: "var(--ds-font-weight-regular, 400)",
    semibold: "var(--ds-font-weight-semibold, 600)"
};
var $11472afca28cc3f2$export$3c7e9587132614b4 = {
    'font.family.brand.body': "var(--ds-font-family-brand-body, \"Charlie Text\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    'font.family.brand.heading': "var(--ds-font-family-brand-heading, \"Charlie Display\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)"
};
/**
 * @codegenEnd
 */ // Generate maps for Box props. backgroundColor, padding, etc
var $11472afca28cc3f2$var$spacingProperties = [
    // Used by Box
    'padding',
    'paddingBlock',
    'paddingBlockStart',
    'paddingBlockEnd',
    'paddingInline',
    'paddingInlineStart',
    'paddingInlineEnd',
    // Used by Inline and Stack
    'gap',
    'rowGap',
    'columnGap'
];
var $11472afca28cc3f2$var$getSerializedStylesMap = function getSerializedStylesMap(cssProperty, tokenMap) {
    return Object.keys(tokenMap).reduce(function(emotionSpacingMap, token) {
        emotionSpacingMap[token] = (0, $74Zh5.css)((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, cssProperty, tokenMap[token]));
        return emotionSpacingMap;
    }, {});
};
var $11472afca28cc3f2$export$e615f061ca585a6c = $11472afca28cc3f2$var$spacingProperties.reduce(function(styleMap, spacingProperty) {
    styleMap[spacingProperty] = $11472afca28cc3f2$var$getSerializedStylesMap(spacingProperty, $11472afca28cc3f2$export$958d0ae7f2977ae4);
    return styleMap;
}, {});
var $11472afca28cc3f2$export$bf46c3f9eeafc71f = $11472afca28cc3f2$var$spacingProperties.reduce(function(styleMap, spacingProperty) {
    styleMap[spacingProperty] = $11472afca28cc3f2$var$getSerializedStylesMap(spacingProperty, $11472afca28cc3f2$export$958d0ae7f2977ae4);
    return styleMap;
}, {});
var $11472afca28cc3f2$export$e7af83bafe7f9e63 = $11472afca28cc3f2$var$getSerializedStylesMap('backgroundColor', $11472afca28cc3f2$export$d1d79bf68ac056bd);
var $11472afca28cc3f2$export$3a1bcba60b23d7f0 = $11472afca28cc3f2$var$getSerializedStylesMap('color', $11472afca28cc3f2$export$8473307aa00d6ea1);
var $11472afca28cc3f2$export$45f3f4fe16f9f7d5 = $11472afca28cc3f2$var$getSerializedStylesMap('fontWeight', $11472afca28cc3f2$export$303e322c6b1ed114);
var $11472afca28cc3f2$export$68cc305da27dbaa4 = $11472afca28cc3f2$var$getSerializedStylesMap('fontFamily', $11472afca28cc3f2$export$3c7e9587132614b4);
var $11472afca28cc3f2$export$128f10c238242f83 = $11472afca28cc3f2$var$getSerializedStylesMap('font', $11472afca28cc3f2$export$6cc560b4dedf3816);
var $11472afca28cc3f2$export$ff257d957d48c421 = $11472afca28cc3f2$var$getSerializedStylesMap((0, $59e7965bd64289a3$export$9d7b58831ae93caa), $11472afca28cc3f2$export$41a358c9c2356760);
var $11472afca28cc3f2$export$5e65a44e5b6ecadb = function isSurfaceColorToken(color) {
    return $11472afca28cc3f2$export$41a358c9c2356760[color] !== undefined;
};



var $fC8ib = parcelRequire("fC8ib");

var $25nEq = parcelRequire("25nEq");

var $iYJcE = parcelRequire("iYJcE");

var $ekGgq = parcelRequire("ekGgq");

var $74Zh5 = parcelRequire("74Zh5");


var $3ZMUU = parcelRequire("3ZMUU");
function $7c2f920c3bda89b1$var$_createForOfIteratorHelper(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (!it) {
        if (Array.isArray(o) || (it = $7c2f920c3bda89b1$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
            if (it) o = it;
            var i = 0;
            var F = function F() {};
            return {
                s: F,
                n: function n() {
                    if (i >= o.length) return {
                        done: true
                    };
                    return {
                        done: false,
                        value: o[i++]
                    };
                },
                e: function e(_e) {
                    throw _e;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var normalCompletion = true, didErr = false, err;
    return {
        s: function s() {
            it = it.call(o);
        },
        n: function n() {
            var step = it.next();
            normalCompletion = step.done;
            return step;
        },
        e: function e(_e2) {
            didErr = true;
            err = _e2;
        },
        f: function f() {
            try {
                if (!normalCompletion && it.return != null) it.return();
            } finally{
                if (didErr) throw err;
            }
        }
    };
}
function $7c2f920c3bda89b1$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $7c2f920c3bda89b1$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $7c2f920c3bda89b1$var$_arrayLikeToArray(o, minLen);
}
function $7c2f920c3bda89b1$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
var $7c2f920c3bda89b1$export$9a199fbafee0014e = {
    backgroundColor: (0, $11472afca28cc3f2$export$d1d79bf68ac056bd),
    blockSize: (0, $11472afca28cc3f2$export$6ccdbebca2ee545f),
    borderBlockColor: (0, $11472afca28cc3f2$export$1531ad5bb3fbedac),
    borderBlockEndColor: (0, $11472afca28cc3f2$export$1531ad5bb3fbedac),
    borderBlockEndWidth: (0, $11472afca28cc3f2$export$e1b83c5210c471b8),
    borderBlockStartColor: (0, $11472afca28cc3f2$export$1531ad5bb3fbedac),
    borderBlockStartWidth: (0, $11472afca28cc3f2$export$e1b83c5210c471b8),
    borderBlockWidth: (0, $11472afca28cc3f2$export$e1b83c5210c471b8),
    borderBottomColor: (0, $11472afca28cc3f2$export$1531ad5bb3fbedac),
    borderBottomLeftRadius: (0, $11472afca28cc3f2$export$3c0a6c3e64bb180d),
    borderBottomRightRadius: (0, $11472afca28cc3f2$export$3c0a6c3e64bb180d),
    borderBottomWidth: (0, $11472afca28cc3f2$export$e1b83c5210c471b8),
    borderColor: (0, $11472afca28cc3f2$export$1531ad5bb3fbedac),
    borderEndEndRadius: (0, $11472afca28cc3f2$export$3c0a6c3e64bb180d),
    borderEndStartRadius: (0, $11472afca28cc3f2$export$3c0a6c3e64bb180d),
    borderInlineColor: (0, $11472afca28cc3f2$export$1531ad5bb3fbedac),
    borderInlineEndColor: (0, $11472afca28cc3f2$export$1531ad5bb3fbedac),
    borderInlineEndWidth: (0, $11472afca28cc3f2$export$e1b83c5210c471b8),
    borderInlineStartColor: (0, $11472afca28cc3f2$export$1531ad5bb3fbedac),
    borderInlineStartWidth: (0, $11472afca28cc3f2$export$e1b83c5210c471b8),
    borderInlineWidth: (0, $11472afca28cc3f2$export$e1b83c5210c471b8),
    borderLeftColor: (0, $11472afca28cc3f2$export$1531ad5bb3fbedac),
    borderLeftWidth: (0, $11472afca28cc3f2$export$e1b83c5210c471b8),
    borderRadius: (0, $11472afca28cc3f2$export$3c0a6c3e64bb180d),
    borderRightColor: (0, $11472afca28cc3f2$export$1531ad5bb3fbedac),
    borderRightWidth: (0, $11472afca28cc3f2$export$e1b83c5210c471b8),
    borderStartEndRadius: (0, $11472afca28cc3f2$export$3c0a6c3e64bb180d),
    borderStartStartRadius: (0, $11472afca28cc3f2$export$3c0a6c3e64bb180d),
    borderTopColor: (0, $11472afca28cc3f2$export$1531ad5bb3fbedac),
    borderTopLeftRadius: (0, $11472afca28cc3f2$export$3c0a6c3e64bb180d),
    borderTopRightRadius: (0, $11472afca28cc3f2$export$3c0a6c3e64bb180d),
    borderTopWidth: (0, $11472afca28cc3f2$export$e1b83c5210c471b8),
    borderWidth: (0, $11472afca28cc3f2$export$e1b83c5210c471b8),
    bottom: (0, $11472afca28cc3f2$export$632685d741f3dbbf),
    boxShadow: (0, $11472afca28cc3f2$export$7aff6e7ba39bb774),
    color: (0, $11472afca28cc3f2$export$8473307aa00d6ea1),
    columnGap: (0, $11472afca28cc3f2$export$958d0ae7f2977ae4),
    gap: (0, $11472afca28cc3f2$export$958d0ae7f2977ae4),
    height: (0, $11472afca28cc3f2$export$6ccdbebca2ee545f),
    inlineSize: (0, $11472afca28cc3f2$export$6ccdbebca2ee545f),
    inset: (0, $11472afca28cc3f2$export$632685d741f3dbbf),
    insetBlock: (0, $11472afca28cc3f2$export$632685d741f3dbbf),
    insetBlockEnd: (0, $11472afca28cc3f2$export$632685d741f3dbbf),
    insetBlockStart: (0, $11472afca28cc3f2$export$632685d741f3dbbf),
    insetInline: (0, $11472afca28cc3f2$export$632685d741f3dbbf),
    insetInlineEnd: (0, $11472afca28cc3f2$export$632685d741f3dbbf),
    insetInlineStart: (0, $11472afca28cc3f2$export$632685d741f3dbbf),
    left: (0, $11472afca28cc3f2$export$632685d741f3dbbf),
    margin: (0, $11472afca28cc3f2$export$632685d741f3dbbf),
    marginBlock: (0, $11472afca28cc3f2$export$632685d741f3dbbf),
    marginBlockEnd: (0, $11472afca28cc3f2$export$632685d741f3dbbf),
    marginBlockStart: (0, $11472afca28cc3f2$export$632685d741f3dbbf),
    marginBottom: (0, $11472afca28cc3f2$export$632685d741f3dbbf),
    marginInline: (0, $11472afca28cc3f2$export$632685d741f3dbbf),
    marginInlineEnd: (0, $11472afca28cc3f2$export$632685d741f3dbbf),
    marginInlineStart: (0, $11472afca28cc3f2$export$632685d741f3dbbf),
    marginLeft: (0, $11472afca28cc3f2$export$632685d741f3dbbf),
    marginRight: (0, $11472afca28cc3f2$export$632685d741f3dbbf),
    marginTop: (0, $11472afca28cc3f2$export$632685d741f3dbbf),
    maxBlockSize: (0, $11472afca28cc3f2$export$6ccdbebca2ee545f),
    maxHeight: (0, $11472afca28cc3f2$export$6ccdbebca2ee545f),
    maxInlineSize: (0, $11472afca28cc3f2$export$6ccdbebca2ee545f),
    maxWidth: (0, $11472afca28cc3f2$export$6ccdbebca2ee545f),
    minBlockSize: (0, $11472afca28cc3f2$export$6ccdbebca2ee545f),
    minHeight: (0, $11472afca28cc3f2$export$6ccdbebca2ee545f),
    minInlineSize: (0, $11472afca28cc3f2$export$6ccdbebca2ee545f),
    minWidth: (0, $11472afca28cc3f2$export$6ccdbebca2ee545f),
    opacity: (0, $11472afca28cc3f2$export$daf94a976c798b4f),
    outlineColor: (0, $11472afca28cc3f2$export$1531ad5bb3fbedac),
    outlineOffset: (0, $11472afca28cc3f2$export$958d0ae7f2977ae4),
    outlineWidth: (0, $11472afca28cc3f2$export$e1b83c5210c471b8),
    padding: (0, $11472afca28cc3f2$export$958d0ae7f2977ae4),
    paddingBlock: (0, $11472afca28cc3f2$export$958d0ae7f2977ae4),
    paddingBlockEnd: (0, $11472afca28cc3f2$export$958d0ae7f2977ae4),
    paddingBlockStart: (0, $11472afca28cc3f2$export$958d0ae7f2977ae4),
    paddingBottom: (0, $11472afca28cc3f2$export$958d0ae7f2977ae4),
    paddingInline: (0, $11472afca28cc3f2$export$958d0ae7f2977ae4),
    paddingInlineEnd: (0, $11472afca28cc3f2$export$958d0ae7f2977ae4),
    paddingInlineStart: (0, $11472afca28cc3f2$export$958d0ae7f2977ae4),
    paddingLeft: (0, $11472afca28cc3f2$export$958d0ae7f2977ae4),
    paddingRight: (0, $11472afca28cc3f2$export$958d0ae7f2977ae4),
    paddingTop: (0, $11472afca28cc3f2$export$958d0ae7f2977ae4),
    right: (0, $11472afca28cc3f2$export$632685d741f3dbbf),
    rowGap: (0, $11472afca28cc3f2$export$958d0ae7f2977ae4),
    top: (0, $11472afca28cc3f2$export$632685d741f3dbbf),
    width: (0, $11472afca28cc3f2$export$6ccdbebca2ee545f),
    zIndex: (0, $11472afca28cc3f2$export$b5f31a7e431d2eab)
};
var $7c2f920c3bda89b1$var$uniqueSymbol = Symbol('UNSAFE_INTERNAL_styles');
var $7c2f920c3bda89b1$var$isSafeEnvToThrow = function isSafeEnvToThrow() {
    return (typeof $3ZMUU === "undefined" ? "undefined" : (0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))($3ZMUU)) === 'object' && (0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))($3ZMUU.env) === 'object' && false;
};
var $7c2f920c3bda89b1$var$reNestedSelectors = /(\.|\s|&+|\*\>|#|\[.*\])/;
var $7c2f920c3bda89b1$var$safeSelectors = /^@media .*$|^::?.*$|^@supports .*$/;
var $7c2f920c3bda89b1$var$transformStyles = function transformStyles(styleObj) {
    if (!styleObj || (0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(styleObj) !== 'object') return styleObj;
    // If styles are defined as a CSSObject[], recursively call on each element until we reach CSSObject
    if (Array.isArray(styleObj)) return styleObj.map(transformStyles);
    // Modifies styleObj in place. Be careful.
    Object.entries(styleObj).forEach(function(_ref) {
        var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_ref, 2), key = _ref2[0], value = _ref2[1];
        // If key is a pseudo class or a pseudo element, then value should be an object.
        // So, call transformStyles on the value
        if ((0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(value) === 'object' && $7c2f920c3bda89b1$var$safeSelectors.test(key)) {
            styleObj[key] = transformStyles(value);
            return;
        }
        if ($7c2f920c3bda89b1$var$isSafeEnvToThrow()) {
            // We don't support `.class`, `[data-testid]`, `> *`, `#some-id`
            if ($7c2f920c3bda89b1$var$reNestedSelectors.test(key)) throw new Error("Styles not supported for key '".concat(key, "'."));
        }
        // We have now dealt with all the special cases, so,
        // check whether what remains is a style property
        // that can be transformed.
        if (!(key in $7c2f920c3bda89b1$export$9a199fbafee0014e)) return;
        var tokenValue = $7c2f920c3bda89b1$export$9a199fbafee0014e[key][value];
        styleObj[key] = tokenValue !== null && tokenValue !== void 0 ? tokenValue : value;
    });
    return styleObj;
};
var $7c2f920c3bda89b1$var$baseXcss = function baseXcss(style) {
    var transformedStyles = $7c2f920c3bda89b1$var$transformStyles(style);
    return (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, $7c2f920c3bda89b1$var$uniqueSymbol, (0, $74Zh5.css)(transformedStyles));
};
var $7c2f920c3bda89b1$export$a9c84988c8f81f2d = function parseXcss(args) {
    if (Array.isArray(args)) {
        var emotion = [];
        var staticArr = [];
        var _iterator = $7c2f920c3bda89b1$var$_createForOfIteratorHelper(args), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var arg = _step.value;
                var result = parseXcss(arg);
                if (result.emotion) emotion.push.apply(emotion, (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(result.emotion));
                if (result.static) staticArr.push(result.static);
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
        return {
            emotion: emotion,
            static: staticArr.join(' ')
        };
    }
    var objArgs = args;
    var _ref4 = objArgs || {}, styles = _ref4[$7c2f920c3bda89b1$var$uniqueSymbol];
    if (styles) return {
        emotion: [
            styles
        ]
    };
    if (args) {
        // We use string interpolation here instead of .toString() just
        // in case the resulting object doesn't have the method available.
        var stringifiedArgs = "".concat(args);
        if (stringifiedArgs) return {
            static: stringifiedArgs
        };
    }
    return {};
};
function $7c2f920c3bda89b1$export$f6c783d06584602c(style) {
    return $7c2f920c3bda89b1$var$baseXcss(style);
}



var $5FkrB = parcelRequire("5FkrB");
var $b7f246307f063e1f$export$1ca2a26fecb070ae = /*#__PURE__*/ (0, $5FkrB.createContext)('elevation.surface');
var $b7f246307f063e1f$export$1aeb4f6b93c4540d = function useSurface() {
    return (0, $5FkrB.useContext)($b7f246307f063e1f$export$1ca2a26fecb070ae);
};
$b7f246307f063e1f$export$1ca2a26fecb070ae.displayName = 'SurfaceProvider';


var $abf94df1a292a623$var$_excluded = [
    "as",
    "children",
    "backgroundColor",
    "padding",
    "paddingBlock",
    "paddingBlockStart",
    "paddingBlockEnd",
    "paddingInline",
    "paddingInlineStart",
    "paddingInlineEnd",
    "style",
    "testId",
    "xcss"
], $abf94df1a292a623$var$_excluded2 = [
    "className"
];
var $abf94df1a292a623$export$e71c4d32a2263218 = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? 'div' : _ref$as, children = _ref.children, backgroundColor = _ref.backgroundColor, padding = _ref.padding, paddingBlock = _ref.paddingBlock, paddingBlockStart = _ref.paddingBlockStart, paddingBlockEnd = _ref.paddingBlockEnd, paddingInline = _ref.paddingInline, paddingInlineStart = _ref.paddingInlineStart, paddingInlineEnd = _ref.paddingInlineEnd, style = _ref.style, testId = _ref.testId, xcss = _ref.xcss, htmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $abf94df1a292a623$var$_excluded);
    // This is to remove className from safeHtmlAttributes
    // @ts-expect-error className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(htmlAttributes, $abf94df1a292a623$var$_excluded2);
    var resolvedStyles = (0, $7c2f920c3bda89b1$export$a9c84988c8f81f2d)(xcss);
    var node = // @ts-expect-error Expression produces a union type that is too complex to represent. I think this is unavoidable
    (0, $74Zh5.jsx)(Component, (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        style: style,
        ref: ref,
        className: resolvedStyles.static
    }, safeHtmlAttributes, {
        css: [
            $abf94df1a292a623$var$baseStyles,
            backgroundColor && (0, $11472afca28cc3f2$export$e7af83bafe7f9e63)[backgroundColor],
            (0, $11472afca28cc3f2$export$5e65a44e5b6ecadb)(backgroundColor) && (0, $11472afca28cc3f2$export$ff257d957d48c421)[backgroundColor],
            padding && (0, $11472afca28cc3f2$export$e615f061ca585a6c).padding[padding],
            paddingBlock && (0, $11472afca28cc3f2$export$e615f061ca585a6c).paddingBlock[paddingBlock],
            paddingBlockStart && (0, $11472afca28cc3f2$export$e615f061ca585a6c).paddingBlockStart[paddingBlockStart],
            paddingBlockEnd && (0, $11472afca28cc3f2$export$e615f061ca585a6c).paddingBlockEnd[paddingBlockEnd],
            paddingInline && (0, $11472afca28cc3f2$export$e615f061ca585a6c).paddingInline[paddingInline],
            paddingInlineStart && (0, $11472afca28cc3f2$export$e615f061ca585a6c).paddingInlineStart[paddingInlineStart],
            paddingInlineEnd && (0, $11472afca28cc3f2$export$e615f061ca585a6c).paddingInlineEnd[paddingInlineEnd],
            // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
            resolvedStyles.emotion
        ],
        "data-testid": testId
    }), children);
    return backgroundColor ? (0, $74Zh5.jsx)((0, $b7f246307f063e1f$export$1ca2a26fecb070ae).Provider, {
        value: backgroundColor
    }, node) : node;
});
var $abf94df1a292a623$export$2e2bcd8739ae039 = $abf94df1a292a623$export$e71c4d32a2263218;
var $abf94df1a292a623$var$baseStyles = (0, $74Zh5.css)({
    boxSizing: 'border-box',
    appearance: 'none',
    border: 'none'
});

/** @jsx jsx */ 
var $5FkrB = parcelRequire("5FkrB");

var $74Zh5 = parcelRequire("74Zh5");


var $0654f583dbdded1e$var$justifyContentMap = {
    start: (0, $74Zh5.css)({
        justifyContent: 'start'
    }),
    center: (0, $74Zh5.css)({
        justifyContent: 'center'
    }),
    end: (0, $74Zh5.css)({
        justifyContent: 'end'
    }),
    'space-between': (0, $74Zh5.css)({
        justifyContent: 'space-between'
    }),
    'space-around': (0, $74Zh5.css)({
        justifyContent: 'space-around'
    }),
    'space-evenly': (0, $74Zh5.css)({
        justifyContent: 'space-evenly'
    }),
    stretch: (0, $74Zh5.css)({
        justifyContent: 'stretch'
    })
};
var $0654f583dbdded1e$var$flexDirectionMap = {
    column: (0, $74Zh5.css)({
        flexDirection: 'column'
    }),
    row: (0, $74Zh5.css)({
        flexDirection: 'row'
    })
};
var $0654f583dbdded1e$var$flexWrapMap = {
    wrap: (0, $74Zh5.css)({
        flexWrap: 'wrap'
    }),
    nowrap: (0, $74Zh5.css)({
        flexWrap: 'nowrap'
    })
};
var $0654f583dbdded1e$var$alignItemsMap = {
    start: (0, $74Zh5.css)({
        alignItems: 'start'
    }),
    center: (0, $74Zh5.css)({
        alignItems: 'center'
    }),
    baseline: (0, $74Zh5.css)({
        alignItems: 'baseline'
    }),
    end: (0, $74Zh5.css)({
        alignItems: 'end'
    }),
    stretch: (0, $74Zh5.css)({
        alignItems: 'stretch'
    })
};
var $0654f583dbdded1e$var$baseStyles = (0, $74Zh5.css)({
    display: 'flex',
    boxSizing: 'border-box'
});
/**
 * __Flex__
 *
 * `Flex` is a primitive component that implements the CSS Flexbox API.
 *
 * - [Examples](https://atlassian.design/components/primitives/flex/examples)
 * - [Code](https://atlassian.design/components/primitives/flex/code)
 *
 * @example
 * ```tsx
 * import { Flex, Box } from '@atlaskit/primitives'
 *
 * const Component = () => (
 *   <Flex direction="column">
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *   </Flex>
 * )
 * ```
 */ var $0654f583dbdded1e$var$Flex = /*#__PURE__*/ (0, $5FkrB.memo)(/*#__PURE__*/ (0, $5FkrB.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? 'div' : _ref$as, role = _ref.role, alignItems = _ref.alignItems, justifyContent = _ref.justifyContent, gap = _ref.gap, columnGap = _ref.columnGap, rowGap = _ref.rowGap, children = _ref.children, testId = _ref.testId, direction = _ref.direction, wrap = _ref.wrap, xcss = _ref.xcss;
    var resolvedStyles = (0, $7c2f920c3bda89b1$export$a9c84988c8f81f2d)(xcss);
    return (0, $74Zh5.jsx)(Component, {
        role: role,
        className: resolvedStyles.static,
        css: [
            $0654f583dbdded1e$var$baseStyles,
            gap && (0, $11472afca28cc3f2$export$bf46c3f9eeafc71f).gap[gap],
            columnGap && (0, $11472afca28cc3f2$export$bf46c3f9eeafc71f).columnGap[columnGap],
            rowGap && (0, $11472afca28cc3f2$export$bf46c3f9eeafc71f).rowGap[rowGap],
            alignItems && $0654f583dbdded1e$var$alignItemsMap[alignItems],
            direction && $0654f583dbdded1e$var$flexDirectionMap[direction],
            justifyContent && $0654f583dbdded1e$var$justifyContentMap[justifyContent],
            wrap && $0654f583dbdded1e$var$flexWrapMap[wrap],
            // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
            resolvedStyles.emotion
        ],
        "data-testid": testId,
        ref: ref
    }, children);
}));
$0654f583dbdded1e$var$Flex.displayName = 'Flex';
var $0654f583dbdded1e$export$2e2bcd8739ae039 = $0654f583dbdded1e$var$Flex;


var $fC8ib = parcelRequire("fC8ib");

var $5FkrB = parcelRequire("5FkrB");

var $74Zh5 = parcelRequire("74Zh5");


var $0c22dfc1af284338$var$flexGrowMap = {
    hug: (0, $7c2f920c3bda89b1$export$f6c783d06584602c)({
        flexGrow: 0
    }),
    fill: (0, $7c2f920c3bda89b1$export$f6c783d06584602c)({
        width: '100%',
        flexGrow: 1
    })
};
var $0c22dfc1af284338$var$separatorStyles = (0, $74Zh5.css)({
    color: "var(--ds-text-subtle, #42526E)",
    marginBlock: "var(--ds-space-0, 0px)",
    marginInline: "var(--ds-space-negative-025, -2px)",
    pointerEvents: 'none',
    userSelect: 'none'
});
var $0c22dfc1af284338$var$Separator = function Separator(_ref) {
    var children = _ref.children;
    return (0, $74Zh5.jsx)("span", {
        css: $0c22dfc1af284338$var$separatorStyles
    }, children);
};
/**
 * __Inline__
 *
 * Inline is a primitive component based on CSS Flexbox that manages the horizontal layout of direct children.
 *
 * @example
 * ```tsx
 *  <Inline>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *  </Inline>
 * ```
 *
 */ var $0c22dfc1af284338$var$Inline = /*#__PURE__*/ (0, $5FkrB.memo)(/*#__PURE__*/ (0, $5FkrB.forwardRef)(function(_ref2, ref) {
    var as = _ref2.as, alignInline = _ref2.alignInline, _ref2$alignBlock = _ref2.alignBlock, alignItems = _ref2$alignBlock === void 0 ? 'start' : _ref2$alignBlock, _ref2$shouldWrap = _ref2.shouldWrap, shouldWrap = _ref2$shouldWrap === void 0 ? false : _ref2$shouldWrap, spread = _ref2.spread, grow = _ref2.grow, space = _ref2.space, rowSpace = _ref2.rowSpace, separator = _ref2.separator, xcss = _ref2.xcss, testId = _ref2.testId, role = _ref2.role, rawChildren = _ref2.children;
    var separatorComponent = typeof separator === 'string' ? (0, $74Zh5.jsx)($0c22dfc1af284338$var$Separator, null, separator) : separator;
    var children = separatorComponent ? (0, $5FkrB.Children).toArray(rawChildren).filter(Boolean).map(function(child, index) {
        return (0, $74Zh5.jsx)((0, $5FkrB.Fragment), {
            key: index
        }, separator && index > 0 ? separatorComponent : null, child);
    }) : rawChildren;
    var justifyContent = spread || alignInline;
    // We're type coercing this as Compiled styles in an array isn't supported by the types
    // But the runtime accepts it none-the-wiser. We can remove this entire block and replace
    // it with cx(defaultStyles, focusRingStyles, xcssStyles) when we've moved away from Emotion.
    var styles = grow ? [
        $0c22dfc1af284338$var$flexGrowMap[grow]
    ].concat((0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(Array.isArray(xcss) ? xcss : [
        xcss
    ])) : xcss;
    return (0, $74Zh5.jsx)((0, $0654f583dbdded1e$export$2e2bcd8739ae039), {
        as: as,
        role: role,
        alignItems: alignItems,
        justifyContent: justifyContent,
        direction: "row",
        gap: space,
        rowGap: rowSpace,
        wrap: shouldWrap ? 'wrap' : undefined,
        xcss: styles,
        testId: testId,
        ref: ref
    }, children);
}));
$0c22dfc1af284338$var$Inline.displayName = 'Inline';
var $0c22dfc1af284338$export$2e2bcd8739ae039 = $0c22dfc1af284338$var$Inline;

/**
 * This is an object of usable media query helpers using our internal breakpoints configuration.
 *
 * When using Compiled CSS-in-JS, please ensure that only a single declaration can take effect at a time.
 * This means that you should avoid multiple breakpoints taking effect at the same time,
 * eg. ```{ [media.above.xs]: { color: 'red' }, [media.above.sm]: { color: 'green' }}```.
 * Instead, make sure that only one breakpoint can take effect at a time,
 * e.g, ```{ [media.only.xs]: { color: 'red' }, [media.above.sm]: { color: 'green' }}```.
 * For more details, please see <https://compiledcssinjs.com/docs/atomic-css#selector-specificity>.
 */ var $cb8cedbc477f5a81$export$987d49ffe1b0900f = {
    above: {
        xxs: '@media all',
        xs: '@media (min-width: 30rem)',
        sm: '@media (min-width: 48rem)',
        md: '@media (min-width: 64rem)',
        lg: '@media (min-width: 90rem)',
        xl: '@media (min-width: 110rem)'
    },
    only: {
        xxs: '@media (min-width: 0rem) and (max-width: 29.99rem)',
        xs: '@media (min-width: 30rem) and (max-width: 47.99rem)',
        sm: '@media (min-width: 48rem) and (max-width: 63.99rem)',
        md: '@media (min-width: 64rem) and (max-width: 89.99rem)',
        lg: '@media (min-width: 90rem) and (max-width: 109.99rem)',
        xl: '@media (min-width: 110rem)'
    },
    below: {
        xs: '@media not all and (min-width: 30rem)',
        sm: '@media not all and (min-width: 48rem)',
        md: '@media not all and (min-width: 64rem)',
        lg: '@media not all and (min-width: 90rem)',
        xl: '@media not all and (min-width: 110rem)'
    }
};
var $cb8cedbc477f5a81$export$c881183ca713c214 = $cb8cedbc477f5a81$export$987d49ffe1b0900f;


var $fC8ib = parcelRequire("fC8ib");

var $5FkrB = parcelRequire("5FkrB");

var $74Zh5 = parcelRequire("74Zh5");


var $bdfb9b3a36dcb2bb$var$flexGrowMap = {
    hug: (0, $7c2f920c3bda89b1$export$f6c783d06584602c)({
        flexGrow: 0
    }),
    fill: (0, $7c2f920c3bda89b1$export$f6c783d06584602c)({
        width: '100%',
        flexGrow: 1
    })
};
/**
 * __Stack__
 *
 * Stack is a primitive component based on flexbox that manages the block layout of direct children.
 *
 * @example
 * ```tsx
 *  <Stack>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *  </Stack>
 * ```
 *
 */ var $bdfb9b3a36dcb2bb$var$Stack = /*#__PURE__*/ (0, $5FkrB.memo)(/*#__PURE__*/ (0, $5FkrB.forwardRef)(function(_ref, ref) {
    var as = _ref.as, alignItems = _ref.alignInline, _ref$alignBlock = _ref.alignBlock, alignBlock = _ref$alignBlock === void 0 ? 'stretch' : _ref$alignBlock, spread = _ref.spread, grow = _ref.grow, space = _ref.space, children = _ref.children, testId = _ref.testId, xcss = _ref.xcss, role = _ref.role;
    var justifyContent = spread || alignBlock;
    // We're type coercing this as Compiled styles in an array isn't supported by the types
    // But the runtime accepts it none-the-wiser. We can remove this entire block and replace
    // it with cx(defaultStyles, focusRingStyles, xcssStyles) when we've moved away from Emotion.
    var styles = grow ? [
        $bdfb9b3a36dcb2bb$var$flexGrowMap[grow]
    ].concat((0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(Array.isArray(xcss) ? xcss : [
        xcss
    ])) : xcss;
    return (0, $74Zh5.jsx)((0, $0654f583dbdded1e$export$2e2bcd8739ae039), {
        as: as,
        role: role,
        gap: space,
        direction: "column",
        alignItems: alignItems,
        justifyContent: justifyContent,
        xcss: styles,
        testId: testId,
        ref: ref
    }, children);
}));
$bdfb9b3a36dcb2bb$var$Stack.displayName = 'Stack';
var $bdfb9b3a36dcb2bb$export$2e2bcd8739ae039 = $bdfb9b3a36dcb2bb$var$Stack;

/** @jsx jsx */ 
var $5FkrB = parcelRequire("5FkrB");

var $74Zh5 = parcelRequire("74Zh5");

var $afMOk = parcelRequire("afMOk");


var $c9e5a7a14e07f4e4$var$asAllowlist = [
    'span',
    'p',
    'strong',
    'em'
];
// We're doing this because our CSS reset can add top margins to elements such as `p` which is totally insane.
// Long term we should remove those instances from the reset - it should be a reset to 0.
// For now, at least we know <Text> will be unaffected by this.
var $c9e5a7a14e07f4e4$var$resetStyles = (0, $74Zh5.css)({
    margin: 0
});
var $c9e5a7a14e07f4e4$var$strongStyles = (0, $74Zh5.css)({
    fontWeight: 'bold'
});
var $c9e5a7a14e07f4e4$var$emStyles = (0, $74Zh5.css)({
    fontStyle: 'italic'
});
var $c9e5a7a14e07f4e4$var$textAlignMap = {
    center: (0, $74Zh5.css)({
        textAlign: 'center'
    }),
    end: (0, $74Zh5.css)({
        textAlign: 'end'
    }),
    start: (0, $74Zh5.css)({
        textAlign: 'start'
    })
};
var $c9e5a7a14e07f4e4$var$truncationStyles = (0, $74Zh5.css)({
    display: '-webkit-box',
    overflow: 'hidden',
    WebkitBoxOrient: 'vertical'
});
var $c9e5a7a14e07f4e4$var$wordBreakMap = {
    breakAll: (0, $74Zh5.css)({
        wordBreak: 'break-all'
    })
};
var $c9e5a7a14e07f4e4$var$HasTextAncestorContext = /*#__PURE__*/ (0, $5FkrB.createContext)(false);
var $c9e5a7a14e07f4e4$var$useHasTextAncestor = function useHasTextAncestor() {
    return (0, $5FkrB.useContext)($c9e5a7a14e07f4e4$var$HasTextAncestorContext);
};
/**
 * Custom hook designed to abstract the parsing of the color props and make it clearer in the future how color is reconciled between themes and tokens.
 */ var $c9e5a7a14e07f4e4$var$useColor = function useColor(colorProp, hasTextAncestor) {
    var surface = (0, $b7f246307f063e1f$export$1aeb4f6b93c4540d)();
    /**
   * Where the color of the surface is inverted we always override the color
   * as there is no valid choice that is not covered by the override.
   */ if ((0, $11472afca28cc3f2$export$2185ce37f9bdd963).hasOwnProperty(surface)) return (0, $11472afca28cc3f2$export$2185ce37f9bdd963)[surface];
    if (colorProp === 'inherit') return undefined;
    if (!colorProp && hasTextAncestor) return undefined;
    return colorProp || 'color.text';
};
/**
 * __Text__
 *
 * Text is a primitive component that has the Atlassian Design System's design guidelines baked in.
 * This includes considerations for text attributes such as color, font size, font weight, and line height.
 * It renders a `span` by default.
 *
 * @internal
 */ var $c9e5a7a14e07f4e4$var$Text = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? 'span' : _ref$as, colorProp = _ref.color, align = _ref.align, testId = _ref.testId, id = _ref.id, _ref$size = _ref.size, size = _ref$size === void 0 ? 'medium' : _ref$size, weight = _ref.weight, maxLines = _ref.maxLines, children = _ref.children;
    (0, $afMOk.default)($c9e5a7a14e07f4e4$var$asAllowlist.includes(Component), "@atlaskit/primitives: Text received an invalid \"as\" value of \"".concat(Component, "\""));
    var hasTextAncestor = $c9e5a7a14e07f4e4$var$useHasTextAncestor();
    var color = $c9e5a7a14e07f4e4$var$useColor(colorProp, hasTextAncestor);
    var component = (0, $74Zh5.jsx)(Component, {
        ref: ref,
        css: [
            $c9e5a7a14e07f4e4$var$resetStyles,
            (0, $11472afca28cc3f2$export$128f10c238242f83)[size],
            color && (0, $11472afca28cc3f2$export$3a1bcba60b23d7f0)[color],
            maxLines && $c9e5a7a14e07f4e4$var$truncationStyles,
            maxLines === 1 && $c9e5a7a14e07f4e4$var$wordBreakMap.breakAll,
            align && $c9e5a7a14e07f4e4$var$textAlignMap[align],
            weight && (0, $11472afca28cc3f2$export$45f3f4fe16f9f7d5)[weight],
            Component === 'em' && $c9e5a7a14e07f4e4$var$emStyles,
            Component === 'strong' && $c9e5a7a14e07f4e4$var$strongStyles
        ],
        style: {
            WebkitLineClamp: maxLines
        },
        "data-testid": testId,
        id: id
    }, children);
    return hasTextAncestor ? // no need to re-apply context if the text is already wrapped
    component : (0, $74Zh5.jsx)($c9e5a7a14e07f4e4$var$HasTextAncestorContext.Provider, {
        value: true
    }, component);
});
var $c9e5a7a14e07f4e4$export$2e2bcd8739ae039 = $c9e5a7a14e07f4e4$var$Text;


var $fec45b36b8fde091$exports = {};
"use strict";
Object.defineProperty($fec45b36b8fde091$exports, "__esModule", {
    value: true
});
$fec45b36b8fde091$exports.default = void 0;

var $fec45b36b8fde091$var$_react = $fec45b36b8fde091$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $kqp0i = parcelRequire("kqp0i");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");

var $5Y2Mt = parcelRequire("5Y2Mt");

var $kqp0i = parcelRequire("kqp0i");

var $25nEq = parcelRequire("25nEq");

var $5FkrB = parcelRequire("5FkrB");

var $74Zh5 = parcelRequire("74Zh5");
var $90d264785f5b1735$export$c647cb0ee6e282fe = {
    small: '16px',
    medium: '24px',
    large: '32px',
    xlarge: '48px'
};
var $90d264785f5b1735$export$7bd66fc94c81bf84 = {
    small: 'small',
    medium: 'medium',
    large: 'large',
    xlarge: 'xlarge'
};
var $90d264785f5b1735$export$62ad7b0c781000e9 = {
    small: {
        width: $90d264785f5b1735$export$c647cb0ee6e282fe.small,
        height: $90d264785f5b1735$export$c647cb0ee6e282fe.small
    },
    medium: {
        width: $90d264785f5b1735$export$c647cb0ee6e282fe.medium,
        height: $90d264785f5b1735$export$c647cb0ee6e282fe.medium
    },
    large: {
        width: $90d264785f5b1735$export$c647cb0ee6e282fe.large,
        height: $90d264785f5b1735$export$c647cb0ee6e282fe.large
    },
    xlarge: {
        width: $90d264785f5b1735$export$c647cb0ee6e282fe.xlarge,
        height: $90d264785f5b1735$export$c647cb0ee6e282fe.xlarge
    }
};



var $74Zh5 = parcelRequire("74Zh5");
var $7b95aa0adab0444c$export$16374db1c3e6dfba = {
    overflow: 'hidden',
    pointerEvents: 'none',
    /**
   * Stop-color doesn't properly apply in chrome when the inherited/current color changes.
   * We have to initially set stop-color to inherit (either via DOM attribute or an initial CSS
   * rule) and then override it with currentColor for the color changes to be picked up.
   */ stop: {
        stopColor: 'currentColor'
    }
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
var $7b95aa0adab0444c$var$smallStyles = (0, $74Zh5.css)((0, $90d264785f5b1735$export$62ad7b0c781000e9).small);
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
var $7b95aa0adab0444c$var$mediumStyles = (0, $74Zh5.css)((0, $90d264785f5b1735$export$62ad7b0c781000e9).medium);
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
var $7b95aa0adab0444c$var$largeStyles = (0, $74Zh5.css)((0, $90d264785f5b1735$export$62ad7b0c781000e9).large);
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
var $7b95aa0adab0444c$var$xlargeStyles = (0, $74Zh5.css)((0, $90d264785f5b1735$export$62ad7b0c781000e9).xlarge);
var $7b95aa0adab0444c$export$ef0ad74202575b64 = {
    small: $7b95aa0adab0444c$var$smallStyles,
    medium: $7b95aa0adab0444c$var$mediumStyles,
    large: $7b95aa0adab0444c$var$largeStyles,
    xlarge: $7b95aa0adab0444c$var$xlargeStyles
};
var $7b95aa0adab0444c$export$3eb7d6130acfda37 = function getIconSize(_ref) {
    var width = _ref.width, height = _ref.height, size = _ref.size;
    if (width && height) return {
        width: width,
        height: height
    };
    if (size) return (0, $90d264785f5b1735$export$62ad7b0c781000e9)[size];
    return undefined;
};


var $7000d2c62822c4fb$export$18cb9425622d4e06 = function getBackground() {
    return "var(--ds-surface, #FFFFFF)";
};


function $228a50bc4e3498d7$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $228a50bc4e3498d7$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $228a50bc4e3498d7$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $228a50bc4e3498d7$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
/**
 * We are hiding these props from consumers as they're used to
 * hack around icon sizing specifically for icon-file-type.
 */ var $228a50bc4e3498d7$var$iconStyles = (0, $74Zh5.css)({
    display: 'inline-block',
    flexShrink: 0,
    lineHeight: 1,
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '> svg': $228a50bc4e3498d7$var$_objectSpread($228a50bc4e3498d7$var$_objectSpread({}, (0, $7b95aa0adab0444c$export$16374db1c3e6dfba)), {}, {
        maxWidth: '100%',
        maxHeight: '100%',
        color: 'var(--icon-primary-color)',
        fill: 'var(--icon-secondary-color)',
        verticalAlign: 'bottom'
    })
});
/**
 * For windows high contrast mode
 */ var $228a50bc4e3498d7$var$baseHcmStyles = (0, $74Zh5.css)({
    '@media screen and (forced-colors: active)': {
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '> svg': {
            filter: 'grayscale(1)',
            '--icon-primary-color': 'CanvasText',
            // foreground
            '--icon-secondary-color': 'Canvas' // background
        }
    }
});
var $228a50bc4e3498d7$var$primaryEqualsSecondaryHcmStyles = (0, $74Zh5.css)({
    '@media screen and (forced-colors: active)': {
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '> svg': {
            // if the primaryColor is the same as the secondaryColor we
            // set the --icon-primary-color to Canvas
            // this is usually to convey state i.e. Checkbox checked -> not checked
            '--icon-primary-color': 'Canvas' // foreground
        }
    }
});
var $228a50bc4e3498d7$var$secondaryTransparentHcmStyles = (0, $74Zh5.css)({
    '@media screen and (forced-colors: active)': {
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '> svg': {
            '--icon-secondary-color': 'transparent' // background
        }
    }
});
var $228a50bc4e3498d7$export$f04a61298a47a40f = /*#__PURE__*/ (0, $5FkrB.memo)(function Icon(props) {
    var _ref = props, Glyph = _ref.glyph, dangerouslySetGlyph = _ref.dangerouslySetGlyph, _ref$primaryColor = _ref.primaryColor, primaryColor = _ref$primaryColor === void 0 ? 'currentColor' : _ref$primaryColor, secondaryColor = _ref.secondaryColor, size = _ref.size, testId = _ref.testId, label = _ref.label, width = _ref.width, height = _ref.height, UNSAFE_margin = _ref.UNSAFE_margin;
    var glyphProps = dangerouslySetGlyph ? {
        dangerouslySetInnerHTML: {
            __html: dangerouslySetGlyph
        }
    } : {
        children: Glyph ? (0, $74Zh5.jsx)(Glyph, {
            role: "presentation"
        }) : null
    };
    var dimensions = (0, $7b95aa0adab0444c$export$3eb7d6130acfda37)({
        width: width,
        height: height,
        size: size
    });
    return (0, $74Zh5.jsx)("span", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        "data-testid": testId,
        "data-vc": "icon-".concat(testId),
        role: label ? 'img' : undefined,
        "aria-label": label ? label : undefined,
        "aria-hidden": label ? undefined : true,
        style: {
            '--icon-primary-color': primaryColor,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            '--icon-secondary-color': secondaryColor || (0, $7000d2c62822c4fb$export$18cb9425622d4e06)(),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            margin: UNSAFE_margin
        }
    }, glyphProps, {
        css: [
            $228a50bc4e3498d7$var$iconStyles,
            $228a50bc4e3498d7$var$baseHcmStyles,
            primaryColor === secondaryColor && $228a50bc4e3498d7$var$primaryEqualsSecondaryHcmStyles,
            secondaryColor === 'transparent' && $228a50bc4e3498d7$var$secondaryTransparentHcmStyles,
            // NB: This can be resolved if this component, composes base SVG / and/or skeleton
            // We could then simplify how common styles are dealt with simply by encapsulating them
            // at their appropriate level and/or having a singular approach to css variables in the package
            dimensions && // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $74Zh5.css)({
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                width: dimensions.width,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                height: dimensions.height,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                '> svg': dimensions
            })
        ]
    }));
});
var $228a50bc4e3498d7$export$2e2bcd8739ae039 = $228a50bc4e3498d7$export$f04a61298a47a40f;


var $49a9e186635900ef$var$_excluded = [
    "dangerouslySetGlyph"
];
var $49a9e186635900ef$var$sizeSpacingMap = {
    utility: {
        small: 'compact',
        medium: 'spacious'
    },
    core: {
        small: 'none',
        medium: 'spacious'
    }
};
var $49a9e186635900ef$export$3cfb73f70dfca966 = /*#__PURE__*/ (0, $5FkrB.memo)(function IconFacade(_ref) {
    var _props$size;
    var dangerouslySetGlyph = _ref.dangerouslySetGlyph, props = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $49a9e186635900ef$var$_excluded);
    var NewIcon = props.newIcon;
    // By default, the icon size will be medium for core icons and small for utility icons
    var size = (_props$size = props.size) !== null && _props$size !== void 0 ? _props$size : 'medium';
    var useNewIcon = !props.isFacadeDisabled && // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
    (0, $5Y2Mt.fg)('platform-visual-refresh-icons-legacy-facade');
    if (useNewIcon && NewIcon && (size === 'small' || size === 'medium')) {
        if (props.iconType === 'utility') {
            var Icon = NewIcon;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(Icon, (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, props, {
                spacing: (0, $5Y2Mt.fg)('platform-visual-refresh-icons-facade-button-fix') ? $49a9e186635900ef$var$sizeSpacingMap['utility'][size] : 'none',
                color: props.primaryColor || 'currentColor',
                type: props.iconType
            }));
        } else {
            var _Icon = NewIcon;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(_Icon, (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, props, {
                spacing: $49a9e186635900ef$var$sizeSpacingMap['core'][size],
                color: props.primaryColor || 'currentColor',
                type: props.iconType
            }));
        }
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $228a50bc4e3498d7$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        dangerouslySetGlyph: dangerouslySetGlyph
    }, props));
});
var $49a9e186635900ef$export$2e2bcd8739ae039 = $49a9e186635900ef$export$3cfb73f70dfca966;



var $fec45b36b8fde091$var$_close = $fec45b36b8fde091$var$_interopRequireDefault((parcelRequire("6eqzM")));
function $fec45b36b8fde091$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $fec45b36b8fde091$var$CrossIcon = (props)=>/*#__PURE__*/ $fec45b36b8fde091$var$_react.default.createElement($49a9e186635900ef$export$3cfb73f70dfca966, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M12 10.586 6.707 5.293a1 1 0 0 0-1.414 1.414L10.586 12l-5.293 5.293a1 1 0 0 0 1.414 1.414L12 13.414l5.293 5.293a1 1 0 0 0 1.414-1.414L13.414 12l5.293-5.293a1 1 0 1 0-1.414-1.414z"/></svg>`
    }, props, {
        newIcon: $fec45b36b8fde091$var$_close.default
    }));
$fec45b36b8fde091$var$CrossIcon.displayName = 'CrossIcon';
var $fec45b36b8fde091$var$_default = $fec45b36b8fde091$exports.default = $fec45b36b8fde091$var$CrossIcon;



var $aBp15 = parcelRequire("aBp15");
var $1595a2df2d5c9f61$exports = {};
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c9e42f0bd2701e924d060f406b40f887>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty($1595a2df2d5c9f61$exports, "__esModule", {
    value: true
});
$1595a2df2d5c9f61$exports.default = void 0;

var $1595a2df2d5c9f61$var$_react = $1595a2df2d5c9f61$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $1595a2df2d5c9f61$var$_UNSAFE_baseNew = $1595a2df2d5c9f61$var$_interopRequireDefault((parcelRequire("bPdWt")));
function $1595a2df2d5c9f61$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "AtlassianIntelligence".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for Atlassian Intelligence products or experiences.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $1595a2df2d5c9f61$var$AtlassianIntelligenceIcon = (props)=>/*#__PURE__*/ $1595a2df2d5c9f61$var$_react.default.createElement($1595a2df2d5c9f61$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-width="1.5" d="m2 2 4 4m8 8-4-4m4-8-4 4m-8 8 4-4m2-9v3m0 8v3m7-7h-3M4 8H1"/>`
    }, props));
$1595a2df2d5c9f61$var$AtlassianIntelligenceIcon.displayName = 'AtlassianIntelligenceIcon';
var $1595a2df2d5c9f61$var$_default = $1595a2df2d5c9f61$exports.default = $1595a2df2d5c9f61$var$AtlassianIntelligenceIcon;


var $5ec615fd02e164a6$exports = {};
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6db9feac5032e1f6cb5923640df1c100>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty($5ec615fd02e164a6$exports, "__esModule", {
    value: true
});
$5ec615fd02e164a6$exports.default = void 0;

var $5ec615fd02e164a6$var$_react = $5ec615fd02e164a6$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $5ec615fd02e164a6$var$_UNSAFE_baseNew = $5ec615fd02e164a6$var$_interopRequireDefault((parcelRequire("bPdWt")));
function $5ec615fd02e164a6$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Calendar".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: date metadata, date input field, calendar view, jira status.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $5ec615fd02e164a6$var$CalendarIcon = (props)=>/*#__PURE__*/ $5ec615fd02e164a6$var$_react.default.createElement($5ec615fd02e164a6$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-width="1.5" d="M1.75 6.75V13c0 .69.56 1.25 1.25 1.25h10c.69 0 1.25-.56 1.25-1.25V6.75m-12.5 0V3c0-.69.56-1.25 1.25-1.25h2.25m-3.5 5h12.5m0 0V3c0-.69-.56-1.25-1.25-1.25h-2.25m-5.5 0V0m0 1.75V4.5m0-2.75h5.5m0 0V0m0 1.75V4.5"/>`
    }, props));
$5ec615fd02e164a6$var$CalendarIcon.displayName = 'CalendarIcon';
var $5ec615fd02e164a6$var$_default = $5ec615fd02e164a6$exports.default = $5ec615fd02e164a6$var$CalendarIcon;


var $c76c9acbab193ca4$exports = {};
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::48d6c52e2f1120d34c1ed8048cf8da09>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty($c76c9acbab193ca4$exports, "__esModule", {
    value: true
});
$c76c9acbab193ca4$exports.default = void 0;

var $c76c9acbab193ca4$var$_react = $c76c9acbab193ca4$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $c76c9acbab193ca4$var$_UNSAFE_baseNew = $c76c9acbab193ca4$var$_interopRequireDefault((parcelRequire("bPdWt")));
function $c76c9acbab193ca4$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Compass".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: templates.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c76c9acbab193ca4$var$CompassIcon = (props)=>/*#__PURE__*/ $c76c9acbab193ca4$var$_react.default.createElement($c76c9acbab193ca4$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M8 15.25A7.25 7.25 0 1 0 8 .75a7.25 7.25 0 0 0 0 14.5Z"/><path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="m4.75 11.25 4.5-2-2.5-2.5z"/><path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="m11.25 4.75-4.5 2 2.5 2.5z"/>`
    }, props));
$c76c9acbab193ca4$var$CompassIcon.displayName = 'CompassIcon';
var $c76c9acbab193ca4$var$_default = $c76c9acbab193ca4$exports.default = $c76c9acbab193ca4$var$CompassIcon;



var $exnso = parcelRequire("exnso");
var $d670f5d7c7940d5f$exports = {};
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::79997d69990d173364910f60504b3516>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty($d670f5d7c7940d5f$exports, "__esModule", {
    value: true
});
$d670f5d7c7940d5f$exports.default = void 0;

var $d670f5d7c7940d5f$var$_react = $d670f5d7c7940d5f$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $d670f5d7c7940d5f$var$_UNSAFE_baseNew = $d670f5d7c7940d5f$var$_interopRequireDefault((parcelRequire("bPdWt")));
function $d670f5d7c7940d5f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "LinkExternal".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for links that open up a new tab.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $d670f5d7c7940d5f$var$LinkExternalIcon = (props)=>/*#__PURE__*/ $d670f5d7c7940d5f$var$_react.default.createElement($d670f5d7c7940d5f$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M6 1.75H3c-.69 0-1.25.56-1.25 1.25v10c0 .69.56 1.25 1.25 1.25h10c.69 0 1.25-.56 1.25-1.25v-3M7 9l6.75-6.75m.5 3.75V1.75H10"/>`
    }, props));
$d670f5d7c7940d5f$var$LinkExternalIcon.displayName = 'LinkExternalIcon';
var $d670f5d7c7940d5f$var$_default = $d670f5d7c7940d5f$exports.default = $d670f5d7c7940d5f$var$LinkExternalIcon;



var $ln0Ih = parcelRequire("ln0Ih");
var $742fae155a6bbd32$exports = {};
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::60edb8db9f6bfb3658759225f550b1d1>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty($742fae155a6bbd32$exports, "__esModule", {
    value: true
});
$742fae155a6bbd32$exports.default = void 0;

var $742fae155a6bbd32$var$_react = $742fae155a6bbd32$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $742fae155a6bbd32$var$_UNSAFE_baseNew = $742fae155a6bbd32$var$_interopRequireDefault((parcelRequire("bPdWt")));
function $742fae155a6bbd32$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Megaphone".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: feedback in products.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $742fae155a6bbd32$var$MegaphoneIcon = (props)=>/*#__PURE__*/ $742fae155a6bbd32$var$_react.default.createElement($742fae155a6bbd32$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M6.75 4.25H3c-.69 0-1.25.56-1.25 1.25v3.25C1.75 9.44 2.31 10 3 10h1.25m2.5-5.75 5.786-2.314a1.25 1.25 0 0 1 1.714 1.16v8.058a1.25 1.25 0 0 1-1.714 1.16L6.75 10m0-5.75V10m0 0h-2.5m2.5 0v4.25H5.5c-.69 0-1.25-.56-1.25-1.25v-3"/>`
    }, props));
$742fae155a6bbd32$var$MegaphoneIcon.displayName = 'MegaphoneIcon';
var $742fae155a6bbd32$var$_default = $742fae155a6bbd32$exports.default = $742fae155a6bbd32$var$MegaphoneIcon;


var $be2e2d4d6fde7b33$exports = {};
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::1c2c434ab24649808044e93163bd51c1>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty($be2e2d4d6fde7b33$exports, "__esModule", {
    value: true
});
$be2e2d4d6fde7b33$exports.default = void 0;

var $be2e2d4d6fde7b33$var$_react = $be2e2d4d6fde7b33$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $be2e2d4d6fde7b33$var$_UNSAFE_baseNew = $be2e2d4d6fde7b33$var$_interopRequireDefault((parcelRequire("bPdWt")));
function $be2e2d4d6fde7b33$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "PeopleGroup".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Known uses: representing a group or collection of people or users.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $be2e2d4d6fde7b33$var$PeopleGroupIcon = (props)=>/*#__PURE__*/ $be2e2d4d6fde7b33$var$_react.default.createElement($be2e2d4d6fde7b33$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M5 9.75H2.625C1.59 9.75.75 10.59.75 11.625V13m14.5 1v-1.5a2.75 2.75 0 0 0-2.75-2.75h-3a2.75 2.75 0 0 0-2.75 2.75V14m7-9.5a2.75 2.75 0 1 1-5.5 0 2.75 2.75 0 0 1 5.5 0Zm-8 1a1.75 1.75 0 1 1-3.5 0 1.75 1.75 0 0 1 3.5 0Z"/>`
    }, props));
$be2e2d4d6fde7b33$var$PeopleGroupIcon.displayName = 'PeopleGroupIcon';
var $be2e2d4d6fde7b33$var$_default = $be2e2d4d6fde7b33$exports.default = $be2e2d4d6fde7b33$var$PeopleGroupIcon;


var $d0d6b2a53e44f9e1$exports = {};
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::42f87835acc0152c23ae77c3bbeeba86>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty($d0d6b2a53e44f9e1$exports, "__esModule", {
    value: true
});
$d0d6b2a53e44f9e1$exports.default = void 0;

var $d0d6b2a53e44f9e1$var$_react = $d0d6b2a53e44f9e1$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $d0d6b2a53e44f9e1$var$_UNSAFE_baseNew = $d0d6b2a53e44f9e1$var$_interopRequireDefault((parcelRequire("bPdWt")));
function $d0d6b2a53e44f9e1$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Person".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Known uses: representing a person or user, owner, contributor.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $d0d6b2a53e44f9e1$var$PersonIcon = (props)=>/*#__PURE__*/ $d0d6b2a53e44f9e1$var$_react.default.createElement($d0d6b2a53e44f9e1$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M13.25 15v-2.25a3 3 0 0 0-3-3h-4.5a3 3 0 0 0-3 3V15m8.5-11a3.25 3.25 0 1 1-6.5 0 3.25 3.25 0 0 1 6.5 0Z"/>`
    }, props));
$d0d6b2a53e44f9e1$var$PersonIcon.displayName = 'PersonIcon';
var $d0d6b2a53e44f9e1$var$_default = $d0d6b2a53e44f9e1$exports.default = $d0d6b2a53e44f9e1$var$PersonIcon;


var $2a5cc7bed34af7d5$exports = {};
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2b1290bc5816db04bbec0542a218c285>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty($2a5cc7bed34af7d5$exports, "__esModule", {
    value: true
});
$2a5cc7bed34af7d5$exports.default = void 0;

var $2a5cc7bed34af7d5$var$_react = $2a5cc7bed34af7d5$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $2a5cc7bed34af7d5$var$_UNSAFE_baseNew = $2a5cc7bed34af7d5$var$_interopRequireDefault((parcelRequire("bPdWt")));
function $2a5cc7bed34af7d5$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Project".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for projects in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $2a5cc7bed34af7d5$var$ProjectIcon = (props)=>/*#__PURE__*/ $2a5cc7bed34af7d5$var$_react.default.createElement($2a5cc7bed34af7d5$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M1.25 10.25 3.5 8 1.25 5.75l.884-.884a1.25 1.25 0 0 1 .884-.366H7.25l2.384-2.384a1.25 1.25 0 0 1 .884-.366H13c.69 0 1.25.56 1.25 1.25v2.482c0 .332-.132.65-.366.884L11.5 8.75v4.232c0 .332-.132.65-.366.884l-.884.884L8 12.5l-2.25 2.25m-4.5 0 5-5"/><circle cx="11.375" cy="4.625" r="1.125" fill="currentcolor"/>`
    }, props));
$2a5cc7bed34af7d5$var$ProjectIcon.displayName = 'ProjectIcon';
var $2a5cc7bed34af7d5$var$_default = $2a5cc7bed34af7d5$exports.default = $2a5cc7bed34af7d5$var$ProjectIcon;


var $75ab11f9a6d4b351$exports = {};
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::21cc5e8a48fa1ff0264c5abb7df80aa6>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty($75ab11f9a6d4b351$exports, "__esModule", {
    value: true
});
$75ab11f9a6d4b351$exports.default = void 0;

var $75ab11f9a6d4b351$var$_react = $75ab11f9a6d4b351$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $75ab11f9a6d4b351$var$_UNSAFE_baseNew = $75ab11f9a6d4b351$var$_interopRequireDefault((parcelRequire("bPdWt")));
function $75ab11f9a6d4b351$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "SidebarCollapse".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for collapsing the navigation sidebar.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $75ab11f9a6d4b351$var$SidebarCollapseIcon = (props)=>/*#__PURE__*/ $75ab11f9a6d4b351$var$_react.default.createElement($75ab11f9a6d4b351$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M4.75 1.75H2C1.31 1.75.75 2.31.75 3v10c0 .69.56 1.25 1.25 1.25h2.75m0-12.5H14c.69 0 1.25.56 1.25 1.25v10c0 .69-.56 1.25-1.25 1.25H4.75m0-12.5v12.5M11 5.5 8.5 8l2.5 2.5"/>`
    }, props));
$75ab11f9a6d4b351$var$SidebarCollapseIcon.displayName = 'SidebarCollapseIcon';
var $75ab11f9a6d4b351$var$_default = $75ab11f9a6d4b351$exports.default = $75ab11f9a6d4b351$var$SidebarCollapseIcon;


var $e8ed8fa21860117a$exports = {};
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::67bd8e50f260741b99439472e94111fa>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty($e8ed8fa21860117a$exports, "__esModule", {
    value: true
});
$e8ed8fa21860117a$exports.default = void 0;

var $e8ed8fa21860117a$var$_react = $e8ed8fa21860117a$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $e8ed8fa21860117a$var$_UNSAFE_baseNew = $e8ed8fa21860117a$var$_interopRequireDefault((parcelRequire("bPdWt")));
function $e8ed8fa21860117a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "SidebarExpand".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for expanding the navigation sidebar.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $e8ed8fa21860117a$var$SidebarExpandIcon = (props)=>/*#__PURE__*/ $e8ed8fa21860117a$var$_react.default.createElement($e8ed8fa21860117a$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M11.25 1.75H14c.69 0 1.25.56 1.25 1.25v10c0 .69-.56 1.25-1.25 1.25h-2.75m0-12.5H2C1.31 1.75.75 2.31.75 3v10c0 .69.56 1.25 1.25 1.25h9.25m0-12.5v12.5M5 5.5 7.5 8 5 10.5"/>`
    }, props));
$e8ed8fa21860117a$var$SidebarExpandIcon.displayName = 'SidebarExpandIcon';
var $e8ed8fa21860117a$var$_default = $e8ed8fa21860117a$exports.default = $e8ed8fa21860117a$var$SidebarExpandIcon;


var $9bde3da3ddd3925b$exports = {};
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f4906a52ca50c71ce3e4b4da49e7ade3>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty($9bde3da3ddd3925b$exports, "__esModule", {
    value: true
});
$9bde3da3ddd3925b$exports.default = void 0;

var $9bde3da3ddd3925b$var$_react = $9bde3da3ddd3925b$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $9bde3da3ddd3925b$var$_UNSAFE_baseNew = $9bde3da3ddd3925b$var$_interopRequireDefault((parcelRequire("bPdWt")));
function $9bde3da3ddd3925b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "ThumbsDown".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: voting, feedback in AI.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $9bde3da3ddd3925b$var$ThumbsDownIcon = (props)=>/*#__PURE__*/ $9bde3da3ddd3925b$var$_react.default.createElement($9bde3da3ddd3925b$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M10.993 9.24c-1.586.69-3.176 2.118-3.176 4.234 0 1.057-4.202 1.586-2.086-3.702-1.058.475-4.98 1.747-4.98-.897 0-3.173-.25-6.346 3.98-6.346 2.453 0 4.06 0 6.036 1.267m0 0A1.25 1.25 0 0 1 12 2.75h2c.69 0 1.25.56 1.25 1.25v4.5c0 .69-.56 1.25-1.25 1.25h-2c-.69 0-1.25-.56-1.25-1.25V4q0-.105.017-.204Z"/>`
    }, props));
$9bde3da3ddd3925b$var$ThumbsDownIcon.displayName = 'ThumbsDownIcon';
var $9bde3da3ddd3925b$var$_default = $9bde3da3ddd3925b$exports.default = $9bde3da3ddd3925b$var$ThumbsDownIcon;


var $d613dcd7cfbb1e58$exports = {};
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::fc6198fed855ec7c0bf831f638e93e94>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty($d613dcd7cfbb1e58$exports, "__esModule", {
    value: true
});
$d613dcd7cfbb1e58$exports.default = void 0;

var $d613dcd7cfbb1e58$var$_react = $d613dcd7cfbb1e58$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $d613dcd7cfbb1e58$var$_UNSAFE_baseNew = $d613dcd7cfbb1e58$var$_interopRequireDefault((parcelRequire("bPdWt")));
function $d613dcd7cfbb1e58$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "ThumbsUp".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: voting options in Jira, like.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $d613dcd7cfbb1e58$var$ThumbsUpIcon = (props)=>/*#__PURE__*/ $d613dcd7cfbb1e58$var$_react.default.createElement($d613dcd7cfbb1e58$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M5.007 6.76c1.586-.69 3.176-2.117 3.176-4.233 0-1.057 4.202-1.586 2.086 3.702 1.058-.475 4.981-1.747 4.981.897 0 3.173-.25 6.346-4.48 6.346-2.454 0-3.561 0-5.537-1.267m0 0A1.25 1.25 0 0 1 4 13.251H2c-.69 0-1.25-.56-1.25-1.25v-4.5c0-.69.56-1.25 1.25-1.25h2c.69 0 1.25.56 1.25 1.25v4.5q0 .105-.017.204Z"/>`
    }, props));
$d613dcd7cfbb1e58$var$ThumbsUpIcon.displayName = 'ThumbsUpIcon';
var $d613dcd7cfbb1e58$var$_default = $d613dcd7cfbb1e58$exports.default = $d613dcd7cfbb1e58$var$ThumbsUpIcon;


var $1a8d9f6b66868ddc$exports = {};
"use strict";
Object.defineProperty($1a8d9f6b66868ddc$exports, "__esModule", {
    value: true
});
$1a8d9f6b66868ddc$exports.default = void 0;

var $1a8d9f6b66868ddc$var$_react = $1a8d9f6b66868ddc$var$_interopRequireDefault((parcelRequire("5FkrB")));


var $1a8d9f6b66868ddc$var$_add = $1a8d9f6b66868ddc$var$_interopRequireDefault((parcelRequire("jfDBU")));
function $1a8d9f6b66868ddc$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $1a8d9f6b66868ddc$var$AddIcon = (props)=>/*#__PURE__*/ $1a8d9f6b66868ddc$var$_react.default.createElement($49a9e186635900ef$export$3cfb73f70dfca966, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M13 11V3.993A.997.997 0 0 0 12 3c-.556 0-1 .445-1 .993V11H3.993A.997.997 0 0 0 3 12c0 .557.445 1 .993 1H11v7.007c0 .548.448.993 1 .993.556 0 1-.445 1-.993V13h7.007A.997.997 0 0 0 21 12c0-.556-.445-1-.993-1z"/></svg>`
    }, props, {
        newIcon: $1a8d9f6b66868ddc$var$_add.default
    }));
$1a8d9f6b66868ddc$var$AddIcon.displayName = 'AddIcon';
var $1a8d9f6b66868ddc$var$_default = $1a8d9f6b66868ddc$exports.default = $1a8d9f6b66868ddc$var$AddIcon;


var $98bc205bd71a8c29$exports = {};
"use strict";
Object.defineProperty($98bc205bd71a8c29$exports, "__esModule", {
    value: true
});
$98bc205bd71a8c29$exports.default = void 0;

var $98bc205bd71a8c29$var$_react = $98bc205bd71a8c29$var$_interopRequireDefault((parcelRequire("5FkrB")));


var $98bc205bd71a8c29$var$_add = $98bc205bd71a8c29$var$_interopRequireDefault((parcelRequire("jfDBU")));
function $98bc205bd71a8c29$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $98bc205bd71a8c29$var$AddCircleIcon = (props)=>/*#__PURE__*/ $98bc205bd71a8c29$var$_react.default.createElement($49a9e186635900ef$export$3cfb73f70dfca966, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><circle cx="12" cy="12" r="10" fill="currentcolor"/><path fill="inherit" d="M11.046 7.958v3.088H7.958a.954.954 0 1 0 0 1.908h3.088v3.088a.954.954 0 1 0 1.908 0v-3.088h3.088a.954.954 0 1 0 0-1.908h-3.088V7.958a.954.954 0 1 0-1.908 0"/></g></svg>`
    }, props, {
        newIcon: $98bc205bd71a8c29$var$_add.default
    }));
$98bc205bd71a8c29$var$AddCircleIcon.displayName = 'AddCircleIcon';
var $98bc205bd71a8c29$var$_default = $98bc205bd71a8c29$exports.default = $98bc205bd71a8c29$var$AddCircleIcon;


var $6d9883dd8b1794e3$exports = {};
"use strict";
Object.defineProperty($6d9883dd8b1794e3$exports, "__esModule", {
    value: true
});
$6d9883dd8b1794e3$exports.default = void 0;

var $6d9883dd8b1794e3$var$_react = $6d9883dd8b1794e3$var$_interopRequireDefault((parcelRequire("5FkrB")));


var $6d9883dd8b1794e3$var$_arrowLeft = $6d9883dd8b1794e3$var$_interopRequireDefault((parcelRequire("ldiUp")));
function $6d9883dd8b1794e3$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $6d9883dd8b1794e3$var$ArrowLeftCircleIcon = (props)=>/*#__PURE__*/ $6d9883dd8b1794e3$var$_react.default.createElement($49a9e186635900ef$export$3cfb73f70dfca966, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><circle cx="12" cy="12" r="10" fill="currentcolor"/><path fill="inherit" d="M16 10.995h-5.586l1.272-1.279a1.01 1.01 0 0 0 0-1.421.996.996 0 0 0-1.415 0l-2.978 2.994a1.01 1.01 0 0 0 0 1.423l2.978 2.993a1 1 0 0 0 1.415 0 1.01 1.01 0 0 0 0-1.421l-1.272-1.279H16c.552 0 1-.45 1-1.005s-.448-1.005-1-1.005"/></svg>`
    }, props, {
        newIcon: $6d9883dd8b1794e3$var$_arrowLeft.default
    }));
$6d9883dd8b1794e3$var$ArrowLeftCircleIcon.displayName = 'ArrowLeftCircleIcon';
var $6d9883dd8b1794e3$var$_default = $6d9883dd8b1794e3$exports.default = $6d9883dd8b1794e3$var$ArrowLeftCircleIcon;


var $c98a967905aaff91$exports = {};
"use strict";
Object.defineProperty($c98a967905aaff91$exports, "__esModule", {
    value: true
});
$c98a967905aaff91$exports.default = void 0;

var $c98a967905aaff91$var$_react = $c98a967905aaff91$var$_interopRequireDefault((parcelRequire("5FkrB")));


var $c98a967905aaff91$var$_arrowRight = $c98a967905aaff91$var$_interopRequireDefault((parcelRequire("5GKWl")));
function $c98a967905aaff91$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $c98a967905aaff91$var$ArrowRightIcon = (props)=>/*#__PURE__*/ $c98a967905aaff91$var$_react.default.createElement($49a9e186635900ef$export$3cfb73f70dfca966, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M11.793 5.793a1 1 0 0 0 0 1.414L15.586 11H6a1 1 0 0 0 0 2h9.586l-3.793 3.793a1 1 0 0 0 0 1.414c.39.39 1.024.39 1.415 0l5.499-5.5a1 1 0 0 0 .293-.679v-.057a1 1 0 0 0-.293-.678l-5.499-5.5a1 1 0 0 0-1.415 0"/></svg>`
    }, props, {
        newIcon: $c98a967905aaff91$var$_arrowRight.default
    }));
$c98a967905aaff91$var$ArrowRightIcon.displayName = 'ArrowRightIcon';
var $c98a967905aaff91$var$_default = $c98a967905aaff91$exports.default = $c98a967905aaff91$var$ArrowRightIcon;


var $7ef4b2cc5f25a288$exports = {};
"use strict";
Object.defineProperty($7ef4b2cc5f25a288$exports, "__esModule", {
    value: true
});
$7ef4b2cc5f25a288$exports.default = void 0;

var $7ef4b2cc5f25a288$var$_react = $7ef4b2cc5f25a288$var$_interopRequireDefault((parcelRequire("5FkrB")));


var $7ef4b2cc5f25a288$var$_arrowRight = $7ef4b2cc5f25a288$var$_interopRequireDefault((parcelRequire("5GKWl")));
function $7ef4b2cc5f25a288$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $7ef4b2cc5f25a288$var$ArrowRightCircleIcon = (props)=>/*#__PURE__*/ $7ef4b2cc5f25a288$var$_react.default.createElement($49a9e186635900ef$export$3cfb73f70dfca966, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><circle cx="12" cy="12" r="10" fill="currentcolor" fill-rule="nonzero"/><path fill="inherit" d="M12.314 8.294a1.01 1.01 0 0 0 0 1.422l1.271 1.279H8c-.553 0-1.001.45-1.001 1.005S7.447 13.005 8 13.005h5.585l-1.271 1.279a1.01 1.01 0 0 0 0 1.422 1 1 0 0 0 1.415 0l2.978-2.995a1.01 1.01 0 0 0 0-1.422l-2.978-2.995a1 1 0 0 0-1.415 0"/></g></svg>`
    }, props, {
        newIcon: $7ef4b2cc5f25a288$var$_arrowRight.default
    }));
$7ef4b2cc5f25a288$var$ArrowRightCircleIcon.displayName = 'ArrowRightCircleIcon';
var $7ef4b2cc5f25a288$var$_default = $7ef4b2cc5f25a288$exports.default = $7ef4b2cc5f25a288$var$ArrowRightCircleIcon;


var $9cd1998a3c9cfc99$exports = {};
"use strict";
Object.defineProperty($9cd1998a3c9cfc99$exports, "__esModule", {
    value: true
});
$9cd1998a3c9cfc99$exports.default = void 0;

var $9cd1998a3c9cfc99$var$_react = $9cd1998a3c9cfc99$var$_interopRequireDefault((parcelRequire("5FkrB")));


var $9cd1998a3c9cfc99$var$_arrowUp = $9cd1998a3c9cfc99$var$_interopRequireDefault((parcelRequire("5mlBi")));
function $9cd1998a3c9cfc99$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $9cd1998a3c9cfc99$var$ArrowUpIcon = (props)=>/*#__PURE__*/ $9cd1998a3c9cfc99$var$_react.default.createElement($49a9e186635900ef$export$3cfb73f70dfca966, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m11.293 5.293-5.5 5.499a1 1 0 0 0 0 1.415 1 1 0 0 0 1.414 0L11 8.414V18a1 1 0 0 0 2 0V8.414l3.793 3.793a1 1 0 1 0 1.414-1.415l-5.5-5.499A1 1 0 0 0 12 5a1 1 0 0 0-.707.293"/></svg>`
    }, props, {
        newIcon: $9cd1998a3c9cfc99$var$_arrowUp.default
    }));
$9cd1998a3c9cfc99$var$ArrowUpIcon.displayName = 'ArrowUpIcon';
var $9cd1998a3c9cfc99$var$_default = $9cd1998a3c9cfc99$exports.default = $9cd1998a3c9cfc99$var$ArrowUpIcon;


var $e48f677aac887358$exports = {};
"use strict";
Object.defineProperty($e48f677aac887358$exports, "__esModule", {
    value: true
});
$e48f677aac887358$exports.default = void 0;

var $e48f677aac887358$var$_react = $e48f677aac887358$var$_interopRequireDefault((parcelRequire("5FkrB")));


var $e48f677aac887358$var$_arrowUp = $e48f677aac887358$var$_interopRequireDefault((parcelRequire("5mlBi")));
function $e48f677aac887358$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $e48f677aac887358$var$ArrowUpCircleIcon = (props)=>/*#__PURE__*/ $e48f677aac887358$var$_react.default.createElement($49a9e186635900ef$export$3cfb73f70dfca966, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><circle cx="12" cy="12" r="10" fill="currentcolor" fill-rule="nonzero"/><path fill="inherit" d="M11.288 7.293 8.294 10.27a1 1 0 0 0 0 1.416 1.01 1.01 0 0 0 1.421 0l1.279-1.272V16c0 .552.451 1 1.006 1s1.005-.448 1.005-1v-5.586l1.279 1.272a1.01 1.01 0 0 0 1.421 0 1 1 0 0 0 0-1.416l-2.994-2.977a1.01 1.01 0 0 0-1.423 0"/></g></svg>`
    }, props, {
        newIcon: $e48f677aac887358$var$_arrowUp.default
    }));
$e48f677aac887358$var$ArrowUpCircleIcon.displayName = 'ArrowUpCircleIcon';
var $e48f677aac887358$var$_default = $e48f677aac887358$exports.default = $e48f677aac887358$var$ArrowUpCircleIcon;


var $8e55f27140ce88eb$exports = {};
"use strict";
Object.defineProperty($8e55f27140ce88eb$exports, "__esModule", {
    value: true
});
$8e55f27140ce88eb$exports.default = void 0;

var $8e55f27140ce88eb$var$_react = $8e55f27140ce88eb$var$_interopRequireDefault((parcelRequire("5FkrB")));

function $8e55f27140ce88eb$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $8e55f27140ce88eb$var$BitbucketBuildsIcon = (props)=>/*#__PURE__*/ $8e55f27140ce88eb$var$_react.default.createElement($49a9e186635900ef$export$3cfb73f70dfca966, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor"><path d="M10 5a1 1 0 0 0 1 1h3.01a1 1 0 0 0 0-2H11c-.55 0-1 .45-1 1M8 5c0-1.66 1.35-3 3-3h3.01a3 3 0 0 1 0 6H11a3 3 0 0 1-3-3m2 7a1 1 0 0 0 1 1h3.01a1 1 0 0 0 0-2H11c-.55 0-1 .45-1 1m-2 0c0-1.66 1.35-3 3-3h3.01a3 3 0 0 1 0 6H11a3 3 0 0 1-3-3m2 7a1 1 0 0 0 1 1h3.01a1 1 0 0 0 0-2H11c-.55 0-1 .45-1 1m-2 0c0-1.66 1.35-3 3-3h3.01a3 3 0 0 1 0 6H11a3 3 0 0 1-3-3"/><path d="M16.06 6h2.42c.81 0 1.47.66 1.47 1.47v1.95c0 .82-.65 1.47-1.47 1.47H16v2h2.47a3.47 3.47 0 0 0 3.48-3.47V7.47A3.47 3.47 0 0 0 18.48 4h-2.41zm-7.17 5H6.47A3.47 3.47 0 0 0 3 14.47v1.95c0 1.92 1.55 3.47 3.47 3.47h2.48v-2H6.47c-.82 0-1.47-.65-1.47-1.47v-1.95c0-.81.66-1.47 1.47-1.47h2.42z"/></g></svg>`
    }, props));
$8e55f27140ce88eb$var$BitbucketBuildsIcon.displayName = 'BitbucketBuildsIcon';
var $8e55f27140ce88eb$var$_default = $8e55f27140ce88eb$exports.default = $8e55f27140ce88eb$var$BitbucketBuildsIcon;


var $873ac5cd1764ee99$exports = {};
"use strict";
Object.defineProperty($873ac5cd1764ee99$exports, "__esModule", {
    value: true
});
$873ac5cd1764ee99$exports.default = void 0;

var $873ac5cd1764ee99$var$_react = $873ac5cd1764ee99$var$_interopRequireDefault((parcelRequire("5FkrB")));


var $873ac5cd1764ee99$var$_checkMark = $873ac5cd1764ee99$var$_interopRequireDefault((parcelRequire("bE62y")));
function $873ac5cd1764ee99$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $873ac5cd1764ee99$var$CheckIcon = (props)=>/*#__PURE__*/ $873ac5cd1764ee99$var$_react.default.createElement($49a9e186635900ef$export$3cfb73f70dfca966, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M6.735 12.322a1 1 0 0 0-1.47 1.356l3.612 3.919c.537.526 1.337.526 1.834.03l.364-.359a2336 2336 0 0 0 3.939-3.883l.04-.04a493 493 0 0 0 3.658-3.643 1 1 0 0 0-1.424-1.404 518 518 0 0 1-3.64 3.625l-.04.04a2049 2049 0 0 1-3.775 3.722z"/></svg>`
    }, props, {
        newIcon: $873ac5cd1764ee99$var$_checkMark.default
    }));
$873ac5cd1764ee99$var$CheckIcon.displayName = 'CheckIcon';
var $873ac5cd1764ee99$var$_default = $873ac5cd1764ee99$exports.default = $873ac5cd1764ee99$var$CheckIcon;


var $d5a84db960eef864$exports = {};
"use strict";
Object.defineProperty($d5a84db960eef864$exports, "__esModule", {
    value: true
});
$d5a84db960eef864$exports.default = void 0;

var $d5a84db960eef864$var$_react = $d5a84db960eef864$var$_interopRequireDefault((parcelRequire("5FkrB")));


var $d5a84db960eef864$var$_success = $d5a84db960eef864$var$_interopRequireDefault((parcelRequire("4AP9B")));
function $d5a84db960eef864$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $d5a84db960eef864$var$CheckCircleIcon = (props)=>/*#__PURE__*/ $d5a84db960eef864$var$_react.default.createElement($49a9e186635900ef$export$3cfb73f70dfca966, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><circle cx="12" cy="12" r="10" fill="currentcolor"/><path fill="inherit" d="M9.707 11.293a1 1 0 1 0-1.414 1.414l2 2a1 1 0 0 0 1.414 0l4-4a1 1 0 1 0-1.414-1.414L11 12.586z"/></g></svg>`
    }, props, {
        newIcon: $d5a84db960eef864$var$_success.default
    }));
$d5a84db960eef864$var$CheckCircleIcon.displayName = 'CheckCircleIcon';
var $d5a84db960eef864$var$_default = $d5a84db960eef864$exports.default = $d5a84db960eef864$var$CheckCircleIcon;


var $ade8daf0e7d9a0c6$exports = {};
"use strict";
Object.defineProperty($ade8daf0e7d9a0c6$exports, "__esModule", {
    value: true
});
$ade8daf0e7d9a0c6$exports.default = void 0;

var $ade8daf0e7d9a0c6$var$_react = $ade8daf0e7d9a0c6$var$_interopRequireDefault((parcelRequire("5FkrB")));


var $ade8daf0e7d9a0c6$var$_checkCircle = $ade8daf0e7d9a0c6$var$_interopRequireDefault((parcelRequire("eC7kC")));
function $ade8daf0e7d9a0c6$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $ade8daf0e7d9a0c6$var$CheckCircleOutlineIcon = (props)=>/*#__PURE__*/ $ade8daf0e7d9a0c6$var$_react.default.createElement($49a9e186635900ef$export$3cfb73f70dfca966, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path fill-rule="nonzero" d="M12 20a8 8 0 1 0 0-16 8 8 0 0 0 0 16m0 2C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10"/><path d="M9.707 11.293a1 1 0 1 0-1.414 1.414l2 2a1 1 0 0 0 1.414 0l4-4a1 1 0 1 0-1.414-1.414L11 12.586z"/></g></svg>`
    }, props, {
        newIcon: $ade8daf0e7d9a0c6$var$_checkCircle.default
    }));
$ade8daf0e7d9a0c6$var$CheckCircleOutlineIcon.displayName = 'CheckCircleOutlineIcon';
var $ade8daf0e7d9a0c6$var$_default = $ade8daf0e7d9a0c6$exports.default = $ade8daf0e7d9a0c6$var$CheckCircleOutlineIcon;


var $9486f8503a3e67e2$exports = {};
"use strict";
Object.defineProperty($9486f8503a3e67e2$exports, "__esModule", {
    value: true
});
$9486f8503a3e67e2$exports.default = void 0;

var $9486f8503a3e67e2$var$_react = $9486f8503a3e67e2$var$_interopRequireDefault((parcelRequire("5FkrB")));


var $9486f8503a3e67e2$var$_chevronDown = $9486f8503a3e67e2$var$_interopRequireDefault((parcelRequire("5Y5FQ")));
function $9486f8503a3e67e2$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $9486f8503a3e67e2$var$ChevronDownIcon = (props)=>/*#__PURE__*/ $9486f8503a3e67e2$var$_react.default.createElement($49a9e186635900ef$export$3cfb73f70dfca966, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M8.292 10.293a1.01 1.01 0 0 0 0 1.419l2.939 2.965c.218.215.5.322.779.322s.556-.107.769-.322l2.93-2.955a1.01 1.01 0 0 0 0-1.419.987.987 0 0 0-1.406 0l-2.298 2.317-2.307-2.327a.99.99 0 0 0-1.406 0"/></svg>`
    }, props, {
        newIcon: $9486f8503a3e67e2$var$_chevronDown.default,
        iconType: "utility"
    }));
$9486f8503a3e67e2$var$ChevronDownIcon.displayName = 'ChevronDownIcon';
var $9486f8503a3e67e2$var$_default = $9486f8503a3e67e2$exports.default = $9486f8503a3e67e2$var$ChevronDownIcon;


var $e572ec8845a02646$exports = {};
"use strict";
Object.defineProperty($e572ec8845a02646$exports, "__esModule", {
    value: true
});
$e572ec8845a02646$exports.default = void 0;

var $e572ec8845a02646$var$_react = $e572ec8845a02646$var$_interopRequireDefault((parcelRequire("5FkrB")));


var $e572ec8845a02646$var$_chevronDown = $e572ec8845a02646$var$_interopRequireDefault((parcelRequire("5Y5FQ")));
function $e572ec8845a02646$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $e572ec8845a02646$var$ChevronDownCircleIcon = (props)=>/*#__PURE__*/ $e572ec8845a02646$var$_react.default.createElement($49a9e186635900ef$export$3cfb73f70dfca966, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><circle cx="12" cy="12" r="10" fill="currentcolor"/><path fill="inherit" d="M8.292 10.293a1.01 1.01 0 0 0 0 1.419l2.939 2.965c.218.215.5.322.779.322s.556-.107.769-.322l2.93-2.955a1.01 1.01 0 0 0 0-1.419.987.987 0 0 0-1.406 0l-2.298 2.317-2.307-2.327a.99.99 0 0 0-1.406 0"/></g></svg>`
    }, props, {
        newIcon: $e572ec8845a02646$var$_chevronDown.default,
        iconType: "utility"
    }));
$e572ec8845a02646$var$ChevronDownCircleIcon.displayName = 'ChevronDownCircleIcon';
var $e572ec8845a02646$var$_default = $e572ec8845a02646$exports.default = $e572ec8845a02646$var$ChevronDownCircleIcon;


var $385bb13f555ba5b8$exports = {};
"use strict";
Object.defineProperty($385bb13f555ba5b8$exports, "__esModule", {
    value: true
});
$385bb13f555ba5b8$exports.default = void 0;

var $385bb13f555ba5b8$var$_react = $385bb13f555ba5b8$var$_interopRequireDefault((parcelRequire("5FkrB")));


var $385bb13f555ba5b8$var$_chevronLeft = $385bb13f555ba5b8$var$_interopRequireDefault((parcelRequire("447N2")));
function $385bb13f555ba5b8$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $385bb13f555ba5b8$var$ChevronLeftIcon = (props)=>/*#__PURE__*/ $385bb13f555ba5b8$var$_react.default.createElement($49a9e186635900ef$export$3cfb73f70dfca966, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M13.706 9.698a.99.99 0 0 0 0-1.407 1.01 1.01 0 0 0-1.419 0l-2.965 2.94a1.09 1.09 0 0 0 0 1.548l2.955 2.93a1.01 1.01 0 0 0 1.42 0 .99.99 0 0 0 0-1.407l-2.318-2.297z"/></svg>`
    }, props, {
        newIcon: $385bb13f555ba5b8$var$_chevronLeft.default,
        iconType: "utility"
    }));
$385bb13f555ba5b8$var$ChevronLeftIcon.displayName = 'ChevronLeftIcon';
var $385bb13f555ba5b8$var$_default = $385bb13f555ba5b8$exports.default = $385bb13f555ba5b8$var$ChevronLeftIcon;


var $464fbc8de2c8545a$exports = {};
"use strict";
Object.defineProperty($464fbc8de2c8545a$exports, "__esModule", {
    value: true
});
$464fbc8de2c8545a$exports.default = void 0;

var $464fbc8de2c8545a$var$_react = $464fbc8de2c8545a$var$_interopRequireDefault((parcelRequire("5FkrB")));


var $464fbc8de2c8545a$var$_chevronLeft = $464fbc8de2c8545a$var$_interopRequireDefault((parcelRequire("447N2")));
function $464fbc8de2c8545a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $464fbc8de2c8545a$var$ChevronLeftLargeIcon = (props)=>/*#__PURE__*/ $464fbc8de2c8545a$var$_react.default.createElement($49a9e186635900ef$export$3cfb73f70dfca966, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m9.005 10.995 4.593-4.593a.99.99 0 1 1 1.4 1.4l-3.9 3.9 3.9 3.9a.99.99 0 0 1-1.4 1.4L9.005 12.41a1 1 0 0 1 0-1.414"/></svg>`
    }, props, {
        newIcon: $464fbc8de2c8545a$var$_chevronLeft.default,
        iconType: "utility"
    }));
$464fbc8de2c8545a$var$ChevronLeftLargeIcon.displayName = 'ChevronLeftLargeIcon';
var $464fbc8de2c8545a$var$_default = $464fbc8de2c8545a$exports.default = $464fbc8de2c8545a$var$ChevronLeftLargeIcon;


var $dffd612a245a9817$exports = {};
"use strict";
Object.defineProperty($dffd612a245a9817$exports, "__esModule", {
    value: true
});
$dffd612a245a9817$exports.default = void 0;

var $dffd612a245a9817$var$_react = $dffd612a245a9817$var$_interopRequireDefault((parcelRequire("5FkrB")));


var $dffd612a245a9817$var$_chevronRight = $dffd612a245a9817$var$_interopRequireDefault((parcelRequire("jiU5J")));
function $dffd612a245a9817$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $dffd612a245a9817$var$ChevronRightIcon = (props)=>/*#__PURE__*/ $dffd612a245a9817$var$_react.default.createElement($49a9e186635900ef$export$3cfb73f70dfca966, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M10.294 9.698a.99.99 0 0 1 0-1.407 1.01 1.01 0 0 1 1.419 0l2.965 2.94a1.09 1.09 0 0 1 0 1.548l-2.955 2.93a1.01 1.01 0 0 1-1.42 0 .99.99 0 0 1 0-1.407l2.318-2.297z"/></svg>`
    }, props, {
        newIcon: $dffd612a245a9817$var$_chevronRight.default,
        iconType: "utility"
    }));
$dffd612a245a9817$var$ChevronRightIcon.displayName = 'ChevronRightIcon';
var $dffd612a245a9817$var$_default = $dffd612a245a9817$exports.default = $dffd612a245a9817$var$ChevronRightIcon;


var $30203922e34ab8aa$exports = {};
"use strict";
Object.defineProperty($30203922e34ab8aa$exports, "__esModule", {
    value: true
});
$30203922e34ab8aa$exports.default = void 0;

var $30203922e34ab8aa$var$_react = $30203922e34ab8aa$var$_interopRequireDefault((parcelRequire("5FkrB")));


var $30203922e34ab8aa$var$_chevronUp = $30203922e34ab8aa$var$_interopRequireDefault((parcelRequire("cS1ic")));
function $30203922e34ab8aa$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $30203922e34ab8aa$var$ChevronUpIcon = (props)=>/*#__PURE__*/ $30203922e34ab8aa$var$_react.default.createElement($49a9e186635900ef$export$3cfb73f70dfca966, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m11.221 9.322-2.929 2.955a1.01 1.01 0 0 0 0 1.419.986.986 0 0 0 1.405 0l2.298-2.317 2.307 2.327a.99.99 0 0 0 1.407 0 1.01 1.01 0 0 0 0-1.419l-2.94-2.965A1.1 1.1 0 0 0 11.991 9c-.279 0-.557.107-.77.322"/></svg>`
    }, props, {
        newIcon: $30203922e34ab8aa$var$_chevronUp.default,
        iconType: "utility"
    }));
$30203922e34ab8aa$var$ChevronUpIcon.displayName = 'ChevronUpIcon';
var $30203922e34ab8aa$var$_default = $30203922e34ab8aa$exports.default = $30203922e34ab8aa$var$ChevronUpIcon;


var $590d7c6a980c3249$exports = {};
"use strict";
Object.defineProperty($590d7c6a980c3249$exports, "__esModule", {
    value: true
});
$590d7c6a980c3249$exports.default = void 0;

var $590d7c6a980c3249$var$_react = $590d7c6a980c3249$var$_interopRequireDefault((parcelRequire("5FkrB")));


var $590d7c6a980c3249$var$_copy = $590d7c6a980c3249$var$_interopRequireDefault((parcelRequire("gxkfx")));
function $590d7c6a980c3249$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $590d7c6a980c3249$var$CopyIcon = (props)=>/*#__PURE__*/ $590d7c6a980c3249$var$_react.default.createElement($49a9e186635900ef$export$3cfb73f70dfca966, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor"><path d="M10 19h8V8h-8zM8 7.992C8 6.892 8.902 6 10.009 6h7.982C19.101 6 20 6.893 20 7.992v11.016c0 1.1-.902 1.992-2.009 1.992H10.01A2 2 0 0 1 8 19.008z"/><path d="M5 16V4.992C5 3.892 5.902 3 7.009 3H15v13zm2 0h8V5H7z"/></g></svg>`
    }, props, {
        newIcon: $590d7c6a980c3249$var$_copy.default
    }));
$590d7c6a980c3249$var$CopyIcon.displayName = 'CopyIcon';
var $590d7c6a980c3249$var$_default = $590d7c6a980c3249$exports.default = $590d7c6a980c3249$var$CopyIcon;


var $be4a353bf96cd982$exports = {};
"use strict";
Object.defineProperty($be4a353bf96cd982$exports, "__esModule", {
    value: true
});
$be4a353bf96cd982$exports.default = void 0;

var $be4a353bf96cd982$var$_react = $be4a353bf96cd982$var$_interopRequireDefault((parcelRequire("5FkrB")));


var $be4a353bf96cd982$var$_download = $be4a353bf96cd982$var$_interopRequireDefault((parcelRequire("exnso")));
function $be4a353bf96cd982$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $be4a353bf96cd982$var$DownloadIcon = (props)=>/*#__PURE__*/ $be4a353bf96cd982$var$_react.default.createElement($49a9e186635900ef$export$3cfb73f70dfca966, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path fill-rule="nonzero" d="M10.687 17.292a.983.983 0 0 0-1.397 0 1 1 0 0 0 0 1.407l1.964 1.98a1.08 1.08 0 0 0 1.538 0l1.919-1.933a1 1 0 0 0 0-1.408.983.983 0 0 0-1.398 0l-1.29 1.3z"/><path fill-rule="nonzero" d="M13.001 19.993 13 10.006C13 9.451 12.552 9 12 9s-1 .45-1 1.007l.001 9.987c0 .555.448 1.006 1 1.006s1-.45 1-1.007"/><path d="M7.938 5.48a5 5 0 0 0-.777-.062C4.356 5.418 2 7.62 2 10.498 2 13.409 4.385 16 7.1 16h2.881v-1.993H7.1c-1.657 0-3.115-1.663-3.115-3.508 0-1.778 1.469-3.087 3.104-3.087h.012c.389 0 .686.05.97.15l.17.063c.605.248.875-.246.875-.246l.15-.267c.73-1.347 2.201-2.096 3.716-2.12a4.14 4.14 0 0 1 4.069 3.645l.046.34s.071.525.665.525c.013 0 .012.005.023.005h.254c1.136 0 1.976.959 1.976 2.158 0 1.207-.987 2.342-2.07 2.342h-3.964V16h3.964C20.105 16 22 13.955 22 11.665c0-2-1.312-3.663-3.138-4.074-.707-2.707-3.053-4.552-5.886-4.591-1.975.02-3.901.9-5.038 2.48"/></g></svg>`
    }, props, {
        newIcon: $be4a353bf96cd982$var$_download.default
    }));
$be4a353bf96cd982$var$DownloadIcon.displayName = 'DownloadIcon';
var $be4a353bf96cd982$var$_default = $be4a353bf96cd982$exports.default = $be4a353bf96cd982$var$DownloadIcon;


var $8710dfec56d91aa3$exports = {};
"use strict";
Object.defineProperty($8710dfec56d91aa3$exports, "__esModule", {
    value: true
});
$8710dfec56d91aa3$exports.default = void 0;

var $8710dfec56d91aa3$var$_react = $8710dfec56d91aa3$var$_interopRequireDefault((parcelRequire("5FkrB")));


var $8710dfec56d91aa3$var$_edit = $8710dfec56d91aa3$var$_interopRequireDefault((parcelRequire("dI7Bp")));
function $8710dfec56d91aa3$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $8710dfec56d91aa3$var$EditIcon = (props)=>/*#__PURE__*/ $8710dfec56d91aa3$var$_react.default.createElement($49a9e186635900ef$export$3cfb73f70dfca966, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M4.02 19.23a1 1 0 0 0 1.18 1.18l3.81-.78-4.21-4.21zm5.92-2.62-2.12-2.12L16.31 6l2.12 2.12zm9.9-9.9-2.12-2.12A2 2 0 0 0 16.31 4c-.51 0-1.02.2-1.41.59l-9.76 9.76 4.95 4.95 9.76-9.76a2 2 0 0 0 0-2.83"/></svg>`
    }, props, {
        newIcon: $8710dfec56d91aa3$var$_edit.default
    }));
$8710dfec56d91aa3$var$EditIcon.displayName = 'EditIcon';
var $8710dfec56d91aa3$var$_default = $8710dfec56d91aa3$exports.default = $8710dfec56d91aa3$var$EditIcon;


var $d565c3bdf418c732$exports = {};
"use strict";
Object.defineProperty($d565c3bdf418c732$exports, "__esModule", {
    value: true
});
$d565c3bdf418c732$exports.default = void 0;

var $d565c3bdf418c732$var$_react = $d565c3bdf418c732$var$_interopRequireDefault((parcelRequire("5FkrB")));


var $d565c3bdf418c732$var$_edit = $d565c3bdf418c732$var$_interopRequireDefault((parcelRequire("dI7Bp")));
function $d565c3bdf418c732$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $d565c3bdf418c732$var$EditFilledIcon = (props)=>/*#__PURE__*/ $d565c3bdf418c732$var$_react.default.createElement($49a9e186635900ef$export$3cfb73f70dfca966, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M4.02 19.23a1 1 0 0 0 1.18 1.18l3.81-.78-4.21-4.21zM19.84 6.71l-2.12-2.12A2 2 0 0 0 16.31 4c-.51 0-1.02.2-1.41.59l-9.76 9.76 4.95 4.95 9.76-9.76a2 2 0 0 0 0-2.83"/></svg>`
    }, props, {
        newIcon: $d565c3bdf418c732$var$_edit.default
    }));
$d565c3bdf418c732$var$EditFilledIcon.displayName = 'EditFilledIcon';
var $d565c3bdf418c732$var$_default = $d565c3bdf418c732$exports.default = $d565c3bdf418c732$var$EditFilledIcon;


var $79f04fcc1fc38f5b$exports = {};
"use strict";
Object.defineProperty($79f04fcc1fc38f5b$exports, "__esModule", {
    value: true
});
$79f04fcc1fc38f5b$exports.default = void 0;

var $79f04fcc1fc38f5b$var$_react = $79f04fcc1fc38f5b$var$_interopRequireDefault((parcelRequire("5FkrB")));


var $79f04fcc1fc38f5b$var$_close = $79f04fcc1fc38f5b$var$_interopRequireDefault((parcelRequire("6eqzM")));
function $79f04fcc1fc38f5b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $79f04fcc1fc38f5b$var$EditorCloseIcon = (props)=>/*#__PURE__*/ $79f04fcc1fc38f5b$var$_react.default.createElement($49a9e186635900ef$export$3cfb73f70dfca966, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m15.185 7.4-3.184 3.185-3.186-3.186a.507.507 0 0 0-.712.003l-.7.701a.496.496 0 0 0-.004.712l3.185 3.184L7.4 15.185a.507.507 0 0 0 .004.712l.7.7c.206.207.516.2.712.004l3.186-3.185 3.184 3.185a.507.507 0 0 0 .712-.004l.701-.7a.496.496 0 0 0 .003-.712l-3.186-3.186 3.186-3.184a.507.507 0 0 0-.003-.712l-.7-.7a.5.5 0 0 0-.36-.153.5.5 0 0 0-.353.15"/></svg>`
    }, props, {
        newIcon: $79f04fcc1fc38f5b$var$_close.default
    }));
$79f04fcc1fc38f5b$var$EditorCloseIcon.displayName = 'EditorCloseIcon';
var $79f04fcc1fc38f5b$var$_default = $79f04fcc1fc38f5b$exports.default = $79f04fcc1fc38f5b$var$EditorCloseIcon;


var $34e5d1c6c1f4125d$exports = {};
"use strict";
Object.defineProperty($34e5d1c6c1f4125d$exports, "__esModule", {
    value: true
});
$34e5d1c6c1f4125d$exports.default = void 0;

var $34e5d1c6c1f4125d$var$_react = $34e5d1c6c1f4125d$var$_interopRequireDefault((parcelRequire("5FkrB")));


var $34e5d1c6c1f4125d$var$_contentWrapRight = $34e5d1c6c1f4125d$var$_interopRequireDefault((parcelRequire("b37du")));
function $34e5d1c6c1f4125d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $34e5d1c6c1f4125d$var$EditorMediaWrapRightIcon = (props)=>/*#__PURE__*/ $34e5d1c6c1f4125d$var$_react.default.createElement($49a9e186635900ef$export$3cfb73f70dfca966, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M6 17h12a1 1 0 0 1 0 2H6a1 1 0 0 1 0-2m0-8h4a1 1 0 0 1 0 2H6a1 1 0 0 1 0-2m0 4h4a1 1 0 0 1 0 2H6a1 1 0 0 1 0-2m8-4h4a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1h-4a1 1 0 0 1-1-1v-4a1 1 0 0 1 1-1M6 5h12a1 1 0 0 1 0 2H6a1 1 0 1 1 0-2"/></svg>`
    }, props, {
        newIcon: $34e5d1c6c1f4125d$var$_contentWrapRight.default
    }));
$34e5d1c6c1f4125d$var$EditorMediaWrapRightIcon.displayName = 'EditorMediaWrapRightIcon';
var $34e5d1c6c1f4125d$var$_default = $34e5d1c6c1f4125d$exports.default = $34e5d1c6c1f4125d$var$EditorMediaWrapRightIcon;


var $3f5daf0b07171f08$exports = {};
"use strict";
Object.defineProperty($3f5daf0b07171f08$exports, "__esModule", {
    value: true
});
$3f5daf0b07171f08$exports.default = void 0;

var $3f5daf0b07171f08$var$_react = $3f5daf0b07171f08$var$_interopRequireDefault((parcelRequire("5FkrB")));


var $3f5daf0b07171f08$var$_arrowUpRight = $3f5daf0b07171f08$var$_interopRequireDefault((parcelRequire("aBp15")));
function $3f5daf0b07171f08$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $3f5daf0b07171f08$var$EditorOpenIcon = (props)=>/*#__PURE__*/ $3f5daf0b07171f08$var$_react.default.createElement($49a9e186635900ef$export$3cfb73f70dfca966, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M9.873 7.63c-.28 0-.344.159-.147.357l2.436 2.436-4.386 4.386a.51.51 0 0 0 0 .713l.7.7a.495.495 0 0 0 .713.001l4.387-4.386 2.436 2.436c.197.197.357.124.357-.147V8.133a.507.507 0 0 0-.503-.503z"/></svg>`
    }, props, {
        newIcon: $3f5daf0b07171f08$var$_arrowUpRight.default
    }));
$3f5daf0b07171f08$var$EditorOpenIcon.displayName = 'EditorOpenIcon';
var $3f5daf0b07171f08$var$_default = $3f5daf0b07171f08$exports.default = $3f5daf0b07171f08$var$EditorOpenIcon;


var $533ab672e6b1443b$exports = {};
"use strict";
Object.defineProperty($533ab672e6b1443b$exports, "__esModule", {
    value: true
});
$533ab672e6b1443b$exports.default = void 0;

var $533ab672e6b1443b$var$_react = $533ab672e6b1443b$var$_interopRequireDefault((parcelRequire("5FkrB")));


var $533ab672e6b1443b$var$_information = $533ab672e6b1443b$var$_interopRequireDefault((parcelRequire("93YpG")));
function $533ab672e6b1443b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $533ab672e6b1443b$var$EditorPanelIcon = (props)=>/*#__PURE__*/ $533ab672e6b1443b$var$_react.default.createElement($49a9e186635900ef$export$3cfb73f70dfca966, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M12 19a7 7 0 1 1 0-14 7 7 0 0 1 0 14m0-1.5a5.5 5.5 0 1 0 0-11 5.5 5.5 0 0 0 0 11m0-6a1 1 0 0 1 1 1v2a1 1 0 0 1-2 0v-2a1 1 0 0 1 1-1m0-3a1 1 0 1 1 0 2 1 1 0 0 1 0-2"/></svg>`
    }, props, {
        newIcon: $533ab672e6b1443b$var$_information.default
    }));
$533ab672e6b1443b$var$EditorPanelIcon.displayName = 'EditorPanelIcon';
var $533ab672e6b1443b$var$_default = $533ab672e6b1443b$exports.default = $533ab672e6b1443b$var$EditorPanelIcon;


var $3ac3f969cbb47b8f$exports = {};
"use strict";
Object.defineProperty($3ac3f969cbb47b8f$exports, "__esModule", {
    value: true
});
$3ac3f969cbb47b8f$exports.default = void 0;

var $3ac3f969cbb47b8f$var$_react = $3ac3f969cbb47b8f$var$_interopRequireDefault((parcelRequire("5FkrB")));


var $3ac3f969cbb47b8f$var$_grid = $3ac3f969cbb47b8f$var$_interopRequireDefault((parcelRequire("bWJYo")));
function $3ac3f969cbb47b8f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $3ac3f969cbb47b8f$var$EditorTableIcon = (props)=>/*#__PURE__*/ $3ac3f969cbb47b8f$var$_react.default.createElement($49a9e186635900ef$export$3cfb73f70dfca966, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M8 6h8a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2m0 2v3h3V8zm5 0v3h3V8zm-5 5v3h3v-3zm5 0v3h3v-3z"/></svg>`
    }, props, {
        newIcon: $3ac3f969cbb47b8f$var$_grid.default
    }));
$3ac3f969cbb47b8f$var$EditorTableIcon.displayName = 'EditorTableIcon';
var $3ac3f969cbb47b8f$var$_default = $3ac3f969cbb47b8f$exports.default = $3ac3f969cbb47b8f$var$EditorTableIcon;


var $207a5ee071608021$exports = {};
"use strict";
Object.defineProperty($207a5ee071608021$exports, "__esModule", {
    value: true
});
$207a5ee071608021$exports.default = void 0;

var $207a5ee071608021$var$_react = $207a5ee071608021$var$_interopRequireDefault((parcelRequire("5FkrB")));

function $207a5ee071608021$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $207a5ee071608021$var$EmojiAtlassianIcon = (props)=>/*#__PURE__*/ $207a5ee071608021$var$_react.default.createElement($49a9e186635900ef$export$3cfb73f70dfca966, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M8.7 11.48c-.24-.25-.61-.24-.77.09l-3.88 7.76a.46.46 0 0 0 .42.67h5.41a.45.45 0 0 0 .42-.26c1.17-2.41.46-6.08-1.59-8.27m2.84-7.06c-2.17 3.44-2.03 7.26-.6 10.12l2.61 5.22c.08.16.24.26.42.26h5.41a.46.46 0 0 0 .42-.67S12.53 4.77 12.35 4.41c-.17-.32-.58-.33-.79 0"/></svg>`
    }, props));
$207a5ee071608021$var$EmojiAtlassianIcon.displayName = 'EmojiAtlassianIcon';
var $207a5ee071608021$var$_default = $207a5ee071608021$exports.default = $207a5ee071608021$var$EmojiAtlassianIcon;


var $2bb56a67b3ef2d16$exports = {};
"use strict";
Object.defineProperty($2bb56a67b3ef2d16$exports, "__esModule", {
    value: true
});
$2bb56a67b3ef2d16$exports.default = void 0;

var $2bb56a67b3ef2d16$var$_react = $2bb56a67b3ef2d16$var$_interopRequireDefault((parcelRequire("5FkrB")));


var $2bb56a67b3ef2d16$var$_clock = $2bb56a67b3ef2d16$var$_interopRequireDefault((parcelRequire("cJnPm")));
function $2bb56a67b3ef2d16$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $2bb56a67b3ef2d16$var$EmojiFrequentIcon = (props)=>/*#__PURE__*/ $2bb56a67b3ef2d16$var$_react.default.createElement($49a9e186635900ef$export$3cfb73f70dfca966, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M12 4c-4.412 0-8 3.588-8 8s3.588 8 8 8 8-3.588 8-8-3.588-8-8-8m0 14.222A6.23 6.23 0 0 1 5.778 12 6.23 6.23 0 0 1 12 5.778 6.23 6.23 0 0 1 18.222 12 6.23 6.23 0 0 1 12 18.222m.889-6.59V8.448c0-.489-.4-.889-.889-.889s-.889.4-.889.89v3.555c0 .248.103.471.268.633l2.195 2.194a.89.89 0 0 0 1.257 0 .89.89 0 0 0 0-1.256z"/></svg>`
    }, props, {
        newIcon: $2bb56a67b3ef2d16$var$_clock.default
    }));
$2bb56a67b3ef2d16$var$EmojiFrequentIcon.displayName = 'EmojiFrequentIcon';
var $2bb56a67b3ef2d16$var$_default = $2bb56a67b3ef2d16$exports.default = $2bb56a67b3ef2d16$var$EmojiFrequentIcon;


var $88999ebaf76df20a$exports = {};
"use strict";
Object.defineProperty($88999ebaf76df20a$exports, "__esModule", {
    value: true
});
$88999ebaf76df20a$exports.default = void 0;

var $88999ebaf76df20a$var$_react = $88999ebaf76df20a$var$_interopRequireDefault((parcelRequire("5FkrB")));


var $88999ebaf76df20a$var$_heart = $88999ebaf76df20a$var$_interopRequireDefault((parcelRequire("czNKk")));
function $88999ebaf76df20a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $88999ebaf76df20a$var$EmojiSymbolsIcon = (props)=>/*#__PURE__*/ $88999ebaf76df20a$var$_react.default.createElement($49a9e186635900ef$export$3cfb73f70dfca966, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m12 9.44 1.76-1.744a2.505 2.505 0 0 1 3.52 0 2.45 2.45 0 0 1 0 3.488L12 16.417l-5.28-5.232a2.45 2.45 0 0 1 0-3.49 2.505 2.505 0 0 1 3.52 0v.001zm-6.684 3.143.003.004 6.322 6.266a.51.51 0 0 0 .718 0l6.322-6.266.003-.004.004-.003a4.41 4.41 0 0 0 0-6.28 4.51 4.51 0 0 0-6.336 0l-.003.004-.004.003L12 6.65l-.345-.342-.004-.003-.003-.003a4.51 4.51 0 0 0-6.336 0 4.41 4.41 0 0 0 0 6.279z"/></svg>`
    }, props, {
        newIcon: $88999ebaf76df20a$var$_heart.default
    }));
$88999ebaf76df20a$var$EmojiSymbolsIcon.displayName = 'EmojiSymbolsIcon';
var $88999ebaf76df20a$var$_default = $88999ebaf76df20a$exports.default = $88999ebaf76df20a$var$EmojiSymbolsIcon;


var $ff31d8fb1771b8a0$exports = {};
"use strict";
Object.defineProperty($ff31d8fb1771b8a0$exports, "__esModule", {
    value: true
});
$ff31d8fb1771b8a0$exports.default = void 0;

var $ff31d8fb1771b8a0$var$_react = $ff31d8fb1771b8a0$var$_interopRequireDefault((parcelRequire("5FkrB")));


var $ff31d8fb1771b8a0$var$_error = $ff31d8fb1771b8a0$var$_interopRequireDefault((parcelRequire("4YUxz")));
function $ff31d8fb1771b8a0$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $ff31d8fb1771b8a0$var$ErrorIcon = (props)=>/*#__PURE__*/ $ff31d8fb1771b8a0$var$_react.default.createElement($49a9e186635900ef$export$3cfb73f70dfca966, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><path fill="currentcolor" d="M13.416 4.417a2 2 0 0 0-2.832 0l-6.168 6.167a2 2 0 0 0 0 2.833l6.168 6.167a2 2 0 0 0 2.832 0l6.168-6.167a2 2 0 0 0 0-2.833z"/><path fill="inherit" d="M12 14a1 1 0 0 1-1-1V8a1 1 0 0 1 2 0v5a1 1 0 0 1-1 1m0 3a1 1 0 0 1 0-2 1 1 0 0 1 0 2"/></g></svg>`
    }, props, {
        newIcon: $ff31d8fb1771b8a0$var$_error.default
    }));
$ff31d8fb1771b8a0$var$ErrorIcon.displayName = 'ErrorIcon';
var $ff31d8fb1771b8a0$var$_default = $ff31d8fb1771b8a0$exports.default = $ff31d8fb1771b8a0$var$ErrorIcon;


var $34d04bfb84685d13$exports = {};
"use strict";
Object.defineProperty($34d04bfb84685d13$exports, "__esModule", {
    value: true
});
$34d04bfb84685d13$exports.default = void 0;

var $34d04bfb84685d13$var$_react = $34d04bfb84685d13$var$_interopRequireDefault((parcelRequire("5FkrB")));


var $34d04bfb84685d13$var$_upload = $34d04bfb84685d13$var$_interopRequireDefault((parcelRequire("ie0cB")));
function $34d04bfb84685d13$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $34d04bfb84685d13$var$ExportIcon = (props)=>/*#__PURE__*/ $34d04bfb84685d13$var$_react.default.createElement($49a9e186635900ef$export$3cfb73f70dfca966, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M13 6.491V16a1 1 0 0 1-2 0V6.491L9.784 7.697a1.05 1.05 0 0 1-1.478 0 1.03 1.03 0 0 1 0-1.465l2.955-2.929a1.05 1.05 0 0 1 1.478 0l2.955 2.93c.408.404.408 1.06 0 1.464a1.05 1.05 0 0 1-1.478 0zM9 9v2H7c-.002 0 0 7.991 0 7.991 0 .004 9.994.009 9.994.009.003 0 .006-7.991.006-7.991 0-.006-2-.009-2-.009V9h2c1.105 0 2 .902 2 2.009v7.982c0 1.11-.897 2.009-2.006 2.009H7.006A2.01 2.01 0 0 1 5 18.991V11.01A2 2 0 0 1 7 9z"/></svg>`
    }, props, {
        newIcon: $34d04bfb84685d13$var$_upload.default
    }));
$34d04bfb84685d13$var$ExportIcon.displayName = 'ExportIcon';
var $34d04bfb84685d13$var$_default = $34d04bfb84685d13$exports.default = $34d04bfb84685d13$var$ExportIcon;


var $fb968510c42de8af$exports = {};
"use strict";
Object.defineProperty($fb968510c42de8af$exports, "__esModule", {
    value: true
});
$fb968510c42de8af$exports.default = void 0;

var $fb968510c42de8af$var$_react = $fb968510c42de8af$var$_interopRequireDefault((parcelRequire("5FkrB")));


var $fb968510c42de8af$var$_filter = $fb968510c42de8af$var$_interopRequireDefault((parcelRequire("86XB8")));
function $fb968510c42de8af$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $fb968510c42de8af$var$FilterIcon = (props)=>/*#__PURE__*/ $fb968510c42de8af$var$_react.default.createElement($49a9e186635900ef$export$3cfb73f70dfca966, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M7 13h10l1-2H6zM3.99 6c-.55 0-.79.41-.55.9L4 8h16l.55-1.1c.25-.5.01-.9-.54-.9zm6.79 11.56a.87.87 0 0 0 .73.44h.99c.28 0 .61-.2.73-.44L14 16h-4z"/></svg>`
    }, props, {
        newIcon: $fb968510c42de8af$var$_filter.default
    }));
$fb968510c42de8af$var$FilterIcon.displayName = 'FilterIcon';
var $fb968510c42de8af$var$_default = $fb968510c42de8af$exports.default = $fb968510c42de8af$var$FilterIcon;


var $5d26562b02511d06$exports = {};
"use strict";
Object.defineProperty($5d26562b02511d06$exports, "__esModule", {
    value: true
});
$5d26562b02511d06$exports.default = void 0;

var $5d26562b02511d06$var$_react = $5d26562b02511d06$var$_interopRequireDefault((parcelRequire("5FkrB")));


var $5d26562b02511d06$var$_chevronDown = $5d26562b02511d06$var$_interopRequireDefault((parcelRequire("5Y5FQ")));
function $5d26562b02511d06$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $5d26562b02511d06$var$HipchatChevronDownIcon = (props)=>/*#__PURE__*/ $5d26562b02511d06$var$_react.default.createElement($49a9e186635900ef$export$3cfb73f70dfca966, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M6.744 8.744a1.053 1.053 0 0 0 0 1.49l4.547 4.557a1 1 0 0 0 1.416 0l4.55-4.558a1.051 1.051 0 1 0-1.488-1.488l-3.77 3.776-3.768-3.776a1.05 1.05 0 0 0-1.487 0"/></svg>`
    }, props, {
        newIcon: $5d26562b02511d06$var$_chevronDown.default,
        iconType: "utility"
    }));
$5d26562b02511d06$var$HipchatChevronDownIcon.displayName = 'HipchatChevronDownIcon';
var $5d26562b02511d06$var$_default = $5d26562b02511d06$exports.default = $5d26562b02511d06$var$HipchatChevronDownIcon;


var $56277a34572e0602$exports = {};
"use strict";
Object.defineProperty($56277a34572e0602$exports, "__esModule", {
    value: true
});
$56277a34572e0602$exports.default = void 0;

var $56277a34572e0602$var$_react = $56277a34572e0602$var$_interopRequireDefault((parcelRequire("5FkrB")));


var $56277a34572e0602$var$_chevronUp = $56277a34572e0602$var$_interopRequireDefault((parcelRequire("cS1ic")));
function $56277a34572e0602$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $56277a34572e0602$var$HipchatChevronUpIcon = (props)=>/*#__PURE__*/ $56277a34572e0602$var$_react.default.createElement($49a9e186635900ef$export$3cfb73f70dfca966, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m11.294 8.708-4.549 4.559a1.051 1.051 0 1 0 1.486 1.488l.001-.001 3.77-3.776 3.768 3.776a1.05 1.05 0 0 0 1.486.001h.001a1.054 1.054 0 0 0 .001-1.489L12.71 8.708a1 1 0 0 0-1.415-.001"/></svg>`
    }, props, {
        newIcon: $56277a34572e0602$var$_chevronUp.default,
        iconType: "utility"
    }));
$56277a34572e0602$var$HipchatChevronUpIcon.displayName = 'HipchatChevronUpIcon';
var $56277a34572e0602$var$_default = $56277a34572e0602$exports.default = $56277a34572e0602$var$HipchatChevronUpIcon;


var $a68fb0b0d8dbf79c$exports = {};
"use strict";
Object.defineProperty($a68fb0b0d8dbf79c$exports, "__esModule", {
    value: true
});
$a68fb0b0d8dbf79c$exports.default = void 0;

var $a68fb0b0d8dbf79c$var$_react = $a68fb0b0d8dbf79c$var$_interopRequireDefault((parcelRequire("5FkrB")));


var $a68fb0b0d8dbf79c$var$_image = $a68fb0b0d8dbf79c$var$_interopRequireDefault((parcelRequire("kmK71")));
function $a68fb0b0d8dbf79c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $a68fb0b0d8dbf79c$var$ImageIcon = (props)=>/*#__PURE__*/ $a68fb0b0d8dbf79c$var$_react.default.createElement($49a9e186635900ef$export$3cfb73f70dfca966, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M3 4.995C3 3.893 3.893 3 4.995 3h14.01C20.107 3 21 3.893 21 4.995v14.01A1.995 1.995 0 0 1 19.005 21H4.995A1.995 1.995 0 0 1 3 19.005zM10.5 16.5 9 15l-3 3h12v-2.7L15 12zM8 10a2 2 0 1 0 0-4 2 2 0 0 0 0 4"/></svg>`
    }, props, {
        newIcon: $a68fb0b0d8dbf79c$var$_image.default
    }));
$a68fb0b0d8dbf79c$var$ImageIcon.displayName = 'ImageIcon';
var $a68fb0b0d8dbf79c$var$_default = $a68fb0b0d8dbf79c$exports.default = $a68fb0b0d8dbf79c$var$ImageIcon;


var $03d4c1818fb39364$exports = {};
"use strict";
Object.defineProperty($03d4c1818fb39364$exports, "__esModule", {
    value: true
});
$03d4c1818fb39364$exports.default = void 0;

var $03d4c1818fb39364$var$_react = $03d4c1818fb39364$var$_interopRequireDefault((parcelRequire("5FkrB")));


var $03d4c1818fb39364$var$_information = $03d4c1818fb39364$var$_interopRequireDefault((parcelRequire("93YpG")));
function $03d4c1818fb39364$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $03d4c1818fb39364$var$InfoIcon = (props)=>/*#__PURE__*/ $03d4c1818fb39364$var$_react.default.createElement($49a9e186635900ef$export$3cfb73f70dfca966, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><path fill="currentcolor" d="M2 12c0 5.523 4.477 10 10 10s10-4.477 10-10S17.523 2 12 2 2 6.477 2 12"/><rect width="2" height="7" x="11" y="10" fill="inherit" rx="1"/><circle cx="12" cy="8" r="1" fill="inherit"/></g></svg>`
    }, props, {
        newIcon: $03d4c1818fb39364$var$_information.default
    }));
$03d4c1818fb39364$var$InfoIcon.displayName = 'InfoIcon';
var $03d4c1818fb39364$var$_default = $03d4c1818fb39364$exports.default = $03d4c1818fb39364$var$InfoIcon;


var $0be4bc1b8cb1f6f1$exports = {};
"use strict";
Object.defineProperty($0be4bc1b8cb1f6f1$exports, "__esModule", {
    value: true
});
$0be4bc1b8cb1f6f1$exports.default = void 0;

var $0be4bc1b8cb1f6f1$var$_react = $0be4bc1b8cb1f6f1$var$_interopRequireDefault((parcelRequire("5FkrB")));


var $0be4bc1b8cb1f6f1$var$_link = $0be4bc1b8cb1f6f1$var$_interopRequireDefault((parcelRequire("bgEmk")));
function $0be4bc1b8cb1f6f1$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $0be4bc1b8cb1f6f1$var$LinkIcon = (props)=>/*#__PURE__*/ $0be4bc1b8cb1f6f1$var$_react.default.createElement($49a9e186635900ef$export$3cfb73f70dfca966, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path d="m12.856 5.457-.937.92a1 1 0 0 0 0 1.437 1.047 1.047 0 0 0 1.463 0l.984-.966c.967-.95 2.542-1.135 3.602-.288a2.54 2.54 0 0 1 .203 3.81l-2.903 2.852a2.646 2.646 0 0 1-3.696 0l-1.11-1.09L9 13.57l1.108 1.089c1.822 1.788 4.802 1.788 6.622 0l2.905-2.852a4.558 4.558 0 0 0-.357-6.82c-1.893-1.517-4.695-1.226-6.422.47"/><path d="m11.144 19.543.937-.92a1 1 0 0 0 0-1.437 1.047 1.047 0 0 0-1.462 0l-.985.966c-.967.95-2.542 1.135-3.602.288a2.54 2.54 0 0 1-.203-3.81l2.903-2.852a2.646 2.646 0 0 1 3.696 0l1.11 1.09L15 11.43l-1.108-1.089c-1.822-1.788-4.802-1.788-6.622 0l-2.905 2.852a4.558 4.558 0 0 0 .357 6.82c1.893 1.517 4.695 1.226 6.422-.47"/></g></svg>`
    }, props, {
        newIcon: $0be4bc1b8cb1f6f1$var$_link.default
    }));
$0be4bc1b8cb1f6f1$var$LinkIcon.displayName = 'LinkIcon';
var $0be4bc1b8cb1f6f1$var$_default = $0be4bc1b8cb1f6f1$exports.default = $0be4bc1b8cb1f6f1$var$LinkIcon;


var $0035a91c863e72cf$exports = {};
"use strict";
Object.defineProperty($0035a91c863e72cf$exports, "__esModule", {
    value: true
});
$0035a91c863e72cf$exports.default = void 0;

var $0035a91c863e72cf$var$_react = $0035a91c863e72cf$var$_interopRequireDefault((parcelRequire("5FkrB")));


var $0035a91c863e72cf$var$_location = $0035a91c863e72cf$var$_interopRequireDefault((parcelRequire("ln0Ih")));
function $0035a91c863e72cf$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $0035a91c863e72cf$var$LocationIcon = (props)=>/*#__PURE__*/ $0035a91c863e72cf$var$_react.default.createElement($49a9e186635900ef$export$3cfb73f70dfca966, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M12 21c-2.28 0-6-8.686-6-12a6 6 0 1 1 12 0c0 3.314-3.72 12-6 12m0-9a2.912 2.912 0 1 0 0-5.824A2.912 2.912 0 0 0 12 12"/></svg>`
    }, props, {
        newIcon: $0035a91c863e72cf$var$_location.default
    }));
$0035a91c863e72cf$var$LocationIcon.displayName = 'LocationIcon';
var $0035a91c863e72cf$var$_default = $0035a91c863e72cf$exports.default = $0035a91c863e72cf$var$LocationIcon;


var $1fb024143896ae8b$exports = {};
"use strict";
Object.defineProperty($1fb024143896ae8b$exports, "__esModule", {
    value: true
});
$1fb024143896ae8b$exports.default = void 0;

var $1fb024143896ae8b$var$_react = $1fb024143896ae8b$var$_interopRequireDefault((parcelRequire("5FkrB")));


var $1fb024143896ae8b$var$_zoomIn = $1fb024143896ae8b$var$_interopRequireDefault((parcelRequire("4cYNL")));
function $1fb024143896ae8b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $1fb024143896ae8b$var$MediaServicesZoomInIcon = (props)=>/*#__PURE__*/ $1fb024143896ae8b$var$_react.default.createElement($49a9e186635900ef$export$3cfb73f70dfca966, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m16.436 15.085 3.94 4.01a1 1 0 0 1-1.425 1.402l-3.938-4.006a7.5 7.5 0 1 1 1.423-1.406M13.5 11.5a1 1 0 0 0 0-2h-2v-2a1 1 0 0 0-2 0v2h-2a1 1 0 0 0 0 2h2v2a1 1 0 0 0 2 0v-2z"/></svg>`
    }, props, {
        newIcon: $1fb024143896ae8b$var$_zoomIn.default
    }));
$1fb024143896ae8b$var$MediaServicesZoomInIcon.displayName = 'MediaServicesZoomInIcon';
var $1fb024143896ae8b$var$_default = $1fb024143896ae8b$exports.default = $1fb024143896ae8b$var$MediaServicesZoomInIcon;


var $f84ee0cde97a62c2$exports = {};
"use strict";
Object.defineProperty($f84ee0cde97a62c2$exports, "__esModule", {
    value: true
});
$f84ee0cde97a62c2$exports.default = void 0;

var $f84ee0cde97a62c2$var$_react = $f84ee0cde97a62c2$var$_interopRequireDefault((parcelRequire("5FkrB")));


var $f84ee0cde97a62c2$var$_zoomOut = $f84ee0cde97a62c2$var$_interopRequireDefault((parcelRequire("zmEJd")));
function $f84ee0cde97a62c2$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $f84ee0cde97a62c2$var$MediaServicesZoomOutIcon = (props)=>/*#__PURE__*/ $f84ee0cde97a62c2$var$_react.default.createElement($49a9e186635900ef$export$3cfb73f70dfca966, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m16.436 15.085 3.94 4.01a1 1 0 0 1-1.425 1.402l-3.938-4.006a7.5 7.5 0 1 1 1.423-1.406M13.5 11.5h-6a1 1 0 0 1 0-2h6a1 1 0 0 1 0 2"/></svg>`
    }, props, {
        newIcon: $f84ee0cde97a62c2$var$_zoomOut.default
    }));
$f84ee0cde97a62c2$var$MediaServicesZoomOutIcon.displayName = 'MediaServicesZoomOutIcon';
var $f84ee0cde97a62c2$var$_default = $f84ee0cde97a62c2$exports.default = $f84ee0cde97a62c2$var$MediaServicesZoomOutIcon;


var $3388360884a36db4$exports = {};
"use strict";
Object.defineProperty($3388360884a36db4$exports, "__esModule", {
    value: true
});
$3388360884a36db4$exports.default = void 0;

var $3388360884a36db4$var$_react = $3388360884a36db4$var$_interopRequireDefault((parcelRequire("5FkrB")));


var $3388360884a36db4$var$_menu = $3388360884a36db4$var$_interopRequireDefault((parcelRequire("3sJq9")));
function $3388360884a36db4$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $3388360884a36db4$var$MenuIcon = (props)=>/*#__PURE__*/ $3388360884a36db4$var$_react.default.createElement($49a9e186635900ef$export$3cfb73f70dfca966, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M5 15h14v2H5zm0-8h14v2H5zm0 4h14v2H5z"/></svg>`
    }, props, {
        newIcon: $3388360884a36db4$var$_menu.default
    }));
$3388360884a36db4$var$MenuIcon.displayName = 'MenuIcon';
var $3388360884a36db4$var$_default = $3388360884a36db4$exports.default = $3388360884a36db4$var$MenuIcon;


var $89ede3cf48e6c473$exports = {};
"use strict";
Object.defineProperty($89ede3cf48e6c473$exports, "__esModule", {
    value: true
});
$89ede3cf48e6c473$exports.default = void 0;

var $89ede3cf48e6c473$var$_react = $89ede3cf48e6c473$var$_interopRequireDefault((parcelRequire("5FkrB")));


var $89ede3cf48e6c473$var$_showMoreVertical = $89ede3cf48e6c473$var$_interopRequireDefault((parcelRequire("iQYaZ")));
function $89ede3cf48e6c473$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $89ede3cf48e6c473$var$MoreVerticalIcon = (props)=>/*#__PURE__*/ $89ede3cf48e6c473$var$_react.default.createElement($49a9e186635900ef$export$3cfb73f70dfca966, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><circle cx="12" cy="19" r="2"/><circle cx="12" cy="12" r="2"/><circle cx="12" cy="5" r="2"/></g></svg>`
    }, props, {
        newIcon: $89ede3cf48e6c473$var$_showMoreVertical.default
    }));
$89ede3cf48e6c473$var$MoreVerticalIcon.displayName = 'MoreVerticalIcon';
var $89ede3cf48e6c473$var$_default = $89ede3cf48e6c473$exports.default = $89ede3cf48e6c473$var$MoreVerticalIcon;


var $c7b70d3a2f678352$exports = {};
"use strict";
Object.defineProperty($c7b70d3a2f678352$exports, "__esModule", {
    value: true
});
$c7b70d3a2f678352$exports.default = void 0;

var $c7b70d3a2f678352$var$_react = $c7b70d3a2f678352$var$_interopRequireDefault((parcelRequire("5FkrB")));


var $c7b70d3a2f678352$var$_alignLeft = $c7b70d3a2f678352$var$_interopRequireDefault((parcelRequire("acHUo")));
function $c7b70d3a2f678352$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $c7b70d3a2f678352$var$OverviewIcon = (props)=>/*#__PURE__*/ $c7b70d3a2f678352$var$_react.default.createElement($49a9e186635900ef$export$3cfb73f70dfca966, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M8.01 18c.546 0 .99-.444.99-1a1 1 0 0 0-.99-1H3.99A.993.993 0 0 0 3 17a1 1 0 0 0 .99 1zM3 7c0 .552.445 1 .993 1h16.014A.994.994 0 0 0 21 7c0-.552-.445-1-.993-1H3.993A.994.994 0 0 0 3 7m10.998 6A1 1 0 0 0 15 12c0-.552-.456-1-1.002-1H4.002A1 1 0 0 0 3 12c0 .552.456 1 1.002 1z"/></svg>`
    }, props, {
        newIcon: $c7b70d3a2f678352$var$_alignLeft.default
    }));
$c7b70d3a2f678352$var$OverviewIcon.displayName = 'OverviewIcon';
var $c7b70d3a2f678352$var$_default = $c7b70d3a2f678352$exports.default = $c7b70d3a2f678352$var$OverviewIcon;


var $4d9bc1cb23b5f81c$exports = {};
"use strict";
Object.defineProperty($4d9bc1cb23b5f81c$exports, "__esModule", {
    value: true
});
$4d9bc1cb23b5f81c$exports.default = void 0;

var $4d9bc1cb23b5f81c$var$_react = $4d9bc1cb23b5f81c$var$_interopRequireDefault((parcelRequire("5FkrB")));


var $4d9bc1cb23b5f81c$var$_questionCircle = $4d9bc1cb23b5f81c$var$_interopRequireDefault((parcelRequire("lEjQC")));
function $4d9bc1cb23b5f81c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $4d9bc1cb23b5f81c$var$QuestionIcon = (props)=>/*#__PURE__*/ $4d9bc1cb23b5f81c$var$_react.default.createElement($49a9e186635900ef$export$3cfb73f70dfca966, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path d="M12 18a1 1 0 0 1 0-2 1 1 0 0 1 0 2m-2-9a1 1 0 1 1-2 0 1 1 0 0 1 2 0"/><path d="M15.89 8.048a3.97 3.97 0 0 0-2.951-2.94A4.005 4.005 0 0 0 8 9.087l.009.008 1.878.022.112-.116A2 2 0 0 1 12 7c1.103 0 2 .897 2 2s-.897 2-2 2h.008a1 1 0 0 0-.998.987v2.014a1 1 0 1 0 2 0v-.782c0-.217.145-.399.349-.472a3.99 3.99 0 0 0 2.53-4.699"/></g></svg>`
    }, props, {
        newIcon: $4d9bc1cb23b5f81c$var$_questionCircle.default
    }));
$4d9bc1cb23b5f81c$var$QuestionIcon.displayName = 'QuestionIcon';
var $4d9bc1cb23b5f81c$var$_default = $4d9bc1cb23b5f81c$exports.default = $4d9bc1cb23b5f81c$var$QuestionIcon;


var $7f6dfc6f29e99698$exports = {};
"use strict";
Object.defineProperty($7f6dfc6f29e99698$exports, "__esModule", {
    value: true
});
$7f6dfc6f29e99698$exports.default = void 0;

var $7f6dfc6f29e99698$var$_react = $7f6dfc6f29e99698$var$_interopRequireDefault((parcelRequire("5FkrB")));


var $7f6dfc6f29e99698$var$_refresh = $7f6dfc6f29e99698$var$_interopRequireDefault((parcelRequire("1qAa4")));
function $7f6dfc6f29e99698$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $7f6dfc6f29e99698$var$RefreshIcon = (props)=>/*#__PURE__*/ $7f6dfc6f29e99698$var$_react.default.createElement($49a9e186635900ef$export$3cfb73f70dfca966, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path fill-rule="nonzero" d="M8 6.003v2.995a1 1 0 1 0 2 0V5.102C10 4.494 9.507 4 8.9 4H5a1 1 0 0 0 0 2.003z"/><path fill-rule="nonzero" d="M9.428 18.018C7.351 16.989 6 14.807 6 12.37c0-2.266 1.167-4.319 3.02-5.425.48-.286.646-.922.371-1.421a.98.98 0 0 0-1.364-.386C5.557 6.611 4 9.35 4 12.37c0 3.248 1.802 6.158 4.57 7.529.498.247 1.095.026 1.332-.493.237-.52.025-1.141-.474-1.388"/><path d="M14 15.002v3.896c0 .608.493 1.102 1.1 1.102H19a1 1 0 0 0 0-2.003h-3v-2.995a1 1 0 1 0-2 0"/><path d="M14.097 4.596c-.237.52-.025 1.14.474 1.387 2.077 1.029 3.428 3.21 3.428 5.647 0 2.266-1.167 4.32-3.021 5.425a1.063 1.063 0 0 0-.37 1.42c.274.5.885.673 1.364.387 2.47-1.473 4.027-4.212 4.027-7.232 0-3.248-1.802-6.158-4.57-7.528A.96.96 0 0 0 15.002 4a1 1 0 0 0-.905.596"/></g></svg>`
    }, props, {
        newIcon: $7f6dfc6f29e99698$var$_refresh.default
    }));
$7f6dfc6f29e99698$var$RefreshIcon.displayName = 'RefreshIcon';
var $7f6dfc6f29e99698$var$_default = $7f6dfc6f29e99698$exports.default = $7f6dfc6f29e99698$var$RefreshIcon;


var $47b625f21d7ae4a6$exports = {};
"use strict";
Object.defineProperty($47b625f21d7ae4a6$exports, "__esModule", {
    value: true
});
$47b625f21d7ae4a6$exports.default = void 0;

var $47b625f21d7ae4a6$var$_react = $47b625f21d7ae4a6$var$_interopRequireDefault((parcelRequire("5FkrB")));


var $47b625f21d7ae4a6$var$_search = $47b625f21d7ae4a6$var$_interopRequireDefault((parcelRequire("e3tIz")));
function $47b625f21d7ae4a6$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $47b625f21d7ae4a6$var$SearchIcon = (props)=>/*#__PURE__*/ $47b625f21d7ae4a6$var$_react.default.createElement($49a9e186635900ef$export$3cfb73f70dfca966, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m16.436 15.085 3.94 4.01a1 1 0 0 1-1.425 1.402l-3.938-4.006a7.5 7.5 0 1 1 1.423-1.406M10.5 16a5.5 5.5 0 1 0 0-11 5.5 5.5 0 0 0 0 11"/></svg>`
    }, props, {
        newIcon: $47b625f21d7ae4a6$var$_search.default
    }));
$47b625f21d7ae4a6$var$SearchIcon.displayName = 'SearchIcon';
var $47b625f21d7ae4a6$var$_default = $47b625f21d7ae4a6$exports.default = $47b625f21d7ae4a6$var$SearchIcon;


var $d93733cd60a2ee2e$exports = {};
"use strict";
Object.defineProperty($d93733cd60a2ee2e$exports, "__esModule", {
    value: true
});
$d93733cd60a2ee2e$exports.default = void 0;

var $d93733cd60a2ee2e$var$_react = $d93733cd60a2ee2e$var$_interopRequireDefault((parcelRequire("5FkrB")));


var $d93733cd60a2ee2e$var$_settings = $d93733cd60a2ee2e$var$_interopRequireDefault((parcelRequire("gmX7n")));
function $d93733cd60a2ee2e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $d93733cd60a2ee2e$var$SettingsIcon = (props)=>/*#__PURE__*/ $d93733cd60a2ee2e$var$_react.default.createElement($49a9e186635900ef$export$3cfb73f70dfca966, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M11.701 16.7a5.002 5.002 0 1 1 0-10.003 5.002 5.002 0 0 1 0 10.004m8.368-3.117a1.995 1.995 0 0 1-1.346-1.885c0-.876.563-1.613 1.345-1.885a.48.48 0 0 0 .315-.574 9 9 0 0 0-.836-1.993.48.48 0 0 0-.598-.195 2.04 2.04 0 0 1-1.29.08 1.99 1.99 0 0 1-1.404-1.395 2.04 2.04 0 0 1 .076-1.297.48.48 0 0 0-.196-.597 9 9 0 0 0-1.975-.826.48.48 0 0 0-.574.314 1.995 1.995 0 0 1-1.885 1.346 1.99 1.99 0 0 1-1.884-1.345.48.48 0 0 0-.575-.315c-.708.2-1.379.485-2.004.842a.47.47 0 0 0-.198.582A2.002 2.002 0 0 1 4.445 7.06a.48.48 0 0 0-.595.196 9 9 0 0 0-.833 1.994.48.48 0 0 0 .308.572 1.995 1.995 0 0 1 1.323 1.877c0 .867-.552 1.599-1.324 1.877a.48.48 0 0 0-.308.57 9 9 0 0 0 .723 1.79.477.477 0 0 0 .624.194c.595-.273 1.343-.264 2.104.238.117.077.225.185.302.3.527.8.512 1.58.198 2.188a.473.473 0 0 0 .168.628 9 9 0 0 0 2.11.897.474.474 0 0 0 .57-.313 1.995 1.995 0 0 1 1.886-1.353c.878 0 1.618.567 1.887 1.353a.475.475 0 0 0 .57.313 9 9 0 0 0 2.084-.883.473.473 0 0 0 .167-.631c-.318-.608-.337-1.393.191-2.195.077-.116.185-.225.302-.302.772-.511 1.527-.513 2.125-.23a.477.477 0 0 0 .628-.19 9 9 0 0 0 .728-1.793.48.48 0 0 0-.314-.573"/></svg>`
    }, props, {
        newIcon: $d93733cd60a2ee2e$var$_settings.default
    }));
$d93733cd60a2ee2e$var$SettingsIcon.displayName = 'SettingsIcon';
var $d93733cd60a2ee2e$var$_default = $d93733cd60a2ee2e$exports.default = $d93733cd60a2ee2e$var$SettingsIcon;


var $eb718c580db4626b$exports = {};
"use strict";
Object.defineProperty($eb718c580db4626b$exports, "__esModule", {
    value: true
});
$eb718c580db4626b$exports.default = void 0;

var $eb718c580db4626b$var$_react = $eb718c580db4626b$var$_interopRequireDefault((parcelRequire("5FkrB")));


var $eb718c580db4626b$var$_share = $eb718c580db4626b$var$_interopRequireDefault((parcelRequire("ecMhW")));
function $eb718c580db4626b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $eb718c580db4626b$var$ShareIcon = (props)=>/*#__PURE__*/ $eb718c580db4626b$var$_react.default.createElement($49a9e186635900ef$export$3cfb73f70dfca966, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path fill-rule="nonzero" d="M6 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6m0-2a1 1 0 1 1 0-2 1 1 0 0 1 0 2m12-4a3 3 0 1 0 0-6 3 3 0 0 0 0 6m0-2a1 1 0 1 1 0-2 1 1 0 0 1 0 2m0 14a3 3 0 1 0 0-6 3 3 0 0 0 0 6m0-2a1 1 0 1 1 0-2 1 1 0 0 1 0 2"/><path d="m7 13.562 8.66 5 1-1.732-8.66-5z"/><path d="m7 10.83 1 1.732 8.66-5-1-1.732z"/></g></svg>`
    }, props, {
        newIcon: $eb718c580db4626b$var$_share.default
    }));
$eb718c580db4626b$var$ShareIcon.displayName = 'ShareIcon';
var $eb718c580db4626b$var$_default = $eb718c580db4626b$exports.default = $eb718c580db4626b$var$ShareIcon;


var $de0848e68fcb9d68$exports = {};
"use strict";
Object.defineProperty($de0848e68fcb9d68$exports, "__esModule", {
    value: true
});
$de0848e68fcb9d68$exports.default = void 0;

var $de0848e68fcb9d68$var$_react = $de0848e68fcb9d68$var$_interopRequireDefault((parcelRequire("5FkrB")));


var $de0848e68fcb9d68$var$_starUnstarred = $de0848e68fcb9d68$var$_interopRequireDefault((parcelRequire("8heaH")));
function $de0848e68fcb9d68$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $de0848e68fcb9d68$var$StarIcon = (props)=>/*#__PURE__*/ $de0848e68fcb9d68$var$_react.default.createElement($49a9e186635900ef$export$3cfb73f70dfca966, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="m12 16.373 3.98 2.193-.76-4.655 3.276-3.347-4.524-.69L12 5.687l-1.972 4.189-4.524.689L8.78 13.91l-.762 4.655zm0 2.283-3.016 1.662a2 2 0 0 1-2.939-2.075l.599-3.656-2.57-2.624a2 2 0 0 1 1.129-3.377l3.47-.528 1.518-3.224a2 2 0 0 1 3.618 0l1.519 3.224 3.47.528a2 2 0 0 1 1.127 3.377l-2.569 2.624.599 3.656a2 2 0 0 1-2.94 2.075z"/></svg>`
    }, props, {
        newIcon: $de0848e68fcb9d68$var$_starUnstarred.default
    }));
$de0848e68fcb9d68$var$StarIcon.displayName = 'StarIcon';
var $de0848e68fcb9d68$var$_default = $de0848e68fcb9d68$exports.default = $de0848e68fcb9d68$var$StarIcon;


var $7f3db16b7d369d9b$exports = {};
"use strict";
Object.defineProperty($7f3db16b7d369d9b$exports, "__esModule", {
    value: true
});
$7f3db16b7d369d9b$exports.default = void 0;

var $7f3db16b7d369d9b$var$_react = $7f3db16b7d369d9b$var$_interopRequireDefault((parcelRequire("5FkrB")));


var $7f3db16b7d369d9b$var$_starStarred = $7f3db16b7d369d9b$var$_interopRequireDefault((parcelRequire("9ujTo")));
function $7f3db16b7d369d9b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $7f3db16b7d369d9b$var$StarFilledIcon = (props)=>/*#__PURE__*/ $7f3db16b7d369d9b$var$_react.default.createElement($49a9e186635900ef$export$3cfb73f70dfca966, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m12.072 17.284-3.905 2.053a1 1 0 0 1-1.451-1.054l.745-4.349-3.159-3.08a1 1 0 0 1 .554-1.705l4.366-.635 1.953-3.956a1 1 0 0 1 1.794 0l1.952 3.956 4.366.635a1 1 0 0 1 .555 1.705l-3.16 3.08.746 4.349a1 1 0 0 1-1.45 1.054z"/></svg>`
    }, props, {
        newIcon: $7f3db16b7d369d9b$var$_starStarred.default
    }));
$7f3db16b7d369d9b$var$StarFilledIcon.displayName = 'StarFilledIcon';
var $7f3db16b7d369d9b$var$_default = $7f3db16b7d369d9b$exports.default = $7f3db16b7d369d9b$var$StarFilledIcon;


var $fcdbc1d2bc40f8ba$exports = {};
"use strict";
Object.defineProperty($fcdbc1d2bc40f8ba$exports, "__esModule", {
    value: true
});
$fcdbc1d2bc40f8ba$exports.default = void 0;

var $fcdbc1d2bc40f8ba$var$_react = $fcdbc1d2bc40f8ba$var$_interopRequireDefault((parcelRequire("5FkrB")));


var $fcdbc1d2bc40f8ba$var$_warning = $fcdbc1d2bc40f8ba$var$_interopRequireDefault((parcelRequire("72WPR")));
function $fcdbc1d2bc40f8ba$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $fcdbc1d2bc40f8ba$var$WarningIcon = (props)=>/*#__PURE__*/ $fcdbc1d2bc40f8ba$var$_react.default.createElement($49a9e186635900ef$export$3cfb73f70dfca966, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><path fill="currentcolor" d="M12.938 4.967c-.518-.978-1.36-.974-1.876 0L3.938 18.425c-.518.978-.045 1.771 1.057 1.771h14.01c1.102 0 1.573-.797 1.057-1.771z"/><path fill="inherit" d="M12 15a1 1 0 0 1-1-1V9a1 1 0 0 1 2 0v5a1 1 0 0 1-1 1m0 3a1 1 0 0 1 0-2 1 1 0 0 1 0 2"/></g></svg>`
    }, props, {
        newIcon: $fcdbc1d2bc40f8ba$var$_warning.default
    }));
$fcdbc1d2bc40f8ba$var$WarningIcon.displayName = 'WarningIcon';
var $fcdbc1d2bc40f8ba$var$_default = $fcdbc1d2bc40f8ba$exports.default = $fcdbc1d2bc40f8ba$var$WarningIcon;


var $25e8a161b396b80d$exports = {};
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6b7be9690353c7bf82b96c9a0cc89ae3>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty($25e8a161b396b80d$exports, "__esModule", {
    value: true
});
$25e8a161b396b80d$exports.default = void 0;

var $25e8a161b396b80d$var$_react = $25e8a161b396b80d$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $25e8a161b396b80d$var$_baseNew = $25e8a161b396b80d$var$_interopRequireDefault((parcelRequire("k6VkH")));
function $25e8a161b396b80d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "RoadmapsPlan".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for representing plans.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $25e8a161b396b80d$var$RoadmapsPlanIcon = (props)=>/*#__PURE__*/ $25e8a161b396b80d$var$_react.default.createElement($25e8a161b396b80d$var$_baseNew.default, Object.assign({
        name: "RoadmapsPlanIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M3.5 2.5a1 1 0 1 0 0 2 1 1 0 0 0 0-2M1 3.5a2.5 2.5 0 0 1 4.886-.75h4.864a3 3 0 1 1 0 6h-5.5a1.5 1.5 0 1 0 0 3h4.865a2.501 2.501 0 1 1 0 1.5H5.25a3 3 0 1 1 0-6h5.5a1.5 1.5 0 0 0 0-3H5.886A2.501 2.501 0 0 1 1 3.5m11.5 8a1 1 0 1 0 0 2 1 1 0 0 0 0-2" clip-rule="evenodd"/>`
    }, props));
$25e8a161b396b80d$var$RoadmapsPlanIcon.displayName = 'RoadmapsPlanIcon';
var $25e8a161b396b80d$var$_default = $25e8a161b396b80d$exports.default = $25e8a161b396b80d$var$RoadmapsPlanIcon;


/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ /* eslint-disable prefer-rest-params */ /* eslint-disable no-console */ var $7daadcd75c03f17d$var$printed = {};
function $7daadcd75c03f17d$export$2e2bcd8739ae039(message) {
    if ($7daadcd75c03f17d$var$printed[message]) return;
    $7daadcd75c03f17d$var$printed[message] = true;
    if (typeof window !== 'undefined') console.warn(message);
}



var $3ZMUU = parcelRequire("3ZMUU");
function $b89ec1d634bf8f9f$export$2e2bcd8739ae039(packageName, api, additionalMessage) {
    (0, $7daadcd75c03f17d$export$2e2bcd8739ae039)("[".concat(packageName, "]: The ").concat(api, " is deprecated.").concat(additionalMessage && " ".concat(additionalMessage)));
}
function $b89ec1d634bf8f9f$export$eb1decd851a5ae56(packageName, propName, predicate, deprecationAnnouncementOnDAC) {
    typeof $3ZMUU;
}



var $0ce0c6f54e6e45da$export$44ffba16bd48dac6 = '__ATLASKIT_THEME__';
var $0ce0c6f54e6e45da$export$c93026a968943f95 = 'light';
var $0ce0c6f54e6e45da$export$6ba72c8346b4c57e = [
    'light',
    'dark'
];
var $0ce0c6f54e6e45da$export$7a57f79000377ca2 = function borderRadius() {
    return 3;
};
var $0ce0c6f54e6e45da$export$6d8204c2cb2e06b8 = function gridSize() {
    return 8;
};
var $0ce0c6f54e6e45da$export$85e3c3ca0c6fb93 = function fontSize() {
    return 14;
};
var $0ce0c6f54e6e45da$export$6746fe0d9c9fab54 = function fontSizeSmall() {
    return 11;
};
var $0ce0c6f54e6e45da$export$a5975749f0374264 = function fontFamily() {
    return "-apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif";
};
var $0ce0c6f54e6e45da$export$356129969ee49c55 = function codeFontFamily() {
    return "'SFMono-Medium', 'SF Mono', 'Segoe UI Mono', 'Roboto Mono', 'Ubuntu Mono', Menlo, Consolas, Courier, monospace";
};
var $0ce0c6f54e6e45da$export$8e24544ddba725ee = function focusRing() {
    var color = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "var(--ds-border-focused, ".concat((0, $54ca2d3948378259$export$215b7063051591f1), ")");
    var outlineWidth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $0ce0c6f54e6e45da$export$6d8204c2cb2e06b8() / 4;
    (0, $b89ec1d634bf8f9f$export$2e2bcd8739ae039)('@atlaskit/theme', 'focus ring mixin', 'Please use `@atlaskit/focus-ring` instead.');
    return "\n  &:focus {\n    outline: none;\n    box-shadow: 0px 0px 0px ".concat(outlineWidth, "px ").concat(color, ";\n  }\n");
};
var $0ce0c6f54e6e45da$export$c0dd343266bc3261 = function noFocusRing() {
    return "\n  box-shadow: none;\n";
};
var $0ce0c6f54e6e45da$export$7be255094ccdc533 = {
    card: function card() {
        return 100;
    },
    navigation: function navigation() {
        return 200;
    },
    dialog: function dialog() {
        return 300;
    },
    layer: function layer() {
        return 400;
    },
    blanket: function blanket() {
        return 500;
    },
    modal: function modal() {
        return 510;
    },
    flag: function flag() {
        return 600;
    },
    spotlight: function spotlight() {
        return 700;
    },
    tooltip: function tooltip() {
        return 9999;
    }
};
var $0ce0c6f54e6e45da$export$a1b3edb637fb4f35 = function visuallyHidden() {
    (0, $b89ec1d634bf8f9f$export$2e2bcd8739ae039)('@atlaskit/theme', 'visually hidden mixin', 'Please use `@atlaskit/visually-hidden` instead.');
    return {
        border: '0 !important',
        clip: 'rect(1px, 1px, 1px, 1px) !important',
        height: '1px !important',
        overflow: 'hidden !important',
        padding: '0 !important',
        position: 'absolute !important',
        width: '1px !important',
        whiteSpace: 'nowrap !important'
    };
};
var $0ce0c6f54e6e45da$export$ba1d834b86d72a09 = $0ce0c6f54e6e45da$export$a1b3edb637fb4f35;
var $0ce0c6f54e6e45da$export$e497e856b4f89fcd = function skeletonShimmer() {
    return {
        css: {
            backgroundColor: "var(--ds-skeleton, ".concat((0, $54ca2d3948378259$export$2a0674ff2eb10214)(), ")"),
            animationDuration: '1.5s',
            animationIterationCount: 'infinite',
            animationTimingFunction: 'linear',
            animationDirection: 'alternate'
        },
        keyframes: {
            from: {
                backgroundColor: "var(--ds-skeleton, ".concat((0, $54ca2d3948378259$export$2a0674ff2eb10214)(), ")")
            },
            to: {
                backgroundColor: "var(--ds-skeleton-subtle, ".concat((0, $54ca2d3948378259$export$920c0d5c49070351), ")")
            }
        }
    };
};


function $c72245efbf0a215e$export$2e2bcd8739ae039(props) {
    if (props && props.theme) {
        // Theme is the global Atlaskit theme
        if ((0, $0ce0c6f54e6e45da$export$44ffba16bd48dac6) in props.theme) return props.theme[0, $0ce0c6f54e6e45da$export$44ffba16bd48dac6];
        else if ('mode' in props.theme && (0, $0ce0c6f54e6e45da$export$6ba72c8346b4c57e).includes(props.theme.mode)) return props.theme;
    }
    // If format not supported (or no theme provided), return standard theme
    return {
        mode: (0, $0ce0c6f54e6e45da$export$c93026a968943f95)
    };
}


// Unpack custom variants, and get correct value for the current theme
function $aad78afbdc47a5b9$var$themedVariants(variantProp, variants) {
    return function(props) {
        var theme = (0, $c72245efbf0a215e$export$2e2bcd8739ae039)(props);
        if (props && props[variantProp] && variants) {
            var modes = variants[props[variantProp]];
            if (modes && modes[theme.mode]) {
                var value = modes[theme.mode];
                if (value) return value;
                 // TS believes value can be undefined
            }
        }
        return '';
    };
}
function $aad78afbdc47a5b9$export$2e2bcd8739ae039(modesOrVariant, variantModes) {
    if (typeof modesOrVariant === 'string') return $aad78afbdc47a5b9$var$themedVariants(modesOrVariant, variantModes);
    var modes = modesOrVariant;
    return function(props) {
        // Get theme from the user's props
        var theme = (0, $c72245efbf0a215e$export$2e2bcd8739ae039)(props);
        // User isn't required to provide both light and dark values
        if (theme.mode in modes) {
            var value = modes[theme.mode]; // TS believes value can be undefined
            if (value) return value;
        }
        return '';
    };
}


var $54ca2d3948378259$export$4b84fd0e2c617bd = '#FFEBE6';
var $54ca2d3948378259$export$b34b069eff244586 = '#FFBDAD';
var $54ca2d3948378259$export$be802dd0d8b57f35 = '#FF8F73';
var $54ca2d3948378259$export$60847d42f9da92a6 = '#FF7452';
var $54ca2d3948378259$export$4a7404f376229999 = '#FF5630';
var $54ca2d3948378259$export$2010d0fb4295b346 = '#DE350B';
var $54ca2d3948378259$export$2837b5a1a71d5c02 = '#BF2600';
var $54ca2d3948378259$export$8d9596b529bbb9cf = '#FFFAE6';
var $54ca2d3948378259$export$41060a744ab0b7ae = '#FFF0B3';
var $54ca2d3948378259$export$1cc05bbbf340e559 = '#FFE380';
var $54ca2d3948378259$export$5aae31392d72caaa = '#FFC400';
var $54ca2d3948378259$export$c6930421db9fa514 = '#FFAB00';
var $54ca2d3948378259$export$59619663aa6500fb = '#FF991F';
var $54ca2d3948378259$export$874739ea9e379ab6 = '#FF8B00';
var $54ca2d3948378259$export$8a6341c32b6a3ee6 = '#E3FCEF';
var $54ca2d3948378259$export$69a3bf21b9686c2b = '#ABF5D1';
var $54ca2d3948378259$export$afbce1382ec95f73 = '#79F2C0';
var $54ca2d3948378259$export$747d86715d4175de = '#57D9A3';
var $54ca2d3948378259$export$940e1f69e873f202 = '#36B37E';
var $54ca2d3948378259$export$a49394138f7b8e85 = '#00875A';
var $54ca2d3948378259$export$6fa04827ac68a4fb = '#006644';
var $54ca2d3948378259$export$226de0355ed012f8 = '#DEEBFF';
var $54ca2d3948378259$export$8c13c2ee36917869 = '#B3D4FF';
var $54ca2d3948378259$export$ecfc1dff386a3e7a = '#4C9AFF';
var $54ca2d3948378259$export$215b7063051591f1 = '#2684FF';
var $54ca2d3948378259$export$e62e8919cca44969 = '#0065FF';
var $54ca2d3948378259$export$b3de0ae08da2ce64 = '#0052CC';
var $54ca2d3948378259$export$a6ee3d71bc067634 = '#0747A6';
var $54ca2d3948378259$export$363e4475840015bb = '#EAE6FF';
var $54ca2d3948378259$export$4b0a4417ed59760f = '#C0B6F2';
var $54ca2d3948378259$export$6011520a64d9a187 = '#998DD9';
var $54ca2d3948378259$export$a7175d4e9206bc80 = '#8777D9';
var $54ca2d3948378259$export$b48405b95304b5a1 = '#6554C0';
var $54ca2d3948378259$export$c71e4279dd54a18d = '#5243AA';
var $54ca2d3948378259$export$147899de772240ec = '#403294';
var $54ca2d3948378259$export$2cf711fe14c66f06 = '#E6FCFF';
var $54ca2d3948378259$export$7a8f4d33f6f9772c = '#B3F5FF';
var $54ca2d3948378259$export$776c9c497ef08533 = '#79E2F2';
var $54ca2d3948378259$export$69cb3ca10c1e330e = '#00C7E6';
var $54ca2d3948378259$export$9dc1ef0f3f48059b = '#00B8D9';
var $54ca2d3948378259$export$7c835c78b6fcdef8 = '#00A3BF';
var $54ca2d3948378259$export$6036577f95c3877e = '#008DA6';
var $54ca2d3948378259$export$29a4f05edc054374 = '#FFFFFF';
var $54ca2d3948378259$export$e655ef011c4aa1a2 = '#FAFBFC';
var $54ca2d3948378259$export$9fdfb749e33cdf97 = '#F4F5F7';
var $54ca2d3948378259$export$3e51e8f1440314ba = '#EBECF0';
var $54ca2d3948378259$export$1ce2d1575d444ceb = '#DFE1E6';
var $54ca2d3948378259$export$8754fc7e6d8b3000 = '#C1C7D0';
var $54ca2d3948378259$export$c2e91cbeada39b8b = '#B3BAC5';
var $54ca2d3948378259$export$5f71e19f3a7ad9de = '#A5ADBA';
var $54ca2d3948378259$export$eaa8c8a70ac22806 = '#97A0AF';
var $54ca2d3948378259$export$7c87d337fb91a97d = '#8993A4';
var $54ca2d3948378259$export$d6447c357493214f = '#7A869A';
var $54ca2d3948378259$export$f563ee71e9ee74cd = '#6B778C';
var $54ca2d3948378259$export$e2ef2124cf4024b1 = '#5E6C84';
var $54ca2d3948378259$export$eece5f492e429f08 = '#505F79';
var $54ca2d3948378259$export$c39c0fe0f26207ae = '#42526E';
var $54ca2d3948378259$export$7090862dc3038a9f = '#344563';
var $54ca2d3948378259$export$ad0bacf983b7ddaa = '#253858';
var $54ca2d3948378259$export$7d61b15e0da132af = '#172B4D';
var $54ca2d3948378259$export$fbda843f0a27fe96 = '#091E42';
var $54ca2d3948378259$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
var $54ca2d3948378259$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
var $54ca2d3948378259$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
var $54ca2d3948378259$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
var $54ca2d3948378259$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
var $54ca2d3948378259$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
var $54ca2d3948378259$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
var $54ca2d3948378259$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
var $54ca2d3948378259$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
var $54ca2d3948378259$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
var $54ca2d3948378259$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
var $54ca2d3948378259$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
var $54ca2d3948378259$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
var $54ca2d3948378259$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
var $54ca2d3948378259$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
var $54ca2d3948378259$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
var $54ca2d3948378259$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
var $54ca2d3948378259$export$2f6319cf7d736c2a = '#E6EDFA';
var $54ca2d3948378259$export$95126bc8884d6634 = '#DCE5F5';
var $54ca2d3948378259$export$8338d8c35d44ff1 = '#CED9EB';
var $54ca2d3948378259$export$5368d76ae4fbbda7 = '#B8C7E0';
var $54ca2d3948378259$export$9f0a771d16ec8d36 = '#ABBBD6';
var $54ca2d3948378259$export$abcf8c38338b4aa5 = '#9FB0CC';
var $54ca2d3948378259$export$97e81faa16a182c7 = '#8C9CB8';
var $54ca2d3948378259$export$bfe21c59123ecf33 = '#7988A3';
var $54ca2d3948378259$export$ee82aa2ea6a1558 = '#67758F';
var $54ca2d3948378259$export$682927c6ed76be02 = '#56637A';
var $54ca2d3948378259$export$91fd9994c5be9757 = '#455166';
var $54ca2d3948378259$export$d281fbfe3cff2df6 = '#3B475C';
var $54ca2d3948378259$export$3902c91d8b98a753 = '#313D52';
var $54ca2d3948378259$export$8e8133c1ba5845b5 = '#283447';
var $54ca2d3948378259$export$33ff357f6620b39 = '#202B3D';
var $54ca2d3948378259$export$633847cf062b69e0 = '#1B2638';
var $54ca2d3948378259$export$9776a6e503bdbf76 = '#121A29';
var $54ca2d3948378259$export$6c813d5160dff5db = '#0E1624';
var $54ca2d3948378259$export$3d4f271a500072a = '#0D1424';
var $54ca2d3948378259$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
var $54ca2d3948378259$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
var $54ca2d3948378259$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
var $54ca2d3948378259$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
var $54ca2d3948378259$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
var $54ca2d3948378259$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
var $54ca2d3948378259$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
var $54ca2d3948378259$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
var $54ca2d3948378259$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
var $54ca2d3948378259$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
var $54ca2d3948378259$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
var $54ca2d3948378259$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
var $54ca2d3948378259$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
var $54ca2d3948378259$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
var $54ca2d3948378259$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
var $54ca2d3948378259$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
var $54ca2d3948378259$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';
var $54ca2d3948378259$export$8ce1fd94bee2f412 = (0, $aad78afbdc47a5b9$export$2e2bcd8739ae039)({
    light: "var(--ds-surface, ".concat($54ca2d3948378259$export$29a4f05edc054374, ")"),
    dark: "var(--ds-surface, ".concat($54ca2d3948378259$export$633847cf062b69e0, ")")
});
var $54ca2d3948378259$export$b861914ea877b580 = (0, $aad78afbdc47a5b9$export$2e2bcd8739ae039)({
    light: "var(--ds-background-selected, ".concat($54ca2d3948378259$export$226de0355ed012f8, ")"),
    dark: "var(--ds-background-selected, ".concat($54ca2d3948378259$export$8c13c2ee36917869, ")")
});
var $54ca2d3948378259$export$3f1b020df94387af = (0, $aad78afbdc47a5b9$export$2e2bcd8739ae039)({
    light: "var(--ds-background-neutral-hovered, ".concat($54ca2d3948378259$export$3e51e8f1440314ba, ")"),
    dark: "var(--ds-background-neutral-hovered, ".concat($54ca2d3948378259$export$d281fbfe3cff2df6, ")")
});
var $54ca2d3948378259$export$c0183dbab98ca63e = (0, $aad78afbdc47a5b9$export$2e2bcd8739ae039)({
    light: "var(--ds-surface-overlay, ".concat($54ca2d3948378259$export$29a4f05edc054374, ")"),
    dark: "var(--ds-surface-overlay, ".concat($54ca2d3948378259$export$8e8133c1ba5845b5, ")")
});
var $54ca2d3948378259$export$6f093cfa640b7166 = (0, $aad78afbdc47a5b9$export$2e2bcd8739ae039)({
    light: "var(--ds-text, ".concat($54ca2d3948378259$export$fbda843f0a27fe96, ")"),
    dark: "var(--ds-text, ".concat($54ca2d3948378259$export$5368d76ae4fbbda7, ")")
});
var $54ca2d3948378259$export$42f8e9c698766e7a = (0, $aad78afbdc47a5b9$export$2e2bcd8739ae039)({
    light: "var(--ds-text, ".concat($54ca2d3948378259$export$7d61b15e0da132af, ")"),
    dark: "var(--ds-text, ".concat($54ca2d3948378259$export$5368d76ae4fbbda7, ")")
});
var $54ca2d3948378259$export$c2d157ca1c34b6e3 = (0, $aad78afbdc47a5b9$export$2e2bcd8739ae039)({
    light: "var(--ds-text-selected, ".concat($54ca2d3948378259$export$b3de0ae08da2ce64, ")"),
    dark: "var(--ds-text-selected, ".concat($54ca2d3948378259$export$b3de0ae08da2ce64, ")")
});
var $54ca2d3948378259$export$1905ba28d7cf066f = (0, $aad78afbdc47a5b9$export$2e2bcd8739ae039)({
    light: "var(--ds-text-subtlest, ".concat($54ca2d3948378259$export$f563ee71e9ee74cd, ")"),
    dark: "var(--ds-text-subtlest, ".concat($54ca2d3948378259$export$97e81faa16a182c7, ")")
});
var $54ca2d3948378259$export$bd9002130d306d39 = (0, $aad78afbdc47a5b9$export$2e2bcd8739ae039)({
    light: "var(--ds-text-subtlest, ".concat($54ca2d3948378259$export$f563ee71e9ee74cd, ")"),
    dark: "var(--ds-text-subtlest, ".concat($54ca2d3948378259$export$bfe21c59123ecf33, ")")
});
var $54ca2d3948378259$export$46e4a324ac90507f = (0, $aad78afbdc47a5b9$export$2e2bcd8739ae039)({
    light: "var(--ds-text, ".concat($54ca2d3948378259$export$7d61b15e0da132af, ")"),
    dark: "var(--ds-text, ".concat($54ca2d3948378259$export$5368d76ae4fbbda7, ")")
});
var $54ca2d3948378259$export$79f3f2b82beb0d36 = (0, $aad78afbdc47a5b9$export$2e2bcd8739ae039)({
    light: "var(--ds-text-subtlest, ".concat($54ca2d3948378259$export$f563ee71e9ee74cd, ")"),
    dark: "var(--ds-text-subtlest, ".concat($54ca2d3948378259$export$97e81faa16a182c7, ")")
});
var $54ca2d3948378259$export$7bb0d5c671655cc4 = (0, $aad78afbdc47a5b9$export$2e2bcd8739ae039)({
    light: $54ca2d3948378259$export$9fdfb749e33cdf97,
    dark: $54ca2d3948378259$export$8e8133c1ba5845b5
});
var $54ca2d3948378259$export$9c30223ca0a664fb = (0, $aad78afbdc47a5b9$export$2e2bcd8739ae039)({
    light: "var(--ds-link, ".concat($54ca2d3948378259$export$b3de0ae08da2ce64, ")"),
    dark: "var(--ds-link, ".concat($54ca2d3948378259$export$ecfc1dff386a3e7a, ")")
});
var $54ca2d3948378259$export$7ed258b0728b004b = (0, $aad78afbdc47a5b9$export$2e2bcd8739ae039)({
    light: "var(--ds-link-pressed, ".concat($54ca2d3948378259$export$e62e8919cca44969, ")"),
    dark: "var(--ds-link-pressed, ".concat($54ca2d3948378259$export$215b7063051591f1, ")")
});
var $54ca2d3948378259$export$dfa920d8decc8a59 = (0, $aad78afbdc47a5b9$export$2e2bcd8739ae039)({
    light: "var(--ds-link-pressed, ".concat($54ca2d3948378259$export$a6ee3d71bc067634, ")"),
    dark: "var(--ds-link-pressed, ".concat($54ca2d3948378259$export$ecfc1dff386a3e7a, ")")
});
var $54ca2d3948378259$export$6069e6ad5c78f632 = (0, $aad78afbdc47a5b9$export$2e2bcd8739ae039)({
    light: "var(--ds-border-focused, ".concat($54ca2d3948378259$export$215b7063051591f1, ")"),
    dark: "var(--ds-border-focused, ".concat($54ca2d3948378259$export$215b7063051591f1, ")")
});
var $54ca2d3948378259$export$9ad721cf3b3debe0 = (0, $aad78afbdc47a5b9$export$2e2bcd8739ae039)({
    light: "var(--ds-background-brand-bold, ".concat($54ca2d3948378259$export$b3de0ae08da2ce64, ")"),
    dark: "var(--ds-background-brand-bold, ".concat($54ca2d3948378259$export$ecfc1dff386a3e7a, ")")
});
var $54ca2d3948378259$export$2aa0182783e7e9de = (0, $aad78afbdc47a5b9$export$2e2bcd8739ae039)({
    light: $54ca2d3948378259$export$b3de0ae08da2ce64,
    dark: $54ca2d3948378259$export$ecfc1dff386a3e7a
});
var $54ca2d3948378259$export$8bf7dff220b82b4a = (0, $aad78afbdc47a5b9$export$2e2bcd8739ae039)({
    light: $54ca2d3948378259$export$9dc1ef0f3f48059b,
    dark: $54ca2d3948378259$export$69cb3ca10c1e330e
});
var $54ca2d3948378259$export$e13cce2a2d16a9d4 = (0, $aad78afbdc47a5b9$export$2e2bcd8739ae039)({
    light: $54ca2d3948378259$export$b48405b95304b5a1,
    dark: $54ca2d3948378259$export$6011520a64d9a187
});
var $54ca2d3948378259$export$a90204d1394caf30 = (0, $aad78afbdc47a5b9$export$2e2bcd8739ae039)({
    light: $54ca2d3948378259$export$4a7404f376229999,
    dark: $54ca2d3948378259$export$4a7404f376229999
});
var $54ca2d3948378259$export$594c5a8758200c32 = (0, $aad78afbdc47a5b9$export$2e2bcd8739ae039)({
    light: $54ca2d3948378259$export$c6930421db9fa514,
    dark: $54ca2d3948378259$export$c6930421db9fa514
});
var $54ca2d3948378259$export$955a2ebd2fb142ae = (0, $aad78afbdc47a5b9$export$2e2bcd8739ae039)({
    light: $54ca2d3948378259$export$940e1f69e873f202,
    dark: $54ca2d3948378259$export$940e1f69e873f202
});
var $54ca2d3948378259$export$2a0674ff2eb10214 = function skeleton() {
    return "var(--ds-skeleton, ".concat($54ca2d3948378259$export$8d43898f60b96a82, ")");
};



var $5FkrB = parcelRequire("5FkrB");
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ var $f9ff4343296b19bf$var$n = function(t, e) {
    return ($f9ff4343296b19bf$var$n = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(t, e) {
        t.__proto__ = e;
    } || function(t, e) {
        for(var n in e)e.hasOwnProperty(n) && (t[n] = e[n]);
    })(t, e);
};
var $f9ff4343296b19bf$var$o, $f9ff4343296b19bf$var$r, $f9ff4343296b19bf$var$i = (function(t) {
    /*!
  Copyright (c) 2017 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/ !function() {
        var e = {}.hasOwnProperty;
        function n() {
            for(var t = [], o = 0; o < arguments.length; o++){
                var r = arguments[o];
                if (r) {
                    var i = typeof r;
                    if ("string" === i || "number" === i) t.push(r);
                    else if (Array.isArray(r) && r.length) {
                        var s = n.apply(null, r);
                        s && t.push(s);
                    } else if ("object" === i) for(var l in r)e.call(r, l) && r[l] && t.push(l);
                }
            }
            return t.join(" ");
        }
        t.exports ? (n.default = n, t.exports = n) : window.classNames = n;
    }();
}($f9ff4343296b19bf$var$r = {
    path: $f9ff4343296b19bf$var$o,
    exports: {},
    require: function(t, e) {
        return function() {
            throw new Error("Dynamic requires are not currently supported by @rollup/plugin-commonjs");
        }(null == e && $f9ff4343296b19bf$var$r.path);
    }
}, $f9ff4343296b19bf$var$r.exports), $f9ff4343296b19bf$var$r.exports);
function $f9ff4343296b19bf$var$s(t, e, n) {
    var o, r, i, s, l;
    function a() {
        var c = Date.now() - s;
        c < e && c >= 0 ? o = setTimeout(a, e - c) : (o = null, n || (l = t.apply(i, r), i = r = null));
    }
    null == e && (e = 100);
    var c = function() {
        i = this, r = arguments, s = Date.now();
        var c = n && !o;
        return o || (o = setTimeout(a, e)), c && (l = t.apply(i, r), i = r = null), l;
    };
    return c.clear = function() {
        o && (clearTimeout(o), o = null);
    }, c.flush = function() {
        o && (l = t.apply(i, r), i = r = null, clearTimeout(o), o = null);
    }, c;
}
$f9ff4343296b19bf$var$s.debounce = $f9ff4343296b19bf$var$s;
var $f9ff4343296b19bf$var$l = $f9ff4343296b19bf$var$s;
!function(t, e) {
    void 0 === e && (e = {});
    var n = e.insertAt;
    if (t && "undefined" != typeof document) {
        var o = document.head || document.getElementsByTagName("head")[0], r = document.createElement("style");
        r.type = "text/css", "top" === n && o.firstChild ? o.insertBefore(r, o.firstChild) : o.appendChild(r), r.styleSheet ? r.styleSheet.cssText = t : r.appendChild(document.createTextNode(t));
    }
}(".indiana-scroll-container {\n  overflow: auto;\n}\n.indiana-scroll-container--dragging {\n  scroll-behavior: auto !important;\n}\n.indiana-scroll-container--dragging > * {\n  pointer-events: none;\n  cursor: -webkit-grab;\n  cursor: grab;\n}\n.indiana-scroll-container--hide-scrollbars {\n  overflow: hidden;\n  overflow: -moz-scrollbars-none;\n  -ms-overflow-style: none;\n  scrollbar-width: none;\n}\n.indiana-scroll-container--hide-scrollbars::-webkit-scrollbar {\n  display: none !important;\n  height: 0 !important;\n  width: 0 !important;\n  background: transparent !important;\n  -webkit-appearance: none !important;\n}\n.indiana-scroll-container--native-scroll {\n  overflow: auto;\n}\n\n.indiana-dragging {\n  cursor: -webkit-grab;\n  cursor: grab;\n}");
var $f9ff4343296b19bf$var$a, $f9ff4343296b19bf$var$c = ($f9ff4343296b19bf$var$a = "indiana-scroll-container", function(t, e) {
    if (!t) return $f9ff4343296b19bf$var$a;
    var n;
    "string" == typeof t ? n = t : e = t;
    var o = $f9ff4343296b19bf$var$a;
    return n && (o += "__" + n), o + (e ? Object.keys(e).reduce(function(t, n) {
        var r = e[n];
        return r && (t += " " + ("boolean" == typeof r ? o + "--" + n : o + "--" + n + "_" + r)), t;
    }, "") : "");
}), $f9ff4343296b19bf$var$p = function(e) {
    function o(n) {
        var o = e.call(this, n) || this;
        return o.onEndScroll = function() {
            o.scrolling = !1, !o.pressed && o.started && o.processEnd();
        }, o.onScroll = function(t) {
            var e = o.container.current;
            e.scrollLeft === o.scrollLeft && e.scrollTop === o.scrollTop || (o.scrolling = !0, o.processScroll(t), o.onEndScroll());
        }, o.onTouchStart = function(t) {
            var e = o.props.nativeMobileScroll;
            if (o.isDraggable(t.target)) {
                if (o.internal = !0, e && o.scrolling) o.pressed = !0;
                else {
                    var n = t.touches[0];
                    o.processClick(t, n.clientX, n.clientY), !e && o.props.stopPropagation && t.stopPropagation();
                }
            }
        }, o.onTouchEnd = function(t) {
            var e = o.props.nativeMobileScroll;
            o.pressed && (!o.started || o.scrolling && e ? o.pressed = !1 : o.processEnd(), o.forceUpdate());
        }, o.onTouchMove = function(t) {
            var e = o.props.nativeMobileScroll;
            if (o.pressed && (!e || !o.isMobile)) {
                var n = t.touches[0];
                n && o.processMove(t, n.clientX, n.clientY), t.preventDefault(), o.props.stopPropagation && t.stopPropagation();
            }
        }, o.onMouseDown = function(t) {
            o.isDraggable(t.target) && o.isScrollable() && (o.internal = !0, -1 !== o.props.buttons.indexOf(t.button) && (o.processClick(t, t.clientX, t.clientY), t.preventDefault(), o.props.stopPropagation && t.stopPropagation()));
        }, o.onMouseMove = function(t) {
            o.pressed && (o.processMove(t, t.clientX, t.clientY), t.preventDefault(), o.props.stopPropagation && t.stopPropagation());
        }, o.onMouseUp = function(t) {
            o.pressed && (o.started ? o.processEnd() : (o.internal = !1, o.pressed = !1, o.forceUpdate(), o.props.onClick && o.props.onClick(t)), t.preventDefault(), o.props.stopPropagation && t.stopPropagation());
        }, o.container = (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createRef(), o.onEndScroll = $f9ff4343296b19bf$var$l(o.onEndScroll, 300), o.scrolling = !1, o.started = !1, o.pressed = !1, o.internal = !1, o.getRef = o.getRef.bind(o), o;
    }
    return function(t, e) {
        function o() {
            this.constructor = t;
        }
        $f9ff4343296b19bf$var$n(t, e), t.prototype = null === e ? Object.create(e) : (o.prototype = e.prototype, new o);
    }(o, e), o.prototype.componentDidMount = function() {
        var t = this.props.nativeMobileScroll, e = this.container.current;
        window.addEventListener("mouseup", this.onMouseUp), window.addEventListener("mousemove", this.onMouseMove), window.addEventListener("touchmove", this.onTouchMove, {
            passive: !1
        }), window.addEventListener("touchend", this.onTouchEnd), e.addEventListener("touchstart", this.onTouchStart, {
            passive: !1
        }), e.addEventListener("mousedown", this.onMouseDown, {
            passive: !1
        }), t && (this.isMobile = this.isMobileDevice(), this.isMobile && this.forceUpdate());
    }, o.prototype.componentWillUnmount = function() {
        window.removeEventListener("mouseup", this.onMouseUp), window.removeEventListener("mousemove", this.onMouseMove), window.removeEventListener("touchmove", this.onTouchMove), window.removeEventListener("touchend", this.onTouchEnd);
    }, o.prototype.getElement = function() {
        return this.container.current;
    }, o.prototype.isMobileDevice = function() {
        return void 0 !== window.orientation || -1 !== navigator.userAgent.indexOf("IEMobile");
    }, o.prototype.isDraggable = function(t) {
        var e = this.props.ignoreElements;
        if (e) {
            var n = t.closest(e);
            return null === n || n.contains(this.getElement());
        }
        return !0;
    }, o.prototype.isScrollable = function() {
        var t = this.container.current;
        return t && (t.scrollWidth > t.clientWidth || t.scrollHeight > t.clientHeight);
    }, o.prototype.processClick = function(t, e, n) {
        var o = this.container.current;
        this.scrollLeft = o.scrollLeft, this.scrollTop = o.scrollTop, this.clientX = e, this.clientY = n, this.pressed = !0;
    }, o.prototype.processStart = function(t) {
        void 0 === t && (t = !0);
        var e = this.props.onStartScroll;
        this.started = !0, t && document.body.classList.add("indiana-dragging"), e && e({
            external: !this.internal
        }), this.forceUpdate();
    }, o.prototype.processScroll = function(t) {
        if (this.started) {
            var e = this.props.onScroll;
            e && e({
                external: !this.internal
            });
        } else this.processStart(!1);
    }, o.prototype.processMove = function(t, e, n) {
        var o = this.props, r = o.horizontal, i = o.vertical, s = o.activationDistance, l = o.onScroll, a = this.container.current;
        this.started ? (r && (a.scrollLeft -= e - this.clientX), i && (a.scrollTop -= n - this.clientY), l && l({
            external: !this.internal
        }), this.clientX = e, this.clientY = n, this.scrollLeft = a.scrollLeft, this.scrollTop = a.scrollTop) : (r && Math.abs(e - this.clientX) > s || i && Math.abs(n - this.clientY) > s) && (this.clientX = e, this.clientY = n, this.processStart());
    }, o.prototype.processEnd = function() {
        var t = this.props.onEndScroll;
        this.container.current && t && t({
            external: !this.internal
        }), this.pressed = !1, this.started = !1, this.scrolling = !1, this.internal = !1, document.body.classList.remove("indiana-dragging"), this.forceUpdate();
    }, o.prototype.getRef = function(t) {
        [
            this.container,
            this.props.innerRef
        ].forEach(function(e) {
            e && ("function" == typeof e ? e(t) : e.current = t);
        });
    }, o.prototype.render = function() {
        var e = this.props, n = e.children, o = e.draggingClassName, r = e.className, s = e.style, l = e.hideScrollbars, a = e.component;
        return (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(a, {
            className: $f9ff4343296b19bf$var$i(r, this.pressed && o, $f9ff4343296b19bf$var$c({
                dragging: this.pressed,
                "hide-scrollbars": l,
                "native-scroll": this.isMobile
            })),
            style: s,
            ref: this.getRef,
            onScroll: this.onScroll
        }, n);
    }, o.defaultProps = {
        nativeMobileScroll: !0,
        hideScrollbars: !0,
        activationDistance: 10,
        vertical: !0,
        horizontal: !0,
        stopPropagation: !1,
        style: {},
        component: "div",
        buttons: [
            0
        ]
    }, o;
}((0, $5FkrB.PureComponent));
var $f9ff4343296b19bf$export$2e2bcd8739ae039 = $f9ff4343296b19bf$var$p;



var $kqp0i = parcelRequire("kqp0i");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");
/* button-base.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $kqp0i = parcelRequire("kqp0i");

var $1Vcia = parcelRequire("1Vcia");

var $970q7 = parcelRequire("970q7");

var $5FkrB = parcelRequire("5FkrB");
/* index.tsx generated by @compiled/babel-plugin v0.38.1 */ parcelRequire("5FkrB");


var $Pd8py = parcelRequire("Pd8py");
var $51c2ad1cc5d37be6$var$strictApi = (0, $Pd8py.createStrictAPI)();
var $51c2ad1cc5d37be6$export$dbf350e5966cf602 = $51c2ad1cc5d37be6$var$strictApi.css;
var $51c2ad1cc5d37be6$export$eb1ecd84a24ee424 = $51c2ad1cc5d37be6$var$strictApi.cssMap;
$51c2ad1cc5d37be6$var$strictApi.cssMap;
var $51c2ad1cc5d37be6$export$a274e22fb40f762e = $51c2ad1cc5d37be6$var$strictApi.cx;
var $51c2ad1cc5d37be6$var$XCSSProp = $51c2ad1cc5d37be6$var$strictApi.XCSSProp; // This is to mitigate local TS error TS2315: Type 'StrictXCSSProp' is not generic.
 // Currently for some reason tsc is generating malformed .d.ts in local dev environment, below change fixes it
 /**
 * ## StrictXCSSProp
 *
 * Declare styles your component takes with all other styles marked as violations
 * by the TypeScript compiler. There are two primary use cases for xcss prop:
 *
 * - safe style overrides
 * - inverting style declarations
 *
 * Interverting style declarations is interesting for platform teams as
 * it means apps only pay for styles they use as they're now the ones who declare
 * the styles!
 *
 * The {@link StrictXCSSProp} type has generics two of which must be defined — use to explicitly
 * set what you want to maintain as API. Use {@link XCSSAllProperties} and {@link XCSSAllPseudos}
 * to enable all properties and pseudos.
 *
 * The third generic is used to declare what properties and pseudos should be required.
 *
 * ```tsx
 * interface MyComponentProps {
 *   // Color is accepted, all other properties / pseudos are considered violations.
 *   xcss?: StrictXCSSProp<'color', never>;
 *
 *   // Only background color and hover pseudo are accepted.
 *   xcss?: StrictXCSSProp<'backgroundColor', '&:hover'>;
 *
 *   // All properties are accepted, all pseudos are considered violations.
 *   xcss?: StrictXCSSProp<XCSSAllProperties, never>;
 *
 *   // All properties are accepted, only the hover pseudo is accepted.
 *   xcss?: StrictXCSSProp<XCSSAllProperties, '&:hover'>;
 *
 *   // The xcss prop is required as well as the color property. No pseudos are required.
 *   xcss: StrictXCSSProp<
 *     XCSSAllProperties,
 *     '&:hover',
 *     { requiredProperties: 'color', requiredPseudos: never }
 *   >;
 * }
 *
 * function MyComponent({ xcss }: MyComponentProps) {
 *   return <div css={{ color: 'var(--ds-text-danger)' }} className={xcss} />
 * }
 * ```
 *
 * The xcss prop works with static inline objects and the [cssMap](https://compiledcssinjs.com/docs/api-cssmap) API.
 *
 * ```jsx
 * // Declared as an inline object
 * <Component xcss={{ color: 'var(--ds-text)' }} />
 *
 * // Declared with the cssMap API
 * const styles = cssMap({ text: { color: 'var(--ds-text)' } });
 * <Component xcss={styles.text} />
 * ```
 *
 * To concatenate and conditonally apply styles use the {@link cssMap} and {@link cx} functions.
 */ 



var $iO8GM = parcelRequire("iO8GM");

var $gpUQB = parcelRequire("gpUQB");

var $h8qvJ = parcelRequire("h8qvJ");

var $dU8Y3 = parcelRequire("dU8Y3");
/* pressable.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $kqp0i = parcelRequire("kqp0i");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");

/**
 * This length includes the underscore,
 * e.g. `"_1s4A"` would be a valid atomic group hash.
 */ const $458e520941ef4f54$var$ATOMIC_GROUP_LENGTH = 5;
function $458e520941ef4f54$export$2e2bcd8739ae039(classNames) {
    // Shortcut: nothing to do
    if (!classNames.length) return;
    // Shortcut: don't need to do anything if we only have a single classname
    if (classNames.length === 1 && classNames[0] && // checking to see if `classNames[0]` is a string that contains other classnames
    !classNames[0].includes(' ')) return classNames[0];
    // Using an object rather than a `Map` as it performed better in our benchmarks.
    // Would be happy to move to `Map` if it proved to be better under real conditions.
    const map = {};
    // Note: using loops to minimize iterations over the collection
    for (const value of classNames){
        // Exclude all falsy values, which leaves us with populated strings
        if (!value) continue;
        // a `value` can contain multiple classnames
        const list = value.split(' ');
        for (const className of list){
            /**
             * For atomic style classnames: the `key` is the `group`
             *
             * - Later atomic classnames with the same `group` will override earlier ones
             *   (which is what we want).
             * - Assumes atomic classnames are the only things that start with `_`
             * - Could use a regex to ensure that atomic classnames are structured how we expect,
             *   but did not add that for now as it did slow things down a bit.
             *
             * For other classnames: the `key` is the whole classname
             * - Okay to remove duplicates as doing so does not impact specificity
             *
             * */ const key = className.startsWith('_') ? className.slice(0, $458e520941ef4f54$var$ATOMIC_GROUP_LENGTH) : className;
            map[key] = className;
        }
    }
    /**
     * We are converting the `map` into a string.
     *
     * The simple way to do this would be `Object.values(map).join(' ')`.
     * However, the approach below performs 10%-20% better in benchmarks.
     *
     * For `ax()` it feels right to squeeze as much runtime performance out as we can.
     */ let result = '';
    for(const key in map)result += map[key] + ' ';
    // If we have an empty string, then our `map` was empty.
    if (!result) return;
    // remove last " " from the result (we added " " at the end of every value)
    return result.trimEnd();
}


const $2647dcfef1dfe71b$export$a274e22fb40f762e = (...styles)=>{
    // At runtime TStyles is resolved down to strings, but not at compile time.
    // We circumvent the type system here because of that.
    const actualStyles = styles;
    // The output should be a union type of passed in styles. This ensures the call
    // site of xcss prop can raise violations when disallowed styles have been passed.
    return (0, $458e520941ef4f54$export$2e2bcd8739ae039)(actualStyles);
};



var $25nEq = parcelRequire("25nEq");

var $5FkrB = parcelRequire("5FkrB");

var $dLGML = parcelRequire("dLGML");

var $fC8ib = parcelRequire("fC8ib");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $kIXpt = parcelRequire("kIXpt");

var $cYPzS = parcelRequire("cYPzS");

var $lwlXp = parcelRequire("lwlXp");

var $eyuDe = parcelRequire("eyuDe");

var $25nEq = parcelRequire("25nEq");

var $ekGgq = parcelRequire("ekGgq");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $25nEq = parcelRequire("25nEq");
function $506ce1a15eca601f$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $506ce1a15eca601f$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $506ce1a15eca601f$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $506ce1a15eca601f$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $506ce1a15eca601f$export$ad4be5c2ec28cecf = function isAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $506ce1a15eca601f$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === 'AnalyticsEvent';
};
var $506ce1a15eca601f$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function AnalyticsEvent(props) {
        var _this = this;
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, AnalyticsEvent);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "_isAnalyticsEvent", true);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "clone", function() {
            // just a shallow clone, don't change sub refs unless you want to
            // affect the original's too
            var payload = $506ce1a15eca601f$var$_objectSpread({}, _this.payload);
            return new AnalyticsEvent({
                payload: payload
            });
        });
        this.payload = props.payload;
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(AnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (typeof updater === 'function') this.payload = updater(this.payload);
                if ((0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(updater) === 'object') this.payload = $506ce1a15eca601f$var$_objectSpread($506ce1a15eca601f$var$_objectSpread({}, this.payload), updater);
                return this;
            }
        }
    ]);
}();


function $641d3b73eba6c901$var$_callSuper(t, o, e) {
    return o = (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(o), (0, (/*@__PURE__*/$parcel$interopDefault($kIXpt)))(t, $641d3b73eba6c901$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(t).constructor) : o.apply(t, e));
}
function $641d3b73eba6c901$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($641d3b73eba6c901$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $641d3b73eba6c901$var$_superPropGet(t, o, e, r) {
    var p = (0, (/*@__PURE__*/$parcel$interopDefault($lwlXp)))((0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(1 & r ? t.prototype : t), o, e);
    return 2 & r && "function" == typeof p ? function(t) {
        return p.apply(e, t);
    } : p;
}
var $641d3b73eba6c901$export$35f8383928ba8d7 = function isUIAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $641d3b73eba6c901$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isUIAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === 'UIAnalyticsEvent';
};
var $641d3b73eba6c901$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_AnalyticsEvent) {
    function UIAnalyticsEvent(props) {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, UIAnalyticsEvent);
        _this = $641d3b73eba6c901$var$_callSuper(this, UIAnalyticsEvent, [
            props
        ]);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "_isUIAnalyticsEvent", true);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "clone", function() {
            if (_this.hasFired) return null;
            var context = (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(_this.context);
            var handlers = (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(_this.handlers);
            /**
       * A hacky "deep clone" of the object. This is limited in that it wont
       * support functions, regexs, Maps, Sets, etc, but none of those need to
       * be represented in our payload.
       */ var payload = JSON.parse(JSON.stringify(_this.payload));
            return new UIAnalyticsEvent({
                context: context,
                handlers: handlers,
                payload: payload
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "fire", function(channel) {
            if (_this.hasFired) return;
            _this.handlers.forEach(function(handler) {
                return handler(_this, channel);
            });
            _this.hasFired = true;
        });
        _this.context = props.context || [];
        _this.handlers = props.handlers || [];
        _this.hasFired = false;
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($eyuDe)))(UIAnalyticsEvent, _AnalyticsEvent);
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(UIAnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (this.hasFired) return this;
                return $641d3b73eba6c901$var$_superPropGet(UIAnalyticsEvent, "update", this, 3)([
                    updater
                ]);
            }
        }
    ]);
}((0, $506ce1a15eca601f$export$2e2bcd8739ae039));



var $5FkrB = parcelRequire("5FkrB");

var $iyyOp = parcelRequire("iyyOp");
var $700e2181b4577d30$export$d1f587f82ad51c4 = function useAnalyticsContext() {
    return (0, $5FkrB.useContext)((0, $iyyOp.default));
};


function $51e88b9fa4d8f8fc$export$5bf35293e545f20c() {
    var analyticsContext = (0, $700e2181b4577d30$export$d1f587f82ad51c4)();
    var createAnalyticsEvent = (0, $dLGML.useCallbackOne)(function(payload) {
        return new (0, $641d3b73eba6c901$export$2e2bcd8739ae039)({
            context: analyticsContext.getAtlaskitAnalyticsContext(),
            handlers: analyticsContext.getAtlaskitAnalyticsEventHandlers(),
            payload: payload
        });
    }, [
        analyticsContext
    ]);
    return {
        createAnalyticsEvent: createAnalyticsEvent
    };
}



var $5FkrB = parcelRequire("5FkrB");
var $11128bf676f27053$export$1d27a74659855e44 = function useTrackedRef(value) {
    var ref = (0, $5FkrB.useRef)(value);
    ref.current = value;
    return ref;
};


function $f1b63fd217f30033$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $f1b63fd217f30033$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $f1b63fd217f30033$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $f1b63fd217f30033$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $f1b63fd217f30033$export$a4687b0234b40e28(_ref) {
    var fn = _ref.fn, action = _ref.action, componentName = _ref.componentName, actionSubject = _ref.actionSubject, packageName = _ref.packageName, packageVersion = _ref.packageVersion, analyticsData = _ref.analyticsData;
    var _useAnalyticsEvents = (0, $51e88b9fa4d8f8fc$export$5bf35293e545f20c)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
    // We put analyticsData and fn in a ref so that we don't need to break
    // memoization.
    // Generally these could be defined by consumers inline
    // and so we do this to avoid breaking memoization of useCallback
    var dataRef = (0, $11128bf676f27053$export$1d27a74659855e44)(analyticsData);
    var fnRef = (0, $11128bf676f27053$export$1d27a74659855e44)(fn);
    var handler = (0, $5FkrB.useCallback)(function(value) {
        var analyticsEvent = createAnalyticsEvent({
            action: action,
            actionSubject: actionSubject || componentName,
            attributes: {
                componentName: componentName,
                packageName: packageName,
                packageVersion: packageVersion
            }
        });
        // To avoid wrapping this component in AnalyticsContext we manually
        // push the parent context's meta data into the context.
        // Note: this new 'context'
        var context = $f1b63fd217f30033$var$_objectSpread({
            componentName: componentName,
            packageName: packageName,
            packageVersion: packageVersion
        }, dataRef.current);
        analyticsEvent.context.push(context);
        // fire an event on the atlaskit channel
        var clone = analyticsEvent.clone();
        if (clone) clone.fire('atlaskit');
        fnRef.current(value, analyticsEvent);
    }, [
        // These are strings and won't change
        action,
        componentName,
        actionSubject,
        packageName,
        packageVersion,
        // This function is memoized in the context
        createAnalyticsEvent,
        // these are a stable ref because of the useTrackedRef hook
        dataRef,
        fnRef
    ]);
    return handler;
}


function $d3348e8cb36d7199$var$testPlatform(re) {
    var _userAgentData;
    return typeof window !== 'undefined' && window.navigator != null ? re.test(((_userAgentData = window.navigator['userAgentData']) === null || _userAgentData === void 0 ? void 0 : _userAgentData.platform) || window.navigator.platform) : false;
}
function $d3348e8cb36d7199$var$isIPhone() {
    return $d3348e8cb36d7199$var$testPlatform(/^iPhone/i);
}
function $d3348e8cb36d7199$var$isMac() {
    return $d3348e8cb36d7199$var$testPlatform(/^Mac/i);
}
function $d3348e8cb36d7199$var$isIPad() {
    return $d3348e8cb36d7199$var$testPlatform(/^iPad/i) || // iPadOS 13 lies and says it's a Mac, but we can distinguish by detecting touch support.
    $d3348e8cb36d7199$var$isMac() && navigator.maxTouchPoints > 1;
}
function $d3348e8cb36d7199$var$isIOS() {
    return $d3348e8cb36d7199$var$isIPhone() || $d3348e8cb36d7199$var$isIPad();
}
function $d3348e8cb36d7199$export$95df08bae54cb4df() {
    if (typeof window !== 'undefined' && window.navigator != null) {
        var _window$navigator$use;
        var ua = (_window$navigator$use = window.navigator.userAgent) === null || _window$navigator$use === void 0 ? void 0 : _window$navigator$use.toLowerCase();
        return ua ? ua.includes('safari') && !ua.includes('chrome') : false;
    }
    return false;
}
function $d3348e8cb36d7199$export$e1865c3bedcd822b() {
    return $d3348e8cb36d7199$var$isMac() || $d3348e8cb36d7199$var$isIOS();
}


/**
 * An empty function which does nothing.
 */ function $3c132a730ba9e0f2$export$2e2bcd8739ae039() {}



var $eqVaP = parcelRequire("eqVaP");
/* focusable.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $kqp0i = parcelRequire("kqp0i");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");

var $f3537773a2f23e62$var$_excluded = [
    "as",
    "children",
    "isInset",
    "testId",
    "style",
    "xcss"
], $f3537773a2f23e62$var$_excluded2 = [
    "className"
];
var $f3537773a2f23e62$var$focusRingStyles = null;
var $f3537773a2f23e62$var$insetFocusRingStyles = null;
/**
 * __Focus ring__
 *
 * A focus ring visually indicates the currently focused item.
 *
 */ var $f3537773a2f23e62$var$Focusable = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? 'button' : _ref$as, children = _ref.children, isInset = _ref.isInset, testId = _ref.testId, style = _ref.style, xcss = _ref.xcss, htmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $f3537773a2f23e62$var$_excluded);
    // This is to remove className from safeHtmlAttributes
    // @ts-ignore -- not using expect since it causes issues with help-center local consumption - className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(htmlAttributes, $f3537773a2f23e62$var$_excluded2);
    return /*#__PURE__*/ $5FkrB.createElement(Component, (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, safeHtmlAttributes, {
        // @ts-ignore Expression produces a union type that is too complex to represent. We may be able to narrow the type here but unsure.
        ref: ref,
        className: (0, $458e520941ef4f54$export$2e2bcd8739ae039)([
            "_ymio1r31 _ypr0glyw _zcxs1o36 _mizu194a _1ah3dkaa _ra3xnqa1 _128mdkaa _1cvmnqa1 _4davt94y",
            isInset && "_1ah31gjf _2mwq1gjf",
            xcss
        ]),
        style: style,
        "data-testid": testId
    }), children);
});
var $f3537773a2f23e62$export$2e2bcd8739ae039 = $f3537773a2f23e62$var$Focusable;


var $6dbbe01da48ec968$var$_excluded = [
    "children",
    "isDisabled",
    "type",
    "onClick",
    "interactionName",
    "componentName",
    "analyticsContext",
    "style",
    "testId",
    "xcss",
    "tabIndex"
], $6dbbe01da48ec968$var$_excluded2 = [
    "className"
];
var $6dbbe01da48ec968$var$styles = {
    root: "_19itglyw _vchhusvi _r06hglyw _80omtlke",
    disabled: "_80om13gf"
};
/**
 * __Pressable__
 *
 * A primitive for building custom buttons.
 *
 * - [Examples](https://atlassian.design/components/primitives/pressable/examples)
 * - [Code](https://atlassian.design/components/primitives/pressable/code)
 * - [Usage](https://atlassian.design/components/primitives/pressable/usage)
 */ var $6dbbe01da48ec968$var$Pressable = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function(_ref, ref) {
    var children = _ref.children, isDisabled = _ref.isDisabled, _ref$type = _ref.type, type = _ref$type === void 0 ? 'button' : _ref$type, _ref$onClick = _ref.onClick, providedOnClick = _ref$onClick === void 0 ? (0, $3c132a730ba9e0f2$export$2e2bcd8739ae039) : _ref$onClick, interactionName = _ref.interactionName, componentName = _ref.componentName, analyticsContext = _ref.analyticsContext, style = _ref.style, testId = _ref.testId, xcss = _ref.xcss, tabIndex = _ref.tabIndex, htmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $6dbbe01da48ec968$var$_excluded);
    var interactionContext = (0, $5FkrB.useContext)((0, $eqVaP.default));
    var handleClick = (0, $5FkrB.useCallback)(function(e, analyticsEvent) {
        interactionContext && interactionContext.tracePress(interactionName, e.timeStamp);
        providedOnClick(e, analyticsEvent);
    }, [
        providedOnClick,
        interactionContext,
        interactionName
    ]);
    var onClick = (0, $f1b63fd217f30033$export$a4687b0234b40e28)({
        fn: handleClick,
        action: 'clicked',
        componentName: componentName || 'Pressable',
        packageName: "@atlaskit/primitives",
        packageVersion: "0.0.0-development",
        analyticsData: analyticsContext,
        actionSubject: 'button'
    });
    // This is to remove className from safeHtmlAttributes
    // @ts-expect-error className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(htmlAttributes, $6dbbe01da48ec968$var$_excluded2);
    return /*#__PURE__*/ $5FkrB.createElement((0, $f3537773a2f23e62$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        as: "button",
        tabIndex: tabIndex !== null && tabIndex !== void 0 ? tabIndex : (0, $d3348e8cb36d7199$export$95df08bae54cb4df)() && !isDisabled ? 0 : undefined,
        style: style
    }, safeHtmlAttributes, {
        type: type,
        onClick: onClick,
        disabled: isDisabled,
        xcss: (0, $2647dcfef1dfe71b$export$a274e22fb40f762e)($6dbbe01da48ec968$var$styles.root, isDisabled && $6dbbe01da48ec968$var$styles.disabled, xcss),
        testId: testId,
        ref: ref
    }), children);
});
var $6dbbe01da48ec968$export$2e2bcd8739ae039 = $6dbbe01da48ec968$var$Pressable;




var $5FkrB = parcelRequire("5FkrB");
var $3b769c3dfe8fc954$export$4b86304b2c0d7e71 = /*#__PURE__*/ (0, $5FkrB.createContext)(undefined);
var $3b769c3dfe8fc954$export$47e2c6fdb142d947 = function useSplitButtonContext() {
    var context = (0, $5FkrB.useContext)($3b769c3dfe8fc954$export$4b86304b2c0d7e71);
    if (!context) return undefined;
    if (context.appearance === 'navigation') {
        var newContext = {
            spacing: 'default',
            appearance: 'subtle',
            isDisabled: false,
            isActiveOverSelected: false,
            isNavigationSplitButton: true,
            isHighlighted: context.isHighlighted
        };
        return newContext;
    }
    var splitButtonContext = {
        spacing: context.spacing,
        appearance: context.appearance,
        isDisabled: context.isDisabled,
        isActiveOverSelected: true,
        isNavigationSplitButton: false,
        isHighlighted: false
    };
    return splitButtonContext;
};


function $5c198466d8586d17$var$abort(event) {
    event.preventDefault();
    event.stopPropagation();
}
var $5c198466d8586d17$var$tabKeyCode = 9;
function $5c198466d8586d17$var$onKey(event) {
    // Allowing tab so that a user can move focus away
    if (event.keyCode === $5c198466d8586d17$var$tabKeyCode) return;
    $5c198466d8586d17$var$abort(event);
}
function $5c198466d8586d17$export$2e2bcd8739ae039(shouldBlockEvents, events) {
    return shouldBlockEvents ? {
        onMouseDownCapture: $5c198466d8586d17$var$abort,
        onMouseUpCapture: $5c198466d8586d17$var$abort,
        onKeyDownCapture: $5c198466d8586d17$var$onKey,
        onKeyUpCapture: $5c198466d8586d17$var$onKey,
        onTouchStartCapture: $5c198466d8586d17$var$abort,
        onTouchEndCapture: $5c198466d8586d17$var$abort,
        onPointerDownCapture: $5c198466d8586d17$var$abort,
        onPointerUpCapture: $5c198466d8586d17$var$abort,
        onClickCapture: $5c198466d8586d17$var$abort,
        // Just smashing the existing onClick for good measure
        onClick: $5c198466d8586d17$var$abort
    } : events;
}



var $5FkrB = parcelRequire("5FkrB");

function $252b241f11c62840$var$getIconSpacing(spacing) {
    switch(spacing){
        case 'compact':
            return 'small';
        default:
            return 'medium';
    }
}
function $252b241f11c62840$var$getSpinnerAppearance(_ref) {
    var appearance = _ref.appearance, isDisabled = _ref.isDisabled, isSelected = _ref.isSelected;
    if (isDisabled || isSelected) return 'inherit';
    if (appearance === 'primary' || appearance === 'danger' || appearance === 'discovery') return 'invert';
    return 'inherit';
}
function $252b241f11c62840$export$2e2bcd8739ae039(_ref2) {
    var appearance = _ref2.appearance, spacing = _ref2.spacing, isDisabled = _ref2.isDisabled, isSelected = _ref2.isSelected, testId = _ref2.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $3595ac2db996a99a$export$2e2bcd8739ae039), {
        size: $252b241f11c62840$var$getIconSpacing(spacing),
        appearance: $252b241f11c62840$var$getSpinnerAppearance({
            appearance: appearance,
            isDisabled: isDisabled,
            isSelected: isSelected
        }),
        testId: testId ? "".concat(testId, "--loading-spinner") : undefined
    });
}


var $11dd84bac22fa83e$var$_excluded = [
    "appearance",
    "autoFocus",
    "isDisabled",
    "isLoading",
    "isSelected",
    "isIconButton",
    "isCircle",
    "hasIconBefore",
    "hasIconAfter",
    "shouldFitContainer",
    "spacing",
    "ariaLabel",
    "ariaLabelledBy",
    "children",
    "interactionName",
    "onClick",
    "onMouseDown",
    "onMouseDownCapture",
    "onMouseUp",
    "onMouseUpCapture",
    "onKeyDown",
    "onKeyDownCapture",
    "onKeyUp",
    "onKeyUpCapture",
    "onTouchStart",
    "onTouchStartCapture",
    "onTouchEnd",
    "onTouchEndCapture",
    "onPointerDown",
    "onPointerDownCapture",
    "onPointerUp",
    "onPointerUpCapture",
    "onClickCapture",
    "testId",
    "analyticsContext",
    "componentName",
    "role",
    "onMouseOver",
    "onMouseOut",
    "onFocus",
    "onBlur",
    "onMouseMove",
    "type"
], $11dd84bac22fa83e$var$_excluded2 = [
    "className",
    "css",
    "as",
    "style"
];
var $11dd84bac22fa83e$var$LOADING_LABEL = ', Loading';
var $11dd84bac22fa83e$var$styles = {
    base: "_2rkofajl _11c8fhey _v5649dqc _189eidpf _1rjc12x7 _1e0c116y _vchhusvi _1bsb1wug _p12f1osq _kqswh2mm _4cvr1q9y _1bah1h6o _gy1p1b66 _1o9zidpf _4t3iviql _k48p1wq8 _y4tiutpp _bozgutpp _y3gn1h6o _s7n4nkob _14mj1kw7 _9v7aze3t _1tv3nqa1 _39yqe4h9 _11fnglyw _18postnw",
    baseT26Shape: "_2rko1qi0",
    linkDecorationUnset: "_4bfu1r31 _1hmsglyw _ajmmnqa1 _1a3b1r31 _4fprglyw _5goinqa1 _9oik1r31 _1bnxglyw _jf4cnqa1 _1nrm1r31 _c2waglyw _1iohnqa1",
    disabled: "_80om13gf _syaz1gmx _30l31gmx _9h8h1gmx",
    sharedDisabled: "_bfhk1fvb _irr31fvb _1di61fvb",
    spacingCompact: "_1rjcv77o _gy1p1b66 _4t3i1k8s _y4tiutpp _bozgutpp _s7n4nkob",
    spacingCompactT26Shape: "_2rko12b0",
    circle: "_2rko1rr0",
    fullWidth: "_1bsb1osq",
    loading: "_80om15jw",
    iconButton: "_4t3iviql _1bsbviql _y4tize3t _bozgze3t",
    iconButtonCompact: "_4t3i1k8s _1bsb1k8s",
    buttonIconBeforeWithHack: "_bozgu2gc",
    buttonIconAfterWithHack: "_y4tiu2gc",
    buttonIconBefore: "_bozgutpp _gy1p12x7",
    buttonIconAfter: "_y4tiutpp _gy1p12x7",
    splitButton: "_g0pbb4wl",
    loadingOverlay: "_1reo15vq _18m915vq _1e0c1txw _kqswstnw _4cvr1h6o _1bah1h6o _u7coze3t _152tze3t _rjxpze3t _1e02ze3t",
    navigationSplitButton: "_1bsb1tcg _bfhksm61 _y4ti12x7 _bozg12x7"
};
var $11dd84bac22fa83e$var$defaultStyles = {
    root: "_bfhksm61 _syazazsu _8l3m1l7x _aetrb3bt _1053azsu _f8pjazsu _30l3azsu _9h8hazsu",
    interactive: "_irr31dpa _30l3azsu _1di6fcek _9h8hazsu",
    disabled: "_bfhk1j28 _8l3mbk0g _irr31j28 _1di61j28"
};
var $11dd84bac22fa83e$var$primaryStyles = {
    root: "_bfhkomb0 _syaz15cr _105315cr _f8pj15cr _30l315cr _9h8h15cr",
    interactive: "_30l315cr _irr31wqm _9h8h15cr _1di617hq"
};
var $11dd84bac22fa83e$var$warningStyles = {
    root: "_bfhk1ikc _syazal3n _1053al3n _f8pjal3n _30l3al3n _9h8hal3n",
    interactive: "_30l3al3n _irr31j43 _9h8hal3n _1di6h4op"
};
var $11dd84bac22fa83e$var$dangerStyles = {
    root: "_bfhk1v7l _syaz15cr _105315cr _f8pj15cr _30l315cr _9h8h15cr",
    interactive: "_30l315cr _irr31rwk _9h8h15cr _1di6yycf"
};
var $11dd84bac22fa83e$var$discoveryStyles = {
    root: "_bfhk1vbi _syaz15cr _105315cr _f8pj15cr _30l315cr _9h8h15cr",
    interactive: "_30l315cr _irr37gr8 _9h8h15cr _1di61wu2"
};
var $11dd84bac22fa83e$var$subtleStyles = {
    root: "_bfhkqtfy _syazazsu _1053azsu _f8pjazsu _30l3azsu _9h8hazsu",
    interactive: "_irr34mfv _30l3azsu _1di619qy _9h8hazsu",
    disabled: "_bfhk1j28 _8l3mbk0g _irr31j28 _1di61j28"
};
var $11dd84bac22fa83e$var$selectedStyles = {
    root: "_bfhk15s3 _syaz1ldt _8l3mcoux _aetrb3bt _10531ldt _f8pj1ldt _30l31ldt _9h8h1ldt",
    insideSplitButton: "_1pbycs5v",
    interactive: "_irr3t71w _30l31pke _1di6yssv _9h8h1pke",
    warning: "_bfhkvdtc _syaz16q2 _30l31pke _irr3vdtc _9h8h1pke _1di6vdtc",
    danger: "_bfhkbeib _syaz1pke _30l31pke _irr3beib _9h8h1pke _1di6beib",
    discovery: "_bfhk1g49 _syaz1pke _30l31pke _irr31g49 _9h8h1pke _1di61g49"
};
/**
 * __button base__
 *
 * - Implements auto focus when enabled.
 * - Appends the `onClick` event with UFO analytics tracking.
 *
 * @private
 */ var $11dd84bac22fa83e$var$ButtonBase = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).forwardRef(// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore: to unblock React 18.2.0 -> 18.3.1 version bump in Jira
function(_ref, ref) {
    var propAppearance = _ref.appearance, _ref$autoFocus = _ref.autoFocus, autoFocus = _ref$autoFocus === void 0 ? false : _ref$autoFocus, _ref$isDisabled = _ref.isDisabled, propIsDisabled = _ref$isDisabled === void 0 ? false : _ref$isDisabled, _ref$isLoading = _ref.isLoading, isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading, _ref$isSelected = _ref.isSelected, propIsSelected = _ref$isSelected === void 0 ? false : _ref$isSelected, _ref$isIconButton = _ref.isIconButton, isIconButton = _ref$isIconButton === void 0 ? false : _ref$isIconButton, _ref$isCircle = _ref.isCircle, isCircle = _ref$isCircle === void 0 ? false : _ref$isCircle, _ref$hasIconBefore = _ref.hasIconBefore, hasIconBefore = _ref$hasIconBefore === void 0 ? false : _ref$hasIconBefore, _ref$hasIconAfter = _ref.hasIconAfter, hasIconAfter = _ref$hasIconAfter === void 0 ? false : _ref$hasIconAfter, _ref$shouldFitContain = _ref.shouldFitContainer, shouldFitContainer = _ref$shouldFitContain === void 0 ? false : _ref$shouldFitContain, _ref$spacing = _ref.spacing, propSpacing = _ref$spacing === void 0 ? 'default' : _ref$spacing, ariaLabel = _ref.ariaLabel, ariaLabelledBy = _ref.ariaLabelledBy, children = _ref.children, interactionName = _ref.interactionName, onClick = _ref.onClick, onMouseDown = _ref.onMouseDown, onMouseDownCapture = _ref.onMouseDownCapture, onMouseUp = _ref.onMouseUp, onMouseUpCapture = _ref.onMouseUpCapture, onKeyDown = _ref.onKeyDown, onKeyDownCapture = _ref.onKeyDownCapture, onKeyUp = _ref.onKeyUp, onKeyUpCapture = _ref.onKeyUpCapture, onTouchStart = _ref.onTouchStart, onTouchStartCapture = _ref.onTouchStartCapture, onTouchEnd = _ref.onTouchEnd, onTouchEndCapture = _ref.onTouchEndCapture, onPointerDown = _ref.onPointerDown, onPointerDownCapture = _ref.onPointerDownCapture, onPointerUp = _ref.onPointerUp, onPointerUpCapture = _ref.onPointerUpCapture, onClickCapture = _ref.onClickCapture, testId = _ref.testId, analyticsContext = _ref.analyticsContext, componentName = _ref.componentName, role = _ref.role, onMouseOver = _ref.onMouseOver, onMouseOut = _ref.onMouseOut, onFocus = _ref.onFocus, onBlur = _ref.onBlur, onMouseMove = _ref.onMouseMove, type = _ref.type, unsafeRest = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $11dd84bac22fa83e$var$_excluded);
    var localRef = (0, $5FkrB.useRef)(null);
    var splitButtonContext = (0, $3b769c3dfe8fc954$export$47e2c6fdb142d947)();
    var loadingLabelId = (0, $h8qvJ.useId)();
    var isSplitButton = Boolean(splitButtonContext);
    var isNavigationSplitButton = (splitButtonContext === null || splitButtonContext === void 0 ? void 0 : splitButtonContext.isNavigationSplitButton) || false;
    var isDefaultAppearanceSplitButton = (splitButtonContext === null || splitButtonContext === void 0 ? void 0 : splitButtonContext.appearance) === 'default';
    var appearance = isDefaultAppearanceSplitButton ? 'subtle' : propAppearance || (splitButtonContext === null || splitButtonContext === void 0 ? void 0 : splitButtonContext.appearance) || 'default';
    var spacing = (splitButtonContext === null || splitButtonContext === void 0 ? void 0 : splitButtonContext.spacing) || propSpacing;
    var isDisabled = (splitButtonContext === null || splitButtonContext === void 0 ? void 0 : splitButtonContext.isDisabled) || propIsDisabled;
    var isInteractive = !isDisabled && !isLoading;
    // Also treat loading buttons as disabled
    var isEffectivelyDisabled = isDisabled || isLoading;
    var isSelected = propIsSelected && !isDisabled;
    (0, $gpUQB.default)(localRef, autoFocus);
    // @ts-expect-error
    var _className = unsafeRest.className, _css = unsafeRest.css, _as = unsafeRest.as, _style = unsafeRest.style, saferRest = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(unsafeRest, $11dd84bac22fa83e$var$_excluded2);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $6dbbe01da48ec968$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, saferRest, {
        componentName: componentName || 'button',
        analyticsContext: analyticsContext,
        role: role,
        ref: (0, $iO8GM.default)([
            localRef,
            ref
        ]),
        xcss: (0, $51c2ad1cc5d37be6$export$a274e22fb40f762e)($11dd84bac22fa83e$var$styles.base, (0, $dU8Y3.fg)('platform-dst-shape-theme-default') && $11dd84bac22fa83e$var$styles.baseT26Shape, appearance === 'default' && $11dd84bac22fa83e$var$defaultStyles.root, appearance === 'default' && isInteractive && $11dd84bac22fa83e$var$defaultStyles.interactive, appearance === 'primary' && $11dd84bac22fa83e$var$primaryStyles.root, appearance === 'primary' && isInteractive && $11dd84bac22fa83e$var$primaryStyles.interactive, appearance === 'warning' && $11dd84bac22fa83e$var$warningStyles.root, appearance === 'warning' && isInteractive && $11dd84bac22fa83e$var$warningStyles.interactive, appearance === 'danger' && $11dd84bac22fa83e$var$dangerStyles.root, appearance === 'danger' && isInteractive && $11dd84bac22fa83e$var$dangerStyles.interactive, appearance === 'discovery' && $11dd84bac22fa83e$var$discoveryStyles.root, appearance === 'discovery' && isInteractive && $11dd84bac22fa83e$var$discoveryStyles.interactive, appearance === 'subtle' && $11dd84bac22fa83e$var$subtleStyles.root, appearance === 'subtle' && isInteractive && $11dd84bac22fa83e$var$subtleStyles.interactive, $11dd84bac22fa83e$var$styles.linkDecorationUnset, isSelected && $11dd84bac22fa83e$var$selectedStyles.root, isSelected && isSplitButton && $11dd84bac22fa83e$var$selectedStyles.insideSplitButton, isSelected && isInteractive && $11dd84bac22fa83e$var$selectedStyles.interactive, // TODO: remove me once we kill color fallbacks
        isSelected && appearance === 'danger' && $11dd84bac22fa83e$var$selectedStyles.danger, // TODO: remove me once we kill color fallbacks
        isSelected && appearance === 'warning' && $11dd84bac22fa83e$var$selectedStyles.warning, // TODO: remove me once we kill color fallbacks
        isSelected && appearance === 'discovery' && $11dd84bac22fa83e$var$selectedStyles.discovery, isDisabled && $11dd84bac22fa83e$var$styles.disabled, isDisabled && appearance !== 'default' && appearance !== 'subtle' && $11dd84bac22fa83e$var$styles.sharedDisabled, isDisabled && appearance === 'default' && $11dd84bac22fa83e$var$defaultStyles.disabled, isCircle && !isSplitButton && $11dd84bac22fa83e$var$styles.circle, spacing === 'compact' && $11dd84bac22fa83e$var$styles.spacingCompact, spacing === 'compact' && (0, $dU8Y3.fg)('platform-dst-shape-theme-default') && $11dd84bac22fa83e$var$styles.spacingCompactT26Shape, shouldFitContainer && $11dd84bac22fa83e$var$styles.fullWidth, hasIconBefore && !(0, $dU8Y3.fg)('platform-button-icon-spacing-cleanup') && $11dd84bac22fa83e$var$styles.buttonIconBeforeWithHack, //TODO Remove when platform-button-icon-spacing-cleanup is removed
        hasIconAfter && !(0, $dU8Y3.fg)('platform-button-icon-spacing-cleanup') && $11dd84bac22fa83e$var$styles.buttonIconAfterWithHack, //TODO Remove when platform-button-icon-spacing-cleanup is removed
        hasIconBefore && (0, $dU8Y3.fg)('platform-button-icon-spacing-cleanup') && $11dd84bac22fa83e$var$styles.buttonIconBefore, //to keep when platform-button-icon-spacing-cleanup is removed
        hasIconAfter && (0, $dU8Y3.fg)('platform-button-icon-spacing-cleanup') && $11dd84bac22fa83e$var$styles.buttonIconAfter, //to keep when platform-button-icon-spacing-cleanup is removed
        isIconButton && $11dd84bac22fa83e$var$styles.iconButton, isIconButton && spacing === 'compact' && $11dd84bac22fa83e$var$styles.iconButtonCompact, isLoading && $11dd84bac22fa83e$var$styles.loading, isSplitButton && $11dd84bac22fa83e$var$styles.splitButton, isNavigationSplitButton && $11dd84bac22fa83e$var$styles.navigationSplitButton),
        isDisabled: (0, $dU8Y3.fg)('platform-dst_fix_not_focusable_loading_button') ? isDisabled : isEffectivelyDisabled
    }, (0, $dU8Y3.fg)('platform-dst_fix_not_focusable_loading_button') && {
        'aria-live': 'polite'
    }, isLoading && (0, $dU8Y3.fg)('platform-dst_fix_not_focusable_loading_button') && {
        'aria-disabled': true
    }, {
        "aria-label": isLoading && ariaLabel && !ariaLabelledBy ? "".concat(ariaLabel, " ").concat($11dd84bac22fa83e$var$LOADING_LABEL) : ariaLabel,
        "aria-labelledby": isLoading && ariaLabelledBy ? "".concat(ariaLabelledBy, " ").concat(loadingLabelId) : ariaLabelledBy,
        onClick: onClick
    }, (0, $5c198466d8586d17$export$2e2bcd8739ae039)(isEffectivelyDisabled, {
        onMouseDownCapture: onMouseDownCapture,
        onMouseUpCapture: onMouseUpCapture,
        onKeyDownCapture: onKeyDownCapture,
        onKeyUpCapture: onKeyUpCapture,
        onTouchStartCapture: onTouchStartCapture,
        onTouchEndCapture: onTouchEndCapture,
        onPointerDownCapture: onPointerDownCapture,
        onPointerUpCapture: onPointerUpCapture,
        onClickCapture: onClickCapture
    }), {
        testId: testId,
        onMouseOver: onMouseOver,
        onFocus: onFocus,
        onMouseMove: onMouseMove,
        onBlur: onBlur,
        type: type,
        interactionName: interactionName,
        onMouseDown: onMouseDown,
        onMouseUp: onMouseUp,
        onKeyDown: onKeyDown,
        onMouseOut: onMouseOut,
        onKeyUp: onKeyUp,
        onTouchStart: onTouchStart,
        onTouchEnd: onTouchEnd,
        onPointerDown: onPointerDown,
        onPointerUp: onPointerUp
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $3b769c3dfe8fc954$export$4b86304b2c0d7e71).Provider, {
        value: undefined
    }, children, isLoading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("span", {
        className: (0, $970q7.default)([
            $11dd84bac22fa83e$var$styles.loadingOverlay
        ])
    }, (0, $252b241f11c62840$export$2e2bcd8739ae039)({
        spacing: spacing,
        appearance: appearance,
        isDisabled: isDisabled,
        isSelected: isSelected,
        testId: testId
    })), isLoading && (ariaLabelledBy || !ariaLabel) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $e3573d3717f44b5e$export$2e2bcd8739ae039), {
        id: loadingLabelId
    }, $11dd84bac22fa83e$var$LOADING_LABEL)));
});
var $11dd84bac22fa83e$export$2e2bcd8739ae039 = $11dd84bac22fa83e$var$ButtonBase;


/* content.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $970q7 = parcelRequire("970q7");

var $5FkrB = parcelRequire("5FkrB");

var $dU8Y3 = parcelRequire("dU8Y3");
var $53ad6069579b4666$var$styles = {
    text: "_1reo15vq _18m915vq _16jlkb7n _1o9zkb7n _1bto1l2s _o5721q9c",
    icon: "_1e0c1txw _16jlidpf _1o9zidpf _1wpz1h6o _1wybidpf _vwz4idpf _uiztglyw",
    common: "_v564g17y",
    fade: "_tzy4idpf",
    beforeIcon: "_1he91b66 _w795v77o",
    afterIcon: "_1he9v77o _w7951b66"
};
/**
 * __Content__
 *
 * Used for slots within a Button, including icons and text content.
 */ var $53ad6069579b4666$var$Content = function Content(_ref) {
    var children = _ref.children, _ref$type = _ref.type, type = _ref$type === void 0 ? 'text' : _ref$type, isLoading = _ref.isLoading, position = _ref.position;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("span", {
        className: (0, $970q7.default)([
            $53ad6069579b4666$var$styles.common,
            type === 'text' && $53ad6069579b4666$var$styles.text,
            type === 'icon' && $53ad6069579b4666$var$styles.icon,
            isLoading && $53ad6069579b4666$var$styles.fade,
            !(0, $dU8Y3.fg)('platform-button-icon-spacing-cleanup') && position === 'before' && $53ad6069579b4666$var$styles.beforeIcon,
            !(0, $dU8Y3.fg)('platform-button-icon-spacing-cleanup') && position === 'after' && $53ad6069579b4666$var$styles.afterIcon
        ])
    }, children);
};
var $53ad6069579b4666$export$2e2bcd8739ae039 = $53ad6069579b4666$var$Content;



var $5FkrB = parcelRequire("5FkrB");

var $dU8Y3 = parcelRequire("dU8Y3");
function $a4b6b6a5fbbf2f99$var$isIconRenderProp(func) {
    return !func.displayName && // most function components and class components have a displayName, negate them
    !func.render && // forwardRef doesn't require a display name, however it does include a render function, negate them
    typeof func === 'function' // at the very least we need to be a function
    ;
}
/**
 * __Icon renderer__
 *
 * Used to support render props with icons.
 *
 */ var $a4b6b6a5fbbf2f99$var$IconRenderer = function IconRenderer(_ref) {
    var Icon = _ref.icon;
    var isRenderProp = $a4b6b6a5fbbf2f99$var$isIconRenderProp(Icon);
    var iconProps = {
        label: '',
        color: 'currentColor',
        size: (0, $dU8Y3.fg)('platform_dst_button_chevron_sizing') ? function(iconName) {
            return iconName.startsWith('Chevron') ? 'small' : 'medium';
        } : undefined
    };
    // @ts-ignore - TS2322 TypeScript 5.9.2 upgrade
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).Fragment, null, isRenderProp ? Icon(iconProps) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(Icon, iconProps));
};
var $a4b6b6a5fbbf2f99$export$2e2bcd8739ae039 = $a4b6b6a5fbbf2f99$var$IconRenderer;


var $123ba5aab151a241$var$_excluded = [
    "analyticsContext",
    "appearance",
    "aria-label",
    "aria-labelledby",
    "autoFocus",
    "children",
    "iconAfter",
    "iconBefore",
    "interactionName",
    "isDisabled",
    "isLoading",
    "isSelected",
    "onClick",
    "onClickCapture",
    "onKeyDownCapture",
    "onKeyUpCapture",
    "onMouseDownCapture",
    "onMouseUpCapture",
    "onPointerDownCapture",
    "onPointerUpCapture",
    "onTouchEndCapture",
    "onTouchStartCapture",
    "shouldFitContainer",
    "spacing",
    "testId",
    "type"
], $123ba5aab151a241$var$_excluded2 = [
    "className",
    "css",
    "as",
    "style"
];
/**
 * __Button__
 *
 * A button triggers an event or action.
 *
 * - [Examples](https://atlassian.design/components/button/examples)
 * - [Code](https://atlassian.design/components/button/code)
 * - [Usage](https://atlassian.design/components/button/usage)
 */ var $123ba5aab151a241$var$Button = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).forwardRef(function Button(_ref, ref) {
    var analyticsContext = _ref.analyticsContext, appearance = _ref.appearance, ariaLabel = _ref['aria-label'], ariaLabelledBy = _ref['aria-labelledby'], autoFocus = _ref.autoFocus, children = _ref.children, iconAfter = _ref.iconAfter, iconBefore = _ref.iconBefore, interactionName = _ref.interactionName, isDisabled = _ref.isDisabled, _ref$isLoading = _ref.isLoading, isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading, isSelected = _ref.isSelected, onClick = _ref.onClick, onClickCapture = _ref.onClickCapture, onKeyDownCapture = _ref.onKeyDownCapture, onKeyUpCapture = _ref.onKeyUpCapture, onMouseDownCapture = _ref.onMouseDownCapture, onMouseUpCapture = _ref.onMouseUpCapture, onPointerDownCapture = _ref.onPointerDownCapture, onPointerUpCapture = _ref.onPointerUpCapture, onTouchEndCapture = _ref.onTouchEndCapture, onTouchStartCapture = _ref.onTouchStartCapture, shouldFitContainer = _ref.shouldFitContainer, spacing = _ref.spacing, testId = _ref.testId, _ref$type = _ref.type, type = _ref$type === void 0 ? 'button' : _ref$type, unsafeRest = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $123ba5aab151a241$var$_excluded);
    // @ts-expect-error
    var _className = unsafeRest.className, _css = unsafeRest.css, _as = unsafeRest.as, _style = unsafeRest.style, saferRest = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(unsafeRest, $123ba5aab151a241$var$_excluded2);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $11dd84bac22fa83e$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        analyticsContext: analyticsContext,
        ref: ref,
        appearance: appearance,
        autoFocus: autoFocus,
        isDisabled: isDisabled,
        isLoading: isLoading,
        isSelected: isSelected,
        hasIconBefore: Boolean(iconBefore),
        hasIconAfter: Boolean(iconAfter),
        shouldFitContainer: shouldFitContainer,
        spacing: spacing,
        ariaLabel: ariaLabel,
        ariaLabelledBy: ariaLabelledBy,
        onClick: onClick,
        onClickCapture: onClickCapture,
        onKeyDownCapture: onKeyDownCapture,
        onKeyUpCapture: onKeyUpCapture,
        onMouseDownCapture: onMouseDownCapture,
        onMouseUpCapture: onMouseUpCapture,
        onPointerDownCapture: onPointerDownCapture,
        onPointerUpCapture: onPointerUpCapture,
        onTouchStartCapture: onTouchStartCapture,
        onTouchEndCapture: onTouchEndCapture,
        testId: testId,
        componentName: "Button",
        type: type,
        interactionName: interactionName
    }, saferRest), iconBefore && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $53ad6069579b4666$export$2e2bcd8739ae039), {
        type: "icon",
        position: "before",
        isLoading: isLoading
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $a4b6b6a5fbbf2f99$export$2e2bcd8739ae039), {
        icon: iconBefore
    })), children && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $53ad6069579b4666$export$2e2bcd8739ae039), {
        isLoading: isLoading
    }, children), iconAfter && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $53ad6069579b4666$export$2e2bcd8739ae039), {
        type: "icon",
        position: "after",
        isLoading: isLoading
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $a4b6b6a5fbbf2f99$export$2e2bcd8739ae039), {
        icon: iconAfter
    })));
}));
$123ba5aab151a241$var$Button.displayName = 'Button';
var $123ba5aab151a241$export$2e2bcd8739ae039 = $123ba5aab151a241$var$Button;


var $kqp0i = parcelRequire("kqp0i");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");

var $iO8GM = parcelRequire("iO8GM");

var $kqp0i = parcelRequire("kqp0i");

var $iYJcE = parcelRequire("iYJcE");

var $25nEq = parcelRequire("25nEq");

var $5FkrB = parcelRequire("5FkrB");

var $7QpUe = parcelRequire("7QpUe");

var $25nEq = parcelRequire("25nEq");

var $5FkrB = parcelRequire("5FkrB");


function $05a56ef091e45a2e$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $05a56ef091e45a2e$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $05a56ef091e45a2e$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $05a56ef091e45a2e$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $05a56ef091e45a2e$export$1a04351537078b55(_ref) {
    var fn = _ref.fn, action = _ref.action, componentName = _ref.componentName, packageName = _ref.packageName, packageVersion = _ref.packageVersion, analyticsData = _ref.analyticsData;
    var _useAnalyticsEvents = (0, $57689e08a4ac98d0$export$5bf35293e545f20c)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
    // We put analyticsData and fn in a ref so that we don't need to break
    // memoization.
    // Generally these could be defined by consumers inline
    // and so we do this to avoid breaking memoization of useCallback
    var dataRef = (0, $bc093c0471a9c62c$export$1d27a74659855e44)(analyticsData);
    var fnRef = (0, $bc093c0471a9c62c$export$1d27a74659855e44)(fn);
    var handler = (0, $5FkrB.useCallback)(function() {
        var analyticsEvent = createAnalyticsEvent({
            action: action,
            actionSubject: componentName,
            attributes: {
                componentName: componentName,
                packageName: packageName,
                packageVersion: packageVersion
            }
        });
        // To avoid wrapping this component in AnalyticsContext we manually
        // push the parent context's meta data into the context.
        // Note: this new 'context'
        var context = $05a56ef091e45a2e$var$_objectSpread({
            componentName: componentName,
            packageName: packageName,
            packageVersion: packageVersion
        }, dataRef.current);
        analyticsEvent.context.push(context);
        // fire an event on the atlaskit channel
        var clone = analyticsEvent.clone();
        if (clone) clone.fire('atlaskit');
        fnRef.current(analyticsEvent);
    }, [
        // These are strings and won't change
        action,
        componentName,
        packageName,
        packageVersion,
        // This function is memoized in the context
        createAnalyticsEvent,
        // these are a stable ref because of the useTrackedRef hook
        dataRef,
        fnRef
    ]);
    return handler;
}



var $eVb4V = parcelRequire("eVb4V");

var $hy47X = parcelRequire("hy47X");

var $3UUXy = parcelRequire("3UUXy");

var $iUCre = parcelRequire("iUCre");

var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");
/**
 * Internally we will be playing with an element that will always have a key defined.
 */ /**
 * Internal data passed to child motions.
 */ // We define empty context here so the object doesn't change.
var $86260cff212ffed2$var$emptyContext = {
    // Motions will always appear if not inside a exiting persistence component.
    appear: true,
    isExiting: false
};
/**
 * __Exiting context__
 *
 * An exiting context.
 */ var $86260cff212ffed2$var$ExitingContext = /*#__PURE__*/ (0, $5FkrB.createContext)($86260cff212ffed2$var$emptyContext);
/**
 * This method will wrap any React element with a context provider. We're using context (instead of
 * cloneElement) so we can communicate between multiple elements without the need of prop drilling
 * (results in a better API for consumers).
 */ var $86260cff212ffed2$var$wrapChildWithContextProvider = function wrapChildWithContextProvider(child) {
    var value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $86260cff212ffed2$var$emptyContext;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement($86260cff212ffed2$var$ExitingContext.Provider, {
        key: "".concat(child.key, "-provider"),
        value: value
    }, child);
};
/**
 * This function will convert all children types to an array while also filtering out non-valid React elements.
 */ var $86260cff212ffed2$var$childrenToArray = function childrenToArray(children) {
    var childrenAsArray = [];
    // We convert children to an array using this helper method as it will add keys to children that do not
    // have them, such as when we have hardcoded children that are conditionally rendered.
    (0, $5FkrB.Children).toArray(children).forEach(function(child) {
        // We ignore any boolean children to make our code a little more simple later on,
        // and also filter out any falsies (empty strings, nulls, and undefined).
        if (typeof child !== 'boolean' && Boolean(child)) // Children WILL have a key after being forced into an array using the React.Children helper.
        childrenAsArray.push(child);
    });
    return childrenAsArray;
};
var $86260cff212ffed2$var$spliceNewElementsIntoPrevious = function spliceNewElementsIntoPrevious(current, previous) {
    var splicedChildren = previous.concat([]);
    var previousMap = $86260cff212ffed2$var$childrenToObj(previous);
    for(var i = 0; i < current.length; i++){
        var child = current[i];
        var childIsNew = !previousMap[child.key];
        if (childIsNew) // This will insert the new element after the previous element.
        splicedChildren.splice(i + 1, 0, child);
    }
    return splicedChildren;
};
var $86260cff212ffed2$var$childrenToObj = function childrenToObj(children) {
    return children.reduce(function(acc, child) {
        acc[child.key] = child;
        return acc;
    }, {});
};
var $86260cff212ffed2$var$getMissingKeys = function getMissingKeys(current, previous) {
    var currentMapKeys = new Set(current.map(function(child) {
        return child.key;
    }));
    var missing = new Set();
    for(var i = 0; i < previous.length; i++){
        var element = previous[i];
        var _key = element.key;
        if (!currentMapKeys.has(_key)) missing.add(_key);
    }
    return missing;
};
/**
 * How does this component work?
 *
 * It looks at changes in its children to see what is removed.
 *
 * If a child is removed it clones it and wraps it with context providing an `onFinish` callback.
 *
 * The cloned child will call the `onFinish` when it finishes its exit animation,
 * which lets `ExitingPersistence` know to stop rendering it.
 */ /**
 * __ExitingPersistence__
 *
 * Useful for enabling elements to persist and animate away when they are removed from the DOM.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/motion/docs/entering-motions)
 */ var $86260cff212ffed2$var$ExitingPersistence = /*#__PURE__*/ (0, $5FkrB.memo)(function(_ref) {
    var _ref$appear = _ref.appear, appear = _ref$appear === void 0 ? false : _ref$appear, children = _ref.children, exitThenEnter = _ref.exitThenEnter;
    var _useState = (0, $5FkrB.useState)([
        null,
        children
    ]), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), stateChildren = _useState2[0], setChildren = _useState2[1];
    var _useState3 = (0, $5FkrB.useState)([]), _useState4 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState3, 2), exitingChildren = _useState4[0], setExitingChildren = _useState4[1];
    var _useState5 = (0, $5FkrB.useState)(function() {
        return {
            appear: appear,
            isExiting: false
        };
    }), _useState6 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState5, 2), defaultContext = _useState6[0], setDefaultContext = _useState6[1];
    (0, $5FkrB.useEffect)(function() {
        if (!defaultContext.appear) setDefaultContext({
            appear: true,
            isExiting: false
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    /**
   * NOTE: This is a workaround for the test case written in Jira where the stateChildren is a boolean value because
   * useState is mocked to return a boolean value.
   */ if (typeof stateChildren === 'boolean') return children;
    var _stateChildren = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(stateChildren, 2), previousChildren = _stateChildren[0], currentChildren = _stateChildren[1];
    var previous = $86260cff212ffed2$var$childrenToArray(previousChildren);
    var current = $86260cff212ffed2$var$childrenToArray(currentChildren);
    if (currentChildren !== children) setChildren([
        currentChildren,
        children
    ]);
    var missingKeys = $86260cff212ffed2$var$getMissingKeys(current, previous);
    var isSomeChildRemoved = !!missingKeys.size;
    var visibleChildren = current;
    if (isSomeChildRemoved) visibleChildren = $86260cff212ffed2$var$spliceNewElementsIntoPrevious(current, previous);
    if (exitThenEnter) {
        if (exitingChildren.length) visibleChildren = exitingChildren;
        else {
            var nextExitingChildren = visibleChildren.filter(function(child) {
                return missingKeys.has(child.key);
            });
            if (nextExitingChildren.length) setExitingChildren(nextExitingChildren);
        }
    }
    if (missingKeys.size) visibleChildren = visibleChildren.map(function(child) {
        var isExiting = missingKeys.has(child.key);
        return $86260cff212ffed2$var$wrapChildWithContextProvider(child, {
            appear: true,
            isExiting: isExiting,
            onFinish: isExiting ? function() {
                missingKeys.delete(child.key);
                if (missingKeys.size === 0) {
                    setChildren([
                        null,
                        children
                    ]);
                    setExitingChildren([]);
                }
            } : undefined
        });
    });
    else visibleChildren = visibleChildren.map(function(child) {
        return $86260cff212ffed2$var$wrapChildWithContextProvider(child, defaultContext);
    });
    return visibleChildren;
});
var $86260cff212ffed2$export$3b6f38abbdcbd000 = function useExitingPersistence() {
    return (0, $5FkrB.useContext)($86260cff212ffed2$var$ExitingContext);
};
$86260cff212ffed2$var$ExitingPersistence.displayName = 'ExitingPersistence';
var $86260cff212ffed2$export$2e2bcd8739ae039 = $86260cff212ffed2$var$ExitingPersistence;


var $5FkrB = parcelRequire("5FkrB");
/* keyframes-motion.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");

var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");

var $7QpUe = parcelRequire("7QpUe");
var $693e67aaaa2fc4d2$var$isMatchMediaAvailable = function isMatchMediaAvailable() {
    return typeof window !== 'undefined' && 'matchMedia' in window;
};
var $693e67aaaa2fc4d2$export$b7baf7667a68d87c = function isReducedMotion() {
    if (!$693e67aaaa2fc4d2$var$isMatchMediaAvailable()) return false;
    var _window$matchMedia = window.matchMedia('(prefers-reduced-motion: reduce)'), matches = _window$matchMedia.matches;
    return matches;
};
var $693e67aaaa2fc4d2$export$c537e63161742ce3 = function useIsReducedMotion() {
    var _useState = (0, $5FkrB.useState)($693e67aaaa2fc4d2$export$b7baf7667a68d87c), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), prefersReducedMotion = _useState2[0], setPrefersReducedMotion = _useState2[1];
    (0, $5FkrB.useEffect)(function() {
        if (!$693e67aaaa2fc4d2$var$isMatchMediaAvailable()) return;
        var mediaQueryList = window.matchMedia('(prefers-reduced-motion: reduce)');
        var onChange = function onChange(event) {
            return setPrefersReducedMotion(event.matches);
        };
        return (0, $7QpUe.bind)(mediaQueryList, {
            type: 'change',
            listener: onChange
        });
    }, []);
    return prefersReducedMotion;
};
var $693e67aaaa2fc4d2$export$f0f789643ba5a83c = {
    '@media (prefers-reduced-motion: reduce)': {
        animation: 'none',
        transition: 'none'
    }
};
var $693e67aaaa2fc4d2$export$ff7706047246b98b = function prefersReducedMotion() {
    return $693e67aaaa2fc4d2$export$f0f789643ba5a83c;
};


/**
 * Think of this as the motion equivalent of the @atlaskit/theme `grid()`.
 */ var $01fe14a0cb8e1a3d$export$368bacef0dacbe05 = 25;
var $01fe14a0cb8e1a3d$export$38b928a7167ce124 = {
    none: 0,
    small: 100,
    medium: 350,
    large: 700
};
/**
 * Used to multiply the initial duration for exiting motions.
 */ var $01fe14a0cb8e1a3d$var$EXITING_MOTION_MULTIPLIER = 0.5;
var $01fe14a0cb8e1a3d$export$30fa1a2e62ae150c = {
    none: $01fe14a0cb8e1a3d$export$38b928a7167ce124.none,
    small: $01fe14a0cb8e1a3d$export$38b928a7167ce124.small * $01fe14a0cb8e1a3d$var$EXITING_MOTION_MULTIPLIER,
    medium: $01fe14a0cb8e1a3d$export$38b928a7167ce124.medium * $01fe14a0cb8e1a3d$var$EXITING_MOTION_MULTIPLIER,
    large: $01fe14a0cb8e1a3d$export$38b928a7167ce124.large * $01fe14a0cb8e1a3d$var$EXITING_MOTION_MULTIPLIER
};



var $5FkrB = parcelRequire("5FkrB");
// Handle both browser and Node.js environments
var $2f171294bed54748$var$getHookDeps = function getHookDeps(opts) {
    switch(opts.cleanup){
        case 'next-effect':
            return undefined;
        case 'unmount':
        default:
            return [];
    }
};
var $2f171294bed54748$export$1775f27e7c8051ca = function useRequestAnimationFrame() {
    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        cleanup: 'unmount'
    };
    var frames = (0, $5FkrB.useRef)([]);
    (0, $5FkrB.useEffect)(function() {
        return function() {
            if (frames.current.length) {
                frames.current.forEach(function(id) {
                    return cancelAnimationFrame(id);
                });
                frames.current = [];
            }
        };
    // We dynamically set this so we either clean up on the next effect - or on unmount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, $2f171294bed54748$var$getHookDeps(opts));
    return (0, $5FkrB.useCallback)(function(handler) {
        var id = requestAnimationFrame(function(time) {
            frames.current = frames.current.filter(function(frameId) {
                return frameId !== id;
            });
            handler(time);
        });
        frames.current.push(id);
    }, []);
};
var $2f171294bed54748$export$4f34107a2b00f39c = function useSetTimeout() {
    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        cleanup: 'unmount'
    };
    var timeouts = (0, $5FkrB.useRef)([]);
    (0, $5FkrB.useEffect)(function() {
        return function() {
            if (timeouts.current.length) {
                timeouts.current.forEach(function(id) {
                    return clearTimeout(id);
                });
                timeouts.current = [];
            }
        };
    // We dynamically set this so we either clean up on the next effect - or on unmount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, $2f171294bed54748$var$getHookDeps(opts));
    return (0, $5FkrB.useCallback)(function(handler, timeout) {
        for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)args[_key - 2] = arguments[_key];
        var id = setTimeout.apply(void 0, [
            function() {
                timeouts.current = timeouts.current.filter(function(timeoutId) {
                    return timeoutId !== id;
                });
                handler();
            },
            timeout
        ].concat(args));
        timeouts.current.push(id);
    }, []);
};




var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");

var $eVb4V = parcelRequire("eVb4V");

var $5FkrB = parcelRequire("5FkrB");
var $3a026c80ce49c116$export$e5c5a5f917a5871c = typeof window === 'undefined' ? (0, $5FkrB.useEffect) : (0, $5FkrB.useLayoutEffect);


/* eslint-disable @repo/internal/react/disallow-unstable-values */ 
var $5FkrB = parcelRequire("5FkrB");
function $f9d94013d81fb6f4$export$c485849f2e393253() {
    var identifier = (0, $5FkrB.useRef)('');
    if (!identifier.current) identifier.current = '_' + (Number(String(Math.random()).slice(2)) + Date.now() + Math.round(performance.now())).toString(36);
    return identifier.current;
}


var $8e148fb96d11a76d$var$StaggeredEntranceContext = /*#__PURE__*/ (0, $5FkrB.createContext)(function() {
    return {
        isReady: true,
        delay: 0,
        ref: (0, $eVb4V.default)
    };
});
var $8e148fb96d11a76d$export$25c7213fc07ec080 = function useStaggeredEntrance() {
    var indentifier = (0, $f9d94013d81fb6f4$export$c485849f2e393253)();
    var context = (0, $5FkrB.useContext)($8e148fb96d11a76d$var$StaggeredEntranceContext);
    return context(indentifier);
};
/**
 * For a list of elements that need to animate in,
 * this should be used in conjunction with entering components.
 * This does not need Javascript to execute so it will run immediately for any SSR rendered React apps before the JS has executed.
 *
 * Will dynamically add delay to each child entering component.
 * Unfortunately all entering components _NEED_ to be a direct descendant.
 */ var $8e148fb96d11a76d$var$StaggeredEntrance = function StaggeredEntrance(_ref) {
    var children = _ref.children, column = _ref.column, _ref$columns = _ref.columns, columns = _ref$columns === void 0 ? 'responsive' : _ref$columns, _ref$delayStep = _ref.delayStep, delayStep = _ref$delayStep === void 0 ? 50 : _ref$delayStep;
    var elementRefs = (0, $5FkrB.useRef)([]);
    var indexes = [];
    var _useState = (0, $5FkrB.useState)(function() {
        if (typeof columns === 'number') // A hardcoded columns is set so bail out and set it to that!
        return columns;
        if (typeof column === 'number') // A hardcoded column is set so we will set actualColumns to be 1.
        return 1;
        // We are in "responsive" mode.
        // So we will be calculating when the Javascript executes on the client how many columns there will be.
        return 0;
    }), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), actualColumns = _useState2[0], setActualColumns = _useState2[1];
    (0, $3a026c80ce49c116$export$e5c5a5f917a5871c)(function() {
        // We want to only run this code when we are in "responsive" mode.
        // It is assumed we are in responsive mode if `columns` is "responsive",
        // we have children element refs ready to be read (i.e. if there are no children this won't run as well)
        // and finally that `actualColumns` is `0` - this is because for the first render cycle `actualColumns` will be `0` (set above)
        // and then after this layout effect runs the value for `actualColumns` will then be calculated and set.
        if (columns === 'responsive' && elementRefs.current.length && actualColumns === 0) {
            var currentTop = 0;
            var numberColumns = 0;
            if (elementRefs.current.length <= 1) {
                setActualColumns(1);
                return;
            }
            // We set the current top to the first elements.
            // We will be comparing this and incrementing the column count
            // until we hit an element that has a different offset top (or we run out of elements).
            currentTop = elementRefs.current[0] ? elementRefs.current[0].offsetTop : 0;
            for(var i = 0; i < elementRefs.current.length; i++){
                var child = elementRefs.current[i];
                if (!child) break;
                if (currentTop === child.offsetTop) {
                    numberColumns += 1;
                    if (elementRefs.current.length - 1 === i) setActualColumns(numberColumns);
                    continue;
                }
                setActualColumns(numberColumns);
                break;
            }
        }
    // We only want this effect to run once - on initial mount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement($8e148fb96d11a76d$var$StaggeredEntranceContext.Provider, {
        value: function value(id) {
            if (!indexes.includes(id)) indexes.push(id);
            var isReady = actualColumns > 0;
            var index = indexes.indexOf(id);
            var currentColumn = column || index % actualColumns;
            var currentRow = Math.floor(index / actualColumns);
            var distanceFromTopLeftElement = currentRow + currentColumn;
            // We don't want loads of elements to have the same staggered delay as it ends up looking slow for users.
            // To get around that we calculate the logarithm using `distanceFromTopLeftElement` which ends making
            // elements appear faster the further away from the top left element.
            var delay = Math.ceil(Math.log(distanceFromTopLeftElement + 1) * delayStep * 1.5) || 0;
            return {
                delay: delay,
                isReady: isReady,
                ref: function ref(element) {
                    return elementRefs.current[index] = element;
                }
            };
        }
    }, children);
};
var $8e148fb96d11a76d$export$2e2bcd8739ae039 = $8e148fb96d11a76d$var$StaggeredEntrance;


var $478c6cfa86239f89$var$zoomIn = null;
var $478c6cfa86239f89$var$zoomOut = null;
var $478c6cfa86239f89$var$fadeIn = null;
var $478c6cfa86239f89$var$fadeOut = null;
var $478c6cfa86239f89$var$fadeInFromTop = null;
var $478c6cfa86239f89$var$fadeOutFromTop = null;
var $478c6cfa86239f89$var$fadeInFromLeft = null;
var $478c6cfa86239f89$var$fadeOutFromLeft = null;
var $478c6cfa86239f89$var$fadeInFromBottom = null;
var $478c6cfa86239f89$var$fadeOutFromBottom = null;
var $478c6cfa86239f89$var$fadeInFromRight = null;
var $478c6cfa86239f89$var$fadeOutFromRight = null;
var $478c6cfa86239f89$var$fadeInFromTopConstant = null;
var $478c6cfa86239f89$var$fadeOutFromTopConstant = null;
var $478c6cfa86239f89$var$fadeInFromLeftConstant = null;
var $478c6cfa86239f89$var$fadeOutFromLeftConstant = null;
var $478c6cfa86239f89$var$fadeInFromBottomConstant = null;
var $478c6cfa86239f89$var$fadeOutFromBottomConstant = null;
var $478c6cfa86239f89$var$fadeInFromRightConstant = null;
var $478c6cfa86239f89$var$fadeOutFromRightConstant = null;
var $478c6cfa86239f89$var$slideInFromTop = null;
var $478c6cfa86239f89$var$slideOutFromTop = null;
var $478c6cfa86239f89$var$slideInFromRight = null;
var $478c6cfa86239f89$var$slideOutFromRight = null;
var $478c6cfa86239f89$var$slideInFromBottom = null;
var $478c6cfa86239f89$var$slideOutFromBottom = null;
var $478c6cfa86239f89$var$slideInFromLeft = null;
var $478c6cfa86239f89$var$slideOutFromLeft = null;
/**
 * These are props that motions should use as their external props for consumers.
 * See [FadeIn](packages/helpers/motion/src/entering/fade-in.tsx) for an example usage.
 */ /**
 * This is the base INTERNAL component used for all other entering motions.
 * This does not need Javascript to execute on the client so it will run immediately
 * for any SSR rendered React apps before the JS has executed.
 */ var $478c6cfa86239f89$var$EnteringMotion = function EnteringMotion(_ref) {
    var children = _ref.children, animationTimingFunction = _ref.animationTimingFunction, _ref$animationTimingF = _ref.animationTimingFunctionExiting, animationTimingFunctionExiting = _ref$animationTimingF === void 0 ? animationTimingFunction : _ref$animationTimingF, enteringAnimation = _ref.enteringAnimation, _ref$exitingAnimation = _ref.exitingAnimation, exitingAnimation = _ref$exitingAnimation === void 0 ? enteringAnimation : _ref$exitingAnimation, isPaused = _ref.isPaused, onFinishMotion = _ref.onFinish, _ref$duration = _ref.duration, duration = _ref$duration === void 0 ? 'large' : _ref$duration;
    var staggered = (0, $8e148fb96d11a76d$export$25c7213fc07ec080)();
    var _useExitingPersistenc = (0, $86260cff212ffed2$export$3b6f38abbdcbd000)(), isExiting = _useExitingPersistenc.isExiting, onExitFinished = _useExitingPersistenc.onFinish, appear = _useExitingPersistenc.appear;
    var setTimeout = (0, $2f171294bed54748$export$4f34107a2b00f39c)();
    var paused = isPaused || !staggered.isReady;
    var delay = isExiting ? 0 : staggered.delay;
    var state = isExiting ? 'exiting' : 'entering';
    var _useState = (0, $5FkrB.useState)(appear), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), hasAnimationStyles = _useState2[0], setHasAnimationStyles = _useState2[1];
    (0, $5FkrB.useEffect)(function() {
        // Tracking this to prevent changing state on an unmounted component
        var isCancelled = false;
        if (paused) return;
        // On initial mount if elements aren't set to animate on appear, we return early and callback
        if (!appear) {
            onFinishMotion && onFinishMotion(state);
            return;
        }
        /**
     * Updates relevant state.
     * Called when the animation is finished, or immediately with reduced motion.
     */ var onAnimationEnd = function onAnimationEnd() {
            if (state === 'exiting') // Updates the `ExitingPersistence` to remove this child
            onExitFinished === null || onExitFinished === void 0 || onExitFinished();
            if (!isCancelled) setHasAnimationStyles(false);
            onFinishMotion === null || onFinishMotion === void 0 || onFinishMotion(state);
        };
        if ((0, $693e67aaaa2fc4d2$export$b7baf7667a68d87c)()) {
            // If there is reduced motion there is no exit animation, so call this immediately
            onAnimationEnd();
            return;
        }
        // Elements may need animation styles back after initial mount (they could animate out)
        setHasAnimationStyles(true);
        // Queue `onAnimationEnd` for after the animation has finished
        setTimeout(onAnimationEnd, isExiting ? (0, $01fe14a0cb8e1a3d$export$30fa1a2e62ae150c)[duration] : (0, $01fe14a0cb8e1a3d$export$38b928a7167ce124)[duration] + delay);
        return function() {
            isCancelled = true;
        };
    // We ignore this for onFinishMotion as consumers could potentially inline the function
    // which would then trigger this effect every re-render.
    // We want to make it easier for consumers so we go down this path unfortunately.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        onExitFinished,
        state,
        isExiting,
        duration,
        delay,
        paused,
        setTimeout
    ]);
    return children({
        ref: staggered.ref,
        // @ts-expect-error: `ax` is not typed correctly
        className: hasAnimationStyles ? (0, $970q7.default)([
            (0, $970q7.default)([
                "_1o51eoah _1y0co91m _1bumglyw _sedtglyw"
            ]),
            paused && (0, $970q7.default)([
                "_1y0ctrqk"
            ]),
            duration === 'small' && (0, $970q7.default)([
                "_5sag1yx9"
            ]),
            duration === 'medium' && (0, $970q7.default)([
                "_5sag1ttt"
            ]),
            duration === 'large' && (0, $970q7.default)([
                "_5sagpwmj"
            ]),
            isExiting && duration === 'small' && (0, $970q7.default)([
                "_5sag14ed"
            ]),
            isExiting && duration === 'medium' && (0, $970q7.default)([
                "_5sagluct"
            ]),
            isExiting && duration === 'large' && (0, $970q7.default)([
                "_5sag1ttt"
            ]),
            isExiting && (0, $970q7.default)([
                "_ju255cps _1o51q7pw"
            ]),
            !isExiting && animationTimingFunction === 'linear' && (0, $970q7.default)([
                "_1pglp3kn"
            ]),
            !isExiting && animationTimingFunction === 'ease-out' && (0, $970q7.default)([
                "_1pgldkwg"
            ]),
            !isExiting && animationTimingFunction === 'ease-in' && (0, $970q7.default)([
                "_1pgl1nzg"
            ]),
            !isExiting && animationTimingFunction === 'ease-in-40-out' && (0, $970q7.default)([
                "_1pgl5y64"
            ]),
            !isExiting && animationTimingFunction === 'ease-in-60-out' && (0, $970q7.default)([
                "_1pgl1ddy"
            ]),
            !isExiting && animationTimingFunction === 'ease-in-80-out' && (0, $970q7.default)([
                "_1pglannl"
            ]),
            !isExiting && animationTimingFunction === 'ease-in-out' && (0, $970q7.default)([
                "_1pgl1fu8"
            ]),
            isExiting && animationTimingFunction === 'linear' && (0, $970q7.default)([
                "_1pglp3kn"
            ]),
            isExiting && animationTimingFunctionExiting === 'ease-out' && (0, $970q7.default)([
                "_1pgldkwg"
            ]),
            isExiting && animationTimingFunctionExiting === 'ease-in' && (0, $970q7.default)([
                "_1pgl1nzg"
            ]),
            isExiting && animationTimingFunctionExiting === 'ease-in-40-out' && (0, $970q7.default)([
                "_1pgl5y64"
            ]),
            isExiting && animationTimingFunctionExiting === 'ease-in-60-out' && (0, $970q7.default)([
                "_1pgl1ddy"
            ]),
            isExiting && animationTimingFunctionExiting === 'ease-in-80-out' && (0, $970q7.default)([
                "_1pglannl"
            ]),
            isExiting && animationTimingFunctionExiting === 'ease-in-out' && (0, $970q7.default)([
                "_1pgl1fu8"
            ]),
            (!isExiting && enteringAnimation === 'fade-in' || isExiting && exitingAnimation === 'fade-in') && (0, $970q7.default)([
                "_j7hq1cgr"
            ]),
            (!isExiting && enteringAnimation === 'fade-out' || isExiting && exitingAnimation === 'fade-out') && (0, $970q7.default)([
                "_j7hq1lln"
            ]),
            (!isExiting && enteringAnimation === 'zoom-in' || isExiting && exitingAnimation === 'zoom-in') && (0, $970q7.default)([
                "_j7hqe8p0"
            ]),
            (!isExiting && enteringAnimation === 'zoom-out' || isExiting && exitingAnimation === 'zoom-out') && (0, $970q7.default)([
                "_j7hqy6ql"
            ]),
            (!isExiting && enteringAnimation === 'slide-in-from-top' || isExiting && exitingAnimation === 'slide-in-from-top') && (0, $970q7.default)([
                "_j7hqqshu"
            ]),
            (!isExiting && enteringAnimation === 'slide-out-from-top' || isExiting && exitingAnimation === 'slide-out-from-top') && (0, $970q7.default)([
                "_j7hq7ri4"
            ]),
            (!isExiting && enteringAnimation === 'slide-in-from-right' || isExiting && exitingAnimation === 'slide-in-from-right') && (0, $970q7.default)([
                "_j7hqdfjr"
            ]),
            (!isExiting && enteringAnimation === 'slide-out-from-right' || isExiting && exitingAnimation === 'slide-out-from-right') && (0, $970q7.default)([
                "_j7hqonfj"
            ]),
            (!isExiting && enteringAnimation === 'slide-in-from-bottom' || isExiting && exitingAnimation === 'slide-in-from-bottom') && (0, $970q7.default)([
                "_j7hq1liq"
            ]),
            (!isExiting && enteringAnimation === 'slide-out-from-bottom' || isExiting && exitingAnimation === 'slide-out-from-bottom') && (0, $970q7.default)([
                "_j7hqhnf1"
            ]),
            (!isExiting && enteringAnimation === 'slide-in-from-left' || isExiting && exitingAnimation === 'slide-in-from-left') && (0, $970q7.default)([
                "_j7hq1bh1"
            ]),
            (!isExiting && enteringAnimation === 'slide-out-from-left' || isExiting && exitingAnimation === 'slide-out-from-left') && (0, $970q7.default)([
                "_j7hqj08w"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-top' || isExiting && exitingAnimation === 'fade-in-from-top') && (0, $970q7.default)([
                "_j7hq2iua"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-top' || isExiting && exitingAnimation === 'fade-out-from-top') && (0, $970q7.default)([
                "_j7hq39va"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-left' || isExiting && exitingAnimation === 'fade-in-from-left') && (0, $970q7.default)([
                "_j7hq15m2"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-left' || isExiting && exitingAnimation === 'fade-out-from-left') && (0, $970q7.default)([
                "_j7hq1yiv"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-bottom' || isExiting && exitingAnimation === 'fade-in-from-bottom') && (0, $970q7.default)([
                "_j7hq1w00"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-bottom' || isExiting && exitingAnimation === 'fade-out-from-bottom') && (0, $970q7.default)([
                "_j7hqzy3z"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-right' || isExiting && exitingAnimation === 'fade-in-from-right') && (0, $970q7.default)([
                "_j7hqpqak"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-right' || isExiting && exitingAnimation === 'fade-out-from-right') && (0, $970q7.default)([
                "_j7hq1ebg"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-top-constant' || isExiting && exitingAnimation === 'fade-in-from-top-constant') && (0, $970q7.default)([
                "_j7hqm2e2"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-top-constant' || isExiting && exitingAnimation === 'fade-out-from-top-constant') && (0, $970q7.default)([
                "_j7hq97jn"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-left-constant' || isExiting && exitingAnimation === 'fade-in-from-left-constant') && (0, $970q7.default)([
                "_j7hqovgq"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-left-constant' || isExiting && exitingAnimation === 'fade-out-from-left-constant') && (0, $970q7.default)([
                "_j7hq15do"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-bottom-constant' || isExiting && exitingAnimation === 'fade-in-from-bottom-constant') && (0, $970q7.default)([
                "_j7hq797a"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-bottom-constant' || isExiting && exitingAnimation === 'fade-out-from-bottom-constant') && (0, $970q7.default)([
                "_j7hqwo7r"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-right-constant' || isExiting && exitingAnimation === 'fade-in-from-right-constant') && (0, $970q7.default)([
                "_j7hqt8u5"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-right-constant' || isExiting && exitingAnimation === 'fade-out-from-right-constant') && (0, $970q7.default)([
                "_j7hq1pgp"
            ])
        ]) : '',
        style: {
            animationDelay: "".concat(delay, "ms")
        }
    }, state);
};
var $478c6cfa86239f89$export$2e2bcd8739ae039 = $478c6cfa86239f89$var$EnteringMotion;


var $9bd9df748b04f613$var$invertedDirection = {
    top: 'bottom',
    bottom: 'top',
    left: 'right',
    right: 'left'
};
/**
 * Props for controlling the behavior of the FadeIn animation
 */ /**
 * __FadeIn__
 *
 * Useful for fading in one or more elements.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/motion/docs/entering-motions)
 */ var $9bd9df748b04f613$var$FadeIn = function FadeIn(_ref) {
    var children = _ref.children, _ref$duration = _ref.duration, duration = _ref$duration === void 0 ? 'large' : _ref$duration, entranceDirection = _ref.entranceDirection, exitDirection = _ref.exitDirection, _ref$distance = _ref.distance, distance = _ref$distance === void 0 ? 'proportional' : _ref$distance, onFinish = _ref.onFinish, isPaused = _ref.isPaused;
    var invertedEntranceDirection = entranceDirection !== undefined ? $9bd9df748b04f613$var$invertedDirection[entranceDirection] : undefined;
    var isExitDirect = Boolean(exitDirection || invertedEntranceDirection) ? "fade-out-from-".concat(exitDirection || invertedEntranceDirection).concat(distance === 'proportional' ? '' : '-constant') : 'fade-out';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $478c6cfa86239f89$export$2e2bcd8739ae039), {
        duration: duration,
        enteringAnimation: entranceDirection ? "fade-in-from-".concat(entranceDirection).concat(distance === 'proportional' ? '' : '-constant') : 'fade-in',
        exitingAnimation: isExitDirect,
        animationTimingFunction: "ease-in-out",
        onFinish: onFinish,
        isPaused: isPaused
    }, children);
};
var $9bd9df748b04f613$export$2e2bcd8739ae039 = $9bd9df748b04f613$var$FadeIn;



var $dU8Y3 = parcelRequire("dU8Y3");

var $5K5L9 = parcelRequire("5K5L9");

var $5FkrB = parcelRequire("5FkrB");

var $dU8Y3 = parcelRequire("dU8Y3");

var $5FkrB = parcelRequire("5FkrB");

var $aLeHs = parcelRequire("aLeHs");
/* index.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $kqp0i = parcelRequire("kqp0i");

var $fL8KA = parcelRequire("fL8KA");

var $25nEq = parcelRequire("25nEq");

var $iYJcE = parcelRequire("iYJcE");

var $970q7 = parcelRequire("970q7");

var $6HG4S = parcelRequire("6HG4S");

var $5FkrB = parcelRequire("5FkrB");

var $7QpUe = parcelRequire("7QpUe");

var $dU8Y3 = parcelRequire("dU8Y3");

var $25nEq = parcelRequire("25nEq");

var $dU8Y3 = parcelRequire("dU8Y3");

var $a1YOk = parcelRequire("a1YOk");

var $3myK9 = parcelRequire("3myK9");

var $ekGgq = parcelRequire("ekGgq");

var $iYJcE = parcelRequire("iYJcE");

var $3myK9 = parcelRequire("3myK9");
var $1d7c118e55b82fd0$var$themeKinds = [
    'light',
    'dark',
    'spacing',
    'typography',
    'shape'
];
var $1d7c118e55b82fd0$var$customThemeOptions = 'UNSAFE_themeOptions';
var $1d7c118e55b82fd0$var$isThemeKind = function isThemeKind(themeKind) {
    return $1d7c118e55b82fd0$var$themeKinds.find(function(kind) {
        return kind === themeKind;
    }) !== undefined;
};
var $1d7c118e55b82fd0$var$isThemeIds = function isThemeIds(themeId) {
    return (0, $3myK9.themeIds).find(function(id) {
        return id === themeId;
    }) !== undefined;
};
var $1d7c118e55b82fd0$var$isColorMode = function isColorMode(modeId) {
    return [
        'light',
        'dark',
        'auto'
    ].includes(modeId);
};
var $1d7c118e55b82fd0$export$f19b488f7c0547ee = function themeStringToObject(themeState) {
    return themeState.split(' ')// @ts-ignore - TS1501 TypeScript 5.9.2 upgrade
    .map(function(theme) {
        return theme.split(/:([^]*)/);
    }).reduce(function(themeObject, _ref) {
        var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_ref, 2), kind = _ref2[0], id = _ref2[1];
        if (kind === 'colorMode' && $1d7c118e55b82fd0$var$isColorMode(id)) themeObject[kind] = id;
        if ($1d7c118e55b82fd0$var$isThemeKind(kind) && $1d7c118e55b82fd0$var$isThemeIds(id)) // @ts-expect-error FIXME - this is a valid ts error
        themeObject[kind] = id;
        if (kind === $1d7c118e55b82fd0$var$customThemeOptions) try {
            themeObject[$1d7c118e55b82fd0$var$customThemeOptions] = JSON.parse(id);
        } catch (_unused) {
            new Error('Invalid custom theme string');
        }
        return themeObject;
    }, {});
};
var $1d7c118e55b82fd0$export$62c37ab81302621a = function themeObjectToString(themeState) {
    return Object.entries(themeState).reduce(function(themeString, _ref3) {
        var _ref4 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_ref3, 2), kind = _ref4[0], id = _ref4[1];
        if (// colorMode theme state
        kind === 'colorMode' && typeof id === 'string' && $1d7c118e55b82fd0$var$isColorMode(id) || // custom theme state
        kind === $1d7c118e55b82fd0$var$customThemeOptions && (0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(id) === 'object' || // other theme states
        $1d7c118e55b82fd0$var$isThemeKind(kind) && typeof id === 'string' && $1d7c118e55b82fd0$var$isThemeIds(id)) return themeString + "".concat(themeString ? ' ' : '') + "".concat(kind, ":").concat((0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(id) === 'object' ? JSON.stringify(id) : id);
        return themeString;
    }, '');
};



var $7BgMu = parcelRequire("7BgMu");

var $7OC9w = parcelRequire("7OC9w");
function $6cadcf023d331d75$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $6cadcf023d331d75$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $6cadcf023d331d75$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $6cadcf023d331d75$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $6cadcf023d331d75$var$defaultColorMode = 'light';
var $6cadcf023d331d75$var$defaultContrastMode = 'no-preference';
/**
 * Server-side rendering utility. Generates the valid HTML attributes for a given theme.
 * Note: this utility does not handle automatic theme switching.
 *
 * @param {Object<string, string>} themeOptions - Theme options object
 * @param {string} themeState.colorMode Determines which color theme is applied. If set to `auto`, the theme applied will be determined by the OS setting.
 * @param {string} themeState.dark The color theme to be applied when the color mode resolves to 'dark'.
 * @param {string} themeState.light The color theme to be applied when the color mode resolves to 'light'.
 * @param {string} themeState.spacing The spacing theme to be applied.
 * @param {string} themeState.typography The typography theme to be applied.
 * @param {Object} themeState.UNSAFE_themeOptions The custom branding options to be used for custom theme generation
 *
 * @returns {Object} Object of HTML attributes to be applied to the document root
 */ var $6cadcf023d331d75$var$getThemeHtmlAttrs = function getThemeHtmlAttrs() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, _ref$colorMode = _ref.colorMode, colorMode = _ref$colorMode === void 0 ? (0, $3myK9.themeStateDefaults)['colorMode'] : _ref$colorMode, _ref$dark = _ref.dark, dark = _ref$dark === void 0 ? (0, $3myK9.themeStateDefaults)['dark'] : _ref$dark, _ref$light = _ref.light, light = _ref$light === void 0 ? (0, $3myK9.themeStateDefaults)['light'] : _ref$light, _ref$contrastMode = _ref.contrastMode, contrastMode = _ref$contrastMode === void 0 ? (0, $3myK9.themeStateDefaults)['contrastMode'] : _ref$contrastMode, _ref$shape = _ref.shape, shape = _ref$shape === void 0 ? (0, $3myK9.themeStateDefaults)['shape']() : _ref$shape, _ref$spacing = _ref.spacing, spacing = _ref$spacing === void 0 ? (0, $3myK9.themeStateDefaults)['spacing'] : _ref$spacing, _ref$typography = _ref.typography, typography = _ref$typography === void 0 ? (0, $3myK9.themeStateDefaults)['typography'] : _ref$typography, _ref$UNSAFE_themeOpti = _ref.UNSAFE_themeOptions, UNSAFE_themeOptions = _ref$UNSAFE_themeOpti === void 0 ? (0, $3myK9.themeStateDefaults)['UNSAFE_themeOptions'] : _ref$UNSAFE_themeOpti;
    var themeAttribute = (0, $1d7c118e55b82fd0$export$62c37ab81302621a)({
        dark: dark,
        light: light,
        shape: shape,
        spacing: spacing,
        typography: typography
    });
    var result = (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, (0, $a1YOk.THEME_DATA_ATTRIBUTE), themeAttribute), (0, $a1YOk.COLOR_MODE_ATTRIBUTE), colorMode === 'auto' ? $6cadcf023d331d75$var$defaultColorMode : colorMode);
    if ((0, $dU8Y3.fg)('platform_increased-contrast-themes')) result = $6cadcf023d331d75$var$_objectSpread($6cadcf023d331d75$var$_objectSpread({}, result), {}, (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, (0, $a1YOk.CONTRAST_MODE_ATTRIBUTE), contrastMode === 'auto' ? $6cadcf023d331d75$var$defaultContrastMode : contrastMode));
    if (UNSAFE_themeOptions && (0, $7BgMu.isValidBrandHex)(UNSAFE_themeOptions.brandColor)) {
        var optionString = JSON.stringify(UNSAFE_themeOptions);
        var uniqueId = (0, $7OC9w.hash)(optionString);
        result[0, $a1YOk.CUSTOM_THEME_ATTRIBUTE] = uniqueId;
    }
    return result;
};
var $6cadcf023d331d75$export$2e2bcd8739ae039 = $6cadcf023d331d75$var$getThemeHtmlAttrs;


var $25nEq = parcelRequire("25nEq");

var $fL8KA = parcelRequire("fL8KA");

var $6HG4S = parcelRequire("6HG4S");

var $dU8Y3 = parcelRequire("dU8Y3");

var $25nEq = parcelRequire("25nEq");

var $a1YOk = parcelRequire("a1YOk");

var $3myK9 = parcelRequire("3myK9");

function $1e4b65fba65a5e1e$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $1e4b65fba65a5e1e$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $1e4b65fba65a5e1e$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $1e4b65fba65a5e1e$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $1e4b65fba65a5e1e$var$isThemeColorMode = function isThemeColorMode(colorMode) {
    return (0, $3myK9.themeColorModes).find(function(mode) {
        return mode === colorMode;
    }) !== undefined;
};
var $1e4b65fba65a5e1e$var$getGlobalTheme = function getGlobalTheme() {
    if (typeof document === 'undefined') return {};
    var element = document.documentElement;
    var colorMode = element.getAttribute((0, $a1YOk.COLOR_MODE_ATTRIBUTE)) || '';
    var theme = element.getAttribute((0, $a1YOk.THEME_DATA_ATTRIBUTE)) || '';
    return $1e4b65fba65a5e1e$var$_objectSpread($1e4b65fba65a5e1e$var$_objectSpread({}, (0, $1d7c118e55b82fd0$export$f19b488f7c0547ee)(theme)), $1e4b65fba65a5e1e$var$isThemeColorMode(colorMode) && {
        colorMode: colorMode
    });
};
var $1e4b65fba65a5e1e$export$2e2bcd8739ae039 = $1e4b65fba65a5e1e$var$getGlobalTheme;



var $3myK9 = parcelRequire("3myK9");

var $7BgMu = parcelRequire("7BgMu");

var $iYJcE = parcelRequire("iYJcE");

var $dU8Y3 = parcelRequire("dU8Y3");


var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $25nEq = parcelRequire("25nEq");

var $7QpUe = parcelRequire("7QpUe");

var $a1YOk = parcelRequire("a1YOk");

var $fL8KA = parcelRequire("fL8KA");

var $6HG4S = parcelRequire("6HG4S");
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 *
 * This file contains a dynamic import for each theme this package exports.
 * Themes are loaded asynchronously at runtime to minimise the amount of CSS we send to the client.
 * This allows users to compose their themes and only use the tokens that are requested.
 * When a new theme is created, the import should automatically be added to the map
 *
 * @codegen <<SignedSource::926662cc712c2c412c8b6b4cdcd8d64f>>
 * @codegenCommand yarn build tokens
 */ 










var $db95856281fc8dae$var$themeImportsMap = {
    'light': function light() {
        return (parcelRequire("jWjO0"));
    },
    'light-future': function lightFuture() {
        return (parcelRequire("5yZ6f"));
    },
    'light-increased-contrast': function lightIncreasedContrast() {
        return (parcelRequire("6imoA"));
    },
    'dark': function dark() {
        return (parcelRequire("aKbCl"));
    },
    'dark-future': function darkFuture() {
        return (parcelRequire("gK10y"));
    },
    'dark-increased-contrast': function darkIncreasedContrast() {
        return (parcelRequire("2CkAK"));
    },
    'legacy-light': function legacyLight() {
        return (parcelRequire("ifXfp"));
    },
    'legacy-dark': function legacyDark() {
        return (parcelRequire("juzct"));
    },
    'spacing': function spacing() {
        return (parcelRequire("fkr37"));
    },
    'typography': function typography() {
        return (parcelRequire("44JHn"));
    },
    'shape': function shape() {
        return (parcelRequire("kgf22"));
    }
};
var $db95856281fc8dae$export$2e2bcd8739ae039 = $db95856281fc8dae$var$themeImportsMap;



var $a1YOk = parcelRequire("a1YOk");
var $b09026356628ae40$export$26cd7ae85c7144e5 = /*#__PURE__*/ function() {
    var _ref = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee(themeId) {
        var themeCss, style;
        return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee$(_context) {
            while(true)switch(_context.prev = _context.next){
                case 0:
                    if (!document.head.querySelector("style[".concat((0, $a1YOk.THEME_DATA_ATTRIBUTE), "=\"").concat(themeId, "\"]:not([").concat((0, $a1YOk.CUSTOM_THEME_ATTRIBUTE), "])"))) {
                        _context.next = 2;
                        break;
                    }
                    return _context.abrupt("return");
                case 2:
                    if (themeId) {
                        _context.next = 4;
                        break;
                    }
                    return _context.abrupt("return");
                case 4:
                    _context.next = 6;
                    return $b09026356628ae40$export$8a48286ed7df6720(themeId);
                case 6:
                    themeCss = _context.sent;
                    style = document.createElement('style');
                    style.textContent = themeCss;
                    style.dataset.theme = themeId;
                    document.head.appendChild(style);
                case 11:
                case "end":
                    return _context.stop();
            }
        }, _callee);
    }));
    return function loadAndAppendThemeCss(_x) {
        return _ref.apply(this, arguments);
    };
}();
var $b09026356628ae40$export$8a48286ed7df6720 = /*#__PURE__*/ function() {
    var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee2(themeId) {
        var _yield$themeImportMap, themeCss;
        return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee2$(_context2) {
            while(true)switch(_context2.prev = _context2.next){
                case 0:
                    _context2.next = 2;
                    return (0, $db95856281fc8dae$export$2e2bcd8739ae039)[themeId]();
                case 2:
                    _yield$themeImportMap = _context2.sent;
                    themeCss = _yield$themeImportMap.default;
                    return _context2.abrupt("return", themeCss);
                case 5:
                case "end":
                    return _context2.stop();
            }
        }, _callee2);
    }));
    return function loadThemeCss(_x2) {
        return _ref2.apply(this, arguments);
    };
}();
var $b09026356628ae40$export$bb1e815119d30f8b = '(prefers-color-scheme: dark)';
var $b09026356628ae40$export$8662df6937d86fcb = '(prefers-contrast: more)';


var $276a6a39b693b418$var$isMatchMediaAvailable = typeof window !== 'undefined' && 'matchMedia' in window;
/**
 * Updates the current theme when the system theme changes. Should be bound
 * to an event listener listening on the '(prefers-color-scheme: dark)' query
 * @param e The event representing a change in system theme.
 */ function $276a6a39b693b418$var$checkNativeListener(e) {
    var element = document.documentElement;
    element.setAttribute((0, $a1YOk.COLOR_MODE_ATTRIBUTE), e.matches ? 'dark' : 'light');
}
var $276a6a39b693b418$var$darkModeMql = $276a6a39b693b418$var$isMatchMediaAvailable && window.matchMedia((0, $b09026356628ae40$export$bb1e815119d30f8b));
var $276a6a39b693b418$var$ColorModeObserver = /*#__PURE__*/ function() {
    function ColorModeObserver() {
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, ColorModeObserver);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "unbindThemeChangeListener", null);
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(ColorModeObserver, [
        {
            key: "getColorMode",
            value: function getColorMode() {
                if (!$276a6a39b693b418$var$darkModeMql) return 'light';
                return $276a6a39b693b418$var$darkModeMql !== null && $276a6a39b693b418$var$darkModeMql !== void 0 && $276a6a39b693b418$var$darkModeMql.matches ? 'dark' : 'light';
            }
        },
        {
            key: "bind",
            value: function bind() {
                if ($276a6a39b693b418$var$darkModeMql && this.unbindThemeChangeListener === null) this.unbindThemeChangeListener = (0, $7QpUe.bind)($276a6a39b693b418$var$darkModeMql, {
                    type: 'change',
                    listener: $276a6a39b693b418$var$checkNativeListener
                });
            }
        },
        {
            key: "unbind",
            value: function unbind() {
                if (this.unbindThemeChangeListener) {
                    this.unbindThemeChangeListener();
                    this.unbindThemeChangeListener = null;
                }
            }
        }
    ]);
}();
/**
 * A singleton color mode observer - binds "auto" switching logic to a single `mediaQueryList` listener
 * that can be unbound by any consumer when no longer needed.
 */ var $276a6a39b693b418$var$SingletonColorModeObserver = new $276a6a39b693b418$var$ColorModeObserver();
var $276a6a39b693b418$export$2e2bcd8739ae039 = $276a6a39b693b418$var$SingletonColorModeObserver;



var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $25nEq = parcelRequire("25nEq");

var $7QpUe = parcelRequire("7QpUe");

var $a1YOk = parcelRequire("a1YOk");

var $9d613292cdbf108d$var$isMatchMediaAvailable = typeof window !== 'undefined' && 'matchMedia' in window;
/**
 * Updates the current theme when the system contrast preference changes. Should be bound
 * to an event listener listening on the '(prefers-contrast: more)' query
 * @param e The event representing a change in system theme.
 */ function $9d613292cdbf108d$var$checkNativeListener(e) {
    var element = document.documentElement;
    element.setAttribute((0, $a1YOk.CONTRAST_MODE_ATTRIBUTE), e.matches ? 'more' : 'no-preference');
}
var $9d613292cdbf108d$var$contrastModeMql = $9d613292cdbf108d$var$isMatchMediaAvailable && window.matchMedia((0, $b09026356628ae40$export$8662df6937d86fcb));
var $9d613292cdbf108d$var$ContrastModeObserver = /*#__PURE__*/ function() {
    function ContrastModeObserver() {
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, ContrastModeObserver);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "unbindContrastChangeListener", null);
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(ContrastModeObserver, [
        {
            key: "getContrastMode",
            value: function getContrastMode() {
                if (!$9d613292cdbf108d$var$contrastModeMql) return 'no-preference';
                return $9d613292cdbf108d$var$contrastModeMql !== null && $9d613292cdbf108d$var$contrastModeMql !== void 0 && $9d613292cdbf108d$var$contrastModeMql.matches ? 'more' : 'no-preference';
            }
        },
        {
            key: "bind",
            value: function bind() {
                if ($9d613292cdbf108d$var$contrastModeMql && this.unbindContrastChangeListener === null) this.unbindContrastChangeListener = (0, $7QpUe.bind)($9d613292cdbf108d$var$contrastModeMql, {
                    type: 'change',
                    listener: $9d613292cdbf108d$var$checkNativeListener
                });
            }
        },
        {
            key: "unbind",
            value: function unbind() {
                if (this.unbindContrastChangeListener) {
                    this.unbindContrastChangeListener();
                    this.unbindContrastChangeListener = null;
                }
            }
        }
    ]);
}();
/**
 * A singleton contrast mode observer - binds "auto" switching logic to a single `mediaQueryList` listener
 * that can be unbound by any consumer when no longer needed.
 */ var $9d613292cdbf108d$var$SingletonContrastModeObserver = new $9d613292cdbf108d$var$ContrastModeObserver();
var $9d613292cdbf108d$export$2e2bcd8739ae039 = $9d613292cdbf108d$var$SingletonContrastModeObserver;


function $c2c53e17eb81a691$export$2e2bcd8739ae039(themeState) {
    if (themeState.colorMode === 'auto') {
        // Set colorMode based on the user preference
        themeState.colorMode = (0, $276a6a39b693b418$export$2e2bcd8739ae039).getColorMode();
        // Bind a listener (if one doesn't already exist) to keep colorMode updated
        (0, $276a6a39b693b418$export$2e2bcd8739ae039).bind();
    } else (0, $276a6a39b693b418$export$2e2bcd8739ae039).unbind();
    if ((0, $dU8Y3.fg)('platform_increased-contrast-themes')) {
        if (themeState.contrastMode === 'auto') {
            // Set contrastMode based on the user preference
            themeState.contrastMode = (0, $9d613292cdbf108d$export$2e2bcd8739ae039).getContrastMode();
            // Bind a listener (if one doesn't already exist) to keep contrastMode updated
            (0, $9d613292cdbf108d$export$2e2bcd8739ae039).bind();
        } else (0, $9d613292cdbf108d$export$2e2bcd8739ae039).unbind();
    }
    var themeAttributes = (0, $6cadcf023d331d75$export$2e2bcd8739ae039)(themeState);
    Object.entries(themeAttributes).forEach(function(_ref) {
        var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_ref, 2), key = _ref2[0], value = _ref2[1];
        document.documentElement.setAttribute(key, value);
    });
    return function() {
        (0, $276a6a39b693b418$export$2e2bcd8739ae039).unbind();
        if ((0, $dU8Y3.fg)('platform_increased-contrast-themes')) (0, $9d613292cdbf108d$export$2e2bcd8739ae039).unbind();
    };
}



var $3dPVw = parcelRequire("3dPVw");

var $fC8ib = parcelRequire("fC8ib");

var $dU8Y3 = parcelRequire("dU8Y3");

var $iYJcE = parcelRequire("iYJcE");

var $3myK9 = parcelRequire("3myK9");
function $f7826c6a39f87072$export$2e2bcd8739ae039(themeId) {
    var _Object$entries$find;
    return (_Object$entries$find = Object.entries((0, $3myK9.default)).find(function(_ref) {
        var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_ref, 2), increasesContrastFor = _ref2[1].increasesContrastFor;
        return increasesContrastFor === themeId;
    })) === null || _Object$entries$find === void 0 ? void 0 : _Object$entries$find[1].id;
}


var $e3a60d4c8e185312$export$dd6aeb7c823fc03d = function getThemePreferences(themeState) {
    var colorMode = themeState.colorMode, contrastMode = themeState.contrastMode, dark = themeState.dark, light = themeState.light, shape = themeState.shape, spacing = themeState.spacing, typography = themeState.typography;
    var autoColorModeThemes = [
        light,
        dark
    ];
    var themePreferences = [];
    if (colorMode === 'auto') {
        if (contrastMode !== 'no-preference' && (0, $dU8Y3.fg)('platform_increased-contrast-themes')) autoColorModeThemes.forEach(function(normalTheme) {
            var increasedContrastTheme = (0, $f7826c6a39f87072$export$2e2bcd8739ae039)(normalTheme);
            if (increasedContrastTheme) autoColorModeThemes.push(increasedContrastTheme);
        });
        themePreferences.push.apply(themePreferences, autoColorModeThemes);
    } else {
        themePreferences.push(themeState[colorMode]);
        if (contrastMode !== 'no-preference' && (0, $dU8Y3.fg)('platform_increased-contrast-themes')) {
            var increasedContrastTheme = (0, $f7826c6a39f87072$export$2e2bcd8739ae039)(themeState[colorMode]);
            if (increasedContrastTheme) themePreferences.push(increasedContrastTheme);
        }
    }
    [
        shape,
        spacing,
        typography
    ].forEach(function(themeId) {
        if (themeId) themePreferences.push(themeId);
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(new Set(themePreferences));
};
var $e3a60d4c8e185312$export$5d76d7014f4a5d08 = function getThemeOverridePreferences(_themeState) {
    var themeOverridePreferences = [];
    return (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(new Set(themeOverridePreferences));
};



function $58c709afdca0347c$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $58c709afdca0347c$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $58c709afdca0347c$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $58c709afdca0347c$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $58c709afdca0347c$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $58c709afdca0347c$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $58c709afdca0347c$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $58c709afdca0347c$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $58c709afdca0347c$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $58c709afdca0347c$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}

/**
 * Sets the theme globally at runtime. This updates the `data-theme` and `data-color-mode` attributes on your page's <html> tag.
 *
 * @param {Object<string, string>} themeState The themes and color mode that should be applied.
 * @param {string} themeState.colorMode Determines which color theme is applied. If set to `auto`, the theme applied will be determined by the OS setting.
 * @param {string} themeState.contrastMode The contrast mode theme to be applied. If set to `auto`, the theme applied will be determined by the OS setting.set to `auto`, the theme applied will be determined by the OS setting.
 * @param {string} themeState.dark The color theme to be applied when the color mode resolves to 'dark'.
 * @param {string} themeState.light The color theme to be applied when the color mode resolves to 'light'.
 * @param {string} themeState.shape The shape theme to be applied.
 * @param {string} themeState.spacing The spacing theme to be applied.
 * @param {string} themeState.typography The typography theme to be applied.
 * @param {Object} themeState.UNSAFE_themeOptions The custom branding options to be used for custom theme generation
 * @param {function} themeLoader Callback function used to override the default theme loading functionality.
 *
 * @returns A Promise of an unbind function, that can be used to stop listening for changes to system theme.
 *
 * @example
 * ```
 * setGlobalTheme({colorMode: 'auto', light: 'light', dark: 'dark', spacing: 'spacing'});
 * ```
 */ var $58c709afdca0347c$var$setGlobalTheme = /*#__PURE__*/ function() {
    var _ref = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee3() {
        var nextThemeState, themeLoader, _ref2, _ref2$colorMode, colorMode, _ref2$contrastMode, contrastMode, _ref2$dark, dark, _ref2$light, light, _ref2$shape, shape, _ref2$spacing, spacing, _ref2$typography, typography, _ref2$UNSAFE_themeOpt, UNSAFE_themeOptions, themeState, themePreferences, loadingStrategy, loadingTasks, mode, attrOfMissingCustomStyles, themeOverridePreferences, _iterator, _step, themeId, autoUnbind, _args3 = arguments;
        return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee3$(_context3) {
            while(true)switch(_context3.prev = _context3.next){
                case 0:
                    nextThemeState = _args3.length > 0 && _args3[0] !== undefined ? _args3[0] : {};
                    themeLoader = _args3.length > 1 ? _args3[1] : undefined;
                    _ref2 = typeof nextThemeState === 'function' ? nextThemeState($58c709afdca0347c$var$_objectSpread($58c709afdca0347c$var$_objectSpread({}, (0, $3myK9.themeStateDefaults)), {}, {
                        typography: (0, $3myK9.themeStateDefaults)['typography'],
                        shape: (0, $3myK9.themeStateDefaults)['shape']()
                    }, (0, $1e4b65fba65a5e1e$export$2e2bcd8739ae039)())) : nextThemeState, _ref2$colorMode = _ref2.colorMode, colorMode = _ref2$colorMode === void 0 ? (0, $3myK9.themeStateDefaults)['colorMode'] : _ref2$colorMode, _ref2$contrastMode = _ref2.contrastMode, contrastMode = _ref2$contrastMode === void 0 ? (0, $3myK9.themeStateDefaults)['contrastMode'] : _ref2$contrastMode, _ref2$dark = _ref2.dark, dark = _ref2$dark === void 0 ? (0, $3myK9.themeStateDefaults)['dark'] : _ref2$dark, _ref2$light = _ref2.light, light = _ref2$light === void 0 ? (0, $3myK9.themeStateDefaults)['light'] : _ref2$light, _ref2$shape = _ref2.shape, shape = _ref2$shape === void 0 ? (0, $3myK9.themeStateDefaults)['shape']() : _ref2$shape, _ref2$spacing = _ref2.spacing, spacing = _ref2$spacing === void 0 ? (0, $3myK9.themeStateDefaults)['spacing'] : _ref2$spacing, _ref2$typography = _ref2.typography, typography = _ref2$typography === void 0 ? (0, $3myK9.themeStateDefaults)['typography'] : _ref2$typography, _ref2$UNSAFE_themeOpt = _ref2.UNSAFE_themeOptions, UNSAFE_themeOptions = _ref2$UNSAFE_themeOpt === void 0 ? (0, $3myK9.themeStateDefaults)['UNSAFE_themeOptions'] : _ref2$UNSAFE_themeOpt; // CLEANUP: Remove. This blocks application of increased contrast themes
                    // without the feature flag enabled.
                    if (!(0, $dU8Y3.fg)('platform_increased-contrast-themes')) {
                        if (light === 'light-increased-contrast') light = 'light';
                        if (dark === 'dark-increased-contrast') dark = 'dark';
                    }
                    themeState = {
                        colorMode: colorMode,
                        contrastMode: contrastMode,
                        dark: dark,
                        light: light,
                        shape: shape,
                        spacing: spacing,
                        typography: typography,
                        UNSAFE_themeOptions: themeLoader ? undefined : UNSAFE_themeOptions
                    }; // Determine what to load and loading strategy
                    themePreferences = (0, $e3a60d4c8e185312$export$dd6aeb7c823fc03d)(themeState);
                    loadingStrategy = themeLoader ? themeLoader : (0, $b09026356628ae40$export$26cd7ae85c7144e5); // Load standard themes
                    loadingTasks = themePreferences.map(/*#__PURE__*/ function() {
                        var _ref3 = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee(themeId) {
                            return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee$(_context) {
                                while(true)switch(_context.prev = _context.next){
                                    case 0:
                                        _context.next = 2;
                                        return loadingStrategy(themeId);
                                    case 2:
                                        return _context.abrupt("return", _context.sent);
                                    case 3:
                                    case "end":
                                        return _context.stop();
                                }
                            }, _callee);
                        }));
                        return function(_x) {
                            return _ref3.apply(this, arguments);
                        };
                    }()); // Load custom themes if needed
                    if (!themeLoader && UNSAFE_themeOptions && (0, $7BgMu.isValidBrandHex)(UNSAFE_themeOptions === null || UNSAFE_themeOptions === void 0 ? void 0 : UNSAFE_themeOptions.brandColor)) {
                        mode = colorMode || (0, $3myK9.themeStateDefaults)['colorMode'];
                        attrOfMissingCustomStyles = (0, $3dPVw.findMissingCustomStyleElements)(UNSAFE_themeOptions, mode);
                        if (attrOfMissingCustomStyles.length > 0) // Load custom theme styles
                        loadingTasks.push((0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee2() {
                            var _yield$import, loadAndAppendCustomThemeCss;
                            return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee2$(_context2) {
                                while(true)switch(_context2.prev = _context2.next){
                                    case 0:
                                        _context2.next = 2;
                                        return (parcelRequire("3Yyny"));
                                    case 2:
                                        _yield$import = _context2.sent;
                                        loadAndAppendCustomThemeCss = _yield$import.loadAndAppendCustomThemeCss;
                                        loadAndAppendCustomThemeCss({
                                            colorMode: attrOfMissingCustomStyles.length === 2 ? 'auto' : // only load the missing custom theme styles
                                            attrOfMissingCustomStyles[0],
                                            UNSAFE_themeOptions: UNSAFE_themeOptions
                                        });
                                    case 5:
                                    case "end":
                                        return _context2.stop();
                                }
                            }, _callee2);
                        }))());
                    }
                    _context3.next = 11;
                    return Promise.all(loadingTasks);
                case 11:
                    // Load override themes after standard themes
                    themeOverridePreferences = (0, $e3a60d4c8e185312$export$5d76d7014f4a5d08)(themeState);
                    _iterator = $58c709afdca0347c$var$_createForOfIteratorHelper(themeOverridePreferences);
                    _context3.prev = 13;
                    _iterator.s();
                case 15:
                    if ((_step = _iterator.n()).done) {
                        _context3.next = 21;
                        break;
                    }
                    themeId = _step.value;
                    _context3.next = 19;
                    return loadingStrategy(themeId);
                case 19:
                    _context3.next = 15;
                    break;
                case 21:
                    _context3.next = 26;
                    break;
                case 23:
                    _context3.prev = 23;
                    _context3.t0 = _context3["catch"](13);
                    _iterator.e(_context3.t0);
                case 26:
                    _context3.prev = 26;
                    _iterator.f();
                    return _context3.finish(26);
                case 29:
                    autoUnbind = (0, $c2c53e17eb81a691$export$2e2bcd8739ae039)(themeState);
                    return _context3.abrupt("return", autoUnbind);
                case 31:
                case "end":
                    return _context3.stop();
            }
        }, _callee3, null, [
            [
                13,
                23,
                26,
                29
            ]
        ]);
    }));
    return function setGlobalTheme() {
        return _ref.apply(this, arguments);
    };
}();
var $58c709afdca0347c$export$2e2bcd8739ae039 = $58c709afdca0347c$var$setGlobalTheme;


var $a1YOk = parcelRequire("a1YOk");

var $5FkrB = parcelRequire("5FkrB");
var $b2806b4beb17a266$export$7981b2444296e410 = /*#__PURE__*/ (0, $5FkrB.createContext)(false);
var $b2806b4beb17a266$export$26aa23367bfbab0e = function useIsInsideAppProvider() {
    return (0, $5FkrB.useContext)($b2806b4beb17a266$export$7981b2444296e410);
};



var $5FkrB = parcelRequire("5FkrB");
var $3d871d0e9788d082$export$49ddd74a6729fdb0 = /*#__PURE__*/ (0, $5FkrB.createContext)(undefined);
var $3d871d0e9788d082$export$b06130bad0bbc70f = /*#__PURE__*/ (0, $5FkrB.createContext)(undefined);



var $5FkrB = parcelRequire("5FkrB");
var $f0211a45eac9bc2a$export$332347eeb335453c = /*#__PURE__*/ (0, $5FkrB.createContext)(false);



var $5FkrB = parcelRequire("5FkrB");
var $473bf1060de42898$export$2c657da244d00bd6 = /*#__PURE__*/ (0, $5FkrB.createContext)(undefined);
var $473bf1060de42898$export$f7a97b47760e2a13 = /*#__PURE__*/ (0, $5FkrB.createContext)(undefined);



var $5FkrB = parcelRequire("5FkrB");

var $161f962d9120a6b3$export$7ca11437599d653d = function useIsInsideThemeProvider() {
    var _useContext;
    return (_useContext = (0, $5FkrB.useContext)((0, $f0211a45eac9bc2a$export$332347eeb335453c))) !== null && _useContext !== void 0 ? _useContext : false;
};



var $fL8KA = parcelRequire("fL8KA");

var $6HG4S = parcelRequire("6HG4S");

var $hBCYb = parcelRequire("hBCYb");


var $hBCYb = parcelRequire("hBCYb");

var $a1YOk = parcelRequire("a1YOk");
function $6851922efb5ed1f1$export$835a0dc855d02822(themeId) {
    var doc = (0, $hBCYb.getDocument)();
    if (!doc) return false;
    return doc.head.querySelector("style[".concat((0, $a1YOk.THEME_DATA_ATTRIBUTE), "=\"").concat(themeId, "\"]"));
}


var $cfe4fa477e2790e2$var$loadThemeCss = /*#__PURE__*/ function() {
    var _ref = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee(themeId) {
        var _yield$themeImportMap, themeCss;
        return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee$(_context) {
            while(true)switch(_context.prev = _context.next){
                case 0:
                    if (!(0, $6851922efb5ed1f1$export$835a0dc855d02822)(themeId)) {
                        _context.next = 2;
                        break;
                    }
                    return _context.abrupt("return");
                case 2:
                    if (themeId) {
                        _context.next = 4;
                        break;
                    }
                    return _context.abrupt("return");
                case 4:
                    _context.next = 6;
                    return (0, $db95856281fc8dae$export$2e2bcd8739ae039)[themeId]();
                case 6:
                    _yield$themeImportMap = _context.sent;
                    themeCss = _yield$themeImportMap.default;
                    return _context.abrupt("return", themeCss);
                case 9:
                case "end":
                    return _context.stop();
            }
        }, _callee);
    }));
    return function loadThemeCss(_x) {
        return _ref.apply(this, arguments);
    };
}();
var $cfe4fa477e2790e2$var$mountThemeCss = /*#__PURE__*/ function() {
    var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee2(css, themeId) {
        var doc, style;
        return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee2$(_context2) {
            while(true)switch(_context2.prev = _context2.next){
                case 0:
                    // SSR-safe: Only mount on client side
                    doc = (0, $hBCYb.getDocument)();
                    if (doc) {
                        _context2.next = 3;
                        break;
                    }
                    return _context2.abrupt("return");
                case 3:
                    style = doc.createElement('style');
                    style.textContent = css;
                    style.dataset.theme = themeId;
                    // Prevent duplicate mounting of themes.
                    // It's possible the theme was already being loaded elsewhere.
                    if (!(0, $6851922efb5ed1f1$export$835a0dc855d02822)(themeId)) {
                        _context2.next = 8;
                        break;
                    }
                    return _context2.abrupt("return");
                case 8:
                    doc.head.appendChild(style);
                case 9:
                case "end":
                    return _context2.stop();
            }
        }, _callee2);
    }));
    return function mountThemeCss(_x2, _x3) {
        return _ref2.apply(this, arguments);
    };
}();
var $cfe4fa477e2790e2$var$loadAndMountThemeCss = /*#__PURE__*/ function() {
    var _ref3 = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee3(themeId) {
        var themeCss;
        return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee3$(_context3) {
            while(true)switch(_context3.prev = _context3.next){
                case 0:
                    _context3.next = 2;
                    return $cfe4fa477e2790e2$var$loadThemeCss(themeId);
                case 2:
                    themeCss = _context3.sent;
                    if (themeCss) {
                        _context3.next = 5;
                        break;
                    }
                    return _context3.abrupt("return");
                case 5:
                    $cfe4fa477e2790e2$var$mountThemeCss(themeCss, themeId);
                case 6:
                case "end":
                    return _context3.stop();
            }
        }, _callee3);
    }));
    return function loadAndMountThemeCss(_x4) {
        return _ref3.apply(this, arguments);
    };
}();
var $cfe4fa477e2790e2$export$7d4a7e812d176b24 = /*#__PURE__*/ function() {
    var _ref4 = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee4(theme) {
        var themesToLoad;
        return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee4$(_context4) {
            while(true)switch(_context4.prev = _context4.next){
                case 0:
                    themesToLoad = Object.values(theme).filter(function(themeId) {
                        return !!themeId;
                    });
                    themesToLoad.forEach($cfe4fa477e2790e2$var$loadAndMountThemeCss);
                case 2:
                case "end":
                    return _context4.stop();
            }
        }, _callee4);
    }));
    return function loadAndMountThemes(_x5) {
        return _ref4.apply(this, arguments);
    };
}();


function $ae62b1130b2497f3$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $ae62b1130b2497f3$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $ae62b1130b2497f3$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $ae62b1130b2497f3$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $ae62b1130b2497f3$var$defaultThemeSettings = {
    dark: 'dark',
    light: 'light',
    spacing: 'spacing',
    typography: 'typography'
};
var $ae62b1130b2497f3$var$isMatchMediaAvailable = typeof window !== 'undefined' && 'matchMedia' in window;
var $ae62b1130b2497f3$var$prefersDarkModeMql = $ae62b1130b2497f3$var$isMatchMediaAvailable ? window.matchMedia('(prefers-color-scheme: dark)') : undefined;
// TODO: currently 'auto' color mode will always return 'light' in SSR.
// Additional work required: https://product-fabric.atlassian.net/browse/DSP-9781
function $ae62b1130b2497f3$var$getReconciledColorMode(colorMode) {
    if (colorMode === 'auto') return $ae62b1130b2497f3$var$prefersDarkModeMql !== null && $ae62b1130b2497f3$var$prefersDarkModeMql !== void 0 && $ae62b1130b2497f3$var$prefersDarkModeMql.matches ? 'dark' : 'light';
    return colorMode;
}
var $ae62b1130b2497f3$var$contentStyles = {
    body: "_1e0c1bgi"
};
/**
 * __Theme provider__
 *
 * Provides global theming configuration.
 */ function $ae62b1130b2497f3$var$ThemeProvider(_ref) {
    var children = _ref.children, _ref$defaultColorMode = _ref.defaultColorMode, defaultColorMode = _ref$defaultColorMode === void 0 ? 'auto' : _ref$defaultColorMode, defaultTheme = _ref.defaultTheme;
    var _useState = (0, $5FkrB.useState)(defaultColorMode), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), chosenColorMode = _useState2[0], setChosenColorMode = _useState2[1];
    var _useState3 = (0, $5FkrB.useState)($ae62b1130b2497f3$var$getReconciledColorMode(defaultColorMode)), _useState4 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState3, 2), reconciledColorMode = _useState4[0], setReconciledColorMode = _useState4[1];
    var _useState5 = (0, $5FkrB.useState)(function() {
        return $ae62b1130b2497f3$var$_objectSpread($ae62b1130b2497f3$var$_objectSpread({}, $ae62b1130b2497f3$var$defaultThemeSettings), defaultTheme);
    }), _useState6 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState5, 2), theme = _useState6[0], setTheme = _useState6[1];
    var setColorMode = (0, $5FkrB.useCallback)(function(colorMode) {
        setChosenColorMode(colorMode);
        setReconciledColorMode($ae62b1130b2497f3$var$getReconciledColorMode(colorMode));
    }, []);
    var setPartialTheme = (0, $5FkrB.useCallback)(function(nextTheme) {
        setTheme(function(theme) {
            return $ae62b1130b2497f3$var$_objectSpread($ae62b1130b2497f3$var$_objectSpread({}, theme), nextTheme);
        });
    }, []);
    var lastSetGlobalThemePromiseRef = (0, $5FkrB.useRef)(null);
    var isInsideAppProvider = (0, $b2806b4beb17a266$export$26aa23367bfbab0e)();
    var isInsideThemeProvider = (0, $161f962d9120a6b3$export$7ca11437599d653d)();
    var isRootThemeProvider = isInsideAppProvider && !isInsideThemeProvider;
    (0, $5FkrB.useEffect)(function() {
        if (/**
     * A top-level ThemeProvider is detected by being the first ThemeProvider inside an AppProvider.
     *
     * This will not use sub-tree theming but instead set the global theme state using the
     * `@atlaskit/tokens` APIs, as it's required for styling root `html` and `body` elements
     * for compatibility with `@atlaskit/css-reset`.
     *
     * In the future we could consider moving away from DOM mutations and require AppProvider to wrap
     * `html` in order to apply global theme state, which would allow a more consistent approach to
     * theme loading.
     */ isRootThemeProvider || /**
     * Or when not behind feature flag, partially revert to legacy behavior.
     * This only affects theme providers that are not inside an AppProvider or a ThemeProvider,
     * as we still need to set global theme state to prevent breaking existing apps,
     * but also prevent multiple theme providers from loading conflicting theme states.
     *
     * After we roll out the feature flag, this will be removed as we will
     * only support sub-tree theming when used outside of AppProvider.
     */ !isInsideAppProvider && !isInsideThemeProvider && !(0, $dU8Y3.fg)('platform_dst_subtree_theming')) {
            /**
       * We need to wait for any previous `setGlobalTheme` calls to finish before calling it again.
       * This is to prevent race conditions as `setGlobalTheme` is async and mutates the DOM (e.g. sets the
       * `data-color-mode` attribute on the root element).
       *
       * Since we can't safely abort the `setGlobalTheme` execution, we need to wait for it to properly finish before
       * applying the new theme.
       *
       * Without this, we can end up in the following scenario:
       * 1. app loads with the default 'light' theme, kicking off `setGlobalTheme`
       * 2. app switches to 'dark' theme after retrieving value persisted in local storage, calling `setGlobalTheme` again
       * 3. `setGlobalTheme` function execution for `dark` finishes before the initial `light` execution
       * 4. `setGlobalTheme` function execution for `light` then finishes, resulting in the 'light' theme being applied.
       */ var cleanupLastFnCall = /*#__PURE__*/ function() {
                var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee() {
                    var unbindFn;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee$(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                if (!lastSetGlobalThemePromiseRef.current) {
                                    _context.next = 6;
                                    break;
                                }
                                _context.next = 3;
                                return lastSetGlobalThemePromiseRef.current;
                            case 3:
                                unbindFn = _context.sent;
                                unbindFn();
                                lastSetGlobalThemePromiseRef.current = null;
                            case 6:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee);
                }));
                return function cleanupLastFnCall() {
                    return _ref2.apply(this, arguments);
                };
            }();
            var safelySetGlobalTheme = /*#__PURE__*/ function() {
                var _ref3 = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee2() {
                    var promise;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee2$(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                _context2.next = 2;
                                return cleanupLastFnCall();
                            case 2:
                                promise = (0, $58c709afdca0347c$export$2e2bcd8739ae039)($ae62b1130b2497f3$var$_objectSpread($ae62b1130b2497f3$var$_objectSpread({}, theme), {}, {
                                    colorMode: reconciledColorMode
                                }));
                                lastSetGlobalThemePromiseRef.current = promise;
                            case 4:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2);
                }));
                return function safelySetGlobalTheme() {
                    return _ref3.apply(this, arguments);
                };
            }();
            safelySetGlobalTheme();
            return function cleanup() {
                cleanupLastFnCall();
            };
        } else // For other theme providers (whether outside AppProvider or nested inside a ThemeProvider),
        // we treat them as sub-tree themes that do not load global theme state.
        (0, $cfe4fa477e2790e2$export$7d4a7e812d176b24)(theme);
    }, [
        isInsideAppProvider,
        isInsideThemeProvider,
        isRootThemeProvider,
        reconciledColorMode,
        theme
    ]);
    (0, $5FkrB.useEffect)(function() {
        if (!$ae62b1130b2497f3$var$prefersDarkModeMql) return;
        var unbindListener = (0, $7QpUe.bind)($ae62b1130b2497f3$var$prefersDarkModeMql, {
            type: 'change',
            listener: function listener(event) {
                if (chosenColorMode === 'auto') setReconciledColorMode(event.matches ? 'dark' : 'light');
            }
        });
        return unbindListener;
    }, [
        chosenColorMode
    ]);
    var attrs = $ae62b1130b2497f3$var$_objectSpread($ae62b1130b2497f3$var$_objectSpread({}, (0, $6cadcf023d331d75$export$2e2bcd8739ae039)($ae62b1130b2497f3$var$_objectSpread($ae62b1130b2497f3$var$_objectSpread({}, theme), {}, {
        colorMode: reconciledColorMode
    }))), {}, (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, (0, $a1YOk.SUBTREE_THEME_ATTRIBUTE), true));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $f0211a45eac9bc2a$export$332347eeb335453c).Provider, {
        value: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $3d871d0e9788d082$export$49ddd74a6729fdb0).Provider, {
        value: reconciledColorMode
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $3d871d0e9788d082$export$b06130bad0bbc70f).Provider, {
        value: setColorMode
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $473bf1060de42898$export$2c657da244d00bd6).Provider, {
        value: theme
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $473bf1060de42898$export$f7a97b47760e2a13).Provider, {
        value: setPartialTheme
    }, (0, $dU8Y3.fg)('platform_dst_subtree_theming') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, attrs, {
        className: (0, $970q7.default)([
            $ae62b1130b2497f3$var$contentStyles.body
        ])
    }), children) : children)))));
}
var $ae62b1130b2497f3$export$2e2bcd8739ae039 = $ae62b1130b2497f3$var$ThemeProvider;


var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $25nEq = parcelRequire("25nEq");

var $a1YOk = parcelRequire("a1YOk");

/**
 * A MutationObserver which watches the `<html>` element for changes to the theme.
 *
 * In React, use the {@link useThemeObserver `useThemeObserver`} hook instead.
 *
 * @param {function} callback - A callback function which fires when the theme changes.
 *
 * @example
 * ```
 * const observer = new ThemeMutationObserver((theme) => {});
 * observer.observe();
 * ```
 */ var $7a3ead58de8d61f8$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function ThemeMutationObserver(callback) {
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, ThemeMutationObserver);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "legacyObserver", null);
        this.callback = callback;
        ThemeMutationObserver.callbacks.add(callback);
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(ThemeMutationObserver, [
        {
            key: "observe",
            value: function observe() {
                if (!ThemeMutationObserver.observer) {
                    ThemeMutationObserver.observer = new MutationObserver(function() {
                        var theme = (0, $1e4b65fba65a5e1e$export$2e2bcd8739ae039)();
                        ThemeMutationObserver.callbacks.forEach(function(callback) {
                            return callback(theme);
                        });
                    });
                    // Observer only needs to be configured once
                    ThemeMutationObserver.observer.observe(document.documentElement, {
                        attributeFilter: [
                            (0, $a1YOk.THEME_DATA_ATTRIBUTE),
                            (0, $a1YOk.COLOR_MODE_ATTRIBUTE)
                        ]
                    });
                }
            }
        },
        {
            key: "disconnect",
            value: function disconnect() {
                if (this.callback) ThemeMutationObserver.callbacks.delete(this.callback);
                if (ThemeMutationObserver.callbacks.size === 0 && ThemeMutationObserver.observer) {
                    ThemeMutationObserver.observer.disconnect();
                    ThemeMutationObserver.observer = null;
                }
            }
        }
    ]);
}();
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($7a3ead58de8d61f8$export$2e2bcd8739ae039, "observer", null);
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($7a3ead58de8d61f8$export$2e2bcd8739ae039, "callbacks", new Set());



function $6db22a05296c06ce$export$20f3076712c8dfa() {
    var value = (0, $5FkrB.useContext)((0, $3d871d0e9788d082$export$49ddd74a6729fdb0));
    // TODO: This will only return 'light' or 'dark' but never 'auto', which in some cases
    // may be desirable. We should consider returning both the reconciled color mode (e.g. 'light' or 'dark') and the selected color mode ("auto").
    var theme = (0, $1e4b65fba65a5e1e$export$2e2bcd8739ae039)();
    var _useState = (0, $5FkrB.useState)((theme === null || theme === void 0 ? void 0 : theme.colorMode) || 'light'), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), resolvedColorMode = _useState2[0], setResolvedColorMode = _useState2[1];
    (0, $5FkrB.useEffect)(function() {
        // We are using theme from context so no need to reference the DOM
        if (value) return;
        var observer = new (0, $7a3ead58de8d61f8$export$2e2bcd8739ae039)(function(theme) {
            setResolvedColorMode((theme === null || theme === void 0 ? void 0 : theme.colorMode) || 'light');
        });
        observer.observe();
        return function() {
            return observer.disconnect();
        };
    }, [
        value
    ]);
    return value ? value : resolvedColorMode;
}



var $dU8Y3 = parcelRequire("dU8Y3");
var $e23d32067a752065$export$e4c79eb95c23a0da = 'atlaskit-portal-container';
var $e23d32067a752065$export$72f415121273627e = 'body > .atlaskit-portal-container';
var $e23d32067a752065$export$13f57c02915787b3 = 'atlaskit-portal';


var $1e742c1d47ccd862$export$26ae5ca175b4ec5a = function createContainer(zIndex) {
    var container = document.createElement('div');
    container.className = (0, $e23d32067a752065$export$13f57c02915787b3);
    container.style.zIndex = "".concat(zIndex);
    return container;
};
/**
 * Returns document body element
 * @return {number} - The document body element
 */ var $1e742c1d47ccd862$var$getBody = function getBody() {
    return document.body;
};
/**
 * Returns portal parent container. If no container exists already then it creates a new container with class name 'atlaskit-portal-container'
 * @return {Element} - The portal parent container div element
 */ var $1e742c1d47ccd862$var$getPortalParent = function getPortalParent() {
    var parentElement = document.querySelector((0, $e23d32067a752065$export$72f415121273627e));
    if (!parentElement) {
        var _getBody;
        var parent = document.createElement('div');
        parent.className = (0, $e23d32067a752065$export$e4c79eb95c23a0da);
        // we are setting display to flex because we want each portal to create a new stacking context
        // See https://developer.mozilla.org/en-US/docs/Web/CSS/CSS_Positioning/Understanding_z_index/The_stacking_context
        parent.style.display = 'flex';
        (_getBody = $1e742c1d47ccd862$var$getBody()) === null || _getBody === void 0 || _getBody.appendChild(parent);
        return parent;
    }
    return parentElement;
};
var $1e742c1d47ccd862$export$da99f98bf3fe55b3 = function removePortalContainer(container) {
    $1e742c1d47ccd862$var$getPortalParent().removeChild(container);
};
var $1e742c1d47ccd862$export$c582005add11e141 = function appendPortalContainerIfNotAppended(container) {
    if (!container.parentElement) $1e742c1d47ccd862$var$getPortalParent().appendChild(container);
};
var $1e742c1d47ccd862$var$isDocumentDefined = function isDocumentDefined() {
    return document !== undefined;
};
var $1e742c1d47ccd862$export$fef014d7cef9e543 = function createAtlaskitPortal(zIndex) {
    //atlaskit-portal div
    if ($1e742c1d47ccd862$var$isDocumentDefined()) {
        var atlaskitportal = document.createElement('div');
        atlaskitportal.className = (0, $e23d32067a752065$export$13f57c02915787b3);
        atlaskitportal.style.zIndex = "".concat(zIndex);
        return atlaskitportal;
    }
    return;
};
var $1e742c1d47ccd862$export$95029ca7aca2989e = function createPortalParent() {
    //atlaskit-portal-container div
    if ($1e742c1d47ccd862$var$isDocumentDefined()) {
        var parentElement = document.querySelector((0, $e23d32067a752065$export$72f415121273627e));
        if (!parentElement) {
            var _getBody2;
            var parent = document.createElement('div');
            parent.className = (0, $e23d32067a752065$export$e4c79eb95c23a0da);
            parent.style.display = 'flex';
            (_getBody2 = $1e742c1d47ccd862$var$getBody()) === null || _getBody2 === void 0 || _getBody2.appendChild(parent);
            return parent;
        }
        return parentElement;
    }
    return;
};


function $c1991d6d9bd46da5$export$2e2bcd8739ae039(props) {
    var zIndex = props.zIndex, children = props.children;
    var container = (0, $5FkrB.useMemo)(function() {
        return (0, $1e742c1d47ccd862$export$26ae5ca175b4ec5a)(zIndex);
    }, [
        zIndex
    ]);
    var colorMode = (0, $6db22a05296c06ce$export$20f3076712c8dfa)();
    // This is in the render method instead of useEffect so that
    // the portal will be added to the DOM before the children render.
    // For any further changes, ensure that the container does not have a
    // parent besides the portal parent.
    (0, $1e742c1d47ccd862$export$c582005add11e141)(container);
    (0, $5FkrB.useEffect)(function() {
        return function() {
            (0, $1e742c1d47ccd862$export$da99f98bf3fe55b3)(container);
        };
    }, [
        container
    ]);
    return /*#__PURE__*/ (0, $aLeHs.createPortal)(colorMode && (0, $dU8Y3.fg)('platform_dst_subtree_theming') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $ae62b1130b2497f3$export$2e2bcd8739ae039), {
        defaultColorMode: colorMode
    }, children) : children, container);
}



var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");

var $aLeHs = parcelRequire("aLeHs");


var $dU8Y3 = parcelRequire("dU8Y3");

var $5FkrB = parcelRequire("5FkrB");
var $b8e2dddaa7a08a03$export$700979bc83e7db82 = typeof window !== 'undefined' ? (0, $5FkrB.useLayoutEffect) : (0, $5FkrB.useEffect);



function $8ba2d3c420b3f943$export$2e2bcd8739ae039(props) {
    var zIndex = props.zIndex, children = props.children;
    var _useState = (0, $5FkrB.useState)(null), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), atlaskitPortal = _useState2[0], setAtlaskitPortal = _useState2[1];
    var colorMode = (0, $6db22a05296c06ce$export$20f3076712c8dfa)();
    (0, $b8e2dddaa7a08a03$export$700979bc83e7db82)(function() {
        var tempPortalContainer = (0, $1e742c1d47ccd862$export$fef014d7cef9e543)(zIndex);
        setAtlaskitPortal(tempPortalContainer);
        var portalParent = (0, $1e742c1d47ccd862$export$95029ca7aca2989e)();
        if (!tempPortalContainer || !portalParent) return;
        portalParent.appendChild(tempPortalContainer);
        return function() {
            if (tempPortalContainer) portalParent.removeChild(tempPortalContainer);
            setAtlaskitPortal(null);
        };
    }, [
        zIndex
    ]);
    /**
   * We wrap portal children with a Suspense boundary because in React 18 concurrent,
   * if you suspend from _within_ a portal to a Suspense boundary _outside_ the portal,
   * our portal gets in an infinite loop of rendering.
   */ var suspendedChildren = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $5FkrB.Suspense), {
        fallback: null
    }, colorMode && (0, $dU8Y3.fg)('platform_dst_subtree_theming') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $ae62b1130b2497f3$export$2e2bcd8739ae039), {
        defaultColorMode: colorMode
    }, children) : children);
    return atlaskitPortal ? /*#__PURE__*/ (0, $aLeHs.createPortal)(suspendedChildren, atlaskitPortal) : null;
}



var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");

var $47a7238a4812c9dc$var$useIsSubsequentRender = function useIsSubsequentRender(mountStrategy) {
    var _useState = (0, $5FkrB.useState)(false), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), isSubsequentRender = _useState2[0], setIsSubsequentRender = _useState2[1];
    var _useState3 = (0, $5FkrB.useState)(function() {
        return mountStrategy === 'layoutEffect' ? (0, $b8e2dddaa7a08a03$export$700979bc83e7db82) : (0, $5FkrB.useEffect);
    }), _useState4 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState3, 1), useMountEffect = _useState4[0];
    useMountEffect(function() {
        setIsSubsequentRender(true);
    }, []);
    return isSubsequentRender;
};
var $47a7238a4812c9dc$export$2e2bcd8739ae039 = $47a7238a4812c9dc$var$useIsSubsequentRender;



var $5FkrB = parcelRequire("5FkrB");
var $de9cd8831c03e991$export$ed5835cc67e87f72 = 'akPortalMount';
var $de9cd8831c03e991$export$80816bd900e5bd00 = 'akPortalUnmount';


var $af305d709bd22dc8$var$zIndexToName = {
    100: 'card',
    200: 'navigation',
    300: 'dialog',
    400: 'layer',
    500: 'blanket',
    510: 'modal',
    600: 'flag',
    700: 'spotlight',
    9999: 'tooltip'
};
/**
 * return layer name in Atlassian design system corresponding to given z-index
 * @param {number} zIndex - z-index value for which layer name is needed
 * @returns {LayerName | null} - The layer name for given z-index. If layer name is not found then null is returned
 */ var $af305d709bd22dc8$var$getLayerName = function getLayerName(zIndex) {
    return $af305d709bd22dc8$var$zIndexToName.hasOwnProperty(zIndex) ? $af305d709bd22dc8$var$zIndexToName[zIndex] : null;
};
/**
 * Creates a PortalEvent object with given eventName, given zIndex and corresponding layer
 * @param {string} eventName - either of Mount or Unmount event name
 * @param {number} zIndex - z-index value which will be included in the event to be dispatched
 * @returns {PortalEvent} - The newly created PortalEvent object
 */ var $af305d709bd22dc8$var$getEvent = function getEvent(eventName, zIndex) {
    var detail = {
        layer: $af305d709bd22dc8$var$getLayerName(Number(zIndex)),
        zIndex: zIndex
    };
    return new CustomEvent(eventName, {
        detail: detail
    });
};
function $af305d709bd22dc8$export$2e2bcd8739ae039(eventName, zIndex) {
    var event = $af305d709bd22dc8$var$getEvent(eventName, zIndex);
    window.dispatchEvent(event);
}


var $317ffa1a2ed520bc$var$useFirePortalEvent = function useFirePortalEvent(zIndex) {
    var zIndexNumber = Number(zIndex);
    (0, $5FkrB.useEffect)(function() {
        (0, $af305d709bd22dc8$export$2e2bcd8739ae039)((0, $de9cd8831c03e991$export$ed5835cc67e87f72), zIndexNumber);
        return function() {
            (0, $af305d709bd22dc8$export$2e2bcd8739ae039)((0, $de9cd8831c03e991$export$80816bd900e5bd00), zIndexNumber);
        };
    }, [
        zIndexNumber
    ]);
};
var $317ffa1a2ed520bc$export$2e2bcd8739ae039 = $317ffa1a2ed520bc$var$useFirePortalEvent;


function $3abdb7aea1ec0147$export$2e2bcd8739ae039(_ref) {
    var _ref$zIndex = _ref.zIndex, zIndex = _ref$zIndex === void 0 ? 0 : _ref$zIndex, children = _ref.children, _ref$mountStrategy = _ref.mountStrategy, mountStrategy = _ref$mountStrategy === void 0 ? 'effect' : _ref$mountStrategy;
    var isSubsequentRender = (0, $47a7238a4812c9dc$export$2e2bcd8739ae039)(mountStrategy);
    (0, $317ffa1a2ed520bc$export$2e2bcd8739ae039)(zIndex);
    return !(0, $dU8Y3.fg)('platform_design_system_team_portal_logic_r18_fix') ? isSubsequentRender ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $c1991d6d9bd46da5$export$2e2bcd8739ae039), {
        zIndex: zIndex
    }, children) : null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $8ba2d3c420b3f943$export$2e2bcd8739ae039), {
        zIndex: zIndex
    }, children);
}



var $kxpsr = parcelRequire("kxpsr");
// Reds
var $3fd09f6d997c5775$export$4b84fd0e2c617bd = '#FFEBE6';
var $3fd09f6d997c5775$export$b34b069eff244586 = '#FFBDAD';
var $3fd09f6d997c5775$export$be802dd0d8b57f35 = '#FF8F73';
var $3fd09f6d997c5775$export$60847d42f9da92a6 = '#FF7452';
var $3fd09f6d997c5775$export$4a7404f376229999 = '#FF5630';
var $3fd09f6d997c5775$export$2010d0fb4295b346 = '#DE350B';
var $3fd09f6d997c5775$export$2837b5a1a71d5c02 = '#BF2600';
var $3fd09f6d997c5775$export$8d9596b529bbb9cf = '#FFFAE6';
var $3fd09f6d997c5775$export$41060a744ab0b7ae = '#FFF0B3';
var $3fd09f6d997c5775$export$1cc05bbbf340e559 = '#FFE380';
var $3fd09f6d997c5775$export$5aae31392d72caaa = '#FFC400';
var $3fd09f6d997c5775$export$c6930421db9fa514 = '#FFAB00';
var $3fd09f6d997c5775$export$59619663aa6500fb = '#FF991F';
var $3fd09f6d997c5775$export$874739ea9e379ab6 = '#FF8B00';
var $3fd09f6d997c5775$export$8a6341c32b6a3ee6 = '#E3FCEF';
var $3fd09f6d997c5775$export$69a3bf21b9686c2b = '#ABF5D1';
var $3fd09f6d997c5775$export$afbce1382ec95f73 = '#79F2C0';
var $3fd09f6d997c5775$export$747d86715d4175de = '#57D9A3';
var $3fd09f6d997c5775$export$940e1f69e873f202 = '#36B37E';
var $3fd09f6d997c5775$export$a49394138f7b8e85 = '#00875A';
var $3fd09f6d997c5775$export$6fa04827ac68a4fb = '#006644';
var $3fd09f6d997c5775$export$226de0355ed012f8 = '#DEEBFF';
var $3fd09f6d997c5775$export$8c13c2ee36917869 = '#B3D4FF';
var $3fd09f6d997c5775$export$ecfc1dff386a3e7a = '#4C9AFF';
var $3fd09f6d997c5775$export$215b7063051591f1 = '#2684FF';
var $3fd09f6d997c5775$export$e62e8919cca44969 = '#0065FF';
var $3fd09f6d997c5775$export$b3de0ae08da2ce64 = '#0052CC';
var $3fd09f6d997c5775$export$a6ee3d71bc067634 = '#0747A6';
var $3fd09f6d997c5775$export$67f15409e87642a1 = '#669DF1';
var $3fd09f6d997c5775$export$f0539dbc42dbb067 = '#8FB8F6';
var $3fd09f6d997c5775$export$363e4475840015bb = '#EAE6FF';
var $3fd09f6d997c5775$export$4b0a4417ed59760f = '#C0B6F2';
var $3fd09f6d997c5775$export$6011520a64d9a187 = '#998DD9';
var $3fd09f6d997c5775$export$a7175d4e9206bc80 = '#8777D9';
var $3fd09f6d997c5775$export$b48405b95304b5a1 = '#6554C0';
var $3fd09f6d997c5775$export$c71e4279dd54a18d = '#5243AA';
var $3fd09f6d997c5775$export$147899de772240ec = '#403294';
var $3fd09f6d997c5775$export$2cf711fe14c66f06 = '#E6FCFF';
var $3fd09f6d997c5775$export$7a8f4d33f6f9772c = '#B3F5FF';
var $3fd09f6d997c5775$export$776c9c497ef08533 = '#79E2F2';
var $3fd09f6d997c5775$export$69cb3ca10c1e330e = '#00C7E6';
var $3fd09f6d997c5775$export$9dc1ef0f3f48059b = '#00B8D9';
var $3fd09f6d997c5775$export$7c835c78b6fcdef8 = '#00A3BF';
var $3fd09f6d997c5775$export$6036577f95c3877e = '#008DA6';
var $3fd09f6d997c5775$export$29a4f05edc054374 = '#FFFFFF';
var $3fd09f6d997c5775$export$e655ef011c4aa1a2 = '#FAFBFC';
var $3fd09f6d997c5775$export$9fdfb749e33cdf97 = '#F4F5F7';
var $3fd09f6d997c5775$export$3e51e8f1440314ba = '#EBECF0';
var $3fd09f6d997c5775$export$1ce2d1575d444ceb = '#DFE1E6';
var $3fd09f6d997c5775$export$8754fc7e6d8b3000 = '#C1C7D0';
var $3fd09f6d997c5775$export$c2e91cbeada39b8b = '#B3BAC5';
var $3fd09f6d997c5775$export$5f71e19f3a7ad9de = '#A5ADBA';
var $3fd09f6d997c5775$export$eaa8c8a70ac22806 = '#97A0AF';
var $3fd09f6d997c5775$export$7c87d337fb91a97d = '#8993A4';
var $3fd09f6d997c5775$export$d6447c357493214f = '#7A869A';
var $3fd09f6d997c5775$export$f563ee71e9ee74cd = '#6B778C';
var $3fd09f6d997c5775$export$e2ef2124cf4024b1 = '#5E6C84';
var $3fd09f6d997c5775$export$eece5f492e429f08 = '#505F79';
var $3fd09f6d997c5775$export$c39c0fe0f26207ae = '#42526E';
var $3fd09f6d997c5775$export$7090862dc3038a9f = '#344563';
var $3fd09f6d997c5775$export$ad0bacf983b7ddaa = '#253858';
var $3fd09f6d997c5775$export$7d61b15e0da132af = '#172B4D';
var $3fd09f6d997c5775$export$fbda843f0a27fe96 = '#091E42';
var $3fd09f6d997c5775$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
var $3fd09f6d997c5775$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
var $3fd09f6d997c5775$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
var $3fd09f6d997c5775$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
var $3fd09f6d997c5775$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
var $3fd09f6d997c5775$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
var $3fd09f6d997c5775$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
var $3fd09f6d997c5775$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
var $3fd09f6d997c5775$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
var $3fd09f6d997c5775$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
var $3fd09f6d997c5775$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
var $3fd09f6d997c5775$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
var $3fd09f6d997c5775$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
var $3fd09f6d997c5775$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
var $3fd09f6d997c5775$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
var $3fd09f6d997c5775$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
var $3fd09f6d997c5775$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
var $3fd09f6d997c5775$export$2f6319cf7d736c2a = '#E6EDFA';
var $3fd09f6d997c5775$export$95126bc8884d6634 = '#DCE5F5';
var $3fd09f6d997c5775$export$8338d8c35d44ff1 = '#CED9EB';
var $3fd09f6d997c5775$export$5368d76ae4fbbda7 = '#B8C7E0';
var $3fd09f6d997c5775$export$9f0a771d16ec8d36 = '#ABBBD6';
var $3fd09f6d997c5775$export$abcf8c38338b4aa5 = '#9FB0CC';
var $3fd09f6d997c5775$export$97e81faa16a182c7 = '#8C9CB8';
var $3fd09f6d997c5775$export$bfe21c59123ecf33 = '#7988A3';
var $3fd09f6d997c5775$export$ee82aa2ea6a1558 = '#67758F';
var $3fd09f6d997c5775$export$682927c6ed76be02 = '#56637A';
var $3fd09f6d997c5775$export$91fd9994c5be9757 = '#455166';
var $3fd09f6d997c5775$export$d281fbfe3cff2df6 = '#3B475C';
var $3fd09f6d997c5775$export$3902c91d8b98a753 = '#313D52';
var $3fd09f6d997c5775$export$8e8133c1ba5845b5 = '#283447';
var $3fd09f6d997c5775$export$33ff357f6620b39 = '#202B3D';
var $3fd09f6d997c5775$export$633847cf062b69e0 = '#1B2638';
var $3fd09f6d997c5775$export$9776a6e503bdbf76 = '#121A29';
var $3fd09f6d997c5775$export$6c813d5160dff5db = '#0E1624';
var $3fd09f6d997c5775$export$3d4f271a500072a = '#0D1424';
var $3fd09f6d997c5775$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
var $3fd09f6d997c5775$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
var $3fd09f6d997c5775$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
var $3fd09f6d997c5775$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
var $3fd09f6d997c5775$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
var $3fd09f6d997c5775$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
var $3fd09f6d997c5775$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
var $3fd09f6d997c5775$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
var $3fd09f6d997c5775$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
var $3fd09f6d997c5775$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
var $3fd09f6d997c5775$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
var $3fd09f6d997c5775$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
var $3fd09f6d997c5775$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
var $3fd09f6d997c5775$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
var $3fd09f6d997c5775$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
var $3fd09f6d997c5775$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
var $3fd09f6d997c5775$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';
var $3fd09f6d997c5775$export$d2adc5dedf09fced = '#292A2E';
var $3fd09f6d997c5775$export$f51762073d2bb381 = '#94C748';
var $3fd09f6d997c5775$export$95e26d54def96891 = '#B3DF72';


var $d37e64f35eec0d40$export$44ffba16bd48dac6 = '__ATLASKIT_THEME__';
var $d37e64f35eec0d40$export$c93026a968943f95 = 'light';
var $d37e64f35eec0d40$export$6ba72c8346b4c57e = [
    'light',
    'dark'
];
var $d37e64f35eec0d40$export$8e24544ddba725ee = function focusRing() {
    var color = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "var(--ds-border-focused, ".concat((0, $3fd09f6d997c5775$export$215b7063051591f1), ")");
    var outlineWidth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
    (0, $kxpsr.default)('@atlaskit/theme', 'focus ring mixin', 'Please use `@atlaskit/focus-ring` instead.');
    return "\n  &:focus {\n    outline: none;\n    box-shadow: 0px 0px 0px ".concat(outlineWidth, "px ").concat(color, ";\n  }\n");
};
var $d37e64f35eec0d40$export$c0dd343266bc3261 = function noFocusRing() {
    return "\n  box-shadow: none;\n";
};
var $d37e64f35eec0d40$export$7be255094ccdc533 = {
    card: function card() {
        return 100;
    },
    navigation: function navigation() {
        return 200;
    },
    dialog: function dialog() {
        return 300;
    },
    layer: function layer() {
        return 400;
    },
    blanket: function blanket() {
        return 500;
    },
    modal: function modal() {
        return 510;
    },
    flag: function flag() {
        return 600;
    },
    spotlight: function spotlight() {
        return 700;
    },
    tooltip: function tooltip() {
        return 9999;
    }
};
var $d37e64f35eec0d40$export$a1b3edb637fb4f35 = function visuallyHidden() {
    (0, $kxpsr.default)('@atlaskit/theme', 'visually hidden mixin', 'Please use `@atlaskit/visually-hidden` instead.');
    return {
        border: '0 !important',
        clip: 'rect(1px, 1px, 1px, 1px) !important',
        height: '1px !important',
        overflow: 'hidden !important',
        padding: '0 !important',
        position: 'absolute !important',
        width: '1px !important',
        whiteSpace: 'nowrap !important'
    };
};
var $d37e64f35eec0d40$export$ba1d834b86d72a09 = $d37e64f35eec0d40$export$a1b3edb637fb4f35;
var $d37e64f35eec0d40$export$e497e856b4f89fcd = function skeletonShimmer() {
    return {
        css: {
            backgroundColor: "var(--ds-skeleton, ".concat((0, $3fd09f6d997c5775$export$8d43898f60b96a82), ")"),
            animationDuration: '1.5s',
            animationIterationCount: 'infinite',
            animationTimingFunction: 'linear',
            animationDirection: 'alternate'
        },
        keyframes: {
            from: {
                backgroundColor: "var(--ds-skeleton, ".concat((0, $3fd09f6d997c5775$export$8d43898f60b96a82), ")")
            },
            to: {
                backgroundColor: "var(--ds-skeleton-subtle, ".concat((0, $3fd09f6d997c5775$export$920c0d5c49070351), ")")
            }
        }
    };
};


/* eslint-disable @atlaskit/design-system/no-direct-use-of-web-platform-drag-and-drop */ /**
 * We are listening directly to drag events instead of using a monitor from
 * `@atlaskit/pragmatic-drag-and-drop` to avoid the bundle size cost, as it
 * would affect almost every view in every app.
 *
 * We can reconsider this choice in the future.
 */ 
var $7QpUe = parcelRequire("7QpUe");
var $04c4752fbeced1ac$var$registrations = new Set();
var $04c4752fbeced1ac$var$cleanupEndEventListeners = null;
function $04c4752fbeced1ac$var$onDragStart() {
    if ($04c4752fbeced1ac$var$cleanupEndEventListeners) // If the cleanup function exists then we've already run this
    return;
    $04c4752fbeced1ac$var$cleanupEndEventListeners = (0, $7QpUe.bindAll)(window, [
        {
            type: 'dragend',
            listener: $04c4752fbeced1ac$var$onDragEnd
        },
        {
            type: 'pointerdown',
            listener: $04c4752fbeced1ac$var$onDragEnd
        },
        {
            type: 'pointermove',
            listener: function() {
                var callCount = 0;
                return function listener() {
                    // Using 20 as it is far bigger than the most observed (3)
                    if (callCount < 20) {
                        callCount++;
                        return;
                    }
                    $04c4752fbeced1ac$var$onDragEnd();
                };
            }()
        }
    ]);
    var clone = Array.from($04c4752fbeced1ac$var$registrations);
    clone.forEach(function(subscriber) {
        subscriber.onDragStart();
    });
}
function $04c4752fbeced1ac$var$onDragEnd() {
    var _cleanupEndEventListe;
    (_cleanupEndEventListe = $04c4752fbeced1ac$var$cleanupEndEventListeners) === null || _cleanupEndEventListe === void 0 || _cleanupEndEventListe();
    $04c4752fbeced1ac$var$cleanupEndEventListeners = null;
    var clone = Array.from($04c4752fbeced1ac$var$registrations);
    clone.forEach(function(subscriber) {
        subscriber.onDragEnd();
    });
}
function $04c4752fbeced1ac$var$bindStartEvents() {
    return (0, $7QpUe.bindAll)(window, [
        {
            type: 'dragstart',
            listener: $04c4752fbeced1ac$var$onDragStart
        },
        {
            type: 'dragenter',
            listener: $04c4752fbeced1ac$var$onDragStart
        }
    ]);
}
var $04c4752fbeced1ac$var$cleanupStartEventListeners = null;
function $04c4752fbeced1ac$export$6503ec6e8aabbaf(registration) {
    // if first registration, bind event listeners
    if (!$04c4752fbeced1ac$var$cleanupStartEventListeners) // note: currently never unbinding these event listeners
    $04c4752fbeced1ac$var$cleanupStartEventListeners = $04c4752fbeced1ac$var$bindStartEvents();
    $04c4752fbeced1ac$var$registrations.add(registration);
    /**
   * The reasoning for this behavior is so that if a tooltip mounts during
   * a drag it can still be suppressed.
   *
   * We use a separate callback instead of onDragStart to avoid infinite loops.
   */ registration.onRegister({
        isDragging: $04c4752fbeced1ac$var$cleanupEndEventListeners !== null
    });
    return function unregister() {
        $04c4752fbeced1ac$var$registrations.delete(registration);
        if ($04c4752fbeced1ac$var$registrations.size === 0) {
            var _cleanupStartEventLis;
            (_cleanupStartEventLis = $04c4752fbeced1ac$var$cleanupStartEventListeners) === null || _cleanupStartEventLis === void 0 || _cleanupStartEventLis();
            $04c4752fbeced1ac$var$cleanupStartEventListeners = null;
        }
    };
}



var $dU8Y3 = parcelRequire("dU8Y3");
var $7f975c83cfcc5eb1$var$delayId = null;
function $7f975c83cfcc5eb1$export$eaf678f6f93f5250() {
    if ($7f975c83cfcc5eb1$var$delayId != null) {
        window.clearTimeout($7f975c83cfcc5eb1$var$delayId);
        $7f975c83cfcc5eb1$var$delayId = null;
    }
}
function $7f975c83cfcc5eb1$export$5f4d6617421d489b(fn, delay) {
    $7f975c83cfcc5eb1$export$eaf678f6f93f5250();
    $7f975c83cfcc5eb1$var$delayId = window.setTimeout(function() {
        $7f975c83cfcc5eb1$var$delayId = null;
        fn();
    }, delay);
}


// This file is a singleton for managing tooltips
var $6e217632bbb5b2c1$var$active = null;
function $6e217632bbb5b2c1$export$57bf213be019eeb0(entry) {
    var phase = 'waiting-to-show';
    function isActive() {
        return Boolean($6e217632bbb5b2c1$var$active && $6e217632bbb5b2c1$var$active.entry === entry);
    }
    function cleanup() {
        if (isActive()) {
            (0, $7f975c83cfcc5eb1$export$eaf678f6f93f5250)();
            $6e217632bbb5b2c1$var$active = null;
        }
    }
    function done() {
        if (isActive()) entry.done();
        phase = 'done';
        cleanup();
    }
    function immediatelyHideAndDone() {
        if (isActive()) entry.hide({
            isImmediate: true
        });
        done();
    }
    function keep() {
        if (!isActive()) return;
        // aborting a wait to hide
        if (phase === 'waiting-to-hide') {
            phase = 'shown';
            (0, $7f975c83cfcc5eb1$export$eaf678f6f93f5250)();
            return;
        }
        // aborting hide animation
        if (phase === 'hide-animating') {
            phase = 'shown';
            (0, $7f975c83cfcc5eb1$export$eaf678f6f93f5250)();
            entry.show({
                isImmediate: false
            });
            return;
        }
    }
    function requestHide(_ref) {
        var isImmediate = _ref.isImmediate;
        if (!isActive()) return;
        // If we were not showing yet anyway; finish straight away
        if (phase === 'waiting-to-show') {
            immediatelyHideAndDone();
            return;
        }
        // already waiting to hide
        if (phase === 'waiting-to-hide') return;
        if (isImmediate) {
            immediatelyHideAndDone();
            return;
        }
        phase = 'waiting-to-hide';
        (0, $7f975c83cfcc5eb1$export$5f4d6617421d489b)(function() {
            phase = 'hide-animating';
            entry.hide({
                isImmediate: false
            });
        }, entry.delay);
    }
    function finishHideAnimation() {
        if (isActive() && phase === 'hide-animating') done();
    }
    function isVisible() {
        return phase === 'shown' || phase === 'waiting-to-hide' || phase === 'hide-animating';
    }
    function getInitialMouse() {
        if (entry.source.type === 'mouse') return entry.source.mouse;
        return null;
    }
    function start() {
        var shouldAlwaysFadeIn = (0, $dU8Y3.fg)('platform_dst_nav4_side_nav_resize_tooltip_feedback') ? entry.shouldAlwaysFadeIn : false;
        var showImmediately = Boolean($6e217632bbb5b2c1$var$active && $6e217632bbb5b2c1$var$active.isVisible()) && !shouldAlwaysFadeIn;
        // If there was an active tooltip; we tell it to remove itself at once!
        if ($6e217632bbb5b2c1$var$active) {
            (0, $7f975c83cfcc5eb1$export$eaf678f6f93f5250)();
            $6e217632bbb5b2c1$var$active.entry.hide({
                isImmediate: true
            });
            $6e217632bbb5b2c1$var$active.entry.done();
            $6e217632bbb5b2c1$var$active = null;
        }
        // this tooltip is now the active tooltip
        $6e217632bbb5b2c1$var$active = {
            entry: entry,
            isVisible: isVisible
        };
        function show() {
            phase = 'shown';
            entry.show({
                isImmediate: showImmediately
            });
        }
        if (showImmediately) {
            show();
            return;
        }
        phase = 'waiting-to-show';
        (0, $7f975c83cfcc5eb1$export$5f4d6617421d489b)(show, entry.delay);
    }
    // let's get started!
    start();
    var result = {
        keep: keep,
        abort: cleanup,
        isActive: isActive,
        requestHide: requestHide,
        finishHideAnimation: finishHideAnimation,
        // Removing old `mousePosition` behind gate because it stored a function.
        // With the gate we just store the coords which are easier to work with.
        mousePosition: (0, $dU8Y3.fg)('platform_dst_nav4_side_nav_resize_tooltip_feedback') ? undefined : getInitialMouse(),
        mousePos: entry.source.type === 'mouse' && (0, $dU8Y3.fg)('platform_dst_nav4_side_nav_resize_tooltip_feedback') ? {
            clientX: entry.source.clientX,
            clientY: entry.source.clientY
        } : null
    };
    return result;
}



var $h8qvJ = parcelRequire("h8qvJ");
function $6671774545117937$export$2e2bcd8739ae039(prefix, shouldRenderId) {
    var seed = (0, $h8qvJ.useIdSeed)();
    return shouldRenderId ? "".concat(seed(prefix)) : undefined;
}


/* tooltip-container.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");
/* tooltip-primitive.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");
/* tooltip-shortcut.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");
var $eaf4ddf998a2f107$var$styles = {
    shortcutSegmentsContainer: "_zulpv77o _1e0c1txw _1q511b66 _85i5v77o",
    shortcutSegment: "_11c8wadc _2rkolb4i _1dqonqa1 _189ee4h9 _1h6d1ihb _1e0c1txw _4cvr1h6o _4t3i1k92 _vchhusvi _1q51v77o _85i5v77o _bozg12x7 _y4ti12x7 _16qsn7od _1254n7od _cgnln7od _syazn7od _ahbqn7od _12l2n7od _1pfhn7od _6rthn7od _1ul9n7od _w19jn7od _bfhk261p"
};
var $eaf4ddf998a2f107$export$5bcbc43c84236222 = function TooltipShortcut(_ref) {
    var shortcut = _ref.shortcut;
    return /*#__PURE__*/ $5FkrB.createElement("div", {
        className: (0, $970q7.default)([
            $eaf4ddf998a2f107$var$styles.shortcutSegmentsContainer
        ])
    }, shortcut.map(function(segment, index) {
        return /*#__PURE__*/ $5FkrB.createElement("kbd", {
            key: "".concat(segment, "-").concat(index),
            className: (0, $970q7.default)([
                $eaf4ddf998a2f107$var$styles.shortcutSegment
            ])
        }, segment);
    }));
};


var $76f42a71da83c271$var$primitiveStyles = null;
/**
 * The lower level component for rendering a tooltip.
 */ var $76f42a71da83c271$var$TooltipPrimitive = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function TooltipPrimitive(_ref, ref) {
    var style = _ref.style, className = _ref.className, children = _ref.children, placement = _ref.placement, testId = _ref.testId, onMouseOut = _ref.onMouseOut, onMouseOver = _ref.onMouseOver, id = _ref.id, shortcut = _ref.shortcut;
    return /*#__PURE__*/ $5FkrB.createElement("div", {
        ref: ref,
        style: style,
        "data-testid": testId ? "".concat(testId, "--wrapper") : undefined
    }, /*#__PURE__*/ $5FkrB.createElement("div", {
        role: "tooltip",
        className: (0, $970q7.default)([
            "_80om73ad",
            className
        ]),
        onMouseOut: onMouseOut,
        onMouseOver: onMouseOver,
        "data-placement": placement,
        "data-testid": testId,
        id: id
    }, children, shortcut && /*#__PURE__*/ $5FkrB.createElement((0, $eaf4ddf998a2f107$export$5bcbc43c84236222), {
        shortcut: shortcut
    })));
});
$76f42a71da83c271$var$TooltipPrimitive.displayName = 'TooltipPrimitive';
var $76f42a71da83c271$export$2e2bcd8739ae039 = $76f42a71da83c271$var$TooltipPrimitive;


var $1019c6f57b5eee75$var$styles = {
    base: "_2rkofajl _11c8wadc _vchhusvi _p12fp3fh _bfhkgkf6 _syaz15cr _152tze3t _1e02ze3t _1i4q1hna _1q511b66 _85i51b66 _y4ti12x7 _bozg12x7 _slp31hna",
    truncate: "_1reo15vq _18m915vq _p12f1pna _1bto1l2s _o5721q9c"
};
/**
 * Used as the default tooltip container component for the exported `Tooltip` component.
 * Adds some styles to the tooltip primitive.
 */ var $1019c6f57b5eee75$var$TooltipContainer = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function TooltipContainer(_ref, ref) {
    var style = _ref.style, className = _ref.className, children = _ref.children, truncate = _ref.truncate, placement = _ref.placement, testId = _ref.testId, onMouseOut = _ref.onMouseOut, onMouseOver = _ref.onMouseOver, id = _ref.id, shortcut = _ref.shortcut;
    return /*#__PURE__*/ $5FkrB.createElement((0, $76f42a71da83c271$export$2e2bcd8739ae039), {
        ref: ref,
        style: style,
        className: (0, $970q7.default)([
            $1019c6f57b5eee75$var$styles.base,
            truncate && $1019c6f57b5eee75$var$styles.truncate,
            className
        ]),
        placement: placement,
        testId: testId,
        id: id,
        onMouseOut: onMouseOut,
        onMouseOver: onMouseOver,
        shortcut: shortcut
    }, children);
});
$1019c6f57b5eee75$var$TooltipContainer.displayName = 'TooltipContainer';
var $1019c6f57b5eee75$export$2e2bcd8739ae039 = $1019c6f57b5eee75$var$TooltipContainer;


function $cf3ea0b5f3269fe8$export$642213d516a9b928(mouseCoordinates) {
    var safeMouse = mouseCoordinates || {
        top: 0,
        left: 0
    };
    var getBoundingClientRect = function getBoundingClientRect() {
        return {
            top: safeMouse.top,
            left: safeMouse.left,
            bottom: safeMouse.top,
            right: safeMouse.left,
            width: 0,
            height: 0
        };
    };
    return {
        getBoundingClientRect: getBoundingClientRect,
        clientWidth: 0,
        clientHeight: 0
    };
}
function $cf3ea0b5f3269fe8$export$2e68479e0a5d8746(mousePos, _ref) {
    var targetElement = _ref.targetElement, tooltipPosition = _ref.tooltipPosition;
    if (tooltipPosition === 'mouse') return {
        getBoundingClientRect: function getBoundingClientRect() {
            return DOMRect.fromRect({
                x: mousePos.clientX,
                y: mousePos.clientY,
                width: 0,
                height: 0
            });
        }
    };
    var targetRect = targetElement.getBoundingClientRect();
    if (tooltipPosition === 'mouse-x') return {
        getBoundingClientRect: function getBoundingClientRect() {
            return DOMRect.fromRect({
                x: mousePos.clientX,
                y: targetRect.top,
                width: 0,
                height: targetRect.height
            });
        }
    };
    if (tooltipPosition === 'mouse-y') return {
        getBoundingClientRect: function getBoundingClientRect() {
            return DOMRect.fromRect({
                x: targetRect.left,
                y: mousePos.clientY,
                width: targetRect.width,
                height: 0
            });
        }
    };
    throw new Error("Invalid tooltip position for virtual element: ".concat(tooltipPosition));
}


function $a65c42b28ba16ee0$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $a65c42b28ba16ee0$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $a65c42b28ba16ee0$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $a65c42b28ba16ee0$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $a65c42b28ba16ee0$var$tooltipZIndex = (0, $d37e64f35eec0d40$export$7be255094ccdc533).tooltip();
var $a65c42b28ba16ee0$var$analyticsAttributes = {
    componentName: 'tooltip',
    packageName: "@atlaskit/tooltip",
    packageVersion: "20.14.1"
};
// Inverts motion direction
var $a65c42b28ba16ee0$var$invertedDirection = {
    top: 'bottom',
    bottom: 'top',
    left: 'right',
    right: 'left'
};
/**
 * Converts a Popper placement to it's general direction.
 *
 * @param placement - Popper Placement value, e.g. 'top-start'
 * @returns Popper Direction, e.g. 'top'
 */ var $a65c42b28ba16ee0$var$getDirectionFromPlacement = function getDirectionFromPlacement(placement) {
    return placement.split('-')[0];
};
/**
 * __Tooltip__
 *
 * A tooltip is a floating, non-actionable label used to explain a user interface element or feature.
 */ function $a65c42b28ba16ee0$var$Tooltip(_ref) {
    var children = _ref.children, _ref$position = _ref.position, position = _ref$position === void 0 ? 'bottom' : _ref$position, _ref$mousePosition = _ref.mousePosition, mousePosition = _ref$mousePosition === void 0 ? 'bottom' : _ref$mousePosition, content = _ref.content, _ref$truncate = _ref.truncate, truncate = _ref$truncate === void 0 ? false : _ref$truncate, _ref$component = _ref.component, Container = _ref$component === void 0 ? (0, $1019c6f57b5eee75$export$2e2bcd8739ae039) : _ref$component, _ref$tag = _ref.tag, TargetContainer = _ref$tag === void 0 ? 'div' : _ref$tag, testId = _ref.testId, _ref$delay = _ref.delay, delay = _ref$delay === void 0 ? 300 : _ref$delay, _ref$onShow = _ref.onShow, onShow = _ref$onShow === void 0 ? (0, $eVb4V.default) : _ref$onShow, _ref$onHide = _ref.onHide, onHide = _ref$onHide === void 0 ? (0, $eVb4V.default) : _ref$onHide, canAppear = _ref.canAppear, _ref$hideTooltipOnCli = _ref.hideTooltipOnClick, hideTooltipOnClick = _ref$hideTooltipOnCli === void 0 ? false : _ref$hideTooltipOnCli, _ref$hideTooltipOnMou = _ref.hideTooltipOnMouseDown, hideTooltipOnMouseDown = _ref$hideTooltipOnMou === void 0 ? false : _ref$hideTooltipOnMou, analyticsContext = _ref.analyticsContext, _ref$strategy = _ref.strategy, strategy = _ref$strategy === void 0 ? 'fixed' : _ref$strategy, _ref$ignoreTooltipPoi = _ref.ignoreTooltipPointerEvents, ignoreTooltipPointerEvents = _ref$ignoreTooltipPoi === void 0 ? false : _ref$ignoreTooltipPoi, _ref$isScreenReaderAn = _ref.isScreenReaderAnnouncementDisabled, isScreenReaderAnnouncementDisabled = _ref$isScreenReaderAn === void 0 ? false : _ref$isScreenReaderAn, shortcut = _ref.shortcut, _ref$UNSAFE_shouldAlw = _ref.UNSAFE_shouldAlwaysFadeIn, shouldAlwaysFadeIn = _ref$UNSAFE_shouldAlw === void 0 ? false : _ref$UNSAFE_shouldAlw, _ref$UNSAFE_shouldRen = _ref.UNSAFE_shouldRenderToParent, UNSAFE_shouldRenderToParent = _ref$UNSAFE_shouldRen === void 0 ? false : _ref$UNSAFE_shouldRen;
    // Not using a gate for this check. When the gate is disabled `mouse-y` and `mouse-x` are treated as `mouse`.
    var isMousePosition = position === 'mouse' || position === 'mouse-y' || position === 'mouse-x';
    var tooltipPosition = isMousePosition ? mousePosition : position;
    var onShowHandler = (0, $05a56ef091e45a2e$export$1a04351537078b55)($a65c42b28ba16ee0$var$_objectSpread({
        fn: onShow,
        action: 'displayed',
        analyticsData: analyticsContext
    }, $a65c42b28ba16ee0$var$analyticsAttributes));
    var onHideHandler = (0, $05a56ef091e45a2e$export$1a04351537078b55)($a65c42b28ba16ee0$var$_objectSpread({
        fn: onHide,
        action: 'hidden',
        analyticsData: analyticsContext
    }, $a65c42b28ba16ee0$var$analyticsAttributes));
    var apiRef = (0, $5FkrB.useRef)(null);
    var _useState = (0, $5FkrB.useState)('hide'), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), state = _useState2[0], setState = _useState2[1];
    var targetRef = (0, $5FkrB.useRef)(null);
    var containerRef = (0, $5FkrB.useRef)(null);
    // This function is deliberately _not_ memoized as it needs to re-run every render
    // to pick up any child ref changes. If you use render props you don't have this issue.
    var setImplicitRefFromChildren = function setImplicitRefFromChildren(node) {
        containerRef.current = node;
        targetRef.current = node ? node.firstElementChild : null;
    };
    // This is memoized and passed into the render props callback.
    var setDirectRef = (0, $5FkrB.useCallback)(function(node) {
        targetRef.current = node;
    }, []);
    // Putting a few things into refs so that we don't have to break memoization
    var stableState = (0, $3UUXy.default)(state);
    // These props are placed in separate refs instead of a single object to reduce memory usage.
    // Placing them in the same object previously caused an increase in the number of JavaScript event listeners
    // before garbage collection.
    var onShowHandlerStable = (0, $3UUXy.default)(onShowHandler);
    var onHideHandlerStable = (0, $3UUXy.default)(onHideHandler);
    var delayStable = (0, $3UUXy.default)(delay);
    var canAppearStable = (0, $3UUXy.default)(canAppear);
    var hasCalledShowHandler = (0, $5FkrB.useRef)(false);
    var shouldAlwaysFadeInStable = (0, $3UUXy.default)(shouldAlwaysFadeIn);
    var start = (0, $5FkrB.useCallback)(function(api) {
        // @ts-ignore
        apiRef.current = api;
        hasCalledShowHandler.current = false;
    }, []);
    var done = (0, $5FkrB.useCallback)(function() {
        if (!apiRef.current) return;
        // Only call onHideHandler if we have called onShowHandler
        if (hasCalledShowHandler.current) onHideHandlerStable.current();
        // @ts-ignore
        apiRef.current = null;
        // @ts-ignore
        hasCalledShowHandler.current = false;
        // just in case
        setState('hide');
    }, [
        onHideHandlerStable
    ]);
    var abort = (0, $5FkrB.useCallback)(function() {
        if (!apiRef.current) return;
        apiRef.current.abort();
        // Only call onHideHandler if we have called onShowHandler
        if (hasCalledShowHandler.current) onHideHandlerStable.current();
        // @ts-ignore
        apiRef.current = null;
    }, [
        onHideHandlerStable
    ]);
    (0, $5FkrB.useEffect)(function mount() {
        return function unmount() {
            if (apiRef.current) abort();
        };
    }, [
        abort
    ]);
    var isDraggingRef = (0, $5FkrB.useRef)(false);
    (0, $5FkrB.useEffect)(function() {
        return (0, $04c4752fbeced1ac$export$6503ec6e8aabbaf)({
            onRegister: function onRegister(_ref2) {
                var isDragging = _ref2.isDragging;
                isDraggingRef.current = isDragging;
            },
            onDragStart: function onDragStart() {
                var _apiRef$current;
                /**
         * Hiding any visible tooltips when a drag starts because otherwise it
         * looks janky (disappears and reappears), and is not required.
         */ (_apiRef$current = apiRef.current) === null || _apiRef$current === void 0 || _apiRef$current.requestHide({
                    isImmediate: true
                });
                isDraggingRef.current = true;
            },
            onDragEnd: function onDragEnd() {
                isDraggingRef.current = false;
            }
        });
    }, []);
    var tryShowTooltip = (0, $5FkrB.useCallback)(function(source) {
        var _canAppearStable$curr;
        /**
     * Prevent tooltips from being shown during a drag. This can occur with
     * the native drag and drop API, where some pointer events can fire
     * when they should not and lead to jank with tooltips.
     */ if (isDraggingRef.current) return;
        // Another tooltip is has been active but we still have the old `api`
        // around. We need to finish up the last usage.
        // Note: just being safe - this should not happen
        if (apiRef.current && !apiRef.current.isActive()) abort();
        // This tooltip is already active, we can exit
        if (apiRef.current && apiRef.current.isActive()) {
            apiRef.current.keep();
            return;
        }
        /**
     * Check if tooltip is allowed to show.
     *
     * Once a tooltip has started, or has scheduled to start
     * we won't be checking `canAppear` again.
     *
     * - We don't want tooltips to disappear once they are shown
     * - For consistency, we start after a single positive `canAppear`.
     *   Otherwise the amount of times we ask consumers would depend on
     *   how many times we get a "mousemove", which _could_ lead to situations
     *   where moving the mouse could result in a different outcome to if
     *   the mouse was not moved.
     */ if (canAppearStable.current && !((_canAppearStable$curr = canAppearStable.current) !== null && _canAppearStable$curr !== void 0 && _canAppearStable$curr.call(canAppearStable))) return;
        var entry = {
            source: source,
            delay: delayStable.current,
            show: function show(_ref3) {
                var isImmediate = _ref3.isImmediate;
                // Call the onShow handler if it hasn't been called yet
                if (!hasCalledShowHandler.current) {
                    hasCalledShowHandler.current = true;
                    onShowHandlerStable.current();
                }
                setState(!isImmediate ? 'fade-in' : 'show-immediate');
            },
            hide: function hide(_ref4) {
                var isImmediate = _ref4.isImmediate;
                if (isImmediate) setState('hide');
                else setState('before-fade-out');
            },
            done: done,
            shouldAlwaysFadeIn: (0, $dU8Y3.fg)('platform_dst_nav4_side_nav_resize_tooltip_feedback') ? shouldAlwaysFadeInStable.current : false
        };
        var api = (0, $6e217632bbb5b2c1$export$57bf213be019eeb0)(entry);
        start(api);
    }, [
        canAppearStable,
        delayStable,
        done,
        start,
        abort,
        onShowHandlerStable,
        shouldAlwaysFadeInStable
    ]);
    var hideTooltipOnEsc = (0, $5FkrB.useCallback)(function() {
        var _apiRef$current2;
        (_apiRef$current2 = apiRef.current) === null || _apiRef$current2 === void 0 || _apiRef$current2.requestHide({
            isImmediate: true
        });
    }, [
        apiRef
    ]);
    (0, $hy47X.default)({
        onClose: hideTooltipOnEsc,
        isDisabled: state === 'hide' || state === 'fade-out'
    });
    (0, $5FkrB.useEffect)(function() {
        if (state === 'hide') return 0, $eVb4V.default;
        if (state === 'before-fade-out') setState('fade-out');
        var unbind = (0, $7QpUe.bind)(window, {
            type: 'scroll',
            listener: function listener() {
                if (apiRef.current) apiRef.current.requestHide({
                    isImmediate: true
                });
            },
            options: {
                capture: true,
                passive: true,
                once: true
            }
        });
        return unbind;
    }, [
        state
    ]);
    var onMouseDown = (0, $5FkrB.useCallback)(function() {
        if (hideTooltipOnMouseDown && apiRef.current) apiRef.current.requestHide({
            isImmediate: true
        });
    }, [
        hideTooltipOnMouseDown
    ]);
    var onClick = (0, $5FkrB.useCallback)(function() {
        if (hideTooltipOnClick && apiRef.current) apiRef.current.requestHide({
            isImmediate: true
        });
    }, [
        hideTooltipOnClick
    ]);
    // Ideally we would be using onMouseEnter here, but
    // because we are binding the event to the target parent
    // we need to listen for the mouseover of all sub elements
    // This means when moving along a tooltip we are quickly toggling
    // between api.requestHide and api.keep. This it not ideal
    var onMouseOver = (0, $5FkrB.useCallback)(function(event) {
        // Ignoring events from the container ref
        if (containerRef.current && event.target === containerRef.current) return;
        // Using prevent default as a signal that parent tooltips
        if (event.defaultPrevented) return;
        event.preventDefault();
        var source = isMousePosition ? {
            type: 'mouse',
            // TODO: ideally not recalculating this object each time
            // Removing old `mouse` behind gate because it stored a function.
            // With the gate we just store the coords which are easier to work with.
            mouse: (0, $dU8Y3.fg)('platform_dst_nav4_side_nav_resize_tooltip_feedback') ? undefined : (0, $cf3ea0b5f3269fe8$export$642213d516a9b928)({
                left: event.clientX,
                top: event.clientY
            }),
            clientX: event.clientX,
            clientY: event.clientY
        } : {
            type: 'keyboard'
        };
        tryShowTooltip(source);
    }, [
        isMousePosition,
        tryShowTooltip
    ]);
    // Ideally we would be using onMouseEnter here, but
    // because we are binding the event to the target parent
    // we need to listen for the mouseout of all sub elements
    // This means when moving along a tooltip we are quickly toggling
    // between api.requestHide and api.keep. This it not ideal
    var onMouseOut = (0, $5FkrB.useCallback)(function(event) {
        // Ignoring events from the container ref
        if (containerRef.current && event.target === containerRef.current) return;
        // Using prevent default as a signal that parent tooltips
        if (event.defaultPrevented) return;
        event.preventDefault();
        if (apiRef.current) apiRef.current.requestHide({
            isImmediate: false
        });
    }, []);
    var onMouseMove = isMousePosition ? function(event) {
        var _apiRef$current3;
        if ((_apiRef$current3 = apiRef.current) !== null && _apiRef$current3 !== void 0 && _apiRef$current3.isActive()) {
            if (!(0, $dU8Y3.fg)('platform_dst_nav4_side_nav_resize_tooltip_feedback')) apiRef.current.mousePosition = (0, $cf3ea0b5f3269fe8$export$642213d516a9b928)({
                left: event.clientX,
                top: event.clientY
            });
            apiRef.current.mousePos = {
                clientX: event.clientX,
                clientY: event.clientY
            };
        }
    } : undefined;
    var onMouseOverTooltip = (0, $5FkrB.useCallback)(function() {
        if (apiRef.current && apiRef.current.isActive()) {
            apiRef.current.keep();
            return;
        }
    }, []);
    var onFocus = (0, $5FkrB.useCallback)(function(e) {
        // Check if focus-visible
        // Prevents tooltips from showing when focus is not visible,
        // i.e., when focus is moved onto tooltip trigger inside a popup on open
        try {
            if (!e.target.matches(':focus-visible')) return;
        } catch (_unused) {
        // Ignore errors from environments that don't support :focus-visible
        }
        // TODO: this does not play well with `hideTooltipOnMouseDown`
        // as "focus" will occur after the "mousedown".
        tryShowTooltip({
            type: 'keyboard'
        });
    }, [
        tryShowTooltip
    ]);
    var onBlur = (0, $5FkrB.useCallback)(function() {
        if (apiRef.current) apiRef.current.requestHide({
            isImmediate: false
        });
    }, []);
    var onAnimationFinished = (0, $5FkrB.useCallback)(function(transition) {
        // Using lastState here because motion is not picking up the latest value
        if (transition === 'exiting' && stableState.current === 'fade-out' && apiRef.current) // @ts-ignore: refs are writeable
        apiRef.current.finishHideAnimation();
    }, [
        stableState
    ]);
    // Doing a cast because typescript is struggling to narrow the type
    var CastTargetContainer = TargetContainer;
    var shouldRenderTooltipPopup = state !== 'hide' && Boolean(content);
    var shouldRenderHiddenContent = !isScreenReaderAnnouncementDisabled && shouldRenderTooltipPopup;
    var shouldRenderTooltipChildren = state !== 'hide' && state !== 'fade-out';
    var handleOpenLayerObserverCloseSignal = (0, $5FkrB.useCallback)(function() {
        var _apiRef$current4;
        (_apiRef$current4 = apiRef.current) === null || _apiRef$current4 === void 0 || _apiRef$current4.requestHide({
            isImmediate: true
        });
    }, []);
    (0, $iUCre.useNotifyOpenLayerObserver)({
        // Layer is only visually open if both the tooltip popup (container) and children are rendered.
        isOpen: shouldRenderTooltipPopup && shouldRenderTooltipChildren,
        /**
     * We don't strictly need to provide an onClose callback at this time, as there is
     * already code that handles hiding the tooltip when a drag is started (and the only
     * usage right now is closing all layers when the user resizes the side nav).
     *
     * However, for future-proofing and semantic reasons, it makes sense to close the tooltip
     * whenever the open layer observer requests a close.
     */ onClose: handleOpenLayerObserverCloseSignal
    });
    var getReferenceElement = function getReferenceElement() {
        var _apiRef$current5, _apiRef$current6;
        if (isMousePosition && (_apiRef$current5 = apiRef.current) !== null && _apiRef$current5 !== void 0 && _apiRef$current5.mousePos && targetRef.current && (0, $dU8Y3.fg)('platform_dst_nav4_side_nav_resize_tooltip_feedback')) return (0, $cf3ea0b5f3269fe8$export$2e68479e0a5d8746)(apiRef.current.mousePos, {
            targetElement: targetRef.current,
            tooltipPosition: position
        });
        if (isMousePosition && (_apiRef$current6 = apiRef.current) !== null && _apiRef$current6 !== void 0 && _apiRef$current6.mousePosition && !(0, $dU8Y3.fg)('platform_dst_nav4_side_nav_resize_tooltip_feedback')) {
            var _apiRef$current7;
            return (_apiRef$current7 = apiRef.current) === null || _apiRef$current7 === void 0 ? void 0 : _apiRef$current7.mousePosition;
        }
        return targetRef.current || undefined;
    };
    var tooltipIdForHiddenContent = (0, $6671774545117937$export$2e2bcd8739ae039)('tooltip', shouldRenderHiddenContent);
    var tooltipTriggerProps = {
        onMouseOver: onMouseOver,
        onMouseOut: onMouseOut,
        onMouseMove: onMouseMove,
        onMouseDown: onMouseDown,
        onClick: onClick,
        onFocus: onFocus,
        onBlur: onBlur
    };
    // Don't set `data-testid` unless it's defined, as it's not in the interface.
    if (testId) // Adding `data-testid` to the TriggerProps interface breaks Buttons, so we use type assertion
    tooltipTriggerProps['data-testid'] = "".concat(testId, "--container");
    // This useEffect is purely for managing the aria attribute when using the
    // wrapped children approach.
    var isChildrenAFunction = typeof children === 'function';
    (0, $5FkrB.useEffect)(function() {
        if (isChildrenAFunction) return;
        // If `children` is _not_ a function, we are stepping outside of the public
        // API to add a `aria-describedby` attribute.
        var target = targetRef.current;
        if (!target || !tooltipIdForHiddenContent) return;
        target.setAttribute('aria-describedby', tooltipIdForHiddenContent);
        return function() {
            return target.removeAttribute('aria-describedby');
        };
    }, [
        isChildrenAFunction,
        tooltipIdForHiddenContent
    ]);
    var hiddenContent = shouldRenderHiddenContent ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("span", {
        "data-testid": testId ? "".concat(testId, "-hidden") : undefined,
        hidden: true,
        id: tooltipIdForHiddenContent
    }, typeof content === 'function' ? content({}) : content) : null;
    var PopperWrapper = UNSAFE_shouldRenderToParent && (0, $dU8Y3.fg)('platform_dst_nav4_side_nav_resize_tooltip_feedback') ? (0, $5FkrB.Fragment) : $a65c42b28ba16ee0$var$TooltipPortal;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).Fragment, null, typeof children === 'function' ? /*#__PURE__*/ // once we deprecate the wrapped approach, we can put the aria
    // attribute back into the tooltipTriggerProps and make it required
    // instead of optional in `types`
    (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).Fragment, null, children($a65c42b28ba16ee0$var$_objectSpread($a65c42b28ba16ee0$var$_objectSpread({}, tooltipTriggerProps), {}, {
        'aria-describedby': tooltipIdForHiddenContent,
        ref: setDirectRef
    })), hiddenContent) : /*#__PURE__*/ // @ts-ignore
    (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(CastTargetContainer, (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, tooltipTriggerProps, {
        ref: setImplicitRefFromChildren,
        role: "presentation"
    }), children, hiddenContent), shouldRenderTooltipPopup ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(PopperWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $5K5L9.Popper), {
        placement: tooltipPosition,
        referenceElement: getReferenceElement(),
        strategy: strategy
    }, function(_ref5) {
        var ref = _ref5.ref, style = _ref5.style, update = _ref5.update, placement = _ref5.placement;
        // Invert the entrance and exit directions.
        // E.g. a tooltip's position is on the 'right', it should enter from and exit to the 'left'
        // This gives the effect the tooltip is appearing from the target
        var direction = isMousePosition ? undefined : $a65c42b28ba16ee0$var$invertedDirection[$a65c42b28ba16ee0$var$getDirectionFromPlacement(placement)];
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $86260cff212ffed2$export$2e2bcd8739ae039), {
            appear: true
        }, shouldRenderTooltipChildren && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $9bd9df748b04f613$export$2e2bcd8739ae039), {
            distance: "constant",
            entranceDirection: direction,
            exitDirection: direction,
            onFinish: onAnimationFinished,
            duration: state !== 'show-immediate' ? 'medium' : 'none'
        }, function(_ref6) {
            var className = _ref6.className;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(Container, {
                ref: ref,
                className: "Tooltip ".concat(className),
                style: $a65c42b28ba16ee0$var$_objectSpread($a65c42b28ba16ee0$var$_objectSpread({}, style), ignoreTooltipPointerEvents && {
                    pointerEvents: 'none'
                }),
                truncate: truncate,
                placement: tooltipPosition,
                testId: getReferenceElement() ? testId : testId && "".concat(testId, "--unresolved"),
                onMouseOut: onMouseOut,
                onMouseOver: onMouseOverTooltip,
                shortcut: shortcut
            }, typeof content === 'function' ? content({
                update: update
            }) : content);
        }));
    })) : null);
}
var $a65c42b28ba16ee0$export$2e2bcd8739ae039 = $a65c42b28ba16ee0$var$Tooltip;
var $a65c42b28ba16ee0$var$TooltipPortal = function TooltipPortal(_ref7) {
    var children = _ref7.children;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $3abdb7aea1ec0147$export$2e2bcd8739ae039), {
        zIndex: $a65c42b28ba16ee0$var$tooltipZIndex
    }, children);
};






var $0c4c08ddec83e35f$var$_excluded = [
    "aria-label",
    "aria-labelledby",
    "analyticsContext",
    "appearance",
    "autoFocus",
    "icon",
    "interactionName",
    "isDisabled",
    "isLoading",
    "isSelected",
    "isTooltipDisabled",
    "label",
    "onClick",
    "onClickCapture",
    "onKeyDownCapture",
    "onKeyUpCapture",
    "onMouseDownCapture",
    "onMouseUpCapture",
    "onPointerDownCapture",
    "onPointerUpCapture",
    "onTouchEndCapture",
    "onTouchStartCapture",
    "shape",
    "spacing",
    "testId",
    "tooltip",
    "type"
], $0c4c08ddec83e35f$var$_excluded2 = [
    "className",
    "css",
    "as",
    "style"
];
/**
 * __Icon Button__
 *
 * Renders an icon-only button lets people take a common and recognizable action where space is limited.
 *
 * - [Examples](https://atlassian.design/components/button/icon-button/examples)
 * - [Code](https://atlassian.design/components/button/icon-button/code)
 * - [Usage](https://atlassian.design/components/button/icon-button/usage)
 */ var $0c4c08ddec83e35f$var$IconButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).forwardRef(function Button(_ref, ref) {
    var _tooltip$content;
    var preventedAriaLabel = _ref['aria-label'], ariaLabelledBy = _ref['aria-labelledby'], analyticsContext = _ref.analyticsContext, appearance = _ref.appearance, autoFocus = _ref.autoFocus, icon = _ref.icon, interactionName = _ref.interactionName, isDisabled = _ref.isDisabled, _ref$isLoading = _ref.isLoading, isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading, isSelected = _ref.isSelected, _ref$isTooltipDisable = _ref.isTooltipDisabled, isTooltipDisabled = _ref$isTooltipDisable === void 0 ? true : _ref$isTooltipDisable, label = _ref.label, _onClick = _ref.onClick, onClickCapture = _ref.onClickCapture, onKeyDownCapture = _ref.onKeyDownCapture, onKeyUpCapture = _ref.onKeyUpCapture, onMouseDownCapture = _ref.onMouseDownCapture, onMouseUpCapture = _ref.onMouseUpCapture, onPointerDownCapture = _ref.onPointerDownCapture, onPointerUpCapture = _ref.onPointerUpCapture, onTouchEndCapture = _ref.onTouchEndCapture, onTouchStartCapture = _ref.onTouchStartCapture, shape = _ref.shape, spacing = _ref.spacing, testId = _ref.testId, tooltip = _ref.tooltip, _ref$type = _ref.type, type = _ref$type === void 0 ? 'button' : _ref$type, unsafeRest = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $0c4c08ddec83e35f$var$_excluded);
    // @ts-expect-error
    var _className = unsafeRest.className, _css = unsafeRest.css, _as = unsafeRest.as, _style = unsafeRest.style, saferRest = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(unsafeRest, $0c4c08ddec83e35f$var$_excluded2);
    if (isTooltipDisabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $11dd84bac22fa83e$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, saferRest, {
        ref: ref,
        appearance: appearance,
        autoFocus: autoFocus,
        isDisabled: isDisabled,
        isLoading: isLoading,
        isSelected: isSelected,
        isIconButton: true,
        isCircle: shape === 'circle',
        hasIconBefore: !!icon,
        spacing: spacing,
        ariaLabelledBy: ariaLabelledBy,
        onClick: _onClick,
        onClickCapture: onClickCapture,
        onKeyDownCapture: onKeyDownCapture,
        onKeyUpCapture: onKeyUpCapture,
        onMouseDownCapture: onMouseDownCapture,
        onMouseUpCapture: onMouseUpCapture,
        onPointerDownCapture: onPointerDownCapture,
        onPointerUpCapture: onPointerUpCapture,
        onTouchStartCapture: onTouchStartCapture,
        onTouchEndCapture: onTouchEndCapture,
        testId: testId,
        componentName: "IconButton",
        analyticsContext: analyticsContext,
        type: type,
        interactionName: interactionName
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $53ad6069579b4666$export$2e2bcd8739ae039), {
        type: "icon",
        isLoading: isLoading
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $a4b6b6a5fbbf2f99$export$2e2bcd8739ae039), {
        icon: icon
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $e3573d3717f44b5e$export$2e2bcd8739ae039), null, label)));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $a65c42b28ba16ee0$export$2e2bcd8739ae039), {
        content: (_tooltip$content = tooltip === null || tooltip === void 0 ? void 0 : tooltip.content) !== null && _tooltip$content !== void 0 ? _tooltip$content : label,
        testId: tooltip === null || tooltip === void 0 ? void 0 : tooltip.testId,
        position: tooltip === null || tooltip === void 0 ? void 0 : tooltip.position,
        delay: tooltip === null || tooltip === void 0 ? void 0 : tooltip.delay,
        onShow: tooltip === null || tooltip === void 0 ? void 0 : tooltip.onShow,
        onHide: tooltip === null || tooltip === void 0 ? void 0 : tooltip.onHide,
        mousePosition: tooltip === null || tooltip === void 0 ? void 0 : tooltip.mousePosition,
        analyticsContext: tooltip === null || tooltip === void 0 ? void 0 : tooltip.analyticsContext,
        strategy: tooltip === null || tooltip === void 0 ? void 0 : tooltip.strategy,
        tag: tooltip === null || tooltip === void 0 ? void 0 : tooltip.tag,
        truncate: tooltip === null || tooltip === void 0 ? void 0 : tooltip.truncate,
        component: tooltip === null || tooltip === void 0 ? void 0 : tooltip.component,
        hideTooltipOnClick: tooltip === null || tooltip === void 0 ? void 0 : tooltip.hideTooltipOnClick,
        hideTooltipOnMouseDown: tooltip === null || tooltip === void 0 ? void 0 : tooltip.hideTooltipOnMouseDown,
        ignoreTooltipPointerEvents: tooltip === null || tooltip === void 0 ? void 0 : tooltip.ignoreTooltipPointerEvents,
        shortcut: tooltip === null || tooltip === void 0 ? void 0 : tooltip.shortcut
    }, function(triggerProps) {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $11dd84bac22fa83e$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, saferRest, {
            appearance: appearance,
            autoFocus: autoFocus,
            isDisabled: isDisabled,
            isLoading: isLoading,
            isSelected: isSelected,
            isIconButton: true,
            isCircle: shape === 'circle',
            hasIconBefore: false,
            spacing: spacing,
            ariaLabelledBy: ariaLabelledBy,
            onClick: function onClick(e, analyticsEvent) {
                var _triggerProps$onClick;
                _onClick === null || _onClick === void 0 || _onClick(e, analyticsEvent);
                (_triggerProps$onClick = triggerProps.onClick) === null || _triggerProps$onClick === void 0 || _triggerProps$onClick.call(triggerProps, e);
            },
            onMouseOver: function onMouseOver(e) {
                var _triggerProps$onMouse, _saferRest$onMouseOve;
                (_triggerProps$onMouse = triggerProps.onMouseOver) === null || _triggerProps$onMouse === void 0 || _triggerProps$onMouse.call(triggerProps, e);
                (_saferRest$onMouseOve = saferRest.onMouseOver) === null || _saferRest$onMouseOve === void 0 || _saferRest$onMouseOve.call(saferRest, e);
            },
            onMouseOut: function onMouseOut(e) {
                var _triggerProps$onMouse2, _saferRest$onMouseOut;
                (_triggerProps$onMouse2 = triggerProps.onMouseOut) === null || _triggerProps$onMouse2 === void 0 || _triggerProps$onMouse2.call(triggerProps, e);
                (_saferRest$onMouseOut = saferRest.onMouseOut) === null || _saferRest$onMouseOut === void 0 || _saferRest$onMouseOut.call(saferRest, e);
            },
            onMouseMove: function onMouseMove(e) {
                var _triggerProps$onMouse3, _saferRest$onMouseMov;
                (_triggerProps$onMouse3 = triggerProps.onMouseMove) === null || _triggerProps$onMouse3 === void 0 || _triggerProps$onMouse3.call(triggerProps, e);
                (_saferRest$onMouseMov = saferRest.onMouseMove) === null || _saferRest$onMouseMov === void 0 || _saferRest$onMouseMov.call(saferRest, e);
            },
            onMouseDown: function onMouseDown(e) {
                var _triggerProps$onMouse4, _saferRest$onMouseDow;
                (_triggerProps$onMouse4 = triggerProps.onMouseDown) === null || _triggerProps$onMouse4 === void 0 || _triggerProps$onMouse4.call(triggerProps, e);
                (_saferRest$onMouseDow = saferRest.onMouseDown) === null || _saferRest$onMouseDow === void 0 || _saferRest$onMouseDow.call(saferRest, e);
            },
            onFocus: function onFocus(e) {
                var _triggerProps$onFocus, _saferRest$onFocus;
                (_triggerProps$onFocus = triggerProps.onFocus) === null || _triggerProps$onFocus === void 0 || _triggerProps$onFocus.call(triggerProps, e);
                (_saferRest$onFocus = saferRest.onFocus) === null || _saferRest$onFocus === void 0 || _saferRest$onFocus.call(saferRest, e);
            },
            onBlur: function onBlur(e) {
                var _triggerProps$onBlur, _saferRest$onBlur;
                (_triggerProps$onBlur = triggerProps.onBlur) === null || _triggerProps$onBlur === void 0 || _triggerProps$onBlur.call(triggerProps, e);
                (_saferRest$onBlur = saferRest.onBlur) === null || _saferRest$onBlur === void 0 || _saferRest$onBlur.call(saferRest, e);
            },
            ref: (0, $iO8GM.default)([
                ref,
                triggerProps === null || triggerProps === void 0 ? void 0 : triggerProps.ref
            ].filter(Boolean)),
            onMouseDownCapture: onMouseDownCapture,
            onMouseUpCapture: onMouseUpCapture,
            onKeyDownCapture: onKeyDownCapture,
            onKeyUpCapture: onKeyUpCapture,
            onTouchStartCapture: onTouchStartCapture,
            onTouchEndCapture: onTouchEndCapture,
            onPointerDownCapture: onPointerDownCapture,
            onPointerUpCapture: onPointerUpCapture,
            onClickCapture: onClickCapture,
            type: type,
            testId: testId,
            analyticsContext: analyticsContext,
            interactionName: interactionName,
            componentName: "IconButton"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $53ad6069579b4666$export$2e2bcd8739ae039), {
            type: "icon",
            isLoading: isLoading
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $a4b6b6a5fbbf2f99$export$2e2bcd8739ae039), {
            icon: icon
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $e3573d3717f44b5e$export$2e2bcd8739ae039), null, label)));
    });
}));
$0c4c08ddec83e35f$var$IconButton.displayName = 'IconButton';
var $0c4c08ddec83e35f$export$2e2bcd8739ae039 = $0c4c08ddec83e35f$var$IconButton;


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ced2179e9e0992ccb4af61b51b4f10a3>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");
/* icon-wrapper.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $5FkrB = parcelRequire("5FkrB");
/**
 * This length includes the underscore,
 * e.g. `"_1s4A"` would be a valid atomic group hash.
 */ const $461693459c687c45$var$ATOMIC_GROUP_LENGTH = 5;
function $461693459c687c45$export$2e2bcd8739ae039(classNames) {
    // Shortcut: nothing to do
    if (!classNames.length) return;
    // Shortcut: don't need to do anything if we only have a single classname
    if (classNames.length === 1 && classNames[0] && // checking to see if `classNames[0]` is a string that contains other classnames
    !classNames[0].includes(' ')) return classNames[0];
    // Using an object rather than a `Map` as it performed better in our benchmarks.
    // Would be happy to move to `Map` if it proved to be better under real conditions.
    const map = {};
    // Note: using loops to minimize iterations over the collection
    for (const value of classNames){
        // Exclude all falsy values, which leaves us with populated strings
        if (!value) continue;
        // a `value` can contain multiple classnames
        const list = value.split(' ');
        for (const className of list){
            /**
             * For atomic style classnames: the `key` is the `group`
             *
             * - Later atomic classnames with the same `group` will override earlier ones
             *   (which is what we want).
             * - Assumes atomic classnames are the only things that start with `_`
             * - Could use a regex to ensure that atomic classnames are structured how we expect,
             *   but did not add that for now as it did slow things down a bit.
             *
             * For other classnames: the `key` is the whole classname
             * - Okay to remove duplicates as doing so does not impact specificity
             *
             * */ const key = className.startsWith('_') ? className.slice(0, $461693459c687c45$var$ATOMIC_GROUP_LENGTH) : className;
            map[key] = className;
        }
    }
    /**
     * We are converting the `map` into a string.
     *
     * The simple way to do this would be `Object.values(map).join(' ')`.
     * However, the approach below performs 10%-20% better in benchmarks.
     *
     * For `ax()` it feels right to squeeze as much runtime performance out as we can.
     */ let result = '';
    for(const key in map)result += map[key] + ' ';
    // If we have an empty string, then our `map` was empty.
    if (!result) return;
    // remove last " " from the result (we added " " at the end of every value)
    return result.trimEnd();
}



var $dU8Y3 = parcelRequire("dU8Y3");

var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");

var $25nEq = parcelRequire("25nEq");
var $6bdb5e85ebbc6298$export$4ef52930e33717cd = 'data-theme';
var $6bdb5e85ebbc6298$export$cb374d25ded7f6ab = 'data-subtree-theme';
var $6bdb5e85ebbc6298$export$a00eac3f8684bcd0 = 'data-color-mode';
var $6bdb5e85ebbc6298$export$2112803007239c61 = 'data-contrast-mode';
var $6bdb5e85ebbc6298$export$352e418ed5b6193a = 'data-custom-theme';
var $6bdb5e85ebbc6298$export$6f0c6fb8c80fcc92 = 'ds';
var $6bdb5e85ebbc6298$export$4d0c7bbf80185957 = [
    'opacity',
    'font',
    'space',
    'border',
    'radius'
];
var $6bdb5e85ebbc6298$export$dddac1532e822863 = "--".concat($6bdb5e85ebbc6298$export$6f0c6fb8c80fcc92, "-token-not-found");
var $6bdb5e85ebbc6298$export$9d7b58831ae93caa = "--".concat($6bdb5e85ebbc6298$export$6f0c6fb8c80fcc92, "-elevation-surface-current");



var $dU8Y3 = parcelRequire("dU8Y3");
var $80dcc87888308ce0$export$83993de8eb66733 = [
    'light',
    'dark',
    'auto'
];
/**
 * Contrast preferences: The system contrast preference
 */ var $80dcc87888308ce0$var$themeContrastModes = [
    'more',
    'no-preference',
    'auto'
];
var $80dcc87888308ce0$export$7d43e72a58e3283f = [
    'light-increased-contrast',
    'light',
    'light-future',
    'dark',
    'dark-future',
    'dark-increased-contrast',
    'spacing',
    'shape',
    'typography',
    'motion'
];
/**
 * Theme override ids: the equivalent of themeIds for theme overrides.
 * Theme overrides are temporary and there may not be any defined at times.
 */ var $80dcc87888308ce0$var$themeOverrideIds = [];
var $80dcc87888308ce0$export$92ba366331403db2 = [].concat($80dcc87888308ce0$export$7d43e72a58e3283f, $80dcc87888308ce0$var$themeOverrideIds);
/**
 * Theme to use a base. This will create the theme as
 * an extension with all token values marked as optional
 * to allow tokens to be overridden as required.
 */ /**
 * Palettes: The set of base tokens a given theme may be populated with.
 * For example: legacy light & dark themes use the "legacyPalette" containing colors from our
 * previous color set.
 */ /**
 * ThemeConfig: the source of truth for all theme meta-data.
 * This object should be used whenever interfacing with themes.
 */ var $80dcc87888308ce0$var$themeConfig = {
    'atlassian-light': {
        id: 'light',
        displayName: 'Light Theme',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'light'
        }
    },
    'atlassian-light-future': {
        id: 'light-future',
        displayName: 'Future Light Theme',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'light'
        },
        override: 'light'
    },
    'atlassian-light-increased-contrast': {
        id: 'light-increased-contrast',
        displayName: 'Light Theme (increased contrast)',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'light'
        },
        extends: 'light',
        increasesContrastFor: 'light'
    },
    'atlassian-dark': {
        id: 'dark',
        displayName: 'Dark Theme',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'dark'
        }
    },
    'atlassian-dark-future': {
        id: 'dark-future',
        displayName: 'Future Dark Theme',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'dark'
        },
        override: 'light'
    },
    'atlassian-dark-increased-contrast': {
        id: 'dark-increased-contrast',
        displayName: 'Dark Theme (increased contrast)',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'dark'
        },
        extends: 'dark',
        increasesContrastFor: 'dark'
    },
    'atlassian-spacing': {
        id: 'spacing',
        displayName: 'Atlassian Spacing',
        palette: 'spacingScale',
        attributes: {
            type: 'spacing'
        }
    },
    'atlassian-typography': {
        id: 'typography',
        displayName: 'Atlassian Typography',
        palette: 'typographyPalette',
        attributes: {
            type: 'typography'
        }
    },
    'atlassian-shape': {
        id: 'shape',
        displayName: 'Shape',
        palette: 'shapePalette',
        attributes: {
            type: 'shape'
        }
    },
    'atlassian-motion': {
        id: 'motion',
        displayName: 'Motion',
        palette: 'motionPalette',
        attributes: {
            type: 'motion'
        }
    }
};
var $80dcc87888308ce0$export$9aedcfa7336a207 = {
    colorMode: 'auto',
    contrastMode: 'auto',
    dark: 'dark',
    light: 'light',
    shape: function shape() {
        if ((0, $dU8Y3.fg)('platform-dst-shape-theme-default')) return 'shape';
        return undefined;
    },
    spacing: 'spacing',
    typography: 'typography',
    motion: function motion() {
        if ((0, $dU8Y3.fg)('platform-dst-motion-theme-default')) return 'motion';
        return undefined;
    },
    UNSAFE_themeOptions: undefined
};
var /**
 * Represents theme state once mounted to the page
 * (the page doesn't have an "auto" color mode, it's either light or dark)
 */ $80dcc87888308ce0$export$2e2bcd8739ae039 = $80dcc87888308ce0$var$themeConfig;



var $ekGgq = parcelRequire("ekGgq");

var $iYJcE = parcelRequire("iYJcE");

var $8c79c91c069af023$var$themeKinds = [
    'light',
    'dark',
    'spacing',
    'typography',
    'shape',
    'motion'
];
var $8c79c91c069af023$var$customThemeOptions = 'UNSAFE_themeOptions';
var $8c79c91c069af023$var$isThemeKind = function isThemeKind(themeKind) {
    return $8c79c91c069af023$var$themeKinds.find(function(kind) {
        return kind === themeKind;
    }) !== undefined;
};
var $8c79c91c069af023$var$isThemeIds = function isThemeIds(themeId) {
    return (0, $80dcc87888308ce0$export$7d43e72a58e3283f).find(function(id) {
        return id === themeId;
    }) !== undefined;
};
var $8c79c91c069af023$var$isColorMode = function isColorMode(modeId) {
    return [
        'light',
        'dark',
        'auto'
    ].includes(modeId);
};
var $8c79c91c069af023$export$f19b488f7c0547ee = function themeStringToObject(themeState) {
    return themeState.split(' ')// @ts-ignore - TS1501 TypeScript 5.9.2 upgrade
    .map(function(theme) {
        return theme.split(/:([^]*)/);
    }).reduce(function(themeObject, _ref) {
        var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_ref, 2), kind = _ref2[0], id = _ref2[1];
        if (kind === 'colorMode' && $8c79c91c069af023$var$isColorMode(id)) themeObject[kind] = id;
        if ($8c79c91c069af023$var$isThemeKind(kind) && $8c79c91c069af023$var$isThemeIds(id)) // @ts-expect-error FIXME - this is a valid ts error
        themeObject[kind] = id;
        if (kind === $8c79c91c069af023$var$customThemeOptions) try {
            themeObject[$8c79c91c069af023$var$customThemeOptions] = JSON.parse(id);
        } catch (_unused) {
            new Error('Invalid custom theme string');
        }
        return themeObject;
    }, {});
};
var $8c79c91c069af023$export$62c37ab81302621a = function themeObjectToString(themeState) {
    return Object.entries(themeState).reduce(function(themeString, _ref3) {
        var _ref4 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_ref3, 2), kind = _ref4[0], id = _ref4[1];
        if (// colorMode theme state
        kind === 'colorMode' && typeof id === 'string' && $8c79c91c069af023$var$isColorMode(id) || // custom theme state
        kind === $8c79c91c069af023$var$customThemeOptions && (0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(id) === 'object' || // other theme states
        $8c79c91c069af023$var$isThemeKind(kind) && typeof id === 'string' && $8c79c91c069af023$var$isThemeIds(id)) return themeString + "".concat(themeString ? ' ' : '') + "".concat(kind, ":").concat((0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(id) === 'object' ? JSON.stringify(id) : id);
        return themeString;
    }, '');
};


function $1fc4301ee09bc816$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $1fc4301ee09bc816$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $1fc4301ee09bc816$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $1fc4301ee09bc816$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $1fc4301ee09bc816$var$isThemeColorMode = function isThemeColorMode(colorMode) {
    return (0, $80dcc87888308ce0$export$83993de8eb66733).find(function(mode) {
        return mode === colorMode;
    }) !== undefined;
};
var $1fc4301ee09bc816$var$getGlobalTheme = function getGlobalTheme() {
    if (typeof document === 'undefined') return {};
    var element = document.documentElement;
    var colorMode = element.getAttribute((0, $6bdb5e85ebbc6298$export$a00eac3f8684bcd0)) || '';
    var theme = element.getAttribute((0, $6bdb5e85ebbc6298$export$4ef52930e33717cd)) || '';
    return $1fc4301ee09bc816$var$_objectSpread($1fc4301ee09bc816$var$_objectSpread({}, (0, $8c79c91c069af023$export$f19b488f7c0547ee)(theme)), $1fc4301ee09bc816$var$isThemeColorMode(colorMode) && {
        colorMode: colorMode
    });
};
var $1fc4301ee09bc816$export$2e2bcd8739ae039 = $1fc4301ee09bc816$var$getGlobalTheme;



var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $25nEq = parcelRequire("25nEq");


/**
 * A MutationObserver which watches the `<html>` element for changes to the theme.
 *
 * In React, use the {@link useThemeObserver `useThemeObserver`} hook instead.
 *
 * @param {function} callback - A callback function which fires when the theme changes.
 *
 * @example
 * ```
 * const observer = new ThemeMutationObserver((theme) => {});
 * observer.observe();
 * ```
 */ var $3303d62153a39d5f$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function ThemeMutationObserver(callback) {
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, ThemeMutationObserver);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "legacyObserver", null);
        this.callback = callback;
        ThemeMutationObserver.callbacks.add(callback);
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(ThemeMutationObserver, [
        {
            key: "observe",
            value: function observe() {
                if (!ThemeMutationObserver.observer) {
                    ThemeMutationObserver.observer = new MutationObserver(function() {
                        var theme = (0, $1fc4301ee09bc816$export$2e2bcd8739ae039)();
                        ThemeMutationObserver.callbacks.forEach(function(callback) {
                            return callback(theme);
                        });
                    });
                    // Observer only needs to be configured once
                    ThemeMutationObserver.observer.observe(document.documentElement, {
                        attributeFilter: [
                            (0, $6bdb5e85ebbc6298$export$4ef52930e33717cd),
                            (0, $6bdb5e85ebbc6298$export$a00eac3f8684bcd0)
                        ]
                    });
                }
            }
        },
        {
            key: "disconnect",
            value: function disconnect() {
                if (this.callback) ThemeMutationObserver.callbacks.delete(this.callback);
                if (ThemeMutationObserver.callbacks.size === 0 && ThemeMutationObserver.observer) {
                    ThemeMutationObserver.observer.disconnect();
                    ThemeMutationObserver.observer = null;
                }
            }
        }
    ]);
}();
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($3303d62153a39d5f$export$2e2bcd8739ae039, "observer", null);
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($3303d62153a39d5f$export$2e2bcd8739ae039, "callbacks", new Set());


/**
 * A React hook which returns the current themes and color-mode set on `<html>`.
 *
 * @example
 * ```
 * const { colorMode, dark, light, spacing, typography } = useThemeObserver();
 *
 * // Performing side effects when it changes
 * useEffect(() => {
 *   console.log(`The color mode has changed to ${theme.colorMode}`);
 * }, [theme.colorMode]);
 * ```
 */ var $fdb77cc968262235$var$useThemeObserver = function useThemeObserver() {
    var _useState = (0, $5FkrB.useState)((0, $1fc4301ee09bc816$export$2e2bcd8739ae039)()), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), theme = _useState2[0], setTheme = _useState2[1];
    (0, $5FkrB.useEffect)(function() {
        var observer = new (0, $3303d62153a39d5f$export$2e2bcd8739ae039)(function(theme) {
            return setTheme(theme);
        });
        observer.observe();
        return function() {
            return observer.disconnect();
        };
    }, []);
    return theme;
};
var $fdb77cc968262235$export$2e2bcd8739ae039 = $fdb77cc968262235$var$useThemeObserver;


var $05f9b20d45e480e2$var$styles = {
    root: "_1e0c1o8l",
    TEMP_assets: "_9aea1fkg"
};
/* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ var $05f9b20d45e480e2$var$cloudLightAppearanceMap = {
    brand: "_1b3i18uv _9aea18uv",
    neutral: "_1b3i1e01 _9aea1fkg",
    inverse: "_1b3i5a6q _9aeau67f",
    legacy: "_1b3iu67f _9aeadoyu"
};
/* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ var $05f9b20d45e480e2$var$cloudDarkAppearanceMap = {
    brand: "_1b3i18uv _9aea18uv",
    neutral: "_1b3i1gvk _9aea8hz0",
    inverse: "_1b3iu67f _9aea5a6q",
    legacy: "_1b3iu67f _9aeadoyu"
};
/* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ var $05f9b20d45e480e2$var$dataCenterLightAppearanceMap = {
    brand: "_1b3idoyu _9aeau67f _3wu01fkg",
    neutral: "_1b3i1e01 _9aea1fkg _3wu01e01",
    inverse: "_1b3iu67f _9aeaqlpt _3wu0u67f",
    legacy: "_1b3idoyu _9aeau67f _3wu01fkg"
};
/* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ var $05f9b20d45e480e2$var$dataCenterDarkAppearanceMap = {
    brand: "_1b3idoyu _9aeaqlpt _3wu08hz0",
    neutral: "_1b3i1gvk _9aea8hz0 _3wu01gvk",
    inverse: "_1b3i1501 _9aeau67f _3wu01501",
    legacy: "_1b3idoyu _9aeaqlpt _3wu08hz0"
};
var $05f9b20d45e480e2$var$rovoDarkAppearanceMap = {
    brand: "_170318uv _1evo18uv _epb518uv _1osd18uv",
    neutral: "_17031gvk _1evo1gvk _epb51gvk _1osd1gvk",
    inverse: "_1703qlpt _1evoqlpt _epb5qlpt _1osdqlpt",
    legacy: "_1703doyu _1evodoyu _epb5doyu _1osddoyu"
};
var $05f9b20d45e480e2$var$rovoLightAppearanceMap = {
    brand: "_170318uv _1evo18uv _epb518uv _1osd18uv",
    neutral: "_17031e01 _1evo1e01 _epb51e01 _1osd1e01",
    inverse: "_1703u67f _1evou67f _epb5u67f _1osdu67f",
    legacy: "_1703doyu _1evodoyu _epb5doyu _1osddoyu"
};
/* eslint-enable @atlaskit/ui-styling-standard/no-imported-style-values */ /* eslint-enable @atlaskit/ui-styling-standard/no-unsafe-values */ var $05f9b20d45e480e2$var$sizeMap = {
    xxsmall: "_4t3i7vkz",
    xsmall: "_4t3igktf",
    small: "_4t3i1tcg",
    medium: "_4t3izwfg",
    large: "_4t3i1ylp",
    xlarge: "_4t3ickbl",
    '12': "_4t3i1crf",
    '16': "_4t3i7vkz",
    '20': "_4t3igktf",
    '24': "_4t3i1tcg",
    '32': "_4t3izwfg"
};
function $05f9b20d45e480e2$export$be58b4326e23250f(_ref) {
    var _ref$size = _ref.size, size = _ref$size === void 0 ? '20' : _ref$size, label = _ref.label, svg = _ref.svg, customThemeSvg = _ref.customThemeSvg, userDefinedTestId = _ref.testId, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, customIconColor = _ref.iconColor, _ref$isAssets = _ref.isAssets, isAssets = _ref$isAssets === void 0 ? false : _ref$isAssets, _ref$type = _ref.type, type = _ref$type === void 0 ? 'tile' : _ref$type;
    var testId = userDefinedTestId && "".concat(userDefinedTestId, "--wrapper");
    var isCustomThemed = customThemeSvg && customIconColor;
    var _useThemeObserver = (0, $fdb77cc968262235$export$2e2bcd8739ae039)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ $5FkrB.createElement("span", {
        "data-testid": testId,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            '--themed-icon-color': customIconColor || 'initial'
        },
        "aria-label": label ? label : undefined,
        role: label ? 'img' : undefined,
        "aria-hidden": label === '' ? true : undefined,
        dangerouslySetInnerHTML: {
            __html: isCustomThemed ? customThemeSvg : svg
        },
        className: (0, $461693459c687c45$export$2e2bcd8739ae039)([
            $05f9b20d45e480e2$var$styles.root,
            $05f9b20d45e480e2$var$sizeMap[size],
            colorMode === 'dark' ? $05f9b20d45e480e2$var$dataCenterDarkAppearanceMap[appearance] : $05f9b20d45e480e2$var$dataCenterLightAppearanceMap[appearance],
            type === 'rovo' ? colorMode === 'dark' ? $05f9b20d45e480e2$var$rovoDarkAppearanceMap[appearance] : $05f9b20d45e480e2$var$rovoLightAppearanceMap[appearance] : colorMode === 'dark' ? $05f9b20d45e480e2$var$cloudDarkAppearanceMap[appearance] : $05f9b20d45e480e2$var$cloudLightAppearanceMap[appearance],
            isAssets && appearance === 'brand' && (0, $dU8Y3.fg)('assets-platform-branding') && $05f9b20d45e480e2$var$styles.TEMP_assets
        ])
    });
}


// `height` is set to 100% to allow the SVG to scale with the parent element
var $42816eed69858c8d$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" fill-rule=\"evenodd\" d=\"M10.444 5h3.111l.98 2.61 2.75-.457 1.555 2.694L17.07 12l1.77 2.153-1.555 2.694-2.75-.457-.979 2.61h-3.11l-.98-2.61-2.75.457-1.555-2.694L6.931 12 5.16 9.847l1.555-2.694 2.75.457zM12 14.625a2.625 2.625 0 1 0 0-5.25 2.625 2.625 0 0 0 0 5.25\" clip-rule=\"evenodd\"/>\n</svg>\n";
function $42816eed69858c8d$export$ef8e5f836dd989d3(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Admin' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $05f9b20d45e480e2$export$be58b4326e23250f), {
        svg: $42816eed69858c8d$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::58c9ee3b4e44f14aa5c8a2e33c7dac51>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");
/* logo-wrapper.tsx generated by @compiled/babel-plugin v0.39.1 */ /* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ 
var $5FkrB = parcelRequire("5FkrB");


var $dU8Y3 = parcelRequire("dU8Y3");

var $e5724170be447320$var$styles = {
    root: "_1e0c1o8l _vwz4idpf",
    TEMP_assets: "_9aea1fkg"
};
// These styles set the `color` property so that the child SVG can inherit the correct text color using "currentColor"
var $e5724170be447320$var$logoTextColorMap = {
    light: "_syazqlpt",
    dark: "_syazz6c6"
};
var $e5724170be447320$var$sizeMap = {
    xxsmall: "_4t3i7vkz",
    xsmall: "_4t3igktf",
    small: "_4t3i1tcg",
    medium: "_4t3izwfg",
    large: "_4t3i1ylp",
    xlarge: "_4t3ickbl"
};
/* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ var $e5724170be447320$var$textLightAppearanceMap = {
    brand: "_1wyci7uo",
    neutral: "_1wyc1e01",
    inverse: "_1wycu67f",
    legacy: "_1wycu67f"
};
/* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ var $e5724170be447320$var$textDarkAppearanceMap = {
    brand: "_1wyci7uo",
    neutral: "_1wyc1gvk",
    inverse: "_1wyc5a6q",
    legacy: "_1wycu67f"
};
/* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ var $e5724170be447320$var$cloudLightAppearanceMap = {
    brand: "_1b3i18uv _9aea18uv",
    neutral: "_1b3i1e01 _9aea1fkg",
    inverse: "_1b3i5a6q _9aeau67f",
    legacy: "_1b3iu67f _9aeadoyu"
};
/* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ var $e5724170be447320$var$cloudDarkAppearanceMap = {
    brand: "_1b3i18uv _9aea18uv",
    neutral: "_1b3i1gvk _9aea8hz0",
    inverse: "_1b3iu67f _9aea5a6q",
    legacy: "_1b3iu67f _9aeadoyu"
};
/* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ var $e5724170be447320$var$dataCenterLightAppearanceMap = {
    brand: "_1b3idoyu _9aeau67f _3wu01fkg",
    neutral: "_1b3i1e01 _9aea1fkg _3wu01e01",
    inverse: "_1b3iu67f _9aeaqlpt _3wu0u67f",
    legacy: "_1b3idoyu _9aeau67f _3wu01fkg"
};
/* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ var $e5724170be447320$var$dataCenterDarkAppearanceMap = {
    brand: "_1b3idoyu _9aeaqlpt _3wu08hz0",
    neutral: "_1b3i1gvk _9aea8hz0 _3wu01gvk",
    inverse: "_1b3i1501 _9aeau67f _3wu01501",
    legacy: "_1b3idoyu _9aeaqlpt _3wu08hz0"
};
var $e5724170be447320$var$rovoDarkAppearanceMap = {
    brand: "_1703lrxy _1evoh727 _epb51yy8 _1osdxeun",
    neutral: "_17031gvk _1evo1gvk _epb51gvk _1osd1gvk",
    inverse: "_1703qlpt _1evoqlpt _epb5qlpt _1osdqlpt",
    legacy: "_1703doyu _1evodoyu _epb5doyu _1osddoyu"
};
var $e5724170be447320$var$rovoLightAppearanceMap = {
    brand: "_170318uv _1evo18uv _epb518uv _1osd18uv",
    neutral: "_17031e01 _1evo1e01 _epb51e01 _1osd1e01",
    inverse: "_1703u67f _1evou67f _epb5u67f _1osdu67f",
    legacy: "_1703doyu _1evodoyu _epb5doyu _1osddoyu"
};
function $e5724170be447320$export$f827d3c5a9c3f644(_ref) {
    var _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$size = _ref.size, size = _ref$size === void 0 ? 'small' : _ref$size, svg = _ref.svg, customThemeSvg = _ref.customThemeSvg, label = _ref.label, userDefinedTestId = _ref.testId, customIconColor = _ref.iconColor, customTextColor = _ref.textColor, _ref$isAssets = _ref.isAssets, isAssets = _ref$isAssets === void 0 ? false : _ref$isAssets, _ref$type = _ref.type, type = _ref$type === void 0 ? 'tile' : _ref$type;
    var _useThemeObserver = (0, $fdb77cc968262235$export$2e2bcd8739ae039)(), colorMode = _useThemeObserver.colorMode;
    var testId = userDefinedTestId && "".concat(userDefinedTestId, "--wrapper");
    var isCustomThemed = customThemeSvg && (customIconColor || customTextColor);
    return /*#__PURE__*/ $5FkrB.createElement("span", {
        style: {
            // Nav v3 passes in "inherit" incorrectly for iconColor, so we fall back to textColor when this happens.
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            '--themed-icon-color': customIconColor === 'inherit' ? customTextColor : customIconColor,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            '--themed-text-color': customTextColor || 'inherit'
        },
        "data-testid": testId,
        "aria-label": label ? label : undefined,
        role: label ? 'img' : undefined,
        "aria-hidden": label === '' ? true : undefined,
        dangerouslySetInnerHTML: {
            __html: isCustomThemed ? customThemeSvg : svg
        },
        className: (0, $461693459c687c45$export$2e2bcd8739ae039)([
            $e5724170be447320$var$styles.root,
            // Setting the color so that the SVG can inherit the correct text color using "currentColor"
            $e5724170be447320$var$logoTextColorMap[colorMode !== null && colorMode !== void 0 ? colorMode : 'light'],
            $e5724170be447320$var$sizeMap[size],
            colorMode === 'dark' ? $e5724170be447320$var$textDarkAppearanceMap[appearance] : $e5724170be447320$var$textLightAppearanceMap[appearance],
            colorMode === 'dark' ? $e5724170be447320$var$dataCenterDarkAppearanceMap[appearance] : $e5724170be447320$var$dataCenterLightAppearanceMap[appearance],
            type === 'rovo' ? colorMode === 'dark' ? $e5724170be447320$var$rovoDarkAppearanceMap[appearance] : $e5724170be447320$var$rovoLightAppearanceMap[appearance] : colorMode === 'dark' ? $e5724170be447320$var$cloudDarkAppearanceMap[appearance] : $e5724170be447320$var$cloudLightAppearanceMap[appearance],
            isAssets && appearance === 'brand' && (0, $dU8Y3.fg)('assets-platform-branding') && $e5724170be447320$var$styles.TEMP_assets
        ])
    });
}


// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $f75b13e9496c8aa2$var$svg = "<svg height=\"100%\" viewBox=\"0 0 126 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M124.84 16.35v8.99h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.51c.98-1.81 2.79-2.82 4.85-2.82 3.53 0 5.55 2.42 5.55 6.66m-20.15-10.4c0-1.17.77-1.84 1.84-1.84s1.84.67 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-14.07-8.52v8.53h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.51c.98-1.81 2.79-2.82 4.85-2.82 2.61 0 4.39 1.32 5.15 3.74.86-2.36 2.91-3.74 5.46-3.74 3.44 0 5.34 2.33 5.34 6.66v8.99h-2.64v-8.52c0-3.16-1.1-4.72-3.62-4.72-2.45 0-4.14 1.63-4.14 4.72m-28.32.85c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V3.59h2.64v21.74zm-22.02-4.01c-1.53 0-3.1-.18-4.81-.52l-1.69 4.54h-3.1l7.94-20.15h3.5l7.94 20.15h-3.1l-1.69-4.57c-1.81.37-3.37.55-5 .55m0-2.45c1.29 0 2.61-.15 4.17-.4L49.53 7.43 45.45 18.5c1.5.25 2.76.37 3.99.37\"/>\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" fill-rule=\"evenodd\" d=\"M13.826 6.4h4.255l1.338 3.569 3.76-.626 2.128 3.684-2.422 2.945 2.421 2.943L23.18 22.6l-3.76-.626-1.338 3.57h-4.255l-1.338-3.57-3.76.625L6.6 18.915l2.421-2.943L6.6 13.028l2.127-3.685 3.76.626zm2.128 13.16a3.59 3.59 0 1 0 0-7.178 3.59 3.59 0 0 0 0 7.179\" clip-rule=\"evenodd\"/>\n</svg>\n";
function $f75b13e9496c8aa2$export$61afcb38c001e19(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Admin' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $e5724170be447320$export$f827d3c5a9c3f644), {
        svg: $f75b13e9496c8aa2$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::9c308d558bb8f01b0a6c887a98e5347d>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
var $ef02305e93d38cfe$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#fb9700)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M18.545 18.545a4.49 4.49 0 0 0-4.48-4.48h-4.13v-3.78h-4.48v7.434c0 .576.25.826.826.826zM5.455 5.455a4.454 4.454 0 0 0 4.455 4.48h4.155v3.78h4.48V6.28q0-.825-.826-.826z\"/>\n</svg>\n";
function $ef02305e93d38cfe$export$70a0c2f5862937b6(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Align' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $05f9b20d45e480e2$export$be58b4326e23250f), {
        svg: $ef02305e93d38cfe$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4d1c9f8765265019cd33e94ea5235515>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $5407f49539ceea52$var$svg = "<svg height=\"100%\" viewBox=\"0 0 106 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M105.76 16.35v8.99h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.63V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 3.53 0 5.55 2.42 5.55 6.66m-19.6 7.75v-1.53c-.98 2.02-2.82 3.07-5.18 3.07-4.05 0-6.07-3.46-6.07-7.97 0-4.32 2.12-7.97 6.38-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.58v13.95c0 4.51-2.12 7.54-7.61 7.54-2.58 0-3.99-.34-5.46-.83v-2.58c1.69.55 3.43.92 5.34.92 3.83 0 5.15-2.05 5.15-4.91m-8.68-6.44c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52M68.73 5.95c0-1.17.77-1.84 1.84-1.84s1.84.67 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-2.54-.03c-.21.06-.67.12-1.35.12-2.51 0-4.11-1.19-4.11-4.02V3.59h2.64V21.1c0 1.38.92 1.87 2.06 1.87.28 0 .46 0 .77-.03zM49.6 21.32c-1.53 0-3.1-.18-4.82-.52l-1.69 4.54H40l7.94-20.15h3.5l7.94 20.15h-3.1l-1.69-4.57c-1.81.37-3.37.55-5 .55m0-2.45c1.29 0 2.61-.15 4.17-.4L49.68 7.43 45.6 18.5c1.5.25 2.76.37 3.99.37\"/>\n    <path fill=\"var(--tile-color,#fb9700)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M23.735 23.735c0-2.928-2.396-5.295-5.295-5.295h-4.88v-4.466H8.265v8.785c0 .68.296.976.976.976zM8.265 8.265c0 2.928 2.337 5.295 5.265 5.295h4.91v4.466h5.295V9.241q0-.976-.976-.976z\"/>\n</svg>\n";
function $5407f49539ceea52$export$8b5103382c06639c(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Align' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $e5724170be447320$export$f827d3c5a9c3f644), {
        svg: $5407f49539ceea52$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::5edf47443601d30b199c36fbcc7b1d7c>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
var $483e4eae5b0896bb$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M14.63 5.88v9.19h3.06v-9.2zM5.88 18.13h11.81v-1.75H5.87zm0-3.07v-4.81h3.06v4.81zm4.37-6.56v6.56h3.06V8.5z\"/>\n</svg>\n";
function $483e4eae5b0896bb$export$af3460f51ce3602a(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Analytics' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $05f9b20d45e480e2$export$be58b4326e23250f), {
        svg: $483e4eae5b0896bb$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::843c7beab94f5191123277c61cbca79e>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $f74d50e4aa1d9379$var$svg = "<svg height=\"100%\" viewBox=\"0 0 161 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M160.66 21.16c0 2.55-1.66 4.48-5.76 4.48-2.3 0-4.17-.52-5.34-1.13v-2.79c1.32.77 3.53 1.5 5.46 1.5 2.02 0 3.07-.83 3.07-2.02 0-1.17-.89-1.84-3.8-2.55-3.4-.83-4.85-2.15-4.85-4.66 0-2.67 2.06-4.29 5.55-4.29 1.99 0 3.8.49 4.94 1.1v2.73c-1.84-.92-3.34-1.41-4.97-1.41-1.93 0-2.97.67-2.97 1.87 0 1.07.74 1.75 3.56 2.42 3.4.83 5.12 2.09 5.12 4.75m-13.6 1.41v2.36c-.92.49-2.33.71-3.74.71-5.46 0-8-3.31-8-8 0-4.63 2.55-7.94 8-7.94 1.38 0 2.45.18 3.65.74v2.45c-.98-.46-2.02-.74-3.47-.74-3.99 0-5.61 2.52-5.61 5.49s1.66 5.49 5.67 5.49c1.56 0 2.55-.21 3.5-.55M129.13 5.95c0-1.16.77-1.84 1.84-1.84s1.84.68 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-7.46-4.75c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55c-.46.12-.98.25-1.78.25-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zm-14.12 3.77h-1.72L100.77 10h2.82l4.91 13.13L113.41 10h2.82l-5.8 14.84c-1.72 4.39-2.7 6.66-6.59 6.66-1.32 0-2.05-.12-2.82-.43V28.8c.89.28 1.9.37 2.67.37 2.15 0 3.1-1.47 4.36-4.81m-7.8.94c-.21.06-.67.12-1.35.12-2.51 0-4.11-1.19-4.11-4.02V3.59h2.64V21.1c0 1.38.92 1.87 2.06 1.87.28 0 .46 0 .77-.03zM79.5 17.67c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.47-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zM74.1 16.35v8.99h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.63V10h2.64v2.51c.98-1.81 2.79-2.82 4.85-2.82 3.53 0 5.55 2.42 5.55 6.66m-24.66 4.97c-1.53 0-3.1-.18-4.81-.52l-1.69 4.54h-3.1l7.94-20.15h3.5l7.94 20.15h-3.1l-1.69-4.57c-1.81.37-3.37.55-5 .55m0-2.45c1.29 0 2.61-.15 4.17-.4L49.53 7.43 45.45 18.5c1.5.25 2.76.37 3.99.37\"/>\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M19.5 7.83v12.25h4.08V7.83zM7.83 24.17h15.75v-2.33H7.83zm0-4.09v-6.42h4.08v6.42zm5.84-8.75v8.75h4.08v-8.75z\"/>\n</svg>\n";
function $f74d50e4aa1d9379$export$f0bac2b7ac3e3504(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Analytics' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $e5724170be447320$export$f827d3c5a9c3f644), {
        svg: $f74d50e4aa1d9379$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6ef8f48b1d072b5b8a0869540d1f52a5>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
var $8373c87ee8f07dfa$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#ffc716)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" fill-rule=\"evenodd\" d=\"M8.34 11.495a3.64 3.64 0 0 0 3.155-3.154h2.3V6.523h-2.537a3.638 3.638 0 1 0-4.735 4.735v2.538H8.34zM7.887 9.25a1.364 1.364 0 1 0 0-2.727 1.364 1.364 0 0 0 0 2.727\" clip-rule=\"evenodd\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M19.25 7.43a2.27 2.27 0 1 1-4.54 0 2.27 2.27 0 0 1 4.55 0M7.43 19.25a2.27 2.27 0 1 0 0-4.54 2.27 2.27 0 0 0 0 4.55m9.55-.01a2.27 2.27 0 1 0 0-4.54 2.27 2.27 0 0 0 0 4.55m-3.18-3.19h-3.18v1.82h3.18zm2.27-5.46v3.18h1.82v-3.18z\"/>\n</svg>\n";
var $8373c87ee8f07dfa$var$customThemeSvg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--themed-icon-color, currentcolor)\" d=\"M18 0a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6V6a6 6 0 0 1 6-6zM7.432 14.704a2.273 2.273 0 1 0 .001 4.547 2.273 2.273 0 0 0-.001-4.547m9.545 0a2.274 2.274 0 1 0 .001 4.548 2.274 2.274 0 0 0 0-4.548m-6.364 1.364v1.819h3.183v-1.819zM7.887 4.25a3.637 3.637 0 0 0-1.365 7.009v2.537h1.819v-2.302a3.64 3.64 0 0 0 3.153-3.153h2.302V6.522h-2.537A3.64 3.64 0 0 0 7.887 4.25m8.181 6.363v3.183h1.819v-3.183zm.91-5.454a2.273 2.273 0 1 0 0 4.547 2.273 2.273 0 0 0 0-4.547M7.887 6.522a1.364 1.364 0 1 1-.002 2.729 1.364 1.364 0 0 1 .002-2.729\"/>\n</svg>\n";
function $8373c87ee8f07dfa$export$d89497e7f33ca6f5(_ref) {
    var iconColor = _ref.iconColor, size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Assets' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $05f9b20d45e480e2$export$be58b4326e23250f), {
        svg: $8373c87ee8f07dfa$var$svg,
        customThemeSvg: $8373c87ee8f07dfa$var$customThemeSvg,
        iconColor: iconColor,
        label: label,
        isAssets: true,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3e04e8bc884193d0eee2f110efb35733>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $bcf55440e1ac49e3$var$svg = "<svg height=\"100%\" viewBox=\"0 0 126 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M125.8 21.16c0 2.55-1.66 4.48-5.76 4.48-2.3 0-4.17-.52-5.34-1.13v-2.79c1.32.77 3.53 1.5 5.46 1.5 2.02 0 3.07-.83 3.07-2.02 0-1.16-.89-1.84-3.8-2.54-3.4-.83-4.84-2.15-4.84-4.66 0-2.67 2.06-4.29 5.55-4.29 1.99 0 3.8.49 4.94 1.1v2.73c-1.84-.92-3.34-1.41-4.97-1.41-1.93 0-2.97.67-2.97 1.87 0 1.07.74 1.75 3.56 2.42 3.4.83 5.12 2.09 5.12 4.75m-17.77-.59c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55c-.46.12-.98.25-1.78.25-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zm-13.53-8.5c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.2c.37 2.61 2.05 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-15.13-3.56c0 2.55-1.66 4.48-5.77 4.48-2.3 0-4.17-.52-5.34-1.13v-2.79c1.32.77 3.53 1.5 5.46 1.5 2.02 0 3.07-.83 3.07-2.02 0-1.16-.89-1.84-3.8-2.54-3.4-.83-4.85-2.15-4.85-4.66 0-2.67 2.06-4.29 5.55-4.29 1.99 0 3.8.49 4.94 1.1v2.73c-1.84-.92-3.34-1.41-4.97-1.41-1.93 0-2.97.67-2.97 1.87 0 1.07.74 1.75 3.56 2.42 3.4.83 5.12 2.09 5.12 4.75m-13.63-.01c0 2.55-1.66 4.48-5.76 4.48-2.3 0-4.17-.52-5.34-1.13v-2.79c1.32.77 3.53 1.5 5.46 1.5 2.02 0 3.07-.83 3.07-2.02 0-1.16-.89-1.84-3.8-2.54-3.4-.83-4.84-2.15-4.84-4.66 0-2.67 2.06-4.29 5.55-4.29 1.99 0 3.8.49 4.94 1.1v2.73c-1.84-.92-3.34-1.41-4.97-1.41-1.93 0-2.97.67-2.97 1.87 0 1.07.74 1.75 3.56 2.42 3.4.83 5.12 2.09 5.12 4.75m-22.22.15c-1.53 0-3.1-.18-4.81-.52l-1.69 4.54h-3.1l7.94-20.15h3.5l7.94 20.15h-3.1l-1.69-4.57c-1.81.37-3.37.55-5 .55m0-2.45c1.29 0 2.61-.15 4.17-.4L49.53 7.43 45.45 18.5c1.5.25 2.76.37 3.99.37\"/>\n    <path fill=\"var(--tile-color,#ffc716)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" fill-rule=\"evenodd\" d=\"M11.667 15.425a4.335 4.335 0 0 0 3.758-3.758h2.742V9.5h-3.023A4.335 4.335 0 1 0 9.5 15.144v3.023h2.167zm-.542-2.675a1.625 1.625 0 1 0 0-3.25 1.625 1.625 0 0 0 0 3.25\" clip-rule=\"evenodd\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M24.67 10.58a2.71 2.71 0 1 1-5.42 0 2.71 2.71 0 0 1 5.42 0M10.58 24.67a2.71 2.71 0 1 0 0-5.42 2.71 2.71 0 0 0 0 5.42m11.38 0a2.71 2.71 0 1 0 0-5.42 2.71 2.71 0 0 0 0 5.42m-3.79-3.79h-3.79v2.17h3.79zm2.71-6.5v3.79h2.17v-3.79z\"/>\n</svg>\n";
function $bcf55440e1ac49e3$export$81c47abe19675c4c(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Assets' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $e5724170be447320$export$f827d3c5a9c3f644), {
        svg: $bcf55440e1ac49e3$var$svg,
        label: label,
        isAssets: true,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::74f0ca66b8bc3995f7a9817f08a67d6f>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
var $9e5a8315f2f6dca2$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color, white)\" d=\"M6 .5h12A5.5 5.5 0 0 1 23.5 6v12a5.5 5.5 0 0 1-5.5 5.5H6A5.5 5.5 0 0 1 .5 18V6A5.5 5.5 0 0 1 6 .5\"/>\n    <path fill=\"none\" stroke=\"var(--border-color, #dddee1)\" d=\"M6 .5h12A5.5 5.5 0 0 1 23.5 6v12a5.5 5.5 0 0 1-5.5 5.5H6A5.5 5.5 0 0 1 .5 18V6A5.5 5.5 0 0 1 6 .5Z\"/>\n    <path fill=\"var(--icon-color, #1868db)\" d=\"M9.215 12.652a2.75 2.75 0 0 0 2.749 2.742v4.205a6.964 6.964 0 0 1-6.849-5.727l-.049-.317zm9.26 0a.44.44 0 0 1 .436.468c-.222 3.311-2.783 5.989-6.043 6.414l-.904-4.14a2.75 2.75 0 0 0 2.723-2.37.44.44 0 0 1 .44-.372zM11.963 9.91a2.75 2.75 0 0 0-2.748 2.742H5v-.065c.033-3.495 2.668-6.374 6.059-6.816zm0-5.972a.436.436 0 0 1 .72-.33l4.824 4.138a.436.436 0 0 1 0 .662l-4.823 4.139a.436.436 0 0 1-.72-.331z\"/>\n</svg>\n";
function $9e5a8315f2f6dca2$export$e812398311cab9a3(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Bamboo' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $05f9b20d45e480e2$export$be58b4326e23250f), {
        svg: $9e5a8315f2f6dca2$var$svg,
        label: label,
        type: "data-center",
        appearance: appearance,
        size: size,
        testId: testId
    });
}

/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::5436ab9ea17c11b656095d6ae713006c>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $3a004855a7d196e5$var$svg = "<svg height=\"100%\" viewBox=\"0 0 154 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M146 25.64c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49m-16.68 13.49c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49m-12.07 5.52c0-3.68-1.47-5.52-4.2-5.52-2.36 0-4.48 1.5-4.48 4.91v1.23c0 3.4 1.93 4.91 4.17 4.91 2.98 0 4.51-1.96 4.51-5.52m-3.8 7.97c-2.24 0-3.96-1.01-4.88-3v2.7h-2.64V3.59h2.64v9.17c.98-2.02 2.82-3.07 5.18-3.07 4.08 0 6.13 3.47 6.13 7.97 0 4.32-2.15 7.97-6.44 7.97m-21.58-8.82v8.53h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 2.61 0 4.39 1.32 5.15 3.74.86-2.36 2.91-3.74 5.46-3.74 3.43 0 5.34 2.33 5.34 6.66v8.99h-2.64v-8.52c0-3.16-1.1-4.72-3.62-4.72-2.45 0-4.14 1.63-4.14 4.72m-28.32.84c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-20.23-9.04H45.8v6.29h6.26c2.64 0 3.83-.95 3.83-2.97 0-2.15-1.13-3.31-3.89-3.31m-.89-8.46h-5.3v6.01h5.31c2.61 0 3.68-1.2 3.68-3.13 0-1.96-1.16-2.88-3.68-2.88m-8.06 17.51V5.19h8.43c4.11 0 6.1 2.02 6.1 5.28 0 2.42-1.1 3.93-3.37 4.48 2.97.49 4.45 2.12 4.45 4.97 0 3.22-2.18 5.43-6.68 5.43z\"/>\n    <path fill=\"var(--tile-color, white)\" d=\"M8 .667h16A7.333 7.333 0 0 1 31.333 8v16A7.333 7.333 0 0 1 24 31.333H8A7.333 7.333 0 0 1 .667 24V8A7.333 7.333 0 0 1 8 .667\"/>\n    <path fill=\"none\" stroke=\"var(--border-color, #dddee1)\" stroke-width=\"1.333\" d=\"M8 .667h16A7.333 7.333 0 0 1 31.333 8v16A7.333 7.333 0 0 1 24 31.333H8A7.333 7.333 0 0 1 .667 24V8A7.333 7.333 0 0 1 8 .667Z\"/>\n    <path fill=\"var(--icon-color, #1868db)\" d=\"M12.287 16.869a3.665 3.665 0 0 0 3.665 3.656v5.607c-4.71 0-8.602-3.52-9.196-8.06zm12.347 0a.584.584 0 0 1 .581.624c-.295 4.415-3.71 7.986-8.057 8.554l-1.206-5.521a3.67 3.67 0 0 0 3.63-3.161.59.59 0 0 1 .589-.496zm-8.683-3.656a3.664 3.664 0 0 0-3.665 3.656h-5.62v-.088c.044-4.66 3.557-8.498 8.078-9.088zm0-7.964a.58.58 0 0 1 .96-.44l6.432 5.518c.27.232.27.65 0 .883l-6.431 5.517a.581.581 0 0 1-.96-.44z\"/>\n</svg>\n";
function $3a004855a7d196e5$export$7c51958462d750e(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Bamboo' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $e5724170be447320$export$f827d3c5a9c3f644), {
        svg: $3a004855a7d196e5$var$svg,
        label: label,
        type: "data-center",
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::83bd991a11895fc697ec86ba4d2d82c2>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
var $0f19a71cf5ef3443$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#94c748)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"m17.898 11.353-.994 6.064c-.065.367-.324.583-.691.583H7.787c-.367 0-.627-.216-.691-.583L5.346 6.604C5.28 6.237 5.476 6 5.82 6h12.358c.346 0 .54.237.475.604l-.475 2.85c-.065.41-.303.582-.691.582h-7.432c-.109 0-.173.065-.152.194l.584 3.583c.021.086.086.151.172.151h2.68c.086 0 .15-.065.172-.151l.41-2.59c.044-.324.26-.453.563-.453H17.4c.432 0 .562.216.497.582\"/>\n</svg>\n";
var $0f19a71cf5ef3443$var$customThemeSvg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--themed-icon-color, currentcolor)\" d=\"M18 0a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6V6a6 6 0 0 1 6-6zM5.821 6c-.345 0-.54.238-.475.604l1.75 10.813c.065.367.324.583.691.583h8.426c.367 0 .627-.216.691-.583l.994-6.065c.065-.366-.065-.582-.497-.582h-2.917c-.302 0-.518.13-.561.453l-.41 2.59c-.022.086-.087.15-.173.15h-2.68c-.086 0-.151-.064-.173-.15l-.583-3.583c-.021-.129.044-.194.152-.194h7.431c.39 0 .627-.173.692-.583l.475-2.849c.065-.366-.13-.604-.475-.604z\"/>\n</svg>\n";
function $0f19a71cf5ef3443$export$5fc1066e677788d4(_ref) {
    var iconColor = _ref.iconColor, size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Bitbucket' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $05f9b20d45e480e2$export$be58b4326e23250f), {
        svg: $0f19a71cf5ef3443$var$svg,
        customThemeSvg: $0f19a71cf5ef3443$var$customThemeSvg,
        iconColor: iconColor,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7131ffd6f745f530e9a82fe4842b6a8c>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $e971c6946cb1c8ba$var$svg = "<svg height=\"100%\" viewBox=\"0 0 166 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M161.21 20.58c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55a6.3 6.3 0 0 1-1.78.25c-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zm-13.53-8.49c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.67-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.05 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-23.83.6h-2.64V3.59h2.64v13.59l6.6-7.18h3.44l-7.21 7.54 7.51 7.79h-3.59l-6.75-7.18zm-5.64-2.76v2.36c-.92.49-2.33.71-3.74.71-5.46 0-8-3.31-8-8 0-4.63 2.55-7.94 8-7.94 1.38 0 2.45.18 3.65.74v2.45c-.98-.46-2.02-.74-3.46-.74-3.99 0-5.61 2.52-5.61 5.49s1.66 5.49 5.67 5.49c1.56 0 2.55-.21 3.5-.55m-27.86-3.59V10h2.64v9.26c0 2.76 1.1 3.99 3.62 3.99 2.45 0 4.14-1.63 4.14-4.72V10h2.64v15.33h-2.64v-2.51c-.98 1.81-2.79 2.82-4.84 2.82-3.53 0-5.55-2.42-5.55-6.65m-5.4-1.32c0-3.68-1.47-5.52-4.2-5.52-2.36 0-4.48 1.5-4.48 4.91v1.23c0 3.4 1.93 4.91 4.17 4.91 2.98 0 4.51-1.96 4.51-5.52m-3.8 7.97c-2.24 0-3.96-1.01-4.88-3v2.7h-2.64V3.59h2.64v9.17c.98-2.02 2.82-3.07 5.18-3.07 4.08 0 6.13 3.47 6.13 7.97 0 4.32-2.15 7.97-6.44 7.97m-14.96-5.05c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55c-.46.12-.98.25-1.78.25-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zM61.33 5.95c0-1.16.77-1.84 1.84-1.84s1.84.68 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-9.83-9.04H45.8v6.29h6.26c2.64 0 3.83-.95 3.83-2.97 0-2.15-1.13-3.31-3.89-3.31m-.89-8.46h-5.3v6.01h5.31c2.61 0 3.68-1.2 3.68-3.13 0-1.96-1.17-2.88-3.68-2.88m-8.06 17.51V5.19h8.43c4.11 0 6.1 2.02 6.1 5.27 0 2.42-1.1 3.93-3.37 4.48 2.97.49 4.45 2.12 4.45 4.97 0 3.22-2.18 5.43-6.69 5.43z\"/>\n    <path fill=\"var(--tile-color,#94c748)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"m23.79 15.684-1.315 8.032c-.085.486-.428.772-.914.772H10.413c-.486 0-.829-.286-.915-.772L7.183 9.396c-.086-.486.172-.8.629-.8h16.35c.457 0 .714.314.629.8l-.63 3.773c-.085.543-.4.772-.914.772h-9.833c-.143 0-.228.086-.2.257l.772 4.745c.029.114.114.2.229.2h3.544c.114 0 .2-.086.229-.2l.543-3.43c.057-.429.343-.6.743-.6h3.859c.572 0 .743.285.657.771\"/>\n</svg>\n";
function $e971c6946cb1c8ba$export$f7ef5e5488e4b430(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Bitbucket' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $e5724170be447320$export$f827d3c5a9c3f644), {
        svg: $e971c6946cb1c8ba$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::61dd349b817df11b196de45b8945fcdf>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
var $ec366d15f1e808c3$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color, white)\" d=\"M6 .5h12A5.5 5.5 0 0 1 23.5 6v12a5.5 5.5 0 0 1-5.5 5.5H6A5.5 5.5 0 0 1 .5 18V6A5.5 5.5 0 0 1 6 .5\"/>\n    <path fill=\"none\" stroke=\"var(--border-color, #dddee1)\" d=\"M6 .5h12A5.5 5.5 0 0 1 23.5 6v12a5.5 5.5 0 0 1-5.5 5.5H6A5.5 5.5 0 0 1 .5 18V6A5.5 5.5 0 0 1 6 .5Z\"/>\n    <path fill=\"var(--icon-color, #1868db)\" d=\"m17.843 11.763-.986 6.024c-.065.365-.322.58-.686.58H7.81c-.365 0-.622-.215-.686-.58L5.387 7.047c-.064-.364.129-.6.472-.6h12.262c.343 0 .536.236.472.6l-.472 2.83c-.064.407-.3.579-.686.579h-7.374c-.107 0-.172.064-.15.193l.579 3.558c.021.086.085.15.171.15h2.658c.086 0 .15-.064.172-.15l.407-2.572c.043-.322.257-.45.558-.45h2.894c.428 0 .557.214.493.578\"/>\n</svg>\n";
function $ec366d15f1e808c3$export$d3ab16bbf4f954ee(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Bitbucket Data Center' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $05f9b20d45e480e2$export$be58b4326e23250f), {
        svg: $ec366d15f1e808c3$var$svg,
        label: label,
        type: "data-center",
        appearance: appearance,
        size: size,
        testId: testId
    });
}

/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::68c2bbf4fd6874e93c78c51b9065dc7c>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $c4ad96900069ac69$var$svg = "<svg height=\"100%\" viewBox=\"0 0 166 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M161.21 20.58c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55c-.46.12-.98.25-1.78.25-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zm-13.53-8.49c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-23.83.6h-2.64V3.59h2.64v13.59l6.6-7.18h3.44l-7.21 7.54 7.51 7.79h-3.59l-6.75-7.18zm-5.64-2.76v2.36c-.92.49-2.33.71-3.74.71-5.46 0-8-3.31-8-8 0-4.63 2.55-7.94 8-7.94 1.38 0 2.45.18 3.65.74v2.45c-.98-.46-2.02-.74-3.47-.74-3.99 0-5.61 2.51-5.61 5.49s1.66 5.49 5.67 5.49c1.56 0 2.55-.21 3.5-.55m-27.85-3.59V10h2.64v9.26c0 2.76 1.1 3.99 3.62 3.99 2.45 0 4.14-1.62 4.14-4.72V10h2.64v15.33h-2.64v-2.51c-.98 1.81-2.79 2.82-4.85 2.82-3.53 0-5.55-2.42-5.55-6.65m-5.39-1.32c0-3.68-1.47-5.52-4.2-5.52-2.36 0-4.48 1.5-4.48 4.91v1.23c0 3.4 1.93 4.91 4.17 4.91 2.98 0 4.51-1.96 4.51-5.52m-3.8 7.97c-2.24 0-3.96-1.01-4.88-3v2.7h-2.64V3.59h2.64v9.17c.98-2.02 2.82-3.07 5.18-3.07 4.08 0 6.13 3.47 6.13 7.97 0 4.32-2.15 7.97-6.44 7.97m-14.96-5.05c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55a6.3 6.3 0 0 1-1.78.25c-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zM61.33 5.95c0-1.16.77-1.84 1.84-1.84s1.84.68 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-9.83-9.04H45.8v6.29h6.26c2.64 0 3.83-.95 3.83-2.97 0-2.15-1.13-3.31-3.89-3.31m-.89-8.46h-5.3v6.01h5.31c2.61 0 3.68-1.2 3.68-3.13 0-1.96-1.16-2.88-3.68-2.88m-8.06 17.51V5.19h8.43c4.11 0 6.1 2.02 6.1 5.28 0 2.42-1.1 3.93-3.37 4.48 2.97.49 4.45 2.12 4.45 4.97 0 3.22-2.18 5.43-6.68 5.43z\"/>\n    <path fill=\"var(--tile-color, white)\" d=\"M8 .667h16A7.333 7.333 0 0 1 31.333 8v16A7.333 7.333 0 0 1 24 31.333H8A7.333 7.333 0 0 1 .667 24V8A7.333 7.333 0 0 1 8 .667\"/>\n    <path fill=\"none\" stroke=\"var(--border-color, #dddee1)\" stroke-width=\"1.333\" d=\"M8 .667h16A7.333 7.333 0 0 1 31.333 8v16A7.333 7.333 0 0 1 24 31.333H8A7.333 7.333 0 0 1 .667 24V8A7.333 7.333 0 0 1 8 .667Z\"/>\n    <path fill=\"var(--icon-color, #1868db)\" d=\"m23.79 15.684-1.315 8.032c-.085.486-.428.772-.914.772H10.413c-.486 0-.829-.286-.915-.772L7.183 9.396c-.086-.486.172-.8.629-.8h16.35c.457 0 .714.314.629.8l-.63 3.773c-.085.543-.4.772-.914.772h-9.833c-.143 0-.228.086-.2.257l.772 4.745c.028.114.114.2.229.2h3.544c.114 0 .2-.086.229-.2l.543-3.43c.057-.429.343-.6.743-.6h3.859c.571 0 .743.285.657.771\"/>\n</svg>\n";
function $c4ad96900069ac69$export$cc55e2a4c4b40552(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Bitbucket Data Center' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $e5724170be447320$export$f827d3c5a9c3f644), {
        svg: $c4ad96900069ac69$var$svg,
        label: label,
        type: "data-center",
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3a833c6410fabd244b1134a630f9a005>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
var $ed33621c770c8f6f$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" fill-rule=\"evenodd\" d=\"M10.125 16.5h8.125V6H5.75v13zM12 12.125a.875.875 0 1 0 0-1.75.875.875 0 0 0 0 1.75m4-.875a.875.875 0 1 1-1.75 0 .875.875 0 0 1 1.75 0m-7.125.875a.875.875 0 1 0 0-1.75.875.875 0 0 0 0 1.75\" clip-rule=\"evenodd\"/>\n</svg>\n";
function $ed33621c770c8f6f$export$52cd484a7ef4f2b9(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Chat' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $05f9b20d45e480e2$export$be58b4326e23250f), {
        svg: $ed33621c770c8f6f$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b3a55f079b563dca3c91045ce0a761dc>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $422e6573ccf128d4$var$svg = "<svg height=\"100%\" viewBox=\"0 0 102 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M97.51 20.58c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55c-.46.12-.98.25-1.78.25-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zm-18.94-2.91c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.47-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-14.1-8.98v8.99h-2.64v-8.52c0-3.16-1.1-4.72-3.62-4.72-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V3.59h2.64v8.96c1.01-1.81 2.85-2.85 5.06-2.85 3.44 0 5.34 2.33 5.34 6.65m-16.22 5.43v2.67c-1.26.83-3.25 1.2-5.34 1.2-6.62 0-10.36-3.99-10.36-10.33 0-6.13 3.74-10.43 10.3-10.43 1.96 0 3.93.37 5.37 1.41v2.67c-1.44-.92-3.04-1.41-5.37-1.41-4.72 0-7.54 3.13-7.54 7.76s2.91 7.7 7.7 7.7c2.12 0 3.77-.49 5.24-1.23\"/>\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" fill-rule=\"evenodd\" d=\"M24.167 21.834h-10.5l-5.833 3.5v-17.5h16.333zm-12.25-5.833a1.167 1.167 0 1 0 0-2.334 1.167 1.167 0 0 0 0 2.334M16 16a1.167 1.167 0 1 0 0-2.334A1.167 1.167 0 0 0 16 16m5.25-1.167a1.167 1.167 0 1 1-2.334 0 1.167 1.167 0 0 1 2.333 0\" clip-rule=\"evenodd\"/>\n</svg>\n";
function $422e6573ccf128d4$export$a529e78951cd6709(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Chat' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $e5724170be447320$export$f827d3c5a9c3f644), {
        svg: $422e6573ccf128d4$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ad5b8ef64559dc5207c779379dec44c9>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
var $7712961585b3c6e3$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" fill-rule=\"evenodd\" d=\"M18.563 16.688h-8.438L5.438 19.5V5.438h13.125zm-6.83-9.375-.255.647c-.362.92-.543 1.38-.878 1.727-.334.346-.787.543-1.694.938l-.388.17v.535l.388.17c.907.394 1.36.592 1.694.938.335.346.516.807.878 1.727l.255.648h.535l.255-.648c.362-.92.543-1.38.877-1.727.335-.346.788-.544 1.694-.939l.388-.169v-.535l-.388-.17c-.906-.395-1.36-.592-1.694-.938-.334-.347-.515-.807-.877-1.727l-.255-.647z\" clip-rule=\"evenodd\"/>\n</svg>\n";
function $7712961585b3c6e3$export$402a257da320c93c(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Chat' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $05f9b20d45e480e2$export$be58b4326e23250f), {
        svg: $7712961585b3c6e3$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::1eb74baaf9574600817f9bd5473029df>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $eed89fab9307a98b$var$svg = "<svg height=\"100%\" viewBox=\"0 0 102 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M97.51 20.58c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55c-.46.12-.98.25-1.78.25-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zm-18.94-2.91c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-14.1-8.98v8.99h-2.64v-8.52c0-3.16-1.1-4.72-3.62-4.72-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V3.59h2.64v8.95c1.01-1.81 2.85-2.85 5.06-2.85 3.44 0 5.34 2.33 5.34 6.66m-16.22 5.43v2.67c-1.26.83-3.25 1.2-5.34 1.2-6.62 0-10.36-3.99-10.36-10.33 0-6.13 3.74-10.43 10.3-10.43 1.96 0 3.93.37 5.37 1.41v2.67c-1.44-.92-3.04-1.41-5.37-1.41-4.72 0-7.54 3.13-7.54 7.76s2.91 7.7 7.7 7.7c2.12 0 3.77-.49 5.24-1.23\"/>\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" fill-rule=\"evenodd\" d=\"M24.75 22.25H13.5L7.25 26V7.25h17.5zm-9.107-12.5-.34.864c-.482 1.226-.724 1.84-1.17 2.302s-1.05.725-2.258 1.251l-.518.226v.714l.518.226c1.209.526 1.813.79 2.259 1.251.445.462.687 1.076 1.17 2.303l.34.863h.714l.34-.864c.482-1.227.724-1.84 1.17-2.302s1.049-.725 2.258-1.251l.517-.226v-.714l-.517-.226c-1.21-.526-1.813-.79-2.259-1.251-.445-.462-.687-1.075-1.17-2.302l-.34-.864z\" clip-rule=\"evenodd\"/>\n</svg>\n";
function $eed89fab9307a98b$export$a3af32a9109d706d(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Chat' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $e5724170be447320$export$f827d3c5a9c3f644), {
        svg: $eed89fab9307a98b$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e5ce5248a23a237688e2341559569305>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
var $391da3670ec5c41a$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#94c748)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M12.75 7.877v-3.37l6.16-.007h.007a.59.59 0 0 1 .583.598v6.147h-3.366V7.877z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M12.75 14.615v-3.37h3.368v6.165a.59.59 0 0 1-.591.59H6.583A.59.59 0 0 1 6 17.402V8.467a.59.59 0 0 1 .591-.59h6.16v3.368H9.373v3.37z\"/>\n</svg>\n";
function $391da3670ec5c41a$export$f7857fe64d7161d9(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Compass' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $05f9b20d45e480e2$export$be58b4326e23250f), {
        svg: $391da3670ec5c41a$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::bbcc7f43e0a51fb6caa253b27359fb22>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $a1c2d8d9a6d45234$var$svg = "<svg height=\"100%\" viewBox=\"0 0 162 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M161.79 21.16c0 2.55-1.66 4.48-5.76 4.48-2.3 0-4.17-.52-5.34-1.13v-2.79c1.32.77 3.53 1.5 5.46 1.5 2.02 0 3.07-.83 3.07-2.02 0-1.16-.89-1.84-3.8-2.55-3.4-.83-4.85-2.15-4.85-4.66 0-2.67 2.06-4.29 5.55-4.29 1.99 0 3.8.49 4.94 1.1v2.73c-1.84-.92-3.34-1.41-4.97-1.41-1.93 0-2.97.68-2.97 1.87 0 1.07.74 1.75 3.56 2.42 3.4.83 5.12 2.09 5.12 4.75m-13.63 0c0 2.55-1.66 4.48-5.76 4.48-2.3 0-4.17-.52-5.34-1.13v-2.79c1.32.77 3.53 1.5 5.46 1.5 2.02 0 3.07-.83 3.07-2.02 0-1.16-.89-1.84-3.8-2.55-3.4-.83-4.84-2.15-4.84-4.66 0-2.67 2.06-4.29 5.55-4.29 1.99 0 3.8.49 4.94 1.1v2.73c-1.84-.92-3.34-1.41-4.97-1.41-1.93 0-2.97.68-2.97 1.87 0 1.07.74 1.75 3.56 2.42 3.4.83 5.12 2.09 5.12 4.75m-25.9-3.49c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01v-2.7h2.64v15.33zm-16.09-7.66c0-3.68-1.47-5.52-4.2-5.52-2.36 0-4.48 1.5-4.48 4.91v1.23c0 3.4 1.93 4.91 4.17 4.91 2.98 0 4.51-1.96 4.51-5.52m-3.8 7.97c-2.24 0-3.96-1.01-4.88-3v8.68h-2.64V10h2.64v2.76c.98-2.02 2.82-3.07 5.18-3.07 4.08 0 6.13 3.47 6.13 7.97 0 4.32-2.15 7.97-6.44 7.97M89.5 16.81v8.53h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.51c.98-1.81 2.79-2.82 4.85-2.82 2.61 0 4.39 1.32 5.15 3.74.86-2.36 2.91-3.74 5.46-3.74 3.43 0 5.34 2.33 5.34 6.66v8.99h-2.64v-8.53c0-3.16-1.1-4.72-3.62-4.72-2.45 0-4.14 1.63-4.14 4.72m-23.34 8.83c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49m-9.23 9.63v2.67c-1.26.83-3.25 1.2-5.34 1.2-6.62 0-10.36-3.99-10.36-10.33 0-6.13 3.74-10.43 10.3-10.43 1.96 0 3.93.37 5.37 1.41v2.67c-1.44-.92-3.04-1.41-5.37-1.41-4.72 0-7.54 3.13-7.54 7.76s2.91 7.7 7.7 7.7c2.12 0 3.77-.49 5.24-1.23\"/>\n    <path fill=\"var(--tile-color,#94c748)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M16.69 15.16v4.24h-4.25v-4.24zv-4.24H8.93a.74.74 0 0 0-.74.74v11.25a.74.74 0 0 0 .74.75h11.26a.74.74 0 0 0 .75-.74v-7.76zm0-8.48v4.24h4.26v4.24h4.24V7.42a.74.74 0 0 0-.73-.75h-.01z\"/>\n</svg>\n";
function $a1c2d8d9a6d45234$export$a16f50a81d183ce(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Compass' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $e5724170be447320$export$f827d3c5a9c3f644), {
        svg: $a1c2d8d9a6d45234$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2264fa822c5f74cedf4229a8911c73b4>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
var $2f121db3d400a7f2$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#1868db)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, white)\" d=\"M17.888 14.461c-4.039-1.953-5.219-2.245-6.92-2.245-1.997 0-3.699.831-5.219 3.165l-.25.382c-.204.314-.249.426-.249.561s.068.247.318.404l2.564 1.594c.136.09.25.135.363.135.136 0 .226-.068.363-.27l.408-.628c.635-.966 1.203-1.28 1.928-1.28.636 0 1.385.18 2.315.629l2.677 1.257c.272.134.567.067.704-.247l1.27-2.783c.136-.315.046-.517-.272-.674M6.112 9.545c4.039 1.953 5.219 2.245 6.92 2.245 1.997 0 3.699-.83 5.219-3.165l.25-.381c.204-.315.249-.427.249-.562 0-.134-.068-.247-.318-.404L15.87 5.685c-.137-.09-.25-.135-.364-.135-.136 0-.226.067-.363.27l-.408.628c-.635.965-1.203 1.28-1.928 1.28-.636 0-1.385-.18-2.315-.63L7.814 5.843c-.272-.135-.567-.068-.703.247L5.84 8.872c-.136.314-.045.516.272.673\"/>\n</svg>\n";
var $2f121db3d400a7f2$var$customThemeSvg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--themed-icon-color, currentcolor)\" d=\"M18 0a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6V6a6 6 0 0 1 6-6zm-7.032 12.217c-1.997 0-3.699.83-5.219 3.165l-.249.38c-.204.315-.25.427-.25.562s.068.247.317.404l2.565 1.594c.136.09.249.135.362.135.136 0 .227-.068.363-.27l.409-.628c.635-.966 1.202-1.28 1.928-1.28.636 0 1.384.18 2.315.63l2.677 1.256c.273.134.568.067.704-.247l1.27-2.783c.136-.315.045-.517-.272-.674-4.039-1.953-5.219-2.244-6.92-2.244m4.538-6.667c-.136 0-.227.067-.363.27l-.409.628c-.635.965-1.202 1.28-1.928 1.28-.636 0-1.384-.18-2.315-.63L7.813 5.843c-.272-.135-.567-.067-.703.247L5.84 8.872c-.136.314-.045.517.272.674 4.039 1.953 5.219 2.244 6.92 2.244 1.997 0 3.699-.83 5.219-3.165l.249-.382c.204-.314.25-.426.25-.56s-.068-.248-.317-.405l-2.565-1.593c-.136-.09-.249-.135-.362-.135\"/>\n</svg>\n";
function $2f121db3d400a7f2$export$68f3db7f6af48bcb(_ref) {
    var iconColor = _ref.iconColor, size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Confluence' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $05f9b20d45e480e2$export$be58b4326e23250f), {
        svg: $2f121db3d400a7f2$var$svg,
        customThemeSvg: $2f121db3d400a7f2$var$customThemeSvg,
        iconColor: iconColor,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::90f8012e577da50adfff14718da1e4b3>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $0b415cb06590d81b$var$svg = "<svg height=\"100%\" viewBox=\"0 0 188 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M181.16 12.09c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.2c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-15.1-2.16v2.36c-.92.49-2.33.71-3.74.71-5.46 0-8-3.31-8-8 0-4.63 2.55-7.94 8-7.94 1.38 0 2.45.18 3.65.74v2.45c-.98-.46-2.02-.74-3.46-.74-3.99 0-5.61 2.51-5.61 5.49s1.66 5.49 5.67 5.49c1.56 0 2.55-.21 3.5-.55m-14.51-6.23v8.99h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 3.53 0 5.55 2.42 5.55 6.66m-22.92-4.27c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-29.1-5.74V10h2.64v9.26c0 2.76 1.1 3.99 3.62 3.99 2.45 0 4.14-1.62 4.14-4.72V10h2.64v15.33h-2.64v-2.51c-.98 1.81-2.79 2.82-4.84 2.82-3.53 0-5.55-2.42-5.55-6.65m-2.24 6.31c-.21.06-.67.12-1.35.12-2.51 0-4.11-1.19-4.11-4.02V3.59h2.64V21.1c0 1.38.92 1.87 2.06 1.87.28 0 .46 0 .77-.03zM96.82 8.38V10h3.96v2.45h-3.96v12.88h-2.58V12.45h-2.48V10h2.48V8.31c0-2.85 1.59-4.78 4.88-4.78.8 0 1.32.12 1.78.25V6.2a8.7 8.7 0 0 0-1.66-.15c-1.62 0-2.42.95-2.42 2.33m-7.32 7.97v8.99h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 3.53 0 5.55 2.42 5.55 6.66m-23.34 9.28c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49m-9.23 9.63v2.67c-1.26.83-3.25 1.2-5.34 1.2-6.62 0-10.36-3.99-10.36-10.33 0-6.13 3.74-10.43 10.3-10.43 1.96 0 3.93.37 5.37 1.41v2.67c-1.44-.92-3.04-1.41-5.37-1.41-4.72 0-7.54 3.13-7.54 7.76s2.91 7.7 7.7 7.7c2.12 0 3.77-.49 5.24-1.23\"/>\n    <path fill=\"var(--tile-color,#1868db)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, white)\" d=\"M23.16 19.02c-4.938-2.387-6.38-2.744-8.461-2.744-2.442 0-4.522 1.015-6.38 3.87l-.306.466c-.25.384-.305.521-.305.686s.083.302.388.494l3.135 1.948c.167.11.305.165.444.165.166 0 .277-.082.444-.33l.5-.768c.776-1.18 1.47-1.564 2.357-1.564.777 0 1.692.22 2.83.768l3.273 1.537c.333.165.693.083.86-.302l1.553-3.403c.167-.384.056-.63-.333-.823M8.761 13.01c4.938 2.388 6.38 2.744 8.461 2.744 2.441 0 4.522-1.015 6.38-3.87l.305-.466c.25-.384.305-.521.305-.686 0-.164-.083-.302-.388-.494L20.691 8.29c-.167-.11-.306-.165-.444-.165-.167 0-.278.082-.444.33l-.5.768c-.776 1.18-1.47 1.564-2.357 1.564-.777 0-1.693-.22-2.83-.768l-3.273-1.537c-.333-.165-.694-.083-.86.302l-1.554 3.403c-.166.384-.055.63.333.823\"/>\n</svg>\n";
function $0b415cb06590d81b$export$a88b0b0da9ef63ce(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Confluence' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $e5724170be447320$export$f827d3c5a9c3f644), {
        svg: $0b415cb06590d81b$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::daf8acf7c1707ab5f837689f4e92f4a5>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
var $cdf91bfd5129c5de$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color, white)\" d=\"M6 .5h12A5.5 5.5 0 0 1 23.5 6v12a5.5 5.5 0 0 1-5.5 5.5H6A5.5 5.5 0 0 1 .5 18V6A5.5 5.5 0 0 1 6 .5\"/>\n    <path fill=\"none\" stroke=\"var(--border-color, #dddee1)\" d=\"M6 .5h12A5.5 5.5 0 0 1 23.5 6v12a5.5 5.5 0 0 1-5.5 5.5H6A5.5 5.5 0 0 1 .5 18V6A5.5 5.5 0 0 1 6 .5Z\"/>\n    <path fill=\"var(--icon-color, #1868db)\" d=\"M17.37 14.265c-3.704-1.79-4.785-2.058-6.346-2.058-1.83 0-3.391.761-4.785 2.902l-.229.35c-.187.288-.229.39-.229.514s.063.227.292.37l2.35 1.462c.125.083.23.124.333.124.125 0 .208-.062.333-.247l.375-.577c.582-.885 1.102-1.173 1.768-1.173.583 0 1.27.165 2.122.577l2.455 1.152c.25.124.52.062.645-.226l1.165-2.552c.125-.289.042-.474-.25-.618M6.572 9.757c3.703 1.791 4.785 2.059 6.346 2.059 1.83 0 3.39-.762 4.785-2.902l.229-.35c.187-.288.228-.391.228-.515 0-.123-.062-.226-.29-.37l-2.352-1.462c-.125-.082-.229-.123-.333-.123-.125 0-.208.061-.333.247l-.374.576c-.583.885-1.103 1.173-1.769 1.173-.582 0-1.269-.164-2.122-.576L8.132 6.361c-.25-.123-.52-.061-.645.227L6.322 9.14c-.125.288-.041.473.25.617\"/>\n</svg>\n";
function $cdf91bfd5129c5de$export$53305f1f2855d3be(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Confluence Data Center' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $05f9b20d45e480e2$export$be58b4326e23250f), {
        svg: $cdf91bfd5129c5de$var$svg,
        label: label,
        type: "data-center",
        appearance: appearance,
        size: size,
        testId: testId
    });
}

/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c86f2cdcf615e24dd3ad3f9b48bca5bf>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $663307540044c66a$var$svg = "<svg height=\"100%\" viewBox=\"0 0 188 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M181.16 12.09c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.2c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-15.1-2.16v2.36c-.92.49-2.33.71-3.74.71-5.46 0-8-3.31-8-8 0-4.63 2.55-7.94 8-7.94 1.38 0 2.45.18 3.65.74v2.45c-.98-.46-2.02-.74-3.47-.74-3.99 0-5.61 2.51-5.61 5.49s1.66 5.49 5.67 5.49c1.56 0 2.55-.21 3.5-.55m-14.5-6.23v8.99h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 3.53 0 5.55 2.42 5.55 6.66m-22.92-4.27c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-29.1-5.74V10h2.64v9.26c0 2.76 1.1 3.99 3.62 3.99 2.45 0 4.14-1.62 4.14-4.72V10h2.64v15.33h-2.64v-2.51c-.98 1.81-2.79 2.82-4.85 2.82-3.53 0-5.55-2.42-5.55-6.65m-2.23 6.31c-.21.06-.67.12-1.35.12-2.51 0-4.11-1.2-4.11-4.02V3.59h2.64V21.1c0 1.38.92 1.87 2.06 1.87.28 0 .46 0 .77-.03zM96.82 8.38V10h3.96v2.45h-3.96v12.88h-2.58V12.45h-2.48V10h2.48V8.31c0-2.85 1.59-4.78 4.88-4.78.8 0 1.32.12 1.78.25V6.2a8.7 8.7 0 0 0-1.66-.15c-1.62 0-2.42.95-2.42 2.33m-7.32 7.97v8.99h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 3.53 0 5.55 2.42 5.55 6.66m-23.34 9.28c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49m-9.23 9.63v2.67c-1.26.83-3.25 1.2-5.34 1.2-6.62 0-10.36-3.99-10.36-10.33 0-6.13 3.74-10.43 10.3-10.43 1.96 0 3.93.37 5.37 1.41v2.67c-1.44-.92-3.04-1.41-5.37-1.41-4.72 0-7.54 3.13-7.54 7.76s2.91 7.7 7.7 7.7c2.12 0 3.77-.49 5.24-1.23\"/>\n    <path fill=\"var(--tile-color, white)\" d=\"M8 .667h16A7.333 7.333 0 0 1 31.333 8v16A7.333 7.333 0 0 1 24 31.333H8A7.333 7.333 0 0 1 .667 24V8A7.333 7.333 0 0 1 8 .667\"/>\n    <path fill=\"none\" stroke=\"var(--border-color, #dddee1)\" stroke-width=\"1.333\" d=\"M8 .667h16A7.333 7.333 0 0 1 31.333 8v16A7.333 7.333 0 0 1 24 31.333H8A7.333 7.333 0 0 1 .667 24V8A7.333 7.333 0 0 1 8 .667Z\"/>\n    <path fill=\"var(--icon-color, #1868db)\" d=\"M23.16 19.02c-4.938-2.387-6.38-2.744-8.461-2.744-2.441 0-4.522 1.015-6.38 3.87l-.306.466c-.25.384-.305.521-.305.686s.084.302.389.494l3.134 1.948c.167.11.306.165.444.165.167 0 .278-.082.444-.33l.5-.768c.776-1.18 1.47-1.564 2.357-1.564.777 0 1.693.22 2.83.768l3.273 1.537c.333.165.694.083.86-.302l1.554-3.403c.166-.384.055-.63-.333-.823M8.762 13.01c4.938 2.388 6.38 2.744 8.461 2.744 2.441 0 4.522-1.015 6.38-3.87l.306-.466c.25-.384.305-.521.305-.686 0-.164-.083-.302-.388-.494L20.69 8.29c-.167-.11-.305-.165-.444-.165-.166 0-.277.082-.444.33l-.5.768c-.776 1.18-1.47 1.564-2.357 1.564-.777 0-1.692-.22-2.83-.768l-3.273-1.537c-.333-.165-.694-.083-.86.302L8.43 12.187c-.167.384-.056.63.332.823\"/>\n</svg>\n";
function $663307540044c66a$export$b3e508cb103e1f93(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Confluence Data Center' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $e5724170be447320$export$f827d3c5a9c3f644), {
        svg: $663307540044c66a$var$svg,
        label: label,
        type: "data-center",
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::9928c9b96accda0f9234a11fc7ddaca0>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
var $7bcc6b150a03baab$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color, white)\" d=\"M6 .5h12A5.5 5.5 0 0 1 23.5 6v12a5.5 5.5 0 0 1-5.5 5.5H6A5.5 5.5 0 0 1 .5 18V6A5.5 5.5 0 0 1 6 .5\"/>\n    <path fill=\"none\" stroke=\"var(--border-color, #dddee1)\" d=\"M6 .5h12A5.5 5.5 0 0 1 23.5 6v12a5.5 5.5 0 0 1-5.5 5.5H6A5.5 5.5 0 0 1 .5 18V6A5.5 5.5 0 0 1 6 .5Z\"/>\n    <path fill=\"var(--icon-color, #1868db)\" d=\"M18.71 7.463 12 4.993l-6.71 2.47a.44.44 0 0 0-.29.433l.14 3.807c.103 3.148 1.684 5.489 4.163 7.018a.446.446 0 0 0 .646-.204l1.445-3.412a.22.22 0 0 0-.14-.298 2.585 2.585 0 1 1 1.492 0 .22.22 0 0 0-.14.298l1.446 3.412a.446.446 0 0 0 .645.204c2.48-1.529 4.06-3.87 4.163-7.018L19 7.896a.44.44 0 0 0-.29-.433\"/>\n</svg>\n";
function $7bcc6b150a03baab$export$eaf73f391f7103bd(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Crowd' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $05f9b20d45e480e2$export$be58b4326e23250f), {
        svg: $7bcc6b150a03baab$var$svg,
        label: label,
        type: "data-center",
        appearance: appearance,
        size: size,
        testId: testId
    });
}

/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::206fa44ab9c6427ebeb6aaad7e53b58f>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $cabff14b4a4d22c8$var$svg = "<svg height=\"100%\" viewBox=\"0 0 126 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M113.97 17.67c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V3.59h2.64v21.74zm-17.72 0h-3.37l-2.64-7.42-1.41-4.72-1.41 4.72-2.64 7.42h-3.37L84.45 10h2.91l4.42 13 4.48-13h2.51l4.48 13 4.41-13h2.91zm-28.47.31c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49m-13.77 4.14v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.68-5.43 3.93m-5.76 5.48v2.67c-1.26.83-3.25 1.2-5.34 1.2-6.62 0-10.36-3.99-10.36-10.33 0-6.13 3.74-10.43 10.3-10.43 1.96 0 3.93.37 5.37 1.41v2.67c-1.44-.92-3.04-1.41-5.37-1.41-4.72 0-7.54 3.13-7.54 7.76s2.91 7.7 7.7 7.7c2.12 0 3.77-.49 5.24-1.23\"/>\n    <path fill=\"var(--tile-color, white)\" d=\"M8 .667h16A7.333 7.333 0 0 1 31.333 8v16A7.333 7.333 0 0 1 24 31.333H8A7.333 7.333 0 0 1 .667 24V8A7.333 7.333 0 0 1 8 .667\"/>\n    <path fill=\"none\" stroke=\"var(--border-color, #dddee1)\" stroke-width=\"1.333\" d=\"M8 .667h16A7.333 7.333 0 0 1 31.333 8v16A7.333 7.333 0 0 1 24 31.333H8A7.333 7.333 0 0 1 .667 24V8A7.333 7.333 0 0 1 8 .667Z\"/>\n    <path fill=\"var(--icon-color, #1868db)\" d=\"M24.946 9.951 16 6.657 7.054 9.95a.59.59 0 0 0-.387.577l.187 5.076c.137 4.197 2.245 7.319 5.55 9.357.31.19.719.063.86-.272l1.928-4.55a.294.294 0 0 0-.185-.396 3.447 3.447 0 1 1 1.987 0 .294.294 0 0 0-.185.397l1.927 4.549c.142.335.55.463.86.272 3.305-2.038 5.413-5.16 5.55-9.357l.187-5.076a.59.59 0 0 0-.387-.577\"/>\n</svg>\n";
function $cabff14b4a4d22c8$export$3c371bdbcdfcdce(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Crowd' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $e5724170be447320$export$f827d3c5a9c3f644), {
        svg: $cabff14b4a4d22c8$var$svg,
        label: label,
        type: "data-center",
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2cbaafcea60527c20df8d8395e491b95>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
var $d29a2f476ea23fcc$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#ffc716)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M16.43 17.42A6.97 6.97 0 0 1 12 19H6.4v-.47l3.84-3.78a3.25 3.25 0 0 0 1.76.52c.65 0 1.25-.19 1.76-.51zm.99-.99A6.97 6.97 0 0 0 19 12a6.97 6.97 0 0 0-1.58-4.43l-2.67 2.67c.33.51.52 1.11.52 1.76s-.19 1.25-.51 1.76zm-.99-9.85-2.67 2.67A3.25 3.25 0 0 0 12 8.73c-.65 0-1.25.19-1.76.52L7.57 6.58A6.97 6.97 0 0 1 12 5c1.68 0 3.22.59 4.43 1.58m-9.85.99A6.97 6.97 0 0 0 5 12c0 1.68.59 3.22 1.58 4.43l2.67-2.67A3.25 3.25 0 0 1 8.73 12c0-.65.19-1.25.52-1.76z\"/>\n</svg>\n";
var $d29a2f476ea23fcc$var$customThemeSvg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--themed-icon-color, currentcolor)\" d=\"M18 0a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6V6a6 6 0 0 1 6-6zm-4.238 14.751a3.25 3.25 0 0 1-1.762.516 3.25 3.25 0 0 1-1.762-.515L6.4 18.533V19H12a6.97 6.97 0 0 0 4.43-1.58zM6.58 7.571A6.97 6.97 0 0 0 5 12a6.97 6.97 0 0 0 1.58 4.43l2.669-2.668A3.25 3.25 0 0 1 8.733 12c0-.649.19-1.253.516-1.762zm8.172 2.667c.326.508.515 1.113.515 1.762s-.189 1.254-.515 1.762l2.668 2.668A6.97 6.97 0 0 0 19 12a6.97 6.97 0 0 0-1.58-4.43zM12 5a6.97 6.97 0 0 0-4.43 1.58l2.668 2.668A3.25 3.25 0 0 1 12 8.733c.649 0 1.253.19 1.762.516L16.43 6.58A6.97 6.97 0 0 0 12 5\"/>\n</svg>\n";
function $d29a2f476ea23fcc$export$6da5aa77c402ba0f(_ref) {
    var iconColor = _ref.iconColor, size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Customer Service Management' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $05f9b20d45e480e2$export$be58b4326e23250f), {
        svg: $d29a2f476ea23fcc$var$svg,
        customThemeSvg: $d29a2f476ea23fcc$var$customThemeSvg,
        iconColor: iconColor,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7b7476897879e097648c054d2783409e>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $501906e2812827da$var$svg = "<svg height=\"100%\" viewBox=\"0 0 456 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M451.86 20.58c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55c-.46.12-.98.25-1.78.25-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zm-7.33-4.23v8.99h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 3.53 0 5.55 2.42 5.55 6.66m-22.92-4.27c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-26.16-7.92v8.53h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 2.61 0 4.39 1.32 5.15 3.74.86-2.36 2.91-3.74 5.46-3.74 3.44 0 5.34 2.33 5.34 6.66v8.99h-2.64v-8.52c0-3.16-1.1-4.72-3.62-4.72-2.45 0-4.14 1.63-4.14 4.72m-22.92-4.74c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-18.64-.62v-1.53c-.98 2.02-2.82 3.07-5.18 3.07-4.05 0-6.07-3.46-6.07-7.97 0-4.32 2.12-7.97 6.38-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.58v13.95c0 4.51-2.12 7.54-7.6 7.54-2.58 0-3.99-.34-5.46-.83v-2.58c1.69.55 3.44.92 5.34.92 3.83 0 5.15-2.05 5.15-4.91m-8.68-6.44c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m-16.96.03c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-14.08-8.98v8.99h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 3.53 0 5.55 2.42 5.55 6.66m-28.33 1.31c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-31.44-11.01-2.76-7.48v18.49h-2.76V5.19h4.78l4.57 11.56 1.87 5.55 1.87-5.55 4.6-11.56h4.45v20.15h-2.76V7.06l-2.36 7.27-4.45 11.01h-2.67zm-21.51-2.23c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-15.1-2.16v2.36c-.92.49-2.33.71-3.74.71-5.46 0-8-3.31-8-8 0-4.63 2.55-7.94 8-7.94 1.38 0 2.45.18 3.65.74v2.45c-.98-.46-2.02-.74-3.47-.74-3.99 0-5.61 2.51-5.61 5.49s1.66 5.49 5.67 5.49c1.56 0 2.55-.21 3.5-.55M234.91 5.95c0-1.16.77-1.84 1.84-1.84s1.84.68 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-8.24 0h-3.53L217.69 10h2.76l4.97 13.09L230.36 10h2.76zm-15.45-9.04v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.68-5.43 3.93m-12.46-4.21c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.05 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-15.33-4.95c0 3.5-2.08 5.86-7.08 5.86-3.89 0-5.7-.77-7.27-1.56v-2.82c1.87.98 4.75 1.69 7.42 1.69 3.04 0 4.17-1.2 4.17-2.97 0-1.78-1.1-2.73-4.94-3.65-4.54-1.1-6.56-2.67-6.56-5.98 0-3.13 2.39-5.46 7.08-5.46 2.91 0 4.78.71 6.16 1.47v2.76c-2.02-1.16-4.2-1.53-6.29-1.53-2.64 0-4.2.92-4.2 2.76 0 1.66 1.29 2.48 4.85 3.37 4.26 1.07 6.65 2.45 6.65 6.07m-26.4-3.5v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.68-5.43 3.93m-12.46-4.21c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2H146.5c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-26.15-7.92v8.53h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 2.61 0 4.39 1.32 5.15 3.74.86-2.36 2.91-3.74 5.46-3.74 3.44 0 5.34 2.33 5.34 6.66v8.99h-2.64v-8.52c0-3.16-1.1-4.72-3.62-4.72-2.45 0-4.14 1.63-4.14 4.72m-23.34 8.81c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49M94.1 20.58c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55a6.3 6.3 0 0 1-1.78.25c-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45H94.1zm-6.7.58c0 2.55-1.66 4.48-5.77 4.48-2.3 0-4.17-.52-5.34-1.13v-2.79c1.32.77 3.53 1.5 5.46 1.5 2.02 0 3.07-.83 3.07-2.02 0-1.16-.89-1.84-3.8-2.54-3.4-.83-4.84-2.15-4.84-4.66 0-2.67 2.05-4.29 5.55-4.29 1.99 0 3.8.49 4.94 1.1v2.73c-1.84-.92-3.34-1.41-4.97-1.41-1.93 0-2.97.68-2.97 1.87 0 1.07.74 1.75 3.56 2.42 3.4.83 5.12 2.09 5.12 4.75m-27.6-2.18V10h2.64v9.26c0 2.76 1.1 3.99 3.62 3.99 2.45 0 4.14-1.63 4.14-4.72V10h2.64v15.33h-2.64v-2.51c-.98 1.81-2.79 2.82-4.84 2.82-3.53 0-5.55-2.42-5.55-6.65m-2.89 2.79v2.67c-1.26.83-3.25 1.2-5.34 1.2-6.62 0-10.36-3.99-10.36-10.33 0-6.13 3.74-10.43 10.3-10.43 1.96 0 3.93.37 5.37 1.41v2.67c-1.44-.92-3.04-1.41-5.37-1.41-4.72 0-7.54 3.13-7.54 7.76s2.91 7.7 7.7 7.7c2.12 0 3.77-.49 5.24-1.23\"/>\n    <path fill=\"var(--tile-color,#ffc716)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M21.91 23.23a9.3 9.3 0 0 1-5.91 2.1H8.53v-.62l5.12-5.04a4.34 4.34 0 0 0 2.35.69c.86 0 1.67-.25 2.35-.69zm1.32-1.32a9.3 9.3 0 0 0 2.1-5.91c0-2.24-.79-4.3-2.11-5.91l-3.56 3.56c.43.68.69 1.48.69 2.35s-.25 1.67-.69 2.35zM21.91 8.77l-3.56 3.56a4.34 4.34 0 0 0-2.35-.69c-.86 0-1.67.25-2.35.69l-3.56-3.56A9.3 9.3 0 0 1 16 6.67c2.24 0 4.3.79 5.91 2.11M8.77 10.09A9.3 9.3 0 0 0 6.67 16c0 2.24.79 4.3 2.11 5.91l3.56-3.56a4.34 4.34 0 0 1-.69-2.35c0-.86.25-1.67.69-2.35z\"/>\n</svg>\n";
function $501906e2812827da$export$f597f0f7fadce0b9(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Customer Service Management' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $e5724170be447320$export$f827d3c5a9c3f644), {
        svg: $501906e2812827da$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::fe1275028f179c85adabcde30f1dc14d>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
var $dec238ff93319a00$var$svg = "<svg height=\"100%\" viewBox=\"0 0 48 48\">\n    <path fill=\"var(--tile-color,#94c748)\" d=\"M0 12C0 5.373 5.373 0 12 0h24c6.627 0 12 5.373 12 12v24c0 6.627-5.373 12-12 12H12C5.373 48 0 42.627 0 36z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"m36.22 26.75 4.9 7.25h-4.78c-.52-.6-1.02-1.31-1.47-1.98-.68-1.02-.68-2.41.03-3.41zm-7.3-5.5L24.02 14h4.78c.52.6 1.02 1.31 1.47 1.98.68 1.02.68 2.41-.02 3.41zm6.98-6.02c.5-.84 1.07-1.16 1.95-1.16l3.9-.07-12.68 19.27a1.46 1.46 0 0 1-1.22.67H23.6c4.07-6.25 8.37-12.37 12.31-18.7M8 33.94h6.89c6.16 0 9.92-3.88 9.92-9.94s-3.76-9.94-9.92-9.94H8l4.28 3.9h-1.76C9.13 17.96 8 19.12 8 20.55v13.38m4.41-3.9V17.96h2.46c3.52 0 5.49 2.38 5.49 6.04 0 3.65-1.97 6.04-5.46 6.04z\"/>\n</svg>\n";
function $dec238ff93319a00$export$9951d02c2d848122(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Dx' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $05f9b20d45e480e2$export$be58b4326e23250f), {
        svg: $dec238ff93319a00$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c86bc4a90f7eb35fd36ae7c99f20011b>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
var $7b0cb8c2403d85b2$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#fb9700)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M20.84 12.21a4.29 4.29 0 0 0-6.05 0l-1.394 1.393c-.77.769-2.02.769-2.789 0L9.45 12.445 6.424 15.47l1.158 1.158a6.25 6.25 0 0 0 8.838 0zm-17.68-.418a4.253 4.253 0 0 0 6.034.017l1.412-1.412a1.973 1.973 0 0 1 2.788 0l1.158 1.158 3.026-3.025-1.158-1.158a6.25 6.25 0 0 0-8.838 0l-4.42 4.419z\"/>\n</svg>\n";
function $7b0cb8c2403d85b2$export$1e02e7298035a77c(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Focus' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $05f9b20d45e480e2$export$be58b4326e23250f), {
        svg: $7b0cb8c2403d85b2$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7aca4717e5f7edbaa74141430c7d1f8d>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $4997c0e4e5416e87$var$svg = "<svg height=\"100%\" viewBox=\"0 0 117 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M116.03 21.16c0 2.55-1.66 4.48-5.76 4.48-2.3 0-4.17-.52-5.34-1.13v-2.79c1.32.77 3.53 1.5 5.46 1.5 2.02 0 3.07-.83 3.07-2.02 0-1.16-.89-1.84-3.8-2.54-3.4-.83-4.85-2.15-4.85-4.66 0-2.67 2.06-4.29 5.55-4.29 1.99 0 3.8.49 4.94 1.1v2.73c-1.84-.92-3.34-1.41-4.97-1.41-1.93 0-2.97.68-2.97 1.87 0 1.07.74 1.75 3.56 2.42 3.4.83 5.12 2.09 5.12 4.75m-27.6-2.18V10h2.64v9.26c0 2.76 1.1 3.99 3.62 3.99 2.45 0 4.14-1.62 4.14-4.72V10h2.64v15.33h-2.64v-2.51c-.98 1.81-2.79 2.82-4.85 2.82-3.53 0-5.55-2.42-5.55-6.65m-2.71 3.58v2.36c-.92.49-2.33.71-3.74.71-5.46 0-8-3.31-8-8 0-4.63 2.55-7.94 8-7.94 1.38 0 2.45.18 3.65.74v2.45c-.98-.46-2.02-.74-3.47-.74-3.99 0-5.61 2.51-5.61 5.49s1.66 5.49 5.67 5.49c1.56 0 2.55-.21 3.5-.55M64.6 25.64c-4.6 0-7.3-3.4-7.3-8S60 9.7 64.6 9.7c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49m-9.97 5.67h-9.14v7.51h-2.76V5.19h12.94v2.64H45.49v7.36h9.14z\"/>\n    <path fill=\"var(--tile-color,#fb9700)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M27.607 16.272c-2.176-2.176-5.712-2.152-7.865 0l-1.812 1.812c-1 1-2.625 1-3.625 0L12.8 16.578l-3.933 3.934 1.505 1.505a8.126 8.126 0 0 0 11.49 0zm-22.982-.541c2.176 2.175 5.668 2.196 7.844.02l1.834-1.834c1-1 2.625-1 3.625 0l1.505 1.505 3.934-3.933-1.505-1.505a8.126 8.126 0 0 0-11.49 0l-5.745 5.745z\"/>\n</svg>\n";
function $4997c0e4e5416e87$export$3a6e8b37e069a69d(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Focus' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $e5724170be447320$export$f827d3c5a9c3f644), {
        svg: $4997c0e4e5416e87$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::691ffc068fd79d2f7585ba74e9375893>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
var $054a7cc9a77efc09$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M14.352 12a2.352 2.352 0 1 1-4.704 0 2.352 2.352 0 0 1 4.704 0\"/>\n    <path fill=\"var(--icon-color, #101214)\" fill-rule=\"evenodd\" d=\"M12 18.563a6.562 6.562 0 1 0 0-13.125 6.562 6.562 0 0 0 0 13.125M16.102 12a4.102 4.102 0 1 1-8.204 0 4.102 4.102 0 0 1 8.204 0\" clip-rule=\"evenodd\"/>\n</svg>\n";
function $054a7cc9a77efc09$export$9eb74917ea768ed4(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Goals' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $05f9b20d45e480e2$export$be58b4326e23250f), {
        svg: $054a7cc9a77efc09$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4fcd237a4e74e8fc6ee2ed98ecae9d02>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $44589a9683d32305$var$svg = "<svg height=\"100%\" viewBox=\"0 0 116 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M115.55 21.16c0 2.55-1.66 4.48-5.77 4.48-2.3 0-4.17-.52-5.34-1.13v-2.79c1.32.77 3.53 1.5 5.46 1.5 2.02 0 3.07-.83 3.07-2.02 0-1.16-.89-1.84-3.8-2.54-3.4-.83-4.84-2.15-4.84-4.66 0-2.67 2.05-4.29 5.55-4.29 1.99 0 3.8.49 4.94 1.1v2.73c-1.84-.92-3.34-1.41-4.97-1.41-1.93 0-2.97.68-2.97 1.87 0 1.07.74 1.75 3.56 2.42 3.4.83 5.12 2.09 5.12 4.75m-13.12 4.13c-.21.06-.67.12-1.35.12-2.51 0-4.11-1.19-4.11-4.02V3.59h2.64V21.1c0 1.38.92 1.87 2.06 1.87.28 0 .46 0 .77-.03zm-20.75-7.63c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-20.7.31c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49M58.71 24.2c-1.59.95-4.54 1.44-6.81 1.44-6.93 0-10.67-4.23-10.67-10.33 0-6.56 4.26-10.46 11.44-10.46 1.6 0 3.47.18 5.24.8v2.76c-1.53-.61-3.34-.89-5.21-.89-5.98 0-8.71 2.98-8.71 7.73 0 4.66 2.76 7.76 8.56 7.76.95 0 2.27-.09 3.4-.43v-5.61H50.8v-2.64h7.91z\"/>\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M19.36 16a3.36 3.36 0 1 1-6.72 0 3.36 3.36 0 0 1 6.72 0\"/>\n    <path fill=\"var(--icon-color, #101214)\" fill-rule=\"evenodd\" d=\"M16 25.375a9.375 9.375 0 1 0 0-18.75 9.375 9.375 0 1 0 0 18.75M21.86 16a5.86 5.86 0 1 1-11.72 0 5.86 5.86 0 0 1 11.72 0\" clip-rule=\"evenodd\"/>\n</svg>\n";
function $44589a9683d32305$export$c527a545aa426db3(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Goals' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $e5724170be447320$export$f827d3c5a9c3f644), {
        svg: $44589a9683d32305$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::9271fe2e99ed03180fc112676167f42e>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
var $22b6ae01216a6a81$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M5.49 10.87h13.02c.374 0 .574-.2.574-.574V5.907c0-.374-.2-.574-.574-.574h-2.744c-.374 0-.573.2-.573.574v2.22h-1.247v-2.22c0-.374-.2-.574-.574-.574h-2.743c-.374 0-.574.2-.574.574v2.22H8.807v-2.22c0-.374-.2-.574-.573-.574H5.49c-.374 0-.573.2-.573.574v4.39c0 .373.2.573.573.573m.225 3.84a8.7 8.7 0 0 1-.5-2.493c-.024-.324.126-.499.475-.499h12.62c.349 0 .498.15.498.449a8.2 8.2 0 0 1-.523 2.544c-.15.399-.375.573-.799.573H6.513c-.424 0-.649-.174-.798-.573m11.547 2.07C16.065 18.253 14.095 19.2 12 19.2s-4.116-.948-5.288-2.42c-.299-.398-.15-.648.15-.648h10.275c.3 0 .45.25.125.649\"/>\n</svg>\n";
function $22b6ae01216a6a81$export$3f95fcfdc25a741d(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Guard' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $05f9b20d45e480e2$export$be58b4326e23250f), {
        svg: $22b6ae01216a6a81$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::db6984f13fa8a1f65e3a27814935822a>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $0d052c1f365de2d0$var$svg = "<svg height=\"100%\" viewBox=\"0 0 120 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M108.4 17.67c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V3.59h2.64v21.74zm-17.8-9.04v9.05H96.7V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.67-5.43 3.93m-17.86 1.37c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-27.42-6.34V10h2.64v9.26c0 2.76 1.1 3.99 3.62 3.99 2.45 0 4.14-1.62 4.14-4.72V10h2.64v15.33h-2.64v-2.51c-.98 1.81-2.79 2.82-4.84 2.82-3.53 0-5.55-2.42-5.55-6.65m-3.98 5.21c-1.59.95-4.54 1.44-6.81 1.44-6.93 0-10.67-4.23-10.67-10.33 0-6.56 4.26-10.46 11.44-10.46 1.6 0 3.47.18 5.24.8v2.76c-1.53-.61-3.34-.89-5.21-.89-5.98 0-8.71 2.98-8.71 7.73 0 4.66 2.76 7.76 8.56 7.76.95 0 2.27-.09 3.4-.43v-5.61H50.8v-2.64h7.91z\"/>\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M8.188 14.644h15.623c.449 0 .688-.24.688-.688V8.688c0-.449-.24-.688-.688-.688h-3.292c-.45 0-.689.24-.689.688v2.664h-1.496V8.688c0-.449-.24-.688-.688-.688h-3.293c-.448 0-.688.24-.688.688v2.664H12.17V8.688c0-.449-.24-.688-.689-.688H8.188c-.449 0-.688.24-.688.688v5.268c0 .449.24.688.688.688m.27 4.609a10.4 10.4 0 0 1-.599-2.993c-.03-.389.15-.598.569-.598H23.57c.42 0 .599.18.599.538q-.09 1.662-.629 3.053c-.18.479-.448.688-.957.688H9.415c-.508 0-.778-.21-.957-.688m13.856 2.484c-1.436 1.766-3.8 2.903-6.314 2.903s-4.939-1.137-6.345-2.903c-.36-.479-.18-.778.18-.778h12.33c.359 0 .538.3.15.778\"/>\n</svg>\n";
function $0d052c1f365de2d0$export$2b896c4d595a4331(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Guard' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $e5724170be447320$export$f827d3c5a9c3f644), {
        svg: $0d052c1f365de2d0$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2dae141e789f6f860676eab772d48c16>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
var $899d9f8a72fd5810$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M5.875 10.688v7.437h4.375V13.75h3.5v4.375h4.375v-7.437L12 5z\"/>\n</svg>\n";
function $899d9f8a72fd5810$export$92c8767b874048d(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Home' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $05f9b20d45e480e2$export$be58b4326e23250f), {
        svg: $899d9f8a72fd5810$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f61715fd61f2481e52a0f7c7611f421f>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $cacaef9956f97a67$var$svg = "<svg height=\"100%\" viewBox=\"0 0 121 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M113.57 12.09c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zM93.3 16.81v8.53h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 2.61 0 4.39 1.32 5.15 3.74.86-2.36 2.91-3.74 5.46-3.74 3.43 0 5.34 2.33 5.34 6.66v8.99h-2.64v-8.52c0-3.16-1.1-4.72-3.62-4.72-2.45 0-4.14 1.63-4.14 4.72m-23.33 8.81c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49M56.41 5.19h2.76v20.15h-2.76v-8.71H45.8v8.71h-2.76V5.19h2.76v8.8h10.61z\"/>\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M7.25 14.125V24.75h6.25V18.5h5v6.25h6.25V14.125L16 6z\"/>\n</svg>\n";
function $cacaef9956f97a67$export$8b6b7f1b1b2367d3(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Home' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $e5724170be447320$export$f827d3c5a9c3f644), {
        svg: $cacaef9956f97a67$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::459e9cba95b1e0b094b9b0a89db30ecd>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
var $012945d8e2fbfa71$var$svg = "<svg height=\"100%\" viewBox=\"0 0 32 32\">\n    <g clip-path=\"url(#clip0_95164_16219)\">\n        <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n        <g clip-path=\"url(#clip1_95164_16219)\">\n            <path fill=\"var(--icon-color, #101214)\" fill-rule=\"evenodd\" d=\"M9 25.333V6.667h14v18.666h-5.25V21.25h-3.5v4.083zm3.5-14.583h2.333V9H12.5zm4.667 0H19.5V9h-2.333zm-2.334 4.083H12.5v-1.75h2.333zM12.5 18.916h2.333v-1.75H12.5zm7-4.083h-2.333v-1.75H19.5zm-2.333 4.083H19.5v-1.75h-2.333z\" clip-rule=\"evenodd\"/>\n        </g>\n    </g>\n    <defs>\n        <clipPath id=\"clip0_95164_16219\">\n            <path fill=\"var(--icon-color, white)\" d=\"M0 0h32v32H0z\"/>\n        </clipPath>\n        <clipPath id=\"clip1_95164_16219\">\n            <path fill=\"var(--icon-color, white)\" d=\"M2 2h28v28H2z\"/>\n        </clipPath>\n    </defs>\n</svg>\n";
function $012945d8e2fbfa71$export$80b8b269d8b5014e(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Hub' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $05f9b20d45e480e2$export$be58b4326e23250f), {
        svg: $012945d8e2fbfa71$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::edd23980285704c09d78f5241a37a99c>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $d01ef7a6c70afe03$var$svg = "<svg height=\"100%\" viewBox=\"0 0 95 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M91.61 17.67c0-3.68-1.47-5.52-4.2-5.52-2.36 0-4.48 1.5-4.48 4.91v1.23c0 3.4 1.93 4.91 4.17 4.91 2.98 0 4.51-1.96 4.51-5.52m-3.8 7.97c-2.24 0-3.96-1.01-4.88-3v2.7h-2.64V3.59h2.64v9.17c.98-2.02 2.82-3.07 5.18-3.07 4.08 0 6.13 3.47 6.13 7.97 0 4.32-2.15 7.97-6.44 7.97m-24.52-6.64V10h2.64v9.26c0 2.76 1.1 3.99 3.62 3.99 2.45 0 4.14-1.62 4.14-4.72V10h2.64v15.33h-2.64v-2.51c-.98 1.81-2.79 2.82-4.84 2.82-3.53 0-5.55-2.42-5.55-6.65M56.4 5.19h2.76v20.15H56.4v-8.71H45.79v8.71h-2.76V5.19h2.76v8.8H56.4z\"/>\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" fill-rule=\"evenodd\" d=\"M9 25.333V6.667h14v18.666h-5.25V21.25h-3.5v4.083zm3.5-14.583h2.333V9H12.5zm4.667 0H19.5V9h-2.333zm-2.334 4.083H12.5v-1.75h2.333zM12.5 18.916h2.333v-1.75H12.5zm7-4.083h-2.333v-1.75H19.5zm-2.333 4.083H19.5v-1.75h-2.333z\" clip-rule=\"evenodd\"/>\n</svg>\n";
function $d01ef7a6c70afe03$export$7a38180641471460(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Hub' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $e5724170be447320$export$f827d3c5a9c3f644), {
        svg: $d01ef7a6c70afe03$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b225283860ba91a6c228b8f4fa0e1d39>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
var $701d5396eb72984c$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#1868db)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, white)\" d=\"M9.051 15.434H7.734c-1.988 0-3.413-1.218-3.413-3h7.085c.367 0 .605.26.605.63v7.13c-1.772 0-2.96-1.435-2.96-3.434zm3.5-3.543h-1.318c-1.987 0-3.413-1.196-3.413-2.978h7.085c.367 0 .627.239.627.608v7.13c-1.772 0-2.981-1.435-2.981-3.434zm3.52-3.522h-1.317c-1.987 0-3.413-1.217-3.413-3h7.085c.367 0 .605.262.605.61v7.129c-1.771 0-2.96-1.435-2.96-3.434z\"/>\n</svg>\n";
var $701d5396eb72984c$var$customThemeSvg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--themed-icon-color, currentcolor)\" d=\"M18 0a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6V6a6 6 0 0 1 6-6zM4.321 12.434c0 1.782 1.425 3 3.412 3h1.319v1.326c0 2 1.188 3.433 2.959 3.433v-7.129c0-.369-.238-.63-.605-.63zm3.5-3.52c0 1.781 1.425 2.977 3.412 2.977h1.318v1.326c0 2 1.21 3.433 2.98 3.433V9.521c0-.369-.259-.608-.626-.608zm3.52-3.544c0 1.782 1.426 3 3.413 3h1.317v1.304c0 2 1.188 3.433 2.96 3.433V5.98c0-.348-.238-.609-.605-.609z\"/>\n</svg>\n";
function $701d5396eb72984c$export$c4b5b1f965d8b3eb(_ref) {
    var iconColor = _ref.iconColor, size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Jira' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $05f9b20d45e480e2$export$be58b4326e23250f), {
        svg: $701d5396eb72984c$var$svg,
        customThemeSvg: $701d5396eb72984c$var$customThemeSvg,
        iconColor: iconColor,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3ed7d2f84cfdfe8bfef2a295bafed6da>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $840eb01c1734ebe0$var$svg = "<svg height=\"100%\" viewBox=\"0 0 83 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M71.02 17.67c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.98 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-17.79-9.04v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.67-5.43 3.93M52.22 5.95c0-1.17.77-1.84 1.84-1.84s1.84.67 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-6.42-5.95V5.19h2.76V19.2c0 3.71-1.63 6.26-5.43 6.26-1.44 0-2.55-.25-3.31-.52v-2.67c.83.34 1.84.52 2.85.52 2.33 0 3.13-1.41 3.13-3.4\"/>\n    <path fill=\"var(--tile-color,#1868db)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, white)\" d=\"M11.965 20.698h-1.803c-2.72 0-4.67-1.666-4.67-4.105h9.695c.502 0 .827.357.827.863v9.756c-2.423 0-4.05-1.963-4.05-4.7zm4.788-4.848H14.95c-2.72 0-4.67-1.636-4.67-4.075h9.695c.503 0 .857.327.857.832v9.756c-2.424 0-4.079-1.963-4.079-4.7zm4.818-4.82h-1.803c-2.72 0-4.67-1.665-4.67-4.104h9.695c.503 0 .828.357.828.833v9.756c-2.424 0-4.05-1.963-4.05-4.7z\"/>\n</svg>\n";
function $840eb01c1734ebe0$export$bf4c5f97b468e8d6(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Jira' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $e5724170be447320$export$f827d3c5a9c3f644), {
        svg: $840eb01c1734ebe0$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::61edfa3e375524991498620530471e0e>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
var $7d3956dbe8d63e3e$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color, white)\" d=\"M6 .5h12A5.5 5.5 0 0 1 23.5 6v12a5.5 5.5 0 0 1-5.5 5.5H6A5.5 5.5 0 0 1 .5 18V6A5.5 5.5 0 0 1 6 .5\"/>\n    <path fill=\"none\" stroke=\"var(--border-color, #dddee1)\" d=\"M6 .5h12A5.5 5.5 0 0 1 23.5 6v12a5.5 5.5 0 0 1-5.5 5.5H6A5.5 5.5 0 0 1 .5 18V6A5.5 5.5 0 0 1 6 .5Z\"/>\n    <path fill=\"var(--icon-color, #1868db)\" d=\"M8.974 15.523H7.62c-2.04 0-3.502-1.249-3.502-3.078h7.271c.377 0 .62.268.62.647v7.317c-1.817 0-3.036-1.472-3.036-3.525zm3.591-3.636h-1.352c-2.04 0-3.503-1.227-3.503-3.056h7.272c.376 0 .642.245.642.625v7.317c-1.817 0-3.059-1.473-3.059-3.525zm3.614-3.614h-1.353c-2.04 0-3.502-1.249-3.502-3.078h7.271c.377 0 .62.268.62.624v7.318c-1.817 0-3.036-1.473-3.036-3.525z\"/>\n</svg>\n";
function $7d3956dbe8d63e3e$export$f8455b5667a3ee0c(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Jira Data Center' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $05f9b20d45e480e2$export$be58b4326e23250f), {
        svg: $7d3956dbe8d63e3e$var$svg,
        label: label,
        type: "data-center",
        appearance: appearance,
        size: size,
        testId: testId
    });
}

/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::193cafbd0d66aed78a8eae06654a150d>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $69c118aaee2a1243$var$svg = "<svg height=\"100%\" viewBox=\"0 0 83 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M71.02 17.67c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.98 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.47-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-17.79-9.04v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.67-5.43 3.93M52.22 5.95c0-1.17.77-1.84 1.84-1.84s1.84.67 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-6.42-5.95V5.19h2.76V19.2c0 3.71-1.63 6.26-5.43 6.26-1.44 0-2.55-.24-3.31-.52v-2.67c.83.34 1.84.52 2.85.52 2.33 0 3.13-1.41 3.13-3.4\"/>\n    <path fill=\"var(--tile-color, white)\" d=\"M8 .667h16A7.333 7.333 0 0 1 31.333 8v16A7.333 7.333 0 0 1 24 31.333H8A7.333 7.333 0 0 1 .667 24V8A7.333 7.333 0 0 1 8 .667\"/>\n    <path fill=\"none\" stroke=\"var(--border-color, #dddee1)\" stroke-width=\"1.333\" d=\"M8 .667h16A7.333 7.333 0 0 1 31.333 8v16A7.333 7.333 0 0 1 24 31.333H8A7.333 7.333 0 0 1 .667 24V8A7.333 7.333 0 0 1 8 .667Z\"/>\n    <path fill=\"var(--icon-color, #1868db)\" d=\"M11.965 20.699h-1.803c-2.72 0-4.67-1.666-4.67-4.105h9.695c.502 0 .827.357.827.863v9.756c-2.424 0-4.05-1.963-4.05-4.7zm4.788-4.848H14.95c-2.72 0-4.67-1.636-4.67-4.075h9.695c.502 0 .857.327.857.832v9.756c-2.424 0-4.079-1.963-4.079-4.699zm4.818-4.819h-1.803c-2.72 0-4.67-1.666-4.67-4.105h9.695c.503 0 .828.357.828.833v9.756c-2.424 0-4.05-1.963-4.05-4.7z\"/>\n</svg>\n";
function $69c118aaee2a1243$export$3224b07bc93ef23e(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Jira Data Center' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $e5724170be447320$export$f827d3c5a9c3f644), {
        svg: $69c118aaee2a1243$var$svg,
        label: label,
        type: "data-center",
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3b3ec3c590ed89c431e0f979daa3e25e>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
var $78c17eeb06008ac8$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#c97cf4)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M13.467 4.882a9.47 9.47 0 0 0 5.422 0c.159-.035.265.07.23.229-.513 1.85-.513 3.558 0 5.408.035.14-.072.264-.23.211a10.1 10.1 0 0 0-5.422 0c-.142.053-.265-.07-.212-.211.476-1.85.476-3.559 0-5.408-.053-.159.07-.264.212-.23m.724 6.553v.3c0 1.39-.972 2.412-2.173 2.412a2.153 2.153 0 0 1-2.154-2.166c0-1.198.971-2.15 2.331-2.15h.353V5.62c-.176-.017-.353-.017-.53-.017a6.387 6.387 0 0 0-6.393 6.394 6.37 6.37 0 0 0 6.393 6.377c3.533 0 6.411-2.854 6.411-6.377v-.563z\"/>\n</svg>\n";
var $78c17eeb06008ac8$var$customThemeSvg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--themed-icon-color, currentcolor)\" d=\"M18 0a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6V6a6 6 0 0 1 6-6zm-5.981 5.604a6.387 6.387 0 0 0-6.394 6.394 6.373 6.373 0 0 0 6.394 6.377c3.532 0 6.41-2.854 6.41-6.377v-.563H14.19v.3c0 1.39-.97 2.412-2.171 2.413a2.154 2.154 0 0 1-2.156-2.168c0-1.197.973-2.148 2.332-2.148h.353v-4.21c-.177-.018-.353-.018-.53-.018m6.87-.722a9.47 9.47 0 0 1-5.422 0c-.141-.035-.265.07-.212.228.477 1.85.477 3.559 0 5.409-.053.14.07.264.212.211a10.1 10.1 0 0 1 5.422 0c.159.053.265-.07.23-.211-.513-1.85-.513-3.56 0-5.409.034-.158-.072-.263-.23-.228\"/>\n</svg>\n";
function $78c17eeb06008ac8$export$21bfbeb62fdcce8d(_ref) {
    var iconColor = _ref.iconColor, size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Jira Product Discovery' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $05f9b20d45e480e2$export$be58b4326e23250f), {
        svg: $78c17eeb06008ac8$var$svg,
        customThemeSvg: $78c17eeb06008ac8$var$customThemeSvg,
        iconColor: iconColor,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c8e2d27dec964efc37c6ed5782c3fe57>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $083a696f8e2d95a0$var$svg = "<svg height=\"100%\" viewBox=\"0 0 327 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M317.88 24.35h-1.72L310.62 10h2.82l4.91 13.13 4.9-13.13h2.82l-5.8 14.84c-1.72 4.39-2.7 6.65-6.59 6.65-1.32 0-2.06-.12-2.82-.43v-2.27c.89.28 1.9.37 2.67.37 2.15 0 3.1-1.47 4.36-4.82m-13.25-8.05v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.67-5.43 3.93m-12.47-4.21c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-19.72.6h-3.53L268.87 10h2.76l4.97 13.1 4.93-13.1h2.76zm-17.46.31c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49m-9.39 10.42v2.36c-.92.49-2.33.71-3.74.71-5.46 0-8-3.31-8-8 0-4.63 2.55-7.94 8-7.94 1.38 0 2.45.18 3.65.74v2.45c-.98-.46-2.02-.74-3.46-.74-3.99 0-5.61 2.51-5.61 5.49s1.66 5.49 5.67 5.49c1.56 0 2.55-.21 3.5-.55m-13.88-1.42c0 2.55-1.66 4.48-5.76 4.48-2.3 0-4.17-.52-5.34-1.13v-2.79c1.32.77 3.53 1.5 5.46 1.5 2.02 0 3.07-.83 3.07-2.02 0-1.16-.89-1.84-3.8-2.54-3.4-.83-4.85-2.15-4.85-4.66 0-2.67 2.06-4.29 5.55-4.29 1.99 0 3.8.49 4.94 1.1v2.73c-1.84-.92-3.34-1.41-4.97-1.41-1.93 0-2.97.68-2.97 1.87 0 1.07.74 1.75 3.56 2.42 3.4.83 5.12 2.09 5.12 4.75m-17.7-15.22c0-1.16.77-1.84 1.84-1.84s1.84.68 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zM207.68 7.82h-4.54v14.87h4.69c4.6 0 6.9-2.42 6.9-7.3 0-4.91-2.18-7.57-7.05-7.57m-7.3 17.51V5.19h7.42c6.53 0 9.69 4.08 9.69 10.12 0 6.1-3.19 10.03-9.69 10.03zm-13.41-4.75c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55c-.46.12-.98.25-1.78.25-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zm-6.66 1.99v2.36c-.92.49-2.33.71-3.74.71-5.46 0-8-3.31-8-8 0-4.63 2.55-7.94 8-7.94 1.38 0 2.45.18 3.65.74v2.45c-.98-.46-2.02-.74-3.46-.74-3.99 0-5.61 2.51-5.61 5.49s1.66 5.49 5.67 5.49c1.56 0 2.55-.21 3.5-.55m-27.86-3.59V10h2.64v9.26c0 2.76 1.1 3.99 3.62 3.99 2.45 0 4.14-1.62 4.14-4.72V10h2.64v15.33h-2.64v-2.51c-.98 1.81-2.79 2.82-4.84 2.82-3.53 0-5.55-2.42-5.55-6.65m-14.99-1.32c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V3.59h2.64v21.74zm-20.7.31c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49m-13.78 4.14v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.67-5.43 3.93m-5-4.4c0 4.39-2.45 6.84-7.48 6.84h-4.02v6.59h-2.76V5.19h6.78c5.03 0 7.48 2.58 7.48 6.72m-7.79 4.2c3.56.12 4.94-1.56 4.94-4.14 0-2.45-1.38-4.14-4.94-4.14h-3.71v8.28zm-27.87 1.56c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.98 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-17.79-9.04v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.67-5.43 3.93M52.22 5.95c0-1.16.77-1.84 1.84-1.84s1.84.68 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-6.42-5.95V5.19h2.76V19.2c0 3.71-1.63 6.26-5.43 6.26-1.44 0-2.55-.24-3.31-.52v-2.67c.83.34 1.84.52 2.85.52 2.33 0 3.13-1.41 3.13-3.4\"/>\n    <path fill=\"var(--tile-color,#c97cf4)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M17.448 6.967c2.544.746 5.113.746 7.656 0 .225-.05.375.1.325.323-.724 2.612-.724 5.025 0 7.637.05.199-.1.373-.325.298a14.3 14.3 0 0 0-7.656 0c-.2.075-.374-.1-.3-.298.674-2.612.674-5.025 0-7.637-.074-.223.1-.373.3-.323m1.023 9.253v.423c0 1.965-1.372 3.408-3.068 3.408a3.04 3.04 0 0 1-3.043-3.06c0-1.691 1.372-3.034 3.292-3.034h.5V8.012c-.25-.025-.5-.025-.749-.025a9.02 9.02 0 0 0-9.028 9.03c0 4.999 4.04 9.004 9.028 9.004s9.053-4.03 9.053-9.005v-.796z\"/>\n</svg>\n";
function $083a696f8e2d95a0$export$602140a6a10b02bf(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Jira Product Discovery' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $e5724170be447320$export$f827d3c5a9c3f644), {
        svg: $083a696f8e2d95a0$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::cedb5d68059644a06a093aa74d8e3cc5>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
var $508ce61f11a3a789$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#ffc716)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M13.744 10.156h4.578c.688 0 .922.654.503 1.174l-7.16 8.837c-2.314-1.845-2.096-4.763-.402-6.892zm-3.538 3.521H5.63c-.688 0-.923-.654-.504-1.173l7.16-8.837c2.315 1.844 2.063 4.728.386 6.875z\"/>\n</svg>\n";
var $508ce61f11a3a789$var$customThemeSvg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--themed-icon-color, currentcolor)\" d=\"M18 0a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6V6a6 6 0 0 1 6-6zm-4.256 10.156-2.481 3.12c-1.694 2.129-1.912 5.047.402 6.891l7.16-8.837c.42-.52.185-1.174-.503-1.174zm-8.619 2.348c-.419.52-.183 1.174.504 1.174h4.577l2.465-3.136c1.677-2.146 1.928-5.03-.386-6.875z\"/>\n</svg>\n";
function $508ce61f11a3a789$export$3c6158790f5e01c4(_ref) {
    var iconColor = _ref.iconColor, size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Jira Service Management' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $05f9b20d45e480e2$export$be58b4326e23250f), {
        svg: $508ce61f11a3a789$var$svg,
        customThemeSvg: $508ce61f11a3a789$var$customThemeSvg,
        iconColor: iconColor,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::bcf1b6bc0c0712320d6fbdb868500ebb>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $4db70b2e6f76ba0c$var$svg = "<svg height=\"100%\" viewBox=\"0 0 372 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M367.07 20.58c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55a6.3 6.3 0 0 1-1.78.25c-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zm-7.32-4.23v8.99h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 3.53 0 5.55 2.42 5.55 6.66m-22.92-4.27c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-26.16-7.92v8.53h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 2.61 0 4.39 1.32 5.15 3.74.86-2.36 2.91-3.74 5.46-3.74 3.43 0 5.34 2.33 5.34 6.66v8.99h-2.64v-8.52c0-3.16-1.1-4.72-3.62-4.72-2.45 0-4.14 1.63-4.14 4.72m-22.92-4.74c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2H289.2c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-18.64-.62v-1.53c-.98 2.02-2.82 3.07-5.18 3.07-4.05 0-6.07-3.46-6.07-7.97 0-4.32 2.12-7.97 6.38-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.58v13.95c0 4.51-2.12 7.54-7.6 7.54-2.58 0-3.99-.34-5.46-.83v-2.58c1.69.55 3.44.92 5.34.92 3.83 0 5.15-2.05 5.15-4.91m-8.68-6.44c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m-16.97.03c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-14.07-8.98v8.99h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 3.53 0 5.55 2.42 5.55 6.66m-28.33 1.31c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-31.44-11.01-2.76-7.48v18.49h-2.76V5.19h4.78l4.57 11.56 1.87 5.55 1.87-5.55 4.6-11.56h4.45v20.15h-2.76V7.06l-2.36 7.27-4.45 11.01h-2.67zm-21.52-2.23c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.05 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-15.09-2.16v2.36c-.92.49-2.33.71-3.74.71-5.46 0-8-3.31-8-8 0-4.63 2.55-7.94 8-7.94 1.38 0 2.45.18 3.65.74v2.45c-.98-.46-2.02-.74-3.46-.74-3.99 0-5.61 2.51-5.61 5.49s1.66 5.49 5.67 5.49c1.56 0 2.55-.21 3.5-.55M150.12 5.95c0-1.17.77-1.84 1.84-1.84s1.84.67 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-8.23 0h-3.53L132.91 10h2.76l4.97 13.1 4.93-13.1h2.76zm-15.45-9.04v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.67-5.43 3.93m-12.47-4.21c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-15.33-4.95c0 3.5-2.08 5.86-7.08 5.86-3.89 0-5.7-.77-7.27-1.56v-2.82c1.87.98 4.75 1.69 7.42 1.69 3.04 0 4.17-1.2 4.17-2.97 0-1.78-1.1-2.73-4.94-3.65-4.54-1.1-6.56-2.67-6.56-5.98 0-3.13 2.39-5.46 7.08-5.46 2.91 0 4.78.71 6.16 1.47v2.76c-2.02-1.16-4.2-1.53-6.29-1.53-2.64 0-4.2.92-4.2 2.76 0 1.66 1.29 2.48 4.84 3.37 4.26 1.07 6.66 2.45 6.66 6.07m-33.99-2.12c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.98 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-17.79-9.04v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.67-5.43 3.93M52.22 5.95c0-1.17.77-1.84 1.84-1.84s1.84.67 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-6.42-5.95V5.19h2.76V19.2c0 3.71-1.63 6.26-5.43 6.26-1.44 0-2.55-.25-3.31-.52v-2.67c.83.34 1.84.52 2.85.52 2.33 0 3.13-1.41 3.13-3.4\"/>\n    <path fill=\"var(--tile-color,#ffc716)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M18.268 13.604h5.951c.894 0 1.199.85.654 1.526l-9.308 11.487c-3.008-2.397-2.725-6.19-.523-8.959zm-4.6 4.577h-5.95c-.894 0-1.2-.85-.655-1.526l9.308-11.488c3.009 2.398 2.682 6.148.502 8.938z\"/>\n</svg>\n";
function $4db70b2e6f76ba0c$export$de148263c75d2bc1(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Jira Service Management' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $e5724170be447320$export$f827d3c5a9c3f644), {
        svg: $4db70b2e6f76ba0c$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::5b3684e2355c28ec62827d09d362b6cf>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
var $c24549e1d7926fb7$var$svg = "<svg height=\"100%\" viewBox=\"0 0 25 24\">\n    <path fill=\"var(--tile-color, white)\" d=\"M6.417.5h12a5.5 5.5 0 0 1 5.5 5.5v12a5.5 5.5 0 0 1-5.5 5.5h-12a5.5 5.5 0 0 1-5.5-5.5V6a5.5 5.5 0 0 1 5.5-5.5\"/>\n    <path fill=\"none\" stroke=\"var(--border-color, #dddee1)\" d=\"M6.417.5h12a5.5 5.5 0 0 1 5.5 5.5v12a5.5 5.5 0 0 1-5.5 5.5h-12a5.5 5.5 0 0 1-5.5-5.5V6a5.5 5.5 0 0 1 5.5-5.5Z\"/>\n    <path fill=\"var(--icon-color, #1868db)\" d=\"M14.117 10.203h4.464c.67 0 .899.637.49 1.144l-6.98 8.616c-2.257-1.798-2.044-4.643-.393-6.72zm-3.45 3.433H6.205c-.67 0-.899-.638-.49-1.144l6.981-8.617c2.256 1.799 2.011 4.61.376 6.704z\"/>\n</svg>\n";
function $c24549e1d7926fb7$export$65fae0eaf343f2ca(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Jira Service Management Data Center' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $05f9b20d45e480e2$export$be58b4326e23250f), {
        svg: $c24549e1d7926fb7$var$svg,
        label: label,
        type: "data-center",
        appearance: appearance,
        size: size,
        testId: testId
    });
}

/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d19396c378541211d8225aae490bcbcf>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $4e01efda4183800b$var$svg = "<svg height=\"100%\" viewBox=\"0 0 372 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M367.07 20.58c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55c-.46.12-.98.25-1.78.25-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zm-7.32-4.23v8.99h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 3.53 0 5.55 2.42 5.55 6.66m-22.92-4.27c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-26.16-7.92v8.53h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 2.61 0 4.39 1.32 5.15 3.74.86-2.36 2.91-3.74 5.46-3.74 3.43 0 5.34 2.33 5.34 6.66v8.99h-2.64v-8.52c0-3.16-1.1-4.72-3.62-4.72-2.45 0-4.14 1.63-4.14 4.72m-22.92-4.74c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2H289.2c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-18.64-.62v-1.53c-.98 2.02-2.82 3.07-5.18 3.07-4.05 0-6.07-3.46-6.07-7.97 0-4.32 2.12-7.97 6.38-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.58v13.95c0 4.51-2.12 7.54-7.6 7.54-2.58 0-3.99-.34-5.46-.83v-2.58c1.69.55 3.44.92 5.34.92 3.83 0 5.15-2.05 5.15-4.91m-8.68-6.44c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m-16.97.03c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-14.07-8.98v8.99h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 3.53 0 5.55 2.42 5.55 6.66m-28.33 1.31c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-31.44-11.01-2.76-7.48v18.49h-2.76V5.19h4.78l4.57 11.56 1.87 5.55 1.87-5.55 4.6-11.56h4.45v20.15h-2.76V7.06l-2.36 7.27-4.45 11.01h-2.67zm-21.52-2.23c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.05 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-15.09-2.16v2.36c-.92.49-2.33.71-3.74.71-5.46 0-8-3.31-8-8 0-4.63 2.55-7.94 8-7.94 1.38 0 2.45.18 3.65.74v2.45c-.98-.46-2.02-.74-3.46-.74-3.99 0-5.61 2.51-5.61 5.49s1.66 5.49 5.67 5.49c1.56 0 2.55-.21 3.5-.55M150.12 5.95c0-1.16.77-1.84 1.84-1.84s1.84.68 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-8.23 0h-3.53L132.91 10h2.76l4.97 13.1 4.93-13.1h2.76zm-15.45-9.04v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.68-5.43 3.93m-12.47-4.21c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-15.33-4.95c0 3.5-2.08 5.86-7.08 5.86-3.89 0-5.7-.77-7.27-1.56v-2.82c1.87.98 4.75 1.69 7.42 1.69 3.04 0 4.17-1.2 4.17-2.97s-1.1-2.73-4.94-3.65c-4.54-1.1-6.56-2.67-6.56-5.98 0-3.13 2.39-5.46 7.08-5.46 2.91 0 4.78.71 6.16 1.47v2.76c-2.02-1.17-4.2-1.53-6.29-1.53-2.64 0-4.2.92-4.2 2.76 0 1.66 1.29 2.48 4.84 3.37 4.26 1.07 6.66 2.45 6.66 6.07m-33.99-2.12c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-17.79-9.04v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.68-5.43 3.93M52.22 5.95c0-1.16.77-1.84 1.84-1.84s1.84.68 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-6.42-5.95V5.19h2.76V19.2c0 3.71-1.63 6.26-5.43 6.26-1.44 0-2.55-.24-3.31-.52v-2.67c.83.34 1.84.52 2.85.52 2.33 0 3.13-1.41 3.13-3.4\"/>\n    <path fill=\"var(--tile-color, white)\" d=\"M8 .667h16A7.333 7.333 0 0 1 31.333 8v16A7.333 7.333 0 0 1 24 31.333H8A7.333 7.333 0 0 1 .667 24V8A7.333 7.333 0 0 1 8 .667\"/>\n    <path fill=\"none\" stroke=\"var(--border-color, #dddee1)\" stroke-width=\"1.333\" d=\"M8 .667h16A7.333 7.333 0 0 1 31.333 8v16A7.333 7.333 0 0 1 24 31.333H8A7.333 7.333 0 0 1 .667 24V8A7.333 7.333 0 0 1 8 .667Z\"/>\n    <path fill=\"var(--icon-color, #1868db)\" d=\"M18.268 13.604h5.95c.895 0 1.2.85.655 1.526l-9.308 11.487c-3.008-2.397-2.725-6.19-.524-8.959zm-4.6 4.577h-5.95c-.895 0-1.2-.85-.655-1.526l9.308-11.488c3.009 2.398 2.682 6.148.502 8.938z\"/>\n</svg>\n";
function $4e01efda4183800b$export$f64bc7a7f04428d0(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Jira Service Management Data Center' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $e5724170be447320$export$f827d3c5a9c3f644), {
        svg: $4e01efda4183800b$var$svg,
        label: label,
        type: "data-center",
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::568f663154fd35333110385dd0c22e41>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
var $77de63f0b90e2204$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#1868db)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, white)\" d=\"M19.083 11.212h-4.142l3.588-2.071-.788-1.365-3.588 2.071 2.07-3.587-1.364-.788-2.071 3.587V4.917h-1.576v4.142L9.141 5.472l-1.365.787 2.071 3.588L6.26 7.776 5.472 9.14l3.587 2.07H4.917v1.577h4.142l-3.587 2.071.788 1.365 3.587-2.07-2.071 3.587 1.365.787 2.07-3.587v4.142h1.577V14.94l2.07 3.587 1.365-.787-2.07-3.588 3.587 2.071.788-1.365-3.587-2.07h4.142zM12 14.143a2.151 2.151 0 1 1 0-4.302 2.151 2.151 0 0 1 0 4.302\"/>\n</svg>\n";
function $77de63f0b90e2204$export$8d789f76fde3e05(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Loom' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $05f9b20d45e480e2$export$be58b4326e23250f), {
        svg: $77de63f0b90e2204$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2d69248f39a87c063a78e83a58b63bd7>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $abb4c183d82eabca$var$svg = "<svg height=\"100%\" viewBox=\"0 0 103 32\">\n    <path fill=\"var(--tile-color,#1868db)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, white)\" d=\"M25.375 15.31H19.99l4.664-2.693-1.024-1.775-4.664 2.693 2.692-4.663-1.775-1.025-2.692 4.663V7.125h-2.048v5.386l-2.694-4.664-1.774 1.024 2.693 4.664-4.664-2.693-1.024 1.774 4.664 2.693H6.959v2.049h5.384L7.68 20.05l1.024 1.774 4.663-2.692-2.692 4.664 1.774 1.024 2.693-4.664v5.385h2.049v-5.385l2.692 4.664 1.774-1.024-2.692-4.665 4.663 2.693 1.025-1.774-4.664-2.693h5.385zm-9.208 3.81a2.797 2.797 0 1 1 0-5.593 2.797 2.797 0 0 1 0 5.593\"/>\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M42.67 25.34V3.93h3.93v21.41zm37.7-14.55h3.75v1.78c.8-1.42 2.66-2.19 4.26-2.19 1.98 0 3.58.86 4.32 2.43 1.15-1.77 2.69-2.42 4.61-2.42 2.69 0 5.26 1.63 5.26 5.53v9.43h-3.81v-8.63c0-1.57-.77-2.75-2.57-2.75-1.68 0-2.69 1.3-2.69 2.87v8.52h-3.9v-8.63c0-1.57-.8-2.75-2.57-2.75-1.71 0-2.72 1.27-2.72 2.87v8.52h-3.93zM55.48 25.77c-4.43 0-7.63-3.28-7.63-7.7 0-4.34 3.2-7.7 7.64-7.7 4.46 0 7.63 3.39 7.63 7.7 0 4.38-3.21 7.7-7.63 7.7m0-11.84a4.15 4.15 0 0 0-4.14 4.14 4.15 4.15 0 0 0 4.14 4.14 4.15 4.15 0 0 0 4.14-4.14 4.15 4.15 0 0 0-4.14-4.14m16.02 11.84c-4.43 0-7.63-3.28-7.63-7.7 0-4.34 3.2-7.7 7.63-7.7 4.46 0 7.64 3.39 7.64 7.7 0 4.38-3.21 7.7-7.63 7.7m0-11.89c-2.31 0-4.19 1.88-4.19 4.19s1.88 4.19 4.19 4.19 4.19-1.88 4.19-4.19-1.88-4.19-4.19-4.19\"/>\n</svg>\n";
function $abb4c183d82eabca$export$78c0b4d8be34c9b2(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Loom' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $e5724170be447320$export$f827d3c5a9c3f644), {
        svg: $abb4c183d82eabca$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::9f5d94b0d7bf822b6ab4c2ad26c21970>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $7b6b7e76773b7419$var$svg = "<svg height=\"100%\" viewBox=\"0 0 100 32\">\n    <path fill=\"var(--icon-color, #101214)\" d=\"M66.71 5.11c0 1.08.49 1.93 2.47 2.31 1.16.26 1.41.44 1.41.82 0 .39-.26.62-1.08.62-.95 0-2.08-.33-2.83-.77v1.75c.59.28 1.36.62 2.83.62 2.06 0 2.85-.92 2.85-2.26m0 .03c0-1.28-.67-1.88-2.59-2.29-1.05-.23-1.31-.46-1.31-.8 0-.41.39-.59 1.08-.59.85 0 1.67.26 2.47.62V3.5c-.56-.28-1.41-.49-2.41-.49-1.9 0-2.88.82-2.88 2.16m26.29-2.11v7.32h1.57V4.81l.64 1.46 2.21 4.11h1.95V3.06h-1.54v4.73l-.59-1.39-1.77-3.34zm-9.91 0h-1.7v7.32h1.7zM79.45 8.2c0-1.28-.67-1.88-2.59-2.29-1.05-.23-1.31-.46-1.31-.8 0-.41.39-.59 1.08-.59.85 0 1.67.26 2.47.62V3.47c-.56-.28-1.41-.49-2.41-.49-1.9 0-2.88.82-2.88 2.16 0 1.08.49 1.93 2.47 2.31 1.16.26 1.41.44 1.41.82s-.26.62-1.08.62c-.95 0-2.08-.33-2.83-.77v1.75c.59.28 1.36.62 2.83.62 2.03 0 2.85-.92 2.85-2.29M53.5 3.06v7.32h3.49l.54-1.59h-2.34V3.06zm-6.91 0v1.57h1.88v5.75h1.72V4.63h2.03V3.06zm-2.49 0h-2.24l-2.54 7.32h1.95l.36-1.23c.44.13.9.21 1.36.21s.93-.08 1.36-.21l.36 1.23h1.95c-.03 0-2.57-7.32-2.57-7.32m-1.13 4.75c-.33 0-.64-.05-.93-.13l.93-3.19.93 3.19c-.28.08-.59.13-.92.13m20.06-4.75H60.8l-2.57 7.32h1.95l.36-1.23c.44.13.9.21 1.36.21s.93-.08 1.36-.21l.36 1.23h1.95zM61.9 7.81c-.33 0-.64-.05-.92-.13l.93-3.19.93 3.19c-.28.08-.59.13-.92.13m27.32-4.75h-2.23l-2.54 7.32h1.95l.36-1.23c.44.13.9.21 1.36.21s.93-.08 1.36-.21l.36 1.23h1.95zm-1.11 4.75c-.33 0-.64-.05-.92-.13l.93-3.19.93 3.19a3.7 3.7 0 0 1-.92.13\"/>\n    <path fill=\"var(--tile-color,#1868db)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, white)\" d=\"M25.375 15.31H19.99l4.664-2.693-1.024-1.775-4.664 2.693 2.692-4.664-1.775-1.025-2.692 4.664V7.125h-2.048v5.385l-2.694-4.664-1.774 1.025 2.693 4.663-4.664-2.692-1.024 1.774 4.664 2.693H6.958v2.048h5.385L7.68 20.05l1.024 1.775 4.663-2.693-2.692 4.664 1.774 1.024 2.693-4.664v5.386h2.049v-5.385l2.692 4.663 1.774-1.024-2.692-4.664 4.663 2.693 1.025-1.775-4.664-2.692h5.385zm-9.208 3.81a2.797 2.797 0 1 1 0-5.594 2.797 2.797 0 0 1 0 5.593\"/>\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M39.32 27.74v-13.7h2.52v13.7zm24.13-9.31h2.4v1.14c.51-.91 1.7-1.4 2.72-1.4 1.27 0 2.29.55 2.76 1.55.74-1.14 1.72-1.55 2.95-1.55 1.72 0 3.37 1.04 3.37 3.54v6.04h-2.44v-5.53c0-1-.49-1.76-1.65-1.76-1.08 0-1.72.83-1.72 1.84v5.45h-2.49v-5.53c0-1-.51-1.76-1.65-1.76-1.1 0-1.74.81-1.74 1.84v5.45h-2.52zm-15.93 9.58c-2.83 0-4.89-2.1-4.89-4.93 0-2.78 2.05-4.93 4.89-4.93 2.85 0 4.89 2.17 4.89 4.93 0 2.8-2.05 4.93-4.89 4.93m0-7.58a2.65 2.65 0 0 0-2.65 2.65 2.65 2.65 0 0 0 2.65 2.65c1.46 0 2.65-1.19 2.65-2.65a2.65 2.65 0 0 0-2.65-2.65m10.26 7.58c-2.83 0-4.89-2.1-4.89-4.93 0-2.78 2.05-4.93 4.89-4.93 2.85 0 4.89 2.17 4.89 4.93 0 2.8-2.06 4.93-4.89 4.93m0-7.61a2.69 2.69 0 0 0-2.68 2.68 2.69 2.69 0 0 0 2.68 2.68 2.69 2.69 0 0 0 2.68-2.68 2.69 2.69 0 0 0-2.68-2.68\"/>\n</svg>\n";
function $7b6b7e76773b7419$export$68d7391318cdef11(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Loom Attribution' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $e5724170be447320$export$f827d3c5a9c3f644), {
        svg: $7b6b7e76773b7419$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::45c3b4b2f73587dee325566fc7978684>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
var $3977e5b1edd67333$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#625df5)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, white)\" d=\"M19.083 11.212h-4.142l3.588-2.071-.788-1.365-3.588 2.071 2.07-3.587-1.364-.788-2.071 3.587V4.917h-1.576v4.142L9.141 5.472l-1.365.787 2.071 3.588L6.26 7.776 5.472 9.14l3.587 2.07H4.917v1.577h4.142l-3.587 2.071.788 1.365 3.587-2.07-2.071 3.587 1.365.787 2.07-3.587v4.142h1.577V14.94l2.07 3.587 1.365-.787-2.07-3.588 3.587 2.071.788-1.365-3.587-2.07h4.142zM12 14.143a2.151 2.151 0 1 1 0-4.302 2.151 2.151 0 0 1 0 4.302\"/>\n</svg>\n";
function $3977e5b1edd67333$export$38c7b37a3e5e8d70(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Loom' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $05f9b20d45e480e2$export$be58b4326e23250f), {
        svg: $3977e5b1edd67333$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7f4fa46a3d520008396bf538a250ebef>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $04e5c7b99b518b6e$var$svg = "<svg height=\"100%\" viewBox=\"0 0 103 32\">\n    <path fill=\"var(--tile-color,#625df5)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, white)\" d=\"M25.375 15.31H19.99l4.664-2.693-1.024-1.775-4.664 2.693 2.692-4.663-1.775-1.025-2.692 4.663V7.125h-2.048v5.386l-2.694-4.664-1.774 1.024 2.693 4.664-4.664-2.693-1.024 1.774 4.664 2.693H6.959v2.049h5.384L7.68 20.05l1.024 1.774 4.663-2.692-2.692 4.664 1.774 1.024 2.693-4.664v5.385h2.049v-5.385l2.692 4.664 1.774-1.024-2.692-4.665 4.663 2.693 1.025-1.774-4.664-2.693h5.385zm-9.208 3.81a2.797 2.797 0 1 1 0-5.593 2.797 2.797 0 0 1 0 5.593\"/>\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M42.67 25.34V3.93h3.93v21.41zm37.7-14.55h3.75v1.78c.8-1.42 2.66-2.19 4.26-2.19 1.98 0 3.58.86 4.32 2.43 1.15-1.77 2.69-2.42 4.61-2.42 2.69 0 5.26 1.63 5.26 5.53v9.43h-3.81v-8.63c0-1.57-.77-2.75-2.57-2.75-1.68 0-2.69 1.3-2.69 2.87v8.52h-3.9v-8.63c0-1.57-.8-2.75-2.57-2.75-1.71 0-2.72 1.27-2.72 2.87v8.52h-3.93zM55.48 25.77c-4.43 0-7.63-3.28-7.63-7.7 0-4.34 3.2-7.7 7.64-7.7 4.46 0 7.63 3.39 7.63 7.7 0 4.38-3.21 7.7-7.63 7.7m0-11.84a4.15 4.15 0 0 0-4.14 4.14 4.15 4.15 0 0 0 4.14 4.14 4.15 4.15 0 0 0 4.14-4.14 4.15 4.15 0 0 0-4.14-4.14m16.02 11.84c-4.43 0-7.63-3.28-7.63-7.7 0-4.34 3.2-7.7 7.63-7.7 4.46 0 7.64 3.39 7.64 7.7 0 4.38-3.21 7.7-7.63 7.7m0-11.89c-2.31 0-4.19 1.88-4.19 4.19s1.88 4.19 4.19 4.19 4.19-1.88 4.19-4.19-1.88-4.19-4.19-4.19\"/>\n</svg>\n";
function $04e5c7b99b518b6e$export$71743a944cb62e48(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Loom' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $e5724170be447320$export$f827d3c5a9c3f644), {
        svg: $04e5c7b99b518b6e$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2bf4732a418598faff0fcffc57f4a7b7>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
var $ef3200acd4dd189e$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#ffc716)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M12.696 19.45c-.49.361-.749.336-1.24-.026-2.375-1.704-4.57-3.641-6.042-5.655-.155-.207-.078-.49.155-.62l2.685-1.678q.35-.233.62.077c1.033 1.188 2.04 2.35 3.202 3.176 1.162-.826 2.17-1.988 3.202-3.176q.272-.31.62-.078l2.686 1.679c.232.13.31.413.155.62-1.472 2.014-3.667 3.95-6.043 5.68m-.62-7.411c2.118 0 3.874-1.73 3.874-3.848s-1.756-3.9-3.874-3.9c-2.117 0-3.873 1.757-3.873 3.9s1.704 3.848 3.873 3.848\"/>\n</svg>\n";
function $ef3200acd4dd189e$export$eeccc49dc7a12d9f(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Opsgenie' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $05f9b20d45e480e2$export$be58b4326e23250f), {
        svg: $ef3200acd4dd189e$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::032f8fa95ed51413adb506dd076fd343>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $7312026661045ee4$var$svg = "<svg height=\"100%\" viewBox=\"0 0 164 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M156.69 12.09c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.67-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zM143.39 5.95c0-1.16.77-1.84 1.84-1.84s1.84.68 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-3.68-8.98v8.99h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.51c.98-1.81 2.79-2.82 4.85-2.82 3.53 0 5.55 2.42 5.55 6.66m-22.92-4.26c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.67-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-18.64-.62v-1.53c-.98 2.02-2.82 3.07-5.18 3.07-4.05 0-6.07-3.47-6.07-7.97 0-4.32 2.12-7.97 6.38-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.58v13.95c0 4.51-2.12 7.54-7.6 7.54-2.58 0-3.99-.34-5.46-.83v-2.58c1.69.55 3.44.92 5.34.92 3.83 0 5.15-2.06 5.15-4.91m-8.68-6.44c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m-4.72 3.52c0 2.55-1.66 4.48-5.76 4.48-2.3 0-4.17-.52-5.34-1.13v-2.79c1.32.77 3.53 1.5 5.46 1.5 2.02 0 3.07-.83 3.07-2.02 0-1.17-.89-1.84-3.8-2.55-3.4-.83-4.85-2.15-4.85-4.66 0-2.67 2.06-4.29 5.55-4.29 1.99 0 3.8.49 4.94 1.1v2.73c-1.84-.92-3.34-1.41-4.97-1.41-1.93 0-2.97.67-2.97 1.87 0 1.07.74 1.75 3.56 2.42 3.4.83 5.12 2.09 5.12 4.75m-16.29-3.49c0-3.68-1.47-5.52-4.2-5.52-2.36 0-4.48 1.5-4.48 4.91v1.23c0 3.4 1.93 4.91 4.17 4.91 2.98 0 4.51-1.96 4.51-5.52m-3.8 7.97c-2.24 0-3.96-1.01-4.88-3.01v8.68h-2.64V10h2.64v2.76c.98-2.02 2.82-3.07 5.18-3.07 4.08 0 6.13 3.47 6.13 7.97 0 4.32-2.15 7.97-6.44 7.97m-20.11.01c-6.22 0-9.72-4.29-9.72-10.43 0-6.07 3.5-10.33 9.72-10.33 6.2 0 9.69 4.26 9.69 10.34 0 6.13-3.5 10.43-9.69 10.43m0-18.12c-4.97 0-6.96 3.53-6.96 7.7 0 4.26 1.99 7.79 6.96 7.79 4.94 0 6.93-3.53 6.93-7.79 0-4.17-1.99-7.7-6.93-7.7\"/>\n    <path fill=\"var(--tile-color,#ffc716)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M16.905 25.684c-.638.47-.974.437-1.612-.033-3.088-2.216-5.942-4.734-7.855-7.352-.202-.269-.1-.638.201-.806l3.491-2.182q.454-.302.806.1c1.343 1.545 2.652 3.056 4.163 4.13 1.51-1.074 2.82-2.585 4.163-4.13q.352-.402.805-.1l3.491 2.182c.303.168.403.537.202.806-1.914 2.618-4.767 5.136-7.855 7.385m-.806-9.635c2.753 0 5.035-2.249 5.035-5.001s-2.282-5.07-5.035-5.07-5.036 2.283-5.036 5.07c0 2.786 2.216 5.001 5.036 5.001\"/>\n</svg>\n";
function $7312026661045ee4$export$a5b9122e89b32ad3(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Opsgenie' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $e5724170be447320$export$f827d3c5a9c3f644), {
        svg: $7312026661045ee4$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6bab74cd77291828d528d124967c3552>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
var $ee859ead2c997d6c$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" fill-rule=\"evenodd\" d=\"m5.106 14.44 1.856-1.856-1.856-1.856L6.653 9.18h3.712l2.784-2.784h4.332v4.33l-2.785 2.785v3.712L13.15 18.77l-1.857-1.856-1.856 1.856-1.7-1.7 2.784-2.784-.928-.928-2.784 2.784zm10.209-4.331a1.094 1.094 0 1 1-1.547-1.546 1.094 1.094 0 0 1 1.547 1.546\" clip-rule=\"evenodd\"/>\n</svg>\n";
function $ee859ead2c997d6c$export$5ed3e1bb3b04fc02(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Projects' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $05f9b20d45e480e2$export$be58b4326e23250f), {
        svg: $ee859ead2c997d6c$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::820b1edb3bac4a2b82da6f532724cb11>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $d49a05cc2e75a98d$var$svg = "<svg height=\"100%\" viewBox=\"0 0 145 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M144.54 21.16c0 2.55-1.66 4.48-5.77 4.48-2.3 0-4.17-.52-5.34-1.13v-2.79c1.32.77 3.53 1.5 5.46 1.5 2.02 0 3.07-.83 3.07-2.02 0-1.17-.89-1.84-3.8-2.55-3.4-.83-4.84-2.15-4.84-4.66 0-2.67 2.05-4.29 5.55-4.29 1.99 0 3.8.49 4.94 1.1v2.73c-1.84-.92-3.34-1.41-4.97-1.41-1.93 0-2.97.67-2.97 1.87 0 1.07.74 1.75 3.56 2.42 3.4.83 5.12 2.09 5.12 4.75m-17.75-.58c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55c-.46.12-.98.25-1.78.25-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zm-6.66 1.99v2.36c-.92.49-2.33.71-3.74.71-5.46 0-8-3.31-8-8 0-4.63 2.55-7.94 8-7.94 1.38 0 2.45.18 3.65.74v2.45c-.98-.46-2.02-.74-3.47-.74-3.99 0-5.61 2.52-5.61 5.49s1.66 5.49 5.67 5.49c1.56 0 2.55-.21 3.5-.55M99.43 12.09c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.67-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.2c.37 2.61 2.05 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zM83.8 31.25v-2.36c.31.03.49.03.77.03 1.13 0 2.05-.49 2.05-1.87V10h2.64v17.36c0 2.82-1.59 4.02-4.11 4.02-.67 0-1.13-.06-1.35-.12m2.3-25.3c0-1.16.77-1.84 1.84-1.84s1.84.68 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84M76.07 25.64c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49M62.3 16.29v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.67-5.43 3.93m-5-4.4c0 4.39-2.45 6.84-7.48 6.84H45.8v6.59h-2.76V5.19h6.78c5.03 0 7.48 2.58 7.48 6.72m-7.79 4.2c3.56.12 4.94-1.56 4.94-4.14 0-2.45-1.38-4.14-4.94-4.14H45.8v8.28z\"/>\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" fill-rule=\"evenodd\" d=\"m6.152 19.486 2.651-2.652-2.651-2.651 2.21-2.21h5.303l3.977-3.977h6.187v6.187l-3.977 3.977v5.304l-2.21 2.21-2.652-2.652-2.651 2.651-2.429-2.428 3.978-3.978-1.326-1.325-3.978 3.977zM20.736 13.3a1.562 1.562 0 1 1-2.21-2.21 1.562 1.562 0 0 1 2.21 2.21\" clip-rule=\"evenodd\"/>\n</svg>\n";
function $d49a05cc2e75a98d$export$e3d1678155aaab99(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Projects' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $e5724170be447320$export$f827d3c5a9c3f644), {
        svg: $d49a05cc2e75a98d$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c09aee6cc96e54887271dd42a7eae172>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
var $70f94f8ec7b1b295$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#1868db)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, white)\" d=\"M11.057 5.257a1.57 1.57 0 0 1 1.539.015l4.621 2.668c.484.279.783.797.783 1.354v5.336a1.56 1.56 0 0 1-.782 1.355l-3.474 2.005a2 2 0 0 0 .12-.691v-5.337c0-.733-.39-1.409-1.026-1.774l-2.59-1.495V6.626q.001-.246.074-.473c.117-.364.366-.68.707-.877z\"/>\n    <path fill=\"var(--icon-color, white)\" d=\"M9.881 5.94 6.408 7.945A1.56 1.56 0 0 0 5.625 9.3v5.337c0 .557.3 1.075.783 1.354l4.621 2.668c.475.274 1.06.279 1.539.015l.027-.019a1.57 1.57 0 0 0 .781-1.35v-2.067l-2.589-1.495a2.05 2.05 0 0 1-1.026-1.775V6.631a2 2 0 0 1 .12-.691\"/>\n</svg>\n";
function $70f94f8ec7b1b295$export$e23ae35269442b4f(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Rovo' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $05f9b20d45e480e2$export$be58b4326e23250f), {
        svg: $70f94f8ec7b1b295$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::29265478015ee48ec34dc1fd6eae4b81>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $f8f680c2b9153e80$var$svg = "<svg height=\"100%\" viewBox=\"0 0 106 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M98.36 25.64c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49M84.34 25.33h-3.53L74.87 10h2.76l4.97 13.1L87.53 10h2.76zm-17.46.31c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49M49.84 7.82h-4.05v7.36h4.05c3.59 0 4.69-1.38 4.69-3.68 0-2.18-1.13-3.68-4.69-3.68m7.45 3.62c0 3.04-1.29 5.09-3.96 5.95l4.94 7.94h-3.25l-4.44-7.51H45.8v7.51h-2.76V5.19h7.12c4.81 0 7.15 2.39 7.15 6.26\"/>\n    <path fill=\"var(--tile-color,#1868db)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, white)\" d=\"M15.013 6.281a2.26 2.26 0 0 1 2.222.021l6.674 3.854a2.26 2.26 0 0 1 1.131 1.956v7.707c0 .809-.43 1.553-1.13 1.956l-5.018 2.896q.017-.046.032-.093c.093-.289.142-.594.142-.906v-7.707a2.95 2.95 0 0 0-1.481-2.563l-3.74-2.158V8.258c0-.235.036-.465.105-.682.17-.527.529-.983 1.021-1.267h.002z\"/>\n    <path fill=\"var(--icon-color, white)\" d=\"m13.314 7.267-5.017 2.896a2.25 2.25 0 0 0-1.13 1.956v7.707c0 .806.432 1.553 1.13 1.956l6.675 3.854c.686.396 1.53.403 2.222.02l.04-.026c.493-.284.853-.74 1.023-1.267a2.3 2.3 0 0 0 .105-.683v-2.986l-3.74-2.158a2.96 2.96 0 0 1-1.482-2.563V8.266a3 3 0 0 1 .174-1\"/>\n</svg>\n";
function $f8f680c2b9153e80$export$b0e15f0a1c9f4c55(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Rovo' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $e5724170be447320$export$f827d3c5a9c3f644), {
        svg: $f8f680c2b9153e80$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::0424c604e8fb1e51fac762a4e1efa562>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
var $aede3667eebcd473$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#94c748)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M11.26 4.71a1.7 1.7 0 0 1 1.666.017l5.006 2.89c.524.302.848.863.848 1.467v5.78a1.69 1.69 0 0 1-.848 1.467l-3.763 2.172.024-.07c.07-.216.107-.445.107-.679v-5.78c0-.794-.423-1.526-1.112-1.922l-2.805-1.62V6.195q.001-.267.08-.512c.126-.395.396-.737.765-.95l.002-.001z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M9.986 5.45 6.223 7.623a1.69 1.69 0 0 0-.848 1.466v5.78c0 .605.324 1.166.848 1.468l5.006 2.89a1.7 1.7 0 0 0 1.666.016l.03-.02c.37-.214.64-.556.768-.95q.078-.247.079-.513v-2.24l-2.805-1.618a2.22 2.22 0 0 1-1.112-1.922V6.2a2.2 2.2 0 0 1 .13-.75\"/>\n</svg>\n";
function $aede3667eebcd473$export$8b784b3227531b3e(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Rovo Dev' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $05f9b20d45e480e2$export$be58b4326e23250f), {
        svg: $aede3667eebcd473$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e0f280d200b0e27835aec655dfa5a41e>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $1738a389ff1a4b17$var$svg = "<svg height=\"100%\" viewBox=\"0 0 165 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M158.79 25.33h-3.53L149.32 10h2.76l4.97 13.1 4.93-13.1h2.76zm-17.64-13.24c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.05 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zM121.91 7.82h-4.54v14.87h4.69c4.6 0 6.9-2.42 6.9-7.3 0-4.91-2.18-7.57-7.05-7.57m-7.3 17.51V5.19h7.42c6.53 0 9.69 4.08 9.69 10.12 0 6.1-3.19 10.03-9.69 10.03zm-16.26.31c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49M84.34 25.33h-3.53L74.86 10h2.76l4.97 13.1L87.53 10h2.76zm-17.46.31c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49M49.84 7.82h-4.05v7.36h4.05c3.59 0 4.69-1.38 4.69-3.68 0-2.18-1.13-3.68-4.69-3.68m7.45 3.62c0 3.04-1.29 5.09-3.96 5.95l4.94 7.94h-3.25l-4.44-7.51H45.8v7.51h-2.76V5.19h7.12c4.81 0 7.15 2.39 7.15 6.26\"/>\n    <path fill=\"var(--tile-color,#94c748)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M15.013 6.281a2.26 2.26 0 0 1 2.222.021l6.674 3.854a2.26 2.26 0 0 1 1.131 1.956v7.707c0 .809-.43 1.553-1.13 1.956l-5.018 2.896.032-.093c.093-.289.142-.594.142-.906v-7.707a2.95 2.95 0 0 0-1.481-2.563l-3.74-2.158V8.258c0-.235.036-.465.105-.682a2.26 2.26 0 0 1 1.021-1.267h.002z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"m13.314 7.267-5.017 2.896a2.25 2.25 0 0 0-1.13 1.956v7.707c0 .806.432 1.553 1.13 1.956l6.675 3.854c.686.396 1.53.403 2.222.02l.04-.026c.493-.284.853-.74 1.023-1.267a2.3 2.3 0 0 0 .105-.683v-2.986l-3.74-2.158a2.96 2.96 0 0 1-1.482-2.563V8.266a3 3 0 0 1 .174-1\"/>\n</svg>\n";
function $1738a389ff1a4b17$export$4145bd793c9ed1d0(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Rovo Dev' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $e5724170be447320$export$f827d3c5a9c3f644), {
        svg: $1738a389ff1a4b17$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c56e9a05bb3a4c70bfd4cbcb5fa54ba2>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
var $967b8b902cad02df$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#94c748)\" d=\"M10.7.368a2.75 2.75 0 0 1 2.748 0l8.016 4.626a2.75 2.75 0 0 1 1.375 2.38v9.252c0 .982-.524 1.889-1.375 2.38l-8.016 4.626a2.75 2.75 0 0 1-2.749 0l-8.016-4.626a2.75 2.75 0 0 1-1.374-2.38V7.374c0-.982.524-1.889 1.374-2.38z\"/>\n    <path fill=\"var(--icon-color, #101214)\" fill-rule=\"evenodd\" d=\"M10.181 6.096 6.777 8.06a1.53 1.53 0 0 0-.768 1.327v5.229c0 .547.294 1.054.768 1.327l.807.466 3.722 2.149a1.54 1.54 0 0 0 1.508.014l.027-.018a1.54 1.54 0 0 0 .766-1.323v-2.026l-1.97-1.137-.568-.327a2 2 0 0 1-1.006-1.74V6.775a2 2 0 0 1 .118-.678\" clip-rule=\"evenodd\"/>\n    <path fill=\"var(--icon-color, #101214)\" fill-rule=\"evenodd\" d=\"M12.842 5.441a1.54 1.54 0 0 0-1.508-.014l-.028.019a1.54 1.54 0 0 0-.765 1.323v2.025l1.91 1.102.628.362a2 2 0 0 1 1.006 1.74v5.228a2 2 0 0 1-.118.678l3.404-1.965c.476-.273.767-.778.767-1.327V9.383c0-.546-.293-1.054-.767-1.327l-.868-.501z\" clip-rule=\"evenodd\"/>\n</svg>\n";
function $967b8b902cad02df$export$813cff80931d9dbf(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Rovo Dev Agent' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $05f9b20d45e480e2$export$be58b4326e23250f), {
        svg: $967b8b902cad02df$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ca2d332c134816706ee434029a355d3c>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $4b1bd776417e729e$var$svg = "<svg height=\"100%\" viewBox=\"0 0 160 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M153.94 25.67h-3.53l-5.95-15.33h2.76l4.97 13.1 4.94-13.09h2.76zM136.3 12.42c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.67-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.2c.37 2.61 2.05 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-25.13-16.9h-4.54v14.87h4.69c4.6 0 6.9-2.42 6.9-7.3 0-4.91-2.18-7.57-7.05-7.57m-7.3 17.51V5.52h7.42c6.53 0 9.69 4.08 9.69 10.12 0 6.1-3.19 10.03-9.69 10.03zm-16.25.31c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49M79.49 25.67h-3.53l-5.95-15.33h2.76l4.97 13.1 4.94-13.09h2.76zm-17.46.31c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49M45 8.16h-4.05v7.36H45c3.59 0 4.69-1.38 4.69-3.68 0-2.18-1.13-3.68-4.69-3.68m7.45 3.62c0 3.04-1.29 5.09-3.96 5.95l4.94 7.94h-3.25l-4.45-7.51h-4.78v7.51h-2.76V5.52h7.11c4.82 0 7.15 2.39 7.15 6.26\"/>\n    <path fill=\"var(--tile-color,#94c748)\" d=\"M12.52.49a3.67 3.67 0 0 1 3.666 0l10.688 6.17a3.66 3.66 0 0 1 1.833 3.173v12.336a3.66 3.66 0 0 1-1.833 3.173L16.186 31.51a3.67 3.67 0 0 1-3.665 0L1.833 25.341A3.66 3.66 0 0 1 0 22.168V9.832c0-1.309.7-2.519 1.833-3.173z\"/>\n    <path fill=\"var(--icon-color, #101214)\" fill-rule=\"evenodd\" d=\"m11.83 8.128-4.54 2.62a2.04 2.04 0 0 0-1.022 1.77v6.972c0 .728.39 1.405 1.023 1.77l1.076.62 4.963 2.865a2.05 2.05 0 0 0 2.01.02l.037-.025c.445-.257.771-.67.925-1.146q.094-.297.095-.619v-2.7l-2.627-1.516-.757-.436a2.67 2.67 0 0 1-1.34-2.32v-6.97a2.7 2.7 0 0 1 .157-.904\" clip-rule=\"evenodd\"/>\n    <path fill=\"var(--icon-color, #101214)\" fill-rule=\"evenodd\" d=\"M15.377 7.255a2.05 2.05 0 0 0-2.01-.019l-.038.026c-.445.257-.77.67-.924 1.145a2 2 0 0 0-.095.618v2.7l2.545 1.47.839.483a2.67 2.67 0 0 1 1.34 2.319v6.972a2.7 2.7 0 0 1-.157.903l4.54-2.62a2.04 2.04 0 0 0 1.022-1.77v-6.971c0-.729-.39-1.405-1.023-1.77l-1.157-.668z\" clip-rule=\"evenodd\"/>\n</svg>\n";
function $4b1bd776417e729e$export$58747af448450872(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Rovo Dev Agent' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $e5724170be447320$export$f827d3c5a9c3f644), {
        svg: $4b1bd776417e729e$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b1fdf93317430cb701429972e6c41dc4>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
var $2e769877b28b6c1c$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--rovo-blue-color, #1868db)\" fill-rule=\"evenodd\" d=\"m13.227 16.789-7.154 4.169-3.403-1.96a2.72 2.72 0 0 1-1.362-2.355V7.366c0-.973.518-1.87 1.361-2.354l6.044-3.487-.038.114a3.6 3.6 0 0 0-.172 1.088v9.278c0 1.274.68 2.45 1.786 3.085z\" clip-rule=\"evenodd\"/>\n    <path fill=\"var(--rovo-green-color, #6a9a23)\" fill-rule=\"evenodd\" d=\"m11.296 15.671-7.193 4.153 6.607 3.812a2.73 2.73 0 0 0 2.676.026l.048-.033a2.73 2.73 0 0 0 1.232-1.525 2.7 2.7 0 0 0 .127-.822v-3.594z\" clip-rule=\"evenodd\"/>\n    <path fill=\"var(--rovo-purple-color, #af59e1)\" fill-rule=\"evenodd\" d=\"m21.477 5.003-4.404-2.539-5.904 4.89 2.69 1.556a3.56 3.56 0 0 1 1.785 3.086v9.277a3.6 3.6 0 0 1-.21 1.202l6.044-3.486a2.71 2.71 0 0 0 1.362-2.355V7.357c0-.97-.521-1.87-1.363-2.354\" clip-rule=\"evenodd\"/>\n    <path fill=\"var(--rovo-yellow-color, #fca700)\" fill-rule=\"evenodd\" d=\"M12.74 8.266 9.353 6.312V2.718c0-.283.044-.56.127-.821A2.73 2.73 0 0 1 10.71.372V.37a.4.4 0 0 0 .048-.033 2.73 2.73 0 0 1 2.676.026l6.499 3.75z\" clip-rule=\"evenodd\"/>\n</svg>\n";
function $2e769877b28b6c1c$export$9e62346a60cfb459(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Rovo' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $05f9b20d45e480e2$export$be58b4326e23250f), {
        svg: $2e769877b28b6c1c$var$svg,
        label: label,
        type: "rovo",
        appearance: appearance,
        size: size,
        testId: testId
    });
}

/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::0e01ef8caae93929e35d346a5091c5ef>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $e0c14a4c94331bbd$var$svg = "<svg height=\"100%\" viewBox=\"0 0 102 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M93.5 25.97c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49M79.49 25.67h-3.53l-5.95-15.33h2.76l4.97 13.1 4.94-13.09h2.76zm-17.46.3c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49M44.99 8.16h-4.05v7.36h4.05c3.59 0 4.69-1.38 4.69-3.68 0-2.18-1.13-3.68-4.69-3.68m7.45 3.62c0 3.04-1.29 5.09-3.96 5.95l4.94 7.94h-3.25l-4.45-7.51h-4.78v7.51h-2.76V5.52h7.11c4.82 0 7.15 2.39 7.15 6.26\"/>\n    <path fill=\"var(--rovo-blue-color, #1868db)\" fill-rule=\"evenodd\" d=\"m15.892 22.385-9.538 5.559-4.538-2.613A3.63 3.63 0 0 1 0 22.19V9.821C0 8.524.69 7.33 1.816 6.682l8.058-4.649-.052.152a4.7 4.7 0 0 0-.228 1.452v12.37a4.74 4.74 0 0 0 2.38 4.113z\" clip-rule=\"evenodd\"/>\n    <path fill=\"var(--rovo-green-color, #6a9a23)\" fill-rule=\"evenodd\" d=\"m13.318 20.895-9.591 5.538 8.809 5.082a3.64 3.64 0 0 0 3.568.034l.065-.043a3.63 3.63 0 0 0 1.642-2.034c.11-.35.17-.718.17-1.096v-4.792z\" clip-rule=\"evenodd\"/>\n    <path fill=\"var(--rovo-purple-color, #af59e1)\" fill-rule=\"evenodd\" d=\"M26.893 6.67 21.02 3.285l-7.873 6.52 3.587 2.075a4.74 4.74 0 0 1 2.38 4.115v12.369a4.7 4.7 0 0 1-.28 1.603l8.058-4.649a3.62 3.62 0 0 0 1.816-3.139V9.81a3.63 3.63 0 0 0-1.816-3.139\" clip-rule=\"evenodd\"/>\n    <path fill=\"var(--rovo-yellow-color, #fca700)\" fill-rule=\"evenodd\" d=\"m15.244 11.022-4.519-2.606V3.625c0-.378.059-.747.17-1.096a3.63 3.63 0 0 1 1.64-2.033l.002-.001.064-.044a3.64 3.64 0 0 1 3.569.034l8.665 5z\" clip-rule=\"evenodd\"/>\n</svg>\n";
function $e0c14a4c94331bbd$export$5e38d02efdb45577(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Rovo' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $e5724170be447320$export$f827d3c5a9c3f644), {
        svg: $e0c14a4c94331bbd$var$svg,
        label: label,
        type: "rovo",
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::88ee37f21199df8c4f6de50b597bc415>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
var $e63a46d3e5ee26b0$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" fill-rule=\"evenodd\" d=\"M5 10.688a5.69 5.69 0 0 0 5.697 5.687c1.01 0 1.958-.262 2.78-.723L16.832 19 19 16.834l-3.347-3.341c.471-.828.74-1.785.74-2.806A5.69 5.69 0 0 0 10.697 5 5.69 5.69 0 0 0 5 10.688m2.191 0c0 1.932 1.57 3.5 3.506 3.5a3.503 3.503 0 0 0 3.505-3.5c0-1.933-1.57-3.5-3.505-3.5a3.503 3.503 0 0 0-3.506 3.5\" clip-rule=\"evenodd\"/>\n</svg>\n";
function $e63a46d3e5ee26b0$export$82eafebb825fc23f(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Search' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $05f9b20d45e480e2$export$be58b4326e23250f), {
        svg: $e63a46d3e5ee26b0$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4165d5d8279c6abbf1ec41290594700b>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $b400386b6118e9fc$var$svg = "<svg height=\"100%\" viewBox=\"0 0 130 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M128.82 16.35v8.99h-2.64v-8.53c0-3.16-1.1-4.72-3.62-4.72-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V3.59h2.64v8.96c1.01-1.81 2.85-2.85 5.06-2.85 3.44 0 5.34 2.33 5.34 6.66m-16.04 6.21v2.36c-.92.49-2.33.71-3.74.71-5.46 0-8-3.31-8-8 0-4.63 2.55-7.94 8-7.94 1.38 0 2.45.18 3.65.74v2.45c-.98-.46-2.02-.74-3.47-.74-3.99 0-5.61 2.51-5.61 5.49s1.66 5.49 5.67 5.49c1.56 0 2.55-.21 3.5-.55m-18.23-6.29v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.68-5.43 3.93m-17.87 1.37c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10H88v15.33zM65.08 12.09c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.2c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-15.33-4.95c0 3.5-2.08 5.86-7.08 5.86-3.89 0-5.7-.77-7.27-1.56v-2.82c1.87.98 4.75 1.69 7.42 1.69 3.04 0 4.17-1.2 4.17-2.97 0-1.78-1.1-2.73-4.94-3.65-4.54-1.1-6.56-2.67-6.56-5.98 0-3.13 2.39-5.46 7.08-5.46 2.91 0 4.78.71 6.16 1.47v2.76c-2.02-1.16-4.2-1.53-6.29-1.53-2.64 0-4.2.92-4.2 2.76 0 1.66 1.29 2.48 4.84 3.37 4.26 1.07 6.66 2.45 6.66 6.07\"/>\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" fill-rule=\"evenodd\" d=\"M7.127 14.833a7.583 7.583 0 0 0 11.286 6.62l4.464 4.464 2.887-2.888-4.455-4.455a7.583 7.583 0 1 0-14.181-3.74m2.917 0a4.667 4.667 0 1 0 9.333 0 4.667 4.667 0 0 0-9.333 0\" clip-rule=\"evenodd\"/>\n</svg>\n";
function $b400386b6118e9fc$export$fa08cbfe393f2a68(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Search' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $e5724170be447320$export$f827d3c5a9c3f644), {
        svg: $b400386b6118e9fc$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::5fb81b6548e62d67fc83daf888114f8f>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
var $7f925c2c05d86612$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 6.625a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" fill-rule=\"evenodd\" d=\"M10.76 17.176a5.791 5.791 0 1 1 5.038-2.935l3.403 3.403-2.205 2.204-3.409-3.408a5.77 5.77 0 0 1-2.827.736m-.274-9.37-.242.615c-.344.874-.516 1.312-.833 1.64-.318.33-.749.518-1.61.893l-.37.16v.51l.37.16c.861.376 1.292.563 1.61.893.317.329.49.766.833 1.64l.242.616h.51l.242-.616c.344-.874.516-1.311.834-1.64.317-.33.748-.517 1.61-.893l.368-.16v-.51l-.369-.16c-.861-.375-1.292-.563-1.61-.892-.317-.33-.489-.766-.833-1.64l-.242-.616z\" clip-rule=\"evenodd\"/>\n</svg>\n";
function $7f925c2c05d86612$export$3599582ddc9fc5cf(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Search' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $05f9b20d45e480e2$export$be58b4326e23250f), {
        svg: $7f925c2c05d86612$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::12cecbe0aa290ffe5232721f12ef458f>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $4a274402133bcfb4$var$svg = "<svg height=\"100%\" viewBox=\"0 0 130 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M128.82 16.35v8.99h-2.64v-8.52c0-3.16-1.1-4.72-3.62-4.72-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V3.59h2.64v8.96c1.01-1.81 2.85-2.85 5.06-2.85 3.44 0 5.34 2.33 5.34 6.66m-16.05 6.21v2.36c-.92.49-2.33.71-3.74.71-5.46 0-8-3.31-8-8 0-4.63 2.55-7.94 8-7.94 1.38 0 2.45.18 3.65.74v2.45c-.98-.46-2.02-.74-3.46-.74-3.99 0-5.61 2.52-5.61 5.49s1.66 5.49 5.67 5.49c1.56 0 2.55-.21 3.5-.55m-18.23-6.29v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.67-5.43 3.93m-17.87 1.37c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.47-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zM65.08 12.09c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.67-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.2c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-15.33-4.95c0 3.5-2.08 5.86-7.08 5.86-3.89 0-5.7-.77-7.27-1.56v-2.82c1.87.98 4.75 1.69 7.42 1.69 3.04 0 4.17-1.2 4.17-2.97s-1.1-2.73-4.94-3.65c-4.54-1.1-6.56-2.67-6.56-5.98 0-3.13 2.39-5.46 7.08-5.46 2.91 0 4.78.71 6.16 1.47v2.76c-2.02-1.16-4.2-1.53-6.29-1.53-2.64 0-4.2.92-4.2 2.76 0 1.66 1.29 2.48 4.85 3.37 4.26 1.07 6.66 2.45 6.66 6.07\"/>\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" fill-rule=\"evenodd\" d=\"M14.346 22.068a7.721 7.721 0 1 1 6.718-3.913l4.537 4.536-2.94 2.94-4.545-4.545a7.7 7.7 0 0 1-3.77.982m-.364-12.494-.323.82c-.459 1.167-.688 1.75-1.112 2.188-.423.44-.997.69-2.146 1.19l-.492.214v.68l.492.213c1.149.5 1.723.75 2.146 1.19.424.439.653 1.022 1.112 2.188l.323.82h.679l.323-.82c.459-1.166.688-1.75 1.111-2.188.424-.44.998-.69 2.147-1.19l.491-.214v-.679l-.491-.214c-1.149-.5-1.723-.75-2.147-1.19-.423-.438-.652-1.021-1.111-2.187l-.323-.82z\" clip-rule=\"evenodd\"/>\n</svg>\n";
function $4a274402133bcfb4$export$d669f6cbbb67e061(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Search' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $e5724170be447320$export$f827d3c5a9c3f644), {
        svg: $4a274402133bcfb4$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::37c59c3ee979ff8acaf7525e576da094>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
var $4f9732d887e085b6$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#ffc716)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M12 9.796c-1.924 0-3.796.832-5.324 2.118q-.238.227-.475.227c-.132 0-.263-.076-.369-.202L3.908 9.771c-.105-.126-.158-.252-.158-.353 0-.151.08-.277.237-.429C6.307 7.023 9.127 5.914 12 5.914s5.693 1.109 8.013 3.075c.158.152.237.278.237.429 0 .1-.053.227-.158.353l-1.924 2.168c-.106.126-.238.202-.37.202q-.236 0-.474-.227c-1.529-1.286-3.4-2.118-5.324-2.118m0 8.118c-2.135 0-3.875-1.664-3.875-3.68 0-2.018 1.74-3.682 3.875-3.682s3.875 1.64 3.875 3.681-1.74 3.68-3.875 3.68\"/>\n</svg>\n";
function $4f9732d887e085b6$export$f3f5aa321d88adf9(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Statuspage' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $05f9b20d45e480e2$export$be58b4326e23250f), {
        svg: $4f9732d887e085b6$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4e31a509778b74933bf91345a74560c5>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $535fb25abeb69827$var$svg = "<svg height=\"100%\" viewBox=\"0 0 192 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M184.96 12.09c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.05 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-18.64-.62v-1.53c-.98 2.02-2.82 3.07-5.18 3.07-4.05 0-6.07-3.46-6.07-7.97 0-4.32 2.12-7.97 6.38-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.58v13.95c0 4.51-2.12 7.54-7.61 7.54-2.58 0-3.99-.34-5.46-.83v-2.58c1.69.55 3.43.92 5.34.92 3.83 0 5.15-2.05 5.15-4.91m-8.68-6.44c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m-16.96.03c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-16.09-7.66c0-3.68-1.47-5.52-4.2-5.52-2.36 0-4.48 1.5-4.48 4.91v1.23c0 3.4 1.93 4.91 4.17 4.91 2.98 0 4.51-1.96 4.51-5.52m-3.8 7.97c-2.24 0-3.96-1.01-4.88-3v8.68h-2.64V10h2.64v2.76c.98-2.02 2.82-3.07 5.18-3.07 4.08 0 6.13 3.47 6.13 7.97 0 4.32-2.15 7.97-6.44 7.97m-10.55-4.47c0 2.55-1.66 4.48-5.77 4.48-2.3 0-4.17-.52-5.34-1.13v-2.79c1.32.77 3.53 1.5 5.46 1.5 2.02 0 3.07-.83 3.07-2.02 0-1.16-.89-1.84-3.8-2.54-3.4-.83-4.84-2.15-4.84-4.66 0-2.67 2.05-4.29 5.55-4.29 1.99 0 3.8.49 4.94 1.1v2.73c-1.84-.92-3.34-1.41-4.97-1.41-1.93 0-2.97.68-2.97 1.87 0 1.07.74 1.75 3.56 2.42 3.4.83 5.12 2.09 5.12 4.75m-27.61-2.18V10h2.64v9.26c0 2.76 1.1 3.99 3.62 3.99 2.45 0 4.14-1.62 4.14-4.72V10h2.64v15.33h-2.64v-2.51c-.98 1.81-2.79 2.82-4.84 2.82-3.53 0-5.55-2.42-5.55-6.65m-7.16 1.59c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55c-.46.12-.98.25-1.78.25-3.28 0-4.88-1.93-4.88-4.78v-8.19H85V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zm-18.95-2.91c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-17.26-4.75c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55c-.46.12-.98.25-1.78.25-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zm-6.89-.8c0 3.5-2.08 5.86-7.08 5.86-3.89 0-5.7-.77-7.27-1.56v-2.82c1.87.98 4.75 1.69 7.42 1.69 3.04 0 4.17-1.2 4.17-2.97s-1.1-2.73-4.94-3.65c-4.54-1.1-6.56-2.67-6.56-5.98 0-3.13 2.39-5.46 7.08-5.46 2.91 0 4.78.71 6.16 1.47v2.76c-2.02-1.16-4.2-1.53-6.29-1.53-2.64 0-4.2.92-4.2 2.76 0 1.66 1.29 2.48 4.84 3.37 4.26 1.07 6.66 2.45 6.66 6.07\"/>\n    <path fill=\"var(--tile-color,#ffc716)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M15.896 13.196c-2.464 0-4.86 1.114-6.817 2.835q-.303.304-.607.304c-.169 0-.338-.102-.473-.27l-2.463-2.902c-.135-.17-.202-.338-.202-.473 0-.202.1-.371.303-.573C8.607 9.484 12.217 8 15.896 8c3.678 0 7.29 1.484 10.259 4.117.202.202.303.37.303.573 0 .135-.067.304-.202.473l-2.463 2.902c-.135.168-.304.27-.473.27q-.303 0-.607-.304c-1.958-1.721-4.353-2.835-6.817-2.835m0 10.867c-2.733 0-4.96-2.228-4.96-4.927 0-2.7 2.227-4.927 4.96-4.927s4.96 2.193 4.96 4.927-2.227 4.927-4.96 4.927\"/>\n</svg>\n";
function $535fb25abeb69827$export$2bc88a281410ffa7(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Statuspage' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $e5724170be447320$export$f827d3c5a9c3f644), {
        svg: $535fb25abeb69827$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2be4b98bf6f70e39467c5c4d0f75c6d5>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
var $71c085540a543398$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M10.7 11.222V19h7.8v-7.778z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M14.6 7.609 10.05 5 5.5 7.609v5.217l3.64 2.087V9.667h5.46z\"/>\n</svg>\n";
function $71c085540a543398$export$290a0f24614cde9f(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Studio' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $05f9b20d45e480e2$export$be58b4326e23250f), {
        svg: $71c085540a543398$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a96e3d2d2d3910fdbea7d20bda091bd2>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $dd6e7f6bc9a5125a$var$svg = "<svg height=\"100%\" viewBox=\"0 0 124 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M116.71 25.64c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49m-13.48-6.2c0-1.16.77-1.84 1.84-1.84s1.84.68 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-15.3-7.66c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V3.59h2.64v21.74zm-27.41-6.34V10h2.64v9.26c0 2.76 1.1 3.99 3.62 3.99 2.45 0 4.14-1.62 4.14-4.72V10h2.64v15.33h-2.64v-2.51c-.98 1.81-2.79 2.82-4.84 2.82-3.53 0-5.55-2.42-5.55-6.65m-7.17 1.59c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55c-.46.12-.98.25-1.78.25-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zm-6.89-.8c0 3.5-2.08 5.86-7.08 5.86-3.89 0-5.7-.77-7.27-1.56v-2.82c1.87.98 4.75 1.69 7.42 1.69 3.04 0 4.17-1.2 4.17-2.97 0-1.78-1.1-2.73-4.94-3.65-4.54-1.1-6.56-2.67-6.56-5.98 0-3.13 2.39-5.46 7.08-5.46 2.91 0 4.78.71 6.16 1.47v2.76c-2.02-1.16-4.2-1.53-6.29-1.53-2.64 0-4.2.92-4.2 2.76 0 1.66 1.29 2.48 4.84 3.37 4.26 1.07 6.66 2.45 6.66 6.07\"/>\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M14.125 14.125V24.75H24.75V14.125z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M19.75 9.594 13.5 6 7.25 9.594v7.187l5 2.875V12.25h7.5z\"/>\n</svg>\n";
function $dd6e7f6bc9a5125a$export$273fd56580e523ae(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Studio' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $e5724170be447320$export$f827d3c5a9c3f644), {
        svg: $dd6e7f6bc9a5125a$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e6df92ef654dd711bfb690d95b2c06d7>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
var $15c0e7b58291f7da$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" fill-rule=\"evenodd\" d=\"M10.594 18.563v-7.97h7.969v7.97zm3.808-6.488-.163.429c-.235.615-.352.922-.572 1.155s-.52.368-1.12.638l-.222.1v.357l.222.099c.6.27.9.405 1.12.638s.337.54.572 1.156l.163.428h.347l.163-.429c.235-.615.352-.922.572-1.155s.52-.368 1.12-.638l.221-.1v-.357l-.22-.1c-.601-.269-.901-.404-1.121-.637s-.337-.54-.572-1.155l-.164-.429z\" clip-rule=\"evenodd\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M14.813 7.195 10.125 4.5 5.438 7.195v5.39l3.75 2.157V9.187h5.625z\"/>\n</svg>\n";
function $15c0e7b58291f7da$export$8bb9894377e04e04(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Studio' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $05f9b20d45e480e2$export$be58b4326e23250f), {
        svg: $15c0e7b58291f7da$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::88f184410a9d6dcf22f1ca1246d077a0>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $11ae8c55cb332e8a$var$svg = "<svg height=\"100%\" viewBox=\"0 0 124 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M116.71 25.64c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49m-13.48-6.2c0-1.17.77-1.84 1.84-1.84s1.84.67 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-15.3-7.66c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.47-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V3.59h2.64v21.74zm-27.41-6.34V10h2.64v9.26c0 2.76 1.1 3.99 3.62 3.99 2.45 0 4.14-1.63 4.14-4.72V10h2.64v15.33h-2.64v-2.51c-.98 1.81-2.79 2.82-4.85 2.82-3.53 0-5.55-2.42-5.55-6.65m-7.16 1.59c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55a6.3 6.3 0 0 1-1.78.25c-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zm-6.89-.8c0 3.5-2.08 5.86-7.08 5.86-3.89 0-5.7-.77-7.27-1.56v-2.82c1.87.98 4.75 1.69 7.42 1.69 3.04 0 4.17-1.2 4.17-2.97s-1.1-2.73-4.94-3.65c-4.54-1.1-6.56-2.67-6.56-5.98 0-3.13 2.39-5.46 7.08-5.46 2.91 0 4.78.71 6.16 1.47v2.76c-2.02-1.16-4.2-1.53-6.29-1.53-2.64 0-4.2.92-4.2 2.76 0 1.66 1.29 2.48 4.85 3.37 4.26 1.07 6.66 2.45 6.66 6.07\"/>\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" fill-rule=\"evenodd\" d=\"M14.125 24.75V14.125H24.75V24.75zm5.078-8.65-.218.571c-.312.82-.469 1.23-.762 1.541s-.694.49-1.494.85l-.295.133v.476l.295.133c.8.36 1.2.54 1.494.85.293.311.45.721.762 1.541l.218.572h.462l.218-.572c.313-.82.469-1.23.762-1.54s.694-.491 1.494-.851l.295-.133v-.476l-.295-.132c-.8-.36-1.2-.54-1.494-.85-.293-.312-.45-.722-.762-1.542l-.218-.571z\" clip-rule=\"evenodd\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M19.75 9.594 13.5 6 7.25 9.594v7.187l5 2.875V12.25h7.5z\"/>\n</svg>\n";
function $11ae8c55cb332e8a$export$170353c338ac5f4a(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Studio' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $e5724170be447320$export$f827d3c5a9c3f644), {
        svg: $11ae8c55cb332e8a$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f1d8fa09e3a068fb57474a844fe5ab56>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
var $7d5bd85babd9d964$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#fb9700)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" fill-rule=\"evenodd\" d=\"m9.297 8.753 2.277-5.073h.858l2.277 5.073 5.529.598.265.816-4.121 3.734 1.14 5.442-.695.505-4.824-2.766-4.824 2.766-.695-.505 1.14-5.442-4.121-3.733.265-.817zm.777 6.415v-.678a1.857 1.857 0 0 1 3.715 0v.613a3.6 3.6 0 0 1-1.886.548h-.053a3.6 3.6 0 0 1-1.776-.483m1.858-3.134a1.393 1.393 0 1 0 0-2.786 1.393 1.393 0 0 0 0 2.786\" clip-rule=\"evenodd\"/>\n</svg>\n";
function $7d5bd85babd9d964$export$4b05688514531169(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Talent' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $05f9b20d45e480e2$export$be58b4326e23250f), {
        svg: $7d5bd85babd9d964$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4af27131cfc453f0f255c3cbe65f158e>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $545ed004ae83180d$var$svg = "<svg height=\"100%\" viewBox=\"0 0 122 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M117.1 20.58c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55c-.46.12-.98.25-1.78.25-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zm-7.33-4.23v8.99h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.51c.98-1.81 2.79-2.82 4.85-2.82 3.53 0 5.55 2.42 5.55 6.66m-22.92-4.26c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.67-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2H82.4c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-14.47.57c-.21.06-.67.12-1.35.12-2.51 0-4.11-1.19-4.11-4.02V3.59h2.64V21.1c0 1.38.92 1.87 2.06 1.87.28 0 .46 0 .77-.03zm-20.75-7.63c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.47-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zM40.28 5.19h15.09v2.64H49.2v17.51h-2.76V7.82h-6.16z\"/>\n    <path fill=\"var(--tile-color,#fb9700)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"m16.577 4.907 3.035 6.763 7.372.797.354 1.09-5.495 4.977 1.52 7.257-.927.672-6.431-3.687-6.433 3.687-.926-.672 1.52-7.257-5.495-4.978.353-1.089 7.372-.797 3.035-6.763zm-.668 11.936a2.476 2.476 0 0 0-2.476 2.477v.904a4.8 4.8 0 0 0 2.369.644h.07a4.8 4.8 0 0 0 2.514-.73v-.818a2.477 2.477 0 0 0-2.477-2.477m0-4.511a1.857 1.857 0 1 0 0 3.714 1.857 1.857 0 0 0 0-3.714\"/>\n</svg>\n";
function $545ed004ae83180d$export$1b3979d995ebbc6e(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Talent' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $e5724170be447320$export$f827d3c5a9c3f644), {
        svg: $545ed004ae83180d$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7cfe9311dc5f8070530ce9772b12f3fc>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
var $ec2f473c5d030159$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M8.06 11.25a2.63 2.63 0 1 0 0-5.25 2.63 2.63 0 0 0 0 5.25m7.88 0a2.63 2.63 0 1 0 0-5.25 2.63 2.63 0 0 0 0 5.25m.17 1.31a2.89 2.89 0 0 1 2.89 2.9V18h-7.22l1.66-3.67a2.89 2.89 0 0 1 2.67-1.77M5 15.63V18h4.81l1.31-2.81a2.63 2.63 0 0 0-2.62-2.63h-.44A3.06 3.06 0 0 0 5 15.63\"/>\n</svg>\n";
function $ec2f473c5d030159$export$1bcbc9c337da86da(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Teams' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $05f9b20d45e480e2$export$be58b4326e23250f), {
        svg: $ec2f473c5d030159$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a9a7a0d4583e5a9f22d08a0d2f6ac1f1>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $ec92cf1c4d78f147$var$svg = "<svg height=\"100%\" viewBox=\"0 0 127 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M126.58 21.16c0 2.55-1.66 4.48-5.77 4.48-2.3 0-4.17-.52-5.34-1.13v-2.79c1.32.77 3.53 1.5 5.46 1.5 2.02 0 3.07-.83 3.07-2.02 0-1.16-.89-1.84-3.8-2.54-3.4-.83-4.84-2.15-4.84-4.66 0-2.67 2.05-4.29 5.55-4.29 1.99 0 3.8.49 4.94 1.1v2.73c-1.84-.92-3.34-1.41-4.97-1.41-1.93 0-2.97.67-2.97 1.87 0 1.07.74 1.75 3.56 2.42 3.4.83 5.12 2.09 5.12 4.75m-24.66-4.36v8.53h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 2.61 0 4.39 1.32 5.15 3.74.86-2.36 2.91-3.74 5.46-3.74 3.44 0 5.34 2.33 5.34 6.66v8.99h-2.64v-8.52c0-3.16-1.1-4.72-3.62-4.72-2.45 0-4.14 1.63-4.14 4.72m-28.33.84c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zM61.99 12.08c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2H57.55c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zM40.28 5.19h15.09v2.64H49.2v17.51h-2.76V7.82h-6.16z\"/>\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M10.75 14.83a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7m10.5 0a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7m.23 1.75a3.86 3.86 0 0 1 3.86 3.86v3.72h-9.62l2.21-5.23a3.86 3.86 0 0 1 3.55-2.35M6.67 20.67v3.5h6.42l1.75-4.08a3.5 3.5 0 0 0-3.5-3.5h-.58a4.08 4.08 0 0 0-4.08 4.08\"/>\n</svg>\n";
function $ec92cf1c4d78f147$export$bfd8d1c4da84ce71(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Teams' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $e5724170be447320$export$f827d3c5a9c3f644), {
        svg: $ec92cf1c4d78f147$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2fc7b25031952cd94704eefaa85d7de4>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
var $80ddb30da36b08ce$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#1558bc)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, white)\" d=\"M9.39 18.23a.95.95 0 0 0 .95-.95V5.38a.95.95 0 0 0-.95-.95H5.38a.95.95 0 0 0-.95.95v11.91c0 .52.42.95.95.95zm9.23-5.46a.95.95 0 0 0 .95-.95V5.38a.95.95 0 0 0-.95-.95h-4.01a.95.95 0 0 0-.95.95v6.44c0 .52.42.95.95.95z\"/>\n</svg>\n";
var $80ddb30da36b08ce$var$customThemeSvg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--themed-icon-color, currentcolor)\" d=\"M18 0a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6V6a6 6 0 0 1 6-6zM5.379 4.43a.95.95 0 0 0-.948.949v11.907c0 .523.424.948.948.948H9.39a.95.95 0 0 0 .947-.948V5.38a.95.95 0 0 0-.947-.948zm9.23 0a.95.95 0 0 0-.947.949v6.44c0 .523.423.948.947.949h4.012a.95.95 0 0 0 .948-.949V5.38a.95.95 0 0 0-.948-.948z\"/>\n</svg>\n";
function $80ddb30da36b08ce$export$4384da9b8b140bf4(_ref) {
    var iconColor = _ref.iconColor, size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Trello' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $05f9b20d45e480e2$export$be58b4326e23250f), {
        svg: $80ddb30da36b08ce$var$svg,
        customThemeSvg: $80ddb30da36b08ce$var$customThemeSvg,
        iconColor: iconColor,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b73a20da143650f747e32cb182c99798>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $50e26eff8a8bc584$var$svg = "<svg height=\"100%\" viewBox=\"0 0 113 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M104.97 25.64c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49M96.21 25.3c-.21.06-.67.12-1.35.12-2.51 0-4.11-1.19-4.11-4.02V3.59h2.64V21.1c0 1.38.92 1.87 2.06 1.87.28 0 .46 0 .77-.03zm-8 0c-.21.06-.67.12-1.35.12-2.51 0-4.11-1.19-4.11-4.02V3.59h2.64V21.1c0 1.38.92 1.87 2.06 1.87.28 0 .46 0 .77-.03zM72.86 12.09c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.67-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2H68.42c.37 2.61 2.05 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-19.48-8.44v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.67-5.43 3.93M40.28 5.19h15.09v2.64H49.2v17.51h-2.76V7.82h-6.16z\"/>\n    <path fill=\"var(--tile-color,#1558bc)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, white)\" d=\"M12.9 24c.62 0 1.13-.49 1.13-1.1V9.1c0-.61-.5-1.1-1.13-1.1H8.13C7.51 8 7 8.49 7 9.1v13.8c0 .61.5 1.1 1.13 1.1zm10.97-6.34c.62 0 1.13-.49 1.13-1.1V9.1c0-.61-.5-1.1-1.13-1.1H19.1c-.62 0-1.13.49-1.13 1.1v7.47c0 .61.5 1.1 1.13 1.1z\"/>\n</svg>\n";
function $50e26eff8a8bc584$export$1b13139dfc0336af(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Trello' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $e5724170be447320$export$f827d3c5a9c3f644), {
        svg: $50e26eff8a8bc584$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}



var $5FkrB = parcelRequire("5FkrB");

/**
 * These are the default parameters for LogoProps if the user does not specify values.
 */ var $4695b20c010af541$export$438460117ae6b7ee = {
    iconColor: 'inherit',
    label: '',
    size: 'medium',
    textColor: 'currentColor'
};
var $4695b20c010af541$export$793fba32aed8942a = {
    iconGradientStart: 'inherit',
    iconGradientStop: 'inherit'
}; /**
 * The props for the <Wrapper /> that takes the svg and turns it into a component.
 */ 


/* wrapper.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $kqp0i = parcelRequire("kqp0i");

var $25nEq = parcelRequire("25nEq");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");

var $246be689d43c2dd2$var$_excluded = [
    "label",
    "svg",
    "size",
    "appearance",
    "iconColor",
    "textColor",
    "testId"
];
var $246be689d43c2dd2$var$CSS_VAR_COLOR = '--logo-color';
var $246be689d43c2dd2$var$CSS_VAR_FILL = '--logo-fill';
var $246be689d43c2dd2$var$styles = {
    root: "_1e0c1o8l _kqswh2mm _syaz1vry _lswu1xf6 _vwz4kb7n _uiztglyw _o5724jg8 _zbji1osq _3se11kw7",
    stop: "_vc881r31",
    xxsmall: "_4t3i7vkz",
    xsmall: "_4t3igktf",
    small: "_4t3i1tcg",
    medium: "_4t3izwfg",
    large: "_4t3i1ylp",
    xlarge: "_4t3ickbl"
};
/**
 * __Wrapper__
 *
 * An internal component used by `@atlaskit/logo` to render logo SVGs with correct styles.
 */ var $246be689d43c2dd2$var$Wrapper = function Wrapper(_ref) {
    var label = _ref.label, svg = _ref.svg, size = _ref.size, appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor, userDefinedTestId = _ref.testId, rest = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $246be689d43c2dd2$var$_excluded);
    // Only required for old logos with gradients, which set gradient values to `inherit` when no appearance is provided
    var shouldApplyStopColor = appearance === undefined;
    var testId = userDefinedTestId && "".concat(userDefinedTestId, "--wrapper");
    return /*#__PURE__*/ $5FkrB.createElement("span", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        "data-testid": testId,
        style: (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, $246be689d43c2dd2$var$CSS_VAR_COLOR, iconColor), $246be689d43c2dd2$var$CSS_VAR_FILL, textColor),
        "aria-label": label ? label : undefined,
        role: label ? 'img' : undefined,
        dangerouslySetInnerHTML: {
            __html: svg
        }
    }, rest, {
        className: (0, $461693459c687c45$export$2e2bcd8739ae039)([
            $246be689d43c2dd2$var$styles.root,
            shouldApplyStopColor && $246be689d43c2dd2$var$styles.stop,
            size && $246be689d43c2dd2$var$styles[size]
        ])
    }));
};
var $246be689d43c2dd2$export$2e2bcd8739ae039 = $246be689d43c2dd2$var$Wrapper;


// Reds
var $f7a5f10e00858daf$export$4b84fd0e2c617bd = '#FFEBE6';
var $f7a5f10e00858daf$export$b34b069eff244586 = '#FFBDAD';
var $f7a5f10e00858daf$export$be802dd0d8b57f35 = '#FF8F73';
var $f7a5f10e00858daf$export$60847d42f9da92a6 = '#FF7452';
var $f7a5f10e00858daf$export$4a7404f376229999 = '#FF5630';
var $f7a5f10e00858daf$export$2010d0fb4295b346 = '#DE350B';
var $f7a5f10e00858daf$export$2837b5a1a71d5c02 = '#BF2600';
var $f7a5f10e00858daf$export$8d9596b529bbb9cf = '#FFFAE6';
var $f7a5f10e00858daf$export$41060a744ab0b7ae = '#FFF0B3';
var $f7a5f10e00858daf$export$1cc05bbbf340e559 = '#FFE380';
var $f7a5f10e00858daf$export$5aae31392d72caaa = '#FFC400';
var $f7a5f10e00858daf$export$c6930421db9fa514 = '#FFAB00';
var $f7a5f10e00858daf$export$59619663aa6500fb = '#FF991F';
var $f7a5f10e00858daf$export$874739ea9e379ab6 = '#FF8B00';
var $f7a5f10e00858daf$export$8a6341c32b6a3ee6 = '#E3FCEF';
var $f7a5f10e00858daf$export$69a3bf21b9686c2b = '#ABF5D1';
var $f7a5f10e00858daf$export$afbce1382ec95f73 = '#79F2C0';
var $f7a5f10e00858daf$export$747d86715d4175de = '#57D9A3';
var $f7a5f10e00858daf$export$940e1f69e873f202 = '#36B37E';
var $f7a5f10e00858daf$export$a49394138f7b8e85 = '#00875A';
var $f7a5f10e00858daf$export$6fa04827ac68a4fb = '#006644';
var $f7a5f10e00858daf$export$226de0355ed012f8 = '#DEEBFF';
var $f7a5f10e00858daf$export$8c13c2ee36917869 = '#B3D4FF';
var $f7a5f10e00858daf$export$ecfc1dff386a3e7a = '#4C9AFF';
var $f7a5f10e00858daf$export$215b7063051591f1 = '#2684FF';
var $f7a5f10e00858daf$export$e62e8919cca44969 = '#0065FF';
var $f7a5f10e00858daf$export$b3de0ae08da2ce64 = '#0052CC';
var $f7a5f10e00858daf$export$a6ee3d71bc067634 = '#0747A6';
var $f7a5f10e00858daf$export$67f15409e87642a1 = '#669DF1';
var $f7a5f10e00858daf$export$f0539dbc42dbb067 = '#8FB8F6';
var $f7a5f10e00858daf$export$363e4475840015bb = '#EAE6FF';
var $f7a5f10e00858daf$export$4b0a4417ed59760f = '#C0B6F2';
var $f7a5f10e00858daf$export$6011520a64d9a187 = '#998DD9';
var $f7a5f10e00858daf$export$a7175d4e9206bc80 = '#8777D9';
var $f7a5f10e00858daf$export$b48405b95304b5a1 = '#6554C0';
var $f7a5f10e00858daf$export$c71e4279dd54a18d = '#5243AA';
var $f7a5f10e00858daf$export$147899de772240ec = '#403294';
var $f7a5f10e00858daf$export$2cf711fe14c66f06 = '#E6FCFF';
var $f7a5f10e00858daf$export$7a8f4d33f6f9772c = '#B3F5FF';
var $f7a5f10e00858daf$export$776c9c497ef08533 = '#79E2F2';
var $f7a5f10e00858daf$export$69cb3ca10c1e330e = '#00C7E6';
var $f7a5f10e00858daf$export$9dc1ef0f3f48059b = '#00B8D9';
var $f7a5f10e00858daf$export$7c835c78b6fcdef8 = '#00A3BF';
var $f7a5f10e00858daf$export$6036577f95c3877e = '#008DA6';
var $f7a5f10e00858daf$export$29a4f05edc054374 = '#FFFFFF';
var $f7a5f10e00858daf$export$e655ef011c4aa1a2 = '#FAFBFC';
var $f7a5f10e00858daf$export$9fdfb749e33cdf97 = '#F4F5F7';
var $f7a5f10e00858daf$export$3e51e8f1440314ba = '#EBECF0';
var $f7a5f10e00858daf$export$1ce2d1575d444ceb = '#DFE1E6';
var $f7a5f10e00858daf$export$8754fc7e6d8b3000 = '#C1C7D0';
var $f7a5f10e00858daf$export$c2e91cbeada39b8b = '#B3BAC5';
var $f7a5f10e00858daf$export$5f71e19f3a7ad9de = '#A5ADBA';
var $f7a5f10e00858daf$export$eaa8c8a70ac22806 = '#97A0AF';
var $f7a5f10e00858daf$export$7c87d337fb91a97d = '#8993A4';
var $f7a5f10e00858daf$export$d6447c357493214f = '#7A869A';
var $f7a5f10e00858daf$export$f563ee71e9ee74cd = '#6B778C';
var $f7a5f10e00858daf$export$e2ef2124cf4024b1 = '#5E6C84';
var $f7a5f10e00858daf$export$eece5f492e429f08 = '#505F79';
var $f7a5f10e00858daf$export$c39c0fe0f26207ae = '#42526E';
var $f7a5f10e00858daf$export$7090862dc3038a9f = '#344563';
var $f7a5f10e00858daf$export$ad0bacf983b7ddaa = '#253858';
var $f7a5f10e00858daf$export$7d61b15e0da132af = '#172B4D';
var $f7a5f10e00858daf$export$fbda843f0a27fe96 = '#091E42';
var $f7a5f10e00858daf$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
var $f7a5f10e00858daf$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
var $f7a5f10e00858daf$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
var $f7a5f10e00858daf$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
var $f7a5f10e00858daf$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
var $f7a5f10e00858daf$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
var $f7a5f10e00858daf$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
var $f7a5f10e00858daf$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
var $f7a5f10e00858daf$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
var $f7a5f10e00858daf$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
var $f7a5f10e00858daf$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
var $f7a5f10e00858daf$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
var $f7a5f10e00858daf$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
var $f7a5f10e00858daf$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
var $f7a5f10e00858daf$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
var $f7a5f10e00858daf$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
var $f7a5f10e00858daf$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
var $f7a5f10e00858daf$export$2f6319cf7d736c2a = '#E6EDFA';
var $f7a5f10e00858daf$export$95126bc8884d6634 = '#DCE5F5';
var $f7a5f10e00858daf$export$8338d8c35d44ff1 = '#CED9EB';
var $f7a5f10e00858daf$export$5368d76ae4fbbda7 = '#B8C7E0';
var $f7a5f10e00858daf$export$9f0a771d16ec8d36 = '#ABBBD6';
var $f7a5f10e00858daf$export$abcf8c38338b4aa5 = '#9FB0CC';
var $f7a5f10e00858daf$export$97e81faa16a182c7 = '#8C9CB8';
var $f7a5f10e00858daf$export$bfe21c59123ecf33 = '#7988A3';
var $f7a5f10e00858daf$export$ee82aa2ea6a1558 = '#67758F';
var $f7a5f10e00858daf$export$682927c6ed76be02 = '#56637A';
var $f7a5f10e00858daf$export$91fd9994c5be9757 = '#455166';
var $f7a5f10e00858daf$export$d281fbfe3cff2df6 = '#3B475C';
var $f7a5f10e00858daf$export$3902c91d8b98a753 = '#313D52';
var $f7a5f10e00858daf$export$8e8133c1ba5845b5 = '#283447';
var $f7a5f10e00858daf$export$33ff357f6620b39 = '#202B3D';
var $f7a5f10e00858daf$export$633847cf062b69e0 = '#1B2638';
var $f7a5f10e00858daf$export$9776a6e503bdbf76 = '#121A29';
var $f7a5f10e00858daf$export$6c813d5160dff5db = '#0E1624';
var $f7a5f10e00858daf$export$3d4f271a500072a = '#0D1424';
var $f7a5f10e00858daf$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
var $f7a5f10e00858daf$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
var $f7a5f10e00858daf$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
var $f7a5f10e00858daf$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
var $f7a5f10e00858daf$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
var $f7a5f10e00858daf$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
var $f7a5f10e00858daf$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
var $f7a5f10e00858daf$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
var $f7a5f10e00858daf$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
var $f7a5f10e00858daf$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
var $f7a5f10e00858daf$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
var $f7a5f10e00858daf$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
var $f7a5f10e00858daf$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
var $f7a5f10e00858daf$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
var $f7a5f10e00858daf$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
var $f7a5f10e00858daf$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
var $f7a5f10e00858daf$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';
var $f7a5f10e00858daf$export$d2adc5dedf09fced = '#292A2E';
var $f7a5f10e00858daf$export$f51762073d2bb381 = '#94C748';
var $f7a5f10e00858daf$export$95e26d54def96891 = '#B3DF72';


var $244fe5cbdef580ed$export$362a25f017e2bc8a = function getColorsFromAppearanceOldLogos(appearance, colorMode) {
    var iconGradientStart, iconGradientStop, iconColor, textColor, atlassianLogoTextColor;
    switch(appearance){
        case 'brand':
            iconGradientStart = (0, $f7a5f10e00858daf$export$b3de0ae08da2ce64);
            iconGradientStop = (0, $f7a5f10e00858daf$export$215b7063051591f1);
            iconColor = (0, $f7a5f10e00858daf$export$215b7063051591f1);
            textColor = "var(--ds-text, #292A2E)";
            // This is only used for the top level Atlassian wordmark (see AtlassianLogo
            // or AtlassianStartLogo for example), and is only different for the Brand
            // appearance - a bold brand color. For other appearances,
            // atlassianLogoTextColor is the same as textColor.
            atlassianLogoTextColor = (0, $f7a5f10e00858daf$export$b3de0ae08da2ce64);
            break;
        case 'neutral':
            iconGradientStart = (0, $f7a5f10e00858daf$export$7090862dc3038a9f);
            iconGradientStop = (0, $f7a5f10e00858daf$export$d6447c357493214f);
            iconColor = (0, $f7a5f10e00858daf$export$d6447c357493214f);
            textColor = (0, $f7a5f10e00858daf$export$eece5f492e429f08);
            atlassianLogoTextColor = (0, $f7a5f10e00858daf$export$eece5f492e429f08);
            break;
        case 'inverse':
            iconGradientStart = '#FFFFFF66';
            iconGradientStop = '#FFFFFF';
            iconColor = '#FFFFFF';
            textColor = '#FFFFFF';
            atlassianLogoTextColor = '#FFFFFF';
            break;
    }
    if (colorMode === 'dark' && appearance === 'inverse') {
        iconGradientStart = '#161A1D66';
        iconGradientStop = '#161A1D';
        iconColor = '#161A1D';
        textColor = '#161A1D';
        atlassianLogoTextColor = '#161A1D';
    }
    return {
        iconGradientStart: iconGradientStart,
        iconGradientStop: iconGradientStop,
        iconColor: iconColor,
        textColor: textColor,
        atlassianLogoTextColor: atlassianLogoTextColor
    };
};
var $244fe5cbdef580ed$export$bbacc3980e0f3029 = function getColorsFromAppearance(appearance, colorMode) {
    var iconColor, textColor, atlassianLogoTextColor;
    if (colorMode === 'dark') switch(appearance){
        case 'brand':
            iconColor = '#357DE8';
            textColor = '#E2E3E4';
            atlassianLogoTextColor = '#357DE8';
            break;
        case 'neutral':
            iconColor = '#96999E';
            textColor = '#BFC1C4';
            atlassianLogoTextColor = '#96999E';
            break;
        case 'inverse':
            iconColor = '#101214';
            textColor = '#101214';
            atlassianLogoTextColor = '#101214';
            break;
    }
    else switch(appearance){
        case 'brand':
            iconColor = '#1868DB';
            textColor = '#101214';
            atlassianLogoTextColor = '#1868DB';
            break;
        case 'neutral':
            iconColor = '#6C6F77';
            textColor = '#3B3D42';
            atlassianLogoTextColor = '#6C6F77';
            break;
        case 'inverse':
            iconColor = (0, $f7a5f10e00858daf$export$29a4f05edc054374);
            textColor = (0, $f7a5f10e00858daf$export$29a4f05edc054374);
            atlassianLogoTextColor = (0, $f7a5f10e00858daf$export$29a4f05edc054374);
            break;
    }
    return {
        iconColor: iconColor,
        textColor: textColor,
        atlassianLogoTextColor: atlassianLogoTextColor
    };
};
var $244fe5cbdef580ed$export$7818df200941dbbf = function getColorsForLoom(appearance, colorMode) {
    var iconColor = $244fe5cbdef580ed$export$bbacc3980e0f3029(appearance, colorMode).iconColor;
    var textColor = $244fe5cbdef580ed$export$bbacc3980e0f3029(appearance, colorMode).textColor;
    if (colorMode === 'dark') switch(appearance){
        case 'brand':
            iconColor = '#625DF5';
            textColor = '#EFF0FF';
            break;
    }
    else switch(appearance){
        case 'brand':
            iconColor = '#625DF5';
            textColor = '#252434';
            break;
    }
    return {
        iconColor: iconColor,
        textColor: textColor
    };
};


var $deef3d3b45588f0d$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor;
    var colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $244fe5cbdef580ed$export$bbacc3980e0f3029)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" focusable=\"false\" aria-hidden=\"true\">\n      <path\n        d=\"M27.545 24.378 16.96 3.208c-.208-.458-.417-.541-.667-.541-.208 0-.458.083-.708.5-1.5 2.375-2.167 5.125-2.167 8 0 4.001 2.042 7.752 5.042 13.794.334.667.584.792 1.167.792h7.335c.541 0 .833-.208.833-.625 0-.208-.042-.333-.25-.75M12.168 14.377c-.834-1.25-1.084-1.334-1.292-1.334s-.333.083-.708.834L4.875 24.46c-.167.334-.208.459-.208.625 0 .334.291.667.916.667h7.46c.5 0 .875-.416 1.083-1.208.25-1 .334-1.876.334-2.917 0-2.917-1.292-5.751-2.292-7.251z\"\n        fill=\"".concat(colors.iconColor, "\"\n      />\n    </svg>");
};
var $deef3d3b45588f0d$export$84109e099492cb5f = function AtlassianAdminIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Atlassian Admin' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $4695b20c010af541$export$438460117ae6b7ee).size : _ref2$size, testId = _ref2.testId, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $4695b20c010af541$export$438460117ae6b7ee).textColor : _ref2$textColor, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $4695b20c010af541$export$438460117ae6b7ee).iconColor : _ref2$iconColor;
    var _useThemeObserver = (0, $fdb77cc968262235$export$2e2bcd8739ae039)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $246be689d43c2dd2$export$2e2bcd8739ae039), {
        appearance: appearance,
        svg: $deef3d3b45588f0d$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        label: label,
        size: size,
        testId: testId,
        textColor: textColor
    });
};


var $5FkrB = parcelRequire("5FkrB");




var $d33c9708982ababa$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $244fe5cbdef580ed$export$bbacc3980e0f3029)(appearance, colorMode);
    return "<svg\n      fill=\"none\"\n      height=\"32\"\n      xmlns=\"http://www.w3.org/2000/svg\"\n      viewBox=\"0 0 295 32\"\n      focusable=\"false\"\n      aria-hidden=\"true\"\n    >\n      <path\n        d=\"M294.31 16.348v8.985h-2.637v-9.261c0-2.76-1.104-3.987-3.619-3.987-2.453 0-4.14 1.626-4.14 4.723v8.525h-2.637V10h2.637v2.515c.982-1.81 2.791-2.822 4.846-2.822 3.526 0 5.55 2.423 5.55 6.655M274.168 5.952c0-1.165.766-1.84 1.84-1.84 1.073 0 1.84.675 1.84 1.84s-.767 1.84-1.84 1.84c-1.074 0-1.84-.675-1.84-1.84m.49 19.381V10h2.638v15.333zm-14.069-8.525v8.525h-2.637v-9.261c0-2.76-1.104-3.987-3.619-3.987-2.453 0-4.14 1.626-4.14 4.723v8.525h-2.637V10h2.637v2.515c.981-1.81 2.791-2.822 4.845-2.822 2.607 0 4.386 1.319 5.152 3.742.859-2.362 2.914-3.742 5.459-3.742 3.435 0 5.336 2.331 5.336 6.655v8.985h-2.637v-8.525c0-3.159-1.104-4.723-3.619-4.723-2.453 0-4.14 1.626-4.14 4.723m-28.327.859c0 3.68 1.472 5.52 4.202 5.52 2.361 0 4.477-1.503 4.477-4.907v-1.227c0-3.404-1.932-4.906-4.171-4.906-2.974 0-4.508 1.962-4.508 5.52m8.679 7.666v-2.76c-.981 2.024-2.821 3.067-5.183 3.067-4.078 0-6.133-3.465-6.133-7.973 0-4.324 2.147-7.974 6.44-7.974 2.239 0 3.956 1.012 4.876 3.006V3.59h2.637v21.742zm-22.021-4.017c-1.533 0-3.097-.184-4.814-.521l-1.687 4.538h-3.097l7.942-20.148h3.496l7.943 20.148h-3.097l-1.687-4.569c-1.809.368-3.373.552-4.999.552m0-2.453c1.288 0 2.607-.154 4.171-.399l-4.079-11.04-4.078 11.07c1.502.246 2.76.369 3.986.369\"\n        fill=\"".concat(colors.textColor, "\"\n      />\n      <path\n        d=\"M107.447 10.828c0 2.972 1.345 5.308 6.795 6.37 3.185.707 3.893 1.203 3.893 2.264 0 1.062-.708 1.699-2.973 1.699-2.619 0-5.733-.92-7.785-2.123v4.812c1.627.779 3.751 1.699 7.785 1.699 5.662 0 7.856-2.548 7.856-6.228m0 .07c0-3.538-1.84-5.166-7.148-6.299-2.902-.637-3.61-1.274-3.61-2.194 0-1.132 1.062-1.628 2.973-1.628 2.335 0 4.6.708 6.794 1.7V6.368c-1.557-.779-3.892-1.345-6.653-1.345-5.237 0-7.927 2.265-7.927 5.945m72.475-5.803v20.172h4.318V9.978l1.769 4.034 6.087 11.325h5.379V5.165h-4.247v13.023l-1.628-3.822-4.883-9.2zm-27.319 0h-4.671v20.172h4.671zm-10.05 14.155c0-3.538-1.841-5.166-7.149-6.298-2.902-.637-3.609-1.274-3.609-2.194 0-1.133 1.061-1.628 2.972-1.628 2.336 0 4.601.707 6.795 1.698v-4.6c-1.557-.779-3.893-1.345-6.653-1.345-5.238 0-7.927 2.265-7.927 5.945 0 2.973 1.345 5.309 6.794 6.37 3.185.708 3.893 1.203 3.893 2.265s-.708 1.699-2.973 1.699c-2.618 0-5.733-.92-7.785-2.124v4.813c1.628.779 3.751 1.699 7.785 1.699 5.592 0 7.857-2.548 7.857-6.3M71.069 5.165v20.172h9.625l1.486-4.389h-6.44V5.165zm-19.039 0v4.318h5.167v15.854h4.741V9.483h5.592V5.165zm-6.866 0h-6.157L32 25.336h5.379l.99-3.397c1.204.354 2.478.566 3.752.566s2.548-.212 3.751-.566l.991 3.397h5.379c-.07 0-7.078-20.17-7.078-20.17zM42.05 18.26c-.92 0-1.77-.142-2.548-.354L42.05 9.13l2.548 8.776a9.6 9.6 0 0 1-2.548.354M97.326 5.165H91.17l-7.08 20.171h5.38l.99-3.397c1.203.354 2.477.566 3.751.566s2.548-.212 3.751-.566l.991 3.397h5.379zM94.212 18.26c-.92 0-1.77-.142-2.548-.354l2.548-8.776 2.548 8.776a9.6 9.6 0 0 1-2.548.354m75.306-13.095h-6.157l-7.007 20.171h5.379l.991-3.397c1.203.354 2.477.566 3.751.566s2.548-.212 3.751-.566l.991 3.397h5.379zm-3.043 13.094c-.92 0-1.77-.142-2.548-.354l2.548-8.776 2.548 8.776a10 10 0 0 1-2.548.354M22.878 24.378 12.293 3.208c-.208-.458-.416-.541-.666-.541-.209 0-.459.083-.709.5-1.5 2.375-2.167 5.125-2.167 8 0 4.001 2.042 7.752 5.043 13.794.333.667.583.792 1.166.792h7.335c.542 0 .833-.208.833-.625 0-.208-.041-.333-.25-.75M7.501 14.377c-.833-1.25-1.083-1.334-1.292-1.334s-.333.083-.708.834L.208 24.46c-.166.334-.208.459-.208.625 0 .334.292.667.917.667h7.46c.5 0 .874-.416 1.083-1.208.25-1 .333-1.876.333-2.917 0-2.917-1.292-5.751-2.292-7.251z\"\n        fill=\"").concat(colors.iconColor, "\"\n      />\n    </svg>");
};
var $d33c9708982ababa$export$f845d9b9254f0541 = function AtlassianAdminLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Atlassian Admin' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $4695b20c010af541$export$438460117ae6b7ee).size : _ref2$size, testId = _ref2.testId, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $4695b20c010af541$export$438460117ae6b7ee).textColor : _ref2$textColor, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $4695b20c010af541$export$438460117ae6b7ee).iconColor : _ref2$iconColor;
    var _useThemeObserver = (0, $fdb77cc968262235$export$2e2bcd8739ae039)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $246be689d43c2dd2$export$2e2bcd8739ae039), {
        appearance: appearance,
        iconColor: iconColor,
        label: label,
        size: size,
        svg: $d33c9708982ababa$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};



var $5FkrB = parcelRequire("5FkrB");




var $d8e67cdbc001644b$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor;
    var colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $244fe5cbdef580ed$export$bbacc3980e0f3029)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" focusable=\"false\" aria-hidden=\"true\">\n      <path\n        d=\"M27.545 24.378 16.96 3.208c-.208-.458-.417-.541-.667-.541-.208 0-.458.083-.708.5-1.5 2.375-2.167 5.125-2.167 8 0 4.001 2.042 7.752 5.042 13.794.334.667.584.792 1.167.792h7.335c.541 0 .833-.208.833-.625 0-.208-.042-.333-.25-.75M12.168 14.377c-.834-1.25-1.084-1.334-1.292-1.334s-.333.083-.708.834L4.875 24.46c-.167.334-.208.459-.208.625 0 .334.291.667.916.667h7.46c.5 0 .875-.416 1.083-1.208.25-1 .334-1.876.334-2.917 0-2.917-1.292-5.751-2.292-7.251z\"\n        fill=\"".concat(colors.iconColor, "\"\n      />\n    </svg>");
};
var $d8e67cdbc001644b$export$74517ed253186308 = function AtlassianAdministrationIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Atlassian Administration' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $4695b20c010af541$export$438460117ae6b7ee).size : _ref2$size, testId = _ref2.testId, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $4695b20c010af541$export$438460117ae6b7ee).textColor : _ref2$textColor, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $4695b20c010af541$export$438460117ae6b7ee).iconColor : _ref2$iconColor;
    var _useThemeObserver = (0, $fdb77cc968262235$export$2e2bcd8739ae039)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $246be689d43c2dd2$export$2e2bcd8739ae039), {
        appearance: appearance,
        svg: $d8e67cdbc001644b$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        label: label,
        size: size,
        testId: testId,
        textColor: textColor
    });
};


var $5FkrB = parcelRequire("5FkrB");




var $d34bb2adfdd493f4$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $244fe5cbdef580ed$export$bbacc3980e0f3029)(appearance, colorMode);
    return "<svg\n      fill=\"none\"\n      height=\"32\"\n      xmlns=\"http://www.w3.org/2000/svg\"\n      viewBox=\"0 0 404 32\"\n      focusable=\"false\"\n      aria-hidden=\"true\"\n    >\n      <path\n        d=\"M403.77 16.348v8.985h-2.637v-9.261c0-2.76-1.104-3.987-3.619-3.987-2.453 0-4.14 1.626-4.14 4.723v8.525h-2.637V10h2.637v2.515c.981-1.81 2.791-2.822 4.845-2.822 3.527 0 5.551 2.423 5.551 6.655m-23.336 9.292c-4.6 0-7.299-3.404-7.299-8.004s2.699-7.943 7.299-7.943c4.57 0 7.237 3.343 7.237 7.943s-2.667 8.004-7.237 8.004m0-13.493c-3.281 0-4.723 2.576-4.723 5.489s1.442 5.55 4.723 5.55c3.251 0 4.661-2.637 4.661-5.55s-1.41-5.49-4.661-5.49zm-13.488-6.195c0-1.165.767-1.84 1.84-1.84 1.074 0 1.84.675 1.84 1.84s-.766 1.84-1.84 1.84c-1.073 0-1.84-.675-1.84-1.84m.491 19.381V10h2.637v15.333zm-7.461-4.753c0 1.35.797 2.27 2.422 2.27.614 0 1.196-.123 1.656-.215v2.545a6.3 6.3 0 0 1-1.778.245c-3.282 0-4.876-1.932-4.876-4.784v-8.188h-2.484V10h2.484V6.75h2.576V10h4.078v2.453h-4.078zm-18.943-2.913c0 3.68 1.472 5.52 4.202 5.52 2.361 0 4.477-1.503 4.477-4.907v-1.227c0-3.404-1.932-4.906-4.171-4.906-2.974 0-4.508 1.962-4.508 5.52m8.679 7.666v-2.76c-.981 2.024-2.821 3.067-5.183 3.067-4.078 0-6.133-3.465-6.133-7.973 0-4.324 2.147-7.974 6.44-7.974 2.239 0 3.956 1.012 4.876 3.006V10h2.637v15.333zm-17.793-9.046v9.046h-2.576V10h2.576v2.699c.89-1.81 2.423-3.098 5.428-2.914v2.576c-3.373-.337-5.428.675-5.428 3.926m-10.037 4.293c0 1.35.797 2.27 2.423 2.27.613 0 1.196-.123 1.656-.215v2.545c-.46.123-.982.245-1.779.245-3.281 0-4.876-1.932-4.876-4.784v-8.188h-2.484V10h2.484V6.75h2.576V10h4.079v2.453h-4.079zm-6.696.583c0 2.545-1.656 4.477-5.765 4.477-2.3 0-4.171-.521-5.336-1.135v-2.79c1.319.766 3.527 1.502 5.459 1.502 2.024 0 3.066-.828 3.066-2.024 0-1.165-.889-1.84-3.802-2.545-3.404-.828-4.846-2.147-4.846-4.661 0-2.668 2.055-4.294 5.551-4.294 1.993 0 3.803.491 4.937 1.104v2.73c-1.84-.92-3.342-1.411-4.968-1.411-1.932 0-2.974.675-2.974 1.87 0 1.074.736 1.749 3.557 2.423 3.404.828 5.121 2.086 5.121 4.754M297.497 5.952c0-1.165.767-1.84 1.84-1.84 1.074 0 1.84.675 1.84 1.84s-.766 1.84-1.84 1.84c-1.073 0-1.84-.675-1.84-1.84m.491 19.381V10h2.637v15.333zm-3.678-8.985v8.985h-2.637v-9.261c0-2.76-1.104-3.987-3.619-3.987-2.453 0-4.14 1.626-4.14 4.723v8.525h-2.637V10h2.637v2.515c.982-1.81 2.791-2.822 4.846-2.822 3.526 0 5.55 2.423 5.55 6.655M274.168 5.952c0-1.165.766-1.84 1.84-1.84 1.073 0 1.84.675 1.84 1.84s-.767 1.84-1.84 1.84c-1.074 0-1.84-.675-1.84-1.84m.49 19.381V10h2.638v15.333zm-14.069-8.525v8.525h-2.637v-9.261c0-2.76-1.104-3.987-3.619-3.987-2.453 0-4.14 1.626-4.14 4.723v8.525h-2.637V10h2.637v2.515c.981-1.81 2.791-2.822 4.845-2.822 2.607 0 4.386 1.319 5.152 3.742.859-2.362 2.914-3.742 5.459-3.742 3.435 0 5.336 2.331 5.336 6.655v8.985h-2.637v-8.525c0-3.159-1.104-4.723-3.619-4.723-2.453 0-4.14 1.626-4.14 4.723m-28.327.859c0 3.68 1.472 5.52 4.202 5.52 2.361 0 4.477-1.503 4.477-4.907v-1.227c0-3.404-1.932-4.906-4.171-4.906-2.974 0-4.508 1.962-4.508 5.52m8.679 7.666v-2.76c-.981 2.024-2.821 3.067-5.183 3.067-4.078 0-6.133-3.465-6.133-7.973 0-4.324 2.147-7.974 6.44-7.974 2.239 0 3.956 1.012 4.876 3.006V3.59h2.637v21.742zm-22.021-4.017c-1.533 0-3.097-.184-4.814-.521l-1.687 4.538h-3.097l7.942-20.148h3.496l7.943 20.148h-3.097l-1.687-4.569c-1.809.368-3.373.552-4.999.552m0-2.453c1.288 0 2.607-.154 4.171-.399l-4.079-11.04-4.078 11.07c1.502.246 2.76.369 3.986.369\"\n        fill=\"".concat(colors.textColor, "\"\n      />\n      <path\n        d=\"M107.447 10.828c0 2.972 1.345 5.308 6.795 6.37 3.185.707 3.893 1.203 3.893 2.264 0 1.062-.708 1.699-2.973 1.699-2.619 0-5.733-.92-7.785-2.123v4.812c1.627.779 3.751 1.699 7.785 1.699 5.662 0 7.856-2.548 7.856-6.228m0 .07c0-3.538-1.84-5.166-7.148-6.299-2.902-.637-3.61-1.274-3.61-2.194 0-1.132 1.062-1.628 2.973-1.628 2.335 0 4.6.708 6.794 1.7V6.368c-1.557-.779-3.892-1.345-6.653-1.345-5.237 0-7.927 2.265-7.927 5.945m72.475-5.803v20.172h4.318V9.978l1.769 4.034 6.087 11.325h5.379V5.165h-4.247v13.023l-1.628-3.822-4.883-9.2zm-27.319 0h-4.671v20.172h4.671zm-10.05 14.155c0-3.538-1.841-5.166-7.149-6.298-2.902-.637-3.609-1.274-3.609-2.194 0-1.133 1.061-1.628 2.972-1.628 2.336 0 4.601.707 6.795 1.698v-4.6c-1.557-.779-3.893-1.345-6.653-1.345-5.238 0-7.927 2.265-7.927 5.945 0 2.973 1.345 5.309 6.794 6.37 3.185.708 3.893 1.203 3.893 2.265s-.708 1.699-2.973 1.699c-2.618 0-5.733-.92-7.785-2.124v4.813c1.628.779 3.751 1.699 7.785 1.699 5.592 0 7.857-2.548 7.857-6.3M71.069 5.165v20.172h9.625l1.486-4.389h-6.44V5.165zm-19.039 0v4.318h5.167v15.854h4.741V9.483h5.592V5.165zm-6.866 0h-6.157L32 25.336h5.379l.99-3.397c1.204.354 2.478.566 3.752.566s2.548-.212 3.751-.566l.991 3.397h5.379c-.07 0-7.078-20.17-7.078-20.17zM42.05 18.26c-.92 0-1.77-.142-2.548-.354L42.05 9.13l2.548 8.776a9.6 9.6 0 0 1-2.548.354M97.326 5.165H91.17l-7.08 20.171h5.38l.99-3.397c1.203.354 2.477.566 3.751.566s2.548-.212 3.751-.566l.991 3.397h5.379zM94.212 18.26c-.92 0-1.77-.142-2.548-.354l2.548-8.776 2.548 8.776a9.6 9.6 0 0 1-2.548.354m75.306-13.095h-6.157l-7.007 20.171h5.379l.991-3.397c1.203.354 2.477.566 3.751.566s2.548-.212 3.751-.566l.991 3.397h5.379zm-3.043 13.094c-.92 0-1.77-.142-2.548-.354l2.548-8.776 2.548 8.776a10 10 0 0 1-2.548.354M22.878 24.378 12.293 3.208c-.208-.458-.416-.541-.666-.541-.209 0-.459.083-.709.5-1.5 2.375-2.167 5.125-2.167 8 0 4.001 2.042 7.752 5.043 13.794.333.667.583.792 1.166.792h7.335c.542 0 .833-.208.833-.625 0-.208-.041-.333-.25-.75M7.501 14.377c-.833-1.25-1.083-1.334-1.292-1.334s-.333.083-.708.834L.208 24.46c-.166.334-.208.459-.208.625 0 .334.292.667.917.667h7.46c.5 0 .874-.416 1.083-1.208.25-1 .333-1.876.333-2.917 0-2.917-1.292-5.751-2.292-7.251z\"\n        fill=\"").concat(colors.iconColor, "\"\n      />\n    </svg>");
};
var $d34bb2adfdd493f4$export$833abe6c2ce5ebfd = function AtlassianAdministrationLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Atlassian Administration' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $4695b20c010af541$export$438460117ae6b7ee).size : _ref2$size, testId = _ref2.testId, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $4695b20c010af541$export$438460117ae6b7ee).textColor : _ref2$textColor, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $4695b20c010af541$export$438460117ae6b7ee).iconColor : _ref2$iconColor;
    var _useThemeObserver = (0, $fdb77cc968262235$export$2e2bcd8739ae039)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $246be689d43c2dd2$export$2e2bcd8739ae039), {
        appearance: appearance,
        iconColor: iconColor,
        label: label,
        size: size,
        svg: $d34bb2adfdd493f4$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};



var $5FkrB = parcelRequire("5FkrB");

var $ekGgq = parcelRequire("ekGgq");

var $5FkrB = parcelRequire("5FkrB");
function $8a4e0f31a3c0be30$export$f680877a34711e37() {
    // React uses `:` or `«»` in selectors which breaks `document.querySelector(…)`.
    // Replace with `_` to match future React 19 functionality.
    return (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).useId().replace(/[:«»]/g, '_');
}
var $8a4e0f31a3c0be30$export$6be90bcb437e928f = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function(_ref, ref) {
    var children = _ref.children, _ref$postfix = _ref.postfix, postfix = _ref$postfix === void 0 ? '' : _ref$postfix, _ref$prefix = _ref.prefix, prefix = _ref$prefix === void 0 ? '' : _ref$prefix;
    var id = "".concat(prefix).concat($8a4e0f31a3c0be30$export$f680877a34711e37()).concat(postfix);
    (0, $5FkrB.useEffect)(function() {
        if (!ref) return;
        switch((0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(ref)){
            case 'function':
                ref(id);
                break;
            case 'object':
                ref.current = id;
                break;
            default:
                throw new Error("Unreachable case for unsupported type of ref \"".concat((0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(ref), "\""));
        }
    }, [
        id,
        ref
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).Fragment, null, typeof children === 'function' ? children({
        id: id
    }) : children);
});
function $8a4e0f31a3c0be30$export$6ee17796e3d70de2() {
    var uid = $8a4e0f31a3c0be30$export$f680877a34711e37();
    return function(id) {
        return "".concat(uid, "-").concat(id.toString());
    };
}






var $f554407486f95716$var$svg = function svg(_ref, colorMode, id) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor;
    var colors = {
        iconGradientStart: iconColor,
        iconGradientStop: iconColor,
        iconColor: iconColor
    };
    if (appearance) colors = (0, $244fe5cbdef580ed$export$362a25f017e2bc8a)(appearance, colorMode);
    return "<svg height=\"32\" viewBox=\"0 0 48 48\" xmlns=\"http://www.w3.org/2000/svg\">\n  <defs>\n    <linearGradient id=\"".concat(id, "-a\" x1=\"12.595\" x2=\"12.595\" y1=\"40\" y2=\"30\" gradientUnits=\"userSpaceOnUse\">\n      <stop offset=\"0\" stop-color=\"").concat(colors.iconGradientStart, "\"/>\n      <stop offset=\"1\" stop-color=\"").concat(colors.iconGradientStop, "\"/>\n    </linearGradient>\n    <linearGradient id=\"").concat(id, "-b\" x1=\"28.595\" x2=\"28.595\" y1=\"40\" y2=\"27\" gradientUnits=\"userSpaceOnUse\">\n      <stop offset=\"0\" stop-color=\"").concat(colors.iconGradientStart, "\"/>\n      <stop offset=\"1\" stop-color=\"").concat(colors.iconGradientStop, "\"/>\n    </linearGradient>\n    <linearGradient xlink:href=\"#").concat(id, "-b\" id=\"").concat(id, "-c\" x1=\"20.595\" x2=\"20.595\" y2=\"22\"/>\n    <linearGradient xlink:href=\"#").concat(id, "-b\" id=\"").concat(id, "-d\" x1=\"36.595\" x2=\"36.595\" y2=\"20\"/>\n  </defs>\n  <path d=\"M10.595 30h4v10h-4z\" fill=\"url(#").concat(id, "-a)\"/>\n  <path d=\"M26.595 27h4v13h-4z\" fill=\"url(#").concat(id, "-b)\"/>\n  <path d=\"M18.595 22h4v18h-4z\" fill=\"url(#").concat(id, "-c)\"/>\n  <path d=\"M34.595 20h4v20h-4z\" fill=\"url(#").concat(id, "-d)\"/>\n  <path fill=\"").concat(colors.iconColor, "\" d=\"m9.009 25.414-2.828-2.828 10.127-10.128a5 5 0 0 1 6.605-.411l4.471 3.477a1.5 1.5 0 0 0 1.982-.123l9.815-9.815 2.828 2.828-10.127 10.128a5 5 0 0 1-6.605.411l-4.471-3.477a1.5 1.5 0 0 0-1.982.123l-9.815 9.815Z\" />\n</svg>");
};
var $f554407486f95716$export$c42ad8a0b925c762 = function AtlassianAnalyticsIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Atlassian Analytics' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $4695b20c010af541$export$438460117ae6b7ee).size : _ref2$size, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $4695b20c010af541$export$438460117ae6b7ee).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $4695b20c010af541$export$438460117ae6b7ee).textColor : _ref2$textColor, testId = _ref2.testId;
    var _useThemeObserver = (0, $fdb77cc968262235$export$2e2bcd8739ae039)(), colorMode = _useThemeObserver.colorMode;
    var id = (0, $8a4e0f31a3c0be30$export$f680877a34711e37)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $246be689d43c2dd2$export$2e2bcd8739ae039), {
        appearance: appearance,
        label: label,
        svg: $f554407486f95716$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode, id),
        iconColor: iconColor,
        textColor: textColor,
        size: size,
        testId: testId
    });
};


var $5FkrB = parcelRequire("5FkrB");





var $95feedc4efaebf57$var$svg = function svg(_ref, colorMode, id) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconGradientStart: iconColor,
        iconGradientStop: iconColor,
        textColor: textColor,
        iconColor: iconColor,
        // We treat the word "Atlassian" differently to normal app logos, it has a bold brand look
        atlassianLogoTextColor: textColor
    };
    if (appearance) colors = (0, $244fe5cbdef580ed$export$362a25f017e2bc8a)(appearance, colorMode);
    return "\n  <svg height=\"32\" viewBox=\"0 0 477 48\" xmlns=\"http://www.w3.org/2000/svg\">\n  <defs>\n    <linearGradient id=\"".concat(id, "-a\" x1=\"447.285\" x2=\"447.285\" y1=\"40\" y2=\"30\" gradientUnits=\"userSpaceOnUse\">\n      <stop offset=\"0\" stop-color=\"").concat(colors.iconGradientStart, "\"/>\n      <stop offset=\"1\" stop-color=\"").concat(colors.iconGradientStop, "\"/>\n    </linearGradient>\n    <linearGradient xlink:href=\"#").concat(id, "-a\" id=\"").concat(id, "-b\" x1=\"463.285\" x2=\"463.285\" y2=\"27\"/>\n    <linearGradient xlink:href=\"#").concat(id, "-a\" id=\"").concat(id, "-c\" x1=\"455.285\" x2=\"455.285\" y2=\"22\"/>\n    <linearGradient xlink:href=\"#").concat(id, "-a\" id=\"").concat(id, "-d\" x1=\"471.285\" x2=\"471.285\" y2=\"20\"/>\n  </defs>\n  <g fill=\"").concat(colors.atlassianLogoTextColor, "\">\n    <path d=\"M106.72 18.359c0 4.201 1.949 7.536 9.572 9.008 4.548.953 5.5 1.689 5.5 3.205 0 1.473-.953 2.425-4.158 2.425-3.725 0-8.142-1.256-11.044-2.988v6.843c2.295 1.126 5.327 2.382 10.957 2.382 7.969 0 11.131-3.551 11.131-8.835m0 0c0-4.981-2.642-7.319-10.091-8.922-4.114-.91-5.111-1.819-5.111-3.118 0-1.646 1.473-2.339 4.201-2.339 3.292 0 6.54.996 9.615 2.382v-6.54c-2.166-1.083-5.5-1.949-9.398-1.949-7.363 0-11.174 3.205-11.174 8.445M209.1 10.346v28.455h6.063V17.103l2.556 5.76 8.575 15.938h7.623V10.346h-6.064V28.71l-2.295-5.327-6.886-13.037H209.1zM163.909 10.346h6.626v28.455h-6.626zM156.263 30.399c0-4.981-2.642-7.319-10.091-8.922-4.114-.91-5.111-1.819-5.111-3.118 0-1.646 1.473-2.339 4.201-2.339 3.292 0 6.54.996 9.615 2.382v-6.54c-2.166-1.083-5.5-1.949-9.398-1.949-7.363 0-11.174 3.205-11.174 8.445 0 4.201 1.949 7.536 9.572 9.008 4.548.953 5.5 1.689 5.5 3.205 0 1.473-.953 2.425-4.158 2.425-3.725 0-8.142-1.256-11.044-2.988v6.843c2.295 1.126 5.327 2.382 10.957 2.382 7.969 0 11.131-3.551 11.131-8.835M55.243 10.346v28.455h13.62l2.145-6.15h-9.095V10.346h-6.67zM28.334 10.346v6.15h7.363v22.305h6.67V16.496h7.882v-6.15H28.334zM18.663 10.346h-8.74L0 38.801h7.579l1.407-4.792a18.852 18.852 0 0 0 10.612 0l1.407 4.792h7.579l-9.922-28.455Zm-4.37 18.533c-1.267 0-2.49-.185-3.647-.524l3.647-12.422 3.647 12.422c-1.157.339-2.38.524-3.647.524ZM92.344 10.346h-8.74l-9.922 28.455h7.579l1.407-4.792a18.852 18.852 0 0 0 10.612 0l1.407 4.792h7.579l-9.922-28.455Zm-4.37 18.533c-1.267 0-2.49-.185-3.647-.524l3.647-12.422 3.647 12.422c-1.157.339-2.38.524-3.647.524ZM194.414 10.346h-8.74l-9.922 28.455h7.579l1.407-4.792a18.852 18.852 0 0 0 10.612 0l1.407 4.792h7.579l-9.922-28.455Zm-4.37 18.533c-1.267 0-2.49-.185-3.647-.524l3.647-12.422 3.647 12.422c-1.157.339-2.38.524-3.647.524Z\"/>\n  </g>\n  <g fill=\"").concat(colors.textColor, "\">\n    <path d=\"m254.776 31.987-2.53 6.809H247.6l11.916-30.225h5.244l11.916 30.225h-4.646l-2.53-6.855c-2.714.552-5.061.828-7.499.828-2.3 0-4.646-.276-7.223-.782Zm13.479-3.496-6.119-16.562-6.119 16.608c2.254.368 4.141.552 5.98.552 1.933 0 3.911-.23 6.257-.598ZM298.984 38.796h-3.957V24.902c0-4.141-1.656-5.981-5.428-5.981-3.681 0-6.211 2.438-6.211 7.085v12.79h-3.957V15.794h3.957v3.772c1.472-2.715 4.187-4.232 7.269-4.232 5.291 0 8.327 3.634 8.327 9.983v13.479ZM320.097 34.656c-1.472 3.036-4.232 4.6-7.775 4.6-6.119 0-9.201-5.199-9.201-11.961 0-6.486 3.22-11.961 9.661-11.961 3.358 0 5.935 1.518 7.314 4.508v-4.048h3.957v23.002h-3.957v-4.14Zm-6.717.92c3.542 0 6.717-2.254 6.717-7.361v-1.84c0-5.106-2.898-7.361-6.256-7.361-4.463 0-6.763 2.944-6.763 8.281 0 5.521 2.208 8.281 6.303 8.281ZM336.196 38.935c-3.772 0-6.165-1.794-6.165-6.027V6.179h3.957v26.269c0 2.07 1.38 2.806 3.083 2.806.414 0 .69 0 1.15-.046v3.542c-.322.092-1.012.184-2.024.184ZM347.328 37.324l-8.327-21.53h4.232l7.361 19.69 7.361-19.69h4.232l-8.695 22.267c-2.576 6.579-4.048 9.983-9.891 9.983-1.979 0-3.083-.184-4.232-.644v-3.404c1.334.414 2.852.552 4.002.552 3.22 0 4.646-2.208 6.533-7.223h-2.576ZM374.698 35.07c.92 0 1.794-.185 2.484-.322v3.818c-.69.184-1.472.368-2.668.368-4.923 0-7.315-2.898-7.315-7.177V19.473h-3.727v-3.68h3.727v-4.877h3.864v4.877h6.119v3.68h-6.119v12.191c0 2.024 1.196 3.405 3.635 3.405ZM384.265 6.961c1.61 0 2.76 1.012 2.76 2.76s-1.15 2.76-2.76 2.76-2.76-1.012-2.76-2.76 1.15-2.76 2.76-2.76Zm-2.024 8.833h3.957v23.002h-3.957V15.794ZM408.416 38.198c-1.38.736-3.496 1.058-5.612 1.058-8.189 0-12.007-4.968-12.007-12.007 0-6.947 3.818-11.915 12.007-11.915 2.07 0 3.68.276 5.475 1.104v3.681c-1.472-.69-3.037-1.104-5.199-1.104-5.98 0-8.419 3.772-8.419 8.235s2.484 8.235 8.511 8.235c2.346 0 3.818-.322 5.244-.828v3.542ZM420.144 39.256c-3.451 0-6.257-.782-8.005-1.702v-4.187c1.978 1.15 5.291 2.254 8.188 2.254 3.037 0 4.601-1.242 4.601-3.036 0-1.749-1.334-2.761-5.705-3.818-5.106-1.242-7.269-3.221-7.269-6.993 0-4.002 3.082-6.44 8.327-6.44 2.99 0 5.705.736 7.407 1.656v4.094c-2.76-1.38-5.014-2.117-7.453-2.117-2.898 0-4.462 1.013-4.462 2.807 0 1.61 1.104 2.622 5.336 3.635 5.106 1.242 7.683 3.128 7.683 7.13 0 3.819-2.484 6.717-8.649 6.717Z\"/>\n  </g>\n  <path fill=\"url(#").concat(id, "-a)\" d=\"M445.285 30h4v10h-4z\"/>\n  <path fill=\"url(#").concat(id, "-b)\" d=\"M461.285 27h4v13h-4z\"/>\n  <path fill=\"url(#").concat(id, "-c)\" d=\"M453.285 22h4v18h-4z\"/>\n  <path fill=\"url(#").concat(id, "-d)\" d=\"M469.285 20h4v20h-4z\"/>\n  <path fill=\"").concat(colors.iconColor, "\" d=\"m443.699 25.414-2.828-2.828 10.127-10.128a5 5 0 0 1 6.605-.411l4.471 3.477a1.5 1.5 0 0 0 1.982-.123l9.815-9.815 2.828 2.828-10.127 10.128a5 5 0 0 1-6.605.411l-4.471-3.477a1.5 1.5 0 0 0-1.982.123l-9.815 9.815Z\"/>\n</svg>");
};
var $95feedc4efaebf57$export$e6470bfc39010cc4 = function AtlassianAnalyticsLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Atlassian Analytics' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $4695b20c010af541$export$438460117ae6b7ee).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $4695b20c010af541$export$438460117ae6b7ee).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $4695b20c010af541$export$438460117ae6b7ee).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $fdb77cc968262235$export$2e2bcd8739ae039)(), colorMode = _useThemeObserver.colorMode;
    var id = (0, $8a4e0f31a3c0be30$export$f680877a34711e37)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $246be689d43c2dd2$export$2e2bcd8739ae039), {
        appearance: appearance,
        label: label,
        size: size,
        iconColor: iconColor,
        svg: $95feedc4efaebf57$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode, id),
        testId: testId,
        textColor: textColor
    });
};



var $5FkrB = parcelRequire("5FkrB");




var $8ad89f28fbf49cde$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor;
    var colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $244fe5cbdef580ed$export$bbacc3980e0f3029)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" viewBox=\"0 0 32 32\" focusable=\"false\" aria-hidden=\"true\" xmlns=\"http://www.w3.org/2000/svg\">\n      <path fill=".concat(colors.iconColor, " d=\"m25.586 15.819-1.618 9.885c-.106.598-.528.95-1.126.95H9.122c-.598 0-1.02-.352-1.126-.95L5.146 8.08c-.105-.598.212-.985.775-.985h20.123c.562 0 .88.387.773.985l-.773 4.644c-.106.668-.493.95-1.126.95H12.816c-.176 0-.282.105-.246.316l.95 5.84c.035.14.14.246.281.246h4.362c.141 0 .246-.105.282-.246l.668-4.222c.07-.527.422-.738.915-.738h4.75c.703 0 .914.351.808.95\"/>\n    </svg>");
};
var $8ad89f28fbf49cde$export$5fc1066e677788d4 = function BitbucketIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Bitbucket' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $4695b20c010af541$export$438460117ae6b7ee).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $4695b20c010af541$export$438460117ae6b7ee).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $4695b20c010af541$export$438460117ae6b7ee).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $fdb77cc968262235$export$2e2bcd8739ae039)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $246be689d43c2dd2$export$2e2bcd8739ae039), {
        appearance: appearance,
        label: label,
        svg: $8ad89f28fbf49cde$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};


var $5FkrB = parcelRequire("5FkrB");




var $19440dcca25229ac$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $244fe5cbdef580ed$export$bbacc3980e0f3029)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" viewBox=\"0 0 158 32\" focusable=\"false\" aria-hidden=\"true\" xmlns=\"http://www.w3.org/2000/svg\">\n        <path fill=".concat(colors.iconColor, " d=\"m20.46 15.152-1.619 9.885c-.105.598-.527.95-1.125.95H3.996c-.599 0-1.02-.352-1.126-.95L.02 7.412c-.105-.598.211-.985.774-.985h20.123c.563 0 .88.387.774.985l-.774 4.644c-.106.668-.493.95-1.126.95H7.69c-.176 0-.281.105-.246.316l.95 5.84c.035.141.14.247.281.247h4.363c.14 0 .246-.106.281-.247l.668-4.221c.07-.528.423-.739.915-.739h4.75c.703 0 .914.352.809.95\"/>\n        <path fill=").concat(colors.textColor, " d=\"M153.212 20.787c0 1.35.797 2.27 2.422 2.27.614 0 1.196-.123 1.656-.215v2.545c-.46.123-.981.245-1.778.245-3.282 0-4.876-1.932-4.876-4.784v-8.187h-2.484v-2.454h2.484v-3.25h2.576v3.25h4.078v2.453h-4.078zm-13.537-8.494c-2.791 0-4.201 1.809-4.477 4.477h8.556c-.154-2.852-1.442-4.477-4.079-4.477m5.888 12.634c-1.257.675-3.189.92-4.753.92-5.735 0-8.25-3.312-8.25-8.004 0-4.63 2.576-7.942 7.238-7.942 4.722 0 6.624 3.281 6.624 7.942v1.196h-11.194c.368 2.607 2.055 4.294 5.674 4.294 1.778 0 3.281-.338 4.661-.828zm-23.82.613h-2.638V3.799h2.638v13.585l6.593-7.176h3.435l-7.207 7.544 7.513 7.79h-3.588l-6.746-7.176zm-5.648-2.76v2.362c-.92.49-2.331.705-3.742.705-5.458 0-8.004-3.312-8.004-8.004 0-4.63 2.546-7.942 8.004-7.942 1.38 0 2.454.184 3.65.736v2.453c-.982-.46-2.024-.736-3.466-.736-3.986 0-5.612 2.515-5.612 5.49s1.656 5.489 5.674 5.489c1.564 0 2.545-.215 3.496-.552m-27.843-3.588v-8.986h2.637v9.262c0 2.76 1.104 3.986 3.619 3.986 2.453 0 4.14-1.625 4.14-4.722v-8.526h2.637v15.334h-2.637v-2.515c-.982 1.81-2.79 2.821-4.846 2.821-3.526 0-5.55-2.422-5.55-6.654m-5.388-1.319c0-3.68-1.472-5.52-4.201-5.52-2.362 0-4.478 1.503-4.478 4.907v1.226c0 3.404 1.932 4.907 4.171 4.907 2.975 0 4.508-1.963 4.508-5.52m-3.803 7.973c-2.238 0-3.956-1.012-4.876-3.005v2.699h-2.637V3.798h2.637v9.17c.982-2.025 2.822-3.067 5.183-3.067 4.079 0 6.133 3.465 6.133 7.973 0 4.324-2.146 7.973-6.44 7.973m-14.974-5.06c0 1.35.797 2.27 2.422 2.27.614 0 1.196-.123 1.656-.215v2.545a6.3 6.3 0 0 1-1.778.245c-3.282 0-4.876-1.932-4.876-4.784v-8.187h-2.484v-2.454h2.484v-3.25h2.576v3.25h4.078v2.453h-4.078zM53.328 6.16c0-1.166.767-1.84 1.84-1.84s1.84.674 1.84 1.84S56.242 8 55.168 8s-1.84-.676-1.84-1.84m.49 19.38V10.207h2.638V25.54zm-9.828-9.046h-6.194v6.287h6.256c2.637 0 3.833-.951 3.833-2.975 0-2.147-1.134-3.312-3.894-3.312m-.889-8.464h-5.305v6.01h5.305c2.607 0 3.68-1.195 3.68-3.127 0-1.963-1.165-2.883-3.68-2.883m-8.065 17.51V5.394h8.433c4.11 0 6.103 2.024 6.103 5.274 0 2.423-1.104 3.926-3.373 4.478 2.974.49 4.446 2.116 4.446 4.968 0 3.22-2.177 5.428-6.685 5.428z\"/>\n      </svg>");
};
var $19440dcca25229ac$export$bd40525f5333524b = function BitbucketLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Bitbucket' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $4695b20c010af541$export$438460117ae6b7ee).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $4695b20c010af541$export$438460117ae6b7ee).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $4695b20c010af541$export$438460117ae6b7ee).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $fdb77cc968262235$export$2e2bcd8739ae039)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $246be689d43c2dd2$export$2e2bcd8739ae039), {
        appearance: appearance,
        label: label,
        iconColor: iconColor,
        size: size,
        svg: $19440dcca25229ac$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};



var $5FkrB = parcelRequire("5FkrB");




var $df6923e07315bf90$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor;
    var colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $244fe5cbdef580ed$export$bbacc3980e0f3029)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" viewBox=\"0 0 32 32\" focusable=\"false\" aria-hidden=\"true\" xmlns=\"http://www.w3.org/2000/svg\">\n      <path fill=\"".concat(colors.iconColor, "\" d=\"M15.667 15.66v5.942H9.713V15.66zV9.722H4.807c-.58.004-1.047.47-1.043 1.04v15.755a1.04 1.04 0 0 0 1.028 1.054h15.771a1.04 1.04 0 0 0 1.042-1.04V15.66zm0-11.88v5.942h5.967v5.938h5.935V4.82a1.04 1.04 0 0 0-1.028-1.053h-.014z\"/>\n      </svg>\n    ");
};
var $df6923e07315bf90$export$f7857fe64d7161d9 = function CompassIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Compass' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $4695b20c010af541$export$438460117ae6b7ee).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $4695b20c010af541$export$438460117ae6b7ee).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $4695b20c010af541$export$438460117ae6b7ee).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $fdb77cc968262235$export$2e2bcd8739ae039)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $246be689d43c2dd2$export$2e2bcd8739ae039), {
        appearance: appearance,
        label: label,
        svg: $df6923e07315bf90$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};


var $5FkrB = parcelRequire("5FkrB");




var $607814e595771710$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $244fe5cbdef580ed$export$bbacc3980e0f3029)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" viewBox=\"0 0 155 32\" focusable=\"false\" aria-hidden=\"true\" xmlns=\"http://www.w3.org/2000/svg\">\n    <path fill=".concat(colors.iconColor, " d=\"M11.903 14.993v5.942H5.95v-5.942zV9.055H1.043c-.58.004-1.047.47-1.043 1.04v15.756a1.04 1.04 0 0 0 1.028 1.054H16.8a1.04 1.04 0 0 0 1.043-1.04V14.993zm0-11.879v5.941h5.967v5.938h5.936V4.153A1.04 1.04 0 0 0 22.778 3.1h-.015z\"/>\n    <path fill=\"").concat(colors.textColor, "\" d=\"M154.46 21.37c0 2.545-1.656 4.477-5.765 4.477-2.3 0-4.171-.521-5.336-1.134v-2.791c1.318.767 3.526 1.503 5.458 1.503 2.024 0 3.067-.828 3.067-2.024 0-1.166-.889-1.84-3.803-2.546-3.404-.828-4.845-2.146-4.845-4.661 0-2.668 2.055-4.293 5.551-4.293 1.993 0 3.802.49 4.937 1.104v2.729c-1.84-.92-3.343-1.41-4.968-1.41-1.932 0-2.975.674-2.975 1.87 0 1.073.736 1.748 3.558 2.423 3.404.828 5.121 2.085 5.121 4.753m-13.626 0c0 2.545-1.656 4.477-5.766 4.477-2.3 0-4.17-.521-5.336-1.134v-2.791c1.319.767 3.527 1.503 5.459 1.503 2.024 0 3.067-.828 3.067-2.024 0-1.166-.89-1.84-3.803-2.546-3.404-.828-4.845-2.146-4.845-4.661 0-2.668 2.054-4.293 5.55-4.293 1.994 0 3.803.49 4.938 1.104v2.729c-1.84-.92-3.343-1.41-4.968-1.41-1.932 0-2.975.674-2.975 1.87 0 1.073.736 1.748 3.557 2.423 3.404.828 5.122 2.085 5.122 4.753m-25.873-3.496c0 3.68 1.472 5.52 4.201 5.52 2.361 0 4.477-1.503 4.477-4.907v-1.226c0-3.404-1.932-4.907-4.17-4.907-2.975 0-4.508 1.963-4.508 5.52m8.678 7.667v-2.76c-.981 2.024-2.821 3.066-5.182 3.066-4.079 0-6.134-3.465-6.134-7.973 0-4.324 2.147-7.973 6.44-7.973 2.239 0 3.956 1.012 4.876 3.005v-2.699h2.638v15.334zm-16.09-7.667c0-3.68-1.472-5.52-4.201-5.52-2.362 0-4.478 1.503-4.478 4.907v1.226c0 3.404 1.932 4.907 4.171 4.907 2.975 0 4.508-1.963 4.508-5.52m-3.803 7.973c-2.238 0-3.956-1.012-4.876-3.005v8.679h-2.637V10.207h2.637v2.76c.982-2.024 2.822-3.066 5.183-3.066 4.079 0 6.133 3.465 6.133 7.973 0 4.324-2.146 7.973-6.44 7.973m-21.583-8.832v8.526h-2.637v-9.262c0-2.76-1.104-3.986-3.619-3.986-2.453 0-4.14 1.625-4.14 4.722v8.526H69.13V10.207h2.637v2.515c.982-1.81 2.791-2.821 4.846-2.821 2.606 0 4.385 1.318 5.152 3.741.858-2.361 2.913-3.741 5.458-3.741 3.435 0 5.336 2.33 5.336 6.654v8.986h-2.637v-8.526c0-3.158-1.104-4.722-3.619-4.722-2.453 0-4.14 1.625-4.14 4.722m-23.335 8.832c-4.6 0-7.299-3.404-7.299-8.004s2.699-7.942 7.299-7.942c4.57 0 7.237 3.342 7.237 7.942s-2.668 8.004-7.237 8.004m0-13.493c-3.282 0-4.723 2.576-4.723 5.49s1.441 5.55 4.723 5.55c3.25 0 4.661-2.637 4.661-5.55s-1.41-5.49-4.661-5.49m-9.233 9.629v2.668c-1.258.828-3.251 1.196-5.336 1.196-6.624 0-10.366-3.986-10.366-10.334 0-6.134 3.742-10.427 10.304-10.427 1.963 0 3.926.368 5.367 1.41v2.669c-1.441-.92-3.036-1.411-5.367-1.411-4.722 0-7.544 3.128-7.544 7.759s2.914 7.697 7.698 7.697c2.116 0 3.772-.49 5.244-1.227\"/>\n  </svg>");
};
var $607814e595771710$export$eb7d748e4f9c9676 = function CompassLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Compass' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $4695b20c010af541$export$438460117ae6b7ee).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $4695b20c010af541$export$438460117ae6b7ee).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $4695b20c010af541$export$438460117ae6b7ee).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $fdb77cc968262235$export$2e2bcd8739ae039)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $246be689d43c2dd2$export$2e2bcd8739ae039), {
        appearance: appearance,
        label: label,
        iconColor: iconColor,
        size: size,
        svg: $607814e595771710$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};



var $5FkrB = parcelRequire("5FkrB");




var $aa668dadae1ee6cd$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor;
    var colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $244fe5cbdef580ed$export$bbacc3980e0f3029)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" viewBox=\"0 0 32 32\" focusable=\"false\" aria-hidden=\"true\" xmlns=\"http://www.w3.org/2000/svg\">\n      <path fill=\"".concat(colors.iconColor, "\" d=\"M25.769 20.234c-6.584-3.183-8.507-3.66-11.282-3.66-3.254 0-6.028 1.355-8.507 5.16l-.406.622c-.333.513-.407.696-.407.915s.11.403.517.659l4.18 2.598c.222.146.407.22.592.22.222 0 .37-.11.592-.44l.665-1.024c1.036-1.574 1.96-2.086 3.144-2.086 1.036 0 2.257.293 3.773 1.025l4.365 2.049c.443.22.924.11 1.146-.403l2.071-4.537c.222-.512.074-.842-.444-1.098M6.572 12.22c6.584 3.184 8.507 3.66 11.281 3.66 3.255 0 6.03-1.354 8.507-5.16l.407-.622c.333-.512.407-.695.407-.915s-.11-.402-.518-.658l-4.18-2.598c-.221-.147-.406-.22-.591-.22-.222 0-.37.11-.592.44l-.666 1.024c-1.035 1.573-1.96 2.086-3.144 2.086-1.035 0-2.256-.293-3.772-1.025L9.346 6.183c-.444-.22-.924-.11-1.146.402l-2.072 4.538c-.222.512-.074.841.444 1.098\"/>\n    </svg>");
};
var $aa668dadae1ee6cd$export$68f3db7f6af48bcb = function ConfluenceIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Confluence' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $4695b20c010af541$export$438460117ae6b7ee).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $4695b20c010af541$export$438460117ae6b7ee).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $4695b20c010af541$export$438460117ae6b7ee).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $fdb77cc968262235$export$2e2bcd8739ae039)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $246be689d43c2dd2$export$2e2bcd8739ae039), {
        appearance: appearance,
        label: label,
        svg: $aa668dadae1ee6cd$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};


var $5FkrB = parcelRequire("5FkrB");




var $373ecfd01b587d78$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $244fe5cbdef580ed$export$bbacc3980e0f3029)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" viewBox=\"0 0 180 32\" focusable=\"false\" aria-hidden=\"true\" xmlns=\"http://www.w3.org/2000/svg\">\n      <path fill=\"".concat(colors.iconColor, "\" d=\"M20.602 20.234c-6.584-3.183-8.507-3.66-11.281-3.66-3.255 0-6.03 1.355-8.507 5.16l-.407.622c-.333.513-.407.696-.407.915s.111.403.518.659l4.18 2.598c.221.146.406.22.591.22.222 0 .37-.11.592-.44l.666-1.024c1.035-1.574 1.96-2.086 3.144-2.086 1.035 0 2.256.293 3.772 1.025l4.365 2.049c.444.22.925.11 1.146-.403l2.072-4.537c.222-.512.074-.842-.444-1.098M1.406 12.22c6.583 3.184 8.507 3.66 11.28 3.66 3.256 0 6.03-1.354 8.508-5.16l.407-.622c.332-.512.406-.695.406-.915s-.11-.402-.518-.658L17.31 5.927c-.222-.147-.407-.22-.592-.22-.222 0-.37.11-.592.44l-.665 1.024c-1.036 1.573-1.96 2.086-3.144 2.086-1.036 0-2.257-.293-3.773-1.025L4.18 6.183c-.444-.22-.925-.11-1.147.402L.962 11.123c-.222.512-.074.841.444 1.098\"/>\n      <path fill=\"").concat(colors.textColor, "\" d=\"M172.49 12.293c-2.791 0-4.201 1.809-4.477 4.477h8.556c-.154-2.852-1.442-4.477-4.079-4.477m5.888 12.634c-1.257.675-3.189.92-4.753.92-5.735 0-8.25-3.312-8.25-8.004 0-4.63 2.576-7.942 7.238-7.942 4.722 0 6.624 3.281 6.624 7.942v1.196h-11.194c.368 2.607 2.055 4.294 5.674 4.294 1.778 0 3.281-.338 4.661-.828zm-15.093-2.147v2.362c-.92.49-2.331.705-3.742.705-5.458 0-8.004-3.312-8.004-8.004 0-4.63 2.546-7.942 8.004-7.942 1.38 0 2.454.184 3.65.736v2.453c-.982-.46-2.024-.736-3.466-.736-3.986 0-5.612 2.515-5.612 5.49s1.656 5.489 5.674 5.489c1.564 0 2.545-.215 3.496-.552m-14.503-6.226v8.986h-2.637v-9.262c0-2.76-1.104-3.986-3.619-3.986-2.453 0-4.14 1.625-4.14 4.722v8.526h-2.637V10.207h2.637v2.515c.981-1.81 2.791-2.821 4.845-2.821 3.527 0 5.551 2.422 5.551 6.654m-22.921-4.262c-2.79 0-4.201 1.809-4.477 4.477h8.556c-.154-2.852-1.441-4.477-4.079-4.477m5.888 12.634c-1.257.675-3.189.92-4.753.92-5.735 0-8.249-3.312-8.249-8.004 0-4.63 2.576-7.942 7.237-7.942 4.723 0 6.624 3.281 6.624 7.942v1.196h-11.193c.368 2.607 2.054 4.294 5.673 4.294 1.778 0 3.281-.338 4.661-.828zm-29.1-5.734v-8.986h2.637v9.262c0 2.76 1.104 3.986 3.619 3.986 2.453 0 4.14-1.625 4.14-4.722v-8.526h2.637v15.334h-2.637v-2.515c-.981 1.81-2.791 2.821-4.845 2.821-3.527 0-5.551-2.422-5.551-6.654m-2.231 6.317c-.215.061-.674.122-1.35.122-2.514 0-4.108-1.196-4.108-4.017V3.798h2.637v17.51c0 1.38.92 1.871 2.055 1.871.275 0 .459 0 .766-.03zM88.157 8.582v1.625h3.956v2.454h-3.956v12.88h-2.576V12.66h-2.484v-2.454h2.484V8.521c0-2.852 1.595-4.784 4.876-4.784a6.3 6.3 0 0 1 1.779.245v2.423a8.7 8.7 0 0 0-1.656-.154c-1.626 0-2.423.95-2.423 2.33m-7.327 7.974v8.986h-2.637v-9.262c0-2.76-1.104-3.986-3.619-3.986-2.453 0-4.14 1.625-4.14 4.722v8.526h-2.637V10.207h2.637v2.515c.981-1.81 2.79-2.821 4.845-2.821 3.527 0 5.551 2.422 5.551 6.654m-23.336 9.292c-4.6 0-7.298-3.404-7.298-8.004s2.698-7.942 7.298-7.942c4.57 0 7.238 3.342 7.238 7.942s-2.668 8.004-7.238 8.004m0-13.493c-3.28 0-4.722 2.576-4.722 5.49s1.441 5.55 4.722 5.55c3.251 0 4.662-2.637 4.662-5.55s-1.41-5.49-4.662-5.49m-9.233 9.629v2.668c-1.257.828-3.25 1.196-5.336 1.196-6.624 0-10.365-3.986-10.365-10.334 0-6.134 3.741-10.427 10.304-10.427 1.963 0 3.925.368 5.367 1.41v2.669c-1.442-.92-3.036-1.411-5.367-1.411-4.723 0-7.544 3.128-7.544 7.759s2.913 7.697 7.697 7.697c2.116 0 3.772-.49 5.244-1.227\"/>\n    </svg>\n    ");
};
var $373ecfd01b587d78$export$1b2e4fe6ef471556 = function ConfluenceLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Confluence' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $4695b20c010af541$export$438460117ae6b7ee).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $4695b20c010af541$export$438460117ae6b7ee).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $4695b20c010af541$export$438460117ae6b7ee).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $fdb77cc968262235$export$2e2bcd8739ae039)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $246be689d43c2dd2$export$2e2bcd8739ae039), {
        appearance: appearance,
        label: label,
        iconColor: iconColor,
        size: size,
        svg: $373ecfd01b587d78$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};



var $5FkrB = parcelRequire("5FkrB");




var $bde93df51b3897c4$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor;
    var colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $244fe5cbdef580ed$export$bbacc3980e0f3029)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" viewBox=\"0 0 48 48\" focusable=\"false\" aria-hidden=\"true\" xmlns=\"http://www.w3.org/2000/svg\">\n\t\t<path fill=\"".concat(colors.iconColor, "\" d=\"M45.4277 24.5018C41.4108 20.4849 34.8821 20.5276 30.908 24.5018L27.5636 27.8462C25.717 29.6927 22.7177 29.6927 20.8712 27.8462L18.0925 25.0675L10.8309 32.3291L13.6096 35.1078C19.4658 40.9641 28.9654 40.9641 34.8216 35.1078L45.4277 24.5018ZM3 23.5018C7.01684 27.5186 13.4637 27.5578 17.4805 23.5409L20.8676 20.1538C22.7142 18.3073 25.7135 18.3073 27.56 20.1538L30.3387 22.9325L37.6003 15.6709L34.8216 12.8922C28.9654 7.03593 19.4658 7.03593 13.6096 12.8922L3.00356 23.4982L3 23.5018Z\"/>\n\t\t</svg>\n\t\t");
};
var $bde93df51b3897c4$export$1e02e7298035a77c = function FocusIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Focus' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $4695b20c010af541$export$438460117ae6b7ee).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $4695b20c010af541$export$438460117ae6b7ee).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $4695b20c010af541$export$438460117ae6b7ee).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $fdb77cc968262235$export$2e2bcd8739ae039)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $246be689d43c2dd2$export$2e2bcd8739ae039), {
        appearance: appearance,
        label: label,
        svg: $bde93df51b3897c4$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};


var $5FkrB = parcelRequire("5FkrB");




var $2a97c4bc3293e3ce$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $244fe5cbdef580ed$export$bbacc3980e0f3029)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" viewBox=\"0 0 168 48\" focusable=\"false\" aria-hidden=\"true\" xmlns=\"http://www.w3.org/2000/svg\">\n\t\t<path fill=\"".concat(colors.iconColor, "\" d=\"M42.4277 24.5018C38.4108 20.4849 31.8821 20.5276 27.908 24.5018L24.5636 27.8462C22.717 29.6927 19.7177 29.6927 17.8712 27.8462L15.0925 25.0675L7.83088 32.3291L10.6096 35.1078C16.4658 40.9641 25.9654 40.9641 31.8216 35.1078L42.4277 24.5018ZM0 23.5018C4.01684 27.5186 10.4637 27.5578 14.4805 23.5409L17.8676 20.1538C19.7142 18.3073 22.7135 18.3073 24.56 20.1538L27.3387 22.9325L34.6003 15.6709L31.8216 12.8922C25.9654 7.03593 16.4658 7.03593 10.6096 12.8922L0.00355592 23.4982L0 23.5018Z\"/>\n\t\t<path fill=\"").concat(colors.textColor, "\" d=\"M167.405 31.746C167.405 35.564 164.921 38.462 158.757 38.462C155.307 38.462 152.501 37.68 150.753 36.76V32.574C152.731 33.724 156.043 34.828 158.941 34.828C161.977 34.828 163.541 33.586 163.541 31.792C163.541 30.044 162.207 29.032 157.837 27.974C152.731 26.732 150.569 24.754 150.569 20.982C150.569 16.98 153.651 14.542 158.895 14.542C161.885 14.542 164.599 15.278 166.301 16.198V20.292C163.541 18.912 161.287 18.176 158.849 18.176C155.951 18.176 154.387 19.188 154.387 20.982C154.387 22.592 155.491 23.604 159.723 24.616C164.829 25.858 167.405 27.744 167.405 31.746Z\"/>\n\t\t<path fill=\"").concat(colors.textColor, "\" d=\"M126.009 28.48V15.002H129.965V28.894C129.965 33.034 131.621 34.874 135.393 34.874C139.073 34.874 141.603 32.436 141.603 27.79V15.002H145.559V38.002H141.603V34.23C140.131 36.944 137.417 38.462 134.335 38.462C129.045 38.462 126.009 34.828 126.009 28.48Z\"/>\n\t\t<path fill=\"").concat(colors.textColor, "\" d=\"M121.953 33.862V37.404C120.573 38.14 118.457 38.462 116.341 38.462C108.153 38.462 104.335 33.494 104.335 26.456C104.335 19.51 108.153 14.542 116.341 14.542C118.411 14.542 120.021 14.818 121.815 15.646V19.326C120.343 18.636 118.779 18.222 116.617 18.222C110.637 18.222 108.199 21.994 108.199 26.456C108.199 30.918 110.683 34.69 116.709 34.69C119.055 34.69 120.527 34.368 121.953 33.862Z\"/>\n\t\t<path fill=\"").concat(colors.textColor, "\" d=\"M90.2616 38.462C83.3616 38.462 79.3136 33.356 79.3136 26.456C79.3136 19.556 83.3616 14.542 90.2616 14.542C97.1156 14.542 101.118 19.556 101.118 26.456C101.118 33.356 97.1156 38.462 90.2616 38.462ZM90.2616 18.222C85.3396 18.222 83.1776 22.086 83.1776 26.456C83.1776 30.826 85.3396 34.782 90.2616 34.782C95.1376 34.782 97.2536 30.826 97.2536 26.456C97.2536 22.086 95.1376 18.222 90.2616 18.222Z\"/>\n\t\t<path fill=\"").concat(colors.textColor, "\" d=\"M75.298 26.732H61.59V38.002H57.45V7.78003H76.862V11.736H61.59V22.776H75.298V26.732Z\"/>\n\t\t</svg>\n\t\t");
};
var $2a97c4bc3293e3ce$export$33908560ea1b226d = function FocusLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Focus' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $4695b20c010af541$export$438460117ae6b7ee).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $4695b20c010af541$export$438460117ae6b7ee).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $4695b20c010af541$export$438460117ae6b7ee).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $fdb77cc968262235$export$2e2bcd8739ae039)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $246be689d43c2dd2$export$2e2bcd8739ae039), {
        appearance: appearance,
        label: label,
        iconColor: iconColor,
        size: size,
        svg: $2a97c4bc3293e3ce$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};



var $5FkrB = parcelRequire("5FkrB");




var $053b89dee6a0094b$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor;
    var colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $244fe5cbdef580ed$export$bbacc3980e0f3029)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" focusable=\"false\" aria-hidden=\"true\">\n      <path\n        d=\"M5.584 14.4h20.83c.599 0 .918-.32.918-.918V6.459c0-.599-.319-.918-.918-.918h-4.39c-.598 0-.917.32-.917.918v3.551h-1.995V6.46c0-.599-.32-.918-.918-.918h-4.39c-.598 0-.917.32-.917.918v3.551h-1.995V6.46c0-.599-.32-.918-.918-.918h-4.39c-.598 0-.917.32-.917.918v7.023c0 .599.319.918.917.918zm.36 6.145a13.9 13.9 0 0 1-.798-3.99c-.04-.52.199-.799.758-.799h20.191c.559 0 .798.24.798.719q-.12 2.214-.838 4.07c-.24.638-.598.918-1.277.918H7.221c-.679 0-1.038-.28-1.277-.918m18.475 3.312c-1.915 2.354-5.068 3.87-8.42 3.87s-6.584-1.516-8.46-3.87c-.478-.638-.239-1.038.24-1.038h16.44c.48 0 .719.4.2 1.038\"\n        fill=\"".concat(colors.iconColor, "\"\n      />\n    </svg>");
};
var $053b89dee6a0094b$export$3f95fcfdc25a741d = function GuardIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Guard' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $4695b20c010af541$export$438460117ae6b7ee).size : _ref2$size, testId = _ref2.testId, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $4695b20c010af541$export$438460117ae6b7ee).textColor : _ref2$textColor, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $4695b20c010af541$export$438460117ae6b7ee).iconColor : _ref2$iconColor;
    var _useThemeObserver = (0, $fdb77cc968262235$export$2e2bcd8739ae039)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $246be689d43c2dd2$export$2e2bcd8739ae039), {
        appearance: appearance,
        svg: $053b89dee6a0094b$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        label: label,
        size: size,
        testId: testId,
        textColor: textColor
    });
};


var $5FkrB = parcelRequire("5FkrB");




var $fecf9fe2b046b3a2$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $244fe5cbdef580ed$export$bbacc3980e0f3029)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 114 32\" focusable=\"false\" aria-hidden=\"true\">\n      <path\n        d=\"M.918 13.733h20.83c.598 0 .918-.32.918-.918V5.792c0-.599-.32-.918-.918-.918h-4.39c-.598 0-.918.32-.918.918v3.551h-1.995V5.792c0-.599-.319-.918-.918-.918H9.139c-.599 0-.918.32-.918.918v3.551H6.225V5.792c0-.599-.32-.918-.918-.918H.917c-.598 0-.917.32-.917.918v7.023c0 .599.32.918.918.918m.359 6.145a13.9 13.9 0 0 1-.798-3.99c-.04-.52.2-.799.758-.799h20.191c.56 0 .799.24.799.719q-.12 2.214-.838 4.07c-.24.638-.599.918-1.277.918H2.554c-.679 0-1.038-.28-1.277-.918m18.476 3.312c-1.916 2.354-5.068 3.87-8.42 3.87s-6.584-1.516-8.46-3.87c-.479-.638-.24-1.038.24-1.038h16.44c.479 0 .718.4.2 1.038\"\n        fill=\"".concat(colors.iconColor, "\"\n      />\n      <path\n        d=\"M102.398 17.874c0 3.68 1.472 5.52 4.202 5.52 2.361 0 4.477-1.502 4.477-4.906V17.26c0-3.404-1.932-4.907-4.171-4.907-2.974 0-4.508 1.963-4.508 5.52zm8.679 7.667v-2.76c-.982 2.024-2.822 3.067-5.183 3.067-4.079 0-6.133-3.466-6.133-7.974 0-4.324 2.146-7.973 6.44-7.973 2.238 0 3.956 1.012 4.876 3.005V3.798h2.637v21.743zm-17.793-9.047v9.047h-2.576V10.208h2.576v2.698c.89-1.809 2.423-3.097 5.428-2.913v2.576c-3.373-.337-5.428.675-5.428 3.925m-17.869 1.381c0 3.68 1.472 5.52 4.201 5.52 2.362 0 4.478-1.503 4.478-4.907v-1.227c0-3.404-1.932-4.906-4.17-4.906-2.976 0-4.509 1.962-4.509 5.52m8.679 7.666v-2.76c-.982 2.024-2.822 3.067-5.183 3.067-4.079 0-6.133-3.465-6.133-7.973 0-4.324 2.146-7.974 6.44-7.974 2.238 0 3.956 1.012 4.876 3.006v-2.699h2.637v15.333zM56.68 19.193v-8.985h2.637v9.261c0 2.76 1.105 3.987 3.62 3.987 2.453 0 4.14-1.625 4.14-4.723v-8.525h2.637v15.333h-2.638v-2.514c-.981 1.809-2.79 2.821-4.845 2.821-3.527 0-5.55-2.423-5.55-6.655zm-3.973 5.213c-1.595.951-4.539 1.442-6.808 1.442-6.931 0-10.672-4.232-10.672-10.335 0-6.563 4.262-10.457 11.438-10.457 1.595 0 3.466.184 5.244.797v2.76c-1.533-.613-3.342-.89-5.213-.89-5.98 0-8.71 2.975-8.71 7.729 0 4.661 2.76 7.758 8.557 7.758.95 0 2.269-.092 3.404-.429v-5.612h-5.152v-2.637h7.912z\"\n        fill=\"").concat(colors.textColor, "\"\n      />\n    </svg>");
};
var $fecf9fe2b046b3a2$export$a4a891d202775deb = function GuardLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Guard' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $4695b20c010af541$export$438460117ae6b7ee).size : _ref2$size, testId = _ref2.testId, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $4695b20c010af541$export$438460117ae6b7ee).textColor : _ref2$textColor, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $4695b20c010af541$export$438460117ae6b7ee).iconColor : _ref2$iconColor;
    var _useThemeObserver = (0, $fdb77cc968262235$export$2e2bcd8739ae039)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $246be689d43c2dd2$export$2e2bcd8739ae039), {
        appearance: appearance,
        iconColor: iconColor,
        label: label,
        size: size,
        svg: $fecf9fe2b046b3a2$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};



var $5FkrB = parcelRequire("5FkrB");




var $807ff5327a76c7fe$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor;
    var colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $244fe5cbdef580ed$export$bbacc3980e0f3029)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" viewBox=\"0 0 32 32\" focusable=\"false\" aria-hidden=\"true\" xmlns=\"http://www.w3.org/2000/svg\">\n      <path fill=\"".concat(colors.iconColor, "\" d=\"M11.034 21.99h-2.22c-3.346 0-5.747-2.05-5.747-5.052h11.932c.619 0 1.019.44 1.019 1.062v12.007c-2.983 0-4.984-2.416-4.984-5.784zm5.893-5.967h-2.219c-3.347 0-5.748-2.013-5.748-5.015h11.933c.618 0 1.055.402 1.055 1.025V24.04c-2.983 0-5.02-2.416-5.02-5.784zm5.93-5.93h-2.219c-3.347 0-5.748-2.05-5.748-5.052h11.933c.618 0 1.018.439 1.018 1.025v12.007c-2.983 0-4.984-2.416-4.984-5.784z\"/>\n    </svg>");
};
var $807ff5327a76c7fe$export$c4b5b1f965d8b3eb = function JiraIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Jira' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $4695b20c010af541$export$438460117ae6b7ee).size : _ref2$size, testId = _ref2.testId, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $4695b20c010af541$export$438460117ae6b7ee).textColor : _ref2$textColor, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $4695b20c010af541$export$438460117ae6b7ee).iconColor : _ref2$iconColor;
    var _useThemeObserver = (0, $fdb77cc968262235$export$2e2bcd8739ae039)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $246be689d43c2dd2$export$2e2bcd8739ae039), {
        appearance: appearance,
        label: label,
        svg: $807ff5327a76c7fe$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};


var $5FkrB = parcelRequire("5FkrB");




var $d47476c3a75b7640$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $244fe5cbdef580ed$export$bbacc3980e0f3029)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" viewBox=\"0 0 77 32\" focusable=\"false\" aria-hidden=\"true\" xmlns=\"http://www.w3.org/2000/svg\">\n      <path fill=\"".concat(colors.iconColor, "\" d=\"M7.967 21.323H5.748C2.401 21.323 0 19.273 0 16.271h11.933c.618 0 1.018.44 1.018 1.062V29.34c-2.983 0-4.984-2.416-4.984-5.784zm5.894-5.967h-2.22c-3.346 0-5.747-2.013-5.747-5.015h11.932c.618 0 1.055.402 1.055 1.025v12.007c-2.983 0-5.02-2.416-5.02-5.784zm5.93-5.93h-2.22c-3.347 0-5.748-2.05-5.748-5.052h11.933c.618 0 1.019.439 1.019 1.025v12.007c-2.983 0-4.984-2.416-4.984-5.784z\"/>\n      <path fill=\"").concat(colors.textColor, "\" d=\"M65.023 17.874c0 3.68 1.472 5.52 4.202 5.52 2.36 0 4.477-1.503 4.477-4.907V17.26c0-3.404-1.932-4.906-4.17-4.906-2.975 0-4.509 1.962-4.509 5.52m8.679 7.666v-2.76c-.981 2.024-2.821 3.067-5.183 3.067-4.078 0-6.133-3.465-6.133-7.973 0-4.324 2.147-7.974 6.44-7.974 2.239 0 3.956 1.012 4.876 3.006v-2.699h2.637V25.54zM55.91 16.493v9.047h-2.577V10.207h2.576v2.698c.89-1.809 2.423-3.097 5.428-2.913v2.576c-3.373-.337-5.428.675-5.428 3.925M46.224 6.159c0-1.165.767-1.84 1.84-1.84s1.84.675 1.84 1.84-.767 1.84-1.84 1.84-1.84-.675-1.84-1.84m.49 19.381V10.207h2.638V25.54zm-6.427-5.95V5.393h2.76v14.015c0 3.71-1.626 6.256-5.428 6.256-1.442 0-2.546-.246-3.312-.522v-2.668c.828.338 1.84.522 2.852.522 2.33 0 3.128-1.41 3.128-3.404\"/>\n    </svg>");
};
var $d47476c3a75b7640$export$17d3acb0b4379d02 = function JiraLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Jira' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $4695b20c010af541$export$438460117ae6b7ee).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $4695b20c010af541$export$438460117ae6b7ee).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $4695b20c010af541$export$438460117ae6b7ee).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $fdb77cc968262235$export$2e2bcd8739ae039)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $246be689d43c2dd2$export$2e2bcd8739ae039), {
        appearance: appearance,
        label: label,
        iconColor: iconColor,
        size: size,
        svg: $d47476c3a75b7640$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};



var $5FkrB = parcelRequire("5FkrB");




var $74e00d71dd66b21c$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor;
    var colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $244fe5cbdef580ed$export$bbacc3980e0f3029)(appearance, colorMode);
    return "<svg viewBox=\"0 0 32 32\" focusable=\"false\" aria-hidden=\"true\" height=\"32\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n    <path\n      fill=\"".concat(colors.iconColor, "\"\n      d=\"M25.52 25.727c0-3.604-2.949-6.517-6.517-6.517h-6.007v-5.497H6.48v10.813c0 .837.364 1.201 1.201 1.201zM6.48 6.687c0 3.604 2.876 6.517 6.48 6.517h6.043V18.7h6.517V7.888q0-1.2-1.201-1.201z\"\n    />\n  </svg>");
};
var $74e00d71dd66b21c$export$407687b2dd89cc68 = function JiraAlignIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Jira Align' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $4695b20c010af541$export$438460117ae6b7ee).size : _ref2$size, testId = _ref2.testId, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $4695b20c010af541$export$438460117ae6b7ee).textColor : _ref2$textColor, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $4695b20c010af541$export$438460117ae6b7ee).iconColor : _ref2$iconColor;
    var _useThemeObserver = (0, $fdb77cc968262235$export$2e2bcd8739ae039)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $246be689d43c2dd2$export$2e2bcd8739ae039), {
        appearance: appearance,
        label: label,
        svg: $74e00d71dd66b21c$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};


var $5FkrB = parcelRequire("5FkrB");




var $1ff2ed273c1e5214$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $244fe5cbdef580ed$export$bbacc3980e0f3029)(appearance, colorMode);
    return "<svg viewBox=\"0 0 146 32\" focusable=\"false\" aria-hidden=\"true\" height=\"32\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n      <path d=\"M19.04 25.727c0-3.604-2.949-6.517-6.517-6.517H6.517v-5.497H0v10.813c0 .837.364 1.201 1.201 1.201zM0 6.687c0 3.604 2.876 6.517 6.48 6.517h6.043V18.7h6.517V7.888q0-1.2-1.201-1.201z\" fill=\"".concat(colors.iconColor, "\"/>\n      <path d=\"M144.993 16.555v8.985h-2.638v-9.26c0-2.76-1.104-3.988-3.618-3.988-2.454 0-4.14 1.626-4.14 4.723v8.525h-2.638V10.207h2.638v2.515c.981-1.81 2.79-2.822 4.845-2.822 3.527 0 5.551 2.423 5.551 6.655m-19.589 7.759V22.78c-.982 2.024-2.822 3.067-5.183 3.067-4.048 0-6.072-3.465-6.072-7.973 0-4.324 2.116-7.974 6.379-7.974 2.238 0 3.956 1.012 4.876 3.006v-2.699h2.576V24.16c0 4.508-2.116 7.544-7.606 7.544-2.576 0-3.986-.337-5.458-.828V28.3c1.686.552 3.434.92 5.336.92 3.833 0 5.152-2.054 5.152-4.906m-8.679-6.44c0 3.68 1.472 5.52 4.201 5.52 2.362 0 4.478-1.503 4.478-4.907V17.26c0-3.404-1.932-4.906-4.171-4.906-2.975 0-4.508 1.962-4.508 5.52M107.96 6.16c0-1.166.766-1.84 1.84-1.84 1.073 0 1.84.674 1.84 1.84S110.873 8 109.8 8c-1.074 0-1.84-.675-1.84-1.84m.49 19.38V10.208h2.638v15.334h-2.638Zm-2.537-.03c-.215.061-.675.122-1.349.122-2.515 0-4.11-1.196-4.11-4.017V3.798h2.638v17.51c0 1.38.92 1.871 2.054 1.871.276 0 .46 0 .767-.03v2.36ZM88.83 21.523c-1.534 0-3.098-.184-4.815-.521l-1.687 4.539h-3.097l7.942-20.148h3.496l7.943 20.148h-3.097l-1.687-4.57c-1.81.368-3.373.552-4.999.552Zm0-2.453c1.287 0 2.606-.153 4.17-.399l-4.079-11.04-4.078 11.07c1.502.246 2.76.369 3.986.369Zm-27.807-1.196c0 3.68 1.472 5.52 4.202 5.52 2.36 0 4.477-1.503 4.477-4.907V17.26c0-3.404-1.932-4.906-4.17-4.906-2.975 0-4.509 1.962-4.509 5.52m8.679 7.666v-2.76c-.981 2.024-2.822 3.067-5.183 3.067-4.079 0-6.133-3.465-6.133-7.973 0-4.324 2.146-7.974 6.44-7.974 2.239 0 3.956 1.012 4.876 3.006v-2.699h2.637V25.54zM51.91 16.494v9.047h-2.577V10.207h2.576v2.699c.89-1.81 2.423-3.097 5.428-2.913v2.576c-3.373-.338-5.428.674-5.428 3.925ZM42.224 6.16c0-1.166.767-1.84 1.84-1.84s1.84.674 1.84 1.84S45.137 8 44.064 8s-1.84-.675-1.84-1.84m.49 19.38V10.208h2.638v15.334h-2.637Zm-6.427-5.949V5.393h2.76v14.014c0 3.71-1.626 6.256-5.428 6.256-1.442 0-2.546-.245-3.312-.521v-2.668c.828.337 1.84.521 2.852.521 2.33 0 3.128-1.41 3.128-3.404\" fill=\"").concat(colors.textColor, "\"/>\n    </svg>\n  ");
};
var $1ff2ed273c1e5214$export$ee11e928d3d045fd = function JiraAlignLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Jira Align' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $4695b20c010af541$export$438460117ae6b7ee).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $4695b20c010af541$export$438460117ae6b7ee).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $4695b20c010af541$export$438460117ae6b7ee).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $fdb77cc968262235$export$2e2bcd8739ae039)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $246be689d43c2dd2$export$2e2bcd8739ae039), {
        appearance: appearance,
        label: label,
        iconColor: iconColor,
        size: size,
        svg: $1ff2ed273c1e5214$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};



var $5FkrB = parcelRequire("5FkrB");




var $4f72d54064feed25$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor;
    var colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $244fe5cbdef580ed$export$bbacc3980e0f3029)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" viewBox=\"0 0 32 32\" focusable=\"false\" aria-hidden=\"true\" xmlns=\"http://www.w3.org/2000/svg\">\n      <path fill=\"".concat(colors.iconColor, "\" d=\"M17.655 5.884a15.3 15.3 0 0 0 8.75 0c.257-.056.428.114.37.37-.826 2.985-.826 5.742 0 8.727.058.228-.113.427-.37.342a16.33 16.33 0 0 0-8.75 0c-.228.085-.428-.114-.342-.342.77-2.985.77-5.742 0-8.727-.086-.256.114-.426.342-.37m1.169 10.576v.483c0 2.246-1.568 3.894-3.506 3.894a3.474 3.474 0 0 1-3.477-3.496c0-1.933 1.567-3.468 3.762-3.468h.57V7.078c-.285-.028-.57-.028-.855-.028C9.618 7.05 5 11.655 5 17.37c0 5.713 4.617 10.29 10.318 10.29s10.346-4.605 10.346-10.29v-.91z\"/>\n    </svg>");
};
var $4f72d54064feed25$export$21bfbeb62fdcce8d = function JiraProductDiscoveryIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Jira Product Discovery' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $4695b20c010af541$export$438460117ae6b7ee).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $4695b20c010af541$export$438460117ae6b7ee).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $4695b20c010af541$export$438460117ae6b7ee).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $fdb77cc968262235$export$2e2bcd8739ae039)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $246be689d43c2dd2$export$2e2bcd8739ae039), {
        appearance: appearance,
        label: label,
        svg: $4f72d54064feed25$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};


var $5FkrB = parcelRequire("5FkrB");




var $d4ffd9e5f2cef8fe$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $244fe5cbdef580ed$export$bbacc3980e0f3029)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" viewBox=\"0 0 318 32\" focusable=\"false\" aria-hidden=\"true\" xmlns=\"http://www.w3.org/2000/svg\">\n      <path fill=\"".concat(colors.iconColor, "\" d=\"M12.655 5.218a15.3 15.3 0 0 0 8.75 0c.257-.057.428.114.37.37-.826 2.984-.826 5.742 0 8.727.058.227-.113.426-.37.341a16.33 16.33 0 0 0-8.75 0c-.228.085-.428-.114-.342-.341.77-2.985.77-5.743 0-8.727-.086-.256.114-.427.342-.37m1.169 10.575v.483c0 2.246-1.568 3.895-3.506 3.895a3.474 3.474 0 0 1-3.478-3.497c0-1.933 1.568-3.468 3.763-3.468h.57V6.412c-.285-.028-.57-.028-.855-.028C4.618 6.384 0 10.989 0 16.703s4.617 10.29 10.318 10.29 10.346-4.605 10.346-10.29v-.91z\" />\n      <path fill=\"").concat(colors.textColor, "\" d=\"M308.551 24.559h-1.718l-5.55-14.352h2.821l4.907 13.125 4.906-13.125h2.822l-5.796 14.843c-1.718 4.385-2.699 6.654-6.594 6.654-1.318 0-2.054-.122-2.821-.429v-2.27c.889.277 1.901.369 2.668.369 2.147 0 3.097-1.472 4.355-4.815m-13.247-8.065v9.047h-2.576V10.207h2.576v2.699c.889-1.81 2.422-3.097 5.428-2.913v2.576c-3.374-.338-5.428.674-5.428 3.925m-12.464-4.202c-2.79 0-4.201 1.81-4.477 4.478h8.556c-.153-2.852-1.441-4.478-4.079-4.478m5.888 12.635c-1.257.675-3.189.92-4.753.92-5.735 0-8.249-3.312-8.249-8.004 0-4.63 2.576-7.943 7.237-7.943 4.723 0 6.624 3.282 6.624 7.943v1.196h-11.193c.368 2.607 2.054 4.293 5.673 4.293 1.779 0 3.281-.337 4.661-.828zm-19.717.613h-3.527l-5.949-15.333h2.76l4.968 13.095 4.937-13.095h2.76zm-17.462.307c-4.6 0-7.299-3.404-7.299-8.004s2.699-7.943 7.299-7.943c4.569 0 7.237 3.343 7.237 7.943s-2.668 8.004-7.237 8.004m0-13.493c-3.281 0-4.723 2.576-4.723 5.49 0 2.912 1.442 5.55 4.723 5.55 3.251 0 4.661-2.638 4.661-5.55 0-2.914-1.41-5.49-4.661-5.49M242.16 22.78v2.362c-.92.49-2.331.705-3.742.705-5.458 0-8.004-3.312-8.004-8.004 0-4.63 2.546-7.943 8.004-7.943 1.38 0 2.454.184 3.65.736v2.454c-.982-.46-2.024-.736-3.466-.736-3.986 0-5.612 2.514-5.612 5.49 0 2.974 1.656 5.488 5.674 5.488 1.564 0 2.545-.214 3.496-.552m-13.872-1.41c0 2.545-1.656 4.477-5.765 4.477-2.3 0-4.171-.521-5.336-1.135v-2.79c1.319.766 3.527 1.502 5.459 1.502 2.024 0 3.066-.828 3.066-2.024 0-1.165-.889-1.84-3.802-2.545-3.404-.828-4.846-2.147-4.846-4.661 0-2.668 2.055-4.294 5.551-4.294 1.993 0 3.803.491 4.937 1.104v2.73c-1.84-.92-3.342-1.41-4.968-1.41-1.932 0-2.974.674-2.974 1.87 0 1.073.736 1.748 3.557 2.422 3.404.828 5.121 2.086 5.121 4.754M210.599 6.16c0-1.166.767-1.84 1.84-1.84s1.84.674 1.84 1.84-.767 1.84-1.84 1.84-1.84-.675-1.84-1.84m.491 19.38V10.208h2.637v15.334zM198.344 8.03h-4.539v14.873h4.692c4.6 0 6.9-2.422 6.9-7.298 0-4.907-2.177-7.575-7.053-7.575m-7.299 17.51V5.394h7.422c6.532 0 9.69 4.078 9.69 10.12 0 6.102-3.189 10.028-9.69 10.028zm-13.411-4.753c0 1.35.797 2.27 2.422 2.27.614 0 1.196-.123 1.656-.215v2.545c-.46.123-.981.245-1.778.245-3.282 0-4.876-1.932-4.876-4.784v-8.187h-2.484v-2.454h2.484v-3.25h2.576v3.25h4.078v2.453h-4.078zm-6.66 1.993v2.362c-.92.49-2.331.705-3.742.705-5.458 0-8.004-3.312-8.004-8.004 0-4.63 2.546-7.943 8.004-7.943 1.38 0 2.454.184 3.65.736v2.454c-.982-.46-2.024-.736-3.466-.736-3.986 0-5.612 2.514-5.612 5.49 0 2.974 1.656 5.488 5.674 5.488 1.564 0 2.545-.214 3.496-.552m-27.843-3.588v-8.985h2.637v9.261c0 2.76 1.104 3.987 3.619 3.987 2.453 0 4.14-1.625 4.14-4.723v-8.525h2.637V25.54h-2.637v-2.514c-.982 1.809-2.791 2.821-4.846 2.821-3.526 0-5.55-2.423-5.55-6.655m-14.987-1.318c0 3.68 1.472 5.52 4.202 5.52 2.361 0 4.477-1.503 4.477-4.907V17.26c0-3.404-1.932-4.906-4.171-4.906-2.974 0-4.508 1.962-4.508 5.52m8.679 7.667v-2.76c-.981 2.023-2.821 3.066-5.183 3.066-4.078 0-6.133-3.465-6.133-7.973 0-4.324 2.147-7.973 6.44-7.973 2.239 0 3.956 1.012 4.876 3.005V3.798h2.637V25.54zm-20.698.306c-4.6 0-7.299-3.404-7.299-8.004s2.699-7.943 7.299-7.943c4.569 0 7.237 3.343 7.237 7.943s-2.668 8.004-7.237 8.004m0-13.493c-3.282 0-4.723 2.576-4.723 5.49 0 2.912 1.441 5.55 4.723 5.55 3.25 0 4.661-2.638 4.661-5.55 0-2.914-1.411-5.49-4.661-5.49m-13.776 4.14v9.047h-2.576V10.207h2.576v2.699c.89-1.81 2.423-3.097 5.428-2.913v2.576c-3.373-.338-5.428.674-5.428 3.925m-5.002-4.385c0 4.385-2.454 6.838-7.483 6.838h-4.017v6.594h-2.76V5.393h6.777c5.03 0 7.483 2.576 7.483 6.716m-7.79 4.2c3.558.124 4.938-1.563 4.938-4.14 0-2.452-1.38-4.14-4.938-4.14h-3.71v8.28zM61.69 17.874c0 3.68 1.472 5.52 4.201 5.52 2.361 0 4.477-1.503 4.477-4.907V17.26c0-3.404-1.931-4.906-4.17-4.906-2.975 0-4.508 1.962-4.508 5.52m8.679 7.666v-2.76c-.982 2.024-2.822 3.067-5.183 3.067-4.079 0-6.134-3.465-6.134-7.973 0-4.324 2.147-7.974 6.44-7.974 2.24 0 3.957 1.012 4.877 3.006v-2.699h2.637V25.54zm-17.793-9.046v9.047H50V10.207h2.576v2.699c.89-1.81 2.423-3.097 5.428-2.913v2.576c-3.373-.338-5.428.674-5.428 3.925M42.89 6.16c0-1.166.767-1.84 1.84-1.84s1.84.674 1.84 1.84S45.805 8 44.73 8s-1.84-.675-1.84-1.84m.491 19.38V10.208h2.638v15.334zm-6.428-5.949V5.393h2.76v14.014c0 3.71-1.625 6.256-5.428 6.256-1.441 0-2.545-.245-3.312-.521v-2.668c.828.337 1.84.521 2.852.521 2.331 0 3.128-1.41 3.128-3.404\" />\n    </svg>");
};
var $d4ffd9e5f2cef8fe$export$c49a2b642fe9eef4 = function JiraProductDiscoveryLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Jira Product Discovery' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $4695b20c010af541$export$438460117ae6b7ee).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $4695b20c010af541$export$438460117ae6b7ee).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $4695b20c010af541$export$438460117ae6b7ee).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $fdb77cc968262235$export$2e2bcd8739ae039)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $246be689d43c2dd2$export$2e2bcd8739ae039), {
        appearance: appearance,
        label: label,
        iconColor: iconColor,
        size: size,
        svg: $d4ffd9e5f2cef8fe$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};



var $5FkrB = parcelRequire("5FkrB");




var $f91c71cad280ca7f$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor;
    var colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $244fe5cbdef580ed$export$bbacc3980e0f3029)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" viewBox=\"0 0 32 32\" focusable=\"false\" aria-hidden=\"true\" xmlns=\"http://www.w3.org/2000/svg\">\n      <path fill=".concat(colors.iconColor, " d=\"M18.79 13.257h7.325c1.1 0 1.476 1.046.805 1.878L15.464 29.274c-3.702-2.951-3.353-7.62-.644-11.027zm-5.66 5.634H5.806c-1.1 0-1.476-1.046-.805-1.878L16.457 2.874c3.702 2.951 3.3 7.566.617 11z\"/>\n    </svg>");
};
var $f91c71cad280ca7f$export$3c6158790f5e01c4 = function JiraServiceManagementIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Jira Service Management' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $4695b20c010af541$export$438460117ae6b7ee).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $4695b20c010af541$export$438460117ae6b7ee).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $4695b20c010af541$export$438460117ae6b7ee).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $fdb77cc968262235$export$2e2bcd8739ae039)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $246be689d43c2dd2$export$2e2bcd8739ae039), {
        appearance: appearance,
        label: label,
        svg: $f91c71cad280ca7f$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};


var $5FkrB = parcelRequire("5FkrB");




var $07206c874cffd34a$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $244fe5cbdef580ed$export$bbacc3980e0f3029)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" viewBox=\"0 0 362 32\" focusable=\"false\" aria-hidden=\"true\" xmlns=\"http://www.w3.org/2000/svg\">\n      <path fill=".concat(colors.iconColor, " d=\"M14.124 13.257h7.325c1.1 0 1.475 1.046.804 1.878L10.798 29.274c-3.702-2.951-3.353-7.62-.644-11.027zm-5.66 5.634H1.138c-1.1 0-1.476-1.046-.805-1.878L11.79 2.874c3.703 2.951 3.3 7.566.617 11z\" />\n      <path fill=").concat(colors.textColor, " d=\"M357.074 20.787c0 1.35.797 2.27 2.422 2.27.614 0 1.196-.123 1.656-.215v2.545c-.46.123-.981.245-1.778.245-3.282 0-4.876-1.932-4.876-4.784v-8.187h-2.484v-2.454h2.484v-3.25h2.576v3.25h4.078v2.453h-4.078zm-7.327-4.231v8.985h-2.638V16.28c0-2.76-1.104-3.987-3.618-3.987-2.454 0-4.14 1.625-4.14 4.723v8.525h-2.638V10.208h2.638v2.514c.981-1.81 2.79-2.821 4.845-2.821 3.527 0 5.551 2.423 5.551 6.655m-22.921-4.263c-2.791 0-4.201 1.81-4.477 4.477h8.556c-.154-2.852-1.442-4.477-4.079-4.477m5.888 12.635c-1.257.674-3.189.92-4.753.92-5.735 0-8.25-3.312-8.25-8.004 0-4.631 2.576-7.943 7.238-7.943 4.722 0 6.624 3.281 6.624 7.943v1.196h-11.194c.368 2.606 2.055 4.293 5.674 4.293 1.778 0 3.281-.337 4.661-.828zm-26.152-7.912v8.525h-2.637V16.28c0-2.76-1.104-3.987-3.619-3.987-2.453 0-4.14 1.625-4.14 4.723v8.525h-2.637V10.208h2.637v2.514c.981-1.81 2.79-2.821 4.845-2.821 2.607 0 4.385 1.319 5.152 3.741.859-2.361 2.913-3.741 5.459-3.741 3.434 0 5.336 2.33 5.336 6.655v8.985h-2.638v-8.525c0-3.16-1.104-4.723-3.618-4.723-2.454 0-4.14 1.625-4.14 4.723m-22.921-4.723c-2.79 0-4.201 1.81-4.477 4.477h8.556c-.153-2.852-1.441-4.477-4.079-4.477m5.888 12.635c-1.257.674-3.189.92-4.753.92-5.735 0-8.25-3.312-8.25-8.004 0-4.631 2.577-7.943 7.238-7.943 4.723 0 6.624 3.281 6.624 7.943v1.196h-11.193c.368 2.606 2.054 4.293 5.673 4.293 1.779 0 3.281-.337 4.661-.828zm-18.638-.614v-1.533c-.982 2.024-2.822 3.067-5.183 3.067-4.048 0-6.072-3.466-6.072-7.974 0-4.324 2.116-7.973 6.379-7.973 2.238 0 3.956 1.012 4.876 3.005v-2.698h2.576V24.16c0 4.508-2.116 7.544-7.606 7.544-2.576 0-3.986-.337-5.458-.828V28.3c1.686.552 3.434.92 5.336.92 3.833 0 5.152-2.055 5.152-4.907m-8.679-6.44c0 3.68 1.472 5.52 4.201 5.52 2.362 0 4.478-1.503 4.478-4.906V17.26c0-3.404-1.932-4.907-4.171-4.907-2.975 0-4.508 1.963-4.508 5.52m-16.949.001c0 3.68 1.472 5.52 4.201 5.52 2.361 0 4.477-1.503 4.477-4.906V17.26c0-3.404-1.932-4.907-4.17-4.907-2.975 0-4.508 1.963-4.508 5.52m8.678 7.667v-2.76c-.981 2.024-2.821 3.066-5.182 3.066-4.079 0-6.134-3.465-6.134-7.973 0-4.324 2.147-7.973 6.44-7.973 2.239 0 3.956 1.012 4.876 3.005v-2.699h2.638V25.54zm-14.073-8.984v8.985h-2.638V16.28c0-2.76-1.104-3.987-3.618-3.987-2.454 0-4.14 1.625-4.14 4.723v8.525h-2.638V10.208h2.638v2.514c.981-1.81 2.79-2.821 4.845-2.821 3.527 0 5.551 2.423 5.551 6.655m-28.327 1.318c0 3.68 1.472 5.52 4.202 5.52 2.361 0 4.477-1.503 4.477-4.906V17.26c0-3.404-1.932-4.907-4.171-4.907-2.974 0-4.508 1.963-4.508 5.52m8.679 7.667v-2.76c-.981 2.024-2.821 3.066-5.183 3.066-4.078 0-6.133-3.465-6.133-7.973 0-4.324 2.147-7.973 6.44-7.973 2.239 0 3.956 1.012 4.876 3.005v-2.699h2.637V25.54zm-31.445-11.009-2.76-7.482V25.54h-2.76V5.393h4.784l4.569 11.56 1.871 5.552 1.87-5.551 4.6-11.561h4.447V25.54h-2.76V7.263l-2.361 7.268-4.447 11.01h-2.668zm-21.511-2.238c-2.791 0-4.202 1.81-4.478 4.477h8.556c-.153-2.852-1.441-4.477-4.078-4.477m5.888 12.635c-1.258.674-3.19.92-4.754.92-5.734 0-8.249-3.312-8.249-8.004 0-4.631 2.576-7.943 7.237-7.943 4.723 0 6.624 3.281 6.624 7.943v1.196h-11.193c.368 2.606 2.055 4.293 5.673 4.293 1.779 0 3.282-.337 4.662-.828zm-15.094-2.148v2.362c-.92.49-2.33.705-3.741.705-5.459 0-8.004-3.312-8.004-8.004 0-4.63 2.545-7.942 8.004-7.942 1.38 0 2.453.184 3.649.736v2.453c-.981-.46-2.024-.736-3.465-.736-3.987 0-5.612 2.515-5.612 5.49s1.656 5.489 5.673 5.489c1.564 0 2.546-.215 3.496-.552M140.124 6.16c0-1.166.766-1.84 1.84-1.84 1.073 0 1.84.674 1.84 1.84S143.037 8 141.964 8c-1.074 0-1.84-.675-1.84-1.84m.49 19.38V10.208h2.638v15.334zm-8.233 0h-3.527l-5.949-15.332h2.76l4.968 13.094 4.937-13.094h2.76zm-15.455-9.046v9.047h-2.576V10.207h2.576v2.699c.889-1.81 2.423-3.097 5.428-2.913v2.576c-3.373-.338-5.428.674-5.428 3.925m-12.463-4.201c-2.791 0-4.202 1.81-4.478 4.477h8.556c-.153-2.852-1.441-4.477-4.078-4.477m5.888 12.635c-1.258.674-3.19.92-4.754.92-5.734 0-8.249-3.312-8.249-8.004 0-4.631 2.576-7.943 7.237-7.943 4.723 0 6.624 3.281 6.624 7.943v1.196h-11.193c.368 2.606 2.055 4.293 5.673 4.293 1.779 0 3.282-.337 4.662-.828zM95.024 19.99c0 3.496-2.085 5.857-7.084 5.857-3.894 0-5.704-.766-7.268-1.564v-2.821c1.87.981 4.754 1.687 7.422 1.687 3.036 0 4.17-1.196 4.17-2.975s-1.104-2.73-4.937-3.65c-4.539-1.103-6.563-2.667-6.563-5.98 0-3.127 2.392-5.458 7.084-5.458 2.914 0 4.784.705 6.164 1.472v2.76c-2.024-1.165-4.201-1.533-6.286-1.533-2.638 0-4.202.92-4.202 2.76 0 1.656 1.288 2.484 4.845 3.373 4.263 1.073 6.655 2.453 6.655 6.072m-34.001-2.116c0 3.68 1.472 5.52 4.201 5.52 2.362 0 4.478-1.503 4.478-4.906V17.26c0-3.404-1.932-4.907-4.17-4.907-2.975 0-4.509 1.963-4.509 5.52m8.679 7.667v-2.76c-.981 2.024-2.821 3.066-5.183 3.066-4.078 0-6.133-3.465-6.133-7.973 0-4.324 2.147-7.973 6.44-7.973 2.239 0 3.956 1.012 4.876 3.005v-2.699h2.637V25.54zM51.91 16.494v9.047h-2.577V10.207h2.576v2.699c.89-1.81 2.423-3.097 5.428-2.913v2.576c-3.373-.338-5.428.674-5.428 3.925M42.224 6.16c0-1.166.767-1.84 1.84-1.84s1.84.674 1.84 1.84S45.137 8 44.064 8s-1.84-.675-1.84-1.84m.49 19.38V10.208h2.638v15.334zm-6.427-5.949V5.393h2.76v14.014c0 3.71-1.626 6.256-5.428 6.256-1.442 0-2.546-.245-3.312-.521v-2.668c.828.337 1.84.521 2.852.521 2.33 0 3.128-1.41 3.128-3.404\" />\n    </svg>");
};
var $07206c874cffd34a$export$dabef2be6cd28c20 = function JiraServiceManagementLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Jira Service Management' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $4695b20c010af541$export$438460117ae6b7ee).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $4695b20c010af541$export$438460117ae6b7ee).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $4695b20c010af541$export$438460117ae6b7ee).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $fdb77cc968262235$export$2e2bcd8739ae039)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $246be689d43c2dd2$export$2e2bcd8739ae039), {
        appearance: appearance,
        label: label,
        iconColor: iconColor,
        size: size,
        svg: $07206c874cffd34a$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};



var $5FkrB = parcelRequire("5FkrB");




var $3ddf4511117ec2bd$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor;
    var colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $244fe5cbdef580ed$export$7818df200941dbbf)(appearance, colorMode);
    return "<svg\n    fill=\"none\"\n    height=\"32\"\n    viewBox=\"0 0 32 32\"\n    xmlns=\"http://www.w3.org/2000/svg\"\n    focusable=\"false\"\n    aria-hidden=\"true\"\n  >\n    <path\n      d=\"M27.333 15.508h-6.628l5.74-3.315-1.26-2.184-5.74 3.314 3.313-5.74-2.184-1.26-3.313 5.74V5.434h-2.522v6.628l-3.314-5.74-2.184 1.26 3.314 5.74-5.74-3.314-1.26 2.184 5.74 3.314H4.667v2.521h6.627l-5.74 3.314 1.261 2.184 5.74-3.313-3.314 5.74 2.184 1.26 3.314-5.74V28.1h2.521v-6.627l3.313 5.74 2.184-1.261-3.314-5.74 5.74 3.313 1.261-2.184-5.74-3.313h6.628zM16 20.198a3.442 3.442 0 1 1 0-6.885 3.442 3.442 0 0 1 0 6.884\"\n      fill=\"".concat(colors.iconColor, "\"\n    />\n  </svg>");
};
var $3ddf4511117ec2bd$export$8d789f76fde3e05 = function LoomIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Loom' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $4695b20c010af541$export$438460117ae6b7ee).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $4695b20c010af541$export$438460117ae6b7ee).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $4695b20c010af541$export$438460117ae6b7ee).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $fdb77cc968262235$export$2e2bcd8739ae039)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $246be689d43c2dd2$export$2e2bcd8739ae039), {
        appearance: appearance,
        label: label,
        svg: $3ddf4511117ec2bd$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};


var $5FkrB = parcelRequire("5FkrB");




var $63d22dd409edae8e$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $244fe5cbdef580ed$export$7818df200941dbbf)(appearance, colorMode);
    return "<svg\n      fill=\"none\"\n      height=\"32\"\n      xmlns=\"http://www.w3.org/2000/svg\"\n      viewBox=\"0 0 98 32\"\n      focusable=\"false\"\n      aria-hidden=\"true\"\n    >\n      <path\n        d=\"M29.657 13.659h-8.672l7.51-4.337-1.649-2.857-7.51 4.336 4.335-7.51-2.857-1.65-4.336 7.51V.479H13.18v8.672l-4.337-7.51-2.856 1.65 4.336 7.51-7.51-4.336-1.65 2.857 7.51 4.336H0v3.299h8.671l-7.51 4.336 1.65 2.858 7.51-4.336-4.336 7.51 2.857 1.65 4.336-7.511v8.672h3.3v-8.671l4.335 7.51 2.857-1.65-4.336-7.51 7.51 4.336 1.65-2.858-7.51-4.335h8.672v-3.3zM14.83 19.794a4.503 4.503 0 1 1 0-9.006 4.503 4.503 0 0 1 0 9.006\"\n        fill=\"".concat(colors.iconColor, "\"\n      />\n      <path\n        d=\"M37.303 26.155V4.459h3.983v21.696zm38.204-14.743h3.803v1.798c.808-1.438 2.696-2.218 4.313-2.218 2.007 0 3.624.87 4.373 2.457 1.167-1.798 2.726-2.457 4.673-2.457 2.725 0 5.33 1.648 5.33 5.604v9.559h-3.862v-8.75c0-1.588-.78-2.786-2.607-2.786-1.707 0-2.726 1.318-2.726 2.907v8.63H84.85v-8.75c0-1.59-.808-2.787-2.606-2.787-1.738 0-2.757 1.288-2.757 2.907v8.63h-3.981zm-25.219 15.17c-4.487 0-7.737-3.328-7.737-7.798 0-4.4 3.24-7.806 7.737-7.806 4.52 0 7.737 3.439 7.737 7.806 0 4.438-3.251 7.798-7.737 7.798m0-11.996a4.2 4.2 0 0 0-4.197 4.199c0 2.315 1.883 4.199 4.197 4.199s4.196-1.884 4.196-4.2a4.2 4.2 0 0 0-4.196-4.198m16.245 11.996c-4.487 0-7.737-3.328-7.737-7.798 0-4.4 3.24-7.806 7.737-7.806 4.52 0 7.737 3.439 7.737 7.806 0 4.438-3.253 7.798-7.737 7.798m0-12.046c-2.34 0-4.245 1.906-4.245 4.247s1.904 4.247 4.245 4.247a4.25 4.25 0 0 0 4.245-4.247 4.25 4.25 0 0 0-4.245-4.247\"\n        fill=\"").concat(colors.textColor, "\"\n      />\n    </svg>");
};
var $63d22dd409edae8e$export$94e206806e36c2ec = function LoomLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Loom' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $4695b20c010af541$export$438460117ae6b7ee).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $4695b20c010af541$export$438460117ae6b7ee).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $4695b20c010af541$export$438460117ae6b7ee).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $fdb77cc968262235$export$2e2bcd8739ae039)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $246be689d43c2dd2$export$2e2bcd8739ae039), {
        appearance: appearance,
        label: label,
        iconColor: iconColor,
        size: size,
        svg: $63d22dd409edae8e$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};



var $5FkrB = parcelRequire("5FkrB");


var $254ae2e514074c6b$export$1bf47cdade1a9fcb = function LoomAttributionIcon(_ref) {
    var appearance = _ref.appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Loom Attribution' : _ref$label, _ref$size = _ref.size, size = _ref$size === void 0 ? (0, $4695b20c010af541$export$438460117ae6b7ee).size : _ref$size, testId = _ref.testId, _ref$iconColor = _ref.iconColor, iconColor = _ref$iconColor === void 0 ? (0, $4695b20c010af541$export$438460117ae6b7ee).iconColor : _ref$iconColor, _ref$textColor = _ref.textColor, textColor = _ref$textColor === void 0 ? (0, $4695b20c010af541$export$438460117ae6b7ee).textColor : _ref$textColor;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $3ddf4511117ec2bd$export$8d789f76fde3e05), {
        appearance: appearance,
        label: label,
        size: size,
        testId: testId,
        iconColor: iconColor,
        textColor: textColor
    });
};


var $5FkrB = parcelRequire("5FkrB");




var $c779b4e9d6dc1521$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $244fe5cbdef580ed$export$7818df200941dbbf)(appearance, colorMode);
    return "<svg\n\t\tfill=\"none\"\n\t\theight=\"32\"\n\t\txmlns=\"http://www.w3.org/2000/svg\"\n\t\tfocusable=\"false\"\n\t\taria-hidden=\"true\"\n\t\tviewBox=\"0 0 88 32\"\n\t>\n\t\t<path\n\t\t\td=\"M29.488 12.765h-8.983l7.78-4.344-1.544-2.585-7.78 4.344 4.492-7.523-2.674-1.493-4.491 7.522V0H13.2v8.687L8.71 1.164 6.035 2.657l4.49 7.522-7.778-4.343L1.204 8.42l7.779 4.344H0v2.986h8.982l-7.778 4.343 1.543 2.585 7.78-4.342-4.492 7.522 2.674 1.493L13.2 19.83v8.687h3.087v-8.873l4.574 7.663 2.507-1.4-4.575-7.663 7.946 4.437 1.544-2.586-7.779-4.343h8.982v-2.986h.001Zm-14.744 5.552c-2.318 0-4.197-1.817-4.197-4.059s1.88-4.059 4.197-4.059 4.198 1.817 4.198 4.06c0 2.24-1.88 4.058-4.198 4.058\"\n\t\t\tfill=\"".concat(colors.iconColor, "\"\n\t\t/>\n\t\t<path\n\t\t\td=\"M38.379 26.847V10.094h3.18v16.753zm30.503-11.79h3.036v1.438c.646-1.15 2.153-1.773 3.444-1.773 1.602 0 2.893.695 3.49 1.964.932-1.438 2.177-1.964 3.731-1.964 2.175 0 4.256 1.318 4.256 4.48v7.642h-3.084V19.85c0-1.27-.623-2.228-2.081-2.228-1.363 0-2.177 1.054-2.177 2.324v6.9h-3.155V19.85c0-1.27-.646-2.228-2.081-2.228-1.387 0-2.2 1.03-2.2 2.324v6.9h-3.18V15.057Zm-20.134 12.13c-3.582 0-6.176-2.66-6.176-6.234 0-3.517 2.585-6.242 6.176-6.242 3.609 0 6.177 2.75 6.177 6.242 0 3.547-2.596 6.234-6.177 6.234m0-9.59a3.357 3.357 0 0 0 0 6.713 3.357 3.357 0 0 0 0-6.713m12.966 9.59c-3.583 0-6.177-2.66-6.177-6.234 0-3.517 2.586-6.242 6.177-6.242 3.608 0 6.176 2.75 6.176 6.242 0 3.547-2.597 6.234-6.176 6.234m0-9.63a3.397 3.397 0 0 0-3.39 3.395 3.397 3.397 0 0 0 3.39 3.395 3.396 3.396 0 0 0 0-6.79M64.933 5.63c0-1.102-.697-1.522-1.983-1.837-.803-.21-1.018-.368-1.018-.63q0-.473.804-.473c.643 0 1.286.21 1.93.473V1.798a4.5 4.5 0 0 0-1.876-.42c-1.447 0-2.25.682-2.25 1.785 0 1.05.696 1.575 1.928 1.838.804.157 1.072.315 1.072.682 0 .263-.215.473-.804.473a4.46 4.46 0 0 1-2.197-.63v1.417c.483.263 1.233.473 2.197.473 1.5.052 2.197-.683 2.197-1.785Zm16.662-4.067v5.988h1.3V3.007l.542 1.23 1.841 3.368h1.626V1.563h-1.3v3.85l-.488-1.123-1.463-2.727zm-8.056 0h-1.465v6.042h1.465zm-23.981 0v6.042h2.863l.432-1.295h-1.945V1.563zm-5.671 0v1.295h1.604v4.747h1.44V2.858h1.715V1.563zm-2.177 0h-1.802l-2.066 6.042h1.59l.317-1.025a4 4 0 0 0 1.113.162q.556 0 1.113-.162l.318 1.025h1.59zm-.9 3.938a3 3 0 0 1-.743-.108l.742-2.643.742 2.643c-.265.054-.477.108-.742.108Zm16.577-3.938H55.53L53.4 7.605h1.638l.328-1.025q.573.162 1.146.162.574 0 1.147-.162l.328 1.025h1.638l-2.24-6.042Zm-.928 3.938c-.273 0-.546-.054-.765-.108l.765-2.643.764 2.643a3.3 3.3 0 0 1-.764.108m21.98-3.938h-1.857l-2.13 6.042h1.638l.328-1.025q.574.162 1.147.162c.573 0 .764-.054 1.146-.162l.328 1.025h1.638zm-.93 3.938c-.272 0-.545-.054-.763-.108l.764-2.643.765 2.643a3.3 3.3 0 0 1-.765.108Zm-6.894.129c0-1.102-.697-1.522-1.983-1.837-.803-.21-1.018-.368-1.018-.63q0-.473.804-.473c.643 0 1.286.21 1.93.473V1.798a4.5 4.5 0 0 0-1.876-.42c-1.447 0-2.25.682-2.25 1.785 0 1.05.696 1.575 1.928 1.838.804.157 1.072.315 1.072.682 0 .263-.215.473-.804.473-.75 0-1.608-.263-2.197-.63v1.417c.482.263 1.233.473 2.197.473 1.447.052 2.197-.683 2.197-1.785Z\"\n\t\t\tfill=\"").concat(colors.textColor, "\"\n\t\t/>\n\t</svg>");
};
var $c779b4e9d6dc1521$export$6e87ce8d41eda665 = function LoomAttributionLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Loom Attribution' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $4695b20c010af541$export$438460117ae6b7ee).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $4695b20c010af541$export$438460117ae6b7ee).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $4695b20c010af541$export$438460117ae6b7ee).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $fdb77cc968262235$export$2e2bcd8739ae039)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $246be689d43c2dd2$export$2e2bcd8739ae039), {
        appearance: appearance,
        label: label,
        iconColor: iconColor,
        size: size,
        svg: $c779b4e9d6dc1521$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};



var $5FkrB = parcelRequire("5FkrB");




var $dd57b5534d9c8bad$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor;
    var colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $244fe5cbdef580ed$export$bbacc3980e0f3029)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" viewBox=\"0 0 32 32\" focusable=\"false\" aria-hidden=\"true\" xmlns=\"http://www.w3.org/2000/svg\">\n      <path fill=\"".concat(colors.iconColor, "\" d=\"M17.114 28.127c-.785.578-1.199.537-1.984-.041-3.8-2.727-7.313-5.826-9.668-9.049-.248-.33-.124-.785.248-.991l4.297-2.686q.558-.372.992.124c1.652 1.9 3.264 3.76 5.123 5.082 1.86-1.322 3.47-3.181 5.123-5.082q.434-.495.992-.124l4.297 2.686c.372.206.496.66.248.991-2.355 3.223-5.867 6.322-9.668 9.09m-.992-11.858c3.388 0 6.198-2.768 6.198-6.156s-2.81-6.239-6.198-6.239-6.198 2.81-6.198 6.239c0 3.43 2.727 6.156 6.198 6.156\"/>\n    </svg>");
};
var $dd57b5534d9c8bad$export$eeccc49dc7a12d9f = function OpsgenieIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Opsgenie' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $4695b20c010af541$export$438460117ae6b7ee).size : _ref2$size, testId = _ref2.testId, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $4695b20c010af541$export$438460117ae6b7ee).textColor : _ref2$textColor, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $4695b20c010af541$export$438460117ae6b7ee).iconColor : _ref2$iconColor;
    var _useThemeObserver = (0, $fdb77cc968262235$export$2e2bcd8739ae039)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $246be689d43c2dd2$export$2e2bcd8739ae039), {
        appearance: appearance,
        svg: $dd57b5534d9c8bad$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        label: label,
        size: size,
        testId: testId,
        textColor: textColor
    });
};


var $5FkrB = parcelRequire("5FkrB");




var $dd86d607cf9e8d92$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $244fe5cbdef580ed$export$bbacc3980e0f3029)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" viewBox=\"0 0 154 32\" focusable=\"false\" aria-hidden=\"true\" xmlns=\"http://www.w3.org/2000/svg\">\n      <path fill=\"".concat(colors.iconColor, "\" d=\"M11.78 28.127c-.785.578-1.198.537-1.983-.041-3.801-2.727-7.313-5.826-9.668-9.049-.248-.33-.124-.785.248-.991l4.297-2.686q.558-.372.991.124c1.653 1.9 3.264 3.76 5.124 5.082 1.859-1.322 3.47-3.181 5.123-5.082q.435-.495.992-.124l4.297 2.686c.371.206.495.66.247.991-2.355 3.223-5.867 6.322-9.668 9.09m-.99-11.857c3.388 0 6.197-2.768 6.197-6.156s-2.81-6.239-6.197-6.239-6.198 2.81-6.198 6.239c0 3.43 2.727 6.156 6.198 6.156\"/>\n      <path fill=\"").concat(colors.textColor, "\" d=\"M146.689 12.293c-2.79 0-4.201 1.81-4.477 4.477h8.556c-.153-2.852-1.441-4.477-4.079-4.477m5.888 12.635c-1.257.674-3.189.92-4.753.92-5.735 0-8.249-3.312-8.249-8.004 0-4.631 2.576-7.943 7.237-7.943 4.723 0 6.624 3.281 6.624 7.943v1.196h-11.193c.368 2.606 2.054 4.293 5.673 4.293 1.779 0 3.281-.337 4.661-.828zM133.385 6.16c0-1.166.767-1.84 1.841-1.84s1.84.674 1.84 1.84-.767 1.84-1.84 1.84c-1.074 0-1.841-.675-1.841-1.84m.491 19.38V10.208h2.638v15.334zm-3.677-8.984v8.985h-2.638V16.28c0-2.76-1.104-3.987-3.618-3.987-2.454 0-4.14 1.625-4.14 4.723v8.525h-2.638V10.208h2.638v2.514c.981-1.81 2.79-2.821 4.845-2.821 3.527 0 5.551 2.423 5.551 6.655m-22.921-4.263c-2.791 0-4.201 1.81-4.477 4.477h8.556c-.154-2.852-1.442-4.477-4.079-4.477m5.888 12.635c-1.257.674-3.189.92-4.753.92-5.735 0-8.25-3.312-8.25-8.004 0-4.631 2.576-7.943 7.238-7.943 4.722 0 6.624 3.281 6.624 7.943v1.196h-11.194c.368 2.606 2.055 4.293 5.674 4.293 1.778 0 3.281-.337 4.661-.828zm-18.639-.614v-1.533c-.981 2.024-2.821 3.067-5.182 3.067-4.048 0-6.072-3.466-6.072-7.974 0-4.324 2.116-7.973 6.378-7.973 2.239 0 3.956 1.012 4.876 3.005v-2.698h2.576V24.16c0 4.508-2.116 7.544-7.605 7.544-2.576 0-3.987-.337-5.459-.828V28.3c1.687.552 3.435.92 5.336.92 3.834 0 5.152-2.055 5.152-4.907m-8.678-6.44c0 3.68 1.472 5.52 4.2 5.52 2.362 0 4.478-1.503 4.478-4.906V17.26c0-3.404-1.932-4.907-4.17-4.907-2.975 0-4.508 1.963-4.508 5.52m-4.703 3.497c0 2.545-1.656 4.477-5.765 4.477-2.3 0-4.17-.52-5.336-1.134v-2.79c1.319.766 3.527 1.502 5.459 1.502 2.024 0 3.066-.828 3.066-2.024 0-1.165-.89-1.84-3.802-2.545-3.404-.829-4.846-2.147-4.846-4.662 0-2.668 2.055-4.293 5.55-4.293 1.994 0 3.804.49 4.938 1.104v2.73c-1.84-.92-3.342-1.411-4.968-1.411-1.932 0-2.974.674-2.974 1.87 0 1.073.736 1.748 3.557 2.423 3.404.828 5.121 2.085 5.121 4.753m-16.274-3.496c0-3.68-1.472-5.52-4.202-5.52-2.36 0-4.477 1.503-4.477 4.907v1.227c0 3.404 1.932 4.906 4.17 4.906 2.975 0 4.509-1.962 4.509-5.52m-3.803 7.974c-2.239 0-3.956-1.013-4.876-3.006v8.679h-2.637V10.207h2.637v2.76c.981-2.024 2.821-3.066 5.183-3.066 4.079 0 6.133 3.465 6.133 7.973 0 4.324-2.147 7.973-6.44 7.973m-20.121 0c-6.225 0-9.721-4.293-9.721-10.426 0-6.072 3.496-10.335 9.721-10.335 6.195 0 9.69 4.263 9.69 10.335 0 6.133-3.495 10.426-9.69 10.426m0-18.124c-4.968 0-6.961 3.527-6.961 7.698 0 4.262 1.993 7.789 6.961 7.789 4.937 0 6.93-3.527 6.93-7.79 0-4.17-1.993-7.697-6.93-7.697\" />\n    </svg>");
};
var $dd86d607cf9e8d92$export$a1c6484cdecc2c4b = function OpsgenieLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Opsgenie' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $4695b20c010af541$export$438460117ae6b7ee).size : _ref2$size, testId = _ref2.testId, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $4695b20c010af541$export$438460117ae6b7ee).textColor : _ref2$textColor, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $4695b20c010af541$export$438460117ae6b7ee).iconColor : _ref2$iconColor;
    var _useThemeObserver = (0, $fdb77cc968262235$export$2e2bcd8739ae039)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $246be689d43c2dd2$export$2e2bcd8739ae039), {
        appearance: appearance,
        iconColor: iconColor,
        label: label,
        size: size,
        svg: $dd86d607cf9e8d92$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};



var $5FkrB = parcelRequire("5FkrB");




var $8e27972843b9c298$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor;
    var colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $244fe5cbdef580ed$export$bbacc3980e0f3029)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" focusable=\"false\" aria-hidden=\"true\">\n    <g fill=\"".concat(colors.iconColor, "\" fill-rule=\"evenodd\">\n      <path d=\"M17.06 4.246a2.79 2.79 0 0 0-2.736-.026l-.049.033-.002.001c-.605.35-1.048.91-1.256 1.558-.085.268-.13.552-.13.842v3.675l4.603 2.656a3.64 3.64 0 0 1 1.824 3.155v9.487a3.6 3.6 0 0 1-.214 1.23l6.175-3.566a2.77 2.77 0 0 0 1.392-2.407v-9.487c0-.991-.532-1.912-1.392-2.408z\"/>\n      <path d=\"m6.058 9 6.176-3.566a3.7 3.7 0 0 0-.214 1.23v9.486c0 1.303.693 2.505 1.823 3.155l4.604 2.657v3.674c0 .29-.045.575-.13.843a2.8 2.8 0 0 1-1.258 1.558.4.4 0 0 0-.05.033c-.851.47-1.89.461-2.735-.026L6.06 23.301a2.78 2.78 0 0 1-1.392-2.408v-9.486c0-.996.529-1.912 1.391-2.408z\"/>\n    </g>\n  </svg>");
};
var $8e27972843b9c298$export$e23ae35269442b4f = function RovoIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Rovo' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $4695b20c010af541$export$438460117ae6b7ee).size : _ref2$size, testId = _ref2.testId, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $4695b20c010af541$export$438460117ae6b7ee).textColor : _ref2$textColor, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $4695b20c010af541$export$438460117ae6b7ee).iconColor : _ref2$iconColor;
    var _useThemeObserver = (0, $fdb77cc968262235$export$2e2bcd8739ae039)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $246be689d43c2dd2$export$2e2bcd8739ae039), {
        appearance: appearance,
        svg: $8e27972843b9c298$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        label: label,
        size: size,
        testId: testId,
        textColor: textColor
    });
};


var $5FkrB = parcelRequire("5FkrB");




var $907ff11a1071d0d7$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $244fe5cbdef580ed$export$bbacc3980e0f3029)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" viewBox=\"0 0 100 32\" focusable=\"false\" aria-hidden=\"true\" xmlns=\"http://www.w3.org/2000/svg\">\n      <path\n        d=\"M12.393 4.246a2.79 2.79 0 0 0-2.735-.026.4.4 0 0 1-.05.033l-.001.001c-.606.35-1.048.91-1.257 1.558q-.129.404-.13.842v3.675l4.603 2.656a3.64 3.64 0 0 1 1.824 3.155v9.487a3.6 3.6 0 0 1-.214 1.23l6.175-3.566A2.77 2.77 0 0 0 22 20.884v-9.487c0-.991-.532-1.912-1.392-2.408z\"\n        fill=\"".concat(colors.iconColor, "\"\n        fillRule=\"evenodd\"\n      />\n      <path\n        d=\"m1.391 9 6.176-3.566a3.6 3.6 0 0 0-.214 1.23v9.486c0 1.303.693 2.505 1.823 3.155h.001l4.603 2.657v3.674c0 .29-.045.575-.13.843a2.8 2.8 0 0 1-1.258 1.558.4.4 0 0 0-.05.033c-.85.47-1.89.461-2.734-.026l-8.216-4.743A2.78 2.78 0 0 1 0 20.893v-9.486c0-.996.529-1.912 1.391-2.408z\"\n        fill=\"").concat(colors.iconColor, "\"\n        fillRule=\"evenodd\"\n      />\n      <path\n        d=\"M91.688 25.848c-4.6 0-7.298-3.404-7.298-8.004S87.088 9.9 91.688 9.9c4.57 0 7.238 3.342 7.238 7.942s-2.668 8.004-7.238 8.004zm0-13.494c-3.28 0-4.722 2.576-4.722 5.49 0 2.913 1.441 5.55 4.722 5.55 3.251 0 4.662-2.637 4.662-5.55 0-2.914-1.41-5.49-4.662-5.49M77.675 25.54H74.15L68.2 10.208h2.76l4.968 13.094 4.938-13.095h2.76zm-17.462.308c-4.6 0-7.299-3.404-7.299-8.004s2.7-7.943 7.3-7.943c4.568 0 7.236 3.342 7.236 7.942s-2.668 8.004-7.237 8.004zm0-13.494c-3.281 0-4.723 2.576-4.723 5.49 0 2.913 1.442 5.55 4.723 5.55 3.25 0 4.661-2.637 4.661-5.55 0-2.914-1.41-5.49-4.66-5.49zM43.177 8.03H39.13v7.36h4.048c3.588 0 4.692-1.38 4.692-3.68 0-2.177-1.134-3.68-4.692-3.68zm7.452 3.619c0 3.036-1.288 5.09-3.956 5.949l4.938 7.943H48.36l-4.447-7.514H39.13v7.514h-2.76V5.393h7.115c4.815 0 7.145 2.392 7.145 6.256z\"\n        fill=\"").concat(colors.textColor, "\"\n      />\n    </svg>");
};
var $907ff11a1071d0d7$export$a0f6cb8061290bbb = function RovoLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Rovo' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $4695b20c010af541$export$438460117ae6b7ee).size : _ref2$size, testId = _ref2.testId, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $4695b20c010af541$export$438460117ae6b7ee).textColor : _ref2$textColor, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $4695b20c010af541$export$438460117ae6b7ee).iconColor : _ref2$iconColor;
    var _useThemeObserver = (0, $fdb77cc968262235$export$2e2bcd8739ae039)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $246be689d43c2dd2$export$2e2bcd8739ae039), {
        appearance: appearance,
        iconColor: iconColor,
        label: label,
        size: size,
        svg: $907ff11a1071d0d7$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};



var $5FkrB = parcelRequire("5FkrB");




var $68bc3c849d9fd0fe$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor;
    var colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $244fe5cbdef580ed$export$bbacc3980e0f3029)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" viewBox=\"0 0 32 32\" focusable=\"false\" aria-hidden=\"true\" xmlns=\"http://www.w3.org/2000/svg\">\n      <path fill=\"".concat(colors.iconColor, "\" d=\"M16 12.604c-3.033 0-5.981 1.37-8.39 3.489q-.375.373-.748.373c-.208 0-.415-.124-.581-.332l-3.032-3.572c-.166-.207-.25-.415-.25-.581 0-.25.125-.457.374-.706 3.655-3.24 8.1-5.067 12.627-5.067s8.97 1.827 12.626 5.067c.249.249.374.457.374.706 0 .166-.084.374-.25.581l-3.032 3.572c-.166.208-.373.332-.581.332q-.374 0-.748-.374c-2.409-2.118-5.358-3.488-8.39-3.488m0 13.374c-3.365 0-6.106-2.742-6.106-6.064S12.635 13.85 16 13.85s6.106 2.7 6.106 6.064-2.741 6.063-6.105 6.063\"/>\n    </svg>");
};
var $68bc3c849d9fd0fe$export$f3f5aa321d88adf9 = function StatuspageIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Statuspage' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $4695b20c010af541$export$438460117ae6b7ee).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $4695b20c010af541$export$438460117ae6b7ee).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $4695b20c010af541$export$438460117ae6b7ee).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $fdb77cc968262235$export$2e2bcd8739ae039)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $246be689d43c2dd2$export$2e2bcd8739ae039), {
        appearance: appearance,
        label: label,
        svg: $68bc3c849d9fd0fe$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};


var $5FkrB = parcelRequire("5FkrB");




var $4821146c88fc2e7a$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $244fe5cbdef580ed$export$bbacc3980e0f3029)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" viewBox=\"0 0 188 32\" focusable=\"false\" aria-hidden=\"true\" xmlns=\"http://www.w3.org/2000/svg\">\n      <path fill=\"".concat(colors.iconColor, "\" d=\"M13 12.604c-3.032 0-5.98 1.37-8.39 3.489q-.373.373-.747.373c-.208 0-.416-.124-.582-.332L.25 12.562c-.167-.207-.25-.415-.25-.581 0-.25.125-.457.374-.706C4.029 8.035 8.473 6.208 13 6.208s8.971 1.827 12.626 5.067c.25.249.374.457.374.706 0 .166-.083.374-.25.581l-3.031 3.572c-.166.208-.374.332-.582.332q-.373 0-.747-.374c-2.41-2.118-5.358-3.488-8.39-3.488m0 13.374c-3.364 0-6.105-2.742-6.105-6.064S9.635 13.85 13 13.85c3.364 0 6.105 2.7 6.105 6.064s-2.74 6.063-6.105 6.063\" />\n      <path fill=\"").concat(colors.textColor, "\" d=\"M180.293 12.293c-2.79 0-4.201 1.81-4.477 4.477h8.556c-.153-2.852-1.441-4.477-4.079-4.477m5.888 12.635c-1.257.674-3.189.92-4.753.92-5.735 0-8.249-3.312-8.249-8.004 0-4.631 2.576-7.943 7.237-7.943 4.723 0 6.624 3.281 6.624 7.943v1.196h-11.193c.368 2.606 2.054 4.293 5.673 4.293 1.779 0 3.281-.337 4.661-.828zm-18.638-.614v-1.533c-.981 2.024-2.821 3.067-5.183 3.067-4.048 0-6.072-3.466-6.072-7.974 0-4.324 2.116-7.973 6.379-7.973 2.239 0 3.956 1.012 4.876 3.005v-2.698h2.576V24.16c0 4.508-2.116 7.544-7.605 7.544-2.576 0-3.987-.337-5.459-.828V28.3c1.687.552 3.435.92 5.336.92 3.833 0 5.152-2.055 5.152-4.907m-8.679-6.44c0 3.68 1.472 5.52 4.202 5.52 2.361 0 4.477-1.503 4.477-4.906V17.26c0-3.404-1.932-4.907-4.171-4.907-2.974 0-4.508 1.963-4.508 5.52m-16.949.001c0 3.68 1.472 5.52 4.201 5.52 2.362 0 4.478-1.503 4.478-4.906V17.26c0-3.404-1.932-4.907-4.171-4.907-2.975 0-4.508 1.963-4.508 5.52m8.679 7.667v-2.76c-.982 2.024-2.822 3.066-5.183 3.066-4.079 0-6.133-3.465-6.133-7.973 0-4.324 2.146-7.973 6.44-7.973 2.238 0 3.956 1.012 4.876 3.005v-2.699h2.637V25.54zm-16.091-7.666c0-3.68-1.472-5.52-4.201-5.52-2.361 0-4.477 1.503-4.477 4.907v1.227c0 3.404 1.932 4.906 4.17 4.906 2.975 0 4.508-1.962 4.508-5.52m-3.802 7.974c-2.239 0-3.956-1.013-4.876-3.006v8.679h-2.638V10.207h2.638v2.76c.981-2.024 2.821-3.066 5.182-3.066 4.079 0 6.134 3.465 6.134 7.973 0 4.324-2.147 7.973-6.44 7.973m-10.56-4.477c0 2.545-1.656 4.477-5.765 4.477-2.3 0-4.171-.52-5.336-1.134v-2.79c1.318.766 3.526 1.502 5.458 1.502 2.024 0 3.067-.828 3.067-2.024 0-1.165-.889-1.84-3.803-2.545-3.404-.829-4.845-2.147-4.845-4.662 0-2.668 2.055-4.293 5.551-4.293 1.993 0 3.802.49 4.937 1.104v2.73c-1.84-.92-3.343-1.411-4.968-1.411-1.932 0-2.975.674-2.975 1.87 0 1.073.736 1.748 3.558 2.423 3.404.828 5.121 2.085 5.121 4.753m-27.598-2.177v-8.985h2.638v9.26c0 2.76 1.104 3.988 3.618 3.988 2.454 0 4.14-1.626 4.14-4.723v-8.525h2.638V25.54h-2.638v-2.515c-.981 1.81-2.79 2.821-4.845 2.821-3.527 0-5.55-2.422-5.55-6.654m-7.155 1.596c0 1.349.797 2.269 2.422 2.269.614 0 1.196-.123 1.656-.215v2.546a6.3 6.3 0 0 1-1.778.245c-3.282 0-4.876-1.932-4.876-4.784v-8.188h-2.484v-2.453h2.484V6.957h2.576v3.25h4.078v2.454H85.39zm-18.943-2.914c0 3.68 1.472 5.52 4.202 5.52 2.361 0 4.477-1.503 4.477-4.906V17.26c0-3.404-1.932-4.907-4.17-4.907-2.975 0-4.509 1.963-4.509 5.52m8.679 7.667v-2.76c-.981 2.024-2.821 3.066-5.183 3.066-4.078 0-6.133-3.465-6.133-7.973 0-4.324 2.147-7.973 6.44-7.973 2.239 0 3.956 1.012 4.876 3.005v-2.699h2.637V25.54zm-17.258-4.752c0 1.349.797 2.269 2.422 2.269.614 0 1.196-.123 1.656-.215v2.546a6.3 6.3 0 0 1-1.778.245c-3.282 0-4.876-1.932-4.876-4.784v-8.188h-2.484v-2.453h2.484V6.957h2.576v3.25h4.078v2.454h-4.078zm-6.894-.798c0 3.496-2.085 5.858-7.084 5.858-3.894 0-5.704-.767-7.268-1.564v-2.822c1.871.982 4.754 1.687 7.422 1.687 3.036 0 4.17-1.196 4.17-2.975 0-1.778-1.104-2.729-4.937-3.649-4.539-1.104-6.563-2.668-6.563-5.98 0-3.128 2.392-5.459 7.084-5.459 2.914 0 4.784.706 6.164 1.472v2.76c-2.024-1.165-4.201-1.533-6.286-1.533-2.638 0-4.202.92-4.202 2.76 0 1.656 1.288 2.484 4.846 3.373 4.262 1.074 6.654 2.454 6.654 6.072\" />\n    </svg>");
};
var $4821146c88fc2e7a$export$bb4ae5b41b43be04 = function StatuspageLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Statuspage' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $4695b20c010af541$export$438460117ae6b7ee).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $4695b20c010af541$export$438460117ae6b7ee).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $4695b20c010af541$export$438460117ae6b7ee).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $fdb77cc968262235$export$2e2bcd8739ae039)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $246be689d43c2dd2$export$2e2bcd8739ae039), {
        appearance: appearance,
        label: label,
        iconColor: iconColor,
        size: size,
        svg: $4821146c88fc2e7a$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};



var $5FkrB = parcelRequire("5FkrB");




var $bf3ce5cac71ed0fb$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor;
    var colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $244fe5cbdef580ed$export$bbacc3980e0f3029)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" viewBox=\"0 0 32 32\" focusable=\"false\" aria-hidden=\"true\" xmlns=\"http://www.w3.org/2000/svg\">\n      <path fill=".concat(colors.iconColor, " clip-rule=\"evenodd\" d=\"M24.286 5.337H7.714a2.585 2.585 0 0 0-2.585 2.585v16.572a2.585 2.585 0 0 0 2.585 2.584h16.572a2.585 2.585 0 0 0 2.585-2.584V7.922a2.585 2.585 0 0 0-2.585-2.585m-9.791 15.66a.86.86 0 0 1-.859.858h-3.634a.86.86 0 0 1-.859-.859V10.21a.86.86 0 0 1 .859-.86h3.634a.86.86 0 0 1 .859.86zm8.362-4.953a.86.86 0 0 1-.859.859h-3.634a.86.86 0 0 1-.859-.859V10.21a.86.86 0 0 1 .859-.86h3.634a.86.86 0 0 1 .859.86z\" fill-rule=\"evenodd\"/>\n    </svg>");
};
var $bf3ce5cac71ed0fb$export$4384da9b8b140bf4 = function TrelloIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Trello' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $4695b20c010af541$export$438460117ae6b7ee).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $4695b20c010af541$export$438460117ae6b7ee).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $4695b20c010af541$export$438460117ae6b7ee).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $fdb77cc968262235$export$2e2bcd8739ae039)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $246be689d43c2dd2$export$2e2bcd8739ae039), {
        appearance: appearance,
        label: label,
        svg: $bf3ce5cac71ed0fb$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};


var $5FkrB = parcelRequire("5FkrB");




var $d72a3f3cf76878be$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $244fe5cbdef580ed$export$bbacc3980e0f3029)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" viewBox=\"0 0 106 32\" focusable=\"false\" aria-hidden=\"true\" xmlns=\"http://www.w3.org/2000/svg\">\n      <path fill=\"".concat(colors.iconColor, "\" clip-rule=\"evenodd\" d=\"M19.157 4.67H2.585A2.585 2.585 0 0 0 0 7.255v16.572a2.585 2.585 0 0 0 2.585 2.585h16.572a2.585 2.585 0 0 0 2.584-2.585V7.255a2.585 2.585 0 0 0-2.584-2.585M9.365 20.33a.86.86 0 0 1-.858.858H4.873a.86.86 0 0 1-.859-.858V9.543c0-.475.385-.859.859-.859h3.634c.474 0 .858.385.858.86zm8.362-4.952a.86.86 0 0 1-.858.858h-3.634a.86.86 0 0 1-.859-.858V9.543c0-.475.385-.859.859-.859h3.634c.474 0 .858.385.858.86z\" fill-rule=\"evenodd\"/>\n      <path fill=\"").concat(colors.textColor, "\" d=\"M97.64 25.848c-4.6 0-7.298-3.404-7.298-8.004S93.04 9.9 97.64 9.9c4.57 0 7.238 3.342 7.238 7.942s-2.668 8.004-7.238 8.004m0-13.494c-3.281 0-4.722 2.576-4.722 5.49 0 2.913 1.44 5.55 4.722 5.55 3.251 0 4.662-2.637 4.662-5.55 0-2.914-1.411-5.49-4.662-5.49M88.874 25.51c-.215.062-.675.123-1.35.123-2.514 0-4.109-1.196-4.109-4.017V3.798h2.637V21.31c0 1.38.92 1.87 2.055 1.87.276 0 .46 0 .767-.03zm-7.996 0c-.215.062-.675.123-1.35.123-2.514 0-4.109-1.196-4.109-4.017V3.798h2.637V21.31c0 1.38.92 1.87 2.055 1.87.276 0 .46 0 .767-.03zM65.532 12.293c-2.79 0-4.202 1.81-4.478 4.477h8.556c-.153-2.852-1.44-4.477-4.078-4.477m5.888 12.635c-1.258.674-3.19.92-4.754.92-5.734 0-8.249-3.312-8.249-8.004 0-4.631 2.576-7.943 7.237-7.943 4.723 0 6.624 3.281 6.624 7.943v1.196H61.085c.368 2.606 2.055 4.293 5.673 4.293 1.78 0 3.282-.337 4.662-.828zm-19.48-8.434v9.047h-2.576V10.208h2.576v2.698c.89-1.809 2.423-3.097 5.428-2.913v2.576c-3.373-.337-5.428.675-5.428 3.925M32.943 5.393H48.03V8.03h-6.164v17.511h-2.76V8.031h-6.164z\"/>\n    </svg>");
};
var $d72a3f3cf76878be$export$60e26212f3b61a28 = function TrelloLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Trello' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $4695b20c010af541$export$438460117ae6b7ee).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $4695b20c010af541$export$438460117ae6b7ee).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $4695b20c010af541$export$438460117ae6b7ee).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $fdb77cc968262235$export$2e2bcd8739ae039)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $246be689d43c2dd2$export$2e2bcd8739ae039), {
        appearance: appearance,
        label: label,
        iconColor: iconColor,
        size: size,
        svg: $d72a3f3cf76878be$var$svg({
            appearance: appearance,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};




var $5FkrB = parcelRequire("5FkrB");




var $722ae65b25b74a2f$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor;
    var colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $244fe5cbdef580ed$export$bbacc3980e0f3029)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" focusable=\"false\" aria-hidden=\"true\">\n    <path fill=\"".concat(colors.iconColor, "\" d=\"M27.545 24.817 16.96 3.647c-.208-.458-.417-.541-.667-.541-.208 0-.458.083-.708.5-1.5 2.375-2.167 5.126-2.167 8 0 4.002 2.042 7.752 5.042 13.795.334.666.584.791 1.167.791h7.335c.541 0 .833-.208.833-.625 0-.208-.042-.333-.25-.75M12.168 14.816c-.834-1.25-1.084-1.334-1.292-1.334s-.333.084-.708.834L4.875 24.9c-.167.334-.208.459-.208.626 0 .333.291.666.916.666h7.46c.5 0 .875-.416 1.083-1.208.25-1 .334-1.875.334-2.917 0-2.917-1.292-5.751-2.292-7.251\"/>\n  </svg>\n  ");
};
var $722ae65b25b74a2f$export$94c87d39a54a1894 = function AtlassianMarketplaceIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Atlassian Marketplace' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $4695b20c010af541$export$438460117ae6b7ee).size : _ref2$size, testId = _ref2.testId, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $4695b20c010af541$export$438460117ae6b7ee).textColor : _ref2$textColor, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $4695b20c010af541$export$438460117ae6b7ee).iconColor : _ref2$iconColor;
    var _useThemeObserver = (0, $fdb77cc968262235$export$2e2bcd8739ae039)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $246be689d43c2dd2$export$2e2bcd8739ae039), {
        appearance: appearance,
        svg: $722ae65b25b74a2f$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        label: label,
        size: size,
        testId: testId,
        textColor: textColor
    });
};



var $5FkrB = parcelRequire("5FkrB");




var $90b44dd97a49007a$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor;
    var colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $244fe5cbdef580ed$export$bbacc3980e0f3029)(appearance, colorMode);
    return "<svg\n      fill=\"none\"\n      height=\"32\"\n      xmlns=\"http://www.w3.org/2000/svg\"\n      viewBox=\"0 0 32 32\"\n      focusable=\"false\"\n      aria-hidden=\"true\"\n    >\n      <path\n        d=\"M27.545 24.378 16.96 3.208c-.208-.458-.417-.541-.667-.541-.208 0-.458.083-.708.5-1.5 2.375-2.167 5.126-2.167 8.001 0 4 2.042 7.751 5.042 13.794.334.666.584.791 1.167.791h7.335c.541 0 .833-.208.833-.625 0-.208-.042-.333-.25-.75M12.168 14.377c-.834-1.25-1.084-1.334-1.292-1.334s-.333.084-.708.834L4.875 24.462c-.167.333-.208.458-.208.625 0 .333.291.666.916.666h7.46c.5 0 .875-.416 1.083-1.208.25-1 .334-1.875.334-2.917 0-2.917-1.292-5.751-2.292-7.251\"\n        fill=\"".concat(colors.iconColor, "\"\n      />\n    </svg>");
};
var $90b44dd97a49007a$export$a825993f361832f7 = function AtlassianAccessIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Atlassian Access' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $4695b20c010af541$export$438460117ae6b7ee).size : _ref2$size, testId = _ref2.testId, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $4695b20c010af541$export$438460117ae6b7ee).textColor : _ref2$textColor, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $4695b20c010af541$export$438460117ae6b7ee).iconColor : _ref2$iconColor;
    var _useThemeObserver = (0, $fdb77cc968262235$export$2e2bcd8739ae039)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $246be689d43c2dd2$export$2e2bcd8739ae039), {
        appearance: appearance,
        svg: $90b44dd97a49007a$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        label: label,
        size: size,
        testId: testId,
        textColor: textColor
    });
};




var $5FkrB = parcelRequire("5FkrB");




var $37844134dd17fb96$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor;
    var colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $244fe5cbdef580ed$export$bbacc3980e0f3029)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" viewBox=\"0 0 32 32\" focusable=\"false\" aria-hidden=\"true\" xmlns=\"http://www.w3.org/2000/svg\">\n      <path fill=\"".concat(colors.iconColor, "\" d=\"M27.545 24.378 16.96 3.208c-.208-.458-.417-.541-.667-.541-.208 0-.458.083-.708.5-1.5 2.375-2.167 5.125-2.167 8 0 4.001 2.042 7.752 5.042 13.795.334.666.584.791 1.167.791h7.335c.541 0 .833-.208.833-.625 0-.208-.042-.333-.25-.75M12.168 14.377c-.834-1.25-1.084-1.334-1.292-1.334s-.333.083-.708.834L4.875 24.46c-.167.334-.208.459-.208.625 0 .334.291.667.916.667h7.46c.5 0 .875-.416 1.083-1.208.25-1 .334-1.876.334-2.917 0-2.917-1.292-5.751-2.292-7.251\"/>\n    </svg>");
};
var $37844134dd17fb96$export$8a485e2e7ed91e8f = function AtlassianIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Atlassian' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $4695b20c010af541$export$438460117ae6b7ee).size : _ref2$size, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $4695b20c010af541$export$438460117ae6b7ee).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $4695b20c010af541$export$438460117ae6b7ee).textColor : _ref2$textColor, testId = _ref2.testId;
    var _useThemeObserver = (0, $fdb77cc968262235$export$2e2bcd8739ae039)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $246be689d43c2dd2$export$2e2bcd8739ae039), {
        appearance: appearance,
        label: label,
        svg: $37844134dd17fb96$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        textColor: textColor,
        size: size,
        testId: testId
    });
};


var $5FkrB = parcelRequire("5FkrB");




var $fefa5e0a15da0ac0$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconColor: iconColor,
        textColor: textColor,
        // We treat the word "Atlassian" differently to normal app logos, it has a bold brand look
        atlassianLogoTextColor: textColor
    };
    if (appearance) colors = (0, $244fe5cbdef580ed$export$bbacc3980e0f3029)(appearance, colorMode);
    return "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 198 32\" focusable=\"false\" aria-hidden=\"true\" height=\"32\" fill=\"none\">\n      <path fill=".concat(colors.iconColor, " d=\"M22.878 24.378 12.293 3.208c-.208-.458-.416-.541-.666-.541-.209 0-.459.083-.709.5-1.5 2.375-2.167 5.125-2.167 8 0 4.001 2.042 7.752 5.043 13.794.333.667.583.792 1.166.792h7.335c.542 0 .833-.208.833-.625 0-.208-.041-.333-.25-.75M7.501 14.377c-.833-1.25-1.083-1.334-1.292-1.334s-.333.083-.708.834L.208 24.46c-.166.334-.208.459-.208.625 0 .334.292.667.917.667h7.46c.5 0 .874-.416 1.083-1.208.25-1 .333-1.876.333-2.917 0-2.917-1.292-5.751-2.292-7.251z\"/>\n      <path fill=").concat(colors.atlassianLogoTextColor, " d=\"M107.447 10.828c0 2.972 1.345 5.308 6.795 6.37 3.185.707 3.893 1.203 3.893 2.265 0 1.061-.708 1.698-2.973 1.698-2.619 0-5.733-.92-7.785-2.123v4.813c1.627.778 3.751 1.698 7.785 1.698 5.662 0 7.856-2.548 7.856-6.228m0 .07c0-3.538-1.84-5.166-7.148-6.298-2.902-.637-3.61-1.274-3.61-2.194 0-1.133 1.062-1.628 2.973-1.628 2.335 0 4.6.708 6.794 1.698v-4.6c-1.557-.779-3.892-1.345-6.653-1.345-5.237 0-7.927 2.265-7.927 5.945m72.475-5.803v20.17h4.318V9.979l1.769 4.035 6.087 11.324h5.379V5.166h-4.247v13.022l-1.628-3.821-4.883-9.201zm-27.319 0h-4.671v20.17h4.671zm-10.05 14.154c0-3.538-1.841-5.166-7.149-6.298-2.902-.637-3.609-1.274-3.609-2.194 0-1.133 1.061-1.628 2.972-1.628 2.336 0 4.601.708 6.795 1.699v-4.6c-1.557-.78-3.893-1.346-6.653-1.346-5.238 0-7.927 2.265-7.927 5.946 0 2.972 1.344 5.308 6.794 6.37 3.185.707 3.893 1.203 3.893 2.264 0 1.062-.708 1.699-2.973 1.699-2.618 0-5.733-.92-7.785-2.123v4.812c1.628.779 3.751 1.699 7.785 1.699 5.592 0 7.857-2.548 7.857-6.3M71.069 5.166v20.17h9.625l1.486-4.387h-6.44V5.166zm-19.039 0v4.317h5.167v15.854h4.741V9.483h5.592V5.166zm-6.866 0h-6.157L32 25.336h5.379l.99-3.396c1.204.353 2.478.566 3.752.566s2.548-.213 3.751-.567l.991 3.398h5.379c-.07 0-7.078-20.171-7.078-20.171M42.05 18.259c-.92 0-1.77-.141-2.548-.354L42.05 9.13l2.548 8.776a9.6 9.6 0 0 1-2.548.354zM97.326 5.166H91.17l-7.078 20.17h5.38l.99-3.396c1.203.353 2.477.566 3.751.566s2.548-.213 3.751-.567l.991 3.398h5.379zm-3.114 13.093c-.92 0-1.77-.141-2.548-.354l2.548-8.776 2.548 8.776a9.6 9.6 0 0 1-2.548.354m75.306-13.093h-6.157l-7.007 20.17h5.379l.991-3.396c1.203.353 2.477.566 3.751.566s2.548-.213 3.751-.567l.991 3.398h5.379zm-3.043 13.093c-.92 0-1.77-.141-2.548-.354l2.548-8.776 2.548 8.776a10 10 0 0 1-2.548.354\"/>\n    </svg>");
};
var $fefa5e0a15da0ac0$export$765cacec8b0843f3 = function AtlassianLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Atlassian' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $4695b20c010af541$export$438460117ae6b7ee).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $4695b20c010af541$export$438460117ae6b7ee).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $4695b20c010af541$export$438460117ae6b7ee).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $fdb77cc968262235$export$2e2bcd8739ae039)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $246be689d43c2dd2$export$2e2bcd8739ae039), {
        appearance: appearance,
        label: label,
        svg: $fefa5e0a15da0ac0$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};




var $kqp0i = parcelRequire("kqp0i");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");

var $dU8Y3 = parcelRequire("dU8Y3");
var $32c7a5ef60d1831d$var$_excluded = [
    "size",
    "shouldUseNewLogoDesign"
], $32c7a5ef60d1831d$var$_excluded2 = [
    "size",
    "shouldUseNewLogoDesign"
], $32c7a5ef60d1831d$var$_excluded3 = [
    "shouldUseHexLogo"
], $32c7a5ef60d1831d$var$_excluded4 = [
    "size"
];
/**
 * Creates a feature flagged component that renders the legacy logo or the new logo
 * based on the platform-logo-rebrand feature flag.
 *
 * @param LegacyComponent - The legacy logo component.
 * @param NewComponent - The new logo component.
 * @returns A feature flagged component that renders the legacy logo or the new logo.
 */ var $32c7a5ef60d1831d$export$e30d2ddc605f6bb = function createFeatureFlaggedComponent(LegacyComponent, NewComponent) {
    // Note: textColor and iconColor aren't supported on all new logos
    // These props will be deprecated in the future
    return function(_ref) {
        var size = _ref.size, shouldUseNewLogoDesign = _ref.shouldUseNewLogoDesign, props = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $32c7a5ef60d1831d$var$_excluded);
        if ((0, $dU8Y3.fg)('platform-logo-rebrand') || shouldUseNewLogoDesign) // Size defaults need to be set, as the temp library had different defaults
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(NewComponent, (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
            size: size || 'medium'
        }, props));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(LegacyComponent, (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
            size: size
        }, props));
    };
};
var $32c7a5ef60d1831d$export$436fcf6e31fbacea = function createFeatureFlaggedServiceCollectionComponent(LegacyComponent, NewComponent) {
    // Note: textColor and iconColor aren't supported on all new logos
    // These props will be deprecated in the future
    return function(_ref2) {
        var size = _ref2.size, shouldUseNewLogoDesign = _ref2.shouldUseNewLogoDesign, props = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref2, $32c7a5ef60d1831d$var$_excluded2);
        if ((0, $dU8Y3.fg)('platform-logo-rebrand') || shouldUseNewLogoDesign) // Size defaults need to be set, as the temp library had different defaults
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(NewComponent, (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
            size: size || 'medium'
        }, props));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(LegacyComponent, (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
            size: size
        }, props));
    };
};
var $32c7a5ef60d1831d$export$2469203854060337 = function createFeatureFlaggedRovoComponent(LegacyComponent, NewComponent, NewHexComponent) {
    var RovoHexWrapped = $32c7a5ef60d1831d$export$667425256e2e7296(NewHexComponent);
    var RovoServiceCollectionWrapped = $32c7a5ef60d1831d$export$436fcf6e31fbacea(LegacyComponent, NewComponent);
    return function(_ref3) {
        var shouldUseHexLogo = _ref3.shouldUseHexLogo, props = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref3, $32c7a5ef60d1831d$var$_excluded3);
        // Return hex logo if feature flag enabled. Otherwise revert to old set of components
        if ((0, $dU8Y3.fg)('platform-logo-rebrand-rovo-hex') || shouldUseHexLogo) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(RovoHexWrapped, props);
        else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(RovoServiceCollectionWrapped, props);
    };
};
var $32c7a5ef60d1831d$export$667425256e2e7296 = function tempSizeWrapper(NewComponent) {
    return function(_ref4) {
        var size = _ref4.size, props = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref4, $32c7a5ef60d1831d$var$_excluded4);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(NewComponent, (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
            size: size || 'medium'
        }, props));
    };
};
var $32c7a5ef60d1831d$export$3fe521abfbbe6ab3 = function teamEUFlaggedIcon(LegacyComponent, NewComponent) {
    return function(props) {
        var Logo = (0, $dU8Y3.fg)('platform-logo-rebrand-team-eu') ? $32c7a5ef60d1831d$export$667425256e2e7296(NewComponent) : $32c7a5ef60d1831d$export$667425256e2e7296(LegacyComponent);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(Logo, props);
    };
};
var $32c7a5ef60d1831d$export$172fd793eb6ecac4 = [
    // Program logos
    {
        name: 'atlassian',
        type: 'legacy',
        category: 'program'
    },
    {
        name: 'atlassian-access',
        type: 'legacy',
        category: 'program'
    },
    {
        name: 'atlassian-marketplace',
        type: 'legacy',
        category: 'program'
    },
    // Home collection
    {
        name: 'home',
        type: 'new',
        category: 'app'
    },
    {
        name: 'hub',
        type: 'new',
        category: 'app'
    },
    // Teamwork collection
    {
        name: 'confluence',
        type: 'migration',
        category: 'app'
    },
    {
        name: 'jira',
        type: 'migration',
        category: 'app'
    },
    {
        name: 'loom',
        type: 'migration',
        category: 'app'
    },
    {
        name: 'loom-blurple',
        type: 'new',
        category: 'app',
        skipExample: true
    },
    {
        name: 'loom-attribution',
        type: 'migration',
        category: 'app'
    },
    {
        name: 'rovo',
        type: 'rovo-hex',
        category: 'app'
    },
    // Strategy collection
    {
        name: 'align',
        type: 'new',
        category: 'app'
    },
    {
        name: 'focus',
        type: 'migration',
        category: 'app'
    },
    {
        name: 'talent',
        type: 'new',
        category: 'app'
    },
    // App collection
    {
        name: 'jira-product-discovery',
        type: 'migration',
        category: 'app'
    },
    // Dev collection
    {
        name: 'bitbucket',
        type: 'migration',
        category: 'app'
    },
    {
        name: 'compass',
        type: 'migration',
        category: 'app'
    },
    {
        name: 'dx',
        type: 'new',
        category: 'app',
        skipLogo: true
    },
    {
        name: 'rovo-dev',
        type: 'new',
        category: 'app'
    },
    {
        name: 'rovo-dev-agent',
        type: 'new',
        category: 'agent'
    },
    // Customer collection
    {
        name: 'jira-service-management',
        type: 'migration',
        category: 'app'
    },
    {
        name: 'assets',
        type: 'new',
        category: 'app'
    },
    {
        name: 'customer-service-management',
        type: 'new',
        category: 'app'
    },
    {
        name: 'opsgenie',
        type: 'migration',
        category: 'app'
    },
    {
        name: 'statuspage',
        type: 'migration',
        category: 'app'
    },
    {
        name: 'trello',
        type: 'migration',
        category: 'app'
    },
    // Platform Collection
    {
        name: 'admin',
        type: 'new',
        category: 'app'
    },
    {
        name: 'analytics',
        type: 'new',
        category: 'app'
    },
    {
        name: 'chat',
        type: 'new',
        category: 'app'
    },
    {
        name: 'goals',
        type: 'new',
        category: 'app'
    },
    {
        name: 'guard',
        type: 'migration',
        category: 'app'
    },
    {
        name: 'projects',
        type: 'new',
        category: 'app'
    },
    {
        name: 'search',
        type: 'new',
        category: 'app'
    },
    {
        name: 'studio',
        type: 'new',
        category: 'app'
    },
    {
        name: 'teams',
        type: 'new',
        category: 'app'
    },
    // Data Center
    {
        name: 'jira-data-center',
        type: 'new',
        category: 'app'
    },
    {
        name: 'jira-service-management-data-center',
        type: 'new',
        category: 'app'
    },
    {
        name: 'confluence-data-center',
        type: 'new',
        category: 'app'
    },
    {
        name: 'bitbucket-data-center',
        type: 'new',
        category: 'app'
    },
    {
        name: 'bamboo',
        type: 'new',
        category: 'app'
    },
    {
        name: 'crowd',
        type: 'new',
        category: 'app'
    },
    // Deprecated
    {
        name: 'atlassian-administration',
        type: 'legacy',
        category: 'app',
        skipExample: true,
        deprecated: true
    },
    {
        name: 'atlassian-admin',
        type: 'legacy',
        category: 'app',
        skipExample: true,
        deprecated: true
    },
    {
        name: 'atlassian-analytics',
        type: 'legacy',
        category: 'app',
        skipExample: true,
        deprecated: true
    },
    {
        name: 'atlas',
        type: 'legacy',
        category: 'app',
        skipExample: true,
        deprecated: true
    },
    {
        name: 'jira-align',
        type: 'legacy',
        category: 'app',
        skipExample: true,
        deprecated: true
    },
    {
        name: 'jira-software',
        type: 'legacy',
        category: 'app',
        skipExample: true,
        deprecated: true
    },
    {
        name: 'jira-work-management',
        type: 'legacy',
        category: 'app',
        skipExample: true,
        deprecated: true
    }
];
var $32c7a5ef60d1831d$export$62e1212796a86b1b = $32c7a5ef60d1831d$export$172fd793eb6ecac4.filter(function(logo) {
    return logo.category === 'program' && !logo.skipExample;
}).map(function(logo) {
    return logo.name;
});
var $32c7a5ef60d1831d$export$e0dee4a765830f4d = $32c7a5ef60d1831d$export$172fd793eb6ecac4.filter(function(logo) {
    return logo.category === 'app' && !logo.skipExample;
}).map(function(logo) {
    return logo.name;
});
var $32c7a5ef60d1831d$export$a13ce90e90d7bfc1 = $32c7a5ef60d1831d$export$172fd793eb6ecac4.filter(function(logo) {
    return logo.category === 'agent' && !logo.skipExample;
}).map(function(logo) {
    return logo.name;
}) || [];
var $32c7a5ef60d1831d$export$516fce44c502c1d3 = $32c7a5ef60d1831d$export$172fd793eb6ecac4.filter(function(logo) {
    return logo.type === 'legacy';
});
var $32c7a5ef60d1831d$export$b805fae8e798ed39 = $32c7a5ef60d1831d$export$172fd793eb6ecac4.filter(function(logo) {
    return logo.type === 'migration';
});
var $32c7a5ef60d1831d$export$3f9abd26214cd85f = $32c7a5ef60d1831d$export$172fd793eb6ecac4.filter(function(logo) {
    return logo.type === 'new';
});


/**
 * __Admin icon__
 *
 * The Admin icon without an accompanying wordmark.
 *
 * - [Examples](https://atlassian.design/components/logo/examples)
 * - [Code](https://atlassian.design/components/logo/code)
 * - [Usage](https://atlassian.design/components/logo/usage)
 */ var $e5c28807f044a60a$export$ef8e5f836dd989d3 = (0, $32c7a5ef60d1831d$export$667425256e2e7296)((0, $42816eed69858c8d$export$ef8e5f836dd989d3));
var $e5c28807f044a60a$export$ebcd30672e67406 = (0, $32c7a5ef60d1831d$export$667425256e2e7296)((0, $f75b13e9496c8aa2$export$61afcb38c001e19));
var $e5c28807f044a60a$export$af3460f51ce3602a = (0, $32c7a5ef60d1831d$export$667425256e2e7296)((0, $483e4eae5b0896bb$export$af3460f51ce3602a));
var $e5c28807f044a60a$export$c8415b6abe4a8587 = (0, $32c7a5ef60d1831d$export$667425256e2e7296)((0, $f74d50e4aa1d9379$export$f0bac2b7ac3e3504));
var $e5c28807f044a60a$export$d89497e7f33ca6f5 = (0, $32c7a5ef60d1831d$export$667425256e2e7296)((0, $8373c87ee8f07dfa$export$d89497e7f33ca6f5));
var $e5c28807f044a60a$export$48ca930f3071e3e4 = (0, $32c7a5ef60d1831d$export$667425256e2e7296)((0, $bcf55440e1ac49e3$export$81c47abe19675c4c));
var $e5c28807f044a60a$export$52cd484a7ef4f2b9 = (0, $32c7a5ef60d1831d$export$3fe521abfbbe6ab3)((0, $ed33621c770c8f6f$export$52cd484a7ef4f2b9), (0, $7712961585b3c6e3$export$402a257da320c93c));
var $e5c28807f044a60a$export$9ca9881809919df8 = (0, $32c7a5ef60d1831d$export$3fe521abfbbe6ab3)((0, $422e6573ccf128d4$export$a529e78951cd6709), (0, $eed89fab9307a98b$export$a3af32a9109d706d));
/**
 * __Customer Service Management icon__
 *
 * The Customer service management icon without an accompanying wordmark.
 *
 * - [Examples](https://atlassian.design/components/logo/examples)
 * - [Code](https://atlassian.design/components/logo/code)
 * - [Usage](https://atlassian.design/components/logo/usage)
 */ var $e5c28807f044a60a$export$6da5aa77c402ba0f = (0, $32c7a5ef60d1831d$export$667425256e2e7296)((0, $d29a2f476ea23fcc$export$6da5aa77c402ba0f));
var $e5c28807f044a60a$export$abc95e6180bb1d88 = (0, $32c7a5ef60d1831d$export$667425256e2e7296)((0, $501906e2812827da$export$f597f0f7fadce0b9));
var $e5c28807f044a60a$export$9eb74917ea768ed4 = (0, $32c7a5ef60d1831d$export$667425256e2e7296)((0, $054a7cc9a77efc09$export$9eb74917ea768ed4));
var $e5c28807f044a60a$export$d2577aa28451395f = (0, $32c7a5ef60d1831d$export$667425256e2e7296)((0, $44589a9683d32305$export$c527a545aa426db3));
var $e5c28807f044a60a$export$92c8767b874048d = (0, $32c7a5ef60d1831d$export$667425256e2e7296)((0, $899d9f8a72fd5810$export$92c8767b874048d));
var $e5c28807f044a60a$export$d5648119d5b68e90 = (0, $32c7a5ef60d1831d$export$667425256e2e7296)((0, $cacaef9956f97a67$export$8b6b7f1b1b2367d3));
var $e5c28807f044a60a$export$80b8b269d8b5014e = (0, $32c7a5ef60d1831d$export$667425256e2e7296)((0, $012945d8e2fbfa71$export$80b8b269d8b5014e));
var $e5c28807f044a60a$export$fc9bd6687b80fe3b = (0, $32c7a5ef60d1831d$export$667425256e2e7296)((0, $d01ef7a6c70afe03$export$7a38180641471460));
var $e5c28807f044a60a$export$5ed3e1bb3b04fc02 = (0, $32c7a5ef60d1831d$export$667425256e2e7296)((0, $ee859ead2c997d6c$export$5ed3e1bb3b04fc02));
var $e5c28807f044a60a$export$aeefab651bcf2338 = (0, $32c7a5ef60d1831d$export$667425256e2e7296)((0, $d49a05cc2e75a98d$export$e3d1678155aaab99));
var $e5c28807f044a60a$export$8b784b3227531b3e = (0, $32c7a5ef60d1831d$export$667425256e2e7296)((0, $aede3667eebcd473$export$8b784b3227531b3e));
var $e5c28807f044a60a$export$f0750468d67c6902 = (0, $32c7a5ef60d1831d$export$667425256e2e7296)((0, $1738a389ff1a4b17$export$4145bd793c9ed1d0));
var $e5c28807f044a60a$export$813cff80931d9dbf = (0, $32c7a5ef60d1831d$export$667425256e2e7296)((0, $967b8b902cad02df$export$813cff80931d9dbf));
var $e5c28807f044a60a$export$409b7a5b7f180eba = (0, $32c7a5ef60d1831d$export$667425256e2e7296)((0, $4b1bd776417e729e$export$58747af448450872));
var $e5c28807f044a60a$export$82eafebb825fc23f = (0, $32c7a5ef60d1831d$export$3fe521abfbbe6ab3)((0, $e63a46d3e5ee26b0$export$82eafebb825fc23f), (0, $7f925c2c05d86612$export$3599582ddc9fc5cf));
var $e5c28807f044a60a$export$e4c5487c9a8ae3b1 = (0, $32c7a5ef60d1831d$export$3fe521abfbbe6ab3)((0, $b400386b6118e9fc$export$fa08cbfe393f2a68), (0, $4a274402133bcfb4$export$d669f6cbbb67e061));
var $e5c28807f044a60a$export$290a0f24614cde9f = (0, $32c7a5ef60d1831d$export$3fe521abfbbe6ab3)((0, $71c085540a543398$export$290a0f24614cde9f), (0, $15c0e7b58291f7da$export$8bb9894377e04e04));
var $e5c28807f044a60a$export$8aceb78c659789b6 = (0, $32c7a5ef60d1831d$export$3fe521abfbbe6ab3)((0, $dd6e7f6bc9a5125a$export$273fd56580e523ae), (0, $11ae8c55cb332e8a$export$170353c338ac5f4a));
/**
 * __Talent icon__
 *
 * The Talent icon without an accompanying wordmark.
 *
 * - [Examples](https://atlassian.design/components/logo/examples)
 * - [Code](https://atlassian.design/components/logo/code)
 * - [Usage](https://atlassian.design/components/logo/usage)
 */ var $e5c28807f044a60a$export$4b05688514531169 = (0, $32c7a5ef60d1831d$export$667425256e2e7296)((0, $7d5bd85babd9d964$export$4b05688514531169));
var $e5c28807f044a60a$export$4f6453e012279f89 = (0, $32c7a5ef60d1831d$export$667425256e2e7296)((0, $545ed004ae83180d$export$1b3979d995ebbc6e));
var $e5c28807f044a60a$export$1bcbc9c337da86da = (0, $32c7a5ef60d1831d$export$667425256e2e7296)((0, $ec2f473c5d030159$export$1bcbc9c337da86da));
var $e5c28807f044a60a$export$9b1a0a0c574cec2a = (0, $32c7a5ef60d1831d$export$667425256e2e7296)((0, $ec92cf1c4d78f147$export$bfd8d1c4da84ce71));
var $e5c28807f044a60a$export$e812398311cab9a3 = (0, $32c7a5ef60d1831d$export$667425256e2e7296)((0, $9e5a8315f2f6dca2$export$e812398311cab9a3));
var $e5c28807f044a60a$export$765f5afcc1a5a7e3 = (0, $32c7a5ef60d1831d$export$667425256e2e7296)((0, $3a004855a7d196e5$export$7c51958462d750e));
var $e5c28807f044a60a$export$d3ab16bbf4f954ee = (0, $32c7a5ef60d1831d$export$667425256e2e7296)((0, $ec366d15f1e808c3$export$d3ab16bbf4f954ee));
var $e5c28807f044a60a$export$36044946916e84a0 = (0, $32c7a5ef60d1831d$export$667425256e2e7296)((0, $c4ad96900069ac69$export$cc55e2a4c4b40552));
var $e5c28807f044a60a$export$53305f1f2855d3be = (0, $32c7a5ef60d1831d$export$667425256e2e7296)((0, $cdf91bfd5129c5de$export$53305f1f2855d3be));
var $e5c28807f044a60a$export$5e06396bce773a3 = (0, $32c7a5ef60d1831d$export$667425256e2e7296)((0, $663307540044c66a$export$b3e508cb103e1f93));
var $e5c28807f044a60a$export$eaf73f391f7103bd = (0, $32c7a5ef60d1831d$export$667425256e2e7296)((0, $7bcc6b150a03baab$export$eaf73f391f7103bd));
var $e5c28807f044a60a$export$6128b385660fd3c6 = (0, $32c7a5ef60d1831d$export$667425256e2e7296)((0, $cabff14b4a4d22c8$export$3c371bdbcdfcdce));
var $e5c28807f044a60a$export$f8455b5667a3ee0c = (0, $32c7a5ef60d1831d$export$667425256e2e7296)((0, $7d3956dbe8d63e3e$export$f8455b5667a3ee0c));
var $e5c28807f044a60a$export$eb152ab3801b2ae3 = (0, $32c7a5ef60d1831d$export$667425256e2e7296)((0, $69c118aaee2a1243$export$3224b07bc93ef23e));
var $e5c28807f044a60a$export$65fae0eaf343f2ca = (0, $32c7a5ef60d1831d$export$667425256e2e7296)((0, $c24549e1d7926fb7$export$65fae0eaf343f2ca));
var $e5c28807f044a60a$export$fffc0d480fb1ebf1 = (0, $32c7a5ef60d1831d$export$667425256e2e7296)((0, $4e01efda4183800b$export$f64bc7a7f04428d0));
var $e5c28807f044a60a$export$74517ed253186308 = (0, $32c7a5ef60d1831d$export$e30d2ddc605f6bb)((0, $d8e67cdbc001644b$export$74517ed253186308), (0, $42816eed69858c8d$export$ef8e5f836dd989d3));
var $e5c28807f044a60a$export$833abe6c2ce5ebfd = (0, $32c7a5ef60d1831d$export$e30d2ddc605f6bb)((0, $d34bb2adfdd493f4$export$833abe6c2ce5ebfd), (0, $f75b13e9496c8aa2$export$61afcb38c001e19));
var $e5c28807f044a60a$export$84109e099492cb5f = (0, $32c7a5ef60d1831d$export$e30d2ddc605f6bb)((0, $deef3d3b45588f0d$export$84109e099492cb5f), (0, $42816eed69858c8d$export$ef8e5f836dd989d3));
var $e5c28807f044a60a$export$f845d9b9254f0541 = (0, $32c7a5ef60d1831d$export$e30d2ddc605f6bb)((0, $d33c9708982ababa$export$f845d9b9254f0541), (0, $f75b13e9496c8aa2$export$61afcb38c001e19));
var $e5c28807f044a60a$export$c42ad8a0b925c762 = (0, $32c7a5ef60d1831d$export$e30d2ddc605f6bb)((0, $f554407486f95716$export$c42ad8a0b925c762), (0, $483e4eae5b0896bb$export$af3460f51ce3602a));
var $e5c28807f044a60a$export$e6470bfc39010cc4 = (0, $32c7a5ef60d1831d$export$e30d2ddc605f6bb)((0, $95feedc4efaebf57$export$e6470bfc39010cc4), (0, $f74d50e4aa1d9379$export$f0bac2b7ac3e3504));
var $e5c28807f044a60a$export$5fc1066e677788d4 = (0, $32c7a5ef60d1831d$export$e30d2ddc605f6bb)((0, $8ad89f28fbf49cde$export$5fc1066e677788d4), (0, $0f19a71cf5ef3443$export$5fc1066e677788d4));
var $e5c28807f044a60a$export$bd40525f5333524b = (0, $32c7a5ef60d1831d$export$e30d2ddc605f6bb)((0, $19440dcca25229ac$export$bd40525f5333524b), (0, $e971c6946cb1c8ba$export$f7ef5e5488e4b430));
var $e5c28807f044a60a$export$f7857fe64d7161d9 = (0, $32c7a5ef60d1831d$export$e30d2ddc605f6bb)((0, $df6923e07315bf90$export$f7857fe64d7161d9), (0, $391da3670ec5c41a$export$f7857fe64d7161d9));
var $e5c28807f044a60a$export$eb7d748e4f9c9676 = (0, $32c7a5ef60d1831d$export$e30d2ddc605f6bb)((0, $607814e595771710$export$eb7d748e4f9c9676), (0, $a1c2d8d9a6d45234$export$a16f50a81d183ce));
var $e5c28807f044a60a$export$9951d02c2d848122 = (0, $32c7a5ef60d1831d$export$667425256e2e7296)((0, $dec238ff93319a00$export$9951d02c2d848122));
var $e5c28807f044a60a$export$68f3db7f6af48bcb = (0, $32c7a5ef60d1831d$export$e30d2ddc605f6bb)((0, $aa668dadae1ee6cd$export$68f3db7f6af48bcb), (0, $2f121db3d400a7f2$export$68f3db7f6af48bcb));
var $e5c28807f044a60a$export$1b2e4fe6ef471556 = (0, $32c7a5ef60d1831d$export$e30d2ddc605f6bb)((0, $373ecfd01b587d78$export$1b2e4fe6ef471556), (0, $0b415cb06590d81b$export$a88b0b0da9ef63ce));
var $e5c28807f044a60a$export$70a0c2f5862937b6 = (0, $32c7a5ef60d1831d$export$667425256e2e7296)((0, $ef02305e93d38cfe$export$70a0c2f5862937b6));
var $e5c28807f044a60a$export$1b8596b4b0ef673b = (0, $32c7a5ef60d1831d$export$667425256e2e7296)((0, $5407f49539ceea52$export$8b5103382c06639c));
var $e5c28807f044a60a$export$407687b2dd89cc68 = (0, $32c7a5ef60d1831d$export$e30d2ddc605f6bb)((0, $74e00d71dd66b21c$export$407687b2dd89cc68), (0, $ef02305e93d38cfe$export$70a0c2f5862937b6));
var $e5c28807f044a60a$export$ee11e928d3d045fd = (0, $32c7a5ef60d1831d$export$e30d2ddc605f6bb)((0, $1ff2ed273c1e5214$export$ee11e928d3d045fd), (0, $5407f49539ceea52$export$8b5103382c06639c));
var $e5c28807f044a60a$export$c4b5b1f965d8b3eb = (0, $32c7a5ef60d1831d$export$e30d2ddc605f6bb)((0, $807ff5327a76c7fe$export$c4b5b1f965d8b3eb), (0, $701d5396eb72984c$export$c4b5b1f965d8b3eb));
var $e5c28807f044a60a$export$17d3acb0b4379d02 = (0, $32c7a5ef60d1831d$export$e30d2ddc605f6bb)((0, $d47476c3a75b7640$export$17d3acb0b4379d02), (0, $840eb01c1734ebe0$export$bf4c5f97b468e8d6));
var $e5c28807f044a60a$export$21bfbeb62fdcce8d = (0, $32c7a5ef60d1831d$export$e30d2ddc605f6bb)((0, $4f72d54064feed25$export$21bfbeb62fdcce8d), (0, $78c17eeb06008ac8$export$21bfbeb62fdcce8d));
var $e5c28807f044a60a$export$c49a2b642fe9eef4 = (0, $32c7a5ef60d1831d$export$e30d2ddc605f6bb)((0, $d4ffd9e5f2cef8fe$export$c49a2b642fe9eef4), (0, $083a696f8e2d95a0$export$602140a6a10b02bf));
var $e5c28807f044a60a$export$3c6158790f5e01c4 = (0, $32c7a5ef60d1831d$export$436fcf6e31fbacea)((0, $f91c71cad280ca7f$export$3c6158790f5e01c4), (0, $508ce61f11a3a789$export$3c6158790f5e01c4));
var $e5c28807f044a60a$export$dabef2be6cd28c20 = (0, $32c7a5ef60d1831d$export$436fcf6e31fbacea)((0, $07206c874cffd34a$export$dabef2be6cd28c20), (0, $4db70b2e6f76ba0c$export$de148263c75d2bc1));
var $e5c28807f044a60a$export$8d789f76fde3e05 = (0, $32c7a5ef60d1831d$export$e30d2ddc605f6bb)((0, $3ddf4511117ec2bd$export$8d789f76fde3e05), (0, $77de63f0b90e2204$export$8d789f76fde3e05));
var $e5c28807f044a60a$export$94e206806e36c2ec = (0, $32c7a5ef60d1831d$export$e30d2ddc605f6bb)((0, $63d22dd409edae8e$export$94e206806e36c2ec), (0, $abb4c183d82eabca$export$78c0b4d8be34c9b2));
var $e5c28807f044a60a$export$1bf47cdade1a9fcb = (0, $32c7a5ef60d1831d$export$e30d2ddc605f6bb)((0, $254ae2e514074c6b$export$1bf47cdade1a9fcb), (0, $77de63f0b90e2204$export$8d789f76fde3e05));
var $e5c28807f044a60a$export$6e87ce8d41eda665 = (0, $32c7a5ef60d1831d$export$e30d2ddc605f6bb)((0, $c779b4e9d6dc1521$export$6e87ce8d41eda665), (0, $7b6b7e76773b7419$export$68d7391318cdef11));
var $e5c28807f044a60a$export$e84e925618e0e5bc = (0, $32c7a5ef60d1831d$export$667425256e2e7296)((0, $04e5c7b99b518b6e$export$71743a944cb62e48));
var $e5c28807f044a60a$export$1940ba72c868b663 = (0, $32c7a5ef60d1831d$export$667425256e2e7296)((0, $3977e5b1edd67333$export$38c7b37a3e5e8d70));
var $e5c28807f044a60a$export$eeccc49dc7a12d9f = (0, $32c7a5ef60d1831d$export$436fcf6e31fbacea)((0, $dd57b5534d9c8bad$export$eeccc49dc7a12d9f), (0, $ef3200acd4dd189e$export$eeccc49dc7a12d9f));
var $e5c28807f044a60a$export$a1c6484cdecc2c4b = (0, $32c7a5ef60d1831d$export$436fcf6e31fbacea)((0, $dd86d607cf9e8d92$export$a1c6484cdecc2c4b), (0, $7312026661045ee4$export$a5b9122e89b32ad3));
var $e5c28807f044a60a$export$f3f5aa321d88adf9 = (0, $32c7a5ef60d1831d$export$436fcf6e31fbacea)((0, $68bc3c849d9fd0fe$export$f3f5aa321d88adf9), (0, $4f9732d887e085b6$export$f3f5aa321d88adf9));
var $e5c28807f044a60a$export$bb4ae5b41b43be04 = (0, $32c7a5ef60d1831d$export$436fcf6e31fbacea)((0, $4821146c88fc2e7a$export$bb4ae5b41b43be04), (0, $535fb25abeb69827$export$2bc88a281410ffa7));
var $e5c28807f044a60a$export$4384da9b8b140bf4 = (0, $32c7a5ef60d1831d$export$e30d2ddc605f6bb)((0, $bf3ce5cac71ed0fb$export$4384da9b8b140bf4), (0, $80ddb30da36b08ce$export$4384da9b8b140bf4));
var $e5c28807f044a60a$export$60e26212f3b61a28 = (0, $32c7a5ef60d1831d$export$e30d2ddc605f6bb)((0, $d72a3f3cf76878be$export$60e26212f3b61a28), (0, $50e26eff8a8bc584$export$1b13139dfc0336af));
var $e5c28807f044a60a$export$e23ae35269442b4f = (0, $32c7a5ef60d1831d$export$2469203854060337)((0, $8e27972843b9c298$export$e23ae35269442b4f), (0, $70f94f8ec7b1b295$export$e23ae35269442b4f), (0, $2e769877b28b6c1c$export$9e62346a60cfb459));
var $e5c28807f044a60a$export$a0f6cb8061290bbb = (0, $32c7a5ef60d1831d$export$2469203854060337)((0, $907ff11a1071d0d7$export$a0f6cb8061290bbb), (0, $f8f680c2b9153e80$export$b0e15f0a1c9f4c55), (0, $e0c14a4c94331bbd$export$5e38d02efdb45577));
var $e5c28807f044a60a$export$3f95fcfdc25a741d = (0, $32c7a5ef60d1831d$export$e30d2ddc605f6bb)((0, $053b89dee6a0094b$export$3f95fcfdc25a741d), (0, $22b6ae01216a6a81$export$3f95fcfdc25a741d));
var $e5c28807f044a60a$export$a4a891d202775deb = (0, $32c7a5ef60d1831d$export$e30d2ddc605f6bb)((0, $fecf9fe2b046b3a2$export$a4a891d202775deb), (0, $0d052c1f365de2d0$export$2b896c4d595a4331));
var $e5c28807f044a60a$export$1e02e7298035a77c = (0, $32c7a5ef60d1831d$export$e30d2ddc605f6bb)((0, $bde93df51b3897c4$export$1e02e7298035a77c), (0, $7b0cb8c2403d85b2$export$1e02e7298035a77c));
var $e5c28807f044a60a$export$33908560ea1b226d = (0, $32c7a5ef60d1831d$export$e30d2ddc605f6bb)((0, $2a97c4bc3293e3ce$export$33908560ea1b226d), (0, $4997c0e4e5416e87$export$3a6e8b37e069a69d));



var $5Y5FQ = parcelRequire("5Y5FQ");

var $cS1ic = parcelRequire("cS1ic");

var $25nEq = parcelRequire("25nEq");

var $lAD7C = parcelRequire("lAD7C");

var $5FkrB = parcelRequire("5FkrB");

var $74Zh5 = parcelRequire("74Zh5");

var $dLGML = parcelRequire("dLGML");

var $fC8ib = parcelRequire("fC8ib");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $kIXpt = parcelRequire("kIXpt");

var $cYPzS = parcelRequire("cYPzS");

var $lwlXp = parcelRequire("lwlXp");

var $eyuDe = parcelRequire("eyuDe");

var $25nEq = parcelRequire("25nEq");

var $ekGgq = parcelRequire("ekGgq");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $25nEq = parcelRequire("25nEq");
function $75f76cf0d51f047e$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $75f76cf0d51f047e$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $75f76cf0d51f047e$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $75f76cf0d51f047e$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $75f76cf0d51f047e$export$ad4be5c2ec28cecf = function isAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $75f76cf0d51f047e$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === 'AnalyticsEvent';
};
var $75f76cf0d51f047e$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function AnalyticsEvent(props) {
        var _this = this;
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, AnalyticsEvent);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "_isAnalyticsEvent", true);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "clone", function() {
            // just a shallow clone, don't change sub refs unless you want to
            // affect the original's too
            var payload = $75f76cf0d51f047e$var$_objectSpread({}, _this.payload);
            return new AnalyticsEvent({
                payload: payload
            });
        });
        this.payload = props.payload;
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(AnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (typeof updater === 'function') this.payload = updater(this.payload);
                if ((0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(updater) === 'object') this.payload = $75f76cf0d51f047e$var$_objectSpread($75f76cf0d51f047e$var$_objectSpread({}, this.payload), updater);
                return this;
            }
        }
    ]);
}();


function $1c70d42a822a2f86$var$_callSuper(t, o, e) {
    return o = (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(o), (0, (/*@__PURE__*/$parcel$interopDefault($kIXpt)))(t, $1c70d42a822a2f86$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(t).constructor) : o.apply(t, e));
}
function $1c70d42a822a2f86$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($1c70d42a822a2f86$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $1c70d42a822a2f86$var$_superPropGet(t, o, e, r) {
    var p = (0, (/*@__PURE__*/$parcel$interopDefault($lwlXp)))((0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(1 & r ? t.prototype : t), o, e);
    return 2 & r && "function" == typeof p ? function(t) {
        return p.apply(e, t);
    } : p;
}
var $1c70d42a822a2f86$export$35f8383928ba8d7 = function isUIAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $1c70d42a822a2f86$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isUIAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === 'UIAnalyticsEvent';
};
var $1c70d42a822a2f86$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_AnalyticsEvent) {
    function UIAnalyticsEvent(props) {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, UIAnalyticsEvent);
        _this = $1c70d42a822a2f86$var$_callSuper(this, UIAnalyticsEvent, [
            props
        ]);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "_isUIAnalyticsEvent", true);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "clone", function() {
            if (_this.hasFired) return null;
            var context = (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(_this.context);
            var handlers = (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(_this.handlers);
            /**
       * A hacky "deep clone" of the object. This is limited in that it wont
       * support functions, regexs, Maps, Sets, etc, but none of those need to
       * be represented in our payload.
       */ var payload = JSON.parse(JSON.stringify(_this.payload));
            return new UIAnalyticsEvent({
                context: context,
                handlers: handlers,
                payload: payload
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "fire", function(channel) {
            if (_this.hasFired) return;
            _this.handlers.forEach(function(handler) {
                return handler(_this, channel);
            });
            _this.hasFired = true;
        });
        _this.context = props.context || [];
        _this.handlers = props.handlers || [];
        _this.hasFired = false;
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($eyuDe)))(UIAnalyticsEvent, _AnalyticsEvent);
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(UIAnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (this.hasFired) return this;
                return $1c70d42a822a2f86$var$_superPropGet(UIAnalyticsEvent, "update", this, 3)([
                    updater
                ]);
            }
        }
    ]);
}((0, $75f76cf0d51f047e$export$2e2bcd8739ae039));



var $5FkrB = parcelRequire("5FkrB");

var $iyyOp = parcelRequire("iyyOp");
var $dd4c2c210233ec7c$export$d1f587f82ad51c4 = function useAnalyticsContext() {
    return (0, $5FkrB.useContext)((0, $iyyOp.default));
};


function $629ae1a8f7e1c5ec$export$5bf35293e545f20c() {
    var analyticsContext = (0, $dd4c2c210233ec7c$export$d1f587f82ad51c4)();
    var createAnalyticsEvent = (0, $dLGML.useCallbackOne)(function(payload) {
        return new (0, $1c70d42a822a2f86$export$2e2bcd8739ae039)({
            context: analyticsContext.getAtlaskitAnalyticsContext(),
            handlers: analyticsContext.getAtlaskitAnalyticsEventHandlers(),
            payload: payload
        });
    }, [
        analyticsContext
    ]);
    return {
        createAnalyticsEvent: createAnalyticsEvent
    };
}



var $ekGgq = parcelRequire("ekGgq");

var $5FkrB = parcelRequire("5FkrB");

var $b5lkZ = parcelRequire("b5lkZ");

var $9dOvm = parcelRequire("9dOvm");
var $0a5917e19a4a8cd6$var$_process, $0a5917e19a4a8cd6$var$_process2;
// We can't rely on NODE_ENV === 'test' if its value is already configured by the consumer to some other value, so better to use JEST_WORKER_ID
// https://jestjs.io/docs/environment-variables#jest_worker_id
var $0a5917e19a4a8cd6$var$TESTS_MODE = (globalThis === null || globalThis === void 0 || ($0a5917e19a4a8cd6$var$_process = globalThis.process) === null || $0a5917e19a4a8cd6$var$_process === void 0 || ($0a5917e19a4a8cd6$var$_process = $0a5917e19a4a8cd6$var$_process.env) === null || $0a5917e19a4a8cd6$var$_process === void 0 ? void 0 : $0a5917e19a4a8cd6$var$_process.JEST_WORKER_ID) !== undefined;
var $0a5917e19a4a8cd6$var$DEBUG_MODE = !$0a5917e19a4a8cd6$var$TESTS_MODE && (globalThis === null || globalThis === void 0 || ($0a5917e19a4a8cd6$var$_process2 = globalThis.process) === null || $0a5917e19a4a8cd6$var$_process2 === void 0 || ($0a5917e19a4a8cd6$var$_process2 = $0a5917e19a4a8cd6$var$_process2.env) === null || $0a5917e19a4a8cd6$var$_process2 === void 0 ? void 0 : $0a5917e19a4a8cd6$var$_process2.NODE_ENV) !== 'production';
var $0a5917e19a4a8cd6$export$1c9f709888824e05 = function debug() {
    var _console;
    if (!$0a5917e19a4a8cd6$var$DEBUG_MODE) return;
    // eslint-disable-next-line no-console
    (_console = console).debug.apply(_console, arguments);
};



var $3ZMUU = parcelRequire("3ZMUU");
var $c6a4821229e06dbc$var$pkgName = '@atlaskit/platform-feature-flags';
var $c6a4821229e06dbc$export$7e41b1b2bdee3f98 = '__PLATFORM_FEATURE_FLAGS__';
var $c6a4821229e06dbc$var$hasProcessEnv = typeof $3ZMUU !== 'undefined' && typeof $3ZMUU.env !== 'undefined';
// FF global overrides can be configured by test runners or Storybook
var $c6a4821229e06dbc$var$ENV_ENABLE_PLATFORM_FF = $c6a4821229e06dbc$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
// STORYBOOK_ENABLE_PLATFORM_FF is included as storybook only allows env vars prefixed with STORYBOOK
// https://github.com/storybookjs/storybook/issues/12270
var $c6a4821229e06dbc$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF = $c6a4821229e06dbc$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
var $c6a4821229e06dbc$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE = $c6a4821229e06dbc$var$ENV_ENABLE_PLATFORM_FF || $c6a4821229e06dbc$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF;
var $c6a4821229e06dbc$var$DEFAULT_PFF_GLOBAL = {
    booleanResolver: undefined
};
var $c6a4821229e06dbc$var$globalVar = typeof window !== 'undefined' ? window : globalThis;
$c6a4821229e06dbc$var$globalVar[$c6a4821229e06dbc$export$7e41b1b2bdee3f98] = $c6a4821229e06dbc$var$globalVar[$c6a4821229e06dbc$export$7e41b1b2bdee3f98] || $c6a4821229e06dbc$var$DEFAULT_PFF_GLOBAL;
function $c6a4821229e06dbc$export$f2b591175b3e424c(resolver) {
    $c6a4821229e06dbc$var$globalVar[$c6a4821229e06dbc$export$7e41b1b2bdee3f98].booleanResolver = resolver;
}
function $c6a4821229e06dbc$export$6333b6aff9fc6275(flagKey) {
    if ($c6a4821229e06dbc$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE) {
        (0, $0a5917e19a4a8cd6$export$1c9f709888824e05)('[%s]: The feature flags were enabled while running tests. The flag "%s" will be always enabled.', $c6a4821229e06dbc$var$pkgName, flagKey);
        return true;
    }
    try {
        var _globalVar$PFF_GLOBAL, _globalVar$PFF_GLOBAL2, _globalVar$PFF_GLOBAL3;
        // booleanResolver will be empty for products like Trello, Elevate, Recruit etc.
        // Currently only Confluence, Jira and Bitbucket has set it.
        if (((_globalVar$PFF_GLOBAL = $c6a4821229e06dbc$var$globalVar[$c6a4821229e06dbc$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL === void 0 ? void 0 : _globalVar$PFF_GLOBAL.booleanResolver) === undefined || ((_globalVar$PFF_GLOBAL2 = $c6a4821229e06dbc$var$globalVar[$c6a4821229e06dbc$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL2 === void 0 ? void 0 : _globalVar$PFF_GLOBAL2.booleanResolver) === null) // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
        return (0, $9dOvm.default).checkGate(flagKey);
        var result = (_globalVar$PFF_GLOBAL3 = $c6a4821229e06dbc$var$globalVar[$c6a4821229e06dbc$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL3 === void 0 ? void 0 : _globalVar$PFF_GLOBAL3.booleanResolver(flagKey);
        if (typeof result !== 'boolean') {
            // eslint-disable-next-line no-console
            console.warn("".concat(flagKey, " resolved to a non-boolean value, returning false for safety"));
            return false;
        }
        return result;
    } catch (e) {
        return false;
    }
}


function $05870a9c637c37b9$export$ba05d765b8392e5e(flagResolver) {
    (0, $c6a4821229e06dbc$export$f2b591175b3e424c)(flagResolver);
}
function $05870a9c637c37b9$export$470e5c2be1411c89(name) {
    return (0, $c6a4821229e06dbc$export$6333b6aff9fc6275)(name);
}
function $05870a9c637c37b9$export$b40ec24ac8275656(name) {
    return (0, $c6a4821229e06dbc$export$6333b6aff9fc6275)(name);
}


var $c266bfb019ace8e2$var$_React$useId;
// Type copied from https://github.com/thearnica/react-uid/blob/0f507fbbdb1ab84acf477ec32698afe3d2191e49/src/hooks.ts#L12
// Copied rather than inferred to make the type transparent
// @ts-ignore - useId is not accessible in React 16
var $c266bfb019ace8e2$var$react18UseId = ($c266bfb019ace8e2$var$_React$useId = (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).useId) !== null && $c266bfb019ace8e2$var$_React$useId !== void 0 ? $c266bfb019ace8e2$var$_React$useId : undefined;
function $c266bfb019ace8e2$export$f680877a34711e37() {
    if ($c266bfb019ace8e2$var$react18UseId && (0, $05870a9c637c37b9$export$b40ec24ac8275656)('platform.design-system-team.react-18-use-id_mn8q4')) // eslint-disable-next-line react-hooks/rules-of-hooks
    return $c266bfb019ace8e2$var$react18UseId();
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return "uid".concat((0, $b5lkZ.useUID)());
}
var $c266bfb019ace8e2$export$6be90bcb437e928f = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function(_ref, ref) {
    var children = _ref.children, _ref$postfix = _ref.postfix, postfix = _ref$postfix === void 0 ? '' : _ref$postfix, _ref$prefix = _ref.prefix, prefix = _ref$prefix === void 0 ? '' : _ref$prefix;
    var id = "".concat(prefix).concat($c266bfb019ace8e2$export$f680877a34711e37()).concat(postfix);
    (0, $5FkrB.useEffect)(function() {
        if (!ref) return;
        switch((0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(ref)){
            case 'function':
                ref(id);
                break;
            case 'object':
                ref.current = id;
                break;
            default:
                throw new Error("Unreachable case for unsupported type of ref \"".concat((0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(ref), "\""));
        }
    }, [
        id,
        ref
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).Fragment, null, typeof children === 'function' ? children({
        id: id
    }) : children);
});
function $c266bfb019ace8e2$export$6ee17796e3d70de2() {
    if ($c266bfb019ace8e2$var$react18UseId && (0, $05870a9c637c37b9$export$b40ec24ac8275656)('platform.design-system-team.react-18-use-id_mn8q4')) {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        var uid = $c266bfb019ace8e2$var$react18UseId();
        return function(id) {
            return "".concat(uid, "-").concat(id.toString());
        };
    }
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return (0, $b5lkZ.useUIDSeed)();
}


/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5FkrB = parcelRequire("5FkrB");

var $74Zh5 = parcelRequire("74Zh5");
var $3cb9a830afcc553b$var$BORDER_WIDTH = 2;
var $3cb9a830afcc553b$var$baseFocusOutsideStyles = (0, $74Zh5.css)({
    outline: "".concat($3cb9a830afcc553b$var$BORDER_WIDTH, "px solid ", "var(--ds-border-focused, #2684FF)"),
    outlineOffset: $3cb9a830afcc553b$var$BORDER_WIDTH
});
var $3cb9a830afcc553b$var$baseInsetStyles = (0, $74Zh5.css)({
    outlineColor: "var(--ds-border-focused, #2684FF)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    outlineOffset: -$3cb9a830afcc553b$var$BORDER_WIDTH,
    outlineStyle: 'solid',
    outlineWidth: "var(--ds-border-width-outline, 2px)"
});
var $3cb9a830afcc553b$var$focusRingStyles = (0, $74Zh5.css)({
    // Focus styles used when :focus-visible isn't supported
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
    '&:focus': $3cb9a830afcc553b$var$baseFocusOutsideStyles,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
    '&:focus-visible': $3cb9a830afcc553b$var$baseFocusOutsideStyles,
    // Remove default focus styles for mouse interactions if :focus-visible is supported
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
    '&:focus:not(:focus-visible)': {
        outline: 'none'
    },
    '@media screen and (forced-colors: active), screen and (-ms-high-contrast: active)': {
        '&:focus-visible': {
            outline: '1px solid'
        }
    }
});
var $3cb9a830afcc553b$var$insetFocusRingStyles = (0, $74Zh5.css)({
    // Focus styles used when :focus-visible isn't supported
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
    '&:focus': $3cb9a830afcc553b$var$baseInsetStyles,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
    '&:focus-visible': $3cb9a830afcc553b$var$baseInsetStyles,
    // Remove default focus styles for mouse interactions if :focus-visible is supported
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
    '&:focus:not(:focus-visible)': {
        outline: 'none'
    },
    '@media screen and (forced-colors: active), screen and (-ms-high-contrast: active)': {
        '&:focus-visible': {
            outline: '1px solid',
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
            outlineOffset: '-1px'
        }
    }
});
/**
 * __Focus ring__
 *
 * A focus ring visually indicates the currently focused item.
 *
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/focus-ring)
 *
 * @example
 * ```jsx
 * import FocusRing from '@atlaskit/focus-ring';
 *
 * const InteractiveComponent = () => (
 *   <FocusRing>
 *     <button type="button">Hello</button>
 *   </FocusRing>
 * )
 * ```
 */ var $3cb9a830afcc553b$var$FocusRing = /*#__PURE__*/ (0, $5FkrB.memo)(function(_ref) {
    var children = _ref.children, isInset = _ref.isInset, focus = _ref.focus;
    var controlledStyles = isInset ? $3cb9a830afcc553b$var$baseInsetStyles : $3cb9a830afcc553b$var$baseFocusOutsideStyles;
    var uncontrolledStyles = isInset ? $3cb9a830afcc553b$var$insetFocusRingStyles : $3cb9a830afcc553b$var$focusRingStyles;
    var focusCls = typeof focus === 'undefined' ? uncontrolledStyles : focus === 'on' && controlledStyles;
    return (0, $74Zh5.jsx)((0, $74Zh5.ClassNames), null, function(_ref2) {
        var css = _ref2.css, cx = _ref2.cx;
        return (0, $5FkrB.Children).only(// This may look unwieldy but means we skip applying styles / cloning if no className is applicable
        focusCls ? /*#__PURE__*/ // eslint-disable-next-line @repo/internal/react/no-clone-element
        (0, $5FkrB.cloneElement)(children, {
            className: cx([
                css(focusCls),
                children.props.className
            ])
        }) : children);
    });
});
$3cb9a830afcc553b$var$FocusRing.displayName = 'FocusRing';
var $3cb9a830afcc553b$export$2e2bcd8739ae039 = $3cb9a830afcc553b$var$FocusRing;



var $dU8Y3 = parcelRequire("dU8Y3");
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ // Reds
var $8c59000063260604$export$4b84fd0e2c617bd = '#FFEBE6';
var $8c59000063260604$export$b34b069eff244586 = '#FFBDAD';
var $8c59000063260604$export$be802dd0d8b57f35 = '#FF8F73';
var $8c59000063260604$export$60847d42f9da92a6 = '#FF7452';
var $8c59000063260604$export$4a7404f376229999 = '#FF5630';
var $8c59000063260604$export$2010d0fb4295b346 = '#DE350B';
var $8c59000063260604$export$2837b5a1a71d5c02 = '#BF2600';
var $8c59000063260604$export$8d9596b529bbb9cf = '#FFFAE6';
var $8c59000063260604$export$41060a744ab0b7ae = '#FFF0B3';
var $8c59000063260604$export$1cc05bbbf340e559 = '#FFE380';
var $8c59000063260604$export$5aae31392d72caaa = '#FFC400';
var $8c59000063260604$export$c6930421db9fa514 = '#FFAB00';
var $8c59000063260604$export$59619663aa6500fb = '#FF991F';
var $8c59000063260604$export$874739ea9e379ab6 = '#FF8B00';
var $8c59000063260604$export$8a6341c32b6a3ee6 = '#E3FCEF';
var $8c59000063260604$export$69a3bf21b9686c2b = '#ABF5D1';
var $8c59000063260604$export$afbce1382ec95f73 = '#79F2C0';
var $8c59000063260604$export$747d86715d4175de = '#57D9A3';
var $8c59000063260604$export$940e1f69e873f202 = '#36B37E';
var $8c59000063260604$export$a49394138f7b8e85 = '#00875A';
var $8c59000063260604$export$6fa04827ac68a4fb = '#006644';
var $8c59000063260604$export$226de0355ed012f8 = '#DEEBFF';
var $8c59000063260604$export$8c13c2ee36917869 = '#B3D4FF';
var $8c59000063260604$export$ecfc1dff386a3e7a = '#4C9AFF';
var $8c59000063260604$export$215b7063051591f1 = '#2684FF';
var $8c59000063260604$export$e62e8919cca44969 = '#0065FF';
var $8c59000063260604$export$b3de0ae08da2ce64 = '#0052CC';
var $8c59000063260604$export$a6ee3d71bc067634 = '#0747A6';
var $8c59000063260604$export$67f15409e87642a1 = '#669DF1';
var $8c59000063260604$export$f0539dbc42dbb067 = '#8FB8F6';
var $8c59000063260604$export$363e4475840015bb = '#EAE6FF';
var $8c59000063260604$export$4b0a4417ed59760f = '#C0B6F2';
var $8c59000063260604$export$6011520a64d9a187 = '#998DD9';
var $8c59000063260604$export$a7175d4e9206bc80 = '#8777D9';
var $8c59000063260604$export$b48405b95304b5a1 = '#6554C0';
var $8c59000063260604$export$c71e4279dd54a18d = '#5243AA';
var $8c59000063260604$export$147899de772240ec = '#403294';
var $8c59000063260604$export$2cf711fe14c66f06 = '#E6FCFF';
var $8c59000063260604$export$7a8f4d33f6f9772c = '#B3F5FF';
var $8c59000063260604$export$776c9c497ef08533 = '#79E2F2';
var $8c59000063260604$export$69cb3ca10c1e330e = '#00C7E6';
var $8c59000063260604$export$9dc1ef0f3f48059b = '#00B8D9';
var $8c59000063260604$export$7c835c78b6fcdef8 = '#00A3BF';
var $8c59000063260604$export$6036577f95c3877e = '#008DA6';
var $8c59000063260604$export$29a4f05edc054374 = '#FFFFFF';
var $8c59000063260604$export$e655ef011c4aa1a2 = '#FAFBFC';
var $8c59000063260604$export$9fdfb749e33cdf97 = '#F4F5F7';
var $8c59000063260604$export$3e51e8f1440314ba = '#EBECF0';
var $8c59000063260604$export$1ce2d1575d444ceb = '#DFE1E6';
var $8c59000063260604$export$8754fc7e6d8b3000 = '#C1C7D0';
var $8c59000063260604$export$c2e91cbeada39b8b = '#B3BAC5';
var $8c59000063260604$export$5f71e19f3a7ad9de = '#A5ADBA';
var $8c59000063260604$export$eaa8c8a70ac22806 = '#97A0AF';
var $8c59000063260604$export$7c87d337fb91a97d = '#8993A4';
var $8c59000063260604$export$d6447c357493214f = '#7A869A';
var $8c59000063260604$export$f563ee71e9ee74cd = '#6B778C';
var $8c59000063260604$export$e2ef2124cf4024b1 = '#5E6C84';
var $8c59000063260604$export$eece5f492e429f08 = '#505F79';
var $8c59000063260604$export$c39c0fe0f26207ae = '#42526E';
var $8c59000063260604$export$7090862dc3038a9f = '#344563';
var $8c59000063260604$export$ad0bacf983b7ddaa = '#253858';
var $8c59000063260604$export$7d61b15e0da132af = '#172B4D';
var $8c59000063260604$export$fbda843f0a27fe96 = '#091E42';
var $8c59000063260604$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
var $8c59000063260604$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
var $8c59000063260604$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
var $8c59000063260604$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
var $8c59000063260604$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
var $8c59000063260604$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
var $8c59000063260604$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
var $8c59000063260604$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
var $8c59000063260604$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
var $8c59000063260604$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
var $8c59000063260604$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
var $8c59000063260604$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
var $8c59000063260604$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
var $8c59000063260604$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
var $8c59000063260604$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
var $8c59000063260604$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
var $8c59000063260604$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
var $8c59000063260604$export$2f6319cf7d736c2a = '#E6EDFA';
var $8c59000063260604$export$95126bc8884d6634 = '#DCE5F5';
var $8c59000063260604$export$8338d8c35d44ff1 = '#CED9EB';
var $8c59000063260604$export$5368d76ae4fbbda7 = '#B8C7E0';
var $8c59000063260604$export$9f0a771d16ec8d36 = '#ABBBD6';
var $8c59000063260604$export$abcf8c38338b4aa5 = '#9FB0CC';
var $8c59000063260604$export$97e81faa16a182c7 = '#8C9CB8';
var $8c59000063260604$export$bfe21c59123ecf33 = '#7988A3';
var $8c59000063260604$export$ee82aa2ea6a1558 = '#67758F';
var $8c59000063260604$export$682927c6ed76be02 = '#56637A';
var $8c59000063260604$export$91fd9994c5be9757 = '#455166';
var $8c59000063260604$export$d281fbfe3cff2df6 = '#3B475C';
var $8c59000063260604$export$3902c91d8b98a753 = '#313D52';
var $8c59000063260604$export$8e8133c1ba5845b5 = '#283447';
var $8c59000063260604$export$33ff357f6620b39 = '#202B3D';
var $8c59000063260604$export$633847cf062b69e0 = '#1B2638';
var $8c59000063260604$export$9776a6e503bdbf76 = '#121A29';
var $8c59000063260604$export$6c813d5160dff5db = '#0E1624';
var $8c59000063260604$export$3d4f271a500072a = '#0D1424';
var $8c59000063260604$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
var $8c59000063260604$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
var $8c59000063260604$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
var $8c59000063260604$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
var $8c59000063260604$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
var $8c59000063260604$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
var $8c59000063260604$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
var $8c59000063260604$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
var $8c59000063260604$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
var $8c59000063260604$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
var $8c59000063260604$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
var $8c59000063260604$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
var $8c59000063260604$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
var $8c59000063260604$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
var $8c59000063260604$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
var $8c59000063260604$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
var $8c59000063260604$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';
var $8c59000063260604$export$d2adc5dedf09fced = '#292A2E';
var $8c59000063260604$export$f51762073d2bb381 = '#94C748';
var $8c59000063260604$export$95e26d54def96891 = '#B3DF72';



var $25nEq = parcelRequire("25nEq");

var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");

var $74Zh5 = parcelRequire("74Zh5");
var $1ec978923a0f4fc0$exports = {};
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::67744cfb74ed451c0181f18c132cbdd7>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty($1ec978923a0f4fc0$exports, "__esModule", {
    value: true
});
$1ec978923a0f4fc0$exports.default = void 0;

var $1ec978923a0f4fc0$var$_react = $1ec978923a0f4fc0$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $1ec978923a0f4fc0$var$_person = $1ec978923a0f4fc0$var$_interopRequireDefault((parcelRequire("gENTG")));

var $1ec978923a0f4fc0$var$_person2 = $1ec978923a0f4fc0$var$_interopRequireDefault((parcelRequire("fjELu")));
function $1ec978923a0f4fc0$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for PersonIcon.
 * This component is PersonIcon, with `UNSAFE_fallbackIcon` set to "PersonIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Known uses: representing a person or user, owner, contributor.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $1ec978923a0f4fc0$var$PersonIcon = (props)=>/*#__PURE__*/ $1ec978923a0f4fc0$var$_react.default.createElement($1ec978923a0f4fc0$var$_person.default, Object.assign({
        LEGACY_fallbackIcon: $1ec978923a0f4fc0$var$_person2.default
    }, props));
$1ec978923a0f4fc0$var$PersonIcon.Name = 'PersonIconMigration';
var $1ec978923a0f4fc0$var$_default = $1ec978923a0f4fc0$exports.default = $1ec978923a0f4fc0$var$PersonIcon;


var $854c41d58fae7bc7$exports = {};
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::553e71e438a60de37e6f93988cb1bfa5>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty($854c41d58fae7bc7$exports, "__esModule", {
    value: true
});
$854c41d58fae7bc7$exports.default = void 0;

var $854c41d58fae7bc7$var$_react = $854c41d58fae7bc7$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $854c41d58fae7bc7$var$_release = $854c41d58fae7bc7$var$_interopRequireDefault((parcelRequire("3w44K")));

var $854c41d58fae7bc7$var$_ship = $854c41d58fae7bc7$var$_interopRequireDefault((parcelRequire("7EoFn")));
function $854c41d58fae7bc7$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for ReleaseIcon.
 * This component is ReleaseIcon, with `UNSAFE_fallbackIcon` set to "ShipIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for releases in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $854c41d58fae7bc7$var$ReleaseIcon = (props)=>/*#__PURE__*/ $854c41d58fae7bc7$var$_react.default.createElement($854c41d58fae7bc7$var$_release.default, Object.assign({
        LEGACY_fallbackIcon: $854c41d58fae7bc7$var$_ship.default
    }, props));
$854c41d58fae7bc7$var$ReleaseIcon.Name = 'ReleaseIconMigration';
var $854c41d58fae7bc7$var$_default = $854c41d58fae7bc7$exports.default = $854c41d58fae7bc7$var$ReleaseIcon;



var $gENTG = parcelRequire("gENTG");

var $3w44K = parcelRequire("3w44K");

var $dU8Y3 = parcelRequire("dU8Y3");

// eslint-disable-next-line @atlaskit/design-system/no-deprecated-imports
/* eslint-disable no-console */ var $115fe6a3a9d366f1$var$printed = {};
function $115fe6a3a9d366f1$export$2e2bcd8739ae039(message) {
    if ($115fe6a3a9d366f1$var$printed[message]) return;
    $115fe6a3a9d366f1$var$printed[message] = true;
    if (typeof window !== 'undefined') console.warn(message);
}



var $3ZMUU = parcelRequire("3ZMUU");
function $767e9d663f70663d$export$2e2bcd8739ae039(packageName, api, additionalMessage) {
    (0, $115fe6a3a9d366f1$export$2e2bcd8739ae039)("[".concat(packageName, "]: The ").concat(api, " is deprecated.").concat(additionalMessage && " ".concat(additionalMessage)));
}
function $767e9d663f70663d$export$eb1decd851a5ae56(packageName, propName, predicate, deprecationAnnouncementOnDAC) {
    typeof $3ZMUU;
}



var $17ac36b9e8166c5c$export$44ffba16bd48dac6 = '__ATLASKIT_THEME__';
var $17ac36b9e8166c5c$export$c93026a968943f95 = 'light';
var $17ac36b9e8166c5c$export$6ba72c8346b4c57e = [
    'light',
    'dark'
];
var $17ac36b9e8166c5c$export$7a57f79000377ca2 = function borderRadius() {
    return 3;
};
var $17ac36b9e8166c5c$export$6d8204c2cb2e06b8 = function gridSize() {
    return 8;
};
var $17ac36b9e8166c5c$export$8e24544ddba725ee = function focusRing() {
    var color = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "var(--ds-border-focused, ".concat((0, $8c59000063260604$export$215b7063051591f1), ")");
    var outlineWidth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $17ac36b9e8166c5c$export$6d8204c2cb2e06b8() / 4;
    (0, $767e9d663f70663d$export$2e2bcd8739ae039)('@atlaskit/theme', 'focus ring mixin', 'Please use `@atlaskit/focus-ring` instead.');
    return "\n  &:focus {\n    outline: none;\n    box-shadow: 0px 0px 0px ".concat(outlineWidth, "px ").concat(color, ";\n  }\n");
};
var $17ac36b9e8166c5c$export$c0dd343266bc3261 = function noFocusRing() {
    return "\n  box-shadow: none;\n";
};
var $17ac36b9e8166c5c$export$7be255094ccdc533 = {
    card: function card() {
        return 100;
    },
    navigation: function navigation() {
        return 200;
    },
    dialog: function dialog() {
        return 300;
    },
    layer: function layer() {
        return 400;
    },
    blanket: function blanket() {
        return 500;
    },
    modal: function modal() {
        return 510;
    },
    flag: function flag() {
        return 600;
    },
    spotlight: function spotlight() {
        return 700;
    },
    tooltip: function tooltip() {
        return 9999;
    }
};
var $17ac36b9e8166c5c$export$a1b3edb637fb4f35 = function visuallyHidden() {
    (0, $767e9d663f70663d$export$2e2bcd8739ae039)('@atlaskit/theme', 'visually hidden mixin', 'Please use `@atlaskit/visually-hidden` instead.');
    return {
        border: '0 !important',
        clip: 'rect(1px, 1px, 1px, 1px) !important',
        height: '1px !important',
        overflow: 'hidden !important',
        padding: '0 !important',
        position: 'absolute !important',
        width: '1px !important',
        whiteSpace: 'nowrap !important'
    };
};
var $17ac36b9e8166c5c$export$ba1d834b86d72a09 = $17ac36b9e8166c5c$export$a1b3edb637fb4f35;
var $17ac36b9e8166c5c$export$e497e856b4f89fcd = function skeletonShimmer() {
    return {
        css: {
            backgroundColor: "var(--ds-skeleton, ".concat((0, $8c59000063260604$export$8d43898f60b96a82), ")"),
            animationDuration: '1.5s',
            animationIterationCount: 'infinite',
            animationTimingFunction: 'linear',
            animationDirection: 'alternate'
        },
        keyframes: {
            from: {
                backgroundColor: "var(--ds-skeleton, ".concat((0, $8c59000063260604$export$8d43898f60b96a82), ")")
            },
            to: {
                backgroundColor: "var(--ds-skeleton-subtle, ".concat((0, $8c59000063260604$export$920c0d5c49070351), ")")
            }
        }
    };
};


var $61e5774f84a75f10$export$9a270941bcff7e77 = {
    xsmall: (0, $17ac36b9e8166c5c$export$6d8204c2cb2e06b8)() * 2,
    small: (0, $17ac36b9e8166c5c$export$6d8204c2cb2e06b8)() * 3,
    medium: (0, $17ac36b9e8166c5c$export$6d8204c2cb2e06b8)() * 4,
    large: (0, $17ac36b9e8166c5c$export$6d8204c2cb2e06b8)() * 5,
    xlarge: (0, $17ac36b9e8166c5c$export$6d8204c2cb2e06b8)() * 12,
    xxlarge: (0, $17ac36b9e8166c5c$export$6d8204c2cb2e06b8)() * 16
};
var $61e5774f84a75f10$export$e6da6efe4d1a5c9b = {
    xsmall: 2,
    small: 2,
    medium: 3,
    large: 3,
    xlarge: 6,
    xxlarge: 12
};
var $61e5774f84a75f10$export$e2bd4c1faded7921 = 2;
var $61e5774f84a75f10$export$89a980dfdf90df51 = 0.9;
var $61e5774f84a75f10$export$3c061e31594ebabe = '--avatar-background-color';
var $61e5774f84a75f10$export$fdc820179f1f9be4 = {
    small: 12,
    medium: 14,
    large: 15,
    xlarge: 18
};
var $61e5774f84a75f10$export$382610e783aa2ae8 = {
    small: 0,
    medium: 0,
    large: 1,
    xlarge: 7
};


function $ab8f08636cc80173$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $ab8f08636cc80173$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $ab8f08636cc80173$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $ab8f08636cc80173$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $ab8f08636cc80173$var$avatarDefaultIconStyles = (0, $74Zh5.css)({
    display: 'flex',
    width: '100%',
    height: '100%',
    backgroundColor: "var(--ds-icon-subtle, ".concat((0, $8c59000063260604$export$7c87d337fb91a97d), ")")
});
var $ab8f08636cc80173$var$avatarDefaultIconVisualRefreshStyles = (0, $74Zh5.css)({
    display: 'flex',
    width: '100%',
    height: '100%',
    backgroundColor: "var(--ds-background-accent-gray-subtler, #DCDFE4)"
});
var $ab8f08636cc80173$var$nestedAvatarStyles = Object.entries((0, $61e5774f84a75f10$export$9a270941bcff7e77)).reduce(function(styles, _ref) {
    var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_ref, 2), key = _ref2[0], size = _ref2[1];
    return $ab8f08636cc80173$var$_objectSpread($ab8f08636cc80173$var$_objectSpread({}, styles), {}, (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, key, (0, $74Zh5.css)({
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '& svg': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            width: "".concat(size, "px"),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            height: "".concat(size, "px")
        }
    })));
}, {});
var $ab8f08636cc80173$var$avatarImageStyles = (0, $74Zh5.css)({
    display: 'flex',
    width: '100%',
    height: '100%',
    flex: '1 1 100%'
});
/**
 * __Avatar image__
 *
 * An avatar image is an internal component used to control the rendering phases of an image.
 */ var $ab8f08636cc80173$var$AvatarImage = function AvatarImage(_ref3) {
    var _ref3$alt = _ref3.alt, alt = _ref3$alt === void 0 ? '' : _ref3$alt, src = _ref3.src, appearance = _ref3.appearance, size = _ref3.size, testId = _ref3.testId;
    var _useState = (0, $5FkrB.useState)(false), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), hasImageErrored = _useState2[0], setHasImageErrored = _useState2[1];
    var borderRadius = appearance === 'circle' ? '50%' : "".concat((0, $61e5774f84a75f10$export$e6da6efe4d1a5c9b)[size], "px");
    var isHidden = !alt ? true : undefined;
    // If src changes, reset state
    (0, $5FkrB.useEffect)(function() {
        setHasImageErrored(false);
    }, [
        src
    ]);
    if (!src || hasImageErrored) return (0, $74Zh5.jsx)("span", {
        css: [
            (0, $dU8Y3.fg)('platform-component-visual-refresh') ? $ab8f08636cc80173$var$avatarDefaultIconVisualRefreshStyles : $ab8f08636cc80173$var$avatarDefaultIconStyles,
            $ab8f08636cc80173$var$nestedAvatarStyles[size]
        ]
    }, appearance === 'circle' ? (0, $dU8Y3.fg)('platform-component-visual-refresh') ? (0, $74Zh5.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($gENTG))), {
        label: alt,
        color: "var(--ds-icon-subtle, #626F86)",
        testId: testId && "".concat(testId, "--person"),
        spacing: "spacious"
    }) : (0, $74Zh5.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1ec978923a0f4fc0$exports))), {
        label: alt,
        color: "var(--ds-icon-inverse, ".concat((0, $8c59000063260604$export$29a4f05edc054374), ")"),
        LEGACY_secondaryColor: "var(--ds-icon-subtle, ".concat((0, $8c59000063260604$export$7c87d337fb91a97d), ")"),
        testId: testId && "".concat(testId, "--person"),
        spacing: "spacious"
    }) : (0, $dU8Y3.fg)('platform-component-visual-refresh') ? (0, $74Zh5.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3w44K))), {
        label: alt,
        color: "var(--ds-icon-subtle, #626F86)",
        testId: testId && "".concat(testId, "--ship"),
        spacing: "spacious"
    }) : (0, $74Zh5.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($854c41d58fae7bc7$exports))), {
        label: alt,
        color: "var(--ds-icon-inverse, ".concat((0, $8c59000063260604$export$29a4f05edc054374), ")"),
        LEGACY_secondaryColor: "var(--ds-icon-subtle, ".concat((0, $8c59000063260604$export$7c87d337fb91a97d), ")"),
        testId: testId && "".concat(testId, "--ship"),
        spacing: "spacious"
    }));
    return (0, $74Zh5.jsx)("img", {
        src: src,
        alt: alt,
        "data-testid": testId && "".concat(testId, "--image"),
        css: $ab8f08636cc80173$var$avatarImageStyles,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            borderRadius: borderRadius
        },
        onError: function onError() {
            return setHasImageErrored(true);
        },
        "aria-hidden": isHidden,
        "data-vc": testId ? "".concat(testId, "--image") : 'avatar-image',
        "data-ssr-placeholder-ignored": true
    });
};
var $ab8f08636cc80173$export$2e2bcd8739ae039 = $ab8f08636cc80173$var$AvatarImage;




var $5FkrB = parcelRequire("5FkrB");
var $d52acb751e558d18$export$a20dad690e1279e2 = /*#__PURE__*/ (0, $5FkrB.createContext)(undefined);
var $d52acb751e558d18$export$b50b87a1c4086b23 = function useAvatarContext() {
    return (0, $5FkrB.useContext)($d52acb751e558d18$export$a20dad690e1279e2);
};



var $5FkrB = parcelRequire("5FkrB");


/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $74Zh5 = parcelRequire("74Zh5");


var $0397340cd2230f68$var$iconWrapperStyles = (0, $74Zh5.css)({
    display: 'flex',
    boxSizing: 'border-box',
    width: '100%',
    height: '100%',
    alignItems: 'center',
    alignContent: 'center',
    borderRadius: "var(--ds-border-radius-circle, 50%)",
    overflow: 'hidden'
});
/**
 * __Icon wrapper__
 *
 * An icon wrapper is used internally only.
 */ var $0397340cd2230f68$var$IconWrapper = function IconWrapper(_ref) {
    var _ref$bgColor = _ref.bgColor, bgColor = _ref$bgColor === void 0 ? "var(--ds-surface-overlay, ".concat((0, $8c59000063260604$export$29a4f05edc054374), ")") : _ref$bgColor, children = _ref.children;
    return (0, $74Zh5.jsx)("span", {
        css: $0397340cd2230f68$var$iconWrapperStyles,
        role: "presentation",
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            border: "".concat((0, $61e5774f84a75f10$export$e2bd4c1faded7921), "px solid ").concat(bgColor),
            backgroundColor: bgColor
        }
    }, children);
};
var $0397340cd2230f68$export$2e2bcd8739ae039 = $0397340cd2230f68$var$IconWrapper;


var $737ff5795e5646ca$var$BusyIndicator = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $5FkrB.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("circle", {
    fill: "var(--ds-icon-danger, ".concat((0, $8c59000063260604$export$4a7404f376229999), ")"),
    cx: "4",
    cy: "4",
    r: "4"
}), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("path", {
    fill: "var(--ds-surface-overlay, ".concat((0, $8c59000063260604$export$29a4f05edc054374), ")"),
    d: "M3.3,1.9l2.8,2.8c0.2,0.2,0.2,0.5,0,0.7L5.4,6.1c-0.2,0.2-0.5,0.2-0.7,0L1.9,3.3c-0.2-0.2-0.2-0.5,0-0.7l0.7-0.7C2.8,1.7,3.1,1.7,3.3,1.9z"
}));
var $737ff5795e5646ca$var$FocusIndicator = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $5FkrB.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("path", {
    fill: "var(--ds-icon-discovery, ".concat((0, $8c59000063260604$export$b48405b95304b5a1), ")"),
    d: "M4,8 C1.790861,8 0,6.209139 0,4 C0,1.790861 1.790861,0 4,0 C6.209139,0 8,1.790861 8,4 C8,6.209139 6.209139,8 4,8 Z M4,6.66666667 C5.47275933,6.66666667 6.66666667,5.47275933 6.66666667,4 C6.66666667,2.52724067 5.47275933,1.33333333 4,1.33333333 C2.52724067,1.33333333 1.33333333,2.52724067 1.33333333,4 C1.33333333,5.47275933 2.52724067,6.66666667 4,6.66666667 Z M4,5.33333333 C3.26362033,5.33333333 2.66666667,4.73637967 2.66666667,4 C2.66666667,3.26362033 3.26362033,2.66666667 4,2.66666667 C4.73637967,2.66666667 5.33333333,3.26362033 5.33333333,4 C5.33333333,4.73637967 4.73637967,5.33333333 4,5.33333333 Z"
}));
var $737ff5795e5646ca$var$OfflineIndicator = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $5FkrB.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("path", {
    fill: "var(--ds-text-subtlest, ".concat((0, $8c59000063260604$export$f563ee71e9ee74cd), ")"),
    d: "M4,8 C6.209139,8 8,6.209139 8,4 C8,1.790861 6.209139,0 4,0 C1.790861,0 0,1.790861 0,4 C0,6.209139 1.790861,8 4,8 Z M4,6 C5.1045695,6 6,5.1045695 6,4 C6,2.8954305 5.1045695,2 4,2 C2.8954305,2 2,2.8954305 2,4 C2,5.1045695 2.8954305,6 4,6 Z"
}), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("path", {
    fill: "var(--ds-surface-overlay, ".concat((0, $8c59000063260604$export$1ce2d1575d444ceb), ")"),
    d: "M4,6 C5.1045695,6 6,5.1045695 6,4 C6,2.8954305 5.1045695,2 4,2 C2.8954305,2 2,2.8954305 2,4 C2,5.1045695 2.8954305,6 4,6 Z"
}));
var $737ff5795e5646ca$var$OnlineIndicator = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("circle", {
    fill: "var(--ds-icon-success, ".concat((0, $8c59000063260604$export$940e1f69e873f202), ")"),
    cx: "4",
    cy: "4",
    r: "4"
});
function $737ff5795e5646ca$var$getPresence(presence) {
    switch(presence){
        case 'busy':
            return $737ff5795e5646ca$var$BusyIndicator;
        case 'focus':
            return $737ff5795e5646ca$var$FocusIndicator;
        case 'offline':
            return $737ff5795e5646ca$var$OfflineIndicator;
        case 'online':
            return $737ff5795e5646ca$var$OnlineIndicator;
    }
}
/**
 * __Avatar presence__
 *
 * A presence shows an avatar’s availability.
 *
 * - [Examples](https://atlassian.design/components/avatar/avatar-presence/examples)
 * - [Code](https://atlassian.design/components/avatar/avatar-presence/code)
 * - [Usage](https://atlassian.design/components/avatar/avatar-presence/usage)
 */ var $737ff5795e5646ca$var$AvatarPresence = function AvatarPresence(_ref) {
    var borderColor = _ref.borderColor, children = _ref.children, presence = _ref.presence;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $0397340cd2230f68$export$2e2bcd8739ae039), {
        bgColor: borderColor
    }, presence ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("svg", {
        height: "100%",
        version: "1.1",
        viewBox: "0 0 8 8",
        width: "100%",
        xmlns: "http://www.w3.org/2000/svg"
    }, $737ff5795e5646ca$var$getPresence(presence)) : children);
};
var $737ff5795e5646ca$export$2e2bcd8739ae039 = $737ff5795e5646ca$var$AvatarPresence;
var $737ff5795e5646ca$export$972c5e90200fa0ef = function PresenceWrapper(_ref2) {
    var size = _ref2.size, appearance = _ref2.appearance, children = _ref2.children, borderColor = _ref2.borderColor, presence = _ref2.presence, testId = _ref2.testId;
    var position = appearance === 'square' ? -4 : (0, $61e5774f84a75f10$export$382610e783aa2ae8)[size];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("span", {
        "aria-hidden": "true",
        "data-testid": testId && "".concat(testId, "--presence"),
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            pointerEvents: 'none',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            position: 'absolute',
            bottom: "".concat(position, "px"),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            height: "".concat((0, $61e5774f84a75f10$export$fdc820179f1f9be4)[size], "px"),
            right: "".concat(position, "px"),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            width: "".concat((0, $61e5774f84a75f10$export$fdc820179f1f9be4)[size], "px")
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement($737ff5795e5646ca$var$AvatarPresence, {
        borderColor: borderColor,
        presence: !children ? presence : undefined
    }, children));
};



var $5FkrB = parcelRequire("5FkrB");



var $eecdbe0e7facaeb5$var$ApprovedIndicator = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $5FkrB.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("circle", {
    fill: "var(--ds-icon-success, ".concat((0, $8c59000063260604$export$a49394138f7b8e85), ")"),
    cx: "4",
    cy: "4",
    r: "4"
}), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("path", {
    fill: "var(--ds-surface-overlay, ".concat((0, $8c59000063260604$export$29a4f05edc054374), ")"),
    d: "M2.47140452,3.52859548 C2.21105499,3.26824595 1.78894501,3.26824595 1.52859548,3.52859548 C1.26824595,3.78894501 1.26824595,4.21105499 1.52859548,4.47140452 L2.86192881,5.80473785 C3.12227834,6.06508738 3.54438833,6.06508738 3.80473785,5.80473785 L6.47140452,3.13807119 C6.73175405,2.87772166 6.73175405,2.45561167 6.47140452,2.19526215 C6.21105499,1.93491262 5.78894501,1.93491262 5.52859548,2.19526215 L3.33333333,4.39052429 L2.47140452,3.52859548 Z"
}));
var $eecdbe0e7facaeb5$var$DeclinedIndicator = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $5FkrB.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("circle", {
    fill: "var(--ds-icon-danger, ".concat((0, $8c59000063260604$export$2010d0fb4295b346), ")"),
    cx: "4",
    cy: "4",
    r: "4"
}), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("path", {
    fill: "var(--ds-surface-overlay, ".concat((0, $8c59000063260604$export$29a4f05edc054374), ")"),
    d: "M4.890661,4.0088336 L5.81806461,3.07802178 C6.06167933,2.83351177 6.06048933,2.43826992 5.81540668,2.19522442 C5.57032402,1.95217891 5.17415651,1.95336612 4.93054179,2.19787613 L4.00765946,3.12415007 L3.06906871,2.18377143 C2.82523777,1.93947602 2.42906937,1.93863765 2.18420182,2.18189887 C1.93933427,2.42516008 1.93849394,2.82040282 2.18232488,3.06469822 L3.12544091,4.00961077 L2.20275024,4.93569234 C1.95913552,5.18020236 1.96032551,5.5754442 2.20540817,5.81848971 C2.45049083,6.06153521 2.84665833,6.060348 3.09027306,5.81583799 L4.00844245,4.89429431 L4.9092123,5.79678001 C5.15304324,6.04107541 5.54921164,6.04191379 5.79407919,5.79865257 C6.03894674,5.55539135 6.03978708,5.16014862 5.79595614,4.91585321 L4.890661,4.0088336 Z"
}));
var $eecdbe0e7facaeb5$var$LockedIndicator = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $5FkrB.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("circle", {
    fill: "var(--ds-text-subtlest, ".concat((0, $8c59000063260604$export$1ce2d1575d444ceb), ")"),
    cx: "4",
    cy: "4",
    r: "4"
}), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("path", {
    fill: "var(--ds-surface-overlay, ".concat((0, $8c59000063260604$export$c39c0fe0f26207ae), ")"),
    d: "M4.13074827,1.21766493 L4.10368158,1.21766493 C3.36340745,1.21766493 2.76388015,1.80793503 2.76388015,2.5367787 L2.76388015,3.21632216 L3.44054754,3.21632216 L3.44054754,2.54344089 C3.44054754,2.17901906 3.74031119,1.88388401 4.11044825,1.88388401 L4.1239816,1.88388401 C4.49411866,1.88388401 4.79388232,2.17901906 4.79388232,2.54344089 L4.79388232,3.21632216 L5.47054971,3.21632216 L5.47054971,2.5367787 C5.47054971,1.80793503 4.8710224,1.21766493 4.13074827,1.21766493 M2.76388015,3.21632216 L3.44054754,3.21632216 L3.44054754,3.88254123 L2.76388015,3.88254123 L2.76388015,3.21632216 Z M4.79388232,3.21632216 L5.47054971,3.21632216 L5.47054971,3.88254123 L4.79388232,3.88254123 L4.79388232,3.21632216 Z M4.79401765,3.88254123 L3.44068287,3.88254123 L2.76401548,3.88254123 C2.39049508,3.88254123 2.08734809,4.18100738 2.08734809,4.54876031 L2.08734809,5.54808892 C2.08734809,6.10000287 2.53735205,6.54741753 3.09094491,6.54741753 L5.14375561,6.54741753 C5.69802683,6.54741753 6.14735243,6.10385072 6.14735243,5.54808892 L6.14735243,4.54876031 C6.14735243,4.18100738 5.84420544,3.88254123 5.47068504,3.88254123 L4.79401765,3.88254123 Z"
}));
function $eecdbe0e7facaeb5$var$getStatus(status) {
    switch(status){
        case 'approved':
            return $eecdbe0e7facaeb5$var$ApprovedIndicator;
        case 'declined':
            return $eecdbe0e7facaeb5$var$DeclinedIndicator;
        case 'locked':
            return $eecdbe0e7facaeb5$var$LockedIndicator;
    }
}
/**
 * __Avatar status__
 *
 * An avatar status shows contextual information, such as if someone approves or declines something.
 *
 * - [Examples](https://atlassian.design/components/avatar/avatar-status/examples)
 * - [Code](https://atlassian.design/components/avatar/avatar-status/code)
 */ var $eecdbe0e7facaeb5$var$AvatarStatus = function AvatarStatus(_ref) {
    var borderColor = _ref.borderColor, children = _ref.children, status = _ref.status;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $0397340cd2230f68$export$2e2bcd8739ae039), {
        bgColor: borderColor
    }, status ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("svg", {
        height: "100%",
        version: "1.1",
        viewBox: "0 0 8 8",
        width: "100%",
        xmlns: "http://www.w3.org/2000/svg"
    }, $eecdbe0e7facaeb5$var$getStatus(status)) : children);
};
var $eecdbe0e7facaeb5$export$2e2bcd8739ae039 = $eecdbe0e7facaeb5$var$AvatarStatus;
var $eecdbe0e7facaeb5$export$8045894f255f9726 = function StatusWrapper(_ref2) {
    var size = _ref2.size, status = _ref2.status, appearance = _ref2.appearance, borderColor = _ref2.borderColor, children = _ref2.children, testId = _ref2.testId;
    var position = appearance === 'square' ? 0 : (0, $61e5774f84a75f10$export$382610e783aa2ae8)[size];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("span", {
        "aria-hidden": "true",
        "data-testid": testId && "".concat(testId, "--status"),
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            position: 'absolute',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            height: "".concat((0, $61e5774f84a75f10$export$fdc820179f1f9be4)[size], "px"),
            right: "".concat(position, "px"),
            top: "".concat(position, "px"),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            width: "".concat((0, $61e5774f84a75f10$export$fdc820179f1f9be4)[size], "px")
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement($eecdbe0e7facaeb5$var$AvatarStatus, {
        borderColor: borderColor,
        status: !children ? status : undefined
    }, children));
};


var $359aa0e0a643f965$export$60113ebe1cf0ecf = function getLinkProps(href, target) {
    return {
        href: href,
        rel: target === '_blank' ? 'noopener noreferrer' : null,
        target: target
    };
};
var $359aa0e0a643f965$export$cca6f1bef43616d3 = function getButtonProps(onClick) {
    return {
        type: 'button',
        onClick: onClick
    };
};
var $359aa0e0a643f965$export$83ee468102cdf04c = function getCustomElement(isDisabled, href, onClick) {
    if (href && !isDisabled) return 'a';
    if (onClick || isDisabled) return 'button';
    return 'span';
};


var $f31efb9f24b21b67$var$_templateObject;
function $f31efb9f24b21b67$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $f31efb9f24b21b67$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $f31efb9f24b21b67$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $f31efb9f24b21b67$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $f31efb9f24b21b67$var$packageName = "@atlaskit/avatar";
var $f31efb9f24b21b67$var$packageVersion = "21.18.4";
var $f31efb9f24b21b67$var$getTestId = function getTestId(testId, children) {
    return !children ? {
        'data-testid': "".concat(testId, "--inner")
    } : {
        testId: "".concat(testId, "--inner")
    };
};
// eslint-disable-next-line @repo/internal/react/consistent-types-definitions
var $f31efb9f24b21b67$var$getStyles = function getStyles(css, _ref) {
    var size = _ref.size, radius = _ref.radius, appearance = _ref.appearance, _ref$borderColor = _ref.borderColor, borderColor = _ref$borderColor === void 0 ? (0, $dU8Y3.fg)('platform-component-visual-refresh') ? "var(--ds-surface, #FFFFFF)" : "var(--ds-surface-overlay, ".concat((0, $8c59000063260604$export$29a4f05edc054374), ")") : _ref$borderColor, stackIndex = _ref.stackIndex, isInteractive = _ref.isInteractive, isDisabled = _ref.isDisabled;
    return css($f31efb9f24b21b67$var$_templateObject || ($f31efb9f24b21b67$var$_templateObject = (0, (/*@__PURE__*/$parcel$interopDefault($lAD7C)))([
        "\n\t\theight: ",
        "px;\n\t\twidth: ",
        "px;\n\t\talign-items: stretch;\n\t\tbackground-color: ",
        ";\n\t\tborder-radius: ",
        ";\n\t\tbox-sizing: content-box;\n\t\tcursor: inherit;\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\tjustify-content: center;\n\t\toutline: none;\n\t\toverflow: hidden;\n\t\tposition: static;\n\t\ttransform: translateZ(0);\n\t\ttransition:\n\t\t\ttransform 200ms,\n\t\t\topacity 200ms;\n\t\tbox-shadow: 0 0 0 ",
        "px ",
        ";\n\t\tborder: none;\n\t\tmargin: ",
        ";\n\t\tpadding: ",
        ";\n\n\t\t&::-moz-focus-inner {\n\t\t\tborder: 0;\n\t\t\tmargin: ",
        ";\n\t\t\tpadding: ",
        ";\n\t\t}\n\n\t\t&::after {\n\t\t\tbackground-color: transparent;\n\t\t\tinset: 0px;\n\n\t\t\t/* Added border-radius style to fix hover issue in safari */\n\t\t\tborder-radius: ",
        ";\n\t\t\tcontent: ' ';\n\t\t\topacity: 0;\n\t\t\tpointer-events: none;\n\t\t\tposition: absolute;\n\t\t\ttransition: opacity 200ms;\n\t\t\twidth: 100%;\n\t\t}\n\n\t\t:focus-visible {\n\t\t\tbox-shadow: none;\n\t\t}\n\n\t\t",
        "\n\n\t\t",
        "\n\n    ",
        "\n\t"
    ])), size, size, borderColor, appearance === 'circle' ? '50%' : "".concat(radius, "px"), (0, $61e5774f84a75f10$export$e2bd4c1faded7921), borderColor, "var(--ds-space-025, 2px)", "var(--ds-space-0, 0px)", "var(--ds-space-0, 0px)", "var(--ds-space-0, 0px)", appearance === 'circle' ? '50%' : "".concat(radius, "px"), stackIndex && "position: relative;", isInteractive && "\n      cursor: pointer;\n\n      :hover {\n        &::after {\n          background-color: ".concat("var(--ds-interaction-hovered, ".concat((0, $8c59000063260604$export$6e5e7499ff054f6d), ")"), ";\n          opacity: 1;\n        }\n      }\n\n      :active {\n        &::after {\n          background-color: ", "var(--ds-interaction-pressed, ".concat((0, $8c59000063260604$export$6e5e7499ff054f6d), ")"), ";\n          opacity: 1;\n        }\n      }\n\n      :active {\n        transform: scale(", (0, $61e5774f84a75f10$export$89a980dfdf90df51), ");\n      }\n\n      @media screen and (forced-colors: active) {\n        &:focus-visible {\n          outline: 1px solid\n        }\n      }\n    "), isDisabled && "\n        cursor: not-allowed;\n\n        &::after {\n          opacity: ".concat("var(--ds-opacity-disabled, 0.7)", ";\n          pointer-events: none;\n          background-color: ", "var(--ds-surface, ".concat((0, $8c59000063260604$export$29a4f05edc054374), ")"), ";\n        }\n      "));
};
/**
 * __Avatar__
 *
 * An avatar is a visual representation of a user or entity.
 *
 * - [Examples](https://atlassian.design/components/avatar/examples)
 * - [Code](https://atlassian.design/components/avatar/code)
 * - [Usage](https://atlassian.design/components/avatar/usage)
 */ var $f31efb9f24b21b67$var$Avatar = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function(_ref2, ref) {
    var _ref3;
    var analyticsContext = _ref2.analyticsContext, _ref2$appearance = _ref2.appearance, appearance = _ref2$appearance === void 0 ? 'circle' : _ref2$appearance, label = _ref2.label, borderColor = _ref2.borderColor, children = _ref2.children, href = _ref2.href, isDisabled = _ref2.isDisabled, name = _ref2.name, onClick = _ref2.onClick, presence = _ref2.presence, sizeProp = _ref2.size, src = _ref2.src, stackIndex = _ref2.stackIndex, status = _ref2.status, target = _ref2.target, testId = _ref2.testId, _ref2$as = _ref2.as, AvatarContainer = _ref2$as === void 0 ? 'div' : _ref2$as;
    var _useAnalyticsEvents = (0, $629ae1a8f7e1c5ec$export$5bf35293e545f20c)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
    var context = (0, $d52acb751e558d18$export$b50b87a1c4086b23)();
    var size = (_ref3 = sizeProp !== null && sizeProp !== void 0 ? sizeProp : context === null || context === void 0 ? void 0 : context.size) !== null && _ref3 !== void 0 ? _ref3 : 'medium';
    var customPresenceNode = /*#__PURE__*/ (0, $5FkrB.isValidElement)(presence) ? presence : null;
    var customStatusNode = /*#__PURE__*/ (0, $5FkrB.isValidElement)(status) ? status : null;
    var isValidIconSize = size !== 'xxlarge' && size !== 'xsmall';
    var lastAnalytics = (0, $5FkrB.useRef)(analyticsContext);
    var labelId = (0, $c266bfb019ace8e2$export$f680877a34711e37)();
    (0, $5FkrB.useEffect)(function() {
        lastAnalytics.current = analyticsContext;
    }, [
        analyticsContext
    ]);
    var onClickHandler = (0, $5FkrB.useCallback)(function(event) {
        if (isDisabled || typeof onClick !== 'function') return;
        var analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'avatar',
            attributes: {
                componentName: 'avatar',
                packageName: $f31efb9f24b21b67$var$packageName,
                packageVersion: $f31efb9f24b21b67$var$packageVersion
            }
        });
        /**
     * To avoid wrapping this component in AnalyticsContext we manually
     * push the parent context's meta data into the context.
     */ var context = $f31efb9f24b21b67$var$_objectSpread({
            componentName: 'avatar',
            packageName: $f31efb9f24b21b67$var$packageName,
            packageVersion: $f31efb9f24b21b67$var$packageVersion
        }, lastAnalytics.current);
        analyticsEvent.context.push(context);
        /**
     * Replicating the logic in the `withAnalyticsEvents` HOC.
     */ var clone = analyticsEvent.clone();
        if (clone) clone.fire('atlaskit');
        onClick(event, analyticsEvent);
    }, [
        createAnalyticsEvent,
        isDisabled,
        onClick
    ]);
    var componentProps = function componentProps() {
        if (isDisabled) return {
            disabled: true
        };
        // return only relevant props for either anchor or button elements
        return $f31efb9f24b21b67$var$_objectSpread($f31efb9f24b21b67$var$_objectSpread({}, href && (0, $359aa0e0a643f965$export$60113ebe1cf0ecf)(href, target)), onClick && !href ? (0, $359aa0e0a643f965$export$cca6f1bef43616d3)(onClickHandler) : {
            onClick: onClick
        });
    };
    var isPresence = isValidIconSize && presence && !status;
    var isStatus = isValidIconSize && status;
    // add presence or status to the label by default if presence and status are passed as a string
    // if status or presence are nodes this is not added to the label by default
    var defaultLabel = [
        name,
        isStatus && !customStatusNode && "(".concat(status, ")"),
        isPresence && !customPresenceNode && "(".concat(presence, ")")
    ].filter(Boolean).join(' ');
    var isInteractive = onClick || href || isDisabled;
    var containerShouldBeImage = Boolean(!isInteractive && defaultLabel);
    return (0, $74Zh5.jsx)(AvatarContainer, {
        "data-testid": testId,
        role: containerShouldBeImage ? 'img' : undefined,
        "aria-labelledby": containerShouldBeImage ? labelId : undefined,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            display: 'inline-block',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            position: 'relative',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            outline: 0,
            zIndex: stackIndex
        }
    }, (0, $74Zh5.jsx)((0, $74Zh5.ClassNames), null, function(_ref4) {
        var css = _ref4.css;
        var props = $f31efb9f24b21b67$var$_objectSpread($f31efb9f24b21b67$var$_objectSpread($f31efb9f24b21b67$var$_objectSpread($f31efb9f24b21b67$var$_objectSpread({
            className: $f31efb9f24b21b67$var$getStyles(css, {
                size: (0, $61e5774f84a75f10$export$9a270941bcff7e77)[size],
                radius: (0, $61e5774f84a75f10$export$e6da6efe4d1a5c9b)[size],
                appearance: appearance,
                borderColor: borderColor,
                stackIndex: stackIndex,
                isInteractive: Boolean(href || onClick) && !isDisabled,
                isDisabled: isDisabled
            })
        }, componentProps()), testId && $f31efb9f24b21b67$var$getTestId(testId, children)), (isInteractive || children) && {
            'aria-label': label || defaultLabel
        }), {}, {
            children: (0, $74Zh5.jsx)((0, $ab8f08636cc80173$export$2e2bcd8739ae039), {
                alt: !containerShouldBeImage && src ? name : undefined,
                appearance: appearance,
                size: size,
                src: src,
                testId: testId
            }),
            ref: ref
        });
        if (children) return children(props);
        var element = (0, $359aa0e0a643f965$export$83ee468102cdf04c)(isDisabled, href, onClick);
        return element === 'a' || element === 'button' ? (0, $74Zh5.jsx)((0, $3cb9a830afcc553b$export$2e2bcd8739ae039), null, /*#__PURE__*/ (0, $5FkrB.createElement)(element, props)) : /*#__PURE__*/ (0, $5FkrB.createElement)(element, props);
    }), isPresence && (0, $74Zh5.jsx)((0, $737ff5795e5646ca$export$972c5e90200fa0ef), {
        appearance: appearance,
        size: size,
        presence: typeof presence === 'string' ? presence : undefined,
        testId: testId
    }, customPresenceNode), isStatus && (0, $74Zh5.jsx)((0, $eecdbe0e7facaeb5$export$8045894f255f9726), {
        appearance: appearance,
        size: size,
        borderColor: borderColor,
        status: typeof status === 'string' ? status : undefined,
        testId: testId
    }, customStatusNode), containerShouldBeImage ? (0, $74Zh5.jsx)("span", {
        "data-testid": testId && "".concat(testId, "--label"),
        id: labelId,
        hidden: true
    }, defaultLabel) : undefined);
});
$f31efb9f24b21b67$var$Avatar.displayName = 'Avatar';
var $f31efb9f24b21b67$export$2e2bcd8739ae039 = $f31efb9f24b21b67$var$Avatar;



/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5FkrB = parcelRequire("5FkrB");

var $74Zh5 = parcelRequire("74Zh5");

var $dU8Y3 = parcelRequire("dU8Y3");

var $kqp0i = parcelRequire("kqp0i");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");

var $74Zh5 = parcelRequire("74Zh5");

var $5FkrB = parcelRequire("5FkrB");
var $5a5dcf11228e3e89$export$1ca2a26fecb070ae = /*#__PURE__*/ (0, $5FkrB.createContext)('elevation.surface');
var $5a5dcf11228e3e89$export$1aeb4f6b93c4540d = function useSurface() {
    return (0, $5FkrB.useContext)($5a5dcf11228e3e89$export$1ca2a26fecb070ae);
};
$5a5dcf11228e3e89$export$1ca2a26fecb070ae.displayName = 'SurfaceProvider';



var $25nEq = parcelRequire("25nEq");

var $74Zh5 = parcelRequire("74Zh5");
var $79c25bbc4e071f75$export$4ef52930e33717cd = 'data-theme';
var $79c25bbc4e071f75$export$a00eac3f8684bcd0 = 'data-color-mode';
var $79c25bbc4e071f75$export$2112803007239c61 = 'data-contrast-mode';
var $79c25bbc4e071f75$export$352e418ed5b6193a = 'data-custom-theme';
var $79c25bbc4e071f75$export$2faeed762aac6741 = 'light';
var $79c25bbc4e071f75$export$6f0c6fb8c80fcc92 = 'ds';
var $79c25bbc4e071f75$export$4d0c7bbf80185957 = [
    'opacity',
    'font',
    'space',
    'border'
];
var $79c25bbc4e071f75$export$dddac1532e822863 = "--".concat($79c25bbc4e071f75$export$6f0c6fb8c80fcc92, "-token-not-found");
var $79c25bbc4e071f75$export$9d7b58831ae93caa = "--".concat($79c25bbc4e071f75$export$6f0c6fb8c80fcc92, "-elevation-surface-current");


function $fda1bdf5cf68a2eb$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $fda1bdf5cf68a2eb$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $fda1bdf5cf68a2eb$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $fda1bdf5cf68a2eb$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $fda1bdf5cf68a2eb$export$6ccdbebca2ee545f = {
    '100%': '100%',
    'size.100': '1rem',
    'size.200': '1.5rem',
    'size.300': '2rem',
    'size.400': '2.5rem',
    'size.500': '3rem',
    'size.600': '6rem',
    'size.1000': '12rem'
};
var $fda1bdf5cf68a2eb$export$958d0ae7f2977ae4 = {
    'space.0': "var(--ds-space-0, 0px)",
    'space.025': "var(--ds-space-025, 2px)",
    'space.050': "var(--ds-space-050, 4px)",
    'space.075': "var(--ds-space-075, 6px)",
    'space.100': "var(--ds-space-100, 8px)",
    'space.150': "var(--ds-space-150, 12px)",
    'space.200': "var(--ds-space-200, 16px)",
    'space.250': "var(--ds-space-250, 20px)",
    'space.300': "var(--ds-space-300, 24px)",
    'space.400': "var(--ds-space-400, 32px)",
    'space.500': "var(--ds-space-500, 40px)",
    'space.600': "var(--ds-space-600, 48px)",
    'space.800': "var(--ds-space-800, 64px)",
    'space.1000': "var(--ds-space-1000, 80px)"
};
var $fda1bdf5cf68a2eb$export$d2dc61f58390201c = {
    'space.negative.025': "var(--ds-space-negative-025, -2px)",
    'space.negative.050': "var(--ds-space-negative-050, -4px)",
    'space.negative.075': "var(--ds-space-negative-075, -6px)",
    'space.negative.100': "var(--ds-space-negative-100, -8px)",
    'space.negative.150': "var(--ds-space-negative-150, -12px)",
    'space.negative.200': "var(--ds-space-negative-200, -16px)",
    'space.negative.250': "var(--ds-space-negative-250, -20px)",
    'space.negative.300': "var(--ds-space-negative-300, -24px)",
    'space.negative.400': "var(--ds-space-negative-400, -32px)"
};
var $fda1bdf5cf68a2eb$export$632685d741f3dbbf = $fda1bdf5cf68a2eb$var$_objectSpread($fda1bdf5cf68a2eb$var$_objectSpread({}, $fda1bdf5cf68a2eb$export$958d0ae7f2977ae4), $fda1bdf5cf68a2eb$export$d2dc61f58390201c);
var $fda1bdf5cf68a2eb$export$2185ce37f9bdd963 = {
    'color.background.neutral.bold': 'color.text.inverse',
    'color.background.neutral.bold.hovered': 'color.text.inverse',
    'color.background.neutral.bold.pressed': 'color.text.inverse',
    'color.background.selected.bold': 'color.text.inverse',
    'color.background.selected.bold.hovered': 'color.text.inverse',
    'color.background.selected.bold.pressed': 'color.text.inverse',
    'color.background.brand.bold': 'color.text.inverse',
    'color.background.brand.bold.hovered': 'color.text.inverse',
    'color.background.brand.bold.pressed': 'color.text.inverse',
    'color.background.brand.boldest': 'color.text.inverse',
    'color.background.brand.boldest.hovered': 'color.text.inverse',
    'color.background.brand.boldest.pressed': 'color.text.inverse',
    'color.background.danger.bold': 'color.text.inverse',
    'color.background.danger.bold.hovered': 'color.text.inverse',
    'color.background.danger.bold.pressed': 'color.text.inverse',
    'color.background.warning.bold': 'color.text.warning.inverse',
    'color.background.warning.bold.hovered': 'color.text.warning.inverse',
    'color.background.warning.bold.pressed': 'color.text.warning.inverse',
    'color.background.success.bold': 'color.text.inverse',
    'color.background.success.bold.hovered': 'color.text.inverse',
    'color.background.success.bold.pressed': 'color.text.inverse',
    'color.background.discovery.bold': 'color.text.inverse',
    'color.background.discovery.bold.hovered': 'color.text.inverse',
    'color.background.discovery.bold.pressed': 'color.text.inverse',
    'color.background.information.bold': 'color.text.inverse',
    'color.background.information.bold.hovered': 'color.text.inverse',
    'color.background.information.bold.pressed': 'color.text.inverse'
};
var $fda1bdf5cf68a2eb$export$daf94a976c798b4f = {
    'opacity.disabled': "var(--ds-opacity-disabled, 0.4)",
    'opacity.loading': "var(--ds-opacity-loading, 0.2)"
};
var $fda1bdf5cf68a2eb$export$7aff6e7ba39bb774 = {
    'elevation.shadow.overflow': "var(--ds-shadow-overflow, 0px 0px 8px #091e423f, 0px 0px 1px #091e424f)",
    'elevation.shadow.overflow.perimeter': "var(--ds-shadow-overflow-perimeter, #091e421f)",
    'elevation.shadow.overflow.spread': "var(--ds-shadow-overflow-spread, #091e4229)",
    'elevation.shadow.overlay': "var(--ds-shadow-overlay, 0px 8px 12px #091e423f, 0px 0px 1px #091e424f)",
    'elevation.shadow.raised': "var(--ds-shadow-raised, 0px 1px 1px #091e423f, 0px 0px 1px #091e4221)"
};
var $fda1bdf5cf68a2eb$export$41a358c9c2356760 = {
    'elevation.surface': "var(--ds-surface, #FFFFFF)",
    'elevation.surface.hovered': "var(--ds-surface-hovered, #FAFBFC)",
    'elevation.surface.pressed': "var(--ds-surface-pressed, #F4F5F7)",
    'elevation.surface.overlay': "var(--ds-surface-overlay, #FFFFFF)",
    'elevation.surface.overlay.hovered': "var(--ds-surface-overlay-hovered, #FAFBFC)",
    'elevation.surface.overlay.pressed': "var(--ds-surface-overlay-pressed, #F4F5F7)",
    'elevation.surface.raised': "var(--ds-surface-raised, #FFFFFF)",
    'elevation.surface.raised.hovered': "var(--ds-surface-raised-hovered, #FAFBFC)",
    'elevation.surface.raised.pressed': "var(--ds-surface-raised-pressed, #F4F5F7)",
    'elevation.surface.sunken': "var(--ds-surface-sunken, #F4F5F7)"
};
var $fda1bdf5cf68a2eb$export$1531ad5bb3fbedac = {
    'color.border': "var(--ds-border, #091e4221)",
    'color.border.accent.lime': "var(--ds-border-accent-lime, #6A9A23)",
    'color.border.accent.red': "var(--ds-border-accent-red, #FF5630)",
    'color.border.accent.orange': "var(--ds-border-accent-orange, #D94008)",
    'color.border.accent.yellow': "var(--ds-border-accent-yellow, #FFAB00)",
    'color.border.accent.green': "var(--ds-border-accent-green, #36B37E)",
    'color.border.accent.teal': "var(--ds-border-accent-teal, #00B8D9)",
    'color.border.accent.blue': "var(--ds-border-accent-blue, #0065FF)",
    'color.border.accent.purple': "var(--ds-border-accent-purple, #6554C0)",
    'color.border.accent.magenta': "var(--ds-border-accent-magenta, #CD519D)",
    'color.border.accent.gray': "var(--ds-border-accent-gray, #5E6C84)",
    'color.border.disabled': "var(--ds-border-disabled, #FAFBFC)",
    'color.border.focused': "var(--ds-border-focused, #2684FF)",
    'color.border.input': "var(--ds-border-input, #FAFBFC)",
    'color.border.inverse': "var(--ds-border-inverse, #FFFFFF)",
    'color.border.selected': "var(--ds-border-selected, #0052CC)",
    'color.border.brand': "var(--ds-border-brand, #0052CC)",
    'color.border.danger': "var(--ds-border-danger, #FF5630)",
    'color.border.warning': "var(--ds-border-warning, #FFC400)",
    'color.border.success': "var(--ds-border-success, #00875A)",
    'color.border.discovery': "var(--ds-border-discovery, #998DD9)",
    'color.border.information': "var(--ds-border-information, #0065FF)",
    'color.border.bold': "var(--ds-border-bold, #344563)"
};
var $fda1bdf5cf68a2eb$export$d1d79bf68ac056bd = {
    'color.background.accent.lime.subtlest': "var(--ds-background-accent-lime-subtlest, #EEFBDA)",
    'color.background.accent.lime.subtlest.hovered': "var(--ds-background-accent-lime-subtlest-hovered, #D3F1A7)",
    'color.background.accent.lime.subtlest.pressed': "var(--ds-background-accent-lime-subtlest-pressed, #B3DF72)",
    'color.background.accent.lime.subtler': "var(--ds-background-accent-lime-subtler, #D3F1A7)",
    'color.background.accent.lime.subtler.hovered': "var(--ds-background-accent-lime-subtler-hovered, #B3DF72)",
    'color.background.accent.lime.subtler.pressed': "var(--ds-background-accent-lime-subtler-pressed, #94C748)",
    'color.background.accent.lime.subtle': "var(--ds-background-accent-lime-subtle, #94C748)",
    'color.background.accent.lime.subtle.hovered': "var(--ds-background-accent-lime-subtle-hovered, #B3DF72)",
    'color.background.accent.lime.subtle.pressed': "var(--ds-background-accent-lime-subtle-pressed, #D3F1A7)",
    'color.background.accent.lime.bolder': "var(--ds-background-accent-lime-bolder, #5B7F24)",
    'color.background.accent.lime.bolder.hovered': "var(--ds-background-accent-lime-bolder-hovered, #37471F)",
    'color.background.accent.lime.bolder.pressed': "var(--ds-background-accent-lime-bolder-pressed, #37471F)",
    'color.background.accent.red.subtlest': "var(--ds-background-accent-red-subtlest, #FF8F73)",
    'color.background.accent.red.subtlest.hovered': "var(--ds-background-accent-red-subtlest-hovered, #FF7452)",
    'color.background.accent.red.subtlest.pressed': "var(--ds-background-accent-red-subtlest-pressed, #FF5630)",
    'color.background.accent.red.subtler': "var(--ds-background-accent-red-subtler, #FF7452)",
    'color.background.accent.red.subtler.hovered': "var(--ds-background-accent-red-subtler-hovered, #FF5630)",
    'color.background.accent.red.subtler.pressed': "var(--ds-background-accent-red-subtler-pressed, #DE350B)",
    'color.background.accent.red.subtle': "var(--ds-background-accent-red-subtle, #DE350B)",
    'color.background.accent.red.subtle.hovered': "var(--ds-background-accent-red-subtle-hovered, #FF5630)",
    'color.background.accent.red.subtle.pressed': "var(--ds-background-accent-red-subtle-pressed, #FF7452)",
    'color.background.accent.red.bolder': "var(--ds-background-accent-red-bolder, #DE350B)",
    'color.background.accent.red.bolder.hovered': "var(--ds-background-accent-red-bolder-hovered, #FF5630)",
    'color.background.accent.red.bolder.pressed': "var(--ds-background-accent-red-bolder-pressed, #FF7452)",
    'color.background.accent.orange.subtlest': "var(--ds-background-accent-orange-subtlest, #F18D13)",
    'color.background.accent.orange.subtlest.hovered': "var(--ds-background-accent-orange-subtlest-hovered, #FEC57B)",
    'color.background.accent.orange.subtlest.pressed': "var(--ds-background-accent-orange-subtlest-pressed, #FFE2BD)",
    'color.background.accent.orange.subtler': "var(--ds-background-accent-orange-subtler, #B65C02)",
    'color.background.accent.orange.subtler.hovered': "var(--ds-background-accent-orange-subtler-hovered, #F18D13)",
    'color.background.accent.orange.subtler.pressed': "var(--ds-background-accent-orange-subtler-pressed, #FEC57B)",
    'color.background.accent.orange.subtle': "var(--ds-background-accent-orange-subtle, #5F3811)",
    'color.background.accent.orange.subtle.hovered': "var(--ds-background-accent-orange-subtle-hovered, #974F0C)",
    'color.background.accent.orange.subtle.pressed': "var(--ds-background-accent-orange-subtle-pressed, #B65C02)",
    'color.background.accent.orange.bolder': "var(--ds-background-accent-orange-bolder, #43290F)",
    'color.background.accent.orange.bolder.hovered': "var(--ds-background-accent-orange-bolder-hovered, #5F3811)",
    'color.background.accent.orange.bolder.pressed': "var(--ds-background-accent-orange-bolder-pressed, #974F0C)",
    'color.background.accent.yellow.subtlest': "var(--ds-background-accent-yellow-subtlest, #FFE380)",
    'color.background.accent.yellow.subtlest.hovered': "var(--ds-background-accent-yellow-subtlest-hovered, #FFC400)",
    'color.background.accent.yellow.subtlest.pressed': "var(--ds-background-accent-yellow-subtlest-pressed, #FFAB00)",
    'color.background.accent.yellow.subtler': "var(--ds-background-accent-yellow-subtler, #FFC400)",
    'color.background.accent.yellow.subtler.hovered': "var(--ds-background-accent-yellow-subtler-hovered, #FFAB00)",
    'color.background.accent.yellow.subtler.pressed': "var(--ds-background-accent-yellow-subtler-pressed, #FF991F)",
    'color.background.accent.yellow.subtle': "var(--ds-background-accent-yellow-subtle, #FF991F)",
    'color.background.accent.yellow.subtle.hovered': "var(--ds-background-accent-yellow-subtle-hovered, #FFAB00)",
    'color.background.accent.yellow.subtle.pressed': "var(--ds-background-accent-yellow-subtle-pressed, #FFC400)",
    'color.background.accent.yellow.bolder': "var(--ds-background-accent-yellow-bolder, #FF991F)",
    'color.background.accent.yellow.bolder.hovered': "var(--ds-background-accent-yellow-bolder-hovered, #FFAB00)",
    'color.background.accent.yellow.bolder.pressed': "var(--ds-background-accent-yellow-bolder-pressed, #FFC400)",
    'color.background.accent.green.subtlest': "var(--ds-background-accent-green-subtlest, #79F2C0)",
    'color.background.accent.green.subtlest.hovered': "var(--ds-background-accent-green-subtlest-hovered, #57D9A3)",
    'color.background.accent.green.subtlest.pressed': "var(--ds-background-accent-green-subtlest-pressed, #36B37E)",
    'color.background.accent.green.subtler': "var(--ds-background-accent-green-subtler, #57D9A3)",
    'color.background.accent.green.subtler.hovered': "var(--ds-background-accent-green-subtler-hovered, #36B37E)",
    'color.background.accent.green.subtler.pressed': "var(--ds-background-accent-green-subtler-pressed, #00875A)",
    'color.background.accent.green.subtle': "var(--ds-background-accent-green-subtle, #00875A)",
    'color.background.accent.green.subtle.hovered': "var(--ds-background-accent-green-subtle-hovered, #36B37E)",
    'color.background.accent.green.subtle.pressed': "var(--ds-background-accent-green-subtle-pressed, #57D9A3)",
    'color.background.accent.green.bolder': "var(--ds-background-accent-green-bolder, #00875A)",
    'color.background.accent.green.bolder.hovered': "var(--ds-background-accent-green-bolder-hovered, #36B37E)",
    'color.background.accent.green.bolder.pressed': "var(--ds-background-accent-green-bolder-pressed, #57D9A3)",
    'color.background.accent.teal.subtlest': "var(--ds-background-accent-teal-subtlest, #79E2F2)",
    'color.background.accent.teal.subtlest.hovered': "var(--ds-background-accent-teal-subtlest-hovered, #00C7E6)",
    'color.background.accent.teal.subtlest.pressed': "var(--ds-background-accent-teal-subtlest-pressed, #00B8D9)",
    'color.background.accent.teal.subtler': "var(--ds-background-accent-teal-subtler, #00C7E6)",
    'color.background.accent.teal.subtler.hovered': "var(--ds-background-accent-teal-subtler-hovered, #00B8D9)",
    'color.background.accent.teal.subtler.pressed': "var(--ds-background-accent-teal-subtler-pressed, #00A3BF)",
    'color.background.accent.teal.subtle': "var(--ds-background-accent-teal-subtle, #00A3BF)",
    'color.background.accent.teal.subtle.hovered': "var(--ds-background-accent-teal-subtle-hovered, #00B8D9)",
    'color.background.accent.teal.subtle.pressed': "var(--ds-background-accent-teal-subtle-pressed, #00C7E6)",
    'color.background.accent.teal.bolder': "var(--ds-background-accent-teal-bolder, #00A3BF)",
    'color.background.accent.teal.bolder.hovered': "var(--ds-background-accent-teal-bolder-hovered, #00B8D9)",
    'color.background.accent.teal.bolder.pressed': "var(--ds-background-accent-teal-bolder-pressed, #00C7E6)",
    'color.background.accent.blue.subtlest': "var(--ds-background-accent-blue-subtlest, #4C9AFF)",
    'color.background.accent.blue.subtlest.hovered': "var(--ds-background-accent-blue-subtlest-hovered, #2684FF)",
    'color.background.accent.blue.subtlest.pressed': "var(--ds-background-accent-blue-subtlest-pressed, #0065FF)",
    'color.background.accent.blue.subtler': "var(--ds-background-accent-blue-subtler, #2684FF)",
    'color.background.accent.blue.subtler.hovered': "var(--ds-background-accent-blue-subtler-hovered, #0065FF)",
    'color.background.accent.blue.subtler.pressed': "var(--ds-background-accent-blue-subtler-pressed, #0052CC)",
    'color.background.accent.blue.subtle': "var(--ds-background-accent-blue-subtle, #0052CC)",
    'color.background.accent.blue.subtle.hovered': "var(--ds-background-accent-blue-subtle-hovered, #0065FF)",
    'color.background.accent.blue.subtle.pressed': "var(--ds-background-accent-blue-subtle-pressed, #2684FF)",
    'color.background.accent.blue.bolder': "var(--ds-background-accent-blue-bolder, #0052CC)",
    'color.background.accent.blue.bolder.hovered': "var(--ds-background-accent-blue-bolder-hovered, #0065FF)",
    'color.background.accent.blue.bolder.pressed': "var(--ds-background-accent-blue-bolder-pressed, #2684FF)",
    'color.background.accent.purple.subtlest': "var(--ds-background-accent-purple-subtlest, #998DD9)",
    'color.background.accent.purple.subtlest.hovered': "var(--ds-background-accent-purple-subtlest-hovered, #8777D9)",
    'color.background.accent.purple.subtlest.pressed': "var(--ds-background-accent-purple-subtlest-pressed, #6554C0)",
    'color.background.accent.purple.subtler': "var(--ds-background-accent-purple-subtler, #8777D9)",
    'color.background.accent.purple.subtler.hovered': "var(--ds-background-accent-purple-subtler-hovered, #6554C0)",
    'color.background.accent.purple.subtler.pressed': "var(--ds-background-accent-purple-subtler-pressed, #5243AA)",
    'color.background.accent.purple.subtle': "var(--ds-background-accent-purple-subtle, #5243AA)",
    'color.background.accent.purple.subtle.hovered': "var(--ds-background-accent-purple-subtle-hovered, #6554C0)",
    'color.background.accent.purple.subtle.pressed': "var(--ds-background-accent-purple-subtle-pressed, #8777D9)",
    'color.background.accent.purple.bolder': "var(--ds-background-accent-purple-bolder, #5243AA)",
    'color.background.accent.purple.bolder.hovered': "var(--ds-background-accent-purple-bolder-hovered, #6554C0)",
    'color.background.accent.purple.bolder.pressed': "var(--ds-background-accent-purple-bolder-pressed, #8777D9)",
    'color.background.accent.magenta.subtlest': "var(--ds-background-accent-magenta-subtlest, #FFECF8)",
    'color.background.accent.magenta.subtlest.hovered': "var(--ds-background-accent-magenta-subtlest-hovered, #FDD0EC)",
    'color.background.accent.magenta.subtlest.pressed': "var(--ds-background-accent-magenta-subtlest-pressed, #F797D2)",
    'color.background.accent.magenta.subtler': "var(--ds-background-accent-magenta-subtler, #FDD0EC)",
    'color.background.accent.magenta.subtler.hovered': "var(--ds-background-accent-magenta-subtler-hovered, #F797D2)",
    'color.background.accent.magenta.subtler.pressed': "var(--ds-background-accent-magenta-subtler-pressed, #E774BB)",
    'color.background.accent.magenta.subtle': "var(--ds-background-accent-magenta-subtle, #E774BB)",
    'color.background.accent.magenta.subtle.hovered': "var(--ds-background-accent-magenta-subtle-hovered, #F797D2)",
    'color.background.accent.magenta.subtle.pressed': "var(--ds-background-accent-magenta-subtle-pressed, #FDD0EC)",
    'color.background.accent.magenta.bolder': "var(--ds-background-accent-magenta-bolder, #AE4787)",
    'color.background.accent.magenta.bolder.hovered': "var(--ds-background-accent-magenta-bolder-hovered, #943D73)",
    'color.background.accent.magenta.bolder.pressed': "var(--ds-background-accent-magenta-bolder-pressed, #50253F)",
    'color.background.accent.gray.subtlest': "var(--ds-background-accent-gray-subtlest, #6B778C)",
    'color.background.accent.gray.subtlest.hovered': "var(--ds-background-accent-gray-subtlest-hovered, #5E6C84)",
    'color.background.accent.gray.subtlest.pressed': "var(--ds-background-accent-gray-subtlest-pressed, #505F79)",
    'color.background.accent.gray.subtler': "var(--ds-background-accent-gray-subtler, #5E6C84)",
    'color.background.accent.gray.subtler.hovered': "var(--ds-background-accent-gray-subtler-hovered, #505F79)",
    'color.background.accent.gray.subtler.pressed': "var(--ds-background-accent-gray-subtler-pressed, #42526E)",
    'color.background.accent.gray.subtle': "var(--ds-background-accent-gray-subtle, #505F79)",
    'color.background.accent.gray.subtle.hovered': "var(--ds-background-accent-gray-subtle-hovered, #5E6C84)",
    'color.background.accent.gray.subtle.pressed': "var(--ds-background-accent-gray-subtle-pressed, #6B778C)",
    'color.background.accent.gray.bolder': "var(--ds-background-accent-gray-bolder, #42526E)",
    'color.background.accent.gray.bolder.hovered': "var(--ds-background-accent-gray-bolder-hovered, #344563)",
    'color.background.accent.gray.bolder.pressed': "var(--ds-background-accent-gray-bolder-pressed, #253858)",
    'color.background.disabled': "var(--ds-background-disabled, #091e4289)",
    'color.background.input': "var(--ds-background-input, #FAFBFC)",
    'color.background.input.hovered': "var(--ds-background-input-hovered, #EBECF0)",
    'color.background.input.pressed': "var(--ds-background-input-pressed, #FFFFFF)",
    'color.background.inverse.subtle': "var(--ds-background-inverse-subtle, #00000029)",
    'color.background.inverse.subtle.hovered': "var(--ds-background-inverse-subtle-hovered, #0000003D)",
    'color.background.inverse.subtle.pressed': "var(--ds-background-inverse-subtle-pressed, #00000052)",
    'color.background.neutral': "var(--ds-background-neutral, #DFE1E6)",
    'color.background.neutral.hovered': "var(--ds-background-neutral-hovered, #091e4214)",
    'color.background.neutral.pressed': "var(--ds-background-neutral-pressed, #B3D4FF)",
    'color.background.neutral.subtle': "var(--ds-background-neutral-subtle, transparent)",
    'color.background.neutral.subtle.hovered': "var(--ds-background-neutral-subtle-hovered, #091e4214)",
    'color.background.neutral.subtle.pressed': "var(--ds-background-neutral-subtle-pressed, #B3D4FF)",
    'color.background.neutral.bold': "var(--ds-background-neutral-bold, #42526E)",
    'color.background.neutral.bold.hovered': "var(--ds-background-neutral-bold-hovered, #505F79)",
    'color.background.neutral.bold.pressed': "var(--ds-background-neutral-bold-pressed, #344563)",
    'color.background.selected': "var(--ds-background-selected, #DEEBFF)",
    'color.background.selected.hovered': "var(--ds-background-selected-hovered, #B3D4FF)",
    'color.background.selected.pressed': "var(--ds-background-selected-pressed, #4C9AFF)",
    'color.background.selected.bold': "var(--ds-background-selected-bold, #0052CC)",
    'color.background.selected.bold.hovered': "var(--ds-background-selected-bold-hovered, #2684FF)",
    'color.background.selected.bold.pressed': "var(--ds-background-selected-bold-pressed, #0052CC)",
    'color.background.brand.subtlest': "var(--ds-background-brand-subtlest, #B3D4FF)",
    'color.background.brand.subtlest.hovered': "var(--ds-background-brand-subtlest-hovered, #DEEBFF)",
    'color.background.brand.subtlest.pressed': "var(--ds-background-brand-subtlest-pressed, #4C9AFF)",
    'color.background.brand.bold': "var(--ds-background-brand-bold, #0052CC)",
    'color.background.brand.bold.hovered': "var(--ds-background-brand-bold-hovered, #0065FF)",
    'color.background.brand.bold.pressed': "var(--ds-background-brand-bold-pressed, #0747A6)",
    'color.background.brand.boldest': "var(--ds-background-brand-boldest, #0747A6)",
    'color.background.brand.boldest.hovered': "var(--ds-background-brand-boldest-hovered, #0052CC)",
    'color.background.brand.boldest.pressed': "var(--ds-background-brand-boldest-pressed, #0747A6)",
    'color.background.danger': "var(--ds-background-danger, #FFEBE6)",
    'color.background.danger.hovered': "var(--ds-background-danger-hovered, #FFBDAD)",
    'color.background.danger.pressed': "var(--ds-background-danger-pressed, #FF8F73)",
    'color.background.danger.bold': "var(--ds-background-danger-bold, #DE350B)",
    'color.background.danger.bold.hovered': "var(--ds-background-danger-bold-hovered, #FF5630)",
    'color.background.danger.bold.pressed': "var(--ds-background-danger-bold-pressed, #BF2600)",
    'color.background.warning': "var(--ds-background-warning, #FFFAE6)",
    'color.background.warning.hovered': "var(--ds-background-warning-hovered, #FFF0B3)",
    'color.background.warning.pressed': "var(--ds-background-warning-pressed, #FFE380)",
    'color.background.warning.bold': "var(--ds-background-warning-bold, #FFAB00)",
    'color.background.warning.bold.hovered': "var(--ds-background-warning-bold-hovered, #FFC400)",
    'color.background.warning.bold.pressed': "var(--ds-background-warning-bold-pressed, #FF991F)",
    'color.background.success': "var(--ds-background-success, #E3FCEF)",
    'color.background.success.hovered': "var(--ds-background-success-hovered, #ABF5D1)",
    'color.background.success.pressed': "var(--ds-background-success-pressed, #79F2C0)",
    'color.background.success.bold': "var(--ds-background-success-bold, #00875A)",
    'color.background.success.bold.hovered': "var(--ds-background-success-bold-hovered, #57D9A3)",
    'color.background.success.bold.pressed': "var(--ds-background-success-bold-pressed, #00875A)",
    'color.background.discovery': "var(--ds-background-discovery, #EAE6FF)",
    'color.background.discovery.hovered': "var(--ds-background-discovery-hovered, #C0B6F2)",
    'color.background.discovery.pressed': "var(--ds-background-discovery-pressed, #998DD9)",
    'color.background.discovery.bold': "var(--ds-background-discovery-bold, #5243AA)",
    'color.background.discovery.bold.hovered': "var(--ds-background-discovery-bold-hovered, #8777D9)",
    'color.background.discovery.bold.pressed': "var(--ds-background-discovery-bold-pressed, #5243AA)",
    'color.background.information': "var(--ds-background-information, #DEEBFF)",
    'color.background.information.hovered': "var(--ds-background-information-hovered, #B3D4FF)",
    'color.background.information.pressed': "var(--ds-background-information-pressed, #4C9AFF)",
    'color.background.information.bold': "var(--ds-background-information-bold, #0052CC)",
    'color.background.information.bold.hovered': "var(--ds-background-information-bold-hovered, #2684FF)",
    'color.background.information.bold.pressed': "var(--ds-background-information-bold-pressed, #0052CC)",
    'color.blanket': "var(--ds-blanket, #091e4289)",
    'color.blanket.selected': "var(--ds-blanket-selected, #388BFF14)",
    'color.blanket.danger': "var(--ds-blanket-danger, #EF5C4814)",
    'color.skeleton': "var(--ds-skeleton, #F4F5F7)",
    'color.skeleton.subtle': "var(--ds-skeleton-subtle, #091e420a)",
    'elevation.surface': "var(--ds-surface, #FFFFFF)",
    'elevation.surface.hovered': "var(--ds-surface-hovered, #FAFBFC)",
    'elevation.surface.pressed': "var(--ds-surface-pressed, #F4F5F7)",
    'elevation.surface.overlay': "var(--ds-surface-overlay, #FFFFFF)",
    'elevation.surface.overlay.hovered': "var(--ds-surface-overlay-hovered, #FAFBFC)",
    'elevation.surface.overlay.pressed': "var(--ds-surface-overlay-pressed, #F4F5F7)",
    'elevation.surface.raised': "var(--ds-surface-raised, #FFFFFF)",
    'elevation.surface.raised.hovered': "var(--ds-surface-raised-hovered, #FAFBFC)",
    'elevation.surface.raised.pressed': "var(--ds-surface-raised-pressed, #F4F5F7)",
    'elevation.surface.sunken': "var(--ds-surface-sunken, #F4F5F7)",
    'utility.elevation.surface.current': "var(--ds-elevation-surface-current, #FFFFFF)"
};
var $fda1bdf5cf68a2eb$export$8473307aa00d6ea1 = {
    'color.text': "var(--ds-text, #172B4D)",
    'color.text.accent.lime': "var(--ds-text-accent-lime, #4C6B1F)",
    'color.text.accent.lime.bolder': "var(--ds-text-accent-lime-bolder, #37471F)",
    'color.text.accent.red': "var(--ds-text-accent-red, #DE350B)",
    'color.text.accent.red.bolder': "var(--ds-text-accent-red-bolder, #BF2600)",
    'color.text.accent.orange': "var(--ds-text-accent-orange, #F18D13)",
    'color.text.accent.orange.bolder': "var(--ds-text-accent-orange-bolder, #B65C02)",
    'color.text.accent.yellow': "var(--ds-text-accent-yellow, #FF991F)",
    'color.text.accent.yellow.bolder': "var(--ds-text-accent-yellow-bolder, #FF8B00)",
    'color.text.accent.green': "var(--ds-text-accent-green, #00875A)",
    'color.text.accent.green.bolder': "var(--ds-text-accent-green-bolder, #006644)",
    'color.text.accent.teal': "var(--ds-text-accent-teal, #00A3BF)",
    'color.text.accent.teal.bolder': "var(--ds-text-accent-teal-bolder, #008DA6)",
    'color.text.accent.blue': "var(--ds-text-accent-blue, #0052CC)",
    'color.text.accent.blue.bolder': "var(--ds-text-accent-blue-bolder, #0747A6)",
    'color.text.accent.purple': "var(--ds-text-accent-purple, #5243AA)",
    'color.text.accent.purple.bolder': "var(--ds-text-accent-purple-bolder, #403294)",
    'color.text.accent.magenta': "var(--ds-text-accent-magenta, #E774BB)",
    'color.text.accent.magenta.bolder': "var(--ds-text-accent-magenta-bolder, #DA62AC)",
    'color.text.accent.gray': "var(--ds-text-accent-gray, #505F79)",
    'color.text.accent.gray.bolder': "var(--ds-text-accent-gray-bolder, #172B4D)",
    'color.text.disabled': "var(--ds-text-disabled, #A5ADBA)",
    'color.text.inverse': "var(--ds-text-inverse, #FFFFFF)",
    'color.text.selected': "var(--ds-text-selected, #0052CC)",
    'color.text.brand': "var(--ds-text-brand, #0065FF)",
    'color.text.danger': "var(--ds-text-danger, #DE350B)",
    'color.text.warning': "var(--ds-text-warning, #974F0C)",
    'color.text.warning.inverse': "var(--ds-text-warning-inverse, #172B4D)",
    'color.text.success': "var(--ds-text-success, #006644)",
    'color.text.discovery': "var(--ds-text-discovery, #403294)",
    'color.text.information': "var(--ds-text-information, #0052CC)",
    'color.text.subtlest': "var(--ds-text-subtlest, #7A869A)",
    'color.text.subtle': "var(--ds-text-subtle, #42526E)",
    'color.link': "var(--ds-link, #0052CC)",
    'color.link.pressed': "var(--ds-link-pressed, #0747A6)",
    'color.link.visited': "var(--ds-link-visited, #403294)",
    'color.link.visited.pressed': "var(--ds-link-visited-pressed, #403294)"
};
var $fda1bdf5cf68a2eb$export$498780f74be9af68 = {
    'color.icon': "var(--ds-icon, #505F79)",
    'color.icon.accent.lime': "var(--ds-icon-accent-lime, #6A9A23)",
    'color.icon.accent.red': "var(--ds-icon-accent-red, #FF5630)",
    'color.icon.accent.orange': "var(--ds-icon-accent-orange, #D94008)",
    'color.icon.accent.yellow': "var(--ds-icon-accent-yellow, #FFAB00)",
    'color.icon.accent.green': "var(--ds-icon-accent-green, #36B37E)",
    'color.icon.accent.teal': "var(--ds-icon-accent-teal, #00B8D9)",
    'color.icon.accent.blue': "var(--ds-icon-accent-blue, #0065FF)",
    'color.icon.accent.purple': "var(--ds-icon-accent-purple, #6554C0)",
    'color.icon.accent.magenta': "var(--ds-icon-accent-magenta, #CD519D)",
    'color.icon.accent.gray': "var(--ds-icon-accent-gray, #5E6C84)",
    'color.icon.disabled': "var(--ds-icon-disabled, #8993A4)",
    'color.icon.inverse': "var(--ds-icon-inverse, #FFFFFF)",
    'color.icon.selected': "var(--ds-icon-selected, #0052CC)",
    'color.icon.brand': "var(--ds-icon-brand, #0065FF)",
    'color.icon.danger': "var(--ds-icon-danger, #DE350B)",
    'color.icon.warning': "var(--ds-icon-warning, #FFC400)",
    'color.icon.warning.inverse': "var(--ds-icon-warning-inverse, #253858)",
    'color.icon.success': "var(--ds-icon-success, #00875A)",
    'color.icon.discovery': "var(--ds-icon-discovery, #8777D9)",
    'color.icon.information': "var(--ds-icon-information, #0747A6)",
    'color.icon.subtle': "var(--ds-icon-subtle, #6B778C)"
};
var $fda1bdf5cf68a2eb$export$b5f31a7e431d2eab = {
    '1': 1,
    card: 100,
    navigation: 200,
    dialog: 300,
    layer: 400,
    blanket: 500,
    modal: 510,
    flag: 600,
    spotlight: 700,
    tooltip: 800
};
var $fda1bdf5cf68a2eb$export$e1b83c5210c471b8 = {
    'border.width': "var(--ds-border-width, 1px)",
    'border.width.0': "var(--ds-border-width-0, 0px)",
    'border.width.indicator': "var(--ds-border-width-indicator, 3px)",
    'border.width.outline': "var(--ds-border-width-outline, 2px)"
};
var $fda1bdf5cf68a2eb$export$3c0a6c3e64bb180d = {
    'border.radius.050': "var(--ds-border-radius-050, 2px)",
    'border.radius': "var(--ds-border-radius, 3px)",
    'border.radius.100': "var(--ds-border-radius-100, 3px)",
    'border.radius.200': "var(--ds-border-radius-200, 8px)",
    'border.radius.300': "var(--ds-border-radius-300, 12px)",
    'border.radius.400': "var(--ds-border-radius-400, 16px)",
    'border.radius.circle': "var(--ds-border-radius-circle, 32032px)"
};
var $fda1bdf5cf68a2eb$export$6ffa317d5e70375 = {
    'font.body': "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    'font.body.UNSAFE_small': "var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    'font.body.large': "var(--ds-font-body-large, normal 400 16px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    'font.body.small': "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    'font.code': "var(--ds-font-code, normal 400 0.875em/1 ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)",
    'font.heading.large': "var(--ds-font-heading-large, normal 500 24px/28px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    'font.heading.medium': "var(--ds-font-heading-medium, normal 500 20px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    'font.heading.small': "var(--ds-font-heading-small, normal 600 16px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    'font.heading.xlarge': "var(--ds-font-heading-xlarge, normal 600 29px/32px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    'font.heading.xsmall': "var(--ds-font-heading-xsmall, normal 600 14px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    'font.heading.xxlarge': "var(--ds-font-heading-xxlarge, normal 500 35px/40px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    'font.heading.xxsmall': "var(--ds-font-heading-xxsmall, normal 600 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)"
};
var $fda1bdf5cf68a2eb$export$303e322c6b1ed114 = {
    'font.weight.bold': "var(--ds-font-weight-bold, 700)",
    'font.weight.medium': "var(--ds-font-weight-medium, 500)",
    'font.weight.regular': "var(--ds-font-weight-regular, 400)",
    'font.weight.semibold': "var(--ds-font-weight-semibold, 600)"
};
var $fda1bdf5cf68a2eb$export$3c7e9587132614b4 = {
    'font.family.body': "var(--ds-font-family-body, ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    'font.family.brand.body': "var(--ds-font-family-brand-body, \"Charlie Text\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    'font.family.brand.heading': "var(--ds-font-family-brand-heading, \"Charlie Display\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    'font.family.code': "var(--ds-font-family-code, ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)",
    'font.family.heading': "var(--ds-font-family-heading, ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)"
};
var $fda1bdf5cf68a2eb$export$236bfe3a33ef1292 = {
    medium: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    UNSAFE_small: "var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    large: "var(--ds-font-body-large, normal 400 16px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    small: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)"
};
var $fda1bdf5cf68a2eb$export$855cfd311192d666 = {
    bold: "var(--ds-font-weight-bold, 700)",
    medium: "var(--ds-font-weight-medium, 500)",
    regular: "var(--ds-font-weight-regular, 400)",
    semibold: "var(--ds-font-weight-semibold, 600)"
};
/**
 * @codegenEnd
 */ // Margin needs some bespoke types: https://atlassian.slack.com/archives/CKRHB23K8/p1712623192772909
// Generate maps for Box props. backgroundColor, padding, etc
var $fda1bdf5cf68a2eb$var$spacingProperties = [
    // Used by Box
    'padding',
    'paddingBlock',
    'paddingBlockStart',
    'paddingBlockEnd',
    'paddingInline',
    'paddingInlineStart',
    'paddingInlineEnd',
    // Used by Inline and Stack
    'gap',
    'rowGap',
    'columnGap'
];
var $fda1bdf5cf68a2eb$export$ca0f9c2de39ffed7 = function getSerializedStylesMap(cssProperty, tokenMap) {
    return Object.keys(tokenMap).reduce(function(emotionSpacingMap, token) {
        // eslint-disable-next-line @repo/internal/styles/no-exported-styles
        emotionSpacingMap[token] = (0, $74Zh5.css)((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, cssProperty, tokenMap[token]));
        return emotionSpacingMap;
    }, {});
};
var $fda1bdf5cf68a2eb$export$e615f061ca585a6c = $fda1bdf5cf68a2eb$var$spacingProperties.reduce(function(styleMap, spacingProperty) {
    styleMap[spacingProperty] = $fda1bdf5cf68a2eb$export$ca0f9c2de39ffed7(spacingProperty, $fda1bdf5cf68a2eb$export$958d0ae7f2977ae4);
    return styleMap;
}, {});
var $fda1bdf5cf68a2eb$export$bf46c3f9eeafc71f = $fda1bdf5cf68a2eb$var$spacingProperties.reduce(function(styleMap, spacingProperty) {
    styleMap[spacingProperty] = $fda1bdf5cf68a2eb$export$ca0f9c2de39ffed7(spacingProperty, $fda1bdf5cf68a2eb$export$958d0ae7f2977ae4);
    return styleMap;
}, {});
var $fda1bdf5cf68a2eb$export$e7af83bafe7f9e63 = $fda1bdf5cf68a2eb$export$ca0f9c2de39ffed7('backgroundColor', $fda1bdf5cf68a2eb$export$d1d79bf68ac056bd);
var $fda1bdf5cf68a2eb$export$3a1bcba60b23d7f0 = $fda1bdf5cf68a2eb$export$ca0f9c2de39ffed7('color', $fda1bdf5cf68a2eb$export$8473307aa00d6ea1);
var $fda1bdf5cf68a2eb$export$45f3f4fe16f9f7d5 = $fda1bdf5cf68a2eb$export$ca0f9c2de39ffed7('fontWeight', $fda1bdf5cf68a2eb$export$303e322c6b1ed114);
var $fda1bdf5cf68a2eb$export$68cc305da27dbaa4 = $fda1bdf5cf68a2eb$export$ca0f9c2de39ffed7('fontFamily', $fda1bdf5cf68a2eb$export$3c7e9587132614b4);
var $fda1bdf5cf68a2eb$export$128f10c238242f83 = $fda1bdf5cf68a2eb$export$ca0f9c2de39ffed7('font', $fda1bdf5cf68a2eb$export$6ffa317d5e70375);
var $fda1bdf5cf68a2eb$export$219d364c0da35ae4 = $fda1bdf5cf68a2eb$export$ca0f9c2de39ffed7('font', $fda1bdf5cf68a2eb$export$236bfe3a33ef1292);
var $fda1bdf5cf68a2eb$export$38845ca010b93505 = $fda1bdf5cf68a2eb$export$ca0f9c2de39ffed7('fontWeight', $fda1bdf5cf68a2eb$export$855cfd311192d666);
var $fda1bdf5cf68a2eb$export$ff257d957d48c421 = $fda1bdf5cf68a2eb$export$ca0f9c2de39ffed7((0, $79c25bbc4e071f75$export$9d7b58831ae93caa), $fda1bdf5cf68a2eb$export$41a358c9c2356760);
var $fda1bdf5cf68a2eb$export$5e65a44e5b6ecadb = function isSurfaceColorToken(color) {
    return $fda1bdf5cf68a2eb$export$41a358c9c2356760[color] !== undefined;
};



var $fC8ib = parcelRequire("fC8ib");

var $25nEq = parcelRequire("25nEq");

var $iYJcE = parcelRequire("iYJcE");

var $ekGgq = parcelRequire("ekGgq");

var $74Zh5 = parcelRequire("74Zh5");


var $3ZMUU = parcelRequire("3ZMUU");
function $efa3c762c3cee56f$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $efa3c762c3cee56f$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $efa3c762c3cee56f$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $efa3c762c3cee56f$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $efa3c762c3cee56f$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $efa3c762c3cee56f$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
var $efa3c762c3cee56f$export$9a199fbafee0014e = {
    backgroundColor: (0, $fda1bdf5cf68a2eb$export$d1d79bf68ac056bd),
    blockSize: (0, $fda1bdf5cf68a2eb$export$6ccdbebca2ee545f),
    borderBlockColor: (0, $fda1bdf5cf68a2eb$export$1531ad5bb3fbedac),
    borderBlockEndColor: (0, $fda1bdf5cf68a2eb$export$1531ad5bb3fbedac),
    borderBlockEndWidth: (0, $fda1bdf5cf68a2eb$export$e1b83c5210c471b8),
    borderBlockStartColor: (0, $fda1bdf5cf68a2eb$export$1531ad5bb3fbedac),
    borderBlockStartWidth: (0, $fda1bdf5cf68a2eb$export$e1b83c5210c471b8),
    borderBlockWidth: (0, $fda1bdf5cf68a2eb$export$e1b83c5210c471b8),
    borderBottomColor: (0, $fda1bdf5cf68a2eb$export$1531ad5bb3fbedac),
    borderBottomLeftRadius: (0, $fda1bdf5cf68a2eb$export$3c0a6c3e64bb180d),
    borderBottomRightRadius: (0, $fda1bdf5cf68a2eb$export$3c0a6c3e64bb180d),
    borderBottomWidth: (0, $fda1bdf5cf68a2eb$export$e1b83c5210c471b8),
    borderColor: (0, $fda1bdf5cf68a2eb$export$1531ad5bb3fbedac),
    borderEndEndRadius: (0, $fda1bdf5cf68a2eb$export$3c0a6c3e64bb180d),
    borderEndStartRadius: (0, $fda1bdf5cf68a2eb$export$3c0a6c3e64bb180d),
    borderInlineColor: (0, $fda1bdf5cf68a2eb$export$1531ad5bb3fbedac),
    borderInlineEndColor: (0, $fda1bdf5cf68a2eb$export$1531ad5bb3fbedac),
    borderInlineEndWidth: (0, $fda1bdf5cf68a2eb$export$e1b83c5210c471b8),
    borderInlineStartColor: (0, $fda1bdf5cf68a2eb$export$1531ad5bb3fbedac),
    borderInlineStartWidth: (0, $fda1bdf5cf68a2eb$export$e1b83c5210c471b8),
    borderInlineWidth: (0, $fda1bdf5cf68a2eb$export$e1b83c5210c471b8),
    borderLeftColor: (0, $fda1bdf5cf68a2eb$export$1531ad5bb3fbedac),
    borderLeftWidth: (0, $fda1bdf5cf68a2eb$export$e1b83c5210c471b8),
    borderRadius: (0, $fda1bdf5cf68a2eb$export$3c0a6c3e64bb180d),
    borderRightColor: (0, $fda1bdf5cf68a2eb$export$1531ad5bb3fbedac),
    borderRightWidth: (0, $fda1bdf5cf68a2eb$export$e1b83c5210c471b8),
    borderStartEndRadius: (0, $fda1bdf5cf68a2eb$export$3c0a6c3e64bb180d),
    borderStartStartRadius: (0, $fda1bdf5cf68a2eb$export$3c0a6c3e64bb180d),
    borderTopColor: (0, $fda1bdf5cf68a2eb$export$1531ad5bb3fbedac),
    borderTopLeftRadius: (0, $fda1bdf5cf68a2eb$export$3c0a6c3e64bb180d),
    borderTopRightRadius: (0, $fda1bdf5cf68a2eb$export$3c0a6c3e64bb180d),
    borderTopWidth: (0, $fda1bdf5cf68a2eb$export$e1b83c5210c471b8),
    borderWidth: (0, $fda1bdf5cf68a2eb$export$e1b83c5210c471b8),
    bottom: (0, $fda1bdf5cf68a2eb$export$632685d741f3dbbf),
    boxShadow: (0, $fda1bdf5cf68a2eb$export$7aff6e7ba39bb774),
    color: (0, $fda1bdf5cf68a2eb$export$8473307aa00d6ea1),
    columnGap: (0, $fda1bdf5cf68a2eb$export$958d0ae7f2977ae4),
    font: (0, $fda1bdf5cf68a2eb$export$6ffa317d5e70375),
    fontFamily: (0, $fda1bdf5cf68a2eb$export$3c7e9587132614b4),
    fontWeight: (0, $fda1bdf5cf68a2eb$export$303e322c6b1ed114),
    gap: (0, $fda1bdf5cf68a2eb$export$958d0ae7f2977ae4),
    height: (0, $fda1bdf5cf68a2eb$export$6ccdbebca2ee545f),
    inlineSize: (0, $fda1bdf5cf68a2eb$export$6ccdbebca2ee545f),
    inset: (0, $fda1bdf5cf68a2eb$export$632685d741f3dbbf),
    insetBlock: (0, $fda1bdf5cf68a2eb$export$632685d741f3dbbf),
    insetBlockEnd: (0, $fda1bdf5cf68a2eb$export$632685d741f3dbbf),
    insetBlockStart: (0, $fda1bdf5cf68a2eb$export$632685d741f3dbbf),
    insetInline: (0, $fda1bdf5cf68a2eb$export$632685d741f3dbbf),
    insetInlineEnd: (0, $fda1bdf5cf68a2eb$export$632685d741f3dbbf),
    insetInlineStart: (0, $fda1bdf5cf68a2eb$export$632685d741f3dbbf),
    left: (0, $fda1bdf5cf68a2eb$export$632685d741f3dbbf),
    margin: (0, $fda1bdf5cf68a2eb$export$632685d741f3dbbf),
    marginBlock: (0, $fda1bdf5cf68a2eb$export$632685d741f3dbbf),
    marginBlockEnd: (0, $fda1bdf5cf68a2eb$export$632685d741f3dbbf),
    marginBlockStart: (0, $fda1bdf5cf68a2eb$export$632685d741f3dbbf),
    marginBottom: (0, $fda1bdf5cf68a2eb$export$632685d741f3dbbf),
    marginInline: (0, $fda1bdf5cf68a2eb$export$632685d741f3dbbf),
    marginInlineEnd: (0, $fda1bdf5cf68a2eb$export$632685d741f3dbbf),
    marginInlineStart: (0, $fda1bdf5cf68a2eb$export$632685d741f3dbbf),
    marginLeft: (0, $fda1bdf5cf68a2eb$export$632685d741f3dbbf),
    marginRight: (0, $fda1bdf5cf68a2eb$export$632685d741f3dbbf),
    marginTop: (0, $fda1bdf5cf68a2eb$export$632685d741f3dbbf),
    maxBlockSize: (0, $fda1bdf5cf68a2eb$export$6ccdbebca2ee545f),
    maxHeight: (0, $fda1bdf5cf68a2eb$export$6ccdbebca2ee545f),
    maxInlineSize: (0, $fda1bdf5cf68a2eb$export$6ccdbebca2ee545f),
    maxWidth: (0, $fda1bdf5cf68a2eb$export$6ccdbebca2ee545f),
    minBlockSize: (0, $fda1bdf5cf68a2eb$export$6ccdbebca2ee545f),
    minHeight: (0, $fda1bdf5cf68a2eb$export$6ccdbebca2ee545f),
    minInlineSize: (0, $fda1bdf5cf68a2eb$export$6ccdbebca2ee545f),
    minWidth: (0, $fda1bdf5cf68a2eb$export$6ccdbebca2ee545f),
    opacity: (0, $fda1bdf5cf68a2eb$export$daf94a976c798b4f),
    outlineColor: (0, $fda1bdf5cf68a2eb$export$1531ad5bb3fbedac),
    outlineOffset: (0, $fda1bdf5cf68a2eb$export$958d0ae7f2977ae4),
    outlineWidth: (0, $fda1bdf5cf68a2eb$export$e1b83c5210c471b8),
    padding: (0, $fda1bdf5cf68a2eb$export$958d0ae7f2977ae4),
    paddingBlock: (0, $fda1bdf5cf68a2eb$export$958d0ae7f2977ae4),
    paddingBlockEnd: (0, $fda1bdf5cf68a2eb$export$958d0ae7f2977ae4),
    paddingBlockStart: (0, $fda1bdf5cf68a2eb$export$958d0ae7f2977ae4),
    paddingBottom: (0, $fda1bdf5cf68a2eb$export$958d0ae7f2977ae4),
    paddingInline: (0, $fda1bdf5cf68a2eb$export$958d0ae7f2977ae4),
    paddingInlineEnd: (0, $fda1bdf5cf68a2eb$export$958d0ae7f2977ae4),
    paddingInlineStart: (0, $fda1bdf5cf68a2eb$export$958d0ae7f2977ae4),
    paddingLeft: (0, $fda1bdf5cf68a2eb$export$958d0ae7f2977ae4),
    paddingRight: (0, $fda1bdf5cf68a2eb$export$958d0ae7f2977ae4),
    paddingTop: (0, $fda1bdf5cf68a2eb$export$958d0ae7f2977ae4),
    right: (0, $fda1bdf5cf68a2eb$export$632685d741f3dbbf),
    rowGap: (0, $fda1bdf5cf68a2eb$export$958d0ae7f2977ae4),
    top: (0, $fda1bdf5cf68a2eb$export$632685d741f3dbbf),
    width: (0, $fda1bdf5cf68a2eb$export$6ccdbebca2ee545f),
    zIndex: (0, $fda1bdf5cf68a2eb$export$b5f31a7e431d2eab)
};
var $efa3c762c3cee56f$var$uniqueSymbol = Symbol('UNSAFE_INTERNAL_styles');
var $efa3c762c3cee56f$var$isSafeEnvToThrow = function isSafeEnvToThrow() {
    return (typeof $3ZMUU === "undefined" ? "undefined" : (0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))($3ZMUU)) === 'object' && (0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))($3ZMUU.env) === 'object' && false;
};
var $efa3c762c3cee56f$var$reNestedSelectors = /(\.|\s|&+|\*\>|#|\[.*\])/;
var $efa3c762c3cee56f$var$safeSelectors = /^@media .*$|^::?.*$|^@supports .*$/;
var $efa3c762c3cee56f$var$_transformStyles = function transformStyles(styleObj) {
    if (!styleObj || (0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(styleObj) !== 'object') return styleObj;
    // If styles are defined as a CSSObject[], recursively call on each element until we reach CSSObject
    if (Array.isArray(styleObj)) return styleObj.map($efa3c762c3cee56f$var$_transformStyles);
    // Modifies styleObj in place. Be careful.
    Object.entries(styleObj).forEach(function(_ref) {
        var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_ref, 2), key = _ref2[0], value = _ref2[1];
        // If key is a pseudo class or a pseudo element, then value should be an object.
        // So, call transformStyles on the value
        if ((0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(value) === 'object' && $efa3c762c3cee56f$var$safeSelectors.test(key)) {
            styleObj[key] = $efa3c762c3cee56f$var$_transformStyles(value);
            return;
        }
        if ($efa3c762c3cee56f$var$isSafeEnvToThrow()) {
            // We don't support `.class`, `[data-testid]`, `> *`, `#some-id`
            if ($efa3c762c3cee56f$var$reNestedSelectors.test(key)) throw new Error("Styles not supported for key '".concat(key, "'."));
        }
        // We have now dealt with all the special cases, so,
        // check whether what remains is a style property
        // that can be transformed.
        if (!(key in $efa3c762c3cee56f$export$9a199fbafee0014e)) return;
        var tokenValue = $efa3c762c3cee56f$export$9a199fbafee0014e[key][value];
        styleObj[key] = tokenValue !== null && tokenValue !== void 0 ? tokenValue : value;
    });
    return styleObj;
};
var $efa3c762c3cee56f$var$baseXcss = function baseXcss(style) {
    var transformedStyles = $efa3c762c3cee56f$var$_transformStyles(style);
    return (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, $efa3c762c3cee56f$var$uniqueSymbol, (0, $74Zh5.css)(transformedStyles));
};
/**
 * Picks out runtime XCSS objects and build-time XCSS strings. This is needed
 * to supported both Emotion and Compiled styles until we've fully migrated
 * to Compiled.
 *
 * @private
 * @deprecated
 */ var $efa3c762c3cee56f$export$a9c84988c8f81f2d = function parseXcss(args) {
    if (Array.isArray(args)) {
        var emotion = [];
        var staticArr = [];
        var _iterator = $efa3c762c3cee56f$var$_createForOfIteratorHelper(args), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var arg = _step.value;
                var result = $efa3c762c3cee56f$export$a9c84988c8f81f2d(arg);
                if (result.emotion) emotion.push.apply(emotion, (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(result.emotion));
                if (result.static) staticArr.push(result.static);
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
        return {
            emotion: emotion,
            static: staticArr.join(' ')
        };
    }
    var objArgs = args;
    var _ref4 = objArgs || {}, styles = _ref4[$efa3c762c3cee56f$var$uniqueSymbol];
    if (styles) return {
        emotion: [
            styles
        ]
    };
    if (args) {
        // We use string interpolation here instead of .toString() just
        // in case the resulting object doesn't have the method available.
        var stringifiedArgs = "".concat(args);
        if (stringifiedArgs) return {
            static: stringifiedArgs
        };
    }
    return {};
};
function $efa3c762c3cee56f$export$f6c783d06584602c(style) {
    return $efa3c762c3cee56f$var$baseXcss(style);
}


var $a014b84d18d0cecf$var$_excluded = [
    "as",
    "children",
    "backgroundColor",
    "padding",
    "paddingBlock",
    "paddingBlockStart",
    "paddingBlockEnd",
    "paddingInline",
    "paddingInlineStart",
    "paddingInlineEnd",
    "style",
    "testId",
    "xcss"
], $a014b84d18d0cecf$var$_excluded2 = [
    "className"
];
var $a014b84d18d0cecf$export$e71c4d32a2263218 = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? 'div' : _ref$as, children = _ref.children, backgroundColor = _ref.backgroundColor, padding = _ref.padding, paddingBlock = _ref.paddingBlock, paddingBlockStart = _ref.paddingBlockStart, paddingBlockEnd = _ref.paddingBlockEnd, paddingInline = _ref.paddingInline, paddingInlineStart = _ref.paddingInlineStart, paddingInlineEnd = _ref.paddingInlineEnd, style = _ref.style, testId = _ref.testId, xcss = _ref.xcss, htmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $a014b84d18d0cecf$var$_excluded);
    // This is to remove className from safeHtmlAttributes
    // @ts-expect-error className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(htmlAttributes, $a014b84d18d0cecf$var$_excluded2);
    var resolvedStyles = (0, $efa3c762c3cee56f$export$a9c84988c8f81f2d)(xcss);
    var node = // @ts-expect-error Expression produces a union type that is too complex to represent. I think this is unavoidable
    (0, $74Zh5.jsx)(Component, (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        style: style,
        ref: ref,
        className: resolvedStyles.static
    }, safeHtmlAttributes, {
        css: [
            $a014b84d18d0cecf$var$baseStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            backgroundColor && (0, $fda1bdf5cf68a2eb$export$e7af83bafe7f9e63)[backgroundColor],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $fda1bdf5cf68a2eb$export$5e65a44e5b6ecadb)(backgroundColor) && (0, $fda1bdf5cf68a2eb$export$ff257d957d48c421)[backgroundColor],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            padding && (0, $fda1bdf5cf68a2eb$export$e615f061ca585a6c).padding[padding],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlock && (0, $fda1bdf5cf68a2eb$export$e615f061ca585a6c).paddingBlock[paddingBlock],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlockStart && (0, $fda1bdf5cf68a2eb$export$e615f061ca585a6c).paddingBlockStart[paddingBlockStart],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlockEnd && (0, $fda1bdf5cf68a2eb$export$e615f061ca585a6c).paddingBlockEnd[paddingBlockEnd],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInline && (0, $fda1bdf5cf68a2eb$export$e615f061ca585a6c).paddingInline[paddingInline],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInlineStart && (0, $fda1bdf5cf68a2eb$export$e615f061ca585a6c).paddingInlineStart[paddingInlineStart],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInlineEnd && (0, $fda1bdf5cf68a2eb$export$e615f061ca585a6c).paddingInlineEnd[paddingInlineEnd],
            // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
            resolvedStyles.emotion
        ],
        "data-testid": testId
    }), children);
    return backgroundColor ? (0, $74Zh5.jsx)((0, $5a5dcf11228e3e89$export$1ca2a26fecb070ae).Provider, {
        value: backgroundColor
    }, node) : node;
});
var $a014b84d18d0cecf$export$2e2bcd8739ae039 = $a014b84d18d0cecf$export$e71c4d32a2263218;
var $a014b84d18d0cecf$var$baseStyles = (0, $74Zh5.css)({
    boxSizing: 'border-box',
    appearance: 'none',
    border: 'none'
});


var $31a965b6dd4a0db8$var$baseStylesOld = (0, $efa3c762c3cee56f$export$f6c783d06584602c)({
    display: 'inline-flex',
    borderRadius: 'border.radius',
    blockSize: 'min-content',
    position: 'static',
    overflow: 'hidden'
});
var $31a965b6dd4a0db8$var$styles = {
    container: (0, $74Zh5.css)({
        display: 'inline-flex',
        boxSizing: 'border-box',
        position: 'static',
        blockSize: 'min-content',
        borderRadius: '3px',
        overflow: 'hidden',
        paddingInline: "var(--ds-space-050, 4px)"
    }),
    containerSubtle: (0, $74Zh5.css)({
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
        outlineOffset: -1
    }),
    background: {
        bold: {
            default: (0, $74Zh5.css)({
                backgroundColor: '#DDDEE1'
            }),
            inprogress: (0, $74Zh5.css)({
                backgroundColor: '#8FB8F6'
            }),
            moved: (0, $74Zh5.css)({
                backgroundColor: '#F9C84E'
            }),
            new: (0, $74Zh5.css)({
                backgroundColor: '#D8A0F7'
            }),
            removed: (0, $74Zh5.css)({
                backgroundColor: '#FD9891'
            }),
            success: (0, $74Zh5.css)({
                backgroundColor: '#B3DF72'
            })
        },
        subtle: {
            default: (0, $74Zh5.css)({
                backgroundColor: "var(--ds-background-neutral-subtle, #00000000)"
            }),
            inprogress: (0, $74Zh5.css)({
                backgroundColor: "var(--ds-background-neutral-subtle, #00000000)"
            }),
            moved: (0, $74Zh5.css)({
                backgroundColor: "var(--ds-background-neutral-subtle, #00000000)"
            }),
            new: (0, $74Zh5.css)({
                backgroundColor: "var(--ds-background-neutral-subtle, #00000000)"
            }),
            removed: (0, $74Zh5.css)({
                backgroundColor: "var(--ds-background-neutral-subtle, #00000000)"
            }),
            success: (0, $74Zh5.css)({
                backgroundColor: "var(--ds-background-neutral-subtle, #00000000)"
            })
        }
    },
    border: {
        subtle: {
            default: (0, $74Zh5.css)({
                border: "1px solid #B7B9BE"
            }),
            inprogress: (0, $74Zh5.css)({
                border: "1px solid #669DF1"
            }),
            moved: (0, $74Zh5.css)({
                border: "1px solid #FCA700"
            }),
            new: (0, $74Zh5.css)({
                border: "1px solid #C97CF4"
            }),
            removed: (0, $74Zh5.css)({
                border: "1px solid #F87168"
            }),
            success: (0, $74Zh5.css)({
                border: "1px solid #94C748"
            })
        }
    },
    outline: {
        subtle: {
            default: (0, $74Zh5.css)({
                outline: "1px solid #B7B9BE"
            }),
            inprogress: (0, $74Zh5.css)({
                outline: "1px solid #669DF1"
            }),
            moved: (0, $74Zh5.css)({
                outline: "1px solid #FCA700"
            }),
            new: (0, $74Zh5.css)({
                outline: "1px solid #C97CF4"
            }),
            removed: (0, $74Zh5.css)({
                outline: "1px solid #F87168"
            }),
            success: (0, $74Zh5.css)({
                outline: "1px solid #94C748"
            })
        }
    },
    text: {
        subtle: (0, $74Zh5.css)({
            color: "var(--ds-text, #172B4D)"
        }),
        bold: (0, $74Zh5.css)({
            color: '#292A2E'
        })
    }
};
var $31a965b6dd4a0db8$var$textStyles = (0, $74Zh5.css)({
    fontFamily: "var(--ds-font-family-body, ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    fontSize: '11px',
    fontStyle: 'normal',
    fontWeight: "var(--ds-font-weight-bold, 700)",
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: '16px',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    textTransform: 'uppercase',
    whiteSpace: 'nowrap'
});
/**
 * __Lozenge__
 *
 * A lozenge is a visual indicator used to highlight an item's status for quick recognition.
 *
 * - [Examples](https://atlassian.design/components/lozenge/examples)
 * - [Code](https://atlassian.design/components/lozenge/code)
 * - [Usage](https://atlassian.design/components/lozenge/usage)
 */ var $31a965b6dd4a0db8$var$Lozenge = /*#__PURE__*/ (0, $5FkrB.memo)(function(_ref) {
    var children = _ref.children, testId = _ref.testId, _ref$isBold = _ref.isBold, isBold = _ref$isBold === void 0 ? false : _ref$isBold, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'default' : _ref$appearance, _ref$maxWidth = _ref.maxWidth, maxWidth = _ref$maxWidth === void 0 ? 200 : _ref$maxWidth, style = _ref.style;
    var appearanceStyle = isBold ? 'bold' : 'subtle';
    var appearanceType = appearance in $31a965b6dd4a0db8$var$styles.background[appearanceStyle] ? appearance : 'default';
    var maxWidthValue = typeof maxWidth === 'string' ? maxWidth : "".concat(maxWidth, "px");
    var maxWidthIsPc = typeof maxWidth === 'string' && /%$/.test(maxWidth);
    if ((0, $dU8Y3.fg)('platform-component-visual-refresh')) return (0, $74Zh5.jsx)("span", {
        style: {
            backgroundColor: style === null || style === void 0 ? void 0 : style.backgroundColor,
            maxWidth: maxWidthIsPc ? maxWidth : '100%'
        },
        css: [
            $31a965b6dd4a0db8$var$styles.container,
            $31a965b6dd4a0db8$var$styles.background[appearanceStyle][appearanceType],
            appearanceStyle === 'subtle' && !(0, $dU8Y3.fg)('visual-refresh_drop_5') && $31a965b6dd4a0db8$var$styles.border.subtle[appearanceType],
            appearanceStyle === 'subtle' && (0, $dU8Y3.fg)('visual-refresh_drop_5') && $31a965b6dd4a0db8$var$styles.outline.subtle[appearanceType],
            appearanceStyle === 'subtle' && (0, $dU8Y3.fg)('visual-refresh_drop_5') && $31a965b6dd4a0db8$var$styles.containerSubtle
        ],
        "data-testid": testId
    }, (0, $74Zh5.jsx)("span", {
        css: [
            $31a965b6dd4a0db8$var$textStyles,
            $31a965b6dd4a0db8$var$styles.text[appearanceStyle]
        ],
        style: {
            color: style === null || style === void 0 ? void 0 : style.color,
            // to negate paddingInline specified on Box above
            maxWidth: maxWidthIsPc ? '100%' : "calc(".concat(maxWidthValue, " - ", "var(--ds-space-100, 8px)", ")")
        },
        "data-testid": testId && "".concat(testId, "--text")
    }, children));
    var appearanceTypeOld = appearance in $31a965b6dd4a0db8$var$backgroundColorsOld[appearanceStyle] ? appearance : 'default';
    return (0, $74Zh5.jsx)((0, $a014b84d18d0cecf$export$2e2bcd8739ae039), {
        as: "span",
        backgroundColor: $31a965b6dd4a0db8$var$backgroundColorsOld[appearanceStyle][appearanceTypeOld],
        style: {
            backgroundColor: style === null || style === void 0 ? void 0 : style.backgroundColor,
            maxWidth: maxWidthIsPc ? maxWidth : '100%'
        },
        paddingInline: "space.050",
        xcss: $31a965b6dd4a0db8$var$baseStylesOld,
        testId: testId
    }, (0, $74Zh5.jsx)("span", {
        css: [
            $31a965b6dd4a0db8$var$textStyles,
            $31a965b6dd4a0db8$var$textColorsOld[appearanceStyle][appearanceType]
        ],
        style: {
            color: style === null || style === void 0 ? void 0 : style.color,
            // to negate paddingInline specified on Box above
            maxWidth: maxWidthIsPc ? '100%' : "calc(".concat(maxWidthValue, " - ", "var(--ds-space-100, 8px)", ")")
        },
        "data-testid": testId && "".concat(testId, "--text")
    }, children));
});
$31a965b6dd4a0db8$var$Lozenge.displayName = 'Lozenge';
var $31a965b6dd4a0db8$export$2e2bcd8739ae039 = $31a965b6dd4a0db8$var$Lozenge;
var $31a965b6dd4a0db8$var$backgroundColorsOld = {
    bold: {
        default: 'color.background.neutral.bold',
        inprogress: 'color.background.information.bold',
        moved: 'color.background.warning.bold',
        new: 'color.background.discovery.bold',
        removed: 'color.background.danger.bold',
        success: 'color.background.success.bold'
    },
    subtle: {
        default: 'color.background.neutral',
        inprogress: 'color.background.information',
        moved: 'color.background.warning',
        new: 'color.background.discovery',
        removed: 'color.background.danger',
        success: 'color.background.success'
    }
};
var $31a965b6dd4a0db8$var$textColorsOld = {
    bold: {
        default: (0, $74Zh5.css)({
            color: "var(--ds-text-inverse, #FFFFFF)"
        }),
        inprogress: (0, $74Zh5.css)({
            color: "var(--ds-text-inverse, #FFFFFF)"
        }),
        moved: (0, $74Zh5.css)({
            color: "var(--ds-text-warning-inverse, #172B4D)"
        }),
        new: (0, $74Zh5.css)({
            color: "var(--ds-text-inverse, #FFFFFF)"
        }),
        removed: (0, $74Zh5.css)({
            color: "var(--ds-text-inverse, #FFFFFF)"
        }),
        success: (0, $74Zh5.css)({
            color: "var(--ds-text-inverse, #FFFFFF)"
        })
    },
    subtle: {
        default: (0, $74Zh5.css)({
            color: "var(--ds-text-subtle, #42526E)"
        }),
        inprogress: (0, $74Zh5.css)({
            color: "var(--ds-text-information, #0052CC)"
        }),
        moved: (0, $74Zh5.css)({
            color: "var(--ds-text-warning, #974F0C)"
        }),
        new: (0, $74Zh5.css)({
            color: "var(--ds-text-discovery, #403294)"
        }),
        removed: (0, $74Zh5.css)({
            color: "var(--ds-text-danger, #DE350B)"
        }),
        success: (0, $74Zh5.css)({
            color: "var(--ds-text-success, #006644)"
        })
    }
};



var $kqp0i = parcelRequire("kqp0i");

var $5FkrB = parcelRequire("5FkrB");

var $74Zh5 = parcelRequire("74Zh5");

var $69J3E = parcelRequire("69J3E");

var $3FlkA = parcelRequire("3FlkA");


var $1qBWl = parcelRequire("1qBWl");
/**
 * An empty function which does nothing.
 */ function $da390e863547ad56$export$2e2bcd8739ae039() {}



var $25nEq = parcelRequire("25nEq");

var $5FkrB = parcelRequire("5FkrB");


var $dU8Y3 = parcelRequire("dU8Y3");
function $43f1965ab31d9c6c$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $43f1965ab31d9c6c$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $43f1965ab31d9c6c$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $43f1965ab31d9c6c$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $43f1965ab31d9c6c$export$650d12d3c2ddb8fc = /*#__PURE__*/ (0, $5FkrB.createContext)(0);
var $43f1965ab31d9c6c$export$48b383b280e20440 = /*#__PURE__*/ (0, $5FkrB.createContext)({
    topLevelRef: {
        current: null
    },
    layerList: {
        current: null
    },
    setTopLevel: (0, $da390e863547ad56$export$2e2bcd8739ae039)
});
/**
 *
 *  @internal
 * Context Provider Component which provider the current level of nested layers
 * It handles level management when it mounts and unmounts
 *
 */ var $43f1965ab31d9c6c$var$LevelProvider = function LevelProvider(_ref) {
    var children = _ref.children, currentLevel = _ref.currentLevel;
    var _useContext = (0, $5FkrB.useContext)($43f1965ab31d9c6c$export$48b383b280e20440), setTopLevel = _useContext.setTopLevel, topLevelRef = _useContext.topLevelRef, layerList = _useContext.layerList;
    // This is not unstable, it will run once for ref creation.
    // eslint-disable-next-line  @repo/internal/react/disallow-unstable-values
    var id = (0, $5FkrB.useRef)((0, $dU8Y3.fg)('layering-top-level-use-array') ? Math.random().toString(36) : '');
    if (!(0, $dU8Y3.fg)('layering-top-level-use-array')) {
        if (topLevelRef.current === null || currentLevel > topLevelRef.current) setTopLevel(currentLevel);
    }
    if (!(0, $dU8Y3.fg)('layering-top-level-use-array')) // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $5FkrB.useEffect)(function() {
        return function() {
            // avoid immediate cleanup using setTimeout when component unmount
            // this will make sure non-top layer components can get the correct top level value
            // when multiple layers trigger onClose in sequence
            setTimeout(function() {
                setTopLevel(currentLevel - 1);
            }, 0);
        };
    }, [
        setTopLevel,
        currentLevel,
        topLevelRef
    ]);
    if ((0, $dU8Y3.fg)('layering-top-level-use-array')) // Remove eslint error on FG cleanup
    // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $5FkrB.useEffect)(function() {
        var safeLayerList = layerList === null || layerList === void 0 ? void 0 : layerList.current;
        var safeId = id.current;
        if (!safeLayerList) return;
        safeLayerList.push(safeId);
        return function() {
            var index = safeLayerList.indexOf(safeId);
            if (index > -1) safeLayerList.splice(index, 1);
        };
    }, [
        layerList,
        id
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement($43f1965ab31d9c6c$export$650d12d3c2ddb8fc.Provider, {
        value: currentLevel
    }, children);
};
/**
 *
 *  @internal
 * Context Provider Component which provides the top level of all nested layers
 * It provides initial top level ref value as 0 and set top level method
 *
 */ var $43f1965ab31d9c6c$var$LayeringProvider = function LayeringProvider(_ref2) {
    var children = _ref2.children;
    var topLevelRef = (0, $5FkrB.useRef)(0);
    var layerList = (0, $5FkrB.useRef)([]);
    var value = (0, $5FkrB.useMemo)(function() {
        return $43f1965ab31d9c6c$var$_objectSpread({
            topLevelRef: topLevelRef,
            setTopLevel: function setTopLevel(level) {
                topLevelRef.current = level;
            }
        }, (0, $dU8Y3.fg)('layering-top-level-use-array') ? {
            layerList: layerList
        } : {});
    }, [
        topLevelRef
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement($43f1965ab31d9c6c$export$48b383b280e20440.Provider, {
        value: value
    }, children);
};
var $43f1965ab31d9c6c$export$7c885f891c940977 = function Layering(_ref3) {
    var children = _ref3.children, _ref3$isDisabled = _ref3.isDisabled, isDisabled = _ref3$isDisabled === void 0 ? true : _ref3$isDisabled;
    var currentLevel = (0, $5FkrB.useContext)($43f1965ab31d9c6c$export$650d12d3c2ddb8fc);
    if (isDisabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).Fragment, null, children);
    var isNested = currentLevel > 0;
    var content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement($43f1965ab31d9c6c$var$LevelProvider, {
        currentLevel: currentLevel + 1
    }, children);
    return isNested ? content : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement($43f1965ab31d9c6c$var$LayeringProvider, null, content);
};



var $5FkrB = parcelRequire("5FkrB");
/* keyframes-motion.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");

var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");

var $7QpUe = parcelRequire("7QpUe");
var $7d5b75923bcd7df8$var$isMatchMediaAvailable = function isMatchMediaAvailable() {
    return typeof window !== 'undefined' && 'matchMedia' in window;
};
var $7d5b75923bcd7df8$export$b7baf7667a68d87c = function isReducedMotion() {
    if (!$7d5b75923bcd7df8$var$isMatchMediaAvailable()) return false;
    var _window$matchMedia = window.matchMedia('(prefers-reduced-motion: reduce)'), matches = _window$matchMedia.matches;
    return matches;
};
var $7d5b75923bcd7df8$export$c537e63161742ce3 = function useIsReducedMotion() {
    var _useState = (0, $5FkrB.useState)($7d5b75923bcd7df8$export$b7baf7667a68d87c), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), prefersReducedMotion = _useState2[0], setPrefersReducedMotion = _useState2[1];
    (0, $5FkrB.useEffect)(function() {
        if (!$7d5b75923bcd7df8$var$isMatchMediaAvailable()) return;
        var mediaQueryList = window.matchMedia('(prefers-reduced-motion: reduce)');
        var onChange = function onChange(event) {
            return setPrefersReducedMotion(event.matches);
        };
        return (0, $7QpUe.bind)(mediaQueryList, {
            type: 'change',
            listener: onChange
        });
    }, []);
    return prefersReducedMotion;
};
var $7d5b75923bcd7df8$export$f0f789643ba5a83c = {
    '@media (prefers-reduced-motion: reduce)': {
        animation: 'none',
        transition: 'none'
    }
};
var $7d5b75923bcd7df8$export$ff7706047246b98b = function prefersReducedMotion() {
    return $7d5b75923bcd7df8$export$f0f789643ba5a83c;
};


/**
 * Think of this as the motion equivalent of the @atlaskit/theme `grid()`.
 */ var $3f46f842626a6ed4$export$368bacef0dacbe05 = 25;
var $3f46f842626a6ed4$export$38b928a7167ce124 = {
    none: 0,
    small: 100,
    medium: 350,
    large: 700
};
/**
 * Used to multiply the initial duration for exiting motions.
 */ var $3f46f842626a6ed4$var$EXITING_MOTION_MULTIPLIER = 0.5;
var $3f46f842626a6ed4$export$30fa1a2e62ae150c = {
    none: $3f46f842626a6ed4$export$38b928a7167ce124.none,
    small: $3f46f842626a6ed4$export$38b928a7167ce124.small * $3f46f842626a6ed4$var$EXITING_MOTION_MULTIPLIER,
    medium: $3f46f842626a6ed4$export$38b928a7167ce124.medium * $3f46f842626a6ed4$var$EXITING_MOTION_MULTIPLIER,
    large: $3f46f842626a6ed4$export$38b928a7167ce124.large * $3f46f842626a6ed4$var$EXITING_MOTION_MULTIPLIER
};



var $5FkrB = parcelRequire("5FkrB");
// Handle both browser and Node.js environments
var $a65ac7b835c82434$var$getHookDeps = function getHookDeps(opts) {
    switch(opts.cleanup){
        case 'next-effect':
            return undefined;
        case 'unmount':
        default:
            return [];
    }
};
var $a65ac7b835c82434$export$1775f27e7c8051ca = function useRequestAnimationFrame() {
    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        cleanup: 'unmount'
    };
    var frames = (0, $5FkrB.useRef)([]);
    (0, $5FkrB.useEffect)(function() {
        return function() {
            if (frames.current.length) {
                frames.current.forEach(function(id) {
                    return cancelAnimationFrame(id);
                });
                frames.current = [];
            }
        };
    // We dynamically set this so we either clean up on the next effect - or on unmount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, $a65ac7b835c82434$var$getHookDeps(opts));
    return (0, $5FkrB.useCallback)(function(handler) {
        var id = requestAnimationFrame(function(time) {
            frames.current = frames.current.filter(function(frameId) {
                return frameId !== id;
            });
            handler(time);
        });
        frames.current.push(id);
    }, []);
};
var $a65ac7b835c82434$export$4f34107a2b00f39c = function useSetTimeout() {
    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        cleanup: 'unmount'
    };
    var timeouts = (0, $5FkrB.useRef)([]);
    (0, $5FkrB.useEffect)(function() {
        return function() {
            if (timeouts.current.length) {
                timeouts.current.forEach(function(id) {
                    return clearTimeout(id);
                });
                timeouts.current = [];
            }
        };
    // We dynamically set this so we either clean up on the next effect - or on unmount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, $a65ac7b835c82434$var$getHookDeps(opts));
    return (0, $5FkrB.useCallback)(function(handler, timeout) {
        for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)args[_key - 2] = arguments[_key];
        var id = setTimeout.apply(void 0, [
            function() {
                timeouts.current = timeouts.current.filter(function(timeoutId) {
                    return timeoutId !== id;
                });
                handler();
            },
            timeout
        ].concat(args));
        timeouts.current.push(id);
    }, []);
};



var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");
/**
 * Internally we will be playing with an element that will always have a key defined.
 */ /**
 * Internal data passed to child motions.
 */ // We define empty context here so the object doesn't change.
var $0fe6287c12490552$var$emptyContext = {
    // Motions will always appear if not inside a exiting persistence component.
    appear: true,
    isExiting: false
};
/**
 * __Exiting context__
 *
 * An exiting context.
 */ var $0fe6287c12490552$var$ExitingContext = /*#__PURE__*/ (0, $5FkrB.createContext)($0fe6287c12490552$var$emptyContext);
/**
 * This method will wrap any React element with a context provider. We're using context (instead of
 * cloneElement) so we can communicate between multiple elements without the need of prop drilling
 * (results in a better API for consumers).
 */ var $0fe6287c12490552$var$wrapChildWithContextProvider = function wrapChildWithContextProvider(child) {
    var value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $0fe6287c12490552$var$emptyContext;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement($0fe6287c12490552$var$ExitingContext.Provider, {
        key: "".concat(child.key, "-provider"),
        value: value
    }, child);
};
/**
 * This function will convert all children types to an array while also filtering out non-valid React elements.
 */ var $0fe6287c12490552$var$childrenToArray = function childrenToArray(children) {
    var childrenAsArray = [];
    // We convert children to an array using this helper method as it will add keys to children that do not
    // have them, such as when we have hardcoded children that are conditionally rendered.
    (0, $5FkrB.Children).toArray(children).forEach(function(child) {
        // We ignore any boolean children to make our code a little more simple later on,
        // and also filter out any falsies (empty strings, nulls, and undefined).
        if (typeof child !== 'boolean' && Boolean(child)) // Children WILL have a key after being forced into an array using the React.Children helper.
        childrenAsArray.push(child);
    });
    return childrenAsArray;
};
var $0fe6287c12490552$var$spliceNewElementsIntoPrevious = function spliceNewElementsIntoPrevious(current, previous) {
    var splicedChildren = previous.concat([]);
    var previousMap = $0fe6287c12490552$var$childrenToObj(previous);
    for(var i = 0; i < current.length; i++){
        var child = current[i];
        var childIsNew = !previousMap[child.key];
        if (childIsNew) // This will insert the new element after the previous element.
        splicedChildren.splice(i + 1, 0, child);
    }
    return splicedChildren;
};
var $0fe6287c12490552$var$childrenToObj = function childrenToObj(children) {
    return children.reduce(function(acc, child) {
        acc[child.key] = child;
        return acc;
    }, {});
};
var $0fe6287c12490552$var$getMissingKeys = function getMissingKeys(current, previous) {
    var currentMapKeys = new Set(current.map(function(child) {
        return child.key;
    }));
    var missing = new Set();
    for(var i = 0; i < previous.length; i++){
        var element = previous[i];
        var _key = element.key;
        if (!currentMapKeys.has(_key)) missing.add(_key);
    }
    return missing;
};
/**
 * How does this component work?
 *
 * It looks at changes in its children to see what is removed.
 *
 * If a child is removed it clones it and wraps it with context providing an `onFinish` callback.
 *
 * The cloned child will call the `onFinish` when it finishes its exit animation,
 * which lets `ExitingPersistence` know to stop rendering it.
 */ /**
 * __ExitingPersistence__
 *
 * Useful for enabling elements to persist and animate away when they are removed from the DOM.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/motion/docs/entering-motions)
 */ var $0fe6287c12490552$var$ExitingPersistence = /*#__PURE__*/ (0, $5FkrB.memo)(function(_ref) {
    var _ref$appear = _ref.appear, appear = _ref$appear === void 0 ? false : _ref$appear, children = _ref.children, exitThenEnter = _ref.exitThenEnter;
    var _useState = (0, $5FkrB.useState)([
        null,
        children
    ]), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), stateChildren = _useState2[0], setChildren = _useState2[1];
    var _useState3 = (0, $5FkrB.useState)([]), _useState4 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState3, 2), exitingChildren = _useState4[0], setExitingChildren = _useState4[1];
    var _useState5 = (0, $5FkrB.useState)(function() {
        return {
            appear: appear,
            isExiting: false
        };
    }), _useState6 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState5, 2), defaultContext = _useState6[0], setDefaultContext = _useState6[1];
    (0, $5FkrB.useEffect)(function() {
        if (!defaultContext.appear) setDefaultContext({
            appear: true,
            isExiting: false
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    /**
   * NOTE: This is a workaround for the test case written in Jira where the stateChildren is a boolean value because
   * useState is mocked to return a boolean value.
   */ if (typeof stateChildren === 'boolean') return children;
    var _stateChildren = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(stateChildren, 2), previousChildren = _stateChildren[0], currentChildren = _stateChildren[1];
    var previous = $0fe6287c12490552$var$childrenToArray(previousChildren);
    var current = $0fe6287c12490552$var$childrenToArray(currentChildren);
    if (currentChildren !== children) setChildren([
        currentChildren,
        children
    ]);
    var missingKeys = $0fe6287c12490552$var$getMissingKeys(current, previous);
    var isSomeChildRemoved = !!missingKeys.size;
    var visibleChildren = current;
    if (isSomeChildRemoved) visibleChildren = $0fe6287c12490552$var$spliceNewElementsIntoPrevious(current, previous);
    if (exitThenEnter) {
        if (exitingChildren.length) visibleChildren = exitingChildren;
        else {
            var nextExitingChildren = visibleChildren.filter(function(child) {
                return missingKeys.has(child.key);
            });
            if (nextExitingChildren.length) setExitingChildren(nextExitingChildren);
        }
    }
    if (missingKeys.size) visibleChildren = visibleChildren.map(function(child) {
        var isExiting = missingKeys.has(child.key);
        return $0fe6287c12490552$var$wrapChildWithContextProvider(child, {
            appear: true,
            isExiting: isExiting,
            onFinish: isExiting ? function() {
                missingKeys.delete(child.key);
                if (missingKeys.size === 0) {
                    setChildren([
                        null,
                        children
                    ]);
                    setExitingChildren([]);
                }
            } : undefined
        });
    });
    else visibleChildren = visibleChildren.map(function(child) {
        return $0fe6287c12490552$var$wrapChildWithContextProvider(child, defaultContext);
    });
    return visibleChildren;
});
var $0fe6287c12490552$export$3b6f38abbdcbd000 = function useExitingPersistence() {
    return (0, $5FkrB.useContext)($0fe6287c12490552$var$ExitingContext);
};
$0fe6287c12490552$var$ExitingPersistence.displayName = 'ExitingPersistence';
var $0fe6287c12490552$export$2e2bcd8739ae039 = $0fe6287c12490552$var$ExitingPersistence;



var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");

var $eVb4V = parcelRequire("eVb4V");

var $5FkrB = parcelRequire("5FkrB");
var $ddf5c8c411f7d786$export$e5c5a5f917a5871c = typeof window === 'undefined' ? (0, $5FkrB.useEffect) : (0, $5FkrB.useLayoutEffect);


/* eslint-disable @repo/internal/react/disallow-unstable-values */ 
var $5FkrB = parcelRequire("5FkrB");
function $757344d5499b8033$export$c485849f2e393253() {
    var identifier = (0, $5FkrB.useRef)('');
    if (!identifier.current) identifier.current = '_' + (Number(String(Math.random()).slice(2)) + Date.now() + Math.round(performance.now())).toString(36);
    return identifier.current;
}


var $b5825582ff6fd441$var$StaggeredEntranceContext = /*#__PURE__*/ (0, $5FkrB.createContext)(function() {
    return {
        isReady: true,
        delay: 0,
        ref: (0, $eVb4V.default)
    };
});
var $b5825582ff6fd441$export$25c7213fc07ec080 = function useStaggeredEntrance() {
    var indentifier = (0, $757344d5499b8033$export$c485849f2e393253)();
    var context = (0, $5FkrB.useContext)($b5825582ff6fd441$var$StaggeredEntranceContext);
    return context(indentifier);
};
/**
 * For a list of elements that need to animate in,
 * this should be used in conjunction with entering components.
 * This does not need Javascript to execute so it will run immediately for any SSR rendered React apps before the JS has executed.
 *
 * Will dynamically add delay to each child entering component.
 * Unfortunately all entering components _NEED_ to be a direct descendant.
 */ var $b5825582ff6fd441$var$StaggeredEntrance = function StaggeredEntrance(_ref) {
    var children = _ref.children, column = _ref.column, _ref$columns = _ref.columns, columns = _ref$columns === void 0 ? 'responsive' : _ref$columns, _ref$delayStep = _ref.delayStep, delayStep = _ref$delayStep === void 0 ? 50 : _ref$delayStep;
    var elementRefs = (0, $5FkrB.useRef)([]);
    var indexes = [];
    var _useState = (0, $5FkrB.useState)(function() {
        if (typeof columns === 'number') // A hardcoded columns is set so bail out and set it to that!
        return columns;
        if (typeof column === 'number') // A hardcoded column is set so we will set actualColumns to be 1.
        return 1;
        // We are in "responsive" mode.
        // So we will be calculating when the Javascript executes on the client how many columns there will be.
        return 0;
    }), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), actualColumns = _useState2[0], setActualColumns = _useState2[1];
    (0, $ddf5c8c411f7d786$export$e5c5a5f917a5871c)(function() {
        // We want to only run this code when we are in "responsive" mode.
        // It is assumed we are in responsive mode if `columns` is "responsive",
        // we have children element refs ready to be read (i.e. if there are no children this won't run as well)
        // and finally that `actualColumns` is `0` - this is because for the first render cycle `actualColumns` will be `0` (set above)
        // and then after this layout effect runs the value for `actualColumns` will then be calculated and set.
        if (columns === 'responsive' && elementRefs.current.length && actualColumns === 0) {
            var currentTop = 0;
            var numberColumns = 0;
            if (elementRefs.current.length <= 1) {
                setActualColumns(1);
                return;
            }
            // We set the current top to the first elements.
            // We will be comparing this and incrementing the column count
            // until we hit an element that has a different offset top (or we run out of elements).
            currentTop = elementRefs.current[0] ? elementRefs.current[0].offsetTop : 0;
            for(var i = 0; i < elementRefs.current.length; i++){
                var child = elementRefs.current[i];
                if (!child) break;
                if (currentTop === child.offsetTop) {
                    numberColumns += 1;
                    if (elementRefs.current.length - 1 === i) setActualColumns(numberColumns);
                    continue;
                }
                setActualColumns(numberColumns);
                break;
            }
        }
    // We only want this effect to run once - on initial mount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement($b5825582ff6fd441$var$StaggeredEntranceContext.Provider, {
        value: function value(id) {
            if (!indexes.includes(id)) indexes.push(id);
            var isReady = actualColumns > 0;
            var index = indexes.indexOf(id);
            var currentColumn = column || index % actualColumns;
            var currentRow = Math.floor(index / actualColumns);
            var distanceFromTopLeftElement = currentRow + currentColumn;
            // We don't want loads of elements to have the same staggered delay as it ends up looking slow for users.
            // To get around that we calculate the logarithm using `distanceFromTopLeftElement` which ends making
            // elements appear faster the further away from the top left element.
            var delay = Math.ceil(Math.log(distanceFromTopLeftElement + 1) * delayStep * 1.5) || 0;
            return {
                delay: delay,
                isReady: isReady,
                ref: function ref(element) {
                    return elementRefs.current[index] = element;
                }
            };
        }
    }, children);
};
var $b5825582ff6fd441$export$2e2bcd8739ae039 = $b5825582ff6fd441$var$StaggeredEntrance;


var $9ee674df2e38cf65$var$zoomIn = null;
var $9ee674df2e38cf65$var$zoomOut = null;
var $9ee674df2e38cf65$var$fadeIn = null;
var $9ee674df2e38cf65$var$fadeOut = null;
var $9ee674df2e38cf65$var$fadeInFromTop = null;
var $9ee674df2e38cf65$var$fadeOutFromTop = null;
var $9ee674df2e38cf65$var$fadeInFromLeft = null;
var $9ee674df2e38cf65$var$fadeOutFromLeft = null;
var $9ee674df2e38cf65$var$fadeInFromBottom = null;
var $9ee674df2e38cf65$var$fadeOutFromBottom = null;
var $9ee674df2e38cf65$var$fadeInFromRight = null;
var $9ee674df2e38cf65$var$fadeOutFromRight = null;
var $9ee674df2e38cf65$var$fadeInFromTopConstant = null;
var $9ee674df2e38cf65$var$fadeOutFromTopConstant = null;
var $9ee674df2e38cf65$var$fadeInFromLeftConstant = null;
var $9ee674df2e38cf65$var$fadeOutFromLeftConstant = null;
var $9ee674df2e38cf65$var$fadeInFromBottomConstant = null;
var $9ee674df2e38cf65$var$fadeOutFromBottomConstant = null;
var $9ee674df2e38cf65$var$fadeInFromRightConstant = null;
var $9ee674df2e38cf65$var$fadeOutFromRightConstant = null;
var $9ee674df2e38cf65$var$slideInFromTop = null;
var $9ee674df2e38cf65$var$slideOutFromTop = null;
var $9ee674df2e38cf65$var$slideInFromRight = null;
var $9ee674df2e38cf65$var$slideOutFromRight = null;
var $9ee674df2e38cf65$var$slideInFromBottom = null;
var $9ee674df2e38cf65$var$slideOutFromBottom = null;
var $9ee674df2e38cf65$var$slideInFromLeft = null;
var $9ee674df2e38cf65$var$slideOutFromLeft = null;
/**
 * These are props that motions should use as their external props for consumers.
 * See [FadeIn](packages/helpers/motion/src/entering/fade-in.tsx) for an example usage.
 */ /**
 * This is the base INTERNAL component used for all other entering motions.
 * This does not need Javascript to execute on the client so it will run immediately
 * for any SSR rendered React apps before the JS has executed.
 */ var $9ee674df2e38cf65$var$EnteringMotion = function EnteringMotion(_ref) {
    var children = _ref.children, animationTimingFunction = _ref.animationTimingFunction, _ref$animationTimingF = _ref.animationTimingFunctionExiting, animationTimingFunctionExiting = _ref$animationTimingF === void 0 ? animationTimingFunction : _ref$animationTimingF, enteringAnimation = _ref.enteringAnimation, _ref$exitingAnimation = _ref.exitingAnimation, exitingAnimation = _ref$exitingAnimation === void 0 ? enteringAnimation : _ref$exitingAnimation, isPaused = _ref.isPaused, onFinishMotion = _ref.onFinish, _ref$duration = _ref.duration, duration = _ref$duration === void 0 ? 'large' : _ref$duration;
    var staggered = (0, $b5825582ff6fd441$export$25c7213fc07ec080)();
    var _useExitingPersistenc = (0, $0fe6287c12490552$export$3b6f38abbdcbd000)(), isExiting = _useExitingPersistenc.isExiting, onExitFinished = _useExitingPersistenc.onFinish, appear = _useExitingPersistenc.appear;
    var setTimeout = (0, $a65ac7b835c82434$export$4f34107a2b00f39c)();
    var paused = isPaused || !staggered.isReady;
    var delay = isExiting ? 0 : staggered.delay;
    var state = isExiting ? 'exiting' : 'entering';
    var _useState = (0, $5FkrB.useState)(appear), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), hasAnimationStyles = _useState2[0], setHasAnimationStyles = _useState2[1];
    (0, $5FkrB.useEffect)(function() {
        // Tracking this to prevent changing state on an unmounted component
        var isCancelled = false;
        if (paused) return;
        // On initial mount if elements aren't set to animate on appear, we return early and callback
        if (!appear) {
            onFinishMotion && onFinishMotion(state);
            return;
        }
        /**
     * Updates relevant state.
     * Called when the animation is finished, or immediately with reduced motion.
     */ var onAnimationEnd = function onAnimationEnd() {
            if (state === 'exiting') // Updates the `ExitingPersistence` to remove this child
            onExitFinished === null || onExitFinished === void 0 || onExitFinished();
            if (!isCancelled) setHasAnimationStyles(false);
            onFinishMotion === null || onFinishMotion === void 0 || onFinishMotion(state);
        };
        if ((0, $7d5b75923bcd7df8$export$b7baf7667a68d87c)()) {
            // If there is reduced motion there is no exit animation, so call this immediately
            onAnimationEnd();
            return;
        }
        // Elements may need animation styles back after initial mount (they could animate out)
        setHasAnimationStyles(true);
        // Queue `onAnimationEnd` for after the animation has finished
        setTimeout(onAnimationEnd, isExiting ? (0, $3f46f842626a6ed4$export$30fa1a2e62ae150c)[duration] : (0, $3f46f842626a6ed4$export$38b928a7167ce124)[duration] + delay);
        return function() {
            isCancelled = true;
        };
    // We ignore this for onFinishMotion as consumers could potentially inline the function
    // which would then trigger this effect every re-render.
    // We want to make it easier for consumers so we go down this path unfortunately.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        onExitFinished,
        state,
        isExiting,
        duration,
        delay,
        paused,
        setTimeout
    ]);
    return children({
        ref: staggered.ref,
        // @ts-expect-error: `ax` is not typed correctly
        className: hasAnimationStyles ? (0, $970q7.default)([
            (0, $970q7.default)([
                "_1o51eoah _1y0co91m _1bumglyw _sedtglyw"
            ]),
            paused && (0, $970q7.default)([
                "_1y0ctrqk"
            ]),
            duration === 'small' && (0, $970q7.default)([
                "_5sag1yx9"
            ]),
            duration === 'medium' && (0, $970q7.default)([
                "_5sag1ttt"
            ]),
            duration === 'large' && (0, $970q7.default)([
                "_5sagpwmj"
            ]),
            isExiting && duration === 'small' && (0, $970q7.default)([
                "_5sag14ed"
            ]),
            isExiting && duration === 'medium' && (0, $970q7.default)([
                "_5sagluct"
            ]),
            isExiting && duration === 'large' && (0, $970q7.default)([
                "_5sag1ttt"
            ]),
            isExiting && (0, $970q7.default)([
                "_ju255cps _1o51q7pw"
            ]),
            !isExiting && animationTimingFunction === 'linear' && (0, $970q7.default)([
                "_1pglp3kn"
            ]),
            !isExiting && animationTimingFunction === 'ease-out' && (0, $970q7.default)([
                "_1pgldkwg"
            ]),
            !isExiting && animationTimingFunction === 'ease-in' && (0, $970q7.default)([
                "_1pgl1nzg"
            ]),
            !isExiting && animationTimingFunction === 'ease-in-40-out' && (0, $970q7.default)([
                "_1pgl5y64"
            ]),
            !isExiting && animationTimingFunction === 'ease-in-60-out' && (0, $970q7.default)([
                "_1pgl1ddy"
            ]),
            !isExiting && animationTimingFunction === 'ease-in-80-out' && (0, $970q7.default)([
                "_1pglannl"
            ]),
            !isExiting && animationTimingFunction === 'ease-in-out' && (0, $970q7.default)([
                "_1pgl1fu8"
            ]),
            isExiting && animationTimingFunction === 'linear' && (0, $970q7.default)([
                "_1pglp3kn"
            ]),
            isExiting && animationTimingFunctionExiting === 'ease-out' && (0, $970q7.default)([
                "_1pgldkwg"
            ]),
            isExiting && animationTimingFunctionExiting === 'ease-in' && (0, $970q7.default)([
                "_1pgl1nzg"
            ]),
            isExiting && animationTimingFunctionExiting === 'ease-in-40-out' && (0, $970q7.default)([
                "_1pgl5y64"
            ]),
            isExiting && animationTimingFunctionExiting === 'ease-in-60-out' && (0, $970q7.default)([
                "_1pgl1ddy"
            ]),
            isExiting && animationTimingFunctionExiting === 'ease-in-80-out' && (0, $970q7.default)([
                "_1pglannl"
            ]),
            isExiting && animationTimingFunctionExiting === 'ease-in-out' && (0, $970q7.default)([
                "_1pgl1fu8"
            ]),
            (!isExiting && enteringAnimation === 'fade-in' || isExiting && exitingAnimation === 'fade-in') && (0, $970q7.default)([
                "_j7hq1cgr"
            ]),
            (!isExiting && enteringAnimation === 'fade-out' || isExiting && exitingAnimation === 'fade-out') && (0, $970q7.default)([
                "_j7hq1lln"
            ]),
            (!isExiting && enteringAnimation === 'zoom-in' || isExiting && exitingAnimation === 'zoom-in') && (0, $970q7.default)([
                "_j7hqe8p0"
            ]),
            (!isExiting && enteringAnimation === 'zoom-out' || isExiting && exitingAnimation === 'zoom-out') && (0, $970q7.default)([
                "_j7hqy6ql"
            ]),
            (!isExiting && enteringAnimation === 'slide-in-from-top' || isExiting && exitingAnimation === 'slide-in-from-top') && (0, $970q7.default)([
                "_j7hqqshu"
            ]),
            (!isExiting && enteringAnimation === 'slide-out-from-top' || isExiting && exitingAnimation === 'slide-out-from-top') && (0, $970q7.default)([
                "_j7hq7ri4"
            ]),
            (!isExiting && enteringAnimation === 'slide-in-from-right' || isExiting && exitingAnimation === 'slide-in-from-right') && (0, $970q7.default)([
                "_j7hqdfjr"
            ]),
            (!isExiting && enteringAnimation === 'slide-out-from-right' || isExiting && exitingAnimation === 'slide-out-from-right') && (0, $970q7.default)([
                "_j7hqonfj"
            ]),
            (!isExiting && enteringAnimation === 'slide-in-from-bottom' || isExiting && exitingAnimation === 'slide-in-from-bottom') && (0, $970q7.default)([
                "_j7hq1liq"
            ]),
            (!isExiting && enteringAnimation === 'slide-out-from-bottom' || isExiting && exitingAnimation === 'slide-out-from-bottom') && (0, $970q7.default)([
                "_j7hqhnf1"
            ]),
            (!isExiting && enteringAnimation === 'slide-in-from-left' || isExiting && exitingAnimation === 'slide-in-from-left') && (0, $970q7.default)([
                "_j7hq1bh1"
            ]),
            (!isExiting && enteringAnimation === 'slide-out-from-left' || isExiting && exitingAnimation === 'slide-out-from-left') && (0, $970q7.default)([
                "_j7hqj08w"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-top' || isExiting && exitingAnimation === 'fade-in-from-top') && (0, $970q7.default)([
                "_j7hq2iua"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-top' || isExiting && exitingAnimation === 'fade-out-from-top') && (0, $970q7.default)([
                "_j7hq39va"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-left' || isExiting && exitingAnimation === 'fade-in-from-left') && (0, $970q7.default)([
                "_j7hq15m2"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-left' || isExiting && exitingAnimation === 'fade-out-from-left') && (0, $970q7.default)([
                "_j7hq1yiv"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-bottom' || isExiting && exitingAnimation === 'fade-in-from-bottom') && (0, $970q7.default)([
                "_j7hq1w00"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-bottom' || isExiting && exitingAnimation === 'fade-out-from-bottom') && (0, $970q7.default)([
                "_j7hqzy3z"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-right' || isExiting && exitingAnimation === 'fade-in-from-right') && (0, $970q7.default)([
                "_j7hqpqak"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-right' || isExiting && exitingAnimation === 'fade-out-from-right') && (0, $970q7.default)([
                "_j7hq1ebg"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-top-constant' || isExiting && exitingAnimation === 'fade-in-from-top-constant') && (0, $970q7.default)([
                "_j7hqm2e2"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-top-constant' || isExiting && exitingAnimation === 'fade-out-from-top-constant') && (0, $970q7.default)([
                "_j7hq97jn"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-left-constant' || isExiting && exitingAnimation === 'fade-in-from-left-constant') && (0, $970q7.default)([
                "_j7hqovgq"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-left-constant' || isExiting && exitingAnimation === 'fade-out-from-left-constant') && (0, $970q7.default)([
                "_j7hq15do"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-bottom-constant' || isExiting && exitingAnimation === 'fade-in-from-bottom-constant') && (0, $970q7.default)([
                "_j7hq797a"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-bottom-constant' || isExiting && exitingAnimation === 'fade-out-from-bottom-constant') && (0, $970q7.default)([
                "_j7hqwo7r"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-right-constant' || isExiting && exitingAnimation === 'fade-in-from-right-constant') && (0, $970q7.default)([
                "_j7hqt8u5"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-right-constant' || isExiting && exitingAnimation === 'fade-out-from-right-constant') && (0, $970q7.default)([
                "_j7hq1pgp"
            ])
        ]) : '',
        style: {
            animationDelay: "".concat(delay, "ms")
        }
    }, state);
};
var $9ee674df2e38cf65$export$2e2bcd8739ae039 = $9ee674df2e38cf65$var$EnteringMotion;


var $c6ef6bab38bd84d5$var$invertedDirection = {
    top: 'bottom',
    bottom: 'top',
    left: 'right',
    right: 'left'
};
/**
 * Props for controlling the behavior of the FadeIn animation
 */ /**
 * __FadeIn__
 *
 * Useful for fading in one or more elements.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/motion/docs/entering-motions)
 */ var $c6ef6bab38bd84d5$var$FadeIn = function FadeIn(_ref) {
    var children = _ref.children, _ref$duration = _ref.duration, duration = _ref$duration === void 0 ? 'large' : _ref$duration, entranceDirection = _ref.entranceDirection, exitDirection = _ref.exitDirection, _ref$distance = _ref.distance, distance = _ref$distance === void 0 ? 'proportional' : _ref$distance, onFinish = _ref.onFinish, isPaused = _ref.isPaused;
    var invertedEntranceDirection = entranceDirection !== undefined ? $c6ef6bab38bd84d5$var$invertedDirection[entranceDirection] : undefined;
    var isExitDirect = Boolean(exitDirection || invertedEntranceDirection) ? "fade-out-from-".concat(exitDirection || invertedEntranceDirection).concat(distance === 'proportional' ? '' : '-constant') : 'fade-out';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $9ee674df2e38cf65$export$2e2bcd8739ae039), {
        duration: duration,
        enteringAnimation: entranceDirection ? "fade-in-from-".concat(entranceDirection).concat(distance === 'proportional' ? '' : '-constant') : 'fade-in',
        exitingAnimation: isExitDirect,
        animationTimingFunction: "ease-in-out",
        onFinish: onFinish,
        isPaused: isPaused
    }, children);
};
var $c6ef6bab38bd84d5$export$2e2bcd8739ae039 = $c6ef6bab38bd84d5$var$FadeIn;



var $dU8Y3 = parcelRequire("dU8Y3");

var $5FkrB = parcelRequire("5FkrB");

var $dU8Y3 = parcelRequire("dU8Y3");

var $5FkrB = parcelRequire("5FkrB");

var $aLeHs = parcelRequire("aLeHs");
var $afd17a2832845011$export$e4c79eb95c23a0da = 'atlaskit-portal-container';
var $afd17a2832845011$export$72f415121273627e = 'body > .atlaskit-portal-container';
var $afd17a2832845011$export$13f57c02915787b3 = 'atlaskit-portal';


var $4edea02eb2028794$export$26ae5ca175b4ec5a = function createContainer(zIndex) {
    var container = document.createElement('div');
    container.className = (0, $afd17a2832845011$export$13f57c02915787b3);
    container.style.zIndex = "".concat(zIndex);
    return container;
};
/**
 * Returns document body element
 * @return {number} - The document body element
 */ var $4edea02eb2028794$var$getBody = function getBody() {
    return document.body;
};
/**
 * Returns portal parent container. If no container exists already then it creates a new container with class name 'atlaskit-portal-container'
 * @return {Element} - The portal parent container div element
 */ var $4edea02eb2028794$var$getPortalParent = function getPortalParent() {
    var parentElement = document.querySelector((0, $afd17a2832845011$export$72f415121273627e));
    if (!parentElement) {
        var _getBody;
        var parent = document.createElement('div');
        parent.className = (0, $afd17a2832845011$export$e4c79eb95c23a0da);
        // we are setting display to flex because we want each portal to create a new stacking context
        // See https://developer.mozilla.org/en-US/docs/Web/CSS/CSS_Positioning/Understanding_z_index/The_stacking_context
        parent.style.display = 'flex';
        (_getBody = $4edea02eb2028794$var$getBody()) === null || _getBody === void 0 || _getBody.appendChild(parent);
        return parent;
    }
    return parentElement;
};
var $4edea02eb2028794$export$da99f98bf3fe55b3 = function removePortalContainer(container) {
    $4edea02eb2028794$var$getPortalParent().removeChild(container);
};
var $4edea02eb2028794$export$c582005add11e141 = function appendPortalContainerIfNotAppended(container) {
    if (!container.parentElement) $4edea02eb2028794$var$getPortalParent().appendChild(container);
};
var $4edea02eb2028794$var$isDocumentDefined = function isDocumentDefined() {
    return document !== undefined;
};
var $4edea02eb2028794$export$fef014d7cef9e543 = function createAtlaskitPortal(zIndex) {
    //atlaskit-portal div
    if ($4edea02eb2028794$var$isDocumentDefined()) {
        var atlaskitportal = document.createElement('div');
        atlaskitportal.className = (0, $afd17a2832845011$export$13f57c02915787b3);
        atlaskitportal.style.zIndex = "".concat(zIndex);
        return atlaskitportal;
    }
    return;
};
var $4edea02eb2028794$export$95029ca7aca2989e = function createPortalParent() {
    //atlaskit-portal-container div
    if ($4edea02eb2028794$var$isDocumentDefined()) {
        var parentElement = document.querySelector((0, $afd17a2832845011$export$72f415121273627e));
        if (!parentElement) {
            var _getBody2;
            var parent = document.createElement('div');
            parent.className = (0, $afd17a2832845011$export$e4c79eb95c23a0da);
            parent.style.display = 'flex';
            (_getBody2 = $4edea02eb2028794$var$getBody()) === null || _getBody2 === void 0 || _getBody2.appendChild(parent);
            return parent;
        }
        return parentElement;
    }
    return;
};


function $f20771a0bd71fdf4$export$2e2bcd8739ae039(props) {
    var zIndex = props.zIndex, children = props.children;
    var container = (0, $5FkrB.useMemo)(function() {
        return (0, $4edea02eb2028794$export$26ae5ca175b4ec5a)(zIndex);
    }, [
        zIndex
    ]);
    // This is in the render method instead of useEffect so that
    // the portal will be added to the DOM before the children render.
    // For any further changes, ensure that the container does not have a
    // parent besides the portal parent.
    (0, $4edea02eb2028794$export$c582005add11e141)(container);
    (0, $5FkrB.useEffect)(function() {
        return function() {
            (0, $4edea02eb2028794$export$da99f98bf3fe55b3)(container);
        };
    }, [
        container
    ]);
    return /*#__PURE__*/ (0, $aLeHs.createPortal)(children, container);
}



var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");

var $aLeHs = parcelRequire("aLeHs");

var $5FkrB = parcelRequire("5FkrB");
var $170cb47092015b5c$export$700979bc83e7db82 = typeof window !== 'undefined' ? (0, $5FkrB.useLayoutEffect) : (0, $5FkrB.useEffect);



function $4b631ac6bcfbd682$export$2e2bcd8739ae039(props) {
    var zIndex = props.zIndex, children = props.children;
    var _useState = (0, $5FkrB.useState)(null), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), atlaskitPortal = _useState2[0], setAtlaskitPortal = _useState2[1];
    (0, $170cb47092015b5c$export$700979bc83e7db82)(function() {
        var tempPortalContainer = (0, $4edea02eb2028794$export$fef014d7cef9e543)(zIndex);
        setAtlaskitPortal(tempPortalContainer);
        var portalParent = (0, $4edea02eb2028794$export$95029ca7aca2989e)();
        if (!tempPortalContainer || !portalParent) return;
        portalParent.appendChild(tempPortalContainer);
        return function() {
            if (tempPortalContainer) portalParent.removeChild(tempPortalContainer);
            setAtlaskitPortal(null);
        };
    }, [
        zIndex
    ]);
    /**
   * We wrap portal children with a Suspense boundary because in React 18 concurrent,
   * if you suspend from _within_ a portal to a Suspense boundary _outside_ the portal,
   * our portal gets in an infinite loop of rendering.
   */ var suspendedChildren = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $5FkrB.Suspense), {
        fallback: null
    }, children);
    return atlaskitPortal ? /*#__PURE__*/ (0, $aLeHs.createPortal)(suspendedChildren, atlaskitPortal) : null;
}



var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");

var $45f32acfdab27d59$var$useIsSubsequentRender = function useIsSubsequentRender(mountStrategy) {
    var _useState = (0, $5FkrB.useState)(false), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), isSubsequentRender = _useState2[0], setIsSubsequentRender = _useState2[1];
    var _useState3 = (0, $5FkrB.useState)(function() {
        return mountStrategy === 'layoutEffect' ? (0, $170cb47092015b5c$export$700979bc83e7db82) : (0, $5FkrB.useEffect);
    }), _useState4 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState3, 1), useMountEffect = _useState4[0];
    useMountEffect(function() {
        setIsSubsequentRender(true);
    }, []);
    return isSubsequentRender;
};
var $45f32acfdab27d59$export$2e2bcd8739ae039 = $45f32acfdab27d59$var$useIsSubsequentRender;



var $5FkrB = parcelRequire("5FkrB");
var $5024562cbe4bd0a6$export$ed5835cc67e87f72 = 'akPortalMount';
var $5024562cbe4bd0a6$export$80816bd900e5bd00 = 'akPortalUnmount';


var $6604c609bdf7ecc9$var$zIndexToName = {
    100: 'card',
    200: 'navigation',
    300: 'dialog',
    400: 'layer',
    500: 'blanket',
    510: 'modal',
    600: 'flag',
    700: 'spotlight',
    9999: 'tooltip'
};
/**
 * return layer name in Atlassian design system corresponding to given z-index
 * @param {number} zIndex - z-index value for which layer name is needed
 * @returns {LayerName | null} - The layer name for given z-index. If layer name is not found then null is returned
 */ var $6604c609bdf7ecc9$var$getLayerName = function getLayerName(zIndex) {
    return $6604c609bdf7ecc9$var$zIndexToName.hasOwnProperty(zIndex) ? $6604c609bdf7ecc9$var$zIndexToName[zIndex] : null;
};
/**
 * Creates a PortalEvent object with given eventName, given zIndex and corresponding layer
 * @param {string} eventName - either of Mount or Unmount event name
 * @param {number} zIndex - z-index value which will be included in the event to be dispatched
 * @returns {PortalEvent} - The newly created PortalEvent object
 */ var $6604c609bdf7ecc9$var$getEvent = function getEvent(eventName, zIndex) {
    var detail = {
        layer: $6604c609bdf7ecc9$var$getLayerName(Number(zIndex)),
        zIndex: zIndex
    };
    return new CustomEvent(eventName, {
        detail: detail
    });
};
function $6604c609bdf7ecc9$export$2e2bcd8739ae039(eventName, zIndex) {
    var event = $6604c609bdf7ecc9$var$getEvent(eventName, zIndex);
    window.dispatchEvent(event);
}


var $974956a0478f07c4$var$useFirePortalEvent = function useFirePortalEvent(zIndex) {
    var zIndexNumber = Number(zIndex);
    (0, $5FkrB.useEffect)(function() {
        (0, $6604c609bdf7ecc9$export$2e2bcd8739ae039)((0, $5024562cbe4bd0a6$export$ed5835cc67e87f72), zIndexNumber);
        return function() {
            (0, $6604c609bdf7ecc9$export$2e2bcd8739ae039)((0, $5024562cbe4bd0a6$export$80816bd900e5bd00), zIndexNumber);
        };
    }, [
        zIndexNumber
    ]);
};
var $974956a0478f07c4$export$2e2bcd8739ae039 = $974956a0478f07c4$var$useFirePortalEvent;


function $062c34d20b8b2f54$export$2e2bcd8739ae039(_ref) {
    var _ref$zIndex = _ref.zIndex, zIndex = _ref$zIndex === void 0 ? 0 : _ref$zIndex, children = _ref.children, _ref$mountStrategy = _ref.mountStrategy, mountStrategy = _ref$mountStrategy === void 0 ? 'effect' : _ref$mountStrategy;
    var isSubsequentRender = (0, $45f32acfdab27d59$export$2e2bcd8739ae039)(mountStrategy);
    (0, $974956a0478f07c4$export$2e2bcd8739ae039)(zIndex);
    return !(0, $dU8Y3.fg)('platform_design_system_team_portal_logic_r18_fix') ? isSubsequentRender ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $f20771a0bd71fdf4$export$2e2bcd8739ae039), {
        zIndex: zIndex
    }, children) : null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $4b631ac6bcfbd682$export$2e2bcd8739ae039), {
        zIndex: zIndex
    }, children);
}


/* eslint-disable no-console */ var $f37f61d831f45d36$var$printed = {};
function $f37f61d831f45d36$export$2e2bcd8739ae039(message) {
    if ($f37f61d831f45d36$var$printed[message]) return;
    $f37f61d831f45d36$var$printed[message] = true;
    if (typeof window !== 'undefined') console.warn(message);
}



var $3ZMUU = parcelRequire("3ZMUU");
function $b5d2e0354c69b158$export$2e2bcd8739ae039(packageName, api, additionalMessage) {
    (0, $f37f61d831f45d36$export$2e2bcd8739ae039)("[".concat(packageName, "]: The ").concat(api, " is deprecated.").concat(additionalMessage && " ".concat(additionalMessage)));
}
function $b5d2e0354c69b158$export$eb1decd851a5ae56(packageName, propName, predicate, deprecationAnnouncementOnDAC) {
    typeof $3ZMUU;
}


// Reds
var $881e75c45a88d9b7$export$4b84fd0e2c617bd = '#FFEBE6';
var $881e75c45a88d9b7$export$b34b069eff244586 = '#FFBDAD';
var $881e75c45a88d9b7$export$be802dd0d8b57f35 = '#FF8F73';
var $881e75c45a88d9b7$export$60847d42f9da92a6 = '#FF7452';
var $881e75c45a88d9b7$export$4a7404f376229999 = '#FF5630';
var $881e75c45a88d9b7$export$2010d0fb4295b346 = '#DE350B';
var $881e75c45a88d9b7$export$2837b5a1a71d5c02 = '#BF2600';
var $881e75c45a88d9b7$export$8d9596b529bbb9cf = '#FFFAE6';
var $881e75c45a88d9b7$export$41060a744ab0b7ae = '#FFF0B3';
var $881e75c45a88d9b7$export$1cc05bbbf340e559 = '#FFE380';
var $881e75c45a88d9b7$export$5aae31392d72caaa = '#FFC400';
var $881e75c45a88d9b7$export$c6930421db9fa514 = '#FFAB00';
var $881e75c45a88d9b7$export$59619663aa6500fb = '#FF991F';
var $881e75c45a88d9b7$export$874739ea9e379ab6 = '#FF8B00';
var $881e75c45a88d9b7$export$8a6341c32b6a3ee6 = '#E3FCEF';
var $881e75c45a88d9b7$export$69a3bf21b9686c2b = '#ABF5D1';
var $881e75c45a88d9b7$export$afbce1382ec95f73 = '#79F2C0';
var $881e75c45a88d9b7$export$747d86715d4175de = '#57D9A3';
var $881e75c45a88d9b7$export$940e1f69e873f202 = '#36B37E';
var $881e75c45a88d9b7$export$a49394138f7b8e85 = '#00875A';
var $881e75c45a88d9b7$export$6fa04827ac68a4fb = '#006644';
var $881e75c45a88d9b7$export$226de0355ed012f8 = '#DEEBFF';
var $881e75c45a88d9b7$export$8c13c2ee36917869 = '#B3D4FF';
var $881e75c45a88d9b7$export$ecfc1dff386a3e7a = '#4C9AFF';
var $881e75c45a88d9b7$export$215b7063051591f1 = '#2684FF';
var $881e75c45a88d9b7$export$e62e8919cca44969 = '#0065FF';
var $881e75c45a88d9b7$export$b3de0ae08da2ce64 = '#0052CC';
var $881e75c45a88d9b7$export$a6ee3d71bc067634 = '#0747A6';
var $881e75c45a88d9b7$export$67f15409e87642a1 = '#669DF1';
var $881e75c45a88d9b7$export$f0539dbc42dbb067 = '#8FB8F6';
var $881e75c45a88d9b7$export$363e4475840015bb = '#EAE6FF';
var $881e75c45a88d9b7$export$4b0a4417ed59760f = '#C0B6F2';
var $881e75c45a88d9b7$export$6011520a64d9a187 = '#998DD9';
var $881e75c45a88d9b7$export$a7175d4e9206bc80 = '#8777D9';
var $881e75c45a88d9b7$export$b48405b95304b5a1 = '#6554C0';
var $881e75c45a88d9b7$export$c71e4279dd54a18d = '#5243AA';
var $881e75c45a88d9b7$export$147899de772240ec = '#403294';
var $881e75c45a88d9b7$export$2cf711fe14c66f06 = '#E6FCFF';
var $881e75c45a88d9b7$export$7a8f4d33f6f9772c = '#B3F5FF';
var $881e75c45a88d9b7$export$776c9c497ef08533 = '#79E2F2';
var $881e75c45a88d9b7$export$69cb3ca10c1e330e = '#00C7E6';
var $881e75c45a88d9b7$export$9dc1ef0f3f48059b = '#00B8D9';
var $881e75c45a88d9b7$export$7c835c78b6fcdef8 = '#00A3BF';
var $881e75c45a88d9b7$export$6036577f95c3877e = '#008DA6';
var $881e75c45a88d9b7$export$29a4f05edc054374 = '#FFFFFF';
var $881e75c45a88d9b7$export$e655ef011c4aa1a2 = '#FAFBFC';
var $881e75c45a88d9b7$export$9fdfb749e33cdf97 = '#F4F5F7';
var $881e75c45a88d9b7$export$3e51e8f1440314ba = '#EBECF0';
var $881e75c45a88d9b7$export$1ce2d1575d444ceb = '#DFE1E6';
var $881e75c45a88d9b7$export$8754fc7e6d8b3000 = '#C1C7D0';
var $881e75c45a88d9b7$export$c2e91cbeada39b8b = '#B3BAC5';
var $881e75c45a88d9b7$export$5f71e19f3a7ad9de = '#A5ADBA';
var $881e75c45a88d9b7$export$eaa8c8a70ac22806 = '#97A0AF';
var $881e75c45a88d9b7$export$7c87d337fb91a97d = '#8993A4';
var $881e75c45a88d9b7$export$d6447c357493214f = '#7A869A';
var $881e75c45a88d9b7$export$f563ee71e9ee74cd = '#6B778C';
var $881e75c45a88d9b7$export$e2ef2124cf4024b1 = '#5E6C84';
var $881e75c45a88d9b7$export$eece5f492e429f08 = '#505F79';
var $881e75c45a88d9b7$export$c39c0fe0f26207ae = '#42526E';
var $881e75c45a88d9b7$export$7090862dc3038a9f = '#344563';
var $881e75c45a88d9b7$export$ad0bacf983b7ddaa = '#253858';
var $881e75c45a88d9b7$export$7d61b15e0da132af = '#172B4D';
var $881e75c45a88d9b7$export$fbda843f0a27fe96 = '#091E42';
var $881e75c45a88d9b7$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
var $881e75c45a88d9b7$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
var $881e75c45a88d9b7$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
var $881e75c45a88d9b7$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
var $881e75c45a88d9b7$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
var $881e75c45a88d9b7$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
var $881e75c45a88d9b7$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
var $881e75c45a88d9b7$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
var $881e75c45a88d9b7$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
var $881e75c45a88d9b7$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
var $881e75c45a88d9b7$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
var $881e75c45a88d9b7$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
var $881e75c45a88d9b7$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
var $881e75c45a88d9b7$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
var $881e75c45a88d9b7$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
var $881e75c45a88d9b7$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
var $881e75c45a88d9b7$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
var $881e75c45a88d9b7$export$2f6319cf7d736c2a = '#E6EDFA';
var $881e75c45a88d9b7$export$95126bc8884d6634 = '#DCE5F5';
var $881e75c45a88d9b7$export$8338d8c35d44ff1 = '#CED9EB';
var $881e75c45a88d9b7$export$5368d76ae4fbbda7 = '#B8C7E0';
var $881e75c45a88d9b7$export$9f0a771d16ec8d36 = '#ABBBD6';
var $881e75c45a88d9b7$export$abcf8c38338b4aa5 = '#9FB0CC';
var $881e75c45a88d9b7$export$97e81faa16a182c7 = '#8C9CB8';
var $881e75c45a88d9b7$export$bfe21c59123ecf33 = '#7988A3';
var $881e75c45a88d9b7$export$ee82aa2ea6a1558 = '#67758F';
var $881e75c45a88d9b7$export$682927c6ed76be02 = '#56637A';
var $881e75c45a88d9b7$export$91fd9994c5be9757 = '#455166';
var $881e75c45a88d9b7$export$d281fbfe3cff2df6 = '#3B475C';
var $881e75c45a88d9b7$export$3902c91d8b98a753 = '#313D52';
var $881e75c45a88d9b7$export$8e8133c1ba5845b5 = '#283447';
var $881e75c45a88d9b7$export$33ff357f6620b39 = '#202B3D';
var $881e75c45a88d9b7$export$633847cf062b69e0 = '#1B2638';
var $881e75c45a88d9b7$export$9776a6e503bdbf76 = '#121A29';
var $881e75c45a88d9b7$export$6c813d5160dff5db = '#0E1624';
var $881e75c45a88d9b7$export$3d4f271a500072a = '#0D1424';
var $881e75c45a88d9b7$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
var $881e75c45a88d9b7$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
var $881e75c45a88d9b7$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
var $881e75c45a88d9b7$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
var $881e75c45a88d9b7$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
var $881e75c45a88d9b7$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
var $881e75c45a88d9b7$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
var $881e75c45a88d9b7$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
var $881e75c45a88d9b7$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
var $881e75c45a88d9b7$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
var $881e75c45a88d9b7$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
var $881e75c45a88d9b7$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
var $881e75c45a88d9b7$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
var $881e75c45a88d9b7$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
var $881e75c45a88d9b7$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
var $881e75c45a88d9b7$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
var $881e75c45a88d9b7$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';
var $881e75c45a88d9b7$export$d2adc5dedf09fced = '#292A2E';
var $881e75c45a88d9b7$export$f51762073d2bb381 = '#94C748';
var $881e75c45a88d9b7$export$95e26d54def96891 = '#B3DF72';


var $4e4d6f9c8d79362c$export$44ffba16bd48dac6 = '__ATLASKIT_THEME__';
var $4e4d6f9c8d79362c$export$c93026a968943f95 = 'light';
var $4e4d6f9c8d79362c$export$6ba72c8346b4c57e = [
    'light',
    'dark'
];
var $4e4d6f9c8d79362c$export$7a57f79000377ca2 = function borderRadius() {
    return 3;
};
var $4e4d6f9c8d79362c$export$6d8204c2cb2e06b8 = function gridSize() {
    return 8;
};
var $4e4d6f9c8d79362c$export$8e24544ddba725ee = function focusRing() {
    var color = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "var(--ds-border-focused, ".concat((0, $881e75c45a88d9b7$export$215b7063051591f1), ")");
    var outlineWidth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $4e4d6f9c8d79362c$export$6d8204c2cb2e06b8() / 4;
    (0, $b5d2e0354c69b158$export$2e2bcd8739ae039)('@atlaskit/theme', 'focus ring mixin', 'Please use `@atlaskit/focus-ring` instead.');
    return "\n  &:focus {\n    outline: none;\n    box-shadow: 0px 0px 0px ".concat(outlineWidth, "px ").concat(color, ";\n  }\n");
};
var $4e4d6f9c8d79362c$export$c0dd343266bc3261 = function noFocusRing() {
    return "\n  box-shadow: none;\n";
};
var $4e4d6f9c8d79362c$export$7be255094ccdc533 = {
    card: function card() {
        return 100;
    },
    navigation: function navigation() {
        return 200;
    },
    dialog: function dialog() {
        return 300;
    },
    layer: function layer() {
        return 400;
    },
    blanket: function blanket() {
        return 500;
    },
    modal: function modal() {
        return 510;
    },
    flag: function flag() {
        return 600;
    },
    spotlight: function spotlight() {
        return 700;
    },
    tooltip: function tooltip() {
        return 9999;
    }
};
var $4e4d6f9c8d79362c$export$a1b3edb637fb4f35 = function visuallyHidden() {
    (0, $b5d2e0354c69b158$export$2e2bcd8739ae039)('@atlaskit/theme', 'visually hidden mixin', 'Please use `@atlaskit/visually-hidden` instead.');
    return {
        border: '0 !important',
        clip: 'rect(1px, 1px, 1px, 1px) !important',
        height: '1px !important',
        overflow: 'hidden !important',
        padding: '0 !important',
        position: 'absolute !important',
        width: '1px !important',
        whiteSpace: 'nowrap !important'
    };
};
var $4e4d6f9c8d79362c$export$ba1d834b86d72a09 = $4e4d6f9c8d79362c$export$a1b3edb637fb4f35;
var $4e4d6f9c8d79362c$export$e497e856b4f89fcd = function skeletonShimmer() {
    return {
        css: {
            backgroundColor: "var(--ds-skeleton, ".concat((0, $881e75c45a88d9b7$export$8d43898f60b96a82), ")"),
            animationDuration: '1.5s',
            animationIterationCount: 'infinite',
            animationTimingFunction: 'linear',
            animationDirection: 'alternate'
        },
        keyframes: {
            from: {
                backgroundColor: "var(--ds-skeleton, ".concat((0, $881e75c45a88d9b7$export$8d43898f60b96a82), ")")
            },
            to: {
                backgroundColor: "var(--ds-skeleton-subtle, ".concat((0, $881e75c45a88d9b7$export$920c0d5c49070351), ")")
            }
        }
    };
};



var $kqp0i = parcelRequire("kqp0i");

var $iYJcE = parcelRequire("iYJcE");

var $ekGgq = parcelRequire("ekGgq");

var $25nEq = parcelRequire("25nEq");

var $5FkrB = parcelRequire("5FkrB");

var $74Zh5 = parcelRequire("74Zh5");
/**
 * Assigns the node to all the refs passed in the argument.
 *
 * @param refs: An array of refs (as function or ref object)
 */ function $515a728f55aede1c$export$2e2bcd8739ae039(refs) {
    // TODO: could this be wrapped in `useCallback` so we get a stable function?
    return function(value) {
        refs.forEach(function(ref) {
            if (typeof ref === 'function') ref(value);
            else if (ref !== null) ref.current = value;
        });
    };
}



var $5FkrB = parcelRequire("5FkrB");
function $12ca9acfdfc10757$export$2e2bcd8739ae039(ref, autoFocus) {
    var initialMount = (0, $5FkrB.useRef)(true);
    (0, $5FkrB.useEffect)(function() {
        if (ref && initialMount.current && autoFocus && ref.current) ref.current.focus();
        initialMount.current = false;
    }, [
        autoFocus,
        ref
    ]);
}



var $ekGgq = parcelRequire("ekGgq");

var $5FkrB = parcelRequire("5FkrB");

var $b5lkZ = parcelRequire("b5lkZ");

var $dU8Y3 = parcelRequire("dU8Y3");
var $e90663b74b3343bb$var$_React$useId;
// Type copied from https://github.com/thearnica/react-uid/blob/0f507fbbdb1ab84acf477ec32698afe3d2191e49/src/hooks.ts#L12
// Copied rather than inferred to make the type transparent
// @ts-ignore - useId is not accessible in React 16
var $e90663b74b3343bb$var$react18UseId = ($e90663b74b3343bb$var$_React$useId = (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).useId) !== null && $e90663b74b3343bb$var$_React$useId !== void 0 ? $e90663b74b3343bb$var$_React$useId : undefined;
function $e90663b74b3343bb$export$f680877a34711e37() {
    if ($e90663b74b3343bb$var$react18UseId && (0, $dU8Y3.fg)('platform-dst-react-18-use-id')) return $e90663b74b3343bb$var$react18UseId();
    return "uid".concat((0, $b5lkZ.useUID)());
}
var $e90663b74b3343bb$export$6be90bcb437e928f = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function(_ref, ref) {
    var children = _ref.children, _ref$postfix = _ref.postfix, postfix = _ref$postfix === void 0 ? '' : _ref$postfix, _ref$prefix = _ref.prefix, prefix = _ref$prefix === void 0 ? '' : _ref$prefix;
    var id = "".concat(prefix).concat($e90663b74b3343bb$export$f680877a34711e37()).concat(postfix);
    (0, $5FkrB.useEffect)(function() {
        if (!ref) return;
        switch((0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(ref)){
            case 'function':
                ref(id);
                break;
            case 'object':
                ref.current = id;
                break;
            default:
                throw new Error("Unreachable case for unsupported type of ref \"".concat((0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(ref), "\""));
        }
    }, [
        id,
        ref
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).Fragment, null, typeof children === 'function' ? children({
        id: id
    }) : children);
});
function $e90663b74b3343bb$export$6ee17796e3d70de2() {
    if ($e90663b74b3343bb$var$react18UseId && (0, $dU8Y3.fg)('platform-dst-react-18-use-id')) {
        var uid = $e90663b74b3343bb$var$react18UseId();
        return function(id) {
            return "".concat(uid, "-").concat(id.toString());
        };
    }
    return (0, $b5lkZ.useUIDSeed)();
}



var $eYQvF = parcelRequire("eYQvF");

var $25nEq = parcelRequire("25nEq");

var $5FkrB = parcelRequire("5FkrB");

var $7QpUe = parcelRequire("7QpUe");

var $dU8Y3 = parcelRequire("dU8Y3");

function $50ca8d9fc44121b9$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $50ca8d9fc44121b9$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $50ca8d9fc44121b9$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $50ca8d9fc44121b9$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $50ca8d9fc44121b9$var$ESCAPE = 'Escape';
function $50ca8d9fc44121b9$export$4a4bf067ea9e7886(_ref) {
    var onClose = _ref.onClose, isDisabled = _ref.isDisabled;
    var escapePressed = (0, $5FkrB.useRef)(false);
    var _useLayering = $50ca8d9fc44121b9$export$c8b4d54e03dee6ed(), isLayerDisabled = _useLayering.isLayerDisabled;
    var onKeyDown = (0, $5FkrB.useCallback)(function(e) {
        var isDisabledLayer = isLayerDisabled();
        if (isDisabled || escapePressed.current || e.key !== $50ca8d9fc44121b9$var$ESCAPE || isDisabledLayer) // We're either already handling the key down event or it's not escape or disabled.
        // Bail early!
        return;
        escapePressed.current = true;
        onClose(e);
    }, [
        onClose,
        isDisabled,
        isLayerDisabled
    ]);
    var onKeyUp = (0, $5FkrB.useCallback)(function() {
        escapePressed.current = false;
    }, []);
    (0, $5FkrB.useEffect)(function() {
        return (0, $7QpUe.bindAll)(window, [
            {
                type: 'keydown',
                listener: onKeyDown
            },
            {
                type: 'keyup',
                listener: onKeyUp
            }
        ], {
            capture: false
        });
    }, [
        onKeyDown,
        onKeyUp
    ]);
}
function $50ca8d9fc44121b9$export$c8b4d54e03dee6ed() {
    var currentLevel = (0, $5FkrB.useContext)((0, $43f1965ab31d9c6c$export$650d12d3c2ddb8fc));
    var _useContext = (0, $5FkrB.useContext)((0, $43f1965ab31d9c6c$export$48b383b280e20440)), topLevelRef = _useContext.topLevelRef, layerList = _useContext.layerList;
    var isLayerDisabled = (0, $5FkrB.useCallback)(function() {
        if ((0, $dU8Y3.fg)('layering-top-level-use-array')) {
            var _layerList$current$le, _layerList$current;
            return ((_layerList$current$le = layerList === null || layerList === void 0 || (_layerList$current = layerList.current) === null || _layerList$current === void 0 ? void 0 : _layerList$current.length) !== null && _layerList$current$le !== void 0 ? _layerList$current$le : 0) !== currentLevel;
        }
        return !!topLevelRef.current && currentLevel !== topLevelRef.current;
    }, [
        currentLevel,
        topLevelRef,
        layerList
    ]);
    return $50ca8d9fc44121b9$var$_objectSpread({
        currentLevel: currentLevel,
        topLevelRef: topLevelRef,
        isLayerDisabled: isLayerDisabled
    }, (0, $dU8Y3.fg)('layering-top-level-use-array') ? {
        layerList: layerList
    } : {});
}



parcelRequire("jkmxD");
var $fGFYU = parcelRequire("fGFYU");
/**
 * This is an object of usable media query helpers using our internal breakpoints configuration.
 *
 * When using Compiled CSS-in-JS, please ensure that only a single declaration can take effect at a time.
 * This means that you should avoid multiple breakpoints taking effect at the same time,
 * eg. ```{ [media.above.xs]: { color: 'red' }, [media.above.sm]: { color: 'green' }}```.
 * Instead, make sure that only one breakpoint can take effect at a time,
 * e.g, ```{ [media.only.xs]: { color: 'red' }, [media.above.sm]: { color: 'green' }}```.
 * For more details, please see <https://compiledcssinjs.com/docs/atomic-css#selector-specificity>.
 */ var $21b7e6b4b91231d5$export$987d49ffe1b0900f = {
    above: {
        xxs: '@media all',
        xs: '@media (min-width: 30rem)',
        sm: '@media (min-width: 48rem)',
        md: '@media (min-width: 64rem)',
        lg: '@media (min-width: 90rem)',
        xl: '@media (min-width: 110.5rem)'
    },
    only: {
        xxs: '@media (min-width: 0rem) and (max-width: 29.99rem)',
        xs: '@media (min-width: 30rem) and (max-width: 47.99rem)',
        sm: '@media (min-width: 48rem) and (max-width: 63.99rem)',
        md: '@media (min-width: 64rem) and (max-width: 89.99rem)',
        lg: '@media (min-width: 90rem) and (max-width: 110.49rem)',
        xl: '@media (min-width: 110.5rem)'
    },
    below: {
        xs: '@media not all and (min-width: 30rem)',
        sm: '@media not all and (min-width: 48rem)',
        md: '@media not all and (min-width: 64rem)',
        lg: '@media not all and (min-width: 90rem)',
        xl: '@media not all and (min-width: 110.5rem)'
    }
};
var $21b7e6b4b91231d5$export$c881183ca713c214 = $21b7e6b4b91231d5$export$987d49ffe1b0900f;



var $e7c942592165b6c5$export$4ef52930e33717cd = 'data-theme';
var $e7c942592165b6c5$export$a00eac3f8684bcd0 = 'data-color-mode';
var $e7c942592165b6c5$export$2112803007239c61 = 'data-contrast-mode';
var $e7c942592165b6c5$export$352e418ed5b6193a = 'data-custom-theme';
var $e7c942592165b6c5$export$6f0c6fb8c80fcc92 = 'ds';
var $e7c942592165b6c5$export$4d0c7bbf80185957 = [
    'opacity',
    'font',
    'space',
    'border'
];
var $e7c942592165b6c5$export$dddac1532e822863 = "--".concat($e7c942592165b6c5$export$6f0c6fb8c80fcc92, "-token-not-found");
var $e7c942592165b6c5$export$9d7b58831ae93caa = "--".concat($e7c942592165b6c5$export$6f0c6fb8c80fcc92, "-elevation-surface-current");



var $5FkrB = parcelRequire("5FkrB");
var $7168667b2edf2dff$export$ab57792b9b6974a6 = /*#__PURE__*/ (0, $5FkrB.createContext)(null);
var $7168667b2edf2dff$export$dece24112a937f92 = /*#__PURE__*/ (0, $5FkrB.createContext)(null);



var $5FkrB = parcelRequire("5FkrB");
function $b7efde3c54a58959$export$2e2bcd8739ae039(_ref) {
    var onOpenComplete = _ref.onOpenComplete, onCloseComplete = _ref.onCloseComplete;
    var motionRef = (0, $5FkrB.useRef)(null);
    var onMotionFinish = (0, $5FkrB.useCallback)(function(state) {
        if (state === 'entering' && onOpenComplete) onOpenComplete(motionRef.current, true);
        if (state === 'exiting' && onCloseComplete) onCloseComplete(motionRef.current);
    }, [
        onOpenComplete,
        onCloseComplete
    ]);
    return [
        motionRef,
        onMotionFinish
    ];
}



var $7QpUe = parcelRequire("7QpUe");
parcelRequire("jkmxD");
var $fGFYU = parcelRequire("fGFYU");
parcelRequire("5ldyY");
var $f8loy = parcelRequire("f8loy");

var $fC8ib = parcelRequire("fC8ib");
parcelRequire("jkmxD");
var $fGFYU = parcelRequire("fGFYU");
/**
 * Set a `style` property on a `HTMLElement`
 *
 * @returns a `cleanup` function to restore the `style` property to it's original state
 */ function $ca7ed9508127d4d2$var$setStyle(el, _ref) {
    var property = _ref.property, rule = _ref.rule, _ref$priority = _ref.priority, priority = _ref$priority === void 0 ? '' : _ref$priority;
    var originalValue = el.style.getPropertyValue(property);
    var originalPriority = el.style.getPropertyPriority(property);
    el.style.setProperty(property, rule, priority);
    return function cleanup() {
        el.style.setProperty(property, originalValue, originalPriority);
    };
}
function $ca7ed9508127d4d2$var$hasSameOrigin(href1, href2) {
    var url1;
    var url2;
    try {
        url1 = new URL(href1);
        url2 = new URL(href2);
    } catch (error) {
        // failed to parse a href
        return false;
    }
    // https://developer.mozilla.org/en-US/docs/Web/Security/Same-origin_policy
    return url1.protocol === url2.protocol && url1.host === url2.host && url1.port === url2.port;
}
function $ca7ed9508127d4d2$var$isIframeOnAnotherDomain(iframe) {
    /**
   * iframe with contents defined inline. Runs on the current origin.
   * `<iframe srcdoc="<!doctype html><body>Hello</body>" />`
   */ if (iframe.srcdoc) return false;
    /**
   * iframe with contents defined inline. Runs on the current origin.
   * `<iframe src={`data:text/html;charset=utf-8,${encodeURI('<!doctype html><body>Hello</body>')}`} />`
   */ if (iframe.src.startsWith('data:')) return false;
    return !$ca7ed9508127d4d2$var$hasSameOrigin(window.location.href, iframe.src);
}
var $ca7ed9508127d4d2$var$registry = new Map();
function $ca7ed9508127d4d2$var$applyFix(watchForEndOfInteraction) {
    var iframes = Array.from(document.querySelectorAll('iframe')).filter($ca7ed9508127d4d2$var$isIframeOnAnotherDomain);
    var cleanups = iframes.map(function(iframe) {
        var entry = $ca7ed9508127d4d2$var$registry.get(iframe);
        if (!entry) {
            entry = {
                reset: $ca7ed9508127d4d2$var$setStyle(iframe, {
                    property: 'pointer-events',
                    rule: 'none',
                    priority: 'important'
                }),
                count: 1
            };
            $ca7ed9508127d4d2$var$registry.set(iframe, entry);
        } else // pointer-events:none already applied to the iframe
        // increment how many things requested the fix
        entry.count++;
        return function cleanup() {
            entry.count--;
            if (entry.count < 1) {
                entry.reset();
                $ca7ed9508127d4d2$var$registry.delete(iframe);
            }
        };
    });
    function stop() {
        cleanupWatcher();
        (0, $fGFYU.combine).apply(void 0, (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(cleanups))();
    }
    var cleanupWatcher = watchForEndOfInteraction({
        stop: stop
    });
}
function $ca7ed9508127d4d2$export$a74bff2507e6126b(_ref2) {
    var watchForInteractionStart = _ref2.watchForInteractionStart, watchForInteractionEnd = _ref2.watchForInteractionEnd;
    var registrationCount = 0;
    var stopWatchingInteractionStart = null;
    function start() {
        $ca7ed9508127d4d2$var$applyFix(watchForInteractionEnd);
    }
    function registerUsage() {
        if (registrationCount === 0) stopWatchingInteractionStart = watchForInteractionStart({
            start: start
        });
        registrationCount++;
        return function unregisterUsage() {
            var _stopWatchingInteract;
            registrationCount--;
            if (registrationCount !== 0) return;
            (_stopWatchingInteract = stopWatchingInteractionStart) === null || _stopWatchingInteract === void 0 || _stopWatchingInteract();
            stopWatchingInteractionStart = null;
        };
    }
    return {
        registerUsage: registerUsage
    };
}


function $83969708bab70d34$var$watchForInteractionEnd(_ref) {
    var stop = _ref.stop;
    var isDragging = false;
    function stopIfNotDragging() {
        if (isDragging) return;
        stop();
    }
    var unbindEvents = (0, $7QpUe.bindAll)(window, [
        {
            // Another interaction is starting, this fix should be removed.
            type: 'pointerdown',
            listener: stop
        },
        {
            // The user did not start a drag
            type: 'pointerup',
            listener: stopIfNotDragging
        },
        {
            // if a "dragstart" occurs and the flag is not set,
            // then a drag has not started.
            // Note: could not use "pointercancel" as it is not
            // published in Safari
            // → https://bugs.webkit.org/show_bug.cgi?id=222632
            type: 'dragstart',
            listener: stopIfNotDragging,
            // Need to come after the element adapter
            options: {
                capture: false
            }
        }
    ], {
        // Listening in the capture phase to increase resilience
        // against events being stopped.
        capture: true,
        // Being super clear these should only run once
        once: true
    });
    var unbindMonitor = (0, $f8loy.monitorForElements)({
        onGenerateDragPreview: function onGenerateDragPreview() {
            isDragging = true;
        },
        onDrop: function onDrop() {
            isDragging = false;
            stop();
        }
    });
    return (0, $fGFYU.combine)(unbindEvents, unbindMonitor);
}
function $83969708bab70d34$var$watchForInteractionStart(_ref2) {
    var start = _ref2.start;
    return (0, $7QpUe.bind)(window, {
        // Note: Using "mousedown" rather than "pointerdown" due to a Safari bug.
        // Safari not publish a "pointerdown" on the interaction after a drag
        // → https://bugs.webkit.org/show_bug.cgi?id=279749
        type: 'mousedown',
        listener: function listener(event) {
            // Only starting if pressing down inside a draggable element
            // At this point, we are not sure which if:
            // 1. a text selection drag is starting
            // 2. a draggable managed by pdnd is going to be dragged
            // 3. a draggable not managed by pdnd is going to be dragged
            // 4. The user will be dragging anything at all (might be doing a click)
            if (event.target instanceof HTMLElement && event.target.closest('[draggable="true"]')) start();
        }
    });
}
var $83969708bab70d34$var$api = (0, $ca7ed9508127d4d2$export$a74bff2507e6126b)({
    watchForInteractionStart: $83969708bab70d34$var$watchForInteractionStart,
    watchForInteractionEnd: $83969708bab70d34$var$watchForInteractionEnd
});
function $83969708bab70d34$export$ec28e97c7d8b1b35() {
    return $83969708bab70d34$var$api.registerUsage();
}


parcelRequire("aPh0Z");
var $h6ZPT = parcelRequire("h6ZPT");

function $5f80798a6c74042d$var$watchForInteractionStart(_ref) {
    var start = _ref.start;
    return (0, $h6ZPT.monitorForExternal)({
        onDragStart: function onDragStart() {
            start();
        }
    });
}
function $5f80798a6c74042d$var$watchForInteractionEnd(_ref2) {
    var stop = _ref2.stop;
    return (0, $h6ZPT.monitorForExternal)({
        onDrop: function onDrop() {
            stop();
        }
    });
}
var $5f80798a6c74042d$var$api = (0, $ca7ed9508127d4d2$export$a74bff2507e6126b)({
    watchForInteractionStart: $5f80798a6c74042d$var$watchForInteractionStart,
    watchForInteractionEnd: $5f80798a6c74042d$var$watchForInteractionEnd
});
function $5f80798a6c74042d$export$27d79116d3a4e7d5() {
    return $5f80798a6c74042d$var$api.registerUsage();
}



var $7QpUe = parcelRequire("7QpUe");
parcelRequire("jkmxD");
var $fGFYU = parcelRequire("fGFYU");
parcelRequire("4p4mj");
var $5O7Kz = parcelRequire("5O7Kz");

function $6d69ce072be2e03a$var$watchForInteractionEnd(_ref) {
    var stop = _ref.stop;
    var isDragging = false;
    function stopIfNotDragging() {
        if (isDragging) return;
        stop();
    }
    var frameId = null;
    var unbindEvents = (0, $7QpUe.bindAll)(window, [
        {
            // User is starting another interaction
            type: 'pointerdown',
            listener: stop
        },
        {
            // User did not start a drag.
            // "pointerdown" won't be fired if a drag started
            type: 'pointerup',
            listener: stopIfNotDragging
        },
        {
            type: 'dragstart',
            listener: function listener() {
                /**
       * The pdnd `onDragStart()` fires in the frame after "dragstart"
       * So we are delaying our isDragging check to give a chance
       * for `onDragStart()` to set the value correctly.
       *
       * Note: could not use "pointercancel" as it is not
       * published in Safari → https://bugs.webkit.org/show_bug.cgi?id=222632
       */ frameId = requestAnimationFrame(function() {
                    frameId = null;
                    stopIfNotDragging();
                });
            },
            // need to schedule our frame after the text-selection
            // adapter queues it's `onDragStart` frame.
            options: {
                capture: false
            }
        }
    ], {
        // Listening in the capture phase to increase resilience
        // against events being stopped.
        capture: true,
        // being super clear these should only run once
        once: true
    });
    var unbindMonitor = (0, $5O7Kz.monitorForTextSelection)({
        onDragStart: function onDragStart() {
            isDragging = true;
        },
        onDrop: function onDrop() {
            isDragging = false;
            stop();
        }
    });
    return (0, $fGFYU.combine)(unbindEvents, unbindMonitor, function abortFrame() {
        if (frameId != null) cancelAnimationFrame(frameId);
    });
}
function $6d69ce072be2e03a$var$watchForInteractionStart(_ref2) {
    var start = _ref2.start;
    return (0, $7QpUe.bind)(window, {
        // Note: Using "mousedown" rather than "pointerdown" due to a Safari bug.
        // Safari not publish a "pointerdown" on the interaction after a drag
        // → https://bugs.webkit.org/show_bug.cgi?id=279749
        type: 'mousedown',
        listener: function listener() {
            // A text selection drag will only start when there is
            // an active text selection.
            var selection = window.getSelection();
            // No selection object found
            if (!selection) return;
            // `isCollapsed` is "true" if there is currently no selected text
            if (selection.isCollapsed) return;
            start();
        }
    });
}
var $6d69ce072be2e03a$var$api = (0, $ca7ed9508127d4d2$export$a74bff2507e6126b)({
    watchForInteractionStart: $6d69ce072be2e03a$var$watchForInteractionStart,
    watchForInteractionEnd: $6d69ce072be2e03a$var$watchForInteractionEnd
});
function $6d69ce072be2e03a$export$9c0606fcefb5d1e2() {
    return $6d69ce072be2e03a$var$api.registerUsage();
}


var $3e53a340f86f7a9c$export$7e3df82ee760448c = {
    values: [
        'small',
        'medium',
        'large',
        'x-large'
    ],
    widths: {
        small: 400,
        medium: 600,
        large: 800,
        'x-large': 968
    },
    defaultValue: 'medium'
};
var $3e53a340f86f7a9c$export$a3da89b899389ed8 = function dialogWidth(input) {
    if (!input) return 'auto';
    var isWidthName = $3e53a340f86f7a9c$export$7e3df82ee760448c.values.indexOf(input.toString()) !== -1;
    var widthName = isWidthName && input;
    if (widthName) return "".concat($3e53a340f86f7a9c$export$7e3df82ee760448c.widths[widthName], "px");
    return typeof input === 'number' ? "".concat(input, "px") : input;
};
var $3e53a340f86f7a9c$export$ceba93bf0bdd16f2 = function dialogHeight(input) {
    if (!input) return 'auto';
    return typeof input === 'number' ? "".concat(input, "px") : input;
};



var $25nEq = parcelRequire("25nEq");

var $74Zh5 = parcelRequire("74Zh5");
var $d88db13560bd0be3$export$c07234257a03d5e9 = 'cubic-bezier(0.15,1,0.3,1)';
var $d88db13560bd0be3$export$57636bb43b1ccbb0 = 'cubic-bezier(0.2,0,0,1)';
var $d88db13560bd0be3$export$929e5a82286172a6 = 'cubic-bezier(0.8,0,0,0.8)';
var $d88db13560bd0be3$export$fc825baa2ef870d0 = 'cubic-bezier(0.4,0,0,1)';
var $d88db13560bd0be3$export$816ee5d79b5bd9a5 = 'cubic-bezier(0.6,0,0,1)';
var $d88db13560bd0be3$export$53ce3390a1a8f2a2 = 'cubic-bezier(0.8,0,0,1)';
var $d88db13560bd0be3$export$45db2fc2f15997e7 = 'cubic-bezier(0,0,1,1)';





var $df7cf2c434291638$var$gutter = 60;
var $df7cf2c434291638$var$maxWidthDimensions = "calc(100vw - ".concat($df7cf2c434291638$var$gutter * 2, "px)");
var $df7cf2c434291638$var$maxHeightDimensions = "calc(100vh - ".concat($df7cf2c434291638$var$gutter * 2 - 1, "px)");
// Flex and min-content are set to constrain the height of the body and support multi-column scrolling experiences
var $df7cf2c434291638$var$positionerStyles = (0, $74Zh5.css)({
    display: 'flex',
    width: '100%',
    maxWidth: '100%',
    height: '100%',
    position: 'fixed',
    zIndex: (0, $4e4d6f9c8d79362c$export$7be255094ccdc533).modal(),
    flexDirection: 'column',
    insetBlockStart: 0,
    insetInlineStart: 0
});
var $df7cf2c434291638$var$viewportScrollStyles = (0, $74Zh5.css)((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({
    height: 'auto',
    position: 'relative'
}, (0, $21b7e6b4b91231d5$export$987d49ffe1b0900f).above.xs, {
    margin: "".concat($df7cf2c434291638$var$gutter, "px auto"),
    pointerEvents: 'none'
}));
var $df7cf2c434291638$var$bodyScrollStyles = (0, $74Zh5.css)((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, (0, $21b7e6b4b91231d5$export$987d49ffe1b0900f).above.xs, {
    maxWidth: $df7cf2c434291638$var$maxWidthDimensions,
    maxHeight: $df7cf2c434291638$var$maxHeightDimensions,
    position: 'absolute',
    insetBlockStart: "".concat($df7cf2c434291638$var$gutter, "px"),
    insetInlineEnd: 0,
    insetInlineStart: 0,
    marginInlineEnd: 'auto',
    marginInlineStart: 'auto',
    pointerEvents: 'none'
}));
var $df7cf2c434291638$var$stackTransitionStyles = (0, $74Zh5.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
    transitionDuration: "".concat((0, $3f46f842626a6ed4$export$38b928a7167ce124).medium, "ms"),
    transitionProperty: 'transform',
    transitionTimingFunction: (0, $d88db13560bd0be3$export$c07234257a03d5e9),
    /**
   * Duplicated from @atlaskit/motion/accessibility
   * because @repo/internal/styles/consistent-style-ordering
   * doesn't work well with object spreading.
   */ '@media (prefers-reduced-motion: reduce)': {
        animation: 'none',
        transition: 'none'
    }
});
var $df7cf2c434291638$var$stackTransformStyles = (0, $74Zh5.css)({
    transform: 'translateY(var(--modal-dialog-translate-y))'
});
var $df7cf2c434291638$var$stackIdleStyles = (0, $74Zh5.css)({
    transform: 'none'
});
var $df7cf2c434291638$var$Positioner = function Positioner(props) {
    var children = props.children, stackIndex = props.stackIndex, shouldScrollInViewport = props.shouldScrollInViewport, testId = props.testId;
    return (0, $74Zh5.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            '--modal-dialog-translate-y': "calc(".concat(stackIndex, "px * ", "var(--ds-space-100, 8px)", ")")
        },
        css: [
            $df7cf2c434291638$var$positionerStyles,
            $df7cf2c434291638$var$stackTransitionStyles,
            /* We only want to apply transform on modals shifting to the back of the stack. */ stackIndex > 0 ? $df7cf2c434291638$var$stackTransformStyles : $df7cf2c434291638$var$stackIdleStyles,
            shouldScrollInViewport ? $df7cf2c434291638$var$viewportScrollStyles : $df7cf2c434291638$var$bodyScrollStyles
        ],
        "data-testid": testId && "".concat(testId, "--positioner")
    }, children);
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$df7cf2c434291638$export$2e2bcd8739ae039 = $df7cf2c434291638$var$Positioner;


var $f73dacf51e76b762$var$dialogStyles = (0, $74Zh5.css)((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({
    display: 'flex',
    width: '100%',
    maxWidth: '100vw',
    height: '100%',
    minHeight: 0,
    maxHeight: '100vh',
    // Flex-grow set to 0 to prevent this element from filling its parent flexbox container
    flex: '0 1 auto',
    flexDirection: 'column',
    backgroundColor: "var(--ds-surface-overlay, ".concat((0, $881e75c45a88d9b7$export$29a4f05edc054374), ")"),
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    color: "var(--ds-text, ".concat((0, $881e75c45a88d9b7$export$fbda843f0a27fe96), ")")
}, (0, $e7c942592165b6c5$export$9d7b58831ae93caa), "var(--ds-surface-overlay, ".concat((0, $881e75c45a88d9b7$export$29a4f05edc054374), ")")), "pointerEvents", 'auto'), (0, $21b7e6b4b91231d5$export$987d49ffe1b0900f).above.xs, {
    width: 'var(--modal-dialog-width)',
    maxWidth: 'inherit',
    borderRadius: "var(--ds-border-radius, 3px)",
    boxShadow: "var(--ds-shadow-overlay, ".concat("0 0 0 1px ".concat((0, $881e75c45a88d9b7$export$920c0d5c49070351), ", 0 2px 1px ").concat((0, $881e75c45a88d9b7$export$920c0d5c49070351), ", 0 0 20px -6px ").concat((0, $881e75c45a88d9b7$export$d2d3bedfb276cac0)), ")"),
    marginInlineEnd: 'inherit',
    marginInlineStart: 'inherit'
}), '& > form:only-child', {
    display: 'inherit',
    maxHeight: 'inherit',
    flexDirection: 'inherit'
}));
var $f73dacf51e76b762$var$viewportScrollStyles = (0, $74Zh5.css)((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({
    /**
   * This ensures that the element fills the viewport on mobile
   * while also allowing it to overflow if its height is larger than
   * the viewport.
   */ minHeight: '100vh',
    maxHeight: 'none'
}, (0, $21b7e6b4b91231d5$export$987d49ffe1b0900f).above.xs, {
    minHeight: 'var(--modal-dialog-height)'
}));
var $f73dacf51e76b762$var$bodyScrollStyles = (0, $74Zh5.css)((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, (0, $21b7e6b4b91231d5$export$987d49ffe1b0900f).above.xs, {
    height: 'var(--modal-dialog-height)',
    maxHeight: 'inherit'
}));
var $f73dacf51e76b762$var$ModalDialog = function ModalDialog(props) {
    var _props$width = props.width, width = _props$width === void 0 ? 'medium' : _props$width, _props$shouldScrollIn = props.shouldScrollInViewport, shouldScrollInViewport = _props$shouldScrollIn === void 0 ? false : _props$shouldScrollIn, shouldCloseOnEscapePress = props.shouldCloseOnEscapePress, autoFocus = props.autoFocus, stackIndex = props.stackIndex, onClose = props.onClose, onCloseComplete = props.onCloseComplete, onOpenComplete = props.onOpenComplete, height = props.height, children = props.children, label = props.label, testId = props.testId;
    var id = (0, $e90663b74b3343bb$export$f680877a34711e37)();
    var titleId = "modal-dialog-title-".concat(id);
    (0, $5FkrB.useEffect)(function() {
        // Modal dialogs can appear on top of iframe elements that are on another domain.
        // There is a Chrome bug where drag and drop in an element on top of a cross domain
        // iframe is not working. We are applying the workaround for this bug in modal so
        // that consumers of our modal don't have to worry about this bug and are free to
        // create whatever drag and drop experience they like inside a modal
        //
        // Chrome bug: https://issues.chromium.org/issues/362301053
        return (0, $fGFYU.combine)((0, $83969708bab70d34$export$ec28e97c7d8b1b35)(), (0, $6d69ce072be2e03a$export$9c0606fcefb5d1e2)(), (0, $5f80798a6c74042d$export$27d79116d3a4e7d5)());
    }, []);
    (0, $12ca9acfdfc10757$export$2e2bcd8739ae039)((0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(autoFocus) === 'object' ? autoFocus : undefined, // When a user supplies  a ref to focus we enable this hook
    (0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(autoFocus) === 'object');
    var _useOnMotionFinish = (0, $b7efde3c54a58959$export$2e2bcd8739ae039)({
        onOpenComplete: onOpenComplete,
        onCloseComplete: onCloseComplete
    }), _useOnMotionFinish2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useOnMotionFinish, 2), motionRef = _useOnMotionFinish2[0], onMotionFinish = _useOnMotionFinish2[1];
    var modalDialogContext = (0, $5FkrB.useMemo)(function() {
        return {
            testId: testId,
            titleId: titleId,
            onClose: onClose
        };
    }, [
        testId,
        titleId,
        onClose
    ]);
    (0, $50ca8d9fc44121b9$export$4a4bf067ea9e7886)({
        onClose: onClose,
        isDisabled: !shouldCloseOnEscapePress
    });
    var _useLayering = (0, $50ca8d9fc44121b9$export$c8b4d54e03dee6ed)(), currentLevel = _useLayering.currentLevel;
    return (0, $74Zh5.jsx)((0, $df7cf2c434291638$export$2e2bcd8739ae039), {
        stackIndex: stackIndex,
        shouldScrollInViewport: shouldScrollInViewport,
        testId: testId
    }, (0, $74Zh5.jsx)((0, $7168667b2edf2dff$export$ab57792b9b6974a6).Provider, {
        value: modalDialogContext
    }, (0, $74Zh5.jsx)((0, $7168667b2edf2dff$export$dece24112a937f92).Provider, {
        value: shouldScrollInViewport
    }, (0, $74Zh5.jsx)((0, $c6ef6bab38bd84d5$export$2e2bcd8739ae039), {
        entranceDirection: "bottom",
        onFinish: onMotionFinish
    }, function(bottomFadeInProps) {
        return (0, $74Zh5.jsx)((0, $eYQvF.default), null, (0, $74Zh5.jsx)("section", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, bottomFadeInProps, {
            "aria-label": label,
            ref: (0, $515a728f55aede1c$export$2e2bcd8739ae039)([
                bottomFadeInProps.ref,
                motionRef
            ]),
            style: {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                '--modal-dialog-width': (0, $3e53a340f86f7a9c$export$a3da89b899389ed8)(width),
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                '--modal-dialog-height': (0, $3e53a340f86f7a9c$export$ceba93bf0bdd16f2)(height)
            },
            css: [
                $f73dacf51e76b762$var$dialogStyles,
                shouldScrollInViewport ? $f73dacf51e76b762$var$viewportScrollStyles : $f73dacf51e76b762$var$bodyScrollStyles
            ],
            role: "dialog",
            "aria-labelledby": label ? undefined : titleId,
            "data-testid": testId,
            "data-modal-stack": stackIndex,
            tabIndex: -1,
            "aria-modal": true,
            "data-ds--level": currentLevel
        }), children));
    }))));
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$f73dacf51e76b762$export$2e2bcd8739ae039 = $f73dacf51e76b762$var$ModalDialog;



var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");

var $5FkrB = parcelRequire("5FkrB");
var $864965a5b9e9a355$var$uniqueReferencedValue = {};
function $864965a5b9e9a355$export$2e2bcd8739ae039(initializer) {
    var ref = (0, $5FkrB.useRef)($864965a5b9e9a355$var$uniqueReferencedValue);
    if (ref.current === $864965a5b9e9a355$var$uniqueReferencedValue) ref.current = initializer();
    return ref;
}


function $877d61a231a715c1$export$2e2bcd8739ae039(callback) {
    var ref = (0, $864965a5b9e9a355$export$2e2bcd8739ae039)(function() {
        return callback;
    });
    return ref.current;
}



var $5FkrB = parcelRequire("5FkrB");
function $e2caa9fe43b5c14b$export$2e2bcd8739ae039(value) {
    var ref = (0, $5FkrB.useRef)();
    (0, $5FkrB.useEffect)(function() {
        ref.current = value;
    }, [
        value
    ]);
    return ref.current;
}



var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");
function $a8ffe3327e3b33eb$export$2e2bcd8739ae039(initialState) {
    var _useState = (0, $5FkrB.useState)(initialState), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), value = _useState2[0], setValue = _useState2[1];
    var valueRef = (0, $5FkrB.useRef)(value);
    valueRef.current = value;
    return [
        valueRef,
        setValue
    ];
}



/**
 *  ________________________________________________
 * | MAJOR VERSIONS WILL NOT KNOW ABOUT EACH OTHER! |
 *  ------------------------------------------------
 *
 * An array which holds references to all currently open modal dialogs.
 * This will only work for modal dialogs of the same major version,
 * as the reference will be different between them.
 *
 * E.g. V11 won't know about any from V12.
 */ var $d60d7d08f9026a79$var$modalStackRegister = [];
function $d60d7d08f9026a79$export$2e2bcd8739ae039(_ref) {
    var onStackChange = _ref.onStackChange;
    var _useExitingPersistenc = (0, $0fe6287c12490552$export$3b6f38abbdcbd000)(), isExiting = _useExitingPersistenc.isExiting;
    var _useStateRef = (0, $a8ffe3327e3b33eb$export$2e2bcd8739ae039)(0), _useStateRef2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useStateRef, 2), stackIndexRef = _useStateRef2[0], setStackIndex = _useStateRef2[1];
    var currentStackIndex = stackIndexRef.current;
    var previousStackIndex = (0, $e2caa9fe43b5c14b$export$2e2bcd8739ae039)(stackIndexRef.current);
    // We want to ensure this function **never changes** during the lifecycle of this component.
    // This is why it's assigned to a ref and not in a useMemo/useCallback.
    var updateStack = (0, $877d61a231a715c1$export$2e2bcd8739ae039)(function() {
        var newStackIndex = $d60d7d08f9026a79$var$modalStackRegister.indexOf(updateStack);
        // We access the stack index ref instead of state because this closure will always only
        // have the initial state and not any of the later values.
        if (stackIndexRef.current !== newStackIndex) {
            setStackIndex(newStackIndex);
            stackIndexRef.current = newStackIndex;
        }
    });
    (0, $5FkrB.useEffect)(function() {
        var currentStackIndex = $d60d7d08f9026a79$var$modalStackRegister.indexOf(updateStack);
        if (!isExiting && currentStackIndex === -1) // We are opening the modal dialog.
        // Add ourselves to the modal stack register!
        $d60d7d08f9026a79$var$modalStackRegister.unshift(updateStack);
        if (isExiting && currentStackIndex !== -1) // We are closing the modal dialog using a wrapping modal transition component.
        // Remove ourselves from the modal stack register!
        // NOTE: Modal dialogs that don't have a wrapping modal transition component won't flow through here!
        // For that scenario we cleanup when the component unmounts.
        $d60d7d08f9026a79$var$modalStackRegister.splice(currentStackIndex, 1);
        // Fire all registered modal dialogs to update their position in the stack.
        $d60d7d08f9026a79$var$modalStackRegister.forEach(function(cb) {
            return cb();
        });
    }, [
        updateStack,
        isExiting
    ]);
    (0, $5FkrB.useEffect)(function() {
        return function() {
            // Final cleanup just in case this modal dialog did not have a wrapping modal transition.
            var currentStackIndex = $d60d7d08f9026a79$var$modalStackRegister.indexOf(updateStack);
            if (currentStackIndex !== -1) {
                $d60d7d08f9026a79$var$modalStackRegister.splice(currentStackIndex, 1);
                $d60d7d08f9026a79$var$modalStackRegister.forEach(function(cb) {
                    return cb();
                });
            }
        };
    }, [
        updateStack
    ]);
    (0, $5FkrB.useEffect)(function() {
        if (previousStackIndex === undefined) // Initial case that we don't need to notify about.
        return;
        if (previousStackIndex !== currentStackIndex) onStackChange(currentStackIndex);
    }, [
        onStackChange,
        previousStackIndex,
        currentStackIndex
    ]);
    return currentStackIndex;
}



var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");

var $7QpUe = parcelRequire("7QpUe");
/**
 * Returns how far the body is scrolled from the top of the viewport.
 *
 *   ____
 * ||____|| <-- overflow
 *  |    |  <-- viewport
 *  |____|
 *
 * Scroll distance is the height of overflow outside the viewport.
 */ function $54fd0c2a27623d22$var$getScrollDistance() {
    var _document$documentEle, _document$body;
    return window.pageYOffset || ((_document$documentEle = document.documentElement) === null || _document$documentEle === void 0 ? void 0 : _document$documentEle.scrollTop) || ((_document$body = document.body) === null || _document$body === void 0 ? void 0 : _document$body.scrollTop) || 0;
}
function $54fd0c2a27623d22$export$2e2bcd8739ae039() {
    var _useState = (0, $5FkrB.useState)(0), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), scrollTopOffset = _useState2[0], setScrollTopOffset = _useState2[1];
    (0, $5FkrB.useLayoutEffect)(function() {
        setScrollTopOffset($54fd0c2a27623d22$var$getScrollDistance());
    }, []);
    var onWindowScroll = (0, $5FkrB.useCallback)(function() {
        if ($54fd0c2a27623d22$var$getScrollDistance() !== scrollTopOffset) window.scrollTo(window.pageXOffset, scrollTopOffset);
    }, [
        scrollTopOffset
    ]);
    (0, $5FkrB.useEffect)(function() {
        return (0, $7QpUe.bind)(window, {
            type: 'scroll',
            listener: onWindowScroll
        });
    }, [
        onWindowScroll
    ]);
    return scrollTopOffset;
}


var $73c4314b1cf0d4b0$var$fillScreenStyles = (0, $74Zh5.css)({
    width: '100vw',
    height: '100vh',
    position: 'fixed',
    insetBlockStart: "var(--ds-space-0, 0)",
    insetInlineStart: "var(--ds-space-0, 0)",
    overflowY: 'auto',
    WebkitOverflowScrolling: 'touch'
});
var $73c4314b1cf0d4b0$var$allowlistElements = function allowlistElements(element, callback) {
    var isAuiDialogAllowlisted = (0, $dU8Y3.fg)('platform_dst_allowlist-aui-dialog-for-ak-modal');
    // Allow focus to reach elements outside the modal:
    // if AUI dialog is allowListed and visible
    if (isAuiDialogAllowlisted && !!document.querySelector('.aui-blanket:not([hidden])')) return false;
    // allows to pass a callback function to allow elements be ignored by focus lock
    if (typeof callback === 'function') return callback(element);
    return true;
};
/**
 * __Modal wrapper__
 *
 * A modal wrapper displays content that requires user interaction, in a layer above the page.
 * This component is primary container for other modal components.
 *
 * - [Examples](https://atlassian.design/components/modal-dialog/examples)
 * - [Code](https://atlassian.design/components/modal-dialog/code)
 * - [Usage](https://atlassian.design/components/modal-dialog/usage)
 */ var $73c4314b1cf0d4b0$var$ModalWrapper = function ModalWrapper(props) {
    var _props$autoFocus = props.autoFocus, autoFocus = _props$autoFocus === void 0 ? true : _props$autoFocus, focusLockAllowlist = props.focusLockAllowlist, _props$shouldCloseOnE = props.shouldCloseOnEscapePress, shouldCloseOnEscapePress = _props$shouldCloseOnE === void 0 ? true : _props$shouldCloseOnE, _props$shouldCloseOnO = props.shouldCloseOnOverlayClick, shouldCloseOnOverlayClick = _props$shouldCloseOnO === void 0 ? true : _props$shouldCloseOnO, _props$shouldScrollIn = props.shouldScrollInViewport, shouldScrollInViewport = _props$shouldScrollIn === void 0 ? false : _props$shouldScrollIn, _props$shouldReturnFo = props.shouldReturnFocus, shouldReturnFocus = _props$shouldReturnFo === void 0 ? true : _props$shouldReturnFo, stackIndexOverride = props.stackIndex, _props$onClose = props.onClose, onClose = _props$onClose === void 0 ? (0, $da390e863547ad56$export$2e2bcd8739ae039) : _props$onClose, _props$onStackChange = props.onStackChange, onStackChange = _props$onStackChange === void 0 ? (0, $da390e863547ad56$export$2e2bcd8739ae039) : _props$onStackChange, isBlanketHidden = props.isBlanketHidden, children = props.children, height = props.height, width = props.width, onCloseComplete = props.onCloseComplete, onOpenComplete = props.onOpenComplete, label = props.label, testId = props.testId;
    var calculatedStackIndex = (0, $d60d7d08f9026a79$export$2e2bcd8739ae039)({
        onStackChange: onStackChange
    });
    var stackIndex = stackIndexOverride || calculatedStackIndex;
    var isForeground = stackIndex === 0;
    // When a user supplies a ref to focus we skip auto focus via react-focus-lock
    var autoFocusLock = typeof autoFocus === 'boolean' ? autoFocus : false;
    var onCloseHandler = (0, $e2c415d6ac5c0326$export$a4687b0234b40e28)({
        fn: onClose,
        action: 'closed',
        componentName: 'modalDialog',
        packageName: "@atlaskit/modal-dialog",
        packageVersion: "13.1.1"
    });
    var onBlanketClicked = (0, $5FkrB.useCallback)(function(e) {
        if (shouldCloseOnOverlayClick) onCloseHandler(e);
    }, [
        shouldCloseOnOverlayClick,
        onCloseHandler
    ]);
    // This ensures to prevent additional re-renders while nothing is passed to focusLockAllowlist explicitly.
    var allowListCallback = (0, $5FkrB.useCallback)(function(element) {
        return $73c4314b1cf0d4b0$var$allowlistElements(element, focusLockAllowlist);
    }, [
        focusLockAllowlist
    ]);
    (0, $54fd0c2a27623d22$export$2e2bcd8739ae039)();
    var modalDialogWithBlanket = (0, $74Zh5.jsx)((0, $1qBWl.default), {
        isTinted: !isBlanketHidden,
        onBlanketClicked: onBlanketClicked,
        testId: testId && "".concat(testId, "--blanket")
    }, (0, $74Zh5.jsx)((0, $f73dacf51e76b762$export$2e2bcd8739ae039), {
        testId: testId,
        label: label,
        autoFocus: autoFocus,
        stackIndex: stackIndex,
        onClose: onCloseHandler,
        shouldCloseOnEscapePress: shouldCloseOnEscapePress && isForeground,
        shouldScrollInViewport: shouldScrollInViewport,
        height: height,
        width: width,
        onCloseComplete: onCloseComplete,
        onOpenComplete: onOpenComplete
    }, children));
    var returnFocus = true;
    var onDeactivation;
    if ('boolean' === typeof shouldReturnFocus) returnFocus = shouldReturnFocus;
    else onDeactivation = function onDeactivation() {
        window.setTimeout(function() {
            var _shouldReturnFocus$cu;
            (_shouldReturnFocus$cu = shouldReturnFocus.current) === null || _shouldReturnFocus$cu === void 0 || _shouldReturnFocus$cu.focus();
        }, 0);
    };
    return (0, $74Zh5.jsx)((0, $43f1965ab31d9c6c$export$7c885f891c940977), {
        isDisabled: false
    }, (0, $74Zh5.jsx)((0, $062c34d20b8b2f54$export$2e2bcd8739ae039), {
        zIndex: (0, $4e4d6f9c8d79362c$export$7be255094ccdc533).modal()
    }, (0, $74Zh5.jsx)((0, $c6ef6bab38bd84d5$export$2e2bcd8739ae039), null, function(fadeInProps) {
        return (0, $74Zh5.jsx)("div", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, fadeInProps, {
            css: $73c4314b1cf0d4b0$var$fillScreenStyles,
            "aria-hidden": !isForeground
        }), (0, $74Zh5.jsx)((0, $69J3E.default), {
            autoFocus: autoFocusLock,
            returnFocus: returnFocus,
            onDeactivation: onDeactivation,
            whiteList: allowListCallback
        }, (0, $74Zh5.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3FlkA))), null), shouldScrollInViewport ? (0, $74Zh5.jsx)((0, $3FlkA.TouchScrollable), null, modalDialogWithBlanket) : modalDialogWithBlanket));
    })));
};
var $73c4314b1cf0d4b0$export$2e2bcd8739ae039 = $73c4314b1cf0d4b0$var$ModalWrapper;

/**
 * @jsxRuntime classic
 * @jsx jsx
 */ parcelRequire("5FkrB");

var $74Zh5 = parcelRequire("74Zh5");

var $3FlkA = parcelRequire("3FlkA");

var $5FkrB = parcelRequire("5FkrB");

var $bce5b57c6ca393c3$export$33ffd74ebf07f060 = function useModal() {
    var modalContext = (0, $5FkrB.useContext)((0, $7168667b2edf2dff$export$ab57792b9b6974a6));
    if (modalContext == null) throw Error("@atlaskit/modal-dialog: Modal context unavailable \u2013 this component needs to be a child of ModalDialog.");
    return modalContext;
};



var $iYJcE = parcelRequire("iYJcE");

var $25nEq = parcelRequire("25nEq");

var $5FkrB = parcelRequire("5FkrB");

var $74Zh5 = parcelRequire("74Zh5");

var $7QpUe = parcelRequire("7QpUe");

var $45Zis = parcelRequire("45Zis");




var $eYQvF = parcelRequire("eYQvF");


var $cd3675e8dd132216$var$keylineColor = "var(--ds-border, ".concat((0, $881e75c45a88d9b7$export$3e51e8f1440314ba), ")");
var $cd3675e8dd132216$var$baseStyles = (0, $74Zh5.css)((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({
    display: 'inherit',
    margin: "var(--ds-space-0, 0px)",
    flex: 'inherit',
    flexDirection: 'inherit',
    flexGrow: 1,
    overflowX: 'hidden',
    overflowY: 'auto'
}, (0, $21b7e6b4b91231d5$export$987d49ffe1b0900f).above.xs, {
    height: 'unset',
    overflowY: 'auto'
}));
var $cd3675e8dd132216$var$keylineHeight = 2;
var $cd3675e8dd132216$var$topKeylineStyles = (0, $74Zh5.css)({
    borderBlockStart: "var(--ds-border-width-outline, 2px)".concat(" solid ", $cd3675e8dd132216$var$keylineColor)
});
var $cd3675e8dd132216$var$bottomKeylineStyles = (0, $74Zh5.css)({
    borderBlockEnd: "var(--ds-border-width-outline, 2px)".concat(" solid ", $cd3675e8dd132216$var$keylineColor)
});
/**
 * A container that shows top and bottom keylines when the
 * content overflows into the scrollable element.
 */ var $cd3675e8dd132216$var$ScrollContainer = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function(_ref, ref) {
    var testId = _ref.testId, children = _ref.children;
    var scrollableRef = (0, $5FkrB.useRef)(null);
    var _useState = (0, $5FkrB.useState)(false), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), showTopKeyline = _useState2[0], setTopKeyline = _useState2[1];
    var _useState3 = (0, $5FkrB.useState)(false), _useState4 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState3, 2), showBottomKeyline = _useState4[0], setBottomKeyline = _useState4[1];
    var _useState5 = (0, $5FkrB.useState)(false), _useState6 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState5, 2), showContentFocus = _useState6[0], setContentFocus = _useState6[1];
    // Schedule a content focus on the target element
    // WARNING: In theory, `target` may not be available when `rafSchedule` hits in concurrent rendering
    (0, $5FkrB.useEffect)(function() {
        var schedule = (0, $45Zis.default)(function() {
            var target = scrollableRef.current;
            target && setContentFocus(target.scrollHeight > target.clientHeight);
        });
        schedule();
    }, [
        scrollableRef
    ]);
    var setLazyKeylines = (0, $877d61a231a715c1$export$2e2bcd8739ae039)((0, $45Zis.default)(function() {
        var target = scrollableRef.current;
        if (target) {
            var scrollableDistance = target.scrollHeight - target.clientHeight;
            if (target.previousElementSibling) setTopKeyline(target.scrollTop > $cd3675e8dd132216$var$keylineHeight);
            if (target.nextElementSibling) setBottomKeyline(target.scrollTop <= scrollableDistance - $cd3675e8dd132216$var$keylineHeight);
        }
    }));
    // On load (and scroll/resize events), we set "keylines"
    // these border the content to indicate scrollability when content underflows the header or footer
    (0, $5FkrB.useEffect)(function() {
        var target = scrollableRef.current;
        setLazyKeylines();
        var unbindWindowEvent = (0, $7QpUe.bind)(window, {
            type: 'resize',
            listener: setLazyKeylines
        });
        var unbindTargetEvent = target ? (0, $7QpUe.bind)(target, {
            type: 'scroll',
            listener: setLazyKeylines
        }) : (0, $da390e863547ad56$export$2e2bcd8739ae039);
        return function() {
            unbindWindowEvent();
            unbindTargetEvent();
        };
    }, [
        setLazyKeylines
    ]);
    return (0, $74Zh5.jsx)((0, $eYQvF.default), {
        isInset: true
    }, (0, $74Zh5.jsx)("div", {
        // tabindex is allowed here so that keyboard users can scroll content
        // eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex
        tabIndex: showContentFocus ? 0 : undefined,
        role: showContentFocus ? 'region' : undefined,
        "aria-label": showContentFocus ? 'Scrollable content' : undefined,
        "data-testid": testId && "".concat(testId, "--scrollable"),
        ref: (0, $515a728f55aede1c$export$2e2bcd8739ae039)([
            ref,
            scrollableRef
        ]),
        css: [
            $cd3675e8dd132216$var$baseStyles,
            showTopKeyline && $cd3675e8dd132216$var$topKeylineStyles,
            showBottomKeyline && $cd3675e8dd132216$var$bottomKeylineStyles
        ]
    }, children));
});
$cd3675e8dd132216$var$ScrollContainer.displayName = 'ScrollContainer';
var $cd3675e8dd132216$export$2e2bcd8739ae039 = $cd3675e8dd132216$var$ScrollContainer;



var $5FkrB = parcelRequire("5FkrB");

function $6b0ee122ced171d4$export$2e2bcd8739ae039() {
    var shouldScrollInViewport = (0, $5FkrB.useContext)((0, $7168667b2edf2dff$export$dece24112a937f92));
    if (shouldScrollInViewport == null) throw Error("@atlaskit/modal-dialog: Scroll context unavailable \u2013 this component needs to be a child of ModalDialog.");
    return shouldScrollInViewport;
}


var $883c6fe3d36b669f$var$bodyStyles = (0, $74Zh5.css)({
    /* This ensures the body fills the whole space between header and footer. */ flex: '1 1 auto'
});
/**
 * Adding the padding here avoids cropping the keyline on its sides.
 * The combined vertical spacing is maintained by subtracting the
 * keyline height from header and footer using negative margins.
 */ var $883c6fe3d36b669f$var$bodyScrollStyles = (0, $74Zh5.css)({
    paddingBlock: "var(--ds-border-width-outline, 2px)",
    paddingInline: "var(--ds-space-300, 24px)"
});
/**
 * Keylines will not be shown if scrolling in viewport so we do
 * not account for them in this case.
 */ var $883c6fe3d36b669f$var$viewportScrollStyles = (0, $74Zh5.css)({
    paddingInline: "var(--ds-space-300, 24px)"
});
/**
 * __Modal body__
 *
 * A modal body is used to display the main content of a modal.
 *
 * - [Examples](https://atlassian.design/components/modal-dialog/examples)
 * - [Code](https://atlassian.design/components/modal-dialog/code#modal-body-props)
 * - [Usage](https://atlassian.design/components/modal-dialog/usage)
 */ var $883c6fe3d36b669f$var$ModalBody = function ModalBody(props) {
    var children = props.children, userDefinedTestId = props.testId;
    var _useModal = (0, $bce5b57c6ca393c3$export$33ffd74ebf07f060)(), modalTestId = _useModal.testId;
    var shouldScrollInViewport = (0, $6b0ee122ced171d4$export$2e2bcd8739ae039)();
    var testId = userDefinedTestId || modalTestId && "".concat(modalTestId, "--body");
    return shouldScrollInViewport ? (0, $74Zh5.jsx)("div", {
        css: [
            $883c6fe3d36b669f$var$bodyStyles,
            $883c6fe3d36b669f$var$viewportScrollStyles
        ],
        "data-testid": testId
    }, children) : (0, $74Zh5.jsx)((0, $3FlkA.TouchScrollable), null, (0, $74Zh5.jsx)((0, $cd3675e8dd132216$export$2e2bcd8739ae039), {
        testId: userDefinedTestId || modalTestId
    }, (0, $74Zh5.jsx)("div", {
        css: [
            $883c6fe3d36b669f$var$bodyStyles,
            $883c6fe3d36b669f$var$bodyScrollStyles
        ],
        "data-testid": testId
    }, children)));
};
var $883c6fe3d36b669f$export$2e2bcd8739ae039 = $883c6fe3d36b669f$var$ModalBody;

/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $74Zh5 = parcelRequire("74Zh5");

var $812d3a996ab3db86$var$footerStyles = (0, $74Zh5.css)({
    display: 'flex',
    position: 'relative',
    alignItems: 'center',
    justifyContent: 'flex-end',
    gap: "var(--ds-space-100, 8px)",
    marginBlockStart: "calc(-1 * ".concat("var(--ds-border-width-outline, 2px)", ")"),
    paddingBlockEnd: "var(--ds-space-300, 24px)",
    paddingBlockStart: "var(--ds-space-200, 16px)",
    paddingInline: "var(--ds-space-300, 24px)"
});
/**
 * __Modal footer__
 *
 * A modal footer often contains a primary action and the ability to cancel and close the dialog, though can contain any React element.
 *
 * - [Examples](https://atlassian.design/components/modal-dialog/examples#modal-footer)
 * - [Code](https://atlassian.design/components/modal-dialog/code#modal-footer-props)
 * - [Usage](https://atlassian.design/components/modal-dialog/usage)
 */ var $812d3a996ab3db86$var$ModalFooter = function ModalFooter(props) {
    var children = props.children, userDefinedTestId = props.testId;
    var _useModal = (0, $bce5b57c6ca393c3$export$33ffd74ebf07f060)(), modalTestId = _useModal.testId;
    var testId = userDefinedTestId || modalTestId && "".concat(modalTestId, "--footer");
    return (0, $74Zh5.jsx)("div", {
        css: $812d3a996ab3db86$var$footerStyles,
        "data-testid": testId
    }, children);
};
var $812d3a996ab3db86$export$2e2bcd8739ae039 = $812d3a996ab3db86$var$ModalFooter;

/**
 * @jsxRuntime classic
 * @jsx jsx
 */ parcelRequire("5FkrB");

var $74Zh5 = parcelRequire("74Zh5");

var $e63db9e78b9f7f9d$var$headerStyles = (0, $74Zh5.css)({
    display: 'flex',
    position: 'relative',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBlockEnd: "calc(-1 * ".concat("var(--ds-border-width-outline, 2px)", ")"),
    paddingBlockEnd: "var(--ds-space-200, 16px)",
    paddingBlockStart: "var(--ds-space-300, 24px)",
    paddingInline: "var(--ds-space-300, 24px)"
});
/**
 * __Modal header__
 *
 * A modal header contains the title of the modal and can contain other React elements such as a close button.
 *
 * - [Examples](https://atlassian.design/components/modal-dialog/examples#modal-header)
 * - [Code](https://atlassian.design/components/modal-dialog/code#modal-header-props)
 * - [Usage](https://atlassian.design/components/modal-dialog/usage)
 */ var $e63db9e78b9f7f9d$var$ModalHeader = function ModalHeader(props) {
    var children = props.children, userDefinedTestId = props.testId;
    var _useModal = (0, $bce5b57c6ca393c3$export$33ffd74ebf07f060)(), modalTestId = _useModal.testId;
    var testId = userDefinedTestId || modalTestId && "".concat(modalTestId, "--header");
    return (0, $74Zh5.jsx)("div", {
        css: $e63db9e78b9f7f9d$var$headerStyles,
        "data-testid": testId
    }, children);
};
var $e63db9e78b9f7f9d$export$2e2bcd8739ae039 = $e63db9e78b9f7f9d$var$ModalHeader;


var $5FkrB = parcelRequire("5FkrB");

/**
 * __Modal transition__
 *
 * A modal transition wraps a modal to provide a fluid transition upon opening and closing.
 *
 * - [Examples](https://atlassian.design/components/modal-dialog/examples)
 * - [Code](https://atlassian.design/components/modal-dialog/code)
 * - [Usage](https://atlassian.design/components/modal-dialog/usage)
 */ var $58963c306889e449$var$ModalTransition = function ModalTransition(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $0fe6287c12490552$export$2e2bcd8739ae039), {
        appear: true
    }, props.children);
};
var $58963c306889e449$export$2e2bcd8739ae039 = $58963c306889e449$var$ModalTransition;



var $7KfP5 = parcelRequire("7KfP5");

var $kqp0i = parcelRequire("kqp0i");

var $25nEq = parcelRequire("25nEq");

var $1Vcia = parcelRequire("1Vcia");

var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");

var $7QpUe = parcelRequire("7QpUe");

var $kqp0i = parcelRequire("kqp0i");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");

var $kqp0i = parcelRequire("kqp0i");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");

var $74Zh5 = parcelRequire("74Zh5");

var $25nEq = parcelRequire("25nEq");

var $5FkrB = parcelRequire("5FkrB");

var $dLGML = parcelRequire("dLGML");

var $fC8ib = parcelRequire("fC8ib");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $kIXpt = parcelRequire("kIXpt");

var $cYPzS = parcelRequire("cYPzS");

var $lwlXp = parcelRequire("lwlXp");

var $eyuDe = parcelRequire("eyuDe");

var $25nEq = parcelRequire("25nEq");

var $ekGgq = parcelRequire("ekGgq");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $25nEq = parcelRequire("25nEq");
function $5d12b81cf835d0fa$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $5d12b81cf835d0fa$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $5d12b81cf835d0fa$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $5d12b81cf835d0fa$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $5d12b81cf835d0fa$export$ad4be5c2ec28cecf = function isAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $5d12b81cf835d0fa$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === 'AnalyticsEvent';
};
var $5d12b81cf835d0fa$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function AnalyticsEvent(props) {
        var _this = this;
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, AnalyticsEvent);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "_isAnalyticsEvent", true);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "clone", function() {
            // just a shallow clone, don't change sub refs unless you want to
            // affect the original's too
            var payload = $5d12b81cf835d0fa$var$_objectSpread({}, _this.payload);
            return new AnalyticsEvent({
                payload: payload
            });
        });
        this.payload = props.payload;
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(AnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (typeof updater === 'function') this.payload = updater(this.payload);
                if ((0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(updater) === 'object') this.payload = $5d12b81cf835d0fa$var$_objectSpread($5d12b81cf835d0fa$var$_objectSpread({}, this.payload), updater);
                return this;
            }
        }
    ]);
}();


function $5a5f42fc4617c35b$var$_callSuper(t, o, e) {
    return o = (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(o), (0, (/*@__PURE__*/$parcel$interopDefault($kIXpt)))(t, $5a5f42fc4617c35b$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(t).constructor) : o.apply(t, e));
}
function $5a5f42fc4617c35b$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($5a5f42fc4617c35b$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $5a5f42fc4617c35b$var$_superPropGet(t, o, e, r) {
    var p = (0, (/*@__PURE__*/$parcel$interopDefault($lwlXp)))((0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(1 & r ? t.prototype : t), o, e);
    return 2 & r && "function" == typeof p ? function(t) {
        return p.apply(e, t);
    } : p;
}
var $5a5f42fc4617c35b$export$35f8383928ba8d7 = function isUIAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $5a5f42fc4617c35b$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isUIAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === 'UIAnalyticsEvent';
};
var $5a5f42fc4617c35b$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_AnalyticsEvent) {
    function UIAnalyticsEvent(props) {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, UIAnalyticsEvent);
        _this = $5a5f42fc4617c35b$var$_callSuper(this, UIAnalyticsEvent, [
            props
        ]);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "_isUIAnalyticsEvent", true);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "clone", function() {
            if (_this.hasFired) return null;
            var context = (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(_this.context);
            var handlers = (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(_this.handlers);
            /**
       * A hacky "deep clone" of the object. This is limited in that it wont
       * support functions, regexs, Maps, Sets, etc, but none of those need to
       * be represented in our payload.
       */ var payload = JSON.parse(JSON.stringify(_this.payload));
            return new UIAnalyticsEvent({
                context: context,
                handlers: handlers,
                payload: payload
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "fire", function(channel) {
            if (_this.hasFired) return;
            _this.handlers.forEach(function(handler) {
                return handler(_this, channel);
            });
            _this.hasFired = true;
        });
        _this.context = props.context || [];
        _this.handlers = props.handlers || [];
        _this.hasFired = false;
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($eyuDe)))(UIAnalyticsEvent, _AnalyticsEvent);
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(UIAnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (this.hasFired) return this;
                return $5a5f42fc4617c35b$var$_superPropGet(UIAnalyticsEvent, "update", this, 3)([
                    updater
                ]);
            }
        }
    ]);
}((0, $5d12b81cf835d0fa$export$2e2bcd8739ae039));



var $5FkrB = parcelRequire("5FkrB");

var $iyyOp = parcelRequire("iyyOp");
var $726ef29a554b591d$export$d1f587f82ad51c4 = function useAnalyticsContext() {
    return (0, $5FkrB.useContext)((0, $iyyOp.default));
};


function $6d9e5de0c2a6279b$export$5bf35293e545f20c() {
    var analyticsContext = (0, $726ef29a554b591d$export$d1f587f82ad51c4)();
    var createAnalyticsEvent = (0, $dLGML.useCallbackOne)(function(payload) {
        return new (0, $5a5f42fc4617c35b$export$2e2bcd8739ae039)({
            context: analyticsContext.getAtlaskitAnalyticsContext(),
            handlers: analyticsContext.getAtlaskitAnalyticsEventHandlers(),
            payload: payload
        });
    }, [
        analyticsContext
    ]);
    return {
        createAnalyticsEvent: createAnalyticsEvent
    };
}



var $5FkrB = parcelRequire("5FkrB");
var $73f6b1d7f567637f$export$1d27a74659855e44 = function useTrackedRef(value) {
    var ref = (0, $5FkrB.useRef)(value);
    ref.current = value;
    return ref;
};


function $8fb7a896bc43fd0a$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $8fb7a896bc43fd0a$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $8fb7a896bc43fd0a$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $8fb7a896bc43fd0a$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $8fb7a896bc43fd0a$export$a4687b0234b40e28(_ref) {
    var fn = _ref.fn, action = _ref.action, componentName = _ref.componentName, actionSubject = _ref.actionSubject, packageName = _ref.packageName, packageVersion = _ref.packageVersion, analyticsData = _ref.analyticsData;
    var _useAnalyticsEvents = (0, $6d9e5de0c2a6279b$export$5bf35293e545f20c)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
    // We put analyticsData and fn in a ref so that we don't need to break
    // memoization.
    // Generally these could be defined by consumers inline
    // and so we do this to avoid breaking memoization of useCallback
    var dataRef = (0, $73f6b1d7f567637f$export$1d27a74659855e44)(analyticsData);
    var fnRef = (0, $73f6b1d7f567637f$export$1d27a74659855e44)(fn);
    var handler = (0, $5FkrB.useCallback)(function(value) {
        var analyticsEvent = createAnalyticsEvent({
            action: action,
            actionSubject: actionSubject || componentName,
            attributes: {
                componentName: componentName,
                packageName: packageName,
                packageVersion: packageVersion
            }
        });
        // To avoid wrapping this component in AnalyticsContext we manually
        // push the parent context's meta data into the context.
        // Note: this new 'context'
        var context = $8fb7a896bc43fd0a$var$_objectSpread({
            componentName: componentName,
            packageName: packageName,
            packageVersion: packageVersion
        }, dataRef.current);
        analyticsEvent.context.push(context);
        // fire an event on the atlaskit channel
        var clone = analyticsEvent.clone();
        if (clone) clone.fire('atlaskit');
        fnRef.current(value, analyticsEvent);
    }, [
        // These are strings and won't change
        action,
        componentName,
        actionSubject,
        packageName,
        packageVersion,
        // This function is memoized in the context
        createAnalyticsEvent,
        // these are a stable ref because of the useTrackedRef hook
        dataRef,
        fnRef
    ]);
    return handler;
}


/**
 * An empty function which does nothing.
 */ // eslint-disable-next-line @repo/internal/react/use-noop
function $3a341012e037de4f$export$2e2bcd8739ae039() {}



var $5FkrB = parcelRequire("5FkrB");
var $6aca23134cc0dc0c$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $5FkrB.createContext)(null);



var $25nEq = parcelRequire("25nEq");

var $74Zh5 = parcelRequire("74Zh5");
var $dfb11b85b532f292$export$4ef52930e33717cd = 'data-theme';
var $dfb11b85b532f292$export$a00eac3f8684bcd0 = 'data-color-mode';
var $dfb11b85b532f292$export$2112803007239c61 = 'data-contrast-mode';
var $dfb11b85b532f292$export$352e418ed5b6193a = 'data-custom-theme';
var $dfb11b85b532f292$export$2faeed762aac6741 = 'light';
var $dfb11b85b532f292$export$6f0c6fb8c80fcc92 = 'ds';
var $dfb11b85b532f292$export$4d0c7bbf80185957 = [
    'opacity',
    'font',
    'space',
    'border'
];
var $dfb11b85b532f292$export$dddac1532e822863 = "--".concat($dfb11b85b532f292$export$6f0c6fb8c80fcc92, "-token-not-found");
var $dfb11b85b532f292$export$9d7b58831ae93caa = "--".concat($dfb11b85b532f292$export$6f0c6fb8c80fcc92, "-elevation-surface-current");


function $1d749ea5cf4f6b0d$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $1d749ea5cf4f6b0d$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $1d749ea5cf4f6b0d$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $1d749ea5cf4f6b0d$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $1d749ea5cf4f6b0d$export$6ccdbebca2ee545f = {
    '100%': '100%',
    'size.100': '1rem',
    'size.200': '1.5rem',
    'size.300': '2rem',
    'size.400': '2.5rem',
    'size.500': '3rem',
    'size.600': '6rem',
    'size.1000': '12rem'
};
var $1d749ea5cf4f6b0d$export$958d0ae7f2977ae4 = {
    'space.0': "var(--ds-space-0, 0px)",
    'space.025': "var(--ds-space-025, 2px)",
    'space.050': "var(--ds-space-050, 4px)",
    'space.075': "var(--ds-space-075, 6px)",
    'space.100': "var(--ds-space-100, 8px)",
    'space.150': "var(--ds-space-150, 12px)",
    'space.200': "var(--ds-space-200, 16px)",
    'space.250': "var(--ds-space-250, 20px)",
    'space.300': "var(--ds-space-300, 24px)",
    'space.400': "var(--ds-space-400, 32px)",
    'space.500': "var(--ds-space-500, 40px)",
    'space.600': "var(--ds-space-600, 48px)",
    'space.800': "var(--ds-space-800, 64px)",
    'space.1000': "var(--ds-space-1000, 80px)"
};
var $1d749ea5cf4f6b0d$export$d2dc61f58390201c = {
    'space.negative.025': "var(--ds-space-negative-025, -2px)",
    'space.negative.050': "var(--ds-space-negative-050, -4px)",
    'space.negative.075': "var(--ds-space-negative-075, -6px)",
    'space.negative.100': "var(--ds-space-negative-100, -8px)",
    'space.negative.150': "var(--ds-space-negative-150, -12px)",
    'space.negative.200': "var(--ds-space-negative-200, -16px)",
    'space.negative.250': "var(--ds-space-negative-250, -20px)",
    'space.negative.300': "var(--ds-space-negative-300, -24px)",
    'space.negative.400': "var(--ds-space-negative-400, -32px)"
};
var $1d749ea5cf4f6b0d$export$632685d741f3dbbf = $1d749ea5cf4f6b0d$var$_objectSpread($1d749ea5cf4f6b0d$var$_objectSpread({}, $1d749ea5cf4f6b0d$export$958d0ae7f2977ae4), $1d749ea5cf4f6b0d$export$d2dc61f58390201c);
var $1d749ea5cf4f6b0d$export$2185ce37f9bdd963 = {
    'color.background.neutral.bold': 'color.text.inverse',
    'color.background.neutral.bold.hovered': 'color.text.inverse',
    'color.background.neutral.bold.pressed': 'color.text.inverse',
    'color.background.selected.bold': 'color.text.inverse',
    'color.background.selected.bold.hovered': 'color.text.inverse',
    'color.background.selected.bold.pressed': 'color.text.inverse',
    'color.background.brand.bold': 'color.text.inverse',
    'color.background.brand.bold.hovered': 'color.text.inverse',
    'color.background.brand.bold.pressed': 'color.text.inverse',
    'color.background.brand.boldest': 'color.text.inverse',
    'color.background.brand.boldest.hovered': 'color.text.inverse',
    'color.background.brand.boldest.pressed': 'color.text.inverse',
    'color.background.danger.bold': 'color.text.inverse',
    'color.background.danger.bold.hovered': 'color.text.inverse',
    'color.background.danger.bold.pressed': 'color.text.inverse',
    'color.background.warning.bold': 'color.text.warning.inverse',
    'color.background.warning.bold.hovered': 'color.text.warning.inverse',
    'color.background.warning.bold.pressed': 'color.text.warning.inverse',
    'color.background.success.bold': 'color.text.inverse',
    'color.background.success.bold.hovered': 'color.text.inverse',
    'color.background.success.bold.pressed': 'color.text.inverse',
    'color.background.discovery.bold': 'color.text.inverse',
    'color.background.discovery.bold.hovered': 'color.text.inverse',
    'color.background.discovery.bold.pressed': 'color.text.inverse',
    'color.background.information.bold': 'color.text.inverse',
    'color.background.information.bold.hovered': 'color.text.inverse',
    'color.background.information.bold.pressed': 'color.text.inverse'
};
var $1d749ea5cf4f6b0d$export$daf94a976c798b4f = {
    'opacity.disabled': "var(--ds-opacity-disabled, 0.4)",
    'opacity.loading': "var(--ds-opacity-loading, 0.2)"
};
var $1d749ea5cf4f6b0d$export$7aff6e7ba39bb774 = {
    'elevation.shadow.overflow': "var(--ds-shadow-overflow, 0px 0px 8px #091e423f, 0px 0px 1px #091e424f)",
    'elevation.shadow.overflow.perimeter': "var(--ds-shadow-overflow-perimeter, #091e421f)",
    'elevation.shadow.overflow.spread': "var(--ds-shadow-overflow-spread, #091e4229)",
    'elevation.shadow.overlay': "var(--ds-shadow-overlay, 0px 8px 12px #091e423f, 0px 0px 1px #091e424f)",
    'elevation.shadow.raised': "var(--ds-shadow-raised, 0px 1px 1px #091e423f, 0px 0px 1px #091e4221)"
};
var $1d749ea5cf4f6b0d$export$41a358c9c2356760 = {
    'elevation.surface': "var(--ds-surface, #FFFFFF)",
    'elevation.surface.hovered': "var(--ds-surface-hovered, #FAFBFC)",
    'elevation.surface.pressed': "var(--ds-surface-pressed, #F4F5F7)",
    'elevation.surface.overlay': "var(--ds-surface-overlay, #FFFFFF)",
    'elevation.surface.overlay.hovered': "var(--ds-surface-overlay-hovered, #FAFBFC)",
    'elevation.surface.overlay.pressed': "var(--ds-surface-overlay-pressed, #F4F5F7)",
    'elevation.surface.raised': "var(--ds-surface-raised, #FFFFFF)",
    'elevation.surface.raised.hovered': "var(--ds-surface-raised-hovered, #FAFBFC)",
    'elevation.surface.raised.pressed': "var(--ds-surface-raised-pressed, #F4F5F7)",
    'elevation.surface.sunken': "var(--ds-surface-sunken, #F4F5F7)"
};
var $1d749ea5cf4f6b0d$export$1531ad5bb3fbedac = {
    'color.border': "var(--ds-border, #091e4221)",
    'color.border.accent.lime': "var(--ds-border-accent-lime, #6A9A23)",
    'color.border.accent.red': "var(--ds-border-accent-red, #FF5630)",
    'color.border.accent.orange': "var(--ds-border-accent-orange, #D94008)",
    'color.border.accent.yellow': "var(--ds-border-accent-yellow, #FFAB00)",
    'color.border.accent.green': "var(--ds-border-accent-green, #36B37E)",
    'color.border.accent.teal': "var(--ds-border-accent-teal, #00B8D9)",
    'color.border.accent.blue': "var(--ds-border-accent-blue, #0065FF)",
    'color.border.accent.purple': "var(--ds-border-accent-purple, #6554C0)",
    'color.border.accent.magenta': "var(--ds-border-accent-magenta, #CD519D)",
    'color.border.accent.gray': "var(--ds-border-accent-gray, #5E6C84)",
    'color.border.disabled': "var(--ds-border-disabled, #FAFBFC)",
    'color.border.focused': "var(--ds-border-focused, #2684FF)",
    'color.border.input': "var(--ds-border-input, #FAFBFC)",
    'color.border.inverse': "var(--ds-border-inverse, #FFFFFF)",
    'color.border.selected': "var(--ds-border-selected, #0052CC)",
    'color.border.brand': "var(--ds-border-brand, #0052CC)",
    'color.border.danger': "var(--ds-border-danger, #FF5630)",
    'color.border.warning': "var(--ds-border-warning, #FFC400)",
    'color.border.success': "var(--ds-border-success, #00875A)",
    'color.border.discovery': "var(--ds-border-discovery, #998DD9)",
    'color.border.information': "var(--ds-border-information, #0065FF)",
    'color.border.bold': "var(--ds-border-bold, #344563)"
};
var $1d749ea5cf4f6b0d$export$d1d79bf68ac056bd = {
    'color.background.accent.lime.subtlest': "var(--ds-background-accent-lime-subtlest, #EEFBDA)",
    'color.background.accent.lime.subtlest.hovered': "var(--ds-background-accent-lime-subtlest-hovered, #D3F1A7)",
    'color.background.accent.lime.subtlest.pressed': "var(--ds-background-accent-lime-subtlest-pressed, #B3DF72)",
    'color.background.accent.lime.subtler': "var(--ds-background-accent-lime-subtler, #D3F1A7)",
    'color.background.accent.lime.subtler.hovered': "var(--ds-background-accent-lime-subtler-hovered, #B3DF72)",
    'color.background.accent.lime.subtler.pressed': "var(--ds-background-accent-lime-subtler-pressed, #94C748)",
    'color.background.accent.lime.subtle': "var(--ds-background-accent-lime-subtle, #94C748)",
    'color.background.accent.lime.subtle.hovered': "var(--ds-background-accent-lime-subtle-hovered, #B3DF72)",
    'color.background.accent.lime.subtle.pressed': "var(--ds-background-accent-lime-subtle-pressed, #D3F1A7)",
    'color.background.accent.lime.bolder': "var(--ds-background-accent-lime-bolder, #5B7F24)",
    'color.background.accent.lime.bolder.hovered': "var(--ds-background-accent-lime-bolder-hovered, #37471F)",
    'color.background.accent.lime.bolder.pressed': "var(--ds-background-accent-lime-bolder-pressed, #37471F)",
    'color.background.accent.red.subtlest': "var(--ds-background-accent-red-subtlest, #FF8F73)",
    'color.background.accent.red.subtlest.hovered': "var(--ds-background-accent-red-subtlest-hovered, #FF7452)",
    'color.background.accent.red.subtlest.pressed': "var(--ds-background-accent-red-subtlest-pressed, #FF5630)",
    'color.background.accent.red.subtler': "var(--ds-background-accent-red-subtler, #FF7452)",
    'color.background.accent.red.subtler.hovered': "var(--ds-background-accent-red-subtler-hovered, #FF5630)",
    'color.background.accent.red.subtler.pressed': "var(--ds-background-accent-red-subtler-pressed, #DE350B)",
    'color.background.accent.red.subtle': "var(--ds-background-accent-red-subtle, #DE350B)",
    'color.background.accent.red.subtle.hovered': "var(--ds-background-accent-red-subtle-hovered, #FF5630)",
    'color.background.accent.red.subtle.pressed': "var(--ds-background-accent-red-subtle-pressed, #FF7452)",
    'color.background.accent.red.bolder': "var(--ds-background-accent-red-bolder, #DE350B)",
    'color.background.accent.red.bolder.hovered': "var(--ds-background-accent-red-bolder-hovered, #FF5630)",
    'color.background.accent.red.bolder.pressed': "var(--ds-background-accent-red-bolder-pressed, #FF7452)",
    'color.background.accent.orange.subtlest': "var(--ds-background-accent-orange-subtlest, #F18D13)",
    'color.background.accent.orange.subtlest.hovered': "var(--ds-background-accent-orange-subtlest-hovered, #FEC57B)",
    'color.background.accent.orange.subtlest.pressed': "var(--ds-background-accent-orange-subtlest-pressed, #FFE2BD)",
    'color.background.accent.orange.subtler': "var(--ds-background-accent-orange-subtler, #B65C02)",
    'color.background.accent.orange.subtler.hovered': "var(--ds-background-accent-orange-subtler-hovered, #F18D13)",
    'color.background.accent.orange.subtler.pressed': "var(--ds-background-accent-orange-subtler-pressed, #FEC57B)",
    'color.background.accent.orange.subtle': "var(--ds-background-accent-orange-subtle, #5F3811)",
    'color.background.accent.orange.subtle.hovered': "var(--ds-background-accent-orange-subtle-hovered, #974F0C)",
    'color.background.accent.orange.subtle.pressed': "var(--ds-background-accent-orange-subtle-pressed, #B65C02)",
    'color.background.accent.orange.bolder': "var(--ds-background-accent-orange-bolder, #43290F)",
    'color.background.accent.orange.bolder.hovered': "var(--ds-background-accent-orange-bolder-hovered, #5F3811)",
    'color.background.accent.orange.bolder.pressed': "var(--ds-background-accent-orange-bolder-pressed, #974F0C)",
    'color.background.accent.yellow.subtlest': "var(--ds-background-accent-yellow-subtlest, #FFE380)",
    'color.background.accent.yellow.subtlest.hovered': "var(--ds-background-accent-yellow-subtlest-hovered, #FFC400)",
    'color.background.accent.yellow.subtlest.pressed': "var(--ds-background-accent-yellow-subtlest-pressed, #FFAB00)",
    'color.background.accent.yellow.subtler': "var(--ds-background-accent-yellow-subtler, #FFC400)",
    'color.background.accent.yellow.subtler.hovered': "var(--ds-background-accent-yellow-subtler-hovered, #FFAB00)",
    'color.background.accent.yellow.subtler.pressed': "var(--ds-background-accent-yellow-subtler-pressed, #FF991F)",
    'color.background.accent.yellow.subtle': "var(--ds-background-accent-yellow-subtle, #FF991F)",
    'color.background.accent.yellow.subtle.hovered': "var(--ds-background-accent-yellow-subtle-hovered, #FFAB00)",
    'color.background.accent.yellow.subtle.pressed': "var(--ds-background-accent-yellow-subtle-pressed, #FFC400)",
    'color.background.accent.yellow.bolder': "var(--ds-background-accent-yellow-bolder, #FF991F)",
    'color.background.accent.yellow.bolder.hovered': "var(--ds-background-accent-yellow-bolder-hovered, #FFAB00)",
    'color.background.accent.yellow.bolder.pressed': "var(--ds-background-accent-yellow-bolder-pressed, #FFC400)",
    'color.background.accent.green.subtlest': "var(--ds-background-accent-green-subtlest, #79F2C0)",
    'color.background.accent.green.subtlest.hovered': "var(--ds-background-accent-green-subtlest-hovered, #57D9A3)",
    'color.background.accent.green.subtlest.pressed': "var(--ds-background-accent-green-subtlest-pressed, #36B37E)",
    'color.background.accent.green.subtler': "var(--ds-background-accent-green-subtler, #57D9A3)",
    'color.background.accent.green.subtler.hovered': "var(--ds-background-accent-green-subtler-hovered, #36B37E)",
    'color.background.accent.green.subtler.pressed': "var(--ds-background-accent-green-subtler-pressed, #00875A)",
    'color.background.accent.green.subtle': "var(--ds-background-accent-green-subtle, #00875A)",
    'color.background.accent.green.subtle.hovered': "var(--ds-background-accent-green-subtle-hovered, #36B37E)",
    'color.background.accent.green.subtle.pressed': "var(--ds-background-accent-green-subtle-pressed, #57D9A3)",
    'color.background.accent.green.bolder': "var(--ds-background-accent-green-bolder, #00875A)",
    'color.background.accent.green.bolder.hovered': "var(--ds-background-accent-green-bolder-hovered, #36B37E)",
    'color.background.accent.green.bolder.pressed': "var(--ds-background-accent-green-bolder-pressed, #57D9A3)",
    'color.background.accent.teal.subtlest': "var(--ds-background-accent-teal-subtlest, #79E2F2)",
    'color.background.accent.teal.subtlest.hovered': "var(--ds-background-accent-teal-subtlest-hovered, #00C7E6)",
    'color.background.accent.teal.subtlest.pressed': "var(--ds-background-accent-teal-subtlest-pressed, #00B8D9)",
    'color.background.accent.teal.subtler': "var(--ds-background-accent-teal-subtler, #00C7E6)",
    'color.background.accent.teal.subtler.hovered': "var(--ds-background-accent-teal-subtler-hovered, #00B8D9)",
    'color.background.accent.teal.subtler.pressed': "var(--ds-background-accent-teal-subtler-pressed, #00A3BF)",
    'color.background.accent.teal.subtle': "var(--ds-background-accent-teal-subtle, #00A3BF)",
    'color.background.accent.teal.subtle.hovered': "var(--ds-background-accent-teal-subtle-hovered, #00B8D9)",
    'color.background.accent.teal.subtle.pressed': "var(--ds-background-accent-teal-subtle-pressed, #00C7E6)",
    'color.background.accent.teal.bolder': "var(--ds-background-accent-teal-bolder, #00A3BF)",
    'color.background.accent.teal.bolder.hovered': "var(--ds-background-accent-teal-bolder-hovered, #00B8D9)",
    'color.background.accent.teal.bolder.pressed': "var(--ds-background-accent-teal-bolder-pressed, #00C7E6)",
    'color.background.accent.blue.subtlest': "var(--ds-background-accent-blue-subtlest, #4C9AFF)",
    'color.background.accent.blue.subtlest.hovered': "var(--ds-background-accent-blue-subtlest-hovered, #2684FF)",
    'color.background.accent.blue.subtlest.pressed': "var(--ds-background-accent-blue-subtlest-pressed, #0065FF)",
    'color.background.accent.blue.subtler': "var(--ds-background-accent-blue-subtler, #2684FF)",
    'color.background.accent.blue.subtler.hovered': "var(--ds-background-accent-blue-subtler-hovered, #0065FF)",
    'color.background.accent.blue.subtler.pressed': "var(--ds-background-accent-blue-subtler-pressed, #0052CC)",
    'color.background.accent.blue.subtle': "var(--ds-background-accent-blue-subtle, #0052CC)",
    'color.background.accent.blue.subtle.hovered': "var(--ds-background-accent-blue-subtle-hovered, #0065FF)",
    'color.background.accent.blue.subtle.pressed': "var(--ds-background-accent-blue-subtle-pressed, #2684FF)",
    'color.background.accent.blue.bolder': "var(--ds-background-accent-blue-bolder, #0052CC)",
    'color.background.accent.blue.bolder.hovered': "var(--ds-background-accent-blue-bolder-hovered, #0065FF)",
    'color.background.accent.blue.bolder.pressed': "var(--ds-background-accent-blue-bolder-pressed, #2684FF)",
    'color.background.accent.purple.subtlest': "var(--ds-background-accent-purple-subtlest, #998DD9)",
    'color.background.accent.purple.subtlest.hovered': "var(--ds-background-accent-purple-subtlest-hovered, #8777D9)",
    'color.background.accent.purple.subtlest.pressed': "var(--ds-background-accent-purple-subtlest-pressed, #6554C0)",
    'color.background.accent.purple.subtler': "var(--ds-background-accent-purple-subtler, #8777D9)",
    'color.background.accent.purple.subtler.hovered': "var(--ds-background-accent-purple-subtler-hovered, #6554C0)",
    'color.background.accent.purple.subtler.pressed': "var(--ds-background-accent-purple-subtler-pressed, #5243AA)",
    'color.background.accent.purple.subtle': "var(--ds-background-accent-purple-subtle, #5243AA)",
    'color.background.accent.purple.subtle.hovered': "var(--ds-background-accent-purple-subtle-hovered, #6554C0)",
    'color.background.accent.purple.subtle.pressed': "var(--ds-background-accent-purple-subtle-pressed, #8777D9)",
    'color.background.accent.purple.bolder': "var(--ds-background-accent-purple-bolder, #5243AA)",
    'color.background.accent.purple.bolder.hovered': "var(--ds-background-accent-purple-bolder-hovered, #6554C0)",
    'color.background.accent.purple.bolder.pressed': "var(--ds-background-accent-purple-bolder-pressed, #8777D9)",
    'color.background.accent.magenta.subtlest': "var(--ds-background-accent-magenta-subtlest, #FFECF8)",
    'color.background.accent.magenta.subtlest.hovered': "var(--ds-background-accent-magenta-subtlest-hovered, #FDD0EC)",
    'color.background.accent.magenta.subtlest.pressed': "var(--ds-background-accent-magenta-subtlest-pressed, #F797D2)",
    'color.background.accent.magenta.subtler': "var(--ds-background-accent-magenta-subtler, #FDD0EC)",
    'color.background.accent.magenta.subtler.hovered': "var(--ds-background-accent-magenta-subtler-hovered, #F797D2)",
    'color.background.accent.magenta.subtler.pressed': "var(--ds-background-accent-magenta-subtler-pressed, #E774BB)",
    'color.background.accent.magenta.subtle': "var(--ds-background-accent-magenta-subtle, #E774BB)",
    'color.background.accent.magenta.subtle.hovered': "var(--ds-background-accent-magenta-subtle-hovered, #F797D2)",
    'color.background.accent.magenta.subtle.pressed': "var(--ds-background-accent-magenta-subtle-pressed, #FDD0EC)",
    'color.background.accent.magenta.bolder': "var(--ds-background-accent-magenta-bolder, #AE4787)",
    'color.background.accent.magenta.bolder.hovered': "var(--ds-background-accent-magenta-bolder-hovered, #943D73)",
    'color.background.accent.magenta.bolder.pressed': "var(--ds-background-accent-magenta-bolder-pressed, #50253F)",
    'color.background.accent.gray.subtlest': "var(--ds-background-accent-gray-subtlest, #6B778C)",
    'color.background.accent.gray.subtlest.hovered': "var(--ds-background-accent-gray-subtlest-hovered, #5E6C84)",
    'color.background.accent.gray.subtlest.pressed': "var(--ds-background-accent-gray-subtlest-pressed, #505F79)",
    'color.background.accent.gray.subtler': "var(--ds-background-accent-gray-subtler, #5E6C84)",
    'color.background.accent.gray.subtler.hovered': "var(--ds-background-accent-gray-subtler-hovered, #505F79)",
    'color.background.accent.gray.subtler.pressed': "var(--ds-background-accent-gray-subtler-pressed, #42526E)",
    'color.background.accent.gray.subtle': "var(--ds-background-accent-gray-subtle, #505F79)",
    'color.background.accent.gray.subtle.hovered': "var(--ds-background-accent-gray-subtle-hovered, #5E6C84)",
    'color.background.accent.gray.subtle.pressed': "var(--ds-background-accent-gray-subtle-pressed, #6B778C)",
    'color.background.accent.gray.bolder': "var(--ds-background-accent-gray-bolder, #42526E)",
    'color.background.accent.gray.bolder.hovered': "var(--ds-background-accent-gray-bolder-hovered, #344563)",
    'color.background.accent.gray.bolder.pressed': "var(--ds-background-accent-gray-bolder-pressed, #253858)",
    'color.background.disabled': "var(--ds-background-disabled, #091e4289)",
    'color.background.input': "var(--ds-background-input, #FAFBFC)",
    'color.background.input.hovered': "var(--ds-background-input-hovered, #EBECF0)",
    'color.background.input.pressed': "var(--ds-background-input-pressed, #FFFFFF)",
    'color.background.inverse.subtle': "var(--ds-background-inverse-subtle, #00000029)",
    'color.background.inverse.subtle.hovered': "var(--ds-background-inverse-subtle-hovered, #0000003D)",
    'color.background.inverse.subtle.pressed': "var(--ds-background-inverse-subtle-pressed, #00000052)",
    'color.background.neutral': "var(--ds-background-neutral, #DFE1E6)",
    'color.background.neutral.hovered': "var(--ds-background-neutral-hovered, #091e4214)",
    'color.background.neutral.pressed': "var(--ds-background-neutral-pressed, #B3D4FF)",
    'color.background.neutral.subtle': "var(--ds-background-neutral-subtle, transparent)",
    'color.background.neutral.subtle.hovered': "var(--ds-background-neutral-subtle-hovered, #091e4214)",
    'color.background.neutral.subtle.pressed': "var(--ds-background-neutral-subtle-pressed, #B3D4FF)",
    'color.background.neutral.bold': "var(--ds-background-neutral-bold, #42526E)",
    'color.background.neutral.bold.hovered': "var(--ds-background-neutral-bold-hovered, #505F79)",
    'color.background.neutral.bold.pressed': "var(--ds-background-neutral-bold-pressed, #344563)",
    'color.background.selected': "var(--ds-background-selected, #DEEBFF)",
    'color.background.selected.hovered': "var(--ds-background-selected-hovered, #B3D4FF)",
    'color.background.selected.pressed': "var(--ds-background-selected-pressed, #4C9AFF)",
    'color.background.selected.bold': "var(--ds-background-selected-bold, #0052CC)",
    'color.background.selected.bold.hovered': "var(--ds-background-selected-bold-hovered, #2684FF)",
    'color.background.selected.bold.pressed': "var(--ds-background-selected-bold-pressed, #0052CC)",
    'color.background.brand.subtlest': "var(--ds-background-brand-subtlest, #B3D4FF)",
    'color.background.brand.subtlest.hovered': "var(--ds-background-brand-subtlest-hovered, #DEEBFF)",
    'color.background.brand.subtlest.pressed': "var(--ds-background-brand-subtlest-pressed, #4C9AFF)",
    'color.background.brand.bold': "var(--ds-background-brand-bold, #0052CC)",
    'color.background.brand.bold.hovered': "var(--ds-background-brand-bold-hovered, #0065FF)",
    'color.background.brand.bold.pressed': "var(--ds-background-brand-bold-pressed, #0747A6)",
    'color.background.brand.boldest': "var(--ds-background-brand-boldest, #0747A6)",
    'color.background.brand.boldest.hovered': "var(--ds-background-brand-boldest-hovered, #0052CC)",
    'color.background.brand.boldest.pressed': "var(--ds-background-brand-boldest-pressed, #0747A6)",
    'color.background.danger': "var(--ds-background-danger, #FFEBE6)",
    'color.background.danger.hovered': "var(--ds-background-danger-hovered, #FFBDAD)",
    'color.background.danger.pressed': "var(--ds-background-danger-pressed, #FF8F73)",
    'color.background.danger.bold': "var(--ds-background-danger-bold, #DE350B)",
    'color.background.danger.bold.hovered': "var(--ds-background-danger-bold-hovered, #FF5630)",
    'color.background.danger.bold.pressed': "var(--ds-background-danger-bold-pressed, #BF2600)",
    'color.background.warning': "var(--ds-background-warning, #FFFAE6)",
    'color.background.warning.hovered': "var(--ds-background-warning-hovered, #FFF0B3)",
    'color.background.warning.pressed': "var(--ds-background-warning-pressed, #FFE380)",
    'color.background.warning.bold': "var(--ds-background-warning-bold, #FFAB00)",
    'color.background.warning.bold.hovered': "var(--ds-background-warning-bold-hovered, #FFC400)",
    'color.background.warning.bold.pressed': "var(--ds-background-warning-bold-pressed, #FF991F)",
    'color.background.success': "var(--ds-background-success, #E3FCEF)",
    'color.background.success.hovered': "var(--ds-background-success-hovered, #ABF5D1)",
    'color.background.success.pressed': "var(--ds-background-success-pressed, #79F2C0)",
    'color.background.success.bold': "var(--ds-background-success-bold, #00875A)",
    'color.background.success.bold.hovered': "var(--ds-background-success-bold-hovered, #57D9A3)",
    'color.background.success.bold.pressed': "var(--ds-background-success-bold-pressed, #00875A)",
    'color.background.discovery': "var(--ds-background-discovery, #EAE6FF)",
    'color.background.discovery.hovered': "var(--ds-background-discovery-hovered, #C0B6F2)",
    'color.background.discovery.pressed': "var(--ds-background-discovery-pressed, #998DD9)",
    'color.background.discovery.bold': "var(--ds-background-discovery-bold, #5243AA)",
    'color.background.discovery.bold.hovered': "var(--ds-background-discovery-bold-hovered, #8777D9)",
    'color.background.discovery.bold.pressed': "var(--ds-background-discovery-bold-pressed, #5243AA)",
    'color.background.information': "var(--ds-background-information, #DEEBFF)",
    'color.background.information.hovered': "var(--ds-background-information-hovered, #B3D4FF)",
    'color.background.information.pressed': "var(--ds-background-information-pressed, #4C9AFF)",
    'color.background.information.bold': "var(--ds-background-information-bold, #0052CC)",
    'color.background.information.bold.hovered': "var(--ds-background-information-bold-hovered, #2684FF)",
    'color.background.information.bold.pressed': "var(--ds-background-information-bold-pressed, #0052CC)",
    'color.blanket': "var(--ds-blanket, #091e4289)",
    'color.blanket.selected': "var(--ds-blanket-selected, #388BFF14)",
    'color.blanket.danger': "var(--ds-blanket-danger, #EF5C4814)",
    'color.skeleton': "var(--ds-skeleton, #F4F5F7)",
    'color.skeleton.subtle': "var(--ds-skeleton-subtle, #091e420a)",
    'elevation.surface': "var(--ds-surface, #FFFFFF)",
    'elevation.surface.hovered': "var(--ds-surface-hovered, #FAFBFC)",
    'elevation.surface.pressed': "var(--ds-surface-pressed, #F4F5F7)",
    'elevation.surface.overlay': "var(--ds-surface-overlay, #FFFFFF)",
    'elevation.surface.overlay.hovered': "var(--ds-surface-overlay-hovered, #FAFBFC)",
    'elevation.surface.overlay.pressed': "var(--ds-surface-overlay-pressed, #F4F5F7)",
    'elevation.surface.raised': "var(--ds-surface-raised, #FFFFFF)",
    'elevation.surface.raised.hovered': "var(--ds-surface-raised-hovered, #FAFBFC)",
    'elevation.surface.raised.pressed': "var(--ds-surface-raised-pressed, #F4F5F7)",
    'elevation.surface.sunken': "var(--ds-surface-sunken, #F4F5F7)",
    'utility.elevation.surface.current': "var(--ds-elevation-surface-current, #FFFFFF)"
};
var $1d749ea5cf4f6b0d$export$8473307aa00d6ea1 = {
    'color.text': "var(--ds-text, #172B4D)",
    'color.text.accent.lime': "var(--ds-text-accent-lime, #4C6B1F)",
    'color.text.accent.lime.bolder': "var(--ds-text-accent-lime-bolder, #37471F)",
    'color.text.accent.red': "var(--ds-text-accent-red, #DE350B)",
    'color.text.accent.red.bolder': "var(--ds-text-accent-red-bolder, #BF2600)",
    'color.text.accent.orange': "var(--ds-text-accent-orange, #F18D13)",
    'color.text.accent.orange.bolder': "var(--ds-text-accent-orange-bolder, #B65C02)",
    'color.text.accent.yellow': "var(--ds-text-accent-yellow, #FF991F)",
    'color.text.accent.yellow.bolder': "var(--ds-text-accent-yellow-bolder, #FF8B00)",
    'color.text.accent.green': "var(--ds-text-accent-green, #00875A)",
    'color.text.accent.green.bolder': "var(--ds-text-accent-green-bolder, #006644)",
    'color.text.accent.teal': "var(--ds-text-accent-teal, #00A3BF)",
    'color.text.accent.teal.bolder': "var(--ds-text-accent-teal-bolder, #008DA6)",
    'color.text.accent.blue': "var(--ds-text-accent-blue, #0052CC)",
    'color.text.accent.blue.bolder': "var(--ds-text-accent-blue-bolder, #0747A6)",
    'color.text.accent.purple': "var(--ds-text-accent-purple, #5243AA)",
    'color.text.accent.purple.bolder': "var(--ds-text-accent-purple-bolder, #403294)",
    'color.text.accent.magenta': "var(--ds-text-accent-magenta, #E774BB)",
    'color.text.accent.magenta.bolder': "var(--ds-text-accent-magenta-bolder, #DA62AC)",
    'color.text.accent.gray': "var(--ds-text-accent-gray, #505F79)",
    'color.text.accent.gray.bolder': "var(--ds-text-accent-gray-bolder, #172B4D)",
    'color.text.disabled': "var(--ds-text-disabled, #A5ADBA)",
    'color.text.inverse': "var(--ds-text-inverse, #FFFFFF)",
    'color.text.selected': "var(--ds-text-selected, #0052CC)",
    'color.text.brand': "var(--ds-text-brand, #0065FF)",
    'color.text.danger': "var(--ds-text-danger, #DE350B)",
    'color.text.warning': "var(--ds-text-warning, #974F0C)",
    'color.text.warning.inverse': "var(--ds-text-warning-inverse, #172B4D)",
    'color.text.success': "var(--ds-text-success, #006644)",
    'color.text.discovery': "var(--ds-text-discovery, #403294)",
    'color.text.information': "var(--ds-text-information, #0052CC)",
    'color.text.subtlest': "var(--ds-text-subtlest, #7A869A)",
    'color.text.subtle': "var(--ds-text-subtle, #42526E)",
    'color.link': "var(--ds-link, #0052CC)",
    'color.link.pressed': "var(--ds-link-pressed, #0747A6)",
    'color.link.visited': "var(--ds-link-visited, #403294)",
    'color.link.visited.pressed': "var(--ds-link-visited-pressed, #403294)"
};
var $1d749ea5cf4f6b0d$export$498780f74be9af68 = {
    'color.icon': "var(--ds-icon, #505F79)",
    'color.icon.accent.lime': "var(--ds-icon-accent-lime, #6A9A23)",
    'color.icon.accent.red': "var(--ds-icon-accent-red, #FF5630)",
    'color.icon.accent.orange': "var(--ds-icon-accent-orange, #D94008)",
    'color.icon.accent.yellow': "var(--ds-icon-accent-yellow, #FFAB00)",
    'color.icon.accent.green': "var(--ds-icon-accent-green, #36B37E)",
    'color.icon.accent.teal': "var(--ds-icon-accent-teal, #00B8D9)",
    'color.icon.accent.blue': "var(--ds-icon-accent-blue, #0065FF)",
    'color.icon.accent.purple': "var(--ds-icon-accent-purple, #6554C0)",
    'color.icon.accent.magenta': "var(--ds-icon-accent-magenta, #CD519D)",
    'color.icon.accent.gray': "var(--ds-icon-accent-gray, #5E6C84)",
    'color.icon.disabled': "var(--ds-icon-disabled, #8993A4)",
    'color.icon.inverse': "var(--ds-icon-inverse, #FFFFFF)",
    'color.icon.selected': "var(--ds-icon-selected, #0052CC)",
    'color.icon.brand': "var(--ds-icon-brand, #0065FF)",
    'color.icon.danger': "var(--ds-icon-danger, #DE350B)",
    'color.icon.warning': "var(--ds-icon-warning, #FFC400)",
    'color.icon.warning.inverse': "var(--ds-icon-warning-inverse, #253858)",
    'color.icon.success': "var(--ds-icon-success, #00875A)",
    'color.icon.discovery': "var(--ds-icon-discovery, #8777D9)",
    'color.icon.information': "var(--ds-icon-information, #0747A6)",
    'color.icon.subtle': "var(--ds-icon-subtle, #6B778C)"
};
var $1d749ea5cf4f6b0d$export$b5f31a7e431d2eab = {
    '1': 1,
    card: 100,
    navigation: 200,
    dialog: 300,
    layer: 400,
    blanket: 500,
    modal: 510,
    flag: 600,
    spotlight: 700,
    tooltip: 800
};
var $1d749ea5cf4f6b0d$export$e1b83c5210c471b8 = {
    'border.width': "var(--ds-border-width, 1px)",
    'border.width.0': "var(--ds-border-width-0, 0px)",
    'border.width.indicator': "var(--ds-border-width-indicator, 3px)",
    'border.width.outline': "var(--ds-border-width-outline, 2px)"
};
var $1d749ea5cf4f6b0d$export$3c0a6c3e64bb180d = {
    'border.radius.050': "var(--ds-border-radius-050, 2px)",
    'border.radius': "var(--ds-border-radius, 3px)",
    'border.radius.100': "var(--ds-border-radius-100, 3px)",
    'border.radius.200': "var(--ds-border-radius-200, 8px)",
    'border.radius.300': "var(--ds-border-radius-300, 12px)",
    'border.radius.400': "var(--ds-border-radius-400, 16px)",
    'border.radius.circle': "var(--ds-border-radius-circle, 32032px)"
};
var $1d749ea5cf4f6b0d$export$6ffa317d5e70375 = {
    'font.body': "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    'font.body.UNSAFE_small': "var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    'font.body.large': "var(--ds-font-body-large, normal 400 16px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    'font.body.small': "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    'font.code': "var(--ds-font-code, normal 400 0.875em/1 ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)",
    'font.heading.large': "var(--ds-font-heading-large, normal 500 24px/28px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    'font.heading.medium': "var(--ds-font-heading-medium, normal 500 20px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    'font.heading.small': "var(--ds-font-heading-small, normal 600 16px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    'font.heading.xlarge': "var(--ds-font-heading-xlarge, normal 600 29px/32px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    'font.heading.xsmall': "var(--ds-font-heading-xsmall, normal 600 14px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    'font.heading.xxlarge': "var(--ds-font-heading-xxlarge, normal 500 35px/40px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    'font.heading.xxsmall': "var(--ds-font-heading-xxsmall, normal 600 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)"
};
var $1d749ea5cf4f6b0d$export$303e322c6b1ed114 = {
    'font.weight.bold': "var(--ds-font-weight-bold, 700)",
    'font.weight.medium': "var(--ds-font-weight-medium, 500)",
    'font.weight.regular': "var(--ds-font-weight-regular, 400)",
    'font.weight.semibold': "var(--ds-font-weight-semibold, 600)"
};
var $1d749ea5cf4f6b0d$export$3c7e9587132614b4 = {
    'font.family.body': "var(--ds-font-family-body, ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    'font.family.brand.body': "var(--ds-font-family-brand-body, \"Charlie Text\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    'font.family.brand.heading': "var(--ds-font-family-brand-heading, \"Charlie Display\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    'font.family.code': "var(--ds-font-family-code, ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)",
    'font.family.heading': "var(--ds-font-family-heading, ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)"
};
var $1d749ea5cf4f6b0d$export$236bfe3a33ef1292 = {
    medium: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    UNSAFE_small: "var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    large: "var(--ds-font-body-large, normal 400 16px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    small: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)"
};
var $1d749ea5cf4f6b0d$export$855cfd311192d666 = {
    bold: "var(--ds-font-weight-bold, 700)",
    medium: "var(--ds-font-weight-medium, 500)",
    regular: "var(--ds-font-weight-regular, 400)",
    semibold: "var(--ds-font-weight-semibold, 600)"
};
/**
 * @codegenEnd
 */ // Margin needs some bespoke types: https://atlassian.slack.com/archives/CKRHB23K8/p1712623192772909
// Generate maps for Box props. backgroundColor, padding, etc
var $1d749ea5cf4f6b0d$var$spacingProperties = [
    // Used by Box
    'padding',
    'paddingBlock',
    'paddingBlockStart',
    'paddingBlockEnd',
    'paddingInline',
    'paddingInlineStart',
    'paddingInlineEnd',
    // Used by Inline and Stack
    'gap',
    'rowGap',
    'columnGap'
];
var $1d749ea5cf4f6b0d$export$ca0f9c2de39ffed7 = function getSerializedStylesMap(cssProperty, tokenMap) {
    return Object.keys(tokenMap).reduce(function(emotionSpacingMap, token) {
        // eslint-disable-next-line @repo/internal/styles/no-exported-styles
        emotionSpacingMap[token] = (0, $74Zh5.css)((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, cssProperty, tokenMap[token]));
        return emotionSpacingMap;
    }, {});
};
var $1d749ea5cf4f6b0d$export$e615f061ca585a6c = $1d749ea5cf4f6b0d$var$spacingProperties.reduce(function(styleMap, spacingProperty) {
    styleMap[spacingProperty] = $1d749ea5cf4f6b0d$export$ca0f9c2de39ffed7(spacingProperty, $1d749ea5cf4f6b0d$export$958d0ae7f2977ae4);
    return styleMap;
}, {});
var $1d749ea5cf4f6b0d$export$bf46c3f9eeafc71f = $1d749ea5cf4f6b0d$var$spacingProperties.reduce(function(styleMap, spacingProperty) {
    styleMap[spacingProperty] = $1d749ea5cf4f6b0d$export$ca0f9c2de39ffed7(spacingProperty, $1d749ea5cf4f6b0d$export$958d0ae7f2977ae4);
    return styleMap;
}, {});
var $1d749ea5cf4f6b0d$export$e7af83bafe7f9e63 = $1d749ea5cf4f6b0d$export$ca0f9c2de39ffed7('backgroundColor', $1d749ea5cf4f6b0d$export$d1d79bf68ac056bd);
var $1d749ea5cf4f6b0d$export$3a1bcba60b23d7f0 = $1d749ea5cf4f6b0d$export$ca0f9c2de39ffed7('color', $1d749ea5cf4f6b0d$export$8473307aa00d6ea1);
var $1d749ea5cf4f6b0d$export$45f3f4fe16f9f7d5 = $1d749ea5cf4f6b0d$export$ca0f9c2de39ffed7('fontWeight', $1d749ea5cf4f6b0d$export$303e322c6b1ed114);
var $1d749ea5cf4f6b0d$export$68cc305da27dbaa4 = $1d749ea5cf4f6b0d$export$ca0f9c2de39ffed7('fontFamily', $1d749ea5cf4f6b0d$export$3c7e9587132614b4);
var $1d749ea5cf4f6b0d$export$128f10c238242f83 = $1d749ea5cf4f6b0d$export$ca0f9c2de39ffed7('font', $1d749ea5cf4f6b0d$export$6ffa317d5e70375);
var $1d749ea5cf4f6b0d$export$219d364c0da35ae4 = $1d749ea5cf4f6b0d$export$ca0f9c2de39ffed7('font', $1d749ea5cf4f6b0d$export$236bfe3a33ef1292);
var $1d749ea5cf4f6b0d$export$38845ca010b93505 = $1d749ea5cf4f6b0d$export$ca0f9c2de39ffed7('fontWeight', $1d749ea5cf4f6b0d$export$855cfd311192d666);
var $1d749ea5cf4f6b0d$export$ff257d957d48c421 = $1d749ea5cf4f6b0d$export$ca0f9c2de39ffed7((0, $dfb11b85b532f292$export$9d7b58831ae93caa), $1d749ea5cf4f6b0d$export$41a358c9c2356760);
var $1d749ea5cf4f6b0d$export$5e65a44e5b6ecadb = function isSurfaceColorToken(color) {
    return $1d749ea5cf4f6b0d$export$41a358c9c2356760[color] !== undefined;
};



var $fC8ib = parcelRequire("fC8ib");

var $25nEq = parcelRequire("25nEq");

var $iYJcE = parcelRequire("iYJcE");

var $ekGgq = parcelRequire("ekGgq");

var $74Zh5 = parcelRequire("74Zh5");


var $3ZMUU = parcelRequire("3ZMUU");
function $a8477e78427cc4b7$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $a8477e78427cc4b7$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $a8477e78427cc4b7$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $a8477e78427cc4b7$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $a8477e78427cc4b7$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $a8477e78427cc4b7$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
var $a8477e78427cc4b7$export$9a199fbafee0014e = {
    backgroundColor: (0, $1d749ea5cf4f6b0d$export$d1d79bf68ac056bd),
    blockSize: (0, $1d749ea5cf4f6b0d$export$6ccdbebca2ee545f),
    borderBlockColor: (0, $1d749ea5cf4f6b0d$export$1531ad5bb3fbedac),
    borderBlockEndColor: (0, $1d749ea5cf4f6b0d$export$1531ad5bb3fbedac),
    borderBlockEndWidth: (0, $1d749ea5cf4f6b0d$export$e1b83c5210c471b8),
    borderBlockStartColor: (0, $1d749ea5cf4f6b0d$export$1531ad5bb3fbedac),
    borderBlockStartWidth: (0, $1d749ea5cf4f6b0d$export$e1b83c5210c471b8),
    borderBlockWidth: (0, $1d749ea5cf4f6b0d$export$e1b83c5210c471b8),
    borderBottomColor: (0, $1d749ea5cf4f6b0d$export$1531ad5bb3fbedac),
    borderBottomLeftRadius: (0, $1d749ea5cf4f6b0d$export$3c0a6c3e64bb180d),
    borderBottomRightRadius: (0, $1d749ea5cf4f6b0d$export$3c0a6c3e64bb180d),
    borderBottomWidth: (0, $1d749ea5cf4f6b0d$export$e1b83c5210c471b8),
    borderColor: (0, $1d749ea5cf4f6b0d$export$1531ad5bb3fbedac),
    borderEndEndRadius: (0, $1d749ea5cf4f6b0d$export$3c0a6c3e64bb180d),
    borderEndStartRadius: (0, $1d749ea5cf4f6b0d$export$3c0a6c3e64bb180d),
    borderInlineColor: (0, $1d749ea5cf4f6b0d$export$1531ad5bb3fbedac),
    borderInlineEndColor: (0, $1d749ea5cf4f6b0d$export$1531ad5bb3fbedac),
    borderInlineEndWidth: (0, $1d749ea5cf4f6b0d$export$e1b83c5210c471b8),
    borderInlineStartColor: (0, $1d749ea5cf4f6b0d$export$1531ad5bb3fbedac),
    borderInlineStartWidth: (0, $1d749ea5cf4f6b0d$export$e1b83c5210c471b8),
    borderInlineWidth: (0, $1d749ea5cf4f6b0d$export$e1b83c5210c471b8),
    borderLeftColor: (0, $1d749ea5cf4f6b0d$export$1531ad5bb3fbedac),
    borderLeftWidth: (0, $1d749ea5cf4f6b0d$export$e1b83c5210c471b8),
    borderRadius: (0, $1d749ea5cf4f6b0d$export$3c0a6c3e64bb180d),
    borderRightColor: (0, $1d749ea5cf4f6b0d$export$1531ad5bb3fbedac),
    borderRightWidth: (0, $1d749ea5cf4f6b0d$export$e1b83c5210c471b8),
    borderStartEndRadius: (0, $1d749ea5cf4f6b0d$export$3c0a6c3e64bb180d),
    borderStartStartRadius: (0, $1d749ea5cf4f6b0d$export$3c0a6c3e64bb180d),
    borderTopColor: (0, $1d749ea5cf4f6b0d$export$1531ad5bb3fbedac),
    borderTopLeftRadius: (0, $1d749ea5cf4f6b0d$export$3c0a6c3e64bb180d),
    borderTopRightRadius: (0, $1d749ea5cf4f6b0d$export$3c0a6c3e64bb180d),
    borderTopWidth: (0, $1d749ea5cf4f6b0d$export$e1b83c5210c471b8),
    borderWidth: (0, $1d749ea5cf4f6b0d$export$e1b83c5210c471b8),
    bottom: (0, $1d749ea5cf4f6b0d$export$632685d741f3dbbf),
    boxShadow: (0, $1d749ea5cf4f6b0d$export$7aff6e7ba39bb774),
    color: (0, $1d749ea5cf4f6b0d$export$8473307aa00d6ea1),
    columnGap: (0, $1d749ea5cf4f6b0d$export$958d0ae7f2977ae4),
    font: (0, $1d749ea5cf4f6b0d$export$6ffa317d5e70375),
    fontFamily: (0, $1d749ea5cf4f6b0d$export$3c7e9587132614b4),
    fontWeight: (0, $1d749ea5cf4f6b0d$export$303e322c6b1ed114),
    gap: (0, $1d749ea5cf4f6b0d$export$958d0ae7f2977ae4),
    height: (0, $1d749ea5cf4f6b0d$export$6ccdbebca2ee545f),
    inlineSize: (0, $1d749ea5cf4f6b0d$export$6ccdbebca2ee545f),
    inset: (0, $1d749ea5cf4f6b0d$export$632685d741f3dbbf),
    insetBlock: (0, $1d749ea5cf4f6b0d$export$632685d741f3dbbf),
    insetBlockEnd: (0, $1d749ea5cf4f6b0d$export$632685d741f3dbbf),
    insetBlockStart: (0, $1d749ea5cf4f6b0d$export$632685d741f3dbbf),
    insetInline: (0, $1d749ea5cf4f6b0d$export$632685d741f3dbbf),
    insetInlineEnd: (0, $1d749ea5cf4f6b0d$export$632685d741f3dbbf),
    insetInlineStart: (0, $1d749ea5cf4f6b0d$export$632685d741f3dbbf),
    left: (0, $1d749ea5cf4f6b0d$export$632685d741f3dbbf),
    margin: (0, $1d749ea5cf4f6b0d$export$632685d741f3dbbf),
    marginBlock: (0, $1d749ea5cf4f6b0d$export$632685d741f3dbbf),
    marginBlockEnd: (0, $1d749ea5cf4f6b0d$export$632685d741f3dbbf),
    marginBlockStart: (0, $1d749ea5cf4f6b0d$export$632685d741f3dbbf),
    marginBottom: (0, $1d749ea5cf4f6b0d$export$632685d741f3dbbf),
    marginInline: (0, $1d749ea5cf4f6b0d$export$632685d741f3dbbf),
    marginInlineEnd: (0, $1d749ea5cf4f6b0d$export$632685d741f3dbbf),
    marginInlineStart: (0, $1d749ea5cf4f6b0d$export$632685d741f3dbbf),
    marginLeft: (0, $1d749ea5cf4f6b0d$export$632685d741f3dbbf),
    marginRight: (0, $1d749ea5cf4f6b0d$export$632685d741f3dbbf),
    marginTop: (0, $1d749ea5cf4f6b0d$export$632685d741f3dbbf),
    maxBlockSize: (0, $1d749ea5cf4f6b0d$export$6ccdbebca2ee545f),
    maxHeight: (0, $1d749ea5cf4f6b0d$export$6ccdbebca2ee545f),
    maxInlineSize: (0, $1d749ea5cf4f6b0d$export$6ccdbebca2ee545f),
    maxWidth: (0, $1d749ea5cf4f6b0d$export$6ccdbebca2ee545f),
    minBlockSize: (0, $1d749ea5cf4f6b0d$export$6ccdbebca2ee545f),
    minHeight: (0, $1d749ea5cf4f6b0d$export$6ccdbebca2ee545f),
    minInlineSize: (0, $1d749ea5cf4f6b0d$export$6ccdbebca2ee545f),
    minWidth: (0, $1d749ea5cf4f6b0d$export$6ccdbebca2ee545f),
    opacity: (0, $1d749ea5cf4f6b0d$export$daf94a976c798b4f),
    outlineColor: (0, $1d749ea5cf4f6b0d$export$1531ad5bb3fbedac),
    outlineOffset: (0, $1d749ea5cf4f6b0d$export$958d0ae7f2977ae4),
    outlineWidth: (0, $1d749ea5cf4f6b0d$export$e1b83c5210c471b8),
    padding: (0, $1d749ea5cf4f6b0d$export$958d0ae7f2977ae4),
    paddingBlock: (0, $1d749ea5cf4f6b0d$export$958d0ae7f2977ae4),
    paddingBlockEnd: (0, $1d749ea5cf4f6b0d$export$958d0ae7f2977ae4),
    paddingBlockStart: (0, $1d749ea5cf4f6b0d$export$958d0ae7f2977ae4),
    paddingBottom: (0, $1d749ea5cf4f6b0d$export$958d0ae7f2977ae4),
    paddingInline: (0, $1d749ea5cf4f6b0d$export$958d0ae7f2977ae4),
    paddingInlineEnd: (0, $1d749ea5cf4f6b0d$export$958d0ae7f2977ae4),
    paddingInlineStart: (0, $1d749ea5cf4f6b0d$export$958d0ae7f2977ae4),
    paddingLeft: (0, $1d749ea5cf4f6b0d$export$958d0ae7f2977ae4),
    paddingRight: (0, $1d749ea5cf4f6b0d$export$958d0ae7f2977ae4),
    paddingTop: (0, $1d749ea5cf4f6b0d$export$958d0ae7f2977ae4),
    right: (0, $1d749ea5cf4f6b0d$export$632685d741f3dbbf),
    rowGap: (0, $1d749ea5cf4f6b0d$export$958d0ae7f2977ae4),
    top: (0, $1d749ea5cf4f6b0d$export$632685d741f3dbbf),
    width: (0, $1d749ea5cf4f6b0d$export$6ccdbebca2ee545f),
    zIndex: (0, $1d749ea5cf4f6b0d$export$b5f31a7e431d2eab)
};
var $a8477e78427cc4b7$var$uniqueSymbol = Symbol('UNSAFE_INTERNAL_styles');
var $a8477e78427cc4b7$var$isSafeEnvToThrow = function isSafeEnvToThrow() {
    return (typeof $3ZMUU === "undefined" ? "undefined" : (0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))($3ZMUU)) === 'object' && (0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))($3ZMUU.env) === 'object' && false;
};
var $a8477e78427cc4b7$var$reNestedSelectors = /(\.|\s|&+|\*\>|#|\[.*\])/;
var $a8477e78427cc4b7$var$safeSelectors = /^@media .*$|^::?.*$|^@supports .*$/;
var $a8477e78427cc4b7$var$_transformStyles = function transformStyles(styleObj) {
    if (!styleObj || (0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(styleObj) !== 'object') return styleObj;
    // If styles are defined as a CSSObject[], recursively call on each element until we reach CSSObject
    if (Array.isArray(styleObj)) return styleObj.map($a8477e78427cc4b7$var$_transformStyles);
    // Modifies styleObj in place. Be careful.
    Object.entries(styleObj).forEach(function(_ref) {
        var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_ref, 2), key = _ref2[0], value = _ref2[1];
        // If key is a pseudo class or a pseudo element, then value should be an object.
        // So, call transformStyles on the value
        if ((0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(value) === 'object' && $a8477e78427cc4b7$var$safeSelectors.test(key)) {
            styleObj[key] = $a8477e78427cc4b7$var$_transformStyles(value);
            return;
        }
        if ($a8477e78427cc4b7$var$isSafeEnvToThrow()) {
            // We don't support `.class`, `[data-testid]`, `> *`, `#some-id`
            if ($a8477e78427cc4b7$var$reNestedSelectors.test(key)) throw new Error("Styles not supported for key '".concat(key, "'."));
        }
        // We have now dealt with all the special cases, so,
        // check whether what remains is a style property
        // that can be transformed.
        if (!(key in $a8477e78427cc4b7$export$9a199fbafee0014e)) return;
        var tokenValue = $a8477e78427cc4b7$export$9a199fbafee0014e[key][value];
        styleObj[key] = tokenValue !== null && tokenValue !== void 0 ? tokenValue : value;
    });
    return styleObj;
};
var $a8477e78427cc4b7$var$baseXcss = function baseXcss(style) {
    var transformedStyles = $a8477e78427cc4b7$var$_transformStyles(style);
    return (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, $a8477e78427cc4b7$var$uniqueSymbol, (0, $74Zh5.css)(transformedStyles));
};
/**
 * Picks out runtime XCSS objects and build-time XCSS strings. This is needed
 * to supported both Emotion and Compiled styles until we've fully migrated
 * to Compiled.
 *
 * @private
 * @deprecated
 */ var $a8477e78427cc4b7$export$a9c84988c8f81f2d = function parseXcss(args) {
    if (Array.isArray(args)) {
        var emotion = [];
        var staticArr = [];
        var _iterator = $a8477e78427cc4b7$var$_createForOfIteratorHelper(args), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var arg = _step.value;
                var result = $a8477e78427cc4b7$export$a9c84988c8f81f2d(arg);
                if (result.emotion) emotion.push.apply(emotion, (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(result.emotion));
                if (result.static) staticArr.push(result.static);
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
        return {
            emotion: emotion,
            static: staticArr.join(' ')
        };
    }
    var objArgs = args;
    var _ref4 = objArgs || {}, styles = _ref4[$a8477e78427cc4b7$var$uniqueSymbol];
    if (styles) return {
        emotion: [
            styles
        ]
    };
    if (args) {
        // We use string interpolation here instead of .toString() just
        // in case the resulting object doesn't have the method available.
        var stringifiedArgs = "".concat(args);
        if (stringifiedArgs) return {
            static: stringifiedArgs
        };
    }
    return {};
};
function $a8477e78427cc4b7$export$f6c783d06584602c(style) {
    return $a8477e78427cc4b7$var$baseXcss(style);
}


var $d469e5ab074fc4c0$var$_excluded = [
    "children",
    "backgroundColor",
    "padding",
    "paddingBlock",
    "paddingBlockStart",
    "paddingBlockEnd",
    "paddingInline",
    "paddingInlineStart",
    "paddingInlineEnd",
    "isDisabled",
    "type",
    "onClick",
    "interactionName",
    "componentName",
    "analyticsContext",
    "style",
    "testId",
    "xcss"
], $d469e5ab074fc4c0$var$_excluded2 = [
    "className"
];
// This duplicates FocusRing styles from `@atlaskit/focus-ring`.
var $d469e5ab074fc4c0$var$focusRingStyles = (0, $74Zh5.css)({
    '&:focus, &:focus-visible': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        outlineColor: (0, $1d749ea5cf4f6b0d$export$1531ad5bb3fbedac)['color.border.focused'],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        outlineOffset: (0, $1d749ea5cf4f6b0d$export$958d0ae7f2977ae4)['space.025'],
        outlineStyle: 'solid',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        outlineWidth: (0, $1d749ea5cf4f6b0d$export$e1b83c5210c471b8)['border.width.outline']
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
    '&:focus:not(:focus-visible)': {
        outline: 'none'
    },
    '@media screen and (forced-colors: active), screen and (-ms-high-contrast: active)': {
        '&:focus-visible': {
            outline: '1px solid'
        }
    }
});
var $d469e5ab074fc4c0$var$baseStyles = (0, $74Zh5.css)({
    boxSizing: 'border-box',
    appearance: 'none',
    border: 'none'
});
var $d469e5ab074fc4c0$var$enabledStyles = (0, $74Zh5.css)({
    cursor: 'pointer'
});
var $d469e5ab074fc4c0$var$disabledStyles = (0, $74Zh5.css)({
    cursor: 'not-allowed'
});
/**
 * __Pressable__
 *
 * A primitive for building custom buttons.
 *
 * - [Examples](https://atlassian.design/components/primitives/pressable/examples)
 * - [Code](https://atlassian.design/components/primitives/pressable/code)
 * - [Usage](https://atlassian.design/components/primitives/pressable/usage)
 */ var $d469e5ab074fc4c0$var$Pressable = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function(_ref, ref) {
    var children = _ref.children, backgroundColor = _ref.backgroundColor, padding = _ref.padding, paddingBlock = _ref.paddingBlock, paddingBlockStart = _ref.paddingBlockStart, paddingBlockEnd = _ref.paddingBlockEnd, paddingInline = _ref.paddingInline, paddingInlineStart = _ref.paddingInlineStart, paddingInlineEnd = _ref.paddingInlineEnd, isDisabled = _ref.isDisabled, _ref$type = _ref.type, type = _ref$type === void 0 ? 'button' : _ref$type, _ref$onClick = _ref.onClick, providedOnClick = _ref$onClick === void 0 ? (0, $3a341012e037de4f$export$2e2bcd8739ae039) : _ref$onClick, interactionName = _ref.interactionName, componentName = _ref.componentName, analyticsContext = _ref.analyticsContext, style = _ref.style, testId = _ref.testId, xcss = _ref.xcss, htmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $d469e5ab074fc4c0$var$_excluded);
    var interactionContext = (0, $5FkrB.useContext)((0, $6aca23134cc0dc0c$export$2e2bcd8739ae039));
    var handleClick = (0, $5FkrB.useCallback)(function(e, analyticsEvent) {
        interactionContext && interactionContext.tracePress(interactionName, e.timeStamp);
        providedOnClick(e, analyticsEvent);
    }, [
        providedOnClick,
        interactionContext,
        interactionName
    ]);
    var onClick = (0, $8fb7a896bc43fd0a$export$a4687b0234b40e28)({
        fn: handleClick,
        action: 'clicked',
        componentName: componentName || 'Pressable',
        packageName: "@atlaskit/primitives",
        packageVersion: "13.6.0",
        analyticsData: analyticsContext,
        actionSubject: 'button'
    });
    // This is to remove className from safeHtmlAttributes
    // @ts-expect-error className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(htmlAttributes, $d469e5ab074fc4c0$var$_excluded2);
    var resolvedStyles = (0, $a8477e78427cc4b7$export$a9c84988c8f81f2d)(xcss);
    return(// eslint-disable-next-line @atlaskit/design-system/no-html-button
    (0, $74Zh5.jsx)("button", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: style,
        ref: ref,
        className: resolvedStyles.static
    }, safeHtmlAttributes, {
        // eslint-disable-next-line react/button-has-type
        type: type,
        onClick: onClick,
        disabled: isDisabled,
        css: [
            $d469e5ab074fc4c0$var$baseStyles,
            $d469e5ab074fc4c0$var$focusRingStyles,
            isDisabled ? $d469e5ab074fc4c0$var$disabledStyles : $d469e5ab074fc4c0$var$enabledStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            backgroundColor && (0, $1d749ea5cf4f6b0d$export$e7af83bafe7f9e63)[backgroundColor],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            padding && (0, $1d749ea5cf4f6b0d$export$e615f061ca585a6c).padding[padding],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlock && (0, $1d749ea5cf4f6b0d$export$e615f061ca585a6c).paddingBlock[paddingBlock],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlockStart && (0, $1d749ea5cf4f6b0d$export$e615f061ca585a6c).paddingBlockStart[paddingBlockStart],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlockEnd && (0, $1d749ea5cf4f6b0d$export$e615f061ca585a6c).paddingBlockEnd[paddingBlockEnd],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInline && (0, $1d749ea5cf4f6b0d$export$e615f061ca585a6c).paddingInline[paddingInline],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInlineStart && (0, $1d749ea5cf4f6b0d$export$e615f061ca585a6c).paddingInlineStart[paddingInlineStart],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInlineEnd && (0, $1d749ea5cf4f6b0d$export$e615f061ca585a6c).paddingInlineEnd[paddingInlineEnd],
            // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
            resolvedStyles.emotion
        ],
        "data-testid": testId
    }), children));
});
var $d469e5ab074fc4c0$export$2e2bcd8739ae039 = $d469e5ab074fc4c0$var$Pressable;



var $5FkrB = parcelRequire("5FkrB");

var $fC8ib = parcelRequire("fC8ib");

var $5FkrB = parcelRequire("5FkrB");

var $kqp0i = parcelRequire("kqp0i");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");

var $74Zh5 = parcelRequire("74Zh5");

var $5FkrB = parcelRequire("5FkrB");
var $108885aefd7aac23$export$1ca2a26fecb070ae = /*#__PURE__*/ (0, $5FkrB.createContext)('elevation.surface');
var $108885aefd7aac23$export$1aeb4f6b93c4540d = function useSurface() {
    return (0, $5FkrB.useContext)($108885aefd7aac23$export$1ca2a26fecb070ae);
};
$108885aefd7aac23$export$1ca2a26fecb070ae.displayName = 'SurfaceProvider';




var $d007f17589e0f9b9$var$_excluded = [
    "as",
    "children",
    "backgroundColor",
    "padding",
    "paddingBlock",
    "paddingBlockStart",
    "paddingBlockEnd",
    "paddingInline",
    "paddingInlineStart",
    "paddingInlineEnd",
    "style",
    "testId",
    "xcss"
], $d007f17589e0f9b9$var$_excluded2 = [
    "className"
];
var $d007f17589e0f9b9$export$e71c4d32a2263218 = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? 'div' : _ref$as, children = _ref.children, backgroundColor = _ref.backgroundColor, padding = _ref.padding, paddingBlock = _ref.paddingBlock, paddingBlockStart = _ref.paddingBlockStart, paddingBlockEnd = _ref.paddingBlockEnd, paddingInline = _ref.paddingInline, paddingInlineStart = _ref.paddingInlineStart, paddingInlineEnd = _ref.paddingInlineEnd, style = _ref.style, testId = _ref.testId, xcss = _ref.xcss, htmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $d007f17589e0f9b9$var$_excluded);
    // This is to remove className from safeHtmlAttributes
    // @ts-expect-error className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(htmlAttributes, $d007f17589e0f9b9$var$_excluded2);
    var resolvedStyles = (0, $a8477e78427cc4b7$export$a9c84988c8f81f2d)(xcss);
    var node = // @ts-expect-error Expression produces a union type that is too complex to represent. I think this is unavoidable
    (0, $74Zh5.jsx)(Component, (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        style: style,
        ref: ref,
        className: resolvedStyles.static
    }, safeHtmlAttributes, {
        css: [
            $d007f17589e0f9b9$var$baseStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            backgroundColor && (0, $1d749ea5cf4f6b0d$export$e7af83bafe7f9e63)[backgroundColor],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $1d749ea5cf4f6b0d$export$5e65a44e5b6ecadb)(backgroundColor) && (0, $1d749ea5cf4f6b0d$export$ff257d957d48c421)[backgroundColor],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            padding && (0, $1d749ea5cf4f6b0d$export$e615f061ca585a6c).padding[padding],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlock && (0, $1d749ea5cf4f6b0d$export$e615f061ca585a6c).paddingBlock[paddingBlock],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlockStart && (0, $1d749ea5cf4f6b0d$export$e615f061ca585a6c).paddingBlockStart[paddingBlockStart],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlockEnd && (0, $1d749ea5cf4f6b0d$export$e615f061ca585a6c).paddingBlockEnd[paddingBlockEnd],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInline && (0, $1d749ea5cf4f6b0d$export$e615f061ca585a6c).paddingInline[paddingInline],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInlineStart && (0, $1d749ea5cf4f6b0d$export$e615f061ca585a6c).paddingInlineStart[paddingInlineStart],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInlineEnd && (0, $1d749ea5cf4f6b0d$export$e615f061ca585a6c).paddingInlineEnd[paddingInlineEnd],
            // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
            resolvedStyles.emotion
        ],
        "data-testid": testId
    }), children);
    return backgroundColor ? (0, $74Zh5.jsx)((0, $108885aefd7aac23$export$1ca2a26fecb070ae).Provider, {
        value: backgroundColor
    }, node) : node;
});
var $d007f17589e0f9b9$export$2e2bcd8739ae039 = $d007f17589e0f9b9$export$e71c4d32a2263218;
var $d007f17589e0f9b9$var$baseStyles = (0, $74Zh5.css)({
    boxSizing: 'border-box',
    appearance: 'none',
    border: 'none'
});


var $301b23ec1b0d3f05$var$textStyles = (0, $a8477e78427cc4b7$export$f6c783d06584602c)({
    // content can grow and shrink
    flexGrow: 1,
    flexShrink: 1,
    // ellipsis for overflow text
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
});
var $301b23ec1b0d3f05$var$iconStyles = (0, $a8477e78427cc4b7$export$f6c783d06584602c)({
    display: 'flex',
    // icon size cannot grow and shrink
    flexGrow: 0,
    flexShrink: 0,
    alignSelf: 'center',
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    fontSize: 0,
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: 0,
    userSelect: 'none'
});
var $301b23ec1b0d3f05$var$commonStyles = (0, $a8477e78427cc4b7$export$f6c783d06584602c)({
    transition: 'opacity 0.3s'
});
var $301b23ec1b0d3f05$var$fadeStyles = (0, $a8477e78427cc4b7$export$f6c783d06584602c)({
    opacity: 0
});
/**
 * These CSS variables consumed by the new icons, to allow them to have appropriate
 * padding inside Button while also maintaining spacing for the existing icons.
 *
 * These styles can be removed once the new icons are fully rolled out, feature flag
 * platform-visual-refresh-icons is cleaned up,
 * and we bump Button to set padding based on the new icons.
 */ var $301b23ec1b0d3f05$var$beforeIconStyles = (0, $a8477e78427cc4b7$export$f6c783d06584602c)({
    // @ts-ignore
    '--ds--button--new-icon-padding-start': "var(--ds-space-050, 4px)",
    // @ts-ignore
    '--ds--button--new-icon-padding-end': "var(--ds-space-025, 2px)"
});
var $301b23ec1b0d3f05$var$afterIconStyles = (0, $a8477e78427cc4b7$export$f6c783d06584602c)({
    // @ts-ignore
    '--ds--button--new-icon-padding-start': "var(--ds-space-025, 2px)",
    // @ts-ignore
    '--ds--button--new-icon-padding-end': "var(--ds-space-050, 4px)"
});
/**
 * __Content__
 *
 * Used for slots within a Button, including icons and text content.
 */ var $301b23ec1b0d3f05$var$Content = function Content(_ref) {
    var children = _ref.children, _ref$type = _ref.type, type = _ref$type === void 0 ? 'text' : _ref$type, isLoading = _ref.isLoading, position = _ref.position;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $d007f17589e0f9b9$export$2e2bcd8739ae039), {
        as: "span",
        xcss: [
            $301b23ec1b0d3f05$var$commonStyles
        ].concat((0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(type === 'text' ? [
            $301b23ec1b0d3f05$var$textStyles
        ] : [
            $301b23ec1b0d3f05$var$iconStyles
        ]), (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(isLoading ? [
            $301b23ec1b0d3f05$var$fadeStyles
        ] : []), (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(position === 'before' ? [
            $301b23ec1b0d3f05$var$beforeIconStyles
        ] : []), (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(position === 'after' ? [
            $301b23ec1b0d3f05$var$afterIconStyles
        ] : []))
    }, children);
};
var $301b23ec1b0d3f05$export$2e2bcd8739ae039 = $301b23ec1b0d3f05$var$Content;



var $5FkrB = parcelRequire("5FkrB");
function $a2bbd318f52424a1$var$isIconRenderProp(func) {
    return !func.displayName && // most function components and class components have a displayName, negate them
    !func.render && // forwardRef doesn't require a display name, however it does include a render function, negate them
    typeof func === 'function' // at the very least we need to be a function
    ;
}
/**
 * __Icon renderer__
 *
 * Used to support render props with icons.
 *
 */ var $a2bbd318f52424a1$var$IconRenderer = function IconRenderer(_ref) {
    var Icon = _ref.icon;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).Fragment, null, $a2bbd318f52424a1$var$isIconRenderProp(Icon) ? Icon({
        label: '',
        color: 'currentColor'
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(Icon, {
        label: "",
        color: 'currentColor'
    }));
};
var $a2bbd318f52424a1$export$2e2bcd8739ae039 = $a2bbd318f52424a1$var$IconRenderer;



var $25nEq = parcelRequire("25nEq");

var $5FkrB = parcelRequire("5FkrB");
/**
 * Assigns the node to all the refs passed in the argument.
 *
 * @param refs: An array of refs (as function or ref object)
 */ function $0d2a37110e22a1c9$export$2e2bcd8739ae039(refs) {
    // TODO: could this be wrapped in `useCallback` so we get a stable function?
    return function(value) {
        refs.forEach(function(ref) {
            if (typeof ref === 'function') ref(value);
            else if (ref !== null) ref.current = value;
        });
    };
}



var $5FkrB = parcelRequire("5FkrB");
function $65ad6b2d82b5101d$export$2e2bcd8739ae039(ref, autoFocus) {
    var initialMount = (0, $5FkrB.useRef)(true);
    (0, $5FkrB.useEffect)(function() {
        if (ref && initialMount.current && autoFocus && ref.current) ref.current.focus();
        initialMount.current = false;
    }, [
        autoFocus,
        ref
    ]);
}



var $ekGgq = parcelRequire("ekGgq");

var $5FkrB = parcelRequire("5FkrB");

var $b5lkZ = parcelRequire("b5lkZ");

var $9dOvm = parcelRequire("9dOvm");
var $cbe66bde7ac5f637$var$_process, $cbe66bde7ac5f637$var$_process2;
// We can't rely on NODE_ENV === 'test' if its value is already configured by the consumer to some other value, so better to use JEST_WORKER_ID
// https://jestjs.io/docs/environment-variables#jest_worker_id
var $cbe66bde7ac5f637$var$TESTS_MODE = (globalThis === null || globalThis === void 0 || ($cbe66bde7ac5f637$var$_process = globalThis.process) === null || $cbe66bde7ac5f637$var$_process === void 0 || ($cbe66bde7ac5f637$var$_process = $cbe66bde7ac5f637$var$_process.env) === null || $cbe66bde7ac5f637$var$_process === void 0 ? void 0 : $cbe66bde7ac5f637$var$_process.JEST_WORKER_ID) !== undefined;
var $cbe66bde7ac5f637$var$DEBUG_MODE = !$cbe66bde7ac5f637$var$TESTS_MODE && (globalThis === null || globalThis === void 0 || ($cbe66bde7ac5f637$var$_process2 = globalThis.process) === null || $cbe66bde7ac5f637$var$_process2 === void 0 || ($cbe66bde7ac5f637$var$_process2 = $cbe66bde7ac5f637$var$_process2.env) === null || $cbe66bde7ac5f637$var$_process2 === void 0 ? void 0 : $cbe66bde7ac5f637$var$_process2.NODE_ENV) !== 'production';
var $cbe66bde7ac5f637$export$1c9f709888824e05 = function debug() {
    var _console;
    if (!$cbe66bde7ac5f637$var$DEBUG_MODE) return;
    // eslint-disable-next-line no-console
    (_console = console).debug.apply(_console, arguments);
};



var $3ZMUU = parcelRequire("3ZMUU");
var $2c5062b6952f3b7b$var$pkgName = '@atlaskit/platform-feature-flags';
var $2c5062b6952f3b7b$export$7e41b1b2bdee3f98 = '__PLATFORM_FEATURE_FLAGS__';
var $2c5062b6952f3b7b$var$hasProcessEnv = typeof $3ZMUU !== 'undefined' && typeof $3ZMUU.env !== 'undefined';
// FF global overrides can be configured by test runners or Storybook
var $2c5062b6952f3b7b$var$ENV_ENABLE_PLATFORM_FF = $2c5062b6952f3b7b$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
// STORYBOOK_ENABLE_PLATFORM_FF is included as storybook only allows env vars prefixed with STORYBOOK
// https://github.com/storybookjs/storybook/issues/12270
var $2c5062b6952f3b7b$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF = $2c5062b6952f3b7b$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
var $2c5062b6952f3b7b$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE = $2c5062b6952f3b7b$var$ENV_ENABLE_PLATFORM_FF || $2c5062b6952f3b7b$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF;
var $2c5062b6952f3b7b$var$DEFAULT_PFF_GLOBAL = {
    booleanResolver: undefined
};
var $2c5062b6952f3b7b$var$globalVar = typeof window !== 'undefined' ? window : globalThis;
$2c5062b6952f3b7b$var$globalVar[$2c5062b6952f3b7b$export$7e41b1b2bdee3f98] = $2c5062b6952f3b7b$var$globalVar[$2c5062b6952f3b7b$export$7e41b1b2bdee3f98] || $2c5062b6952f3b7b$var$DEFAULT_PFF_GLOBAL;
function $2c5062b6952f3b7b$export$f2b591175b3e424c(resolver) {
    $2c5062b6952f3b7b$var$globalVar[$2c5062b6952f3b7b$export$7e41b1b2bdee3f98].booleanResolver = resolver;
}
function $2c5062b6952f3b7b$export$6333b6aff9fc6275(flagKey) {
    if ($2c5062b6952f3b7b$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE) {
        (0, $cbe66bde7ac5f637$export$1c9f709888824e05)('[%s]: The feature flags were enabled while running tests. The flag "%s" will be always enabled.', $2c5062b6952f3b7b$var$pkgName, flagKey);
        return true;
    }
    try {
        var _globalVar$PFF_GLOBAL, _globalVar$PFF_GLOBAL2, _globalVar$PFF_GLOBAL3;
        // booleanResolver will be empty for products like Trello, Elevate, Recruit etc.
        // Currently only Confluence, Jira and Bitbucket has set it.
        if (((_globalVar$PFF_GLOBAL = $2c5062b6952f3b7b$var$globalVar[$2c5062b6952f3b7b$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL === void 0 ? void 0 : _globalVar$PFF_GLOBAL.booleanResolver) === undefined || ((_globalVar$PFF_GLOBAL2 = $2c5062b6952f3b7b$var$globalVar[$2c5062b6952f3b7b$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL2 === void 0 ? void 0 : _globalVar$PFF_GLOBAL2.booleanResolver) === null) // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
        return (0, $9dOvm.default).checkGate(flagKey);
        var result = (_globalVar$PFF_GLOBAL3 = $2c5062b6952f3b7b$var$globalVar[$2c5062b6952f3b7b$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL3 === void 0 ? void 0 : _globalVar$PFF_GLOBAL3.booleanResolver(flagKey);
        if (typeof result !== 'boolean') {
            // eslint-disable-next-line no-console
            console.warn("".concat(flagKey, " resolved to a non-boolean value, returning false for safety"));
            return false;
        }
        return result;
    } catch (e) {
        return false;
    }
}


function $c52fc99465dcc625$export$ba05d765b8392e5e(flagResolver) {
    (0, $2c5062b6952f3b7b$export$f2b591175b3e424c)(flagResolver);
}
function $c52fc99465dcc625$export$470e5c2be1411c89(name) {
    return (0, $2c5062b6952f3b7b$export$6333b6aff9fc6275)(name);
}
function $c52fc99465dcc625$export$b40ec24ac8275656(name) {
    return (0, $2c5062b6952f3b7b$export$6333b6aff9fc6275)(name);
}


var $24526c38f36cc756$var$_React$useId;
// Type copied from https://github.com/thearnica/react-uid/blob/0f507fbbdb1ab84acf477ec32698afe3d2191e49/src/hooks.ts#L12
// Copied rather than inferred to make the type transparent
// @ts-ignore - useId is not accessible in React 16
var $24526c38f36cc756$var$react18UseId = ($24526c38f36cc756$var$_React$useId = (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).useId) !== null && $24526c38f36cc756$var$_React$useId !== void 0 ? $24526c38f36cc756$var$_React$useId : undefined;
function $24526c38f36cc756$export$f680877a34711e37() {
    if ($24526c38f36cc756$var$react18UseId && (0, $c52fc99465dcc625$export$b40ec24ac8275656)('platform.design-system-team.react-18-use-id_mn8q4')) // eslint-disable-next-line react-hooks/rules-of-hooks
    return $24526c38f36cc756$var$react18UseId();
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return "uid".concat((0, $b5lkZ.useUID)());
}
var $24526c38f36cc756$export$6be90bcb437e928f = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function(_ref, ref) {
    var children = _ref.children, _ref$postfix = _ref.postfix, postfix = _ref$postfix === void 0 ? '' : _ref$postfix, _ref$prefix = _ref.prefix, prefix = _ref$prefix === void 0 ? '' : _ref$prefix;
    var id = "".concat(prefix).concat($24526c38f36cc756$export$f680877a34711e37()).concat(postfix);
    (0, $5FkrB.useEffect)(function() {
        if (!ref) return;
        switch((0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(ref)){
            case 'function':
                ref(id);
                break;
            case 'object':
                ref.current = id;
                break;
            default:
                throw new Error("Unreachable case for unsupported type of ref \"".concat((0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(ref), "\""));
        }
    }, [
        id,
        ref
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).Fragment, null, typeof children === 'function' ? children({
        id: id
    }) : children);
});
function $24526c38f36cc756$export$6ee17796e3d70de2() {
    if ($24526c38f36cc756$var$react18UseId && (0, $c52fc99465dcc625$export$b40ec24ac8275656)('platform.design-system-team.react-18-use-id_mn8q4')) {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        var uid = $24526c38f36cc756$var$react18UseId();
        return function(id) {
            return "".concat(uid, "-").concat(id.toString());
        };
    }
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return (0, $b5lkZ.useUIDSeed)();
}



var $dU8Y3 = parcelRequire("dU8Y3");

/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ // Reds
var $d879fc455f6e75a0$export$4b84fd0e2c617bd = '#FFEBE6';
var $d879fc455f6e75a0$export$b34b069eff244586 = '#FFBDAD';
var $d879fc455f6e75a0$export$be802dd0d8b57f35 = '#FF8F73';
var $d879fc455f6e75a0$export$60847d42f9da92a6 = '#FF7452';
var $d879fc455f6e75a0$export$4a7404f376229999 = '#FF5630';
var $d879fc455f6e75a0$export$2010d0fb4295b346 = '#DE350B';
var $d879fc455f6e75a0$export$2837b5a1a71d5c02 = '#BF2600';
var $d879fc455f6e75a0$export$8d9596b529bbb9cf = '#FFFAE6';
var $d879fc455f6e75a0$export$41060a744ab0b7ae = '#FFF0B3';
var $d879fc455f6e75a0$export$1cc05bbbf340e559 = '#FFE380';
var $d879fc455f6e75a0$export$5aae31392d72caaa = '#FFC400';
var $d879fc455f6e75a0$export$c6930421db9fa514 = '#FFAB00';
var $d879fc455f6e75a0$export$59619663aa6500fb = '#FF991F';
var $d879fc455f6e75a0$export$874739ea9e379ab6 = '#FF8B00';
var $d879fc455f6e75a0$export$8a6341c32b6a3ee6 = '#E3FCEF';
var $d879fc455f6e75a0$export$69a3bf21b9686c2b = '#ABF5D1';
var $d879fc455f6e75a0$export$afbce1382ec95f73 = '#79F2C0';
var $d879fc455f6e75a0$export$747d86715d4175de = '#57D9A3';
var $d879fc455f6e75a0$export$940e1f69e873f202 = '#36B37E';
var $d879fc455f6e75a0$export$a49394138f7b8e85 = '#00875A';
var $d879fc455f6e75a0$export$6fa04827ac68a4fb = '#006644';
var $d879fc455f6e75a0$export$226de0355ed012f8 = '#DEEBFF';
var $d879fc455f6e75a0$export$8c13c2ee36917869 = '#B3D4FF';
var $d879fc455f6e75a0$export$ecfc1dff386a3e7a = '#4C9AFF';
var $d879fc455f6e75a0$export$215b7063051591f1 = '#2684FF';
var $d879fc455f6e75a0$export$e62e8919cca44969 = '#0065FF';
var $d879fc455f6e75a0$export$b3de0ae08da2ce64 = '#0052CC';
var $d879fc455f6e75a0$export$a6ee3d71bc067634 = '#0747A6';
var $d879fc455f6e75a0$export$67f15409e87642a1 = '#669DF1';
var $d879fc455f6e75a0$export$f0539dbc42dbb067 = '#8FB8F6';
var $d879fc455f6e75a0$export$363e4475840015bb = '#EAE6FF';
var $d879fc455f6e75a0$export$4b0a4417ed59760f = '#C0B6F2';
var $d879fc455f6e75a0$export$6011520a64d9a187 = '#998DD9';
var $d879fc455f6e75a0$export$a7175d4e9206bc80 = '#8777D9';
var $d879fc455f6e75a0$export$b48405b95304b5a1 = '#6554C0';
var $d879fc455f6e75a0$export$c71e4279dd54a18d = '#5243AA';
var $d879fc455f6e75a0$export$147899de772240ec = '#403294';
var $d879fc455f6e75a0$export$2cf711fe14c66f06 = '#E6FCFF';
var $d879fc455f6e75a0$export$7a8f4d33f6f9772c = '#B3F5FF';
var $d879fc455f6e75a0$export$776c9c497ef08533 = '#79E2F2';
var $d879fc455f6e75a0$export$69cb3ca10c1e330e = '#00C7E6';
var $d879fc455f6e75a0$export$9dc1ef0f3f48059b = '#00B8D9';
var $d879fc455f6e75a0$export$7c835c78b6fcdef8 = '#00A3BF';
var $d879fc455f6e75a0$export$6036577f95c3877e = '#008DA6';
var $d879fc455f6e75a0$export$29a4f05edc054374 = '#FFFFFF';
var $d879fc455f6e75a0$export$e655ef011c4aa1a2 = '#FAFBFC';
var $d879fc455f6e75a0$export$9fdfb749e33cdf97 = '#F4F5F7';
var $d879fc455f6e75a0$export$3e51e8f1440314ba = '#EBECF0';
var $d879fc455f6e75a0$export$1ce2d1575d444ceb = '#DFE1E6';
var $d879fc455f6e75a0$export$8754fc7e6d8b3000 = '#C1C7D0';
var $d879fc455f6e75a0$export$c2e91cbeada39b8b = '#B3BAC5';
var $d879fc455f6e75a0$export$5f71e19f3a7ad9de = '#A5ADBA';
var $d879fc455f6e75a0$export$eaa8c8a70ac22806 = '#97A0AF';
var $d879fc455f6e75a0$export$7c87d337fb91a97d = '#8993A4';
var $d879fc455f6e75a0$export$d6447c357493214f = '#7A869A';
var $d879fc455f6e75a0$export$f563ee71e9ee74cd = '#6B778C';
var $d879fc455f6e75a0$export$e2ef2124cf4024b1 = '#5E6C84';
var $d879fc455f6e75a0$export$eece5f492e429f08 = '#505F79';
var $d879fc455f6e75a0$export$c39c0fe0f26207ae = '#42526E';
var $d879fc455f6e75a0$export$7090862dc3038a9f = '#344563';
var $d879fc455f6e75a0$export$ad0bacf983b7ddaa = '#253858';
var $d879fc455f6e75a0$export$7d61b15e0da132af = '#172B4D';
var $d879fc455f6e75a0$export$fbda843f0a27fe96 = '#091E42';
var $d879fc455f6e75a0$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
var $d879fc455f6e75a0$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
var $d879fc455f6e75a0$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
var $d879fc455f6e75a0$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
var $d879fc455f6e75a0$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
var $d879fc455f6e75a0$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
var $d879fc455f6e75a0$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
var $d879fc455f6e75a0$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
var $d879fc455f6e75a0$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
var $d879fc455f6e75a0$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
var $d879fc455f6e75a0$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
var $d879fc455f6e75a0$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
var $d879fc455f6e75a0$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
var $d879fc455f6e75a0$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
var $d879fc455f6e75a0$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
var $d879fc455f6e75a0$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
var $d879fc455f6e75a0$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
var $d879fc455f6e75a0$export$2f6319cf7d736c2a = '#E6EDFA';
var $d879fc455f6e75a0$export$95126bc8884d6634 = '#DCE5F5';
var $d879fc455f6e75a0$export$8338d8c35d44ff1 = '#CED9EB';
var $d879fc455f6e75a0$export$5368d76ae4fbbda7 = '#B8C7E0';
var $d879fc455f6e75a0$export$9f0a771d16ec8d36 = '#ABBBD6';
var $d879fc455f6e75a0$export$abcf8c38338b4aa5 = '#9FB0CC';
var $d879fc455f6e75a0$export$97e81faa16a182c7 = '#8C9CB8';
var $d879fc455f6e75a0$export$bfe21c59123ecf33 = '#7988A3';
var $d879fc455f6e75a0$export$ee82aa2ea6a1558 = '#67758F';
var $d879fc455f6e75a0$export$682927c6ed76be02 = '#56637A';
var $d879fc455f6e75a0$export$91fd9994c5be9757 = '#455166';
var $d879fc455f6e75a0$export$d281fbfe3cff2df6 = '#3B475C';
var $d879fc455f6e75a0$export$3902c91d8b98a753 = '#313D52';
var $d879fc455f6e75a0$export$8e8133c1ba5845b5 = '#283447';
var $d879fc455f6e75a0$export$33ff357f6620b39 = '#202B3D';
var $d879fc455f6e75a0$export$633847cf062b69e0 = '#1B2638';
var $d879fc455f6e75a0$export$9776a6e503bdbf76 = '#121A29';
var $d879fc455f6e75a0$export$6c813d5160dff5db = '#0E1624';
var $d879fc455f6e75a0$export$3d4f271a500072a = '#0D1424';
var $d879fc455f6e75a0$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
var $d879fc455f6e75a0$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
var $d879fc455f6e75a0$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
var $d879fc455f6e75a0$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
var $d879fc455f6e75a0$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
var $d879fc455f6e75a0$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
var $d879fc455f6e75a0$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
var $d879fc455f6e75a0$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
var $d879fc455f6e75a0$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
var $d879fc455f6e75a0$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
var $d879fc455f6e75a0$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
var $d879fc455f6e75a0$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
var $d879fc455f6e75a0$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
var $d879fc455f6e75a0$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
var $d879fc455f6e75a0$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
var $d879fc455f6e75a0$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
var $d879fc455f6e75a0$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';
var $d879fc455f6e75a0$export$d2adc5dedf09fced = '#292A2E';
var $d879fc455f6e75a0$export$f51762073d2bb381 = '#94C748';
var $d879fc455f6e75a0$export$95e26d54def96891 = '#B3DF72';


/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $74Zh5 = parcelRequire("74Zh5");
// eslint-disable-next-line @atlaskit/design-system/use-visually-hidden
var $c2b3658074a39275$var$visuallyHiddenStyles = (0, $74Zh5.css)({
    width: '1px',
    height: '1px',
    padding: '0',
    position: 'absolute',
    border: '0',
    clip: 'rect(1px, 1px, 1px, 1px)',
    overflow: 'hidden',
    whiteSpace: 'nowrap'
});
/**
 * __Visually hidden__
 *
 * A composable element to apply a visually hidden effect to children.
 * Useful for accessibility compliance.
 *
 * @example
 * ```jsx
 * import VisuallyHidden from '@atlaskit/visually-hidden';
 *
 * export default () => (
 *   <div style={{ border: '1px solid black' }}>
 *      There is text hidden between the brackets [
 *      <VisuallyHidden>Can't see me!</VisuallyHidden>]
 *   </div>
 * );
 * ```
 */ var $c2b3658074a39275$var$VisuallyHidden = function VisuallyHidden(_ref) {
    var children = _ref.children, testId = _ref.testId, role = _ref.role, id = _ref.id;
    return (0, $74Zh5.jsx)("span", {
        id: id,
        "data-testid": testId,
        css: $c2b3658074a39275$var$visuallyHiddenStyles,
        role: role
    }, children);
};
var $c2b3658074a39275$export$2e2bcd8739ae039 = $c2b3658074a39275$var$VisuallyHidden;



var $5FkrB = parcelRequire("5FkrB");
var $cf7ba7cef9450939$export$4b86304b2c0d7e71 = /*#__PURE__*/ (0, $5FkrB.createContext)(undefined);
var $cf7ba7cef9450939$export$47e2c6fdb142d947 = function useSplitButtonContext() {
    var context = (0, $5FkrB.useContext)($cf7ba7cef9450939$export$4b86304b2c0d7e71);
    if (!context) return undefined;
    if (context.appearance === 'navigation') {
        var newContext = {
            spacing: 'default',
            appearance: 'subtle',
            isDisabled: false,
            isActiveOverSelected: false,
            isNavigationSplitButton: true,
            isHighlighted: context.isHighlighted
        };
        return newContext;
    }
    var splitButtonContext = {
        spacing: context.spacing,
        appearance: context.appearance,
        isDisabled: context.isDisabled,
        isActiveOverSelected: true,
        isNavigationSplitButton: false,
        isHighlighted: false
    };
    return splitButtonContext;
};


function $e55b531334fd90dc$var$abort(event) {
    event.preventDefault();
    event.stopPropagation();
}
var $e55b531334fd90dc$var$tabKeyCode = 9;
function $e55b531334fd90dc$var$onKey(event) {
    // Allowing tab so that a user can move focus away
    if (event.keyCode === $e55b531334fd90dc$var$tabKeyCode) return;
    $e55b531334fd90dc$var$abort(event);
}
function $e55b531334fd90dc$export$2e2bcd8739ae039(shouldBlockEvents, events) {
    return shouldBlockEvents ? {
        onMouseDownCapture: $e55b531334fd90dc$var$abort,
        onMouseUpCapture: $e55b531334fd90dc$var$abort,
        onKeyDownCapture: $e55b531334fd90dc$var$onKey,
        onKeyUpCapture: $e55b531334fd90dc$var$onKey,
        onTouchStartCapture: $e55b531334fd90dc$var$abort,
        onTouchEndCapture: $e55b531334fd90dc$var$abort,
        onPointerDownCapture: $e55b531334fd90dc$var$abort,
        onPointerUpCapture: $e55b531334fd90dc$var$abort,
        onClickCapture: $e55b531334fd90dc$var$abort,
        // Just smashing the existing onClick for good measure
        onClick: $e55b531334fd90dc$var$abort
    } : events;
}


var $84ce6d9f678fc045$export$d4c5499dc806c969 = ', Loading';



var $5FkrB = parcelRequire("5FkrB");
/* spinner.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $970q7 = parcelRequire("970q7");

var $5FkrB = parcelRequire("5FkrB");


var $62ad4e230a652fb5$export$4e9f1640bbe7a1a8 = {
    xsmall: 8,
    small: 16,
    medium: 24,
    large: 48,
    xlarge: 96
};


/**
 * Returns the appropriate circle stroke color.
 */ function $cd099e806837dee6$var$getStrokeColor(appearance) {
    return appearance === 'inherit' ? "var(--ds-icon-subtle, ".concat((0, $d879fc455f6e75a0$export$c39c0fe0f26207ae), ")") : "var(--ds-icon-inverse, ".concat((0, $d879fc455f6e75a0$export$29a4f05edc054374), ")");
}
var $cd099e806837dee6$var$rotate = null;
/**
 * There are three parts to the load in animation:
 * 1. Fade in
 * 2. Accelerated spin
 * 3. Stretch the spinner line
 */ var $cd099e806837dee6$var$loadIn = null;
var $cd099e806837dee6$var$styles = {
    rotateStyles: "_y44v1ozz _1pgl2qsq _8hrz1h6o",
    loadInStyles: "_y44v1a7z _1o51q7pw _tzy4idpf",
    wrapperStyles: "_1e0c116y _s7n4nkob",
    circleStyles: "_lswuglyw _7ljx1dhp _opj11kw7 _134c892t _1snbbs82 _jcxd7g3v _1tjm1onz"
};
/**
 * `useLayoutEffect` is being used in SSR safe form. On the server, this work doesn’t need to run.
 * `useEffect` is used in-place, because `useEffect` is not run on the server and it matches types
 * which makes things simpler than doing an `isServer` check or a `null` check.
 *
 * @see https://hello.atlassian.net/wiki/spaces/DST/pages/2081696628/DSTDACI-010+-+Interaction+Tracing+hooks+in+DS+components
 */ var $cd099e806837dee6$var$useLayoutEffect = typeof window === 'undefined' ? (0, $5FkrB.useEffect) : (0, $5FkrB.useLayoutEffect);
/**
 * __Spinner__
 *
 * A spinner is an animated spinning icon that lets users know content is being loaded.
 *
 * - [Examples](https://atlassian.design/components/spinner/examples)
 * - [Code](https://atlassian.design/components/spinner/code)
 * - [Usage](https://atlassian.design/components/spinner/usage)
 */ var $cd099e806837dee6$var$Spinner = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).forwardRef(function Spinner(_ref, ref) {
    var _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'inherit' : _ref$appearance, _ref$delay = _ref.delay, delay = _ref$delay === void 0 ? 0 : _ref$delay, interactionName = _ref.interactionName, label = _ref.label, _ref$size = _ref.size, providedSize = _ref$size === void 0 ? 'medium' : _ref$size, testId = _ref.testId;
    var size = typeof providedSize === 'number' ? providedSize : (0, $62ad4e230a652fb5$export$4e9f1640bbe7a1a8)[providedSize];
    var animationDelay = "".concat(delay, "ms");
    var stroke = $cd099e806837dee6$var$getStrokeColor(appearance);
    var context = (0, $5FkrB.useContext)((0, $6aca23134cc0dc0c$export$2e2bcd8739ae039));
    $cd099e806837dee6$var$useLayoutEffect(function() {
        if (context != null) return context.hold(interactionName);
    }, [
        context,
        interactionName
    ]);
    /**
   * The Spinner animation uses a combination of two
   * css animations on two separate elements.
   */ return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("span", {
        "data-testid": testId ? "".concat(testId, "-wrapper") : 'spinner-wrapper',
        style: {
            animationDelay: animationDelay,
            width: size,
            height: size
        },
        className: (0, $970q7.default)([
            $cd099e806837dee6$var$styles.wrapperStyles,
            $cd099e806837dee6$var$styles.rotateStyles
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("svg", {
        height: size,
        width: size,
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg",
        "data-testid": testId,
        ref: ref,
        "aria-label": label || undefined,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            animationDelay: animationDelay
        },
        role: label ? 'img' : 'none',
        className: (0, $970q7.default)([
            $cd099e806837dee6$var$styles.loadInStyles
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("circle", {
        cx: "8",
        cy: "8",
        r: "7",
        style: {
            stroke: stroke
        },
        className: (0, $970q7.default)([
            $cd099e806837dee6$var$styles.circleStyles
        ])
    })));
}));
var $cd099e806837dee6$export$2e2bcd8739ae039 = $cd099e806837dee6$var$Spinner;


function $f9596edbd527292a$var$getIconSpacing(spacing) {
    switch(spacing){
        case 'compact':
            return 'small';
        default:
            return 'medium';
    }
}
function $f9596edbd527292a$var$getSpinnerAppearance(_ref) {
    var appearance = _ref.appearance, isDisabled = _ref.isDisabled, isSelected = _ref.isSelected;
    if (isDisabled || isSelected) return 'inherit';
    if (appearance === 'primary' || appearance === 'danger' || appearance === 'discovery') return 'invert';
    return 'inherit';
}
function $f9596edbd527292a$export$2e2bcd8739ae039(_ref2) {
    var appearance = _ref2.appearance, spacing = _ref2.spacing, isDisabled = _ref2.isDisabled, isSelected = _ref2.isSelected, testId = _ref2.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $cd099e806837dee6$export$2e2bcd8739ae039), {
        size: $f9596edbd527292a$var$getIconSpacing(spacing),
        appearance: $f9596edbd527292a$var$getSpinnerAppearance({
            appearance: appearance,
            isDisabled: isDisabled,
            isSelected: isSelected
        }),
        testId: testId ? "".concat(testId, "--loading-spinner") : undefined
    });
}


function $8eb35ff6fdad60aa$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $8eb35ff6fdad60aa$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $8eb35ff6fdad60aa$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $8eb35ff6fdad60aa$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
// If updating `buttonStyles`, also update `buttonStylesWithRem`.
var $8eb35ff6fdad60aa$var$buttonStyles = (0, $a8477e78427cc4b7$export$f6c783d06584602c)({
    display: 'inline-flex',
    boxSizing: 'border-box',
    width: 'auto',
    maxWidth: '100%',
    position: 'relative',
    alignItems: 'baseline',
    justifyContent: 'center',
    columnGap: 'space.050',
    borderRadius: 'border.radius.100',
    borderWidth: 'border.width.0',
    flexShrink: 0,
    height: "".concat(32 / 14, "em"),
    font: 'font.body',
    fontWeight: 'font.weight.medium',
    paddingBlock: 'space.075',
    paddingInlineEnd: 'space.150',
    paddingInlineStart: 'space.150',
    textAlign: 'center',
    transition: 'background 0.1s ease-out',
    verticalAlign: 'middle',
    '::after': {
        borderRadius: 'inherit',
        inset: 'space.0',
        borderStyle: 'solid',
        borderWidth: "var(--ds-border-width, 1px)",
        pointerEvents: 'none',
        position: 'absolute'
    }
});
var $8eb35ff6fdad60aa$var$buttonStylesWithRem = (0, $a8477e78427cc4b7$export$f6c783d06584602c)({
    display: 'inline-flex',
    boxSizing: 'border-box',
    width: 'auto',
    maxWidth: '100%',
    position: 'relative',
    alignItems: 'baseline',
    justifyContent: 'center',
    columnGap: 'space.050',
    borderRadius: 'border.radius.100',
    borderWidth: 'border.width.0',
    flexShrink: 0,
    height: '2rem',
    font: 'font.body',
    fontWeight: 'font.weight.medium',
    paddingBlock: 'space.075',
    paddingInlineEnd: 'space.150',
    paddingInlineStart: 'space.150',
    textAlign: 'center',
    transition: 'background 0.1s ease-out',
    verticalAlign: 'middle',
    '::after': {
        borderRadius: 'inherit',
        inset: 'space.0',
        borderStyle: 'solid',
        borderWidth: "var(--ds-border-width, 1px)",
        pointerEvents: 'none',
        position: 'absolute'
    }
});
var $8eb35ff6fdad60aa$var$defaultInteractiveStyles = (0, $a8477e78427cc4b7$export$f6c783d06584602c)({
    ':hover': {
        background: "var(--ds-background-neutral-hovered, #091e4214)",
        // @ts-expect-error
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        color: "var(--ds-text, ".concat($d879fc455f6e75a0$export$c39c0fe0f26207ae, ")")
    },
    ':active': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        background: "var(--ds-background-neutral-pressed, ".concat($d879fc455f6e75a0$export$8c13c2ee36917869, ")"),
        // @ts-expect-error
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        color: "var(--ds-text, ".concat($d879fc455f6e75a0$export$b3de0ae08da2ce64, ")")
    }
});
var $8eb35ff6fdad60aa$var$defaultInteractiveRefreshedStyles = (0, $a8477e78427cc4b7$export$f6c783d06584602c)({
    ':hover': {
        background: "var(--ds-background-neutral-subtle-hovered, #091E420F)",
        color: 'color.text.subtle'
    },
    ':active': {
        background: "var(--ds-background-neutral-subtle-pressed, #091E4224)",
        color: 'color.text.subtle'
    }
});
var $8eb35ff6fdad60aa$var$defaultStyles = (0, $a8477e78427cc4b7$export$f6c783d06584602c)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
    background: "var(--ds-background-neutral, ".concat($d879fc455f6e75a0$export$8d43898f60b96a82, ")"),
    // @ts-expect-error — using tokens for explicit fallback usage.
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values --  -- Ignored via go/DSP-18766
    color: "var(--ds-text, ".concat($d879fc455f6e75a0$export$c39c0fe0f26207ae, ")"),
    ':visited': {
        // @ts-expect-error
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        color: "var(--ds-text, ".concat($d879fc455f6e75a0$export$c39c0fe0f26207ae, ")")
    }
});
var $8eb35ff6fdad60aa$var$defaultRefreshedStyles = (0, $a8477e78427cc4b7$export$f6c783d06584602c)({
    background: "var(--ds-background-neutral-subtle, #00000000)",
    color: 'color.text.subtle',
    '::after': {
        content: '""',
        borderColor: 'color.border'
    },
    ':visited': {
        color: 'color.text.subtle'
    }
});
var $8eb35ff6fdad60aa$var$primaryStyles = (0, $a8477e78427cc4b7$export$f6c783d06584602c)({
    background: "var(--ds-background-brand-bold, #0052CC)",
    // @ts-expect-error
    color: "var(--ds-text-inverse, #FFFFFF)",
    ':visited': {
        // @ts-expect-error
        color: "var(--ds-text-inverse, #FFFFFF)"
    }
});
var $8eb35ff6fdad60aa$var$primaryInteractiveStyles = (0, $a8477e78427cc4b7$export$f6c783d06584602c)({
    ':hover': {
        // @ts-expect-error
        color: "var(--ds-text-inverse, #FFFFFF)",
        background: "var(--ds-background-brand-bold-hovered, #0065FF)"
    },
    ':active': {
        // @ts-expect-error
        color: "var(--ds-text-inverse, #FFFFFF)",
        background: "var(--ds-background-brand-bold-pressed, #0747A6)"
    }
});
var $8eb35ff6fdad60aa$var$warningStyles = (0, $a8477e78427cc4b7$export$f6c783d06584602c)({
    background: "var(--ds-background-warning-bold, #FFAB00)",
    // @ts-expect-error
    color: "var(--ds-text-warning-inverse, #172B4D)",
    ':visited': {
        // @ts-expect-error
        color: "var(--ds-text-warning-inverse, #172B4D)"
    }
});
var $8eb35ff6fdad60aa$var$warningInteractiveStyles = (0, $a8477e78427cc4b7$export$f6c783d06584602c)({
    ':hover': {
        // @ts-expect-error
        color: "var(--ds-text-warning-inverse, #172B4D)",
        background: "var(--ds-background-warning-bold-hovered, #FFC400)"
    },
    ':active': {
        // @ts-expect-error
        color: "var(--ds-text-warning-inverse, #172B4D)",
        background: "var(--ds-background-warning-bold-pressed, #FF991F)"
    }
});
var $8eb35ff6fdad60aa$var$dangerStyles = (0, $a8477e78427cc4b7$export$f6c783d06584602c)({
    background: "var(--ds-background-danger-bold, #DE350B)",
    color: 'color.text.inverse',
    ':visited': {
        color: 'color.text.inverse'
    }
});
var $8eb35ff6fdad60aa$var$dangerInteractiveStyles = (0, $a8477e78427cc4b7$export$f6c783d06584602c)({
    ':hover': {
        color: 'color.text.inverse',
        background: "var(--ds-background-danger-bold-hovered, #FF5630)"
    },
    ':active': {
        color: 'color.text.inverse',
        background: "var(--ds-background-danger-bold-pressed, #BF2600)"
    }
});
var $8eb35ff6fdad60aa$var$discoveryStyles = (0, $a8477e78427cc4b7$export$f6c783d06584602c)({
    background: "var(--ds-background-discovery-bold, #5243AA)",
    color: 'color.text.inverse',
    ':visited': {
        color: 'color.text.inverse'
    }
});
var $8eb35ff6fdad60aa$var$discoveryInteractiveStyles = (0, $a8477e78427cc4b7$export$f6c783d06584602c)({
    ':hover': {
        color: 'color.text.inverse',
        background: "var(--ds-background-discovery-bold-hovered, #8777D9)"
    },
    ':active': {
        color: 'color.text.inverse',
        background: "var(--ds-background-discovery-bold-pressed, #5243AA)"
    }
});
var $8eb35ff6fdad60aa$var$subtleStyles = (0, $a8477e78427cc4b7$export$f6c783d06584602c)({
    background: "var(--ds-background-neutral-subtle, transparent)",
    // @ts-expect-error
    color: "var(--ds-text, #42526E)",
    ':visited': {
        // @ts-expect-error
        color: "var(--ds-text, #42526E)"
    }
});
var $8eb35ff6fdad60aa$var$subtleRefreshedStyles = (0, $a8477e78427cc4b7$export$f6c783d06584602c)({
    background: "var(--ds-background-neutral-subtle, transparent)",
    color: 'color.text.subtle',
    ':visited': {
        color: 'color.text.subtle'
    }
});
var $8eb35ff6fdad60aa$var$subtleInteractiveStyles = (0, $a8477e78427cc4b7$export$f6c783d06584602c)({
    ':hover': {
        background: "var(--ds-background-neutral-subtle-hovered, #091e4214)",
        // @ts-expect-error
        color: "var(--ds-text, #42526E)"
    },
    ':active': {
        background: "var(--ds-background-neutral-subtle-pressed, #B3D4FF)",
        // @ts-expect-error
        color: "var(--ds-text, #42526E)"
    }
});
var $8eb35ff6fdad60aa$var$subtleInteractiveRefreshedStyles = (0, $a8477e78427cc4b7$export$f6c783d06584602c)({
    ':hover': {
        background: "var(--ds-background-neutral-subtle-hovered, #091e4214)",
        color: 'color.text.subtle'
    },
    ':active': {
        background: "var(--ds-background-neutral-subtle-pressed, #B3D4FF)",
        color: 'color.text.subtle'
    }
});
// Required due to Jira's AUI CSS reset: https://product-fabric.atlassian.net/browse/DSP-15687
var $8eb35ff6fdad60aa$var$linkDecorationUnsetStyles = (0, $a8477e78427cc4b7$export$f6c783d06584602c)({
    textDecoration: 'none',
    ':hover': {
        textDecoration: 'none'
    },
    ':active': {
        textDecoration: 'none'
    },
    ':focus': {
        textDecoration: 'none'
    }
});
var $8eb35ff6fdad60aa$var$disabledStyles = (0, $a8477e78427cc4b7$export$f6c783d06584602c)({
    cursor: 'not-allowed',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    background: "var(--ds-background-disabled, ".concat($d879fc455f6e75a0$export$8d43898f60b96a82, ")"),
    // @ts-expect-error
    color: "var(--ds-text-disabled, #091E424F)",
    ':hover': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        background: "var(--ds-background-disabled, ".concat($d879fc455f6e75a0$export$8d43898f60b96a82, ")"),
        // @ts-expect-error
        color: "var(--ds-text-disabled, #091E424F)"
    },
    ':active': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        background: "var(--ds-background-disabled, ".concat($d879fc455f6e75a0$export$8d43898f60b96a82, ")"),
        // @ts-expect-error
        color: "var(--ds-text-disabled, #091E424F)"
    },
    '::after': {
        content: 'none'
    }
});
var $8eb35ff6fdad60aa$var$selectedStyles = (0, $a8477e78427cc4b7$export$f6c783d06584602c)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    background: "var(--ds-background-selected, ".concat($d879fc455f6e75a0$export$ad0bacf983b7ddaa, ")"),
    // @ts-expect-error
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    color: "var(--ds-text-selected, ".concat($d879fc455f6e75a0$export$9fdfb749e33cdf97, ")"),
    ':visited': {
        // @ts-expect-error
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        color: "var(--ds-text-selected, ".concat($d879fc455f6e75a0$export$9fdfb749e33cdf97, ")")
    }
});
var $8eb35ff6fdad60aa$var$selectedRefreshedStyles = (0, $a8477e78427cc4b7$export$f6c783d06584602c)({
    background: "var(--ds-background-selected, #E9F2FF)",
    color: 'color.text.selected',
    '::after': {
        content: '""',
        borderColor: 'color.border.selected'
    },
    ':visited': {
        color: 'color.text.selected'
    }
});
var $8eb35ff6fdad60aa$var$selectedInsideSplitButtonStyles = (0, $a8477e78427cc4b7$export$f6c783d06584602c)({
    // This is 2 so it appears above the split button divider when selected.
    // See split-button.tsx.
    // @ts-expect-error — We need a local zindex just for button.
    zIndex: 2
});
var $8eb35ff6fdad60aa$var$selectedInteractiveStyles = (0, $a8477e78427cc4b7$export$f6c783d06584602c)({
    ':hover': {
        // @ts-expect-error
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        color: "var(--ds-text-selected, ".concat($d879fc455f6e75a0$export$9fdfb749e33cdf97, ")"),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        background: "var(--ds-background-selected-hovered, ".concat($d879fc455f6e75a0$export$ad0bacf983b7ddaa, ")")
    },
    ':active': {
        // @ts-expect-error
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        color: "var(--ds-text-selected, ".concat($d879fc455f6e75a0$export$9fdfb749e33cdf97, ")"),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        background: "var(--ds-background-selected-pressed, ".concat($d879fc455f6e75a0$export$ad0bacf983b7ddaa, ")")
    }
});
// TODO: Remove me once we kill color fallbacks
var $8eb35ff6fdad60aa$var$selectedWarningStyles = (0, $a8477e78427cc4b7$export$f6c783d06584602c)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    background: "var(--ds-background-selected, ".concat($d879fc455f6e75a0$export$59619663aa6500fb, ")"),
    // @ts-expect-error
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    color: "var(--ds-text-selected, ".concat($d879fc455f6e75a0$export$7d61b15e0da132af, ")"),
    ':hover': {
        // @ts-expect-error
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        color: "var(--ds-text-selected, ".concat($d879fc455f6e75a0$export$9fdfb749e33cdf97, ")"),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        background: "var(--ds-background-selected, ".concat($d879fc455f6e75a0$export$59619663aa6500fb, ")")
    },
    ':active': {
        // @ts-expect-error
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        color: "var(--ds-text-selected, ".concat($d879fc455f6e75a0$export$9fdfb749e33cdf97, ")"),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        background: "var(--ds-background-selected, ".concat($d879fc455f6e75a0$export$59619663aa6500fb, ")")
    }
});
// TODO: Remove me once we kill color fallbacks
var $8eb35ff6fdad60aa$var$selectedDangerStyles = (0, $a8477e78427cc4b7$export$f6c783d06584602c)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    background: "var(--ds-background-selected, ".concat($d879fc455f6e75a0$export$2837b5a1a71d5c02, ")"),
    // @ts-expect-error
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    color: "var(--ds-text-selected, ".concat($d879fc455f6e75a0$export$9fdfb749e33cdf97, ")"),
    ':hover': {
        // @ts-expect-error
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        color: "var(--ds-text-selected, ".concat($d879fc455f6e75a0$export$9fdfb749e33cdf97, ")"),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        background: "var(--ds-background-selected, ".concat($d879fc455f6e75a0$export$2837b5a1a71d5c02, ")")
    },
    ':active': {
        // @ts-expect-error
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        color: "var(--ds-text-selected, ".concat($d879fc455f6e75a0$export$9fdfb749e33cdf97, ")"),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        background: "var(--ds-background-selected, ".concat($d879fc455f6e75a0$export$2837b5a1a71d5c02, ")")
    }
});
// TODO: Remove me once we kill color fallbacks
var $8eb35ff6fdad60aa$var$selectedDiscoveryStyles = (0, $a8477e78427cc4b7$export$f6c783d06584602c)({
    background: "var(--ds-background-selected, #403294)",
    // @ts-expect-error
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    color: "var(--ds-text-selected, ".concat($d879fc455f6e75a0$export$9fdfb749e33cdf97, ")"),
    ':hover': {
        // @ts-expect-error
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        color: "var(--ds-text-selected, ".concat($d879fc455f6e75a0$export$9fdfb749e33cdf97, ")"),
        background: "var(--ds-background-selected, #403294)"
    },
    ':active': {
        // @ts-expect-error
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        color: "var(--ds-text-selected, ".concat($d879fc455f6e75a0$export$9fdfb749e33cdf97, ")"),
        background: "var(--ds-background-selected, #403294)"
    }
});
// If updating `spacingCompactStyles`, also update `spacingCompactStylesWithRem`.
var $8eb35ff6fdad60aa$var$spacingCompactStyles = (0, $a8477e78427cc4b7$export$f6c783d06584602c)({
    columnGap: 'space.050',
    height: "".concat(24 / 14, "em"),
    paddingBlock: 'space.025',
    paddingInlineEnd: 'space.150',
    paddingInlineStart: 'space.150',
    verticalAlign: 'middle'
});
var $8eb35ff6fdad60aa$var$spacingCompactStylesWithRem = (0, $a8477e78427cc4b7$export$f6c783d06584602c)({
    columnGap: 'space.050',
    height: '1.5rem',
    paddingBlock: 'space.025',
    paddingInlineEnd: 'space.150',
    paddingInlineStart: 'space.150',
    verticalAlign: 'middle'
});
var $8eb35ff6fdad60aa$var$circleStyles = (0, $a8477e78427cc4b7$export$f6c783d06584602c)({
    borderRadius: 'border.radius.circle'
});
var $8eb35ff6fdad60aa$var$fullWidthStyles = (0, $a8477e78427cc4b7$export$f6c783d06584602c)({
    width: '100%'
});
var $8eb35ff6fdad60aa$var$loadingStyles = (0, $a8477e78427cc4b7$export$f6c783d06584602c)({
    cursor: 'progress'
});
// If updating `iconButtonStyles`, also update `iconButtonStylesWithRem`.
var $8eb35ff6fdad60aa$var$iconButtonStyles = (0, $a8477e78427cc4b7$export$f6c783d06584602c)({
    height: "".concat(32 / 14, "em"),
    width: "".concat(32 / 14, "em"),
    paddingInlineEnd: 'space.0',
    paddingInlineStart: 'space.0'
});
var $8eb35ff6fdad60aa$var$iconButtonStylesWithRem = (0, $a8477e78427cc4b7$export$f6c783d06584602c)({
    height: '2rem',
    width: '2rem',
    paddingInlineEnd: 'space.0',
    paddingInlineStart: 'space.0'
});
// If updating `iconButtonCompactStyles`, also update `iconButtonCompactStylesWithRem`.
var $8eb35ff6fdad60aa$var$iconButtonCompactStyles = (0, $a8477e78427cc4b7$export$f6c783d06584602c)({
    width: "".concat(24 / 14, "em"),
    height: "".concat(24 / 14, "em")
});
var $8eb35ff6fdad60aa$var$iconButtonCompactStylesWithRem = (0, $a8477e78427cc4b7$export$f6c783d06584602c)({
    width: '1.5rem',
    height: '1.5rem'
});
var $8eb35ff6fdad60aa$var$buttonIconBeforeStyles = (0, $a8477e78427cc4b7$export$f6c783d06584602c)({
    paddingInlineStart: 'space.100'
});
var $8eb35ff6fdad60aa$var$buttonIconAfterStyles = (0, $a8477e78427cc4b7$export$f6c783d06584602c)({
    paddingInlineEnd: 'space.100'
});
var $8eb35ff6fdad60aa$var$splitButtonStyles = (0, $a8477e78427cc4b7$export$f6c783d06584602c)({
    ':focus-visible': {
        zIndex: 'card'
    }
});
var $8eb35ff6fdad60aa$var$navigationSplitButtonStyles = (0, $a8477e78427cc4b7$export$f6c783d06584602c)({
    width: '24px',
    backgroundColor: 'color.background.neutral.subtle',
    paddingInlineEnd: 'space.075',
    paddingInlineStart: 'space.075'
});
var $8eb35ff6fdad60aa$var$loadingOverlayStyles = (0, $a8477e78427cc4b7$export$f6c783d06584602c)({
    display: 'flex',
    position: 'absolute',
    alignItems: 'center',
    justifyContent: 'center',
    insetBlockEnd: 'space.0',
    insetBlockStart: 'space.0',
    insetInlineEnd: 'space.0',
    insetInlineStart: 'space.0'
});
/**
 * __Use button base__
 *
 * A React hook that accepts a set of common Button props,
 * and processes them to return consistent base props for usage
 * across various Button components.
 *
 * It also:
 * - Implements auto focus when enabled.
 * - Appends the `onClick` event with UFO analytics tracking.
 *
 * @private
 */ var $8eb35ff6fdad60aa$var$useButtonBase = function useButtonBase(_ref) {
    var _ref$appearance = _ref.appearance, propAppearance = _ref$appearance === void 0 ? 'default' : _ref$appearance, _ref$autoFocus = _ref.autoFocus, autoFocus = _ref$autoFocus === void 0 ? false : _ref$autoFocus, _ref$isDisabled = _ref.isDisabled, propIsDisabled = _ref$isDisabled === void 0 ? false : _ref$isDisabled, _ref$isLoading = _ref.isLoading, isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading, _ref$isSelected = _ref.isSelected, propIsSelected = _ref$isSelected === void 0 ? false : _ref$isSelected, _ref$isIconButton = _ref.isIconButton, isIconButton = _ref$isIconButton === void 0 ? false : _ref$isIconButton, _ref$isCircle = _ref.isCircle, isCircle = _ref$isCircle === void 0 ? false : _ref$isCircle, _ref$hasIconBefore = _ref.hasIconBefore, hasIconBefore = _ref$hasIconBefore === void 0 ? false : _ref$hasIconBefore, _ref$hasIconAfter = _ref.hasIconAfter, hasIconAfter = _ref$hasIconAfter === void 0 ? false : _ref$hasIconAfter, children = _ref.children, onClick = _ref.onClick, onMouseDownCapture = _ref.onMouseDownCapture, onMouseUpCapture = _ref.onMouseUpCapture, onKeyDownCapture = _ref.onKeyDownCapture, onKeyUpCapture = _ref.onKeyUpCapture, onTouchStartCapture = _ref.onTouchStartCapture, onTouchEndCapture = _ref.onTouchEndCapture, onPointerDownCapture = _ref.onPointerDownCapture, onPointerUpCapture = _ref.onPointerUpCapture, onClickCapture = _ref.onClickCapture, ref = _ref.ref, _ref$shouldFitContain = _ref.shouldFitContainer, shouldFitContainer = _ref$shouldFitContain === void 0 ? false : _ref$shouldFitContain, _ref$spacing = _ref.spacing, propSpacing = _ref$spacing === void 0 ? 'default' : _ref$spacing, testId = _ref.testId, ariaLabel = _ref.ariaLabel, ariaLabelledBy = _ref.ariaLabelledBy;
    var localRef = (0, $5FkrB.useRef)(null);
    var splitButtonContext = (0, $cf7ba7cef9450939$export$47e2c6fdb142d947)();
    var loadingLabelId = (0, $24526c38f36cc756$export$f680877a34711e37)();
    var isSplitButton = Boolean(splitButtonContext);
    var isNavigationSplitButton = (splitButtonContext === null || splitButtonContext === void 0 ? void 0 : splitButtonContext.isNavigationSplitButton) || false;
    var isDefaultAppearanceSplitButton = (splitButtonContext === null || splitButtonContext === void 0 ? void 0 : splitButtonContext.appearance) === 'default';
    var appearance = isDefaultAppearanceSplitButton && (0, $dU8Y3.fg)('platform-component-visual-refresh') ? 'subtle' : (splitButtonContext === null || splitButtonContext === void 0 ? void 0 : splitButtonContext.appearance) || propAppearance;
    var spacing = (splitButtonContext === null || splitButtonContext === void 0 ? void 0 : splitButtonContext.spacing) || propSpacing;
    var isDisabled = (splitButtonContext === null || splitButtonContext === void 0 ? void 0 : splitButtonContext.isDisabled) || propIsDisabled;
    var isInteractive = !isDisabled && !isLoading;
    // Also treat loading buttons as disabled
    var isEffectivelyDisabled = isDisabled || isLoading;
    var isSelected = propIsSelected && !isDisabled;
    (0, $65ad6b2d82b5101d$export$2e2bcd8739ae039)(localRef, autoFocus);
    return $8eb35ff6fdad60aa$var$_objectSpread({
        ref: (0, $0d2a37110e22a1c9$export$2e2bcd8739ae039)([
            localRef,
            ref
        ]),
        xcss: [
            (0, $dU8Y3.fg)('platform_dst_button_replace_em_with_rem') ? $8eb35ff6fdad60aa$var$buttonStylesWithRem : $8eb35ff6fdad60aa$var$buttonStyles,
            appearance === 'default' && ((0, $dU8Y3.fg)('platform-component-visual-refresh') ? $8eb35ff6fdad60aa$var$defaultRefreshedStyles : $8eb35ff6fdad60aa$var$defaultStyles),
            appearance === 'default' && isInteractive && ((0, $dU8Y3.fg)('platform-component-visual-refresh') ? $8eb35ff6fdad60aa$var$defaultInteractiveRefreshedStyles : $8eb35ff6fdad60aa$var$defaultInteractiveStyles),
            appearance === 'primary' && $8eb35ff6fdad60aa$var$primaryStyles,
            appearance === 'primary' && isInteractive && $8eb35ff6fdad60aa$var$primaryInteractiveStyles,
            appearance === 'warning' && $8eb35ff6fdad60aa$var$warningStyles,
            appearance === 'warning' && isInteractive && $8eb35ff6fdad60aa$var$warningInteractiveStyles,
            appearance === 'danger' && $8eb35ff6fdad60aa$var$dangerStyles,
            appearance === 'danger' && isInteractive && $8eb35ff6fdad60aa$var$dangerInteractiveStyles,
            appearance === 'discovery' && $8eb35ff6fdad60aa$var$discoveryStyles,
            appearance === 'discovery' && isInteractive && $8eb35ff6fdad60aa$var$discoveryInteractiveStyles,
            appearance === 'subtle' && ((0, $dU8Y3.fg)('platform-component-visual-refresh') ? $8eb35ff6fdad60aa$var$subtleRefreshedStyles : $8eb35ff6fdad60aa$var$subtleStyles),
            appearance === 'subtle' && isInteractive && ((0, $dU8Y3.fg)('platform-component-visual-refresh') ? $8eb35ff6fdad60aa$var$subtleInteractiveRefreshedStyles : $8eb35ff6fdad60aa$var$subtleInteractiveStyles),
            $8eb35ff6fdad60aa$var$linkDecorationUnsetStyles,
            isSelected && ((0, $dU8Y3.fg)('platform-component-visual-refresh') ? $8eb35ff6fdad60aa$var$selectedRefreshedStyles : $8eb35ff6fdad60aa$var$selectedStyles),
            isSelected && isSplitButton && $8eb35ff6fdad60aa$var$selectedInsideSplitButtonStyles,
            isSelected && isInteractive && $8eb35ff6fdad60aa$var$selectedInteractiveStyles,
            // TODO: remove me once we kill color fallbacks
            isSelected && appearance === 'danger' && $8eb35ff6fdad60aa$var$selectedDangerStyles,
            // TODO: remove me once we kill color fallbacks
            isSelected && appearance === 'warning' && $8eb35ff6fdad60aa$var$selectedWarningStyles,
            // TODO: remove me once we kill color fallbacks
            isSelected && appearance === 'discovery' && $8eb35ff6fdad60aa$var$selectedDiscoveryStyles,
            isDisabled && $8eb35ff6fdad60aa$var$disabledStyles,
            isCircle && !isSplitButton && $8eb35ff6fdad60aa$var$circleStyles,
            spacing === 'compact' && ((0, $dU8Y3.fg)('platform_dst_button_replace_em_with_rem') ? $8eb35ff6fdad60aa$var$spacingCompactStylesWithRem : $8eb35ff6fdad60aa$var$spacingCompactStyles),
            hasIconBefore && $8eb35ff6fdad60aa$var$buttonIconBeforeStyles,
            hasIconAfter && $8eb35ff6fdad60aa$var$buttonIconAfterStyles,
            isIconButton && ((0, $dU8Y3.fg)('platform_dst_button_replace_em_with_rem') ? $8eb35ff6fdad60aa$var$iconButtonStylesWithRem : $8eb35ff6fdad60aa$var$iconButtonStyles),
            isIconButton && spacing === 'compact' && ((0, $dU8Y3.fg)('platform_dst_button_replace_em_with_rem') ? $8eb35ff6fdad60aa$var$iconButtonCompactStylesWithRem : $8eb35ff6fdad60aa$var$iconButtonCompactStyles),
            shouldFitContainer && $8eb35ff6fdad60aa$var$fullWidthStyles,
            isLoading && $8eb35ff6fdad60aa$var$loadingStyles,
            isSplitButton && $8eb35ff6fdad60aa$var$splitButtonStyles,
            isNavigationSplitButton && $8eb35ff6fdad60aa$var$navigationSplitButtonStyles
        ],
        isDisabled: isEffectivelyDisabled,
        children: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $cf7ba7cef9450939$export$4b86304b2c0d7e71).Provider, {
            value: undefined
        }, children, isLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $d007f17589e0f9b9$export$2e2bcd8739ae039), {
            as: "span",
            xcss: $8eb35ff6fdad60aa$var$loadingOverlayStyles
        }, (0, $f9596edbd527292a$export$2e2bcd8739ae039)({
            spacing: spacing,
            appearance: appearance,
            isDisabled: isDisabled,
            isSelected: isSelected,
            testId: testId
        })) : null, isLoading && (children && !ariaLabel && !ariaLabelledBy || ariaLabelledBy) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $c2b3658074a39275$export$2e2bcd8739ae039), {
            id: loadingLabelId
        }, (0, $84ce6d9f678fc045$export$d4c5499dc806c969))),
        'aria-label': isLoading && ariaLabel && !ariaLabelledBy ? "".concat(ariaLabel, " ").concat((0, $84ce6d9f678fc045$export$d4c5499dc806c969)) : ariaLabel,
        'aria-labelledby': isLoading && ariaLabelledBy ? "".concat(ariaLabelledBy, " ").concat(loadingLabelId) : ariaLabelledBy
    }, (0, $e55b531334fd90dc$export$2e2bcd8739ae039)(isEffectivelyDisabled, {
        onClick: onClick,
        onMouseDownCapture: onMouseDownCapture,
        onMouseUpCapture: onMouseUpCapture,
        onKeyDownCapture: onKeyDownCapture,
        onKeyUpCapture: onKeyUpCapture,
        onTouchStartCapture: onTouchStartCapture,
        onTouchEndCapture: onTouchEndCapture,
        onPointerDownCapture: onPointerDownCapture,
        onPointerUpCapture: onPointerUpCapture,
        onClickCapture: onClickCapture
    }));
};
var $8eb35ff6fdad60aa$export$2e2bcd8739ae039 = $8eb35ff6fdad60aa$var$useButtonBase;


/**
 * __Use default button base__
 *
 * A React hook that accepts a set of default Button props,
 * and processes them to return consistent base props for usage
 * across Button and LinkButton variants.
 *
 * @private
 */ var $0eb17ca5f07eb9cf$var$useDefaultButton = function useDefaultButton(_ref) {
    var analyticsContext = _ref.analyticsContext, appearance = _ref.appearance, ariaLabel = _ref.ariaLabel, ariaLabelledBy = _ref.ariaLabelledBy, autoFocus = _ref.autoFocus, buttonType = _ref.buttonType, children = _ref.children, iconAfter = _ref.iconAfter, iconBefore = _ref.iconBefore, interactionName = _ref.interactionName, isDisabled = _ref.isDisabled, _ref$isLoading = _ref.isLoading, isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading, isSelected = _ref.isSelected, onClick = _ref.onClick, onClickCapture = _ref.onClickCapture, onKeyDownCapture = _ref.onKeyDownCapture, onKeyUpCapture = _ref.onKeyUpCapture, onMouseDownCapture = _ref.onMouseDownCapture, onMouseUpCapture = _ref.onMouseUpCapture, onPointerDownCapture = _ref.onPointerDownCapture, onPointerUpCapture = _ref.onPointerUpCapture, onTouchEndCapture = _ref.onTouchEndCapture, onTouchStartCapture = _ref.onTouchStartCapture, ref = _ref.ref, shouldFitContainer = _ref.shouldFitContainer, spacing = _ref.spacing, testId = _ref.testId;
    var baseProps = (0, $8eb35ff6fdad60aa$export$2e2bcd8739ae039)({
        analyticsContext: analyticsContext,
        appearance: appearance,
        autoFocus: autoFocus,
        ariaLabel: ariaLabel,
        ariaLabelledBy: ariaLabelledBy,
        buttonType: buttonType,
        children: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $5FkrB.Fragment), null, iconBefore && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $301b23ec1b0d3f05$export$2e2bcd8739ae039), {
            type: "icon",
            position: "before",
            isLoading: isLoading
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $a2bbd318f52424a1$export$2e2bcd8739ae039), {
            icon: iconBefore
        })), children && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $301b23ec1b0d3f05$export$2e2bcd8739ae039), {
            isLoading: isLoading
        }, children), iconAfter && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $301b23ec1b0d3f05$export$2e2bcd8739ae039), {
            type: "icon",
            position: "after",
            isLoading: isLoading
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $a2bbd318f52424a1$export$2e2bcd8739ae039), {
            icon: iconAfter
        }))),
        interactionName: interactionName,
        isDisabled: isDisabled,
        isLoading: isLoading,
        isSelected: isSelected,
        onClick: onClick,
        onMouseDownCapture: onMouseDownCapture,
        onMouseUpCapture: onMouseUpCapture,
        onKeyDownCapture: onKeyDownCapture,
        onKeyUpCapture: onKeyUpCapture,
        onTouchStartCapture: onTouchStartCapture,
        onTouchEndCapture: onTouchEndCapture,
        onPointerDownCapture: onPointerDownCapture,
        onPointerUpCapture: onPointerUpCapture,
        onClickCapture: onClickCapture,
        ref: ref,
        shouldFitContainer: shouldFitContainer,
        spacing: spacing,
        testId: testId,
        hasIconBefore: Boolean(iconBefore),
        hasIconAfter: Boolean(iconAfter)
    });
    return baseProps;
};
var $0eb17ca5f07eb9cf$export$2e2bcd8739ae039 = $0eb17ca5f07eb9cf$var$useDefaultButton;


var $1fa2d718d507adf5$var$_excluded = [
    "analyticsContext",
    "appearance",
    "aria-label",
    "aria-labelledby",
    "autoFocus",
    "children",
    "iconAfter",
    "iconBefore",
    "interactionName",
    "isDisabled",
    "isLoading",
    "isSelected",
    "onClick",
    "onClickCapture",
    "onKeyDownCapture",
    "onKeyUpCapture",
    "onMouseDownCapture",
    "onMouseUpCapture",
    "onPointerDownCapture",
    "onPointerUpCapture",
    "onTouchEndCapture",
    "onTouchStartCapture",
    "shouldFitContainer",
    "spacing",
    "testId",
    "type"
], $1fa2d718d507adf5$var$_excluded2 = [
    "className",
    "css",
    "as",
    "style"
];
/**
 * __Button__
 *
 * A button triggers an event or action.
 *
 * - [Examples](https://atlassian.design/components/button/examples)
 * - [Code](https://atlassian.design/components/button/code)
 * - [Usage](https://atlassian.design/components/button/usage)
 */ var $1fa2d718d507adf5$var$Button = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).forwardRef(function Button(_ref, ref) {
    var analyticsContext = _ref.analyticsContext, appearance = _ref.appearance, ariaLabel = _ref['aria-label'], ariaLabelledBy = _ref['aria-labelledby'], autoFocus = _ref.autoFocus, children = _ref.children, iconAfter = _ref.iconAfter, iconBefore = _ref.iconBefore, interactionName = _ref.interactionName, isDisabled = _ref.isDisabled, isLoading = _ref.isLoading, isSelected = _ref.isSelected, onClick = _ref.onClick, onClickCapture = _ref.onClickCapture, onKeyDownCapture = _ref.onKeyDownCapture, onKeyUpCapture = _ref.onKeyUpCapture, onMouseDownCapture = _ref.onMouseDownCapture, onMouseUpCapture = _ref.onMouseUpCapture, onPointerDownCapture = _ref.onPointerDownCapture, onPointerUpCapture = _ref.onPointerUpCapture, onTouchEndCapture = _ref.onTouchEndCapture, onTouchStartCapture = _ref.onTouchStartCapture, shouldFitContainer = _ref.shouldFitContainer, spacing = _ref.spacing, testId = _ref.testId, _ref$type = _ref.type, type = _ref$type === void 0 ? 'button' : _ref$type, unsafeRest = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $1fa2d718d507adf5$var$_excluded);
    // @ts-expect-error
    var _className = unsafeRest.className, _css = unsafeRest.css, _as = unsafeRest.as, _style = unsafeRest.style, saferRest = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(unsafeRest, $1fa2d718d507adf5$var$_excluded2);
    var baseProps = (0, $0eb17ca5f07eb9cf$export$2e2bcd8739ae039)({
        ariaLabel: ariaLabel,
        ariaLabelledBy: ariaLabelledBy,
        analyticsContext: analyticsContext,
        appearance: appearance,
        autoFocus: autoFocus,
        buttonType: 'button',
        children: children,
        iconAfter: iconAfter,
        iconBefore: iconBefore,
        interactionName: interactionName,
        isDisabled: isDisabled,
        isLoading: isLoading,
        isSelected: isSelected,
        onClick: onClick,
        onClickCapture: onClickCapture,
        onKeyDownCapture: onKeyDownCapture,
        onKeyUpCapture: onKeyUpCapture,
        onMouseDownCapture: onMouseDownCapture,
        onMouseUpCapture: onMouseUpCapture,
        onPointerDownCapture: onPointerDownCapture,
        onPointerUpCapture: onPointerUpCapture,
        onTouchEndCapture: onTouchEndCapture,
        onTouchStartCapture: onTouchStartCapture,
        ref: ref,
        shouldFitContainer: shouldFitContainer,
        spacing: spacing,
        testId: testId
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $d469e5ab074fc4c0$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, saferRest, {
        "aria-label": baseProps['aria-label'],
        "aria-labelledby": baseProps['aria-labelledby'],
        ref: baseProps.ref,
        xcss: baseProps.xcss,
        isDisabled: baseProps.isDisabled,
        onClick: baseProps.onClick,
        onMouseDownCapture: baseProps.onMouseDownCapture,
        onMouseUpCapture: baseProps.onMouseUpCapture,
        onKeyDownCapture: baseProps.onKeyDownCapture,
        onKeyUpCapture: baseProps.onKeyUpCapture,
        onTouchStartCapture: baseProps.onTouchStartCapture,
        onTouchEndCapture: baseProps.onTouchEndCapture,
        onPointerDownCapture: baseProps.onPointerDownCapture,
        onPointerUpCapture: baseProps.onPointerUpCapture,
        onClickCapture: baseProps.onClickCapture,
        type: type,
        testId: testId,
        analyticsContext: analyticsContext,
        interactionName: interactionName,
        componentName: "Button"
    }), baseProps.children);
}));
$1fa2d718d507adf5$var$Button.displayName = 'Button';
var $1fa2d718d507adf5$export$2e2bcd8739ae039 = $1fa2d718d507adf5$var$Button;


/**
 * Character key codes which can be used in keyboard events.
 */ var $e27a1598a26ffda3$export$390330c10ff2b9a1 = 'ArrowUp';
var $e27a1598a26ffda3$export$a80636c6f41931fe = 'ArrowDown';
var $e27a1598a26ffda3$export$4af703091671bc = 'Home';
var $e27a1598a26ffda3$export$e2bc30913faa5db7 = 'End';
var $e27a1598a26ffda3$export$10f6869ed0a7d75b = 'Tab';
var $e27a1598a26ffda3$export$8152f929a25a0ff4 = 'Enter';
var $e27a1598a26ffda3$export$e51a3576c045c8d5 = 'Space';
var $e27a1598a26ffda3$export$2bb790b9008907b4 = 'Escape';





var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");
function $f4d287be7eb5fb6d$export$2e2bcd8739ae039(propValue) {
    var getDefaultPropValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function() {
        return propValue;
    };
    var isControlled = propValue !== undefined;
    var _useState = (0, $5FkrB.useState)(getDefaultPropValue), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), valueState = _useState2[0], setValue = _useState2[1];
    var isControlledRef = (0, $5FkrB.useRef)(isControlled);
    (0, $5FkrB.useEffect)(function() {
        isControlledRef.current = isControlled;
    }, [
        isControlled
    ]);
    var value = isControlled ? propValue : valueState;
    var setValueIfUncontrolled = (0, $5FkrB.useCallback)(function(newValue) {
        if (!isControlledRef.current) setValue(newValue);
    }, []);
    return [
        value,
        setValueIfUncontrolled
    ];
}



var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");
function $7632941312f4921f$export$2e2bcd8739ae039() {
    var _useState = (0, $5FkrB.useState)(false), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), isFocused = _useState2[0], setIsFocused = _useState2[1];
    // ensure bindFocus has a stable ref
    var bindFocus = (0, $5FkrB.useRef)({
        onFocus: function onFocus() {
            return setIsFocused(true);
        },
        onBlur: function onBlur() {
            return setIsFocused(false);
        }
    });
    (0, $5FkrB.useEffect)(function() {
        // handle the case where a component might
        // unmount while being focused.
        return function() {
            return setIsFocused(false);
        };
    }, []);
    return {
        isFocused: isFocused,
        bindFocus: bindFocus.current
    };
}


var $c21b397a5a41009b$exports = {};
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4f1feec303b173e7de0228adfc7e7782>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty($c21b397a5a41009b$exports, "__esModule", {
    value: true
});
$c21b397a5a41009b$exports.default = void 0;

var $c21b397a5a41009b$var$_react = $c21b397a5a41009b$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $c21b397a5a41009b$var$_chevronDown = $c21b397a5a41009b$var$_interopRequireDefault((parcelRequire("8kEM5")));

var $c21b397a5a41009b$var$_chevronDown2 = $c21b397a5a41009b$var$_interopRequireDefault((parcelRequire("kINa4")));
function $c21b397a5a41009b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for ChevronDownIcon.
 * This component is ChevronDownIcon, with `UNSAFE_fallbackIcon` set to "ChevronDownIcon".
 *
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for dropdown menus, selects, accordions, and expands.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c21b397a5a41009b$var$ChevronDownIcon = (props)=>/*#__PURE__*/ $c21b397a5a41009b$var$_react.default.createElement($c21b397a5a41009b$var$_chevronDown.default, Object.assign({
        LEGACY_fallbackIcon: $c21b397a5a41009b$var$_chevronDown2.default
    }, props));
$c21b397a5a41009b$var$ChevronDownIcon.Name = 'ChevronDownIconMigration';
var $c21b397a5a41009b$var$_default = $c21b397a5a41009b$exports.default = $c21b397a5a41009b$var$ChevronDownIcon;



var $dU8Y3 = parcelRequire("dU8Y3");

var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");

var $74Zh5 = parcelRequire("74Zh5");


var $5FkrB = parcelRequire("5FkrB");

var $5be177ba607b9a5f$export$650d12d3c2ddb8fc = /*#__PURE__*/ (0, $5FkrB.createContext)(0);
var $5be177ba607b9a5f$export$48b383b280e20440 = /*#__PURE__*/ (0, $5FkrB.createContext)({
    topLevelRef: {
        current: null
    },
    setTopLevel: (0, $3a341012e037de4f$export$2e2bcd8739ae039)
});
/**
 *
 *  @internal
 * Context Provider Component which provider the current level of nested layers
 * It handles level management when it mounts and unmounts
 *
 */ var $5be177ba607b9a5f$var$LevelProvider = function LevelProvider(_ref) {
    var children = _ref.children, currentLevel = _ref.currentLevel;
    var _useContext = (0, $5FkrB.useContext)($5be177ba607b9a5f$export$48b383b280e20440), setTopLevel = _useContext.setTopLevel, topLevelRef = _useContext.topLevelRef;
    if (topLevelRef.current === null || currentLevel > topLevelRef.current) setTopLevel(currentLevel);
    (0, $5FkrB.useEffect)(function() {
        return function() {
            // avoid immediate cleanup using setTimeout when component unmount
            // this will make sure non-top layer components can get the correct top level value
            // when multiple layers trigger onClose in sequence
            setTimeout(function() {
                setTopLevel(currentLevel - 1);
            }, 0);
        };
    }, [
        setTopLevel,
        currentLevel
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement($5be177ba607b9a5f$export$650d12d3c2ddb8fc.Provider, {
        value: currentLevel
    }, children);
};
/**
 *
 *  @internal
 * Context Provider Component which provides the top level of all nested layers
 * It provides initial top level ref value as 0 and set top level method
 *
 */ var $5be177ba607b9a5f$var$LayeringProvider = function LayeringProvider(_ref2) {
    var children = _ref2.children;
    var topLevelRef = (0, $5FkrB.useRef)(0);
    var value = (0, $5FkrB.useMemo)(function() {
        return {
            topLevelRef: topLevelRef,
            setTopLevel: function setTopLevel(level) {
                topLevelRef.current = level;
            }
        };
    }, [
        topLevelRef
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement($5be177ba607b9a5f$export$48b383b280e20440.Provider, {
        value: value
    }, children);
};
var $5be177ba607b9a5f$export$7c885f891c940977 = function Layering(_ref3) {
    var children = _ref3.children, _ref3$isDisabled = _ref3.isDisabled, isDisabled = _ref3$isDisabled === void 0 ? true : _ref3$isDisabled;
    var currentLevel = (0, $5FkrB.useContext)($5be177ba607b9a5f$export$650d12d3c2ddb8fc);
    if (isDisabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).Fragment, null, children);
    var isNested = currentLevel > 0;
    var content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement($5be177ba607b9a5f$var$LevelProvider, {
        currentLevel: currentLevel + 1
    }, children);
    return isNested ? content : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement($5be177ba607b9a5f$var$LayeringProvider, null, content);
};



var $5FkrB = parcelRequire("5FkrB");

var $5FkrB = parcelRequire("5FkrB");
var $c256ad6a425c0250$export$5fbf4d7fae6cdc00 = /*#__PURE__*/ (0, $5FkrB.createContext)(null);


function $346f36c0232779ff$export$469bb693f11edc7f() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, _ref$isOpen = _ref.isOpen, isOpen = _ref$isOpen === void 0 ? true : _ref$isOpen;
    var context = (0, $5FkrB.useContext)((0, $c256ad6a425c0250$export$5fbf4d7fae6cdc00));
    (0, $5FkrB.useEffect)(function() {
        if (context === null) return;
        if (!isOpen) return;
        context.increment();
        return function() {
            context.decrement();
        };
    }, [
        context,
        isOpen
    ]);
}



var $dU8Y3 = parcelRequire("dU8Y3");

var $hvYLl = parcelRequire("hvYLl");
var $agyC9 = parcelRequire("agyC9");

var $5FkrB = parcelRequire("5FkrB");

var $dU8Y3 = parcelRequire("dU8Y3");

var $5FkrB = parcelRequire("5FkrB");

var $aLeHs = parcelRequire("aLeHs");
var $3929e2e80ca8c43b$export$e4c79eb95c23a0da = 'atlaskit-portal-container';
var $3929e2e80ca8c43b$export$72f415121273627e = 'body > .atlaskit-portal-container';
var $3929e2e80ca8c43b$export$13f57c02915787b3 = 'atlaskit-portal';


var $8e68cdd6df9f10d0$export$26ae5ca175b4ec5a = function createContainer(zIndex) {
    var container = document.createElement('div');
    container.className = (0, $3929e2e80ca8c43b$export$13f57c02915787b3);
    container.style.zIndex = "".concat(zIndex);
    return container;
};
/**
 * Returns document body element
 * @return {number} - The document body element
 */ var $8e68cdd6df9f10d0$var$getBody = function getBody() {
    return document.body;
};
/**
 * Returns portal parent container. If no container exists already then it creates a new container with class name 'atlaskit-portal-container'
 * @return {Element} - The portal parent container div element
 */ var $8e68cdd6df9f10d0$var$getPortalParent = function getPortalParent() {
    var parentElement = document.querySelector((0, $3929e2e80ca8c43b$export$72f415121273627e));
    if (!parentElement) {
        var _getBody;
        var parent = document.createElement('div');
        parent.className = (0, $3929e2e80ca8c43b$export$e4c79eb95c23a0da);
        // we are setting display to flex because we want each portal to create a new stacking context
        // See https://developer.mozilla.org/en-US/docs/Web/CSS/CSS_Positioning/Understanding_z_index/The_stacking_context
        parent.style.display = 'flex';
        (_getBody = $8e68cdd6df9f10d0$var$getBody()) === null || _getBody === void 0 || _getBody.appendChild(parent);
        return parent;
    }
    return parentElement;
};
var $8e68cdd6df9f10d0$export$da99f98bf3fe55b3 = function removePortalContainer(container) {
    $8e68cdd6df9f10d0$var$getPortalParent().removeChild(container);
};
var $8e68cdd6df9f10d0$export$c582005add11e141 = function appendPortalContainerIfNotAppended(container) {
    if (!container.parentElement) $8e68cdd6df9f10d0$var$getPortalParent().appendChild(container);
};
var $8e68cdd6df9f10d0$export$842dfe7a9f24298 = function isDocumentDefined() {
    return document !== undefined;
};
var $8e68cdd6df9f10d0$export$fef014d7cef9e543 = function createAtlaskitPortal(zIndex) {
    //atlaskit-portal div
    if ($8e68cdd6df9f10d0$export$842dfe7a9f24298()) {
        var atlaskitportal = document.createElement('div');
        atlaskitportal.className = (0, $3929e2e80ca8c43b$export$13f57c02915787b3);
        atlaskitportal.style.zIndex = "".concat(zIndex);
        return atlaskitportal;
    }
};
var $8e68cdd6df9f10d0$export$95029ca7aca2989e = function createPortalParent() {
    //atlaskit-portal-container div
    if ($8e68cdd6df9f10d0$export$842dfe7a9f24298()) {
        var parentElement = document.querySelector((0, $3929e2e80ca8c43b$export$72f415121273627e));
        if (!parentElement) {
            var _getBody2;
            var parent = document.createElement('div');
            parent.className = (0, $3929e2e80ca8c43b$export$e4c79eb95c23a0da);
            parent.style.display = 'flex';
            (_getBody2 = $8e68cdd6df9f10d0$var$getBody()) === null || _getBody2 === void 0 || _getBody2.appendChild(parent);
            return parent;
        }
        return parentElement;
    }
};


function $ea563bc615717bc2$export$2e2bcd8739ae039(props) {
    var zIndex = props.zIndex, children = props.children;
    var container = (0, $5FkrB.useMemo)(function() {
        return (0, $8e68cdd6df9f10d0$export$26ae5ca175b4ec5a)(zIndex);
    }, [
        zIndex
    ]);
    // This is in the render method instead of useEffect so that
    // the portal will be added to the DOM before the children render.
    // For any further changes, ensure that the container does not have a
    // parent besides the portal parent.
    (0, $8e68cdd6df9f10d0$export$c582005add11e141)(container);
    (0, $5FkrB.useEffect)(function() {
        return function() {
            (0, $8e68cdd6df9f10d0$export$da99f98bf3fe55b3)(container);
        };
    }, [
        container
    ]);
    return /*#__PURE__*/ (0, $aLeHs.createPortal)(children, container);
}



var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");

var $aLeHs = parcelRequire("aLeHs");

var $dU8Y3 = parcelRequire("dU8Y3");

var $5FkrB = parcelRequire("5FkrB");
var $e0ed51ed9a0fa054$export$700979bc83e7db82 = typeof window !== 'undefined' ? (0, $5FkrB.useLayoutEffect) : (0, $5FkrB.useEffect);



function $35320d7775a1497c$export$2e2bcd8739ae039(props) {
    var zIndex = props.zIndex, children = props.children;
    var _useState = (0, $5FkrB.useState)(null), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), atlaskitPortal = _useState2[0], setAtlaskitPortal = _useState2[1];
    (0, $e0ed51ed9a0fa054$export$700979bc83e7db82)(function() {
        var tempPortalContainer = (0, $8e68cdd6df9f10d0$export$fef014d7cef9e543)(zIndex);
        setAtlaskitPortal(tempPortalContainer);
        var portalParent = (0, $8e68cdd6df9f10d0$export$95029ca7aca2989e)();
        if (!tempPortalContainer || !portalParent) return;
        portalParent.appendChild(tempPortalContainer);
        return function() {
            if (tempPortalContainer) portalParent.removeChild(tempPortalContainer);
            setAtlaskitPortal(null);
        };
    }, [
        zIndex
    ]);
    /**
   * Conditionally wrap ALL portal children with Suspense behind a feature gate for safe rollout.
   *
   * This is here because in React 18 concurrent, if you suspend from _within_ a portal to a
   * suspense boundary _outside_ a portal, our portal gets in an infinite loop of re-rendering.
   */ var conditionallySuspendedChildren = (0, $dU8Y3.fg)('platform_design_system_suspend_portal_children') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $5FkrB.Suspense), {
        fallback: null
    }, children) : children;
    return atlaskitPortal ? /*#__PURE__*/ (0, $aLeHs.createPortal)(conditionallySuspendedChildren, atlaskitPortal) : null;
}



var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");

var $7eec85c1019abf3b$var$useIsSubsequentRender = function useIsSubsequentRender(mountStrategy) {
    var _useState = (0, $5FkrB.useState)(false), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), isSubsequentRender = _useState2[0], setIsSubsequentRender = _useState2[1];
    var _useState3 = (0, $5FkrB.useState)(function() {
        return mountStrategy === 'layoutEffect' ? (0, $e0ed51ed9a0fa054$export$700979bc83e7db82) : (0, $5FkrB.useEffect);
    }), _useState4 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState3, 1), useMountEffect = _useState4[0];
    useMountEffect(function() {
        setIsSubsequentRender(true);
    }, []);
    return isSubsequentRender;
};
var $7eec85c1019abf3b$export$2e2bcd8739ae039 = $7eec85c1019abf3b$var$useIsSubsequentRender;



var $5FkrB = parcelRequire("5FkrB");
var $e0fabee1e72bda5b$export$ed5835cc67e87f72 = 'akPortalMount';
var $e0fabee1e72bda5b$export$80816bd900e5bd00 = 'akPortalUnmount';


var $4c6474c69cf23d9c$var$zIndexToName = {
    100: 'card',
    200: 'navigation',
    300: 'dialog',
    400: 'layer',
    500: 'blanket',
    510: 'modal',
    600: 'flag',
    700: 'spotlight',
    9999: 'tooltip'
};
/**
 * return layer name in Atlassian design system corresponding to given z-index
 * @param {number} zIndex - z-index value for which layer name is needed
 * @returns {LayerName | null} - The layer name for given z-index. If layer name is not found then null is returned
 */ var $4c6474c69cf23d9c$var$getLayerName = function getLayerName(zIndex) {
    return $4c6474c69cf23d9c$var$zIndexToName.hasOwnProperty(zIndex) ? $4c6474c69cf23d9c$var$zIndexToName[zIndex] : null;
};
/**
 * Creates a PortalEvent object with given eventName, given zIndex and corresponding layer
 * @param {string} eventName - either of Mount or Unmount event name
 * @param {number} zIndex - z-index value which will be included in the event to be dispatched
 * @returns {PortalEvent} - The newly created PortalEvent object
 */ var $4c6474c69cf23d9c$var$getEvent = function getEvent(eventName, zIndex) {
    var detail = {
        layer: $4c6474c69cf23d9c$var$getLayerName(Number(zIndex)),
        zIndex: zIndex
    };
    return new CustomEvent(eventName, {
        detail: detail
    });
};
function $4c6474c69cf23d9c$export$2e2bcd8739ae039(eventName, zIndex) {
    var event = $4c6474c69cf23d9c$var$getEvent(eventName, zIndex);
    window.dispatchEvent(event);
}


var $15c9d4fe09356553$var$useFirePortalEvent = function useFirePortalEvent(zIndex) {
    var zIndexNumber = Number(zIndex);
    (0, $5FkrB.useEffect)(function() {
        (0, $4c6474c69cf23d9c$export$2e2bcd8739ae039)((0, $e0fabee1e72bda5b$export$ed5835cc67e87f72), zIndexNumber);
        return function() {
            (0, $4c6474c69cf23d9c$export$2e2bcd8739ae039)((0, $e0fabee1e72bda5b$export$80816bd900e5bd00), zIndexNumber);
        };
    }, [
        zIndexNumber
    ]);
};
var $15c9d4fe09356553$export$2e2bcd8739ae039 = $15c9d4fe09356553$var$useFirePortalEvent;


function $a038809878bd7654$export$2e2bcd8739ae039(_ref) {
    var _ref$zIndex = _ref.zIndex, zIndex = _ref$zIndex === void 0 ? 0 : _ref$zIndex, children = _ref.children, _ref$mountStrategy = _ref.mountStrategy, mountStrategy = _ref$mountStrategy === void 0 ? 'effect' : _ref$mountStrategy;
    var isSubsequentRender = (0, $7eec85c1019abf3b$export$2e2bcd8739ae039)(mountStrategy);
    (0, $15c9d4fe09356553$export$2e2bcd8739ae039)(zIndex);
    // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
    return !(0, $dU8Y3.fg)('platform_design_system_team_portal_logic_r18_fix') ? isSubsequentRender ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $ea563bc615717bc2$export$2e2bcd8739ae039), {
        zIndex: zIndex
    }, children) : null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $35320d7775a1497c$export$2e2bcd8739ae039), {
        zIndex: zIndex
    }, children);
}



/* eslint-disable no-console */ var $51ab6b853d704d00$var$printed = {};
function $51ab6b853d704d00$export$2e2bcd8739ae039(message) {
    if ($51ab6b853d704d00$var$printed[message]) return;
    $51ab6b853d704d00$var$printed[message] = true;
    if (typeof window !== 'undefined') console.warn(message);
}



var $3ZMUU = parcelRequire("3ZMUU");
function $fec3bc1e5d746c60$export$2e2bcd8739ae039(packageName, api, additionalMessage) {
    (0, $51ab6b853d704d00$export$2e2bcd8739ae039)("[".concat(packageName, "]: The ").concat(api, " is deprecated.").concat(additionalMessage && " ".concat(additionalMessage)));
}
function $fec3bc1e5d746c60$export$eb1decd851a5ae56(packageName, propName, predicate, deprecationAnnouncementOnDAC) {
    typeof $3ZMUU;
}



var $10b83e40731cc155$export$44ffba16bd48dac6 = '__ATLASKIT_THEME__';
var $10b83e40731cc155$export$c93026a968943f95 = 'light';
var $10b83e40731cc155$export$6ba72c8346b4c57e = [
    'light',
    'dark'
];
var $10b83e40731cc155$export$7a57f79000377ca2 = function borderRadius() {
    return 3;
};
var $10b83e40731cc155$export$6d8204c2cb2e06b8 = function gridSize() {
    return 8;
};
var $10b83e40731cc155$export$8e24544ddba725ee = function focusRing() {
    var color = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "var(--ds-border-focused, ".concat((0, $d879fc455f6e75a0$export$215b7063051591f1), ")");
    var outlineWidth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $10b83e40731cc155$export$6d8204c2cb2e06b8() / 4;
    (0, $fec3bc1e5d746c60$export$2e2bcd8739ae039)('@atlaskit/theme', 'focus ring mixin', 'Please use `@atlaskit/focus-ring` instead.');
    return "\n  &:focus {\n    outline: none;\n    box-shadow: 0px 0px 0px ".concat(outlineWidth, "px ").concat(color, ";\n  }\n");
};
var $10b83e40731cc155$export$c0dd343266bc3261 = function noFocusRing() {
    return "\n  box-shadow: none;\n";
};
var $10b83e40731cc155$export$7be255094ccdc533 = {
    card: function card() {
        return 100;
    },
    navigation: function navigation() {
        return 200;
    },
    dialog: function dialog() {
        return 300;
    },
    layer: function layer() {
        return 400;
    },
    blanket: function blanket() {
        return 500;
    },
    modal: function modal() {
        return 510;
    },
    flag: function flag() {
        return 600;
    },
    spotlight: function spotlight() {
        return 700;
    },
    tooltip: function tooltip() {
        return 9999;
    }
};
var $10b83e40731cc155$export$a1b3edb637fb4f35 = function visuallyHidden() {
    (0, $fec3bc1e5d746c60$export$2e2bcd8739ae039)('@atlaskit/theme', 'visually hidden mixin', 'Please use `@atlaskit/visually-hidden` instead.');
    return {
        border: '0 !important',
        clip: 'rect(1px, 1px, 1px, 1px) !important',
        height: '1px !important',
        overflow: 'hidden !important',
        padding: '0 !important',
        position: 'absolute !important',
        width: '1px !important',
        whiteSpace: 'nowrap !important'
    };
};
var $10b83e40731cc155$export$ba1d834b86d72a09 = $10b83e40731cc155$export$a1b3edb637fb4f35;
var $10b83e40731cc155$export$e497e856b4f89fcd = function skeletonShimmer() {
    return {
        css: {
            backgroundColor: "var(--ds-skeleton, ".concat((0, $d879fc455f6e75a0$export$8d43898f60b96a82), ")"),
            animationDuration: '1.5s',
            animationIterationCount: 'infinite',
            animationTimingFunction: 'linear',
            animationDirection: 'alternate'
        },
        keyframes: {
            from: {
                backgroundColor: "var(--ds-skeleton, ".concat((0, $d879fc455f6e75a0$export$8d43898f60b96a82), ")")
            },
            to: {
                backgroundColor: "var(--ds-skeleton-subtle, ".concat((0, $d879fc455f6e75a0$export$920c0d5c49070351), ")")
            }
        }
    };
};



var $fC8ib = parcelRequire("fC8ib");

var $iYJcE = parcelRequire("iYJcE");

var $kqp0i = parcelRequire("kqp0i");

var $1Vcia = parcelRequire("1Vcia");

var $25nEq = parcelRequire("25nEq");

var $5FkrB = parcelRequire("5FkrB");

var $74Zh5 = parcelRequire("74Zh5");
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5FkrB = parcelRequire("5FkrB");

var $74Zh5 = parcelRequire("74Zh5");
var $7e4032dad619a626$var$BORDER_WIDTH = 2;
var $7e4032dad619a626$var$baseFocusOutsideStyles = (0, $74Zh5.css)({
    outline: "".concat($7e4032dad619a626$var$BORDER_WIDTH, "px solid ", "var(--ds-border-focused, #2684FF)"),
    outlineOffset: $7e4032dad619a626$var$BORDER_WIDTH
});
var $7e4032dad619a626$var$baseInsetStyles = (0, $74Zh5.css)({
    outlineColor: "var(--ds-border-focused, #2684FF)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    outlineOffset: -$7e4032dad619a626$var$BORDER_WIDTH,
    outlineStyle: 'solid',
    outlineWidth: "var(--ds-border-width-outline, 2px)"
});
var $7e4032dad619a626$var$focusRingStyles = (0, $74Zh5.css)({
    // Focus styles used when :focus-visible isn't supported
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
    '&:focus': $7e4032dad619a626$var$baseFocusOutsideStyles,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
    '&:focus-visible': $7e4032dad619a626$var$baseFocusOutsideStyles,
    // Remove default focus styles for mouse interactions if :focus-visible is supported
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
    '&:focus:not(:focus-visible)': {
        outline: 'none'
    },
    '@media screen and (forced-colors: active), screen and (-ms-high-contrast: active)': {
        '&:focus-visible': {
            outline: '1px solid'
        }
    }
});
var $7e4032dad619a626$var$insetFocusRingStyles = (0, $74Zh5.css)({
    // Focus styles used when :focus-visible isn't supported
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
    '&:focus': $7e4032dad619a626$var$baseInsetStyles,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
    '&:focus-visible': $7e4032dad619a626$var$baseInsetStyles,
    // Remove default focus styles for mouse interactions if :focus-visible is supported
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
    '&:focus:not(:focus-visible)': {
        outline: 'none'
    },
    '@media screen and (forced-colors: active), screen and (-ms-high-contrast: active)': {
        '&:focus-visible': {
            outline: '1px solid',
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
            outlineOffset: '-1px'
        }
    }
});
/**
 * __Focus ring__
 *
 * A focus ring visually indicates the currently focused item.
 *
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/focus-ring)
 *
 * @example
 * ```jsx
 * import FocusRing from '@atlaskit/focus-ring';
 *
 * const InteractiveComponent = () => (
 *   <FocusRing>
 *     <button type="button">Hello</button>
 *   </FocusRing>
 * )
 * ```
 */ var $7e4032dad619a626$var$FocusRing = /*#__PURE__*/ (0, $5FkrB.memo)(function(_ref) {
    var children = _ref.children, isInset = _ref.isInset, focus = _ref.focus;
    var controlledStyles = isInset ? $7e4032dad619a626$var$baseInsetStyles : $7e4032dad619a626$var$baseFocusOutsideStyles;
    var uncontrolledStyles = isInset ? $7e4032dad619a626$var$insetFocusRingStyles : $7e4032dad619a626$var$focusRingStyles;
    var focusCls = typeof focus === 'undefined' ? uncontrolledStyles : focus === 'on' && controlledStyles;
    return (0, $74Zh5.jsx)((0, $74Zh5.ClassNames), null, function(_ref2) {
        var css = _ref2.css, cx = _ref2.cx;
        return (0, $5FkrB.Children).only(// This may look unwieldy but means we skip applying styles / cloning if no className is applicable
        focusCls ? /*#__PURE__*/ // eslint-disable-next-line @repo/internal/react/no-clone-element
        (0, $5FkrB.cloneElement)(children, {
            className: cx([
                css(focusCls),
                children.props.className
            ])
        }) : children);
    });
});
$7e4032dad619a626$var$FocusRing.displayName = 'FocusRing';
var $7e4032dad619a626$export$2e2bcd8739ae039 = $7e4032dad619a626$var$FocusRing;



var $5FkrB = parcelRequire("5FkrB");

var $7QpUe = parcelRequire("7QpUe");

var $88efd4caf07ed116$var$ESCAPE = 'Escape';
function $88efd4caf07ed116$export$4a4bf067ea9e7886(_ref) {
    var onClose = _ref.onClose, isDisabled = _ref.isDisabled;
    var escapePressed = (0, $5FkrB.useRef)(false);
    var _useLayering = $88efd4caf07ed116$export$c8b4d54e03dee6ed(), isLayerDisabled = _useLayering.isLayerDisabled;
    var onKeyDown = (0, $5FkrB.useCallback)(function(e) {
        var isDisabledLayer = isLayerDisabled();
        if (isDisabled || escapePressed.current || e.key !== $88efd4caf07ed116$var$ESCAPE || isDisabledLayer) // We're either already handling the key down event or it's not escape or disabled.
        // Bail early!
        return;
        escapePressed.current = true;
        onClose(e);
    }, [
        onClose,
        isDisabled,
        isLayerDisabled
    ]);
    var onKeyUp = (0, $5FkrB.useCallback)(function() {
        escapePressed.current = false;
    }, []);
    (0, $5FkrB.useEffect)(function() {
        return (0, $7QpUe.bindAll)(window, [
            {
                type: 'keydown',
                listener: onKeyDown
            },
            {
                type: 'keyup',
                listener: onKeyUp
            }
        ], {
            capture: false
        });
    }, [
        onKeyDown,
        onKeyUp
    ]);
}
function $88efd4caf07ed116$export$c8b4d54e03dee6ed() {
    var currentLevel = (0, $5FkrB.useContext)((0, $5be177ba607b9a5f$export$650d12d3c2ddb8fc));
    var _useContext = (0, $5FkrB.useContext)((0, $5be177ba607b9a5f$export$48b383b280e20440)), topLevelRef = _useContext.topLevelRef;
    var isLayerDisabled = (0, $5FkrB.useCallback)(function() {
        return !!topLevelRef.current && currentLevel !== topLevelRef.current;
    }, [
        currentLevel,
        topLevelRef
    ]);
    return {
        currentLevel: currentLevel,
        topLevelRef: topLevelRef,
        isLayerDisabled: isLayerDisabled
    };
}



var $dU8Y3 = parcelRequire("dU8Y3");

var $fC8ib = parcelRequire("fC8ib");

var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");

var $lsgol = parcelRequire("lsgol");

var $iYJcE = parcelRequire("iYJcE");
function $0e3d45500b47bd10$export$6d8c2b45c99d6e3f(_ref) {
    var viewportPadding = _ref.viewportPadding;
    return [
        {
            /**
     * Performing DOM measurements in the 'read' phase,
     * which is the convention for popper modifiers
     */ name: 'maxSizeData',
            enabled: true,
            phase: 'read',
            fn: function fn(_ref2) {
                var state = _ref2.state, name = _ref2.name;
                if (!window.visualViewport) return;
                state.modifiersData[name] = {
                    viewport: {
                        width: window.visualViewport.width,
                        height: window.visualViewport.height
                    }
                };
            }
        },
        {
            /**
     * Applying max size CSS
     */ name: 'maxSize',
            enabled: true,
            phase: 'beforeWrite',
            requiresIfExists: [
                'offset',
                'preventOverflow',
                'flip'
            ],
            fn: function fn(_ref3) {
                var _data$viewport, _data$viewport2, _state$modifiersData$2, _state$modifiersData;
                var state = _ref3.state;
                var data = state.modifiersData.maxSizeData;
                if (typeof (data === null || data === void 0 || (_data$viewport = data.viewport) === null || _data$viewport === void 0 ? void 0 : _data$viewport.width) !== 'number' || typeof (data === null || data === void 0 || (_data$viewport2 = data.viewport) === null || _data$viewport2 === void 0 ? void 0 : _data$viewport2.height) !== 'number') // This shouldn't occur in a real browser but might in non-browser test environments
                return;
                var viewport = data.viewport;
                var _state$modifiersData$ = state.modifiersData.popperOffsets, popperOffsets = _state$modifiersData$ === void 0 ? {
                    x: 0,
                    y: 0
                } : _state$modifiersData$;
                var _state$placement$spli = state.placement.split('-'), _state$placement$spli2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_state$placement$spli, 1), basePlacement = _state$placement$spli2[0];
                var placementOffset = (_state$modifiersData$2 = (_state$modifiersData = state.modifiersData) === null || _state$modifiersData === void 0 || (_state$modifiersData = _state$modifiersData.offset) === null || _state$modifiersData === void 0 ? void 0 : _state$modifiersData[state.placement]) !== null && _state$modifiersData$2 !== void 0 ? _state$modifiersData$2 : {
                    x: 0,
                    y: 0
                };
                // By default we set these to the entire viewport (minus padding)
                // Each placement direction will overwrite one of these
                var maxWidth = viewport.width - 2 * viewportPadding;
                var maxHeight = viewport.height - 2 * viewportPadding;
                if (basePlacement === 'top') maxHeight = state.rects.reference.y + // Viewport-relative position of reference element
                placementOffset.y - // Space between popper and reference
                viewportPadding;
                if (basePlacement === 'bottom') maxHeight = viewport.height - popperOffsets.y - // Viewport-relative position of popper
                viewportPadding;
                if (basePlacement === 'left') maxWidth = state.rects.reference.x + // Viewport-relative position of reference element
                placementOffset.x - // Space between popper and reference
                viewportPadding;
                if (basePlacement === 'right') maxWidth = viewport.width - popperOffsets.x - // Viewport-relative position of popper
                viewportPadding;
                state.styles.popper.maxWidth = "".concat(maxWidth, "px");
                state.styles.popper.maxHeight = "".concat(maxHeight, "px");
            }
        }
    ];
}



// Export types from PopperJS / React Popper
var $d0d6728fff2cc74d$var$viewportPadding = 5;
var $d0d6728fff2cc74d$var$constantModifiers = [
    {
        name: 'flip',
        options: {
            flipVariations: false,
            padding: $d0d6728fff2cc74d$var$viewportPadding,
            boundary: 'clippingParents',
            rootBoundary: 'viewport'
        }
    }
];
function $d0d6728fff2cc74d$var$defaultChildrenFn() {
    return null;
}
var $d0d6728fff2cc74d$var$defaultOffset = [
    0,
    8
];
function $d0d6728fff2cc74d$export$badac9ada3a0bdf9(_ref) {
    var _ref$children = _ref.children, children = _ref$children === void 0 ? $d0d6728fff2cc74d$var$defaultChildrenFn : _ref$children, _ref$offset = _ref.offset, offset = _ref$offset === void 0 ? $d0d6728fff2cc74d$var$defaultOffset : _ref$offset, _ref$placement = _ref.placement, placement = _ref$placement === void 0 ? 'bottom-start' : _ref$placement, _ref$referenceElement = _ref.referenceElement, referenceElement = _ref$referenceElement === void 0 ? undefined : _ref$referenceElement, modifiers = _ref.modifiers, _ref$strategy = _ref.strategy, strategy = _ref$strategy === void 0 ? 'fixed' : _ref$strategy, _ref$shouldFitViewpor = _ref.shouldFitViewport, shouldFitViewport = _ref$shouldFitViewpor === void 0 ? false : _ref$shouldFitViewpor;
    var _offset = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(offset, 2), offsetX = _offset[0], offsetY = _offset[1];
    var internalModifiers = (0, $5FkrB.useMemo)(function() {
        var preventOverflowModifier = {
            name: 'preventOverflow',
            options: {
                padding: $d0d6728fff2cc74d$var$viewportPadding,
                rootBoundary: shouldFitViewport ? 'viewport' : 'document'
            }
        };
        var offsetModifier = {
            name: 'offset',
            options: {
                offset: [
                    offsetX,
                    offsetY
                ]
            }
        };
        var maxSizeModifiers = shouldFitViewport ? (0, $0e3d45500b47bd10$export$6d8c2b45c99d6e3f)({
            viewportPadding: $d0d6728fff2cc74d$var$viewportPadding
        }) : [];
        // @ts-ignore Type errors from incompatible @popperjs/core versions between Jira and AFM Platform... we are using ts-ignore here because ts-expect-error will cause an "Unused '@ts-expect-error' directive." error
        return [].concat($d0d6728fff2cc74d$var$constantModifiers, [
            preventOverflowModifier,
            offsetModifier
        ], (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(maxSizeModifiers));
    }, [
        offsetX,
        offsetY,
        shouldFitViewport
    ]);
    // Merge custom props and memoize
    var mergedModifiers = (0, $5FkrB.useMemo)(function() {
        if (modifiers == null) return internalModifiers;
        return [].concat((0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(internalModifiers), (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(modifiers));
    }, [
        internalModifiers,
        modifiers
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $lsgol.Popper), {
        modifiers: mergedModifiers,
        placement: placement,
        strategy: strategy,
        referenceElement: referenceElement
    }, children);
}






var $5FkrB = parcelRequire("5FkrB");
var $483dc76949219dff$export$51eddd7655ca235a = function RepositionOnUpdate(_ref) {
    var children = _ref.children, update = _ref.update;
    // Ref used here to skip update on first render (when refs haven't been set)
    var isFirstRenderRef = (0, $5FkrB.useRef)(true);
    (0, $5FkrB.useLayoutEffect)(function() {
        if (isFirstRenderRef.current) {
            isFirstRenderRef.current = false;
            return;
        }
        // callback function from popper that repositions pop-up on content Update
        update();
    }, [
        update
    ]);
    // wrapping in fragment to make TS happy (known issue with FC returning children)
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $5FkrB.Fragment), null, children);
};


// eslint-disable-next-line @typescript-eslint/consistent-type-imports

var $5FkrB = parcelRequire("5FkrB");

var $7QpUe = parcelRequire("7QpUe");



var $dU8Y3 = parcelRequire("dU8Y3");
var $281db6f8a8af7fa1$var$interactiveTags = [
    'button',
    'a',
    'input',
    'select',
    'textarea'
];
var $281db6f8a8af7fa1$export$3dee5e4542c672d9 = function isInteractiveElement(element) {
    if ($281db6f8a8af7fa1$var$interactiveTags.includes(element.tagName.toLowerCase())) return true;
    if (element.getAttribute('tabindex') !== null || element.hasAttribute('contenteditable')) return true;
    return false;
};



var $5FkrB = parcelRequire("5FkrB");
var $b316a35c03701f47$export$641fa9c94086b46e = function useAnimationFrame() {
    var animationsRef = (0, $5FkrB.useRef)([]);
    var requestFrame = (0, $5FkrB.useCallback)(function(callback) {
        var id = requestAnimationFrame(callback);
        animationsRef.current.push(id);
        return id;
    }, []);
    var cancelFrame = (0, $5FkrB.useCallback)(function(id) {
        cancelAnimationFrame(id);
        animationsRef.current = animationsRef.current.filter(function(frameId) {
            return frameId !== id;
        });
    }, []);
    var cancelAllFrames = (0, $5FkrB.useCallback)(function() {
        animationsRef.current.forEach(function(id) {
            return cancelAnimationFrame(id);
        });
        animationsRef.current = [];
    }, []);
    return {
        requestFrame: requestFrame,
        cancelFrame: cancelFrame,
        cancelAllFrames: cancelAllFrames
    };
};


var $87f997011a7e17c0$export$92dae2778ae88f9d = function useCloseManager(_ref) {
    var isOpen = _ref.isOpen, onClose = _ref.onClose, popupRef = _ref.popupRef, triggerRef = _ref.triggerRef, autoFocus = _ref.autoFocus, shouldDisableFocusTrap = _ref.shouldDisableFocusTrap, capture = _ref.shouldUseCaptureOnOutsideClick, shouldCloseOnTab = _ref.shouldCloseOnTab, shouldRenderToParent = _ref.shouldRenderToParent;
    var _useLayering = (0, $88efd4caf07ed116$export$c8b4d54e03dee6ed)(), isLayerDisabled = _useLayering.isLayerDisabled, currentLevel = _useLayering.currentLevel;
    var _useAnimationFrame = (0, $b316a35c03701f47$export$641fa9c94086b46e)(), requestFrame = _useAnimationFrame.requestFrame, cancelAllFrames = _useAnimationFrame.cancelAllFrames;
    (0, $5FkrB.useEffect)(function() {
        if (!isOpen || !popupRef) return 0, $3a341012e037de4f$export$2e2bcd8739ae039;
        var inIframe = window && window.self !== window.top && (0, $dU8Y3.fg)('fix-dropdown-close-outside-iframe');
        var closePopup = function closePopup(event) {
            if (onClose) {
                if ((0, $dU8Y3.fg)('sibling-dropdown-close-issue')) {
                    var _currentLevel = null;
                    if (event.target instanceof HTMLElement) {
                        var _event$target$closest;
                        _currentLevel = (_event$target$closest = event.target.closest("[data-ds--level]")) === null || _event$target$closest === void 0 ? void 0 : _event$target$closest.getAttribute('data-ds--level');
                    }
                    _currentLevel ? onClose(event, Number(_currentLevel)) : onClose(event);
                } else onClose(event);
            }
            if (shouldDisableFocusTrap && (0, $dU8Y3.fg)('platform_dst_popup-disable-focuslock')) // Restoring the normal focus order for trigger.
            requestFrame(function() {
                triggerRef === null || triggerRef === void 0 || triggerRef.setAttribute('tabindex', '0');
                if (popupRef && autoFocus) popupRef.setAttribute('tabindex', '0');
            });
        };
        // This check is required for cases where components like
        // Select or DDM are placed inside a Popup. A click
        // on a MenuItem or Option would close the Popup, without registering
        // a click on DDM/Select.
        // Users would have to call `onClose` manually to close the Popup in these cases.
        // You can see the bug in action here:
        // https://codesandbox.io/s/atlaskitpopup-default-forked-2eb87?file=/example.tsx:0-1788
        var onClick = function onClick(event) {
            var target = event.target;
            var doesDomNodeExist = document.body.contains(target);
            if (!doesDomNodeExist && !inIframe) return;
            if (isLayerDisabled()) {
                if ((0, $dU8Y3.fg)('design-system-closed-all-when-click-outside')) {
                    if (target instanceof HTMLElement) {
                        var _target$closest;
                        var layeredElement = (_target$closest = target.closest) === null || _target$closest === void 0 ? void 0 : _target$closest.call(target, "[data-ds--level]");
                        if (layeredElement) {
                            var closeType = layeredElement.getAttribute('[data-ds--close--type]');
                            if (closeType === 'single') // if the close type is single, we won't close other disabled layers when clicking outside
                            return;
                            var levelOfClickedLayer = layeredElement.getAttribute('data-ds--level');
                            if (levelOfClickedLayer && Number(levelOfClickedLayer) > currentLevel) // won't trigger onClick event when we click in a higher layer.
                            return;
                        }
                    }
                } else return;
            }
            var isClickOnPopup = popupRef && popupRef.contains(target);
            var isClickOnTrigger = triggerRef && triggerRef.contains(target);
            if (!isClickOnPopup && !isClickOnTrigger) {
                closePopup(event);
                // If there was an outside click on a non-interactive element, the focus should be on the trigger.
                if (document.activeElement && !(0, $281db6f8a8af7fa1$export$3dee5e4542c672d9)(document.activeElement) && (0, $dU8Y3.fg)('platform_dst_popup-disable-focuslock')) triggerRef === null || triggerRef === void 0 || triggerRef.focus();
            }
        };
        var onKeyDown = function onKeyDown(event) {
            if ((0, $dU8Y3.fg)('platform_dst_popup-disable-focuslock')) {
                var key = event.key, shiftKey = event.shiftKey;
                if (shiftKey && key === 'Tab' && !shouldRenderToParent) {
                    if (isLayerDisabled()) return;
                    // We need to move the focus to the popup trigger when the popup is displayed in React.Portal.
                    requestFrame(function() {
                        var isPopupFocusOut = popupRef && !popupRef.contains(document.activeElement);
                        if (isPopupFocusOut) {
                            closePopup(event);
                            if (currentLevel === 1) triggerRef === null || triggerRef === void 0 || triggerRef.focus();
                        }
                    });
                    return;
                }
                if (key === 'Tab') {
                    var _document$activeEleme;
                    // We have cases where we need to close the Popup on Tab press.
                    // Example: DropdownMenu
                    if (shouldCloseOnTab) {
                        if (isLayerDisabled()) return;
                        closePopup(event);
                        return;
                    }
                    if (isLayerDisabled() && (_document$activeEleme = document.activeElement) !== null && _document$activeEleme !== void 0 && _document$activeEleme.closest('[aria-modal]')) return;
                    if (shouldDisableFocusTrap) {
                        if (shouldRenderToParent) // We need to move the focus to the previous interactive element before popup trigger
                        requestFrame(function() {
                            var isPopupFocusOut = popupRef && !popupRef.contains(document.activeElement);
                            if (isPopupFocusOut) closePopup(event);
                        });
                        else requestFrame(function() {
                            if (!document.hasFocus()) closePopup(event);
                        });
                        return;
                    }
                }
                if (isLayerDisabled()) return;
                if (key === 'Escape' || key === 'Esc') {
                    if (triggerRef && autoFocus) triggerRef.focus();
                    closePopup(event);
                }
            } else {
                if (isLayerDisabled()) return;
                var _key = event.key;
                if (_key === 'Escape' || _key === 'Esc' || shouldCloseOnTab && _key === 'Tab') closePopup(event);
            }
        };
        var parentUnbind;
        // if the popup is inside iframe, we want to listen to click events outside iframe,
        // to close the popup correctly in the iframe.
        if (inIframe && isOpen) parentUnbind = (0, $7QpUe.bind)(window.parent.window, {
            type: 'click',
            listener: onClick,
            options: {
                capture: capture
            }
        });
        var unbind = (0, $7QpUe.bindAll)(window, [
            {
                type: 'click',
                listener: onClick,
                options: {
                    capture: capture
                }
            },
            {
                type: 'keydown',
                listener: onKeyDown
            }
        ]);
        // bind onBlur event listener to fix popup not close when clicking on iframe outside
        var unbindBlur = (0, $3a341012e037de4f$export$2e2bcd8739ae039);
        unbindBlur = (0, $7QpUe.bind)(window, {
            type: 'blur',
            listener: function onBlur(e) {
                if (isLayerDisabled() || !(document.activeElement instanceof HTMLIFrameElement)) return;
                closePopup(e);
            }
        });
        return function() {
            var _parentUnbind;
            cancelAllFrames();
            unbind();
            (_parentUnbind = parentUnbind) === null || _parentUnbind === void 0 || _parentUnbind();
            unbindBlur();
        };
    }, [
        isOpen,
        onClose,
        popupRef,
        triggerRef,
        autoFocus,
        shouldDisableFocusTrap,
        capture,
        isLayerDisabled,
        shouldCloseOnTab,
        currentLevel,
        shouldRenderToParent,
        requestFrame,
        cancelAllFrames
    ]);
};



var $5FkrB = parcelRequire("5FkrB");

var $b6Hjk = parcelRequire("b6Hjk");



var $dU8Y3 = parcelRequire("dU8Y3");

var $d926fa057629b6e5$export$10c5169755ce7bd7 = function useFocusManager(_ref) {
    var initialFocusRef = _ref.initialFocusRef, popupRef = _ref.popupRef, triggerRef = _ref.triggerRef, autoFocus = _ref.autoFocus, shouldCloseOnTab = _ref.shouldCloseOnTab, shouldDisableFocusTrap = _ref.shouldDisableFocusTrap, shouldReturnFocus = _ref.shouldReturnFocus, shouldRenderToParent = _ref.shouldRenderToParent;
    var _useAnimationFrame = (0, $b316a35c03701f47$export$641fa9c94086b46e)(), requestFrame = _useAnimationFrame.requestFrame, cancelAllFrames = _useAnimationFrame.cancelAllFrames;
    var _useLayering = (0, $88efd4caf07ed116$export$c8b4d54e03dee6ed)(), currentLevel = _useLayering.currentLevel;
    (0, $5FkrB.useEffect)(function() {
        if (!popupRef || shouldCloseOnTab) return 0, $3a341012e037de4f$export$2e2bcd8739ae039;
        if (shouldDisableFocusTrap && (0, $dU8Y3.fg)('platform_dst_popup-disable-focuslock')) {
            var isDropdown = popupRef.matches('[id^=ds--dropdown--]');
            var popups = document.querySelectorAll("[data-ds--level=\"".concat(currentLevel - 1, "\"]"));
            if (!(popups[popups.length - 1] && !shouldRenderToParent && isDropdown)) {
                // Plucking trigger & popup content container from the tab order so that
                // when we Shift+Tab, the focus moves to the element before trigger
                requestFrame(function() {
                    triggerRef === null || triggerRef === void 0 || triggerRef.setAttribute('tabindex', '-1');
                    if (popupRef && autoFocus) popupRef.setAttribute('tabindex', '-1');
                    (initialFocusRef || popupRef).focus();
                });
                return 0, $3a341012e037de4f$export$2e2bcd8739ae039;
            }
        }
        var trapConfig = {
            clickOutsideDeactivates: true,
            escapeDeactivates: true,
            initialFocus: initialFocusRef || popupRef,
            fallbackFocus: popupRef,
            returnFocusOnDeactivate: shouldReturnFocus
        };
        var focusTrap = (0, (/*@__PURE__*/$parcel$interopDefault($b6Hjk)))(popupRef, trapConfig);
        // Wait for the popup to reposition itself before we focus
        requestFrame(function() {
            focusTrap.activate();
        });
        return function() {
            cancelAllFrames();
            focusTrap.deactivate();
        };
    }, [
        popupRef,
        triggerRef,
        autoFocus,
        initialFocusRef,
        shouldCloseOnTab,
        shouldDisableFocusTrap,
        requestFrame,
        cancelAllFrames,
        shouldReturnFocus,
        shouldRenderToParent,
        currentLevel
    ]);
};


var $5287728bcd8b6381$var$_excluded = [
    "shouldRenderToParent",
    "shouldFitContainer",
    "children",
    "appearance",
    "xcss"
];
var $5287728bcd8b6381$var$fullWidthStyles = (0, $74Zh5.css)({
    width: '100%'
});
var $5287728bcd8b6381$var$rootStyles = (0, $74Zh5.css)((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({
    display: 'block',
    boxSizing: 'border-box',
    zIndex: (0, $10b83e40731cc155$export$7be255094ccdc533).layer(),
    backgroundColor: "var(--ds-surface-overlay, ".concat((0, $d879fc455f6e75a0$export$29a4f05edc054374), ")"),
    borderRadius: "var(--ds-border-radius, 3px)",
    boxShadow: "var(--ds-shadow-overlay, ".concat("0 4px 8px -2px ".concat((0, $d879fc455f6e75a0$export$7d3359664e8bb0e5), ", 0 0 1px ").concat((0, $d879fc455f6e75a0$export$d2d3bedfb276cac0)), ")"),
    // Resetting text color for portal content.
    // Otherwise, when rendering into the parent (not using a portal),
    // the text color can be inherited from the parent.
    color: "var(--ds-text, #172B4D)"
}, (0, $dfb11b85b532f292$export$9d7b58831ae93caa), "var(--ds-surface-overlay, ".concat((0, $d879fc455f6e75a0$export$29a4f05edc054374), ")")), '&:focus', {
    outline: 'none'
}));
var $5287728bcd8b6381$var$scrollableStyles = (0, $74Zh5.css)({
    overflow: 'auto'
});
var $5287728bcd8b6381$var$blanketStyles = (0, $74Zh5.css)({
    position: 'fixed',
    inset: 0,
    backgroundColor: "var(--ds-blanket, #091E427D)"
});
var $5287728bcd8b6381$var$modalStyles = (0, $74Zh5.css)({
    maxHeight: '50vh',
    position: 'fixed',
    insetBlockStart: "var(--ds-space-050, 4px)",
    insetInline: "var(--ds-space-050, 4px)"
});
var $5287728bcd8b6381$var$DefaultPopupComponent = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function(props, ref) {
    var shouldRenderToParent = props.shouldRenderToParent, shouldFitContainer = props.shouldFitContainer, children = props.children, appearance = props.appearance, xcss = props.xcss, htmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(props, $5287728bcd8b6381$var$_excluded);
    return (0, $74Zh5.jsx)("div", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        // Because we're using Emotion local jsx namespace we have to coerce xcss prop to a string.
        // When we're fully on Compiled its local jsx namespace accepts the output of xcss prop.
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- This rule still fails because of the TS assertion
        className: xcss,
        css: [
            $5287728bcd8b6381$var$rootStyles,
            appearance === 'UNSAFE_modal-below-sm' && $5287728bcd8b6381$var$modalStyles,
            !shouldRenderToParent && $5287728bcd8b6381$var$scrollableStyles,
            shouldFitContainer && $5287728bcd8b6381$var$fullWidthStyles
        ]
    }, htmlAttributes, {
        ref: ref
    }), children);
});
function $5287728bcd8b6381$var$PopperWrapper(_ref) {
    var xcss = _ref.xcss, isOpen = _ref.isOpen, id = _ref.id, offset = _ref.offset, testId = _ref.testId, content = _ref.content, fallbackPlacements = _ref.fallbackPlacements, onClose = _ref.onClose, boundary = _ref.boundary, rootBoundary = _ref.rootBoundary, shouldFlip = _ref.shouldFlip, _ref$placement = _ref.placement, placement = _ref$placement === void 0 ? 'auto' : _ref$placement, _ref$popupComponent = _ref.popupComponent, PopupContainer = _ref$popupComponent === void 0 ? $5287728bcd8b6381$var$DefaultPopupComponent : _ref$popupComponent, _ref$autoFocus = _ref.autoFocus, autoFocus = _ref$autoFocus === void 0 ? true : _ref$autoFocus, triggerRef = _ref.triggerRef, shouldUseCaptureOnOutsideClick = _ref.shouldUseCaptureOnOutsideClick, shouldRenderToParent = _ref.shouldRenderToParent, shouldFitContainer = _ref.shouldFitContainer, shouldDisableFocusLock = _ref.shouldDisableFocusLock, _ref$shouldReturnFocu = _ref.shouldReturnFocus, shouldReturnFocus = _ref$shouldReturnFocu === void 0 ? true : _ref$shouldReturnFocu, strategy = _ref.strategy, role = _ref.role, label = _ref.label, titleId = _ref.titleId, modifiers = _ref.modifiers, shouldFitViewport = _ref.shouldFitViewport, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'default' : _ref$appearance;
    var _useState = (0, $5FkrB.useState)(null), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), popupRef = _useState2[0], setPopupRef = _useState2[1];
    var _useState3 = (0, $5FkrB.useState)(null), _useState4 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState3, 2), initialFocusRef = _useState4[0], setInitialFocusRef = _useState4[1];
    // We have cases where we need to close the Popup on Tab press, e.g. DropdownMenu
    var shouldCloseOnTab = shouldRenderToParent && shouldDisableFocusLock;
    var shouldDisableFocusTrap = role !== 'dialog';
    (0, $d926fa057629b6e5$export$10c5169755ce7bd7)({
        initialFocusRef: initialFocusRef,
        popupRef: popupRef,
        shouldCloseOnTab: shouldCloseOnTab,
        triggerRef: triggerRef,
        autoFocus: autoFocus,
        shouldDisableFocusTrap: shouldDisableFocusTrap,
        shouldReturnFocus: shouldReturnFocus
    });
    (0, $87f997011a7e17c0$export$92dae2778ae88f9d)({
        isOpen: isOpen,
        onClose: onClose,
        popupRef: popupRef,
        triggerRef: triggerRef,
        shouldUseCaptureOnOutsideClick: shouldUseCaptureOnOutsideClick,
        shouldCloseOnTab: shouldCloseOnTab,
        autoFocus: autoFocus,
        shouldDisableFocusTrap: shouldDisableFocusTrap,
        shouldRenderToParent: shouldRenderToParent
    });
    var _useLayering = (0, $88efd4caf07ed116$export$c8b4d54e03dee6ed)(), currentLevel = _useLayering.currentLevel;
    var mergedModifiers = (0, $5FkrB.useMemo)(function() {
        return [
            {
                name: 'flip',
                enabled: shouldFlip,
                options: {
                    rootBoundary: rootBoundary,
                    boundary: boundary,
                    fallbackPlacements: fallbackPlacements
                }
            }
        ].concat((0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(modifiers || []));
    }, [
        shouldFlip,
        rootBoundary,
        boundary,
        fallbackPlacements,
        modifiers
    ]);
    return (0, $74Zh5.jsx)((0, $d0d6728fff2cc74d$export$badac9ada3a0bdf9), {
        placement: placement,
        offset: offset,
        modifiers: mergedModifiers,
        strategy: strategy,
        shouldFitViewport: shouldFitViewport
    }, function(_ref2) {
        var _ref3 = _ref2.ref, style = _ref2.style, placement = _ref2.placement, update = _ref2.update;
        var popupContainer = (0, $74Zh5.jsx)(PopupContainer, {
            xcss: xcss,
            appearance: appearance,
            id: id,
            "data-ds--level": currentLevel,
            "data-placement": placement,
            "data-testid": testId,
            role: role,
            "aria-label": label,
            "aria-labelledby": titleId,
            ref: function ref(node) {
                if (node) {
                    if (typeof _ref3 === 'function') _ref3(node);
                    else _ref3.current = node;
                    setPopupRef(node);
                }
            },
            style: appearance === 'UNSAFE_modal-below-sm' ? {} : style,
            tabIndex: autoFocus ? 0 : undefined,
            shouldRenderToParent: shouldRenderToParent,
            shouldFitContainer: shouldFitContainer
        }, (0, $74Zh5.jsx)((0, $483dc76949219dff$export$51eddd7655ca235a), {
            update: update
        }, content({
            update: update,
            isOpen: isOpen,
            onClose: onClose,
            setInitialFocusRef: setInitialFocusRef
        })));
        return !initialFocusRef && (0, $dU8Y3.fg)('platform-design-system-apply-popup-wrapper-focus') ? (0, $74Zh5.jsx)((0, $5FkrB.Fragment), null, (0, $74Zh5.jsx)((0, $7e4032dad619a626$export$2e2bcd8739ae039), null, popupContainer), appearance === 'UNSAFE_modal-below-sm' && (0, $74Zh5.jsx)("div", {
            css: $5287728bcd8b6381$var$blanketStyles
        })) : (0, $74Zh5.jsx)((0, $5FkrB.Fragment), null, popupContainer, appearance === 'UNSAFE_modal-below-sm' && (0, $74Zh5.jsx)("div", {
            css: $5287728bcd8b6381$var$blanketStyles
        }));
    });
}
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$5287728bcd8b6381$export$2e2bcd8739ae039 = $5287728bcd8b6381$var$PopperWrapper;



var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");

var $5FkrB = parcelRequire("5FkrB");

var $7QpUe = parcelRequire("7QpUe");

var $5FkrB = parcelRequire("5FkrB");
var $aab05c5b0a7a3f8c$export$e5c5a5f917a5871c = typeof window === 'undefined' ? (0, $5FkrB.useEffect) : (0, $5FkrB.useLayoutEffect);


/**
 * This is an object of usable media query helpers using our internal breakpoints configuration.
 *
 * When using Compiled CSS-in-JS, please ensure that only a single declaration can take effect at a time.
 * This means that you should avoid multiple breakpoints taking effect at the same time,
 * eg. ```{ [media.above.xs]: { color: 'red' }, [media.above.sm]: { color: 'green' }}```.
 * Instead, make sure that only one breakpoint can take effect at a time,
 * e.g, ```{ [media.only.xs]: { color: 'red' }, [media.above.sm]: { color: 'green' }}```.
 * For more details, please see <https://compiledcssinjs.com/docs/atomic-css#selector-specificity>.
 */ var $223fba48ec05e503$export$987d49ffe1b0900f = {
    above: {
        xxs: '@media all',
        xs: '@media (min-width: 30rem)',
        sm: '@media (min-width: 48rem)',
        md: '@media (min-width: 64rem)',
        lg: '@media (min-width: 90rem)',
        xl: '@media (min-width: 110.5rem)'
    },
    only: {
        xxs: '@media (min-width: 0rem) and (max-width: 29.99rem)',
        xs: '@media (min-width: 30rem) and (max-width: 47.99rem)',
        sm: '@media (min-width: 48rem) and (max-width: 63.99rem)',
        md: '@media (min-width: 64rem) and (max-width: 89.99rem)',
        lg: '@media (min-width: 90rem) and (max-width: 110.49rem)',
        xl: '@media (min-width: 110.5rem)'
    },
    below: {
        xs: '@media not all and (min-width: 30rem)',
        sm: '@media not all and (min-width: 48rem)',
        md: '@media not all and (min-width: 64rem)',
        lg: '@media not all and (min-width: 90rem)',
        xl: '@media not all and (min-width: 110.5rem)'
    }
};
var $223fba48ec05e503$export$c881183ca713c214 = $223fba48ec05e503$export$987d49ffe1b0900f;


var $ea954643b2ddba49$var$_window, $ea954643b2ddba49$var$_window$matchMedia, $ea954643b2ddba49$var$_window2, $ea954643b2ddba49$var$_window2$matchMedia, $ea954643b2ddba49$var$_window3, $ea954643b2ddba49$var$_window3$matchMedia, $ea954643b2ddba49$var$_window4, $ea954643b2ddba49$var$_window4$matchMedia, $ea954643b2ddba49$var$_window5, $ea954643b2ddba49$var$_window5$matchMedia, $ea954643b2ddba49$var$_window6, $ea954643b2ddba49$var$_window6$matchMedia, $ea954643b2ddba49$var$_window7, $ea954643b2ddba49$var$_window7$matchMedia, $ea954643b2ddba49$var$_window8, $ea954643b2ddba49$var$_window8$matchMedia, $ea954643b2ddba49$var$_window9, $ea954643b2ddba49$var$_window9$matchMedia, $ea954643b2ddba49$var$_window10, $ea954643b2ddba49$var$_window10$matchMedia, $ea954643b2ddba49$var$_window11, $ea954643b2ddba49$var$_window11$matchMedia;
var $ea954643b2ddba49$var$queries = {
    'above.xxs': typeof window === 'undefined' ? undefined : ($ea954643b2ddba49$var$_window = window) === null || $ea954643b2ddba49$var$_window === void 0 || ($ea954643b2ddba49$var$_window$matchMedia = $ea954643b2ddba49$var$_window.matchMedia) === null || $ea954643b2ddba49$var$_window$matchMedia === void 0 ? void 0 : $ea954643b2ddba49$var$_window$matchMedia.call($ea954643b2ddba49$var$_window, (0, $223fba48ec05e503$export$c881183ca713c214).above.xxs.replace('@media ', '').trim()),
    'above.xs': typeof window === 'undefined' ? undefined : ($ea954643b2ddba49$var$_window2 = window) === null || $ea954643b2ddba49$var$_window2 === void 0 || ($ea954643b2ddba49$var$_window2$matchMedia = $ea954643b2ddba49$var$_window2.matchMedia) === null || $ea954643b2ddba49$var$_window2$matchMedia === void 0 ? void 0 : $ea954643b2ddba49$var$_window2$matchMedia.call($ea954643b2ddba49$var$_window2, (0, $223fba48ec05e503$export$c881183ca713c214).above.xs.replace('@media ', '').trim()),
    'above.sm': typeof window === 'undefined' ? undefined : ($ea954643b2ddba49$var$_window3 = window) === null || $ea954643b2ddba49$var$_window3 === void 0 || ($ea954643b2ddba49$var$_window3$matchMedia = $ea954643b2ddba49$var$_window3.matchMedia) === null || $ea954643b2ddba49$var$_window3$matchMedia === void 0 ? void 0 : $ea954643b2ddba49$var$_window3$matchMedia.call($ea954643b2ddba49$var$_window3, (0, $223fba48ec05e503$export$c881183ca713c214).above.sm.replace('@media ', '').trim()),
    'above.md': typeof window === 'undefined' ? undefined : ($ea954643b2ddba49$var$_window4 = window) === null || $ea954643b2ddba49$var$_window4 === void 0 || ($ea954643b2ddba49$var$_window4$matchMedia = $ea954643b2ddba49$var$_window4.matchMedia) === null || $ea954643b2ddba49$var$_window4$matchMedia === void 0 ? void 0 : $ea954643b2ddba49$var$_window4$matchMedia.call($ea954643b2ddba49$var$_window4, (0, $223fba48ec05e503$export$c881183ca713c214).above.md.replace('@media ', '').trim()),
    'above.lg': typeof window === 'undefined' ? undefined : ($ea954643b2ddba49$var$_window5 = window) === null || $ea954643b2ddba49$var$_window5 === void 0 || ($ea954643b2ddba49$var$_window5$matchMedia = $ea954643b2ddba49$var$_window5.matchMedia) === null || $ea954643b2ddba49$var$_window5$matchMedia === void 0 ? void 0 : $ea954643b2ddba49$var$_window5$matchMedia.call($ea954643b2ddba49$var$_window5, (0, $223fba48ec05e503$export$c881183ca713c214).above.lg.replace('@media ', '').trim()),
    'above.xl': typeof window === 'undefined' ? undefined : ($ea954643b2ddba49$var$_window6 = window) === null || $ea954643b2ddba49$var$_window6 === void 0 || ($ea954643b2ddba49$var$_window6$matchMedia = $ea954643b2ddba49$var$_window6.matchMedia) === null || $ea954643b2ddba49$var$_window6$matchMedia === void 0 ? void 0 : $ea954643b2ddba49$var$_window6$matchMedia.call($ea954643b2ddba49$var$_window6, (0, $223fba48ec05e503$export$c881183ca713c214).above.xl.replace('@media ', '').trim()),
    'below.xs': typeof window === 'undefined' ? undefined : ($ea954643b2ddba49$var$_window7 = window) === null || $ea954643b2ddba49$var$_window7 === void 0 || ($ea954643b2ddba49$var$_window7$matchMedia = $ea954643b2ddba49$var$_window7.matchMedia) === null || $ea954643b2ddba49$var$_window7$matchMedia === void 0 ? void 0 : $ea954643b2ddba49$var$_window7$matchMedia.call($ea954643b2ddba49$var$_window7, (0, $223fba48ec05e503$export$c881183ca713c214).below.xs.replace('@media ', '').trim()),
    'below.sm': typeof window === 'undefined' ? undefined : ($ea954643b2ddba49$var$_window8 = window) === null || $ea954643b2ddba49$var$_window8 === void 0 || ($ea954643b2ddba49$var$_window8$matchMedia = $ea954643b2ddba49$var$_window8.matchMedia) === null || $ea954643b2ddba49$var$_window8$matchMedia === void 0 ? void 0 : $ea954643b2ddba49$var$_window8$matchMedia.call($ea954643b2ddba49$var$_window8, (0, $223fba48ec05e503$export$c881183ca713c214).below.sm.replace('@media ', '').trim()),
    'below.md': typeof window === 'undefined' ? undefined : ($ea954643b2ddba49$var$_window9 = window) === null || $ea954643b2ddba49$var$_window9 === void 0 || ($ea954643b2ddba49$var$_window9$matchMedia = $ea954643b2ddba49$var$_window9.matchMedia) === null || $ea954643b2ddba49$var$_window9$matchMedia === void 0 ? void 0 : $ea954643b2ddba49$var$_window9$matchMedia.call($ea954643b2ddba49$var$_window9, (0, $223fba48ec05e503$export$c881183ca713c214).below.md.replace('@media ', '').trim()),
    'below.lg': typeof window === 'undefined' ? undefined : ($ea954643b2ddba49$var$_window10 = window) === null || $ea954643b2ddba49$var$_window10 === void 0 || ($ea954643b2ddba49$var$_window10$matchMedia = $ea954643b2ddba49$var$_window10.matchMedia) === null || $ea954643b2ddba49$var$_window10$matchMedia === void 0 ? void 0 : $ea954643b2ddba49$var$_window10$matchMedia.call($ea954643b2ddba49$var$_window10, (0, $223fba48ec05e503$export$c881183ca713c214).below.lg.replace('@media ', '').trim()),
    'below.xl': typeof window === 'undefined' ? undefined : ($ea954643b2ddba49$var$_window11 = window) === null || $ea954643b2ddba49$var$_window11 === void 0 || ($ea954643b2ddba49$var$_window11$matchMedia = $ea954643b2ddba49$var$_window11.matchMedia) === null || $ea954643b2ddba49$var$_window11$matchMedia === void 0 ? void 0 : $ea954643b2ddba49$var$_window11$matchMedia.call($ea954643b2ddba49$var$_window11, (0, $223fba48ec05e503$export$c881183ca713c214).below.xl.replace('@media ', '').trim())
};
var $ea954643b2ddba49$export$49e55ae2c03d6045 = function UNSAFE_useMediaQuery(queryString, listener) {
    var listenerRef = (0, $5FkrB.useRef)(listener);
    (0, $5FkrB.useEffect)(function() {
        // Bind the listener if changed so it's called on the next change event; no guarantee on timing.
        listenerRef.current = listener;
    }, [
        listener
    ]);
    /**
   * We explicitly only react to boolean changes for binding our listener
   * Changes to the functional reference are ignored.
   */ var hasListener = !!listener;
    /**
   * The `matchMedia(…)` return value for our breakpoint query.
   */ var mq = $ea954643b2ddba49$var$queries[queryString];
    (0, $aab05c5b0a7a3f8c$export$e5c5a5f917a5871c)(function() {
        listenerRef.current = listener; // Bind the listener now in case the `useEffect` hasn't fired above yet
        if (!mq || !hasListener || !listenerRef.current) return;
        return (0, $7QpUe.bind)(mq, {
            type: 'change',
            listener: function listener(event) {
                // We explicitly call the current version of the function
                return listenerRef.current(event);
            }
        });
    }, // eslint-disable-next-line react-hooks/exhaustive-deps -- explicitly do not trigger the effect on `listener` reference change, only on a boolean representation of it.
    [
        mq,
        hasListener
    ]);
    return mq || null;
};


function $cd2f53b335f2ed07$export$4065aef1d79a5730(_ref) {
    var _appearance = _ref.appearance, _shouldRenderToParent = _ref.shouldRenderToParent;
    var mq = (0, $ea954643b2ddba49$export$49e55ae2c03d6045)('below.sm', function(e) {
        setIsSmallViewport(!!e.matches);
    });
    var _useState = (0, $5FkrB.useState)(!!(mq !== null && mq !== void 0 && mq.matches)), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), isSmallViewport = _useState2[0], setIsSmallViewport = _useState2[1];
    var appearance = _appearance === 'UNSAFE_modal-below-sm' && isSmallViewport ? 'UNSAFE_modal-below-sm' : 'default';
    var shouldRenderToParent = _shouldRenderToParent && appearance === 'default';
    return {
        appearance: appearance,
        shouldRenderToParent: shouldRenderToParent
    };
}



var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");

var $cvlyC = parcelRequire("cvlyC");
var $8dac168dfc6e5491$export$7cc5c058dd769dff = function useGetMemoizedMergedTriggerRef() {
    var _useState = (0, $5FkrB.useState)(function() {
        return (0, $cvlyC.default)(function(ref, setTriggerRef, isOpen) {
            return function(node) {
                if (node && isOpen) {
                    if (typeof ref === 'function') ref(node);
                    else if (ref) ref.current = node;
                    setTriggerRef(node);
                }
            };
        });
    }), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 1), getMemoizedMergedTriggerRef = _useState2[0];
    return getMemoizedMergedTriggerRef;
};



var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");

var $cvlyC = parcelRequire("cvlyC");
var $45ca7f41d2278ef9$export$5d3a2de79e07b376 = function useGetMemoizedMergedTriggerRefNew() {
    var _useState = (0, $5FkrB.useState)(function() {
        return (0, $cvlyC.default)(function(ref, setTriggerRef) {
            return function(node) {
                if (node) {
                    if (typeof ref === 'function') ref(node);
                    else if (ref) ref.current = node;
                    setTriggerRef(node);
                }
            };
        });
    }), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 1), getMemoizedMergedTriggerRefNew = _useState2[0];
    return getMemoizedMergedTriggerRefNew;
};


var $9bd4a3391294b0ad$var$defaultLayer = (0, $10b83e40731cc155$export$7be255094ccdc533).layer();
var $9bd4a3391294b0ad$var$wrapperStyles = (0, $a8477e78427cc4b7$export$f6c783d06584602c)({
    position: 'relative'
});
var $9bd4a3391294b0ad$export$129a32eedafa97c5 = /*#__PURE__*/ (0, $5FkrB.memo)(function(_ref) {
    var xcss = _ref.xcss, _ref$appearance = _ref.appearance, inAppearance = _ref$appearance === void 0 ? 'default' : _ref$appearance, isOpen = _ref.isOpen, providedId = _ref.id, offset = _ref.offset, testId = _ref.testId, trigger = _ref.trigger, content = _ref.content, onClose = _ref.onClose, boundary = _ref.boundary, _ref$rootBoundary = _ref.rootBoundary, rootBoundary = _ref$rootBoundary === void 0 ? 'viewport' : _ref$rootBoundary, _ref$shouldFlip = _ref.shouldFlip, shouldFlip = _ref$shouldFlip === void 0 ? true : _ref$shouldFlip, _ref$placement = _ref.placement, placement = _ref$placement === void 0 ? 'auto' : _ref$placement, fallbackPlacements = _ref.fallbackPlacements, PopupContainer = _ref.popupComponent, _ref$autoFocus = _ref.autoFocus, autoFocus = _ref$autoFocus === void 0 ? true : _ref$autoFocus, _ref$zIndex = _ref.zIndex, zIndex = _ref$zIndex === void 0 ? $9bd4a3391294b0ad$var$defaultLayer : _ref$zIndex, _ref$shouldUseCapture = _ref.shouldUseCaptureOnOutsideClick, shouldUseCaptureOnOutsideClick = _ref$shouldUseCapture === void 0 ? false : _ref$shouldUseCapture, _ref$shouldRenderToPa = _ref.shouldRenderToParent, inShouldRenderToParent = _ref$shouldRenderToPa === void 0 ? false : _ref$shouldRenderToPa, _ref$shouldFitContain = _ref.shouldFitContainer, shouldFitContainer = _ref$shouldFitContain === void 0 ? false : _ref$shouldFitContain, _ref$shouldDisableFoc = _ref.shouldDisableFocusLock, shouldDisableFocusLock = _ref$shouldDisableFoc === void 0 ? false : _ref$shouldDisableFoc, _ref$shouldReturnFocu = _ref.shouldReturnFocus, shouldReturnFocus = _ref$shouldReturnFocu === void 0 ? true : _ref$shouldReturnFocu, strategy = _ref.strategy, role = _ref.role, label = _ref.label, titleId = _ref.titleId, modifiers = _ref.modifiers, shouldFitViewport = _ref.shouldFitViewport;
    var _useState = (0, $5FkrB.useState)(null), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), triggerRef = _useState2[0], setTriggerRef = _useState2[1];
    var getMergedTriggerRef = (0, $8dac168dfc6e5491$export$7cc5c058dd769dff)();
    var getMergedTriggerRefNew = (0, $45ca7f41d2278ef9$export$5d3a2de79e07b376)();
    var generatedId = (0, $24526c38f36cc756$export$f680877a34711e37)();
    var _usePopupAppearance = (0, $cd2f53b335f2ed07$export$4065aef1d79a5730)({
        appearance: inAppearance,
        shouldRenderToParent: inShouldRenderToParent
    }), appearance = _usePopupAppearance.appearance, shouldRenderToParent = _usePopupAppearance.shouldRenderToParent;
    var id = providedId || generatedId;
    (0, $346f36c0232779ff$export$469bb693f11edc7f)({
        isOpen: isOpen
    });
    var renderPopperWrapper = (0, $74Zh5.jsx)((0, $5be177ba607b9a5f$export$7c885f891c940977), {
        isDisabled: false
    }, (0, $74Zh5.jsx)((0, $5287728bcd8b6381$export$2e2bcd8739ae039), {
        xcss: xcss,
        appearance: appearance,
        content: content,
        isOpen: isOpen,
        placement: placement,
        fallbackPlacements: fallbackPlacements,
        boundary: boundary,
        rootBoundary: rootBoundary,
        shouldFlip: shouldFlip,
        offset: offset,
        popupComponent: PopupContainer,
        id: id,
        testId: testId,
        onClose: onClose,
        autoFocus: autoFocus,
        shouldUseCaptureOnOutsideClick: shouldUseCaptureOnOutsideClick,
        shouldRenderToParent: shouldRenderToParent || shouldFitContainer,
        shouldFitContainer: shouldFitContainer,
        shouldDisableFocusLock: shouldDisableFocusLock,
        shouldReturnFocus: shouldReturnFocus,
        triggerRef: triggerRef,
        strategy: shouldFitContainer ? 'absolute' : strategy,
        role: role,
        label: label,
        titleId: titleId,
        modifiers: modifiers,
        shouldFitViewport: shouldFitViewport
    }));
    var popupContent = (0, $74Zh5.jsx)((0, $hvYLl.Manager), null, (0, $74Zh5.jsx)((0, $agyC9.Reference), null, function(_ref2) {
        var ref = _ref2.ref;
        return trigger({
            ref: !(0, $dU8Y3.fg)('platform-design-system-popup-ref') ? getMergedTriggerRef(ref, setTriggerRef, isOpen) : getMergedTriggerRefNew(ref, setTriggerRef),
            'aria-controls': isOpen ? id : undefined,
            'aria-expanded': isOpen,
            'aria-haspopup': role === 'dialog' && (0, $dU8Y3.fg)('platform_dst_popup-disable-focuslock') ? 'dialog' : true
        });
    }), isOpen && (shouldRenderToParent || shouldFitContainer ? renderPopperWrapper : (0, $74Zh5.jsx)((0, $a038809878bd7654$export$2e2bcd8739ae039), {
        zIndex: zIndex
    }, renderPopperWrapper)));
    if (shouldFitContainer) return (0, $74Zh5.jsx)((0, $d007f17589e0f9b9$export$2e2bcd8739ae039), {
        xcss: $9bd4a3391294b0ad$var$wrapperStyles
    }, popupContent);
    return popupContent;
});
var $9bd4a3391294b0ad$export$2e2bcd8739ae039 = $9bd4a3391294b0ad$export$129a32eedafa97c5;


var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$b36dd04f01c3a491$export$2e2bcd8739ae039 = (0, $9bd4a3391294b0ad$export$129a32eedafa97c5);




var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");

var $7QpUe = parcelRequire("7QpUe");



var $25nEq = parcelRequire("25nEq");


var $dU8Y3 = parcelRequire("dU8Y3");

var $ddd3993c923b373a$export$8a682ae47622dbb9 = 'ds--dropdown--';
function $ddd3993c923b373a$export$2e2bcd8739ae039() {
    var id = (0, $24526c38f36cc756$export$f680877a34711e37)();
    return "".concat($ddd3993c923b373a$export$8a682ae47622dbb9).concat(id);
}


var $53c800e14611e521$var$actionMap = (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, (0, $e27a1598a26ffda3$export$a80636c6f41931fe), 'next'), (0, $e27a1598a26ffda3$export$390330c10ff2b9a1), 'prev'), (0, $e27a1598a26ffda3$export$4af703091671bc), 'first'), (0, $e27a1598a26ffda3$export$e2bc30913faa5db7), 'last');
/**
 * `currentFocusedIdx + 1` will not work if the next focusable element
 * is disabled. So, we need to iterate through the following menu items
 * to find one that isn't disabled. If all following elements are disabled,
 * return undefined.
 */ var $53c800e14611e521$var$getNextFocusableElement = function getNextFocusableElement(refs, currentFocusedIdx) {
    while(currentFocusedIdx + 1 < refs.length){
        var element = refs[++currentFocusedIdx].current;
        var isValid = !!element && !element.hasAttribute('disabled');
        if (isValid) return element;
    }
};
/**
 * `currentFocusedIdx - 1` will not work if the prev focusable element
 * is disabled. So, we need to iterate through the previous menu items
 * to find one that isn't disabled. If all previous elements are disabled,
 * return undefined.
 */ var $53c800e14611e521$var$getPrevFocusableElement = function getPrevFocusableElement(refs, currentFocusedIdx) {
    while(currentFocusedIdx > 0){
        var element = refs[--currentFocusedIdx].current;
        var isValid = !!element && !element.hasAttribute('disabled');
        if (isValid) return element;
    }
};
function $53c800e14611e521$export$2e2bcd8739ae039(refs, isLayerDisabled, onClose) {
    return function(e) {
        var _refs$current;
        var currentRefs = (_refs$current = refs.current) !== null && _refs$current !== void 0 ? _refs$current : [];
        var currentFocusedIdx = currentRefs.findIndex(function(_ref) {
            var _document$activeEleme;
            var el = _ref.current;
            return el && ((_document$activeEleme = document.activeElement) === null || _document$activeEleme === void 0 ? void 0 : _document$activeEleme.isSameNode(el));
        });
        if ((0, $dU8Y3.fg)('platform_dst_popup-disable-focuslock')) {
            var _document$activeEleme2;
            // if we use a popup as a nested dropdown, we must prevent the dropdown from closing.
            var isNestedDropdown = !!((_document$activeEleme2 = document.activeElement) !== null && _document$activeEleme2 !== void 0 && _document$activeEleme2.closest("[id^=".concat((0, $ddd3993c923b373a$export$8a682ae47622dbb9), "]")));
            if (isLayerDisabled() && isNestedDropdown) {
                if (e.key === (0, $e27a1598a26ffda3$export$10f6869ed0a7d75b) && !e.shiftKey) onClose(e);
                // if it is a nested dropdown and the level of the given dropdown is not the current level,
                // we don't need to have focus on it
                return;
            }
        } else if (isLayerDisabled()) {
            if (e.key === (0, $e27a1598a26ffda3$export$10f6869ed0a7d75b) && !e.shiftKey) onClose(e);
            // if it is a nested dropdown and the level of the given dropdown is not the current level,
            // we don't need to have focus on it
            return;
        }
        var action = $53c800e14611e521$var$actionMap[e.key];
        switch(action){
            case 'next':
                // Always cancelling the event to prevent scrolling
                e.preventDefault();
                if (currentFocusedIdx < currentRefs.length - 1) {
                    var _nextFocusableElement = $53c800e14611e521$var$getNextFocusableElement(currentRefs, currentFocusedIdx);
                    _nextFocusableElement === null || _nextFocusableElement === void 0 || _nextFocusableElement.focus();
                } else {
                    var firstFocusableElement = $53c800e14611e521$var$getNextFocusableElement(currentRefs, -1);
                    firstFocusableElement === null || firstFocusableElement === void 0 || firstFocusableElement.focus();
                }
                break;
            case 'prev':
                // Always cancelling the event to prevent scrolling
                e.preventDefault();
                if (currentFocusedIdx > 0) {
                    var _prevFocusableElement = $53c800e14611e521$var$getPrevFocusableElement(currentRefs, currentFocusedIdx);
                    _prevFocusableElement === null || _prevFocusableElement === void 0 || _prevFocusableElement.focus();
                } else {
                    var lastFocusableElement = $53c800e14611e521$var$getPrevFocusableElement(currentRefs, currentRefs.length);
                    lastFocusableElement === null || lastFocusableElement === void 0 || lastFocusableElement.focus();
                }
                break;
            case 'first':
                e.preventDefault();
                // Search for first non-disabled element if first element is disabled
                var nextFocusableElement = $53c800e14611e521$var$getNextFocusableElement(currentRefs, -1);
                nextFocusableElement === null || nextFocusableElement === void 0 || nextFocusableElement.focus();
                break;
            case 'last':
                e.preventDefault();
                // Search for last non-disabled element if last element is disabled
                var prevFocusableElement = $53c800e14611e521$var$getPrevFocusableElement(currentRefs, currentRefs.length);
                prevFocusableElement === null || prevFocusableElement === void 0 || prevFocusableElement.focus();
                break;
            default:
                return;
        }
    };
}


var $732d8fed4cea8f22$export$f18c1d4fc7326096 = /*#__PURE__*/ (0, $5FkrB.createContext)({
    menuItemRefs: [],
    registerRef: (0, $3a341012e037de4f$export$2e2bcd8739ae039)
});
/**
 * Focus manager logic.
 */ var $732d8fed4cea8f22$var$FocusManager = function FocusManager(_ref) {
    var children = _ref.children, onClose = _ref.onClose;
    var menuItemRefs = (0, $5FkrB.useRef)([]);
    // Used to force a re-render only
    var _useState = (0, $5FkrB.useState)(0), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), refresh = _useState2[0], setRefresh = _useState2[1];
    var registerMode = (0, $5FkrB.useRef)('ordered');
    registerMode.current = 'ordered';
    var registerRef = (0, $5FkrB.useCallback)(function(ref) {
        if (menuItemRefs.current.includes(ref)) return;
        switch(registerMode.current){
            case 'ordered':
                menuItemRefs.current.push(ref);
                break;
            case 'unordered':
                // Reset and force a rerender
                registerMode.current = 'regenerate';
                menuItemRefs.current = [];
                setRefresh(refresh + 1);
                break;
            case 'regenerate':
                break;
            default:
                throw new Error("Unexpected case of ".concat(registerMode.current));
        }
    }, // Updating register ref on force reload will cause `useRegisterItemWithFocusManager` to re-register
    [
        refresh
    ]);
    var _useLayering = (0, $88efd4caf07ed116$export$c8b4d54e03dee6ed)(), isLayerDisabled = _useLayering.isLayerDisabled;
    // Intentionally rebinding on each render
    (0, $5FkrB.useEffect)(function() {
        if (registerMode.current === 'ordered') // Use effect is called after rendering is complete and useEffects of the children a called first
        registerMode.current = 'unordered';
    });
    (0, $5FkrB.useEffect)(function() {
        return (0, $7QpUe.bind)(window, {
            type: 'keydown',
            listener: (0, $53c800e14611e521$export$2e2bcd8739ae039)(menuItemRefs, isLayerDisabled, onClose)
        });
    }, [
        isLayerDisabled,
        onClose
    ]);
    var contextValue = {
        menuItemRefs: menuItemRefs.current,
        registerRef: registerRef
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement($732d8fed4cea8f22$export$f18c1d4fc7326096.Provider, {
        value: contextValue
    }, children);
};
var $732d8fed4cea8f22$export$2e2bcd8739ae039 = $732d8fed4cea8f22$var$FocusManager;


/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5FkrB = parcelRequire("5FkrB");

var $74Zh5 = parcelRequire("74Zh5");

var $kqp0i = parcelRequire("kqp0i");

var $1Vcia = parcelRequire("1Vcia");

var $74Zh5 = parcelRequire("74Zh5");

var $5FkrB = parcelRequire("5FkrB");
var $029784b0740265a3$export$443076ec7ebce042 = /*#__PURE__*/ (0, $5FkrB.createContext)('cozy');
var $029784b0740265a3$export$9ca534b70725964d = /*#__PURE__*/ (0, $5FkrB.createContext)('border');


var $4dd7739ff03cb484$var$_excluded = [
    "isLoading",
    "maxWidth",
    "minWidth",
    "minHeight",
    "maxHeight",
    "testId",
    "role",
    "spacing",
    "className"
];
var $4dd7739ff03cb484$var$baseStyles = (0, $74Zh5.css)({
    display: 'flex',
    position: 'static',
    flexDirection: 'column',
    overflow: 'auto'
});
/**
 * __Menu group__
 *
 * A menu group includes all the actions or items in a menu.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/menu/docs/menu-group)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/menu)
 */ var $4dd7739ff03cb484$var$MenuGroup = function MenuGroup(_ref) {
    var isLoading = _ref.isLoading, maxWidth = _ref.maxWidth, minWidth = _ref.minWidth, minHeight = _ref.minHeight, maxHeight = _ref.maxHeight, testId = _ref.testId, role = _ref.role, _ref$spacing = _ref.spacing, spacing = _ref$spacing === void 0 ? 'cozy' : _ref$spacing, UNSAFE_className = _ref.className, rest = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $4dd7739ff03cb484$var$_excluded);
    return (0, $74Zh5.jsx)((0, $029784b0740265a3$export$443076ec7ebce042).Provider, {
        value: spacing
    }, (0, $74Zh5.jsx)((0, $029784b0740265a3$export$9ca534b70725964d).Provider, {
        value: "border"
    }, (0, $74Zh5.jsx)("div", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        "aria-busy": isLoading,
        style: {
            minWidth: minWidth,
            maxWidth: maxWidth,
            minHeight: minHeight,
            maxHeight: maxHeight
        },
        css: $4dd7739ff03cb484$var$baseStyles,
        "data-testid": testId,
        role: role,
        className: UNSAFE_className
    }, rest))));
};
var $4dd7739ff03cb484$export$2e2bcd8739ae039 = $4dd7739ff03cb484$var$MenuGroup;




function $8a07363b08703372$export$2e2bcd8739ae039(element) {
    var role = element.getAttribute('role');
    return role === 'checkbox' || role === 'menuitemcheckbox';
}


function $f60049cc6bf61b68$export$2e2bcd8739ae039(element) {
    var role = element.getAttribute('role');
    return role === 'radio' || role === 'menuitemradio';
}



var $60be549fc44af1f1$var$spinnerContainerStyles = (0, $a8477e78427cc4b7$export$f6c783d06584602c)({
    display: 'flex',
    minWidth: '160px',
    padding: 'space.250',
    justifyContent: 'center'
});
var $60be549fc44af1f1$var$LoadingIndicator = function LoadingIndicator(_ref) {
    var _ref$statusLabel = _ref.statusLabel, statusLabel = _ref$statusLabel === void 0 ? 'Loading' : _ref$statusLabel, testId = _ref.testId;
    return (0, $74Zh5.jsx)((0, $d007f17589e0f9b9$export$2e2bcd8739ae039), {
        xcss: $60be549fc44af1f1$var$spinnerContainerStyles
    }, (0, $74Zh5.jsx)((0, $cd099e806837dee6$export$2e2bcd8739ae039), {
        size: "small",
        label: statusLabel,
        testId: testId
    }));
};
/**
 *
 * MenuWrapper wraps all the menu items.
 * It handles the logic to close the menu when a MenuItem is clicked, but leaves it open
 * if a CheckboxItem or RadioItem is clicked.
 * It also sets focus to the first menu item when opened.
 */ var $60be549fc44af1f1$var$MenuWrapper = function MenuWrapper(_ref2) {
    var children = _ref2.children, isLoading = _ref2.isLoading, maxHeight = _ref2.maxHeight, maxWidth = _ref2.maxWidth, onClose = _ref2.onClose, onUpdate = _ref2.onUpdate, statusLabel = _ref2.statusLabel, setInitialFocusRef = _ref2.setInitialFocusRef, shouldRenderToParent = _ref2.shouldRenderToParent, spacing = _ref2.spacing, testId = _ref2.testId, isTriggeredUsingKeyboard = _ref2.isTriggeredUsingKeyboard, autoFocus = _ref2.autoFocus;
    var _useContext = (0, $5FkrB.useContext)((0, $732d8fed4cea8f22$export$f18c1d4fc7326096)), menuItemRefs = _useContext.menuItemRefs;
    var closeOnMenuItemClick = function closeOnMenuItemClick(e) {
        var isTargetMenuItemOrDescendant = menuItemRefs.some(function(menuItemRef) {
            var menuItem = menuItemRef.current;
            if (!menuItem) return false;
            var isCheckboxOrRadio = (0, $8a07363b08703372$export$2e2bcd8739ae039)(menuItem) || (0, $f60049cc6bf61b68$export$2e2bcd8739ae039)(menuItem);
            return menuItem.contains(e.target) && !isCheckboxOrRadio;
        });
        // Close menu if the click is triggered from a MenuItem or
        // its descendant. Don't close the menu if the click is triggered
        // from a MenuItemRadio or MenuItemCheckbox so that the user can
        // select multiple items.
        if (isTargetMenuItemOrDescendant && onClose) onClose(e);
    };
    // Using useEffect here causes a flicker.
    // useLayoutEffect ensures that the update and render happen in the same
    // rAF tick.
    (0, $5FkrB.useLayoutEffect)(function() {
        onUpdate();
    }, [
        isLoading,
        onUpdate
    ]);
    (0, $5FkrB.useEffect)(function() {
        var _menuItemRefs$map$fin;
        var firstFocusableRef = (_menuItemRefs$map$fin = menuItemRefs.map(function(_ref3) {
            var current = _ref3.current;
            return current;
        }).find(function(el) {
            return !!el && !el.hasAttribute('disabled');
        })) !== null && _menuItemRefs$map$fin !== void 0 ? _menuItemRefs$map$fin : null;
        if (shouldRenderToParent && (isTriggeredUsingKeyboard || autoFocus)) firstFocusableRef === null || firstFocusableRef === void 0 || firstFocusableRef.focus();
        setInitialFocusRef === null || setInitialFocusRef === void 0 || setInitialFocusRef(firstFocusableRef);
    }, [
        menuItemRefs,
        setInitialFocusRef,
        autoFocus,
        shouldRenderToParent,
        isTriggeredUsingKeyboard
    ]);
    return (0, $74Zh5.jsx)((0, $4dd7739ff03cb484$export$2e2bcd8739ae039), {
        isLoading: isLoading,
        maxHeight: maxHeight,
        maxWidth: maxWidth,
        onClick: closeOnMenuItemClick,
        role: "menu",
        spacing: spacing,
        testId: testId && "".concat(testId, "--menu-group")
    }, isLoading ? (0, $74Zh5.jsx)($60be549fc44af1f1$var$LoadingIndicator, {
        statusLabel: statusLabel,
        testId: testId && "".concat(testId, "--loading-indicator")
    }) : children);
};
var $60be549fc44af1f1$export$2e2bcd8739ae039 = $60be549fc44af1f1$var$MenuWrapper;



var $5FkrB = parcelRequire("5FkrB");

var $6c8d7d354dcb5a30$export$756f795847463ebd = /*#__PURE__*/ (0, $5FkrB.createContext)({
    setItemState: (0, $3a341012e037de4f$export$2e2bcd8739ae039),
    getItemState: function getItemState() {
        return undefined;
    },
    setGroupState: (0, $3a341012e037de4f$export$2e2bcd8739ae039),
    getGroupState: function getGroupState() {
        return {};
    }
});
/**
 * Selection store will persist data as long as it remains mounted.
 * It handles the uncontrolled story for dropdown menu when the menu
 * items can be mounted/unmounted depending if the menu is open or closed.
 */ var $6c8d7d354dcb5a30$var$SelectionStore = function SelectionStore(props) {
    var children = props.children;
    var store = (0, $5FkrB.useRef)({});
    var context = (0, $5FkrB.useMemo)(function() {
        return {
            setItemState: function setItemState(group, id, value) {
                if (!store.current[group]) store.current[group] = {};
                store.current[group][id] = value;
            },
            getItemState: function getItemState(group, id) {
                if (!store.current[group]) return undefined;
                return store.current[group][id];
            },
            setGroupState: function setGroupState(group, value) {
                store.current[group] = value;
            },
            getGroupState: function getGroupState(group) {
                return store.current[group] || {};
            }
        };
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement($6c8d7d354dcb5a30$export$756f795847463ebd.Provider, {
        value: context
    }, children);
};
var $6c8d7d354dcb5a30$export$2e2bcd8739ae039 = $6c8d7d354dcb5a30$var$SelectionStore;



var $5FkrB = parcelRequire("5FkrB");

var $dU8Y3 = parcelRequire("dU8Y3");

// This function is called whenever a MenuItem mounts.
// The refs stored in the context are used to programmatically
// control focus on a user navigates using the keyboard.
function $342103062545c958$var$useRegisterItemWithFocusManager() {
    var hasPopup = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    var _useContext = (0, $5FkrB.useContext)((0, $732d8fed4cea8f22$export$f18c1d4fc7326096)), registerRef = _useContext.registerRef;
    var itemRef = (0, $5FkrB.useRef)(null);
    (0, $5FkrB.useEffect)(function() {
        if (hasPopup && (0, $dU8Y3.fg)('select-avoid-duplicated-registered-ref')) return;
        registerRef(itemRef);
    }, [
        registerRef,
        hasPopup
    ]);
    return itemRef;
}
var $342103062545c958$export$2e2bcd8739ae039 = $342103062545c958$var$useRegisterItemWithFocusManager;



var $9e29898158274f39$var$_excluded = [
    "ref",
    "aria-controls",
    "aria-expanded",
    "aria-haspopup"
];
function $9e29898158274f39$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $9e29898158274f39$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $9e29898158274f39$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $9e29898158274f39$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $9e29898158274f39$var$gridSize = (0, $10b83e40731cc155$export$6d8204c2cb2e06b8)();
var $9e29898158274f39$var$MAX_HEIGHT = "calc(100vh - ".concat($9e29898158274f39$var$gridSize * 2, "px)");
var $9e29898158274f39$var$opposites = {
    top: 'bottom',
    bottom: 'top',
    left: 'right',
    right: 'left',
    start: 'end',
    auto: 'auto',
    end: 'start'
};
var $9e29898158274f39$var$getFallbackPlacements = function getFallbackPlacements(placement) {
    var placementPieces = placement.split('-');
    var mainAxis = placementPieces[0];
    // Left, right and auto placements can rely on standard popper sliding behaviour
    if (![
        'top',
        'bottom'
    ].includes(mainAxis)) return undefined;
    else if (placementPieces.length === 2 && [
        'start',
        'end'
    ].includes(placementPieces[1])) {
        var crossAxis = placementPieces[1];
        return [
            "".concat(mainAxis),
            "".concat(mainAxis, "-").concat($9e29898158274f39$var$opposites[crossAxis]),
            "".concat($9e29898158274f39$var$opposites[mainAxis], "-").concat(crossAxis),
            "".concat($9e29898158274f39$var$opposites[mainAxis]),
            "".concat($9e29898158274f39$var$opposites[mainAxis], "-").concat($9e29898158274f39$var$opposites[crossAxis]),
            'auto'
        ];
    } else return [
        "".concat(mainAxis, "-start"),
        "".concat(mainAxis, "-end"),
        "".concat($9e29898158274f39$var$opposites[mainAxis]),
        "".concat($9e29898158274f39$var$opposites[mainAxis], "-start"),
        "".concat($9e29898158274f39$var$opposites[mainAxis], "-end"),
        "auto"
    ];
};
/**
 * __Dropdown menu__
 *
 * A dropdown menu displays a list of actions or options to a user.
 *
 * - [Examples](https://atlassian.design/components/dropdown-menu/examples)
 * - [Code](https://atlassian.design/components/dropdown-menu/code)
 * - [Usage](https://atlassian.design/components/dropdown-menu/usage)
 */ var $9e29898158274f39$var$DropdownMenu = function DropdownMenu(_ref) {
    var _ref$autoFocus = _ref.autoFocus, autoFocus = _ref$autoFocus === void 0 ? false : _ref$autoFocus, children = _ref.children, _ref$defaultOpen = _ref.defaultOpen, defaultOpen = _ref$defaultOpen === void 0 ? false : _ref$defaultOpen, _ref$isLoading = _ref.isLoading, isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading, isOpen = _ref.isOpen, _ref$onOpenChange = _ref.onOpenChange, onOpenChange = _ref$onOpenChange === void 0 ? (0, $3a341012e037de4f$export$2e2bcd8739ae039) : _ref$onOpenChange, _ref$placement = _ref.placement, placement = _ref$placement === void 0 ? 'bottom-start' : _ref$placement, _ref$shouldFitContain = _ref.shouldFitContainer, shouldFitContainer = _ref$shouldFitContain === void 0 ? false : _ref$shouldFitContain, _ref$shouldFlip = _ref.shouldFlip, shouldFlip = _ref$shouldFlip === void 0 ? true : _ref$shouldFlip, _ref$shouldRenderToPa = _ref.shouldRenderToParent, shouldRenderToParent = _ref$shouldRenderToPa === void 0 ? false : _ref$shouldRenderToPa, returnFocusRef = _ref.returnFocusRef, spacing = _ref.spacing, statusLabel = _ref.statusLabel, testId = _ref.testId, _trigger = _ref.trigger, _ref$zIndex = _ref.zIndex, zIndex = _ref$zIndex === void 0 ? (0, $10b83e40731cc155$export$7be255094ccdc533).modal() : _ref$zIndex, label = _ref.label, interactionName = _ref.interactionName, strategy = _ref.strategy;
    var _useControlledState = (0, $f4d287be7eb5fb6d$export$2e2bcd8739ae039)(isOpen, function() {
        return defaultOpen;
    }), _useControlledState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useControlledState, 2), isLocalOpen = _useControlledState2[0], setLocalIsOpen = _useControlledState2[1];
    var triggerRef = (0, $5FkrB.useRef)(null);
    var _useState = (0, $5FkrB.useState)(false), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), isTriggeredUsingKeyboard = _useState2[0], setTriggeredUsingKeyboard = _useState2[1];
    var id = (0, $ddd3993c923b373a$export$2e2bcd8739ae039)();
    var itemRef = (0, $342103062545c958$export$2e2bcd8739ae039)();
    var fallbackPlacements = (0, $5FkrB.useMemo)(function() {
        return $9e29898158274f39$var$getFallbackPlacements(placement);
    }, [
        placement
    ]);
    var handleTriggerClicked = (0, $5FkrB.useCallback)(// TODO: event is an `any` and is being cast incorrectly
    // This means that the public type for `onOpenChange` is incorrect
    // current: (event: React.MouseEvent | React.KeyboardEvent) => void;
    // correct: (event: React.MouseEvent | KeyboardEvent) => void;
    // https://product-fabric.atlassian.net/browse/DSP-4692
    function(event) {
        var newValue = !isLocalOpen;
        var clientX = event.clientX, clientY = event.clientY, type = event.type, detail = event.detail;
        if (type === 'keydown') setTriggeredUsingKeyboard(true);
        else if (clientX === 0 || clientY === 0) // Hitting enter/space is registered as a click
        // with both clientX and clientY === 0
        setTriggeredUsingKeyboard(true);
        else if (detail === 0) // Fix for Safari. clientX and clientY !== 0 in Safari
        setTriggeredUsingKeyboard(true);
        else {
            var _itemRef$current;
            // The trigger element must be focused to avoid problems with an incorrectly focused element after closing DropdownMenu
            itemRef === null || itemRef === void 0 || (_itemRef$current = itemRef.current) === null || _itemRef$current === void 0 || _itemRef$current.focus();
            setTriggeredUsingKeyboard(false);
        }
        setLocalIsOpen(newValue);
        onOpenChange({
            isOpen: newValue,
            event: event
        });
    }, [
        isLocalOpen,
        setLocalIsOpen,
        onOpenChange,
        itemRef
    ]);
    var handleOnClose = (0, $5FkrB.useCallback)(function(event, currentLevel) {
        var _event$target, _event$target$closest;
        if (event.key !== 'Escape' && event.key !== 'Tab' && (_event$target = event.target) !== null && _event$target !== void 0 && (_event$target$closest = _event$target.closest) !== null && _event$target$closest !== void 0 && _event$target$closest.call(_event$target, "[id^=".concat((0, $ddd3993c923b373a$export$8a682ae47622dbb9), "] [aria-haspopup]"))) {
            var _itemRef$current2;
            // Check if it is within dropdown and it is a trigger button
            // if it is a nested dropdown, clicking trigger won't close the dropdown
            // Dropdown can be closed by pressing Escape, Tab or Shift + Tab
            if (!currentLevel) return;
            // if currentLevel is provided, we will compare with the given item's level
            // when it is available and larger than currentLevel, we will proceed the close behavior
            var toCloseLevel = (_itemRef$current2 = itemRef.current) === null || _itemRef$current2 === void 0 ? void 0 : _itemRef$current2.dataset['ds-Level'];
            if (toCloseLevel && Number(toCloseLevel) < currentLevel) return;
        }
        // transfer focus to the element specified by ref
        // if ref is not provided, use old behavior:
        // focus on trigger when <Esc> or <Shift+Tab> is pressed
        if (returnFocusRef) requestAnimationFrame(function() {
            var _returnFocusRef$curre;
            (_returnFocusRef$curre = returnFocusRef.current) === null || _returnFocusRef$curre === void 0 || _returnFocusRef$curre.focus();
        });
        else if (event.key === 'Tab' && event.shiftKey || event.key === 'Escape') requestAnimationFrame(function() {
            var _itemRef$current3;
            (_itemRef$current3 = itemRef.current) === null || _itemRef$current3 === void 0 || _itemRef$current3.focus();
        });
        else if (triggerRef.current) requestAnimationFrame(function() {
            var _triggerRef$current;
            (_triggerRef$current = triggerRef.current) === null || _triggerRef$current === void 0 || _triggerRef$current.focus();
        });
        var newValue = false;
        setLocalIsOpen(newValue);
        onOpenChange({
            isOpen: newValue,
            event: event
        });
    }, [
        itemRef,
        onOpenChange,
        returnFocusRef,
        setLocalIsOpen
    ]);
    var _useFocus = (0, $7632941312f4921f$export$2e2bcd8739ae039)(), isFocused = _useFocus.isFocused, bindFocus = _useFocus.bindFocus;
    // When a trigger is focused, we want to open the dropdown if
    // the user presses the DownArrow
    (0, $5FkrB.useEffect)(function() {
        // Only need to listen for keydown when focused
        if (!isFocused) return 0, $3a341012e037de4f$export$2e2bcd8739ae039;
        // Being safe: we don't want to open the dropdown if it is already open
        // Note: This shouldn't happen as the trigger should not be able to get focus
        if (isLocalOpen) return 0, $3a341012e037de4f$export$2e2bcd8739ae039;
        return (0, $7QpUe.bind)(window, {
            type: 'keydown',
            listener: function openOnKeyDown(e) {
                var isNestedTriggerButton;
                if (e.target instanceof HTMLElement) isNestedTriggerButton = e.target.closest("[id^=".concat((0, $ddd3993c923b373a$export$8a682ae47622dbb9), "] [aria-haspopup]"));
                if (e.key === (0, $e27a1598a26ffda3$export$a80636c6f41931fe) && !isNestedTriggerButton) {
                    // prevent page scroll
                    e.preventDefault();
                    handleTriggerClicked(e);
                } else if ((e.code === (0, $e27a1598a26ffda3$export$e51a3576c045c8d5) || e.key === (0, $e27a1598a26ffda3$export$8152f929a25a0ff4)) && e.detail === 0) // This allows us to focus on the first element if the dropdown was triggered by a custom trigger with a custom onClick
                setTriggeredUsingKeyboard(true);
                else if (e.key === (0, $e27a1598a26ffda3$export$10f6869ed0a7d75b) && isNestedTriggerButton) // This closes dropdown if it is a nested dropdown
                handleOnClose(e);
            }
        });
    }, [
        isFocused,
        isLocalOpen,
        handleTriggerClicked,
        handleOnClose
    ]);
    /*
   * The Popup component requires either:
   * - shouldFitContainer={true} and shouldRenderToParent={true | undefined}
   * or
   * - shouldFitContainer={false | undefined} and shouldRenderToParent={true | false | undefined}
   *
   * But not:
   * - shouldFitContainer={true} and shouldRenderToParent={false}
   *
   * By only including either shouldFitContainer or shouldRenderToParent, we can ensure that the Popup component
   * types are satisfied.
   */ var conditionalProps = shouldFitContainer ? {
        shouldFitContainer: shouldFitContainer,
        // When shouldFitContainer is true, `fixed` positions are not allowed
        strategy: strategy !== 'fixed' ? strategy : undefined
    } : {
        shouldRenderToParent: shouldRenderToParent,
        strategy: strategy
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $6c8d7d354dcb5a30$export$2e2bcd8739ae039), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $b36dd04f01c3a491$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        id: isLocalOpen ? id : undefined,
        shouldFlip: shouldFlip,
        isOpen: isLocalOpen,
        shouldReturnFocus: // If returnFocusRef is provided, we **don't** want to return focus to the trigger.
        // Otherwise, Popup will focus on the dropdown trigger after the `returnFocusRef` element is focused.
        returnFocusRef === undefined,
        onClose: handleOnClose,
        zIndex: zIndex,
        placement: placement,
        fallbackPlacements: fallbackPlacements,
        testId: testId && "".concat(testId, "--content"),
        shouldUseCaptureOnOutsideClick: true
    }, conditionalProps, {
        shouldDisableFocusLock: true,
        trigger: function trigger(_ref2) {
            var ref = _ref2.ref, ariaControls = _ref2['aria-controls'], ariaExpanded = _ref2['aria-expanded'], ariaHasPopup = _ref2['aria-haspopup'], rest = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref2, $9e29898158274f39$var$_excluded);
            if (typeof _trigger === 'function') return _trigger($9e29898158274f39$var$_objectSpread($9e29898158274f39$var$_objectSpread($9e29898158274f39$var$_objectSpread({
                'aria-controls': ariaControls,
                'aria-expanded': ariaExpanded,
                'aria-haspopup': ariaHasPopup
            }, rest), bindFocus), {}, {
                triggerRef: (0, $0d2a37110e22a1c9$export$2e2bcd8739ae039)([
                    ref,
                    triggerRef,
                    itemRef
                ]),
                isSelected: isLocalOpen,
                onClick: handleTriggerClicked,
                testId: testId && "".concat(testId, "--trigger")
            }));
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $1fa2d718d507adf5$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, bindFocus, {
                ref: (0, $0d2a37110e22a1c9$export$2e2bcd8739ae039)([
                    ref,
                    triggerRef,
                    itemRef
                ]),
                "aria-controls": ariaControls,
                "aria-expanded": ariaExpanded,
                "aria-haspopup": ariaHasPopup,
                isSelected: isLocalOpen,
                iconAfter: (0, (/*@__PURE__*/$parcel$interopDefault($c21b397a5a41009b$exports))),
                onClick: handleTriggerClicked,
                testId: testId && "".concat(testId, "--trigger"),
                "aria-label": label
            }, (0, $dU8Y3.fg)('platform_button_item-add-ufo-metrics') && {
                interactionName: interactionName
            }), _trigger);
        },
        content: function content(_ref3) {
            var setInitialFocusRef = _ref3.setInitialFocusRef, update = _ref3.update;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $732d8fed4cea8f22$export$2e2bcd8739ae039), {
                onClose: handleOnClose
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $60be549fc44af1f1$export$2e2bcd8739ae039), {
                spacing: spacing,
                maxHeight: $9e29898158274f39$var$MAX_HEIGHT,
                maxWidth: shouldFitContainer ? undefined : 800,
                onClose: handleOnClose,
                onUpdate: update,
                isLoading: isLoading,
                statusLabel: statusLabel,
                setInitialFocusRef: isTriggeredUsingKeyboard || autoFocus ? setInitialFocusRef : undefined,
                shouldRenderToParent: shouldRenderToParent || shouldFitContainer,
                isTriggeredUsingKeyboard: isTriggeredUsingKeyboard,
                autoFocus: autoFocus,
                testId: testId && "".concat(testId, "--menu-wrapper")
            }, children));
        }
    })));
};
var $9e29898158274f39$export$2e2bcd8739ae039 = $9e29898158274f39$var$DropdownMenu;


var $kqp0i = parcelRequire("kqp0i");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");


var $kqp0i = parcelRequire("kqp0i");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");

var $74Zh5 = parcelRequire("74Zh5");
/* eslint-disable no-console */ var $ae3cc759f1e5ecdb$var$printed = {};
function $ae3cc759f1e5ecdb$export$2e2bcd8739ae039(message) {
    if ($ae3cc759f1e5ecdb$var$printed[message]) return;
    $ae3cc759f1e5ecdb$var$printed[message] = true;
    if (typeof window !== 'undefined') console.warn(message);
}



var $3ZMUU = parcelRequire("3ZMUU");
function $c6f574dac5b81c12$export$2e2bcd8739ae039(packageName, api, additionalMessage) {
    (0, $ae3cc759f1e5ecdb$export$2e2bcd8739ae039)("[".concat(packageName, "]: The ").concat(api, " is deprecated.").concat(additionalMessage && " ".concat(additionalMessage)));
}
function $c6f574dac5b81c12$export$eb1decd851a5ae56(packageName, propName, predicate, deprecationAnnouncementOnDAC) {
    typeof $3ZMUU;
}


/**
 * An empty function which does nothing.
 */ // eslint-disable-next-line @repo/internal/react/use-noop
function $f2ed9a22761e3cb5$export$2e2bcd8739ae039() {}



var $5FkrB = parcelRequire("5FkrB");
var $1d30d2a862a7a995$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $5FkrB.createContext)(null);



var $dU8Y3 = parcelRequire("dU8Y3");
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5FkrB = parcelRequire("5FkrB");

var $74Zh5 = parcelRequire("74Zh5");

/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5FkrB = parcelRequire("5FkrB");

var $74Zh5 = parcelRequire("74Zh5");
var $20f6066d053c10c9$var$BORDER_WIDTH = 2;
var $20f6066d053c10c9$var$baseFocusOutsideStyles = (0, $74Zh5.css)({
    outline: "".concat($20f6066d053c10c9$var$BORDER_WIDTH, "px solid ", "var(--ds-border-focused, #2684FF)"),
    outlineOffset: $20f6066d053c10c9$var$BORDER_WIDTH
});
var $20f6066d053c10c9$var$baseInsetStyles = (0, $74Zh5.css)({
    outlineColor: "var(--ds-border-focused, #2684FF)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    outlineOffset: -$20f6066d053c10c9$var$BORDER_WIDTH,
    outlineStyle: 'solid',
    outlineWidth: "var(--ds-border-width-outline, 2px)"
});
var $20f6066d053c10c9$var$focusRingStyles = (0, $74Zh5.css)({
    // Focus styles used when :focus-visible isn't supported
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
    '&:focus': $20f6066d053c10c9$var$baseFocusOutsideStyles,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
    '&:focus-visible': $20f6066d053c10c9$var$baseFocusOutsideStyles,
    // Remove default focus styles for mouse interactions if :focus-visible is supported
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
    '&:focus:not(:focus-visible)': {
        outline: 'none'
    },
    '@media screen and (forced-colors: active), screen and (-ms-high-contrast: active)': {
        '&:focus-visible': {
            outline: '1px solid'
        }
    }
});
var $20f6066d053c10c9$var$insetFocusRingStyles = (0, $74Zh5.css)({
    // Focus styles used when :focus-visible isn't supported
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
    '&:focus': $20f6066d053c10c9$var$baseInsetStyles,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
    '&:focus-visible': $20f6066d053c10c9$var$baseInsetStyles,
    // Remove default focus styles for mouse interactions if :focus-visible is supported
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
    '&:focus:not(:focus-visible)': {
        outline: 'none'
    },
    '@media screen and (forced-colors: active), screen and (-ms-high-contrast: active)': {
        '&:focus-visible': {
            outline: '1px solid',
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
            outlineOffset: '-1px'
        }
    }
});
/**
 * __Focus ring__
 *
 * A focus ring visually indicates the currently focused item.
 *
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/focus-ring)
 *
 * @example
 * ```jsx
 * import FocusRing from '@atlaskit/focus-ring';
 *
 * const InteractiveComponent = () => (
 *   <FocusRing>
 *     <button type="button">Hello</button>
 *   </FocusRing>
 * )
 * ```
 */ var $20f6066d053c10c9$var$FocusRing = /*#__PURE__*/ (0, $5FkrB.memo)(function(_ref) {
    var children = _ref.children, isInset = _ref.isInset, focus = _ref.focus;
    var controlledStyles = isInset ? $20f6066d053c10c9$var$baseInsetStyles : $20f6066d053c10c9$var$baseFocusOutsideStyles;
    var uncontrolledStyles = isInset ? $20f6066d053c10c9$var$insetFocusRingStyles : $20f6066d053c10c9$var$focusRingStyles;
    var focusCls = typeof focus === 'undefined' ? uncontrolledStyles : focus === 'on' && controlledStyles;
    return (0, $74Zh5.jsx)((0, $74Zh5.ClassNames), null, function(_ref2) {
        var css = _ref2.css, cx = _ref2.cx;
        return (0, $5FkrB.Children).only(// This may look unwieldy but means we skip applying styles / cloning if no className is applicable
        focusCls ? /*#__PURE__*/ // eslint-disable-next-line @repo/internal/react/no-clone-element
        (0, $5FkrB.cloneElement)(children, {
            className: cx([
                css(focusCls),
                children.props.className
            ])
        }) : children);
    });
});
$20f6066d053c10c9$var$FocusRing.displayName = 'FocusRing';
var $20f6066d053c10c9$export$2e2bcd8739ae039 = $20f6066d053c10c9$var$FocusRing;



var $fC8ib = parcelRequire("fC8ib");

var $5FkrB = parcelRequire("5FkrB");

var $74Zh5 = parcelRequire("74Zh5");

var $fC8ib = parcelRequire("fC8ib");

var $25nEq = parcelRequire("25nEq");

var $iYJcE = parcelRequire("iYJcE");

var $ekGgq = parcelRequire("ekGgq");

var $74Zh5 = parcelRequire("74Zh5");

var $25nEq = parcelRequire("25nEq");

var $74Zh5 = parcelRequire("74Zh5");
var $dcc0f48710161fe0$export$4ef52930e33717cd = 'data-theme';
var $dcc0f48710161fe0$export$a00eac3f8684bcd0 = 'data-color-mode';
var $dcc0f48710161fe0$export$2112803007239c61 = 'data-contrast-mode';
var $dcc0f48710161fe0$export$352e418ed5b6193a = 'data-custom-theme';
var $dcc0f48710161fe0$export$2faeed762aac6741 = 'light';
var $dcc0f48710161fe0$export$6f0c6fb8c80fcc92 = 'ds';
var $dcc0f48710161fe0$export$4d0c7bbf80185957 = [
    'opacity',
    'font',
    'space',
    'border'
];
var $dcc0f48710161fe0$export$dddac1532e822863 = "--".concat($dcc0f48710161fe0$export$6f0c6fb8c80fcc92, "-token-not-found");
var $dcc0f48710161fe0$export$9d7b58831ae93caa = "--".concat($dcc0f48710161fe0$export$6f0c6fb8c80fcc92, "-elevation-surface-current");


function $9e847408f5b72379$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $9e847408f5b72379$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $9e847408f5b72379$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $9e847408f5b72379$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $9e847408f5b72379$export$6ccdbebca2ee545f = {
    '100%': '100%',
    'size.100': '1rem',
    'size.200': '1.5rem',
    'size.300': '2rem',
    'size.400': '2.5rem',
    'size.500': '3rem',
    'size.600': '6rem',
    'size.1000': '12rem'
};
var $9e847408f5b72379$export$958d0ae7f2977ae4 = {
    'space.0': "var(--ds-space-0, 0px)",
    'space.025': "var(--ds-space-025, 2px)",
    'space.050': "var(--ds-space-050, 4px)",
    'space.075': "var(--ds-space-075, 6px)",
    'space.100': "var(--ds-space-100, 8px)",
    'space.150': "var(--ds-space-150, 12px)",
    'space.200': "var(--ds-space-200, 16px)",
    'space.250': "var(--ds-space-250, 20px)",
    'space.300': "var(--ds-space-300, 24px)",
    'space.400': "var(--ds-space-400, 32px)",
    'space.500': "var(--ds-space-500, 40px)",
    'space.600': "var(--ds-space-600, 48px)",
    'space.800': "var(--ds-space-800, 64px)",
    'space.1000': "var(--ds-space-1000, 80px)"
};
var $9e847408f5b72379$export$d2dc61f58390201c = {
    'space.negative.025': "var(--ds-space-negative-025, -2px)",
    'space.negative.050': "var(--ds-space-negative-050, -4px)",
    'space.negative.075': "var(--ds-space-negative-075, -6px)",
    'space.negative.100': "var(--ds-space-negative-100, -8px)",
    'space.negative.150': "var(--ds-space-negative-150, -12px)",
    'space.negative.200': "var(--ds-space-negative-200, -16px)",
    'space.negative.250': "var(--ds-space-negative-250, -20px)",
    'space.negative.300': "var(--ds-space-negative-300, -24px)",
    'space.negative.400': "var(--ds-space-negative-400, -32px)"
};
var $9e847408f5b72379$export$632685d741f3dbbf = $9e847408f5b72379$var$_objectSpread($9e847408f5b72379$var$_objectSpread({}, $9e847408f5b72379$export$958d0ae7f2977ae4), $9e847408f5b72379$export$d2dc61f58390201c);
var $9e847408f5b72379$export$2185ce37f9bdd963 = {
    'color.background.neutral.bold': 'color.text.inverse',
    'color.background.neutral.bold.hovered': 'color.text.inverse',
    'color.background.neutral.bold.pressed': 'color.text.inverse',
    'color.background.selected.bold': 'color.text.inverse',
    'color.background.selected.bold.hovered': 'color.text.inverse',
    'color.background.selected.bold.pressed': 'color.text.inverse',
    'color.background.brand.bold': 'color.text.inverse',
    'color.background.brand.bold.hovered': 'color.text.inverse',
    'color.background.brand.bold.pressed': 'color.text.inverse',
    'color.background.brand.boldest': 'color.text.inverse',
    'color.background.brand.boldest.hovered': 'color.text.inverse',
    'color.background.brand.boldest.pressed': 'color.text.inverse',
    'color.background.danger.bold': 'color.text.inverse',
    'color.background.danger.bold.hovered': 'color.text.inverse',
    'color.background.danger.bold.pressed': 'color.text.inverse',
    'color.background.warning.bold': 'color.text.warning.inverse',
    'color.background.warning.bold.hovered': 'color.text.warning.inverse',
    'color.background.warning.bold.pressed': 'color.text.warning.inverse',
    'color.background.success.bold': 'color.text.inverse',
    'color.background.success.bold.hovered': 'color.text.inverse',
    'color.background.success.bold.pressed': 'color.text.inverse',
    'color.background.discovery.bold': 'color.text.inverse',
    'color.background.discovery.bold.hovered': 'color.text.inverse',
    'color.background.discovery.bold.pressed': 'color.text.inverse',
    'color.background.information.bold': 'color.text.inverse',
    'color.background.information.bold.hovered': 'color.text.inverse',
    'color.background.information.bold.pressed': 'color.text.inverse'
};
var $9e847408f5b72379$export$daf94a976c798b4f = {
    'opacity.disabled': "var(--ds-opacity-disabled, 0.4)",
    'opacity.loading': "var(--ds-opacity-loading, 0.2)"
};
var $9e847408f5b72379$export$7aff6e7ba39bb774 = {
    'elevation.shadow.overflow': "var(--ds-shadow-overflow, 0px 0px 8px #091e423f, 0px 0px 1px #091e424f)",
    'elevation.shadow.overflow.perimeter': "var(--ds-shadow-overflow-perimeter, #091e421f)",
    'elevation.shadow.overflow.spread': "var(--ds-shadow-overflow-spread, #091e4229)",
    'elevation.shadow.overlay': "var(--ds-shadow-overlay, 0px 8px 12px #091e423f, 0px 0px 1px #091e424f)",
    'elevation.shadow.raised': "var(--ds-shadow-raised, 0px 1px 1px #091e423f, 0px 0px 1px #091e4221)"
};
var $9e847408f5b72379$export$41a358c9c2356760 = {
    'elevation.surface': "var(--ds-surface, #FFFFFF)",
    'elevation.surface.hovered': "var(--ds-surface-hovered, #FAFBFC)",
    'elevation.surface.pressed': "var(--ds-surface-pressed, #F4F5F7)",
    'elevation.surface.overlay': "var(--ds-surface-overlay, #FFFFFF)",
    'elevation.surface.overlay.hovered': "var(--ds-surface-overlay-hovered, #FAFBFC)",
    'elevation.surface.overlay.pressed': "var(--ds-surface-overlay-pressed, #F4F5F7)",
    'elevation.surface.raised': "var(--ds-surface-raised, #FFFFFF)",
    'elevation.surface.raised.hovered': "var(--ds-surface-raised-hovered, #FAFBFC)",
    'elevation.surface.raised.pressed': "var(--ds-surface-raised-pressed, #F4F5F7)",
    'elevation.surface.sunken': "var(--ds-surface-sunken, #F4F5F7)"
};
var $9e847408f5b72379$export$1531ad5bb3fbedac = {
    'color.border': "var(--ds-border, #091e4221)",
    'color.border.accent.lime': "var(--ds-border-accent-lime, #6A9A23)",
    'color.border.accent.red': "var(--ds-border-accent-red, #FF5630)",
    'color.border.accent.orange': "var(--ds-border-accent-orange, #D94008)",
    'color.border.accent.yellow': "var(--ds-border-accent-yellow, #FFAB00)",
    'color.border.accent.green': "var(--ds-border-accent-green, #36B37E)",
    'color.border.accent.teal': "var(--ds-border-accent-teal, #00B8D9)",
    'color.border.accent.blue': "var(--ds-border-accent-blue, #0065FF)",
    'color.border.accent.purple': "var(--ds-border-accent-purple, #6554C0)",
    'color.border.accent.magenta': "var(--ds-border-accent-magenta, #CD519D)",
    'color.border.accent.gray': "var(--ds-border-accent-gray, #5E6C84)",
    'color.border.disabled': "var(--ds-border-disabled, #FAFBFC)",
    'color.border.focused': "var(--ds-border-focused, #2684FF)",
    'color.border.input': "var(--ds-border-input, #FAFBFC)",
    'color.border.inverse': "var(--ds-border-inverse, #FFFFFF)",
    'color.border.selected': "var(--ds-border-selected, #0052CC)",
    'color.border.brand': "var(--ds-border-brand, #0052CC)",
    'color.border.danger': "var(--ds-border-danger, #FF5630)",
    'color.border.warning': "var(--ds-border-warning, #FFC400)",
    'color.border.success': "var(--ds-border-success, #00875A)",
    'color.border.discovery': "var(--ds-border-discovery, #998DD9)",
    'color.border.information': "var(--ds-border-information, #0065FF)",
    'color.border.bold': "var(--ds-border-bold, #344563)"
};
var $9e847408f5b72379$export$d1d79bf68ac056bd = {
    'color.background.accent.lime.subtlest': "var(--ds-background-accent-lime-subtlest, #EEFBDA)",
    'color.background.accent.lime.subtlest.hovered': "var(--ds-background-accent-lime-subtlest-hovered, #D3F1A7)",
    'color.background.accent.lime.subtlest.pressed': "var(--ds-background-accent-lime-subtlest-pressed, #B3DF72)",
    'color.background.accent.lime.subtler': "var(--ds-background-accent-lime-subtler, #D3F1A7)",
    'color.background.accent.lime.subtler.hovered': "var(--ds-background-accent-lime-subtler-hovered, #B3DF72)",
    'color.background.accent.lime.subtler.pressed': "var(--ds-background-accent-lime-subtler-pressed, #94C748)",
    'color.background.accent.lime.subtle': "var(--ds-background-accent-lime-subtle, #94C748)",
    'color.background.accent.lime.subtle.hovered': "var(--ds-background-accent-lime-subtle-hovered, #B3DF72)",
    'color.background.accent.lime.subtle.pressed': "var(--ds-background-accent-lime-subtle-pressed, #D3F1A7)",
    'color.background.accent.lime.bolder': "var(--ds-background-accent-lime-bolder, #5B7F24)",
    'color.background.accent.lime.bolder.hovered': "var(--ds-background-accent-lime-bolder-hovered, #37471F)",
    'color.background.accent.lime.bolder.pressed': "var(--ds-background-accent-lime-bolder-pressed, #37471F)",
    'color.background.accent.red.subtlest': "var(--ds-background-accent-red-subtlest, #FF8F73)",
    'color.background.accent.red.subtlest.hovered': "var(--ds-background-accent-red-subtlest-hovered, #FF7452)",
    'color.background.accent.red.subtlest.pressed': "var(--ds-background-accent-red-subtlest-pressed, #FF5630)",
    'color.background.accent.red.subtler': "var(--ds-background-accent-red-subtler, #FF7452)",
    'color.background.accent.red.subtler.hovered': "var(--ds-background-accent-red-subtler-hovered, #FF5630)",
    'color.background.accent.red.subtler.pressed': "var(--ds-background-accent-red-subtler-pressed, #DE350B)",
    'color.background.accent.red.subtle': "var(--ds-background-accent-red-subtle, #DE350B)",
    'color.background.accent.red.subtle.hovered': "var(--ds-background-accent-red-subtle-hovered, #FF5630)",
    'color.background.accent.red.subtle.pressed': "var(--ds-background-accent-red-subtle-pressed, #FF7452)",
    'color.background.accent.red.bolder': "var(--ds-background-accent-red-bolder, #DE350B)",
    'color.background.accent.red.bolder.hovered': "var(--ds-background-accent-red-bolder-hovered, #FF5630)",
    'color.background.accent.red.bolder.pressed': "var(--ds-background-accent-red-bolder-pressed, #FF7452)",
    'color.background.accent.orange.subtlest': "var(--ds-background-accent-orange-subtlest, #F18D13)",
    'color.background.accent.orange.subtlest.hovered': "var(--ds-background-accent-orange-subtlest-hovered, #FEC57B)",
    'color.background.accent.orange.subtlest.pressed': "var(--ds-background-accent-orange-subtlest-pressed, #FFE2BD)",
    'color.background.accent.orange.subtler': "var(--ds-background-accent-orange-subtler, #B65C02)",
    'color.background.accent.orange.subtler.hovered': "var(--ds-background-accent-orange-subtler-hovered, #F18D13)",
    'color.background.accent.orange.subtler.pressed': "var(--ds-background-accent-orange-subtler-pressed, #FEC57B)",
    'color.background.accent.orange.subtle': "var(--ds-background-accent-orange-subtle, #5F3811)",
    'color.background.accent.orange.subtle.hovered': "var(--ds-background-accent-orange-subtle-hovered, #974F0C)",
    'color.background.accent.orange.subtle.pressed': "var(--ds-background-accent-orange-subtle-pressed, #B65C02)",
    'color.background.accent.orange.bolder': "var(--ds-background-accent-orange-bolder, #43290F)",
    'color.background.accent.orange.bolder.hovered': "var(--ds-background-accent-orange-bolder-hovered, #5F3811)",
    'color.background.accent.orange.bolder.pressed': "var(--ds-background-accent-orange-bolder-pressed, #974F0C)",
    'color.background.accent.yellow.subtlest': "var(--ds-background-accent-yellow-subtlest, #FFE380)",
    'color.background.accent.yellow.subtlest.hovered': "var(--ds-background-accent-yellow-subtlest-hovered, #FFC400)",
    'color.background.accent.yellow.subtlest.pressed': "var(--ds-background-accent-yellow-subtlest-pressed, #FFAB00)",
    'color.background.accent.yellow.subtler': "var(--ds-background-accent-yellow-subtler, #FFC400)",
    'color.background.accent.yellow.subtler.hovered': "var(--ds-background-accent-yellow-subtler-hovered, #FFAB00)",
    'color.background.accent.yellow.subtler.pressed': "var(--ds-background-accent-yellow-subtler-pressed, #FF991F)",
    'color.background.accent.yellow.subtle': "var(--ds-background-accent-yellow-subtle, #FF991F)",
    'color.background.accent.yellow.subtle.hovered': "var(--ds-background-accent-yellow-subtle-hovered, #FFAB00)",
    'color.background.accent.yellow.subtle.pressed': "var(--ds-background-accent-yellow-subtle-pressed, #FFC400)",
    'color.background.accent.yellow.bolder': "var(--ds-background-accent-yellow-bolder, #FF991F)",
    'color.background.accent.yellow.bolder.hovered': "var(--ds-background-accent-yellow-bolder-hovered, #FFAB00)",
    'color.background.accent.yellow.bolder.pressed': "var(--ds-background-accent-yellow-bolder-pressed, #FFC400)",
    'color.background.accent.green.subtlest': "var(--ds-background-accent-green-subtlest, #79F2C0)",
    'color.background.accent.green.subtlest.hovered': "var(--ds-background-accent-green-subtlest-hovered, #57D9A3)",
    'color.background.accent.green.subtlest.pressed': "var(--ds-background-accent-green-subtlest-pressed, #36B37E)",
    'color.background.accent.green.subtler': "var(--ds-background-accent-green-subtler, #57D9A3)",
    'color.background.accent.green.subtler.hovered': "var(--ds-background-accent-green-subtler-hovered, #36B37E)",
    'color.background.accent.green.subtler.pressed': "var(--ds-background-accent-green-subtler-pressed, #00875A)",
    'color.background.accent.green.subtle': "var(--ds-background-accent-green-subtle, #00875A)",
    'color.background.accent.green.subtle.hovered': "var(--ds-background-accent-green-subtle-hovered, #36B37E)",
    'color.background.accent.green.subtle.pressed': "var(--ds-background-accent-green-subtle-pressed, #57D9A3)",
    'color.background.accent.green.bolder': "var(--ds-background-accent-green-bolder, #00875A)",
    'color.background.accent.green.bolder.hovered': "var(--ds-background-accent-green-bolder-hovered, #36B37E)",
    'color.background.accent.green.bolder.pressed': "var(--ds-background-accent-green-bolder-pressed, #57D9A3)",
    'color.background.accent.teal.subtlest': "var(--ds-background-accent-teal-subtlest, #79E2F2)",
    'color.background.accent.teal.subtlest.hovered': "var(--ds-background-accent-teal-subtlest-hovered, #00C7E6)",
    'color.background.accent.teal.subtlest.pressed': "var(--ds-background-accent-teal-subtlest-pressed, #00B8D9)",
    'color.background.accent.teal.subtler': "var(--ds-background-accent-teal-subtler, #00C7E6)",
    'color.background.accent.teal.subtler.hovered': "var(--ds-background-accent-teal-subtler-hovered, #00B8D9)",
    'color.background.accent.teal.subtler.pressed': "var(--ds-background-accent-teal-subtler-pressed, #00A3BF)",
    'color.background.accent.teal.subtle': "var(--ds-background-accent-teal-subtle, #00A3BF)",
    'color.background.accent.teal.subtle.hovered': "var(--ds-background-accent-teal-subtle-hovered, #00B8D9)",
    'color.background.accent.teal.subtle.pressed': "var(--ds-background-accent-teal-subtle-pressed, #00C7E6)",
    'color.background.accent.teal.bolder': "var(--ds-background-accent-teal-bolder, #00A3BF)",
    'color.background.accent.teal.bolder.hovered': "var(--ds-background-accent-teal-bolder-hovered, #00B8D9)",
    'color.background.accent.teal.bolder.pressed': "var(--ds-background-accent-teal-bolder-pressed, #00C7E6)",
    'color.background.accent.blue.subtlest': "var(--ds-background-accent-blue-subtlest, #4C9AFF)",
    'color.background.accent.blue.subtlest.hovered': "var(--ds-background-accent-blue-subtlest-hovered, #2684FF)",
    'color.background.accent.blue.subtlest.pressed': "var(--ds-background-accent-blue-subtlest-pressed, #0065FF)",
    'color.background.accent.blue.subtler': "var(--ds-background-accent-blue-subtler, #2684FF)",
    'color.background.accent.blue.subtler.hovered': "var(--ds-background-accent-blue-subtler-hovered, #0065FF)",
    'color.background.accent.blue.subtler.pressed': "var(--ds-background-accent-blue-subtler-pressed, #0052CC)",
    'color.background.accent.blue.subtle': "var(--ds-background-accent-blue-subtle, #0052CC)",
    'color.background.accent.blue.subtle.hovered': "var(--ds-background-accent-blue-subtle-hovered, #0065FF)",
    'color.background.accent.blue.subtle.pressed': "var(--ds-background-accent-blue-subtle-pressed, #2684FF)",
    'color.background.accent.blue.bolder': "var(--ds-background-accent-blue-bolder, #0052CC)",
    'color.background.accent.blue.bolder.hovered': "var(--ds-background-accent-blue-bolder-hovered, #0065FF)",
    'color.background.accent.blue.bolder.pressed': "var(--ds-background-accent-blue-bolder-pressed, #2684FF)",
    'color.background.accent.purple.subtlest': "var(--ds-background-accent-purple-subtlest, #998DD9)",
    'color.background.accent.purple.subtlest.hovered': "var(--ds-background-accent-purple-subtlest-hovered, #8777D9)",
    'color.background.accent.purple.subtlest.pressed': "var(--ds-background-accent-purple-subtlest-pressed, #6554C0)",
    'color.background.accent.purple.subtler': "var(--ds-background-accent-purple-subtler, #8777D9)",
    'color.background.accent.purple.subtler.hovered': "var(--ds-background-accent-purple-subtler-hovered, #6554C0)",
    'color.background.accent.purple.subtler.pressed': "var(--ds-background-accent-purple-subtler-pressed, #5243AA)",
    'color.background.accent.purple.subtle': "var(--ds-background-accent-purple-subtle, #5243AA)",
    'color.background.accent.purple.subtle.hovered': "var(--ds-background-accent-purple-subtle-hovered, #6554C0)",
    'color.background.accent.purple.subtle.pressed': "var(--ds-background-accent-purple-subtle-pressed, #8777D9)",
    'color.background.accent.purple.bolder': "var(--ds-background-accent-purple-bolder, #5243AA)",
    'color.background.accent.purple.bolder.hovered': "var(--ds-background-accent-purple-bolder-hovered, #6554C0)",
    'color.background.accent.purple.bolder.pressed': "var(--ds-background-accent-purple-bolder-pressed, #8777D9)",
    'color.background.accent.magenta.subtlest': "var(--ds-background-accent-magenta-subtlest, #FFECF8)",
    'color.background.accent.magenta.subtlest.hovered': "var(--ds-background-accent-magenta-subtlest-hovered, #FDD0EC)",
    'color.background.accent.magenta.subtlest.pressed': "var(--ds-background-accent-magenta-subtlest-pressed, #F797D2)",
    'color.background.accent.magenta.subtler': "var(--ds-background-accent-magenta-subtler, #FDD0EC)",
    'color.background.accent.magenta.subtler.hovered': "var(--ds-background-accent-magenta-subtler-hovered, #F797D2)",
    'color.background.accent.magenta.subtler.pressed': "var(--ds-background-accent-magenta-subtler-pressed, #E774BB)",
    'color.background.accent.magenta.subtle': "var(--ds-background-accent-magenta-subtle, #E774BB)",
    'color.background.accent.magenta.subtle.hovered': "var(--ds-background-accent-magenta-subtle-hovered, #F797D2)",
    'color.background.accent.magenta.subtle.pressed': "var(--ds-background-accent-magenta-subtle-pressed, #FDD0EC)",
    'color.background.accent.magenta.bolder': "var(--ds-background-accent-magenta-bolder, #AE4787)",
    'color.background.accent.magenta.bolder.hovered': "var(--ds-background-accent-magenta-bolder-hovered, #943D73)",
    'color.background.accent.magenta.bolder.pressed': "var(--ds-background-accent-magenta-bolder-pressed, #50253F)",
    'color.background.accent.gray.subtlest': "var(--ds-background-accent-gray-subtlest, #6B778C)",
    'color.background.accent.gray.subtlest.hovered': "var(--ds-background-accent-gray-subtlest-hovered, #5E6C84)",
    'color.background.accent.gray.subtlest.pressed': "var(--ds-background-accent-gray-subtlest-pressed, #505F79)",
    'color.background.accent.gray.subtler': "var(--ds-background-accent-gray-subtler, #5E6C84)",
    'color.background.accent.gray.subtler.hovered': "var(--ds-background-accent-gray-subtler-hovered, #505F79)",
    'color.background.accent.gray.subtler.pressed': "var(--ds-background-accent-gray-subtler-pressed, #42526E)",
    'color.background.accent.gray.subtle': "var(--ds-background-accent-gray-subtle, #505F79)",
    'color.background.accent.gray.subtle.hovered': "var(--ds-background-accent-gray-subtle-hovered, #5E6C84)",
    'color.background.accent.gray.subtle.pressed': "var(--ds-background-accent-gray-subtle-pressed, #6B778C)",
    'color.background.accent.gray.bolder': "var(--ds-background-accent-gray-bolder, #42526E)",
    'color.background.accent.gray.bolder.hovered': "var(--ds-background-accent-gray-bolder-hovered, #344563)",
    'color.background.accent.gray.bolder.pressed': "var(--ds-background-accent-gray-bolder-pressed, #253858)",
    'color.background.disabled': "var(--ds-background-disabled, #091e4289)",
    'color.background.input': "var(--ds-background-input, #FAFBFC)",
    'color.background.input.hovered': "var(--ds-background-input-hovered, #EBECF0)",
    'color.background.input.pressed': "var(--ds-background-input-pressed, #FFFFFF)",
    'color.background.inverse.subtle': "var(--ds-background-inverse-subtle, #00000029)",
    'color.background.inverse.subtle.hovered': "var(--ds-background-inverse-subtle-hovered, #0000003D)",
    'color.background.inverse.subtle.pressed': "var(--ds-background-inverse-subtle-pressed, #00000052)",
    'color.background.neutral': "var(--ds-background-neutral, #DFE1E6)",
    'color.background.neutral.hovered': "var(--ds-background-neutral-hovered, #091e4214)",
    'color.background.neutral.pressed': "var(--ds-background-neutral-pressed, #B3D4FF)",
    'color.background.neutral.subtle': "var(--ds-background-neutral-subtle, transparent)",
    'color.background.neutral.subtle.hovered': "var(--ds-background-neutral-subtle-hovered, #091e4214)",
    'color.background.neutral.subtle.pressed': "var(--ds-background-neutral-subtle-pressed, #B3D4FF)",
    'color.background.neutral.bold': "var(--ds-background-neutral-bold, #42526E)",
    'color.background.neutral.bold.hovered': "var(--ds-background-neutral-bold-hovered, #505F79)",
    'color.background.neutral.bold.pressed': "var(--ds-background-neutral-bold-pressed, #344563)",
    'color.background.selected': "var(--ds-background-selected, #DEEBFF)",
    'color.background.selected.hovered': "var(--ds-background-selected-hovered, #B3D4FF)",
    'color.background.selected.pressed': "var(--ds-background-selected-pressed, #4C9AFF)",
    'color.background.selected.bold': "var(--ds-background-selected-bold, #0052CC)",
    'color.background.selected.bold.hovered': "var(--ds-background-selected-bold-hovered, #2684FF)",
    'color.background.selected.bold.pressed': "var(--ds-background-selected-bold-pressed, #0052CC)",
    'color.background.brand.subtlest': "var(--ds-background-brand-subtlest, #B3D4FF)",
    'color.background.brand.subtlest.hovered': "var(--ds-background-brand-subtlest-hovered, #DEEBFF)",
    'color.background.brand.subtlest.pressed': "var(--ds-background-brand-subtlest-pressed, #4C9AFF)",
    'color.background.brand.bold': "var(--ds-background-brand-bold, #0052CC)",
    'color.background.brand.bold.hovered': "var(--ds-background-brand-bold-hovered, #0065FF)",
    'color.background.brand.bold.pressed': "var(--ds-background-brand-bold-pressed, #0747A6)",
    'color.background.brand.boldest': "var(--ds-background-brand-boldest, #0747A6)",
    'color.background.brand.boldest.hovered': "var(--ds-background-brand-boldest-hovered, #0052CC)",
    'color.background.brand.boldest.pressed': "var(--ds-background-brand-boldest-pressed, #0747A6)",
    'color.background.danger': "var(--ds-background-danger, #FFEBE6)",
    'color.background.danger.hovered': "var(--ds-background-danger-hovered, #FFBDAD)",
    'color.background.danger.pressed': "var(--ds-background-danger-pressed, #FF8F73)",
    'color.background.danger.bold': "var(--ds-background-danger-bold, #DE350B)",
    'color.background.danger.bold.hovered': "var(--ds-background-danger-bold-hovered, #FF5630)",
    'color.background.danger.bold.pressed': "var(--ds-background-danger-bold-pressed, #BF2600)",
    'color.background.warning': "var(--ds-background-warning, #FFFAE6)",
    'color.background.warning.hovered': "var(--ds-background-warning-hovered, #FFF0B3)",
    'color.background.warning.pressed': "var(--ds-background-warning-pressed, #FFE380)",
    'color.background.warning.bold': "var(--ds-background-warning-bold, #FFAB00)",
    'color.background.warning.bold.hovered': "var(--ds-background-warning-bold-hovered, #FFC400)",
    'color.background.warning.bold.pressed': "var(--ds-background-warning-bold-pressed, #FF991F)",
    'color.background.success': "var(--ds-background-success, #E3FCEF)",
    'color.background.success.hovered': "var(--ds-background-success-hovered, #ABF5D1)",
    'color.background.success.pressed': "var(--ds-background-success-pressed, #79F2C0)",
    'color.background.success.bold': "var(--ds-background-success-bold, #00875A)",
    'color.background.success.bold.hovered': "var(--ds-background-success-bold-hovered, #57D9A3)",
    'color.background.success.bold.pressed': "var(--ds-background-success-bold-pressed, #00875A)",
    'color.background.discovery': "var(--ds-background-discovery, #EAE6FF)",
    'color.background.discovery.hovered': "var(--ds-background-discovery-hovered, #C0B6F2)",
    'color.background.discovery.pressed': "var(--ds-background-discovery-pressed, #998DD9)",
    'color.background.discovery.bold': "var(--ds-background-discovery-bold, #5243AA)",
    'color.background.discovery.bold.hovered': "var(--ds-background-discovery-bold-hovered, #8777D9)",
    'color.background.discovery.bold.pressed': "var(--ds-background-discovery-bold-pressed, #5243AA)",
    'color.background.information': "var(--ds-background-information, #DEEBFF)",
    'color.background.information.hovered': "var(--ds-background-information-hovered, #B3D4FF)",
    'color.background.information.pressed': "var(--ds-background-information-pressed, #4C9AFF)",
    'color.background.information.bold': "var(--ds-background-information-bold, #0052CC)",
    'color.background.information.bold.hovered': "var(--ds-background-information-bold-hovered, #2684FF)",
    'color.background.information.bold.pressed': "var(--ds-background-information-bold-pressed, #0052CC)",
    'color.blanket': "var(--ds-blanket, #091e4289)",
    'color.blanket.selected': "var(--ds-blanket-selected, #388BFF14)",
    'color.blanket.danger': "var(--ds-blanket-danger, #EF5C4814)",
    'color.skeleton': "var(--ds-skeleton, #F4F5F7)",
    'color.skeleton.subtle': "var(--ds-skeleton-subtle, #091e420a)",
    'elevation.surface': "var(--ds-surface, #FFFFFF)",
    'elevation.surface.hovered': "var(--ds-surface-hovered, #FAFBFC)",
    'elevation.surface.pressed': "var(--ds-surface-pressed, #F4F5F7)",
    'elevation.surface.overlay': "var(--ds-surface-overlay, #FFFFFF)",
    'elevation.surface.overlay.hovered': "var(--ds-surface-overlay-hovered, #FAFBFC)",
    'elevation.surface.overlay.pressed': "var(--ds-surface-overlay-pressed, #F4F5F7)",
    'elevation.surface.raised': "var(--ds-surface-raised, #FFFFFF)",
    'elevation.surface.raised.hovered': "var(--ds-surface-raised-hovered, #FAFBFC)",
    'elevation.surface.raised.pressed': "var(--ds-surface-raised-pressed, #F4F5F7)",
    'elevation.surface.sunken': "var(--ds-surface-sunken, #F4F5F7)",
    'utility.elevation.surface.current': "var(--ds-elevation-surface-current, #FFFFFF)"
};
var $9e847408f5b72379$export$8473307aa00d6ea1 = {
    'color.text': "var(--ds-text, #172B4D)",
    'color.text.accent.lime': "var(--ds-text-accent-lime, #4C6B1F)",
    'color.text.accent.lime.bolder': "var(--ds-text-accent-lime-bolder, #37471F)",
    'color.text.accent.red': "var(--ds-text-accent-red, #DE350B)",
    'color.text.accent.red.bolder': "var(--ds-text-accent-red-bolder, #BF2600)",
    'color.text.accent.orange': "var(--ds-text-accent-orange, #F18D13)",
    'color.text.accent.orange.bolder': "var(--ds-text-accent-orange-bolder, #B65C02)",
    'color.text.accent.yellow': "var(--ds-text-accent-yellow, #FF991F)",
    'color.text.accent.yellow.bolder': "var(--ds-text-accent-yellow-bolder, #FF8B00)",
    'color.text.accent.green': "var(--ds-text-accent-green, #00875A)",
    'color.text.accent.green.bolder': "var(--ds-text-accent-green-bolder, #006644)",
    'color.text.accent.teal': "var(--ds-text-accent-teal, #00A3BF)",
    'color.text.accent.teal.bolder': "var(--ds-text-accent-teal-bolder, #008DA6)",
    'color.text.accent.blue': "var(--ds-text-accent-blue, #0052CC)",
    'color.text.accent.blue.bolder': "var(--ds-text-accent-blue-bolder, #0747A6)",
    'color.text.accent.purple': "var(--ds-text-accent-purple, #5243AA)",
    'color.text.accent.purple.bolder': "var(--ds-text-accent-purple-bolder, #403294)",
    'color.text.accent.magenta': "var(--ds-text-accent-magenta, #E774BB)",
    'color.text.accent.magenta.bolder': "var(--ds-text-accent-magenta-bolder, #DA62AC)",
    'color.text.accent.gray': "var(--ds-text-accent-gray, #505F79)",
    'color.text.accent.gray.bolder': "var(--ds-text-accent-gray-bolder, #172B4D)",
    'color.text.disabled': "var(--ds-text-disabled, #A5ADBA)",
    'color.text.inverse': "var(--ds-text-inverse, #FFFFFF)",
    'color.text.selected': "var(--ds-text-selected, #0052CC)",
    'color.text.brand': "var(--ds-text-brand, #0065FF)",
    'color.text.danger': "var(--ds-text-danger, #DE350B)",
    'color.text.warning': "var(--ds-text-warning, #974F0C)",
    'color.text.warning.inverse': "var(--ds-text-warning-inverse, #172B4D)",
    'color.text.success': "var(--ds-text-success, #006644)",
    'color.text.discovery': "var(--ds-text-discovery, #403294)",
    'color.text.information': "var(--ds-text-information, #0052CC)",
    'color.text.subtlest': "var(--ds-text-subtlest, #7A869A)",
    'color.text.subtle': "var(--ds-text-subtle, #42526E)",
    'color.link': "var(--ds-link, #0052CC)",
    'color.link.pressed': "var(--ds-link-pressed, #0747A6)",
    'color.link.visited': "var(--ds-link-visited, #403294)",
    'color.link.visited.pressed': "var(--ds-link-visited-pressed, #403294)"
};
var $9e847408f5b72379$export$498780f74be9af68 = {
    'color.icon': "var(--ds-icon, #505F79)",
    'color.icon.accent.lime': "var(--ds-icon-accent-lime, #6A9A23)",
    'color.icon.accent.red': "var(--ds-icon-accent-red, #FF5630)",
    'color.icon.accent.orange': "var(--ds-icon-accent-orange, #D94008)",
    'color.icon.accent.yellow': "var(--ds-icon-accent-yellow, #FFAB00)",
    'color.icon.accent.green': "var(--ds-icon-accent-green, #36B37E)",
    'color.icon.accent.teal': "var(--ds-icon-accent-teal, #00B8D9)",
    'color.icon.accent.blue': "var(--ds-icon-accent-blue, #0065FF)",
    'color.icon.accent.purple': "var(--ds-icon-accent-purple, #6554C0)",
    'color.icon.accent.magenta': "var(--ds-icon-accent-magenta, #CD519D)",
    'color.icon.accent.gray': "var(--ds-icon-accent-gray, #5E6C84)",
    'color.icon.disabled': "var(--ds-icon-disabled, #8993A4)",
    'color.icon.inverse': "var(--ds-icon-inverse, #FFFFFF)",
    'color.icon.selected': "var(--ds-icon-selected, #0052CC)",
    'color.icon.brand': "var(--ds-icon-brand, #0065FF)",
    'color.icon.danger': "var(--ds-icon-danger, #DE350B)",
    'color.icon.warning': "var(--ds-icon-warning, #FFC400)",
    'color.icon.warning.inverse': "var(--ds-icon-warning-inverse, #253858)",
    'color.icon.success': "var(--ds-icon-success, #00875A)",
    'color.icon.discovery': "var(--ds-icon-discovery, #8777D9)",
    'color.icon.information': "var(--ds-icon-information, #0747A6)",
    'color.icon.subtle': "var(--ds-icon-subtle, #6B778C)"
};
var $9e847408f5b72379$export$b5f31a7e431d2eab = {
    '1': 1,
    card: 100,
    navigation: 200,
    dialog: 300,
    layer: 400,
    blanket: 500,
    modal: 510,
    flag: 600,
    spotlight: 700,
    tooltip: 800
};
var $9e847408f5b72379$export$e1b83c5210c471b8 = {
    'border.width': "var(--ds-border-width, 1px)",
    'border.width.0': "var(--ds-border-width-0, 0px)",
    'border.width.indicator': "var(--ds-border-width-indicator, 3px)",
    'border.width.outline': "var(--ds-border-width-outline, 2px)"
};
var $9e847408f5b72379$export$3c0a6c3e64bb180d = {
    'border.radius.050': "var(--ds-border-radius-050, 2px)",
    'border.radius': "var(--ds-border-radius, 3px)",
    'border.radius.100': "var(--ds-border-radius-100, 3px)",
    'border.radius.200': "var(--ds-border-radius-200, 8px)",
    'border.radius.300': "var(--ds-border-radius-300, 12px)",
    'border.radius.400': "var(--ds-border-radius-400, 16px)",
    'border.radius.circle': "var(--ds-border-radius-circle, 32032px)"
};
var $9e847408f5b72379$export$6ffa317d5e70375 = {
    'font.body': "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    'font.body.UNSAFE_small': "var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    'font.body.large': "var(--ds-font-body-large, normal 400 16px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    'font.body.small': "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    'font.code': "var(--ds-font-code, normal 400 0.875em/1 ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)",
    'font.heading.large': "var(--ds-font-heading-large, normal 500 24px/28px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    'font.heading.medium': "var(--ds-font-heading-medium, normal 500 20px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    'font.heading.small': "var(--ds-font-heading-small, normal 600 16px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    'font.heading.xlarge': "var(--ds-font-heading-xlarge, normal 600 29px/32px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    'font.heading.xsmall': "var(--ds-font-heading-xsmall, normal 600 14px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    'font.heading.xxlarge': "var(--ds-font-heading-xxlarge, normal 500 35px/40px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    'font.heading.xxsmall': "var(--ds-font-heading-xxsmall, normal 600 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)"
};
var $9e847408f5b72379$export$303e322c6b1ed114 = {
    'font.weight.bold': "var(--ds-font-weight-bold, 700)",
    'font.weight.medium': "var(--ds-font-weight-medium, 500)",
    'font.weight.regular': "var(--ds-font-weight-regular, 400)",
    'font.weight.semibold': "var(--ds-font-weight-semibold, 600)"
};
var $9e847408f5b72379$export$3c7e9587132614b4 = {
    'font.family.body': "var(--ds-font-family-body, ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    'font.family.brand.body': "var(--ds-font-family-brand-body, \"Charlie Text\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    'font.family.brand.heading': "var(--ds-font-family-brand-heading, \"Charlie Display\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    'font.family.code': "var(--ds-font-family-code, ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)",
    'font.family.heading': "var(--ds-font-family-heading, ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)"
};
var $9e847408f5b72379$export$236bfe3a33ef1292 = {
    medium: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    UNSAFE_small: "var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    large: "var(--ds-font-body-large, normal 400 16px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    small: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)"
};
var $9e847408f5b72379$export$855cfd311192d666 = {
    bold: "var(--ds-font-weight-bold, 700)",
    medium: "var(--ds-font-weight-medium, 500)",
    regular: "var(--ds-font-weight-regular, 400)",
    semibold: "var(--ds-font-weight-semibold, 600)"
};
/**
 * @codegenEnd
 */ // Margin needs some bespoke types: https://atlassian.slack.com/archives/CKRHB23K8/p1712623192772909
// Generate maps for Box props. backgroundColor, padding, etc
var $9e847408f5b72379$var$spacingProperties = [
    // Used by Box
    'padding',
    'paddingBlock',
    'paddingBlockStart',
    'paddingBlockEnd',
    'paddingInline',
    'paddingInlineStart',
    'paddingInlineEnd',
    // Used by Inline and Stack
    'gap',
    'rowGap',
    'columnGap'
];
var $9e847408f5b72379$export$ca0f9c2de39ffed7 = function getSerializedStylesMap(cssProperty, tokenMap) {
    return Object.keys(tokenMap).reduce(function(emotionSpacingMap, token) {
        // eslint-disable-next-line @repo/internal/styles/no-exported-styles
        emotionSpacingMap[token] = (0, $74Zh5.css)((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, cssProperty, tokenMap[token]));
        return emotionSpacingMap;
    }, {});
};
var $9e847408f5b72379$export$e615f061ca585a6c = $9e847408f5b72379$var$spacingProperties.reduce(function(styleMap, spacingProperty) {
    styleMap[spacingProperty] = $9e847408f5b72379$export$ca0f9c2de39ffed7(spacingProperty, $9e847408f5b72379$export$958d0ae7f2977ae4);
    return styleMap;
}, {});
var $9e847408f5b72379$export$bf46c3f9eeafc71f = $9e847408f5b72379$var$spacingProperties.reduce(function(styleMap, spacingProperty) {
    styleMap[spacingProperty] = $9e847408f5b72379$export$ca0f9c2de39ffed7(spacingProperty, $9e847408f5b72379$export$958d0ae7f2977ae4);
    return styleMap;
}, {});
var $9e847408f5b72379$export$e7af83bafe7f9e63 = $9e847408f5b72379$export$ca0f9c2de39ffed7('backgroundColor', $9e847408f5b72379$export$d1d79bf68ac056bd);
var $9e847408f5b72379$export$3a1bcba60b23d7f0 = $9e847408f5b72379$export$ca0f9c2de39ffed7('color', $9e847408f5b72379$export$8473307aa00d6ea1);
var $9e847408f5b72379$export$45f3f4fe16f9f7d5 = $9e847408f5b72379$export$ca0f9c2de39ffed7('fontWeight', $9e847408f5b72379$export$303e322c6b1ed114);
var $9e847408f5b72379$export$68cc305da27dbaa4 = $9e847408f5b72379$export$ca0f9c2de39ffed7('fontFamily', $9e847408f5b72379$export$3c7e9587132614b4);
var $9e847408f5b72379$export$128f10c238242f83 = $9e847408f5b72379$export$ca0f9c2de39ffed7('font', $9e847408f5b72379$export$6ffa317d5e70375);
var $9e847408f5b72379$export$219d364c0da35ae4 = $9e847408f5b72379$export$ca0f9c2de39ffed7('font', $9e847408f5b72379$export$236bfe3a33ef1292);
var $9e847408f5b72379$export$38845ca010b93505 = $9e847408f5b72379$export$ca0f9c2de39ffed7('fontWeight', $9e847408f5b72379$export$855cfd311192d666);
var $9e847408f5b72379$export$ff257d957d48c421 = $9e847408f5b72379$export$ca0f9c2de39ffed7((0, $dcc0f48710161fe0$export$9d7b58831ae93caa), $9e847408f5b72379$export$41a358c9c2356760);
var $9e847408f5b72379$export$5e65a44e5b6ecadb = function isSurfaceColorToken(color) {
    return $9e847408f5b72379$export$41a358c9c2356760[color] !== undefined;
};



var $3ZMUU = parcelRequire("3ZMUU");
function $30e684ef34ab0a0b$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $30e684ef34ab0a0b$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $30e684ef34ab0a0b$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $30e684ef34ab0a0b$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $30e684ef34ab0a0b$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $30e684ef34ab0a0b$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
var $30e684ef34ab0a0b$export$9a199fbafee0014e = {
    backgroundColor: (0, $9e847408f5b72379$export$d1d79bf68ac056bd),
    blockSize: (0, $9e847408f5b72379$export$6ccdbebca2ee545f),
    borderBlockColor: (0, $9e847408f5b72379$export$1531ad5bb3fbedac),
    borderBlockEndColor: (0, $9e847408f5b72379$export$1531ad5bb3fbedac),
    borderBlockEndWidth: (0, $9e847408f5b72379$export$e1b83c5210c471b8),
    borderBlockStartColor: (0, $9e847408f5b72379$export$1531ad5bb3fbedac),
    borderBlockStartWidth: (0, $9e847408f5b72379$export$e1b83c5210c471b8),
    borderBlockWidth: (0, $9e847408f5b72379$export$e1b83c5210c471b8),
    borderBottomColor: (0, $9e847408f5b72379$export$1531ad5bb3fbedac),
    borderBottomLeftRadius: (0, $9e847408f5b72379$export$3c0a6c3e64bb180d),
    borderBottomRightRadius: (0, $9e847408f5b72379$export$3c0a6c3e64bb180d),
    borderBottomWidth: (0, $9e847408f5b72379$export$e1b83c5210c471b8),
    borderColor: (0, $9e847408f5b72379$export$1531ad5bb3fbedac),
    borderEndEndRadius: (0, $9e847408f5b72379$export$3c0a6c3e64bb180d),
    borderEndStartRadius: (0, $9e847408f5b72379$export$3c0a6c3e64bb180d),
    borderInlineColor: (0, $9e847408f5b72379$export$1531ad5bb3fbedac),
    borderInlineEndColor: (0, $9e847408f5b72379$export$1531ad5bb3fbedac),
    borderInlineEndWidth: (0, $9e847408f5b72379$export$e1b83c5210c471b8),
    borderInlineStartColor: (0, $9e847408f5b72379$export$1531ad5bb3fbedac),
    borderInlineStartWidth: (0, $9e847408f5b72379$export$e1b83c5210c471b8),
    borderInlineWidth: (0, $9e847408f5b72379$export$e1b83c5210c471b8),
    borderLeftColor: (0, $9e847408f5b72379$export$1531ad5bb3fbedac),
    borderLeftWidth: (0, $9e847408f5b72379$export$e1b83c5210c471b8),
    borderRadius: (0, $9e847408f5b72379$export$3c0a6c3e64bb180d),
    borderRightColor: (0, $9e847408f5b72379$export$1531ad5bb3fbedac),
    borderRightWidth: (0, $9e847408f5b72379$export$e1b83c5210c471b8),
    borderStartEndRadius: (0, $9e847408f5b72379$export$3c0a6c3e64bb180d),
    borderStartStartRadius: (0, $9e847408f5b72379$export$3c0a6c3e64bb180d),
    borderTopColor: (0, $9e847408f5b72379$export$1531ad5bb3fbedac),
    borderTopLeftRadius: (0, $9e847408f5b72379$export$3c0a6c3e64bb180d),
    borderTopRightRadius: (0, $9e847408f5b72379$export$3c0a6c3e64bb180d),
    borderTopWidth: (0, $9e847408f5b72379$export$e1b83c5210c471b8),
    borderWidth: (0, $9e847408f5b72379$export$e1b83c5210c471b8),
    bottom: (0, $9e847408f5b72379$export$632685d741f3dbbf),
    boxShadow: (0, $9e847408f5b72379$export$7aff6e7ba39bb774),
    color: (0, $9e847408f5b72379$export$8473307aa00d6ea1),
    columnGap: (0, $9e847408f5b72379$export$958d0ae7f2977ae4),
    font: (0, $9e847408f5b72379$export$6ffa317d5e70375),
    fontFamily: (0, $9e847408f5b72379$export$3c7e9587132614b4),
    fontWeight: (0, $9e847408f5b72379$export$303e322c6b1ed114),
    gap: (0, $9e847408f5b72379$export$958d0ae7f2977ae4),
    height: (0, $9e847408f5b72379$export$6ccdbebca2ee545f),
    inlineSize: (0, $9e847408f5b72379$export$6ccdbebca2ee545f),
    inset: (0, $9e847408f5b72379$export$632685d741f3dbbf),
    insetBlock: (0, $9e847408f5b72379$export$632685d741f3dbbf),
    insetBlockEnd: (0, $9e847408f5b72379$export$632685d741f3dbbf),
    insetBlockStart: (0, $9e847408f5b72379$export$632685d741f3dbbf),
    insetInline: (0, $9e847408f5b72379$export$632685d741f3dbbf),
    insetInlineEnd: (0, $9e847408f5b72379$export$632685d741f3dbbf),
    insetInlineStart: (0, $9e847408f5b72379$export$632685d741f3dbbf),
    left: (0, $9e847408f5b72379$export$632685d741f3dbbf),
    margin: (0, $9e847408f5b72379$export$632685d741f3dbbf),
    marginBlock: (0, $9e847408f5b72379$export$632685d741f3dbbf),
    marginBlockEnd: (0, $9e847408f5b72379$export$632685d741f3dbbf),
    marginBlockStart: (0, $9e847408f5b72379$export$632685d741f3dbbf),
    marginBottom: (0, $9e847408f5b72379$export$632685d741f3dbbf),
    marginInline: (0, $9e847408f5b72379$export$632685d741f3dbbf),
    marginInlineEnd: (0, $9e847408f5b72379$export$632685d741f3dbbf),
    marginInlineStart: (0, $9e847408f5b72379$export$632685d741f3dbbf),
    marginLeft: (0, $9e847408f5b72379$export$632685d741f3dbbf),
    marginRight: (0, $9e847408f5b72379$export$632685d741f3dbbf),
    marginTop: (0, $9e847408f5b72379$export$632685d741f3dbbf),
    maxBlockSize: (0, $9e847408f5b72379$export$6ccdbebca2ee545f),
    maxHeight: (0, $9e847408f5b72379$export$6ccdbebca2ee545f),
    maxInlineSize: (0, $9e847408f5b72379$export$6ccdbebca2ee545f),
    maxWidth: (0, $9e847408f5b72379$export$6ccdbebca2ee545f),
    minBlockSize: (0, $9e847408f5b72379$export$6ccdbebca2ee545f),
    minHeight: (0, $9e847408f5b72379$export$6ccdbebca2ee545f),
    minInlineSize: (0, $9e847408f5b72379$export$6ccdbebca2ee545f),
    minWidth: (0, $9e847408f5b72379$export$6ccdbebca2ee545f),
    opacity: (0, $9e847408f5b72379$export$daf94a976c798b4f),
    outlineColor: (0, $9e847408f5b72379$export$1531ad5bb3fbedac),
    outlineOffset: (0, $9e847408f5b72379$export$958d0ae7f2977ae4),
    outlineWidth: (0, $9e847408f5b72379$export$e1b83c5210c471b8),
    padding: (0, $9e847408f5b72379$export$958d0ae7f2977ae4),
    paddingBlock: (0, $9e847408f5b72379$export$958d0ae7f2977ae4),
    paddingBlockEnd: (0, $9e847408f5b72379$export$958d0ae7f2977ae4),
    paddingBlockStart: (0, $9e847408f5b72379$export$958d0ae7f2977ae4),
    paddingBottom: (0, $9e847408f5b72379$export$958d0ae7f2977ae4),
    paddingInline: (0, $9e847408f5b72379$export$958d0ae7f2977ae4),
    paddingInlineEnd: (0, $9e847408f5b72379$export$958d0ae7f2977ae4),
    paddingInlineStart: (0, $9e847408f5b72379$export$958d0ae7f2977ae4),
    paddingLeft: (0, $9e847408f5b72379$export$958d0ae7f2977ae4),
    paddingRight: (0, $9e847408f5b72379$export$958d0ae7f2977ae4),
    paddingTop: (0, $9e847408f5b72379$export$958d0ae7f2977ae4),
    right: (0, $9e847408f5b72379$export$632685d741f3dbbf),
    rowGap: (0, $9e847408f5b72379$export$958d0ae7f2977ae4),
    top: (0, $9e847408f5b72379$export$632685d741f3dbbf),
    width: (0, $9e847408f5b72379$export$6ccdbebca2ee545f),
    zIndex: (0, $9e847408f5b72379$export$b5f31a7e431d2eab)
};
var $30e684ef34ab0a0b$var$uniqueSymbol = Symbol('UNSAFE_INTERNAL_styles');
var $30e684ef34ab0a0b$var$isSafeEnvToThrow = function isSafeEnvToThrow() {
    return (typeof $3ZMUU === "undefined" ? "undefined" : (0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))($3ZMUU)) === 'object' && (0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))($3ZMUU.env) === 'object' && false;
};
var $30e684ef34ab0a0b$var$reNestedSelectors = /(\.|\s|&+|\*\>|#|\[.*\])/;
var $30e684ef34ab0a0b$var$safeSelectors = /^@media .*$|^::?.*$|^@supports .*$/;
var $30e684ef34ab0a0b$var$_transformStyles = function transformStyles(styleObj) {
    if (!styleObj || (0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(styleObj) !== 'object') return styleObj;
    // If styles are defined as a CSSObject[], recursively call on each element until we reach CSSObject
    if (Array.isArray(styleObj)) return styleObj.map($30e684ef34ab0a0b$var$_transformStyles);
    // Modifies styleObj in place. Be careful.
    Object.entries(styleObj).forEach(function(_ref) {
        var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_ref, 2), key = _ref2[0], value = _ref2[1];
        // If key is a pseudo class or a pseudo element, then value should be an object.
        // So, call transformStyles on the value
        if ((0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(value) === 'object' && $30e684ef34ab0a0b$var$safeSelectors.test(key)) {
            styleObj[key] = $30e684ef34ab0a0b$var$_transformStyles(value);
            return;
        }
        if ($30e684ef34ab0a0b$var$isSafeEnvToThrow()) {
            // We don't support `.class`, `[data-testid]`, `> *`, `#some-id`
            if ($30e684ef34ab0a0b$var$reNestedSelectors.test(key)) throw new Error("Styles not supported for key '".concat(key, "'."));
        }
        // We have now dealt with all the special cases, so,
        // check whether what remains is a style property
        // that can be transformed.
        if (!(key in $30e684ef34ab0a0b$export$9a199fbafee0014e)) return;
        var tokenValue = $30e684ef34ab0a0b$export$9a199fbafee0014e[key][value];
        styleObj[key] = tokenValue !== null && tokenValue !== void 0 ? tokenValue : value;
    });
    return styleObj;
};
var $30e684ef34ab0a0b$var$baseXcss = function baseXcss(style) {
    var transformedStyles = $30e684ef34ab0a0b$var$_transformStyles(style);
    return (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, $30e684ef34ab0a0b$var$uniqueSymbol, (0, $74Zh5.css)(transformedStyles));
};
/**
 * Picks out runtime XCSS objects and build-time XCSS strings. This is needed
 * to supported both Emotion and Compiled styles until we've fully migrated
 * to Compiled.
 *
 * @private
 * @deprecated
 */ var $30e684ef34ab0a0b$export$a9c84988c8f81f2d = function parseXcss(args) {
    if (Array.isArray(args)) {
        var emotion = [];
        var staticArr = [];
        var _iterator = $30e684ef34ab0a0b$var$_createForOfIteratorHelper(args), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var arg = _step.value;
                var result = $30e684ef34ab0a0b$export$a9c84988c8f81f2d(arg);
                if (result.emotion) emotion.push.apply(emotion, (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(result.emotion));
                if (result.static) staticArr.push(result.static);
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
        return {
            emotion: emotion,
            static: staticArr.join(' ')
        };
    }
    var objArgs = args;
    var _ref4 = objArgs || {}, styles = _ref4[$30e684ef34ab0a0b$var$uniqueSymbol];
    if (styles) return {
        emotion: [
            styles
        ]
    };
    if (args) {
        // We use string interpolation here instead of .toString() just
        // in case the resulting object doesn't have the method available.
        var stringifiedArgs = "".concat(args);
        if (stringifiedArgs) return {
            static: stringifiedArgs
        };
    }
    return {};
};
function $30e684ef34ab0a0b$export$f6c783d06584602c(style) {
    return $30e684ef34ab0a0b$var$baseXcss(style);
}


/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5FkrB = parcelRequire("5FkrB");

var $74Zh5 = parcelRequire("74Zh5");


var $3cedca516816060e$var$justifyContentMap = {
    start: (0, $74Zh5.css)({
        justifyContent: 'start'
    }),
    center: (0, $74Zh5.css)({
        justifyContent: 'center'
    }),
    end: (0, $74Zh5.css)({
        justifyContent: 'end'
    }),
    'space-between': (0, $74Zh5.css)({
        justifyContent: 'space-between'
    }),
    'space-around': (0, $74Zh5.css)({
        justifyContent: 'space-around'
    }),
    'space-evenly': (0, $74Zh5.css)({
        justifyContent: 'space-evenly'
    }),
    stretch: (0, $74Zh5.css)({
        justifyContent: 'stretch'
    })
};
var $3cedca516816060e$var$flexDirectionMap = {
    column: (0, $74Zh5.css)({
        flexDirection: 'column'
    }),
    row: (0, $74Zh5.css)({
        flexDirection: 'row'
    })
};
var $3cedca516816060e$var$flexWrapMap = {
    wrap: (0, $74Zh5.css)({
        flexWrap: 'wrap'
    }),
    nowrap: (0, $74Zh5.css)({
        flexWrap: 'nowrap'
    })
};
var $3cedca516816060e$var$alignItemsMap = {
    start: (0, $74Zh5.css)({
        alignItems: 'start'
    }),
    center: (0, $74Zh5.css)({
        alignItems: 'center'
    }),
    baseline: (0, $74Zh5.css)({
        alignItems: 'baseline'
    }),
    end: (0, $74Zh5.css)({
        alignItems: 'end'
    }),
    stretch: (0, $74Zh5.css)({
        alignItems: 'stretch'
    })
};
var $3cedca516816060e$var$baseStyles = (0, $74Zh5.css)({
    display: 'flex',
    boxSizing: 'border-box'
});
/**
 * __Flex__
 *
 * `Flex` is a primitive component that implements the CSS Flexbox API.
 *
 * - [Examples](https://atlassian.design/components/primitives/flex/examples)
 * - [Code](https://atlassian.design/components/primitives/flex/code)
 *
 * @example
 * ```tsx
 * import { Flex, Box } from '@atlaskit/primitives'
 *
 * const Component = () => (
 *   <Flex direction="column">
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *   </Flex>
 * )
 * ```
 */ var $3cedca516816060e$var$Flex = /*#__PURE__*/ (0, $5FkrB.memo)(/*#__PURE__*/ (0, $5FkrB.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? 'div' : _ref$as, role = _ref.role, alignItems = _ref.alignItems, justifyContent = _ref.justifyContent, gap = _ref.gap, columnGap = _ref.columnGap, rowGap = _ref.rowGap, children = _ref.children, testId = _ref.testId, direction = _ref.direction, wrap = _ref.wrap, xcss = _ref.xcss;
    var resolvedStyles = (0, $30e684ef34ab0a0b$export$a9c84988c8f81f2d)(xcss);
    return (0, $74Zh5.jsx)(Component, {
        role: role,
        className: resolvedStyles.static,
        css: [
            $3cedca516816060e$var$baseStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            gap && (0, $9e847408f5b72379$export$bf46c3f9eeafc71f).gap[gap],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            columnGap && (0, $9e847408f5b72379$export$bf46c3f9eeafc71f).columnGap[columnGap],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            rowGap && (0, $9e847408f5b72379$export$bf46c3f9eeafc71f).rowGap[rowGap],
            alignItems && $3cedca516816060e$var$alignItemsMap[alignItems],
            direction && $3cedca516816060e$var$flexDirectionMap[direction],
            justifyContent && $3cedca516816060e$var$justifyContentMap[justifyContent],
            wrap && $3cedca516816060e$var$flexWrapMap[wrap],
            // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
            resolvedStyles.emotion
        ],
        "data-testid": testId,
        ref: ref
    }, children);
}));
$3cedca516816060e$var$Flex.displayName = 'Flex';
var $3cedca516816060e$export$2e2bcd8739ae039 = $3cedca516816060e$var$Flex;


var $27179a0b661c3101$var$flexGrowMap = {
    hug: (0, $30e684ef34ab0a0b$export$f6c783d06584602c)({
        flexGrow: 0
    }),
    fill: (0, $30e684ef34ab0a0b$export$f6c783d06584602c)({
        width: '100%',
        flexGrow: 1
    })
};
var $27179a0b661c3101$var$separatorStyles = (0, $74Zh5.css)({
    color: "var(--ds-text-subtle, #42526E)",
    marginBlock: "var(--ds-space-0, 0px)",
    marginInline: "var(--ds-space-negative-025, -2px)",
    pointerEvents: 'none',
    userSelect: 'none'
});
var $27179a0b661c3101$var$Separator = function Separator(_ref) {
    var children = _ref.children;
    return (0, $74Zh5.jsx)("span", {
        css: $27179a0b661c3101$var$separatorStyles
    }, children);
};
/**
 * __Inline__
 *
 * Inline is a primitive component based on CSS Flexbox that manages the horizontal layout of direct children.
 *
 * @example
 * ```tsx
 *  <Inline>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *  </Inline>
 * ```
 *
 */ var $27179a0b661c3101$var$Inline = /*#__PURE__*/ (0, $5FkrB.memo)(/*#__PURE__*/ (0, $5FkrB.forwardRef)(function(_ref2, ref) {
    var as = _ref2.as, alignInline = _ref2.alignInline, _ref2$alignBlock = _ref2.alignBlock, alignItems = _ref2$alignBlock === void 0 ? 'start' : _ref2$alignBlock, _ref2$shouldWrap = _ref2.shouldWrap, shouldWrap = _ref2$shouldWrap === void 0 ? false : _ref2$shouldWrap, spread = _ref2.spread, grow = _ref2.grow, space = _ref2.space, rowSpace = _ref2.rowSpace, separator = _ref2.separator, xcss = _ref2.xcss, testId = _ref2.testId, role = _ref2.role, rawChildren = _ref2.children;
    var separatorComponent = typeof separator === 'string' ? (0, $74Zh5.jsx)($27179a0b661c3101$var$Separator, null, separator) : separator;
    var children = separatorComponent ? (0, $5FkrB.Children).toArray(rawChildren).filter(Boolean).map(function(child, index) {
        return (0, $74Zh5.jsx)((0, $5FkrB.Fragment), {
            key: index
        }, separator && index > 0 ? separatorComponent : null, child);
    }) : rawChildren;
    var justifyContent = spread || alignInline;
    // We're type coercing this as Compiled styles in an array isn't supported by the types
    // But the runtime accepts it none-the-wiser. We can remove this entire block and replace
    // it with cx(defaultStyles, focusRingStyles, xcssStyles) when we've moved away from Emotion.
    var styles = grow ? [
        $27179a0b661c3101$var$flexGrowMap[grow]
    ].concat((0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(Array.isArray(xcss) ? xcss : [
        xcss
    ])) : xcss;
    return (0, $74Zh5.jsx)((0, $3cedca516816060e$export$2e2bcd8739ae039), {
        as: as,
        role: role,
        alignItems: alignItems,
        justifyContent: justifyContent,
        direction: "row",
        gap: space,
        rowGap: rowSpace,
        wrap: shouldWrap ? 'wrap' : undefined,
        xcss: styles,
        testId: testId,
        ref: ref
    }, children);
}));
$27179a0b661c3101$var$Inline.displayName = 'Inline';
var $27179a0b661c3101$export$2e2bcd8739ae039 = $27179a0b661c3101$var$Inline;


var $fC8ib = parcelRequire("fC8ib");

var $5FkrB = parcelRequire("5FkrB");

var $74Zh5 = parcelRequire("74Zh5");


var $7e3cff32e16d4929$var$flexGrowMap = {
    hug: (0, $30e684ef34ab0a0b$export$f6c783d06584602c)({
        flexGrow: 0
    }),
    fill: (0, $30e684ef34ab0a0b$export$f6c783d06584602c)({
        width: '100%',
        flexGrow: 1
    })
};
/**
 * __Stack__
 *
 * Stack is a primitive component based on flexbox that manages the block layout of direct children.
 *
 * @example
 * ```tsx
 *  <Stack>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *  </Stack>
 * ```
 *
 */ var $7e3cff32e16d4929$var$Stack = /*#__PURE__*/ (0, $5FkrB.memo)(/*#__PURE__*/ (0, $5FkrB.forwardRef)(function(_ref, ref) {
    var as = _ref.as, alignItems = _ref.alignInline, _ref$alignBlock = _ref.alignBlock, alignBlock = _ref$alignBlock === void 0 ? 'stretch' : _ref$alignBlock, spread = _ref.spread, grow = _ref.grow, space = _ref.space, children = _ref.children, testId = _ref.testId, xcss = _ref.xcss, role = _ref.role;
    var justifyContent = spread || alignBlock;
    // We're type coercing this as Compiled styles in an array isn't supported by the types
    // But the runtime accepts it none-the-wiser. We can remove this entire block and replace
    // it with cx(defaultStyles, focusRingStyles, xcssStyles) when we've moved away from Emotion.
    var styles = grow ? [
        $7e3cff32e16d4929$var$flexGrowMap[grow]
    ].concat((0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(Array.isArray(xcss) ? xcss : [
        xcss
    ])) : xcss;
    return (0, $74Zh5.jsx)((0, $3cedca516816060e$export$2e2bcd8739ae039), {
        as: as,
        role: role,
        gap: space,
        direction: "column",
        alignItems: alignItems,
        justifyContent: justifyContent,
        xcss: styles,
        testId: testId,
        ref: ref
    }, children);
}));
$7e3cff32e16d4929$var$Stack.displayName = 'Stack';
var $7e3cff32e16d4929$export$2e2bcd8739ae039 = $7e3cff32e16d4929$var$Stack;


/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ // Reds
var $1d2890bfdc85c1d1$export$4b84fd0e2c617bd = '#FFEBE6';
var $1d2890bfdc85c1d1$export$b34b069eff244586 = '#FFBDAD';
var $1d2890bfdc85c1d1$export$be802dd0d8b57f35 = '#FF8F73';
var $1d2890bfdc85c1d1$export$60847d42f9da92a6 = '#FF7452';
var $1d2890bfdc85c1d1$export$4a7404f376229999 = '#FF5630';
var $1d2890bfdc85c1d1$export$2010d0fb4295b346 = '#DE350B';
var $1d2890bfdc85c1d1$export$2837b5a1a71d5c02 = '#BF2600';
var $1d2890bfdc85c1d1$export$8d9596b529bbb9cf = '#FFFAE6';
var $1d2890bfdc85c1d1$export$41060a744ab0b7ae = '#FFF0B3';
var $1d2890bfdc85c1d1$export$1cc05bbbf340e559 = '#FFE380';
var $1d2890bfdc85c1d1$export$5aae31392d72caaa = '#FFC400';
var $1d2890bfdc85c1d1$export$c6930421db9fa514 = '#FFAB00';
var $1d2890bfdc85c1d1$export$59619663aa6500fb = '#FF991F';
var $1d2890bfdc85c1d1$export$874739ea9e379ab6 = '#FF8B00';
var $1d2890bfdc85c1d1$export$8a6341c32b6a3ee6 = '#E3FCEF';
var $1d2890bfdc85c1d1$export$69a3bf21b9686c2b = '#ABF5D1';
var $1d2890bfdc85c1d1$export$afbce1382ec95f73 = '#79F2C0';
var $1d2890bfdc85c1d1$export$747d86715d4175de = '#57D9A3';
var $1d2890bfdc85c1d1$export$940e1f69e873f202 = '#36B37E';
var $1d2890bfdc85c1d1$export$a49394138f7b8e85 = '#00875A';
var $1d2890bfdc85c1d1$export$6fa04827ac68a4fb = '#006644';
var $1d2890bfdc85c1d1$export$226de0355ed012f8 = '#DEEBFF';
var $1d2890bfdc85c1d1$export$8c13c2ee36917869 = '#B3D4FF';
var $1d2890bfdc85c1d1$export$ecfc1dff386a3e7a = '#4C9AFF';
var $1d2890bfdc85c1d1$export$215b7063051591f1 = '#2684FF';
var $1d2890bfdc85c1d1$export$e62e8919cca44969 = '#0065FF';
var $1d2890bfdc85c1d1$export$b3de0ae08da2ce64 = '#0052CC';
var $1d2890bfdc85c1d1$export$a6ee3d71bc067634 = '#0747A6';
var $1d2890bfdc85c1d1$export$67f15409e87642a1 = '#669DF1';
var $1d2890bfdc85c1d1$export$f0539dbc42dbb067 = '#8FB8F6';
var $1d2890bfdc85c1d1$export$363e4475840015bb = '#EAE6FF';
var $1d2890bfdc85c1d1$export$4b0a4417ed59760f = '#C0B6F2';
var $1d2890bfdc85c1d1$export$6011520a64d9a187 = '#998DD9';
var $1d2890bfdc85c1d1$export$a7175d4e9206bc80 = '#8777D9';
var $1d2890bfdc85c1d1$export$b48405b95304b5a1 = '#6554C0';
var $1d2890bfdc85c1d1$export$c71e4279dd54a18d = '#5243AA';
var $1d2890bfdc85c1d1$export$147899de772240ec = '#403294';
var $1d2890bfdc85c1d1$export$2cf711fe14c66f06 = '#E6FCFF';
var $1d2890bfdc85c1d1$export$7a8f4d33f6f9772c = '#B3F5FF';
var $1d2890bfdc85c1d1$export$776c9c497ef08533 = '#79E2F2';
var $1d2890bfdc85c1d1$export$69cb3ca10c1e330e = '#00C7E6';
var $1d2890bfdc85c1d1$export$9dc1ef0f3f48059b = '#00B8D9';
var $1d2890bfdc85c1d1$export$7c835c78b6fcdef8 = '#00A3BF';
var $1d2890bfdc85c1d1$export$6036577f95c3877e = '#008DA6';
var $1d2890bfdc85c1d1$export$29a4f05edc054374 = '#FFFFFF';
var $1d2890bfdc85c1d1$export$e655ef011c4aa1a2 = '#FAFBFC';
var $1d2890bfdc85c1d1$export$9fdfb749e33cdf97 = '#F4F5F7';
var $1d2890bfdc85c1d1$export$3e51e8f1440314ba = '#EBECF0';
var $1d2890bfdc85c1d1$export$1ce2d1575d444ceb = '#DFE1E6';
var $1d2890bfdc85c1d1$export$8754fc7e6d8b3000 = '#C1C7D0';
var $1d2890bfdc85c1d1$export$c2e91cbeada39b8b = '#B3BAC5';
var $1d2890bfdc85c1d1$export$5f71e19f3a7ad9de = '#A5ADBA';
var $1d2890bfdc85c1d1$export$eaa8c8a70ac22806 = '#97A0AF';
var $1d2890bfdc85c1d1$export$7c87d337fb91a97d = '#8993A4';
var $1d2890bfdc85c1d1$export$d6447c357493214f = '#7A869A';
var $1d2890bfdc85c1d1$export$f563ee71e9ee74cd = '#6B778C';
var $1d2890bfdc85c1d1$export$e2ef2124cf4024b1 = '#5E6C84';
var $1d2890bfdc85c1d1$export$eece5f492e429f08 = '#505F79';
var $1d2890bfdc85c1d1$export$c39c0fe0f26207ae = '#42526E';
var $1d2890bfdc85c1d1$export$7090862dc3038a9f = '#344563';
var $1d2890bfdc85c1d1$export$ad0bacf983b7ddaa = '#253858';
var $1d2890bfdc85c1d1$export$7d61b15e0da132af = '#172B4D';
var $1d2890bfdc85c1d1$export$fbda843f0a27fe96 = '#091E42';
var $1d2890bfdc85c1d1$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
var $1d2890bfdc85c1d1$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
var $1d2890bfdc85c1d1$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
var $1d2890bfdc85c1d1$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
var $1d2890bfdc85c1d1$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
var $1d2890bfdc85c1d1$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
var $1d2890bfdc85c1d1$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
var $1d2890bfdc85c1d1$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
var $1d2890bfdc85c1d1$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
var $1d2890bfdc85c1d1$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
var $1d2890bfdc85c1d1$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
var $1d2890bfdc85c1d1$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
var $1d2890bfdc85c1d1$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
var $1d2890bfdc85c1d1$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
var $1d2890bfdc85c1d1$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
var $1d2890bfdc85c1d1$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
var $1d2890bfdc85c1d1$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
var $1d2890bfdc85c1d1$export$2f6319cf7d736c2a = '#E6EDFA';
var $1d2890bfdc85c1d1$export$95126bc8884d6634 = '#DCE5F5';
var $1d2890bfdc85c1d1$export$8338d8c35d44ff1 = '#CED9EB';
var $1d2890bfdc85c1d1$export$5368d76ae4fbbda7 = '#B8C7E0';
var $1d2890bfdc85c1d1$export$9f0a771d16ec8d36 = '#ABBBD6';
var $1d2890bfdc85c1d1$export$abcf8c38338b4aa5 = '#9FB0CC';
var $1d2890bfdc85c1d1$export$97e81faa16a182c7 = '#8C9CB8';
var $1d2890bfdc85c1d1$export$bfe21c59123ecf33 = '#7988A3';
var $1d2890bfdc85c1d1$export$ee82aa2ea6a1558 = '#67758F';
var $1d2890bfdc85c1d1$export$682927c6ed76be02 = '#56637A';
var $1d2890bfdc85c1d1$export$91fd9994c5be9757 = '#455166';
var $1d2890bfdc85c1d1$export$d281fbfe3cff2df6 = '#3B475C';
var $1d2890bfdc85c1d1$export$3902c91d8b98a753 = '#313D52';
var $1d2890bfdc85c1d1$export$8e8133c1ba5845b5 = '#283447';
var $1d2890bfdc85c1d1$export$33ff357f6620b39 = '#202B3D';
var $1d2890bfdc85c1d1$export$633847cf062b69e0 = '#1B2638';
var $1d2890bfdc85c1d1$export$9776a6e503bdbf76 = '#121A29';
var $1d2890bfdc85c1d1$export$6c813d5160dff5db = '#0E1624';
var $1d2890bfdc85c1d1$export$3d4f271a500072a = '#0D1424';
var $1d2890bfdc85c1d1$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
var $1d2890bfdc85c1d1$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
var $1d2890bfdc85c1d1$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
var $1d2890bfdc85c1d1$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
var $1d2890bfdc85c1d1$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
var $1d2890bfdc85c1d1$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
var $1d2890bfdc85c1d1$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
var $1d2890bfdc85c1d1$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
var $1d2890bfdc85c1d1$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
var $1d2890bfdc85c1d1$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
var $1d2890bfdc85c1d1$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
var $1d2890bfdc85c1d1$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
var $1d2890bfdc85c1d1$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
var $1d2890bfdc85c1d1$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
var $1d2890bfdc85c1d1$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
var $1d2890bfdc85c1d1$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
var $1d2890bfdc85c1d1$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';
var $1d2890bfdc85c1d1$export$d2adc5dedf09fced = '#292A2E';
var $1d2890bfdc85c1d1$export$f51762073d2bb381 = '#94C748';
var $1d2890bfdc85c1d1$export$95e26d54def96891 = '#B3DF72';



var $7e07e48730988c43$var$defaultRender = function defaultRender(Component, props) {
    return(// eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    (0, $74Zh5.jsx)(Component, props));
};
var $7e07e48730988c43$var$beforeAfterElementStyles = (0, $74Zh5.css)({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0
});
var $7e07e48730988c43$var$contentStyles = (0, $30e684ef34ab0a0b$export$f6c783d06584602c)({
    outline: 'none',
    overflow: 'hidden',
    textAlign: 'left'
});
var $7e07e48730988c43$var$truncateStyles = (0, $74Zh5.css)({
    display: 'block',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
});
var $7e07e48730988c43$var$titleStyles = (0, $74Zh5.css)({
    font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)"
});
var $7e07e48730988c43$var$wordBreakStyles = (0, $74Zh5.css)({
    wordBreak: 'break-word'
});
var $7e07e48730988c43$var$descriptionStyles = (0, $74Zh5.css)({
    color: "var(--ds-text-subtlest, ".concat((0, $1d2890bfdc85c1d1$export$f563ee71e9ee74cd), ")"),
    font: "var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)"
});
var $7e07e48730988c43$var$disabledDescriptionStyles = (0, $74Zh5.css)({
    color: "var(--ds-text-disabled, ".concat((0, $1d2890bfdc85c1d1$export$f563ee71e9ee74cd), ")")
});
var $7e07e48730988c43$var$positionRelativeStyles = (0, $74Zh5.css)({
    position: 'relative'
});
var $7e07e48730988c43$var$primitiveStyles = (0, $74Zh5.css)({
    display: 'flex',
    boxSizing: 'border-box',
    width: '100%',
    minHeight: 40,
    margin: "var(--ds-space-0, 0px)",
    alignItems: 'center',
    border: 0,
    outline: 0,
    textDecoration: 'none',
    userSelect: 'none',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '&::-moz-focus-inner': {
        border: 0
    },
    '&:hover': {
        textDecoration: 'none'
    }
});
var $7e07e48730988c43$var$spacingMapStyles = {
    cozy: (0, $74Zh5.css)({
        // 8 * 2 (16) + icon (24) === 40
        paddingBlock: "var(--ds-space-100, 8px)",
        paddingInline: "var(--ds-space-200, 16px)"
    }),
    compact: (0, $74Zh5.css)({
        minHeight: 32,
        // 4 * 2 (8) + icon (24) === 32
        paddingBlock: "var(--ds-space-050, 4px)",
        paddingInline: "var(--ds-space-150, 12px)"
    })
};
var $7e07e48730988c43$var$interactiveStyles = (0, $74Zh5.css)({
    cursor: 'pointer'
});
var $7e07e48730988c43$var$unselectedStyles = (0, $74Zh5.css)({
    backgroundColor: "var(--ds-background-neutral-subtle, transparent)",
    color: 'currentColor',
    '&:visited': {
        color: 'currentColor'
    },
    '&:hover': {
        backgroundColor: "var(--ds-background-neutral-subtle-hovered, ".concat((0, $1d2890bfdc85c1d1$export$9fdfb749e33cdf97), ")"),
        color: 'currentColor'
    },
    '&:active': {
        backgroundColor: "var(--ds-background-neutral-subtle-pressed, ".concat((0, $1d2890bfdc85c1d1$export$3e51e8f1440314ba), ")"),
        boxShadow: 'none',
        color: 'currentColor'
    }
});
var $7e07e48730988c43$var$disabledStyles = (0, $74Zh5.css)({
    cursor: 'not-allowed',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '&, :hover, :active': {
        backgroundColor: "var(--ds-background-neutral-subtle, transparent)",
        color: "var(--ds-text-disabled, ".concat((0, $1d2890bfdc85c1d1$export$f563ee71e9ee74cd), ")")
    }
});
var $7e07e48730988c43$var$selectedBorderStyles = (0, $74Zh5.css)({
    '&::before': {
        width: 2,
        position: 'absolute',
        background: "var(--ds-border-selected, transparent)",
        content: '""',
        insetBlockEnd: 0,
        insetBlockStart: 0,
        insetInlineStart: 0
    }
});
var $7e07e48730988c43$var$selectedNotchStyles = (0, $74Zh5.css)({
    '&::before': {
        width: 4,
        position: 'absolute',
        background: "var(--ds-border-selected, transparent)",
        borderRadius: "0 ".concat("var(--ds-border-radius, 4px)", " ", "var(--ds-border-radius, 4px)", " 0"),
        content: '""',
        insetBlockEnd: "var(--ds-space-150, 12px)",
        insetBlockStart: "var(--ds-space-150, 12px)",
        insetInlineStart: 0
    }
});
var $7e07e48730988c43$var$selectedStyles = (0, $74Zh5.css)({
    backgroundColor: "var(--ds-background-selected, ".concat((0, $1d2890bfdc85c1d1$export$9fdfb749e33cdf97), ")"),
    // Fallback set as babel plugin inserts one otherwise
    color: "var(--ds-text-selected, currentColor)",
    '&:visited': {
        color: "var(--ds-text-selected, currentColor)"
    },
    '&:hover': {
        backgroundColor: "var(--ds-background-selected-hovered, ".concat((0, $1d2890bfdc85c1d1$export$9fdfb749e33cdf97), ")"),
        color: "var(--ds-text-selected, currentColor)"
    },
    '&:active': {
        backgroundColor: "var(--ds-background-selected-pressed, ".concat((0, $1d2890bfdc85c1d1$export$3e51e8f1440314ba), ")"),
        color: "var(--ds-text-selected, currentColor)"
    }
});
var $7e07e48730988c43$var$gapMap = {
    compact: 'space.100',
    cozy: 'space.150'
};
/**
 * __Menu item primitive__
 *
 * Menu item primitive contains all the styles for menu items,
 * including support for selected, disabled, and interaction states.
 *
 * Using children as function prop you wire up this to your own host element.
 *
 * ```jsx
 * <MenuItemPrimitive>
 *   {({ children, ...props }) => <button {...props}>{children}</button>}
 * </MenuItemPrimitive>
 * ```
 */ var $7e07e48730988c43$var$MenuItemPrimitive = function MenuItemPrimitive(_ref) {
    var children = _ref.children, title = _ref.title, description = _ref.description, iconAfter = _ref.iconAfter, iconBefore = _ref.iconBefore, overrides = _ref.overrides, UNSAFE_externalClassName = _ref.className, _ref$shouldTitleWrap = _ref.shouldTitleWrap, shouldTitleWrap = _ref$shouldTitleWrap === void 0 ? false : _ref$shouldTitleWrap, _ref$shouldDescriptio = _ref.shouldDescriptionWrap, shouldDescriptionWrap = _ref$shouldDescriptio === void 0 ? false : _ref$shouldDescriptio, _ref$isDisabled = _ref.isDisabled, isDisabled = _ref$isDisabled === void 0 ? false : _ref$isDisabled, _ref$isSelected = _ref.isSelected, isSelected = _ref$isSelected === void 0 ? false : _ref$isSelected, testId = _ref.testId;
    (0, $c6f574dac5b81c12$export$eb1decd851a5ae56)("@atlaskit/menu", 'overrides', overrides !== undefined, '' // TODO: Create DAC post when primitives/xcss are available as alternatives
    );
    var spacing = (0, $5FkrB.useContext)((0, $029784b0740265a3$export$443076ec7ebce042));
    var selectionStyle = (0, $5FkrB.useContext)((0, $029784b0740265a3$export$9ca534b70725964d));
    var renderTitle = overrides && overrides.Title && overrides.Title.render || $7e07e48730988c43$var$defaultRender;
    var UNSAFE_className = UNSAFE_externalClassName;
    return (0, $74Zh5.jsx)((0, $74Zh5.ClassNames), null, function(_ref2) {
        var cn = _ref2.css, cx = _ref2.cx;
        return (0, $74Zh5.jsx)((0, $20f6066d053c10c9$export$2e2bcd8739ae039), {
            isInset: true
        }, children({
            className: cx([
                cn([
                    $7e07e48730988c43$var$positionRelativeStyles,
                    $7e07e48730988c43$var$primitiveStyles,
                    $7e07e48730988c43$var$spacingMapStyles[spacing],
                    !isDisabled && !isSelected && $7e07e48730988c43$var$unselectedStyles,
                    !isDisabled && isSelected && [
                        $7e07e48730988c43$var$selectedStyles,
                        [
                            selectionStyle === 'border' && $7e07e48730988c43$var$selectedBorderStyles,
                            selectionStyle === 'notch' && $7e07e48730988c43$var$selectedNotchStyles
                        ]
                    ],
                    isDisabled ? $7e07e48730988c43$var$disabledStyles : $7e07e48730988c43$var$interactiveStyles
                ]),
                UNSAFE_className
            ]),
            children: (0, $74Zh5.jsx)((0, $27179a0b661c3101$export$2e2bcd8739ae039), {
                as: "span",
                spread: "space-between",
                alignBlock: "center",
                space: $7e07e48730988c43$var$gapMap[spacing],
                grow: "fill",
                testId: testId && "".concat(testId, "--container")
            }, iconBefore && (0, $74Zh5.jsx)("span", {
                "data-item-elem-before": true,
                css: $7e07e48730988c43$var$beforeAfterElementStyles,
                "data-testid": testId && "".concat(testId, "--icon-before")
            }, iconBefore), title && (0, $74Zh5.jsx)((0, $7e3cff32e16d4929$export$2e2bcd8739ae039), {
                alignBlock: "center",
                grow: "fill",
                xcss: $7e07e48730988c43$var$contentStyles
            }, renderTitle('span', {
                children: title,
                className: cn($7e07e48730988c43$var$titleStyles, shouldTitleWrap ? $7e07e48730988c43$var$wordBreakStyles : $7e07e48730988c43$var$truncateStyles),
                'data-item-title': true
            }), description && (0, $74Zh5.jsx)("span", {
                "data-item-description": true,
                css: [
                    $7e07e48730988c43$var$descriptionStyles,
                    isDisabled && $7e07e48730988c43$var$disabledDescriptionStyles,
                    shouldDescriptionWrap ? $7e07e48730988c43$var$wordBreakStyles : $7e07e48730988c43$var$truncateStyles
                ]
            }, description)), iconAfter && (0, $74Zh5.jsx)("span", {
                "data-item-elem-after": true,
                css: $7e07e48730988c43$var$beforeAfterElementStyles,
                "data-testid": testId && "".concat(testId, "--icon-after")
            }, iconAfter))
        }));
    });
};
var $7e07e48730988c43$export$2e2bcd8739ae039 = $7e07e48730988c43$var$MenuItemPrimitive;


var $deae49ab7e32e8cd$var$_excluded = [
    "children",
    "cssFn",
    "description",
    "iconAfter",
    "iconBefore",
    "isDisabled",
    "isSelected",
    "onClick",
    "testId",
    "overrides",
    "onMouseDown",
    "shouldTitleWrap",
    "shouldDescriptionWrap",
    "className",
    "interactionName"
];
/**
 * __Button item__
 *
 * A button item is used to populate a menu with items that are buttons.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/menu/docs/button-item)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/menu)
 */ var $deae49ab7e32e8cd$var$ButtonItem = /*#__PURE__*/ (0, $5FkrB.memo)(/*#__PURE__*/ (0, $5FkrB.forwardRef)(// Type needed on props to extract types with extract react types.
function(props, ref) {
    var children = props.children, _props$cssFn = props.cssFn, cssFn = _props$cssFn === void 0 ? (0, $f2ed9a22761e3cb5$export$2e2bcd8739ae039) : _props$cssFn, description = props.description, iconAfter = props.iconAfter, iconBefore = props.iconBefore, _props$isDisabled = props.isDisabled, isDisabled = _props$isDisabled === void 0 ? false : _props$isDisabled, _props$isSelected = props.isSelected, isSelected = _props$isSelected === void 0 ? false : _props$isSelected, onClick = props.onClick, testId = props.testId, overrides = props.overrides, onMouseDown = props.onMouseDown, shouldTitleWrap = props.shouldTitleWrap, shouldDescriptionWrap = props.shouldDescriptionWrap, UNSAFE_className = props.className, interactionName = props.interactionName, rest = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(props, $deae49ab7e32e8cd$var$_excluded);
    var onMouseDownHandler = onMouseDown;
    var interactionContext = (0, $5FkrB.useContext)((0, $1d30d2a862a7a995$export$2e2bcd8739ae039));
    var handleClick = (0, $5FkrB.useCallback)(function(e) {
        interactionContext === null || interactionContext === void 0 || interactionContext.tracePress(interactionName, e.timeStamp);
        onClick === null || onClick === void 0 || onClick(e);
    }, [
        onClick,
        interactionContext,
        interactionName
    ]);
    if (!children) return null;
    (0, $c6f574dac5b81c12$export$eb1decd851a5ae56)("@atlaskit/menu", 'cssFn', cssFn !== (0, $f2ed9a22761e3cb5$export$2e2bcd8739ae039), '' // TODO: Create DAC post when primitives/xcss are available as alternatives
    );
    return (0, $74Zh5.jsx)((0, $7e07e48730988c43$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        className: UNSAFE_className
    }, rest, {
        // eslint-disable-next-line @repo/internal/react/no-unsafe-overrides
        overrides: overrides,
        iconBefore: iconBefore,
        iconAfter: iconAfter,
        isDisabled: isDisabled,
        isSelected: isSelected,
        description: description,
        title: children,
        shouldTitleWrap: shouldTitleWrap,
        shouldDescriptionWrap: shouldDescriptionWrap,
        css: // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
        cssFn({
            isSelected: isSelected,
            isDisabled: isDisabled
        }),
        testId: testId && "".concat(testId, "--primitive")
    }), function(_ref) {
        var children = _ref.children, className = _ref.className;
        return (0, $74Zh5.jsx)("button", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
            "data-testid": testId
        }, rest, {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: className,
            ref: ref,
            disabled: isDisabled,
            onClick: (0, $dU8Y3.fg)('platform_button_item-add-ufo-metrics') ? handleClick : onClick,
            onMouseDown: onMouseDownHandler,
            type: "button"
        }), children);
    });
}));
var $deae49ab7e32e8cd$export$2e2bcd8739ae039 = $deae49ab7e32e8cd$var$ButtonItem;



var $kqp0i = parcelRequire("kqp0i");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");

var $74Zh5 = parcelRequire("74Zh5");




var $dU8Y3 = parcelRequire("dU8Y3");

var $4935fc4df735be0f$var$_excluded = [
    "component",
    "cssFn",
    "isDisabled",
    "isSelected",
    "onClick",
    "testId",
    "children",
    "description",
    "iconAfter",
    "iconBefore",
    "overrides",
    "onMouseDown",
    "shouldTitleWrap",
    "shouldDescriptionWrap",
    "className",
    "UNSAFE_isDraggable",
    "interactionName"
];
var $4935fc4df735be0f$var$preventEvent = function preventEvent(e) {
    e.preventDefault();
};
// Dirty hack to get generics working with forward ref [1/2]
/**
 * __Custom item__
 *
 * A custom item is used to populate a menu with items that can be any element.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/menu/docs/custom-item)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/menu)
 */ var $4935fc4df735be0f$var$CustomItem = /*#__PURE__*/ (0, $5FkrB.memo)(/*#__PURE__*/ (0, $5FkrB.forwardRef)(function(_ref, ref) {
    var Component = _ref.component, _ref$cssFn = _ref.cssFn, cssFn = _ref$cssFn === void 0 ? (0, $f2ed9a22761e3cb5$export$2e2bcd8739ae039) : _ref$cssFn, _ref$isDisabled = _ref.isDisabled, isDisabled = _ref$isDisabled === void 0 ? false : _ref$isDisabled, _ref$isSelected = _ref.isSelected, isSelected = _ref$isSelected === void 0 ? false : _ref$isSelected, onClick = _ref.onClick, testId = _ref.testId, children = _ref.children, description = _ref.description, iconAfter = _ref.iconAfter, iconBefore = _ref.iconBefore, overrides = _ref.overrides, onMouseDown = _ref.onMouseDown, shouldTitleWrap = _ref.shouldTitleWrap, shouldDescriptionWrap = _ref.shouldDescriptionWrap, UNSAFE_className = _ref.className, UNSAFE_isDraggable = _ref.UNSAFE_isDraggable, interactionName = _ref.interactionName, rest = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $4935fc4df735be0f$var$_excluded);
    var onMouseDownHandler = onMouseDown;
    var interactionContext = (0, $5FkrB.useContext)((0, $1d30d2a862a7a995$export$2e2bcd8739ae039));
    var handleClick = (0, $5FkrB.useCallback)(function(e) {
        interactionContext === null || interactionContext === void 0 || interactionContext.tracePress(interactionName, e.timeStamp);
        onClick === null || onClick === void 0 || onClick(e);
    }, [
        onClick,
        interactionContext,
        interactionName
    ]);
    if (!Component) return null;
    (0, $c6f574dac5b81c12$export$eb1decd851a5ae56)("@atlaskit/menu", 'cssFn', cssFn !== (0, $f2ed9a22761e3cb5$export$2e2bcd8739ae039), '' // TODO: Create DAC post when primitives/xcss are available as alternatives
    );
    return (0, $74Zh5.jsx)((0, $7e07e48730988c43$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        className: UNSAFE_className
    }, rest, {
        // eslint-disable-next-line @repo/internal/react/no-unsafe-overrides
        overrides: overrides,
        description: description,
        iconAfter: iconAfter,
        title: children,
        iconBefore: iconBefore,
        isSelected: isSelected,
        isDisabled: isDisabled,
        shouldTitleWrap: shouldTitleWrap,
        shouldDescriptionWrap: shouldDescriptionWrap,
        css: (0, $74Zh5.css)(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        cssFn({
            isDisabled: isDisabled,
            isSelected: isSelected
        })),
        testId: testId && "".concat(testId, "--primitive")
    }), function(_ref2) {
        var children = _ref2.children, className = _ref2.className;
        return (0, $74Zh5.jsx)(Component, (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
            "data-testid": testId
        }, rest, {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: className,
            ref: ref
        }, UNSAFE_isDraggable ? {} : {
            draggable: false,
            onDragStart: $4935fc4df735be0f$var$preventEvent
        }, {
            onMouseDown: isDisabled ? $4935fc4df735be0f$var$preventEvent : onMouseDownHandler,
            onClick: isDisabled ? $4935fc4df735be0f$var$preventEvent : (0, $dU8Y3.fg)('platform_button_item-add-ufo-metrics') ? handleClick : onClick,
            tabIndex: isDisabled ? -1 : undefined,
            "aria-disabled": isDisabled
        }), children);
    });
}));
var $4935fc4df735be0f$export$2e2bcd8739ae039 = $4935fc4df735be0f$var$CustomItem;



var $kqp0i = parcelRequire("kqp0i");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");

var $74Zh5 = parcelRequire("74Zh5");

var $5FkrB = parcelRequire("5FkrB");

var $5FkrB = parcelRequire("5FkrB");
var $9efa5b1edaff374d$export$2931e0ee690eee88 = /*#__PURE__*/ (0, $5FkrB.createContext)({});
/**
 * __RouterLinkProvider__
 *
 * Provides a configured router link component for use
 * within Design System components.
 */ var $9efa5b1edaff374d$var$RouterLinkProvider = function RouterLinkProvider(_ref) {
    var routerLinkComponent = _ref.routerLinkComponent, children = _ref.children;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement($9efa5b1edaff374d$export$2931e0ee690eee88.Provider, {
        value: {
            routerLinkComponent: routerLinkComponent
        }
    }, children);
};
var $9efa5b1edaff374d$export$2e2bcd8739ae039 = $9efa5b1edaff374d$var$RouterLinkProvider;


/**
 * __useRouterLink()__
 *
 * Hook: Returns app-configured router link component.
 *
 * A generic can be passed to define advanced link configuration:
 * ```
 * type MyRouterLinkConfig = {
 *  to: string;
 *  replace?: boolean;
 * }
 *
 * const RouterLink = useRouterLink<MyRouterLinkConfig>();
 * ```
 */ var $7d1898a7983f51c4$var$useRouterLink = function useRouterLink() {
    var _useContext = (0, $5FkrB.useContext)((0, $9efa5b1edaff374d$export$2931e0ee690eee88)), routerLinkComponent = _useContext.routerLinkComponent;
    if (routerLinkComponent) return routerLinkComponent;
};
var $7d1898a7983f51c4$export$2e2bcd8739ae039 = $7d1898a7983f51c4$var$useRouterLink;






var $dU8Y3 = parcelRequire("dU8Y3");

var $e9e55778a7afa09d$var$_excluded = [
    "children",
    "href",
    "cssFn",
    "description",
    "iconAfter",
    "iconBefore",
    "isDisabled",
    "isSelected",
    "onClick",
    "testId",
    "overrides",
    "onMouseDown",
    "shouldTitleWrap",
    "shouldDescriptionWrap",
    "className",
    "UNSAFE_shouldDisableRouterLink",
    "UNSAFE_isDraggable",
    "interactionName"
];
var $e9e55778a7afa09d$var$IS_EXTERNAL_LINK_REGEX = /^(?:(http|https):\/\/)/;
var $e9e55778a7afa09d$var$IS_NON_HTTP_BASED = /^(((mailto|tel|sms):)|(#))/;
var $e9e55778a7afa09d$var$preventEvent = function preventEvent(e) {
    e.preventDefault();
};
/**
 * __Link item__
 *
 * A link item is used to populate a menu with items that are links.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/menu/docs/link-item)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/menu)
 */ var $e9e55778a7afa09d$var$LinkItem = /*#__PURE__*/ (0, $5FkrB.memo)(/*#__PURE__*/ (0, $5FkrB.forwardRef)(// Type needed on props to extract types with extract react types.
function(props, ref) {
    var children = props.children, href = props.href, _props$cssFn = props.cssFn, cssFn = _props$cssFn === void 0 ? (0, $f2ed9a22761e3cb5$export$2e2bcd8739ae039) : _props$cssFn, description = props.description, iconAfter = props.iconAfter, iconBefore = props.iconBefore, _props$isDisabled = props.isDisabled, isDisabled = _props$isDisabled === void 0 ? false : _props$isDisabled, _props$isSelected = props.isSelected, isSelected = _props$isSelected === void 0 ? false : _props$isSelected, onClick = props.onClick, testId = props.testId, overrides = props.overrides, onMouseDown = props.onMouseDown, shouldTitleWrap = props.shouldTitleWrap, shouldDescriptionWrap = props.shouldDescriptionWrap, UNSAFE_className = props.className, UNSAFE_shouldDisableRouterLink = props.UNSAFE_shouldDisableRouterLink, UNSAFE_isDraggable = props.UNSAFE_isDraggable, interactionName = props.interactionName, rest = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(props, $e9e55778a7afa09d$var$_excluded);
    var onMouseDownHandler = onMouseDown;
    var RouterLink = (0, $7d1898a7983f51c4$export$2e2bcd8739ae039)();
    var interactionContext = (0, $5FkrB.useContext)((0, $1d30d2a862a7a995$export$2e2bcd8739ae039));
    var handleClick = (0, $5FkrB.useCallback)(function(e) {
        interactionContext === null || interactionContext === void 0 || interactionContext.tracePress(interactionName, e.timeStamp);
        onClick === null || onClick === void 0 || onClick(e);
    }, [
        onClick,
        interactionContext,
        interactionName
    ]);
    if (!children) return null;
    var isExternal = typeof href === 'string' && $e9e55778a7afa09d$var$IS_EXTERNAL_LINK_REGEX.test(href);
    var isNonHttpBased = typeof href === 'string' && $e9e55778a7afa09d$var$IS_NON_HTTP_BASED.test(href);
    var isEmptyHref = href == null || href === '';
    /**
   * Renders a router link if:
   *
   * - a link component is set in the app provider
   * - it's not an external link (starting with `http://` or `https://`)
   * - it's not a non-HTTP-based link (e.g. emails, phone numbers, hash links etc.)
   * - it doesn't have an empty href (e.g. href="" or href={undefined})
   */ var isRouterLink = !UNSAFE_shouldDisableRouterLink && RouterLink && !isExternal && !isNonHttpBased && !isEmptyHref;
    var Component = isRouterLink ? RouterLink : 'a';
    (0, $c6f574dac5b81c12$export$eb1decd851a5ae56)("@atlaskit/menu", 'cssFn', cssFn !== (0, $f2ed9a22761e3cb5$export$2e2bcd8739ae039), '' // TODO: Create DAC post when primitives/xcss are available as alternatives
    );
    return (0, $74Zh5.jsx)((0, $7e07e48730988c43$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, rest, {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: UNSAFE_className,
        overrides: overrides,
        iconBefore: iconBefore,
        iconAfter: iconAfter,
        isSelected: isSelected,
        isDisabled: isDisabled,
        description: description,
        shouldTitleWrap: shouldTitleWrap,
        shouldDescriptionWrap: shouldDescriptionWrap,
        css: // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
        cssFn({
            isSelected: isSelected,
            isDisabled: isDisabled
        }),
        title: children,
        testId: testId && "".concat(testId, "--primitive")
    }), function(_ref) {
        var children = _ref.children, className = _ref.className;
        return (0, $74Zh5.jsx)(Component, (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
            "data-testid": testId,
            "data-is-router-link": testId ? isRouterLink ? 'true' : 'false' : undefined,
            "data-vc": "link-item"
        }, rest, {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: className,
            href: isDisabled ? undefined : href
        }, UNSAFE_isDraggable ? {} : {
            draggable: false,
            onDragStart: $e9e55778a7afa09d$var$preventEvent
        }, {
            onMouseDown: isDisabled ? $e9e55778a7afa09d$var$preventEvent : onMouseDownHandler,
            onClick: isDisabled ? $e9e55778a7afa09d$var$preventEvent : (0, $dU8Y3.fg)('platform_button_item-add-ufo-metrics') ? handleClick : onClick,
            "aria-current": isSelected ? 'page' : undefined,
            "aria-disabled": isDisabled,
            ref: ref
        }), children);
    });
}));
var $e9e55778a7afa09d$export$2e2bcd8739ae039 = $e9e55778a7afa09d$var$LinkItem;



var $dU8Y3 = parcelRequire("dU8Y3");

var $896b4f3af893fddb$var$_excluded = [
    "children",
    "component",
    "description",
    "elemAfter",
    "elemBefore",
    "href",
    "isDisabled",
    "isSelected",
    "onClick",
    "rel",
    "shouldDescriptionWrap",
    "shouldTitleWrap",
    "target",
    "testId",
    "UNSAFE_shouldDisableRouterLink",
    "returnFocusRef",
    "interactionName"
];
/**
 * __Dropdown menu item__
 *
 * A dropdown item populates the dropdown menu with items. Every item should be inside a dropdown item group.
 *
 * - [Examples](https://atlassian.design/components/dropdown-menu/dropdown-item/examples)
 * - [Code](https://atlassian.design/components/dropdown-menu/dropdown-item/code)
 * - [Usage](https://atlassian.design/components/dropdown-menu/dropdown-item/usage)
 */ var $896b4f3af893fddb$var$DropdownMenuItem = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function(_ref, ref) {
    var children = _ref.children, component = _ref.component, description = _ref.description, elemAfter = _ref.elemAfter, elemBefore = _ref.elemBefore, href = _ref.href, isDisabled = _ref.isDisabled, isSelected = _ref.isSelected, onClick = _ref.onClick, rel = _ref.rel, _ref$shouldDescriptio = _ref.shouldDescriptionWrap, shouldDescriptionWrap = _ref$shouldDescriptio === void 0 ? true : _ref$shouldDescriptio, _ref$shouldTitleWrap = _ref.shouldTitleWrap, shouldTitleWrap = _ref$shouldTitleWrap === void 0 ? true : _ref$shouldTitleWrap, target = _ref.target, testId = _ref.testId, UNSAFE_shouldDisableRouterLink = _ref.UNSAFE_shouldDisableRouterLink, returnFocusRef = _ref.returnFocusRef, interactionName = _ref.interactionName, rest = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $896b4f3af893fddb$var$_excluded);
    // if the dropdown item has aria-haspopup, we won't register with focus manager
    // since it is a nested trigger, we have registered inside dropdown-menu
    var itemRef = (0, $342103062545c958$export$2e2bcd8739ae039)(!!rest['aria-haspopup']);
    var handleItemClick = (0, $5FkrB.useCallback)(function(event) {
        if (returnFocusRef !== null && returnFocusRef !== void 0 && returnFocusRef.current) returnFocusRef.current.focus();
        if (onClick) onClick(event);
    }, [
        onClick,
        returnFocusRef
    ]);
    if (component) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $4935fc4df735be0f$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        component: component,
        description: description,
        iconAfter: elemAfter,
        iconBefore: elemBefore,
        isDisabled: isDisabled,
        isSelected: isSelected,
        onClick: handleItemClick,
        ref: (0, $0d2a37110e22a1c9$export$2e2bcd8739ae039)([
            ref,
            itemRef
        ]),
        shouldDescriptionWrap: shouldDescriptionWrap,
        shouldTitleWrap: shouldTitleWrap,
        testId: testId,
        href: href,
        target: target,
        rel: rel
    }, (0, $dU8Y3.fg)('platform_button_item-add-ufo-metrics') && {
        interactionName: interactionName
    }, rest), children);
    else if (href) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $e9e55778a7afa09d$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        description: description,
        href: href,
        iconAfter: elemAfter,
        iconBefore: elemBefore,
        isDisabled: isDisabled,
        isSelected: isSelected,
        onClick: handleItemClick,
        ref: (0, $0d2a37110e22a1c9$export$2e2bcd8739ae039)([
            ref,
            itemRef
        ]),
        rel: rel,
        role: "menuitem",
        shouldDescriptionWrap: shouldDescriptionWrap,
        shouldTitleWrap: shouldTitleWrap,
        target: target,
        testId: testId,
        UNSAFE_shouldDisableRouterLink: UNSAFE_shouldDisableRouterLink
    }, (0, $dU8Y3.fg)('platform_button_item-add-ufo-metrics') && {
        interactionName: interactionName
    }, rest), children);
    else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $deae49ab7e32e8cd$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        description: description,
        iconAfter: elemAfter,
        iconBefore: elemBefore,
        isDisabled: isDisabled,
        isSelected: isSelected,
        onClick: handleItemClick,
        ref: (0, $0d2a37110e22a1c9$export$2e2bcd8739ae039)([
            ref,
            itemRef
        ]),
        role: "menuitem",
        shouldDescriptionWrap: shouldDescriptionWrap,
        shouldTitleWrap: shouldTitleWrap,
        testId: testId,
        target: target,
        rel: rel
    }, (0, $dU8Y3.fg)('platform_button_item-add-ufo-metrics') && {
        interactionName: interactionName
    }, rest), children);
});
var $896b4f3af893fddb$export$2e2bcd8739ae039 = $896b4f3af893fddb$var$DropdownMenuItem;


var $kqp0i = parcelRequire("kqp0i");

var $iYJcE = parcelRequire("iYJcE");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");




var $dU8Y3 = parcelRequire("dU8Y3");

var $5FkrB = parcelRequire("5FkrB");
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5FkrB = parcelRequire("5FkrB");

var $74Zh5 = parcelRequire("74Zh5");

var $cw16F = parcelRequire("cw16F");

var $1b631 = parcelRequire("1b631");
// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
var $1b6d57c283ee4ca6$var$svgStyles = (0, $74Zh5.css)((0, $1b631.commonSVGStyles));
/**
 * __SVG__
 *
 * An icon is used as a visual representation of common actions and commands to provide context.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-svgs)
 */ var $1b6d57c283ee4ca6$var$SVG = /*#__PURE__*/ (0, $5FkrB.memo)(function SVG(_ref) {
    var _ref$size = _ref.size, size = _ref$size === void 0 ? 'medium' : _ref$size, label = _ref.label, _ref$primaryColor = _ref.primaryColor, primaryColor = _ref$primaryColor === void 0 ? 'currentColor' : _ref$primaryColor, secondaryColor = _ref.secondaryColor, testId = _ref.testId, children = _ref.children;
    return (0, $74Zh5.jsx)("svg", {
        viewBox: "0 0 24 24",
        style: {
            color: primaryColor,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            fill: secondaryColor || (0, $cw16F.getBackground)()
        },
        css: [
            $1b6d57c283ee4ca6$var$svgStyles,
            (0, $1b631.sizeStyleMap)[size]
        ],
        "data-testid": testId,
        "aria-label": label || undefined,
        role: label ? 'img' : 'presentation'
    }, children);
});
var $1b6d57c283ee4ca6$export$2e2bcd8739ae039 = $1b6d57c283ee4ca6$var$SVG;



var $dU8Y3 = parcelRequire("dU8Y3");

/**
 * __Checkbox icon__
 *
 * Used to visually represent the selected state in DropdownItemCheckbox
 *
 * @internal
 */ var $be6adeddf968289c$var$CheckboxIcon = function CheckboxIcon(_ref) {
    var checked = _ref.checked;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $1b6d57c283ee4ca6$export$2e2bcd8739ae039), {
        label: "",
        size: "medium",
        primaryColor: checked ? "var(--ds-background-selected-bold, ".concat((0, $d879fc455f6e75a0$export$b3de0ae08da2ce64), ")") : "var(--ds-background-input, ".concat((0, $d879fc455f6e75a0$export$e655ef011c4aa1a2), ")"),
        secondaryColor: checked ? "var(--ds-icon-inverse, ".concat((0, $d879fc455f6e75a0$export$e655ef011c4aa1a2), ")") : 'transparent'
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("g", {
        fillRule: "evenodd"
    }, // eslint-disable-next-line @atlaskit/platform/no-preconditioning, @atlaskit/platform/ensure-feature-flag-prefix
    (0, $dU8Y3.fg)('platform-visual-refresh-icons') && (0, $dU8Y3.fg)('platform-icon-control-migration') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("rect", {
        stroke: checked ? "var(--ds-border-selected, ".concat((0, $d879fc455f6e75a0$export$b3de0ae08da2ce64), ")") : "var(--ds-border-input, ".concat((0, $d879fc455f6e75a0$export$d6447c357493214f), ")"),
        x: "5.5",
        y: "5.5",
        width: "13",
        height: "13",
        rx: "1.5",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M16.3262 9.48011L15.1738 8.51984L10.75 13.8284L8.82616 11.5198L7.67383 12.4801L10.1738 15.4801C10.3163 15.6511 10.5274 15.75 10.75 15.75C10.9726 15.75 11.1837 15.6511 11.3262 15.4801L16.3262 9.48011Z",
        fill: "inherit"
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("rect", {
        fill: "currentColor",
        x: "6",
        y: "6",
        width: "12",
        height: "12",
        rx: "2",
        stroke: checked ? "var(--ds-border-selected, ".concat((0, $d879fc455f6e75a0$export$b3de0ae08da2ce64), ")") : "var(--ds-border-input, ".concat((0, $d879fc455f6e75a0$export$d6447c357493214f), ")"),
        strokeWidth: 1
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("path", {
        d: "M9.707 11.293a1 1 0 10-1.414 1.414l2 2a1 1 0 001.414 0l4-4a1 1 0 10-1.414-1.414L11 12.586l-1.293-1.293z",
        fill: "inherit"
    }))));
};
var $be6adeddf968289c$export$2e2bcd8739ae039 = $be6adeddf968289c$var$CheckboxIcon;



var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");

var $5FkrB = parcelRequire("5FkrB");
var $0902122f60812d1d$export$baf37c4be89255b8 = /*#__PURE__*/ (0, $5FkrB.createContext)('');



/**
 * Custom hook to handle checkbox state for dropdown menu.
 * It works in tandem with the selection store context when the
 * component is uncontrolled.
 */ var $55dd3ea434b7a8af$var$useCheckboxState = function useCheckboxState(_ref) {
    var isSelected = _ref.isSelected, id = _ref.id, defaultSelected = _ref.defaultSelected;
    var _useContext = (0, $5FkrB.useContext)((0, $6c8d7d354dcb5a30$export$756f795847463ebd)), setItemState = _useContext.setItemState, getItemState = _useContext.getItemState;
    var groupId = (0, $5FkrB.useContext)((0, $0902122f60812d1d$export$baf37c4be89255b8));
    var persistedIsSelected = getItemState(groupId, id);
    var _useState = (0, $5FkrB.useState)(// Initial state is set depending on value being defined or not.
    // This state is only utilised if the checkbox is uncontrolled.
    function() {
        return persistedIsSelected !== undefined ? persistedIsSelected : defaultSelected || false;
    }), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), localIsSelected = _useState2[0], setLocalIsSelected = _useState2[1];
    var setLocalState = (0, $5FkrB.useCallback)(function(newValue) {
        var nextValue = newValue(persistedIsSelected);
        setLocalIsSelected(nextValue);
        setItemState(groupId, id, nextValue);
    }, [
        setItemState,
        persistedIsSelected,
        groupId,
        id
    ]);
    // Checkbox is controlled - do nothing!
    if (typeof isSelected === 'boolean') return [
        isSelected,
        function() {
            return false;
        }
    ];
    // Checkbox is going through its first render pass!
    if (persistedIsSelected === undefined) // Set the item so we have this state to access next time the checkbox renders (either by mounting or re-rendering!)
    setItemState(groupId, id, defaultSelected || false);
    // Return the value and setter!
    // Remember this flow is only returned if the checkbox is uncontrolled.
    return [
        localIsSelected,
        setLocalState
    ];
};
var $55dd3ea434b7a8af$export$2e2bcd8739ae039 = $55dd3ea434b7a8af$var$useCheckboxState;




var $3ZMUU = parcelRequire("3ZMUU");
var $9717609675842cd9$var$_excluded = [
    "children",
    "defaultSelected",
    "description",
    "id",
    "isDisabled",
    "isSelected",
    "onClick",
    "shouldDescriptionWrap",
    "shouldTitleWrap",
    "testId",
    "interactionName"
];
/**
 * __Dropdown item checkbox__
 *
 * A dropdown item checkbox creates groups that have multiple selections.
 *
 * - [Examples](https://atlassian.design/components/dropdown-menu/dropdown-item-checkbox/examples)
 * - [Code](https://atlassian.design/components/dropdown-menu/dropdown-item-checkbox/code)
 * - [Usage](https://atlassian.design/components/dropdown-menu/dropdown-item-checkbox/usage)
 */ var $9717609675842cd9$var$DropdownItemCheckbox = function DropdownItemCheckbox(_ref) {
    var children = _ref.children, defaultSelected = _ref.defaultSelected, description = _ref.description, id = _ref.id, isDisabled = _ref.isDisabled, isSelected = _ref.isSelected, _ref$onClick = _ref.onClick, providedOnClick = _ref$onClick === void 0 ? (0, $3a341012e037de4f$export$2e2bcd8739ae039) : _ref$onClick, _ref$shouldDescriptio = _ref.shouldDescriptionWrap, shouldDescriptionWrap = _ref$shouldDescriptio === void 0 ? true : _ref$shouldDescriptio, _ref$shouldTitleWrap = _ref.shouldTitleWrap, shouldTitleWrap = _ref$shouldTitleWrap === void 0 ? true : _ref$shouldTitleWrap, testId = _ref.testId, interactionName = _ref.interactionName, rest = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $9717609675842cd9$var$_excluded);
    typeof $3ZMUU;
    var _useCheckboxState = (0, $55dd3ea434b7a8af$export$2e2bcd8739ae039)({
        id: id,
        isSelected: isSelected,
        defaultSelected: defaultSelected
    }), _useCheckboxState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useCheckboxState, 2), selected = _useCheckboxState2[0], setSelected = _useCheckboxState2[1];
    var onClickHandler = (0, $5FkrB.useCallback)(function(event) {
        setSelected(function(selected) {
            return !selected;
        });
        providedOnClick(event);
    }, [
        providedOnClick,
        setSelected
    ]);
    var itemRef = (0, $342103062545c958$export$2e2bcd8739ae039)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $029784b0740265a3$export$9ca534b70725964d).Provider, {
        value: "none"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $deae49ab7e32e8cd$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        "aria-checked": selected,
        description: description,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $be6adeddf968289c$export$2e2bcd8739ae039), {
            checked: selected
        }),
        id: id,
        isDisabled: isDisabled,
        isSelected: selected,
        onClick: onClickHandler,
        ref: itemRef,
        role: "menuitemcheckbox",
        shouldDescriptionWrap: shouldDescriptionWrap,
        shouldTitleWrap: shouldTitleWrap,
        testId: testId
    }, (0, $dU8Y3.fg)('platform_button_item-add-ufo-metrics') && {
        interactionName: interactionName
    }, rest), children));
};
var $9717609675842cd9$export$2e2bcd8739ae039 = $9717609675842cd9$var$DropdownItemCheckbox;


var $kqp0i = parcelRequire("kqp0i");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");


var $kqp0i = parcelRequire("kqp0i");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");

var $74Zh5 = parcelRequire("74Zh5");



var $kqp0i = parcelRequire("kqp0i");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");

var $74Zh5 = parcelRequire("74Zh5");



var $2dbde3d3788ab954$var$_excluded = [
    "children",
    "testId",
    "headingLevel",
    "id",
    "cssFn",
    "className"
];
var $2dbde3d3788ab954$var$headingStyles = (0, $74Zh5.css)({
    color: "var(--ds-text-subtle, ".concat((0, $1d2890bfdc85c1d1$export$e2ef2124cf4024b1), ")"),
    font: "var(--ds-font-heading-xxsmall, normal 600 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    paddingBlock: "var(--ds-space-0, 0px)",
    paddingInline: "var(--ds-space-200, 16px)"
});
/**
 * __Heading item__
 *
 * A heading item is used to describe sibling menu items.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/menu/docs/heading-item)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/menu)
 */ var $2dbde3d3788ab954$var$HeadingItem = /*#__PURE__*/ (0, $5FkrB.memo)(function(_ref) {
    var children = _ref.children, testId = _ref.testId, _ref$headingLevel = _ref.headingLevel, headingLevel = _ref$headingLevel === void 0 ? 2 : _ref$headingLevel, id = _ref.id, _ref$cssFn = _ref.cssFn, cssFn = _ref$cssFn === void 0 ? (0, $f2ed9a22761e3cb5$export$2e2bcd8739ae039) : _ref$cssFn, UNSAFE_className = _ref.className, rest = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $2dbde3d3788ab954$var$_excluded);
    (0, $c6f574dac5b81c12$export$eb1decd851a5ae56)("@atlaskit/menu", 'cssFn', cssFn !== (0, $f2ed9a22761e3cb5$export$2e2bcd8739ae039), '' // TODO: Create DAC post when primitives/xcss are available as alternatives
    );
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    var UNSAFE_overrides = (0, $74Zh5.css)(cssFn(undefined));
    return (0, $74Zh5.jsx)("div", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        css: [
            $2dbde3d3788ab954$var$headingStyles,
            // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
            UNSAFE_overrides
        ],
        role: "heading",
        "aria-level": headingLevel,
        "data-testid": testId,
        "data-ds--menu--heading-item": true,
        id: id,
        className: UNSAFE_className
    }, rest), children);
});
var $2dbde3d3788ab954$export$2e2bcd8739ae039 = $2dbde3d3788ab954$var$HeadingItem;


var $bb6d010069fda365$var$_excluded = [
    "children",
    "overrides",
    "title",
    "titleId",
    "testId",
    "isScrollable",
    "hasSeparator",
    "id",
    "isList",
    "className"
];
var $bb6d010069fda365$var$gridSize = 8;
var $bb6d010069fda365$var$itemHeadingTopMargin = $bb6d010069fda365$var$gridSize * 2.5;
var $bb6d010069fda365$var$itemHeadingBottomMargin = $bb6d010069fda365$var$gridSize * 0.75;
// Skeleton content is slightly shorter than the real content.
// Because of that we slightly increase the top margin to offset this so the
// containing size both real and skeleton always equal approx 30px.
var $bb6d010069fda365$var$itemHeadingContentHeight = 16; // Originally headingSizes.h100.lineHeight from '@atlaskit/theme/typography'
var $bb6d010069fda365$var$skeletonHeadingHeight = $bb6d010069fda365$var$gridSize;
var $bb6d010069fda365$var$skeletonHeadingMarginOffset = 3;
var $bb6d010069fda365$var$skeletonHeadingTopMargin = $bb6d010069fda365$var$itemHeadingTopMargin + ($bb6d010069fda365$var$itemHeadingContentHeight - $bb6d010069fda365$var$skeletonHeadingHeight) - $bb6d010069fda365$var$skeletonHeadingMarginOffset;
// We want to move the entire body up by 3px without affecting the height of the skeleton container.
var $bb6d010069fda365$var$skeletonHeadingBottomMargin = $bb6d010069fda365$var$itemHeadingBottomMargin + $bb6d010069fda365$var$skeletonHeadingMarginOffset;
var $bb6d010069fda365$var$sectionPaddingTopBottom = $bb6d010069fda365$var$gridSize * 0.75;
var $bb6d010069fda365$var$VAR_SEPARATOR_COLOR = '--ds-menu-seperator-color';
var $bb6d010069fda365$var$sectionStyles = (0, $74Zh5.css)({
    '&::before, &::after': {
        display: 'block',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        height: $bb6d010069fda365$var$sectionPaddingTopBottom,
        content: '""'
    },
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& [data-ds--menu--heading-item]': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        marginBlockEnd: $bb6d010069fda365$var$itemHeadingBottomMargin,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        marginBlockStart: $bb6d010069fda365$var$itemHeadingTopMargin,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '&:first-of-type': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            marginBlockStart: $bb6d010069fda365$var$itemHeadingTopMargin - $bb6d010069fda365$var$sectionPaddingTopBottom
        }
    },
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& [data-ds--menu--skeleton-heading-item]': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        marginBlockEnd: $bb6d010069fda365$var$skeletonHeadingBottomMargin,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        marginBlockStart: $bb6d010069fda365$var$skeletonHeadingTopMargin,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '&:first-of-type': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            marginBlockStart: $bb6d010069fda365$var$skeletonHeadingTopMargin - $bb6d010069fda365$var$sectionPaddingTopBottom
        }
    },
    '&:focus': {
        // NOTE: Firefox allows elements that have "overflow: auto" to gain focus (as if it had tab-index="0")
        // We have made a deliberate choice to leave this behaviour as is.
        // This makes the outline go inside by 1px so it can actually be displayed
        // else it gets cut off from the overflow: scroll from the parent menu group.
        outlineOffset: -1
    }
});
var $bb6d010069fda365$var$scrollableStyles = (0, $74Zh5.css)({
    flexShrink: 1,
    overflow: 'auto'
});
var $bb6d010069fda365$var$unscrollableStyles = (0, $74Zh5.css)({
    flexShrink: 0
});
var $bb6d010069fda365$var$thinSeparatorStyles = (0, $74Zh5.css)({
    borderBlockStart: "1px solid var(".concat($bb6d010069fda365$var$VAR_SEPARATOR_COLOR, ", ", "var(--ds-border, ".concat((0, $1d2890bfdc85c1d1$export$920c0d5c49070351), ")"), ")")
});
var $bb6d010069fda365$var$noSeparatorStyles = (0, $74Zh5.css)({
    // this is to ensure that adjacent sections without separators don't get additional margins.
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '[data-section] + &': {
        marginBlockStart: -6
    }
});
/**
 * __Section__
 *
 * A section includes related actions or items in a menu.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/menu/docs/section)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/menu)
 */ var $bb6d010069fda365$var$Section = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function(_ref, ref) {
    var children = _ref.children, overrides = _ref.overrides, title = _ref.title, titleId = _ref.titleId, testId = _ref.testId, isScrollable = _ref.isScrollable, hasSeparator = _ref.hasSeparator, id = _ref.id, _ref$isList = _ref.isList, isList = _ref$isList === void 0 ? false : _ref$isList, UNSAFE_className = _ref.className, rest = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $bb6d010069fda365$var$_excluded);
    (0, $c6f574dac5b81c12$export$eb1decd851a5ae56)("@atlaskit/menu", 'overrides', overrides !== undefined, '' // TODO: Create DAC post when primitives/xcss are available as alternatives
    );
    var UNSAFE_headingOverrides = overrides && overrides.HeadingItem && overrides.HeadingItem.cssFn;
    var content = isList ? (0, $74Zh5.jsx)("ul", {
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            margin: 0,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            padding: 0
        }
    }, (0, $5FkrB.Children).map((0, $5FkrB.Children).toArray(children), function(child, index) {
        return (0, $74Zh5.jsx)("li", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            style: {
                listStyleType: 'none',
                margin: 0,
                padding: 0
            },
            key: index
        }, child);
    })) : children;
    var childrenMarkup = title !== undefined ? (0, $74Zh5.jsx)((0, $5FkrB.Fragment), null, (0, $74Zh5.jsx)((0, $2dbde3d3788ab954$export$2e2bcd8739ae039), {
        cssFn: UNSAFE_headingOverrides,
        testId: testId && "".concat(testId, "--heading"),
        "aria-hidden": true
    }, title), content) : (0, $74Zh5.jsx)((0, $5FkrB.Fragment), null, content);
    return (0, $74Zh5.jsx)("div", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, rest, {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: UNSAFE_className,
        id: id,
        css: [
            $bb6d010069fda365$var$sectionStyles,
            isScrollable ? $bb6d010069fda365$var$scrollableStyles : $bb6d010069fda365$var$unscrollableStyles,
            hasSeparator ? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            $bb6d010069fda365$var$thinSeparatorStyles : $bb6d010069fda365$var$noSeparatorStyles
        ],
        "aria-label": title,
        "aria-labelledby": titleId,
        "data-testid": testId,
        role: "group",
        "data-section": true,
        ref: ref
    }), childrenMarkup);
});
var $bb6d010069fda365$export$2e2bcd8739ae039 = $bb6d010069fda365$var$Section;



var $5FkrB = parcelRequire("5FkrB");

var $23428f2f9e2005b2$var$headingStyles = (0, $a8477e78427cc4b7$export$f6c783d06584602c)({
    color: 'color.text.subtle',
    font: 'font.heading.xxsmall',
    paddingBlock: 'space.0',
    paddingInline: 'space.200'
});
/**
 * __Group title__
 *
 * Used to visually represent the title for DropdownMenu groups
 *
 * @internal
 */ var $23428f2f9e2005b2$var$GroupTitle = function GroupTitle(_ref) {
    var id = _ref.id, title = _ref.title;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $d007f17589e0f9b9$export$2e2bcd8739ae039), {
        "data-ds--menu--heading-item": true,
        role: "menuitem",
        id: id,
        "aria-hidden": "true",
        xcss: $23428f2f9e2005b2$var$headingStyles
    }, title);
};
var $23428f2f9e2005b2$export$2e2bcd8739ae039 = $23428f2f9e2005b2$var$GroupTitle;



var $4efa9b4942c769d7$var$_excluded = [
    "children",
    "hasSeparator",
    "id",
    "isList",
    "isScrollable",
    "overrides",
    "testId",
    "title"
];
/**
 * __Dropdown item checkbox group__
 *
 * A wrapping element for dropdown menu checkbox items.
 *
 */ var $4efa9b4942c769d7$var$DropdownItemCheckboxGroup = function DropdownItemCheckboxGroup(_ref) {
    var children = _ref.children, hasSeparator = _ref.hasSeparator, id = _ref.id, isList = _ref.isList, isScrollable = _ref.isScrollable, overrides = _ref.overrides, testId = _ref.testId, title = _ref.title, rest = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $4efa9b4942c769d7$var$_excluded);
    var uid = (0, $24526c38f36cc756$export$f680877a34711e37)();
    var titleId = "dropdown-menu-item-checkbox-group-title-".concat(uid);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $0902122f60812d1d$export$baf37c4be89255b8).Provider, {
        value: id
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $bb6d010069fda365$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        hasSeparator: hasSeparator,
        id: id,
        isList: isList,
        isScrollable: isScrollable,
        overrides: overrides,
        testId: testId,
        titleId: title ? titleId : undefined
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $23428f2f9e2005b2$export$2e2bcd8739ae039), {
        id: titleId,
        title: title
    }), children));
};
var $4efa9b4942c769d7$export$2e2bcd8739ae039 = $4efa9b4942c769d7$var$DropdownItemCheckboxGroup;


var $kqp0i = parcelRequire("kqp0i");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");



var $c45aef576c3a1b33$var$_excluded = [
    "children",
    "id",
    "isList",
    "isScrollable",
    "title",
    "testId",
    "hasSeparator",
    "overrides"
];
/**
 * __Dropdown item checkbox group__
 *
 * A wrapping element for dropdown menu items.
 *
 */ var $c45aef576c3a1b33$var$DropdownMenuItemGroup = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function(_ref, ref) {
    var children = _ref.children, id = _ref.id, isList = _ref.isList, isScrollable = _ref.isScrollable, title = _ref.title, testId = _ref.testId, hasSeparator = _ref.hasSeparator, overrides = _ref.overrides, rest = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $c45aef576c3a1b33$var$_excluded);
    var uid = (0, $24526c38f36cc756$export$f680877a34711e37)();
    var titleId = "dropdown-menu-item-group-title-".concat(uid);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $bb6d010069fda365$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        id: id,
        ref: ref,
        isList: isList,
        isScrollable: isScrollable,
        hasSeparator: hasSeparator,
        testId: testId,
        titleId: title ? titleId : undefined,
        overrides: overrides
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $23428f2f9e2005b2$export$2e2bcd8739ae039), {
        id: titleId,
        title: title
    }), children);
});
var $c45aef576c3a1b33$export$2e2bcd8739ae039 = $c45aef576c3a1b33$var$DropdownMenuItemGroup;


var $kqp0i = parcelRequire("kqp0i");

var $iYJcE = parcelRequire("iYJcE");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");




var $dU8Y3 = parcelRequire("dU8Y3");

var $5FkrB = parcelRequire("5FkrB");


var $dU8Y3 = parcelRequire("dU8Y3");

/**
 * __Radio icon__
 *
 * Used to visually represent the selected state in DropdownItemRadio
 *
 * @internal
 */ var $6f640f39f2f07b66$var$RadioIcon = function RadioIcon(_ref) {
    var checked = _ref.checked;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $1b6d57c283ee4ca6$export$2e2bcd8739ae039), {
        label: "",
        size: "medium",
        primaryColor: checked ? "var(--ds-background-selected-bold, ".concat((0, $d879fc455f6e75a0$export$b3de0ae08da2ce64), ")") : "var(--ds-background-input, ".concat((0, $d879fc455f6e75a0$export$e655ef011c4aa1a2), ")"),
        secondaryColor: checked ? "var(--ds-icon-inverse, ".concat((0, $d879fc455f6e75a0$export$e655ef011c4aa1a2), ")") : 'transparent'
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("g", {
        fillRule: "evenodd"
    }, // eslint-disable-next-line @atlaskit/platform/no-preconditioning, @atlaskit/platform/ensure-feature-flag-prefix
    (0, $dU8Y3.fg)('platform-visual-refresh-icons') && (0, $dU8Y3.fg)('platform-icon-control-migration') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("circle", {
        cx: "12",
        cy: "12",
        r: "7.5",
        fill: "currentColor",
        stroke: checked ? "var(--ds-border-selected, ".concat((0, $d879fc455f6e75a0$export$b3de0ae08da2ce64), ")") : "var(--ds-border-input, ".concat((0, $d879fc455f6e75a0$export$d6447c357493214f), ")"),
        strokeWidth: "1"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("circle", {
        cx: "12",
        cy: "12",
        r: "3",
        fill: "inherit"
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("circle", {
        fill: "currentColor",
        cx: "12",
        cy: "12",
        r: "6",
        stroke: checked ? "var(--ds-border-selected, ".concat((0, $d879fc455f6e75a0$export$b3de0ae08da2ce64), ")") : "var(--ds-border-input, ".concat((0, $d879fc455f6e75a0$export$d6447c357493214f), ")"),
        strokeWidth: 1
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("circle", {
        fill: "inherit",
        cx: "12",
        cy: "12",
        r: "2"
    }))));
};
var $6f640f39f2f07b66$export$2e2bcd8739ae039 = $6f640f39f2f07b66$var$RadioIcon;



var $25nEq = parcelRequire("25nEq");

var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");

var $kqp0i = parcelRequire("kqp0i");

var $25nEq = parcelRequire("25nEq");

var $iYJcE = parcelRequire("iYJcE");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");






var $25nEq = parcelRequire("25nEq");
function $db8e4a3eb620c41f$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $db8e4a3eb620c41f$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $db8e4a3eb620c41f$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $db8e4a3eb620c41f$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $db8e4a3eb620c41f$var$resetOptionsInGroup = function resetOptionsInGroup(group) {
    return Object.keys(group || {}).reduce(function(accumulator, current) {
        return $db8e4a3eb620c41f$var$_objectSpread($db8e4a3eb620c41f$var$_objectSpread({}, accumulator), {}, (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, current, typeof group[current] === 'undefined' ? undefined : false));
    }, {});
};
var $db8e4a3eb620c41f$export$2e2bcd8739ae039 = $db8e4a3eb620c41f$var$resetOptionsInGroup;


var $d7f1a7874207c75a$var$_excluded = [
    "children",
    "hasSeparator",
    "id",
    "isList",
    "isScrollable",
    "overrides",
    "testId",
    "title"
];
function $d7f1a7874207c75a$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $d7f1a7874207c75a$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $d7f1a7874207c75a$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $d7f1a7874207c75a$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $d7f1a7874207c75a$export$a79eda4ff50e30b6 = /*#__PURE__*/ (0, $5FkrB.createContext)({
    id: '',
    radioGroupState: {},
    selectRadioItem: (0, $3a341012e037de4f$export$2e2bcd8739ae039)
});
/**
 * __Dropdown item radio group__
 *  Store which manages the selection state for each DropdownItemRadio
 *  across mount and unmounts.
 *
 */ var $d7f1a7874207c75a$var$DropdownItemRadioGroup = function DropdownItemRadioGroup(_ref) {
    var children = _ref.children, hasSeparator = _ref.hasSeparator, id = _ref.id, isList = _ref.isList, isScrollable = _ref.isScrollable, overrides = _ref.overrides, testId = _ref.testId, title = _ref.title, rest = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $d7f1a7874207c75a$var$_excluded);
    var _useContext = (0, $5FkrB.useContext)((0, $6c8d7d354dcb5a30$export$756f795847463ebd)), setGroupState = _useContext.setGroupState, getGroupState = _useContext.getGroupState;
    var uid = (0, $24526c38f36cc756$export$f680877a34711e37)();
    var titleId = "dropdown-menu-item-radio-group-title-".concat(uid);
    /**
   *  - initially `radioGroupState` is from selection store, so it's safe to update without re-rendering
   *  - we flush a render by updating this local radio group state
   */ var _useState = (0, $5FkrB.useState)(function() {
        return getGroupState(id);
    }), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), radioGroupState = _useState2[0], setRadioGroupState = _useState2[1];
    var selectRadioItem = function selectRadioItem(childId, value) {
        var newValue = $d7f1a7874207c75a$var$_objectSpread($d7f1a7874207c75a$var$_objectSpread({}, (0, $db8e4a3eb620c41f$export$2e2bcd8739ae039)(getGroupState(id))), {}, (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, childId, value));
        setRadioGroupState(newValue);
        setGroupState(id, newValue);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement($d7f1a7874207c75a$export$a79eda4ff50e30b6.Provider, {
        value: {
            id: id,
            radioGroupState: radioGroupState,
            selectRadioItem: selectRadioItem
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $bb6d010069fda365$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        hasSeparator: hasSeparator,
        id: id,
        isList: isList,
        isScrollable: isScrollable,
        overrides: overrides,
        testId: testId,
        titleId: title ? titleId : undefined
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $23428f2f9e2005b2$export$2e2bcd8739ae039), {
        id: titleId,
        title: title
    }), children));
};
var $d7f1a7874207c75a$export$2e2bcd8739ae039 = $d7f1a7874207c75a$var$DropdownItemRadioGroup;




function $2bb515b7d71ee3c9$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $2bb515b7d71ee3c9$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $2bb515b7d71ee3c9$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $2bb515b7d71ee3c9$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $2bb515b7d71ee3c9$var$useRadioState(_ref) {
    var id = _ref.id, isSelected = _ref.isSelected, defaultSelected = _ref.defaultSelected;
    var _useContext = (0, $5FkrB.useContext)((0, $6c8d7d354dcb5a30$export$756f795847463ebd)), setGroupState = _useContext.setGroupState, getGroupState = _useContext.getGroupState;
    var _useContext2 = (0, $5FkrB.useContext)((0, $d7f1a7874207c75a$export$a79eda4ff50e30b6)), group = _useContext2.id, radioGroupState = _useContext2.radioGroupState, selectRadioItem = _useContext2.selectRadioItem;
    var persistedIsSelected = radioGroupState[id];
    var _useState = (0, $5FkrB.useState)(function() {
        return persistedIsSelected !== undefined ? persistedIsSelected : defaultSelected || false;
    }), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), localIsSelected = _useState2[0], setLocalIsSelected = _useState2[1];
    var setLocalState = (0, $5FkrB.useCallback)(function(newValue) {
        if (!persistedIsSelected) {
            var nextValue = newValue(persistedIsSelected);
            selectRadioItem(id, nextValue);
            setLocalIsSelected(nextValue);
        }
    }, [
        persistedIsSelected,
        id,
        selectRadioItem
    ]);
    /**
   * - radio state changes any time a radio child is changed
   * - when it changes we want all radio buttons to update their local state
   * - it takes the value from radio group state and applies it locally if it exists which it will only exist, if it is selected
   */ (0, $5FkrB.useEffect)(function() {
        setLocalIsSelected(function() {
            var existing = radioGroupState[id];
            return existing !== undefined ? existing : defaultSelected || false;
        });
    }, [
        radioGroupState,
        group,
        id,
        defaultSelected
    ]);
    if (typeof isSelected === 'boolean') return [
        isSelected,
        function() {
            return false;
        }
    ];
    if (persistedIsSelected === undefined) {
        var existing = getGroupState(group);
        setGroupState(group, $2bb515b7d71ee3c9$var$_objectSpread($2bb515b7d71ee3c9$var$_objectSpread({}, (0, $db8e4a3eb620c41f$export$2e2bcd8739ae039)(existing || {})), {}, (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, id, defaultSelected || false)));
    }
    return [
        localIsSelected,
        setLocalState
    ];
}
var $2bb515b7d71ee3c9$export$2e2bcd8739ae039 = $2bb515b7d71ee3c9$var$useRadioState;



var $16d5fae6b7e2571d$var$canUseDOM = function canUseDOM() {
    return Boolean(typeof window !== 'undefined' && window.document && window.document.createElement);
};
/*
 * Making sure we can fallback to browsers doesn't support voice over -
 * we would using menuitemcheckbox / menuitemradio for these that supports voice over, and
 * will fallback to checkbox / radio for these doesn't
 */ var $16d5fae6b7e2571d$var$isVoiceOverSupported = function isVoiceOverSupported() {
    return /Mac OS X/.test($16d5fae6b7e2571d$var$canUseDOM() ? navigator.userAgent : '');
};
var $16d5fae6b7e2571d$export$2e2bcd8739ae039 = $16d5fae6b7e2571d$var$isVoiceOverSupported;



var $3ZMUU = parcelRequire("3ZMUU");
var $2f6caa8af3b1a588$var$_excluded = [
    "children",
    "defaultSelected",
    "testId",
    "id",
    "title",
    "description",
    "isDisabled",
    "isSelected",
    "onClick",
    "shouldDescriptionWrap",
    "shouldTitleWrap",
    "interactionName"
];
/**
 * __Dropdown item radio__
 *
 * A dropdown item radio displays groups that have a single selection.
 *
 * - [Examples](https://atlassian.design/components/dropdown-menu/dropdown-item-radio/examples)
 * - [Code](https://atlassian.design/components/dropdown-menu/dropdown-item-radio/code)
 * - [Usage](https://atlassian.design/components/dropdown-menu/dropdown-item-radio/usage)
 */ var $2f6caa8af3b1a588$var$DropdownItemRadio = function DropdownItemRadio(_ref) {
    var children = _ref.children, defaultSelected = _ref.defaultSelected, testId = _ref.testId, id = _ref.id, title = _ref.title, description = _ref.description, isDisabled = _ref.isDisabled, isSelected = _ref.isSelected, _ref$onClick = _ref.onClick, providedOnClick = _ref$onClick === void 0 ? (0, $3a341012e037de4f$export$2e2bcd8739ae039) : _ref$onClick, _ref$shouldDescriptio = _ref.shouldDescriptionWrap, shouldDescriptionWrap = _ref$shouldDescriptio === void 0 ? true : _ref$shouldDescriptio, _ref$shouldTitleWrap = _ref.shouldTitleWrap, shouldTitleWrap = _ref$shouldTitleWrap === void 0 ? true : _ref$shouldTitleWrap, interactionName = _ref.interactionName, rest = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $2f6caa8af3b1a588$var$_excluded);
    typeof $3ZMUU;
    var _useRadioState = (0, $2bb515b7d71ee3c9$export$2e2bcd8739ae039)({
        id: id,
        isSelected: isSelected,
        defaultSelected: defaultSelected
    }), _useRadioState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useRadioState, 2), selected = _useRadioState2[0], setSelected = _useRadioState2[1];
    var onClickHandler = (0, $5FkrB.useCallback)(function(event) {
        setSelected(function(selected) {
            return !selected;
        });
        providedOnClick(event);
    }, [
        providedOnClick,
        setSelected
    ]);
    var itemRef = (0, $342103062545c958$export$2e2bcd8739ae039)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $029784b0740265a3$export$9ca534b70725964d).Provider, {
        value: "none"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $deae49ab7e32e8cd$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        "aria-checked": selected,
        description: description,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $6f640f39f2f07b66$export$2e2bcd8739ae039), {
            checked: selected
        }),
        id: id,
        isDisabled: isDisabled,
        isSelected: selected,
        onClick: onClickHandler,
        ref: itemRef,
        role: (0, $16d5fae6b7e2571d$export$2e2bcd8739ae039)() ? 'radio' : 'menuitemradio',
        shouldDescriptionWrap: shouldDescriptionWrap,
        shouldTitleWrap: shouldTitleWrap,
        testId: testId,
        title: title
    }, (0, $dU8Y3.fg)('platform_button_item-add-ufo-metrics') && {
        interactionName: interactionName
    }, rest), children));
};
var $2f6caa8af3b1a588$export$2e2bcd8739ae039 = $2f6caa8af3b1a588$var$DropdownItemRadio;




var $kqp0i = parcelRequire("kqp0i");

var $25nEq = parcelRequire("25nEq");

var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");

var $6ILNo = parcelRequire("6ILNo");

var $jOmHm = parcelRequire("jOmHm");

var $117fZ = parcelRequire("117fZ");

var $dU8Y3 = parcelRequire("dU8Y3");

var $6ILNo = parcelRequire("6ILNo");
var $d41e3f84b1285b42$export$fc06342dc8588d3b = function getFirstErrorField(inputs, errors) {
    // Guaranteed to be of type HTMLInputElement[] due to getInputs function overrided in createDecorator
    var htmlInputs = inputs;
    return htmlInputs.find(function(input) {
        // If input is hidden, do not focus
        if (input.type === 'hidden') return false;
        // If input ID matches the error, focus
        if (input.id && (0, $6ILNo.getIn)(errors, input.id)) return true;
        // Default to base behavior
        return input.name && (0, $6ILNo.getIn)(errors, input.name);
    });
};


function $916dd591feb93e13$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $916dd591feb93e13$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $916dd591feb93e13$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $916dd591feb93e13$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $916dd591feb93e13$export$c24727297075ec6a = /*#__PURE__*/ (0, $5FkrB.createContext)({
    registerField: function registerField() {
        return function() {};
    },
    getCurrentValue: function getCurrentValue() {
        return undefined;
    },
    subscribe: function subscribe() {
        return function() {};
    }
});
var $916dd591feb93e13$export$c17cf6b332a82dbc = /*#__PURE__*/ (0, $5FkrB.createContext)(false);
function $916dd591feb93e13$export$2e2bcd8739ae039(props) {
    var userProvidedFormProps = props.formProps, onSubmit = props.onSubmit, testId = props.testId;
    var formRef = (0, $5FkrB.useRef)(null);
    var onSubmitRef = (0, $5FkrB.useRef)(onSubmit);
    onSubmitRef.current = onSubmit;
    var _useState = (0, $5FkrB.useState)(function() {
        // Types here would break the existing API
        var finalForm = (0, $6ILNo.createForm)({
            onSubmit: function onSubmit() {
                return onSubmitRef.current.apply(onSubmitRef, arguments);
            },
            destroyOnUnregister: true,
            initialValues: {},
            mutators: {
                setDefaultValue: function setDefaultValue(_ref, state) {
                    var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_ref, 2), name = _ref2[0], defaultValue = _ref2[1];
                    if (state.formState.initialValues) {
                        var initialValues = state.formState.initialValues;
                        var values = state.formState.values;
                        var _value = name && typeof defaultValue === 'function' ? defaultValue(initialValues[name]) : defaultValue;
                        (0, (/*@__PURE__*/$parcel$interopDefault($117fZ)))(initialValues, name, _value);
                        (0, (/*@__PURE__*/$parcel$interopDefault($117fZ)))(values, name, _value);
                    }
                }
            }
        });
        (0, $jOmHm.default)(function() {
            return formRef.current ? Array.from(formRef.current.querySelectorAll('input')) : [];
        }, (0, $dU8Y3.fg)('platform-form-field-error-focus') ? (0, $d41e3f84b1285b42$export$fc06342dc8588d3b) : undefined)(finalForm);
        return finalForm;
    }), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 1), form = _useState2[0];
    var _useState3 = (0, $5FkrB.useState)({
        dirty: false,
        submitting: false
    }), _useState4 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState3, 2), state = _useState4[0], setState = _useState4[1];
    (0, $5FkrB.useEffect)(function() {
        var unsubscribe = form.subscribe(function(_ref3) {
            var dirty = _ref3.dirty, submitting = _ref3.submitting;
            setState({
                dirty: dirty,
                submitting: submitting
            });
        }, {
            dirty: true,
            submitting: true
        });
        return unsubscribe;
    }, [
        form
    ]);
    var registerField = (0, $5FkrB.useCallback)(function(name, defaultValue, subscriber, subscription, config) {
        form.pauseValidation();
        var unsubscribe = form.registerField(name, subscriber, subscription, config);
        form.mutators.setDefaultValue(name, defaultValue);
        form.resumeValidation();
        return unsubscribe;
    }, [
        form
    ]);
    var handleSubmit = function handleSubmit(e) {
        if (e) e.preventDefault();
        form.submit();
    };
    var handleReset = function handleReset(initialValues) {
        form.reset(initialValues);
    };
    var handleKeyDown = function handleKeyDown(e) {
        if (e.key === 'Enter' && (e.ctrlKey || e.metaKey) && formRef.current) {
            var submitButton = formRef.current.querySelector('button:not([type]), button[type="submit"], input[type="submit"]');
            if (submitButton) submitButton.click();
            e.preventDefault();
        }
    };
    var _props$isDisabled = props.isDisabled, isDisabled = _props$isDisabled === void 0 ? false : _props$isDisabled, children = props.children;
    var dirty = state.dirty, submitting = state.submitting;
    /**
   * This method is needed in FormContext to use it on the field level
   * to check the current value of the field in case of the component re-mounting.
   */ var getCurrentValue = (0, $5FkrB.useCallback)(function(name) {
        var formState = form.getState();
        return (formState === null || formState === void 0 ? void 0 : formState.values[name]) || undefined;
    }, [
        form
    ]);
    var FormContextValue = (0, $5FkrB.useMemo)(function() {
        return {
            registerField: registerField,
            getCurrentValue: getCurrentValue,
            subscribe: form.subscribe
        };
    }, [
        registerField,
        getCurrentValue,
        form.subscribe
    ]);
    // Abstracting so we can use the same for both rendering patterns
    var formProps = $916dd591feb93e13$var$_objectSpread({
        onKeyDown: handleKeyDown,
        onSubmit: handleSubmit,
        ref: formRef
    }, testId && {
        'data-testid': testId
    });
    var childrenContent = function() {
        if (typeof children === 'function') {
            var result = children.length > 0 ? children($916dd591feb93e13$var$_objectSpread({
                formProps: formProps,
                dirty: dirty,
                reset: handleReset,
                submitting: submitting,
                disabled: isDisabled,
                getState: function getState() {
                    return form.getState();
                },
                getValues: function getValues() {
                    return form.getState().values;
                },
                setFieldValue: form.change
            }, (0, $dU8Y3.fg)('platform-form-reset-field-state') && {
                resetFieldState: form.resetFieldState
            })) : children();
            return result === undefined ? null : result;
        } else return (0, $dU8Y3.fg)('platform_design-system-team_form-upgrade') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("form", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, formProps, userProvidedFormProps), children) : children;
    }();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement($916dd591feb93e13$export$c24727297075ec6a.Provider, {
        value: FormContextValue
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement($916dd591feb93e13$export$c17cf6b332a82dbc.Provider, {
        value: isDisabled
    }, childrenContent));
}

/* messages.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");
var $9768e521609fe02c$exports = {};
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f636032ea4a949f6a3ed21b2a88730cd>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty($9768e521609fe02c$exports, "__esModule", {
    value: true
});
$9768e521609fe02c$exports.default = void 0;

var $9768e521609fe02c$var$_react = $9768e521609fe02c$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $9768e521609fe02c$var$_statusError = $9768e521609fe02c$var$_interopRequireDefault((parcelRequire("coPW0")));

var $9768e521609fe02c$var$_error = $9768e521609fe02c$var$_interopRequireDefault((parcelRequire("1yYLz")));
function $9768e521609fe02c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for StatusErrorIcon.
 * This component is StatusErrorIcon, with `UNSAFE_fallbackIcon` set to "ErrorIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for error statuses and messaging.
Filled status icons provide higher visual contrast to draw attention to important information.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $9768e521609fe02c$var$StatusErrorIcon = (props)=>/*#__PURE__*/ $9768e521609fe02c$var$_react.default.createElement($9768e521609fe02c$var$_statusError.default, Object.assign({
        name: "StatusErrorIcon",
        LEGACY_fallbackIcon: $9768e521609fe02c$var$_error.default
    }, props));
$9768e521609fe02c$var$StatusErrorIcon.displayName = 'StatusErrorIconMigration';
var $9768e521609fe02c$var$_default = $9768e521609fe02c$exports.default = $9768e521609fe02c$var$StatusErrorIcon;


var $b40aa0df80f33508$exports = {};
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::849e146248de3896aa5effb6cb325c8d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty($b40aa0df80f33508$exports, "__esModule", {
    value: true
});
$b40aa0df80f33508$exports.default = void 0;

var $b40aa0df80f33508$var$_react = $b40aa0df80f33508$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $b40aa0df80f33508$var$_statusSuccess = $b40aa0df80f33508$var$_interopRequireDefault((parcelRequire("bQGRN")));

var $b40aa0df80f33508$var$_success = $b40aa0df80f33508$var$_interopRequireDefault((parcelRequire("6AF9r")));
function $b40aa0df80f33508$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for StatusSuccessIcon.
 * This component is StatusSuccessIcon, with `UNSAFE_fallbackIcon` set to "EditorSuccessIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for success statuses and messaging. Filled status icons provide higher visual contrast to draw attention to important information.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $b40aa0df80f33508$var$StatusSuccessIcon = (props)=>/*#__PURE__*/ $b40aa0df80f33508$var$_react.default.createElement($b40aa0df80f33508$var$_statusSuccess.default, Object.assign({
        name: "StatusSuccessIcon",
        LEGACY_fallbackIcon: $b40aa0df80f33508$var$_success.default
    }, props));
$b40aa0df80f33508$var$StatusSuccessIcon.displayName = 'StatusSuccessIconMigration';
var $b40aa0df80f33508$var$_default = $b40aa0df80f33508$exports.default = $b40aa0df80f33508$var$StatusSuccessIcon;



var $dU8Y3 = parcelRequire("dU8Y3");

var $5FkrB = parcelRequire("5FkrB");
var $56b9ed80af5bcb03$export$3c4232819458a302 = /*#__PURE__*/ (0, $5FkrB.createContext)(undefined);


/**
 * API for the internal `<Message />` component. This is not public API.
 */ /**
 * Public API of the various message components.
 */ var $3433a9f6c8d902bf$var$messageStyles = null;
var $3433a9f6c8d902bf$var$messageAppearanceStyles = {
    default: "_syaz1wmz",
    error: "_syaze6sf",
    valid: "_syazy73q"
};
var $3433a9f6c8d902bf$var$iconWrapperStyles = {
    root: "_1e0c1txw _4t3i7vkz _4cvr1h6o"
};
var $3433a9f6c8d902bf$var$IconWrapper = function IconWrapper(_ref) {
    var children = _ref.children;
    return /*#__PURE__*/ $5FkrB.createElement("span", {
        className: (0, $970q7.default)([
            $3433a9f6c8d902bf$var$iconWrapperStyles.root
        ])
    }, children);
};
var $3433a9f6c8d902bf$var$messageIcons = {
    error: /*#__PURE__*/ $5FkrB.createElement((0, (/*@__PURE__*/$parcel$interopDefault($9768e521609fe02c$exports))), {
        LEGACY_margin: "0 -2px 0 0",
        color: "currentColor",
        LEGACY_size: "small",
        label: "error",
        size: "small"
    }),
    valid: /*#__PURE__*/ $5FkrB.createElement((0, (/*@__PURE__*/$parcel$interopDefault($b40aa0df80f33508$exports))), {
        LEGACY_margin: "0 -2px 0 0",
        color: "currentColor",
        LEGACY_size: "small",
        label: "success",
        size: "small"
    })
};
var $3433a9f6c8d902bf$var$Message = function Message(_ref2) {
    var children = _ref2.children, _ref2$appearance = _ref2.appearance, appearance = _ref2$appearance === void 0 ? 'default' : _ref2$appearance, fieldId = _ref2.fieldId, testId = _ref2.testId;
    var icon = $3433a9f6c8d902bf$var$messageIcons[appearance];
    var _useContext = (0, $5FkrB.useContext)($3433a9f6c8d902bf$var$MessageWrapperContext), isWrapper = _useContext.isWrapper;
    var _useState = (0, $5FkrB.useState)(false), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), shouldRenderAfterDelay = _useState2[0], setShouldRenderAfterDelay = _useState2[1];
    // TODO: DSP-23603 - To clean up when removing "platform_dst_form_screenreader_message_fix" feature flag
    var isDelayRenderEnabled = (0, $dU8Y3.fg)('platform_dst_form_screenreader_message_fix') && !isWrapper;
    (0, $5FkrB.useEffect)(function() {
        if (isDelayRenderEnabled) {
            // Only delay rendering if there is no wrapper and feature flag is enabled
            var timer = setTimeout(function() {
                setShouldRenderAfterDelay(true);
            }, 10);
            return function() {
                return clearTimeout(timer);
            };
        }
    }, [
        isDelayRenderEnabled
    ]);
    /**
   * The wrapping span is necessary to preserve spaces between children.
   * Otherwise the flex layout of the message will remove any whitespace
   * between children.
   *
   * If the child is just a string, this is not required and we can use one
   * less DOM element.
   */ var content = typeof children === 'string' ? children : /*#__PURE__*/ $5FkrB.createElement("span", null, children);
    var childrenToRender = /*#__PURE__*/ $5FkrB.createElement((0, $5FkrB.Fragment), null, icon && /*#__PURE__*/ $5FkrB.createElement($3433a9f6c8d902bf$var$IconWrapper, null, icon), content);
    return /*#__PURE__*/ $5FkrB.createElement("div", {
        "data-testid": testId,
        id: fieldId,
        "aria-live": !isWrapper ? 'polite' : undefined,
        className: (0, $970q7.default)([
            "_zulp12x7 _11c8dcr7 _1e0c1txw _1bah1q9y _1pfh1b66",
            $3433a9f6c8d902bf$var$messageAppearanceStyles[appearance]
        ])
    }, isDelayRenderEnabled ? shouldRenderAfterDelay && childrenToRender : childrenToRender);
};
var $3433a9f6c8d902bf$export$8fbe3c7d0ed2c683 = function HelperMessage(_ref3) {
    var children = _ref3.children, testId = _ref3.testId;
    return /*#__PURE__*/ $5FkrB.createElement((0, $56b9ed80af5bcb03$export$3c4232819458a302).Consumer, null, function(fieldId) {
        return /*#__PURE__*/ $5FkrB.createElement($3433a9f6c8d902bf$var$Message, {
            fieldId: fieldId ? "".concat(fieldId, "-helper") : undefined,
            testId: testId
        }, children);
    });
};
var $3433a9f6c8d902bf$export$915e9e7bd4f0f96d = function ErrorMessage(_ref4) {
    var children = _ref4.children, testId = _ref4.testId;
    return /*#__PURE__*/ $5FkrB.createElement((0, $56b9ed80af5bcb03$export$3c4232819458a302).Consumer, null, function(fieldId) {
        return /*#__PURE__*/ $5FkrB.createElement($3433a9f6c8d902bf$var$Message, {
            appearance: "error",
            fieldId: fieldId ? "".concat(fieldId, "-error") : undefined,
            testId: testId
        }, children);
    });
};
var $3433a9f6c8d902bf$export$5505afb209a532c8 = function ValidMessage(_ref5) {
    var children = _ref5.children, testId = _ref5.testId;
    return /*#__PURE__*/ $5FkrB.createElement((0, $56b9ed80af5bcb03$export$3c4232819458a302).Consumer, null, function(fieldId) {
        return /*#__PURE__*/ $5FkrB.createElement($3433a9f6c8d902bf$var$Message, {
            appearance: "valid",
            fieldId: fieldId ? "".concat(fieldId, "-valid") : undefined,
            testId: testId
        }, children);
    });
};
/**
 * __Message wrapper context__
 *
 * A message wrapper context allows the children to check
 * if it is contained within the MessageWrapper.
 */ var $3433a9f6c8d902bf$var$MessageWrapperContext = /*#__PURE__*/ (0, $5FkrB.createContext)({
    isWrapper: false
});
var $3433a9f6c8d902bf$export$ec445f12f63100a5 = function MessageWrapper(_ref6) {
    var children = _ref6.children;
    var contextValue = {
        isWrapper: true
    };
    return /*#__PURE__*/ $5FkrB.createElement($3433a9f6c8d902bf$var$MessageWrapperContext.Provider, {
        value: contextValue
    }, /*#__PURE__*/ $5FkrB.createElement("div", {
        "aria-live": "polite",
        "data-testid": "message-wrapper"
    }, children));
};

/* field.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $25nEq = parcelRequire("25nEq");

var $iYJcE = parcelRequire("iYJcE");

var $ekGgq = parcelRequire("ekGgq");

var $970q7 = parcelRequire("970q7");

var $5FkrB = parcelRequire("5FkrB");

var $ekGgq = parcelRequire("ekGgq");

var $5FkrB = parcelRequire("5FkrB");

var $b5lkZ = parcelRequire("b5lkZ");

var $dU8Y3 = parcelRequire("dU8Y3");
var $c461177f06e9e5de$var$_React$useId;
// Type copied from https://github.com/thearnica/react-uid/blob/0f507fbbdb1ab84acf477ec32698afe3d2191e49/src/hooks.ts#L12
// Copied rather than inferred to make the type transparent
// @ts-ignore - useId is not accessible in React 16
var $c461177f06e9e5de$var$react18UseId = ($c461177f06e9e5de$var$_React$useId = (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).useId) !== null && $c461177f06e9e5de$var$_React$useId !== void 0 ? $c461177f06e9e5de$var$_React$useId : undefined;
function $c461177f06e9e5de$export$f680877a34711e37() {
    if ($c461177f06e9e5de$var$react18UseId && (0, $dU8Y3.fg)('platform-dst-react-18-use-id')) {
        if ((0, $dU8Y3.fg)('platform-dst-react-18-use-id-selector-safe')) // tl;dr: React uses `:` or `«»` in selectors which breaks `document.querySelector(…)`
        // in hundreds of tests. So we replace it with a safe string of `_` to match future
        // React 19 functionality: https://github.com/facebook/react/pull/33422
        return $c461177f06e9e5de$var$react18UseId().replace(/[:«»]/g, '_');
        return $c461177f06e9e5de$var$react18UseId();
    }
    return "uid".concat((0, $b5lkZ.useUID)());
}
var $c461177f06e9e5de$export$6be90bcb437e928f = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function(_ref, ref) {
    var children = _ref.children, _ref$postfix = _ref.postfix, postfix = _ref$postfix === void 0 ? '' : _ref$postfix, _ref$prefix = _ref.prefix, prefix = _ref$prefix === void 0 ? '' : _ref$prefix;
    var id = "".concat(prefix).concat($c461177f06e9e5de$export$f680877a34711e37()).concat(postfix);
    (0, $5FkrB.useEffect)(function() {
        if (!ref) return;
        switch((0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(ref)){
            case 'function':
                ref(id);
                break;
            case 'object':
                ref.current = id;
                break;
            default:
                throw new Error("Unreachable case for unsupported type of ref \"".concat((0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(ref), "\""));
        }
    }, [
        id,
        ref
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).Fragment, null, typeof children === 'function' ? children({
        id: id
    }) : children);
});
function $c461177f06e9e5de$export$6ee17796e3d70de2() {
    if ($c461177f06e9e5de$var$react18UseId && (0, $dU8Y3.fg)('platform-dst-react-18-use-id')) {
        // eslint-disable-next-line react-hooks/rules-of-hooks -- cleanup with feature gating
        var uid = $c461177f06e9e5de$export$f680877a34711e37();
        return function(id) {
            return "".concat(uid, "-").concat(id.toString());
        };
    }
    return (0, $b5lkZ.useUIDSeed)();
}



var $dU8Y3 = parcelRequire("dU8Y3");


/* label.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");
var $5ac1013239c7eb7f$var$fieldsetLabelStyles = null;
var $5ac1013239c7eb7f$export$b04be29aa201d4f5 = function Label(_ref) {
    var children = _ref.children, htmlFor = _ref.htmlFor, id = _ref.id, testId = _ref.testId;
    return /*#__PURE__*/ $5FkrB.createElement("label", {
        id: id,
        htmlFor: htmlFor,
        "data-testid": testId,
        className: (0, $970q7.default)([
            "_11c8dcr7 _1e0c1o8l _syaz1gjq _k48pmoej _6rth1b66 _1pfhze3t"
        ])
    }, children);
};
var $5ac1013239c7eb7f$export$ed247974535929c7 = function Legend(_ref2) {
    var children = _ref2.children;
    return /*#__PURE__*/ $5FkrB.createElement("legend", {
        className: (0, $970q7.default)([
            "_11c8dcr7 _1e0c1o8l _syaz1gjq _k48pmoej _6rth1b66 _1pfhze3t"
        ])
    }, children);
};



/* required-asterisk.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");
var $83f0848311ef2185$var$requiredIndicatorStyles = null;
function $83f0848311ef2185$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ $5FkrB.createElement("span", {
        "aria-hidden": "true",
        title: "required",
        className: (0, $970q7.default)([
            "_syaz1ick _ect41gqc _bozgv77o"
        ])
    }, "*");
}


function $2111f5e4df021534$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $2111f5e4df021534$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $2111f5e4df021534$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $2111f5e4df021534$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $2111f5e4df021534$var$fieldWrapperStyles = null;
function $2111f5e4df021534$var$isEvent(event) {
    return Boolean(event && event.target);
}
function $2111f5e4df021534$var$isFunction(x) {
    return typeof x === 'function';
}
// Must be exported to satisfy error TS4023 from Jira builds
// src/packages/servicedesk/virtual-agent/common/src/ui/base-text-field/index.tsx(10,14):
// error TS4023: Exported variable `BaseTextField` has or is using name
// `FieldComponentProps` from external module
// `/opt/atlassian/pipelines/agent/build/jira/tsDist/@atlaskit__form/app/src/field`
// but cannot be named.
function $2111f5e4df021534$var$usePreviousRef(current) {
    var ref = (0, $5FkrB.useRef)(current);
    // will be updated on the next render
    (0, $5FkrB.useEffect)(function() {
        ref.current = current;
    });
    // return the existing current (pre render)
    return ref;
}
function $2111f5e4df021534$var$isShallowEqual(previousValue, currentValue) {
    if (previousValue === currentValue) return true;
    // not checking functions
    if (typeof previousValue === 'function' && typeof currentValue === 'function') return true;
    if (Array.isArray(previousValue) && Array.isArray(currentValue)) return JSON.stringify(previousValue) === JSON.stringify(currentValue);
    if ((0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(previousValue) === 'object' && (0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(currentValue) === 'object') return JSON.stringify(previousValue) === JSON.stringify(currentValue);
    return false;
}
function $2111f5e4df021534$export$2e2bcd8739ae039(props) {
    var _getCurrentValue;
    var _props$children = props.children, children = _props$children === void 0 ? function() {
        return null;
    } : _props$children, component = props.component;
    var _useContext = (0, $5FkrB.useContext)((0, $916dd591feb93e13$export$c24727297075ec6a)), registerField = _useContext.registerField, getCurrentValue = _useContext.getCurrentValue;
    var isDisabled = (0, $5FkrB.useContext)((0, $916dd591feb93e13$export$c17cf6b332a82dbc)) || props.isDisabled || false;
    var defaultValue = $2111f5e4df021534$var$isFunction(props.defaultValue) ? props.defaultValue() : props.defaultValue;
    var latestPropsRef = $2111f5e4df021534$var$usePreviousRef(props);
    /**
   * HACK: defaultValue can potentially be an array or object which cannot be
   * passed directly into a `useEffect` dependency array, since it will trigger
   * the hook every time.
   */ var isDefaultValueChanged = !$2111f5e4df021534$var$isShallowEqual(latestPropsRef.current.defaultValue, props.defaultValue);
    var _useState = (0, $5FkrB.useState)({
        fieldProps: {
            onChange: function onChange() {},
            onBlur: function onBlur() {},
            onFocus: function onFocus() {},
            /* Previously, defaultValue was being set as undefined in Field.defaultProps, which
         * effectively made it an optional prop to external consumers of Field. However the
         * prop types defined defaultValue as required, so inside the component it was not
         * valid for defaultValue to be undefined. We need to suppress the error
         * after changing defaultValue to explicitly be an optional prop.
         * If default value has changed we are using new default value.
         * Otherwise we need to check if we already have value for this field
         * (because we are using changing key prop to re-run field level validation, and that
         * cause the component re-mounting) to not override the actual value with the default value.
         */ // @ts-ignore
            value: isDefaultValueChanged ? defaultValue : (_getCurrentValue = getCurrentValue(props.name)) !== null && _getCurrentValue !== void 0 ? _getCurrentValue : defaultValue
        },
        error: undefined,
        valid: false,
        meta: {
            dirty: false,
            dirtySinceLastSubmit: false,
            touched: false,
            valid: false,
            validating: false,
            submitting: false,
            submitFailed: false,
            error: undefined,
            submitError: undefined
        }
    }), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), state = _useState2[0], setState = _useState2[1];
    var latestStateRef = $2111f5e4df021534$var$usePreviousRef(state);
    (0, $5FkrB.useEffect)(function() {
        function fieldStateToMeta() {
            var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
            return {
                dirty: value.dirty || false,
                dirtySinceLastSubmit: value.dirtySinceLastSubmit || false,
                touched: value.touched || false,
                valid: value.valid || false,
                submitting: value.submitting || false,
                submitFailed: value.submitFailed || false,
                error: value.error,
                submitError: value.submitError,
                validating: !!value.validating
            };
        }
        var unregister = registerField(latestPropsRef.current.name, /**
     * Similar as for setting initial state value.
     * Additionally we are checking if the default value is a function,
     * it is used in checkbox fields, where fields with same name and
     * defaultIsChecked should create array of values. In this situation we can't
     * override the default value on re-registering, but also we don't need to change
     * the key prop to re-run validation.
     */ // @ts-ignore
        isDefaultValueChanged || // @ts-ignore
        $2111f5e4df021534$var$isFunction(latestPropsRef.current.defaultValue) ? latestPropsRef.current.defaultValue : latestStateRef.current.fieldProps.value, function(fieldState) {
            /**
       * Do not update dirtySinceLastSubmit until submission has finished.
       */ var modifiedDirtySinceLastSubmit = fieldState.submitting ? latestStateRef.current.meta.dirtySinceLastSubmit : fieldState.dirtySinceLastSubmit;
            /**
       * Do not update submitFailed until submission has finished.
       */ var modifiedSubmitFailed = fieldState.submitting ? latestStateRef.current.meta.submitFailed : fieldState.submitFailed;
            /**
       * Do not use submitError if the value has changed.
       */ var modifiedSubmitError = modifiedDirtySinceLastSubmit && latestPropsRef.current.validate ? undefined : fieldState.submitError;
            var modifiedError = modifiedSubmitError || (fieldState.touched || fieldState.dirty) && fieldState.error;
            /**
       * If there has been a submit error, then use logic in modifiedError to determine validity,
       * so we can determine when there is a submit error which we do not want to display
       * because the value has been changed.
       */ var modifiedValid = modifiedSubmitFailed ? modifiedError === undefined : fieldState.valid;
            function getTransform(eventOrValue, currentValue) {
                if (latestPropsRef.current.transform) return latestPropsRef.current.transform(eventOrValue, currentValue);
                if ($2111f5e4df021534$var$isEvent(eventOrValue)) {
                    var currentTarget = eventOrValue.currentTarget;
                    if (currentTarget.type === 'checkbox') {
                        if (currentTarget.checked) return currentTarget.value || true;
                        return currentTarget.value ? undefined : false;
                    } else if (currentTarget) return currentTarget.value;
                } else return eventOrValue;
            }
            setState({
                fieldProps: {
                    onChange: function onChange(e) {
                        fieldState.change(getTransform(e, fieldState.value));
                    },
                    onBlur: fieldState.blur,
                    onFocus: fieldState.focus,
                    value: fieldState.value
                },
                error: modifiedError || undefined,
                /**
         * The following parameters are optionally typed in final-form to indicate that not all parameters need
         * to be subscribed to. We cast them as booleans (using || false), since this is what they are semantically.
         */ valid: modifiedValid || false,
                meta: fieldStateToMeta(fieldState)
            });
        }, {
            dirty: true,
            dirtySinceLastSubmit: true,
            touched: true,
            valid: true,
            submitting: true,
            submitFailed: true,
            value: true,
            error: true,
            submitError: true,
            validating: true
        }, {
            getValidator: function getValidator() {
                return function validate(value, formState, fieldState) {
                    var supplied = latestPropsRef.current.validate;
                    if (supplied && fieldState) return supplied(value, formState, fieldStateToMeta(fieldState));
                };
            }
        });
        return unregister;
    }, [
        latestPropsRef,
        latestStateRef,
        registerField,
        props.name,
        isDefaultValueChanged
    ]);
    var uid = (0, $c461177f06e9e5de$export$f680877a34711e37)();
    var fieldId = (0, $5FkrB.useMemo)(function() {
        return props.id ? props.id : "".concat(props.name, "-").concat(uid);
    }, [
        props.id,
        props.name,
        uid
    ]);
    var getDescribedBy = function getDescribedBy() {
        var value = '';
        if (state.error) value += "".concat(fieldId, "-error ");
        if (state.valid) value += "".concat(fieldId, "-valid ");
        return "".concat(value).concat(fieldId, "-helper");
    };
    var extendedFieldProps = $2111f5e4df021534$var$_objectSpread($2111f5e4df021534$var$_objectSpread({}, state.fieldProps), {}, {
        name: props.name,
        isDisabled: isDisabled,
        isInvalid: Boolean(state.error),
        isRequired: Boolean(props.isRequired),
        'aria-invalid': state.error ? 'true' : 'false',
        'aria-describedby': getDescribedBy(),
        'aria-labelledby': "".concat(fieldId, "-label"),
        id: fieldId
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("div", {
        "data-testid": props.testId,
        className: (0, $970q7.default)([
            "_1pfhu2gc"
        ])
    }, props.label && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $5ac1013239c7eb7f$export$b04be29aa201d4f5), {
        htmlFor: fieldId,
        id: "".concat(fieldId, "-label"),
        testId: props.testId && "".concat(props.testId, "--label")
    }, props.label, props.isRequired && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $83f0848311ef2185$export$2e2bcd8739ae039), null), props.elementAfterLabel), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $56b9ed80af5bcb03$export$3c4232819458a302).Provider, {
        value: fieldId
    }, component && (0, $dU8Y3.fg)('platform_design-system-team_field-upgrade') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).Fragment, null, component && component({
        fieldProps: extendedFieldProps
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $3433a9f6c8d902bf$export$ec445f12f63100a5), null, props.helperMessage && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $3433a9f6c8d902bf$export$8fbe3c7d0ed2c683), null, props.helperMessage), state.error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $3433a9f6c8d902bf$export$915e9e7bd4f0f96d), null, props.errorMessage || state.error), state.meta.touched && state.valid && props.validMessage && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $3433a9f6c8d902bf$export$5505afb209a532c8), null, props.validMessage))) : children({
        fieldProps: extendedFieldProps,
        error: state.error,
        valid: state.valid,
        meta: state.meta
    })));
}

/* form-footer.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");
var $ab642ec49327e475$var$formFooterWrapperStyles = null;
var $ab642ec49327e475$var$justifyContentStyles = null;
function $ab642ec49327e475$export$2e2bcd8739ae039(_ref) {
    var _ref$align = _ref.align, align = _ref$align === void 0 ? 'end' : _ref$align, children = _ref.children;
    return /*#__PURE__*/ $5FkrB.createElement("footer", {
        className: (0, $970q7.default)([
            "_1e0c1txw _1bahesu3 _1pfh1ejb",
            align === 'start' && "_1bah1y6m"
        ])
    }, children);
}


var $68426ff7d9d92e39$exports = {};
"use strict";
Object.defineProperty($68426ff7d9d92e39$exports, "__esModule", {
    value: true
});
$68426ff7d9d92e39$exports.default = void 0;

var $68426ff7d9d92e39$var$_react = $68426ff7d9d92e39$var$_interopRequireDefault((parcelRequire("5FkrB")));


var $68426ff7d9d92e39$var$_showMoreHorizontal = $68426ff7d9d92e39$var$_interopRequireDefault((parcelRequire("8dIct")));
function $68426ff7d9d92e39$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $68426ff7d9d92e39$var$MoreIcon = (props)=>/*#__PURE__*/ $68426ff7d9d92e39$var$_react.default.createElement($49a9e186635900ef$export$3cfb73f70dfca966, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><circle cx="5" cy="12" r="2"/><circle cx="12" cy="12" r="2"/><circle cx="19" cy="12" r="2"/></g></svg>`
    }, props, {
        newIcon: $68426ff7d9d92e39$var$_showMoreHorizontal.default
    }));
$68426ff7d9d92e39$var$MoreIcon.displayName = 'MoreIcon';
var $68426ff7d9d92e39$var$_default = $68426ff7d9d92e39$exports.default = $68426ff7d9d92e39$var$MoreIcon;



var $igbF4 = parcelRequire("igbF4");
var $af69d9e57c55d6b7$exports = {};
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::0b480e25e279369257bb77bb164319fb>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty($af69d9e57c55d6b7$exports, "__esModule", {
    value: true
});
$af69d9e57c55d6b7$exports.default = void 0;

var $af69d9e57c55d6b7$var$_react = $af69d9e57c55d6b7$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $af69d9e57c55d6b7$var$_UNSAFE_baseNew = $af69d9e57c55d6b7$var$_interopRequireDefault((parcelRequire("bPdWt")));
function $af69d9e57c55d6b7$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Camera".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: upload photo in Trello, photos.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $af69d9e57c55d6b7$var$CameraIcon = (props)=>/*#__PURE__*/ $af69d9e57c55d6b7$var$_react.default.createElement($af69d9e57c55d6b7$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M14 13.25H2c-.69 0-1.25-.56-1.25-1.25V5.25a2 2 0 0 1 2-2H4.5l1.5-2h4l1.5 2h1.75a2 2 0 0 1 2 2V12c0 .69-.56 1.25-1.25 1.25Z"/><path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M10.5 8.25a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0Z"/>`
    }, props));
$af69d9e57c55d6b7$var$CameraIcon.displayName = 'CameraIcon';
var $af69d9e57c55d6b7$var$_default = $af69d9e57c55d6b7$exports.default = $af69d9e57c55d6b7$var$CameraIcon;


var $1c94bc9aa532188d$exports = {};
typeof navigator === "object" && function(global1, factory) {
    $1c94bc9aa532188d$exports = factory();
}($1c94bc9aa532188d$exports, function() {
    'use strict';
    function _defineProperty$1(obj, key, value) {
        if (key in obj) Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
        else obj[key] = value;
        return obj;
    }
    function _classCallCheck(e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }
    function _defineProperties(e, t) {
        for(var n = 0; n < t.length; n++){
            var r = t[n];
            r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
        }
    }
    function _createClass(e, t, n) {
        return t && _defineProperties(e.prototype, t), n && _defineProperties(e, n), e;
    }
    function _defineProperty(e, t, n) {
        return t in e ? Object.defineProperty(e, t, {
            value: n,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }) : e[t] = n, e;
    }
    function ownKeys(e, t) {
        var n = Object.keys(e);
        if (Object.getOwnPropertySymbols) {
            var r = Object.getOwnPropertySymbols(e);
            t && (r = r.filter(function(t) {
                return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })), n.push.apply(n, r);
        }
        return n;
    }
    function _objectSpread2(e) {
        for(var t = 1; t < arguments.length; t++){
            var n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? ownKeys(Object(n), !0).forEach(function(t) {
                _defineProperty(e, t, n[t]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : ownKeys(Object(n)).forEach(function(t) {
                Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
            });
        }
        return e;
    }
    var defaults$1 = {
        addCSS: !0,
        thumbWidth: 15,
        watch: !0
    };
    function matches$1(e, t) {
        return (function() {
            return Array.from(document.querySelectorAll(t)).includes(this);
        }).call(e, t);
    }
    function trigger(e, t) {
        if (e && t) {
            var n = new Event(t, {
                bubbles: !0
            });
            e.dispatchEvent(n);
        }
    }
    var getConstructor$1 = function(e) {
        return null != e ? e.constructor : null;
    }, instanceOf$1 = function(e, t) {
        return !!(e && t && e instanceof t);
    }, isNullOrUndefined$1 = function(e) {
        return null == e;
    }, isObject$1 = function(e) {
        return getConstructor$1(e) === Object;
    }, isNumber$1 = function(e) {
        return getConstructor$1(e) === Number && !Number.isNaN(e);
    }, isString$1 = function(e) {
        return getConstructor$1(e) === String;
    }, isBoolean$1 = function(e) {
        return getConstructor$1(e) === Boolean;
    }, isFunction$1 = function(e) {
        return getConstructor$1(e) === Function;
    }, isArray$1 = function(e) {
        return Array.isArray(e);
    }, isNodeList$1 = function(e) {
        return instanceOf$1(e, NodeList);
    }, isElement$1 = function(e) {
        return instanceOf$1(e, Element);
    }, isEvent$1 = function(e) {
        return instanceOf$1(e, Event);
    }, isEmpty$1 = function(e) {
        return isNullOrUndefined$1(e) || (isString$1(e) || isArray$1(e) || isNodeList$1(e)) && !e.length || isObject$1(e) && !Object.keys(e).length;
    }, is$1 = {
        nullOrUndefined: isNullOrUndefined$1,
        object: isObject$1,
        number: isNumber$1,
        string: isString$1,
        boolean: isBoolean$1,
        function: isFunction$1,
        array: isArray$1,
        nodeList: isNodeList$1,
        element: isElement$1,
        event: isEvent$1,
        empty: isEmpty$1
    };
    function getDecimalPlaces(e) {
        var t = "".concat(e).match(/(?:\.(\d+))?(?:[eE]([+-]?\d+))?$/);
        return t ? Math.max(0, (t[1] ? t[1].length : 0) - (t[2] ? +t[2] : 0)) : 0;
    }
    function round(e, t) {
        if (1 > t) {
            var n = getDecimalPlaces(t);
            return parseFloat(e.toFixed(n));
        }
        return Math.round(e / t) * t;
    }
    var RangeTouch = function() {
        function e(t, n) {
            _classCallCheck(this, e), is$1.element(t) ? this.element = t : is$1.string(t) && (this.element = document.querySelector(t)), is$1.element(this.element) && is$1.empty(this.element.rangeTouch) && (this.config = _objectSpread2({}, defaults$1, {}, n), this.init());
        }
        return _createClass(e, [
            {
                key: "init",
                value: function() {
                    e.enabled && (this.config.addCSS && (this.element.style.userSelect = "none", this.element.style.webKitUserSelect = "none", this.element.style.touchAction = "manipulation"), this.listeners(!0), this.element.rangeTouch = this);
                }
            },
            {
                key: "destroy",
                value: function() {
                    e.enabled && (this.config.addCSS && (this.element.style.userSelect = "", this.element.style.webKitUserSelect = "", this.element.style.touchAction = ""), this.listeners(!1), this.element.rangeTouch = null);
                }
            },
            {
                key: "listeners",
                value: function(e) {
                    var t = this, n = e ? "addEventListener" : "removeEventListener";
                    [
                        "touchstart",
                        "touchmove",
                        "touchend"
                    ].forEach(function(e) {
                        t.element[n](e, function(e) {
                            return t.set(e);
                        }, !1);
                    });
                }
            },
            {
                key: "get",
                value: function(t) {
                    if (!e.enabled || !is$1.event(t)) return null;
                    var n, r = t.target, i = t.changedTouches[0], o = parseFloat(r.getAttribute("min")) || 0, s = parseFloat(r.getAttribute("max")) || 100, u = parseFloat(r.getAttribute("step")) || 1, c = r.getBoundingClientRect(), a = 100 / c.width * (this.config.thumbWidth / 2) / 100;
                    return 0 > (n = 100 / c.width * (i.clientX - c.left)) ? n = 0 : 100 < n && (n = 100), 50 > n ? n -= (100 - 2 * n) * a : 50 < n && (n += 2 * (n - 50) * a), o + round(n / 100 * (s - o), u);
                }
            },
            {
                key: "set",
                value: function(t) {
                    e.enabled && is$1.event(t) && !t.target.disabled && (t.preventDefault(), t.target.value = this.get(t), trigger(t.target, "touchend" === t.type ? "change" : "input"));
                }
            }
        ], [
            {
                key: "setup",
                value: function(t) {
                    var n = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : {}, r = null;
                    if (is$1.empty(t) || is$1.string(t) ? r = Array.from(document.querySelectorAll(is$1.string(t) ? t : 'input[type="range"]')) : is$1.element(t) ? r = [
                        t
                    ] : is$1.nodeList(t) ? r = Array.from(t) : is$1.array(t) && (r = t.filter(is$1.element)), is$1.empty(r)) return null;
                    var i = _objectSpread2({}, defaults$1, {}, n);
                    if (is$1.string(t) && i.watch) {
                        var o = new MutationObserver(function(n) {
                            Array.from(n).forEach(function(n) {
                                Array.from(n.addedNodes).forEach(function(n) {
                                    is$1.element(n) && matches$1(n, t) && new e(n, i);
                                });
                            });
                        });
                        o.observe(document.body, {
                            childList: !0,
                            subtree: !0
                        });
                    }
                    return r.map(function(t) {
                        return new e(t, n);
                    });
                }
            },
            {
                key: "enabled",
                get: function() {
                    return "ontouchstart" in document.documentElement;
                }
            }
        ]), e;
    }();
    // ==========================================================================
    // Type checking utils
    // ==========================================================================
    const getConstructor = (input)=>input !== null && typeof input !== 'undefined' ? input.constructor : null;
    const instanceOf = (input, constructor)=>Boolean(input && constructor && input instanceof constructor);
    const isNullOrUndefined = (input)=>input === null || typeof input === 'undefined';
    const isObject = (input)=>getConstructor(input) === Object;
    const isNumber = (input)=>getConstructor(input) === Number && !Number.isNaN(input);
    const isString = (input)=>getConstructor(input) === String;
    const isBoolean = (input)=>getConstructor(input) === Boolean;
    const isFunction = (input)=>typeof input === 'function';
    const isArray = (input)=>Array.isArray(input);
    const isWeakMap = (input)=>instanceOf(input, WeakMap);
    const isNodeList = (input)=>instanceOf(input, NodeList);
    const isTextNode = (input)=>getConstructor(input) === Text;
    const isEvent = (input)=>instanceOf(input, Event);
    const isKeyboardEvent = (input)=>instanceOf(input, KeyboardEvent);
    const isCue = (input)=>instanceOf(input, window.TextTrackCue) || instanceOf(input, window.VTTCue);
    const isTrack = (input)=>instanceOf(input, TextTrack) || !isNullOrUndefined(input) && isString(input.kind);
    const isPromise = (input)=>instanceOf(input, Promise) && isFunction(input.then);
    const isElement = (input)=>input !== null && typeof input === 'object' && input.nodeType === 1 && typeof input.style === 'object' && typeof input.ownerDocument === 'object';
    const isEmpty = (input)=>isNullOrUndefined(input) || (isString(input) || isArray(input) || isNodeList(input)) && !input.length || isObject(input) && !Object.keys(input).length;
    const isUrl = (input)=>{
        // Accept a URL object
        if (instanceOf(input, window.URL)) return true;
        // Must be string from here
        if (!isString(input)) return false;
        // Add the protocol if required
        let string = input;
        if (!input.startsWith('http://') || !input.startsWith('https://')) string = `http://${input}`;
        try {
            return !isEmpty(new URL(string).hostname);
        } catch (_) {
            return false;
        }
    };
    var is = {
        nullOrUndefined: isNullOrUndefined,
        object: isObject,
        number: isNumber,
        string: isString,
        boolean: isBoolean,
        function: isFunction,
        array: isArray,
        weakMap: isWeakMap,
        nodeList: isNodeList,
        element: isElement,
        textNode: isTextNode,
        event: isEvent,
        keyboardEvent: isKeyboardEvent,
        cue: isCue,
        track: isTrack,
        promise: isPromise,
        url: isUrl,
        empty: isEmpty
    };
    // ==========================================================================
    const transitionEndEvent = (()=>{
        const element = document.createElement('span');
        const events = {
            WebkitTransition: 'webkitTransitionEnd',
            MozTransition: 'transitionend',
            OTransition: 'oTransitionEnd otransitionend',
            transition: 'transitionend'
        };
        const type = Object.keys(events).find((event)=>element.style[event] !== undefined);
        return is.string(type) ? events[type] : false;
    })();
    // Force repaint of element
    function repaint(element, delay) {
        setTimeout(()=>{
            try {
                // eslint-disable-next-line no-param-reassign
                element.hidden = true;
                // eslint-disable-next-line no-unused-expressions
                element.offsetHeight;
                // eslint-disable-next-line no-param-reassign
                element.hidden = false;
            } catch (_) {
            // Do nothing
            }
        }, delay);
    }
    // ==========================================================================
    // Browser sniffing
    // Unfortunately, due to mixed support, UA sniffing is required
    // ==========================================================================
    const browser = {
        isIE: Boolean(window.document.documentMode),
        isEdge: /Edge/g.test(navigator.userAgent),
        isWebkit: 'WebkitAppearance' in document.documentElement.style && !/Edge/g.test(navigator.userAgent),
        isIPhone: /iPhone|iPod/gi.test(navigator.userAgent) && navigator.maxTouchPoints > 1,
        isIos: /iPad|iPhone|iPod/gi.test(navigator.userAgent) && navigator.maxTouchPoints > 1
    };
    // ==========================================================================
    // Clone nested objects
    function cloneDeep(object) {
        return JSON.parse(JSON.stringify(object));
    }
    // Get a nested value in an object
    function getDeep(object, path) {
        return path.split('.').reduce((obj, key)=>obj && obj[key], object);
    }
    // Deep extend destination object with N more objects
    function extend(target = {}, ...sources) {
        if (!sources.length) return target;
        const source = sources.shift();
        if (!is.object(source)) return target;
        Object.keys(source).forEach((key)=>{
            if (is.object(source[key])) {
                if (!Object.keys(target).includes(key)) Object.assign(target, {
                    [key]: {}
                });
                extend(target[key], source[key]);
            } else Object.assign(target, {
                [key]: source[key]
            });
        });
        return extend(target, ...sources);
    }
    // ==========================================================================
    // Wrap an element
    function wrap(elements, wrapper) {
        // Convert `elements` to an array, if necessary.
        const targets = elements.length ? elements : [
            elements
        ];
        // Loops backwards to prevent having to clone the wrapper on the
        // first element (see `child` below).
        Array.from(targets).reverse().forEach((element, index)=>{
            const child = index > 0 ? wrapper.cloneNode(true) : wrapper;
            // Cache the current parent and sibling.
            const parent = element.parentNode;
            const sibling = element.nextSibling;
            // Wrap the element (is automatically removed from its current
            // parent).
            child.appendChild(element);
            // If the element had a sibling, insert the wrapper before
            // the sibling to maintain the HTML structure; otherwise, just
            // append it to the parent.
            if (sibling) parent.insertBefore(child, sibling);
            else parent.appendChild(child);
        });
    }
    // Set attributes
    function setAttributes(element, attributes) {
        if (!is.element(element) || is.empty(attributes)) return;
        // Assume null and undefined attributes should be left out,
        // Setting them would otherwise convert them to "null" and "undefined"
        Object.entries(attributes).filter(([, value])=>!is.nullOrUndefined(value)).forEach(([key, value])=>element.setAttribute(key, value));
    }
    // Create a DocumentFragment
    function createElement(type, attributes, text) {
        // Create a new <element>
        const element = document.createElement(type);
        // Set all passed attributes
        if (is.object(attributes)) setAttributes(element, attributes);
        // Add text node
        if (is.string(text)) element.innerText = text;
        // Return built element
        return element;
    }
    // Inaert an element after another
    function insertAfter(element, target) {
        if (!is.element(element) || !is.element(target)) return;
        target.parentNode.insertBefore(element, target.nextSibling);
    }
    // Insert a DocumentFragment
    function insertElement(type, parent, attributes, text) {
        if (!is.element(parent)) return;
        parent.appendChild(createElement(type, attributes, text));
    }
    // Remove element(s)
    function removeElement(element) {
        if (is.nodeList(element) || is.array(element)) {
            Array.from(element).forEach(removeElement);
            return;
        }
        if (!is.element(element) || !is.element(element.parentNode)) return;
        element.parentNode.removeChild(element);
    }
    // Remove all child elements
    function emptyElement(element) {
        if (!is.element(element)) return;
        let { length: length } = element.childNodes;
        while(length > 0){
            element.removeChild(element.lastChild);
            length -= 1;
        }
    }
    // Replace element
    function replaceElement(newChild, oldChild) {
        if (!is.element(oldChild) || !is.element(oldChild.parentNode) || !is.element(newChild)) return null;
        oldChild.parentNode.replaceChild(newChild, oldChild);
        return newChild;
    }
    // Get an attribute object from a string selector
    function getAttributesFromSelector(sel, existingAttributes) {
        // For example:
        // '.test' to { class: 'test' }
        // '#test' to { id: 'test' }
        // '[data-test="test"]' to { 'data-test': 'test' }
        if (!is.string(sel) || is.empty(sel)) return {};
        const attributes = {};
        const existing = extend({}, existingAttributes);
        sel.split(',').forEach((s)=>{
            // Remove whitespace
            const selector = s.trim();
            const className = selector.replace('.', '');
            const stripped = selector.replace(/[[\]]/g, '');
            // Get the parts and value
            const parts = stripped.split('=');
            const [key] = parts;
            const value = parts.length > 1 ? parts[1].replace(/["']/g, '') : '';
            // Get the first character
            const start = selector.charAt(0);
            switch(start){
                case '.':
                    // Add to existing classname
                    if (is.string(existing.class)) attributes.class = `${existing.class} ${className}`;
                    else attributes.class = className;
                    break;
                case '#':
                    // ID selector
                    attributes.id = selector.replace('#', '');
                    break;
                case '[':
                    // Attribute selector
                    attributes[key] = value;
                    break;
            }
        });
        return extend(existing, attributes);
    }
    // Toggle hidden
    function toggleHidden(element, hidden) {
        if (!is.element(element)) return;
        let hide = hidden;
        if (!is.boolean(hide)) hide = !element.hidden;
        // eslint-disable-next-line no-param-reassign
        element.hidden = hide;
    }
    // Mirror Element.classList.toggle, with IE compatibility for "force" argument
    function toggleClass(element, className, force) {
        if (is.nodeList(element)) return Array.from(element).map((e)=>toggleClass(e, className, force));
        if (is.element(element)) {
            let method = 'toggle';
            if (typeof force !== 'undefined') method = force ? 'add' : 'remove';
            element.classList[method](className);
            return element.classList.contains(className);
        }
        return false;
    }
    // Has class name
    function hasClass(element, className) {
        return is.element(element) && element.classList.contains(className);
    }
    // Element matches selector
    function matches(element, selector) {
        const { prototype: prototype } = Element;
        function match() {
            return Array.from(document.querySelectorAll(selector)).includes(this);
        }
        const method = prototype.matches || prototype.webkitMatchesSelector || prototype.mozMatchesSelector || prototype.msMatchesSelector || match;
        return method.call(element, selector);
    }
    // Closest ancestor element matching selector (also tests element itself)
    function closest$1(element, selector) {
        const { prototype: prototype } = Element;
        // https://developer.mozilla.org/en-US/docs/Web/API/Element/closest#Polyfill
        function closestElement() {
            let el = this;
            do {
                if (matches.matches(el, selector)) return el;
                el = el.parentElement || el.parentNode;
            }while (el !== null && el.nodeType === 1);
            return null;
        }
        const method = prototype.closest || closestElement;
        return method.call(element, selector);
    }
    // Find all elements
    function getElements(selector) {
        return this.elements.container.querySelectorAll(selector);
    }
    // Find a single element
    function getElement(selector) {
        return this.elements.container.querySelector(selector);
    }
    // Set focus and tab focus class
    function setFocus(element = null, tabFocus = false) {
        if (!is.element(element)) return;
        // Set regular focus
        element.focus({
            preventScroll: true
        });
        // If we want to mimic keyboard focus via tab
        if (tabFocus) toggleClass(element, this.config.classNames.tabFocus);
    }
    // ==========================================================================
    // Default codecs for checking mimetype support
    const defaultCodecs = {
        'audio/ogg': 'vorbis',
        'audio/wav': '1',
        'video/webm': 'vp8, vorbis',
        'video/mp4': 'avc1.42E01E, mp4a.40.2',
        'video/ogg': 'theora'
    };
    // Check for feature support
    const support = {
        // Basic support
        audio: 'canPlayType' in document.createElement('audio'),
        video: 'canPlayType' in document.createElement('video'),
        // Check for support
        // Basic functionality vs full UI
        check (type, provider, playsinline) {
            const canPlayInline = browser.isIPhone && playsinline && support.playsinline;
            const api = support[type] || provider !== 'html5';
            const ui = api && support.rangeInput && (type !== 'video' || !browser.isIPhone || canPlayInline);
            return {
                api: api,
                ui: ui
            };
        },
        // Picture-in-picture support
        // Safari & Chrome only currently
        pip: (()=>{
            // While iPhone's support picture-in-picture for some apps, seemingly Safari isn't one of them
            // It will throw the following error when trying to enter picture-in-picture
            // `NotSupportedError: The Picture-in-Picture mode is not supported.`
            if (browser.isIPhone) return false;
            // Safari
            // https://developer.apple.com/documentation/webkitjs/adding_picture_in_picture_to_your_safari_media_controls
            if (is.function(createElement('video').webkitSetPresentationMode)) return true;
            // Chrome
            // https://developers.google.com/web/updates/2018/10/watch-video-using-picture-in-picture
            if (document.pictureInPictureEnabled && !createElement('video').disablePictureInPicture) return true;
            return false;
        })(),
        // Airplay support
        // Safari only currently
        airplay: is.function(window.WebKitPlaybackTargetAvailabilityEvent),
        // Inline playback support
        // https://webkit.org/blog/6784/new-video-policies-for-ios/
        playsinline: 'playsInline' in document.createElement('video'),
        // Check for mime type support against a player instance
        // Credits: http://diveintohtml5.info/everything.html
        // Related: http://www.leanbackplayer.com/test/h5mt.html
        mime (input) {
            if (is.empty(input)) return false;
            const [mediaType] = input.split('/');
            let type = input;
            // Verify we're using HTML5 and there's no media type mismatch
            if (!this.isHTML5 || mediaType !== this.type) return false;
            // Add codec if required
            if (Object.keys(defaultCodecs).includes(type)) type += `; codecs="${defaultCodecs[input]}"`;
            try {
                return Boolean(type && this.media.canPlayType(type).replace(/no/, ''));
            } catch (_) {
                return false;
            }
        },
        // Check for textTracks support
        textTracks: 'textTracks' in document.createElement('video'),
        // <input type="range"> Sliders
        rangeInput: (()=>{
            const range = document.createElement('input');
            range.type = 'range';
            return range.type === 'range';
        })(),
        // Touch
        // NOTE: Remember a device can be mouse + touch enabled so we check on first touch event
        touch: 'ontouchstart' in document.documentElement,
        // Detect transitions support
        transitions: transitionEndEvent !== false,
        // Reduced motion iOS & MacOS setting
        // https://webkit.org/blog/7551/responsive-design-for-motion/
        reducedMotion: 'matchMedia' in window && window.matchMedia('(prefers-reduced-motion)').matches
    };
    // ==========================================================================
    // Check for passive event listener support
    // https://github.com/WICG/EventListenerOptions/blob/gh-pages/explainer.md
    // https://www.youtube.com/watch?v=NPM6172J22g
    const supportsPassiveListeners = (()=>{
        // Test via a getter in the options object to see if the passive property is accessed
        let supported = false;
        try {
            const options = Object.defineProperty({}, 'passive', {
                get () {
                    supported = true;
                    return null;
                }
            });
            window.addEventListener('test', null, options);
            window.removeEventListener('test', null, options);
        } catch (_) {
        // Do nothing
        }
        return supported;
    })();
    // Toggle event listener
    function toggleListener(element, event, callback, toggle = false, passive = true, capture = false) {
        // Bail if no element, event, or callback
        if (!element || !('addEventListener' in element) || is.empty(event) || !is.function(callback)) return;
        // Allow multiple events
        const events = event.split(' ');
        // Build options
        // Default to just the capture boolean for browsers with no passive listener support
        let options = capture;
        // If passive events listeners are supported
        if (supportsPassiveListeners) options = {
            passive: // Whether the listener can be passive (i.e. default never prevented)
            passive,
            capture: // Whether the listener is a capturing listener or not
            capture
        };
        // If a single node is passed, bind the event listener
        events.forEach((type)=>{
            if (this && this.eventListeners && toggle) // Cache event listener
            this.eventListeners.push({
                element: element,
                type: type,
                callback: callback,
                options: options
            });
            element[toggle ? 'addEventListener' : 'removeEventListener'](type, callback, options);
        });
    }
    // Bind event handler
    function on(element, events = '', callback, passive = true, capture = false) {
        toggleListener.call(this, element, events, callback, true, passive, capture);
    }
    // Unbind event handler
    function off(element, events = '', callback, passive = true, capture = false) {
        toggleListener.call(this, element, events, callback, false, passive, capture);
    }
    // Bind once-only event handler
    function once(element, events = '', callback, passive = true, capture = false) {
        const onceCallback = (...args)=>{
            off(element, events, onceCallback, passive, capture);
            callback.apply(this, args);
        };
        toggleListener.call(this, element, events, onceCallback, true, passive, capture);
    }
    // Trigger event
    function triggerEvent(element, type = '', bubbles = false, detail = {}) {
        // Bail if no element
        if (!is.element(element) || is.empty(type)) return;
        // Create and dispatch the event
        const event = new CustomEvent(type, {
            bubbles: bubbles,
            detail: {
                ...detail,
                plyr: this
            }
        });
        // Dispatch the event
        element.dispatchEvent(event);
    }
    // Unbind all cached event listeners
    function unbindListeners() {
        if (this && this.eventListeners) {
            this.eventListeners.forEach((item)=>{
                const { element: element, type: type, callback: callback, options: options } = item;
                element.removeEventListener(type, callback, options);
            });
            this.eventListeners = [];
        }
    }
    // Run method when / if player is ready
    function ready() {
        return new Promise((resolve)=>this.ready ? setTimeout(resolve, 0) : on.call(this, this.elements.container, 'ready', resolve)).then(()=>{});
    }
    /**
   * Silence a Promise-like object.
   * This is useful for avoiding non-harmful, but potentially confusing "uncaught
   * play promise" rejection error messages.
   * @param  {Object} value An object that may or may not be `Promise`-like.
   */ function silencePromise(value) {
        if (is.promise(value)) value.then(null, ()=>{});
    }
    // ==========================================================================
    // Remove duplicates in an array
    function dedupe(array) {
        if (!is.array(array)) return array;
        return array.filter((item, index)=>array.indexOf(item) === index);
    }
    // Get the closest value in an array
    function closest(array, value) {
        if (!is.array(array) || !array.length) return null;
        return array.reduce((prev, curr)=>Math.abs(curr - value) < Math.abs(prev - value) ? curr : prev);
    }
    // ==========================================================================
    // Check support for a CSS declaration
    function supportsCSS(declaration) {
        if (!window || !window.CSS) return false;
        return window.CSS.supports(declaration);
    }
    // Standard/common aspect ratios
    const standardRatios = [
        [
            1,
            1
        ],
        [
            4,
            3
        ],
        [
            3,
            4
        ],
        [
            5,
            4
        ],
        [
            4,
            5
        ],
        [
            3,
            2
        ],
        [
            2,
            3
        ],
        [
            16,
            10
        ],
        [
            10,
            16
        ],
        [
            16,
            9
        ],
        [
            9,
            16
        ],
        [
            21,
            9
        ],
        [
            9,
            21
        ],
        [
            32,
            9
        ],
        [
            9,
            32
        ]
    ].reduce((out, [x, y])=>({
            ...out,
            [x / y]: [
                x,
                y
            ]
        }), {});
    // Validate an aspect ratio
    function validateAspectRatio(input) {
        if (!is.array(input) && (!is.string(input) || !input.includes(':'))) return false;
        const ratio = is.array(input) ? input : input.split(':');
        return ratio.map(Number).every(is.number);
    }
    // Reduce an aspect ratio to it's lowest form
    function reduceAspectRatio(ratio) {
        if (!is.array(ratio) || !ratio.every(is.number)) return null;
        const [width, height] = ratio;
        const getDivider = (w, h)=>h === 0 ? w : getDivider(h, w % h);
        const divider = getDivider(width, height);
        return [
            width / divider,
            height / divider
        ];
    }
    // Calculate an aspect ratio
    function getAspectRatio(input) {
        const parse = (ratio)=>validateAspectRatio(ratio) ? ratio.split(':').map(Number) : null;
        // Try provided ratio
        let ratio = parse(input);
        // Get from config
        if (ratio === null) ratio = parse(this.config.ratio);
        // Get from embed
        if (ratio === null && !is.empty(this.embed) && is.array(this.embed.ratio)) ({ ratio: ratio } = this.embed);
        // Get from HTML5 video
        if (ratio === null && this.isHTML5) {
            const { videoWidth: videoWidth, videoHeight: videoHeight } = this.media;
            ratio = [
                videoWidth,
                videoHeight
            ];
        }
        return reduceAspectRatio(ratio);
    }
    // Set aspect ratio for responsive container
    function setAspectRatio(input) {
        if (!this.isVideo) return {};
        const { wrapper: wrapper } = this.elements;
        const ratio = getAspectRatio.call(this, input);
        if (!is.array(ratio)) return {};
        const [x, y] = reduceAspectRatio(ratio);
        const useNative = supportsCSS(`aspect-ratio: ${x}/${y}`);
        const padding = 100 / x * y;
        if (useNative) wrapper.style.aspectRatio = `${x}/${y}`;
        else wrapper.style.paddingBottom = `${padding}%`;
        // For Vimeo we have an extra <div> to hide the standard controls and UI
        if (this.isVimeo && !this.config.vimeo.premium && this.supported.ui) {
            const height = 100 / this.media.offsetWidth * parseInt(window.getComputedStyle(this.media).paddingBottom, 10);
            const offset = (height - padding) / (height / 50);
            if (this.fullscreen.active) wrapper.style.paddingBottom = null;
            else this.media.style.transform = `translateY(-${offset}%)`;
        } else if (this.isHTML5) wrapper.classList.add(this.config.classNames.videoFixedRatio);
        return {
            padding: padding,
            ratio: ratio
        };
    }
    // Round an aspect ratio to closest standard ratio
    function roundAspectRatio(x, y, tolerance = 0.05) {
        const ratio = x / y;
        const closestRatio = closest(Object.keys(standardRatios), ratio);
        // Check match is within tolerance
        if (Math.abs(closestRatio - ratio) <= tolerance) return standardRatios[closestRatio];
        // No match
        return [
            x,
            y
        ];
    }
    // Get the size of the viewport
    // https://stackoverflow.com/questions/1248081/how-to-get-the-browser-viewport-dimensions
    function getViewportSize() {
        const width = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0);
        const height = Math.max(document.documentElement.clientHeight || 0, window.innerHeight || 0);
        return [
            width,
            height
        ];
    }
    // ==========================================================================
    const html5 = {
        getSources () {
            if (!this.isHTML5) return [];
            const sources = Array.from(this.media.querySelectorAll('source'));
            // Filter out unsupported sources (if type is specified)
            return sources.filter((source)=>{
                const type = source.getAttribute('type');
                if (is.empty(type)) return true;
                return support.mime.call(this, type);
            });
        },
        // Get quality levels
        getQualityOptions () {
            // Whether we're forcing all options (e.g. for streaming)
            if (this.config.quality.forced) return this.config.quality.options;
            // Get sizes from <source> elements
            return html5.getSources.call(this).map((source)=>Number(source.getAttribute('size'))).filter(Boolean);
        },
        setup () {
            if (!this.isHTML5) return;
            const player = this;
            // Set speed options from config
            player.options.speed = player.config.speed.options;
            // Set aspect ratio if fixed
            if (!is.empty(this.config.ratio)) setAspectRatio.call(player);
            // Quality
            Object.defineProperty(player.media, 'quality', {
                get () {
                    // Get sources
                    const sources = html5.getSources.call(player);
                    const source = sources.find((s)=>s.getAttribute('src') === player.source);
                    // Return size, if match is found
                    return source && Number(source.getAttribute('size'));
                },
                set (input) {
                    if (player.quality === input) return;
                    // If we're using an external handler...
                    if (player.config.quality.forced && is.function(player.config.quality.onChange)) player.config.quality.onChange(input);
                    else {
                        // Get sources
                        const sources = html5.getSources.call(player);
                        // Get first match for requested size
                        const source = sources.find((s)=>Number(s.getAttribute('size')) === input);
                        // No matching source found
                        if (!source) return;
                        // Get current state
                        const { currentTime: currentTime, paused: paused, preload: preload, readyState: readyState, playbackRate: playbackRate } = player.media;
                        // Set new source
                        player.media.src = source.getAttribute('src');
                        // Prevent loading if preload="none" and the current source isn't loaded (#1044)
                        if (preload !== 'none' || readyState) {
                            // Restore time
                            player.once('loadedmetadata', ()=>{
                                player.speed = playbackRate;
                                player.currentTime = currentTime;
                                // Resume playing
                                if (!paused) silencePromise(player.play());
                            });
                            // Load new source
                            player.media.load();
                        }
                    }
                    // Trigger change event
                    triggerEvent.call(player, player.media, 'qualitychange', false, {
                        quality: input
                    });
                }
            });
        },
        // Cancel current network requests
        // See https://github.com/sampotts/plyr/issues/174
        cancelRequests () {
            if (!this.isHTML5) return;
            // Remove child sources
            removeElement(html5.getSources.call(this));
            // Set blank video src attribute
            // This is to prevent a MEDIA_ERR_SRC_NOT_SUPPORTED error
            // Info: http://stackoverflow.com/questions/32231579/how-to-properly-dispose-of-an-html5-video-and-close-socket-or-connection
            this.media.setAttribute('src', this.config.blankVideo);
            // Load the new empty source
            // This will cancel existing requests
            // See https://github.com/sampotts/plyr/issues/174
            this.media.load();
            // Debugging
            this.debug.log('Cancelled network requests');
        }
    };
    // ==========================================================================
    // Generate a random ID
    function generateId(prefix) {
        return `${prefix}-${Math.floor(Math.random() * 10000)}`;
    }
    // Format string
    function format(input, ...args) {
        if (is.empty(input)) return input;
        return input.toString().replace(/{(\d+)}/g, (match, i)=>args[i].toString());
    }
    // Get percentage
    function getPercentage(current, max) {
        if (current === 0 || max === 0 || Number.isNaN(current) || Number.isNaN(max)) return 0;
        return (current / max * 100).toFixed(2);
    }
    // Replace all occurrences of a string in a string
    const replaceAll = (input = '', find = '', replace = '')=>input.replace(new RegExp(find.toString().replace(/([.*+?^=!:${}()|[\]/\\])/g, '\\$1'), 'g'), replace.toString());
    // Convert to title case
    const toTitleCase = (input = '')=>input.toString().replace(/\w\S*/g, (text)=>text.charAt(0).toUpperCase() + text.slice(1).toLowerCase());
    // Convert string to pascalCase
    function toPascalCase(input = '') {
        let string = input.toString();
        // Convert kebab case
        string = replaceAll(string, '-', ' ');
        // Convert snake case
        string = replaceAll(string, '_', ' ');
        // Convert to title case
        string = toTitleCase(string);
        // Convert to pascal case
        return replaceAll(string, ' ', '');
    }
    // Convert string to pascalCase
    function toCamelCase(input = '') {
        let string = input.toString();
        // Convert to pascal case
        string = toPascalCase(string);
        // Convert first character to lowercase
        return string.charAt(0).toLowerCase() + string.slice(1);
    }
    // Remove HTML from a string
    function stripHTML(source) {
        const fragment = document.createDocumentFragment();
        const element = document.createElement('div');
        fragment.appendChild(element);
        element.innerHTML = source;
        return fragment.firstChild.innerText;
    }
    // Like outerHTML, but also works for DocumentFragment
    function getHTML(element) {
        const wrapper = document.createElement('div');
        wrapper.appendChild(element);
        return wrapper.innerHTML;
    }
    // ==========================================================================
    // Skip i18n for abbreviations and brand names
    const resources = {
        pip: 'PIP',
        airplay: 'AirPlay',
        html5: 'HTML5',
        vimeo: 'Vimeo',
        youtube: 'YouTube'
    };
    const i18n = {
        get (key = '', config = {}) {
            if (is.empty(key) || is.empty(config)) return '';
            let string = getDeep(config.i18n, key);
            if (is.empty(string)) {
                if (Object.keys(resources).includes(key)) return resources[key];
                return '';
            }
            const replace = {
                '{seektime}': config.seekTime,
                '{title}': config.title
            };
            Object.entries(replace).forEach(([k, v])=>{
                string = replaceAll(string, k, v);
            });
            return string;
        }
    };
    class Storage {
        constructor(player){
            _defineProperty$1(this, "get", (key)=>{
                if (!Storage.supported || !this.enabled) return null;
                const store = window.localStorage.getItem(this.key);
                if (is.empty(store)) return null;
                const json = JSON.parse(store);
                return is.string(key) && key.length ? json[key] : json;
            });
            _defineProperty$1(this, "set", (object)=>{
                // Bail if we don't have localStorage support or it's disabled
                if (!Storage.supported || !this.enabled) return;
                // Can only store objectst
                if (!is.object(object)) return;
                // Get current storage
                let storage = this.get();
                // Default to empty object
                if (is.empty(storage)) storage = {};
                // Update the working copy of the values
                extend(storage, object);
                // Update storage
                try {
                    window.localStorage.setItem(this.key, JSON.stringify(storage));
                } catch (_) {
                // Do nothing
                }
            });
            this.enabled = player.config.storage.enabled;
            this.key = player.config.storage.key;
        }
        // Check for actual support (see if we can use it)
        static get supported() {
            try {
                if (!('localStorage' in window)) return false;
                const test = '___test';
                // Try to use it (it might be disabled, e.g. user is in private mode)
                // see: https://github.com/sampotts/plyr/issues/131
                window.localStorage.setItem(test, test);
                window.localStorage.removeItem(test);
                return true;
            } catch (_) {
                return false;
            }
        }
    }
    // ==========================================================================
    // Fetch wrapper
    // Using XHR to avoid issues with older browsers
    // ==========================================================================
    function fetch(url, responseType = 'text') {
        return new Promise((resolve, reject)=>{
            try {
                const request = new XMLHttpRequest();
                // Check for CORS support
                if (!('withCredentials' in request)) return;
                request.addEventListener('load', ()=>{
                    if (responseType === 'text') try {
                        resolve(JSON.parse(request.responseText));
                    } catch (_) {
                        resolve(request.responseText);
                    }
                    else resolve(request.response);
                });
                request.addEventListener('error', ()=>{
                    throw new Error(request.status);
                });
                request.open('GET', url, true);
                // Set the required response type
                request.responseType = responseType;
                request.send();
            } catch (error) {
                reject(error);
            }
        });
    }
    // ==========================================================================
    // Load an external SVG sprite
    function loadSprite(url, id) {
        if (!is.string(url)) return;
        const prefix = 'cache';
        const hasId = is.string(id);
        let isCached = false;
        const exists = ()=>document.getElementById(id) !== null;
        const update = (container, data)=>{
            // eslint-disable-next-line no-param-reassign
            container.innerHTML = data;
            // Check again incase of race condition
            if (hasId && exists()) return;
            // Inject the SVG to the body
            document.body.insertAdjacentElement('afterbegin', container);
        };
        // Only load once if ID set
        if (!hasId || !exists()) {
            const useStorage = Storage.supported;
            // Create container
            const container = document.createElement('div');
            container.setAttribute('hidden', '');
            if (hasId) container.setAttribute('id', id);
            // Check in cache
            if (useStorage) {
                const cached = window.localStorage.getItem(`${prefix}-${id}`);
                isCached = cached !== null;
                if (isCached) {
                    const data = JSON.parse(cached);
                    update(container, data.content);
                }
            }
            // Get the sprite
            fetch(url).then((result)=>{
                if (is.empty(result)) return;
                if (useStorage) try {
                    window.localStorage.setItem(`${prefix}-${id}`, JSON.stringify({
                        content: result
                    }));
                } catch (_) {
                // Do nothing
                }
                update(container, result);
            }).catch(()=>{});
        }
    }
    // ==========================================================================
    // Time helpers
    const getHours = (value)=>Math.trunc(value / 60 / 60 % 60, 10);
    const getMinutes = (value)=>Math.trunc(value / 60 % 60, 10);
    const getSeconds = (value)=>Math.trunc(value % 60, 10);
    // Format time to UI friendly string
    function formatTime(time = 0, displayHours = false, inverted = false) {
        // Bail if the value isn't a number
        if (!is.number(time)) return formatTime(undefined, displayHours, inverted);
        // Format time component to add leading zero
        const format = (value)=>`0${value}`.slice(-2);
        // Breakdown to hours, mins, secs
        let hours = getHours(time);
        const mins = getMinutes(time);
        const secs = getSeconds(time);
        // Do we need to display hours?
        if (displayHours || hours > 0) hours = `${hours}:`;
        else hours = '';
        // Render
        return `${inverted && time > 0 ? '-' : ''}${hours}${format(mins)}:${format(secs)}`;
    }
    // ==========================================================================
    // TODO: Don't export a massive object - break down and create class
    const controls = {
        // Get icon URL
        getIconUrl () {
            const url = new URL(this.config.iconUrl, window.location);
            const host = window.location.host ? window.location.host : window.top.location.host;
            const cors = url.host !== host || browser.isIE && !window.svg4everybody;
            return {
                url: this.config.iconUrl,
                cors: cors
            };
        },
        // Find the UI controls
        findElements () {
            try {
                this.elements.controls = getElement.call(this, this.config.selectors.controls.wrapper);
                // Buttons
                this.elements.buttons = {
                    play: getElements.call(this, this.config.selectors.buttons.play),
                    pause: getElement.call(this, this.config.selectors.buttons.pause),
                    restart: getElement.call(this, this.config.selectors.buttons.restart),
                    rewind: getElement.call(this, this.config.selectors.buttons.rewind),
                    fastForward: getElement.call(this, this.config.selectors.buttons.fastForward),
                    mute: getElement.call(this, this.config.selectors.buttons.mute),
                    pip: getElement.call(this, this.config.selectors.buttons.pip),
                    airplay: getElement.call(this, this.config.selectors.buttons.airplay),
                    settings: getElement.call(this, this.config.selectors.buttons.settings),
                    captions: getElement.call(this, this.config.selectors.buttons.captions),
                    fullscreen: getElement.call(this, this.config.selectors.buttons.fullscreen)
                };
                // Progress
                this.elements.progress = getElement.call(this, this.config.selectors.progress);
                // Inputs
                this.elements.inputs = {
                    seek: getElement.call(this, this.config.selectors.inputs.seek),
                    volume: getElement.call(this, this.config.selectors.inputs.volume)
                };
                // Display
                this.elements.display = {
                    buffer: getElement.call(this, this.config.selectors.display.buffer),
                    currentTime: getElement.call(this, this.config.selectors.display.currentTime),
                    duration: getElement.call(this, this.config.selectors.display.duration)
                };
                // Seek tooltip
                if (is.element(this.elements.progress)) this.elements.display.seekTooltip = this.elements.progress.querySelector(`.${this.config.classNames.tooltip}`);
                return true;
            } catch (error) {
                // Log it
                this.debug.warn('It looks like there is a problem with your custom controls HTML', error);
                // Restore native video controls
                this.toggleNativeControls(true);
                return false;
            }
        },
        // Create <svg> icon
        createIcon (type, attributes) {
            const namespace = 'http://www.w3.org/2000/svg';
            const iconUrl = controls.getIconUrl.call(this);
            const iconPath = `${!iconUrl.cors ? iconUrl.url : ''}#${this.config.iconPrefix}`;
            // Create <svg>
            const icon = document.createElementNS(namespace, 'svg');
            setAttributes(icon, extend(attributes, {
                'aria-hidden': 'true',
                focusable: 'false'
            }));
            // Create the <use> to reference sprite
            const use = document.createElementNS(namespace, 'use');
            const path = `${iconPath}-${type}`;
            // Set `href` attributes
            // https://github.com/sampotts/plyr/issues/460
            // https://developer.mozilla.org/en-US/docs/Web/SVG/Attribute/xlink:href
            if ('href' in use) use.setAttributeNS('http://www.w3.org/1999/xlink', 'href', path);
            // Always set the older attribute even though it's "deprecated" (it'll be around for ages)
            use.setAttributeNS('http://www.w3.org/1999/xlink', 'xlink:href', path);
            // Add <use> to <svg>
            icon.appendChild(use);
            return icon;
        },
        // Create hidden text label
        createLabel (key, attr = {}) {
            const text = i18n.get(key, this.config);
            const attributes = {
                ...attr,
                class: [
                    attr.class,
                    this.config.classNames.hidden
                ].filter(Boolean).join(' ')
            };
            return createElement('span', attributes, text);
        },
        // Create a badge
        createBadge (text) {
            if (is.empty(text)) return null;
            const badge = createElement('span', {
                class: this.config.classNames.menu.value
            });
            badge.appendChild(createElement('span', {
                class: this.config.classNames.menu.badge
            }, text));
            return badge;
        },
        // Create a <button>
        createButton (buttonType, attr) {
            const attributes = extend({}, attr);
            let type = toCamelCase(buttonType);
            const props = {
                element: 'button',
                toggle: false,
                label: null,
                icon: null,
                labelPressed: null,
                iconPressed: null
            };
            [
                'element',
                'icon',
                'label'
            ].forEach((key)=>{
                if (Object.keys(attributes).includes(key)) {
                    props[key] = attributes[key];
                    delete attributes[key];
                }
            });
            // Default to 'button' type to prevent form submission
            if (props.element === 'button' && !Object.keys(attributes).includes('type')) attributes.type = 'button';
            // Set class name
            if (Object.keys(attributes).includes('class')) {
                if (!attributes.class.split(' ').some((c)=>c === this.config.classNames.control)) extend(attributes, {
                    class: `${attributes.class} ${this.config.classNames.control}`
                });
            } else attributes.class = this.config.classNames.control;
            // Large play button
            switch(buttonType){
                case 'play':
                    props.toggle = true;
                    props.label = 'play';
                    props.labelPressed = 'pause';
                    props.icon = 'play';
                    props.iconPressed = 'pause';
                    break;
                case 'mute':
                    props.toggle = true;
                    props.label = 'mute';
                    props.labelPressed = 'unmute';
                    props.icon = 'volume';
                    props.iconPressed = 'muted';
                    break;
                case 'captions':
                    props.toggle = true;
                    props.label = 'enableCaptions';
                    props.labelPressed = 'disableCaptions';
                    props.icon = 'captions-off';
                    props.iconPressed = 'captions-on';
                    break;
                case 'fullscreen':
                    props.toggle = true;
                    props.label = 'enterFullscreen';
                    props.labelPressed = 'exitFullscreen';
                    props.icon = 'enter-fullscreen';
                    props.iconPressed = 'exit-fullscreen';
                    break;
                case 'play-large':
                    attributes.class += ` ${this.config.classNames.control}--overlaid`;
                    type = 'play';
                    props.label = 'play';
                    props.icon = 'play';
                    break;
                default:
                    if (is.empty(props.label)) props.label = type;
                    if (is.empty(props.icon)) props.icon = buttonType;
            }
            const button = createElement(props.element);
            // Setup toggle icon and labels
            if (props.toggle) {
                // Icon
                button.appendChild(controls.createIcon.call(this, props.iconPressed, {
                    class: 'icon--pressed'
                }));
                button.appendChild(controls.createIcon.call(this, props.icon, {
                    class: 'icon--not-pressed'
                }));
                // Label/Tooltip
                button.appendChild(controls.createLabel.call(this, props.labelPressed, {
                    class: 'label--pressed'
                }));
                button.appendChild(controls.createLabel.call(this, props.label, {
                    class: 'label--not-pressed'
                }));
            } else {
                button.appendChild(controls.createIcon.call(this, props.icon));
                button.appendChild(controls.createLabel.call(this, props.label));
            }
            // Merge and set attributes
            extend(attributes, getAttributesFromSelector(this.config.selectors.buttons[type], attributes));
            setAttributes(button, attributes);
            // We have multiple play buttons
            if (type === 'play') {
                if (!is.array(this.elements.buttons[type])) this.elements.buttons[type] = [];
                this.elements.buttons[type].push(button);
            } else this.elements.buttons[type] = button;
            return button;
        },
        // Create an <input type='range'>
        createRange (type, attributes) {
            // Seek input
            const input = createElement('input', extend(getAttributesFromSelector(this.config.selectors.inputs[type]), {
                type: 'range',
                min: 0,
                max: 100,
                step: 0.01,
                value: 0,
                autocomplete: 'off',
                // A11y fixes for https://github.com/sampotts/plyr/issues/905
                role: 'slider',
                'aria-label': i18n.get(type, this.config),
                'aria-valuemin': 0,
                'aria-valuemax': 100,
                'aria-valuenow': 0
            }, attributes));
            this.elements.inputs[type] = input;
            // Set the fill for webkit now
            controls.updateRangeFill.call(this, input);
            // Improve support on touch devices
            RangeTouch.setup(input);
            return input;
        },
        // Create a <progress>
        createProgress (type, attributes) {
            const progress = createElement('progress', extend(getAttributesFromSelector(this.config.selectors.display[type]), {
                min: 0,
                max: 100,
                value: 0,
                role: 'progressbar',
                'aria-hidden': true
            }, attributes));
            // Create the label inside
            if (type !== 'volume') {
                progress.appendChild(createElement('span', null, '0'));
                const suffixKey = {
                    played: 'played',
                    buffer: 'buffered'
                }[type];
                const suffix = suffixKey ? i18n.get(suffixKey, this.config) : '';
                progress.innerText = `% ${suffix.toLowerCase()}`;
            }
            this.elements.display[type] = progress;
            return progress;
        },
        // Create time display
        createTime (type, attrs) {
            const attributes = getAttributesFromSelector(this.config.selectors.display[type], attrs);
            const container = createElement('div', extend(attributes, {
                class: `${attributes.class ? attributes.class : ''} ${this.config.classNames.display.time} `.trim(),
                'aria-label': i18n.get(type, this.config)
            }), '00:00');
            // Reference for updates
            this.elements.display[type] = container;
            return container;
        },
        // Bind keyboard shortcuts for a menu item
        // We have to bind to keyup otherwise Firefox triggers a click when a keydown event handler shifts focus
        // https://bugzilla.mozilla.org/show_bug.cgi?id=1220143
        bindMenuItemShortcuts (menuItem, type) {
            // Navigate through menus via arrow keys and space
            on.call(this, menuItem, 'keydown keyup', (event)=>{
                // We only care about space and ⬆️ ⬇️️ ➡️
                if (![
                    'Space',
                    'ArrowUp',
                    'ArrowDown',
                    'ArrowRight'
                ].includes(event.key)) return;
                // Prevent play / seek
                event.preventDefault();
                event.stopPropagation();
                // We're just here to prevent the keydown bubbling
                if (event.type === 'keydown') return;
                const isRadioButton = matches(menuItem, '[role="menuitemradio"]');
                // Show the respective menu
                if (!isRadioButton && [
                    'Space',
                    'ArrowRight'
                ].includes(event.key)) controls.showMenuPanel.call(this, type, true);
                else {
                    let target;
                    if (event.key !== 'Space') {
                        if (event.key === 'ArrowDown' || isRadioButton && event.key === 'ArrowRight') {
                            target = menuItem.nextElementSibling;
                            if (!is.element(target)) target = menuItem.parentNode.firstElementChild;
                        } else {
                            target = menuItem.previousElementSibling;
                            if (!is.element(target)) target = menuItem.parentNode.lastElementChild;
                        }
                        setFocus.call(this, target, true);
                    }
                }
            }, false);
            // Enter will fire a `click` event but we still need to manage focus
            // So we bind to keyup which fires after and set focus here
            on.call(this, menuItem, 'keyup', (event)=>{
                if (event.key !== 'Return') return;
                controls.focusFirstMenuItem.call(this, null, true);
            });
        },
        // Create a settings menu item
        createMenuItem ({ value: value, list: list, type: type, title: title, badge: badge = null, checked: checked = false }) {
            const attributes = getAttributesFromSelector(this.config.selectors.inputs[type]);
            const menuItem = createElement('button', extend(attributes, {
                type: 'button',
                role: 'menuitemradio',
                class: `${this.config.classNames.control} ${attributes.class ? attributes.class : ''}`.trim(),
                'aria-checked': checked,
                value: value
            }));
            const flex = createElement('span');
            // We have to set as HTML incase of special characters
            flex.innerHTML = title;
            if (is.element(badge)) flex.appendChild(badge);
            menuItem.appendChild(flex);
            // Replicate radio button behavior
            Object.defineProperty(menuItem, 'checked', {
                enumerable: true,
                get () {
                    return menuItem.getAttribute('aria-checked') === 'true';
                },
                set (check) {
                    // Ensure exclusivity
                    if (check) Array.from(menuItem.parentNode.children).filter((node)=>matches(node, '[role="menuitemradio"]')).forEach((node)=>node.setAttribute('aria-checked', 'false'));
                    menuItem.setAttribute('aria-checked', check ? 'true' : 'false');
                }
            });
            this.listeners.bind(menuItem, 'click keyup', (event)=>{
                if (is.keyboardEvent(event) && event.key !== 'Space') return;
                event.preventDefault();
                event.stopPropagation();
                menuItem.checked = true;
                switch(type){
                    case 'language':
                        this.currentTrack = Number(value);
                        break;
                    case 'quality':
                        this.quality = value;
                        break;
                    case 'speed':
                        this.speed = parseFloat(value);
                        break;
                }
                controls.showMenuPanel.call(this, 'home', is.keyboardEvent(event));
            }, type, false);
            controls.bindMenuItemShortcuts.call(this, menuItem, type);
            list.appendChild(menuItem);
        },
        // Format a time for display
        formatTime (time = 0, inverted = false) {
            // Bail if the value isn't a number
            if (!is.number(time)) return time;
            // Always display hours if duration is over an hour
            const forceHours = getHours(this.duration) > 0;
            return formatTime(time, forceHours, inverted);
        },
        // Update the displayed time
        updateTimeDisplay (target = null, time = 0, inverted = false) {
            // Bail if there's no element to display or the value isn't a number
            if (!is.element(target) || !is.number(time)) return;
            // eslint-disable-next-line no-param-reassign
            target.innerText = controls.formatTime(time, inverted);
        },
        // Update volume UI and storage
        updateVolume () {
            if (!this.supported.ui) return;
            // Update range
            if (is.element(this.elements.inputs.volume)) controls.setRange.call(this, this.elements.inputs.volume, this.muted ? 0 : this.volume);
            // Update mute state
            if (is.element(this.elements.buttons.mute)) this.elements.buttons.mute.pressed = this.muted || this.volume === 0;
        },
        // Update seek value and lower fill
        setRange (target, value = 0) {
            if (!is.element(target)) return;
            // eslint-disable-next-line
            target.value = value;
            // Webkit range fill
            controls.updateRangeFill.call(this, target);
        },
        // Update <progress> elements
        updateProgress (event) {
            if (!this.supported.ui || !is.event(event)) return;
            let value = 0;
            const setProgress = (target, input)=>{
                const val = is.number(input) ? input : 0;
                const progress = is.element(target) ? target : this.elements.display.buffer;
                // Update value and label
                if (is.element(progress)) {
                    progress.value = val;
                    // Update text label inside
                    const label = progress.getElementsByTagName('span')[0];
                    if (is.element(label)) label.childNodes[0].nodeValue = val;
                }
            };
            if (event) switch(event.type){
                // Video playing
                case 'timeupdate':
                case 'seeking':
                case 'seeked':
                    value = getPercentage(this.currentTime, this.duration);
                    // Set seek range value only if it's a 'natural' time event
                    if (event.type === 'timeupdate') controls.setRange.call(this, this.elements.inputs.seek, value);
                    break;
                // Check buffer status
                case 'playing':
                case 'progress':
                    setProgress(this.elements.display.buffer, this.buffered * 100);
                    break;
            }
        },
        // Webkit polyfill for lower fill range
        updateRangeFill (target) {
            // Get range from event if event passed
            const range = is.event(target) ? target.target : target;
            // Needs to be a valid <input type='range'>
            if (!is.element(range) || range.getAttribute('type') !== 'range') return;
            // Set aria values for https://github.com/sampotts/plyr/issues/905
            if (matches(range, this.config.selectors.inputs.seek)) {
                range.setAttribute('aria-valuenow', this.currentTime);
                const currentTime = controls.formatTime(this.currentTime);
                const duration = controls.formatTime(this.duration);
                const format = i18n.get('seekLabel', this.config);
                range.setAttribute('aria-valuetext', format.replace('{currentTime}', currentTime).replace('{duration}', duration));
            } else if (matches(range, this.config.selectors.inputs.volume)) {
                const percent = range.value * 100;
                range.setAttribute('aria-valuenow', percent);
                range.setAttribute('aria-valuetext', `${percent.toFixed(1)}%`);
            } else range.setAttribute('aria-valuenow', range.value);
            // WebKit only
            if (!browser.isWebkit) return;
            // Set CSS custom property
            range.style.setProperty('--value', `${range.value / range.max * 100}%`);
        },
        // Update hover tooltip for seeking
        updateSeekTooltip (event) {
            var _this$config$markers, _this$config$markers$;
            // Bail if setting not true
            if (!this.config.tooltips.seek || !is.element(this.elements.inputs.seek) || !is.element(this.elements.display.seekTooltip) || this.duration === 0) return;
            const tipElement = this.elements.display.seekTooltip;
            const visible = `${this.config.classNames.tooltip}--visible`;
            const toggle = (show)=>toggleClass(tipElement, visible, show);
            // Hide on touch
            if (this.touch) {
                toggle(false);
                return;
            }
            // Determine percentage, if already visible
            let percent = 0;
            const clientRect = this.elements.progress.getBoundingClientRect();
            if (is.event(event)) percent = 100 / clientRect.width * (event.pageX - clientRect.left);
            else if (hasClass(tipElement, visible)) percent = parseFloat(tipElement.style.left, 10);
            else return;
            // Set bounds
            if (percent < 0) percent = 0;
            else if (percent > 100) percent = 100;
            const time = this.duration / 100 * percent;
            // Display the time a click would seek to
            tipElement.innerText = controls.formatTime(time);
            // Get marker point for time
            const point = (_this$config$markers = this.config.markers) === null || _this$config$markers === void 0 ? void 0 : (_this$config$markers$ = _this$config$markers.points) === null || _this$config$markers$ === void 0 ? void 0 : _this$config$markers$.find(({ time: t })=>t === Math.round(time));
            // Append the point label to the tooltip
            if (point) tipElement.insertAdjacentHTML('afterbegin', `${point.label}<br>`);
            // Set position
            tipElement.style.left = `${percent}%`;
            // Show/hide the tooltip
            // If the event is a moues in/out and percentage is inside bounds
            if (is.event(event) && [
                'mouseenter',
                'mouseleave'
            ].includes(event.type)) toggle(event.type === 'mouseenter');
        },
        // Handle time change event
        timeUpdate (event) {
            // Only invert if only one time element is displayed and used for both duration and currentTime
            const invert = !is.element(this.elements.display.duration) && this.config.invertTime;
            // Duration
            controls.updateTimeDisplay.call(this, this.elements.display.currentTime, invert ? this.duration - this.currentTime : this.currentTime, invert);
            // Ignore updates while seeking
            if (event && event.type === 'timeupdate' && this.media.seeking) return;
            // Playing progress
            controls.updateProgress.call(this, event);
        },
        // Show the duration on metadataloaded or durationchange events
        durationUpdate () {
            // Bail if no UI or durationchange event triggered after playing/seek when invertTime is false
            if (!this.supported.ui || !this.config.invertTime && this.currentTime) return;
            // If duration is the 2**32 (shaka), Infinity (HLS), DASH-IF (Number.MAX_SAFE_INTEGER || Number.MAX_VALUE) indicating live we hide the currentTime and progressbar.
            // https://github.com/video-dev/hls.js/blob/5820d29d3c4c8a46e8b75f1e3afa3e68c1a9a2db/src/controller/buffer-controller.js#L415
            // https://github.com/google/shaka-player/blob/4d889054631f4e1cf0fbd80ddd2b71887c02e232/lib/media/streaming_engine.js#L1062
            // https://github.com/Dash-Industry-Forum/dash.js/blob/69859f51b969645b234666800d4cb596d89c602d/src/dash/models/DashManifestModel.js#L338
            if (this.duration >= 2 ** 32) {
                toggleHidden(this.elements.display.currentTime, true);
                toggleHidden(this.elements.progress, true);
                return;
            }
            // Update ARIA values
            if (is.element(this.elements.inputs.seek)) this.elements.inputs.seek.setAttribute('aria-valuemax', this.duration);
            // If there's a spot to display duration
            const hasDuration = is.element(this.elements.display.duration);
            // If there's only one time display, display duration there
            if (!hasDuration && this.config.displayDuration && this.paused) controls.updateTimeDisplay.call(this, this.elements.display.currentTime, this.duration);
            // If there's a duration element, update content
            if (hasDuration) controls.updateTimeDisplay.call(this, this.elements.display.duration, this.duration);
            if (this.config.markers.enabled) controls.setMarkers.call(this);
            // Update the tooltip (if visible)
            controls.updateSeekTooltip.call(this);
        },
        // Hide/show a tab
        toggleMenuButton (setting, toggle) {
            toggleHidden(this.elements.settings.buttons[setting], !toggle);
        },
        // Update the selected setting
        updateSetting (setting, container, input) {
            const pane = this.elements.settings.panels[setting];
            let value = null;
            let list = container;
            if (setting === 'captions') value = this.currentTrack;
            else {
                value = !is.empty(input) ? input : this[setting];
                // Get default
                if (is.empty(value)) value = this.config[setting].default;
                // Unsupported value
                if (!is.empty(this.options[setting]) && !this.options[setting].includes(value)) {
                    this.debug.warn(`Unsupported value of '${value}' for ${setting}`);
                    return;
                }
                // Disabled value
                if (!this.config[setting].options.includes(value)) {
                    this.debug.warn(`Disabled value of '${value}' for ${setting}`);
                    return;
                }
            }
            // Get the list if we need to
            if (!is.element(list)) list = pane && pane.querySelector('[role="menu"]');
            // If there's no list it means it's not been rendered...
            if (!is.element(list)) return;
            // Update the label
            const label = this.elements.settings.buttons[setting].querySelector(`.${this.config.classNames.menu.value}`);
            label.innerHTML = controls.getLabel.call(this, setting, value);
            // Find the radio option and check it
            const target = list && list.querySelector(`[value="${value}"]`);
            if (is.element(target)) target.checked = true;
        },
        // Translate a value into a nice label
        getLabel (setting, value) {
            switch(setting){
                case 'speed':
                    return value === 1 ? i18n.get('normal', this.config) : `${value}&times;`;
                case 'quality':
                    if (is.number(value)) {
                        const label = i18n.get(`qualityLabel.${value}`, this.config);
                        if (!label.length) return `${value}p`;
                        return label;
                    }
                    return toTitleCase(value);
                case 'captions':
                    return captions.getLabel.call(this);
                default:
                    return null;
            }
        },
        // Set the quality menu
        setQualityMenu (options) {
            // Menu required
            if (!is.element(this.elements.settings.panels.quality)) return;
            const type = 'quality';
            const list = this.elements.settings.panels.quality.querySelector('[role="menu"]');
            // Set options if passed and filter based on uniqueness and config
            if (is.array(options)) this.options.quality = dedupe(options).filter((quality)=>this.config.quality.options.includes(quality));
            // Toggle the pane and tab
            const toggle = !is.empty(this.options.quality) && this.options.quality.length > 1;
            controls.toggleMenuButton.call(this, type, toggle);
            // Empty the menu
            emptyElement(list);
            // Check if we need to toggle the parent
            controls.checkMenu.call(this);
            // If we're hiding, nothing more to do
            if (!toggle) return;
            // Get the badge HTML for HD, 4K etc
            const getBadge = (quality)=>{
                const label = i18n.get(`qualityBadge.${quality}`, this.config);
                if (!label.length) return null;
                return controls.createBadge.call(this, label);
            };
            // Sort options by the config and then render options
            this.options.quality.sort((a, b)=>{
                const sorting = this.config.quality.options;
                return sorting.indexOf(a) > sorting.indexOf(b) ? 1 : -1;
            }).forEach((quality)=>{
                controls.createMenuItem.call(this, {
                    value: quality,
                    list: list,
                    type: type,
                    title: controls.getLabel.call(this, 'quality', quality),
                    badge: getBadge(quality)
                });
            });
            controls.updateSetting.call(this, type, list);
        },
        // Set the looping options
        /* setLoopMenu() {
          // Menu required
          if (!is.element(this.elements.settings.panels.loop)) {
              return;
          }
           const options = ['start', 'end', 'all', 'reset'];
          const list = this.elements.settings.panels.loop.querySelector('[role="menu"]');
           // Show the pane and tab
          toggleHidden(this.elements.settings.buttons.loop, false);
          toggleHidden(this.elements.settings.panels.loop, false);
           // Toggle the pane and tab
          const toggle = !is.empty(this.loop.options);
          controls.toggleMenuButton.call(this, 'loop', toggle);
           // Empty the menu
          emptyElement(list);
           options.forEach(option => {
              const item = createElement('li');
               const button = createElement(
                  'button',
                  extend(getAttributesFromSelector(this.config.selectors.buttons.loop), {
                      type: 'button',
                      class: this.config.classNames.control,
                      'data-plyr-loop-action': option,
                  }),
                  i18n.get(option, this.config)
              );
               if (['start', 'end'].includes(option)) {
                  const badge = controls.createBadge.call(this, '00:00');
                  button.appendChild(badge);
              }
               item.appendChild(button);
              list.appendChild(item);
          });
      }, */ // Get current selected caption language
        // TODO: rework this to user the getter in the API?
        // Set a list of available captions languages
        setCaptionsMenu () {
            // Menu required
            if (!is.element(this.elements.settings.panels.captions)) return;
            // TODO: Captions or language? Currently it's mixed
            const type = 'captions';
            const list = this.elements.settings.panels.captions.querySelector('[role="menu"]');
            const tracks = captions.getTracks.call(this);
            const toggle = Boolean(tracks.length);
            // Toggle the pane and tab
            controls.toggleMenuButton.call(this, type, toggle);
            // Empty the menu
            emptyElement(list);
            // Check if we need to toggle the parent
            controls.checkMenu.call(this);
            // If there's no captions, bail
            if (!toggle) return;
            // Generate options data
            const options = tracks.map((track, value)=>({
                    value: value,
                    checked: this.captions.toggled && this.currentTrack === value,
                    title: captions.getLabel.call(this, track),
                    badge: track.language && controls.createBadge.call(this, track.language.toUpperCase()),
                    list: list,
                    type: 'language'
                }));
            // Add the "Disabled" option to turn off captions
            options.unshift({
                value: -1,
                checked: !this.captions.toggled,
                title: i18n.get('disabled', this.config),
                list: list,
                type: 'language'
            });
            // Generate options
            options.forEach(controls.createMenuItem.bind(this));
            controls.updateSetting.call(this, type, list);
        },
        // Set a list of available captions languages
        setSpeedMenu () {
            // Menu required
            if (!is.element(this.elements.settings.panels.speed)) return;
            const type = 'speed';
            const list = this.elements.settings.panels.speed.querySelector('[role="menu"]');
            // Filter out invalid speeds
            this.options.speed = this.options.speed.filter((o)=>o >= this.minimumSpeed && o <= this.maximumSpeed);
            // Toggle the pane and tab
            const toggle = !is.empty(this.options.speed) && this.options.speed.length > 1;
            controls.toggleMenuButton.call(this, type, toggle);
            // Empty the menu
            emptyElement(list);
            // Check if we need to toggle the parent
            controls.checkMenu.call(this);
            // If we're hiding, nothing more to do
            if (!toggle) return;
            // Create items
            this.options.speed.forEach((speed)=>{
                controls.createMenuItem.call(this, {
                    value: speed,
                    list: list,
                    type: type,
                    title: controls.getLabel.call(this, 'speed', speed)
                });
            });
            controls.updateSetting.call(this, type, list);
        },
        // Check if we need to hide/show the settings menu
        checkMenu () {
            const { buttons: buttons } = this.elements.settings;
            const visible = !is.empty(buttons) && Object.values(buttons).some((button)=>!button.hidden);
            toggleHidden(this.elements.settings.menu, !visible);
        },
        // Focus the first menu item in a given (or visible) menu
        focusFirstMenuItem (pane, tabFocus = false) {
            if (this.elements.settings.popup.hidden) return;
            let target = pane;
            if (!is.element(target)) target = Object.values(this.elements.settings.panels).find((p)=>!p.hidden);
            const firstItem = target.querySelector('[role^="menuitem"]');
            setFocus.call(this, firstItem, tabFocus);
        },
        // Show/hide menu
        toggleMenu (input) {
            const { popup: popup } = this.elements.settings;
            const button = this.elements.buttons.settings;
            // Menu and button are required
            if (!is.element(popup) || !is.element(button)) return;
            // True toggle by default
            const { hidden: hidden } = popup;
            let show = hidden;
            if (is.boolean(input)) show = input;
            else if (is.keyboardEvent(input) && input.key === 'Escape') show = false;
            else if (is.event(input)) {
                // If Plyr is in a shadowDOM, the event target is set to the component, instead of the
                // Element in the shadowDOM. The path, if available, is complete.
                const target = is.function(input.composedPath) ? input.composedPath()[0] : input.target;
                const isMenuItem = popup.contains(target);
                // If the click was inside the menu or if the click
                // wasn't the button or menu item and we're trying to
                // show the menu (a doc click shouldn't show the menu)
                if (isMenuItem || !isMenuItem && input.target !== button && show) return;
            }
            // Set button attributes
            button.setAttribute('aria-expanded', show);
            // Show the actual popup
            toggleHidden(popup, !show);
            // Add class hook
            toggleClass(this.elements.container, this.config.classNames.menu.open, show);
            // Focus the first item if key interaction
            if (show && is.keyboardEvent(input)) controls.focusFirstMenuItem.call(this, null, true);
            else if (!show && !hidden) // If closing, re-focus the button
            setFocus.call(this, button, is.keyboardEvent(input));
        },
        // Get the natural size of a menu panel
        getMenuSize (tab) {
            const clone = tab.cloneNode(true);
            clone.style.position = 'absolute';
            clone.style.opacity = 0;
            clone.removeAttribute('hidden');
            // Append to parent so we get the "real" size
            tab.parentNode.appendChild(clone);
            // Get the sizes before we remove
            const width = clone.scrollWidth;
            const height = clone.scrollHeight;
            // Remove from the DOM
            removeElement(clone);
            return {
                width: width,
                height: height
            };
        },
        // Show a panel in the menu
        showMenuPanel (type = '', tabFocus = false) {
            const target = this.elements.container.querySelector(`#plyr-settings-${this.id}-${type}`);
            // Nothing to show, bail
            if (!is.element(target)) return;
            // Hide all other panels
            const container = target.parentNode;
            const current = Array.from(container.children).find((node)=>!node.hidden);
            // If we can do fancy animations, we'll animate the height/width
            if (support.transitions && !support.reducedMotion) {
                // Set the current width as a base
                container.style.width = `${current.scrollWidth}px`;
                container.style.height = `${current.scrollHeight}px`;
                // Get potential sizes
                const size = controls.getMenuSize.call(this, target);
                // Restore auto height/width
                const restore = (event)=>{
                    // We're only bothered about height and width on the container
                    if (event.target !== container || ![
                        'width',
                        'height'
                    ].includes(event.propertyName)) return;
                    // Revert back to auto
                    container.style.width = '';
                    container.style.height = '';
                    // Only listen once
                    off.call(this, container, transitionEndEvent, restore);
                };
                // Listen for the transition finishing and restore auto height/width
                on.call(this, container, transitionEndEvent, restore);
                // Set dimensions to target
                container.style.width = `${size.width}px`;
                container.style.height = `${size.height}px`;
            }
            // Set attributes on current tab
            toggleHidden(current, true);
            // Set attributes on target
            toggleHidden(target, false);
            // Focus the first item
            controls.focusFirstMenuItem.call(this, target, tabFocus);
        },
        // Set the download URL
        setDownloadUrl () {
            const button = this.elements.buttons.download;
            // Bail if no button
            if (!is.element(button)) return;
            // Set attribute
            button.setAttribute('href', this.download);
        },
        // Build the default HTML
        create (data) {
            const { bindMenuItemShortcuts: bindMenuItemShortcuts, createButton: createButton, createProgress: createProgress, createRange: createRange, createTime: createTime, setQualityMenu: setQualityMenu, setSpeedMenu: setSpeedMenu, showMenuPanel: showMenuPanel } = controls;
            this.elements.controls = null;
            // Larger overlaid play button
            if (is.array(this.config.controls) && this.config.controls.includes('play-large')) this.elements.container.appendChild(createButton.call(this, 'play-large'));
            // Create the container
            const container = createElement('div', getAttributesFromSelector(this.config.selectors.controls.wrapper));
            this.elements.controls = container;
            // Default item attributes
            const defaultAttributes = {
                class: 'plyr__controls__item'
            };
            // Loop through controls in order
            dedupe(is.array(this.config.controls) ? this.config.controls : []).forEach((control)=>{
                // Restart button
                if (control === 'restart') container.appendChild(createButton.call(this, 'restart', defaultAttributes));
                // Rewind button
                if (control === 'rewind') container.appendChild(createButton.call(this, 'rewind', defaultAttributes));
                // Play/Pause button
                if (control === 'play') container.appendChild(createButton.call(this, 'play', defaultAttributes));
                // Fast forward button
                if (control === 'fast-forward') container.appendChild(createButton.call(this, 'fast-forward', defaultAttributes));
                // Progress
                if (control === 'progress') {
                    const progressContainer = createElement('div', {
                        class: `${defaultAttributes.class} plyr__progress__container`
                    });
                    const progress = createElement('div', getAttributesFromSelector(this.config.selectors.progress));
                    // Seek range slider
                    progress.appendChild(createRange.call(this, 'seek', {
                        id: `plyr-seek-${data.id}`
                    }));
                    // Buffer progress
                    progress.appendChild(createProgress.call(this, 'buffer'));
                    // TODO: Add loop display indicator
                    // Seek tooltip
                    if (this.config.tooltips.seek) {
                        const tooltip = createElement('span', {
                            class: this.config.classNames.tooltip
                        }, '00:00');
                        progress.appendChild(tooltip);
                        this.elements.display.seekTooltip = tooltip;
                    }
                    this.elements.progress = progress;
                    progressContainer.appendChild(this.elements.progress);
                    container.appendChild(progressContainer);
                }
                // Media current time display
                if (control === 'current-time') container.appendChild(createTime.call(this, 'currentTime', defaultAttributes));
                // Media duration display
                if (control === 'duration') container.appendChild(createTime.call(this, 'duration', defaultAttributes));
                // Volume controls
                if (control === 'mute' || control === 'volume') {
                    let { volume: volume } = this.elements;
                    // Create the volume container if needed
                    if (!is.element(volume) || !container.contains(volume)) {
                        volume = createElement('div', extend({}, defaultAttributes, {
                            class: `${defaultAttributes.class} plyr__volume`.trim()
                        }));
                        this.elements.volume = volume;
                        container.appendChild(volume);
                    }
                    // Toggle mute button
                    if (control === 'mute') volume.appendChild(createButton.call(this, 'mute'));
                    // Volume range control
                    // Ignored on iOS as it's handled globally
                    // https://developer.apple.com/library/safari/documentation/AudioVideo/Conceptual/Using_HTML5_Audio_Video/Device-SpecificConsiderations/Device-SpecificConsiderations.html
                    if (control === 'volume' && !browser.isIos) {
                        // Set the attributes
                        const attributes = {
                            max: 1,
                            step: 0.05,
                            value: this.config.volume
                        };
                        // Create the volume range slider
                        volume.appendChild(createRange.call(this, 'volume', extend(attributes, {
                            id: `plyr-volume-${data.id}`
                        })));
                    }
                }
                // Toggle captions button
                if (control === 'captions') container.appendChild(createButton.call(this, 'captions', defaultAttributes));
                // Settings button / menu
                if (control === 'settings' && !is.empty(this.config.settings)) {
                    const wrapper = createElement('div', extend({}, defaultAttributes, {
                        class: `${defaultAttributes.class} plyr__menu`.trim(),
                        hidden: ''
                    }));
                    wrapper.appendChild(createButton.call(this, 'settings', {
                        'aria-haspopup': true,
                        'aria-controls': `plyr-settings-${data.id}`,
                        'aria-expanded': false
                    }));
                    const popup = createElement('div', {
                        class: 'plyr__menu__container',
                        id: `plyr-settings-${data.id}`,
                        hidden: ''
                    });
                    const inner = createElement('div');
                    const home = createElement('div', {
                        id: `plyr-settings-${data.id}-home`
                    });
                    // Create the menu
                    const menu = createElement('div', {
                        role: 'menu'
                    });
                    home.appendChild(menu);
                    inner.appendChild(home);
                    this.elements.settings.panels.home = home;
                    // Build the menu items
                    this.config.settings.forEach((type)=>{
                        // TODO: bundle this with the createMenuItem helper and bindings
                        const menuItem = createElement('button', extend(getAttributesFromSelector(this.config.selectors.buttons.settings), {
                            type: 'button',
                            class: `${this.config.classNames.control} ${this.config.classNames.control}--forward`,
                            role: 'menuitem',
                            'aria-haspopup': true,
                            hidden: ''
                        }));
                        // Bind menu shortcuts for keyboard users
                        bindMenuItemShortcuts.call(this, menuItem, type);
                        // Show menu on click
                        on.call(this, menuItem, 'click', ()=>{
                            showMenuPanel.call(this, type, false);
                        });
                        const flex = createElement('span', null, i18n.get(type, this.config));
                        const value = createElement('span', {
                            class: this.config.classNames.menu.value
                        });
                        // Speed contains HTML entities
                        value.innerHTML = data[type];
                        flex.appendChild(value);
                        menuItem.appendChild(flex);
                        menu.appendChild(menuItem);
                        // Build the panes
                        const pane = createElement('div', {
                            id: `plyr-settings-${data.id}-${type}`,
                            hidden: ''
                        });
                        // Back button
                        const backButton = createElement('button', {
                            type: 'button',
                            class: `${this.config.classNames.control} ${this.config.classNames.control}--back`
                        });
                        // Visible label
                        backButton.appendChild(createElement('span', {
                            'aria-hidden': true
                        }, i18n.get(type, this.config)));
                        // Screen reader label
                        backButton.appendChild(createElement('span', {
                            class: this.config.classNames.hidden
                        }, i18n.get('menuBack', this.config)));
                        // Go back via keyboard
                        on.call(this, pane, 'keydown', (event)=>{
                            if (event.key !== 'ArrowLeft') return;
                            // Prevent seek
                            event.preventDefault();
                            event.stopPropagation();
                            // Show the respective menu
                            showMenuPanel.call(this, 'home', true);
                        }, false);
                        // Go back via button click
                        on.call(this, backButton, 'click', ()=>{
                            showMenuPanel.call(this, 'home', false);
                        });
                        // Add to pane
                        pane.appendChild(backButton);
                        // Menu
                        pane.appendChild(createElement('div', {
                            role: 'menu'
                        }));
                        inner.appendChild(pane);
                        this.elements.settings.buttons[type] = menuItem;
                        this.elements.settings.panels[type] = pane;
                    });
                    popup.appendChild(inner);
                    wrapper.appendChild(popup);
                    container.appendChild(wrapper);
                    this.elements.settings.popup = popup;
                    this.elements.settings.menu = wrapper;
                }
                // Picture in picture button
                if (control === 'pip' && support.pip) container.appendChild(createButton.call(this, 'pip', defaultAttributes));
                // Airplay button
                if (control === 'airplay' && support.airplay) container.appendChild(createButton.call(this, 'airplay', defaultAttributes));
                // Download button
                if (control === 'download') {
                    const attributes = extend({}, defaultAttributes, {
                        element: 'a',
                        href: this.download,
                        target: '_blank'
                    });
                    // Set download attribute for HTML5 only
                    if (this.isHTML5) attributes.download = '';
                    const { download: download } = this.config.urls;
                    if (!is.url(download) && this.isEmbed) extend(attributes, {
                        icon: `logo-${this.provider}`,
                        label: this.provider
                    });
                    container.appendChild(createButton.call(this, 'download', attributes));
                }
                // Toggle fullscreen button
                if (control === 'fullscreen') container.appendChild(createButton.call(this, 'fullscreen', defaultAttributes));
            });
            // Set available quality levels
            if (this.isHTML5) setQualityMenu.call(this, html5.getQualityOptions.call(this));
            setSpeedMenu.call(this);
            return container;
        },
        // Insert controls
        inject () {
            // Sprite
            if (this.config.loadSprite) {
                const icon = controls.getIconUrl.call(this);
                // Only load external sprite using AJAX
                if (icon.cors) loadSprite(icon.url, 'sprite-plyr');
            }
            // Create a unique ID
            this.id = Math.floor(Math.random() * 10000);
            // Null by default
            let container = null;
            this.elements.controls = null;
            // Set template properties
            const props = {
                id: this.id,
                seektime: this.config.seekTime,
                title: this.config.title
            };
            let update = true;
            // If function, run it and use output
            if (is.function(this.config.controls)) this.config.controls = this.config.controls.call(this, props);
            // Convert falsy controls to empty array (primarily for empty strings)
            if (!this.config.controls) this.config.controls = [];
            if (is.element(this.config.controls) || is.string(this.config.controls)) // HTMLElement or Non-empty string passed as the option
            container = this.config.controls;
            else {
                // Create controls
                container = controls.create.call(this, {
                    id: this.id,
                    seektime: this.config.seekTime,
                    speed: this.speed,
                    quality: this.quality,
                    captions: captions.getLabel.call(this)
                });
                update = false;
            }
            // Replace props with their value
            const replace = (input)=>{
                let result = input;
                Object.entries(props).forEach(([key, value])=>{
                    result = replaceAll(result, `{${key}}`, value);
                });
                return result;
            };
            // Update markup
            if (update) {
                if (is.string(this.config.controls)) container = replace(container);
            }
            // Controls container
            let target;
            // Inject to custom location
            if (is.string(this.config.selectors.controls.container)) target = document.querySelector(this.config.selectors.controls.container);
            // Inject into the container by default
            if (!is.element(target)) target = this.elements.container;
            // Inject controls HTML (needs to be before captions, hence "afterbegin")
            const insertMethod = is.element(container) ? 'insertAdjacentElement' : 'insertAdjacentHTML';
            target[insertMethod]('afterbegin', container);
            // Find the elements if need be
            if (!is.element(this.elements.controls)) controls.findElements.call(this);
            // Add pressed property to buttons
            if (!is.empty(this.elements.buttons)) {
                const addProperty = (button)=>{
                    const className = this.config.classNames.controlPressed;
                    button.setAttribute('aria-pressed', 'false');
                    Object.defineProperty(button, 'pressed', {
                        configurable: true,
                        enumerable: true,
                        get () {
                            return hasClass(button, className);
                        },
                        set (pressed = false) {
                            toggleClass(button, className, pressed);
                            button.setAttribute('aria-pressed', pressed ? 'true' : 'false');
                        }
                    });
                };
                // Toggle classname when pressed property is set
                Object.values(this.elements.buttons).filter(Boolean).forEach((button)=>{
                    if (is.array(button) || is.nodeList(button)) Array.from(button).filter(Boolean).forEach(addProperty);
                    else addProperty(button);
                });
            }
            // Edge sometimes doesn't finish the paint so force a repaint
            if (browser.isEdge) repaint(target);
            // Setup tooltips
            if (this.config.tooltips.controls) {
                const { classNames: classNames, selectors: selectors } = this.config;
                const selector = `${selectors.controls.wrapper} ${selectors.labels} .${classNames.hidden}`;
                const labels = getElements.call(this, selector);
                Array.from(labels).forEach((label)=>{
                    toggleClass(label, this.config.classNames.hidden, false);
                    toggleClass(label, this.config.classNames.tooltip, true);
                });
            }
        },
        // Set media metadata
        setMediaMetadata () {
            try {
                if ('mediaSession' in navigator) navigator.mediaSession.metadata = new window.MediaMetadata({
                    title: this.config.mediaMetadata.title,
                    artist: this.config.mediaMetadata.artist,
                    album: this.config.mediaMetadata.album,
                    artwork: this.config.mediaMetadata.artwork
                });
            } catch (_) {
            // Do nothing
            }
        },
        // Add markers
        setMarkers () {
            var _this$config$markers2, _this$config$markers3;
            if (!this.duration || this.elements.markers) return;
            // Get valid points
            const points = (_this$config$markers2 = this.config.markers) === null || _this$config$markers2 === void 0 ? void 0 : (_this$config$markers3 = _this$config$markers2.points) === null || _this$config$markers3 === void 0 ? void 0 : _this$config$markers3.filter(({ time: time })=>time > 0 && time < this.duration);
            if (!(points !== null && points !== void 0 && points.length)) return;
            const containerFragment = document.createDocumentFragment();
            const pointsFragment = document.createDocumentFragment();
            let tipElement = null;
            const tipVisible = `${this.config.classNames.tooltip}--visible`;
            const toggleTip = (show)=>toggleClass(tipElement, tipVisible, show);
            // Inject markers to progress container
            points.forEach((point)=>{
                const markerElement = createElement('span', {
                    class: this.config.classNames.marker
                }, '');
                const left = `${point.time / this.duration * 100}%`;
                if (tipElement) {
                    // Show on hover
                    markerElement.addEventListener('mouseenter', ()=>{
                        if (point.label) return;
                        tipElement.style.left = left;
                        tipElement.innerHTML = point.label;
                        toggleTip(true);
                    });
                    // Hide on leave
                    markerElement.addEventListener('mouseleave', ()=>{
                        toggleTip(false);
                    });
                }
                markerElement.addEventListener('click', ()=>{
                    this.currentTime = point.time;
                });
                markerElement.style.left = left;
                pointsFragment.appendChild(markerElement);
            });
            containerFragment.appendChild(pointsFragment);
            // Inject a tooltip if needed
            if (!this.config.tooltips.seek) {
                tipElement = createElement('span', {
                    class: this.config.classNames.tooltip
                }, '');
                containerFragment.appendChild(tipElement);
            }
            this.elements.markers = {
                points: pointsFragment,
                tip: tipElement
            };
            this.elements.progress.appendChild(containerFragment);
        }
    };
    // ==========================================================================
    /**
   * Parse a string to a URL object
   * @param {String} input - the URL to be parsed
   * @param {Boolean} safe - failsafe parsing
   */ function parseUrl(input, safe = true) {
        let url = input;
        if (safe) {
            const parser = document.createElement('a');
            parser.href = url;
            url = parser.href;
        }
        try {
            return new URL(url);
        } catch (_) {
            return null;
        }
    }
    // Convert object to URLSearchParams
    function buildUrlParams(input) {
        const params = new URLSearchParams();
        if (is.object(input)) Object.entries(input).forEach(([key, value])=>{
            params.set(key, value);
        });
        return params;
    }
    // ==========================================================================
    const captions = {
        // Setup captions
        setup () {
            // Requires UI support
            if (!this.supported.ui) return;
            // Only Vimeo and HTML5 video supported at this point
            if (!this.isVideo || this.isYouTube || this.isHTML5 && !support.textTracks) {
                // Clear menu and hide
                if (is.array(this.config.controls) && this.config.controls.includes('settings') && this.config.settings.includes('captions')) controls.setCaptionsMenu.call(this);
                return;
            }
            // Inject the container
            if (!is.element(this.elements.captions)) {
                this.elements.captions = createElement('div', getAttributesFromSelector(this.config.selectors.captions));
                this.elements.captions.setAttribute('dir', 'auto');
                insertAfter(this.elements.captions, this.elements.wrapper);
            }
            // Fix IE captions if CORS is used
            // Fetch captions and inject as blobs instead (data URIs not supported!)
            if (browser.isIE && window.URL) {
                const elements = this.media.querySelectorAll('track');
                Array.from(elements).forEach((track)=>{
                    const src = track.getAttribute('src');
                    const url = parseUrl(src);
                    if (url !== null && url.hostname !== window.location.href.hostname && [
                        'http:',
                        'https:'
                    ].includes(url.protocol)) fetch(src, 'blob').then((blob)=>{
                        track.setAttribute('src', window.URL.createObjectURL(blob));
                    }).catch(()=>{
                        removeElement(track);
                    });
                });
            }
            // Get and set initial data
            // The "preferred" options are not realized unless / until the wanted language has a match
            // * languages: Array of user's browser languages.
            // * language:  The language preferred by user settings or config
            // * active:    The state preferred by user settings or config
            // * toggled:   The real captions state
            const browserLanguages = navigator.languages || [
                navigator.language || navigator.userLanguage || 'en'
            ];
            const languages = dedupe(browserLanguages.map((language)=>language.split('-')[0]));
            let language = (this.storage.get('language') || this.config.captions.language || 'auto').toLowerCase();
            // Use first browser language when language is 'auto'
            if (language === 'auto') [language] = languages;
            let active = this.storage.get('captions');
            if (!is.boolean(active)) ({ active: active } = this.config.captions);
            Object.assign(this.captions, {
                toggled: false,
                active: active,
                language: language,
                languages: languages
            });
            // Watch changes to textTracks and update captions menu
            if (this.isHTML5) {
                const trackEvents = this.config.captions.update ? 'addtrack removetrack' : 'removetrack';
                on.call(this, this.media.textTracks, trackEvents, captions.update.bind(this));
            }
            // Update available languages in list next tick (the event must not be triggered before the listeners)
            setTimeout(captions.update.bind(this), 0);
        },
        // Update available language options in settings based on tracks
        update () {
            const tracks = captions.getTracks.call(this, true);
            // Get the wanted language
            const { active: active, language: language, meta: meta, currentTrackNode: currentTrackNode } = this.captions;
            const languageExists = Boolean(tracks.find((track)=>track.language === language));
            // Handle tracks (add event listener and "pseudo"-default)
            if (this.isHTML5 && this.isVideo) tracks.filter((track)=>!meta.get(track)).forEach((track)=>{
                this.debug.log('Track added', track);
                // Attempt to store if the original dom element was "default"
                meta.set(track, {
                    default: track.mode === 'showing'
                });
                // Turn off native caption rendering to avoid double captions
                // Note: mode='hidden' forces a track to download. To ensure every track
                // isn't downloaded at once, only 'showing' tracks should be reassigned
                // eslint-disable-next-line no-param-reassign
                if (track.mode === 'showing') // eslint-disable-next-line no-param-reassign
                track.mode = 'hidden';
                // Add event listener for cue changes
                on.call(this, track, 'cuechange', ()=>captions.updateCues.call(this));
            });
            // Update language first time it matches, or if the previous matching track was removed
            if (languageExists && this.language !== language || !tracks.includes(currentTrackNode)) {
                captions.setLanguage.call(this, language);
                captions.toggle.call(this, active && languageExists);
            }
            // Enable or disable captions based on track length
            if (this.elements) toggleClass(this.elements.container, this.config.classNames.captions.enabled, !is.empty(tracks));
            // Update available languages in list
            if (is.array(this.config.controls) && this.config.controls.includes('settings') && this.config.settings.includes('captions')) controls.setCaptionsMenu.call(this);
        },
        // Toggle captions display
        // Used internally for the toggleCaptions method, with the passive option forced to false
        toggle (input, passive = true) {
            // If there's no full support
            if (!this.supported.ui) return;
            const { toggled: toggled } = this.captions; // Current state
            const activeClass = this.config.classNames.captions.active;
            // Get the next state
            // If the method is called without parameter, toggle based on current value
            const active = is.nullOrUndefined(input) ? !toggled : input;
            // Update state and trigger event
            if (active !== toggled) {
                // When passive, don't override user preferences
                if (!passive) {
                    this.captions.active = active;
                    this.storage.set({
                        captions: active
                    });
                }
                // Force language if the call isn't passive and there is no matching language to toggle to
                if (!this.language && active && !passive) {
                    const tracks = captions.getTracks.call(this);
                    const track = captions.findTrack.call(this, [
                        this.captions.language,
                        ...this.captions.languages
                    ], true);
                    // Override user preferences to avoid switching languages if a matching track is added
                    this.captions.language = track.language;
                    // Set caption, but don't store in localStorage as user preference
                    captions.set.call(this, tracks.indexOf(track));
                    return;
                }
                // Toggle button if it's enabled
                if (this.elements.buttons.captions) this.elements.buttons.captions.pressed = active;
                // Add class hook
                toggleClass(this.elements.container, activeClass, active);
                this.captions.toggled = active;
                // Update settings menu
                controls.updateSetting.call(this, 'captions');
                // Trigger event (not used internally)
                triggerEvent.call(this, this.media, active ? 'captionsenabled' : 'captionsdisabled');
            }
            // Wait for the call stack to clear before setting mode='hidden'
            // on the active track - forcing the browser to download it
            setTimeout(()=>{
                if (active && this.captions.toggled) this.captions.currentTrackNode.mode = 'hidden';
            });
        },
        // Set captions by track index
        // Used internally for the currentTrack setter with the passive option forced to false
        set (index, passive = true) {
            const tracks = captions.getTracks.call(this);
            // Disable captions if setting to -1
            if (index === -1) {
                captions.toggle.call(this, false, passive);
                return;
            }
            if (!is.number(index)) {
                this.debug.warn('Invalid caption argument', index);
                return;
            }
            if (!(index in tracks)) {
                this.debug.warn('Track not found', index);
                return;
            }
            if (this.captions.currentTrack !== index) {
                this.captions.currentTrack = index;
                const track = tracks[index];
                const { language: language } = track || {};
                // Store reference to node for invalidation on remove
                this.captions.currentTrackNode = track;
                // Update settings menu
                controls.updateSetting.call(this, 'captions');
                // When passive, don't override user preferences
                if (!passive) {
                    this.captions.language = language;
                    this.storage.set({
                        language: language
                    });
                }
                // Handle Vimeo captions
                if (this.isVimeo) this.embed.enableTextTrack(language);
                // Trigger event
                triggerEvent.call(this, this.media, 'languagechange');
            }
            // Show captions
            captions.toggle.call(this, true, passive);
            if (this.isHTML5 && this.isVideo) // If we change the active track while a cue is already displayed we need to update it
            captions.updateCues.call(this);
        },
        // Set captions by language
        // Used internally for the language setter with the passive option forced to false
        setLanguage (input, passive = true) {
            if (!is.string(input)) {
                this.debug.warn('Invalid language argument', input);
                return;
            }
            // Normalize
            const language = input.toLowerCase();
            this.captions.language = language;
            // Set currentTrack
            const tracks = captions.getTracks.call(this);
            const track = captions.findTrack.call(this, [
                language
            ]);
            captions.set.call(this, tracks.indexOf(track), passive);
        },
        // Get current valid caption tracks
        // If update is false it will also ignore tracks without metadata
        // This is used to "freeze" the language options when captions.update is false
        getTracks (update = false) {
            // Handle media or textTracks missing or null
            const tracks = Array.from((this.media || {}).textTracks || []);
            // For HTML5, use cache instead of current tracks when it exists (if captions.update is false)
            // Filter out removed tracks and tracks that aren't captions/subtitles (for example metadata)
            return tracks.filter((track)=>!this.isHTML5 || update || this.captions.meta.has(track)).filter((track)=>[
                    'captions',
                    'subtitles'
                ].includes(track.kind));
        },
        // Match tracks based on languages and get the first
        findTrack (languages, force = false) {
            const tracks = captions.getTracks.call(this);
            const sortIsDefault = (track)=>Number((this.captions.meta.get(track) || {}).default);
            const sorted = Array.from(tracks).sort((a, b)=>sortIsDefault(b) - sortIsDefault(a));
            let track;
            languages.every((language)=>{
                track = sorted.find((t)=>t.language === language);
                return !track; // Break iteration if there is a match
            });
            // If no match is found but is required, get first
            return track || (force ? sorted[0] : undefined);
        },
        // Get the current track
        getCurrentTrack () {
            return captions.getTracks.call(this)[this.currentTrack];
        },
        // Get UI label for track
        getLabel (track) {
            let currentTrack = track;
            if (!is.track(currentTrack) && support.textTracks && this.captions.toggled) currentTrack = captions.getCurrentTrack.call(this);
            if (is.track(currentTrack)) {
                if (!is.empty(currentTrack.label)) return currentTrack.label;
                if (!is.empty(currentTrack.language)) return track.language.toUpperCase();
                return i18n.get('enabled', this.config);
            }
            return i18n.get('disabled', this.config);
        },
        // Update captions using current track's active cues
        // Also optional array argument in case there isn't any track (ex: vimeo)
        updateCues (input) {
            // Requires UI
            if (!this.supported.ui) return;
            if (!is.element(this.elements.captions)) {
                this.debug.warn('No captions element to render to');
                return;
            }
            // Only accept array or empty input
            if (!is.nullOrUndefined(input) && !Array.isArray(input)) {
                this.debug.warn('updateCues: Invalid input', input);
                return;
            }
            let cues = input;
            // Get cues from track
            if (!cues) {
                const track = captions.getCurrentTrack.call(this);
                cues = Array.from((track || {}).activeCues || []).map((cue)=>cue.getCueAsHTML()).map(getHTML);
            }
            // Set new caption text
            const content = cues.map((cueText)=>cueText.trim()).join('\n');
            const changed = content !== this.elements.captions.innerHTML;
            if (changed) {
                // Empty the container and create a new child element
                emptyElement(this.elements.captions);
                const caption = createElement('span', getAttributesFromSelector(this.config.selectors.caption));
                caption.innerHTML = content;
                this.elements.captions.appendChild(caption);
                // Trigger event
                triggerEvent.call(this, this.media, 'cuechange');
            }
        }
    };
    // ==========================================================================
    // Plyr default config
    // ==========================================================================
    const defaults = {
        // Disable
        enabled: true,
        // Custom media title
        title: '',
        // Logging to console
        debug: false,
        // Auto play (if supported)
        autoplay: false,
        // Only allow one media playing at once (vimeo only)
        autopause: true,
        // Allow inline playback on iOS (this effects YouTube/Vimeo - HTML5 requires the attribute present)
        // TODO: Remove iosNative fullscreen option in favour of this (logic needs work)
        playsinline: true,
        // Default time to skip when rewind/fast forward
        seekTime: 10,
        // Default volume
        volume: 1,
        muted: false,
        // Pass a custom duration
        duration: null,
        // Display the media duration on load in the current time position
        // If you have opted to display both duration and currentTime, this is ignored
        displayDuration: true,
        // Invert the current time to be a countdown
        invertTime: true,
        // Clicking the currentTime inverts it's value to show time left rather than elapsed
        toggleInvert: true,
        // Force an aspect ratio
        // The format must be `'w:h'` (e.g. `'16:9'`)
        ratio: null,
        // Click video container to play/pause
        clickToPlay: true,
        // Auto hide the controls
        hideControls: true,
        // Reset to start when playback ended
        resetOnEnd: false,
        // Disable the standard context menu
        disableContextMenu: true,
        // Sprite (for icons)
        loadSprite: true,
        iconPrefix: 'plyr',
        iconUrl: 'https://cdn.plyr.io/3.7.3/plyr.svg',
        // Blank video (used to prevent errors on source change)
        blankVideo: 'https://cdn.plyr.io/static/blank.mp4',
        // Quality default
        quality: {
            default: 576,
            // The options to display in the UI, if available for the source media
            options: [
                4320,
                2880,
                2160,
                1440,
                1080,
                720,
                576,
                480,
                360,
                240
            ],
            forced: false,
            onChange: null
        },
        // Set loops
        loop: {
            active: false
        },
        // Speed default and options to display
        speed: {
            selected: 1,
            // The options to display in the UI, if available for the source media (e.g. Vimeo and YouTube only support 0.5x-4x)
            options: [
                0.5,
                0.75,
                1,
                1.25,
                1.5,
                1.75,
                2,
                4
            ]
        },
        // Keyboard shortcut settings
        keyboard: {
            focused: true,
            global: false
        },
        // Display tooltips
        tooltips: {
            controls: false,
            seek: true
        },
        // Captions settings
        captions: {
            active: false,
            language: 'auto',
            // Listen to new tracks added after Plyr is initialized.
            // This is needed for streaming captions, but may result in unselectable options
            update: false
        },
        // Fullscreen settings
        fullscreen: {
            enabled: true,
            // Allow fullscreen?
            fallback: true,
            // Fallback using full viewport/window
            iosNative: false // Use the native fullscreen in iOS (disables custom controls)
        },
        // Local storage
        storage: {
            enabled: true,
            key: 'plyr'
        },
        // Default controls
        controls: [
            'play-large',
            // 'restart',
            // 'rewind',
            'play',
            // 'fast-forward',
            'progress',
            'current-time',
            // 'duration',
            'mute',
            'volume',
            'captions',
            'settings',
            'pip',
            'airplay',
            // 'download',
            'fullscreen'
        ],
        settings: [
            'captions',
            'quality',
            'speed'
        ],
        // Localisation
        i18n: {
            restart: 'Restart',
            rewind: 'Rewind {seektime}s',
            play: 'Play',
            pause: 'Pause',
            fastForward: 'Forward {seektime}s',
            seek: 'Seek',
            seekLabel: '{currentTime} of {duration}',
            played: 'Played',
            buffered: 'Buffered',
            currentTime: 'Current time',
            duration: 'Duration',
            volume: 'Volume',
            mute: 'Mute',
            unmute: 'Unmute',
            enableCaptions: 'Enable captions',
            disableCaptions: 'Disable captions',
            download: 'Download',
            enterFullscreen: 'Enter fullscreen',
            exitFullscreen: 'Exit fullscreen',
            frameTitle: 'Player for {title}',
            captions: 'Captions',
            settings: 'Settings',
            pip: 'PIP',
            menuBack: 'Go back to previous menu',
            speed: 'Speed',
            normal: 'Normal',
            quality: 'Quality',
            loop: 'Loop',
            start: 'Start',
            end: 'End',
            all: 'All',
            reset: 'Reset',
            disabled: 'Disabled',
            enabled: 'Enabled',
            advertisement: 'Ad',
            qualityBadge: {
                2160: '4K',
                1440: 'HD',
                1080: 'HD',
                720: 'HD',
                576: 'SD',
                480: 'SD'
            }
        },
        // URLs
        urls: {
            download: null,
            vimeo: {
                sdk: 'https://player.vimeo.com/api/player.js',
                iframe: 'https://player.vimeo.com/video/{0}?{1}',
                api: 'https://vimeo.com/api/oembed.json?url={0}'
            },
            youtube: {
                sdk: 'https://www.youtube.com/iframe_api',
                api: 'https://noembed.com/embed?url=https://www.youtube.com/watch?v={0}'
            },
            googleIMA: {
                sdk: 'https://imasdk.googleapis.com/js/sdkloader/ima3.js'
            }
        },
        // Custom control listeners
        listeners: {
            seek: null,
            play: null,
            pause: null,
            restart: null,
            rewind: null,
            fastForward: null,
            mute: null,
            volume: null,
            captions: null,
            download: null,
            fullscreen: null,
            pip: null,
            airplay: null,
            speed: null,
            quality: null,
            loop: null,
            language: null
        },
        // Events to watch and bubble
        events: [
            // Events to watch on HTML5 media elements and bubble
            // https://developer.mozilla.org/en/docs/Web/Guide/Events/Media_events
            'ended',
            'progress',
            'stalled',
            'playing',
            'waiting',
            'canplay',
            'canplaythrough',
            'loadstart',
            'loadeddata',
            'loadedmetadata',
            'timeupdate',
            'volumechange',
            'play',
            'pause',
            'error',
            'seeking',
            'seeked',
            'emptied',
            'ratechange',
            'cuechange',
            // Custom events
            'download',
            'enterfullscreen',
            'exitfullscreen',
            'captionsenabled',
            'captionsdisabled',
            'languagechange',
            'controlshidden',
            'controlsshown',
            'ready',
            // YouTube
            'statechange',
            // Quality
            'qualitychange',
            // Ads
            'adsloaded',
            'adscontentpause',
            'adscontentresume',
            'adstarted',
            'adsmidpoint',
            'adscomplete',
            'adsallcomplete',
            'adsimpression',
            'adsclick'
        ],
        // Selectors
        // Change these to match your template if using custom HTML
        selectors: {
            editable: 'input, textarea, select, [contenteditable]',
            container: '.plyr',
            controls: {
                container: null,
                wrapper: '.plyr__controls'
            },
            labels: '[data-plyr]',
            buttons: {
                play: '[data-plyr="play"]',
                pause: '[data-plyr="pause"]',
                restart: '[data-plyr="restart"]',
                rewind: '[data-plyr="rewind"]',
                fastForward: '[data-plyr="fast-forward"]',
                mute: '[data-plyr="mute"]',
                captions: '[data-plyr="captions"]',
                download: '[data-plyr="download"]',
                fullscreen: '[data-plyr="fullscreen"]',
                pip: '[data-plyr="pip"]',
                airplay: '[data-plyr="airplay"]',
                settings: '[data-plyr="settings"]',
                loop: '[data-plyr="loop"]'
            },
            inputs: {
                seek: '[data-plyr="seek"]',
                volume: '[data-plyr="volume"]',
                speed: '[data-plyr="speed"]',
                language: '[data-plyr="language"]',
                quality: '[data-plyr="quality"]'
            },
            display: {
                currentTime: '.plyr__time--current',
                duration: '.plyr__time--duration',
                buffer: '.plyr__progress__buffer',
                loop: '.plyr__progress__loop',
                // Used later
                volume: '.plyr__volume--display'
            },
            progress: '.plyr__progress',
            captions: '.plyr__captions',
            caption: '.plyr__caption'
        },
        // Class hooks added to the player in different states
        classNames: {
            type: 'plyr--{0}',
            provider: 'plyr--{0}',
            video: 'plyr__video-wrapper',
            embed: 'plyr__video-embed',
            videoFixedRatio: 'plyr__video-wrapper--fixed-ratio',
            embedContainer: 'plyr__video-embed__container',
            poster: 'plyr__poster',
            posterEnabled: 'plyr__poster-enabled',
            ads: 'plyr__ads',
            control: 'plyr__control',
            controlPressed: 'plyr__control--pressed',
            playing: 'plyr--playing',
            paused: 'plyr--paused',
            stopped: 'plyr--stopped',
            loading: 'plyr--loading',
            hover: 'plyr--hover',
            tooltip: 'plyr__tooltip',
            cues: 'plyr__cues',
            marker: 'plyr__progress__marker',
            hidden: 'plyr__sr-only',
            hideControls: 'plyr--hide-controls',
            isIos: 'plyr--is-ios',
            isTouch: 'plyr--is-touch',
            uiSupported: 'plyr--full-ui',
            noTransition: 'plyr--no-transition',
            display: {
                time: 'plyr__time'
            },
            menu: {
                value: 'plyr__menu__value',
                badge: 'plyr__badge',
                open: 'plyr--menu-open'
            },
            captions: {
                enabled: 'plyr--captions-enabled',
                active: 'plyr--captions-active'
            },
            fullscreen: {
                enabled: 'plyr--fullscreen-enabled',
                fallback: 'plyr--fullscreen-fallback'
            },
            pip: {
                supported: 'plyr--pip-supported',
                active: 'plyr--pip-active'
            },
            airplay: {
                supported: 'plyr--airplay-supported',
                active: 'plyr--airplay-active'
            },
            tabFocus: 'plyr__tab-focus',
            previewThumbnails: {
                // Tooltip thumbs
                thumbContainer: 'plyr__preview-thumb',
                thumbContainerShown: 'plyr__preview-thumb--is-shown',
                imageContainer: 'plyr__preview-thumb__image-container',
                timeContainer: 'plyr__preview-thumb__time-container',
                // Scrubbing
                scrubbingContainer: 'plyr__preview-scrubbing',
                scrubbingContainerShown: 'plyr__preview-scrubbing--is-shown'
            }
        },
        // Embed attributes
        attributes: {
            embed: {
                provider: 'data-plyr-provider',
                id: 'data-plyr-embed-id',
                hash: 'data-plyr-embed-hash'
            }
        },
        // Advertisements plugin
        // Register for an account here: http://vi.ai/publisher-video-monetization/?aid=plyrio
        ads: {
            enabled: false,
            publisherId: '',
            tagUrl: ''
        },
        // Preview Thumbnails plugin
        previewThumbnails: {
            enabled: false,
            src: ''
        },
        // Vimeo plugin
        vimeo: {
            byline: false,
            portrait: false,
            title: false,
            speed: true,
            transparent: false,
            // Custom settings from Plyr
            customControls: true,
            referrerPolicy: null,
            // https://developer.mozilla.org/en-US/docs/Web/API/HTMLIFrameElement/referrerPolicy
            // Whether the owner of the video has a Pro or Business account
            // (which allows us to properly hide controls without CSS hacks, etc)
            premium: false
        },
        // YouTube plugin
        youtube: {
            rel: 0,
            // No related vids
            showinfo: 0,
            // Hide info
            iv_load_policy: 3,
            // Hide annotations
            modestbranding: 1,
            // Hide logos as much as possible (they still show one in the corner when paused)
            // Custom settings from Plyr
            customControls: true,
            noCookie: false // Whether to use an alternative version of YouTube without cookies
        },
        // Media Metadata
        mediaMetadata: {
            title: '',
            artist: '',
            album: '',
            artwork: []
        },
        // Markers
        markers: {
            enabled: false,
            points: []
        }
    };
    // ==========================================================================
    // Plyr states
    // ==========================================================================
    const pip = {
        active: 'picture-in-picture',
        inactive: 'inline'
    };
    // ==========================================================================
    // Plyr supported types and providers
    // ==========================================================================
    const providers = {
        html5: 'html5',
        youtube: 'youtube',
        vimeo: 'vimeo'
    };
    const types = {
        audio: 'audio',
        video: 'video'
    };
    /**
   * Get provider by URL
   * @param {String} url
   */ function getProviderByUrl(url) {
        // YouTube
        if (/^(https?:\/\/)?(www\.)?(youtube\.com|youtube-nocookie\.com|youtu\.?be)\/.+$/.test(url)) return providers.youtube;
        // Vimeo
        if (/^https?:\/\/player.vimeo.com\/video\/\d{0,9}(?=\b|\/)/.test(url)) return providers.vimeo;
        return null;
    }
    // ==========================================================================
    // Console wrapper
    // ==========================================================================
    const noop = ()=>{};
    class Console {
        constructor(enabled = false){
            this.enabled = window.console && enabled;
            if (this.enabled) this.log('Debugging enabled');
        }
        get log() {
            // eslint-disable-next-line no-console
            return this.enabled ? Function.prototype.bind.call(console.log, console) : noop;
        }
        get warn() {
            // eslint-disable-next-line no-console
            return this.enabled ? Function.prototype.bind.call(console.warn, console) : noop;
        }
        get error() {
            // eslint-disable-next-line no-console
            return this.enabled ? Function.prototype.bind.call(console.error, console) : noop;
        }
    }
    class Fullscreen {
        constructor(player){
            _defineProperty$1(this, "onChange", ()=>{
                if (!this.enabled) return;
                // Update toggle button
                const button = this.player.elements.buttons.fullscreen;
                if (is.element(button)) button.pressed = this.active;
                // Always trigger events on the plyr / media element (not a fullscreen container) and let them bubble up
                const target = this.target === this.player.media ? this.target : this.player.elements.container;
                // Trigger an event
                triggerEvent.call(this.player, target, this.active ? 'enterfullscreen' : 'exitfullscreen', true);
            });
            _defineProperty$1(this, "toggleFallback", (toggle = false)=>{
                // Store or restore scroll position
                if (toggle) this.scrollPosition = {
                    x: window.scrollX || 0,
                    y: window.scrollY || 0
                };
                else window.scrollTo(this.scrollPosition.x, this.scrollPosition.y);
                // Toggle scroll
                document.body.style.overflow = toggle ? 'hidden' : '';
                // Toggle class hook
                toggleClass(this.target, this.player.config.classNames.fullscreen.fallback, toggle);
                // Force full viewport on iPhone X+
                if (browser.isIos) {
                    let viewport = document.head.querySelector('meta[name="viewport"]');
                    const property = 'viewport-fit=cover';
                    // Inject the viewport meta if required
                    if (!viewport) {
                        viewport = document.createElement('meta');
                        viewport.setAttribute('name', 'viewport');
                    }
                    // Check if the property already exists
                    const hasProperty = is.string(viewport.content) && viewport.content.includes(property);
                    if (toggle) {
                        this.cleanupViewport = !hasProperty;
                        if (!hasProperty) viewport.content += `,${property}`;
                    } else if (this.cleanupViewport) viewport.content = viewport.content.split(',').filter((part)=>part.trim() !== property).join(',');
                }
                // Toggle button and fire events
                this.onChange();
            });
            _defineProperty$1(this, "trapFocus", (event)=>{
                // Bail if iOS, not active, not the tab key
                if (browser.isIos || !this.active || event.key !== 'Tab') return;
                // Get the current focused element
                const focused = document.activeElement;
                const focusable = getElements.call(this.player, 'a[href], button:not(:disabled), input:not(:disabled), [tabindex]');
                const [first] = focusable;
                const last = focusable[focusable.length - 1];
                if (focused === last && !event.shiftKey) {
                    // Move focus to first element that can be tabbed if Shift isn't used
                    first.focus();
                    event.preventDefault();
                } else if (focused === first && event.shiftKey) {
                    // Move focus to last element that can be tabbed if Shift is used
                    last.focus();
                    event.preventDefault();
                }
            });
            _defineProperty$1(this, "update", ()=>{
                if (this.enabled) {
                    let mode;
                    if (this.forceFallback) mode = 'Fallback (forced)';
                    else if (Fullscreen.native) mode = 'Native';
                    else mode = 'Fallback';
                    this.player.debug.log(`${mode} fullscreen enabled`);
                } else this.player.debug.log('Fullscreen not supported and fallback disabled');
                // Add styling hook to show button
                toggleClass(this.player.elements.container, this.player.config.classNames.fullscreen.enabled, this.enabled);
            });
            _defineProperty$1(this, "enter", ()=>{
                if (!this.enabled) return;
                // iOS native fullscreen doesn't need the request step
                if (browser.isIos && this.player.config.fullscreen.iosNative) {
                    if (this.player.isVimeo) this.player.embed.requestFullscreen();
                    else this.target.webkitEnterFullscreen();
                } else if (!Fullscreen.native || this.forceFallback) this.toggleFallback(true);
                else if (!this.prefix) this.target.requestFullscreen({
                    navigationUI: 'hide'
                });
                else if (!is.empty(this.prefix)) this.target[`${this.prefix}Request${this.property}`]();
            });
            _defineProperty$1(this, "exit", ()=>{
                if (!this.enabled) return;
                // iOS native fullscreen
                if (browser.isIos && this.player.config.fullscreen.iosNative) {
                    this.target.webkitExitFullscreen();
                    silencePromise(this.player.play());
                } else if (!Fullscreen.native || this.forceFallback) this.toggleFallback(false);
                else if (!this.prefix) (document.cancelFullScreen || document.exitFullscreen).call(document);
                else if (!is.empty(this.prefix)) {
                    const action = this.prefix === 'moz' ? 'Cancel' : 'Exit';
                    document[`${this.prefix}${action}${this.property}`]();
                }
            });
            _defineProperty$1(this, "toggle", ()=>{
                if (!this.active) this.enter();
                else this.exit();
            });
            // Keep reference to parent
            this.player = player;
            // Get prefix
            this.prefix = Fullscreen.prefix;
            this.property = Fullscreen.property;
            // Scroll position
            this.scrollPosition = {
                x: 0,
                y: 0
            };
            // Force the use of 'full window/browser' rather than fullscreen
            this.forceFallback = player.config.fullscreen.fallback === 'force';
            // Get the fullscreen element
            // Checks container is an ancestor, defaults to null
            this.player.elements.fullscreen = player.config.fullscreen.container && closest$1(this.player.elements.container, player.config.fullscreen.container);
            // Register event listeners
            // Handle event (incase user presses escape etc)
            on.call(this.player, document, this.prefix === 'ms' ? 'MSFullscreenChange' : `${this.prefix}fullscreenchange`, ()=>{
                // TODO: Filter for target??
                this.onChange();
            });
            // Fullscreen toggle on double click
            on.call(this.player, this.player.elements.container, 'dblclick', (event)=>{
                // Ignore double click in controls
                if (is.element(this.player.elements.controls) && this.player.elements.controls.contains(event.target)) return;
                this.player.listeners.proxy(event, this.toggle, 'fullscreen');
            });
            // Tap focus when in fullscreen
            on.call(this, this.player.elements.container, 'keydown', (event)=>this.trapFocus(event));
            // Update the UI
            this.update();
        // this.toggle = this.toggle.bind(this);
        }
        // Determine if native supported
        static get native() {
            return !!(document.fullscreenEnabled || document.webkitFullscreenEnabled || document.mozFullScreenEnabled || document.msFullscreenEnabled);
        }
        // If we're actually using native
        get usingNative() {
            return Fullscreen.native && !this.forceFallback;
        }
        // Get the prefix for handlers
        static get prefix() {
            // No prefix
            if (is.function(document.exitFullscreen)) return '';
            // Check for fullscreen support by vendor prefix
            let value = '';
            const prefixes = [
                'webkit',
                'moz',
                'ms'
            ];
            prefixes.some((pre)=>{
                if (is.function(document[`${pre}ExitFullscreen`]) || is.function(document[`${pre}CancelFullScreen`])) {
                    value = pre;
                    return true;
                }
                return false;
            });
            return value;
        }
        static get property() {
            return this.prefix === 'moz' ? 'FullScreen' : 'Fullscreen';
        }
        // Determine if fullscreen is enabled
        get enabled() {
            return (Fullscreen.native || this.player.config.fullscreen.fallback) && this.player.config.fullscreen.enabled && this.player.supported.ui && this.player.isVideo;
        }
        // Get active state
        get active() {
            if (!this.enabled) return false;
            // Fallback using classname
            if (!Fullscreen.native || this.forceFallback) return hasClass(this.target, this.player.config.classNames.fullscreen.fallback);
            const element = !this.prefix ? this.target.getRootNode().fullscreenElement : this.target.getRootNode()[`${this.prefix}${this.property}Element`];
            return element && element.shadowRoot ? element === this.target.getRootNode().host : element === this.target;
        }
        // Get target element
        get target() {
            return browser.isIos && this.player.config.fullscreen.iosNative ? this.player.media : this.player.elements.fullscreen || this.player.elements.container;
        }
    }
    // ==========================================================================
    // Load image avoiding xhr/fetch CORS issues
    // Server status can't be obtained this way unfortunately, so this uses "naturalWidth" to determine if the image has loaded
    // By default it checks if it is at least 1px, but you can add a second argument to change this
    // ==========================================================================
    function loadImage(src, minWidth = 1) {
        return new Promise((resolve, reject)=>{
            const image = new Image();
            const handler = ()=>{
                delete image.onload;
                delete image.onerror;
                (image.naturalWidth >= minWidth ? resolve : reject)(image);
            };
            Object.assign(image, {
                onload: handler,
                onerror: handler,
                src: src
            });
        });
    }
    // ==========================================================================
    const ui = {
        addStyleHook () {
            toggleClass(this.elements.container, this.config.selectors.container.replace('.', ''), true);
            toggleClass(this.elements.container, this.config.classNames.uiSupported, this.supported.ui);
        },
        // Toggle native HTML5 media controls
        toggleNativeControls (toggle = false) {
            if (toggle && this.isHTML5) this.media.setAttribute('controls', '');
            else this.media.removeAttribute('controls');
        },
        // Setup the UI
        build () {
            // Re-attach media element listeners
            // TODO: Use event bubbling?
            this.listeners.media();
            // Don't setup interface if no support
            if (!this.supported.ui) {
                this.debug.warn(`Basic support only for ${this.provider} ${this.type}`);
                // Restore native controls
                ui.toggleNativeControls.call(this, true);
                // Bail
                return;
            }
            // Inject custom controls if not present
            if (!is.element(this.elements.controls)) {
                // Inject custom controls
                controls.inject.call(this);
                // Re-attach control listeners
                this.listeners.controls();
            }
            // Remove native controls
            ui.toggleNativeControls.call(this);
            // Setup captions for HTML5
            if (this.isHTML5) captions.setup.call(this);
            // Reset volume
            this.volume = null;
            // Reset mute state
            this.muted = null;
            // Reset loop state
            this.loop = null;
            // Reset quality setting
            this.quality = null;
            // Reset speed
            this.speed = null;
            // Reset volume display
            controls.updateVolume.call(this);
            // Reset time display
            controls.timeUpdate.call(this);
            // Reset duration display
            controls.durationUpdate.call(this);
            // Update the UI
            ui.checkPlaying.call(this);
            // Check for picture-in-picture support
            toggleClass(this.elements.container, this.config.classNames.pip.supported, support.pip && this.isHTML5 && this.isVideo);
            // Check for airplay support
            toggleClass(this.elements.container, this.config.classNames.airplay.supported, support.airplay && this.isHTML5);
            // Add iOS class
            toggleClass(this.elements.container, this.config.classNames.isIos, browser.isIos);
            // Add touch class
            toggleClass(this.elements.container, this.config.classNames.isTouch, this.touch);
            // Ready for API calls
            this.ready = true;
            // Ready event at end of execution stack
            setTimeout(()=>{
                triggerEvent.call(this, this.media, 'ready');
            }, 0);
            // Set the title
            ui.setTitle.call(this);
            // Assure the poster image is set, if the property was added before the element was created
            if (this.poster) ui.setPoster.call(this, this.poster, false).catch(()=>{});
            // Manually set the duration if user has overridden it.
            // The event listeners for it doesn't get called if preload is disabled (#701)
            if (this.config.duration) controls.durationUpdate.call(this);
            // Media metadata
            if (this.config.mediaMetadata) controls.setMediaMetadata.call(this);
        },
        // Setup aria attribute for play and iframe title
        setTitle () {
            // Find the current text
            let label = i18n.get('play', this.config);
            // If there's a media title set, use that for the label
            if (is.string(this.config.title) && !is.empty(this.config.title)) label += `, ${this.config.title}`;
            // If there's a play button, set label
            Array.from(this.elements.buttons.play || []).forEach((button)=>{
                button.setAttribute('aria-label', label);
            });
            // Set iframe title
            // https://github.com/sampotts/plyr/issues/124
            if (this.isEmbed) {
                const iframe = getElement.call(this, 'iframe');
                if (!is.element(iframe)) return;
                // Default to media type
                const title = !is.empty(this.config.title) ? this.config.title : 'video';
                const format = i18n.get('frameTitle', this.config);
                iframe.setAttribute('title', format.replace('{title}', title));
            }
        },
        // Toggle poster
        togglePoster (enable) {
            toggleClass(this.elements.container, this.config.classNames.posterEnabled, enable);
        },
        // Set the poster image (async)
        // Used internally for the poster setter, with the passive option forced to false
        setPoster (poster, passive = true) {
            // Don't override if call is passive
            if (passive && this.poster) return Promise.reject(new Error('Poster already set'));
            // Set property synchronously to respect the call order
            this.media.setAttribute('data-poster', poster);
            // Show the poster
            this.elements.poster.removeAttribute('hidden');
            // Wait until ui is ready
            return ready.call(this)// Load image
            .then(()=>loadImage(poster)).catch((error)=>{
                // Hide poster on error unless it's been set by another call
                if (poster === this.poster) ui.togglePoster.call(this, false);
                // Rethrow
                throw error;
            }).then(()=>{
                // Prevent race conditions
                if (poster !== this.poster) throw new Error('setPoster cancelled by later call to setPoster');
            }).then(()=>{
                Object.assign(this.elements.poster.style, {
                    backgroundImage: `url('${poster}')`,
                    // Reset backgroundSize as well (since it can be set to "cover" for padded thumbnails for youtube)
                    backgroundSize: ''
                });
                ui.togglePoster.call(this, true);
                return poster;
            });
        },
        // Check playing state
        checkPlaying (event) {
            // Class hooks
            toggleClass(this.elements.container, this.config.classNames.playing, this.playing);
            toggleClass(this.elements.container, this.config.classNames.paused, this.paused);
            toggleClass(this.elements.container, this.config.classNames.stopped, this.stopped);
            // Set state
            Array.from(this.elements.buttons.play || []).forEach((target)=>{
                Object.assign(target, {
                    pressed: this.playing
                });
                target.setAttribute('aria-label', i18n.get(this.playing ? 'pause' : 'play', this.config));
            });
            // Only update controls on non timeupdate events
            if (is.event(event) && event.type === 'timeupdate') return;
            // Toggle controls
            ui.toggleControls.call(this);
        },
        // Check if media is loading
        checkLoading (event) {
            this.loading = [
                'stalled',
                'waiting'
            ].includes(event.type);
            // Clear timer
            clearTimeout(this.timers.loading);
            // Timer to prevent flicker when seeking
            this.timers.loading = setTimeout(()=>{
                // Update progress bar loading class state
                toggleClass(this.elements.container, this.config.classNames.loading, this.loading);
                // Update controls visibility
                ui.toggleControls.call(this);
            }, this.loading ? 250 : 0);
        },
        // Toggle controls based on state and `force` argument
        toggleControls (force) {
            const { controls: controlsElement } = this.elements;
            if (controlsElement && this.config.hideControls) {
                // Don't hide controls if a touch-device user recently seeked. (Must be limited to touch devices, or it occasionally prevents desktop controls from hiding.)
                const recentTouchSeek = this.touch && this.lastSeekTime + 2000 > Date.now();
                // Show controls if force, loading, paused, button interaction, or recent seek, otherwise hide
                this.toggleControls(Boolean(force || this.loading || this.paused || controlsElement.pressed || controlsElement.hover || recentTouchSeek));
            }
        },
        // Migrate any custom properties from the media to the parent
        migrateStyles () {
            // Loop through values (as they are the keys when the object is spread 🤔)
            Object.values({
                ...this.media.style
            })// We're only fussed about Plyr specific properties
            .filter((key)=>!is.empty(key) && is.string(key) && key.startsWith('--plyr')).forEach((key)=>{
                // Set on the container
                this.elements.container.style.setProperty(key, this.media.style.getPropertyValue(key));
                // Clean up from media element
                this.media.style.removeProperty(key);
            });
            // Remove attribute if empty
            if (is.empty(this.media.style)) this.media.removeAttribute('style');
        }
    };
    class Listeners {
        constructor(_player){
            _defineProperty$1(this, "firstTouch", ()=>{
                const { player: player } = this;
                const { elements: elements } = player;
                player.touch = true;
                // Add touch class
                toggleClass(elements.container, player.config.classNames.isTouch, true);
            });
            _defineProperty$1(this, "setTabFocus", (event)=>{
                const { player: player } = this;
                const { elements: elements } = player;
                const { key: key, type: type, timeStamp: timeStamp } = event;
                clearTimeout(this.focusTimer);
                // Ignore any key other than tab
                if (type === 'keydown' && key !== 'Tab') return;
                // Store reference to event timeStamp
                if (type === 'keydown') this.lastKeyDown = timeStamp;
                // Remove current classes
                const removeCurrent = ()=>{
                    const className = player.config.classNames.tabFocus;
                    const current = getElements.call(player, `.${className}`);
                    toggleClass(current, className, false);
                };
                // Determine if a key was pressed to trigger this event
                const wasKeyDown = timeStamp - this.lastKeyDown <= 20;
                // Ignore focus events if a key was pressed prior
                if (type === 'focus' && !wasKeyDown) return;
                // Remove all current
                removeCurrent();
                // Delay the adding of classname until the focus has changed
                // This event fires before the focusin event
                if (type !== 'focusout') this.focusTimer = setTimeout(()=>{
                    const focused = document.activeElement;
                    // Ignore if current focus element isn't inside the player
                    if (!elements.container.contains(focused)) return;
                    toggleClass(document.activeElement, player.config.classNames.tabFocus, true);
                }, 10);
            });
            _defineProperty$1(this, "global", (toggle = true)=>{
                const { player: player } = this;
                // Keyboard shortcuts
                if (player.config.keyboard.global) toggleListener.call(player, window, 'keydown keyup', this.handleKey, toggle, false);
                // Click anywhere closes menu
                toggleListener.call(player, document.body, 'click', this.toggleMenu, toggle);
                // Detect touch by events
                once.call(player, document.body, 'touchstart', this.firstTouch);
                // Tab focus detection
                toggleListener.call(player, document.body, 'keydown focus blur focusout', this.setTabFocus, toggle, false, true);
            });
            _defineProperty$1(this, "container", ()=>{
                const { player: player } = this;
                const { config: config, elements: elements, timers: timers } = player;
                // Keyboard shortcuts
                if (!config.keyboard.global && config.keyboard.focused) on.call(player, elements.container, 'keydown keyup', this.handleKey, false);
                // Toggle controls on mouse events and entering fullscreen
                on.call(player, elements.container, 'mousemove mouseleave touchstart touchmove enterfullscreen exitfullscreen', (event)=>{
                    const { controls: controlsElement } = elements;
                    // Remove button states for fullscreen
                    if (controlsElement && event.type === 'enterfullscreen') {
                        controlsElement.pressed = false;
                        controlsElement.hover = false;
                    }
                    // Show, then hide after a timeout unless another control event occurs
                    const show = [
                        'touchstart',
                        'touchmove',
                        'mousemove'
                    ].includes(event.type);
                    let delay = 0;
                    if (show) {
                        ui.toggleControls.call(player, true);
                        // Use longer timeout for touch devices
                        delay = player.touch ? 3000 : 2000;
                    }
                    // Clear timer
                    clearTimeout(timers.controls);
                    // Set new timer to prevent flicker when seeking
                    timers.controls = setTimeout(()=>ui.toggleControls.call(player, false), delay);
                });
                // Set a gutter for Vimeo
                const setGutter = ()=>{
                    if (!player.isVimeo || player.config.vimeo.premium) return;
                    const target = elements.wrapper;
                    const { active: active } = player.fullscreen;
                    const [videoWidth, videoHeight] = getAspectRatio.call(player);
                    const useNativeAspectRatio = supportsCSS(`aspect-ratio: ${videoWidth} / ${videoHeight}`);
                    // If not active, remove styles
                    if (!active) {
                        if (useNativeAspectRatio) {
                            target.style.width = null;
                            target.style.height = null;
                        } else {
                            target.style.maxWidth = null;
                            target.style.margin = null;
                        }
                        return;
                    }
                    // Determine which dimension will overflow and constrain view
                    const [viewportWidth, viewportHeight] = getViewportSize();
                    const overflow = viewportWidth / viewportHeight > videoWidth / videoHeight;
                    if (useNativeAspectRatio) {
                        target.style.width = overflow ? 'auto' : '100%';
                        target.style.height = overflow ? '100%' : 'auto';
                    } else {
                        target.style.maxWidth = overflow ? `${viewportHeight / videoHeight * videoWidth}px` : null;
                        target.style.margin = overflow ? '0 auto' : null;
                    }
                };
                // Handle resizing
                const resized = ()=>{
                    clearTimeout(timers.resized);
                    timers.resized = setTimeout(setGutter, 50);
                };
                on.call(player, elements.container, 'enterfullscreen exitfullscreen', (event)=>{
                    const { target: target } = player.fullscreen;
                    // Ignore events not from target
                    if (target !== elements.container) return;
                    // If it's not an embed and no ratio specified
                    if (!player.isEmbed && is.empty(player.config.ratio)) return;
                    // Set Vimeo gutter
                    setGutter();
                    // Watch for resizes
                    const method = event.type === 'enterfullscreen' ? on : off;
                    method.call(player, window, 'resize', resized);
                });
            });
            _defineProperty$1(this, "media", ()=>{
                const { player: player } = this;
                const { elements: elements } = player;
                // Time change on media
                on.call(player, player.media, 'timeupdate seeking seeked', (event)=>controls.timeUpdate.call(player, event));
                // Display duration
                on.call(player, player.media, 'durationchange loadeddata loadedmetadata', (event)=>controls.durationUpdate.call(player, event));
                // Handle the media finishing
                on.call(player, player.media, 'ended', ()=>{
                    // Show poster on end
                    if (player.isHTML5 && player.isVideo && player.config.resetOnEnd) {
                        // Restart
                        player.restart();
                        // Call pause otherwise IE11 will start playing the video again
                        player.pause();
                    }
                });
                // Check for buffer progress
                on.call(player, player.media, 'progress playing seeking seeked', (event)=>controls.updateProgress.call(player, event));
                // Handle volume changes
                on.call(player, player.media, 'volumechange', (event)=>controls.updateVolume.call(player, event));
                // Handle play/pause
                on.call(player, player.media, 'playing play pause ended emptied timeupdate', (event)=>ui.checkPlaying.call(player, event));
                // Loading state
                on.call(player, player.media, 'waiting canplay seeked playing', (event)=>ui.checkLoading.call(player, event));
                // Click video
                if (player.supported.ui && player.config.clickToPlay && !player.isAudio) {
                    // Re-fetch the wrapper
                    const wrapper = getElement.call(player, `.${player.config.classNames.video}`);
                    // Bail if there's no wrapper (this should never happen)
                    if (!is.element(wrapper)) return;
                    // On click play, pause or restart
                    on.call(player, elements.container, 'click', (event)=>{
                        const targets = [
                            elements.container,
                            wrapper
                        ];
                        // Ignore if click if not container or in video wrapper
                        if (!targets.includes(event.target) && !wrapper.contains(event.target)) return;
                        // Touch devices will just show controls (if hidden)
                        if (player.touch && player.config.hideControls) return;
                        if (player.ended) {
                            this.proxy(event, player.restart, 'restart');
                            this.proxy(event, ()=>{
                                silencePromise(player.play());
                            }, 'play');
                        } else this.proxy(event, ()=>{
                            silencePromise(player.togglePlay());
                        }, 'play');
                    });
                }
                // Disable right click
                if (player.supported.ui && player.config.disableContextMenu) on.call(player, elements.wrapper, 'contextmenu', (event)=>{
                    event.preventDefault();
                }, false);
                // Volume change
                on.call(player, player.media, 'volumechange', ()=>{
                    // Save to storage
                    player.storage.set({
                        volume: player.volume,
                        muted: player.muted
                    });
                });
                // Speed change
                on.call(player, player.media, 'ratechange', ()=>{
                    // Update UI
                    controls.updateSetting.call(player, 'speed');
                    // Save to storage
                    player.storage.set({
                        speed: player.speed
                    });
                });
                // Quality change
                on.call(player, player.media, 'qualitychange', (event)=>{
                    // Update UI
                    controls.updateSetting.call(player, 'quality', null, event.detail.quality);
                });
                // Update download link when ready and if quality changes
                on.call(player, player.media, 'ready qualitychange', ()=>{
                    controls.setDownloadUrl.call(player);
                });
                // Proxy events to container
                // Bubble up key events for Edge
                const proxyEvents = player.config.events.concat([
                    'keyup',
                    'keydown'
                ]).join(' ');
                on.call(player, player.media, proxyEvents, (event)=>{
                    let { detail: detail = {} } = event;
                    // Get error details from media
                    if (event.type === 'error') detail = player.media.error;
                    triggerEvent.call(player, elements.container, event.type, true, detail);
                });
            });
            _defineProperty$1(this, "proxy", (event, defaultHandler, customHandlerKey)=>{
                const { player: player } = this;
                const customHandler = player.config.listeners[customHandlerKey];
                const hasCustomHandler = is.function(customHandler);
                let returned = true;
                // Execute custom handler
                if (hasCustomHandler) returned = customHandler.call(player, event);
                // Only call default handler if not prevented in custom handler
                if (returned !== false && is.function(defaultHandler)) defaultHandler.call(player, event);
            });
            _defineProperty$1(this, "bind", (element, type, defaultHandler, customHandlerKey, passive = true)=>{
                const { player: player } = this;
                const customHandler = player.config.listeners[customHandlerKey];
                const hasCustomHandler = is.function(customHandler);
                on.call(player, element, type, (event)=>this.proxy(event, defaultHandler, customHandlerKey), passive && !hasCustomHandler);
            });
            _defineProperty$1(this, "controls", ()=>{
                const { player: player } = this;
                const { elements: elements } = player;
                // IE doesn't support input event, so we fallback to change
                const inputEvent = browser.isIE ? 'change' : 'input';
                // Play/pause toggle
                if (elements.buttons.play) Array.from(elements.buttons.play).forEach((button)=>{
                    this.bind(button, 'click', ()=>{
                        silencePromise(player.togglePlay());
                    }, 'play');
                });
                // Pause
                this.bind(elements.buttons.restart, 'click', player.restart, 'restart');
                // Rewind
                this.bind(elements.buttons.rewind, 'click', ()=>{
                    // Record seek time so we can prevent hiding controls for a few seconds after rewind
                    player.lastSeekTime = Date.now();
                    player.rewind();
                }, 'rewind');
                // Rewind
                this.bind(elements.buttons.fastForward, 'click', ()=>{
                    // Record seek time so we can prevent hiding controls for a few seconds after fast forward
                    player.lastSeekTime = Date.now();
                    player.forward();
                }, 'fastForward');
                // Mute toggle
                this.bind(elements.buttons.mute, 'click', ()=>{
                    player.muted = !player.muted;
                }, 'mute');
                // Captions toggle
                this.bind(elements.buttons.captions, 'click', ()=>player.toggleCaptions());
                // Download
                this.bind(elements.buttons.download, 'click', ()=>{
                    triggerEvent.call(player, player.media, 'download');
                }, 'download');
                // Fullscreen toggle
                this.bind(elements.buttons.fullscreen, 'click', ()=>{
                    player.fullscreen.toggle();
                }, 'fullscreen');
                // Picture-in-Picture
                this.bind(elements.buttons.pip, 'click', ()=>{
                    player.pip = 'toggle';
                }, 'pip');
                // Airplay
                this.bind(elements.buttons.airplay, 'click', player.airplay, 'airplay');
                // Settings menu - click toggle
                this.bind(elements.buttons.settings, 'click', (event)=>{
                    // Prevent the document click listener closing the menu
                    event.stopPropagation();
                    event.preventDefault();
                    controls.toggleMenu.call(player, event);
                }, null, false); // Can't be passive as we're preventing default
                // Settings menu - keyboard toggle
                // We have to bind to keyup otherwise Firefox triggers a click when a keydown event handler shifts focus
                // https://bugzilla.mozilla.org/show_bug.cgi?id=1220143
                this.bind(elements.buttons.settings, 'keyup', (event)=>{
                    if (![
                        'Space',
                        'Enter'
                    ].includes(event.key)) return;
                    // Because return triggers a click anyway, all we need to do is set focus
                    if (event.key === 'Enter') {
                        controls.focusFirstMenuItem.call(player, null, true);
                        return;
                    }
                    // Prevent scroll
                    event.preventDefault();
                    // Prevent playing video (Firefox)
                    event.stopPropagation();
                    // Toggle menu
                    controls.toggleMenu.call(player, event);
                }, null, false // Can't be passive as we're preventing default
                );
                // Escape closes menu
                this.bind(elements.settings.menu, 'keydown', (event)=>{
                    if (event.key === 'Escape') controls.toggleMenu.call(player, event);
                });
                // Set range input alternative "value", which matches the tooltip time (#954)
                this.bind(elements.inputs.seek, 'mousedown mousemove', (event)=>{
                    const rect = elements.progress.getBoundingClientRect();
                    const percent = 100 / rect.width * (event.pageX - rect.left);
                    event.currentTarget.setAttribute('seek-value', percent);
                });
                // Pause while seeking
                this.bind(elements.inputs.seek, 'mousedown mouseup keydown keyup touchstart touchend', (event)=>{
                    const seek = event.currentTarget;
                    const attribute = 'play-on-seeked';
                    if (is.keyboardEvent(event) && ![
                        'ArrowLeft',
                        'ArrowRight'
                    ].includes(event.key)) return;
                    // Record seek time so we can prevent hiding controls for a few seconds after seek
                    player.lastSeekTime = Date.now();
                    // Was playing before?
                    const play = seek.hasAttribute(attribute);
                    // Done seeking
                    const done = [
                        'mouseup',
                        'touchend',
                        'keyup'
                    ].includes(event.type);
                    // If we're done seeking and it was playing, resume playback
                    if (play && done) {
                        seek.removeAttribute(attribute);
                        silencePromise(player.play());
                    } else if (!done && player.playing) {
                        seek.setAttribute(attribute, '');
                        player.pause();
                    }
                });
                // Fix range inputs on iOS
                // Super weird iOS bug where after you interact with an <input type="range">,
                // it takes over further interactions on the page. This is a hack
                if (browser.isIos) {
                    const inputs = getElements.call(player, 'input[type="range"]');
                    Array.from(inputs).forEach((input)=>this.bind(input, inputEvent, (event)=>repaint(event.target)));
                }
                // Seek
                this.bind(elements.inputs.seek, inputEvent, (event)=>{
                    const seek = event.currentTarget;
                    // If it exists, use seek-value instead of "value" for consistency with tooltip time (#954)
                    let seekTo = seek.getAttribute('seek-value');
                    if (is.empty(seekTo)) seekTo = seek.value;
                    seek.removeAttribute('seek-value');
                    player.currentTime = seekTo / seek.max * player.duration;
                }, 'seek');
                // Seek tooltip
                this.bind(elements.progress, 'mouseenter mouseleave mousemove', (event)=>controls.updateSeekTooltip.call(player, event));
                // Preview thumbnails plugin
                // TODO: Really need to work on some sort of plug-in wide event bus or pub-sub for this
                this.bind(elements.progress, 'mousemove touchmove', (event)=>{
                    const { previewThumbnails: previewThumbnails } = player;
                    if (previewThumbnails && previewThumbnails.loaded) previewThumbnails.startMove(event);
                });
                // Hide thumbnail preview - on mouse click, mouse leave, and video play/seek. All four are required, e.g., for buffering
                this.bind(elements.progress, 'mouseleave touchend click', ()=>{
                    const { previewThumbnails: previewThumbnails } = player;
                    if (previewThumbnails && previewThumbnails.loaded) previewThumbnails.endMove(false, true);
                });
                // Show scrubbing preview
                this.bind(elements.progress, 'mousedown touchstart', (event)=>{
                    const { previewThumbnails: previewThumbnails } = player;
                    if (previewThumbnails && previewThumbnails.loaded) previewThumbnails.startScrubbing(event);
                });
                this.bind(elements.progress, 'mouseup touchend', (event)=>{
                    const { previewThumbnails: previewThumbnails } = player;
                    if (previewThumbnails && previewThumbnails.loaded) previewThumbnails.endScrubbing(event);
                });
                // Polyfill for lower fill in <input type="range"> for webkit
                if (browser.isWebkit) Array.from(getElements.call(player, 'input[type="range"]')).forEach((element)=>{
                    this.bind(element, 'input', (event)=>controls.updateRangeFill.call(player, event.target));
                });
                // Current time invert
                // Only if one time element is used for both currentTime and duration
                if (player.config.toggleInvert && !is.element(elements.display.duration)) this.bind(elements.display.currentTime, 'click', ()=>{
                    // Do nothing if we're at the start
                    if (player.currentTime === 0) return;
                    player.config.invertTime = !player.config.invertTime;
                    controls.timeUpdate.call(player);
                });
                // Volume
                this.bind(elements.inputs.volume, inputEvent, (event)=>{
                    player.volume = event.target.value;
                }, 'volume');
                // Update controls.hover state (used for ui.toggleControls to avoid hiding when interacting)
                this.bind(elements.controls, 'mouseenter mouseleave', (event)=>{
                    elements.controls.hover = !player.touch && event.type === 'mouseenter';
                });
                // Also update controls.hover state for any non-player children of fullscreen element (as above)
                if (elements.fullscreen) Array.from(elements.fullscreen.children).filter((c)=>!c.contains(elements.container)).forEach((child)=>{
                    this.bind(child, 'mouseenter mouseleave', (event)=>{
                        if (elements.controls) elements.controls.hover = !player.touch && event.type === 'mouseenter';
                    });
                });
                // Update controls.pressed state (used for ui.toggleControls to avoid hiding when interacting)
                this.bind(elements.controls, 'mousedown mouseup touchstart touchend touchcancel', (event)=>{
                    elements.controls.pressed = [
                        'mousedown',
                        'touchstart'
                    ].includes(event.type);
                });
                // Show controls when they receive focus (e.g., when using keyboard tab key)
                this.bind(elements.controls, 'focusin', ()=>{
                    const { config: config, timers: timers } = player;
                    // Skip transition to prevent focus from scrolling the parent element
                    toggleClass(elements.controls, config.classNames.noTransition, true);
                    // Toggle
                    ui.toggleControls.call(player, true);
                    // Restore transition
                    setTimeout(()=>{
                        toggleClass(elements.controls, config.classNames.noTransition, false);
                    }, 0);
                    // Delay a little more for mouse users
                    const delay = this.touch ? 3000 : 4000;
                    // Clear timer
                    clearTimeout(timers.controls);
                    // Hide again after delay
                    timers.controls = setTimeout(()=>ui.toggleControls.call(player, false), delay);
                });
                // Mouse wheel for volume
                this.bind(elements.inputs.volume, 'wheel', (event)=>{
                    // Detect "natural" scroll - supported on OS X Safari only
                    // Other browsers on OS X will be inverted until support improves
                    const inverted = event.webkitDirectionInvertedFromDevice;
                    // Get delta from event. Invert if `inverted` is true
                    const [x, y] = [
                        event.deltaX,
                        -event.deltaY
                    ].map((value)=>inverted ? -value : value);
                    // Using the biggest delta, normalize to 1 or -1 (or 0 if no delta)
                    const direction = Math.sign(Math.abs(x) > Math.abs(y) ? x : y);
                    // Change the volume by 2%
                    player.increaseVolume(direction / 50);
                    // Don't break page scrolling at max and min
                    const { volume: volume } = player.media;
                    if (direction === 1 && volume < 1 || direction === -1 && volume > 0) event.preventDefault();
                }, 'volume', false);
            });
            this.player = _player;
            this.lastKey = null;
            this.focusTimer = null;
            this.lastKeyDown = null;
            this.handleKey = this.handleKey.bind(this);
            this.toggleMenu = this.toggleMenu.bind(this);
            this.setTabFocus = this.setTabFocus.bind(this);
            this.firstTouch = this.firstTouch.bind(this);
        }
        // Handle key presses
        handleKey(event) {
            const { player: player } = this;
            const { elements: elements } = player;
            const { key: key, type: type, altKey: altKey, ctrlKey: ctrlKey, metaKey: metaKey, shiftKey: shiftKey } = event;
            const pressed = type === 'keydown';
            const repeat = pressed && key === this.lastKey;
            // Bail if a modifier key is set
            if (altKey || ctrlKey || metaKey || shiftKey) return;
            // If the event is bubbled from the media element
            // Firefox doesn't get the key for whatever reason
            if (!key) return;
            // Seek by increment
            const seekByIncrement = (increment)=>{
                // Divide the max duration into 10th's and times by the number value
                player.currentTime = player.duration / 10 * increment;
            };
            // Handle the key on keydown
            // Reset on keyup
            if (pressed) {
                // Check focused element
                // and if the focused element is not editable (e.g. text input)
                // and any that accept key input http://webaim.org/techniques/keyboard/
                const focused = document.activeElement;
                if (is.element(focused)) {
                    const { editable: editable } = player.config.selectors;
                    const { seek: seek } = elements.inputs;
                    if (focused !== seek && matches(focused, editable)) return;
                    if (event.key === 'Space' && matches(focused, 'button, [role^="menuitem"]')) return;
                }
                // Which keys should we prevent default
                const preventDefault = [
                    'Space',
                    'ArrowLeft',
                    'ArrowUp',
                    'ArrowRight',
                    'ArrowDown',
                    '0',
                    '1',
                    '2',
                    '3',
                    '4',
                    '5',
                    '6',
                    '7',
                    '8',
                    '9',
                    'c',
                    'f',
                    'k',
                    'l',
                    'm'
                ];
                // If the key is found prevent default (e.g. prevent scrolling for arrows)
                if (preventDefault.includes(key)) {
                    event.preventDefault();
                    event.stopPropagation();
                }
                switch(key){
                    case '0':
                    case '1':
                    case '2':
                    case '3':
                    case '4':
                    case '5':
                    case '6':
                    case '7':
                    case '8':
                    case '9':
                        if (!repeat) seekByIncrement(parseInt(key, 10));
                        break;
                    case 'Space':
                    case 'k':
                        if (!repeat) silencePromise(player.togglePlay());
                        break;
                    case 'ArrowUp':
                        player.increaseVolume(0.1);
                        break;
                    case 'ArrowDown':
                        player.decreaseVolume(0.1);
                        break;
                    case 'm':
                        if (!repeat) player.muted = !player.muted;
                        break;
                    case 'ArrowRight':
                        player.forward();
                        break;
                    case 'ArrowLeft':
                        player.rewind();
                        break;
                    case 'f':
                        player.fullscreen.toggle();
                        break;
                    case 'c':
                        if (!repeat) player.toggleCaptions();
                        break;
                    case 'l':
                        player.loop = !player.loop;
                        break;
                }
                // Escape is handle natively when in full screen
                // So we only need to worry about non native
                if (key === 'Escape' && !player.fullscreen.usingNative && player.fullscreen.active) player.fullscreen.toggle();
                // Store last key for next cycle
                this.lastKey = key;
            } else this.lastKey = null;
        }
        // Toggle menu
        toggleMenu(event) {
            controls.toggleMenu.call(this.player, event);
        }
    }
    var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof $parcel$global !== 'undefined' ? $parcel$global : typeof self !== 'undefined' ? self : {};
    function createCommonjsModule(fn, module1) {
        return module1 = {
            exports: {}
        }, fn(module1, module1.exports), module1.exports;
    }
    var loadjs_umd = createCommonjsModule(function(module1, exports) {
        (function(root, factory) {
            module1.exports = factory();
        })(commonjsGlobal, function() {
            /**
       * Global dependencies.
       * @global {Object} document - DOM
       */ var devnull = function() {}, bundleIdCache = {}, bundleResultCache = {}, bundleCallbackQueue = {};
            /**
       * Subscribe to bundle load event.
       * @param {string[]} bundleIds - Bundle ids
       * @param {Function} callbackFn - The callback function
       */ function subscribe(bundleIds, callbackFn) {
                // listify
                bundleIds = bundleIds.push ? bundleIds : [
                    bundleIds
                ];
                var depsNotFound = [], i = bundleIds.length, numWaiting = i, fn, bundleId, r, q;
                // define callback function
                fn = function(bundleId, pathsNotFound) {
                    if (pathsNotFound.length) depsNotFound.push(bundleId);
                    numWaiting--;
                    if (!numWaiting) callbackFn(depsNotFound);
                };
                // register callback
                while(i--){
                    bundleId = bundleIds[i];
                    // execute callback if in result cache
                    r = bundleResultCache[bundleId];
                    if (r) {
                        fn(bundleId, r);
                        continue;
                    }
                    // add to callback queue
                    q = bundleCallbackQueue[bundleId] = bundleCallbackQueue[bundleId] || [];
                    q.push(fn);
                }
            }
            /**
       * Publish bundle load event.
       * @param {string} bundleId - Bundle id
       * @param {string[]} pathsNotFound - List of files not found
       */ function publish(bundleId, pathsNotFound) {
                // exit if id isn't defined
                if (!bundleId) return;
                var q = bundleCallbackQueue[bundleId];
                // cache result
                bundleResultCache[bundleId] = pathsNotFound;
                // exit if queue is empty
                if (!q) return;
                // empty callback queue
                while(q.length){
                    q[0](bundleId, pathsNotFound);
                    q.splice(0, 1);
                }
            }
            /**
       * Execute callbacks.
       * @param {Object or Function} args - The callback args
       * @param {string[]} depsNotFound - List of dependencies not found
       */ function executeCallbacks(args, depsNotFound) {
                // accept function as argument
                if (args.call) args = {
                    success: args
                };
                // success and error callbacks
                if (depsNotFound.length) (args.error || devnull)(depsNotFound);
                else (args.success || devnull)(args);
            }
            /**
       * Load individual file.
       * @param {string} path - The file path
       * @param {Function} callbackFn - The callback function
       */ function loadFile(path, callbackFn, args, numTries) {
                var doc = document, async = args.async, maxTries = (args.numRetries || 0) + 1, beforeCallbackFn = args.before || devnull, pathname = path.replace(/[\?|#].*$/, ''), pathStripped = path.replace(/^(css|img)!/, ''), isLegacyIECss, e;
                numTries = numTries || 0;
                if (/(^css!|\.css$)/.test(pathname)) {
                    // css
                    e = doc.createElement('link');
                    e.rel = 'stylesheet';
                    e.href = pathStripped;
                    // tag IE9+
                    isLegacyIECss = 'hideFocus' in e;
                    // use preload in IE Edge (to detect load errors)
                    if (isLegacyIECss && e.relList) {
                        isLegacyIECss = 0;
                        e.rel = 'preload';
                        e.as = 'style';
                    }
                } else if (/(^img!|\.(png|gif|jpg|svg|webp)$)/.test(pathname)) {
                    // image
                    e = doc.createElement('img');
                    e.src = pathStripped;
                } else {
                    // javascript
                    e = doc.createElement('script');
                    e.src = path;
                    e.async = async === undefined ? true : async;
                }
                e.onload = e.onerror = e.onbeforeload = function(ev) {
                    var result = ev.type[0];
                    // treat empty stylesheets as failures to get around lack of onerror
                    // support in IE9-11
                    if (isLegacyIECss) try {
                        if (!e.sheet.cssText.length) result = 'e';
                    } catch (x) {
                        // sheets objects created from load errors don't allow access to
                        // `cssText` (unless error is Code:18 SecurityError)
                        if (x.code != 18) result = 'e';
                    }
                    // handle retries in case of load failure
                    if (result == 'e') {
                        // increment counter
                        numTries += 1;
                        // exit function and try again
                        if (numTries < maxTries) return loadFile(path, callbackFn, args, numTries);
                    } else if (e.rel == 'preload' && e.as == 'style') // activate preloaded stylesheets
                    return e.rel = 'stylesheet'; // jshint ignore:line
                    // execute callback
                    callbackFn(path, result, ev.defaultPrevented);
                };
                // add to document (unless callback returns `false`)
                if (beforeCallbackFn(path, e) !== false) doc.head.appendChild(e);
            }
            /**
       * Load multiple files.
       * @param {string[]} paths - The file paths
       * @param {Function} callbackFn - The callback function
       */ function loadFiles(paths, callbackFn, args) {
                // listify paths
                paths = paths.push ? paths : [
                    paths
                ];
                var numWaiting = paths.length, x = numWaiting, pathsNotFound = [], fn, i;
                // define callback function
                fn = function(path, result, defaultPrevented) {
                    // handle error
                    if (result == 'e') pathsNotFound.push(path);
                    // handle beforeload event. If defaultPrevented then that means the load
                    // will be blocked (ex. Ghostery/ABP on Safari)
                    if (result == 'b') {
                        if (defaultPrevented) pathsNotFound.push(path);
                        else return;
                    }
                    numWaiting--;
                    if (!numWaiting) callbackFn(pathsNotFound);
                };
                // load scripts
                for(i = 0; i < x; i++)loadFile(paths[i], fn, args);
            }
            /**
       * Initiate script load and register bundle.
       * @param {(string|string[])} paths - The file paths
       * @param {(string|Function|Object)} [arg1] - The (1) bundleId or (2) success
       *   callback or (3) object literal with success/error arguments, numRetries,
       *   etc.
       * @param {(Function|Object)} [arg2] - The (1) success callback or (2) object
       *   literal with success/error arguments, numRetries, etc.
       */ function loadjs(paths, arg1, arg2) {
                var bundleId, args;
                // bundleId (if string)
                if (arg1 && arg1.trim) bundleId = arg1;
                // args (default is {})
                args = (bundleId ? arg2 : arg1) || {};
                // throw error if bundle is already defined
                if (bundleId) {
                    if (bundleId in bundleIdCache) throw "LoadJS";
                    else bundleIdCache[bundleId] = true;
                }
                function loadFn(resolve, reject) {
                    loadFiles(paths, function(pathsNotFound) {
                        // execute callbacks
                        executeCallbacks(args, pathsNotFound);
                        // resolve Promise
                        if (resolve) executeCallbacks({
                            success: resolve,
                            error: reject
                        }, pathsNotFound);
                        // publish bundle load event
                        publish(bundleId, pathsNotFound);
                    }, args);
                }
                if (args.returnPromise) return new Promise(loadFn);
                else loadFn();
            }
            /**
       * Execute callbacks when dependencies have been satisfied.
       * @param {(string|string[])} deps - List of bundle ids
       * @param {Object} args - success/error arguments
       */ loadjs.ready = function ready(deps, args) {
                // subscribe to bundle load event
                subscribe(deps, function(depsNotFound) {
                    // execute callbacks
                    executeCallbacks(args, depsNotFound);
                });
                return loadjs;
            };
            /**
       * Manually satisfy bundle dependencies.
       * @param {string} bundleId - The bundle id
       */ loadjs.done = function done(bundleId) {
                publish(bundleId, []);
            };
            /**
       * Reset loadjs dependencies statuses
       */ loadjs.reset = function reset() {
                bundleIdCache = {};
                bundleResultCache = {};
                bundleCallbackQueue = {};
            };
            /**
       * Determine if bundle has already been defined
       * @param String} bundleId - The bundle id
       */ loadjs.isDefined = function isDefined(bundleId) {
                return bundleId in bundleIdCache;
            };
            // export
            return loadjs;
        });
    });
    // ==========================================================================
    function loadScript(url) {
        return new Promise((resolve, reject)=>{
            loadjs_umd(url, {
                success: resolve,
                error: reject
            });
        });
    }
    // ==========================================================================
    // Parse Vimeo ID from URL
    function parseId$1(url) {
        if (is.empty(url)) return null;
        if (is.number(Number(url))) return url;
        const regex = /^.*(vimeo.com\/|video\/)(\d+).*/;
        return url.match(regex) ? RegExp.$2 : url;
    }
    // Try to extract a hash for private videos from the URL
    function parseHash(url) {
        /* This regex matches a hexadecimal hash if given in any of these forms:
     *  - [https://player.]vimeo.com/video/{id}/{hash}[?params]
     *  - [https://player.]vimeo.com/video/{id}?h={hash}[&params]
     *  - [https://player.]vimeo.com/video/{id}?[params]&h={hash}
     *  - video/{id}/{hash}
     * If matched, the hash is available in capture group 4
     */ const regex = /^.*(vimeo.com\/|video\/)(\d+)(\?.*&*h=|\/)+([\d,a-f]+)/;
        const found = url.match(regex);
        return found && found.length === 5 ? found[4] : null;
    }
    // Set playback state and trigger change (only on actual change)
    function assurePlaybackState$1(play) {
        if (play && !this.embed.hasPlayed) this.embed.hasPlayed = true;
        if (this.media.paused === play) {
            this.media.paused = !play;
            triggerEvent.call(this, this.media, play ? 'play' : 'pause');
        }
    }
    const vimeo = {
        setup () {
            const player = this;
            // Add embed class for responsive
            toggleClass(player.elements.wrapper, player.config.classNames.embed, true);
            // Set speed options from config
            player.options.speed = player.config.speed.options;
            // Set intial ratio
            setAspectRatio.call(player);
            // Load the SDK if not already
            if (!is.object(window.Vimeo)) loadScript(player.config.urls.vimeo.sdk).then(()=>{
                vimeo.ready.call(player);
            }).catch((error)=>{
                player.debug.warn('Vimeo SDK (player.js) failed to load', error);
            });
            else vimeo.ready.call(player);
        },
        // API Ready
        ready () {
            const player = this;
            const config = player.config.vimeo;
            const { premium: premium, referrerPolicy: referrerPolicy, ...frameParams } = config;
            // Get the source URL or ID
            let source = player.media.getAttribute('src');
            let hash = '';
            // Get from <div> if needed
            if (is.empty(source)) {
                source = player.media.getAttribute(player.config.attributes.embed.id);
                // hash can also be set as attribute on the <div>
                hash = player.media.getAttribute(player.config.attributes.embed.hash);
            } else hash = parseHash(source);
            const hashParam = hash ? {
                h: hash
            } : {};
            // If the owner has a pro or premium account then we can hide controls etc
            if (premium) Object.assign(frameParams, {
                controls: false,
                sidedock: false
            });
            // Get Vimeo params for the iframe
            const params = buildUrlParams({
                loop: player.config.loop.active,
                autoplay: player.autoplay,
                muted: player.muted,
                gesture: 'media',
                playsinline: !this.config.fullscreen.iosNative,
                // hash has to be added to iframe-URL
                ...hashParam,
                ...frameParams
            });
            const id = parseId$1(source);
            // Build an iframe
            const iframe = createElement('iframe');
            const src = format(player.config.urls.vimeo.iframe, id, params);
            iframe.setAttribute('src', src);
            iframe.setAttribute('allowfullscreen', '');
            iframe.setAttribute('allow', [
                'autoplay',
                'fullscreen',
                'picture-in-picture',
                'encrypted-media',
                'accelerometer',
                'gyroscope'
            ].join('; '));
            // Set the referrer policy if required
            if (!is.empty(referrerPolicy)) iframe.setAttribute('referrerPolicy', referrerPolicy);
            // Inject the package
            if (premium || !config.customControls) {
                iframe.setAttribute('data-poster', player.poster);
                player.media = replaceElement(iframe, player.media);
            } else {
                const wrapper = createElement('div', {
                    class: player.config.classNames.embedContainer,
                    'data-poster': player.poster
                });
                wrapper.appendChild(iframe);
                player.media = replaceElement(wrapper, player.media);
            }
            // Get poster image
            if (!config.customControls) fetch(format(player.config.urls.vimeo.api, src)).then((response)=>{
                if (is.empty(response) || !response.thumbnail_url) return;
                // Set and show poster
                ui.setPoster.call(player, response.thumbnail_url).catch(()=>{});
            });
            // Setup instance
            // https://github.com/vimeo/player.js
            player.embed = new window.Vimeo.Player(iframe, {
                autopause: player.config.autopause,
                muted: player.muted
            });
            player.media.paused = true;
            player.media.currentTime = 0;
            // Disable native text track rendering
            if (player.supported.ui) player.embed.disableTextTrack();
            // Create a faux HTML5 API using the Vimeo API
            player.media.play = ()=>{
                assurePlaybackState$1.call(player, true);
                return player.embed.play();
            };
            player.media.pause = ()=>{
                assurePlaybackState$1.call(player, false);
                return player.embed.pause();
            };
            player.media.stop = ()=>{
                player.pause();
                player.currentTime = 0;
            };
            // Seeking
            let { currentTime: currentTime } = player.media;
            Object.defineProperty(player.media, 'currentTime', {
                get () {
                    return currentTime;
                },
                set (time) {
                    // Vimeo will automatically play on seek if the video hasn't been played before
                    // Get current paused state and volume etc
                    const { embed: embed, media: media, paused: paused, volume: volume } = player;
                    const restorePause = paused && !embed.hasPlayed;
                    // Set seeking state and trigger event
                    media.seeking = true;
                    triggerEvent.call(player, media, 'seeking');
                    // If paused, mute until seek is complete
                    Promise.resolve(restorePause && embed.setVolume(0))// Seek
                    .then(()=>embed.setCurrentTime(time))// Restore paused
                    .then(()=>restorePause && embed.pause())// Restore volume
                    .then(()=>restorePause && embed.setVolume(volume)).catch(()=>{
                    // Do nothing
                    });
                }
            });
            // Playback speed
            let speed = player.config.speed.selected;
            Object.defineProperty(player.media, 'playbackRate', {
                get () {
                    return speed;
                },
                set (input) {
                    player.embed.setPlaybackRate(input).then(()=>{
                        speed = input;
                        triggerEvent.call(player, player.media, 'ratechange');
                    }).catch(()=>{
                        // Cannot set Playback Rate, Video is probably not on Pro account
                        player.options.speed = [
                            1
                        ];
                    });
                }
            });
            // Volume
            let { volume: volume } = player.config;
            Object.defineProperty(player.media, 'volume', {
                get () {
                    return volume;
                },
                set (input) {
                    player.embed.setVolume(input).then(()=>{
                        volume = input;
                        triggerEvent.call(player, player.media, 'volumechange');
                    });
                }
            });
            // Muted
            let { muted: muted } = player.config;
            Object.defineProperty(player.media, 'muted', {
                get () {
                    return muted;
                },
                set (input) {
                    const toggle = is.boolean(input) ? input : false;
                    player.embed.setVolume(toggle ? 0 : player.config.volume).then(()=>{
                        muted = toggle;
                        triggerEvent.call(player, player.media, 'volumechange');
                    });
                }
            });
            // Loop
            let { loop: loop } = player.config;
            Object.defineProperty(player.media, 'loop', {
                get () {
                    return loop;
                },
                set (input) {
                    const toggle = is.boolean(input) ? input : player.config.loop.active;
                    player.embed.setLoop(toggle).then(()=>{
                        loop = toggle;
                    });
                }
            });
            // Source
            let currentSrc;
            player.embed.getVideoUrl().then((value)=>{
                currentSrc = value;
                controls.setDownloadUrl.call(player);
            }).catch((error)=>{
                this.debug.warn(error);
            });
            Object.defineProperty(player.media, 'currentSrc', {
                get () {
                    return currentSrc;
                }
            });
            // Ended
            Object.defineProperty(player.media, 'ended', {
                get () {
                    return player.currentTime === player.duration;
                }
            });
            // Set aspect ratio based on video size
            Promise.all([
                player.embed.getVideoWidth(),
                player.embed.getVideoHeight()
            ]).then((dimensions)=>{
                const [width, height] = dimensions;
                player.embed.ratio = roundAspectRatio(width, height);
                setAspectRatio.call(this);
            });
            // Set autopause
            player.embed.setAutopause(player.config.autopause).then((state)=>{
                player.config.autopause = state;
            });
            // Get title
            player.embed.getVideoTitle().then((title)=>{
                player.config.title = title;
                ui.setTitle.call(this);
            });
            // Get current time
            player.embed.getCurrentTime().then((value)=>{
                currentTime = value;
                triggerEvent.call(player, player.media, 'timeupdate');
            });
            // Get duration
            player.embed.getDuration().then((value)=>{
                player.media.duration = value;
                triggerEvent.call(player, player.media, 'durationchange');
            });
            // Get captions
            player.embed.getTextTracks().then((tracks)=>{
                player.media.textTracks = tracks;
                captions.setup.call(player);
            });
            player.embed.on('cuechange', ({ cues: cues = [] })=>{
                const strippedCues = cues.map((cue)=>stripHTML(cue.text));
                captions.updateCues.call(player, strippedCues);
            });
            player.embed.on('loaded', ()=>{
                // Assure state and events are updated on autoplay
                player.embed.getPaused().then((paused)=>{
                    assurePlaybackState$1.call(player, !paused);
                    if (!paused) triggerEvent.call(player, player.media, 'playing');
                });
                if (is.element(player.embed.element) && player.supported.ui) {
                    const frame = player.embed.element;
                    // Fix keyboard focus issues
                    // https://github.com/sampotts/plyr/issues/317
                    frame.setAttribute('tabindex', -1);
                }
            });
            player.embed.on('bufferstart', ()=>{
                triggerEvent.call(player, player.media, 'waiting');
            });
            player.embed.on('bufferend', ()=>{
                triggerEvent.call(player, player.media, 'playing');
            });
            player.embed.on('play', ()=>{
                assurePlaybackState$1.call(player, true);
                triggerEvent.call(player, player.media, 'playing');
            });
            player.embed.on('pause', ()=>{
                assurePlaybackState$1.call(player, false);
            });
            player.embed.on('timeupdate', (data)=>{
                player.media.seeking = false;
                currentTime = data.seconds;
                triggerEvent.call(player, player.media, 'timeupdate');
            });
            player.embed.on('progress', (data)=>{
                player.media.buffered = data.percent;
                triggerEvent.call(player, player.media, 'progress');
                // Check all loaded
                if (parseInt(data.percent, 10) === 1) triggerEvent.call(player, player.media, 'canplaythrough');
                // Get duration as if we do it before load, it gives an incorrect value
                // https://github.com/sampotts/plyr/issues/891
                player.embed.getDuration().then((value)=>{
                    if (value !== player.media.duration) {
                        player.media.duration = value;
                        triggerEvent.call(player, player.media, 'durationchange');
                    }
                });
            });
            player.embed.on('seeked', ()=>{
                player.media.seeking = false;
                triggerEvent.call(player, player.media, 'seeked');
            });
            player.embed.on('ended', ()=>{
                player.media.paused = true;
                triggerEvent.call(player, player.media, 'ended');
            });
            player.embed.on('error', (detail)=>{
                player.media.error = detail;
                triggerEvent.call(player, player.media, 'error');
            });
            // Rebuild UI
            if (config.customControls) setTimeout(()=>ui.build.call(player), 0);
        }
    };
    // ==========================================================================
    // Parse YouTube ID from URL
    function parseId(url) {
        if (is.empty(url)) return null;
        const regex = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
        return url.match(regex) ? RegExp.$2 : url;
    }
    // Set playback state and trigger change (only on actual change)
    function assurePlaybackState(play) {
        if (play && !this.embed.hasPlayed) this.embed.hasPlayed = true;
        if (this.media.paused === play) {
            this.media.paused = !play;
            triggerEvent.call(this, this.media, play ? 'play' : 'pause');
        }
    }
    function getHost(config) {
        if (config.noCookie) return 'https://www.youtube-nocookie.com';
        if (window.location.protocol === 'http:') return 'http://www.youtube.com';
        // Use YouTube's default
        return undefined;
    }
    const youtube = {
        setup () {
            // Add embed class for responsive
            toggleClass(this.elements.wrapper, this.config.classNames.embed, true);
            // Setup API
            if (is.object(window.YT) && is.function(window.YT.Player)) youtube.ready.call(this);
            else {
                // Reference current global callback
                const callback = window.onYouTubeIframeAPIReady;
                // Set callback to process queue
                window.onYouTubeIframeAPIReady = ()=>{
                    // Call global callback if set
                    if (is.function(callback)) callback();
                    youtube.ready.call(this);
                };
                // Load the SDK
                loadScript(this.config.urls.youtube.sdk).catch((error)=>{
                    this.debug.warn('YouTube API failed to load', error);
                });
            }
        },
        // Get the media title
        getTitle (videoId) {
            const url = format(this.config.urls.youtube.api, videoId);
            fetch(url).then((data)=>{
                if (is.object(data)) {
                    const { title: title, height: height, width: width } = data;
                    // Set title
                    this.config.title = title;
                    ui.setTitle.call(this);
                    // Set aspect ratio
                    this.embed.ratio = roundAspectRatio(width, height);
                }
                setAspectRatio.call(this);
            }).catch(()=>{
                // Set aspect ratio
                setAspectRatio.call(this);
            });
        },
        // API ready
        ready () {
            const player = this;
            const config = player.config.youtube;
            // Ignore already setup (race condition)
            const currentId = player.media && player.media.getAttribute('id');
            if (!is.empty(currentId) && currentId.startsWith('youtube-')) return;
            // Get the source URL or ID
            let source = player.media.getAttribute('src');
            // Get from <div> if needed
            if (is.empty(source)) source = player.media.getAttribute(this.config.attributes.embed.id);
            // Replace the <iframe> with a <div> due to YouTube API issues
            const videoId = parseId(source);
            const id = generateId(player.provider);
            // Replace media element
            const container = createElement('div', {
                id: id,
                'data-poster': config.customControls ? player.poster : undefined
            });
            player.media = replaceElement(container, player.media);
            // Only load the poster when using custom controls
            if (config.customControls) {
                const posterSrc = (s)=>`https://i.ytimg.com/vi/${videoId}/${s}default.jpg`;
                // Check thumbnail images in order of quality, but reject fallback thumbnails (120px wide)
                loadImage(posterSrc('maxres'), 121) // Higest quality and unpadded
                .catch(()=>loadImage(posterSrc('sd'), 121)) // 480p padded 4:3
                .catch(()=>loadImage(posterSrc('hq'))) // 360p padded 4:3. Always exists
                .then((image)=>ui.setPoster.call(player, image.src)).then((src)=>{
                    // If the image is padded, use background-size "cover" instead (like youtube does too with their posters)
                    if (!src.includes('maxres')) player.elements.poster.style.backgroundSize = 'cover';
                }).catch(()=>{});
            }
            // Setup instance
            // https://developers.google.com/youtube/iframe_api_reference
            player.embed = new window.YT.Player(player.media, {
                videoId: videoId,
                host: getHost(config),
                playerVars: extend({}, {
                    // Autoplay
                    autoplay: player.config.autoplay ? 1 : 0,
                    // iframe interface language
                    hl: player.config.hl,
                    // Only show controls if not fully supported or opted out
                    controls: player.supported.ui && config.customControls ? 0 : 1,
                    // Disable keyboard as we handle it
                    disablekb: 1,
                    // Allow iOS inline playback
                    playsinline: !player.config.fullscreen.iosNative ? 1 : 0,
                    // Captions are flaky on YouTube
                    cc_load_policy: player.captions.active ? 1 : 0,
                    cc_lang_pref: player.config.captions.language,
                    // Tracking for stats
                    widget_referrer: window ? window.location.href : null
                }, config),
                events: {
                    onError (event) {
                        // YouTube may fire onError twice, so only handle it once
                        if (!player.media.error) {
                            const code = event.data;
                            // Messages copied from https://developers.google.com/youtube/iframe_api_reference#onError
                            const message = {
                                2: 'The request contains an invalid parameter value. For example, this error occurs if you specify a video ID that does not have 11 characters, or if the video ID contains invalid characters, such as exclamation points or asterisks.',
                                5: 'The requested content cannot be played in an HTML5 player or another error related to the HTML5 player has occurred.',
                                100: 'The video requested was not found. This error occurs when a video has been removed (for any reason) or has been marked as private.',
                                101: 'The owner of the requested video does not allow it to be played in embedded players.',
                                150: 'The owner of the requested video does not allow it to be played in embedded players.'
                            }[code] || 'An unknown error occured';
                            player.media.error = {
                                code: code,
                                message: message
                            };
                            triggerEvent.call(player, player.media, 'error');
                        }
                    },
                    onPlaybackRateChange (event) {
                        // Get the instance
                        const instance = event.target;
                        // Get current speed
                        player.media.playbackRate = instance.getPlaybackRate();
                        triggerEvent.call(player, player.media, 'ratechange');
                    },
                    onReady (event) {
                        // Bail if onReady has already been called. See issue #1108
                        if (is.function(player.media.play)) return;
                        // Get the instance
                        const instance = event.target;
                        // Get the title
                        youtube.getTitle.call(player, videoId);
                        // Create a faux HTML5 API using the YouTube API
                        player.media.play = ()=>{
                            assurePlaybackState.call(player, true);
                            instance.playVideo();
                        };
                        player.media.pause = ()=>{
                            assurePlaybackState.call(player, false);
                            instance.pauseVideo();
                        };
                        player.media.stop = ()=>{
                            instance.stopVideo();
                        };
                        player.media.duration = instance.getDuration();
                        player.media.paused = true;
                        // Seeking
                        player.media.currentTime = 0;
                        Object.defineProperty(player.media, 'currentTime', {
                            get () {
                                return Number(instance.getCurrentTime());
                            },
                            set (time) {
                                // If paused and never played, mute audio preventively (YouTube starts playing on seek if the video hasn't been played yet).
                                if (player.paused && !player.embed.hasPlayed) player.embed.mute();
                                // Set seeking state and trigger event
                                player.media.seeking = true;
                                triggerEvent.call(player, player.media, 'seeking');
                                // Seek after events sent
                                instance.seekTo(time);
                            }
                        });
                        // Playback speed
                        Object.defineProperty(player.media, 'playbackRate', {
                            get () {
                                return instance.getPlaybackRate();
                            },
                            set (input) {
                                instance.setPlaybackRate(input);
                            }
                        });
                        // Volume
                        let { volume: volume } = player.config;
                        Object.defineProperty(player.media, 'volume', {
                            get () {
                                return volume;
                            },
                            set (input) {
                                volume = input;
                                instance.setVolume(volume * 100);
                                triggerEvent.call(player, player.media, 'volumechange');
                            }
                        });
                        // Muted
                        let { muted: muted } = player.config;
                        Object.defineProperty(player.media, 'muted', {
                            get () {
                                return muted;
                            },
                            set (input) {
                                const toggle = is.boolean(input) ? input : muted;
                                muted = toggle;
                                instance[toggle ? 'mute' : 'unMute']();
                                instance.setVolume(volume * 100);
                                triggerEvent.call(player, player.media, 'volumechange');
                            }
                        });
                        // Source
                        Object.defineProperty(player.media, 'currentSrc', {
                            get () {
                                return instance.getVideoUrl();
                            }
                        });
                        // Ended
                        Object.defineProperty(player.media, 'ended', {
                            get () {
                                return player.currentTime === player.duration;
                            }
                        });
                        // Get available speeds
                        const speeds = instance.getAvailablePlaybackRates();
                        // Filter based on config
                        player.options.speed = speeds.filter((s)=>player.config.speed.options.includes(s));
                        // Set the tabindex to avoid focus entering iframe
                        if (player.supported.ui && config.customControls) player.media.setAttribute('tabindex', -1);
                        triggerEvent.call(player, player.media, 'timeupdate');
                        triggerEvent.call(player, player.media, 'durationchange');
                        // Reset timer
                        clearInterval(player.timers.buffering);
                        // Setup buffering
                        player.timers.buffering = setInterval(()=>{
                            // Get loaded % from YouTube
                            player.media.buffered = instance.getVideoLoadedFraction();
                            // Trigger progress only when we actually buffer something
                            if (player.media.lastBuffered === null || player.media.lastBuffered < player.media.buffered) triggerEvent.call(player, player.media, 'progress');
                            // Set last buffer point
                            player.media.lastBuffered = player.media.buffered;
                            // Bail if we're at 100%
                            if (player.media.buffered === 1) {
                                clearInterval(player.timers.buffering);
                                // Trigger event
                                triggerEvent.call(player, player.media, 'canplaythrough');
                            }
                        }, 200);
                        // Rebuild UI
                        if (config.customControls) setTimeout(()=>ui.build.call(player), 50);
                    },
                    onStateChange (event) {
                        // Get the instance
                        const instance = event.target;
                        // Reset timer
                        clearInterval(player.timers.playing);
                        const seeked = player.media.seeking && [
                            1,
                            2
                        ].includes(event.data);
                        if (seeked) {
                            // Unset seeking and fire seeked event
                            player.media.seeking = false;
                            triggerEvent.call(player, player.media, 'seeked');
                        }
                        // Handle events
                        // -1   Unstarted
                        // 0    Ended
                        // 1    Playing
                        // 2    Paused
                        // 3    Buffering
                        // 5    Video cued
                        switch(event.data){
                            case -1:
                                // Update scrubber
                                triggerEvent.call(player, player.media, 'timeupdate');
                                // Get loaded % from YouTube
                                player.media.buffered = instance.getVideoLoadedFraction();
                                triggerEvent.call(player, player.media, 'progress');
                                break;
                            case 0:
                                assurePlaybackState.call(player, false);
                                // YouTube doesn't support loop for a single video, so mimick it.
                                if (player.media.loop) {
                                    // YouTube needs a call to `stopVideo` before playing again
                                    instance.stopVideo();
                                    instance.playVideo();
                                } else triggerEvent.call(player, player.media, 'ended');
                                break;
                            case 1:
                                // Restore paused state (YouTube starts playing on seek if the video hasn't been played yet)
                                if (config.customControls && !player.config.autoplay && player.media.paused && !player.embed.hasPlayed) player.media.pause();
                                else {
                                    assurePlaybackState.call(player, true);
                                    triggerEvent.call(player, player.media, 'playing');
                                    // Poll to get playback progress
                                    player.timers.playing = setInterval(()=>{
                                        triggerEvent.call(player, player.media, 'timeupdate');
                                    }, 50);
                                    // Check duration again due to YouTube bug
                                    // https://github.com/sampotts/plyr/issues/374
                                    // https://code.google.com/p/gdata-issues/issues/detail?id=8690
                                    if (player.media.duration !== instance.getDuration()) {
                                        player.media.duration = instance.getDuration();
                                        triggerEvent.call(player, player.media, 'durationchange');
                                    }
                                }
                                break;
                            case 2:
                                // Restore audio (YouTube starts playing on seek if the video hasn't been played yet)
                                if (!player.muted) player.embed.unMute();
                                assurePlaybackState.call(player, false);
                                break;
                            case 3:
                                // Trigger waiting event to add loading classes to container as the video buffers.
                                triggerEvent.call(player, player.media, 'waiting');
                                break;
                        }
                        triggerEvent.call(player, player.elements.container, 'statechange', false, {
                            code: event.data
                        });
                    }
                }
            });
        }
    };
    // ==========================================================================
    const media = {
        // Setup media
        setup () {
            // If there's no media, bail
            if (!this.media) {
                this.debug.warn('No media element found!');
                return;
            }
            // Add type class
            toggleClass(this.elements.container, this.config.classNames.type.replace('{0}', this.type), true);
            // Add provider class
            toggleClass(this.elements.container, this.config.classNames.provider.replace('{0}', this.provider), true);
            // Add video class for embeds
            // This will require changes if audio embeds are added
            if (this.isEmbed) toggleClass(this.elements.container, this.config.classNames.type.replace('{0}', 'video'), true);
            // Inject the player wrapper
            if (this.isVideo) {
                // Create the wrapper div
                this.elements.wrapper = createElement('div', {
                    class: this.config.classNames.video
                });
                // Wrap the video in a container
                wrap(this.media, this.elements.wrapper);
                // Poster image container
                this.elements.poster = createElement('div', {
                    class: this.config.classNames.poster
                });
                this.elements.wrapper.appendChild(this.elements.poster);
            }
            if (this.isHTML5) html5.setup.call(this);
            else if (this.isYouTube) youtube.setup.call(this);
            else if (this.isVimeo) vimeo.setup.call(this);
        }
    };
    const destroy = (instance)=>{
        // Destroy our adsManager
        if (instance.manager) instance.manager.destroy();
        // Destroy our adsManager
        if (instance.elements.displayContainer) instance.elements.displayContainer.destroy();
        instance.elements.container.remove();
    };
    class Ads {
        /**
     * Ads constructor.
     * @param {Object} player
     * @return {Ads}
     */ constructor(player){
            _defineProperty$1(this, "load", ()=>{
                if (!this.enabled) return;
                // Check if the Google IMA3 SDK is loaded or load it ourselves
                if (!is.object(window.google) || !is.object(window.google.ima)) loadScript(this.player.config.urls.googleIMA.sdk).then(()=>{
                    this.ready();
                }).catch(()=>{
                    // Script failed to load or is blocked
                    this.trigger('error', new Error('Google IMA SDK failed to load'));
                });
                else this.ready();
            });
            _defineProperty$1(this, "ready", ()=>{
                // Double check we're enabled
                if (!this.enabled) destroy(this);
                // Start ticking our safety timer. If the whole advertisement
                // thing doesn't resolve within our set time; we bail
                this.startSafetyTimer(12000, 'ready()');
                // Clear the safety timer
                this.managerPromise.then(()=>{
                    this.clearSafetyTimer('onAdsManagerLoaded()');
                });
                // Set listeners on the Plyr instance
                this.listeners();
                // Setup the IMA SDK
                this.setupIMA();
            });
            _defineProperty$1(this, "setupIMA", ()=>{
                // Create the container for our advertisements
                this.elements.container = createElement('div', {
                    class: this.player.config.classNames.ads
                });
                this.player.elements.container.appendChild(this.elements.container);
                // So we can run VPAID2
                google.ima.settings.setVpaidMode(google.ima.ImaSdkSettings.VpaidMode.ENABLED);
                // Set language
                google.ima.settings.setLocale(this.player.config.ads.language);
                // Set playback for iOS10+
                google.ima.settings.setDisableCustomPlaybackForIOS10Plus(this.player.config.playsinline);
                // We assume the adContainer is the video container of the plyr element that will house the ads
                this.elements.displayContainer = new google.ima.AdDisplayContainer(this.elements.container, this.player.media);
                // Create ads loader
                this.loader = new google.ima.AdsLoader(this.elements.displayContainer);
                // Listen and respond to ads loaded and error events
                this.loader.addEventListener(google.ima.AdsManagerLoadedEvent.Type.ADS_MANAGER_LOADED, (event)=>this.onAdsManagerLoaded(event), false);
                this.loader.addEventListener(google.ima.AdErrorEvent.Type.AD_ERROR, (error)=>this.onAdError(error), false);
                // Request video ads to be pre-loaded
                this.requestAds();
            });
            _defineProperty$1(this, "requestAds", ()=>{
                const { container: container } = this.player.elements;
                try {
                    // Request video ads
                    const request = new google.ima.AdsRequest();
                    request.adTagUrl = this.tagUrl;
                    // Specify the linear and nonlinear slot sizes. This helps the SDK
                    // to select the correct creative if multiple are returned
                    request.linearAdSlotWidth = container.offsetWidth;
                    request.linearAdSlotHeight = container.offsetHeight;
                    request.nonLinearAdSlotWidth = container.offsetWidth;
                    request.nonLinearAdSlotHeight = container.offsetHeight;
                    // We only overlay ads as we only support video.
                    request.forceNonLinearFullSlot = false;
                    // Mute based on current state
                    request.setAdWillPlayMuted(!this.player.muted);
                    this.loader.requestAds(request);
                } catch (error) {
                    this.onAdError(error);
                }
            });
            _defineProperty$1(this, "pollCountdown", (start = false)=>{
                if (!start) {
                    clearInterval(this.countdownTimer);
                    this.elements.container.removeAttribute('data-badge-text');
                    return;
                }
                const update = ()=>{
                    const time = formatTime(Math.max(this.manager.getRemainingTime(), 0));
                    const label = `${i18n.get('advertisement', this.player.config)} - ${time}`;
                    this.elements.container.setAttribute('data-badge-text', label);
                };
                this.countdownTimer = setInterval(update, 100);
            });
            _defineProperty$1(this, "onAdsManagerLoaded", (event)=>{
                // Load could occur after a source change (race condition)
                if (!this.enabled) return;
                // Get the ads manager
                const settings = new google.ima.AdsRenderingSettings();
                // Tell the SDK to save and restore content video state on our behalf
                settings.restoreCustomPlaybackStateOnAdBreakComplete = true;
                settings.enablePreloading = true;
                // The SDK is polling currentTime on the contentPlayback. And needs a duration
                // so it can determine when to start the mid- and post-roll
                this.manager = event.getAdsManager(this.player, settings);
                // Get the cue points for any mid-rolls by filtering out the pre- and post-roll
                this.cuePoints = this.manager.getCuePoints();
                // Add listeners to the required events
                // Advertisement error events
                this.manager.addEventListener(google.ima.AdErrorEvent.Type.AD_ERROR, (error)=>this.onAdError(error));
                // Advertisement regular events
                Object.keys(google.ima.AdEvent.Type).forEach((type)=>{
                    this.manager.addEventListener(google.ima.AdEvent.Type[type], (e)=>this.onAdEvent(e));
                });
                // Resolve our adsManager
                this.trigger('loaded');
            });
            _defineProperty$1(this, "addCuePoints", ()=>{
                // Add advertisement cue's within the time line if available
                if (!is.empty(this.cuePoints)) this.cuePoints.forEach((cuePoint)=>{
                    if (cuePoint !== 0 && cuePoint !== -1 && cuePoint < this.player.duration) {
                        const seekElement = this.player.elements.progress;
                        if (is.element(seekElement)) {
                            const cuePercentage = 100 / this.player.duration * cuePoint;
                            const cue = createElement('span', {
                                class: this.player.config.classNames.cues
                            });
                            cue.style.left = `${cuePercentage.toString()}%`;
                            seekElement.appendChild(cue);
                        }
                    }
                });
            });
            _defineProperty$1(this, "onAdEvent", (event)=>{
                const { container: container } = this.player.elements;
                // Retrieve the ad from the event. Some events (e.g. ALL_ADS_COMPLETED)
                // don't have ad object associated
                const ad = event.getAd();
                const adData = event.getAdData();
                // Proxy event
                const dispatchEvent = (type)=>{
                    triggerEvent.call(this.player, this.player.media, `ads${type.replace(/_/g, '').toLowerCase()}`);
                };
                // Bubble the event
                dispatchEvent(event.type);
                switch(event.type){
                    case google.ima.AdEvent.Type.LOADED:
                        // This is the first event sent for an ad - it is possible to determine whether the
                        // ad is a video ad or an overlay
                        this.trigger('loaded');
                        // Start countdown
                        this.pollCountdown(true);
                        if (!ad.isLinear()) {
                            // Position AdDisplayContainer correctly for overlay
                            ad.width = container.offsetWidth;
                            ad.height = container.offsetHeight;
                        }
                        break;
                    case google.ima.AdEvent.Type.STARTED:
                        // Set volume to match player
                        this.manager.setVolume(this.player.volume);
                        break;
                    case google.ima.AdEvent.Type.ALL_ADS_COMPLETED:
                        // All ads for the current videos are done. We can now request new advertisements
                        // in case the video is re-played
                        // TODO: Example for what happens when a next video in a playlist would be loaded.
                        // So here we load a new video when all ads are done.
                        // Then we load new ads within a new adsManager. When the video
                        // Is started - after - the ads are loaded, then we get ads.
                        // You can also easily test cancelling and reloading by running
                        // player.ads.cancel() and player.ads.play from the console I guess.
                        // this.player.source = {
                        //     type: 'video',
                        //     title: 'View From A Blue Moon',
                        //     sources: [{
                        //         src:
                        // 'https://cdn.plyr.io/static/demo/View_From_A_Blue_Moon_Trailer-HD.mp4', type:
                        // 'video/mp4', }], poster:
                        // 'https://cdn.plyr.io/static/demo/View_From_A_Blue_Moon_Trailer-HD.jpg', tracks:
                        // [ { kind: 'captions', label: 'English', srclang: 'en', src:
                        // 'https://cdn.plyr.io/static/demo/View_From_A_Blue_Moon_Trailer-HD.en.vtt',
                        // default: true, }, { kind: 'captions', label: 'French', srclang: 'fr', src:
                        // 'https://cdn.plyr.io/static/demo/View_From_A_Blue_Moon_Trailer-HD.fr.vtt', }, ],
                        // };
                        // TODO: So there is still this thing where a video should only be allowed to start
                        // playing when the IMA SDK is ready or has failed
                        if (this.player.ended) this.loadAds();
                        else // The SDK won't allow new ads to be called without receiving a contentComplete()
                        this.loader.contentComplete();
                        break;
                    case google.ima.AdEvent.Type.CONTENT_PAUSE_REQUESTED:
                        // This event indicates the ad has started - the video player can adjust the UI,
                        // for example display a pause button and remaining time. Fired when content should
                        // be paused. This usually happens right before an ad is about to cover the content
                        this.pauseContent();
                        break;
                    case google.ima.AdEvent.Type.CONTENT_RESUME_REQUESTED:
                        // This event indicates the ad has finished - the video player can perform
                        // appropriate UI actions, such as removing the timer for remaining time detection.
                        // Fired when content should be resumed. This usually happens when an ad finishes
                        // or collapses
                        this.pollCountdown();
                        this.resumeContent();
                        break;
                    case google.ima.AdEvent.Type.LOG:
                        if (adData.adError) this.player.debug.warn(`Non-fatal ad error: ${adData.adError.getMessage()}`);
                        break;
                }
            });
            _defineProperty$1(this, "onAdError", (event)=>{
                this.cancel();
                this.player.debug.warn('Ads error', event);
            });
            _defineProperty$1(this, "listeners", ()=>{
                const { container: container } = this.player.elements;
                let time;
                this.player.on('canplay', ()=>{
                    this.addCuePoints();
                });
                this.player.on('ended', ()=>{
                    this.loader.contentComplete();
                });
                this.player.on('timeupdate', ()=>{
                    time = this.player.currentTime;
                });
                this.player.on('seeked', ()=>{
                    const seekedTime = this.player.currentTime;
                    if (is.empty(this.cuePoints)) return;
                    this.cuePoints.forEach((cuePoint, index)=>{
                        if (time < cuePoint && cuePoint < seekedTime) {
                            this.manager.discardAdBreak();
                            this.cuePoints.splice(index, 1);
                        }
                    });
                });
                // Listen to the resizing of the window. And resize ad accordingly
                // TODO: eventually implement ResizeObserver
                window.addEventListener('resize', ()=>{
                    if (this.manager) this.manager.resize(container.offsetWidth, container.offsetHeight, google.ima.ViewMode.NORMAL);
                });
            });
            _defineProperty$1(this, "play", ()=>{
                const { container: container } = this.player.elements;
                if (!this.managerPromise) this.resumeContent();
                // Play the requested advertisement whenever the adsManager is ready
                this.managerPromise.then(()=>{
                    // Set volume to match player
                    this.manager.setVolume(this.player.volume);
                    // Initialize the container. Must be done via a user action on mobile devices
                    this.elements.displayContainer.initialize();
                    try {
                        if (!this.initialized) {
                            // Initialize the ads manager. Ad rules playlist will start at this time
                            this.manager.init(container.offsetWidth, container.offsetHeight, google.ima.ViewMode.NORMAL);
                            // Call play to start showing the ad. Single video and overlay ads will
                            // start at this time; the call will be ignored for ad rules
                            this.manager.start();
                        }
                        this.initialized = true;
                    } catch (adError) {
                        // An error may be thrown if there was a problem with the
                        // VAST response
                        this.onAdError(adError);
                    }
                }).catch(()=>{});
            });
            _defineProperty$1(this, "resumeContent", ()=>{
                // Hide the advertisement container
                this.elements.container.style.zIndex = '';
                // Ad is stopped
                this.playing = false;
                // Play video
                silencePromise(this.player.media.play());
            });
            _defineProperty$1(this, "pauseContent", ()=>{
                // Show the advertisement container
                this.elements.container.style.zIndex = 3;
                // Ad is playing
                this.playing = true;
                // Pause our video.
                this.player.media.pause();
            });
            _defineProperty$1(this, "cancel", ()=>{
                // Pause our video
                if (this.initialized) this.resumeContent();
                // Tell our instance that we're done for now
                this.trigger('error');
                // Re-create our adsManager
                this.loadAds();
            });
            _defineProperty$1(this, "loadAds", ()=>{
                // Tell our adsManager to go bye bye
                this.managerPromise.then(()=>{
                    // Destroy our adsManager
                    if (this.manager) this.manager.destroy();
                    // Re-set our adsManager promises
                    this.managerPromise = new Promise((resolve)=>{
                        this.on('loaded', resolve);
                        this.player.debug.log(this.manager);
                    });
                    // Now that the manager has been destroyed set it to also be un-initialized
                    this.initialized = false;
                    // Now request some new advertisements
                    this.requestAds();
                }).catch(()=>{});
            });
            _defineProperty$1(this, "trigger", (event, ...args)=>{
                const handlers = this.events[event];
                if (is.array(handlers)) handlers.forEach((handler)=>{
                    if (is.function(handler)) handler.apply(this, args);
                });
            });
            _defineProperty$1(this, "on", (event, callback)=>{
                if (!is.array(this.events[event])) this.events[event] = [];
                this.events[event].push(callback);
                return this;
            });
            _defineProperty$1(this, "startSafetyTimer", (time, from)=>{
                this.player.debug.log(`Safety timer invoked from: ${from}`);
                this.safetyTimer = setTimeout(()=>{
                    this.cancel();
                    this.clearSafetyTimer('startSafetyTimer()');
                }, time);
            });
            _defineProperty$1(this, "clearSafetyTimer", (from)=>{
                if (!is.nullOrUndefined(this.safetyTimer)) {
                    this.player.debug.log(`Safety timer cleared from: ${from}`);
                    clearTimeout(this.safetyTimer);
                    this.safetyTimer = null;
                }
            });
            this.player = player;
            this.config = player.config.ads;
            this.playing = false;
            this.initialized = false;
            this.elements = {
                container: null,
                displayContainer: null
            };
            this.manager = null;
            this.loader = null;
            this.cuePoints = null;
            this.events = {};
            this.safetyTimer = null;
            this.countdownTimer = null;
            // Setup a promise to resolve when the IMA manager is ready
            this.managerPromise = new Promise((resolve, reject)=>{
                // The ad is loaded and ready
                this.on('loaded', resolve);
                // Ads failed
                this.on('error', reject);
            });
            this.load();
        }
        get enabled() {
            const { config: config } = this;
            return this.player.isHTML5 && this.player.isVideo && config.enabled && (!is.empty(config.publisherId) || is.url(config.tagUrl));
        }
        /**
     * Load the IMA SDK
     */ // Build the tag URL
        get tagUrl() {
            const { config: config } = this;
            if (is.url(config.tagUrl)) return config.tagUrl;
            const params = {
                AV_PUBLISHERID: '58c25bb0073ef448b1087ad6',
                AV_CHANNELID: '5a0458dc28a06145e4519d21',
                AV_URL: window.location.hostname,
                cb: Date.now(),
                AV_WIDTH: 640,
                AV_HEIGHT: 480,
                AV_CDIM2: config.publisherId
            };
            const base = 'https://go.aniview.com/api/adserver6/vast/';
            return `${base}?${buildUrlParams(params)}`;
        }
    }
    /**
   * Returns a number whose value is limited to the given range.
   *
   * Example: limit the output of this computation to between 0 and 255
   * (x * 255).clamp(0, 255)
   *
   * @param {Number} input
   * @param {Number} min The lower boundary of the output range
   * @param {Number} max The upper boundary of the output range
   * @returns A number within the bounds of min and max
   * @type Number
   */ function clamp(input = 0, min = 0, max = 255) {
        return Math.min(Math.max(input, min), max);
    }
    // Arg: vttDataString example: "WEBVTT\n\n1\n00:00:05.000 --> 00:00:10.000\n1080p-00001.jpg"
    const parseVtt = (vttDataString)=>{
        const processedList = [];
        const frames = vttDataString.split(/\r\n\r\n|\n\n|\r\r/);
        frames.forEach((frame)=>{
            const result = {};
            const lines = frame.split(/\r\n|\n|\r/);
            lines.forEach((line)=>{
                if (!is.number(result.startTime)) {
                    // The line with start and end times on it is the first line of interest
                    const matchTimes = line.match(/([0-9]{2})?:?([0-9]{2}):([0-9]{2}).([0-9]{2,3})( ?--> ?)([0-9]{2})?:?([0-9]{2}):([0-9]{2}).([0-9]{2,3})/); // Note that this currently ignores caption formatting directives that are optionally on the end of this line - fine for non-captions VTT
                    if (matchTimes) {
                        result.startTime = Number(matchTimes[1] || 0) * 3600 + Number(matchTimes[2]) * 60 + Number(matchTimes[3]) + Number(`0.${matchTimes[4]}`);
                        result.endTime = Number(matchTimes[6] || 0) * 3600 + Number(matchTimes[7]) * 60 + Number(matchTimes[8]) + Number(`0.${matchTimes[9]}`);
                    }
                } else if (!is.empty(line.trim()) && is.empty(result.text)) {
                    // If we already have the startTime, then we're definitely up to the text line(s)
                    const lineSplit = line.trim().split('#xywh=');
                    [result.text] = lineSplit;
                    // If there's content in lineSplit[1], then we have sprites. If not, then it's just one frame per image
                    if (lineSplit[1]) [result.x, result.y, result.w, result.h] = lineSplit[1].split(',');
                }
            });
            if (result.text) processedList.push(result);
        });
        return processedList;
    };
    /**
   * Preview thumbnails for seek hover and scrubbing
   * Seeking: Hover over the seek bar (desktop only): shows a small preview container above the seek bar
   * Scrubbing: Click and drag the seek bar (desktop and mobile): shows the preview image over the entire video, as if the video is scrubbing at very high speed
   *
   * Notes:
   * - Thumbs are set via JS settings on Plyr init, not HTML5 'track' property. Using the track property would be a bit gross, because it doesn't support custom 'kinds'. kind=metadata might be used for something else, and we want to allow multiple thumbnails tracks. Tracks must have a unique combination of 'kind' and 'label'. We would have to do something like kind=metadata,label=thumbnails1 / kind=metadata,label=thumbnails2. Square peg, round hole
   * - VTT info: the image URL is relative to the VTT, not the current document. But if the url starts with a slash, it will naturally be relative to the current domain. https://support.jwplayer.com/articles/how-to-add-preview-thumbnails
   * - This implementation uses multiple separate img elements. Other implementations use background-image on one element. This would be nice and simple, but Firefox and Safari have flickering issues with replacing backgrounds of larger images. It seems that YouTube perhaps only avoids this because they don't have the option for high-res previews (even the fullscreen ones, when mousedown/seeking). Images appear over the top of each other, and previous ones are discarded once the new ones have been rendered
   */ const fitRatio = (ratio, outer)=>{
        const targetRatio = outer.width / outer.height;
        const result = {};
        if (ratio > targetRatio) {
            result.width = outer.width;
            result.height = 1 / ratio * outer.width;
        } else {
            result.height = outer.height;
            result.width = ratio * outer.height;
        }
        return result;
    };
    class PreviewThumbnails {
        /**
     * PreviewThumbnails constructor.
     * @param {Plyr} player
     * @return {PreviewThumbnails}
     */ constructor(player){
            _defineProperty$1(this, "load", ()=>{
                // Toggle the regular seek tooltip
                if (this.player.elements.display.seekTooltip) this.player.elements.display.seekTooltip.hidden = this.enabled;
                if (!this.enabled) return;
                this.getThumbnails().then(()=>{
                    if (!this.enabled) return;
                    // Render DOM elements
                    this.render();
                    // Check to see if thumb container size was specified manually in CSS
                    this.determineContainerAutoSizing();
                    this.loaded = true;
                });
            });
            _defineProperty$1(this, "getThumbnails", ()=>{
                return new Promise((resolve)=>{
                    const { src: src } = this.player.config.previewThumbnails;
                    if (is.empty(src)) throw new Error('Missing previewThumbnails.src config attribute');
                    // Resolve promise
                    const sortAndResolve = ()=>{
                        // Sort smallest to biggest (e.g., [120p, 480p, 1080p])
                        this.thumbnails.sort((x, y)=>x.height - y.height);
                        this.player.debug.log('Preview thumbnails', this.thumbnails);
                        resolve();
                    };
                    // Via callback()
                    if (is.function(src)) src((thumbnails)=>{
                        this.thumbnails = thumbnails;
                        sortAndResolve();
                    });
                    else {
                        // If string, convert into single-element list
                        const urls = is.string(src) ? [
                            src
                        ] : src;
                        // Loop through each src URL. Download and process the VTT file, storing the resulting data in this.thumbnails
                        const promises = urls.map((u)=>this.getThumbnail(u));
                        // Resolve
                        Promise.all(promises).then(sortAndResolve);
                    }
                });
            });
            _defineProperty$1(this, "getThumbnail", (url)=>{
                return new Promise((resolve)=>{
                    fetch(url).then((response)=>{
                        const thumbnail = {
                            frames: parseVtt(response),
                            height: null,
                            urlPrefix: ''
                        };
                        // If the URLs don't start with '/', then we need to set their relative path to be the location of the VTT file
                        // If the URLs do start with '/', then they obviously don't need a prefix, so it will remain blank
                        // If the thumbnail URLs start with with none of '/', 'http://' or 'https://', then we need to set their relative path to be the location of the VTT file
                        if (!thumbnail.frames[0].text.startsWith('/') && !thumbnail.frames[0].text.startsWith('http://') && !thumbnail.frames[0].text.startsWith('https://')) thumbnail.urlPrefix = url.substring(0, url.lastIndexOf('/') + 1);
                        // Download the first frame, so that we can determine/set the height of this thumbnailsDef
                        const tempImage = new Image();
                        tempImage.onload = ()=>{
                            thumbnail.height = tempImage.naturalHeight;
                            thumbnail.width = tempImage.naturalWidth;
                            this.thumbnails.push(thumbnail);
                            resolve();
                        };
                        tempImage.src = thumbnail.urlPrefix + thumbnail.frames[0].text;
                    });
                });
            });
            _defineProperty$1(this, "startMove", (event)=>{
                if (!this.loaded) return;
                if (!is.event(event) || ![
                    'touchmove',
                    'mousemove'
                ].includes(event.type)) return;
                // Wait until media has a duration
                if (!this.player.media.duration) return;
                if (event.type === 'touchmove') // Calculate seek hover position as approx video seconds
                this.seekTime = this.player.media.duration * (this.player.elements.inputs.seek.value / 100);
                else {
                    var _this$player$config$m, _this$player$config$m2;
                    // Calculate seek hover position as approx video seconds
                    const clientRect = this.player.elements.progress.getBoundingClientRect();
                    const percentage = 100 / clientRect.width * (event.pageX - clientRect.left);
                    this.seekTime = this.player.media.duration * (percentage / 100);
                    if (this.seekTime < 0) // The mousemove fires for 10+px out to the left
                    this.seekTime = 0;
                    if (this.seekTime > this.player.media.duration - 1) // Took 1 second off the duration for safety, because different players can disagree on the real duration of a video
                    this.seekTime = this.player.media.duration - 1;
                    this.mousePosX = event.pageX;
                    // Set time text inside image container
                    this.elements.thumb.time.innerText = formatTime(this.seekTime);
                    // Get marker point for time
                    const point = (_this$player$config$m = this.player.config.markers) === null || _this$player$config$m === void 0 ? void 0 : (_this$player$config$m2 = _this$player$config$m.points) === null || _this$player$config$m2 === void 0 ? void 0 : _this$player$config$m2.find(({ time: t })=>t === Math.round(this.seekTime));
                    // Append the point label to the tooltip
                    if (point) // this.elements.thumb.time.innerText.concat('\n');
                    this.elements.thumb.time.insertAdjacentHTML('afterbegin', `${point.label}<br>`);
                }
                // Download and show image
                this.showImageAtCurrentTime();
            });
            _defineProperty$1(this, "endMove", ()=>{
                this.toggleThumbContainer(false, true);
            });
            _defineProperty$1(this, "startScrubbing", (event)=>{
                // Only act on left mouse button (0), or touch device (event.button does not exist or is false)
                if (is.nullOrUndefined(event.button) || event.button === false || event.button === 0) {
                    this.mouseDown = true;
                    // Wait until media has a duration
                    if (this.player.media.duration) {
                        this.toggleScrubbingContainer(true);
                        this.toggleThumbContainer(false, true);
                        // Download and show image
                        this.showImageAtCurrentTime();
                    }
                }
            });
            _defineProperty$1(this, "endScrubbing", ()=>{
                this.mouseDown = false;
                // Hide scrubbing preview. But wait until the video has successfully seeked before hiding the scrubbing preview
                if (Math.ceil(this.lastTime) === Math.ceil(this.player.media.currentTime)) // The video was already seeked/loaded at the chosen time - hide immediately
                this.toggleScrubbingContainer(false);
                else // The video hasn't seeked yet. Wait for that
                once.call(this.player, this.player.media, 'timeupdate', ()=>{
                    // Re-check mousedown - we might have already started scrubbing again
                    if (!this.mouseDown) this.toggleScrubbingContainer(false);
                });
            });
            _defineProperty$1(this, "listeners", ()=>{
                // Hide thumbnail preview - on mouse click, mouse leave (in listeners.js for now), and video play/seek. All four are required, e.g., for buffering
                this.player.on('play', ()=>{
                    this.toggleThumbContainer(false, true);
                });
                this.player.on('seeked', ()=>{
                    this.toggleThumbContainer(false);
                });
                this.player.on('timeupdate', ()=>{
                    this.lastTime = this.player.media.currentTime;
                });
            });
            _defineProperty$1(this, "render", ()=>{
                // Create HTML element: plyr__preview-thumbnail-container
                this.elements.thumb.container = createElement('div', {
                    class: this.player.config.classNames.previewThumbnails.thumbContainer
                });
                // Wrapper for the image for styling
                this.elements.thumb.imageContainer = createElement('div', {
                    class: this.player.config.classNames.previewThumbnails.imageContainer
                });
                this.elements.thumb.container.appendChild(this.elements.thumb.imageContainer);
                // Create HTML element, parent+span: time text (e.g., 01:32:00)
                const timeContainer = createElement('div', {
                    class: this.player.config.classNames.previewThumbnails.timeContainer
                });
                this.elements.thumb.time = createElement('span', {}, '00:00');
                timeContainer.appendChild(this.elements.thumb.time);
                this.elements.thumb.imageContainer.appendChild(timeContainer);
                // Inject the whole thumb
                if (is.element(this.player.elements.progress)) this.player.elements.progress.appendChild(this.elements.thumb.container);
                // Create HTML element: plyr__preview-scrubbing-container
                this.elements.scrubbing.container = createElement('div', {
                    class: this.player.config.classNames.previewThumbnails.scrubbingContainer
                });
                this.player.elements.wrapper.appendChild(this.elements.scrubbing.container);
            });
            _defineProperty$1(this, "destroy", ()=>{
                if (this.elements.thumb.container) this.elements.thumb.container.remove();
                if (this.elements.scrubbing.container) this.elements.scrubbing.container.remove();
            });
            _defineProperty$1(this, "showImageAtCurrentTime", ()=>{
                if (this.mouseDown) this.setScrubbingContainerSize();
                else this.setThumbContainerSizeAndPos();
                // Find the desired thumbnail index
                // TODO: Handle a video longer than the thumbs where thumbNum is null
                const thumbNum = this.thumbnails[0].frames.findIndex((frame)=>this.seekTime >= frame.startTime && this.seekTime <= frame.endTime);
                const hasThumb = thumbNum >= 0;
                let qualityIndex = 0;
                // Show the thumb container if we're not scrubbing
                if (!this.mouseDown) this.toggleThumbContainer(hasThumb);
                // No matching thumb found
                if (!hasThumb) return;
                // Check to see if we've already downloaded higher quality versions of this image
                this.thumbnails.forEach((thumbnail, index)=>{
                    if (this.loadedImages.includes(thumbnail.frames[thumbNum].text)) qualityIndex = index;
                });
                // Only proceed if either thumb num or thumbfilename has changed
                if (thumbNum !== this.showingThumb) {
                    this.showingThumb = thumbNum;
                    this.loadImage(qualityIndex);
                }
            });
            _defineProperty$1(this, "loadImage", (qualityIndex = 0)=>{
                const thumbNum = this.showingThumb;
                const thumbnail = this.thumbnails[qualityIndex];
                const { urlPrefix: urlPrefix } = thumbnail;
                const frame = thumbnail.frames[thumbNum];
                const thumbFilename = thumbnail.frames[thumbNum].text;
                const thumbUrl = urlPrefix + thumbFilename;
                if (!this.currentImageElement || this.currentImageElement.dataset.filename !== thumbFilename) {
                    // If we're already loading a previous image, remove its onload handler - we don't want it to load after this one
                    // Only do this if not using sprites. Without sprites we really want to show as many images as possible, as a best-effort
                    if (this.loadingImage && this.usingSprites) this.loadingImage.onload = null;
                    // We're building and adding a new image. In other implementations of similar functionality (YouTube), background image
                    // is instead used. But this causes issues with larger images in Firefox and Safari - switching between background
                    // images causes a flicker. Putting a new image over the top does not
                    const previewImage = new Image();
                    previewImage.src = thumbUrl;
                    previewImage.dataset.index = thumbNum;
                    previewImage.dataset.filename = thumbFilename;
                    this.showingThumbFilename = thumbFilename;
                    this.player.debug.log(`Loading image: ${thumbUrl}`);
                    // For some reason, passing the named function directly causes it to execute immediately. So I've wrapped it in an anonymous function...
                    previewImage.onload = ()=>this.showImage(previewImage, frame, qualityIndex, thumbNum, thumbFilename, true);
                    this.loadingImage = previewImage;
                    this.removeOldImages(previewImage);
                } else {
                    // Update the existing image
                    this.showImage(this.currentImageElement, frame, qualityIndex, thumbNum, thumbFilename, false);
                    this.currentImageElement.dataset.index = thumbNum;
                    this.removeOldImages(this.currentImageElement);
                }
            });
            _defineProperty$1(this, "showImage", (previewImage, frame, qualityIndex, thumbNum, thumbFilename, newImage = true)=>{
                this.player.debug.log(`Showing thumb: ${thumbFilename}. num: ${thumbNum}. qual: ${qualityIndex}. newimg: ${newImage}`);
                this.setImageSizeAndOffset(previewImage, frame);
                if (newImage) {
                    this.currentImageContainer.appendChild(previewImage);
                    this.currentImageElement = previewImage;
                    if (!this.loadedImages.includes(thumbFilename)) this.loadedImages.push(thumbFilename);
                }
                // Preload images before and after the current one
                // Show higher quality of the same frame
                // Each step here has a short time delay, and only continues if still hovering/seeking the same spot. This is to protect slow connections from overloading
                this.preloadNearby(thumbNum, true).then(this.preloadNearby(thumbNum, false)).then(this.getHigherQuality(qualityIndex, previewImage, frame, thumbFilename));
            });
            _defineProperty$1(this, "removeOldImages", (currentImage)=>{
                // Get a list of all images, convert it from a DOM list to an array
                Array.from(this.currentImageContainer.children).forEach((image)=>{
                    if (image.tagName.toLowerCase() !== 'img') return;
                    const removeDelay = this.usingSprites ? 500 : 1000;
                    if (image.dataset.index !== currentImage.dataset.index && !image.dataset.deleting) {
                        // Wait 200ms, as the new image can take some time to show on certain browsers (even though it was downloaded before showing). This will prevent flicker, and show some generosity towards slower clients
                        // First set attribute 'deleting' to prevent multi-handling of this on repeat firing of this function
                        // eslint-disable-next-line no-param-reassign
                        image.dataset.deleting = true;
                        // This has to be set before the timeout - to prevent issues switching between hover and scrub
                        const { currentImageContainer: currentImageContainer } = this;
                        setTimeout(()=>{
                            currentImageContainer.removeChild(image);
                            this.player.debug.log(`Removing thumb: ${image.dataset.filename}`);
                        }, removeDelay);
                    }
                });
            });
            _defineProperty$1(this, "preloadNearby", (thumbNum, forward = true)=>{
                return new Promise((resolve)=>{
                    setTimeout(()=>{
                        const oldThumbFilename = this.thumbnails[0].frames[thumbNum].text;
                        if (this.showingThumbFilename === oldThumbFilename) {
                            // Find the nearest thumbs with different filenames. Sometimes it'll be the next index, but in the case of sprites, it might be 100+ away
                            let thumbnailsClone;
                            if (forward) thumbnailsClone = this.thumbnails[0].frames.slice(thumbNum);
                            else thumbnailsClone = this.thumbnails[0].frames.slice(0, thumbNum).reverse();
                            let foundOne = false;
                            thumbnailsClone.forEach((frame)=>{
                                const newThumbFilename = frame.text;
                                if (newThumbFilename !== oldThumbFilename) // Found one with a different filename. Make sure it hasn't already been loaded on this page visit
                                {
                                    if (!this.loadedImages.includes(newThumbFilename)) {
                                        foundOne = true;
                                        this.player.debug.log(`Preloading thumb filename: ${newThumbFilename}`);
                                        const { urlPrefix: urlPrefix } = this.thumbnails[0];
                                        const thumbURL = urlPrefix + newThumbFilename;
                                        const previewImage = new Image();
                                        previewImage.src = thumbURL;
                                        previewImage.onload = ()=>{
                                            this.player.debug.log(`Preloaded thumb filename: ${newThumbFilename}`);
                                            if (!this.loadedImages.includes(newThumbFilename)) this.loadedImages.push(newThumbFilename);
                                            // We don't resolve until the thumb is loaded
                                            resolve();
                                        };
                                    }
                                }
                            });
                            // If there are none to preload then we want to resolve immediately
                            if (!foundOne) resolve();
                        }
                    }, 300);
                });
            });
            _defineProperty$1(this, "getHigherQuality", (currentQualityIndex, previewImage, frame, thumbFilename)=>{
                if (currentQualityIndex < this.thumbnails.length - 1) {
                    // Only use the higher quality version if it's going to look any better - if the current thumb is of a lower pixel density than the thumbnail container
                    let previewImageHeight = previewImage.naturalHeight;
                    if (this.usingSprites) previewImageHeight = frame.h;
                    if (previewImageHeight < this.thumbContainerHeight) // Recurse back to the loadImage function - show a higher quality one, but only if the viewer is on this frame for a while
                    setTimeout(()=>{
                        // Make sure the mouse hasn't already moved on and started hovering at another image
                        if (this.showingThumbFilename === thumbFilename) {
                            this.player.debug.log(`Showing higher quality thumb for: ${thumbFilename}`);
                            this.loadImage(currentQualityIndex + 1);
                        }
                    }, 300);
                }
            });
            _defineProperty$1(this, "toggleThumbContainer", (toggle = false, clearShowing = false)=>{
                const className = this.player.config.classNames.previewThumbnails.thumbContainerShown;
                this.elements.thumb.container.classList.toggle(className, toggle);
                if (!toggle && clearShowing) {
                    this.showingThumb = null;
                    this.showingThumbFilename = null;
                }
            });
            _defineProperty$1(this, "toggleScrubbingContainer", (toggle = false)=>{
                const className = this.player.config.classNames.previewThumbnails.scrubbingContainerShown;
                this.elements.scrubbing.container.classList.toggle(className, toggle);
                if (!toggle) {
                    this.showingThumb = null;
                    this.showingThumbFilename = null;
                }
            });
            _defineProperty$1(this, "determineContainerAutoSizing", ()=>{
                if (this.elements.thumb.imageContainer.clientHeight > 20 || this.elements.thumb.imageContainer.clientWidth > 20) // This will prevent auto sizing in this.setThumbContainerSizeAndPos()
                this.sizeSpecifiedInCSS = true;
            });
            _defineProperty$1(this, "setThumbContainerSizeAndPos", ()=>{
                const { imageContainer: imageContainer } = this.elements.thumb;
                if (!this.sizeSpecifiedInCSS) {
                    const thumbWidth = Math.floor(this.thumbContainerHeight * this.thumbAspectRatio);
                    imageContainer.style.height = `${this.thumbContainerHeight}px`;
                    imageContainer.style.width = `${thumbWidth}px`;
                } else if (imageContainer.clientHeight > 20 && imageContainer.clientWidth < 20) {
                    const thumbWidth = Math.floor(imageContainer.clientHeight * this.thumbAspectRatio);
                    imageContainer.style.width = `${thumbWidth}px`;
                } else if (imageContainer.clientHeight < 20 && imageContainer.clientWidth > 20) {
                    const thumbHeight = Math.floor(imageContainer.clientWidth / this.thumbAspectRatio);
                    imageContainer.style.height = `${thumbHeight}px`;
                }
                this.setThumbContainerPos();
            });
            _defineProperty$1(this, "setThumbContainerPos", ()=>{
                const scrubberRect = this.player.elements.progress.getBoundingClientRect();
                const containerRect = this.player.elements.container.getBoundingClientRect();
                const { container: container } = this.elements.thumb;
                // Find the lowest and highest desired left-position, so we don't slide out the side of the video container
                const min = containerRect.left - scrubberRect.left + 10;
                const max = containerRect.right - scrubberRect.left - container.clientWidth - 10;
                // Set preview container position to: mousepos, minus seekbar.left, minus half of previewContainer.clientWidth
                const position = this.mousePosX - scrubberRect.left - container.clientWidth / 2;
                const clamped = clamp(position, min, max);
                // Move the popover position
                container.style.left = `${clamped}px`;
                // The arrow can follow the cursor
                container.style.setProperty('--preview-arrow-offset', `${position - clamped}px`);
            });
            _defineProperty$1(this, "setScrubbingContainerSize", ()=>{
                const { width: width, height: height } = fitRatio(this.thumbAspectRatio, {
                    width: this.player.media.clientWidth,
                    height: this.player.media.clientHeight
                });
                this.elements.scrubbing.container.style.width = `${width}px`;
                this.elements.scrubbing.container.style.height = `${height}px`;
            });
            _defineProperty$1(this, "setImageSizeAndOffset", (previewImage, frame)=>{
                if (!this.usingSprites) return;
                // Find difference between height and preview container height
                const multiplier = this.thumbContainerHeight / frame.h;
                // eslint-disable-next-line no-param-reassign
                previewImage.style.height = `${previewImage.naturalHeight * multiplier}px`;
                // eslint-disable-next-line no-param-reassign
                previewImage.style.width = `${previewImage.naturalWidth * multiplier}px`;
                // eslint-disable-next-line no-param-reassign
                previewImage.style.left = `-${frame.x * multiplier}px`;
                // eslint-disable-next-line no-param-reassign
                previewImage.style.top = `-${frame.y * multiplier}px`;
            });
            this.player = player;
            this.thumbnails = [];
            this.loaded = false;
            this.lastMouseMoveTime = Date.now();
            this.mouseDown = false;
            this.loadedImages = [];
            this.elements = {
                thumb: {},
                scrubbing: {}
            };
            this.load();
        }
        get enabled() {
            return this.player.isHTML5 && this.player.isVideo && this.player.config.previewThumbnails.enabled;
        }
        get currentImageContainer() {
            return this.mouseDown ? this.elements.scrubbing.container : this.elements.thumb.imageContainer;
        }
        get usingSprites() {
            return Object.keys(this.thumbnails[0].frames[0]).includes('w');
        }
        get thumbAspectRatio() {
            if (this.usingSprites) return this.thumbnails[0].frames[0].w / this.thumbnails[0].frames[0].h;
            return this.thumbnails[0].width / this.thumbnails[0].height;
        }
        get thumbContainerHeight() {
            if (this.mouseDown) {
                const { height: height } = fitRatio(this.thumbAspectRatio, {
                    width: this.player.media.clientWidth,
                    height: this.player.media.clientHeight
                });
                return height;
            }
            // If css is used this needs to return the css height for sprites to work (see setImageSizeAndOffset)
            if (this.sizeSpecifiedInCSS) return this.elements.thumb.imageContainer.clientHeight;
            return Math.floor(this.player.media.clientWidth / this.thumbAspectRatio / 4);
        }
        get currentImageElement() {
            return this.mouseDown ? this.currentScrubbingImageElement : this.currentThumbnailImageElement;
        }
        set currentImageElement(element) {
            if (this.mouseDown) this.currentScrubbingImageElement = element;
            else this.currentThumbnailImageElement = element;
        }
    }
    // ==========================================================================
    const source = {
        // Add elements to HTML5 media (source, tracks, etc)
        insertElements (type, attributes) {
            if (is.string(attributes)) insertElement(type, this.media, {
                src: attributes
            });
            else if (is.array(attributes)) attributes.forEach((attribute)=>{
                insertElement(type, this.media, attribute);
            });
        },
        // Update source
        // Sources are not checked for support so be careful
        change (input) {
            if (!getDeep(input, 'sources.length')) {
                this.debug.warn('Invalid source format');
                return;
            }
            // Cancel current network requests
            html5.cancelRequests.call(this);
            // Destroy instance and re-setup
            this.destroy.call(this, ()=>{
                // Reset quality options
                this.options.quality = [];
                // Remove elements
                removeElement(this.media);
                this.media = null;
                // Reset class name
                if (is.element(this.elements.container)) this.elements.container.removeAttribute('class');
                // Set the type and provider
                const { sources: sources, type: type } = input;
                const [{ provider: provider = providers.html5, src: src }] = sources;
                const tagName = provider === 'html5' ? type : 'div';
                const attributes = provider === 'html5' ? {} : {
                    src: src
                };
                Object.assign(this, {
                    provider: provider,
                    type: type,
                    // Check for support
                    supported: support.check(type, provider, this.config.playsinline),
                    // Create new element
                    media: createElement(tagName, attributes)
                });
                // Inject the new element
                this.elements.container.appendChild(this.media);
                // Autoplay the new source?
                if (is.boolean(input.autoplay)) this.config.autoplay = input.autoplay;
                // Set attributes for audio and video
                if (this.isHTML5) {
                    if (this.config.crossorigin) this.media.setAttribute('crossorigin', '');
                    if (this.config.autoplay) this.media.setAttribute('autoplay', '');
                    if (!is.empty(input.poster)) this.poster = input.poster;
                    if (this.config.loop.active) this.media.setAttribute('loop', '');
                    if (this.config.muted) this.media.setAttribute('muted', '');
                    if (this.config.playsinline) this.media.setAttribute('playsinline', '');
                }
                // Restore class hook
                ui.addStyleHook.call(this);
                // Set new sources for html5
                if (this.isHTML5) source.insertElements.call(this, 'source', sources);
                // Set video title
                this.config.title = input.title;
                // Set up from scratch
                media.setup.call(this);
                // HTML5 stuff
                if (this.isHTML5) // Setup captions
                {
                    if (Object.keys(input).includes('tracks')) source.insertElements.call(this, 'track', input.tracks);
                }
                // If HTML5 or embed but not fully supported, setupInterface and call ready now
                if (this.isHTML5 || this.isEmbed && !this.supported.ui) // Setup interface
                ui.build.call(this);
                // Load HTML5 sources
                if (this.isHTML5) this.media.load();
                // Update previewThumbnails config & reload plugin
                if (!is.empty(input.previewThumbnails)) {
                    Object.assign(this.config.previewThumbnails, input.previewThumbnails);
                    // Cleanup previewThumbnails plugin if it was loaded
                    if (this.previewThumbnails && this.previewThumbnails.loaded) {
                        this.previewThumbnails.destroy();
                        this.previewThumbnails = null;
                    }
                    // Create new instance if it is still enabled
                    if (this.config.previewThumbnails.enabled) this.previewThumbnails = new PreviewThumbnails(this);
                }
                // Update the fullscreen support
                this.fullscreen.update();
            }, true);
        }
    };
    // Private properties
    // TODO: Use a WeakMap for private globals
    // const globals = new WeakMap();
    // Plyr instance
    class Plyr {
        constructor(target, options){
            _defineProperty$1(this, "play", ()=>{
                if (!is.function(this.media.play)) return null;
                // Intecept play with ads
                if (this.ads && this.ads.enabled) this.ads.managerPromise.then(()=>this.ads.play()).catch(()=>silencePromise(this.media.play()));
                // Return the promise (for HTML5)
                return this.media.play();
            });
            _defineProperty$1(this, "pause", ()=>{
                if (!this.playing || !is.function(this.media.pause)) return null;
                return this.media.pause();
            });
            _defineProperty$1(this, "togglePlay", (input)=>{
                // Toggle based on current state if nothing passed
                const toggle = is.boolean(input) ? input : !this.playing;
                if (toggle) return this.play();
                return this.pause();
            });
            _defineProperty$1(this, "stop", ()=>{
                if (this.isHTML5) {
                    this.pause();
                    this.restart();
                } else if (is.function(this.media.stop)) this.media.stop();
            });
            _defineProperty$1(this, "restart", ()=>{
                this.currentTime = 0;
            });
            _defineProperty$1(this, "rewind", (seekTime)=>{
                this.currentTime -= is.number(seekTime) ? seekTime : this.config.seekTime;
            });
            _defineProperty$1(this, "forward", (seekTime)=>{
                this.currentTime += is.number(seekTime) ? seekTime : this.config.seekTime;
            });
            _defineProperty$1(this, "increaseVolume", (step)=>{
                const volume = this.media.muted ? 0 : this.volume;
                this.volume = volume + (is.number(step) ? step : 0);
            });
            _defineProperty$1(this, "decreaseVolume", (step)=>{
                this.increaseVolume(-step);
            });
            _defineProperty$1(this, "airplay", ()=>{
                // Show dialog if supported
                if (support.airplay) this.media.webkitShowPlaybackTargetPicker();
            });
            _defineProperty$1(this, "toggleControls", (toggle)=>{
                // Don't toggle if missing UI support or if it's audio
                if (this.supported.ui && !this.isAudio) {
                    // Get state before change
                    const isHidden = hasClass(this.elements.container, this.config.classNames.hideControls);
                    // Negate the argument if not undefined since adding the class to hides the controls
                    const force = typeof toggle === 'undefined' ? undefined : !toggle;
                    // Apply and get updated state
                    const hiding = toggleClass(this.elements.container, this.config.classNames.hideControls, force);
                    // Close menu
                    if (hiding && is.array(this.config.controls) && this.config.controls.includes('settings') && !is.empty(this.config.settings)) controls.toggleMenu.call(this, false);
                    // Trigger event on change
                    if (hiding !== isHidden) {
                        const eventName = hiding ? 'controlshidden' : 'controlsshown';
                        triggerEvent.call(this, this.media, eventName);
                    }
                    return !hiding;
                }
                return false;
            });
            _defineProperty$1(this, "on", (event, callback)=>{
                on.call(this, this.elements.container, event, callback);
            });
            _defineProperty$1(this, "once", (event, callback)=>{
                once.call(this, this.elements.container, event, callback);
            });
            _defineProperty$1(this, "off", (event, callback)=>{
                off(this.elements.container, event, callback);
            });
            _defineProperty$1(this, "destroy", (callback, soft = false)=>{
                if (!this.ready) return;
                const done = ()=>{
                    // Reset overflow (incase destroyed while in fullscreen)
                    document.body.style.overflow = '';
                    // GC for embed
                    this.embed = null;
                    // If it's a soft destroy, make minimal changes
                    if (soft) {
                        if (Object.keys(this.elements).length) {
                            // Remove elements
                            removeElement(this.elements.buttons.play);
                            removeElement(this.elements.captions);
                            removeElement(this.elements.controls);
                            removeElement(this.elements.wrapper);
                            // Clear for GC
                            this.elements.buttons.play = null;
                            this.elements.captions = null;
                            this.elements.controls = null;
                            this.elements.wrapper = null;
                        }
                        // Callback
                        if (is.function(callback)) callback();
                    } else {
                        // Unbind listeners
                        unbindListeners.call(this);
                        // Cancel current network requests
                        html5.cancelRequests.call(this);
                        // Replace the container with the original element provided
                        replaceElement(this.elements.original, this.elements.container);
                        // Event
                        triggerEvent.call(this, this.elements.original, 'destroyed', true);
                        // Callback
                        if (is.function(callback)) callback.call(this.elements.original);
                        // Reset state
                        this.ready = false;
                        // Clear for garbage collection
                        setTimeout(()=>{
                            this.elements = null;
                            this.media = null;
                        }, 200);
                    }
                };
                // Stop playback
                this.stop();
                // Clear timeouts
                clearTimeout(this.timers.loading);
                clearTimeout(this.timers.controls);
                clearTimeout(this.timers.resized);
                // Provider specific stuff
                if (this.isHTML5) {
                    // Restore native video controls
                    ui.toggleNativeControls.call(this, true);
                    // Clean up
                    done();
                } else if (this.isYouTube) {
                    // Clear timers
                    clearInterval(this.timers.buffering);
                    clearInterval(this.timers.playing);
                    // Destroy YouTube API
                    if (this.embed !== null && is.function(this.embed.destroy)) this.embed.destroy();
                    // Clean up
                    done();
                } else if (this.isVimeo) {
                    // Destroy Vimeo API
                    // then clean up (wait, to prevent postmessage errors)
                    if (this.embed !== null) this.embed.unload().then(done);
                    // Vimeo does not always return
                    setTimeout(done, 200);
                }
            });
            _defineProperty$1(this, "supports", (type)=>support.mime.call(this, type));
            this.timers = {};
            // State
            this.ready = false;
            this.loading = false;
            this.failed = false;
            // Touch device
            this.touch = support.touch;
            // Set the media element
            this.media = target;
            // String selector passed
            if (is.string(this.media)) this.media = document.querySelectorAll(this.media);
            // jQuery, NodeList or Array passed, use first element
            if (window.jQuery && this.media instanceof jQuery || is.nodeList(this.media) || is.array(this.media)) // eslint-disable-next-line
            this.media = this.media[0];
            // Set config
            this.config = extend({}, defaults, Plyr.defaults, options || {}, (()=>{
                try {
                    return JSON.parse(this.media.getAttribute('data-plyr-config'));
                } catch (_) {
                    return {};
                }
            })());
            // Elements cache
            this.elements = {
                container: null,
                fullscreen: null,
                captions: null,
                buttons: {},
                display: {},
                progress: {},
                inputs: {},
                settings: {
                    popup: null,
                    menu: null,
                    panels: {},
                    buttons: {}
                }
            };
            // Captions
            this.captions = {
                active: null,
                currentTrack: -1,
                meta: new WeakMap()
            };
            // Fullscreen
            this.fullscreen = {
                active: false
            };
            // Options
            this.options = {
                speed: [],
                quality: []
            };
            // Debugging
            // TODO: move to globals
            this.debug = new Console(this.config.debug);
            // Log config options and support
            this.debug.log('Config', this.config);
            this.debug.log('Support', support);
            // We need an element to setup
            if (is.nullOrUndefined(this.media) || !is.element(this.media)) {
                this.debug.error('Setup failed: no suitable element passed');
                return;
            }
            // Bail if the element is initialized
            if (this.media.plyr) {
                this.debug.warn('Target already setup');
                return;
            }
            // Bail if not enabled
            if (!this.config.enabled) {
                this.debug.error('Setup failed: disabled by config');
                return;
            }
            // Bail if disabled or no basic support
            // You may want to disable certain UAs etc
            if (!support.check().api) {
                this.debug.error('Setup failed: no support');
                return;
            }
            // Cache original element state for .destroy()
            const clone = this.media.cloneNode(true);
            clone.autoplay = false;
            this.elements.original = clone;
            // Set media type based on tag or data attribute
            // Supported: video, audio, vimeo, youtube
            const _type = this.media.tagName.toLowerCase();
            // Embed properties
            let iframe = null;
            let url = null;
            // Different setup based on type
            switch(_type){
                case 'div':
                    // Find the frame
                    iframe = this.media.querySelector('iframe');
                    // <iframe> type
                    if (is.element(iframe)) {
                        // Detect provider
                        url = parseUrl(iframe.getAttribute('src'));
                        this.provider = getProviderByUrl(url.toString());
                        // Rework elements
                        this.elements.container = this.media;
                        this.media = iframe;
                        // Reset classname
                        this.elements.container.className = '';
                        // Get attributes from URL and set config
                        if (url.search.length) {
                            const truthy = [
                                '1',
                                'true'
                            ];
                            if (truthy.includes(url.searchParams.get('autoplay'))) this.config.autoplay = true;
                            if (truthy.includes(url.searchParams.get('loop'))) this.config.loop.active = true;
                            // TODO: replace fullscreen.iosNative with this playsinline config option
                            // YouTube requires the playsinline in the URL
                            if (this.isYouTube) {
                                this.config.playsinline = truthy.includes(url.searchParams.get('playsinline'));
                                this.config.youtube.hl = url.searchParams.get('hl'); // TODO: Should this be setting language?
                            } else this.config.playsinline = true;
                        }
                    } else {
                        // <div> with attributes
                        this.provider = this.media.getAttribute(this.config.attributes.embed.provider);
                        // Remove attribute
                        this.media.removeAttribute(this.config.attributes.embed.provider);
                    }
                    // Unsupported or missing provider
                    if (is.empty(this.provider) || !Object.values(providers).includes(this.provider)) {
                        this.debug.error('Setup failed: Invalid provider');
                        return;
                    }
                    // Audio will come later for external providers
                    this.type = types.video;
                    break;
                case 'video':
                case 'audio':
                    this.type = _type;
                    this.provider = providers.html5;
                    // Get config from attributes
                    if (this.media.hasAttribute('crossorigin')) this.config.crossorigin = true;
                    if (this.media.hasAttribute('autoplay')) this.config.autoplay = true;
                    if (this.media.hasAttribute('playsinline') || this.media.hasAttribute('webkit-playsinline')) this.config.playsinline = true;
                    if (this.media.hasAttribute('muted')) this.config.muted = true;
                    if (this.media.hasAttribute('loop')) this.config.loop.active = true;
                    break;
                default:
                    this.debug.error('Setup failed: unsupported type');
                    return;
            }
            // Check for support again but with type
            this.supported = support.check(this.type, this.provider, this.config.playsinline);
            // If no support for even API, bail
            if (!this.supported.api) {
                this.debug.error('Setup failed: no support');
                return;
            }
            this.eventListeners = [];
            // Create listeners
            this.listeners = new Listeners(this);
            // Setup local storage for user settings
            this.storage = new Storage(this);
            // Store reference
            this.media.plyr = this;
            // Wrap media
            if (!is.element(this.elements.container)) {
                this.elements.container = createElement('div', {
                    tabindex: 0
                });
                wrap(this.media, this.elements.container);
            }
            // Migrate custom properties from media to container (so they work 😉)
            ui.migrateStyles.call(this);
            // Add style hook
            ui.addStyleHook.call(this);
            // Setup media
            media.setup.call(this);
            // Listen for events if debugging
            if (this.config.debug) on.call(this, this.elements.container, this.config.events.join(' '), (event)=>{
                this.debug.log(`event: ${event.type}`);
            });
            // Setup fullscreen
            this.fullscreen = new Fullscreen(this);
            // Setup interface
            // If embed but not fully supported, build interface now to avoid flash of controls
            if (this.isHTML5 || this.isEmbed && !this.supported.ui) ui.build.call(this);
            // Container listeners
            this.listeners.container();
            // Global listeners
            this.listeners.global();
            // Setup ads if provided
            if (this.config.ads.enabled) this.ads = new Ads(this);
            // Autoplay if required
            if (this.isHTML5 && this.config.autoplay) this.once('canplay', ()=>silencePromise(this.play()));
            // Seek time will be recorded (in listeners.js) so we can prevent hiding controls for a few seconds after seek
            this.lastSeekTime = 0;
            // Setup preview thumbnails if enabled
            if (this.config.previewThumbnails.enabled) this.previewThumbnails = new PreviewThumbnails(this);
        }
        // ---------------------------------------
        // API
        // ---------------------------------------
        /**
     * Types and provider helpers
     */ get isHTML5() {
            return this.provider === providers.html5;
        }
        get isEmbed() {
            return this.isYouTube || this.isVimeo;
        }
        get isYouTube() {
            return this.provider === providers.youtube;
        }
        get isVimeo() {
            return this.provider === providers.vimeo;
        }
        get isVideo() {
            return this.type === types.video;
        }
        get isAudio() {
            return this.type === types.audio;
        }
        /**
     * Play the media, or play the advertisement (if they are not blocked)
     */ /**
     * Get playing state
     */ get playing() {
            return Boolean(this.ready && !this.paused && !this.ended);
        }
        /**
     * Get paused state
     */ get paused() {
            return Boolean(this.media.paused);
        }
        /**
     * Get stopped state
     */ get stopped() {
            return Boolean(this.paused && this.currentTime === 0);
        }
        /**
     * Get ended state
     */ get ended() {
            return Boolean(this.media.ended);
        }
        /**
     * Toggle playback based on current status
     * @param {Boolean} input
     */ /**
     * Seek to a time
     * @param {Number} input - where to seek to in seconds. Defaults to 0 (the start)
     */ set currentTime(input) {
            // Bail if media duration isn't available yet
            if (!this.duration) return;
            // Validate input
            const inputIsValid = is.number(input) && input > 0;
            // Set
            this.media.currentTime = inputIsValid ? Math.min(input, this.duration) : 0;
            // Logging
            this.debug.log(`Seeking to ${this.currentTime} seconds`);
        }
        /**
     * Get current time
     */ get currentTime() {
            return Number(this.media.currentTime);
        }
        /**
     * Get buffered
     */ get buffered() {
            const { buffered: buffered } = this.media;
            // YouTube / Vimeo return a float between 0-1
            if (is.number(buffered)) return buffered;
            // HTML5
            // TODO: Handle buffered chunks of the media
            // (i.e. seek to another section buffers only that section)
            if (buffered && buffered.length && this.duration > 0) return buffered.end(0) / this.duration;
            return 0;
        }
        /**
     * Get seeking status
     */ get seeking() {
            return Boolean(this.media.seeking);
        }
        /**
     * Get the duration of the current media
     */ get duration() {
            // Faux duration set via config
            const fauxDuration = parseFloat(this.config.duration);
            // Media duration can be NaN or Infinity before the media has loaded
            const realDuration = (this.media || {}).duration;
            const duration = !is.number(realDuration) || realDuration === Infinity ? 0 : realDuration;
            // If config duration is funky, use regular duration
            return fauxDuration || duration;
        }
        /**
     * Set the player volume
     * @param {Number} value - must be between 0 and 1. Defaults to the value from local storage and config.volume if not set in storage
     */ set volume(value) {
            let volume = value;
            const max = 1;
            const min = 0;
            if (is.string(volume)) volume = Number(volume);
            // Load volume from storage if no value specified
            if (!is.number(volume)) volume = this.storage.get('volume');
            // Use config if all else fails
            if (!is.number(volume)) ({ volume: volume } = this.config);
            // Maximum is volumeMax
            if (volume > max) volume = max;
            // Minimum is volumeMin
            if (volume < min) volume = min;
            // Update config
            this.config.volume = volume;
            // Set the player volume
            this.media.volume = volume;
            // If muted, and we're increasing volume manually, reset muted state
            if (!is.empty(value) && this.muted && volume > 0) this.muted = false;
        }
        /**
     * Get the current player volume
     */ get volume() {
            return Number(this.media.volume);
        }
        /**
     * Increase volume
     * @param {Boolean} step - How much to decrease by (between 0 and 1)
     */ /**
     * Set muted state
     * @param {Boolean} mute
     */ set muted(mute) {
            let toggle = mute;
            // Load muted state from storage
            if (!is.boolean(toggle)) toggle = this.storage.get('muted');
            // Use config if all else fails
            if (!is.boolean(toggle)) toggle = this.config.muted;
            // Update config
            this.config.muted = toggle;
            // Set mute on the player
            this.media.muted = toggle;
        }
        /**
     * Get current muted state
     */ get muted() {
            return Boolean(this.media.muted);
        }
        /**
     * Check if the media has audio
     */ get hasAudio() {
            // Assume yes for all non HTML5 (as we can't tell...)
            if (!this.isHTML5) return true;
            if (this.isAudio) return true;
            // Get audio tracks
            return Boolean(this.media.mozHasAudio) || Boolean(this.media.webkitAudioDecodedByteCount) || Boolean(this.media.audioTracks && this.media.audioTracks.length);
        }
        /**
     * Set playback speed
     * @param {Number} input - the speed of playback (0.5-2.0)
     */ set speed(input) {
            let speed = null;
            if (is.number(input)) speed = input;
            if (!is.number(speed)) speed = this.storage.get('speed');
            if (!is.number(speed)) speed = this.config.speed.selected;
            // Clamp to min/max
            const { minimumSpeed: min, maximumSpeed: max } = this;
            speed = clamp(speed, min, max);
            // Update config
            this.config.speed.selected = speed;
            // Set media speed
            setTimeout(()=>{
                if (this.media) this.media.playbackRate = speed;
            }, 0);
        }
        /**
     * Get current playback speed
     */ get speed() {
            return Number(this.media.playbackRate);
        }
        /**
     * Get the minimum allowed speed
     */ get minimumSpeed() {
            if (this.isYouTube) // https://developers.google.com/youtube/iframe_api_reference#setPlaybackRate
            return Math.min(...this.options.speed);
            if (this.isVimeo) // https://github.com/vimeo/player.js/#setplaybackrateplaybackrate-number-promisenumber-rangeerrorerror
            return 0.5;
            // https://stackoverflow.com/a/32320020/1191319
            return 0.0625;
        }
        /**
     * Get the maximum allowed speed
     */ get maximumSpeed() {
            if (this.isYouTube) // https://developers.google.com/youtube/iframe_api_reference#setPlaybackRate
            return Math.max(...this.options.speed);
            if (this.isVimeo) // https://github.com/vimeo/player.js/#setplaybackrateplaybackrate-number-promisenumber-rangeerrorerror
            return 2;
            // https://stackoverflow.com/a/32320020/1191319
            return 16;
        }
        /**
     * Set playback quality
     * Currently HTML5 & YouTube only
     * @param {Number} input - Quality level
     */ set quality(input) {
            const config = this.config.quality;
            const options = this.options.quality;
            if (!options.length) return;
            let quality = [
                !is.empty(input) && Number(input),
                this.storage.get('quality'),
                config.selected,
                config.default
            ].find(is.number);
            let updateStorage = true;
            if (!options.includes(quality)) {
                const value = closest(options, quality);
                this.debug.warn(`Unsupported quality option: ${quality}, using ${value} instead`);
                quality = value;
                // Don't update storage if quality is not supported
                updateStorage = false;
            }
            // Update config
            config.selected = quality;
            // Set quality
            this.media.quality = quality;
            // Save to storage
            if (updateStorage) this.storage.set({
                quality: quality
            });
        }
        /**
     * Get current quality level
     */ get quality() {
            return this.media.quality;
        }
        /**
     * Toggle loop
     * TODO: Finish fancy new logic. Set the indicator on load as user may pass loop as config
     * @param {Boolean} input - Whether to loop or not
     */ set loop(input) {
            const toggle = is.boolean(input) ? input : this.config.loop.active;
            this.config.loop.active = toggle;
            this.media.loop = toggle;
        // Set default to be a true toggle
        /* const type = ['start', 'end', 'all', 'none', 'toggle'].includes(input) ? input : 'toggle';
           switch (type) {
              case 'start':
                  if (this.config.loop.end && this.config.loop.end <= this.currentTime) {
                      this.config.loop.end = null;
                  }
                  this.config.loop.start = this.currentTime;
                  // this.config.loop.indicator.start = this.elements.display.played.value;
                  break;
               case 'end':
                  if (this.config.loop.start >= this.currentTime) {
                      return this;
                  }
                  this.config.loop.end = this.currentTime;
                  // this.config.loop.indicator.end = this.elements.display.played.value;
                  break;
               case 'all':
                  this.config.loop.start = 0;
                  this.config.loop.end = this.duration - 2;
                  this.config.loop.indicator.start = 0;
                  this.config.loop.indicator.end = 100;
                  break;
               case 'toggle':
                  if (this.config.loop.active) {
                      this.config.loop.start = 0;
                      this.config.loop.end = null;
                  } else {
                      this.config.loop.start = 0;
                      this.config.loop.end = this.duration - 2;
                  }
                  break;
               default:
                  this.config.loop.start = 0;
                  this.config.loop.end = null;
                  break;
          } */ }
        /**
     * Get current loop state
     */ get loop() {
            return Boolean(this.media.loop);
        }
        /**
     * Set new media source
     * @param {Object} input - The new source object (see docs)
     */ set source(input) {
            source.change.call(this, input);
        }
        /**
     * Get current source
     */ get source() {
            return this.media.currentSrc;
        }
        /**
     * Get a download URL (either source or custom)
     */ get download() {
            const { download: download } = this.config.urls;
            return is.url(download) ? download : this.source;
        }
        /**
     * Set the download URL
     */ set download(input) {
            if (!is.url(input)) return;
            this.config.urls.download = input;
            controls.setDownloadUrl.call(this);
        }
        /**
     * Set the poster image for a video
     * @param {String} input - the URL for the new poster image
     */ set poster(input) {
            if (!this.isVideo) {
                this.debug.warn('Poster can only be set for video');
                return;
            }
            ui.setPoster.call(this, input, false).catch(()=>{});
        }
        /**
     * Get the current poster image
     */ get poster() {
            if (!this.isVideo) return null;
            return this.media.getAttribute('poster') || this.media.getAttribute('data-poster');
        }
        /**
     * Get the current aspect ratio in use
     */ get ratio() {
            if (!this.isVideo) return null;
            const ratio = reduceAspectRatio(getAspectRatio.call(this));
            return is.array(ratio) ? ratio.join(':') : ratio;
        }
        /**
     * Set video aspect ratio
     */ set ratio(input) {
            if (!this.isVideo) {
                this.debug.warn('Aspect ratio can only be set for video');
                return;
            }
            if (!is.string(input) || !validateAspectRatio(input)) {
                this.debug.error(`Invalid aspect ratio specified (${input})`);
                return;
            }
            this.config.ratio = reduceAspectRatio(input);
            setAspectRatio.call(this);
        }
        /**
     * Set the autoplay state
     * @param {Boolean} input - Whether to autoplay or not
     */ set autoplay(input) {
            this.config.autoplay = is.boolean(input) ? input : this.config.autoplay;
        }
        /**
     * Get the current autoplay state
     */ get autoplay() {
            return Boolean(this.config.autoplay);
        }
        /**
     * Toggle captions
     * @param {Boolean} input - Whether to enable captions
     */ toggleCaptions(input) {
            captions.toggle.call(this, input, false);
        }
        /**
     * Set the caption track by index
     * @param {Number} input - Caption index
     */ set currentTrack(input) {
            captions.set.call(this, input, false);
            captions.setup.call(this);
        }
        /**
     * Get the current caption track index (-1 if disabled)
     */ get currentTrack() {
            const { toggled: toggled, currentTrack: currentTrack } = this.captions;
            return toggled ? currentTrack : -1;
        }
        /**
     * Set the wanted language for captions
     * Since tracks can be added later it won't update the actual caption track until there is a matching track
     * @param {String} input - Two character ISO language code (e.g. EN, FR, PT, etc)
     */ set language(input) {
            captions.setLanguage.call(this, input, false);
        }
        /**
     * Get the current track's language
     */ get language() {
            return (captions.getCurrentTrack.call(this) || {}).language;
        }
        /**
     * Toggle picture-in-picture playback on WebKit/MacOS
     * TODO: update player with state, support, enabled
     * TODO: detect outside changes
     */ set pip(input) {
            // Bail if no support
            if (!support.pip) return;
            // Toggle based on current state if not passed
            const toggle = is.boolean(input) ? input : !this.pip;
            // Toggle based on current state
            // Safari
            if (is.function(this.media.webkitSetPresentationMode)) this.media.webkitSetPresentationMode(toggle ? pip.active : pip.inactive);
            // Chrome
            if (is.function(this.media.requestPictureInPicture)) {
                if (!this.pip && toggle) this.media.requestPictureInPicture();
                else if (this.pip && !toggle) document.exitPictureInPicture();
            }
        }
        /**
     * Get the current picture-in-picture state
     */ get pip() {
            if (!support.pip) return null;
            // Safari
            if (!is.empty(this.media.webkitPresentationMode)) return this.media.webkitPresentationMode === pip.active;
            // Chrome
            return this.media === document.pictureInPictureElement;
        }
        /**
     * Sets the preview thubmnails for the current source
     */ setPreviewThumbnails(thumbnailSource) {
            if (this.previewThumbnails && this.previewThumbnails.loaded) {
                this.previewThumbnails.destroy();
                this.previewThumbnails = null;
            }
            Object.assign(this.config.previewThumbnails, thumbnailSource);
            // Create new instance if it is still enabled
            if (this.config.previewThumbnails.enabled) this.previewThumbnails = new PreviewThumbnails(this);
        }
        /**
     * Trigger the airplay dialog
     * TODO: update player with state, support, enabled
     */ /**
     * Check for support
     * @param {String} type - Player type (audio/video)
     * @param {String} provider - Provider (html5/youtube/vimeo)
     * @param {Boolean} inline - Where player has `playsinline` sttribute
     */ static supported(type, provider, inline) {
            return support.check(type, provider, inline);
        }
        /**
     * Load an SVG sprite into the page
     * @param {String} url - URL for the SVG sprite
     * @param {String} [id] - Unique ID
     */ static loadSprite(url, id) {
            return loadSprite(url, id);
        }
        /**
     * Setup multiple instances
     * @param {*} selector
     * @param {Object} options
     */ static setup(selector, options = {}) {
            let targets = null;
            if (is.string(selector)) targets = Array.from(document.querySelectorAll(selector));
            else if (is.nodeList(selector)) targets = Array.from(selector);
            else if (is.array(selector)) targets = selector.filter(is.element);
            if (is.empty(targets)) return null;
            return targets.map((t)=>new Plyr(t, options));
        }
    }
    Plyr.defaults = cloneDeep(defaults);
    return Plyr;
}); //# sourceMappingURL=plyr.js.map



var $5FkrB = parcelRequire("5FkrB");
/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */ /* global Reflect, Promise */ var $f188eff9b59fb855$var$extendStatics = function(d, b) {
    $f188eff9b59fb855$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return $f188eff9b59fb855$var$extendStatics(d, b);
};
function $f188eff9b59fb855$var$__extends(d, b) {
    $f188eff9b59fb855$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $f188eff9b59fb855$var$__assign = function() {
    $f188eff9b59fb855$var$__assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $f188eff9b59fb855$var$__assign.apply(this, arguments);
};
function $f188eff9b59fb855$var$__rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
    }
    return t;
}
var $f188eff9b59fb855$var$VIEWBOX_WIDTH = 100;
var $f188eff9b59fb855$var$VIEWBOX_HEIGHT = 100;
var $f188eff9b59fb855$var$VIEWBOX_HEIGHT_HALF = 50;
var $f188eff9b59fb855$var$VIEWBOX_CENTER_X = 50;
var $f188eff9b59fb855$var$VIEWBOX_CENTER_Y = 50;
function $f188eff9b59fb855$var$Path(_a) {
    var className = _a.className, counterClockwise = _a.counterClockwise, dashRatio = _a.dashRatio, pathRadius = _a.pathRadius, strokeWidth = _a.strokeWidth, style = _a.style;
    return (0, $5FkrB.createElement)("path", {
        className: className,
        style: Object.assign({}, style, $f188eff9b59fb855$var$getDashStyle({
            pathRadius: pathRadius,
            dashRatio: dashRatio,
            counterClockwise: counterClockwise
        })),
        d: $f188eff9b59fb855$var$getPathDescription({
            pathRadius: pathRadius,
            counterClockwise: counterClockwise
        }),
        strokeWidth: strokeWidth,
        fillOpacity: 0
    });
}
function $f188eff9b59fb855$var$getPathDescription(_a) {
    var pathRadius = _a.pathRadius, counterClockwise = _a.counterClockwise;
    var radius = pathRadius;
    var rotation = counterClockwise ? 1 : 0;
    return "\n      M " + $f188eff9b59fb855$var$VIEWBOX_CENTER_X + "," + $f188eff9b59fb855$var$VIEWBOX_CENTER_Y + "\n      m 0,-" + radius + "\n      a " + radius + "," + radius + " " + rotation + " 1 1 0," + 2 * radius + "\n      a " + radius + "," + radius + " " + rotation + " 1 1 0,-" + 2 * radius + "\n    ";
}
function $f188eff9b59fb855$var$getDashStyle(_a) {
    var counterClockwise = _a.counterClockwise, dashRatio = _a.dashRatio, pathRadius = _a.pathRadius;
    var diameter = Math.PI * 2 * pathRadius;
    var gapLength = (1 - dashRatio) * diameter;
    return {
        strokeDasharray: diameter + "px " + diameter + "px",
        strokeDashoffset: (counterClockwise ? -gapLength : gapLength) + "px"
    };
}
var $f188eff9b59fb855$export$14082143029b37c8 = function(_super) {
    $f188eff9b59fb855$var$__extends(CircularProgressbar, _super);
    function CircularProgressbar() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CircularProgressbar.prototype.getBackgroundPadding = function() {
        if (!this.props.background) return 0;
        return this.props.backgroundPadding;
    };
    CircularProgressbar.prototype.getPathRadius = function() {
        return $f188eff9b59fb855$var$VIEWBOX_HEIGHT_HALF - this.props.strokeWidth / 2 - this.getBackgroundPadding();
    };
    CircularProgressbar.prototype.getPathRatio = function() {
        var _a = this.props, value = _a.value, minValue = _a.minValue, maxValue = _a.maxValue;
        var boundedValue = Math.min(Math.max(value, minValue), maxValue);
        return (boundedValue - minValue) / (maxValue - minValue);
    };
    CircularProgressbar.prototype.render = function() {
        var _a = this.props, circleRatio = _a.circleRatio, className = _a.className, classes = _a.classes, counterClockwise = _a.counterClockwise, styles = _a.styles, strokeWidth = _a.strokeWidth, text = _a.text;
        var pathRadius = this.getPathRadius();
        var pathRatio = this.getPathRatio();
        return (0, $5FkrB.createElement)("svg", {
            className: classes.root + " " + className,
            style: styles.root,
            viewBox: "0 0 " + $f188eff9b59fb855$var$VIEWBOX_WIDTH + " " + $f188eff9b59fb855$var$VIEWBOX_HEIGHT,
            "data-test-id": "CircularProgressbar"
        }, this.props.background ? (0, $5FkrB.createElement)("circle", {
            className: classes.background,
            style: styles.background,
            cx: $f188eff9b59fb855$var$VIEWBOX_CENTER_X,
            cy: $f188eff9b59fb855$var$VIEWBOX_CENTER_Y,
            r: $f188eff9b59fb855$var$VIEWBOX_HEIGHT_HALF
        }) : null, (0, $5FkrB.createElement)($f188eff9b59fb855$var$Path, {
            className: classes.trail,
            counterClockwise: counterClockwise,
            dashRatio: circleRatio,
            pathRadius: pathRadius,
            strokeWidth: strokeWidth,
            style: styles.trail
        }), (0, $5FkrB.createElement)($f188eff9b59fb855$var$Path, {
            className: classes.path,
            counterClockwise: counterClockwise,
            dashRatio: pathRatio * circleRatio,
            pathRadius: pathRadius,
            strokeWidth: strokeWidth,
            style: styles.path
        }), text ? (0, $5FkrB.createElement)("text", {
            className: classes.text,
            style: styles.text,
            x: $f188eff9b59fb855$var$VIEWBOX_CENTER_X,
            y: $f188eff9b59fb855$var$VIEWBOX_CENTER_Y
        }, text) : null);
    };
    CircularProgressbar.defaultProps = {
        background: false,
        backgroundPadding: 0,
        circleRatio: 1,
        classes: {
            root: 'CircularProgressbar',
            trail: 'CircularProgressbar-trail',
            path: 'CircularProgressbar-path',
            text: 'CircularProgressbar-text',
            background: 'CircularProgressbar-background'
        },
        counterClockwise: false,
        className: '',
        maxValue: 100,
        minValue: 0,
        strokeWidth: 8,
        styles: {
            root: {},
            trail: {},
            path: {},
            text: {},
            background: {}
        },
        text: ''
    };
    return CircularProgressbar;
}((0, $5FkrB.Component));
function $f188eff9b59fb855$export$5ab97151efedb8c6(props) {
    var children = props.children, circularProgressbarProps = $f188eff9b59fb855$var$__rest(props, [
        "children"
    ]);
    return (0, $5FkrB.createElement)("div", {
        "data-test-id": "CircularProgressbarWithChildren"
    }, (0, $5FkrB.createElement)("div", {
        style: {
            position: 'relative',
            width: '100%',
            height: '100%'
        }
    }, (0, $5FkrB.createElement)($f188eff9b59fb855$export$14082143029b37c8, $f188eff9b59fb855$var$__assign({}, circularProgressbarProps)), props.children ? (0, $5FkrB.createElement)("div", {
        "data-test-id": "CircularProgressbarWithChildren__children",
        style: {
            position: 'absolute',
            width: '100%',
            height: '100%',
            marginTop: '-100%',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center'
        }
    }, props.children) : null));
}
function $f188eff9b59fb855$export$5115a192ad9bf57f(_a) {
    var rotation = _a.rotation, strokeLinecap = _a.strokeLinecap, textColor = _a.textColor, textSize = _a.textSize, pathColor = _a.pathColor, pathTransition = _a.pathTransition, pathTransitionDuration = _a.pathTransitionDuration, trailColor = _a.trailColor, backgroundColor = _a.backgroundColor;
    var rotationTransform = rotation == null ? undefined : "rotate(" + rotation + "turn)";
    var rotationTransformOrigin = rotation == null ? undefined : 'center center';
    return {
        root: {},
        path: $f188eff9b59fb855$var$removeUndefinedValues({
            stroke: pathColor,
            strokeLinecap: strokeLinecap,
            transform: rotationTransform,
            transformOrigin: rotationTransformOrigin,
            transition: pathTransition,
            transitionDuration: pathTransitionDuration == null ? undefined : pathTransitionDuration + "s"
        }),
        trail: $f188eff9b59fb855$var$removeUndefinedValues({
            stroke: trailColor,
            strokeLinecap: strokeLinecap,
            transform: rotationTransform,
            transformOrigin: rotationTransformOrigin
        }),
        text: $f188eff9b59fb855$var$removeUndefinedValues({
            fill: textColor,
            fontSize: textSize
        }),
        background: $f188eff9b59fb855$var$removeUndefinedValues({
            fill: backgroundColor
        })
    };
}
function $f188eff9b59fb855$var$removeUndefinedValues(obj) {
    Object.keys(obj).forEach(function(key) {
        if (obj[key] == null) delete obj[key];
    });
    return obj;
}



var $kqp0i = parcelRequire("kqp0i");

var $ekGgq = parcelRequire("ekGgq");

var $25nEq = parcelRequire("25nEq");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");

var $74Zh5 = parcelRequire("74Zh5");

var $25nEq = parcelRequire("25nEq");

var $5FkrB = parcelRequire("5FkrB");

var $dLGML = parcelRequire("dLGML");

var $fC8ib = parcelRequire("fC8ib");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $kIXpt = parcelRequire("kIXpt");

var $cYPzS = parcelRequire("cYPzS");

var $lwlXp = parcelRequire("lwlXp");

var $eyuDe = parcelRequire("eyuDe");

var $25nEq = parcelRequire("25nEq");

var $ekGgq = parcelRequire("ekGgq");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $25nEq = parcelRequire("25nEq");
function $b559068f7c9d286f$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $b559068f7c9d286f$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $b559068f7c9d286f$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $b559068f7c9d286f$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $b559068f7c9d286f$export$ad4be5c2ec28cecf = function isAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $b559068f7c9d286f$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === 'AnalyticsEvent';
};
var $b559068f7c9d286f$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function AnalyticsEvent(props) {
        var _this = this;
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, AnalyticsEvent);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "_isAnalyticsEvent", true);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "clone", function() {
            // just a shallow clone, don't change sub refs unless you want to
            // affect the original's too
            var payload = $b559068f7c9d286f$var$_objectSpread({}, _this.payload);
            return new AnalyticsEvent({
                payload: payload
            });
        });
        this.payload = props.payload;
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(AnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (typeof updater === 'function') this.payload = updater(this.payload);
                if ((0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(updater) === 'object') this.payload = $b559068f7c9d286f$var$_objectSpread($b559068f7c9d286f$var$_objectSpread({}, this.payload), updater);
                return this;
            }
        }
    ]);
}();


function $a2a767ee516c1728$var$_callSuper(t, o, e) {
    return o = (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(o), (0, (/*@__PURE__*/$parcel$interopDefault($kIXpt)))(t, $a2a767ee516c1728$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(t).constructor) : o.apply(t, e));
}
function $a2a767ee516c1728$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($a2a767ee516c1728$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $a2a767ee516c1728$var$_superPropGet(t, o, e, r) {
    var p = (0, (/*@__PURE__*/$parcel$interopDefault($lwlXp)))((0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(1 & r ? t.prototype : t), o, e);
    return 2 & r && "function" == typeof p ? function(t) {
        return p.apply(e, t);
    } : p;
}
var $a2a767ee516c1728$export$35f8383928ba8d7 = function isUIAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $a2a767ee516c1728$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isUIAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === 'UIAnalyticsEvent';
};
var $a2a767ee516c1728$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_AnalyticsEvent) {
    function UIAnalyticsEvent(props) {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, UIAnalyticsEvent);
        _this = $a2a767ee516c1728$var$_callSuper(this, UIAnalyticsEvent, [
            props
        ]);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "_isUIAnalyticsEvent", true);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "clone", function() {
            if (_this.hasFired) return null;
            var context = (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(_this.context);
            var handlers = (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(_this.handlers);
            /**
       * A hacky "deep clone" of the object. This is limited in that it wont
       * support functions, regexs, Maps, Sets, etc, but none of those need to
       * be represented in our payload.
       */ var payload = JSON.parse(JSON.stringify(_this.payload));
            return new UIAnalyticsEvent({
                context: context,
                handlers: handlers,
                payload: payload
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "fire", function(channel) {
            if (_this.hasFired) return;
            _this.handlers.forEach(function(handler) {
                return handler(_this, channel);
            });
            _this.hasFired = true;
        });
        _this.context = props.context || [];
        _this.handlers = props.handlers || [];
        _this.hasFired = false;
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($eyuDe)))(UIAnalyticsEvent, _AnalyticsEvent);
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(UIAnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (this.hasFired) return this;
                return $a2a767ee516c1728$var$_superPropGet(UIAnalyticsEvent, "update", this, 3)([
                    updater
                ]);
            }
        }
    ]);
}((0, $b559068f7c9d286f$export$2e2bcd8739ae039));



var $5FkrB = parcelRequire("5FkrB");

var $iyyOp = parcelRequire("iyyOp");
var $6f484fa23a28b277$export$d1f587f82ad51c4 = function useAnalyticsContext() {
    return (0, $5FkrB.useContext)((0, $iyyOp.default));
};


function $57e166037969db43$export$5bf35293e545f20c() {
    var analyticsContext = (0, $6f484fa23a28b277$export$d1f587f82ad51c4)();
    var createAnalyticsEvent = (0, $dLGML.useCallbackOne)(function(payload) {
        return new (0, $a2a767ee516c1728$export$2e2bcd8739ae039)({
            context: analyticsContext.getAtlaskitAnalyticsContext(),
            handlers: analyticsContext.getAtlaskitAnalyticsEventHandlers(),
            payload: payload
        });
    }, [
        analyticsContext
    ]);
    return {
        createAnalyticsEvent: createAnalyticsEvent
    };
}



var $5FkrB = parcelRequire("5FkrB");
var $e078443cd71270ad$export$1d27a74659855e44 = function useTrackedRef(value) {
    var ref = (0, $5FkrB.useRef)(value);
    ref.current = value;
    return ref;
};


function $efbe8ac0102cf4bd$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $efbe8ac0102cf4bd$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $efbe8ac0102cf4bd$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $efbe8ac0102cf4bd$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $efbe8ac0102cf4bd$export$a4687b0234b40e28(_ref) {
    var fn = _ref.fn, action = _ref.action, componentName = _ref.componentName, actionSubject = _ref.actionSubject, packageName = _ref.packageName, packageVersion = _ref.packageVersion, analyticsData = _ref.analyticsData;
    var _useAnalyticsEvents = (0, $57e166037969db43$export$5bf35293e545f20c)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
    // We put analyticsData and fn in a ref so that we don't need to break
    // memoization.
    // Generally these could be defined by consumers inline
    // and so we do this to avoid breaking memoization of useCallback
    var dataRef = (0, $e078443cd71270ad$export$1d27a74659855e44)(analyticsData);
    var fnRef = (0, $e078443cd71270ad$export$1d27a74659855e44)(fn);
    var handler = (0, $5FkrB.useCallback)(function(value) {
        var analyticsEvent = createAnalyticsEvent({
            action: action,
            actionSubject: actionSubject || componentName,
            attributes: {
                componentName: componentName,
                packageName: packageName,
                packageVersion: packageVersion
            }
        });
        // To avoid wrapping this component in AnalyticsContext we manually
        // push the parent context's meta data into the context.
        // Note: this new 'context'
        var context = $efbe8ac0102cf4bd$var$_objectSpread({
            componentName: componentName,
            packageName: packageName,
            packageVersion: packageVersion
        }, dataRef.current);
        analyticsEvent.context.push(context);
        // fire an event on the atlaskit channel
        var clone = analyticsEvent.clone();
        if (clone) clone.fire('atlaskit');
        fnRef.current(value, analyticsEvent);
    }, [
        // These are strings and won't change
        action,
        componentName,
        actionSubject,
        packageName,
        packageVersion,
        // This function is memoized in the context
        createAnalyticsEvent,
        // these are a stable ref because of the useTrackedRef hook
        dataRef,
        fnRef
    ]);
    return handler;
}



var $25nEq = parcelRequire("25nEq");

var $74Zh5 = parcelRequire("74Zh5");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $25nEq = parcelRequire("25nEq");

var $1Vcia = parcelRequire("1Vcia");

var $iYJcE = parcelRequire("iYJcE");

var $fL8KA = parcelRequire("fL8KA");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $25nEq = parcelRequire("25nEq");

var $6HG4S = parcelRequire("6HG4S");

var $iFR7a = parcelRequire("iFR7a");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $25nEq = parcelRequire("25nEq");

var $hLfKH = parcelRequire("hLfKH");
function $f5baaaf4b2f8257c$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $f5baaaf4b2f8257c$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $f5baaaf4b2f8257c$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $f5baaaf4b2f8257c$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $f5baaaf4b2f8257c$export$a66cbd9b2289cd78 = '@all-features';
var $f5baaaf4b2f8257c$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function Subscriptions() {
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, Subscriptions);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "eventToValue", new Map());
        this.emitter = new (0, (/*@__PURE__*/$parcel$interopDefault($hLfKH)))();
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(Subscriptions, [
        {
            key: "onGateUpdated",
            value: function onGateUpdated(gateName, callback, checkGate, options) {
                var _this = this;
                var value = checkGate(gateName, $f5baaaf4b2f8257c$var$_objectSpread($f5baaaf4b2f8257c$var$_objectSpread({}, options), {}, {
                    fireGateExposure: false
                }));
                if (this.eventToValue.get(callback) === undefined) this.eventToValue.set(callback, value);
                var wrapCallback = function wrapCallback() {
                    var value = checkGate(gateName, $f5baaaf4b2f8257c$var$_objectSpread($f5baaaf4b2f8257c$var$_objectSpread({}, options), {}, {
                        fireGateExposure: false
                    }));
                    var existingValue = _this.eventToValue.get(callback);
                    if (existingValue !== value) {
                        _this.eventToValue.set(callback, value);
                        callback(value);
                    }
                };
                this.emitter.on(gateName, wrapCallback);
                return function() {
                    _this.emitter.off(gateName, wrapCallback);
                };
            }
        },
        {
            key: "onExperimentValueUpdated",
            value: function onExperimentValueUpdated(experimentName, parameterName, defaultValue, callback, getExperimentValue, options) {
                var _this2 = this;
                var experimentEventName = "".concat(experimentName, ".").concat(parameterName);
                var value = getExperimentValue(experimentName, parameterName, defaultValue, $f5baaaf4b2f8257c$var$_objectSpread($f5baaaf4b2f8257c$var$_objectSpread({}, options), {}, {
                    fireExperimentExposure: false
                }));
                if (this.eventToValue.get(callback) === undefined) this.eventToValue.set(callback, value);
                var wrapCallback = function wrapCallback() {
                    var value = getExperimentValue(experimentName, parameterName, defaultValue, $f5baaaf4b2f8257c$var$_objectSpread($f5baaaf4b2f8257c$var$_objectSpread({}, options), {}, {
                        fireExperimentExposure: false
                    }));
                    var existingValue = _this2.eventToValue.get(callback);
                    if (existingValue !== value) {
                        _this2.eventToValue.set(callback, value);
                        callback(value);
                    }
                };
                this.emitter.on(experimentEventName, wrapCallback);
                return function() {
                    _this2.emitter.off(experimentEventName, wrapCallback);
                };
            }
        },
        {
            key: "onAnyUpdated",
            value: function onAnyUpdated(callback) {
                var _this3 = this;
                this.emitter.on($f5baaaf4b2f8257c$export$a66cbd9b2289cd78, callback);
                return function() {
                    _this3.emitter.off($f5baaaf4b2f8257c$export$a66cbd9b2289cd78, callback);
                };
            }
        },
        {
            key: "anyUpdated",
            value: function anyUpdated() {
                var _this4 = this;
                this.emitter.emit($f5baaaf4b2f8257c$export$a66cbd9b2289cd78);
                this.emitter.eventNames().filter(function(name) {
                    return name !== $f5baaaf4b2f8257c$export$a66cbd9b2289cd78;
                }).forEach(function(event) {
                    _this4.emitter.emit(event);
                });
            }
        }
    ]);
}();



var $ekGgq = parcelRequire("ekGgq");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $1Vcia = parcelRequire("1Vcia");

var $iYJcE = parcelRequire("iYJcE");

var $25nEq = parcelRequire("25nEq");

var $ygbGG = parcelRequire("ygbGG");
// Reference: https://github.com/statsig-io/js-lite/blob/main/src/StatsigStore.ts
var $ba555164627c78dc$export$c62558b199e46828 = /*#__PURE__*/ function(EvaluationReason) {
    // Order is important since the logic for migrating from a new client reason to an old one
    // returns the first which is a substring of the new client reason
    EvaluationReason["Error"] = "Error";
    EvaluationReason["LocalOverride"] = "LocalOverride";
    EvaluationReason["Unrecognized"] = "Unrecognized";
    EvaluationReason["Uninitialized"] = "Uninitialized";
    EvaluationReason["NetworkNotModified"] = "NetworkNotModified";
    EvaluationReason["Network"] = "Network";
    EvaluationReason["InvalidBootstrap"] = "InvalidBootstrap";
    EvaluationReason["Bootstrap"] = "Bootstrap";
    EvaluationReason["Cache"] = "Cache";
    // For when we could not migrate the reason from the new client
    EvaluationReason["Unknown"] = "Unknown";
    return EvaluationReason;
}({}); // Reference: https://github.com/statsig-io/js-lite/blob/main/src/StatsigSDKOptions.ts


/**
 * The identifiers for the user. Options are restricted to the set that is currently supported.
 */ /**
 * Base client options. Does not include any options specific to providers
 * @interface BaseClientOptions
 * @property {FeatureGateEnvironment} environment - The environment for the client.
 * @property {string} targetApp - The target app for the client.
 * @property {AnalyticsWebClient} analyticsWebClient - The analytics web client.
 * @property {PerimeterType} perimeter - The perimeter for the client.
 */ /**
 * The options for the client.
 * @interface ClientOptions
 * @extends {BaseClientOptions}
 * @property {string} apiKey - The API key for the client.
 * @property {fetchTimeoutMs} fetchTimeoutMs - The timeout for the fetch request in milliseconds. Defaults to 5000.
 * @property {boolean} useGatewayURL - Whether to use the gateway URL. Defaults to false.
 */ /**
 * The custom attributes for the user.
 */ var $9c86d86ab7ceadb6$export$479e7351a733299 = /*#__PURE__*/ function(FeatureGateEnvironment) {
    FeatureGateEnvironment["Development"] = "development";
    FeatureGateEnvironment["Staging"] = "staging";
    FeatureGateEnvironment["Production"] = "production";
    return FeatureGateEnvironment;
}({});
var $9c86d86ab7ceadb6$export$c42b7bbc5e7ba555 = /*#__PURE__*/ function(PerimeterType) {
    PerimeterType["COMMERCIAL"] = "commercial";
    PerimeterType["FEDRAMP_MODERATE"] = "fedramp-moderate";
    return PerimeterType;
}({});
var $9c86d86ab7ceadb6$export$42f4885608027d0c = 'non_boolean'; // Type magic to get the JSDoc comments from the Client class methods to appear on the static
 // methods in FeatureGates where the property name and function type are identical


var $7966583915353999$var$_excluded = [
    "api",
    "disableCurrentPageLogging",
    "loggingIntervalMillis",
    "loggingBufferMaxSize",
    "localMode",
    "eventLoggingApi",
    "eventLoggingApiForRetries",
    "disableLocalStorage",
    "ignoreWindowUndefined",
    "disableAllLogging",
    "initTimeoutMs",
    "disableNetworkKeepalive",
    "overrideStableID",
    "disableErrorLogging",
    "disableAutoMetricsLogging"
];
function $7966583915353999$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $7966583915353999$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $7966583915353999$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $7966583915353999$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $7966583915353999$export$d119b37e5f788b43 = function getOptionsWithDefaults(options) {
    return $7966583915353999$var$_objectSpread({
        /**
     * If more federal PerimeterTypes are added in the future, this should be updated so
     * that isFedRamp() === true always returns the strictest perimeter.
     */ perimeter: (0, $ygbGG.isFedRamp)() ? (0, $9c86d86ab7ceadb6$export$c42b7bbc5e7ba555).FEDRAMP_MODERATE : (0, $9c86d86ab7ceadb6$export$c42b7bbc5e7ba555).COMMERCIAL
    }, options);
};
var $7966583915353999$export$fa1c2bbf4100b8bc = function shallowEquals(objectA, objectB) {
    if (!objectA && !objectB) return true;
    if (!objectA || !objectB) return false;
    var aEntries = Object.entries(objectA);
    var bEntries = Object.entries(objectB);
    if (aEntries.length !== bEntries.length) return false;
    var ascendingKeyOrder = function ascendingKeyOrder(_ref, _ref2) {
        var _ref3 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_ref, 1), key1 = _ref3[0];
        var _ref4 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_ref2, 1), key2 = _ref4[0];
        return key1.localeCompare(key2);
    };
    aEntries.sort(ascendingKeyOrder);
    bEntries.sort(ascendingKeyOrder);
    for(var i = 0; i < aEntries.length; i++){
        var _aEntries$i = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(aEntries[i], 2), aValue = _aEntries$i[1];
        var _bEntries$i = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(bEntries[i], 2), bValue = _bEntries$i[1];
        if (aValue !== bValue) return false;
    }
    return true;
};
var $7966583915353999$export$3dad1db244472f32 = function toStatsigUser(identifiers, customAttributes) {
    var user = {
        customIDs: identifiers,
        custom: customAttributes
    };
    if (identifiers.atlassianAccountId) user.userID = identifiers.atlassianAccountId;
    return user;
};
var $7966583915353999$export$202946b690d26d22 = function migrateInitializationOptions(options) {
    var api = options.api, disableCurrentPageLogging = options.disableCurrentPageLogging, loggingIntervalMillis = options.loggingIntervalMillis, loggingBufferMaxSize = options.loggingBufferMaxSize, localMode = options.localMode, eventLoggingApi = options.eventLoggingApi, eventLoggingApiForRetries = options.eventLoggingApiForRetries, disableLocalStorage = options.disableLocalStorage, ignoreWindowUndefined = options.ignoreWindowUndefined, disableAllLogging = options.disableAllLogging, _initTimeoutMs = options.initTimeoutMs, _disableNetworkKeepalive = options.disableNetworkKeepalive, _overrideStableID = options.overrideStableID, _disableErrorLogging = options.disableErrorLogging, _disableAutoMetricsLogging = options.disableAutoMetricsLogging, rest = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(options, $7966583915353999$var$_excluded);
    return $7966583915353999$var$_objectSpread($7966583915353999$var$_objectSpread({}, rest), {}, {
        networkConfig: {
            api: api,
            logEventUrl: eventLoggingApi ? eventLoggingApi + 'rgstr' : undefined,
            logEventFallbackUrls: eventLoggingApiForRetries ? [
                eventLoggingApiForRetries
            ] : undefined,
            preventAllNetworkTraffic: localMode || !ignoreWindowUndefined && typeof window === 'undefined'
        },
        includeCurrentPageUrlWithEvents: !disableCurrentPageLogging,
        loggingIntervalMs: loggingIntervalMillis,
        loggingBufferMaxSize: loggingBufferMaxSize,
        disableStorage: disableLocalStorage === undefined ? localMode : disableLocalStorage,
        disableLogging: disableAllLogging === undefined ? localMode : disableAllLogging
    });
};
var $7966583915353999$var$evaluationReasonMappings = Object.entries((0, $ba555164627c78dc$export$c62558b199e46828)).map(function(_ref5) {
    var _ref6 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_ref5, 2), key = _ref6[0], value = _ref6[1];
    return [
        key.toLowerCase(),
        value
    ];
});
var $7966583915353999$export$18ad168d3dbac899 = function migrateEvaluationDetails(details) {
    var _evaluationReasonMapp, _evaluationReasonMapp2, _details$receivedAt;
    var reasonLower = details.reason.toLowerCase();
    return {
        reason: (_evaluationReasonMapp = (_evaluationReasonMapp2 = $7966583915353999$var$evaluationReasonMappings.find(function(_ref7) {
            var _ref8 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_ref7, 1), key = _ref8[0];
            return reasonLower.includes(key);
        })) === null || _evaluationReasonMapp2 === void 0 ? void 0 : _evaluationReasonMapp2[1]) !== null && _evaluationReasonMapp !== void 0 ? _evaluationReasonMapp : (0, $ba555164627c78dc$export$c62558b199e46828).Unknown,
        time: (_details$receivedAt = details.receivedAt) !== null && _details$receivedAt !== void 0 ? _details$receivedAt : Date.now()
    };
};
var $7966583915353999$export$55fd683752d01e67 = function migrateSecondaryExposures(secondaryExposures) {
    return secondaryExposures.map(function(exposure) {
        if (typeof exposure === 'string') // This should ideally have gateValue and ruleID fields too, but it's not possible for us
        // to determine the correct values for these.
        return {
            gate: exposure
        };
        return exposure;
    });
};


var $4ced36f4dd1a5269$export$6dc24881a3d96325 = /*#__PURE__*/ function() {
    function DynamicConfig(configName, configValue, ruleID, evaluationDetails) {
        var secondaryExposures = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : [];
        var allocatedExperimentName = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : '';
        var onDefaultValueFallback = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : null;
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, DynamicConfig);
        this.value = configValue;
        this._name = configName;
        this._ruleID = ruleID;
        this._secondaryExposures = secondaryExposures;
        this._allocatedExperimentName = allocatedExperimentName;
        this._evaluationDetails = evaluationDetails;
        this._onDefaultValueFallback = onDefaultValueFallback;
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(DynamicConfig, [
        {
            key: "get",
            value: function get(key, defaultValue, typeGuard) {
                var _this$_onDefaultValue2;
                var val = this.getValue(key, defaultValue);
                if (val == null) return defaultValue;
                var expectedType = Array.isArray(defaultValue) ? 'array' : (0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(defaultValue);
                var actualType = Array.isArray(val) ? 'array' : (0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(val);
                if (typeGuard) {
                    var _this$_onDefaultValue;
                    if (typeGuard(val)) {
                        this.fireExposure(key);
                        return val;
                    }
                    (_this$_onDefaultValue = this._onDefaultValueFallback) === null || _this$_onDefaultValue === void 0 || _this$_onDefaultValue.call(this, this, key, expectedType, actualType);
                    return defaultValue;
                }
                if (defaultValue == null || expectedType === actualType) {
                    this.fireExposure(key);
                    return val;
                }
                (_this$_onDefaultValue2 = this._onDefaultValueFallback) === null || _this$_onDefaultValue2 === void 0 || _this$_onDefaultValue2.call(this, this, key, expectedType, actualType);
                return defaultValue;
            }
        },
        {
            key: "getValue",
            value: function getValue(key, defaultValue) {
                if (key == null) return this.value;
                if (defaultValue == null) defaultValue = null;
                if (this.value[key] == null) return defaultValue;
                this.fireExposure(key);
                return this.value[key];
            }
        },
        {
            key: "fireExposure",
            value: function fireExposure(key) {
                // Call the wrapped experiment's get method to fire exposure
                if (this.experiment) this.experiment.get(key);
            }
        }
    ], [
        {
            key: "fromExperiment",
            value: function fromExperiment(experiment) {
                var _experiment$__evaluat, _experiment$__evaluat2, _experiment$groupName;
                var config = new DynamicConfig(experiment.name, experiment.value, experiment.ruleID, (0, $7966583915353999$export$18ad168d3dbac899)(experiment.details), (0, $7966583915353999$export$55fd683752d01e67)((_experiment$__evaluat = (_experiment$__evaluat2 = experiment.__evaluation) === null || _experiment$__evaluat2 === void 0 ? void 0 : _experiment$__evaluat2.secondary_exposures) !== null && _experiment$__evaluat !== void 0 ? _experiment$__evaluat : []), (_experiment$groupName = experiment.groupName) !== null && _experiment$groupName !== void 0 ? _experiment$groupName : undefined);
                config.experiment = experiment;
                return config;
            }
        }
    ]);
}();



var $ekGgq = parcelRequire("ekGgq");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $1e45ecff8cda5921$export$936d0764594b6eb3 = /*#__PURE__*/ function() {
    function Layer(name, layerValue, ruleID, evaluationDetails) {
        var logParameterFunction = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
        var secondaryExposures = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : [];
        var undelegatedSecondaryExposures = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : [];
        var allocatedExperimentName = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : '';
        var explicitParameters = arguments.length > 8 && arguments[8] !== undefined ? arguments[8] : [];
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, Layer);
        this._logParameterFunction = logParameterFunction;
        this._name = name;
        this._value = JSON.parse(JSON.stringify(layerValue !== null && layerValue !== void 0 ? layerValue : {}));
        this._ruleID = ruleID !== null && ruleID !== void 0 ? ruleID : '';
        this._evaluationDetails = evaluationDetails;
        this._secondaryExposures = secondaryExposures;
        this._undelegatedSecondaryExposures = undelegatedSecondaryExposures;
        this._allocatedExperimentName = allocatedExperimentName;
        this._explicitParameters = explicitParameters;
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(Layer, [
        {
            key: "get",
            value: function get(key, defaultValue, typeGuard) {
                var _this = this;
                var val = this._value[key];
                if (val == null) return defaultValue;
                var logAndReturn = function logAndReturn() {
                    _this._logLayerParameterExposure(key);
                    return val;
                };
                if (typeGuard) return typeGuard(val) ? logAndReturn() : defaultValue;
                if (defaultValue == null) return logAndReturn();
                if ((0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(val) === (0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(defaultValue) && Array.isArray(defaultValue) === Array.isArray(val)) return logAndReturn();
                return defaultValue;
            }
        },
        {
            key: "getValue",
            value: function getValue(key, defaultValue) {
                // eslint-disable-next-line eqeqeq
                if (defaultValue == undefined) defaultValue = null;
                var val = this._value[key];
                if (val != null) this._logLayerParameterExposure(key);
                return val !== null && val !== void 0 ? val : defaultValue;
            }
        },
        {
            key: "_logLayerParameterExposure",
            value: function _logLayerParameterExposure(parameterName) {
                var _this$_logParameterFu;
                (_this$_logParameterFu = this._logParameterFunction) === null || _this$_logParameterFu === void 0 || _this$_logParameterFu.call(this, this, parameterName);
            }
        }
    ], [
        {
            key: "fromLayer",
            value: function fromLayer(layer) {
                var _layer$__evaluation$s, _layer$__evaluation, _layer$__evaluation$u, _layer$__evaluation2, _layer$__evaluation3, _layer$__evaluation4;
                var value = new Layer(layer.name, layer.__value, layer.ruleID, (0, $7966583915353999$export$18ad168d3dbac899)(layer.details), function(_layer, parameterName) {
                    return layer.get(parameterName);
                }, (0, $7966583915353999$export$55fd683752d01e67)((_layer$__evaluation$s = (_layer$__evaluation = layer.__evaluation) === null || _layer$__evaluation === void 0 ? void 0 : _layer$__evaluation.secondary_exposures) !== null && _layer$__evaluation$s !== void 0 ? _layer$__evaluation$s : []), (0, $7966583915353999$export$55fd683752d01e67)((_layer$__evaluation$u = (_layer$__evaluation2 = layer.__evaluation) === null || _layer$__evaluation2 === void 0 ? void 0 : _layer$__evaluation2.undelegated_secondary_exposures) !== null && _layer$__evaluation$u !== void 0 ? _layer$__evaluation$u : []), (_layer$__evaluation3 = layer.__evaluation) === null || _layer$__evaluation3 === void 0 ? void 0 : _layer$__evaluation3.allocated_experiment_name, (_layer$__evaluation4 = layer.__evaluation) === null || _layer$__evaluation4 === void 0 ? void 0 : _layer$__evaluation4.explicit_parameters);
                return value;
            }
        }
    ]);
}();




var $25nEq = parcelRequire("25nEq");

var $fL8KA = parcelRequire("fL8KA");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $6HG4S = parcelRequire("6HG4S");

/// <reference types="node" />
var $abe922f7cb7f1134$export$a59f8d67326bd1cb = "0.0.0-development";



var $arMYe = parcelRequire("arMYe");

var $9P61R = parcelRequire("9P61R");

var $kIXpt = parcelRequire("kIXpt");

var $cYPzS = parcelRequire("cYPzS");

var $eyuDe = parcelRequire("eyuDe");

var $c7s0H = parcelRequire("c7s0H");
function $7f7c525dd25eff02$var$_callSuper(t, o, e) {
    return o = (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(o), (0, (/*@__PURE__*/$parcel$interopDefault($kIXpt)))(t, $7f7c525dd25eff02$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(t).constructor) : o.apply(t, e));
}
function $7f7c525dd25eff02$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($7f7c525dd25eff02$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $7f7c525dd25eff02$export$286baf652d0b1206 = /*#__PURE__*/ function(_Error) {
    function ResponseError(message) {
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, ResponseError);
        return $7f7c525dd25eff02$var$_callSuper(this, ResponseError, [
            message
        ]);
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($eyuDe)))(ResponseError, _Error);
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(ResponseError);
}(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($c7s0H)))(Error));


function $abab9d5375955b27$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $abab9d5375955b27$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $abab9d5375955b27$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $abab9d5375955b27$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $abab9d5375955b27$var$DEFAULT_REQUEST_TIMEOUT_MS = 5000;
var $abab9d5375955b27$export$250a58ecde616daa = 'https://api.atlassian.com/flags';
var $abab9d5375955b27$export$942ba04389b0d5a2 = 'https://api.stg.atlassian.com/flags';
var $abab9d5375955b27$export$f058dbf75c3bc647 = 'https://api.dev.atlassian.com/flags';
var $abab9d5375955b27$export$1a401a0da8da3565 = 'https://api.stg.atlassian-us-gov-mod.com/flags';
var $abab9d5375955b27$export$18c93900db9358a4 = 'https://api.atlassian-us-gov-mod.com/flags';
var $abab9d5375955b27$export$4e8a0415edbfa1f7 = 'https://atlassian-statsig-proxy-archetype.atl-paas.%s.atl-ic.net';
var $abab9d5375955b27$export$cb3cd156f70d7e94 = 'oasis-stg.com/flags';
var $abab9d5375955b27$export$921fbc6cdfd4eee0 = 'atlassian-isolated.net/flags';
var $abab9d5375955b27$export$450bd8fb2a6d7ace = '/gateway/api/flags';
var $abab9d5375955b27$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function Fetcher() {
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, Fetcher);
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(Fetcher, null, [
        {
            key: "fetchClientSdk",
            value: function() {
                var _fetchClientSdk = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee(fetcherOptions) {
                    var targetApp, url;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee$(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                targetApp = fetcherOptions.targetApp;
                                url = "/api/v2/frontend/clientSdkKey/".concat(targetApp);
                                _context.prev = 2;
                                _context.next = 5;
                                return this.fetchRequest(url, 'GET', fetcherOptions);
                            case 5:
                                return _context.abrupt("return", _context.sent);
                            case 8:
                                _context.prev = 8;
                                _context.t0 = _context["catch"](2);
                                if (!(_context.t0 instanceof Error)) {
                                    _context.next = 12;
                                    break;
                                }
                                throw _context.t0;
                            case 12:
                                throw Error('Failed to retrieve client sdk key');
                            case 13:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee, this, [
                        [
                            2,
                            8
                        ]
                    ]);
                }));
                function fetchClientSdk(_x) {
                    return _fetchClientSdk.apply(this, arguments);
                }
                return fetchClientSdk;
            }()
        },
        {
            key: "fetchExperimentValues",
            value: function() {
                var _fetchExperimentValues = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee2(fetcherOptions, identifiers, customAttributes) {
                    var requestBody;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee2$(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                requestBody = {
                                    identifiers: identifiers,
                                    customAttributes: customAttributes,
                                    targetApp: fetcherOptions.targetApp
                                };
                                _context2.prev = 1;
                                _context2.next = 4;
                                return this.fetchRequest('/api/v2/frontend/experimentValues', 'POST', fetcherOptions, requestBody);
                            case 4:
                                return _context2.abrupt("return", _context2.sent);
                            case 7:
                                _context2.prev = 7;
                                _context2.t0 = _context2["catch"](1);
                                if (!(_context2.t0 instanceof Error)) {
                                    _context2.next = 11;
                                    break;
                                }
                                throw _context2.t0;
                            case 11:
                                throw Error('Failed to retrieve experiment values');
                            case 12:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2, this, [
                        [
                            1,
                            7
                        ]
                    ]);
                }));
                function fetchExperimentValues(_x2, _x3, _x4) {
                    return _fetchExperimentValues.apply(this, arguments);
                }
                return fetchExperimentValues;
            }()
        },
        {
            key: "handleResponseError",
            value: function() {
                var _handleResponseError = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee3(response) {
                    var body;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee3$(_context3) {
                        while(true)switch(_context3.prev = _context3.next){
                            case 0:
                                if (response.ok) {
                                    _context3.next = 5;
                                    break;
                                }
                                _context3.next = 3;
                                return response.text();
                            case 3:
                                body = _context3.sent;
                                throw new (0, $7f7c525dd25eff02$export$286baf652d0b1206)("Non 2xx response status received, status: ".concat(response.status, ", body: ").concat(JSON.stringify(body)));
                            case 5:
                                if (!(response.status === 204)) {
                                    _context3.next = 7;
                                    break;
                                }
                                throw new (0, $7f7c525dd25eff02$export$286baf652d0b1206)('Unexpected 204 response');
                            case 7:
                            case "end":
                                return _context3.stop();
                        }
                    }, _callee3);
                }));
                function handleResponseError(_x5) {
                    return _handleResponseError.apply(this, arguments);
                }
                return handleResponseError;
            }()
        },
        {
            key: "extractResponseBody",
            value: function() {
                var _extractResponseBody = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee4(response) {
                    var value;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee4$(_context4) {
                        while(true)switch(_context4.prev = _context4.next){
                            case 0:
                                _context4.next = 2;
                                return response.text();
                            case 2:
                                value = _context4.sent;
                                return _context4.abrupt("return", JSON.parse(value));
                            case 4:
                            case "end":
                                return _context4.stop();
                        }
                    }, _callee4);
                }));
                function extractResponseBody(_x6) {
                    return _extractResponseBody.apply(this, arguments);
                }
                return extractResponseBody;
            }()
        },
        {
            key: "getBaseUrl",
            value: function getBaseUrl(serviceEnv) {
                var useGatewayUrl = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
                var perimeter = arguments.length > 2 ? arguments[2] : undefined;
                var isolationContextId = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
                if (useGatewayUrl) return $abab9d5375955b27$export$450bd8fb2a6d7ace;
                if (perimeter === (0, $9c86d86ab7ceadb6$export$c42b7bbc5e7ba555).FEDRAMP_MODERATE) switch(serviceEnv){
                    case (0, $9c86d86ab7ceadb6$export$479e7351a733299).Production:
                        return $abab9d5375955b27$export$18c93900db9358a4;
                    case (0, $9c86d86ab7ceadb6$export$479e7351a733299).Staging:
                        return $abab9d5375955b27$export$1a401a0da8da3565;
                    default:
                        throw new Error("Invalid environment \"".concat(serviceEnv, "\" for \"").concat(perimeter, "\" perimeter"));
                }
                else if (perimeter === (0, $9c86d86ab7ceadb6$export$c42b7bbc5e7ba555).COMMERCIAL) switch(serviceEnv){
                    case (0, $9c86d86ab7ceadb6$export$479e7351a733299).Development:
                        return $abab9d5375955b27$export$f058dbf75c3bc647;
                    case (0, $9c86d86ab7ceadb6$export$479e7351a733299).Staging:
                        var apiUrl = this.getApiUrl(isolationContextId);
                        if (apiUrl !== null) return apiUrl;
                        return $abab9d5375955b27$export$942ba04389b0d5a2;
                    default:
                        var prodApiUrl = this.getApiUrl(isolationContextId);
                        if (prodApiUrl !== null) return prodApiUrl;
                        return $abab9d5375955b27$export$250a58ecde616daa;
                }
                else throw new Error("Invalid perimeter \"".concat(perimeter, "\""));
            }
        },
        {
            key: "fetchRequest",
            value: function() {
                var _fetchRequest = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee5(path, method, fetcherOptions, body) {
                    var baseUrl, fetchTimeout, abortSignal, abortController, response;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee5$(_context5) {
                        while(true)switch(_context5.prev = _context5.next){
                            case 0:
                                baseUrl = Fetcher.getBaseUrl(fetcherOptions.environment, fetcherOptions.useGatewayURL, fetcherOptions.perimeter, fetcherOptions.isolationContextId);
                                fetchTimeout = fetcherOptions.fetchTimeoutMs || $abab9d5375955b27$var$DEFAULT_REQUEST_TIMEOUT_MS;
                                if (AbortSignal.timeout) abortSignal = AbortSignal.timeout(fetchTimeout);
                                else if (AbortController) {
                                    abortController = new AbortController();
                                    abortSignal = abortController.signal;
                                    setTimeout(function() {
                                        return abortController.abort();
                                    }, fetchTimeout);
                                }
                                _context5.next = 5;
                                return fetch("".concat(baseUrl).concat(path), $abab9d5375955b27$var$_objectSpread({
                                    method: method,
                                    headers: {
                                        'Content-Type': 'application/json',
                                        'X-Client-Name': 'feature-gate-js-client',
                                        'X-Client-Version': (0, $abe922f7cb7f1134$export$a59f8d67326bd1cb),
                                        'X-API-KEY': fetcherOptions.apiKey
                                    },
                                    signal: abortSignal
                                }, body && {
                                    body: JSON.stringify(body)
                                }));
                            case 5:
                                response = _context5.sent;
                                _context5.next = 8;
                                return this.handleResponseError(response);
                            case 8:
                                _context5.next = 10;
                                return this.extractResponseBody(response);
                            case 10:
                                return _context5.abrupt("return", _context5.sent);
                            case 11:
                            case "end":
                                return _context5.stop();
                        }
                    }, _callee5, this);
                }));
                function fetchRequest(_x7, _x8, _x9, _x0) {
                    return _fetchRequest.apply(this, arguments);
                }
                return fetchRequest;
            }()
        },
        {
            key: "getApiUrl",
            value: function getApiUrl(isolationContextId) {
                var window1 = this.getWindowLocation();
                if (window1 === undefined) {
                    //this is needed when this SDK is used for SSR or plugin use cases where secret keys not available to use backend SDKs
                    if (!isolationContextId) return null;
                    return $abab9d5375955b27$export$4e8a0415edbfa1f7.replace('%s', isolationContextId);
                }
                var protocol = window1.protocol, hostname = window1.hostname;
                // Match last subdomain fragment before oasis-stg.com
                var oasisMatch = hostname.match(/([^.]+)\.oasis-stg\.com$/);
                if (oasisMatch) return "".concat(protocol, "//api.").concat(oasisMatch[1], ".").concat($abab9d5375955b27$export$cb3cd156f70d7e94);
                // Match last subdomain fragment before atlassian-isolated.net
                var isolatedMatch = hostname.match(/([^.]+)\.atlassian-isolated\.net$/);
                if (isolatedMatch) return "".concat(protocol, "//api.").concat(isolatedMatch[1], ".").concat($abab9d5375955b27$export$921fbc6cdfd4eee0);
                return null;
            }
        },
        {
            key: "getWindowLocation",
            value: function getWindowLocation() {
                if (typeof window !== 'undefined' && window.location) return window.location;
                return undefined;
            }
        }
    ]);
}();



var $fL8KA = parcelRequire("fL8KA");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $kIXpt = parcelRequire("kIXpt");

var $cYPzS = parcelRequire("cYPzS");

var $lwlXp = parcelRequire("lwlXp");

var $eyuDe = parcelRequire("eyuDe");

var $25nEq = parcelRequire("25nEq");

var $6HG4S = parcelRequire("6HG4S");

var $iFR7a = parcelRequire("iFR7a");
function $a96d5501b6a4242d$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $a96d5501b6a4242d$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $a96d5501b6a4242d$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $a96d5501b6a4242d$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $a96d5501b6a4242d$var$_callSuper(t, o, e) {
    return o = (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(o), (0, (/*@__PURE__*/$parcel$interopDefault($kIXpt)))(t, $a96d5501b6a4242d$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(t).constructor) : o.apply(t, e));
}
function $a96d5501b6a4242d$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($a96d5501b6a4242d$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $a96d5501b6a4242d$var$_superPropGet(t, o, e, r) {
    var p = (0, (/*@__PURE__*/$parcel$interopDefault($lwlXp)))((0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(1 & r ? t.prototype : t), o, e);
    return 2 & r && "function" == typeof p ? function(t) {
        return p.apply(e, t);
    } : p;
}
var $a96d5501b6a4242d$export$55fffef3474104af = /*#__PURE__*/ function(_DataAdapterCore) {
    function NoFetchDataAdapter() {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, NoFetchDataAdapter);
        _this = $a96d5501b6a4242d$var$_callSuper(this, NoFetchDataAdapter, [
            'NoFetchDataAdapter',
            'nofetch'
        ]);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "bootstrapResult", null);
        return _this;
    }
    /**
   * Make sure to call this **before** calling `initializeAsync` or `updateUserAsync` but
   * after the Statsig client has been created!
   */ (0, (/*@__PURE__*/$parcel$interopDefault($eyuDe)))(NoFetchDataAdapter, _DataAdapterCore);
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(NoFetchDataAdapter, [
        {
            key: "setBootstrapData",
            value: function setBootstrapData(data) {
                this.bootstrapResult = data ? {
                    source: 'Bootstrap',
                    data: JSON.stringify(data),
                    receivedAt: Date.now(),
                    stableID: (0, $iFR7a.StableID).get(this._getSdkKey()),
                    fullUserHash: null
                } : null;
            }
        },
        {
            key: "prefetchData",
            value: function() {
                var _prefetchData = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee(_user, _options) {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee$(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee);
                }));
                function prefetchData(_x, _x2) {
                    return _prefetchData.apply(this, arguments);
                }
                return prefetchData;
            }()
        },
        {
            key: "getDataAsync",
            value: function() {
                var _getDataAsync = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee2(_current, user, _options) {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee2$(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                return _context2.abrupt("return", this.bootstrapResult && $a96d5501b6a4242d$var$_objectSpread($a96d5501b6a4242d$var$_objectSpread({}, this.bootstrapResult), {}, {
                                    fullUserHash: (0, $iFR7a._getFullUserHash)(user)
                                }));
                            case 1:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2, this);
                }));
                function getDataAsync(_x3, _x4, _x5) {
                    return _getDataAsync.apply(this, arguments);
                }
                return getDataAsync;
            }()
        },
        {
            key: "getDataSync",
            value: function getDataSync(user) {
                return this.bootstrapResult && $a96d5501b6a4242d$var$_objectSpread($a96d5501b6a4242d$var$_objectSpread({}, this.bootstrapResult), {}, {
                    fullUserHash: (0, $iFR7a._getFullUserHash)(user)
                });
            }
        },
        {
            key: "_fetchFromNetwork",
            value: function() {
                var _fetchFromNetwork2 = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee3(_current, _user, _options) {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee3$(_context3) {
                        while(true)switch(_context3.prev = _context3.next){
                            case 0:
                                return _context3.abrupt("return", null);
                            case 1:
                            case "end":
                                return _context3.stop();
                        }
                    }, _callee3);
                }));
                function _fetchFromNetwork(_x6, _x7, _x8) {
                    return _fetchFromNetwork2.apply(this, arguments);
                }
                return _fetchFromNetwork;
            }()
        },
        {
            key: "_getCacheKey",
            value: function _getCacheKey(user) {
                // Same logic as default data adapter
                // https://github.com/statsig-io/js-client-monorepo/blob/main/packages/js-client/src/StatsigEvaluationsDataAdapter.ts
                var key = (0, $iFR7a._getStorageKey)(this._getSdkKey(), user);
                return "".concat((0, $iFR7a.DataAdapterCachePrefix), ".").concat(this._cacheSuffix, ".").concat(key);
            }
        },
        {
            key: "_isCachedResultValidFor204",
            value: function _isCachedResultValidFor204(_result, _user) {
                return false;
            }
        },
        {
            key: "setDataLegacy",
            value: function setDataLegacy(data, user) {
                $a96d5501b6a4242d$var$_superPropGet(NoFetchDataAdapter, "setData", this, 3)([
                    data,
                    user
                ]);
            }
        },
        {
            key: "toJSON",
            value: function toJSON() {
                var result = $a96d5501b6a4242d$var$_objectSpread({}, this);
                delete result._options;
                delete result._inMemoryCache;
                delete result.bootstrapResult;
                return result;
            }
        }
    ]);
}((0, $iFR7a.DataAdapterCore));



var $25nEq = parcelRequire("25nEq");

var $iYJcE = parcelRequire("iYJcE");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $dtn6l = parcelRequire("dtn6l");
function $0bd51deafeacf187$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $0bd51deafeacf187$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $0bd51deafeacf187$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $0bd51deafeacf187$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $0bd51deafeacf187$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $0bd51deafeacf187$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $0bd51deafeacf187$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $0bd51deafeacf187$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $0bd51deafeacf187$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $0bd51deafeacf187$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
var $0bd51deafeacf187$var$LOCAL_OVERRIDE_REASON = 'LocalOverride:Recognized';
var $0bd51deafeacf187$export$d8474cff104280f3 = 'STATSIG_OVERRIDES';
var $0bd51deafeacf187$var$LEGACY_LOCAL_STORAGE_KEY = 'STATSIG_JS_LITE_LOCAL_OVERRIDES';
var $0bd51deafeacf187$var$makeEmptyStore = function makeEmptyStore() {
    return {
        gates: {},
        configs: {},
        layers: {}
    };
};
var $0bd51deafeacf187$var$djb2MapKey = function djb2MapKey(hash, kind) {
    return kind + ':' + hash;
};
var $0bd51deafeacf187$export$bcb28fbac1def494 = /*#__PURE__*/ function() {
    function PersistentOverrideAdapter(localStorageKey) {
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, PersistentOverrideAdapter);
        this._overrides = $0bd51deafeacf187$var$makeEmptyStore();
        this._djb2Map = new Map();
        this._localStorageKey = localStorageKey;
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(PersistentOverrideAdapter, [
        {
            key: "parseStoredOverrides",
            value: function parseStoredOverrides(localStorageKey) {
                try {
                    var json = window.localStorage.getItem(localStorageKey);
                    if (!json) return $0bd51deafeacf187$var$makeEmptyStore();
                    return JSON.parse(json);
                } catch (_unused) {
                    return $0bd51deafeacf187$var$makeEmptyStore();
                }
            }
        },
        {
            key: "mergeOverrides",
            value: function mergeOverrides() {
                var merged = $0bd51deafeacf187$var$makeEmptyStore();
                for(var _len = arguments.length, allOverrides = new Array(_len), _key = 0; _key < _len; _key++)allOverrides[_key] = arguments[_key];
                for(var _i = 0, _allOverrides = allOverrides; _i < _allOverrides.length; _i++){
                    var overrides = _allOverrides[_i];
                    for(var _i2 = 0, _Object$entries = Object.entries((_overrides$gates = overrides.gates) !== null && _overrides$gates !== void 0 ? _overrides$gates : {}); _i2 < _Object$entries.length; _i2++){
                        var _overrides$gates;
                        var _Object$entries$_i = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_Object$entries[_i2], 2), name = _Object$entries$_i[0], value = _Object$entries$_i[1];
                        merged.gates[name] = value;
                    }
                    for(var _i3 = 0, _Object$entries2 = Object.entries((_overrides$configs = overrides.configs) !== null && _overrides$configs !== void 0 ? _overrides$configs : {}); _i3 < _Object$entries2.length; _i3++){
                        var _overrides$configs;
                        var _Object$entries2$_i = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_Object$entries2[_i3], 2), _name = _Object$entries2$_i[0], _value = _Object$entries2$_i[1];
                        merged.configs[_name] = _value;
                    }
                    for(var _i4 = 0, _Object$entries3 = Object.entries((_overrides$layers = overrides.layers) !== null && _overrides$layers !== void 0 ? _overrides$layers : {}); _i4 < _Object$entries3.length; _i4++){
                        var _overrides$layers;
                        var _Object$entries3$_i = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_Object$entries3[_i4], 2), _name2 = _Object$entries3$_i[0], _value2 = _Object$entries3$_i[1];
                        merged.layers[_name2] = _value2;
                    }
                }
                return merged;
            }
        },
        {
            key: "initFromStoredOverrides",
            value: function initFromStoredOverrides() {
                var storedOverrides = this.mergeOverrides(this._overrides, this.parseStoredOverrides($0bd51deafeacf187$var$LEGACY_LOCAL_STORAGE_KEY), this.parseStoredOverrides(this._localStorageKey));
                // Clear data from legacy local storage key now we've read from it.
                // This prevents things being stuck in there that are always read but never written to.
                try {
                    window.localStorage.removeItem($0bd51deafeacf187$var$LEGACY_LOCAL_STORAGE_KEY);
                } catch (_unused2) {
                // ignored - window is not defined in non-browser environments, and we don't save things there
                // (things like SSR, etc)
                }
                // In version 4.24.0 we introduced hashes in this override adapter, but had a bug which would cause
                // multiple hashes to continue being created. This code here removes these hashes since we've moved
                // to using a more reliable and easier to maintain map in `_djb2Map`.
                for(var _i5 = 0, _Object$values = Object.values(storedOverrides); _i5 < _Object$values.length; _i5++){
                    var container = _Object$values[_i5];
                    var allKeys = new Set(Object.keys(container));
                    var _iterator = $0bd51deafeacf187$var$_createForOfIteratorHelper(allKeys), _step;
                    try {
                        for(_iterator.s(); !(_step = _iterator.n()).done;){
                            var name = _step.value;
                            var hash = (0, $dtn6l._DJB2)(name);
                            if (allKeys.has(hash)) delete container[hash];
                        }
                    } catch (err) {
                        _iterator.e(err);
                    } finally{
                        _iterator.f();
                    }
                }
                this.applyOverrides(storedOverrides);
            }
        },
        {
            key: "saveOverrides",
            value: function saveOverrides() {
                try {
                    window.localStorage.setItem(this._localStorageKey, JSON.stringify(this._overrides));
                } catch (_unused3) {
                // ignored - window is not defined in non-browser environments, and we don't save things there
                // (things like SSR, etc)
                }
            }
        },
        {
            key: "getOverrides",
            value: function getOverrides() {
                return this.mergeOverrides(this._overrides);
            }
        },
        {
            key: "applyOverrides",
            value: function applyOverrides(overrides) {
                var newOverrides = $0bd51deafeacf187$var$_objectSpread($0bd51deafeacf187$var$_objectSpread({}, $0bd51deafeacf187$var$makeEmptyStore()), overrides);
                this._djb2Map.clear();
                for(var _i6 = 0, _Object$entries4 = Object.entries(newOverrides); _i6 < _Object$entries4.length; _i6++){
                    var _Object$entries4$_i = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_Object$entries4[_i6], 2), containerName = _Object$entries4$_i[0], container = _Object$entries4$_i[1];
                    for(var _i7 = 0, _Object$entries5 = Object.entries(container); _i7 < _Object$entries5.length; _i7++){
                        var _Object$entries5$_i = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_Object$entries5[_i7], 2), name = _Object$entries5$_i[0], value = _Object$entries5$_i[1];
                        this._djb2Map.set($0bd51deafeacf187$var$djb2MapKey((0, $dtn6l._DJB2)(name), containerName), value);
                    }
                }
                this._overrides = newOverrides;
            }
        },
        {
            key: "setOverrides",
            value: function setOverrides(overrides) {
                this.applyOverrides(overrides);
                this.saveOverrides();
            }
        },
        {
            key: "overrideGate",
            value: function overrideGate(name, value) {
                this._overrides.gates[name] = value;
                this._djb2Map.set($0bd51deafeacf187$var$djb2MapKey((0, $dtn6l._DJB2)(name), 'gates'), value);
                this.saveOverrides();
            }
        },
        {
            key: "removeGateOverride",
            value: function removeGateOverride(name) {
                delete this._overrides.gates[name];
                this._djb2Map.delete($0bd51deafeacf187$var$djb2MapKey((0, $dtn6l._DJB2)(name), 'gates'));
                this.saveOverrides();
            }
        },
        {
            key: "getGateOverride",
            value: function getGateOverride(current, _user) {
                var _this$_overrides$gate;
                var overridden = (_this$_overrides$gate = this._overrides.gates[current.name]) !== null && _this$_overrides$gate !== void 0 ? _this$_overrides$gate : this._djb2Map.get($0bd51deafeacf187$var$djb2MapKey(current.name, 'gates'));
                if (overridden == null) return null;
                return $0bd51deafeacf187$var$_objectSpread($0bd51deafeacf187$var$_objectSpread({}, current), {}, {
                    value: overridden,
                    details: $0bd51deafeacf187$var$_objectSpread($0bd51deafeacf187$var$_objectSpread({}, current.details), {}, {
                        reason: $0bd51deafeacf187$var$LOCAL_OVERRIDE_REASON
                    })
                });
            }
        },
        {
            key: "overrideDynamicConfig",
            value: function overrideDynamicConfig(name, value) {
                this._overrides.configs[name] = value;
                this._djb2Map.set($0bd51deafeacf187$var$djb2MapKey((0, $dtn6l._DJB2)(name), 'configs'), value);
                this.saveOverrides();
            }
        },
        {
            key: "removeDynamicConfigOverride",
            value: function removeDynamicConfigOverride(name) {
                delete this._overrides.configs[name];
                this._djb2Map.delete($0bd51deafeacf187$var$djb2MapKey((0, $dtn6l._DJB2)(name), 'configs'));
                this.saveOverrides();
            }
        },
        {
            key: "getDynamicConfigOverride",
            value: function getDynamicConfigOverride(current, _user) {
                return this._getConfigOverride(current, this._overrides.configs);
            }
        },
        {
            key: "overrideExperiment",
            value: function overrideExperiment(name, value) {
                this._overrides.configs[name] = value;
                this._djb2Map.set($0bd51deafeacf187$var$djb2MapKey((0, $dtn6l._DJB2)(name), 'configs'), value);
                this.saveOverrides();
            }
        },
        {
            key: "removeExperimentOverride",
            value: function removeExperimentOverride(name) {
                delete this._overrides.configs[name];
                this._djb2Map.delete($0bd51deafeacf187$var$djb2MapKey((0, $dtn6l._DJB2)(name), 'configs'));
                this.saveOverrides();
            }
        },
        {
            key: "getExperimentOverride",
            value: function getExperimentOverride(current, _user) {
                return this._getConfigOverride(current, this._overrides.configs);
            }
        },
        {
            key: "overrideLayer",
            value: function overrideLayer(name, value) {
                this._overrides.layers[name] = value;
                this._djb2Map.set($0bd51deafeacf187$var$djb2MapKey((0, $dtn6l._DJB2)(name), 'layers'), value);
                this.saveOverrides();
            }
        },
        {
            key: "removeLayerOverride",
            value: function removeLayerOverride(name) {
                delete this._overrides.layers[name];
                this._djb2Map.delete($0bd51deafeacf187$var$djb2MapKey((0, $dtn6l._DJB2)(name), 'layers'));
                this.saveOverrides();
            }
        },
        {
            key: "removeAllOverrides",
            value: function removeAllOverrides() {
                this._overrides = $0bd51deafeacf187$var$makeEmptyStore();
                try {
                    window.localStorage.removeItem(this._localStorageKey);
                } catch (_unused4) {
                // ignored - window is not defined in non-browser environments, and we don't save things there
                // (things like SSR, etc)
                }
            }
        },
        {
            key: "getLayerOverride",
            value: function getLayerOverride(current, _user) {
                var _this$_overrides$laye;
                var overridden = (_this$_overrides$laye = this._overrides.layers[current.name]) !== null && _this$_overrides$laye !== void 0 ? _this$_overrides$laye : this._djb2Map.get($0bd51deafeacf187$var$djb2MapKey(current.name, 'layers'));
                if (overridden == null) return null;
                return $0bd51deafeacf187$var$_objectSpread($0bd51deafeacf187$var$_objectSpread({}, current), {}, {
                    __value: overridden,
                    get: (0, $dtn6l._makeTypedGet)(current.name, overridden),
                    details: $0bd51deafeacf187$var$_objectSpread($0bd51deafeacf187$var$_objectSpread({}, current.details), {}, {
                        reason: $0bd51deafeacf187$var$LOCAL_OVERRIDE_REASON
                    })
                });
            }
        },
        {
            key: "_getConfigOverride",
            value: function _getConfigOverride(current, lookup) {
                var _lookup$current$name;
                var overridden = (_lookup$current$name = lookup[current.name]) !== null && _lookup$current$name !== void 0 ? _lookup$current$name : this._djb2Map.get($0bd51deafeacf187$var$djb2MapKey(current.name, 'configs'));
                if (overridden == null) return null;
                return $0bd51deafeacf187$var$_objectSpread($0bd51deafeacf187$var$_objectSpread({}, current), {}, {
                    value: overridden,
                    get: (0, $dtn6l._makeTypedGet)(current.name, overridden),
                    details: $0bd51deafeacf187$var$_objectSpread($0bd51deafeacf187$var$_objectSpread({}, current.details), {}, {
                        reason: $0bd51deafeacf187$var$LOCAL_OVERRIDE_REASON
                    })
                });
            }
        }
    ]);
}();





var $033b24876eae39c3$var$_excluded = [
    "sdkKey",
    "environment",
    "updateUserCompletionCallback",
    "perimeter"
];
function $033b24876eae39c3$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $033b24876eae39c3$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $033b24876eae39c3$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $033b24876eae39c3$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $033b24876eae39c3$var$DEFAULT_CLIENT_KEY = 'client-default-key';
// default event logging api is Atlassian proxy rather than Statsig's domain, to avoid ad blockers
var $033b24876eae39c3$var$DEFAULT_EVENT_LOGGING_API = 'https://xp.atlassian.com/v1/rgstr';
var $033b24876eae39c3$export$1f2bb630327ac4b6 = /*#__PURE__*/ function() {
    function Client() {
        var _this = this;
        var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, _ref$localStorageKey = _ref.localStorageKey, localStorageKey = _ref$localStorageKey === void 0 ? (0, $0bd51deafeacf187$export$d8474cff104280f3) : _ref$localStorageKey, overrideAdapter = _ref.overrideAdapter;
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, Client);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "initPromise", null);
        /** True if an initialize method was called and completed successfully. */ (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "initCompleted", false);
        /**
     * True if an initialize method was called and completed, meaning the client is now usable.
     * However if there was an error during initialization it may have initialized with default
     * values. Use {@link initCompleted} to check for this.
     */ (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "initWithDefaults", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "hasCheckGateErrorOccurred", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "hasGetExperimentErrorOccurred", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "hasGetExperimentValueErrorOccurred", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "hasGetLayerErrorOccurred", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "hasGetLayerValueErrorOccurred", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "subscriptions", new (0, $f5baaaf4b2f8257c$export$2e2bcd8739ae039)());
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "dataAdapter", new (0, $a96d5501b6a4242d$export$55fffef3474104af)());
        /**
     * Call this if modifying the values being served by the Statsig library since it has its own
     * memoization cache which will not be updated if the values are changed outside of the library.
     */ (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "statsigValuesUpdated", function() {
            if (_this.user) // Trigger a reset of the memoize cache
            _this.statsigClient.updateUserSync(_this.user, {
                disableBackgroundCacheRefresh: true
            });
            _this.subscriptions.anyUpdated();
        });
        this.overrideAdapter = overrideAdapter || new (0, $0bd51deafeacf187$export$bcb28fbac1def494)(localStorageKey);
    }
    /**
   * @description
   * This method initializes the client using a network call to fetch the bootstrap values.
   * If the client is inialized with an `analyticsWebClient`, it will send an operational event
   * to GASv3 with the following attributes:
   * - targetApp: the target app of the client
   * - clientVersion: the version of the client
   * - success: whether the initialization was successful
   * - startTime: the time when the initialization started
   * - totalTime: the total time it took to initialize the client
   * - apiKey: the api key used to initialize the client
   * @param clientOptions {ClientOptions}
   * @param identifiers {Identifiers}
   * @param customAttributes {CustomAttributes}
   * @returns {Promise<void>}
   */ return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(Client, [
        {
            key: "initialize",
            value: function() {
                var _initialize = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee(clientOptions, identifiers, customAttributes) {
                    var _this2 = this;
                    var clientOptionsWithDefaults, startTime;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee$(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                clientOptionsWithDefaults = (0, $7966583915353999$export$d119b37e5f788b43)(clientOptions);
                                if (!this.initPromise) {
                                    _context.next = 4;
                                    break;
                                }
                                if (!(0, $7966583915353999$export$fa1c2bbf4100b8bc)(clientOptionsWithDefaults, this.initOptions)) // eslint-disable-next-line no-console
                                console.warn('Feature Gates client already initialized with different options. New options were not applied.');
                                return _context.abrupt("return", this.initPromise);
                            case 4:
                                startTime = performance.now();
                                this.initOptions = clientOptionsWithDefaults;
                                this.initPromise = this.init(clientOptionsWithDefaults, identifiers, customAttributes).then(function() {
                                    _this2.initCompleted = true;
                                    _this2.initWithDefaults = true;
                                }).finally(function() {
                                    var endTime = performance.now();
                                    var totalTime = endTime - startTime;
                                    _this2.fireClientEvent(startTime, totalTime, 'initialize', _this2.initCompleted, clientOptionsWithDefaults.apiKey);
                                });
                                return _context.abrupt("return", this.initPromise);
                            case 8:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee, this);
                }));
                function initialize(_x, _x2, _x3) {
                    return _initialize.apply(this, arguments);
                }
                return initialize;
            }()
        },
        {
            key: "initializeWithProvider",
            value: function() {
                var _initializeWithProvider = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee2(clientOptions, provider, identifiers, customAttributes) {
                    var _this3 = this;
                    var clientOptionsWithDefaults, startTime;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee2$(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                clientOptionsWithDefaults = (0, $7966583915353999$export$d119b37e5f788b43)(clientOptions);
                                if (!this.initPromise) {
                                    _context2.next = 4;
                                    break;
                                }
                                if (!(0, $7966583915353999$export$fa1c2bbf4100b8bc)(clientOptionsWithDefaults, this.initOptions)) // eslint-disable-next-line no-console
                                console.warn('Feature Gates client already initialized with different options. New options were not applied.');
                                return _context2.abrupt("return", this.initPromise);
                            case 4:
                                startTime = performance.now();
                                this.initOptions = clientOptionsWithDefaults;
                                this.provider = provider;
                                this.provider.setClientVersion((0, $abe922f7cb7f1134$export$a59f8d67326bd1cb));
                                if (this.provider.setApplyUpdateCallback) this.provider.setApplyUpdateCallback(this.applyUpdateCallback.bind(this));
                                this.initPromise = this.initWithProvider(clientOptionsWithDefaults, provider, identifiers, customAttributes).then(function() {
                                    _this3.initCompleted = true;
                                    _this3.initWithDefaults = true;
                                }).finally(function() {
                                    var endTime = performance.now();
                                    var totalTime = endTime - startTime;
                                    _this3.fireClientEvent(startTime, totalTime, 'initializeWithProvider', _this3.initCompleted, provider.getApiKey ? provider.getApiKey() : undefined);
                                });
                                return _context2.abrupt("return", this.initPromise);
                            case 11:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2, this);
                }));
                function initializeWithProvider(_x4, _x5, _x6, _x7) {
                    return _initializeWithProvider.apply(this, arguments);
                }
                return initializeWithProvider;
            }()
        },
        {
            key: "applyUpdateCallback",
            value: function applyUpdateCallback(experimentsResult) {
                try {
                    if (this.initCompleted || this.initWithDefaults) {
                        this.assertInitialized(this.statsigClient);
                        this.dataAdapter.setBootstrapData(experimentsResult.experimentValues);
                        this.dataAdapter.setData(JSON.stringify(experimentsResult.experimentValues));
                        this.statsigValuesUpdated();
                    }
                } catch (error) {
                    // eslint-disable-next-line no-console
                    console.warn('Error when attempting to apply update', error);
                }
            }
        },
        {
            key: "fireClientEvent",
            value: function fireClientEvent(startTime, totalTime, action, success) {
                var _analyticsWebClient, _this4 = this;
                var apiKey = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
                (_analyticsWebClient = this.initOptions.analyticsWebClient) === null || _analyticsWebClient === void 0 || _analyticsWebClient.then(function(analyticsWebClient) {
                    var attributes = $033b24876eae39c3$var$_objectSpread({
                        targetApp: _this4.initOptions.targetApp,
                        clientVersion: (0, $abe922f7cb7f1134$export$a59f8d67326bd1cb),
                        success: success,
                        startTime: startTime,
                        totalTime: totalTime
                    }, apiKey && {
                        apiKey: apiKey
                    });
                    analyticsWebClient.sendOperationalEvent({
                        action: action,
                        actionSubject: 'featureGatesClient',
                        attributes: attributes,
                        tags: [
                            'measurement'
                        ],
                        source: '@atlaskit/feature-gate-js-client'
                    });
                }).catch(function(err) {
                    if (_this4.initOptions.environment !== (0, $9c86d86ab7ceadb6$export$479e7351a733299).Production) // eslint-disable-next-line no-console
                    console.error('Analytics web client promise did not resolve', err);
                });
            }
        },
        {
            key: "initializeFromValues",
            value: function() {
                var _initializeFromValues = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee3(clientOptions, identifiers, customAttributes) {
                    var _this5 = this;
                    var initializeValues, clientOptionsWithDefaults, startTime, _args3 = arguments;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee3$(_context3) {
                        while(true)switch(_context3.prev = _context3.next){
                            case 0:
                                initializeValues = _args3.length > 3 && _args3[3] !== undefined ? _args3[3] : {};
                                clientOptionsWithDefaults = (0, $7966583915353999$export$d119b37e5f788b43)(clientOptions);
                                if (!this.initPromise) {
                                    _context3.next = 5;
                                    break;
                                }
                                if (!(0, $7966583915353999$export$fa1c2bbf4100b8bc)(clientOptionsWithDefaults, this.initOptions)) // eslint-disable-next-line no-console
                                console.warn('Feature Gates client already initialized with different options. New options were not applied.');
                                return _context3.abrupt("return", this.initPromise);
                            case 5:
                                // This makes sure the new Statsig client behaves like the old when bootstrap data is
                                // passed, and `has_updates` isn't specified (which happens a lot in product integration tests).
                                if (!Object.prototype.hasOwnProperty.call(initializeValues, 'has_updates')) initializeValues['has_updates'] = true;
                                startTime = performance.now();
                                this.initOptions = clientOptionsWithDefaults;
                                this.initPromise = this.initFromValues(clientOptionsWithDefaults, identifiers, customAttributes, initializeValues).then(function() {
                                    _this5.initCompleted = true;
                                    _this5.initWithDefaults = true;
                                }).finally(function() {
                                    var endTime = performance.now();
                                    var totalTime = endTime - startTime;
                                    _this5.fireClientEvent(startTime, totalTime, 'initializeFromValues', _this5.initCompleted);
                                });
                                return _context3.abrupt("return", this.initPromise);
                            case 10:
                            case "end":
                                return _context3.stop();
                        }
                    }, _callee3, this);
                }));
                function initializeFromValues(_x8, _x9, _x0) {
                    return _initializeFromValues.apply(this, arguments);
                }
                return initializeFromValues;
            }()
        },
        {
            key: "assertInitialized",
            value: function assertInitialized(statsigClient) {
                if (!statsigClient) throw new Error('Client must be initialized before using this method');
            }
        },
        {
            key: "updateUser",
            value: function() {
                var _updateUser = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee4(fetchOptions, identifiers, customAttributes) {
                    var fetchOptionsWithDefaults, initializeValuesProducer;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee4$(_context4) {
                        while(true)switch(_context4.prev = _context4.next){
                            case 0:
                                this.assertInitialized(this.statsigClient);
                                fetchOptionsWithDefaults = (0, $7966583915353999$export$d119b37e5f788b43)(fetchOptions);
                                initializeValuesProducer = function initializeValuesProducer() {
                                    return (0, $abab9d5375955b27$export$2e2bcd8739ae039).fetchExperimentValues(fetchOptionsWithDefaults, identifiers, customAttributes).then(function(_ref2) {
                                        var experimentValues = _ref2.experimentValues, customAttributes = _ref2.customAttributes;
                                        return {
                                            experimentValues: experimentValues,
                                            customAttributesFromFetch: customAttributes
                                        };
                                    });
                                };
                                _context4.next = 5;
                                return this.updateUserUsingInitializeValuesProducer(initializeValuesProducer, identifiers, customAttributes);
                            case 5:
                            case "end":
                                return _context4.stop();
                        }
                    }, _callee4, this);
                }));
                function updateUser(_x1, _x10, _x11) {
                    return _updateUser.apply(this, arguments);
                }
                return updateUser;
            }()
        },
        {
            key: "updateUserWithProvider",
            value: function() {
                var _updateUserWithProvider = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee5(identifiers, customAttributes) {
                    var _this6 = this;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee5$(_context5) {
                        while(true)switch(_context5.prev = _context5.next){
                            case 0:
                                this.assertInitialized(this.statsigClient);
                                if (this.provider) {
                                    _context5.next = 3;
                                    break;
                                }
                                throw new Error('Cannot update user using provider as the client was not initialised with a provider');
                            case 3:
                                _context5.next = 5;
                                return this.provider.setProfile(this.initOptions, identifiers, customAttributes);
                            case 5:
                                _context5.next = 7;
                                return this.updateUserUsingInitializeValuesProducer(function() {
                                    return _this6.provider.getExperimentValues();
                                }, identifiers, customAttributes);
                            case 7:
                            case "end":
                                return _context5.stop();
                        }
                    }, _callee5, this);
                }));
                function updateUserWithProvider(_x12, _x13) {
                    return _updateUserWithProvider.apply(this, arguments);
                }
                return updateUserWithProvider;
            }()
        },
        {
            key: "updateUserWithValues",
            value: function() {
                var _updateUserWithValues = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee6(identifiers, customAttributes) {
                    var initializeValues, initializeValuesProducer, _args6 = arguments;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee6$(_context6) {
                        while(true)switch(_context6.prev = _context6.next){
                            case 0:
                                initializeValues = _args6.length > 2 && _args6[2] !== undefined ? _args6[2] : {};
                                this.assertInitialized(this.statsigClient);
                                initializeValuesProducer = function initializeValuesProducer() {
                                    return Promise.resolve({
                                        experimentValues: initializeValues,
                                        customAttributesFromFetch: customAttributes
                                    });
                                };
                                _context6.next = 5;
                                return this.updateUserUsingInitializeValuesProducer(initializeValuesProducer, identifiers, customAttributes);
                            case 5:
                            case "end":
                                return _context6.stop();
                        }
                    }, _callee6, this);
                }));
                function updateUserWithValues(_x14, _x15) {
                    return _updateUserWithValues.apply(this, arguments);
                }
                return updateUserWithValues;
            }()
        },
        {
            key: "initializeCalled",
            value: function initializeCalled() {
                return this.initPromise != null;
            }
        },
        {
            key: "initializeCompleted",
            value: function initializeCompleted() {
                return this.initCompleted;
            }
        },
        {
            key: "waitUntilInitializeCompleted",
            value: function() {
                var _waitUntilInitializeCompleted = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee7() {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee7$(_context7) {
                        while(true)switch(_context7.prev = _context7.next){
                            case 0:
                                if (this.initPromise) {
                                    _context7.next = 2;
                                    break;
                                }
                                throw new Error('The client must be initialized before you can wait until initialized.');
                            case 2:
                                if (!this.initCompleted) {
                                    _context7.next = 4;
                                    break;
                                }
                                return _context7.abrupt("return");
                            case 4:
                                _context7.next = 6;
                                return this.initPromise;
                            case 6:
                            case "end":
                                return _context7.stop();
                        }
                    }, _callee7, this);
                }));
                function waitUntilInitializeCompleted() {
                    return _waitUntilInitializeCompleted.apply(this, arguments);
                }
                return waitUntilInitializeCompleted;
            }()
        },
        {
            key: "checkGate",
            value: function checkGate(gateName) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                try {
                    this.assertInitialized(this.statsigClient);
                    var _options$fireGateExpo = options.fireGateExposure, fireGateExposure = _options$fireGateExpo === void 0 ? true : _options$fireGateExpo;
                    return this.statsigClient.checkGate(gateName, {
                        disableExposureLog: !fireGateExposure
                    });
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!this.hasCheckGateErrorOccurred) {
                        // eslint-disable-next-line no-console
                        console.warn({
                            msg: 'An error has occurred checking the feature gate. Only the first occurrence of this error is logged.',
                            gateName: gateName,
                            error: error
                        });
                        this.hasCheckGateErrorOccurred = true;
                    }
                    return false;
                }
            }
        },
        {
            key: "isGateExist",
            value: function isGateExist(gateName) {
                try {
                    this.assertInitialized(this.statsigClient);
                    var gate = this.statsigClient.getFeatureGate(gateName, {
                        disableExposureLog: true
                    });
                    return !gate.details.reason.includes('Unrecognized');
                } catch (error) {
                    // eslint-disable-next-line no-console
                    console.error("Error occurred when trying to check FeatureGate: ".concat(error));
                    // in case of error report true to avoid false positives.
                    return true;
                }
            }
        },
        {
            key: "isExperimentExist",
            value: function isExperimentExist(experimentName) {
                try {
                    this.assertInitialized(this.statsigClient);
                    var config = this.statsigClient.getExperiment(experimentName, {
                        disableExposureLog: true
                    });
                    return !config.details.reason.includes('Unrecognized');
                } catch (error) {
                    // eslint-disable-next-line no-console
                    console.error("Error occurred when trying to check Experiment: ".concat(error));
                    // in case of error report true to avoid false positives.
                    return true;
                }
            }
        },
        {
            key: "manuallyLogGateExposure",
            value: function manuallyLogGateExposure(gateName) {
                this.assertInitialized(this.statsigClient);
                // This is the approach recommended in the docs
                // https://docs.statsig.com/client/javascript-sdk/#manual-exposures-
                this.statsigClient.checkGate(gateName);
            }
        },
        {
            key: "getExperiment",
            value: function getExperiment(experimentName) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                try {
                    this.assertInitialized(this.statsigClient);
                    var _options$fireExperime = options.fireExperimentExposure, fireExperimentExposure = _options$fireExperime === void 0 ? true : _options$fireExperime;
                    return (0, $4ced36f4dd1a5269$export$6dc24881a3d96325).fromExperiment(this.statsigClient.getExperiment(experimentName, {
                        disableExposureLog: !fireExperimentExposure
                    }));
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!this.hasGetExperimentErrorOccurred) {
                        // eslint-disable-next-line no-console
                        console.warn({
                            msg: 'An error has occurred getting the experiment. Only the first occurrence of this error is logged.',
                            experimentName: experimentName,
                            error: error
                        });
                        this.hasGetExperimentErrorOccurred = true;
                    }
                    // Return a default value
                    return new (0, $4ced36f4dd1a5269$export$6dc24881a3d96325)(experimentName, {}, '', {
                        time: Date.now(),
                        reason: (0, $ba555164627c78dc$export$c62558b199e46828).Error
                    });
                }
            }
        },
        {
            key: "getExperimentValue",
            value: function getExperimentValue(experimentName, parameterName, defaultValue) {
                var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var experiment = this.getExperiment(experimentName, options);
                try {
                    var typeGuard = options.typeGuard;
                    return experiment.get(parameterName, defaultValue, typeGuard);
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!this.hasGetExperimentValueErrorOccurred) {
                        // eslint-disable-next-line no-console
                        console.warn({
                            msg: 'An error has occurred getting the experiment value. Only the first occurrence of this error is logged.',
                            experimentName: experimentName,
                            defaultValue: defaultValue,
                            options: options,
                            error: error
                        });
                        this.hasGetExperimentValueErrorOccurred = true;
                    }
                    return defaultValue;
                }
            }
        },
        {
            key: "manuallyLogExperimentExposure",
            value: function manuallyLogExperimentExposure(experimentName) {
                this.assertInitialized(this.statsigClient);
                // This is the approach recommended in the docs
                // https://docs.statsig.com/client/javascript-sdk/#manual-exposures-
                this.statsigClient.getExperiment(experimentName);
            }
        },
        {
            key: "manuallyLogLayerExposure",
            value: function manuallyLogLayerExposure(layerName, parameterName) {
                var _this$statsigClient$g;
                this.assertInitialized(this.statsigClient);
                // This is the approach recommended in the docs
                // https://docs.statsig.com/client/javascript-sdk/#manual-exposures-
                (_this$statsigClient$g = this.statsigClient.getLayer(layerName)) === null || _this$statsigClient$g === void 0 || _this$statsigClient$g.get(parameterName);
            }
        },
        {
            key: "shutdownStatsig",
            value: function shutdownStatsig() {
                this.assertInitialized(this.statsigClient);
                this.statsigClient.shutdown();
            }
        },
        {
            key: "overrideGate",
            value: function overrideGate(gateName, value) {
                this.overrideAdapter.overrideGate(gateName, value);
                // Trigger a reset of the memoized gate value
                if (this.user) {
                    var _this$statsigClient;
                    (_this$statsigClient = this.statsigClient) === null || _this$statsigClient === void 0 || _this$statsigClient.updateUserSync(this.user, {
                        disableBackgroundCacheRefresh: true
                    });
                }
                this.statsigValuesUpdated();
            }
        },
        {
            key: "clearGateOverride",
            value: function clearGateOverride(gateName) {
                this.overrideAdapter.removeGateOverride(gateName);
                this.statsigValuesUpdated();
            }
        },
        {
            key: "overrideConfig",
            value: function overrideConfig(experimentName, values) {
                this.overrideAdapter.overrideDynamicConfig(experimentName, values);
                this.statsigValuesUpdated();
            }
        },
        {
            key: "clearConfigOverride",
            value: function clearConfigOverride(experimentName) {
                this.overrideAdapter.removeDynamicConfigOverride(experimentName);
                this.statsigValuesUpdated();
            }
        },
        {
            key: "setOverrides",
            value: function setOverrides(overrides) {
                this.overrideAdapter.setOverrides(overrides);
                this.statsigValuesUpdated();
            }
        },
        {
            key: "getOverrides",
            value: function getOverrides() {
                return this.overrideAdapter.getOverrides();
            }
        },
        {
            key: "clearAllOverrides",
            value: function clearAllOverrides() {
                this.overrideAdapter.removeAllOverrides();
                this.statsigValuesUpdated();
            }
        },
        {
            key: "isCurrentUser",
            value: function isCurrentUser(identifiers, customAttributes) {
                return (0, $7966583915353999$export$fa1c2bbf4100b8bc)(this.currentIdentifiers, identifiers) && (0, $7966583915353999$export$fa1c2bbf4100b8bc)(this.currentAttributes, customAttributes);
            }
        },
        {
            key: "onGateUpdated",
            value: function onGateUpdated(gateName, callback) {
                var _this7 = this;
                var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var wrapCallback = function wrapCallback(value) {
                    var _options$fireGateExpo2 = options.fireGateExposure, fireGateExposure = _options$fireGateExpo2 === void 0 ? true : _options$fireGateExpo2;
                    if (fireGateExposure) _this7.manuallyLogGateExposure(gateName);
                    try {
                        callback(value);
                    } catch (error) {
                        // eslint-disable-next-line no-console
                        console.warn("Error calling callback for gate ".concat(gateName, " with value ").concat(value), error);
                    }
                };
                return this.subscriptions.onGateUpdated(gateName, wrapCallback, this.checkGate.bind(this), options);
            }
        },
        {
            key: "onExperimentValueUpdated",
            value: function onExperimentValueUpdated(experimentName, parameterName, defaultValue, callback) {
                var _this8 = this;
                var options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
                var wrapCallback = function wrapCallback(value) {
                    var _options$fireExperime2 = options.fireExperimentExposure, fireExperimentExposure = _options$fireExperime2 === void 0 ? true : _options$fireExperime2;
                    if (fireExperimentExposure) _this8.manuallyLogExperimentExposure(experimentName);
                    try {
                        callback(value);
                    } catch (error) {
                        // eslint-disable-next-line no-console
                        console.warn("Error calling callback for experiment ".concat(experimentName, " with value ").concat(value), error);
                    }
                };
                return this.subscriptions.onExperimentValueUpdated(experimentName, parameterName, defaultValue, wrapCallback, this.getExperimentValue.bind(this), options);
            }
        },
        {
            key: "onAnyUpdated",
            value: function onAnyUpdated(callback) {
                return this.subscriptions.onAnyUpdated(callback);
            }
        },
        {
            key: "init",
            value: function() {
                var _init = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee8(clientOptions, identifiers, customAttributes) {
                    var fromValuesClientOptions, experimentValues, customAttributesFromResult, clientSdkKeyPromise, experimentValuesPromise, _yield$Promise$all, _yield$Promise$all2, experimentValuesResult;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee8$(_context8) {
                        while(true)switch(_context8.prev = _context8.next){
                            case 0:
                                fromValuesClientOptions = $033b24876eae39c3$var$_objectSpread({}, clientOptions);
                                _context8.prev = 1;
                                // If client sdk key fetch fails, an error would be thrown and handled instead of waiting for
                                // the experiment values request to be settled, and it will fall back to use default values.
                                clientSdkKeyPromise = (0, $abab9d5375955b27$export$2e2bcd8739ae039).fetchClientSdk(clientOptions).then(function(value) {
                                    return fromValuesClientOptions.sdkKey = value.clientSdkKey;
                                });
                                experimentValuesPromise = (0, $abab9d5375955b27$export$2e2bcd8739ae039).fetchExperimentValues(clientOptions, identifiers, customAttributes); // Only wait for the experiment values request to finish and try to initialise the client
                                // with experiment values if both requests are successful. Else an error would be thrown and
                                // handled by the catch
                                _context8.next = 6;
                                return Promise.all([
                                    clientSdkKeyPromise,
                                    experimentValuesPromise
                                ]);
                            case 6:
                                _yield$Promise$all = _context8.sent;
                                _yield$Promise$all2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_yield$Promise$all, 2);
                                experimentValuesResult = _yield$Promise$all2[1];
                                experimentValues = experimentValuesResult.experimentValues;
                                customAttributesFromResult = experimentValuesResult.customAttributes;
                                _context8.next = 20;
                                break;
                            case 13:
                                _context8.prev = 13;
                                _context8.t0 = _context8["catch"](1);
                                if (_context8.t0 instanceof Error) // eslint-disable-next-line no-console
                                console.error("Error occurred when trying to fetch the Feature Gates client values, error: ".concat(_context8.t0 === null || _context8.t0 === void 0 ? void 0 : _context8.t0.message));
                                // eslint-disable-next-line no-console
                                console.warn("Initialising Statsig client without values");
                                _context8.next = 19;
                                return this.initFromValues(fromValuesClientOptions, identifiers, customAttributes);
                            case 19:
                                throw _context8.t0;
                            case 20:
                                return _context8.abrupt("return", this.initFromValues(fromValuesClientOptions, identifiers, customAttributesFromResult, experimentValues));
                            case 21:
                            case "end":
                                return _context8.stop();
                        }
                    }, _callee8, this, [
                        [
                            1,
                            13
                        ]
                    ]);
                }));
                function init(_x16, _x17, _x18) {
                    return _init.apply(this, arguments);
                }
                return init;
            }()
        },
        {
            key: "initWithProvider",
            value: function() {
                var _initWithProvider = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee9(baseClientOptions, provider, identifiers, customAttributes) {
                    var fromValuesClientOptions, experimentValues, customAttributesFromResult, clientSdkKeyPromise, experimentValuesPromise, _yield$Promise$all3, _yield$Promise$all4, experimentValuesResult;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee9$(_context9) {
                        while(true)switch(_context9.prev = _context9.next){
                            case 0:
                                fromValuesClientOptions = $033b24876eae39c3$var$_objectSpread($033b24876eae39c3$var$_objectSpread({}, baseClientOptions), {}, {
                                    disableCurrentPageLogging: true
                                });
                                _context9.prev = 1;
                                _context9.next = 4;
                                return provider.setProfile(baseClientOptions, identifiers, customAttributes);
                            case 4:
                                // If client sdk key fetch fails, an error would be thrown and handled instead of waiting for
                                // the experiment values request to be settled, and it will fall back to use default values.
                                clientSdkKeyPromise = provider.getClientSdkKey().then(function(value) {
                                    return fromValuesClientOptions.sdkKey = value;
                                });
                                experimentValuesPromise = provider.getExperimentValues(); // Only wait for the experiment values request to finish and try to initialise the client
                                // with experiment values if both requests are successful. Else an error would be thrown and
                                // handled by the catch
                                _context9.next = 8;
                                return Promise.all([
                                    clientSdkKeyPromise,
                                    experimentValuesPromise
                                ]);
                            case 8:
                                _yield$Promise$all3 = _context9.sent;
                                _yield$Promise$all4 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_yield$Promise$all3, 2);
                                experimentValuesResult = _yield$Promise$all4[1];
                                experimentValues = experimentValuesResult.experimentValues;
                                customAttributesFromResult = experimentValuesResult.customAttributesFromFetch;
                                _context9.next = 22;
                                break;
                            case 15:
                                _context9.prev = 15;
                                _context9.t0 = _context9["catch"](1);
                                if (_context9.t0 instanceof Error) // eslint-disable-next-line no-console
                                console.error("Error occurred when trying to fetch the Feature Gates client values, error: ".concat(_context9.t0 === null || _context9.t0 === void 0 ? void 0 : _context9.t0.message));
                                // eslint-disable-next-line no-console
                                console.warn("Initialising Statsig client without values");
                                _context9.next = 21;
                                return this.initFromValues(fromValuesClientOptions, identifiers, customAttributes);
                            case 21:
                                throw _context9.t0;
                            case 22:
                                return _context9.abrupt("return", this.initFromValues(fromValuesClientOptions, identifiers, customAttributesFromResult, experimentValues));
                            case 23:
                            case "end":
                                return _context9.stop();
                        }
                    }, _callee9, this, [
                        [
                            1,
                            15
                        ]
                    ]);
                }));
                function initWithProvider(_x19, _x20, _x21, _x22) {
                    return _initWithProvider.apply(this, arguments);
                }
                return initWithProvider;
            }()
        },
        {
            key: "initFromValues",
            value: function() {
                var _initFromValues = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee0(clientOptions, identifiers, customAttributes) {
                    var _newClientOptions$net;
                    var initializeValues, newClientOptions, sdkKey, environment, _updateUserCompletionCallback, _perimeter, restClientOptions, statsigOptions, _args0 = arguments;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee0$(_context0) {
                        while(true)switch(_context0.prev = _context0.next){
                            case 0:
                                initializeValues = _args0.length > 3 && _args0[3] !== undefined ? _args0[3] : {};
                                this.overrideAdapter.initFromStoredOverrides();
                                this.currentIdentifiers = identifiers;
                                this.currentAttributes = customAttributes;
                                newClientOptions = (0, $7966583915353999$export$202946b690d26d22)(clientOptions);
                                if (!newClientOptions.sdkKey) newClientOptions.sdkKey = $033b24876eae39c3$var$DEFAULT_CLIENT_KEY;
                                if (!((_newClientOptions$net = newClientOptions.networkConfig) !== null && _newClientOptions$net !== void 0 && _newClientOptions$net.logEventUrl)) newClientOptions.networkConfig = $033b24876eae39c3$var$_objectSpread($033b24876eae39c3$var$_objectSpread({}, newClientOptions.networkConfig), {}, {
                                    logEventUrl: $033b24876eae39c3$var$DEFAULT_EVENT_LOGGING_API
                                });
                                if (newClientOptions.perimeter === (0, $9c86d86ab7ceadb6$export$c42b7bbc5e7ba555).FEDRAMP_MODERATE) // disable all logging in FedRAMP to prevent egress of sensitive data
                                newClientOptions.disableLogging = true;
                                sdkKey = newClientOptions.sdkKey, environment = newClientOptions.environment, _updateUserCompletionCallback = newClientOptions.updateUserCompletionCallback, _perimeter = newClientOptions.perimeter, restClientOptions = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(newClientOptions, $033b24876eae39c3$var$_excluded);
                                this.user = (0, $7966583915353999$export$3dad1db244472f32)(identifiers, customAttributes);
                                statsigOptions = $033b24876eae39c3$var$_objectSpread($033b24876eae39c3$var$_objectSpread({}, restClientOptions), {}, {
                                    environment: {
                                        tier: environment
                                    },
                                    includeCurrentPageUrlWithEvents: false,
                                    dataAdapter: this.dataAdapter,
                                    overrideAdapter: this.overrideAdapter,
                                    logEventCompressionMode: (0, $iFR7a.LogEventCompressionMode).Forced
                                }); // Statsig validates the provided stableId against their own cookie, so we either need
                                // to update the cookie to match, or disable the validation completely.
                                if (identifiers.stableId) (0, $iFR7a.StableID).setOverride(identifiers.stableId, sdkKey);
                                else statsigOptions.disableStableID = true;
                                _context0.prev = 12;
                                this.statsigClient = new (0, $iFR7a.StatsigClient)(sdkKey, this.user, statsigOptions);
                                this.dataAdapter.setBootstrapData(initializeValues);
                                _context0.next = 17;
                                return this.statsigClient.initializeAsync();
                            case 17:
                                _context0.next = 29;
                                break;
                            case 19:
                                _context0.prev = 19;
                                _context0.t0 = _context0["catch"](12);
                                if (_context0.t0 instanceof Error) // eslint-disable-next-line no-console
                                console.error("Error occurred when trying to initialise the Statsig client, error: ".concat(_context0.t0 === null || _context0.t0 === void 0 ? void 0 : _context0.t0.message));
                                // eslint-disable-next-line no-console
                                console.warn("Initialising Statsig client with default sdk key and without values");
                                this.statsigClient = new (0, $iFR7a.StatsigClient)($033b24876eae39c3$var$DEFAULT_CLIENT_KEY, this.user, statsigOptions);
                                this.dataAdapter.setBootstrapData();
                                _context0.next = 27;
                                return this.statsigClient.initializeAsync();
                            case 27:
                                this.initWithDefaults = true;
                                throw _context0.t0;
                            case 29:
                            case "end":
                                return _context0.stop();
                        }
                    }, _callee0, this, [
                        [
                            12,
                            19
                        ]
                    ]);
                }));
                function initFromValues(_x23, _x24, _x25) {
                    return _initFromValues.apply(this, arguments);
                }
                return initFromValues;
            }()
        },
        {
            key: "updateUserUsingInitializeValuesProducer",
            value: function() {
                var _updateUserUsingInitializeValuesProducer = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee10(getInitializeValues, identifiers, customAttributes) {
                    var _this9 = this;
                    var originalInitPromise, initializeValuesPromise, updateUserPromise;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee10$(_context10) {
                        while(true)switch(_context10.prev = _context10.next){
                            case 0:
                                this.assertInitialized(this.statsigClient);
                                if (this.initPromise) {
                                    _context10.next = 3;
                                    break;
                                }
                                throw new Error('The client must be initialized before you can update the user.');
                            case 3:
                                if (!this.isCurrentUser(identifiers, customAttributes)) {
                                    _context10.next = 5;
                                    break;
                                }
                                return _context10.abrupt("return", this.initPromise);
                            case 5:
                                // Wait for the current initialize/update to finish
                                originalInitPromise = this.initPromise;
                                _context10.prev = 6;
                                _context10.next = 9;
                                return this.initPromise;
                            case 9:
                                _context10.next = 13;
                                break;
                            case 11:
                                _context10.prev = 11;
                                _context10.t0 = _context10["catch"](6);
                            case 13:
                                initializeValuesPromise = getInitializeValues();
                                updateUserPromise = this.updateStatsigClientUser(initializeValuesPromise, identifiers, customAttributes); // We replace the init promise here since we are essentially re-initializing the client at this
                                // point. Any subsequent calls to await client.initialize() or client.updateUser()
                                // will now also await this user update.
                                this.initPromise = updateUserPromise.catch(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee1() {
                                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee1$(_context1) {
                                        while(true)switch(_context1.prev = _context1.next){
                                            case 0:
                                                // If the update failed then it changed nothing, so revert back to the original promise.
                                                _this9.initPromise = originalInitPromise;
                                                // Set the user profile again to revert back to the current user
                                                if (!_this9.provider) {
                                                    _context1.next = 4;
                                                    break;
                                                }
                                                _context1.next = 4;
                                                return _this9.provider.setProfile(_this9.initOptions, _this9.currentIdentifiers, _this9.currentAttributes);
                                            case 4:
                                            case "end":
                                                return _context1.stop();
                                        }
                                    }, _callee1);
                                })));
                                return _context10.abrupt("return", updateUserPromise);
                            case 17:
                            case "end":
                                return _context10.stop();
                        }
                    }, _callee10, this, [
                        [
                            6,
                            11
                        ]
                    ]);
                }));
                function updateUserUsingInitializeValuesProducer(_x26, _x27, _x28) {
                    return _updateUserUsingInitializeValuesProducer.apply(this, arguments);
                }
                return updateUserUsingInitializeValuesProducer;
            }()
        },
        {
            key: "updateStatsigClientUser",
            value: function() {
                var _updateStatsigClientUser = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee11(initializeValuesPromise, identifiers, customAttributes) {
                    var _this$initOptions, _this$initOptions$upd;
                    var initializeValues, user, _updateUserCompletion, _ref4, errMsg, success, errorMessage;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee11$(_context11) {
                        while(true)switch(_context11.prev = _context11.next){
                            case 0:
                                this.assertInitialized(this.statsigClient);
                                _context11.prev = 1;
                                _context11.next = 4;
                                return initializeValuesPromise;
                            case 4:
                                initializeValues = _context11.sent;
                                user = (0, $7966583915353999$export$3dad1db244472f32)(identifiers, initializeValues.customAttributesFromFetch);
                                _context11.next = 13;
                                break;
                            case 8:
                                _context11.prev = 8;
                                _context11.t0 = _context11["catch"](1);
                                // Make sure the updateUserCompletionCallback is called for any errors in our custom code.
                                // This is not necessary for the updateUserWithValues call, because the Statsig client will
                                // already invoke the callback itself.
                                errMsg = _context11.t0 instanceof Error ? _context11.t0.message : JSON.stringify(_context11.t0);
                                (_updateUserCompletion = (_ref4 = this.initOptions).updateUserCompletionCallback) === null || _updateUserCompletion === void 0 || _updateUserCompletion.call(_ref4, false, errMsg);
                                throw _context11.t0;
                            case 13:
                                success = true;
                                errorMessage = null;
                                _context11.prev = 15;
                                this.dataAdapter.setBootstrapData(initializeValues.experimentValues);
                                this.user = user;
                                if (!this.user) {
                                    _context11.next = 21;
                                    break;
                                }
                                _context11.next = 21;
                                return this.statsigClient.updateUserAsync(this.user);
                            case 21:
                                _context11.next = 27;
                                break;
                            case 23:
                                _context11.prev = 23;
                                _context11.t1 = _context11["catch"](15);
                                success = false;
                                errorMessage = String(_context11.t1);
                            case 27:
                                (_this$initOptions = this.initOptions) === null || _this$initOptions === void 0 || (_this$initOptions$upd = _this$initOptions.updateUserCompletionCallback) === null || _this$initOptions$upd === void 0 || _this$initOptions$upd.call(_this$initOptions, success, errorMessage);
                                if (!success) {
                                    _context11.next = 34;
                                    break;
                                }
                                this.currentIdentifiers = identifiers;
                                this.currentAttributes = customAttributes;
                                this.subscriptions.anyUpdated();
                                _context11.next = 35;
                                break;
                            case 34:
                                throw new Error('Failed to update user. An unexpected error occured.');
                            case 35:
                            case "end":
                                return _context11.stop();
                        }
                    }, _callee11, this, [
                        [
                            1,
                            8
                        ],
                        [
                            15,
                            23
                        ]
                    ]);
                }));
                function updateStatsigClientUser(_x29, _x30, _x31) {
                    return _updateStatsigClientUser.apply(this, arguments);
                }
                return updateStatsigClientUser;
            }()
        },
        {
            key: "getPackageVersion",
            value: /**
     * @returns string version of the current package in semver style.
     */ function getPackageVersion() {
                return 0, $abe922f7cb7f1134$export$a59f8d67326bd1cb;
            }
        },
        {
            key: "getLayer",
            value: function getLayer(/** The name of the layer */ layerName) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                try {
                    this.assertInitialized(this.statsigClient);
                    var _options$fireLayerExp = options.fireLayerExposure, fireLayerExposure = _options$fireLayerExp === void 0 ? true : _options$fireLayerExp;
                    return (0, $1e45ecff8cda5921$export$936d0764594b6eb3).fromLayer(this.statsigClient.getLayer(layerName, {
                        disableExposureLog: !fireLayerExposure
                    }));
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!this.hasGetLayerErrorOccurred) {
                        // eslint-disable-next-line no-console
                        console.warn({
                            msg: 'An error has occurred getting the layer. Only the first occurrence of this error is logged.',
                            layerName: layerName,
                            error: error
                        });
                        this.hasGetLayerErrorOccurred = true;
                    }
                    // Return a default value
                    return (0, $1e45ecff8cda5921$export$936d0764594b6eb3).fromLayer((0, $iFR7a._makeLayer)(layerName, {
                        reason: 'Error'
                    }, null));
                }
            }
        },
        {
            key: "getLayerValue",
            value: function getLayerValue(layerName, parameterName, defaultValue) {
                var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var layer = this.getLayer(layerName, options);
                try {
                    var typeGuard = options.typeGuard;
                    return layer.get(parameterName, defaultValue, typeGuard);
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!this.hasGetLayerValueErrorOccurred) {
                        // eslint-disable-next-line no-console
                        console.warn({
                            msg: 'An error has occurred getting the layer value. Only the first occurrence of this error is logged.',
                            layerName: layerName,
                            defaultValue: defaultValue,
                            options: options,
                            error: error
                        });
                        this.hasGetLayerValueErrorOccurred = true;
                    }
                    return defaultValue;
                }
            }
        }
    ]);
}();






var $40cfbbae529c6223$var$_FeatureGates;
/**
 * Access the FeatureGates object via the default export.
 * ```ts
 * import FeatureGates from '@atlaskit/feature-gate-js-client';
 * ```
 */ var $40cfbbae529c6223$var$FeatureGates = /*#__PURE__*/ function() {
    function FeatureGates() {
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, FeatureGates);
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(FeatureGates, null, [
        {
            key: "isGateExists",
            value: function isGateExists(gateName) {
                return this.client.isGateExist(gateName);
            }
        },
        {
            key: "isExperimentExists",
            value: function isExperimentExists(experimentName) {
                return this.client.isExperimentExist(experimentName);
            }
        }
    ]);
}();
$40cfbbae529c6223$var$_FeatureGates = $40cfbbae529c6223$var$FeatureGates;
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($40cfbbae529c6223$var$FeatureGates, "client", new (0, $033b24876eae39c3$export$1f2bb630327ac4b6)());
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($40cfbbae529c6223$var$FeatureGates, "hasCheckGateErrorOccurred", false);
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($40cfbbae529c6223$var$FeatureGates, "hasGetExperimentValueErrorOccurred", false);
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($40cfbbae529c6223$var$FeatureGates, "checkGate", function(gateName, options) {
    try {
        // Check if the CRITERION override mechanism is available
        if (typeof window !== 'undefined' && window.__CRITERION__ && typeof window.__CRITERION__.getFeatureFlagOverride === 'function') {
            // Attempt to retrieve an override value for the feature gate
            var overrideValue = window.__CRITERION__.getFeatureFlagOverride(gateName);
            // If an override value is found, return it immediately
            if (overrideValue !== undefined) return overrideValue;
        }
    } catch (error) {
        // Log the first occurrence of the error
        if (!$40cfbbae529c6223$var$_FeatureGates.hasCheckGateErrorOccurred) {
            // eslint-disable-next-line no-console
            console.warn({
                msg: 'An error has occurred checking the feature gate from criterion override. Only the first occurrence of this error is logged.',
                gateName: gateName,
                error: error
            });
            $40cfbbae529c6223$var$_FeatureGates.hasCheckGateErrorOccurred = true;
        }
    }
    // Proceed with the main logic if no override is found
    return $40cfbbae529c6223$var$_FeatureGates.client.checkGate(gateName, options);
});
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($40cfbbae529c6223$var$FeatureGates, "getExperimentValue", function(experimentName, parameterName, defaultValue, options) {
    try {
        // Check if the CRITERION override mechanism is available
        if (typeof window !== 'undefined' && window.__CRITERION__ && typeof window.__CRITERION__.getExperimentValueOverride === 'function') {
            var overrideValue = window.__CRITERION__.getExperimentValueOverride(experimentName, parameterName);
            if (overrideValue !== undefined && overrideValue !== null) return overrideValue;
        }
    } catch (error) {
        // Log the first occurrence of the error
        if (!$40cfbbae529c6223$var$_FeatureGates.hasGetExperimentValueErrorOccurred) {
            // eslint-disable-next-line no-console
            console.warn({
                msg: 'An error has occurred getting the experiment value from criterion override. Only the first occurrence of this error is logged.',
                experimentName: experimentName,
                defaultValue: defaultValue,
                options: options,
                error: error
            });
            $40cfbbae529c6223$var$_FeatureGates.hasGetExperimentValueErrorOccurred = true;
        }
        return defaultValue;
    }
    // Proceed with the main logic if no override is found
    return $40cfbbae529c6223$var$_FeatureGates.client.getExperimentValue(experimentName, parameterName, defaultValue, options);
});
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($40cfbbae529c6223$var$FeatureGates, "initializeCalled", $40cfbbae529c6223$var$_FeatureGates.client.initializeCalled.bind($40cfbbae529c6223$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($40cfbbae529c6223$var$FeatureGates, "initializeCompleted", $40cfbbae529c6223$var$_FeatureGates.client.initializeCompleted.bind($40cfbbae529c6223$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($40cfbbae529c6223$var$FeatureGates, "waitUntilInitializeCompleted", $40cfbbae529c6223$var$_FeatureGates.client.waitUntilInitializeCompleted.bind($40cfbbae529c6223$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($40cfbbae529c6223$var$FeatureGates, "initialize", $40cfbbae529c6223$var$_FeatureGates.client.initialize.bind($40cfbbae529c6223$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($40cfbbae529c6223$var$FeatureGates, "initializeWithProvider", $40cfbbae529c6223$var$_FeatureGates.client.initializeWithProvider.bind($40cfbbae529c6223$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($40cfbbae529c6223$var$FeatureGates, "initializeFromValues", $40cfbbae529c6223$var$_FeatureGates.client.initializeFromValues.bind($40cfbbae529c6223$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($40cfbbae529c6223$var$FeatureGates, "manuallyLogGateExposure", $40cfbbae529c6223$var$_FeatureGates.client.manuallyLogGateExposure.bind($40cfbbae529c6223$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($40cfbbae529c6223$var$FeatureGates, "getExperiment", $40cfbbae529c6223$var$_FeatureGates.client.getExperiment.bind($40cfbbae529c6223$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($40cfbbae529c6223$var$FeatureGates, "manuallyLogExperimentExposure", $40cfbbae529c6223$var$_FeatureGates.client.manuallyLogExperimentExposure.bind($40cfbbae529c6223$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($40cfbbae529c6223$var$FeatureGates, "manuallyLogLayerExposure", $40cfbbae529c6223$var$_FeatureGates.client.manuallyLogLayerExposure.bind($40cfbbae529c6223$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($40cfbbae529c6223$var$FeatureGates, "shutdownStatsig", $40cfbbae529c6223$var$_FeatureGates.client.shutdownStatsig.bind($40cfbbae529c6223$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($40cfbbae529c6223$var$FeatureGates, "overrideGate", $40cfbbae529c6223$var$_FeatureGates.client.overrideGate.bind($40cfbbae529c6223$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($40cfbbae529c6223$var$FeatureGates, "clearGateOverride", $40cfbbae529c6223$var$_FeatureGates.client.clearGateOverride.bind($40cfbbae529c6223$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($40cfbbae529c6223$var$FeatureGates, "overrideConfig", $40cfbbae529c6223$var$_FeatureGates.client.overrideConfig.bind($40cfbbae529c6223$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($40cfbbae529c6223$var$FeatureGates, "clearConfigOverride", $40cfbbae529c6223$var$_FeatureGates.client.clearConfigOverride.bind($40cfbbae529c6223$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($40cfbbae529c6223$var$FeatureGates, "setOverrides", $40cfbbae529c6223$var$_FeatureGates.client.setOverrides.bind($40cfbbae529c6223$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($40cfbbae529c6223$var$FeatureGates, "getOverrides", $40cfbbae529c6223$var$_FeatureGates.client.getOverrides.bind($40cfbbae529c6223$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($40cfbbae529c6223$var$FeatureGates, "clearAllOverrides", $40cfbbae529c6223$var$_FeatureGates.client.clearAllOverrides.bind($40cfbbae529c6223$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($40cfbbae529c6223$var$FeatureGates, "isCurrentUser", $40cfbbae529c6223$var$_FeatureGates.client.isCurrentUser.bind($40cfbbae529c6223$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($40cfbbae529c6223$var$FeatureGates, "onGateUpdated", $40cfbbae529c6223$var$_FeatureGates.client.onGateUpdated.bind($40cfbbae529c6223$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($40cfbbae529c6223$var$FeatureGates, "onExperimentValueUpdated", $40cfbbae529c6223$var$_FeatureGates.client.onExperimentValueUpdated.bind($40cfbbae529c6223$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($40cfbbae529c6223$var$FeatureGates, "onAnyUpdated", $40cfbbae529c6223$var$_FeatureGates.client.onAnyUpdated.bind($40cfbbae529c6223$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($40cfbbae529c6223$var$FeatureGates, "updateUser", $40cfbbae529c6223$var$_FeatureGates.client.updateUser.bind($40cfbbae529c6223$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($40cfbbae529c6223$var$FeatureGates, "updateUserWithProvider", $40cfbbae529c6223$var$_FeatureGates.client.updateUserWithProvider.bind($40cfbbae529c6223$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($40cfbbae529c6223$var$FeatureGates, "updateUserWithValues", $40cfbbae529c6223$var$_FeatureGates.client.updateUserWithValues.bind($40cfbbae529c6223$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($40cfbbae529c6223$var$FeatureGates, "getPackageVersion", $40cfbbae529c6223$var$_FeatureGates.client.getPackageVersion.bind($40cfbbae529c6223$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($40cfbbae529c6223$var$FeatureGates, "getLayer", $40cfbbae529c6223$var$_FeatureGates.client.getLayer.bind($40cfbbae529c6223$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($40cfbbae529c6223$var$FeatureGates, "getLayerValue", $40cfbbae529c6223$var$_FeatureGates.client.getLayerValue.bind($40cfbbae529c6223$var$_FeatureGates.client));
var $40cfbbae529c6223$var$boundFGJS = $40cfbbae529c6223$var$FeatureGates;
// This makes it possible to get a reference to the FeatureGates client at runtime.
// This is important for overriding values in Cypress tests, as there needs to be a
// way to get the exact instance for a window in order to mock some of its methods.
if (typeof window !== 'undefined') {
    if (window.__FEATUREGATES_JS__ === undefined) window.__FEATUREGATES_JS__ = $40cfbbae529c6223$var$FeatureGates;
    else {
        var $40cfbbae529c6223$var$_boundFGJS, $40cfbbae529c6223$var$_boundFGJS$getPackage;
        $40cfbbae529c6223$var$boundFGJS = window.__FEATUREGATES_JS__;
        var $40cfbbae529c6223$var$boundVersion = (($40cfbbae529c6223$var$_boundFGJS = $40cfbbae529c6223$var$boundFGJS) === null || $40cfbbae529c6223$var$_boundFGJS === void 0 || ($40cfbbae529c6223$var$_boundFGJS$getPackage = $40cfbbae529c6223$var$_boundFGJS.getPackageVersion) === null || $40cfbbae529c6223$var$_boundFGJS$getPackage === void 0 ? void 0 : $40cfbbae529c6223$var$_boundFGJS$getPackage.call($40cfbbae529c6223$var$_boundFGJS)) || '4.10.0 or earlier';
        if ($40cfbbae529c6223$var$boundVersion !== (0, $abe922f7cb7f1134$export$a59f8d67326bd1cb)) {
            var $40cfbbae529c6223$var$message = "Multiple versions of FeatureGateClients found on the current page.\n      The currently bound version is ".concat($40cfbbae529c6223$var$boundVersion, " when module version ").concat((0, $abe922f7cb7f1134$export$a59f8d67326bd1cb), " was loading.");
            // eslint-disable-next-line no-console
            console.warn($40cfbbae529c6223$var$message);
        }
    }
}
var /**
 * @property {FeatureGates} FeatureGate default export
 */ $40cfbbae529c6223$export$2e2bcd8739ae039 = $40cfbbae529c6223$var$boundFGJS;


var $f304cdd3ab592a65$var$_process, $f304cdd3ab592a65$var$_process2;
// We can't rely on NODE_ENV === 'test' if its value is already configured by the consumer to some other value, so better to use JEST_WORKER_ID
// https://jestjs.io/docs/environment-variables#jest_worker_id
var $f304cdd3ab592a65$var$TESTS_MODE = (globalThis === null || globalThis === void 0 || ($f304cdd3ab592a65$var$_process = globalThis.process) === null || $f304cdd3ab592a65$var$_process === void 0 || ($f304cdd3ab592a65$var$_process = $f304cdd3ab592a65$var$_process.env) === null || $f304cdd3ab592a65$var$_process === void 0 ? void 0 : $f304cdd3ab592a65$var$_process.JEST_WORKER_ID) !== undefined;
var $f304cdd3ab592a65$var$DEBUG_MODE = !$f304cdd3ab592a65$var$TESTS_MODE && (globalThis === null || globalThis === void 0 || ($f304cdd3ab592a65$var$_process2 = globalThis.process) === null || $f304cdd3ab592a65$var$_process2 === void 0 || ($f304cdd3ab592a65$var$_process2 = $f304cdd3ab592a65$var$_process2.env) === null || $f304cdd3ab592a65$var$_process2 === void 0 ? void 0 : $f304cdd3ab592a65$var$_process2.NODE_ENV) !== 'production';
var $f304cdd3ab592a65$export$1c9f709888824e05 = function debug() {
    var _console;
    if (!$f304cdd3ab592a65$var$DEBUG_MODE) return;
    // eslint-disable-next-line no-console
    (_console = console).debug.apply(_console, arguments);
};



var $3ZMUU = parcelRequire("3ZMUU");
var $e1b407b925443d5a$var$pkgName = '@atlaskit/platform-feature-flags';
var $e1b407b925443d5a$export$7e41b1b2bdee3f98 = '__PLATFORM_FEATURE_FLAGS__';
var $e1b407b925443d5a$var$hasProcessEnv = typeof $3ZMUU !== 'undefined' && typeof $3ZMUU.env !== 'undefined';
// FF global overrides can be configured by test runners or Storybook
var $e1b407b925443d5a$var$ENV_ENABLE_PLATFORM_FF = $e1b407b925443d5a$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
// STORYBOOK_ENABLE_PLATFORM_FF is included as storybook only allows env vars prefixed with STORYBOOK
// https://github.com/storybookjs/storybook/issues/12270
var $e1b407b925443d5a$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF = $e1b407b925443d5a$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
var $e1b407b925443d5a$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE = $e1b407b925443d5a$var$ENV_ENABLE_PLATFORM_FF || $e1b407b925443d5a$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF;
var $e1b407b925443d5a$var$DEFAULT_PFF_GLOBAL = {
    booleanResolver: undefined
};
var $e1b407b925443d5a$var$globalVar = typeof window !== 'undefined' ? window : globalThis;
$e1b407b925443d5a$var$globalVar[$e1b407b925443d5a$export$7e41b1b2bdee3f98] = $e1b407b925443d5a$var$globalVar[$e1b407b925443d5a$export$7e41b1b2bdee3f98] || $e1b407b925443d5a$var$DEFAULT_PFF_GLOBAL;
function $e1b407b925443d5a$export$f2b591175b3e424c(resolver) {
    $e1b407b925443d5a$var$globalVar[$e1b407b925443d5a$export$7e41b1b2bdee3f98].booleanResolver = resolver;
}
function $e1b407b925443d5a$export$6333b6aff9fc6275(flagKey) {
    if ($e1b407b925443d5a$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE) {
        (0, $f304cdd3ab592a65$export$1c9f709888824e05)('[%s]: The feature flags were enabled while running tests. The flag "%s" will be always enabled.', $e1b407b925443d5a$var$pkgName, flagKey);
        return true;
    }
    try {
        var _globalVar$PFF_GLOBAL, _globalVar$PFF_GLOBAL2, _globalVar$PFF_GLOBAL3;
        // booleanResolver will be empty for products like Trello, Elevate, Recruit etc.
        // Currently only Confluence, Jira and Bitbucket has set it.
        if (((_globalVar$PFF_GLOBAL = $e1b407b925443d5a$var$globalVar[$e1b407b925443d5a$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL === void 0 ? void 0 : _globalVar$PFF_GLOBAL.booleanResolver) === undefined || ((_globalVar$PFF_GLOBAL2 = $e1b407b925443d5a$var$globalVar[$e1b407b925443d5a$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL2 === void 0 ? void 0 : _globalVar$PFF_GLOBAL2.booleanResolver) === null) // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
        return (0, $40cfbbae529c6223$export$2e2bcd8739ae039).checkGate(flagKey);
        var result = (_globalVar$PFF_GLOBAL3 = $e1b407b925443d5a$var$globalVar[$e1b407b925443d5a$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL3 === void 0 ? void 0 : _globalVar$PFF_GLOBAL3.booleanResolver(flagKey);
        if (typeof result !== 'boolean') {
            // eslint-disable-next-line no-console
            console.warn("".concat(flagKey, " resolved to a non-boolean value, returning false for safety"));
            return false;
        }
        return result;
    } catch (e) {
        return false;
    }
}


function $473292da1a47ed2b$export$ba05d765b8392e5e(flagResolver) {
    (0, $e1b407b925443d5a$export$f2b591175b3e424c)(flagResolver);
}
function $473292da1a47ed2b$export$470e5c2be1411c89(name) {
    return (0, $e1b407b925443d5a$export$6333b6aff9fc6275)(name);
}
function $473292da1a47ed2b$export$b40ec24ac8275656(name) {
    return (0, $e1b407b925443d5a$export$6333b6aff9fc6275)(name);
}


/**
 * This is an object of usable media query helpers using our internal breakpoints configuration.
 *
 * When using Compiled CSS-in-JS, please ensure that only a single declaration can take effect at a time.
 * This means that you should avoid multiple breakpoints taking effect at the same time,
 * eg. ```{ [media.above.xs]: { color: 'red' }, [media.above.sm]: { color: 'green' }}```.
 * Instead, make sure that only one breakpoint can take effect at a time,
 * e.g, ```{ [media.only.xs]: { color: 'red' }, [media.above.sm]: { color: 'green' }}```.
 * For more details, please see <https://compiledcssinjs.com/docs/atomic-css#selector-specificity>.
 */ var $5d46c179935a1c9c$export$987d49ffe1b0900f = {
    above: {
        xxs: '@media all',
        xs: '@media (min-width: 30rem)',
        sm: '@media (min-width: 48rem)',
        md: '@media (min-width: 64rem)',
        lg: '@media (min-width: 90rem)',
        xl: '@media (min-width: 110.5rem)'
    },
    only: {
        xxs: '@media (min-width: 0rem) and (max-width: 29.99rem)',
        xs: '@media (min-width: 30rem) and (max-width: 47.99rem)',
        sm: '@media (min-width: 48rem) and (max-width: 63.99rem)',
        md: '@media (min-width: 64rem) and (max-width: 89.99rem)',
        lg: '@media (min-width: 90rem) and (max-width: 110.49rem)',
        xl: '@media (min-width: 110.5rem)'
    },
    below: {
        xs: '@media not all and (min-width: 30rem)',
        sm: '@media not all and (min-width: 48rem)',
        md: '@media not all and (min-width: 64rem)',
        lg: '@media not all and (min-width: 90rem)',
        xl: '@media not all and (min-width: 110.5rem)'
    }
};
var $5d46c179935a1c9c$export$c881183ca713c214 = $5d46c179935a1c9c$export$987d49ffe1b0900f;


/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ // Reds
var $89c2f4de61c9eb17$export$4b84fd0e2c617bd = '#FFEBE6';
var $89c2f4de61c9eb17$export$b34b069eff244586 = '#FFBDAD';
var $89c2f4de61c9eb17$export$be802dd0d8b57f35 = '#FF8F73';
var $89c2f4de61c9eb17$export$60847d42f9da92a6 = '#FF7452';
var $89c2f4de61c9eb17$export$4a7404f376229999 = '#FF5630';
var $89c2f4de61c9eb17$export$2010d0fb4295b346 = '#DE350B';
var $89c2f4de61c9eb17$export$2837b5a1a71d5c02 = '#BF2600';
var $89c2f4de61c9eb17$export$8d9596b529bbb9cf = '#FFFAE6';
var $89c2f4de61c9eb17$export$41060a744ab0b7ae = '#FFF0B3';
var $89c2f4de61c9eb17$export$1cc05bbbf340e559 = '#FFE380';
var $89c2f4de61c9eb17$export$5aae31392d72caaa = '#FFC400';
var $89c2f4de61c9eb17$export$c6930421db9fa514 = '#FFAB00';
var $89c2f4de61c9eb17$export$59619663aa6500fb = '#FF991F';
var $89c2f4de61c9eb17$export$874739ea9e379ab6 = '#FF8B00';
var $89c2f4de61c9eb17$export$8a6341c32b6a3ee6 = '#E3FCEF';
var $89c2f4de61c9eb17$export$69a3bf21b9686c2b = '#ABF5D1';
var $89c2f4de61c9eb17$export$afbce1382ec95f73 = '#79F2C0';
var $89c2f4de61c9eb17$export$747d86715d4175de = '#57D9A3';
var $89c2f4de61c9eb17$export$940e1f69e873f202 = '#36B37E';
var $89c2f4de61c9eb17$export$a49394138f7b8e85 = '#00875A';
var $89c2f4de61c9eb17$export$6fa04827ac68a4fb = '#006644';
var $89c2f4de61c9eb17$export$226de0355ed012f8 = '#DEEBFF';
var $89c2f4de61c9eb17$export$8c13c2ee36917869 = '#B3D4FF';
var $89c2f4de61c9eb17$export$ecfc1dff386a3e7a = '#4C9AFF';
var $89c2f4de61c9eb17$export$215b7063051591f1 = '#2684FF';
var $89c2f4de61c9eb17$export$e62e8919cca44969 = '#0065FF';
var $89c2f4de61c9eb17$export$b3de0ae08da2ce64 = '#0052CC';
var $89c2f4de61c9eb17$export$a6ee3d71bc067634 = '#0747A6';
var $89c2f4de61c9eb17$export$67f15409e87642a1 = '#669DF1';
var $89c2f4de61c9eb17$export$f0539dbc42dbb067 = '#8FB8F6';
var $89c2f4de61c9eb17$export$363e4475840015bb = '#EAE6FF';
var $89c2f4de61c9eb17$export$4b0a4417ed59760f = '#C0B6F2';
var $89c2f4de61c9eb17$export$6011520a64d9a187 = '#998DD9';
var $89c2f4de61c9eb17$export$a7175d4e9206bc80 = '#8777D9';
var $89c2f4de61c9eb17$export$b48405b95304b5a1 = '#6554C0';
var $89c2f4de61c9eb17$export$c71e4279dd54a18d = '#5243AA';
var $89c2f4de61c9eb17$export$147899de772240ec = '#403294';
var $89c2f4de61c9eb17$export$2cf711fe14c66f06 = '#E6FCFF';
var $89c2f4de61c9eb17$export$7a8f4d33f6f9772c = '#B3F5FF';
var $89c2f4de61c9eb17$export$776c9c497ef08533 = '#79E2F2';
var $89c2f4de61c9eb17$export$69cb3ca10c1e330e = '#00C7E6';
var $89c2f4de61c9eb17$export$9dc1ef0f3f48059b = '#00B8D9';
var $89c2f4de61c9eb17$export$7c835c78b6fcdef8 = '#00A3BF';
var $89c2f4de61c9eb17$export$6036577f95c3877e = '#008DA6';
var $89c2f4de61c9eb17$export$29a4f05edc054374 = '#FFFFFF';
var $89c2f4de61c9eb17$export$e655ef011c4aa1a2 = '#FAFBFC';
var $89c2f4de61c9eb17$export$9fdfb749e33cdf97 = '#F4F5F7';
var $89c2f4de61c9eb17$export$3e51e8f1440314ba = '#EBECF0';
var $89c2f4de61c9eb17$export$1ce2d1575d444ceb = '#DFE1E6';
var $89c2f4de61c9eb17$export$8754fc7e6d8b3000 = '#C1C7D0';
var $89c2f4de61c9eb17$export$c2e91cbeada39b8b = '#B3BAC5';
var $89c2f4de61c9eb17$export$5f71e19f3a7ad9de = '#A5ADBA';
var $89c2f4de61c9eb17$export$eaa8c8a70ac22806 = '#97A0AF';
var $89c2f4de61c9eb17$export$7c87d337fb91a97d = '#8993A4';
var $89c2f4de61c9eb17$export$d6447c357493214f = '#7A869A';
var $89c2f4de61c9eb17$export$f563ee71e9ee74cd = '#6B778C';
var $89c2f4de61c9eb17$export$e2ef2124cf4024b1 = '#5E6C84';
var $89c2f4de61c9eb17$export$eece5f492e429f08 = '#505F79';
var $89c2f4de61c9eb17$export$c39c0fe0f26207ae = '#42526E';
var $89c2f4de61c9eb17$export$7090862dc3038a9f = '#344563';
var $89c2f4de61c9eb17$export$ad0bacf983b7ddaa = '#253858';
var $89c2f4de61c9eb17$export$7d61b15e0da132af = '#172B4D';
var $89c2f4de61c9eb17$export$fbda843f0a27fe96 = '#091E42';
var $89c2f4de61c9eb17$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
var $89c2f4de61c9eb17$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
var $89c2f4de61c9eb17$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
var $89c2f4de61c9eb17$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
var $89c2f4de61c9eb17$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
var $89c2f4de61c9eb17$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
var $89c2f4de61c9eb17$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
var $89c2f4de61c9eb17$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
var $89c2f4de61c9eb17$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
var $89c2f4de61c9eb17$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
var $89c2f4de61c9eb17$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
var $89c2f4de61c9eb17$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
var $89c2f4de61c9eb17$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
var $89c2f4de61c9eb17$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
var $89c2f4de61c9eb17$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
var $89c2f4de61c9eb17$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
var $89c2f4de61c9eb17$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
var $89c2f4de61c9eb17$export$2f6319cf7d736c2a = '#E6EDFA';
var $89c2f4de61c9eb17$export$95126bc8884d6634 = '#DCE5F5';
var $89c2f4de61c9eb17$export$8338d8c35d44ff1 = '#CED9EB';
var $89c2f4de61c9eb17$export$5368d76ae4fbbda7 = '#B8C7E0';
var $89c2f4de61c9eb17$export$9f0a771d16ec8d36 = '#ABBBD6';
var $89c2f4de61c9eb17$export$abcf8c38338b4aa5 = '#9FB0CC';
var $89c2f4de61c9eb17$export$97e81faa16a182c7 = '#8C9CB8';
var $89c2f4de61c9eb17$export$bfe21c59123ecf33 = '#7988A3';
var $89c2f4de61c9eb17$export$ee82aa2ea6a1558 = '#67758F';
var $89c2f4de61c9eb17$export$682927c6ed76be02 = '#56637A';
var $89c2f4de61c9eb17$export$91fd9994c5be9757 = '#455166';
var $89c2f4de61c9eb17$export$d281fbfe3cff2df6 = '#3B475C';
var $89c2f4de61c9eb17$export$3902c91d8b98a753 = '#313D52';
var $89c2f4de61c9eb17$export$8e8133c1ba5845b5 = '#283447';
var $89c2f4de61c9eb17$export$33ff357f6620b39 = '#202B3D';
var $89c2f4de61c9eb17$export$633847cf062b69e0 = '#1B2638';
var $89c2f4de61c9eb17$export$9776a6e503bdbf76 = '#121A29';
var $89c2f4de61c9eb17$export$6c813d5160dff5db = '#0E1624';
var $89c2f4de61c9eb17$export$3d4f271a500072a = '#0D1424';
var $89c2f4de61c9eb17$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
var $89c2f4de61c9eb17$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
var $89c2f4de61c9eb17$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
var $89c2f4de61c9eb17$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
var $89c2f4de61c9eb17$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
var $89c2f4de61c9eb17$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
var $89c2f4de61c9eb17$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
var $89c2f4de61c9eb17$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
var $89c2f4de61c9eb17$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
var $89c2f4de61c9eb17$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
var $89c2f4de61c9eb17$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
var $89c2f4de61c9eb17$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
var $89c2f4de61c9eb17$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
var $89c2f4de61c9eb17$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
var $89c2f4de61c9eb17$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
var $89c2f4de61c9eb17$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
var $89c2f4de61c9eb17$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';
var $89c2f4de61c9eb17$export$d2adc5dedf09fced = '#292A2E';
var $89c2f4de61c9eb17$export$f51762073d2bb381 = '#94C748';
var $89c2f4de61c9eb17$export$95e26d54def96891 = '#B3DF72';


var $cc17fe7e1b63b8a0$export$ae3cba7672df0890 = "var(--ds-background-disabled, ".concat((0, $89c2f4de61c9eb17$export$9fdfb749e33cdf97), ")");
var $cc17fe7e1b63b8a0$export$fe505fe3c5edbdf6 = "var(--ds-border-disabled, ".concat((0, $89c2f4de61c9eb17$export$1ce2d1575d444ceb), ")");
var $cc17fe7e1b63b8a0$export$7f333bbf7ddab792 = "var(--ds-border-danger, ".concat((0, $89c2f4de61c9eb17$export$2010d0fb4295b346), ")");
var $cc17fe7e1b63b8a0$export$dafd83031c202ca8 = "var(--ds-border-input, ".concat((0, $89c2f4de61c9eb17$export$d6447c357493214f), ")");
var $cc17fe7e1b63b8a0$export$e8320c09dc1e4012 = "var(--ds-border-focused, ".concat((0, $89c2f4de61c9eb17$export$215b7063051591f1), ")");
var $cc17fe7e1b63b8a0$export$b13414ee9ac9cae6 = "var(--ds-background-input, ".concat((0, $89c2f4de61c9eb17$export$e655ef011c4aa1a2), ")");
var $cc17fe7e1b63b8a0$export$bca15982c103d57b = "var(--ds-background-input-hovered, ".concat((0, $89c2f4de61c9eb17$export$3e51e8f1440314ba), ")");
var $cc17fe7e1b63b8a0$export$21287e4b7f134f09 = "var(--ds-background-input-pressed, ".concat((0, $89c2f4de61c9eb17$export$29a4f05edc054374), ")");
var $cc17fe7e1b63b8a0$export$a87538d56ee366ec = "var(--ds-border-input, transparent)";
var $cc17fe7e1b63b8a0$export$5e076b2557ef7bbb = "var(--ds-text-subtlest, ".concat((0, $89c2f4de61c9eb17$export$f563ee71e9ee74cd), ")");
var $cc17fe7e1b63b8a0$export$32f78bffcd82ff28 = "var(--ds-text, ".concat((0, $89c2f4de61c9eb17$export$fbda843f0a27fe96), ")");
var $cc17fe7e1b63b8a0$export$eb4a7d363eec53c8 = "var(--ds-text-disabled, ".concat((0, $89c2f4de61c9eb17$export$5f71e19f3a7ad9de), ")");
var $cc17fe7e1b63b8a0$export$f4d082c200a4b4b8 = 'transparent';


function $a1ba02130c420f9d$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $a1ba02130c420f9d$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $a1ba02130c420f9d$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $a1ba02130c420f9d$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $a1ba02130c420f9d$var$disabledRules = {
    backgroundColor: $cc17fe7e1b63b8a0$export$ae3cba7672df0890,
    backgroundColorFocus: $cc17fe7e1b63b8a0$export$ae3cba7672df0890,
    backgroundColorHover: $cc17fe7e1b63b8a0$export$ae3cba7672df0890,
    borderColor: $cc17fe7e1b63b8a0$export$fe505fe3c5edbdf6,
    borderColorFocus: $cc17fe7e1b63b8a0$export$e8320c09dc1e4012,
    textColor: $cc17fe7e1b63b8a0$export$eb4a7d363eec53c8
};
var $a1ba02130c420f9d$var$invalidRules = {
    borderColor: $cc17fe7e1b63b8a0$export$7f333bbf7ddab792,
    borderColorFocus: $cc17fe7e1b63b8a0$export$e8320c09dc1e4012,
    backgroundColor: $cc17fe7e1b63b8a0$export$b13414ee9ac9cae6,
    backgroundColorFocus: $cc17fe7e1b63b8a0$export$21287e4b7f134f09,
    backgroundColorHover: $cc17fe7e1b63b8a0$export$bca15982c103d57b
};
var $a1ba02130c420f9d$var$backgroundColor = {
    standard: $cc17fe7e1b63b8a0$export$b13414ee9ac9cae6,
    subtle: $cc17fe7e1b63b8a0$export$f4d082c200a4b4b8,
    none: $cc17fe7e1b63b8a0$export$f4d082c200a4b4b8
};
var $a1ba02130c420f9d$var$backgroundColorFocus = {
    standard: $cc17fe7e1b63b8a0$export$21287e4b7f134f09,
    subtle: $cc17fe7e1b63b8a0$export$21287e4b7f134f09,
    none: $cc17fe7e1b63b8a0$export$f4d082c200a4b4b8
};
var $a1ba02130c420f9d$var$backgroundColorHover = {
    standard: $cc17fe7e1b63b8a0$export$bca15982c103d57b,
    subtle: $cc17fe7e1b63b8a0$export$bca15982c103d57b,
    none: $cc17fe7e1b63b8a0$export$f4d082c200a4b4b8
};
var $a1ba02130c420f9d$var$borderColor = {
    standard: $cc17fe7e1b63b8a0$export$dafd83031c202ca8,
    subtle: $cc17fe7e1b63b8a0$export$f4d082c200a4b4b8,
    none: $cc17fe7e1b63b8a0$export$f4d082c200a4b4b8
};
var $a1ba02130c420f9d$var$borderColorFocus = {
    standard: $cc17fe7e1b63b8a0$export$e8320c09dc1e4012,
    subtle: $cc17fe7e1b63b8a0$export$e8320c09dc1e4012,
    none: $cc17fe7e1b63b8a0$export$f4d082c200a4b4b8
};
var $a1ba02130c420f9d$var$borderColorHover = {
    standard: $cc17fe7e1b63b8a0$export$dafd83031c202ca8,
    subtle: $cc17fe7e1b63b8a0$export$a87538d56ee366ec,
    none: $cc17fe7e1b63b8a0$export$f4d082c200a4b4b8
};
var $a1ba02130c420f9d$var$lineHeightBase = 20;
var $a1ba02130c420f9d$var$lineHeightCompact = 16;
var $a1ba02130c420f9d$var$compactVerticalPadding = 2;
var $a1ba02130c420f9d$var$verticalPadding = 6;
var $a1ba02130c420f9d$var$horizontalPadding = 8;
var $a1ba02130c420f9d$var$transitionDuration = '0.2s';
var $a1ba02130c420f9d$export$12879c7697ed953d = 2;
// Safari puts on some difficult to remove styles, mainly for disabled inputs
// but we want full control so need to override them in all cases
var $a1ba02130c420f9d$var$overrideSafariDisabledStyles = {
    WebkitTextFillColor: 'unset',
    WebkitOpacity: '1'
};
var $a1ba02130c420f9d$var$borderBoxMinHeight = function borderBoxMinHeight(minimumRows, borderHeight) {
    var contentHeight = $a1ba02130c420f9d$var$lineHeightBase * minimumRows;
    return contentHeight + $a1ba02130c420f9d$var$verticalPadding * 2 + borderHeight * 2;
};
var $a1ba02130c420f9d$var$borderBoxMinHeightCompact = function borderBoxMinHeightCompact(minimumRows, borderHeight) {
    var contentHeightCompact = $a1ba02130c420f9d$var$lineHeightCompact * minimumRows;
    return contentHeightCompact + $a1ba02130c420f9d$var$compactVerticalPadding * 2 + borderHeight * 2;
};
var $a1ba02130c420f9d$var$bgAndBorderColorStyles = function bgAndBorderColorStyles(appearance) {
    return appearance && (0, $74Zh5.css)($a1ba02130c420f9d$var$_objectSpread({
        '&:focus': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            backgroundColor: $a1ba02130c420f9d$var$backgroundColorFocus[appearance],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            borderColor: $a1ba02130c420f9d$var$borderColorFocus[appearance],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            boxShadow: "inset 0 0 0 ".concat("var(--ds-border-width, 1px)", " ", $a1ba02130c420f9d$var$borderColorFocus[appearance])
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '&:not(:focus)': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            backgroundColor: $a1ba02130c420f9d$var$backgroundColor[appearance],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            borderColor: $a1ba02130c420f9d$var$borderColor[appearance]
        },
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '&[data-invalid]:focus': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            backgroundColor: $a1ba02130c420f9d$var$invalidRules.backgroundColorFocus,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            borderColor: $a1ba02130c420f9d$var$invalidRules.borderColorFocus,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            boxShadow: "inset 0 0 0 ".concat("var(--ds-border-width, 1px)", " ", $a1ba02130c420f9d$var$invalidRules.borderColorFocus)
        },
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '&[data-invalid]:not(:focus)': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            backgroundColor: $a1ba02130c420f9d$var$invalidRules.backgroundColor,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            borderColor: $a1ba02130c420f9d$var$invalidRules.borderColor,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            boxShadow: "inset 0 0 0 ".concat("var(--ds-border-width, 1px)", " ", $a1ba02130c420f9d$var$invalidRules.borderColor)
        }
    }, appearance === 'standard' ? {
        '&:disabled:focus': {
            backgroundColor: $a1ba02130c420f9d$var$disabledRules.backgroundColorFocus,
            borderColor: $a1ba02130c420f9d$var$disabledRules.borderColorFocus
        },
        '&:disabled:not(:focus)': {
            backgroundColor: $a1ba02130c420f9d$var$disabledRules.backgroundColor,
            borderColor: $a1ba02130c420f9d$var$disabledRules.borderColor
        }
    } : {}));
};
var $a1ba02130c420f9d$var$placeholderStyles = (0, $74Zh5.css)({
    '&::placeholder': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        color: $cc17fe7e1b63b8a0$export$5e076b2557ef7bbb
    },
    '&:disabled::placeholder': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        color: $a1ba02130c420f9d$var$disabledRules.textColor
    }
});
var $a1ba02130c420f9d$var$hoverBackgroundAndBorderStyles = function hoverBackgroundAndBorderStyles(appearance) {
    return appearance && (0, $74Zh5.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '&:hover:not(:read-only):not(:focus)': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            backgroundColor: $a1ba02130c420f9d$var$backgroundColorHover[appearance],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            borderColor: $a1ba02130c420f9d$var$borderColorHover[appearance],
            '&:disabled': {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                backgroundColor: $a1ba02130c420f9d$var$disabledRules.backgroundColorHover
            },
            // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
            '&[data-invalid]': {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                backgroundColor: $a1ba02130c420f9d$var$invalidRules.backgroundColorHover,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                borderColor: $a1ba02130c420f9d$var$invalidRules.borderColor,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                boxShadow: "inset 0 0 0 ".concat("var(--ds-border-width, 1px)", " ", $a1ba02130c420f9d$var$invalidRules.borderColor)
            }
        }
    });
};
var $a1ba02130c420f9d$var$resizeStyle = function resizeStyle(resize) {
    if (resize === 'horizontal' || resize === 'vertical') // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    return (0, $74Zh5.css)({
        resize: resize
    });
    if (resize === 'auto') return (0, $74Zh5.css)({
        resize: 'both'
    });
    return (0, $74Zh5.css)({
        resize: 'none'
    });
};
var $a1ba02130c420f9d$var$borderStyle = function borderStyle(appearance) {
    return (0, $74Zh5.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        borderStyle: appearance === 'none' ? 'none' : 'solid'
    });
};
var $a1ba02130c420f9d$var$fontFamilyStyle = function fontFamilyStyle(isMonospaced) {
    return (0, $74Zh5.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/design-system/use-tokens-typography -- Ignored via go/DSP-18766
        fontFamily: isMonospaced ? "var(--ds-font-family-code, ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)" : "var(--ds-font-family-body, ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)"
    });
};
var $a1ba02130c420f9d$var$borderPaddingAndHeightStyles = function borderPaddingAndHeightStyles() {
    var minimumRows = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
    var appearance = arguments.length > 1 ? arguments[1] : undefined;
    var borderWidth = appearance !== 'none' ? 1 : 2;
    var horizontalPaddingWithoutBorderWidth = $a1ba02130c420f9d$var$horizontalPadding - borderWidth;
    var borderHeight = borderWidth;
    return (0, $74Zh5.css)({
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '&[data-compact]': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            minHeight: $a1ba02130c420f9d$var$borderBoxMinHeightCompact(minimumRows, borderHeight),
            // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            padding: "".concat($a1ba02130c420f9d$var$compactVerticalPadding, "px ").concat(horizontalPaddingWithoutBorderWidth, "px"),
            // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/design-system/use-tokens-typography
            lineHeight: $a1ba02130c420f9d$var$lineHeightCompact / 14
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '&:not([data-compact])': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            minHeight: $a1ba02130c420f9d$var$borderBoxMinHeight(minimumRows, borderHeight),
            // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            padding: "".concat($a1ba02130c420f9d$var$verticalPadding, "px ").concat(horizontalPaddingWithoutBorderWidth, "px"),
            // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/design-system/use-tokens-typography
            lineHeight: $a1ba02130c420f9d$var$lineHeightBase / 14
        }
    });
};
var $a1ba02130c420f9d$var$staticStyles = (0, $74Zh5.css)({
    display: 'block',
    boxSizing: 'border-box',
    width: '100%',
    minWidth: 0,
    maxWidth: '100%',
    margin: 0,
    position: 'relative',
    flex: '1 1 100%',
    borderRadius: "var(--ds-border-radius, 3px)",
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
    borderWidth: 1,
    font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    outline: 'none',
    overflow: 'auto',
    transition: "background-color ".concat($a1ba02130c420f9d$var$transitionDuration, " ease-in-out,\n               border-color ").concat($a1ba02130c420f9d$var$transitionDuration, " ease-in-out"),
    wordWrap: 'break-word',
    '&:disabled': $a1ba02130c420f9d$var$_objectSpread({
        cursor: 'not-allowed'
    }, $a1ba02130c420f9d$var$overrideSafariDisabledStyles),
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '&::-ms-clear': {
        display: 'none'
    },
    '&:invalid': {
        boxShadow: 'none'
    }
});
// suggestion: these two could be merged into cssMap during @compiled rewrite
var $a1ba02130c420f9d$var$newFontStyles = (0, $74Zh5.css)((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({
    font: "var(--ds-font-body-large, normal 400 16px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)"
}, (0, $5d46c179935a1c9c$export$987d49ffe1b0900f).above.xs, {
    font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)"
}));
var $a1ba02130c420f9d$var$monospacedFontFamilyStyles = (0, $74Zh5.css)((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({
    fontFamily: "var(--ds-font-family-code, ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)"
}, (0, $5d46c179935a1c9c$export$987d49ffe1b0900f).above.xs, {
    // Reapply the monospaced font family as the font declaration used in the breakpoint in newFontStyles overrides it otherwise
    fontFamily: "var(--ds-font-family-code, ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)"
}));
var $a1ba02130c420f9d$export$bff8031d86bb089 = function getBaseStyles(_ref) {
    var minimumRows = _ref.minimumRows, resize = _ref.resize, appearance = _ref.appearance, isMonospaced = _ref.isMonospaced, maxHeight = _ref.maxHeight;
    return(// eslint-disable-next-line @repo/internal/styles/no-exported-styles
    (0, $74Zh5.css)(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    $a1ba02130c420f9d$var$staticStyles, // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    $a1ba02130c420f9d$var$borderPaddingAndHeightStyles(minimumRows, appearance), // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    $a1ba02130c420f9d$var$resizeStyle(resize), // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    $a1ba02130c420f9d$var$borderStyle(appearance), // @todo: remove in `platform_design_system_team_safari_input_fix` cleanup
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    $a1ba02130c420f9d$var$fontFamilyStyle(isMonospaced), // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    (0, $473292da1a47ed2b$export$b40ec24ac8275656)('platform_design_system_team_safari_input_fix') ? $a1ba02130c420f9d$var$newFontStyles : undefined, // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
    isMonospaced && (0, $473292da1a47ed2b$export$b40ec24ac8275656)('platform_design_system_team_safari_input_fix') ? $a1ba02130c420f9d$var$monospacedFontFamilyStyles : undefined, // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    {
        maxHeight: maxHeight
    }));
};
var $a1ba02130c420f9d$export$98856a888ef36079 = function dynamicStyles(appearance) {
    return(// eslint-disable-next-line @repo/internal/styles/no-exported-styles
    (0, $74Zh5.css)(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    $a1ba02130c420f9d$var$bgAndBorderColorStyles(appearance), // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    $a1ba02130c420f9d$var$hoverBackgroundAndBorderStyles(appearance), // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    $a1ba02130c420f9d$var$placeholderStyles, {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        color: $cc17fe7e1b63b8a0$export$32f78bffcd82ff28,
        '&:disabled': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            color: $a1ba02130c420f9d$var$disabledRules.textColor
        }
    }));
};


var $195b49e60159a439$var$_excluded = [
    "resize",
    "appearance",
    "isCompact",
    "isRequired",
    "isReadOnly",
    "isDisabled",
    "isInvalid",
    "isMonospaced",
    "minimumRows",
    "testId",
    "maxHeight",
    "onBlur",
    "onFocus",
    "onChange",
    "value"
];
function $195b49e60159a439$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $195b49e60159a439$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $195b49e60159a439$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $195b49e60159a439$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $195b49e60159a439$var$packageName = "@atlaskit/textarea";
var $195b49e60159a439$var$packageVersion = "5.8.2";
var $195b49e60159a439$var$analyticsParams = {
    componentName: 'textArea',
    packageName: $195b49e60159a439$var$packageName,
    packageVersion: $195b49e60159a439$var$packageVersion
};
var $195b49e60159a439$var$setSmartHeight = function setSmartHeight(el) {
    // Always reset height to auto before calculating new height
    el.style.height = 'auto';
    var borderHeight = (0, $a1ba02130c420f9d$export$12879c7697ed953d);
    var paddingBoxHeight = el.scrollHeight;
    var borderBoxHeight = paddingBoxHeight + borderHeight * 2;
    el.style.height = "".concat(borderBoxHeight, "px");
};
var $195b49e60159a439$var$InnerTextArea = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function(props, ref) {
    var ourRef = (0, $5FkrB.useRef)(null);
    var _props$resize = props.resize, resize = _props$resize === void 0 ? 'smart' : _props$resize, _props$appearance = props.appearance, appearance = _props$appearance === void 0 ? 'standard' : _props$appearance, _props$isCompact = props.isCompact, isCompact = _props$isCompact === void 0 ? false : _props$isCompact, _props$isRequired = props.isRequired, isRequired = _props$isRequired === void 0 ? false : _props$isRequired, _props$isReadOnly = props.isReadOnly, isReadOnly = _props$isReadOnly === void 0 ? false : _props$isReadOnly, _props$isDisabled = props.isDisabled, isDisabled = _props$isDisabled === void 0 ? false : _props$isDisabled, _props$isInvalid = props.isInvalid, isInvalid = _props$isInvalid === void 0 ? false : _props$isInvalid, _props$isMonospaced = props.isMonospaced, isMonospaced = _props$isMonospaced === void 0 ? false : _props$isMonospaced, _props$minimumRows = props.minimumRows, minimumRows = _props$minimumRows === void 0 ? 2 : _props$minimumRows, testId = props.testId, _props$maxHeight = props.maxHeight, maxHeight = _props$maxHeight === void 0 ? '50vh' : _props$maxHeight, onBlur = props.onBlur, onFocus = props.onFocus, onChange = props.onChange, value = props.value, rest = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(props, $195b49e60159a439$var$_excluded);
    (0, $5FkrB.useEffect)(function() {
        var el = ourRef.current;
        if (resize === 'smart' && el) $195b49e60159a439$var$setSmartHeight(el);
    }, [
        resize,
        value
    ]);
    var onBlurWithAnalytics = (0, $efbe8ac0102cf4bd$export$a4687b0234b40e28)($195b49e60159a439$var$_objectSpread({
        fn: function fn(event) {
            onBlur && onBlur(event);
        },
        action: 'blurred'
    }, $195b49e60159a439$var$analyticsParams));
    var onFocusWithAnalytics = (0, $efbe8ac0102cf4bd$export$a4687b0234b40e28)($195b49e60159a439$var$_objectSpread({
        fn: function fn(event) {
            onFocus && onFocus(event);
        },
        action: 'focused'
    }, $195b49e60159a439$var$analyticsParams));
    var getTextAreaRef = function getTextAreaRef(elementRef) {
        ourRef.current = elementRef;
        if (ref && (0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(ref) === 'object') // @ts-ignore
        ref.current = elementRef;
        if (ref && typeof ref === 'function') ref(elementRef);
    };
    var handleOnChange = (0, $5FkrB.useCallback)(function(e) {
        var el = ourRef.current;
        if (resize === 'smart' && el) $195b49e60159a439$var$setSmartHeight(el);
        onChange && onChange(e);
    }, [
        onChange,
        resize
    ]);
    var controlProps = {
        'data-invalid': isInvalid ? isInvalid : undefined,
        'data-compact': isCompact ? isCompact : undefined,
        'data-testid': testId ? testId : undefined
    };
    var baseStyles = (0, $5FkrB.useMemo)(function() {
        return (0, $a1ba02130c420f9d$export$bff8031d86bb089)({
            minimumRows: minimumRows,
            resize: resize,
            appearance: appearance,
            isMonospaced: isMonospaced,
            maxHeight: maxHeight
        });
    }, [
        minimumRows,
        resize,
        appearance,
        isMonospaced,
        maxHeight
    ]);
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-array-arguments, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    var textAreaStyles = (0, $74Zh5.css)([
        baseStyles,
        (0, $a1ba02130c420f9d$export$98856a888ef36079)(appearance)
    ]);
    return (0, $74Zh5.jsx)("textarea", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, controlProps, {
        value: value,
        disabled: isDisabled,
        readOnly: isReadOnly,
        required: isRequired,
        ref: getTextAreaRef,
        onChange: handleOnChange,
        onBlur: onBlurWithAnalytics,
        onFocus: onFocusWithAnalytics,
        rows: minimumRows,
        css: textAreaStyles
    }, rest));
});
/**
 * __Text area__
 *
 * A text area lets users enter long form text which spans over multiple lines.
 *
 * - [Examples](https://atlassian.design/components/textarea/examples)
 * - [Code](https://atlassian.design/components/textarea/code)
 * - [Usage](https://atlassian.design/components/textarea/usage)
 */ var $195b49e60159a439$var$TextArea = /*#__PURE__*/ (0, $5FkrB.memo)(/*#__PURE__*/ (0, $5FkrB.forwardRef)(function TextArea(props, ref) {
    return (0, $74Zh5.jsx)($195b49e60159a439$var$InnerTextArea, (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        ref: ref
    }, props));
}));
$195b49e60159a439$var$TextArea.displayName = 'TextArea';
var $195b49e60159a439$export$2e2bcd8739ae039 = $195b49e60159a439$var$TextArea;


var $336d3dfe62d84a74$exports = {};
/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ /** Used as references for various `Number` constants. */ var $336d3dfe62d84a74$var$INFINITY = 1 / 0, $336d3dfe62d84a74$var$MAX_SAFE_INTEGER = 9007199254740991, $336d3dfe62d84a74$var$MAX_INTEGER = 1.7976931348623157e+308, $336d3dfe62d84a74$var$NAN = 0 / 0;
/** Used as references for the maximum length and index of an array. */ var $336d3dfe62d84a74$var$MAX_ARRAY_LENGTH = 4294967295;
/** `Object#toString` result references. */ var $336d3dfe62d84a74$var$argsTag = '[object Arguments]', $336d3dfe62d84a74$var$funcTag = '[object Function]', $336d3dfe62d84a74$var$genTag = '[object GeneratorFunction]', $336d3dfe62d84a74$var$mapTag = '[object Map]', $336d3dfe62d84a74$var$objectTag = '[object Object]', $336d3dfe62d84a74$var$promiseTag = '[object Promise]', $336d3dfe62d84a74$var$setTag = '[object Set]', $336d3dfe62d84a74$var$stringTag = '[object String]', $336d3dfe62d84a74$var$symbolTag = '[object Symbol]', $336d3dfe62d84a74$var$weakMapTag = '[object WeakMap]';
var $336d3dfe62d84a74$var$dataViewTag = '[object DataView]';
/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var $336d3dfe62d84a74$var$reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to match leading and trailing whitespace. */ var $336d3dfe62d84a74$var$reTrim = /^\s+|\s+$/g;
/** Used to detect bad signed hexadecimal string values. */ var $336d3dfe62d84a74$var$reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
/** Used to detect binary string values. */ var $336d3dfe62d84a74$var$reIsBinary = /^0b[01]+$/i;
/** Used to detect host constructors (Safari). */ var $336d3dfe62d84a74$var$reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used to detect octal string values. */ var $336d3dfe62d84a74$var$reIsOctal = /^0o[0-7]+$/i;
/** Used to detect unsigned integer values. */ var $336d3dfe62d84a74$var$reIsUint = /^(?:0|[1-9]\d*)$/;
/** Used to compose unicode character classes. */ var $336d3dfe62d84a74$var$rsAstralRange = '\\ud800-\\udfff', $336d3dfe62d84a74$var$rsComboMarksRange = '\\u0300-\\u036f\\ufe20-\\ufe23', $336d3dfe62d84a74$var$rsComboSymbolsRange = '\\u20d0-\\u20f0', $336d3dfe62d84a74$var$rsVarRange = '\\ufe0e\\ufe0f';
/** Used to compose unicode capture groups. */ var $336d3dfe62d84a74$var$rsAstral = '[' + $336d3dfe62d84a74$var$rsAstralRange + ']', $336d3dfe62d84a74$var$rsCombo = '[' + $336d3dfe62d84a74$var$rsComboMarksRange + $336d3dfe62d84a74$var$rsComboSymbolsRange + ']', $336d3dfe62d84a74$var$rsFitz = '\\ud83c[\\udffb-\\udfff]', $336d3dfe62d84a74$var$rsModifier = '(?:' + $336d3dfe62d84a74$var$rsCombo + '|' + $336d3dfe62d84a74$var$rsFitz + ')', $336d3dfe62d84a74$var$rsNonAstral = '[^' + $336d3dfe62d84a74$var$rsAstralRange + ']', $336d3dfe62d84a74$var$rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}', $336d3dfe62d84a74$var$rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]', $336d3dfe62d84a74$var$rsZWJ = '\\u200d';
/** Used to compose unicode regexes. */ var $336d3dfe62d84a74$var$reOptMod = $336d3dfe62d84a74$var$rsModifier + '?', $336d3dfe62d84a74$var$rsOptVar = '[' + $336d3dfe62d84a74$var$rsVarRange + ']?', $336d3dfe62d84a74$var$rsOptJoin = '(?:' + $336d3dfe62d84a74$var$rsZWJ + '(?:' + [
    $336d3dfe62d84a74$var$rsNonAstral,
    $336d3dfe62d84a74$var$rsRegional,
    $336d3dfe62d84a74$var$rsSurrPair
].join('|') + ')' + $336d3dfe62d84a74$var$rsOptVar + $336d3dfe62d84a74$var$reOptMod + ')*', $336d3dfe62d84a74$var$rsSeq = $336d3dfe62d84a74$var$rsOptVar + $336d3dfe62d84a74$var$reOptMod + $336d3dfe62d84a74$var$rsOptJoin, $336d3dfe62d84a74$var$rsSymbol = '(?:' + [
    $336d3dfe62d84a74$var$rsNonAstral + $336d3dfe62d84a74$var$rsCombo + '?',
    $336d3dfe62d84a74$var$rsCombo,
    $336d3dfe62d84a74$var$rsRegional,
    $336d3dfe62d84a74$var$rsSurrPair,
    $336d3dfe62d84a74$var$rsAstral
].join('|') + ')';
/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */ var $336d3dfe62d84a74$var$reUnicode = RegExp($336d3dfe62d84a74$var$rsFitz + '(?=' + $336d3dfe62d84a74$var$rsFitz + ')|' + $336d3dfe62d84a74$var$rsSymbol + $336d3dfe62d84a74$var$rsSeq, 'g');
/** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */ var $336d3dfe62d84a74$var$reHasUnicode = RegExp('[' + $336d3dfe62d84a74$var$rsZWJ + $336d3dfe62d84a74$var$rsAstralRange + $336d3dfe62d84a74$var$rsComboMarksRange + $336d3dfe62d84a74$var$rsComboSymbolsRange + $336d3dfe62d84a74$var$rsVarRange + ']');
/** Built-in method references without a dependency on `root`. */ var $336d3dfe62d84a74$var$freeParseInt = parseInt;
/** Detect free variable `global` from Node.js. */ var $336d3dfe62d84a74$var$freeGlobal = typeof $parcel$global == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
/** Detect free variable `self`. */ var $336d3dfe62d84a74$var$freeSelf = typeof self == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $336d3dfe62d84a74$var$root = $336d3dfe62d84a74$var$freeGlobal || $336d3dfe62d84a74$var$freeSelf || Function('return this')();
/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function $336d3dfe62d84a74$var$arrayMap(array, iteratee) {
    var index = -1, length = array ? array.length : 0, result = Array(length);
    while(++index < length)result[index] = iteratee(array[index], index, array);
    return result;
}
/**
 * Converts an ASCII `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */ function $336d3dfe62d84a74$var$asciiToArray(string) {
    return string.split('');
}
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ function $336d3dfe62d84a74$var$baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
/**
 * The base implementation of `_.values` and `_.valuesIn` which creates an
 * array of `object` property values corresponding to the property names
 * of `props`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} props The property names to get values for.
 * @returns {Object} Returns the array of property values.
 */ function $336d3dfe62d84a74$var$baseValues(object, props) {
    return $336d3dfe62d84a74$var$arrayMap(props, function(key) {
        return object[key];
    });
}
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function $336d3dfe62d84a74$var$getValue(object, key) {
    return object == null ? undefined : object[key];
}
/**
 * Checks if `string` contains Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a symbol is found, else `false`.
 */ function $336d3dfe62d84a74$var$hasUnicode(string) {
    return $336d3dfe62d84a74$var$reHasUnicode.test(string);
}
/**
 * Checks if `value` is a host object in IE < 9.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
 */ function $336d3dfe62d84a74$var$isHostObject(value) {
    // Many host objects are `Object` objects that can coerce to strings
    // despite having improperly defined `toString` methods.
    var result = false;
    if (value != null && typeof value.toString != 'function') try {
        result = !!(value + '');
    } catch (e) {}
    return result;
}
/**
 * Converts `iterator` to an array.
 *
 * @private
 * @param {Object} iterator The iterator to convert.
 * @returns {Array} Returns the converted array.
 */ function $336d3dfe62d84a74$var$iteratorToArray(iterator) {
    var data, result = [];
    while(!(data = iterator.next()).done)result.push(data.value);
    return result;
}
/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */ function $336d3dfe62d84a74$var$mapToArray(map) {
    var index = -1, result = Array(map.size);
    map.forEach(function(value, key) {
        result[++index] = [
            key,
            value
        ];
    });
    return result;
}
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function $336d3dfe62d84a74$var$overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */ function $336d3dfe62d84a74$var$setToArray(set) {
    var index = -1, result = Array(set.size);
    set.forEach(function(value) {
        result[++index] = value;
    });
    return result;
}
/**
 * Converts `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */ function $336d3dfe62d84a74$var$stringToArray(string) {
    return $336d3dfe62d84a74$var$hasUnicode(string) ? $336d3dfe62d84a74$var$unicodeToArray(string) : $336d3dfe62d84a74$var$asciiToArray(string);
}
/**
 * Converts a Unicode `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */ function $336d3dfe62d84a74$var$unicodeToArray(string) {
    return string.match($336d3dfe62d84a74$var$reUnicode) || [];
}
/** Used for built-in method references. */ var $336d3dfe62d84a74$var$funcProto = Function.prototype, $336d3dfe62d84a74$var$objectProto = Object.prototype;
/** Used to detect overreaching core-js shims. */ var $336d3dfe62d84a74$var$coreJsData = $336d3dfe62d84a74$var$root['__core-js_shared__'];
/** Used to detect methods masquerading as native. */ var $336d3dfe62d84a74$var$maskSrcKey = function() {
    var uid = /[^.]+$/.exec($336d3dfe62d84a74$var$coreJsData && $336d3dfe62d84a74$var$coreJsData.keys && $336d3dfe62d84a74$var$coreJsData.keys.IE_PROTO || '');
    return uid ? 'Symbol(src)_1.' + uid : '';
}();
/** Used to resolve the decompiled source of functions. */ var $336d3dfe62d84a74$var$funcToString = $336d3dfe62d84a74$var$funcProto.toString;
/** Used to check objects for own properties. */ var $336d3dfe62d84a74$var$hasOwnProperty = $336d3dfe62d84a74$var$objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $336d3dfe62d84a74$var$objectToString = $336d3dfe62d84a74$var$objectProto.toString;
/** Used to detect if a method is native. */ var $336d3dfe62d84a74$var$reIsNative = RegExp('^' + $336d3dfe62d84a74$var$funcToString.call($336d3dfe62d84a74$var$hasOwnProperty).replace($336d3dfe62d84a74$var$reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
/** Built-in value references. */ var $336d3dfe62d84a74$var$Symbol = $336d3dfe62d84a74$var$root.Symbol, $336d3dfe62d84a74$var$iteratorSymbol = $336d3dfe62d84a74$var$Symbol ? $336d3dfe62d84a74$var$Symbol.iterator : undefined, $336d3dfe62d84a74$var$propertyIsEnumerable = $336d3dfe62d84a74$var$objectProto.propertyIsEnumerable;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $336d3dfe62d84a74$var$nativeFloor = Math.floor, $336d3dfe62d84a74$var$nativeKeys = $336d3dfe62d84a74$var$overArg(Object.keys, Object), $336d3dfe62d84a74$var$nativeRandom = Math.random;
/* Built-in method references that are verified to be native. */ var $336d3dfe62d84a74$var$DataView = $336d3dfe62d84a74$var$getNative($336d3dfe62d84a74$var$root, 'DataView'), $336d3dfe62d84a74$var$Map = $336d3dfe62d84a74$var$getNative($336d3dfe62d84a74$var$root, 'Map'), $336d3dfe62d84a74$var$Promise = $336d3dfe62d84a74$var$getNative($336d3dfe62d84a74$var$root, 'Promise'), $336d3dfe62d84a74$var$Set = $336d3dfe62d84a74$var$getNative($336d3dfe62d84a74$var$root, 'Set'), $336d3dfe62d84a74$var$WeakMap = $336d3dfe62d84a74$var$getNative($336d3dfe62d84a74$var$root, 'WeakMap');
/** Used to detect maps, sets, and weakmaps. */ var $336d3dfe62d84a74$var$dataViewCtorString = $336d3dfe62d84a74$var$toSource($336d3dfe62d84a74$var$DataView), $336d3dfe62d84a74$var$mapCtorString = $336d3dfe62d84a74$var$toSource($336d3dfe62d84a74$var$Map), $336d3dfe62d84a74$var$promiseCtorString = $336d3dfe62d84a74$var$toSource($336d3dfe62d84a74$var$Promise), $336d3dfe62d84a74$var$setCtorString = $336d3dfe62d84a74$var$toSource($336d3dfe62d84a74$var$Set), $336d3dfe62d84a74$var$weakMapCtorString = $336d3dfe62d84a74$var$toSource($336d3dfe62d84a74$var$WeakMap);
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function $336d3dfe62d84a74$var$arrayLikeKeys(value, inherited) {
    // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
    // Safari 9 makes `arguments.length` enumerable in strict mode.
    var result = $336d3dfe62d84a74$var$isArray(value) || $336d3dfe62d84a74$var$isArguments(value) ? $336d3dfe62d84a74$var$baseTimes(value.length, String) : [];
    var length = result.length, skipIndexes = !!length;
    for(var key in value)if ((inherited || $336d3dfe62d84a74$var$hasOwnProperty.call(value, key)) && !(skipIndexes && (key == 'length' || $336d3dfe62d84a74$var$isIndex(key, length)))) result.push(key);
    return result;
}
/**
 * The base implementation of `_.clamp` which doesn't coerce arguments.
 *
 * @private
 * @param {number} number The number to clamp.
 * @param {number} [lower] The lower bound.
 * @param {number} upper The upper bound.
 * @returns {number} Returns the clamped number.
 */ function $336d3dfe62d84a74$var$baseClamp(number, lower, upper) {
    if (number === number) {
        if (upper !== undefined) number = number <= upper ? number : upper;
        if (lower !== undefined) number = number >= lower ? number : lower;
    }
    return number;
}
/**
 * The base implementation of `getTag`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function $336d3dfe62d84a74$var$baseGetTag(value) {
    return $336d3dfe62d84a74$var$objectToString.call(value);
}
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function $336d3dfe62d84a74$var$baseIsNative(value) {
    if (!$336d3dfe62d84a74$var$isObject(value) || $336d3dfe62d84a74$var$isMasked(value)) return false;
    var pattern = $336d3dfe62d84a74$var$isFunction(value) || $336d3dfe62d84a74$var$isHostObject(value) ? $336d3dfe62d84a74$var$reIsNative : $336d3dfe62d84a74$var$reIsHostCtor;
    return pattern.test($336d3dfe62d84a74$var$toSource(value));
}
/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $336d3dfe62d84a74$var$baseKeys(object) {
    if (!$336d3dfe62d84a74$var$isPrototype(object)) return $336d3dfe62d84a74$var$nativeKeys(object);
    var result = [];
    for(var key in Object(object))if ($336d3dfe62d84a74$var$hasOwnProperty.call(object, key) && key != 'constructor') result.push(key);
    return result;
}
/**
 * The base implementation of `_.random` without support for returning
 * floating-point numbers.
 *
 * @private
 * @param {number} lower The lower bound.
 * @param {number} upper The upper bound.
 * @returns {number} Returns the random number.
 */ function $336d3dfe62d84a74$var$baseRandom(lower, upper) {
    return lower + $336d3dfe62d84a74$var$nativeFloor($336d3dfe62d84a74$var$nativeRandom() * (upper - lower + 1));
}
/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */ function $336d3dfe62d84a74$var$copyArray(source, array) {
    var index = -1, length = source.length;
    array || (array = Array(length));
    while(++index < length)array[index] = source[index];
    return array;
}
/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function $336d3dfe62d84a74$var$getNative(object, key) {
    var value = $336d3dfe62d84a74$var$getValue(object, key);
    return $336d3dfe62d84a74$var$baseIsNative(value) ? value : undefined;
}
/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ var $336d3dfe62d84a74$var$getTag = $336d3dfe62d84a74$var$baseGetTag;
// Fallback for data views, maps, sets, and weak maps in IE 11,
// for data views in Edge < 14, and promises in Node.js.
if ($336d3dfe62d84a74$var$DataView && $336d3dfe62d84a74$var$getTag(new $336d3dfe62d84a74$var$DataView(new ArrayBuffer(1))) != $336d3dfe62d84a74$var$dataViewTag || $336d3dfe62d84a74$var$Map && $336d3dfe62d84a74$var$getTag(new $336d3dfe62d84a74$var$Map) != $336d3dfe62d84a74$var$mapTag || $336d3dfe62d84a74$var$Promise && $336d3dfe62d84a74$var$getTag($336d3dfe62d84a74$var$Promise.resolve()) != $336d3dfe62d84a74$var$promiseTag || $336d3dfe62d84a74$var$Set && $336d3dfe62d84a74$var$getTag(new $336d3dfe62d84a74$var$Set) != $336d3dfe62d84a74$var$setTag || $336d3dfe62d84a74$var$WeakMap && $336d3dfe62d84a74$var$getTag(new $336d3dfe62d84a74$var$WeakMap) != $336d3dfe62d84a74$var$weakMapTag) $336d3dfe62d84a74$var$getTag = function(value) {
    var result = $336d3dfe62d84a74$var$objectToString.call(value), Ctor = result == $336d3dfe62d84a74$var$objectTag ? value.constructor : undefined, ctorString = Ctor ? $336d3dfe62d84a74$var$toSource(Ctor) : undefined;
    if (ctorString) switch(ctorString){
        case $336d3dfe62d84a74$var$dataViewCtorString:
            return $336d3dfe62d84a74$var$dataViewTag;
        case $336d3dfe62d84a74$var$mapCtorString:
            return $336d3dfe62d84a74$var$mapTag;
        case $336d3dfe62d84a74$var$promiseCtorString:
            return $336d3dfe62d84a74$var$promiseTag;
        case $336d3dfe62d84a74$var$setCtorString:
            return $336d3dfe62d84a74$var$setTag;
        case $336d3dfe62d84a74$var$weakMapCtorString:
            return $336d3dfe62d84a74$var$weakMapTag;
    }
    return result;
};
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function $336d3dfe62d84a74$var$isIndex(value, length) {
    length = length == null ? $336d3dfe62d84a74$var$MAX_SAFE_INTEGER : length;
    return !!length && (typeof value == 'number' || $336d3dfe62d84a74$var$reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */ function $336d3dfe62d84a74$var$isIterateeCall(value, index, object) {
    if (!$336d3dfe62d84a74$var$isObject(object)) return false;
    var type = typeof index;
    if (type == 'number' ? $336d3dfe62d84a74$var$isArrayLike(object) && $336d3dfe62d84a74$var$isIndex(index, object.length) : type == 'string' && index in object) return $336d3dfe62d84a74$var$eq(object[index], value);
    return false;
}
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function $336d3dfe62d84a74$var$isMasked(func) {
    return !!$336d3dfe62d84a74$var$maskSrcKey && $336d3dfe62d84a74$var$maskSrcKey in func;
}
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function $336d3dfe62d84a74$var$isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == 'function' && Ctor.prototype || $336d3dfe62d84a74$var$objectProto;
    return value === proto;
}
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to process.
 * @returns {string} Returns the source code.
 */ function $336d3dfe62d84a74$var$toSource(func) {
    if (func != null) {
        try {
            return $336d3dfe62d84a74$var$funcToString.call(func);
        } catch (e) {}
        try {
            return func + '';
        } catch (e) {}
    }
    return '';
}
/**
 * Gets `n` random elements at unique keys from `collection` up to the
 * size of `collection`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Collection
 * @param {Array|Object} collection The collection to sample.
 * @param {number} [n=1] The number of elements to sample.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Array} Returns the random elements.
 * @example
 *
 * _.sampleSize([1, 2, 3], 2);
 * // => [3, 1]
 *
 * _.sampleSize([1, 2, 3], 4);
 * // => [2, 3, 1]
 */ function $336d3dfe62d84a74$var$sampleSize(collection, n, guard) {
    var index = -1, result = $336d3dfe62d84a74$var$toArray(collection), length = result.length, lastIndex = length - 1;
    if (guard ? $336d3dfe62d84a74$var$isIterateeCall(collection, n, guard) : n === undefined) n = 1;
    else n = $336d3dfe62d84a74$var$baseClamp($336d3dfe62d84a74$var$toInteger(n), 0, length);
    while(++index < n){
        var rand = $336d3dfe62d84a74$var$baseRandom(index, lastIndex), value = result[rand];
        result[rand] = result[index];
        result[index] = value;
    }
    result.length = n;
    return result;
}
/**
 * Creates an array of shuffled values, using a version of the
 * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to shuffle.
 * @returns {Array} Returns the new shuffled array.
 * @example
 *
 * _.shuffle([1, 2, 3, 4]);
 * // => [4, 1, 3, 2]
 */ function $336d3dfe62d84a74$var$shuffle(collection) {
    return $336d3dfe62d84a74$var$sampleSize(collection, $336d3dfe62d84a74$var$MAX_ARRAY_LENGTH);
}
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function $336d3dfe62d84a74$var$eq(value, other) {
    return value === other || value !== value && other !== other;
}
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ function $336d3dfe62d84a74$var$isArguments(value) {
    // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
    return $336d3dfe62d84a74$var$isArrayLikeObject(value) && $336d3dfe62d84a74$var$hasOwnProperty.call(value, 'callee') && (!$336d3dfe62d84a74$var$propertyIsEnumerable.call(value, 'callee') || $336d3dfe62d84a74$var$objectToString.call(value) == $336d3dfe62d84a74$var$argsTag);
}
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var $336d3dfe62d84a74$var$isArray = Array.isArray;
/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function $336d3dfe62d84a74$var$isArrayLike(value) {
    return value != null && $336d3dfe62d84a74$var$isLength(value.length) && !$336d3dfe62d84a74$var$isFunction(value);
}
/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */ function $336d3dfe62d84a74$var$isArrayLikeObject(value) {
    return $336d3dfe62d84a74$var$isObjectLike(value) && $336d3dfe62d84a74$var$isArrayLike(value);
}
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function $336d3dfe62d84a74$var$isFunction(value) {
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 8-9 which returns 'object' for typed array and other constructors.
    var tag = $336d3dfe62d84a74$var$isObject(value) ? $336d3dfe62d84a74$var$objectToString.call(value) : '';
    return tag == $336d3dfe62d84a74$var$funcTag || tag == $336d3dfe62d84a74$var$genTag;
}
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function $336d3dfe62d84a74$var$isLength(value) {
    return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= $336d3dfe62d84a74$var$MAX_SAFE_INTEGER;
}
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $336d3dfe62d84a74$var$isObject(value) {
    var type = typeof value;
    return !!value && (type == 'object' || type == 'function');
}
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $336d3dfe62d84a74$var$isObjectLike(value) {
    return !!value && typeof value == 'object';
}
/**
 * Checks if `value` is classified as a `String` primitive or object.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
 * @example
 *
 * _.isString('abc');
 * // => true
 *
 * _.isString(1);
 * // => false
 */ function $336d3dfe62d84a74$var$isString(value) {
    return typeof value == 'string' || !$336d3dfe62d84a74$var$isArray(value) && $336d3dfe62d84a74$var$isObjectLike(value) && $336d3dfe62d84a74$var$objectToString.call(value) == $336d3dfe62d84a74$var$stringTag;
}
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $336d3dfe62d84a74$var$isSymbol(value) {
    return typeof value == 'symbol' || $336d3dfe62d84a74$var$isObjectLike(value) && $336d3dfe62d84a74$var$objectToString.call(value) == $336d3dfe62d84a74$var$symbolTag;
}
/**
 * Converts `value` to an array.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {Array} Returns the converted array.
 * @example
 *
 * _.toArray({ 'a': 1, 'b': 2 });
 * // => [1, 2]
 *
 * _.toArray('abc');
 * // => ['a', 'b', 'c']
 *
 * _.toArray(1);
 * // => []
 *
 * _.toArray(null);
 * // => []
 */ function $336d3dfe62d84a74$var$toArray(value) {
    if (!value) return [];
    if ($336d3dfe62d84a74$var$isArrayLike(value)) return $336d3dfe62d84a74$var$isString(value) ? $336d3dfe62d84a74$var$stringToArray(value) : $336d3dfe62d84a74$var$copyArray(value);
    if ($336d3dfe62d84a74$var$iteratorSymbol && value[$336d3dfe62d84a74$var$iteratorSymbol]) return $336d3dfe62d84a74$var$iteratorToArray(value[$336d3dfe62d84a74$var$iteratorSymbol]());
    var tag = $336d3dfe62d84a74$var$getTag(value), func = tag == $336d3dfe62d84a74$var$mapTag ? $336d3dfe62d84a74$var$mapToArray : tag == $336d3dfe62d84a74$var$setTag ? $336d3dfe62d84a74$var$setToArray : $336d3dfe62d84a74$var$values;
    return func(value);
}
/**
 * Converts `value` to a finite number.
 *
 * @static
 * @memberOf _
 * @since 4.12.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted number.
 * @example
 *
 * _.toFinite(3.2);
 * // => 3.2
 *
 * _.toFinite(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toFinite(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toFinite('3.2');
 * // => 3.2
 */ function $336d3dfe62d84a74$var$toFinite(value) {
    if (!value) return value === 0 ? value : 0;
    value = $336d3dfe62d84a74$var$toNumber(value);
    if (value === $336d3dfe62d84a74$var$INFINITY || value === -$336d3dfe62d84a74$var$INFINITY) {
        var sign = value < 0 ? -1 : 1;
        return sign * $336d3dfe62d84a74$var$MAX_INTEGER;
    }
    return value === value ? value : 0;
}
/**
 * Converts `value` to an integer.
 *
 * **Note:** This method is loosely based on
 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted integer.
 * @example
 *
 * _.toInteger(3.2);
 * // => 3
 *
 * _.toInteger(Number.MIN_VALUE);
 * // => 0
 *
 * _.toInteger(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toInteger('3.2');
 * // => 3
 */ function $336d3dfe62d84a74$var$toInteger(value) {
    var result = $336d3dfe62d84a74$var$toFinite(value), remainder = result % 1;
    return result === result ? remainder ? result - remainder : result : 0;
}
/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */ function $336d3dfe62d84a74$var$toNumber(value) {
    if (typeof value == 'number') return value;
    if ($336d3dfe62d84a74$var$isSymbol(value)) return $336d3dfe62d84a74$var$NAN;
    if ($336d3dfe62d84a74$var$isObject(value)) {
        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
        value = $336d3dfe62d84a74$var$isObject(other) ? other + '' : other;
    }
    if (typeof value != 'string') return value === 0 ? value : +value;
    value = value.replace($336d3dfe62d84a74$var$reTrim, '');
    var isBinary = $336d3dfe62d84a74$var$reIsBinary.test(value);
    return isBinary || $336d3dfe62d84a74$var$reIsOctal.test(value) ? $336d3dfe62d84a74$var$freeParseInt(value.slice(2), isBinary ? 2 : 8) : $336d3dfe62d84a74$var$reIsBadHex.test(value) ? $336d3dfe62d84a74$var$NAN : +value;
}
/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */ function $336d3dfe62d84a74$var$keys(object) {
    return $336d3dfe62d84a74$var$isArrayLike(object) ? $336d3dfe62d84a74$var$arrayLikeKeys(object) : $336d3dfe62d84a74$var$baseKeys(object);
}
/**
 * Creates an array of the own enumerable string keyed property values of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property values.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.values(new Foo);
 * // => [1, 2] (iteration order is not guaranteed)
 *
 * _.values('hi');
 * // => ['h', 'i']
 */ function $336d3dfe62d84a74$var$values(object) {
    return object ? $336d3dfe62d84a74$var$baseValues(object, $336d3dfe62d84a74$var$keys(object)) : [];
}
$336d3dfe62d84a74$exports = $336d3dfe62d84a74$var$shuffle;


/* eslint-disable @repo/internal/react/require-jsdoc */ var $37b3839b25967d6a$export$2e2bcd8739ae039 = function(channel) {
    return function(payload) {
        return function(createAnalyticsEvent) {
            var consumerEvent = createAnalyticsEvent(payload);
            var clonedEvent = consumerEvent.clone();
            if (clonedEvent) clonedEvent.fire(channel);
            return consumerEvent;
        };
    };
};


var $kqp0i = parcelRequire("kqp0i");

var $25nEq = parcelRequire("25nEq");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");

var $5FkrB = parcelRequire("5FkrB");

var $dU8Y3 = parcelRequire("dU8Y3");

var $3ZMUU = parcelRequire("3ZMUU");
var $8c4111c5b5f87bd8$var$_process$env;
var /// <reference types="node" />
$8c4111c5b5f87bd8$export$2e2bcd8739ae039 = typeof $3ZMUU !== 'undefined' && $3ZMUU !== null && (($8c4111c5b5f87bd8$var$_process$env = {}, $8c4111c5b5f87bd8$var$_process$env === void 0) ? void 0 : $8c4111c5b5f87bd8$var$_process$env['ANALYTICS_NEXT_MODERN_CONTEXT']);



var $fC8ib = parcelRequire("fC8ib");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $kIXpt = parcelRequire("kIXpt");

var $cYPzS = parcelRequire("cYPzS");

var $eyuDe = parcelRequire("eyuDe");

var $25nEq = parcelRequire("25nEq");

var $5FkrB = parcelRequire("5FkrB");

var $8vJ0V = parcelRequire("8vJ0V");

var $iyyOp = parcelRequire("iyyOp");
function $adfe6f477584295a$var$_callSuper(t, o, e) {
    return o = (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(o), (0, (/*@__PURE__*/$parcel$interopDefault($kIXpt)))(t, $adfe6f477584295a$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(t).constructor) : o.apply(t, e));
}
function $adfe6f477584295a$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($adfe6f477584295a$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $adfe6f477584295a$var$ContextTypes = {
    getAtlaskitAnalyticsContext: (0, (/*@__PURE__*/$parcel$interopDefault($8vJ0V))).func,
    getAtlaskitAnalyticsEventHandlers: (0, (/*@__PURE__*/$parcel$interopDefault($8vJ0V))).func
};
var $adfe6f477584295a$var$noop = function noop() {
    return [];
};
// eslint-disable-next-line @repo/internal/react/no-class-components
var $adfe6f477584295a$var$AnalyticsContext = /*#__PURE__*/ function(_Component) {
    function AnalyticsContext(props) {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, AnalyticsContext);
        _this = $adfe6f477584295a$var$_callSuper(this, AnalyticsContext, [
            props
        ]);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "getChildContext", function() {
            return {
                getAtlaskitAnalyticsContext: _this.getAnalyticsContext
            };
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "getAnalyticsContext", function() {
            var data = _this.props.data;
            var _this$context$getAtla = _this.context.getAtlaskitAnalyticsContext, getAtlaskitAnalyticsContext = _this$context$getAtla === void 0 ? $adfe6f477584295a$var$noop : _this$context$getAtla;
            return [].concat((0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(getAtlaskitAnalyticsContext()), [
                data
            ]);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "getAnalyticsEventHandlers", function() {
            var _this$context$getAtla2 = _this.context.getAtlaskitAnalyticsEventHandlers, getAtlaskitAnalyticsEventHandlers = _this$context$getAtla2 === void 0 ? $adfe6f477584295a$var$noop : _this$context$getAtla2;
            return getAtlaskitAnalyticsEventHandlers();
        });
        _this.contextValue = {
            getAtlaskitAnalyticsContext: _this.getAnalyticsContext,
            getAtlaskitAnalyticsEventHandlers: _this.getAnalyticsEventHandlers
        };
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($eyuDe)))(AnalyticsContext, _Component);
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(AnalyticsContext, [
        {
            key: "render",
            value: function render() {
                var children = this.props.children;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $iyyOp.default).Provider, {
                    value: this.contextValue
                }, children);
            }
        }
    ]);
}((0, $5FkrB.Component));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($adfe6f477584295a$var$AnalyticsContext, "contextTypes", $adfe6f477584295a$var$ContextTypes);
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($adfe6f477584295a$var$AnalyticsContext, "childContextTypes", $adfe6f477584295a$var$ContextTypes);
var $adfe6f477584295a$export$2e2bcd8739ae039 = $adfe6f477584295a$var$AnalyticsContext;



var $fC8ib = parcelRequire("fC8ib");

var $5FkrB = parcelRequire("5FkrB");

var $iyyOp = parcelRequire("iyyOp");


var $ebefe9547976eb9d$var$AnalyticsContext = function AnalyticsContext(_ref) {
    var data = _ref.data, children = _ref.children;
    var dataRef = (0, $bc093c0471a9c62c$export$1d27a74659855e44)(data);
    var _useAnalyticsContext = (0, $198cc46d8348dafa$export$d1f587f82ad51c4)(), getAtlaskitAnalyticsEventHandlers = _useAnalyticsContext.getAtlaskitAnalyticsEventHandlers, getOriginalAnalyticsContext = _useAnalyticsContext.getAtlaskitAnalyticsContext;
    var getAtlaskitAnalyticsContext = (0, $5FkrB.useCallback)(function() {
        return [].concat((0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(getOriginalAnalyticsContext()), [
            dataRef.current
        ]);
    }, [
        getOriginalAnalyticsContext,
        dataRef
    ]);
    var value = (0, $5FkrB.useMemo)(function() {
        return {
            getAtlaskitAnalyticsContext: getAtlaskitAnalyticsContext,
            getAtlaskitAnalyticsEventHandlers: getAtlaskitAnalyticsEventHandlers
        };
    }, [
        getAtlaskitAnalyticsContext,
        getAtlaskitAnalyticsEventHandlers
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $iyyOp.default).Provider, {
        value: value
    }, children);
};
var $ebefe9547976eb9d$export$2e2bcd8739ae039 = $ebefe9547976eb9d$var$AnalyticsContext;


var $fc9d1ee8e29cc2d8$var$AnalyticsContext = function AnalyticsContext(props) {
    var isModernContext = (0, $8c4111c5b5f87bd8$export$2e2bcd8739ae039) || (0, $dU8Y3.fg)('analytics-next-use-legacy-context') === false;
    return isModernContext ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $ebefe9547976eb9d$export$2e2bcd8739ae039), props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $adfe6f477584295a$export$2e2bcd8739ae039), props);
};
var $fc9d1ee8e29cc2d8$export$2e2bcd8739ae039 = $fc9d1ee8e29cc2d8$var$AnalyticsContext;


var $f3c7ff6e742cb9cd$var$_excluded = [
    "analyticsContext"
];
function $f3c7ff6e742cb9cd$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $f3c7ff6e742cb9cd$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $f3c7ff6e742cb9cd$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $f3c7ff6e742cb9cd$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $f3c7ff6e742cb9cd$var$withAnalyticsContext = function withAnalyticsContext(defaultData) {
    return function(WrappedComponent) {
        var WithAnalyticsContext = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function(_ref, ref) {
            var analyticsContext = _ref.analyticsContext, rest = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $f3c7ff6e742cb9cd$var$_excluded);
            var analyticsData = (0, $5FkrB.useMemo)(function() {
                return $f3c7ff6e742cb9cd$var$_objectSpread($f3c7ff6e742cb9cd$var$_objectSpread({}, defaultData), analyticsContext);
            }, [
                analyticsContext
            ]);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $fc9d1ee8e29cc2d8$export$2e2bcd8739ae039), {
                data: analyticsData
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(WrappedComponent, (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, rest, {
                ref: ref
            })));
        });
        WithAnalyticsContext.displayName = "WithAnalyticsContext(".concat(WrappedComponent.displayName || WrappedComponent.name, ")");
        return WithAnalyticsContext;
    };
};
var $f3c7ff6e742cb9cd$export$2e2bcd8739ae039 = $f3c7ff6e742cb9cd$var$withAnalyticsContext;


var $kqp0i = parcelRequire("kqp0i");

var $5FkrB = parcelRequire("5FkrB");


var $25nEq = parcelRequire("25nEq");

var $ekGgq = parcelRequire("ekGgq");

var $5FkrB = parcelRequire("5FkrB");

function $41ae38aeaf9bb6bd$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $41ae38aeaf9bb6bd$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $41ae38aeaf9bb6bd$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $41ae38aeaf9bb6bd$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $41ae38aeaf9bb6bd$export$9ebb5a84d17e5d18() {
    var createEventMap = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var wrappedComponentProps = arguments.length > 1 ? arguments[1] : undefined;
    var _useAnalyticsEvents = (0, $57689e08a4ac98d0$export$5bf35293e545f20c)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
    var handlerCache = (0, $5FkrB.useRef)({});
    var patchedProps = (0, $5FkrB.useMemo)(function() {
        var cache = handlerCache.current;
        // Clean up no longer used handlers in cache
        Object.keys(cache).filter(function(key) {
            return !(key in createEventMap);
        }).forEach(function(key) {
            return delete cache[key];
        });
        return Object.keys(createEventMap).reduce(function(p, k) {
            var eventCreator = createEventMap[k];
            if (![
                'object',
                'function'
            ].includes((0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(eventCreator))) return p;
            var propValue = wrappedComponentProps[k];
            if (k in cache && cache[k].eventCreator === eventCreator && cache[k].propValue === propValue) return $41ae38aeaf9bb6bd$var$_objectSpread($41ae38aeaf9bb6bd$var$_objectSpread({}, p), {}, (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, k, cache[k].wrappedCallback));
            var wrappedCallback = function wrappedCallback() {
                var analyticsEvent = typeof eventCreator === 'function' ? eventCreator(createAnalyticsEvent, wrappedComponentProps) : createAnalyticsEvent(eventCreator);
                if (propValue && typeof propValue === 'function') {
                    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                    propValue.apply(void 0, args.concat([
                        analyticsEvent
                    ]));
                }
            };
            cache[k] = {
                eventCreator: eventCreator,
                wrappedCallback: wrappedCallback,
                propValue: propValue
            };
            return $41ae38aeaf9bb6bd$var$_objectSpread($41ae38aeaf9bb6bd$var$_objectSpread({}, p), {}, (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, k, wrappedCallback));
        }, {});
    }, [
        createEventMap,
        wrappedComponentProps,
        createAnalyticsEvent,
        handlerCache
    ]);
    return {
        patchedEventProps: patchedProps
    };
}


var $1fd824424b4b7dd4$var$withAnalyticsEvents = function withAnalyticsEvents() {
    var createEventMap = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return function(WrappedComponent) {
        var WithAnalyticsEvents = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function(props, ref) {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore: to unblock React 18.2.0 -> 18.3.1 version bump in Jira
            var _usePatchedProps = (0, $41ae38aeaf9bb6bd$export$9ebb5a84d17e5d18)(createEventMap, props), patchedEventProps = _usePatchedProps.patchedEventProps;
            var _useAnalyticsEvents = (0, $57689e08a4ac98d0$export$5bf35293e545f20c)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(WrappedComponent, (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, props, patchedEventProps, {
                createAnalyticsEvent: createAnalyticsEvent,
                ref: ref
            }));
        });
        WithAnalyticsEvents.displayName = "WithAnalyticsEvents(".concat(WrappedComponent.displayName || WrappedComponent.name, ")");
        return WithAnalyticsEvents;
    };
};
var $1fd824424b4b7dd4$export$2e2bcd8739ae039 = $1fd824424b4b7dd4$var$withAnalyticsEvents;



var $kqp0i = parcelRequire("kqp0i");

var $5FkrB = parcelRequire("5FkrB");

var $kqp0i = parcelRequire("kqp0i");
parcelRequire("dujqE");

var $ekGgq = parcelRequire("ekGgq");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $kIXpt = parcelRequire("kIXpt");

var $cYPzS = parcelRequire("cYPzS");

var $eyuDe = parcelRequire("eyuDe");

var $25nEq = parcelRequire("25nEq");

var $fC8ib = parcelRequire("fC8ib");

var $5FkrB = parcelRequire("5FkrB");

var $dJ32z = parcelRequire("dJ32z");

var $dU8Y3 = parcelRequire("dU8Y3");
/* eslint-disable @repo/internal/fs/filename-pattern-match */ var $5e499e1ed2b54346$export$f4da216a6ca54656 = function formatGroupLabel(group) {
    return group.label;
};
var $5e499e1ed2b54346$export$dac6ace3020563ca = function getOptionLabel(option) {
    return option.label;
};
var $5e499e1ed2b54346$export$40be908210c5a79c = function getOptionValue(option) {
    return option.value;
};
var $5e499e1ed2b54346$export$56bd0c8d90db075 = function isOptionDisabled(option) {
    return !!option.isDisabled;
};



var $25nEq = parcelRequire("25nEq");
/* containers.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $kqp0i = parcelRequire("kqp0i");

var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");

var $hUFig = parcelRequire("hUFig");

var $iYJcE = parcelRequire("iYJcE");

var $25nEq = parcelRequire("25nEq");

var $1Vcia = parcelRequire("1Vcia");

var $ekGgq = parcelRequire("ekGgq");
var $c6f45647f62090f7$var$_excluded = [
    "className",
    "clearValue",
    "cx",
    "xcss",
    "getStyles",
    "getClassNames",
    "getValue",
    "hasValue",
    "isMulti",
    "isRtl",
    "options",
    "selectOption",
    "selectProps",
    "setValue"
];
function $c6f45647f62090f7$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $c6f45647f62090f7$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $c6f45647f62090f7$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $c6f45647f62090f7$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $c6f45647f62090f7$export$8793edee2d425525 = function noop() {};
// ==============================
// Class Name Prefixer
// ==============================
/**
 * String representation of component state for styling with class names.
 *
 * Expects an array of strings OR a string/object pair:
 * - className(['comp', 'comp-arg', 'comp-arg-2'])
 * @returns 'react-select__comp react-select__comp-arg react-select__comp-arg-2'
 * - className('comp', { some: true, state: false })
 * @returns 'react-select__comp react-select__comp--some'
 */ function $c6f45647f62090f7$var$applyPrefixToName(prefix, name) {
    if (!name) return prefix;
    else if (name[0] === '-') return prefix + name;
    else return prefix + '__' + name;
}
function $c6f45647f62090f7$export$ce4ab0c55987d1ff(prefix, state) {
    for(var _len = arguments.length, classNameList = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)classNameList[_key - 2] = arguments[_key];
    var arr = [].concat(classNameList);
    if (state && prefix) {
        for(var key in state)if (state.hasOwnProperty(key) && state[key]) arr.push("".concat($c6f45647f62090f7$var$applyPrefixToName(prefix, key)));
    }
    return arr.filter(function(i) {
        return i;
    }).map(function(i) {
        return String(i).trim();
    }).join(' ');
}
var $c6f45647f62090f7$export$33f062f47f21a01 = function cleanValue(value) {
    if ($c6f45647f62090f7$var$isArray(value)) return value.filter(Boolean);
    if ((0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(value) === 'object' && value !== null) return [
        value
    ];
    return [];
};
var $c6f45647f62090f7$export$8e9fd4287627890c = function cleanCommonProps(props) {
    //className
    var className = props.className, clearValue = props.clearValue, cx = props.cx, xcss = props.xcss, getStyles = props.getStyles, getClassNames = props.getClassNames, getValue = props.getValue, hasValue = props.hasValue, isMulti = props.isMulti, isRtl = props.isRtl, options = props.options, selectOption = props.selectOption, selectProps = props.selectProps, setValue = props.setValue, innerProps = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(props, $c6f45647f62090f7$var$_excluded);
    return $c6f45647f62090f7$var$_objectSpread({}, innerProps);
};
var $c6f45647f62090f7$export$26417cabd806a658 = function getStyleProps(props, name, classNamesState) {
    var cx = props.cx, getStyles = props.getStyles, getClassNames = props.getClassNames, className = props.className;
    return {
        css: getStyles(name, props),
        className: cx(classNamesState !== null && classNamesState !== void 0 ? classNamesState : {}, getClassNames(name, props), className)
    };
};
function $c6f45647f62090f7$export$2096bae78ecda911(inputValue, actionMeta, onInputChange) {
    if (onInputChange) {
        var newValue = onInputChange(inputValue, actionMeta);
        if (typeof newValue === 'string') return newValue;
    }
    return inputValue;
}
function $c6f45647f62090f7$export$d8a62a489b442872(el) {
    return [
        document.documentElement,
        document.body,
        window
    ].indexOf(el) > -1;
}
function $c6f45647f62090f7$export$2e0654fad740d2e4(el) {
    if ($c6f45647f62090f7$export$d8a62a489b442872(el)) return window.innerHeight;
    return el.clientHeight;
}
function $c6f45647f62090f7$export$c4a223a8ba9e4ea5(el) {
    if ($c6f45647f62090f7$export$d8a62a489b442872(el)) return window.pageYOffset;
    return el.scrollTop;
}
function $c6f45647f62090f7$export$3f99968195accfaf(el, top) {
    // with a scroll distance, we perform scroll on the element
    if ($c6f45647f62090f7$export$d8a62a489b442872(el)) {
        window.scrollTo(0, top);
        return;
    }
    el.scrollTop = top;
}
function $c6f45647f62090f7$export$cfa2225e87938781(element) {
    var style = getComputedStyle(element);
    var excludeStaticParent = style.position === 'absolute';
    var overflowRx = /(auto|scroll)/;
    if (style.position === 'fixed') return document.documentElement;
    for(var parent = element; parent = parent.parentElement;){
        style = getComputedStyle(parent);
        if (excludeStaticParent && style.position === 'static') continue;
        if (overflowRx.test(style.overflow + style.overflowY + style.overflowX)) return parent;
    }
    return document.documentElement;
}
// Animated Scroll To
// ------------------------------
/**
 * @param t: time (elapsed)
 * @param b: initial value
 * @param c: amount of change
 * @param d: duration
 */ function $c6f45647f62090f7$var$easeOutCubic(t, b, c, d) {
    return c * ((t = t / d - 1) * t * t + 1) + b;
}
function $c6f45647f62090f7$export$858c30343199f3af(element, to) {
    var duration = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 200;
    var callback = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : $c6f45647f62090f7$export$8793edee2d425525;
    var start = $c6f45647f62090f7$export$c4a223a8ba9e4ea5(element);
    var change = to - start;
    var increment = 10;
    var currentTime = 0;
    function animateScroll() {
        currentTime += increment;
        var val = $c6f45647f62090f7$var$easeOutCubic(currentTime, start, change, duration);
        $c6f45647f62090f7$export$3f99968195accfaf(element, val);
        if (currentTime < duration) window.requestAnimationFrame(animateScroll);
        else callback(element);
    }
    animateScroll();
}
function $c6f45647f62090f7$export$53a0910f038337bd(menuEl, focusedEl) {
    var menuRect = menuEl.getBoundingClientRect();
    var focusedRect = focusedEl.getBoundingClientRect();
    var overScroll = focusedEl.offsetHeight / 3;
    if (focusedRect.bottom + overScroll > menuRect.bottom) $c6f45647f62090f7$export$3f99968195accfaf(menuEl, Math.min(focusedEl.offsetTop + focusedEl.clientHeight - menuEl.offsetHeight + overScroll, menuEl.scrollHeight));
    else if (focusedRect.top - overScroll < menuRect.top) $c6f45647f62090f7$export$3f99968195accfaf(menuEl, Math.max(focusedEl.offsetTop - overScroll, 0));
}
function $c6f45647f62090f7$export$7807c2a424c2f6d1(element) {
    var rect = element.getBoundingClientRect();
    return {
        bottom: rect.bottom,
        height: rect.height,
        left: rect.left,
        right: rect.right,
        top: rect.top,
        width: rect.width
    };
}
function $c6f45647f62090f7$export$56963d77dbffdde7() {
    try {
        document.createEvent('TouchEvent');
        return true;
    } catch (_unused) {
        return false;
    }
}
function $c6f45647f62090f7$export$44f917bf91becd01() {
    try {
        return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    } catch (_unused2) {
        return false;
    }
}
// ==============================
// Passive Event Detector
// ==============================
// https://github.com/rafgraph/detect-it/blob/main/src/index.ts#L19-L36
var $c6f45647f62090f7$var$passiveOptionAccessed = false;
var $c6f45647f62090f7$var$options = {
    get passive () {
        return $c6f45647f62090f7$var$passiveOptionAccessed = true;
    }
};
// check for SSR
var $c6f45647f62090f7$var$w = typeof window !== 'undefined' ? window : {};
if ($c6f45647f62090f7$var$w.addEventListener && $c6f45647f62090f7$var$w.removeEventListener) {
    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
    $c6f45647f62090f7$var$w.addEventListener('p', $c6f45647f62090f7$export$8793edee2d425525, $c6f45647f62090f7$var$options);
    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
    $c6f45647f62090f7$var$w.removeEventListener('p', $c6f45647f62090f7$export$8793edee2d425525, false);
}
var $c6f45647f62090f7$export$b0622a6911dbeaf5 = $c6f45647f62090f7$var$passiveOptionAccessed;
function $c6f45647f62090f7$export$aedb69ff3e31596c(item) {
    return item != null;
}
function $c6f45647f62090f7$var$isArray(arg) {
    return Array.isArray(arg);
}
function $c6f45647f62090f7$export$40fb9515c784cc3b(isMulti, multiValue, singleValue) {
    return isMulti ? multiValue : singleValue;
}
function $c6f45647f62090f7$export$dea4763e29237f4c(singleValue) {
    return singleValue;
}
function $c6f45647f62090f7$export$d1ca752ec761b95b(multiValue) {
    return multiValue;
}
var $c6f45647f62090f7$export$4213b25a1c4e877 = function removeProps(propsObj) {
    for(var _len2 = arguments.length, properties = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)properties[_key2 - 1] = arguments[_key2];
    var propsMap = Object.entries(propsObj).filter(function(_ref) {
        var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_ref, 1), key = _ref2[0];
        return !properties.includes(key);
    });
    return propsMap.reduce(function(newProps, _ref3) {
        var _ref4 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_ref3, 2), key = _ref4[0], val = _ref4[1];
        newProps[key] = val;
        return newProps;
    }, {});
};
var $c6f45647f62090f7$export$bf2eda47afa5f369 = function filterUnsupportedSelectors(styles) {
    var unsupportedSelectors = [
        ':',
        // pseudo-classes/elements
        '[',
        // attribute selectors
        '>',
        // child combinator
        '+',
        // adjacent sibling combinator
        '~',
        // general sibling combinator
        ' ',
        // descendant combinator
        '*',
        // universal selector
        '#',
        // ID selector
        '.',
        // class selector
        '@',
        // at-rules
        '&',
        // parent selector
        '|',
        // namespace separator
        '^',
        // starts with
        '$',
        // ends with
        '=' // equals
    ];
    return Object.keys(styles).reduce(function(filteredStyles, key) {
        if (!unsupportedSelectors.some(function(selector) {
            return key.includes(selector);
        })) filteredStyles[key] = styles[key];
        return filteredStyles;
    }, {});
};


var $4f917748c6c51291$export$949392aeaf7d2e3a = function containerCSS() {
    return {};
};
var $4f917748c6c51291$var$containerStyles = {
    default: "_11c81d4k _kqswh2mm _lcxv1rj4 _1tn2fhey",
    rtl: "_1eim1xrj",
    disabled: "_80om13gf"
};
var $4f917748c6c51291$export$446eebadefe1123b = function SelectContainer(props) {
    var children = props.children, innerProps = props.innerProps, isDisabled = props.isDisabled, isRtl = props.isRtl, xcss = props.xcss;
    var _getStyleProps = (0, $c6f45647f62090f7$export$26417cabd806a658)(props, 'container', {
        '--is-disabled': isDisabled,
        '--is-rtl': isRtl
    }), className = _getStyleProps.className, css = _getStyleProps.css;
    return /*#__PURE__*/ $5FkrB.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $970q7.default)([
            $4f917748c6c51291$var$containerStyles.default,
            isRtl && $4f917748c6c51291$var$containerStyles.rtl,
            isDisabled && $4f917748c6c51291$var$containerStyles.disabled,
            (0, $hUFig.cx)(className, xcss, '-container')
        ]),
        style: css
    }, innerProps), children);
};
var $4f917748c6c51291$export$47aec73c7aa6b9aa = function valueContainerCSS() {
    return {};
};
var $4f917748c6c51291$var$valueContainerStyles = {
    default: "_16jlkb7n _1o9zkb7n _i0dlf1ug _1reo15vq _18m915vq _4cvr1h6o _1e0c11p5 _1n261g80 _8am5i4x0 _kqswh2mm _ca0qv77o _u5f312x7 _n3tdv77o _19bv12x7",
    flex: "_1e0c1txw",
    compact: "_ca0qze3t _u5f312x7 _n3tdze3t _19bv12x7"
};
var $4f917748c6c51291$export$4dc9f58ad9a1a000 = function ValueContainer(props) {
    var children = props.children, innerProps = props.innerProps, isMulti = props.isMulti, hasValue = props.hasValue, isCompact = props.isCompact, xcss = props.xcss, controlShouldRenderValue = props.selectProps.controlShouldRenderValue;
    var _getStyleProps2 = (0, $c6f45647f62090f7$export$26417cabd806a658)(props, 'valueContainer', {
        'value-container': true,
        'value-container--is-multi': isMulti,
        'value-container--has-value': hasValue
    }), css = _getStyleProps2.css, className = _getStyleProps2.className;
    return /*#__PURE__*/ $5FkrB.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $970q7.default)([
            $4f917748c6c51291$var$valueContainerStyles.default,
            isMulti && hasValue && controlShouldRenderValue && $4f917748c6c51291$var$valueContainerStyles.flex,
            isCompact && $4f917748c6c51291$var$valueContainerStyles.compact,
            (0, $hUFig.cx)(className, xcss, '-ValueContainer')
        ]),
        style: css
    }, innerProps), children);
};
var $4f917748c6c51291$export$9d74e3c8b5868ad7 = function indicatorsContainerCSS() {
    return {};
};
var $4f917748c6c51291$var$indicatorContainerStyles = null;
var $4f917748c6c51291$export$d0ffd7e649cab6f = function IndicatorsContainer(props) {
    var children = props.children, innerProps = props.innerProps, xcss = props.xcss;
    var _getStyleProps3 = (0, $c6f45647f62090f7$export$26417cabd806a658)(props, 'indicatorsContainer', {
        indicators: true
    }), css = _getStyleProps3.css, className = _getStyleProps3.className;
    return /*#__PURE__*/ $5FkrB.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        className: (0, $970q7.default)([
            "_1e0c1txw _4cvr1h6o _1o9zidpf _1wpz1fhb _y4ti1b66",
            (0, $hUFig.cx)(className, xcss, '-IndicatorsContainer')
        ])
    }, innerProps), children);
};


/* control.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $kqp0i = parcelRequire("kqp0i");

var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");

var $hUFig = parcelRequire("hUFig");

var $dU8Y3 = parcelRequire("dU8Y3");

var $c40f4e2f8ec9aafa$var$styles = {
    default: "_12ji1r31 _1qu2glyw _12y3idpf _2rkofajl _v564r5cv _1h6drsbi _1dqonqa1 _189ee4h9 _4cvr1h6o _80om73ad _1e0c1txw _1n261g80 _1bah1yb4 _kqswh2mm _bfhk1j9a _1tke1ylp _1q51ze3t _y4tize3t _85i5ze3t _bozgze3t _15peftgi _1ke8ftgi _jaboglyw _1u6luvb6 _4cvxrsbi _123byq51 _d0altlke _irr3l4ek _1ogl1caj",
    defaultT26Shape: "_2rko1qi0",
    compact: "_1tkezwfg",
    invalid: "_1h6d1bqt _16qsizbr _1u6lizbr _4cvx1bqt",
    focusedInvalid: "_16qsvyy1",
    disabled: "_1h6dby5v _lcxvglyw _bfhkby5v _1u6l1s3b",
    focused: "_1h6d1v1w _bfhkr01l _16qsvyy1 _1u6lvyy1 _4cvx1v1w _irr3r01l",
    subtle: "_1h6d1j28 _bfhk1j28 _1u6l3sij",
    subtleFocused: "_bfhkvuon",
    none: "_1h6d1j28 _bfhk1j28 _1u6l3sij _4cvx1j28 _irr31j28"
};
var $c40f4e2f8ec9aafa$export$dbf350e5966cf602 = function css() {
    return {};
};
var $c40f4e2f8ec9aafa$var$Control = function Control(props) {
    var children = props.children, appearance = props.appearance, isCompact = props.isCompact, isDisabled = props.isDisabled, isFocused = props.isFocused, isInvalid = props.isInvalid, innerRef = props.innerRef, innerProps = props.innerProps, menuIsOpen = props.menuIsOpen, xcss = props.xcss;
    var _getStyleProps = (0, $c6f45647f62090f7$export$26417cabd806a658)(props, 'control', {
        control: true,
        'control--is-disabled': isDisabled,
        'control--is-focused': isFocused,
        'control--menu-is-open': menuIsOpen
    }), css = _getStyleProps.css, className = _getStyleProps.className;
    return /*#__PURE__*/ $5FkrB.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        ref: innerRef,
        className: (0, $970q7.default)([
            $c40f4e2f8ec9aafa$var$styles.default,
            (0, $dU8Y3.fg)('platform-dst-shape-theme-default') && $c40f4e2f8ec9aafa$var$styles.defaultT26Shape,
            isDisabled && $c40f4e2f8ec9aafa$var$styles.disabled,
            isInvalid && $c40f4e2f8ec9aafa$var$styles.invalid,
            isCompact && $c40f4e2f8ec9aafa$var$styles.compact,
            appearance === 'subtle' && $c40f4e2f8ec9aafa$var$styles.subtle,
            appearance === 'subtle' && isFocused && $c40f4e2f8ec9aafa$var$styles.subtleFocused,
            isFocused && $c40f4e2f8ec9aafa$var$styles.focused,
            appearance === 'none' && $c40f4e2f8ec9aafa$var$styles.none,
            (0, $hUFig.cx)(className, xcss, '-control')
        ]),
        style: css
    }, innerProps, {
        "aria-disabled": isDisabled || undefined
    }), children);
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$c40f4e2f8ec9aafa$export$2e2bcd8739ae039 = $c40f4e2f8ec9aafa$var$Control;


/* group.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $1Vcia = parcelRequire("1Vcia");

var $kqp0i = parcelRequire("kqp0i");

var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");

var $hUFig = parcelRequire("hUFig");

var $53cf7edb74ae36f8$var$_excluded = [
    "data"
];
var $53cf7edb74ae36f8$var$styles = {
    root: "_n3tdu2gc _ca0qu2gc"
};
var $53cf7edb74ae36f8$export$b6794329c1460634 = function groupCSS() {
    return {};
};
var $53cf7edb74ae36f8$var$Group = function Group(props) {
    var children = props.children, builtinCX = props.cx, getStyles = props.getStyles, getClassNames = props.getClassNames, Heading = props.Heading, headingProps = props.headingProps, innerProps = props.innerProps, label = props.label, selectProps = props.selectProps, xcss = props.xcss;
    var _getStyleProps = (0, $c6f45647f62090f7$export$26417cabd806a658)(props, 'group', {
        group: true
    }), css = _getStyleProps.css, className = _getStyleProps.className;
    return /*#__PURE__*/ $5FkrB.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css
    }, innerProps, {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $970q7.default)([
            $53cf7edb74ae36f8$var$styles.root,
            (0, $hUFig.cx)(className, xcss, innerProps === null || innerProps === void 0 ? void 0 : innerProps.className, '-Group')
        ])
    }), label && /*#__PURE__*/ $5FkrB.createElement(Heading, (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, headingProps, {
        selectProps: selectProps,
        getStyles: getStyles,
        getClassNames: getClassNames,
        cx: builtinCX
    }), label), /*#__PURE__*/ $5FkrB.createElement("div", null, children));
};
var $53cf7edb74ae36f8$var$headingStyles = null;
var $53cf7edb74ae36f8$export$e5a7fbb542efcb7d = function groupHeadingCSS() {
    return {};
};
var $53cf7edb74ae36f8$export$85c8b41a3cd87edc = function GroupHeading(props) {
    var xcss = props.xcss;
    var _cleanCommonProps = (0, $c6f45647f62090f7$export$8e9fd4287627890c)(props), data = _cleanCommonProps.data, innerProps = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_cleanCommonProps, $53cf7edb74ae36f8$var$_excluded);
    var _getStyleProps2 = (0, $c6f45647f62090f7$export$26417cabd806a658)(props, 'groupHeading', {
        'group-heading': true
    }), css = _getStyleProps2.css, className = _getStyleProps2.className;
    return /*#__PURE__*/ $5FkrB.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $970q7.default)([
            "_11c8wadc _1e0c1ule _syazazsu _80om73ad _k48pwu06 _6rthpd1z _y4tiutpp _bozgutpp _1p1dglyw",
            (0, $hUFig.cx)(className, xcss, '-group')
        ]),
        style: css
    }, innerProps));
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$53cf7edb74ae36f8$export$2e2bcd8739ae039 = $53cf7edb74ae36f8$var$Group;


/* indicators.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $25nEq = parcelRequire("25nEq");

var $1Vcia = parcelRequire("1Vcia");

var $kqp0i = parcelRequire("kqp0i");

var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");

var $hUFig = parcelRequire("hUFig");
var $c150c6015359071d$exports = {};
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d56e8662eb8a8d2462ec3a39ff3aa40b>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty($c150c6015359071d$exports, "__esModule", {
    value: true
});
$c150c6015359071d$exports.default = void 0;

var $c150c6015359071d$var$_react = $c150c6015359071d$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $c150c6015359071d$var$_baseNew = $c150c6015359071d$var$_interopRequireDefault((parcelRequire("k8BjC")));
function $c150c6015359071d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ChevronDown".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Do not use 16px chevrons within buttons, icon buttons, or dropdowns to maintain visual cohesion with ADS which uses 12px chevrons.
Known uses: Open dropdown menu, expanded tree item, collapse tree item
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c150c6015359071d$var$ChevronDownIcon = (props)=>/*#__PURE__*/ $c150c6015359071d$var$_react.default.createElement($c150c6015359071d$var$_baseNew.default, Object.assign({
        name: "ChevronDownIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="m14.53 6.03-6 6a.75.75 0 0 1-1.004.052l-.056-.052-6-6 1.06-1.06L8 10.44l5.47-5.47z"/>`
    }, props));
$c150c6015359071d$var$ChevronDownIcon.displayName = 'ChevronDownIcon';
var $c150c6015359071d$var$_default = $c150c6015359071d$exports.default = $c150c6015359071d$var$ChevronDownIcon;


var $22ee7b357a49397a$exports = {};
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3eb90e0e095210547df6d71f04e27a56>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty($22ee7b357a49397a$exports, "__esModule", {
    value: true
});
$22ee7b357a49397a$exports.default = void 0;

var $22ee7b357a49397a$var$_react = $22ee7b357a49397a$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $22ee7b357a49397a$var$_baseNew = $22ee7b357a49397a$var$_interopRequireDefault((parcelRequire("k8BjC")));
function $22ee7b357a49397a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "CrossCircle".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: clear text field, error status.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $22ee7b357a49397a$var$CrossCircleIcon = (props)=>/*#__PURE__*/ $22ee7b357a49397a$var$_react.default.createElement($22ee7b357a49397a$var$_baseNew.default, Object.assign({
        name: "CrossCircleIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0m4.03 5.03L9.06 8l2.97 2.97-1.06 1.06L8 9.06l-2.97 2.97-1.06-1.06L6.94 8 3.97 5.03l1.06-1.06L8 6.94l2.97-2.97z" clip-rule="evenodd"/>`
    }, props));
$22ee7b357a49397a$var$CrossCircleIcon.displayName = 'CrossCircleIcon';
var $22ee7b357a49397a$var$_default = $22ee7b357a49397a$exports.default = $22ee7b357a49397a$var$CrossCircleIcon;


/* inline.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $kqp0i = parcelRequire("kqp0i");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");

/* flex.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $kqp0i = parcelRequire("kqp0i");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");
var $2695cedaa453587e$var$_excluded = [
    "as",
    "role",
    "alignItems",
    "justifyContent",
    "gap",
    "columnGap",
    "rowGap",
    "children",
    "testId",
    "direction",
    "wrap",
    "xcss"
];
var $2695cedaa453587e$var$rowGapMap = {
    'space.0': "_1p57ze3t",
    'space.025': "_1p57v77o",
    'space.050': "_1p571b66",
    'space.075': "_1p5712x7",
    'space.100': "_1p57u2gc",
    'space.150': "_1p57utpp",
    'space.200': "_1p57pxbi",
    'space.250': "_1p57v47k",
    'space.300': "_1p571ejb",
    'space.400': "_1p57xy5q",
    'space.500': "_1p571jfw",
    'space.600': "_1p57oahv",
    'space.800': "_1p57xncg",
    'space.1000': "_1p571epz"
};
var $2695cedaa453587e$var$columnGapMap = {
    'space.0': "_gy1pze3t",
    'space.025': "_gy1pv77o",
    'space.050': "_gy1p1b66",
    'space.075': "_gy1p12x7",
    'space.100': "_gy1pu2gc",
    'space.150': "_gy1putpp",
    'space.200': "_gy1ppxbi",
    'space.250': "_gy1pv47k",
    'space.300': "_gy1p1ejb",
    'space.400': "_gy1pxy5q",
    'space.500': "_gy1p1jfw",
    'space.600': "_gy1poahv",
    'space.800': "_gy1pxncg",
    'space.1000': "_gy1p1epz"
};
var $2695cedaa453587e$var$justifyContentMap = {
    start: "_1bahv2br",
    center: "_1bah1h6o",
    end: "_1bahh9n0",
    'space-between': "_1bah1yb4",
    'space-around': "_1bah1b1v",
    'space-evenly': "_1bahitcz",
    stretch: "_1bah1fhb"
};
var $2695cedaa453587e$var$flexDirectionMap = {
    column: "_2lx21bp4",
    row: "_2lx2vrvc"
};
var $2695cedaa453587e$var$flexWrapMap = {
    wrap: "_1n261g80",
    nowrap: "_1n261q9c"
};
var $2695cedaa453587e$var$alignItemsMap = {
    start: "_4cvrv2br",
    center: "_4cvr1h6o",
    baseline: "_4cvr1q9y",
    end: "_4cvrh9n0",
    stretch: "_4cvr1fhb"
};
var $2695cedaa453587e$var$styles = {
    root: "_1e0c1txw _vchhusvi"
};
/**
 * __Flex__
 *
 * `Flex` is a primitive component that implements the CSS Flexbox API.
 *
 * - [Examples](https://atlassian.design/components/primitives/flex/examples)
 * - [Code](https://atlassian.design/components/primitives/flex/code)
 *
 * @example
 * ```tsx
 * // eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
 * import { Flex, Box } from '@atlaskit/primitives'
 *
 * const Component = () => (
 *   <Flex direction="column">
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *   </Flex>
 * )
 * ```
 */ var $2695cedaa453587e$var$Flex = /*#__PURE__*/ (0, $5FkrB.memo)(/*#__PURE__*/ (0, $5FkrB.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? 'div' : _ref$as, role = _ref.role, alignItems = _ref.alignItems, justifyContent = _ref.justifyContent, gap = _ref.gap, columnGap = _ref.columnGap, rowGap = _ref.rowGap, children = _ref.children, testId = _ref.testId, direction = _ref.direction, wrap = _ref.wrap, xcss = _ref.xcss, ariaAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $2695cedaa453587e$var$_excluded);
    return /*#__PURE__*/ $5FkrB.createElement(Component, (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, ariaAttributes, {
        role: role,
        className: (0, $970q7.default)([
            $2695cedaa453587e$var$styles.root,
            gap && $2695cedaa453587e$var$columnGapMap[gap],
            columnGap && $2695cedaa453587e$var$columnGapMap[columnGap],
            gap && $2695cedaa453587e$var$rowGapMap[gap],
            rowGap && $2695cedaa453587e$var$rowGapMap[rowGap],
            alignItems && $2695cedaa453587e$var$alignItemsMap[alignItems],
            direction && $2695cedaa453587e$var$flexDirectionMap[direction],
            justifyContent && $2695cedaa453587e$var$justifyContentMap[justifyContent],
            wrap && $2695cedaa453587e$var$flexWrapMap[wrap],
            xcss
        ]),
        "data-testid": testId,
        ref: ref
    }), children);
}));
$2695cedaa453587e$var$Flex.displayName = 'Flex';
var $2695cedaa453587e$export$2e2bcd8739ae039 = $2695cedaa453587e$var$Flex;


var $bcf51d45413e6fcb$var$_excluded = [
    "as",
    "alignInline",
    "alignBlock",
    "shouldWrap",
    "spread",
    "grow",
    "space",
    "rowSpace",
    "separator",
    "xcss",
    "testId",
    "role",
    "children"
];
var $bcf51d45413e6fcb$var$styles = {
    separator: "_1mouze3t _195g1i6y _syazjjyb _lcxvglyw _uiztglyw",
    hug: "_16jlidpf",
    fill: "_1bsb1osq _16jlkb7n"
};
var $bcf51d45413e6fcb$var$Separator = function Separator(_ref) {
    var children = _ref.children;
    return /*#__PURE__*/ $5FkrB.createElement("span", {
        className: (0, $970q7.default)([
            $bcf51d45413e6fcb$var$styles.separator
        ])
    }, children);
};
/**
 * __Inline__
 *
 * Inline is a primitive component based on CSS Flexbox that manages the horizontal layout of direct children.
 *
 * @example
 * ```tsx
 *  <Inline>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *  </Inline>
 * ```
 *
 */ var $bcf51d45413e6fcb$var$Inline = /*#__PURE__*/ (0, $5FkrB.memo)(/*#__PURE__*/ (0, $5FkrB.forwardRef)(function(_ref2, ref) {
    var as = _ref2.as, alignInline = _ref2.alignInline, _ref2$alignBlock = _ref2.alignBlock, alignItems = _ref2$alignBlock === void 0 ? 'start' : _ref2$alignBlock, _ref2$shouldWrap = _ref2.shouldWrap, shouldWrap = _ref2$shouldWrap === void 0 ? false : _ref2$shouldWrap, spread = _ref2.spread, grow = _ref2.grow, space = _ref2.space, rowSpace = _ref2.rowSpace, separator = _ref2.separator, xcss = _ref2.xcss, testId = _ref2.testId, role = _ref2.role, rawChildren = _ref2.children, ariaAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref2, $bcf51d45413e6fcb$var$_excluded);
    var separatorComponent = typeof separator === 'string' ? /*#__PURE__*/ $5FkrB.createElement($bcf51d45413e6fcb$var$Separator, null, separator) : separator;
    var children = separatorComponent ? (0, $5FkrB.Children).toArray(rawChildren).filter(Boolean).map(function(child, index) {
        return /*#__PURE__*/ $5FkrB.createElement((0, $5FkrB.Fragment), {
            key: index
        }, separator && index > 0 ? separatorComponent : null, child);
    }) : rawChildren;
    return /*#__PURE__*/ $5FkrB.createElement((0, $2695cedaa453587e$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, ariaAttributes, {
        as: as,
        role: role,
        alignItems: alignItems,
        justifyContent: spread || alignInline,
        direction: "row",
        gap: space,
        rowGap: rowSpace,
        wrap: shouldWrap ? 'wrap' : undefined,
        xcss: (0, $51c2ad1cc5d37be6$export$a274e22fb40f762e)(grow === 'hug' && $bcf51d45413e6fcb$var$styles.hug, grow === 'fill' && $bcf51d45413e6fcb$var$styles.fill, xcss),
        testId: testId,
        ref: ref
    }), children);
}));
$bcf51d45413e6fcb$var$Inline.displayName = 'Inline';
var $bcf51d45413e6fcb$export$2e2bcd8739ae039 = $bcf51d45413e6fcb$var$Inline;

/* pressable.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $kqp0i = parcelRequire("kqp0i");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");


var $hUFig = parcelRequire("hUFig");


var $dJ32z = parcelRequire("dJ32z");

var $eVb4V = parcelRequire("eVb4V");

var $eqVaP = parcelRequire("eqVaP");
/* focusable.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $kqp0i = parcelRequire("kqp0i");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");
var $3963eec8dec07451$var$_excluded = [
    "as",
    "children",
    "isInset",
    "testId",
    "style",
    "xcss"
], $3963eec8dec07451$var$_excluded2 = [
    "className"
];
var $3963eec8dec07451$var$focusRingStyles = null;
var $3963eec8dec07451$var$insetFocusRingStyles = null;
/**
 * __Focus ring__
 *
 * A focus ring visually indicates the currently focused item.
 *
 */ var $3963eec8dec07451$var$Focusable = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? 'button' : _ref$as, children = _ref.children, isInset = _ref.isInset, testId = _ref.testId, style = _ref.style, xcss = _ref.xcss, htmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $3963eec8dec07451$var$_excluded);
    // This is to remove className from safeHtmlAttributes
    // @ts-ignore -- not using expect since it causes issues with help-center local consumption - className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(htmlAttributes, $3963eec8dec07451$var$_excluded2);
    return /*#__PURE__*/ $5FkrB.createElement(Component, (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, safeHtmlAttributes, {
        // @ts-ignore Expression produces a union type that is too complex to represent. We may be able to narrow the type here but unsure.
        ref: ref,
        className: (0, $970q7.default)([
            "_ymio1r31 _ypr0glyw _zcxs1o36 _mizu194a _1ah3dkaa _ra3xnqa1 _128mdkaa _1cvmnqa1 _4davt94y",
            isInset && "_1ah31gjf _2mwq1gjf",
            xcss
        ]),
        style: style,
        "data-testid": testId
    }), children);
});
var $3963eec8dec07451$export$2e2bcd8739ae039 = $3963eec8dec07451$var$Focusable;


var $21ae1b99be8c2c1c$var$_excluded = [
    "children",
    "isDisabled",
    "type",
    "onClick",
    "interactionName",
    "componentName",
    "analyticsContext",
    "style",
    "testId",
    "xcss",
    "tabIndex"
], $21ae1b99be8c2c1c$var$_excluded2 = [
    "className"
];
var $21ae1b99be8c2c1c$var$styles = {
    root: "_19itglyw _vchhusvi _r06hglyw _80omtlke",
    disabled: "_80om13gf"
};
/**
 * __Pressable__
 *
 * A primitive for building custom buttons.
 *
 * - [Examples](https://atlassian.design/components/primitives/pressable/examples)
 * - [Code](https://atlassian.design/components/primitives/pressable/code)
 * - [Usage](https://atlassian.design/components/primitives/pressable/usage)
 */ var $21ae1b99be8c2c1c$var$Pressable = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function(_ref, ref) {
    var children = _ref.children, isDisabled = _ref.isDisabled, _ref$type = _ref.type, type = _ref$type === void 0 ? 'button' : _ref$type, _ref$onClick = _ref.onClick, providedOnClick = _ref$onClick === void 0 ? (0, $eVb4V.default) : _ref$onClick, interactionName = _ref.interactionName, componentName = _ref.componentName, analyticsContext = _ref.analyticsContext, style = _ref.style, testId = _ref.testId, xcss = _ref.xcss, tabIndex = _ref.tabIndex, htmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $21ae1b99be8c2c1c$var$_excluded);
    var interactionContext = (0, $5FkrB.useContext)((0, $eqVaP.default));
    var handleClick = (0, $5FkrB.useCallback)(function(e, analyticsEvent) {
        interactionContext && interactionContext.tracePress(interactionName, e.timeStamp);
        providedOnClick(e, analyticsEvent);
    }, [
        providedOnClick,
        interactionContext,
        interactionName
    ]);
    var onClick = (0, $e2c415d6ac5c0326$export$a4687b0234b40e28)({
        fn: handleClick,
        action: 'clicked',
        componentName: componentName || 'Pressable',
        packageName: "@atlaskit/primitives",
        packageVersion: "17.1.0",
        analyticsData: analyticsContext,
        actionSubject: 'button'
    });
    // This is to remove className from safeHtmlAttributes
    // @ts-expect-error className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(htmlAttributes, $21ae1b99be8c2c1c$var$_excluded2);
    return /*#__PURE__*/ $5FkrB.createElement((0, $3963eec8dec07451$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        as: "button",
        tabIndex: tabIndex !== null && tabIndex !== void 0 ? tabIndex : (0, $dJ32z.isSafari)() && !isDisabled ? 0 : undefined,
        style: style
    }, safeHtmlAttributes, {
        type: type,
        onClick: onClick,
        disabled: isDisabled,
        xcss: (0, $hUFig.cx)($21ae1b99be8c2c1c$var$styles.root, isDisabled && $21ae1b99be8c2c1c$var$styles.disabled, xcss),
        testId: testId,
        ref: ref
    }), children);
});
var $21ae1b99be8c2c1c$export$2e2bcd8739ae039 = $21ae1b99be8c2c1c$var$Pressable;


/* spinner.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $970q7 = parcelRequire("970q7");

var $5FkrB = parcelRequire("5FkrB");

var $eqVaP = parcelRequire("eqVaP");
// Reds
var $78a37bb51d460180$export$4b84fd0e2c617bd = '#FFEBE6';
var $78a37bb51d460180$export$b34b069eff244586 = '#FFBDAD';
var $78a37bb51d460180$export$be802dd0d8b57f35 = '#FF8F73';
var $78a37bb51d460180$export$60847d42f9da92a6 = '#FF7452';
var $78a37bb51d460180$export$4a7404f376229999 = '#FF5630';
var $78a37bb51d460180$export$2010d0fb4295b346 = '#DE350B';
var $78a37bb51d460180$export$2837b5a1a71d5c02 = '#BF2600';
var $78a37bb51d460180$export$8d9596b529bbb9cf = '#FFFAE6';
var $78a37bb51d460180$export$41060a744ab0b7ae = '#FFF0B3';
var $78a37bb51d460180$export$1cc05bbbf340e559 = '#FFE380';
var $78a37bb51d460180$export$5aae31392d72caaa = '#FFC400';
var $78a37bb51d460180$export$c6930421db9fa514 = '#FFAB00';
var $78a37bb51d460180$export$59619663aa6500fb = '#FF991F';
var $78a37bb51d460180$export$874739ea9e379ab6 = '#FF8B00';
var $78a37bb51d460180$export$8a6341c32b6a3ee6 = '#E3FCEF';
var $78a37bb51d460180$export$69a3bf21b9686c2b = '#ABF5D1';
var $78a37bb51d460180$export$afbce1382ec95f73 = '#79F2C0';
var $78a37bb51d460180$export$747d86715d4175de = '#57D9A3';
var $78a37bb51d460180$export$940e1f69e873f202 = '#36B37E';
var $78a37bb51d460180$export$a49394138f7b8e85 = '#00875A';
var $78a37bb51d460180$export$6fa04827ac68a4fb = '#006644';
var $78a37bb51d460180$export$226de0355ed012f8 = '#DEEBFF';
var $78a37bb51d460180$export$8c13c2ee36917869 = '#B3D4FF';
var $78a37bb51d460180$export$ecfc1dff386a3e7a = '#4C9AFF';
var $78a37bb51d460180$export$215b7063051591f1 = '#2684FF';
var $78a37bb51d460180$export$e62e8919cca44969 = '#0065FF';
var $78a37bb51d460180$export$b3de0ae08da2ce64 = '#0052CC';
var $78a37bb51d460180$export$a6ee3d71bc067634 = '#0747A6';
var $78a37bb51d460180$export$67f15409e87642a1 = '#669DF1';
var $78a37bb51d460180$export$f0539dbc42dbb067 = '#8FB8F6';
var $78a37bb51d460180$export$363e4475840015bb = '#EAE6FF';
var $78a37bb51d460180$export$4b0a4417ed59760f = '#C0B6F2';
var $78a37bb51d460180$export$6011520a64d9a187 = '#998DD9';
var $78a37bb51d460180$export$a7175d4e9206bc80 = '#8777D9';
var $78a37bb51d460180$export$b48405b95304b5a1 = '#6554C0';
var $78a37bb51d460180$export$c71e4279dd54a18d = '#5243AA';
var $78a37bb51d460180$export$147899de772240ec = '#403294';
var $78a37bb51d460180$export$2cf711fe14c66f06 = '#E6FCFF';
var $78a37bb51d460180$export$7a8f4d33f6f9772c = '#B3F5FF';
var $78a37bb51d460180$export$776c9c497ef08533 = '#79E2F2';
var $78a37bb51d460180$export$69cb3ca10c1e330e = '#00C7E6';
var $78a37bb51d460180$export$9dc1ef0f3f48059b = '#00B8D9';
var $78a37bb51d460180$export$7c835c78b6fcdef8 = '#00A3BF';
var $78a37bb51d460180$export$6036577f95c3877e = '#008DA6';
var $78a37bb51d460180$export$29a4f05edc054374 = '#FFFFFF';
var $78a37bb51d460180$export$e655ef011c4aa1a2 = '#FAFBFC';
var $78a37bb51d460180$export$9fdfb749e33cdf97 = '#F4F5F7';
var $78a37bb51d460180$export$3e51e8f1440314ba = '#EBECF0';
var $78a37bb51d460180$export$1ce2d1575d444ceb = '#DFE1E6';
var $78a37bb51d460180$export$8754fc7e6d8b3000 = '#C1C7D0';
var $78a37bb51d460180$export$c2e91cbeada39b8b = '#B3BAC5';
var $78a37bb51d460180$export$5f71e19f3a7ad9de = '#A5ADBA';
var $78a37bb51d460180$export$eaa8c8a70ac22806 = '#97A0AF';
var $78a37bb51d460180$export$7c87d337fb91a97d = '#8993A4';
var $78a37bb51d460180$export$d6447c357493214f = '#7A869A';
var $78a37bb51d460180$export$f563ee71e9ee74cd = '#6B778C';
var $78a37bb51d460180$export$e2ef2124cf4024b1 = '#5E6C84';
var $78a37bb51d460180$export$eece5f492e429f08 = '#505F79';
var $78a37bb51d460180$export$c39c0fe0f26207ae = '#42526E';
var $78a37bb51d460180$export$7090862dc3038a9f = '#344563';
var $78a37bb51d460180$export$ad0bacf983b7ddaa = '#253858';
var $78a37bb51d460180$export$7d61b15e0da132af = '#172B4D';
var $78a37bb51d460180$export$fbda843f0a27fe96 = '#091E42';
var $78a37bb51d460180$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
var $78a37bb51d460180$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
var $78a37bb51d460180$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
var $78a37bb51d460180$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
var $78a37bb51d460180$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
var $78a37bb51d460180$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
var $78a37bb51d460180$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
var $78a37bb51d460180$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
var $78a37bb51d460180$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
var $78a37bb51d460180$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
var $78a37bb51d460180$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
var $78a37bb51d460180$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
var $78a37bb51d460180$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
var $78a37bb51d460180$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
var $78a37bb51d460180$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
var $78a37bb51d460180$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
var $78a37bb51d460180$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
var $78a37bb51d460180$export$2f6319cf7d736c2a = '#E6EDFA';
var $78a37bb51d460180$export$95126bc8884d6634 = '#DCE5F5';
var $78a37bb51d460180$export$8338d8c35d44ff1 = '#CED9EB';
var $78a37bb51d460180$export$5368d76ae4fbbda7 = '#B8C7E0';
var $78a37bb51d460180$export$9f0a771d16ec8d36 = '#ABBBD6';
var $78a37bb51d460180$export$abcf8c38338b4aa5 = '#9FB0CC';
var $78a37bb51d460180$export$97e81faa16a182c7 = '#8C9CB8';
var $78a37bb51d460180$export$bfe21c59123ecf33 = '#7988A3';
var $78a37bb51d460180$export$ee82aa2ea6a1558 = '#67758F';
var $78a37bb51d460180$export$682927c6ed76be02 = '#56637A';
var $78a37bb51d460180$export$91fd9994c5be9757 = '#455166';
var $78a37bb51d460180$export$d281fbfe3cff2df6 = '#3B475C';
var $78a37bb51d460180$export$3902c91d8b98a753 = '#313D52';
var $78a37bb51d460180$export$8e8133c1ba5845b5 = '#283447';
var $78a37bb51d460180$export$33ff357f6620b39 = '#202B3D';
var $78a37bb51d460180$export$633847cf062b69e0 = '#1B2638';
var $78a37bb51d460180$export$9776a6e503bdbf76 = '#121A29';
var $78a37bb51d460180$export$6c813d5160dff5db = '#0E1624';
var $78a37bb51d460180$export$3d4f271a500072a = '#0D1424';
var $78a37bb51d460180$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
var $78a37bb51d460180$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
var $78a37bb51d460180$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
var $78a37bb51d460180$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
var $78a37bb51d460180$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
var $78a37bb51d460180$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
var $78a37bb51d460180$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
var $78a37bb51d460180$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
var $78a37bb51d460180$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
var $78a37bb51d460180$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
var $78a37bb51d460180$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
var $78a37bb51d460180$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
var $78a37bb51d460180$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
var $78a37bb51d460180$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
var $78a37bb51d460180$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
var $78a37bb51d460180$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
var $78a37bb51d460180$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';
var $78a37bb51d460180$export$d2adc5dedf09fced = '#292A2E';
var $78a37bb51d460180$export$f51762073d2bb381 = '#94C748';
var $78a37bb51d460180$export$95e26d54def96891 = '#B3DF72';


var $91619096e141467f$export$4e9f1640bbe7a1a8 = {
    xsmall: 12,
    small: 16,
    medium: 24,
    large: 48,
    xlarge: 96
};


/**
 * Returns the appropriate circle stroke color.
 */ function $bc6b39f2ac546666$var$getStrokeColor(appearance) {
    return appearance === 'inherit' ? "var(--ds-icon-subtle, ".concat((0, $78a37bb51d460180$export$c39c0fe0f26207ae), ")") : "var(--ds-icon-inverse, ".concat((0, $78a37bb51d460180$export$29a4f05edc054374), ")");
}
var $bc6b39f2ac546666$var$rotate = null;
/**
 * There are three parts to the load in animation:
 * 1. Accelerated spin
 * 2. Stretch the spinner line
 */ var $bc6b39f2ac546666$var$loadIn = null;
var $bc6b39f2ac546666$var$styles = {
    rotateStyles: "_j7hqsf8s _5sag12kz _tip812c5 _1pgl2qsq _8hrz1h6o",
    loadInStyles: "_j7hq1ky6 _5sag9cwz _1pgl1ytf _1o51q7pw",
    wrapperStyles: "_1e0c116y _s7n4nkob",
    circleStyles: "_lswuglyw _7ljx1dhp _1snbbs82 _jcxd7g3v _1tjm1onz"
};
/**
 * `useLayoutEffect` is being used in SSR safe form. On the server, this work doesn’t need to run.
 * `useEffect` is used in-place, because `useEffect` is not run on the server and it matches types
 * which makes things simpler than doing an `isServer` check or a `null` check.
 *
 * @see https://hello.atlassian.net/wiki/spaces/DST/pages/2081696628/DSTDACI-010+-+Interaction+Tracing+hooks+in+DS+components
 */ var $bc6b39f2ac546666$var$useLayoutEffect = typeof window === 'undefined' ? (0, $5FkrB.useEffect) : (0, $5FkrB.useLayoutEffect);
/**
 * __Spinner__
 *
 * A spinner is an animated spinning icon that lets users know content is being loaded.
 *
 * - [Examples](https://atlassian.design/components/spinner/examples)
 * - [Code](https://atlassian.design/components/spinner/code)
 * - [Usage](https://atlassian.design/components/spinner/usage)
 */ var $bc6b39f2ac546666$var$Spinner = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).forwardRef(function Spinner(_ref, ref) {
    var _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'inherit' : _ref$appearance, _ref$delay = _ref.delay, delay = _ref$delay === void 0 ? 0 : _ref$delay, interactionName = _ref.interactionName, label = _ref.label, _ref$size = _ref.size, providedSize = _ref$size === void 0 ? 'medium' : _ref$size, testId = _ref.testId;
    var size = typeof providedSize === 'number' ? providedSize : (0, $91619096e141467f$export$4e9f1640bbe7a1a8)[providedSize];
    var animationDelay = "".concat(delay, "ms");
    var stroke = $bc6b39f2ac546666$var$getStrokeColor(appearance);
    var context = (0, $5FkrB.useContext)((0, $eqVaP.default));
    $bc6b39f2ac546666$var$useLayoutEffect(function() {
        if (context != null) return context.hold(interactionName);
    }, [
        context,
        interactionName
    ]);
    /**
   * The Spinner animation uses a combination of two
   * css animations on two separate elements.
   */ return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("span", {
        "data-testid": testId ? "".concat(testId, "-wrapper") : 'spinner-wrapper',
        style: {
            animationDelay: animationDelay,
            width: size,
            height: size
        },
        className: (0, $970q7.default)([
            $bc6b39f2ac546666$var$styles.wrapperStyles,
            $bc6b39f2ac546666$var$styles.rotateStyles
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("svg", {
        height: size,
        width: size,
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg",
        "data-testid": testId,
        ref: ref,
        "aria-label": label || undefined,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            animationDelay: animationDelay
        },
        role: label ? 'img' : 'none',
        className: (0, $970q7.default)([
            $bc6b39f2ac546666$var$styles.loadInStyles
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("circle", {
        cx: "8",
        cy: "8",
        r: "7",
        style: {
            stroke: stroke
        },
        className: (0, $970q7.default)([
            $bc6b39f2ac546666$var$styles.circleStyles
        ])
    })));
}));
var $bc6b39f2ac546666$export$2e2bcd8739ae039 = $bc6b39f2ac546666$var$Spinner;



var $7c6d514c13224b5d$var$_excluded = [
    "innerProps",
    "isRtl",
    "size",
    "isCompact",
    "xcss"
];
function $7c6d514c13224b5d$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $7c6d514c13224b5d$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $7c6d514c13224b5d$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $7c6d514c13224b5d$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
// ==============================
// Dropdown & Clear Icons
// ==============================
var $7c6d514c13224b5d$var$iconContainerStyles = {
    root: "_kkk2n7od _12ji1r31 _1qu219ly _12y31o36 _1e0c1txw _4cvr1h6o _1bah1h6o _1q51v77o _y4tiv77o _85i5v77o _bozgv77o"
};
var $7c6d514c13224b5d$var$dropdownWrapperStyles = {
    root: "_1q5112x7 _y4ti12x7 _85i512x7 _bozg12x7"
};
// ==============================
// Dropdown & Clear Buttons
// ==============================
var $7c6d514c13224b5d$var$dropdownStyles = {
    default: "_v564vrg3 _1e0c1txw _syazazsu _1q5112x7 _y4tiv77o _85i512x7 _bozgv77o _30l3azsu",
    compact: "_1q51idpf _85i5idpf",
    disabled: "_syaz1gmx"
};
var $7c6d514c13224b5d$export$e1687335805e1230 = function dropdownIndicatorCSS() {
    return {};
};
var $7c6d514c13224b5d$export$ec98719d3db7f2e4 = function DropdownIndicator(props) {
    var innerProps = props.innerProps, children = props.children, isDisabled = props.isDisabled, isCompact = props.isCompact, xcss = props.xcss;
    var _getStyleProps = (0, $c6f45647f62090f7$export$26417cabd806a658)(props, 'dropdownIndicator', {
        indicator: true,
        'dropdown-indicator': true
    }), css = _getStyleProps.css, className = _getStyleProps.className;
    return /*#__PURE__*/ $5FkrB.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        className: (0, $970q7.default)([
            $7c6d514c13224b5d$var$dropdownStyles.default,
            isDisabled && $7c6d514c13224b5d$var$dropdownStyles.disabled,
            isCompact && $7c6d514c13224b5d$var$dropdownStyles.compact,
            (0, $hUFig.cx)(className, xcss, '-indicatorContainer')
        ])
    }, innerProps), children ? children : /*#__PURE__*/ $5FkrB.createElement((0, $bcf51d45413e6fcb$export$2e2bcd8739ae039), {
        as: "span",
        xcss: $7c6d514c13224b5d$var$dropdownWrapperStyles.root
    }, /*#__PURE__*/ $5FkrB.createElement((0, (/*@__PURE__*/$parcel$interopDefault($c150c6015359071d$exports))), {
        color: "currentColor",
        label: "open",
        size: "small"
    })));
};
var $7c6d514c13224b5d$export$9c0419fd944c1def = function clearIndicatorCSS() {
    return {};
};
var $7c6d514c13224b5d$var$clearIndicatorStyles = {
    default: "_v564vrg3 _1e0c1txw _syaz1rpy _1q5112x7 _y4tiv77o _85i512x7 _bozgv77o _30l3azsu",
    compact: "_1q51idpf _85i5idpf"
};
var $7c6d514c13224b5d$export$ecf9cf59142dd54a = function ClearIndicator(props) {
    var innerProps = props.innerProps, _props$clearControlLa = props.clearControlLabel, clearControlLabel = _props$clearControlLa === void 0 ? 'clear' : _props$clearControlLa, isCompact = props.isCompact, xcss = props.xcss;
    var _getStyleProps2 = (0, $c6f45647f62090f7$export$26417cabd806a658)(props, 'clearIndicator', {
        indicator: true,
        'clear-indicator': true
    }), css = _getStyleProps2.css, className = _getStyleProps2.className;
    return /*#__PURE__*/ $5FkrB.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        className: (0, $970q7.default)([
            $7c6d514c13224b5d$var$clearIndicatorStyles.default,
            isCompact && $7c6d514c13224b5d$var$clearIndicatorStyles.compact,
            (0, $hUFig.cx)(className, xcss, '-indicatorContainer')
        ])
    }, innerProps), /*#__PURE__*/ $5FkrB.createElement((0, $21ae1b99be8c2c1c$export$2e2bcd8739ae039), {
        xcss: $7c6d514c13224b5d$var$iconContainerStyles.root,
        tabIndex: -1,
        "aria-label": clearControlLabel
    }, /*#__PURE__*/ $5FkrB.createElement((0, (/*@__PURE__*/$parcel$interopDefault($22ee7b357a49397a$exports))), {
        label: "",
        color: "currentColor",
        size: "small"
    })));
};
var $7c6d514c13224b5d$export$1d3f24cde248e6b5 = function loadingIndicatorCSS() {
    return {};
};
var $7c6d514c13224b5d$var$loadingIndicatorStyles = {
    default: "_1q5112x7 _y4tiu2gc _85i512x7 _bozgu2gc",
    compact: "_1q51idpf _85i5idpf"
};
var $7c6d514c13224b5d$export$7c20be4c1d342248 = function LoadingIndicator(_ref) {
    var innerProps = _ref.innerProps, isRtl = _ref.isRtl, _ref$size = _ref.size, size = _ref$size === void 0 ? 4 : _ref$size, isCompact = _ref.isCompact, xcss = _ref.xcss, restProps = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $7c6d514c13224b5d$var$_excluded);
    var _getStyleProps3 = (0, $c6f45647f62090f7$export$26417cabd806a658)($7c6d514c13224b5d$var$_objectSpread($7c6d514c13224b5d$var$_objectSpread({}, restProps), {}, {
        innerProps: innerProps,
        isRtl: isRtl,
        size: size
    }), 'loadingIndicator', {
        indicator: true,
        'loading-indicator': true
    }), css = _getStyleProps3.css, className = _getStyleProps3.className;
    return /*#__PURE__*/ $5FkrB.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        className: (0, $970q7.default)([
            $7c6d514c13224b5d$var$loadingIndicatorStyles.default,
            isCompact && $7c6d514c13224b5d$var$loadingIndicatorStyles.compact,
            (0, $hUFig.cx)(className, xcss, '-loadingIndicator')
        ])
    }, innerProps), /*#__PURE__*/ $5FkrB.createElement((0, $bc6b39f2ac546666$export$2e2bcd8739ae039), {
        size: "small"
    }));
};


/* input.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $kqp0i = parcelRequire("kqp0i");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");

var $hUFig = parcelRequire("hUFig");

var $dU8Y3 = parcelRequire("dU8Y3");

var $6464be408c5bbddb$var$_excluded = [
    "innerRef",
    "isDisabled",
    "isHidden",
    "inputClassName",
    "testId"
];
var $6464be408c5bbddb$export$14a7781d0ca7abea = function inputCSS() {
    return {};
};
var $6464be408c5bbddb$var$inputStylesOld = {
    root: "_16jlkb7n _1o9zkb7n _i0dl1wug _nd5l1sux _1mouv77o _195gv77o _1rjcv77o _1e0c1n7u _yv0e12qd _syazi7uo _j8d6idpf _1av2idpf _1doyidpf _pfztidpf _uoe3idpf _1recidpf _70xridpf _1k96idpf _eq43idpf _1h9u1kw7 _ckog1yjy _1x651r31 _1nn4glyw _1rzeidpf _1yd8yh40 _aetr11ps _uy7x15vq _1qjlqvpr",
    disabled: "_3um015vq"
};
var $6464be408c5bbddb$var$inputStyles = {
    root: "_16jlkb7n _1o9zkb7n _i0dl1wug _nd5l1sux _1mouv77o _195gv77o _1rjcv77o _kqswh2mm _1e0c1txw _yv0e12qd _syazi7uo _j8d6idpf _1av2idpf _1doyidpf _pfztidpf _uoe3idpf _1recidpf _70xridpf _1k96idpf _eq43idpf _1h9u1kw7 _ckog1yjy _1x651r31 _1nn4glyw _1rzeidpf _1yd8yh40 _aetr11ps _uy7x15vq _1qjlqvpr",
    disabled: "_3um015vq"
};
var $6464be408c5bbddb$var$nativeInputStylesOld = null;
var $6464be408c5bbddb$var$nativeInputStyles = null;
var $6464be408c5bbddb$var$hidden = null;
var $6464be408c5bbddb$var$Input = function Input(props) {
    var builtinCX = props.cx, value = props.value, xcss = props.xcss;
    var _cleanCommonProps = (0, $c6f45647f62090f7$export$8e9fd4287627890c)(props), innerRef = _cleanCommonProps.innerRef, isDisabled = _cleanCommonProps.isDisabled, isHidden = _cleanCommonProps.isHidden, inputClassName = _cleanCommonProps.inputClassName, testId = _cleanCommonProps.testId, innerProps = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_cleanCommonProps, $6464be408c5bbddb$var$_excluded);
    var dataId = testId ? "".concat(testId, "-select--input") : null;
    var _getStyleProps = (0, $c6f45647f62090f7$export$26417cabd806a658)(props, 'input', {
        'input-container': true
    }), css = _getStyleProps.css, className = _getStyleProps.className;
    if ((0, $dU8Y3.fg)('platform_do_not_clear_input_for_multiselect')) return /*#__PURE__*/ $5FkrB.createElement("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        className: (0, $970q7.default)([
            $6464be408c5bbddb$var$inputStyles.root,
            isDisabled && $6464be408c5bbddb$var$inputStyles.disabled,
            (0, $hUFig.cx)(className, xcss, '-Input')
        ]),
        "data-value": value || '',
        "data-testid": dataId && "".concat(dataId, "-container")
    }, /*#__PURE__*/ $5FkrB.createElement("input", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $970q7.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1r04idpf _11q7idpf _19itidpf _11c81kw7 _nd5l1yjy _12ji1r31 _1qu2glyw _12y3idpf _1bsb1osq _1ul9yh40 _kqswstnw _syaz1kw7 _tzy4kb7n",
            isHidden && "_tzy4idpf",
            builtinCX({
                input: true
            }, inputClassName, '-input')
        ]),
        ref: innerRef,
        disabled: isDisabled,
        "data-testid": dataId
    }, innerProps)));
    return /*#__PURE__*/ $5FkrB.createElement("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        className: (0, $970q7.default)([
            $6464be408c5bbddb$var$inputStylesOld.root,
            isDisabled && $6464be408c5bbddb$var$inputStylesOld.disabled,
            (0, $hUFig.cx)(className, xcss, '-Input')
        ]),
        "data-value": value || '',
        "data-testid": dataId && "".concat(dataId, "-container")
    }, /*#__PURE__*/ $5FkrB.createElement("input", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $970q7.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _11q7idpf _19itidpf _11c81kw7 _nd5l1yjy _12ji1r31 _1qu2glyw _12y3idpf _1bsb1osq _1ul9yh40 _syaz1kw7 _tzy4kb7n",
            isHidden && "_tzy4idpf",
            builtinCX({
                input: true
            }, inputClassName, '-input')
        ]),
        ref: innerRef,
        disabled: isDisabled,
        "data-testid": dataId
    }, innerProps)));
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$6464be408c5bbddb$export$2e2bcd8739ae039 = $6464be408c5bbddb$var$Input;


/* menu.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $1Vcia = parcelRequire("1Vcia");

var $kqp0i = parcelRequire("kqp0i");

var $25nEq = parcelRequire("25nEq");

var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");

var $hUFig = parcelRequire("hUFig");

var $6I9SI = parcelRequire("6I9SI");

var $aLeHs = parcelRequire("aLeHs");

var $g8g1T = parcelRequire("g8g1T");

var $dU8Y3 = parcelRequire("dU8Y3");
/* text.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");

var $afMOk = parcelRequire("afMOk");

var $5FkrB = parcelRequire("5FkrB");
var $1f8dbd7d91f9c6c2$var$HasTextAncestorContext = /*#__PURE__*/ (0, $5FkrB.createContext)(false);
var $1f8dbd7d91f9c6c2$export$9322276ec105d055 = function useHasTextAncestor() {
    return (0, $5FkrB.useContext)($1f8dbd7d91f9c6c2$var$HasTextAncestorContext);
};
var $1f8dbd7d91f9c6c2$export$ae933c6cbe5643ad = $1f8dbd7d91f9c6c2$var$HasTextAncestorContext.Provider;



var $5FkrB = parcelRequire("5FkrB");
var $8407c88bdc456fbd$export$1ca2a26fecb070ae = /*#__PURE__*/ (0, $5FkrB.createContext)('elevation.surface');
var $8407c88bdc456fbd$export$1aeb4f6b93c4540d = function useSurface() {
    return (0, $5FkrB.useContext)($8407c88bdc456fbd$export$1ca2a26fecb070ae);
};
$8407c88bdc456fbd$export$1ca2a26fecb070ae.displayName = 'SurfaceProvider';


var $3e631f986b84a440$var$asAllowlist = [
    'span',
    'p',
    'strong',
    'em'
];
/**
 * Custom hook designed to abstract the parsing of the color props and make it clearer in the future how color is reconciled between themes and tokens.
 */ var $3e631f986b84a440$var$useColor = function useColor(colorProp, hasTextAncestor) {
    var surface = (0, $8407c88bdc456fbd$export$1aeb4f6b93c4540d)();
    if (colorProp === 'inherit') return undefined;
    if (colorProp) return colorProp;
    if (hasTextAncestor) return undefined;
    if ($3e631f986b84a440$export$2185ce37f9bdd963.hasOwnProperty(surface)) return $3e631f986b84a440$export$2185ce37f9bdd963[surface];
    return 'color.text';
};
var $3e631f986b84a440$var$styles = {
    root: "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _1i4qfg65",
    'as.strong': "_k48pwu06",
    'as.em': "_zg8l1m30",
    'textAlign.center': "_y3gn1h6o",
    'textAlign.end': "_y3gnh9n0",
    'textAlign.start': "_y3gnv2br",
    truncation: "_1reo15vq _18m915vq _1e0ccj1k _sudp1e54",
    breakAll: "_1nmz9jpi"
};
var $3e631f986b84a440$var$fontSizeMap = {
    medium: "_11c8fhey",
    UNSAFE_small: "_11c8rymc",
    large: "_11c81d4k",
    small: "_11c8wadc"
};
var $3e631f986b84a440$var$fontWeightMap = {
    bold: "_k48pwu06",
    medium: "_k48p1wq8",
    regular: "_k48pi7a9",
    semibold: "_k48p1pd9"
};
var $3e631f986b84a440$var$textColorMap = {
    'color.text': "_syazi7uo",
    'color.text.accent.lime': "_syaz1tco",
    'color.text.accent.lime.bolder': "_syaz1ik3",
    'color.text.accent.red': "_syaz9lu1",
    'color.text.accent.red.bolder': "_syazhwvp",
    'color.text.accent.orange': "_syazp1lv",
    'color.text.accent.orange.bolder': "_syaz7i1p",
    'color.text.accent.yellow': "_syazfb2s",
    'color.text.accent.yellow.bolder': "_syazekll",
    'color.text.accent.green': "_syazh55r",
    'color.text.accent.green.bolder': "_syaz1y78",
    'color.text.accent.teal': "_syaz17qg",
    'color.text.accent.teal.bolder': "_syaz12v7",
    'color.text.accent.blue': "_syaz16jw",
    'color.text.accent.blue.bolder': "_syaz1kyx",
    'color.text.accent.purple': "_syazqmo9",
    'color.text.accent.purple.bolder': "_syaz1mn1",
    'color.text.accent.magenta': "_syaz1s8m",
    'color.text.accent.magenta.bolder': "_syaz1qur",
    'color.text.accent.gray': "_syaz1sqi",
    'color.text.accent.gray.bolder': "_syaz1tmo",
    'color.text.disabled': "_syaz1gmx",
    'color.text.inverse': "_syaz15cr",
    'color.text.selected': "_syaz6x5g",
    'color.text.brand': "_syaz1oa5",
    'color.text.danger': "_syaz1tmw",
    'color.text.warning': "_syaz1xn9",
    'color.text.warning.inverse': "_syaz1yd3",
    'color.text.success': "_syazgsak",
    'color.text.discovery': "_syazdv2p",
    'color.text.information': "_syazu3tg",
    'color.text.subtlest': "_syaz1rpy",
    'color.text.subtle': "_syazazsu",
    'color.link': "_syaz13af",
    'color.link.pressed': "_syaz12zz",
    'color.link.visited': "_syaz1ra0",
    'color.link.visited.pressed': "_syaz17z1"
};
var $3e631f986b84a440$export$2185ce37f9bdd963 = {
    'color.background.neutral.bold': 'color.text.inverse',
    'color.background.neutral.bold.hovered': 'color.text.inverse',
    'color.background.neutral.bold.pressed': 'color.text.inverse',
    'color.background.selected.bold': 'color.text.inverse',
    'color.background.selected.bold.hovered': 'color.text.inverse',
    'color.background.selected.bold.pressed': 'color.text.inverse',
    'color.background.brand.bold': 'color.text.inverse',
    'color.background.brand.bold.hovered': 'color.text.inverse',
    'color.background.brand.bold.pressed': 'color.text.inverse',
    'color.background.brand.boldest': 'color.text.inverse',
    'color.background.brand.boldest.hovered': 'color.text.inverse',
    'color.background.brand.boldest.pressed': 'color.text.inverse',
    'color.background.danger.bold': 'color.text.inverse',
    'color.background.danger.bold.hovered': 'color.text.inverse',
    'color.background.danger.bold.pressed': 'color.text.inverse',
    'color.background.warning.bold': 'color.text.warning.inverse',
    'color.background.warning.bold.hovered': 'color.text.warning.inverse',
    'color.background.warning.bold.pressed': 'color.text.warning.inverse',
    'color.background.success.bold': 'color.text.inverse',
    'color.background.success.bold.hovered': 'color.text.inverse',
    'color.background.success.bold.pressed': 'color.text.inverse',
    'color.background.discovery.bold': 'color.text.inverse',
    'color.background.discovery.bold.hovered': 'color.text.inverse',
    'color.background.discovery.bold.pressed': 'color.text.inverse',
    'color.background.information.bold': 'color.text.inverse',
    'color.background.information.bold.hovered': 'color.text.inverse',
    'color.background.information.bold.pressed': 'color.text.inverse'
};
/**
 * __Text__
 *
 * Text is a primitive component that has the Atlassian Design System's design guidelines baked in.
 * This includes considerations for text attributes such as color, font size, font weight, and line height.
 * It renders a `span` by default.
 *
 * @internal
 */ var $3e631f986b84a440$var$Text = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? 'span' : _ref$as, colorProp = _ref.color, align = _ref.align, testId = _ref.testId, id = _ref.id, size = _ref.size, weight = _ref.weight, maxLines = _ref.maxLines, xcss = _ref.xcss, children = _ref.children;
    (0, $afMOk.default)($3e631f986b84a440$var$asAllowlist.includes(Component), "@atlaskit/primitives: Text received an invalid \"as\" value of \"".concat(Component, "\""));
    var hasTextAncestor = (0, $1f8dbd7d91f9c6c2$export$9322276ec105d055)();
    var color = $3e631f986b84a440$var$useColor(colorProp, hasTextAncestor);
    if (!size && !hasTextAncestor) size = 'medium';
    var component = /*#__PURE__*/ $5FkrB.createElement(Component, {
        id: id,
        className: (0, $970q7.default)([
            $3e631f986b84a440$var$styles.root,
            size && $3e631f986b84a440$var$fontSizeMap[size],
            color && $3e631f986b84a440$var$textColorMap[color],
            maxLines && $3e631f986b84a440$var$styles.truncation,
            maxLines === 1 && $3e631f986b84a440$var$styles.breakAll,
            align && $3e631f986b84a440$var$styles["textAlign.".concat(align)],
            weight && $3e631f986b84a440$var$fontWeightMap[weight],
            Component === 'em' && $3e631f986b84a440$var$styles['as.em'],
            Component === 'strong' && $3e631f986b84a440$var$styles['as.strong'],
            xcss
        ]),
        style: {
            WebkitLineClamp: maxLines
        },
        "data-testid": testId,
        ref: ref
    }, children);
    if (hasTextAncestor) // no need to re-apply context if the text is already wrapped
    return component;
    return /*#__PURE__*/ $5FkrB.createElement((0, $1f8dbd7d91f9c6c2$export$ae933c6cbe5643ad), {
        value: true
    }, component);
});
var $3e631f986b84a440$export$2e2bcd8739ae039 = $3e631f986b84a440$var$Text;



var $195c12e5177a207f$var$_excluded = [
    "children",
    "innerProps",
    "xcss"
], $195c12e5177a207f$var$_excluded2 = [
    "children",
    "innerProps",
    "xcss"
];
function $195c12e5177a207f$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $195c12e5177a207f$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $195c12e5177a207f$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $195c12e5177a207f$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
// ==============================
// Menu
// ==============================
// Get Menu Placement
// ------------------------------
function $195c12e5177a207f$var$getMenuPlacement(_ref) {
    var preferredMaxHeight = _ref.maxHeight, menuEl = _ref.menuEl, minHeight = _ref.minHeight, preferredPlacement = _ref.placement, shouldScroll = _ref.shouldScroll, isFixedPosition = _ref.isFixedPosition, controlHeight = _ref.controlHeight;
    var scrollParent = (0, $c6f45647f62090f7$export$cfa2225e87938781)(menuEl);
    var defaultState = {
        placement: 'bottom',
        maxHeight: preferredMaxHeight
    };
    // something went wrong, return default state
    if (!menuEl || !menuEl.offsetParent) return defaultState;
    // we can't trust `scrollParent.scrollHeight` --> it may increase when
    // the menu is rendered
    var _scrollParent$getBoun = scrollParent.getBoundingClientRect(), scrollHeight = _scrollParent$getBoun.height;
    var _menuEl$getBoundingCl = menuEl.getBoundingClientRect(), menuBottom = _menuEl$getBoundingCl.bottom, menuHeight = _menuEl$getBoundingCl.height, menuTop = _menuEl$getBoundingCl.top;
    var _menuEl$offsetParent$ = menuEl.offsetParent.getBoundingClientRect(), containerTop = _menuEl$offsetParent$.top;
    var viewHeight = isFixedPosition ? window.innerHeight : (0, $c6f45647f62090f7$export$2e0654fad740d2e4)(scrollParent);
    var scrollTop = (0, $c6f45647f62090f7$export$c4a223a8ba9e4ea5)(scrollParent);
    var menuTopFromParent = menuTop;
    var marginBottom = parseInt(getComputedStyle(menuEl).marginBottom, 10);
    var marginTop = parseInt(getComputedStyle(menuEl).marginTop, 10);
    var viewSpaceAbove = containerTop - marginTop;
    var viewSpaceBelow = viewHeight - menuTopFromParent;
    var scrollSpaceAbove = viewSpaceAbove + scrollTop;
    var scrollSpaceBelow = scrollHeight - scrollTop - menuTopFromParent;
    var scrollDown = menuBottom - viewHeight + scrollTop + marginBottom;
    var scrollUp = scrollTop + menuTop - marginTop;
    var scrollDuration = 160;
    switch(preferredPlacement){
        case 'auto':
        case 'bottom':
            // 1: the menu will fit, do nothing
            if (viewSpaceBelow >= menuHeight) return {
                placement: 'bottom',
                maxHeight: preferredMaxHeight
            };
            // 2: the menu will fit, if scrolled
            if (scrollSpaceBelow >= menuHeight && !isFixedPosition) {
                if (shouldScroll) (0, $c6f45647f62090f7$export$858c30343199f3af)(scrollParent, scrollDown, scrollDuration);
                return {
                    placement: 'bottom',
                    maxHeight: preferredMaxHeight
                };
            }
            // 3: the menu will fit, if constrained
            if (!isFixedPosition && scrollSpaceBelow >= minHeight || isFixedPosition && viewSpaceBelow >= minHeight) {
                if (shouldScroll) (0, $c6f45647f62090f7$export$858c30343199f3af)(scrollParent, scrollDown, scrollDuration);
                // we want to provide as much of the menu as possible to the user,
                // so give them whatever is available below rather than the minHeight.
                var constrainedHeight = isFixedPosition ? viewSpaceBelow - marginBottom : scrollSpaceBelow - marginBottom;
                return {
                    placement: 'bottom',
                    maxHeight: constrainedHeight
                };
            }
            // 4. Forked beviour when there isn't enough space below
            // AUTO: flip the menu, render above
            if (preferredPlacement === 'auto' || isFixedPosition) {
                // may need to be constrained after flipping
                var _constrainedHeight = preferredMaxHeight;
                var spaceAbove = isFixedPosition ? viewSpaceAbove : scrollSpaceAbove;
                if (spaceAbove >= minHeight) _constrainedHeight = Math.min(spaceAbove - marginBottom - controlHeight, preferredMaxHeight);
                return {
                    placement: 'top',
                    maxHeight: _constrainedHeight
                };
            }
            // BOTTOM: allow browser to increase scrollable area and immediately set scroll
            if (preferredPlacement === 'bottom') {
                if (shouldScroll) (0, $c6f45647f62090f7$export$3f99968195accfaf)(scrollParent, scrollDown);
                return {
                    placement: 'bottom',
                    maxHeight: preferredMaxHeight
                };
            }
            break;
        case 'top':
            // 1: the menu will fit, do nothing
            if (viewSpaceAbove >= menuHeight) return {
                placement: 'top',
                maxHeight: preferredMaxHeight
            };
            // 2: the menu will fit, if scrolled
            if (scrollSpaceAbove >= menuHeight && !isFixedPosition) {
                if (shouldScroll) (0, $c6f45647f62090f7$export$858c30343199f3af)(scrollParent, scrollUp, scrollDuration);
                return {
                    placement: 'top',
                    maxHeight: preferredMaxHeight
                };
            }
            // 3: the menu will fit, if constrained
            if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) {
                var _constrainedHeight2 = preferredMaxHeight;
                // we want to provide as much of the menu as possible to the user,
                // so give them whatever is available below rather than the minHeight.
                if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) _constrainedHeight2 = isFixedPosition ? viewSpaceAbove - marginTop : scrollSpaceAbove - marginTop;
                if (shouldScroll) (0, $c6f45647f62090f7$export$858c30343199f3af)(scrollParent, scrollUp, scrollDuration);
                return {
                    placement: 'top',
                    maxHeight: _constrainedHeight2
                };
            }
            // 4. not enough space, the browser WILL NOT increase scrollable area when
            // absolutely positioned element rendered above the viewport (only below).
            // Flip the menu, render below
            return {
                placement: 'bottom',
                maxHeight: preferredMaxHeight
            };
        default:
            throw new Error("Invalid placement provided \"".concat(preferredPlacement, "\"."));
    }
    return defaultState;
}
// Menu Component
// ------------------------------
var $195c12e5177a207f$var$coercePlacement = function coercePlacement(p) {
    return p === 'auto' ? 'bottom' : p;
};
var $195c12e5177a207f$var$menuStyles = {
    root: "_2rko12b0 _kqswstnw _1bsb1osq _1pbykb7n _6rthu2gc _1pfhu2gc _bfhk1bhr _16qsd0yg",
    rootT26Shape: "_2rko1mok",
    bottom: "_152t1osq",
    top: "_u7co1osq"
};
var $195c12e5177a207f$export$a228922d5ca42a79 = function menuCSS() {
    return {};
};
var $195c12e5177a207f$var$PortalPlacementContext = /*#__PURE__*/ (0, $5FkrB.createContext)(null);
var $195c12e5177a207f$export$f32337f3a7617699 = function MenuPlacer(props) {
    var children = props.children, minMenuHeight = props.minMenuHeight, maxMenuHeight = props.maxMenuHeight, menuPlacement = props.menuPlacement, menuPosition = props.menuPosition, menuShouldScrollIntoView = props.menuShouldScrollIntoView;
    var _ref2 = (0, $5FkrB.useContext)($195c12e5177a207f$var$PortalPlacementContext) || {}, setPortalPlacement = _ref2.setPortalPlacement;
    var ref = (0, $5FkrB.useRef)(null);
    var _useState = (0, $5FkrB.useState)(maxMenuHeight), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), maxHeight = _useState2[0], setMaxHeight = _useState2[1];
    var _useState3 = (0, $5FkrB.useState)(null), _useState4 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState3, 2), placement = _useState4[0], setPlacement = _useState4[1];
    // The minimum height of the control
    var controlHeight = 38;
    (0, $g8g1T.default)(function() {
        var menuEl = ref.current;
        if (!menuEl) return;
        // DO NOT scroll if position is fixed
        var isFixedPosition = menuPosition === 'fixed';
        var shouldScroll = menuShouldScrollIntoView && !isFixedPosition;
        var state = $195c12e5177a207f$var$getMenuPlacement({
            maxHeight: maxMenuHeight,
            menuEl: menuEl,
            minHeight: minMenuHeight,
            placement: menuPlacement,
            shouldScroll: shouldScroll,
            isFixedPosition: isFixedPosition,
            controlHeight: controlHeight
        });
        setMaxHeight(state.maxHeight);
        setPlacement(state.placement);
        setPortalPlacement === null || setPortalPlacement === void 0 || setPortalPlacement(state.placement);
    }, [
        maxMenuHeight,
        menuPlacement,
        menuPosition,
        menuShouldScrollIntoView,
        minMenuHeight,
        setPortalPlacement,
        controlHeight
    ]);
    return children({
        ref: ref,
        placerProps: $195c12e5177a207f$var$_objectSpread($195c12e5177a207f$var$_objectSpread({}, props), {}, {
            placement: placement || $195c12e5177a207f$var$coercePlacement(menuPlacement),
            maxHeight: maxHeight
        })
    });
};
var $195c12e5177a207f$var$Menu = function Menu(props) {
    var children = props.children, innerRef = props.innerRef, innerProps = props.innerProps, _props$placement = props.placement, placement = _props$placement === void 0 ? 'bottom' : _props$placement, xcss = props.xcss;
    var _getStyleProps = (0, $c6f45647f62090f7$export$26417cabd806a658)(props, 'menu', {
        menu: true
    }), css = _getStyleProps.css, className = _getStyleProps.className;
    return /*#__PURE__*/ $5FkrB.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $970q7.default)([
            $195c12e5177a207f$var$menuStyles.root,
            $195c12e5177a207f$var$menuStyles[placement],
            (0, $dU8Y3.fg)('platform-dst-shape-theme-default') && $195c12e5177a207f$var$menuStyles.rootT26Shape,
            (0, $hUFig.cx)(xcss, className, '-menu')
        ]),
        style: css,
        ref: innerRef
    }, innerProps), children);
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$195c12e5177a207f$export$2e2bcd8739ae039 = $195c12e5177a207f$var$Menu;
var $195c12e5177a207f$export$abafed69cff95d5e = function menuListCSS() {
    return {};
};
var $195c12e5177a207f$var$menuListStyles = null;
var $195c12e5177a207f$export$d4c4e98c5044dc8 = function MenuList(props) {
    var children = props.children, innerProps = props.innerProps, innerRef = props.innerRef, isMulti = props.isMulti, maxHeight = props.maxHeight, xcss = props.xcss;
    var _getStyleProps2 = (0, $c6f45647f62090f7$export$26417cabd806a658)(props, 'menuList', {
        'menu-list': true,
        'menu-list--is-multi': isMulti
    }), css = _getStyleProps2.css, className = _getStyleProps2.className;
    return /*#__PURE__*/ $5FkrB.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $970q7.default)([
            "_kqswh2mm _18m91wug _85i5u2gc _1q51u2gc _8am5i4x0",
            (0, $hUFig.cx)(className, xcss, '-MenuList')
        ]),
        style: $195c12e5177a207f$var$_objectSpread($195c12e5177a207f$var$_objectSpread({}, css), {}, {
            maxHeight: maxHeight
        }),
        ref: innerRef
    }, innerProps, {
        tabIndex: -1
    }), children);
};
// ==============================
// Menu Notices
// ==============================
var $195c12e5177a207f$var$noticeCSS = function noticeCSS() {
    return {};
};
var $195c12e5177a207f$var$noticeStyles = null;
var $195c12e5177a207f$export$cf0e22534d8b0074 = $195c12e5177a207f$var$noticeCSS;
var $195c12e5177a207f$export$98ec46397a8cb3cd = $195c12e5177a207f$var$noticeCSS;
var $195c12e5177a207f$export$d58b72b7d3c4072c = function NoOptionsMessage(_ref3) {
    var _ref3$children = _ref3.children, children = _ref3$children === void 0 ? 'No options' : _ref3$children, innerProps = _ref3.innerProps, xcss = _ref3.xcss, restProps = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref3, $195c12e5177a207f$var$_excluded);
    var _getStyleProps3 = (0, $c6f45647f62090f7$export$26417cabd806a658)($195c12e5177a207f$var$_objectSpread($195c12e5177a207f$var$_objectSpread({}, restProps), {}, {
        children: children,
        innerProps: innerProps
    }), 'noOptionsMessage', {
        'menu-notice': true,
        'menu-notice--no-options': true
    }), css = _getStyleProps3.css, className = _getStyleProps3.className;
    return /*#__PURE__*/ $5FkrB.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $970q7.default)([
            "_85i5u2gc _1q51u2gc _y4tiutpp _bozgutpp _y3gn1h6o",
            (0, $hUFig.cx)(className, xcss, '-NoOptionsMessage')
        ]),
        style: css,
        role: "option"
    }, innerProps), /*#__PURE__*/ $5FkrB.createElement((0, $3e631f986b84a440$export$2e2bcd8739ae039), {
        color: "color.text.subtle"
    }, children));
};
var $195c12e5177a207f$export$e928a71d039d3102 = function LoadingMessage(_ref4) {
    var _ref4$children = _ref4.children, children = _ref4$children === void 0 ? 'Loading...' : _ref4$children, innerProps = _ref4.innerProps, xcss = _ref4.xcss, restProps = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref4, $195c12e5177a207f$var$_excluded2);
    var _getStyleProps4 = (0, $c6f45647f62090f7$export$26417cabd806a658)($195c12e5177a207f$var$_objectSpread($195c12e5177a207f$var$_objectSpread({}, restProps), {}, {
        children: children,
        innerProps: innerProps
    }), 'loadingMessage', {
        'menu-notice': true,
        'menu-notice--loading': true
    }), css = _getStyleProps4.css, className = _getStyleProps4.className;
    return /*#__PURE__*/ $5FkrB.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $970q7.default)([
            "_85i5u2gc _1q51u2gc _y4tiutpp _bozgutpp _y3gn1h6o",
            (0, $hUFig.cx)(className, xcss, '-LoadingMessage')
        ]),
        style: css
    }, innerProps, {
        // eslint-disable-next-line @atlassian/a11y/role-has-required-aria-props
        role: "option"
    }), /*#__PURE__*/ $5FkrB.createElement((0, $3e631f986b84a440$export$2e2bcd8739ae039), {
        color: "color.text.subtle"
    }, children));
};
var $195c12e5177a207f$export$1dbbeb9648d1fdc9 = function menuPortalCSS() {
    return {};
};
var $195c12e5177a207f$var$menuPortalStyles = {
    root: "_1pbykb7n _1e02a1vk _kqswcp1v _152t1nmo _1bsb1qxj"
};
var $195c12e5177a207f$export$793392f970497feb = function MenuPortal(props) {
    var appendTo = props.appendTo, children = props.children, controlElement = props.controlElement, innerProps = props.innerProps, menuPlacement = props.menuPlacement, menuPosition = props.menuPosition, xcss = props.xcss;
    var menuPortalRef = (0, $5FkrB.useRef)(null);
    var cleanupRef = (0, $5FkrB.useRef)(null);
    var _useState5 = (0, $5FkrB.useState)($195c12e5177a207f$var$coercePlacement(menuPlacement)), _useState6 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState5, 2), placement = _useState6[0], setPortalPlacement = _useState6[1];
    var portalPlacementContext = (0, $5FkrB.useMemo)(function() {
        return {
            setPortalPlacement: setPortalPlacement
        };
    }, []);
    var _useState7 = (0, $5FkrB.useState)(null), _useState8 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState7, 2), computedPosition = _useState8[0], setComputedPosition = _useState8[1];
    var updateComputedPosition = (0, $5FkrB.useCallback)(function() {
        if (!controlElement) return;
        var rect = (0, $c6f45647f62090f7$export$7807c2a424c2f6d1)(controlElement);
        var scrollDistance = menuPosition === 'fixed' ? 0 : window.pageYOffset;
        var offset = rect[placement] + scrollDistance;
        if (offset !== (computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.offset) || rect.left !== (computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.left) || rect.width !== (computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.width)) setComputedPosition({
            offset: offset,
            rect: rect
        });
    }, [
        controlElement,
        menuPosition,
        placement,
        computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.offset,
        computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.left,
        computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.width
    ]);
    (0, $g8g1T.default)(function() {
        updateComputedPosition();
    }, [
        updateComputedPosition
    ]);
    var runAutoUpdate = (0, $5FkrB.useCallback)(function() {
        if (typeof cleanupRef.current === 'function') {
            cleanupRef.current();
            cleanupRef.current = null;
        }
        if (controlElement && menuPortalRef.current) cleanupRef.current = (0, $6I9SI.autoUpdate)(controlElement, menuPortalRef.current, updateComputedPosition, {
            elementResize: 'ResizeObserver' in window
        });
    }, [
        controlElement,
        updateComputedPosition
    ]);
    (0, $g8g1T.default)(function() {
        runAutoUpdate();
    }, [
        runAutoUpdate
    ]);
    var setMenuPortalElement = (0, $5FkrB.useCallback)(function(menuPortalElement) {
        menuPortalRef.current = menuPortalElement;
        runAutoUpdate();
    }, [
        runAutoUpdate
    ]);
    // bail early if required elements aren't present
    if (!appendTo && menuPosition !== 'fixed' || !computedPosition) return null;
    var _getStyleProps5 = (0, $c6f45647f62090f7$export$26417cabd806a658)($195c12e5177a207f$var$_objectSpread($195c12e5177a207f$var$_objectSpread({}, props), {}, {
        offset: computedPosition.offset,
        position: menuPosition,
        rect: computedPosition.rect
    }), 'menuPortal', {
        'menu-portal': true
    }), css = _getStyleProps5.css, className = _getStyleProps5.className;
    // same wrapper element whether fixed or portalled
    var menuWrapper = /*#__PURE__*/ $5FkrB.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $970q7.default)([
            $195c12e5177a207f$var$menuPortalStyles.root,
            (0, $hUFig.cx)(className, xcss, '-MenuPortal')
        ]),
        ref: setMenuPortalElement,
        style: $195c12e5177a207f$var$_objectSpread({
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            '--menu-left': "".concat(computedPosition.rect.left, "px"),
            '--menu-position': menuPosition,
            '--menu-top': "".concat(computedPosition.offset, "px"),
            '--menu-width': "".concat(computedPosition.rect.width, "px")
        }, css)
    }, innerProps), children);
    return /*#__PURE__*/ $5FkrB.createElement($195c12e5177a207f$var$PortalPlacementContext.Provider, {
        value: portalPlacementContext
    }, appendTo ? /*#__PURE__*/ (0, $aLeHs.createPortal)(menuWrapper, appendTo) : menuWrapper);
};


/* multi-value.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $25nEq = parcelRequire("25nEq");

var $kqp0i = parcelRequire("kqp0i");

var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");

var $hUFig = parcelRequire("hUFig");
var $fdf9ed0b0605978a$exports = {};
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::13080645a1b889dca339823c8ecd9929>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty($fdf9ed0b0605978a$exports, "__esModule", {
    value: true
});
$fdf9ed0b0605978a$exports.default = void 0;

var $fdf9ed0b0605978a$var$_react = $fdf9ed0b0605978a$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $fdf9ed0b0605978a$var$_baseNew = $fdf9ed0b0605978a$var$_interopRequireDefault((parcelRequire("k8BjC")));
function $fdf9ed0b0605978a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Cross".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Known uses: closing modals, panels, and transient views; removing tags
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $fdf9ed0b0605978a$var$CrossIcon = (props)=>/*#__PURE__*/ $fdf9ed0b0605978a$var$_react.default.createElement($fdf9ed0b0605978a$var$_baseNew.default, Object.assign({
        name: "CrossIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M14.03 3.03 9.06 8l4.97 4.97-1.06 1.06L8 9.06l-4.97 4.97-1.06-1.06L6.94 8 1.97 3.03l1.06-1.06L8 6.94l4.97-4.97z"/>`
    }, props));
$fdf9ed0b0605978a$var$CrossIcon.displayName = 'CrossIcon';
var $fdf9ed0b0605978a$var$_default = $fdf9ed0b0605978a$exports.default = $fdf9ed0b0605978a$var$CrossIcon;



function $dbc085bfcaa2309b$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $dbc085bfcaa2309b$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $dbc085bfcaa2309b$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $dbc085bfcaa2309b$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $dbc085bfcaa2309b$var$multiValueStyles = {
    root: "_2rko12b0 _1h6d14je _1dqonqa1 _189ee4h9 _1e0c1txw _1ul9ze3t _1pfhv77o _12l2v77o _6rthv77o _ahbqv77o _bfhk1j9a _p12f1osq _syazjpor _3yq3glyw",
    disabled: "_syaz1gmx _bfhki8nm",
    focused: "_syaz1wum _bfhk15s3 _16qs7ex6 _1aewe4h9 _6up51j28 _1xdnnqa1"
};
var $dbc085bfcaa2309b$export$23c213f7717186af = function multiValueCSS() {
    return {};
};
var $dbc085bfcaa2309b$export$f40612612e0af964 = function multiValueLabelCSS() {
    return {};
};
var $dbc085bfcaa2309b$var$multiValueLabelStyles = {
    root: "_1reo15vq _18m915vq _2rkolb4i _11c8fhey _o5721q9c _y4tiv77o _bozg1b66 _syaz1kw7",
    disabled: "_syaz1gmx",
    ellipsis: "_1bto1l2s"
};
var $dbc085bfcaa2309b$export$283467f6c4ac142b = function multiValueRemoveCSS() {
    return {};
};
var $dbc085bfcaa2309b$var$multiValueRemoveStyles = {
    focused: "_bfhkb1q9 _lswu1rrc",
    root: "_19itglyw _2rko12b0 _4cvr1h6o _1bah1h6o _1wpz1h6o _r06hglyw _bfhksm61 _syazi7uo _1e0c1txw _lswu1dx5 _1q51v77o _y4tiv77o _85i5v77o _bozgv77o _12l2v77o _1ah312gs _irr31dpa _13br1jjn _1di6fcek _i5f81jjn"
};
var $dbc085bfcaa2309b$export$cf9cf2a30a59265c = function MultiValueContainer(_ref) {
    var children = _ref.children, innerProps = _ref.innerProps, isFocused = _ref.isFocused, isDisabled = _ref.isDisabled, className = _ref.className, xcss = _ref.xcss;
    return /*#__PURE__*/ $5FkrB.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, innerProps, {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $970q7.default)([
            $dbc085bfcaa2309b$var$multiValueStyles.root,
            isDisabled && $dbc085bfcaa2309b$var$multiValueStyles.disabled,
            isFocused && $dbc085bfcaa2309b$var$multiValueStyles.focused,
            (0, $hUFig.cx)(className, xcss, '-multiValue')
        ])
    }), children);
};
var $dbc085bfcaa2309b$export$544aeea2a5ce08ee = function MultiValueLabel(_ref2) {
    var children = _ref2.children, innerProps = _ref2.innerProps, isDisabled = _ref2.isDisabled, hasEllipsis = _ref2.hasEllipsis, className = _ref2.className, xcss = _ref2.xcss;
    return /*#__PURE__*/ $5FkrB.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, innerProps, {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $970q7.default)([
            $dbc085bfcaa2309b$var$multiValueLabelStyles.root,
            isDisabled && $dbc085bfcaa2309b$var$multiValueLabelStyles.disabled,
            hasEllipsis && $dbc085bfcaa2309b$var$multiValueLabelStyles.ellipsis,
            (0, $hUFig.cx)(className, xcss, '-MultiValueLabel')
        ])
    }), children);
};
var $dbc085bfcaa2309b$var$disabledStyles = null;
var $dbc085bfcaa2309b$var$enabledStyles = null;
function $dbc085bfcaa2309b$export$8e1fd1a40e7a2f4a(_ref3) {
    var isDisabled = _ref3.isDisabled, isFocused = _ref3.isFocused, innerProps = _ref3.innerProps, className = _ref3.className, xcss = _ref3.xcss;
    return /*#__PURE__*/ $5FkrB.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, innerProps, {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $970q7.default)([
            $dbc085bfcaa2309b$var$multiValueRemoveStyles.root,
            isFocused && $dbc085bfcaa2309b$var$multiValueRemoveStyles.focused,
            (0, $hUFig.cx)(className, xcss, '-MultiValueRemove')
        ])
    }), /*#__PURE__*/ $5FkrB.createElement("div", {
        "data-testid": isDisabled ? 'hide-clear-icon' : 'show-clear-icon',
        className: (0, $970q7.default)([
            isDisabled && "_1e0cglyw",
            !isDisabled && "_1e0c1kw7"
        ])
    }, /*#__PURE__*/ $5FkrB.createElement((0, (/*@__PURE__*/$parcel$interopDefault($fdf9ed0b0605978a$exports))), {
        label: "",
        color: "currentColor",
        size: "small"
    })));
}
var $dbc085bfcaa2309b$var$MultiValue = function MultiValue(props) {
    var children = props.children, components = props.components, data = props.data, innerProps = props.innerProps, isDisabled = props.isDisabled, isFocused = props.isFocused, removeProps = props.removeProps, selectProps = props.selectProps, cropWithEllipsis = props.cropWithEllipsis;
    var Container = components.Container, Label = components.Label, Remove = components.Remove;
    var ariaLabel = typeof children === 'string' ? children : data.label;
    var _getStyleProps = (0, $c6f45647f62090f7$export$26417cabd806a658)(props, 'multiValue', {
        'multi-value': true,
        'multi-value--is-disabled': isDisabled
    }), containerCss = _getStyleProps.css, containerClassName = _getStyleProps.className;
    var _getStyleProps2 = (0, $c6f45647f62090f7$export$26417cabd806a658)(props, 'multiValueLabel', {
        'multi-value__label': true
    }), labelCss = _getStyleProps2.css, labelClassName = _getStyleProps2.className;
    var _getStyleProps3 = (0, $c6f45647f62090f7$export$26417cabd806a658)(props, 'multiValueRemove', {
        'multi-value__remove': true
    }), removeCss = _getStyleProps3.css, removeClassName = _getStyleProps3.className;
    return /*#__PURE__*/ $5FkrB.createElement(Container, {
        data: data,
        innerProps: $dbc085bfcaa2309b$var$_objectSpread({
            style: containerCss,
            className: containerClassName
        }, innerProps),
        className: containerClassName,
        isFocused: isFocused,
        isDisabled: isDisabled,
        selectProps: selectProps
    }, /*#__PURE__*/ $5FkrB.createElement(Label, {
        data: data,
        innerProps: {
            style: labelCss,
            className: labelClassName
        },
        className: labelClassName,
        hasEllipsis: cropWithEllipsis || cropWithEllipsis === undefined,
        selectProps: selectProps
    }, children), /*#__PURE__*/ $5FkrB.createElement(Remove, {
        data: data,
        innerProps: $dbc085bfcaa2309b$var$_objectSpread({
            style: removeCss,
            className: removeClassName,
            role: 'button',
            tabIndex: -1,
            'aria-label': "".concat(ariaLabel || 'option', ", remove")
        }, removeProps),
        className: removeClassName,
        isDisabled: isDisabled,
        selectProps: selectProps
    }));
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$dbc085bfcaa2309b$export$2e2bcd8739ae039 = $dbc085bfcaa2309b$var$MultiValue;


/* option.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $kqp0i = parcelRequire("kqp0i");

var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");

var $hUFig = parcelRequire("hUFig");

var $451efba6d73717a4$export$ef897119b7e920ba = function optionCSS() {
    return {};
};
var $451efba6d73717a4$var$optionStyles = {
    root: "_1rjc12x7 _18zrutpp _syazi7uo _80om73ad _1e0c1ule _1wyb1kw7 _1bsb1osq _uiztglyw _18ql1j7p _1di6fcek",
    disabled: "_syaz1gmx _80om13gf _bfhk1j28 _16qsglyw _1di61j28 _112eglyw",
    focused: "_bfhk1dpa _16qs1x9r _112e5u6v",
    selected: "_syaz6x5g _bfhk15s3 _16qs1x9r _1di6nozp _112e5u6v",
    focusedSelected: "_bfhkufnl"
};
var $451efba6d73717a4$var$Option = function Option(props) {
    var children = props.children, isDisabled = props.isDisabled, isFocused = props.isFocused, isSelected = props.isSelected, innerRef = props.innerRef, innerProps = props.innerProps, xcss = props.xcss;
    var _getStyleProps = (0, $c6f45647f62090f7$export$26417cabd806a658)(props, 'option', {
        option: true,
        'option--is-disabled': isDisabled,
        'option--is-focused': isFocused,
        'option--is-selected': isSelected
    }), css = _getStyleProps.css, className = _getStyleProps.className;
    return /*#__PURE__*/ $5FkrB.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        className: (0, $970q7.default)([
            $451efba6d73717a4$var$optionStyles.root,
            isFocused && $451efba6d73717a4$var$optionStyles.focused,
            isSelected && $451efba6d73717a4$var$optionStyles.selected,
            isFocused && isSelected && $451efba6d73717a4$var$optionStyles.focusedSelected,
            isDisabled && $451efba6d73717a4$var$optionStyles.disabled,
            (0, $hUFig.cx)(className, xcss, '-option')
        ]),
        ref: innerRef
    }, innerProps, {
        tabIndex: -1
    }), children);
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$451efba6d73717a4$export$2e2bcd8739ae039 = $451efba6d73717a4$var$Option;


/* placeholder.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $kqp0i = parcelRequire("kqp0i");

var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");

var $hUFig = parcelRequire("hUFig");

var $9f233418c7cb4308$export$5f3ffacd6594d90f = function placeholderCSS() {
    return {};
};
var $9f233418c7cb4308$var$placeholderStyles = {
    root: "_nd5l1sux _19pkidpf _2hwxv77o _otyridpf _18u0v77o _syaz1rpy",
    disabled: "_syaz1gmx"
};
var $9f233418c7cb4308$var$Placeholder = function Placeholder(props) {
    var children = props.children, innerProps = props.innerProps, isDisabled = props.isDisabled, xcss = props.xcss;
    var _getStyleProps = (0, $c6f45647f62090f7$export$26417cabd806a658)(props, 'placeholder', {
        placeholder: true
    }), css = _getStyleProps.css, className = _getStyleProps.className;
    return /*#__PURE__*/ $5FkrB.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        className: (0, $970q7.default)([
            $9f233418c7cb4308$var$placeholderStyles.root,
            isDisabled && $9f233418c7cb4308$var$placeholderStyles.disabled,
            (0, $hUFig.cx)(className, xcss, '-placeholder')
        ])
    }, innerProps), children);
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$9f233418c7cb4308$export$2e2bcd8739ae039 = $9f233418c7cb4308$var$Placeholder;


/* single-value.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $kqp0i = parcelRequire("kqp0i");

var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");

var $hUFig = parcelRequire("hUFig");

var $6fd83c0b3c7ff0a6$export$dbf350e5966cf602 = function css() {
    return {};
};
var $6fd83c0b3c7ff0a6$var$styles = {
    root: "_nd5l1sux _1reo15vq _18m915vq _p12f1osq _1bto1l2s _o5721q9c _19pkidpf _2hwxv77o _otyridpf _18u0v77o _syazi7uo",
    disalbed: "_syaz1gmx"
};
var $6fd83c0b3c7ff0a6$var$SingleValue = function SingleValue(props) {
    var children = props.children, isDisabled = props.isDisabled, innerProps = props.innerProps, xcss = props.xcss;
    var _getStyleProps = (0, $c6f45647f62090f7$export$26417cabd806a658)(props, 'singleValue', {
        'single-value': true,
        'single-value--is-disabled': isDisabled
    }), css = _getStyleProps.css, className = _getStyleProps.className;
    return /*#__PURE__*/ $5FkrB.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        className: (0, $970q7.default)([
            $6fd83c0b3c7ff0a6$var$styles.root,
            isDisabled && $6fd83c0b3c7ff0a6$var$styles.disalbed,
            (0, $hUFig.cx)(className, xcss, '-singleValue')
        ])
    }, innerProps), children);
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$6fd83c0b3c7ff0a6$export$2e2bcd8739ae039 = $6fd83c0b3c7ff0a6$var$SingleValue;


function $de5e6bb37d0375f4$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $de5e6bb37d0375f4$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $de5e6bb37d0375f4$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $de5e6bb37d0375f4$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $de5e6bb37d0375f4$export$9b5ac10f59f76296 = {
    ClearIndicator: (0, $7c6d514c13224b5d$export$ecf9cf59142dd54a),
    Control: (0, $c40f4e2f8ec9aafa$export$2e2bcd8739ae039),
    DropdownIndicator: (0, $7c6d514c13224b5d$export$ec98719d3db7f2e4),
    Group: (0, $53cf7edb74ae36f8$export$2e2bcd8739ae039),
    GroupHeading: (0, $53cf7edb74ae36f8$export$85c8b41a3cd87edc),
    IndicatorsContainer: (0, $4f917748c6c51291$export$d0ffd7e649cab6f),
    Input: (0, $6464be408c5bbddb$export$2e2bcd8739ae039),
    LoadingIndicator: (0, $7c6d514c13224b5d$export$7c20be4c1d342248),
    Menu: (0, $195c12e5177a207f$export$2e2bcd8739ae039),
    MenuList: (0, $195c12e5177a207f$export$d4c4e98c5044dc8),
    MenuPortal: (0, $195c12e5177a207f$export$793392f970497feb),
    LoadingMessage: (0, $195c12e5177a207f$export$e928a71d039d3102),
    NoOptionsMessage: (0, $195c12e5177a207f$export$d58b72b7d3c4072c),
    MultiValue: (0, $dbc085bfcaa2309b$export$2e2bcd8739ae039),
    MultiValueContainer: (0, $dbc085bfcaa2309b$export$cf9cf2a30a59265c),
    MultiValueLabel: (0, $dbc085bfcaa2309b$export$544aeea2a5ce08ee),
    MultiValueRemove: (0, $dbc085bfcaa2309b$export$8e1fd1a40e7a2f4a),
    Option: (0, $451efba6d73717a4$export$2e2bcd8739ae039),
    Placeholder: (0, $9f233418c7cb4308$export$2e2bcd8739ae039),
    SelectContainer: (0, $4f917748c6c51291$export$446eebadefe1123b),
    SingleValue: (0, $6fd83c0b3c7ff0a6$export$2e2bcd8739ae039),
    ValueContainer: (0, $4f917748c6c51291$export$4dc9f58ad9a1a000)
};
var $de5e6bb37d0375f4$export$71abc632aa29e6fe = function defaultComponents(props) {
    return $de5e6bb37d0375f4$var$_objectSpread($de5e6bb37d0375f4$var$_objectSpread({}, $de5e6bb37d0375f4$export$9b5ac10f59f76296), props.components);
};


/* dummy-input.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $kqp0i = parcelRequire("kqp0i");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");

var $2c241b2b825c3040$var$_excluded = [
    "innerRef"
];
var $2c241b2b825c3040$var$dummyInputStyles = null;
function $2c241b2b825c3040$export$2e2bcd8739ae039(_ref) {
    var innerRef = _ref.innerRef, props = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $2c241b2b825c3040$var$_excluded);
    // Remove animation props not meant for HTML elements
    var filteredProps = (0, $c6f45647f62090f7$export$4213b25a1c4e877)(props, 'onExited', 'in', 'enter', 'exit', 'appear');
    // eslint-disable-next-line  @atlaskit/ui-styling-standard/no-classname-prop
    return /*#__PURE__*/ $5FkrB.createElement("input", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        ref: innerRef,
        className: (0, $970q7.default)([
            "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _11q7idpf _19itidpf _nd5l1sux _12ji1r31 _1qu2glyw _12y3idpf _1bsbt94y _kqswh2mm _1n5d1j28 _syaz1j28 _1e02p1rm _tzy4idpf _t9ec1kuz",
            "-dummyInput"
        ])
    }, filteredProps));
}

/* required-input.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");

var $eVb4V = parcelRequire("eVb4V");
var $9f94d239c388760b$var$styles = null;
var $9f94d239c388760b$var$RequiredInput = function RequiredInput(_ref) {
    var name = _ref.name, onFocus = _ref.onFocus;
    return /*#__PURE__*/ $5FkrB.createElement("input", {
        required: true,
        name: name,
        tabIndex: -1,
        "aria-hidden": "true",
        className: (0, $970q7.default)([
            "_1bsb1osq _kqswstnw _u7coidpf _rjxpidpf _1e02idpf _tzy4idpf _lcxvglyw",
            "-requiredInput"
        ]),
        onFocus: onFocus,
        // Prevent `Switching from uncontrolled to controlled` error
        value: "",
        onChange: (0, $eVb4V.default)
    });
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$9f94d239c388760b$export$2e2bcd8739ae039 = $9f94d239c388760b$var$RequiredInput;


var $5FkrB = parcelRequire("5FkrB");

var $5FkrB = parcelRequire("5FkrB");

var $422e03c0c1bb35a2$var$cancelScroll = function cancelScroll(event) {
    if (event.cancelable) event.preventDefault();
    event.stopPropagation();
};
function $422e03c0c1bb35a2$export$2e2bcd8739ae039(_ref) {
    var isEnabled = _ref.isEnabled, onBottomArrive = _ref.onBottomArrive, onBottomLeave = _ref.onBottomLeave, onTopArrive = _ref.onTopArrive, onTopLeave = _ref.onTopLeave;
    var isBottom = (0, $5FkrB.useRef)(false);
    var isTop = (0, $5FkrB.useRef)(false);
    var touchStart = (0, $5FkrB.useRef)(0);
    var scrollTarget = (0, $5FkrB.useRef)(null);
    var handleEventDelta = (0, $5FkrB.useCallback)(function(event, delta) {
        if (scrollTarget.current === null) return;
        var _scrollTarget$current = scrollTarget.current, scrollTop = _scrollTarget$current.scrollTop, scrollHeight = _scrollTarget$current.scrollHeight, clientHeight = _scrollTarget$current.clientHeight;
        var target = scrollTarget.current;
        var isDeltaPositive = delta > 0;
        var availableScroll = scrollHeight - clientHeight - scrollTop;
        var shouldCancelScroll = false;
        // reset bottom/top flags
        if (availableScroll > delta && isBottom.current) {
            if (onBottomLeave) onBottomLeave(event);
            isBottom.current = false;
        }
        if (isDeltaPositive && isTop.current) {
            if (onTopLeave) onTopLeave(event);
            isTop.current = false;
        }
        // bottom limit
        if (isDeltaPositive && delta > availableScroll) {
            if (onBottomArrive && !isBottom.current) onBottomArrive(event);
            target.scrollTop = scrollHeight;
            shouldCancelScroll = true;
            isBottom.current = true;
        // top limit
        } else if (!isDeltaPositive && -delta > scrollTop) {
            if (onTopArrive && !isTop.current) onTopArrive(event);
            target.scrollTop = 0;
            shouldCancelScroll = true;
            isTop.current = true;
        }
        // cancel scroll
        if (shouldCancelScroll) $422e03c0c1bb35a2$var$cancelScroll(event);
    }, [
        onBottomArrive,
        onBottomLeave,
        onTopArrive,
        onTopLeave
    ]);
    var onWheel = (0, $5FkrB.useCallback)(function(event) {
        handleEventDelta(event, event.deltaY);
    }, [
        handleEventDelta
    ]);
    var onTouchStart = (0, $5FkrB.useCallback)(function(event) {
        // set touch start so we can calculate touchmove delta
        touchStart.current = event.changedTouches[0].clientY;
    }, []);
    var onTouchMove = (0, $5FkrB.useCallback)(function(event) {
        var deltaY = touchStart.current - event.changedTouches[0].clientY;
        handleEventDelta(event, deltaY);
    }, [
        handleEventDelta
    ]);
    var startListening = (0, $5FkrB.useCallback)(function(el) {
        // bail early if no element is available to attach to
        if (!el) return;
        var notPassive = (0, $c6f45647f62090f7$export$b0622a6911dbeaf5) ? {
            passive: false
        } : false;
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        el.addEventListener('wheel', onWheel, notPassive);
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        el.addEventListener('touchstart', onTouchStart, notPassive);
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        el.addEventListener('touchmove', onTouchMove, notPassive);
    }, [
        onTouchMove,
        onTouchStart,
        onWheel
    ]);
    var stopListening = (0, $5FkrB.useCallback)(function(el) {
        // bail early if no element is available to detach from
        if (!el) return;
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        el.removeEventListener('wheel', onWheel, false);
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        el.removeEventListener('touchstart', onTouchStart, false);
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        el.removeEventListener('touchmove', onTouchMove, false);
    }, [
        onTouchMove,
        onTouchStart,
        onWheel
    ]);
    (0, $5FkrB.useEffect)(function() {
        if (!isEnabled) return;
        var element = scrollTarget.current;
        startListening(element);
        return function() {
            stopListening(element);
        };
    }, [
        isEnabled,
        startListening,
        stopListening
    ]);
    return function(element) {
        scrollTarget.current = element;
    };
}



var $5FkrB = parcelRequire("5FkrB");
var $c881e3eb6d9519ef$var$STYLE_KEYS = [
    'boxSizing',
    'height',
    'overflow',
    'paddingRight',
    'position'
];
var $c881e3eb6d9519ef$var$LOCK_STYLES = {
    boxSizing: 'border-box',
    // account for possible declaration `width: 100%;` on body
    overflow: 'hidden',
    position: 'relative',
    height: '100%'
};
function $c881e3eb6d9519ef$var$preventTouchMove(e) {
    e.preventDefault();
}
function $c881e3eb6d9519ef$var$allowTouchMove(e) {
    e.stopPropagation();
}
function $c881e3eb6d9519ef$var$preventInertiaScroll() {
    var top = this.scrollTop;
    var totalScroll = this.scrollHeight;
    var currentScroll = top + this.offsetHeight;
    if (top === 0) this.scrollTop = 1;
    else if (currentScroll === totalScroll) this.scrollTop = top - 1;
}
// `ontouchstart` check works on most browsers
// `maxTouchPoints` works on IE10/11 and Surface
function $c881e3eb6d9519ef$var$isTouchDevice() {
    return 'ontouchstart' in window || navigator.maxTouchPoints;
}
var $c881e3eb6d9519ef$var$canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
var $c881e3eb6d9519ef$var$activeScrollLocks = 0;
var $c881e3eb6d9519ef$var$listenerOptions = {
    capture: false,
    passive: false
};
function $c881e3eb6d9519ef$export$2e2bcd8739ae039(_ref) {
    var isEnabled = _ref.isEnabled, _ref$accountForScroll = _ref.accountForScrollbars, accountForScrollbars = _ref$accountForScroll === void 0 ? true : _ref$accountForScroll;
    var originalStyles = (0, $5FkrB.useRef)({});
    var scrollTarget = (0, $5FkrB.useRef)(null);
    var addScrollLock = (0, $5FkrB.useCallback)(function(touchScrollTarget) {
        if (!$c881e3eb6d9519ef$var$canUseDOM) return;
        var target = document.body;
        var targetStyle = target && target.style;
        if (accountForScrollbars) // store any styles already applied to the body
        $c881e3eb6d9519ef$var$STYLE_KEYS.forEach(function(key) {
            var val = targetStyle && targetStyle[key];
            originalStyles.current[key] = val;
        });
        // apply the lock styles and padding if this is the first scroll lock
        if (accountForScrollbars && $c881e3eb6d9519ef$var$activeScrollLocks < 1) {
            var currentPadding = parseInt(originalStyles.current.paddingRight, 10) || 0;
            var clientWidth = document.body ? document.body.clientWidth : 0;
            var adjustedPadding = window.innerWidth - clientWidth + currentPadding || 0;
            Object.keys($c881e3eb6d9519ef$var$LOCK_STYLES).forEach(function(key) {
                var val = $c881e3eb6d9519ef$var$LOCK_STYLES[key];
                if (targetStyle) targetStyle[key] = val;
            });
            if (targetStyle) targetStyle.paddingRight = "".concat(adjustedPadding, "px");
        }
        // account for touch devices
        if (target && $c881e3eb6d9519ef$var$isTouchDevice()) {
            // Mobile Safari ignores { overflow: hidden } declaration on the body.
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            target.addEventListener('touchmove', $c881e3eb6d9519ef$var$preventTouchMove, $c881e3eb6d9519ef$var$listenerOptions);
            // Allow scroll on provided target
            if (touchScrollTarget) {
                // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                touchScrollTarget.addEventListener('touchstart', $c881e3eb6d9519ef$var$preventInertiaScroll, $c881e3eb6d9519ef$var$listenerOptions);
                // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                touchScrollTarget.addEventListener('touchmove', $c881e3eb6d9519ef$var$allowTouchMove, $c881e3eb6d9519ef$var$listenerOptions);
            }
        }
        // increment active scroll locks
        $c881e3eb6d9519ef$var$activeScrollLocks += 1;
    }, [
        accountForScrollbars
    ]);
    var removeScrollLock = (0, $5FkrB.useCallback)(function(touchScrollTarget) {
        if (!$c881e3eb6d9519ef$var$canUseDOM) return;
        var target = document.body;
        var targetStyle = target && target.style;
        // safely decrement active scroll locks
        $c881e3eb6d9519ef$var$activeScrollLocks = Math.max($c881e3eb6d9519ef$var$activeScrollLocks - 1, 0);
        // reapply original body styles, if any
        if (accountForScrollbars && $c881e3eb6d9519ef$var$activeScrollLocks < 1) $c881e3eb6d9519ef$var$STYLE_KEYS.forEach(function(key) {
            var val = originalStyles.current[key];
            if (targetStyle) targetStyle[key] = val;
        });
        // remove touch listeners
        if (target && $c881e3eb6d9519ef$var$isTouchDevice()) {
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            target.removeEventListener('touchmove', $c881e3eb6d9519ef$var$preventTouchMove, $c881e3eb6d9519ef$var$listenerOptions);
            if (touchScrollTarget) {
                // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                touchScrollTarget.removeEventListener('touchstart', $c881e3eb6d9519ef$var$preventInertiaScroll, $c881e3eb6d9519ef$var$listenerOptions);
                // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                touchScrollTarget.removeEventListener('touchmove', $c881e3eb6d9519ef$var$allowTouchMove, $c881e3eb6d9519ef$var$listenerOptions);
            }
        }
    }, [
        accountForScrollbars
    ]);
    (0, $5FkrB.useEffect)(function() {
        if (!isEnabled) return;
        var element = scrollTarget.current;
        addScrollLock(element);
        return function() {
            removeScrollLock(element);
        };
    }, [
        isEnabled,
        addScrollLock,
        removeScrollLock
    ]);
    return function(element) {
        scrollTarget.current = element;
    };
}


var $d702bd5fc1670502$var$blurSelectInput = function blurSelectInput(event) {
    var element = event.target;
    return element.ownerDocument.activeElement && element.ownerDocument.activeElement.blur();
};
function $d702bd5fc1670502$export$2e2bcd8739ae039(_ref) {
    var children = _ref.children, lockEnabled = _ref.lockEnabled, _ref$captureEnabled = _ref.captureEnabled, captureEnabled = _ref$captureEnabled === void 0 ? true : _ref$captureEnabled, onBottomArrive = _ref.onBottomArrive, onBottomLeave = _ref.onBottomLeave, onTopArrive = _ref.onTopArrive, onTopLeave = _ref.onTopLeave;
    var setScrollCaptureTarget = (0, $422e03c0c1bb35a2$export$2e2bcd8739ae039)({
        isEnabled: captureEnabled,
        onBottomArrive: onBottomArrive,
        onBottomLeave: onBottomLeave,
        onTopArrive: onTopArrive,
        onTopLeave: onTopLeave
    });
    var setScrollLockTarget = (0, $c881e3eb6d9519ef$export$2e2bcd8739ae039)({
        isEnabled: lockEnabled
    });
    var targetRef = function targetRef(element) {
        setScrollCaptureTarget(element);
        setScrollLockTarget(element);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $5FkrB.Fragment), null, lockEnabled && /*#__PURE__*/ // eslint-disable-next-line @atlassian/a11y/click-events-have-key-events, @atlassian/a11y/interactive-element-not-keyboard-focusable, @atlassian/a11y/no-static-element-interactions
    (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("div", {
        onClick: $d702bd5fc1670502$var$blurSelectInput,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            position: 'fixed',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            insetBlockEnd: 0,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            insetBlockStart: 0,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            insetInlineEnd: 0,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            insetInlineStart: 0
        }
    }), children(targetRef));
}



var $iUCre = parcelRequire("iUCre");
function $52077d8a5b48b859$export$17baa7c95b6ba1b8(_ref) {
    var isOpen = _ref.isOpen, onClose = _ref.onClose;
    // @ts-ignore - hot-116676
    (0, $iUCre.useNotifyOpenLayerObserver)({
        isOpen: isOpen,
        onClose: onClose
    });
    return null;
}



var $25nEq = parcelRequire("25nEq");

var $5FkrB = parcelRequire("5FkrB");
var $b057f6c02ca907ff$export$a7265767c78f9bae = {
    onChange: function onChange(props) {
        var action = props.action, _props$label = props.label, label = _props$label === void 0 ? '' : _props$label, isDisabled = props.isDisabled;
        switch(action){
            case 'deselect-option':
            case 'pop-value':
            case 'remove-value':
                return label.length ? "option ".concat(label, ", deselected") : '';
            case 'clear':
                return 'All selected options have been cleared.';
            case 'select-option':
                return label.length && !isDisabled ? "option ".concat(label, ", selected.") : '';
            default:
                return '';
        }
    },
    onFilter: function onFilter(props) {
        var inputValue = props.inputValue, resultsMessage = props.resultsMessage;
        return inputValue ? "".concat(resultsMessage, " for search term ").concat(inputValue, ".") : '';
    }
};


/* a11y-text.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $kqp0i = parcelRequire("kqp0i");

var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");
// Assistive text to describe visual elements. Hidden for sighted users.
var $4f6afa59435f829e$var$styles = null;
var $4f6afa59435f829e$var$A11yText = function A11yText(props) {
    return /*#__PURE__*/ $5FkrB.createElement("span", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        // eslint-disable-next-line  @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $970q7.default)([
            "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19itidpf _1reo15vq _18m915vq _1bsbt94y _4t3it94y _kqswstnw _1pbydx66 _ogto7mnp _uiztglyw _o5721q9c",
            "-a11yText"
        ])
    }, props));
};
var $4f6afa59435f829e$export$2e2bcd8739ae039 = $4f6afa59435f829e$var$A11yText;


function $509727e7da2e808a$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $509727e7da2e808a$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $509727e7da2e808a$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $509727e7da2e808a$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
// ==============================
// Root Container
// ==============================
var $509727e7da2e808a$var$LiveRegion = function LiveRegion(props) {
    var ariaSelection = props.ariaSelection, focusableOptions = props.focusableOptions, isFocused = props.isFocused, selectValue = props.selectValue, selectProps = props.selectProps, id = props.id;
    var ariaLiveMessages = selectProps.ariaLiveMessages, getOptionLabel = selectProps.getOptionLabel, inputValue = selectProps.inputValue, isOptionDisabled = selectProps.isOptionDisabled, menuIsOpen = selectProps.menuIsOpen, options = selectProps.options, screenReaderStatus = selectProps.screenReaderStatus, isLoading = selectProps.isLoading;
    var ariaLive = selectProps['aria-live'];
    // Update aria live message configuration when prop changes
    var messages = (0, $5FkrB.useMemo)(function() {
        return $509727e7da2e808a$var$_objectSpread($509727e7da2e808a$var$_objectSpread({}, (0, $b057f6c02ca907ff$export$a7265767c78f9bae)), ariaLiveMessages || {});
    }, [
        ariaLiveMessages
    ]);
    // Update aria live selected option when prop changes
    var ariaSelected = (0, $5FkrB.useMemo)(function() {
        var message = '';
        if (menuIsOpen) // we don't need to have selected message when the menu is open
        return '';
        if (ariaSelection && messages.onChange) {
            var option = ariaSelection.option, selectedOptions = ariaSelection.options, removedValue = ariaSelection.removedValue, removedValues = ariaSelection.removedValues, value = ariaSelection.value;
            // select-option when !isMulti does not return option so we assume selected option is value
            var asOption = function asOption(val) {
                return !Array.isArray(val) ? val : null;
            };
            // If there is just one item from the action then get its label
            var selected = removedValue || option || asOption(value);
            var label = selected ? getOptionLabel(selected) : '';
            // If there are multiple items from the action then return an array of labels
            var multiSelected = selectedOptions || removedValues || undefined;
            var labels = multiSelected ? multiSelected.map(getOptionLabel) : [];
            if (!label && !labels.length) // return empty string if no labels provided
            return '';
            var onChangeProps = $509727e7da2e808a$var$_objectSpread({
                // multiSelected items are usually items that have already been selected
                // or set by the user as a default value so we assume they are not disabled
                isDisabled: selected && isOptionDisabled(selected, selectValue),
                label: label,
                labels: labels
            }, ariaSelection);
            message = messages.onChange(onChangeProps);
        }
        return message;
    }, [
        ariaSelection,
        messages,
        isOptionDisabled,
        selectValue,
        getOptionLabel,
        menuIsOpen
    ]);
    var ariaResults = (0, $5FkrB.useMemo)(function() {
        var resultsMsg = '';
        if (isLoading) resultsMsg = 'Loading. ';
        if (menuIsOpen && options.length && !isLoading && messages.onFilter) {
            var resultsMessage = screenReaderStatus({
                count: focusableOptions.length
            });
            resultsMsg = messages.onFilter({
                inputValue: inputValue,
                resultsMessage: resultsMessage
            });
        }
        if (options && options.length === 0) resultsMsg = 'No options. ';
        return resultsMsg;
    }, [
        focusableOptions,
        inputValue,
        menuIsOpen,
        messages,
        options,
        screenReaderStatus,
        isLoading
    ]);
    var isInitialFocus = (ariaSelection === null || ariaSelection === void 0 ? void 0 : ariaSelection.action) === 'initial-input-focus';
    var ScreenReaderText = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $5FkrB.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("span", {
        id: "aria-selection"
    }, ariaSelected), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("span", {
        id: "aria-results"
    }, ariaResults));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $5FkrB.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $4f6afa59435f829e$export$2e2bcd8739ae039), {
        id: id
    }, isInitialFocus && ScreenReaderText), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $4f6afa59435f829e$export$2e2bcd8739ae039), {
        "aria-live": ariaLive // Should be undefined by default unless a specific use case requires it
        ,
        role: "status"
    }, isFocused && !isInitialFocus && ScreenReaderText));
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$509727e7da2e808a$export$2e2bcd8739ae039 = $509727e7da2e808a$var$LiveRegion;




var $25nEq = parcelRequire("25nEq");

var $cvlyC = parcelRequire("cvlyC");
var $114557f07b4d8bb7$var$diacritics = [
    {
        base: 'A',
        letters: "A\u24B6\uFF21\xC0\xC1\xC2\u1EA6\u1EA4\u1EAA\u1EA8\xC3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\xC4\u01DE\u1EA2\xC5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F"
    },
    {
        base: 'AA',
        letters: "\uA732"
    },
    {
        base: 'AE',
        letters: "\xC6\u01FC\u01E2"
    },
    {
        base: 'AO',
        letters: "\uA734"
    },
    {
        base: 'AU',
        letters: "\uA736"
    },
    {
        base: 'AV',
        letters: "\uA738\uA73A"
    },
    {
        base: 'AY',
        letters: "\uA73C"
    },
    {
        base: 'B',
        letters: "B\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181"
    },
    {
        base: 'C',
        letters: "C\u24B8\uFF23\u0106\u0108\u010A\u010C\xC7\u1E08\u0187\u023B\uA73E"
    },
    {
        base: 'D',
        letters: "D\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779"
    },
    {
        base: 'DZ',
        letters: "\u01F1\u01C4"
    },
    {
        base: 'Dz',
        letters: "\u01F2\u01C5"
    },
    {
        base: 'E',
        letters: "E\u24BA\uFF25\xC8\xC9\xCA\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\xCB\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E"
    },
    {
        base: 'F',
        letters: "F\u24BB\uFF26\u1E1E\u0191\uA77B"
    },
    {
        base: 'G',
        letters: "G\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E"
    },
    {
        base: 'H',
        letters: "H\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D"
    },
    {
        base: 'I',
        letters: "I\u24BE\uFF29\xCC\xCD\xCE\u0128\u012A\u012C\u0130\xCF\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197"
    },
    {
        base: 'J',
        letters: "J\u24BF\uFF2A\u0134\u0248"
    },
    {
        base: 'K',
        letters: "K\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2"
    },
    {
        base: 'L',
        letters: "L\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780"
    },
    {
        base: 'LJ',
        letters: "\u01C7"
    },
    {
        base: 'Lj',
        letters: "\u01C8"
    },
    {
        base: 'M',
        letters: "M\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C"
    },
    {
        base: 'N',
        letters: "N\u24C3\uFF2E\u01F8\u0143\xD1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4"
    },
    {
        base: 'NJ',
        letters: "\u01CA"
    },
    {
        base: 'Nj',
        letters: "\u01CB"
    },
    {
        base: 'O',
        letters: "O\u24C4\uFF2F\xD2\xD3\xD4\u1ED2\u1ED0\u1ED6\u1ED4\xD5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\xD6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\xD8\u01FE\u0186\u019F\uA74A\uA74C"
    },
    {
        base: 'OI',
        letters: "\u01A2"
    },
    {
        base: 'OO',
        letters: "\uA74E"
    },
    {
        base: 'OU',
        letters: "\u0222"
    },
    {
        base: 'P',
        letters: "P\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754"
    },
    {
        base: 'Q',
        letters: "Q\u24C6\uFF31\uA756\uA758\u024A"
    },
    {
        base: 'R',
        letters: "R\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782"
    },
    {
        base: 'S',
        letters: "S\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784"
    },
    {
        base: 'T',
        letters: "T\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786"
    },
    {
        base: 'TZ',
        letters: "\uA728"
    },
    {
        base: 'U',
        letters: "U\u24CA\uFF35\xD9\xDA\xDB\u0168\u1E78\u016A\u1E7A\u016C\xDC\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244"
    },
    {
        base: 'V',
        letters: "V\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245"
    },
    {
        base: 'VY',
        letters: "\uA760"
    },
    {
        base: 'W',
        letters: "W\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72"
    },
    {
        base: 'X',
        letters: "X\u24CD\uFF38\u1E8A\u1E8C"
    },
    {
        base: 'Y',
        letters: "Y\u24CE\uFF39\u1EF2\xDD\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE"
    },
    {
        base: 'Z',
        letters: "Z\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762"
    },
    {
        base: 'a',
        letters: "a\u24D0\uFF41\u1E9A\xE0\xE1\xE2\u1EA7\u1EA5\u1EAB\u1EA9\xE3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\xE4\u01DF\u1EA3\xE5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250"
    },
    {
        base: 'aa',
        letters: "\uA733"
    },
    {
        base: 'ae',
        letters: "\xE6\u01FD\u01E3"
    },
    {
        base: 'ao',
        letters: "\uA735"
    },
    {
        base: 'au',
        letters: "\uA737"
    },
    {
        base: 'av',
        letters: "\uA739\uA73B"
    },
    {
        base: 'ay',
        letters: "\uA73D"
    },
    {
        base: 'b',
        letters: "b\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253"
    },
    {
        base: 'c',
        letters: "c\u24D2\uFF43\u0107\u0109\u010B\u010D\xE7\u1E09\u0188\u023C\uA73F\u2184"
    },
    {
        base: 'd',
        letters: "d\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A"
    },
    {
        base: 'dz',
        letters: "\u01F3\u01C6"
    },
    {
        base: 'e',
        letters: "e\u24D4\uFF45\xE8\xE9\xEA\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\xEB\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD"
    },
    {
        base: 'f',
        letters: "f\u24D5\uFF46\u1E1F\u0192\uA77C"
    },
    {
        base: 'g',
        letters: "g\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F"
    },
    {
        base: 'h',
        letters: "h\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265"
    },
    {
        base: 'hv',
        letters: "\u0195"
    },
    {
        base: 'i',
        letters: "i\u24D8\uFF49\xEC\xED\xEE\u0129\u012B\u012D\xEF\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131"
    },
    {
        base: 'j',
        letters: "j\u24D9\uFF4A\u0135\u01F0\u0249"
    },
    {
        base: 'k',
        letters: "k\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3"
    },
    {
        base: 'l',
        letters: "l\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747"
    },
    {
        base: 'lj',
        letters: "\u01C9"
    },
    {
        base: 'm',
        letters: "m\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F"
    },
    {
        base: 'n',
        letters: "n\u24DD\uFF4E\u01F9\u0144\xF1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5"
    },
    {
        base: 'nj',
        letters: "\u01CC"
    },
    {
        base: 'o',
        letters: "o\u24DE\uFF4F\xF2\xF3\xF4\u1ED3\u1ED1\u1ED7\u1ED5\xF5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\xF6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\xF8\u01FF\u0254\uA74B\uA74D\u0275"
    },
    {
        base: 'oi',
        letters: "\u01A3"
    },
    {
        base: 'ou',
        letters: "\u0223"
    },
    {
        base: 'oo',
        letters: "\uA74F"
    },
    {
        base: 'p',
        letters: "p\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755"
    },
    {
        base: 'q',
        letters: "q\u24E0\uFF51\u024B\uA757\uA759"
    },
    {
        base: 'r',
        letters: "r\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783"
    },
    {
        base: 's',
        letters: "s\u24E2\uFF53\xDF\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B"
    },
    {
        base: 't',
        letters: "t\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787"
    },
    {
        base: 'tz',
        letters: "\uA729"
    },
    {
        base: 'u',
        letters: "u\u24E4\uFF55\xF9\xFA\xFB\u0169\u1E79\u016B\u1E7B\u016D\xFC\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289"
    },
    {
        base: 'v',
        letters: "v\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C"
    },
    {
        base: 'vy',
        letters: "\uA761"
    },
    {
        base: 'w',
        letters: "w\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73"
    },
    {
        base: 'x',
        letters: "x\u24E7\uFF58\u1E8B\u1E8D"
    },
    {
        base: 'y',
        letters: "y\u24E8\uFF59\u1EF3\xFD\u0177\u1EF9\u0233\u1E8F\xFF\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF"
    },
    {
        base: 'z',
        letters: "z\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763"
    }
];
var $114557f07b4d8bb7$var$anyDiacritic = new RegExp('[' + $114557f07b4d8bb7$var$diacritics.map(function(d) {
    return d.letters;
}).join('') + ']', 'g');
var $114557f07b4d8bb7$var$diacriticToBase = {};
for(var $114557f07b4d8bb7$var$i = 0; $114557f07b4d8bb7$var$i < $114557f07b4d8bb7$var$diacritics.length; $114557f07b4d8bb7$var$i++){
    var $114557f07b4d8bb7$var$diacritic = $114557f07b4d8bb7$var$diacritics[$114557f07b4d8bb7$var$i];
    for(var $114557f07b4d8bb7$var$j = 0; $114557f07b4d8bb7$var$j < $114557f07b4d8bb7$var$diacritic.letters.length; $114557f07b4d8bb7$var$j++)$114557f07b4d8bb7$var$diacriticToBase[$114557f07b4d8bb7$var$diacritic.letters[$114557f07b4d8bb7$var$j]] = $114557f07b4d8bb7$var$diacritic.base;
}
var $114557f07b4d8bb7$export$b5bee4b27048330b = function stripDiacritics(str) {
    return str.replace($114557f07b4d8bb7$var$anyDiacritic, function(match) {
        return $114557f07b4d8bb7$var$diacriticToBase[match];
    });
};


function $d998080e8bc09b8a$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $d998080e8bc09b8a$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $d998080e8bc09b8a$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $d998080e8bc09b8a$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $d998080e8bc09b8a$var$memoizedStripDiacriticsForInput = (0, $cvlyC.default)((0, $114557f07b4d8bb7$export$b5bee4b27048330b));
var $d998080e8bc09b8a$var$trimString = function trimString(str) {
    return str.replace(/^\s+|\s+$/g, '');
};
var $d998080e8bc09b8a$var$defaultStringify = function defaultStringify(option) {
    return "".concat(option.label, " ").concat(option.value);
};
var $d998080e8bc09b8a$export$5d81789ff4aeccdf = function createFilter(config) {
    return function(option, rawInput) {
        if (option.data.__isNew__) return true;
        var _ignoreCase$ignoreAcc = $d998080e8bc09b8a$var$_objectSpread({
            ignoreCase: true,
            ignoreAccents: true,
            stringify: $d998080e8bc09b8a$var$defaultStringify,
            trim: true,
            matchFrom: 'any'
        }, config), ignoreCase = _ignoreCase$ignoreAcc.ignoreCase, ignoreAccents = _ignoreCase$ignoreAcc.ignoreAccents, stringify = _ignoreCase$ignoreAcc.stringify, trim = _ignoreCase$ignoreAcc.trim, matchFrom = _ignoreCase$ignoreAcc.matchFrom;
        var input = trim ? $d998080e8bc09b8a$var$trimString(rawInput) : rawInput;
        var candidate = trim ? $d998080e8bc09b8a$var$trimString(stringify(option)) : stringify(option);
        if (ignoreCase) {
            input = input.toLowerCase();
            candidate = candidate.toLowerCase();
        }
        if (ignoreAccents) {
            input = $d998080e8bc09b8a$var$memoizedStripDiacriticsForInput(input);
            candidate = (0, $114557f07b4d8bb7$export$b5bee4b27048330b)(candidate);
        }
        return matchFrom === 'start' ? candidate.substr(0, input.length) === input : candidate.indexOf(input) > -1;
    };
};



var $25nEq = parcelRequire("25nEq");










function $9a0e9b732d07073d$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $9a0e9b732d07073d$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $9a0e9b732d07073d$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $9a0e9b732d07073d$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $9a0e9b732d07073d$export$214b055320e0bf32 = {
    clearIndicator: (0, $7c6d514c13224b5d$export$9c0419fd944c1def),
    container: (0, $4f917748c6c51291$export$949392aeaf7d2e3a),
    control: (0, $c40f4e2f8ec9aafa$export$dbf350e5966cf602),
    dropdownIndicator: (0, $7c6d514c13224b5d$export$e1687335805e1230),
    group: (0, $53cf7edb74ae36f8$export$b6794329c1460634),
    groupHeading: (0, $53cf7edb74ae36f8$export$e5a7fbb542efcb7d),
    indicatorsContainer: (0, $4f917748c6c51291$export$9d74e3c8b5868ad7),
    input: (0, $6464be408c5bbddb$export$14a7781d0ca7abea),
    loadingIndicator: (0, $7c6d514c13224b5d$export$1d3f24cde248e6b5),
    loadingMessage: (0, $195c12e5177a207f$export$98ec46397a8cb3cd),
    menu: (0, $195c12e5177a207f$export$a228922d5ca42a79),
    menuList: (0, $195c12e5177a207f$export$abafed69cff95d5e),
    menuPortal: (0, $195c12e5177a207f$export$1dbbeb9648d1fdc9),
    multiValue: (0, $dbc085bfcaa2309b$export$23c213f7717186af),
    multiValueLabel: (0, $dbc085bfcaa2309b$export$f40612612e0af964),
    multiValueRemove: (0, $dbc085bfcaa2309b$export$283467f6c4ac142b),
    noOptionsMessage: (0, $195c12e5177a207f$export$cf0e22534d8b0074),
    option: (0, $451efba6d73717a4$export$ef897119b7e920ba),
    placeholder: (0, $9f233418c7cb4308$export$5f3ffacd6594d90f),
    singleValue: (0, $6fd83c0b3c7ff0a6$export$dbf350e5966cf602),
    valueContainer: (0, $4f917748c6c51291$export$47aec73c7aa6b9aa)
};
function $9a0e9b732d07073d$export$e618dc39ac9ad607(source) {
    var target = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    // initialize with source styles
    var styles = $9a0e9b732d07073d$var$_objectSpread({}, source);
    // massage in target styles
    Object.keys(target).forEach(function(keyAsString) {
        var key = keyAsString;
        if (source[key]) styles[key] = function(rsCss, props) {
            return target[key](source[key](rsCss, props), props);
        };
        else styles[key] = target[key];
    });
    return styles;
}



function $688ea211cffbe405$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $688ea211cffbe405$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $688ea211cffbe405$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $688ea211cffbe405$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $688ea211cffbe405$var$_callSuper(t, o, e) {
    return o = (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(o), (0, (/*@__PURE__*/$parcel$interopDefault($kIXpt)))(t, $688ea211cffbe405$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(t).constructor) : o.apply(t, e));
}
function $688ea211cffbe405$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($688ea211cffbe405$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $688ea211cffbe405$export$9c21a3269931e1e6 = {
    backspaceRemovesValue: true,
    blurInputOnSelect: (0, $c6f45647f62090f7$export$56963d77dbffdde7)(),
    captureMenuScroll: !(0, $c6f45647f62090f7$export$56963d77dbffdde7)(),
    classNames: {},
    closeMenuOnSelect: true,
    closeMenuOnScroll: false,
    components: {},
    controlShouldRenderValue: true,
    escapeClearsValue: false,
    filterOption: (0, $d998080e8bc09b8a$export$5d81789ff4aeccdf)(),
    formatGroupLabel: (0, $5e499e1ed2b54346$export$f4da216a6ca54656),
    getOptionLabel: (0, $5e499e1ed2b54346$export$dac6ace3020563ca),
    getOptionValue: (0, $5e499e1ed2b54346$export$40be908210c5a79c),
    isDisabled: false,
    isLoading: false,
    isMulti: false,
    isRtl: false,
    isSearchable: true,
    isOptionDisabled: (0, $5e499e1ed2b54346$export$56bd0c8d90db075),
    loadingMessage: function loadingMessage() {
        return 'Loading...';
    },
    maxMenuHeight: 300,
    minMenuHeight: 140,
    menuIsOpen: false,
    menuPlacement: 'bottom',
    menuPosition: 'absolute',
    menuShouldBlockScroll: false,
    menuShouldScrollIntoView: !(0, $c6f45647f62090f7$export$44f917bf91becd01)(),
    noOptionsMessage: function noOptionsMessage() {
        return 'No options';
    },
    openMenuOnFocus: false,
    openMenuOnClick: true,
    shouldPreventEscapePropagation: false,
    options: [],
    pageSize: 5,
    placeholder: 'Select...',
    screenReaderStatus: function screenReaderStatus(_ref) {
        var count = _ref.count;
        return "".concat(count, " result").concat(count !== 1 ? 's' : '', " available");
    },
    styles: {},
    tabIndex: 0,
    tabSelectsValue: true,
    UNSAFE_is_experimental_generic: false,
    shouldKeepInputOnSelect: false
};
function $688ea211cffbe405$var$toCategorizedOption(props, option, selectValue, index) {
    var isDisabled = $688ea211cffbe405$var$_isOptionDisabled(props, option, selectValue);
    var isSelected = $688ea211cffbe405$var$_isOptionSelected(props, option, selectValue);
    var label = $688ea211cffbe405$var$getOptionLabel(props, option);
    var value = $688ea211cffbe405$var$getOptionValue(props, option);
    return {
        type: 'option',
        data: option,
        isDisabled: isDisabled,
        isSelected: isSelected,
        label: label,
        value: value,
        index: index
    };
}
function $688ea211cffbe405$var$buildCategorizedOptions(props, selectValue) {
    return props.options.map(function(groupOrOption, groupOrOptionIndex) {
        //@ts-ignore
        if ('options' in groupOrOption) {
            var categorizedOptions = groupOrOption.options.map(function(option, optionIndex) {
                return $688ea211cffbe405$var$toCategorizedOption(props, option, selectValue, optionIndex);
            }).filter(function(categorizedOption) {
                return $688ea211cffbe405$var$isFocusable(props, categorizedOption);
            });
            return categorizedOptions.length > 0 ? {
                type: 'group',
                data: groupOrOption,
                options: categorizedOptions,
                index: groupOrOptionIndex
            } : undefined;
        }
        var categorizedOption = $688ea211cffbe405$var$toCategorizedOption(props, groupOrOption, selectValue, groupOrOptionIndex);
        return $688ea211cffbe405$var$isFocusable(props, categorizedOption) ? categorizedOption : undefined;
    }).filter((0, $c6f45647f62090f7$export$aedb69ff3e31596c));
}
function $688ea211cffbe405$var$buildFocusableOptionsFromCategorizedOptions(categorizedOptions) {
    return categorizedOptions.reduce(function(optionsAccumulator, categorizedOption) {
        if (categorizedOption.type === 'group') optionsAccumulator.push.apply(optionsAccumulator, (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(categorizedOption.options.map(function(option) {
            return option.data;
        })));
        else optionsAccumulator.push(categorizedOption.data);
        return optionsAccumulator;
    }, []);
}
function $688ea211cffbe405$var$buildFocusableOptionsWithIds(categorizedOptions, optionId) {
    return categorizedOptions.reduce(function(optionsAccumulator, categorizedOption) {
        if (categorizedOption.type === 'group') optionsAccumulator.push.apply(optionsAccumulator, (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(categorizedOption.options.map(function(option) {
            return {
                data: option.data,
                id: "".concat(optionId, "-").concat(categorizedOption.index, "-").concat(option.index)
            };
        })));
        else optionsAccumulator.push({
            data: categorizedOption.data,
            id: "".concat(optionId, "-").concat(categorizedOption.index)
        });
        return optionsAccumulator;
    }, []);
}
function $688ea211cffbe405$var$buildFocusableOptions(props, selectValue) {
    return $688ea211cffbe405$var$buildFocusableOptionsFromCategorizedOptions($688ea211cffbe405$var$buildCategorizedOptions(props, selectValue));
}
function $688ea211cffbe405$var$isFocusable(props, categorizedOption) {
    var _props$inputValue = props.inputValue, inputValue = _props$inputValue === void 0 ? '' : _props$inputValue;
    var data = categorizedOption.data, isSelected = categorizedOption.isSelected, label = categorizedOption.label, value = categorizedOption.value;
    return (!$688ea211cffbe405$var$shouldHideSelectedOptions(props) || !isSelected) && $688ea211cffbe405$var$_filterOption(props, {
        label: label,
        value: value,
        data: data
    }, inputValue);
}
function $688ea211cffbe405$var$getNextFocusedValue(state, nextSelectValue) {
    var focusedValue = state.focusedValue, lastSelectValue = state.selectValue;
    var lastFocusedIndex = lastSelectValue.indexOf(focusedValue);
    if (lastFocusedIndex > -1) {
        var nextFocusedIndex = nextSelectValue.indexOf(focusedValue);
        if (nextFocusedIndex > -1) // the focused value is still in the selectValue, return it
        return focusedValue;
        else if (lastFocusedIndex < nextSelectValue.length) // the focusedValue is not present in the next selectValue array by
        // reference, so return the new value at the same index
        return nextSelectValue[lastFocusedIndex];
    }
    return null;
}
function $688ea211cffbe405$var$getNextFocusedOption(state, options) {
    var lastFocusedOption = state.focusedOption;
    return lastFocusedOption && options.indexOf(lastFocusedOption) > -1 ? lastFocusedOption : options[0];
}
var $688ea211cffbe405$var$getFocusedOptionId = function getFocusedOptionId(focusableOptionsWithIds, focusedOption) {
    var _focusableOptionsWith;
    var focusedOptionId = (_focusableOptionsWith = focusableOptionsWithIds.find(function(option) {
        return option.data === focusedOption;
    })) === null || _focusableOptionsWith === void 0 ? void 0 : _focusableOptionsWith.id;
    return focusedOptionId || null;
};
var $688ea211cffbe405$var$getOptionLabel = function getOptionLabel(props, data) {
    return props.getOptionLabel(data);
};
var $688ea211cffbe405$var$getOptionValue = function getOptionValue(props, data) {
    return props.getOptionValue(data);
};
function $688ea211cffbe405$var$_isOptionDisabled(props, option, selectValue) {
    return typeof props.isOptionDisabled === 'function' ? props.isOptionDisabled(option, selectValue) : false;
}
function $688ea211cffbe405$var$_isOptionSelected(props, option, selectValue) {
    if (selectValue.indexOf(option) > -1) return true;
    if (typeof props.isOptionSelected === 'function') return props.isOptionSelected(option, selectValue);
    var candidate = $688ea211cffbe405$var$getOptionValue(props, option);
    return selectValue.some(function(i) {
        return $688ea211cffbe405$var$getOptionValue(props, i) === candidate;
    });
}
function $688ea211cffbe405$var$_filterOption(props, option, inputValue) {
    return props.filterOption ? props.filterOption(option, inputValue) : true;
}
var $688ea211cffbe405$var$shouldHideSelectedOptions = function shouldHideSelectedOptions(props) {
    var hideSelectedOptions = props.hideSelectedOptions, isMulti = props.isMulti;
    if (hideSelectedOptions === undefined) return isMulti;
    return hideSelectedOptions;
};
var $688ea211cffbe405$var$instanceId = 1;
// eslint-disable-next-line @repo/internal/react/no-class-components
var $688ea211cffbe405$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_Component) {
    // Lifecycle
    // ------------------------------
    function Select(_props) {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, Select);
        _this = $688ea211cffbe405$var$_callSuper(this, Select, [
            _props
        ]);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "state", {
            ariaSelection: null,
            focusedOption: null,
            focusedOptionId: null,
            focusableOptionsWithIds: [],
            focusedValue: null,
            focusedValueId: null,
            inputIsHidden: false,
            isFocused: false,
            selectValue: [],
            clearFocusValueOnUpdate: false,
            prevWasFocused: false,
            inputIsHiddenAfterUpdate: undefined,
            prevProps: undefined,
            instancePrefix: ''
        });
        // Misc. Instance Properties
        // ------------------------------
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "blockOptionHover", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "isComposing", false);
        // TODO
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "initialTouchX", 0);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "initialTouchY", 0);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "openAfterFocus", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "scrollToFocusedOptionOnUpdate", false);
        // Refs
        // ------------------------------
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "controlRef", null);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "getControlRef", function(ref) {
            _this.controlRef = ref;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "focusedOptionRef", null);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "getFocusedOptionRef", function(ref) {
            _this.focusedOptionRef = ref;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "menuListRef", null);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "getMenuListRef", function(ref) {
            _this.menuListRef = ref;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "inputRef", null);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "getInputRef", function(ref) {
            _this.inputRef = ref;
        });
        // aliased for consumers
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "focus", _this.focusInput);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "blur", _this.blurInput);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "onChange", function(newValue, actionMeta) {
            var _this$props = _this.props, onChange = _this$props.onChange, name = _this$props.name;
            actionMeta.name = name;
            _this.ariaOnChange(newValue, actionMeta);
            onChange(newValue, actionMeta);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "setValue", function(newValue, action, option) {
            var _this$props2 = _this.props, closeMenuOnSelect = _this$props2.closeMenuOnSelect, isMulti = _this$props2.isMulti, inputValue = _this$props2.inputValue, shouldKeepInputOnSelect = _this$props2.shouldKeepInputOnSelect;
            // for multiple selection options, do not clear the search input value
            if (isMulti && shouldKeepInputOnSelect && (0, $dU8Y3.fg)('platform_do_not_clear_input_for_multiselect')) _this.onInputChange(inputValue, {
                action: 'set-value',
                prevInputValue: inputValue
            });
            else _this.onInputChange('', {
                action: 'set-value',
                prevInputValue: inputValue
            });
            if (closeMenuOnSelect) {
                _this.setState({
                    inputIsHiddenAfterUpdate: !isMulti
                });
                _this.onMenuClose();
            }
            // when the select value should change, we should reset focusedValue
            _this.setState({
                clearFocusValueOnUpdate: true
            });
            _this.onChange(newValue, {
                action: action,
                option: option
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "selectOption", function(newValue) {
            var _this$props3 = _this.props, blurInputOnSelect = _this$props3.blurInputOnSelect, isMulti = _this$props3.isMulti, name = _this$props3.name;
            var selectValue = _this.state.selectValue;
            var deselected = isMulti && _this.isOptionSelected(newValue, selectValue);
            var isDisabled = _this.isOptionDisabled(newValue, selectValue);
            if (deselected) {
                var candidate = _this.getOptionValue(newValue);
                _this.setValue((0, $c6f45647f62090f7$export$d1ca752ec761b95b)(selectValue.filter(function(i) {
                    return _this.getOptionValue(i) !== candidate;
                })), 'deselect-option', newValue);
            } else if (!isDisabled) {
                // Select option if option is not disabled
                if (isMulti) _this.setValue((0, $c6f45647f62090f7$export$d1ca752ec761b95b)([].concat((0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(selectValue), [
                    newValue
                ])), 'select-option', newValue);
                else _this.setValue((0, $c6f45647f62090f7$export$dea4763e29237f4c)(newValue), 'select-option');
            } else {
                _this.ariaOnChange((0, $c6f45647f62090f7$export$dea4763e29237f4c)(newValue), {
                    action: 'select-option',
                    option: newValue,
                    name: name
                });
                return;
            }
            if (blurInputOnSelect) _this.blurInput();
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "removeValue", function(removedValue) {
            var isMulti = _this.props.isMulti;
            var selectValue = _this.state.selectValue;
            var candidate = _this.getOptionValue(removedValue);
            var newValueArray = selectValue.filter(function(i) {
                return _this.getOptionValue(i) !== candidate;
            });
            var newValue = (0, $c6f45647f62090f7$export$40fb9515c784cc3b)(isMulti, newValueArray, newValueArray[0] || null);
            _this.onChange(newValue, {
                action: 'remove-value',
                removedValue: removedValue
            });
            _this.focusInput();
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "clearValue", function() {
            var selectValue = _this.state.selectValue;
            _this.onChange((0, $c6f45647f62090f7$export$40fb9515c784cc3b)(_this.props.isMulti, [], null), {
                action: 'clear',
                removedValues: selectValue
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "popValue", function() {
            var isMulti = _this.props.isMulti;
            var selectValue = _this.state.selectValue;
            var lastSelectedValue = selectValue[selectValue.length - 1];
            var newValueArray = selectValue.slice(0, selectValue.length - 1);
            var newValue = (0, $c6f45647f62090f7$export$40fb9515c784cc3b)(isMulti, newValueArray, newValueArray[0] || null);
            _this.onChange(newValue, {
                action: 'pop-value',
                removedValue: lastSelectedValue
            });
        });
        // ==============================
        // Getters
        // ==============================
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "getFocusedOptionId", function(focusedOption) {
            return $688ea211cffbe405$var$getFocusedOptionId(_this.state.focusableOptionsWithIds, focusedOption);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "getFocusableOptionsWithIds", function() {
            return $688ea211cffbe405$var$buildFocusableOptionsWithIds($688ea211cffbe405$var$buildCategorizedOptions(_this.props, _this.state.selectValue), _this.getElementId('option'));
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "getValue", function() {
            return _this.state.selectValue;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "cx", function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            return (0, $c6f45647f62090f7$export$ce4ab0c55987d1ff).apply(void 0, [
                _this.props.classNamePrefix
            ].concat(args));
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "getOptionLabel", function(data) {
            return $688ea211cffbe405$var$getOptionLabel(_this.props, data);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "getOptionValue", function(data) {
            return $688ea211cffbe405$var$getOptionValue(_this.props, data);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "getStyles", function(key, props) {
            var base = (0, $9a0e9b732d07073d$export$214b055320e0bf32)[key](props);
            base.boxSizing = 'border-box';
            var custom = _this.props.styles[key];
            if (!custom) return base;
            var customStyles = (0, $c6f45647f62090f7$export$bf2eda47afa5f369)(custom(base, props));
            return customStyles;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "getClassNames", function(key, props) {
            var _this$props$className, _this$props$className2;
            return (_this$props$className = (_this$props$className2 = _this.props.classNames)[key]) === null || _this$props$className === void 0 ? void 0 : _this$props$className.call(_this$props$className2, props);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "getElementId", function(element) {
            return "".concat(_this.state.instancePrefix, "-").concat(element);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "getComponents", function() {
            return (0, $de5e6bb37d0375f4$export$71abc632aa29e6fe)(_this.props);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "buildCategorizedOptions", function() {
            return $688ea211cffbe405$var$buildCategorizedOptions(_this.props, _this.state.selectValue);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "getCategorizedOptions", function() {
            return _this.props.menuIsOpen ? _this.buildCategorizedOptions() : [];
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "buildFocusableOptions", function() {
            return $688ea211cffbe405$var$buildFocusableOptionsFromCategorizedOptions(_this.buildCategorizedOptions());
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "getFocusableOptions", function() {
            return _this.props.menuIsOpen ? _this.buildFocusableOptions() : [];
        });
        // ==============================
        // Helpers
        // ==============================
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "ariaOnChange", function(value, actionMeta) {
            _this.setState({
                ariaSelection: $688ea211cffbe405$var$_objectSpread({
                    value: value
                }, actionMeta)
            });
        });
        // ==============================
        // Mouse Handlers
        // ==============================
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "onMenuMouseDown", function(event) {
            if (event.button !== 0) return;
            event.stopPropagation();
            event.preventDefault();
            _this.focusInput();
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "onMenuMouseMove", function(_) {
            _this.blockOptionHover = false;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "onControlMouseDown", function(event) {
            // Event captured by dropdown indicator
            if (event.defaultPrevented) {
                var _this$controlRef;
                // react-dnd will fire preventDefault in mouseDown, which make select is not clickable.
                // temp workaround to check if select is within dnd, we don't do the early return.
                if (!((_this$controlRef = _this.controlRef) !== null && _this$controlRef !== void 0 && _this$controlRef.closest('[data-rbd-draggable-context-id]'))) return;
            }
            var openMenuOnClick = _this.props.openMenuOnClick;
            if (!_this.state.isFocused) {
                if (openMenuOnClick) _this.openAfterFocus = true;
                _this.focusInput();
            } else if (!_this.props.menuIsOpen) {
                if (openMenuOnClick) _this.openMenu('first');
            } else if (event.target.tagName !== 'INPUT' && event.target.tagName !== 'TEXTAREA') _this.onMenuClose();
            if (event.target.tagName !== 'INPUT' && event.target.tagName !== 'TEXTAREA') event.preventDefault();
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "onDropdownIndicatorMouseDown", function(event) {
            // ignore mouse events that weren't triggered by the primary button
            if (event && event.type === 'mousedown' && event.button !== 0) return;
            if (_this.props.isDisabled) return;
            var _this$props4 = _this.props, isMulti = _this$props4.isMulti, menuIsOpen = _this$props4.menuIsOpen;
            _this.focusInput();
            if (menuIsOpen) {
                _this.setState({
                    inputIsHiddenAfterUpdate: !isMulti
                });
                _this.onMenuClose();
            } else _this.openMenu('first');
            event.preventDefault();
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "onClearIndicatorMouseDown", function(event) {
            // ignore mouse events that weren't triggered by the primary button
            if (event && event.type === 'mousedown' && event.button !== 0) return;
            _this.clearValue();
            event.preventDefault();
            _this.openAfterFocus = false;
            if (event.type === 'touchend') _this.focusInput();
            else setTimeout(function() {
                return _this.focusInput();
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "onScroll", function(event) {
            if (typeof _this.props.closeMenuOnScroll === 'boolean') {
                if (event.target instanceof HTMLElement && (0, $c6f45647f62090f7$export$d8a62a489b442872)(event.target)) _this.props.onMenuClose();
            } else if (typeof _this.props.closeMenuOnScroll === 'function') {
                if (_this.props.closeMenuOnScroll(event)) _this.props.onMenuClose();
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "onCompositionStart", function() {
            _this.isComposing = true;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "onCompositionEnd", function() {
            _this.isComposing = false;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "onTouchStart", function(_ref2) {
            var touches = _ref2.touches;
            var touch = touches && touches.item(0);
            if (!touch) return;
            _this.initialTouchX = touch.clientX;
            _this.initialTouchY = touch.clientY;
            _this.userIsDragging = false;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "onTouchMove", function(_ref3) {
            var touches = _ref3.touches;
            var touch = touches && touches.item(0);
            if (!touch) return;
            var deltaX = Math.abs(touch.clientX - _this.initialTouchX);
            var deltaY = Math.abs(touch.clientY - _this.initialTouchY);
            var moveThreshold = 5;
            _this.userIsDragging = deltaX > moveThreshold || deltaY > moveThreshold;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "onTouchEnd", function(event) {
            if (_this.userIsDragging) return;
            // close the menu if the user taps outside
            // we're checking on event.target here instead of event.currentTarget, because we want to assert information
            // on events on child elements, not the document (which we've attached this handler to).
            if (_this.controlRef && !_this.controlRef.contains(event.target) && _this.menuListRef && !_this.menuListRef.contains(event.target)) _this.blurInput();
            // reset move vars
            _this.initialTouchX = 0;
            _this.initialTouchY = 0;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "onControlTouchEnd", function(event) {
            if (_this.userIsDragging) return;
            _this.onControlMouseDown(event);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "onClearIndicatorTouchEnd", function(event) {
            if (_this.userIsDragging) return;
            _this.onClearIndicatorMouseDown(event);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "onDropdownIndicatorTouchEnd", function(event) {
            if (_this.userIsDragging) return;
            _this.onDropdownIndicatorMouseDown(event);
        });
        // ==============================
        // Focus Handlers
        // ==============================
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "handleInputChange", function(event) {
            var prevInputValue = _this.props.inputValue;
            var inputValue = event.currentTarget.value;
            _this.setState({
                inputIsHiddenAfterUpdate: false
            });
            _this.onInputChange(inputValue, {
                action: 'input-change',
                prevInputValue: prevInputValue
            });
            if (!_this.props.menuIsOpen) _this.onMenuOpen();
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "onInputFocus", function(event) {
            if (_this.props.onFocus) _this.props.onFocus(event);
            _this.setState({
                inputIsHiddenAfterUpdate: false,
                isFocused: true
            });
            if (_this.openAfterFocus || _this.props.openMenuOnFocus) _this.openMenu('first');
            _this.openAfterFocus = false;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "onInputBlur", function(event) {
            var prevInputValue = _this.props.inputValue;
            if (_this.menuListRef && _this.menuListRef.contains(document.activeElement)) {
                _this.inputRef.focus();
                return;
            }
            if (_this.props.onBlur) _this.props.onBlur(event);
            _this.onInputChange('', {
                action: 'input-blur',
                prevInputValue: prevInputValue
            });
            if ((0, $dU8Y3.fg)('platform_dst_select_menu_close_on_blur')) // when fg is enabled, we only call onMenuClose when this.props.menuIsOpen is true.
            _this.props.menuIsOpen && _this.onMenuClose();
            else _this.onMenuClose();
            _this.setState({
                focusedValue: null,
                isFocused: false
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "onOptionHover", function(focusedOption) {
            if (_this.blockOptionHover || _this.state.focusedOption === focusedOption) return;
            var options = _this.getFocusableOptions();
            var focusedOptionIndex = options.indexOf(focusedOption);
            _this.setState({
                focusedOption: focusedOption,
                focusedOptionId: focusedOptionIndex > -1 ? _this.getFocusedOptionId(focusedOption) : null
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "shouldHideSelectedOptions", function() {
            return $688ea211cffbe405$var$shouldHideSelectedOptions(_this.props);
        });
        // If the hidden input gets focus through form submit,
        // redirect focus to focusable input.
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "onValueInputFocus", function(e) {
            e.preventDefault();
            e.stopPropagation();
            _this.focus();
        });
        // ==============================
        // Keyboard Handlers
        // ==============================
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "onKeyDown", function(event) {
            var _this$props5 = _this.props, isMulti = _this$props5.isMulti, backspaceRemovesValue = _this$props5.backspaceRemovesValue, escapeClearsValue = _this$props5.escapeClearsValue, inputValue = _this$props5.inputValue, isClearable = _this$props5.isClearable, isDisabled = _this$props5.isDisabled, menuIsOpen = _this$props5.menuIsOpen, onKeyDown = _this$props5.onKeyDown, tabSelectsValue = _this$props5.tabSelectsValue, openMenuOnFocus = _this$props5.openMenuOnFocus, shouldPreventEscapePropagation = _this$props5.shouldPreventEscapePropagation;
            var _this$state = _this.state, focusedOption = _this$state.focusedOption, focusedValue = _this$state.focusedValue, selectValue = _this$state.selectValue;
            if (isDisabled) return;
            if (typeof onKeyDown === 'function') {
                onKeyDown(event);
                if (event.defaultPrevented) return;
            }
            // Block option hover events when the user has just pressed a key
            _this.blockOptionHover = true;
            switch(event.key){
                case 'ArrowLeft':
                    if (!isMulti || inputValue) return;
                    _this.focusValue('previous');
                    break;
                case 'ArrowRight':
                    if (!isMulti || inputValue) return;
                    _this.focusValue('next');
                    break;
                case 'Delete':
                case 'Backspace':
                    if (inputValue) return;
                    if (focusedValue) _this.removeValue(focusedValue);
                    else {
                        if (!backspaceRemovesValue) return;
                        if (isMulti) _this.popValue();
                        else if (isClearable) _this.clearValue();
                    }
                    break;
                case 'Tab':
                    if (_this.isComposing) return;
                    if (event.shiftKey || !menuIsOpen || !tabSelectsValue || !focusedOption || // don't capture the event if the menu opens on focus and the focused
                    // option is already selected; it breaks the flow of navigation
                    openMenuOnFocus && _this.isOptionSelected(focusedOption, selectValue)) return;
                    _this.selectOption(focusedOption);
                    break;
                case 'Enter':
                    if (event.keyCode === 229) break;
                    if (focusedValue) _this.removeValue(focusedValue);
                    if (menuIsOpen) {
                        if (!focusedOption) return;
                        if (_this.isComposing) return;
                        _this.selectOption(focusedOption);
                        break;
                    }
                    return;
                case 'Escape':
                    if (menuIsOpen) {
                        _this.setState({
                            inputIsHiddenAfterUpdate: false
                        });
                        _this.onInputChange('', {
                            action: 'menu-close',
                            prevInputValue: inputValue
                        });
                        _this.onMenuClose();
                        if (shouldPreventEscapePropagation && event.target instanceof HTMLElement) event.stopPropagation();
                    } else if (isClearable && escapeClearsValue) _this.clearValue();
                    break;
                case ' ':
                    // space
                    if (inputValue) return;
                    if (!menuIsOpen) {
                        _this.openMenu('first');
                        break;
                    }
                    if (!focusedOption) return;
                    _this.selectOption(focusedOption);
                    break;
                case 'ArrowUp':
                    if (menuIsOpen) _this.focusOption('up');
                    else _this.openMenu('last');
                    break;
                case 'ArrowDown':
                    if (menuIsOpen) _this.focusOption('down');
                    else _this.openMenu('first');
                    break;
                case 'PageUp':
                    if (!menuIsOpen) return;
                    _this.focusOption('pageup');
                    break;
                case 'PageDown':
                    if (!menuIsOpen) return;
                    _this.focusOption('pagedown');
                    break;
                case 'Home':
                    if (!menuIsOpen) return;
                    _this.focusOption('first');
                    break;
                case 'End':
                    if (!menuIsOpen) return;
                    _this.focusOption('last');
                    break;
                default:
                    return;
            }
            event.preventDefault();
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "handleOpenLayerObserverCloseSignal", function() {
            _this.onMenuClose();
        });
        _this.state.instancePrefix = 'react-select-' + (_this.props.instanceId || ++$688ea211cffbe405$var$instanceId);
        _this.state.selectValue = (0, $c6f45647f62090f7$export$33f062f47f21a01)(_props.value);
        // Set focusedOption if menuIsOpen is set on init (e.g. defaultMenuIsOpen)
        if (_props.menuIsOpen) {
            var focusableOptionsWithIds = _this.getFocusableOptionsWithIds();
            var focusableOptions = _this.buildFocusableOptions();
            var optionIndex = focusableOptions.indexOf(_this.state.selectValue[0]);
            _this.state.focusableOptionsWithIds = focusableOptionsWithIds;
            _this.state.focusedOption = focusableOptions[optionIndex];
            _this.state.focusedOptionId = $688ea211cffbe405$var$getFocusedOptionId(focusableOptionsWithIds, focusableOptions[optionIndex]);
        }
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($eyuDe)))(Select, _Component);
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(Select, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this.startListeningComposition();
                this.startListeningToTouch();
                if (this.props.closeMenuOnScroll && document && document.addEventListener) // Listen to all scroll events, and filter them out inside of 'onScroll'
                // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                document.addEventListener('scroll', this.onScroll, true);
                if (this.props.autoFocus) this.focusInput();
                // Scroll focusedOption into view if menuIsOpen is set on mount (e.g. defaultMenuIsOpen)
                if (this.props.menuIsOpen && this.state.focusedOption && this.menuListRef && this.focusedOptionRef) (0, $c6f45647f62090f7$export$53a0910f038337bd)(this.menuListRef, this.focusedOptionRef);
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps) {
                var _this$props6 = this.props, isDisabled = _this$props6.isDisabled, menuIsOpen = _this$props6.menuIsOpen;
                var isFocused = this.state.isFocused;
                if (// ensure focus is restored correctly when the control becomes enabled
                isFocused && !isDisabled && prevProps.isDisabled || // ensure focus is on the Input when the menu opens
                isFocused && menuIsOpen && !prevProps.menuIsOpen) this.focusInput();
                if (isFocused && isDisabled && !prevProps.isDisabled) // ensure select state gets blurred in case Select is programmatically disabled while focused
                this.setState({
                    isFocused: false
                }, this.onMenuClose);
                else if (!isFocused && !isDisabled && prevProps.isDisabled && this.inputRef === document.activeElement) // ensure select state gets focused in case Select is programatically re-enabled while focused (Firefox)
                this.setState({
                    isFocused: true
                });
                // scroll the focused option into view if necessary
                if (this.menuListRef && this.focusedOptionRef && this.scrollToFocusedOptionOnUpdate) {
                    (0, $c6f45647f62090f7$export$53a0910f038337bd)(this.menuListRef, this.focusedOptionRef);
                    this.scrollToFocusedOptionOnUpdate = false;
                }
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this.stopListeningComposition();
                this.stopListeningToTouch();
                // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                document.removeEventListener('scroll', this.onScroll, true);
            }
        },
        {
            key: "onMenuOpen",
            value: function onMenuOpen() {
                this.props.onMenuOpen();
            }
        },
        {
            key: "onMenuClose",
            value: function onMenuClose() {
                this.onInputChange('', {
                    action: 'menu-close',
                    prevInputValue: this.props.inputValue
                });
                this.props.onMenuClose();
            }
        },
        {
            key: "onInputChange",
            value: function onInputChange(newValue, actionMeta) {
                this.props.onInputChange(newValue, actionMeta);
            }
        },
        {
            key: "focusInput",
            value: function focusInput() {
                if (!this.inputRef) return;
                this.inputRef.focus();
            }
        },
        {
            key: "blurInput",
            value: function blurInput() {
                if (!this.inputRef) return;
                this.inputRef.blur();
            }
        },
        {
            key: "openMenu",
            value: function openMenu(focusOption) {
                var _this2 = this;
                var _this$state2 = this.state, selectValue = _this$state2.selectValue, isFocused = _this$state2.isFocused;
                var focusableOptions = this.buildFocusableOptions();
                var openAtIndex = focusOption === 'first' ? 0 : focusableOptions.length - 1;
                if (!this.props.isMulti) {
                    var selectedIndex = focusableOptions.indexOf(selectValue[0]);
                    if (selectedIndex > -1) openAtIndex = selectedIndex;
                }
                var focusedOption = focusableOptions[openAtIndex];
                // only scroll if the menu isn't already open
                this.scrollToFocusedOptionOnUpdate = !(isFocused && this.menuListRef);
                this.setState({
                    inputIsHiddenAfterUpdate: false,
                    focusedValue: null,
                    focusedOption: focusedOption,
                    focusedOptionId: this.getFocusedOptionId(focusedOption)
                }, function() {
                    return _this2.onMenuOpen();
                });
                (0, $dJ32z.isSafari)() && focusedOption && this.updateInputLabel(this.calculateInputLabel(focusedOption, openAtIndex));
            }
        },
        {
            key: "updateInputLabel",
            value: function updateInputLabel(inputLabel) {
                var _this3 = this;
                if (inputLabel) {
                    var _this$inputRef;
                    (_this$inputRef = this.inputRef) === null || _this$inputRef === void 0 || _this$inputRef.setAttribute('aria-label', inputLabel);
                    setTimeout(function() {
                        var normalizedLabel = _this3.props['aria-label'] || _this3.props.label;
                        if (normalizedLabel) {
                            var _this3$inputRef;
                            (_this3$inputRef = _this3.inputRef) === null || _this3$inputRef === void 0 || _this3$inputRef.setAttribute('aria-label', normalizedLabel);
                        } else {
                            var _this3$inputRef2;
                            (_this3$inputRef2 = _this3.inputRef) === null || _this3$inputRef2 === void 0 || _this3$inputRef2.removeAttribute('aria-label');
                        }
                    }, 500);
                }
            }
        },
        {
            key: "calculateInputLabel",
            value: function calculateInputLabel(focusedOption, optionIndex) {
                var _this4 = this;
                var options = this.props.options;
                var isOptionsGrouped = options === null || options === void 0 ? void 0 : options.every(function(obj) {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(obj) === 'object' && obj !== null && 'options' in obj;
                });
                var inputLabel = this.getOptionLabel(focusedOption);
                var isOptionFocused = function isOptionFocused(option) {
                    return _this4.getOptionLabel(option) === inputLabel;
                };
                var groupData = options === null || options === void 0 ? void 0 : options.find(function(option) {
                    var _groupCandidate$optio, _groupCandidate$optio2;
                    var groupCandidate = option;
                    return (_groupCandidate$optio = (_groupCandidate$optio2 = groupCandidate.options) === null || _groupCandidate$optio2 === void 0 ? void 0 : _groupCandidate$optio2.some(isOptionFocused)) !== null && _groupCandidate$optio !== void 0 ? _groupCandidate$optio : false;
                });
                if (isOptionsGrouped) {
                    var _groupData$options$fi;
                    var groupOptionIndex = (_groupData$options$fi = groupData === null || groupData === void 0 ? void 0 : groupData.options.findIndex(isOptionFocused)) !== null && _groupData$options$fi !== void 0 ? _groupData$options$fi : 0;
                    var totalLength = options === null || options === void 0 ? void 0 : options.reduce(function(acc, currentGroup) {
                        var _group$options;
                        var group = currentGroup;
                        acc += group === null || group === void 0 || (_group$options = group.options) === null || _group$options === void 0 ? void 0 : _group$options.length;
                        return acc;
                    }, 0);
                    inputLabel = "".concat(inputLabel, ", ").concat(groupData === null || groupData === void 0 ? void 0 : groupData.label, " (").concat(groupOptionIndex + 1, " of ").concat(totalLength, ")");
                } else inputLabel = "".concat(inputLabel, " (").concat(optionIndex + 1, " of ").concat(options === null || options === void 0 ? void 0 : options.length, ")");
                return inputLabel;
            }
        },
        {
            key: "focusValue",
            value: function focusValue(direction) {
                var _this$state3 = this.state, selectValue = _this$state3.selectValue, focusedValue = _this$state3.focusedValue;
                // Only multiselects support value focusing
                if (!this.props.isMulti) return;
                this.setState({
                    focusedOption: null
                });
                var focusedIndex = selectValue.indexOf(focusedValue);
                if (!focusedValue) focusedIndex = -1;
                var lastIndex = selectValue.length - 1;
                var nextFocus = -1;
                if (!selectValue.length) return;
                switch(direction){
                    case 'previous':
                        if (focusedIndex === 0) // don't cycle from the start to the end
                        nextFocus = 0;
                        else if (focusedIndex === -1) // if nothing is focused, focus the last value first
                        nextFocus = lastIndex;
                        else nextFocus = focusedIndex - 1;
                        break;
                    case 'next':
                        if (focusedIndex > -1 && focusedIndex < lastIndex) nextFocus = focusedIndex + 1;
                        break;
                }
                this.setState({
                    inputIsHidden: nextFocus !== -1,
                    focusedValue: selectValue[nextFocus],
                    focusedValueId: "".concat(this.getElementId('selected-value'), "-").concat(nextFocus, "-remove"),
                    focusedOption: null,
                    focusedOptionId: null
                });
            }
        },
        {
            key: "focusOption",
            value: function focusOption() {
                var direction = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'first';
                var pageSize = this.props.pageSize;
                var focusedOption = this.state.focusedOption;
                var options = this.getFocusableOptions();
                if (!options.length) return;
                var nextFocus = 0; // handles 'first'
                var focusedIndex = options.indexOf(focusedOption);
                if (!focusedOption) focusedIndex = -1;
                if (direction === 'up') nextFocus = focusedIndex > 0 ? focusedIndex - 1 : options.length - 1;
                else if (direction === 'down') nextFocus = (focusedIndex + 1) % options.length;
                else if (direction === 'pageup') {
                    nextFocus = focusedIndex - pageSize;
                    if (nextFocus < 0) nextFocus = 0;
                } else if (direction === 'pagedown') {
                    nextFocus = focusedIndex + pageSize;
                    if (nextFocus > options.length - 1) nextFocus = options.length - 1;
                } else if (direction === 'last') nextFocus = options.length - 1;
                this.scrollToFocusedOptionOnUpdate = true;
                this.setState({
                    focusedOption: options[nextFocus],
                    focusedValue: null,
                    focusedValueId: null,
                    focusedOptionId: this.getFocusedOptionId(options[nextFocus])
                });
            }
        },
        {
            key: "getCommonProps",
            value: function getCommonProps() {
                var clearValue = this.clearValue, cx = this.cx, getStyles = this.getStyles, getClassNames = this.getClassNames, getValue = this.getValue, selectOption = this.selectOption, setValue = this.setValue, props = this.props;
                var isMulti = props.isMulti, isRtl = props.isRtl, options = props.options;
                var hasValue = this.hasValue();
                return {
                    clearValue: clearValue,
                    cx: cx,
                    getStyles: getStyles,
                    getClassNames: getClassNames,
                    getValue: getValue,
                    hasValue: hasValue,
                    isMulti: isMulti,
                    isRtl: isRtl,
                    options: options,
                    selectOption: selectOption,
                    selectProps: props,
                    setValue: setValue
                };
            }
        },
        {
            key: "hasValue",
            value: function hasValue() {
                var selectValue = this.state.selectValue;
                return selectValue.length > 0;
            }
        },
        {
            key: "hasOptions",
            value: function hasOptions() {
                return !!this.getFocusableOptions().length;
            }
        },
        {
            key: "isClearable",
            value: function isClearable() {
                var _this$props7 = this.props, isClearable = _this$props7.isClearable, isMulti = _this$props7.isMulti;
                // single select, by default, IS NOT clearable
                // multi select, by default, IS clearable
                if (isClearable === undefined) return isMulti;
                return isClearable;
            }
        },
        {
            key: "isOptionDisabled",
            value: function isOptionDisabled(option, selectValue) {
                return $688ea211cffbe405$var$_isOptionDisabled(this.props, option, selectValue);
            }
        },
        {
            key: "isOptionSelected",
            value: function isOptionSelected(option, selectValue) {
                return $688ea211cffbe405$var$_isOptionSelected(this.props, option, selectValue);
            }
        },
        {
            key: "filterOption",
            value: function filterOption(option, inputValue) {
                return $688ea211cffbe405$var$_filterOption(this.props, option, inputValue);
            }
        },
        {
            key: "formatOptionLabel",
            value: function formatOptionLabel(data, context) {
                if (typeof this.props.formatOptionLabel === 'function') {
                    var inputValue = this.props.inputValue;
                    var selectValue = this.state.selectValue;
                    return this.props.formatOptionLabel(data, {
                        context: context,
                        inputValue: inputValue,
                        selectValue: selectValue
                    });
                } else return this.getOptionLabel(data);
            }
        },
        {
            key: "formatGroupLabel",
            value: function formatGroupLabel(data) {
                return this.props.formatGroupLabel(data);
            }
        },
        {
            key: "calculateDescription",
            value: function calculateDescription() {
                var descriptionProp = this.props['aria-describedby'] || this.props.descriptionId;
                var isMulti = this.props.isMulti;
                var hasValue = this.state.selectValue.length > 0;
                // Determine base description based on selection state
                var baseDescriptionId = hasValue ? isMulti ? '' : this.getElementId('single-value') : this.getElementId('placeholder');
                // Fast path for single select with no description prop
                if (!isMulti && !descriptionProp) return {
                    'aria-describedby': baseDescriptionId
                };
                // Build the describedby string efficiently
                var describedBy = baseDescriptionId;
                // Add description prop if it exists
                if (descriptionProp) describedBy = describedBy ? "".concat(descriptionProp, " ").concat(describedBy) : descriptionProp;
                // For multi-select, always add multi-message ID
                if (isMulti) {
                    var multiMessage = this.getElementId('multi-message');
                    describedBy = describedBy ? "".concat(describedBy, " ").concat(multiMessage) : multiMessage;
                }
                return {
                    'aria-describedby': describedBy
                };
            }
        },
        {
            key: "startListeningComposition",
            value: // ==============================
            // Composition Handlers
            // ==============================
            function startListeningComposition() {
                if (document && document.addEventListener) {
                    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                    document.addEventListener('compositionstart', this.onCompositionStart, false);
                    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                    document.addEventListener('compositionend', this.onCompositionEnd, false);
                }
            }
        },
        {
            key: "stopListeningComposition",
            value: function stopListeningComposition() {
                if (document && document.removeEventListener) {
                    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                    document.removeEventListener('compositionstart', this.onCompositionStart);
                    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                    document.removeEventListener('compositionend', this.onCompositionEnd);
                }
            }
        },
        {
            key: "startListeningToTouch",
            value: // ==============================
            // Touch Handlers
            // ==============================
            function startListeningToTouch() {
                if (document && document.addEventListener) {
                    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                    document.addEventListener('touchstart', this.onTouchStart, false);
                    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                    document.addEventListener('touchmove', this.onTouchMove, false);
                    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                    document.addEventListener('touchend', this.onTouchEnd, false);
                }
            }
        },
        {
            key: "stopListeningToTouch",
            value: function stopListeningToTouch() {
                if (document && document.removeEventListener) {
                    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                    document.removeEventListener('touchstart', this.onTouchStart);
                    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                    document.removeEventListener('touchmove', this.onTouchMove);
                    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                    document.removeEventListener('touchend', this.onTouchEnd);
                }
            }
        },
        {
            key: "renderInput",
            value: // ==============================
            // Renderers
            // ==============================
            function renderInput() {
                var _this$props8 = this.props, form = _this$props8.form, inputId = _this$props8.inputId, inputValue = _this$props8.inputValue, isDisabled = _this$props8.isDisabled, isInvalid = _this$props8.isInvalid, isRequired = _this$props8.isRequired, isSearchable = _this$props8.isSearchable, label = _this$props8.label, labelId = _this$props8.labelId, menuIsOpen = _this$props8.menuIsOpen, required = _this$props8.required, _this$props8$tabIndex = _this$props8.tabIndex, tabIndex = _this$props8$tabIndex === void 0 ? 0 : _this$props8$tabIndex, testId = _this$props8.testId;
                var _this$getComponents = this.getComponents(), Input = _this$getComponents.Input;
                var inputIsHidden = this.state.inputIsHidden;
                var commonProps = this.commonProps;
                var id = inputId || this.getElementId('input');
                // aria attributes makes the JSX "noisy", separated for clarity
                var ariaAttributes = $688ea211cffbe405$var$_objectSpread($688ea211cffbe405$var$_objectSpread($688ea211cffbe405$var$_objectSpread($688ea211cffbe405$var$_objectSpread({}, !this.props.isSearchable && (0, $dU8Y3.fg)('platform_fix_autocomplete_aria_for_select') ? {} : {
                    'aria-autocomplete': 'both'
                }), {}, {
                    'aria-errormessage': this.props['aria-errormessage'],
                    'aria-expanded': menuIsOpen,
                    // TODO: aria-haspopup is implied as listbox with role="combobox" and was deprecated for aria 1.2, we still might need to keep it for back compat
                    'aria-haspopup': this.props['UNSAFE_is_experimental_generic'] ? 'dialog' : 'listbox',
                    'aria-invalid': this.props['aria-invalid'] || isInvalid,
                    'aria-label': this.props['aria-label'] || label,
                    'aria-labelledby': this.props['aria-labelledby'] || labelId,
                    'aria-required': required || isRequired,
                    role: 'combobox',
                    'aria-activedescendant': this.props['UNSAFE_is_experimental_generic'] ? undefined : this.state.focusedOptionId || this.state.focusedValueId || undefined
                }, menuIsOpen && {
                    'aria-controls': this.getElementId('listbox')
                }), !isSearchable && {
                    'aria-readonly': true
                }), this.calculateDescription());
                if (!isSearchable) // use a dummy input to maintain focus/blur functionality
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $2c241b2b825c3040$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
                    id: id,
                    innerRef: this.getInputRef,
                    onBlur: this.onInputBlur,
                    onChange: (0, $c6f45647f62090f7$export$8793edee2d425525),
                    onFocus: this.onInputFocus,
                    disabled: isDisabled,
                    tabIndex: tabIndex,
                    inputMode: "none",
                    form: form,
                    value: "",
                    "data-testid": testId && "".concat(testId, "-select--input")
                }, ariaAttributes));
                // NOTE: Don't add the `name` prop to this Input, `name` is already a prop on the hidden input element that has the value of the select.
                // Adding `name` to this Input will cause unexpected behavior.
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(Input, (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, commonProps, {
                    autoCapitalize: "none",
                    autoComplete: "off",
                    autoCorrect: "off",
                    id: id,
                    testId: testId,
                    innerRef: this.getInputRef,
                    isDisabled: isDisabled,
                    isHidden: inputIsHidden,
                    onBlur: this.onInputBlur,
                    onChange: this.handleInputChange,
                    onFocus: this.onInputFocus,
                    spellCheck: "false",
                    tabIndex: tabIndex,
                    form: form,
                    type: "text",
                    value: inputValue
                }, ariaAttributes));
            }
        },
        {
            key: "renderPlaceholderOrValue",
            value: function renderPlaceholderOrValue() {
                var _this5 = this;
                var _this$getComponents2 = this.getComponents(), MultiValue = _this$getComponents2.MultiValue, MultiValueContainer = _this$getComponents2.MultiValueContainer, MultiValueLabel = _this$getComponents2.MultiValueLabel, MultiValueRemove = _this$getComponents2.MultiValueRemove, SingleValue = _this$getComponents2.SingleValue, Placeholder = _this$getComponents2.Placeholder;
                var commonProps = this.commonProps;
                var _this$props9 = this.props, controlShouldRenderValue = _this$props9.controlShouldRenderValue, isDisabled = _this$props9.isDisabled, isMulti = _this$props9.isMulti, inputValue = _this$props9.inputValue, placeholder = _this$props9.placeholder, testId = _this$props9.testId;
                var _this$state4 = this.state, selectValue = _this$state4.selectValue, focusedValue = _this$state4.focusedValue, isFocused = _this$state4.isFocused;
                if (!this.hasValue() || !controlShouldRenderValue) return inputValue ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(Placeholder, (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, commonProps, {
                    key: "placeholder",
                    isDisabled: isDisabled,
                    isFocused: isFocused,
                    innerProps: $688ea211cffbe405$var$_objectSpread({
                        id: this.getElementId('placeholder')
                    }, testId && {
                        'data-testid': "".concat(testId, "-select--placeholder")
                    })
                }), placeholder);
                if (isMulti) return selectValue.map(function(opt, index) {
                    var isOptionFocused = opt === focusedValue;
                    var key = "".concat(_this5.getOptionLabel(opt), "-").concat(_this5.getOptionValue(opt));
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(MultiValue, (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, commonProps, {
                        components: {
                            Container: MultiValueContainer,
                            Label: MultiValueLabel,
                            Remove: MultiValueRemove
                        },
                        isFocused: isOptionFocused,
                        isDisabled: isDisabled,
                        key: key,
                        index: index,
                        removeProps: $688ea211cffbe405$var$_objectSpread($688ea211cffbe405$var$_objectSpread({
                            onClick: function onClick() {
                                return _this5.removeValue(opt);
                            },
                            onTouchEnd: function onTouchEnd() {
                                return _this5.removeValue(opt);
                            },
                            onMouseDown: function onMouseDown(e) {
                                e.preventDefault();
                            }
                        }, testId && {
                            'data-testid': "".concat(testId, "-select--multivalue-").concat(index, "-remove")
                        }), {}, {
                            id: "".concat(_this5.getElementId('selected-value'), "-").concat(index, "-remove")
                        }),
                        data: opt,
                        innerProps: $688ea211cffbe405$var$_objectSpread($688ea211cffbe405$var$_objectSpread({}, testId && {
                            'data-testid': "".concat(testId, "-select--multivalue-").concat(index)
                        }), {}, {
                            id: "".concat(_this5.getElementId('selected-value'), "-").concat(index)
                        })
                    }), _this5.formatOptionLabel(opt, 'value'));
                });
                if (inputValue) return null;
                var singleValue = selectValue[0];
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(SingleValue, (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, commonProps, {
                    data: singleValue,
                    isDisabled: isDisabled,
                    innerProps: {
                        id: this.getElementId('single-value')
                    }
                }), this.formatOptionLabel(singleValue, 'value'));
            }
        },
        {
            key: "renderClearIndicator",
            value: function renderClearIndicator() {
                var _this$getComponents3 = this.getComponents(), ClearIndicator = _this$getComponents3.ClearIndicator;
                var commonProps = this.commonProps;
                var _this$props0 = this.props, clearControlLabel = _this$props0.clearControlLabel, isDisabled = _this$props0.isDisabled, isLoading = _this$props0.isLoading, spacing = _this$props0.spacing, testId = _this$props0.testId;
                var isFocused = this.state.isFocused;
                if (!this.isClearable() || !ClearIndicator || isDisabled || !this.hasValue() || isLoading) return null;
                var innerProps = $688ea211cffbe405$var$_objectSpread({
                    onMouseDown: this.onClearIndicatorMouseDown,
                    onTouchEnd: this.onClearIndicatorTouchEnd
                }, testId && {
                    'data-testid': "".concat(testId, "-select--clear-indicator")
                });
                var isCompact = spacing === 'compact';
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(ClearIndicator, (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
                    clearControlLabel: clearControlLabel
                }, commonProps, {
                    innerProps: innerProps,
                    isFocused: isFocused,
                    isCompact: isCompact
                }));
            }
        },
        {
            key: "renderLoadingIndicator",
            value: function renderLoadingIndicator() {
                var _this$getComponents4 = this.getComponents(), LoadingIndicator = _this$getComponents4.LoadingIndicator;
                var commonProps = this.commonProps;
                var _this$props1 = this.props, isDisabled = _this$props1.isDisabled, isLoading = _this$props1.isLoading, spacing = _this$props1.spacing, testId = _this$props1.testId;
                var isFocused = this.state.isFocused;
                if (!LoadingIndicator || !isLoading) return null;
                var isCompact = spacing === 'compact';
                var innerProps = {
                    'aria-hidden': 'true'
                };
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(LoadingIndicator, (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
                    "data-testid": testId && "".concat(testId, "-select--loading-indicator")
                }, commonProps, {
                    innerProps: innerProps,
                    isDisabled: isDisabled,
                    isFocused: isFocused,
                    isCompact: isCompact
                }));
            }
        },
        {
            key: "renderDropdownIndicator",
            value: function renderDropdownIndicator() {
                var _this$getComponents5 = this.getComponents(), DropdownIndicator = _this$getComponents5.DropdownIndicator;
                if (!DropdownIndicator) return null;
                var commonProps = this.commonProps;
                var _this$props10 = this.props, isDisabled = _this$props10.isDisabled, spacing = _this$props10.spacing, testId = _this$props10.testId;
                var isFocused = this.state.isFocused;
                var isCompact = spacing === 'compact';
                var innerProps = $688ea211cffbe405$var$_objectSpread({
                    onMouseDown: this.onDropdownIndicatorMouseDown,
                    onTouchEnd: this.onDropdownIndicatorTouchEnd,
                    'aria-hidden': 'true'
                }, testId && {
                    'data-testid': "".concat(testId, "-select--dropdown-indicator")
                });
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(DropdownIndicator, (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, commonProps, {
                    innerProps: innerProps,
                    isDisabled: isDisabled,
                    isFocused: isFocused,
                    isCompact: isCompact
                }));
            }
        },
        {
            key: "renderMenu",
            value: function renderMenu() {
                var _this6 = this;
                var _this$getComponents6 = this.getComponents(), Group = _this$getComponents6.Group, GroupHeading = _this$getComponents6.GroupHeading, Menu = _this$getComponents6.Menu, MenuList = _this$getComponents6.MenuList, MenuPortal = _this$getComponents6.MenuPortal, LoadingMessage = _this$getComponents6.LoadingMessage, NoOptionsMessage = _this$getComponents6.NoOptionsMessage, Option = _this$getComponents6.Option;
                var commonProps = this.commonProps;
                var focusedOption = this.state.focusedOption;
                var _this$props11 = this.props, captureMenuScroll = _this$props11.captureMenuScroll, inputValue = _this$props11.inputValue, isLoading = _this$props11.isLoading, loadingMessage = _this$props11.loadingMessage, minMenuHeight = _this$props11.minMenuHeight, maxMenuHeight = _this$props11.maxMenuHeight, menuIsOpen = _this$props11.menuIsOpen, menuPlacement = _this$props11.menuPlacement, menuPosition = _this$props11.menuPosition, menuPortalTarget = _this$props11.menuPortalTarget, menuShouldBlockScroll = _this$props11.menuShouldBlockScroll, menuShouldScrollIntoView = _this$props11.menuShouldScrollIntoView, noOptionsMessage = _this$props11.noOptionsMessage, onMenuScrollToTop = _this$props11.onMenuScrollToTop, onMenuScrollToBottom = _this$props11.onMenuScrollToBottom, testId = _this$props11.testId;
                if (!menuIsOpen) return null;
                // TODO: Internal Option Type here
                var render = function render(props, id, headingId) {
                    var type = props.type, data = props.data, isDisabled = props.isDisabled, isSelected = props.isSelected, label = props.label, value = props.value;
                    var isFocused = focusedOption === data;
                    var onHover = isDisabled ? undefined : function() {
                        return _this6.onOptionHover(data);
                    };
                    var onSelect = isDisabled ? undefined : function() {
                        return _this6.selectOption(data);
                    };
                    var optionId = "".concat(_this6.getElementId('option'), "-").concat(id);
                    var innerProps = $688ea211cffbe405$var$_objectSpread({
                        id: optionId,
                        onClick: onSelect,
                        onMouseMove: onHover,
                        onMouseOver: onHover,
                        role: _this6.props['UNSAFE_is_experimental_generic'] ? 'listitem' : 'option',
                        'aria-selected': _this6.props['UNSAFE_is_experimental_generic'] ? undefined : isSelected,
                        // We don't want aria-disabled if it's false. It's just noisy.
                        'aria-disabled': !isDisabled ? undefined : isDisabled,
                        'aria-describedby': headingId
                    }, testId && {
                        'data-testid': "".concat(testId, "-select--option-").concat(id)
                    });
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(Option, (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, commonProps, {
                        innerProps: innerProps,
                        data: data,
                        isDisabled: isDisabled,
                        isSelected: isSelected,
                        key: optionId,
                        label: label,
                        type: type,
                        value: value,
                        isFocused: isFocused,
                        innerRef: isFocused ? _this6.getFocusedOptionRef : undefined
                    }), _this6.formatOptionLabel(props.data, 'menu'));
                };
                var menuUI;
                if (this.hasOptions()) {
                    var items = this.getCategorizedOptions();
                    menuUI = items.map(function(item) {
                        if (item.type === 'group') {
                            var data = item.data, options = item.options, groupIndex = item.index;
                            var groupId = "".concat(_this6.getElementId('group'), "-").concat(groupIndex);
                            var headingId = "".concat(groupId, "-heading");
                            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(Group, (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, commonProps, {
                                key: groupId,
                                data: data,
                                options: options,
                                Heading: GroupHeading,
                                headingProps: $688ea211cffbe405$var$_objectSpread({
                                    id: headingId,
                                    data: item.data
                                }, testId && {
                                    'data-testid': "".concat(testId, "-select--group-").concat(groupIndex, "-heading")
                                }),
                                label: _this6.formatGroupLabel(item.data)
                            }), item.options.map(function(option) {
                                return render(option, "".concat(groupIndex, "-").concat(option.index), headingId);
                            }));
                        } else if (item.type === 'option') return render(item, "".concat(item.index));
                        return undefined;
                    });
                } else if (isLoading) {
                    var message = loadingMessage({
                        inputValue: inputValue
                    });
                    if (message === null) return null;
                    menuUI = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(LoadingMessage, commonProps, message);
                } else {
                    var _message = noOptionsMessage({
                        inputValue: inputValue
                    });
                    if (_message === null) return null;
                    menuUI = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(NoOptionsMessage, (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, commonProps, {
                        innerProps: $688ea211cffbe405$var$_objectSpread({}, testId && {
                            'data-testid': "".concat(testId, "-select--no-options")
                        })
                    }), _message);
                }
                var menuPlacementProps = {
                    minMenuHeight: minMenuHeight,
                    maxMenuHeight: maxMenuHeight,
                    menuPlacement: menuPlacement,
                    menuPosition: menuPosition,
                    menuShouldScrollIntoView: menuShouldScrollIntoView
                };
                var menuElement = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $195c12e5177a207f$export$f32337f3a7617699), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, commonProps, menuPlacementProps), function(_ref4) {
                    var ref = _ref4.ref, _ref4$placerProps = _ref4.placerProps, placement = _ref4$placerProps.placement, maxHeight = _ref4$placerProps.maxHeight;
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(Menu, (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, commonProps, menuPlacementProps, {
                        innerRef: ref,
                        innerProps: $688ea211cffbe405$var$_objectSpread({
                            onMouseDown: _this6.onMenuMouseDown,
                            onMouseMove: _this6.onMenuMouseMove,
                            id: _this6.props.components.Menu ? _this6.getElementId('listbox') : undefined
                        }, testId && {
                            'data-testid': "".concat(testId, "-select--listbox-container")
                        }),
                        isLoading: isLoading,
                        placement: placement
                    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $d702bd5fc1670502$export$2e2bcd8739ae039), {
                        captureEnabled: captureMenuScroll,
                        onTopArrive: onMenuScrollToTop,
                        onBottomArrive: onMenuScrollToBottom,
                        lockEnabled: menuShouldBlockScroll
                    }, function(scrollTargetRef) {
                        var _this6$inputRef, _this6$inputRef2;
                        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(MenuList, (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, commonProps, {
                            innerRef: function innerRef(instance) {
                                _this6.getMenuListRef(instance);
                                scrollTargetRef(instance);
                            },
                            innerProps: $688ea211cffbe405$var$_objectSpread($688ea211cffbe405$var$_objectSpread($688ea211cffbe405$var$_objectSpread({
                                role: _this6.props['UNSAFE_is_experimental_generic'] ? 'dialog' : 'listbox'
                            }, _this6.props['UNSAFE_is_experimental_generic'] && {
                                'aria-labelledby': ((_this6$inputRef = _this6.inputRef) === null || _this6$inputRef === void 0 ? void 0 : _this6$inputRef.id) || _this6.getElementId('input')
                            }), {}, {
                                'aria-multiselectable': !commonProps.isMulti || _this6.props['UNSAFE_is_experimental_generic'] ? undefined : commonProps.isMulti,
                                id: _this6.getElementId('listbox')
                            }, testId && {
                                'data-testid': "".concat(testId, "-select--listbox")
                            }), (0, $dJ32z.isSafari)() && !_this6.props['UNSAFE_is_experimental_generic'] && {
                                'aria-describedby': ((_this6$inputRef2 = _this6.inputRef) === null || _this6$inputRef2 === void 0 ? void 0 : _this6$inputRef2.id) || _this6.getElementId('input')
                            }),
                            isLoading: isLoading,
                            maxHeight: maxHeight,
                            focusedOption: focusedOption
                        }), _this6.props['UNSAFE_is_experimental_generic'] ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("div", {
                            role: "list"
                        }, menuUI) : menuUI);
                    }));
                });
                // positioning behaviour is almost identical for portalled and fixed,
                // so we use the same component. the actual portalling logic is forked
                // within the component based on `menuPosition`
                return menuPortalTarget || menuPosition === 'fixed' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(MenuPortal, (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, commonProps, {
                    appendTo: menuPortalTarget,
                    controlElement: this.controlRef,
                    menuPlacement: menuPlacement,
                    menuPosition: menuPosition
                }), menuElement) : menuElement;
            }
        },
        {
            key: "renderFormField",
            value: function renderFormField() {
                var _this7 = this;
                var _this$props12 = this.props, delimiter = _this$props12.delimiter, isDisabled = _this$props12.isDisabled, isMulti = _this$props12.isMulti, required = _this$props12.required, name = _this$props12.name;
                var selectValue = this.state.selectValue;
                if (required && !this.hasValue() && !isDisabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $9f94d239c388760b$export$2e2bcd8739ae039), {
                    name: name,
                    onFocus: this.onValueInputFocus
                });
                if (!name || isDisabled) return;
                if (isMulti) {
                    if (delimiter) {
                        var value = selectValue.map(function(opt) {
                            return _this7.getOptionValue(opt);
                        }).join(delimiter);
                        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("input", {
                            name: name,
                            type: "hidden",
                            value: value
                        });
                    } else {
                        var input = selectValue.length > 0 ? selectValue.map(function(opt, i) {
                            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("input", {
                                key: "i-".concat(i),
                                name: name,
                                type: "hidden",
                                value: _this7.getOptionValue(opt)
                            });
                        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("input", {
                            name: name,
                            type: "hidden",
                            value: ""
                        });
                        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("div", null, input);
                    }
                } else {
                    var _value = selectValue[0] ? this.getOptionValue(selectValue[0]) : '';
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("input", {
                        name: name,
                        type: "hidden",
                        value: _value
                    });
                }
            }
        },
        {
            key: "renderLiveRegion",
            value: function renderLiveRegion() {
                var commonProps = this.commonProps;
                var _this$state5 = this.state, ariaSelection = _this$state5.ariaSelection, isFocused = _this$state5.isFocused, selectValue = _this$state5.selectValue;
                var focusableOptions = this.getFocusableOptions();
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $509727e7da2e808a$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, commonProps, {
                    id: this.getElementId('live-region'),
                    ariaSelection: ariaSelection,
                    isFocused: isFocused,
                    selectValue: selectValue,
                    focusableOptions: focusableOptions
                }));
            }
        },
        {
            key: "renderMultiselectMessage",
            value: function renderMultiselectMessage() {
                // In the future, when we actually support touch devices, we'll need to update this to not be keyboard specific.
                // Also, since this is rendered onscreen, it should be transtlated automatically.
                var msg = ", multiple selections available, ".concat(this.state.selectValue.length ? 'Use left or right arrow keys to navigate selected items' : '');
                return(/*#__PURE__*/ // eslint-disable-next-line @atlaskit/design-system/use-primitives-text
                (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("span", {
                    id: this.getElementId('multi-message'),
                    hidden: true
                }, msg));
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$getComponents7 = this.getComponents(), Control = _this$getComponents7.Control, IndicatorsContainer = _this$getComponents7.IndicatorsContainer, SelectContainer = _this$getComponents7.SelectContainer, ValueContainer = _this$getComponents7.ValueContainer;
                var _this$props13 = this.props, className = _this$props13.className, id = _this$props13.id, isDisabled = _this$props13.isDisabled, menuIsOpen = _this$props13.menuIsOpen, isInvalid = _this$props13.isInvalid, testId = _this$props13.testId, _this$props13$appeara = _this$props13.appearance, appearance = _this$props13$appeara === void 0 ? 'default' : _this$props13$appeara, _this$props13$spacing = _this$props13.spacing, spacing = _this$props13$spacing === void 0 ? 'default' : _this$props13$spacing;
                var isFocused = this.state.isFocused;
                var commonProps = this.commonProps = this.getCommonProps();
                var isCompact = spacing === 'compact';
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(SelectContainer, (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, commonProps, {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
                    className: className,
                    innerProps: $688ea211cffbe405$var$_objectSpread({
                        id: id,
                        onKeyDown: this.onKeyDown
                    }, testId && {
                        'data-testid': testId && "".concat(testId, "-select--container")
                    }),
                    isDisabled: isDisabled,
                    isFocused: isFocused
                }), this.renderLiveRegion(), commonProps.isMulti && this.renderMultiselectMessage(), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(Control, (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, commonProps, {
                    innerRef: this.getControlRef,
                    innerProps: $688ea211cffbe405$var$_objectSpread({
                        onMouseDown: this.onControlMouseDown,
                        onTouchEnd: this.onControlTouchEnd
                    }, testId && {
                        'data-testid': "".concat(testId, "-select--control")
                    }),
                    appearance: appearance,
                    isInvalid: isInvalid,
                    isDisabled: isDisabled,
                    isFocused: isFocused,
                    menuIsOpen: menuIsOpen,
                    isCompact: isCompact
                }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(ValueContainer, (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, commonProps, {
                    isDisabled: isDisabled,
                    isCompact: isCompact,
                    innerProps: $688ea211cffbe405$var$_objectSpread($688ea211cffbe405$var$_objectSpread({}, testId && {
                        'data-testid': "".concat(testId, "-select--value-container")
                    }), commonProps.isMulti && commonProps.hasValue && !(0, $dJ32z.isAppleDevice)() && {
                        // Required to keep JAWS from popping out of forms mode when using LEFT/RIGHT arrow keys.
                        // This is Jedi Master level ARIA and not taken lightly. Do not modify without consulting
                        // DST Accessibility.
                        role: 'application'
                    })
                }), this.renderPlaceholderOrValue(), this.renderInput()), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(IndicatorsContainer, (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, commonProps, {
                    isDisabled: isDisabled,
                    innerProps: $688ea211cffbe405$var$_objectSpread({}, testId && {
                        'data-testid': "".concat(testId, "-select--indicators-container")
                    })
                }), this.renderClearIndicator(), this.renderLoadingIndicator(), this.renderDropdownIndicator())), this.renderMenu(), this.renderFormField(), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $52077d8a5b48b859$export$17baa7c95b6ba1b8), {
                    isOpen: this.props.menuIsOpen,
                    onClose: this.handleOpenLayerObserverCloseSignal
                }));
            }
        }
    ], [
        {
            key: "getDerivedStateFromProps",
            value: function getDerivedStateFromProps(props, state) {
                var prevProps = state.prevProps, clearFocusValueOnUpdate = state.clearFocusValueOnUpdate, inputIsHiddenAfterUpdate = state.inputIsHiddenAfterUpdate, ariaSelection = state.ariaSelection, isFocused = state.isFocused, prevWasFocused = state.prevWasFocused, instancePrefix = state.instancePrefix;
                var options = props.options, value = props.value, menuIsOpen = props.menuIsOpen, inputValue = props.inputValue, isMulti = props.isMulti;
                var selectValue = (0, $c6f45647f62090f7$export$33f062f47f21a01)(value);
                var newMenuOptionsState = {};
                if (prevProps && (value !== prevProps.value || options !== prevProps.options || menuIsOpen !== prevProps.menuIsOpen || inputValue !== prevProps.inputValue)) {
                    var focusableOptions = menuIsOpen ? $688ea211cffbe405$var$buildFocusableOptions(props, selectValue) : [];
                    var focusableOptionsWithIds = menuIsOpen ? $688ea211cffbe405$var$buildFocusableOptionsWithIds($688ea211cffbe405$var$buildCategorizedOptions(props, selectValue), "".concat(instancePrefix, "-option")) : [];
                    var focusedValue = clearFocusValueOnUpdate ? $688ea211cffbe405$var$getNextFocusedValue(state, selectValue) : null;
                    var focusedOption = $688ea211cffbe405$var$getNextFocusedOption(state, focusableOptions);
                    var focusedOptionId = $688ea211cffbe405$var$getFocusedOptionId(focusableOptionsWithIds, focusedOption);
                    newMenuOptionsState = {
                        selectValue: selectValue,
                        focusedOption: focusedOption,
                        focusedOptionId: focusedOptionId,
                        focusableOptionsWithIds: focusableOptionsWithIds,
                        focusedValue: focusedValue,
                        clearFocusValueOnUpdate: false
                    };
                }
                // some updates should toggle the state of the input visibility
                var newInputIsHiddenState = inputIsHiddenAfterUpdate != null && props !== prevProps ? {
                    inputIsHidden: inputIsHiddenAfterUpdate,
                    inputIsHiddenAfterUpdate: undefined
                } : {};
                var newAriaSelection = ariaSelection;
                var hasKeptFocus = isFocused && prevWasFocused;
                if (isFocused && !hasKeptFocus) {
                    // If `value` or `defaultValue` props are not empty then announce them
                    // when the Select is initially focused
                    newAriaSelection = {
                        value: (0, $c6f45647f62090f7$export$40fb9515c784cc3b)(isMulti, selectValue, selectValue[0] || null),
                        options: selectValue,
                        action: 'initial-input-focus'
                    };
                    hasKeptFocus = !prevWasFocused;
                }
                // If the 'initial-input-focus' action has been set already
                // then reset the ariaSelection to null
                if ((ariaSelection === null || ariaSelection === void 0 ? void 0 : ariaSelection.action) === 'initial-input-focus') newAriaSelection = null;
                return $688ea211cffbe405$var$_objectSpread($688ea211cffbe405$var$_objectSpread($688ea211cffbe405$var$_objectSpread({}, newMenuOptionsState), newInputIsHiddenState), {}, {
                    prevProps: props,
                    ariaSelection: newAriaSelection,
                    prevWasFocused: hasKeptFocus
                });
            }
        }
    ]);
}((0, $5FkrB.Component));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($688ea211cffbe405$export$2e2bcd8739ae039, "defaultProps", $688ea211cffbe405$export$9c21a3269931e1e6);



var $25nEq = parcelRequire("25nEq");

var $iYJcE = parcelRequire("iYJcE");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");

var $e4185ab08309eab6$var$_excluded = [
    "defaultOptions",
    "cacheOptions",
    "loadOptions",
    "options",
    "isLoading",
    "onInputChange",
    "filterOption"
];
function $e4185ab08309eab6$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $e4185ab08309eab6$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $e4185ab08309eab6$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $e4185ab08309eab6$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $e4185ab08309eab6$export$2e2bcd8739ae039(_ref) {
    var _ref$defaultOptions = _ref.defaultOptions, propsDefaultOptions = _ref$defaultOptions === void 0 ? false : _ref$defaultOptions, _ref$cacheOptions = _ref.cacheOptions, cacheOptions = _ref$cacheOptions === void 0 ? false : _ref$cacheOptions, propsLoadOptions = _ref.loadOptions, propsOptions = _ref.options, _ref$isLoading = _ref.isLoading, propsIsLoading = _ref$isLoading === void 0 ? false : _ref$isLoading, propsOnInputChange = _ref.onInputChange, _ref$filterOption = _ref.filterOption, filterOption = _ref$filterOption === void 0 ? null : _ref$filterOption, restSelectProps = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $e4185ab08309eab6$var$_excluded);
    var propsInputValue = restSelectProps.inputValue;
    var lastRequest = (0, $5FkrB.useRef)(undefined);
    var mounted = (0, $5FkrB.useRef)(false);
    var _useState = (0, $5FkrB.useState)(Array.isArray(propsDefaultOptions) ? propsDefaultOptions : undefined), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), defaultOptions = _useState2[0], setDefaultOptions = _useState2[1];
    var _useState3 = (0, $5FkrB.useState)(typeof propsInputValue !== 'undefined' ? propsInputValue : ''), _useState4 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState3, 2), stateInputValue = _useState4[0], setStateInputValue = _useState4[1];
    var _useState5 = (0, $5FkrB.useState)(propsDefaultOptions === true), _useState6 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState5, 2), isLoading = _useState6[0], setIsLoading = _useState6[1];
    var _useState7 = (0, $5FkrB.useState)(undefined), _useState8 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState7, 2), loadedInputValue = _useState8[0], setLoadedInputValue = _useState8[1];
    var _useState9 = (0, $5FkrB.useState)([]), _useState0 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState9, 2), loadedOptions = _useState0[0], setLoadedOptions = _useState0[1];
    var _useState1 = (0, $5FkrB.useState)(false), _useState10 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState1, 2), passEmptyOptions = _useState10[0], setPassEmptyOptions = _useState10[1];
    var _useState11 = (0, $5FkrB.useState)({}), _useState12 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState11, 2), optionsCache = _useState12[0], setOptionsCache = _useState12[1];
    var _useState13 = (0, $5FkrB.useState)(undefined), _useState14 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState13, 2), prevDefaultOptions = _useState14[0], setPrevDefaultOptions = _useState14[1];
    var _useState15 = (0, $5FkrB.useState)(undefined), _useState16 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState15, 2), prevCacheOptions = _useState16[0], setPrevCacheOptions = _useState16[1];
    if (cacheOptions !== prevCacheOptions) {
        setOptionsCache({});
        setPrevCacheOptions(cacheOptions);
    }
    if (propsDefaultOptions !== prevDefaultOptions) {
        setDefaultOptions(Array.isArray(propsDefaultOptions) ? propsDefaultOptions : undefined);
        setPrevDefaultOptions(propsDefaultOptions);
    }
    (0, $5FkrB.useEffect)(function() {
        mounted.current = true;
        return function() {
            mounted.current = false;
        };
    }, []);
    var loadOptions = (0, $5FkrB.useCallback)(function(inputValue, callback) {
        if (!propsLoadOptions) return callback();
        var loader = propsLoadOptions(inputValue, callback);
        if (loader && typeof loader.then === 'function') loader.then(callback, function() {
            return callback();
        });
    }, [
        propsLoadOptions
    ]);
    (0, $5FkrB.useEffect)(function() {
        if (propsDefaultOptions === true) loadOptions(stateInputValue, function(options) {
            if (!mounted.current) return;
            setDefaultOptions(options || []);
            setIsLoading(!!lastRequest.current);
        });
    // NOTE: this effect is designed to only run when the component mounts,
    // so we don't want to include any hook dependencies
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    var onInputChange = (0, $5FkrB.useCallback)(function(newValue, actionMeta) {
        var inputValue = (0, $c6f45647f62090f7$export$2096bae78ecda911)(newValue, actionMeta, propsOnInputChange);
        if (!inputValue) {
            lastRequest.current = undefined;
            setStateInputValue('');
            setLoadedInputValue('');
            setLoadedOptions([]);
            setIsLoading(false);
            setPassEmptyOptions(false);
            return;
        }
        if (cacheOptions && optionsCache[inputValue]) {
            setStateInputValue(inputValue);
            setLoadedInputValue(inputValue);
            setLoadedOptions(optionsCache[inputValue]);
            setIsLoading(false);
            setPassEmptyOptions(false);
        } else {
            var request = lastRequest.current = {};
            setStateInputValue(inputValue);
            setIsLoading(true);
            setPassEmptyOptions(!loadedInputValue);
            loadOptions(inputValue, function(options) {
                if (!mounted) return;
                if (request !== lastRequest.current) return;
                lastRequest.current = undefined;
                setIsLoading(false);
                setLoadedInputValue(inputValue);
                setLoadedOptions(options || []);
                setPassEmptyOptions(false);
                setOptionsCache(options ? $e4185ab08309eab6$var$_objectSpread($e4185ab08309eab6$var$_objectSpread({}, optionsCache), {}, (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, inputValue, options)) : optionsCache);
            });
        }
    }, [
        cacheOptions,
        loadOptions,
        loadedInputValue,
        optionsCache,
        propsOnInputChange
    ]);
    var options = passEmptyOptions ? [] : stateInputValue && loadedInputValue ? loadedOptions : defaultOptions || [];
    return $e4185ab08309eab6$var$_objectSpread($e4185ab08309eab6$var$_objectSpread({}, restSelectProps), {}, {
        options: options,
        isLoading: isLoading || propsIsLoading,
        onInputChange: onInputChange,
        filterOption: filterOption
    });
}



var $25nEq = parcelRequire("25nEq");

var $iYJcE = parcelRequire("iYJcE");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");
var $3ca1752e6d757d7e$var$_excluded = [
    "defaultInputValue",
    "defaultMenuIsOpen",
    "defaultValue",
    "inputValue",
    "menuIsOpen",
    "onChange",
    "onInputChange",
    "onMenuClose",
    "onMenuOpen",
    "value"
];
function $3ca1752e6d757d7e$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $3ca1752e6d757d7e$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $3ca1752e6d757d7e$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $3ca1752e6d757d7e$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $3ca1752e6d757d7e$export$2e2bcd8739ae039(_ref) {
    var _ref$defaultInputValu = _ref.defaultInputValue, defaultInputValue = _ref$defaultInputValu === void 0 ? '' : _ref$defaultInputValu, _ref$defaultMenuIsOpe = _ref.defaultMenuIsOpen, defaultMenuIsOpen = _ref$defaultMenuIsOpe === void 0 ? false : _ref$defaultMenuIsOpe, _ref$defaultValue = _ref.defaultValue, defaultValue = _ref$defaultValue === void 0 ? null : _ref$defaultValue, propsInputValue = _ref.inputValue, propsMenuIsOpen = _ref.menuIsOpen, propsOnChange = _ref.onChange, propsOnInputChange = _ref.onInputChange, propsOnMenuClose = _ref.onMenuClose, propsOnMenuOpen = _ref.onMenuOpen, propsValue = _ref.value, restSelectProps = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $3ca1752e6d757d7e$var$_excluded);
    var _useState = (0, $5FkrB.useState)(propsInputValue !== undefined ? propsInputValue : defaultInputValue), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), stateInputValue = _useState2[0], setStateInputValue = _useState2[1];
    var _useState3 = (0, $5FkrB.useState)(propsMenuIsOpen !== undefined ? propsMenuIsOpen : defaultMenuIsOpen), _useState4 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState3, 2), stateMenuIsOpen = _useState4[0], setStateMenuIsOpen = _useState4[1];
    var _useState5 = (0, $5FkrB.useState)(propsValue !== undefined ? propsValue : defaultValue), _useState6 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState5, 2), stateValue = _useState6[0], setStateValue = _useState6[1];
    var onChange = (0, $5FkrB.useCallback)(function(value, actionMeta) {
        if (typeof propsOnChange === 'function') propsOnChange(value, actionMeta);
        setStateValue(value);
    }, [
        propsOnChange
    ]);
    var onInputChange = (0, $5FkrB.useCallback)(function(value, actionMeta) {
        var newValue;
        if (typeof propsOnInputChange === 'function') newValue = propsOnInputChange(value, actionMeta);
        setStateInputValue(newValue !== undefined ? newValue : value);
    }, [
        propsOnInputChange
    ]);
    var onMenuOpen = (0, $5FkrB.useCallback)(function() {
        if (typeof propsOnMenuOpen === 'function') propsOnMenuOpen();
        setStateMenuIsOpen(true);
    }, [
        propsOnMenuOpen
    ]);
    var onMenuClose = (0, $5FkrB.useCallback)(function() {
        if (typeof propsOnMenuClose === 'function') propsOnMenuClose();
        setStateMenuIsOpen(false);
    }, [
        propsOnMenuClose
    ]);
    var inputValue = propsInputValue !== undefined ? propsInputValue : stateInputValue;
    var menuIsOpen = propsMenuIsOpen !== undefined ? propsMenuIsOpen : stateMenuIsOpen;
    var value = propsValue !== undefined ? propsValue : stateValue;
    //@ts-ignore react-select unsupported props
    return $3ca1752e6d757d7e$var$_objectSpread($3ca1752e6d757d7e$var$_objectSpread({}, restSelectProps), {}, {
        inputValue: inputValue,
        menuIsOpen: menuIsOpen,
        onChange: onChange,
        onInputChange: onInputChange,
        onMenuClose: onMenuClose,
        onMenuOpen: onMenuOpen,
        value: value
    });
}


var $a1ba8d6c870895b8$var$AsyncSelect = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function(props, ref) {
    // when isAsync is true, options are not provided and async props are used, we will enable async
    var isAsyncEnabledInBaseSelect = props.isAsync && !props.options && (!!props.loadOptions || !!props.defaultOptions);
    var stateManagedProps = (0, $e4185ab08309eab6$export$2e2bcd8739ae039)(props);
    // when isAsync is falsy or isAsyncEnabledInBaseSelect is true, we use async props, otherwise we use base props
    var selectAsyncProps = !props.isAsync || isAsyncEnabledInBaseSelect ? stateManagedProps : props;
    var selectProps = (0, $3ca1752e6d757d7e$export$2e2bcd8739ae039)(selectAsyncProps);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $688ea211cffbe405$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        ref: ref
    }, selectProps));
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$a1ba8d6c870895b8$export$2e2bcd8739ae039 = $a1ba8d6c870895b8$var$AsyncSelect;



var $kqp0i = parcelRequire("kqp0i");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");
var $1592b8d0711f5d6e$var$_excluded = [
    "ariaLiveMessages",
    "isInvalid",
    "onClickPreventDefault",
    "tabSelectsValue",
    "validationState"
];
function $1592b8d0711f5d6e$export$2e2bcd8739ae039(WrappedComponent) {
    var AtlaskitSelect = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function AtlaskitSelect(props, forwardedRef) {
        var ariaLiveMessages = props.ariaLiveMessages, isInvalid = props.isInvalid, _props$onClickPrevent = props.onClickPreventDefault, onClickPreventDefault = _props$onClickPrevent === void 0 ? true : _props$onClickPrevent, _props$tabSelectsValu = props.tabSelectsValue, tabSelectsValue = _props$tabSelectsValu === void 0 ? false : _props$tabSelectsValu, _props$validationStat = props.validationState, validationState = _props$validationStat === void 0 ? 'default' : _props$validationStat, restProps = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(props, $1592b8d0711f5d6e$var$_excluded);
        var internalSelectRef = (0, $5FkrB.useRef)(null);
        /**
     * The following `useImperativeHandle` hook exists for the sake of backwards compatibility.
     * This component used to be a class component which set the value of the `ref` prop to object with the properties and value as below.
     * This has lead to slightly odd usage of refs with this component, e.g. `myRef.current.select.select.controlRef` instead of just `myRef.current.select.controlRef`
     * In the next major release, this should removed and the ref should be passed directly to the wrapped component (given users have updated usage)
     * More info https://stash.atlassian.com/projects/ATLASSIAN/repos/atlassian-frontend-monorepo/pull-requests/88021/overview
     */ (0, $5FkrB.useImperativeHandle)(forwardedRef, function() {
            return {
                select: internalSelectRef.current,
                focus: function focus() {
                    var _internalSelectRef$cu;
                    return (_internalSelectRef$cu = internalSelectRef.current) === null || _internalSelectRef$cu === void 0 ? void 0 : _internalSelectRef$cu.focus();
                },
                blur: function blur() {
                    var _internalSelectRef$cu2;
                    return (_internalSelectRef$cu2 = internalSelectRef.current) === null || _internalSelectRef$cu2 === void 0 ? void 0 : _internalSelectRef$cu2.blur();
                }
            };
        }, []);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(WrappedComponent, (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
            ref: internalSelectRef,
            ariaLiveMessages: ariaLiveMessages,
            tabSelectsValue: tabSelectsValue,
            onClickPreventDefault: onClickPreventDefault,
            isInvalid: isInvalid || validationState === 'error'
        }, restProps, {
            // indicates react-select to be async by default using the base Select component
            // so that makers can pass all async props on the base select to async load options.
            isAsync: true
        }));
    });
    AtlaskitSelect.displayName = 'AtlaskitSelect';
    return AtlaskitSelect;
}


var $6b35e1e8c8ac06e7$var$packageName = "@atlaskit/select";
var $6b35e1e8c8ac06e7$var$packageVersion = "21.7.7";
var $6b35e1e8c8ac06e7$export$d1de3b251ccaa8a3 = (0, $1592b8d0711f5d6e$export$2e2bcd8739ae039)((0, $a1ba8d6c870895b8$export$2e2bcd8739ae039));
var $6b35e1e8c8ac06e7$var$createAndFireEventOnAtlaskit = (0, $37b3839b25967d6a$export$2e2bcd8739ae039)('atlaskit');
var $6b35e1e8c8ac06e7$var$Select = (0, $f3c7ff6e742cb9cd$export$2e2bcd8739ae039)({
    componentName: 'select',
    packageName: $6b35e1e8c8ac06e7$var$packageName,
    packageVersion: $6b35e1e8c8ac06e7$var$packageVersion
})((0, $1fd824424b4b7dd4$export$2e2bcd8739ae039)({
    onChange: $6b35e1e8c8ac06e7$var$createAndFireEventOnAtlaskit({
        action: 'changed',
        actionSubject: 'option',
        attributes: {
            componentName: 'select',
            packageName: $6b35e1e8c8ac06e7$var$packageName,
            packageVersion: $6b35e1e8c8ac06e7$var$packageVersion
        }
    })
})($6b35e1e8c8ac06e7$export$d1de3b251ccaa8a3));
var $6b35e1e8c8ac06e7$export$2e2bcd8739ae039 = $6b35e1e8c8ac06e7$var$Select;



var $kqp0i = parcelRequire("kqp0i");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");

var $fC8ib = parcelRequire("fC8ib");

var $5FkrB = parcelRequire("5FkrB");

var $kqp0i = parcelRequire("kqp0i");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");

var $74Zh5 = parcelRequire("74Zh5");

var $5FkrB = parcelRequire("5FkrB");
var $de50da79535ed886$export$1ca2a26fecb070ae = /*#__PURE__*/ (0, $5FkrB.createContext)('elevation.surface');
var $de50da79535ed886$export$1aeb4f6b93c4540d = function useSurface() {
    return (0, $5FkrB.useContext)($de50da79535ed886$export$1ca2a26fecb070ae);
};
$de50da79535ed886$export$1ca2a26fecb070ae.displayName = 'SurfaceProvider';



var $25nEq = parcelRequire("25nEq");

var $74Zh5 = parcelRequire("74Zh5");
var $da02f9ea28dda37a$export$4ef52930e33717cd = 'data-theme';
var $da02f9ea28dda37a$export$cb374d25ded7f6ab = 'data-subtree-theme';
var $da02f9ea28dda37a$export$a00eac3f8684bcd0 = 'data-color-mode';
var $da02f9ea28dda37a$export$2112803007239c61 = 'data-contrast-mode';
var $da02f9ea28dda37a$export$352e418ed5b6193a = 'data-custom-theme';
var $da02f9ea28dda37a$export$6f0c6fb8c80fcc92 = 'ds';
var $da02f9ea28dda37a$export$4d0c7bbf80185957 = [
    'opacity',
    'font',
    'space',
    'border',
    'radius'
];
var $da02f9ea28dda37a$export$dddac1532e822863 = "--".concat($da02f9ea28dda37a$export$6f0c6fb8c80fcc92, "-token-not-found");
var $da02f9ea28dda37a$export$9d7b58831ae93caa = "--".concat($da02f9ea28dda37a$export$6f0c6fb8c80fcc92, "-elevation-surface-current");


function $8cd2f451c5ad80c5$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $8cd2f451c5ad80c5$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $8cd2f451c5ad80c5$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $8cd2f451c5ad80c5$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $8cd2f451c5ad80c5$export$6ccdbebca2ee545f = {
    '100%': '100%',
    'size.100': '1rem',
    'size.200': '1.5rem',
    'size.300': '2rem',
    'size.400': '2.5rem',
    'size.500': '3rem',
    'size.600': '6rem',
    'size.1000': '12rem'
};
var $8cd2f451c5ad80c5$export$958d0ae7f2977ae4 = {
    'space.0': "var(--ds-space-0, 0px)",
    'space.025': "var(--ds-space-025, 2px)",
    'space.050': "var(--ds-space-050, 4px)",
    'space.075': "var(--ds-space-075, 6px)",
    'space.100': "var(--ds-space-100, 8px)",
    'space.150': "var(--ds-space-150, 12px)",
    'space.200': "var(--ds-space-200, 16px)",
    'space.250': "var(--ds-space-250, 20px)",
    'space.300': "var(--ds-space-300, 24px)",
    'space.400': "var(--ds-space-400, 32px)",
    'space.500': "var(--ds-space-500, 40px)",
    'space.600': "var(--ds-space-600, 48px)",
    'space.800': "var(--ds-space-800, 64px)",
    'space.1000': "var(--ds-space-1000, 80px)"
};
var $8cd2f451c5ad80c5$export$d2dc61f58390201c = {
    'space.negative.025': "var(--ds-space-negative-025, -2px)",
    'space.negative.050': "var(--ds-space-negative-050, -4px)",
    'space.negative.075': "var(--ds-space-negative-075, -6px)",
    'space.negative.100': "var(--ds-space-negative-100, -8px)",
    'space.negative.150': "var(--ds-space-negative-150, -12px)",
    'space.negative.200': "var(--ds-space-negative-200, -16px)",
    'space.negative.250': "var(--ds-space-negative-250, -20px)",
    'space.negative.300': "var(--ds-space-negative-300, -24px)",
    'space.negative.400': "var(--ds-space-negative-400, -32px)"
};
var $8cd2f451c5ad80c5$export$632685d741f3dbbf = $8cd2f451c5ad80c5$var$_objectSpread($8cd2f451c5ad80c5$var$_objectSpread({}, $8cd2f451c5ad80c5$export$958d0ae7f2977ae4), $8cd2f451c5ad80c5$export$d2dc61f58390201c);
var $8cd2f451c5ad80c5$export$2185ce37f9bdd963 = {
    'color.background.neutral.bold': 'color.text.inverse',
    'color.background.neutral.bold.hovered': 'color.text.inverse',
    'color.background.neutral.bold.pressed': 'color.text.inverse',
    'color.background.selected.bold': 'color.text.inverse',
    'color.background.selected.bold.hovered': 'color.text.inverse',
    'color.background.selected.bold.pressed': 'color.text.inverse',
    'color.background.brand.bold': 'color.text.inverse',
    'color.background.brand.bold.hovered': 'color.text.inverse',
    'color.background.brand.bold.pressed': 'color.text.inverse',
    'color.background.brand.boldest': 'color.text.inverse',
    'color.background.brand.boldest.hovered': 'color.text.inverse',
    'color.background.brand.boldest.pressed': 'color.text.inverse',
    'color.background.danger.bold': 'color.text.inverse',
    'color.background.danger.bold.hovered': 'color.text.inverse',
    'color.background.danger.bold.pressed': 'color.text.inverse',
    'color.background.warning.bold': 'color.text.warning.inverse',
    'color.background.warning.bold.hovered': 'color.text.warning.inverse',
    'color.background.warning.bold.pressed': 'color.text.warning.inverse',
    'color.background.success.bold': 'color.text.inverse',
    'color.background.success.bold.hovered': 'color.text.inverse',
    'color.background.success.bold.pressed': 'color.text.inverse',
    'color.background.discovery.bold': 'color.text.inverse',
    'color.background.discovery.bold.hovered': 'color.text.inverse',
    'color.background.discovery.bold.pressed': 'color.text.inverse',
    'color.background.information.bold': 'color.text.inverse',
    'color.background.information.bold.hovered': 'color.text.inverse',
    'color.background.information.bold.pressed': 'color.text.inverse'
};
var $8cd2f451c5ad80c5$export$daf94a976c798b4f = {
    'opacity.disabled': "var(--ds-opacity-disabled, 0.4)",
    'opacity.loading': "var(--ds-opacity-loading, 0.2)"
};
var $8cd2f451c5ad80c5$export$7aff6e7ba39bb774 = {
    'elevation.shadow.overflow': "var(--ds-shadow-overflow, 0px 0px 8px #091e423f, 0px 0px 1px #091e424f)",
    'elevation.shadow.overflow.perimeter': "var(--ds-shadow-overflow-perimeter, #091e421f)",
    'elevation.shadow.overflow.spread': "var(--ds-shadow-overflow-spread, #091e4229)",
    'elevation.shadow.overlay': "var(--ds-shadow-overlay, 0px 8px 12px #091e423f, 0px 0px 1px #091e424f)",
    'elevation.shadow.raised': "var(--ds-shadow-raised, 0px 1px 1px #091e423f, 0px 0px 1px #091e4221)"
};
var $8cd2f451c5ad80c5$export$41a358c9c2356760 = {
    'elevation.surface': "var(--ds-surface, #FFFFFF)",
    'elevation.surface.hovered': "var(--ds-surface-hovered, #FAFBFC)",
    'elevation.surface.pressed': "var(--ds-surface-pressed, #F4F5F7)",
    'elevation.surface.overlay': "var(--ds-surface-overlay, #FFFFFF)",
    'elevation.surface.overlay.hovered': "var(--ds-surface-overlay-hovered, #FAFBFC)",
    'elevation.surface.overlay.pressed': "var(--ds-surface-overlay-pressed, #F4F5F7)",
    'elevation.surface.raised': "var(--ds-surface-raised, #FFFFFF)",
    'elevation.surface.raised.hovered': "var(--ds-surface-raised-hovered, #FAFBFC)",
    'elevation.surface.raised.pressed': "var(--ds-surface-raised-pressed, #F4F5F7)",
    'elevation.surface.sunken': "var(--ds-surface-sunken, #F4F5F7)"
};
var $8cd2f451c5ad80c5$export$1531ad5bb3fbedac = {
    'color.border': "var(--ds-border, #091e4221)",
    'color.border.accent.lime': "var(--ds-border-accent-lime, #6A9A23)",
    'color.border.accent.red': "var(--ds-border-accent-red, #FF5630)",
    'color.border.accent.orange': "var(--ds-border-accent-orange, #D94008)",
    'color.border.accent.yellow': "var(--ds-border-accent-yellow, #FFAB00)",
    'color.border.accent.green': "var(--ds-border-accent-green, #36B37E)",
    'color.border.accent.teal': "var(--ds-border-accent-teal, #00B8D9)",
    'color.border.accent.blue': "var(--ds-border-accent-blue, #0065FF)",
    'color.border.accent.purple': "var(--ds-border-accent-purple, #6554C0)",
    'color.border.accent.magenta': "var(--ds-border-accent-magenta, #CD519D)",
    'color.border.accent.gray': "var(--ds-border-accent-gray, #5E6C84)",
    'color.border.disabled': "var(--ds-border-disabled, #FAFBFC)",
    'color.border.focused': "var(--ds-border-focused, #2684FF)",
    'color.border.input': "var(--ds-border-input, #FAFBFC)",
    'color.border.inverse': "var(--ds-border-inverse, #FFFFFF)",
    'color.border.selected': "var(--ds-border-selected, #0052CC)",
    'color.border.brand': "var(--ds-border-brand, #0052CC)",
    'color.border.danger': "var(--ds-border-danger, #FF5630)",
    'color.border.warning': "var(--ds-border-warning, #FFC400)",
    'color.border.success': "var(--ds-border-success, #00875A)",
    'color.border.discovery': "var(--ds-border-discovery, #998DD9)",
    'color.border.information': "var(--ds-border-information, #0065FF)",
    'color.border.bold': "var(--ds-border-bold, #344563)"
};
var $8cd2f451c5ad80c5$export$d1d79bf68ac056bd = {
    'color.background.accent.lime.subtlest': "var(--ds-background-accent-lime-subtlest, #EEFBDA)",
    'color.background.accent.lime.subtlest.hovered': "var(--ds-background-accent-lime-subtlest-hovered, #D3F1A7)",
    'color.background.accent.lime.subtlest.pressed': "var(--ds-background-accent-lime-subtlest-pressed, #B3DF72)",
    'color.background.accent.lime.subtler': "var(--ds-background-accent-lime-subtler, #D3F1A7)",
    'color.background.accent.lime.subtler.hovered': "var(--ds-background-accent-lime-subtler-hovered, #B3DF72)",
    'color.background.accent.lime.subtler.pressed': "var(--ds-background-accent-lime-subtler-pressed, #94C748)",
    'color.background.accent.lime.subtle': "var(--ds-background-accent-lime-subtle, #94C748)",
    'color.background.accent.lime.subtle.hovered': "var(--ds-background-accent-lime-subtle-hovered, #B3DF72)",
    'color.background.accent.lime.subtle.pressed': "var(--ds-background-accent-lime-subtle-pressed, #D3F1A7)",
    'color.background.accent.lime.bolder': "var(--ds-background-accent-lime-bolder, #5B7F24)",
    'color.background.accent.lime.bolder.hovered': "var(--ds-background-accent-lime-bolder-hovered, #37471F)",
    'color.background.accent.lime.bolder.pressed': "var(--ds-background-accent-lime-bolder-pressed, #37471F)",
    'color.background.accent.red.subtlest': "var(--ds-background-accent-red-subtlest, #FF8F73)",
    'color.background.accent.red.subtlest.hovered': "var(--ds-background-accent-red-subtlest-hovered, #FF7452)",
    'color.background.accent.red.subtlest.pressed': "var(--ds-background-accent-red-subtlest-pressed, #FF5630)",
    'color.background.accent.red.subtler': "var(--ds-background-accent-red-subtler, #FF7452)",
    'color.background.accent.red.subtler.hovered': "var(--ds-background-accent-red-subtler-hovered, #FF5630)",
    'color.background.accent.red.subtler.pressed': "var(--ds-background-accent-red-subtler-pressed, #DE350B)",
    'color.background.accent.red.subtle': "var(--ds-background-accent-red-subtle, #DE350B)",
    'color.background.accent.red.subtle.hovered': "var(--ds-background-accent-red-subtle-hovered, #FF5630)",
    'color.background.accent.red.subtle.pressed': "var(--ds-background-accent-red-subtle-pressed, #FF7452)",
    'color.background.accent.red.bolder': "var(--ds-background-accent-red-bolder, #DE350B)",
    'color.background.accent.red.bolder.hovered': "var(--ds-background-accent-red-bolder-hovered, #FF5630)",
    'color.background.accent.red.bolder.pressed': "var(--ds-background-accent-red-bolder-pressed, #FF7452)",
    'color.background.accent.orange.subtlest': "var(--ds-background-accent-orange-subtlest, #F18D13)",
    'color.background.accent.orange.subtlest.hovered': "var(--ds-background-accent-orange-subtlest-hovered, #FEC57B)",
    'color.background.accent.orange.subtlest.pressed': "var(--ds-background-accent-orange-subtlest-pressed, #FFE2BD)",
    'color.background.accent.orange.subtler': "var(--ds-background-accent-orange-subtler, #B65C02)",
    'color.background.accent.orange.subtler.hovered': "var(--ds-background-accent-orange-subtler-hovered, #F18D13)",
    'color.background.accent.orange.subtler.pressed': "var(--ds-background-accent-orange-subtler-pressed, #FEC57B)",
    'color.background.accent.orange.subtle': "var(--ds-background-accent-orange-subtle, #5F3811)",
    'color.background.accent.orange.subtle.hovered': "var(--ds-background-accent-orange-subtle-hovered, #974F0C)",
    'color.background.accent.orange.subtle.pressed': "var(--ds-background-accent-orange-subtle-pressed, #B65C02)",
    'color.background.accent.orange.bolder': "var(--ds-background-accent-orange-bolder, #43290F)",
    'color.background.accent.orange.bolder.hovered': "var(--ds-background-accent-orange-bolder-hovered, #5F3811)",
    'color.background.accent.orange.bolder.pressed': "var(--ds-background-accent-orange-bolder-pressed, #974F0C)",
    'color.background.accent.yellow.subtlest': "var(--ds-background-accent-yellow-subtlest, #FFE380)",
    'color.background.accent.yellow.subtlest.hovered': "var(--ds-background-accent-yellow-subtlest-hovered, #FFC400)",
    'color.background.accent.yellow.subtlest.pressed': "var(--ds-background-accent-yellow-subtlest-pressed, #FFAB00)",
    'color.background.accent.yellow.subtler': "var(--ds-background-accent-yellow-subtler, #FFC400)",
    'color.background.accent.yellow.subtler.hovered': "var(--ds-background-accent-yellow-subtler-hovered, #FFAB00)",
    'color.background.accent.yellow.subtler.pressed': "var(--ds-background-accent-yellow-subtler-pressed, #FF991F)",
    'color.background.accent.yellow.subtle': "var(--ds-background-accent-yellow-subtle, #FF991F)",
    'color.background.accent.yellow.subtle.hovered': "var(--ds-background-accent-yellow-subtle-hovered, #FFAB00)",
    'color.background.accent.yellow.subtle.pressed': "var(--ds-background-accent-yellow-subtle-pressed, #FFC400)",
    'color.background.accent.yellow.bolder': "var(--ds-background-accent-yellow-bolder, #FF991F)",
    'color.background.accent.yellow.bolder.hovered': "var(--ds-background-accent-yellow-bolder-hovered, #FFAB00)",
    'color.background.accent.yellow.bolder.pressed': "var(--ds-background-accent-yellow-bolder-pressed, #FFC400)",
    'color.background.accent.green.subtlest': "var(--ds-background-accent-green-subtlest, #79F2C0)",
    'color.background.accent.green.subtlest.hovered': "var(--ds-background-accent-green-subtlest-hovered, #57D9A3)",
    'color.background.accent.green.subtlest.pressed': "var(--ds-background-accent-green-subtlest-pressed, #36B37E)",
    'color.background.accent.green.subtler': "var(--ds-background-accent-green-subtler, #57D9A3)",
    'color.background.accent.green.subtler.hovered': "var(--ds-background-accent-green-subtler-hovered, #36B37E)",
    'color.background.accent.green.subtler.pressed': "var(--ds-background-accent-green-subtler-pressed, #00875A)",
    'color.background.accent.green.subtle': "var(--ds-background-accent-green-subtle, #00875A)",
    'color.background.accent.green.subtle.hovered': "var(--ds-background-accent-green-subtle-hovered, #36B37E)",
    'color.background.accent.green.subtle.pressed': "var(--ds-background-accent-green-subtle-pressed, #57D9A3)",
    'color.background.accent.green.bolder': "var(--ds-background-accent-green-bolder, #00875A)",
    'color.background.accent.green.bolder.hovered': "var(--ds-background-accent-green-bolder-hovered, #36B37E)",
    'color.background.accent.green.bolder.pressed': "var(--ds-background-accent-green-bolder-pressed, #57D9A3)",
    'color.background.accent.teal.subtlest': "var(--ds-background-accent-teal-subtlest, #79E2F2)",
    'color.background.accent.teal.subtlest.hovered': "var(--ds-background-accent-teal-subtlest-hovered, #00C7E6)",
    'color.background.accent.teal.subtlest.pressed': "var(--ds-background-accent-teal-subtlest-pressed, #00B8D9)",
    'color.background.accent.teal.subtler': "var(--ds-background-accent-teal-subtler, #00C7E6)",
    'color.background.accent.teal.subtler.hovered': "var(--ds-background-accent-teal-subtler-hovered, #00B8D9)",
    'color.background.accent.teal.subtler.pressed': "var(--ds-background-accent-teal-subtler-pressed, #00A3BF)",
    'color.background.accent.teal.subtle': "var(--ds-background-accent-teal-subtle, #00A3BF)",
    'color.background.accent.teal.subtle.hovered': "var(--ds-background-accent-teal-subtle-hovered, #00B8D9)",
    'color.background.accent.teal.subtle.pressed': "var(--ds-background-accent-teal-subtle-pressed, #00C7E6)",
    'color.background.accent.teal.bolder': "var(--ds-background-accent-teal-bolder, #00A3BF)",
    'color.background.accent.teal.bolder.hovered': "var(--ds-background-accent-teal-bolder-hovered, #00B8D9)",
    'color.background.accent.teal.bolder.pressed': "var(--ds-background-accent-teal-bolder-pressed, #00C7E6)",
    'color.background.accent.blue.subtlest': "var(--ds-background-accent-blue-subtlest, #4C9AFF)",
    'color.background.accent.blue.subtlest.hovered': "var(--ds-background-accent-blue-subtlest-hovered, #2684FF)",
    'color.background.accent.blue.subtlest.pressed': "var(--ds-background-accent-blue-subtlest-pressed, #0065FF)",
    'color.background.accent.blue.subtler': "var(--ds-background-accent-blue-subtler, #2684FF)",
    'color.background.accent.blue.subtler.hovered': "var(--ds-background-accent-blue-subtler-hovered, #0065FF)",
    'color.background.accent.blue.subtler.pressed': "var(--ds-background-accent-blue-subtler-pressed, #0052CC)",
    'color.background.accent.blue.subtle': "var(--ds-background-accent-blue-subtle, #0052CC)",
    'color.background.accent.blue.subtle.hovered': "var(--ds-background-accent-blue-subtle-hovered, #0065FF)",
    'color.background.accent.blue.subtle.pressed': "var(--ds-background-accent-blue-subtle-pressed, #2684FF)",
    'color.background.accent.blue.bolder': "var(--ds-background-accent-blue-bolder, #0052CC)",
    'color.background.accent.blue.bolder.hovered': "var(--ds-background-accent-blue-bolder-hovered, #0065FF)",
    'color.background.accent.blue.bolder.pressed': "var(--ds-background-accent-blue-bolder-pressed, #2684FF)",
    'color.background.accent.purple.subtlest': "var(--ds-background-accent-purple-subtlest, #998DD9)",
    'color.background.accent.purple.subtlest.hovered': "var(--ds-background-accent-purple-subtlest-hovered, #8777D9)",
    'color.background.accent.purple.subtlest.pressed': "var(--ds-background-accent-purple-subtlest-pressed, #6554C0)",
    'color.background.accent.purple.subtler': "var(--ds-background-accent-purple-subtler, #8777D9)",
    'color.background.accent.purple.subtler.hovered': "var(--ds-background-accent-purple-subtler-hovered, #6554C0)",
    'color.background.accent.purple.subtler.pressed': "var(--ds-background-accent-purple-subtler-pressed, #5243AA)",
    'color.background.accent.purple.subtle': "var(--ds-background-accent-purple-subtle, #5243AA)",
    'color.background.accent.purple.subtle.hovered': "var(--ds-background-accent-purple-subtle-hovered, #6554C0)",
    'color.background.accent.purple.subtle.pressed': "var(--ds-background-accent-purple-subtle-pressed, #8777D9)",
    'color.background.accent.purple.bolder': "var(--ds-background-accent-purple-bolder, #5243AA)",
    'color.background.accent.purple.bolder.hovered': "var(--ds-background-accent-purple-bolder-hovered, #6554C0)",
    'color.background.accent.purple.bolder.pressed': "var(--ds-background-accent-purple-bolder-pressed, #8777D9)",
    'color.background.accent.magenta.subtlest': "var(--ds-background-accent-magenta-subtlest, #FFECF8)",
    'color.background.accent.magenta.subtlest.hovered': "var(--ds-background-accent-magenta-subtlest-hovered, #FDD0EC)",
    'color.background.accent.magenta.subtlest.pressed': "var(--ds-background-accent-magenta-subtlest-pressed, #F797D2)",
    'color.background.accent.magenta.subtler': "var(--ds-background-accent-magenta-subtler, #FDD0EC)",
    'color.background.accent.magenta.subtler.hovered': "var(--ds-background-accent-magenta-subtler-hovered, #F797D2)",
    'color.background.accent.magenta.subtler.pressed': "var(--ds-background-accent-magenta-subtler-pressed, #E774BB)",
    'color.background.accent.magenta.subtle': "var(--ds-background-accent-magenta-subtle, #E774BB)",
    'color.background.accent.magenta.subtle.hovered': "var(--ds-background-accent-magenta-subtle-hovered, #F797D2)",
    'color.background.accent.magenta.subtle.pressed': "var(--ds-background-accent-magenta-subtle-pressed, #FDD0EC)",
    'color.background.accent.magenta.bolder': "var(--ds-background-accent-magenta-bolder, #AE4787)",
    'color.background.accent.magenta.bolder.hovered': "var(--ds-background-accent-magenta-bolder-hovered, #943D73)",
    'color.background.accent.magenta.bolder.pressed': "var(--ds-background-accent-magenta-bolder-pressed, #50253F)",
    'color.background.accent.gray.subtlest': "var(--ds-background-accent-gray-subtlest, #6B778C)",
    'color.background.accent.gray.subtlest.hovered': "var(--ds-background-accent-gray-subtlest-hovered, #5E6C84)",
    'color.background.accent.gray.subtlest.pressed': "var(--ds-background-accent-gray-subtlest-pressed, #505F79)",
    'color.background.accent.gray.subtler': "var(--ds-background-accent-gray-subtler, #5E6C84)",
    'color.background.accent.gray.subtler.hovered': "var(--ds-background-accent-gray-subtler-hovered, #505F79)",
    'color.background.accent.gray.subtler.pressed': "var(--ds-background-accent-gray-subtler-pressed, #42526E)",
    'color.background.accent.gray.subtle': "var(--ds-background-accent-gray-subtle, #505F79)",
    'color.background.accent.gray.subtle.hovered': "var(--ds-background-accent-gray-subtle-hovered, #5E6C84)",
    'color.background.accent.gray.subtle.pressed': "var(--ds-background-accent-gray-subtle-pressed, #6B778C)",
    'color.background.accent.gray.bolder': "var(--ds-background-accent-gray-bolder, #42526E)",
    'color.background.accent.gray.bolder.hovered': "var(--ds-background-accent-gray-bolder-hovered, #344563)",
    'color.background.accent.gray.bolder.pressed': "var(--ds-background-accent-gray-bolder-pressed, #253858)",
    'color.background.disabled': "var(--ds-background-disabled, #091e4289)",
    'color.background.input': "var(--ds-background-input, #FAFBFC)",
    'color.background.input.hovered': "var(--ds-background-input-hovered, #EBECF0)",
    'color.background.input.pressed': "var(--ds-background-input-pressed, #FFFFFF)",
    'color.background.inverse.subtle': "var(--ds-background-inverse-subtle, #00000029)",
    'color.background.inverse.subtle.hovered': "var(--ds-background-inverse-subtle-hovered, #0000003D)",
    'color.background.inverse.subtle.pressed': "var(--ds-background-inverse-subtle-pressed, #00000052)",
    'color.background.neutral': "var(--ds-background-neutral, #DFE1E6)",
    'color.background.neutral.hovered': "var(--ds-background-neutral-hovered, #091e4214)",
    'color.background.neutral.pressed': "var(--ds-background-neutral-pressed, #B3D4FF)",
    'color.background.neutral.subtle': "var(--ds-background-neutral-subtle, transparent)",
    'color.background.neutral.subtle.hovered': "var(--ds-background-neutral-subtle-hovered, #091e4214)",
    'color.background.neutral.subtle.pressed': "var(--ds-background-neutral-subtle-pressed, #B3D4FF)",
    'color.background.neutral.bold': "var(--ds-background-neutral-bold, #42526E)",
    'color.background.neutral.bold.hovered': "var(--ds-background-neutral-bold-hovered, #505F79)",
    'color.background.neutral.bold.pressed': "var(--ds-background-neutral-bold-pressed, #344563)",
    'color.background.selected': "var(--ds-background-selected, #DEEBFF)",
    'color.background.selected.hovered': "var(--ds-background-selected-hovered, #B3D4FF)",
    'color.background.selected.pressed': "var(--ds-background-selected-pressed, #4C9AFF)",
    'color.background.selected.bold': "var(--ds-background-selected-bold, #0052CC)",
    'color.background.selected.bold.hovered': "var(--ds-background-selected-bold-hovered, #2684FF)",
    'color.background.selected.bold.pressed': "var(--ds-background-selected-bold-pressed, #0052CC)",
    'color.background.brand.subtlest': "var(--ds-background-brand-subtlest, #B3D4FF)",
    'color.background.brand.subtlest.hovered': "var(--ds-background-brand-subtlest-hovered, #DEEBFF)",
    'color.background.brand.subtlest.pressed': "var(--ds-background-brand-subtlest-pressed, #4C9AFF)",
    'color.background.brand.bold': "var(--ds-background-brand-bold, #0052CC)",
    'color.background.brand.bold.hovered': "var(--ds-background-brand-bold-hovered, #0065FF)",
    'color.background.brand.bold.pressed': "var(--ds-background-brand-bold-pressed, #0747A6)",
    'color.background.brand.boldest': "var(--ds-background-brand-boldest, #0747A6)",
    'color.background.brand.boldest.hovered': "var(--ds-background-brand-boldest-hovered, #0052CC)",
    'color.background.brand.boldest.pressed': "var(--ds-background-brand-boldest-pressed, #0747A6)",
    'color.background.danger': "var(--ds-background-danger, #FFEBE6)",
    'color.background.danger.hovered': "var(--ds-background-danger-hovered, #FFBDAD)",
    'color.background.danger.pressed': "var(--ds-background-danger-pressed, #FF8F73)",
    'color.background.danger.subtler': "var(--ds-background-danger-subtler, #FFBDAD)",
    'color.background.danger.subtler.hovered': "var(--ds-background-danger-subtler-hovered, #FF8F73)",
    'color.background.danger.subtler.pressed': "var(--ds-background-danger-subtler-pressed, #FF7452)",
    'color.background.danger.bold': "var(--ds-background-danger-bold, #DE350B)",
    'color.background.danger.bold.hovered': "var(--ds-background-danger-bold-hovered, #FF5630)",
    'color.background.danger.bold.pressed': "var(--ds-background-danger-bold-pressed, #BF2600)",
    'color.background.warning': "var(--ds-background-warning, #FFFAE6)",
    'color.background.warning.hovered': "var(--ds-background-warning-hovered, #FFF0B3)",
    'color.background.warning.pressed': "var(--ds-background-warning-pressed, #FFE380)",
    'color.background.warning.subtler': "var(--ds-background-warning-subtler, #FFF0B3)",
    'color.background.warning.subtler.hovered': "var(--ds-background-warning-subtler-hovered, #FFE380)",
    'color.background.warning.subtler.pressed': "var(--ds-background-warning-subtler-pressed, #FFC400)",
    'color.background.warning.bold': "var(--ds-background-warning-bold, #FFAB00)",
    'color.background.warning.bold.hovered': "var(--ds-background-warning-bold-hovered, #FFC400)",
    'color.background.warning.bold.pressed': "var(--ds-background-warning-bold-pressed, #FF991F)",
    'color.background.success': "var(--ds-background-success, #E3FCEF)",
    'color.background.success.hovered': "var(--ds-background-success-hovered, #ABF5D1)",
    'color.background.success.pressed': "var(--ds-background-success-pressed, #79F2C0)",
    'color.background.success.subtler': "var(--ds-background-success-subtler, #ABF5D1)",
    'color.background.success.subtler.hovered': "var(--ds-background-success-subtler-hovered, #79F2C0)",
    'color.background.success.subtler.pressed': "var(--ds-background-success-subtler-pressed, #57D9A3)",
    'color.background.success.bold': "var(--ds-background-success-bold, #00875A)",
    'color.background.success.bold.hovered': "var(--ds-background-success-bold-hovered, #57D9A3)",
    'color.background.success.bold.pressed': "var(--ds-background-success-bold-pressed, #00875A)",
    'color.background.discovery': "var(--ds-background-discovery, #EAE6FF)",
    'color.background.discovery.hovered': "var(--ds-background-discovery-hovered, #C0B6F2)",
    'color.background.discovery.pressed': "var(--ds-background-discovery-pressed, #998DD9)",
    'color.background.discovery.subtler': "var(--ds-background-discovery-subtler, #C0B6F2)",
    'color.background.discovery.subtler.hovered': "var(--ds-background-discovery-subtler-hovered, #998DD9)",
    'color.background.discovery.subtler.pressed': "var(--ds-background-discovery-subtler-pressed, #8777D9)",
    'color.background.discovery.bold': "var(--ds-background-discovery-bold, #5243AA)",
    'color.background.discovery.bold.hovered': "var(--ds-background-discovery-bold-hovered, #8777D9)",
    'color.background.discovery.bold.pressed': "var(--ds-background-discovery-bold-pressed, #5243AA)",
    'color.background.information': "var(--ds-background-information, #DEEBFF)",
    'color.background.information.hovered': "var(--ds-background-information-hovered, #B3D4FF)",
    'color.background.information.pressed': "var(--ds-background-information-pressed, #4C9AFF)",
    'color.background.information.subtler': "var(--ds-background-information-subtler, #B3D4FF)",
    'color.background.information.subtler.hovered': "var(--ds-background-information-subtler-hovered, #4C9AFF)",
    'color.background.information.subtler.pressed': "var(--ds-background-information-subtler-pressed, #2684FF)",
    'color.background.information.bold': "var(--ds-background-information-bold, #0052CC)",
    'color.background.information.bold.hovered': "var(--ds-background-information-bold-hovered, #2684FF)",
    'color.background.information.bold.pressed': "var(--ds-background-information-bold-pressed, #0052CC)",
    'color.blanket': "var(--ds-blanket, #091e4289)",
    'color.blanket.selected': "var(--ds-blanket-selected, #388BFF14)",
    'color.blanket.danger': "var(--ds-blanket-danger, #EF5C4814)",
    'color.skeleton': "var(--ds-skeleton, #F4F5F7)",
    'color.skeleton.subtle': "var(--ds-skeleton-subtle, #091e420a)",
    'elevation.surface': "var(--ds-surface, #FFFFFF)",
    'elevation.surface.hovered': "var(--ds-surface-hovered, #FAFBFC)",
    'elevation.surface.pressed': "var(--ds-surface-pressed, #F4F5F7)",
    'elevation.surface.overlay': "var(--ds-surface-overlay, #FFFFFF)",
    'elevation.surface.overlay.hovered': "var(--ds-surface-overlay-hovered, #FAFBFC)",
    'elevation.surface.overlay.pressed': "var(--ds-surface-overlay-pressed, #F4F5F7)",
    'elevation.surface.raised': "var(--ds-surface-raised, #FFFFFF)",
    'elevation.surface.raised.hovered': "var(--ds-surface-raised-hovered, #FAFBFC)",
    'elevation.surface.raised.pressed': "var(--ds-surface-raised-pressed, #F4F5F7)",
    'elevation.surface.sunken': "var(--ds-surface-sunken, #F4F5F7)",
    'utility.elevation.surface.current': "var(--ds-elevation-surface-current, #FFFFFF)"
};
var $8cd2f451c5ad80c5$export$8473307aa00d6ea1 = {
    'color.text': "var(--ds-text, #172B4D)",
    'color.text.accent.lime': "var(--ds-text-accent-lime, #4C6B1F)",
    'color.text.accent.lime.bolder': "var(--ds-text-accent-lime-bolder, #37471F)",
    'color.text.accent.red': "var(--ds-text-accent-red, #DE350B)",
    'color.text.accent.red.bolder': "var(--ds-text-accent-red-bolder, #BF2600)",
    'color.text.accent.orange': "var(--ds-text-accent-orange, #F18D13)",
    'color.text.accent.orange.bolder': "var(--ds-text-accent-orange-bolder, #B65C02)",
    'color.text.accent.yellow': "var(--ds-text-accent-yellow, #FF991F)",
    'color.text.accent.yellow.bolder': "var(--ds-text-accent-yellow-bolder, #FF8B00)",
    'color.text.accent.green': "var(--ds-text-accent-green, #00875A)",
    'color.text.accent.green.bolder': "var(--ds-text-accent-green-bolder, #006644)",
    'color.text.accent.teal': "var(--ds-text-accent-teal, #00A3BF)",
    'color.text.accent.teal.bolder': "var(--ds-text-accent-teal-bolder, #008DA6)",
    'color.text.accent.blue': "var(--ds-text-accent-blue, #0052CC)",
    'color.text.accent.blue.bolder': "var(--ds-text-accent-blue-bolder, #0747A6)",
    'color.text.accent.purple': "var(--ds-text-accent-purple, #5243AA)",
    'color.text.accent.purple.bolder': "var(--ds-text-accent-purple-bolder, #403294)",
    'color.text.accent.magenta': "var(--ds-text-accent-magenta, #E774BB)",
    'color.text.accent.magenta.bolder': "var(--ds-text-accent-magenta-bolder, #DA62AC)",
    'color.text.accent.gray': "var(--ds-text-accent-gray, #505F79)",
    'color.text.accent.gray.bolder': "var(--ds-text-accent-gray-bolder, #172B4D)",
    'color.text.disabled': "var(--ds-text-disabled, #A5ADBA)",
    'color.text.inverse': "var(--ds-text-inverse, #FFFFFF)",
    'color.text.selected': "var(--ds-text-selected, #0052CC)",
    'color.text.brand': "var(--ds-text-brand, #0065FF)",
    'color.text.danger': "var(--ds-text-danger, #DE350B)",
    'color.text.danger.bolder': "var(--ds-text-danger-bolder, #BF2600)",
    'color.text.warning': "var(--ds-text-warning, #974F0C)",
    'color.text.warning.inverse': "var(--ds-text-warning-inverse, #172B4D)",
    'color.text.warning.bolder': "var(--ds-text-warning-bolder, #974F0C)",
    'color.text.success': "var(--ds-text-success, #006644)",
    'color.text.success.bolder': "var(--ds-text-success-bolder, #006644)",
    'color.text.discovery': "var(--ds-text-discovery, #403294)",
    'color.text.discovery.bolder': "var(--ds-text-discovery-bolder, #403294)",
    'color.text.information': "var(--ds-text-information, #0052CC)",
    'color.text.information.bolder': "var(--ds-text-information-bolder, #0747A6)",
    'color.text.subtlest': "var(--ds-text-subtlest, #7A869A)",
    'color.text.subtle': "var(--ds-text-subtle, #42526E)",
    'color.link': "var(--ds-link, #0052CC)",
    'color.link.pressed': "var(--ds-link-pressed, #0747A6)",
    'color.link.visited': "var(--ds-link-visited, #403294)",
    'color.link.visited.pressed': "var(--ds-link-visited-pressed, #403294)"
};
var $8cd2f451c5ad80c5$export$498780f74be9af68 = {
    'color.icon': "var(--ds-icon, #505F79)",
    'color.icon.accent.lime': "var(--ds-icon-accent-lime, #6A9A23)",
    'color.icon.accent.red': "var(--ds-icon-accent-red, #FF5630)",
    'color.icon.accent.orange': "var(--ds-icon-accent-orange, #D94008)",
    'color.icon.accent.yellow': "var(--ds-icon-accent-yellow, #FFAB00)",
    'color.icon.accent.green': "var(--ds-icon-accent-green, #36B37E)",
    'color.icon.accent.teal': "var(--ds-icon-accent-teal, #00B8D9)",
    'color.icon.accent.blue': "var(--ds-icon-accent-blue, #0065FF)",
    'color.icon.accent.purple': "var(--ds-icon-accent-purple, #6554C0)",
    'color.icon.accent.magenta': "var(--ds-icon-accent-magenta, #CD519D)",
    'color.icon.accent.gray': "var(--ds-icon-accent-gray, #5E6C84)",
    'color.icon.disabled': "var(--ds-icon-disabled, #8993A4)",
    'color.icon.inverse': "var(--ds-icon-inverse, #FFFFFF)",
    'color.icon.selected': "var(--ds-icon-selected, #0052CC)",
    'color.icon.brand': "var(--ds-icon-brand, #0065FF)",
    'color.icon.danger': "var(--ds-icon-danger, #DE350B)",
    'color.icon.warning': "var(--ds-icon-warning, #FFC400)",
    'color.icon.warning.inverse': "var(--ds-icon-warning-inverse, #253858)",
    'color.icon.success': "var(--ds-icon-success, #00875A)",
    'color.icon.discovery': "var(--ds-icon-discovery, #8777D9)",
    'color.icon.information': "var(--ds-icon-information, #0747A6)",
    'color.icon.subtlest': "var(--ds-icon-subtlest, #6B778C)",
    'color.icon.subtle': "var(--ds-icon-subtle, #6B778C)"
};
var $8cd2f451c5ad80c5$export$b5f31a7e431d2eab = {
    '1': 1,
    card: 100,
    navigation: 200,
    dialog: 300,
    layer: 400,
    blanket: 500,
    modal: 510,
    flag: 600,
    spotlight: 700,
    tooltip: 800
};
var $8cd2f451c5ad80c5$export$e1b83c5210c471b8 = {
    'border.width': "var(--ds-border-width, 1px)",
    'border.width.selected': "var(--ds-border-width-selected, 2px)",
    'border.width.focused': "var(--ds-border-width-focused, 2px)"
};
var $8cd2f451c5ad80c5$export$3c0a6c3e64bb180d = {
    'radius.xsmall': "var(--ds-radius-xsmall, 2px)",
    'radius.small': "var(--ds-radius-small, 3px)",
    'radius.medium': "var(--ds-radius-medium, 6px)",
    'radius.large': "var(--ds-radius-large, 8px)",
    'radius.xlarge': "var(--ds-radius-xlarge, 12px)",
    'radius.xxlarge': "var(--ds-radius-xxlarge, 16px)",
    'radius.full': "var(--ds-radius-full, 9999px)",
    'radius.tile': "var(--ds-radius-tile, 25%)"
};
var $8cd2f451c5ad80c5$export$6ffa317d5e70375 = {
    'font.body': "var(--ds-font-body, normal 400 14px/20px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.body.UNSAFE_small': "var(--ds-font-body-UNSAFE_small, normal 400 12px/16px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.body.large': "var(--ds-font-body-large, normal 400 16px/24px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.body.small': "var(--ds-font-body-small, normal 400 12px/16px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.code': "var(--ds-font-code, normal 400 0.875em/1 \"Atlassian Mono\", ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)",
    'font.heading.large': "var(--ds-font-heading-large, normal 653 24px/28px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.heading.medium': "var(--ds-font-heading-medium, normal 653 20px/24px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.heading.small': "var(--ds-font-heading-small, normal 653 16px/20px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.heading.xlarge': "var(--ds-font-heading-xlarge, normal 653 28px/32px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.heading.xsmall': "var(--ds-font-heading-xsmall, normal 653 14px/20px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.heading.xxlarge': "var(--ds-font-heading-xxlarge, normal 653 32px/36px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.heading.xxsmall': "var(--ds-font-heading-xxsmall, normal 653 12px/16px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.metric.large': "var(--ds-font-metric-large, normal 653 28px/32px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.metric.medium': "var(--ds-font-metric-medium, normal 653 24px/28px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.metric.small': "var(--ds-font-metric-small, normal 653 16px/20px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
};
var $8cd2f451c5ad80c5$export$303e322c6b1ed114 = {
    'font.weight.bold': "var(--ds-font-weight-bold, 653)",
    'font.weight.medium': "var(--ds-font-weight-medium, 500)",
    'font.weight.regular': "var(--ds-font-weight-regular, 400)",
    'font.weight.semibold': "var(--ds-font-weight-semibold, 600)"
};
var $8cd2f451c5ad80c5$export$3c7e9587132614b4 = {
    'font.family.body': "var(--ds-font-family-body, \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.family.brand.body': "var(--ds-font-family-brand-body, \"Charlie Text\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.family.brand.heading': "var(--ds-font-family-brand-heading, \"Charlie Display\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.family.code': "var(--ds-font-family-code, \"Atlassian Mono\", ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)",
    'font.family.heading': "var(--ds-font-family-heading, \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
};
var $8cd2f451c5ad80c5$export$236bfe3a33ef1292 = {
    medium: "var(--ds-font-body, normal 400 14px/20px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    UNSAFE_small: "var(--ds-font-body-UNSAFE_small, normal 400 12px/16px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    large: "var(--ds-font-body-large, normal 400 16px/24px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    small: "var(--ds-font-body-small, normal 400 12px/16px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
};
var $8cd2f451c5ad80c5$export$855cfd311192d666 = {
    bold: "var(--ds-font-weight-bold, 653)",
    medium: "var(--ds-font-weight-medium, 500)",
    regular: "var(--ds-font-weight-regular, 400)",
    semibold: "var(--ds-font-weight-semibold, 600)"
};
var $8cd2f451c5ad80c5$export$b805719bc8cb376 = {
    large: "var(--ds-font-metric-large, normal 653 28px/32px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    medium: "var(--ds-font-metric-medium, normal 653 24px/28px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    small: "var(--ds-font-metric-small, normal 653 16px/20px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
};
/**
 * @codegenEnd
 */ // Margin needs some bespoke types: https://atlassian.slack.com/archives/CKRHB23K8/p1712623192772909
/**
 * Token functions are currently allowed for borderRadius in xcss to ease migration.
 * Because 'radius.small' defaults to 3px, we need a mechanism to allow for 4px values to be provided:
 * This is done by calling the token function - token('radius.small')
 *
 * TODO: Remove once shape them is rolled out and fg platform-dst-shape-theme-default removed
 */ // Generate maps for Box props. backgroundColor, padding, etc
var $8cd2f451c5ad80c5$var$spacingProperties = [
    // Used by Box
    'padding',
    'paddingBlock',
    'paddingBlockStart',
    'paddingBlockEnd',
    'paddingInline',
    'paddingInlineStart',
    'paddingInlineEnd',
    // Used by Inline and Stack
    'gap',
    'rowGap',
    'columnGap'
];
var $8cd2f451c5ad80c5$export$ca0f9c2de39ffed7 = function getSerializedStylesMap(cssProperty, tokenMap) {
    return Object.keys(tokenMap).reduce(function(emotionSpacingMap, token) {
        // eslint-disable-next-line @repo/internal/styles/no-exported-styles
        emotionSpacingMap[token] = (0, $74Zh5.css)((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, cssProperty, tokenMap[token]));
        return emotionSpacingMap;
    }, {});
};
var $8cd2f451c5ad80c5$export$e615f061ca585a6c = $8cd2f451c5ad80c5$var$spacingProperties.reduce(function(styleMap, spacingProperty) {
    styleMap[spacingProperty] = $8cd2f451c5ad80c5$export$ca0f9c2de39ffed7(spacingProperty, $8cd2f451c5ad80c5$export$958d0ae7f2977ae4);
    return styleMap;
}, {});
var $8cd2f451c5ad80c5$export$bf46c3f9eeafc71f = $8cd2f451c5ad80c5$var$spacingProperties.reduce(function(styleMap, spacingProperty) {
    styleMap[spacingProperty] = $8cd2f451c5ad80c5$export$ca0f9c2de39ffed7(spacingProperty, $8cd2f451c5ad80c5$export$958d0ae7f2977ae4);
    return styleMap;
}, {});
var $8cd2f451c5ad80c5$export$e7af83bafe7f9e63 = $8cd2f451c5ad80c5$export$ca0f9c2de39ffed7('backgroundColor', $8cd2f451c5ad80c5$export$d1d79bf68ac056bd);
var $8cd2f451c5ad80c5$export$3a1bcba60b23d7f0 = $8cd2f451c5ad80c5$export$ca0f9c2de39ffed7('color', $8cd2f451c5ad80c5$export$8473307aa00d6ea1);
var $8cd2f451c5ad80c5$export$45f3f4fe16f9f7d5 = $8cd2f451c5ad80c5$export$ca0f9c2de39ffed7('fontWeight', $8cd2f451c5ad80c5$export$303e322c6b1ed114);
var $8cd2f451c5ad80c5$export$68cc305da27dbaa4 = $8cd2f451c5ad80c5$export$ca0f9c2de39ffed7('fontFamily', $8cd2f451c5ad80c5$export$3c7e9587132614b4);
var $8cd2f451c5ad80c5$export$128f10c238242f83 = $8cd2f451c5ad80c5$export$ca0f9c2de39ffed7('font', $8cd2f451c5ad80c5$export$6ffa317d5e70375);
var $8cd2f451c5ad80c5$export$219d364c0da35ae4 = $8cd2f451c5ad80c5$export$ca0f9c2de39ffed7('font', $8cd2f451c5ad80c5$export$236bfe3a33ef1292);
var $8cd2f451c5ad80c5$export$38845ca010b93505 = $8cd2f451c5ad80c5$export$ca0f9c2de39ffed7('fontWeight', $8cd2f451c5ad80c5$export$855cfd311192d666);
var $8cd2f451c5ad80c5$export$ff257d957d48c421 = $8cd2f451c5ad80c5$export$ca0f9c2de39ffed7((0, $da02f9ea28dda37a$export$9d7b58831ae93caa), $8cd2f451c5ad80c5$export$41a358c9c2356760);
var $8cd2f451c5ad80c5$export$5e65a44e5b6ecadb = function isSurfaceColorToken(color) {
    return $8cd2f451c5ad80c5$export$41a358c9c2356760[color] !== undefined;
};
var $8cd2f451c5ad80c5$export$7001ce64d9ff7c7f = $8cd2f451c5ad80c5$export$ca0f9c2de39ffed7('font', $8cd2f451c5ad80c5$export$b805719bc8cb376);



var $fC8ib = parcelRequire("fC8ib");

var $25nEq = parcelRequire("25nEq");

var $iYJcE = parcelRequire("iYJcE");

var $ekGgq = parcelRequire("ekGgq");

var $74Zh5 = parcelRequire("74Zh5");


var $3ZMUU = parcelRequire("3ZMUU");
function $e4d6a42270c0fa86$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $e4d6a42270c0fa86$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $e4d6a42270c0fa86$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $e4d6a42270c0fa86$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $e4d6a42270c0fa86$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $e4d6a42270c0fa86$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
var $e4d6a42270c0fa86$export$9a199fbafee0014e = {
    backgroundColor: (0, $8cd2f451c5ad80c5$export$d1d79bf68ac056bd),
    blockSize: (0, $8cd2f451c5ad80c5$export$6ccdbebca2ee545f),
    borderBlockColor: (0, $8cd2f451c5ad80c5$export$1531ad5bb3fbedac),
    borderBlockEndColor: (0, $8cd2f451c5ad80c5$export$1531ad5bb3fbedac),
    borderBlockEndWidth: (0, $8cd2f451c5ad80c5$export$e1b83c5210c471b8),
    borderBlockStartColor: (0, $8cd2f451c5ad80c5$export$1531ad5bb3fbedac),
    borderBlockStartWidth: (0, $8cd2f451c5ad80c5$export$e1b83c5210c471b8),
    borderBlockWidth: (0, $8cd2f451c5ad80c5$export$e1b83c5210c471b8),
    borderBottomColor: (0, $8cd2f451c5ad80c5$export$1531ad5bb3fbedac),
    borderBottomLeftRadius: (0, $8cd2f451c5ad80c5$export$3c0a6c3e64bb180d),
    borderBottomRightRadius: (0, $8cd2f451c5ad80c5$export$3c0a6c3e64bb180d),
    borderBottomWidth: (0, $8cd2f451c5ad80c5$export$e1b83c5210c471b8),
    borderColor: (0, $8cd2f451c5ad80c5$export$1531ad5bb3fbedac),
    borderEndEndRadius: (0, $8cd2f451c5ad80c5$export$3c0a6c3e64bb180d),
    borderEndStartRadius: (0, $8cd2f451c5ad80c5$export$3c0a6c3e64bb180d),
    borderInlineColor: (0, $8cd2f451c5ad80c5$export$1531ad5bb3fbedac),
    borderInlineEndColor: (0, $8cd2f451c5ad80c5$export$1531ad5bb3fbedac),
    borderInlineEndWidth: (0, $8cd2f451c5ad80c5$export$e1b83c5210c471b8),
    borderInlineStartColor: (0, $8cd2f451c5ad80c5$export$1531ad5bb3fbedac),
    borderInlineStartWidth: (0, $8cd2f451c5ad80c5$export$e1b83c5210c471b8),
    borderInlineWidth: (0, $8cd2f451c5ad80c5$export$e1b83c5210c471b8),
    borderLeftColor: (0, $8cd2f451c5ad80c5$export$1531ad5bb3fbedac),
    borderLeftWidth: (0, $8cd2f451c5ad80c5$export$e1b83c5210c471b8),
    borderRadius: (0, $8cd2f451c5ad80c5$export$3c0a6c3e64bb180d),
    borderRightColor: (0, $8cd2f451c5ad80c5$export$1531ad5bb3fbedac),
    borderRightWidth: (0, $8cd2f451c5ad80c5$export$e1b83c5210c471b8),
    borderStartEndRadius: (0, $8cd2f451c5ad80c5$export$3c0a6c3e64bb180d),
    borderStartStartRadius: (0, $8cd2f451c5ad80c5$export$3c0a6c3e64bb180d),
    borderTopColor: (0, $8cd2f451c5ad80c5$export$1531ad5bb3fbedac),
    borderTopLeftRadius: (0, $8cd2f451c5ad80c5$export$3c0a6c3e64bb180d),
    borderTopRightRadius: (0, $8cd2f451c5ad80c5$export$3c0a6c3e64bb180d),
    borderTopWidth: (0, $8cd2f451c5ad80c5$export$e1b83c5210c471b8),
    borderWidth: (0, $8cd2f451c5ad80c5$export$e1b83c5210c471b8),
    bottom: (0, $8cd2f451c5ad80c5$export$632685d741f3dbbf),
    boxShadow: (0, $8cd2f451c5ad80c5$export$7aff6e7ba39bb774),
    color: (0, $8cd2f451c5ad80c5$export$8473307aa00d6ea1),
    columnGap: (0, $8cd2f451c5ad80c5$export$958d0ae7f2977ae4),
    font: (0, $8cd2f451c5ad80c5$export$6ffa317d5e70375),
    fontFamily: (0, $8cd2f451c5ad80c5$export$3c7e9587132614b4),
    fontWeight: (0, $8cd2f451c5ad80c5$export$303e322c6b1ed114),
    gap: (0, $8cd2f451c5ad80c5$export$958d0ae7f2977ae4),
    height: (0, $8cd2f451c5ad80c5$export$6ccdbebca2ee545f),
    inlineSize: (0, $8cd2f451c5ad80c5$export$6ccdbebca2ee545f),
    inset: (0, $8cd2f451c5ad80c5$export$632685d741f3dbbf),
    insetBlock: (0, $8cd2f451c5ad80c5$export$632685d741f3dbbf),
    insetBlockEnd: (0, $8cd2f451c5ad80c5$export$632685d741f3dbbf),
    insetBlockStart: (0, $8cd2f451c5ad80c5$export$632685d741f3dbbf),
    insetInline: (0, $8cd2f451c5ad80c5$export$632685d741f3dbbf),
    insetInlineEnd: (0, $8cd2f451c5ad80c5$export$632685d741f3dbbf),
    insetInlineStart: (0, $8cd2f451c5ad80c5$export$632685d741f3dbbf),
    left: (0, $8cd2f451c5ad80c5$export$632685d741f3dbbf),
    margin: (0, $8cd2f451c5ad80c5$export$632685d741f3dbbf),
    marginBlock: (0, $8cd2f451c5ad80c5$export$632685d741f3dbbf),
    marginBlockEnd: (0, $8cd2f451c5ad80c5$export$632685d741f3dbbf),
    marginBlockStart: (0, $8cd2f451c5ad80c5$export$632685d741f3dbbf),
    marginBottom: (0, $8cd2f451c5ad80c5$export$632685d741f3dbbf),
    marginInline: (0, $8cd2f451c5ad80c5$export$632685d741f3dbbf),
    marginInlineEnd: (0, $8cd2f451c5ad80c5$export$632685d741f3dbbf),
    marginInlineStart: (0, $8cd2f451c5ad80c5$export$632685d741f3dbbf),
    marginLeft: (0, $8cd2f451c5ad80c5$export$632685d741f3dbbf),
    marginRight: (0, $8cd2f451c5ad80c5$export$632685d741f3dbbf),
    marginTop: (0, $8cd2f451c5ad80c5$export$632685d741f3dbbf),
    maxBlockSize: (0, $8cd2f451c5ad80c5$export$6ccdbebca2ee545f),
    maxHeight: (0, $8cd2f451c5ad80c5$export$6ccdbebca2ee545f),
    maxInlineSize: (0, $8cd2f451c5ad80c5$export$6ccdbebca2ee545f),
    maxWidth: (0, $8cd2f451c5ad80c5$export$6ccdbebca2ee545f),
    minBlockSize: (0, $8cd2f451c5ad80c5$export$6ccdbebca2ee545f),
    minHeight: (0, $8cd2f451c5ad80c5$export$6ccdbebca2ee545f),
    minInlineSize: (0, $8cd2f451c5ad80c5$export$6ccdbebca2ee545f),
    minWidth: (0, $8cd2f451c5ad80c5$export$6ccdbebca2ee545f),
    opacity: (0, $8cd2f451c5ad80c5$export$daf94a976c798b4f),
    outlineColor: (0, $8cd2f451c5ad80c5$export$1531ad5bb3fbedac),
    outlineOffset: (0, $8cd2f451c5ad80c5$export$632685d741f3dbbf),
    outlineWidth: (0, $8cd2f451c5ad80c5$export$e1b83c5210c471b8),
    padding: (0, $8cd2f451c5ad80c5$export$958d0ae7f2977ae4),
    paddingBlock: (0, $8cd2f451c5ad80c5$export$958d0ae7f2977ae4),
    paddingBlockEnd: (0, $8cd2f451c5ad80c5$export$958d0ae7f2977ae4),
    paddingBlockStart: (0, $8cd2f451c5ad80c5$export$958d0ae7f2977ae4),
    paddingBottom: (0, $8cd2f451c5ad80c5$export$958d0ae7f2977ae4),
    paddingInline: (0, $8cd2f451c5ad80c5$export$958d0ae7f2977ae4),
    paddingInlineEnd: (0, $8cd2f451c5ad80c5$export$958d0ae7f2977ae4),
    paddingInlineStart: (0, $8cd2f451c5ad80c5$export$958d0ae7f2977ae4),
    paddingLeft: (0, $8cd2f451c5ad80c5$export$958d0ae7f2977ae4),
    paddingRight: (0, $8cd2f451c5ad80c5$export$958d0ae7f2977ae4),
    paddingTop: (0, $8cd2f451c5ad80c5$export$958d0ae7f2977ae4),
    right: (0, $8cd2f451c5ad80c5$export$632685d741f3dbbf),
    rowGap: (0, $8cd2f451c5ad80c5$export$958d0ae7f2977ae4),
    top: (0, $8cd2f451c5ad80c5$export$632685d741f3dbbf),
    width: (0, $8cd2f451c5ad80c5$export$6ccdbebca2ee545f),
    zIndex: (0, $8cd2f451c5ad80c5$export$b5f31a7e431d2eab)
};
var $e4d6a42270c0fa86$var$uniqueSymbol = Symbol('UNSAFE_INTERNAL_styles');
var $e4d6a42270c0fa86$var$isSafeEnvToThrow = function isSafeEnvToThrow() {
    return (typeof $3ZMUU === "undefined" ? "undefined" : (0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))($3ZMUU)) === 'object' && (0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))($3ZMUU.env) === 'object' && false;
};
var $e4d6a42270c0fa86$var$reNestedSelectors = /(\.|\s|&+|\*\>|#|\[.*\])/;
var $e4d6a42270c0fa86$var$safeSelectors = /^@media .*$|^::?.*$|^@supports .*$/;
var $e4d6a42270c0fa86$var$_transformStyles = function transformStyles(styleObj) {
    if (!styleObj || (0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(styleObj) !== 'object') return styleObj;
    // If styles are defined as a CSSObject[], recursively call on each element until we reach CSSObject
    if (Array.isArray(styleObj)) return styleObj.map($e4d6a42270c0fa86$var$_transformStyles);
    // Modifies styleObj in place. Be careful.
    Object.entries(styleObj).forEach(function(_ref) {
        var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_ref, 2), key = _ref2[0], value = _ref2[1];
        // If key is a pseudo class or a pseudo element, then value should be an object.
        // So, call transformStyles on the value
        if ((0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(value) === 'object' && $e4d6a42270c0fa86$var$safeSelectors.test(key)) {
            styleObj[key] = $e4d6a42270c0fa86$var$_transformStyles(value);
            return;
        }
        if ($e4d6a42270c0fa86$var$isSafeEnvToThrow()) {
            // We don't support `.class`, `[data-testid]`, `> *`, `#some-id`
            if ($e4d6a42270c0fa86$var$reNestedSelectors.test(key)) throw new Error("Styles not supported for key '".concat(key, "'."));
        }
        // We have now dealt with all the special cases, so,
        // check whether what remains is a style property
        // that can be transformed.
        if (!(key in $e4d6a42270c0fa86$export$9a199fbafee0014e)) return;
        var tokenValue = $e4d6a42270c0fa86$export$9a199fbafee0014e[key][value];
        styleObj[key] = tokenValue !== null && tokenValue !== void 0 ? tokenValue : value;
    });
    return styleObj;
};
var $e4d6a42270c0fa86$var$baseXcss = function baseXcss(style) {
    var transformedStyles = $e4d6a42270c0fa86$var$_transformStyles(style);
    return (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, $e4d6a42270c0fa86$var$uniqueSymbol, (0, $74Zh5.css)(transformedStyles));
};
/**
 * Picks out runtime XCSS objects and build-time XCSS strings. This is needed
 * to supported both Emotion and Compiled styles until we've fully migrated
 * to Compiled.
 *
 * @private
 * @deprecated
 */ var $e4d6a42270c0fa86$export$a9c84988c8f81f2d = function parseXcss(args) {
    if (Array.isArray(args)) {
        var emotion = [];
        var staticArr = [];
        var _iterator = $e4d6a42270c0fa86$var$_createForOfIteratorHelper(args), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var arg = _step.value;
                var result = $e4d6a42270c0fa86$export$a9c84988c8f81f2d(arg);
                if (result.emotion) emotion.push.apply(emotion, (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(result.emotion));
                if (result.static) staticArr.push(result.static);
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
        return {
            emotion: emotion,
            static: staticArr.join(' ')
        };
    }
    var objArgs = args;
    var _ref4 = objArgs || {}, styles = _ref4[$e4d6a42270c0fa86$var$uniqueSymbol];
    if (styles) return {
        emotion: [
            styles
        ]
    };
    if (args) {
        // We use string interpolation here instead of .toString() just
        // in case the resulting object doesn't have the method available.
        var stringifiedArgs = "".concat(args);
        if (stringifiedArgs) return {
            static: stringifiedArgs
        };
    }
    return {};
};
function $e4d6a42270c0fa86$export$f6c783d06584602c(style) {
    return $e4d6a42270c0fa86$var$baseXcss(style);
}


var $a18eb272727512e1$var$_excluded = [
    "as",
    "children",
    "backgroundColor",
    "padding",
    "paddingBlock",
    "paddingBlockStart",
    "paddingBlockEnd",
    "paddingInline",
    "paddingInlineStart",
    "paddingInlineEnd",
    "style",
    "testId",
    "xcss"
], $a18eb272727512e1$var$_excluded2 = [
    "className"
];
var $a18eb272727512e1$export$e71c4d32a2263218 = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? 'div' : _ref$as, children = _ref.children, backgroundColor = _ref.backgroundColor, padding = _ref.padding, paddingBlock = _ref.paddingBlock, paddingBlockStart = _ref.paddingBlockStart, paddingBlockEnd = _ref.paddingBlockEnd, paddingInline = _ref.paddingInline, paddingInlineStart = _ref.paddingInlineStart, paddingInlineEnd = _ref.paddingInlineEnd, style = _ref.style, testId = _ref.testId, xcss = _ref.xcss, htmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $a18eb272727512e1$var$_excluded);
    // This is to remove className from safeHtmlAttributes
    // @ts-ignore -- not using expect since it causes issues with help-center local consumption - className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(htmlAttributes, $a18eb272727512e1$var$_excluded2);
    var resolvedStyles = (0, $e4d6a42270c0fa86$export$a9c84988c8f81f2d)(xcss);
    var node = // @ts-expect-error Expression produces a union type that is too complex to represent. I think this is unavoidable
    (0, $74Zh5.jsx)(Component, (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        style: style,
        ref: ref,
        className: resolvedStyles.static
    }, safeHtmlAttributes, {
        css: [
            $a18eb272727512e1$var$baseStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            backgroundColor && (0, $8cd2f451c5ad80c5$export$e7af83bafe7f9e63)[backgroundColor],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $8cd2f451c5ad80c5$export$5e65a44e5b6ecadb)(backgroundColor) && (0, $8cd2f451c5ad80c5$export$ff257d957d48c421)[backgroundColor],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            padding && (0, $8cd2f451c5ad80c5$export$e615f061ca585a6c).padding[padding],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlock && (0, $8cd2f451c5ad80c5$export$e615f061ca585a6c).paddingBlock[paddingBlock],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlockStart && (0, $8cd2f451c5ad80c5$export$e615f061ca585a6c).paddingBlockStart[paddingBlockStart],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlockEnd && (0, $8cd2f451c5ad80c5$export$e615f061ca585a6c).paddingBlockEnd[paddingBlockEnd],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInline && (0, $8cd2f451c5ad80c5$export$e615f061ca585a6c).paddingInline[paddingInline],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInlineStart && (0, $8cd2f451c5ad80c5$export$e615f061ca585a6c).paddingInlineStart[paddingInlineStart],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInlineEnd && (0, $8cd2f451c5ad80c5$export$e615f061ca585a6c).paddingInlineEnd[paddingInlineEnd],
            resolvedStyles.emotion
        ],
        "data-testid": testId
    }), children);
    return backgroundColor ? (0, $74Zh5.jsx)((0, $de50da79535ed886$export$1ca2a26fecb070ae).Provider, {
        value: backgroundColor
    }, node) : node;
});
var $a18eb272727512e1$export$2e2bcd8739ae039 = $a18eb272727512e1$export$e71c4d32a2263218;
var $a18eb272727512e1$var$baseStyles = (0, $74Zh5.css)({
    boxSizing: 'border-box',
    appearance: 'none',
    border: 'none'
});


/**
 * https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/Attributes/aria-sort
 */ var $48eaba2dc4ec4d09$var$baseResetStyles = (0, $e4d6a42270c0fa86$export$f6c783d06584602c)({
    display: 'table-cell',
    verticalAlign: 'middle',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    ':first-of-type': {
        paddingInlineStart: 'space.100'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    ':last-of-type': {
        paddingInlineEnd: 'space.100'
    }
});
var $48eaba2dc4ec4d09$var$alignMapStyles = {
    text: (0, $e4d6a42270c0fa86$export$f6c783d06584602c)({
        textAlign: 'left'
    }),
    icon: (0, $e4d6a42270c0fa86$export$f6c783d06584602c)({
        textAlign: 'center'
    }),
    number: (0, $e4d6a42270c0fa86$export$f6c783d06584602c)({
        textAlign: 'right'
    })
};
var $48eaba2dc4ec4d09$export$41ad0bbfa4755cac = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function(_ref, ref) {
    var testId = _ref.testId, as = _ref.as, children = _ref.children, _ref$align = _ref.align, align = _ref$align === void 0 ? 'text' : _ref$align, _ref$paddingBlock = _ref.paddingBlock, paddingBlock = _ref$paddingBlock === void 0 ? 'space.100' : _ref$paddingBlock, _ref$paddingInline = _ref.paddingInline, paddingInline = _ref$paddingInline === void 0 ? 'space.100' : _ref$paddingInline, backgroundColor = _ref.backgroundColor, scope = _ref.scope, width = _ref.width, xcss = _ref.xcss, sortDirection = _ref.sortDirection, colSpan = _ref.colSpan, rowSpan = _ref.rowSpan;
    // We're type coercing this as Compiled styles in an array isn't supported by the types
    // But the runtime accepts it none-the-wiser. We can remove this entire block and replace
    // it with cx(defaultStyles, focusRingStyles, xcssStyles) when we've moved away from Emotion.
    var styles = Array.isArray(xcss) ? xcss : [
        xcss
    ];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $a18eb272727512e1$export$2e2bcd8739ae039), {
        xcss: [
            $48eaba2dc4ec4d09$var$baseResetStyles,
            $48eaba2dc4ec4d09$var$alignMapStyles[align]
        ].concat((0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(styles)),
        ref: ref,
        scope: scope,
        backgroundColor: backgroundColor,
        paddingBlock: paddingBlock,
        paddingInline: paddingInline,
        as: as,
        testId: testId,
        style: width ? {
            width: width
        } : undefined,
        "aria-sort": sortDirection,
        colSpan: colSpan,
        rowSpan: rowSpan
    }, children);
});


var $db2ca91e0d53ac06$var$_excluded = [
    "testId"
];
var $db2ca91e0d53ac06$export$9cf5b401f969f5e3 = function TD(_ref) {
    var testId = _ref.testId, props = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $db2ca91e0d53ac06$var$_excluded);
    return(/*#__PURE__*/ // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $48eaba2dc4ec4d09$export$41ad0bbfa4755cac), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        as: "td",
        testId: testId
    }, props)));
};


var $5FkrB = parcelRequire("5FkrB");

var $5FkrB = parcelRequire("5FkrB");

var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");
var $b1da8f3ca8bdaac0$export$2a909d4c080cb420 = {
    checked: [],
    allChecked: false,
    anyChecked: false,
    maxChecked: 0,
    selectionStart: -1,
    previousSelection: []
};
var $b1da8f3ca8bdaac0$var$arrayFromRange = function arrayFromRange(from, to) {
    var startIdx = from;
    var stopIdx = to;
    var increment = 1;
    if (from > to) {
        startIdx = to;
        stopIdx = from;
        increment = 0;
    }
    // Create an array with values between `from` and `to` - either ascending or descending
    return Array.from({
        length: stopIdx - startIdx
    }, function(_, i) {
        return startIdx + i + increment;
    });
};
function $b1da8f3ca8bdaac0$var$reducer(_ref, action) {
    var checked = _ref.checked, anyChecked = _ref.anyChecked, maxChecked = _ref.maxChecked, selectionStart = _ref.selectionStart, previousSelection = _ref.previousSelection;
    switch(action.type){
        case 'toggle_selection':
            var _action$value = action.value, id = _action$value.id, shiftHeld = _action$value.shiftHeld;
            var updated = checked.slice();
            var newSelectionStart = selectionStart;
            var newPreviousSelection = previousSelection.slice();
            if (shiftHeld) {
                if (checked.length > 0) {
                    var newIds = $b1da8f3ca8bdaac0$var$arrayFromRange(selectionStart, id); // create an array of the new ids
                    // Uncheck ids from the previous selection.
                    // This is done to maintain consistency with Shift-select behaviour elsewhere (e.g. macOS)
                    // TODO: Code could be improved to only remove ids that are not included in the new range, avoiding needing to re-add them below
                    updated = updated.filter(function(id) {
                        return !previousSelection.includes(id);
                    });
                    newIds.forEach(function(id) {
                        return updated.indexOf(id) === -1 && updated.push(id);
                    } // If the new id is not already checked, check it
                    );
                    newPreviousSelection = newIds; // Maintain an array of the previous selection to allow for consistent Shift-select behaviour
                }
            } else {
                var checkedIndex = checked.indexOf(id); // is index already checked
                if (checkedIndex !== -1) updated.splice(checkedIndex, 1); // if index is already checked, uncheck
                else updated.push(id); // if index is not checked, check
                newSelectionStart = id; // Reset selection start id to this non-shift-selected id
                newPreviousSelection = []; // Reset previous selection as it is no longer relevant once a new non-shift-selected id is added
            }
            var _anyChecked = updated.length > 0;
            return {
                checked: updated,
                allChecked: updated.length === maxChecked,
                anyChecked: _anyChecked || Boolean(updated[id]),
                maxChecked: maxChecked,
                selectionStart: newSelectionStart,
                previousSelection: newPreviousSelection
            };
        case 'set_root':
            return {
                checked: action.value ? Array.from(Array(maxChecked).keys()) : [],
                allChecked: action.value,
                anyChecked: Boolean(action.value),
                maxChecked: maxChecked,
                selectionStart: selectionStart,
                previousSelection: previousSelection
            };
        case 'set_max':
            var max = action.value;
            return {
                maxChecked: max,
                allChecked: checked.length === max,
                anyChecked: anyChecked,
                checked: checked,
                selectionStart: selectionStart,
                previousSelection: previousSelection
            };
        default:
            throw new Error();
    }
}
function $b1da8f3ca8bdaac0$var$useSelectable() {
    var _useReducer = (0, $5FkrB.useReducer)($b1da8f3ca8bdaac0$var$reducer, $b1da8f3ca8bdaac0$export$2a909d4c080cb420), _useReducer2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useReducer, 2), state = _useReducer2[0], dispatch = _useReducer2[1];
    var toggleSelection = (0, $5FkrB.useCallback)(function(id, shiftHeld) {
        dispatch({
            type: 'toggle_selection',
            value: {
                id: id,
                shiftHeld: shiftHeld
            }
        });
    }, []);
    var setAll = (0, $5FkrB.useCallback)(function() {
        dispatch({
            type: 'set_root',
            value: true
        });
    }, []);
    var removeAll = (0, $5FkrB.useCallback)(function() {
        dispatch({
            type: 'set_root',
            value: false
        });
    }, []);
    var setMax = (0, $5FkrB.useCallback)(function(max) {
        dispatch({
            type: 'set_max',
            value: max
        });
    }, []);
    return [
        state,
        {
            setAll: setAll,
            removeAll: removeAll,
            toggleSelection: toggleSelection,
            setMax: setMax
        }
    ];
}
var $b1da8f3ca8bdaac0$export$2e2bcd8739ae039 = $b1da8f3ca8bdaac0$var$useSelectable;


var $777bb5c8a69aeae5$var$SelectionContext = /*#__PURE__*/ (0, $5FkrB.createContext)([
    (0, $b1da8f3ca8bdaac0$export$2a909d4c080cb420),
    {}
]);
/**
 * __Selection provider__
 *
 * A selection provider injects selection specific state into the table.
 */ var $777bb5c8a69aeae5$var$SelectionProvider = function SelectionProvider(_ref) {
    var children = _ref.children;
    var reducer = (0, $b1da8f3ca8bdaac0$export$2e2bcd8739ae039)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement($777bb5c8a69aeae5$var$SelectionContext.Provider, {
        value: reducer
    }, children);
};
var $777bb5c8a69aeae5$export$a97c3cc4bf1da1ca = function useSelection() {
    return (0, $5FkrB.useContext)($777bb5c8a69aeae5$var$SelectionContext);
};
var $777bb5c8a69aeae5$export$2e2bcd8739ae039 = $777bb5c8a69aeae5$var$SelectionProvider;



var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");
var $4e506b1e6559e97a$export$21ebc1ba2b2bee67 = function useSorting(sortKey) {
    var _useState = (0, $5FkrB.useState)(sortKey), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), localSortKey = _useState2[0], setLocalSortKey = _useState2[1];
    var _useState3 = (0, $5FkrB.useState)(), _useState4 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState3, 2), localSortDirection = _useState4[0], setLocalSortDirection = _useState4[1];
    var toggleSortDirection = (0, $5FkrB.useCallback)(function() {
        setLocalSortDirection(function(oldLocalSortDirection) {
            switch(oldLocalSortDirection){
                case undefined:
                    return 'ascending';
                case 'ascending':
                    return 'descending';
                case 'descending':
                    return 'ascending';
            }
        });
    }, []);
    var setSortState = (0, $5FkrB.useCallback)(function(key) {
        setLocalSortKey(function(localSortKey) {
            if (key !== localSortKey) {
                // sorting by different column
                setLocalSortDirection('ascending');
                return key;
            } else toggleSortDirection();
            return localSortKey;
        });
    }, [
        toggleSortDirection
    ]);
    var sortFn = (0, $5FkrB.useCallback)(function(rowA, rowB) {
        if (localSortKey === 'unset') return 0;
        var ascendingComparator = rowA[localSortKey] < rowB[localSortKey] ? -1 : 1;
        return localSortDirection === 'ascending' ? ascendingComparator : -ascendingComparator;
    }, [
        localSortDirection,
        localSortKey
    ]);
    return {
        sortKey: localSortKey,
        sortDirection: localSortDirection,
        setSortState: setSortState,
        sortFn: sortFn
    };
};



var $5FkrB = parcelRequire("5FkrB");

var $eVb4V = parcelRequire("eVb4V");
function $c410d2d48027d6af$var$generateContext() {
    return /*#__PURE__*/ (0, $5FkrB.createContext)({
        isSelectable: false,
        sortKey: 'unset',
        setSortState: (0, $eVb4V.default),
        sortFn: function sortFn() {
            return 0;
        }
    });
}
var $c410d2d48027d6af$var$TableContext = $c410d2d48027d6af$var$generateContext();
function $c410d2d48027d6af$export$d542ac353845c9cf(_ref) {
    var children = _ref.children, state = _ref.state;
    return(/*#__PURE__*/ // @ts-expect-error
    (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement($c410d2d48027d6af$var$TableContext.Provider, {
        value: state
    }, children));
}
var $c410d2d48027d6af$export$25bceaac3c7e4dc7 = function useTable() {
    return(// @ts-expect-error
    (0, $5FkrB.useContext)($c410d2d48027d6af$var$TableContext));
};



var $5FkrB = parcelRequire("5FkrB");
var $252502c30937ddc7$export$54ec01a60f47d33d = function Table(_ref) {
    var children = _ref.children, testId = _ref.testId, summary = _ref.summary;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("table", {
        "data-testid": testId
    }, summary && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("caption", null, summary), children);
};


/**
 * __Table__
 *
 * A data table is used to display dynamic data.
 *
 * - [Examples](https://atlassian.design/components/table/examples)
 */ function $1c9849e9ca2bf87c$var$Table(_ref) {
    var children = _ref.children, isSelectable = _ref.isSelectable, _ref$sortKey = _ref.sortKey, sortKey = _ref$sortKey === void 0 ? 'unset' : _ref$sortKey, testId = _ref.testId;
    var _useSorting = (0, $4e506b1e6559e97a$export$21ebc1ba2b2bee67)(sortKey), localSortKey = _useSorting.sortKey, sortDirection = _useSorting.sortDirection, setSortState = _useSorting.setSortState, sortFn = _useSorting.sortFn;
    var tableProviderState = (0, $5FkrB.useMemo)(function() {
        return {
            isSelectable: isSelectable,
            sortKey: localSortKey,
            sortDirection: sortDirection,
            setSortState: setSortState,
            sortFn: sortFn
        };
    }, [
        isSelectable,
        localSortKey,
        setSortState,
        sortDirection,
        sortFn
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $c410d2d48027d6af$export$d542ac353845c9cf), {
        state: tableProviderState
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $252502c30937ddc7$export$54ec01a60f47d33d), {
        testId: testId
    }, isSelectable ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $777bb5c8a69aeae5$export$2e2bcd8739ae039), null, children) : children));
}
var $1c9849e9ca2bf87c$export$2e2bcd8739ae039 = $1c9849e9ca2bf87c$var$Table;


var $5FkrB = parcelRequire("5FkrB");
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5FkrB = parcelRequire("5FkrB");

var $74Zh5 = parcelRequire("74Zh5");

var $afMOk = parcelRequire("afMOk");

var $5FkrB = parcelRequire("5FkrB");
var $27ab4881942cfff6$var$HasTextAncestorContext = /*#__PURE__*/ (0, $5FkrB.createContext)(false);
var $27ab4881942cfff6$export$9322276ec105d055 = function useHasTextAncestor() {
    return (0, $5FkrB.useContext)($27ab4881942cfff6$var$HasTextAncestorContext);
};
var $27ab4881942cfff6$export$ae933c6cbe5643ad = $27ab4881942cfff6$var$HasTextAncestorContext.Provider;




var $f1e6ff9ef5ff2e1b$var$asAllowlist = [
    'span',
    'p',
    'strong',
    'em'
];
// We're doing this because our CSS reset can add top margins to elements such as `p` which is totally insane.
// Long term we should remove those instances from the reset - it should be a reset to 0.
// For now, at least we know <Text> will be unaffected by this.
var $f1e6ff9ef5ff2e1b$var$resetStyles = (0, $74Zh5.css)({
    margin: 0,
    overflowWrap: 'anywhere'
});
var $f1e6ff9ef5ff2e1b$var$strongStyles = (0, $74Zh5.css)({
    fontWeight: "var(--ds-font-weight-bold, 653)"
});
var $f1e6ff9ef5ff2e1b$var$emStyles = (0, $74Zh5.css)({
    fontStyle: 'italic'
});
var $f1e6ff9ef5ff2e1b$var$textAlignMap = {
    center: (0, $74Zh5.css)({
        textAlign: 'center'
    }),
    end: (0, $74Zh5.css)({
        textAlign: 'end'
    }),
    start: (0, $74Zh5.css)({
        textAlign: 'start'
    })
};
var $f1e6ff9ef5ff2e1b$var$truncationStyles = (0, $74Zh5.css)({
    display: '-webkit-box',
    overflow: 'hidden',
    WebkitBoxOrient: 'vertical'
});
var $f1e6ff9ef5ff2e1b$var$wordBreakMap = {
    breakAll: (0, $74Zh5.css)({
        wordBreak: 'break-all'
    })
};
/**
 * Custom hook designed to abstract the parsing of the color props and make it clearer in the future how color is reconciled between themes and tokens.
 */ var $f1e6ff9ef5ff2e1b$var$useColor = function useColor(colorProp, hasTextAncestor) {
    var surface = (0, $de50da79535ed886$export$1aeb4f6b93c4540d)();
    if (colorProp === 'inherit') return undefined;
    if (colorProp) return colorProp;
    if (hasTextAncestor) return undefined;
    if ((0, $8cd2f451c5ad80c5$export$2185ce37f9bdd963).hasOwnProperty(surface)) return (0, $8cd2f451c5ad80c5$export$2185ce37f9bdd963)[surface];
    return 'color.text';
};
/**
 * __Text__
 *
 * Text is a primitive component that has the Atlassian Design System's design guidelines baked in.
 * This includes considerations for text attributes such as color, font size, font weight, and line height.
 * It renders a `span` by default.
 *
 * @internal
 */ var $f1e6ff9ef5ff2e1b$var$Text = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? 'span' : _ref$as, colorProp = _ref.color, align = _ref.align, testId = _ref.testId, id = _ref.id, size = _ref.size, weight = _ref.weight, maxLines = _ref.maxLines, children = _ref.children;
    (0, $afMOk.default)($f1e6ff9ef5ff2e1b$var$asAllowlist.includes(Component), "@atlaskit/primitives: Text received an invalid \"as\" value of \"".concat(Component, "\""));
    var hasTextAncestor = (0, $27ab4881942cfff6$export$9322276ec105d055)();
    var color = $f1e6ff9ef5ff2e1b$var$useColor(colorProp, hasTextAncestor);
    if (!size && !hasTextAncestor) size = 'medium';
    var component = (0, $74Zh5.jsx)(Component, {
        ref: ref,
        css: [
            $f1e6ff9ef5ff2e1b$var$resetStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            size && (0, $8cd2f451c5ad80c5$export$219d364c0da35ae4)[size],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            color && (0, $8cd2f451c5ad80c5$export$3a1bcba60b23d7f0)[color],
            maxLines && $f1e6ff9ef5ff2e1b$var$truncationStyles,
            maxLines === 1 && $f1e6ff9ef5ff2e1b$var$wordBreakMap.breakAll,
            align && $f1e6ff9ef5ff2e1b$var$textAlignMap[align],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            weight && (0, $8cd2f451c5ad80c5$export$38845ca010b93505)[weight],
            Component === 'em' && $f1e6ff9ef5ff2e1b$var$emStyles,
            Component === 'strong' && $f1e6ff9ef5ff2e1b$var$strongStyles
        ],
        style: {
            WebkitLineClamp: maxLines
        },
        "data-testid": testId,
        id: id
    }, children);
    return hasTextAncestor ? // no need to re-apply context if the text is already wrapped
    component : (0, $74Zh5.jsx)((0, $27ab4881942cfff6$export$ae933c6cbe5643ad), {
        value: true
    }, component);
});
var $f1e6ff9ef5ff2e1b$export$2e2bcd8739ae039 = $f1e6ff9ef5ff2e1b$var$Text;



var $5FkrB = parcelRequire("5FkrB");

var $b58322d0be7716da$export$2b39a3648955dd09 = function TH(_ref) {
    var children = _ref.children, testId = _ref.testId, align = _ref.align, scope = _ref.scope, backgroundColor = _ref.backgroundColor, width = _ref.width, sortDirection = _ref.sortDirection, colSpan = _ref.colSpan;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $48eaba2dc4ec4d09$export$41ad0bbfa4755cac), {
        as: "th",
        testId: testId,
        align: align,
        scope: scope,
        width: width,
        backgroundColor: backgroundColor,
        sortDirection: sortDirection,
        colSpan: colSpan
    }, children);
};


/**
 * __HeadCell__
 *
 * HeadCell element
 */ var $017ea8a39e3f2896$var$HeadCell = function HeadCell(_ref) {
    var children = _ref.children, align = _ref.align, testId = _ref.testId, backgroundColor = _ref.backgroundColor, _ref$scope = _ref.scope, scope = _ref$scope === void 0 ? 'col' : _ref$scope;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $b58322d0be7716da$export$2b39a3648955dd09), {
        scope: scope,
        align: align,
        testId: testId,
        backgroundColor: backgroundColor
    }, children && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $f1e6ff9ef5ff2e1b$export$2e2bcd8739ae039), {
        weight: "medium"
    }, children));
};
var $017ea8a39e3f2896$export$2e2bcd8739ae039 = $017ea8a39e3f2896$var$HeadCell;


var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");


var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");

var $eVb4V = parcelRequire("eVb4V");
var $6a2e067d7f178d02$var$ExpandContext = /*#__PURE__*/ (0, $5FkrB.createContext)({
    isExpanded: false,
    toggleExpanded: (0, $eVb4V.default)
});
var $6a2e067d7f178d02$export$2994164b482c6fe4 = function ExpandContextProvider(_ref) {
    var children = _ref.children, isExpandedProp = _ref.isExpanded, _ref$isDefaultExpande = _ref.isDefaultExpanded, isDefaultExpanded = _ref$isDefaultExpande === void 0 ? false : _ref$isDefaultExpande;
    var _useState = (0, $5FkrB.useState)(isDefaultExpanded), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), isExpanded = _useState2[0], setIsExpanded = _useState2[1];
    var toggleExpanded = (0, $5FkrB.useCallback)(function() {
        setIsExpanded(function(v) {
            return !v;
        });
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement($6a2e067d7f178d02$var$ExpandContext.Provider, {
        value: {
            isExpanded: isExpandedProp || isExpanded,
            toggleExpanded: toggleExpanded
        }
    }, children);
};
var $6a2e067d7f178d02$var$useExpand = function useExpand() {
    return (0, $5FkrB.useContext)($6a2e067d7f178d02$var$ExpandContext);
};
var $6a2e067d7f178d02$export$2e2bcd8739ae039 = $6a2e067d7f178d02$var$useExpand;



var $5FkrB = parcelRequire("5FkrB");
var $043408dc1c1a3669$var$ExpandContentContext = /*#__PURE__*/ (0, $5FkrB.createContext)({
    isExpandableContent: false
});
var $043408dc1c1a3669$export$bc52fac1a043e39f = function ExpandContentContextProvider(_ref) {
    var children = _ref.children;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement($043408dc1c1a3669$var$ExpandContentContext.Provider, {
        value: {
            isExpandableContent: true
        }
    }, children);
};
var $043408dc1c1a3669$var$useExpandContent = function useExpandContent() {
    return (0, $5FkrB.useContext)($043408dc1c1a3669$var$ExpandContentContext);
};
var $043408dc1c1a3669$export$2e2bcd8739ae039 = $043408dc1c1a3669$var$useExpandContent;



var $5FkrB = parcelRequire("5FkrB");
var $1f65586892545a6c$var$RowContext = /*#__PURE__*/ (0, $5FkrB.createContext)(undefined);
var $1f65586892545a6c$export$81981d840a2ece5 = function useRowId() {
    return (0, $5FkrB.useContext)($1f65586892545a6c$var$RowContext);
};
var $1f65586892545a6c$export$329ef9142f16ee64 = $1f65586892545a6c$var$RowContext.Provider;




var $5FkrB = parcelRequire("5FkrB");

var $afMOk = parcelRequire("afMOk");
var $3ec5c5d14d7bc945$var$TableBodyContext = /*#__PURE__*/ (0, $5FkrB.createContext)(false);
var $3ec5c5d14d7bc945$export$c0d7aba0938441d = $3ec5c5d14d7bc945$var$TableBodyContext.Provider;
var $3ec5c5d14d7bc945$export$e4e48199ad91605c = function useTableBody() {
    var hasTableBody = (0, $5FkrB.useContext)($3ec5c5d14d7bc945$var$TableBodyContext);
    (0, $afMOk.default)(hasTableBody, '<Row /> must be nested inside a <TableBody>');
};



var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");
/* checkbox.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $kqp0i = parcelRequire("kqp0i");

var $iYJcE = parcelRequire("iYJcE");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");

var $25nEq = parcelRequire("25nEq");

var $5FkrB = parcelRequire("5FkrB");

var $dLGML = parcelRequire("dLGML");

var $fC8ib = parcelRequire("fC8ib");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $kIXpt = parcelRequire("kIXpt");

var $cYPzS = parcelRequire("cYPzS");

var $lwlXp = parcelRequire("lwlXp");

var $eyuDe = parcelRequire("eyuDe");

var $25nEq = parcelRequire("25nEq");

var $ekGgq = parcelRequire("ekGgq");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $25nEq = parcelRequire("25nEq");
function $f150d5461c467163$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $f150d5461c467163$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $f150d5461c467163$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $f150d5461c467163$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $f150d5461c467163$export$ad4be5c2ec28cecf = function isAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $f150d5461c467163$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === 'AnalyticsEvent';
};
var $f150d5461c467163$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function AnalyticsEvent(props) {
        var _this = this;
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, AnalyticsEvent);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "_isAnalyticsEvent", true);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "clone", function() {
            // just a shallow clone, don't change sub refs unless you want to
            // affect the original's too
            var payload = $f150d5461c467163$var$_objectSpread({}, _this.payload);
            return new AnalyticsEvent({
                payload: payload
            });
        });
        this.payload = props.payload;
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(AnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (typeof updater === 'function') this.payload = updater(this.payload);
                if ((0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(updater) === 'object') this.payload = $f150d5461c467163$var$_objectSpread($f150d5461c467163$var$_objectSpread({}, this.payload), updater);
                return this;
            }
        }
    ]);
}();


function $5f1e708ec415b60e$var$_callSuper(t, o, e) {
    return o = (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(o), (0, (/*@__PURE__*/$parcel$interopDefault($kIXpt)))(t, $5f1e708ec415b60e$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(t).constructor) : o.apply(t, e));
}
function $5f1e708ec415b60e$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($5f1e708ec415b60e$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $5f1e708ec415b60e$var$_superPropGet(t, o, e, r) {
    var p = (0, (/*@__PURE__*/$parcel$interopDefault($lwlXp)))((0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(1 & r ? t.prototype : t), o, e);
    return 2 & r && "function" == typeof p ? function(t) {
        return p.apply(e, t);
    } : p;
}
var $5f1e708ec415b60e$export$35f8383928ba8d7 = function isUIAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $5f1e708ec415b60e$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isUIAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === 'UIAnalyticsEvent';
};
var $5f1e708ec415b60e$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_AnalyticsEvent) {
    function UIAnalyticsEvent(props) {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, UIAnalyticsEvent);
        _this = $5f1e708ec415b60e$var$_callSuper(this, UIAnalyticsEvent, [
            props
        ]);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "_isUIAnalyticsEvent", true);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "clone", function() {
            if (_this.hasFired) return null;
            var context = (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(_this.context);
            var handlers = (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(_this.handlers);
            /**
       * A hacky "deep clone" of the object. This is limited in that it wont
       * support functions, regexs, Maps, Sets, etc, but none of those need to
       * be represented in our payload.
       */ var payload = JSON.parse(JSON.stringify(_this.payload));
            return new UIAnalyticsEvent({
                context: context,
                handlers: handlers,
                payload: payload
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "fire", function(channel) {
            if (_this.hasFired) return;
            _this.handlers.forEach(function(handler) {
                return handler(_this, channel);
            });
            _this.hasFired = true;
        });
        _this.context = props.context || [];
        _this.handlers = props.handlers || [];
        _this.hasFired = false;
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($eyuDe)))(UIAnalyticsEvent, _AnalyticsEvent);
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(UIAnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (this.hasFired) return this;
                return $5f1e708ec415b60e$var$_superPropGet(UIAnalyticsEvent, "update", this, 3)([
                    updater
                ]);
            }
        }
    ]);
}((0, $f150d5461c467163$export$2e2bcd8739ae039));



var $5FkrB = parcelRequire("5FkrB");

var $iyyOp = parcelRequire("iyyOp");
var $f041e46c3826fc87$export$d1f587f82ad51c4 = function useAnalyticsContext() {
    return (0, $5FkrB.useContext)((0, $iyyOp.default));
};


function $c09c67dbf32a3827$export$5bf35293e545f20c() {
    var analyticsContext = (0, $f041e46c3826fc87$export$d1f587f82ad51c4)();
    var createAnalyticsEvent = (0, $dLGML.useCallbackOne)(function(payload) {
        return new (0, $5f1e708ec415b60e$export$2e2bcd8739ae039)({
            context: analyticsContext.getAtlaskitAnalyticsContext(),
            handlers: analyticsContext.getAtlaskitAnalyticsEventHandlers(),
            payload: payload
        });
    }, [
        analyticsContext
    ]);
    return {
        createAnalyticsEvent: createAnalyticsEvent
    };
}



var $5FkrB = parcelRequire("5FkrB");
var $521ab623aa630431$export$1d27a74659855e44 = function useTrackedRef(value) {
    var ref = (0, $5FkrB.useRef)(value);
    ref.current = value;
    return ref;
};


function $e18af02ff64c1d51$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $e18af02ff64c1d51$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $e18af02ff64c1d51$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $e18af02ff64c1d51$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $e18af02ff64c1d51$export$a4687b0234b40e28(_ref) {
    var fn = _ref.fn, action = _ref.action, componentName = _ref.componentName, actionSubject = _ref.actionSubject, packageName = _ref.packageName, packageVersion = _ref.packageVersion, analyticsData = _ref.analyticsData;
    var _useAnalyticsEvents = (0, $c09c67dbf32a3827$export$5bf35293e545f20c)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
    // We put analyticsData and fn in a ref so that we don't need to break
    // memoization.
    // Generally these could be defined by consumers inline
    // and so we do this to avoid breaking memoization of useCallback
    var dataRef = (0, $521ab623aa630431$export$1d27a74659855e44)(analyticsData);
    var fnRef = (0, $521ab623aa630431$export$1d27a74659855e44)(fn);
    var handler = (0, $5FkrB.useCallback)(function(value) {
        var analyticsEvent = createAnalyticsEvent({
            action: action,
            actionSubject: actionSubject || componentName,
            attributes: {
                componentName: componentName,
                packageName: packageName,
                packageVersion: packageVersion
            }
        });
        // To avoid wrapping this component in AnalyticsContext we manually
        // push the parent context's meta data into the context.
        // Note: this new 'context'
        var context = $e18af02ff64c1d51$var$_objectSpread({
            componentName: componentName,
            packageName: packageName,
            packageVersion: packageVersion
        }, dataRef.current);
        analyticsEvent.context.push(context);
        // fire an event on the atlaskit channel
        var clone = analyticsEvent.clone();
        if (clone) clone.fire('atlaskit');
        fnRef.current(value, analyticsEvent);
    }, [
        // These are strings and won't change
        action,
        componentName,
        actionSubject,
        packageName,
        packageVersion,
        // This function is memoized in the context
        createAnalyticsEvent,
        // these are a stable ref because of the useTrackedRef hook
        dataRef,
        fnRef
    ]);
    return handler;
}



var $iO8GM = parcelRequire("iO8GM");
/* checkbox-icon.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");
/**
 * Styles for the checkbox icon.
 * CSS custom properties for colors are set by the parent Label element
 * and consumed directly in these styles.
 */ var $c30cf9142c2d249a$var$svgStyles = {
    root: "_nd5lfibj _1reo15vq _18m915vq _v5641mn3 _2rko12b0 _1a3742bt _lcxvglyw _syazmov0 _lswu1kgh _1cwg1i6y",
    rect: "_v56411so _1snbe4h9 _1s17hteq"
};
function $c30cf9142c2d249a$var$getIcon(isIndeterminate, isChecked) {
    if (isIndeterminate) return /*#__PURE__*/ $5FkrB.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M7.75 12.75H16.25V11.25H7.75V12.75Z",
        fill: "inherit"
    });
    if (isChecked) return /*#__PURE__*/ $5FkrB.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M16.3262 9.48011L15.1738 8.51984L10.75 13.8284L8.82616 11.5198L7.67383 12.4801L10.1738 15.4801C10.3163 15.6511 10.5274 15.75 10.75 15.75C10.9726 15.75 11.1837 15.6511 11.3262 15.4801L16.3262 9.48011Z",
        fill: "inherit"
    });
    // No icon
    return null;
}
/**
 * __Checkbox icon__
 *
 * A checkbox icon is the visual representation of checkbox state,
 * which is shown instead of the native input.
 *
 * @internal
 */ var $c30cf9142c2d249a$var$CheckboxIcon = /*#__PURE__*/ (0, $5FkrB.memo)(function(_ref) {
    var isIndeterminate = _ref.isIndeterminate, isChecked = _ref.isChecked;
    var icon = (0, $5FkrB.useMemo)(function() {
        return $c30cf9142c2d249a$var$getIcon(isIndeterminate, isChecked);
    }, [
        isIndeterminate,
        isChecked
    ]);
    return /*#__PURE__*/ $5FkrB.createElement("svg", {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        role: "presentation",
        className: (0, $970q7.default)([
            $c30cf9142c2d249a$var$svgStyles.root
        ])
    }, /*#__PURE__*/ $5FkrB.createElement("g", {
        fillRule: "evenodd"
    }, /*#__PURE__*/ $5FkrB.createElement("rect", {
        fill: "currentColor",
        x: "5.5",
        y: "5.5",
        width: "13",
        height: "13",
        rx: "1.5",
        className: (0, $970q7.default)([
            $c30cf9142c2d249a$var$svgStyles.rect
        ])
    }), icon));
});
var $c30cf9142c2d249a$export$2e2bcd8739ae039 = $c30cf9142c2d249a$var$CheckboxIcon;

/* label.tsx generated by @compiled/babel-plugin v0.38.1 */ /**
 * Base state styles with CSS custom properties.
 * Pseudo-selectors (:hover, :focus-within, :active) on the label element
 * update CSS variables that cascade to the CheckboxIcon.
 * This avoids nested sibling selectors.
 *
 * Uses `css` over `cssMap` to work around a bug in Compiled types when
 * using CSS variables in pseudo-selectors.
 */ 
var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");
var $3b03ac2b87f5e244$var$baseStyles = null;
var $3b03ac2b87f5e244$var$textLabelLayoutStyles = null;
// Checked/Indeterminate state
var $3b03ac2b87f5e244$var$checkedStyles = null;
// Invalid state - must override hover/active to maintain red border
var $3b03ac2b87f5e244$var$invalidStyles = null;
// Disabled state - must override hover/active to maintain disabled appearance
var $3b03ac2b87f5e244$var$disabledStyles = null;
// Disabled + Checked/Indeterminate
var $3b03ac2b87f5e244$var$disabledCheckedStyles = null;
function $3b03ac2b87f5e244$export$2e2bcd8739ae039(_ref) {
    var children = _ref.children, isDisabled = _ref.isDisabled, isChecked = _ref.isChecked, isIndeterminate = _ref.isIndeterminate, isInvalid = _ref.isInvalid, testId = _ref.testId, label = _ref.label, id = _ref.id, xcss = _ref.xcss;
    return /*#__PURE__*/ $5FkrB.createElement("label", {
        className: (0, $970q7.default)([
            "_11c8fhey _1e0c11p5 _1ejihkll _umai184x _1qwn1j9a _f0grrsbi _1c53glyw _1e9d1j28 _syazi7uo _80om73ad _ljcgdfik _1vj5l4ek _dh4gr01l _cz1u1l7x _jom5wc43 _1s071onz _106f1onz",
            label && "_zulp1nu5 _yv0ey09t",
            (isChecked || isIndeterminate) && "_1qwnjmqp _f0grjmqp _1e9d5w2r _1vj51q28 _q29q1q28 _dh4gr01l _cz1u1l7x _zoo95w2r _jom5wc43 _1s071onz _106f1onz",
            isInvalid && "_f0gr1bqt _q29q1bqt _cz1u1bqt _1s07gir2",
            isDisabled && "_1qwnby5v _f0grby5v _syaz1tvo _80om13gf _1vj5by5v _q29qby5v _dh4gby5v _cz1uby5v _jom5wc43 _1s0718qt _106f18qt",
            isDisabled && (isChecked || isIndeterminate) && "_1e9d2sac _9js12sac _zoo92sac",
            xcss
        ]),
        "data-testid": testId,
        "data-disabled": isDisabled || undefined,
        id: id
    }, children);
}

/* label-text.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");
var $354cf3d9c52a9cc1$var$labelTextStyles = null;
function $354cf3d9c52a9cc1$export$2e2bcd8739ae039(_ref) {
    var children = _ref.children;
    return /*#__PURE__*/ $5FkrB.createElement("span", {
        className: (0, $970q7.default)([
            "_nd5l11ig _1wpz1h6o"
        ])
    }, children);
}

/* required-indicator.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");
var $cAVP0 = parcelRequire("cAVP0");
// Reds
var $11d0f24a4ddb8d4f$export$4b84fd0e2c617bd = '#FFEBE6';
var $11d0f24a4ddb8d4f$export$b34b069eff244586 = '#FFBDAD';
var $11d0f24a4ddb8d4f$export$be802dd0d8b57f35 = '#FF8F73';
var $11d0f24a4ddb8d4f$export$60847d42f9da92a6 = '#FF7452';
var $11d0f24a4ddb8d4f$export$4a7404f376229999 = '#FF5630';
var $11d0f24a4ddb8d4f$export$2010d0fb4295b346 = '#DE350B';
var $11d0f24a4ddb8d4f$export$2837b5a1a71d5c02 = '#BF2600';
var $11d0f24a4ddb8d4f$export$8d9596b529bbb9cf = '#FFFAE6';
var $11d0f24a4ddb8d4f$export$41060a744ab0b7ae = '#FFF0B3';
var $11d0f24a4ddb8d4f$export$1cc05bbbf340e559 = '#FFE380';
var $11d0f24a4ddb8d4f$export$5aae31392d72caaa = '#FFC400';
var $11d0f24a4ddb8d4f$export$c6930421db9fa514 = '#FFAB00';
var $11d0f24a4ddb8d4f$export$59619663aa6500fb = '#FF991F';
var $11d0f24a4ddb8d4f$export$874739ea9e379ab6 = '#FF8B00';
var $11d0f24a4ddb8d4f$export$8a6341c32b6a3ee6 = '#E3FCEF';
var $11d0f24a4ddb8d4f$export$69a3bf21b9686c2b = '#ABF5D1';
var $11d0f24a4ddb8d4f$export$afbce1382ec95f73 = '#79F2C0';
var $11d0f24a4ddb8d4f$export$747d86715d4175de = '#57D9A3';
var $11d0f24a4ddb8d4f$export$940e1f69e873f202 = '#36B37E';
var $11d0f24a4ddb8d4f$export$a49394138f7b8e85 = '#00875A';
var $11d0f24a4ddb8d4f$export$6fa04827ac68a4fb = '#006644';
var $11d0f24a4ddb8d4f$export$226de0355ed012f8 = '#DEEBFF';
var $11d0f24a4ddb8d4f$export$8c13c2ee36917869 = '#B3D4FF';
var $11d0f24a4ddb8d4f$export$ecfc1dff386a3e7a = '#4C9AFF';
var $11d0f24a4ddb8d4f$export$215b7063051591f1 = '#2684FF';
var $11d0f24a4ddb8d4f$export$e62e8919cca44969 = '#0065FF';
var $11d0f24a4ddb8d4f$export$b3de0ae08da2ce64 = '#0052CC';
var $11d0f24a4ddb8d4f$export$a6ee3d71bc067634 = '#0747A6';
var $11d0f24a4ddb8d4f$export$67f15409e87642a1 = '#669DF1';
var $11d0f24a4ddb8d4f$export$f0539dbc42dbb067 = '#8FB8F6';
var $11d0f24a4ddb8d4f$export$363e4475840015bb = '#EAE6FF';
var $11d0f24a4ddb8d4f$export$4b0a4417ed59760f = '#C0B6F2';
var $11d0f24a4ddb8d4f$export$6011520a64d9a187 = '#998DD9';
var $11d0f24a4ddb8d4f$export$a7175d4e9206bc80 = '#8777D9';
var $11d0f24a4ddb8d4f$export$b48405b95304b5a1 = '#6554C0';
var $11d0f24a4ddb8d4f$export$c71e4279dd54a18d = '#5243AA';
var $11d0f24a4ddb8d4f$export$147899de772240ec = '#403294';
var $11d0f24a4ddb8d4f$export$2cf711fe14c66f06 = '#E6FCFF';
var $11d0f24a4ddb8d4f$export$7a8f4d33f6f9772c = '#B3F5FF';
var $11d0f24a4ddb8d4f$export$776c9c497ef08533 = '#79E2F2';
var $11d0f24a4ddb8d4f$export$69cb3ca10c1e330e = '#00C7E6';
var $11d0f24a4ddb8d4f$export$9dc1ef0f3f48059b = '#00B8D9';
var $11d0f24a4ddb8d4f$export$7c835c78b6fcdef8 = '#00A3BF';
var $11d0f24a4ddb8d4f$export$6036577f95c3877e = '#008DA6';
var $11d0f24a4ddb8d4f$export$29a4f05edc054374 = '#FFFFFF';
var $11d0f24a4ddb8d4f$export$e655ef011c4aa1a2 = '#FAFBFC';
var $11d0f24a4ddb8d4f$export$9fdfb749e33cdf97 = '#F4F5F7';
var $11d0f24a4ddb8d4f$export$3e51e8f1440314ba = '#EBECF0';
var $11d0f24a4ddb8d4f$export$1ce2d1575d444ceb = '#DFE1E6';
var $11d0f24a4ddb8d4f$export$8754fc7e6d8b3000 = '#C1C7D0';
var $11d0f24a4ddb8d4f$export$c2e91cbeada39b8b = '#B3BAC5';
var $11d0f24a4ddb8d4f$export$5f71e19f3a7ad9de = '#A5ADBA';
var $11d0f24a4ddb8d4f$export$eaa8c8a70ac22806 = '#97A0AF';
var $11d0f24a4ddb8d4f$export$7c87d337fb91a97d = '#8993A4';
var $11d0f24a4ddb8d4f$export$d6447c357493214f = '#7A869A';
var $11d0f24a4ddb8d4f$export$f563ee71e9ee74cd = '#6B778C';
var $11d0f24a4ddb8d4f$export$e2ef2124cf4024b1 = '#5E6C84';
var $11d0f24a4ddb8d4f$export$eece5f492e429f08 = '#505F79';
var $11d0f24a4ddb8d4f$export$c39c0fe0f26207ae = '#42526E';
var $11d0f24a4ddb8d4f$export$7090862dc3038a9f = '#344563';
var $11d0f24a4ddb8d4f$export$ad0bacf983b7ddaa = '#253858';
var $11d0f24a4ddb8d4f$export$7d61b15e0da132af = '#172B4D';
var $11d0f24a4ddb8d4f$export$fbda843f0a27fe96 = '#091E42';
var $11d0f24a4ddb8d4f$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
var $11d0f24a4ddb8d4f$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
var $11d0f24a4ddb8d4f$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
var $11d0f24a4ddb8d4f$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
var $11d0f24a4ddb8d4f$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
var $11d0f24a4ddb8d4f$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
var $11d0f24a4ddb8d4f$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
var $11d0f24a4ddb8d4f$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
var $11d0f24a4ddb8d4f$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
var $11d0f24a4ddb8d4f$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
var $11d0f24a4ddb8d4f$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
var $11d0f24a4ddb8d4f$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
var $11d0f24a4ddb8d4f$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
var $11d0f24a4ddb8d4f$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
var $11d0f24a4ddb8d4f$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
var $11d0f24a4ddb8d4f$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
var $11d0f24a4ddb8d4f$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
var $11d0f24a4ddb8d4f$export$2f6319cf7d736c2a = '#E6EDFA';
var $11d0f24a4ddb8d4f$export$95126bc8884d6634 = '#DCE5F5';
var $11d0f24a4ddb8d4f$export$8338d8c35d44ff1 = '#CED9EB';
var $11d0f24a4ddb8d4f$export$5368d76ae4fbbda7 = '#B8C7E0';
var $11d0f24a4ddb8d4f$export$9f0a771d16ec8d36 = '#ABBBD6';
var $11d0f24a4ddb8d4f$export$abcf8c38338b4aa5 = '#9FB0CC';
var $11d0f24a4ddb8d4f$export$97e81faa16a182c7 = '#8C9CB8';
var $11d0f24a4ddb8d4f$export$bfe21c59123ecf33 = '#7988A3';
var $11d0f24a4ddb8d4f$export$ee82aa2ea6a1558 = '#67758F';
var $11d0f24a4ddb8d4f$export$682927c6ed76be02 = '#56637A';
var $11d0f24a4ddb8d4f$export$91fd9994c5be9757 = '#455166';
var $11d0f24a4ddb8d4f$export$d281fbfe3cff2df6 = '#3B475C';
var $11d0f24a4ddb8d4f$export$3902c91d8b98a753 = '#313D52';
var $11d0f24a4ddb8d4f$export$8e8133c1ba5845b5 = '#283447';
var $11d0f24a4ddb8d4f$export$33ff357f6620b39 = '#202B3D';
var $11d0f24a4ddb8d4f$export$633847cf062b69e0 = '#1B2638';
var $11d0f24a4ddb8d4f$export$9776a6e503bdbf76 = '#121A29';
var $11d0f24a4ddb8d4f$export$6c813d5160dff5db = '#0E1624';
var $11d0f24a4ddb8d4f$export$3d4f271a500072a = '#0D1424';
var $11d0f24a4ddb8d4f$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
var $11d0f24a4ddb8d4f$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
var $11d0f24a4ddb8d4f$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
var $11d0f24a4ddb8d4f$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
var $11d0f24a4ddb8d4f$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
var $11d0f24a4ddb8d4f$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
var $11d0f24a4ddb8d4f$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
var $11d0f24a4ddb8d4f$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
var $11d0f24a4ddb8d4f$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
var $11d0f24a4ddb8d4f$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
var $11d0f24a4ddb8d4f$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
var $11d0f24a4ddb8d4f$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
var $11d0f24a4ddb8d4f$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
var $11d0f24a4ddb8d4f$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
var $11d0f24a4ddb8d4f$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
var $11d0f24a4ddb8d4f$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
var $11d0f24a4ddb8d4f$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';
var $11d0f24a4ddb8d4f$export$d2adc5dedf09fced = '#292A2E';
var $11d0f24a4ddb8d4f$export$f51762073d2bb381 = '#94C748';
var $11d0f24a4ddb8d4f$export$95e26d54def96891 = '#B3DF72';


var $2cf8b476b3bb79f9$var$requiredIndicatorStyles = null;
function $2cf8b476b3bb79f9$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ $5FkrB.createElement("span", {
        "aria-hidden": true,
        className: (0, $970q7.default)([
            "_syaz1ml5 _bozgv77o"
        ]),
        style: {
            "--_1xw92dq": (0, $cAVP0.default)("var(--ds-text-danger, ".concat((0, $11d0f24a4ddb8d4f$export$2837b5a1a71d5c02), ")"))
        }
    }, "*");
}


var $9530357121cd5f70$var$_excluded = [
    "isChecked",
    "isDisabled",
    "isInvalid",
    "defaultChecked",
    "isIndeterminate",
    "onChange",
    "analyticsContext",
    "label",
    "name",
    "value",
    "isRequired",
    "testId",
    "xcss",
    "className"
];
/**
 * The input is visually hidden but remains in the DOM for accessibility.
 * State-based styling is handled by the Label component using CSS custom properties
 * that cascade to the CheckboxIcon, avoiding nested sibling selectors.
 */ var $9530357121cd5f70$var$checkboxStyles = {
    root: "_19itglyw _nd5lfibj _12ji1r31 _1qu2glyw _12y31o36 _1bsb1osq _4t3i1osq _r06hglyw _6rthze3t _1pfhze3t _12l2ze3t _ahbqze3t _tzy4idpf"
};
/**
 * __Checkbox__
 *
 * A checkbox an input control that allows a user to select one or more options from a number of choices.
 *
 * - [Examples](https://atlassian.design/components/checkbox/examples)
 * - [Code](https://atlassian.design/components/checkbox/code)
 * - [Usage](https://atlassian.design/components/checkbox/usage)
 */ var $9530357121cd5f70$var$Checkbox = /*#__PURE__*/ (0, $5FkrB.memo)(/*#__PURE__*/ (0, $5FkrB.forwardRef)(function Checkbox(_ref, ref) {
    var isCheckedProp = _ref.isChecked, _ref$isDisabled = _ref.isDisabled, isDisabled = _ref$isDisabled === void 0 ? false : _ref$isDisabled, _ref$isInvalid = _ref.isInvalid, isInvalid = _ref$isInvalid === void 0 ? false : _ref$isInvalid, _ref$defaultChecked = _ref.defaultChecked, defaultChecked = _ref$defaultChecked === void 0 ? false : _ref$defaultChecked, _ref$isIndeterminate = _ref.isIndeterminate, isIndeterminate = _ref$isIndeterminate === void 0 ? false : _ref$isIndeterminate, onChangeProps = _ref.onChange, analyticsContext = _ref.analyticsContext, label = _ref.label, name = _ref.name, value = _ref.value, isRequired = _ref.isRequired, testId = _ref.testId, xcss = _ref.xcss, className = _ref.className, rest = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $9530357121cd5f70$var$_excluded);
    var _useState = (0, $5FkrB.useState)(isCheckedProp !== undefined ? isCheckedProp : defaultChecked), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), isCheckedState = _useState2[0], setIsCheckedState = _useState2[1];
    var onChange = (0, $5FkrB.useCallback)(function(e, analyticsEvent) {
        setIsCheckedState(e.target.checked);
        if (onChangeProps) onChangeProps(e, analyticsEvent);
    }, [
        onChangeProps
    ]);
    var onChangeAnalytics = (0, $e18af02ff64c1d51$export$a4687b0234b40e28)({
        fn: onChange,
        action: 'changed',
        analyticsData: analyticsContext,
        componentName: 'checkbox',
        packageName: "@atlaskit/checkbox",
        packageVersion: "17.3.4"
    });
    var internalRef = (0, $5FkrB.useRef)(null);
    var mergedRefs = (0, $iO8GM.default)([
        internalRef,
        ref
    ]);
    // Use isChecked from the state if it is controlled
    var isChecked = isCheckedProp === undefined ? isCheckedState : isCheckedProp;
    (0, $5FkrB.useEffect)(function() {
        if (internalRef.current) internalRef.current.indeterminate = isIndeterminate;
    }, [
        isIndeterminate
    ]);
    return /*#__PURE__*/ $5FkrB.createElement((0, $3b03ac2b87f5e244$export$2e2bcd8739ae039), {
        isDisabled: isDisabled,
        isChecked: isChecked,
        isIndeterminate: isIndeterminate,
        isInvalid: isInvalid,
        label: label,
        id: rest.id ? "".concat(rest.id, "-label") : undefined,
        testId: testId && "".concat(testId, "--checkbox-label"),
        xcss: xcss
    }, /*#__PURE__*/ $5FkrB.createElement("input", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        // It is necessary only for Safari. It allows to render focus styles.
        tabIndex: 0
    }, rest, {
        type: "checkbox",
        ref: mergedRefs,
        disabled: isDisabled,
        checked: isChecked,
        value: value,
        name: name,
        required: isRequired,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $970q7.default)([
            $9530357121cd5f70$var$checkboxStyles.root,
            className
        ]),
        onChange: onChangeAnalytics,
        "aria-invalid": isInvalid ? 'true' : undefined,
        "data-testid": testId && "".concat(testId, "--hidden-checkbox"),
        "data-invalid": isInvalid ? 'true' : undefined
    })), /*#__PURE__*/ $5FkrB.createElement((0, $c30cf9142c2d249a$export$2e2bcd8739ae039), {
        isIndeterminate: isIndeterminate,
        isChecked: isChecked
    }), label && /*#__PURE__*/ $5FkrB.createElement((0, $354cf3d9c52a9cc1$export$2e2bcd8739ae039), null, label, isRequired && /*#__PURE__*/ $5FkrB.createElement((0, $2cf8b476b3bb79f9$export$2e2bcd8739ae039), null)));
}));
$9530357121cd5f70$var$Checkbox.displayName = 'Checkbox';
var $9530357121cd5f70$export$2e2bcd8739ae039 = $9530357121cd5f70$var$Checkbox;



var $e8kqY = parcelRequire("e8kqY");



var $5FkrB = parcelRequire("5FkrB");


var $fc0dd2f534f6c2e1$var$spacingStyles = (0, $e4d6a42270c0fa86$export$f6c783d06584602c)({
    width: '2rem',
    padding: 'space.0'
});
var $fc0dd2f534f6c2e1$export$1049d18762739f1d = function SelectableCell(_ref) {
    var children = _ref.children, as = _ref.as;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $48eaba2dc4ec4d09$export$41ad0bbfa4755cac), {
        as: as,
        xcss: $fc0dd2f534f6c2e1$var$spacingStyles
    }, children);
};


var $1784c866f06db016$var$SelectableCellComponent = function SelectableCellComponent() {
    var _useSelection = (0, $777bb5c8a69aeae5$export$a97c3cc4bf1da1ca)(), _useSelection2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useSelection, 2), _useSelection2$ = _useSelection2[0], allChecked = _useSelection2$.allChecked, checked = _useSelection2$.checked, toggleSelection = _useSelection2[1].toggleSelection;
    var idx = (0, $1f65586892545a6c$export$81981d840a2ece5)();
    var isChecked = (0, $5FkrB.useMemo)(function() {
        return allChecked || checked.includes(idx);
    }, [
        allChecked,
        checked,
        idx
    ]);
    var onChange = (0, $5FkrB.useCallback)(function(e) {
        return toggleSelection === null || toggleSelection === void 0 ? void 0 : toggleSelection(idx, e.nativeEvent.shiftKey);
    }, [
        idx,
        toggleSelection
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $fc0dd2f534f6c2e1$export$1049d18762739f1d), {
        as: "td"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $9530357121cd5f70$export$2e2bcd8739ae039), {
        isChecked: isChecked,
        onChange: onChange,
        label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $e8kqY.default), null, "Select row ", idx + 1)
    }));
};
var $1784c866f06db016$var$SelectableCell = /*#__PURE__*/ (0, $5FkrB.memo)($1784c866f06db016$var$SelectableCellComponent);
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$1784c866f06db016$export$2e2bcd8739ae039 = $1784c866f06db016$var$SelectableCell;



/* tr.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $5FkrB = parcelRequire("5FkrB");

/* index.tsx generated by @compiled/babel-plugin v0.38.1 */ parcelRequire("5FkrB");


var $Pd8py = parcelRequire("Pd8py");
var $da9b4678c76c32cc$var$strictApi = (0, $Pd8py.createStrictAPI)();
var $da9b4678c76c32cc$export$dbf350e5966cf602 = $da9b4678c76c32cc$var$strictApi.css;
var $da9b4678c76c32cc$export$eb1ecd84a24ee424 = $da9b4678c76c32cc$var$strictApi.cssMap;
$da9b4678c76c32cc$var$strictApi.cssMap;
var $da9b4678c76c32cc$export$a274e22fb40f762e = $da9b4678c76c32cc$var$strictApi.cx;
var $da9b4678c76c32cc$var$XCSSProp = $da9b4678c76c32cc$var$strictApi.XCSSProp; // This is to mitigate local TS error TS2315: Type 'StrictXCSSProp' is not generic.
 // Currently for some reason tsc is generating malformed .d.ts in local dev environment, below change fixes it
 /**
 * ## StrictXCSSProp
 *
 * Declare styles your component takes with all other styles marked as violations
 * by the TypeScript compiler. There are two primary use cases for xcss prop:
 *
 * - safe style overrides
 * - inverting style declarations
 *
 * Interverting style declarations is interesting for platform teams as
 * it means apps only pay for styles they use as they're now the ones who declare
 * the styles!
 *
 * The {@link StrictXCSSProp} type has generics two of which must be defined — use to explicitly
 * set what you want to maintain as API. Use {@link XCSSAllProperties} and {@link XCSSAllPseudos}
 * to enable all properties and pseudos.
 *
 * The third generic is used to declare what properties and pseudos should be required.
 *
 * ```tsx
 * interface MyComponentProps {
 *   // Color is accepted, all other properties / pseudos are considered violations.
 *   xcss?: StrictXCSSProp<'color', never>;
 *
 *   // Only background color and hover pseudo are accepted.
 *   xcss?: StrictXCSSProp<'backgroundColor', '&:hover'>;
 *
 *   // All properties are accepted, all pseudos are considered violations.
 *   xcss?: StrictXCSSProp<XCSSAllProperties, never>;
 *
 *   // All properties are accepted, only the hover pseudo is accepted.
 *   xcss?: StrictXCSSProp<XCSSAllProperties, '&:hover'>;
 *
 *   // The xcss prop is required as well as the color property. No pseudos are required.
 *   xcss: StrictXCSSProp<
 *     XCSSAllProperties,
 *     '&:hover',
 *     { requiredProperties: 'color', requiredPseudos: never }
 *   >;
 * }
 *
 * function MyComponent({ xcss }: MyComponentProps) {
 *   return <div css={{ color: 'var(--ds-text-danger)' }} className={xcss} />
 * }
 * ```
 *
 * The xcss prop works with static inline objects and the [cssMap](https://compiledcssinjs.com/docs/api-cssmap) API.
 *
 * ```jsx
 * // Declared as an inline object
 * <Component xcss={{ color: 'var(--ds-text)' }} />
 *
 * // Declared with the cssMap API
 * const styles = cssMap({ text: { color: 'var(--ds-text)' } });
 * <Component xcss={styles.text} />
 * ```
 *
 * To concatenate and conditonally apply styles use the {@link cssMap} and {@link cx} functions.
 */ 


/* focusable.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $kqp0i = parcelRequire("kqp0i");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");
var $eebd42600c0b8c3d$var$_excluded = [
    "as",
    "children",
    "isInset",
    "testId",
    "style",
    "xcss"
], $eebd42600c0b8c3d$var$_excluded2 = [
    "className"
];
var $eebd42600c0b8c3d$var$focusRingStyles = null;
var $eebd42600c0b8c3d$var$insetFocusRingStyles = null;
/**
 * __Focus ring__
 *
 * A focus ring visually indicates the currently focused item.
 *
 */ var $eebd42600c0b8c3d$var$Focusable = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? 'button' : _ref$as, children = _ref.children, isInset = _ref.isInset, testId = _ref.testId, style = _ref.style, xcss = _ref.xcss, htmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $eebd42600c0b8c3d$var$_excluded);
    // This is to remove className from safeHtmlAttributes
    // @ts-ignore -- not using expect since it causes issues with help-center local consumption - className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(htmlAttributes, $eebd42600c0b8c3d$var$_excluded2);
    return /*#__PURE__*/ $5FkrB.createElement(Component, (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, safeHtmlAttributes, {
        // @ts-ignore Expression produces a union type that is too complex to represent. We may be able to narrow the type here but unsure.
        ref: ref,
        className: (0, $970q7.default)([
            "_ymio1r31 _ypr0glyw _zcxs1o36 _mizu194a _1ah3dkaa _ra3xnqa1 _128mdkaa _1cvmnqa1 _4davt94y",
            isInset && "_1ah31gjf _2mwq1gjf",
            xcss
        ]),
        style: style,
        "data-testid": testId
    }), children);
});
var $eebd42600c0b8c3d$export$2e2bcd8739ae039 = $eebd42600c0b8c3d$var$Focusable;


var $d34538b46070ed67$var$styles = {
    base: "_19itglyw _4t3i1wto _kqswh2mm _hpylidpf _btyzidpf",
    selected: "_bfhkcslv _irr3quvt",
    subitem: "_bfhkm7j4",
    bodyRow: "_1r62e4h9 _12ornqa1 _1ezz1tr0 _irr3134o"
};
var $d34538b46070ed67$export$5582bd7183a5e873 = function TR(_ref) {
    var children = _ref.children, testId = _ref.testId, isSelected = _ref.isSelected, _ref$isBodyRow = _ref.isBodyRow, isBodyRow = _ref$isBodyRow === void 0 ? true : _ref$isBodyRow, isSubitem = _ref.isSubitem;
    return /*#__PURE__*/ $5FkrB.createElement((0, $eebd42600c0b8c3d$export$2e2bcd8739ae039), {
        as: "tr",
        isInset: true,
        tabIndex: -1,
        "aria-selected": isSelected,
        testId: testId,
        xcss: (0, $da9b4678c76c32cc$export$a274e22fb40f762e)($d34538b46070ed67$var$styles.base, isBodyRow && $d34538b46070ed67$var$styles.bodyRow, isSelected && $d34538b46070ed67$var$styles.selected, isSubitem && $d34538b46070ed67$var$styles.subitem)
    }, children);
};


/**
 * __Row__
 *
 * A table row.
 *
 * - [Examples](https://atlassian.design/components/table/examples)
 */ var $1df2a8a5055de686$var$Row = /*#__PURE__*/ (0, $5FkrB.memo)(function(_ref) {
    var children = _ref.children, testId = _ref.testId;
    // To ensure valid nesting
    (0, $3ec5c5d14d7bc945$export$e4e48199ad91605c)();
    // to access table state
    var _useTable = (0, $c410d2d48027d6af$export$25bceaac3c7e4dc7)(), isSelectable = _useTable.isSelectable;
    var _useSelection = (0, $777bb5c8a69aeae5$export$a97c3cc4bf1da1ca)(), _useSelection2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useSelection, 1), _useSelection2$ = _useSelection2[0], allChecked = _useSelection2$.allChecked, checked = _useSelection2$.checked;
    var _useExpand = (0, $6a2e067d7f178d02$export$2e2bcd8739ae039)(), isExpanded = _useExpand.isExpanded;
    var _useExpandContent = (0, $043408dc1c1a3669$export$2e2bcd8739ae039)(), isExpandableContent = _useExpandContent.isExpandableContent;
    var rowId = (0, $1f65586892545a6c$export$81981d840a2ece5)();
    var isSelected = (0, $5FkrB.useMemo)(function() {
        if (!isSelectable || rowId === undefined) return undefined;
        return allChecked || checked.includes(rowId);
    }, [
        allChecked,
        checked,
        isSelectable,
        rowId
    ]);
    if (isExpanded === false && isExpandableContent) return null;
    var selectableCell = isSelectable && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $1784c866f06db016$export$2e2bcd8739ae039), null);
    if (isSelectable && isExpandableContent) selectableCell = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $fc0dd2f534f6c2e1$export$1049d18762739f1d), {
        as: "td"
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $d34538b46070ed67$export$5582bd7183a5e873), {
        isSelected: isSelected,
        testId: testId,
        isSubitem: isExpandableContent
    }, selectableCell, children);
});
var $1df2a8a5055de686$export$2e2bcd8739ae039 = $1df2a8a5055de686$var$Row;


var $1Vcia = parcelRequire("1Vcia");

var $25nEq = parcelRequire("25nEq");

var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");




/* tbody.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");
var $5e0a6a316d56daa1$var$bodyStyles = null;
var $5e0a6a316d56daa1$export$7005b8a93a167348 = function TBody(_ref) {
    var children = _ref.children;
    return /*#__PURE__*/ $5FkrB.createElement("tbody", {
        className: (0, $970q7.default)([
            "_19itglyw _kqswh2mm _9v7aidpf _18postnw _8x3u8fd9 _aetrb3bt _11fnglyw"
        ])
    }, children);
};


var $722a9df093eb8cc5$var$_excluded = [
    "idx"
];
function $722a9df093eb8cc5$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $722a9df093eb8cc5$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $722a9df093eb8cc5$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $722a9df093eb8cc5$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
/**
 * __Table body__
 */ function $722a9df093eb8cc5$var$TBody(_ref) {
    var rows = _ref.rows, children = _ref.children;
    var _useTable = (0, $c410d2d48027d6af$export$25bceaac3c7e4dc7)(), sortFn = _useTable.sortFn;
    var _useSelection = (0, $777bb5c8a69aeae5$export$a97c3cc4bf1da1ca)(), _useSelection2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useSelection, 2), _state = _useSelection2[0], _useSelection2$ = _useSelection2[1], removeAll = _useSelection2$.removeAll, setMax = _useSelection2$.setMax;
    // TODO: this seems like something the user should control or opt into.
    (0, $5FkrB.useEffect)(function() {
        removeAll === null || removeAll === void 0 || removeAll();
    // eslint-disable-next-line react-hooks/exhaustive-deps -- When the rows change, we [currently] want to call removeAll.
    }, [
        rows
    ]);
    var childrenCount = (0, $5FkrB.Children).count(children);
    var rowsLength = rows === null || rows === void 0 ? void 0 : rows.length;
    // Set data length (via setMax) whenever data changes
    (0, $5FkrB.useEffect)(function() {
        var numRows = rowsLength !== null && rowsLength !== void 0 ? rowsLength : childrenCount;
        setMax === null || setMax === void 0 || setMax(numRows);
    }, [
        rowsLength,
        childrenCount,
        setMax
    ]);
    var sortedRows = (0, $5FkrB.useMemo)(function() {
        return rows === null || rows === void 0 ? void 0 : rows.map(function(row, idx) {
            return $722a9df093eb8cc5$var$_objectSpread($722a9df093eb8cc5$var$_objectSpread({}, row), {}, {
                idx: idx
            });
        }).sort(sortFn);
    }, [
        rows,
        sortFn
    ]);
    var renderedChildren = function() {
        if (typeof children === 'function') return sortedRows === null || sortedRows === void 0 ? void 0 : sortedRows.map(function(_ref2) {
            var idx = _ref2.idx, row = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref2, $722a9df093eb8cc5$var$_excluded);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $1f65586892545a6c$export$329ef9142f16ee64), {
                key: idx,
                value: idx
            }, // @ts-expect-error
            children(row));
        });
        var childrenArray = Array.isArray(children) ? children : [
            children
        ];
        return childrenArray.map(function(row, idx) {
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $1f65586892545a6c$export$329ef9142f16ee64), {
                key: idx,
                value: idx
            }, row);
        });
    }();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $3ec5c5d14d7bc945$export$c0d7aba0938441d), {
        value: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $5e0a6a316d56daa1$export$7005b8a93a167348), null, renderedChildren));
}
var $722a9df093eb8cc5$export$2e2bcd8739ae039 = $722a9df093eb8cc5$var$TBody;


var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");


var $fC8ib = parcelRequire("fC8ib");

var $5FkrB = parcelRequire("5FkrB");

var $74Zh5 = parcelRequire("74Zh5");


var $fC8ib = parcelRequire("fC8ib");

var $5FkrB = parcelRequire("5FkrB");

var $74Zh5 = parcelRequire("74Zh5");


var $c26cb8c597cf5d6f$var$justifyContentMap = {
    start: (0, $74Zh5.css)({
        justifyContent: 'start'
    }),
    center: (0, $74Zh5.css)({
        justifyContent: 'center'
    }),
    end: (0, $74Zh5.css)({
        justifyContent: 'end'
    }),
    'space-between': (0, $74Zh5.css)({
        justifyContent: 'space-between'
    }),
    'space-around': (0, $74Zh5.css)({
        justifyContent: 'space-around'
    }),
    'space-evenly': (0, $74Zh5.css)({
        justifyContent: 'space-evenly'
    }),
    stretch: (0, $74Zh5.css)({
        justifyContent: 'stretch'
    })
};
var $c26cb8c597cf5d6f$var$flexDirectionMap = {
    column: (0, $74Zh5.css)({
        flexDirection: 'column'
    }),
    row: (0, $74Zh5.css)({
        flexDirection: 'row'
    })
};
var $c26cb8c597cf5d6f$var$flexWrapMap = {
    wrap: (0, $74Zh5.css)({
        flexWrap: 'wrap'
    }),
    nowrap: (0, $74Zh5.css)({
        flexWrap: 'nowrap'
    })
};
var $c26cb8c597cf5d6f$var$alignItemsMap = {
    start: (0, $74Zh5.css)({
        alignItems: 'start'
    }),
    center: (0, $74Zh5.css)({
        alignItems: 'center'
    }),
    baseline: (0, $74Zh5.css)({
        alignItems: 'baseline'
    }),
    end: (0, $74Zh5.css)({
        alignItems: 'end'
    }),
    stretch: (0, $74Zh5.css)({
        alignItems: 'stretch'
    })
};
var $c26cb8c597cf5d6f$var$baseStyles = (0, $74Zh5.css)({
    display: 'flex',
    boxSizing: 'border-box'
});
/**
 * __Flex__
 *
 * `Flex` is a primitive component that implements the CSS Flexbox API.
 *
 * - [Examples](https://atlassian.design/components/primitives/flex/examples)
 * - [Code](https://atlassian.design/components/primitives/flex/code)
 *
 * @example
 * ```tsx
 * // eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
 * import { Flex, Box } from '@atlaskit/primitives'
 *
 * const Component = () => (
 *   <Flex direction="column">
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *   </Flex>
 * )
 * ```
 */ var $c26cb8c597cf5d6f$var$Flex = /*#__PURE__*/ (0, $5FkrB.memo)(/*#__PURE__*/ (0, $5FkrB.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? 'div' : _ref$as, role = _ref.role, alignItems = _ref.alignItems, justifyContent = _ref.justifyContent, gap = _ref.gap, columnGap = _ref.columnGap, rowGap = _ref.rowGap, children = _ref.children, testId = _ref.testId, direction = _ref.direction, wrap = _ref.wrap, xcss = _ref.xcss, id = _ref.id;
    var resolvedStyles = (0, $e4d6a42270c0fa86$export$a9c84988c8f81f2d)(xcss);
    return (0, $74Zh5.jsx)(Component, {
        id: id,
        role: role,
        className: resolvedStyles.static,
        css: [
            $c26cb8c597cf5d6f$var$baseStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            gap && (0, $8cd2f451c5ad80c5$export$bf46c3f9eeafc71f).gap[gap],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            columnGap && (0, $8cd2f451c5ad80c5$export$bf46c3f9eeafc71f).columnGap[columnGap],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            rowGap && (0, $8cd2f451c5ad80c5$export$bf46c3f9eeafc71f).rowGap[rowGap],
            alignItems && $c26cb8c597cf5d6f$var$alignItemsMap[alignItems],
            direction && $c26cb8c597cf5d6f$var$flexDirectionMap[direction],
            justifyContent && $c26cb8c597cf5d6f$var$justifyContentMap[justifyContent],
            wrap && $c26cb8c597cf5d6f$var$flexWrapMap[wrap]
        ].concat((0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(resolvedStyles.emotion || [])),
        "data-testid": testId,
        ref: ref
    }, children);
}));
$c26cb8c597cf5d6f$var$Flex.displayName = 'Flex';
var $c26cb8c597cf5d6f$export$2e2bcd8739ae039 = $c26cb8c597cf5d6f$var$Flex;


var $c03a9f36412c08af$var$flexGrowMap = {
    hug: (0, $e4d6a42270c0fa86$export$f6c783d06584602c)({
        flexGrow: 0
    }),
    fill: (0, $e4d6a42270c0fa86$export$f6c783d06584602c)({
        width: '100%',
        flexGrow: 1
    })
};
var $c03a9f36412c08af$var$separatorStyles = (0, $74Zh5.css)({
    color: "var(--ds-text-subtle, #42526E)",
    marginBlock: "var(--ds-space-0, 0px)",
    marginInline: "var(--ds-space-negative-025, -2px)",
    pointerEvents: 'none',
    userSelect: 'none'
});
var $c03a9f36412c08af$var$Separator = function Separator(_ref) {
    var children = _ref.children;
    return (0, $74Zh5.jsx)("span", {
        css: $c03a9f36412c08af$var$separatorStyles
    }, children);
};
/**
 * __Inline__
 *
 * Inline is a primitive component based on CSS Flexbox that manages the horizontal layout of direct children.
 *
 * @example
 * ```tsx
 *  <Inline>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *  </Inline>
 * ```
 *
 */ var $c03a9f36412c08af$var$Inline = /*#__PURE__*/ (0, $5FkrB.memo)(/*#__PURE__*/ (0, $5FkrB.forwardRef)(function(_ref2, ref) {
    var as = _ref2.as, alignInline = _ref2.alignInline, _ref2$alignBlock = _ref2.alignBlock, alignItems = _ref2$alignBlock === void 0 ? 'start' : _ref2$alignBlock, _ref2$shouldWrap = _ref2.shouldWrap, shouldWrap = _ref2$shouldWrap === void 0 ? false : _ref2$shouldWrap, spread = _ref2.spread, grow = _ref2.grow, space = _ref2.space, rowSpace = _ref2.rowSpace, separator = _ref2.separator, xcss = _ref2.xcss, testId = _ref2.testId, role = _ref2.role, id = _ref2.id, rawChildren = _ref2.children;
    var separatorComponent = typeof separator === 'string' ? (0, $74Zh5.jsx)($c03a9f36412c08af$var$Separator, null, separator) : separator;
    var children = separatorComponent ? (0, $5FkrB.Children).toArray(rawChildren).filter(Boolean).map(function(child, index) {
        return (0, $74Zh5.jsx)((0, $5FkrB.Fragment), {
            key: index
        }, separator && index > 0 ? separatorComponent : null, child);
    }) : rawChildren;
    var justifyContent = spread || alignInline;
    // We're type coercing this as Compiled styles in an array isn't supported by the types
    // But the runtime accepts it none-the-wiser. We can remove this entire block and replace
    // it with cx(defaultStyles, focusRingStyles, xcssStyles) when we've moved away from Emotion.
    var styles = grow ? [
        $c03a9f36412c08af$var$flexGrowMap[grow]
    ].concat((0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(Array.isArray(xcss) ? xcss : [
        xcss
    ])) : xcss;
    return (0, $74Zh5.jsx)((0, $c26cb8c597cf5d6f$export$2e2bcd8739ae039), {
        id: id,
        as: as,
        role: role,
        alignItems: alignItems,
        justifyContent: justifyContent,
        direction: "row",
        gap: space,
        rowGap: rowSpace,
        wrap: shouldWrap ? 'wrap' : undefined,
        xcss: styles,
        testId: testId,
        ref: ref
    }, children);
}));
$c03a9f36412c08af$var$Inline.displayName = 'Inline';
var $c03a9f36412c08af$export$2e2bcd8739ae039 = $c03a9f36412c08af$var$Inline;



var $e8kqY = parcelRequire("e8kqY");



var $5FkrB = parcelRequire("5FkrB");

var $c2c88a7f46957c03$var$overlayStyles = (0, $e4d6a42270c0fa86$export$f6c783d06584602c)({
    display: 'flex',
    position: 'absolute',
    inset: 'space.0',
    insetInlineStart: 'space.400'
});
var $c2c88a7f46957c03$export$7e782ae264b7f61c = function BulkActionOverlay(_ref) {
    var children = _ref.children;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $a18eb272727512e1$export$2e2bcd8739ae039), {
        as: "th",
        paddingInline: "space.100",
        backgroundColor: "elevation.surface",
        xcss: $c2c88a7f46957c03$var$overlayStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $c03a9f36412c08af$export$2e2bcd8739ae039), {
        space: "space.300",
        alignBlock: "center"
    }, children));
};



/* thead.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");
var $b1f2c46434dde5bf$var$baseStyles = null;
var $b1f2c46434dde5bf$export$c4c2bc57f2e82919 = function THead(_ref) {
    var children = _ref.children;
    return /*#__PURE__*/ $5FkrB.createElement("thead", {
        className: (0, $970q7.default)([
            "_1r04idpf _19itglyw _179rhf6m _mqm25u6v _kqsw1if8 _1pbykb7n _bfhkvuon"
        ])
    }, children);
};



var $46ca8edaccb96b62$var$THead = function THead(_ref) {
    var actions = _ref.actions, children = _ref.children;
    var _useTable = (0, $c410d2d48027d6af$export$25bceaac3c7e4dc7)(), isSelectable = _useTable.isSelectable;
    var _useSelection = (0, $777bb5c8a69aeae5$export$a97c3cc4bf1da1ca)(), _useSelection2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useSelection, 2), state = _useSelection2[0], _useSelection2$ = _useSelection2[1], setAll = _useSelection2$.setAll, removeAll = _useSelection2$.removeAll;
    var isChecked = state.allChecked || state.anyChecked;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $b1f2c46434dde5bf$export$c4c2bc57f2e82919), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $d34538b46070ed67$export$5582bd7183a5e873), {
        isBodyRow: false
    }, isSelectable && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $fc0dd2f534f6c2e1$export$1049d18762739f1d), {
        as: "th"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $9530357121cd5f70$export$2e2bcd8739ae039), {
        label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $e8kqY.default), {
            id: "select-all"
        }, "Select all rows"),
        onChange: isChecked ? removeAll : setAll,
        isChecked: isChecked,
        isIndeterminate: state.anyChecked && !state.allChecked
    })), children, isSelectable && isChecked && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $c2c88a7f46957c03$export$7e782ae264b7f61c), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("span", {
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            color: "var(--ds-text, #172B4D)",
            /* @ts-ignore migrate to Text */ // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            fontWeight: "var(--ds-font-weight-medium, 500)"
        }
    }, state.checked.length, " selected"), actions && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $c03a9f36412c08af$export$2e2bcd8739ae039), {
        alignBlock: "stretch",
        space: "space.100"
    }, actions(state.checked)))));
};
var $46ca8edaccb96b62$export$2e2bcd8739ae039 = $46ca8edaccb96b62$var$THead;


var $0e561d53dcc9f631$exports = {};
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::36758847330c30e3d31c155e38099f5e>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty($0e561d53dcc9f631$exports, "__esModule", {
    value: true
});
$0e561d53dcc9f631$exports.default = void 0;

var $0e561d53dcc9f631$var$_react = $0e561d53dcc9f631$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $0e561d53dcc9f631$var$_UNSAFE_baseNew = $0e561d53dcc9f631$var$_interopRequireDefault((parcelRequire("bPdWt")));
function $0e561d53dcc9f631$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Comment".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for comments on objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $0e561d53dcc9f631$var$CommentIcon = (props)=>/*#__PURE__*/ $0e561d53dcc9f631$var$_react.default.createElement($0e561d53dcc9f631$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="M4.25 13.25v-.75h-.2l-.172.099zm-3.5 2H0a.75.75 0 0 0 1.122.651zM2.625 2h10.75V.5H2.625zM14.5 3.125v8.25H16v-8.25zM13.375 12.5H4.25V14h9.125zm-9.497.099-3.5 2 .744 1.302 3.5-2zM1.5 15.25V3.125H0V15.25zM4 6.5h8V5H4zm0 3h5V8H4zm10.5 1.875c0 .621-.504 1.125-1.125 1.125V14A2.625 2.625 0 0 0 16 11.375zM13.375 2c.621 0 1.125.504 1.125 1.125H16A2.625 2.625 0 0 0 13.375.5zM2.625.5A2.625 2.625 0 0 0 0 3.125h1.5C1.5 2.504 2.004 2 2.625 2z"/>`
    }, props));
$0e561d53dcc9f631$var$CommentIcon.displayName = 'CommentIcon';
var $0e561d53dcc9f631$var$_default = $0e561d53dcc9f631$exports.default = $0e561d53dcc9f631$var$CommentIcon;


var $59c4a893ce5f1bf5$exports = {};
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3e445612cfd22a19ca6ff947247db0ce>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty($59c4a893ce5f1bf5$exports, "__esModule", {
    value: true
});
$59c4a893ce5f1bf5$exports.default = void 0;

var $59c4a893ce5f1bf5$var$_react = $59c4a893ce5f1bf5$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $59c4a893ce5f1bf5$var$_UNSAFE_baseNew = $59c4a893ce5f1bf5$var$_interopRequireDefault((parcelRequire("bPdWt")));
function $59c4a893ce5f1bf5$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "EyeOpen".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: watch page in Confluence, show password in text field, and following in Atlas.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $59c4a893ce5f1bf5$var$EyeOpenIcon = (props)=>/*#__PURE__*/ $59c4a893ce5f1bf5$var$_react.default.createElement($59c4a893ce5f1bf5$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M8 2.75c-3.255 0-6.086 2.039-7.13 4.888a1.06 1.06 0 0 0 0 .724C1.914 11.212 4.745 13.25 8 13.25s6.086-2.039 7.129-4.888a1.06 1.06 0 0 0 0-.724c-1.043-2.85-3.874-4.888-7.13-4.888Z"/><path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M10.25 8a2.25 2.25 0 1 1-4.5 0 2.25 2.25 0 0 1 4.5 0Z"/>`
    }, props));
$59c4a893ce5f1bf5$var$EyeOpenIcon.displayName = 'EyeOpenIcon';
var $59c4a893ce5f1bf5$var$_default = $59c4a893ce5f1bf5$exports.default = $59c4a893ce5f1bf5$var$EyeOpenIcon;


var $0dd7a84998b77bec$exports = {};
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::1b7d311e04eceb9781b3930a729d8836>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty($0dd7a84998b77bec$exports, "__esModule", {
    value: true
});
$0dd7a84998b77bec$exports.default = void 0;

var $0dd7a84998b77bec$var$_react = $0dd7a84998b77bec$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $0dd7a84998b77bec$var$_UNSAFE_baseNew = $0dd7a84998b77bec$var$_interopRequireDefault((parcelRequire("bPdWt")));
function $0dd7a84998b77bec$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "PersonAdded".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for a user added to an object.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $0dd7a84998b77bec$var$PersonAddedIcon = (props)=>/*#__PURE__*/ $0dd7a84998b77bec$var$_react.default.createElement($0dd7a84998b77bec$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M.75 15v-2.25a3 3 0 0 1 3-3h2.5a3 3 0 0 1 3 3V15m.25-7.278L11.346 9.5l4-4M8.25 4a3.25 3.25 0 1 1-6.5 0 3.25 3.25 0 0 1 6.5 0Z"/>`
    }, props));
$0dd7a84998b77bec$var$PersonAddedIcon.displayName = 'PersonAddedIcon';
var $0dd7a84998b77bec$var$_default = $0dd7a84998b77bec$exports.default = $0dd7a84998b77bec$var$PersonAddedIcon;


function $24c02ea0e14dbe4f$var$$parcel$exportWildcard(dest, source) {
    Object.keys(source).forEach(function(key) {
        if (key === 'default' || key === '__esModule' || dest.hasOwnProperty(key)) return;
        Object.defineProperty(dest, key, {
            enumerable: true,
            get: function get() {
                return source[key];
            }
        });
    });
    return dest;
}
function $24c02ea0e14dbe4f$var$$parcel$export(e, n, v, s) {
    Object.defineProperty(e, n, {
        get: v,
        set: s,
        enumerable: true,
        configurable: true
    });
}
function $24c02ea0e14dbe4f$var$$parcel$defineInteropFlag(a) {
    Object.defineProperty(a, '__esModule', {
        value: true,
        configurable: true
    });
}
/// <reference types="./types/custom.d.ts" />
var $24c02ea0e14dbe4f$var$$a69491ea5a126553$exports = {};
var $24c02ea0e14dbe4f$var$$5d4509b60606b6df$exports = {};
var $24c02ea0e14dbe4f$var$$660bd1c6cb41002a$exports = {};
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$660bd1c6cb41002a$exports, "Blockquote", ()=>$24c02ea0e14dbe4f$export$29a7a275fe11687);
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$660bd1c6cb41002a$exports, "blockquoteStyles", ()=>$24c02ea0e14dbe4f$export$7a77f8e9665fa6b2);
const $24c02ea0e14dbe4f$export$29a7a275fe11687 = ({ children: children })=>{
    return (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("blockquote", {
        css: (0, $74Zh5.css)($24c02ea0e14dbe4f$export$7a77f8e9665fa6b2),
        children: children
    });
};
const $24c02ea0e14dbe4f$var$$660bd1c6cb41002a$var$fontSizeStyles = {
    fontSize: "1.5rem",
    lineHeight: "2.25rem",
    fontWeight: 600
};
const $24c02ea0e14dbe4f$export$7a77f8e9665fa6b2 = {
    paddingLeft: 0,
    fontFamily: "Inter, sans-serif",
    color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text"),
    ...$24c02ea0e14dbe4f$var$$660bd1c6cb41002a$var$fontSizeStyles,
    span: $24c02ea0e14dbe4f$var$$660bd1c6cb41002a$var$fontSizeStyles,
    "&:before, &:after": {
        content: "''"
    }
};
var $24c02ea0e14dbe4f$var$$fec02fc26c7e145d$exports = {};
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$fec02fc26c7e145d$exports, "ButtonSize", ()=>$24c02ea0e14dbe4f$export$5dd2748b7940a2a0);
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$fec02fc26c7e145d$exports, "ButtonAppearance", ()=>$24c02ea0e14dbe4f$export$261c9483fc4a455a);
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$fec02fc26c7e145d$exports, "Button", ()=>$24c02ea0e14dbe4f$export$353f5b6fc5456de1);
const $24c02ea0e14dbe4f$var$$ecfd5f2b18d4854e$export$b7c3a2f69225ecf = ({ label: label, type: type, clickHandler: clickHandler, iconBefore: iconBefore, iconAfter: iconAfter, appearance: appearance, testId: testId, href: href, target: target, fullWidth: fullWidth = false, disabled: disabled = false, isLoading: isLoading = false, selected: selected = false })=>{
    return (0, $6bec4f26b2cb3094$export$25062201e9e25d76)((0, $e015d36248b70172$export$2e2bcd8739ae039), {
        "aria-label": label.replaceAll("-", " "),
        type: type,
        onClick: clickHandler,
        iconBefore: iconBefore,
        iconAfter: iconAfter,
        appearance: appearance,
        testId: testId,
        href: href,
        target: target,
        shouldFitContainer: fullWidth,
        isDisabled: disabled || isLoading,
        isSelected: selected,
        css: [
            isLoading && !label && (0, $74Zh5.css)({
                padding: "21px 49px",
                alignItems: "center"
            }),
            fullWidth && (0, $74Zh5.css)({
                width: "100%",
                justifyContent: "center"
            })
        ],
        children: [
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("span", {
                css: [
                    isLoading && label && (0, $74Zh5.css)({
                        marginRight: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.100")
                    })
                ],
                children: label
            }),
            isLoading && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $e9bb9e7afd1cf629$export$2e2bcd8739ae039), {
                testId: "spinner",
                size: "small"
            })
        ]
    });
};
const $24c02ea0e14dbe4f$var$$384448a6ffd0907f$export$5be053290bf6cd4c = (appearance, selected, disabled)=>{
    let testId = `button-${appearance}`;
    if (selected) testId += "-selected";
    if (disabled) testId += "-disabled";
    return testId;
};
const $24c02ea0e14dbe4f$var$$384448a6ffd0907f$export$99c79d2ae299b19a = (iconType)=>iconType ? iconType.replaceAll("-", " ") : "button icon";
const $24c02ea0e14dbe4f$var$$f0f55be381b0aa07$export$c25acd513dcc8062 = ({ clickHandler: clickHandler, testId: testId, disabled: disabled = false, selected: selected = false, isLoading: isLoading = false, tooltip: tooltip, iconType: iconType, showBeforeIcon: showBeforeIcon, href: href, target: target, iconColor: iconColor, size: size })=>{
    const commonProps = {
        tabIndex: 0,
        "aria-label": $24c02ea0e14dbe4f$var$$384448a6ffd0907f$export$99c79d2ae299b19a(iconType),
        "data-testid": testId,
        css: [
            $24c02ea0e14dbe4f$var$$f0f55be381b0aa07$var$learningButtonIconStyles["base"],
            size === $24c02ea0e14dbe4f$export$5dd2748b7940a2a0.MEDIUM && $24c02ea0e14dbe4f$var$$f0f55be381b0aa07$var$learningButtonIconStyles["medium"],
            selected && $24c02ea0e14dbe4f$var$$f0f55be381b0aa07$var$learningButtonIconStyles["selected"],
            iconColor && (0, $74Zh5.css)({
                color: iconColor
            })
        ],
        onClick: clickHandler
    };
    const content = (0, $6bec4f26b2cb3094$export$25062201e9e25d76)((0, $6bec4f26b2cb3094$export$ffb0004e005737fa), {
        children: [
            isLoading && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $e9bb9e7afd1cf629$export$2e2bcd8739ae039), {
                testId: "spinner",
                size: "small"
            }),
            showBeforeIcon
        ]
    });
    let element;
    if (href && !disabled) element = (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("a", {
        ...commonProps,
        href: href,
        target: target,
        rel: target === "_blank" ? "noreferrer" : "",
        children: content
    });
    else element = (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("button", {
        id: "icon-button",
        ...commonProps,
        disabled: disabled,
        children: content
    });
    return tooltip ? (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $1ee6819d2d8fb6a1$export$2e2bcd8739ae039), {
        content: tooltip,
        testId: "tooltip",
        children: element
    }) : element;
};
const $24c02ea0e14dbe4f$var$$f0f55be381b0aa07$var$learningButtonIconStyles = {
    base: (0, $74Zh5.css)({
        width: "24px",
        height: "24px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        borderRadius: "4px",
        border: "none",
        color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.icon"),
        backgroundColor: "transparent",
        cursor: "pointer",
        "&:hover": {
            backgroundColor: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.background.accent.gray.subtlest.hovered")
        },
        "&:active": {
            backgroundColor: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.background.accent.gray.subtlest.pressed")
        },
        "&:disabled": {
            backgroundColor: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.background.disabled"),
            color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.icon.disabled"),
            cursor: "not-allowed"
        }
    }),
    medium: (0, $74Zh5.css)({
        width: "38px",
        height: "38px",
        minWidth: "38px",
        minHeight: "38px"
    }),
    selected: (0, $74Zh5.css)({
        backgroundColor: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.background.selected"),
        color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.icon.selected"),
        "&:hover": {
            backgroundColor: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.background.selected.hovered"),
            color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.icon.selected")
        }
    })
};
const $24c02ea0e14dbe4f$var$$426d900cf47bc59f$export$8f9833f38f34a075 = {
    basic: (0, $74Zh5.css)({
        fontFamily: "Charlie Text, sans-serif",
        display: "flex",
        alignItems: "center",
        borderRadius: "4px",
        borderStyle: "solid",
        borderWidth: "1px",
        cursor: "pointer",
        textDecoration: "none",
        justifyContent: "center",
        maxWidth: "max-content",
        width: "100%",
        whiteSpace: "nowrap",
        boxSizing: "border-box",
        height: "40px",
        "&:hover": {
            backgroundColor: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.background.selected.bold.hovered"),
            borderColor: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.border.selected"),
            color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text.inverse"),
            textDecoration: "none"
        },
        "&:active": {
            backgroundColor: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.background.selected.bold.pressed"),
            borderColor: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.border.selected"),
            color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text.inverse")
        },
        "&:disabled": {
            backgroundColor: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.background.disabled"),
            borderColor: "transparent",
            color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text.subtle"),
            cursor: "not-allowed"
        }
    }),
    primary: (0, $74Zh5.css)({
        padding: `10px ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.150")}`,
        backgroundColor: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.background.brand.bold"),
        borderColor: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.border.brand"),
        color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text.inverse"),
        "&:focus-visible": {
            outline: `2px solid ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.border.focused")}`
        }
    }),
    secondary: (0, $74Zh5.css)({
        padding: `10px ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.150")}`,
        backgroundColor: "transparent",
        borderColor: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.border.brand"),
        color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text.brand")
    }),
    danger: (0, $74Zh5.css)({
        padding: `10px ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.150")}`,
        backgroundColor: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.background.danger.bold"),
        borderColor: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.border.danger"),
        color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text.inverse")
    }),
    warning: (0, $74Zh5.css)({
        padding: `10px ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.150")}`,
        backgroundColor: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.background.warning.bold"),
        borderColor: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.border.warning"),
        color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text.warning.inverse")
    }),
    subtle: (0, $74Zh5.css)({
        padding: `10px ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.150")}`,
        backgroundColor: "transparent",
        borderColor: "transparent",
        color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text")
    }),
    success: (0, $74Zh5.css)({
        padding: `10px ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.150")}`,
        backgroundColor: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.background.success.bold"),
        borderColor: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.border.success"),
        color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text.inverse")
    }),
    selected: (0, $74Zh5.css)({
        backgroundColor: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.background.selected"),
        borderColor: "transparent",
        color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text.brand"),
        "&:hover": {
            backgroundColor: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.background.selected"),
            borderColor: "transparent",
            color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text.brand")
        }
    })
};
const $24c02ea0e14dbe4f$var$$426d900cf47bc59f$export$b2e4e24d9c5d7463 = {
    medium: (0, $74Zh5.css)({
        fontSize: "16px",
        lineHeight: "20px",
        fontWeight: 600,
        height: "40px"
    }),
    large: (0, $74Zh5.css)({
        fontSize: "20px",
        lineHeight: "24px",
        fontWeight: 600,
        height: "48px"
    })
};
const $24c02ea0e14dbe4f$var$$426d900cf47bc59f$export$84379743ac6ff850 = {
    medium: (0, $74Zh5.css)({
        padding: `10px ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.150")}`
    }),
    "medium-icon-before": (0, $74Zh5.css)({
        padding: `10px ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.150")} 10px 10px`
    }),
    "medium-icon-after": (0, $74Zh5.css)({
        padding: `10px 10px 10px ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.150")}`
    }),
    large: (0, $74Zh5.css)({
        maxWidth: "max-content",
        padding: `${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.150")} ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.200")}`
    }),
    "large-icon-before": (0, $74Zh5.css)({
        padding: `${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.150")} ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.200")} ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.150")} ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.150")}`
    }),
    "large-icon-after": (0, $74Zh5.css)({
        padding: `${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.150")} ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.150")} ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.150")} ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.200")}`
    })
};
const $24c02ea0e14dbe4f$var$$426d900cf47bc59f$export$6398dd78520de6de = {
    large: (0, $74Zh5.css)({
        [(0, $cb8cedbc477f5a81$export$987d49ffe1b0900f).below.sm]: {
            padding: `10px ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.150")}`
        }
    }),
    "large-icon-before": (0, $74Zh5.css)({
        [(0, $cb8cedbc477f5a81$export$987d49ffe1b0900f).below.sm]: {
            padding: `10px ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.150")} 10px 10px`
        }
    }),
    "large-icon-after": (0, $74Zh5.css)({
        [(0, $cb8cedbc477f5a81$export$987d49ffe1b0900f).below.sm]: {
            padding: `10px 10px 10px ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.150")}`
        }
    })
};
const $24c02ea0e14dbe4f$var$$426d900cf47bc59f$export$9d41b2b2e9b27135 = (0, $74Zh5.css)({
    [(0, $cb8cedbc477f5a81$export$987d49ffe1b0900f).below.sm]: {
        fontSize: "16px",
        lineHeight: "20px"
    }
});
const $24c02ea0e14dbe4f$var$$426d900cf47bc59f$export$1870a7443335e00d = (0, $74Zh5.css)({
    width: "20px",
    height: "20px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0,
    "& > span": {
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
    },
    "& svg": {
        maxWidth: "20px",
        maxHeight: "20px"
    }
});
const $24c02ea0e14dbe4f$var$$426d900cf47bc59f$export$46d009ded5eecf4e = (0, $74Zh5.css)({
    color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.icon"),
    cursor: "not-allowed"
});
const $24c02ea0e14dbe4f$var$$426d900cf47bc59f$export$d0e85600c25cfb6 = (0, $74Zh5.css)({
    backgroundColor: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.background.disabled"),
    borderColor: "transparent",
    color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text.subtle"),
    "&:hover": {
        backgroundColor: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.background.disabled"),
        borderColor: "transparent",
        color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text.subtle"),
        cursor: "not-allowed"
    }
});
const $24c02ea0e14dbe4f$var$$6fde84a571ed6267$export$8c0322faba831be3 = (appearance, size)=>[
        $24c02ea0e14dbe4f$var$$426d900cf47bc59f$export$8f9833f38f34a075["basic"],
        $24c02ea0e14dbe4f$var$$426d900cf47bc59f$export$8f9833f38f34a075[appearance],
        $24c02ea0e14dbe4f$var$$426d900cf47bc59f$export$b2e4e24d9c5d7463[size]
    ];
const $24c02ea0e14dbe4f$var$$6fde84a571ed6267$export$18739f551ab326b6 = (size, isButtonWithoutIcon, showBeforeIcon, showAfterIcon)=>{
    const styles = [];
    if (isButtonWithoutIcon) styles.push($24c02ea0e14dbe4f$var$$426d900cf47bc59f$export$84379743ac6ff850[size]);
    if (showBeforeIcon) styles.push($24c02ea0e14dbe4f$var$$426d900cf47bc59f$export$84379743ac6ff850[`${size}-icon-before`]);
    if (showAfterIcon) styles.push($24c02ea0e14dbe4f$var$$426d900cf47bc59f$export$84379743ac6ff850[`${size}-icon-after`]);
    return styles;
};
const $24c02ea0e14dbe4f$var$$6fde84a571ed6267$export$10dac92f1edafe3b = (isResponsiveSpacing, size, showBeforeIcon, showAfterIcon)=>{
    const styles = [
        $24c02ea0e14dbe4f$var$$426d900cf47bc59f$export$6398dd78520de6de[size],
        $24c02ea0e14dbe4f$var$$426d900cf47bc59f$export$9d41b2b2e9b27135
    ];
    if (!isResponsiveSpacing) return [];
    if (showBeforeIcon) styles.push($24c02ea0e14dbe4f$var$$426d900cf47bc59f$export$6398dd78520de6de[`${size}-icon-before`]);
    if (showAfterIcon) styles.push($24c02ea0e14dbe4f$var$$426d900cf47bc59f$export$6398dd78520de6de[`${size}-icon-after`]);
    return styles;
};
const $24c02ea0e14dbe4f$var$$6fde84a571ed6267$export$1bff1bc920069ec8 = (appearance)=>{
    if (appearance === $24c02ea0e14dbe4f$export$261c9483fc4a455a.PRIMARY) return (0, $74Zh5.css)({
        color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text.inverse")
    });
    if (appearance === $24c02ea0e14dbe4f$export$261c9483fc4a455a.SECONDARY) return (0, $74Zh5.css)({
        color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text.brand")
    });
    return null;
};
const $24c02ea0e14dbe4f$var$$6fde84a571ed6267$export$3f4ba612f3306fd2 = (selected, isLoading, disabled, fullWidth)=>{
    const styles = [];
    if (selected) styles.push($24c02ea0e14dbe4f$var$$426d900cf47bc59f$export$8f9833f38f34a075["selected"]);
    if (isLoading || disabled) styles.push((0, $74Zh5.css)({
        ...$24c02ea0e14dbe4f$var$$426d900cf47bc59f$export$d0e85600c25cfb6,
        pointerEvents: "none",
        cursor: "not-allowed"
    }));
    if (fullWidth) styles.push((0, $74Zh5.css)({
        width: "100%",
        maxWidth: "none",
        justifyContent: "center"
    }));
    return styles;
};
const $24c02ea0e14dbe4f$var$$6fde84a571ed6267$export$a803e3773f881664 = (size, isButtonWithoutIcon, showBeforeIcon, showAfterIcon, withPadding = true)=>{
    const linkButtonSpacingStyles = {
        medium: (0, $74Zh5.css)({
            padding: `10px ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.150")}`
        }),
        "medium-icon-before": (0, $74Zh5.css)({
            padding: `10px ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.150")} 10px 10px`
        }),
        "medium-icon-after": (0, $74Zh5.css)({
            padding: `10px 10px 10px ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.150")}`
        }),
        large: (0, $74Zh5.css)({
            maxWidth: "max-content",
            padding: `${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.150")} ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.200")}`
        }),
        "large-icon-before": (0, $74Zh5.css)({
            padding: `${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.150")} ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.200")} ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.150")} ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.150")}`
        }),
        "large-icon-after": (0, $74Zh5.css)({
            padding: `${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.150")} ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.150")} ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.150")} ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.200")}`
        })
    };
    const styles = [];
    if (isButtonWithoutIcon) styles.push(linkButtonSpacingStyles[size]);
    if (showBeforeIcon) styles.push(linkButtonSpacingStyles[`${size}-icon-before`]);
    if (showAfterIcon) styles.push(linkButtonSpacingStyles[`${size}-icon-after`]);
    if (!withPadding) styles.push((0, $74Zh5.css)({
        padding: 0
    }));
    return styles;
};
const $24c02ea0e14dbe4f$var$$9a690c81e99c8d02$var$getLinkButtonStyles = (disabled)=>[
        $24c02ea0e14dbe4f$var$$9a690c81e99c8d02$var$learningButtonLinkStyles["basic"],
        disabled && $24c02ea0e14dbe4f$var$$9a690c81e99c8d02$var$learningButtonLinkStyles["disabled"]
    ];
const $24c02ea0e14dbe4f$var$$9a690c81e99c8d02$export$29d11c0fe2fc51d8 = ({ label: label, disabled: disabled = false, clickHandler: clickHandler, testId: testId, size: size = $24c02ea0e14dbe4f$export$5dd2748b7940a2a0.MEDIUM, href: href, target: target, withPadding: withPadding = true, showBeforeIcon: showBeforeIcon, showAfterIcon: showAfterIcon, isButtonWithoutIcon: isButtonWithoutIcon })=>{
    const commonProps = {
        "aria-label": label.replaceAll("-", " "),
        "data-testid": testId,
        css: [
            ...$24c02ea0e14dbe4f$var$$9a690c81e99c8d02$var$getLinkButtonStyles(disabled),
            ...$24c02ea0e14dbe4f$var$$6fde84a571ed6267$export$a803e3773f881664(size, isButtonWithoutIcon, showBeforeIcon, showAfterIcon, withPadding)
        ]
    };
    const content = (0, $6bec4f26b2cb3094$export$25062201e9e25d76)((0, $6bec4f26b2cb3094$export$ffb0004e005737fa), {
        children: [
            showBeforeIcon && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("span", {
                css: [
                    $24c02ea0e14dbe4f$var$$9a690c81e99c8d02$var$buttonIconContainerStyles,
                    (0, $74Zh5.css)({
                        marginRight: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.050")
                    })
                ],
                children: showBeforeIcon
            }),
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("span", {
                children: label
            }),
            showAfterIcon && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("span", {
                css: [
                    $24c02ea0e14dbe4f$var$$9a690c81e99c8d02$var$buttonIconContainerStyles,
                    (0, $74Zh5.css)({
                        marginLeft: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.050")
                    }),
                    disabled && $24c02ea0e14dbe4f$var$$9a690c81e99c8d02$var$disabledIconStyles
                ],
                children: showAfterIcon
            })
        ]
    });
    if (href && !disabled) return (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("a", {
        ...commonProps,
        href: href,
        target: target,
        rel: target === "_blank" ? "noreferrer" : "",
        onClick: clickHandler,
        children: content
    });
    return (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("button", {
        ...commonProps,
        disabled: disabled,
        onClick: clickHandler,
        children: content
    });
};
const $24c02ea0e14dbe4f$var$$9a690c81e99c8d02$var$learningButtonLinkStyles = {
    basic: (0, $74Zh5.css)({
        display: "flex",
        width: "fit-content",
        padding: `10px ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.150")}`,
        border: "none",
        alignItems: "center",
        fontFamily: "Charlie Text, sans-serif",
        fontWeight: 600,
        fontSize: "16px",
        lineHeight: "20px",
        color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text.brand"),
        background: "transparent",
        outline: "none",
        cursor: "pointer",
        "&:hover": {
            color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text.brand"),
            textDecoration: "underline",
            textUnderlineOffset: "4px"
        },
        "&:active": {
            color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text.brand"),
            textDecoration: "underline"
        }
    }),
    disabled: (0, $74Zh5.css)({
        color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text.disabled"),
        "&:hover": {
            textDecoration: "none"
        },
        "&:active": {
            textDecoration: "none"
        }
    })
};
const $24c02ea0e14dbe4f$var$$9a690c81e99c8d02$var$buttonIconContainerStyles = (0, $74Zh5.css)({
    width: "24px",
    height: "24px"
});
const $24c02ea0e14dbe4f$var$$9a690c81e99c8d02$var$disabledIconStyles = (0, $74Zh5.css)({
    color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.icon.disabled"),
    cursor: "not-allowed"
});
const $24c02ea0e14dbe4f$var$$73286ba8e7c0bafe$export$9508e056e78f90ef = ({ label: label, appearance: appearance, disabled: disabled = false, isLoading: isLoading = false, clickHandler: clickHandler, testId: testId, href: href, target: target, fullWidth: fullWidth = false, selected: selected = false, size: size = $24c02ea0e14dbe4f$export$5dd2748b7940a2a0.MEDIUM, showBeforeIcon: showBeforeIcon, showAfterIcon: showAfterIcon, isButtonWithoutIcon: isButtonWithoutIcon, isResponsiveSpacing: isResponsiveSpacing, as: as = "a", type: type })=>{
    const commonProps = {
        "aria-label": label.replaceAll("-", " "),
        onClick: disabled || isLoading ? undefined : clickHandler,
        role: as === "button" ? undefined : href ? undefined : "button",
        tabIndex: disabled || isLoading ? -1 : 0,
        "data-testid": testId,
        css: [
            ...$24c02ea0e14dbe4f$var$$6fde84a571ed6267$export$8c0322faba831be3(appearance, size),
            ...$24c02ea0e14dbe4f$var$$6fde84a571ed6267$export$18739f551ab326b6(size, isButtonWithoutIcon, showBeforeIcon, showAfterIcon),
            ...$24c02ea0e14dbe4f$var$$6fde84a571ed6267$export$10dac92f1edafe3b(isResponsiveSpacing, size, showBeforeIcon, showAfterIcon),
            $24c02ea0e14dbe4f$var$$6fde84a571ed6267$export$1bff1bc920069ec8(appearance),
            ...$24c02ea0e14dbe4f$var$$6fde84a571ed6267$export$3f4ba612f3306fd2(selected, isLoading, disabled, fullWidth)
        ]
    };
    const children = (0, $6bec4f26b2cb3094$export$25062201e9e25d76)((0, $6bec4f26b2cb3094$export$ffb0004e005737fa), {
        children: [
            isLoading && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $e9bb9e7afd1cf629$export$2e2bcd8739ae039), {
                testId: "spinner",
                size: "small"
            }),
            showBeforeIcon && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("span", {
                css: [
                    $24c02ea0e14dbe4f$var$$426d900cf47bc59f$export$1870a7443335e00d,
                    label && (0, $74Zh5.css)({
                        marginRight: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.050"),
                        [(0, $cb8cedbc477f5a81$export$987d49ffe1b0900f).below.md]: {
                            marginRight: 0
                        }
                    })
                ],
                children: showBeforeIcon
            }),
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("span", {
                css: isLoading && (0, $74Zh5.css)({
                    marginLeft: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.100")
                }),
                children: label
            }),
            showAfterIcon && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("span", {
                css: [
                    $24c02ea0e14dbe4f$var$$426d900cf47bc59f$export$1870a7443335e00d,
                    (0, $74Zh5.css)({
                        marginLeft: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.050")
                    }),
                    disabled && $24c02ea0e14dbe4f$var$$426d900cf47bc59f$export$46d009ded5eecf4e
                ],
                children: showAfterIcon
            })
        ]
    });
    if (as === "button") return (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("button", {
        ...commonProps,
        type: type,
        disabled: disabled || isLoading,
        children: children
    });
    return (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("a", {
        ...commonProps,
        href: !disabled && !isLoading ? href : undefined,
        target: target,
        rel: target === "_blank" ? "noreferrer" : "",
        children: children
    });
};
const $24c02ea0e14dbe4f$var$$ea4b236bf0573f71$export$69c6dd121e96df9e = ({ label: label, type: type = "button", appearance: appearance, disabled: disabled = false, isLoading: isLoading = false, clickHandler: clickHandler, testId: testId, fullWidth: fullWidth = false, selected: selected = false, size: size = $24c02ea0e14dbe4f$export$5dd2748b7940a2a0.MEDIUM, showBeforeIcon: showBeforeIcon, showAfterIcon: showAfterIcon, isButtonWithoutIcon: isButtonWithoutIcon, isResponsiveSpacing: isResponsiveSpacing, href: href, target: target })=>{
    const commonProps = {
        "aria-label": label.replaceAll("-", " "),
        "data-testid": testId,
        css: [
            ...$24c02ea0e14dbe4f$var$$6fde84a571ed6267$export$8c0322faba831be3(appearance, size),
            ...$24c02ea0e14dbe4f$var$$6fde84a571ed6267$export$18739f551ab326b6(size, isButtonWithoutIcon, showBeforeIcon, showAfterIcon),
            ...$24c02ea0e14dbe4f$var$$6fde84a571ed6267$export$10dac92f1edafe3b(isResponsiveSpacing, size, showBeforeIcon, showAfterIcon),
            ...$24c02ea0e14dbe4f$var$$6fde84a571ed6267$export$3f4ba612f3306fd2(selected, isLoading, disabled, fullWidth)
        ],
        onClick: clickHandler
    };
    const content = (0, $6bec4f26b2cb3094$export$25062201e9e25d76)((0, $6bec4f26b2cb3094$export$ffb0004e005737fa), {
        children: [
            isLoading && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $e9bb9e7afd1cf629$export$2e2bcd8739ae039), {
                testId: "spinner",
                size: "small"
            }),
            showBeforeIcon && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("span", {
                css: [
                    $24c02ea0e14dbe4f$var$$426d900cf47bc59f$export$1870a7443335e00d,
                    (0, $74Zh5.css)({
                        marginRight: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.050")
                    })
                ],
                children: showBeforeIcon
            }),
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("span", {
                css: [
                    isLoading && (0, $74Zh5.css)({
                        marginLeft: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.100")
                    })
                ],
                children: label
            }),
            showAfterIcon && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("span", {
                css: [
                    $24c02ea0e14dbe4f$var$$426d900cf47bc59f$export$1870a7443335e00d,
                    (0, $74Zh5.css)({
                        marginLeft: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.050")
                    })
                ],
                children: showAfterIcon
            })
        ]
    });
    if (href && !disabled) return (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("a", {
        ...commonProps,
        href: href,
        target: target,
        rel: target === "_blank" ? "noreferrer" : "",
        children: content
    });
    return (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("button", {
        ...commonProps,
        type: type,
        disabled: disabled || isLoading,
        children: content
    });
};
let $24c02ea0e14dbe4f$export$5dd2748b7940a2a0;
(function(ButtonSize) {
    ButtonSize["MEDIUM"] = "medium";
    ButtonSize["LARGE"] = "large";
})($24c02ea0e14dbe4f$export$5dd2748b7940a2a0 || ($24c02ea0e14dbe4f$export$5dd2748b7940a2a0 = {}));
let $24c02ea0e14dbe4f$export$261c9483fc4a455a;
(function(ButtonAppearance) {
    ButtonAppearance["DEFAULT"] = "default";
    ButtonAppearance["DANGER"] = "danger";
    ButtonAppearance["LINK"] = "link";
    ButtonAppearance["PRIMARY"] = "primary";
    ButtonAppearance["SECONDARY"] = "secondary";
    ButtonAppearance["SUBTLE"] = "subtle";
    ButtonAppearance["WARNING"] = "warning";
    ButtonAppearance["ICON"] = "icon";
    ButtonAppearance["SUCCESS"] = "success";
})($24c02ea0e14dbe4f$export$261c9483fc4a455a || ($24c02ea0e14dbe4f$export$261c9483fc4a455a = {}));
const $24c02ea0e14dbe4f$export$353f5b6fc5456de1 = (props)=>{
    const { appearance: appearance = $24c02ea0e14dbe4f$export$261c9483fc4a455a.DEFAULT, selected: selected = false, disabled: disabled = false, size: size = $24c02ea0e14dbe4f$export$5dd2748b7940a2a0.MEDIUM, onClick: onClick, iconBefore: iconBefore, iconAfter: iconAfter, isLoading: isLoading = false, isResponsive: isResponsive = false } = props;
    const clickHandler = (0, $5FkrB.useCallback)((e)=>{
        if (onClick) onClick(e);
    }, [
        onClick
    ]);
    const isButtonWithoutIcon = !iconBefore && !iconAfter;
    const showBeforeIcon = !isLoading && iconBefore || false;
    const showAfterIcon = !isLoading && iconAfter || false;
    const isResponsiveSpacing = isResponsive && [
        $24c02ea0e14dbe4f$export$261c9483fc4a455a.PRIMARY,
        $24c02ea0e14dbe4f$export$261c9483fc4a455a.SECONDARY
    ].includes(appearance) && size === $24c02ea0e14dbe4f$export$5dd2748b7940a2a0.LARGE;
    const testId = $24c02ea0e14dbe4f$var$$384448a6ffd0907f$export$5be053290bf6cd4c(appearance, selected, disabled);
    const commonProps = {
        ...props,
        size: size,
        clickHandler: clickHandler,
        isButtonWithoutIcon: isButtonWithoutIcon,
        showBeforeIcon: showBeforeIcon,
        showAfterIcon: showAfterIcon,
        isResponsiveSpacing: isResponsiveSpacing,
        testId: testId
    };
    const componentMap = {
        [$24c02ea0e14dbe4f$export$261c9483fc4a455a.DEFAULT]: $24c02ea0e14dbe4f$var$$ecfd5f2b18d4854e$export$b7c3a2f69225ecf,
        [$24c02ea0e14dbe4f$export$261c9483fc4a455a.ICON]: $24c02ea0e14dbe4f$var$$f0f55be381b0aa07$export$c25acd513dcc8062,
        [$24c02ea0e14dbe4f$export$261c9483fc4a455a.LINK]: $24c02ea0e14dbe4f$var$$9a690c81e99c8d02$export$29d11c0fe2fc51d8,
        [$24c02ea0e14dbe4f$export$261c9483fc4a455a.PRIMARY]: $24c02ea0e14dbe4f$var$$73286ba8e7c0bafe$export$9508e056e78f90ef,
        [$24c02ea0e14dbe4f$export$261c9483fc4a455a.SECONDARY]: $24c02ea0e14dbe4f$var$$73286ba8e7c0bafe$export$9508e056e78f90ef
    };
    const Component = componentMap[appearance] ?? $24c02ea0e14dbe4f$var$$ea4b236bf0573f71$export$69c6dd121e96df9e;
    return (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)(Component, {
        ...commonProps
    });
};
var $24c02ea0e14dbe4f$var$$d501466973a9f0a6$exports = {};
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$d501466973a9f0a6$exports, "CheckboxType", ()=>$24c02ea0e14dbe4f$export$138e17770a0a93a6);
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$d501466973a9f0a6$exports, "CheckboxSize", ()=>$24c02ea0e14dbe4f$export$5e435bc8b081a399);
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$d501466973a9f0a6$exports, "Checkbox", ()=>$24c02ea0e14dbe4f$export$48513f6b9f8ce62d);
var $24c02ea0e14dbe4f$var$$633811e9cd66d921$exports = {};
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$633811e9cd66d921$exports, "useKeyboardInteraction", ()=>$24c02ea0e14dbe4f$export$2a0b6757d41dacb2);
const $24c02ea0e14dbe4f$export$2a0b6757d41dacb2 = (handler)=>{
    return (0, $5FkrB.useCallback)((e)=>{
        if (e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            e.stopPropagation();
            handler();
        }
    }, [
        handler
    ]);
};
let $24c02ea0e14dbe4f$export$138e17770a0a93a6;
(function(CheckboxType) {
    CheckboxType["DEFAULT"] = "DEFAULT";
    CheckboxType[/** TODO: remove success styles in scope of the QUIZ component update */ "SUCCESS"] = "SUCCESS";
    CheckboxType["DANGER"] = "DANGER";
    CheckboxType["DISABLED"] = "DISABLED";
})($24c02ea0e14dbe4f$export$138e17770a0a93a6 || ($24c02ea0e14dbe4f$export$138e17770a0a93a6 = {}));
let $24c02ea0e14dbe4f$export$5e435bc8b081a399;
(function(CheckboxSize) {
    CheckboxSize["DEFAULT"] = "DEFAULT";
    CheckboxSize["LARGE"] = "LARGE";
})($24c02ea0e14dbe4f$export$5e435bc8b081a399 || ($24c02ea0e14dbe4f$export$5e435bc8b081a399 = {}));
const $24c02ea0e14dbe4f$export$48513f6b9f8ce62d = ({ label: label, isChecked: isChecked, onChange: onChange, type: type = $24c02ea0e14dbe4f$export$138e17770a0a93a6.DEFAULT, size: size = $24c02ea0e14dbe4f$export$5e435bc8b081a399.DEFAULT, isIndeterminate: isIndeterminate = false, isRequired: isRequired = false, isBold: isBold, tabIndex: tabIndex = 0 })=>{
    const [userHasInteracted, setUserHasInteracted] = (0, $5FkrB.useState)(false);
    const checkboxRef = (0, $5FkrB.useRef)(null);
    const handleChange = (0, $5FkrB.useCallback)(()=>{
        setUserHasInteracted(true);
        if (onChange) onChange();
    }, [
        onChange
    ]);
    const handleKeyDown = $24c02ea0e14dbe4f$export$2a0b6757d41dacb2(handleChange);
    (0, $5FkrB.useEffect)(()=>{
        if (checkboxRef.current) checkboxRef.current.indeterminate = isIndeterminate && !userHasInteracted;
    }, [
        isIndeterminate,
        userHasInteracted
    ]);
    return (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("label", {
        onKeyDown: handleKeyDown,
        css: [
            $24c02ea0e14dbe4f$var$$d501466973a9f0a6$var$labelStyles,
            size === $24c02ea0e14dbe4f$export$5e435bc8b081a399.LARGE && $24c02ea0e14dbe4f$var$$d501466973a9f0a6$var$labelLargeStyles,
            type === $24c02ea0e14dbe4f$export$138e17770a0a93a6.DISABLED && $24c02ea0e14dbe4f$var$$d501466973a9f0a6$var$variants.label.DISABLED,
            isBold && (0, $74Zh5.css)({
                fontWeight: 700
            }),
            !isBold && (0, $74Zh5.css)({
                fontWeight: 400
            })
        ],
        children: [
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("input", {
                ref: checkboxRef,
                tabIndex: -1,
                type: "checkbox",
                checked: isChecked,
                onChange: handleChange,
                css: $24c02ea0e14dbe4f$var$$d501466973a9f0a6$var$inputCheckboxStyles
            }),
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$e61786c4aee8d415, {
                children: label
            }),
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("span", {
                tabIndex: tabIndex,
                onKeyDown: handleKeyDown,
                css: [
                    $24c02ea0e14dbe4f$var$$d501466973a9f0a6$var$variants.checkbox[type],
                    $24c02ea0e14dbe4f$var$$d501466973a9f0a6$var$checkmarkStyles,
                    size === $24c02ea0e14dbe4f$export$5e435bc8b081a399.LARGE && $24c02ea0e14dbe4f$var$$d501466973a9f0a6$var$checkmarkLargeStyles,
                    isIndeterminate && !userHasInteracted && $24c02ea0e14dbe4f$var$$d501466973a9f0a6$var$indeterminateCheckmarkStyles,
                    isChecked && $24c02ea0e14dbe4f$var$$d501466973a9f0a6$var$checkedCheckmarkStyles,
                    isChecked && type === $24c02ea0e14dbe4f$export$138e17770a0a93a6.DANGER && (0, $74Zh5.css)({
                        backgroundColor: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.border.danger")
                    })
                ]
            }),
            isRequired && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("span", {
                css: [
                    $24c02ea0e14dbe4f$var$$d501466973a9f0a6$var$requiredMarkStyles,
                    size === $24c02ea0e14dbe4f$export$5e435bc8b081a399.LARGE && (0, $74Zh5.css)({
                        marginLeft: "2px"
                    })
                ],
                children: "*"
            })
        ]
    });
};
const $24c02ea0e14dbe4f$var$$d501466973a9f0a6$var$requiredMarkStyles = (0, $74Zh5.css)({
    color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text.subtle"),
    marginLeft: "6px"
});
const $24c02ea0e14dbe4f$var$$d501466973a9f0a6$var$labelStyles = (0, $74Zh5.css)({
    display: "flex",
    position: "relative",
    paddingLeft: "22px",
    marginBottom: 0,
    userSelect: "none",
    color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text"),
    fontFamily: "Inter, sans-serif",
    fontSize: "16px",
    lineHeight: "22px",
    "&:hover": {
        cursor: "pointer"
    }
});
const $24c02ea0e14dbe4f$var$$d501466973a9f0a6$var$labelLargeStyles = (0, $74Zh5.css)({
    paddingLeft: "28px",
    fontSize: "20px",
    lineHeight: "32px"
});
const $24c02ea0e14dbe4f$var$$d501466973a9f0a6$var$inputCheckboxStyles = (0, $74Zh5.css)({
    position: "absolute",
    opacity: 0,
    cursor: "pointer",
    height: 0,
    width: 0
});
const $24c02ea0e14dbe4f$var$$d501466973a9f0a6$var$checkmarkStyles = (0, $74Zh5.css)({
    position: "absolute",
    top: 0,
    left: 0,
    width: "16px",
    height: "16px",
    marginTop: "3px",
    backgroundColor: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.background.input"),
    border: `1px solid ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.border.input")}`,
    borderRadius: "2px",
    cursor: "pointer",
    "&:after": {
        content: '""',
        position: "absolute",
        display: "none"
    }
});
const $24c02ea0e14dbe4f$var$$d501466973a9f0a6$var$checkedCheckmarkStyles = (0, $74Zh5.css)({
    backgroundColor: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.background.selected.bold"),
    borderColor: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.border.selected"),
    "&:after": {
        display: "block",
        left: "4px",
        top: "1px",
        width: "4px",
        height: "7px",
        border: `solid ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text.inverse")}`,
        borderWidth: "0 2px 2px 0",
        transform: "rotate(45deg)"
    }
});
const $24c02ea0e14dbe4f$var$$d501466973a9f0a6$var$checkmarkLargeStyles = (0, $74Zh5.css)({
    width: "20px",
    height: "20px",
    marginRight: "8px",
    marginTop: "6px",
    "&:after": {
        left: "5px !important",
        top: "1px",
        width: "6px !important",
        height: "10px !important",
        border: `solid ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text.inverse")}`,
        borderWidth: "0 2px 2px 0",
        transform: "rotate(45deg)"
    }
});
const $24c02ea0e14dbe4f$var$$d501466973a9f0a6$var$indeterminateCheckmarkStyles = (0, $74Zh5.css)({
    backgroundColor: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.background.selected.bold"),
    borderColor: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.border.selected"),
    "&:after": {
        display: "block",
        left: "2.5px",
        top: "-1px",
        width: "9px",
        height: "7px",
        borderBottom: `2px solid ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text.inverse")}`
    }
});
const $24c02ea0e14dbe4f$var$$d501466973a9f0a6$var$variants = {
    label: {
        DISABLED: (0, $74Zh5.css)({
            pointerEvents: "none",
            opacity: "31%"
        })
    },
    checkbox: {
        DEFAULT: (0, $74Zh5.css)({
            "&:hover": {
                borderColor: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.border.selected")
            }
        }),
        SUCCESS: (0, $74Zh5.css)({
            "&, &:hover": {
                borderColor: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.border.selected")
            }
        }),
        DANGER: (0, $74Zh5.css)({
            "&, &:hover": {
                borderColor: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.border.danger")
            }
        }),
        DISABLED: (0, $74Zh5.css)({
            pointerEvents: "none",
            opacity: "31%"
        })
    }
};
var $24c02ea0e14dbe4f$var$$c4979bfceee73878$exports = {};
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$c4979bfceee73878$exports, "CommonModal", ()=>$24c02ea0e14dbe4f$export$8577c1390d697bac);
const $24c02ea0e14dbe4f$export$8577c1390d697bac = ({ isOpen: isOpen, toggleModal: toggleModal, modalDescriptionLabel: modalDescription, children: children, styles: styles })=>{
    const closeModal = (0, $5FkrB.useCallback)((e)=>{
        e?.stopPropagation();
        toggleModal(false);
    }, [
        toggleModal
    ]);
    const modalRef = (0, $5FkrB.useRef)(null);
    const focusOnOpen = (0, $5FkrB.useCallback)(()=>{
        if (isOpen) modalRef?.current?.focus();
    }, [
        isOpen
    ]);
    (0, $5FkrB.useEffect)(()=>{
        focusOnOpen();
        const handleEsc = (event)=>{
            if (event.key === "Escape") toggleModal(false);
        };
        document.addEventListener("keyup", handleEsc, false);
        return ()=>{
            document.removeEventListener("keyup", handleEsc, false);
        };
    // focusOnOpen and toggleModal intentionally excluded to avoid re-creating listener
    /* eslint-disable react-hooks/exhaustive-deps */ }, []);
    (0, $5FkrB.useEffect)(()=>{
        focusOnOpen();
    }, [
        isOpen
    ]);
    if (!isOpen) return null;
    return isOpen && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
        css: [
            $24c02ea0e14dbe4f$var$$c4979bfceee73878$var$backdropStyles,
            styles && styles
        ],
        children: (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
            "aria-modal": true,
            role: "dialog",
            ref: modalRef,
            "aria-label": modalDescription,
            tabIndex: -1,
            css: $24c02ea0e14dbe4f$var$$c4979bfceee73878$var$modalStyles,
            children: [
                (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("button", {
                    type: "button",
                    css: $24c02ea0e14dbe4f$var$$c4979bfceee73878$var$closeButtonStyles,
                    onClick: closeModal,
                    children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($fec45b36b8fde091$exports))), {
                        label: "Close Modal",
                        size: "medium",
                        primaryColor: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.icon")
                    })
                }),
                (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                    css: $24c02ea0e14dbe4f$var$$c4979bfceee73878$var$modalSlotStyles,
                    children: children
                })
            ]
        })
    });
};
const $24c02ea0e14dbe4f$var$$c4979bfceee73878$var$backdropStyles = (0, $74Zh5.css)({
    "&, *": {
        boxSizing: "border-box"
    },
    backgroundColor: "gray",
    position: "fixed",
    padding: "16px",
    width: "100vw",
    height: "100vh",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    left: 0,
    top: 0,
    zIndex: 100000000
});
const $24c02ea0e14dbe4f$var$$c4979bfceee73878$var$modalStyles = (0, $74Zh5.css)({
    position: "relative",
    padding: "16px",
    paddingTop: "48px",
    maxWidth: "100%",
    maxHeight: "100%",
    borderRadius: "8px",
    backgroundColor: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.background.input"),
    boxShadow: "0px 0px 1px 0px rgba(9, 30, 66, 0.31), 0px 1px 1px 0px rgba(9, 30, 66, 0.25)",
    zIndex: 200000000
});
const $24c02ea0e14dbe4f$var$$c4979bfceee73878$var$closeButtonStyles = (0, $74Zh5.css)({
    position: "absolute",
    top: "16px",
    right: "16px",
    border: "none",
    outline: "none",
    background: "transparent",
    padding: 0,
    cursor: "pointer",
    borderRadius: "4px",
    "&:hover": {
        backgroundColor: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.background.neutral.subtle.hovered")
    },
    "&:focus svg": {
        color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.icon.selected")
    },
    "&:active": {
        backgroundColor: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.background.neutral.subtle.pressed")
    },
    "&:disabled": {
        backgroundColor: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.background.accent.gray.subtle.hovered")
    }
});
const $24c02ea0e14dbe4f$var$$c4979bfceee73878$var$modalSlotStyles = (0, $74Zh5.css)({
    minWidth: "100px",
    minHeight: "25px",
    fontSize: "16px"
});
var $24c02ea0e14dbe4f$var$$0903e93de01b205a$exports = {};
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$0903e93de01b205a$exports, "Divider", ()=>$24c02ea0e14dbe4f$export$2e0a83ec2e27ecbb);
/**
 * Horizontal line acting as divider with custom color and height
 * @param {DividerProps} DividerProps
 * @returns {React.ReactElement} React.ReactElement
 *
 * @example
 * <Divider color={token('color.border')} />
 */ const $24c02ea0e14dbe4f$export$2e0a83ec2e27ecbb = ({ color: color, height: height = 1 })=>{
    const styles = {
        height: height + "px",
        border: `0 solid ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.border")}`,
        margin: 0,
        backgroundColor: color
    };
    return (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("hr", {
        "data-testid": "divider",
        style: styles
    });
};
var $24c02ea0e14dbe4f$var$$a950778dc3003c4a$exports = {};
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$a950778dc3003c4a$exports, "Eyebrow", ()=>$24c02ea0e14dbe4f$export$71f050e2efa708bb);
const $24c02ea0e14dbe4f$export$71f050e2efa708bb = ({ fontWeight: fontWeight = "regular", size: size = "small", color: color = (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text"), children: children })=>{
    return (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("h4", {
        css: [
            $24c02ea0e14dbe4f$var$$a950778dc3003c4a$var$eyebrowSmallStyles,
            size === "medium" && $24c02ea0e14dbe4f$var$$a950778dc3003c4a$var$eyebrowMediumStyles,
            fontWeight === "semibold" && (0, $74Zh5.css)({
                fontWeight: 600
            }),
            color && (0, $74Zh5.css)({
                color: color
            })
        ],
        children: children
    });
};
const $24c02ea0e14dbe4f$var$$a950778dc3003c4a$var$eyebrowSmallStyles = (0, $74Zh5.css)({
    fontFamily: '"Charlie Text", sans-serif',
    fontWeight: 400,
    fontSize: "12px",
    lineHeight: "16px",
    color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text"),
    textTransform: "uppercase"
});
const $24c02ea0e14dbe4f$var$$a950778dc3003c4a$var$eyebrowMediumStyles = (0, $74Zh5.css)({
    fontSize: "14px",
    lineHeight: "18px"
});
var $24c02ea0e14dbe4f$var$$582583ec420fce57$exports = {};
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$582583ec420fce57$exports, "Heading", ()=>$24c02ea0e14dbe4f$export$a8a3e93435678ff9);
var $24c02ea0e14dbe4f$var$$fde9406d76ec24a9$exports = {};
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$fde9406d76ec24a9$exports, "objectValuesToControls", ()=>$24c02ea0e14dbe4f$export$8a8918d045227e35);
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$fde9406d76ec24a9$exports, "inspectorProps", ()=>$24c02ea0e14dbe4f$export$1784ac302bd8ebad);
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$fde9406d76ec24a9$exports, "formatMinutes", ()=>$24c02ea0e14dbe4f$export$30c35cbf580cab77);
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$fde9406d76ec24a9$exports, "getRedirectUrl", ()=>$24c02ea0e14dbe4f$export$93832c3affb240d3);
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$fde9406d76ec24a9$exports, "calculateLearningProgress", ()=>$24c02ea0e14dbe4f$export$6e67b290ed5690f6);
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$fde9406d76ec24a9$exports, "SEARCHBAR_HISTORY_STORAGE_KEY", ()=>$24c02ea0e14dbe4f$export$1059c3e9f228d9b);
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$fde9406d76ec24a9$exports, "getLocalStorageHistory", ()=>$24c02ea0e14dbe4f$export$7765f5b61937bda1);
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$fde9406d76ec24a9$exports, "setLocalStorageItems", ()=>$24c02ea0e14dbe4f$export$cec0922aa1b64670);
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$fde9406d76ec24a9$exports, "generateHashFromLabel", ()=>$24c02ea0e14dbe4f$export$1bdcd43c8c2377cf);
const $24c02ea0e14dbe4f$var$$3dba2111a1a6d39b$var$buildAuthQueryParams = ({ email: email, redirectUrl: redirectUrl, prompt: prompt = "none", experience: experience = "entry-auth" })=>{
    const queryParams = [];
    if (email) queryParams.push(`login_hint=${email}`);
    if (experience) queryParams.push(`application=community--${experience}`);
    if (redirectUrl) queryParams.push(`referer=${redirectUrl}`);
    if (prompt) queryParams.push(`prompt=${prompt}`);
    return queryParams;
};
const $24c02ea0e14dbe4f$var$$3dba2111a1a6d39b$export$1db7da00354b15ed = (queryParamValues)=>{
    const queryParams = $24c02ea0e14dbe4f$var$$3dba2111a1a6d39b$var$buildAuthQueryParams(queryParamValues);
    return `/forums/s/plugins/common/feature/oauth2sso_v2/sso_login_redirect?${queryParams.join("&")}`;
};
let $24c02ea0e14dbe4f$export$7dc6752a22ab011a;
(function(Environment) {
    Environment["LOCAL"] = "local";
    Environment["DEVELOPMENT"] = "development";
    Environment["STAGING"] = "staging";
    Environment["PRODUCTION"] = "production";
})($24c02ea0e14dbe4f$export$7dc6752a22ab011a || ($24c02ea0e14dbe4f$export$7dc6752a22ab011a = {}));
const $24c02ea0e14dbe4f$var$$1ff01338112cd7fe$export$1b5aa7388a6c5e6f = {
    [$24c02ea0e14dbe4f$export$7dc6752a22ab011a.LOCAL]: {
        loggedIn: "https://id.stg.internal.atlassian.com",
        loggedOut: "https://id.stg.internal.atlassian.com"
    },
    [$24c02ea0e14dbe4f$export$7dc6752a22ab011a.DEVELOPMENT]: {
        loggedIn: "https://id.stg.internal.atlassian.com",
        loggedOut: "https://id.stg.internal.atlassian.com"
    },
    [$24c02ea0e14dbe4f$export$7dc6752a22ab011a.STAGING]: {
        loggedIn: "https://id.stg.internal.atlassian.com",
        loggedOut: "https://id.stg.internal.atlassian.com"
    },
    [$24c02ea0e14dbe4f$export$7dc6752a22ab011a.PRODUCTION]: {
        loggedIn: "https://id.atlassian.com",
        loggedOut: "https://id.atlassian.com"
    }
};
const $24c02ea0e14dbe4f$var$$1ff01338112cd7fe$export$d349399b473d7299 = {
    loggedIn: "/",
    loggedOut: "/"
};
let $24c02ea0e14dbe4f$export$93d048dc21eb282a;
(function(CommunityApp) {
    CommunityApp["HOME"] = "home";
    CommunityApp["LEARNING"] = "learning";
    CommunityApp["FORUMS"] = "forums";
    CommunityApp["EVENTS"] = "events";
    CommunityApp["PROFILE"] = "unified-portable-profile";
    CommunityApp["CHAMPIONS"] = "champions";
    CommunityApp["APP_UPDATES"] = "release-notes";
})($24c02ea0e14dbe4f$export$93d048dc21eb282a || ($24c02ea0e14dbe4f$export$93d048dc21eb282a = {}));
const $24c02ea0e14dbe4f$export$67e61a6fa639f224 = (email)=>[
        {
            app: $24c02ea0e14dbe4f$export$93d048dc21eb282a.FORUMS,
            label: "Forums",
            target: "_self",
            href: {
                loggedIn: $24c02ea0e14dbe4f$var$$3dba2111a1a6d39b$export$1db7da00354b15ed({
                    email: email,
                    redirectUrl: "/forums"
                }),
                loggedOut: "/forums"
            }
        },
        {
            app: $24c02ea0e14dbe4f$export$93d048dc21eb282a.LEARNING,
            label: "Learning",
            href: {
                loggedIn: "/learning",
                loggedOut: "/learning"
            }
        },
        {
            app: $24c02ea0e14dbe4f$export$93d048dc21eb282a.EVENTS,
            label: "Events",
            target: "_self",
            href: {
                loggedIn: "/events",
                loggedOut: "/events"
            }
        },
        {
            app: $24c02ea0e14dbe4f$export$93d048dc21eb282a.CHAMPIONS,
            label: "Champions",
            target: "_self",
            href: {
                loggedIn: "/champions",
                loggedOut: "/champions"
            }
        },
        {
            app: $24c02ea0e14dbe4f$export$93d048dc21eb282a.APP_UPDATES,
            label: "Release Notes",
            target: "_self",
            href: {
                loggedIn: "/release-notes",
                loggedOut: "/release-notes"
            }
        }
    ];
const $24c02ea0e14dbe4f$export$208c68d48dfc9a12 = $24c02ea0e14dbe4f$export$67e61a6fa639f224();
const $24c02ea0e14dbe4f$var$$1ff01338112cd7fe$export$fe0105b4860d6e11 = {
    [$24c02ea0e14dbe4f$export$93d048dc21eb282a.FORUMS]: "/forums",
    [$24c02ea0e14dbe4f$export$93d048dc21eb282a.LEARNING]: "/learning",
    [$24c02ea0e14dbe4f$export$93d048dc21eb282a.EVENTS]: "/events",
    [$24c02ea0e14dbe4f$export$93d048dc21eb282a.PROFILE]: "/user",
    [$24c02ea0e14dbe4f$export$93d048dc21eb282a.CHAMPIONS]: "/champions",
    [$24c02ea0e14dbe4f$export$93d048dc21eb282a.APP_UPDATES]: "/release-notes"
};
const $24c02ea0e14dbe4f$var$$1ff01338112cd7fe$export$132b2bf91782e62b = "/user";
const $24c02ea0e14dbe4f$var$$1ff01338112cd7fe$export$b9cc8022ec117e91 = "/user/settings";
const $24c02ea0e14dbe4f$var$$1ff01338112cd7fe$export$46dbfbdf99745111 = "Log in";
const $24c02ea0e14dbe4f$var$$1ff01338112cd7fe$export$4fe37309c24221ae = "Sign up";
const $24c02ea0e14dbe4f$var$$1ff01338112cd7fe$export$668d072b293d5f38 = {
    PROFILE: {
        text: "Profile",
        id: "profile"
    },
    SETTINGS: {
        text: "Settings",
        id: "settings"
    },
    SWITCH_ACCOUNT: {
        text: "Switch accounts",
        id: "switch-account"
    },
    LOG_OUT: {
        text: "Log out",
        id: "logout"
    }
};
let $24c02ea0e14dbe4f$export$3d7865934588d77e;
(function(EventType) {
    EventType["TRACK"] = "track";
    EventType["UI"] = "ui";
    EventType["OPERATIONAL"] = "operational";
    EventType["SCREEN"] = "screen";
    EventType["IDENTIFY"] = "identify";
})($24c02ea0e14dbe4f$export$3d7865934588d77e || ($24c02ea0e14dbe4f$export$3d7865934588d77e = {}));
let $24c02ea0e14dbe4f$export$d778a884eb401313;
(function(AnalyticsActivityType) {
    AnalyticsActivityType["NAV_LOGO_CLICK"] = "NAV_LOGO_CLICK";
    AnalyticsActivityType["NAV_ITEM_CLICK"] = "NAV_ITEM_CLICK";
    AnalyticsActivityType["LOG_IN_CLICK"] = "LOG_IN_CLICK";
    AnalyticsActivityType["SIGN_UP_CLICK"] = "SIGN_UP_CLICK";
    AnalyticsActivityType["LOG_OUT_CLICK"] = "LOG_OUT_CLICK";
    AnalyticsActivityType["PROFILE_MENU_OPEN"] = "PROFILE_MENU_OPEN";
    AnalyticsActivityType["PROFILE_MENU_CLOSE"] = "PROFILE_MENU_CLOSE";
    AnalyticsActivityType["PROFILE_MENU_ITEM_CLICK"] = "PROFILE_MENU_ITEM_CLICK";
    AnalyticsActivityType["MOBILE_MENU_OPEN"] = "MOBILE_MENU_OPEN";
    AnalyticsActivityType["MOBILE_MENU_CLOSE"] = "MOBILE_MENU_CLOSE";
})($24c02ea0e14dbe4f$export$d778a884eb401313 || ($24c02ea0e14dbe4f$export$d778a884eb401313 = {}));
const $24c02ea0e14dbe4f$var$$1ff01338112cd7fe$export$bc6e44c7f1ae99f6 = "https://www.atlassian.com/legal/community-platform-terms-of-use";
const $24c02ea0e14dbe4f$var$$1ff01338112cd7fe$export$30786e8ac20c09d8 = "https://www.atlassian.com/legal/privacy-policy#what-this-policy-covers";
const $24c02ea0e14dbe4f$var$$1ff01338112cd7fe$export$6aafbda8e90312f0 = "#";
const $24c02ea0e14dbe4f$var$$1ff01338112cd7fe$export$10bc455dcefd3f1f = "https://www.atlassian.com/trust/data-protection";
const $24c02ea0e14dbe4f$export$8a8918d045227e35 = (obj, control = "select")=>({
        control: control,
        options: Object.values(obj)
    });
const $24c02ea0e14dbe4f$export$1784ac302bd8ebad = (key, inspectMode)=>{
    if (inspectMode && inspectMode[key]) {
        const { entryId: entryId, fieldId: fieldId } = inspectMode[key];
        return {
            "data-contentful-entry-id": entryId,
            "data-contentful-field-id": fieldId
        };
    }
};
const $24c02ea0e14dbe4f$export$30c35cbf580cab77 = (minutes)=>{
    const hours = Math.floor(minutes / 60);
    const remainingMinutes = minutes % 60;
    let output = "";
    if (hours > 0) {
        output += `${hours} hour`;
        if (hours > 1) output += "s";
    }
    if (remainingMinutes > 0) {
        if (hours > 0) output += " and ";
        output += `${remainingMinutes} minute`;
        if (remainingMinutes > 1) output += "s";
    }
    return output;
};
const $24c02ea0e14dbe4f$export$93832c3affb240d3 = (url, environment)=>{
    const idUrl = $24c02ea0e14dbe4f$var$$1ff01338112cd7fe$export$1b5aa7388a6c5e6f[environment] || $24c02ea0e14dbe4f$var$$1ff01338112cd7fe$export$1b5aa7388a6c5e6f[$24c02ea0e14dbe4f$export$7dc6752a22ab011a.STAGING];
    return `${idUrl}/login?continue=${encodeURIComponent(url)}`;
};
const $24c02ea0e14dbe4f$export$6e67b290ed5690f6 = (completed, total)=>{
    if (total === 0) return 0;
    return completed / total * 100;
};
const $24c02ea0e14dbe4f$export$1059c3e9f228d9b = "searchbar_history";
const $24c02ea0e14dbe4f$export$7765f5b61937bda1 = ()=>{
    if (typeof window === "undefined") return [];
    const storedHistory = localStorage.getItem($24c02ea0e14dbe4f$export$1059c3e9f228d9b);
    return storedHistory ? JSON.parse(storedHistory) : [];
};
const $24c02ea0e14dbe4f$export$cec0922aa1b64670 = (items)=>{
    if (typeof window === "undefined") return;
    localStorage.setItem($24c02ea0e14dbe4f$export$1059c3e9f228d9b, JSON.stringify(items));
};
const $24c02ea0e14dbe4f$export$1bdcd43c8c2377cf = (label)=>{
    return `#${label.toLowerCase().replace(/ /g, "-")}`;
};
const $24c02ea0e14dbe4f$export$a8a3e93435678ff9 = ({ children: children, level: level, inspectMode: inspectMode, id: id, color: color = (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text"), fontWeight: fontWeight })=>{
    const HeadingElement = $24c02ea0e14dbe4f$var$$582583ec420fce57$var$levelToHeadingElementsMap[level];
    const headingStyles = $24c02ea0e14dbe4f$var$$582583ec420fce57$var$levelToHeadingStylesMap[level];
    const additionalProps = inspectMode ? $24c02ea0e14dbe4f$export$1784ac302bd8ebad(Object.keys(inspectMode)[0], inspectMode) : {};
    return (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)(HeadingElement, {
        id: id,
        css: [
            headingStyles,
            fontWeight && (0, $74Zh5.css)({
                fontWeight: fontWeight
            })
        ],
        ...additionalProps,
        style: {
            color: color
        },
        children: children
    });
};
const $24c02ea0e14dbe4f$var$$582583ec420fce57$var$h0Styles = (0, $74Zh5.css)({
    fontFamily: '"Charlie Display", sans-serif',
    fontWeight: 700,
    fontSize: "48px",
    lineHeight: "52px",
    letterSpacing: "-0.144px",
    margin: 0,
    [(0, $cb8cedbc477f5a81$export$987d49ffe1b0900f).above.sm]: {
        fontSize: "56px",
        lineHeight: "64px",
        letterSpacing: "-0.168px"
    }
});
const $24c02ea0e14dbe4f$var$$582583ec420fce57$var$h1Styles = (0, $74Zh5.css)({
    fontFamily: '"Charlie Display", sans-serif',
    fontWeight: 700,
    fontSize: "2.5rem",
    lineHeight: "3rem",
    margin: 0,
    letterSpacing: "-0.144px",
    [(0, $cb8cedbc477f5a81$export$987d49ffe1b0900f).above.sm]: {
        fontSize: "3rem",
        lineHeight: "3.5rem",
        letterSpacing: "-0.168px"
    }
});
const $24c02ea0e14dbe4f$var$$582583ec420fce57$var$h2Styles = (0, $74Zh5.css)({
    fontFamily: '"Charlie Display", sans-serif',
    fontWeight: 700,
    fontSize: "2rem",
    lineHeight: "2.5rem",
    margin: 0,
    letterSpacing: "-0.096px",
    [(0, $cb8cedbc477f5a81$export$987d49ffe1b0900f).above.sm]: {
        fontSize: "2.5rem",
        lineHeight: "3rem",
        letterSpacing: "-0.12px"
    }
});
const $24c02ea0e14dbe4f$var$$582583ec420fce57$var$h3Styles = (0, $74Zh5.css)({
    fontFamily: '"Charlie Display", sans-serif',
    fontWeight: 700,
    fontSize: "1.5rem",
    lineHeight: "2rem",
    margin: 0,
    letterSpacing: "normal",
    [(0, $cb8cedbc477f5a81$export$987d49ffe1b0900f).above.sm]: {
        fontSize: "2rem",
        lineHeight: "2.5rem",
        letterSpacing: "normal"
    }
});
const $24c02ea0e14dbe4f$var$$582583ec420fce57$var$h4Styles = (0, $74Zh5.css)({
    fontFamily: '"Charlie Display", sans-serif',
    fontWeight: 600,
    fontSize: "1.25rem",
    lineHeight: "1.75rem",
    margin: 0,
    letterSpacing: "normal",
    [(0, $cb8cedbc477f5a81$export$987d49ffe1b0900f).above.sm]: {
        fontSize: "1.5rem",
        lineHeight: "2rem",
        letterSpacing: "normal"
    }
});
const $24c02ea0e14dbe4f$var$$582583ec420fce57$var$h5Styles = (0, $74Zh5.css)({
    fontFamily: '"Charlie Display", sans-serif',
    fontWeight: 600,
    fontSize: "1rem",
    lineHeight: "1.5rem",
    margin: 0,
    letterSpacing: "normal",
    [(0, $cb8cedbc477f5a81$export$987d49ffe1b0900f).above.sm]: {
        fontSize: "1.25rem",
        lineHeight: "1.75rem",
        letterSpacing: "normal"
    }
});
const $24c02ea0e14dbe4f$var$$582583ec420fce57$var$h6Styles = (0, $74Zh5.css)({
    fontFamily: '"Charlie Display", sans-serif',
    fontWeight: 600,
    fontSize: "0.875rem",
    lineHeight: "1.375rem",
    textTransform: "unset",
    margin: 0,
    letterSpacing: "normal",
    [(0, $cb8cedbc477f5a81$export$987d49ffe1b0900f).above.sm]: {
        fontSize: "1rem",
        lineHeight: "1.5rem",
        letterSpacing: "normal"
    }
});
const $24c02ea0e14dbe4f$var$$582583ec420fce57$var$levelToHeadingElementsMap = {
    0: "h1",
    1: "h1",
    2: "h2",
    3: "h3",
    4: "h4",
    5: "h5",
    6: "h6"
};
const $24c02ea0e14dbe4f$var$$582583ec420fce57$var$levelToHeadingStylesMap = {
    0: $24c02ea0e14dbe4f$var$$582583ec420fce57$var$h0Styles,
    1: $24c02ea0e14dbe4f$var$$582583ec420fce57$var$h1Styles,
    2: $24c02ea0e14dbe4f$var$$582583ec420fce57$var$h2Styles,
    3: $24c02ea0e14dbe4f$var$$582583ec420fce57$var$h3Styles,
    4: $24c02ea0e14dbe4f$var$$582583ec420fce57$var$h4Styles,
    5: $24c02ea0e14dbe4f$var$$582583ec420fce57$var$h5Styles,
    6: $24c02ea0e14dbe4f$var$$582583ec420fce57$var$h6Styles
};
var $24c02ea0e14dbe4f$var$$a02a6f7de308273b$exports = {};
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$a02a6f7de308273b$exports, "icons", ()=>$24c02ea0e14dbe4f$export$df03f54e09e486fa);
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$a02a6f7de308273b$exports, "IconSize", ()=>$24c02ea0e14dbe4f$export$ff775019b5b6e7df);
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$a02a6f7de308273b$exports, "IconRotation", ()=>$24c02ea0e14dbe4f$export$b3241a99d3e47e02);
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$a02a6f7de308273b$exports, "Icon", ()=>$24c02ea0e14dbe4f$export$f04a61298a47a40f);
// Core icons use 'color' prop and default to 'currentColor' for CSS inheritance
// Glyph icons use 'primaryColor' prop
const $24c02ea0e14dbe4f$var$$a02a6f7de308273b$var$CORE_ICONS = [
    "arrow-up-right",
    "atlassian-intelligence",
    "calendar",
    "compass",
    "download-core",
    "link-external",
    "location-outline",
    "megaphone",
    "people-group",
    "person",
    "project",
    "sidebar-collapse",
    "sidebar-expand",
    "thumb-down",
    "thumb-up",
    "roadmaps-plan"
];
const $24c02ea0e14dbe4f$export$df03f54e09e486fa = {
    filter: (props)=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($fb968510c42de8af$exports))), {
            ...props
        }),
    "chevron-down": (props)=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($9486f8503a3e67e2$exports))), {
            ...props
        }),
    "chevron-up": (props)=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($30203922e34ab8aa$exports))), {
            ...props
        }),
    "chevron-left": (props)=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($385bb13f555ba5b8$exports))), {
            ...props
        }),
    "chevron-right": (props)=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($dffd612a245a9817$exports))), {
            ...props
        }),
    "chevron-down-circle": (props)=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($e572ec8845a02646$exports))), {
            ...props
        }),
    "arrow-up-circle": (props)=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($e48f677aac887358$exports))), {
            ...props
        }),
    "arrow-up": (props)=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($9cd1998a3c9cfc99$exports))), {
            ...props
        }),
    "arrow-up-right": (props)=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($aBp15))), {
            ...props
        }),
    "check-circle": (props)=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($d5a84db960eef864$exports))), {
            ...props
        }),
    "check-circle-outline": (props)=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($ade8daf0e7d9a0c6$exports))), {
            ...props
        }),
    "arrow-right": (props)=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($c98a967905aaff91$exports))), {
            ...props
        }),
    "arrow-left-circle": (props)=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($6d9883dd8b1794e3$exports))), {
            ...props
        }),
    "arrow-right-circle": (props)=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($7ef4b2cc5f25a288$exports))), {
            ...props
        }),
    "arrow-right-small": (props)=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("svg", {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M13.908 8L12.8283 9.2021L14.5785 11.1497H7.26318C6.84191 11.1497 6.5 11.5304 6.5 11.9994C6.5 12.4685 6.84191 12.8492 7.26318 12.8492H14.5785L12.8283 14.7979L13.908 16L17.5 11.9994L13.908 8Z",
                fill: props.primaryColor ?? "#1868DB"
            })
        }),
    "atlassian-intelligence": (props)=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($1595a2df2d5c9f61$exports))), {
            ...props
        }),
    "atlassian-logo": (props)=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($207a5ee071608021$exports))), {
            ...props
        }),
    cross: (props)=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($fec45b36b8fde091$exports))), {
            ...props
        }),
    "dropdown-cross": (props)=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($79f04fcc1fc38f5b$exports))), {
            ...props
        }),
    "menu-icon": (props)=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($3388360884a36db4$exports))), {
            ...props
        }),
    "emoji-frequent": (props)=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($2bb56a67b3ef2d16$exports))), {
            ...props
        }),
    "star-filled": (props)=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($7f3db16b7d369d9b$exports))), {
            ...props
        }),
    star: (props)=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($de0848e68fcb9d68$exports))), {
            ...props
        }),
    "bitbucket-builds": (props)=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($8e55f27140ce88eb$exports))), {
            ...props
        }),
    "editor-media-wrap-right": (props)=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($34e5d1c6c1f4125d$exports))), {
            ...props
        }),
    "editor-table": (props)=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($3ac3f969cbb47b8f$exports))), {
            ...props
        }),
    "editor-open": (props)=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($3f5daf0b07171f08$exports))), {
            ...props
        }),
    calendar: (props)=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($5ec615fd02e164a6$exports))), {
            ...props
        }),
    copy: (props)=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($590d7c6a980c3249$exports))), {
            ...props
        }),
    warning: (props)=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($fcdbc1d2bc40f8ba$exports))), {
            ...props
        }),
    image: (props)=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($a68fb0b0d8dbf79c$exports))), {
            ...props
        }),
    download: (props)=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($be4a353bf96cd982$exports))), {
            ...props
        }),
    "download-core": (props)=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($exnso))), {
            ...props
        }),
    "zoom-in": (props)=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($1fb024143896ae8b$exports))), {
            ...props
        }),
    "zoom-out": (props)=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($f84ee0cde97a62c2$exports))), {
            ...props
        }),
    search: (props)=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($47b625f21d7ae4a6$exports))), {
            ...props
        }),
    overview: (props)=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($c7b70d3a2f678352$exports))), {
            ...props
        }),
    add: (props)=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($1a8d9f6b66868ddc$exports))), {
            ...props
        }),
    refresh: (props)=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($7f6dfc6f29e99698$exports))), {
            ...props
        }),
    "add-circle": (props)=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($98bc205bd71a8c29$exports))), {
            ...props
        }),
    edit: (props)=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($8710dfec56d91aa3$exports))), {
            ...props
        }),
    "edit-filled": (props)=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($d565c3bdf418c732$exports))), {
            ...props
        }),
    error: (props)=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($ff31d8fb1771b8a0$exports))), {
            ...props
        }),
    settings: (props)=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($d93733cd60a2ee2e$exports))), {
            ...props
        }),
    info: (props)=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($03d4c1818fb39364$exports))), {
            ...props
        }),
    question: (props)=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($4d9bc1cb23b5f81c$exports))), {
            ...props
        }),
    check: (props)=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($873ac5cd1764ee99$exports))), {
            ...props
        }),
    "check-circle-filled": (props)=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($d5a84db960eef864$exports))), {
            ...props
        }),
    "emoji-symbols": (props)=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($88999ebaf76df20a$exports))), {
            ...props
        }),
    compass: (props)=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($c76c9acbab193ca4$exports))), {
            ...props
        }),
    megaphone: (props)=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($742fae155a6bbd32$exports))), {
            ...props
        }),
    location: (props)=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($0035a91c863e72cf$exports))), {
            ...props
        }),
    "location-outline": (props)=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($ln0Ih))), {
            ...props
        }),
    "chevron-left-large": (props)=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($464fbc8de2c8545a$exports))), {
            ...props
        }),
    "chevron-right-large": (props)=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($464fbc8de2c8545a$exports))), {
            ...props
        }),
    "hipchat-chevron-up": (props)=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($56277a34572e0602$exports))), {
            ...props
        }),
    "hipchat-chevron-down": (props)=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($5d26562b02511d06$exports))), {
            ...props
        }),
    export: (props)=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($34d04bfb84685d13$exports))), {
            ...props
        }),
    link: (props)=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($0be4bc1b8cb1f6f1$exports))), {
            ...props
        }),
    "roadmaps-plan": (props)=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($25e8a161b396b80d$exports))), {
            ...props
        }),
    share: (props)=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($eb718c580db4626b$exports))), {
            ...props
        }),
    "sidebar-collapse": (props)=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($75ab11f9a6d4b351$exports))), {
            ...props
        }),
    "sidebar-expand": (props)=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($e8ed8fa21860117a$exports))), {
            ...props
        }),
    "people-group": (props)=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($be2e2d4d6fde7b33$exports))), {
            ...props
        }),
    project: (props)=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($2a5cc7bed34af7d5$exports))), {
            ...props
        }),
    "link-external": (props)=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($d670f5d7c7940d5f$exports))), {
            ...props
        }),
    person: (props)=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($d0d6b2a53e44f9e1$exports))), {
            ...props
        }),
    "bookmark-narrow": (props)=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("svg", {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("path", {
                d: "M16.5745 5.49575C16.5745 5.13673 16.2832 4.84567 15.9242 4.84554H8.07595C7.71685 4.84554 7.42574 5.13665 7.42574 5.49575V18.2473L12.0001 15.0318L12.5601 15.4268L16.5745 18.2473V5.49575ZM18.5251 20.0633C18.5248 20.8281 17.717 21.2956 17.0659 20.965L16.9377 20.8875L11.9988 17.4155L7.06253 20.8875C6.39483 21.3569 5.47538 20.8794 5.4751 20.0633V5.49575C5.4751 4.05934 6.63954 2.8949 8.07595 2.8949H15.9242C17.3605 2.89503 18.5251 4.05942 18.5251 5.49575V20.0633Z",
                fill: props.primaryColor ?? "white"
            })
        }),
    "bookmark-narrow-filled": (props)=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("svg", {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("path", {
                d: "M18.525 20.0632C18.5247 20.828 17.7168 21.2955 17.0658 20.9649L16.9375 20.8874L11.9987 17.4154L7.06241 20.8874C6.39471 21.3568 5.47525 20.8792 5.47498 20.0632V5.49563C5.47498 4.05922 6.63942 2.89478 8.07583 2.89478H15.9241C17.3604 2.8949 18.525 4.0593 18.525 5.49563V20.0632Z",
                fill: props.primaryColor ?? "white"
            })
        }),
    bookmark: ()=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("svg", {
            "aria-label": "bookmark",
            "data-testid": "bookmark",
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("g", {
                id: "Icons/bookmark_24px",
                children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("path", {
                    id: "bookmark",
                    d: "M12 18L7.8 19.8C7.13333 20.0833 6.5 20.0292 5.9 19.6375C5.3 19.2458 5 18.6917 5 17.975V5C5 4.45 5.19583 3.97917 5.5875 3.5875C5.97917 3.19583 6.45 3 7 3H17C17.55 3 18.0208 3.19583 18.4125 3.5875C18.8042 3.97917 19 4.45 19 5V17.975C19 18.6917 18.7 19.2458 18.1 19.6375C17.5 20.0292 16.8667 20.0833 16.2 19.8L12 18Z",
                    fill: "transparent",
                    stroke: "#626F86",
                    strokeWidth: "2"
                })
            })
        }),
    "bookmark-filled": ()=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("svg", {
            "aria-label": "bookmark filled",
            "data-testid": "bookmark-filled",
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("g", {
                id: "Icons/bookmark_24px",
                children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("path", {
                    id: "bookmark",
                    d: "M12 18L7.8 19.8C7.13333 20.0833 6.5 20.0292 5.9 19.6375C5.3 19.2458 5 18.6917 5 17.975V5C5 4.45 5.19583 3.97917 5.5875 3.5875C5.97917 3.19583 6.45 3 7 3H17C17.55 3 18.0208 3.19583 18.4125 3.5875C18.8042 3.97917 19 4.45 19 5V17.975C19 18.6917 18.7 19.2458 18.1 19.6375C17.5 20.0292 16.8667 20.0833 16.2 19.8L12 18Z",
                    fill: "#626F86",
                    stroke: "#626F86",
                    strokeWidth: "2"
                })
            })
        }),
    "gap-completed": ()=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("svg", {
            "data-testid": "gap-completed",
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("g", {
                id: "Icon / <CheckCircleIcon>",
                children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("path", {
                    id: "gap",
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12ZM9.3824 11.0689C9.50441 11.1213 9.61475 11.1975 9.707 11.293L11 12.586L14.293 9.29302C14.3852 9.19751 14.4956 9.12133 14.6176 9.06892C14.7396 9.01651 14.8708 8.98892 15.0036 8.98777C15.1364 8.98662 15.2681 9.01192 15.391 9.0622C15.5138 9.11248 15.6255 9.18673 15.7194 9.28063C15.8133 9.37452 15.8875 9.48617 15.9378 9.60907C15.9881 9.73196 16.0134 9.86364 16.0122 9.99642C16.0111 10.1292 15.9835 10.2604 15.9311 10.3824C15.8787 10.5044 15.8025 10.6148 15.707 10.707L11.707 14.707C11.5195 14.8945 11.2652 14.9998 11 14.9998C10.7348 14.9998 10.4805 14.8945 10.293 14.707L8.293 12.707C8.19749 12.6148 8.1213 12.5044 8.0689 12.3824C8.01649 12.2604 7.9889 12.1292 7.98775 11.9964C7.98659 11.8636 8.0119 11.732 8.06218 11.6091C8.11246 11.4862 8.18671 11.3745 8.2806 11.2806C8.3745 11.1867 8.48615 11.1125 8.60904 11.0622C8.73194 11.0119 8.86362 10.9866 8.9964 10.9878C9.12918 10.9889 9.2604 11.0165 9.3824 11.0689Z",
                    fill: "#22A06B"
                })
            })
        }),
    "thumb-down": (props)=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($9bde3da3ddd3925b$exports))), {
            ...props
        }),
    "thumb-up": (props)=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($d613dcd7cfbb1e58$exports))), {
            ...props
        }),
    "dot-default": ()=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: "8",
            height: "8",
            viewBox: "0 0 8 8",
            fill: "none",
            children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("rect", {
                x: "0.5",
                y: "0.5",
                width: "7",
                height: "7",
                rx: "3.5",
                stroke: "#091E42",
                strokeOpacity: "0.14"
            })
        }),
    "dot-selected": ()=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: "8",
            height: "8",
            viewBox: "0 0 8 8",
            fill: "none",
            children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("rect", {
                x: "0.5",
                y: "0.5",
                width: "7",
                height: "7",
                rx: "3.5",
                stroke: "#0C66E4"
            })
        }),
    "dot-completed": ()=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: "8",
            height: "8",
            viewBox: "0 0 8 8",
            fill: "none",
            children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("rect", {
                width: "8",
                height: "8",
                rx: "4",
                fill: "#22A06B"
            })
        }),
    "mosaic_map-pin": (props)=>(0, $6bec4f26b2cb3094$export$25062201e9e25d76)("svg", {
            width: "32",
            height: "32",
            viewBox: "0 0 32 32",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: [
                (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M15.8088 12.9426L19.8045 18.7363L23.8003 12.9426C23.8715 12.8394 23.938 12.735 24 12.6296C25.8712 9.44592 23.5904 5.33325 19.8045 5.33325C15.8931 5.33325 13.5882 9.72274 15.8088 12.9426ZM19.9234 12.494C21.1444 12.4321 22.1153 11.4225 22.1153 10.1861C22.1153 8.90983 21.0807 7.87521 19.8045 7.87521C18.5909 7.87521 17.5958 8.81071 17.501 9.99992C17.4961 10.0613 17.4938 10.1234 17.4938 10.1861C17.4938 11.4623 18.5284 12.4969 19.8046 12.497M19.8046 12.497C19.8444 12.497 19.8841 12.496 19.9234 12.494L19.8046 12.497Z",
                    fill: props.primaryColor ?? "#172b4d"
                }),
                (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("path", {
                    d: "M21.3333 22.6666V20.0426L24 16.1759V25.3333H8V9.99992H12.9424C12.9149 10.8857 13.0615 11.7906 13.4072 12.6666H10.6667V22.6666H21.3333Z",
                    fill: props.primaryColor ?? "#172b4d"
                })
            ]
        }),
    mosaic_compass: (props)=>(0, $6bec4f26b2cb3094$export$25062201e9e25d76)("svg", {
            width: "32",
            height: "32",
            viewBox: "0 0 32 32",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: [
                (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("mask", {
                    id: "mask0_64467_13333",
                    style: {
                        maskType: "luminance"
                    },
                    maskUnits: "userSpaceOnUse",
                    x: "0",
                    y: "0",
                    width: "32",
                    height: "32",
                    children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("path", {
                        d: "M32 0H0V32H32V0Z",
                        fill: "white"
                    })
                }),
                (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("g", {
                    mask: "url(#mask0_64467_13333)",
                    children: [
                        (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("path", {
                            d: "M14.6665 16.0001C14.6665 15.2667 15.2665 14.6667 15.9998 14.6667C16.7332 14.6667 17.3332 15.2667 17.3332 16.0001C17.3332 16.7334 16.7332 17.3334 15.9998 17.3334C15.2665 17.3334 14.6665 16.7334 14.6665 16.0001Z",
                            fill: props.primaryColor || "#172b4d"
                        }),
                        (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("path", {
                            fillRule: "evenodd",
                            clipRule: "evenodd",
                            d: "M16.0002 26.6666C21.8935 26.6666 26.6668 21.8933 26.6668 15.9999C26.6668 10.1066 21.8935 5.33325 16.0002 5.33325C10.1068 5.33325 5.3335 10.1066 5.3335 15.9999C5.3335 21.8933 10.1068 26.6666 16.0002 26.6666ZM21.3335 10.6666L13.3335 13.3333L10.6668 21.3333L18.6668 18.6666L21.3335 10.6666Z",
                            fill: props.primaryColor || "#172b4d"
                        })
                    ]
                })
            ]
        }),
    mosaic_megaphone: (props)=>(0, $6bec4f26b2cb3094$export$25062201e9e25d76)("svg", {
            width: "32",
            height: "32",
            viewBox: "0 0 32 32",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: [
                (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("mask", {
                    id: "mask0_64493_847",
                    style: {
                        maskType: "luminance"
                    },
                    maskUnits: "userSpaceOnUse",
                    x: "0",
                    y: "0",
                    width: "32",
                    height: "32",
                    children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("path", {
                        d: "M32 0H0V32H32V0Z",
                        fill: "white"
                    })
                }),
                (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("g", {
                    mask: "url(#mask0_64493_847)",
                    children: [
                        (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("path", {
                            d: "M26 5.33325L16 9.33325V19.9999L26 23.9999V5.33325Z",
                            fill: props.primaryColor || "#172b4d"
                        }),
                        (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("path", {
                            d: "M13.3335 10H5.3335V19.3333H9.3335V25.3333H13.3335V10Z",
                            fill: props.primaryColor || "#172b4d"
                        })
                    ]
                })
            ]
        }),
    "more-vertical": (props)=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($89ede3cf48e6c473$exports))), {
            ...props
        }),
    "editor-panel": (props)=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($533ab672e6b1443b$exports))), {
            ...props
        }),
    one: ()=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("span", {
            css: $24c02ea0e14dbe4f$var$$a02a6f7de308273b$var$iconNumberStyles,
            "data-testid": "one",
            children: "1"
        }),
    two: ()=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("span", {
            css: $24c02ea0e14dbe4f$var$$a02a6f7de308273b$var$iconNumberStyles,
            "data-testid": "two",
            children: "2"
        }),
    three: ()=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("span", {
            css: $24c02ea0e14dbe4f$var$$a02a6f7de308273b$var$iconNumberStyles,
            "data-testid": "three",
            children: "3"
        }),
    four: ()=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("span", {
            css: $24c02ea0e14dbe4f$var$$a02a6f7de308273b$var$iconNumberStyles,
            "data-testid": "four",
            children: "4"
        }),
    five: ()=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("span", {
            css: $24c02ea0e14dbe4f$var$$a02a6f7de308273b$var$iconNumberStyles,
            "data-testid": "five",
            children: "5"
        }),
    six: ()=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("span", {
            css: $24c02ea0e14dbe4f$var$$a02a6f7de308273b$var$iconNumberStyles,
            "data-testid": "six",
            children: "6"
        }),
    seven: ()=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("span", {
            css: $24c02ea0e14dbe4f$var$$a02a6f7de308273b$var$iconNumberStyles,
            "data-testid": "seven",
            children: "7"
        }),
    eight: ()=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("span", {
            css: $24c02ea0e14dbe4f$var$$a02a6f7de308273b$var$iconNumberStyles,
            "data-testid": "eight",
            children: "8"
        }),
    nine: ()=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("span", {
            css: $24c02ea0e14dbe4f$var$$a02a6f7de308273b$var$iconNumberStyles,
            "data-testid": "nine",
            children: "9"
        }),
    zero: ()=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("span", {
            css: $24c02ea0e14dbe4f$var$$a02a6f7de308273b$var$iconNumberStyles,
            "data-testid": "zero",
            children: "0"
        })
};
let $24c02ea0e14dbe4f$export$ff775019b5b6e7df;
(function(IconSize) {
    IconSize["SMALL"] = "small";
    IconSize["MEDIUM"] = "medium";
    IconSize["LARGE"] = "large";
    IconSize["XLARGE"] = "xlarge";
})($24c02ea0e14dbe4f$export$ff775019b5b6e7df || ($24c02ea0e14dbe4f$export$ff775019b5b6e7df = {}));
let $24c02ea0e14dbe4f$export$b3241a99d3e47e02;
(function(IconRotation) {
    IconRotation["ZERO"] = "0deg";
    IconRotation["NINETY"] = "90deg";
    IconRotation["ONE_EIGHTY"] = "180deg";
    IconRotation["TWO_SEVENTY"] = "270deg";
})($24c02ea0e14dbe4f$export$b3241a99d3e47e02 || ($24c02ea0e14dbe4f$export$b3241a99d3e47e02 = {}));
const $24c02ea0e14dbe4f$export$f04a61298a47a40f = ({ type: type, size: size = $24c02ea0e14dbe4f$export$ff775019b5b6e7df.MEDIUM, rotation: rotation = $24c02ea0e14dbe4f$export$b3241a99d3e47e02.ZERO, alt: alt = "", color: color, hoverColor: hoverColor, activeColor: activeColor })=>{
    const icon = (0, $5FkrB.useMemo)(()=>$24c02ea0e14dbe4f$export$df03f54e09e486fa[type], [
        type
    ]);
    const isCoreIcon = $24c02ea0e14dbe4f$var$$a02a6f7de308273b$var$CORE_ICONS.includes(type);
    // Core icons use 'color' prop and default to 'currentColor' for CSS inheritance
    // Glyph icons use 'primaryColor' prop
    const iconProps = isCoreIcon ? {
        size: size,
        label: alt,
        color: color || "currentColor",
        testId: type
    } : {
        size: size,
        label: alt,
        primaryColor: color || undefined,
        testId: type
    };
    return (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("span", {
        css: [
            $24c02ea0e14dbe4f$var$$a02a6f7de308273b$var$baseStyles,
            $24c02ea0e14dbe4f$var$$a02a6f7de308273b$var$rotationStyles[rotation],
            hoverColor && {
                "&:hover": {
                    color: hoverColor
                }
            },
            activeColor && {
                "&:active": {
                    color: activeColor
                }
            }
        ],
        "data-testid": `icon-${type}`,
        children: icon ? icon(iconProps) : null
    });
};
const $24c02ea0e14dbe4f$var$$a02a6f7de308273b$var$baseStyles = (0, $74Zh5.css)({
    width: "fit-content",
    height: "fit-content",
    display: "inline-flex"
});
const $24c02ea0e14dbe4f$var$$a02a6f7de308273b$var$rotationStyles = {
    "0deg": (0, $74Zh5.css)({
        transform: "rotate(0deg)"
    }),
    "90deg": (0, $74Zh5.css)({
        transform: "rotate(90deg)"
    }),
    "180deg": (0, $74Zh5.css)({
        transform: "rotate(180deg)"
    }),
    "270deg": (0, $74Zh5.css)({
        transform: "rotate(270deg)"
    })
};
const $24c02ea0e14dbe4f$var$$a02a6f7de308273b$var$iconNumberStyles = (0, $74Zh5.css)({
    fontSize: "16px"
});
var $24c02ea0e14dbe4f$var$$1298c86a7e6a9fc7$exports = {};
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$1298c86a7e6a9fc7$exports, "Image", ()=>$24c02ea0e14dbe4f$export$3e431a229df88919);
/**
 * It takes a url and returns the last part of the url which is the name of the image.
 * @param {string} url - The URL of the image you want to get the name.
 * @returns name of the image file.
 */ const $24c02ea0e14dbe4f$var$$1298c86a7e6a9fc7$var$getImageName = (url)=>{
    const urlSplitted = url.split("/");
    return urlSplitted[urlSplitted.length - 1];
};
/**
 * Convert bytes into KB or MB
 * @param {number} [bytes] - The number of bytes to format.
 * @returns a string with the KB o MB converted
 */ const $24c02ea0e14dbe4f$var$$1298c86a7e6a9fc7$var$formatBytes = (bytes)=>{
    const marker = 1024;
    const decimal = 0;
    const kiloBytes = marker;
    const megaBytes = marker * marker;
    return bytes ? bytes < kiloBytes ? bytes + " Bytes" : bytes < megaBytes ? (bytes / kiloBytes).toFixed(decimal) + " KB" : (bytes / megaBytes).toFixed(decimal) + " MB" : undefined;
};
/**
 * Download image
 * @param {string} src - The URL of the image you want to download.
 * @param {string} name - The name of the file you want to save the image as.
 */ const $24c02ea0e14dbe4f$var$$1298c86a7e6a9fc7$var$downloadImage = async (src, name)=>{
    const image = await fetch(src);
    const imageBlog = await image.blob();
    const imageURL = URL.createObjectURL(imageBlog);
    const link = document.createElement("a");
    link.href = imageURL;
    link.download = name;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
};
const $24c02ea0e14dbe4f$export$3e431a229df88919 = ({ inspectMode: inspectMode, src: src, alt: alt, width: width, height: height, caption: caption = "", size: size, center: center = true, preventModal: preventModal = false, onClick: onClick, ...props })=>{
    const rightToolsRef = (0, $5FkrB.useRef)(null);
    const downloadButtonRef = (0, $5FkrB.useRef)(null);
    const modalImgRef = (0, $5FkrB.useRef)(null);
    const originalImgRef = (0, $5FkrB.useRef)(null);
    const [showModal, setShowModal] = (0, $5FkrB.useState)(false);
    const [showControls, setShowControls] = (0, $5FkrB.useState)(false);
    const [totalZoom, setTotalZoom] = (0, $5FkrB.useState)(100);
    const [initialWidthModalImage, setInitialWidthModalImage] = (0, $5FkrB.useState)(0);
    const [initialHeightImage, setInitialHeightImage] = (0, $5FkrB.useState)(0);
    const [initialWidthOriginalImage, setInitialWidthOriginalImage] = (0, $5FkrB.useState)(0);
    (0, $5FkrB.useEffect)(()=>{
        if (showModal) {
            setShowControls(true);
            setTotalZoom(100);
            if (rightToolsRef.current) rightToolsRef.current.focus();
        }
    }, [
        showModal
    ]);
    (0, $5FkrB.useEffect)(()=>{
        let timer = null;
        if (showControls) timer = setTimeout(()=>setShowControls(false), 5000);
        return ()=>clearTimeout(timer ?? undefined);
    }, [
        showControls
    ]);
    (0, $5FkrB.useEffect)(()=>{
        const close = (e)=>{
            if (e.key === "Escape") setShowModal(false);
        };
        window.addEventListener("keydown", close);
        return ()=>window.removeEventListener("keydown", close);
    }, []);
    const onHoverModal = ()=>{
        setShowControls(true);
    };
    const onZoomOut = ()=>{
        if (totalZoom > 20) {
            setTotalZoom(totalZoom - 20);
            if (modalImgRef.current) {
                const widthImageModal = Math.round(modalImgRef.current?.offsetWidth - initialWidthModalImage * 0.2);
                const heightImageModal = Math.round(modalImgRef.current?.offsetHeight - initialHeightImage * 0.2);
                modalImgRef.current.style.width = `${widthImageModal}px`;
                modalImgRef.current.style.height = `${heightImageModal}px`;
            }
        }
    };
    const onZoomIn = ()=>{
        if (totalZoom < 320) {
            setTotalZoom(totalZoom + 20);
            if (modalImgRef.current) {
                const widthImageModal = Math.round(modalImgRef.current?.offsetWidth + initialWidthModalImage * 0.2);
                const heightImageModal = Math.round(modalImgRef.current?.offsetHeight + initialHeightImage * 0.2);
                modalImgRef.current.style.width = `${widthImageModal}px`;
                modalImgRef.current.style.height = `${heightImageModal}px`;
            }
        }
    };
    const onBlur = ()=>{
        if (rightToolsRef.current && downloadButtonRef.current) {
            rightToolsRef.current.setAttribute("tabIndex", "-1");
            downloadButtonRef.current.focus();
        }
    };
    const onClickImage = (0, $5FkrB.useCallback)(()=>{
        if (onClick) onClick();
        if (!preventModal) setShowModal(true);
    }, [
        onClick,
        preventModal
    ]);
    const onLoadImageModal = ()=>{
        setInitialWidthModalImage(modalImgRef.current?.offsetWidth ?? 0);
        setInitialHeightImage(modalImgRef.current?.offsetHeight ?? 0);
    };
    (0, $5FkrB.useEffect)(()=>{
        if (originalImgRef.current?.offsetWidth) setInitialWidthOriginalImage(originalImgRef.current.offsetWidth);
    }, [
        originalImgRef.current?.offsetWidth
    ]);
    const handleKeyDown = (0, $5FkrB.useCallback)((e)=>{
        if (e.code === "Space") onClickImage();
    }, [
        onClickImage
    ]);
    return (0, $6bec4f26b2cb3094$export$25062201e9e25d76)((0, $6bec4f26b2cb3094$export$ffb0004e005737fa), {
        children: [
            showModal && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                "data-testid": "modal",
                id: "myModal",
                css: $24c02ea0e14dbe4f$var$$1298c86a7e6a9fc7$var$modalStyles,
                onMouseMove: onHoverModal,
                children: (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                    css: $24c02ea0e14dbe4f$var$$1298c86a7e6a9fc7$var$modalContentStyles,
                    children: [
                        (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                            css: [
                                $24c02ea0e14dbe4f$var$$1298c86a7e6a9fc7$var$modalControlsStyles,
                                showControls && (0, $74Zh5.css)({
                                    opacity: 1
                                }),
                                !showControls && (0, $74Zh5.css)({
                                    opacity: 0
                                })
                            ],
                            children: (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                                css: $24c02ea0e14dbe4f$var$$1298c86a7e6a9fc7$var$containerStyles,
                                children: [
                                    (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                                        css: $24c02ea0e14dbe4f$var$$1298c86a7e6a9fc7$var$textContainerStyles,
                                        children: [
                                            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                                                css: $24c02ea0e14dbe4f$var$$1298c86a7e6a9fc7$var$iconContainerStyles,
                                                children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$f04a61298a47a40f, {
                                                    type: "image",
                                                    size: "large",
                                                    color: (0, $54ca2d3948378259$export$c6930421db9fa514)
                                                })
                                            }),
                                            (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                                                css: $24c02ea0e14dbe4f$var$$1298c86a7e6a9fc7$var$imageContainerStyles,
                                                children: [
                                                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("p", {
                                                        css: $24c02ea0e14dbe4f$var$$1298c86a7e6a9fc7$var$badgeContentStyles,
                                                        children: $24c02ea0e14dbe4f$var$$1298c86a7e6a9fc7$var$getImageName(src)
                                                    }),
                                                    (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("p", {
                                                        css: $24c02ea0e14dbe4f$var$$1298c86a7e6a9fc7$var$badgeContentStyles,
                                                        children: [
                                                            "image \xb7 ",
                                                            $24c02ea0e14dbe4f$var$$1298c86a7e6a9fc7$var$formatBytes(size)
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                                        className: "right",
                                        ref: rightToolsRef,
                                        children: [
                                            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("button", {
                                                "data-testid": "download-button",
                                                ref: downloadButtonRef,
                                                tabIndex: 0,
                                                css: (0, $74Zh5.css)({
                                                    marginRight: "1rem",
                                                    border: "none",
                                                    cursor: "pointer"
                                                }),
                                                "aria-label": "download image",
                                                onClick: ()=>{
                                                    $24c02ea0e14dbe4f$var$$1298c86a7e6a9fc7$var$downloadImage(src, $24c02ea0e14dbe4f$var$$1298c86a7e6a9fc7$var$getImageName(src));
                                                },
                                                children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$f04a61298a47a40f, {
                                                    type: "download",
                                                    size: "medium"
                                                })
                                            }),
                                            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("button", {
                                                css: {
                                                    border: "none",
                                                    cursor: "pointer"
                                                },
                                                tabIndex: 0,
                                                "data-testid": "close-modal-button",
                                                "aria-label": "close modal",
                                                onClick: ()=>{
                                                    setShowModal(false);
                                                },
                                                children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$f04a61298a47a40f, {
                                                    type: "cross",
                                                    size: "medium"
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        }),
                        (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $f9ff4343296b19bf$export$2e2bcd8739ae039), {
                            css: $24c02ea0e14dbe4f$var$$1298c86a7e6a9fc7$var$scrollContainerStyles,
                            children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("img", {
                                src: src,
                                alt: alt,
                                ref: modalImgRef,
                                onLoad: onLoadImageModal,
                                css: (0, $74Zh5.css)({
                                    margin: "auto"
                                })
                            })
                        }),
                        (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                            css: [
                                $24c02ea0e14dbe4f$var$$1298c86a7e6a9fc7$var$modalToolsStyles,
                                (0, $74Zh5.css)({
                                    opacity: showControls ? 1 : 0
                                })
                            ],
                            children: (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                                css: $24c02ea0e14dbe4f$var$$1298c86a7e6a9fc7$var$buttonContainerStyles,
                                children: [
                                    (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                                        children: [
                                            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("button", {
                                                "data-testid": "zoom-out-button",
                                                onClick: ()=>onZoomOut(),
                                                css: (0, $74Zh5.css)({
                                                    marginRight: "0.625rem",
                                                    border: "none",
                                                    cursor: "pointer"
                                                }),
                                                "aria-label": "zoom out",
                                                tabIndex: 0,
                                                children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$f04a61298a47a40f, {
                                                    type: "zoom-out"
                                                })
                                            }),
                                            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("button", {
                                                css: {
                                                    border: "none",
                                                    cursor: "pointer"
                                                },
                                                "data-testid": "zoom-in-button",
                                                onClick: ()=>onZoomIn(),
                                                onBlur: onBlur,
                                                "aria-label": "zoom in",
                                                tabIndex: 0,
                                                children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$f04a61298a47a40f, {
                                                    type: "zoom-in"
                                                })
                                            })
                                        ]
                                    }),
                                    (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                                        css: (0, $74Zh5.css)({
                                            color: (0, $54ca2d3948378259$export$5368d76ae4fbbda7)
                                        }),
                                        children: [
                                            totalZoom,
                                            "%"
                                        ]
                                    })
                                ]
                            })
                        })
                    ]
                })
            }),
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                ...$24c02ea0e14dbe4f$export$1784ac302bd8ebad("image", inspectMode),
                css: (0, $74Zh5.css)({
                    width: "100%",
                    overflow: "hidden"
                }),
                "data-testid": "image",
                onClick: onClickImage,
                children: (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("figure", {
                    css: $24c02ea0e14dbe4f$var$$1298c86a7e6a9fc7$var$figureStyles,
                    children: [
                        (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("img", {
                            tabIndex: 0,
                            width: width,
                            height: height,
                            ref: originalImgRef,
                            alt: alt,
                            src: src,
                            onKeyDown: handleKeyDown,
                            css: [
                                (0, $74Zh5.css)({
                                    transform: "scale(1)",
                                    objectFit: "contain",
                                    height: "auto"
                                }),
                                center && (0, $74Zh5.css)({
                                    margin: "auto"
                                }),
                                !preventModal && (0, $74Zh5.css)({
                                    cursor: "pointer"
                                }),
                                !width && (0, $74Zh5.css)({
                                    width: "100%"
                                })
                            ],
                            ...props
                        }),
                        !!initialWidthOriginalImage && !!caption && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("figcaption", {
                            style: {
                                width: `${initialWidthOriginalImage}px`,
                                maxWidth: "100vw"
                            },
                            css: $24c02ea0e14dbe4f$var$$1298c86a7e6a9fc7$var$captionContainerStyles,
                            children: caption
                        })
                    ]
                })
            })
        ]
    });
};
const $24c02ea0e14dbe4f$var$$1298c86a7e6a9fc7$var$modalStyles = (0, $74Zh5.css)({
    position: "fixed",
    zIndex: 100000,
    left: 0,
    top: 0,
    width: "100%",
    height: "100%",
    overflow: "auto",
    backgroundColor: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.background.input"),
    "& button": {
        background: "transparent",
        borderRadius: "3px",
        verticalAlign: "middle",
        display: "inline-flex",
        padding: "0.125rem !important",
        height: "fit-content",
        "&:hover": {
            backgroundColor: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.background.accent.gray.bolder.hovered"),
            borderRadius: "3px"
        }
    }
});
const $24c02ea0e14dbe4f$var$$1298c86a7e6a9fc7$var$modalContentStyles = (0, $74Zh5.css)({
    justifyContent: "center",
    alignItems: "center",
    display: "flex",
    height: "100%",
    flexDirection: "column",
    padding: 0,
    position: "relative",
    overflow: "hidden",
    "& img": {
        maxWidth: "100%",
        maxHeight: "100%",
        objectFit: "contain",
        width: "auto",
        height: "auto"
    }
});
const $24c02ea0e14dbe4f$var$$1298c86a7e6a9fc7$var$modalControlsStyles = (0, $74Zh5.css)({
    backgroundImage: "linear-gradient(rgb(14, 22, 36), rgba(14, 22, 36, 0))",
    position: "fixed",
    top: 0,
    left: 0,
    width: "100%",
    height: "6.125rem",
    zIndex: 1,
    fontWeight: 500,
    padding: "1.5rem",
    transition: "opacity 0.3s ease 0s",
    "& .right:focus": {
        outline: "none"
    },
    "& .right svg": {
        color: `${(0, $54ca2d3948378259$export$5368d76ae4fbbda7)} !important`
    }
});
const $24c02ea0e14dbe4f$var$$1298c86a7e6a9fc7$var$containerStyles = (0, $74Zh5.css)({
    display: "flex",
    justifyContent: "space-between"
});
const $24c02ea0e14dbe4f$var$$1298c86a7e6a9fc7$var$textContainerStyles = (0, $74Zh5.css)({
    display: "flex",
    color: (0, $54ca2d3948378259$export$5368d76ae4fbbda7)
});
const $24c02ea0e14dbe4f$var$$1298c86a7e6a9fc7$var$iconContainerStyles = (0, $74Zh5.css)({
    marginRight: "0.75rem",
    display: "flex",
    alignItems: "center"
});
const $24c02ea0e14dbe4f$var$$1298c86a7e6a9fc7$var$imageContainerStyles = (0, $74Zh5.css)({
    display: "flex",
    flexDirection: "column",
    color: "filter",
    fontSize: ".875rem",
    lineHeight: "1.25rem"
});
const $24c02ea0e14dbe4f$var$$1298c86a7e6a9fc7$var$badgeContentStyles = (0, $74Zh5.css)({
    margin: 0
});
const $24c02ea0e14dbe4f$var$$1298c86a7e6a9fc7$var$scrollContainerStyles = (0, $74Zh5.css)({
    height: "100%",
    width: "100%",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    overflow: "auto",
    WebkitOverflowScrolling: "touch"
});
const $24c02ea0e14dbe4f$var$$1298c86a7e6a9fc7$var$modalToolsStyles = (0, $74Zh5.css)({
    display: "flex",
    alignItems: "flex-end",
    justifyContent: "flex-end",
    position: "fixed",
    bottom: 0,
    width: "100%",
    height: "6.125rem",
    padding: "0.625rem",
    backgroundImage: "linear-gradient(rgba(14, 22, 36, 0), rgb(14, 22, 36))",
    "& svg": {
        color: `${(0, $54ca2d3948378259$export$5368d76ae4fbbda7)} !important`
    }
});
const $24c02ea0e14dbe4f$var$$1298c86a7e6a9fc7$var$buttonContainerStyles = (0, $74Zh5.css)({
    width: "50%",
    display: "flex",
    justifyContent: "space-between"
});
const $24c02ea0e14dbe4f$var$$1298c86a7e6a9fc7$var$figureStyles = (0, $74Zh5.css)({
    display: "flex",
    flexDirection: "column",
    margin: 0,
    textAlign: "center"
});
const $24c02ea0e14dbe4f$var$$1298c86a7e6a9fc7$var$captionContainerStyles = (0, $74Zh5.css)({
    margin: "16px auto",
    textAlign: "center",
    fontStyle: "italic",
    fontSize: ".875rem",
    lineHeight: "1.25rem",
    color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text.subtlest")
});
var $24c02ea0e14dbe4f$var$$c0c01354ab9765ae$exports = {};
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$c0c01354ab9765ae$exports, "InvertedIconButton", ()=>$24c02ea0e14dbe4f$export$dd09d7da2da4d16f);
const $24c02ea0e14dbe4f$export$dd09d7da2da4d16f = ({ icon: icon, onClick: onClick, ariaLabel: ariaLabel, disabled: disabled = false, selected: selected = false, tooltip: tooltip, testId: testId = "inverted-icon-button" })=>{
    const button = (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("button", {
        css: [
            $24c02ea0e14dbe4f$var$$c0c01354ab9765ae$var$baseStyles,
            selected && $24c02ea0e14dbe4f$var$$c0c01354ab9765ae$var$selectedStyles,
            disabled && $24c02ea0e14dbe4f$var$$c0c01354ab9765ae$var$disabledStyles
        ],
        onClick: onClick,
        "aria-label": ariaLabel,
        disabled: disabled,
        "data-testid": testId,
        type: "button",
        children: icon
    });
    return tooltip && !disabled ? (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $1ee6819d2d8fb6a1$export$2e2bcd8739ae039), {
        content: tooltip,
        testId: `${testId}-tooltip`,
        children: button
    }) : button;
};
const $24c02ea0e14dbe4f$var$$c0c01354ab9765ae$var$baseStyles = (0, $74Zh5.css)({
    background: "transparent",
    border: "none",
    padding: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.050"),
    cursor: "pointer",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: "4px",
    transition: "background-color 0.2s ease",
    color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text.inverse"),
    width: "32px",
    height: "32px",
    "&:hover": {
        backgroundColor: "rgba(255, 255, 255, 0.16)"
    },
    "&:active": {
        backgroundColor: "rgba(255, 255, 255, 0.24)"
    },
    "&:focus": {
        outline: `2px solid ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.border.inverse")}`,
        outlineOffset: "2px"
    },
    // Ensure icon inherits the white color
    "& > span": {
        color: "inherit"
    }
});
const $24c02ea0e14dbe4f$var$$c0c01354ab9765ae$var$selectedStyles = (0, $74Zh5.css)({
    "&:hover": {
        backgroundColor: "rgba(255, 255, 255, 0.32)"
    },
    "&:active": {
        backgroundColor: "rgba(255, 255, 255, 0.40)"
    }
});
const $24c02ea0e14dbe4f$var$$c0c01354ab9765ae$var$disabledStyles = (0, $74Zh5.css)({
    cursor: "not-allowed",
    opacity: 0.4,
    "&:hover": {
        backgroundColor: "transparent"
    },
    "&:active": {
        backgroundColor: "transparent"
    }
});
var $24c02ea0e14dbe4f$var$$4fce8dfc4ce8f546$exports = {};
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$4fce8dfc4ce8f546$exports, "LinkStyle", ()=>$24c02ea0e14dbe4f$export$2b77966d73aefa77);
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$4fce8dfc4ce8f546$exports, "LinkSize", ()=>$24c02ea0e14dbe4f$export$be4c932f76c19adf);
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$4fce8dfc4ce8f546$exports, "Link", ()=>$24c02ea0e14dbe4f$export$a6c7ac8248d6e38a);
let $24c02ea0e14dbe4f$export$2b77966d73aefa77;
(function(LinkStyle) {
    LinkStyle["REGULAR"] = "regular";
    LinkStyle["SEMIBOLD"] = "semibold";
})($24c02ea0e14dbe4f$export$2b77966d73aefa77 || ($24c02ea0e14dbe4f$export$2b77966d73aefa77 = {}));
let $24c02ea0e14dbe4f$export$be4c932f76c19adf;
(function(LinkSize) {
    LinkSize["EXTRA_LARGE"] = "extraLarge";
    LinkSize["LARGE"] = "large";
    LinkSize["MEDIUM"] = "medium";
})($24c02ea0e14dbe4f$export$be4c932f76c19adf || ($24c02ea0e14dbe4f$export$be4c932f76c19adf = {}));
const $24c02ea0e14dbe4f$export$a6c7ac8248d6e38a = ({ label: label, fontColor: fontColor = (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text.accent.blue"), target: target = "_self", link: link, style: style = $24c02ea0e14dbe4f$export$2b77966d73aefa77.REGULAR, icon: icon, onClick: onClick, size: size = $24c02ea0e14dbe4f$export$be4c932f76c19adf.MEDIUM, ...props })=>{
    const clickHandler = (0, $5FkrB.useCallback)((e)=>{
        e.stopPropagation();
        e.preventDefault();
        if (onClick) onClick(e);
    }, [
        onClick
    ]);
    const onKeyDown = (e)=>(handler)=>{
            if (e.key === "Enter" || e.key === " ") handler(e);
        };
    return (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("a", {
        target: target,
        href: link,
        rel: target === "_blank" ? "noopener noreferrer" : "",
        tabIndex: 0,
        css: [
            $24c02ea0e14dbe4f$var$$4fce8dfc4ce8f546$var$sizeStyles[size],
            $24c02ea0e14dbe4f$var$$4fce8dfc4ce8f546$var$variantStyles[style].base,
            $24c02ea0e14dbe4f$var$$4fce8dfc4ce8f546$var$baseStyles,
            $24c02ea0e14dbe4f$var$$4fce8dfc4ce8f546$var$variantStyles[style].hover,
            (0, $74Zh5.css)({
                color: fontColor
            })
        ],
        style: {
            wordBreak: "break-word",
            overflowWrap: "break-word"
        },
        onClick: clickHandler,
        /** @ts-expect-error - onKeyDown is not typed correctly */ onKeyDown: (e)=>onKeyDown(e)(clickHandler),
        ...props,
        children: [
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("span", {
                children: label
            }),
            icon && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("span", {
                css: $24c02ea0e14dbe4f$var$$4fce8dfc4ce8f546$var$iconContainerStyles,
                children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$f04a61298a47a40f, {
                    type: icon,
                    size: "medium"
                })
            })
        ]
    });
};
const $24c02ea0e14dbe4f$var$$4fce8dfc4ce8f546$var$baseStyles = (0, $74Zh5.css)({
    display: "inline",
    alignItems: "center",
    justifyContent: "center",
    columnGap: "2px",
    textDecoration: "none",
    [(0, $cb8cedbc477f5a81$export$987d49ffe1b0900f).below.sm]: {
        fontSize: "16px !important",
        lineHeight: "20px !important"
    }
});
const $24c02ea0e14dbe4f$var$$4fce8dfc4ce8f546$var$sizeStyles = {
    medium: {
        fontSize: "16px",
        lineHeight: "24px"
    },
    large: {
        fontSize: "20px",
        lineHeight: "24px"
    },
    extraLarge: {
        fontSize: "24px",
        lineHeight: "32px"
    }
};
const $24c02ea0e14dbe4f$var$$4fce8dfc4ce8f546$var$variantStyles = {
    regular: {
        base: (0, $74Zh5.css)({
            fontWeight: "normal"
        }),
        hover: (0, $74Zh5.css)({
            "&:hover": {
                color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.link"),
                textDecoration: "underline",
                cursor: "pointer",
                textUnderlineOffset: "4px",
                textDecorationThickness: "2px",
                textDecorationColor: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.link")
            }
        })
    },
    semibold: {
        base: (0, $74Zh5.css)({
            fontWeight: 600
        }),
        hover: (0, $74Zh5.css)({
            "&:hover": {
                color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.link"),
                textDecoration: "underline",
                cursor: "pointer",
                textUnderlineOffset: "4px",
                textDecorationThickness: "2px",
                textDecorationColor: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.link")
            }
        })
    }
};
const $24c02ea0e14dbe4f$var$$4fce8dfc4ce8f546$var$iconContainerStyles = {
    display: "inline",
    verticalAlign: "middle"
};
var $24c02ea0e14dbe4f$var$$800df40a54823a3f$exports = {};
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$800df40a54823a3f$exports, "List", ()=>$24c02ea0e14dbe4f$export$54c2e3dc7acea9f5);
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$800df40a54823a3f$exports, "variantsListStyles", ()=>$24c02ea0e14dbe4f$export$6427468642e6e9fe);
const $24c02ea0e14dbe4f$export$54c2e3dc7acea9f5 = ({ type: type = "unordered", textStyleType: textStyleType = "regular", children: children })=>{
    if (type === "ordered") return (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("ol", {
        "aria-label": "ordered",
        css: [
            $24c02ea0e14dbe4f$var$$800df40a54823a3f$var$listStyles,
            (0, $74Zh5.css)($24c02ea0e14dbe4f$export$6427468642e6e9fe.list[type]),
            $24c02ea0e14dbe4f$export$6427468642e6e9fe.textStyle[textStyleType]
        ],
        children: children
    });
    return (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("ul", {
        "aria-label": "unordered",
        css: [
            $24c02ea0e14dbe4f$var$$800df40a54823a3f$var$listStyles,
            (0, $74Zh5.css)($24c02ea0e14dbe4f$export$6427468642e6e9fe.list[type]),
            $24c02ea0e14dbe4f$export$6427468642e6e9fe.textStyle[textStyleType]
        ],
        children: children
    });
};
const $24c02ea0e14dbe4f$var$$800df40a54823a3f$var$fontSizeStyles = {
    fontSize: "1.25rem",
    lineHeight: "2rem",
    [(0, $cb8cedbc477f5a81$export$987d49ffe1b0900f).below.md]: {
        fontSize: "1rem",
        lineHeight: "1.5rem"
    }
};
const $24c02ea0e14dbe4f$var$$800df40a54823a3f$var$listStyles = (0, $74Zh5.css)({
    fontFamily: "Inter, sans-serif",
    letterSpacing: "0.3%",
    color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text"),
    ...$24c02ea0e14dbe4f$var$$800df40a54823a3f$var$fontSizeStyles,
    span: $24c02ea0e14dbe4f$var$$800df40a54823a3f$var$fontSizeStyles
});
const $24c02ea0e14dbe4f$export$6427468642e6e9fe = {
    list: {
        unordered: {
            listStyleType: "disc",
            paddingLeft: "1.25rem",
            ul: {
                listStyleType: "circle",
                paddingLeft: "1.25rem"
            },
            "ul ul": {
                listStyleType: "square",
                paddingLeft: "1.25rem"
            },
            "ul:not(:first-of-type), ul li, li + li": {
                marginTop: 0
            }
        },
        ordered: {
            listStyleType: "decimal",
            paddingLeft: "1.25rem",
            ol: {
                listStyleType: "lower-alpha",
                paddingLeft: "1.25rem"
            },
            "ol ol": {
                listStyleType: "lower-roman",
                paddingLeft: "1.25rem"
            },
            "ol:not(:first-of-type), ol li, li + li": {
                marginTop: 0
            }
        }
    },
    textStyle: {
        regular: (0, $74Zh5.css)({
            fontWeight: 400
        }),
        italic: (0, $74Zh5.css)({
            fontStyle: "italic"
        }),
        bold: (0, $74Zh5.css)({
            fontWeight: 700
        }),
        boldItalic: (0, $74Zh5.css)({
            fontWeight: 700,
            fontStyle: "italic"
        })
    }
};
var $24c02ea0e14dbe4f$var$$25cbe9fdb2d8d071$exports = {};
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$25cbe9fdb2d8d071$exports, "NavigationBar", ()=>$24c02ea0e14dbe4f$export$214ae410b202e65a);
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$25cbe9fdb2d8d071$exports, "NavBarLinkItem", ()=>$24c02ea0e14dbe4f$export$e76239e22e3abad);
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$25cbe9fdb2d8d071$exports, "NavBarProfileItem", ()=>$24c02ea0e14dbe4f$export$1cba3806e1f1b01d);
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$25cbe9fdb2d8d071$exports, "AtlassianNavLogo", ()=>$24c02ea0e14dbe4f$export$6ce3be5638d8e2a);
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$25cbe9fdb2d8d071$exports, "MenuItem", ()=>$24c02ea0e14dbe4f$export$2ce376c2cc3355c8);
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$25cbe9fdb2d8d071$exports, "NavBarExpandableItem", ()=>$24c02ea0e14dbe4f$export$1229978ae51a03a8);
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$25cbe9fdb2d8d071$exports, "NavbarSlideMenuItem", ()=>$24c02ea0e14dbe4f$export$c7fcbaf97c146aec);
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$25cbe9fdb2d8d071$exports, "NavBarItemWithMenu", ()=>$24c02ea0e14dbe4f$export$2771c1f4a09ce668);
const $24c02ea0e14dbe4f$var$$6a34d18c8d59b475$var$CloseIcon = ()=>(0, $6bec4f26b2cb3094$export$25062201e9e25d76)("svg", {
        width: "32",
        height: "32",
        viewBox: "0 0 32 32",
        fill: "currentColor",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("path", {
                d: "M7 7L23.9706 23.9706",
                stroke: "currentColor",
                strokeWidth: "3",
                strokeLinecap: "round"
            }),
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("path", {
                d: "M7 24L23.9706 7.02944",
                stroke: "currentColor",
                strokeWidth: "3",
                strokeLinecap: "round"
            })
        ]
    });
var $24c02ea0e14dbe4f$var$$6a34d18c8d59b475$export$2e2bcd8739ae039 = $24c02ea0e14dbe4f$var$$6a34d18c8d59b475$var$CloseIcon;
const $24c02ea0e14dbe4f$var$$5ba5f450ff826a14$var$HamburgerMenuIcon = ()=>(0, $6bec4f26b2cb3094$export$25062201e9e25d76)("svg", {
        width: "32",
        height: "32",
        viewBox: "0 0 32 32",
        fill: "currentColor",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("path", {
                d: "M4 8H28",
                stroke: "currentColor",
                strokeWidth: "3",
                strokeLinecap: "round"
            }),
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("path", {
                d: "M4 16H28",
                stroke: "currentColor",
                strokeWidth: "3",
                strokeLinecap: "round"
            }),
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("path", {
                d: "M4 24H28",
                stroke: "currentColor",
                strokeWidth: "3",
                strokeLinecap: "round"
            })
        ]
    });
var $24c02ea0e14dbe4f$var$$5ba5f450ff826a14$export$2e2bcd8739ae039 = $24c02ea0e14dbe4f$var$$5ba5f450ff826a14$var$HamburgerMenuIcon;
const $24c02ea0e14dbe4f$var$$f0285f05d4d9f8a0$export$426e07cd0772984d = {
    MOBILE: {
        MAX_WIDTH: 767,
        MEDIA_QUERY: "@media (max-width: 767px)"
    },
    TABLET: {
        MIN_WIDTH: 768,
        MAX_WIDTH: 1279,
        MEDIA_QUERY: "@media (min-width: 768px) and (max-width: 1279px)"
    },
    DESKTOP: {
        MIN_WIDTH: 1280,
        MEDIA_QUERY: "@media (min-width: 1280px)"
    }
};
var $24c02ea0e14dbe4f$var$$965a3cfbe886b380$exports = {};
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$965a3cfbe886b380$exports, "useOutsideClickHandler", ()=>$24c02ea0e14dbe4f$export$aa79b0abe3dfeaba);
const $24c02ea0e14dbe4f$export$aa79b0abe3dfeaba = (refs, onOutsideClick)=>{
    (0, $5FkrB.useEffect)(()=>{
        const handleOutsideClick = (event)=>{
            // if click has occurred outside of all refs, then call onOutsideClick
            if (refs.every((ref)=>ref.current && !ref.current.contains(event.target))) onOutsideClick();
        };
        // bind the event listener
        document.addEventListener("mousedown", handleOutsideClick);
        return ()=>{
            // unbind the event listener on clean up
            document.removeEventListener("mousedown", handleOutsideClick);
        };
    }, [
        refs,
        onOutsideClick
    ]);
};
const $24c02ea0e14dbe4f$export$6ce3be5638d8e2a = ({ subtitleHref: subtitleHref, label: label, logoSubtitle: logoSubtitle })=>{
    return (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("span", {
        css: $24c02ea0e14dbe4f$var$$90d3cbebafca1fdb$var$containerStyles,
        children: [
            (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("a", {
                href: "https://www.atlassian.com",
                target: "_blank",
                rel: "noopener noreferrer",
                children: [
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("span", {
                        css: $24c02ea0e14dbe4f$var$$90d3cbebafca1fdb$var$smallAtlassianLogoStyles,
                        children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $37844134dd17fb96$export$8a485e2e7ed91e8f), {
                            testId: "mobile"
                        })
                    }),
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("span", {
                        css: $24c02ea0e14dbe4f$var$$90d3cbebafca1fdb$var$bigAtlassianLogoStyles,
                        children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $fefa5e0a15da0ac0$export$765cacec8b0843f3), {
                            testId: "desktop"
                        })
                    })
                ]
            }),
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("span", {
                css: $24c02ea0e14dbe4f$var$$90d3cbebafca1fdb$var$dividerStyles
            }),
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("a", {
                href: subtitleHref,
                css: $24c02ea0e14dbe4f$var$$90d3cbebafca1fdb$var$subtitleStyles,
                "data-testid": "logoSubtitle",
                "aria-label": label,
                children: (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("span", {
                    children: [
                        " ",
                        logoSubtitle,
                        " "
                    ]
                })
            })
        ]
    });
};
const $24c02ea0e14dbe4f$var$$90d3cbebafca1fdb$var$containerStyles = (0, $74Zh5.css)({
    display: "flex",
    alignItems: "center",
    background: "none",
    fontFamily: "Charlie Display"
});
const $24c02ea0e14dbe4f$var$$90d3cbebafca1fdb$var$smallAtlassianLogoStyles = (0, $74Zh5.css)({
    [`@media (max-width: ${$24c02ea0e14dbe4f$var$$f0285f05d4d9f8a0$export$426e07cd0772984d.TABLET.MAX_WIDTH}px)`]: {
        display: "flex",
        alignItems: "center",
        svg: {
            color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.icon.brand"),
            transform: "scale(0.74)"
        }
    },
    [`@media (min-width: ${$24c02ea0e14dbe4f$var$$f0285f05d4d9f8a0$export$426e07cd0772984d.DESKTOP.MIN_WIDTH}px)`]: {
        display: "none"
    }
});
const $24c02ea0e14dbe4f$var$$90d3cbebafca1fdb$var$bigAtlassianLogoStyles = (0, $74Zh5.css)({
    [`@media (min-width: ${$24c02ea0e14dbe4f$var$$f0285f05d4d9f8a0$export$426e07cd0772984d.DESKTOP.MIN_WIDTH}px)`]: {
        display: "flex",
        alignItems: "center",
        span: {
            width: "148px",
            height: "24px"
        },
        svg: {
            color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.icon.brand")
        }
    },
    [`@media (max-width: ${$24c02ea0e14dbe4f$var$$f0285f05d4d9f8a0$export$426e07cd0772984d.TABLET.MAX_WIDTH}px)`]: {
        display: "none"
    }
});
const $24c02ea0e14dbe4f$var$$90d3cbebafca1fdb$var$dividerStyles = (0, $74Zh5.css)({
    width: "1px",
    height: "32px",
    backgroundColor: "#DDDEE1",
    marginLeft: "24px",
    marginRight: "16px",
    [`@media (max-width: ${$24c02ea0e14dbe4f$var$$f0285f05d4d9f8a0$export$426e07cd0772984d.TABLET.MAX_WIDTH}px)`]: {
        marginLeft: "8px",
        marginRight: "16px"
    }
});
const $24c02ea0e14dbe4f$var$$90d3cbebafca1fdb$var$subtitleStyles = (0, $74Zh5.css)({
    fontSize: "22px",
    fontWeight: 600,
    color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text"),
    textDecoration: "none",
    padding: "6px 8px",
    "&:hover": {
        color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.border.brand"),
        textDecoration: "none"
    }
});
const $24c02ea0e14dbe4f$var$$ff532043ef39c56f$var$SlideMenuContext = (0, $5FkrB.createContext)(undefined);
const $24c02ea0e14dbe4f$var$$ff532043ef39c56f$export$74d704c90f90362c = ()=>{
    const context = (0, $5FkrB.useContext)($24c02ea0e14dbe4f$var$$ff532043ef39c56f$var$SlideMenuContext);
    if (!context) throw new Error("useSlideMenuContext must be used within a SlideMenuContextProvider");
    return context;
};
const $24c02ea0e14dbe4f$var$$ff532043ef39c56f$export$f5c7f2da77f7e7fd = ({ children: children })=>{
    const [slideMenuContent, setSlideMenuContent] = (0, $5FkrB.useState)(null);
    const [isSlideMenuOpen, setIsSlideMenuOpen] = (0, $5FkrB.useState)(false);
    const [containerHeight, setContainerHeight] = (0, $5FkrB.useState)("initial");
    const openSlideMenu = (content)=>{
        setSlideMenuContent(content);
        setIsSlideMenuOpen(true);
    };
    const closeSlideMenu = ()=>{
        setIsSlideMenuOpen(false);
    };
    const contextValue = (0, $5FkrB.useMemo)(()=>({
            slideMenuContent: slideMenuContent,
            isSlideMenuOpen: isSlideMenuOpen,
            openSlideMenu: openSlideMenu,
            closeSlideMenu: closeSlideMenu,
            containerHeight: containerHeight,
            setContainerHeight: setContainerHeight
        }), [
        slideMenuContent,
        isSlideMenuOpen,
        containerHeight
    ]);
    return (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$var$$ff532043ef39c56f$var$SlideMenuContext.Provider, {
        value: contextValue,
        children: children
    });
};
const $24c02ea0e14dbe4f$export$2771c1f4a09ce668 = ({ headerContent: headerContent, bodyContent: bodyContent, isNested: isNested = false, isActive: isActive = false })=>(0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
        css: $24c02ea0e14dbe4f$var$$6295d3d31ca2a786$var$containerStyles,
        role: "group",
        "data-testid": "navbar-menu-item",
        children: [
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                css: [
                    $24c02ea0e14dbe4f$var$$6295d3d31ca2a786$var$headerStyles,
                    isActive && $24c02ea0e14dbe4f$var$$6295d3d31ca2a786$var$headerSelectedStyles,
                    isNested && $24c02ea0e14dbe4f$var$$6295d3d31ca2a786$var$nestedHeaderStyles
                ],
                role: "treeitem",
                "aria-selected": isActive,
                children: headerContent
            }),
            isActive && bodyContent && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("ul", {
                css: [
                    $24c02ea0e14dbe4f$var$$6295d3d31ca2a786$var$bodyContentContainerStyles,
                    isNested && $24c02ea0e14dbe4f$var$$6295d3d31ca2a786$var$nestedBodyContentContainerStyles
                ],
                children: bodyContent
            })
        ]
    });
const $24c02ea0e14dbe4f$var$$6295d3d31ca2a786$var$containerStyles = (0, $74Zh5.css)({
    display: "flex",
    fontSize: "16px",
    alignItems: "flex-start",
    flexDirection: "column",
    width: "100%"
});
const $24c02ea0e14dbe4f$var$$6295d3d31ca2a786$var$headerStyles = (0, $74Zh5.css)({
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    cursor: "pointer",
    height: "32px",
    width: "100%",
    padding: `0 ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.300")}`
});
const $24c02ea0e14dbe4f$var$$6295d3d31ca2a786$var$headerSelectedStyles = (0, $74Zh5.css)({
    color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text.selected"),
    "a, span": {
        color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text.selected")
    }
});
const $24c02ea0e14dbe4f$var$$6295d3d31ca2a786$var$nestedHeaderStyles = (0, $74Zh5.css)({
    padding: `0 ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.500")}`
});
const $24c02ea0e14dbe4f$var$$6295d3d31ca2a786$var$bodyContentContainerStyles = (0, $74Zh5.css)({
    display: "flex",
    flexDirection: "column",
    width: "100%",
    gap: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.100"),
    paddingLeft: 0,
    margin: 0,
    marginTop: `${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.100")} !important`,
    listStyle: "none"
});
const $24c02ea0e14dbe4f$var$$6295d3d31ca2a786$var$nestedBodyContentContainerStyles = (0, $74Zh5.css)({
    li: {
        paddingLeft: "56px"
    }
});
var $24c02ea0e14dbe4f$var$$6e8a4d5d78071ed7$exports = {};
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$6e8a4d5d78071ed7$exports, "useMediaQuery", ()=>$24c02ea0e14dbe4f$export$32d5543ab307c01);
const $24c02ea0e14dbe4f$export$32d5543ab307c01 = (mediaQuery)=>{
    const [targetReached, setTargetReached] = (0, $5FkrB.useState)(false);
    const updateTarget = (0, $5FkrB.useCallback)((e)=>{
        if (e.matches) setTargetReached(true);
        else setTargetReached(false);
    }, []);
    (0, $5FkrB.useEffect)(()=>{
        const media = window.matchMedia(mediaQuery);
        media.addEventListener("change", updateTarget);
        // Check on mount (callback is not called until a change occurs)
        if (media.matches) setTargetReached(true);
        return ()=>media.removeEventListener("change", updateTarget);
    // mediaQuery and updateTarget intentionally excluded to avoid re-creating listener
    /* eslint-disable react-hooks/exhaustive-deps */ }, []);
    /* eslint-enable react-hooks/exhaustive-deps */ return targetReached;
};
const $24c02ea0e14dbe4f$var$$3e3d20b49785004a$export$29d11c0fe2fc51d8 = ({ link: link, shouldRedirect: shouldRedirect, isSelected: isSelected })=>{
    const { text: text, href: href, onClick: onClick, target: target } = link;
    return (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("a", {
        css: [
            $24c02ea0e14dbe4f$var$$3e3d20b49785004a$var$linkStyles.default,
            isSelected && $24c02ea0e14dbe4f$var$$3e3d20b49785004a$var$linkStyles.selected
        ],
        href: shouldRedirect ? href : undefined,
        onClick: onClick,
        target: target || "_self",
        children: text
    });
};
const $24c02ea0e14dbe4f$export$e76239e22e3abad = ({ isSelected: isSelected = false, link: link, expandableBodyContent: expandableBodyContent, isNested: isNested = false, showNewMenu: showNewMenu = false })=>{
    const isBreakpoint = $24c02ea0e14dbe4f$export$32d5543ab307c01(`(max-width: ${$24c02ea0e14dbe4f$var$$f0285f05d4d9f8a0$export$426e07cd0772984d.TABLET.MAX_WIDTH}px)`);
    if (isBreakpoint) return showNewMenu ? (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$2771c1f4a09ce668, {
        headerContent: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$var$$3e3d20b49785004a$export$29d11c0fe2fc51d8, {
            link: link,
            isSelected: isSelected,
            shouldRedirect: !expandableBodyContent
        }),
        bodyContent: expandableBodyContent,
        isNested: isNested,
        isActive: isSelected
    }) : (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$1229978ae51a03a8, {
        headerContent: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$var$$3e3d20b49785004a$export$29d11c0fe2fc51d8, {
            link: link,
            isSelected: isSelected,
            shouldRedirect: !expandableBodyContent
        }),
        bodyContent: expandableBodyContent,
        isNested: isNested
    });
    return (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
        css: $24c02ea0e14dbe4f$var$$3e3d20b49785004a$var$buttonDivStyles,
        children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$var$$3e3d20b49785004a$export$29d11c0fe2fc51d8, {
            link: link,
            isSelected: isSelected,
            shouldRedirect: true
        })
    });
};
const $24c02ea0e14dbe4f$var$$3e3d20b49785004a$var$buttonDivStyles = (0, $74Zh5.css)({
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    padding: "10px 12px"
});
const $24c02ea0e14dbe4f$var$$3e3d20b49785004a$var$linkStyles = {
    default: (0, $74Zh5.css)({
        color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text"),
        fontSize: "1rem",
        fontWeight: 400,
        lineHeight: "20px",
        "&:hover": {
            color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text.selected"),
            textDecoration: "none"
        },
        "&:active": {
            color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text.information")
        },
        [`@media (max-width: ${$24c02ea0e14dbe4f$var$$f0285f05d4d9f8a0$export$426e07cd0772984d.TABLET.MAX_WIDTH}px)`]: {
            "&:hover, &:active": {
                color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text.brand"),
                textDecoration: "none"
            }
        }
    }),
    selected: (0, $74Zh5.css)({
        [`@media (min-width: ${$24c02ea0e14dbe4f$var$$f0285f05d4d9f8a0$export$426e07cd0772984d.DESKTOP.MIN_WIDTH}px)`]: {
            color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text.selected")
        }
    })
};
const $24c02ea0e14dbe4f$export$1229978ae51a03a8 = ({ headerContent: headerContent, expandedHeaderContent: expandedHeaderContent, bodyContent: bodyContent, onExpandClick: onExpandClick, isNested: isNested = false })=>{
    const [isOpen, setIsOpen] = (0, $5FkrB.useState)(false);
    const onExpandClickHandler = ()=>{
        setIsOpen(!isOpen);
        if (onExpandClick) onExpandClick(isOpen);
    };
    return (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
        css: $24c02ea0e14dbe4f$var$$3b7e032fd37ae5a5$var$containerStyles,
        role: "group",
        children: bodyContent ? (0, $6bec4f26b2cb3094$export$25062201e9e25d76)((0, $6bec4f26b2cb3094$export$ffb0004e005737fa), {
            children: [
                (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                    css: [
                        $24c02ea0e14dbe4f$var$$3b7e032fd37ae5a5$var$headerStyles,
                        isOpen && $24c02ea0e14dbe4f$var$$3b7e032fd37ae5a5$var$headerSelectedStyles,
                        isNested && $24c02ea0e14dbe4f$var$$3b7e032fd37ae5a5$var$nestedHeaderStyles
                    ],
                    role: "treeitem",
                    tabIndex: 0,
                    "aria-selected": isOpen,
                    onClick: onExpandClickHandler,
                    onKeyDown: (e)=>{
                        if (e.key === "Enter" || e.key === " ") {
                            e.preventDefault();
                            onExpandClickHandler();
                        }
                    },
                    children: [
                        isOpen && expandedHeaderContent ? expandedHeaderContent : headerContent,
                        (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("span", {
                            css: isOpen && $24c02ea0e14dbe4f$var$$3b7e032fd37ae5a5$var$chevronSelectedStyles,
                            children: isOpen ? (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($cS1ic))), {
                                label: "Collapse item"
                            }) : (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($5Y5FQ))), {
                                label: "Expand item"
                            })
                        })
                    ]
                }),
                isOpen && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("ul", {
                    css: [
                        $24c02ea0e14dbe4f$var$$3b7e032fd37ae5a5$var$bodyContentContainerStyles,
                        isNested && $24c02ea0e14dbe4f$var$$3b7e032fd37ae5a5$var$nestedBodyContentContainerStyles
                    ],
                    children: bodyContent
                })
            ]
        }) : (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
            css: $24c02ea0e14dbe4f$var$$3b7e032fd37ae5a5$var$headerStyles,
            role: "treeitem",
            tabIndex: 0,
            "aria-selected": false,
            children: headerContent
        })
    });
};
const $24c02ea0e14dbe4f$var$$3b7e032fd37ae5a5$var$containerStyles = (0, $74Zh5.css)({
    display: "flex",
    fontSize: "1rem",
    alignItems: "flex-start",
    flexDirection: "column",
    width: "100%"
});
const $24c02ea0e14dbe4f$var$$3b7e032fd37ae5a5$var$headerStyles = (0, $74Zh5.css)({
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    cursor: "pointer",
    height: "32px",
    width: "100%",
    padding: "0 24px"
});
// when selected, header text color should appear as selected color (apply to different elements, since headerContent can vary)
const $24c02ea0e14dbe4f$var$$3b7e032fd37ae5a5$var$headerSelectedStyles = (0, $74Zh5.css)({
    color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text.selected"),
    a: {
        color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text.selected")
    },
    span: {
        color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text.selected")
    }
});
const $24c02ea0e14dbe4f$var$$3b7e032fd37ae5a5$var$nestedHeaderStyles = (0, $74Zh5.css)({
    padding: "0 40px"
});
const $24c02ea0e14dbe4f$var$$3b7e032fd37ae5a5$var$bodyContentContainerStyles = (0, $74Zh5.css)({
    display: "flex",
    flexDirection: "column",
    width: "100%",
    gap: "8px",
    paddingTop: "8px",
    paddingLeft: "0",
    margin: 0,
    listStyle: "none"
});
const $24c02ea0e14dbe4f$var$$3b7e032fd37ae5a5$var$nestedBodyContentContainerStyles = (0, $74Zh5.css)({
    li: {
        paddingLeft: "56px"
    }
});
const $24c02ea0e14dbe4f$var$$3b7e032fd37ae5a5$var$chevronSelectedStyles = (0, $74Zh5.css)({
    svg: {
        color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text.selected")
    }
});
const $24c02ea0e14dbe4f$export$c7fcbaf97c146aec = ({ title: title, menuHeader: menuHeader, menuContent: menuContent, type: type = "menuItem" })=>{
    const { openSlideMenu: openSlideMenu } = $24c02ea0e14dbe4f$var$$ff532043ef39c56f$export$74d704c90f90362c();
    const handleOpenMenu = (0, $5FkrB.useCallback)(()=>{
        openSlideMenu({
            header: menuHeader || title,
            content: menuContent
        });
    }, [
        openSlideMenu,
        menuHeader,
        title,
        menuContent
    ]);
    const onKeyDown = $24c02ea0e14dbe4f$export$2a0b6757d41dacb2(handleOpenMenu);
    return (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("li", {
        "data-testid": "navbar-slide-menu-item",
        css: [
            $24c02ea0e14dbe4f$var$$67abd1c503eb8615$var$listItemStyles,
            type === "subMenuItem" && $24c02ea0e14dbe4f$var$$67abd1c503eb8615$var$subMenuItemStyles
        ],
        children: (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
            role: "button",
            tabIndex: 0,
            css: $24c02ea0e14dbe4f$var$$67abd1c503eb8615$var$interactiveContentStyles,
            onClick: handleOpenMenu,
            onKeyDown: onKeyDown,
            children: [
                (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("span", {
                    css: $24c02ea0e14dbe4f$var$$67abd1c503eb8615$var$titleStyles,
                    children: title
                }),
                (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$f04a61298a47a40f, {
                    type: "chevron-right",
                    size: "medium"
                })
            ]
        })
    });
};
const $24c02ea0e14dbe4f$var$$67abd1c503eb8615$var$titleStyles = (0, $74Zh5.css)({
    fontSize: "16px",
    fontWeight: 400
});
const $24c02ea0e14dbe4f$var$$67abd1c503eb8615$var$listItemStyles = (0, $74Zh5.css)({});
const $24c02ea0e14dbe4f$var$$67abd1c503eb8615$var$interactiveContentStyles = (0, $74Zh5.css)({
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    cursor: "pointer",
    color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text"),
    padding: `0 ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.300")}`,
    paddingRight: "18px",
    height: "32px",
    "&:hover": {
        color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.link")
    }
});
const $24c02ea0e14dbe4f$var$$67abd1c503eb8615$var$subMenuItemStyles = (0, $74Zh5.css)({
    "& > div": {
        padding: `0 18px 0 ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.500")}`
    }
});
const $24c02ea0e14dbe4f$var$$397a78fff494027c$var$getAvatarUserHeaderForMobile = (user, isExpanded)=>(0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
        css: [
            $24c02ea0e14dbe4f$var$$397a78fff494027c$var$headerContentStyles,
            isExpanded && $24c02ea0e14dbe4f$var$$397a78fff494027c$var$avatarUserSelectedStyles
        ],
        children: [
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $f31efb9f24b21b67$export$2e2bcd8739ae039), {
                appearance: "circle",
                src: user.avatar,
                size: "small",
                name: user.publicName
            }, user.publicName),
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                css: $24c02ea0e14dbe4f$var$$397a78fff494027c$var$nameStyles,
                children: user.publicName
            })
        ]
    });
const $24c02ea0e14dbe4f$export$1cba3806e1f1b01d = ({ user: user, expandableMenuContent: expandableMenuContent, profileMenuContent: profileMenuContent, onProfileMenuClick: onProfileMenuClick, showNewMenu: showNewMenu = false })=>{
    const [isMenuOpen, setIsMenuOpen] = (0, $5FkrB.useState)(false);
    const isBreakpoint = $24c02ea0e14dbe4f$export$32d5543ab307c01(`(max-width: ${$24c02ea0e14dbe4f$var$$f0285f05d4d9f8a0$export$426e07cd0772984d.TABLET.MAX_WIDTH}px)`);
    const avatarMenuRef = (0, $5FkrB.useRef)(null);
    $24c02ea0e14dbe4f$export$aa79b0abe3dfeaba([
        avatarMenuRef
    ], ()=>setIsMenuOpen(false));
    const onProfileMenuClickHandler = ()=>{
        setIsMenuOpen(!isMenuOpen);
        if (onProfileMenuClick) onProfileMenuClick(isMenuOpen);
    };
    if (isBreakpoint) return showNewMenu ? (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$c7fcbaf97c146aec, {
        title: $24c02ea0e14dbe4f$var$$397a78fff494027c$var$getAvatarUserHeaderForMobile(user, false),
        menuHeader: $24c02ea0e14dbe4f$var$$397a78fff494027c$var$getAvatarUserHeaderForMobile(user, true),
        menuContent: expandableMenuContent
    }) : (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$1229978ae51a03a8, {
        headerContent: $24c02ea0e14dbe4f$var$$397a78fff494027c$var$getAvatarUserHeaderForMobile(user, false),
        expandedHeaderContent: $24c02ea0e14dbe4f$var$$397a78fff494027c$var$getAvatarUserHeaderForMobile(user, true),
        bodyContent: expandableMenuContent,
        onExpandClick: onProfileMenuClick
    });
    return (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("span", {
        ref: avatarMenuRef,
        children: [
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("button", {
                css: [
                    $24c02ea0e14dbe4f$var$$397a78fff494027c$var$avatarStyles,
                    isMenuOpen && $24c02ea0e14dbe4f$var$$397a78fff494027c$var$avatarUserSelectedStyles
                ],
                onClick: onProfileMenuClickHandler,
                children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $f31efb9f24b21b67$export$2e2bcd8739ae039), {
                    appearance: "circle",
                    src: user.avatar,
                    size: "medium",
                    name: user.publicName
                }, user.publicName)
            }),
            isMenuOpen && profileMenuContent ? (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("ul", {
                css: $24c02ea0e14dbe4f$var$$397a78fff494027c$var$openMenuStyles,
                "aria-label": "Profile menu",
                role: "menu",
                children: profileMenuContent
            }) : null
        ]
    });
};
const $24c02ea0e14dbe4f$var$$397a78fff494027c$var$headerContentStyles = (0, $74Zh5.css)({
    display: "flex",
    gap: "8px",
    fontSize: "1rem",
    lineHeight: "20px"
});
const $24c02ea0e14dbe4f$var$$397a78fff494027c$var$nameStyles = (0, $74Zh5.css)({
    alignSelf: "center"
});
const $24c02ea0e14dbe4f$var$$397a78fff494027c$var$avatarStyles = (0, $74Zh5.css)({
    all: "unset",
    cursor: "pointer",
    marginTop: "3px",
    "&:focus-visible": {
        outline: `1px solid ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.border.selected")}`
    }
});
const $24c02ea0e14dbe4f$var$$397a78fff494027c$var$avatarUserSelectedStyles = (0, $74Zh5.css)({
    "& > * > span": {
        outline: `2px ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text.selected")} solid`
    }
});
const $24c02ea0e14dbe4f$var$$397a78fff494027c$var$openMenuStyles = (0, $74Zh5.css)({
    backgroundColor: "#FFFFFF",
    position: "absolute",
    display: "flex",
    flexDirection: "column",
    right: 0,
    zIndex: 10,
    borderRadius: "4px",
    boxShadow: "0 0 1px 0 #ccc,0 5px 20px -5px rgba(0,0,0,.1)",
    listStyle: "none",
    margin: 0,
    padding: 0
});
const $24c02ea0e14dbe4f$export$2ce376c2cc3355c8 = ({ link: link, type: type, contentBefore: contentBefore, contentAfter: contentAfter })=>{
    const { href: href, onClick: onClick, text: text, icon: icon } = link;
    const isActive = (0, $5FkrB.useMemo)(()=>href && globalThis ? globalThis.location.pathname === href : false, [
        href
    ]);
    return (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("a", {
        css: $24c02ea0e14dbe4f$var$$3539883ac1727dfc$var$menuLinkStyles,
        href: href,
        onClick: onClick,
        children: (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("li", {
            css: [
                $24c02ea0e14dbe4f$var$$3539883ac1727dfc$var$menuItemContainerBaseStyles,
                $24c02ea0e14dbe4f$var$$3539883ac1727dfc$var$menuItemContainerStyles[type],
                isActive && $24c02ea0e14dbe4f$var$$3539883ac1727dfc$var$activeStyles
            ],
            role: "treeitem",
            "aria-selected": isActive,
            children: [
                contentBefore,
                text,
                icon && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("span", {
                    css: $24c02ea0e14dbe4f$var$$3539883ac1727dfc$var$iconStyles,
                    children: icon
                }),
                contentAfter
            ]
        })
    });
};
const $24c02ea0e14dbe4f$var$$3539883ac1727dfc$var$menuItemContainerBaseStyles = (0, $74Zh5.css)({
    display: "flex",
    alignItems: "center",
    width: "100%"
});
const $24c02ea0e14dbe4f$var$$3539883ac1727dfc$var$menuItemContainerStyles = {
    subMenu: (0, $74Zh5.css)({
        height: "32px",
        padding: "0 40px"
    }),
    profile: (0, $74Zh5.css)({
        height: "48px",
        padding: "0 24px"
    }),
    menuItem: (0, $74Zh5.css)({
        fontFamily: "Inter, sans-serif",
        fontSize: "14px",
        lineHeight: "22px",
        fontWeight: 400,
        height: "32px",
        padding: `0 ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.150")}`
    })
};
const $24c02ea0e14dbe4f$var$$3539883ac1727dfc$var$menuLinkStyles = (0, $74Zh5.css)({
    fontSize: "16px",
    lineHeight: "16px",
    fontWeight: 400,
    color: "#172B4D",
    cursor: "pointer",
    "&:hover": {
        color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text.selected"),
        textDecoration: "none"
    },
    "&:active": {
        color: "#0055CC",
        li: {
            background: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.background.accent.blue.subtlest")
        }
    }
});
const $24c02ea0e14dbe4f$var$$3539883ac1727dfc$var$activeStyles = (0, $74Zh5.css)({
    color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text.selected")
});
const $24c02ea0e14dbe4f$var$$3539883ac1727dfc$var$iconStyles = (0, $74Zh5.css)({
    display: "inline-flex",
    alignItems: "center",
    marginLeft: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.050")
});
const $24c02ea0e14dbe4f$var$$e2bb601faa5fb56f$export$a24e9349d70a402 = ({ navRef: navRef })=>{
    const navWrapperTopPosition = (0, $5FkrB.useMemo)(()=>navRef.current?.getBoundingClientRect()?.y || 56, [
        navRef
    ]);
    const ref = (0, $5FkrB.useRef)(null);
    const { closeSlideMenu: closeSlideMenu, slideMenuContent: slideMenuContent, isSlideMenuOpen: isSlideMenuOpen, setContainerHeight: setContainerHeight } = $24c02ea0e14dbe4f$var$$ff532043ef39c56f$export$74d704c90f90362c();
    const { header: header, content: content } = slideMenuContent || {};
    const isTitleString = typeof header === "string";
    (0, $5FkrB.useEffect)(()=>{
        const element = ref.current;
        if (!element) return;
        const preventScroll = (e)=>{
            if (element.contains(e.target)) return;
            e.preventDefault();
        };
        element.addEventListener("wheel", preventScroll);
        element.addEventListener("touchmove", preventScroll);
        return ()=>{
            element.removeEventListener("wheel", preventScroll);
            element.removeEventListener("touchmove", preventScroll);
        };
    }, []);
    (0, $5FkrB.useEffect)(()=>{
        if (isSlideMenuOpen) setContainerHeight(ref.current?.getBoundingClientRect().height || "initial");
    // setContainerHeight intentionally excluded (stable setState function)
    /* eslint-disable react-hooks/exhaustive-deps */ }, [
        isSlideMenuOpen
    ]);
    /* eslint-enable react-hooks/exhaustive-deps */ return (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
        ref: ref,
        "data-testid": "slide-menu",
        css: [
            $24c02ea0e14dbe4f$var$$e2bb601faa5fb56f$var$menuStyles,
            (0, $74Zh5.css)({
                maxHeight: `calc(100vh - ${navWrapperTopPosition}px)`
            })
        ],
        "aria-hidden": !isSlideMenuOpen,
        children: [
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                css: $24c02ea0e14dbe4f$var$$e2bb601faa5fb56f$var$backButtonContainerStyles,
                children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$353f5b6fc5456de1, {
                    appearance: $24c02ea0e14dbe4f$export$261c9483fc4a455a.LINK,
                    onClick: closeSlideMenu,
                    iconBefore: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$f04a61298a47a40f, {
                        type: "chevron-left",
                        size: "medium"
                    }),
                    label: "Back"
                })
            }),
            header && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                css: [
                    !isTitleString && $24c02ea0e14dbe4f$var$$e2bb601faa5fb56f$var$headerStyles,
                    isTitleString && $24c02ea0e14dbe4f$var$$e2bb601faa5fb56f$var$titleStyles
                ],
                children: header
            }),
            content && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                css: $24c02ea0e14dbe4f$var$$e2bb601faa5fb56f$var$contentStyles,
                children: content
            })
        ]
    });
};
const $24c02ea0e14dbe4f$var$$e2bb601faa5fb56f$var$menuStyles = (0, $74Zh5.css)({
    position: "fixed",
    width: "375px",
    overflow: "auto",
    backgroundColor: "#FFFFFF",
    borderRadius: "8px",
    zIndex: 1000,
    padding: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.300"),
    top: 0,
    [(0, $cb8cedbc477f5a81$export$987d49ffe1b0900f).below.sm]: {
        transition: "transform 0.3s cubic-bezier(.4,1,.5,1), opacity 0.3s",
        transform: "translateX(-100%)",
        left: 0,
        width: "100vw"
    }
});
const $24c02ea0e14dbe4f$var$$e2bb601faa5fb56f$var$backButtonContainerStyles = (0, $74Zh5.css)({
    marginBottom: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.250"),
    "& button": {
        padding: 0,
        marginLeft: "-9px",
        fontWeight: 400
    }
});
const $24c02ea0e14dbe4f$var$$e2bb601faa5fb56f$var$headerStyles = (0, $74Zh5.css)({
    textTransform: "uppercase",
    marginLeft: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.100"),
    marginBottom: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.200"),
    "& > div": {
        fontSize: "12px",
        lineHeight: "16px",
        fontWeight: 600,
        fontFamily: "Charlie Text, sans-serif"
    }
});
const $24c02ea0e14dbe4f$var$$e2bb601faa5fb56f$var$titleStyles = (0, $74Zh5.css)({
    fontSize: "12px",
    lineHeight: "16px",
    fontWeight: 600,
    fontFamily: "Charlie Text, sans-serif",
    textTransform: "uppercase",
    marginBottom: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.150"),
    marginTop: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.400")
});
const $24c02ea0e14dbe4f$var$$e2bb601faa5fb56f$var$contentStyles = (0, $74Zh5.css)({
    display: "flex",
    flexDirection: "column",
    gap: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.150")
});
const $24c02ea0e14dbe4f$var$$25cbe9fdb2d8d071$var$DRAWER_WIDTH = 375;
const $24c02ea0e14dbe4f$var$$25cbe9fdb2d8d071$var$ToggleButton = ({ isOpen: isOpen, toggleMenu: toggleMenu })=>{
    const { closeSlideMenu: closeSlideMenu } = $24c02ea0e14dbe4f$var$$ff532043ef39c56f$export$74d704c90f90362c();
    const handleToggle = ()=>{
        toggleMenu();
        if (isOpen) closeSlideMenu();
    };
    return (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $0c4c08ddec83e35f$export$2e2bcd8739ae039), {
        appearance: "subtle",
        onClick: handleToggle,
        icon: isOpen ? $24c02ea0e14dbe4f$var$$6a34d18c8d59b475$export$2e2bcd8739ae039 : $24c02ea0e14dbe4f$var$$5ba5f450ff826a14$export$2e2bcd8739ae039,
        label: isOpen ? "Close menu" : "Open menu"
    });
};
const $24c02ea0e14dbe4f$export$214ae410b202e65a = ({ leftItems: leftItems, rightItems: rightItems, logoItem: logoItem, isSticky: isSticky = true, onMenuToggleClick: onMenuToggleClick, onMenuOutsideClick: onMenuOutsideClick })=>{
    // open state of mobile/tablet menu
    const [isMenuOpen, setIsMenuOpen] = (0, $5FkrB.useState)(false);
    // ref for the toggle button - necessary for the useOutsideClickHandler
    // useOutsideClickHandler will close menu IF the user clicks outside of the menu or toggle button (necessary to include toggle button prevent double-click)
    // separately, toggle button (close button) should also close the menu
    const toggleRef = (0, $5FkrB.useRef)(null);
    const handleToggle = ()=>{
        setIsMenuOpen(!isMenuOpen);
        if (onMenuToggleClick) onMenuToggleClick(isMenuOpen);
    };
    return (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("nav", {
        css: [
            $24c02ea0e14dbe4f$var$$25cbe9fdb2d8d071$var$containerStyles,
            !isSticky && $24c02ea0e14dbe4f$var$$25cbe9fdb2d8d071$var$stickyStyles
        ],
        "data-testid": "navbar",
        children: (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
            css: $24c02ea0e14dbe4f$var$$25cbe9fdb2d8d071$var$innerContainerStyles,
            children: [
                (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                    css: $24c02ea0e14dbe4f$var$$25cbe9fdb2d8d071$var$logoWrapperStyles,
                    children: logoItem
                }),
                (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                    css: $24c02ea0e14dbe4f$var$$25cbe9fdb2d8d071$var$navContentWrapperStyles,
                    children: (0, $6bec4f26b2cb3094$export$25062201e9e25d76)($24c02ea0e14dbe4f$var$$ff532043ef39c56f$export$f5c7f2da77f7e7fd, {
                        children: [
                            leftItems || rightItems ? (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                                css: $24c02ea0e14dbe4f$var$$25cbe9fdb2d8d071$var$navMenuToggleButtonStyles,
                                ref: toggleRef,
                                children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$var$$25cbe9fdb2d8d071$var$ToggleButton, {
                                    isOpen: isMenuOpen,
                                    toggleMenu: handleToggle
                                })
                            }) : null,
                            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$var$$25cbe9fdb2d8d071$var$DesktopNavItems, {
                                leftItems: leftItems,
                                rightItems: rightItems
                            }),
                            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$var$$25cbe9fdb2d8d071$var$SmallNavItems, {
                                isMenuOpen: isMenuOpen,
                                setIsMenuOpen: setIsMenuOpen,
                                onMenuOutsideClick: onMenuOutsideClick,
                                leftItems: leftItems,
                                rightItems: rightItems,
                                toggleRef: toggleRef
                            })
                        ]
                    })
                })
            ]
        })
    });
};
const $24c02ea0e14dbe4f$var$$25cbe9fdb2d8d071$var$MenuItems = ({ leftItems: leftItems, rightItems: rightItems })=>(0, $6bec4f26b2cb3094$export$25062201e9e25d76)((0, $6bec4f26b2cb3094$export$ffb0004e005737fa), {
        children: [
            leftItems?.map((item, index)=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("li", {
                    css: [
                        $24c02ea0e14dbe4f$var$$25cbe9fdb2d8d071$var$navItemWrapperStyles,
                        $24c02ea0e14dbe4f$var$$25cbe9fdb2d8d071$var$leftItemStyles
                    ],
                    role: "menuitem",
                    children: item
                }, `left-${index}`)),
            rightItems?.map((item, index)=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("li", {
                    css: [
                        $24c02ea0e14dbe4f$var$$25cbe9fdb2d8d071$var$navItemWrapperStyles,
                        $24c02ea0e14dbe4f$var$$25cbe9fdb2d8d071$var$rightItemStyles
                    ],
                    role: "menuitem",
                    children: item
                }, `right-${index}`))
        ]
    });
const $24c02ea0e14dbe4f$var$$25cbe9fdb2d8d071$var$DesktopNavItems = ({ leftItems: leftItems, rightItems: rightItems })=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("ul", {
        css: $24c02ea0e14dbe4f$var$$25cbe9fdb2d8d071$var$desktopNavWrapperStyles,
        role: "menubar",
        "aria-orientation": "horizontal",
        children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$var$$25cbe9fdb2d8d071$var$MenuItems, {
            leftItems: leftItems,
            rightItems: rightItems
        })
    });
const $24c02ea0e14dbe4f$var$$25cbe9fdb2d8d071$var$SmallNavItems = ({ isMenuOpen: isMenuOpen, setIsMenuOpen: setIsMenuOpen, onMenuOutsideClick: onMenuOutsideClick, leftItems: leftItems, rightItems: rightItems, toggleRef: toggleRef })=>{
    const navRef = (0, $5FkrB.useRef)(null);
    const menuRef = (0, $5FkrB.useRef)(null);
    const slideMenuWrapperRef = (0, $5FkrB.useRef)(null);
    const { isSlideMenuOpen: isSlideMenuOpen, containerHeight: containerHeight, closeSlideMenu: closeSlideMenu } = $24c02ea0e14dbe4f$var$$ff532043ef39c56f$export$74d704c90f90362c();
    $24c02ea0e14dbe4f$export$aa79b0abe3dfeaba([
        menuRef,
        slideMenuWrapperRef,
        toggleRef
    ], ()=>{
        if (isMenuOpen) {
            setIsMenuOpen(false);
            closeSlideMenu();
            if (onMenuOutsideClick) onMenuOutsideClick();
        }
    });
    return isMenuOpen ? (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
        ref: navRef,
        css: [
            $24c02ea0e14dbe4f$var$$25cbe9fdb2d8d071$var$smallNavWrapperStyles,
            isSlideMenuOpen && (0, $74Zh5.css)({
                height: containerHeight
            })
        ],
        children: [
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                ref: slideMenuWrapperRef,
                css: [
                    $24c02ea0e14dbe4f$var$$25cbe9fdb2d8d071$var$slideMenuStyles,
                    isSlideMenuOpen && $24c02ea0e14dbe4f$var$$25cbe9fdb2d8d071$var$slideMenuOpenStyles,
                    !isSlideMenuOpen && $24c02ea0e14dbe4f$var$$25cbe9fdb2d8d071$var$slideMenuClosedStyles
                ],
                children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$var$$e2bb601faa5fb56f$export$a24e9349d70a402, {
                    navRef: navRef
                })
            }),
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                css: [
                    $24c02ea0e14dbe4f$var$$25cbe9fdb2d8d071$var$smallNavContentWrapperStyles,
                    isSlideMenuOpen && $24c02ea0e14dbe4f$var$$25cbe9fdb2d8d071$var$smallNavContentShiftedStyles
                ],
                children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("ul", {
                    css: $24c02ea0e14dbe4f$var$$25cbe9fdb2d8d071$var$smallNavUlStyles,
                    ref: menuRef,
                    role: "menubar",
                    "aria-orientation": "vertical",
                    children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$var$$25cbe9fdb2d8d071$var$MenuItems, {
                        leftItems: leftItems,
                        rightItems: rightItems
                    })
                })
            })
        ]
    }) : null;
};
const $24c02ea0e14dbe4f$var$$25cbe9fdb2d8d071$var$navItemWrapperStyles = (0, $74Zh5.css)({
    height: "100%",
    alignSelf: "center",
    margin: "0 auto",
    padding: 0,
    [`@media (max-width: ${$24c02ea0e14dbe4f$var$$f0285f05d4d9f8a0$export$426e07cd0772984d.TABLET.MAX_WIDTH}px)`]: {
        "& > button": {
            width: "100%",
            justifyContent: "center"
        }
    }
});
const $24c02ea0e14dbe4f$var$$25cbe9fdb2d8d071$var$smallNavContentWrapperStyles = (0, $74Zh5.css)({
    position: "relative",
    transition: "transform 0.4s cubic-bezier(.5,1,.5,1)",
    zIndex: 1,
    borderRadius: "8px"
});
const $24c02ea0e14dbe4f$var$$25cbe9fdb2d8d071$var$slideMenuOpenStyles = (0, $74Zh5.css)({
    transform: "translateX(0)",
    opacity: 1,
    [`@media (max-width: ${$24c02ea0e14dbe4f$var$$f0285f05d4d9f8a0$export$426e07cd0772984d.MOBILE.MAX_WIDTH}px)`]: {
        transform: "translateX(100vw)",
        top: "56px"
    }
});
const $24c02ea0e14dbe4f$var$$25cbe9fdb2d8d071$var$slideMenuClosedStyles = (0, $74Zh5.css)({
    transform: "translateX(-100%)",
    opacity: 0,
    [`@media (max-width: ${$24c02ea0e14dbe4f$var$$f0285f05d4d9f8a0$export$426e07cd0772984d.MOBILE.MAX_WIDTH}px)`]: {
        transform: "translateX(-100vw)",
        top: "56px"
    }
});
const $24c02ea0e14dbe4f$var$$25cbe9fdb2d8d071$var$smallNavContentShiftedStyles = (0, $74Zh5.css)({
    transform: `translateX(${$24c02ea0e14dbe4f$var$$25cbe9fdb2d8d071$var$DRAWER_WIDTH}px)`,
    [`@media (max-width: ${$24c02ea0e14dbe4f$var$$f0285f05d4d9f8a0$export$426e07cd0772984d.MOBILE.MAX_WIDTH}px)`]: {
        transform: "translateX(100vw)"
    }
});
const $24c02ea0e14dbe4f$var$$25cbe9fdb2d8d071$var$slideMenuStyles = (0, $74Zh5.css)({
    position: "absolute",
    left: 0,
    top: 0,
    width: `${$24c02ea0e14dbe4f$var$$25cbe9fdb2d8d071$var$DRAWER_WIDTH}px`,
    height: "100%",
    zIndex: 2,
    transition: "height 0.7s cubic-bezier(0.22, 1, 0.36, 1), transform 0.4s cubic-bezier(.5,1,.5,1), opacity 0.2s",
    transform: "translateX(-100%)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    [`@media (max-width: ${$24c02ea0e14dbe4f$var$$f0285f05d4d9f8a0$export$426e07cd0772984d.MOBILE.MAX_WIDTH}px)`]: {
        width: "100vw",
        position: "fixed",
        borderRadius: 0,
        height: "100%"
    }
});
const $24c02ea0e14dbe4f$var$$25cbe9fdb2d8d071$var$containerStyles = (0, $74Zh5.css)({
    backgroundColor: "#FFFFFF",
    position: "sticky",
    width: "100%",
    height: "68px",
    left: 0,
    top: 0,
    padding: "0 16px",
    zIndex: 100,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    [`@media (max-width: ${$24c02ea0e14dbe4f$var$$f0285f05d4d9f8a0$export$426e07cd0772984d.TABLET.MAX_WIDTH}px)`]: {
        height: "56px",
        justifyContent: "space-between"
    }
});
const $24c02ea0e14dbe4f$var$$25cbe9fdb2d8d071$var$stickyStyles = (0, $74Zh5.css)({
    position: "fixed"
});
const $24c02ea0e14dbe4f$var$$25cbe9fdb2d8d071$var$innerContainerStyles = (0, $74Zh5.css)({
    display: "flex",
    alignItems: "center",
    width: "100%",
    maxWidth: "1232px",
    [`@media (min-width: ${$24c02ea0e14dbe4f$var$$f0285f05d4d9f8a0$export$426e07cd0772984d.DESKTOP.MIN_WIDTH}px)`]: {
        width: "1232px"
    }
});
const $24c02ea0e14dbe4f$var$$25cbe9fdb2d8d071$var$navContentWrapperStyles = (0, $74Zh5.css)({
    flex: 1,
    [`@media (max-width: ${$24c02ea0e14dbe4f$var$$f0285f05d4d9f8a0$export$426e07cd0772984d.TABLET.MAX_WIDTH}px)`]: {
        display: "flex",
        flexDirection: "column"
    }
});
const $24c02ea0e14dbe4f$var$$25cbe9fdb2d8d071$var$navMenuToggleButtonStyles = (0, $74Zh5.css)({
    flex: 0,
    alignSelf: "flex-end",
    [`@media (min-width: ${$24c02ea0e14dbe4f$var$$f0285f05d4d9f8a0$export$426e07cd0772984d.DESKTOP.MIN_WIDTH}px)`]: {
        display: "none"
    },
    button: {
        "&:hover, &:active": {
            backgroundColor: "transparent",
            color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.icon.brand")
        }
    }
});
const $24c02ea0e14dbe4f$var$$25cbe9fdb2d8d071$var$desktopNavWrapperStyles = (0, $74Zh5.css)({
    backgroundColor: "#FFFFFF",
    listStyle: "none",
    display: "none",
    flexDirection: "column",
    width: "100%",
    padding: "16px 12px",
    margin: 0,
    [`@media (min-width: ${$24c02ea0e14dbe4f$var$$f0285f05d4d9f8a0$export$426e07cd0772984d.DESKTOP.MIN_WIDTH}px)`]: {
        display: "block",
        position: "relative",
        gap: "8px",
        padding: 0,
        boxShadow: "none",
        height: "42px"
    }
});
// mobile/tablet open menu
const $24c02ea0e14dbe4f$var$$25cbe9fdb2d8d071$var$smallNavWrapperStyles = (0, $74Zh5.css)({
    backgroundColor: "#FFFFFF",
    position: "absolute",
    right: 0,
    margin: 0,
    width: "100%",
    zIndex: 1000,
    overflow: "hidden",
    transition: "height 0.4s cubic-bezier(.5,1,.5,1)",
    [`@media (max-width: ${$24c02ea0e14dbe4f$var$$f0285f05d4d9f8a0$export$426e07cd0772984d.MOBILE.MAX_WIDTH}px)`]: {
        // full screen menu in mobile view
        height: "100%",
        position: "fixed",
        right: 0,
        top: 0,
        marginTop: "56px"
    },
    [`@media ((min-width: ${$24c02ea0e14dbe4f$var$$f0285f05d4d9f8a0$export$426e07cd0772984d.TABLET.MIN_WIDTH}px) and (max-width: ${$24c02ea0e14dbe4f$var$$f0285f05d4d9f8a0$export$426e07cd0772984d.TABLET.MAX_WIDTH}px))`]: {
        // appearance of floating fixed-width menu in tablet view
        width: `${$24c02ea0e14dbe4f$var$$25cbe9fdb2d8d071$var$DRAWER_WIDTH}px`,
        top: "100%",
        marginTop: "-9px",
        marginRight: "20px",
        borderRadius: "8px",
        boxShadow: "0 0 1px 0 #ccc,0 5px 20px -5px rgba(0,0,0,.1)"
    },
    [`@media (min-width: ${$24c02ea0e14dbe4f$var$$f0285f05d4d9f8a0$export$426e07cd0772984d.DESKTOP.MIN_WIDTH}px)`]: {
        display: "none"
    }
});
const $24c02ea0e14dbe4f$var$$25cbe9fdb2d8d071$var$smallNavUlStyles = (0, $74Zh5.css)({
    display: "flex",
    flexDirection: "column",
    gap: "16px",
    listStyle: "none",
    padding: "16px 0"
});
const $24c02ea0e14dbe4f$var$$25cbe9fdb2d8d071$var$logoWrapperStyles = (0, $74Zh5.css)({
    margin: 0,
    padding: 0,
    paddingRight: "32px",
    flexShrink: 0,
    flexGrow: 0
});
const $24c02ea0e14dbe4f$var$$25cbe9fdb2d8d071$var$leftItemStyles = (0, $74Zh5.css)({
    [`@media (max-width: ${$24c02ea0e14dbe4f$var$$f0285f05d4d9f8a0$export$426e07cd0772984d.TABLET.MAX_WIDTH}px)`]: {
        alignSelf: "flex-start",
        width: "100%"
    },
    [`@media (min-width: ${$24c02ea0e14dbe4f$var$$f0285f05d4d9f8a0$export$426e07cd0772984d.DESKTOP.MIN_WIDTH}px)`]: {
        float: "left",
        marginRight: "8px"
    }
});
const $24c02ea0e14dbe4f$var$$25cbe9fdb2d8d071$var$rightItemStyles = (0, $74Zh5.css)({
    [`@media (max-width: ${$24c02ea0e14dbe4f$var$$f0285f05d4d9f8a0$export$426e07cd0772984d.TABLET.MAX_WIDTH}px)`]: {
        width: "100%"
    },
    [`@media (min-width: ${$24c02ea0e14dbe4f$var$$f0285f05d4d9f8a0$export$426e07cd0772984d.DESKTOP.MIN_WIDTH}px)`]: {
        float: "right"
    }
});
var $24c02ea0e14dbe4f$var$$9efbb38deb40219f$exports = {};
$24c02ea0e14dbe4f$var$$parcel$defineInteropFlag($24c02ea0e14dbe4f$var$$9efbb38deb40219f$exports);
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$9efbb38deb40219f$exports, "NavigationBarWithProfile", ()=>$24c02ea0e14dbe4f$export$fddd19fbf4d591d8);
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$9efbb38deb40219f$exports, "default", ()=>$24c02ea0e14dbe4f$var$$9efbb38deb40219f$export$2e2bcd8739ae039);
/**
 * This file contains the sub-components that are wrapped with the OnClickWrapper component to send analytics events
 * with the relevant payload attributes.
 */ const $24c02ea0e14dbe4f$var$$d97d6cd9a58d7e95$export$bb065923b9250b7b = ({ ...rest })=>{
    return (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$e76239e22e3abad, {
        ...rest
    });
};
/**
 * This is a wrapper component that allows passing in an onClick handler to a div. It can be used to wrap components
 * that are meant to be clicked (e.g. buttons and links), for additional click handling.
 */ const $24c02ea0e14dbe4f$var$$d153af7a71e64fa7$export$9c92f94f6e99bc1a = ({ children: children, onClick: onClick })=>{
    const noOp = ()=>{};
    const handleKeyDown = $24c02ea0e14dbe4f$export$2a0b6757d41dacb2(onClick || noOp);
    return (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("span", {
        role: "button",
        tabIndex: 0,
        onClick: onClick,
        onKeyDown: onClick ? handleKeyDown : undefined,
        children: children
    });
};
const $24c02ea0e14dbe4f$var$$341f96d5922d8aaa$export$68280dacbbcb94bd = (payload, analyticsInfo)=>{
    return {
        ...payload,
        source: "communityNavigation",
        attributes: {
            ...payload.attributes || {},
            currentApp: analyticsInfo.currentApp,
            isLoggedIn: analyticsInfo.isLoggedIn,
            isNavMobileOrTablet: analyticsInfo.isMobileOrTablet
        }
    };
};
const $24c02ea0e14dbe4f$var$$341f96d5922d8aaa$export$5aa64ab1f07d6e00 = ({ analyticsInfo: analyticsInfo, subtitleHref: subtitleHref, ...rest })=>{
    const getSendEventFn = (analyticsInfo)=>()=>{
            analyticsInfo.onAnalyticsSendEvent($24c02ea0e14dbe4f$export$3d7865934588d77e.UI, $24c02ea0e14dbe4f$var$$341f96d5922d8aaa$export$68280dacbbcb94bd({
                action: "clicked",
                actionSubject: "logo",
                actionSubjectId: "communityNavigationHome",
                attributes: {
                    href: subtitleHref,
                    destinationApp: $24c02ea0e14dbe4f$export$93d048dc21eb282a.HOME
                }
            }, analyticsInfo), $24c02ea0e14dbe4f$export$d778a884eb401313.NAV_LOGO_CLICK);
        };
    return (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$var$$d153af7a71e64fa7$export$9c92f94f6e99bc1a, {
        onClick: analyticsInfo && getSendEventFn(analyticsInfo),
        children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$6ce3be5638d8e2a, {
            subtitleHref: subtitleHref,
            ...rest
        })
    });
};
const $24c02ea0e14dbe4f$var$$341f96d5922d8aaa$export$b18dbc162161ec9c = ({ analyticsInfo: analyticsInfo, destinationApp: destinationApp, link: link, ...rest })=>{
    const getSendEventFn = (analyticsInfo)=>()=>{
            analyticsInfo.onAnalyticsSendEvent($24c02ea0e14dbe4f$export$3d7865934588d77e.UI, $24c02ea0e14dbe4f$var$$341f96d5922d8aaa$export$68280dacbbcb94bd({
                action: "clicked",
                actionSubject: "link",
                actionSubjectId: "communityNavigationLink",
                attributes: {
                    href: link.href,
                    label: link.text,
                    destinationApp: destinationApp
                }
            }, analyticsInfo), $24c02ea0e14dbe4f$export$d778a884eb401313.NAV_ITEM_CLICK);
        };
    return (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$var$$d153af7a71e64fa7$export$9c92f94f6e99bc1a, {
        onClick: analyticsInfo && getSendEventFn(analyticsInfo),
        children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$var$$d97d6cd9a58d7e95$export$bb065923b9250b7b, {
            link: link,
            destinationApp: destinationApp,
            ...rest
        })
    });
};
const $24c02ea0e14dbe4f$var$$341f96d5922d8aaa$var$loginSignupWrapperStyles = (isMobile)=>isMobile ? (0, $74Zh5.css)({
        padding: "0 24px"
    }) : undefined;
const $24c02ea0e14dbe4f$var$$341f96d5922d8aaa$var$loginButtonStyles = (isMobile)=>isMobile ? (0, $74Zh5.css)({
        button: {
            width: "100%",
            borderRadius: "0.25rem",
            borderStyle: "solid",
            borderWidth: "1px",
            fontSize: "1rem",
            fontWeight: 600,
            fontFamily: "Charlie Text",
            color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text.brand"),
            borderColor: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.border.brand"),
            "&:active": {
                backgroundColor: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.background.selected.bold.pressed"),
                borderColor: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.border.selected"),
                color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text.inverse")
            },
            "&:hover": {
                backgroundColor: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.background.selected.bold.hovered"),
                borderColor: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.border.selected"),
                color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text.inverse"),
                textDecoration: "none"
            }
        }
    }) : (0, $74Zh5.css)({
        button: {
            fontWeight: 650,
            fontFamily: "Charlie Text",
            fontSize: "1rem",
            color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text"),
            width: "auto",
            "&:hover": {
                backgroundColor: "transparent",
                color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text.brand"),
                textDecoration: "none"
            }
        }
    });
const $24c02ea0e14dbe4f$var$$341f96d5922d8aaa$var$signupButtonStyles = (isMobile)=>(0, $74Zh5.css)({
        button: {
            fontWeight: 550,
            fontFamily: "Charlie Text",
            fontSize: "1rem",
            width: isMobile ? "100%" : "auto"
        }
    });
const $24c02ea0e14dbe4f$var$$341f96d5922d8aaa$export$c421b2a9819014e7 = ({ href: href, analyticsInfo: analyticsInfo, isMobile: isMobile = false })=>{
    const getSendEventFn = (analyticsInfo)=>()=>{
            analyticsInfo.onAnalyticsSendEvent($24c02ea0e14dbe4f$export$3d7865934588d77e.UI, $24c02ea0e14dbe4f$var$$341f96d5922d8aaa$export$68280dacbbcb94bd({
                action: "clicked",
                actionSubject: "button",
                actionSubjectId: "communityNavigationLogin",
                attributes: {
                    href: href
                }
            }, analyticsInfo), $24c02ea0e14dbe4f$export$d778a884eb401313.LOG_IN_CLICK);
        };
    return (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$var$$d153af7a71e64fa7$export$9c92f94f6e99bc1a, {
        onClick: analyticsInfo && getSendEventFn(analyticsInfo),
        children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
            css: $24c02ea0e14dbe4f$var$$341f96d5922d8aaa$var$loginSignupWrapperStyles(isMobile),
            children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("a", {
                css: $24c02ea0e14dbe4f$var$$341f96d5922d8aaa$var$loginButtonStyles(isMobile),
                href: href,
                children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $123ba5aab151a241$export$2e2bcd8739ae039), {
                    appearance: "subtle",
                    children: $24c02ea0e14dbe4f$var$$1ff01338112cd7fe$export$46dbfbdf99745111
                })
            })
        })
    });
};
const $24c02ea0e14dbe4f$var$$341f96d5922d8aaa$export$5f193ccad31822c4 = ({ href: href, analyticsInfo: analyticsInfo, isMobile: isMobile = false })=>{
    const getSendEventFn = (analyticsInfo)=>()=>{
            analyticsInfo.onAnalyticsSendEvent($24c02ea0e14dbe4f$export$3d7865934588d77e.UI, $24c02ea0e14dbe4f$var$$341f96d5922d8aaa$export$68280dacbbcb94bd({
                action: "clicked",
                actionSubject: "button",
                actionSubjectId: "communityNavigationSignup",
                attributes: {
                    href: href
                }
            }, analyticsInfo), $24c02ea0e14dbe4f$export$d778a884eb401313.SIGN_UP_CLICK);
        };
    return (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$var$$d153af7a71e64fa7$export$9c92f94f6e99bc1a, {
        onClick: analyticsInfo && getSendEventFn(analyticsInfo),
        children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
            css: $24c02ea0e14dbe4f$var$$341f96d5922d8aaa$var$loginSignupWrapperStyles(isMobile),
            children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("a", {
                css: $24c02ea0e14dbe4f$var$$341f96d5922d8aaa$var$signupButtonStyles(isMobile),
                href: href,
                children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $123ba5aab151a241$export$2e2bcd8739ae039), {
                    appearance: "primary",
                    children: $24c02ea0e14dbe4f$var$$1ff01338112cd7fe$export$4fe37309c24221ae
                })
            })
        })
    });
};
const $24c02ea0e14dbe4f$var$$341f96d5922d8aaa$export$55b351f575b2f75b = ({ analyticsInfo: analyticsInfo, ...rest })=>{
    const getSendEventFn = (analyticsInfo)=>(isMenuOpen)=>{
            analyticsInfo.onAnalyticsSendEvent($24c02ea0e14dbe4f$export$3d7865934588d77e.UI, $24c02ea0e14dbe4f$var$$341f96d5922d8aaa$export$68280dacbbcb94bd({
                action: "clicked",
                actionSubject: "button",
                actionSubjectId: !isMenuOpen ? "communityNavigationProfileMenuOpen" : "communityNavigationProfileMenuClose"
            }, analyticsInfo), !isMenuOpen ? $24c02ea0e14dbe4f$export$d778a884eb401313.PROFILE_MENU_OPEN : $24c02ea0e14dbe4f$export$d778a884eb401313.PROFILE_MENU_CLOSE);
        };
    return (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$1cba3806e1f1b01d, {
        onProfileMenuClick: analyticsInfo && getSendEventFn(analyticsInfo),
        ...rest
    });
};
const $24c02ea0e14dbe4f$export$92905cc84b82619c = ({ analyticsInfo: analyticsInfo, link: link, type: type, ...rest })=>{
    const getSendEventFn = (analyticsInfo)=>()=>{
            analyticsInfo.onAnalyticsSendEvent($24c02ea0e14dbe4f$export$3d7865934588d77e.UI, $24c02ea0e14dbe4f$var$$341f96d5922d8aaa$export$68280dacbbcb94bd({
                action: "clicked",
                actionSubject: "button",
                actionSubjectId: "communityNavigationMenuItem",
                attributes: {
                    href: link.href,
                    label: link.text,
                    menuItemId: link.id
                }
            }, analyticsInfo), $24c02ea0e14dbe4f$export$d778a884eb401313.PROFILE_MENU_ITEM_CLICK);
        };
    return (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$var$$d153af7a71e64fa7$export$9c92f94f6e99bc1a, {
        onClick: analyticsInfo && getSendEventFn(analyticsInfo),
        children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$2ce376c2cc3355c8, {
            type: type,
            link: link,
            ...rest
        })
    });
};
const $24c02ea0e14dbe4f$var$$341f96d5922d8aaa$export$86a131c9ca6f534a = ({ analyticsInfo: analyticsInfo, ...rest })=>{
    // event when clicking on the menu toggle button in mobile/tablet view
    const getSendEventMenuToggleFn = (analyticsInfo)=>(isMenuOpen)=>{
            analyticsInfo.onAnalyticsSendEvent($24c02ea0e14dbe4f$export$3d7865934588d77e.UI, $24c02ea0e14dbe4f$var$$341f96d5922d8aaa$export$68280dacbbcb94bd({
                action: "clicked",
                actionSubject: "button",
                actionSubjectId: !isMenuOpen ? "communityNavigationMobileMenuOpen" : "communityNavigationMobileMenuClose"
            }, analyticsInfo), !isMenuOpen ? $24c02ea0e14dbe4f$export$d778a884eb401313.MOBILE_MENU_OPEN : $24c02ea0e14dbe4f$export$d778a884eb401313.MOBILE_MENU_CLOSE);
        };
    // event when clicking outside of the menu in mobile/tablet view, which closes the menu
    const getSendEventOutsideClickFn = (analyticsInfo)=>()=>{
            analyticsInfo.onAnalyticsSendEvent($24c02ea0e14dbe4f$export$3d7865934588d77e.UI, $24c02ea0e14dbe4f$var$$341f96d5922d8aaa$export$68280dacbbcb94bd({
                action: "clicked",
                actionSubject: "component",
                actionSubjectId: "communityNavigationMobileMenuClose"
            }, analyticsInfo), $24c02ea0e14dbe4f$export$d778a884eb401313.MOBILE_MENU_CLOSE);
        };
    return (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$214ae410b202e65a, {
        onMenuToggleClick: analyticsInfo && getSendEventMenuToggleFn(analyticsInfo),
        onMenuOutsideClick: analyticsInfo && getSendEventOutsideClickFn(analyticsInfo),
        ...rest
    });
};
const $24c02ea0e14dbe4f$var$$9efbb38deb40219f$var$getUserDisplayMenuContent = (logoutHref, type, profileHref, settingsHref, switchHref, analyticsInfo)=>{
    const subMenuItems = [];
    if (profileHref) subMenuItems.push({
        ...$24c02ea0e14dbe4f$var$$1ff01338112cd7fe$export$668d072b293d5f38.PROFILE,
        href: profileHref
    });
    if (settingsHref) subMenuItems.push({
        ...$24c02ea0e14dbe4f$var$$1ff01338112cd7fe$export$668d072b293d5f38.SETTINGS,
        href: settingsHref
    });
    if (switchHref) subMenuItems.push({
        ...$24c02ea0e14dbe4f$var$$1ff01338112cd7fe$export$668d072b293d5f38.SWITCH_ACCOUNT,
        href: switchHref
    });
    if (logoutHref) subMenuItems.push({
        ...$24c02ea0e14dbe4f$var$$1ff01338112cd7fe$export$668d072b293d5f38.LOG_OUT,
        href: logoutHref
    });
    return (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $6bec4f26b2cb3094$export$ffb0004e005737fa), {
        children: subMenuItems.map((item, index)=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$92905cc84b82619c, {
                link: item,
                type: type,
                analyticsInfo: analyticsInfo
            }, `${item.text}-${index}`))
    });
};
const $24c02ea0e14dbe4f$export$fddd19fbf4d591d8 = ({ logoItem: logoItem, leftItems: leftItems, isLoggedIn: isLoggedIn, user: user, loginHref: loginHref, signupHref: signupHref, logoutHref: logoutHref, switchHref: switchHref, profileHref: profileHref, settingsHref: settingsHref, onAnalyticsSendEvent: onAnalyticsSendEvent, isSticky: isSticky = true, showNewMenu: showNewMenu = false, currentApp: currentApp = "unknown" })=>{
    const isMobileOrTablet = $24c02ea0e14dbe4f$export$32d5543ab307c01(`(max-width: ${$24c02ea0e14dbe4f$var$$f0285f05d4d9f8a0$export$426e07cd0772984d.TABLET.MAX_WIDTH}px)`);
    // Set up analytics info
    const analyticsInfo = onAnalyticsSendEvent ? {
        currentApp: currentApp,
        isLoggedIn: isLoggedIn,
        isMobileOrTablet: isMobileOrTablet,
        onAnalyticsSendEvent: onAnalyticsSendEvent
    } : undefined;
    // Render right items based on login state
    const rightItems = [];
    if (isLoggedIn && user) rightItems.push((0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$var$$341f96d5922d8aaa$export$55b351f575b2f75b, {
        user: user,
        expandableMenuContent: $24c02ea0e14dbe4f$var$$9efbb38deb40219f$var$getUserDisplayMenuContent(logoutHref, showNewMenu ? "menuItem" : "subMenu", profileHref, settingsHref, switchHref, analyticsInfo),
        profileMenuContent: $24c02ea0e14dbe4f$var$$9efbb38deb40219f$var$getUserDisplayMenuContent(logoutHref, "profile", profileHref, settingsHref, switchHref, analyticsInfo),
        analyticsInfo: analyticsInfo,
        showNewMenu: showNewMenu
    }));
    else if (isMobileOrTablet) rightItems.push((0, $6bec4f26b2cb3094$export$25062201e9e25d76)((0, $bdfb9b3a36dcb2bb$export$2e2bcd8739ae039), {
        space: "space.100",
        children: [
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$var$$341f96d5922d8aaa$export$c421b2a9819014e7, {
                href: loginHref,
                analyticsInfo: analyticsInfo,
                isMobile: isMobileOrTablet
            }),
            signupHref && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$var$$341f96d5922d8aaa$export$5f193ccad31822c4, {
                href: signupHref,
                analyticsInfo: analyticsInfo,
                isMobile: isMobileOrTablet
            })
        ]
    }));
    else rightItems.push((0, $6bec4f26b2cb3094$export$25062201e9e25d76)((0, $0c22dfc1af284338$export$2e2bcd8739ae039), {
        space: "space.100",
        children: [
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$var$$341f96d5922d8aaa$export$c421b2a9819014e7, {
                href: loginHref,
                analyticsInfo: analyticsInfo
            }),
            signupHref && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$var$$341f96d5922d8aaa$export$5f193ccad31822c4, {
                href: signupHref,
                analyticsInfo: analyticsInfo
            })
        ]
    }));
    return (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$var$$341f96d5922d8aaa$export$86a131c9ca6f534a, {
        logoItem: logoItem,
        leftItems: leftItems,
        rightItems: rightItems,
        analyticsInfo: analyticsInfo,
        isSticky: isSticky
    });
};
var $24c02ea0e14dbe4f$var$$9efbb38deb40219f$export$2e2bcd8739ae039 = $24c02ea0e14dbe4f$export$fddd19fbf4d591d8;
var $24c02ea0e14dbe4f$var$$3fbcb32390ca7008$exports = {};
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$3fbcb32390ca7008$exports, "RadioType", ()=>$24c02ea0e14dbe4f$export$f5eff9f4cffe1e46);
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$3fbcb32390ca7008$exports, "RadioSize", ()=>$24c02ea0e14dbe4f$export$4da24539a3bb7d98);
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$3fbcb32390ca7008$exports, "Radio", ()=>$24c02ea0e14dbe4f$export$d7b12c4107be0d61);
let $24c02ea0e14dbe4f$export$f5eff9f4cffe1e46;
(function(RadioType) {
    RadioType["DEFAULT"] = "DEFAULT";
    RadioType[/** TODO: remove success styles in scope of the QUIZ component update */ "SUCCESS"] = "SUCCESS";
    RadioType["DANGER"] = "DANGER";
    RadioType["DISABLED"] = "DISABLED";
})($24c02ea0e14dbe4f$export$f5eff9f4cffe1e46 || ($24c02ea0e14dbe4f$export$f5eff9f4cffe1e46 = {}));
let $24c02ea0e14dbe4f$export$4da24539a3bb7d98;
(function(RadioSize) {
    RadioSize["DEFAULT"] = "DEFAULT";
    RadioSize["LARGE"] = "LARGE";
})($24c02ea0e14dbe4f$export$4da24539a3bb7d98 || ($24c02ea0e14dbe4f$export$4da24539a3bb7d98 = {}));
const $24c02ea0e14dbe4f$export$d7b12c4107be0d61 = ({ label: label = "", name: name, isChecked: isChecked, setIsChecked: setIsChecked, type: type = $24c02ea0e14dbe4f$export$f5eff9f4cffe1e46.DEFAULT, size: size = $24c02ea0e14dbe4f$export$4da24539a3bb7d98.DEFAULT, isRequired: isRequired = false, isBold: isBold, tabIndex: tabIndex = 0 })=>{
    const handleChange = (0, $5FkrB.useCallback)(()=>{
        setIsChecked(!isChecked);
    }, [
        isChecked,
        setIsChecked
    ]);
    const handleKeyDown = $24c02ea0e14dbe4f$export$2a0b6757d41dacb2(handleChange);
    const labelAndInputConnection = name ? `${name}-${label?.toLowerCase().replace(/\s+/g, "-")}` + "-radio-input" : label?.toLowerCase().replace(/\s+/g, "-") + "-radio-input";
    return (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
        css: [
            $24c02ea0e14dbe4f$var$$3fbcb32390ca7008$var$radioContainerStyles,
            size === $24c02ea0e14dbe4f$export$4da24539a3bb7d98.LARGE && (0, $74Zh5.css)({
                columnGap: "8px"
            })
        ],
        children: (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("label", {
            htmlFor: labelAndInputConnection,
            css: [
                $24c02ea0e14dbe4f$var$$3fbcb32390ca7008$var$labelStyles,
                size === $24c02ea0e14dbe4f$export$4da24539a3bb7d98.LARGE && $24c02ea0e14dbe4f$var$$3fbcb32390ca7008$var$labelLargeStyles,
                type === $24c02ea0e14dbe4f$export$f5eff9f4cffe1e46.DISABLED && $24c02ea0e14dbe4f$var$$3fbcb32390ca7008$var$variantClasses.label.DISABLED,
                isBold && (0, $74Zh5.css)({
                    fontWeight: 700
                }),
                !isBold && (0, $74Zh5.css)({
                    fontWeight: 400
                })
            ],
            children: [
                (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("input", {
                    "data-testid": "radio-input",
                    name: name,
                    tabIndex: -1,
                    id: labelAndInputConnection,
                    type: "radio",
                    css: $24c02ea0e14dbe4f$var$$3fbcb32390ca7008$var$inputStyles,
                    checked: isChecked,
                    onChange: (e)=>setIsChecked(e.currentTarget.checked),
                    "aria-checked": isChecked
                }),
                (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$e61786c4aee8d415, {
                    children: label
                }),
                (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("span", {
                    role: "radio",
                    "aria-checked": isChecked,
                    "aria-label": label,
                    tabIndex: tabIndex,
                    onKeyDown: handleKeyDown,
                    css: [
                        $24c02ea0e14dbe4f$var$$3fbcb32390ca7008$var$variantClasses.checkbox[type],
                        $24c02ea0e14dbe4f$var$$3fbcb32390ca7008$var$checkmarkStyles,
                        size === $24c02ea0e14dbe4f$export$4da24539a3bb7d98.LARGE && $24c02ea0e14dbe4f$var$$3fbcb32390ca7008$var$checkmarkLargeStyles,
                        isChecked && $24c02ea0e14dbe4f$var$$3fbcb32390ca7008$var$checkedCheckmarkStyles,
                        isChecked && type === $24c02ea0e14dbe4f$export$f5eff9f4cffe1e46.DANGER && (0, $74Zh5.css)({
                            backgroundColor: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.border.danger")
                        })
                    ]
                }),
                isRequired && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("span", {
                    css: [
                        $24c02ea0e14dbe4f$var$$3fbcb32390ca7008$var$requiredMarkStyles,
                        size === $24c02ea0e14dbe4f$export$4da24539a3bb7d98.LARGE && (0, $74Zh5.css)({
                            marginLeft: "4px"
                        })
                    ],
                    children: "*"
                })
            ]
        })
    });
};
const $24c02ea0e14dbe4f$var$$3fbcb32390ca7008$var$radioContainerStyles = (0, $74Zh5.css)({
    display: "flex",
    columnGap: "6px"
});
const $24c02ea0e14dbe4f$var$$3fbcb32390ca7008$var$requiredMarkStyles = (0, $74Zh5.css)({
    color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text.subtle"),
    marginLeft: "2px"
});
const $24c02ea0e14dbe4f$var$$3fbcb32390ca7008$var$inputStyles = (0, $74Zh5.css)({
    position: "absolute",
    height: 0,
    width: 0,
    opacity: 0,
    cursor: "pointer"
});
const $24c02ea0e14dbe4f$var$$3fbcb32390ca7008$var$checkmarkStyles = (0, $74Zh5.css)({
    position: "absolute",
    top: 0,
    left: 0,
    width: "16px",
    height: "16px",
    marginTop: "2px",
    backgroundColor: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.background.input"),
    borderRadius: "50%",
    border: `1px solid ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.border.input")}`,
    cursor: "pointer",
    "&:after": {
        content: '""',
        position: "absolute",
        display: "none"
    },
    [(0, $cb8cedbc477f5a81$export$987d49ffe1b0900f).below.xs]: {
        marginTop: "4px"
    }
});
const $24c02ea0e14dbe4f$var$$3fbcb32390ca7008$var$checkmarkLargeStyles = (0, $74Zh5.css)({
    width: "20px",
    height: "20px",
    marginRight: "8px",
    marginTop: "6px",
    "&:after": {
        left: "5px !important",
        top: "5px !important",
        width: "8px !important",
        height: "8px !important"
    }
});
const $24c02ea0e14dbe4f$var$$3fbcb32390ca7008$var$checkedCheckmarkStyles = (0, $74Zh5.css)({
    backgroundColor: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.background.selected.bold"),
    borderColor: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.border.selected"),
    "&:after": {
        display: "block",
        left: "4px",
        top: "4px",
        width: "6px",
        height: "6px",
        borderRadius: "50%",
        backgroundColor: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.background.input")
    }
});
const $24c02ea0e14dbe4f$var$$3fbcb32390ca7008$var$labelStyles = (0, $74Zh5.css)({
    display: "flex",
    position: "relative",
    paddingLeft: "22px",
    userSelect: "none",
    color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text"),
    fontFamily: "Inter, sans-serif",
    fontSize: "16px",
    fontWeight: 400,
    lineHeight: "22px"
});
const $24c02ea0e14dbe4f$var$$3fbcb32390ca7008$var$labelLargeStyles = (0, $74Zh5.css)({
    paddingLeft: "28px",
    fontSize: "20px",
    lineHeight: "32px"
});
const $24c02ea0e14dbe4f$var$$3fbcb32390ca7008$var$variantClasses = {
    label: {
        DISABLED: (0, $74Zh5.css)({
            pointerEvents: "none",
            opacity: "31%"
        })
    },
    checkbox: {
        DEFAULT: (0, $74Zh5.css)({
            ":hover": {
                borderColor: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.border.selected")
            }
        }),
        SUCCESS: (0, $74Zh5.css)({
            ":hover": {
                borderColor: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.border.selected")
            }
        }),
        DANGER: (0, $74Zh5.css)({
            "&, &:hover": {
                borderColor: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.border.danger")
            }
        }),
        DISABLED: (0, $74Zh5.css)({
            pointerEvents: "none",
            opacity: "31%"
        })
    }
};
var $24c02ea0e14dbe4f$var$$731a4fd527bab680$exports = {};
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$731a4fd527bab680$exports, "TabsSize", ()=>$24c02ea0e14dbe4f$export$ddadc1228c8dcfa);
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$731a4fd527bab680$exports, "Tab", ()=>$24c02ea0e14dbe4f$export$3e41faf802a29e71);
let $24c02ea0e14dbe4f$export$ddadc1228c8dcfa;
(function(TabsSize) {
    TabsSize["SMALL"] = "small";
    TabsSize["MEDIUM"] = "medium";
    TabsSize["LARGE"] = "large";
})($24c02ea0e14dbe4f$export$ddadc1228c8dcfa || ($24c02ea0e14dbe4f$export$ddadc1228c8dcfa = {}));
const $24c02ea0e14dbe4f$export$3e41faf802a29e71 = ({ label: label, labelColor: labelColor = (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text"), labelColorSelected: labelColorSelected = (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text.inverse"), labelColorSelectedHover: labelColorSelectedHover = (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text.inverse"), onClick: onClick, iconBefore: iconBefore, iconAfter: iconAfter, size: size = $24c02ea0e14dbe4f$export$ddadc1228c8dcfa.MEDIUM, selected: selected = false, selectedColor: selectedColor, selectedHoverColor: selectedHoverColor, isLoading: isLoading })=>{
    const clickHandler = (0, $5FkrB.useCallback)((e)=>{
        if (onClick) onClick(e);
    }, [
        onClick
    ]);
    return (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("button", {
        tabIndex: 0,
        onClick: clickHandler,
        "data-testid": `tab${selected ? "-selected" : ""}`,
        css: [
            $24c02ea0e14dbe4f$var$$731a4fd527bab680$var$tabStyles["basic"],
            selected && $24c02ea0e14dbe4f$var$$731a4fd527bab680$var$tabStyles["selected"],
            !iconBefore && !iconAfter && $24c02ea0e14dbe4f$var$$731a4fd527bab680$var$tabSpacingStyles[size],
            iconBefore && $24c02ea0e14dbe4f$var$$731a4fd527bab680$var$tabSpacingStyles[`${size}-icon-before`],
            iconAfter && $24c02ea0e14dbe4f$var$$731a4fd527bab680$var$tabSpacingStyles[`${size}-icon-after`],
            labelColor && !selected && (0, $74Zh5.css)({
                color: labelColor
            }),
            labelColorSelected && selected && (0, $74Zh5.css)({
                color: labelColorSelected
            }),
            labelColorSelectedHover && selected && (0, $74Zh5.css)({
                "&:hover": {
                    color: labelColorSelectedHover
                }
            }),
            selected && selectedColor && (0, $74Zh5.css)({
                backgroundColor: selectedColor,
                borderColor: selectedColor
            }),
            selected && selectedHoverColor && (0, $74Zh5.css)({
                "&:hover": {
                    backgroundColor: selectedHoverColor,
                    borderColor: selectedHoverColor
                }
            })
        ],
        children: [
            iconBefore && !isLoading && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("span", {
                css: [
                    $24c02ea0e14dbe4f$var$$731a4fd527bab680$var$tabIconContainerStyles,
                    (0, $74Zh5.css)({
                        marginRight: "0.25rem"
                    })
                ],
                children: iconBefore
            }),
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("span", {
                css: [
                    isLoading && (0, $74Zh5.css)({
                        marginRight: "0.5rem"
                    })
                ],
                children: label
            }),
            iconAfter && !isLoading && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("span", {
                css: [
                    $24c02ea0e14dbe4f$var$$731a4fd527bab680$var$tabIconContainerStyles,
                    (0, $74Zh5.css)({
                        marginLeft: "0.25rem"
                    })
                ],
                children: iconAfter
            })
        ]
    });
};
const $24c02ea0e14dbe4f$var$$731a4fd527bab680$var$tabStyles = {
    basic: (0, $74Zh5.css)({
        display: "flex",
        alignItems: "center",
        whiteSpace: "nowrap",
        borderRadius: "3.125rem",
        fontFamily: "Charlie Display, sans-serif",
        fontSize: "1.25rem",
        fontWeight: 600,
        lineHeight: "1.75rem",
        color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text"),
        border: `0.125rem solid ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.border")}`,
        cursor: "pointer",
        outline: "none",
        background: "transparent",
        [(0, $cb8cedbc477f5a81$export$987d49ffe1b0900f).below.xs]: {
            fontSize: "1rem",
            lineHeight: "1.5rem",
            padding: "0.5rem 1rem"
        },
        "&:hover": {
            backgroundColor: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.background.accent.gray.subtlest"),
            borderColor: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.border"),
            color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text")
        },
        "&:focus-visible": {
            border: `2px solid ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.border.selected")}`
        }
    }),
    selected: (0, $74Zh5.css)({
        backgroundColor: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.background.neutral.bold.pressed"),
        color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text.inverse"),
        border: "0.125rem solid",
        "&:hover": {
            backgroundColor: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.background.brand.boldest"),
            color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text.inverse"),
            border: "0.125rem solid"
        }
    })
};
const $24c02ea0e14dbe4f$var$$731a4fd527bab680$var$tabSpacingStyles = {
    small: (0, $74Zh5.css)({
        padding: `${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.050")} ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.300")}`,
        [(0, $cb8cedbc477f5a81$export$987d49ffe1b0900f).below.xs]: {
            padding: `${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.050")} ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.300")}`
        }
    }),
    "small-icon-before": (0, $74Zh5.css)({
        padding: "0.375rem 1rem 0.375rem 0.5rem"
    }),
    "small-icon-after": (0, $74Zh5.css)({
        padding: "0.375rem 0.5rem 0.375rem 1rem"
    }),
    medium: (0, $74Zh5.css)({
        padding: "0.375rem 1.5rem"
    }),
    "medium-icon-before": (0, $74Zh5.css)({
        padding: "0.375rem 1.5rem 0.375rem 1rem"
    }),
    "medium-icon-after": (0, $74Zh5.css)({
        padding: "0.375rem 1rem 0.375rem 1.5rem"
    }),
    large: (0, $74Zh5.css)({
        padding: "0.625rem 1.5rem"
    }),
    "large-icon-before": (0, $74Zh5.css)({
        padding: "0.625rem 1.5rem 0.625rem 1rem"
    }),
    "large-icon-after": (0, $74Zh5.css)({
        padding: "0.625rem 1rem 0.625rem 1.5rem"
    })
};
const $24c02ea0e14dbe4f$var$$731a4fd527bab680$var$tabIconContainerStyles = (0, $74Zh5.css)({
    width: "2rem",
    height: "2rem",
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
});
var $24c02ea0e14dbe4f$var$$5cf70e33bfc6ce73$exports = {};
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$5cf70e33bfc6ce73$exports, "Tag", ()=>$24c02ea0e14dbe4f$export$3288d34c523a1192);
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$5cf70e33bfc6ce73$exports, "tagListStyles", ()=>$24c02ea0e14dbe4f$export$f40d73b6f7f951e9);
const $24c02ea0e14dbe4f$var$$5cf70e33bfc6ce73$var$buildCustomStyles = (labelColor, borderColor, backgroundColor, textTransform, fontWeight, fontFamily)=>(0, $74Zh5.css)({
        ...labelColor && {
            color: labelColor
        },
        ...borderColor && {
            borderColor: borderColor
        },
        ...backgroundColor && {
            backgroundColor: backgroundColor
        },
        ...textTransform && {
            textTransform: textTransform
        },
        ...fontWeight && {
            fontWeight: fontWeight
        },
        ...fontFamily && {
            fontFamily: fontFamily
        }
    });
const $24c02ea0e14dbe4f$var$$5cf70e33bfc6ce73$var$buildCustomTextStyles = (labelColor, fontWeight, textTransform, fontFamily, maxSize)=>(0, $74Zh5.css)({
        ...labelColor && {
            color: labelColor
        },
        ...fontWeight && {
            fontWeight: fontWeight
        },
        ...textTransform && {
            textTransform: textTransform
        },
        ...fontFamily && {
            fontFamily: fontFamily
        },
        ...maxSize && {
            maxWidth: maxSize,
            textOverflow: "ellipsis",
            overflow: "hidden",
            whiteSpace: "nowrap"
        }
    });
const $24c02ea0e14dbe4f$export$3288d34c523a1192 = ({ inspectMode: inspectMode, label: label, onClick: onClick, selected: selected, iconAfter: iconAfter, iconBefore: iconBefore, isLarge: isLarge, isTall: isTall, labelColor: labelColor, borderColor: borderColor, backgroundColor: backgroundColor, textTransform: textTransform, fontWeight: fontWeight, fontFamily: fontFamily, maxSize: maxSize })=>{
    const customStyles = $24c02ea0e14dbe4f$var$$5cf70e33bfc6ce73$var$buildCustomStyles(labelColor, borderColor, backgroundColor, textTransform, fontWeight, fontFamily);
    const customTextStyles = $24c02ea0e14dbe4f$var$$5cf70e33bfc6ce73$var$buildCustomTextStyles(labelColor, fontWeight, textTransform, fontFamily, maxSize);
    const noOp = ()=>{};
    const onKeyDown = $24c02ea0e14dbe4f$export$2a0b6757d41dacb2(onClick || noOp);
    return (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
        ...$24c02ea0e14dbe4f$export$1784ac302bd8ebad("tag", inspectMode),
        role: onClick ? "button" : undefined,
        tabIndex: onClick ? 0 : -1,
        css: [
            $24c02ea0e14dbe4f$var$$5cf70e33bfc6ce73$var$tagStyles,
            selected && $24c02ea0e14dbe4f$var$$5cf70e33bfc6ce73$var$selectedTagStyles,
            onClick && $24c02ea0e14dbe4f$var$$5cf70e33bfc6ce73$var$hoverableTagStyles,
            iconBefore && $24c02ea0e14dbe4f$var$$5cf70e33bfc6ce73$var$beforeIconTagStyles,
            iconAfter && $24c02ea0e14dbe4f$var$$5cf70e33bfc6ce73$var$afterIconTagStyles,
            isLarge && $24c02ea0e14dbe4f$var$$5cf70e33bfc6ce73$var$largeTagStyles,
            isTall && $24c02ea0e14dbe4f$var$$5cf70e33bfc6ce73$var$tallTagStyles,
            customStyles
        ],
        onClick: onClick,
        onKeyDown: onClick ? onKeyDown : undefined,
        children: [
            iconBefore && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("span", {
                css: [
                    $24c02ea0e14dbe4f$var$$5cf70e33bfc6ce73$var$iconStyles,
                    $24c02ea0e14dbe4f$var$$5cf70e33bfc6ce73$var$beforeIconStyles
                ],
                children: iconBefore
            }),
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("span", {
                css: [
                    isLarge && $24c02ea0e14dbe4f$var$$5cf70e33bfc6ce73$var$largeTagTextStyles,
                    customTextStyles
                ],
                children: label
            }),
            iconAfter && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("span", {
                css: [
                    $24c02ea0e14dbe4f$var$$5cf70e33bfc6ce73$var$iconStyles,
                    $24c02ea0e14dbe4f$var$$5cf70e33bfc6ce73$var$afterIconStyles
                ],
                children: iconAfter
            })
        ]
    });
};
const $24c02ea0e14dbe4f$export$f40d73b6f7f951e9 = (0, $74Zh5.css)({
    display: "flex",
    flexWrap: "wrap",
    gap: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.100")
});
const $24c02ea0e14dbe4f$var$$5cf70e33bfc6ce73$var$tagStyles = (0, $74Zh5.css)({
    display: "flex",
    height: "24px",
    padding: `4px ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.100")}`,
    border: `1px solid ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.border")}`,
    borderRadius: "4px",
    alignItems: "center",
    fontFamily: "Charlie Text, sans-serif",
    fontSize: "12px",
    fontWeight: 600,
    lineHeight: "16px",
    textTransform: "uppercase",
    color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text"),
    backgroundColor: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.background.input"),
    boxSizing: "border-box",
    whiteSpace: "nowrap"
});
const $24c02ea0e14dbe4f$var$$5cf70e33bfc6ce73$var$hoverableTagStyles = (0, $74Zh5.css)({
    "&:hover": {
        borderColor: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.border.accent.gray"),
        cursor: "pointer"
    }
});
const $24c02ea0e14dbe4f$var$$5cf70e33bfc6ce73$var$selectedTagStyles = (0, $74Zh5.css)({
    borderColor: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.border.selected")
});
const $24c02ea0e14dbe4f$var$$5cf70e33bfc6ce73$var$iconStyles = (0, $74Zh5.css)({
    span: {
        width: "14px",
        height: "14px",
        marginBottom: "2px"
    }
});
const $24c02ea0e14dbe4f$var$$5cf70e33bfc6ce73$var$beforeIconStyles = (0, $74Zh5.css)({
    marginRight: "0.125rem"
});
const $24c02ea0e14dbe4f$var$$5cf70e33bfc6ce73$var$afterIconStyles = (0, $74Zh5.css)({
    marginLeft: "0.125rem"
});
const $24c02ea0e14dbe4f$var$$5cf70e33bfc6ce73$var$beforeIconTagStyles = (0, $74Zh5.css)({
    paddingLeft: "0.375rem"
});
const $24c02ea0e14dbe4f$var$$5cf70e33bfc6ce73$var$afterIconTagStyles = (0, $74Zh5.css)({
    paddingRight: "0.375rem"
});
const $24c02ea0e14dbe4f$var$$5cf70e33bfc6ce73$var$largeTagStyles = (0, $74Zh5.css)({
    display: "flex",
    height: "32px",
    padding: `${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.075")} ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.100")}`,
    justifyContent: "center",
    alignItems: "center",
    borderRadius: "4px",
    border: `1px solid ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.border")}`,
    background: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.background.input"),
    textTransform: "uppercase",
    color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text"),
    backgroundColor: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.background.input"),
    boxSizing: "border-box",
    whiteSpace: "nowrap"
});
const $24c02ea0e14dbe4f$var$$5cf70e33bfc6ce73$var$largeTagTextStyles = (0, $74Zh5.css)({
    color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text"),
    textAlign: "center",
    fontFeatureSettings: "'liga' off, 'clig' off",
    fontFamily: 'var(--Font-Family-Eyebrow, "Charlie Text")',
    fontSize: "12px",
    fontStyle: "normal",
    fontWeight: 600,
    lineHeight: "16px",
    textTransform: "uppercase"
});
const $24c02ea0e14dbe4f$var$$5cf70e33bfc6ce73$var$tallTagStyles = (0, $74Zh5.css)({
    paddingTop: "6px",
    paddingBottom: "6px",
    paddingLeft: "6px",
    paddingRight: "6px",
    height: "auto"
});
var $24c02ea0e14dbe4f$var$$8b54d37779d052e8$exports = {};
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$8b54d37779d052e8$exports, "Text", ()=>$24c02ea0e14dbe4f$export$5f1af8db9871e1d6);
const $24c02ea0e14dbe4f$export$5f1af8db9871e1d6 = ({ fontWeight: fontWeight = "regular", size: size = "regular", color: color = (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text.accent.gray.bolder"), children: children, backgroundColor: backgroundColor })=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("span", {
        css: [
            $24c02ea0e14dbe4f$var$$8b54d37779d052e8$var$textDefaultStyles,
            backgroundColor && (0, $74Zh5.css)({
                backgroundColor: backgroundColor,
                padding: "4px"
            }),
            color && (0, $74Zh5.css)({
                color: color
            }),
            $24c02ea0e14dbe4f$var$$8b54d37779d052e8$var$variantsStyles.fontWeight[fontWeight],
            $24c02ea0e14dbe4f$var$$8b54d37779d052e8$var$variantsStyles.size[size]
        ],
        children: children
    });
const $24c02ea0e14dbe4f$var$$8b54d37779d052e8$var$textDefaultStyles = (0, $74Zh5.css)({
    fontFamily: "Inter, sans-serif",
    blockquote: $24c02ea0e14dbe4f$export$7a77f8e9665fa6b2,
    ul: $24c02ea0e14dbe4f$export$6427468642e6e9fe.list.unordered,
    ol: $24c02ea0e14dbe4f$export$6427468642e6e9fe.list.ordered
});
const $24c02ea0e14dbe4f$var$$8b54d37779d052e8$var$variantsStyles = {
    size: {
        small: (0, $74Zh5.css)({
            fontSize: "14px",
            lineHeight: "20px",
            [(0, $cb8cedbc477f5a81$export$987d49ffe1b0900f).above.sm]: {
                fontSize: "14px",
                lineHeight: "20px"
            }
        }),
        regular: (0, $74Zh5.css)({
            fontSize: "14px",
            lineHeight: "22px",
            [(0, $cb8cedbc477f5a81$export$987d49ffe1b0900f).above.sm]: {
                fontSize: "16px",
                lineHeight: "24px"
            }
        }),
        large: (0, $74Zh5.css)({
            fontSize: "16px",
            lineHeight: "24px",
            [(0, $cb8cedbc477f5a81$export$987d49ffe1b0900f).above.sm]: {
                fontSize: "20px",
                lineHeight: "32px"
            }
        })
    },
    fontWeight: {
        regular: (0, $74Zh5.css)({
            fontWeight: 400
        }),
        semibold: (0, $74Zh5.css)({
            fontWeight: 600
        }),
        bold: (0, $74Zh5.css)({
            fontWeight: 700
        })
    }
};
var $24c02ea0e14dbe4f$var$$9cfa05d02afa3952$exports = {};
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$9cfa05d02afa3952$exports, "AccordionSize", ()=>$24c02ea0e14dbe4f$export$8f89d78db9c8c41f);
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$9cfa05d02afa3952$exports, "Accordion", ()=>$24c02ea0e14dbe4f$export$a766cd26d0d69044);
const $24c02ea0e14dbe4f$var$$51f57eef4d47f918$var$NAVBAR_HEIGHT = 124;
const $24c02ea0e14dbe4f$var$$51f57eef4d47f918$export$10e5e64ea66c812f = ({ title: title, index: index, children: children, isFirstTab: isFirstTab, isExpanded: isExpanded, shouldSingleTabBeOpen: shouldSingleTabBeOpen, setTabState: setTabState, setExpansionMap: setExpansionMap })=>{
    const tabRef = (0, $5FkrB.useRef)(null);
    const handleExpand = (0, $5FkrB.useCallback)(()=>{
        if (!setExpansionMap) return;
        setExpansionMap((prevState)=>prevState.map((tab, i)=>{
                if (setTabState && index !== undefined && i === index) setTabState({
                    [index + 1]: !tab.isExpanded ? "expand" : "collapse"
                });
                return {
                    ...tab,
                    isExpanded: i === index ? !tab.isExpanded : shouldSingleTabBeOpen ? false : tab.isExpanded
                };
            }));
    }, [
        index,
        setExpansionMap,
        setTabState,
        shouldSingleTabBeOpen
    ]);
    const disableClickEventBubbling = (event)=>event.stopPropagation();
    const handleKeyDown = (0, $5FkrB.useCallback)((event)=>{
        if (event.code === "Space") {
            // to handle cases when there are clickable items within accordion
            if (event.target !== event.currentTarget) {
                event.preventDefault();
                event.stopPropagation();
            } else {
                event.preventDefault();
                handleExpand();
            }
        }
    }, [
        handleExpand
    ]);
    (0, $5FkrB.useEffect)(()=>{
        if (isExpanded && tabRef.current) {
            const topPosition = tabRef.current.getBoundingClientRect().top + window.scrollY - $24c02ea0e14dbe4f$var$$51f57eef4d47f918$var$NAVBAR_HEIGHT;
            window.scrollTo({
                top: topPosition,
                behavior: "smooth"
            });
        }
    }, [
        isExpanded
    ]);
    return (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
        role: "button",
        tabIndex: 0,
        ref: tabRef,
        onKeyDown: handleKeyDown,
        css: [
            $24c02ea0e14dbe4f$var$$51f57eef4d47f918$var$accordionTabStyles,
            isFirstTab && $24c02ea0e14dbe4f$var$$51f57eef4d47f918$var$firstTabStyles,
            isExpanded && $24c02ea0e14dbe4f$var$$51f57eef4d47f918$var$expandedTabStyles
        ],
        onClick: handleExpand,
        "data-testid": `accordion-tab-${title}`,
        children: [
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                css: [
                    isExpanded && $24c02ea0e14dbe4f$var$$51f57eef4d47f918$var$expandedTabContentStyles
                ],
                children: isExpanded ? (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$f04a61298a47a40f, {
                    type: "chevron-down",
                    alt: "Chevron down"
                }) : (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$f04a61298a47a40f, {
                    type: "chevron-right",
                    alt: "Chevron right"
                })
            }),
            (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                css: $24c02ea0e14dbe4f$var$$51f57eef4d47f918$var$contentContainer,
                children: [
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("p", {
                        css: $24c02ea0e14dbe4f$var$$51f57eef4d47f918$var$titleStyles,
                        children: title
                    }),
                    isExpanded && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                        role: "button",
                        tabIndex: 0,
                        onClick: disableClickEventBubbling,
                        onKeyDown: (e)=>{
                            if (e.key === "Enter" || e.key === " ") {
                                e.preventDefault();
                                e.stopPropagation();
                            }
                        },
                        css: $24c02ea0e14dbe4f$var$$51f57eef4d47f918$var$contentStyles,
                        "data-testid": "accordion-tab-content",
                        children: children
                    })
                ]
            })
        ]
    });
};
const $24c02ea0e14dbe4f$var$$51f57eef4d47f918$var$accordionTabStyles = (0, $74Zh5.css)({
    display: "flex",
    width: "100%",
    alignContent: "center",
    alignItems: "flex-start",
    padding: "24px",
    cursor: "pointer",
    borderBottom: `1px solid ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.border")}`
});
const $24c02ea0e14dbe4f$var$$51f57eef4d47f918$var$firstTabStyles = (0, $74Zh5.css)({
    borderTop: `1px solid ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.border")}`
});
const $24c02ea0e14dbe4f$var$$51f57eef4d47f918$var$expandedTabStyles = (0, $74Zh5.css)({
    borderLeft: `${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.100")} solid ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.border.accent.blue")}`
});
const $24c02ea0e14dbe4f$var$$51f57eef4d47f918$var$expandedTabContentStyles = (0, $74Zh5.css)({
    marginLeft: "-0.5rem"
});
const $24c02ea0e14dbe4f$var$$51f57eef4d47f918$var$contentContainer = (0, $74Zh5.css)({
    marginLeft: "0.75rem"
});
const $24c02ea0e14dbe4f$var$$51f57eef4d47f918$var$titleStyles = (0, $74Zh5.css)({
    fontFamily: "Charlie Display, sans-serif",
    fontSize: "20px",
    fontWeight: 600,
    lineHeight: "28px",
    marginTop: 0,
    color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text")
});
const $24c02ea0e14dbe4f$var$$51f57eef4d47f918$var$contentStyles = (0, $74Zh5.css)({
    marginTop: "16px",
    fontFamily: "Inter, sans-serif",
    fontSize: "20px",
    fontWeight: 400,
    lineHeight: "30px",
    color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text"),
    ol: {
        margin: 0
    },
    ul: {
        margin: 0
    },
    a: {
        fontSize: "20px !important",
        lineHeight: "28px !important"
    }
});
let $24c02ea0e14dbe4f$export$8f89d78db9c8c41f;
(function(AccordionSize) {
    AccordionSize["DEFAULT"] = "default";
    AccordionSize["WIDE"] = "wide";
    AccordionSize["FULL_WIDTH"] = "full-width";
})($24c02ea0e14dbe4f$export$8f89d78db9c8c41f || ($24c02ea0e14dbe4f$export$8f89d78db9c8c41f = {}));
const $24c02ea0e14dbe4f$export$a766cd26d0d69044 = ({ tabsContent: tabsContent, size: size, shouldSingleTabBeOpen: shouldSingleTabBeOpen, onChange: onChange })=>{
    const [expansionMap, setExpansionMap] = (0, $5FkrB.useState)([]);
    const [tabState, setTabState] = (0, $5FkrB.useState)();
    (0, $5FkrB.useEffect)(()=>{
        const initialExpansionMap = tabsContent.map((tabContent)=>({
                ...tabContent,
                isExpanded: false
            }));
        setExpansionMap(initialExpansionMap);
    // tabsContent intentionally excluded to avoid re-initializing on content changes
    /* eslint-disable react-hooks/exhaustive-deps */ }, []);
    (0, $5FkrB.useEffect)(()=>{
        if (!tabState) return;
        onChange(tabState);
    }, [
        expansionMap,
        setExpansionMap
    ]);
    /* eslint-enable react-hooks/exhaustive-deps */ return (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
        css: [
            $24c02ea0e14dbe4f$var$$9cfa05d02afa3952$var$baseAccordionStyles,
            $24c02ea0e14dbe4f$export$8f89d78db9c8c41f.DEFAULT === size && $24c02ea0e14dbe4f$var$$9cfa05d02afa3952$var$accordionDefaultStyles,
            $24c02ea0e14dbe4f$export$8f89d78db9c8c41f.WIDE === size && $24c02ea0e14dbe4f$var$$9cfa05d02afa3952$var$accordionWideStyles
        ],
        "data-testid": "lesson-accordion",
        children: expansionMap.map(({ title: title, children: children, isExpanded: isExpanded }, index)=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$var$$51f57eef4d47f918$export$10e5e64ea66c812f, {
                title: title,
                isFirstTab: index === 0,
                index: index,
                isExpanded: isExpanded,
                shouldSingleTabBeOpen: shouldSingleTabBeOpen,
                setTabState: setTabState,
                setExpansionMap: setExpansionMap,
                children: children
            }, title))
    });
};
const $24c02ea0e14dbe4f$var$$9cfa05d02afa3952$var$baseAccordionStyles = (0, $74Zh5.css)({
    width: "100%",
    display: "flex",
    flexDirection: "column"
});
const $24c02ea0e14dbe4f$var$$9cfa05d02afa3952$var$accordionDefaultStyles = (0, $74Zh5.css)({
    maxWidth: "720px"
});
const $24c02ea0e14dbe4f$var$$9cfa05d02afa3952$var$accordionWideStyles = (0, $74Zh5.css)({
    maxWidth: "1020px",
    [(0, $cb8cedbc477f5a81$export$987d49ffe1b0900f).below.md]: {
        maxWidth: "720px"
    }
});
var $24c02ea0e14dbe4f$var$$7d458ed59bb9c6a8$exports = {};
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$7d458ed59bb9c6a8$exports, "InlineCode", ()=>$24c02ea0e14dbe4f$export$7f1bf47c7f50a6aa);
const $24c02ea0e14dbe4f$export$7f1bf47c7f50a6aa = ({ code: code = "" })=>{
    const lines = code ? code.split(/\r\n|\r|\n/) : null;
    const [isCopied, setIsCopied] = (0, $5FkrB.useState)(false);
    const copy = (code)=>{
        navigator.clipboard.writeText(code);
        setIsCopied(true);
    };
    return (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("code", {
        "data-testid": "code-block",
        css: $24c02ea0e14dbe4f$var$$7d458ed59bb9c6a8$var$inlineCodeStyles,
        children: [
            (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("button", {
                css: [
                    $24c02ea0e14dbe4f$var$$7d458ed59bb9c6a8$var$inlineCodeButtonStyles,
                    isCopied ? (0, $74Zh5.css)({
                        backgroundColor: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.background.selected.bold.pressed"),
                        border: "2px solid"
                    }) : (0, $74Zh5.css)({
                        backgroundColor: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.background.accent.gray.subtlest"),
                        border: `2px solid ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.border.inverse")}`,
                        "&:hover": {
                            backgroundColor: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.background.accent.gray.subtlest.hovered"),
                            border: "2px solid transparent"
                        }
                    })
                ],
                "aria-label": "Copy",
                "aria-haspopup": "true",
                type: "button",
                tabIndex: 0,
                onClick: ()=>copy(code),
                onMouseOut: ()=>setIsCopied(false),
                onBlur: ()=>setIsCopied(false),
                children: [
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("span", {
                        className: "tooltipText",
                        css: $24c02ea0e14dbe4f$var$$7d458ed59bb9c6a8$var$tooltipTextStyles,
                        children: isCopied ? "Copied!" : "Copy"
                    }),
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$f04a61298a47a40f, {
                        type: "copy",
                        color: isCopied ? (0, $54ca2d3948378259$export$29a4f05edc054374) : (0, $54ca2d3948378259$export$7d61b15e0da132af)
                    })
                ]
            }),
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("span", {
                children: lines?.map((line, index)=>(0, $6bec4f26b2cb3094$export$25062201e9e25d76)("span", {
                        css: $24c02ea0e14dbe4f$var$$7d458ed59bb9c6a8$var$codeLinesStyles,
                        children: [
                            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("span", {
                                css: $24c02ea0e14dbe4f$var$$7d458ed59bb9c6a8$var$lineNumberStyles,
                                children: index + 1
                            }),
                            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("span", {
                                css: $24c02ea0e14dbe4f$var$$7d458ed59bb9c6a8$var$lineTextStyles,
                                children: line
                            })
                        ]
                    }, index))
            })
        ]
    });
};
const $24c02ea0e14dbe4f$var$$7d458ed59bb9c6a8$var$inlineCodeStyles = (0, $74Zh5.css)({
    position: "relative",
    display: "flex",
    maxWidth: "100%",
    margin: "20px 0",
    flexDirection: "column",
    borderRadius: "3px",
    overflowWrap: "normal",
    backgroundColor: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.background.accent.gray.subtlest")
});
const $24c02ea0e14dbe4f$var$$7d458ed59bb9c6a8$var$inlineCodeButtonStyles = (0, $74Zh5.css)({
    position: "absolute",
    right: "8px",
    top: "6px",
    display: "flex",
    padding: "2px",
    borderRadius: "4px",
    transition: "opacity 0.2s ease 0s",
    opacity: 0,
    zIndex: 1,
    cursor: "pointer",
    "&:hover .tooltipText": {
        opacity: 1
    },
    "&:hover": {
        opacity: 1
    }
});
const $24c02ea0e14dbe4f$var$$7d458ed59bb9c6a8$var$tooltipTextStyles = (0, $74Zh5.css)({
    position: "absolute",
    top: "-30px",
    padding: "2px 6px",
    marginLeft: "-5px",
    borderRadius: "6px",
    backgroundColor: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.background.selected.bold.pressed"),
    color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text.inverse"),
    textAlign: "center",
    fontSize: "11px",
    opacity: 0,
    zIndex: 1,
    transition: "opacity 0.4s ease 0s",
    "&:hover": {
        opacity: 1
    }
});
const $24c02ea0e14dbe4f$var$$7d458ed59bb9c6a8$var$codeLinesStyles = (0, $74Zh5.css)({
    display: "flex",
    lineHeight: "20px",
    whiteSpace: "pre",
    fontSize: "12px"
});
const $24c02ea0e14dbe4f$var$$7d458ed59bb9c6a8$var$lineNumberStyles = (0, $74Zh5.css)({
    padding: "4px 8px",
    marginRight: "8px",
    backgroundColor: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.background.accent.gray.subtler")
});
const $24c02ea0e14dbe4f$var$$7d458ed59bb9c6a8$var$lineTextStyles = (0, $74Zh5.css)({
    padding: "4px 8px 4px 0"
});
var $24c02ea0e14dbe4f$var$$a467abe0c2c1750b$exports = {};
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$a467abe0c2c1750b$exports, "Lozenge", ()=>$24c02ea0e14dbe4f$export$a31cbe1bf5463979);
const $24c02ea0e14dbe4f$export$a31cbe1bf5463979 = ({ appearance: appearance = "default", text: text, isBold: isBold })=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $31a965b6dd4a0db8$export$2e2bcd8739ae039), {
        isBold: isBold,
        appearance: appearance,
        testId: "lozenge",
        children: text?.toUpperCase()
    });
var $24c02ea0e14dbe4f$var$$52124b9ae1d78e04$exports = {};
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$52124b9ae1d78e04$exports, "SectionMessageAppearance", ()=>$24c02ea0e14dbe4f$export$710836885d72543c);
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$52124b9ae1d78e04$exports, "SectionMessage", ()=>$24c02ea0e14dbe4f$export$a36903bd214cec06);
let $24c02ea0e14dbe4f$export$710836885d72543c;
(function(SectionMessageAppearance) {
    SectionMessageAppearance["INFORMATION"] = "information";
    SectionMessageAppearance["INFORMATION_WHITE"] = "information_white";
})($24c02ea0e14dbe4f$export$710836885d72543c || ($24c02ea0e14dbe4f$export$710836885d72543c = {}));
const $24c02ea0e14dbe4f$export$a36903bd214cec06 = ({ children: children, appearance: appearance, fullWidth: fullWidth = false, padding: padding, title: title })=>{
    const isInfoWhite = appearance === $24c02ea0e14dbe4f$export$710836885d72543c.INFORMATION_WHITE;
    return (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
        css: [
            $24c02ea0e14dbe4f$var$$52124b9ae1d78e04$var$sectionMessageContainerStyles({
                padding: padding
            }),
            isInfoWhite && $24c02ea0e14dbe4f$var$$52124b9ae1d78e04$var$informationWhiteStyles,
            !isInfoWhite && $24c02ea0e14dbe4f$var$$52124b9ae1d78e04$var$informationStyles,
            !fullWidth && (0, $74Zh5.css)({
                maxWidth: "720px"
            })
        ],
        "data-testid": `section-message${isInfoWhite ? "-white" : ""}`,
        children: [
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                css: $24c02ea0e14dbe4f$var$$52124b9ae1d78e04$var$iconContainerStyles,
                children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$f04a61298a47a40f, {
                    type: "info",
                    alt: "info icon",
                    color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.icon.accent.blue")
                })
            }),
            (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                css: $24c02ea0e14dbe4f$var$$52124b9ae1d78e04$var$descriptionStyles,
                children: [
                    title && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$a8a3e93435678ff9, {
                        level: 5,
                        children: title
                    }),
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$5f1af8db9871e1d6, {
                        children: children
                    })
                ]
            })
        ]
    });
};
const $24c02ea0e14dbe4f$var$$52124b9ae1d78e04$var$sectionMessageContainerStyles = ({ padding: padding = (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.200") })=>(0, $74Zh5.css)({
        display: "flex",
        width: "100%",
        borderRadius: "3px",
        padding: padding,
        columnGap: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.200")
    });
const $24c02ea0e14dbe4f$var$$52124b9ae1d78e04$var$informationStyles = (0, $74Zh5.css)({
    backgroundColor: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.background.information")
});
const $24c02ea0e14dbe4f$var$$52124b9ae1d78e04$var$informationWhiteStyles = (0, $74Zh5.css)({
    border: `1px solid ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.border")}`,
    backgroundColor: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("elevation.surface")
});
const $24c02ea0e14dbe4f$var$$52124b9ae1d78e04$var$iconContainerStyles = (0, $74Zh5.css)({
    marginTop: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.050")
});
const $24c02ea0e14dbe4f$var$$52124b9ae1d78e04$var$descriptionStyles = (0, $74Zh5.css)({
    display: "flex",
    flexDirection: "column",
    gap: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.100"),
    "& *": {
        fontSize: "16px !important"
    }
});
var $24c02ea0e14dbe4f$var$$b5ebb29d1a23bfec$exports = {};
$24c02ea0e14dbe4f$var$$parcel$defineInteropFlag($24c02ea0e14dbe4f$var$$b5ebb29d1a23bfec$exports);
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$b5ebb29d1a23bfec$exports, "SharedFooter", ()=>$24c02ea0e14dbe4f$export$7a92b4adf6bd95bb);
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$b5ebb29d1a23bfec$exports, "MinimalSharedFooter", ()=>$24c02ea0e14dbe4f$export$8dce6dbf8ef18fcb);
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$b5ebb29d1a23bfec$exports, "default", ()=>$24c02ea0e14dbe4f$var$$b5ebb29d1a23bfec$export$2e2bcd8739ae039);
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$b5ebb29d1a23bfec$exports, "columnStyle", ()=>$24c02ea0e14dbe4f$export$c5f2190049e47f52);
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$b5ebb29d1a23bfec$exports, "columnsContainerStyle", ()=>$24c02ea0e14dbe4f$export$220191dc35b80c46);
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$b5ebb29d1a23bfec$exports, "headerStyle", ()=>$24c02ea0e14dbe4f$export$5939e41228734fb7);
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$b5ebb29d1a23bfec$exports, "linkStyle", ()=>$24c02ea0e14dbe4f$export$a4c1071d1005664f);
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$b5ebb29d1a23bfec$exports, "FooterLink", ()=>$24c02ea0e14dbe4f$export$e0513c91be1318ca);
var $24c02ea0e14dbe4f$var$$a0eced43682c2d75$exports = {};
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$a0eced43682c2d75$exports, "LicenseModal", ()=>$24c02ea0e14dbe4f$export$bd0c6e28f5d6b66e);
const $24c02ea0e14dbe4f$export$bd0c6e28f5d6b66e = ({ modalTitle: modalTitle, bodyTitle: bodyTitle, bodyDescription: bodyDescription, closeModal: closeModal, licenses: licenses })=>{
    return (0, $6bec4f26b2cb3094$export$25062201e9e25d76)((0, $73c4314b1cf0d4b0$export$2e2bcd8739ae039), {
        onClose: closeModal,
        shouldScrollInViewport: false,
        children: [
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $e63db9e78b9f7f9d$export$2e2bcd8739ae039), {
                children: modalTitle && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$a8a3e93435678ff9, {
                    level: 3,
                    fontWeight: 600,
                    children: modalTitle
                })
            }),
            (0, $6bec4f26b2cb3094$export$25062201e9e25d76)((0, $883c6fe3d36b669f$export$2e2bcd8739ae039), {
                children: [
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("span", {
                        css: (0, $74Zh5.css)({
                            color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.icon.brand")
                        }),
                        children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $fefa5e0a15da0ac0$export$765cacec8b0843f3), {
                            testId: "desktop"
                        })
                    }),
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                        css: $24c02ea0e14dbe4f$var$$a0eced43682c2d75$var$spacingContainerStyles,
                        children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$a8a3e93435678ff9, {
                            level: 4,
                            fontWeight: 500,
                            children: bodyTitle
                        })
                    }),
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                        css: $24c02ea0e14dbe4f$var$$a0eced43682c2d75$var$spacingContainerStyles,
                        children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $c9e5a7a14e07f4e4$export$2e2bcd8739ae039), {
                            children: bodyDescription
                        })
                    }),
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                        css: $24c02ea0e14dbe4f$var$$a0eced43682c2d75$var$spacingContainerStyles,
                        children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$a8a3e93435678ff9, {
                            level: 4,
                            fontWeight: 500,
                            children: "Attributions for Open Source Libraries"
                        })
                    }),
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                        css: $24c02ea0e14dbe4f$var$$a0eced43682c2d75$var$spacingContainerStyles,
                        children: licenses?.length && licenses.map((license, index)=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                                css: (0, $74Zh5.css)({
                                    padding: `${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.100")} 0`
                                }),
                                children: (0, $6bec4f26b2cb3094$export$25062201e9e25d76)((0, $c9e5a7a14e07f4e4$export$2e2bcd8739ae039), {
                                    children: [
                                        (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("a", {
                                            css: $24c02ea0e14dbe4f$var$$a0eced43682c2d75$var$licenseTitleStyles,
                                            href: license.link,
                                            children: `${license.packageName} ${license.version}`
                                        }),
                                        (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("p", {
                                            css: (0, $74Zh5.css)({
                                                margin: 0
                                            }),
                                            children: license.description
                                        })
                                    ]
                                }, license.packageName)
                            }, license.packageName + index))
                    })
                ]
            }),
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $812d3a996ab3db86$export$2e2bcd8739ae039), {
                children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $123ba5aab151a241$export$2e2bcd8739ae039), {
                    appearance: $24c02ea0e14dbe4f$export$261c9483fc4a455a.PRIMARY,
                    onClick: closeModal,
                    children: "Close"
                })
            })
        ]
    });
};
const $24c02ea0e14dbe4f$var$$a0eced43682c2d75$var$spacingContainerStyles = (0, $74Zh5.css)({
    padding: `${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.100")} 0`
});
const $24c02ea0e14dbe4f$var$$a0eced43682c2d75$var$licenseTitleStyles = (0, $74Zh5.css)({
    fontWeight: 600
});
var $24c02ea0e14dbe4f$var$$795b38850428b3a7$require$Buffer = (0, $7KfP5.Buffer);
const $24c02ea0e14dbe4f$var$$795b38850428b3a7$var$svgStringDesktopFooterWider = `<svg width="3597" height="220" viewBox="0 0 3597 220" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clipPath="url(#clip0_1461_26831)">
<path d="M2132.54 314.529C2146.63 313.033 2161.59 314.218 2177.19 318.272C2192.78 322.325 2207.65 328.995 2219.68 337.581L2245.71 236.527C2232.41 230.415 2218.06 225.333 2202.74 221.351C2187.42 217.369 2172.81 214.822 2158.49 213.604L2132.48 314.564L2132.54 314.529Z" fill="#BF63F3"/>
<path d="M1905.63 13.0095L1932.77 57.7351C1902.11 76.8306 1895.31 95.1589 1908.88 117.522C1922.45 139.884 1942.19 142.885 1973.45 124.776L2000.59 169.502C1939.18 206.46 1898.36 193.057 1867.63 142.412C1836.9 91.7667 1844.25 50.0145 1905.66 13.0565L1905.63 13.0095Z" fill="#BF63F3"/>
<path d="M2653.64 67.1608C2651.12 70.158 2648.74 73.5509 2646.59 77.2837C2644.43 81.0165 2642.62 84.8928 2641.3 88.6374C2633.3 110.896 2640.22 131.445 2658.16 146.049C2661.21 148.541 2664.61 150.872 2668.29 152.996C2671.97 155.121 2675.99 157.022 2679.83 158.505C2701.49 166.665 2722.75 162.381 2737.96 144.444C2740.54 141.43 2742.94 137.998 2745.14 134.187C2747.35 130.375 2749.05 126.695 2750.38 123.013C2758.29 100.911 2751.37 80.3628 2733.5 65.6405C2730.31 63.0181 2726.79 60.6186 2722.96 58.4028C2719.12 56.187 2715.6 54.5204 2711.88 53.1059C2690.25 44.8669 2668.94 49.1675 2653.72 67.2065L2653.64 67.1608Z" fill="#FCA700"/>
<path d="M1895.14 242.555C1892.93 245.176 1890.84 248.144 1888.96 251.41C1887.07 254.676 1885.48 258.069 1884.33 261.347C1877.35 280.834 1883.48 298.855 1899.28 311.691C1901.96 313.881 1904.95 315.93 1908.19 317.8C1911.43 319.669 1914.97 321.344 1918.34 322.652C1937.4 329.85 1956.07 326.142 1969.39 310.457C1971.66 307.822 1973.76 304.819 1975.69 301.484C1977.61 298.149 1979.1 294.929 1980.27 291.705C1987.17 272.356 1981.05 254.335 1965.3 241.396C1962.5 239.091 1959.4 236.981 1956.03 235.031C1952.65 233.081 1949.55 231.613 1946.28 230.365C1927.26 223.099 1908.54 226.821 1895.21 242.595L1895.14 242.555Z" fill="#1868DB"/>
<path d="M2377.56 187.36C2332.41 205.776 2303.33 188.768 2293.49 181.225L2286.73 268.152C2295.75 275.232 2321.35 289.599 2365.56 271.568C2407.5 254.47 2435.57 267.92 2447.25 275.96L2454 189.016C2443.32 181.668 2418.37 170.713 2377.56 187.36Z" fill="#1868DB"/>
<path d="M1956.63 392.322L2067.8 363.764L2103.25 229.834L2021.88 185.761L1956.63 392.322Z" fill="#82B536"/>
<path d="M1814.81 214.821C1777.79 204.861 1754.37 195.571 1741.02 184.518L1735.75 299.502C1749.51 304.079 1764.42 308.373 1780.76 312.342C1816.54 322.129 1838.14 331.724 1849.86 343.657L1855.25 225.91C1842.76 221.962 1829.36 218.25 1814.81 214.821Z" fill="#FCA700"/>
<path d="M1717.71 131.43L1767.34 121.105L1788.77 77.5333L1765.89 33.5097L1715.9 22.1945L1676.46 52.1123L1677.27 100.718L1717.71 131.43Z" fill="#82B536"/>
<path d="M2287.3 0.329368C2292.26 17.6796 2294.03 36.6867 2292.33 57.0839C2290.62 77.481 2285.46 97.5178 2277.28 114.391L2410.19 125.941C2414.99 107.988 2418.26 88.9353 2419.94 68.8981C2421.61 48.8609 2421.63 30.0094 2420.04 11.8036L2287.25 0.264012L2287.3 0.329368Z" fill="#82B536"/>
<path d="M2732.21 188.352C2731.07 192.109 2730.22 196.176 2729.74 200.467C2729.26 204.759 2729.16 209.049 2729.49 213.022C2731.28 236.704 2746.68 252.942 2770.15 259.359C2774.14 260.46 2778.41 261.273 2782.85 261.786C2787.29 262.299 2791.96 262.473 2796.29 262.331C2820.59 261.339 2839.19 249.028 2846.17 226.497C2847.37 222.7 2848.22 218.588 2848.72 214.207C2849.21 209.825 2849.28 205.76 2848.99 201.838C2847.18 178.337 2831.78 162.098 2808.32 155.546C2804.15 154.377 2799.74 153.548 2795.11 153.013C2790.48 152.478 2786.38 152.326 2782.2 152.484C2757.91 153.385 2739.25 165.736 2732.31 188.363L2732.21 188.352Z" fill="#82B536"/>
<path d="M2889.07 147.28C2915.86 136.154 2934.18 130.899 2947.27 131.344L2897.58 60.2224C2887.23 63.8352 2876.31 68.1465 2864.68 73.3134C2838.72 83.9714 2821.36 88.1994 2808.84 86.4762L2859.72 159.306C2869.02 155.908 2878.77 151.943 2889.07 147.28Z" fill="#BF63F3"/>
<path d="M1500.61 92.78C1499.48 96.4691 1498.65 100.462 1498.18 104.676C1497.71 108.89 1497.62 113.103 1497.94 117.004C1499.7 140.257 1514.82 156.202 1537.86 162.503C1541.78 163.584 1545.97 164.382 1550.33 164.886C1554.69 165.39 1559.28 165.56 1563.52 165.421C1587.38 164.447 1605.65 152.359 1612.51 130.235C1613.69 126.507 1614.52 122.47 1615 118.167C1615.49 113.864 1615.56 109.873 1615.27 106.022C1613.5 82.9459 1598.37 67.0012 1575.34 60.5673C1571.24 59.4199 1566.92 58.6058 1562.37 58.0804C1557.82 57.5551 1553.8 57.4053 1549.7 57.5605C1525.84 58.4455 1507.52 70.573 1500.7 92.7908L1500.61 92.78Z" fill="#FCA700"/>
<path d="M2476.23 171.901L2512.57 187.615L2580.4 132.718L2540.7 72.2981L2469.59 84.8102L2476.23 171.901Z" fill="#FCA700"/>
<path d="M1590.18 276.392C1581.18 284.413 1582.82 297.295 1599.18 315.611C1600.94 317.584 1603.22 319.181 1604.98 321.154L1565.44 356.405C1561.81 353.394 1557.79 348.885 1552.5 342.967C1511.68 297.27 1513.72 256.222 1543.27 229.879C1565.29 210.248 1585.75 208.965 1606.41 210.958C1621.55 211.808 1632.33 212.828 1640.38 205.651C1649.37 197.63 1647.78 184.796 1631.38 166.432L1625.63 159.998L1664.69 125.169C1668.74 128.65 1672.77 133.158 1677.63 138.606C1718.87 184.774 1717.35 225.357 1687.28 252.165C1665.26 271.796 1644.39 272.609 1624.1 271.038C1609.01 270.236 1598.18 269.168 1590.13 276.345L1590.18 276.392Z" fill="#BF63F3"/>
<path d="M2627.7 309.01L2674.17 285.958L2684.11 237.19L2650.04 199.408L2597.6 201.079L2566.29 240.945L2579.68 288.97L2627.7 309.01Z" fill="#1868DB"/>
<path d="M2872.12 290.73C2867.27 321.394 2860.18 348.844 2852.92 371.879L2952.23 418.074C2962.37 387.895 2972.61 350.569 2979.35 307.997C2986.08 265.424 2987.84 226.732 2987.52 194.869L2878.89 207.578C2878.69 231.751 2876.97 260.066 2872.12 290.73Z" fill="#1868DB"/>
<path d="M2029.07 76.709L2081.8 60.3305C2094.17 97.6481 2111.48 109.727 2137.85 101.538C2164.21 93.3484 2172.04 73.4588 2160.83 35.7799L2213.56 19.4014C2237.02 93.7899 2213.37 132.978 2153.67 151.525C2093.96 170.071 2052.58 151.08 2029.12 76.6918L2029.07 76.709Z" fill="#1868DB"/>
<path d="M3183.71 263.373L3218.75 257.454C3262.92 249.994 3285.29 225.656 3295.17 194.436C3275.45 168.157 3246.29 152.584 3202.18 160.035L3140.03 170.531L3156.62 268.008L3183.67 263.44L3183.71 263.373Z" fill="#82B536"/>
<path d="M3507.45 240.161L3557.25 236.478L3583.87 196.676L3567.29 150.712L3519.96 133.206L3477.54 157.345L3471.98 204.936L3507.45 240.161Z" fill="#FCA700"/>
<path d="M3409.05 183.497L3432.31 152.723L3395.5 75.4747L3328.88 98.91L3324.57 169.298L3409.05 183.497Z" fill="#BF63F3"/>
<path d="M3096.28 193.6L3071.36 147.313L2999.69 124.541L3013.98 207.767L3075.67 265.657L3096.28 193.6Z" fill="#FCA700"/>
<path d="M3604.18 274.336L3620.24 305.08C3640.49 343.822 3667.68 358.475 3696.55 359.996C3711.89 335.532 3715.4 304.987 3695.17 266.29L3666.68 211.774L3591.71 250.587L3604.11 274.315L3604.18 274.336Z" fill="#1868DB"/>
<path d="M3419.15 246.402C3387.51 238.086 3359.1 229.101 3335.23 220.826L3290.48 267.987C3321.77 279.173 3360.41 291.729 3404.34 303.274C3448.28 314.818 3488.09 322.876 3520.82 328.514L3504.79 265.379C3479.94 260.853 3450.8 254.717 3419.15 246.402Z" fill="#1868DB"/>
<path d="M3194.92 119.479C3224.2 117.038 3243.38 117.413 3255.57 121.325L3234.28 46.2045C3223.2 46.5499 3211.35 47.3509 3198.52 48.703C3170.19 50.9595 3152.29 49.9514 3141.1 45.084L3162.9 122.009C3172.9 121.566 3183.52 120.75 3194.92 119.479Z" fill="#1868DB"/>
<path d="M1080.67 276.053C1089.16 285.428 1102.4 283.893 1120.89 267.24C1122.88 265.447 1124.47 263.118 1126.46 261.324L1163.76 302.525C1160.75 306.228 1156.2 310.327 1150.22 315.707C1104.1 357.253 1061.73 354.658 1033.86 323.868C1013.08 300.924 1011.27 279.808 1012.82 258.521C1013.33 242.923 1014.12 231.819 1006.53 223.431C998.038 214.056 984.845 215.548 966.31 232.244L959.816 238.093L922.961 197.386C926.452 193.256 931.003 189.157 936.501 184.204C983.099 142.231 1024.98 144.284 1053.34 175.616C1074.12 198.56 1075.46 220.103 1074.33 241.006C1073.87 256.561 1073.03 267.708 1080.63 276.096L1080.67 276.053Z" fill="#82B536"/>
<path d="M625.543 193.797C639.63 192.301 654.593 193.486 670.188 197.54C685.782 201.593 700.654 208.263 712.683 216.849L738.712 115.795C725.409 109.683 711.058 104.601 695.739 100.619C680.42 96.6367 665.808 94.0903 651.489 92.8723L625.485 193.832L625.543 193.797Z" fill="#BF63F3"/>
<path d="M1266.86 164.218L1230.53 158.808L1182.68 226.256L1232.61 271.992L1293.45 242.75L1266.86 164.218Z" fill="#FCA700"/>
<path d="M399.069 336.98L422.334 306.205L385.52 228.958L318.902 252.393L314.592 322.781L399.069 336.98Z" fill="#BF63F3"/>
<path d="M388.137 121.823C385.928 124.444 383.843 127.412 381.957 130.678C380.072 133.944 378.484 137.337 377.334 140.615C370.355 160.102 376.477 178.123 392.278 190.959C394.96 193.149 397.955 195.199 401.193 197.068C404.431 198.938 407.967 200.612 411.344 201.92C430.4 209.118 449.068 205.41 462.395 189.725C464.659 187.09 466.763 184.087 468.689 180.752C470.614 177.418 472.102 174.197 473.267 170.973C480.168 151.624 474.045 133.603 458.303 120.664C455.502 118.359 452.403 116.249 449.026 114.299C445.649 112.349 442.55 110.881 439.278 109.634C420.261 102.367 401.539 106.09 388.207 121.863L388.137 121.823Z" fill="#1868DB"/>
<path d="M870.565 66.6285C825.409 85.0438 796.327 68.0356 786.485 60.4931L779.735 147.42C788.749 154.5 814.346 168.867 858.558 150.836C900.496 133.738 928.568 147.188 940.25 155.228L947.002 68.2839C936.315 60.9356 911.368 49.9809 870.565 66.6285Z" fill="#1868DB"/>
<path d="M743.463 217.247C740.532 228.564 734.449 235.337 724.723 239.407C714.173 243.821 704.241 242.98 695.082 237.49L605.16 275.114C646.399 339.254 703.508 358.315 762.522 333.623C817.497 310.622 843.195 267.293 832.726 179.9L743.381 217.282L743.463 217.247Z" fill="#1868DB"/>
<path d="M449.631 271.59L560.8 243.032L596.253 109.102L514.879 65.0287L449.631 271.59Z" fill="#82B536"/>
<path d="M307.812 94.0893C270.79 84.1287 247.365 74.8387 234.016 63.7859L228.75 178.77C242.51 183.347 257.418 187.641 273.761 191.61C309.542 201.397 331.135 210.992 342.854 222.925L348.246 105.178C335.764 101.23 322.362 97.5184 307.812 94.0893Z" fill="#FCA700"/>
<path d="M1225.21 67.6199C1224.07 71.377 1223.22 75.4437 1222.74 79.7352C1222.26 84.0267 1222.16 88.3172 1222.49 92.2903C1224.28 115.972 1239.68 132.21 1263.15 138.627C1267.14 139.728 1271.41 140.541 1275.85 141.054C1280.29 141.567 1284.96 141.741 1289.29 141.599C1313.59 140.607 1332.19 128.296 1339.17 105.765C1340.37 101.968 1341.22 97.8564 1341.72 93.4746C1342.21 89.0927 1342.28 85.0281 1341.99 81.1056C1340.18 57.6047 1324.78 41.3663 1301.32 34.8139C1297.15 33.6454 1292.74 32.8162 1288.11 32.2812C1283.48 31.7462 1279.38 31.5936 1275.2 31.7517C1250.91 32.653 1232.25 45.0039 1225.31 67.631L1225.21 67.6199Z" fill="#82B536"/>
<path d="M83.1762 155.66C74.1789 163.681 75.8177 176.563 92.1789 194.879C93.9408 196.852 96.2182 198.449 97.9802 200.422L58.4398 235.673C54.8145 232.662 50.7872 228.153 45.5013 222.235C4.68234 176.538 6.72077 135.49 36.2695 109.147C58.289 89.5158 78.7491 88.2328 99.414 90.2263C114.549 91.0758 125.328 92.0964 133.378 84.9196C142.375 76.8983 140.778 64.064 124.375 45.7004L118.628 39.2661L157.695 4.43712C161.739 7.91785 165.767 12.4265 170.633 17.8745C211.872 64.0418 210.354 104.625 180.284 131.433C158.265 151.064 137.385 151.877 117.098 150.306C102.005 149.504 91.1843 148.436 83.1342 155.613L83.1762 155.66Z" fill="#BF63F3"/>
<path d="M1120.7 188.278L1167.17 165.226L1177.11 116.458L1143.04 78.6759L1090.6 80.3475L1059.29 120.213L1072.68 168.238L1120.7 188.278Z" fill="#1868DB"/>
<path d="M1365.12 169.998C1360.27 200.662 1353.18 228.112 1345.92 251.147L1445.23 297.342C1455.37 267.164 1465.61 229.838 1472.35 187.265C1479.08 144.692 1480.84 106 1480.52 74.1372L1371.89 86.8457C1371.69 111.019 1369.97 139.334 1365.12 169.998Z" fill="#1868DB"/>
<path d="M184.943 272.962C214.22 270.521 233.398 270.896 245.587 274.808L224.294 199.687C213.221 200.033 201.37 200.834 188.539 202.186C160.208 204.442 142.304 203.434 131.116 198.567L152.92 275.492C162.921 275.048 173.542 274.233 184.943 272.962Z" fill="#1868DB"/>
</g>
<defs>
<clipPath id="clip0_1461_26831">
<rect width="3597" height="220" fill="white"/>
</clipPath>
</defs>
</svg>
`;
const $24c02ea0e14dbe4f$var$$795b38850428b3a7$export$f3cfc44c4eba4576 = `data:image/svg+xml;base64,${$24c02ea0e14dbe4f$var$$795b38850428b3a7$require$Buffer.from($24c02ea0e14dbe4f$var$$795b38850428b3a7$var$svgStringDesktopFooterWider).toString("base64")}`;
const $24c02ea0e14dbe4f$var$$795b38850428b3a7$var$svgStringDesktopFooterWide = `<svg width="3305" height="220" viewBox="0 0 3305 220" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clipPath="url(#clip0_1461_26940)">
<path d="M2132.54 314.529C2146.63 313.033 2161.59 314.218 2177.19 318.272C2192.78 322.325 2207.65 328.995 2219.68 337.581L2245.71 236.527C2232.41 230.415 2218.06 225.333 2202.74 221.351C2187.42 217.369 2172.81 214.822 2158.49 213.604L2132.48 314.564L2132.54 314.529Z" fill="#BF63F3"/>
<path d="M1905.63 13.0095L1932.77 57.7351C1902.11 76.8306 1895.31 95.1589 1908.88 117.522C1922.45 139.884 1942.19 142.885 1973.45 124.776L2000.59 169.502C1939.18 206.46 1898.36 193.057 1867.63 142.412C1836.9 91.7667 1844.25 50.0145 1905.66 13.0565L1905.63 13.0095Z" fill="#BF63F3"/>
<path d="M2653.64 67.1608C2651.12 70.158 2648.74 73.5509 2646.59 77.2837C2644.43 81.0165 2642.62 84.8928 2641.3 88.6374C2633.3 110.896 2640.22 131.445 2658.16 146.049C2661.21 148.541 2664.61 150.872 2668.29 152.996C2671.97 155.121 2675.99 157.022 2679.83 158.505C2701.49 166.665 2722.75 162.381 2737.96 144.444C2740.54 141.43 2742.94 137.998 2745.14 134.187C2747.35 130.375 2749.05 126.695 2750.38 123.013C2758.29 100.911 2751.37 80.3628 2733.5 65.6405C2730.31 63.0181 2726.79 60.6186 2722.96 58.4028C2719.12 56.187 2715.6 54.5204 2711.88 53.1059C2690.25 44.8669 2668.94 49.1675 2653.72 67.2065L2653.64 67.1608Z" fill="#FCA700"/>
<path d="M1895.14 242.555C1892.93 245.176 1890.84 248.144 1888.96 251.41C1887.07 254.676 1885.48 258.069 1884.33 261.347C1877.35 280.834 1883.48 298.855 1899.28 311.691C1901.96 313.881 1904.95 315.93 1908.19 317.8C1911.43 319.669 1914.97 321.344 1918.34 322.652C1937.4 329.85 1956.07 326.142 1969.39 310.457C1971.66 307.822 1973.76 304.819 1975.69 301.484C1977.61 298.149 1979.1 294.929 1980.27 291.705C1987.17 272.356 1981.05 254.335 1965.3 241.396C1962.5 239.091 1959.4 236.981 1956.03 235.031C1952.65 233.081 1949.55 231.613 1946.28 230.365C1927.26 223.099 1908.54 226.821 1895.21 242.595L1895.14 242.555Z" fill="#1868DB"/>
<path d="M2377.56 187.36C2332.41 205.776 2303.33 188.768 2293.49 181.225L2286.73 268.152C2295.75 275.232 2321.35 289.599 2365.56 271.568C2407.5 254.47 2435.57 267.92 2447.25 275.96L2454 189.016C2443.32 181.668 2418.37 170.713 2377.56 187.36Z" fill="#1868DB"/>
<path d="M1956.63 392.322L2067.8 363.764L2103.25 229.834L2021.88 185.761L1956.63 392.322Z" fill="#82B536"/>
<path d="M1814.81 214.821C1777.79 204.861 1754.37 195.571 1741.02 184.518L1735.75 299.502C1749.51 304.079 1764.42 308.373 1780.76 312.342C1816.54 322.129 1838.14 331.724 1849.86 343.657L1855.25 225.91C1842.76 221.962 1829.36 218.25 1814.81 214.821Z" fill="#FCA700"/>
<path d="M1717.71 131.43L1767.34 121.105L1788.77 77.5333L1765.89 33.5097L1715.9 22.1945L1676.46 52.1123L1677.27 100.718L1717.71 131.43Z" fill="#82B536"/>
<path d="M2287.3 0.329368C2292.26 17.6796 2294.03 36.6867 2292.33 57.0839C2290.62 77.481 2285.46 97.5178 2277.28 114.391L2410.19 125.941C2414.99 107.988 2418.26 88.9353 2419.94 68.8981C2421.61 48.8609 2421.63 30.0094 2420.04 11.8036L2287.25 0.264012L2287.3 0.329368Z" fill="#82B536"/>
<path d="M2732.21 188.352C2731.07 192.109 2730.22 196.176 2729.74 200.467C2729.26 204.759 2729.16 209.049 2729.49 213.022C2731.28 236.704 2746.68 252.942 2770.15 259.359C2774.14 260.46 2778.41 261.273 2782.85 261.786C2787.29 262.299 2791.96 262.473 2796.29 262.331C2820.59 261.339 2839.19 249.028 2846.17 226.497C2847.37 222.7 2848.22 218.588 2848.72 214.207C2849.21 209.825 2849.28 205.76 2848.99 201.838C2847.18 178.337 2831.78 162.098 2808.32 155.546C2804.15 154.377 2799.74 153.548 2795.11 153.013C2790.48 152.478 2786.38 152.326 2782.2 152.484C2757.91 153.385 2739.25 165.736 2732.31 188.363L2732.21 188.352Z" fill="#82B536"/>
<path d="M2889.07 147.28C2915.86 136.154 2934.18 130.899 2947.27 131.344L2897.58 60.2224C2887.23 63.8352 2876.31 68.1465 2864.68 73.3134C2838.72 83.9714 2821.36 88.1994 2808.84 86.4762L2859.72 159.306C2869.02 155.908 2878.77 151.943 2889.07 147.28Z" fill="#BF63F3"/>
<path d="M1500.61 92.78C1499.48 96.4691 1498.65 100.462 1498.18 104.676C1497.71 108.89 1497.62 113.103 1497.94 117.004C1499.7 140.257 1514.82 156.202 1537.86 162.503C1541.78 163.584 1545.97 164.382 1550.33 164.886C1554.69 165.39 1559.28 165.56 1563.52 165.421C1587.38 164.447 1605.65 152.359 1612.51 130.235C1613.69 126.507 1614.52 122.47 1615 118.167C1615.49 113.864 1615.56 109.873 1615.27 106.022C1613.5 82.9459 1598.37 67.0012 1575.34 60.5673C1571.24 59.4199 1566.92 58.6058 1562.37 58.0804C1557.82 57.5551 1553.8 57.4053 1549.7 57.5605C1525.84 58.4455 1507.52 70.573 1500.7 92.7908L1500.61 92.78Z" fill="#FCA700"/>
<path d="M2476.23 171.901L2512.57 187.615L2580.4 132.718L2540.7 72.2981L2469.59 84.8102L2476.23 171.901Z" fill="#FCA700"/>
<path d="M1590.18 276.392C1581.18 284.413 1582.82 297.295 1599.18 315.611C1600.94 317.584 1603.22 319.181 1604.98 321.154L1565.44 356.405C1561.81 353.394 1557.79 348.885 1552.5 342.967C1511.68 297.27 1513.72 256.222 1543.27 229.879C1565.29 210.248 1585.75 208.965 1606.41 210.958C1621.55 211.808 1632.33 212.828 1640.38 205.651C1649.37 197.63 1647.78 184.796 1631.38 166.432L1625.63 159.998L1664.69 125.169C1668.74 128.65 1672.77 133.158 1677.63 138.606C1718.87 184.774 1717.35 225.357 1687.28 252.165C1665.26 271.796 1644.39 272.609 1624.1 271.038C1609.01 270.236 1598.18 269.168 1590.13 276.345L1590.18 276.392Z" fill="#BF63F3"/>
<path d="M2627.7 309.01L2674.17 285.958L2684.11 237.19L2650.04 199.408L2597.6 201.079L2566.29 240.945L2579.68 288.97L2627.7 309.01Z" fill="#1868DB"/>
<path d="M2872.12 290.73C2867.27 321.394 2860.18 348.844 2852.92 371.879L2952.23 418.074C2962.37 387.895 2972.61 350.569 2979.35 307.997C2986.08 265.424 2987.84 226.732 2987.52 194.869L2878.89 207.578C2878.69 231.751 2876.97 260.066 2872.12 290.73Z" fill="#1868DB"/>
<path d="M2029.07 76.709L2081.8 60.3305C2094.17 97.6481 2111.48 109.727 2137.85 101.538C2164.21 93.3484 2172.04 73.4588 2160.83 35.7799L2213.56 19.4014C2237.02 93.7899 2213.37 132.978 2153.67 151.525C2093.96 170.071 2052.58 151.08 2029.12 76.6918L2029.07 76.709Z" fill="#1868DB"/>
<path d="M3183.71 263.373L3218.75 257.454C3262.92 249.994 3285.29 225.656 3295.17 194.436C3275.45 168.157 3246.29 152.584 3202.18 160.035L3140.03 170.531L3156.62 268.008L3183.67 263.44L3183.71 263.373Z" fill="#82B536"/>
<path d="M3409.05 183.497L3432.31 152.723L3395.5 75.4747L3328.88 98.91L3324.57 169.298L3409.05 183.497Z" fill="#BF63F3"/>
<path d="M3096.28 193.6L3071.36 147.313L2999.69 124.541L3013.98 207.767L3075.67 265.657L3096.28 193.6Z" fill="#FCA700"/>
<path d="M3419.15 246.402C3387.51 238.086 3359.1 229.101 3335.23 220.826L3290.48 267.987C3321.77 279.173 3360.41 291.729 3404.34 303.274C3448.28 314.818 3488.09 322.876 3520.82 328.514L3504.79 265.379C3479.94 260.853 3450.8 254.717 3419.15 246.402Z" fill="#1868DB"/>
<path d="M3194.92 119.479C3224.2 117.038 3243.38 117.413 3255.57 121.325L3234.28 46.2045C3223.2 46.5499 3211.35 47.3509 3198.52 48.703C3170.19 50.9595 3152.29 49.9514 3141.1 45.084L3162.9 122.009C3172.9 121.566 3183.52 120.75 3194.92 119.479Z" fill="#1868DB"/>
<path d="M1080.67 276.053C1089.16 285.428 1102.4 283.893 1120.89 267.24C1122.88 265.447 1124.47 263.118 1126.46 261.324L1163.76 302.525C1160.75 306.228 1156.2 310.327 1150.22 315.707C1104.1 357.253 1061.73 354.658 1033.86 323.868C1013.08 300.924 1011.27 279.808 1012.82 258.521C1013.33 242.923 1014.12 231.819 1006.53 223.431C998.038 214.056 984.845 215.548 966.31 232.244L959.816 238.093L922.961 197.386C926.452 193.256 931.003 189.157 936.501 184.204C983.099 142.231 1024.98 144.284 1053.34 175.616C1074.12 198.56 1075.46 220.103 1074.33 241.006C1073.87 256.561 1073.03 267.708 1080.63 276.096L1080.67 276.053Z" fill="#82B536"/>
<path d="M625.543 193.797C639.63 192.301 654.593 193.486 670.188 197.54C685.782 201.593 700.654 208.263 712.683 216.849L738.712 115.795C725.409 109.683 711.058 104.601 695.739 100.619C680.42 96.6367 665.808 94.0903 651.489 92.8723L625.485 193.832L625.543 193.797Z" fill="#BF63F3"/>
<path d="M1266.86 164.218L1230.53 158.808L1182.68 226.256L1232.61 271.992L1293.45 242.75L1266.86 164.218Z" fill="#FCA700"/>
<path d="M399.069 336.98L422.334 306.205L385.52 228.958L318.902 252.393L314.592 322.781L399.069 336.98Z" fill="#BF63F3"/>
<path d="M388.137 121.823C385.928 124.444 383.843 127.412 381.957 130.678C380.072 133.944 378.484 137.337 377.334 140.615C370.355 160.102 376.477 178.123 392.278 190.959C394.96 193.149 397.955 195.199 401.193 197.068C404.431 198.938 407.967 200.612 411.344 201.92C430.4 209.118 449.068 205.41 462.395 189.725C464.659 187.09 466.763 184.087 468.689 180.752C470.614 177.418 472.102 174.197 473.267 170.973C480.168 151.624 474.045 133.603 458.303 120.664C455.502 118.359 452.403 116.249 449.026 114.299C445.649 112.349 442.55 110.881 439.278 109.634C420.261 102.367 401.539 106.09 388.207 121.863L388.137 121.823Z" fill="#1868DB"/>
<path d="M870.565 66.6285C825.409 85.0438 796.327 68.0356 786.485 60.4931L779.735 147.42C788.749 154.5 814.346 168.867 858.558 150.836C900.496 133.738 928.568 147.188 940.25 155.228L947.002 68.2839C936.315 60.9356 911.368 49.9809 870.565 66.6285Z" fill="#1868DB"/>
<path d="M743.463 217.247C740.532 228.564 734.449 235.337 724.723 239.407C714.173 243.821 704.241 242.98 695.082 237.49L605.16 275.114C646.399 339.254 703.508 358.315 762.522 333.623C817.497 310.622 843.195 267.293 832.726 179.9L743.381 217.282L743.463 217.247Z" fill="#1868DB"/>
<path d="M449.631 271.59L560.8 243.032L596.253 109.102L514.879 65.0287L449.631 271.59Z" fill="#82B536"/>
<path d="M307.812 94.0893C270.79 84.1287 247.365 74.8387 234.016 63.7859L228.75 178.77C242.51 183.347 257.418 187.641 273.761 191.61C309.542 201.397 331.135 210.992 342.854 222.925L348.246 105.178C335.764 101.23 322.362 97.5184 307.812 94.0893Z" fill="#FCA700"/>
<path d="M1225.21 67.6199C1224.07 71.377 1223.22 75.4437 1222.74 79.7352C1222.26 84.0267 1222.16 88.3172 1222.49 92.2903C1224.28 115.972 1239.68 132.21 1263.15 138.627C1267.14 139.728 1271.41 140.541 1275.85 141.054C1280.29 141.567 1284.96 141.741 1289.29 141.599C1313.59 140.607 1332.19 128.296 1339.17 105.765C1340.37 101.968 1341.22 97.8564 1341.72 93.4746C1342.21 89.0927 1342.28 85.0281 1341.99 81.1056C1340.18 57.6047 1324.78 41.3663 1301.32 34.8139C1297.15 33.6454 1292.74 32.8162 1288.11 32.2812C1283.48 31.7462 1279.38 31.5936 1275.2 31.7517C1250.91 32.653 1232.25 45.0039 1225.31 67.631L1225.21 67.6199Z" fill="#82B536"/>
<path d="M83.1762 155.66C74.1789 163.681 75.8177 176.563 92.1789 194.879C93.9408 196.852 96.2182 198.449 97.9802 200.422L58.4398 235.673C54.8145 232.662 50.7872 228.153 45.5013 222.235C4.68234 176.538 6.72077 135.49 36.2695 109.147C58.289 89.5158 78.7491 88.2328 99.414 90.2263C114.549 91.0758 125.328 92.0964 133.378 84.9196C142.375 76.8983 140.778 64.064 124.375 45.7004L118.628 39.2661L157.695 4.43712C161.739 7.91785 165.767 12.4265 170.633 17.8745C211.872 64.0418 210.354 104.625 180.284 131.433C158.265 151.064 137.385 151.877 117.098 150.306C102.005 149.504 91.1843 148.436 83.1342 155.613L83.1762 155.66Z" fill="#BF63F3"/>
<path d="M1120.7 188.278L1167.17 165.226L1177.11 116.458L1143.04 78.6759L1090.6 80.3475L1059.29 120.213L1072.68 168.238L1120.7 188.278Z" fill="#1868DB"/>
<path d="M1365.12 169.998C1360.27 200.662 1353.18 228.112 1345.92 251.147L1445.23 297.342C1455.37 267.164 1465.61 229.838 1472.35 187.265C1479.08 144.692 1480.84 106 1480.52 74.1372L1371.89 86.8457C1371.69 111.019 1369.97 139.334 1365.12 169.998Z" fill="#1868DB"/>
<path d="M184.943 272.962C214.22 270.521 233.398 270.896 245.587 274.808L224.294 199.687C213.221 200.033 201.37 200.834 188.539 202.186C160.208 204.442 142.304 203.434 131.116 198.567L152.92 275.492C162.921 275.048 173.542 274.233 184.943 272.962Z" fill="#1868DB"/>
</g>
<defs>
<clipPath id="clip0_1461_26940">
<rect width="3305" height="220" fill="white"/>
</clipPath>
</defs>
</svg>
`;
const $24c02ea0e14dbe4f$var$$795b38850428b3a7$export$7d22dc8c5b0cc81c = `data:image/svg+xml;base64,${$24c02ea0e14dbe4f$var$$795b38850428b3a7$require$Buffer.from($24c02ea0e14dbe4f$var$$795b38850428b3a7$var$svgStringDesktopFooterWide).toString("base64")}`;
const $24c02ea0e14dbe4f$var$$795b38850428b3a7$var$svgStringMobileFooter = `<svg width="907" height="139" viewBox="0 0 907 139" fill="none" xmlns="http://www.w3.org/2000/svg">
<mask id="mask0_1421_26676" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="907" height="139">
<rect width="907" height="138.569" fill="#D9D9D9"/>
</mask>
<g mask="url(#mask0_1421_26676)">
<path d="M395.637 190.948C403.967 189.968 412.814 190.744 422.035 193.4C431.255 196.056 440.048 200.427 447.161 206.052L462.551 139.842C454.685 135.837 446.2 132.507 437.142 129.898C428.085 127.289 419.445 125.62 410.979 124.822L395.603 190.971L395.637 190.948Z" fill="#BF63F3"/>
<path d="M261.469 -6.60718L277.516 22.697C259.386 35.2084 255.368 47.2171 263.392 61.8691C271.415 76.5212 283.086 78.4874 301.57 66.6224L317.617 95.9265C281.308 120.141 257.173 111.36 239.002 78.1771C220.831 44.9945 225.177 17.6384 261.486 -6.57639L261.469 -6.60718Z" fill="#BF63F3"/>
<path d="M703.749 28.8725C702.258 30.8363 700.85 33.0593 699.576 35.505C698.302 37.9507 697.228 40.4904 696.449 42.9439C691.72 57.5278 695.81 70.9912 706.42 80.56C708.221 82.1926 710.233 83.7199 712.408 85.1118C714.584 86.5037 716.96 87.7495 719.23 88.7212C732.041 94.0679 744.608 91.2609 753.601 79.5082C755.128 77.5337 756.55 75.2849 757.851 72.7877C759.152 70.2905 760.158 67.8795 760.948 65.4667C765.623 50.9859 761.533 37.5224 750.963 27.8764C749.082 26.1581 747 24.586 744.731 23.1342C742.462 21.6824 740.379 20.5905 738.179 19.6637C725.396 14.2655 712.792 17.0833 703.796 28.9024L703.749 28.8725Z" fill="#FCA700"/>
<path d="M255.266 143.791C253.96 145.508 252.727 147.453 251.612 149.593C250.497 151.733 249.559 153.956 248.879 156.104C244.752 168.871 248.372 180.679 257.715 189.089C259.3 190.524 261.071 191.867 262.985 193.092C264.9 194.316 266.991 195.414 268.987 196.271C280.255 200.986 291.293 198.557 299.172 188.28C300.511 186.554 301.755 184.587 302.894 182.402C304.032 180.217 304.912 178.106 305.601 175.994C309.681 163.316 306.061 151.509 296.753 143.031C295.097 141.521 293.265 140.139 291.268 138.861C289.271 137.584 287.439 136.622 285.504 135.804C274.26 131.044 263.19 133.482 255.307 143.817L255.266 143.791Z" fill="#1868DB"/>
<path d="M540.511 107.628C513.812 119.693 496.617 108.55 490.798 103.608L486.806 160.563C492.136 165.201 507.271 174.615 533.412 162.8C558.209 151.598 574.807 160.41 581.715 165.678L585.707 108.712C579.388 103.898 564.637 96.7202 540.511 107.628Z" fill="#1868DB"/>
<path d="M291.626 241.918L357.357 223.207L378.319 135.456L330.205 106.579L291.626 241.918Z" fill="#82B536"/>
<path d="M207.772 125.619C185.882 119.093 172.032 113.006 164.139 105.765L161.026 181.102C169.161 184.101 177.976 186.914 187.639 189.515C208.795 195.927 221.563 202.214 228.492 210.032L231.68 132.885C224.3 130.298 216.376 127.866 207.772 125.619Z" fill="#FCA700"/>
<path d="M150.358 70.9821L179.701 64.217L192.375 35.669L178.846 6.8247L149.287 -0.588974L125.967 19.0132L126.445 50.8598L150.358 70.9821Z" fill="#82B536"/>
<path d="M487.144 -14.9153C490.073 -3.54747 491.12 8.90597 490.112 22.2702C489.104 35.6344 486.055 48.7625 481.214 59.8175L559.804 67.3853C562.64 55.6224 564.574 43.1392 565.564 30.0109C566.554 16.8825 566.566 4.53097 565.627 -7.39742L487.11 -14.9582L487.144 -14.9153Z" fill="#82B536"/>
<path d="M750.205 108.277C749.527 110.739 749.028 113.403 748.743 116.215C748.458 119.027 748.402 121.838 748.596 124.441C749.655 139.957 758.761 150.597 772.638 154.801C774.997 155.523 777.517 156.055 780.143 156.391C782.77 156.727 785.533 156.841 788.088 156.748C802.457 156.099 813.458 148.032 817.586 133.27C818.296 130.782 818.798 128.088 819.089 125.217C819.38 122.346 819.421 119.683 819.252 117.113C818.181 101.715 809.075 91.0758 795.207 86.7827C792.738 86.0171 790.133 85.4738 787.394 85.1233C784.655 84.7727 782.233 84.6728 779.762 84.7763C765.4 85.3669 754.367 93.4592 750.262 108.284L750.205 108.277Z" fill="#82B536"/>
<path d="M842.951 81.367C858.788 74.077 869.621 70.6339 877.359 70.9258L847.983 24.3268C841.859 26.6939 835.405 29.5186 828.529 32.904C813.18 39.8871 802.914 42.6573 795.515 41.5283L825.596 89.2466C831.096 87.0197 836.858 84.4222 842.951 81.367Z" fill="#BF63F3"/>
<path d="M21.9939 45.6584C21.3276 48.0755 20.8378 50.6918 20.558 53.4527C20.2782 56.2137 20.2233 58.9739 20.4137 61.5301C21.454 76.7656 30.395 87.2126 44.021 91.3409C46.3368 92.0494 48.8118 92.5722 51.3906 92.9022C53.9694 93.2322 56.6827 93.3439 59.1918 93.2528C73.3009 92.6149 84.1031 84.6944 88.1561 70.199C88.853 67.7564 89.3458 65.111 89.6315 62.292C89.9171 59.4729 89.9574 56.8579 89.7918 54.3344C88.7397 39.2151 79.7987 28.7681 66.1814 24.5527C63.7577 23.8009 61.1995 23.2675 58.5098 22.9233C55.8201 22.5791 53.4424 22.4809 51.0165 22.5826C36.9134 23.1624 26.0805 31.1084 22.0493 45.6655L21.9939 45.6584Z" fill="#FCA700"/>
<path d="M598.85 97.498L620.339 107.794L660.44 71.8259L636.967 32.2385L594.924 40.4365L598.85 97.498Z" fill="#FCA700"/>
<path d="M74.9517 165.961C69.6319 171.216 70.6008 179.656 80.2747 191.657C81.3165 192.95 82.6631 193.996 83.7049 195.289L60.3258 218.385C58.1823 216.412 55.801 213.458 52.6756 209.581C28.5406 179.64 29.7458 152.746 47.2172 135.485C60.2366 122.623 72.3341 121.783 84.5526 123.089C93.5012 123.645 99.8746 124.314 104.634 119.612C109.954 114.356 109.01 105.947 99.3113 93.9154L95.9131 89.6996L119.012 66.8797C121.404 69.1603 123.785 72.1144 126.662 75.6839C151.045 105.933 150.148 132.523 132.369 150.087C119.349 162.95 107.004 163.482 95.0086 162.453C86.0848 161.927 79.6867 161.228 74.9268 165.93L74.9517 165.961Z" fill="#BF63F3"/>
<path d="M688.409 187.332L715.888 172.229L721.763 140.276L701.619 115.521L670.609 116.616L652.097 142.736L660.019 174.202L688.409 187.332Z" fill="#1868DB"/>
<path d="M832.929 175.355C830.063 195.446 825.869 213.432 821.573 228.524L880.295 258.791C886.287 239.018 892.347 214.562 896.327 186.668C900.306 158.775 901.351 133.424 901.158 112.547L836.93 120.874C836.813 136.712 835.795 155.264 832.929 175.355Z" fill="#1868DB"/>
<path d="M334.456 35.1284L365.632 24.3972C372.95 48.8477 383.184 56.7618 398.772 51.3962C414.36 46.0306 418.993 32.9989 412.363 8.3117L443.539 -2.41947C457.409 46.3198 443.431 71.9961 408.128 84.1476C372.826 96.2991 348.359 83.8565 334.489 35.1171L334.456 35.1284Z" fill="#1868DB"/>
</g>
</svg>
`;
const $24c02ea0e14dbe4f$var$$795b38850428b3a7$export$eca0cf64e1927e60 = `data:image/svg+xml;base64,${$24c02ea0e14dbe4f$var$$795b38850428b3a7$require$Buffer.from($24c02ea0e14dbe4f$var$$795b38850428b3a7$var$svgStringMobileFooter).toString("base64")}`;
const $24c02ea0e14dbe4f$var$$85f029238a1d2eb6$export$aa27a9003cb13d3 = "@media (min-width: 768px) and (max-width: 1279px)";
const $24c02ea0e14dbe4f$var$$85f029238a1d2eb6$export$dcc4079bc63af6b8 = "@media (max-width: 767px)";
const $24c02ea0e14dbe4f$var$$85f029238a1d2eb6$export$77261562b77476b8 = "@media (min-width: 1280px)";
const $24c02ea0e14dbe4f$var$$85f029238a1d2eb6$export$9f513872ee8f6246 = (0, $74Zh5.css)({
    width: "100%",
    backgroundImage: `url(${$24c02ea0e14dbe4f$var$$795b38850428b3a7$export$f3cfc44c4eba4576})`,
    backgroundSize: "cover",
    backgroundRepeat: "no-repeat",
    backgroundPosition: "center",
    paddingTop: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.200"),
    paddingBottom: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.200"),
    boxSizing: "border-box",
    [$24c02ea0e14dbe4f$var$$85f029238a1d2eb6$export$aa27a9003cb13d3]: {
        backgroundImage: `url(${$24c02ea0e14dbe4f$var$$795b38850428b3a7$export$7d22dc8c5b0cc81c})`
    },
    [$24c02ea0e14dbe4f$var$$85f029238a1d2eb6$export$dcc4079bc63af6b8]: {
        backgroundImage: `url(${$24c02ea0e14dbe4f$var$$795b38850428b3a7$export$eca0cf64e1927e60})`
    }
});
const $24c02ea0e14dbe4f$var$$85f029238a1d2eb6$export$12bbd02e39f3a749 = (0, $74Zh5.css)({
    width: "100%",
    display: "flex",
    justifyContent: "center",
    margin: "0 auto",
    maxWidth: "100%",
    fontFamily: "Inter, sans-serif",
    [$24c02ea0e14dbe4f$var$$85f029238a1d2eb6$export$77261562b77476b8]: {
        maxWidth: "1234px"
    },
    [$24c02ea0e14dbe4f$var$$85f029238a1d2eb6$export$aa27a9003cb13d3]: {
        maxWidth: "720px"
    },
    [$24c02ea0e14dbe4f$var$$85f029238a1d2eb6$export$dcc4079bc63af6b8]: {
        paddingLeft: "20px",
        paddingRight: "20px"
    }
});
const $24c02ea0e14dbe4f$var$$85f029238a1d2eb6$export$b3dee97a51489da1 = (0, $74Zh5.css)({
    borderRadius: "0px 0px 24px 24px",
    width: "100%",
    margin: "0 auto",
    backgroundColor: "#F8F8F8",
    textAlign: "center",
    display: "flex",
    alignItems: "center",
    flexDirection: "column",
    [$24c02ea0e14dbe4f$var$$85f029238a1d2eb6$export$aa27a9003cb13d3]: {
        padding: "0 16px"
    },
    [$24c02ea0e14dbe4f$var$$85f029238a1d2eb6$export$dcc4079bc63af6b8]: {
        paddingLeft: "16px",
        paddingRight: "16px",
        paddingTop: "24px",
        textAlign: "left"
    }
});
const $24c02ea0e14dbe4f$export$a4c1071d1005664f = (0, $74Zh5.css)({
    display: "inline",
    fontSize: "12px",
    fontWeight: 400,
    color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text"),
    textDecoration: "none",
    "&:hover": {
        textDecoration: "underline",
        textDecorationColor: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text"),
        color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text"),
        cursor: "pointer"
    }
});
const $24c02ea0e14dbe4f$var$$85f029238a1d2eb6$export$76b9e543844e8a5 = (0, $74Zh5.css)({
    padding: "24px 24px",
    boxSizing: "border-box",
    width: "100%",
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "space-between",
    [$24c02ea0e14dbe4f$var$$85f029238a1d2eb6$export$aa27a9003cb13d3]: {
        flexDirection: "column",
        alignItems: "flex-start"
    },
    [$24c02ea0e14dbe4f$var$$85f029238a1d2eb6$export$dcc4079bc63af6b8]: {
        flexDirection: "column",
        alignItems: "flex-start",
        paddingTop: "0px",
        paddingBottom: "8px"
    }
});
const $24c02ea0e14dbe4f$var$$85f029238a1d2eb6$export$313ce10a9f9c4472 = (0, $74Zh5.css)({
    width: "420px",
    display: "flex",
    [$24c02ea0e14dbe4f$var$$85f029238a1d2eb6$export$aa27a9003cb13d3]: {
        justifyContent: "flex-start",
        width: "120px"
    },
    [$24c02ea0e14dbe4f$var$$85f029238a1d2eb6$export$dcc4079bc63af6b8]: {
        marginBottom: "16px",
        width: "120px"
    }
});
const $24c02ea0e14dbe4f$var$$85f029238a1d2eb6$export$2bc3a170ad333299 = (0, $74Zh5.css)({
    svg: {
        color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.icon.brand"),
        transform: `scale(0.9)`
    },
    marginLeft: "24px",
    [$24c02ea0e14dbe4f$var$$85f029238a1d2eb6$export$aa27a9003cb13d3]: {
        marginLeft: "0",
        marginBottom: "8px"
    },
    [$24c02ea0e14dbe4f$var$$85f029238a1d2eb6$export$dcc4079bc63af6b8]: {
        marginLeft: "0",
        paddingLeft: "0"
    }
});
const $24c02ea0e14dbe4f$export$220191dc35b80c46 = (0, $74Zh5.css)({
    display: "flex",
    justifyContent: "space-between",
    gap: "24px",
    [$24c02ea0e14dbe4f$var$$85f029238a1d2eb6$export$aa27a9003cb13d3]: {
        gap: "16px"
    },
    [$24c02ea0e14dbe4f$var$$85f029238a1d2eb6$export$dcc4079bc63af6b8]: {
        width: "100%",
        flexDirection: "column",
        gap: "0"
    }
});
const $24c02ea0e14dbe4f$export$c5f2190049e47f52 = (0, $74Zh5.css)({
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    width: "120px",
    textAlign: "left",
    gap: "12px",
    [$24c02ea0e14dbe4f$var$$85f029238a1d2eb6$export$dcc4079bc63af6b8]: {
        width: "100%",
        marginBottom: "16px"
    }
});
const $24c02ea0e14dbe4f$export$5939e41228734fb7 = (0, $74Zh5.css)({
    marginBottom: "4px"
});
const $24c02ea0e14dbe4f$var$$85f029238a1d2eb6$export$17633131d02ad451 = (0, $74Zh5.css)({
    width: "100%",
    display: "flex",
    justifyContent: "center",
    boxSizing: "border-box",
    [$24c02ea0e14dbe4f$var$$85f029238a1d2eb6$export$aa27a9003cb13d3]: {
        padding: "0 0px"
    },
    [$24c02ea0e14dbe4f$var$$85f029238a1d2eb6$export$dcc4079bc63af6b8]: {
        justifyContent: "flex-start",
        width: "100%",
        paddingLeft: "0",
        paddingRight: "0"
    }
});
const $24c02ea0e14dbe4f$var$$85f029238a1d2eb6$export$140449594731c4c9 = (0, $74Zh5.css)({
    marginLeft: "0px",
    fontSize: "12px",
    color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text.subtle")
});
const $24c02ea0e14dbe4f$var$$85f029238a1d2eb6$export$55e15b718251f123 = (0, $74Zh5.css)({
    width: "100%",
    maxWidth: "calc(100% - 48px)",
    paddingTop: "16px",
    paddingBottom: "24px",
    paddingLeft: "24px",
    paddingRight: "24px",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    boxSizing: "border-box",
    borderTop: `1px solid ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.border")}`,
    [$24c02ea0e14dbe4f$var$$85f029238a1d2eb6$export$aa27a9003cb13d3]: {
        paddingLeft: "0",
        paddingRight: "0"
    },
    [$24c02ea0e14dbe4f$var$$85f029238a1d2eb6$export$dcc4079bc63af6b8]: {
        maxWidth: "100%",
        justifyContent: "flex-start",
        flexDirection: "column-reverse",
        alignItems: "flex-start",
        paddingLeft: "24px",
        paddingRight: "0"
    }
});
const $24c02ea0e14dbe4f$var$$85f029238a1d2eb6$export$e635e766db488209 = (0, $74Zh5.css)({
    display: "inline",
    marginLeft: "32px",
    [$24c02ea0e14dbe4f$var$$85f029238a1d2eb6$export$dcc4079bc63af6b8]: {
        marginLeft: "0"
    }
});
const $24c02ea0e14dbe4f$var$$85f029238a1d2eb6$export$b814e32be8f9cc9e = (0, $74Zh5.css)({
    [$24c02ea0e14dbe4f$var$$85f029238a1d2eb6$export$dcc4079bc63af6b8]: {
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
        width: "100%",
        textAlign: "left",
        marginTop: "0",
        marginBottom: "32px",
        gap: "12px"
    }
});
const $24c02ea0e14dbe4f$var$$5a3292f3bef31812$var$YEAR = new Date().getFullYear();
const $24c02ea0e14dbe4f$var$$5a3292f3bef31812$var$COPYRIGHT = `Copyright \xa9 ${$24c02ea0e14dbe4f$var$$5a3292f3bef31812$var$YEAR} Atlassian`;
const $24c02ea0e14dbe4f$export$e0513c91be1318ca = ({ href: href, onClick: onClick, text: text, styles: styles = [] })=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("a", {
        href: href,
        onClick: onClick,
        css: [
            $24c02ea0e14dbe4f$export$a4c1071d1005664f,
            ...styles
        ],
        children: text
    });
const $24c02ea0e14dbe4f$var$$5a3292f3bef31812$export$f769621e3a03739f = ({ termsUrl: termsUrl, nav: nav, reportAProblemCallback: reportAProblemCallback, licenseData: licenseData })=>{
    const [isOpen, setIsOpen] = (0, $5FkrB.useState)(false);
    const openModal = (0, $5FkrB.useCallback)(()=>setIsOpen(true), []);
    const closeModal = (0, $5FkrB.useCallback)(()=>setIsOpen(false), []);
    return (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
        css: $24c02ea0e14dbe4f$var$$85f029238a1d2eb6$export$9f513872ee8f6246,
        children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
            css: $24c02ea0e14dbe4f$var$$85f029238a1d2eb6$export$12bbd02e39f3a749,
            children: (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                css: $24c02ea0e14dbe4f$var$$85f029238a1d2eb6$export$b3dee97a51489da1,
                children: [
                    (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                        css: $24c02ea0e14dbe4f$var$$85f029238a1d2eb6$export$76b9e543844e8a5,
                        children: [
                            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                                css: $24c02ea0e14dbe4f$var$$85f029238a1d2eb6$export$313ce10a9f9c4472,
                                children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                                    css: $24c02ea0e14dbe4f$var$$85f029238a1d2eb6$export$2bc3a170ad333299,
                                    children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $37844134dd17fb96$export$8a485e2e7ed91e8f), {})
                                })
                            }),
                            nav
                        ]
                    }),
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                        css: $24c02ea0e14dbe4f$var$$85f029238a1d2eb6$export$17633131d02ad451,
                        children: (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                            css: $24c02ea0e14dbe4f$var$$85f029238a1d2eb6$export$55e15b718251f123,
                            children: [
                                (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("span", {
                                    css: $24c02ea0e14dbe4f$var$$85f029238a1d2eb6$export$140449594731c4c9,
                                    children: $24c02ea0e14dbe4f$var$$5a3292f3bef31812$var$COPYRIGHT
                                }),
                                (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                                    css: $24c02ea0e14dbe4f$var$$85f029238a1d2eb6$export$b814e32be8f9cc9e,
                                    children: [
                                        reportAProblemCallback && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$e0513c91be1318ca, {
                                            onClick: reportAProblemCallback,
                                            text: "Report a problem",
                                            styles: [
                                                $24c02ea0e14dbe4f$var$$85f029238a1d2eb6$export$e635e766db488209
                                            ]
                                        }),
                                        (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$e0513c91be1318ca, {
                                            href: $24c02ea0e14dbe4f$var$$1ff01338112cd7fe$export$30786e8ac20c09d8,
                                            text: "Privacy Policy",
                                            styles: [
                                                $24c02ea0e14dbe4f$var$$85f029238a1d2eb6$export$e635e766db488209
                                            ]
                                        }),
                                        (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("a", {
                                            href: $24c02ea0e14dbe4f$var$$1ff01338112cd7fe$export$6aafbda8e90312f0,
                                            className: "atl-policy-link",
                                            css: $24c02ea0e14dbe4f$var$$85f029238a1d2eb6$export$e635e766db488209,
                                            children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("span", {
                                                css: $24c02ea0e14dbe4f$export$a4c1071d1005664f,
                                                className: "atl-policy-link-text",
                                                children: "Notice at Collection"
                                            })
                                        }),
                                        (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$e0513c91be1318ca, {
                                            href: termsUrl,
                                            text: "Terms",
                                            styles: [
                                                $24c02ea0e14dbe4f$var$$85f029238a1d2eb6$export$e635e766db488209
                                            ]
                                        }),
                                        (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$e0513c91be1318ca, {
                                            href: $24c02ea0e14dbe4f$var$$1ff01338112cd7fe$export$10bc455dcefd3f1f,
                                            text: "Security",
                                            styles: [
                                                $24c02ea0e14dbe4f$var$$85f029238a1d2eb6$export$e635e766db488209
                                            ]
                                        }),
                                        licenseData && (0, $6bec4f26b2cb3094$export$25062201e9e25d76)((0, $6bec4f26b2cb3094$export$ffb0004e005737fa), {
                                            children: [
                                                (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$e0513c91be1318ca, {
                                                    onClick: openModal,
                                                    text: "About",
                                                    styles: [
                                                        $24c02ea0e14dbe4f$var$$85f029238a1d2eb6$export$e635e766db488209
                                                    ]
                                                }),
                                                (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $58963c306889e449$export$2e2bcd8739ae039), {
                                                    children: isOpen && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$bd0c6e28f5d6b66e, {
                                                        ...licenseData,
                                                        closeModal: closeModal
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                ]
            })
        })
    });
};
const $24c02ea0e14dbe4f$var$$224bc56423ffe231$var$FORUMS_URL = $24c02ea0e14dbe4f$var$$1ff01338112cd7fe$export$fe0105b4860d6e11[$24c02ea0e14dbe4f$export$93d048dc21eb282a.FORUMS];
const $24c02ea0e14dbe4f$var$$224bc56423ffe231$var$getForumsUrl = (url, isLoggedIn, email)=>isLoggedIn ? $24c02ea0e14dbe4f$var$$3dba2111a1a6d39b$export$1db7da00354b15ed({
        email: email,
        redirectUrl: url
    }) : url;
const $24c02ea0e14dbe4f$var$$224bc56423ffe231$var$ABOUT_LEARNING_URL = "https://community.atlassian.com/learning/hub/resources-and-support/about-atlassian-learning";
const $24c02ea0e14dbe4f$var$$224bc56423ffe231$var$RESOURCES_LEARNING_URL = "https://community.atlassian.com/learning/hub/resources-and-support";
const $24c02ea0e14dbe4f$var$$224bc56423ffe231$export$2680595b358b488a = ({ isLoggedIn: isLoggedIn = false, email: email, showAppUpdates: showAppUpdates = false })=>{
    return (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
        css: $24c02ea0e14dbe4f$export$220191dc35b80c46,
        children: [
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                css: $24c02ea0e14dbe4f$export$c5f2190049e47f52,
                children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                    css: $24c02ea0e14dbe4f$export$5939e41228734fb7,
                    children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("a", {
                        href: "/",
                        css: $24c02ea0e14dbe4f$export$a4c1071d1005664f,
                        children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$71f050e2efa708bb, {
                            size: "medium",
                            fontWeight: "semibold",
                            children: "Community"
                        })
                    })
                })
            }),
            (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                css: $24c02ea0e14dbe4f$export$c5f2190049e47f52,
                children: [
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                        css: $24c02ea0e14dbe4f$export$5939e41228734fb7,
                        children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("a", {
                            href: $24c02ea0e14dbe4f$var$$224bc56423ffe231$var$getForumsUrl($24c02ea0e14dbe4f$var$$224bc56423ffe231$var$FORUMS_URL, isLoggedIn, email),
                            css: $24c02ea0e14dbe4f$export$a4c1071d1005664f,
                            children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$71f050e2efa708bb, {
                                size: "medium",
                                fontWeight: "semibold",
                                children: "Forums"
                            })
                        })
                    }),
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$e0513c91be1318ca, {
                        href: $24c02ea0e14dbe4f$var$$224bc56423ffe231$var$getForumsUrl(`${$24c02ea0e14dbe4f$var$$224bc56423ffe231$var$FORUMS_URL}/help/faqpage`, isLoggedIn, email),
                        text: "FAQs"
                    }),
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$e0513c91be1318ca, {
                        href: $24c02ea0e14dbe4f$var$$224bc56423ffe231$var$getForumsUrl(`${$24c02ea0e14dbe4f$var$$224bc56423ffe231$var$FORUMS_URL}/custom/page/page-id/rules-of-engagement`, isLoggedIn, email),
                        text: "Forums guidelines"
                    })
                ]
            }),
            (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                css: $24c02ea0e14dbe4f$export$c5f2190049e47f52,
                children: [
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                        css: $24c02ea0e14dbe4f$export$5939e41228734fb7,
                        children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("a", {
                            href: $24c02ea0e14dbe4f$var$$1ff01338112cd7fe$export$fe0105b4860d6e11[$24c02ea0e14dbe4f$export$93d048dc21eb282a.LEARNING],
                            css: $24c02ea0e14dbe4f$export$a4c1071d1005664f,
                            children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$71f050e2efa708bb, {
                                size: "medium",
                                fontWeight: "semibold",
                                children: "Learning"
                            })
                        })
                    }),
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$e0513c91be1318ca, {
                        href: $24c02ea0e14dbe4f$var$$224bc56423ffe231$var$ABOUT_LEARNING_URL,
                        text: "About learning"
                    }),
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$e0513c91be1318ca, {
                        href: $24c02ea0e14dbe4f$var$$224bc56423ffe231$var$RESOURCES_LEARNING_URL,
                        text: "Resources"
                    })
                ]
            }),
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                css: $24c02ea0e14dbe4f$export$c5f2190049e47f52,
                children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                    css: $24c02ea0e14dbe4f$export$5939e41228734fb7,
                    children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("a", {
                        href: $24c02ea0e14dbe4f$var$$1ff01338112cd7fe$export$fe0105b4860d6e11[$24c02ea0e14dbe4f$export$93d048dc21eb282a.EVENTS],
                        css: $24c02ea0e14dbe4f$export$a4c1071d1005664f,
                        children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$71f050e2efa708bb, {
                            size: "medium",
                            fontWeight: "semibold",
                            children: "Events"
                        })
                    })
                })
            }),
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                css: $24c02ea0e14dbe4f$export$c5f2190049e47f52,
                children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                    css: $24c02ea0e14dbe4f$export$5939e41228734fb7,
                    children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("a", {
                        href: $24c02ea0e14dbe4f$var$$1ff01338112cd7fe$export$fe0105b4860d6e11[$24c02ea0e14dbe4f$export$93d048dc21eb282a.CHAMPIONS],
                        css: $24c02ea0e14dbe4f$export$a4c1071d1005664f,
                        children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$71f050e2efa708bb, {
                            size: "medium",
                            fontWeight: "semibold",
                            children: "Champions"
                        })
                    })
                })
            }),
            showAppUpdates ? (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                css: $24c02ea0e14dbe4f$export$c5f2190049e47f52,
                children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                    css: $24c02ea0e14dbe4f$export$5939e41228734fb7,
                    children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("a", {
                        href: $24c02ea0e14dbe4f$var$$1ff01338112cd7fe$export$fe0105b4860d6e11[$24c02ea0e14dbe4f$export$93d048dc21eb282a.APP_UPDATES],
                        css: $24c02ea0e14dbe4f$export$a4c1071d1005664f,
                        children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$71f050e2efa708bb, {
                            size: "medium",
                            fontWeight: "semibold",
                            children: "Release Notes"
                        })
                    })
                })
            }) : null
        ]
    });
};
const $24c02ea0e14dbe4f$export$7a92b4adf6bd95bb = ({ reportAProblemCallback: reportAProblemCallback, isLoggedIn: isLoggedIn = false, email: email, licenseData: licenseData, showAppUpdates: showAppUpdates = false })=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$var$$5a3292f3bef31812$export$f769621e3a03739f, {
        termsUrl: $24c02ea0e14dbe4f$var$$1ff01338112cd7fe$export$bc6e44c7f1ae99f6,
        reportAProblemCallback: reportAProblemCallback,
        licenseData: licenseData,
        nav: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$var$$224bc56423ffe231$export$2680595b358b488a, {
            isLoggedIn: isLoggedIn,
            email: email,
            showAppUpdates: showAppUpdates
        })
    });
const $24c02ea0e14dbe4f$export$8dce6dbf8ef18fcb = ({ termsUrl: termsUrl, nav: nav, reportAProblemCallback: reportAProblemCallback, licenseData: licenseData })=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$var$$5a3292f3bef31812$export$f769621e3a03739f, {
        termsUrl: termsUrl,
        nav: nav,
        reportAProblemCallback: reportAProblemCallback,
        licenseData: licenseData
    });
var $24c02ea0e14dbe4f$var$$b5ebb29d1a23bfec$export$2e2bcd8739ae039 = $24c02ea0e14dbe4f$export$7a92b4adf6bd95bb;
var $24c02ea0e14dbe4f$var$$77696804880d7cdc$exports = {};
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$77696804880d7cdc$exports, "DropdownMenu", ()=>$24c02ea0e14dbe4f$export$e44a253a59704894);
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$77696804880d7cdc$exports, "DropdownMenuCheckbox", ()=>$24c02ea0e14dbe4f$export$2393c31da95977ae);
// Main DropdownMenu component (config-based with items object or custom items array)
const $24c02ea0e14dbe4f$var$$0199732cf5257721$export$e960b0f5cc4a2826 = ({ items: items, onItemClick: onItemClick })=>{
    return (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $4efa9b4942c769d7$export$2e2bcd8739ae039), {
        id: "actions",
        children: Object.entries(items).map(([label, value])=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $9717609675842cd9$export$2e2bcd8739ae039), {
                testId: `dropdown-item-checkbox-${label}`,
                isDisabled: value.isDisabled,
                id: label,
                onClick: ()=>onItemClick(label),
                isSelected: value.isSelected,
                children: label
            }, label))
    });
};
const $24c02ea0e14dbe4f$var$$77e170ce1d4ab374$export$a6155c53cd00116c = ({ items: items, onItemClick: onItemClick })=>{
    return (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $d7f1a7874207c75a$export$2e2bcd8739ae039), {
        id: "actions",
        children: Object.entries(items).map(([label, value])=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $2f6caa8af3b1a588$export$2e2bcd8739ae039), {
                testId: `dropdown-item-checkbox-${label}`,
                isDisabled: value.isDisabled,
                id: label,
                onClick: ()=>onItemClick(label),
                isSelected: value.isSelected,
                children: label
            }, label))
    });
};
const $24c02ea0e14dbe4f$var$$0633f0dbed99c656$var$selectedItemStyles = (0, $74Zh5.css)({
    backgroundColor: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.background.selected.hovered"),
    fontWeight: 600
});
const $24c02ea0e14dbe4f$var$$0633f0dbed99c656$var$iconMenuStyles = (0, $74Zh5.css)({
    "& button > span": {
        gap: `${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.100")} !important`
    },
    // Ensure icon and text are vertically aligned
    '& button [role="img"]': {
        display: "flex !important"
    }
});
const $24c02ea0e14dbe4f$var$$0633f0dbed99c656$export$efefb5b75235a614 = ({ items: items, onItemClick: onItemClick })=>{
    return (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
        id: "actions",
        css: $24c02ea0e14dbe4f$var$$0633f0dbed99c656$var$iconMenuStyles,
        children: Object.entries(items).map(([label, value])=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                css: value.isSelected && $24c02ea0e14dbe4f$var$$0633f0dbed99c656$var$selectedItemStyles,
                children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $896b4f3af893fddb$export$2e2bcd8739ae039), {
                    testId: `dropdown-item-${label}`,
                    isDisabled: value.isDisabled,
                    onClick: ()=>onItemClick(label),
                    elemBefore: value.icon,
                    children: label
                })
            }, label))
    });
};
const $24c02ea0e14dbe4f$var$$69215f50d6c9f1e0$export$2165c09f364cf0ee = (0, $74Zh5.css)({
    "& > button": {
        border: `1px solid ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.border.brand")}`,
        padding: `${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.100")} ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.100")} ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.100")} ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.150")}`,
        background: "#fff",
        alignItems: "center",
        height: "40px",
        fontSize: "16px",
        lineHeight: "20px",
        fontWeight: 600,
        fontFamily: "Charlie Text, sans-serif",
        color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text.brand"),
        borderRadius: "4px",
        ":hover": {
            background: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.background.selected"),
            color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text.selected")
        }
    },
    svg: {
        width: "30px",
        height: "30px"
    }
});
const $24c02ea0e14dbe4f$var$$69215f50d6c9f1e0$export$a6df230d684a2658 = (0, $74Zh5.css)({
    "#actions": {
        "button[disabled]": {
            background: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.background.disabled"),
            span: {
                color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text.disabled"),
                ":hover": {
                    color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text.disabled")
                }
            },
            rect: {
                stroke: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.border.disabled")
            }
        },
        ":before, :after": {
            display: "none"
        },
        button: {
            padding: `${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.200")} ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.200")} ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.200")} 24px`,
            width: "220px",
            height: "48px",
            '[aria-checked="true"]:before': {
                content: '""',
                position: "absolute",
                top: 0,
                left: 0,
                width: "2px",
                height: "100%",
                background: `${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text.selected")}`
            },
            span: {
                gap: 0,
                span: {
                    fontFamily: "Inter, sans-serif",
                    fontSize: "16px",
                    lineHeight: "20px"
                }
            }
        }
    }
});
const $24c02ea0e14dbe4f$var$$69215f50d6c9f1e0$export$e42df41f371072da = (0, $74Zh5.css)({
    "& > button": {
        border: 0,
        background: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.background.selected")
    }
});
const $24c02ea0e14dbe4f$var$$69215f50d6c9f1e0$export$9ee5d5d0a4499fc5 = (0, $74Zh5.css)({
    display: "flex",
    alignItems: "center",
    gap: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.150"),
    paddingRight: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.100")
});
const $24c02ea0e14dbe4f$export$e44a253a59704894 = ({ items: items, placement: placement, onItemClick: onItemClick, customItems: customItems, isCheckboxMenu: isCheckboxMenu = false, triggerText: triggerText, customTriggerStyles: customTriggerStyles, customTriggerActiveStyles: customTriggerActiveStyles, customTriggerComponent: customTriggerComponent, isOptionMenu: isOptionMenu = false })=>{
    const [isDropdownOpen, setIsDropdownOpen] = (0, $5FkrB.useState)(false);
    const [itemsList, setItemList] = (0, $5FkrB.useState)(items ?? {});
    const isControlled = (0, $5FkrB.useRef)(false);
    const prevItemsRef = (0, $5FkrB.useRef)(items);
    // Check if we're using custom items mode
    const isCustomItemsMode = customItems && customItems.length > 0;
    (0, $5FkrB.useEffect)(()=>{
        if (!isCustomItemsMode && prevItemsRef.current !== items && items) {
            isControlled.current = true;
            setItemList(items);
            prevItemsRef.current = items;
        }
    }, [
        items,
        isCustomItemsMode
    ]);
    const handleItemClick = (label)=>{
        // Only update internal state if not controlled
        if (!isControlled.current) setItemList((prev)=>{
            const updatedState = {
                ...prev
            };
            if (isCheckboxMenu) updatedState[label].isSelected = !updatedState[label].isSelected;
            else Object.keys(updatedState).forEach((key)=>{
                updatedState[key].isSelected = key === label;
            });
            return updatedState;
        });
        if (onItemClick) onItemClick(label);
    };
    const getTriggerText = (itemsChecked)=>{
        const selectedItems = Object.keys(itemsChecked).filter((key)=>itemsChecked[key].isSelected);
        if (isCheckboxMenu) {
            if (triggerText) return triggerText;
            // For checkbox mode, show count of selected items or first item name
            if (selectedItems.length === 0) return Object.keys(itemsChecked)[0] || "Select items";
            else if (selectedItems.length === 1) return selectedItems[0];
            return `${selectedItems.length} selected`;
        }
        if (triggerText) return triggerText;
        // For radio mode, show the selected item or first item
        return selectedItems[0] || Object.keys(itemsChecked)[0];
    };
    const renderTrigger = ()=>{
        const selectedItems = Object.keys(itemsList).filter((key)=>itemsList[key]?.isSelected);
        // If custom trigger component is provided, use it
        if (customTriggerComponent) return customTriggerComponent;
        // For custom items mode, just use the triggerText
        if (isCustomItemsMode) return triggerText || "Menu";
        // If checkbox mode with custom trigger text and selections, render custom trigger with badge
        if (isCheckboxMenu && triggerText && selectedItems.length > 0) return ({ triggerRef: triggerRef, ...triggerButtonProps })=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("button", {
                ...triggerButtonProps,
                ref: triggerRef,
                children: (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("span", {
                    css: $24c02ea0e14dbe4f$var$$69215f50d6c9f1e0$export$9ee5d5d0a4499fc5,
                    children: [
                        triggerText,
                        (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $31a965b6dd4a0db8$export$2e2bcd8739ae039), {
                            isBold: true,
                            appearance: "inprogress",
                            children: selectedItems.length
                        })
                    ]
                })
            });
        // Otherwise return the text trigger
        return getTriggerText(itemsList);
    };
    const hasAnyIcons = Object.values(itemsList).some((item)=>item?.icon);
    const isAnyItemSelected = isCustomItemsMode ? false : Object.values(itemsList).some(({ isSelected: isSelected })=>isSelected);
    const renderMenuContent = ()=>{
        // Custom items mode - render custom DropdownItems
        if (isCustomItemsMode && customItems) return (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $6bec4f26b2cb3094$export$ffb0004e005737fa), {
            children: customItems.map((item, index)=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $896b4f3af893fddb$export$2e2bcd8739ae039), {
                    onClick: item.onClick,
                    isDisabled: item.isDisabled,
                    description: item.description,
                    elemBefore: item.elemBefore,
                    elemAfter: item.elemAfter,
                    testId: item.testId,
                    children: item.children
                }, item.testId ?? index))
        });
        if (isCheckboxMenu) return (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$var$$0199732cf5257721$export$e960b0f5cc4a2826, {
            items: itemsList,
            onItemClick: handleItemClick
        });
        if (isOptionMenu || hasAnyIcons) return (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$var$$0633f0dbed99c656$export$efefb5b75235a614, {
            items: itemsList,
            onItemClick: handleItemClick
        });
        return (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$var$$77e170ce1d4ab374$export$a6155c53cd00116c, {
            items: itemsList,
            onItemClick: handleItemClick
        });
    };
    // Combine base styles with actions styles for full DropdownMenu styling
    const combinedTriggerStyles = (0, $74Zh5.css)([
        $24c02ea0e14dbe4f$var$$69215f50d6c9f1e0$export$2165c09f364cf0ee,
        $24c02ea0e14dbe4f$var$$69215f50d6c9f1e0$export$a6df230d684a2658
    ]);
    return (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
        css: [
            combinedTriggerStyles,
            customTriggerStyles,
            isAnyItemSelected && isDropdownOpen && $24c02ea0e14dbe4f$var$$69215f50d6c9f1e0$export$e42df41f371072da,
            isAnyItemSelected && isDropdownOpen && customTriggerActiveStyles
        ],
        children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $9e29898158274f39$export$2e2bcd8739ae039), {
            onOpenChange: ({ isOpen: isOpen })=>setIsDropdownOpen(isOpen),
            trigger: renderTrigger(),
            shouldRenderToParent: true,
            placement: placement,
            children: renderMenuContent()
        })
    });
};
const $24c02ea0e14dbe4f$export$2393c31da95977ae = (props)=>{
    return (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$e44a253a59704894, {
        ...props,
        isCheckboxMenu: false
    });
};
var $24c02ea0e14dbe4f$var$$4366d2b05f9f8f6b$exports = {};
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$4366d2b05f9f8f6b$exports, "GreetingCard", ()=>$24c02ea0e14dbe4f$export$e52b3c28ffecde23);
const $24c02ea0e14dbe4f$var$$7a335ab395aac0f5$export$6b53fc34987132a8 = ()=>(0, $6bec4f26b2cb3094$export$25062201e9e25d76)("svg", {
        viewBox: "0 0 406 37",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("g", {
                clipPath: "url(#clip0_511_7308)",
                children: [
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("path", {
                        d: "M396.155 27.8221H394.244L388.065 11.4229H391.206L396.667 26.4205L402.129 11.4229H405.269L398.818 28.3828C396.906 33.3937 395.814 35.9867 391.479 35.9867C390.011 35.9867 389.192 35.8465 388.338 35.4961V32.9031C389.328 33.2185 390.455 33.3236 391.308 33.3236C393.697 33.3236 394.756 31.6416 396.155 27.8221Z",
                        fill: "#101214"
                    }),
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("path", {
                        d: "M382.705 23.5062C382.705 25.048 383.593 26.0992 385.402 26.0992C386.085 26.0992 386.733 25.9591 387.245 25.854V28.7624C386.733 28.9025 386.153 29.0427 385.265 29.0427C381.613 29.0427 379.838 26.8351 379.838 23.5763V14.2203H377.073V11.417H379.838V7.70264H382.705V11.417H387.245V14.2203H382.705V23.5062Z",
                        fill: "#101214"
                    }),
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("path", {
                        d: "M370.731 6.79681C370.731 5.46524 371.585 4.69434 372.779 4.69434C373.974 4.69434 374.827 5.46524 374.827 6.79681C374.827 8.12837 373.974 8.89928 372.779 8.89928C371.585 8.89928 370.731 8.12837 370.731 6.79681ZM371.278 28.9428V11.4222H374.213V28.9428H371.278Z",
                        fill: "#101214"
                    }),
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("path", {
                        d: "M367.184 18.6738V28.9408H364.248V18.3584C364.248 15.2047 363.019 13.803 360.22 13.803C357.49 13.803 355.612 15.6602 355.612 19.1994V28.9408H352.677V11.4202H355.612V14.2936C356.705 12.2262 358.718 11.0698 361.005 11.0698C364.931 11.0698 367.184 13.8381 367.184 18.6738Z",
                        fill: "#101214"
                    }),
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("path", {
                        d: "M333.733 21.6899V11.4229H336.669V22.0053C336.669 25.159 337.898 26.5606 340.697 26.5606C343.427 26.5606 345.305 24.7035 345.305 21.1643V11.4229H348.24V28.9434H345.305V26.0701C344.212 28.1375 342.199 29.2938 339.912 29.2938C335.986 29.2938 333.733 26.5256 333.733 21.6899Z",
                        fill: "#101214"
                    }),
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("path", {
                        d: "M318.416 19.1994V28.9408H315.48V18.3584C315.48 15.2047 314.252 13.803 311.453 13.803C308.722 13.803 306.845 15.6602 306.845 19.1994V28.9408H303.909V11.4202H306.845V14.2936C307.937 12.2262 309.951 11.0698 312.238 11.0698C315.139 11.0698 317.119 12.5766 317.972 15.3448C318.928 12.6467 321.215 11.0698 324.048 11.0698C327.871 11.0698 329.987 13.733 329.987 18.6738V28.9408H327.052V19.1994C327.052 15.5901 325.823 13.803 323.024 13.803C320.293 13.803 318.416 15.6602 318.416 19.1994Z",
                        fill: "#101214"
                    }),
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("path", {
                        d: "M288.249 19.1994V28.9408H285.314V18.3584C285.314 15.2047 284.085 13.803 281.286 13.803C278.555 13.803 276.678 15.6602 276.678 19.1994V28.9408H273.742V11.4202H276.678V14.2936C277.77 12.2262 279.784 11.0698 282.071 11.0698C284.972 11.0698 286.952 12.5766 287.805 15.3448C288.761 12.6467 291.048 11.0698 293.881 11.0698C297.704 11.0698 299.82 13.733 299.82 18.6738V28.9408H296.885V19.1994C296.885 15.5901 295.656 13.803 292.857 13.803C290.126 13.803 288.249 15.6602 288.249 19.1994Z",
                        fill: "#101214"
                    }),
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("path", {
                        d: "M262.275 29.2912C257.155 29.2912 254.151 25.4017 254.151 20.1455C254.151 14.8893 257.155 11.0698 262.275 11.0698C267.361 11.0698 270.331 14.8893 270.331 20.1455C270.331 25.4017 267.361 29.2912 262.275 29.2912ZM262.275 13.8731C258.623 13.8731 257.019 16.8166 257.019 20.1455C257.019 23.4744 258.623 26.4879 262.275 26.4879C265.893 26.4879 267.464 23.4744 267.464 20.1455C267.464 16.8166 265.893 13.8731 262.275 13.8731Z",
                        fill: "#101214"
                    }),
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("path", {
                        d: "M251.998 24.88V27.9285C250.598 28.8746 248.38 29.2951 246.059 29.2951C238.686 29.2951 234.521 24.7398 234.521 17.4863C234.521 10.478 238.686 5.57227 245.99 5.57227C248.175 5.57227 250.36 5.99276 251.964 7.18416V10.2327C250.36 9.18151 248.585 8.62085 245.99 8.62085C240.734 8.62085 237.594 12.195 237.594 17.4863C237.594 22.7775 240.836 26.2816 246.161 26.2816C248.516 26.2816 250.36 25.7209 251.998 24.88Z",
                        fill: "#101214"
                    }),
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("path", {
                        d: "M119.605 12.4499C119.605 15.8465 121.102 18.5153 127.168 19.7284C130.713 20.5371 131.501 21.1032 131.501 22.3163C131.501 23.5294 130.713 24.2572 128.192 24.2572C125.277 24.2572 121.811 23.2059 119.526 21.8311V27.3304C121.338 28.22 123.702 29.2713 128.192 29.2713C134.494 29.2713 136.936 26.3599 136.936 22.1546M136.936 22.2354C136.936 18.1918 134.888 16.3318 128.98 15.0378C125.75 14.3099 124.962 13.5821 124.962 12.5308C124.962 11.2368 126.144 10.6707 128.271 10.6707C130.87 10.6707 133.391 11.4794 135.833 12.6116V7.35493C134.1 6.46534 131.501 5.81836 128.428 5.81836C122.599 5.81836 119.605 8.40627 119.605 12.6116",
                        fill: "#1868DB"
                    }),
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("path", {
                        d: "M200.274 5.979V29.0276H205.08V11.4783L207.049 16.088L213.824 29.0276H219.811V5.979H215.085V20.8595L213.273 16.4924L207.837 5.979H200.274Z",
                        fill: "#1868DB"
                    }),
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("path", {
                        d: "M169.865 5.979H164.666V29.0276H169.865V5.979Z",
                        fill: "#1868DB"
                    }),
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("path", {
                        d: "M158.679 22.1554C158.679 18.1117 156.631 16.2517 150.723 14.9577C147.493 14.2299 146.705 13.502 146.705 12.4507C146.705 11.1567 147.887 10.5906 150.014 10.5906C152.614 10.5906 155.134 11.3993 157.577 12.5316V7.27485C155.843 6.38526 153.244 5.73828 150.171 5.73828C144.342 5.73828 141.348 8.32619 141.348 12.5316C141.348 15.9282 142.845 18.597 148.911 19.8101C152.456 20.6188 153.244 21.1849 153.244 22.398C153.244 23.6111 152.456 24.3389 149.935 24.3389C147.02 24.3389 143.554 23.2876 141.27 21.9127V27.412C143.081 28.3016 145.445 29.353 149.935 29.353C156.159 29.353 158.679 26.4416 158.679 22.1554Z",
                        fill: "#1868DB"
                    }),
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("path", {
                        d: "M79.1143 5.979V29.0276H89.828L91.4824 24.0135H84.3136V5.979H79.1143Z",
                        fill: "#1868DB"
                    }),
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("path", {
                        d: "M57.9219 5.979V10.9122H63.6727V29.0276H68.9508V10.9122H75.1742V5.979H57.9219Z",
                        fill: "#1868DB"
                    }),
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("path", {
                        d: "M50.2806 5.97412H43.4269L35.6279 29.0227H41.615L42.7179 25.1408C44.0572 25.5452 45.4752 25.7878 46.8932 25.7878C48.3112 25.7878 49.7292 25.5452 51.0684 25.1408L52.1713 29.0227H58.1584C58.0796 29.0227 50.2806 5.97412 50.2806 5.97412ZM46.8144 20.9355C45.7903 20.9355 44.8449 20.7737 43.9784 20.5311L46.8144 10.503L49.6504 20.5311C48.7838 20.7737 47.8385 20.9355 46.8144 20.9355Z",
                        fill: "#1868DB"
                    }),
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("path", {
                        d: "M108.339 5.97363H101.485L93.6074 29.0222H99.5945L100.697 25.1404C102.037 25.5447 103.455 25.7873 104.873 25.7873C106.291 25.7873 107.709 25.5447 109.048 25.1404L110.151 29.0222H116.138L108.339 5.97363ZM104.873 20.935C103.849 20.935 102.903 20.7733 102.037 20.5306L104.873 10.5025L107.709 20.5306C106.842 20.7733 105.897 20.935 104.873 20.935Z",
                        fill: "#1868DB"
                    }),
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("path", {
                        d: "M188.694 5.97363H181.84L174.041 29.0222H180.028L181.131 25.1404C182.47 25.5447 183.888 25.7873 185.306 25.7873C186.724 25.7873 188.142 25.5447 189.481 25.1404L190.584 29.0222H196.571L188.694 5.97363ZM185.306 20.935C184.282 20.935 183.337 20.7733 182.47 20.5306L185.306 10.5025L188.142 20.5306C187.276 20.7733 186.252 20.935 185.306 20.935Z",
                        fill: "#1868DB"
                    }),
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("g", {
                        clipPath: "url(#clip1_511_7308)",
                        children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("path", {
                            d: "M25.4715 28.1859L13.6868 3.70842C13.4549 3.1784 13.2229 3.08203 12.9445 3.08203C12.7125 3.08203 12.4342 3.1784 12.1558 3.66024C10.4855 6.40673 9.74318 9.58688 9.74318 12.9116C9.74318 17.5372 12.0166 21.8738 15.3571 28.8605C15.7283 29.6314 16.0067 29.776 16.6562 29.776H24.8219C25.4251 29.776 25.7498 29.5351 25.7498 29.0532C25.7498 28.8123 25.7034 28.6678 25.4715 28.1859ZM8.3513 16.6217C7.42338 15.1762 7.145 15.0799 6.91302 15.0799C6.68104 15.0799 6.54185 15.1762 6.12429 16.0435L0.231981 28.2823C0.0463961 28.6678 0 28.8123 0 29.005C0 29.3905 0.324773 29.776 1.02071 29.776H9.32562C9.88237 29.776 10.2999 29.2941 10.5319 28.3786C10.8103 27.2222 10.9031 26.2104 10.9031 25.0058C10.9031 21.6329 9.4648 18.3564 8.3513 16.6217Z",
                            fill: "#1868DB"
                        })
                    })
                ]
            }),
            (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("defs", {
                children: [
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("clipPath", {
                        id: "clip0_511_7308",
                        children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("rect", {
                            width: "406",
                            height: "37",
                            fill: "white"
                        })
                    }),
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("clipPath", {
                        id: "clip1_511_7308",
                        children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("rect", {
                            width: "25.7498",
                            height: "26.694",
                            fill: "white",
                            transform: "translate(0 3.08154)"
                        })
                    })
                ]
            })
        ]
    });
const $24c02ea0e14dbe4f$var$$0467da094044eefe$export$590b8cc7d4f1d823 = ()=>(0, $6bec4f26b2cb3094$export$25062201e9e25d76)("svg", {
        viewBox: "0 0 112 113",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("g", {
                id: "icon-launched-new",
                clipPath: "url(#clip0_608_7795)",
                children: (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("g", {
                    id: "Clip path group",
                    children: [
                        (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("mask", {
                            id: "mask0_608_7795",
                            "mask-type": "luminance",
                            maskUnits: "userSpaceOnUse",
                            x: "0",
                            y: "0",
                            width: "112",
                            height: "113",
                            children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("g", {
                                id: "clip0_10_2524",
                                children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("path", {
                                    id: "Vector",
                                    d: "M112 0.5H0V112.5H112V0.5Z",
                                    fill: "white"
                                })
                            })
                        }),
                        (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("g", {
                            mask: "url(#mask0_608_7795)",
                            children: (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("g", {
                                id: "Group",
                                children: [
                                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("path", {
                                        id: "Vector_2",
                                        fillRule: "evenodd",
                                        clipRule: "evenodd",
                                        d: "M69.4245 80.4295C67.168 95.2604 53.3169 105.459 38.486 103.203C23.6551 100.946 13.456 87.0952 15.7126 72.2643C17.9691 57.4334 31.8202 47.2344 46.6512 49.4909C61.4821 51.7475 71.6811 65.5986 69.4245 80.4295ZM39.5994 70.0078C39.926 67.8848 38.4711 65.9103 36.3482 65.5837C34.2253 65.2571 32.2508 66.712 31.9242 68.8349C31.5976 70.9579 33.0524 72.9324 35.1754 73.259C37.2983 73.5856 39.2728 72.1307 39.5994 70.0078ZM54.9499 72.3385C55.2765 70.2156 53.8217 68.2411 51.6987 67.9145C49.5758 67.5879 47.6013 69.0428 47.2747 71.1657C46.9481 73.2887 48.403 75.2632 50.5259 75.5898C52.6488 75.9164 54.6233 74.4615 54.9499 72.3385ZM33.8541 82.7454L32.132 80.3998L27.4407 83.844L29.1628 86.1896C34.6112 93.5828 45.0181 95.1713 52.4262 89.7229L54.7718 88.0008L51.3276 83.3096L48.9819 85.0317C44.1719 88.565 37.4022 87.5406 33.869 82.7306L33.8541 82.7454Z",
                                        fill: "#1868DB"
                                    }),
                                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("path", {
                                        id: "Vector_3",
                                        fillRule: "evenodd",
                                        clipRule: "evenodd",
                                        d: "M67.8214 26.5393C53.0795 29.3006 43.3555 43.4932 46.1169 58.2499C48.8782 72.9917 63.0707 82.7157 77.8125 79.9544C92.5544 77.1931 102.293 63.0005 99.5319 48.2587C96.7706 33.5168 82.5632 23.7929 67.8214 26.5393ZM78.6588 42.2758C80.7669 41.875 82.7859 43.2705 83.1867 45.3786C83.5875 47.4867 82.1921 49.5057 80.084 49.9066C77.9759 50.3074 75.9568 48.9119 75.556 46.8038C75.1552 44.6957 76.5507 42.6767 78.6588 42.2758ZM63.3973 45.1262C65.5054 44.7254 67.5244 46.1209 67.9253 48.229C68.3261 50.3371 66.9306 52.3561 64.8225 52.7569C62.7144 53.1578 60.6954 51.7623 60.2946 49.6542C59.8937 47.5461 61.2892 45.5271 63.3973 45.1262ZM76.3428 72.0713C68.9496 73.4519 61.8534 68.5974 60.4727 61.2339L87.1802 56.2308C88.5609 63.6092 83.6915 70.6906 76.328 72.0713H76.3428Z",
                                        fill: "#82B536"
                                    }),
                                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("path", {
                                        id: "Vector_4",
                                        fillRule: "evenodd",
                                        clipRule: "evenodd",
                                        d: "M69.3206 71.522C64.8966 69.9781 61.4079 66.1776 60.4874 61.2339L64.6145 60.4619C60.5023 54.7463 54.178 50.6341 46.666 49.4909C46.4285 49.4612 46.1761 49.4167 45.9386 49.4019C45.508 52.2671 45.5526 55.2511 46.1167 58.2499C46.7996 61.8575 48.1506 65.1532 50.036 68.0481C50.5556 67.8848 51.1346 67.8403 51.7136 67.9294C53.8217 68.256 55.2914 70.2305 54.9648 72.3534C54.9054 72.7394 54.7866 73.1105 54.6382 73.4371C58.7208 77.1189 63.8871 79.5387 69.4691 80.2217C69.8996 77.2525 69.8254 74.3279 69.3206 71.522Z",
                                        fill: "#09326C"
                                    }),
                                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("path", {
                                        id: "Vector_5",
                                        fillRule: "evenodd",
                                        clipRule: "evenodd",
                                        d: "M69.3206 71.522C64.8966 69.9781 61.4079 66.1776 60.4874 61.2339L64.6145 60.4619C60.5023 54.7463 54.178 50.6341 46.666 49.4909C46.4285 49.4612 46.1761 49.4167 45.9386 49.4019C45.508 52.2671 45.5526 55.2511 46.1167 58.2499C46.7996 61.8575 48.1506 65.1532 50.036 68.0481C50.5556 67.8848 51.1346 67.8403 51.7136 67.9294C53.8217 68.256 55.2914 70.2305 54.9648 72.3534C54.9054 72.7394 54.7866 73.1105 54.6382 73.4371C58.7208 77.1189 63.8871 79.5387 69.4691 80.2217C69.8996 77.2525 69.8254 74.3279 69.3206 71.522Z",
                                        fill: "#09326C"
                                    }),
                                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("path", {
                                        id: "Vector_6",
                                        d: "M37.1105 18.5589C35.4939 18.8626 33.943 19.3745 32.443 19.9453C32.443 19.9453 31.9357 20.0403 31.129 20.2877C30.3129 20.4878 29.2409 20.8857 28.0837 21.3496C25.7784 22.3248 23.3235 23.9635 22.2601 25.3038C18.8575 27.6207 15.8953 30.6524 13.728 34.2501C13.728 34.2501 13.6005 34.5506 13.3796 35.0267C13.172 35.4954 12.8711 36.1395 12.6779 36.8806C12.4487 37.5894 12.2232 38.3664 12.138 39.0812C12.0319 39.7904 11.9544 40.3955 12.0307 40.8082C12.1735 41.8321 12.4667 42.4724 12.8105 42.6457C13.1619 42.8321 13.577 42.5438 13.99 41.6956C14.1653 41.2628 14.3883 40.6978 14.6648 39.9797C14.8788 39.2444 15.2371 38.3922 15.6052 37.3413C15.6582 37.3111 15.7874 37.1677 15.863 37.1775C16.5848 34.9263 18.0622 33.0179 19.7393 31.3996C21.4298 29.7737 23.3598 28.4153 25.3445 27.0607C25.1727 26.9127 25.2076 26.665 25.3929 26.6826L25.5019 26.9363C26.7066 25.8143 27.936 25.2919 29.1048 24.7864C30.2944 24.2867 31.425 23.8377 32.7028 22.9372C32.7028 22.9372 32.4877 23.3925 32.4745 23.4001C34.8719 22.6182 37.6167 22.0775 40.4373 22.1955C43.2427 22.2869 46.1201 22.9688 48.4691 24.5119C50.8752 25.97 52.5652 28.3606 53.6246 30.9689C53.8516 31.6469 54.0785 32.3249 54.2715 33.0045C54.3962 33.6879 54.6001 34.449 54.6797 35.0528C54.8203 36.1657 54.6543 37.2947 54.118 38.2656L54.1709 38.2354L54.2011 38.2884C54.5424 38.0246 55.2229 36.9369 55.3721 35.7473C55.4646 35.1686 55.434 34.5896 55.3732 34.0806C55.3273 33.5979 55.2903 33.2857 55.2903 33.2857C55.5313 33.7102 55.7664 34.1555 55.9486 34.6309C56.0816 35.0815 56.188 35.5472 56.1791 36.0258C56.182 36.9888 55.8574 37.9623 55.2989 38.7703C54.191 40.4338 52.3157 41.2704 50.6424 41.536L50.6095 41.1688C52.0421 41.0046 52.9986 39.9706 53.223 39.5627C52.2579 40.3033 50.7995 40.8856 49.2811 40.5898C48.5361 40.4515 47.7197 40.1255 47.3784 39.7405C47.0447 39.3686 46.8665 38.8385 46.8708 38.0117C46.8985 36.3298 47.86 34.2232 48.8355 32.512C49.8283 30.7383 50.9433 29.211 51.8152 27.9971C51.4767 27.9261 50.7999 29.7309 49.8072 29.5578C50.7472 28.3402 51.6439 27.0771 52.6818 26.0321C53.0988 26.4268 52.386 26.9015 52.3552 27.0943C52.8898 26.7383 55.478 24.1295 59.4933 21.2541C63.5031 18.3996 69.0286 15.4039 74.4857 13.8324C79.9467 12.2062 85.1646 12.1912 88.1909 12.4555C91.1868 12.7897 92.2788 12.6434 89.3823 11.3409L89.7669 11.1225C86.5833 10.3337 83.8919 10.0724 80.3945 9.8125C79.908 9.91315 79.8439 9.86194 79.8865 10.1534C79.7671 10.2212 79.5682 10.334 79.6283 10.4402C79.7549 11.1575 78.6865 10.9748 78.2284 11.0944C78.351 9.91998 75.6295 10.2545 72.8735 11.3625C71.487 11.8865 70.1322 12.6203 69.0219 13.1979C67.9359 13.8492 67.1077 14.3369 66.7535 14.4854C66.0124 13.6432 64.1295 15.7642 63.1568 15.8426C63.1872 15.7728 63.4117 15.3647 63.4497 15.3081C62.9108 15.193 60.0007 17.2655 57.7814 19.2266C55.5546 21.1746 53.9377 22.899 54.9247 21.1462C53.2247 22.1988 51.4934 23.5672 49.7915 25.2347C48.1027 26.8946 46.436 28.8403 45.0442 31.2087C44.369 32.3987 43.6976 33.6567 43.277 35.1406C42.8754 36.5962 42.5394 38.2601 43.0769 40.165C43.2648 40.6195 43.4204 41.11 43.6821 41.5403C43.9836 41.9478 44.2736 42.397 44.6529 42.7255C45.038 43.0331 45.4249 43.3748 45.846 43.5916C46.2598 43.7953 46.6793 43.9782 47.1119 44.1534C48.7601 44.7088 50.6331 44.7333 52.3051 44.1876C55.7004 43.155 58.0935 39.9553 58.4079 36.5849C58.4804 35.7544 58.4471 34.8615 58.3055 34.1175C58.1656 33.4076 58.0184 32.6845 57.8785 31.9745C57.6573 31.2759 57.4569 30.5828 57.2433 29.8973C56.9823 29.2211 56.6814 28.5676 56.4072 27.8989C55.1699 25.2864 53.2694 23.0503 51.087 21.43C48.9049 19.8099 46.507 18.7681 44.2577 18.0804L44.3555 18.2528C44.2347 18.1635 43.7768 18.1603 43.679 17.9879C42.7253 18.0381 41.0604 18.071 39.6751 18.2259C38.2821 18.3675 37.1464 18.5912 37.1464 18.5912L37.1105 18.5589ZM50.547 43.0983C50.547 43.0983 50.5297 43.1608 50.5507 43.1665C50.5355 43.14 49.968 43.1289 49.3872 43.1252C48.7971 43.0743 48.2184 42.9818 48.1883 42.9288L48.2858 42.5753C48.8516 42.5523 49.5324 42.6394 50.2474 42.7248C50.6105 42.7466 50.968 42.7894 51.2971 42.813C51.6319 42.8158 51.9534 42.8262 52.2278 42.8459C52.7538 42.8456 53.1037 42.875 52.9613 43.026C52.8247 43.1561 52.1654 43.4778 50.8016 43.3924C50.6366 43.5035 50.594 43.212 50.547 43.0983ZM48.7248 28.3305C48.9904 28.0569 49.2619 27.7627 49.5787 27.4249C48.4351 29.7051 46.7257 32.0082 45.4672 34.7042C44.9032 36.0592 44.4354 37.5524 44.6239 39.0589C44.6303 39.4411 44.7788 39.7953 44.9272 40.1495C45.0283 40.5131 45.2962 40.7995 45.5166 41.0953C46.0031 41.6434 46.6452 42.0331 47.3106 42.2168C47.0285 42.3067 46.6746 42.3321 46.3172 42.2895C45.9844 42.1978 45.6066 42.0263 45.2194 41.8076C44.8968 41.5172 44.5439 41.1739 44.2898 40.7569C44.1094 40.3155 43.8119 39.853 43.8 39.3686C43.4767 37.3774 44.2801 35.6412 44.7204 34.5319C45.2518 32.0379 47.2732 29.8209 48.738 28.3229L48.7248 28.3305ZM75.3293 11.3017L75.292 11.1124L75.4605 11.0693C75.4605 11.0693 75.4734 11.1848 75.4336 11.2074C75.4222 11.249 75.3634 11.2999 75.3218 11.2885L75.3293 11.3017ZM39.9067 19.252C40.2934 18.9447 41.7287 19.2176 40.7452 19.7406C40.5072 19.6301 39.8026 19.8723 39.9067 19.252ZM52.7887 24.428C52.3491 23.9935 53.6243 22.6559 54.1751 23.2553C53.7406 23.6949 53.2325 24.0358 52.7887 24.428ZM26.807 23.1792C26.6704 23.9581 26.4775 23.2785 26.1416 22.9955C26.2853 23.0016 26.7001 22.8364 26.7504 23.1412L26.807 23.1792ZM20.0624 28.3223C20.1883 28.6368 19.9807 29.1055 19.8459 29.2696C19.2644 29.5119 19.686 28.3081 20.0624 28.3223ZM12.8127 39.961C13.1396 40.0737 13.1576 40.4142 12.8019 40.4056C12.5581 40.3159 12.4933 39.8617 12.8923 39.9158C12.8923 39.9158 12.845 39.9252 12.826 39.9535L12.8127 39.961ZM59.9658 20.1089C60.1746 21.2182 58.4067 21.5025 57.8937 22.2673C57.4082 21.3502 59.1026 20.9673 59.526 20.4464C59.7175 20.3202 59.8616 20.2033 59.9658 20.1089ZM51.5342 25.7714C51.2097 26.0959 50.8889 25.8395 50.5815 25.4527C50.2554 25.0941 49.8839 24.656 49.6192 24.5607L49.8434 24.2757C50.2098 24.4886 50.5195 24.6636 50.8161 24.8461C51.0936 25.0569 51.3198 25.3318 51.5191 25.7448L51.5342 25.7714ZM48.7068 31.8834C48.8548 32.3607 48.2335 32.6255 48.0926 32.9336C47.6072 32.6655 48.3318 31.3773 48.7068 31.8834ZM49.8278 41.2441C49.8866 41.8421 49.2689 41.5263 49.0854 41.5428C49.237 41.4392 49.4801 41.1258 49.6106 41.1394C49.6996 41.1415 49.7239 41.2154 49.8278 41.2441ZM52.2354 25.9873C52.6331 26.5333 53.1404 27.0872 53.4601 27.7125L53.1417 27.8932C52.8087 27.2754 52.3316 26.7745 51.9396 26.2077L52.2221 25.9948L52.2354 25.9873ZM54.8127 32.2588L54.4625 32.3525C53.8595 31.5372 54.7063 31.1442 54.7977 32.2324L54.8127 32.2588ZM44.6137 21.8595C44.7044 21.8958 44.8517 21.97 44.9482 21.9854C46.2715 22.3392 44.0824 23.0555 44.6137 21.8595ZM37.2998 21.7663C37.1672 21.8416 36.9889 21.9602 36.8452 21.9541C35.8442 22.0136 36.8308 21.0328 37.2998 21.7663Z",
                                        fill: "#09326C"
                                    })
                                ]
                            })
                        })
                    ]
                })
            }),
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("defs", {
                children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("clipPath", {
                    id: "clip0_608_7795",
                    children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("rect", {
                        width: "112",
                        height: "112",
                        fill: "white",
                        transform: "translate(0 0.5)"
                    })
                })
            })
        ]
    });
const $24c02ea0e14dbe4f$export$e52b3c28ffecde23 = ({ onClickLogIn: onClickLogIn, onClickContinue: onClickContinue })=>{
    return (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
        css: $24c02ea0e14dbe4f$var$$4366d2b05f9f8f6b$var$overlayStyles,
        children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
            css: $24c02ea0e14dbe4f$var$$4366d2b05f9f8f6b$var$containerStyles,
            children: (0, $6bec4f26b2cb3094$export$25062201e9e25d76)((0, $bdfb9b3a36dcb2bb$export$2e2bcd8739ae039), {
                alignInline: "center",
                alignBlock: "center",
                grow: "fill",
                xcss: $24c02ea0e14dbe4f$var$$4366d2b05f9f8f6b$var$containerStackStyles,
                children: [
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                        css: $24c02ea0e14dbe4f$var$$4366d2b05f9f8f6b$var$logoStyles,
                        children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$var$$0467da094044eefe$export$590b8cc7d4f1d823, {})
                    }),
                    (0, $6bec4f26b2cb3094$export$25062201e9e25d76)((0, $bdfb9b3a36dcb2bb$export$2e2bcd8739ae039), {
                        alignInline: "center",
                        alignBlock: "center",
                        space: "space.200",
                        xcss: $24c02ea0e14dbe4f$var$$4366d2b05f9f8f6b$var$middleStackStyles,
                        children: [
                            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                                css: $24c02ea0e14dbe4f$var$$4366d2b05f9f8f6b$var$communityLogoStyles,
                                children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$var$$7a335ab395aac0f5$export$6b53fc34987132a8, {})
                            }),
                            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$a8a3e93435678ff9, {
                                level: 3,
                                children: "We've launched something new"
                            }),
                            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$5f1af8db9871e1d6, {
                                children: "We've logged you out. Log back in to see what's changed"
                            })
                        ]
                    }),
                    (0, $6bec4f26b2cb3094$export$25062201e9e25d76)((0, $0c22dfc1af284338$export$2e2bcd8739ae039), {
                        space: "space.200",
                        shouldWrap: true,
                        children: [
                            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                                css: $24c02ea0e14dbe4f$var$$4366d2b05f9f8f6b$var$buttonContainerStyles,
                                children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$353f5b6fc5456de1, {
                                    appearance: $24c02ea0e14dbe4f$export$261c9483fc4a455a.SECONDARY,
                                    label: "Continue without logging in",
                                    fullWidth: true,
                                    onClick: onClickContinue
                                })
                            }),
                            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                                css: $24c02ea0e14dbe4f$var$$4366d2b05f9f8f6b$var$buttonContainerStyles,
                                children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$353f5b6fc5456de1, {
                                    appearance: $24c02ea0e14dbe4f$export$261c9483fc4a455a.PRIMARY,
                                    label: "Log back in",
                                    fullWidth: true,
                                    onClick: onClickLogIn
                                })
                            })
                        ]
                    })
                ]
            })
        })
    });
};
const $24c02ea0e14dbe4f$var$$4366d2b05f9f8f6b$var$overlayStyles = (0, $74Zh5.css)({
    position: "fixed",
    zIndex: (0, $0ce0c6f54e6e45da$export$7be255094ccdc533).blanket(),
    inset: 0,
    backgroundColor: "white",
    overflowY: "auto",
    pointerEvents: "initial",
    fontFamily: "Charlie Display, sans-serif"
});
const $24c02ea0e14dbe4f$var$$4366d2b05f9f8f6b$var$containerStackStyles = (0, $7c2f920c3bda89b1$export$f6c783d06584602c)({
    height: "100%"
});
const $24c02ea0e14dbe4f$var$$4366d2b05f9f8f6b$var$middleStackStyles = (0, $7c2f920c3bda89b1$export$f6c783d06584602c)({
    marginBottom: "space.500"
});
const $24c02ea0e14dbe4f$var$$4366d2b05f9f8f6b$var$containerStyles = (0, $74Zh5.css)({
    position: "absolute",
    width: "100%",
    marginLeft: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.200"),
    marginRight: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.200"),
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    "@media(min-width: 1280px)": {
        width: "720px",
        height: "480px"
    },
    "@media (min-width: 768px) and (max-width: 1279px)": {
        width: "656px"
    }
});
const $24c02ea0e14dbe4f$var$$4366d2b05f9f8f6b$var$communityLogoStyles = (0, $74Zh5.css)({
    width: "406px",
    "@media(max-width: 767px)": {
        width: "90%"
    }
});
const $24c02ea0e14dbe4f$var$$4366d2b05f9f8f6b$var$logoStyles = (0, $74Zh5.css)({
    width: "112px",
    height: "112px",
    borderRadius: "50%",
    border: "1px solid black",
    marginBottom: "24px"
});
const $24c02ea0e14dbe4f$var$$4366d2b05f9f8f6b$var$buttonContainerStyles = (0, $74Zh5.css)({
    "@media(max-width: 767px)": {
        width: "100%"
    }
});
var $24c02ea0e14dbe4f$var$$be203e745bcefb12$exports = {};
$24c02ea0e14dbe4f$var$$parcel$defineInteropFlag($24c02ea0e14dbe4f$var$$be203e745bcefb12$exports);
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$be203e745bcefb12$exports, "Error", ()=>$24c02ea0e14dbe4f$export$edf27be85e5f6da0);
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$be203e745bcefb12$exports, "default", ()=>$24c02ea0e14dbe4f$var$$be203e745bcefb12$export$2e2bcd8739ae039);
const $24c02ea0e14dbe4f$var$$72560d06a87aac8e$export$87321d307719eaf2 = (props)=>{
    return (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("svg", {
        width: "96",
        height: "89",
        viewBox: "0 0 96 89",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("path", {
                d: "M0.576172 88.4576L0.628536 88.5623H95.366L95.4242 88.4576L48.0002 0.8125L0.576172 88.4576Z",
                fill: "#DDDEE1"
            }),
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("path", {
                d: "M48.1641 32.2012V64.207",
                stroke: "white",
                strokeWidth: "7.33",
                strokeMiterlimit: "10"
            }),
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("path", {
                d: "M50.4025 74.1797C50.4316 74.0284 50.4433 73.8655 50.4433 73.6968C50.4433 73.528 50.4316 73.3593 50.4025 73.208C50.2396 72.2946 49.6054 71.736 48.7153 71.5906C48.564 71.5673 48.4069 71.5557 48.2382 71.5557C48.0694 71.5557 47.9007 71.5673 47.7436 71.5964C46.8534 71.7418 46.2251 72.3062 46.0564 73.2138C46.0273 73.3651 46.0156 73.528 46.0156 73.7026C46.0156 73.8771 46.0273 74.0342 46.0564 74.1855C46.2193 75.0931 46.8534 75.6517 47.7436 75.8029C47.9007 75.832 48.0694 75.8437 48.2382 75.8437C48.4069 75.8437 48.564 75.832 48.7153 75.8088C49.6054 75.6633 50.2396 75.0989 50.4025 74.1913V74.1797Z",
                stroke: "white",
                strokeWidth: "7.33",
                strokeMiterlimit: "10"
            })
        ]
    });
};
const $24c02ea0e14dbe4f$export$edf27be85e5f6da0 = ({ onClickLogout: onClickLogout, errorMessage: errorMessage })=>{
    return (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
        css: $24c02ea0e14dbe4f$var$$be203e745bcefb12$var$pageStyles,
        children: (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
            css: $24c02ea0e14dbe4f$var$$be203e745bcefb12$var$containerStyles,
            children: [
                (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$var$$72560d06a87aac8e$export$87321d307719eaf2, {}),
                (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("h1", {
                    css: $24c02ea0e14dbe4f$var$$be203e745bcefb12$var$headingStyles,
                    children: "Error"
                }),
                (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("p", {
                    css: $24c02ea0e14dbe4f$var$$be203e745bcefb12$var$descriptionStyles,
                    children: errorMessage
                }),
                (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$353f5b6fc5456de1, {
                    label: "Log out",
                    appearance: $24c02ea0e14dbe4f$export$261c9483fc4a455a.LINK,
                    onClick: onClickLogout
                })
            ]
        })
    });
};
var $24c02ea0e14dbe4f$var$$be203e745bcefb12$export$2e2bcd8739ae039 = $24c02ea0e14dbe4f$export$edf27be85e5f6da0;
const $24c02ea0e14dbe4f$var$$be203e745bcefb12$var$pageStyles = (0, $74Zh5.css)({
    display: "flex",
    width: "100%",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center"
});
const $24c02ea0e14dbe4f$var$$be203e745bcefb12$var$containerStyles = (0, $74Zh5.css)({
    maxWidth: "800px",
    minWidth: "375px",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    padding: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.600")
});
const $24c02ea0e14dbe4f$var$$be203e745bcefb12$var$headingStyles = (0, $74Zh5.css)({
    marginTop: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.300"),
    marginBottom: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.200"),
    fontFamily: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("font.family.brand.heading"),
    fontSize: "24px",
    fontWeight: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("font.weight.semibold"),
    lineHeight: "32px",
    textAlign: "center"
});
const $24c02ea0e14dbe4f$var$$be203e745bcefb12$var$descriptionStyles = (0, $74Zh5.css)({
    marginBottom: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.200"),
    color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text"),
    fontFamily: "Inter",
    fontWeight: "400",
    lineHeight: "20px",
    textAlign: "center",
    fontSize: "16px"
});
var $24c02ea0e14dbe4f$var$$1db60c687807de63$exports = {};
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$1db60c687807de63$exports, "SUCCESS_MESSAGE", ()=>$24c02ea0e14dbe4f$export$5620dbefc1cb6f80);
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$1db60c687807de63$exports, "ERROR_MESSAGE", ()=>$24c02ea0e14dbe4f$export$3f27bc10068ef877);
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$1db60c687807de63$exports, "NewsletterSignup", ()=>$24c02ea0e14dbe4f$export$21041608e6399292);
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$1db60c687807de63$exports, "Environment", ()=>$24c02ea0e14dbe4f$export$7dc6752a22ab011a);
var $24c02ea0e14dbe4f$var$$ca43fe01b6155439$exports = {};
var $24c02ea0e14dbe4f$var$$3ced3ef7e9864bf1$exports = {};
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$3ced3ef7e9864bf1$exports, "DESKTOP_SCREEN_WIDTH", ()=>$24c02ea0e14dbe4f$export$27ed77542911fb0e);
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$3ced3ef7e9864bf1$exports, "TABLET_SCREEN_WIDTH", ()=>$24c02ea0e14dbe4f$export$62d1d6124a8e4649);
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$3ced3ef7e9864bf1$exports, "useDeviceSize", ()=>$24c02ea0e14dbe4f$export$4616d33c54ae5baf);
// Default to a common desktop device width (is used to handle window object not being available during SSR)
const $24c02ea0e14dbe4f$var$$3ced3ef7e9864bf1$var$DEFAULT_WIDTH = 1440;
const $24c02ea0e14dbe4f$export$27ed77542911fb0e = 1024;
const $24c02ea0e14dbe4f$export$62d1d6124a8e4649 = 900;
const $24c02ea0e14dbe4f$export$4616d33c54ae5baf = ()=>{
    const [width, setWidth] = (0, $5FkrB.useState)(typeof window !== "undefined" ? window.innerWidth : $24c02ea0e14dbe4f$var$$3ced3ef7e9864bf1$var$DEFAULT_WIDTH);
    const handleWindowResize = ()=>{
        setWidth(window.innerWidth);
    };
    (0, $5FkrB.useEffect)(()=>{
        if (typeof window === "undefined") return;
        if (width === $24c02ea0e14dbe4f$var$$3ced3ef7e9864bf1$var$DEFAULT_WIDTH && width !== window.innerWidth) handleWindowResize();
        window.addEventListener("resize", handleWindowResize);
        return ()=>window.removeEventListener("resize", handleWindowResize);
    // width intentionally excluded (stable state setter)
    /* eslint-disable react-hooks/exhaustive-deps */ }, []);
    /* eslint-enable react-hooks/exhaustive-deps */ return width;
};
var $24c02ea0e14dbe4f$var$$cbd57b1b072c1da3$exports = {};
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$cbd57b1b072c1da3$exports, "usePostNewsletterSignup", ()=>$24c02ea0e14dbe4f$export$ea96d97e8873ca7f);
const $24c02ea0e14dbe4f$var$$cbd57b1b072c1da3$var$NEWSLETTER_FORM_TYPE = "community_learning_signup";
const $24c02ea0e14dbe4f$var$$cbd57b1b072c1da3$var$NEWSLETTER_FORM_DEF = "pointALead";
const $24c02ea0e14dbe4f$var$$cbd57b1b072c1da3$var$WAC_BASE_URL = {
    [$24c02ea0e14dbe4f$export$7dc6752a22ab011a.LOCAL]: "/api/wac",
    [$24c02ea0e14dbe4f$export$7dc6752a22ab011a.DEVELOPMENT]: "https://wac.stg.internal.atlassian.com",
    [$24c02ea0e14dbe4f$export$7dc6752a22ab011a.STAGING]: "https://wac.stg.internal.atlassian.com",
    [$24c02ea0e14dbe4f$export$7dc6752a22ab011a.PRODUCTION]: "https://www.atlassian.com"
};
const $24c02ea0e14dbe4f$export$ea96d97e8873ca7f = ({ environment: environment = $24c02ea0e14dbe4f$export$7dc6752a22ab011a.DEVELOPMENT, onError: onError = ()=>null, onSuccess: onSuccess = ()=>null })=>{
    const [loading, setLoading] = (0, $5FkrB.useState)(false);
    const [error, setError] = (0, $5FkrB.useState)(null);
    const [success, setSuccess] = (0, $5FkrB.useState)(false);
    const handleNewsletterSignup = async (formValues, formUrl)=>{
        setLoading(true);
        setError(null);
        setSuccess(false);
        try {
            const preferencesResponse = await $24c02ea0e14dbe4f$var$$cbd57b1b072c1da3$var$postPreferencesUpdate(formValues, environment, formUrl);
            if (!preferencesResponse.ok || preferencesResponse.status !== 202) throw new Error(`Error in postPreferencesUpdate with status: ${preferencesResponse.status}`);
            const wacResponse = await $24c02ea0e14dbe4f$var$$cbd57b1b072c1da3$var$postWacFormLead(formValues, environment);
            if (!wacResponse.ok || wacResponse.status !== 200) throw new Error(`Error in postWacFormLead with status: ${wacResponse.status}`);
            onSuccess();
            setSuccess(true);
        } catch (error) {
            if (error instanceof Error) setError(error.message);
            onError(error);
        } finally{
            setLoading(false);
        }
    };
    return {
        handleNewsletterSignup: handleNewsletterSignup,
        loading: loading,
        error: error,
        success: success
    };
};
const $24c02ea0e14dbe4f$var$$cbd57b1b072c1da3$var$postPreferencesUpdate = async (formValues, environment, formUrl)=>{
    const locale = navigator.language || Intl.DateTimeFormat().resolvedOptions().locale;
    const region = locale.split("-")[1];
    const requestOptions = {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify({
            consentCheckboxValue: true,
            consentLabelText: "By signing up, you agree to receive promotional emails including product news, events, and more from Atlassian and its affiliates, and acknowledge and accept the Atlassian Privacy Policy.",
            email: formValues.email,
            formUrl: formUrl || "https://community.atlassian.com/",
            formId: "655e8a50-2d1f-4c1c-a782-fb5333e272a8",
            locale: region,
            paramsLocale: region,
            privacyPolicyText: '<p>By signing up, you agree to receive promotional emails including product news, events, and more from Atlassian and its affiliates, and acknowledge and accept the Atlassian Privacy Policy. <a href=\\"https://www.atlassian.com/legal/privacy-policy#what-this-policy-covers\\">Atlassian Privacy Policy</a>.</p>\n',
            site: "atlassian"
        })
    };
    return fetch($24c02ea0e14dbe4f$var$$cbd57b1b072c1da3$var$WAC_BASE_URL[environment] + "/gateway/api/preferencesV2/update", requestOptions);
};
// Initiates POST to /streamhub/wacformlead
// Endpoint in: https://bitbucket.org/atlassian/bxp-express/src/routes/streamhubSubmission.ts
const $24c02ea0e14dbe4f$var$$cbd57b1b072c1da3$var$postWacFormLead = async (formValues, environment)=>{
    const now = new Date();
    const requestOptions = {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify({
            ...formValues,
            formType: $24c02ea0e14dbe4f$var$$cbd57b1b072c1da3$var$NEWSLETTER_FORM_TYPE,
            formDef: $24c02ea0e14dbe4f$var$$cbd57b1b072c1da3$var$NEWSLETTER_FORM_DEF,
            created_at: now.toISOString(),
            submitted: now.toString()
        })
    };
    return fetch($24c02ea0e14dbe4f$var$$cbd57b1b072c1da3$var$WAC_BASE_URL[environment] + "/endpoint/streamhub/wacformlead", requestOptions);
};
var $24c02ea0e14dbe4f$var$$18cdd3872ade1318$exports = {};
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$18cdd3872ade1318$exports, "useScrollActiveSection", ()=>$24c02ea0e14dbe4f$export$c0e9cacf89df0750);
const $24c02ea0e14dbe4f$export$c0e9cacf89df0750 = ({ links: links, containerRef: containerRef, options: options = {} })=>{
    const [activeHref, setActiveHref] = (0, $5FkrB.useState)("");
    const { triggerPoint: triggerPoint = 0.3, topThreshold: topThreshold = 100 } = options;
    (0, $5FkrB.useEffect)(()=>{
        // Derive section IDs from links
        const linkHrefs = links.map((link)=>link.href ? link.href : $24c02ea0e14dbe4f$export$1bdcd43c8c2377cf(link.label));
        const sectionIds = linkHrefs.map((href)=>href.replace("#", ""));
        // Find sections by the IDs we derived from links
        const sections = sectionIds.map((id)=>document.getElementById(id)).filter(Boolean);
        if (sections.length === 0) return;
        const container = containerRef?.current;
        const isWindowScroll = !container;
        let ticking = false;
        const updateActiveSection = ()=>{
            // Get scroll position and dimensions
            const scrollY = isWindowScroll ? window.scrollY : container.scrollTop;
            const viewportHeight = isWindowScroll ? window.innerHeight : container.clientHeight;
            const triggerPointPx = viewportHeight * triggerPoint;
            // If we're at the very top, always select the first section
            if (scrollY < topThreshold) {
                setActiveHref(linkHrefs[0]);
                return;
            }
            // Find which section is currently at the trigger point
            let currentSectionIndex = 0;
            sections.forEach((section, index)=>{
                const rect = section.getBoundingClientRect();
                if (isWindowScroll) {
                    if (rect.top <= triggerPointPx) currentSectionIndex = index;
                } else {
                    // For container scroll, calculate relative position
                    const containerRect = container.getBoundingClientRect();
                    const relativeTop = rect.top - containerRect.top;
                    if (relativeTop <= triggerPointPx) currentSectionIndex = index;
                }
            });
            setActiveHref(linkHrefs[currentSectionIndex]);
        };
        const handleScroll = ()=>{
            if (!ticking) {
                window.requestAnimationFrame(()=>{
                    updateActiveSection();
                    ticking = false;
                });
                ticking = true;
            }
        };
        // Set initial active section
        updateActiveSection();
        // Attach scroll listener to container or window
        if (isWindowScroll) window.addEventListener("scroll", handleScroll, {
            passive: true
        });
        else container.addEventListener("scroll", handleScroll, {
            passive: true
        });
        return ()=>{
            if (isWindowScroll) window.removeEventListener("scroll", handleScroll);
            else container.removeEventListener("scroll", handleScroll);
        };
    }, [
        links,
        containerRef,
        triggerPoint,
        topThreshold
    ]);
    return activeHref;
};
$24c02ea0e14dbe4f$var$$parcel$exportWildcard($24c02ea0e14dbe4f$var$$ca43fe01b6155439$exports, $24c02ea0e14dbe4f$var$$3ced3ef7e9864bf1$exports);
$24c02ea0e14dbe4f$var$$parcel$exportWildcard($24c02ea0e14dbe4f$var$$ca43fe01b6155439$exports, $24c02ea0e14dbe4f$var$$633811e9cd66d921$exports);
$24c02ea0e14dbe4f$var$$parcel$exportWildcard($24c02ea0e14dbe4f$var$$ca43fe01b6155439$exports, $24c02ea0e14dbe4f$var$$6e8a4d5d78071ed7$exports);
$24c02ea0e14dbe4f$var$$parcel$exportWildcard($24c02ea0e14dbe4f$var$$ca43fe01b6155439$exports, $24c02ea0e14dbe4f$var$$965a3cfbe886b380$exports);
$24c02ea0e14dbe4f$var$$parcel$exportWildcard($24c02ea0e14dbe4f$var$$ca43fe01b6155439$exports, $24c02ea0e14dbe4f$var$$cbd57b1b072c1da3$exports);
$24c02ea0e14dbe4f$var$$parcel$exportWildcard($24c02ea0e14dbe4f$var$$ca43fe01b6155439$exports, $24c02ea0e14dbe4f$var$$18cdd3872ade1318$exports);
var $24c02ea0e14dbe4f$var$$a6a41c835fd01d00$exports = {};
var $24c02ea0e14dbe4f$var$$1ca64a7075ab6eae$exports = {};
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$1ca64a7075ab6eae$exports, "TextField", ()=>$24c02ea0e14dbe4f$export$2c73285ae9390cec);
const $24c02ea0e14dbe4f$export$2c73285ae9390cec = ({ isInvalid: isInvalid = false, onChange: onChange = ()=>{
    return null;
}, value: value, isDisabled: isDisabled = false, isRequired: isRequired = false, ...rest })=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("input", {
        css: [
            $24c02ea0e14dbe4f$var$$1ca64a7075ab6eae$var$inputStyles,
            isInvalid && $24c02ea0e14dbe4f$var$$1ca64a7075ab6eae$var$invalidStyles,
            isDisabled && $24c02ea0e14dbe4f$var$$1ca64a7075ab6eae$var$disabledStyles
        ],
        onChange: onChange,
        disabled: isDisabled,
        value: value,
        required: isRequired,
        ...rest
    });
const $24c02ea0e14dbe4f$var$$1ca64a7075ab6eae$var$inputStyles = (0, $74Zh5.css)({
    width: "100%",
    height: "42px",
    fontWeight: 400,
    display: "flex",
    padding: "8px 12px",
    alignItems: "center",
    gap: "6px",
    alignSelf: "stretch",
    borderRadius: "4px",
    border: "1px solid #8590A2",
    background: "#FFFFFF",
    fontFamily: "inter",
    fontSize: "16px",
    "&:hover": {
        background: "#F7F8F9"
    },
    "&:focus": {
        borderColor: "inherit",
        boxShadow: "none",
        border: "1px solid #388BFF",
        outline: "1px solid #388BFF"
    }
});
const $24c02ea0e14dbe4f$var$$1ca64a7075ab6eae$var$invalidStyles = (0, $74Zh5.css)({
    border: "1px solid #C9372C",
    outline: "1px solid #C9372C"
});
const $24c02ea0e14dbe4f$var$$1ca64a7075ab6eae$var$disabledStyles = (0, $74Zh5.css)({
    color: "#091E424F",
    border: "1px solid #091E420F",
    background: "#091E4208"
});
var $24c02ea0e14dbe4f$var$$60ab015507144a2b$exports = {};
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$60ab015507144a2b$exports, "TextFieldMessage", ()=>$24c02ea0e14dbe4f$export$9144c5f9beecc4b7);
const $24c02ea0e14dbe4f$export$9144c5f9beecc4b7 = ({ message: message = "Example text here", type: type = "valid" })=>(0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
        css: $24c02ea0e14dbe4f$var$$60ab015507144a2b$var$spacing,
        children: [
            type === "helper" && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $3433a9f6c8d902bf$export$8fbe3c7d0ed2c683), {
                children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("p", {
                    css: $24c02ea0e14dbe4f$var$$60ab015507144a2b$var$helperMessageStyle,
                    children: message
                })
            }),
            type === "error" && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $3433a9f6c8d902bf$export$915e9e7bd4f0f96d), {
                children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("p", {
                    css: $24c02ea0e14dbe4f$var$$60ab015507144a2b$var$errorMessageStyle,
                    children: message
                })
            }),
            type === "valid" && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $3433a9f6c8d902bf$export$5505afb209a532c8), {
                children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("p", {
                    css: $24c02ea0e14dbe4f$var$$60ab015507144a2b$var$validMessageStyles,
                    children: message
                })
            })
        ]
    });
const $24c02ea0e14dbe4f$var$$60ab015507144a2b$var$spacing = (0, $74Zh5.css)({
    marginTop: "2px"
});
const $24c02ea0e14dbe4f$var$$60ab015507144a2b$var$helperMessageStyle = (0, $74Zh5.css)({
    fontFamily: "Inter",
    fontSize: "12px",
    fontStyle: "normal",
    fontWeight: 400,
    lineHeight: "16px"
});
const $24c02ea0e14dbe4f$var$$60ab015507144a2b$var$errorMessageStyle = (0, $74Zh5.css)({
    paddingLeft: "6px",
    fontFamily: "Inter",
    marginTop: "0.5px",
    fontSize: "12px",
    fontStyle: "normal",
    fontWeight: 400,
    lineHeight: "16px"
});
const $24c02ea0e14dbe4f$var$$60ab015507144a2b$var$validMessageStyles = (0, $74Zh5.css)({
    paddingLeft: "6px",
    fontFamily: "Inter",
    fontSize: "12px",
    fontStyle: "normal",
    fontWeight: 400,
    lineHeight: "16px"
});
var $24c02ea0e14dbe4f$var$$57b1d5df6b5425d4$exports = {};
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$57b1d5df6b5425d4$exports, "TextFieldLabel", ()=>$24c02ea0e14dbe4f$export$76375b2580d1f8ac);
const $24c02ea0e14dbe4f$export$76375b2580d1f8ac = ({ labelText: labelText = "Example label", isRequired: isRequired = true })=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $5ac1013239c7eb7f$export$b04be29aa201d4f5), {
        htmlFor: "basic-textfield",
        children: (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("p", {
            css: $24c02ea0e14dbe4f$var$$57b1d5df6b5425d4$var$labelStyles,
            children: [
                labelText,
                isRequired && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $83f0848311ef2185$export$2e2bcd8739ae039), {})
            ]
        })
    });
const $24c02ea0e14dbe4f$var$$57b1d5df6b5425d4$var$labelStyles = (0, $74Zh5.css)({
    fontFamily: "Inter",
    color: "#44546F",
    fontSize: "14px",
    fontStyle: "normal",
    fontWeight: 600,
    lineHeight: "20px"
});
var $24c02ea0e14dbe4f$var$$4be7278e65b71184$exports = {};
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$4be7278e65b71184$exports, "UnifiedAccountCardContent", ()=>$24c02ea0e14dbe4f$export$c031b829a2452999);
var $24c02ea0e14dbe4f$var$$fc6addd2061b87dd$exports = {};
$24c02ea0e14dbe4f$var$$parcel$defineInteropFlag($24c02ea0e14dbe4f$var$$fc6addd2061b87dd$exports);
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$fc6addd2061b87dd$exports, "default", ()=>$24c02ea0e14dbe4f$var$$fc6addd2061b87dd$export$2e2bcd8739ae039);
const $24c02ea0e14dbe4f$var$$fc6addd2061b87dd$var$UnifiedMoreDropdownMenu = ({ actions: actions, isDisabled: isDisabled })=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $9e29898158274f39$export$2e2bcd8739ae039), {
        trigger: ({ triggerRef: triggerRef, ...props })=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                css: $24c02ea0e14dbe4f$var$$fc6addd2061b87dd$var$buttonWrapperStyle,
                "data-testid": "dropdown-trigger",
                children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $0c4c08ddec83e35f$export$2e2bcd8739ae039), {
                    ...props,
                    icon: (0, (/*@__PURE__*/$parcel$interopDefault($68426ff7d9d92e39$exports))),
                    label: "more",
                    ref: triggerRef,
                    appearance: "default",
                    isDisabled: isDisabled
                })
            }),
        placement: "bottom-end",
        shouldRenderToParent: true,
        children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $c45aef576c3a1b33$export$2e2bcd8739ae039), {
            children: actions.map((action, index)=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $896b4f3af893fddb$export$2e2bcd8739ae039), {
                    onClick: action.onClick,
                    children: action.text
                }, index))
        })
    });
var $24c02ea0e14dbe4f$var$$fc6addd2061b87dd$export$2e2bcd8739ae039 = $24c02ea0e14dbe4f$var$$fc6addd2061b87dd$var$UnifiedMoreDropdownMenu;
const $24c02ea0e14dbe4f$var$$fc6addd2061b87dd$var$buttonWrapperStyle = (0, $74Zh5.css)({
    backgroundColor: "#FFFFFF",
    borderRadius: "3px"
});
const $24c02ea0e14dbe4f$export$c031b829a2452999 = ({ email: email, tags: tags, actions: actions, disableMenu: disableMenu })=>{
    return (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
        css: $24c02ea0e14dbe4f$var$$4be7278e65b71184$var$contentWrapperStyles,
        children: [
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                css: $24c02ea0e14dbe4f$var$$4be7278e65b71184$var$dropdownWrapperStyles,
                children: disableMenu ? null : (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$var$$fc6addd2061b87dd$export$2e2bcd8739ae039, {
                    actions: actions,
                    isDisabled: disableMenu
                })
            }),
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                css: $24c02ea0e14dbe4f$var$$4be7278e65b71184$var$coverImageWrapperStyles,
                children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                    css: $24c02ea0e14dbe4f$var$$4be7278e65b71184$var$coverImageStyles,
                    children: (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("svg", {
                        width: "350",
                        height: "82",
                        viewBox: "0 0 350 82",
                        fill: "none",
                        xmlns: "http://www.w3.org/2000/svg",
                        children: [
                            (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("g", {
                                clipPath: "url(#clip0_985_48434)",
                                children: [
                                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("path", {
                                        d: "M167.322 38.821C177.93 34.78 184.789 30.2722 188.858 25.4255C193.11 20.3612 194.263 14.9878 193.538 9.5957C192.822 4.25652 190.271 -1.06544 187.204 -6.12471C185.194 -9.43933 182.915 -12.7134 180.746 -15.8286C179.821 -17.1581 178.915 -18.4586 178.059 -19.7211L221.313 -48.8693C222.054 -47.7618 222.787 -46.6694 223.511 -45.5908C241.665 -18.5315 254.013 -0.126895 247.42 31.5817C243.994 48.0569 230.739 60.1325 218.142 68.1357C211.864 72.1242 205.799 75.0696 201.302 77.0177C199.054 77.9913 197.201 78.7147 195.913 79.1939C195.383 79.3909 194.949 79.5465 194.622 79.6613L167.322 38.821Z",
                                        stroke: "#0C66E4",
                                        strokeWidth: "2"
                                    }),
                                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("path", {
                                        d: "M72.3053 -15.1135C82.328 -17.928 92.5012 -22.9961 101.629 -29.5552C110.755 -36.1128 118.158 -43.5947 123.819 -51.8086L166.607 8.14819C159.501 15.3002 151.561 22.0298 142.555 28.5017C133.545 34.9761 124.385 40.4509 115.146 44.9177L72.3053 -15.1135Z",
                                        stroke: "#0C66E4",
                                        strokeWidth: "2"
                                    }),
                                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("path", {
                                        d: "M145.593 48.2832L177.327 107.164L160.851 130.97L94.7005 121.821L95.1645 67.6983L145.593 48.2832Z",
                                        stroke: "#0C66E4",
                                        strokeWidth: "2"
                                    }),
                                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("path", {
                                        d: "M315.34 72.2206L315.355 72.2331L315.372 72.2449C315.778 72.5416 316.18 72.8355 316.577 73.1258C320.114 75.7149 323.269 78.0239 326.324 79.6083C329.758 81.3894 333.158 82.3068 336.975 81.7093C341.291 81.0335 344.5 78.5429 346.241 74.1008C347.949 69.7418 348.232 63.5491 346.967 55.3884L346.241 50.7055L378.755 45.6149C379.596 48.7568 380.163 52.4046 380.848 56.8254C383.982 77.0371 381.669 92.493 375.423 103.369C369.195 114.213 358.984 120.632 346.012 122.663C327.026 125.636 315.363 118.74 304.711 110.615L304.701 110.608L304.691 110.601C304.22 110.259 303.755 109.92 303.296 109.586C299.84 107.069 296.744 104.815 293.745 103.255C290.311 101.469 286.909 100.54 283.091 101.138L282.103 101.293L282.115 101.369C278.291 102.255 275.438 104.702 273.833 108.804C272.126 113.168 271.843 119.36 273.105 127.5C273.249 128.428 273.503 129.339 273.738 130.185L273.746 130.211C273.89 130.731 274.028 131.226 274.142 131.711L241.242 136.862C240.465 134.058 239.898 130.414 239.159 125.649C236.059 105.652 238.499 90.2821 244.81 79.446C251.105 68.6378 261.321 62.2203 274.06 60.2258C283.596 58.7327 291.242 59.6302 297.818 61.9301C304.407 64.2347 309.975 67.9653 315.34 72.2206Z",
                                        stroke: "#0C66E4",
                                        strokeWidth: "2"
                                    }),
                                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("path", {
                                        d: "M292.179 -56.9295L292.37 -57.2966L292.352 -57.3526L301.854 -75.6471L361.496 -44.2691L338.629 -0.241775C322.356 31.0905 300.658 42.9482 277.565 44.2706C265.48 24.4864 262.733 -0.232558 279.024 -31.6005L292.179 -56.9295Z",
                                        stroke: "#0C66E4",
                                        strokeWidth: "2"
                                    })
                                ]
                            }),
                            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("defs", {
                                children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("clipPath", {
                                    id: "clip0_985_48434",
                                    children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("path", {
                                        d: "M0 8C0 3.58172 3.58172 0 8 0H386C390.418 0 394 3.58172 394 8V96H0V8Z",
                                        fill: "white"
                                    })
                                })
                            })
                        ]
                    })
                })
            }),
            (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                css: $24c02ea0e14dbe4f$var$$4be7278e65b71184$var$textWrapperStyles,
                children: [
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("p", {
                        css: $24c02ea0e14dbe4f$var$$4be7278e65b71184$var$emailStyles,
                        children: email
                    }),
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                        css: $24c02ea0e14dbe4f$var$$4be7278e65b71184$var$tagsWrapperStyles,
                        children: tags.map((tag, index)=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                                css: $24c02ea0e14dbe4f$var$$4be7278e65b71184$var$tagItemStyles,
                                children: tag
                            }, index))
                    })
                ]
            })
        ]
    });
};
const $24c02ea0e14dbe4f$var$$4be7278e65b71184$var$contentWrapperStyles = (0, $74Zh5.css)({
    display: "flex",
    flexDirection: "column",
    width: "100%",
    padding: 0,
    margin: 0,
    height: "100%",
    borderRadius: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.100")
});
const $24c02ea0e14dbe4f$var$$4be7278e65b71184$var$coverImageWrapperStyles = (0, $74Zh5.css)({
    width: "100%",
    overflow: "hidden",
    borderTopLeftRadius: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.100"),
    borderTopRightRadius: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.100")
});
const $24c02ea0e14dbe4f$var$$4be7278e65b71184$var$coverImageStyles = (0, $74Zh5.css)({
    background: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("elevation.surface.sunken"),
    width: "100%",
    height: "82px",
    objectFit: "cover",
    margin: 0,
    padding: 0,
    display: "block"
});
const $24c02ea0e14dbe4f$var$$4be7278e65b71184$var$textWrapperStyles = (0, $74Zh5.css)({
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    padding: "24px",
    boxSizing: "border-box",
    width: "100%"
});
const $24c02ea0e14dbe4f$var$$4be7278e65b71184$var$emailStyles = (0, $74Zh5.css)({
    fontFamily: "Inter",
    marginBottom: "12px",
    fontSize: "16px",
    color: "#44546F",
    lineHeight: "24px"
});
const $24c02ea0e14dbe4f$var$$4be7278e65b71184$var$tagsWrapperStyles = (0, $74Zh5.css)({
    display: "flex",
    flexDirection: "row",
    gap: "8px"
});
const $24c02ea0e14dbe4f$var$$4be7278e65b71184$var$tagItemStyles = (0, $74Zh5.css)({
    display: "inline-block"
});
const $24c02ea0e14dbe4f$var$$4be7278e65b71184$var$dropdownWrapperStyles = (0, $74Zh5.css)({
    position: "absolute",
    top: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.150"),
    right: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.150")
});
var $24c02ea0e14dbe4f$var$$db9d361cdef36cb6$exports = {};
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$db9d361cdef36cb6$exports, "UnifiedAccountContainerCard", ()=>$24c02ea0e14dbe4f$export$c9d2f1697787ae74);
const $24c02ea0e14dbe4f$export$c9d2f1697787ae74 = ({ children: children, testId: testId, onClick: onClick, isAddAccount: isAddAccount = false })=>{
    return (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("button", {
        "data-testid": testId,
        css: [
            $24c02ea0e14dbe4f$var$$db9d361cdef36cb6$var$unstyledButtonStyles,
            $24c02ea0e14dbe4f$var$$db9d361cdef36cb6$var$cardContainerStyles,
            isAddAccount && $24c02ea0e14dbe4f$var$$db9d361cdef36cb6$var$addAccountStyles,
            isAddAccount ? $24c02ea0e14dbe4f$var$$db9d361cdef36cb6$var$hoverEffectStyles : $24c02ea0e14dbe4f$var$$db9d361cdef36cb6$var$noPointerCursorStyles
        ],
        onClick: isAddAccount ? onClick : undefined,
        children: children
    });
};
const $24c02ea0e14dbe4f$var$$db9d361cdef36cb6$var$unstyledButtonStyles = (0, $74Zh5.css)({
    display: "flex",
    textAlign: "inherit",
    textDecoration: "none",
    background: "none",
    color: "inherit",
    border: "none",
    padding: 0,
    fontFamily: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("font.family.brand.body")
});
const $24c02ea0e14dbe4f$var$$db9d361cdef36cb6$var$cardContainerStyles = (0, $74Zh5.css)({
    position: "relative",
    textDecoration: "none",
    display: "flex",
    flexDirection: "column",
    boxSizing: "border-box",
    boxShadow: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("elevation.shadow.raised"),
    borderRadius: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.100"),
    background: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("elevation.surface"),
    alignItems: "center",
    zIndex: 1,
    justifyContent: "center",
    height: "194px",
    transition: "box-shadow 0.2s ease",
    width: "300px",
    "@media (min-width: 768px) and (max-width: 1279px)": {
        width: "290px"
    },
    "@media (min-width: 1280px)": {
        width: "290px"
    }
});
const $24c02ea0e14dbe4f$var$$db9d361cdef36cb6$var$hoverEffectStyles = (0, $74Zh5.css)({
    cursor: "pointer",
    "&:hover": {
        boxShadow: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("elevation.shadow.overlay")
    },
    "&:active": {
        outline: `2px solid ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.border.selected")}`
    }
});
const $24c02ea0e14dbe4f$var$$db9d361cdef36cb6$var$noPointerCursorStyles = (0, $74Zh5.css)({
    cursor: "default"
});
const $24c02ea0e14dbe4f$var$$db9d361cdef36cb6$var$addAccountStyles = (0, $74Zh5.css)({
    border: `1px dashed ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.border")}`,
    boxShadow: "none"
});
var $24c02ea0e14dbe4f$var$$e6da040d2ca2c72a$exports = {};
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$e6da040d2ca2c72a$exports, "UnifiedAccountLinkAccountCard", ()=>$24c02ea0e14dbe4f$export$fc13faf098015d3a);
const $24c02ea0e14dbe4f$var$$5089616a215e9052$var$ellipseStyles = (0, $74Zh5.css)({
    width: "72px",
    height: "72px",
    backgroundColor: "#D3F1A7",
    borderRadius: "50%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
});
const $24c02ea0e14dbe4f$var$$5089616a215e9052$export$f21ab0717a89c77f = ()=>{
    return (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
        css: $24c02ea0e14dbe4f$var$$5089616a215e9052$var$ellipseStyles,
        children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($1a8d9f6b66868ddc$exports))), {
            label: "Add",
            size: "large",
            primaryColor: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.icon")
        })
    });
};
const $24c02ea0e14dbe4f$var$$e6da040d2ca2c72a$var$contentStyles = (0, $74Zh5.css)({
    textAlign: "center",
    padding: "17px 48px",
    fontFamily: "Inter, sans-serif",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    height: "100%"
});
const $24c02ea0e14dbe4f$var$$e6da040d2ca2c72a$var$textStyles = (0, $74Zh5.css)({
    marginTop: "16px",
    color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.icon"),
    fontSize: "16px",
    lineHeight: "24px"
});
const $24c02ea0e14dbe4f$export$fc13faf098015d3a = ()=>{
    return (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
        css: $24c02ea0e14dbe4f$var$$e6da040d2ca2c72a$var$contentStyles,
        children: [
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$var$$5089616a215e9052$export$f21ab0717a89c77f, {}),
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                css: $24c02ea0e14dbe4f$var$$e6da040d2ca2c72a$var$textStyles,
                children: "Link account"
            })
        ]
    });
};
var $24c02ea0e14dbe4f$var$$9c7edcd33b2e220b$exports = {};
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$9c7edcd33b2e220b$exports, "UnifiedAccountTagContainer", ()=>$24c02ea0e14dbe4f$export$b27c6704e245f018);
const $24c02ea0e14dbe4f$export$b27c6704e245f018 = ({ children: children })=>{
    return (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
        css: $24c02ea0e14dbe4f$var$$9c7edcd33b2e220b$var$containerStyles,
        children: children
    });
};
const $24c02ea0e14dbe4f$var$$9c7edcd33b2e220b$var$containerStyles = (0, $74Zh5.css)({
    maxWidth: "84px",
    height: "28px",
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    boxSizing: "border-box",
    borderRadius: "4px"
});
var $24c02ea0e14dbe4f$var$$3ec1f71319ba0295$exports = {};
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$3ec1f71319ba0295$exports, "UnifiedAccountTagLoggedIn", ()=>$24c02ea0e14dbe4f$export$8bee5cfdbbc2fc0c);
const $24c02ea0e14dbe4f$var$$3ec1f71319ba0295$var$loggedInContentStyles = (0, $74Zh5.css)({
    backgroundColor: "#626F86",
    color: "#FFFFFF"
});
const $24c02ea0e14dbe4f$export$8bee5cfdbbc2fc0c = ()=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$b27c6704e245f018, {
        children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
            css: [
                $24c02ea0e14dbe4f$var$$3ec1f71319ba0295$var$loggedInContentStyles,
                $24c02ea0e14dbe4f$var$$3ec1f71319ba0295$var$baseContentStyles
            ],
            children: "LOGGED IN"
        })
    });
const $24c02ea0e14dbe4f$var$$3ec1f71319ba0295$var$baseContentStyles = (0, $74Zh5.css)({
    width: "84px",
    height: "28px",
    fontFamily: "Charlie Text",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "6px 8px",
    boxSizing: "border-box",
    fontSize: "12px",
    fontWeight: "600",
    borderRadius: "4px"
});
var $24c02ea0e14dbe4f$var$$7cbc56ac0bc2e1de$exports = {};
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$7cbc56ac0bc2e1de$exports, "UnifiedAccountTagPrimary", ()=>$24c02ea0e14dbe4f$export$be7f7dedc3a0e1ad);
const $24c02ea0e14dbe4f$var$$5f6e50d159d7e8e1$var$StarFilledIcon = ()=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("svg", {
        width: "12",
        height: "12",
        viewBox: "0 0 12 12",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("g", {
            id: "Icon / <StarFilledIcon>",
            children: [
                (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("rect", {
                    width: "12",
                    height: "12",
                    rx: "6",
                    fill: "#44546F"
                }),
                (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("path", {
                    id: "Vector",
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M6.0357 8.64198L4.0832 9.66848C4.00063 9.7119 3.90755 9.73135 3.8145 9.72463C3.72146 9.71791 3.63214 9.68529 3.55666 9.63046C3.48118 9.57563 3.42255 9.50078 3.38739 9.41437C3.35223 9.32796 3.34194 9.23344 3.3577 9.14149L3.7302 6.96698L2.1507 5.42698C2.08399 5.36186 2.03683 5.27937 2.01452 5.18886C1.99222 5.09834 1.99566 5.00338 2.02447 4.91472C2.05328 4.82605 2.10631 4.74721 2.17756 4.68709C2.24881 4.62697 2.33545 4.58797 2.4277 4.57448L4.6107 4.25698L5.5872 2.27898C5.62846 2.19525 5.69234 2.12474 5.7716 2.07544C5.85087 2.02613 5.94235 2 6.0357 2C6.12905 2 6.22053 2.02613 6.29979 2.07544C6.37906 2.12474 6.44294 2.19525 6.4842 2.27898L7.4602 4.25698L9.6432 4.57448C9.73549 4.58789 9.82219 4.62684 9.89351 4.68693C9.96482 4.74701 10.0179 4.82585 10.0468 4.91453C10.0756 5.00321 10.0791 5.09819 10.0569 5.18875C10.0346 5.2793 9.98741 5.36182 9.9207 5.42698L8.3407 6.96698L8.7137 9.14149C8.72939 9.23337 8.71908 9.32781 8.68394 9.41414C8.64879 9.50048 8.59022 9.57527 8.51482 9.63008C8.43942 9.68488 8.3502 9.71752 8.25724 9.72431C8.16427 9.7311 8.07126 9.71176 7.9887 9.66848L6.0357 8.64198Z",
                    fill: "white"
                })
            ]
        })
    });
var $24c02ea0e14dbe4f$var$$5f6e50d159d7e8e1$export$2e2bcd8739ae039 = $24c02ea0e14dbe4f$var$$5f6e50d159d7e8e1$var$StarFilledIcon;
const $24c02ea0e14dbe4f$var$$7cbc56ac0bc2e1de$var$primaryContentStyles = (0, $74Zh5.css)({
    backgroundColor: "#FFFFFF",
    color: "#172B4D",
    border: "1px solid #091E4224"
});
const $24c02ea0e14dbe4f$var$$7cbc56ac0bc2e1de$var$iconWrapperStyles = (0, $74Zh5.css)({
    marginRight: "2px",
    display: "flex",
    alignItems: "center"
});
const $24c02ea0e14dbe4f$export$be7f7dedc3a0e1ad = ()=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$b27c6704e245f018, {
        children: (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
            css: [
                $24c02ea0e14dbe4f$var$$7cbc56ac0bc2e1de$var$primaryContentStyles,
                $24c02ea0e14dbe4f$var$$7cbc56ac0bc2e1de$var$baseContentStyles
            ],
            children: [
                (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                    css: $24c02ea0e14dbe4f$var$$7cbc56ac0bc2e1de$var$iconWrapperStyles,
                    children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$var$$5f6e50d159d7e8e1$export$2e2bcd8739ae039, {})
                }),
                "PRIMARY"
            ]
        })
    });
const $24c02ea0e14dbe4f$var$$7cbc56ac0bc2e1de$var$baseContentStyles = (0, $74Zh5.css)({
    width: "84px",
    height: "28px",
    fontFamily: "Charlie Text",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "6px 8px",
    boxSizing: "border-box",
    fontSize: "12px",
    fontWeight: "600",
    borderRadius: "4px"
});
var $24c02ea0e14dbe4f$var$$01ef21c48d795edb$exports = {};
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$01ef21c48d795edb$exports, "UnifiedAccountTagLinked", ()=>$24c02ea0e14dbe4f$export$446c53c437a3d14a);
const $24c02ea0e14dbe4f$var$$01ef21c48d795edb$var$primaryContentStyles = (0, $74Zh5.css)({
    backgroundColor: "#FFFFFF",
    color: "#172B4D",
    border: "1px solid #091E4224"
});
const $24c02ea0e14dbe4f$export$446c53c437a3d14a = ()=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$b27c6704e245f018, {
        children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
            css: [
                $24c02ea0e14dbe4f$var$$01ef21c48d795edb$var$primaryContentStyles,
                $24c02ea0e14dbe4f$var$$01ef21c48d795edb$var$baseContentStyles
            ],
            children: "LINKED"
        })
    });
const $24c02ea0e14dbe4f$var$$01ef21c48d795edb$var$baseContentStyles = (0, $74Zh5.css)({
    fontFamily: "Charlie Text",
    height: "28px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "6px 8px",
    boxSizing: "border-box",
    fontSize: "12px",
    fontWeight: "600",
    borderRadius: "4px"
});
var $24c02ea0e14dbe4f$var$$fff41b96fcd62262$exports = {};
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$fff41b96fcd62262$exports, "WelcomeModal", ()=>$24c02ea0e14dbe4f$export$9d12d42929c3fcf);
const $24c02ea0e14dbe4f$export$9d12d42929c3fcf = ({ onAccept: onAccept, onCancel: onCancel, coverImageSrc: coverImageSrc })=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $73c4314b1cf0d4b0$export$2e2bcd8739ae039), {
        onClose: onCancel,
        width: "auto",
        shouldCloseOnEscapePress: false,
        shouldCloseOnOverlayClick: false,
        shouldScrollInViewport: true,
        children: (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
            css: $24c02ea0e14dbe4f$var$$fff41b96fcd62262$var$modalContainerStyles,
            children: [
                (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                    css: $24c02ea0e14dbe4f$var$$fff41b96fcd62262$var$modalImageContainerStyles,
                    children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("img", {
                        src: coverImageSrc,
                        alt: "cover",
                        css: $24c02ea0e14dbe4f$var$$fff41b96fcd62262$var$coverImageStyles
                    })
                }),
                (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                    css: $24c02ea0e14dbe4f$var$$fff41b96fcd62262$var$modalBodyStyles,
                    children: [
                        (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("h1", {
                            css: $24c02ea0e14dbe4f$var$$fff41b96fcd62262$var$modalHeadingContainerStyles,
                            children: "Welcome to the new Atlassian Community"
                        }),
                        (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("p", {
                            css: $24c02ea0e14dbe4f$var$$fff41b96fcd62262$var$modalSubheadingContainerStyles,
                            children: "Online forums and learning are now in one easy-to-use experience."
                        }),
                        (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("p", {
                            css: $24c02ea0e14dbe4f$var$$fff41b96fcd62262$var$modalSubheadingContainerStyles,
                            children: [
                                "By continuing, you accept the updated",
                                " ",
                                (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("a", {
                                    href: $24c02ea0e14dbe4f$var$$1ff01338112cd7fe$export$bc6e44c7f1ae99f6,
                                    target: "_blank",
                                    rel: "noreferrer",
                                    children: "Community Terms of Use"
                                }),
                                " ",
                                "and acknowledge the",
                                " ",
                                (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("a", {
                                    href: $24c02ea0e14dbe4f$var$$1ff01338112cd7fe$export$30786e8ac20c09d8,
                                    target: "_blank",
                                    rel: "noreferrer",
                                    children: "Privacy Policy"
                                }),
                                ". Your public name, photo, and achievements may be publicly visible and available in search engines."
                            ]
                        }),
                        (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                            css: $24c02ea0e14dbe4f$var$$fff41b96fcd62262$var$modalButtonContainerStyles,
                            children: [
                                (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                                    css: $24c02ea0e14dbe4f$var$$fff41b96fcd62262$var$buttonStyle,
                                    children: (0, $6bec4f26b2cb3094$export$25062201e9e25d76)((0, $123ba5aab151a241$export$2e2bcd8739ae039), {
                                        appearance: "subtle",
                                        onClick: onCancel,
                                        children: [
                                            " ",
                                            "Cancel and logout"
                                        ]
                                    })
                                }),
                                (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                                    css: $24c02ea0e14dbe4f$var$$fff41b96fcd62262$var$buttonStyle,
                                    children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $123ba5aab151a241$export$2e2bcd8739ae039), {
                                        appearance: "primary",
                                        onClick: onAccept,
                                        children: "Accept and continue"
                                    })
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
const $24c02ea0e14dbe4f$var$$fff41b96fcd62262$var$buttonStyle = (0, $74Zh5.css)({
    fontSize: "16px",
    "& span": {
        fontWeight: "600"
    }
});
const $24c02ea0e14dbe4f$var$$fff41b96fcd62262$var$coverImageStyles = (0, $74Zh5.css)({
    width: "100%",
    height: "auto",
    display: "block"
});
const $24c02ea0e14dbe4f$var$$fff41b96fcd62262$var$modalContainerStyles = (0, $74Zh5.css)({
    maxWidth: "600px",
    margin: "0 auto"
});
const $24c02ea0e14dbe4f$var$$fff41b96fcd62262$var$modalImageContainerStyles = (0, $74Zh5.css)({
    width: "100%",
    overflow: "hidden"
});
const $24c02ea0e14dbe4f$var$$fff41b96fcd62262$var$modalBodyStyles = (0, $74Zh5.css)({
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    padding: "24px"
});
const $24c02ea0e14dbe4f$var$$fff41b96fcd62262$var$modalHeadingContainerStyles = (0, $74Zh5.css)({
    fontFamily: "Charlie Display, sans-serif",
    fontSize: "32px",
    paddingTop: "24px",
    fontWeight: 700,
    textAlign: "center"
});
const $24c02ea0e14dbe4f$var$$fff41b96fcd62262$var$modalSubheadingContainerStyles = (0, $74Zh5.css)({
    fontSize: "16px",
    marginTop: "16px",
    fontFamily: "Inter",
    textAlign: "center",
    marginBottom: "24px"
});
const $24c02ea0e14dbe4f$var$$fff41b96fcd62262$var$modalButtonContainerStyles = (0, $74Zh5.css)({
    paddingTop: "16px",
    display: "flex",
    justifyContent: "center",
    gap: "8px"
});
$24c02ea0e14dbe4f$var$$parcel$exportWildcard($24c02ea0e14dbe4f$var$$a6a41c835fd01d00$exports, $24c02ea0e14dbe4f$var$$1ca64a7075ab6eae$exports);
$24c02ea0e14dbe4f$var$$parcel$exportWildcard($24c02ea0e14dbe4f$var$$a6a41c835fd01d00$exports, $24c02ea0e14dbe4f$var$$60ab015507144a2b$exports);
$24c02ea0e14dbe4f$var$$parcel$exportWildcard($24c02ea0e14dbe4f$var$$a6a41c835fd01d00$exports, $24c02ea0e14dbe4f$var$$57b1d5df6b5425d4$exports);
$24c02ea0e14dbe4f$var$$parcel$exportWildcard($24c02ea0e14dbe4f$var$$a6a41c835fd01d00$exports, $24c02ea0e14dbe4f$var$$4be7278e65b71184$exports);
$24c02ea0e14dbe4f$var$$parcel$exportWildcard($24c02ea0e14dbe4f$var$$a6a41c835fd01d00$exports, $24c02ea0e14dbe4f$var$$db9d361cdef36cb6$exports);
$24c02ea0e14dbe4f$var$$parcel$exportWildcard($24c02ea0e14dbe4f$var$$a6a41c835fd01d00$exports, $24c02ea0e14dbe4f$var$$e6da040d2ca2c72a$exports);
$24c02ea0e14dbe4f$var$$parcel$exportWildcard($24c02ea0e14dbe4f$var$$a6a41c835fd01d00$exports, $24c02ea0e14dbe4f$var$$9c7edcd33b2e220b$exports);
$24c02ea0e14dbe4f$var$$parcel$exportWildcard($24c02ea0e14dbe4f$var$$a6a41c835fd01d00$exports, $24c02ea0e14dbe4f$var$$3ec1f71319ba0295$exports);
$24c02ea0e14dbe4f$var$$parcel$exportWildcard($24c02ea0e14dbe4f$var$$a6a41c835fd01d00$exports, $24c02ea0e14dbe4f$var$$7cbc56ac0bc2e1de$exports);
$24c02ea0e14dbe4f$var$$parcel$exportWildcard($24c02ea0e14dbe4f$var$$a6a41c835fd01d00$exports, $24c02ea0e14dbe4f$var$$fc6addd2061b87dd$exports);
$24c02ea0e14dbe4f$var$$parcel$exportWildcard($24c02ea0e14dbe4f$var$$a6a41c835fd01d00$exports, $24c02ea0e14dbe4f$var$$01ef21c48d795edb$exports);
$24c02ea0e14dbe4f$var$$parcel$exportWildcard($24c02ea0e14dbe4f$var$$a6a41c835fd01d00$exports, $24c02ea0e14dbe4f$var$$fff41b96fcd62262$exports);
const $24c02ea0e14dbe4f$var$$2db63308c0b2527b$export$b56677d67e73c7be = ({ response: response, isLoading: isLoading })=>{
    const { message: message, isError: responseError } = response;
    return (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
        css: $24c02ea0e14dbe4f$var$$2db63308c0b2527b$var$inputStyles,
        children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $2111f5e4df021534$export$2e2bcd8739ae039), {
            name: "email",
            label: "Email address",
            defaultValue: "",
            children: ({ fieldProps: fieldProps, error: error, meta: meta })=>{
                const validationErrorMessage = meta.dirtySinceLastSubmit ? undefined : error;
                const displayMessage = validationErrorMessage || message;
                const displayType = error || responseError ? "error" : "valid";
                return (0, $6bec4f26b2cb3094$export$25062201e9e25d76)((0, $6bec4f26b2cb3094$export$ffb0004e005737fa), {
                    children: [
                        (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                            css: $24c02ea0e14dbe4f$var$$2db63308c0b2527b$var$inputButtonFlex,
                            children: [
                                (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$2c73285ae9390cec, {
                                    ...fieldProps,
                                    required: true,
                                    type: "email",
                                    autoComplete: "off",
                                    placeholder: "yourname@email.com"
                                }),
                                (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                                    css: $24c02ea0e14dbe4f$var$$2db63308c0b2527b$export$a3b9b213fa74e4fd,
                                    children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$353f5b6fc5456de1, {
                                        as: "button",
                                        label: "Sign up",
                                        type: "submit",
                                        appearance: $24c02ea0e14dbe4f$export$261c9483fc4a455a.PRIMARY,
                                        isLoading: isLoading
                                    })
                                })
                            ]
                        }),
                        displayMessage ? (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$9144c5f9beecc4b7, {
                            type: displayType,
                            message: displayMessage
                        }) : null
                    ]
                });
            }
        })
    });
};
const $24c02ea0e14dbe4f$var$$2db63308c0b2527b$var$inputStyles = (0, $74Zh5.css)({
    "& label": {
        fontWeight: 400
    }
});
const $24c02ea0e14dbe4f$var$$2db63308c0b2527b$var$inputButtonFlex = (0, $74Zh5.css)({
    display: "flex",
    alignContent: "center",
    gap: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.100")
});
const $24c02ea0e14dbe4f$var$$2db63308c0b2527b$export$a3b9b213fa74e4fd = ({ isMobile: isMobile })=>(0, $74Zh5.css)({
        minWidth: "fit-content",
        display: isMobile ? "none" : "block",
        marginTop: isMobile ? (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.200") : 0,
        [$24c02ea0e14dbe4f$var$$f0285f05d4d9f8a0$export$426e07cd0772984d.MOBILE.MEDIA_QUERY]: {
            minWidth: "100%",
            display: isMobile ? "block" : "none"
        }
    });
const $24c02ea0e14dbe4f$var$$d51a9a1c56c91a16$export$eefa3b352a86957 = "https://www.atlassian.com/legal/privacy-policy#what-this-policy-covers";
const $24c02ea0e14dbe4f$var$$d51a9a1c56c91a16$export$ecf6508459835aaf = "By signing up, you agree to receive promotional emails including product news, events, and more from Atlassian and its affiliates, and acknowledge and accept the ";
const $24c02ea0e14dbe4f$var$$d51a9a1c56c91a16$export$ec00f1754868e2a2 = ({ response: response, onSubmit: onSubmit, onPrivacyPolicyClick: onPrivacyPolicyClick })=>{
    const handleSubmit = async (data, form)=>{
        const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        const errors = {
            email: !emailPattern.test(data.email) ? "Enter a valid email address." : undefined
        };
        if (!errors.email) {
            await onSubmit(data);
            form.reset();
        }
        return errors;
    };
    return (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $916dd591feb93e13$export$2e2bcd8739ae039), {
        onSubmit: handleSubmit,
        children: ({ formProps: formProps, submitting: submitting })=>(0, $6bec4f26b2cb3094$export$25062201e9e25d76)("form", {
                ...formProps,
                css: $24c02ea0e14dbe4f$var$$d51a9a1c56c91a16$var$formWrapperStyles,
                "data-testid": "signup-form",
                noValidate: true,
                children: [
                    (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                        css: $24c02ea0e14dbe4f$var$$d51a9a1c56c91a16$var$formActionStyles,
                        children: [
                            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$var$$2db63308c0b2527b$export$b56677d67e73c7be, {
                                response: response,
                                isLoading: submitting
                            }),
                            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                                css: $24c02ea0e14dbe4f$var$$2db63308c0b2527b$export$a3b9b213fa74e4fd({
                                    isMobile: true
                                }),
                                children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$353f5b6fc5456de1, {
                                    as: "button",
                                    label: "Sign up",
                                    type: "submit",
                                    appearance: $24c02ea0e14dbe4f$export$261c9483fc4a455a.PRIMARY,
                                    isLoading: submitting,
                                    fullWidth: true
                                })
                            })
                        ]
                    }),
                    (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("p", {
                        css: $24c02ea0e14dbe4f$var$$d51a9a1c56c91a16$var$acknowledgeStyle,
                        children: [
                            $24c02ea0e14dbe4f$var$$d51a9a1c56c91a16$export$ecf6508459835aaf,
                            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("a", {
                                href: $24c02ea0e14dbe4f$var$$d51a9a1c56c91a16$export$eefa3b352a86957,
                                target: "_blank",
                                onClick: onPrivacyPolicyClick,
                                rel: "noreferrer",
                                children: "Atlassian Privacy Policy"
                            }),
                            "."
                        ]
                    })
                ]
            })
    });
};
const $24c02ea0e14dbe4f$var$$d51a9a1c56c91a16$var$formWrapperStyles = (0, $74Zh5.css)({
    width: "100%",
    paddingLeft: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.800"),
    paddingRight: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.800"),
    [$24c02ea0e14dbe4f$var$$f0285f05d4d9f8a0$export$426e07cd0772984d.MOBILE.MEDIA_QUERY]: {
        padding: 0
    },
    [$24c02ea0e14dbe4f$var$$f0285f05d4d9f8a0$export$426e07cd0772984d.TABLET.MEDIA_QUERY]: {
        marginTop: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.300")
    },
    [$24c02ea0e14dbe4f$var$$f0285f05d4d9f8a0$export$426e07cd0772984d.DESKTOP.MEDIA_QUERY]: {
        marginTop: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.400")
    }
});
const $24c02ea0e14dbe4f$var$$d51a9a1c56c91a16$var$formActionStyles = (0, $74Zh5.css)({
    [$24c02ea0e14dbe4f$var$$f0285f05d4d9f8a0$export$426e07cd0772984d.MOBILE.MEDIA_QUERY]: {
        flexDirection: "column",
        gap: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.200")
    }
});
const $24c02ea0e14dbe4f$var$$d51a9a1c56c91a16$var$acknowledgeStyle = (0, $74Zh5.css)({
    fontFamily: "Inter, sans-serif",
    maxWidth: "405px",
    color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text.subtlest"),
    fontWeight: "400",
    fontSize: "12px",
    marginTop: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.100"),
    "& a": {
        color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text.selected")
    },
    [$24c02ea0e14dbe4f$var$$f0285f05d4d9f8a0$export$426e07cd0772984d.MOBILE.MEDIA_QUERY]: {
        maxWidth: "unset"
    }
});
const $24c02ea0e14dbe4f$var$$eb8aa702a3355ad4$export$260d8f4a67dc36b0 = ()=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("svg", {
        "data-testid": "open-letter",
        width: "124",
        height: "118",
        viewBox: "0 0 124 118",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("g", {
            id: "Spot/Basics/Letter open",
            children: (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("g", {
                id: "Vector",
                children: [
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("path", {
                        id: "Vector_2",
                        d: "M61.8877 12.0239L11 54.5804V105.981H112.775V54.5804L61.8877 12.0239Z",
                        fill: "#1868DB"
                    }),
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("path", {
                        id: "Vector_3",
                        d: "M100.759 28.2393H23.0166V105.981H100.759V28.2393Z",
                        fill: "#FCA700"
                    }),
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("path", {
                        id: "Vector_4",
                        d: "M81.2754 28.2393H42.4938L23.0166 44.5319V105.981H100.759V44.5319L81.2754 28.2393Z",
                        fill: "#164B35"
                    }),
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("path", {
                        id: "Vector_5",
                        d: "M94.3773 34.6199H29.3916V99.6056H94.3773V34.6199Z",
                        fill: "#DDDEE1"
                    }),
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("path", {
                        id: "Vector_6",
                        d: "M88.2168 41.562H36.7148V43.9475H88.2168V41.562Z",
                        fill: "#FCA700"
                    }),
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("path", {
                        id: "Vector_7",
                        d: "M88.2168 51.1689H36.7148V53.5544H88.2168V51.1689Z",
                        fill: "#FCA700"
                    }),
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("path", {
                        id: "Vector_8",
                        d: "M88.2168 60.7825H36.7148V63.1679H88.2168V60.7825Z",
                        fill: "#FCA700"
                    }),
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("path", {
                        id: "Vector_9",
                        d: "M88.2168 70.3901H36.7148V72.7756H88.2168V70.3901Z",
                        fill: "#FCA700"
                    }),
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("path", {
                        id: "Vector_10",
                        d: "M88.2168 80.0034H36.7148V82.3889H88.2168V80.0034Z",
                        fill: "#FCA700"
                    }),
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("path", {
                        id: "Vector_11",
                        d: "M88.2168 89.6106H36.7148V91.9961H88.2168V89.6106Z",
                        fill: "#FCA700"
                    }),
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("path", {
                        id: "Vector_12",
                        d: "M72.2824 105.981L11.1074 54.5923L11.2088 105.981H72.2824Z",
                        fill: "#1868DB"
                    }),
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("path", {
                        id: "Vector_13",
                        d: "M51.4873 105.981L112.662 54.5923L112.567 105.981H51.4873Z",
                        fill: "#1868DB"
                    }),
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("path", {
                        id: "Vector_14",
                        d: "M51.4873 105.981H72.2825L61.8879 97.2446L51.4873 105.981Z",
                        fill: "#09326C"
                    }),
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("path", {
                        id: "Vector_15",
                        d: "M61.8877 12.0239L11 54.5804V105.981H112.775V54.5804L61.8877 12.0239Z",
                        fill: "#1868DB"
                    }),
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("path", {
                        id: "Vector_16",
                        d: "M100.759 28.2393H23.0166V105.981H100.759V28.2393Z",
                        fill: "#FCA700"
                    }),
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("path", {
                        id: "Vector_17",
                        d: "M81.2754 28.2393H42.4938L23.0166 44.5319V105.981H100.759V44.5319L81.2754 28.2393Z",
                        fill: "#164B35"
                    }),
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("path", {
                        id: "Vector_18",
                        d: "M94.3773 34.6199H29.3916V99.6056H94.3773V34.6199Z",
                        fill: "#DDDEE1"
                    }),
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("path", {
                        id: "Vector_19",
                        d: "M51.0637 80.5821L49.6444 80.767C49.6444 80.767 47.1873 80.5642 46.2033 80.9041L42.5059 80.7491C42.5059 80.7491 40.9613 80.8385 40.4961 81.0532C40.2039 81.1844 40.0191 81.3454 39.9773 81.4945C39.8938 81.7927 40.4127 82.0432 41.9036 81.9478C41.9215 81.9656 41.9811 81.9835 41.9871 82.0074C43.5615 81.7987 45.0762 82.1863 46.6804 82.1446C46.6626 82.0551 46.7162 81.9895 46.7639 82.0312L46.746 82.1386C47.8135 81.9239 48.4815 82.2817 49.4595 81.912C49.4595 81.912 49.3402 82.0551 49.3462 82.0551C52.6918 82.0014 57.2241 82.1744 60.85 82.0193L60.8321 82.0014V81.9835C60.5041 81.8702 58.8999 81.7032 58.8999 81.7032C60.1106 81.1784 61.4762 81.739 62.7584 81.7211L62.7465 81.8643C62.1919 81.8583 61.6969 81.9179 61.5001 81.9776C63.4919 82.1803 67.4876 82.234 69.3959 82.0253C69.3482 81.9179 68.7578 82.1505 68.6087 81.7987C69.0978 81.7987 69.5868 81.7509 70.046 81.7569C70.046 81.9835 69.7776 81.906 69.7239 81.9478C70.5171 82.1982 86.7322 82.5441 82.8618 81.5542L82.9632 81.4349C81.9613 81.3812 81.1324 81.3335 80.0947 81.1009C79.9456 81.1188 79.9277 81.1009 79.9277 81.2142C79.886 81.2321 79.8204 81.2679 79.8383 81.3156C79.8502 81.6019 79.5281 81.4886 79.385 81.4945C79.5639 80.6059 76.1527 81.3872 75.6995 81.3514C75.616 80.928 74.8109 81.3335 74.5366 81.1486C74.5545 81.1307 74.6797 81.0413 74.6916 81.0234C74.4471 80.7491 70.4217 81.4826 71.5727 80.9638C66.8196 80.0454 58.1962 81.0771 53.0615 80.272L53.0973 80.3256C53.0556 80.3078 52.9303 80.3316 52.9005 80.272C52.3936 80.439 51.0577 80.5582 51.0577 80.5582L51.0637 80.5821ZM62.8419 81.1486C62.8419 81.1486 62.8479 81.1248 62.8419 81.1188C62.8419 81.1606 63.5039 81.1367 63.5277 81.1486V81.2917C62.8538 81.5601 61.3212 80.588 62.7763 81.0174C62.824 80.9816 62.824 81.1009 62.8359 81.1486H62.8419ZM68.7101 81.1963C68.8234 81.2083 68.9487 81.2202 69.0858 81.2321C67.5651 81.6675 65.5136 81.1069 63.8438 81.3037C64.4163 80.6775 65.77 81.0174 66.4916 81.0592C67.2132 80.922 68.072 81.095 68.7101 81.1963ZM78.5143 81.3514V81.2798H78.574C78.574 81.2977 78.568 81.3216 78.5561 81.3335C78.5501 81.3454 78.5263 81.3633 78.5143 81.3573V81.3514ZM51.8688 80.922C51.9821 80.8087 52.4055 80.8743 52.1252 81.1009C52.0537 81.0651 51.8449 81.1665 51.8688 80.922ZM70.4276 81.3752C70.4276 81.1427 70.9882 81.1009 70.9882 81.417C70.7974 81.417 70.6125 81.3991 70.4276 81.3752ZM47.7121 81.1427C47.5631 81.3872 47.6048 81.1128 47.5571 80.9578C47.5929 80.9936 47.73 81.0055 47.7002 81.1188L47.7121 81.1427ZM45.1001 81.2739C45.0643 81.3931 44.9152 81.4707 44.8436 81.4766C44.6647 81.3812 45.0166 81.1665 45.1001 81.2739ZM40.8003 81.2739C40.7943 81.411 40.6929 81.4587 40.6631 81.3216C40.6751 81.2202 40.8003 81.1427 40.8182 81.2977C40.8182 81.2918 40.8182 81.2798 40.8003 81.2739ZM73.0039 81.8881C72.8489 82.2936 72.342 81.9597 72.0676 82.067C72.1332 81.6615 72.6223 81.9656 72.831 81.8941C72.9025 81.8941 72.9622 81.8941 73.0039 81.8881ZM56.0851 81.6973C56.0851 82.0551 55.5186 81.7688 55.3277 81.8464V81.7032C55.614 81.6675 55.7869 81.578 56.0732 81.6973H56.0851ZM67.7977 81.9776C67.6903 82.1207 67.5114 81.9835 67.3981 81.9835C67.3981 81.7808 67.8692 81.751 67.7977 81.9776ZM63.0447 81.8941C63.0208 81.6734 63.2534 81.7808 63.325 81.7629C63.2772 81.8106 63.1878 81.9478 63.1341 81.9418C63.0983 81.9418 63.0864 81.912 63.0447 81.8941ZM56.2938 81.5601C56.5145 81.5601 56.753 81.5601 56.9796 81.572V81.7152C56.7411 81.7152 56.5145 81.7092 56.2879 81.7032V81.5601H56.2938ZM58.5183 81.7927V81.9358C58.1962 82.067 58.1604 81.7032 58.5123 81.7927H58.5183ZM53.4193 81.7092C53.4551 81.7152 53.5028 81.7271 53.5386 81.7271C53.9978 81.7152 53.3478 82.228 53.4193 81.7092ZM51.01 81.8344C50.9623 81.8523 50.9027 81.8941 50.855 81.8941C50.533 81.8762 50.8908 81.5363 51.01 81.8344Z",
                        fill: "#101214"
                    }),
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("path", {
                        id: "Vector_20",
                        d: "M72.2824 105.981L11.1074 54.5923L11.2088 105.981H72.2824Z",
                        fill: "#1868DB"
                    }),
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("path", {
                        id: "Vector_21",
                        d: "M51.4873 105.981L112.662 54.5923L112.567 105.981H51.4873Z",
                        fill: "#1868DB"
                    }),
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("path", {
                        id: "Vector_22",
                        d: "M51.4873 105.981H72.2825L61.8879 97.2446L51.4873 105.981Z",
                        fill: "#09326C"
                    }),
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("path", {
                        id: "Vector_23",
                        d: "M51.0637 44.3943L49.6444 44.5792C49.6444 44.5792 47.1873 44.3764 46.2033 44.7164L42.5059 44.5613C42.5059 44.5613 40.9613 44.6508 40.4961 44.8655C40.2039 45.0026 40.0191 45.1577 39.9773 45.3068C39.8938 45.605 40.4127 45.8554 41.9036 45.76C41.9215 45.7779 41.9811 45.7958 41.9871 45.8196C43.5615 45.6109 45.0762 45.9986 46.6804 45.9568C46.6626 45.8674 46.7162 45.8018 46.7639 45.8435L46.746 45.9508C47.8135 45.7362 48.4815 46.094 49.4595 45.7242C49.4595 45.7242 49.3402 45.8674 49.3462 45.8674C52.6918 45.8137 57.2241 45.9866 60.85 45.8316L60.8321 45.8137V45.7958C60.5041 45.6825 58.8999 45.5155 58.8999 45.5155C60.1106 44.9907 61.4762 45.5513 62.7584 45.5334L62.7465 45.6765C62.1919 45.6706 61.6969 45.7302 61.5001 45.7898C63.4919 45.9926 67.4876 46.0463 69.3959 45.8375C69.3482 45.7302 68.7578 45.9628 68.6087 45.6109C69.0978 45.6109 69.5868 45.5632 70.046 45.5692C70.046 45.7958 69.7776 45.7183 69.7239 45.76C70.5171 46.0105 86.7322 46.3564 82.8618 45.3664L82.9632 45.2471C81.9613 45.1935 81.1324 45.1458 80.0947 44.9132C79.9456 44.9311 79.9277 44.9132 79.9277 45.0265C79.886 45.0444 79.8204 45.0802 79.8383 45.1279C79.8502 45.4141 79.5281 45.3008 79.385 45.3068C79.5639 44.4182 76.1527 45.1994 75.6995 45.1636C75.616 44.7402 74.8109 45.1458 74.5366 44.9609C74.5545 44.943 74.6797 44.8535 74.6916 44.8356C74.4471 44.5613 70.4217 45.2948 71.5727 44.776C66.8196 43.8576 58.1962 44.8893 53.0615 44.0842L53.0973 44.1379C53.0556 44.12 52.9303 44.1439 52.9005 44.0842C52.3936 44.2512 51.0577 44.3705 51.0577 44.3705L51.0637 44.3943ZM62.8419 44.9549C62.8419 44.9549 62.8479 44.9311 62.8419 44.9251C62.8419 44.9668 63.5039 44.943 63.5277 44.9549V45.098C62.8538 45.3664 61.3212 44.4003 62.7763 44.8237C62.824 44.7879 62.824 44.9072 62.8359 44.9549H62.8419ZM68.7101 45.0026C68.8234 45.0146 68.9487 45.0265 69.0858 45.0384C67.5651 45.4738 65.5136 44.9132 63.8438 45.11C64.4163 44.4838 65.77 44.8237 66.4916 44.8655C67.2132 44.7283 68.072 44.9012 68.7101 45.0026ZM78.5143 45.1577V45.0861H78.574C78.574 45.104 78.568 45.1279 78.5561 45.1398C78.5501 45.1517 78.5263 45.1696 78.5143 45.1636V45.1577ZM51.8688 44.7283C51.9821 44.615 52.4055 44.6806 52.1252 44.9072C52.0537 44.8714 51.8449 44.9728 51.8688 44.7283ZM70.4276 45.1815C70.4276 44.949 70.9882 44.9012 70.9882 45.2233C70.7974 45.2233 70.6125 45.2054 70.4276 45.1815ZM47.7121 44.949C47.5631 45.1935 47.6048 44.9191 47.5571 44.7641C47.5929 44.7999 47.73 44.8118 47.7002 44.9251L47.7121 44.949ZM45.1001 45.0802C45.0643 45.1994 44.9152 45.277 44.8436 45.2829C44.6647 45.1875 45.0166 44.9728 45.1001 45.0802ZM40.8003 45.0802C40.7943 45.2173 40.6929 45.265 40.6631 45.1279C40.6751 45.0265 40.8003 44.949 40.8182 45.104C40.8182 45.098 40.8182 45.0861 40.8003 45.0802ZM73.0039 45.6944C72.8489 46.0999 72.342 45.766 72.0676 45.8733C72.1332 45.4678 72.6223 45.7719 72.831 45.7004C72.9025 45.7004 72.9622 45.7004 73.0039 45.6944ZM56.0851 45.5036C56.0851 45.8614 55.5186 45.5751 55.3277 45.6527V45.5095C55.614 45.4738 55.7869 45.3843 56.0732 45.5036H56.0851ZM67.7977 45.7839C67.6903 45.927 67.5114 45.7898 67.3981 45.7898C67.3981 45.5871 67.8692 45.5572 67.7977 45.7839ZM63.0447 45.7004C63.0208 45.4797 63.2534 45.5871 63.325 45.5692C63.2772 45.6169 63.1878 45.754 63.1341 45.7481C63.0983 45.7481 63.0864 45.7183 63.0447 45.7004ZM56.2938 45.3664C56.5145 45.3664 56.753 45.3664 56.9796 45.3783V45.5215C56.7411 45.5215 56.5145 45.5155 56.2879 45.5095V45.3664H56.2938ZM58.5183 45.599V45.7421C58.1962 45.8733 58.1604 45.5095 58.5123 45.599H58.5183ZM53.4193 45.5155C53.4551 45.5215 53.5028 45.5334 53.5386 45.5334C53.9978 45.5215 53.3478 46.0343 53.4193 45.5155ZM51.01 45.6407C50.9623 45.6586 50.9027 45.7004 50.855 45.6944C50.533 45.6765 50.8908 45.3366 51.01 45.6407Z",
                        fill: "#101214"
                    }),
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("path", {
                        id: "Vector_24",
                        d: "M51.0637 56.4532L49.6444 56.638C49.6444 56.638 47.1873 56.4353 46.2033 56.7752L42.5059 56.6202C42.5059 56.6202 40.9613 56.7096 40.4961 56.9243C40.2039 57.0615 40.0191 57.2165 39.9773 57.3656C39.8938 57.6638 40.4127 57.9143 41.9036 57.8188C41.9215 57.8367 41.9811 57.8546 41.9871 57.8785C43.5615 57.6698 45.0762 58.0574 46.6804 58.0156C46.6626 57.9262 46.7162 57.8606 46.7639 57.9023L46.746 58.0097C47.8135 57.795 48.4815 58.1528 49.4595 57.7831C49.4595 57.7831 49.3402 57.9262 49.3462 57.9262C52.6918 57.8725 57.2241 58.0455 60.85 57.8904L60.8321 57.8725V57.8546C60.5041 57.7413 58.8999 57.5743 58.8999 57.5743C60.1106 57.0495 61.4762 57.6101 62.7584 57.5922L62.7465 57.7354C62.1919 57.7294 61.6969 57.789 61.5001 57.8487C63.4919 58.0514 67.4876 58.1051 69.3959 57.8964C69.3482 57.789 68.7578 58.0216 68.6087 57.6698C69.0978 57.6698 69.5868 57.6221 70.046 57.628C70.046 57.8546 69.7776 57.7771 69.7239 57.8188C70.5171 58.0693 86.7322 58.4152 82.8618 57.4253L82.9632 57.306C81.9613 57.2523 81.1324 57.2046 80.0947 56.972C79.9456 56.9899 79.9277 56.972 79.9277 57.0853C79.886 57.1032 79.8204 57.139 79.8383 57.1867C79.8502 57.473 79.5281 57.3597 79.385 57.3656C79.5639 56.477 76.1527 57.2583 75.6995 57.2225C75.616 56.7991 74.8109 57.2046 74.5366 57.0197C74.5545 57.0018 74.6797 56.9124 74.6916 56.8945C74.4471 56.6202 70.4217 57.3537 71.5727 56.8349C66.8196 55.9165 58.1962 56.9482 53.0615 56.1431L53.0973 56.1967C53.0556 56.1789 52.9303 56.2027 52.9005 56.1431C52.3936 56.31 51.0577 56.4293 51.0577 56.4293L51.0637 56.4532ZM62.8419 57.0197C62.8419 57.0197 62.8479 56.9959 62.8419 56.9899C62.8419 57.0316 63.5039 57.0078 63.5277 57.0197V57.1629C62.8538 57.4312 61.3212 56.4591 62.7763 56.8885C62.824 56.8527 62.824 56.972 62.8359 57.0197H62.8419ZM68.7101 57.0674C68.8234 57.0794 68.9487 57.0913 69.0858 57.1032C67.5651 57.5386 65.5136 56.978 63.8438 57.1748C64.4163 56.5486 65.77 56.8885 66.4916 56.9303C67.2132 56.7931 68.072 56.9661 68.7101 57.0674ZM78.5143 57.2225V57.1509H78.574C78.574 57.1688 78.568 57.1927 78.5561 57.2046C78.5501 57.2225 78.5263 57.2344 78.5143 57.2285V57.2225ZM51.8688 56.7931C51.9821 56.6798 52.4055 56.7454 52.1252 56.972C52.0537 56.9362 51.8449 57.0376 51.8688 56.7931ZM70.4276 57.2463C70.4276 57.0138 70.9882 56.972 70.9882 57.2941C70.7974 57.2941 70.6125 57.2762 70.4276 57.2463ZM47.7121 57.0138C47.5631 57.2583 47.6048 56.9839 47.5571 56.8289C47.5929 56.8647 47.73 56.8766 47.7002 56.9899L47.7121 57.0138ZM45.1001 57.145C45.0643 57.2642 44.9152 57.3418 44.8436 57.3477C44.6647 57.2523 45.0166 57.0376 45.1001 57.145ZM40.8003 57.145C40.7943 57.2821 40.6929 57.3298 40.6631 57.1927C40.6751 57.0913 40.8003 57.0138 40.8182 57.1688C40.8182 57.1628 40.8182 57.1509 40.8003 57.145ZM73.0039 57.7592C72.8489 58.1647 72.342 57.8308 72.0676 57.9381C72.1332 57.5326 72.6223 57.8367 72.831 57.7652C72.9025 57.7652 72.9622 57.7652 73.0039 57.7592ZM56.0851 57.5684C56.0851 57.9262 55.5186 57.6399 55.3277 57.7175V57.5743C55.614 57.5386 55.7869 57.4491 56.0732 57.5684H56.0851ZM67.7977 57.8487C67.6903 57.9918 67.5114 57.8487 67.3981 57.8546C67.3981 57.6519 67.8692 57.622 67.7977 57.8487ZM63.0447 57.7652C63.0208 57.5445 63.2534 57.6519 63.325 57.634C63.2772 57.6817 63.1878 57.8189 63.1341 57.8129C63.0983 57.8129 63.0864 57.7831 63.0447 57.7652ZM56.2938 57.4312C56.5145 57.4312 56.753 57.4312 56.9796 57.4431V57.5863C56.7411 57.5863 56.5145 57.5803 56.2879 57.5743V57.4312H56.2938ZM58.5183 57.6638V57.8069C58.1962 57.9381 58.1604 57.5743 58.5123 57.6638H58.5183ZM53.4193 57.5803C53.4551 57.5863 53.5028 57.5982 53.5386 57.5982C53.9978 57.5863 53.3478 58.0991 53.4193 57.5803ZM51.01 57.7055C50.9623 57.7234 50.9027 57.7652 50.855 57.7592C50.533 57.7413 50.8908 57.4014 51.01 57.7055Z",
                        fill: "#101214"
                    }),
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("path", {
                        id: "Vector_25",
                        d: "M51.0637 68.5174L49.6444 68.7022C49.6444 68.7022 47.1873 68.4995 46.2033 68.8394L42.5059 68.6844C42.5059 68.6844 40.9613 68.7738 40.4961 68.9885C40.2039 69.1257 40.0191 69.2807 39.9773 69.4298C39.8938 69.728 40.4127 69.9785 41.9036 69.8831C41.9215 69.9009 41.9811 69.9188 41.9871 69.9427C43.5615 69.734 45.0762 70.1216 46.6804 70.0799C46.6626 69.9904 46.7162 69.9248 46.7639 69.9665L46.746 70.0739C47.8135 69.8592 48.4815 70.217 49.4595 69.8473C49.4595 69.8473 49.3402 69.9904 49.3462 69.9904C52.6918 69.9367 57.2241 70.1097 60.85 69.9546L60.8321 69.9367V69.9188C60.5041 69.8055 58.8999 69.6385 58.8999 69.6385C60.1106 69.1137 61.4762 69.6743 62.7584 69.6564L62.7465 69.7996C62.1919 69.7936 61.6969 69.8532 61.5001 69.9129C63.4919 70.1156 67.4876 70.1693 69.3959 69.9606C69.3482 69.8532 68.7578 70.0858 68.6087 69.734C69.0978 69.734 69.5868 69.6863 70.046 69.6922C70.046 69.9188 69.7776 69.8413 69.7239 69.8831C70.5171 70.1335 86.7322 70.4794 82.8618 69.4895L82.9632 69.3702C81.9613 69.3165 81.1324 69.2688 80.0947 69.0362C79.9456 69.0541 79.9277 69.0362 79.9277 69.1495C79.886 69.1674 79.8204 69.2032 79.8383 69.2509C79.8502 69.5372 79.5281 69.4238 79.385 69.4298C79.5639 68.5412 76.1527 69.3225 75.6995 69.2867C75.616 68.8633 74.8109 69.2688 74.5366 69.0839C74.5545 69.066 74.6797 68.9766 74.6916 68.9587C74.4471 68.6844 70.4217 69.4179 71.5727 68.8991C66.8196 67.9807 58.1962 69.0124 53.0615 68.2073L53.0973 68.2609C53.0556 68.2431 52.9303 68.2669 52.9005 68.2073C52.3936 68.3743 51.0577 68.4935 51.0577 68.4935L51.0637 68.5174ZM62.8419 69.0839C62.8419 69.0839 62.8479 69.0601 62.8419 69.0541C62.8419 69.0959 63.5039 69.072 63.5277 69.0839V69.2271C62.8538 69.4954 61.3212 68.5233 62.7763 68.9527C62.824 68.9169 62.824 69.0362 62.8359 69.0839H62.8419ZM68.7101 69.1316C68.8234 69.1436 68.9487 69.1555 69.0858 69.1674C67.5651 69.6028 65.5136 69.0422 63.8438 69.239C64.4163 68.6128 65.77 68.9527 66.4916 68.9945C67.2132 68.8573 68.072 69.0302 68.7101 69.1316ZM78.5143 69.2867V69.2151H78.574C78.574 69.233 78.568 69.2569 78.5561 69.2688C78.5501 69.2807 78.5263 69.2986 78.5143 69.2927V69.2867ZM51.8688 68.8573C51.9821 68.744 52.4055 68.8096 52.1252 69.0362C52.0537 69.0004 51.8449 69.1018 51.8688 68.8573ZM70.4276 69.3105C70.4276 69.078 70.9882 69.0362 70.9882 69.3583C70.7974 69.3583 70.6125 69.3404 70.4276 69.3105ZM47.7121 69.078C47.5631 69.3225 47.6048 69.0481 47.5571 68.8931C47.5929 68.9289 47.73 68.9408 47.7002 69.0541L47.7121 69.078ZM45.1001 69.2092C45.0643 69.3284 44.9152 69.406 44.8436 69.4119C44.6647 69.3165 45.0166 69.1018 45.1001 69.2092ZM40.8003 69.2092C40.7943 69.3463 40.6929 69.394 40.6631 69.2569C40.6751 69.1555 40.8003 69.078 40.8182 69.233C40.8182 69.227 40.8182 69.2151 40.8003 69.2092ZM73.0039 69.8234C72.8489 70.2289 72.342 69.895 72.0676 70.0023C72.1332 69.5968 72.6223 69.9009 72.831 69.8294C72.9025 69.8294 72.9622 69.8294 73.0039 69.8234ZM56.0851 69.6326C56.0851 69.9904 55.5186 69.7041 55.3277 69.7817V69.6385C55.614 69.6028 55.7869 69.5133 56.0732 69.6326H56.0851ZM67.7977 69.9129C67.6903 70.056 67.5114 69.9129 67.3981 69.9188C67.3981 69.7161 67.8692 69.6863 67.7977 69.9129ZM63.0447 69.8294C63.0208 69.6087 63.2534 69.7161 63.325 69.6982C63.2772 69.7459 63.1878 69.883 63.1341 69.8771C63.0983 69.8771 63.0864 69.8473 63.0447 69.8294ZM56.2938 69.4954C56.5145 69.4954 56.753 69.4954 56.9796 69.5073V69.6505C56.7411 69.6505 56.5145 69.6445 56.2879 69.6385V69.4954H56.2938ZM58.5183 69.728V69.8711C58.1962 70.0023 58.1604 69.6385 58.5123 69.728H58.5183ZM53.4193 69.6445C53.4551 69.6505 53.5028 69.6624 53.5386 69.6624C53.9978 69.6505 53.3478 70.1633 53.4193 69.6445ZM51.01 69.7697C50.9623 69.7876 50.9027 69.8294 50.855 69.8234C50.533 69.8055 50.8908 69.4656 51.01 69.7697Z",
                        fill: "#101214"
                    })
                ]
            })
        })
    });
const $24c02ea0e14dbe4f$export$5620dbefc1cb6f80 = "You\u2019re on the list! Thanks for signing up.";
const $24c02ea0e14dbe4f$export$3f27bc10068ef877 = "Something went wrong. Try again.";
const $24c02ea0e14dbe4f$export$21041608e6399292 = ({ environment: environment, formUrl: formUrl, atlassianId: atlassianId, anonymousId: anonymousId, eventHandlers: eventHandlers = {} })=>{
    const { handleNewsletterSignup: handleNewsletterSignup, error: error, success: success } = $24c02ea0e14dbe4f$export$ea96d97e8873ca7f({
        environment: environment,
        ...eventHandlers
    });
    const { onSubmit: onSubmit = ()=>null, onPrivacyPolicyClick: onPrivacyPolicyClick } = eventHandlers;
    const handleSubmit = async ({ email: email })=>{
        onSubmit();
        await handleNewsletterSignup({
            email: email,
            anonymousId: anonymousId,
            atlassianId: atlassianId
        }, formUrl);
    };
    const successMessage = success ? $24c02ea0e14dbe4f$export$5620dbefc1cb6f80 : undefined;
    const responseMessage = error ? $24c02ea0e14dbe4f$export$3f27bc10068ef877 : successMessage;
    return (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
        css: $24c02ea0e14dbe4f$var$$1db60c687807de63$var$signUpWrapper,
        children: [
            (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                css: $24c02ea0e14dbe4f$var$$1db60c687807de63$var$stack,
                children: [
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$var$$eb8aa702a3355ad4$export$260d8f4a67dc36b0, {}),
                    (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("h2", {
                        css: $24c02ea0e14dbe4f$var$$1db60c687807de63$var$headingStyles,
                        children: [
                            "Sign up for the community ",
                            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("span", {
                                children: "newsletter"
                            })
                        ]
                    }),
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("p", {
                        css: $24c02ea0e14dbe4f$var$$1db60c687807de63$var$descriptionStyles,
                        children: "Get the latest resources, tips, and trends to help you grow."
                    })
                ]
            }),
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$var$$d51a9a1c56c91a16$export$ec00f1754868e2a2, {
                response: {
                    message: responseMessage,
                    isError: Boolean(error)
                },
                onSubmit: handleSubmit,
                onPrivacyPolicyClick: onPrivacyPolicyClick
            })
        ]
    });
};
const $24c02ea0e14dbe4f$var$$1db60c687807de63$var$signUpWrapper = (0, $74Zh5.css)({
    margin: "0 auto",
    maxWidth: "624px"
});
const $24c02ea0e14dbe4f$var$$1db60c687807de63$var$stack = (0, $74Zh5.css)({
    textAlign: "center",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.100")
});
const $24c02ea0e14dbe4f$var$$1db60c687807de63$var$headingStyles = (0, $74Zh5.css)({
    fontFamily: '"Charlie Display", sans-serif',
    color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text"),
    fontSize: "40px",
    fontWeight: 700,
    lineHeight: "48px",
    letterSpacing: "-0.12px",
    marginTop: 0,
    "& span": {
        display: "block",
        [$24c02ea0e14dbe4f$var$$f0285f05d4d9f8a0$export$426e07cd0772984d.MOBILE.MEDIA_QUERY]: {
            display: "inline-block"
        }
    },
    [$24c02ea0e14dbe4f$var$$f0285f05d4d9f8a0$export$426e07cd0772984d.TABLET.MEDIA_QUERY]: {
        fontSize: "32px"
    },
    [$24c02ea0e14dbe4f$var$$f0285f05d4d9f8a0$export$426e07cd0772984d.MOBILE.MEDIA_QUERY]: {
        width: "340px",
        fontSize: "32px"
    }
});
const $24c02ea0e14dbe4f$var$$1db60c687807de63$var$descriptionStyles = (0, $74Zh5.css)({
    fontFamily: "Inter, sans-serif",
    color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text"),
    fontSize: "20px",
    fontWeight: "400",
    lineHeight: "32px",
    marginTop: 0,
    [$24c02ea0e14dbe4f$var$$f0285f05d4d9f8a0$export$426e07cd0772984d.TABLET.MEDIA_QUERY]: {
        fontSize: "20px"
    },
    [$24c02ea0e14dbe4f$var$$f0285f05d4d9f8a0$export$426e07cd0772984d.MOBILE.MEDIA_QUERY]: {
        fontSize: "16px",
        lineHeight: "24px"
    }
});
var $24c02ea0e14dbe4f$var$$2f0c862779035c26$exports = {};
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$2f0c862779035c26$exports, "MarkdownWrapper", ()=>$24c02ea0e14dbe4f$export$e61786c4aee8d415);
const $24c02ea0e14dbe4f$export$e61786c4aee8d415 = ({ children: children, overrides: overrides })=>{
    if (!children) return null;
    return (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).isValidElement(children) || typeof children !== "string" ? children : (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $igbF4.default), {
        css: $24c02ea0e14dbe4f$var$$2f0c862779035c26$var$defaultStyles,
        options: {
            overrides: overrides
        },
        children: children
    });
};
const $24c02ea0e14dbe4f$var$$2f0c862779035c26$var$defaultStyles = (0, $74Zh5.css)({
    "& > p:first-of-type": {
        margin: 0
    }
});
var $24c02ea0e14dbe4f$var$$6937e97bac512574$exports = {};
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$6937e97bac512574$exports, "TabbedAccordion", ()=>$24c02ea0e14dbe4f$export$187009fd9803261e);
const $24c02ea0e14dbe4f$var$$76fc9668239269ce$var$ResourceCard = ({ description: description, link: link, type: type })=>{
    const handleClick = ()=>{
        window.open(link.link, link.target);
    };
    const hasType = type && type.length > 0;
    const hasDescription = description && description.length > 0;
    const accessibilityLabel = `${link.label}; ${hasType ? `type: ${type}; ` : ""}${hasDescription ? description : ""}`;
    return (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
        css: $24c02ea0e14dbe4f$var$$76fc9668239269ce$var$containerStyles,
        onClick: handleClick,
        onKeyDown: (e)=>{
            if (e.key === "Enter" || e.key === " ") {
                e.preventDefault();
                handleClick();
            }
        },
        tabIndex: 0,
        role: "button",
        "aria-label": accessibilityLabel,
        children: [
            (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                css: $24c02ea0e14dbe4f$var$$76fc9668239269ce$var$contentStyles,
                children: [
                    hasType && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$3288d34c523a1192, {
                        label: type
                    }),
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$a6c7ac8248d6e38a, {
                        ...link,
                        style: $24c02ea0e14dbe4f$export$2b77966d73aefa77.SEMIBOLD,
                        onClick: handleClick,
                        tabIndex: -1
                    }),
                    hasDescription && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("p", {
                        css: $24c02ea0e14dbe4f$var$$76fc9668239269ce$var$descriptionStyles,
                        children: description
                    })
                ]
            }),
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$f04a61298a47a40f, {
                    type: "arrow-right",
                    alt: "Arrow right",
                    size: $24c02ea0e14dbe4f$export$ff775019b5b6e7df.MEDIUM
                })
            })
        ]
    });
};
const $24c02ea0e14dbe4f$var$$76fc9668239269ce$var$containerStyles = (0, $74Zh5.css)({
    display: "flex",
    flexDirection: "row",
    gap: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.100"),
    padding: `${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.300")} ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.300")} ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.300")} ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.250")}`,
    alignItems: "center",
    backgroundColor: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("elevation.surface"),
    justifyContent: "space-between",
    "& a": {
        color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.link")
    },
    "& a:hover": {
        textDecoration: "none"
    },
    "&:hover": {
        cursor: "pointer",
        boxShadow: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("elevation.shadow.overlay"),
        transition: "box-shadow 0.3s ease-in-out"
    },
    "&:hover svg": {
        color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.link"),
        transform: "translateX(2px)"
    },
    [(0, $cb8cedbc477f5a81$export$987d49ffe1b0900f).below.md]: {
        padding: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.150")
    }
});
const $24c02ea0e14dbe4f$var$$76fc9668239269ce$var$contentStyles = (0, $74Zh5.css)({
    display: "flex",
    flexDirection: "column",
    gap: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.100"),
    alignItems: "flex-start",
    [(0, $cb8cedbc477f5a81$export$987d49ffe1b0900f).below.md]: {
        gap: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.050")
    }
});
const $24c02ea0e14dbe4f$var$$76fc9668239269ce$var$descriptionStyles = (0, $74Zh5.css)({
    margin: 0,
    color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text.subtle"),
    fontFamily: "Atlassian Sans",
    fontSize: "14px",
    fontWeight: "500",
    lineHeight: "20px",
    [(0, $cb8cedbc477f5a81$export$987d49ffe1b0900f).below.md]: {
        fontSize: "12px",
        lineHeight: "16px"
    }
});
var $24c02ea0e14dbe4f$var$$76fc9668239269ce$export$2e2bcd8739ae039 = $24c02ea0e14dbe4f$var$$76fc9668239269ce$var$ResourceCard;
const $24c02ea0e14dbe4f$var$$f3815ecfa3837fcc$var$Expander = ({ title: title, description: description, resources: resources, color: color, expandedByDefault: expandedByDefault = false, onExpandToggle: onExpandToggle, iconType: iconType, expandedContent: expandedContent })=>{
    const [isExpanded, setIsExpanded] = (0, $5FkrB.useState)(expandedByDefault);
    const iconProps = isExpanded ? {
        type: "chevron-down",
        alt: "Chevron down"
    } : {
        type: "chevron-right",
        alt: "Chevron right"
    };
    const toggleExpanded = (0, $5FkrB.useCallback)(()=>{
        setIsExpanded(!isExpanded);
        onExpandToggle?.();
    }, [
        isExpanded,
        onExpandToggle
    ]);
    const handleKeyDown = (0, $5FkrB.useCallback)((event)=>{
        if (event.code === "Space") {
            // to handle cases when there are clickable items within accordion
            if (event.target !== event.currentTarget) {
                event.preventDefault();
                event.stopPropagation();
            } else {
                event.preventDefault();
                toggleExpanded();
            }
        }
    }, [
        toggleExpanded
    ]);
    const accessibilityLabel = `${title}; ${typeof description === "string" ? description : ""}`;
    const hasResources = resources.length > 0;
    return (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
        css: $24c02ea0e14dbe4f$var$$f3815ecfa3837fcc$var$iconAndExpanderContainerStyles,
        role: "button",
        "aria-label": accessibilityLabel,
        "aria-expanded": isExpanded,
        tabIndex: 0,
        onKeyDown: handleKeyDown,
        children: [
            iconType && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                css: [
                    $24c02ea0e14dbe4f$var$$f3815ecfa3837fcc$var$outerIconStyles,
                    (0, $74Zh5.css)({
                        opacity: isExpanded ? 1 : 0.6,
                        "& svg": {
                            color: color
                        }
                    })
                ],
                children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$f04a61298a47a40f, {
                    type: iconType,
                    color: color,
                    size: $24c02ea0e14dbe4f$export$ff775019b5b6e7df.LARGE
                })
            }),
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                css: $24c02ea0e14dbe4f$var$$f3815ecfa3837fcc$var$expanderCardStyles,
                style: {
                    borderLeft: `8px solid ${color && isExpanded ? color : "transparent"}`
                },
                children: (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                    css: $24c02ea0e14dbe4f$var$$f3815ecfa3837fcc$var$containerStyles,
                    children: [
                        (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                            role: "button",
                            tabIndex: 0,
                            css: $24c02ea0e14dbe4f$var$$f3815ecfa3837fcc$var$expanderHeaderStyles,
                            onClick: toggleExpanded,
                            onKeyDown: (e)=>{
                                if (e.key === "Enter" || e.key === " ") {
                                    e.preventDefault();
                                    toggleExpanded();
                                }
                            },
                            children: [
                                (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$f04a61298a47a40f, {
                                    ...iconProps,
                                    size: $24c02ea0e14dbe4f$export$ff775019b5b6e7df.LARGE
                                }),
                                (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$a8a3e93435678ff9, {
                                    level: 5,
                                    children: title
                                })
                            ]
                        }),
                        (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                            css: $24c02ea0e14dbe4f$var$$f3815ecfa3837fcc$var$contentStyles,
                            children: [
                                typeof description === "string" ? (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$5f1af8db9871e1d6, {
                                    children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("span", {
                                        css: $24c02ea0e14dbe4f$var$$f3815ecfa3837fcc$var$descriptionStyles,
                                        children: description
                                    })
                                }) : (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                                    css: $24c02ea0e14dbe4f$var$$f3815ecfa3837fcc$var$descriptionStyles,
                                    children: description
                                }),
                                isExpanded && expandedContent && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                                    css: $24c02ea0e14dbe4f$var$$f3815ecfa3837fcc$var$expandedContentStyles,
                                    children: expandedContent
                                }),
                                isExpanded && hasResources && (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                                    css: $24c02ea0e14dbe4f$var$$f3815ecfa3837fcc$var$resourcesStyles,
                                    children: [
                                        (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$71f050e2efa708bb, {
                                            fontWeight: "semibold",
                                            children: "Resources"
                                        }),
                                        resources.map((resource)=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$var$$76fc9668239269ce$export$2e2bcd8739ae039, {
                                                description: resource.description,
                                                link: resource.link,
                                                type: resource.type
                                            }, resource.link.link))
                                    ]
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
const $24c02ea0e14dbe4f$var$$f3815ecfa3837fcc$var$iconAndExpanderContainerStyles = (0, $74Zh5.css)({
    display: "flex",
    flexDirection: "row",
    gap: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.300")
});
const $24c02ea0e14dbe4f$var$$f3815ecfa3837fcc$var$expanderCardStyles = (0, $74Zh5.css)({
    display: "flex",
    flex: "auto",
    padding: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.400"),
    flexDirection: "column",
    gap: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.300"),
    alignSelf: "stretch",
    alignItems: "stretch",
    borderRadius: "8px",
    background: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("elevation.surface"),
    boxShadow: "0 0 1px 0 rgba(9, 30, 66, 0.31), 0 1px 1px 0 rgba(9, 30, 66, 0.25)",
    [(0, $cb8cedbc477f5a81$export$987d49ffe1b0900f).below.md]: {
        padding: `${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.150")} ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.100")} ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.150")} ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.050")}`
    }
});
const $24c02ea0e14dbe4f$var$$f3815ecfa3837fcc$var$containerStyles = (0, $74Zh5.css)({
    display: "flex",
    flexDirection: "column",
    gap: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.150"),
    [(0, $cb8cedbc477f5a81$export$987d49ffe1b0900f).below.md]: {
        gap: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.100")
    }
});
const $24c02ea0e14dbe4f$var$$f3815ecfa3837fcc$var$expanderHeaderStyles = (0, $74Zh5.css)({
    display: "flex",
    alignItems: "center",
    gap: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.200"),
    cursor: "pointer",
    userSelect: "none",
    [(0, $cb8cedbc477f5a81$export$987d49ffe1b0900f).below.md]: {
        gap: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.100")
    }
});
const $24c02ea0e14dbe4f$var$$f3815ecfa3837fcc$var$contentStyles = (0, $74Zh5.css)({
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "flex-start",
    gap: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.400"),
    marginLeft: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.600"),
    [(0, $cb8cedbc477f5a81$export$987d49ffe1b0900f).below.md]: {
        marginLeft: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.500")
    }
});
const $24c02ea0e14dbe4f$var$$f3815ecfa3837fcc$var$resourcesStyles = (0, $74Zh5.css)({
    display: "flex",
    padding: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.300"),
    flexDirection: "column",
    alignItems: "stretch",
    gap: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.100"),
    alignSelf: "stretch",
    borderRadius: "8px",
    backgroundColor: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("elevation.surface.sunken"),
    [(0, $cb8cedbc477f5a81$export$987d49ffe1b0900f).below.md]: {
        padding: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.150"),
        gap: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.200")
    }
});
const $24c02ea0e14dbe4f$var$$f3815ecfa3837fcc$var$outerIconStyles = (0, $74Zh5.css)({
    "& svg": {
        width: "32px !important",
        height: "32px !important"
    },
    [(0, $cb8cedbc477f5a81$export$987d49ffe1b0900f).below.md]: {
        display: "none"
    }
});
const $24c02ea0e14dbe4f$var$$f3815ecfa3837fcc$var$descriptionStyles = (0, $74Zh5.css)({
    whiteSpace: "pre-wrap"
});
const $24c02ea0e14dbe4f$var$$f3815ecfa3837fcc$var$expandedContentStyles = (0, $74Zh5.css)({
    width: "100%"
});
var $24c02ea0e14dbe4f$var$$f3815ecfa3837fcc$export$2e2bcd8739ae039 = $24c02ea0e14dbe4f$var$$f3815ecfa3837fcc$var$Expander;
const $24c02ea0e14dbe4f$var$$737c57f1a347e52a$var$TabContent = ({ tabExpanders: tabExpanders, color: color, iconType: iconType })=>{
    return (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
        css: $24c02ea0e14dbe4f$var$$737c57f1a347e52a$var$tabContentContainerStyles,
        children: tabExpanders.map((tabItem, index)=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$var$$f3815ecfa3837fcc$export$2e2bcd8739ae039, {
                title: tabItem.title,
                description: tabItem.description,
                resources: tabItem.resources,
                color: color,
                expandedByDefault: index === 0,
                iconType: iconType,
                expandedContent: tabItem.expandedContent
            }, tabItem.title))
    });
};
const $24c02ea0e14dbe4f$var$$737c57f1a347e52a$var$tabContentContainerStyles = (0, $74Zh5.css)({
    display: "flex",
    flexDirection: "column",
    gap: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.300"),
    [(0, $cb8cedbc477f5a81$export$987d49ffe1b0900f).below.md]: {
        gap: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.200")
    }
});
var $24c02ea0e14dbe4f$var$$737c57f1a347e52a$export$2e2bcd8739ae039 = $24c02ea0e14dbe4f$var$$737c57f1a347e52a$var$TabContent;
const $24c02ea0e14dbe4f$export$187009fd9803261e = ({ tabs: tabs, containerStyles: containerStyles, defaultSelectedIndex: defaultSelectedIndex = 0, onTabChange: onTabChange })=>{
    const [selectedTabIndex, setSelectedTabIndex] = (0, $5FkrB.useState)(defaultSelectedIndex);
    const tabRefs = (0, $5FkrB.useRef)([]);
    const contentRef = (0, $5FkrB.useRef)(null);
    const handleSelectTab = (0, $5FkrB.useCallback)((index)=>{
        setSelectedTabIndex(index);
        onTabChange?.(index);
    }, [
        onTabChange
    ]);
    const handleKeyDown = (0, $5FkrB.useCallback)((event)=>{
        let newIndex = selectedTabIndex;
        switch(event.key){
            case "ArrowLeft":
                event.preventDefault();
                newIndex = selectedTabIndex > 0 ? selectedTabIndex - 1 : tabs.length - 1;
                break;
            case "ArrowRight":
                event.preventDefault();
                newIndex = selectedTabIndex < tabs.length - 1 ? selectedTabIndex + 1 : 0;
                break;
            case "Home":
                event.preventDefault();
                newIndex = 0;
                break;
            case "End":
                event.preventDefault();
                newIndex = tabs.length - 1;
                break;
            default:
                return;
        }
        if (newIndex !== selectedTabIndex) {
            contentRef.current?.focus?.();
            handleSelectTab(newIndex);
        }
    }, [
        selectedTabIndex,
        tabs.length,
        handleSelectTab
    ]);
    const selectedTabContent = (0, $5FkrB.useMemo)(()=>{
        const selected = tabs[selectedTabIndex];
        if (!selected) return null;
        return selected;
    }, [
        tabs,
        selectedTabIndex
    ]);
    return (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
        css: [
            $24c02ea0e14dbe4f$var$$6937e97bac512574$var$defaultContainerStyles,
            containerStyles
        ],
        "data-testid": "tabbed-accordion",
        children: [
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                css: $24c02ea0e14dbe4f$var$$6937e97bac512574$var$tabsHeaderStyles,
                children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                    css: $24c02ea0e14dbe4f$var$$6937e97bac512574$var$tabsRowStyles,
                    role: "tablist",
                    "aria-label": "Tabbed accordion tabs",
                    tabIndex: 0,
                    onKeyDown: handleKeyDown,
                    children: tabs.map((tab, index)=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                            css: $24c02ea0e14dbe4f$var$$6937e97bac512574$var$tabWrapperStyles,
                            ref: (el)=>tabRefs.current[index] = el,
                            tabIndex: -1,
                            role: "tab",
                            "aria-selected": index === selectedTabIndex,
                            "aria-controls": `tabpanel-${index}`,
                            "aria-setsize": tabs.length,
                            "aria-posinset": index + 1,
                            id: `tab-${index}`,
                            onClick: ()=>handleSelectTab(index),
                            onKeyDown: (e)=>{
                                if (e.key === "Enter" || e.key === " ") {
                                    e.preventDefault();
                                    handleSelectTab(index);
                                }
                            },
                            children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$3e41faf802a29e71, {
                                label: tab.label,
                                labelColor: tab.labelColor || (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text"),
                                labelColorSelected: tab.labelColorSelected || (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text"),
                                labelColorSelectedHover: tab.labelColorSelectedHover || (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text"),
                                selectedColor: tab.color,
                                selectedHoverColor: tab.color,
                                size: $24c02ea0e14dbe4f$export$ddadc1228c8dcfa.SMALL,
                                selected: index === selectedTabIndex
                            })
                        }, tab.label))
                })
            }),
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("hr", {
                css: $24c02ea0e14dbe4f$var$$6937e97bac512574$var$dividerStyles
            }),
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                css: $24c02ea0e14dbe4f$var$$6937e97bac512574$var$accordionContainerStyles,
                ref: contentRef,
                tabIndex: -1,
                role: "tabpanel",
                id: `tabpanel-${selectedTabIndex}`,
                "aria-labelledby": `tab-${selectedTabIndex}`,
                "aria-label": `${tabs[selectedTabIndex]?.label} content`,
                children: selectedTabContent && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$var$$737c57f1a347e52a$export$2e2bcd8739ae039, {
                    tabExpanders: selectedTabContent.tabExpanders,
                    color: selectedTabContent.color,
                    iconType: selectedTabContent.iconType
                })
            })
        ]
    });
};
const $24c02ea0e14dbe4f$var$$6937e97bac512574$var$defaultContainerStyles = (0, $74Zh5.css)({
    width: "100%",
    display: "flex",
    flexDirection: "column",
    gap: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.600"),
    [(0, $cb8cedbc477f5a81$export$987d49ffe1b0900f).below.md]: {
        gap: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.300")
    }
});
const $24c02ea0e14dbe4f$var$$6937e97bac512574$var$tabsHeaderStyles = (0, $74Zh5.css)({
    width: "100%"
});
const $24c02ea0e14dbe4f$var$$6937e97bac512574$var$tabsRowStyles = (0, $74Zh5.css)({
    display: "flex",
    flexWrap: "wrap",
    gap: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.100")
});
const $24c02ea0e14dbe4f$var$$6937e97bac512574$var$dividerStyles = (0, $74Zh5.css)({
    border: `0.5px solid ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.border")}`,
    width: "100%",
    margin: 0,
    [(0, $cb8cedbc477f5a81$export$987d49ffe1b0900f).above.md]: {
        display: "none"
    }
});
const $24c02ea0e14dbe4f$var$$6937e97bac512574$var$tabWrapperStyles = (0, $74Zh5.css)({
    display: "flex",
    // override default pressed style
    '& [data-testid="tab"]:active': {
        backgroundColor: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.background.accent.gray.subtlest.hovered")
    }
});
const $24c02ea0e14dbe4f$var$$6937e97bac512574$var$accordionContainerStyles = (0, $74Zh5.css)({
    width: "100%"
});
var $24c02ea0e14dbe4f$var$$8aff256b69bb18bd$exports = {};
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$8aff256b69bb18bd$exports, "TabbedCards", ()=>$24c02ea0e14dbe4f$export$f0f045459b5b92);
const $24c02ea0e14dbe4f$export$f0f045459b5b92 = ({ cards: cards, containerStyles: containerStyles, defaultSelectedIndex: defaultSelectedIndex = 0, onTabChange: onTabChange, ctaText: ctaText = "Learn more" })=>{
    const safeDefaultSelectedIndex = Math.min(Math.max(0, defaultSelectedIndex), Math.max(0, cards.length - 1));
    const [selectedCardIndex, setSelectedCardIndex] = (0, $5FkrB.useState)(safeDefaultSelectedIndex);
    const tabRefs = (0, $5FkrB.useRef)([]);
    const handleSelectTab = (0, $5FkrB.useCallback)((index)=>{
        setSelectedCardIndex(index);
        onTabChange?.(index);
    }, [
        onTabChange
    ]);
    const selectedCard = (0, $5FkrB.useMemo)(()=>{
        const selected = cards[selectedCardIndex];
        return selected ?? null;
    }, [
        cards,
        selectedCardIndex
    ]);
    if (!cards.length) return null;
    return (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
        css: [
            $24c02ea0e14dbe4f$var$$8aff256b69bb18bd$var$containerBaseStyles,
            containerStyles
        ],
        "data-testid": "tabbed-cards",
        children: [
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                css: $24c02ea0e14dbe4f$var$$8aff256b69bb18bd$var$tabsHeaderStyles,
                children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                    css: $24c02ea0e14dbe4f$var$$8aff256b69bb18bd$var$tabsRowStyles,
                    role: "tablist",
                    "aria-label": "Tabbed cards tabs",
                    children: cards.map((card, index)=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                            css: $24c02ea0e14dbe4f$var$$8aff256b69bb18bd$var$tabWrapperStyles,
                            ref: (el)=>tabRefs.current[index] = el,
                            tabIndex: -1,
                            role: "tab",
                            "aria-selected": index === selectedCardIndex,
                            "aria-controls": `tabpanel-${index}`,
                            "aria-setsize": cards.length,
                            "aria-posinset": index + 1,
                            id: `tab-${index}`,
                            onClick: ()=>handleSelectTab(index),
                            onKeyDown: (e)=>{
                                if (e.key === "Enter" || e.key === " ") {
                                    e.preventDefault();
                                    handleSelectTab(index);
                                }
                            },
                            children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$3e41faf802a29e71, {
                                label: card.title,
                                labelColor: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text"),
                                labelColorSelected: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text.inverse"),
                                labelColorSelectedHover: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text.inverse"),
                                selectedColor: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.icon.discovery"),
                                selectedHoverColor: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.icon.discovery"),
                                size: $24c02ea0e14dbe4f$export$ddadc1228c8dcfa.MEDIUM,
                                selected: index === selectedCardIndex
                            })
                        }, card.title))
                })
            }),
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                css: $24c02ea0e14dbe4f$var$$8aff256b69bb18bd$var$panelContainerStyles,
                tabIndex: -1,
                role: "tabpanel",
                id: `tabpanel-${selectedCardIndex}`,
                "aria-labelledby": `tab-${selectedCardIndex}`,
                "aria-label": `${cards[selectedCardIndex]?.title} content`,
                children: selectedCard && (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                    css: $24c02ea0e14dbe4f$var$$8aff256b69bb18bd$var$cardContainerStyles,
                    children: [
                        (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                            css: $24c02ea0e14dbe4f$var$$8aff256b69bb18bd$var$cardLeftStyles,
                            children: [
                                (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                                    css: $24c02ea0e14dbe4f$var$$8aff256b69bb18bd$var$textBlockStyles,
                                    children: [
                                        (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$a8a3e93435678ff9, {
                                            level: 3,
                                            children: selectedCard.title
                                        }),
                                        selectedCard.subtitle && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$5f1af8db9871e1d6, {
                                            size: "regular",
                                            color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text"),
                                            children: selectedCard.subtitle
                                        })
                                    ]
                                }),
                                (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                                    css: $24c02ea0e14dbe4f$var$$8aff256b69bb18bd$var$ctaContainerStyles,
                                    children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$353f5b6fc5456de1, {
                                        appearance: $24c02ea0e14dbe4f$export$261c9483fc4a455a.LINK,
                                        label: ctaText,
                                        href: selectedCard.href,
                                        target: selectedCard.target,
                                        iconAfter: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$f04a61298a47a40f, {
                                            type: "arrow-right",
                                            alt: "Arrow right",
                                            size: $24c02ea0e14dbe4f$export$ff775019b5b6e7df.MEDIUM
                                        })
                                    })
                                })
                            ]
                        }),
                        (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                            css: $24c02ea0e14dbe4f$var$$8aff256b69bb18bd$var$imageWellStyles,
                            children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("img", {
                                src: selectedCard.img.src,
                                alt: selectedCard.img.alt,
                                width: selectedCard.img.width,
                                height: selectedCard.img.height,
                                css: $24c02ea0e14dbe4f$var$$8aff256b69bb18bd$var$cardImageStyles,
                                loading: selectedCard.img.loading,
                                decoding: selectedCard.img.decoding
                            })
                        })
                    ]
                })
            })
        ]
    });
};
const $24c02ea0e14dbe4f$var$$8aff256b69bb18bd$var$containerBaseStyles = (0, $74Zh5.css)({
    width: "100%",
    display: "flex",
    flexDirection: "column",
    gap: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.600"),
    [(0, $cb8cedbc477f5a81$export$987d49ffe1b0900f).below.md]: {
        gap: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.300")
    }
});
const $24c02ea0e14dbe4f$var$$8aff256b69bb18bd$var$tabsHeaderStyles = (0, $74Zh5.css)({
    width: "100%"
});
const $24c02ea0e14dbe4f$var$$8aff256b69bb18bd$var$tabsRowStyles = (0, $74Zh5.css)({
    display: "flex",
    flexWrap: "nowrap",
    justifyContent: "center",
    gap: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.100"),
    overflowX: "auto",
    [(0, $cb8cedbc477f5a81$export$987d49ffe1b0900f).below.md]: {
        flexWrap: "wrap",
        justifyContent: "flex-start"
    }
});
const $24c02ea0e14dbe4f$var$$8aff256b69bb18bd$var$tabWrapperStyles = (0, $74Zh5.css)({
    display: "flex",
    // override default pressed style
    '& [data-testid="tab-selected"]:active': {
        backgroundColor: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.icon.discovery")
    },
    '& [data-testid="tab"]:active': {
        backgroundColor: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.background.accent.gray.subtlest.hovered")
    }
});
const $24c02ea0e14dbe4f$var$$8aff256b69bb18bd$var$panelContainerStyles = (0, $74Zh5.css)({
    width: "100%"
});
const $24c02ea0e14dbe4f$var$$8aff256b69bb18bd$var$cardContainerStyles = (0, $74Zh5.css)({
    width: "100%",
    backgroundColor: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("elevation.surface"),
    borderRadius: "8px",
    boxShadow: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("elevation.shadow.raised"),
    overflow: "hidden",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    minHeight: "266px",
    gap: "80px",
    paddingLeft: "62px",
    [(0, $cb8cedbc477f5a81$export$987d49ffe1b0900f).below.md]: {
        flexDirection: "column",
        alignItems: "stretch",
        gap: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.400"),
        padding: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.400")
    }
});
const $24c02ea0e14dbe4f$var$$8aff256b69bb18bd$var$cardLeftStyles = (0, $74Zh5.css)({
    display: "flex",
    flexDirection: "column",
    gap: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.300"),
    flex: "1 1 auto",
    minWidth: 0,
    paddingTop: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.400"),
    paddingBottom: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.400"),
    [(0, $cb8cedbc477f5a81$export$987d49ffe1b0900f).below.md]: {
        padding: 0
    }
});
const $24c02ea0e14dbe4f$var$$8aff256b69bb18bd$var$textBlockStyles = (0, $74Zh5.css)({
    display: "flex",
    flexDirection: "column",
    gap: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.100"),
    minWidth: 0
});
const $24c02ea0e14dbe4f$var$$8aff256b69bb18bd$var$ctaContainerStyles = (0, $74Zh5.css)({
    display: "flex",
    alignItems: "center",
    alignSelf: "flex-start",
    // Align button label with heading/subtitle by removing left padding.
    '& [data-testid="button-link"]': {
        paddingLeft: 0
    }
});
const $24c02ea0e14dbe4f$var$$8aff256b69bb18bd$var$imageWellStyles = (0, $74Zh5.css)({
    width: "416px",
    height: "266px",
    backgroundColor: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("elevation.surface.sunken"),
    borderTopRightRadius: "20px",
    borderBottomRightRadius: "20px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0,
    [(0, $cb8cedbc477f5a81$export$987d49ffe1b0900f).below.md]: {
        width: "100%",
        height: "200px",
        borderTopRightRadius: "8px",
        borderBottomRightRadius: "8px",
        borderTopLeftRadius: "8px",
        borderBottomLeftRadius: "8px"
    }
});
const $24c02ea0e14dbe4f$var$$8aff256b69bb18bd$var$cardImageStyles = (0, $74Zh5.css)({
    maxWidth: "100%",
    maxHeight: "100%",
    objectFit: "contain"
});
var $24c02ea0e14dbe4f$var$$271716b3dbf43c41$exports = {};
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$271716b3dbf43c41$exports, "MeatballMenu", ()=>$24c02ea0e14dbe4f$export$ef4a0fdddd7eccb7);
const $24c02ea0e14dbe4f$export$ef4a0fdddd7eccb7 = ({ items: items, placement: placement = "bottom-end", testId: testId = "meatball-menu", ariaLabel: ariaLabel = "More options", isInverted: isInverted = false })=>{
    return (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
        css: $24c02ea0e14dbe4f$var$$271716b3dbf43c41$var$menuContainerStyles,
        "data-testid": testId,
        children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $9e29898158274f39$export$2e2bcd8739ae039), {
            trigger: ({ triggerRef: triggerRef, ...props })=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("button", {
                    ...props,
                    ref: triggerRef,
                    css: [
                        $24c02ea0e14dbe4f$var$$271716b3dbf43c41$var$triggerButtonStyles,
                        isInverted && $24c02ea0e14dbe4f$var$$271716b3dbf43c41$var$invertedTriggerButtonStyles
                    ],
                    "aria-label": ariaLabel,
                    "data-testid": `${testId}-trigger`,
                    children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$f04a61298a47a40f, {
                        type: "more-vertical",
                        rotation: $24c02ea0e14dbe4f$export$b3241a99d3e47e02.NINETY,
                        alt: ariaLabel,
                        color: isInverted ? "#FFFFFF" : undefined
                    })
                }),
            placement: placement,
            children: items.map((item, index)=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $896b4f3af893fddb$export$2e2bcd8739ae039), {
                    onClick: item.onClick,
                    isDisabled: item.isDisabled,
                    testId: item.testId || `${testId}-item-${index}`,
                    children: item.label
                }, `${item.label}-${index}`))
        })
    });
};
const $24c02ea0e14dbe4f$var$$271716b3dbf43c41$var$menuContainerStyles = (0, $74Zh5.css)({
    display: "inline-flex",
    alignItems: "center"
});
const $24c02ea0e14dbe4f$var$$271716b3dbf43c41$var$triggerButtonStyles = (0, $74Zh5.css)({
    background: "transparent",
    border: "none",
    padding: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.050"),
    cursor: "pointer",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: "4px",
    transition: "background-color 0.2s ease",
    "&:hover": {
        backgroundColor: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.background.neutral.hovered")
    },
    "&:active": {
        backgroundColor: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.background.neutral.pressed")
    },
    "&:focus": {
        outline: `2px solid ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.border.focused")}`,
        outlineOffset: "2px"
    }
});
const $24c02ea0e14dbe4f$var$$271716b3dbf43c41$var$invertedTriggerButtonStyles = (0, $74Zh5.css)({
    "&:hover": {
        backgroundColor: "rgba(255, 255, 255, 0.16)"
    },
    "&:active": {
        backgroundColor: "rgba(255, 255, 255, 0.24)"
    },
    "&:focus": {
        outline: `2px solid ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.border.inverse")}`,
        outlineOffset: "2px"
    }
});
var $24c02ea0e14dbe4f$var$$fd4e65895774e705$exports = {};
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$fd4e65895774e705$exports, "ProfileAvatarSize", ()=>$24c02ea0e14dbe4f$export$902867f9afe4e0c1);
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$fd4e65895774e705$exports, "ProfileAvatar", ()=>$24c02ea0e14dbe4f$export$3778be82376b06d7);
let $24c02ea0e14dbe4f$export$902867f9afe4e0c1;
(function(ProfileAvatarSize) {
    ProfileAvatarSize["XS"] = "xs";
    ProfileAvatarSize["S"] = "s";
    ProfileAvatarSize["M"] = "m";
    ProfileAvatarSize["L"] = "l";
    ProfileAvatarSize["XL"] = "xl";
    ProfileAvatarSize["XXL"] = "xxl";
    ProfileAvatarSize["XXXL"] = "xxxl";
})($24c02ea0e14dbe4f$export$902867f9afe4e0c1 || ($24c02ea0e14dbe4f$export$902867f9afe4e0c1 = {}));
const $24c02ea0e14dbe4f$var$$fd4e65895774e705$var$sizeMap = {
    [$24c02ea0e14dbe4f$export$902867f9afe4e0c1.XS]: 16,
    [$24c02ea0e14dbe4f$export$902867f9afe4e0c1.S]: 24,
    [$24c02ea0e14dbe4f$export$902867f9afe4e0c1.M]: 32,
    [$24c02ea0e14dbe4f$export$902867f9afe4e0c1.L]: 40,
    [$24c02ea0e14dbe4f$export$902867f9afe4e0c1.XL]: 96,
    [$24c02ea0e14dbe4f$export$902867f9afe4e0c1.XXL]: 128,
    [$24c02ea0e14dbe4f$export$902867f9afe4e0c1.XXXL]: 248
};
const $24c02ea0e14dbe4f$var$$fd4e65895774e705$var$atlaskitSizeMap = {
    [$24c02ea0e14dbe4f$export$902867f9afe4e0c1.XS]: "xsmall",
    [$24c02ea0e14dbe4f$export$902867f9afe4e0c1.S]: "small",
    [$24c02ea0e14dbe4f$export$902867f9afe4e0c1.M]: "medium",
    [$24c02ea0e14dbe4f$export$902867f9afe4e0c1.L]: "large",
    [$24c02ea0e14dbe4f$export$902867f9afe4e0c1.XL]: "xlarge",
    [$24c02ea0e14dbe4f$export$902867f9afe4e0c1.XXL]: "xxlarge",
    [$24c02ea0e14dbe4f$export$902867f9afe4e0c1.XXXL]: "xxlarge"
};
// Pixel sizes used internally by @atlaskit/avatar for each `size` value.
const $24c02ea0e14dbe4f$var$$fd4e65895774e705$var$atlaskitSizePx = {
    xsmall: 16,
    small: 24,
    medium: 32,
    large: 40,
    xlarge: 96,
    xxlarge: 128
};
const $24c02ea0e14dbe4f$export$3778be82376b06d7 = ({ size: size, label: label, src: src, showCameraIconOnXXXL: showCameraIconOnXXXL = false, onCameraClick: onCameraClick })=>{
    const avatarSize = $24c02ea0e14dbe4f$var$$fd4e65895774e705$var$sizeMap[size] ?? $24c02ea0e14dbe4f$var$$fd4e65895774e705$var$sizeMap[$24c02ea0e14dbe4f$export$902867f9afe4e0c1.M];
    const borderWidth = size === $24c02ea0e14dbe4f$export$902867f9afe4e0c1.XXXL ? 8 : 2;
    const scale = avatarSize / $24c02ea0e14dbe4f$var$$fd4e65895774e705$var$atlaskitSizePx[$24c02ea0e14dbe4f$var$$fd4e65895774e705$var$atlaskitSizeMap[size]];
    return (0, $6bec4f26b2cb3094$export$25062201e9e25d76)((0, $abf94df1a292a623$export$2e2bcd8739ae039), {
        xcss: $24c02ea0e14dbe4f$var$$fd4e65895774e705$var$wrapperBaseStyles,
        style: {
            width: avatarSize + 2 * borderWidth,
            height: avatarSize + 2 * borderWidth
        },
        children: [
            (0, $6bec4f26b2cb3094$export$25062201e9e25d76)((0, $abf94df1a292a623$export$2e2bcd8739ae039), {
                xcss: $24c02ea0e14dbe4f$var$$fd4e65895774e705$var$avatarFrameStyles,
                children: [
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $abf94df1a292a623$export$2e2bcd8739ae039), {
                        xcss: $24c02ea0e14dbe4f$var$$fd4e65895774e705$var$avatarBorderRingStyles,
                        style: {
                            border: `${borderWidth}px solid ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("elevation.surface.overlay")}`
                        }
                    }),
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $abf94df1a292a623$export$2e2bcd8739ae039), {
                        xcss: $24c02ea0e14dbe4f$var$$fd4e65895774e705$var$avatarScaleWrapperStyles,
                        style: {
                            transform: `scale(${scale})`
                        },
                        children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $f31efb9f24b21b67$export$2e2bcd8739ae039), {
                            size: $24c02ea0e14dbe4f$var$$fd4e65895774e705$var$atlaskitSizeMap[size],
                            src: src,
                            name: label,
                            borderColor: "transparent"
                        })
                    })
                ]
            }),
            showCameraIconOnXXXL ? (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $abf94df1a292a623$export$2e2bcd8739ae039), {
                as: "span",
                xcss: $24c02ea0e14dbe4f$var$$fd4e65895774e705$var$cameraWrapperStyles,
                children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $abf94df1a292a623$export$2e2bcd8739ae039), {
                    as: "button",
                    type: "button",
                    xcss: $24c02ea0e14dbe4f$var$$fd4e65895774e705$var$cameraButtonStyles,
                    "aria-label": "Change profile picture",
                    onClick: onCameraClick,
                    children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($af69d9e57c55d6b7$exports))), {
                        label: "Change profile picture",
                        color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.icon.subtle")
                    })
                })
            }) : null
        ]
    });
};
const $24c02ea0e14dbe4f$var$$fd4e65895774e705$var$wrapperBaseStyles = (0, $7c2f920c3bda89b1$export$f6c783d06584602c)({
    position: "relative",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    boxSizing: "border-box"
});
const $24c02ea0e14dbe4f$var$$fd4e65895774e705$var$avatarFrameStyles = (0, $7c2f920c3bda89b1$export$f6c783d06584602c)({
    width: "100%",
    height: "100%",
    borderRadius: "border.radius.circle",
    overflow: "hidden",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "color.background.neutral",
    boxSizing: "border-box",
    position: "relative"
});
const $24c02ea0e14dbe4f$var$$fd4e65895774e705$var$avatarBorderRingStyles = (0, $7c2f920c3bda89b1$export$f6c783d06584602c)({
    position: "absolute",
    inset: "space.0",
    borderRadius: "border.radius.circle",
    pointerEvents: "none",
    boxSizing: "border-box"
});
const $24c02ea0e14dbe4f$var$$fd4e65895774e705$var$avatarScaleWrapperStyles = (0, $7c2f920c3bda89b1$export$f6c783d06584602c)({
    transformOrigin: "center",
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
});
const $24c02ea0e14dbe4f$var$$fd4e65895774e705$var$cameraWrapperStyles = (0, $7c2f920c3bda89b1$export$f6c783d06584602c)({
    position: "absolute",
    width: "55px",
    height: "55px",
    borderRadius: "border.radius.circle",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    right: "16px",
    bottom: "14px",
    backgroundColor: "color.background.input",
    boxShadow: "elevation.shadow.overlay"
});
const $24c02ea0e14dbe4f$var$$fd4e65895774e705$var$cameraButtonStyles = (0, $7c2f920c3bda89b1$export$f6c783d06584602c)({
    width: "100%",
    height: "100%",
    borderRadius: "border.radius.circle",
    borderWidth: "border.width.0",
    padding: "space.0",
    margin: "space.0",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    background: "transparent",
    cursor: "pointer"
});
$24c02ea0e14dbe4f$var$$parcel$exportWildcard($24c02ea0e14dbe4f$var$$5d4509b60606b6df$exports, $24c02ea0e14dbe4f$var$$660bd1c6cb41002a$exports);
$24c02ea0e14dbe4f$var$$parcel$exportWildcard($24c02ea0e14dbe4f$var$$5d4509b60606b6df$exports, $24c02ea0e14dbe4f$var$$fec02fc26c7e145d$exports);
$24c02ea0e14dbe4f$var$$parcel$exportWildcard($24c02ea0e14dbe4f$var$$5d4509b60606b6df$exports, $24c02ea0e14dbe4f$var$$d501466973a9f0a6$exports);
$24c02ea0e14dbe4f$var$$parcel$exportWildcard($24c02ea0e14dbe4f$var$$5d4509b60606b6df$exports, $24c02ea0e14dbe4f$var$$c4979bfceee73878$exports);
$24c02ea0e14dbe4f$var$$parcel$exportWildcard($24c02ea0e14dbe4f$var$$5d4509b60606b6df$exports, $24c02ea0e14dbe4f$var$$0903e93de01b205a$exports);
$24c02ea0e14dbe4f$var$$parcel$exportWildcard($24c02ea0e14dbe4f$var$$5d4509b60606b6df$exports, $24c02ea0e14dbe4f$var$$a950778dc3003c4a$exports);
$24c02ea0e14dbe4f$var$$parcel$exportWildcard($24c02ea0e14dbe4f$var$$5d4509b60606b6df$exports, $24c02ea0e14dbe4f$var$$582583ec420fce57$exports);
$24c02ea0e14dbe4f$var$$parcel$exportWildcard($24c02ea0e14dbe4f$var$$5d4509b60606b6df$exports, $24c02ea0e14dbe4f$var$$a02a6f7de308273b$exports);
$24c02ea0e14dbe4f$var$$parcel$exportWildcard($24c02ea0e14dbe4f$var$$5d4509b60606b6df$exports, $24c02ea0e14dbe4f$var$$1298c86a7e6a9fc7$exports);
$24c02ea0e14dbe4f$var$$parcel$exportWildcard($24c02ea0e14dbe4f$var$$5d4509b60606b6df$exports, $24c02ea0e14dbe4f$var$$c0c01354ab9765ae$exports);
$24c02ea0e14dbe4f$var$$parcel$exportWildcard($24c02ea0e14dbe4f$var$$5d4509b60606b6df$exports, $24c02ea0e14dbe4f$var$$4fce8dfc4ce8f546$exports);
$24c02ea0e14dbe4f$var$$parcel$exportWildcard($24c02ea0e14dbe4f$var$$5d4509b60606b6df$exports, $24c02ea0e14dbe4f$var$$800df40a54823a3f$exports);
$24c02ea0e14dbe4f$var$$parcel$exportWildcard($24c02ea0e14dbe4f$var$$5d4509b60606b6df$exports, $24c02ea0e14dbe4f$var$$25cbe9fdb2d8d071$exports);
$24c02ea0e14dbe4f$var$$parcel$exportWildcard($24c02ea0e14dbe4f$var$$5d4509b60606b6df$exports, $24c02ea0e14dbe4f$var$$9efbb38deb40219f$exports);
$24c02ea0e14dbe4f$var$$parcel$exportWildcard($24c02ea0e14dbe4f$var$$5d4509b60606b6df$exports, $24c02ea0e14dbe4f$var$$3fbcb32390ca7008$exports);
$24c02ea0e14dbe4f$var$$parcel$exportWildcard($24c02ea0e14dbe4f$var$$5d4509b60606b6df$exports, $24c02ea0e14dbe4f$var$$731a4fd527bab680$exports);
$24c02ea0e14dbe4f$var$$parcel$exportWildcard($24c02ea0e14dbe4f$var$$5d4509b60606b6df$exports, $24c02ea0e14dbe4f$var$$5cf70e33bfc6ce73$exports);
$24c02ea0e14dbe4f$var$$parcel$exportWildcard($24c02ea0e14dbe4f$var$$5d4509b60606b6df$exports, $24c02ea0e14dbe4f$var$$8b54d37779d052e8$exports);
$24c02ea0e14dbe4f$var$$parcel$exportWildcard($24c02ea0e14dbe4f$var$$5d4509b60606b6df$exports, $24c02ea0e14dbe4f$var$$9cfa05d02afa3952$exports);
$24c02ea0e14dbe4f$var$$parcel$exportWildcard($24c02ea0e14dbe4f$var$$5d4509b60606b6df$exports, $24c02ea0e14dbe4f$var$$7d458ed59bb9c6a8$exports);
$24c02ea0e14dbe4f$var$$parcel$exportWildcard($24c02ea0e14dbe4f$var$$5d4509b60606b6df$exports, $24c02ea0e14dbe4f$var$$a467abe0c2c1750b$exports);
$24c02ea0e14dbe4f$var$$parcel$exportWildcard($24c02ea0e14dbe4f$var$$5d4509b60606b6df$exports, $24c02ea0e14dbe4f$var$$52124b9ae1d78e04$exports);
$24c02ea0e14dbe4f$var$$parcel$exportWildcard($24c02ea0e14dbe4f$var$$5d4509b60606b6df$exports, $24c02ea0e14dbe4f$var$$b5ebb29d1a23bfec$exports);
$24c02ea0e14dbe4f$var$$parcel$exportWildcard($24c02ea0e14dbe4f$var$$5d4509b60606b6df$exports, $24c02ea0e14dbe4f$var$$77696804880d7cdc$exports);
$24c02ea0e14dbe4f$var$$parcel$exportWildcard($24c02ea0e14dbe4f$var$$5d4509b60606b6df$exports, $24c02ea0e14dbe4f$var$$4366d2b05f9f8f6b$exports);
$24c02ea0e14dbe4f$var$$parcel$exportWildcard($24c02ea0e14dbe4f$var$$5d4509b60606b6df$exports, $24c02ea0e14dbe4f$var$$be203e745bcefb12$exports);
$24c02ea0e14dbe4f$var$$parcel$exportWildcard($24c02ea0e14dbe4f$var$$5d4509b60606b6df$exports, $24c02ea0e14dbe4f$var$$a0eced43682c2d75$exports);
$24c02ea0e14dbe4f$var$$parcel$exportWildcard($24c02ea0e14dbe4f$var$$5d4509b60606b6df$exports, $24c02ea0e14dbe4f$var$$1db60c687807de63$exports);
$24c02ea0e14dbe4f$var$$parcel$exportWildcard($24c02ea0e14dbe4f$var$$5d4509b60606b6df$exports, $24c02ea0e14dbe4f$var$$2f0c862779035c26$exports);
$24c02ea0e14dbe4f$var$$parcel$exportWildcard($24c02ea0e14dbe4f$var$$5d4509b60606b6df$exports, $24c02ea0e14dbe4f$var$$6937e97bac512574$exports);
$24c02ea0e14dbe4f$var$$parcel$exportWildcard($24c02ea0e14dbe4f$var$$5d4509b60606b6df$exports, $24c02ea0e14dbe4f$var$$8aff256b69bb18bd$exports);
$24c02ea0e14dbe4f$var$$parcel$exportWildcard($24c02ea0e14dbe4f$var$$5d4509b60606b6df$exports, $24c02ea0e14dbe4f$var$$271716b3dbf43c41$exports);
$24c02ea0e14dbe4f$var$$parcel$exportWildcard($24c02ea0e14dbe4f$var$$5d4509b60606b6df$exports, $24c02ea0e14dbe4f$var$$fd4e65895774e705$exports);
var $24c02ea0e14dbe4f$var$$6e379ec2eca3d7d3$exports = {};
var $24c02ea0e14dbe4f$var$$83fc18f8199a12ff$exports = {};
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$83fc18f8199a12ff$exports, "AudioPlayer", ()=>$24c02ea0e14dbe4f$export$832cc5475f11d8b4);
// using 'plyr' instead of 'plyr/dist/plyr'
// will start executing DOM APIs right away
// and it breaks SSR
const $24c02ea0e14dbe4f$export$832cc5475f11d8b4 = ({ source: source, isOpened: isOpened, onClose: onClose, onControlClick: onControlClick, onProgressUpdate: onProgressUpdate, onError: onError })=>{
    const audioRef = (0, $5FkrB.useRef)(null);
    const focusRef = (0, $5FkrB.useRef)(null);
    const playerSource = {
        type: "audio",
        sources: [
            {
                src: source
            }
        ]
    };
    const playerOptions = {
        hideControls: true,
        controls: [
            "play",
            "progress",
            "current-time"
        ]
    };
    const addEvent = (0, $5FkrB.useCallback)((instance, event)=>{
        instance.on(event, ()=>onControlClick && onControlClick(event));
        instance.on("timeupdate", ()=>{
            const currentTime = instance.currentTime;
            const duration = instance.duration;
            const percentage = currentTime / duration * 100;
            onProgressUpdate && onProgressUpdate(+percentage.toFixed(2));
        });
    }, [
        onControlClick,
        onProgressUpdate
    ]);
    const addEvents = (0, $5FkrB.useCallback)((instance)=>{
        addEvent(instance, "play");
        addEvent(instance, "pause");
        if (onError) instance.on("error", onError);
    }, [
        addEvent,
        onError
    ]);
    (0, $5FkrB.useEffect)(()=>{
        const player = new (0, (/*@__PURE__*/$parcel$interopDefault($1c94bc9aa532188d$exports)))(audioRef.current, playerOptions);
        player.source = playerSource;
        addEvents(player);
        //To avoid: aria-label attribute is not well supported on a div with no valid role attribute.
        const plyrTimer = document.getElementsByClassName("plyr__time")[0];
        if (plyrTimer) plyrTimer.removeAttribute("aria-label");
        if (isOpened) focusRef.current?.focus();
        const plyrAudioContainer = document.getElementsByClassName("plyr--audio")[0];
        if (plyrAudioContainer) plyrAudioContainer.role = "presentation";
    }, [
        isOpened
    ]);
    /* eslint-enable react-hooks/exhaustive-deps */ const handleKeyDown = (0, $5FkrB.useCallback)((event)=>{
        if (event.code === "Space") {
            event.preventDefault();
            onClose();
        }
    }, [
        onClose
    ]);
    return isOpened && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
        role: "dialog",
        "aria-label": "Audio player",
        ref: focusRef,
        // eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex -- Dialog needs tabIndex for focus management
        tabIndex: 0,
        css: $24c02ea0e14dbe4f$var$$83fc18f8199a12ff$var$audioPlayerStyles,
        children: (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("figure", {
            "data-testid": "audio-player",
            css: $24c02ea0e14dbe4f$var$$83fc18f8199a12ff$var$figureStyles,
            children: [
                (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("audio", {
                    ref: audioRef
                }),
                (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                    role: "button",
                    tabIndex: 0,
                    onKeyDown: handleKeyDown,
                    onClick: onClose,
                    css: $24c02ea0e14dbe4f$var$$83fc18f8199a12ff$var$closeIconStyles,
                    "data-testid": "close-audio",
                    children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$f04a61298a47a40f, {
                        type: "cross",
                        color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.icon.subtle"),
                        alt: "close-audio"
                    })
                })
            ]
        })
    });
};
const $24c02ea0e14dbe4f$var$$83fc18f8199a12ff$var$audioPlayerStyles = (0, $74Zh5.css)({
    borderRadius: "8px",
    maxWidth: "340px",
    padding: "24px",
    boxShadow: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("elevation.shadow.overlay"),
    backgroundColor: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.background.input"),
    ".plyr--audio": {
        width: "100%",
        "--plyr-color-main": (0, $54ca2d3948378259$export$e62e8919cca44969),
        "--plyr-audio-control-color": (0, $54ca2d3948378259$export$29a4f05edc054374),
        "--plyr-control-icon-size": "16px",
        "--plyr-range-thumb-height": "8px",
        "--plyr-range-track-height": "8px",
        "--plyr-range-thumb-shadow": "none",
        "--plyr-audio-progress-buffered-background": (0, $54ca2d3948378259$export$c2e91cbeada39b8b),
        "--plyr-font-family": "Charlie Text",
        "--plyr-tooltip-background": (0, $54ca2d3948378259$export$c39c0fe0f26207ae),
        "--plyr-tooltip-color": (0, $54ca2d3948378259$export$29a4f05edc054374),
        "--plyr-tooltip-radius": "8px",
        "--plyr-control-spacing": "16px",
        "--plyr-range-thumb-background": (0, $54ca2d3948378259$export$e62e8919cca44969)
    },
    ".plyr--audio > .plyr__controls": {
        padding: 0
    },
    ".plyr--audio > .plyr__controls > .plyr__control": {
        width: "40px",
        height: "40px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        marginRight: "16px",
        backgroundColor: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.background.information.bold"),
        borderRadius: "50%"
    },
    ".plyr__progress": {
        marginRight: "16px"
    },
    ".icon--not-pressed": {
        marginRight: "-3px"
    },
    ".plyr__time": {
        fontFamily: "Inter, sans-serif",
        color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text.subtlest"),
        fontSize: "14px",
        fontWeight: 600
    },
    ".plyr--audio:focus, .plyr--audio:focus-visible": {
        border: `2px solid ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.border.selected")}`
    }
});
const $24c02ea0e14dbe4f$var$$83fc18f8199a12ff$var$figureStyles = (0, $74Zh5.css)({
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    margin: 0
});
const $24c02ea0e14dbe4f$var$$83fc18f8199a12ff$var$closeIconStyles = (0, $74Zh5.css)({
    display: "flex",
    cursor: "pointer",
    marginLeft: "4px"
});
var $24c02ea0e14dbe4f$var$$438c82700c218044$exports = {};
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$438c82700c218044$exports, "ArticleJumpLinks", ()=>$24c02ea0e14dbe4f$export$e11be3ad528d3c05);
const $24c02ea0e14dbe4f$var$$7af640a6c4cb35c7$export$5972a68b6e54f38f = (0, $74Zh5.css)({
    display: "flex",
    padding: `${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.150")} ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.100")}`,
    flexDirection: "column",
    alignItems: "flex-start",
    gap: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.100"),
    borderRadius: "8px",
    backgroundColor: "white",
    boxShadow: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("elevation.shadow.raised"),
    // desktop
    "@media (min-width: 1000px)": {
        padding: `${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.200")} ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.100")}`,
        maxWidth: "290px"
    }
});
const $24c02ea0e14dbe4f$var$$7af640a6c4cb35c7$export$2dc6a66a41038997 = (0, $74Zh5.css)({
    listStyle: "none",
    padding: 0,
    margin: 0,
    display: "flex",
    flexDirection: "column",
    gap: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.050")
});
const $24c02ea0e14dbe4f$var$$7af640a6c4cb35c7$export$4ea5976125a01ffa = (0, $74Zh5.css)({
    padding: `${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.050")} 0 ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.050")} ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.200")}`,
    position: "relative",
    "&:hover": {
        borderRadius: "4px",
        backgroundColor: "rgba(220, 223, 228, 0.50)"
    },
    "& a": {
        // limit to 2 lines
        display: "-webkit-box",
        WebkitBoxOrient: "vertical",
        WebkitLineClamp: "2",
        wordBreak: "break-word",
        overflow: "hidden",
        color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text.subtle"),
        textOverflow: "ellipsis",
        textDecoration: "none",
        fontFamily: "Inter, sans-serif",
        fontSize: "16px",
        fontWeight: "400",
        lineHeight: "24px"
    }
});
const $24c02ea0e14dbe4f$var$$7af640a6c4cb35c7$export$976a5bac7cff1dce = (0, $74Zh5.css)({
    // desktop
    "@media (min-width: 1000px)": {
        backgroundColor: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.background.accent.blue.subtlest"),
        borderRadius: "4px",
        "& a": {
            color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text.brand")
        },
        "&:hover": {
            backgroundColor: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.background.accent.blue.subtlest")
        },
        ":before": {
            content: '""',
            display: "block",
            width: "2px",
            height: "16px",
            backgroundColor: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text.brand"),
            position: "absolute",
            left: "0",
            top: "50%",
            transform: "translateY(-50%)"
        }
    }
});
const $24c02ea0e14dbe4f$var$$7af640a6c4cb35c7$export$405b853093cc10c7 = (0, $74Zh5.css)({
    padding: `0 ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.200")}`,
    "& h6": {
        textOverflow: "ellipsis",
        fontSize: "16px !important",
        lineHeight: "24px !important"
    },
    // desktop
    "@media (min-width: 1000px)": {
        display: "none"
    }
});
const $24c02ea0e14dbe4f$var$$438c82700c218044$var$DEFAULT_TITLE = "On this page";
const $24c02ea0e14dbe4f$export$e11be3ad528d3c05 = ({ links: links, className: className, style: style, onClick: onClick, title: title = $24c02ea0e14dbe4f$var$$438c82700c218044$var$DEFAULT_TITLE, activeHref: activeHref })=>{
    const [internalActiveLink, setInternalActiveLink] = (0, $5FkrB.useState)(null);
    const handleScroll = (0, $5FkrB.useCallback)(()=>{
        internalActiveLink && setInternalActiveLink(null);
    }, [
        internalActiveLink
    ]);
    const handleClick = (0, $5FkrB.useCallback)((link)=>{
        requestAnimationFrame(()=>{
            setInternalActiveLink(link);
        });
        onClick?.(link);
    }, [
        onClick,
        setInternalActiveLink
    ]);
    (0, $5FkrB.useEffect)(()=>{
        // Only add scroll listener if activeHref is not provided (internal state mode)
        if (!activeHref) {
            window.addEventListener("scroll", handleScroll);
            return ()=>{
                window.removeEventListener("scroll", handleScroll);
            };
        }
    }, [
        handleScroll,
        activeHref
    ]);
    const linksWithHref = (0, $5FkrB.useMemo)(()=>{
        return links.map((link)=>{
            const linkHref = link.href ? link.href : $24c02ea0e14dbe4f$export$1bdcd43c8c2377cf(link.label);
            // Use activeHref prop if provided, otherwise fall back to internal state
            const isActive = activeHref ? linkHref === activeHref : internalActiveLink?.label === link.label;
            const onLinkClick = ()=>handleClick?.(link);
            return (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("li", {
                css: [
                    $24c02ea0e14dbe4f$var$$7af640a6c4cb35c7$export$4ea5976125a01ffa,
                    isActive && $24c02ea0e14dbe4f$var$$7af640a6c4cb35c7$export$976a5bac7cff1dce
                ],
                children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("a", {
                    href: linkHref,
                    onClick: onLinkClick,
                    children: link.label
                })
            }, linkHref);
        });
    }, [
        links,
        internalActiveLink,
        activeHref,
        handleClick
    ]);
    return (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
        css: $24c02ea0e14dbe4f$var$$7af640a6c4cb35c7$export$5972a68b6e54f38f,
        children: [
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                css: $24c02ea0e14dbe4f$var$$7af640a6c4cb35c7$export$405b853093cc10c7,
                children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$a8a3e93435678ff9, {
                    level: 6,
                    children: title
                })
            }),
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("ul", {
                css: $24c02ea0e14dbe4f$var$$7af640a6c4cb35c7$export$2dc6a66a41038997,
                className: className,
                style: style,
                children: linksWithHref
            })
        ]
    });
};
var $24c02ea0e14dbe4f$var$$389dbaf1c04dd698$exports = {};
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$389dbaf1c04dd698$exports, "BadgeCard", ()=>$24c02ea0e14dbe4f$export$22da447a4012011);
const $24c02ea0e14dbe4f$export$22da447a4012011 = ({ image: image, badgeTitle: badgeTitle, earnedDate: earnedDate, link: link, onClick: onClick })=>{
    const clickHandler = (0, $5FkrB.useCallback)(()=>{
        if (onClick) onClick(link, "_self");
    }, [
        onClick,
        link
    ]);
    const handleKeyDown = $24c02ea0e14dbe4f$export$2a0b6757d41dacb2(clickHandler);
    return (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
        role: "button",
        css: $24c02ea0e14dbe4f$var$$389dbaf1c04dd698$var$containerStyles,
        tabIndex: 0,
        onClick: clickHandler,
        onKeyDown: handleKeyDown,
        "data-testid": "badge-card",
        children: [
            image && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$3e431a229df88919, {
                    ...image,
                    width: 64,
                    height: 64,
                    preventModal: true,
                    style: {
                        height: "64px",
                        objectFit: "contain"
                    }
                })
            }),
            (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                css: $24c02ea0e14dbe4f$var$$389dbaf1c04dd698$var$contentContainerStyles,
                children: [
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("p", {
                        css: $24c02ea0e14dbe4f$var$$389dbaf1c04dd698$var$badgeTitleStyles,
                        children: badgeTitle
                    }),
                    (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("p", {
                        css: $24c02ea0e14dbe4f$var$$389dbaf1c04dd698$var$earnedDateStyles,
                        children: [
                            "Earned: ",
                            earnedDate
                        ]
                    })
                ]
            })
        ]
    });
};
const $24c02ea0e14dbe4f$var$$389dbaf1c04dd698$var$containerStyles = (0, $74Zh5.css)({
    width: "100%",
    display: "flex",
    alignItems: "center",
    background: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.background.input"),
    border: `0 solid ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.border")}`,
    borderRadius: "4px",
    padding: "16px 12px",
    transition: "all 0.2s ease-in-out",
    boxShadow: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("elevation.shadow.raised"),
    "&:hover": {
        cursor: "pointer",
        boxShadow: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("elevation.shadow.overlay")
    }
});
const $24c02ea0e14dbe4f$var$$389dbaf1c04dd698$var$contentContainerStyles = (0, $74Zh5.css)({
    marginLeft: "16px"
});
const $24c02ea0e14dbe4f$var$$389dbaf1c04dd698$var$badgeTitleStyles = (0, $74Zh5.css)({
    paddingBottom: "4px",
    fontSize: "16px",
    fontFamily: "system-ui",
    fontWeight: 600,
    lineHeight: "20px",
    color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text"),
    wordBreak: "break-word",
    margin: 0
});
const $24c02ea0e14dbe4f$var$$389dbaf1c04dd698$var$earnedDateStyles = (0, $74Zh5.css)({
    fontSize: "14px",
    lineHeight: "20px",
    color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text.subtlest"),
    fontFamily: "system-ui",
    fontWeight: "normal",
    wordBreak: "break-word",
    margin: 0
});
var $24c02ea0e14dbe4f$var$$c18917e553fd2737$exports = {};
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$c18917e553fd2737$exports, "CertificateCard", ()=>$24c02ea0e14dbe4f$export$c572aa3e2aa38d2);
const $24c02ea0e14dbe4f$export$c572aa3e2aa38d2 = ({ image: image, backgroundColor: backgroundColor, title: title, link: link, onClick: onClick })=>{
    const clickHandler = (0, $5FkrB.useCallback)(()=>{
        if (onClick) onClick(link, "_self");
    }, [
        onClick,
        link
    ]);
    const handleKeyDown = $24c02ea0e14dbe4f$export$2a0b6757d41dacb2(clickHandler);
    return (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
        role: "button",
        tabIndex: 0,
        css: $24c02ea0e14dbe4f$var$$c18917e553fd2737$var$containerStyles,
        onClick: clickHandler,
        onKeyDown: handleKeyDown,
        "data-testid": "certificate-card",
        children: [
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                css: [
                    $24c02ea0e14dbe4f$var$$c18917e553fd2737$var$cardHeaderStyles,
                    (0, $74Zh5.css)({
                        backgroundColor: backgroundColor
                    })
                ],
                "data-testid": "certificate-card-background",
                children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                    css: $24c02ea0e14dbe4f$var$$c18917e553fd2737$var$imageContainerStyles,
                    children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$3e431a229df88919, {
                        ...image,
                        width: 112,
                        height: 112,
                        preventModal: true,
                        style: {
                            objectFit: "contain"
                        }
                    })
                })
            }),
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                css: $24c02ea0e14dbe4f$var$$c18917e553fd2737$var$cardTitleStyles,
                children: title
            })
        ]
    });
};
const $24c02ea0e14dbe4f$var$$c18917e553fd2737$var$containerStyles = (0, $74Zh5.css)({
    maxWidth: "280px",
    background: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.background.input"),
    borderRadius: "5px",
    boxShadow: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("elevation.shadow.raised"),
    transition: "box-shadow 0.2s ease",
    "&:hover": {
        cursor: "pointer",
        boxShadow: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("elevation.shadow.overlay")
    }
});
const $24c02ea0e14dbe4f$var$$c18917e553fd2737$var$cardHeaderStyles = (0, $74Zh5.css)({
    height: "66px",
    padding: "14px 16px 0",
    borderTopLeftRadius: "5px",
    borderTopRightRadius: "5px"
});
const $24c02ea0e14dbe4f$var$$c18917e553fd2737$var$imageContainerStyles = (0, $74Zh5.css)({
    height: "112px",
    width: "112px"
});
const $24c02ea0e14dbe4f$var$$c18917e553fd2737$var$cardTitleStyles = (0, $74Zh5.css)({
    padding: "0 16px 24px",
    marginTop: "76px",
    color: "N800",
    lineHeight: "20px",
    fontSize: "16px",
    fontFamily: "system-ui",
    fontWeight: 600,
    wordBreak: "break-word"
});
var $24c02ea0e14dbe4f$var$$3ca3d702a74367ba$exports = {};
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$3ca3d702a74367ba$exports, "ContentOverviewCardState", ()=>$24c02ea0e14dbe4f$export$84c408eab3fc01b3);
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$3ca3d702a74367ba$exports, "ContentOverviewCard", ()=>$24c02ea0e14dbe4f$export$cb86f63bb5e77777);
var $24c02ea0e14dbe4f$var$$ed20910b93d89c3f$exports = {};
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$ed20910b93d89c3f$exports, "ContentType", ()=>$24c02ea0e14dbe4f$export$e2e108cbe2e4f865);
let $24c02ea0e14dbe4f$export$e2e108cbe2e4f865;
(function(ContentType) {
    ContentType["LEARNING_PATH"] = "LEARNING_PATH";
    ContentType["COURSE"] = "COURSE";
    ContentType["LESSON"] = "LESSON";
})($24c02ea0e14dbe4f$export$e2e108cbe2e4f865 || ($24c02ea0e14dbe4f$export$e2e108cbe2e4f865 = {}));
let $24c02ea0e14dbe4f$export$84c408eab3fc01b3;
(function(ContentOverviewCardState) {
    ContentOverviewCardState["LOADING"] = "loading";
    ContentOverviewCardState["DEFAULT"] = "default";
    ContentOverviewCardState["IN_PROGRESS"] = "in_progress";
    ContentOverviewCardState["FINISHED"] = "finished";
})($24c02ea0e14dbe4f$export$84c408eab3fc01b3 || ($24c02ea0e14dbe4f$export$84c408eab3fc01b3 = {}));
const $24c02ea0e14dbe4f$export$cb86f63bb5e77777 = ({ inspectMode: inspectMode, state: state = $24c02ea0e14dbe4f$export$84c408eab3fc01b3.DEFAULT, heading: heading, subheading: subheading, tags: tags = [], collapsedSectionItems: itemsSectionCollapsed = [], collapsedSectionContent: infoSectionCollapsed = "", collapsedSectionTitle: titleSectionCollapsed, contentType: contentType, onClickButton: onClickButton, href: href })=>{
    const [isOpen, setIsOpen] = (0, $5FkrB.useState)(false);
    const handleClickButton = (0, $5FkrB.useCallback)((event)=>{
        if (onClickButton) {
            event?.preventDefault();
            onClickButton();
        }
    }, [
        onClickButton
    ]);
    const handleToggleVisibility = (0, $5FkrB.useCallback)(()=>{
        setIsOpen((prevIsOpen)=>!prevIsOpen);
    }, []);
    return (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("article", {
        "aria-label": heading,
        css: [
            $24c02ea0e14dbe4f$var$$3ca3d702a74367ba$var$articleContainerStyles,
            state === $24c02ea0e14dbe4f$export$84c408eab3fc01b3.FINISHED && (0, $74Zh5.css)({
                borderLeftColor: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.border.success")
            })
        ],
        children: [
            (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                css: $24c02ea0e14dbe4f$var$$3ca3d702a74367ba$var$containerStyles,
                children: [
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("button", {
                        "data-testid": "toggle-visibility",
                        "aria-label": isOpen ? "collapse" : "expand",
                        onClick: handleToggleVisibility,
                        css: $24c02ea0e14dbe4f$var$$3ca3d702a74367ba$var$buttonStyles,
                        children: isOpen ? (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("span", {
                            css: $24c02ea0e14dbe4f$var$$3ca3d702a74367ba$var$buttonIconSpanStyles,
                            children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$f04a61298a47a40f, {
                                type: "chevron-down"
                            })
                        }) : (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("span", {
                            css: $24c02ea0e14dbe4f$var$$3ca3d702a74367ba$var$buttonIconSpanStyles,
                            children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$f04a61298a47a40f, {
                                type: "chevron-right"
                            })
                        })
                    }),
                    (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                        css: $24c02ea0e14dbe4f$var$$3ca3d702a74367ba$var$gridContainerStyles,
                        children: [
                            (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                                css: $24c02ea0e14dbe4f$var$$3ca3d702a74367ba$var$gridItemStyles,
                                children: [
                                    tags.length > 0 && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                                        css: $24c02ea0e14dbe4f$var$$3ca3d702a74367ba$var$tagContainerStyles,
                                        children: tags?.map((tag, index)=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                                                css: $24c02ea0e14dbe4f$var$$3ca3d702a74367ba$var$tagStyles,
                                                children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$3288d34c523a1192, {
                                                    inspectMode: tag.inspectMode && {
                                                        tag: tag.inspectMode.duration
                                                    },
                                                    label: tag.label
                                                })
                                            }, `tag-${index}`))
                                    }),
                                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                                        ...$24c02ea0e14dbe4f$export$1784ac302bd8ebad("title", inspectMode),
                                        css: $24c02ea0e14dbe4f$var$$3ca3d702a74367ba$var$titleContainerStyles,
                                        children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$a8a3e93435678ff9, {
                                            level: 5,
                                            children: heading
                                        })
                                    }),
                                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("p", {
                                        ...$24c02ea0e14dbe4f$export$1784ac302bd8ebad("description", inspectMode),
                                        css: $24c02ea0e14dbe4f$var$$3ca3d702a74367ba$var$descriptionStyles,
                                        children: subheading
                                    })
                                ]
                            }),
                            (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                                css: $24c02ea0e14dbe4f$var$$3ca3d702a74367ba$var$gridSideItemStyles,
                                children: [
                                    state === $24c02ea0e14dbe4f$export$84c408eab3fc01b3.LOADING && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$353f5b6fc5456de1, {
                                        label: "",
                                        isLoading: true
                                    }),
                                    state === $24c02ea0e14dbe4f$export$84c408eab3fc01b3.DEFAULT && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$353f5b6fc5456de1, {
                                        label: "Get started",
                                        appearance: $24c02ea0e14dbe4f$export$261c9483fc4a455a.PRIMARY,
                                        onClick: handleClickButton,
                                        href: href,
                                        target: "_blank"
                                    }),
                                    state === $24c02ea0e14dbe4f$export$84c408eab3fc01b3.IN_PROGRESS && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$353f5b6fc5456de1, {
                                        label: "Continue",
                                        appearance: $24c02ea0e14dbe4f$export$261c9483fc4a455a.SECONDARY,
                                        onClick: handleClickButton,
                                        href: href,
                                        target: "_blank"
                                    }),
                                    state === $24c02ea0e14dbe4f$export$84c408eab3fc01b3.FINISHED && (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                                        css: $24c02ea0e14dbe4f$var$$3ca3d702a74367ba$var$finishedStateContainerStyles,
                                        children: [
                                            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                                                css: (0, $74Zh5.css)({
                                                    marginRight: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.100")
                                                }),
                                                children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$a6c7ac8248d6e38a, {
                                                    link: href || "#",
                                                    label: `Review ${$24c02ea0e14dbe4f$export$e2e108cbe2e4f865.COURSE === contentType ? "lesson" : "course"}`,
                                                    onClick: (event)=>handleClickButton(event),
                                                    target: "_blank"
                                                })
                                            }),
                                            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$f04a61298a47a40f, {
                                                type: "check-circle",
                                                color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.icon.success")
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                "data-testid": "section-expanded",
                css: [
                    $24c02ea0e14dbe4f$var$$3ca3d702a74367ba$var$sectionExpandedStyles,
                    (0, $74Zh5.css)({
                        display: isOpen ? "block" : "none"
                    })
                ],
                children: [
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                        css: $24c02ea0e14dbe4f$var$$3ca3d702a74367ba$var$sectionContentStyles,
                        children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$2e0a83ec2e27ecbb, {
                            color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.border"),
                            height: 1
                        })
                    }),
                    (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                        ...$24c02ea0e14dbe4f$export$1784ac302bd8ebad("sectionList", inspectMode),
                        css: $24c02ea0e14dbe4f$var$$3ca3d702a74367ba$var$sectionListStyles,
                        children: [
                            titleSectionCollapsed && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                                css: $24c02ea0e14dbe4f$var$$3ca3d702a74367ba$var$sectionTitleStyles,
                                children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$a8a3e93435678ff9, {
                                    level: 6,
                                    children: titleSectionCollapsed
                                })
                            }),
                            itemsSectionCollapsed.length > 0 && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("ul", {
                                css: $24c02ea0e14dbe4f$var$$3ca3d702a74367ba$var$listStyles,
                                "aria-label": "collapsed section items",
                                children: itemsSectionCollapsed?.map((item, index)=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("li", {
                                        css: $24c02ea0e14dbe4f$var$$3ca3d702a74367ba$var$itemStyles,
                                        children: item
                                    }, `item-${index}`))
                            }),
                            infoSectionCollapsed && infoSectionCollapsed
                        ]
                    })
                ]
            })
        ]
    });
};
const $24c02ea0e14dbe4f$var$$3ca3d702a74367ba$var$articleContainerStyles = (0, $74Zh5.css)({
    backgroundColor: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.background.input"),
    borderLeft: `8px solid ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.border.brand")}`,
    borderRadius: "8px",
    padding: "16px 24px",
    boxShadow: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("elevation.shadow.raised")
});
const $24c02ea0e14dbe4f$var$$3ca3d702a74367ba$var$containerStyles = (0, $74Zh5.css)({
    padding: "16px 0",
    display: "flex",
    alignItems: "flex-start"
});
const $24c02ea0e14dbe4f$var$$3ca3d702a74367ba$var$buttonStyles = (0, $74Zh5.css)({
    padding: 0,
    border: "none",
    backgroundColor: "transparent",
    cursor: "pointer"
});
const $24c02ea0e14dbe4f$var$$3ca3d702a74367ba$var$buttonIconSpanStyles = (0, $74Zh5.css)({
    marginRight: "16px"
});
const $24c02ea0e14dbe4f$var$$3ca3d702a74367ba$var$gridContainerStyles = (0, $74Zh5.css)({
    flex: 1,
    display: "grid",
    gridTemplateColumns: "repeat(12, minmax(0, 1fr))",
    [(0, $cb8cedbc477f5a81$export$987d49ffe1b0900f).above.sm]: {
        columnGap: "16px",
        alignItems: "center"
    }
});
const $24c02ea0e14dbe4f$var$$3ca3d702a74367ba$var$gridItemStyles = (0, $74Zh5.css)({
    gridColumn: "span 12",
    color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text"),
    [(0, $cb8cedbc477f5a81$export$987d49ffe1b0900f).above.sm]: {
        gridColumn: "span 9",
        color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text")
    }
});
const $24c02ea0e14dbe4f$var$$3ca3d702a74367ba$var$tagContainerStyles = (0, $74Zh5.css)({
    display: "flex",
    flexWrap: "wrap"
});
const $24c02ea0e14dbe4f$var$$3ca3d702a74367ba$var$tagStyles = (0, $74Zh5.css)({
    marginRight: "12px",
    "&:last-of-type": {
        marginRight: 0
    }
});
const $24c02ea0e14dbe4f$var$$3ca3d702a74367ba$var$titleContainerStyles = (0, $74Zh5.css)({
    margin: "16px auto",
    [(0, $cb8cedbc477f5a81$export$987d49ffe1b0900f).above.sm]: {
        marginRight: "1px"
    }
});
const $24c02ea0e14dbe4f$var$$3ca3d702a74367ba$var$descriptionStyles = (0, $74Zh5.css)({
    display: "none",
    fontSize: "16px",
    margin: 0,
    color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text"),
    fontFamily: "Inter, sans-serif",
    [(0, $cb8cedbc477f5a81$export$987d49ffe1b0900f).above.sm]: {
        overflow: "hidden",
        textOverflow: "ellipsis",
        width: "100%",
        display: "-webkit-box",
        WebkitLineClamp: 2,
        WebkitBoxOrient: "vertical",
        lineHeight: "1.5",
        color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text")
    }
});
const $24c02ea0e14dbe4f$var$$3ca3d702a74367ba$var$gridSideItemStyles = (0, $74Zh5.css)({
    gridColumn: "span 12",
    [(0, $cb8cedbc477f5a81$export$987d49ffe1b0900f).above.sm]: {
        gridColumn: "span 3",
        justifySelf: "end"
    }
});
const $24c02ea0e14dbe4f$var$$3ca3d702a74367ba$var$finishedStateContainerStyles = (0, $74Zh5.css)({
    display: "flex",
    marginRight: "4px"
});
const $24c02ea0e14dbe4f$var$$3ca3d702a74367ba$var$sectionExpandedStyles = (0, $74Zh5.css)({
    overflow: "hidden",
    transition: "ease-in-out 1000ms",
    paddingLeft: "40px"
});
const $24c02ea0e14dbe4f$var$$3ca3d702a74367ba$var$sectionContentStyles = (0, $74Zh5.css)({
    margin: "8px 0"
});
const $24c02ea0e14dbe4f$var$$3ca3d702a74367ba$var$sectionListStyles = (0, $74Zh5.css)({
    padding: "24px 0"
});
const $24c02ea0e14dbe4f$var$$3ca3d702a74367ba$var$sectionTitleStyles = (0, $74Zh5.css)({
    marginBottom: "8px",
    textTransform: "uppercase"
});
const $24c02ea0e14dbe4f$var$$3ca3d702a74367ba$var$listStyles = (0, $74Zh5.css)({
    color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text"),
    fontSize: "14px",
    lineHeight: "20px",
    listStyleType: "disc",
    listStylePosition: "inside",
    paddingLeft: "4px",
    marginTop: 0,
    fontFamily: "Inter, sans-serif",
    [(0, $cb8cedbc477f5a81$export$987d49ffe1b0900f).above.sm]: {
        fontSize: "16px",
        lineHeight: "1.714"
    }
});
const $24c02ea0e14dbe4f$var$$3ca3d702a74367ba$var$itemStyles = (0, $74Zh5.css)({
    marginTop: 0,
    marginLeft: "20px",
    textIndent: "-20px"
});
var $24c02ea0e14dbe4f$var$$e018ab7ed2648ae8$exports = {};
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$e018ab7ed2648ae8$exports, "EmptyState", ()=>$24c02ea0e14dbe4f$export$fddf379e22a74b00);
const $24c02ea0e14dbe4f$export$fddf379e22a74b00 = ({ image: image, description: description, redirectLink: redirectLink })=>(0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
        css: $24c02ea0e14dbe4f$var$$e018ab7ed2648ae8$var$containerStyles,
        "data-testid": "empty-state",
        children: [
            image && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                css: $24c02ea0e14dbe4f$var$$e018ab7ed2648ae8$var$imageContainerStyles,
                children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$3e431a229df88919, {
                    src: image.src,
                    alt: image.alt,
                    preventModal: true,
                    height: 96
                })
            }),
            (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                css: $24c02ea0e14dbe4f$var$$e018ab7ed2648ae8$var$descriptionContainerStyles,
                children: [
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("p", {
                        css: $24c02ea0e14dbe4f$var$$e018ab7ed2648ae8$var$descriptionStyles,
                        tabIndex: 0,
                        children: description
                    }),
                    redirectLink && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$a6c7ac8248d6e38a, {
                        label: redirectLink.label,
                        link: redirectLink.link,
                        style: $24c02ea0e14dbe4f$export$2b77966d73aefa77.SEMIBOLD,
                        fontColor: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.link"),
                        css: (0, $74Zh5.css)({
                            fontFamily: "system-ui"
                        })
                    })
                ]
            })
        ]
    });
const $24c02ea0e14dbe4f$var$$e018ab7ed2648ae8$var$containerStyles = (0, $74Zh5.css)({
    width: "100%",
    display: "flex",
    padding: "24px",
    border: "1px dashed",
    borderColor: (0, $54ca2d3948378259$export$5f71e19f3a7ad9de),
    borderRadius: "4px",
    alignItems: "center"
});
const $24c02ea0e14dbe4f$var$$e018ab7ed2648ae8$var$imageContainerStyles = (0, $74Zh5.css)({
    width: "64px",
    [(0, $cb8cedbc477f5a81$export$987d49ffe1b0900f).above.sm]: {
        width: "96px"
    }
});
const $24c02ea0e14dbe4f$var$$e018ab7ed2648ae8$var$descriptionContainerStyles = (0, $74Zh5.css)({
    marginLeft: "16px",
    lineHeight: "23px"
});
const $24c02ea0e14dbe4f$var$$e018ab7ed2648ae8$var$descriptionStyles = (0, $74Zh5.css)({
    paddingBottom: "2px",
    margin: 0,
    fontFamily: "system-ui",
    fontSize: "16px",
    color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text"),
    fontWeight: "normal",
    wordBreak: "break-word",
    lineHeight: 1.714
});
var $24c02ea0e14dbe4f$var$$81dd635d83decaee$exports = {};
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$81dd635d83decaee$exports, "InlineFeedbackMessageAppearance", ()=>$24c02ea0e14dbe4f$export$f9292ef28b7b429a);
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$81dd635d83decaee$exports, "InlineFeedbackMessage", ()=>$24c02ea0e14dbe4f$export$f23c56ac9ab316f);
let $24c02ea0e14dbe4f$export$f9292ef28b7b429a;
(function(InlineFeedbackMessageAppearance) {
    InlineFeedbackMessageAppearance["INCORRECT"] = "INCORRECT";
    InlineFeedbackMessageAppearance["CORRECT"] = "CORRECT";
})($24c02ea0e14dbe4f$export$f9292ef28b7b429a || ($24c02ea0e14dbe4f$export$f9292ef28b7b429a = {}));
const $24c02ea0e14dbe4f$export$f23c56ac9ab316f = ({ title: title, description: description, appearance: appearance = $24c02ea0e14dbe4f$export$f9292ef28b7b429a.CORRECT })=>{
    const isIncorrectAppearance = appearance === $24c02ea0e14dbe4f$export$f9292ef28b7b429a.INCORRECT;
    return (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
        css: $24c02ea0e14dbe4f$var$$81dd635d83decaee$var$feedbackMessageContainerStyles,
        children: [
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                css: [
                    $24c02ea0e14dbe4f$var$$81dd635d83decaee$var$feedbackMessageLeftBorderStyles,
                    (0, $74Zh5.css)({
                        backgroundColor: `${isIncorrectAppearance ? (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.border.danger") : (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.border.success")}`
                    })
                ]
            }),
            (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                "data-testid": `feedback-message-${appearance}`,
                css: $24c02ea0e14dbe4f$var$$81dd635d83decaee$var$feedbackMessageContentContainerStyles,
                children: [
                    isIncorrectAppearance ? (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$f04a61298a47a40f, {
                        type: "error",
                        color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.border.danger")
                    }) : (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$f04a61298a47a40f, {
                        type: "check-circle",
                        color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.border.success")
                    }),
                    (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                        css: $24c02ea0e14dbe4f$var$$81dd635d83decaee$var$feedbackMessageContentStyles,
                        children: [
                            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("p", {
                                css: $24c02ea0e14dbe4f$var$$81dd635d83decaee$var$feedbackMessageTitleStyles,
                                children: title
                            }),
                            description && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("p", {
                                css: $24c02ea0e14dbe4f$var$$81dd635d83decaee$var$feedbackMessageDescriptionStyles,
                                children: description
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
const $24c02ea0e14dbe4f$var$$81dd635d83decaee$var$feedbackMessageContainerStyles = (0, $74Zh5.css)({
    width: "100%",
    display: "flex",
    backgroundColor: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.background.input")
});
const $24c02ea0e14dbe4f$var$$81dd635d83decaee$var$feedbackMessageContentContainerStyles = (0, $74Zh5.css)({
    width: "100%",
    padding: "24px 24px 24px 16px",
    display: "flex",
    border: `1px solid ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.border")}`,
    borderRadius: "0 3px 3px 0",
    borderLeft: "none",
    [(0, $cb8cedbc477f5a81$export$987d49ffe1b0900f).below.xs]: {
        padding: "16px 16px 16px 8px"
    }
});
const $24c02ea0e14dbe4f$var$$81dd635d83decaee$var$feedbackMessageLeftBorderStyles = (0, $74Zh5.css)({
    maxHeight: "100%",
    width: "8px",
    borderRadius: "3px 0 0 3px"
});
const $24c02ea0e14dbe4f$var$$81dd635d83decaee$var$feedbackMessageContentStyles = (0, $74Zh5.css)({
    width: "100%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    marginLeft: "16px",
    [(0, $cb8cedbc477f5a81$export$987d49ffe1b0900f).below.xs]: {
        marginLeft: "8px"
    }
});
const $24c02ea0e14dbe4f$var$$81dd635d83decaee$var$feedbackMessageTitleStyles = (0, $74Zh5.css)({
    fontFamily: "Charlie Display, sans-serif",
    fontWeight: 600,
    fontSize: "20px",
    lineHeight: "24px",
    color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text"),
    margin: 0,
    [(0, $cb8cedbc477f5a81$export$987d49ffe1b0900f).below.xs]: {
        fontSize: "16px"
    }
});
const $24c02ea0e14dbe4f$var$$81dd635d83decaee$var$feedbackMessageDescriptionStyles = (0, $74Zh5.css)({
    marginTop: "16px",
    fontFamily: "Inter, sans-serif",
    fontSize: "20px",
    lineHeight: "32px",
    color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text"),
    marginBottom: 0,
    p: {
        margin: 0
    },
    [(0, $cb8cedbc477f5a81$export$987d49ffe1b0900f).below.xs]: {
        marginTop: "8px",
        fontSize: "16px",
        lineHeight: "24px"
    }
});
var $24c02ea0e14dbe4f$var$$8d99d7c025746ac9$exports = {};
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$8d99d7c025746ac9$exports, "LearningContentCard", ()=>$24c02ea0e14dbe4f$export$c01be50dd5c433fe);
const $24c02ea0e14dbe4f$var$$94fa590b0c9d9421$export$64ef9b8c11710c47 = ({ title: title, description: description, isLearningProgress: isLearningProgress, inspectMode: inspectMode, disableDescriptionClamp: disableDescriptionClamp })=>(0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
        "data-testid": "card-content",
        css: $24c02ea0e14dbe4f$var$$94fa590b0c9d9421$var$titleAndDetailsContainerStyles,
        children: [
            isLearningProgress ? (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("h4", {
                ...$24c02ea0e14dbe4f$export$1784ac302bd8ebad("title", inspectMode),
                css: $24c02ea0e14dbe4f$var$$94fa590b0c9d9421$var$withProgressTitleStyles,
                children: title
            }) : (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("h5", {
                ...$24c02ea0e14dbe4f$export$1784ac302bd8ebad("title", inspectMode),
                css: $24c02ea0e14dbe4f$var$$94fa590b0c9d9421$var$catalogTitleStyles,
                children: title
            }),
            description && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("p", {
                "data-testid": "description",
                ...$24c02ea0e14dbe4f$export$1784ac302bd8ebad("description", inspectMode),
                css: [
                    $24c02ea0e14dbe4f$var$$94fa590b0c9d9421$var$descriptionStyles,
                    disableDescriptionClamp && $24c02ea0e14dbe4f$var$$94fa590b0c9d9421$var$descriptionNoClampStyles
                ],
                children: description
            })
        ]
    });
const $24c02ea0e14dbe4f$var$$94fa590b0c9d9421$var$titleAndDetailsContainerStyles = (0, $74Zh5.css)({
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    padding: `0 ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.300")} ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.300")}`,
    marginBottom: "-2px"
});
const $24c02ea0e14dbe4f$var$$94fa590b0c9d9421$var$baseTitleStyles = (0, $74Zh5.css)({
    display: "-webkit-box",
    WebkitLineClamp: 3,
    WebkitBoxOrient: "vertical",
    overflow: "hidden",
    marginBottom: 0,
    fontFamily: "Charlie Display, sans-serif",
    color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text")
});
const $24c02ea0e14dbe4f$var$$94fa590b0c9d9421$var$learningProgressTitleStyles = (0, $74Zh5.css)({
    display: "-webkit-box",
    WebkitLineClamp: 2,
    WebkitBoxOrient: "vertical",
    overflow: "hidden",
    marginTop: "20px !important",
    marginBottom: 0,
    fontFamily: "Charlie Display, sans-serif",
    fontSize: "24px",
    fontWeight: 600,
    lineHeight: "32px",
    color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text"),
    height: "64px"
});
const $24c02ea0e14dbe4f$var$$94fa590b0c9d9421$var$withProgressTitleStyles = (0, $74Zh5.css)([
    $24c02ea0e14dbe4f$var$$94fa590b0c9d9421$var$learningProgressTitleStyles,
    {
        fontSize: "24px",
        lineHeight: "32px",
        marginTop: "0 !important"
    }
]);
const $24c02ea0e14dbe4f$var$$94fa590b0c9d9421$var$catalogTitleStyles = (0, $74Zh5.css)([
    $24c02ea0e14dbe4f$var$$94fa590b0c9d9421$var$baseTitleStyles,
    {
        fontSize: "20px",
        lineHeight: "28px",
        marginTop: `${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.150")} !important`
    }
]);
const $24c02ea0e14dbe4f$var$$94fa590b0c9d9421$var$descriptionStyles = (0, $74Zh5.css)({
    display: "-webkit-box",
    WebkitBoxOrient: "vertical",
    WebkitLineClamp: 2,
    overflow: "hidden",
    marginTop: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.250"),
    marginBottom: 0,
    fontFamily: "Inter, sans-serif",
    fontSize: "16px",
    fontWeight: 400,
    lineHeight: "24px",
    color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text.subtle")
});
const $24c02ea0e14dbe4f$var$$94fa590b0c9d9421$var$descriptionNoClampStyles = (0, $74Zh5.css)({
    display: "block",
    WebkitLineClamp: "none",
    overflow: "visible"
});
const $24c02ea0e14dbe4f$var$$f73a4551a9d8a3b1$export$8a8c015277a3d77a = ({ imageUrl: imageUrl, backgroundColor: backgroundColor, productIcon: productIcon, isLearningProgress: isLearningProgress, imageHeight: imageHeight })=>{
    let height = isLearningProgress ? "96px" : "80px";
    if (imageHeight) height = `${imageHeight}px`;
    const backgroundSize = imageHeight ? "contain" : "cover";
    const backgroundPosition = imageHeight ? "center" : undefined; // if imageHeight is provided, the image will be displayed at the center of the container
    return (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
        css: [
            $24c02ea0e14dbe4f$var$$f73a4551a9d8a3b1$var$imageBaseStyles,
            !imageUrl && $24c02ea0e14dbe4f$var$$f73a4551a9d8a3b1$var$noImageStyles,
            (0, $74Zh5.css)({
                backgroundColor: backgroundColor,
                height: height,
                backgroundSize: backgroundSize,
                ...backgroundPosition && {
                    backgroundPosition: backgroundPosition
                }
            })
        ],
        style: {
            backgroundImage: `url(${imageUrl})`
        },
        "data-testid": "card-image",
        children: productIcon && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("img", {
            css: (0, $74Zh5.css)({
                marginLeft: "26px"
            }),
            src: productIcon,
            alt: "product icon"
        })
    });
};
const $24c02ea0e14dbe4f$var$$f73a4551a9d8a3b1$var$imageBaseStyles = (0, $74Zh5.css)({
    width: "100%",
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    borderRadius: "7px 7px 0 0",
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "center"
});
const $24c02ea0e14dbe4f$var$$f73a4551a9d8a3b1$var$noImageStyles = (0, $74Zh5.css)({
    background: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.background.accent.gray.subtlest")
});
const $24c02ea0e14dbe4f$var$$70542fe329d53412$export$ce572121d239fe86 = 4;
const $24c02ea0e14dbe4f$var$$70542fe329d53412$export$3b38c99bd0870716 = 290;
const $24c02ea0e14dbe4f$var$$70542fe329d53412$export$bb4069a5b1582edc = 24;
const $24c02ea0e14dbe4f$var$$70542fe329d53412$export$9c6eb1f46b993412 = 3;
const $24c02ea0e14dbe4f$var$$fb345954107134f9$export$331084b24da1eef5 = ({ tags: tags, lastLabelWidth: lastLabelWidth })=>tags.length > 0 && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
        css: $24c02ea0e14dbe4f$var$$fb345954107134f9$var$labelContainerStyles,
        id: "tabs-container",
        children: tags.slice(0, $24c02ea0e14dbe4f$var$$70542fe329d53412$export$9c6eb1f46b993412).map((tag, index, arr)=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                css: index === arr.length - 1 && (0, $74Zh5.css)([
                    {
                        "& > div": {
                            width: lastLabelWidth
                        }
                    },
                    $24c02ea0e14dbe4f$var$$fb345954107134f9$var$truncatedLabelStyles
                ]),
                children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$3288d34c523a1192, {
                    ...tag
                })
            }, tag.label + index))
    });
const $24c02ea0e14dbe4f$var$$fb345954107134f9$var$labelContainerStyles = (0, $74Zh5.css)({
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    gap: `${$24c02ea0e14dbe4f$var$$70542fe329d53412$export$ce572121d239fe86}px`,
    padding: `0 ${$24c02ea0e14dbe4f$var$$70542fe329d53412$export$bb4069a5b1582edc}px`,
    overflow: "hidden"
});
const $24c02ea0e14dbe4f$var$$fb345954107134f9$var$truncatedLabelStyles = (0, $74Zh5.css)({
    "& > div": {
        overflow: "hidden",
        textOverflow: "ellipsis",
        display: "block"
    }
});
var $24c02ea0e14dbe4f$var$$d8ee29df49af8811$exports = {};
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$d8ee29df49af8811$exports, "LearningProgressBar", ()=>$24c02ea0e14dbe4f$export$184a993f673fc83f);
const $24c02ea0e14dbe4f$export$184a993f673fc83f = ({ wasPreviouslyCompleted: wasPreviouslyCompleted = false, completedResources: completedResources, resourceCount: resourceCount, completionDate: completionDate, contentType: contentType })=>{
    const getProgressText = ()=>{
        switch(contentType){
            case $24c02ea0e14dbe4f$export$e2e108cbe2e4f865.COURSE:
                return `${completedResources} of ${resourceCount} lessons`;
            case $24c02ea0e14dbe4f$export$e2e108cbe2e4f865.LEARNING_PATH:
                return `${completedResources} of ${resourceCount} courses`;
            default:
                return `${Math.round($24c02ea0e14dbe4f$export$6e67b290ed5690f6(completedResources, resourceCount))}%`;
        }
    };
    if (completedResources === resourceCount || wasPreviouslyCompleted) return (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
        "data-testid": "learning-progress-bar-container",
        css: $24c02ea0e14dbe4f$var$$d8ee29df49af8811$var$progressBarContainerStyles,
        children: [
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                css: $24c02ea0e14dbe4f$var$$d8ee29df49af8811$var$progressBarStyles,
                children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$f04a61298a47a40f, {
                    type: "gap-completed"
                })
            }),
            (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("p", {
                css: [
                    $24c02ea0e14dbe4f$var$$d8ee29df49af8811$var$progressTitleStyles,
                    (0, $74Zh5.css)({
                        color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text.success")
                    })
                ],
                children: [
                    "Completed ",
                    completionDate
                ]
            })
        ]
    });
    return (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
        "data-testid": "learning-progress-bar-container",
        css: $24c02ea0e14dbe4f$var$$d8ee29df49af8811$var$progressBarContainerStyles,
        children: [
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                css: $24c02ea0e14dbe4f$var$$d8ee29df49af8811$var$progressBarStyles,
                children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $f188eff9b59fb855$export$5ab97151efedb8c6), {
                    strokeWidth: 10,
                    value: $24c02ea0e14dbe4f$export$6e67b290ed5690f6(completedResources, resourceCount),
                    styles: (0, $f188eff9b59fb855$export$5115a192ad9bf57f)({
                        pathColor: completedResources === 0 ? (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.border") : (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text.success")
                    })
                })
            }),
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("p", {
                css: $24c02ea0e14dbe4f$var$$d8ee29df49af8811$var$progressTitleStyles,
                children: getProgressText()
            })
        ]
    });
};
const $24c02ea0e14dbe4f$var$$d8ee29df49af8811$var$progressBarContainerStyles = (0, $74Zh5.css)({
    display: "flex",
    alignItems: "center",
    gap: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.100")
});
const $24c02ea0e14dbe4f$var$$d8ee29df49af8811$var$progressBarStyles = (0, $74Zh5.css)({
    display: "flex",
    maxWidth: "20px",
    width: "100%"
});
const $24c02ea0e14dbe4f$var$$d8ee29df49af8811$var$progressTitleStyles = (0, $74Zh5.css)({
    marginTop: 0,
    fontSize: "14px",
    fontWeight: 400,
    lineHeight: "20px",
    fontFamily: "Inter, sans-serif",
    color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text.subtle")
});
let $24c02ea0e14dbe4f$var$$035f8a623e403361$export$23d03d0b3065d061;
(function(LearningProgressStatus) {
    LearningProgressStatus["NOT_STARTED"] = "NOT_STARTED";
    LearningProgressStatus["IN_PROGRESS"] = "IN_PROGRESS";
    LearningProgressStatus["COMPLETED"] = "COMPLETED";
})($24c02ea0e14dbe4f$var$$035f8a623e403361$export$23d03d0b3065d061 || ($24c02ea0e14dbe4f$var$$035f8a623e403361$export$23d03d0b3065d061 = {}));
let $24c02ea0e14dbe4f$var$$035f8a623e403361$export$490c7ce941281ba8;
(function(CardStatus) {
    CardStatus["COMPLETED"] = "completed";
    CardStatus["DEFAULT"] = "default";
})($24c02ea0e14dbe4f$var$$035f8a623e403361$export$490c7ce941281ba8 || ($24c02ea0e14dbe4f$var$$035f8a623e403361$export$490c7ce941281ba8 = {}));
const $24c02ea0e14dbe4f$var$$035f8a623e403361$export$780035d9fe48eb32 = 420;
var $24c02ea0e14dbe4f$var$$ec9b8ebbd21bd316$exports = {};
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$ec9b8ebbd21bd316$exports, "ShowMore", ()=>$24c02ea0e14dbe4f$export$ca7697601dcd7803);
const $24c02ea0e14dbe4f$export$ca7697601dcd7803 = ({ cardRef: cardRef, shareOnPdf: shareOnPdf, onGeneratePdf: onGeneratePdf, areHistoricalNotifications: areHistoricalNotifications, onViewUpdates: onViewUpdates, alignToRight: alignToRight })=>{
    const [isOpen, setIsOpen] = (0, $5FkrB.useState)(false);
    const dropdownRef = (0, $5FkrB.useRef)(null);
    const handleButtonClick = (event)=>{
        event.stopPropagation();
        event.preventDefault();
        setIsOpen(!isOpen);
    };
    const handleOnGeneratePDF = (event)=>{
        if (onGeneratePdf) {
            event.stopPropagation();
            event.preventDefault();
            onGeneratePdf();
            setIsOpen(!isOpen);
        }
    };
    const handleOnViewUpdates = (event)=>{
        if (onViewUpdates) {
            event.stopPropagation();
            event.preventDefault();
            onViewUpdates();
            setIsOpen(!isOpen);
        }
    };
    const handleGeneratePdf = (0, $5FkrB.useCallback)(()=>{
        if (onGeneratePdf) onGeneratePdf();
    }, [
        onGeneratePdf
    ]);
    const handleViewUpdates = (0, $5FkrB.useCallback)(()=>{
        if (onViewUpdates) onViewUpdates();
    }, [
        onViewUpdates
    ]);
    const onKeyDownGeneratePdf = $24c02ea0e14dbe4f$export$2a0b6757d41dacb2(handleGeneratePdf);
    const onKeyDownViewUpdates = $24c02ea0e14dbe4f$export$2a0b6757d41dacb2(handleViewUpdates);
    (0, $5FkrB.useEffect)(()=>{
        const handleClickOutside = (event)=>{
            const isClickOnThisCard = (cardRef?.current || dropdownRef.current)?.contains(event.target);
            if (!isClickOnThisCard) setIsOpen(false);
        };
        if (isOpen) document.addEventListener("mousedown", handleClickOutside);
        return ()=>{
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [
        isOpen,
        cardRef
    ]);
    return (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
        css: (0, $74Zh5.css)({
            width: "fit-content",
            position: "relative"
        }),
        "data-testid": "show-more",
        ref: dropdownRef,
        children: [
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$353f5b6fc5456de1, {
                label: "",
                appearance: $24c02ea0e14dbe4f$export$261c9483fc4a455a.ICON,
                onClick: handleButtonClick,
                selected: isOpen,
                iconBefore: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$f04a61298a47a40f, {
                    type: "more-vertical"
                }),
                iconType: "more-vertical"
            }),
            isOpen && (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                "data-testid": "show-more-dropdown",
                css: [
                    $24c02ea0e14dbe4f$var$$ec9b8ebbd21bd316$var$showMoreDropdownStyles,
                    alignToRight && (0, $74Zh5.css)({
                        right: "unset",
                        textAlign: "left"
                    })
                ],
                children: [
                    shareOnPdf && onGeneratePdf && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                        role: "button",
                        tabIndex: 0,
                        css: $24c02ea0e14dbe4f$var$$ec9b8ebbd21bd316$var$optionStyles,
                        onClick: handleOnGeneratePDF,
                        onKeyDown: onKeyDownGeneratePdf,
                        children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("span", {
                            css: $24c02ea0e14dbe4f$var$$ec9b8ebbd21bd316$var$optionTextStyles,
                            children: "Export to PDF"
                        })
                    }),
                    areHistoricalNotifications && onViewUpdates && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                        role: "button",
                        tabIndex: 0,
                        css: $24c02ea0e14dbe4f$var$$ec9b8ebbd21bd316$var$optionStyles,
                        onClick: handleOnViewUpdates,
                        onKeyDown: onKeyDownViewUpdates,
                        children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("span", {
                            css: $24c02ea0e14dbe4f$var$$ec9b8ebbd21bd316$var$optionTextStyles,
                            children: "View updates"
                        })
                    })
                ]
            })
        ]
    });
};
const $24c02ea0e14dbe4f$var$$ec9b8ebbd21bd316$var$showMoreDropdownStyles = (0, $74Zh5.css)({
    position: "absolute",
    right: 0,
    display: "flex",
    flexDirection: "column",
    border: `1px solid ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.border")}`,
    borderRadius: "4px",
    padding: "7px 0",
    marginTop: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.050"),
    zIndex: 2,
    color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text"),
    backgroundColor: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.background.input"),
    boxShadow: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("elevation.shadow.overlay")
});
const $24c02ea0e14dbe4f$var$$ec9b8ebbd21bd316$var$optionStyles = (0, $74Zh5.css)({
    width: "220px",
    padding: "7px 24px",
    transition: "background",
    transitionDuration: "300ms",
    transitionTimingFunction: "cubic-bezier(0, 0, 0.2, 1)",
    backgroundColor: "transparent",
    boxSizing: "border-box",
    cursor: "pointer",
    ":hover": {
        backgroundColor: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.background.neutral.subtle.hovered")
    }
});
const $24c02ea0e14dbe4f$var$$ec9b8ebbd21bd316$var$optionTextStyles = (0, $74Zh5.css)({
    fontSize: "16px",
    lineHeight: "20px",
    fontFamily: "Inter, sans-serif",
    fontWeight: "400"
});
const $24c02ea0e14dbe4f$export$c01be50dd5c433fe = ({ inspectMode: inspectMode, title: title, description: description, onClick: onClick, target: target, link: link, tags: tags, disableDescriptionClamp: disableDescriptionClamp, minHeight: minHeight = 248, isLoading: isLoading = false, learningProgress: learningProgress, onGeneratePdf: onGeneratePdf, shouldDisplayShowMoreButton: shouldDisplayShowMoreButton, shouldDisplayBookmark: shouldDisplayBookmark, isUpdated: isUpdated, areHistoricalNotifications: areHistoricalNotifications, onViewUpdates: onViewUpdates, onUpdatedButtonClick: onUpdatedButtonClick, productIcon: productIcon, imageUrl: imageUrl, imageHeight: imageHeight, backgroundColor: backgroundColor })=>{
    const cardRef = (0, $5FkrB.useRef)(null);
    const [lastLabelWidth, setLastLabelWidth] = (0, $5FkrB.useState)("auto");
    const clickHandler = (0, $5FkrB.useCallback)(()=>{
        onClick && onClick();
    }, [
        onClick
    ]);
    const handleKeyDown = $24c02ea0e14dbe4f$export$2a0b6757d41dacb2(clickHandler);
    const handleOnSave = (event)=>{
        if (learningProgress) {
            event.stopPropagation();
            event.preventDefault();
            learningProgress.onSave(!learningProgress.isSaved);
        }
    };
    const handleUpdatedButtonClick = (0, $5FkrB.useCallback)((event)=>{
        event.stopPropagation();
        event.preventDefault();
        onUpdatedButtonClick && onUpdatedButtonClick();
    }, [
        onUpdatedButtonClick
    ]);
    (0, $5FkrB.useEffect)(()=>{
        // truncating the last label if it doesn't fit in the card
        if (tags.length && cardRef.current) {
            const card = cardRef.current;
            const tagsContainer = card.querySelector("#tabs-container");
            const maxTagsContainerWidth = (card?.offsetWidth || $24c02ea0e14dbe4f$var$$70542fe329d53412$export$3b38c99bd0870716) - $24c02ea0e14dbe4f$var$$70542fe329d53412$export$bb4069a5b1582edc * 2;
            let firstTagsWidth = 0;
            let totalTagsWidth = 0;
            if (tagsContainer) {
                Array.from(tagsContainer.children).slice(0, $24c02ea0e14dbe4f$var$$70542fe329d53412$export$9c6eb1f46b993412).forEach((tag, i, arr)=>{
                    if (i < arr.length - 1) firstTagsWidth += tag.clientWidth + $24c02ea0e14dbe4f$var$$70542fe329d53412$export$ce572121d239fe86;
                    totalTagsWidth += tag.clientWidth;
                });
                const shouldTruncate = totalTagsWidth + ($24c02ea0e14dbe4f$var$$70542fe329d53412$export$ce572121d239fe86 * tagsContainer.children.length - 1) + $24c02ea0e14dbe4f$var$$70542fe329d53412$export$bb4069a5b1582edc * 2 > card?.offsetWidth;
                if (shouldTruncate) setLastLabelWidth(maxTagsContainerWidth - firstTagsWidth - 2);
            }
        }
    }, [
        cardRef.current
    ]);
    /* eslint-enable react-hooks/exhaustive-deps */ if (isLoading) return (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
        css: [
            $24c02ea0e14dbe4f$var$$8d99d7c025746ac9$var$learningContentCardContainerStyles,
            $24c02ea0e14dbe4f$var$$8d99d7c025746ac9$var$loadingLearningContentCardContainerStyles
        ],
        "data-testid": "loading-learning-content-card",
        style: {
            minHeight: `${minHeight}px`
        },
        children: [
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                css: [
                    $24c02ea0e14dbe4f$var$$8d99d7c025746ac9$var$imageBaseStyles,
                    $24c02ea0e14dbe4f$var$$8d99d7c025746ac9$var$noImageStyles
                ]
            }),
            (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                css: $24c02ea0e14dbe4f$var$$8d99d7c025746ac9$var$bodyContainerStyles,
                children: [
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                        css: $24c02ea0e14dbe4f$var$$8d99d7c025746ac9$var$labelContainerStyles,
                        children: (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                            children: [
                                (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                                    css: $24c02ea0e14dbe4f$var$$8d99d7c025746ac9$var$smallPillStyles
                                }),
                                (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                                    css: [
                                        $24c02ea0e14dbe4f$var$$8d99d7c025746ac9$var$smallPillStyles,
                                        (0, $74Zh5.css)({
                                            marginLeft: "24px"
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                        css: $24c02ea0e14dbe4f$var$$8d99d7c025746ac9$var$titleAndDetailsContainerStyles,
                        children: (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                            css: (0, $74Zh5.css)({
                                marginTop: "12px"
                            }),
                            children: [
                                (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                                    css: [
                                        $24c02ea0e14dbe4f$var$$8d99d7c025746ac9$var$bigPillStyles,
                                        (0, $74Zh5.css)({
                                            width: "212px"
                                        })
                                    ]
                                }),
                                (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                                    css: $24c02ea0e14dbe4f$var$$8d99d7c025746ac9$var$bigPillStyles
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
    return (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("a", {
        href: link,
        target: target,
        rel: "noopener noreferrer",
        css: $24c02ea0e14dbe4f$var$$8d99d7c025746ac9$var$linkContainerStyles,
        onClick: (e)=>e.preventDefault(),
        tabIndex: -1,
        children: (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
            ref: cardRef,
            role: "link",
            css: $24c02ea0e14dbe4f$var$$8d99d7c025746ac9$var$learningContentCardContainerStyles,
            onClick: clickHandler,
            onKeyDown: handleKeyDown,
            tabIndex: 0,
            "data-testid": "learning-content-card",
            style: {
                minHeight: `${minHeight}px`
            },
            children: [
                (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$var$$f73a4551a9d8a3b1$export$8a8c015277a3d77a, {
                    imageUrl: imageUrl,
                    backgroundColor: backgroundColor,
                    productIcon: productIcon,
                    isLearningProgress: !!learningProgress,
                    imageHeight: imageHeight
                }),
                (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                    css: [
                        $24c02ea0e14dbe4f$var$$8d99d7c025746ac9$var$bodyContainerStyles,
                        learningProgress && $24c02ea0e14dbe4f$var$$8d99d7c025746ac9$var$progressBodyContainerStyles
                    ],
                    children: [
                        (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$var$$fb345954107134f9$export$331084b24da1eef5, {
                            tags: tags,
                            lastLabelWidth: lastLabelWidth
                        }),
                        (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$var$$94fa590b0c9d9421$export$64ef9b8c11710c47, {
                            title: title,
                            description: description,
                            inspectMode: inspectMode,
                            isLearningProgress: !!learningProgress,
                            disableDescriptionClamp: disableDescriptionClamp
                        }),
                        learningProgress && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                            css: $24c02ea0e14dbe4f$var$$8d99d7c025746ac9$var$learningContentCardProgressContainerStyles,
                            "data-testid": "learning-progress-content",
                            children: (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                                css: $24c02ea0e14dbe4f$var$$8d99d7c025746ac9$var$learningContentCardProgressItemsContainerStyles,
                                children: [
                                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$184a993f673fc83f, {
                                        wasPreviouslyCompleted: learningProgress.status === $24c02ea0e14dbe4f$var$$035f8a623e403361$export$23d03d0b3065d061.COMPLETED,
                                        completedResources: learningProgress.completedResources,
                                        resourceCount: learningProgress.resourceCount,
                                        completionDate: learningProgress.completionDate,
                                        contentType: $24c02ea0e14dbe4f$export$e2e108cbe2e4f865.LEARNING_PATH
                                    }),
                                    (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                                        css: $24c02ea0e14dbe4f$var$$8d99d7c025746ac9$var$learningContentCardIconsContainerStyles,
                                        children: [
                                            isUpdated && learningProgress.status !== $24c02ea0e14dbe4f$var$$035f8a623e403361$export$23d03d0b3065d061.NOT_STARTED && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                                                "data-testid": "updated-icon",
                                                css: $24c02ea0e14dbe4f$var$$8d99d7c025746ac9$var$updatedIconContainerStyles,
                                                children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$353f5b6fc5456de1, {
                                                    label: "Updated",
                                                    iconBefore: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$f04a61298a47a40f, {
                                                        type: "editor-panel"
                                                    }),
                                                    onClick: handleUpdatedButtonClick
                                                })
                                            }),
                                            shouldDisplayShowMoreButton && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$ca7697601dcd7803, {
                                                cardRef: cardRef,
                                                shareOnPdf: true,
                                                onGeneratePdf: onGeneratePdf,
                                                areHistoricalNotifications: areHistoricalNotifications,
                                                onViewUpdates: onViewUpdates
                                            }),
                                            shouldDisplayBookmark && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("button", {
                                                "data-testid": "save-content",
                                                css: $24c02ea0e14dbe4f$var$$8d99d7c025746ac9$var$learningContentCardBookmarkContainerStyles,
                                                onClick: handleOnSave,
                                                children: learningProgress.isSaved ? (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$f04a61298a47a40f, {
                                                    type: "bookmark-filled"
                                                }) : (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$f04a61298a47a40f, {
                                                    type: "bookmark"
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    ]
                })
            ]
        })
    });
};
const $24c02ea0e14dbe4f$var$$8d99d7c025746ac9$var$imageBaseStyles = (0, $74Zh5.css)({
    width: "100%",
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    borderRadius: "7px 7px 0px 0px",
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "center",
    height: "80px"
});
const $24c02ea0e14dbe4f$var$$8d99d7c025746ac9$var$noImageStyles = (0, $74Zh5.css)({
    background: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.background.accent.gray.subtlest")
});
const $24c02ea0e14dbe4f$var$$8d99d7c025746ac9$var$bodyContainerStyles = (0, $74Zh5.css)({
    display: "flex",
    flexDirection: "column",
    flexGrow: 1,
    padding: `${$24c02ea0e14dbe4f$var$$70542fe329d53412$export$bb4069a5b1582edc}px 0 0`
});
const $24c02ea0e14dbe4f$var$$8d99d7c025746ac9$var$progressBodyContainerStyles = (0, $74Zh5.css)({
    padding: `21px 0 0`
});
const $24c02ea0e14dbe4f$var$$8d99d7c025746ac9$var$labelContainerStyles = (0, $74Zh5.css)({
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    gap: `${$24c02ea0e14dbe4f$var$$70542fe329d53412$export$ce572121d239fe86}px`,
    padding: `0 ${$24c02ea0e14dbe4f$var$$70542fe329d53412$export$bb4069a5b1582edc}px`,
    overflow: "hidden"
});
const $24c02ea0e14dbe4f$var$$8d99d7c025746ac9$var$linkContainerStyles = (0, $74Zh5.css)({
    textDecoration: "none",
    "&:hover": {
        textDecoration: "none"
    }
});
const $24c02ea0e14dbe4f$var$$8d99d7c025746ac9$var$titleAndDetailsContainerStyles = (0, $74Zh5.css)({
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    padding: `0 ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.300")} ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.300")}`
});
const $24c02ea0e14dbe4f$var$$8d99d7c025746ac9$var$learningContentCardProgressContainerStyles = (0, $74Zh5.css)({
    borderTop: `1px solid ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.border")}`
});
const $24c02ea0e14dbe4f$var$$8d99d7c025746ac9$var$learningContentCardProgressItemsContainerStyles = (0, $74Zh5.css)({
    display: "flex",
    justifyContent: "space-between",
    padding: `18px ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.300")}`
});
const $24c02ea0e14dbe4f$var$$8d99d7c025746ac9$var$learningContentCardIconsContainerStyles = (0, $74Zh5.css)({
    display: "flex",
    alignItems: "center",
    gap: "5px"
});
const $24c02ea0e14dbe4f$var$$8d99d7c025746ac9$var$updatedIconContainerStyles = (0, $74Zh5.css)({
    display: "flex",
    alignItems: "center",
    gap: "5px",
    button: {
        backgroundColor: "transparent",
        height: "auto",
        minHeight: "auto",
        alignItems: "center",
        ":hover": {
            backgroundColor: "transparent"
        }
    },
    span: {
        color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text.selected"),
        fontFamily: "SF Pro, sans-serif",
        fontSize: "14px",
        lineHeight: "20px"
    }
});
const $24c02ea0e14dbe4f$var$$8d99d7c025746ac9$var$learningContentCardBookmarkContainerStyles = (0, $74Zh5.css)({
    height: "24px",
    border: "none",
    background: "none",
    cursor: "pointer",
    outline: "none",
    "&:focus-visible": {
        outline: `2px solid ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.border.selected")}`
    }
});
const $24c02ea0e14dbe4f$var$$8d99d7c025746ac9$var$learningContentCardContainerStyles = (0, $74Zh5.css)({
    display: "flex",
    flexDirection: "column",
    backgroundColor: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.background.input"),
    borderRadius: "8px",
    boxShadow: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("elevation.shadow.raised"),
    transition: "box-shadow 0.3s ease-in-out",
    cursor: "pointer",
    minWidth: `${$24c02ea0e14dbe4f$var$$70542fe329d53412$export$3b38c99bd0870716}px`,
    "&:hover": {
        boxShadow: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("elevation.shadow.overlay")
    },
    "&:active": {
        outline: `1px solid ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.border.focused")}`,
        border: `1px solid ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.border.focused")}`
    },
    '&:has([data-testid="show-more"]:active)': {
        outline: "none",
        border: "none"
    }
});
const $24c02ea0e14dbe4f$var$$8d99d7c025746ac9$var$loadingLearningContentCardContainerStyles = (0, $74Zh5.css)({
    boxShadow: "none",
    border: `1px solid ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.background.disabled")}`,
    cursor: "initial",
    "&:hover": {
        boxShadow: "none"
    },
    "&:active": {
        outline: "none",
        border: `1px solid ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.background.disabled")}`
    }
});
const $24c02ea0e14dbe4f$var$$8d99d7c025746ac9$var$smallPillStyles = (0, $74Zh5.css)({
    width: "52px",
    height: "10.5px",
    backgroundColor: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.background.neutral"),
    borderRadius: "15px",
    marginLeft: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.100"),
    display: "inline-block"
});
const $24c02ea0e14dbe4f$var$$8d99d7c025746ac9$var$bigPillStyles = (0, $74Zh5.css)({
    maxWidth: "227px",
    height: "17.5px",
    backgroundColor: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.background.neutral"),
    borderRadius: "25px",
    marginTop: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.100")
});
var $24c02ea0e14dbe4f$var$$1f7c4876f10b107b$exports = {};
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$1f7c4876f10b107b$exports, "Modal", ()=>$24c02ea0e14dbe4f$export$2b77a92f1a5ad772);
let $24c02ea0e14dbe4f$var$$1f7c4876f10b107b$var$DialogWidth;
(function(DialogWidth) {
    DialogWidth["SMALL"] = "small";
    DialogWidth["MEDIUM"] = "medium";
    DialogWidth["LARGE"] = "large";
    DialogWidth["XLARGE"] = "x-large";
})($24c02ea0e14dbe4f$var$$1f7c4876f10b107b$var$DialogWidth || ($24c02ea0e14dbe4f$var$$1f7c4876f10b107b$var$DialogWidth = {}));
const $24c02ea0e14dbe4f$export$2b77a92f1a5ad772 = ({ closeModal: closeModal, width: width = $24c02ea0e14dbe4f$var$$1f7c4876f10b107b$var$DialogWidth.LARGE, imageLink: imageLink, actionButton: actionButton, heading: heading, subheading: subheading, surveyText: surveyText })=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $73c4314b1cf0d4b0$export$2e2bcd8739ae039), {
        onClose: closeModal,
        width: width,
        children: (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
            css: $24c02ea0e14dbe4f$var$$1f7c4876f10b107b$var$modalContainerStyles,
            children: [
                (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("span", {
                    css: $24c02ea0e14dbe4f$var$$1f7c4876f10b107b$var$modalCloseButtonStyles,
                    children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$353f5b6fc5456de1, {
                        label: "close modal button",
                        appearance: $24c02ea0e14dbe4f$export$261c9483fc4a455a.ICON,
                        iconBefore: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$f04a61298a47a40f, {
                            type: "cross"
                        }),
                        onClick: closeModal
                    })
                }),
                (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                    css: $24c02ea0e14dbe4f$var$$1f7c4876f10b107b$var$modalBodyStyles,
                    children: [
                        (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("span", {
                            css: $24c02ea0e14dbe4f$var$$1f7c4876f10b107b$var$modalImageContainerStyles,
                            children: imageLink && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("img", {
                                src: imageLink,
                                alt: "modal-image",
                                width: 120,
                                height: 120,
                                css: $24c02ea0e14dbe4f$var$$1f7c4876f10b107b$var$imageStyles
                            })
                        }),
                        (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("p", {
                            "data-testid": "modal-heading",
                            css: $24c02ea0e14dbe4f$var$$1f7c4876f10b107b$var$modalHeadingContainerStyles,
                            children: heading
                        }),
                        (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("span", {
                            "data-testid": "modal-subheading",
                            css: $24c02ea0e14dbe4f$var$$1f7c4876f10b107b$var$modalSubheadingContainerStyles,
                            children: subheading
                        }),
                        surveyText && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("span", {
                            "data-testid": "modal-survey-text",
                            css: [
                                $24c02ea0e14dbe4f$var$$1f7c4876f10b107b$var$modalSubheadingContainerStyles,
                                $24c02ea0e14dbe4f$var$$1f7c4876f10b107b$var$surveyTextStyles
                            ],
                            children: surveyText
                        }),
                        actionButton && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("span", {
                            css: $24c02ea0e14dbe4f$var$$1f7c4876f10b107b$var$modalActionButtonContainerStyles,
                            children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$353f5b6fc5456de1, {
                                appearance: $24c02ea0e14dbe4f$export$261c9483fc4a455a.PRIMARY,
                                size: $24c02ea0e14dbe4f$export$5dd2748b7940a2a0.LARGE,
                                onClick: actionButton.onClick,
                                label: actionButton.label,
                                iconBefore: actionButton.iconBefore,
                                iconAfter: actionButton.iconAfter
                            })
                        })
                    ]
                })
            ]
        })
    });
const $24c02ea0e14dbe4f$var$$1f7c4876f10b107b$var$imageStyles = (0, $74Zh5.css)({
    borderRadius: "50%"
});
const $24c02ea0e14dbe4f$var$$1f7c4876f10b107b$var$modalContainerStyles = (0, $74Zh5.css)({
    padding: `${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.400")} ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.500")}`,
    [(0, $cb8cedbc477f5a81$export$987d49ffe1b0900f).below.sm]: {
        padding: "16px"
    }
});
const $24c02ea0e14dbe4f$var$$1f7c4876f10b107b$var$modalCloseButtonStyles = (0, $74Zh5.css)({
    width: "100%",
    display: "flex",
    justifyContent: "flex-end",
    [(0, $cb8cedbc477f5a81$export$987d49ffe1b0900f).below.sm]: {
        padding: "8px"
    }
});
const $24c02ea0e14dbe4f$var$$1f7c4876f10b107b$var$modalImageContainerStyles = (0, $74Zh5.css)({
    marginBottom: "24px",
    [(0, $cb8cedbc477f5a81$export$987d49ffe1b0900f).below.sm]: {
        marginBottom: "16px"
    }
});
const $24c02ea0e14dbe4f$var$$1f7c4876f10b107b$var$modalBodyStyles = (0, $74Zh5.css)({
    maxWidth: "640px",
    width: "100%",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    margin: `${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.200")} auto 0`,
    [(0, $cb8cedbc477f5a81$export$987d49ffe1b0900f).below.sm]: {
        marginTop: 0
    }
});
const $24c02ea0e14dbe4f$var$$1f7c4876f10b107b$var$modalHeadingContainerStyles = (0, $74Zh5.css)({
    fontFamily: "Charlie Display, sans-serif",
    fontSize: "32px",
    fontWeight: 600,
    lineHeight: "40px",
    marginTop: 0,
    marginBottom: "24px",
    textAlign: "center",
    [(0, $cb8cedbc477f5a81$export$987d49ffe1b0900f).below.sm]: {
        marginTop: 0,
        marginBottom: "16px",
        fontSize: "24px",
        lineHeight: "32px"
    }
});
const $24c02ea0e14dbe4f$var$$1f7c4876f10b107b$var$modalSubheadingContainerStyles = (0, $74Zh5.css)({
    fontFamily: "Inter, sans-serif",
    fontSize: "20px",
    fontWeight: 400,
    lineHeight: "32px",
    color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text"),
    textAlign: "center",
    [(0, $cb8cedbc477f5a81$export$987d49ffe1b0900f).below.sm]: {
        marginBottom: "32px",
        fontSize: "16px",
        lineHeight: "24px"
    }
});
const $24c02ea0e14dbe4f$var$$1f7c4876f10b107b$var$surveyTextStyles = (0, $74Zh5.css)({
    marginTop: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.200"),
    a: {
        fontSize: "20px"
    }
});
const $24c02ea0e14dbe4f$var$$1f7c4876f10b107b$var$modalActionButtonContainerStyles = (0, $74Zh5.css)({
    marginTop: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.400"),
    [(0, $cb8cedbc477f5a81$export$987d49ffe1b0900f).below.sm]: {
        margin: 0
    }
});
var $24c02ea0e14dbe4f$var$$c5616d3f1657fc84$exports = {};
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$c5616d3f1657fc84$exports, "LessonsTabContentSize", ()=>$24c02ea0e14dbe4f$export$415b2bdf1346d2d4);
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$c5616d3f1657fc84$exports, "LessonsTabContent", ()=>$24c02ea0e14dbe4f$export$ce96f190f5d3ee14);
let $24c02ea0e14dbe4f$export$415b2bdf1346d2d4;
(function(LessonsTabContentSize) {
    LessonsTabContentSize["DEFAULT"] = "default";
    LessonsTabContentSize["WIDE"] = "wide";
})($24c02ea0e14dbe4f$export$415b2bdf1346d2d4 || ($24c02ea0e14dbe4f$export$415b2bdf1346d2d4 = {}));
const $24c02ea0e14dbe4f$export$ce96f190f5d3ee14 = ({ tabLinks: tabLinks, activeTab: activeTab = 0, onClickTab: onClickTab, children: children, size: size = $24c02ea0e14dbe4f$export$415b2bdf1346d2d4.DEFAULT })=>(0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
        css: [
            $24c02ea0e14dbe4f$var$$c5616d3f1657fc84$var$tabsContainerStyles["base"],
            $24c02ea0e14dbe4f$var$$c5616d3f1657fc84$var$tabsContainerStyles[`${size}-size`]
        ],
        "data-testid": "navtab",
        children: [
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("ul", {
                css: $24c02ea0e14dbe4f$var$$c5616d3f1657fc84$var$tabsButtonGroupContainerStyles,
                children: tabLinks.map((tab, index)=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("li", {
                        "data-testid": `button-${tab}${index === activeTab ? "-selected" : ""}`,
                        css: $24c02ea0e14dbe4f$var$$c5616d3f1657fc84$var$tabsButtonContainerStyles,
                        children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$3e41faf802a29e71, {
                            size: $24c02ea0e14dbe4f$export$ddadc1228c8dcfa.LARGE,
                            label: tab,
                            onClick: ()=>onClickTab(index),
                            selected: index === activeTab
                        })
                    }, `li-navtab-${tab}-${index}`))
            }),
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                css: $24c02ea0e14dbe4f$var$$c5616d3f1657fc84$var$tabsContentContainerStyles,
                children: children
            })
        ]
    });
const $24c02ea0e14dbe4f$var$$c5616d3f1657fc84$var$tabsContainerStyles = {
    base: (0, $74Zh5.css)({
        width: "100%",
        borderRadius: "8px",
        boxShadow: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("elevation.shadow.raised"),
        [(0, $cb8cedbc477f5a81$export$987d49ffe1b0900f).below.md]: {
            maxWidth: "720px"
        }
    }),
    "default-size": (0, $74Zh5.css)({
        maxWidth: "720px"
    }),
    "wide-size": (0, $74Zh5.css)({
        maxWidth: "1020px"
    })
};
const $24c02ea0e14dbe4f$var$$c5616d3f1657fc84$var$tabsButtonGroupContainerStyles = (0, $74Zh5.css)({
    padding: "18px",
    overflowX: "auto",
    listStyleType: "none",
    borderBottom: `1px solid ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.border")}`,
    margin: 0,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexWrap: "wrap",
    [(0, $cb8cedbc477f5a81$export$987d49ffe1b0900f).below.xs]: {
        padding: "12px"
    }
});
const $24c02ea0e14dbe4f$var$$c5616d3f1657fc84$var$tabsButtonContainerStyles = (0, $74Zh5.css)({
    margin: "6px",
    [(0, $cb8cedbc477f5a81$export$987d49ffe1b0900f).below.xs]: {
        margin: "4px"
    }
});
const $24c02ea0e14dbe4f$var$$c5616d3f1657fc84$var$tabsContentContainerStyles = (0, $74Zh5.css)({
    fontFamily: "Inter, sans-serif",
    fontSize: "20px",
    fontWeight: 400,
    lineHeight: "32px",
    letterSpacing: "-0.06px",
    padding: "24px",
    color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text"),
    a: {
        fontSize: "20px",
        lineHeight: "32px"
    },
    [(0, $cb8cedbc477f5a81$export$987d49ffe1b0900f).below.xs]: {
        padding: "16px",
        fontSize: "16px",
        lineHeight: "24px"
    }
});
var $24c02ea0e14dbe4f$var$$eb6f767c51421421$exports = {};
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$eb6f767c51421421$exports, "Metadata", ()=>$24c02ea0e14dbe4f$export$e7adebdc1ebd2fed);
const $24c02ea0e14dbe4f$export$e7adebdc1ebd2fed = ({ fields: fields })=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
        css: $24c02ea0e14dbe4f$var$$eb6f767c51421421$var$metadataContainerStyles,
        "data-testid": "metadata",
        children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
            css: $24c02ea0e14dbe4f$var$$eb6f767c51421421$var$metadataListStyles,
            children: fields.map((field)=>field.value && (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                    css: $24c02ea0e14dbe4f$var$$eb6f767c51421421$var$metadataItemsStyles,
                    children: [
                        (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("p", {
                            css: $24c02ea0e14dbe4f$var$$eb6f767c51421421$var$metadataTitleStyles,
                            children: field.name
                        }),
                        (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                            css: $24c02ea0e14dbe4f$var$$eb6f767c51421421$var$metadataValueStyles,
                            children: field.value
                        })
                    ]
                }, field.name))
        })
    });
const $24c02ea0e14dbe4f$var$$eb6f767c51421421$var$metadataContainerStyles = (0, $74Zh5.css)({
    display: "flex",
    padding: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.400"),
    alignItems: "flex-start",
    flexDirection: "column",
    backgroundColor: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.background.input"),
    borderRadius: "8px",
    boxShadow: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("elevation.shadow.raised")
});
const $24c02ea0e14dbe4f$var$$eb6f767c51421421$var$metadataListStyles = (0, $74Zh5.css)({
    display: "flex",
    width: "100%",
    flexDirection: "column",
    alignItems: "flex-start",
    gap: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.200")
});
const $24c02ea0e14dbe4f$var$$eb6f767c51421421$var$metadataItemsStyles = (0, $74Zh5.css)({
    display: "flex",
    minHeight: "24px",
    gap: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.300"),
    alignItems: "center"
});
const $24c02ea0e14dbe4f$var$$eb6f767c51421421$var$metadataTitleStyles = (0, $74Zh5.css)({
    margin: 0,
    minWidth: "88px",
    color: "#000",
    fontFamily: "Charlie Text, sans-serif",
    fontSize: "14px",
    fontWeight: 600,
    lineHeight: "18px",
    textTransform: "uppercase"
});
const $24c02ea0e14dbe4f$var$$eb6f767c51421421$var$metadataValueStyles = (0, $74Zh5.css)({
    margin: 0,
    color: "#000",
    fontFamily: "Inter",
    fontSize: "16px",
    fontWeight: 400,
    lineHeight: "24px"
});
var $24c02ea0e14dbe4f$var$$7fe7e19d380f3d34$exports = {};
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$7fe7e19d380f3d34$exports, "ArrowPosition", ()=>$24c02ea0e14dbe4f$export$2d4c84fdfce6f2a9);
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$7fe7e19d380f3d34$exports, "Popup", ()=>$24c02ea0e14dbe4f$export$129a32eedafa97c5);
let $24c02ea0e14dbe4f$export$2d4c84fdfce6f2a9;
(function(ArrowPosition) {
    ArrowPosition["LEFT_START"] = "leftStart";
    ArrowPosition["LEFT_CENTER"] = "leftCenter";
    ArrowPosition["LEFT_END"] = "leftEnd";
    ArrowPosition["TOP_START"] = "topStart";
    ArrowPosition["TOP_CENTER"] = "topCenter";
    ArrowPosition["TOP_END"] = "topEnd";
    ArrowPosition["RIGHT_START"] = "rightStart";
    ArrowPosition["RIGHT_CENTER"] = "rightCenter";
    ArrowPosition["RIGHT_END"] = "rightEnd";
    ArrowPosition["BOTTOM_START"] = "bottomStart";
    ArrowPosition["BOTTOM_CENTER"] = "bottomCenter";
    ArrowPosition["BOTTOM_END"] = "bottomEnd";
})($24c02ea0e14dbe4f$export$2d4c84fdfce6f2a9 || ($24c02ea0e14dbe4f$export$2d4c84fdfce6f2a9 = {}));
const $24c02ea0e14dbe4f$export$129a32eedafa97c5 = (0, $5FkrB.forwardRef)(({ popupHeight: popupHeight, title: title, children: children, step: step, totalSteps: totalSteps, arrowPosition: arrowPosition, onClose: onClose, onPrevious: onPrevious, onNext: onNext, popupStyle: popupStyle }, popoverRef)=>{
    const CONTAINER_SIZE_PX = 88;
    const handlePrevious = ()=>{
        if (onPrevious) onPrevious();
    };
    const handleNext = ()=>{
        if (onNext) onNext();
    };
    const handleClose = ()=>{
        if (onClose) onClose();
    };
    (0, $5FkrB.useEffect)(()=>{
        const handleClickOutside = (event)=>{
            if (popoverRef && !popoverRef.current.contains(event.target)) handleClose();
        };
        document.addEventListener("mousedown", handleClickOutside);
        return ()=>{
            document.removeEventListener("mousedown", handleClickOutside);
        };
    // handleClose and popoverRef intentionally excluded to avoid re-creating listener
    /* eslint-disable react-hooks/exhaustive-deps */ }, [
        onClose
    ]);
    /* eslint-enable react-hooks/exhaustive-deps */ return (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
        role: "dialog",
        "aria-label": title,
        "data-testid": `popup-${arrowPosition}`,
        css: $24c02ea0e14dbe4f$var$$7fe7e19d380f3d34$var$popupContainerStyles,
        style: popupStyle,
        ref: popoverRef,
        // eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex -- Dialog needs tabIndex for focus management
        tabIndex: 0,
        children: (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
            css: [
                $24c02ea0e14dbe4f$var$$7fe7e19d380f3d34$var$popupContentStyles["base"],
                $24c02ea0e14dbe4f$var$$7fe7e19d380f3d34$var$popupContentStyles[arrowPosition]
            ],
            children: [
                (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                    css: $24c02ea0e14dbe4f$var$$7fe7e19d380f3d34$var$contentHeaderStyles,
                    children: [
                        (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("p", {
                            css: $24c02ea0e14dbe4f$var$$7fe7e19d380f3d34$var$counterContainerStyles,
                            children: [
                                step,
                                "/",
                                totalSteps
                            ]
                        }),
                        (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                            css: $24c02ea0e14dbe4f$var$$7fe7e19d380f3d34$var$buttonsContainerStyles,
                            children: [
                                (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$353f5b6fc5456de1, {
                                    disabled: step === 1,
                                    appearance: $24c02ea0e14dbe4f$export$261c9483fc4a455a.ICON,
                                    label: "Previous",
                                    iconBefore: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$f04a61298a47a40f, {
                                        type: "chevron-left",
                                        alt: "next icon"
                                    }),
                                    onClick: handlePrevious
                                }),
                                (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$353f5b6fc5456de1, {
                                    disabled: step === totalSteps,
                                    appearance: $24c02ea0e14dbe4f$export$261c9483fc4a455a.ICON,
                                    label: "Next",
                                    iconBefore: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$f04a61298a47a40f, {
                                        type: "chevron-right",
                                        alt: "previous icon"
                                    }),
                                    onClick: handleNext
                                })
                            ]
                        })
                    ]
                }),
                (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                    css: (0, $74Zh5.css)({
                        overflow: "auto",
                        maxHeight: `calc(${popupHeight}px - ${CONTAINER_SIZE_PX}px)`,
                        padding: "0 16px"
                    }),
                    children: [
                        (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("p", {
                            css: $24c02ea0e14dbe4f$var$$7fe7e19d380f3d34$var$titleContainerStyles,
                            children: title
                        }),
                        (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("p", {
                            css: $24c02ea0e14dbe4f$var$$7fe7e19d380f3d34$var$descriptionContainerStyles,
                            children: [
                                " ",
                                children
                            ]
                        })
                    ]
                })
            ]
        })
    });
});
const $24c02ea0e14dbe4f$var$$7fe7e19d380f3d34$var$popupContainerStyles = (0, $74Zh5.css)({
    width: "340px",
    position: "absolute",
    zIndex: 10,
    backgroundColor: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.background.input"),
    borderRadius: "8px",
    boxShadow: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("elevation.shadow.overlay"),
    [`@media (max-width: ${$24c02ea0e14dbe4f$var$$f0285f05d4d9f8a0$export$426e07cd0772984d.TABLET.MAX_WIDTH}px)`]: {
        top: "0 !important",
        left: "0 !important"
    },
    [(0, $cb8cedbc477f5a81$export$987d49ffe1b0900f).below.xs]: {
        height: "100%",
        width: "100%",
        border: "1px solid",
        borderColor: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.border"),
        borderRadius: 0
    }
});
const $24c02ea0e14dbe4f$var$$7fe7e19d380f3d34$var$popupContentStyles = {
    base: (0, $74Zh5.css)({
        position: "relative",
        padding: "24px 8px",
        color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text"),
        display: "flex",
        flexDirection: "column",
        "&:after": {
            content: '""',
            display: "block",
            position: "absolute",
            border: "16px solid transparent",
            width: 0,
            height: 0,
            marginTop: "-10px"
        },
        [`@media (max-width: ${$24c02ea0e14dbe4f$var$$f0285f05d4d9f8a0$export$426e07cd0772984d.TABLET.MAX_WIDTH}px)`]: {
            "&:after": {
                display: "none"
            }
        }
    }),
    leftStart: (0, $74Zh5.css)({
        "&::after": {
            top: "35px",
            left: "-5px",
            borderTop: "12px solid transparent",
            borderBottom: "12px solid transparent",
            borderLeft: 0,
            borderRightColor: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.border.inverse"),
            marginLeft: "-10px",
            filter: "drop-shadow(-2px 1px 1px rgb(178, 176, 176))"
        }
    }),
    leftCenter: (0, $74Zh5.css)({
        "&::after": {
            top: "calc(50%)",
            left: "-5px",
            borderTop: "12px solid transparent",
            borderBottom: "12px solid transparent",
            borderLeft: 0,
            borderRightColor: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.border.inverse"),
            marginLeft: "-10px",
            filter: "drop-shadow(-2px 1px 1px rgb(178, 176, 176))"
        }
    }),
    leftEnd: (0, $74Zh5.css)({
        "&::after": {
            left: "-5px",
            bottom: "35px",
            borderTop: "12px solid transparent",
            borderBottom: "12px solid transparent",
            borderLeft: 0,
            borderRightColor: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.border.inverse"),
            marginLeft: "-10px",
            filter: "drop-shadow(-2px 1px 1px rgb(178, 176, 176))"
        }
    }),
    topStart: (0, $74Zh5.css)({
        "&::after": {
            top: "-21px",
            left: "35px",
            borderRight: "12px solid transparent",
            borderLeft: "12px solid transparent",
            borderBottom: `16px solid ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.border.inverse")}`,
            marginRight: "-10px",
            filter: "drop-shadow(0 -1px 0.4px rgb(178, 176, 176))"
        }
    }),
    topCenter: (0, $74Zh5.css)({
        "&::after": {
            top: "-5px",
            left: "calc(50% - 16px)",
            borderRight: "12px solid transparent",
            borderLeft: "12px solid transparent",
            borderBottom: `16px solid ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.border.inverse")}`,
            borderTop: 0,
            marginRight: "-10px",
            filter: "drop-shadow(0 -1px 0.4px rgb(178, 176, 176))"
        }
    }),
    topEnd: (0, $74Zh5.css)({
        "&::after": {
            top: "-5px",
            right: "35px",
            borderRight: "12px solid transparent",
            borderLeft: "12px solid transparent",
            borderBottom: `16px solid ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.border.inverse")}`,
            borderTop: 0,
            marginRight: "-10px",
            filter: "drop-shadow(0 -1px 0.4px rgb(178, 176, 176))"
        }
    }),
    rightStart: (0, $74Zh5.css)({
        "&::after": {
            top: "35px",
            right: "-5px",
            borderTop: "12px solid transparent",
            borderBottom: "12px solid transparent",
            borderLeft: `16px solid ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.border.inverse")}`,
            borderRight: 0,
            marginRight: "-10px",
            filter: "drop-shadow(2px 0 1px #939393)"
        }
    }),
    rightCenter: (0, $74Zh5.css)({
        "&::after": {
            top: "calc(50% - 10px)",
            right: "-5px",
            borderTop: "12px solid transparent",
            borderBottom: "12px solid transparent",
            borderLeft: `16px solid ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.border.inverse")}`,
            borderRight: 0,
            marginRight: "-10px",
            filter: "drop-shadow(2px 0 1px #939393)"
        }
    }),
    rightEnd: (0, $74Zh5.css)({
        "&::after": {
            bottom: "35px",
            right: "-5px",
            borderTop: "12px solid transparent",
            borderBottom: "12px solid transparent",
            borderLeft: `16px solid ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.border.inverse")}`,
            borderRight: 0,
            marginRight: "-10px",
            filter: "drop-shadow(2px 0 1px #939393)"
        }
    }),
    bottomStart: (0, $74Zh5.css)({
        "&::after": {
            left: "35px",
            bottom: "-14px",
            borderLeft: "12px solid transparent",
            borderRight: "12px solid transparent",
            borderTop: `16px solid ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.border.inverse")}`,
            borderBottom: 0,
            filter: "drop-shadow(0 4px 2px #939393)"
        }
    }),
    bottomCenter: (0, $74Zh5.css)({
        "&::after": {
            left: "calc(50% - 16px)",
            bottom: "-14px",
            borderLeft: "12px solid transparent",
            borderRight: "12px solid transparent",
            borderTop: `16px solid ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.border.inverse")}`,
            borderBottom: 0,
            filter: "drop-shadow(0 4px 2px #939393)"
        }
    }),
    bottomEnd: (0, $74Zh5.css)({
        "&::after": {
            right: "35px",
            bottom: "-14px",
            borderLeft: "12px solid transparent",
            borderRight: "12px solid transparent",
            borderTop: `16px solid ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.border.inverse")}`,
            borderBottom: 0,
            filter: "drop-shadow(0 4px 2px #939393)"
        }
    })
};
const $24c02ea0e14dbe4f$var$$7fe7e19d380f3d34$var$contentHeaderStyles = (0, $74Zh5.css)({
    padding: "0 16px",
    marginBottom: "16px",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between"
});
const $24c02ea0e14dbe4f$var$$7fe7e19d380f3d34$var$titleContainerStyles = (0, $74Zh5.css)({
    marginBottom: "16px",
    fontFamily: "Charlie Display, sans-serif",
    fontSize: "16px",
    fontWeight: 600,
    lineHeight: "24px"
});
const $24c02ea0e14dbe4f$var$$7fe7e19d380f3d34$var$descriptionContainerStyles = (0, $74Zh5.css)({
    fontFamily: "Inter, sans-serif",
    fontSize: "16px",
    fontWeight: 400,
    lineHeight: "24px"
});
const $24c02ea0e14dbe4f$var$$7fe7e19d380f3d34$var$counterContainerStyles = (0, $74Zh5.css)({
    fontFamily: "Charlie Text, sans-serif",
    fontSize: "14px",
    fontWeight: 600,
    lineHeight: "18px",
    color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text.subtlest")
});
const $24c02ea0e14dbe4f$var$$7fe7e19d380f3d34$var$buttonsContainerStyles = (0, $74Zh5.css)({
    display: "flex",
    alignItems: "center"
});
var $24c02ea0e14dbe4f$var$$915f5687b3b07750$exports = {};
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$915f5687b3b07750$exports, "ProgressBar", ()=>$24c02ea0e14dbe4f$export$c17561cb55d4db30);
const $24c02ea0e14dbe4f$export$c17561cb55d4db30 = ({ progress: progress, color: color })=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
        "data-testid": "progress-bar",
        css: $24c02ea0e14dbe4f$var$$915f5687b3b07750$var$progressBarContainerStyles,
        children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
            "data-testid": `progress-${progress}`,
            css: [
                $24c02ea0e14dbe4f$var$$915f5687b3b07750$var$progressBarContentStyles,
                color && (0, $74Zh5.css)({
                    backgroundColor: color
                }),
                (0, $74Zh5.css)({
                    width: `${progress}%`
                })
            ]
        })
    });
const $24c02ea0e14dbe4f$var$$915f5687b3b07750$var$progressBarContainerStyles = (0, $74Zh5.css)({
    width: "100%",
    height: "8px",
    backgroundColor: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.background.accent.gray.subtler"),
    borderRadius: "100px",
    overflow: "hidden"
});
const $24c02ea0e14dbe4f$var$$915f5687b3b07750$var$progressBarContentStyles = (0, $74Zh5.css)({
    height: "8px",
    backgroundColor: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text.success"),
    borderRadius: "100px"
});
var $24c02ea0e14dbe4f$var$$579f9ef2424e0bd8$exports = {};
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$579f9ef2424e0bd8$exports, "ProgressStatus", ()=>$24c02ea0e14dbe4f$export$fad76899145ca0c7);
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$579f9ef2424e0bd8$exports, "defineProgressStatus", ()=>$24c02ea0e14dbe4f$export$aa03ab7e1a208875);
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$579f9ef2424e0bd8$exports, "LearningHeader", ()=>$24c02ea0e14dbe4f$export$86f07cccb119409d);
var $24c02ea0e14dbe4f$var$$2cfa64583f556289$exports = {};
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$2cfa64583f556289$exports, "PopupShare", ()=>$24c02ea0e14dbe4f$export$477c64ffaba52edf);
const $24c02ea0e14dbe4f$export$477c64ffaba52edf = ({ cardRef: cardRef, buttonText: buttonText, showCopyLink: showCopyLink = true, shareOnFb: shareOnFb = true, shareOnLinkedin: shareOnLinkedin = true, backgroundColor: backgroundColor = "#FFFFFF", urlToShare: urlToShare, alignToLeft: alignToLeft = false, alignToTop: alignToTop = false, fullWidth: fullWidth = false, color: color = "default", fullHeight: fullHeight = false })=>{
    const [isOpen, setIsOpen] = (0, $5FkrB.useState)(false);
    const [isCopied, setIsCopied] = (0, $5FkrB.useState)(false);
    const dropdownRef = (0, $5FkrB.useRef)(null);
    const handleButtonClick = (event)=>{
        event.stopPropagation();
        event.preventDefault();
        setIsOpen(!isOpen);
    };
    const handleShare = (url)=>{
        window.open(url, "_blank");
    };
    const shareOnFacebook = (0, $5FkrB.useCallback)(()=>{
        const facebookUrl = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(urlToShare)}`;
        handleShare(facebookUrl);
    }, [
        urlToShare
    ]);
    const shareOnLinkedIn = (0, $5FkrB.useCallback)(()=>{
        const shareText = "Check out this training from Atlassian!";
        const linkedinUrl = `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(urlToShare)}&text=${encodeURIComponent(shareText)}`;
        handleShare(linkedinUrl);
    }, [
        urlToShare
    ]);
    const copyToClipboard = (0, $5FkrB.useCallback)(()=>{
        navigator.clipboard.writeText(urlToShare).then(()=>{
            setIsCopied(true);
            setTimeout(()=>{
                setIsCopied(false);
            }, 2000);
        });
    }, [
        urlToShare
    ]);
    const onKeyDownLinkedIn = $24c02ea0e14dbe4f$export$2a0b6757d41dacb2(shareOnLinkedIn);
    const onKeyDownFacebook = $24c02ea0e14dbe4f$export$2a0b6757d41dacb2(shareOnFacebook);
    (0, $5FkrB.useEffect)(()=>{
        const handleClickOutside = (event)=>{
            const isClickOnThisCard = (cardRef?.current || dropdownRef.current)?.contains(event.target);
            if (!isClickOnThisCard) setIsOpen(false);
        };
        if (isOpen) document.addEventListener("mousedown", handleClickOutside);
        return ()=>{
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [
        isOpen,
        cardRef
    ]);
    const primaryColor = (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text.brand");
    const primaryColorStyles = color === "primary" ? (0, $74Zh5.css)({
        color: primaryColor,
        "& span": {
            color: primaryColor
        },
        "& svg": {
            fill: primaryColor
        }
    }) : undefined;
    return (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
        css: [
            $24c02ea0e14dbe4f$var$$2cfa64583f556289$var$shareButtonStyles,
            fullHeight && $24c02ea0e14dbe4f$var$$2cfa64583f556289$var$fullHeightStyles,
            $24c02ea0e14dbe4f$var$$2cfa64583f556289$var$fitContentButtonStyles
        ],
        "data-testid": "popup-share",
        ref: dropdownRef,
        children: [
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$353f5b6fc5456de1, {
                label: buttonText ?? "Share",
                appearance: $24c02ea0e14dbe4f$export$261c9483fc4a455a.ICON,
                onClick: handleButtonClick,
                selected: isOpen,
                size: $24c02ea0e14dbe4f$export$5dd2748b7940a2a0.MEDIUM,
                iconBefore: buttonText ? (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                    css: [
                        $24c02ea0e14dbe4f$var$$2cfa64583f556289$var$buttonWithTextStyles,
                        primaryColorStyles
                    ],
                    "data-testid": "button-with-text",
                    children: [
                        (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("span", {
                            css: $24c02ea0e14dbe4f$var$$2cfa64583f556289$var$buttonTextStyles,
                            children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$5f1af8db9871e1d6, {
                                children: buttonText
                            })
                        }),
                        (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$f04a61298a47a40f, {
                            type: "share"
                        })
                    ]
                }) : (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("span", {
                    css: primaryColorStyles,
                    children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$f04a61298a47a40f, {
                        type: "share"
                    })
                }),
                iconType: "share"
            }),
            isOpen && (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                "data-testid": "popup-share-dropdown",
                css: [
                    $24c02ea0e14dbe4f$var$$2cfa64583f556289$var$popupShareDropdownStyles,
                    alignToLeft && (0, $74Zh5.css)({
                        width: "176px",
                        right: 0
                    }),
                    alignToTop && (0, $74Zh5.css)({
                        bottom: "50px"
                    })
                ],
                style: {
                    backgroundColor: backgroundColor
                },
                children: [
                    showCopyLink && (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("button", {
                        onClick: copyToClipboard,
                        css: [
                            $24c02ea0e14dbe4f$var$$2cfa64583f556289$var$copyToClipboardOptionStyles,
                            fullWidth && $24c02ea0e14dbe4f$var$$2cfa64583f556289$var$fullWidthOptionsStyles
                        ],
                        "aria-label": "copy to clipboard",
                        children: [
                            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$f04a61298a47a40f, {
                                type: "link",
                                size: "small"
                            }),
                            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("span", {
                                css: (0, $74Zh5.css)({
                                    marginLeft: "0.5rem",
                                    fontSize: "0.875rem",
                                    lineHeight: "1.25rem",
                                    fontFamily: "Charlie Text, sans-serif",
                                    color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text")
                                }),
                                children: "Copy link"
                            }),
                            isCopied && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("span", {
                                css: $24c02ea0e14dbe4f$var$$2cfa64583f556289$var$isCopiedStyles,
                                children: "Copied!"
                            })
                        ]
                    }),
                    shareOnLinkedin && (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                        role: "button",
                        tabIndex: 0,
                        css: [
                            $24c02ea0e14dbe4f$var$$2cfa64583f556289$var$shareOnLinkedInOptionStyles,
                            fullWidth && $24c02ea0e14dbe4f$var$$2cfa64583f556289$var$fullWidthOptionsStyles
                        ],
                        onClick: shareOnLinkedIn,
                        onKeyDown: onKeyDownLinkedIn,
                        children: [
                            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("svg", {
                                xmlns: "http://www.w3.org/2000/svg",
                                xmlnsXlink: "http://www.w3.org/1999/xlink",
                                version: "1.1",
                                viewBox: "0 0 512 512",
                                style: {
                                    fillRule: "evenodd",
                                    clipRule: "evenodd",
                                    strokeLinejoin: "round",
                                    strokeMiterlimit: "2",
                                    width: "1rem",
                                    height: "1rem"
                                },
                                xmlSpace: "preserve",
                                children: (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("g", {
                                    id: "g5891",
                                    children: [
                                        (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("path", {
                                            d: "M512,64c0,-35.323 -28.677,-64 -64,-64l-384,0c-35.323,0 -64,28.677 -64,64l0,384c0,35.323 28.677,64 64,64l384,0c35.323,0 64,-28.677 64,-64l0,-384Z",
                                            id: "background",
                                            style: {
                                                fill: "#2867b2"
                                            }
                                        }),
                                        (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("g", {
                                            id: "shapes",
                                            children: [
                                                (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("rect", {
                                                    height: "257.962",
                                                    id: "rect11",
                                                    style: {
                                                        fill: "#fff"
                                                    },
                                                    width: "85.76",
                                                    x: "61.053",
                                                    y: "178.667"
                                                }),
                                                (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("path", {
                                                    d: "M104.512,54.28c-29.341,0 -48.512,19.29 -48.512,44.573c0,24.752 18.588,44.574 47.377,44.574l0.554,0c29.903,0 48.516,-19.822 48.516,-44.574c-0.555,-25.283 -18.611,-44.573 -47.935,-44.573Z",
                                                    id: "path13-0",
                                                    style: {
                                                        fill: "#fff",
                                                        fillRule: "nonzero"
                                                    }
                                                }),
                                                (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("path", {
                                                    d: "M357.278,172.601c-45.49,0 -65.866,25.017 -77.276,42.589l0,-36.523l-85.738,0c1.137,24.197 0,257.961 0,257.961l85.737,0l0,-144.064c0,-7.711 0.554,-15.42 2.827,-20.931c6.188,-15.4 20.305,-31.352 43.993,-31.352c31.012,0 43.436,23.664 43.436,58.327l0,138.02l85.741,0l0,-147.93c0,-79.237 -42.305,-116.097 -98.72,-116.097Z",
                                                    id: "path15",
                                                    style: {
                                                        fill: "#fff",
                                                        fillRule: "nonzero"
                                                    }
                                                })
                                            ]
                                        })
                                    ]
                                })
                            }),
                            " ",
                            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("span", {
                                css: (0, $74Zh5.css)({
                                    marginLeft: "0.5rem",
                                    fontSize: "0.875rem",
                                    lineHeight: "1.25rem"
                                }),
                                children: "Share on LinkedIn"
                            })
                        ]
                    }),
                    shareOnFb && (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                        role: "button",
                        tabIndex: 0,
                        css: [
                            $24c02ea0e14dbe4f$var$$2cfa64583f556289$var$shareOnFacebookOptionStyles,
                            fullWidth && $24c02ea0e14dbe4f$var$$2cfa64583f556289$var$fullWidthOptionsStyles
                        ],
                        onClick: shareOnFacebook,
                        onKeyDown: onKeyDownFacebook,
                        children: [
                            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("svg", {
                                xmlns: "http://www.w3.org/2000/svg",
                                xmlnsXlink: "http://www.w3.org/1999/xlink",
                                version: "1.1",
                                viewBox: "0 0 512 512",
                                style: {
                                    fillRule: "evenodd",
                                    clipRule: "evenodd",
                                    strokeLinejoin: "round",
                                    strokeMiterlimit: "2",
                                    width: "1rem",
                                    height: "1rem"
                                },
                                xmlSpace: "preserve",
                                children: (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("g", {
                                    children: [
                                        (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("path", {
                                            d: "M512,256c0,-141.385 -114.615,-256 -256,-256c-141.385,0 -256,114.615 -256,256c0,127.777 93.616,233.685 216,252.89l0,-178.89l-65,0l0,-74l65,0l0,-56.4c0,-64.16 38.219,-99.6 96.695,-99.6c28.009,0 57.305,5 57.305,5l0,63l-32.281,0c-31.801,0 -41.719,19.733 -41.719,39.978l0,48.022l71,0l-11.35,74l-59.65,0l0,178.89c122.385,-19.205 216,-125.113 216,-252.89Z",
                                            fill: "#1877f2",
                                            fillRule: "nonzero"
                                        }),
                                        (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("path", {
                                            d: "M355.65,330l11.35,-74l-71,0l0,-48.022c0,-20.245 9.917,-39.978 41.719,-39.978l32.281,0l0,-63c0,0 -29.297,-5 -57.305,-5c-58.476,0 -96.695,35.44 -96.695,99.6l0,56.4l-65,0l0,74l65,0l0,178.89c13.033,2.045 26.392,3.11 40,3.11c13.608,0 26.966,-1.065 40,-3.11l0,-178.89l59.65,0Z",
                                            fill: "#fff",
                                            fillRule: "nonzero"
                                        })
                                    ]
                                })
                            }),
                            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("span", {
                                css: (0, $74Zh5.css)({
                                    marginLeft: "0.5rem",
                                    fontSize: "0.875rem",
                                    lineHeight: "1.25rem"
                                }),
                                children: "Share on Facebook"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
const $24c02ea0e14dbe4f$var$$2cfa64583f556289$var$buttonWithTextStyles = (0, $74Zh5.css)({
    display: "flex",
    alignItems: "center",
    gap: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.100")
});
const $24c02ea0e14dbe4f$var$$2cfa64583f556289$var$buttonTextStyles = (0, $74Zh5.css)({
    [(0, $cb8cedbc477f5a81$export$987d49ffe1b0900f).below.sm]: {
        display: "none"
    }
});
const $24c02ea0e14dbe4f$var$$2cfa64583f556289$var$shareButtonStyles = (0, $74Zh5.css)({
    width: "fit-content",
    position: "relative",
    "& span": {
        fontFamily: "Charlie Text, sans-serif"
    }
});
const $24c02ea0e14dbe4f$var$$2cfa64583f556289$var$fitContentButtonStyles = (0, $74Zh5.css)({
    '& button[id*="icon-button"]': {
        width: "fit-content !important",
        height: "fit-content !important"
    }
});
const $24c02ea0e14dbe4f$var$$2cfa64583f556289$var$fullHeightStyles = (0, $74Zh5.css)({
    height: "100%",
    '& button[id*="icon-button"]': {
        height: "100% !important"
    }
});
const $24c02ea0e14dbe4f$var$$2cfa64583f556289$var$popupShareDropdownStyles = (0, $74Zh5.css)({
    position: "absolute",
    marginTop: "0.5rem",
    display: "flex",
    flexDirection: "column",
    borderRadius: "0.25rem",
    zIndex: 2,
    color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text"),
    boxShadow: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("elevation.shadow.overlay")
});
const $24c02ea0e14dbe4f$var$$2cfa64583f556289$var$fullWidthOptionsStyles = (0, $74Zh5.css)({
    whiteSpace: "nowrap"
});
const $24c02ea0e14dbe4f$var$$2cfa64583f556289$var$copyToClipboardOptionStyles = (0, $74Zh5.css)({
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    whiteSpace: "nowrap",
    paddingTop: "0.5rem",
    paddingBottom: "0.5rem",
    paddingLeft: "0.75rem",
    paddingRight: "1rem",
    border: "none",
    transition: "background",
    transitionDuration: "300ms",
    transitionTimingFunction: "cubic-bezier(0, 0, 0.2, 1)",
    cursor: "pointer",
    backgroundColor: "transparent",
    ":hover": {
        backgroundColor: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.background.neutral.subtle.hovered")
    }
});
const $24c02ea0e14dbe4f$var$$2cfa64583f556289$var$isCopiedStyles = (0, $74Zh5.css)({
    position: "absolute",
    backgroundColor: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.background.accent.gray.subtle.pressed"),
    color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text"),
    fontSize: "0.688rem",
    lineHeight: "0.875rem",
    padding: "0.25rem",
    borderRadius: "0.25rem",
    marginTop: "0.25rem",
    right: "1rem"
});
const $24c02ea0e14dbe4f$var$$2cfa64583f556289$var$shareOnLinkedInOptionStyles = (0, $74Zh5.css)({
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    whiteSpace: "nowrap",
    paddingTop: "0.5rem",
    paddingBottom: "0.5rem",
    paddingLeft: "0.75rem",
    paddingRight: "1rem",
    border: "none",
    transition: "background",
    transitionDuration: "300ms",
    transitionTimingFunction: "cubic-bezier(0, 0, 0.2, 1)",
    cursor: "pointer",
    backgroundColor: "transparent",
    ":hover": {
        backgroundColor: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.background.neutral.subtle.hovered")
    }
});
const $24c02ea0e14dbe4f$var$$2cfa64583f556289$var$shareOnFacebookOptionStyles = (0, $74Zh5.css)({
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    whiteSpace: "nowrap",
    paddingTop: "0.5rem",
    paddingBottom: "0.5rem",
    paddingLeft: "0.75rem",
    paddingRight: "1rem",
    border: "none",
    transition: "background",
    transitionDuration: "300ms",
    transitionTimingFunction: "cubic-bezier(0, 0, 0.2, 1)",
    cursor: "pointer",
    backgroundColor: "transparent",
    ":hover": {
        backgroundColor: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.background.neutral.subtle.hovered")
    }
});
let $24c02ea0e14dbe4f$export$fad76899145ca0c7;
(function(ProgressStatus) {
    ProgressStatus["NOT_STARTED"] = "not_started";
    ProgressStatus["IN_PROGRESS"] = "in_progress";
    ProgressStatus["FINISHED"] = "finished";
})($24c02ea0e14dbe4f$export$fad76899145ca0c7 || ($24c02ea0e14dbe4f$export$fad76899145ca0c7 = {}));
const $24c02ea0e14dbe4f$export$aa03ab7e1a208875 = (progressStatus, contentTypeLabel)=>{
    switch(progressStatus){
        case $24c02ea0e14dbe4f$export$fad76899145ca0c7.NOT_STARTED:
            return `Start ${contentTypeLabel}`;
        case $24c02ea0e14dbe4f$export$fad76899145ca0c7.IN_PROGRESS:
            return `Continue ${contentTypeLabel}`;
        case $24c02ea0e14dbe4f$export$fad76899145ca0c7.FINISHED:
            return `Review ${contentTypeLabel}`;
        default:
            return `Start ${contentTypeLabel}`;
    }
};
const $24c02ea0e14dbe4f$export$86f07cccb119409d = ({ inspectMode: inspectMode, heading: heading, anonymousView: anonymousView = true, urlToShare: urlToShare, onSignIn: onSignIn, onStartCourse: onStartCourse, isLoading: isLoading, contentType: contentType, progressStatus: progressStatus, tagLine: tagLine, isSaved: isSaved, onSave: onSave, shouldShowFeedback: shouldShowFeedback, onStartFeedback: onStartFeedback, href: href })=>{
    const handleSignIn = ()=>{
        if (onSignIn) onSignIn();
    };
    const handleStartCourse = (event)=>{
        if (onStartCourse) {
            event?.preventDefault();
            onStartCourse();
        }
    };
    const handleOnSave = ()=>{
        if (onSave) onSave();
    };
    const contentTypeLabel = contentType === $24c02ea0e14dbe4f$export$e2e108cbe2e4f865.COURSE ? "course" : "learning path";
    const status = $24c02ea0e14dbe4f$export$aa03ab7e1a208875(progressStatus, contentTypeLabel);
    const renderActionButtons = ()=>{
        if (isLoading) return (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$353f5b6fc5456de1, {
            label: "",
            isLoading: isLoading
        });
        if (anonymousView) return (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
            css: (0, $74Zh5.css)({
                display: "flex"
            }),
            children: [
                (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$353f5b6fc5456de1, {
                    label: "Sign in",
                    appearance: $24c02ea0e14dbe4f$export$261c9483fc4a455a.PRIMARY,
                    onClick: handleSignIn,
                    isLoading: isLoading
                }),
                (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                    css: (0, $74Zh5.css)({
                        marginLeft: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.200")
                    }),
                    children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$353f5b6fc5456de1, {
                        label: status,
                        appearance: $24c02ea0e14dbe4f$export$261c9483fc4a455a.SECONDARY,
                        onClick: handleStartCourse,
                        isLoading: isLoading,
                        href: href,
                        target: "_blank"
                    })
                })
            ]
        });
        return (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
            css: (0, $74Zh5.css)({
                display: "flex"
            }),
            children: [
                (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$353f5b6fc5456de1, {
                    label: status,
                    appearance: $24c02ea0e14dbe4f$export$261c9483fc4a455a.PRIMARY,
                    onClick: handleStartCourse,
                    isLoading: isLoading,
                    href: href,
                    target: "_blank"
                }),
                shouldShowFeedback && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                    css: (0, $74Zh5.css)({
                        marginLeft: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.200")
                    }),
                    children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$353f5b6fc5456de1, {
                        label: "Take survey",
                        appearance: $24c02ea0e14dbe4f$export$261c9483fc4a455a.SECONDARY,
                        onClick: onStartFeedback,
                        isLoading: isLoading
                    })
                })
            ]
        });
    };
    return (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("section", {
        "data-testid": "learning-header",
        css: $24c02ea0e14dbe4f$var$$579f9ef2424e0bd8$var$learningHeaderContainerStyles,
        children: [
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                css: [
                    $24c02ea0e14dbe4f$export$f40d73b6f7f951e9
                ],
                children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$3288d34c523a1192, {
                    label: contentTypeLabel
                })
            }),
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                css: (0, $74Zh5.css)({
                    margin: `${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.300")} 0`
                }),
                ...$24c02ea0e14dbe4f$export$1784ac302bd8ebad("title", inspectMode),
                children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$a8a3e93435678ff9, {
                    level: 1,
                    children: heading
                })
            }),
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("p", {
                    css: $24c02ea0e14dbe4f$var$$579f9ef2424e0bd8$var$tagLineStyles,
                    children: tagLine
                })
            }),
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                css: (0, $74Zh5.css)({
                    marginTop: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.300"),
                    marginBottom: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.400")
                }),
                children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$2e0a83ec2e27ecbb, {
                    color: (0, $54ca2d3948378259$export$8754fc7e6d8b3000)
                })
            }),
            (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                css: (0, $74Zh5.css)({
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center"
                }),
                children: [
                    renderActionButtons(),
                    (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                        css: (0, $74Zh5.css)({
                            display: "flex"
                        }),
                        children: [
                            !anonymousView && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("button", {
                                tabIndex: 0,
                                css: $24c02ea0e14dbe4f$var$$579f9ef2424e0bd8$var$learningCourseCardBookmarkContainerStyles,
                                onClick: handleOnSave,
                                "aria-label": isSaved ? "unsave" : "save",
                                children: isSaved ? (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$f04a61298a47a40f, {
                                    type: "bookmark-filled"
                                }) : (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$f04a61298a47a40f, {
                                    type: "bookmark"
                                })
                            }),
                            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$477c64ffaba52edf, {
                                urlToShare: urlToShare,
                                alignToLeft: true
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
const $24c02ea0e14dbe4f$var$$579f9ef2424e0bd8$var$learningHeaderContainerStyles = (0, $74Zh5.css)({
    width: "100%",
    paddingTop: `${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.600")}`,
    paddingBottom: `${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.400")}`,
    [(0, $cb8cedbc477f5a81$export$987d49ffe1b0900f).above.lg]: {
        paddingTop: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.1000"),
        paddingBottom: `${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.400")}`
    }
});
const $24c02ea0e14dbe4f$var$$579f9ef2424e0bd8$var$tagLineStyles = (0, $74Zh5.css)({
    color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text"),
    fontFamily: "Inter, sans-serif",
    fontSize: "20px",
    fontWeight: 400,
    lineHeight: "32px"
});
const $24c02ea0e14dbe4f$var$$579f9ef2424e0bd8$var$learningCourseCardBookmarkContainerStyles = (0, $74Zh5.css)({
    height: "24px",
    border: "none",
    padding: 0,
    marginRight: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.100"),
    background: "none",
    cursor: "pointer",
    outline: "none",
    "&:focus-visible": {
        outline: `2px solid ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.border.selected")}`,
        borderRadius: "2px"
    }
});
var $24c02ea0e14dbe4f$var$$d559b1cc82536c49$exports = {};
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$d559b1cc82536c49$exports, "Footer", ()=>$24c02ea0e14dbe4f$export$a06f1c675e846f6f);
const $24c02ea0e14dbe4f$export$a06f1c675e846f6f = ({ onOpenReportProblemModal: onOpenReportProblemModal })=>{
    const noOp = ()=>{};
    const onKeyDownReport = $24c02ea0e14dbe4f$export$2a0b6757d41dacb2(onOpenReportProblemModal || noOp);
    return (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("footer", {
        "data-testid": "footer",
        css: $24c02ea0e14dbe4f$var$$d559b1cc82536c49$var$footerContainerStyles,
        children: [
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("a", {
                href: "https://www.atlassian.com",
                css: [
                    $24c02ea0e14dbe4f$var$$d559b1cc82536c49$var$paddingRightStyles,
                    $24c02ea0e14dbe4f$var$$d559b1cc82536c49$var$logoLinkStyles
                ],
                children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $fefa5e0a15da0ac0$export$765cacec8b0843f3), {
                    appearance: "neutral",
                    size: "small"
                })
            }),
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                children: (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("ul", {
                    css: $24c02ea0e14dbe4f$var$$d559b1cc82536c49$var$listStyles,
                    "aria-label": "footer navigation",
                    children: [
                        onOpenReportProblemModal && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("li", {
                            css: [
                                $24c02ea0e14dbe4f$var$$d559b1cc82536c49$var$listItemStyles,
                                $24c02ea0e14dbe4f$var$$d559b1cc82536c49$var$paddingRightStyles
                            ],
                            children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("span", {
                                role: "button",
                                tabIndex: 0,
                                css: [
                                    $24c02ea0e14dbe4f$var$$d559b1cc82536c49$var$listItemLinkStyles,
                                    (0, $74Zh5.css)({
                                        cursor: "pointer"
                                    })
                                ],
                                onClick: onOpenReportProblemModal,
                                onKeyDown: onKeyDownReport,
                                children: "Report problem"
                            })
                        }),
                        (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("li", {
                            css: [
                                $24c02ea0e14dbe4f$var$$d559b1cc82536c49$var$listItemStyles,
                                $24c02ea0e14dbe4f$var$$d559b1cc82536c49$var$paddingRightStyles
                            ],
                            children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("a", {
                                css: $24c02ea0e14dbe4f$var$$d559b1cc82536c49$var$listItemLinkStyles,
                                href: "https://www.atlassian.com/legal/privacy-policy",
                                children: "Privacy Policy"
                            })
                        }),
                        (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("li", {
                            css: [
                                $24c02ea0e14dbe4f$var$$d559b1cc82536c49$var$listItemStyles,
                                $24c02ea0e14dbe4f$var$$d559b1cc82536c49$var$paddingRightStyles
                            ],
                            children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("a", {
                                css: $24c02ea0e14dbe4f$var$$d559b1cc82536c49$var$listItemLinkStyles,
                                href: "https://community.atlassian.com/t5/user/termsofservicepage",
                                children: "Terms of Use"
                            })
                        }),
                        (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("li", {
                            css: [
                                $24c02ea0e14dbe4f$var$$d559b1cc82536c49$var$listItemStyles,
                                $24c02ea0e14dbe4f$var$$d559b1cc82536c49$var$paddingRightStyles
                            ],
                            children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("a", {
                                css: $24c02ea0e14dbe4f$var$$d559b1cc82536c49$var$listItemLinkStyles,
                                href: "https://www.atlassian.com/security",
                                children: "Security"
                            })
                        }),
                        (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("li", {
                            css: $24c02ea0e14dbe4f$var$$d559b1cc82536c49$var$listItemStyles,
                            children: [
                                "\xa9 ",
                                new Date().getUTCFullYear(),
                                " Atlassian"
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
const $24c02ea0e14dbe4f$var$$d559b1cc82536c49$var$footerContainerStyles = (0, $74Zh5.css)({
    display: "flex",
    justifyContent: "space-between",
    flexDirection: "row",
    alignItems: "center",
    maxWidth: "1440px",
    backgroundColor: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.background.input"),
    zIndex: 4,
    padding: "48px 104px",
    boxSizing: "border-box",
    margin: "0 auto",
    width: "100%",
    [(0, $cb8cedbc477f5a81$export$987d49ffe1b0900f).below.md]: {
        padding: "48px 60px"
    },
    [(0, $cb8cedbc477f5a81$export$987d49ffe1b0900f).below.sm]: {
        padding: "72px 32px",
        flexDirection: "column",
        alignItems: "flex-start"
    }
});
const $24c02ea0e14dbe4f$var$$d559b1cc82536c49$var$listStyles = (0, $74Zh5.css)({
    display: "flex",
    paddingLeft: 0,
    margin: 0,
    flexDirection: "row",
    justifyContent: "flex-end",
    listStyle: "none",
    [(0, $cb8cedbc477f5a81$export$987d49ffe1b0900f).below.sm]: {
        flexDirection: "column"
    }
});
const $24c02ea0e14dbe4f$var$$d559b1cc82536c49$var$listItemStyles = (0, $74Zh5.css)({
    fontFamily: "Charlie Text, sans-serif",
    fontSize: "14px",
    fontStyle: "normal",
    fontWeight: 500,
    lineHeight: "20px",
    marginTop: 0,
    color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text.subtlest"),
    [(0, $cb8cedbc477f5a81$export$987d49ffe1b0900f).below.sm]: {
        paddingTop: "24px"
    }
});
const $24c02ea0e14dbe4f$var$$d559b1cc82536c49$var$paddingRightStyles = (0, $74Zh5.css)({
    paddingRight: "24px"
});
const $24c02ea0e14dbe4f$var$$d559b1cc82536c49$var$logoLinkStyles = (0, $74Zh5.css)({
    lineHeight: "24px"
});
const $24c02ea0e14dbe4f$var$$d559b1cc82536c49$var$listItemLinkStyles = (0, $74Zh5.css)({
    color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text.subtlest"),
    textDecoration: "none",
    "&:hover": {
        color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text.subtlest"),
        textDecoration: "none"
    }
});
var $24c02ea0e14dbe4f$var$$fa53e9c0a1746730$exports = {};
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$fa53e9c0a1746730$exports, "LabelledGraphic", ()=>$24c02ea0e14dbe4f$export$12b5e3eab33f219b);
const $24c02ea0e14dbe4f$export$12b5e3eab33f219b = ({ image: image, markers: markers, onClickMarker: onClickMarker, onClickNext: onClickNext, onClickPrevious: onClickPrevious, onClickDismiss: onClickDismiss, pulseAnimationColor: pulseAnimationColor = (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.background.input") })=>{
    const [activeId, setActiveId] = (0, $5FkrB.useState)(null);
    const [popoverPosX, setPopoverPosX] = (0, $5FkrB.useState)(null);
    const [popoverPosY, setPopoverPosY] = (0, $5FkrB.useState)(null);
    const [clickedMarkers, setClickedMarkers] = (0, $5FkrB.useState)([]);
    const containerDivRef = (0, $5FkrB.useRef)(null);
    const popupRef = (0, $5FkrB.useRef)(null);
    const imageContainerRef = (0, $5FkrB.useRef)(null);
    const maxPopupHeight = 540;
    const maxPopupWidth = 340;
    const defaultDesktopWidth = 1040;
    const iconNumbers = [
        "one",
        "two",
        "three",
        "four",
        "five",
        "six",
        "seven",
        "eight",
        "nine",
        "zero"
    ];
    const handleNextStep = (idx)=>{
        if (onClickNext) onClickNext();
        setClickedMarkers((prevState)=>[
                ...prevState,
                idx + 1
            ]);
        setActiveId((prevId)=>{
            return prevId !== null ? prevId + 1 : null;
        });
    };
    const handlePreviousStep = (idx)=>{
        if (onClickPrevious) onClickPrevious();
        setClickedMarkers((prevState)=>[
                ...prevState,
                idx - 1
            ]);
        setActiveId((prevId)=>{
            return prevId !== null ? prevId - 1 : null;
        });
    };
    const handleDismiss = (0, $5FkrB.useCallback)(()=>{
        if (onClickDismiss) onClickDismiss();
        setActiveId(null);
    }, [
        onClickDismiss
    ]);
    const handleClickMarker = (0, $5FkrB.useCallback)((idx)=>{
        if (onClickMarker) onClickMarker(idx + 1);
        setClickedMarkers((prevState)=>[
                ...prevState,
                idx
            ]);
        setActiveId(idx);
    }, [
        onClickMarker
    ]);
    (0, $5FkrB.useEffect)(()=>{
        if (containerDivRef.current && activeId != null) {
            const parentWidth = containerDivRef.current.clientWidth;
            const parentHeight = containerDivRef.current.clientHeight;
            const popoverHeight = popupRef?.current?.clientHeight ?? 0;
            let posX = parentWidth * markers[activeId].posX / 100;
            let posY = parentHeight * markers[activeId].posY / 100;
            switch(markers[activeId].arrowPosition){
                case $24c02ea0e14dbe4f$export$2d4c84fdfce6f2a9.LEFT_START:
                    posX = posX + 70;
                    posY = posY - 15;
                    break;
                case $24c02ea0e14dbe4f$export$2d4c84fdfce6f2a9.LEFT_CENTER:
                    posX = posX + 70;
                    posY = posY - Math.ceil(popoverHeight / 2.5) - 15;
                    break;
                case $24c02ea0e14dbe4f$export$2d4c84fdfce6f2a9.LEFT_END:
                    posX = posX + 70;
                    posY = posY - popoverHeight + 70;
                    break;
                case $24c02ea0e14dbe4f$export$2d4c84fdfce6f2a9.TOP_START:
                    posX = posX - 24;
                    posY = posY + 70;
                    break;
                case $24c02ea0e14dbe4f$export$2d4c84fdfce6f2a9.TOP_CENTER:
                    posX = posX - Math.ceil(maxPopupWidth / 2) + 27;
                    posY = posY + 70;
                    break;
                case $24c02ea0e14dbe4f$export$2d4c84fdfce6f2a9.TOP_END:
                    posX = posX - maxPopupWidth + 60;
                    posY = posY + 70;
                    break;
                case $24c02ea0e14dbe4f$export$2d4c84fdfce6f2a9.RIGHT_START:
                    posX = posX - maxPopupWidth - 24;
                    posY = posY - 13;
                    break;
                case $24c02ea0e14dbe4f$export$2d4c84fdfce6f2a9.RIGHT_CENTER:
                    posX = posX - maxPopupWidth - 24;
                    posY = posY - Math.ceil(popoverHeight / 2) + 32;
                    break;
                case $24c02ea0e14dbe4f$export$2d4c84fdfce6f2a9.RIGHT_END:
                    posX = posX - maxPopupWidth - 24;
                    posY = posY - popoverHeight + 70;
                    break;
                case $24c02ea0e14dbe4f$export$2d4c84fdfce6f2a9.BOTTOM_START:
                    posX = posX - 25;
                    posY = posY - popoverHeight - 20;
                    break;
                case $24c02ea0e14dbe4f$export$2d4c84fdfce6f2a9.BOTTOM_CENTER:
                    posX = posX - Math.ceil(maxPopupWidth / 2) + 25;
                    posY = posY - popoverHeight - 20;
                    break;
                case $24c02ea0e14dbe4f$export$2d4c84fdfce6f2a9.BOTTOM_END:
                    posX = posX - maxPopupWidth + 70;
                    posY = posY - popoverHeight - 18;
                    break;
                default:
                    break;
            }
            setPopoverPosX(posX / parentWidth * 100);
            setPopoverPosY(posY / parentHeight * 100);
            // Focus the popup when it is opened
            popupRef.current?.focus();
        }
    }, [
        activeId,
        markers,
        imageContainerRef.current?.clientHeight
    ]);
    const handleKeyDown = (0, $5FkrB.useCallback)((event)=>{
        if (event.code === "Space") {
            event.preventDefault();
            handleClickMarker(Number(event.currentTarget.getAttribute("data-marker-index")));
        }
    }, [
        handleClickMarker
    ]);
    return (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
        css: $24c02ea0e14dbe4f$var$$fa53e9c0a1746730$var$labelledGraphicContainerStyles,
        ref: containerDivRef,
        children: [
            markers?.map((marker, idx)=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                    role: "button",
                    tabIndex: 0,
                    onKeyDown: handleKeyDown,
                    "data-testid": "graphic-marker",
                    css: [
                        $24c02ea0e14dbe4f$var$$fa53e9c0a1746730$var$markerPulseStyles,
                        clickedMarkers.includes(idx) && "none",
                        !clickedMarkers.includes(idx) && pulseAnimationColor === "#FFFFFF" && (0, $74Zh5.css)({
                            animation: `${$24c02ea0e14dbe4f$var$$fa53e9c0a1746730$var$pulseWhiteAnimationStyles} 3000ms cubic-bezier(0.55, 0.06, 0.68, 0.19) infinite`
                        }),
                        !clickedMarkers.includes(idx) && pulseAnimationColor !== "#FFFFFF" && (0, $74Zh5.css)({
                            animation: `${$24c02ea0e14dbe4f$var$$fa53e9c0a1746730$var$pulsePurpleAnimationStyles} 3000ms cubic-bezier(0.55, 0.06, 0.68, 0.19) infinite`
                        })
                    ],
                    style: {
                        left: marker.posX + "%",
                        top: marker.posY + "%"
                    },
                    children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                        role: "button",
                        tabIndex: 0,
                        onClick: (e)=>{
                            e.preventDefault();
                            e.stopPropagation();
                            handleClickMarker(idx);
                        },
                        onKeyDown: (e)=>{
                            if (e.key === "Enter" || e.key === " ") {
                                e.preventDefault();
                                e.stopPropagation();
                                handleClickMarker(idx);
                            }
                        },
                        draggable: true,
                        css: [
                            $24c02ea0e14dbe4f$var$$fa53e9c0a1746730$var$graphicMarkerContainerStyles["base"],
                            activeId === idx && $24c02ea0e14dbe4f$var$$fa53e9c0a1746730$var$graphicMarkerContainerStyles["selected"],
                            (0, $74Zh5.css)({
                                border: `2px solid ${pulseAnimationColor}`
                            })
                        ],
                        children: (0, $6bec4f26b2cb3094$export$25062201e9e25d76)((0, $6bec4f26b2cb3094$export$ffb0004e005737fa), {
                            children: [
                                marker.icon && iconNumbers.includes(marker.icon) && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("span", {
                                    css: [
                                        activeId === idx && (0, $74Zh5.css)({
                                            color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text.inverse")
                                        }),
                                        activeId !== idx && (0, $74Zh5.css)({
                                            color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text")
                                        })
                                    ],
                                    children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$f04a61298a47a40f, {
                                        type: marker.icon
                                    })
                                }),
                                marker.icon && !iconNumbers.includes(marker.icon) && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("span", {
                                    css: (0, $74Zh5.css)({
                                        display: "flex",
                                        alignItems: "center"
                                    }),
                                    children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$f04a61298a47a40f, {
                                        size: "small",
                                        color: `${activeId === idx ? (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.icon.inverse") : (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.icon.warning.inverse")}`,
                                        type: marker.icon
                                    })
                                })
                            ]
                        })
                    })
                }, `marker-${idx}`)),
            activeId != null && imageContainerRef.current && containerDivRef.current && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$129a32eedafa97c5, {
                popupHeight: imageContainerRef.current.clientHeight > 540 ? 540 : imageContainerRef.current.clientHeight,
                title: markers[activeId].title,
                totalSteps: markers.length,
                step: activeId + 1,
                popupStyle: {
                    position: "absolute",
                    left: popoverPosX + "%",
                    top: popoverPosY + "%",
                    maxHeight: `${maxPopupHeight}px`,
                    maxWidth: `${maxPopupWidth}px`
                },
                arrowPosition: markers[activeId].arrowPosition,
                onNext: ()=>handleNextStep(activeId),
                onPrevious: ()=>handlePreviousStep(activeId),
                onClose: handleDismiss,
                ref: popupRef,
                children: markers[activeId].children
            }),
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                ref: imageContainerRef,
                children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$3e431a229df88919, {
                    ...image,
                    css: [
                        $24c02ea0e14dbe4f$var$$fa53e9c0a1746730$var$imageStyles,
                        (0, $74Zh5.css)({
                            maxWidth: `${defaultDesktopWidth}px`
                        })
                    ],
                    preventModal: true
                })
            })
        ]
    });
};
const $24c02ea0e14dbe4f$var$$fa53e9c0a1746730$var$labelledGraphicContainerStyles = (0, $74Zh5.css)({
    position: "relative",
    cursor: "default"
});
const $24c02ea0e14dbe4f$var$$fa53e9c0a1746730$var$pulseWhiteAnimationStyles = (0, $74Zh5.keyframes)({
    "0%": {
        boxShadow: `0 0 0 2px ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.border.inverse")}, 0 0 0 ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.border.inverse")}`
    },
    "33%": {
        boxShadow: `0 0 0 2px ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.border.inverse")}, 0 0 0 ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.border.inverse")}`
    },
    "66%": {
        boxShadow: `0 0 0 2px ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.border.inverse")}, 0 0 0 10px ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.border.inverse")}`
    },
    "100%": {
        transform: `0 0 0 2px ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.border.inverse")}, 0 0 0 10px ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.border.inverse")}`
    }
});
const $24c02ea0e14dbe4f$var$$fa53e9c0a1746730$var$pulsePurpleAnimationStyles = (0, $74Zh5.keyframes)({
    "0%": {
        boxShadow: `0 0 0 2px ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text.discovery")}, 0 0 0 ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text.discovery")}`
    },
    "33%": {
        boxShadow: `0 0 0 2px ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text.discovery")}, 0 0 0 ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text.discovery")}`
    },
    "66%": {
        boxShadow: `0 0 0 2px ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text.discovery")}, 0 0 0 10px ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text.discovery")}`
    },
    "100%": {
        transform: `0 0 0 2px ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text.discovery")}, 0 0 0 10px ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text.discovery")}`
    }
});
const $24c02ea0e14dbe4f$var$$fa53e9c0a1746730$var$markerPulseStyles = (0, $74Zh5.css)({
    height: "46px",
    width: "46px",
    padding: "6px 12px",
    backgroundColor: "transparent",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    position: "absolute",
    borderRadius: "50%",
    zIndex: 2,
    cursor: "pointer"
});
const $24c02ea0e14dbe4f$var$$fa53e9c0a1746730$var$graphicMarkerContainerStyles = {
    base: (0, $74Zh5.css)({
        height: "40px",
        width: "40px",
        padding: "6px 12px",
        position: "absolute",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        borderRadius: "50%",
        backgroundColor: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.background.accent.yellow.subtle"),
        fontFamily: "Charlie Display, sans-serif",
        fontSize: "16px",
        fontStyle: "normal",
        fontWeight: 700,
        lineHeight: "24px",
        color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text"),
        boxShadow: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("elevation.shadow.overlay"),
        "&:hover": {
            backgroundColor: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.background.accent.yellow.subtle.hovered")
        },
        "&:active": {
            backgroundColor: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.background.accent.yellow.subtle.pressed")
        }
    }),
    selected: (0, $74Zh5.css)({
        backgroundColor: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text"),
        "&:hover": {
            backgroundColor: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text")
        },
        "&:active": {
            backgroundColor: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text")
        }
    })
};
const $24c02ea0e14dbe4f$var$$fa53e9c0a1746730$var$imageStyles = (0, $74Zh5.css)({
    height: "auto",
    width: "100%"
});
var $24c02ea0e14dbe4f$var$$9225344cd5d1f99b$exports = {};
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$9225344cd5d1f99b$exports, "LessonHeader", ()=>$24c02ea0e14dbe4f$export$7bee7638d150bc04);
const $24c02ea0e14dbe4f$export$7bee7638d150bc04 = ({ heading: heading, tags: tags, description: description, urlToShare: urlToShare, onListenClick: onListenClick, showListenButton: showListenButton = true })=>(0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
        children: [
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                css: $24c02ea0e14dbe4f$var$$9225344cd5d1f99b$var$headingWrapperStyles,
                children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$a8a3e93435678ff9, {
                    level: 1,
                    children: heading
                })
            }),
            (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                css: $24c02ea0e14dbe4f$var$$9225344cd5d1f99b$var$metadataStyles,
                children: [
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                        css: $24c02ea0e14dbe4f$var$$9225344cd5d1f99b$var$flexContainerStyles,
                        children: tags.map((tag, index)=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                                css: $24c02ea0e14dbe4f$var$$9225344cd5d1f99b$var$tagStyles,
                                children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$3288d34c523a1192, {
                                    ...tag
                                })
                            }, index))
                    }),
                    (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                        css: $24c02ea0e14dbe4f$var$$9225344cd5d1f99b$var$flexContainerStyles,
                        children: [
                            showListenButton && (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("button", {
                                css: $24c02ea0e14dbe4f$var$$9225344cd5d1f99b$var$listenButtonStyles,
                                onClick: ()=>onListenClick && onListenClick(),
                                "data-testid": "listen-button",
                                children: [
                                    (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("svg", {
                                        width: "24",
                                        height: "24",
                                        viewBox: "0 0 24 24",
                                        fill: "none",
                                        xmlns: "http://www.w3.org/2000/svg",
                                        children: [
                                            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("path", {
                                                fillRule: "evenodd",
                                                clipRule: "evenodd",
                                                d: "M8.5 17.3333V13.5C8.5 12.9477 8.05228 12.5 7.5 12.5C6.94772 12.5 6.5 12.9477 6.5 13.5V15.6667C6.5 16.6792 7.32081 17.5 8.33333 17.5C8.42538 17.5 8.5 17.4254 8.5 17.3333ZM7.5 11C6.11929 11 5 12.1193 5 13.5V15.6667C5 17.5076 6.49238 19 8.33333 19C9.25381 19 10 18.2538 10 17.3333V13.5C10 12.1193 8.88071 11 7.5 11Z",
                                                fill: "#44546F"
                                            }),
                                            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("path", {
                                                fillRule: "evenodd",
                                                clipRule: "evenodd",
                                                d: "M15.5 17.3333V13.5C15.5 12.9477 15.9477 12.5 16.5 12.5C17.0523 12.5 17.5 12.9477 17.5 13.5V15.6667C17.5 16.6792 16.6792 17.5 15.6667 17.5C15.5746 17.5 15.5 17.4254 15.5 17.3333ZM16.5 11C17.8807 11 19 12.1193 19 13.5V15.6667C19 17.5076 17.5076 19 15.6667 19C14.7462 19 14 18.2538 14 17.3333V13.5C14 12.1193 15.1193 11 16.5 11Z",
                                                fill: "#44546F"
                                            }),
                                            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("path", {
                                                fillRule: "evenodd",
                                                clipRule: "evenodd",
                                                d: "M12 5.5C8.96243 5.5 6.5 7.96243 6.5 11V14.25H5V11C5 7.13401 8.13401 4 12 4C15.866 4 19 7.13401 19 11V14.25H17.5V11C17.5 7.96243 15.0376 5.5 12 5.5Z",
                                                fill: "#44546F"
                                            })
                                        ]
                                    }),
                                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("span", {
                                        css: $24c02ea0e14dbe4f$var$$9225344cd5d1f99b$var$listenTextWrapperStyles,
                                        children: "Listen"
                                    })
                                ]
                            }),
                            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$477c64ffaba52edf, {
                                urlToShare: urlToShare,
                                alignToLeft: true
                            })
                        ]
                    })
                ]
            }),
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                css: $24c02ea0e14dbe4f$var$$9225344cd5d1f99b$var$lineWrapperStyles,
                children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$2e0a83ec2e27ecbb, {
                    color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.border")
                })
            }),
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                css: $24c02ea0e14dbe4f$var$$9225344cd5d1f99b$var$descriptionStyles,
                children: description
            })
        ]
    });
const $24c02ea0e14dbe4f$var$$9225344cd5d1f99b$var$metadataStyles = (0, $74Zh5.css)({
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between"
});
const $24c02ea0e14dbe4f$var$$9225344cd5d1f99b$var$flexContainerStyles = (0, $74Zh5.css)({
    display: "flex"
});
const $24c02ea0e14dbe4f$var$$9225344cd5d1f99b$var$listenButtonStyles = (0, $74Zh5.css)({
    display: "flex",
    alignItems: "center",
    marginRight: "1.5rem",
    cursor: "pointer",
    padding: 0,
    border: "none",
    background: "transparent"
});
const $24c02ea0e14dbe4f$var$$9225344cd5d1f99b$var$listenTextWrapperStyles = (0, $74Zh5.css)({
    marginLeft: "0.25rem",
    color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text.subtle"),
    fontSize: "16px",
    fontFamily: "Charlie Text, sans-serif"
});
const $24c02ea0e14dbe4f$var$$9225344cd5d1f99b$var$tagStyles = (0, $74Zh5.css)({
    marginRight: "0.5rem"
});
const $24c02ea0e14dbe4f$var$$9225344cd5d1f99b$var$lineWrapperStyles = (0, $74Zh5.css)({
    padding: "1.5rem 0 2.5rem 0"
});
const $24c02ea0e14dbe4f$var$$9225344cd5d1f99b$var$headingWrapperStyles = (0, $74Zh5.css)({
    padding: "5rem 0 1.5rem 0"
});
const $24c02ea0e14dbe4f$var$$9225344cd5d1f99b$var$descriptionStyles = (0, $74Zh5.css)({
    paddingBottom: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.1000"),
    fontFamily: "Inter, sans-serif",
    fontSize: "20px",
    lineHeight: "32px",
    color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text"),
    p: {
        margin: 0
    },
    a: {
        fontSize: "20px",
        lineHeight: "32px"
    },
    ul: {
        paddingLeft: "20px",
        marginTop: 0,
        marginBottom: 0,
        li: {
            marginTop: "16px"
        },
        "li + li": {
            marginTop: "16px !important"
        }
    }
});
var $24c02ea0e14dbe4f$var$$3b9afd8fe4435353$exports = {};
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$3b9afd8fe4435353$exports, "LessonList", ()=>$24c02ea0e14dbe4f$export$962a95c44e73eb25);
const $24c02ea0e14dbe4f$var$$057799a99c9f255f$export$b7cafc9b9fbb48b2 = ({ isCompleted: isCompleted, size: size })=>isCompleted ? (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$f04a61298a47a40f, {
        type: "check-circle-filled",
        size: size,
        color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.icon.success")
    }) : (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$f04a61298a47a40f, {
        type: "check-circle-outline",
        size: size,
        color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.background.accent.gray.subtler.pressed")
    });
const $24c02ea0e14dbe4f$var$$7e5a668c3a5a9ea8$export$2c301aad86da9f9a = ({ sectionTitle: sectionTitle, slug: slug, lessonSlug: lessonSlug, isCompleted: isCompleted, onNavigation: onNavigation })=>{
    const handleKeyDown = (0, $5FkrB.useCallback)((event, onNavigation, slug, lessonSlug)=>{
        if (event.code === "Space") {
            event.preventDefault();
            onNavigation({
                sectionSlug: slug,
                lessonSlug: lessonSlug
            });
        }
    }, []);
    return (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
        css: $24c02ea0e14dbe4f$var$$7e5a668c3a5a9ea8$var$sectionStyles,
        children: [
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$var$$057799a99c9f255f$export$b7cafc9b9fbb48b2, {
                isCompleted: isCompleted,
                size: $24c02ea0e14dbe4f$export$ff775019b5b6e7df.SMALL
            }),
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                css: $24c02ea0e14dbe4f$var$$7e5a668c3a5a9ea8$var$sectionLinkStyles,
                children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("span", {
                    role: "link",
                    tabIndex: 0,
                    onKeyDown: (event)=>handleKeyDown(event, onNavigation, slug, lessonSlug),
                    onClick: ()=>onNavigation({
                            sectionSlug: slug,
                            lessonSlug: lessonSlug
                        }),
                    children: sectionTitle
                })
            })
        ]
    });
};
const $24c02ea0e14dbe4f$var$$7e5a668c3a5a9ea8$var$sectionStyles = (0, $74Zh5.css)({
    display: "flex",
    alignItems: "center",
    marginBottom: "0.75rem"
});
const $24c02ea0e14dbe4f$var$$7e5a668c3a5a9ea8$var$sectionLinkStyles = (0, $74Zh5.css)({
    marginLeft: "11px",
    span: {
        fontFamily: "Inter, sans-serif",
        fontSize: "14px",
        lineHeight: "1.5rem",
        fontWeight: 400,
        color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text")
    },
    ":hover": {
        span: {
            color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text.selected"),
            textDecoration: "none"
        }
    }
});
const $24c02ea0e14dbe4f$var$$fc302bf0bdbf0587$export$e4e5e6361d1b89e2 = ({ lessonTitle: lessonTitle, slug: slug, duration: duration, isCompleted: isCompleted, isCurrentLesson: isCurrentLesson, hasDivider: hasDivider, sections: sections, onNavigation: onNavigation })=>{
    const [isExpanded, setIsExpanded] = (0, $5FkrB.useState)(isCurrentLesson);
    const expandByCard = (event)=>{
        if (event.target === event.currentTarget) setIsExpanded(!isExpanded);
    };
    const expandByButton = ()=>{
        setIsExpanded(!isExpanded);
    };
    (0, $5FkrB.useEffect)(()=>{
        setIsExpanded(isCurrentLesson);
    }, [
        isCurrentLesson
    ]);
    const handleKeyDown = (0, $5FkrB.useCallback)((event, onNavigation, slug)=>{
        if (event.code === "Space") {
            event.preventDefault();
            onNavigation({
                lessonSlug: slug
            });
        }
    }, []);
    return (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("section", {
        // eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex -- Section needs tabIndex for keyboard navigation
        tabIndex: 0,
        "aria-label": `Lesson overview for ${lessonTitle}`,
        css: [
            $24c02ea0e14dbe4f$var$$fc302bf0bdbf0587$var$lessonCardContainerStyles,
            !hasDivider && (0, $74Zh5.css)({
                marginBottom: "16px"
            })
        ],
        children: [
            (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                role: "button",
                tabIndex: 0,
                css: [
                    $24c02ea0e14dbe4f$var$$fc302bf0bdbf0587$var$lessonCardStyles,
                    isCurrentLesson && $24c02ea0e14dbe4f$var$$fc302bf0bdbf0587$var$currentLessonStyles,
                    !isCurrentLesson && $24c02ea0e14dbe4f$var$$fc302bf0bdbf0587$var$hoverLessonStyles
                ],
                onClick: expandByCard,
                onKeyDown: (e)=>{
                    if (e.key === "Enter" || e.key === " ") {
                        e.preventDefault();
                        expandByCard(e);
                    }
                },
                children: [
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("button", {
                        tabIndex: 0,
                        "aria-label": "expand lesson button",
                        css: [
                            $24c02ea0e14dbe4f$var$$fc302bf0bdbf0587$var$expandButtonStyles,
                            !isCurrentLesson && (0, $74Zh5.css)({
                                borderColor: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.background.accent.gray.subtlest.hovered")
                            })
                        ],
                        "data-testid": "expand-button",
                        onClick: expandByButton,
                        children: isExpanded ? (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$f04a61298a47a40f, {
                            type: "chevron-down",
                            size: $24c02ea0e14dbe4f$export$ff775019b5b6e7df.MEDIUM,
                            color: isCurrentLesson ? (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.icon.selected") : (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.icon.subtle")
                        }) : (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$f04a61298a47a40f, {
                            type: "chevron-right",
                            size: $24c02ea0e14dbe4f$export$ff775019b5b6e7df.MEDIUM,
                            color: isCurrentLesson ? (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.icon.selected") : (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.icon.subtle")
                        })
                    }),
                    (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                        css: $24c02ea0e14dbe4f$var$$fc302bf0bdbf0587$var$mainContentColumnStyles,
                        children: [
                            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("p", {
                                css: [
                                    $24c02ea0e14dbe4f$var$$fc302bf0bdbf0587$var$durationStyles,
                                    !isCurrentLesson && (0, $74Zh5.css)({
                                        color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text.subtlest")
                                    })
                                ],
                                children: duration.toUpperCase()
                            }),
                            (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                                css: $24c02ea0e14dbe4f$var$$fc302bf0bdbf0587$var$lessonContainer,
                                children: [
                                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                                        css: $24c02ea0e14dbe4f$var$$fc302bf0bdbf0587$var$lessonTitleStyles,
                                        children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("span", {
                                            role: "button",
                                            tabIndex: 0,
                                            onKeyDown: (event)=>handleKeyDown(event, onNavigation, slug),
                                            onClick: ()=>onNavigation({
                                                    lessonSlug: slug
                                                }),
                                            children: lessonTitle
                                        })
                                    }),
                                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                                        css: (0, $74Zh5.css)({
                                            marginLeft: "1.5rem",
                                            display: "flex"
                                        }),
                                        children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$var$$057799a99c9f255f$export$b7cafc9b9fbb48b2, {
                                            isCompleted: isCompleted,
                                            size: $24c02ea0e14dbe4f$export$ff775019b5b6e7df.MEDIUM
                                        })
                                    })
                                ]
                            }),
                            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                                css: (0, $74Zh5.css)({
                                    marginTop: "0.75rem"
                                }),
                                children: isExpanded && sections.map((section)=>(0, $5FkrB.createElement)($24c02ea0e14dbe4f$var$$7e5a668c3a5a9ea8$export$2c301aad86da9f9a, {
                                        ...section,
                                        lessonSlug: slug,
                                        onNavigation: onNavigation,
                                        key: `section-${section.slug}`
                                    }))
                            })
                        ]
                    })
                ]
            }),
            hasDivider && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                css: (0, $74Zh5.css)({
                    marginTop: "16px",
                    marginBottom: "16px"
                }),
                children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$2e0a83ec2e27ecbb, {
                    height: 2,
                    color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.border")
                })
            })
        ]
    }, slug);
};
const $24c02ea0e14dbe4f$var$$fc302bf0bdbf0587$var$lessonCardContainerStyles = (0, $74Zh5.css)({
    maxWidth: "25.25rem",
    [(0, $cb8cedbc477f5a81$export$987d49ffe1b0900f).below.sm]: {
        maxWidth: "100%",
        paddingRight: "16px"
    }
});
const $24c02ea0e14dbe4f$var$$fc302bf0bdbf0587$var$lessonCardStyles = (0, $74Zh5.css)({
    width: "100%",
    display: "flex",
    padding: "16px",
    borderRadius: "0.25rem",
    cursor: "pointer"
});
const $24c02ea0e14dbe4f$var$$fc302bf0bdbf0587$var$currentLessonStyles = (0, $74Zh5.css)({
    backgroundColor: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.background.selected"),
    borderLeft: `4px solid ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text.brand")}`
});
const $24c02ea0e14dbe4f$var$$fc302bf0bdbf0587$var$hoverLessonStyles = (0, $74Zh5.css)({
    ":hover": {
        backgroundColor: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.background.accent.gray.subtlest")
    },
    ":hover button": {
        borderColor: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.background.accent.gray.subtlest.pressed")
    }
});
const $24c02ea0e14dbe4f$var$$fc302bf0bdbf0587$var$mainContentColumnStyles = (0, $74Zh5.css)({
    width: "100%",
    display: "flex",
    flexDirection: "column",
    marginLeft: "0.75rem"
});
const $24c02ea0e14dbe4f$var$$fc302bf0bdbf0587$var$expandButtonStyles = (0, $74Zh5.css)({
    width: "1.5rem",
    height: "1.5rem",
    padding: 0,
    border: `1px solid ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.background.accent.blue.subtlest.pressed")}`,
    borderRadius: "0.25rem",
    boxSizing: "content-box",
    background: "transparent",
    outline: "none",
    cursor: "pointer",
    ":focus-visible": {
        border: `2px solid ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.border.selected")}`
    }
});
const $24c02ea0e14dbe4f$var$$fc302bf0bdbf0587$var$durationStyles = (0, $74Zh5.css)({
    width: "100%",
    fontSize: "0.75rem",
    fontWeight: 400,
    lineHeight: "1.125rem",
    color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text.selected"),
    marginTop: 0,
    marginBottom: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.075")
});
const $24c02ea0e14dbe4f$var$$fc302bf0bdbf0587$var$lessonContainer = (0, $74Zh5.css)({
    display: "flex",
    alignItems: "center"
});
const $24c02ea0e14dbe4f$var$$fc302bf0bdbf0587$var$lessonTitleStyles = (0, $74Zh5.css)({
    width: "100%",
    fontFamily: "Charlie Display",
    fontSize: "16px",
    fontWeight: 600,
    lineHeight: "1.5rem",
    span: {
        color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text")
    },
    ":hover": {
        span: {
            color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text.selected"),
            textDecoration: "none"
        }
    }
});
const $24c02ea0e14dbe4f$export$962a95c44e73eb25 = ({ lessons: lessons })=>{
    const currentLessonIndx = lessons.findIndex((lesson)=>lesson.isCurrentLesson);
    const updatedLessons = lessons.map((lesson, indx)=>({
            ...lesson,
            hasDivider: !(indx === currentLessonIndx || indx === currentLessonIndx - 1)
        }));
    return updatedLessons.map((lesson)=>(0, $5FkrB.createElement)($24c02ea0e14dbe4f$var$$fc302bf0bdbf0587$export$e4e5e6361d1b89e2, {
            ...lesson,
            key: `lesson-${lesson.slug}`
        }));
};
var $24c02ea0e14dbe4f$var$$050a30fc95775cfd$exports = {};
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$050a30fc95775cfd$exports, "LessonsList", ()=>$24c02ea0e14dbe4f$export$c3b0ae23c563b692);
const $24c02ea0e14dbe4f$export$c3b0ae23c563b692 = ({ lessons: lessons, onLessonClick: onLessonClick, isStandalone: isStandalone = false, isTablet: isTablet = false })=>{
    return (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
        css: [
            $24c02ea0e14dbe4f$var$$050a30fc95775cfd$var$lessonsListStyles,
            isStandalone && $24c02ea0e14dbe4f$var$$050a30fc95775cfd$var$lessonsListStandaloneStyles,
            isTablet && !isStandalone && (0, $74Zh5.css)({
                borderRadius: "0"
            })
        ],
        children: lessons?.map(({ slug: slug, isCompleted: isCompleted, title: title, duration: duration }, index)=>(0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                role: "button",
                "data-testid": `lesson-list-item-${index}`,
                tabIndex: 0,
                css: [
                    $24c02ea0e14dbe4f$var$$050a30fc95775cfd$var$lessonItemStyles,
                    !isStandalone && !isTablet && index === lessons.length - 1 && $24c02ea0e14dbe4f$var$$050a30fc95775cfd$var$lastLessonItemStyles,
                    isTablet && !isStandalone && index === 0 && $24c02ea0e14dbe4f$var$$050a30fc95775cfd$var$firstLessonItemTabletStyles,
                    isTablet && !isStandalone && index === lessons.length - 1 && $24c02ea0e14dbe4f$var$$050a30fc95775cfd$var$lastLessonItemTabletStyles
                ],
                onClick: ()=>onLessonClick(slug),
                onKeyDown: (event)=>{
                    if (event.key === "Enter") onLessonClick(slug);
                },
                children: [
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                        css: $24c02ea0e14dbe4f$var$$050a30fc95775cfd$var$circleContainerStyles,
                        children: isCompleted ? (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$f04a61298a47a40f, {
                            size: "small",
                            type: "check-circle",
                            color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.border.success")
                        }) : (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                            css: $24c02ea0e14dbe4f$var$$050a30fc95775cfd$var$emptyCircleStyles
                        })
                    }),
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("span", {
                        css: [
                            $24c02ea0e14dbe4f$var$$050a30fc95775cfd$var$textStyles,
                            isCompleted && {
                                color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text.success")
                            }
                        ],
                        children: title
                    }),
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                        css: $24c02ea0e14dbe4f$var$$050a30fc95775cfd$var$durationBadgeStyles,
                        children: duration
                    }),
                    isStandalone && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                        css: $24c02ea0e14dbe4f$var$$050a30fc95775cfd$var$chevronContainerStyles,
                        children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$f04a61298a47a40f, {
                            size: "medium",
                            type: "chevron-right",
                            color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text")
                        })
                    })
                ]
            }, slug))
    });
};
const $24c02ea0e14dbe4f$var$$050a30fc95775cfd$var$lessonsListStyles = (0, $74Zh5.css)({
    backgroundColor: "#FFFFFF",
    maxWidth: "100%",
    borderRadius: "0 0 8px 8px",
    overflow: "hidden"
});
const $24c02ea0e14dbe4f$var$$050a30fc95775cfd$var$lessonsListStandaloneStyles = (0, $74Zh5.css)({
    border: `1px solid ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.border")}`,
    borderRadius: "8px"
});
const $24c02ea0e14dbe4f$var$$050a30fc95775cfd$var$lessonItemStyles = (0, $74Zh5.css)({
    display: "flex",
    flexDirection: "row",
    borderTop: `1px solid ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.border")}`,
    padding: `${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.150")} ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.200")}`,
    cursor: "pointer",
    "&:hover": {
        backgroundColor: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.background.accent.gray.subtlest")
    },
    "&:active": {
        backgroundColor: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.background.accent.gray.subtlest.hovered")
    },
    ":first-of-type": {
        borderTop: "none"
    }
});
const $24c02ea0e14dbe4f$var$$050a30fc95775cfd$var$circleContainerStyles = (0, $74Zh5.css)({
    marginTop: "3px"
});
const $24c02ea0e14dbe4f$var$$050a30fc95775cfd$var$emptyCircleStyles = (0, $74Zh5.css)({
    width: "14px",
    height: "14px",
    borderRadius: "50%",
    border: `1.4px solid ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.border")}`,
    padding: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.075"),
    margin: "1px",
    marginTop: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.025")
});
const $24c02ea0e14dbe4f$var$$050a30fc95775cfd$var$textStyles = (0, $74Zh5.css)({
    fontSize: "14px",
    fontWeight: "400",
    lineHeight: "20px",
    fontFamily: "Inter",
    padding: `${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.025")} ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.100")}`,
    color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text")
});
const $24c02ea0e14dbe4f$var$$050a30fc95775cfd$var$durationBadgeStyles = (0, $74Zh5.css)({
    marginTop: "1px",
    padding: `${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.025")} ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.075")}`,
    borderRadius: "8px",
    backgroundColor: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.background.disabled"),
    textTransform: "uppercase",
    fontSize: "12px",
    fontWeight: "400",
    lineHeight: "18px",
    marginLeft: "auto",
    whiteSpace: "nowrap",
    height: "fit-content"
});
const $24c02ea0e14dbe4f$var$$050a30fc95775cfd$var$lastLessonItemStyles = (0, $74Zh5.css)({
    borderRadius: "0 0 8px 8px"
});
const $24c02ea0e14dbe4f$var$$050a30fc95775cfd$var$firstLessonItemTabletStyles = (0, $74Zh5.css)({
    borderTop: `1px solid ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.border")} !important`
});
const $24c02ea0e14dbe4f$var$$050a30fc95775cfd$var$lastLessonItemTabletStyles = (0, $74Zh5.css)({
    borderRadius: "0 !important"
});
const $24c02ea0e14dbe4f$var$$050a30fc95775cfd$var$chevronContainerStyles = (0, $74Zh5.css)({
    display: "none",
    "@media (max-width: 965px)": {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        height: "24px",
        marginLeft: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.050"),
        marginRight: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.negative.100")
    }
});
var $24c02ea0e14dbe4f$var$$65703ff0bcd12648$exports = {};
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$65703ff0bcd12648$exports, "LessonSidebar", ()=>$24c02ea0e14dbe4f$export$c2bf8d11366d1eb0);
const $24c02ea0e14dbe4f$var$$bae5a7f2c1ae6bce$export$7ded8628b71ba75 = ({ progress: progress, pathColor: pathColor, trailColor: trailColor = (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.border"), image: image, title: title, onCourseNavigation: onCourseNavigation })=>{
    const handleClick = (0, $5FkrB.useCallback)(()=>{
        onCourseNavigation && onCourseNavigation();
    }, [
        onCourseNavigation
    ]);
    const handleKeyDown = $24c02ea0e14dbe4f$export$2a0b6757d41dacb2(handleClick);
    return (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
        css: $24c02ea0e14dbe4f$var$$bae5a7f2c1ae6bce$var$progressBadgeContainerStyles,
        children: [
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                css: (0, $74Zh5.css)({
                    maxWidth: "64px",
                    [(0, $cb8cedbc477f5a81$export$987d49ffe1b0900f).above.sm]: {
                        maxWidth: "85px"
                    }
                }),
                "data-testid": "progress-circle",
                children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $f188eff9b59fb855$export$5ab97151efedb8c6), {
                    strokeWidth: 4,
                    value: progress,
                    styles: (0, $f188eff9b59fb855$export$5115a192ad9bf57f)({
                        pathColor: pathColor,
                        trailColor: trailColor
                    }),
                    children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                        css: $24c02ea0e14dbe4f$var$$bae5a7f2c1ae6bce$var$imageBadgeContainerStyles,
                        children: image ? (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("img", {
                            css: $24c02ea0e14dbe4f$var$$bae5a7f2c1ae6bce$var$imageStyles,
                            "data-testid": "badge-image",
                            src: image.src,
                            alt: image.alt
                        }) : (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                            css: [
                                (0, $74Zh5.css)({
                                    backgroundColor: trailColor
                                }),
                                $24c02ea0e14dbe4f$var$$bae5a7f2c1ae6bce$var$innerCircleBackgroundStyles
                            ]
                        })
                    })
                })
            }),
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                    role: "button",
                    tabIndex: 0,
                    onKeyDown: handleKeyDown,
                    css: $24c02ea0e14dbe4f$var$$bae5a7f2c1ae6bce$var$titleStyles,
                    onClick: onCourseNavigation,
                    children: title
                })
            })
        ]
    });
};
const $24c02ea0e14dbe4f$var$$bae5a7f2c1ae6bce$var$progressBadgeContainerStyles = (0, $74Zh5.css)({
    display: "flex",
    alignItems: "center",
    gap: "16px"
});
const $24c02ea0e14dbe4f$var$$bae5a7f2c1ae6bce$var$imageBadgeContainerStyles = (0, $74Zh5.css)({
    width: "100%",
    height: "100%",
    padding: "8px"
});
const $24c02ea0e14dbe4f$var$$bae5a7f2c1ae6bce$var$imageStyles = (0, $74Zh5.css)({
    width: "100%",
    height: "100%",
    objectFit: "contain",
    borderRadius: "50%"
});
const $24c02ea0e14dbe4f$var$$bae5a7f2c1ae6bce$var$innerCircleBackgroundStyles = (0, $74Zh5.css)({
    borderRadius: "9999px",
    width: "100%",
    height: "100%"
});
const $24c02ea0e14dbe4f$var$$bae5a7f2c1ae6bce$var$titleStyles = (0, $74Zh5.css)({
    color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text"),
    fontWeight: 600,
    fontSize: "20px",
    lineHeight: "28px",
    fontFamily: "Charlie Display, sans-serif",
    paddingRight: "16px",
    margin: 0,
    "&:hover": {
        cursor: "pointer",
        color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text.selected")
    }
});
const $24c02ea0e14dbe4f$export$c2bf8d11366d1eb0 = ({ lessons: lessons, progress: progress, pathColor: pathColor, title: title, image: image, isVisible: isVisible, onChangeMenuVisibility: onChangeMenuVisibility, onCourseNavigation: onCourseNavigation })=>(0, $6bec4f26b2cb3094$export$25062201e9e25d76)($24c02ea0e14dbe4f$export$1ba59dacbcbf90fe, {
        isVisible: isVisible,
        onChangeMenuVisibility: onChangeMenuVisibility,
        children: [
            (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                css: (0, $74Zh5.css)({
                    marginLeft: "16px"
                }),
                children: [
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                        css: (0, $74Zh5.css)({
                            marginBottom: "16px",
                            lineHeight: "24px"
                        }),
                        children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("span", {
                            css: [
                                $24c02ea0e14dbe4f$var$$65703ff0bcd12648$var$subheadingStyles,
                                (0, $74Zh5.css)({
                                    marginBottom: "24px",
                                    marginTop: "24px"
                                })
                            ],
                            children: "Current course"
                        })
                    }),
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$var$$bae5a7f2c1ae6bce$export$7ded8628b71ba75, {
                        progress: progress,
                        pathColor: pathColor,
                        title: title,
                        image: image,
                        onCourseNavigation: onCourseNavigation
                    }),
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                        css: (0, $74Zh5.css)({
                            marginBottom: "24px",
                            marginTop: "24px",
                            lineHeight: "24px"
                        }),
                        children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("span", {
                            css: $24c02ea0e14dbe4f$var$$65703ff0bcd12648$var$subheadingStyles,
                            children: "Lessons in this course"
                        })
                    })
                ]
            }),
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$962a95c44e73eb25, {
                lessons: lessons
            })
        ]
    });
const $24c02ea0e14dbe4f$var$$65703ff0bcd12648$var$subheadingStyles = (0, $74Zh5.css)({
    fontFamily: "Charlie Text, sens-serif",
    fontSize: "12px",
    fontWeight: 600,
    lineHeight: "16px",
    textTransform: "uppercase",
    color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text")
});
var $24c02ea0e14dbe4f$var$$8340d81aba797956$exports = {};
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$8340d81aba797956$exports, "LearningOverviewCard", ()=>$24c02ea0e14dbe4f$export$60e8035fadc9b8fc);
var $24c02ea0e14dbe4f$var$$8f97e278a4a2a6b3$require$Buffer = (0, $7KfP5.Buffer);
const $24c02ea0e14dbe4f$var$$8f97e278a4a2a6b3$var$svgStringLearningOverviewCardBackground = `<svg width="1003" height="48" viewBox="0 0 1003 48" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_3622_1083)">
      <g clip-path="url(#clip1_3622_1083)">
        <path
          d="M929.87 -106.601C934.923 -113.047 932.654 -115.022 927.128 -108.989C923.208 -104.711 919.232 -100.29 914.973 -95.4457C910.706 -90.547 906.173 -84.8713 902.441 -77.642C901.929 -76.6053 901.438 -75.6223 900.973 -74.6736C900.581 -73.6929 900.196 -72.7546 899.839 -71.8631C899.493 -70.958 899.113 -70.1306 898.849 -69.2729C898.586 -68.4274 898.343 -67.6109 898.101 -66.8314C897.872 -66.0506 897.619 -65.3092 897.435 -64.5795C897.275 -63.835 897.116 -63.1274 896.97 -62.4309C896.673 -61.0446 896.374 -59.7637 896.241 -58.4844C896.079 -57.2144 895.893 -55.9961 895.769 -54.7717C895.695 -53.5422 895.62 -52.3126 895.538 -51.053C895.481 -50.4216 895.48 -49.7785 895.49 -49.1218C895.494 -48.4596 895.492 -47.7918 895.495 -47.0926C895.45 -45.6992 895.57 -44.2212 895.672 -42.6212C895.734 -40.8087 896.046 -38.9029 896.305 -36.9035C896.407 -35.8974 896.663 -34.8941 896.85 -33.8669C897.074 -32.836 897.222 -31.7755 897.514 -30.7316C897.793 -29.6765 898.071 -28.6091 898.36 -27.5159C898.619 -26.4196 899.039 -25.3563 899.372 -24.2525C899.729 -23.1586 900.067 -22.0357 900.524 -20.944C901.095 -19.4758 901.672 -18.0008 902.248 -16.5135C903.686 -16.151 905.125 -15.7886 906.563 -15.4261L908.148 -15.024L909.749 -14.7069C910.816 -14.4996 911.884 -14.2923 912.945 -14.0795C914.015 -13.9338 915.072 -13.7893 916.13 -13.6449C916.659 -13.5788 917.181 -13.4949 917.698 -13.4424C918.222 -13.4077 918.74 -13.3676 919.258 -13.3274C920.294 -13.2594 921.317 -13.1803 922.328 -13.1147C923.342 -13.1108 924.331 -13.1094 925.302 -13.1037C925.79 -13.0974 926.272 -13.098 926.748 -13.093C927.225 -13.1003 927.69 -13.1458 928.161 -13.1722C930.021 -13.305 931.798 -13.3659 933.424 -13.6525C935.06 -13.8885 936.594 -14.073 937.944 -14.4185C939.298 -14.7325 940.538 -14.9593 941.583 -15.2676C942.622 -15.5827 943.499 -15.8526 944.2 -16.0659C944.814 -16.2634 945.445 -16.4282 946.042 -16.6706L947.817 -17.4307C948.868 -17.8993 950.401 -18.4983 952.174 -19.5183C953.072 -20.0086 954.081 -20.5123 955.126 -21.1299C956.149 -21.7869 957.247 -22.4858 958.427 -23.2319C963.03 -26.3399 968.353 -30.7603 973.46 -36.3963C976.055 -39.2319 978.501 -42.2247 981.093 -45.2956C983.684 -48.3664 986.348 -51.5351 989.05 -54.737C994.763 -61.4435 1000.62 -68.3333 1006.26 -74.9487L1008.09 -77.1133L970.879 -109.453C966.364 -113.375 962.194 -116.953 958.273 -120.283C953.7 -124.143 949.449 -127.723 945.42 -131.125C944.678 -130.223 943.943 -129.327 943.214 -128.436C942.856 -127.996 942.499 -127.568 942.141 -127.128C941.939 -126.87 941.731 -126.619 941.535 -126.367C940.74 -125.372 939.959 -124.387 939.189 -123.414C937.664 -121.465 936.17 -119.557 934.69 -117.66C932.576 -114.943 931.934 -113.128 932.4 -112.592L932.334 -112.332C932.406 -112.276 932.468 -112.282 932.515 -112.357L932.544 -112.466C933.134 -112.084 934.804 -113.003 937.144 -115.524C938.768 -117.296 940.405 -119.078 942.08 -120.893C942.908 -121.811 943.75 -122.74 944.611 -123.686C944.824 -123.918 945.032 -124.157 945.245 -124.389L945.523 -124.676C945.697 -124.85 945.871 -125.036 946.051 -125.216C946.212 -125.057 946.378 -124.892 946.551 -124.732L946.789 -124.498C946.872 -124.415 946.884 -124.389 947.164 -124.144C948.023 -123.364 948.906 -122.57 949.794 -121.768C951.584 -120.164 953.428 -118.511 955.343 -116.801C959.18 -113.387 963.311 -109.751 967.813 -105.818C970.585 -103.409 974.75 -99.5537 980.247 -94.53C983.002 -92.0237 986.097 -89.2169 989.489 -86.1324C991.196 -84.5985 992.985 -82.9942 994.853 -81.3264C996.512 -79.8591 998.231 -78.3239 1000.02 -76.7443C1000.02 -76.7443 1000.02 -76.7443 1000.03 -76.7375C1000.03 -76.7375 1000.03 -76.7375 1000.03 -76.7307L999.428 -75.9942C998.608 -74.9765 997.794 -73.9643 996.986 -72.9576C992.58 -67.3803 987.764 -61.4487 983.029 -55.6945C980.656 -52.8241 978.303 -49.9826 976.04 -47.2557C974.903 -45.8928 973.785 -44.5589 972.7 -43.2526C971.603 -41.9845 970.523 -40.8015 969.48 -39.627C968.467 -38.4309 967.35 -37.4185 966.338 -36.4017C965.308 -35.3929 964.34 -34.4148 963.33 -33.6019C962.344 -32.7618 961.416 -31.9716 960.551 -31.2367C959.658 -30.548 958.798 -29.9486 958.034 -29.383C957.263 -28.8364 956.598 -28.2977 955.964 -27.9044C955.336 -27.5166 954.797 -27.1817 954.347 -26.9119C953.472 -26.3698 952.996 -26.0778 952.996 -26.0778C952.138 -25.5031 951.199 -25.0603 950.283 -24.5781C949.361 -24.1149 948.469 -23.5932 947.518 -23.1762C945.607 -22.393 943.74 -21.4938 941.744 -20.9109C937.842 -19.5255 933.722 -18.7251 929.573 -18.2555L926.433 -17.9804L923.272 -17.9363C922.219 -17.8947 921.159 -17.9652 920.098 -18.0234C919.038 -18.1063 917.98 -18.0961 916.922 -18.2406L913.741 -18.6191C912.682 -18.7389 911.629 -18.9819 910.566 -19.1578C909.51 -19.3392 908.455 -19.5329 907.408 -19.8061L905.406 -20.2877L904.553 -22.4154C904.095 -23.4824 903.763 -24.5862 903.387 -25.6759C902.591 -27.8535 902.063 -30.0843 901.455 -32.3048C900.43 -36.7694 899.847 -41.2944 899.708 -45.799C899.617 -54.5172 901.176 -60.7732 902.66 -65.3605C902.844 -65.9356 903.027 -66.4861 903.204 -67.0187C903.288 -67.2822 903.373 -67.5458 903.458 -67.797C903.56 -68.0402 903.663 -68.2833 903.759 -68.521C904.156 -69.4703 904.519 -70.3427 904.855 -71.156C905.02 -71.5599 905.184 -71.9515 905.335 -72.3196C905.517 -72.6785 905.692 -73.0195 905.86 -73.355C906.196 -74.0137 906.505 -74.6256 906.787 -75.1907C907.6 -76.9267 908.616 -78.4937 909.532 -80.0583C910.413 -81.6513 911.478 -83.0586 912.439 -84.4951C912.938 -85.1991 913.381 -85.9272 913.903 -86.5918C914.425 -87.2563 914.927 -87.9166 915.436 -88.5701C916.442 -89.8783 917.421 -91.1521 918.467 -92.4005C922.553 -97.4041 926.266 -102.05 929.852 -106.622L929.87 -106.601Z"
          fill="#ffffff7d"
        />
        <path
          d="M485.107 17.5435C485.157 17.2393 485.206 16.9473 485.261 16.6622C485.278 16.3733 485.284 16.0955 485.3 15.8312C485.322 15.2892 485.33 14.7951 485.324 14.3368C485.343 13.4171 485.158 12.6498 485.022 12.0299C484.719 10.8054 484.323 10.2085 483.928 10.1932C483.526 10.1834 483.114 10.7415 482.773 11.8449C482.59 12.3954 482.499 13.0914 482.264 13.8777C482.161 14.2755 482.069 14.7115 481.982 15.179C481.941 15.4161 481.901 15.6532 481.853 15.9082C481.782 16.1483 481.716 16.3953 481.65 16.6545C480.974 19.6043 479.725 22.3352 477.739 24.515C475.77 26.7027 473.101 28.343 469.989 29.4622C466.875 30.606 463.32 31.2162 459.494 31.4897C458.544 31.5974 457.566 31.6219 456.576 31.6451C455.585 31.6806 454.581 31.7272 453.55 31.6906C452.518 31.6786 451.48 31.6599 450.417 31.6509C449.33 31.6149 448.225 31.5831 447.114 31.5445C442.635 31.4549 438.7 31.3709 437.402 31.3506C437.461 33.0947 437.517 34.758 437.575 36.3721C437.617 37.335 437.653 38.2665 437.691 39.1611C437.768 40.7708 437.837 42.2685 437.903 43.6732C438.049 46.4837 438.178 48.94 438.299 51.2842C438.542 55.9725 438.747 60.2179 438.871 65.9952C438.989 71.3019 439.109 77.3447 439.271 84.7774C442.605 84.9054 446.043 85.0502 449.524 85.1809C452.302 85.302 455.11 85.42 457.906 85.5368C463.561 85.752 469.165 85.7145 474.329 85.3789C479.492 85.0555 484.21 84.4395 488.08 83.7004C491.949 82.9612 494.97 82.1111 496.811 81.5433C498.187 81.1511 499.514 80.6115 500.851 80.0978C502.029 79.5802 503.702 78.8717 505.73 77.7972C506.747 77.2757 507.825 76.6181 509.009 75.928C510.159 75.1726 511.403 74.3834 512.642 73.4081C515.149 71.5039 517.788 69.0935 520.199 66.06C522.609 63.0388 524.767 59.3919 526.368 55.2742C528 51.1658 529.033 46.5883 529.51 41.8369C530 37.0745 529.928 32.156 529.432 27.1513C528.49 17.1591 524.835 6.82357 518.805 -1.52006C514.549 -7.40132 509.649 -11.8944 504.902 -15.2832C503.698 -16.0981 502.525 -16.8914 501.381 -17.6631C500.204 -18.3579 499.057 -19.0433 497.946 -19.7004C496.828 -20.3396 495.706 -20.8803 494.635 -21.4406C494.295 -21.6111 493.962 -21.7871 493.629 -21.9632C493.405 -22.0664 493.158 -22.2337 492.914 -22.3079L492.13 -22.3319C491.5 -22.3463 490.882 -22.3719 490.271 -22.3906C481.737 -22.6506 475.456 -22.8365 471.146 -22.9647C466.13 -23.0903 461.424 -23.2092 457.699 -23.3088L457.377 -18.1211C464.071 -16.6871 469.734 -13.9351 473.851 -9.95455C477.937 -5.97092 480.524 -1.00134 481.726 4.27301C482.155 6.19688 482.534 7.6642 482.859 8.65586C483.208 9.65003 483.595 10.1718 483.947 10.1889C484.305 10.2005 484.622 9.70074 484.85 8.64766C485.091 7.59583 485.137 5.9862 484.816 3.85057C483.934 -1.98513 481.344 -7.93852 476.726 -12.8297C472.089 -17.7166 465.53 -21.0977 458.111 -22.7969L457.845 -18.5252C461.574 -18.3941 466.279 -18.2259 471.299 -18.0566C475.257 -17.9332 481.351 -17.5745 489.372 -17.144C489.878 -17.1174 490.384 -17.0907 490.902 -17.0629L491.679 -17.0211C491.864 -17.0147 491.79 -17.0099 491.827 -17.0061L491.876 -17.0011C491.876 -17.0011 491.906 -16.9672 492.051 -16.8906C492.287 -16.7615 492.523 -16.6324 492.759 -16.5033C493.23 -16.2451 493.715 -15.9857 494.198 -15.7139C495.186 -15.2117 496.131 -14.5776 497.12 -13.97C497.614 -13.6601 498.115 -13.3556 498.622 -13.0444C499.109 -12.7043 499.602 -12.3574 500.095 -12.0104C504.076 -9.24363 508.128 -5.80154 511.761 -1.4742C512.991 -0.0999016 514.024 1.40902 515.133 2.87617L516.629 5.17427C517.149 5.92597 517.586 6.72498 518.024 7.52399C519.044 9.21093 519.835 11.0478 520.681 12.8965C521.038 13.8482 521.389 14.8054 521.745 15.7694C521.936 16.2465 522.095 16.7389 522.224 17.2344L522.652 18.7191C523.758 22.6971 524.486 26.8472 524.689 30.9872C525.268 39.2601 524.188 47.3027 521.595 53.596C520.323 56.7513 518.723 59.4651 517.055 61.7143C515.399 63.977 513.604 65.6937 512.1 67.0998C511.301 67.7547 510.62 68.3784 509.964 68.8499C509.314 69.3283 508.747 69.7347 508.295 70.066C507.343 70.6745 506.828 71.012 506.828 71.012C504.563 72.4459 502.168 73.7183 499.652 74.7619C498.417 75.3293 497.12 75.7605 495.839 76.249C494.529 76.6666 493.237 77.1292 491.9 77.476C486.584 78.9529 481.067 79.9146 475.469 80.435C469.87 80.9678 464.194 81.1277 458.498 81.0197C455.668 80.9799 452.748 80.8629 449.876 80.7879L443.466 80.595L443.003 62.5921L442.312 36.3457L447.253 36.4884C448.371 36.5214 449.476 36.5532 450.557 36.5825C451.664 36.5896 452.764 36.6023 453.845 36.607C454.926 36.6362 455.999 36.5657 457.058 36.5186C458.117 36.4714 459.157 36.4409 460.183 36.3038C464.297 35.9358 468.223 35.1838 471.806 33.7413C475.381 32.329 478.615 30.1893 480.927 27.3127C483.263 24.4509 484.572 20.9901 485.113 17.5626L485.107 17.5435Z"
          fill="#ffffff7d"
        />
        <path
          d="M628.636 -23.6993C627.184 -18.8428 627.285 -16.1605 628.042 -15.9228C628.842 -15.6623 630.281 -17.7738 631.962 -22.3165C632.638 -23.887 633.321 -25.4753 634.004 -27.076C634.766 -28.6378 635.601 -30.1674 636.401 -31.7501C636.774 -32.5596 637.297 -33.2735 637.749 -34.0441C638.219 -34.8067 638.689 -35.5693 639.159 -36.3442C640.136 -37.8656 641.277 -39.3024 642.347 -40.8329C646.985 -46.6464 652.943 -52.2209 660.978 -56.2732C662.164 -56.858 663.294 -57.4299 664.388 -57.8632C664.934 -58.086 665.445 -58.3372 665.959 -58.5077C666.505 -58.7059 667.026 -58.8943 667.522 -59.0729C671.346 -60.2248 674.355 -60.9339 676.118 -61.4106C673.934 -63.5064 671.794 -65.474 669.883 -67.2824C669.186 -67.9284 668.512 -68.5472 667.857 -69.158C667.344 -69.6307 666.85 -70.0829 666.361 -70.5284C664.423 -72.3023 662.67 -73.9028 660.971 -75.4546C657.579 -78.5637 654.391 -81.516 650.316 -85.4491C645.637 -89.9197 640.194 -95.1915 634.538 -100.708C631.719 -103.468 628.828 -106.285 625.968 -109.08C625.255 -109.784 624.535 -110.481 623.827 -111.178L622.162 -112.794L621.685 -113.251L621.448 -113.485L621.329 -113.596C621.329 -113.596 621.229 -113.582 621.179 -113.574L619.975 -113.307L618.771 -113.039L618.209 -112.911L617.847 -112.812L616.408 -112.413C615.469 -112.125 614.541 -111.799 613.625 -111.483C609.996 -110.12 606.696 -108.327 603.832 -106.317C603.47 -106.075 603.114 -105.827 602.751 -105.585C602.413 -105.316 602.075 -105.06 601.742 -104.797C601.078 -104.271 600.433 -103.761 599.794 -103.257C598.6 -102.165 597.433 -101.133 596.389 -100.089C592.2 -95.9121 589.715 -91.9583 588.256 -89.8302C587.419 -88.5482 586.726 -87.1773 585.979 -85.8305C585.374 -84.7971 584.726 -83.2857 583.896 -81.44C583.006 -79.6129 582.202 -77.3255 581.25 -74.7439C580.735 -73.4664 580.356 -72.0451 579.906 -70.5753C579.47 -69.1166 579.012 -67.5796 578.533 -65.9768C578.075 -64.4398 577.589 -62.8438 577.095 -61.1806C576.51 -59.5576 575.868 -57.8971 575.223 -56.175C572.497 -49.3508 568.288 -42.2319 562.402 -35.9698C559.408 -32.8965 555.985 -30.0708 552.167 -27.712C550.27 -26.5128 548.238 -25.4944 546.165 -24.5358L544.574 -23.8869L543.682 -23.5322L542.028 -22.9949C539.834 -22.265 537.606 -21.6005 535.378 -20.9482C537.479 -18.9228 542.769 -13.8396 547.946 -8.84843C558.695 1.42159 567.391 9.73274 574.278 16.3139C577.724 19.6017 580.706 22.4589 583.266 24.8959C584.545 26.1206 585.724 27.2423 586.789 28.2596C587.504 28.9383 588.182 29.5886 588.831 30.2049C589.29 30.6411 589.73 31.0693 590.165 31.4784C590.225 31.5092 590.263 31.6306 590.333 31.5821L590.528 31.5214L590.916 31.4C591.173 31.3209 591.423 31.2473 591.68 31.1682C592.268 30.9929 592.863 30.812 593.445 30.6299C593.795 30.5294 593.902 30.4845 594.078 30.4158L594.574 30.2373C595.233 29.9887 595.903 29.7784 596.534 29.4836C597.169 29.2079 597.793 28.931 598.422 28.6609C599.028 28.3513 599.628 28.0472 600.221 27.7487C600.826 27.4637 601.379 27.1053 601.948 26.7797C602.506 26.4404 603.075 26.1271 603.615 25.7675C604.143 25.4066 604.671 25.0458 605.193 24.6782C605.714 24.3228 606.23 23.9608 606.71 23.558C610.661 20.5014 613.893 17.0563 616.604 13.478C621.912 6.22945 625.281 -1.35211 627.641 -9.08543C629.982 -17.7176 627.486 -18.3668 624.653 -10.2731C621.847 -2.97477 618.23 4.03719 613.054 10.6126C610.418 13.8522 607.349 16.9427 603.702 19.6652C603.261 20.0225 602.791 20.3458 602.302 20.6612C601.825 20.9777 601.342 21.2998 600.853 21.6275C600.364 21.9428 599.84 22.2174 599.332 22.5247C598.814 22.8184 598.312 23.1325 597.77 23.3867C597.228 23.6533 596.691 23.9266 596.149 24.1932C595.582 24.4326 595.022 24.6789 594.456 24.9183C593.895 25.1768 593.294 25.3632 592.71 25.5823L591.926 25.8676L591.619 25.9541C591.538 25.9767 591.456 26.0117 591.375 26.0221C591.322 25.961 591.262 25.9055 591.197 25.8431C591.138 25.7753 591.072 25.713 591.001 25.6439C590.763 25.4095 590.525 25.175 590.269 24.9326C589.277 23.9473 588.177 22.8646 586.976 21.6788C584.593 19.3031 581.8 16.5207 578.639 13.367C572.304 7.05828 564.428 -0.749007 555.093 -9.75596C553.569 -11.2219 552.04 -12.6822 550.497 -14.1192C549.722 -14.8411 548.954 -15.5562 548.185 -16.2713L547.023 -17.3356L546.438 -17.865L546.152 -18.1291L546.093 -18.1969L546.08 -18.1858C545.995 -18.2192 545.856 -18.289 545.699 -18.4038C545.738 -18.4371 545.802 -18.4924 545.891 -18.5453L545.967 -18.587L545.999 -18.6147C546.055 -18.6276 545.923 -18.5853 546.124 -18.6638L547.66 -19.3245C549.706 -20.224 551.69 -21.272 553.622 -22.4058C557.474 -24.6993 561.024 -27.4687 564.189 -30.5123C570.569 -36.582 575.119 -43.8643 578.252 -50.5296C578.645 -51.368 579.024 -52.1831 579.397 -52.9927C579.782 -53.7886 580.044 -54.6218 580.367 -55.4117C580.671 -56.2096 580.968 -56.9774 581.259 -57.7396C581.549 -58.4895 581.839 -59.2271 582.048 -59.9666C582.944 -62.857 583.728 -65.4 584.382 -67.5108C584.702 -68.5361 584.98 -69.4542 585.229 -70.2516C585.472 -71.0558 585.691 -71.7325 585.911 -72.2669C586.326 -73.3505 586.553 -73.9274 586.553 -73.9274C586.553 -73.9274 586.913 -74.8805 587.564 -76.5958C587.883 -77.4541 588.4 -78.447 588.93 -79.6302C589.472 -80.7999 590.059 -82.1629 590.87 -83.5528C591.663 -84.9629 592.457 -86.5524 593.54 -88.094C594.06 -88.8762 594.582 -89.7077 595.141 -90.5355C595.755 -91.3268 596.369 -92.1428 597.015 -92.9741C599.646 -96.2451 602.871 -99.5547 606.768 -102.326C607.258 -102.666 607.748 -103.018 608.238 -103.358C608.746 -103.69 609.277 -103.983 609.791 -104.296C610.813 -104.953 611.929 -105.476 613.021 -106.04C613.565 -106.331 614.148 -106.538 614.715 -106.789C615.281 -107.041 615.854 -107.274 616.443 -107.474C617.032 -107.674 617.605 -107.919 618.211 -108.074L619.106 -108.335L619.556 -108.463L619.693 -108.499L619.768 -108.516L620.049 -108.58C620.049 -108.58 620.15 -108.619 620.186 -108.591L620.287 -108.5L621.186 -107.636C622.186 -106.681 623.185 -105.726 624.185 -104.771C626.179 -102.867 628.149 -100.979 630.09 -99.1241C637.845 -91.7125 645.023 -84.8481 650.362 -79.7354L660.058 -70.4692L664.909 -65.8388L666.201 -64.6006L666.528 -64.289L666.688 -64.1304L666.765 -64.0422C666.765 -64.0422 666.868 -63.9885 666.806 -63.9824C666.538 -63.9169 666.275 -63.8569 666.012 -63.7723C665.881 -63.73 665.75 -63.7 665.624 -63.6509L664.364 -63.2159C662.387 -62.495 660.461 -61.6636 658.599 -60.7207C649.837 -56.2783 643.471 -50.1019 638.705 -43.7384C637.605 -42.0749 636.447 -40.4915 635.471 -38.8401C634.998 -38.0036 634.537 -37.1659 634.071 -36.3472C633.629 -35.5137 633.115 -34.7247 632.758 -33.8579C631.991 -32.1606 631.199 -30.4904 630.488 -28.8183C629.869 -27.1061 629.256 -25.4116 628.649 -23.7227L628.636 -23.6993Z"
          fill="#ffffff7d"
        />
        <path
          d="M802.514 -15.3488C802.255 -15.1958 802.007 -15.0415 801.766 -14.8928C801.549 -14.7169 801.338 -14.5466 801.127 -14.3886C800.718 -14.059 800.353 -13.7435 800.025 -13.4366C799.347 -12.8622 798.925 -12.2246 798.577 -11.7341C797.906 -10.726 797.767 -10.0473 798.052 -9.74631C798.336 -9.44528 799.049 -9.50277 800.095 -9.96575C801.122 -10.4491 802.552 -11.2442 804.398 -12.2444C807.021 -13.6544 809.918 -14.5046 812.946 -14.4571C815.968 -14.4287 819.104 -13.5352 822.187 -11.9667C825.284 -10.4215 828.323 -8.208 831.307 -5.57939C832.074 -4.95732 832.799 -4.24042 833.549 -3.53337C834.3 -2.82631 835.056 -2.12481 835.791 -1.34509C836.533 -0.583212 837.281 0.197792 838.04 0.980018C838.811 1.80046 839.581 2.63321 840.369 3.474C843.542 6.79592 846.33 9.71378 847.249 10.6669C848.471 9.50436 849.642 8.37379 850.774 7.30107C851.45 6.64598 852.094 6.01856 852.712 5.41328C853.832 4.31467 854.857 3.29906 855.829 2.34008C857.762 0.420855 859.456 -1.25662 861.061 -2.85659C864.282 -6.05529 867.225 -8.94207 871.324 -12.7568C875.09 -16.259 879.375 -20.2465 884.651 -25.148C882.323 -27.679 879.919 -30.2858 877.485 -32.9266C875.549 -35.0343 873.595 -37.1748 871.641 -39.3029C867.678 -43.5833 863.565 -47.6625 859.562 -51.2419C855.558 -54.8213 851.676 -57.875 848.315 -60.2386C844.955 -62.6023 842.135 -64.2555 840.376 -65.2443C839.082 -65.9817 837.73 -66.6323 836.371 -67.2651C833.928 -68.3171 829.349 -70.353 822.893 -71.5648C819.678 -72.1633 815.995 -72.5248 812.042 -72.3075C808.089 -72.1025 803.883 -71.3108 799.735 -69.8205C795.57 -68.3505 791.529 -66.1318 787.746 -63.4108C783.945 -60.6977 780.444 -57.4717 777.195 -53.88C770.655 -46.7565 765.856 -37.4398 764.192 -27.6812C763.028 -20.7913 763.322 -14.3287 764.311 -8.68015C764.594 -7.27211 764.866 -5.90225 765.14 -4.56938C765.488 -3.25365 765.832 -1.98167 766.159 -0.742359C766.511 0.487134 766.934 1.65575 767.302 2.80025C767.423 3.15895 767.539 3.51087 767.654 3.87511C767.737 4.10009 767.806 4.38541 767.92 4.61967L768.477 5.20816C768.928 5.68685 769.367 6.15197 769.793 6.61584C775.826 13.0424 780.259 17.7725 783.306 21.0136C786.845 24.7562 790.171 28.2668 792.804 31.0452L796.812 27.9635C792.968 22.1179 790.866 16.1831 790.764 10.6122C790.693 5.05057 792.433 -0.0427144 795.383 -4.31432C796.459 -5.86269 797.251 -7.08128 797.725 -7.95475C798.188 -8.84177 798.288 -9.47491 798.039 -9.73523C797.797 -10.0134 797.199 -9.92557 796.276 -9.41314C795.334 -8.90874 794.131 -7.90512 792.817 -6.30657C789.226 -1.90838 786.78 3.80608 786.583 10.3363C786.404 16.8746 788.698 23.8804 792.878 30.4219L796.178 27.8806C793.571 25.0801 790.284 21.5362 786.776 17.7659C783.985 14.792 779.805 10.0814 774.28 3.91675C773.937 3.52322 773.582 3.14077 773.227 2.74599C773.05 2.54245 772.878 2.34568 772.695 2.14767L772.63 2.07304L772.618 2.05946L772.6 2.03911L772.571 1.99286C772.56 1.95465 772.567 1.94911 772.518 1.78949C772.441 1.53434 772.365 1.2792 772.289 1.02406C772.137 0.513761 771.972 -0.0101045 771.808 -0.533968C771.455 -1.5842 771.234 -2.67674 770.945 -3.79464C770.807 -4.35297 770.663 -4.91808 770.525 -5.48873C770.419 -6.06241 770.313 -6.64842 770.207 -7.23442C769.321 -11.9262 768.883 -17.1107 769.375 -22.5409C769.472 -24.3248 769.82 -26.0523 770.071 -27.802C770.242 -28.663 770.468 -29.5122 770.651 -30.3719C770.755 -30.7943 770.822 -31.2329 770.95 -31.6528L771.335 -32.9003C771.471 -33.3504 771.606 -33.8006 771.749 -34.2562L771.962 -34.9397L772.224 -35.6059C772.582 -36.4974 772.933 -37.3957 773.292 -38.2995C774.16 -40.036 774.986 -41.8201 776.062 -43.4861C778.128 -46.8639 780.613 -50.0569 783.448 -52.8742C789.006 -58.6378 795.609 -63.0458 802.047 -65.2314C805.252 -66.3473 808.392 -66.944 811.234 -67.1876C814.082 -67.4243 816.641 -67.2573 818.754 -67.0615C819.804 -66.8992 820.758 -66.7838 821.581 -66.6385C822.402 -66.4685 823.107 -66.3166 823.677 -66.203C824.816 -65.9266 825.433 -65.7464 825.433 -65.7464C828.131 -65.0335 830.795 -64.0889 833.388 -62.9289C835.995 -61.8046 838.531 -60.4647 841.007 -59.0135C845.958 -56.074 850.673 -52.6574 855.132 -48.8895C859.598 -45.1271 863.848 -41.0711 867.917 -36.8233C869.947 -34.7246 871.99 -32.507 874.023 -30.3522L878.557 -25.5191L865.83 -13.5742L847.266 3.86467L843.846 0.220832C840.742 -3.12502 837.56 -6.39212 834.303 -9.15357C831.04 -11.9341 827.625 -14.3342 823.966 -16.0355C820.332 -17.7465 816.415 -18.7378 812.637 -18.577C808.86 -18.4407 805.395 -17.1595 802.52 -15.342L802.514 -15.3488Z"
          fill="#ffffff7d"
        />
        <path
          d="M896.677 56.1783C892.472 50.562 890.102 52.1214 893.806 58.0641C895.803 61.2605 897.854 64.5057 900.088 67.9488C901.212 69.6648 902.371 71.4339 903.575 73.2819C904.187 74.2037 904.811 75.1392 905.446 76.1005C906.384 77.5009 907.347 78.9283 908.332 80.3953C911.16 80.1752 914.652 79.9049 918.331 79.6164C932.903 78.2748 936.445 77.3663 946.338 76.6075C950.283 76.2781 954.866 75.9453 959.665 75.6159C965.171 75.2469 970.917 74.8714 976.416 74.5079C976.371 72.4312 976.331 70.3736 976.289 68.3653C976.274 67.0586 976.264 65.7834 976.24 64.5439C976.211 62.0606 976.188 59.7265 976.168 57.6153C976.136 53.3874 976.104 50.0627 976.097 48.2497C976.089 47.2344 976.062 46.2112 976.011 45.1854C975.941 43.7247 975.824 41.2696 975.624 37.068C975.434 32.4407 975.156 25.8808 974.762 16.5443C973.11 15.8322 970.49 14.7066 967.178 13.2881C964.633 12.1823 961.564 10.8503 958.168 9.37371C951.382 6.40262 943.322 2.83217 935.648 -0.631174L920.59 -7.28702L908.681 15.5899C902.014 28.4344 897.278 38.1719 892.865 47.868C890.442 53.195 892.708 54.4827 895.67 49.4639C901.067 40.3317 906.334 30.8955 913.044 18.0739C914.017 16.1995 915.482 13.6143 917.4 10.2338C918.352 8.54299 919.419 6.64715 920.598 4.55866C921.185 3.50486 921.798 2.40427 922.445 1.25138C922.605 0.958381 922.771 0.672173 922.931 0.379174L923.158 -0.0307828L923.19 -0.0584499C923.229 -0.0916589 923.261 -0.119349 923.287 -0.141488C923.328 -0.0939942 923.37 -0.0588179 923.393 -0.031678C923.411 -0.011323 923.369 -0.0341659 923.447 0.00475372C923.636 0.0918888 923.83 0.185811 924.036 0.280978C924.431 0.463279 924.843 0.653604 925.268 0.857508C926.961 1.62938 928.843 2.48842 930.798 3.37956C933.366 4.53711 935.962 5.63551 938.548 6.65879C943.946 8.79622 949.698 11.1738 955.309 13.5432C960.426 15.7326 965.434 17.8738 969.858 19.7702C969.896 20.677 969.934 21.5592 969.968 22.3977C970.02 23.708 970.068 24.9623 970.113 26.1483C970.196 28.5133 970.271 30.6117 970.325 32.349C970.431 35.8235 970.496 37.8836 970.496 37.8836L971.644 70.2257L943.162 72.5864C928.788 73.781 921.87 74.3593 917.621 74.7136C916.076 74.8475 914.562 74.9783 913.141 75.1001C912.433 75.1644 911.745 75.2244 911.087 75.2813C910.882 75.3038 910.689 75.3275 910.509 75.3525C908 71.8258 905.724 68.6321 903.589 65.6259C901.183 62.2952 898.91 59.1945 896.652 56.1758L896.677 56.1783Z"
          fill="#ffffff7d"
        />
        <path
          d="M597.353 122.644C597.321 122.504 597.289 122.377 597.257 122.251C597.244 122.119 597.225 121.994 597.217 121.869C597.19 121.619 597.145 121.373 597.13 121.137C597.142 120.674 597.08 120.228 597.152 119.834C597.166 119.631 597.174 119.434 597.188 119.244C597.226 119.056 597.252 118.879 597.284 118.709C597.309 118.532 597.335 118.368 597.36 118.203C597.403 118.047 597.44 117.896 597.477 117.758C597.581 117.168 597.711 116.711 597.738 116.355C597.759 115.992 597.695 115.726 597.534 115.592C597.372 115.458 597.126 115.446 596.773 115.595C596.421 115.745 595.946 116.025 595.478 116.584C595.361 116.72 595.232 116.868 595.101 117.028C594.983 117.201 594.877 117.388 594.763 117.593C594.65 117.798 594.536 118.016 594.409 118.244C594.325 118.495 594.234 118.752 594.142 119.021C593.929 119.562 593.872 120.194 593.777 120.871C593.751 121.214 593.773 121.563 593.777 121.928C593.782 122.114 593.793 122.295 593.804 122.488C593.833 122.676 593.863 122.865 593.892 123.053C594.23 125.234 595.114 127.216 596.16 129.023C597.211 130.85 598.507 132.441 599.847 134.006C600.54 134.763 601.226 135.537 601.969 136.25C602.694 136.991 603.45 137.693 604.214 138.389C606.437 140.427 606.357 139.961 606.372 140.365L606.178 140.568L606.075 140.656L606.036 140.714L605.816 140.964C605.166 141.727 604.511 142.495 603.849 143.269C602.53 144.824 601.174 146.412 599.79 148.047C597.036 151.318 594.151 154.761 591.092 158.39C591.039 158.459 590.987 158.528 590.935 158.597C590.893 158.704 590.821 158.647 590.749 158.603L590.647 158.537L590.593 158.501L590.436 158.386C589.963 158.022 589.507 157.667 589.058 157.318C587.267 155.881 585.586 154.492 584.085 153.232C581.089 150.744 578.706 148.523 576.579 146.378C574.459 144.226 572.571 142.148 570.769 139.794C568.966 137.44 567.199 134.818 565.521 131.524C562.672 126.008 560.589 118.832 561.413 111.629C561.8 108.05 562.864 104.515 564.515 101.318C566.136 98.0866 568.312 95.2209 570.74 92.6593C573.15 90.1019 575.761 87.9422 578.437 86.2963C581.107 84.6437 583.83 83.5037 586.402 82.7565C591.556 81.2879 595.987 81.181 598.452 81.0971L600.716 81.0547C601.478 81.0269 602.303 80.9683 603.053 80.9146C604.356 80.8117 606.189 80.7257 608.761 80.4177C610.041 80.2631 611.534 80.0435 613.228 79.603C614.909 79.149 616.873 78.4514 618.766 77.0539C619.721 76.3715 620.591 75.5134 621.386 74.5055C622.193 73.4988 622.881 72.2388 623.361 70.7906C623.792 69.3127 623.914 67.6613 623.715 66.0144C623.472 64.3815 622.937 62.7994 622.218 61.3039C620.749 58.3528 618.641 55.7513 616.232 53.2677C615.021 52.0314 613.715 50.8289 612.342 49.6379C611.762 49.14 611.17 48.6408 610.573 48.1224L610.369 47.9657C610.369 47.9657 610.416 47.89 610.436 47.8487L610.482 47.773L610.521 47.7398C610.599 47.6241 610.684 47.5152 610.775 47.4007C611.634 46.3621 612.616 45.1567 613.715 43.8271C615.919 41.1622 618.572 37.9553 621.498 34.4174C622.727 32.9401 624.007 31.3938 625.333 29.8089C625.422 29.5891 625.576 29.7655 625.738 29.8748C626.158 30.2019 626.583 30.5357 627.002 30.8752C627.517 31.2985 628.032 31.7218 628.546 32.1452C629.586 33.0301 630.626 33.915 631.678 34.8134C632.686 35.726 633.732 36.5931 634.714 37.5401C636.729 39.3775 638.622 41.3325 640.459 43.3003C645.38 48.6552 649.092 54.0792 651.459 59.2862C653.851 64.4957 654.862 69.4353 654.88 73.7235C654.892 75.8649 654.675 77.847 654.323 79.6607C653.941 81.4651 653.442 83.0968 652.881 84.5677C651.724 87.4934 650.34 89.759 649.124 91.5222C647.674 93.5955 646.045 95.5022 644.343 97.1975C642.666 98.92 640.881 100.39 639.03 101.668C635.34 104.226 631.36 105.869 627.289 106.841C625.265 107.354 623.199 107.676 621.149 107.925C619.098 108.187 617.04 108.3 614.925 108.475C612.828 108.658 610.774 108.827 608.673 109.096C606.585 109.367 604.46 109.764 602.383 110.511C600.137 111.335 598.693 112.617 597.997 113.623C597.631 114.118 597.458 114.564 597.377 114.896C597.301 115.235 597.335 115.455 597.46 115.585L597.512 115.98C597.512 115.98 597.581 115.956 597.564 115.911L597.502 115.62L597.525 115.647C597.676 115.743 597.911 115.754 598.223 115.675C598.529 115.588 598.908 115.404 599.386 115.193C600.338 114.739 601.633 114.085 603.535 113.523C607.106 112.519 611.21 112.552 615.366 112.373C619.512 112.287 623.989 112.141 628.498 111.183C633.018 110.262 637.627 108.515 641.847 105.69C643.957 104.284 645.989 102.659 647.859 100.771C649.752 98.9093 651.542 96.8519 653.182 94.5195C654.443 92.7053 655.981 90.3192 657.364 87.1505C658.723 83.9916 659.911 80.0051 660.141 75.2657C660.376 70.5454 659.595 65.1096 657.494 59.5894C655.399 54.0636 652.045 48.509 647.728 43.203C644.913 39.7504 641.795 36.5825 638.53 33.709C637.82 33.0617 637.079 32.4421 636.337 31.8226C635.59 31.1962 634.849 30.5643 634.106 29.9694C632.622 28.7549 631.102 27.512 629.495 26.285L627.85 25.0666C627.117 24.5468 626.382 24.064 625.654 23.5757L624.552 22.8515L624.414 22.7571C624.414 22.7571 624.372 22.7096 624.347 22.7194L624.289 22.7692L624.088 23.0147L623.679 23.4866C623.134 24.1117 622.583 24.7423 622.055 25.4124C620.76 27.0067 619.471 28.6077 618.182 30.1965C615.865 33.054 613.555 35.8936 611.31 38.6533C608.565 41.9869 605.898 45.2419 603.342 48.3411C604.974 49.7252 606.582 51.0945 608.154 52.4355C609.17 53.2932 610.065 54.0892 610.977 54.9178C612.759 56.5646 614.335 58.2585 615.621 59.9415C616.907 61.6245 617.87 63.3243 618.363 64.8836C618.862 66.4497 618.875 67.8302 618.525 68.9884C618.181 70.1412 617.474 71.0962 616.739 71.8504C616.004 72.5923 615.273 73.0933 614.621 73.4539C614.292 73.6309 613.978 73.7598 613.725 73.895C613.449 74.003 613.21 74.0901 613.022 74.1576C612.639 74.2981 612.427 74.3508 612.427 74.3508C612.427 74.3508 611.579 74.6668 609.824 74.9587C608.074 75.2574 605.4 75.4871 601.98 75.6718C600.33 75.8013 598.451 75.7838 596.367 75.9311C594.302 76.0864 592.087 76.276 589.776 76.7156C587.47 77.1496 585.078 77.7542 582.68 78.6366C580.293 79.5449 577.933 80.7279 575.674 82.1563C573.397 83.5767 571.322 85.333 569.336 87.2035C568.858 87.687 568.369 88.1693 567.892 88.6528C567.408 89.1418 566.979 89.6673 566.519 90.1835C565.606 91.198 564.733 92.2847 563.915 93.4077C560.623 97.892 558.255 103.218 557.363 108.744C556.428 114.259 557.006 119.823 558.369 124.637C559.73 129.476 561.814 133.597 563.8 136.922C566.849 141.92 570.097 145.843 573.095 149.055C576.105 152.267 578.87 154.824 581.332 156.942C583.751 159.025 585.795 160.778 587.707 162.253C588.445 162.816 589.25 163.405 589.984 163.888C590.358 164.136 590.719 164.371 591.08 164.605C591.261 164.723 591.442 164.84 591.617 164.951L591.882 165.126C591.935 165.187 591.957 165.096 591.989 165.069L592.086 164.961C592.604 164.383 593.102 163.846 593.576 163.294C594.044 162.735 594.492 162.193 594.921 161.68C597.951 158.016 600.812 154.559 603.531 151.259C604.884 149.603 606.205 147.986 607.499 146.405C608.144 145.61 608.781 144.834 609.413 144.05C609.894 143.456 610.375 142.874 610.856 142.292C611.408 141.649 611.811 141.028 612.269 140.406L612.603 139.939L612.773 139.709L612.812 139.651C612.812 139.651 612.777 139.611 612.759 139.603L612.639 139.504L611.681 138.726C611.053 138.223 610.43 137.715 609.72 137.247C609.045 136.795 608.197 136.22 607.987 136.057C607.807 135.927 607.663 135.813 607.49 135.666L606.94 135.19C606.199 134.558 605.47 133.939 604.786 133.282C604.076 132.647 603.423 131.975 602.77 131.315C600.231 128.657 598.02 125.705 597.34 122.642L597.353 122.644Z"
          fill="#ffffff7d"
        />
        <path
          d="M905.025 104.617C908.268 104.859 910.596 104.322 912.04 103.776C913.485 103.218 914.096 102.63 913.988 102.248C913.875 101.834 913.048 101.633 911.568 101.532C910.088 101.432 907.949 101.437 905.199 101.09C901.301 100.546 897.6 98.8219 894.302 96.1306C890.979 93.4615 888.092 90.1067 886.444 86.0736C885.591 84.0759 885.092 81.9036 884.855 79.659C884.811 79.3762 884.81 79.0916 884.791 78.8113L884.765 78.3819C884.753 78.2137 884.742 78.1755 884.744 77.8293L884.721 76.1259L884.719 75.699L884.715 75.4883L884.714 75.383C884.714 75.383 884.66 75.3342 884.63 75.3126L883.93 74.7405C882.703 73.7315 881.458 72.7146 880.202 71.684C876.043 68.2867 871.686 64.7148 867.066 60.9429C856.534 52.4702 849.863 47.284 844.067 42.7681C841.173 40.5013 838.494 38.4047 835.636 36.1662C834.216 35.0387 832.755 33.8637 831.198 32.6293C829.498 31.2445 827.702 29.7881 825.745 28.1977C825.123 27.6892 824.488 27.1794 823.86 26.6641C823.543 26.4031 823.219 26.1476 822.902 25.8866L822.417 25.4971C822.26 25.3947 822.069 25.0968 822.006 25.4122C821.299 26.8311 820.573 28.2789 819.833 29.7502C819.557 30.3098 819.268 30.8681 818.986 31.4332C818.751 31.8856 818.534 32.3461 818.317 32.8189C817.877 33.7577 817.437 34.7089 816.996 35.6723C816.089 37.5967 815.284 39.6241 814.409 41.6632C813.632 43.7491 812.757 45.8252 812.043 48.0104C809.022 56.6477 806.809 66.0723 806.012 75.2136C805.771 77.4901 805.691 79.7582 805.607 81.9703C805.61 84.1911 805.553 86.3687 805.702 88.4868C805.864 92.7217 806.395 96.6971 807.016 100.273C808.309 107.431 810.225 112.92 811.332 115.958C812.064 117.727 812.733 119.527 813.615 121.25C815.072 124.354 818.013 130.052 823.031 136.821C827.985 143.621 835.198 151.311 844.23 158.5C848.74 162.081 853.705 165.603 859.117 168.75C864.529 171.885 870.381 174.712 876.587 176.734C882.775 178.759 889.26 180.148 895.734 180.582C902.208 181.041 908.645 180.711 914.787 179.757C923.446 178.304 930.974 175.938 937.461 173.318C943.967 170.694 949.526 167.937 954.295 165.291C959.059 162.639 963.103 160.191 966.488 157.981C968.177 156.878 969.745 155.88 971.126 154.913C972.385 154.051 973.587 153.227 974.726 152.446C975.311 152.047 975.883 151.648 976.443 151.272C976.723 151.077 976.99 150.894 977.263 150.705L977.365 150.641L977.41 150.603C977.41 150.603 977.386 150.576 977.374 150.562L977.177 150.4L976.782 150.075C970.586 145.073 964.791 140.39 959.289 135.941C954.569 132.184 950.114 128.627 945.831 125.217C937.241 118.42 929.312 112.24 921.415 106.175C917.23 102.954 914.707 101.746 914.2 102.195L913.841 102.66C913.927 102.669 913.953 102.634 913.926 102.551L914.115 102.304C913.794 102.902 915.515 105.137 919.53 108.588C927.094 115.083 934.763 121.583 943.177 128.603C947.401 132.1 951.791 135.737 956.439 139.592C960.436 142.868 964.655 146.321 969.155 150.006C969.179 150.033 969.252 150.065 969.232 150.094L969.118 150.169C969.041 150.223 968.959 150.271 968.882 150.325C968.724 150.426 968.559 150.533 968.375 150.644C967.752 151.051 967.091 151.492 966.405 151.941C965.67 152.399 964.908 152.878 964.109 153.378C963.31 153.879 962.473 154.388 961.61 154.931C960.73 155.442 959.817 155.98 958.867 156.539C956.991 157.672 954.913 158.766 952.724 159.979C948.308 162.308 943.298 164.781 937.627 167.1C931.95 169.413 925.605 171.565 918.574 173.109C913.99 174.085 909.349 174.789 904.705 175.128C899.688 175.491 894.42 175.333 889.129 174.53C883.844 173.734 878.535 172.305 873.465 170.324C863.295 166.354 854.154 160.317 846.718 154.33C843.019 151.319 839.715 148.337 836.93 145.512C836.209 144.826 835.584 144.095 834.931 143.422C834.297 142.733 833.655 142.099 833.101 141.437C831.986 140.105 830.883 138.942 830.009 137.783C828.172 135.531 826.851 133.64 825.932 132.353C825.464 131.712 825.157 131.192 824.924 130.846C824.703 130.502 824.58 130.323 824.58 130.323C824.58 130.323 824.406 130.058 824.074 129.548C823.736 129.043 823.247 128.301 822.669 127.302C822.097 126.31 821.329 125.131 820.59 123.677C820.205 122.964 819.797 122.199 819.366 121.382C818.973 120.556 818.557 119.679 818.113 118.756C816.414 115.064 814.643 110.554 813.269 105.417C811.882 100.291 810.891 94.537 810.529 88.5129C810.162 82.482 810.418 76.1866 811.288 69.9782C812.158 63.7699 813.624 57.653 815.434 51.9049C817.238 46.1501 819.429 40.7747 821.671 35.9489C821.95 35.34 822.221 34.749 822.492 34.158C822.755 33.6342 823.011 33.1159 823.267 32.5975C823.341 32.4504 823.415 32.3033 823.489 32.1562L823.597 31.9321L823.65 31.8262C823.65 31.8262 823.717 31.8639 823.741 31.8787C825.04 32.9321 826.255 33.9276 827.38 34.8335C848.06 51.6349 858.015 59.715 864.132 64.678C868.772 68.4209 873.16 71.9652 877.333 75.339C878.195 76.0327 879.058 76.714 879.896 77.3929L880.01 77.4849C880.039 77.5188 880.024 77.5914 880.028 77.6352L880.046 77.9648L880.114 78.8809C880.149 79.2186 880.154 79.5592 880.209 79.8926C880.539 82.5796 881.21 85.2332 882.305 87.6638C883.393 90.0999 884.804 92.34 886.476 94.2724C888.134 96.2159 889.983 97.8881 891.927 99.3472C893.878 100.801 895.972 102.059 898.199 102.953C900.419 103.852 902.739 104.416 905.025 104.617Z"
          fill="#ffffff7d"
        />
        <path
          d="M750.918 46.3522C758.573 45.1128 758.048 42.2019 750.288 42.8307C744.785 43.2804 739.151 43.7848 733.048 44.4087C730.025 44.6895 726.768 45.1259 723.389 45.6428C721.713 45.9736 719.993 46.3063 718.229 46.653C716.491 47.1076 714.704 47.5695 712.867 48.051C704.656 50.6382 699.911 53.2864 696.03 55.8305C695.542 56.1458 695.048 56.4297 694.589 56.7666C694.13 57.1036 693.684 57.4294 693.232 57.7608C692.779 58.0922 692.333 58.418 691.881 58.7494C691.422 59.074 690.976 59.4122 690.546 59.7953C689.669 60.529 688.754 61.2836 687.788 62.0824C686.875 62.9423 685.905 63.852 684.851 64.846C681.414 68.3136 677.817 72.8473 674.903 78.0873C674.182 79.3997 673.527 80.762 672.822 82.1193L671.901 84.2464L671.143 86.0189L670.767 86.9146L670.671 87.14C670.637 87.2169 670.752 87.2719 670.787 87.3373L671.117 87.7172C673.189 90.148 673.774 90.9743 674.941 92.2247C675.48 92.8052 676.025 93.3924 676.558 93.9661L677.364 94.8272L678.215 95.6373C682.663 100.01 687.456 103.478 691.623 105.93C693.74 107.085 695.626 108.154 697.297 108.862C698.123 109.243 698.869 109.585 699.537 109.887C700.213 110.148 700.803 110.375 701.296 110.567C702.473 110.989 703.633 111.485 704.839 111.786C705.916 112.056 707.431 112.507 709.355 112.95C711.288 113.301 713.602 113.869 716.25 114.138C721.545 114.843 728.159 115.205 735.372 114.644C738.976 114.348 742.752 113.939 746.495 113.441C750.273 112.971 754.175 112.489 758.128 111.999C766.026 111.025 774.134 110.061 781.929 109.176L790.783 108.101L783.832 68.3848C782.917 63.2076 782.054 58.4253 781.215 53.9548C780.206 48.6567 779.256 43.7234 778.358 39.0427C777.183 39.2018 776.013 39.3677 774.857 39.5225C774.285 39.6005 773.725 39.6798 773.16 39.7522L772.158 39.9042C770.883 40.1025 769.638 40.2979 768.4 40.4877C765.929 40.8864 763.533 41.2802 761.131 41.6673C757.912 42.2004 756.344 43.068 756.371 43.7574L756.162 43.8785C756.178 43.9604 756.232 43.9968 756.313 43.9865L756.401 43.9336C756.615 44.6048 758.421 45.054 761.689 44.8105C764.121 44.612 766.559 44.4202 769.065 44.2168C770.318 44.109 771.578 43.9956 772.862 43.8848L773.799 43.8005L774.196 43.7789C774.444 43.7669 774.692 43.755 774.946 43.7375C774.986 44.1188 775.032 44.507 775.072 44.9007C775.222 45.9118 775.385 46.9365 775.54 47.9791C775.876 50.079 776.214 52.2473 776.568 54.4852C777.295 58.9692 778.096 63.7575 778.999 68.9335C779.54 72.0563 780.214 76.7884 781.124 83.0166C781.591 86.1319 782.111 89.6175 782.684 93.4612C782.99 95.3849 783.297 97.4016 783.627 99.4947C783.8 100.545 783.967 101.614 784.139 102.714L784.174 102.921L784.194 103.022C784.194 103.022 784.194 103.022 784.2 103.029L784.188 103.04L784.175 103.051C784.156 103.043 784.138 103.035 784.145 103.03L781.976 103.286L779.639 103.593C778.085 103.806 776.53 104.032 774.993 104.278C768.347 105.323 761.182 106.353 754.181 107.312C747.181 108.247 740.314 109.257 734.418 109.667C732.925 109.732 731.488 109.796 730.119 109.861C728.746 109.883 727.424 109.835 726.182 109.827C725.558 109.819 724.952 109.807 724.371 109.798C723.792 109.751 723.225 109.706 722.683 109.663C721.598 109.578 720.593 109.507 719.687 109.434C717.878 109.225 716.441 108.98 715.451 108.849C714.467 108.724 713.94 108.597 713.94 108.597C713.94 108.597 713.149 108.436 711.726 108.143C711.016 107.972 710.136 107.864 709.147 107.566C708.156 107.292 707.019 106.979 705.772 106.63C704.533 106.238 703.205 105.732 701.766 105.24C700.341 104.699 698.861 104.005 697.293 103.338C696.53 102.939 695.755 102.539 694.955 102.124C694.562 101.917 694.156 101.709 693.75 101.5C693.345 101.28 692.966 101.025 692.561 100.792C691.765 100.303 690.956 99.8127 690.129 99.3144C689.342 98.7582 688.542 98.2008 687.731 97.6298C684.548 95.2904 681.374 92.6116 678.556 89.5299C677.819 88.7994 677.14 88.0068 676.468 87.2087L676.019 86.6931C675.99 86.6345 675.9 86.582 675.902 86.5204L675.984 86.3308C676.272 85.6425 676.553 84.9597 676.834 84.2769C677.253 83.404 677.677 82.5379 678.096 81.6773C681.496 74.8288 686.134 69.4791 689.985 66.0103C690.674 65.3195 691.439 64.7539 692.155 64.1709C692.877 63.607 693.538 63.0123 694.25 62.5279C694.956 62.0367 695.643 61.5744 696.305 61.1097C696.635 60.8835 696.96 60.6628 697.278 60.4353C697.602 60.2269 697.937 60.0445 698.266 59.8552C698.912 59.4754 699.539 59.1123 700.141 58.7589C700.736 58.3988 701.319 58.062 701.917 57.7949C703.091 57.2213 704.169 56.6937 705.173 56.1955C706.216 55.7695 707.166 55.3772 708.059 55.0101C708.945 54.6486 709.751 54.2974 710.546 54.0626C712.1 53.5523 713.403 53.1156 714.525 52.7408C716.263 52.2739 717.957 51.8211 719.607 51.3824C721.285 51.0269 722.919 50.6855 724.521 50.3472C727.753 49.7907 730.809 49.2906 733.861 48.889C739.924 48.0384 745.498 47.1939 750.919 46.3153L750.918 46.3522Z"
          fill="#ffffff7d"
        />
        <path
          d="M737.982 -30.5396C732.593 -21.759 735.084 -20.0835 740.952 -28.4568C749.352 -40.2903 758.232 -52.6566 770.032 -68.2584C772.641 -71.7481 774.923 -74.8132 775.687 -75.8304C774.881 -77.2978 774.104 -78.7065 773.355 -80.069C772.865 -80.9414 772.399 -81.7866 771.937 -82.6005C771.02 -84.2213 770.178 -85.7294 769.382 -87.1339C767.784 -89.9496 766.388 -92.417 765.049 -94.7672C762.377 -99.4733 759.978 -103.75 756.841 -109.622C754.559 -113.881 752.054 -118.576 748.766 -124.711C746.283 -121.568 743.683 -118.287 741.024 -114.933C739.035 -112.394 737 -109.793 734.96 -107.198C730.902 -101.981 726.88 -96.7112 723.186 -91.7852C715.782 -81.9413 709.725 -73.4883 707.149 -69.8716C706.263 -68.6192 705.384 -67.3601 704.534 -66.0671C701.497 -61.4703 693.327 -49.0876 683.61 -33.1569C673.857 -17.2423 662.64 2.27826 652.745 20.6217L648.111 29.3675L703.445 35.6948L705.577 31.7609C716.267 12.1249 724.631 -2.31629 732.934 -16.4668C737.533 -24.208 735.393 -25.7118 730.256 -18.2788C720.982 -4.71547 712.04 9.48774 701.254 29.2067C701.107 29.4763 700.947 29.7693 700.574 30.4365C696.645 29.8955 690.711 29.0892 683.012 28.0357C678.849 27.4833 674.212 26.8642 669.126 26.1934C666.586 25.8675 663.935 25.5304 661.173 25.182C659.899 25.0219 658.595 24.8647 657.266 24.6928C657.254 24.6792 657.249 24.6724 657.249 24.6601C657.249 24.6601 657.268 24.6435 657.281 24.6324C657.3 24.6158 657.307 24.598 657.314 24.5801L658.634 22.0606C659.587 20.2151 660.54 18.3697 661.48 16.5352C669.558 0.629919 679.733 -17.1593 688.132 -30.7743C692.323 -37.592 696.033 -43.3885 698.697 -47.4849C701.385 -51.5665 702.973 -53.9723 702.973 -53.9723C710.404 -65.23 718.082 -76.3204 725.964 -87.254C729.908 -92.7174 733.912 -98.1376 737.97 -103.509L744.095 -111.547L748.245 -116.89L755.104 -104.151L769.991 -76.5323L766.066 -71.3824C754.237 -55.6723 745.682 -42.9328 737.982 -30.5396Z"
          fill="#ffffff7d"
        />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_3622_1083">
        <rect width="1003" height="48" fill="white" />
      </clipPath>
      <clipPath id="clip1_3622_1083">
        <rect
          width="3757.37"
          height="4501.65"
          fill="white"
          transform="matrix(0.17533 -0.151453 0.135277 0.155367 247.785 7.06543)"
        />
      </clipPath>
    </defs>
  </svg>`;
const $24c02ea0e14dbe4f$var$$8f97e278a4a2a6b3$export$cdb81064101cb20c = `data:image/svg+xml;base64,${$24c02ea0e14dbe4f$var$$8f97e278a4a2a6b3$require$Buffer.from($24c02ea0e14dbe4f$var$$8f97e278a4a2a6b3$var$svgStringLearningOverviewCardBackground).toString("base64")}`;
const $24c02ea0e14dbe4f$var$$0fd79bc510e2fa30$export$b7c3a2f69225ecf = ({ ...props })=>{
    return (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
        css: $24c02ea0e14dbe4f$var$$0fd79bc510e2fa30$var$defaultButtonStyles,
        children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $123ba5aab151a241$export$2e2bcd8739ae039), {
            appearance: "default",
            ...props
        })
    });
};
const $24c02ea0e14dbe4f$var$$0fd79bc510e2fa30$var$defaultButtonStyles = (0, $74Zh5.css)({
    "& button": {
        borderRadius: "4px",
        border: `1px solid ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.border")}`,
        backgroundColor: `transparent`
    }
});
const $24c02ea0e14dbe4f$var$$7586a58445419b5a$export$2c3faa04d4773275 = ({ lessons: lessons, onLessonClick: onLessonClick, expandButtonText: expandButtonText = "Show lessons", collapseButtonText: collapseButtonText = "Hide lessons", containerStyles: customContainerStyles, buttonContainerStyles: customButtonContainerStyles })=>{
    const [isOpened, setIsOpened] = (0, $5FkrB.useState)(false);
    const deviceSize = $24c02ea0e14dbe4f$export$4616d33c54ae5baf();
    const isTablet = deviceSize <= $24c02ea0e14dbe4f$export$62d1d6124a8e4649;
    const toggleLessons = ()=>{
        setIsOpened(!isOpened);
    };
    return (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
        css: [
            $24c02ea0e14dbe4f$var$$7586a58445419b5a$var$wrapperStyles,
            customContainerStyles
        ],
        children: [
            !isTablet && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                css: [
                    $24c02ea0e14dbe4f$var$$7586a58445419b5a$var$buttonContainerStyles,
                    isOpened && $24c02ea0e14dbe4f$var$$7586a58445419b5a$var$buttonContainerOpenStyles,
                    !isOpened && $24c02ea0e14dbe4f$var$$7586a58445419b5a$var$buttonContainerClosedStyles,
                    customButtonContainerStyles
                ],
                children: (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("button", {
                    css: $24c02ea0e14dbe4f$var$$7586a58445419b5a$var$toggleButtonStyles,
                    onClick: toggleLessons,
                    "data-testid": "toggle-lessons-button",
                    children: [
                        isOpened ? collapseButtonText : expandButtonText,
                        (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$f04a61298a47a40f, {
                            size: "large",
                            type: isOpened ? "chevron-up" : "chevron-down",
                            color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text.brand")
                        })
                    ]
                })
            }),
            isOpened && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                css: $24c02ea0e14dbe4f$var$$7586a58445419b5a$var$lessonsContentWrapperStyles,
                children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$c3b0ae23c563b692, {
                    lessons: lessons,
                    onLessonClick: onLessonClick,
                    isStandalone: false,
                    isTablet: isTablet
                })
            }),
            isTablet && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                css: [
                    $24c02ea0e14dbe4f$var$$7586a58445419b5a$var$buttonContainerStyles,
                    isOpened && $24c02ea0e14dbe4f$var$$7586a58445419b5a$var$buttonContainerOpenStyles,
                    !isOpened && $24c02ea0e14dbe4f$var$$7586a58445419b5a$var$buttonContainerClosedStyles,
                    $24c02ea0e14dbe4f$var$$7586a58445419b5a$var$buttonContainerMobileStyles,
                    customButtonContainerStyles
                ],
                children: (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("button", {
                    css: [
                        $24c02ea0e14dbe4f$var$$7586a58445419b5a$var$toggleButtonStyles,
                        $24c02ea0e14dbe4f$var$$7586a58445419b5a$var$toggleButtonMobileStyles
                    ],
                    onClick: toggleLessons,
                    "data-testid": "toggle-lessons-button-mobile",
                    children: [
                        isOpened ? collapseButtonText : expandButtonText,
                        (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$f04a61298a47a40f, {
                            size: "large",
                            type: isOpened ? "chevron-up" : "chevron-down",
                            color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text.brand")
                        })
                    ]
                })
            })
        ]
    });
};
const $24c02ea0e14dbe4f$var$$7586a58445419b5a$var$wrapperStyles = (0, $74Zh5.css)({
    overflow: "hidden",
    maxWidth: "100%"
});
const $24c02ea0e14dbe4f$var$$7586a58445419b5a$var$buttonContainerStyles = (0, $74Zh5.css)({
    display: "flex",
    alignItems: "center",
    gap: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.200"),
    alignSelf: "stretch",
    padding: `${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.150")} ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.300")}`,
    borderTop: `1px solid ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.border")}`
});
const $24c02ea0e14dbe4f$var$$7586a58445419b5a$var$toggleButtonStyles = (0, $74Zh5.css)({
    color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text.brand"),
    fontFamily: "Charlie Text",
    fontSize: "16px",
    fontStyle: "normal",
    fontWeight: 600,
    background: "none",
    border: "none",
    cursor: "pointer",
    padding: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.0"),
    display: "flex",
    alignItems: "center",
    gap: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.050"),
    "&:hover": {
        textDecoration: "underline",
        textUnderlineOffset: "4px"
    }
});
const $24c02ea0e14dbe4f$var$$7586a58445419b5a$var$toggleButtonMobileStyles = (0, $74Zh5.css)({
    color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text.brand"),
    textAlign: "center",
    fontFamily: "Charlie Text",
    fontSize: "14px",
    fontStyle: "normal",
    fontWeight: 600,
    lineHeight: "20px"
});
const $24c02ea0e14dbe4f$var$$7586a58445419b5a$var$buttonContainerOpenStyles = (0, $74Zh5.css)({
    borderBottom: `1px solid ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.border")}`
});
const $24c02ea0e14dbe4f$var$$7586a58445419b5a$var$lessonsContentWrapperStyles = (0, $74Zh5.css)({
    overflow: "hidden",
    backgroundColor: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.background.neutral")
});
const $24c02ea0e14dbe4f$var$$7586a58445419b5a$var$buttonContainerClosedStyles = (0, $74Zh5.css)({
    justifyContent: "space-between"
});
const $24c02ea0e14dbe4f$var$$7586a58445419b5a$var$buttonContainerMobileStyles = (0, $74Zh5.css)({
    padding: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.150"),
    justifyContent: "space-between",
    [(0, $cb8cedbc477f5a81$export$987d49ffe1b0900f).below.md]: {
        borderTop: `1px solid ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.border")}`
    }
});
const $24c02ea0e14dbe4f$var$$bde17c0708419ffe$var$CompletedIcon = ()=>{
    return (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("path", {
                d: "M15.8203 7.04186L15.8028 7.03662L6.61914 16.5773L6.62525 16.5939L21.6161 21.8224L15.8203 7.04186Z",
                fill: "#1868DB"
            }),
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M5.31618 3.19751L10.3213 7.04536L5.25684 6.23896L5.28564 4.75358L5.31618 3.19751Z",
                fill: "#FCA700"
            }),
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("path", {
                d: "M14.6344 9.49606H12.8924L11.1836 4.41504H12.9256L14.6344 9.49606Z",
                fill: "#BF63F3"
            }),
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("path", {
                d: "M9.40688 15.4488L9.37982 15.3764C9.22448 14.9662 8.95742 14.6153 8.60659 14.3631C8.24877 14.1057 7.82811 13.9695 7.39001 13.9695C6.9519 13.9695 6.53211 14.1057 6.17342 14.3631C5.82259 14.6153 5.55553 14.9662 5.40019 15.3764L5.37313 15.4488H3.82666L3.85808 15.3118C4.04397 14.5054 4.49255 13.774 5.12179 13.253C5.43684 12.9921 5.78855 12.7896 6.16644 12.6491C6.5583 12.5042 6.96935 12.4309 7.38913 12.4309C7.80891 12.4309 8.21997 12.5042 8.61182 12.6491C8.99059 12.7887 9.34142 12.9921 9.65648 13.253C10.2857 13.774 10.7352 14.5054 10.9202 15.3118L10.9516 15.4488H9.40513H9.40688Z",
                fill: "#1868DB"
            }),
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("path", {
                d: "M6.51602 10.2929C6.56926 10.2475 6.62075 10.1943 6.66962 10.1349C6.71849 10.0756 6.76126 10.0127 6.79617 9.94989C7.00126 9.58073 6.94017 9.19935 6.66787 8.89215C6.62162 8.83978 6.56926 8.78916 6.51078 8.74204C6.45231 8.69491 6.38773 8.64953 6.32402 8.61287C5.96707 8.40866 5.5822 8.42436 5.26278 8.69666C5.20867 8.74291 5.15631 8.79615 5.10657 8.85724C5.05769 8.91746 5.0158 8.97855 4.98177 9.03964C4.77755 9.40618 4.83951 9.78669 5.11093 10.0965C5.15893 10.1515 5.21304 10.2039 5.27413 10.2536C5.33522 10.3033 5.39195 10.3426 5.45304 10.3775C5.80911 10.5835 6.19486 10.5678 6.51515 10.2929H6.51602Z",
                fill: "#BF63F3"
            }),
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("path", {
                d: "M13.6186 12.9931C13.6718 12.9477 13.7233 12.8945 13.7722 12.8351C13.821 12.7758 13.8638 12.7129 13.8987 12.6501C14.1038 12.2809 14.0427 11.8995 13.7704 11.5923C13.7242 11.54 13.6718 11.4894 13.6133 11.4422C13.5548 11.3951 13.4903 11.3497 13.4266 11.3131C13.0696 11.1089 12.6847 11.1246 12.3653 11.3969C12.3112 11.4431 12.2589 11.4963 12.2091 11.5574C12.1594 11.6185 12.1183 11.6787 12.0843 11.7398C11.8801 12.1064 11.942 12.4869 12.2135 12.7967C12.2615 12.8517 12.3156 12.9041 12.3767 12.9538C12.4378 13.0035 12.4945 13.0428 12.5556 13.0777C12.9117 13.2837 13.2974 13.268 13.6177 12.9931H13.6186Z",
                fill: "#292A2E"
            }),
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("path", {
                d: "M9.3788 15.3765L9.40586 15.449H10.9523L10.9209 15.3119C10.7446 14.5439 10.3283 13.844 9.74535 13.3291L8.68848 14.4279C8.99829 14.674 9.23655 14.9995 9.3788 15.3765Z",
                fill: "#292A2E"
            }),
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("path", {
                d: "M14.6342 9.4961L14.3235 8.57275L13.4351 9.4961H14.6342Z",
                fill: "#292A2E"
            }),
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("path", {
                d: "M9.68084 8.91065L8.87305 10.5713L10.5337 11.3791L11.3415 9.71844L9.68084 8.91065Z",
                fill: "#FCA700"
            }),
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("path", {
                d: "M2.55684 10.4918C2.52717 10.4718 2.49924 10.4726 2.48004 10.4752C2.46084 10.4787 2.45037 10.4883 2.44601 10.5014C2.43728 10.5285 2.45561 10.5599 2.49051 10.5896C2.54113 10.6323 2.57255 10.6934 2.59786 10.7763C2.62491 10.8592 2.63888 10.9605 2.69648 11.0818C2.72964 11.1499 2.77764 11.2014 2.8239 11.2345C2.8719 11.2686 2.91641 11.2834 2.95742 11.2947C3.03946 11.3148 3.12062 11.3104 3.2175 11.2764C3.37982 11.2153 3.52557 11.0539 3.66346 11.0259C3.72804 11.0111 3.79001 11.0294 3.83277 11.0565C3.87291 11.0835 3.89648 11.1115 3.90608 11.1324C3.91306 11.1438 3.92004 11.1542 3.92702 11.1673C3.94011 11.1883 3.96106 11.2336 3.98462 11.3052C4.00993 11.3759 4.03088 11.4763 4.09982 11.5897C4.13473 11.6464 4.19059 11.6997 4.25691 11.7355C4.32324 11.7686 4.3983 11.787 4.47771 11.7843C4.55713 11.7782 4.62957 11.7486 4.68979 11.7136C4.75088 11.6787 4.80062 11.6395 4.8495 11.6046C4.9839 11.4998 5.07815 11.4675 5.15582 11.492C5.23611 11.512 5.27539 11.5548 5.29808 11.5897C5.35393 11.6744 5.3775 11.7878 5.41851 11.8908C5.45517 11.9938 5.52324 12.1029 5.6271 12.1552C5.6847 12.1823 5.72048 12.1666 5.72746 12.1456C5.73531 12.1221 5.71873 12.0924 5.68295 12.0662C5.61924 12.0147 5.58433 11.9406 5.55815 11.8437C5.52848 11.7494 5.51626 11.6307 5.43335 11.499C5.40281 11.4501 5.33561 11.3646 5.21255 11.3253C5.15321 11.3035 5.07466 11.2965 4.99524 11.3139C4.91495 11.3314 4.84426 11.3742 4.77968 11.4178C4.73691 11.4475 4.70026 11.478 4.66535 11.5077C4.62782 11.54 4.58942 11.567 4.55015 11.588C4.51088 11.6054 4.47161 11.6176 4.43146 11.6142C4.41139 11.6142 4.39044 11.608 4.37037 11.6037C4.35204 11.5941 4.33022 11.5915 4.31539 11.5784C4.28048 11.56 4.25779 11.5286 4.2351 11.4981C4.19495 11.4318 4.17575 11.355 4.15917 11.3017C4.14346 11.2467 4.13299 11.2127 4.13299 11.2127C4.13299 11.2127 4.12862 11.2005 4.12164 11.1778C4.11204 11.1542 4.1007 11.1211 4.07801 11.08C4.05706 11.039 4.02215 10.9902 3.97066 10.9491C3.9183 10.9072 3.85197 10.8802 3.77953 10.8671C3.70448 10.8566 3.62331 10.8697 3.55611 10.9003C3.48717 10.9299 3.43306 10.971 3.38157 11.0076C3.28208 11.0844 3.19655 11.1411 3.13197 11.156C3.03684 11.176 2.95917 11.1411 2.91902 11.1088C2.87801 11.0739 2.85706 11.0382 2.84222 11.0094C2.79859 10.9212 2.77677 10.8191 2.74011 10.7266C2.70433 10.6341 2.64499 10.5416 2.55684 10.4927V10.4918Z",
                fill: "#292A2E"
            }),
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("path", {
                d: "M8.03289 2.23406C8.01543 2.20352 7.99012 2.19043 7.97267 2.18432C7.95434 2.17908 7.9395 2.18257 7.93078 2.19217C7.9107 2.21224 7.91245 2.2489 7.93078 2.29079C7.95609 2.35188 7.95609 2.42083 7.94125 2.50635C7.92729 2.59275 7.89412 2.68875 7.88976 2.82315C7.88801 2.89821 7.90721 2.96715 7.93339 3.01777C7.96045 3.07014 7.99361 3.1033 8.02503 3.1321C8.08961 3.18708 8.16292 3.22112 8.26416 3.23421C8.43609 3.25341 8.63943 3.17574 8.77558 3.21414C8.84016 3.23072 8.88641 3.27523 8.9126 3.31886C8.93616 3.36163 8.94401 3.39654 8.94314 3.4201C8.94401 3.43319 8.94576 3.44628 8.94576 3.46024C8.94838 3.48468 8.94576 3.5353 8.93354 3.60948C8.92394 3.68454 8.89601 3.78315 8.90649 3.91494C8.91172 3.98126 8.9379 4.0537 8.97979 4.11566C9.0243 4.17588 9.0819 4.22563 9.15434 4.25966C9.22852 4.29021 9.3062 4.29719 9.37514 4.2937C9.44583 4.29021 9.5078 4.27799 9.56714 4.27014C9.73383 4.23872 9.83332 4.25268 9.89092 4.31028C9.95376 4.36439 9.9686 4.42024 9.97296 4.46214C9.9843 4.5625 9.95376 4.67421 9.94329 4.78504C9.92932 4.89326 9.9398 5.02155 10.0087 5.11581C10.0471 5.16555 10.0873 5.16904 10.1021 5.15246C10.1196 5.13501 10.1187 5.10097 10.0986 5.0617C10.0646 4.98664 10.0681 4.90461 10.089 4.80686C10.1056 4.70912 10.1493 4.59828 10.1353 4.44294C10.1309 4.38621 10.11 4.27886 10.0183 4.1881C9.97558 4.14184 9.90838 4.09995 9.82983 4.07901C9.75041 4.05806 9.66838 4.0633 9.58983 4.07377C9.53834 4.08075 9.49121 4.09123 9.4467 4.1017C9.3987 4.11304 9.35245 4.12003 9.30794 4.1209C9.26518 4.11828 9.22503 4.1113 9.19012 4.09035C9.17267 4.08075 9.15696 4.06592 9.14125 4.05283C9.1299 4.03624 9.1107 4.02315 9.10372 4.00483C9.08103 3.97254 9.07492 3.93414 9.06881 3.89661C9.06358 3.81894 9.08016 3.74214 9.09063 3.68715C9.10198 3.6313 9.10809 3.59552 9.10809 3.59552C9.10809 3.59552 9.10983 3.58243 9.11332 3.55886C9.11507 3.53355 9.12118 3.49952 9.11943 3.45239C9.11943 3.40614 9.1107 3.34679 9.08365 3.28657C9.0566 3.22548 9.00947 3.17137 8.951 3.12599C8.88903 3.08235 8.81049 3.05704 8.7363 3.05355C8.66125 3.04832 8.59405 3.06054 8.53209 3.07014C8.40816 3.09283 8.30692 3.10504 8.24234 3.08934C8.14896 3.06403 8.09572 2.9977 8.0739 2.9497C8.05296 2.89908 8.05034 2.85894 8.05121 2.82577C8.05209 2.72715 8.08001 2.62679 8.08874 2.5273C8.09921 2.42868 8.08874 2.31872 8.03201 2.23581L8.03289 2.23406Z",
                fill: "#292A2E"
            })
        ]
    });
};
var $24c02ea0e14dbe4f$var$$bde17c0708419ffe$export$2e2bcd8739ae039 = $24c02ea0e14dbe4f$var$$bde17c0708419ffe$var$CompletedIcon;
const $24c02ea0e14dbe4f$var$$b16d92af3081158f$var$QuestionIcon = ()=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12ZM14.8284 7.15997C15.3505 7.67945 15.7181 8.3338 15.89 9.04999C16.1223 10.008 15.9918 11.0181 15.5235 11.8856C15.0552 12.7531 14.2824 13.4165 13.354 13.748C13.149 13.821 13.004 14.003 13.004 14.22V15.002C13.004 15.2677 12.8984 15.5226 12.7105 15.7105C12.5226 15.8984 12.2677 16.004 12.002 16.004C11.7363 16.004 11.4814 15.8984 11.2935 15.7105C11.1056 15.5226 11 15.2677 11 15.002V12.988C11.0034 12.725 11.1103 12.474 11.2975 12.2893C11.4846 12.1046 11.7369 12.001 11.9998 12.001H11.993C13.098 12.001 13.996 11.103 13.996 10.001C13.984 9.47739 13.7676 8.97927 13.3929 8.61327C13.0183 8.24727 12.5153 8.04248 11.9915 8.04275C11.4678 8.04301 10.9649 8.2483 10.5907 8.61467C10.2164 8.98104 10.0004 9.47937 9.989 10.003C9.987 10.554 9.539 11.001 8.987 11.001C8.74019 10.9995 8.50281 10.906 8.32123 10.7388C8.13964 10.5717 8.02689 10.3428 8.005 10.097L8 9.94999C8.017 7.44599 10.321 5.51399 12.933 6.10799C13.6501 6.27628 14.3063 6.64048 14.8284 7.15997ZM13 18C13 18.5523 12.5523 19 12 19C11.4477 19 11 18.5523 11 18C11 17.4477 11.4477 17 12 17C12.5523 17 13 17.4477 13 18Z",
            fill: "#44546F"
        })
    });
var $24c02ea0e14dbe4f$var$$b16d92af3081158f$export$2e2bcd8739ae039 = $24c02ea0e14dbe4f$var$$b16d92af3081158f$var$QuestionIcon;
const $24c02ea0e14dbe4f$var$$c68bccd399b510db$var$STATUS_LABELS = {
    [$24c02ea0e14dbe4f$var$$035f8a623e403361$export$23d03d0b3065d061.NOT_STARTED]: "Not started",
    [$24c02ea0e14dbe4f$var$$035f8a623e403361$export$23d03d0b3065d061.COMPLETED]: "Complete!"
};
const $24c02ea0e14dbe4f$var$$c68bccd399b510db$export$cee724c49a9ffe54 = ({ isRetired: isRetired, progress: progress, status: status })=>{
    if (isRetired) return (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$71f050e2efa708bb, {
        size: "medium",
        fontWeight: "semibold",
        children: (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("span", {
            css: $24c02ea0e14dbe4f$var$$c68bccd399b510db$var$progressStyles,
            children: [
                (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("span", {
                    children: "Retired content"
                }),
                (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$var$$b16d92af3081158f$export$2e2bcd8739ae039, {})
            ]
        })
    });
    if (status === $24c02ea0e14dbe4f$var$$035f8a623e403361$export$23d03d0b3065d061.NOT_STARTED) return (0, $6bec4f26b2cb3094$export$25062201e9e25d76)((0, $6bec4f26b2cb3094$export$ffb0004e005737fa), {
        children: [
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$71f050e2efa708bb, {
                size: "medium",
                fontWeight: "semibold",
                children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("span", {
                    css: (0, $74Zh5.css)({
                        color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text.subtle")
                    }),
                    children: $24c02ea0e14dbe4f$var$$c68bccd399b510db$var$STATUS_LABELS[$24c02ea0e14dbe4f$var$$035f8a623e403361$export$23d03d0b3065d061.NOT_STARTED]
                })
            }),
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$c17561cb55d4db30, {
                progress: 0
            })
        ]
    });
    if (status === $24c02ea0e14dbe4f$var$$035f8a623e403361$export$23d03d0b3065d061.COMPLETED) return (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$71f050e2efa708bb, {
        size: "medium",
        fontWeight: "semibold",
        children: (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("span", {
            css: $24c02ea0e14dbe4f$var$$c68bccd399b510db$var$progressStyles,
            children: [
                (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("span", {
                    children: "Progress"
                }),
                (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("span", {
                    css: (0, $74Zh5.css)({
                        color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text.accent.lime")
                    }),
                    children: $24c02ea0e14dbe4f$var$$c68bccd399b510db$var$STATUS_LABELS[$24c02ea0e14dbe4f$var$$035f8a623e403361$export$23d03d0b3065d061.COMPLETED]
                }),
                (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$var$$bde17c0708419ffe$export$2e2bcd8739ae039, {})
            ]
        })
    });
    return (0, $6bec4f26b2cb3094$export$25062201e9e25d76)((0, $6bec4f26b2cb3094$export$ffb0004e005737fa), {
        children: [
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$71f050e2efa708bb, {
                size: "medium",
                fontWeight: "semibold",
                children: (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("span", {
                    css: $24c02ea0e14dbe4f$var$$c68bccd399b510db$var$progressStyles,
                    children: [
                        (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("span", {
                            children: "Progress"
                        }),
                        (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("span", {
                            css: (0, $74Zh5.css)({
                                color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text.subtle")
                            }),
                            children: [
                                progress,
                                "%"
                            ]
                        })
                    ]
                })
            }),
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$c17561cb55d4db30, {
                progress: progress,
                color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.icon.accent.lime")
            })
        ]
    });
};
const $24c02ea0e14dbe4f$var$$c68bccd399b510db$var$progressStyles = (0, $74Zh5.css)({
    display: "flex",
    alignItems: "center",
    gap: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.100")
});
const $24c02ea0e14dbe4f$var$$e9cd1e314d8acc99$export$aa140c19feb5d492 = ({ title: title, href: href, isRetired: isRetired = false, onTitleClick: onTitleClick })=>{
    const handleClick = (e)=>{
        if (onTitleClick) {
            e.preventDefault();
            onTitleClick();
        }
    };
    const handleKeyboardClick = (0, $5FkrB.useCallback)(()=>{
        if (onTitleClick) onTitleClick();
    }, [
        onTitleClick
    ]);
    const onKeyDown = $24c02ea0e14dbe4f$export$2a0b6757d41dacb2(handleKeyboardClick);
    if (isRetired) return (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
        role: "button",
        tabIndex: 0,
        css: $24c02ea0e14dbe4f$var$$e9cd1e314d8acc99$var$titleContainerStyles,
        onClick: handleClick,
        onKeyDown: onKeyDown,
        children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$a8a3e93435678ff9, {
            level: 4,
            color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text.subtlest"),
            children: title
        })
    });
    return (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
        css: $24c02ea0e14dbe4f$var$$e9cd1e314d8acc99$var$titleContainerStyles,
        children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$a6c7ac8248d6e38a, {
            label: title,
            link: href || "#",
            size: $24c02ea0e14dbe4f$export$be4c932f76c19adf.EXTRA_LARGE,
            style: $24c02ea0e14dbe4f$export$2b77966d73aefa77.SEMIBOLD,
            icon: "arrow-right-small",
            onClick: handleClick
        })
    });
};
const $24c02ea0e14dbe4f$var$$e9cd1e314d8acc99$var$titleContainerStyles = (0, $74Zh5.css)({
    display: "flex",
    alignItems: "center",
    "& *": {
        fontFamily: "Charlie Display, sans-serif"
    },
    "& a:hover": {
        textDecoration: "none"
    },
    "& a span:last-of-type": {
        verticalAlign: "text-bottom"
    },
    [(0, $cb8cedbc477f5a81$export$987d49ffe1b0900f).below.sm]: {
        "& a span:last-of-type": {
            verticalAlign: "bottom"
        }
    }
});
const $24c02ea0e14dbe4f$export$60e8035fadc9b8fc = ({ course: course, lessons: lessons, onLessonClick: onLessonClick, progress: progress, type: type, isSaved: isSaved, isRetired: isRetired, onSave: onSave, tags: tags, status: status, onDownloadPdf: onDownloadPdf, additionalActions: additionalActions, completionBadgeUrl: completionBadgeUrl, dropdownItems: dropdownItems, onTitleClick: onTitleClick, showSaveButton: showSaveButton = true })=>{
    const typeText = (0, $5FkrB.useMemo)(()=>{
        switch(type){
            case $24c02ea0e14dbe4f$export$e2e108cbe2e4f865.COURSE:
                return "Course";
            case $24c02ea0e14dbe4f$export$e2e108cbe2e4f865.LESSON:
                return "Lesson";
            default:
                return "Learning Path";
        }
    }, [
        type
    ]);
    const getBackgroundColor = (0, $5FkrB.useMemo)(()=>{
        if (isRetired) return "#8C8F97"; // neutral 500
        switch(type){
            case $24c02ea0e14dbe4f$export$e2e108cbe2e4f865.COURSE:
                return "#357DE8"; // blue 600
            case $24c02ea0e14dbe4f$export$e2e108cbe2e4f865.LESSON:
                return "#FCA700"; // yellow 400
            default:
                return "#6A9A23"; // lime 600
        }
    }, [
        isRetired,
        type
    ]);
    const expandableTextLabels = (0, $5FkrB.useMemo)(()=>{
        switch(type){
            case $24c02ea0e14dbe4f$export$e2e108cbe2e4f865.COURSE:
                return {
                    expandButtonText: "Show lessons",
                    collapseButtonText: "Hide lessons"
                };
            default:
                return {
                    expandButtonText: "Show courses",
                    collapseButtonText: "Hide courses"
                };
        }
    }, [
        type
    ]);
    const handleSave = ()=>{
        onSave?.(!isSaved);
    };
    const showCourseList = !isRetired && lessons.length > 0;
    const isCompleted = progress === 100;
    return (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
        css: $24c02ea0e14dbe4f$var$$8340d81aba797956$var$containerStyles,
        children: [
            (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                css: $24c02ea0e14dbe4f$var$$8340d81aba797956$var$topControlsStyles,
                style: {
                    backgroundColor: getBackgroundColor
                },
                children: [
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                        css: (0, $74Zh5.css)({
                            flexShrink: 0
                        }),
                        children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$71f050e2efa708bb, {
                            size: "medium",
                            color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text.inverse"),
                            fontWeight: "semibold",
                            children: typeText
                        })
                    }),
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                        css: $24c02ea0e14dbe4f$var$$8340d81aba797956$var$headerImageStyles,
                        style: {
                            backgroundImage: `url(${$24c02ea0e14dbe4f$var$$8f97e278a4a2a6b3$export$cdb81064101cb20c})`
                        }
                    }),
                    isCompleted && completionBadgeUrl && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                        css: $24c02ea0e14dbe4f$var$$8340d81aba797956$var$badgeOuterContainerStyles,
                        children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                            css: $24c02ea0e14dbe4f$var$$8340d81aba797956$var$badgeInnerContainerStyles,
                            children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$3e431a229df88919, {
                                src: completionBadgeUrl,
                                alt: "Completion Badge",
                                width: 48,
                                height: 48
                            })
                        })
                    }),
                    showSaveButton && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$dd09d7da2da4d16f, {
                        icon: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$f04a61298a47a40f, {
                            type: isSaved ? "bookmark-narrow-filled" : "bookmark-narrow",
                            color: "#FFFFFF"
                        }),
                        ariaLabel: isSaved ? "Saved" : "Save",
                        onClick: handleSave,
                        selected: isSaved
                    }),
                    Boolean(dropdownItems?.length) && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$ef4a0fdddd7eccb7, {
                        items: dropdownItems,
                        isInverted: true
                    })
                ]
            }),
            (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                css: $24c02ea0e14dbe4f$var$$8340d81aba797956$var$contentStyles,
                children: [
                    (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                        css: $24c02ea0e14dbe4f$var$$8340d81aba797956$var$leftColumnStyles,
                        children: [
                            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                                css: $24c02ea0e14dbe4f$var$$8340d81aba797956$var$tagsContainerStyles,
                                children: tags.map((tag)=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$3288d34c523a1192, {
                                        label: tag.label
                                    }, tag.label))
                            }),
                            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$var$$e9cd1e314d8acc99$export$aa140c19feb5d492, {
                                title: course.title,
                                href: course.href,
                                isRetired: isRetired,
                                onTitleClick: onTitleClick
                            })
                        ]
                    }),
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                        css: $24c02ea0e14dbe4f$var$$8340d81aba797956$var$rightColumnStyles,
                        children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$var$$c68bccd399b510db$export$cee724c49a9ffe54, {
                            isRetired: isRetired,
                            progress: progress,
                            status: status
                        })
                    })
                ]
            }),
            (onDownloadPdf || additionalActions) && (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                css: $24c02ea0e14dbe4f$var$$8340d81aba797956$var$completionActionsStyles,
                children: [
                    onDownloadPdf && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$var$$0fd79bc510e2fa30$export$b7c3a2f69225ecf, {
                        appearance: $24c02ea0e14dbe4f$export$261c9483fc4a455a.DEFAULT,
                        iconBefore: (0, (/*@__PURE__*/$parcel$interopDefault($exnso))),
                        onClick: onDownloadPdf,
                        children: "Download completion pdf"
                    }),
                    additionalActions
                ]
            }),
            showCourseList && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$var$$7586a58445419b5a$export$2c3faa04d4773275, {
                lessons: lessons,
                onLessonClick: onLessonClick,
                expandButtonText: expandableTextLabels.expandButtonText,
                collapseButtonText: expandableTextLabels.collapseButtonText,
                containerStyles: $24c02ea0e14dbe4f$var$$8340d81aba797956$var$expandableLessonsListContainerStyles,
                buttonContainerStyles: $24c02ea0e14dbe4f$var$$8340d81aba797956$var$expandableLessonsListButtonContainerStyles
            })
        ]
    });
};
const $24c02ea0e14dbe4f$var$$8340d81aba797956$var$containerStyles = (0, $74Zh5.css)({
    display: "flex",
    flexDirection: "column",
    borderRadius: "8px",
    border: `1px solid ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.border")}`,
    boxShadow: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("elevation.shadow.raised"),
    overflow: "hidden"
});
const $24c02ea0e14dbe4f$var$$8340d81aba797956$var$topControlsStyles = (0, $74Zh5.css)({
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: `0 ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.250")}`
});
const $24c02ea0e14dbe4f$var$$8340d81aba797956$var$contentStyles = (0, $74Zh5.css)({
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.250"),
    flexWrap: "wrap",
    rowGap: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.400")
});
const $24c02ea0e14dbe4f$var$$8340d81aba797956$var$leftColumnStyles = (0, $74Zh5.css)({
    display: "flex",
    flexDirection: "column",
    gap: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.150")
});
const $24c02ea0e14dbe4f$var$$8340d81aba797956$var$rightColumnStyles = (0, $74Zh5.css)({
    display: "flex",
    flexDirection: "column",
    gap: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.100"),
    minWidth: "234px",
    alignSelf: "flex-end"
});
const $24c02ea0e14dbe4f$var$$8340d81aba797956$var$tagsContainerStyles = (0, $74Zh5.css)({
    display: "flex",
    gap: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.100")
});
const $24c02ea0e14dbe4f$var$$8340d81aba797956$var$expandableLessonsListContainerStyles = (0, $74Zh5.css)({
    border: "none",
    borderRadius: "0"
});
const $24c02ea0e14dbe4f$var$$8340d81aba797956$var$expandableLessonsListButtonContainerStyles = (0, $74Zh5.css)({
    paddingLeft: `${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.250")} !important`
});
const $24c02ea0e14dbe4f$var$$8340d81aba797956$var$headerImageStyles = (0, $74Zh5.css)({
    display: "flex",
    flexGrow: 1,
    backgroundRepeat: "no-repeat",
    backgroundPosition: "right",
    backgroundSize: "cover",
    minHeight: "48px",
    width: "100%"
});
const $24c02ea0e14dbe4f$var$$8340d81aba797956$var$completionActionsStyles = (0, $74Zh5.css)({
    display: "flex",
    flexDirection: "row",
    gap: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.150"),
    padding: `${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.150")} 0 ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.250")} ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.250")}`
});
const $24c02ea0e14dbe4f$var$$8340d81aba797956$var$badgeOuterContainerStyles = (0, $74Zh5.css)({
    position: "relative",
    marginTop: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.100"),
    marginRight: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.150"),
    width: "72px",
    [(0, $cb8cedbc477f5a81$export$987d49ffe1b0900f).below.sm]: {
        display: "none"
    }
});
const $24c02ea0e14dbe4f$var$$8340d81aba797956$var$badgeInnerContainerStyles = (0, $74Zh5.css)({
    position: "absolute",
    top: 0,
    right: 0,
    backgroundColor: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.background.input"),
    borderRadius: "50%",
    padding: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.150"),
    boxShadow: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("elevation.shadow.overlay"),
    transform: "translateY(-25%)"
});
var $24c02ea0e14dbe4f$var$$dbb9d5792c296a49$exports = {};
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$dbb9d5792c296a49$exports, "SubmitFeedback", ()=>$24c02ea0e14dbe4f$export$f6dc54b55657f29f);
const $24c02ea0e14dbe4f$export$f6dc54b55657f29f = ({ onSubmit: onSubmit, onChange: onChange, isLoading: isLoading, isSubmitted: isSubmitted, hasError: hasError, opinion: opinion })=>{
    const [isOpen, setIsOpen] = (0, $5FkrB.useState)(false);
    const [isYesSelected, setIsYesSelected] = (0, $5FkrB.useState)(false);
    const [isNoSelected, setIsNoSelected] = (0, $5FkrB.useState)(false);
    const handleChange = (0, $5FkrB.useCallback)((e)=>{
        e.preventDefault();
        if (onChange) onChange(e);
    }, [
        onChange
    ]);
    const handleYes = (0, $5FkrB.useCallback)(()=>{
        setIsOpen(true);
        setIsYesSelected(true);
        setIsNoSelected(false);
    }, []);
    const handleNo = (0, $5FkrB.useCallback)(()=>{
        setIsOpen(true);
        setIsNoSelected(true);
        setIsYesSelected(false);
    }, []);
    const handleCancel = (0, $5FkrB.useCallback)(()=>{
        setIsOpen(false);
        setIsYesSelected(false);
        setIsNoSelected(false);
    }, []);
    const renderButtons = ()=>{
        if (isLoading && !isSubmitted) return (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $a60eb1e63addc72a$export$2e2bcd8739ae039), {
            appearance: "primary",
            isLoading: true,
            children: "Submit"
        });
        if (isSubmitted) return null;
        return (0, $6bec4f26b2cb3094$export$25062201e9e25d76)((0, $6bec4f26b2cb3094$export$ffb0004e005737fa), {
            children: [
                (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$353f5b6fc5456de1, {
                    type: "submit",
                    appearance: $24c02ea0e14dbe4f$export$261c9483fc4a455a.PRIMARY,
                    label: "Submit",
                    onClick: onSubmit
                }),
                (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$353f5b6fc5456de1, {
                    appearance: $24c02ea0e14dbe4f$export$261c9483fc4a455a.LINK,
                    label: "Cancel",
                    onClick: handleCancel
                })
            ]
        });
    };
    const renderFeedbackBox = ()=>{
        if (!isOpen) return null;
        if (!isSubmitted) return (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
            css: {
                label: {
                    fontSize: "13.7143px",
                    color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text.subtlest")
                },
                textArea: {
                    borderColor: `${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.border")} !important`,
                    "&:focus": {
                        borderColor: `${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.border.focused")} !important`
                    }
                }
            },
            children: [
                (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $5ac1013239c7eb7f$export$b04be29aa201d4f5), {
                    htmlFor: "area",
                    children: "Send us your opinion"
                }),
                (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $195b49e60159a439$export$2e2bcd8739ae039), {
                    placeholder: "Begin typing in here...",
                    defaultValue: opinion,
                    onChange: handleChange
                }),
                (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $ab642ec49327e475$export$2e2bcd8739ae039), {
                    children: renderButtons()
                })
            ]
        });
        if (!hasError) return (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("p", {
            css: $24c02ea0e14dbe4f$var$$dbb9d5792c296a49$var$feedbackStyles,
            children: "Thanks for your feedback!"
        });
        return (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("p", {
            css: $24c02ea0e14dbe4f$var$$dbb9d5792c296a49$var$feedbackStyles,
            children: "Error submitting feedback. Try again later."
        });
    };
    return (0, $6bec4f26b2cb3094$export$25062201e9e25d76)((0, $6bec4f26b2cb3094$export$ffb0004e005737fa), {
        children: [
            !isSubmitted && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                children: (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                    css: (0, $74Zh5.css)({
                        display: "flex",
                        alignItems: "center",
                        marginBottom: "10px"
                    }),
                    children: [
                        (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("p", {
                            css: $24c02ea0e14dbe4f$var$$dbb9d5792c296a49$var$labelStyles,
                            children: "Was this content helpful?"
                        }),
                        (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                            css: (0, $74Zh5.css)({
                                marginLeft: "1rem",
                                display: "flex"
                            }),
                            children: [
                                (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("span", {
                                    css: (0, $74Zh5.css)({
                                        marginRight: "0.5rem"
                                    }),
                                    children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$353f5b6fc5456de1, {
                                        label: "Yes",
                                        onClick: handleYes,
                                        appearance: $24c02ea0e14dbe4f$export$261c9483fc4a455a.PRIMARY,
                                        disabled: isYesSelected
                                    })
                                }),
                                (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$353f5b6fc5456de1, {
                                    label: "No",
                                    onClick: handleNo,
                                    appearance: $24c02ea0e14dbe4f$export$261c9483fc4a455a.PRIMARY,
                                    disabled: isNoSelected
                                })
                            ]
                        })
                    ]
                })
            }),
            renderFeedbackBox()
        ]
    });
};
const $24c02ea0e14dbe4f$var$$dbb9d5792c296a49$var$labelStyles = (0, $74Zh5.css)({
    marginTop: 0,
    marginBottom: 0,
    fontFamily: "Charlie Display, sans-serif",
    fontSize: "1.25rem",
    fontWeight: 600,
    lineHeight: "1.75rem",
    color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text")
});
const $24c02ea0e14dbe4f$var$$dbb9d5792c296a49$var$feedbackStyles = (0, $74Zh5.css)({
    fontWeight: 600,
    fontSize: "1.125rem",
    lineHeight: "1.5rem",
    width: "13.813rem",
    height: "1.563rem"
});
var $24c02ea0e14dbe4f$var$$44303f6c3c81eeac$exports = {};
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$44303f6c3c81eeac$exports, "QuestionType", ()=>$24c02ea0e14dbe4f$export$51940fbbacba35d4);
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$44303f6c3c81eeac$exports, "QuizStatus", ()=>$24c02ea0e14dbe4f$export$bf1c1ed72daa392b);
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$44303f6c3c81eeac$exports, "QuestionStatus", ()=>$24c02ea0e14dbe4f$export$602daccbd963b20);
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$44303f6c3c81eeac$exports, "MatchingAnswerStatus", ()=>$24c02ea0e14dbe4f$export$85e3e62cc743c830);
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$44303f6c3c81eeac$exports, "ActionDescription", ()=>$24c02ea0e14dbe4f$export$cb9c858407602327);
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$44303f6c3c81eeac$exports, "Quiz", ()=>$24c02ea0e14dbe4f$export$76709845c4fea6cd);
let $24c02ea0e14dbe4f$var$$b55544cdfa85935b$export$1bd2035254432789;
(function(InputStatus) {
    InputStatus["CORRECT"] = "CORRECT";
    InputStatus["INCORRECT"] = "INCORRECT";
    InputStatus["SELECTED"] = "SELECTED";
    InputStatus["DEFAULT"] = "DEFAULT";
    InputStatus["DISABLED"] = "DISABLED";
})($24c02ea0e14dbe4f$var$$b55544cdfa85935b$export$1bd2035254432789 || ($24c02ea0e14dbe4f$var$$b55544cdfa85935b$export$1bd2035254432789 = {}));
const $24c02ea0e14dbe4f$var$$b55544cdfa85935b$export$56e6c05354470c53 = ({ inspectMode: inspectMode, text: text, elementId: elementId, inputStatus: inputStatus = $24c02ea0e14dbe4f$var$$b55544cdfa85935b$export$1bd2035254432789.DEFAULT, onClick: onClick })=>{
    // Keep original Space-only handler for outer div (used by tests)
    const handleKeyDown = (0, $5FkrB.useCallback)((event)=>{
        if (event.code === "Space") {
            event.preventDefault();
            onClick && onClick();
        }
    }, [
        onClick
    ]);
    // Use keyboard interaction hook for inner div
    const handleClick = (0, $5FkrB.useCallback)(()=>onClick?.(), [
        onClick
    ]);
    const onKeyDownInner = $24c02ea0e14dbe4f$export$2a0b6757d41dacb2(handleClick);
    return (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
        role: "button",
        tabIndex: 0,
        onKeyDown: handleKeyDown,
        css: [
            $24c02ea0e14dbe4f$var$$b55544cdfa85935b$var$quizInputsContainerStyles,
            $24c02ea0e14dbe4f$var$$b55544cdfa85935b$var$quizInputsVariantStyles[inputStatus]
        ],
        children: [
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                css: [
                    $24c02ea0e14dbe4f$var$$b55544cdfa85935b$var$quizInputBorderStyles["DEFAULT"],
                    $24c02ea0e14dbe4f$var$$b55544cdfa85935b$var$quizInputBorderStyles[inputStatus],
                    $24c02ea0e14dbe4f$var$$b55544cdfa85935b$var$quizInputsVariantStyles[inputStatus]
                ]
            }),
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                role: "button",
                tabIndex: 0,
                ...$24c02ea0e14dbe4f$export$1784ac302bd8ebad("title", inspectMode),
                id: elementId ? elementId + "-quiz-input" : "",
                css: [
                    $24c02ea0e14dbe4f$var$$b55544cdfa85935b$var$quizInputsContentStyles,
                    $24c02ea0e14dbe4f$var$$b55544cdfa85935b$var$quizInputsVariantStyles[inputStatus]
                ],
                onClick: onClick,
                onKeyDown: onKeyDownInner,
                children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                    css: $24c02ea0e14dbe4f$var$$b55544cdfa85935b$var$quizInputsTextStyles,
                    children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$e61786c4aee8d415, {
                        children: text
                    })
                })
            })
        ]
    });
};
const $24c02ea0e14dbe4f$var$$b55544cdfa85935b$var$quizInputsContainerStyles = (0, $74Zh5.css)({
    width: "50%",
    display: "flex",
    cursor: "pointer",
    borderRadius: "8px",
    boxShadow: "0px 1px 1px 0px rgba(9, 30, 66, 0.25), 0px 0px 1px 0px rgba(9, 30, 66, 0.31)",
    justifyContent: "center"
});
const $24c02ea0e14dbe4f$var$$b55544cdfa85935b$var$quizInputsContentStyles = (0, $74Zh5.css)({
    maxWidth: "300px",
    width: "100%",
    padding: "16px",
    overflow: "hidden",
    display: "flex",
    alignItems: "center",
    border: "1px solid rgba(9, 30, 66, 0.14)",
    borderLeft: "none",
    borderRadius: "0 8px 8px 0"
});
const $24c02ea0e14dbe4f$var$$b55544cdfa85935b$var$quizInputsTextStyles = (0, $74Zh5.css)({
    fontFamily: "Inter, sans-serif",
    fontSize: "16px",
    lineHeight: "24px",
    width: "100%",
    [(0, $cb8cedbc477f5a81$export$987d49ffe1b0900f).below.xs]: {
        fontSize: "14px",
        lineHeight: "20px"
    }
});
const $24c02ea0e14dbe4f$var$$b55544cdfa85935b$var$quizInputBorderStyles = {
    DEFAULT: (0, $74Zh5.css)({
        maxHeight: "100%",
        width: "8px",
        borderRadius: "8px 0 0 8px",
        border: "1px solid rgba(9, 30, 66, 0.14)",
        borderRight: "none",
        backgroundColor: (0, $54ca2d3948378259$export$29a4f05edc054374),
        [(0, $cb8cedbc477f5a81$export$987d49ffe1b0900f).below.xs]: {
            width: "4px"
        }
    }),
    CORRECT: (0, $74Zh5.css)({
        backgroundColor: "#22A06B",
        border: "1px solid #22A06B"
    }),
    INCORRECT: (0, $74Zh5.css)({
        backgroundColor: "#E2483D",
        border: "1px solid #E2483D"
    }),
    SELECTED: (0, $74Zh5.css)({
        backgroundColor: "#0C66E4",
        border: "1px solid #0C66E4"
    })
};
const $24c02ea0e14dbe4f$var$$b55544cdfa85935b$var$quizInputsVariantStyles = {
    DEFAULT: (0, $74Zh5.css)({
        color: "#000000",
        backgroundColor: (0, $54ca2d3948378259$export$29a4f05edc054374),
        fontWeight: 400
    }),
    CORRECT: (0, $74Zh5.css)({
        fontWeight: 700
    }),
    INCORRECT: (0, $74Zh5.css)({
        fontWeight: 700
    }),
    SELECTED: (0, $74Zh5.css)({
        fontWeight: 700
    }),
    DISABLED: (0, $74Zh5.css)({
        color: "#626F86",
        fontWeight: 400,
        backgroundColor: "#F7F8F9",
        border: "1px solid #F7F8F9",
        boxShadow: "none",
        transition: "all",
        transitionDuration: "500ms",
        transitionTimingFunction: "cubic-bezier(0, 0, 0.2, 1)",
        pointerEvents: "none"
    })
};
let $24c02ea0e14dbe4f$export$51940fbbacba35d4;
(function(QuestionType) {
    QuestionType["SINGLE_SELECT"] = "SINGLE_SELECT";
    QuestionType["MULTI_SELECT"] = "MULTI_SELECT";
    QuestionType["MATCHING"] = "MATCHING";
})($24c02ea0e14dbe4f$export$51940fbbacba35d4 || ($24c02ea0e14dbe4f$export$51940fbbacba35d4 = {}));
let $24c02ea0e14dbe4f$export$bf1c1ed72daa392b;
(function(QuizStatus) {
    QuizStatus["DEFAULT"] = "DEFAULT";
    QuizStatus["ERROR"] = "ERROR";
    QuizStatus["PARTLY_CORRECT"] = "PARTLY_CORRECT";
    QuizStatus["SUCCESS"] = "SUCCESS";
})($24c02ea0e14dbe4f$export$bf1c1ed72daa392b || ($24c02ea0e14dbe4f$export$bf1c1ed72daa392b = {}));
let $24c02ea0e14dbe4f$export$602daccbd963b20;
(function(QuestionStatus) {
    QuestionStatus["INCORRECT"] = "INCORRECT";
    QuestionStatus["PARTLY_CORRECT"] = "PARTLY_CORRECT";
    QuestionStatus["CORRECT"] = "CORRECT";
})($24c02ea0e14dbe4f$export$602daccbd963b20 || ($24c02ea0e14dbe4f$export$602daccbd963b20 = {}));
let $24c02ea0e14dbe4f$export$85e3e62cc743c830;
(function(MatchingAnswerStatus) {
    MatchingAnswerStatus["DEFAULT"] = "DEFAULT";
    MatchingAnswerStatus["INCORRECT"] = "INCORRECT";
    MatchingAnswerStatus["CORRECT"] = "CORRECT";
})($24c02ea0e14dbe4f$export$85e3e62cc743c830 || ($24c02ea0e14dbe4f$export$85e3e62cc743c830 = {}));
let $24c02ea0e14dbe4f$export$cb9c858407602327;
(function(ActionDescription) {
    ActionDescription["SINGLE_SELECT"] = "Select the correct answer.";
    ActionDescription["MULTI_SELECT"] = "Select all correct responses.";
    ActionDescription["MATCHING"] = "Select the matching pairs.";
})($24c02ea0e14dbe4f$export$cb9c858407602327 || ($24c02ea0e14dbe4f$export$cb9c858407602327 = {}));
const $24c02ea0e14dbe4f$var$$44303f6c3c81eeac$var$QuizStatusToCheckboxType = {
    [$24c02ea0e14dbe4f$export$bf1c1ed72daa392b.DEFAULT]: "DEFAULT",
    [$24c02ea0e14dbe4f$export$bf1c1ed72daa392b.SUCCESS]: "SUCCESS",
    [$24c02ea0e14dbe4f$export$bf1c1ed72daa392b.ERROR]: "DANGER",
    [$24c02ea0e14dbe4f$export$bf1c1ed72daa392b.PARTLY_CORRECT]: "DANGER"
};
const $24c02ea0e14dbe4f$var$$44303f6c3c81eeac$var$QuizStatusToRadioType = {
    [$24c02ea0e14dbe4f$export$bf1c1ed72daa392b.DEFAULT]: "DEFAULT",
    [$24c02ea0e14dbe4f$export$bf1c1ed72daa392b.SUCCESS]: "SUCCESS",
    [$24c02ea0e14dbe4f$export$bf1c1ed72daa392b.ERROR]: "DANGER",
    [$24c02ea0e14dbe4f$export$bf1c1ed72daa392b.PARTLY_CORRECT]: "DANGER"
};
const $24c02ea0e14dbe4f$var$$44303f6c3c81eeac$var$MOBILE_SCREEN_WIDTH = 480;
const $24c02ea0e14dbe4f$var$$44303f6c3c81eeac$var$NAVBAR_HEIGHT = 136;
const $24c02ea0e14dbe4f$export$76709845c4fea6cd = ({ inspectMode: inspectMode, title: title, questions: questions = [], onCompletion: onCompletion, step: step = 0, setStep: setStep, onInteraction: onInteraction, isCompleted: isCompleted = false, setIsCompleted: setIsCompleted, isLoggedInUser: isLoggedInUser, handleUserLogin: handleUserLogin, lessonId: lessonId, onAnswerSubmit: onAnswerSubmit })=>{
    const [questionAnswers, setQuestionAnswers] = (0, $5FkrB.useState)([]);
    const [selectedAnswers, setSelectedAnswers] = (0, $5FkrB.useState)([]);
    const [status, setStatus] = (0, $5FkrB.useState)($24c02ea0e14dbe4f$export$bf1c1ed72daa392b.DEFAULT);
    const [answersStatus, setAnswersStatus] = (0, $5FkrB.useState)({});
    const [matchingAnswersStatus, setMatchingAnswersStatus] = (0, $5FkrB.useState)($24c02ea0e14dbe4f$export$85e3e62cc743c830.DEFAULT);
    const [correctAnswersArray, setCorrectAnswersArray] = (0, $5FkrB.useState)([]);
    const [incorrectAnswersArray, setIncorrectAnswersArray] = (0, $5FkrB.useState)([]);
    const [lastSubmittedQuestion, setLastSubmittedQuestion] = (0, $5FkrB.useState)({
        lessonId: "",
        step: 0
    });
    const width = $24c02ea0e14dbe4f$export$4616d33c54ae5baf();
    const isNextButtonDisabled = step + 1 !== questions.length ? !isCompleted && status !== $24c02ea0e14dbe4f$export$bf1c1ed72daa392b.SUCCESS : true;
    const isMatchingFeedbackVisible = questions[step]?.type === $24c02ea0e14dbe4f$export$51940fbbacba35d4.MATCHING && matchingAnswersStatus === $24c02ea0e14dbe4f$export$85e3e62cc743c830.CORRECT && !isCompleted;
    (0, $5FkrB.useEffect)(()=>{
        if (lastSubmittedQuestion.lessonId !== lessonId) setLastSubmittedQuestion({
            lessonId: lessonId,
            step: 0
        });
        if (isCompleted && lessonId && questions.length) {
            setStatus($24c02ea0e14dbe4f$export$bf1c1ed72daa392b.SUCCESS);
            onSubmittedQuestionsRecheck(questions.length - 1);
        } else {
            setStatus($24c02ea0e14dbe4f$export$bf1c1ed72daa392b.DEFAULT);
            setSelectedAnswers([]);
        }
    // lastSubmittedQuestion.lessonId, onSubmittedQuestionsRecheck, questions.length intentionally excluded
    /* eslint-disable react-hooks/exhaustive-deps */ }, [
        lessonId,
        isCompleted
    ]);
    (0, $5FkrB.useEffect)(()=>{
        setLastSubmittedQuestion((prevState)=>{
            if (prevState.lessonId === lessonId && !prevState.step) return {
                ...prevState,
                step: step
            };
            return {
                ...prevState
            };
        });
    }, [
        step,
        lastSubmittedQuestion.lessonId
    ]);
    (0, $5FkrB.useEffect)(()=>{
        checkMatchingQuestionCompleted();
    }, [
        correctAnswersArray
    ]);
    (0, $5FkrB.useEffect)(()=>{
        const isLastCompletedQuestion = status === $24c02ea0e14dbe4f$export$bf1c1ed72daa392b.SUCCESS && lastSubmittedQuestion.step === questions.length;
        if (questions.length && !isLastCompletedQuestion) setQuestionAnswers(questions[step]?.answers);
    }, [
        step,
        questions
    ]);
    /* eslint-enable react-hooks/exhaustive-deps */ const handleOnAnswerSubmit = (type, status)=>{
        if (onAnswerSubmit) onAnswerSubmit(type, status);
    };
    const toggleAnswer = (answer)=>{
        onInteraction();
        if (status !== $24c02ea0e14dbe4f$export$bf1c1ed72daa392b.DEFAULT) return;
        if (questions[step]?.type === $24c02ea0e14dbe4f$export$51940fbbacba35d4.SINGLE_SELECT) setSelectedAnswers([
            answer
        ]);
        if (questions[step]?.type === $24c02ea0e14dbe4f$export$51940fbbacba35d4.MULTI_SELECT) {
            if (selectedAnswers.includes(answer)) setSelectedAnswers((a)=>a.filter((ans)=>ans !== answer));
            else setSelectedAnswers((a)=>[
                    ...a,
                    answer
                ]);
        }
        if (questions[step]?.type === $24c02ea0e14dbe4f$export$51940fbbacba35d4.MATCHING) {
            if (isLoggedInUser) toggleMatchingQuestion(answer);
            else handleUserLogin();
        }
    };
    const toggleMatchingQuestion = (answer)=>{
        if (selectedAnswers.length && selectedAnswers[0].title !== answer.title && selectedAnswers[0].isLeftMatchingAnswer !== answer.isLeftMatchingAnswer) {
            if (selectedAnswers[0].matchingAnswer?.title === answer.title && !correctAnswersArray.includes(answer)) {
                const correctAnswers = [
                    ...selectedAnswers,
                    answer
                ];
                handleOnAnswerSubmit($24c02ea0e14dbe4f$export$51940fbbacba35d4.MATCHING, $24c02ea0e14dbe4f$export$602daccbd963b20.CORRECT);
                setMatchingAnswersStatus($24c02ea0e14dbe4f$export$85e3e62cc743c830.CORRECT);
                setSelectedAnswers([
                    ...correctAnswers
                ]);
                setCorrectAnswersArray((a)=>[
                        ...a,
                        ...correctAnswers
                    ]);
                setTimeout(()=>{
                    setSelectedAnswers([]);
                    setMatchingAnswersStatus($24c02ea0e14dbe4f$export$85e3e62cc743c830.DEFAULT);
                }, 500);
            } else {
                const incorrectAnswers = [
                    ...selectedAnswers,
                    answer
                ];
                handleOnAnswerSubmit($24c02ea0e14dbe4f$export$51940fbbacba35d4.MATCHING, $24c02ea0e14dbe4f$export$602daccbd963b20.INCORRECT);
                setMatchingAnswersStatus($24c02ea0e14dbe4f$export$85e3e62cc743c830.INCORRECT);
                setSelectedAnswers([
                    ...incorrectAnswers
                ]);
                setIncorrectAnswersArray((a)=>[
                        ...a,
                        ...incorrectAnswers
                    ]);
                setTimeout(()=>{
                    setSelectedAnswers([]);
                    setMatchingAnswersStatus($24c02ea0e14dbe4f$export$85e3e62cc743c830.DEFAULT);
                }, 500);
            }
        } else {
            setSelectedAnswers([
                answer
            ]);
            setIncorrectAnswersArray([]);
        }
    };
    const checkMatchingQuestionCompleted = ()=>{
        const currentQuestion = questions[step];
        if (!currentQuestion?.leftAnswers || !currentQuestion?.rightAnswers) return;
        const leftAnswers = currentQuestion.leftAnswers;
        const rightAnswers = currentQuestion.rightAnswers;
        if (correctAnswersArray.length === leftAnswers.length + rightAnswers.length) {
            setStatus($24c02ea0e14dbe4f$export$bf1c1ed72daa392b.SUCCESS);
            setLastSubmittedQuestion((prevState)=>{
                return {
                    ...prevState,
                    step: step + 1
                };
            });
            const questionOnCompletion = questions[step]?.onCompletion;
            if (questionOnCompletion) questionOnCompletion();
            if (onCompletion && step + 1 === questions.length) {
                onCompletion();
                setIsCompleted(true);
            }
        }
    };
    const handleAnswerSubmit = ()=>{
        if (isLoggedInUser) onSubmit();
        else handleUserLogin();
    };
    const onSubmit = ()=>{
        const answers = questions[step]?.answers;
        const correctAnswers = answers.filter((ans)=>ans.correct);
        const totalSteps = questions.length;
        const questionOnCompletion = questions[step]?.onCompletion;
        const atLeastOneCorrectAnswer = !!correctAnswers.filter((ans)=>selectedAnswers.includes(ans)).length;
        if (correctAnswers.length === selectedAnswers.length && correctAnswers.every((ans)=>selectedAnswers.includes(ans))) {
            if (step + 1 === totalSteps) {
                /** completed quiz */ setIsCompleted(true);
                if (questionOnCompletion) questionOnCompletion();
                if (onCompletion) onCompletion();
            } else /** unfinished quiz */ if (questionOnCompletion) questionOnCompletion();
            setStatus($24c02ea0e14dbe4f$export$bf1c1ed72daa392b.SUCCESS);
            handleOnAnswerSubmit(questions[step]?.type, $24c02ea0e14dbe4f$export$602daccbd963b20.CORRECT);
            setLastSubmittedQuestion((prevState)=>{
                return {
                    ...prevState,
                    step: step + 1
                };
            });
        } else if (atLeastOneCorrectAnswer) {
            setStatus($24c02ea0e14dbe4f$export$bf1c1ed72daa392b.PARTLY_CORRECT);
            handleOnAnswerSubmit(questions[step]?.type, $24c02ea0e14dbe4f$export$602daccbd963b20.PARTLY_CORRECT);
        } else {
            setStatus($24c02ea0e14dbe4f$export$bf1c1ed72daa392b.ERROR);
            handleOnAnswerSubmit(questions[step]?.type, $24c02ea0e14dbe4f$export$602daccbd963b20.INCORRECT);
        }
        setAnswersStatus(selectedAnswers.reduce((prev, curr)=>({
                ...prev,
                [curr.title]: answers.find((a)=>a.title === curr.title)?.correct ? $24c02ea0e14dbe4f$export$bf1c1ed72daa392b.SUCCESS : $24c02ea0e14dbe4f$export$bf1c1ed72daa392b.ERROR
            }), {}));
    };
    const onTryAgain = ()=>{
        const element = document.getElementById("quiz");
        if (element) {
            const topPosition = element.getBoundingClientRect().top + window.scrollY - $24c02ea0e14dbe4f$var$$44303f6c3c81eeac$var$NAVBAR_HEIGHT;
            window.scrollTo({
                top: topPosition,
                behavior: "smooth"
            });
        }
        setStatus($24c02ea0e14dbe4f$export$bf1c1ed72daa392b.DEFAULT);
        setSelectedAnswers([]);
        setAnswersStatus({});
        setQuestionAnswers((prevState)=>(0, (/*@__PURE__*/$parcel$interopDefault($336d3dfe62d84a74$exports)))(prevState));
    };
    const onSubmittedQuestionsRecheck = (step)=>{
        const prevQuestionAnswers = questions[step].answers;
        const correctAnswers = prevQuestionAnswers.filter((answer)=>answer.correct);
        setStep(step);
        setStatus($24c02ea0e14dbe4f$export$bf1c1ed72daa392b.SUCCESS);
        setSelectedAnswers(correctAnswers);
        setAnswersStatus(correctAnswers.reduce((prev, curr)=>({
                ...prev,
                [curr.title]: questions[step].answers.find((a)=>a.title === curr.title)?.correct ? $24c02ea0e14dbe4f$export$bf1c1ed72daa392b.SUCCESS : $24c02ea0e14dbe4f$export$bf1c1ed72daa392b.ERROR
            }), {}));
    };
    const onNextQuestionClick = ()=>{
        const nextQuestionStep = step + 1;
        const element = document.getElementById("quiz");
        if (element) {
            const topPosition = element.getBoundingClientRect().top + window.scrollY - $24c02ea0e14dbe4f$var$$44303f6c3c81eeac$var$NAVBAR_HEIGHT;
            window.scrollTo({
                top: topPosition,
                behavior: "smooth"
            });
        }
        if (nextQuestionStep < lastSubmittedQuestion.step || isCompleted) onSubmittedQuestionsRecheck(step + 1);
        else {
            setStatus($24c02ea0e14dbe4f$export$bf1c1ed72daa392b.DEFAULT);
            setSelectedAnswers([]);
            setCorrectAnswersArray([]);
            setStep(step + 1);
            setAnswersStatus({});
        }
    };
    const onPrevQuestionClick = ()=>{
        onInteraction();
        onSubmittedQuestionsRecheck(step - 1);
    };
    const getQuizProgress = ()=>{
        const progress = isCompleted ? questions.length : lastSubmittedQuestion.step;
        return progress / questions.length * 100;
    };
    const getInputStatus = (answer)=>{
        if (correctAnswersArray.includes(answer) && selectedAnswers.includes(answer)) return $24c02ea0e14dbe4f$var$$b55544cdfa85935b$export$1bd2035254432789.CORRECT;
        if (incorrectAnswersArray.includes(answer) && selectedAnswers.includes(answer)) return $24c02ea0e14dbe4f$var$$b55544cdfa85935b$export$1bd2035254432789.INCORRECT;
        if (correctAnswersArray.includes(answer) || status === $24c02ea0e14dbe4f$export$bf1c1ed72daa392b.SUCCESS) return $24c02ea0e14dbe4f$var$$b55544cdfa85935b$export$1bd2035254432789.DISABLED;
        if (selectedAnswers.includes(answer)) return $24c02ea0e14dbe4f$var$$b55544cdfa85935b$export$1bd2035254432789.SELECTED;
        return $24c02ea0e14dbe4f$var$$b55544cdfa85935b$export$1bd2035254432789.DEFAULT;
    };
    const getAnswerStatus = (answer)=>!!selectedAnswers.find((a)=>a.title === answer.title);
    return (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
        css: $24c02ea0e14dbe4f$var$$44303f6c3c81eeac$var$quizContainerStyles,
        id: "quiz",
        children: [
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("p", {
                ...$24c02ea0e14dbe4f$export$1784ac302bd8ebad("title", inspectMode),
                css: $24c02ea0e14dbe4f$var$$44303f6c3c81eeac$var$quizTitleStyles,
                children: title
            }),
            (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                css: $24c02ea0e14dbe4f$var$$44303f6c3c81eeac$var$quizContentContainerStyles,
                id: "quiz-question-container",
                "data-testid": "quiz-question-container",
                children: [
                    (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                        css: $24c02ea0e14dbe4f$var$$44303f6c3c81eeac$var$quizHeaderContainerStyles,
                        children: [
                            (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                                css: $24c02ea0e14dbe4f$var$$44303f6c3c81eeac$var$quizActionPanelContainerStyles,
                                children: [
                                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$353f5b6fc5456de1, {
                                        label: "back-button",
                                        disabled: !step,
                                        iconBefore: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$f04a61298a47a40f, {
                                            type: "arrow-left-circle"
                                        }),
                                        appearance: $24c02ea0e14dbe4f$export$261c9483fc4a455a.ICON,
                                        onClick: onPrevQuestionClick,
                                        iconType: "arrow-left-circle"
                                    }),
                                    (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("span", {
                                        css: $24c02ea0e14dbe4f$var$$44303f6c3c81eeac$var$questionsStepStyles,
                                        children: [
                                            "QUESTION ",
                                            step + 1,
                                            " 0F ",
                                            questions.length
                                        ]
                                    }),
                                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("span", {
                                        css: $24c02ea0e14dbe4f$var$$44303f6c3c81eeac$var$desktopScreenProgressContainerStyles,
                                        children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$c17561cb55d4db30, {
                                            progress: getQuizProgress()
                                        })
                                    }),
                                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$353f5b6fc5456de1, {
                                        label: "next-button",
                                        disabled: isNextButtonDisabled,
                                        iconBefore: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$f04a61298a47a40f, {
                                            type: "arrow-right-circle"
                                        }),
                                        appearance: $24c02ea0e14dbe4f$export$261c9483fc4a455a.ICON,
                                        onClick: onNextQuestionClick,
                                        iconType: "arrow-right-circle"
                                    })
                                ]
                            }),
                            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("span", {
                                css: $24c02ea0e14dbe4f$var$$44303f6c3c81eeac$var$mobileScreenProgressContainerStyles,
                                children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$c17561cb55d4db30, {
                                    progress: getQuizProgress()
                                })
                            })
                        ]
                    }),
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("p", {
                        ...$24c02ea0e14dbe4f$export$1784ac302bd8ebad("title", questions[step]?.inspectMode),
                        css: $24c02ea0e14dbe4f$var$$44303f6c3c81eeac$var$questionTitleStyles,
                        children: questions[step]?.title
                    }),
                    questions[step] && questions[step].imageUrl && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                        css: $24c02ea0e14dbe4f$var$$44303f6c3c81eeac$var$questionImageStyles,
                        children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$3e431a229df88919, {
                            src: questions[step].imageUrl,
                            alt: questions[step]?.title.props.children
                        })
                    }),
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("p", {
                        css: $24c02ea0e14dbe4f$var$$44303f6c3c81eeac$var$chooseCorrectAnswerStyles,
                        children: $24c02ea0e14dbe4f$export$cb9c858407602327[questions[step]?.type]
                    }),
                    questions[step]?.type === $24c02ea0e14dbe4f$export$51940fbbacba35d4.MATCHING && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                        children: questions[step]?.leftAnswers?.map((leftAnswer, index)=>{
                            const rightAnswer = questions[step]?.rightAnswers?.[index];
                            if (!rightAnswer) return null;
                            return (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                                css: $24c02ea0e14dbe4f$var$$44303f6c3c81eeac$var$quizInputsContainerStyles,
                                children: [
                                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$var$$b55544cdfa85935b$export$56e6c05354470c53, {
                                        inspectMode: leftAnswer?.inspectMode,
                                        elementId: leftAnswer.title,
                                        text: leftAnswer.title,
                                        onClick: ()=>toggleAnswer(leftAnswer),
                                        inputStatus: getInputStatus(leftAnswer)
                                    }),
                                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$var$$b55544cdfa85935b$export$56e6c05354470c53, {
                                        inspectMode: rightAnswer.inspectMode,
                                        elementId: rightAnswer.title,
                                        text: rightAnswer.title,
                                        onClick: ()=>toggleAnswer(rightAnswer),
                                        inputStatus: getInputStatus(rightAnswer)
                                    })
                                ]
                            }, leftAnswer.title + rightAnswer.title);
                        })
                    }),
                    (questions[step]?.type === $24c02ea0e14dbe4f$export$51940fbbacba35d4.SINGLE_SELECT || questions[step]?.type === $24c02ea0e14dbe4f$export$51940fbbacba35d4.MULTI_SELECT) && questionAnswers?.map((answer)=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                            css: $24c02ea0e14dbe4f$var$$44303f6c3c81eeac$var$answerContainerStyles,
                            ...$24c02ea0e14dbe4f$export$1784ac302bd8ebad("title", answer?.inspectMode),
                            children: questions[step]?.type === $24c02ea0e14dbe4f$export$51940fbbacba35d4.SINGLE_SELECT ? (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$d7b12c4107be0d61, {
                                size: width >= $24c02ea0e14dbe4f$var$$44303f6c3c81eeac$var$MOBILE_SCREEN_WIDTH ? $24c02ea0e14dbe4f$export$4da24539a3bb7d98.LARGE : $24c02ea0e14dbe4f$export$4da24539a3bb7d98.DEFAULT,
                                label: answer.title,
                                isChecked: getAnswerStatus(answer),
                                setIsChecked: ()=>toggleAnswer(answer),
                                type: $24c02ea0e14dbe4f$var$$44303f6c3c81eeac$var$QuizStatusToRadioType[answersStatus[answer.title]],
                                isBold: getAnswerStatus(answer)
                            }) : (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$48513f6b9f8ce62d, {
                                size: width >= $24c02ea0e14dbe4f$var$$44303f6c3c81eeac$var$MOBILE_SCREEN_WIDTH ? $24c02ea0e14dbe4f$export$5e435bc8b081a399.LARGE : $24c02ea0e14dbe4f$export$5e435bc8b081a399.DEFAULT,
                                label: answer.title,
                                onChange: ()=>toggleAnswer(answer),
                                isChecked: getAnswerStatus(answer),
                                type: $24c02ea0e14dbe4f$var$$44303f6c3c81eeac$var$QuizStatusToCheckboxType[answersStatus[answer.title]],
                                isBold: getAnswerStatus(answer)
                            })
                        }, answer.title)),
                    !isCompleted && status === $24c02ea0e14dbe4f$export$bf1c1ed72daa392b.DEFAULT && questions[step]?.type !== $24c02ea0e14dbe4f$export$51940fbbacba35d4.MATCHING && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                        css: [
                            $24c02ea0e14dbe4f$var$$44303f6c3c81eeac$var$buttonContainerStyles,
                            (0, $74Zh5.css)({
                                borderTop: `1px solid ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.border")}`,
                                paddingTop: "32px"
                            })
                        ],
                        children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$353f5b6fc5456de1, {
                            label: "Submit answer",
                            appearance: $24c02ea0e14dbe4f$export$261c9483fc4a455a.PRIMARY,
                            onClick: handleAnswerSubmit,
                            disabled: selectedAnswers.length === 0
                        })
                    }),
                    (status === $24c02ea0e14dbe4f$export$bf1c1ed72daa392b.SUCCESS || questions[step]?.type === $24c02ea0e14dbe4f$export$51940fbbacba35d4.MATCHING) && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                        css: $24c02ea0e14dbe4f$var$$44303f6c3c81eeac$var$buttonContainerStyles,
                        children: (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                            css: [
                                $24c02ea0e14dbe4f$var$$44303f6c3c81eeac$var$feedbackContainerStyles,
                                status !== $24c02ea0e14dbe4f$export$bf1c1ed72daa392b.SUCCESS && (0, $74Zh5.css)({
                                    borderTop: `1px solid ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.border")}`
                                })
                            ],
                            children: [
                                status === $24c02ea0e14dbe4f$export$bf1c1ed72daa392b.SUCCESS && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$f23c56ac9ab316f, {
                                    title: questions[step]?.type === $24c02ea0e14dbe4f$export$51940fbbacba35d4.MATCHING ? "Correct" : "That\u2019s correct",
                                    appearance: $24c02ea0e14dbe4f$export$f9292ef28b7b429a.CORRECT,
                                    description: questions[step]?.feedbackMessage
                                }),
                                (!isCompleted || questions[step]?.type === $24c02ea0e14dbe4f$export$51940fbbacba35d4.MATCHING && !isCompleted) && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("span", {
                                    css: (0, $74Zh5.css)({
                                        marginTop: "32px"
                                    }),
                                    children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$353f5b6fc5456de1, {
                                        disabled: status !== $24c02ea0e14dbe4f$export$bf1c1ed72daa392b.SUCCESS,
                                        label: "Next question",
                                        appearance: $24c02ea0e14dbe4f$export$261c9483fc4a455a.PRIMARY,
                                        onClick: onNextQuestionClick,
                                        iconAfter: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$f04a61298a47a40f, {
                                            type: "arrow-right"
                                        })
                                    })
                                })
                            ]
                        })
                    }),
                    (status === $24c02ea0e14dbe4f$export$bf1c1ed72daa392b.ERROR || status === $24c02ea0e14dbe4f$export$bf1c1ed72daa392b.PARTLY_CORRECT) && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                        css: $24c02ea0e14dbe4f$var$$44303f6c3c81eeac$var$buttonContainerStyles,
                        children: (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                            css: $24c02ea0e14dbe4f$var$$44303f6c3c81eeac$var$feedbackContainerStyles,
                            children: [
                                (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$f23c56ac9ab316f, {
                                    title: status === $24c02ea0e14dbe4f$export$bf1c1ed72daa392b.PARTLY_CORRECT ? "That\u2019s partly correct" : "That\u2019s not correct",
                                    appearance: $24c02ea0e14dbe4f$export$f9292ef28b7b429a.INCORRECT,
                                    description: questions[step]?.feedbackMessage
                                }),
                                (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("span", {
                                    css: (0, $74Zh5.css)({
                                        marginTop: "32px"
                                    }),
                                    children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$353f5b6fc5456de1, {
                                        label: "Try again",
                                        iconBefore: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$f04a61298a47a40f, {
                                            type: "refresh"
                                        }),
                                        appearance: $24c02ea0e14dbe4f$export$261c9483fc4a455a.PRIMARY,
                                        onClick: onTryAgain
                                    })
                                })
                            ]
                        })
                    }),
                    isCompleted && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("p", {
                        css: $24c02ea0e14dbe4f$var$$44303f6c3c81eeac$var$completionMessageStyles,
                        children: "\uD83C\uDF89 Quiz complete! Great work."
                    })
                ]
            }),
            isMatchingFeedbackVisible && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("span", {
                css: $24c02ea0e14dbe4f$var$$44303f6c3c81eeac$var$matchingFeedbackContainerStyles,
                children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$f23c56ac9ab316f, {
                    title: "That\u2019s correct",
                    appearance: $24c02ea0e14dbe4f$export$f9292ef28b7b429a.CORRECT
                })
            })
        ]
    });
};
const $24c02ea0e14dbe4f$var$$44303f6c3c81eeac$var$quizContainerStyles = (0, $74Zh5.css)({
    display: "flex",
    flexDirection: "column",
    alignItems: "center"
});
const $24c02ea0e14dbe4f$var$$44303f6c3c81eeac$var$quizContentContainerStyles = (0, $74Zh5.css)({
    padding: "32px 48px",
    borderRadius: "8px",
    boxShadow: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("elevation.shadow.raised"),
    maxWidth: "720px",
    width: "100%",
    backgroundColor: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.background.input"),
    [(0, $cb8cedbc477f5a81$export$987d49ffe1b0900f).below.md]: {
        maxWidth: "720px",
        width: "100%"
    },
    [(0, $cb8cedbc477f5a81$export$987d49ffe1b0900f).below.xs]: {
        padding: "24px 16px"
    }
});
const $24c02ea0e14dbe4f$var$$44303f6c3c81eeac$var$quizHeaderContainerStyles = (0, $74Zh5.css)({
    marginBottom: "32px",
    paddingBottom: "28px",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    borderBottom: `1px solid ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.border")}`,
    flexDirection: "row",
    [(0, $cb8cedbc477f5a81$export$987d49ffe1b0900f).below.sm]: {
        flexDirection: "column"
    },
    [(0, $cb8cedbc477f5a81$export$987d49ffe1b0900f).below.xs]: {
        marginBottom: "24px",
        paddingBottom: "24px"
    }
});
const $24c02ea0e14dbe4f$var$$44303f6c3c81eeac$var$quizActionPanelContainerStyles = (0, $74Zh5.css)({
    width: "100%",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center"
});
const $24c02ea0e14dbe4f$var$$44303f6c3c81eeac$var$quizTitleStyles = (0, $74Zh5.css)({
    fontFamily: "Charlie Display, sans-serif",
    fontSize: "40px",
    fontWeight: 700,
    lineHeight: "48px",
    letterSpacing: "-0.12px",
    marginTop: 0,
    marginBottom: "32px",
    textAlign: "center",
    [(0, $cb8cedbc477f5a81$export$987d49ffe1b0900f).below.xs]: {
        display: "none"
    }
});
const $24c02ea0e14dbe4f$var$$44303f6c3c81eeac$var$questionTitleStyles = (0, $74Zh5.css)({
    fontFamily: "Charlie Display, sans-serif",
    fontSize: "20px",
    fontWeight: 600,
    lineHeight: "28px",
    color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text"),
    marginTop: 0,
    marginBottom: "32px",
    [(0, $cb8cedbc477f5a81$export$987d49ffe1b0900f).below.xs]: {
        fontSize: "16px",
        lineHeight: "24px",
        marginBottom: "24px"
    }
});
const $24c02ea0e14dbe4f$var$$44303f6c3c81eeac$var$questionImageStyles = (0, $74Zh5.css)({
    padding: "24px 0"
});
const $24c02ea0e14dbe4f$var$$44303f6c3c81eeac$var$desktopScreenProgressContainerStyles = (0, $74Zh5.css)({
    width: "100%",
    margin: "0 24px 0 13px",
    [(0, $cb8cedbc477f5a81$export$987d49ffe1b0900f).below.sm]: {
        display: "none"
    }
});
const $24c02ea0e14dbe4f$var$$44303f6c3c81eeac$var$mobileScreenProgressContainerStyles = (0, $74Zh5.css)({
    [(0, $cb8cedbc477f5a81$export$987d49ffe1b0900f).below.sm]: {
        width: "100%",
        margin: 0,
        marginTop: "12px"
    }
});
const $24c02ea0e14dbe4f$var$$44303f6c3c81eeac$var$chooseCorrectAnswerStyles = (0, $74Zh5.css)({
    fontFamily: "Charlie Display, sans-serif",
    fontSize: "16px",
    fontWeight: 600,
    lineHeight: "24px",
    color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text.subtlest"),
    marginTop: 0,
    marginBottom: "24px",
    [(0, $cb8cedbc477f5a81$export$987d49ffe1b0900f).below.xs]: {
        fontSize: "14px",
        lineHeight: "22px",
        marginBottom: "16px"
    }
});
const $24c02ea0e14dbe4f$var$$44303f6c3c81eeac$var$answerContainerStyles = (0, $74Zh5.css)({
    marginBottom: "24px",
    [(0, $cb8cedbc477f5a81$export$987d49ffe1b0900f).below.xs]: {
        marginBottom: "20px"
    }
});
const $24c02ea0e14dbe4f$var$$44303f6c3c81eeac$var$quizInputsContainerStyles = (0, $74Zh5.css)({
    display: "flex",
    justifyContent: "space-between",
    width: "100%",
    gap: "24px",
    marginTop: "24px"
});
const $24c02ea0e14dbe4f$var$$44303f6c3c81eeac$var$buttonContainerStyles = (0, $74Zh5.css)({
    display: "flex",
    alignItems: "center",
    marginTop: "32px",
    [(0, $cb8cedbc477f5a81$export$987d49ffe1b0900f).below.xs]: {
        marginTop: "24px"
    }
});
const $24c02ea0e14dbe4f$var$$44303f6c3c81eeac$var$feedbackContainerStyles = (0, $74Zh5.css)({
    display: "flex",
    flexDirection: "column",
    width: "100%"
});
const $24c02ea0e14dbe4f$var$$44303f6c3c81eeac$var$questionsStepStyles = (0, $74Zh5.css)({
    minWidth: "115px",
    marginLeft: "24px",
    color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text"),
    fontFamily: "Charlie Text, sans-serif",
    fontSize: "14px",
    fontWeight: 600,
    lineHeight: "18px"
});
const $24c02ea0e14dbe4f$var$$44303f6c3c81eeac$var$completionMessageStyles = (0, $74Zh5.css)({
    marginTop: "40px",
    marginBottom: 0,
    color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text"),
    fontFamily: "Charlie Display, sans-serif",
    fontSize: "20px",
    fontWeight: 600,
    lineHeight: "28px",
    textAlign: "center"
});
const $24c02ea0e14dbe4f$var$$44303f6c3c81eeac$var$matchingFeedbackContainerStyles = (0, $74Zh5.css)({
    marginTop: "40px",
    maxWidth: "624px",
    width: "100%",
    [(0, $cb8cedbc477f5a81$export$987d49ffe1b0900f).below.xs]: {
        display: "none"
    }
});
var $24c02ea0e14dbe4f$var$$9c3f769544bb2079$exports = {};
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$9c3f769544bb2079$exports, "Sidebar", ()=>$24c02ea0e14dbe4f$export$1ba59dacbcbf90fe);
const $24c02ea0e14dbe4f$export$1ba59dacbcbf90fe = ({ onChangeMenuVisibility: onChangeMenuVisibility, isVisible: isVisible = true, children: children })=>{
    const toggleMenu = ()=>{
        if (onChangeMenuVisibility) onChangeMenuVisibility(!isVisible);
    };
    return (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
        css: $24c02ea0e14dbe4f$var$$9c3f769544bb2079$var$sidebarNavContainerStyles,
        children: [
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("button", {
                "data-testid": "button-toggle-menu-toggle",
                css: [
                    $24c02ea0e14dbe4f$var$$9c3f769544bb2079$var$buttonToggleMenuStyles,
                    !isVisible && $24c02ea0e14dbe4f$var$$9c3f769544bb2079$var$buttonToggleMenuClosedStyles,
                    isVisible && $24c02ea0e14dbe4f$var$$9c3f769544bb2079$var$buttonToggleMenuOpenStyles
                ],
                onClick: toggleMenu,
                "aria-label": "toggle menu",
                children: isVisible ? (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$f04a61298a47a40f, {
                    type: "chevron-left",
                    color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.icon")
                }) : (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$f04a61298a47a40f, {
                    type: "chevron-right",
                    color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.icon")
                })
            }),
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                css: $24c02ea0e14dbe4f$var$$9c3f769544bb2079$var$mobileButtonToggleMenuContainerStyles,
                children: (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("button", {
                    "data-testid": "button-toggle-menu-show",
                    css: $24c02ea0e14dbe4f$var$$9c3f769544bb2079$var$mobileButtonToggleMenuStyles,
                    onClick: toggleMenu,
                    "aria-label": "show menu",
                    children: [
                        isVisible ? (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$f04a61298a47a40f, {
                            type: "dropdown-cross",
                            color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.icon")
                        }) : (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$f04a61298a47a40f, {
                            type: "menu-icon",
                            color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.icon")
                        }),
                        isVisible ? (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                            css: (0, $74Zh5.css)({
                                span: {
                                    color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.icon")
                                }
                            }),
                            children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$5f1af8db9871e1d6, {
                                children: "Close"
                            })
                        }) : (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                            css: (0, $74Zh5.css)({
                                span: {
                                    color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.icon")
                                }
                            }),
                            children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$5f1af8db9871e1d6, {
                                children: "Menu"
                            })
                        })
                    ]
                })
            }),
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                css: [
                    isVisible && $24c02ea0e14dbe4f$var$$9c3f769544bb2079$var$sidebarOpenStyles,
                    !isVisible && $24c02ea0e14dbe4f$var$$9c3f769544bb2079$var$sidebarClosedStyles,
                    $24c02ea0e14dbe4f$var$$9c3f769544bb2079$var$sidebarStyles
                ],
                "data-testid": "sidebar",
                children: isVisible && children
            })
        ]
    });
};
const $24c02ea0e14dbe4f$var$$9c3f769544bb2079$var$sidebarNavContainerStyles = (0, $74Zh5.css)({
    position: "absolute",
    height: "100%",
    opacity: 1,
    display: "block",
    transform: "translateX(0px)",
    [(0, $cb8cedbc477f5a81$export$987d49ffe1b0900f).below.sm]: {
        width: "100%",
        position: "absolute"
    }
});
const $24c02ea0e14dbe4f$var$$9c3f769544bb2079$var$sidebarStyles = (0, $74Zh5.css)({
    transition: "all",
    transitionTimingFunction: "cubic-bezier(0.4, 0, 0.2, 1)",
    transitionDuration: "300ms",
    height: "100%",
    paddingTop: "1.75rem",
    paddingRight: "7px",
    paddingLeft: "0.5rem",
    top: 0,
    bottom: 0,
    left: 0,
    borderRightWidth: "1px",
    borderStyle: "solid",
    borderColor: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.border"),
    borderTop: "none",
    borderLeft: "none",
    backgroundColor: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("elevation.surface.sunken"),
    overflowY: "auto",
    overflowX: "hidden"
});
const $24c02ea0e14dbe4f$var$$9c3f769544bb2079$var$sidebarClosedStyles = (0, $74Zh5.css)({
    width: "1.25rem",
    [(0, $cb8cedbc477f5a81$export$987d49ffe1b0900f).below.sm]: {
        top: 0,
        borderRightWidth: 0,
        paddingTop: 0,
        height: 0,
        width: "100%",
        position: "absolute"
    }
});
const $24c02ea0e14dbe4f$var$$9c3f769544bb2079$var$sidebarOpenStyles = (0, $74Zh5.css)({
    display: "block",
    transform: "translateX(0px)",
    paddingTop: "1.75rem",
    position: "fixed",
    [(0, $cb8cedbc477f5a81$export$987d49ffe1b0900f).below.sm]: {
        width: "100vw",
        marginTop: "3rem",
        position: "absolute"
    },
    [(0, $cb8cedbc477f5a81$export$987d49ffe1b0900f).above.sm]: {
        width: "26.25rem",
        position: "absolute"
    },
    [(0, $cb8cedbc477f5a81$export$987d49ffe1b0900f).below.md]: {
        boxShadow: `0 0 0 10000px ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.blanket")}`
    },
    [(0, $cb8cedbc477f5a81$export$987d49ffe1b0900f).above.lg]: {
        position: "relative",
        boxShadow: "none"
    }
});
const $24c02ea0e14dbe4f$var$$9c3f769544bb2079$var$mobileButtonToggleMenuContainerStyles = (0, $74Zh5.css)({
    display: "none",
    alignItems: "center",
    justifyContent: "align-start",
    width: "100vw",
    paddingLeft: "1rem",
    height: "3rem",
    borderBottom: `1px solid ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.border")}`,
    borderLeft: "none",
    borderRight: "none",
    backgroundColor: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.background.input"),
    position: "relative",
    zIndex: 200,
    [(0, $cb8cedbc477f5a81$export$987d49ffe1b0900f).below.sm]: {
        display: "flex"
    }
});
const $24c02ea0e14dbe4f$var$$9c3f769544bb2079$var$mobileButtonToggleMenuStyles = (0, $74Zh5.css)({
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: 0,
    border: "none",
    background: "transparent",
    outline: "none"
});
const $24c02ea0e14dbe4f$var$$9c3f769544bb2079$var$buttonToggleMenuStyles = (0, $74Zh5.css)({
    transition: "all",
    transitionTimingFunction: "cubic-bezier(0.4, 0, 0.2, 1)",
    transitionDuration: "300ms",
    border: "none",
    borderRadius: "9999px",
    backgroundColor: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.background.input"),
    width: "1.5rem",
    height: "1.5rem",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    boxShadow: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("elevation.shadow.overlay"),
    position: "absolute",
    top: "1.75rem",
    zIndex: 200,
    cursor: "pointer",
    [(0, $cb8cedbc477f5a81$export$987d49ffe1b0900f).below.sm]: {
        display: "none"
    }
});
const $24c02ea0e14dbe4f$var$$9c3f769544bb2079$var$buttonToggleMenuOpenStyles = (0, $74Zh5.css)({
    marginLeft: "25.5rem"
});
const $24c02ea0e14dbe4f$var$$9c3f769544bb2079$var$buttonToggleMenuClosedStyles = (0, $74Zh5.css)({
    marginLeft: "0.5rem"
});
var $24c02ea0e14dbe4f$var$$3d76652bb6362040$exports = {};
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$3d76652bb6362040$exports, "LearningSidebar", ()=>$24c02ea0e14dbe4f$export$4ff69a78d3a65d6f);
var $24c02ea0e14dbe4f$var$$ef44b01e6346ac17$require$Buffer = (0, $7KfP5.Buffer);
const $24c02ea0e14dbe4f$var$$ef44b01e6346ac17$var$badge = `<svg width="120" height="120" viewBox="0 0 120 120" fill="none" xmlns="http://www.w3.org/2000/svg">
<mask id="mask0_2407_668" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="120" height="120">
<path d="M60 120C93.1371 120 120 93.1371 120 60C120 26.8629 93.1371 0 60 0C26.8629 0 0 26.8629 0 60C0 93.1371 26.8629 120 60 120Z" fill="#FCA700"/>
</mask>
<g mask="url(#mask0_2407_668)">
<path d="M59.9919 120.001C93.129 120.001 119.992 93.1381 119.992 60.001C119.992 26.8639 93.129 0.00100708 59.9919 0.00100708C26.8549 0.00100708 -0.00805664 26.8639 -0.00805664 60.001C-0.00805664 93.1381 26.8549 120.001 59.9919 120.001Z" fill="#F0F1F2"/>
<path d="M114.195 48.5778C139.041 82.736 131.616 130.479 97.5729 155.447L75.6838 125.554C93.1971 112.63 97.0229 88.0317 84.2648 70.3823L114.195 48.5778Z" stroke="#1868DB" stroke-width="0.5"/>
<path d="M61.381 -11.1668L61.381 -11.1667L61.3875 -11.1713C66.9496 -15.1726 72.2687 -18.6935 77.3965 -21.8258L116.987 15.9668C109.215 16.5818 99.355 21.2346 85.3825 30.54L85.3825 30.5399L85.3765 30.5441C79.0802 35.0076 73.098 38.8783 67.3602 42.2665L28.6585 5.32281C36.6192 3.90769 46.9288 -1.45355 61.381 -11.1668Z" stroke="#1868DB" stroke-width="0.5"/>
<path d="M-4.01227 93.1467L46.5982 80.1918L59.4265 130.835L8.81594 143.79L-4.01227 93.1467Z" stroke="#1868DB" stroke-width="0.5"/>
<path d="M3.67239 23.827L3.68518 23.7211L3.66478 23.6962C4.43632 16.9412 1.0124 10.0403 -2.57376 4.84886C-4.3803 2.23367 -6.23694 0.0395466 -7.64175 -1.5007C-8.34432 -2.27099 -8.93428 -2.8782 -9.34902 -3.29322C-9.39083 -3.33506 -9.43086 -3.37495 -9.46905 -3.41285L13.9267 -0.587166C22.5213 4.49206 28.577 10.8772 32.2178 18.2212C35.8649 25.5781 37.096 33.9122 36.0121 42.8863C34.4107 56.146 27.9882 65.8687 18.1125 72.3709C8.28951 78.8384 -4.96514 82.1287 -20.3194 82.5128L-15.6409 43.7758C-9.8996 42.5993 -5.41093 40.3431 -2.18767 37.026C1.06994 33.6736 3.01663 29.2565 3.67239 23.827Z" stroke="#1868DB" stroke-width="0.5"/>
<path d="M98.1255 59.8467C98.1255 81.1403 81.101 98.3963 60.1074 98.3963C39.1139 98.3963 22.0894 81.1403 22.0894 59.8467C22.0894 38.5531 39.1139 21.2971 60.1074 21.2971C81.101 21.2971 98.1255 38.5531 98.1255 59.8467Z" stroke="#1868DB" stroke-width="0.5"/>
<path d="M35.4794 65.1887C35.2675 65.5337 35.0269 65.9381 34.84 66.2562C34.66 66.5631 34.7569 66.9575 35.06 67.1444L39.3062 69.765C39.6175 69.9569 40.025 69.8581 40.2106 69.5431C40.3794 69.2575 40.5981 68.89 40.8369 68.495C42.52 65.7175 44.2125 66.0562 47.2619 67.5056L51.4731 69.5075C51.805 69.6656 52.2019 69.5181 52.3512 69.1819L54.3737 64.6156C54.5175 64.2906 54.3762 63.9112 54.055 63.76C53.1656 63.3419 51.3981 62.5075 49.8156 61.7412C44.0656 58.9569 39.2 59.1406 35.48 65.1887H35.4794Z" fill="url(#paint0_linear_2407_668)"/>
<path d="M54.5206 54.8113C54.7325 54.4663 54.9731 54.0619 55.16 53.7438C55.34 53.4369 55.2431 53.0425 54.94 52.8556L50.6938 50.235C50.3825 50.0431 49.975 50.1419 49.7894 50.4569C49.6206 50.7425 49.4019 51.11 49.1631 51.505C47.48 54.2825 45.7875 53.9438 42.7381 52.4944L38.5269 50.4925C38.195 50.3344 37.7981 50.4819 37.6488 50.8181L35.6263 55.3844C35.4825 55.7094 35.6238 56.0888 35.945 56.24C36.8344 56.6581 38.6019 57.4925 40.1844 58.2588C45.9344 61.0431 50.8 60.8594 54.52 54.8113H54.5206Z" fill="url(#paint1_linear_2407_668)"/>
<path d="M85.1263 49.5188H73.8275C73.8275 52.335 76.1106 54.6175 78.9263 54.6175H81.0069V56.6256C81.0069 59.4419 83.29 61.7244 86.1056 61.7244V50.4988C86.1056 49.9575 85.6669 49.5188 85.1256 49.5188H85.1263Z" fill="#1D7AFC"/>
<path d="M79.5345 55.1475H68.2357C68.2357 57.9638 70.5188 60.2463 73.3345 60.2463H75.4151V62.2544C75.4151 65.0706 77.6982 67.3531 80.5138 67.3531V56.1275C80.5138 55.5863 80.0751 55.1475 79.5338 55.1475H79.5345Z" fill="url(#paint2_linear_2407_668)"/>
<path d="M73.9425 60.7756H62.6438C62.6438 63.5919 64.9269 65.8744 67.7425 65.8744H69.8232V67.8825C69.8232 70.6988 72.1063 72.9813 74.9219 72.9813V61.7556C74.9219 61.2144 74.4832 60.7756 73.9419 60.7756H73.9425Z" fill="url(#paint3_linear_2407_668)"/>
</g>
<defs>
<linearGradient id="paint0_linear_2407_668" x1="54.2475" y1="71.11" x2="41.3981" y2="63.7263" gradientUnits="userSpaceOnUse">
<stop stop-color="#0055CC"/>
<stop offset="0.972" stop-color="#1C78FA"/>
<stop offset="1" stop-color="#1D7AFC"/>
</linearGradient>
<linearGradient id="paint1_linear_2407_668" x1="35.7519" y1="48.89" x2="48.6019" y2="56.2738" gradientUnits="userSpaceOnUse">
<stop stop-color="#0055CC"/>
<stop offset="0.972" stop-color="#1C78FA"/>
<stop offset="1" stop-color="#1D7AFC"/>
</linearGradient>
<linearGradient id="paint2_linear_2407_668" x1="80.2745" y1="55.1663" x2="75.4682" y2="60.1225" gradientUnits="userSpaceOnUse">
<stop offset="0.176" stop-color="#0055CC"/>
<stop offset="1" stop-color="#1D7AFC"/>
</linearGradient>
<linearGradient id="paint3_linear_2407_668" x1="75.0019" y1="60.8281" x2="69.445" y2="66.2344" gradientUnits="userSpaceOnUse">
<stop offset="0.176" stop-color="#0055CC"/>
<stop offset="1" stop-color="#1D7AFC"/>
</linearGradient>
</defs>
</svg>`;
const $24c02ea0e14dbe4f$var$$ef44b01e6346ac17$export$44f5f766f3f98994 = `data:image/svg+xml;base64,${$24c02ea0e14dbe4f$var$$ef44b01e6346ac17$require$Buffer.from($24c02ea0e14dbe4f$var$$ef44b01e6346ac17$var$badge).toString("base64")}`;
const $24c02ea0e14dbe4f$var$$32c02b5652036d7a$var$SidebarContext = (0, $5FkrB.createContext)(undefined);
const $24c02ea0e14dbe4f$var$$32c02b5652036d7a$export$861cd542ff836f0d = ()=>{
    const context = (0, $5FkrB.useContext)($24c02ea0e14dbe4f$var$$32c02b5652036d7a$var$SidebarContext);
    if (!context) throw new Error("useSidebarContext must be used within a SidebarContextProvider");
    return context;
};
const $24c02ea0e14dbe4f$var$$32c02b5652036d7a$export$d8355e8edbcacbe8 = ({ children: children })=>{
    const [hoverInfo, setHoverInfo] = (0, $5FkrB.useState)(null);
    const popupRef = (0, $5FkrB.useRef)(null);
    const lastIdRef = (0, $5FkrB.useRef)(null);
    const timeoutRef = (0, $5FkrB.useRef)(null);
    const clear = (0, $5FkrB.useCallback)(()=>{
        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
            timeoutRef.current = null;
        }
    }, []);
    const handleMouseEnter = (0, $5FkrB.useCallback)((data)=>{
        clear();
        if (lastIdRef.current !== data.courseId) setHoverInfo(null);
        lastIdRef.current = data.courseId;
        timeoutRef.current = setTimeout(()=>{
            if (lastIdRef.current === data.courseId) setHoverInfo(data);
        }, 1000);
    }, [
        clear
    ]);
    const handleMouseLeave = (0, $5FkrB.useCallback)((id)=>{
        clear();
        if (!id || lastIdRef.current === id) {
            lastIdRef.current = null;
            setHoverInfo(null);
        }
    }, [
        clear
    ]);
    const contextValue = (0, $5FkrB.useMemo)(()=>({
            hoverInfo: hoverInfo,
            handleMouseEnter: handleMouseEnter,
            handleMouseLeave: handleMouseLeave,
            popupRef: popupRef
        }), [
        hoverInfo,
        handleMouseEnter,
        handleMouseLeave
    ]);
    return (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$var$$32c02b5652036d7a$var$SidebarContext.Provider, {
        value: contextValue,
        children: children
    });
};
const $24c02ea0e14dbe4f$var$$48630d5962798e4a$export$272e7ef3ea22070d = (status)=>{
    switch(status){
        case $24c02ea0e14dbe4f$var$$035f8a623e403361$export$23d03d0b3065d061.COMPLETED:
            return $24c02ea0e14dbe4f$var$$035f8a623e403361$export$490c7ce941281ba8.COMPLETED;
        case $24c02ea0e14dbe4f$var$$035f8a623e403361$export$23d03d0b3065d061.IN_PROGRESS:
        case $24c02ea0e14dbe4f$var$$035f8a623e403361$export$23d03d0b3065d061.NOT_STARTED:
        default:
            return $24c02ea0e14dbe4f$var$$035f8a623e403361$export$490c7ce941281ba8.DEFAULT;
    }
};
const $24c02ea0e14dbe4f$var$$48630d5962798e4a$export$15379570ba48f04d = (courseSlug, lessonSlug, sectionSlug)=>{
    const currentPath = globalThis.location.pathname;
    const currentHash = globalThis.location.hash;
    if (courseSlug) return currentPath.includes(`/course/${courseSlug}`);
    if (sectionSlug === "quiz") return currentPath.includes(`lesson/${lessonSlug}`) && currentHash === "#quiz";
    if (sectionSlug) return currentPath.includes(`/lesson/${lessonSlug}`) && currentHash === `#${sectionSlug}`;
    if (lessonSlug) {
        const lessonPath = `/lesson/${lessonSlug}`;
        return currentPath.endsWith(lessonPath) || currentPath.includes(lessonPath + "/");
    }
    return currentHash === `#${sectionSlug}`;
};
const $24c02ea0e14dbe4f$var$$48630d5962798e4a$export$1308f255697e8777 = (lessonsCollection, progressForLessons)=>{
    const numberOfCompletedLessons = lessonsCollection.items.filter(({ sys: { id: id } })=>$24c02ea0e14dbe4f$var$$48630d5962798e4a$export$272e7ef3ea22070d(progressForLessons?.lessons.find((lesson)=>lesson.lessonId === id)?.status) === $24c02ea0e14dbe4f$var$$035f8a623e403361$export$490c7ce941281ba8.COMPLETED).length;
    const numberOfTotalLessons = lessonsCollection.items.length;
    const progress = numberOfTotalLessons === 0 ? 0 : numberOfCompletedLessons / numberOfTotalLessons * 100;
    const isStatusCompleted = progress === 100;
    return {
        progress: progress,
        isStatusCompleted: isStatusCompleted
    };
};
const $24c02ea0e14dbe4f$var$$6cca9b298ff547cb$export$a9a23386c3e0c05f = ({ lessonsCollection: lessonsCollection, progressForLessons: progressForLessons, reward: reward, title: title })=>{
    const { progress: progress, isStatusCompleted: isStatusCompleted } = (0, $5FkrB.useMemo)(()=>$24c02ea0e14dbe4f$var$$48630d5962798e4a$export$1308f255697e8777(lessonsCollection, progressForLessons), [
        lessonsCollection,
        progressForLessons
    ]);
    return (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
        css: $24c02ea0e14dbe4f$var$$6cca9b298ff547cb$var$progressCircleContainerStyles,
        "data-testid": "course-progress-circle",
        children: [
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $f188eff9b59fb855$export$5ab97151efedb8c6), {
                strokeWidth: 8,
                value: progress,
                styles: (0, $f188eff9b59fb855$export$5115a192ad9bf57f)({
                    pathColor: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.border.success"),
                    trailColor: "rgba(9, 30, 66, 0.14)"
                }),
                css: [
                    isStatusCompleted && $24c02ea0e14dbe4f$var$$6cca9b298ff547cb$var$completedCourseProgressStyles
                ],
                children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                    css: [
                        $24c02ea0e14dbe4f$var$$6cca9b298ff547cb$var$imageBadgeContainerStyles,
                        isStatusCompleted && $24c02ea0e14dbe4f$var$$6cca9b298ff547cb$var$completedCourseProgressStyles
                    ],
                    children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("img", {
                        css: $24c02ea0e14dbe4f$var$$6cca9b298ff547cb$var$imageStyles,
                        "data-testid": "course-badge-image",
                        src: reward?.badgeCdnUrl || $24c02ea0e14dbe4f$var$$ef44b01e6346ac17$export$44f5f766f3f98994,
                        alt: title
                    })
                })
            }),
            isStatusCompleted && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$f04a61298a47a40f, {
                type: "check",
                color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.icon.success")
            })
        ]
    });
};
const $24c02ea0e14dbe4f$var$$6cca9b298ff547cb$var$completedCourseProgressStyles = (0, $74Zh5.css)({
    opacity: "0.2"
});
const $24c02ea0e14dbe4f$var$$6cca9b298ff547cb$var$progressCircleContainerStyles = (0, $74Zh5.css)({
    position: "relative",
    maxWidth: "32px",
    span: {
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)"
    }
});
const $24c02ea0e14dbe4f$var$$6cca9b298ff547cb$var$imageBadgeContainerStyles = (0, $74Zh5.css)({
    width: "100%",
    height: "100%",
    padding: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.100")
});
const $24c02ea0e14dbe4f$var$$6cca9b298ff547cb$var$imageStyles = (0, $74Zh5.css)({
    width: "100%",
    height: "100%",
    objectFit: "contain",
    borderRadius: "50%"
});
let $24c02ea0e14dbe4f$var$$47b694880a211b2b$export$40bdb27f2137fcf;
(function(Appearance) {
    Appearance["COURSE"] = "course";
    Appearance["LESSON"] = "lesson";
    Appearance["SECTION"] = "section";
})($24c02ea0e14dbe4f$var$$47b694880a211b2b$export$40bdb27f2137fcf || ($24c02ea0e14dbe4f$var$$47b694880a211b2b$export$40bdb27f2137fcf = {}));
/**
 * Props for the TextTooltip component
 * @param {string} text - Text to display in the tooltip
 * @param {CardStatus} status - Current status of the item (completed, or default)
 * @param {Appearance} appearance - Whether the item is a course card or lesson card
 * @param {boolean} isSelected - Whether the item is selected
 */ const $24c02ea0e14dbe4f$var$$47b694880a211b2b$var$MOBILE_SCREEN_WIDTH = 650;
const $24c02ea0e14dbe4f$var$$47b694880a211b2b$export$c0d3d8bfa41e2e2a = ({ text: text, status: status, appearance: appearance, isSelected: isSelected })=>{
    const [isTruncated, setIsTruncated] = (0, $5FkrB.useState)(false);
    const textRef = (0, $5FkrB.useRef)(null);
    const deviceSize = $24c02ea0e14dbe4f$export$4616d33c54ae5baf();
    const isMobile = deviceSize <= $24c02ea0e14dbe4f$var$$47b694880a211b2b$var$MOBILE_SCREEN_WIDTH;
    (0, $5FkrB.useEffect)(()=>{
        const checkTruncation = ()=>{
            if (textRef.current) setIsTruncated(textRef.current.scrollWidth > textRef.current.clientWidth);
        };
        checkTruncation();
        window.addEventListener("resize", checkTruncation);
        return ()=>{
            window.removeEventListener("resize", checkTruncation);
        };
    }, [
        text
    ]);
    const isLesson = appearance === $24c02ea0e14dbe4f$var$$47b694880a211b2b$export$40bdb27f2137fcf.LESSON;
    const isCourse = appearance === $24c02ea0e14dbe4f$var$$47b694880a211b2b$export$40bdb27f2137fcf.COURSE;
    const isSection = appearance === $24c02ea0e14dbe4f$var$$47b694880a211b2b$export$40bdb27f2137fcf.SECTION;
    const textElement = (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("p", {
        "data-testid": "sidebar-text-tooltip",
        ref: textRef,
        css: [
            isCourse && $24c02ea0e14dbe4f$var$$47b694880a211b2b$var$courseTitleStyles,
            isCourse && isSelected && $24c02ea0e14dbe4f$var$$47b694880a211b2b$var$titleSelectedStyles,
            isLesson && $24c02ea0e14dbe4f$var$$47b694880a211b2b$var$lessonTitleStyles,
            isMobile && isLesson && $24c02ea0e14dbe4f$var$$47b694880a211b2b$var$regularDecorationStyles,
            isLesson && isSelected && $24c02ea0e14dbe4f$var$$47b694880a211b2b$var$titleSelectedStyles,
            $24c02ea0e14dbe4f$var$$47b694880a211b2b$var$sectionTitleStyles,
            isCourse && $24c02ea0e14dbe4f$var$$47b694880a211b2b$var$courseMaxWidth,
            isLesson && $24c02ea0e14dbe4f$var$$47b694880a211b2b$var$lessonMaxWidth,
            status === $24c02ea0e14dbe4f$var$$035f8a623e403361$export$490c7ce941281ba8.COMPLETED && $24c02ea0e14dbe4f$var$$47b694880a211b2b$var$sectionTitleCompletedStyles,
            status === $24c02ea0e14dbe4f$var$$035f8a623e403361$export$490c7ce941281ba8.DEFAULT && $24c02ea0e14dbe4f$var$$47b694880a211b2b$var$sectionTitleDefaultStyles,
            isSection && isSelected && $24c02ea0e14dbe4f$var$$47b694880a211b2b$var$sectionTitleSelectedStyles
        ],
        children: text
    });
    return isTruncated ? (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $1ee6819d2d8fb6a1$export$2e2bcd8739ae039), {
        content: text,
        position: isMobile ? "bottom" : "right",
        children: textElement
    }) : textElement;
};
const $24c02ea0e14dbe4f$var$$47b694880a211b2b$var$sectionTitleStyles = (0, $74Zh5.css)({
    fontFamily: "Inter, sans-serif",
    fontWeight: 400,
    lineHeight: "24px",
    fontSize: "16px",
    marginTop: 0,
    marginLeft: "10px",
    maxWidth: "330px",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    [(0, $cb8cedbc477f5a81$export$987d49ffe1b0900f).below.xs]: {
        maxWidth: "290px"
    }
});
const $24c02ea0e14dbe4f$var$$47b694880a211b2b$var$sectionTitleSelectedStyles = (0, $74Zh5.css)({
    fontWeight: 600,
    color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text.selected")
});
const $24c02ea0e14dbe4f$var$$47b694880a211b2b$var$sectionTitleCompletedStyles = (0, $74Zh5.css)({
    color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text.subtlest")
});
const $24c02ea0e14dbe4f$var$$47b694880a211b2b$var$sectionTitleDefaultStyles = (0, $74Zh5.css)({
    color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text.subtle")
});
const $24c02ea0e14dbe4f$var$$47b694880a211b2b$var$lessonTitleStyles = (0, $74Zh5.css)({
    fontFamily: "Inter, sans-serif",
    fontWeight: 400,
    lineHeight: "24px",
    fontSize: "16px",
    color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text.subtle"),
    marginTop: 0,
    marginRight: "auto",
    marginLeft: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.025"),
    "&:hover": {
        textDecoration: "underline"
    }
});
const $24c02ea0e14dbe4f$var$$47b694880a211b2b$var$regularDecorationStyles = (0, $74Zh5.css)({
    "&:hover": {
        textDecoration: "none"
    }
});
const $24c02ea0e14dbe4f$var$$47b694880a211b2b$var$titleSelectedStyles = (0, $74Zh5.css)({
    fontWeight: "500 !important",
    color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text")
});
const $24c02ea0e14dbe4f$var$$47b694880a211b2b$var$courseTitleStyles = (0, $74Zh5.css)({
    color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text.subtlest"),
    fontFamily: "Inter, sans-serif",
    fontSize: "16px",
    fontWeight: 500,
    lineHeight: "24px",
    marginTop: 0
});
const $24c02ea0e14dbe4f$var$$47b694880a211b2b$var$courseMaxWidth = (0, $74Zh5.css)({
    marginLeft: 0,
    maxWidth: "320px"
});
const $24c02ea0e14dbe4f$var$$47b694880a211b2b$var$lessonMaxWidth = (0, $74Zh5.css)({
    marginLeft: 0,
    marginRight: "auto",
    maxWidth: "290px",
    [(0, $cb8cedbc477f5a81$export$987d49ffe1b0900f).below.xs]: {
        maxWidth: "270px"
    }
});
const $24c02ea0e14dbe4f$var$$0efd93166e145c77$export$a3b47b9708ebe4f0 = {
    [$24c02ea0e14dbe4f$var$$035f8a623e403361$export$490c7ce941281ba8.DEFAULT]: "dot-default",
    [$24c02ea0e14dbe4f$var$$035f8a623e403361$export$490c7ce941281ba8.COMPLETED]: "dot-completed"
};
const $24c02ea0e14dbe4f$var$$0efd93166e145c77$export$411533295806dc51 = (sectionContentfulId, seenSectionObserver)=>{
    const element = document.getElementById(`${sectionContentfulId}`);
    if (element) seenSectionObserver.unobserve(element);
};
const $24c02ea0e14dbe4f$var$$0efd93166e145c77$export$a1fd357e7aacc4df = (0, $5FkrB.memo)(({ section: { title: title, id: id }, status: status, courseSlug: courseSlug, lessonSlug: lessonSlug, onSelect: onSelect, isSelected: isSelected })=>{
    const handleSectionClick = (e)=>{
        e.stopPropagation();
        onSelect(courseSlug || "", lessonSlug, id);
    };
    const handleKeyboardClick = (0, $5FkrB.useCallback)(()=>{
        onSelect(courseSlug || "", lessonSlug, id);
    }, [
        onSelect,
        courseSlug,
        lessonSlug,
        id
    ]);
    const onKeyDown = $24c02ea0e14dbe4f$export$2a0b6757d41dacb2(handleKeyboardClick);
    const getIconType = ()=>{
        if (isSelected && status === $24c02ea0e14dbe4f$var$$035f8a623e403361$export$490c7ce941281ba8.COMPLETED) return $24c02ea0e14dbe4f$var$$0efd93166e145c77$export$a3b47b9708ebe4f0[status];
        if (isSelected) return "dot-selected";
        return $24c02ea0e14dbe4f$var$$0efd93166e145c77$export$a3b47b9708ebe4f0[status];
    };
    const type = getIconType();
    return (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
        role: "button",
        tabIndex: 0,
        "data-testid": "sidebar-section-item",
        css: [
            $24c02ea0e14dbe4f$var$$0efd93166e145c77$var$sectionBarStyles,
            isSelected && $24c02ea0e14dbe4f$var$$0efd93166e145c77$var$sectionBarSelectedStyles
        ],
        onClick: handleSectionClick,
        onKeyDown: onKeyDown,
        children: [
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$f04a61298a47a40f, {
                type: type,
                color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.icon")
            }),
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$var$$47b694880a211b2b$export$c0d3d8bfa41e2e2a, {
                text: title,
                status: status,
                isSelected: isSelected,
                appearance: $24c02ea0e14dbe4f$var$$47b694880a211b2b$export$40bdb27f2137fcf.SECTION
            })
        ]
    });
});
const $24c02ea0e14dbe4f$var$$0efd93166e145c77$var$sectionBarStyles = (0, $74Zh5.css)({
    position: "relative",
    display: "flex",
    alignItems: "center",
    width: "100%",
    padding: "4px 0 4px 10px",
    borderRadius: "4px",
    cursor: "pointer",
    "&:active": {
        background: `${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.background.accent.gray.subtlest.hovered")} !important`
    },
    "&:hover": {
        background: "rgba(220, 223, 228, 0.50)",
        "&::before": {
            content: '""',
            display: "block",
            width: "2px",
            height: "12px",
            position: "absolute",
            left: 0,
            top: "50%",
            transform: "translateY(-50%)",
            background: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.background.neutral")
        }
    }
});
const $24c02ea0e14dbe4f$var$$0efd93166e145c77$var$sectionBarSelectedStyles = (0, $74Zh5.css)({
    "&::before": {
        content: '""',
        display: "block",
        width: "2px",
        height: "12px",
        position: "absolute",
        left: 0,
        top: "50%",
        transform: "translateY(-50%)",
        background: `${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text.selected")} !important`
    }
});
const $24c02ea0e14dbe4f$var$$4baed82dabfd5555$var$loadingFlash = (0, $74Zh5.keyframes)`
  0% {
    background-position: -10px;
  }
  100% {
    background-position: calc(100% + 250px);
  }
`;
const $24c02ea0e14dbe4f$var$$4baed82dabfd5555$var$skeletonStyles = (0, $74Zh5.css)({
    width: "100%",
    height: "100%",
    backgroundColor: "rgba(241, 242, 244, 1)",
    borderRadius: "4px",
    position: "relative",
    "&::before": {
        content: '""',
        display: "block",
        width: "100%",
        height: "100%",
        borderRadius: "4px",
        background: `linear-gradient(
      90deg,
      rgba(241, 242, 244, 1) 0,
      #f9f9f9 calc(50% - 25px),
      #f9f9f9 calc(50% + 25px),
      rgba(241, 242, 244, 1) 100%
    )`,
        backgroundSize: "35%",
        backgroundPosition: 0,
        backgroundRepeat: "no-repeat",
        animation: `${$24c02ea0e14dbe4f$var$$4baed82dabfd5555$var$loadingFlash} 2.5s infinite linear`
    }
});
const $24c02ea0e14dbe4f$var$$4baed82dabfd5555$export$27a22c945b52f415 = ()=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
        css: $24c02ea0e14dbe4f$var$$4baed82dabfd5555$var$skeletonStyles,
        "data-testid": "skeleton-loader"
    });
const $24c02ea0e14dbe4f$var$$193bb26965d10640$export$9794789a1567361c = (0, $5FkrB.memo)(()=>(0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
        css: $24c02ea0e14dbe4f$var$$193bb26965d10640$var$loaderContainerStyles,
        children: [
            [
                ...Array(4)
            ].map((_, index)=>(0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                    css: $24c02ea0e14dbe4f$var$$193bb26965d10640$var$sectionBarStyles,
                    children: [
                        (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$f04a61298a47a40f, {
                            type: $24c02ea0e14dbe4f$var$$0ca1c0d89e77a13d$export$a3b47b9708ebe4f0[$24c02ea0e14dbe4f$var$$035f8a623e403361$export$490c7ce941281ba8.DEFAULT],
                            color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.icon")
                        }),
                        (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                            css: $24c02ea0e14dbe4f$var$$193bb26965d10640$var$skeletonLoaderBarStyles,
                            children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$var$$4baed82dabfd5555$export$27a22c945b52f415, {})
                        })
                    ]
                }, index)),
            (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                css: $24c02ea0e14dbe4f$var$$193bb26965d10640$var$sectionBarStyles,
                children: [
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$f04a61298a47a40f, {
                        type: $24c02ea0e14dbe4f$var$$0ca1c0d89e77a13d$export$a3b47b9708ebe4f0[$24c02ea0e14dbe4f$var$$035f8a623e403361$export$490c7ce941281ba8.DEFAULT],
                        color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.icon")
                    }),
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$var$$47b694880a211b2b$export$c0d3d8bfa41e2e2a, {
                        text: "Quiz",
                        status: $24c02ea0e14dbe4f$var$$035f8a623e403361$export$490c7ce941281ba8.DEFAULT,
                        isSelected: false
                    })
                ]
            })
        ]
    }));
const $24c02ea0e14dbe4f$var$$193bb26965d10640$var$loaderContainerStyles = (0, $74Zh5.css)({
    display: "flex",
    flexDirection: "column",
    gap: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.100"),
    padding: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.100")
});
const $24c02ea0e14dbe4f$var$$193bb26965d10640$var$skeletonLoaderBarStyles = (0, $74Zh5.css)({
    width: "100%",
    height: "20px",
    marginLeft: "10px"
});
const $24c02ea0e14dbe4f$var$$193bb26965d10640$var$sectionBarStyles = (0, $74Zh5.css)({
    position: "relative",
    display: "flex",
    alignItems: "center",
    width: "100%",
    padding: "4px 0 4px 10px",
    borderRadius: "4px",
    cursor: "pointer",
    "&:hover": {
        background: "rgba(220, 223, 228, 0.50)",
        "&::before": {
            content: '""',
            display: "block",
            width: "2px",
            height: "12px",
            position: "absolute",
            left: 0,
            top: "50%",
            transform: "translateY(-50%)",
            background: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.background.neutral")
        }
    }
});
const $24c02ea0e14dbe4f$var$$fd3fa057a77982d6$export$1f81c5947c983f13 = (0, $5FkrB.memo)((props)=>{
    const { lesson: { slug: slug, sectionListCollection: sectionListCollection }, progressForLesson: progressForLesson, isLoading: isLoading, courseSlug: courseSlug, selectedSectionId: selectedSectionId, currentLessonSlug: currentLessonSlug, onSelect: onSelect, isLessonCardExpanded: isLessonCardExpanded, isMobile: isMobile } = props;
    if (isLoading && isLessonCardExpanded) return (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$var$$193bb26965d10640$export$9794789a1567361c, {});
    if (!isLessonCardExpanded || isMobile) return null;
    const status = $24c02ea0e14dbe4f$var$$48630d5962798e4a$export$272e7ef3ea22070d(progressForLesson?.status);
    return (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
        css: $24c02ea0e14dbe4f$var$$fd3fa057a77982d6$var$sectionContainerStyles,
        children: sectionListCollection.items.map((section)=>{
            const sectionStatus = section.id === "quiz" && status === $24c02ea0e14dbe4f$var$$035f8a623e403361$export$490c7ce941281ba8.COMPLETED ? $24c02ea0e14dbe4f$var$$035f8a623e403361$export$490c7ce941281ba8.COMPLETED : $24c02ea0e14dbe4f$var$$48630d5962798e4a$export$272e7ef3ea22070d(progressForLesson?.section.find((sectionProgress)=>sectionProgress.sectionId === section.sys.id)?.status);
            return (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$var$$0efd93166e145c77$export$a1fd357e7aacc4df, {
                section: section,
                status: sectionStatus,
                onSelect: onSelect,
                lessonSlug: slug,
                courseSlug: courseSlug,
                isSelected: currentLessonSlug === slug && section.sys.id === selectedSectionId
            }, section.id);
        })
    });
});
const $24c02ea0e14dbe4f$var$$fd3fa057a77982d6$var$sectionContainerStyles = (0, $74Zh5.css)({
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "column",
    marginLeft: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.200"),
    marginTop: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.100")
});
const $24c02ea0e14dbe4f$var$$d1d0f9af78cf2050$export$5496f515fa03c54e = (totalMinutes)=>{
    if (totalMinutes > 59) {
        const hours = Math.floor(totalMinutes / 60);
        const minutes = totalMinutes % 60;
        if (minutes === 0) return `${hours} h`;
        return `${hours} h ${minutes} min`;
    }
    return `${totalMinutes} min`;
};
const $24c02ea0e14dbe4f$var$$0ca1c0d89e77a13d$export$db6f237c151666ee = 480;
const $24c02ea0e14dbe4f$var$$0ca1c0d89e77a13d$export$a3b47b9708ebe4f0 = {
    [$24c02ea0e14dbe4f$var$$035f8a623e403361$export$490c7ce941281ba8.DEFAULT]: "dot-default",
    [$24c02ea0e14dbe4f$var$$035f8a623e403361$export$490c7ce941281ba8.COMPLETED]: "dot-completed"
};
const $24c02ea0e14dbe4f$var$$0ca1c0d89e77a13d$export$951debaed2d5c034 = (0, $5FkrB.memo)((props)=>{
    const { lesson: { sys: sys, slug: slug, title: title, duration: duration }, courseSlug: courseSlug, isLoading: isLoading, progressForLesson: progressForLesson, onSelect: onSelect, expandedLessonIds: expandedLessonIds, selectedSectionId: selectedSectionId, currentLessonSlug: currentLessonSlug, isCourse: isCourse } = props;
    const deviceSize = $24c02ea0e14dbe4f$export$4616d33c54ae5baf();
    const isMobile = deviceSize <= $24c02ea0e14dbe4f$var$$0ca1c0d89e77a13d$export$db6f237c151666ee;
    const isSelected = $24c02ea0e14dbe4f$var$$48630d5962798e4a$export$15379570ba48f04d("", slug);
    const status = $24c02ea0e14dbe4f$var$$48630d5962798e4a$export$272e7ef3ea22070d(progressForLesson?.status);
    const [isLessonCardExpanded, setIsLessonCardExpanded] = (0, $5FkrB.useState)(false);
    (0, $5FkrB.useEffect)(()=>{
        const isExpanded = expandedLessonIds?.includes(sys.id);
        setIsLessonCardExpanded(isExpanded || false);
    }, [
        expandedLessonIds
    ]);
    /* eslint-enable react-hooks/exhaustive-deps */ const handleExpandClick = (e)=>{
        e.stopPropagation();
        setIsLessonCardExpanded(!isLessonCardExpanded);
    };
    const handleCardClick = (0, $5FkrB.useCallback)(()=>{
        setIsLessonCardExpanded(true);
        onSelect(courseSlug || "", slug);
    }, [
        courseSlug,
        slug,
        onSelect
    ]);
    const handleExpandKeyboard = (0, $5FkrB.useCallback)(()=>{
        setIsLessonCardExpanded(!isLessonCardExpanded);
    }, [
        isLessonCardExpanded
    ]);
    const onKeyDownCard = $24c02ea0e14dbe4f$export$2a0b6757d41dacb2(handleCardClick);
    const onKeyDownExpand = $24c02ea0e14dbe4f$export$2a0b6757d41dacb2(handleExpandKeyboard);
    const renderStatusIndicator = ()=>{
        if (status === $24c02ea0e14dbe4f$var$$035f8a623e403361$export$490c7ce941281ba8.COMPLETED) return (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$f04a61298a47a40f, {
            type: "check-circle-outline",
            color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.icon.success")
        });
        return (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
            css: [
                $24c02ea0e14dbe4f$var$$0ca1c0d89e77a13d$var$lessonTimeBadgeStyles,
                isSelected && $24c02ea0e14dbe4f$var$$0ca1c0d89e77a13d$var$lessonTimeBadgeSelectedStyles
            ],
            children: $24c02ea0e14dbe4f$var$$d1d0f9af78cf2050$export$5496f515fa03c54e(duration)
        });
    };
    return (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
        "data-testid": "sidebar-lesson-card",
        css: [
            $24c02ea0e14dbe4f$var$$0ca1c0d89e77a13d$var$lessonCardStyles,
            isSelected && $24c02ea0e14dbe4f$var$$0ca1c0d89e77a13d$var$lessonCardSelectedStyles
        ],
        children: [
            (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                role: "button",
                tabIndex: 0,
                css: [
                    $24c02ea0e14dbe4f$var$$0ca1c0d89e77a13d$var$lessonCardHeaderStyles,
                    isMobile && $24c02ea0e14dbe4f$var$$0ca1c0d89e77a13d$var$lessonCardHeaderMobileStyles,
                    isCourse && isMobile && $24c02ea0e14dbe4f$var$$0ca1c0d89e77a13d$var$lessonCardHeaderCourseStyles
                ],
                onClick: handleCardClick,
                onKeyDown: onKeyDownCard,
                children: [
                    !isMobile && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                        role: "button",
                        tabIndex: 0,
                        css: $24c02ea0e14dbe4f$var$$0ca1c0d89e77a13d$var$lessonExpanderStyles,
                        onClick: handleExpandClick,
                        onKeyDown: onKeyDownExpand,
                        children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$f04a61298a47a40f, {
                            type: isLessonCardExpanded ? "chevron-down" : "chevron-right",
                            color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.icon")
                        })
                    }),
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$var$$47b694880a211b2b$export$c0d3d8bfa41e2e2a, {
                        text: title,
                        isSelected: isSelected,
                        appearance: $24c02ea0e14dbe4f$var$$47b694880a211b2b$export$40bdb27f2137fcf.LESSON
                    }),
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                        css: $24c02ea0e14dbe4f$var$$0ca1c0d89e77a13d$var$lessonTimeBadgeContainerStyles,
                        children: renderStatusIndicator()
                    })
                ]
            }),
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$var$$fd3fa057a77982d6$export$1f81c5947c983f13, {
                lesson: props.lesson,
                progressForLesson: progressForLesson,
                isLoading: isLoading,
                courseSlug: courseSlug,
                selectedSectionId: selectedSectionId,
                currentLessonSlug: currentLessonSlug,
                onSelect: onSelect,
                isLessonCardExpanded: isLessonCardExpanded,
                isMobile: isMobile
            })
        ]
    });
});
const $24c02ea0e14dbe4f$var$$0ca1c0d89e77a13d$var$lessonCardStyles = (0, $74Zh5.css)({
    display: "flex",
    width: "100%",
    flexDirection: "column",
    paddingTop: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.100"),
    paddingBottom: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.100"),
    paddingLeft: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.250"),
    paddingRight: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.100"),
    "&:active": {
        background: "#F1F2F4 !important"
    },
    "&:hover": {
        background: "#F7F8F9"
    }
});
const $24c02ea0e14dbe4f$var$$0ca1c0d89e77a13d$var$lessonCardSelectedStyles = (0, $74Zh5.css)({
    background: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.background.input.hovered"),
    "&:active": {
        background: `${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.background.input.hovered")} !important`
    }
});
const $24c02ea0e14dbe4f$var$$0ca1c0d89e77a13d$var$lessonCardHeaderStyles = (0, $74Zh5.css)({
    display: "flex",
    justifyContent: "start",
    alignItems: "center",
    cursor: "pointer"
});
const $24c02ea0e14dbe4f$var$$0ca1c0d89e77a13d$var$lessonCardHeaderMobileStyles = (0, $74Zh5.css)({
    marginLeft: `calc(${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.300")} + ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.025")})`
});
const $24c02ea0e14dbe4f$var$$0ca1c0d89e77a13d$var$lessonCardHeaderCourseStyles = (0, $74Zh5.css)({
    marginLeft: 0
});
const $24c02ea0e14dbe4f$var$$0ca1c0d89e77a13d$var$lessonExpanderStyles = (0, $74Zh5.css)({
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "24px",
    height: "24px",
    borderRadius: "4px",
    cursor: "pointer",
    marginRight: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.025"),
    "&:hover": {
        background: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("elevation.surface.pressed")
    }
});
const $24c02ea0e14dbe4f$var$$0ca1c0d89e77a13d$var$lessonTimeBadgeStyles = (0, $74Zh5.css)({
    fontFamily: "Inter, sans-serif",
    fontSize: "12px",
    lineHeight: "18px",
    fontWeight: 400,
    color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text"),
    padding: `${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.025")} ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.075")}`,
    borderRadius: "8px",
    background: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.background.neutral"),
    marginLeft: "auto"
});
const $24c02ea0e14dbe4f$var$$0ca1c0d89e77a13d$var$lessonTimeBadgeSelectedStyles = (0, $74Zh5.css)({
    color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text.brand"),
    background: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.background.brand.subtlest")
});
const $24c02ea0e14dbe4f$var$$0ca1c0d89e77a13d$var$lessonTimeBadgeContainerStyles = (0, $74Zh5.css)({
    marginLeft: "auto"
});
const $24c02ea0e14dbe4f$var$$11732cc088354996$export$748c6b3a71d1e268 = (0, $5FkrB.memo)(()=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $6bec4f26b2cb3094$export$ffb0004e005737fa), {
        children: [
            ...Array(4)
        ].map((_, index)=>(0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                css: $24c02ea0e14dbe4f$var$$11732cc088354996$var$lessonCardHeaderStyles,
                children: [
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                        css: $24c02ea0e14dbe4f$var$$11732cc088354996$var$lessonExpanderStyles,
                        children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$f04a61298a47a40f, {
                            type: "chevron-right",
                            color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.icon")
                        })
                    }),
                    (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                        css: $24c02ea0e14dbe4f$var$$11732cc088354996$var$skeletonLoaderBarStyles,
                        children: [
                            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$var$$4baed82dabfd5555$export$27a22c945b52f415, {}),
                            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                                css: $24c02ea0e14dbe4f$var$$11732cc088354996$var$skeletonTimeLoaderBarStyles,
                                children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$var$$4baed82dabfd5555$export$27a22c945b52f415, {})
                            })
                        ]
                    })
                ]
            }, index))
    }));
const $24c02ea0e14dbe4f$var$$11732cc088354996$var$lessonCardHeaderStyles = (0, $74Zh5.css)({
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    paddingTop: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.100"),
    paddingBottom: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.100"),
    paddingLeft: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.250"),
    paddingRight: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.100")
});
const $24c02ea0e14dbe4f$var$$11732cc088354996$var$lessonExpanderStyles = (0, $74Zh5.css)({
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "24px",
    height: "24px",
    borderRadius: "4px"
});
const $24c02ea0e14dbe4f$var$$11732cc088354996$var$skeletonTimeLoaderBarStyles = (0, $74Zh5.css)({
    width: "50px",
    height: "20px",
    marginLeft: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.300")
});
const $24c02ea0e14dbe4f$var$$11732cc088354996$var$skeletonLoaderBarStyles = (0, $74Zh5.css)({
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "100%",
    height: "20px",
    marginLeft: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.025")
});
const $24c02ea0e14dbe4f$var$$aefb4e9d0a694068$var$COURSE_CARD_TITLE = {
    [$24c02ea0e14dbe4f$var$$035f8a623e403361$export$490c7ce941281ba8.COMPLETED]: "Completed",
    [$24c02ea0e14dbe4f$var$$035f8a623e403361$export$490c7ce941281ba8.DEFAULT]: "Course"
};
const $24c02ea0e14dbe4f$var$$aefb4e9d0a694068$var$CourseCardHeaderContent = ({ isCourseExpanded: isCourseExpanded, isSelected: isSelected, status: status, title: title })=>(0, $6bec4f26b2cb3094$export$25062201e9e25d76)((0, $6bec4f26b2cb3094$export$ffb0004e005737fa), {
        children: [
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                css: [
                    $24c02ea0e14dbe4f$var$$aefb4e9d0a694068$var$courseExpanderStyles,
                    isCourseExpanded && $24c02ea0e14dbe4f$var$$aefb4e9d0a694068$var$courseExpanderSelectedStyles
                ],
                children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$f04a61298a47a40f, {
                    type: isCourseExpanded ? "chevron-down" : "chevron-right",
                    color: isCourseExpanded ? (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.icon.selected") : (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.icon")
                })
            }),
            (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                css: $24c02ea0e14dbe4f$var$$aefb4e9d0a694068$var$courseTitleContainerStyles,
                children: [
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("p", {
                        css: [
                            $24c02ea0e14dbe4f$var$$aefb4e9d0a694068$var$courseCardTitleStyles,
                            status === $24c02ea0e14dbe4f$var$$035f8a623e403361$export$490c7ce941281ba8.COMPLETED && $24c02ea0e14dbe4f$var$$aefb4e9d0a694068$var$courseCardTitleCompletedStyles,
                            status === $24c02ea0e14dbe4f$var$$035f8a623e403361$export$490c7ce941281ba8.DEFAULT && $24c02ea0e14dbe4f$var$$aefb4e9d0a694068$var$courseCardTitleDefaultStyles,
                            isSelected && $24c02ea0e14dbe4f$var$$aefb4e9d0a694068$var$courseCardTitleSelectedStyles
                        ],
                        children: isSelected ? "Current course".toUpperCase() : $24c02ea0e14dbe4f$var$$aefb4e9d0a694068$var$COURSE_CARD_TITLE[status].toUpperCase()
                    }),
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$var$$47b694880a211b2b$export$c0d3d8bfa41e2e2a, {
                        text: title,
                        isSelected: isSelected,
                        appearance: $24c02ea0e14dbe4f$var$$47b694880a211b2b$export$40bdb27f2137fcf.COURSE
                    })
                ]
            })
        ]
    });
const $24c02ea0e14dbe4f$var$$aefb4e9d0a694068$export$bb61bd2f4f2a772c = (props)=>{
    const { handleMouseEnter: handleMouseEnter, handleMouseLeave: handleMouseLeave, popupRef: popupRef } = $24c02ea0e14dbe4f$var$$32c02b5652036d7a$export$861cd542ff836f0d();
    const mouseLeaveHandler = (0, $5FkrB.useCallback)((e, id, courseCardRef)=>{
        const lessonPage = document.getElementById("lesson-page-body");
        const isMovedToSidebar = e.relatedTarget?.tagName === "ASIDE";
        if (!e.relatedTarget || !e.relatedTarget.nodeType || isMovedToSidebar || e.relatedTarget === props.scrollContainerRef.current || lessonPage?.contains(e.relatedTarget)) {
            handleMouseLeave();
            return;
        }
        if (e.currentTarget === courseCardRef.current || e.relatedTarget === popupRef.current) return;
        handleMouseLeave(id);
    }, [
        handleMouseLeave,
        popupRef,
        props.scrollContainerRef
    ]);
    return (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$var$$aefb4e9d0a694068$export$7b8f328152f30a2c, {
        ...props,
        onHover: handleMouseEnter,
        onMouseLeave: mouseLeaveHandler,
        popupRef: popupRef
    });
};
const $24c02ea0e14dbe4f$var$$aefb4e9d0a694068$export$7b8f328152f30a2c = (0, $5FkrB.memo)(({ course: { sys: sys, title: title, reward: reward, slug: slug, lessonsCollection: lessonsCollection }, status: status, isLoading: isLoading, selectedLessonRef: selectedLessonRef, progressForLessons: progressForLessons, onHover: onHover, onMouseLeave: onMouseLeave, onSelect: onSelect, expandedLessonIds: expandedLessonIds = [], expandedCourseIds: expandedCourseIds = [], selectedSectionId: selectedSectionId, currentLessonSlug: currentLessonSlug })=>{
    const courseCardRef = (0, $5FkrB.useRef)(null);
    const isSelected = $24c02ea0e14dbe4f$var$$48630d5962798e4a$export$15379570ba48f04d(slug);
    const [isCourseExpanded, setIsCourseExpanded] = (0, $5FkrB.useState)(false);
    (0, $5FkrB.useEffect)(()=>{
        const isExpanded = expandedCourseIds.includes(sys.id);
        setIsCourseExpanded(isExpanded || false);
    }, [
        expandedCourseIds
    ]);
    /* eslint-enable react-hooks/exhaustive-deps */ const handleCourseCardExpand = (0, $5FkrB.useCallback)(()=>{
        setIsCourseExpanded(!isCourseExpanded);
        onSelect(slug);
    }, [
        isCourseExpanded,
        onSelect,
        slug
    ]);
    const showCoursePopup = (0, $5FkrB.useCallback)(()=>{
        if (courseCardRef.current) onHover({
            courseId: sys.id,
            courseCardPosition: courseCardRef.current.getBoundingClientRect()
        });
    }, [
        sys.id,
        onHover
    ]);
    const hideCoursePopup = (0, $5FkrB.useCallback)((e)=>{
        onMouseLeave(e, sys.id, courseCardRef);
    }, [
        onMouseLeave,
        sys.id,
        courseCardRef
    ]);
    const onKeyDown = $24c02ea0e14dbe4f$export$2a0b6757d41dacb2(handleCourseCardExpand);
    return (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
        "data-testid": "sidebar-course-card",
        css: [
            $24c02ea0e14dbe4f$var$$aefb4e9d0a694068$var$courseCardStyles,
            isCourseExpanded && $24c02ea0e14dbe4f$var$$aefb4e9d0a694068$var$courseCardOpenedStyles
        ],
        ref: courseCardRef,
        onMouseEnter: showCoursePopup,
        onMouseLeave: hideCoursePopup,
        children: [
            (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                role: "button",
                tabIndex: 0,
                css: [
                    $24c02ea0e14dbe4f$var$$aefb4e9d0a694068$var$courseCardHeaderStyles,
                    isCourseExpanded && $24c02ea0e14dbe4f$var$$aefb4e9d0a694068$var$courseCardHeaderOpenedStyles
                ],
                onClick: handleCourseCardExpand,
                onKeyDown: onKeyDown,
                onMouseEnter: showCoursePopup,
                "data-testid": "course-card-header",
                children: [
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$var$$aefb4e9d0a694068$var$CourseCardHeaderContent, {
                        isCourseExpanded: isCourseExpanded,
                        isSelected: isSelected,
                        status: status,
                        title: title
                    }),
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$var$$6cca9b298ff547cb$export$a9a23386c3e0c05f, {
                        lessonsCollection: lessonsCollection,
                        progressForLessons: progressForLessons,
                        reward: reward,
                        title: title
                    })
                ]
            }),
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                css: $24c02ea0e14dbe4f$var$$aefb4e9d0a694068$var$lessonContainerStyles,
                onMouseEnter: hideCoursePopup,
                children: isLoading && isCourseExpanded ? (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$var$$11732cc088354996$export$748c6b3a71d1e268, {}) : isCourseExpanded && lessonsCollection.items.map((lesson)=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                        ref: $24c02ea0e14dbe4f$var$$48630d5962798e4a$export$15379570ba48f04d("", lesson.slug) ? selectedLessonRef : null,
                        children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$var$$0ca1c0d89e77a13d$export$951debaed2d5c034, {
                            lesson: lesson,
                            courseSlug: slug,
                            progressForLesson: progressForLessons?.lessons.find((lessonProgress)=>lessonProgress.lessonId === lesson.sys.id),
                            onSelect: onSelect,
                            isLoading: isLoading,
                            expandedLessonIds: expandedLessonIds,
                            selectedSectionId: selectedSectionId,
                            currentLessonSlug: currentLessonSlug
                        })
                    }, lesson.sys.id))
            })
        ]
    });
});
const $24c02ea0e14dbe4f$var$$aefb4e9d0a694068$var$courseCardStyles = (0, $74Zh5.css)({
    display: "flex",
    width: "100%",
    flexDirection: "column",
    paddingTop: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.300"),
    paddingBottom: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.300"),
    borderBottom: `1px solid ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.border")}`,
    "&:hover": {
        background: "#F7F8F9"
    }
});
const $24c02ea0e14dbe4f$var$$aefb4e9d0a694068$var$courseCardOpenedStyles = (0, $74Zh5.css)({
    paddingBottom: 0,
    "&:hover": {
        background: "none"
    }
});
const $24c02ea0e14dbe4f$var$$aefb4e9d0a694068$var$courseCardHeaderStyles = (0, $74Zh5.css)({
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    cursor: "pointer",
    paddingLeft: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.100"),
    paddingRight: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.100")
});
const $24c02ea0e14dbe4f$var$$aefb4e9d0a694068$var$courseCardHeaderOpenedStyles = (0, $74Zh5.css)({
    marginBottom: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.100")
});
const $24c02ea0e14dbe4f$var$$aefb4e9d0a694068$var$courseExpanderStyles = (0, $74Zh5.css)({
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "24px",
    height: "24px",
    borderRadius: "4px",
    border: `1px solid ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.background.accent.gray.subtlest")}`,
    cursor: "pointer"
});
const $24c02ea0e14dbe4f$var$$aefb4e9d0a694068$var$courseExpanderSelectedStyles = (0, $74Zh5.css)({
    border: `1px solid ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.background.accent.blue.subtler")}`
});
const $24c02ea0e14dbe4f$var$$aefb4e9d0a694068$var$courseTitleContainerStyles = (0, $74Zh5.css)({
    display: "flex",
    flexDirection: "column",
    marginLeft: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.100"),
    marginRight: "auto"
});
const $24c02ea0e14dbe4f$var$$aefb4e9d0a694068$var$courseCardTitleStyles = (0, $74Zh5.css)({
    fontFamily: "Charlie Display, sans-serif",
    fontSize: "12px",
    fontWeight: 600,
    lineHeight: "16px"
});
const $24c02ea0e14dbe4f$var$$aefb4e9d0a694068$var$courseCardTitleSelectedStyles = (0, $74Zh5.css)({
    color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text.selected")
});
const $24c02ea0e14dbe4f$var$$aefb4e9d0a694068$var$courseCardTitleCompletedStyles = (0, $74Zh5.css)({
    color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text.success")
});
const $24c02ea0e14dbe4f$var$$aefb4e9d0a694068$var$courseCardTitleDefaultStyles = (0, $74Zh5.css)({
    color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text.subtlest")
});
const $24c02ea0e14dbe4f$var$$aefb4e9d0a694068$var$lessonContainerStyles = (0, $74Zh5.css)({
    display: "flex",
    flexDirection: "column",
    gap: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.100")
});
var $24c02ea0e14dbe4f$var$$e48fba9cf5395297$require$Buffer = (0, $7KfP5.Buffer);
const $24c02ea0e14dbe4f$var$$e48fba9cf5395297$var$courseBg = `<svg width="419" height="16" viewBox="0 0 419 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clipPath="url(#clip0_550_14457)">
<rect width="419" height="16" fill="#CCE0FF"/>
<g clipPath="url(#clip1_550_14457)">
<path d="M419.987 -18.5349C419.996 -18.6007 420.003 -18.6684 420.014 -18.7323C420.032 -18.7947 420.048 -18.8548 420.064 -18.915C420.099 -19.0356 420.114 -19.1585 420.159 -19.2632C420.248 -19.4786 420.309 -19.6895 420.416 -19.8625C420.463 -19.9546 420.508 -20.0404 420.551 -20.1238C420.603 -20.2039 420.653 -20.2775 420.702 -20.3488C420.75 -20.4201 420.79 -20.4949 420.836 -20.5598C420.888 -20.6209 420.931 -20.6813 420.974 -20.7375C421.14 -20.9764 421.288 -21.1424 421.37 -21.2817C421.452 -21.421 421.479 -21.522 421.443 -21.5797C421.407 -21.6374 421.307 -21.6518 421.142 -21.6124C420.978 -21.5729 420.733 -21.4929 420.458 -21.2992C420.387 -21.251 420.313 -21.2006 420.234 -21.1476C420.159 -21.0907 420.086 -21.0172 420.006 -20.9452C419.928 -20.8714 419.847 -20.793 419.762 -20.7101C419.686 -20.6195 419.613 -20.5188 419.533 -20.4154C419.364 -20.214 419.244 -19.956 419.102 -19.6814C419.032 -19.5431 418.992 -19.3907 418.936 -19.2369C418.91 -19.159 418.885 -19.0793 418.86 -18.9995C418.838 -18.9178 418.826 -18.835 418.809 -18.7495C418.615 -17.7843 418.69 -16.8131 418.876 -15.8955C419.059 -14.9692 419.392 -14.1022 419.756 -13.244C419.947 -12.82 420.142 -12.3941 420.364 -11.9832C420.574 -11.563 420.81 -11.1596 421.049 -10.7501L421.231 -10.4386C421.302 -10.321 421.379 -10.2101 421.453 -10.1053C421.527 -10.0006 421.606 -9.89614 421.681 -9.80195L421.834 -9.60333C421.861 -9.56574 421.887 -9.52816 421.909 -9.49438C421.917 -9.47618 421.939 -9.45715 421.93 -9.44167L421.87 -9.4071L421.756 -9.34475C421.555 -9.2203 421.349 -9.09548 421.146 -8.96877C420.732 -8.71463 420.314 -8.45596 419.889 -8.19466C419.043 -7.67017 418.178 -7.13781 417.292 -6.58888C415.522 -5.48495 413.666 -4.32951 411.701 -3.10375C411.569 -3.02103 411.438 -2.9383 411.311 -2.85594L411.263 -2.82245C411.247 -2.81267 411.23 -2.79231 411.213 -2.79503L411.176 -2.83796L411.129 -2.89683C411.053 -2.99935 410.979 -3.09997 410.908 -3.19868C410.748 -3.42193 410.595 -3.64364 410.445 -3.8657C409.853 -4.75016 409.317 -5.59122 408.833 -6.35712C407.867 -7.87642 407.139 -9.19183 406.523 -10.4477C405.911 -11.704 405.395 -12.8909 404.961 -14.1983C404.532 -15.5018 404.156 -16.9191 403.941 -18.6294C403.764 -20.0724 403.734 -21.6582 403.948 -23.2902C404.067 -24.102 404.224 -24.9319 404.485 -25.7435C404.596 -26.156 404.761 -26.5543 404.909 -26.9594C405.08 -27.3562 405.245 -27.7586 405.453 -28.1438C405.847 -28.925 406.311 -29.6786 406.85 -30.3841C407.385 -31.0935 407.973 -31.7656 408.624 -32.3738C408.936 -32.6905 409.287 -32.9706 409.619 -33.2637C409.969 -33.5374 410.311 -33.821 410.678 -34.0689C411.033 -34.3347 411.41 -34.5667 411.777 -34.8021C412.152 -35.0318 412.539 -35.2437 412.914 -35.465C414.436 -36.3062 415.99 -36.9507 417.497 -37.3604C419.003 -37.7742 420.458 -37.9529 421.776 -37.9727C423.096 -37.9948 424.276 -37.8642 425.269 -37.709C426.262 -37.5579 427.07 -37.3657 427.646 -37.233L428.69 -36.9731C429.045 -36.8906 429.419 -36.816 429.771 -36.7438C430.378 -36.6242 431.227 -36.4356 432.428 -36.2523C433.028 -36.1615 433.721 -36.0769 434.532 -36.0632C435.339 -36.0534 436.29 -36.1149 437.298 -36.4729C437.804 -36.6385 438.302 -36.8957 438.794 -37.2048C439.033 -37.3787 439.288 -37.5351 439.516 -37.7605C439.63 -37.869 439.756 -37.968 439.863 -38.0906C439.969 -38.2173 440.076 -38.3441 440.183 -38.4708C440.585 -39.0093 440.922 -39.6533 441.087 -40.36C441.245 -41.0619 441.295 -41.8006 441.211 -42.5236C441.061 -43.9793 440.534 -45.3835 439.853 -46.7869C439.509 -47.4894 439.114 -48.1853 438.684 -48.8866C438.47 -49.2437 438.255 -49.5754 438.036 -49.9299C437.987 -50.0054 437.941 -50.0791 437.892 -50.1546L437.861 -50.2043C437.876 -50.2183 437.894 -50.2303 437.914 -50.2446C437.836 -50.198 438.202 -50.4311 438.461 -50.5962C439.016 -50.9486 439.658 -51.3547 440.372 -51.809C441.803 -52.7114 443.524 -53.7985 445.425 -54.9977C446.336 -55.5719 447.291 -56.1709 448.275 -56.789L448.326 -56.8229C448.342 -56.8285 448.363 -56.8575 448.374 -56.8291L448.412 -56.782L448.504 -56.6579C448.854 -56.1741 449.194 -55.6643 449.531 -55.1417C449.866 -54.6085 450.202 -54.0711 450.54 -53.5318C450.86 -52.9887 451.204 -52.4562 451.506 -51.9012C452.14 -50.8042 452.697 -49.6712 453.218 -48.5372C454.609 -45.4748 455.414 -42.5189 455.622 -39.8407C455.835 -37.1587 455.451 -34.7733 454.708 -32.833C453.969 -30.8848 452.931 -29.3702 451.906 -28.2006C450.869 -27.0365 449.854 -26.1974 448.994 -25.5647C448.74 -25.3769 448.489 -25.1936 448.225 -25.0259C447.964 -24.8543 447.711 -24.6813 447.441 -24.5299C447.177 -24.3728 446.912 -24.2175 446.652 -24.0608C446.391 -23.9059 446.118 -23.7795 445.858 -23.6394C445.335 -23.3486 444.792 -23.1336 444.267 -22.8909C444.001 -22.7819 443.73 -22.6891 443.467 -22.5865L443.07 -22.4368L442.67 -22.3139C441.607 -21.9637 440.54 -21.7558 439.49 -21.6187C438.439 -21.4751 437.397 -21.4582 436.377 -21.4936C435.354 -21.5266 434.349 -21.6452 433.361 -21.7966C432.866 -21.869 432.377 -21.9631 431.889 -22.0529C431.396 -22.1508 430.914 -22.258 430.418 -22.3472C429.434 -22.5326 428.468 -22.7237 427.477 -22.8686C426.491 -23.014 425.476 -23.1064 424.439 -23.0396C423.318 -22.955 422.489 -22.6083 422.02 -22.2885C421.775 -22.1351 421.62 -21.979 421.526 -21.8617C421.431 -21.7444 421.396 -21.6575 421.422 -21.6051L421.393 -21.4788C421.408 -21.4697 421.421 -21.4749 421.419 -21.4957L421.417 -21.6089L421.441 -21.5816C421.478 -21.5345 421.572 -21.5216 421.717 -21.5384C421.86 -21.5571 422.053 -21.6116 422.306 -21.665C422.804 -21.7878 423.52 -21.9506 424.501 -21.9791C426.333 -22.0036 428.217 -21.4933 430.151 -21.0651C432.069 -20.5956 434.122 -20.121 436.309 -19.9979C437.401 -19.9331 438.53 -19.9303 439.679 -20.0655C440.824 -20.1921 441.997 -20.4071 443.155 -20.7739L443.593 -20.9042L444.026 -21.0614C444.313 -21.168 444.608 -21.2671 444.896 -21.3844C445.464 -21.6371 446.054 -21.8709 446.616 -22.1755C446.899 -22.3238 447.191 -22.4604 447.471 -22.6231C447.751 -22.7858 448.03 -22.9527 448.316 -23.1181C448.602 -23.2793 448.877 -23.4647 449.157 -23.6505C449.44 -23.8303 449.714 -24.0282 449.988 -24.2304C450.841 -24.8582 451.905 -25.7016 453.021 -26.8957C453.309 -27.1871 453.571 -27.5225 453.863 -27.8605C454.004 -28.0321 454.137 -28.2178 454.276 -28.4019C454.418 -28.5841 454.554 -28.7744 454.686 -28.9767C455.233 -29.7648 455.74 -30.6669 456.174 -31.6739C457.054 -33.6806 457.614 -36.1379 457.566 -38.8279C457.534 -41.5171 456.936 -44.407 455.846 -47.313C455.131 -49.2086 454.232 -51.0191 453.22 -52.7275C453 -53.1092 452.768 -53.4857 452.531 -53.8595C452.294 -54.2398 452.058 -54.6159 451.817 -54.9852C451.333 -55.728 450.844 -56.4872 450.306 -57.24C450.171 -57.4276 450.035 -57.6151 449.893 -57.8043C449.653 -58.1255 449.383 -58.4567 449.123 -58.7678L448.927 -59.0067L448.828 -59.1241L448.779 -59.1849L448.713 -59.1435L448.187 -58.821L447.222 -58.2106C446.463 -57.721 445.702 -57.2332 444.944 -56.7458C443.425 -55.7748 441.918 -54.8133 440.448 -53.8739C438.753 -52.7996 437.104 -51.7523 435.527 -50.7531C435.991 -50.0108 436.451 -49.2806 436.903 -48.5602C437.066 -48.3037 437.217 -48.0566 437.362 -47.8111C437.505 -47.5633 437.664 -47.3253 437.793 -47.0784C438.349 -46.1047 438.792 -45.1297 439.105 -44.1938C439.417 -43.2556 439.58 -42.3464 439.535 -41.5453C439.493 -40.7422 439.25 -40.0623 438.851 -39.5598C438.46 -39.0496 437.954 -38.691 437.475 -38.4375C436.995 -38.1882 436.554 -38.0451 436.181 -37.9645C435.996 -37.9233 435.825 -37.9043 435.679 -37.8769C435.529 -37.8639 435.404 -37.8531 435.302 -37.8421C435.2 -37.8312 435.122 -37.8308 435.068 -37.8302C435.013 -37.8297 434.988 -37.8275 434.988 -37.8275C434.988 -37.8275 434.871 -37.8258 434.651 -37.8214C434.54 -37.8264 434.399 -37.8289 434.237 -37.8337C434.073 -37.8405 433.88 -37.8594 433.667 -37.8766C432.801 -37.959 431.531 -38.193 429.936 -38.5373C429.151 -38.6875 428.292 -38.9299 427.33 -39.1213C426.369 -39.3108 425.335 -39.5003 424.228 -39.5889C423.123 -39.684 421.952 -39.7105 420.741 -39.6161C419.533 -39.5114 418.291 -39.2883 417.058 -38.9422C415.82 -38.5999 414.613 -38.0966 413.43 -37.5304C412.848 -37.2281 412.256 -36.9335 411.697 -36.5849C411.125 -36.2584 410.565 -35.8951 410.019 -35.512C407.837 -33.9779 405.925 -31.9888 404.62 -29.7209C403.3 -27.462 402.621 -24.9776 402.422 -22.6921C402.327 -21.5467 402.342 -20.4485 402.416 -19.4205C402.469 -18.9089 402.508 -18.4129 402.588 -17.9394C402.625 -17.7034 402.656 -17.469 402.697 -17.2417C402.742 -17.0148 402.786 -16.792 402.83 -16.5776C403.106 -15.2754 403.444 -14.0752 403.836 -12.9845C404.024 -12.4364 404.237 -11.9177 404.431 -11.4142C404.65 -10.9212 404.839 -10.434 405.058 -9.98298C405.906 -8.16173 406.754 -6.6679 407.532 -5.40717C408.303 -4.16047 408.956 -3.11338 409.589 -2.21778C409.677 -2.09742 409.763 -1.97896 409.846 -1.8624C409.972 -1.69494 410.097 -1.53165 410.231 -1.36908C410.364 -1.21067 410.493 -1.0519 410.619 -0.899205C410.683 -0.822855 410.748 -0.748768 410.811 -0.672419C410.838 -0.607579 410.885 -0.664166 410.925 -0.684437L411.049 -0.758101C411.375 -0.947891 411.688 -1.14077 411.994 -1.33518C412.199 -1.46416 412.396 -1.58825 412.583 -1.70518C414.541 -2.94081 416.392 -4.10837 418.154 -5.22217C419.034 -5.78098 419.891 -6.32738 420.73 -6.86175C421.15 -7.13101 421.563 -7.39348 421.975 -7.65786C422.182 -7.7891 422.388 -7.9245 422.593 -8.05348L423.1 -8.37651L423.351 -8.53671L423.58 -8.69928L424.035 -9.02403L424.063 -9.04323L424.074 -9.05681C424.074 -9.05681 424.071 -9.06287 424.069 -9.06894L424.03 -9.12852L423.95 -9.24961L423.794 -9.48571C423.591 -9.79544 423.369 -10.1056 423.118 -10.405L422.846 -10.7381L422.646 -10.9914C422.584 -11.0742 422.525 -11.1592 422.472 -11.2385L422.296 -11.5213C422.062 -11.9038 421.823 -12.2818 421.616 -12.6688C421.392 -13.0502 421.203 -13.4408 421.015 -13.8274C420.658 -14.6063 420.324 -15.3894 420.137 -16.1874C419.943 -16.9804 419.861 -17.7833 419.977 -18.536L419.987 -18.5349Z" fill="#0055CC"/>
<path d="M375.063 24.9613C374.963 24.9469 374.87 24.934 374.776 24.9211C374.684 24.9207 374.594 24.9181 374.507 24.9151C374.335 24.9132 374.174 24.9167 374.025 24.9233C373.73 24.9258 373.486 24.9952 373.295 25.0474C372.911 25.1605 372.732 25.2998 372.737 25.4357C372.745 25.5735 372.937 25.7079 373.298 25.8109C373.477 25.8688 373.704 25.8932 373.964 25.9651C374.095 25.9937 374.236 26.0234 374.387 26.046C374.461 26.0584 374.54 26.0705 374.623 26.0822C374.702 26.1026 374.783 26.1207 374.867 26.1407C375.825 26.3325 376.729 26.7137 377.473 27.3312C378.22 27.9441 378.807 28.785 379.24 29.7755C379.678 30.7657 379.967 31.901 380.15 33.1252C380.208 33.4286 380.237 33.7429 380.273 34.0629C380.311 34.3807 380.35 34.7026 380.365 35.0327C380.388 35.3644 380.408 35.6983 380.431 36.0384C380.447 36.3874 380.465 36.7426 380.481 37.1C380.568 38.5486 380.642 39.8241 380.666 40.2417C381.225 40.2059 381.762 40.1741 382.279 40.1418C382.607 40.1197 382.919 40.0968 383.222 40.0768C383.739 40.0362 384.218 39.9989 384.668 39.964C385.568 39.8902 386.356 39.8262 387.106 39.7653C388.606 39.6437 389.965 39.5385 391.821 39.449C393.519 39.3668 395.452 39.2727 397.832 39.1566C397.789 38.0735 397.747 36.9566 397.702 35.8254C397.669 34.9323 397.636 34.0245 397.605 33.125C397.53 31.3039 397.376 29.4981 397.138 27.8338C396.902 26.1715 396.583 24.6549 396.247 23.4104C395.91 22.1659 395.554 21.1981 395.327 20.6092C395.161 20.1725 394.959 19.7431 394.754 19.3202C394.367 18.5733 393.65 17.1667 392.278 15.5734C391.593 14.7809 390.741 13.9525 389.693 13.2062C388.648 12.4595 387.41 11.801 386.039 11.3281C384.669 10.8447 383.165 10.5723 381.624 10.4666C380.079 10.3572 378.499 10.4312 376.908 10.6467C373.722 11.0467 370.51 12.3407 368.007 14.3579C366.235 15.781 364.937 17.3979 363.976 18.95C363.746 19.3434 363.514 19.7244 363.305 20.1013C363.11 20.4854 362.924 20.8582 362.739 21.2205C362.569 21.5877 362.42 21.9489 362.268 22.3C362.215 22.422 362.163 22.544 362.112 22.6638C362.01 22.8133 362.067 22.9888 362.062 23.1549C362.073 23.3492 362.081 23.5415 362.091 23.7274C362.225 26.4708 362.325 28.491 362.392 29.8763C362.478 31.4741 362.561 32.9734 362.623 34.1577L364.386 34.2336C364.674 32.0726 365.411 30.2357 366.575 28.8843C367.741 27.5432 369.26 26.6687 370.916 26.2336C371.517 26.0786 371.977 25.9401 372.284 25.8233C372.59 25.6982 372.75 25.5626 372.742 25.4437C372.74 25.3221 372.569 25.2173 372.224 25.1508C371.88 25.0778 371.359 25.0726 370.681 25.1943C368.823 25.5253 366.976 26.4093 365.521 27.937C364.067 29.4689 363.142 31.6116 362.786 34.0198L364.239 34.0827C364.187 32.8954 364.122 31.3966 364.054 29.7974C363.992 28.5249 363.955 26.5621 363.894 23.9844C363.891 23.8231 363.885 23.66 363.883 23.4923L363.878 23.2409L363.877 23.1781L363.878 23.1675L363.881 23.1505C363.881 23.1505 363.892 23.1327 363.903 23.1108C363.934 23.0409 363.966 22.971 364 22.903C364.071 22.75 364.141 22.5928 364.214 22.4376C364.35 22.1194 364.523 21.8086 364.694 21.4895C364.779 21.329 364.866 21.1662 364.953 21.0034C365.043 20.8403 365.147 20.6844 365.242 20.5209C366.022 19.2216 367.014 17.8998 368.295 16.6977C368.509 16.507 368.703 16.2951 368.929 16.1223L369.589 15.5804C369.811 15.3996 370.05 15.2488 370.278 15.0779L370.624 14.8277L370.986 14.6032C371.25 14.4461 371.505 14.2666 371.785 14.127C372.062 13.9854 372.345 13.8413 372.625 13.6975C373.21 13.4516 373.797 13.1846 374.426 13.0021C374.736 12.8997 375.044 12.7954 375.367 12.7275C375.686 12.6516 376.006 12.5651 376.327 12.4994C376.979 12.3905 377.629 12.2649 378.288 12.2204C380.921 11.946 383.526 12.209 385.614 12.968C386.66 13.3411 387.579 13.8238 388.345 14.3365C389.111 14.8534 389.716 15.401 390.206 15.8705C390.437 16.1191 390.649 16.3399 390.826 16.5386C390.997 16.7441 391.142 16.9203 391.259 17.0654C391.379 17.2083 391.454 17.3297 391.516 17.4083C391.573 17.4873 391.601 17.5268 391.601 17.5268C391.873 17.8747 392.103 18.2575 392.347 18.6288C392.569 19.0166 392.801 19.393 392.997 19.7977C393.412 20.5906 393.761 21.4207 394.07 22.2646C394.683 23.9614 395.133 25.7269 395.443 27.5254C395.758 29.3236 395.953 31.1448 396.065 32.9773C396.125 33.8891 396.162 34.828 396.208 35.7514L396.305 37.7845L390.608 38.0895L382.223 38.5415L382.147 37.0331C382.088 35.6115 381.988 34.1912 381.763 32.8742C381.542 31.5526 381.199 30.294 380.646 29.1459C380.101 28.0035 379.328 26.971 378.338 26.2428C377.353 25.5077 376.197 25.1148 375.079 24.9746L375.063 24.9613Z" fill="#0055CC"/>
<path d="M402.801 24.9656C402.203 22.6548 401.239 22.8832 401.63 25.2097C401.897 26.8631 402.16 28.5525 402.386 30.3878C402.496 31.3035 402.599 32.2556 402.664 33.2487C402.731 34.2438 402.77 35.2853 402.721 36.368C402.716 36.4986 402.712 36.6269 402.706 36.7533C402.692 36.9308 402.68 37.106 402.667 37.2728C402.649 37.501 402.616 37.7284 402.587 37.947C402.549 38.1706 402.513 38.3836 402.478 38.5859C402.35 39.3629 402.251 39.9632 402.194 40.3059C402.264 40.2831 402.36 40.2328 402.447 40.1938C402.536 40.1525 402.622 40.1093 402.707 40.0684C402.88 39.9863 403.049 39.9045 403.212 39.8253C403.541 39.6688 403.857 39.5134 404.161 39.3675C404.461 39.2218 404.753 39.0811 405.035 38.9434C405.166 38.8796 405.295 38.8181 405.42 38.7569C405.494 38.719 405.569 38.681 405.641 38.6454C406.222 38.3495 406.739 38.0886 407.235 37.8379C408.23 37.334 409.152 36.8765 410.402 36.3086C413.075 35.0677 416.694 33.4635 419.925 32.0504C420.732 31.6972 421.514 31.3587 422.252 31.0366C422.623 30.8766 422.982 30.7195 423.328 30.5699C423.651 30.4244 423.969 30.2815 424.278 30.1435L424.51 30.0373L424.627 29.9852C424.643 29.9754 424.67 29.971 424.679 29.9555L424.669 29.8934C424.645 29.7298 424.621 29.5703 424.596 29.4109C424.469 28.5658 424.357 27.8075 424.263 27.1716C424.181 26.6584 424.115 26.2443 424.066 25.9443C424.009 25.5906 423.941 25.2398 423.864 24.8897C423.747 24.3627 423.548 23.4609 423.258 22.267C423.115 21.6751 422.945 20.9912 422.762 20.281C422.599 19.5649 422.429 18.7845 422.257 17.937C421.919 16.25 421.588 14.3419 421.404 12.3017C421.312 11.2815 421.271 10.2275 421.314 9.17048C421.331 8.90671 421.348 8.64295 421.367 8.37693L421.413 7.98269L421.436 7.78557L421.445 7.71975C421.453 7.66451 421.46 7.64713 421.465 7.60892L421.506 7.4081C421.68 6.38378 422.084 5.13595 422.384 4.06711C422.287 4.10077 422.129 4.17316 421.956 4.25533C421.78 4.3356 421.585 4.42601 421.371 4.52428C420.941 4.7231 420.436 4.95568 419.886 5.21114C419.131 5.55774 418.245 5.96396 417.367 6.3653C411.226 9.21824 407.424 10.9851 405.438 11.9042C404.269 12.4546 403.174 12.9712 402.136 13.462C401.618 13.7104 401.117 13.9532 400.623 14.1911C400.196 14.396 399.771 14.5986 399.352 14.7986C399.183 14.8195 399.29 14.9823 399.295 15.091L399.363 15.446C399.409 15.6812 399.454 15.9123 399.497 16.1457C399.555 16.4219 399.614 16.6958 399.671 16.9678C399.726 17.219 399.783 17.4679 399.838 17.715C399.952 18.2087 400.069 18.6937 400.19 19.17C400.43 20.1249 400.684 21.0492 400.954 21.9637C401.557 23.9739 402.388 23.7488 401.992 21.7122C401.823 20.7825 401.653 19.851 401.478 18.8926C401.397 18.415 401.313 17.9312 401.226 17.4373C401.149 16.9592 401.07 16.4752 400.989 15.9786L400.974 15.8456L400.966 15.7812C400.966 15.7623 400.949 15.7324 400.982 15.7295L401.11 15.6785L401.173 15.6542L401.28 15.6092C401.78 15.3876 402.289 15.1588 402.814 14.9244C403.86 14.4477 404.962 13.9451 406.136 13.4069C407.958 12.5628 411.855 11.0143 417.234 8.56739C417.672 8.36786 418.107 8.16225 418.54 7.95474L419.186 7.63645L419.508 7.47429C419.526 7.46225 419.52 7.46071 419.527 7.45166C419.541 7.43581 419.56 7.41318 419.589 7.38756L419.638 7.34764L419.667 7.32619C419.667 7.32619 419.691 7.30737 419.688 7.31606C419.694 7.34069 419.694 7.39103 419.696 7.4622L419.696 7.51671L419.663 7.87844C419.633 8.14329 419.62 8.40669 419.607 8.67009C419.56 9.72334 419.595 10.7652 419.667 11.7724C419.824 13.7898 420.128 15.6834 420.427 17.3172C420.573 18.1354 420.726 18.8859 420.861 19.5603C421 20.2365 421.126 20.8298 421.25 21.3122C421.469 22.2689 421.597 22.8286 421.597 22.8286C421.597 22.8286 421.823 23.7951 422.142 25.3537C422.301 26.133 422.48 27.0597 422.663 28.0908C422.702 28.3203 422.743 28.5559 422.785 28.7957L422.803 28.9075L422.812 28.9654C422.818 28.9859 422.785 28.9846 422.771 28.9963C422.384 29.1767 421.984 29.3624 421.575 29.5511C417.19 31.5824 412.042 33.9717 408.986 35.3886L405.982 36.7841L404.671 37.3929L404.467 37.4882L404.366 37.5347L404.316 37.558L404.289 37.5708C404.289 37.5708 404.28 37.5779 404.277 37.576L404.28 37.5631C404.303 37.4584 404.319 37.3521 404.328 37.2442L404.345 37.0687C404.365 36.8613 404.372 36.6551 404.381 36.4465C404.431 35.2672 404.374 34.1685 404.284 33.1272C404.194 32.0859 404.057 31.1094 403.903 30.1765C403.593 28.3087 403.216 26.6124 402.802 24.9739L402.801 24.9656Z" fill="#0055CC"/>
<path d="M384.78 4.00317C387.938 3.20902 387.727 2.24328 384.526 2.8355C382.254 3.25484 379.932 3.70159 377.414 4.2115C376.157 4.47157 374.85 4.74014 373.477 5.02282C372.791 5.16832 372.086 5.31754 371.367 5.47009L371.218 5.49975C371.197 5.50156 371.166 5.52111 371.163 5.48779C371.092 5.3198 371.022 5.14955 370.951 4.97739C369.623 1.76683 368.946 -0.312608 368.381 -2.12056C367.842 -3.9371 367.411 -5.50071 367.051 -7.83206C366.893 -8.815 366.773 -9.88939 366.688 -11.0193C366.622 -12.1487 366.576 -13.3344 366.64 -14.536C366.704 -15.7375 366.819 -16.9582 367.064 -18.1397C367.308 -19.3212 367.637 -20.4743 368.076 -21.5384C368.18 -21.8056 368.312 -22.0583 368.428 -22.3159C368.488 -22.4429 368.547 -22.5717 368.605 -22.6964C368.676 -22.8221 368.743 -22.9475 368.812 -23.071C369.086 -23.5669 369.355 -24.0518 369.614 -24.5212C369.889 -24.9814 370.184 -25.4057 370.452 -25.8255C370.59 -26.0304 370.716 -26.2407 370.855 -26.4332C371 -26.62 371.14 -26.8041 371.278 -26.9818C371.556 -27.3353 371.803 -27.6799 372.06 -27.9813C372.327 -28.2708 372.576 -28.5442 372.802 -28.7905C373.238 -29.3046 373.671 -29.64 373.952 -29.9099L374.459 -30.3798L375.001 -30.8128C375.161 -30.9442 375.356 -31.1016 375.579 -31.2847C375.688 -31.3822 375.817 -31.471 375.954 -31.5606C376.091 -31.6542 376.237 -31.7509 376.39 -31.8543C376.986 -32.2879 377.767 -32.7207 378.666 -33.1973C380.483 -34.1269 382.926 -34.9702 385.749 -35.687C386.452 -35.8718 387.182 -36.0463 387.929 -36.2181C388.673 -36.3959 389.442 -36.5611 390.222 -36.7357C390.745 -36.8524 391.276 -36.9698 391.811 -37.0875C391.827 -37.0973 391.829 -37.0806 391.834 -37.0685L391.843 -37.0295L391.877 -36.8813C391.965 -36.4755 392.052 -36.0698 392.138 -35.6618C392.826 -32.3978 393.535 -29.0517 394.215 -25.8333C394.699 -23.5608 395.138 -21.507 395.533 -19.657C395.709 -18.833 395.874 -18.0563 396.03 -17.3228L396.047 -17.2508C396.046 -17.2319 396.008 -17.237 395.99 -17.2291C395.759 -17.1839 395.532 -17.139 395.315 -17.0972C393.858 -16.8198 392.563 -16.5564 391.456 -16.2549C390.349 -15.9574 389.427 -15.6237 388.695 -15.2811C387.829 -14.8809 387.014 -14.3843 386.312 -13.7653C385.606 -13.1501 385.025 -12.4137 384.602 -11.6258C384.182 -10.8319 383.945 -10.0036 383.788 -9.19684C383.737 -8.79165 383.662 -8.39072 383.656 -7.99783C383.648 -7.79989 383.64 -7.60612 383.631 -7.41235C383.631 -7.2193 383.643 -7.02734 383.649 -6.83691C383.805 -3.79328 384.714 -1.22835 385.709 1.20748C386.262 2.50247 386.762 3.06972 386.983 3.0044L386.993 2.90906C386.995 2.92988 387.006 2.93939 387.029 2.93532L387.023 2.9883C387.233 2.86729 387.157 2.12695 386.709 0.831265C385.907 -1.60452 385.185 -4.13535 385.149 -6.8662C385.149 -7.03616 385.145 -7.20576 385.149 -7.37608C385.164 -7.54521 385.174 -7.71399 385.187 -7.88504C385.199 -8.2302 385.278 -8.56223 385.326 -8.90422C385.476 -9.57396 385.682 -10.2423 386.022 -10.8571C386.365 -11.4682 386.82 -12.0321 387.389 -12.52C387.957 -13.0078 388.635 -13.4232 389.39 -13.7698C389.972 -14.0448 390.76 -14.3208 391.748 -14.5722C392.735 -14.8236 393.919 -15.0374 395.292 -15.2697C395.66 -15.3352 396.039 -15.3995 396.429 -15.469C396.772 -15.5364 397.118 -15.6043 397.469 -15.6724C397.646 -15.7088 397.826 -15.7432 398.003 -15.7796L398.137 -15.8059L398.206 -15.8181C398.206 -15.8181 398.218 -15.8192 398.222 -15.8237L398.22 -15.8404L398.213 -15.8733L398.161 -16.1416C397.961 -17.1481 397.754 -18.2066 397.532 -19.3163C397.2 -21.0059 396.833 -22.8478 396.421 -24.8327C396.152 -26.1249 395.86 -27.4132 395.553 -28.6874C394.886 -31.4349 394.198 -34.3926 393.546 -37.2862L393.341 -38.2231L393.235 -38.7028L393.183 -38.9396L393.156 -39.0589C393.152 -39.0775 393.15 -39.1025 393.141 -39.1143L393.079 -39.1005C392.467 -38.9657 391.858 -38.8289 391.251 -38.6944C390.541 -38.5343 389.839 -38.3748 389.149 -38.2206C387.771 -37.9081 386.435 -37.6014 385.194 -37.2777C382.705 -36.6507 380.584 -35.9233 379.116 -35.303C378.753 -35.1373 378.426 -34.9872 378.141 -34.8597C377.997 -34.7948 377.866 -34.7352 377.745 -34.6785C377.627 -34.6158 377.521 -34.5583 377.422 -34.5058C377.038 -34.2962 376.829 -34.1816 376.829 -34.1816C376.829 -34.1816 376.751 -34.1391 376.605 -34.0572C376.459 -33.9712 376.233 -33.8676 375.972 -33.6855C375.704 -33.5091 375.379 -33.2921 374.999 -33.0431C374.904 -32.9803 374.807 -32.9152 374.705 -32.8498C374.611 -32.7744 374.511 -32.6965 374.413 -32.6167C374.213 -32.4566 373.998 -32.2891 373.775 -32.1102C373.313 -31.7722 372.875 -31.3252 372.39 -30.8677C371.887 -30.4254 371.447 -29.8606 370.947 -29.3074C370.689 -29.0333 370.468 -28.7245 370.238 -28.4087C370.006 -28.097 369.77 -27.7743 369.529 -27.4513C369.295 -27.1226 369.093 -26.7673 368.869 -26.4185C368.652 -26.0639 368.416 -25.714 368.211 -25.3458C368.012 -24.9719 367.81 -24.5935 367.61 -24.2131C367.412 -23.8267 367.19 -23.4612 367.018 -23.0414C366.838 -22.6334 366.644 -22.2242 366.501 -21.7963L366.27 -21.1595C366.194 -20.9452 366.142 -20.7266 366.076 -20.5111C365.569 -18.7781 365.306 -16.9907 365.209 -15.2722C365.017 -11.8291 365.44 -8.6765 365.857 -6.37103C366.505 -2.89797 367.285 -0.399449 367.899 1.48819C368.53 3.37439 369.032 4.64646 369.43 5.61072C369.519 5.81702 369.604 6.02368 369.693 6.2258C369.821 6.52311 369.954 6.82006 370.092 7.11438L370.193 7.33434L370.219 7.39085C370.227 7.40905 370.255 7.38986 370.274 7.39032L370.391 7.36545L370.861 7.27014C371.154 7.20702 371.444 7.142 371.732 7.07923C372.451 6.91835 373.155 6.76081 373.838 6.60923C375.206 6.2955 376.507 5.99813 377.757 5.70926C380.258 5.1232 382.558 4.56506 384.799 4.00364L384.78 4.00317Z" fill="#0055CC"/>
<path d="M289.604 -5.95927C289.825 -7.16812 289.658 -7.81042 289.394 -7.85468C289.12 -7.90012 288.748 -7.36645 288.444 -6.25107C287.978 -4.67267 287.331 -3.1185 286.404 -1.58822C285.451 -0.0788647 284.202 1.41638 282.444 2.63884C282.187 2.81642 281.946 2.9884 281.706 3.1267C281.648 3.16317 281.588 3.19774 281.53 3.23421L281.447 3.28762C281.447 3.28762 281.409 3.30978 281.377 3.32517L281.29 3.36835C281.059 3.48283 280.835 3.59242 280.626 3.69867C280.424 3.80645 280.211 3.89829 280.009 3.98299C279.81 4.06733 279.626 4.14832 279.454 4.2199C279.131 4.36125 278.862 4.47897 278.656 4.5682C278.704 4.61647 278.78 4.66864 278.853 4.71892C278.925 4.77146 278.996 4.81983 279.068 4.87237C279.209 4.97138 279.347 5.07265 279.484 5.16786C279.754 5.36053 280.016 5.54559 280.268 5.72304C280.518 5.89859 280.76 6.0707 280.994 6.2371C281.17 6.35821 281.342 6.47968 281.508 6.59544C282.011 6.93785 282.46 7.2452 282.899 7.54495C283.773 8.1448 284.593 8.71793 285.64 9.49792C286.838 10.3781 288.231 11.4219 289.677 12.5177C290.398 13.0658 291.134 13.6272 291.868 14.1826C292.068 14.3352 292.27 14.4898 292.47 14.6424L292.955 15.0033L293.076 15.0935L293.136 15.1365L293.166 15.1612C293.166 15.1612 293.19 15.1507 293.202 15.1455L293.482 15.0373L294.04 14.8189L294.428 14.6468C294.65 14.5436 294.865 14.4306 295.078 14.3198C295.921 13.8585 296.673 13.3087 297.317 12.722C297.483 12.5796 297.641 12.4338 297.785 12.2807C297.933 12.1314 298.078 11.9825 298.221 11.84C298.484 11.5361 298.742 11.243 298.969 10.9548C299.883 9.79918 300.394 8.76454 300.697 8.20105C300.87 7.86299 301.007 7.51115 301.151 7.16086C301.27 6.89033 301.388 6.50663 301.543 6.03374C301.71 5.56394 301.847 4.99179 302.013 4.33953C302.105 4.01476 302.163 3.66562 302.234 3.29648C302.303 2.93376 302.376 2.55402 302.45 2.15726C302.521 1.78395 302.597 1.39552 302.673 0.992327C302.769 0.593762 302.883 0.187326 302.989 -0.237315C303.46 -1.91903 304.268 -3.72008 305.478 -5.37976C306.096 -6.19706 306.82 -6.9753 307.642 -7.65926C308.05 -8.00731 308.494 -8.31432 308.949 -8.61183L309.48 -8.92643C309.722 -9.05865 309.971 -9.18934 310.24 -9.31123C310.758 -9.55548 311.278 -9.80199 311.8 -10.0466C311.202 -10.492 309.695 -11.6078 308.218 -12.703C305.465 -14.7241 303.236 -16.3585 301.476 -17.6495C300.595 -18.2971 299.83 -18.8559 299.173 -19.3383C298.846 -19.5785 298.546 -19.8001 298.271 -20.0007C298.038 -20.1694 297.818 -20.3308 297.61 -20.4827C297.494 -20.565 297.378 -20.6472 297.27 -20.726C297.244 -20.7594 297.213 -20.7357 297.182 -20.7226L297.092 -20.6791C297.033 -20.6509 296.971 -20.6224 296.914 -20.5965C296.644 -20.4641 296.349 -20.3377 296.113 -20.204C295.961 -20.1194 295.804 -20.0429 295.661 -19.9466C295.516 -19.8563 295.37 -19.7661 295.229 -19.6762C295.09 -19.5803 294.954 -19.4824 294.82 -19.3869C294.549 -19.1934 294.3 -18.9851 294.054 -18.7791C293.819 -18.5594 293.574 -18.3598 293.365 -18.1298C292.493 -17.2443 291.803 -16.2907 291.244 -15.3315C290.158 -13.3931 289.552 -11.4542 289.197 -9.52671C288.87 -7.38335 289.73 -7.29835 290.238 -9.28538C290.758 -11.0888 291.464 -12.8475 292.528 -14.5574C293.072 -15.4019 293.716 -16.2236 294.498 -16.9838C294.687 -17.1806 294.905 -17.3485 295.111 -17.5384C295.329 -17.7105 295.547 -17.8909 295.782 -18.0519C295.901 -18.1335 296.018 -18.2129 296.139 -18.2968C296.263 -18.3705 296.386 -18.4483 296.512 -18.5243C296.637 -18.6044 296.768 -18.6682 296.898 -18.7403C296.958 -18.7749 296.982 -18.7854 297.027 -18.806C297.043 -18.8116 297.059 -18.8214 297.075 -18.827C297.089 -18.8156 297.105 -18.8023 297.118 -18.7909C297.157 -18.7585 297.195 -18.7262 297.236 -18.692C297.49 -18.4937 297.769 -18.2786 298.075 -18.0408C298.684 -17.5628 299.393 -17.0053 300.204 -16.3705C301.821 -15.1028 303.83 -13.5417 306.218 -11.7617C306.608 -11.4723 307 -11.1853 307.395 -10.9069L307.991 -10.4907L308.141 -10.3882C308.141 -10.3882 308.145 -10.3886 308.149 -10.389C308.156 -10.3874 308.164 -10.3881 308.172 -10.3889C308.198 -10.3869 308.247 -10.3723 308.287 -10.3505C308.274 -10.3264 308.253 -10.3015 308.185 -10.2431L308.026 -10.1412L307.856 -10.0215L307.515 -9.7822C307.288 -9.6219 307.077 -9.44412 306.856 -9.27395C305.994 -8.57388 305.217 -7.77012 304.539 -6.92241C303.169 -5.22782 302.263 -3.31968 301.676 -1.61952C301.604 -1.40558 301.532 -1.1958 301.461 -0.992448C301.389 -0.786833 301.346 -0.579579 301.287 -0.381476C301.185 0.0197139 301.063 0.395451 300.994 0.762334C300.848 1.4779 300.721 2.10572 300.615 2.62689C300.509 3.12497 300.445 3.52707 300.363 3.79018C300.29 4.05674 300.25 4.20078 300.25 4.20078C300.25 4.20078 300.188 4.43483 300.074 4.86019C300.018 5.07269 299.922 5.32023 299.824 5.6162C299.724 5.91027 299.618 6.24672 299.46 6.60036C299.308 6.95554 299.158 7.35463 298.943 7.75307C298.84 7.95289 298.734 8.1614 298.625 8.37859C298.502 8.58437 298.376 8.79468 298.248 9.01141C297.713 9.8635 297.042 10.7483 296.207 11.5257C296.102 11.623 295.997 11.7202 295.892 11.8174C295.785 11.9127 295.666 11.9985 295.555 12.09C295.334 12.2791 295.092 12.4386 294.853 12.6083C294.734 12.6941 294.604 12.7621 294.482 12.8418C294.359 12.9197 294.233 12.9956 294.101 13.0617C293.97 13.1296 293.844 13.2056 293.709 13.2614L293.533 13.3417C293.509 13.3522 293.493 13.3619 293.472 13.3679C293.433 13.3734 293.389 13.4255 293.358 13.3799L293.237 13.2897C292.982 13.102 292.724 12.9124 292.469 12.7247C291.958 12.3494 291.452 11.9778 290.954 11.6139C288.967 10.1558 287.13 8.80428 285.762 7.80036L283.266 5.96879L282.16 5.15826L281.992 5.03643L281.909 4.97438L281.868 4.94015C281.868 4.94015 281.82 4.91912 281.851 4.91433C281.973 4.86601 282.09 4.80973 282.204 4.74737L282.226 4.73497L282.264 4.71279L282.428 4.61469L282.757 4.42037C282.977 4.29221 283.184 4.13788 283.397 3.99986C285.383 2.6065 286.754 0.888816 287.729 -0.813492C288.682 -2.53899 289.266 -4.26186 289.612 -5.96416L289.604 -5.95927Z" fill="#0055CC"/>
<path d="M335.18 -24.8556C335.367 -27.0896 334.385 -27.2164 333.994 -25.0108C333.717 -23.4468 333.449 -21.8414 333.182 -20.0956C333.054 -19.2221 332.92 -18.3146 332.78 -17.3583C332.644 -16.3603 332.501 -15.3135 332.351 -14.2073C332.315 -13.902 332.279 -13.6073 332.272 -13.5479C332.586 -13.2373 332.882 -12.942 333.169 -12.6584C333.357 -12.4774 333.536 -12.2999 333.707 -12.1364C334.053 -11.8034 334.368 -11.5034 334.661 -11.2224C335.252 -10.6673 335.75 -10.1985 336.218 -9.76272C337.155 -8.88931 337.961 -8.13454 339.071 -6.99696C339.768 -6.28315 340.543 -5.4922 341.538 -4.47471C342.213 -4.57105 342.912 -4.67145 343.62 -4.77484C344.209 -4.85527 344.811 -4.93678 345.41 -5.02019C346.613 -5.17905 347.818 -5.34016 348.949 -5.49061C351.408 -5.80659 353.549 -6.08036 354.718 -6.22989C354.939 -6.58062 355.125 -6.88001 355.282 -7.13069C355.375 -7.27301 355.451 -7.3908 355.515 -7.49084C355.643 -7.68865 355.727 -7.81548 355.797 -7.92231C355.981 -8.20051 356.158 -8.48443 356.33 -8.77214C356.622 -9.26111 357.152 -10.1443 358.014 -11.5787C358.936 -13.098 360.217 -15.2044 361.956 -18.0724C361.796 -18.5474 361.552 -19.2816 361.244 -20.2012C360.997 -20.9457 360.704 -21.8414 360.38 -22.8288C359.735 -24.8082 358.978 -27.1597 358.266 -29.4229L357.826 -30.7822L346.487 -34.4322C346.071 -34.566 345.657 -34.698 345.367 -34.7904C344.773 -34.3822 344.196 -33.9902 343.636 -33.6038C343.197 -33.2972 342.767 -33.0018 342.351 -32.7098C341.523 -32.1239 340.738 -31.567 339.98 -31.0334C338.475 -29.9545 337.106 -28.942 335.757 -27.9207C334.187 -26.7334 334.67 -26.0221 336.355 -27.0389C337.803 -27.9114 339.251 -28.8111 340.81 -29.8065C341.585 -30.3101 342.392 -30.8333 343.246 -31.3858C343.996 -31.883 344.784 -32.4066 345.626 -32.9622C345.717 -32.9323 345.846 -32.889 345.978 -32.8479C346.88 -32.5568 348.252 -32.0525 350.06 -31.4015C350.964 -31.0812 351.977 -30.72 353.094 -30.3258C354.069 -29.9928 355.133 -29.6276 356.281 -29.234L356.327 -29.0953L356.539 -28.457C356.685 -28.0332 356.834 -27.6097 356.99 -27.1931C357.543 -25.6967 358.111 -24.0988 358.656 -22.52C359.156 -21.0526 359.648 -19.6076 360.1 -18.2892L360.045 -18.1921C359.979 -18.0815 359.913 -17.975 359.847 -17.8644C359.702 -17.6273 359.56 -17.3947 359.422 -17.1666C359.143 -16.7102 358.876 -16.2737 358.625 -15.8595C358.115 -15.0327 357.658 -14.2923 357.279 -13.6761C356.512 -12.4473 356.05 -11.7043 356.05 -11.7043L353.657 -7.82492L342.05 -6.02149L339.492 -8.60924L334.019 -14.1379L334.03 -14.2332C334.157 -15.2577 334.277 -16.227 334.393 -17.1498C334.503 -18.1077 334.607 -19.0211 334.706 -19.8962C334.896 -21.6521 335.05 -23.2727 335.182 -24.8537L335.18 -24.8556Z" fill="#0055CC"/>
<path d="M334.463 4.55043C336.378 5.19855 337.423 5.25896 337.511 5.00382C337.601 4.73999 336.74 4.16631 334.878 3.42756C332.352 2.4169 329.793 1.33152 327.049 0.0860085C325.677 -0.537881 324.262 -1.20208 322.786 -1.9218C322.048 -2.27958 321.294 -2.65483 320.524 -3.0434C320.14 -3.23882 319.751 -3.43804 319.356 -3.63881C318.73 -3.96432 318.098 -4.29136 317.454 -4.62376C317.2 -4.26182 316.851 -3.76363 316.498 -3.26091C311.509 3.94463 310.444 5.82257 307.026 10.6636C306.168 11.8815 305.22 13.2247 304.201 14.6706C303.026 16.3251 301.771 18.0936 300.448 19.9519C301.609 20.5878 302.784 21.2287 303.958 21.8718C304.893 22.372 305.832 22.8676 306.756 23.3477C308.612 24.3052 310.431 25.205 312.103 26.0043C315.451 27.6025 318.222 28.8038 319.543 29.3586C320.099 29.5979 320.659 29.8221 321.228 30.0372C323.093 30.7483 327.879 32.5744 334.242 34.4547C337.42 35.4003 340.99 36.3582 344.761 37.2378C346.647 37.6765 348.582 38.0984 350.545 38.4927C351.525 38.691 352.513 38.8802 353.502 39.0631L354.99 39.3328L357.469 39.7599C357.512 39.07 357.618 37.3781 357.721 35.7073C358.398 24.2427 358.818 17.1478 359.038 13.4422C359.115 12.0821 359.191 10.7663 359.248 9.79823C358.525 9.66157 357.813 9.53027 357.113 9.39788C356.669 9.31047 356.23 9.22686 355.799 9.14253C354.934 8.97197 354.095 8.79926 353.278 8.62663C351.643 8.27947 350.096 7.92473 348.607 7.5691C345.63 6.85142 342.892 6.12149 340.191 5.33379C338.504 4.8422 337.595 4.76987 337.515 5.00346C337.437 5.2242 338.192 5.75466 339.861 6.35065C342.533 7.3025 345.259 8.16562 348.242 8.98554C349.733 9.39341 351.289 9.78944 352.935 10.1692C353.757 10.3623 354.602 10.5471 355.474 10.7317C356.136 10.8674 356.819 11.0054 357.52 11.1503C357.485 11.7346 357.434 12.53 357.383 13.3486C357.181 16.7484 356.524 23.8218 355.888 33.8225C355.843 34.6301 355.797 35.4335 355.753 36.2389L355.697 37.4438C355.695 37.5154 355.695 37.4881 355.696 37.4965L355.7 37.5003L355.703 37.5147L355.713 37.5495C355.713 37.5495 355.699 37.557 355.686 37.5581C355.653 37.5568 355.753 37.5796 355.443 37.531C355.007 37.4618 354.566 37.3929 354.124 37.3222C353.241 37.1784 352.344 37.0274 351.449 36.8616C349.654 36.5388 347.844 36.1754 346.062 35.7822C342.497 35.0064 339.05 34.105 336.046 33.2324C333.043 32.3575 330.487 31.5175 328.681 30.8914C327.778 30.573 327.064 30.3202 326.573 30.1467C326.083 29.9667 325.818 29.8679 325.818 29.8679C321.699 28.3744 317.646 26.7051 313.653 24.9006C311.657 23.9951 309.679 23.0545 307.719 22.0746C306.741 21.5844 305.762 21.086 304.793 20.5804L303.34 19.8146L302.638 19.4369L309.085 10.2354C314.014 3.19241 316.386 -0.198335 317.845 -2.28244C317.896 -2.35604 317.946 -2.42965 317.981 -2.48098C318.602 -2.1676 319.205 -1.86528 319.791 -1.56985C320.573 -1.18236 321.337 -0.814252 322.09 -0.459821C323.592 0.247136 325.035 0.892152 326.437 1.484C329.24 2.67411 331.869 3.66742 334.463 4.55459L334.463 4.55043Z" fill="#0055CC"/>
<path d="M266.148 11.4376C265.904 11.2409 261.607 11.6971 262.767 12.4216C263.152 12.7387 263.531 12.7338 263.685 12.3129C263.756 13.1539 264.635 12.0998 265.004 12.398C264.83 12.9693 266.069 11.8381 265.807 12.4269C270.358 13.3708 279.961 8.37317 268.469 10.984C269.573 11.3221 268.502 11.4792 268.006 11.3161C268.775 10.623 266.63 11.1225 266.225 11.3523C266.878 11.3825 265.768 11.8563 266.15 11.4397L266.148 11.4376Z" fill="#101214"/>
<path d="M272.605 3.22316C273.458 2.36056 274.245 3.76267 275.035 3.06913C276.28 1.68993 267.453 -0.414982 267.475 1.23096C267.685 2.6437 272.067 2.52666 272.605 3.22316Z" fill="#101214"/>
<path d="M353.904 0.605135C351.888 -0.0406305 348.015 0.187959 346.143 -0.686571C344.414 -0.564747 342.931 -1.0713 341.224 -1.48882C341.674 -1.91768 342.883 -2.42509 342.976 -2.90903C346.063 -5.01434 340.805 -2.8555 339.877 -1.40738L339.89 -1.40739C339.89 -1.40739 339.691 -1.15637 339.673 -1.19408C339.802 -0.692643 340.458 -0.0652969 340.454 0.283156C343.482 2.73881 344.616 3.1592 341.381 -0.567943C342.528 -0.296267 343.241 0.288849 344.364 0.147743C344.642 0.54692 350.562 1.43902 348.42 0.717936C348.941 0.404403 350.793 1.07698 349.514 1.05847C350.098 1.25533 359.729 2.18758 358.787 0.832591C358.387 0.926263 357.763 0.58519 357.477 0.747534C357.422 0.905176 357.407 1.02061 357.253 0.965295C357.28 0.632353 356.933 0.630529 356.556 0.701981C356.088 0.866753 355.08 0.903412 355.236 0.665757C355.306 0.46149 353.472 0.982932 353.904 0.607357L353.904 0.605135Z" fill="#101214"/>
</g>
<g clipPath="url(#clip2_550_14457)">
<path d="M13.0459 7.94648C13.2244 7.80301 13.375 7.65148 13.5135 7.50519C13.6519 7.3589 13.7767 7.22429 13.8912 7.09266C14.1165 6.83394 14.2962 6.60644 14.4242 6.41279C14.6826 6.0274 14.7534 5.77787 14.657 5.68132C14.5605 5.58477 14.2987 5.63893 13.898 5.85831C13.6977 5.968 13.4612 6.12069 13.1927 6.31602C13.0586 6.41577 12.9146 6.52266 12.7657 6.64468C12.6168 6.7667 12.4583 6.90004 12.2783 7.02685C11.7797 7.3995 11.2791 7.7744 10.7705 8.1542C10.2398 8.49606 9.70493 8.83827 9.16244 9.18954C8.60947 9.51654 8.02636 9.81049 7.44957 10.1291C7.15404 10.2785 6.84575 10.4017 6.5389 10.5416C6.23133 10.6732 5.92782 10.8275 5.60858 10.9454C5.28898 11.0591 4.96332 11.1755 4.63765 11.2918C4.47464 11.3479 4.31044 11.4146 4.1448 11.4646C3.97464 11.5109 3.80449 11.5571 3.63433 11.6033C3.29175 11.6939 2.94835 11.7992 2.59636 11.8779C2.24139 11.9465 1.88225 12.0154 1.51931 12.0888C0.0606176 12.3264 -1.49813 12.4259 -3.12925 12.2945C-3.56103 12.2753 -3.97141 12.2123 -4.35537 12.1637C-4.54794 12.1447 -4.73171 12.1061 -4.90643 12.0751C-4.9938 12.0596 -5.08116 12.0441 -5.16436 12.0282C-5.22411 12.0166 -5.28576 12.0072 -5.34551 11.9956C-5.43287 11.9801 -5.5081 11.9594 -5.58713 11.9432C-6.21656 11.7732 -6.77491 11.6244 -7.25162 11.4978C-7.70977 11.3676 -8.08591 11.2638 -8.36563 11.1831C-8.05452 12.2599 -7.73595 13.2771 -7.45896 14.2015C-7.28585 14.7489 -7.12621 15.2617 -6.97515 15.748C-6.68674 16.6588 -6.42815 17.4673 -6.18005 18.2515C-5.68384 19.8199 -5.22994 21.2871 -4.66961 23.2339C-4.04204 25.3764 -3.32537 27.8951 -2.58721 30.5168C-2.22004 31.83 -1.84428 33.1696 -1.4715 34.4991C-1.25363 35.2733 -1.04029 36.0438 -0.825398 36.8078C-0.802628 36.8772 -0.789367 36.9578 -0.758627 37.0223L-0.551516 37.0883L-0.137285 37.2202L0.276945 37.3522L0.53893 37.4218C0.71283 37.4676 0.884474 37.5114 1.05837 37.5572C1.23346 37.5924 1.40628 37.6257 1.57946 37.6631C4.36235 38.2066 7.04848 37.8962 9.14027 37.3602C9.66062 37.2144 10.1485 37.0567 10.6086 36.9182C11.0609 36.7615 11.4697 36.5876 11.8496 36.4434C12.2341 36.3031 12.5622 36.1425 12.8562 35.9995C13.1502 35.8565 13.4062 35.7357 13.6198 35.6332C13.8785 35.5185 14.1157 35.3742 14.3552 35.2317L15.0752 34.7979C15.254 34.6817 15.4828 34.5611 15.7156 34.3899C15.9507 34.2205 16.2176 34.0316 16.5119 33.8194C16.8017 33.6033 17.1399 33.3894 17.4667 33.1155C17.7957 32.8436 18.1502 32.5506 18.5283 32.2388C18.716 32.0798 18.9169 31.9281 19.1073 31.7521C19.2955 31.5743 19.4897 31.3938 19.6897 31.2065C20.0835 30.8345 20.499 30.446 20.9358 30.0368C21.3513 29.6482 21.7823 29.2458 22.2305 28.8229C22.6881 28.4119 23.1922 28.0283 23.6952 27.6091C23.943 27.3925 24.219 27.2112 24.4958 27.0152C24.7708 26.8214 25.0517 26.625 25.3346 26.4263C25.4725 26.322 25.6221 26.2314 25.772 26.145C25.9215 26.0544 26.0733 25.9657 26.2248 25.8728C26.5303 25.6932 26.8325 25.4991 27.1493 25.329C28.4302 24.6598 29.8119 24.0406 31.3018 23.6052C32.7947 23.1799 34.3762 22.9064 36.0024 22.8599C36.8156 22.8251 37.6359 22.8736 38.4607 22.9489L39.0913 23.0348L39.4056 23.0789L40.0042 23.2075C40.8225 23.3779 41.6365 23.5717 42.4509 23.7697C42.1544 22.74 41.401 20.1363 40.667 17.5876C37.7264 7.53183 35.9053 1.30688 34.9535 -1.94261C34.9552 -2.23861 34.6651 -2.19668 34.4682 -2.26564C34.2584 -2.3146 34.0485 -2.36355 33.8387 -2.41251L33.6803 -2.44913C33.6311 -2.45956 33.6141 -2.46227 33.5778 -2.46961L33.3902 -2.50372L33.0173 -2.57001C32.7696 -2.61988 32.5206 -2.63607 32.2744 -2.66928L31.9055 -2.71284L31.5408 -2.73367C30.5668 -2.81081 29.6218 -2.74779 28.7074 -2.67062C26.8858 -2.45607 25.2051 -1.99564 23.6927 -1.35886C23.3041 -1.21817 22.9496 -1.02168 22.5817 -0.859698C22.4004 -0.772642 22.2187 -0.689742 22.0393 -0.604949C21.8648 -0.512183 21.6929 -0.413354 21.5206 -0.318686C21.1787 -0.123287 20.8406 0.0675779 20.5024 0.258452C20.1809 0.47097 19.8612 0.681234 19.5415 0.89149C19.3828 0.99757 19.226 1.10138 19.0692 1.20519C18.9128 1.31317 18.7677 1.43066 18.618 1.54435C18.321 1.77363 18.0236 1.99874 17.7304 2.22349C17.4281 2.44063 17.165 2.69844 16.8834 2.93687C16.6064 3.1791 16.3335 3.42097 16.0565 3.6632C14.9003 4.78106 14.4954 5.51069 14.6627 5.67453C14.8371 5.84825 15.5686 5.4743 16.7575 4.469C17.0367 4.25176 17.3182 4.03643 17.6015 3.81883C17.8853 3.60539 18.1547 3.37221 18.455 3.18042C18.7503 2.98066 19.0435 2.77901 19.3427 2.57472C19.4915 2.47579 19.6354 2.36889 19.7888 2.27377C19.9425 2.18281 20.0981 2.08959 20.256 1.99827C20.5672 1.81183 20.8807 1.62728 21.1938 1.43857C21.5194 1.27187 21.8468 1.10292 22.1765 0.935855C22.3434 0.852145 22.5062 0.768783 22.675 0.682808C22.8449 0.60933 23.0189 0.535501 23.193 0.461662C23.5419 0.322314 23.8814 0.148096 24.2446 0.0284898C25.6722 -0.5212 27.2231 -0.905332 28.8787 -1.07402C29.7068 -1.13111 30.5609 -1.17788 31.436 -1.10266L31.7652 -1.08084L32.0939 -1.04009C32.3148 -1.00888 32.5385 -0.994695 32.7585 -0.948727C32.959 -0.911546 33.1636 -0.874721 33.3663 -0.835639L33.4906 -0.804459C33.5296 -0.791045 33.5901 -0.794202 33.5831 -0.753728C33.7626 -0.108343 33.9886 0.711361 34.2604 1.69705C34.563 2.82065 34.9173 4.13071 35.3166 5.62151C36.1212 8.60049 37.1258 12.2923 38.3635 16.5934C38.7677 17.9957 39.1924 19.3919 39.6324 20.7701L39.7103 21.0172L39.7503 21.1397C39.7503 21.1397 39.7548 21.1435 39.757 21.1454C39.7661 21.153 39.7713 21.1651 39.7789 21.1792C39.7935 21.2031 39.816 21.2452 39.8321 21.2858C39.8094 21.2898 39.7776 21.2863 39.7337 21.288L39.7 21.2867L39.6811 21.2863L39.5858 21.2756L39.0005 21.2047C38.6159 21.1478 38.1999 21.1419 37.8004 21.1073C37.3951 21.0795 36.9912 21.0914 36.5855 21.0825C34.9651 21.0992 33.3478 21.3233 31.8071 21.7044C28.7091 22.4451 25.9889 23.9167 23.8329 25.4108C23.5617 25.6001 23.2986 25.7845 23.0374 25.9666C22.7852 26.1563 22.5484 26.3552 22.3129 26.5434C22.0774 26.7317 21.8479 26.9174 21.6222 27.0985C21.5105 27.19 21.3985 27.2773 21.2906 27.3643C21.1876 27.4593 21.0865 27.552 20.9873 27.6424C20.2001 28.3674 19.5102 29.0042 18.937 29.5344C18.6591 29.7914 18.4082 30.0209 18.1904 30.2202C18.0817 30.3219 17.9806 30.4146 17.8871 30.4983C17.7891 30.5781 17.6987 30.6489 17.6204 30.7144C17.3005 30.9709 17.13 31.1094 17.13 31.1094C17.13 31.1094 16.8416 31.3422 16.3261 31.7624C16.0647 31.9676 15.7272 32.1899 15.3418 32.4646C15.15 32.6009 14.9442 32.7446 14.7266 32.8977C14.509 33.0509 14.2624 33.1835 14.0092 33.3376C13.758 33.4895 13.4926 33.6489 13.2175 33.8154C12.9446 33.9838 12.637 34.1154 12.3319 34.2761C12.0216 34.4247 11.7142 34.6066 11.3733 34.7411C11.037 34.8794 10.6885 35.0229 10.3339 35.169C8.89465 35.705 7.25528 36.1346 5.51244 36.2647C4.64192 36.3402 3.74838 36.319 2.85551 36.2327L2.18746 36.1501L1.52224 36.0273C1.30062 35.9877 1.08518 35.9225 0.864745 35.8723L0.70406 35.8338L0.64585 35.8158L0.529429 35.7797C0.476824 35.778 0.495606 35.7281 0.478692 35.7023L0.439583 35.5651L0.23949 34.8753C0.105343 34.4149 -0.0284482 33.9585 -0.162235 33.5022C-0.429811 32.5896 -0.692493 31.685 -0.951844 30.7947C-1.99079 27.2401 -2.95224 23.9516 -3.66507 21.5018L-5.03013 16.8425L-5.71171 14.5117L-5.92228 13.7977L-5.96736 13.64L-5.99086 13.5623L-6.00278 13.5214C-6.00278 13.5214 -6.02077 13.4831 -6.00077 13.496C-5.91685 13.5202 -5.83258 13.5486 -5.74485 13.5683L-5.6163 13.5991L-5.29637 13.6595C-5.12807 13.689 -4.95906 13.7268 -4.78886 13.754L-4.27933 13.8231L-3.7698 13.8922L-3.25864 13.9319C-1.47352 14.073 0.223859 13.951 1.8069 13.6711C2.20054 13.5887 2.59002 13.5067 2.97117 13.4254C3.3535 13.3335 3.71855 13.2116 4.08731 13.1083C4.27151 13.0546 4.45344 12.999 4.63347 12.9456C4.81315 12.8881 4.98721 12.8142 5.162 12.7487C5.51122 12.6135 5.85438 12.481 6.19753 12.3484C6.53616 12.212 6.85488 12.0396 7.17958 11.8877C7.49939 11.7278 7.82481 11.5842 8.13331 11.4148C8.73565 11.052 9.34051 10.7184 9.90882 10.3502C10.4625 9.95811 11.0127 9.57471 11.5478 9.18631C12.0546 8.7626 12.5558 8.34566 13.0547 7.92683L13.0459 7.94648Z" fill="#0055CC"/>
<path d="M114.495 32.3233C112.222 31.5594 111.865 32.4842 114.065 33.4412C115.623 34.1181 117.228 34.7952 118.977 35.5123C119.855 35.8642 120.766 36.2322 121.724 36.617C122.269 36.8321 122.83 37.0521 123.405 37.2771C123.642 37.3719 123.882 37.4581 124.118 37.5446L124.298 37.6109L124.387 37.6431L124.432 37.658C124.448 37.6672 124.451 37.6354 124.461 37.6282L124.677 37.3074C124.82 37.0915 124.962 36.8714 125.107 36.6532C125.214 36.4803 125.323 36.3051 125.431 36.1299C126.78 33.8413 127.434 32.3201 127.986 30.9923C128.522 29.6576 128.956 28.5121 129.531 26.8088C130.002 25.3663 130.481 23.6442 130.752 21.7826C131.029 19.9289 131.072 17.9297 130.72 16.0614C130.685 15.8273 130.618 15.6003 130.566 15.3718L130.485 15.0327C130.452 14.9243 130.42 14.8201 130.388 14.7117C130.257 14.2887 130.129 13.8759 130.004 13.4734C129.871 13.0758 129.708 12.6954 129.569 12.3277C129.497 12.143 129.427 11.9644 129.357 11.79C129.273 11.619 129.194 11.4517 129.115 11.2886C128.956 10.9624 128.812 10.6518 128.666 10.3665C128.501 10.0891 128.349 9.82956 128.209 9.59201C127.945 9.10715 127.656 8.75656 127.474 8.4912L127.134 8.0276L126.744 7.59974C126.627 7.47357 126.483 7.32232 126.319 7.14562C126.159 6.96439 125.94 6.79237 125.717 6.58514C125.273 6.16197 124.688 5.71968 124.013 5.24104C122.649 4.29127 120.829 3.37894 118.787 2.5467C117.766 2.12111 116.69 1.71915 115.586 1.30078C115.27 1.18135 114.951 1.06003 114.628 0.93906C114.367 0.83993 114.105 0.738895 113.84 0.640126L113.446 0.4897L113.246 0.41467L113.146 0.37717L113.096 0.35841C113.096 0.35841 113.082 0.389005 113.075 0.406389C112.755 1.2378 112.429 2.08018 112.103 2.92671C111.218 5.21915 110.304 7.56446 109.412 9.8156C108.794 11.4093 108.234 12.851 107.732 14.1514C107.421 14.9526 107.128 15.7103 106.85 16.4268C106.745 16.6982 106.644 16.965 106.543 17.2276L106.506 17.3274C106.489 17.3478 106.52 17.3471 106.533 17.3544L106.583 17.3731L106.78 17.4463C106.91 17.4938 107.038 17.5435 107.168 17.591C107.634 17.7625 108.085 17.9291 108.525 18.0903C109.559 18.458 110.424 18.7754 111.129 19.0899C111.836 19.4021 112.382 19.7072 112.788 19.9826C113.763 20.6283 114.417 21.4256 114.721 22.3225C115.031 23.2209 115.01 24.211 114.85 25.1627C114.514 27.0782 113.723 28.8274 112.888 30.5008C112.427 31.3926 112.339 31.952 112.53 32.0971L112.524 32.1921C112.543 32.1967 112.555 32.1914 112.562 32.174L112.566 32.1192C112.77 32.2253 113.25 31.9025 113.813 31.0312C114.839 29.3874 115.819 27.6386 116.32 25.4445C116.554 24.3541 116.654 23.1054 116.251 21.8205C116.047 21.1856 115.719 20.5657 115.278 20.0207C114.838 19.4734 114.298 19.004 113.712 18.6079C113.257 18.2948 112.658 17.946 111.931 17.5894C111.201 17.2309 110.34 16.8775 109.378 16.5014C109.259 16.4551 109.137 16.4069 109.015 16.3587L108.972 16.3415L108.965 16.3358L108.952 16.3285L108.932 16.3114L108.894 16.2874C108.885 16.2798 108.864 16.2774 108.883 16.2548C108.905 16.2235 108.922 16.1989 108.937 16.1767C109.05 15.9046 109.164 15.6303 109.285 15.345C109.769 14.1721 110.29 12.891 110.842 11.5045C111.2 10.6006 111.535 9.68824 111.85 8.77542C112.189 7.78926 112.548 6.77404 112.917 5.74334C113.278 4.74895 113.644 3.73943 114.005 2.74504L114.061 2.56814C114.061 2.56814 114.066 2.54885 114.07 2.54849L114.092 2.555L114.135 2.56806L114.223 2.59607L114.268 2.61102L114.292 2.61945L114.381 2.65161L114.756 2.78908C115.003 2.88097 115.248 2.97094 115.491 3.06319C115.976 3.24351 116.451 3.42266 116.91 3.60324C117.372 3.77931 117.813 3.96134 118.238 4.13648C119.943 4.84051 121.328 5.56817 122.259 6.15047C122.71 6.45973 123.088 6.68503 123.314 6.87524C123.546 7.05866 123.675 7.15875 123.675 7.15875C123.675 7.15875 123.72 7.1968 123.812 7.26645C123.898 7.33873 124.044 7.43095 124.196 7.58148C124.355 7.72712 124.549 7.90546 124.772 8.1127C124.829 8.16442 124.886 8.21615 124.948 8.27167C125.001 8.33208 125.059 8.39212 125.117 8.45634C125.233 8.58477 125.355 8.7189 125.483 8.861C126.504 9.99784 127.669 11.8 128.462 14.0309C128.555 14.3103 128.651 14.5957 128.747 14.8812C128.839 15.167 128.95 15.4574 129.012 15.7415C129.087 16.0288 129.164 16.3138 129.211 16.6119L129.291 17.0539C129.312 17.2032 129.325 17.3531 129.347 17.5023C129.488 18.7029 129.464 19.9345 129.335 21.1165C129.074 23.485 128.427 25.6372 127.869 27.2046C127.024 29.5691 126.192 31.2486 125.546 32.5173C124.889 33.7808 124.393 34.6273 124.007 35.2609C123.939 35.3738 123.871 35.4825 123.805 35.589L123.775 35.6377C123.775 35.6377 123.741 35.6281 123.724 35.6254L123.618 35.5863C123.167 35.4156 122.729 35.2521 122.3 35.0921C121.329 34.7356 120.408 34.3979 119.52 34.072C117.742 33.4309 116.096 32.8581 114.486 32.3157L114.495 32.3233Z" fill="#0055CC"/>
<path d="M63.2213 -4.91981C64.3036 -4.55832 64.931 -4.50988 65.0627 -4.7584C65.1871 -4.9937 64.7809 -5.5439 63.6473 -6.03733C62.8457 -6.3791 62.0109 -6.66763 61.1289 -6.89542C60.2473 -7.11905 59.3135 -7.2899 58.3289 -7.34513C57.8413 -7.40358 57.3321 -7.37202 56.8151 -7.38176C56.558 -7.36997 56.296 -7.34306 56.0313 -7.32222C55.898 -7.31066 55.7647 -7.29911 55.6314 -7.28755C55.497 -7.2654 55.3648 -7.24136 55.2303 -7.21921C54.1508 -7.06059 53.0339 -6.72876 51.9327 -6.21366C51.7776 -6.13937 51.624 -6.0715 51.4775 -5.99376C51.3356 -5.91221 51.1978 -5.83104 51.0597 -5.75402C50.7857 -5.59808 50.528 -5.44774 50.2994 -5.27685C50.0662 -5.10976 49.8377 -4.96196 49.6378 -4.79776C49.4383 -4.6294 49.2487 -4.46819 49.0667 -4.31603C48.7053 -4.00564 48.4124 -3.68019 48.1181 -3.3945C47.8555 -3.08218 47.5991 -2.79557 47.3722 -2.50733C46.4759 -1.34485 45.8317 -0.275565 45.0325 1.33172C44.3767 2.70416 43.7657 4.37696 43.3437 6.17395C42.9124 7.95917 42.6876 9.9258 42.8109 11.7679C42.9178 13.6155 43.3565 15.3442 43.9484 16.684C44.5304 18.031 45.2423 18.9618 45.621 19.485C45.8706 19.776 46.1183 20.0692 46.3915 20.3414C46.8871 20.8083 47.8267 21.6795 49.2654 22.4989C49.6286 22.6962 50.0023 22.9177 50.4196 23.1102C50.8332 23.3072 51.2794 23.4931 51.7434 23.6669C52.6774 24.0119 53.698 24.3137 54.8094 24.5258C57.0183 24.9575 59.6288 24.962 62.1114 24.1404C63.3524 23.7391 64.5396 23.1263 65.6002 22.3608C66.6654 21.5991 67.6064 20.6867 68.4118 19.7104C69.54 18.318 70.3115 16.8999 70.9125 15.5972C71.4954 14.2794 71.8779 13.0712 72.1641 11.9868C72.4458 10.8986 72.6224 9.93065 72.7077 9.09447C72.8141 8.26064 72.8305 7.55211 72.8419 6.97831C72.8528 4.26015 72.1712 1.85591 71.051 -0.0633815C70.4777 -1.01665 69.8234 -1.86426 69.0796 -2.58242C68.3284 -3.28736 67.5418 -3.9179 66.6795 -4.40338C66.2508 -4.67885 65.8679 -4.78834 65.5987 -4.84473C65.3256 -4.8966 65.1518 -4.86894 65.0821 -4.77687L65.145 -4.63126C65.1232 -4.66504 65.0952 -4.67311 65.0588 -4.65736L65.0431 -4.69376C65.0108 -4.58185 65.0816 -4.41803 65.2604 -4.21742C65.4355 -4.01228 65.7286 -3.80058 66.0982 -3.50529C66.8482 -2.98281 67.5077 -2.34335 68.1348 -1.66543C68.7505 -0.973925 69.282 -0.187015 69.7486 0.672685C70.2113 1.53691 70.5551 2.50588 70.8114 3.55585C71.0594 4.60655 71.2063 5.74994 71.1886 6.97894C71.1966 7.21745 71.1654 7.48872 71.1497 7.79223C71.1381 8.09539 71.0911 8.42678 71.0364 8.79032C70.948 9.51559 70.767 10.3601 70.5057 11.2954C69.9645 13.1699 69.1073 15.4663 67.5012 17.7163L67.3088 17.9911L67.1005 18.2525L66.6908 18.7811C66.3873 19.1054 66.1203 19.4642 65.8002 19.7668C65.6299 19.9327 65.4716 20.1164 65.2858 20.273C65.1023 20.4316 64.9187 20.5902 64.7333 20.7511C64.3409 21.0432 63.9478 21.35 63.5114 21.5935C62.6552 22.102 61.7221 22.5228 60.7441 22.7629C58.7947 23.2718 56.7658 23.2231 55.0396 22.865C53.3077 22.5136 51.8735 21.9413 50.9288 21.4483C50.4595 21.1889 50.0869 20.9799 49.8427 20.8249C49.602 20.6611 49.4726 20.5716 49.4726 20.5716C49.4726 20.5716 49.4235 20.5381 49.3322 20.4768C49.2405 20.4113 49.0971 20.3293 48.9364 20.1942C48.772 20.0637 48.5714 19.9027 48.3372 19.7174C48.1201 19.5117 47.8736 19.2813 47.5996 19.0239C47.0988 18.4714 46.5061 17.8031 46.0168 16.9475C45.52 16.1009 45.0877 15.1039 44.7938 14.0068C44.1804 11.8107 44.2512 9.25102 44.7058 6.95602C45.1626 4.63984 45.9616 2.59194 46.736 1.18404C47.8904 -0.951311 49.1258 -2.26907 50.1581 -3.12021C51.1942 -3.97588 52.0123 -4.41609 52.6484 -4.70413C53.6061 -5.15434 54.5704 -5.45614 55.5178 -5.6138C55.6356 -5.6345 55.753 -5.65937 55.8686 -5.68198C55.9871 -5.69435 56.1034 -5.70862 56.2219 -5.72099C56.4548 -5.74538 56.6851 -5.77583 56.9142 -5.79569C57.3752 -5.80208 57.8243 -5.8494 58.2681 -5.81234C60.0484 -5.77572 61.691 -5.41453 63.2383 -4.91709L63.2213 -4.91981Z" fill="#0055CC"/>
<path d="M149.643 41.1462C149.707 41.1386 149.772 41.135 149.834 41.1296C149.897 41.1284 149.958 41.1335 150.017 41.1368C150.136 41.1434 150.255 41.1393 150.367 41.1485C150.584 41.1884 150.799 41.195 150.983 41.2609C151.077 41.2863 151.167 41.3078 151.257 41.3294C151.342 41.3619 151.422 41.3948 151.5 41.4216C151.58 41.4504 151.654 41.4776 151.725 41.5028C151.793 41.5368 151.859 41.5689 151.92 41.5972C152.179 41.7027 152.367 41.8102 152.516 41.8582C152.665 41.9103 152.768 41.9119 152.818 41.8655C152.869 41.8192 152.863 41.7211 152.795 41.5675C152.727 41.4139 152.604 41.2022 152.364 40.9733C152.304 40.9155 152.242 40.8517 152.176 40.7882C152.104 40.7315 152.021 40.6736 151.936 40.6138C151.851 40.554 151.758 40.4908 151.66 40.4279C151.555 40.3783 151.444 40.3271 151.328 40.2721C151.099 40.1534 150.826 40.0974 150.536 40.0197C150.391 39.9903 150.237 39.9806 150.078 39.9629C149.999 39.955 149.919 39.9452 149.837 39.9418C149.757 39.9445 149.674 39.9476 149.59 39.9506C148.636 39.9788 147.736 40.254 146.905 40.6177C146.068 40.9798 145.315 41.471 144.572 41.9823C144.209 42.2488 143.842 42.5115 143.498 42.8057C143.142 43.0862 142.801 43.3864 142.46 43.695L142.203 43.9229C142.117 43.9975 142.015 44.1008 141.928 44.1902C141.84 44.2818 141.755 44.373 141.675 44.4639L141.463 44.7068L141.37 44.8029C141.341 44.8285 141.308 44.8776 141.28 44.8192L141.196 44.7216L141.177 44.698L141.059 44.5718L140.819 44.3157C140.497 43.9722 140.173 43.6226 139.843 43.2714C139.187 42.5688 138.512 41.8509 137.823 41.1133C136.438 39.6471 134.985 38.105 133.447 36.4758C133.366 36.3925 133.286 36.3093 133.205 36.2261L133.16 36.188C133.113 36.1606 133.152 36.1278 133.173 36.0987L133.224 36.0376C133.316 35.9373 133.407 35.8393 133.497 35.7413C133.679 35.5471 133.86 35.3593 134.04 35.1738C134.763 34.4418 135.456 33.7649 136.09 33.1581C137.34 31.9418 138.448 30.9918 139.511 30.1548C140.576 29.3197 141.597 28.587 142.741 27.9067C143.884 27.2263 145.144 26.5737 146.712 25.9993C147.041 25.8701 147.387 25.775 147.733 25.6568C148.083 25.5489 148.444 25.4588 148.809 25.36C149.549 25.1973 150.314 25.0408 151.105 24.9722C152.687 24.8036 154.367 24.8909 156.008 25.2858C157.649 25.6806 159.244 26.388 160.67 27.3471C162.105 28.2991 163.355 29.4853 164.442 30.7697C165.532 32.0453 166.437 33.3937 167.101 34.744C167.769 36.094 168.2 37.4415 168.453 38.689C168.707 39.9385 168.791 41.0831 168.821 42.0542C168.854 43.0248 168.81 43.826 168.784 44.399L168.72 45.4389C168.704 45.7886 168.699 46.1626 168.693 46.5093C168.686 47.1141 168.656 47.9581 168.694 49.1446C168.711 49.7348 168.755 50.4171 168.886 51.1989C169.02 51.9762 169.253 52.8834 169.791 53.7915C170.053 54.2472 170.391 54.6816 170.799 55.0868C171.204 55.5007 171.727 55.8667 172.326 56.1546C172.941 56.4245 173.637 56.5655 174.345 56.5693C175.051 56.5605 175.743 56.4082 176.418 56.1881C177.747 55.7099 178.979 54.9338 180.172 53.9974C180.767 53.5283 181.354 53.0136 181.936 52.4638C182.23 52.1929 182.508 51.9211 182.801 51.6419C182.857 51.5887 182.911 51.5337 182.968 51.4805L183.01 51.4391C183.026 51.4524 183.042 51.4657 183.06 51.481L183.076 51.4943L183.085 51.5019L183.154 51.5756C183.256 51.6801 183.36 51.7907 183.472 51.9047C183.91 52.3619 184.42 52.8906 184.982 53.4797C186.108 54.6578 187.46 56.0766 188.952 57.6405C189.633 58.3557 190.346 59.1059 191.082 59.8793C191.101 59.907 191.162 59.9353 191.113 59.9669L191.075 60.0121L190.913 60.1856C190.524 60.6075 190.105 61.0278 189.673 61.445C189.235 61.8649 188.793 62.2851 188.349 62.7117C187.9 63.1179 187.462 63.5461 186.997 63.9389C186.087 64.7501 185.126 65.5027 184.164 66.2239C181.541 68.1593 178.922 69.5424 176.438 70.3284C173.956 71.1228 171.629 71.2992 169.639 71.0479C168.643 70.9245 167.728 70.7079 166.902 70.427C166.08 70.1373 165.338 69.8072 164.678 69.449C163.359 68.7303 162.368 67.9392 161.596 67.2591C160.691 66.4521 159.878 65.572 159.161 64.6753C158.43 63.7861 157.823 62.8547 157.303 61.9115C156.265 60.0228 155.669 58.0497 155.387 56.0934C155.235 55.1162 155.172 54.1397 155.141 53.1751C155.104 52.2089 155.139 51.2533 155.147 50.279C155.152 49.3092 155.16 48.358 155.127 47.3873C155.092 46.4231 155.005 45.4381 154.757 44.4609C154.485 43.4059 153.996 42.6741 153.603 42.2822C153.412 42.0785 153.232 41.9619 153.1 41.8936C152.968 41.8253 152.879 41.812 152.832 41.8497L152.701 41.8442C152.697 41.8635 152.703 41.8692 152.722 41.8655L152.829 41.8436L152.808 41.8685C152.77 41.9138 152.772 42.008 152.817 42.1426C152.86 42.2752 152.946 42.4482 153.042 42.6791C153.244 43.1316 153.527 43.7785 153.718 44.7041C153.889 45.5705 153.936 46.4792 153.926 47.4054C153.92 48.3312 153.872 49.2838 153.833 50.2398C153.722 52.1482 153.636 54.1889 153.902 56.2935C154.151 58.3995 154.77 60.593 155.881 62.6747C156.437 63.7134 157.093 64.7371 157.873 65.7018C158.641 66.6759 159.501 67.6149 160.49 68.5006C161.26 69.1829 162.28 70.0177 163.649 70.8244C165.02 71.6183 166.762 72.3758 168.863 72.7476C170.959 73.1156 173.393 73.0683 175.922 72.44C178.453 71.8219 181.043 70.6301 183.565 69.0036C185.208 67.94 186.742 66.7265 188.162 65.4284C188.478 65.1492 188.784 64.8541 189.092 64.5567C189.402 64.2613 189.714 63.9636 190.011 63.665C190.619 63.0668 191.235 62.4573 191.845 61.8107L192.299 61.316C192.345 61.2617 192.523 61.0679 192.639 60.9257L193.021 60.4708L193.391 60.0086L193.486 59.8955C193.48 59.8561 193.425 59.821 193.399 59.7834L193.195 59.566C192.933 59.2761 192.65 58.988 192.374 58.7014C191.761 58.0705 191.146 57.4377 190.534 56.8068C189.331 55.5598 188.135 54.3226 186.969 53.1144C185.625 51.7139 184.318 50.348 183.066 49.0444C182.442 49.6398 181.829 50.2259 181.227 50.8048C181.016 51.0098 180.808 51.2062 180.602 51.3919C180.393 51.5799 180.196 51.7733 179.987 51.9488C179.164 52.6706 178.326 53.2951 177.498 53.7927C176.67 54.2863 175.836 54.6439 175.066 54.7841C174.293 54.9266 173.6 54.8461 173.042 54.5966C172.477 54.3497 172.045 53.936 171.712 53.5326C171.383 53.1289 171.169 52.7362 171.022 52.3965C170.949 52.2266 170.901 52.067 170.85 51.9351C170.811 51.7937 170.778 51.677 170.753 51.5826C170.724 51.4886 170.713 51.4098 170.7 51.3606C170.689 51.309 170.683 51.2844 170.683 51.2844C170.683 51.2844 170.655 51.1757 170.62 50.9647C170.602 50.8571 170.582 50.7245 170.558 50.5692C170.542 50.409 170.522 50.2261 170.5 50.0182C170.428 49.181 170.429 47.9304 170.475 46.3506C170.48 45.578 170.559 44.7172 170.575 43.7653C170.586 42.816 170.584 41.7985 170.473 40.7275C170.366 39.6562 170.183 38.5328 169.879 37.3967C169.563 36.2616 169.12 35.1208 168.563 34.0109C168.013 32.8919 167.297 31.8419 166.532 30.8276C166.332 30.5785 166.135 30.3312 165.933 30.0802C165.729 29.8356 165.508 29.603 165.296 29.3632C165.082 29.1258 164.871 28.886 164.637 28.6587C164.41 28.4287 164.184 28.1965 163.941 27.9846C162.045 26.2207 159.744 24.834 157.312 24.1068C154.881 23.3649 152.383 23.3003 150.19 23.631C147.983 23.9545 146.071 24.6532 144.51 25.353C142.165 26.4333 140.292 27.6636 138.737 28.8286C137.183 29.9978 135.935 31.0964 134.891 32.0807C133.859 33.0556 132.992 33.8798 132.263 34.6501C132.173 34.7481 132.085 34.8439 131.996 34.9355C131.87 35.0807 131.724 35.2361 131.601 35.3915C131.474 35.5473 131.351 35.6986 131.228 35.8498C131.165 35.9245 131.108 36.0008 131.048 36.0732C131.006 36.1461 130.87 36.225 130.986 36.2883C131.232 36.5607 131.465 36.8217 131.709 37.0734C131.889 37.2634 132.062 37.4477 132.23 37.624C133.778 39.2461 135.238 40.775 136.632 42.2363C137.33 42.9626 138.015 43.6733 138.681 44.3688C139.015 44.7154 139.345 45.0583 139.674 45.3969C139.865 45.5964 140.056 45.7918 140.245 45.9894L140.649 46.4098C140.784 46.5428 140.916 46.6615 141.049 46.7885L141.247 46.9748L141.299 47.0185L141.32 47.044C141.325 47.0478 141.329 47.0516 141.332 47.0535L141.343 47.0399L141.444 46.943L141.83 46.5529C142.085 46.3 142.335 46.0077 142.564 45.7213C142.888 45.3177 143.089 45.0967 143.437 44.779C143.751 44.4791 144.068 44.1851 144.395 43.9113C144.712 43.6257 145.047 43.3701 145.374 43.1088C146.043 42.6165 146.72 42.1424 147.435 41.8013C148.146 41.4564 148.886 41.2055 149.62 41.1503L149.643 41.1462Z" fill="#0055CC"/>
<path d="M80.321 9.381C80.4416 7.10655 79.4571 7.02823 79.1312 9.25752C78.8942 10.8392 78.6434 12.4555 78.3341 14.1966C78.018 15.932 77.6635 17.8049 77.0533 19.8029C76.9621 20.1318 76.8558 20.4327 76.7629 20.7177C76.7418 20.7888 76.7161 20.8561 76.6904 20.9233C76.6579 21.008 76.6295 21.0923 76.5966 21.1728C76.5069 21.4218 76.4055 21.6573 76.3015 21.8866C75.8871 22.7744 75.5595 23.4763 75.3454 23.9376C76.5743 23.808 77.6597 23.6698 78.5962 23.5572C79.1374 23.483 79.6268 23.4154 80.1059 23.3508C81.0599 23.2219 81.9734 23.1092 83.1533 22.9964C85.9529 22.7118 89.7215 22.3998 93.0728 22.1386C93.9107 22.0744 94.7237 22.0123 95.4885 21.9523C95.6782 21.938 95.8679 21.9236 96.0534 21.9097C96.3908 21.8804 96.7199 21.8519 97.0447 21.8237C97.2132 21.807 97.3821 21.7945 97.5465 21.7781L97.6089 21.7727C97.6204 21.7591 97.6182 21.7341 97.6228 21.7148L97.6419 21.5957L97.6801 21.3574C97.73 21.0362 97.7788 20.7257 97.826 20.4215C97.9332 19.7429 98.0279 19.1388 98.1097 18.6281C98.1809 18.1394 98.241 17.7418 98.2835 17.4569C98.332 17.1191 98.3699 16.7801 98.4014 16.4396C98.4496 15.9045 98.5308 14.9722 98.6212 13.7348C98.6626 13.1206 98.7101 12.4304 98.7605 11.6769C98.8248 10.9391 98.9042 10.1327 98.9956 9.27083C99.1893 7.55237 99.4495 5.63093 99.8761 3.6447C100.088 2.65271 100.35 1.64389 100.688 0.657733C100.777 0.415087 100.869 0.172091 100.959 -0.0728197L101.111 -0.432169L101.185 -0.612789C101.19 -0.632072 101.226 -0.698169 101.255 -0.755205L101.343 -0.924419L101.695 -1.60959C101.746 -1.72103 101.822 -1.84298 101.901 -1.96529L102.126 -2.32887C102.421 -2.80344 102.713 -3.27991 103.01 -3.75675C102.93 -3.75822 102.807 -3.74549 102.664 -3.73095C102.522 -3.71867 102.364 -3.70079 102.189 -3.68563C101.84 -3.65113 101.434 -3.60967 100.989 -3.56688C100.271 -3.49835 99.4285 -3.41482 98.594 -3.33619C92.1629 -2.6822 88.1819 -2.27836 86.104 -2.06678C84.8775 -1.93528 83.7301 -1.81063 82.6387 -1.69294C81.9634 -1.61553 81.3068 -1.54182 80.6649 -1.4673L80.3138 -1.42637L80.1393 -1.40705L80.054 -1.39756C80.054 -1.39756 80.0158 -1.40264 80.0195 -1.38408L80.0129 -1.33944C79.9849 -1.10411 79.9566 -0.872952 79.9306 -0.639888C79.9042 -0.410991 79.8778 -0.182091 79.8514 0.046808C79.8379 0.182264 79.824 0.313557 79.8105 0.449013C79.6178 2.44645 79.5162 4.28491 79.4719 6.10582C79.4328 8.10883 80.2926 8.15179 80.5363 6.1856C80.7678 4.39463 81.0108 2.59008 81.2991 0.630513C81.3163 0.51362 81.3335 0.396721 81.3507 0.279829L81.3736 0.156149L81.3968 0.0366324C81.4245 0.0174448 81.4801 0.0294168 81.5173 0.0220026L81.6426 0.0153272C81.7592 0.00521753 81.8758 -0.00488413 81.9924 -0.0149939C82.259 -0.0381019 82.5275 -0.0634723 82.8005 -0.0850388C83.891 -0.187965 85.0441 -0.296311 86.2698 -0.413054C88.1772 -0.605671 92.1765 -0.77399 97.792 -1.29854C98.2499 -1.34242 98.7073 -1.39046 99.1621 -1.44458L99.459 -1.4808C99.459 -1.4808 99.4628 -1.48532 99.4666 -1.48985C99.4723 -1.49664 99.4841 -1.50606 99.5061 -1.51846C99.5282 -1.53086 99.5786 -1.55412 99.6074 -1.56081C99.6134 -1.54035 99.619 -1.52404 99.5928 -1.43784L99.5732 -1.37321L99.4323 -1.01267C99.3335 -0.771204 99.2457 -0.524399 99.1662 -0.278311C98.8317 0.707485 98.5712 1.70154 98.3498 2.68592C97.9192 4.64943 97.6406 6.5515 97.4316 8.21463C97.2283 9.87097 97.0684 11.3011 96.9964 12.3145C96.9101 13.3082 96.8578 13.8939 96.8578 13.8939C96.8578 13.8939 96.7819 14.8384 96.6206 16.3484C96.541 17.1044 96.4359 18.0011 96.3094 18.9919C96.2578 19.3657 96.2075 19.7561 96.1523 20.1616C96.1696 20.265 96.0622 20.2366 95.9922 20.2511C95.7737 20.2721 95.5533 20.2954 95.3287 20.3191C90.738 20.782 85.3487 21.3268 82.1496 21.6503L79.3959 21.931L78.3394 22.0393L78.1542 22.0575L78.0607 22.0677L78.0148 22.0717C78.0148 22.0717 77.9678 22.0862 77.9869 22.0636C78.0476 21.9408 78.1061 21.8162 78.1578 21.6858L78.2605 21.4167C78.3084 21.2909 78.3479 21.1657 78.3917 21.0402C78.4791 20.7893 78.5624 20.5387 78.637 20.2846C79.2812 18.1452 79.6012 16.2123 79.8478 14.4263C80.088 12.6388 80.2266 10.9859 80.3206 9.37683L80.321 9.381Z" fill="#0055CC"/>
</g>
</g>
<defs>
<clipPath id="clip0_550_14457">
<rect width="419" height="16" fill="white"/>
</clipPath>
<clipPath id="clip1_550_14457">
<rect width="304" height="304.679" fill="white" transform="translate(268.681 74.498) rotate(-105)"/>
</clipPath>
<clipPath id="clip2_550_14457">
<rect width="304" height="304.679" fill="white" transform="translate(-42.3188 330) rotate(-105)"/>
</clipPath>
</defs>
</svg>
`;
const $24c02ea0e14dbe4f$var$$e48fba9cf5395297$export$d3a66d29d3f047ac = `data:image/svg+xml;base64,${$24c02ea0e14dbe4f$var$$e48fba9cf5395297$require$Buffer.from($24c02ea0e14dbe4f$var$$e48fba9cf5395297$var$courseBg).toString("base64")}`;
var $24c02ea0e14dbe4f$var$$ea8e736e4eb06883$require$Buffer = (0, $7KfP5.Buffer);
const $24c02ea0e14dbe4f$var$$ea8e736e4eb06883$var$learningPathBg = `<svg width="420" height="32" viewBox="0 0 420 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clipPath="url(#clip0_783_5660)">
<rect width="421" height="32" fill="#D3F1A7"/>
<g clipPath="url(#clip1_783_5660)">
<path d="M419.987 -18.535C419.996 -18.6008 420.003 -18.6685 420.014 -18.7325C420.032 -18.7948 420.048 -18.855 420.064 -18.9151C420.099 -19.0357 420.114 -19.1586 420.159 -19.2633C420.248 -19.4787 420.309 -19.6897 420.416 -19.8626C420.463 -19.9547 420.508 -20.0405 420.551 -20.1239C420.603 -20.204 420.653 -20.2776 420.702 -20.3489C420.75 -20.4203 420.79 -20.495 420.836 -20.56C420.888 -20.6211 420.931 -20.6814 420.974 -20.7377C421.14 -20.9766 421.288 -21.1425 421.37 -21.2818C421.452 -21.4212 421.479 -21.5221 421.443 -21.5798C421.407 -21.6375 421.307 -21.6519 421.142 -21.6125C420.978 -21.5731 420.733 -21.4931 420.458 -21.2993C420.387 -21.2511 420.313 -21.2007 420.234 -21.1477C420.159 -21.0908 420.086 -21.0173 420.006 -20.9454C419.928 -20.8715 419.847 -20.7931 419.762 -20.7102C419.686 -20.6197 419.613 -20.5189 419.533 -20.4155C419.364 -20.2141 419.244 -19.9561 419.102 -19.6815C419.032 -19.5432 418.992 -19.3908 418.936 -19.237C418.91 -19.1592 418.885 -19.0794 418.86 -18.9996C418.838 -18.918 418.826 -18.8351 418.809 -18.7496C418.615 -17.7845 418.69 -16.8132 418.876 -15.8956C419.059 -14.9694 419.392 -14.1023 419.756 -13.2441C419.947 -12.8201 420.142 -12.3942 420.364 -11.9834C420.574 -11.5631 420.81 -11.1597 421.049 -10.7503L421.231 -10.4387C421.302 -10.3211 421.379 -10.2102 421.453 -10.1055C421.527 -10.0007 421.606 -9.89626 421.681 -9.80207L421.834 -9.60345C421.861 -9.56587 421.887 -9.52828 421.909 -9.4945C421.917 -9.4763 421.939 -9.45727 421.93 -9.44179L421.87 -9.40722L421.756 -9.34487C421.555 -9.22042 421.349 -9.0956 421.146 -8.96889C420.732 -8.71475 420.314 -8.45608 419.889 -8.19478C419.043 -7.67029 418.178 -7.13793 417.292 -6.589C415.522 -5.48507 413.666 -4.32963 411.701 -3.10388C411.569 -3.02115 411.438 -2.93843 411.311 -2.85606L411.263 -2.82257C411.247 -2.8128 411.23 -2.79243 411.213 -2.79515L411.176 -2.83808L411.129 -2.89695C411.053 -2.99948 410.979 -3.10009 410.908 -3.19881C410.748 -3.42205 410.595 -3.64376 410.445 -3.86582C409.853 -4.75028 409.317 -5.59134 408.833 -6.35724C407.867 -7.87654 407.139 -9.19195 406.523 -10.4478C405.911 -11.7041 405.395 -12.8911 404.961 -14.1984C404.532 -15.502 404.156 -16.9192 403.941 -18.6296C403.764 -20.0725 403.734 -21.6583 403.948 -23.2903C404.067 -24.1022 404.224 -24.932 404.485 -25.7436C404.596 -26.1561 404.761 -26.5544 404.909 -26.9595C405.08 -27.3563 405.245 -27.7587 405.453 -28.1439C405.847 -28.9251 406.311 -29.6787 406.85 -30.3843C407.385 -31.0937 407.973 -31.7657 408.624 -32.3739C408.936 -32.6906 409.287 -32.9707 409.619 -33.2638C409.969 -33.5376 410.311 -33.8212 410.678 -34.0691C411.033 -34.3348 411.41 -34.5668 411.777 -34.8022C412.152 -35.0319 412.539 -35.2438 412.914 -35.4652C414.436 -36.3063 415.99 -36.9508 417.497 -37.3605C419.003 -37.7744 420.458 -37.953 421.776 -37.9728C423.096 -37.9949 424.276 -37.8643 425.269 -37.7091C426.262 -37.5581 427.07 -37.3658 427.646 -37.2332L428.69 -36.9733C429.045 -36.8908 429.419 -36.8161 429.771 -36.7439C430.378 -36.6244 431.227 -36.4357 432.428 -36.2524C433.028 -36.1617 433.721 -36.077 434.532 -36.0634C435.339 -36.0536 436.29 -36.115 437.298 -36.4731C437.804 -36.6386 438.302 -36.8958 438.794 -37.2049C439.033 -37.3788 439.288 -37.5352 439.516 -37.7606C439.63 -37.8691 439.756 -37.9682 439.863 -38.0907C439.969 -38.2175 440.076 -38.3442 440.183 -38.4709C440.585 -39.0094 440.922 -39.6534 441.087 -40.3602C441.245 -41.0621 441.295 -41.8007 441.211 -42.5237C441.061 -43.9794 440.534 -45.3837 439.853 -46.7871C439.509 -47.4895 439.114 -48.1854 438.684 -48.8867C438.47 -49.2438 438.255 -49.5756 438.036 -49.93C437.987 -50.0056 437.941 -50.0792 437.892 -50.1547L437.861 -50.2044C437.876 -50.2184 437.894 -50.2304 437.914 -50.2447C437.836 -50.1981 438.202 -50.4313 438.461 -50.5964C439.016 -50.9487 439.658 -51.3548 440.372 -51.8091C441.803 -52.7116 443.524 -53.7987 445.425 -54.9978C446.336 -55.572 447.291 -56.171 448.275 -56.7892L448.326 -56.823C448.342 -56.8286 448.363 -56.8577 448.374 -56.8292L448.412 -56.7821L448.504 -56.658C448.854 -56.1743 449.194 -55.6645 449.531 -55.1418C449.866 -54.6086 450.202 -54.0712 450.54 -53.5319C450.86 -52.9889 451.204 -52.4564 451.506 -51.9013C452.14 -50.8043 452.697 -49.6713 453.218 -48.5373C454.609 -45.4749 455.414 -42.519 455.622 -39.8408C455.835 -37.1588 455.451 -34.7734 454.708 -32.8332C453.969 -30.885 452.931 -29.3703 451.906 -28.2008C450.869 -27.0366 449.854 -26.1975 448.994 -25.5648C448.74 -25.377 448.489 -25.1937 448.225 -25.026C447.964 -24.8545 447.711 -24.6814 447.441 -24.53C447.177 -24.3729 446.912 -24.2176 446.652 -24.0609C446.391 -23.906 446.118 -23.7796 445.858 -23.6395C445.335 -23.3487 444.792 -23.1337 444.267 -22.891C444.001 -22.782 443.73 -22.6893 443.467 -22.5866L443.07 -22.4369L442.67 -22.314C441.607 -21.9638 440.54 -21.7559 439.49 -21.6188C438.439 -21.4752 437.397 -21.4584 436.377 -21.4937C435.354 -21.5267 434.349 -21.6453 433.361 -21.7967C432.866 -21.8692 432.377 -21.9632 431.889 -22.0531C431.396 -22.1509 430.914 -22.2581 430.418 -22.3473C429.434 -22.5327 428.468 -22.7238 427.477 -22.8687C426.491 -23.0141 425.476 -23.1065 424.439 -23.0397C423.318 -22.9551 422.489 -22.6084 422.02 -22.2886C421.775 -22.1352 421.62 -21.9792 421.526 -21.8618C421.431 -21.7445 421.396 -21.6576 421.422 -21.6053L421.393 -21.479C421.408 -21.4698 421.421 -21.475 421.419 -21.4959L421.417 -21.6091L421.441 -21.5817C421.478 -21.5346 421.572 -21.5217 421.717 -21.5385C421.86 -21.5572 422.053 -21.6117 422.306 -21.6651C422.804 -21.788 423.52 -21.9508 424.501 -21.9792C426.333 -22.0037 428.217 -21.4935 430.151 -21.0652C432.069 -20.5957 434.122 -20.1211 436.309 -19.998C437.401 -19.9333 438.53 -19.9304 439.679 -20.0657C440.824 -20.1922 441.997 -20.4072 443.155 -20.774L443.593 -20.9043L444.026 -21.0615C444.313 -21.1682 444.608 -21.2672 444.896 -21.3845C445.464 -21.6372 446.054 -21.871 446.616 -22.1756C446.899 -22.3239 447.191 -22.4605 447.471 -22.6232C447.751 -22.7859 448.03 -22.9528 448.316 -23.1182C448.602 -23.2794 448.877 -23.4648 449.157 -23.6507C449.44 -23.8304 449.714 -24.0284 449.988 -24.2305C450.841 -24.8583 451.905 -25.7017 453.021 -26.8958C453.309 -27.1872 453.571 -27.5226 453.863 -27.8606C454.004 -28.0322 454.137 -28.2179 454.276 -28.402C454.418 -28.5843 454.554 -28.7745 454.686 -28.9768C455.233 -29.7649 455.74 -30.6671 456.174 -31.674C457.054 -33.6807 457.614 -36.138 457.566 -38.828C457.534 -41.5172 456.936 -44.4071 455.846 -47.3131C455.131 -49.2087 454.232 -51.0192 453.22 -52.7276C453 -53.1093 452.768 -53.4858 452.531 -53.8597C452.294 -54.2399 452.058 -54.616 451.817 -54.9854C451.333 -55.7282 450.844 -56.4873 450.306 -57.2401C450.171 -57.4277 450.035 -57.6153 449.893 -57.8044C449.653 -58.1256 449.383 -58.4568 449.123 -58.7679L448.927 -59.0068L448.828 -59.1242L448.779 -59.185L448.713 -59.1436L448.187 -58.8211L447.222 -58.2108C446.463 -57.7211 445.702 -57.2334 444.944 -56.746C443.425 -55.775 441.918 -54.8134 440.448 -53.874C438.753 -52.7997 437.104 -51.7524 435.527 -50.7533C435.991 -50.0109 436.451 -49.2807 436.903 -48.5604C437.066 -48.3038 437.217 -48.0567 437.362 -47.8112C437.505 -47.5634 437.664 -47.3254 437.793 -47.0785C438.349 -46.1048 438.792 -45.1298 439.105 -44.1939C439.417 -43.2557 439.58 -42.3466 439.535 -41.5454C439.493 -40.7424 439.25 -40.0624 438.851 -39.5599C438.46 -39.0497 437.954 -38.6911 437.475 -38.4376C436.995 -38.1883 436.554 -38.0452 436.181 -37.9646C435.996 -37.9234 435.825 -37.9044 435.679 -37.877C435.529 -37.864 435.404 -37.8532 435.302 -37.8423C435.2 -37.8313 435.122 -37.8309 435.068 -37.8304C435.013 -37.8298 434.988 -37.8277 434.988 -37.8277C434.988 -37.8277 434.871 -37.8259 434.651 -37.8215C434.54 -37.8265 434.399 -37.829 434.237 -37.8338C434.073 -37.8406 433.88 -37.8596 433.667 -37.8767C432.801 -37.9591 431.531 -38.1931 429.936 -38.5374C429.151 -38.6876 428.292 -38.93 427.33 -39.1214C426.369 -39.3109 425.335 -39.5004 424.228 -39.5891C423.123 -39.6842 421.952 -39.7107 420.741 -39.6162C419.533 -39.5115 418.291 -39.2884 417.058 -38.9423C415.82 -38.6 414.613 -38.0967 413.43 -37.5305C412.848 -37.2282 412.256 -36.9336 411.697 -36.585C411.125 -36.2585 410.565 -35.8952 410.019 -35.5121C407.837 -33.978 405.925 -31.9889 404.62 -29.721C403.3 -27.4622 402.621 -24.9777 402.422 -22.6922C402.327 -21.5468 402.342 -20.4487 402.416 -19.4206C402.469 -18.909 402.508 -18.413 402.588 -17.9395C402.625 -17.7035 402.656 -17.4691 402.697 -17.2418C402.742 -17.0149 402.786 -16.7921 402.83 -16.5777C403.106 -15.2755 403.444 -14.0753 403.836 -12.9846C404.024 -12.4365 404.237 -11.9178 404.431 -11.4143C404.65 -10.9213 404.839 -10.4341 405.058 -9.9831C405.906 -8.16185 406.754 -6.66802 407.532 -5.40729C408.303 -4.16059 408.956 -3.11351 409.589 -2.2179C409.677 -2.09754 409.763 -1.97908 409.846 -1.86252C409.972 -1.69507 410.097 -1.53177 410.231 -1.3692C410.364 -1.2108 410.493 -1.05203 410.619 -0.899327C410.683 -0.822977 410.748 -0.74889 410.811 -0.672541C410.838 -0.607701 410.885 -0.664288 410.925 -0.684559L411.049 -0.758224C411.375 -0.948013 411.688 -1.14089 411.994 -1.3353C412.199 -1.46428 412.396 -1.58837 412.583 -1.70531C414.541 -2.94093 416.392 -4.10849 418.154 -5.2223C419.034 -5.7811 419.891 -6.3275 420.73 -6.86187C421.15 -7.13113 421.563 -7.39361 421.975 -7.65798C422.182 -7.78922 422.388 -7.92463 422.593 -8.0536L423.1 -8.37663L423.351 -8.53683L423.58 -8.6994L424.035 -9.02415L424.063 -9.04335L424.074 -9.05693C424.074 -9.05693 424.071 -9.06299 424.069 -9.06906L424.03 -9.12865L423.95 -9.24973L423.794 -9.48584C423.591 -9.79557 423.369 -10.1058 423.118 -10.4051L422.846 -10.7382L422.646 -10.9915C422.584 -11.0743 422.525 -11.1593 422.472 -11.2387L422.296 -11.5214C422.062 -11.9039 421.823 -12.282 421.616 -12.6689C421.392 -13.0503 421.203 -13.441 421.015 -13.8275C420.658 -14.6065 420.324 -15.3895 420.137 -16.1875C419.943 -16.9806 419.861 -17.7834 419.977 -18.5362L419.987 -18.535Z" fill="#6A9A23"/>
<path d="M375.063 24.9613C374.963 24.9469 374.87 24.934 374.776 24.9211C374.684 24.9207 374.594 24.9181 374.507 24.9151C374.335 24.9132 374.174 24.9167 374.025 24.9233C373.73 24.9258 373.486 24.9952 373.295 25.0474C372.911 25.1605 372.732 25.2998 372.737 25.4357C372.745 25.5735 372.937 25.7079 373.298 25.8109C373.477 25.8688 373.704 25.8932 373.964 25.9651C374.095 25.9937 374.236 26.0234 374.387 26.046C374.461 26.0584 374.54 26.0705 374.623 26.0822C374.702 26.1026 374.783 26.1207 374.867 26.1407C375.825 26.3325 376.729 26.7137 377.473 27.3312C378.22 27.9441 378.807 28.785 379.24 29.7755C379.678 30.7657 379.967 31.901 380.15 33.1252C380.208 33.4286 380.237 33.7429 380.273 34.0629C380.311 34.3807 380.35 34.7026 380.365 35.0327C380.388 35.3644 380.408 35.6983 380.431 36.0384C380.447 36.3874 380.465 36.7426 380.481 37.1C380.568 38.5486 380.642 39.8241 380.666 40.2417C381.225 40.2059 381.762 40.1741 382.279 40.1418C382.607 40.1197 382.919 40.0968 383.222 40.0768C383.739 40.0362 384.218 39.9989 384.668 39.964C385.568 39.8902 386.356 39.8262 387.106 39.7653C388.606 39.6437 389.965 39.5385 391.821 39.449C393.519 39.3668 395.452 39.2727 397.832 39.1566C397.789 38.0735 397.747 36.9566 397.702 35.8254C397.669 34.9323 397.636 34.0245 397.605 33.125C397.53 31.3039 397.376 29.4981 397.138 27.8338C396.902 26.1715 396.583 24.6549 396.247 23.4104C395.91 22.1659 395.554 21.1981 395.327 20.6092C395.161 20.1725 394.959 19.7431 394.754 19.3202C394.367 18.5733 393.65 17.1667 392.278 15.5734C391.593 14.7809 390.741 13.9525 389.693 13.2062C388.648 12.4595 387.41 11.801 386.039 11.3281C384.669 10.8447 383.165 10.5723 381.624 10.4666C380.079 10.3572 378.499 10.4312 376.908 10.6467C373.722 11.0467 370.51 12.3407 368.007 14.3579C366.235 15.781 364.937 17.3979 363.976 18.95C363.746 19.3434 363.514 19.7244 363.305 20.1013C363.11 20.4854 362.924 20.8582 362.739 21.2205C362.569 21.5877 362.42 21.9489 362.268 22.3C362.215 22.422 362.163 22.544 362.112 22.6638C362.01 22.8133 362.067 22.9888 362.062 23.1549C362.073 23.3492 362.081 23.5415 362.091 23.7274C362.225 26.4708 362.325 28.491 362.392 29.8763C362.478 31.4741 362.561 32.9734 362.623 34.1577L364.386 34.2336C364.674 32.0726 365.411 30.2357 366.575 28.8843C367.741 27.5432 369.26 26.6687 370.916 26.2336C371.517 26.0786 371.977 25.9401 372.284 25.8233C372.59 25.6982 372.75 25.5626 372.742 25.4437C372.74 25.3221 372.569 25.2173 372.224 25.1508C371.88 25.0778 371.359 25.0726 370.681 25.1943C368.823 25.5253 366.976 26.4093 365.521 27.937C364.067 29.4689 363.142 31.6116 362.786 34.0198L364.239 34.0827C364.187 32.8954 364.122 31.3966 364.054 29.7974C363.992 28.5249 363.955 26.5621 363.894 23.9844C363.891 23.8231 363.885 23.66 363.883 23.4923L363.878 23.2409L363.877 23.1781L363.878 23.1675L363.881 23.1505C363.881 23.1505 363.892 23.1327 363.903 23.1108C363.934 23.0409 363.966 22.971 364 22.903C364.071 22.75 364.141 22.5928 364.214 22.4376C364.35 22.1194 364.523 21.8086 364.694 21.4895C364.779 21.329 364.866 21.1662 364.953 21.0034C365.043 20.8403 365.147 20.6844 365.242 20.5209C366.022 19.2216 367.014 17.8998 368.295 16.6977C368.509 16.507 368.703 16.2951 368.929 16.1223L369.589 15.5804C369.811 15.3996 370.05 15.2488 370.278 15.0779L370.624 14.8277L370.986 14.6032C371.25 14.4461 371.505 14.2666 371.785 14.127C372.062 13.9854 372.345 13.8413 372.625 13.6975C373.21 13.4516 373.797 13.1846 374.426 13.0021C374.736 12.8997 375.044 12.7954 375.367 12.7275C375.686 12.6516 376.006 12.5651 376.327 12.4994C376.979 12.3905 377.629 12.2649 378.288 12.2204C380.921 11.946 383.526 12.209 385.614 12.968C386.66 13.3411 387.579 13.8238 388.345 14.3365C389.111 14.8534 389.716 15.401 390.206 15.8705C390.437 16.1191 390.649 16.3399 390.826 16.5386C390.997 16.7441 391.142 16.9203 391.259 17.0654C391.379 17.2083 391.454 17.3297 391.516 17.4083C391.573 17.4873 391.601 17.5268 391.601 17.5268C391.873 17.8747 392.103 18.2575 392.347 18.6288C392.569 19.0166 392.801 19.393 392.997 19.7977C393.412 20.5906 393.761 21.4207 394.07 22.2646C394.683 23.9614 395.133 25.7269 395.443 27.5254C395.758 29.3236 395.953 31.1448 396.065 32.9773C396.125 33.8891 396.162 34.828 396.208 35.7514L396.305 37.7845L390.608 38.0895L382.223 38.5415L382.147 37.0331C382.088 35.6115 381.988 34.1912 381.763 32.8742C381.542 31.5526 381.199 30.294 380.646 29.1459C380.101 28.0035 379.328 26.971 378.338 26.2428C377.353 25.5077 376.197 25.1148 375.079 24.9746L375.063 24.9613Z" fill="#6A9A23"/>
<path d="M402.801 24.9656C402.203 22.6548 401.239 22.8832 401.63 25.2097C401.897 26.8631 402.16 28.5525 402.386 30.3878C402.496 31.3035 402.599 32.2556 402.664 33.2487C402.731 34.2438 402.77 35.2853 402.721 36.368C402.716 36.4986 402.712 36.6269 402.706 36.7533C402.692 36.9308 402.68 37.106 402.667 37.2728C402.649 37.501 402.616 37.7284 402.587 37.947C402.549 38.1706 402.513 38.3836 402.478 38.5859C402.35 39.3629 402.251 39.9632 402.194 40.3059C402.264 40.2831 402.36 40.2328 402.447 40.1938C402.536 40.1525 402.622 40.1093 402.707 40.0684C402.88 39.9863 403.049 39.9045 403.212 39.8253C403.541 39.6688 403.857 39.5134 404.161 39.3675C404.461 39.2218 404.753 39.0811 405.035 38.9434C405.166 38.8796 405.295 38.8181 405.42 38.7569C405.494 38.719 405.569 38.681 405.641 38.6454C406.222 38.3495 406.739 38.0886 407.235 37.8379C408.23 37.334 409.152 36.8765 410.402 36.3086C413.075 35.0677 416.694 33.4635 419.925 32.0504C420.732 31.6972 421.514 31.3587 422.252 31.0366C422.623 30.8766 422.982 30.7195 423.328 30.5699C423.651 30.4244 423.969 30.2815 424.278 30.1435L424.51 30.0373L424.627 29.9852C424.643 29.9754 424.67 29.971 424.679 29.9555L424.669 29.8934C424.645 29.7298 424.621 29.5703 424.596 29.4109C424.469 28.5658 424.357 27.8075 424.263 27.1716C424.181 26.6584 424.115 26.2443 424.066 25.9443C424.009 25.5906 423.941 25.2398 423.864 24.8897C423.747 24.3627 423.548 23.4609 423.258 22.267C423.115 21.6751 422.945 20.9912 422.762 20.281C422.599 19.5649 422.429 18.7845 422.257 17.937C421.919 16.25 421.588 14.3419 421.404 12.3017C421.312 11.2815 421.271 10.2275 421.314 9.17048C421.331 8.90671 421.348 8.64295 421.367 8.37693L421.413 7.98269L421.436 7.78557L421.445 7.71975C421.453 7.66451 421.46 7.64713 421.465 7.60892L421.506 7.4081C421.68 6.38378 422.084 5.13595 422.384 4.06711C422.287 4.10077 422.129 4.17316 421.956 4.25533C421.78 4.3356 421.585 4.42601 421.371 4.52428C420.941 4.7231 420.436 4.95568 419.886 5.21114C419.131 5.55774 418.245 5.96396 417.367 6.3653C411.226 9.21824 407.424 10.9851 405.438 11.9042C404.269 12.4546 403.174 12.9712 402.136 13.462C401.618 13.7104 401.117 13.9532 400.623 14.1911C400.196 14.396 399.771 14.5986 399.352 14.7986C399.183 14.8195 399.29 14.9823 399.295 15.091L399.363 15.446C399.409 15.6812 399.454 15.9123 399.497 16.1457C399.555 16.4219 399.614 16.6958 399.671 16.9678C399.726 17.219 399.783 17.4679 399.838 17.715C399.952 18.2087 400.069 18.6937 400.19 19.17C400.43 20.1249 400.684 21.0492 400.954 21.9637C401.557 23.9739 402.388 23.7488 401.992 21.7122C401.823 20.7825 401.653 19.851 401.478 18.8926C401.397 18.415 401.313 17.9312 401.226 17.4373C401.149 16.9592 401.07 16.4752 400.989 15.9786L400.974 15.8456L400.966 15.7812C400.966 15.7623 400.949 15.7324 400.982 15.7295L401.11 15.6785L401.173 15.6542L401.28 15.6092C401.78 15.3876 402.289 15.1588 402.814 14.9244C403.86 14.4477 404.962 13.9451 406.136 13.4069C407.958 12.5628 411.855 11.0143 417.234 8.56739C417.672 8.36786 418.107 8.16225 418.54 7.95474L419.186 7.63645L419.508 7.47429C419.526 7.46225 419.52 7.46071 419.527 7.45166C419.541 7.43581 419.56 7.41318 419.589 7.38756L419.638 7.34764L419.667 7.32619C419.667 7.32619 419.691 7.30737 419.688 7.31606C419.694 7.34069 419.694 7.39103 419.696 7.4622L419.696 7.51671L419.663 7.87844C419.633 8.14329 419.62 8.40669 419.607 8.67009C419.56 9.72334 419.595 10.7652 419.667 11.7724C419.824 13.7898 420.128 15.6834 420.427 17.3172C420.573 18.1354 420.726 18.8859 420.861 19.5603C421 20.2365 421.126 20.8298 421.25 21.3122C421.469 22.2689 421.597 22.8286 421.597 22.8286C421.597 22.8286 421.823 23.7951 422.142 25.3537C422.301 26.133 422.48 27.0597 422.663 28.0908C422.702 28.3203 422.743 28.5559 422.785 28.7957L422.803 28.9075L422.812 28.9654C422.818 28.9859 422.785 28.9846 422.771 28.9963C422.384 29.1767 421.984 29.3624 421.575 29.5511C417.19 31.5824 412.042 33.9717 408.986 35.3886L405.982 36.7841L404.671 37.3929L404.467 37.4882L404.366 37.5347L404.316 37.558L404.289 37.5708C404.289 37.5708 404.28 37.5779 404.277 37.576L404.28 37.5631C404.303 37.4584 404.319 37.3521 404.328 37.2442L404.345 37.0687C404.365 36.8613 404.372 36.6551 404.381 36.4465C404.431 35.2672 404.374 34.1685 404.284 33.1272C404.194 32.0859 404.057 31.1094 403.903 30.1765C403.593 28.3087 403.216 26.6124 402.802 24.9739L402.801 24.9656Z" fill="#6A9A23"/>
<path d="M384.78 4.00329C387.938 3.20915 387.727 2.24341 384.526 2.83562C382.254 3.25496 379.932 3.70171 377.414 4.21162C376.157 4.47169 374.85 4.74026 373.477 5.02294C372.791 5.16845 372.086 5.31766 371.367 5.47022L371.218 5.49987C371.197 5.50168 371.166 5.52123 371.163 5.48791C371.092 5.31992 371.022 5.14967 370.951 4.97752C369.623 1.76695 368.946 -0.312486 368.381 -2.12043C367.842 -3.93698 367.411 -5.50059 367.051 -7.83194C366.893 -8.81488 366.773 -9.88927 366.688 -11.0192C366.622 -12.1486 366.576 -13.3343 366.64 -14.5359C366.704 -15.7374 366.819 -16.9581 367.064 -18.1396C367.308 -19.3211 367.637 -20.4742 368.076 -21.5383C368.18 -21.8055 368.312 -22.0581 368.428 -22.3158C368.488 -22.4427 368.547 -22.5716 368.605 -22.6962C368.676 -22.822 368.743 -22.9474 368.812 -23.0709C369.086 -23.5667 369.355 -24.0516 369.614 -24.5211C369.889 -24.9813 370.184 -25.4056 370.452 -25.8254C370.59 -26.0303 370.716 -26.2406 370.855 -26.4331C371 -26.6199 371.14 -26.804 371.278 -26.9817C371.556 -27.3352 371.803 -27.6798 372.06 -27.9811C372.327 -28.2707 372.576 -28.5441 372.802 -28.7903C373.238 -29.3044 373.671 -29.6399 373.952 -29.9097L374.459 -30.3796L375.001 -30.8127C375.161 -30.9441 375.356 -31.1015 375.579 -31.2845C375.688 -31.3821 375.817 -31.4709 375.954 -31.5604C376.091 -31.6541 376.237 -31.7508 376.39 -31.8542C376.986 -32.2878 377.767 -32.7206 378.666 -33.1972C380.483 -34.1268 382.926 -34.9701 385.749 -35.6869C386.452 -35.8717 387.182 -36.0462 387.929 -36.2179C388.673 -36.3957 389.442 -36.561 390.222 -36.7356C390.745 -36.8523 391.276 -36.9696 391.811 -37.0874C391.827 -37.0972 391.829 -37.0805 391.834 -37.0684L391.843 -37.0293L391.877 -36.8812C391.965 -36.4754 392.052 -36.0697 392.138 -35.6616C392.826 -32.3977 393.535 -29.0516 394.215 -25.8332C394.699 -23.5607 395.138 -21.5069 395.533 -19.6569C395.709 -18.8328 395.874 -18.0562 396.03 -17.3227L396.047 -17.2507C396.046 -17.2318 396.008 -17.2368 395.99 -17.229C395.759 -17.1838 395.532 -17.1389 395.315 -17.097C393.858 -16.8196 392.563 -16.5563 391.456 -16.2547C390.349 -15.9573 389.427 -15.6235 388.695 -15.281C387.829 -14.8808 387.014 -14.3841 386.312 -13.7652C385.606 -13.15 385.025 -12.4135 384.602 -11.6257C384.182 -10.8318 383.945 -10.0035 383.788 -9.19671C383.737 -8.79153 383.662 -8.39059 383.656 -7.99771C383.648 -7.79977 383.64 -7.606 383.631 -7.41223C383.631 -7.21918 383.643 -7.02722 383.649 -6.83679C383.805 -3.79316 384.714 -1.22823 385.709 1.20761C386.262 2.50259 386.762 3.06984 386.983 3.00452L386.993 2.90918C386.995 2.93001 387.006 2.93951 387.029 2.93545L387.023 2.98842C387.233 2.86741 387.157 2.12707 386.709 0.831387C385.907 -1.6044 385.185 -4.13523 385.149 -6.86608C385.149 -7.03604 385.145 -7.20563 385.149 -7.37595C385.164 -7.54509 385.174 -7.71387 385.187 -7.88491C385.199 -8.23008 385.278 -8.56211 385.326 -8.9041C385.476 -9.57384 385.682 -10.2422 386.022 -10.857C386.365 -11.468 386.82 -12.032 387.389 -12.5198C387.957 -13.0076 388.635 -13.4231 389.39 -13.7697C389.972 -14.0447 390.76 -14.3207 391.748 -14.5721C392.735 -14.8234 393.919 -15.0373 395.292 -15.2696C395.66 -15.3351 396.039 -15.3993 396.429 -15.4689C396.772 -15.5363 397.118 -15.6041 397.469 -15.6723C397.646 -15.7087 397.826 -15.7431 398.003 -15.7795L398.137 -15.8058L398.206 -15.818C398.206 -15.818 398.218 -15.8191 398.222 -15.8236L398.22 -15.8403L398.213 -15.8732L398.161 -16.1414C397.961 -17.148 397.754 -18.2065 397.532 -19.3161C397.2 -21.0058 396.833 -22.8477 396.421 -24.8325C396.152 -26.1248 395.86 -27.413 395.553 -28.6873C394.886 -31.4348 394.198 -34.3925 393.546 -37.286L393.341 -38.223L393.235 -38.7027L393.183 -38.9395L393.156 -39.0588C393.152 -39.0774 393.15 -39.1024 393.141 -39.1141L393.079 -39.1004C392.467 -38.9655 391.858 -38.8288 391.251 -38.6943C390.541 -38.5342 389.839 -38.3747 389.149 -38.2205C387.771 -37.908 386.435 -37.6013 385.194 -37.2776C382.705 -36.6506 380.584 -35.9232 379.116 -35.3029C378.753 -35.1371 378.426 -34.9871 378.141 -34.8596C377.997 -34.7947 377.866 -34.7351 377.745 -34.6784C377.627 -34.6157 377.521 -34.5582 377.422 -34.5056C377.038 -34.296 376.829 -34.1815 376.829 -34.1815C376.829 -34.1815 376.751 -34.139 376.605 -34.0571C376.459 -33.971 376.233 -33.8675 375.972 -33.6854C375.704 -33.509 375.379 -33.292 374.999 -33.043C374.904 -32.9802 374.807 -32.9151 374.705 -32.8496C374.611 -32.7743 374.511 -32.6964 374.413 -32.6165C374.213 -32.4565 373.998 -32.289 373.775 -32.1101C373.313 -31.7721 372.875 -31.325 372.39 -30.8675C371.887 -30.4253 371.447 -29.8604 370.947 -29.3072C370.689 -29.0331 370.468 -28.7244 370.238 -28.4086C370.006 -28.0969 369.77 -27.7742 369.529 -27.4512C369.295 -27.1225 369.093 -26.7672 368.869 -26.4183C368.652 -26.0638 368.416 -25.7139 368.211 -25.3457C368.012 -24.9718 367.81 -24.5934 367.61 -24.213C367.412 -23.8266 367.19 -23.4611 367.018 -23.0413C366.838 -22.6332 366.644 -22.2241 366.501 -21.7962L366.27 -21.1594C366.194 -20.9451 366.142 -20.7265 366.076 -20.511C365.569 -18.778 365.306 -16.9905 365.209 -15.272C365.017 -11.829 365.44 -8.67637 365.857 -6.37091C366.505 -2.89785 367.285 -0.399327 367.899 1.48832C368.53 3.37452 369.032 4.64658 369.43 5.61085C369.519 5.81714 369.604 6.0238 369.693 6.22593C369.821 6.52323 369.954 6.82018 370.092 7.1145L370.193 7.33446L370.219 7.39097C370.227 7.40918 370.255 7.38998 370.274 7.39044L370.391 7.36557L370.861 7.27026C371.154 7.20714 371.444 7.14212 371.732 7.07936C372.451 6.91847 373.155 6.76093 373.838 6.60936C375.206 6.29562 376.507 5.99825 377.757 5.70939C380.258 5.12332 382.558 4.56518 384.799 4.00376L384.78 4.00329Z" fill="#6A9A23"/>
<path d="M289.604 -5.95927C289.825 -7.16812 289.658 -7.81042 289.394 -7.85468C289.12 -7.90012 288.748 -7.36645 288.444 -6.25107C287.978 -4.67267 287.331 -3.1185 286.404 -1.58822C285.451 -0.0788647 284.202 1.41638 282.444 2.63884C282.187 2.81642 281.946 2.9884 281.706 3.1267C281.648 3.16317 281.588 3.19774 281.53 3.23421L281.447 3.28762C281.447 3.28762 281.409 3.30978 281.377 3.32517L281.29 3.36835C281.059 3.48283 280.835 3.59242 280.626 3.69867C280.424 3.80645 280.211 3.89829 280.009 3.98299C279.81 4.06733 279.626 4.14832 279.454 4.2199C279.131 4.36125 278.862 4.47897 278.656 4.5682C278.704 4.61647 278.78 4.66864 278.853 4.71892C278.925 4.77146 278.996 4.81983 279.068 4.87237C279.209 4.97138 279.347 5.07265 279.484 5.16786C279.754 5.36053 280.016 5.54559 280.268 5.72304C280.518 5.89859 280.76 6.0707 280.994 6.2371C281.17 6.35821 281.342 6.47968 281.508 6.59544C282.011 6.93785 282.46 7.2452 282.899 7.54495C283.773 8.1448 284.593 8.71793 285.64 9.49792C286.838 10.3781 288.231 11.4219 289.677 12.5177C290.398 13.0658 291.134 13.6272 291.868 14.1826C292.068 14.3352 292.27 14.4898 292.47 14.6424L292.955 15.0033L293.076 15.0935L293.136 15.1365L293.166 15.1612C293.166 15.1612 293.19 15.1507 293.202 15.1455L293.482 15.0373L294.04 14.8189L294.428 14.6468C294.65 14.5436 294.865 14.4306 295.078 14.3198C295.921 13.8585 296.673 13.3087 297.317 12.722C297.483 12.5796 297.641 12.4338 297.785 12.2807C297.933 12.1314 298.078 11.9825 298.221 11.84C298.484 11.5361 298.742 11.243 298.969 10.9548C299.883 9.79918 300.394 8.76454 300.697 8.20105C300.87 7.86299 301.007 7.51115 301.151 7.16086C301.27 6.89033 301.388 6.50663 301.543 6.03374C301.71 5.56394 301.847 4.99179 302.013 4.33953C302.105 4.01476 302.163 3.66562 302.234 3.29648C302.303 2.93376 302.376 2.55402 302.45 2.15726C302.521 1.78395 302.597 1.39552 302.673 0.992327C302.769 0.593762 302.883 0.187326 302.989 -0.237315C303.46 -1.91903 304.268 -3.72008 305.478 -5.37976C306.096 -6.19706 306.82 -6.9753 307.642 -7.65926C308.05 -8.00731 308.494 -8.31432 308.949 -8.61183L309.48 -8.92643C309.722 -9.05865 309.971 -9.18934 310.24 -9.31123C310.758 -9.55548 311.278 -9.80199 311.8 -10.0466C311.202 -10.492 309.695 -11.6078 308.218 -12.703C305.465 -14.7241 303.236 -16.3585 301.476 -17.6495C300.595 -18.2971 299.83 -18.8559 299.173 -19.3383C298.846 -19.5785 298.546 -19.8001 298.271 -20.0007C298.038 -20.1694 297.818 -20.3308 297.61 -20.4827C297.494 -20.565 297.378 -20.6472 297.27 -20.726C297.244 -20.7594 297.213 -20.7357 297.182 -20.7226L297.092 -20.6791C297.033 -20.6509 296.971 -20.6224 296.914 -20.5965C296.644 -20.4641 296.349 -20.3377 296.113 -20.204C295.961 -20.1194 295.804 -20.0429 295.661 -19.9466C295.516 -19.8563 295.37 -19.7661 295.229 -19.6762C295.09 -19.5803 294.954 -19.4824 294.82 -19.3869C294.549 -19.1934 294.3 -18.9851 294.054 -18.7791C293.819 -18.5594 293.574 -18.3598 293.365 -18.1298C292.493 -17.2443 291.803 -16.2907 291.244 -15.3315C290.158 -13.3931 289.552 -11.4542 289.197 -9.52671C288.87 -7.38335 289.73 -7.29835 290.238 -9.28538C290.758 -11.0888 291.464 -12.8475 292.528 -14.5574C293.072 -15.4019 293.716 -16.2236 294.498 -16.9838C294.687 -17.1806 294.905 -17.3485 295.111 -17.5384C295.329 -17.7105 295.547 -17.8909 295.782 -18.0519C295.901 -18.1335 296.018 -18.2129 296.139 -18.2968C296.263 -18.3705 296.386 -18.4483 296.512 -18.5243C296.637 -18.6044 296.768 -18.6682 296.898 -18.7403C296.958 -18.7749 296.982 -18.7854 297.027 -18.806C297.043 -18.8116 297.059 -18.8214 297.075 -18.827C297.089 -18.8156 297.105 -18.8023 297.118 -18.7909C297.157 -18.7585 297.195 -18.7262 297.236 -18.692C297.49 -18.4937 297.769 -18.2786 298.075 -18.0408C298.684 -17.5628 299.393 -17.0053 300.204 -16.3705C301.821 -15.1028 303.83 -13.5417 306.218 -11.7617C306.608 -11.4723 307 -11.1853 307.395 -10.9069L307.991 -10.4907L308.141 -10.3882C308.141 -10.3882 308.145 -10.3886 308.149 -10.389C308.156 -10.3874 308.164 -10.3881 308.172 -10.3889C308.198 -10.3869 308.247 -10.3723 308.287 -10.3505C308.274 -10.3264 308.253 -10.3015 308.185 -10.2431L308.026 -10.1412L307.856 -10.0215L307.515 -9.7822C307.288 -9.6219 307.077 -9.44412 306.856 -9.27395C305.994 -8.57388 305.217 -7.77012 304.539 -6.92241C303.169 -5.22782 302.263 -3.31968 301.676 -1.61952C301.604 -1.40558 301.532 -1.1958 301.461 -0.992448C301.389 -0.786833 301.346 -0.579579 301.287 -0.381476C301.185 0.0197139 301.063 0.395451 300.994 0.762334C300.848 1.4779 300.721 2.10572 300.615 2.62689C300.509 3.12497 300.445 3.52707 300.363 3.79018C300.29 4.05674 300.25 4.20078 300.25 4.20078C300.25 4.20078 300.188 4.43483 300.074 4.86019C300.018 5.07269 299.922 5.32023 299.824 5.6162C299.724 5.91027 299.618 6.24672 299.46 6.60036C299.308 6.95554 299.158 7.35463 298.943 7.75307C298.84 7.95289 298.734 8.1614 298.625 8.37859C298.502 8.58437 298.376 8.79468 298.248 9.01141C297.713 9.8635 297.042 10.7483 296.207 11.5257C296.102 11.623 295.997 11.7202 295.892 11.8174C295.785 11.9127 295.666 11.9985 295.555 12.09C295.334 12.2791 295.092 12.4386 294.853 12.6083C294.734 12.6941 294.604 12.7621 294.482 12.8418C294.359 12.9197 294.233 12.9956 294.101 13.0617C293.97 13.1296 293.844 13.2056 293.709 13.2614L293.533 13.3417C293.509 13.3522 293.493 13.3619 293.472 13.3679C293.433 13.3734 293.389 13.4255 293.358 13.3799L293.237 13.2897C292.982 13.102 292.724 12.9124 292.469 12.7247C291.958 12.3494 291.452 11.9778 290.954 11.6139C288.967 10.1558 287.13 8.80428 285.762 7.80036L283.266 5.96879L282.16 5.15826L281.992 5.03643L281.909 4.97438L281.868 4.94015C281.868 4.94015 281.82 4.91912 281.851 4.91433C281.973 4.86601 282.09 4.80973 282.204 4.74737L282.226 4.73497L282.264 4.71279L282.428 4.61469L282.757 4.42037C282.977 4.29221 283.184 4.13788 283.397 3.99986C285.383 2.6065 286.754 0.888816 287.729 -0.813492C288.682 -2.53899 289.266 -4.26186 289.612 -5.96416L289.604 -5.95927Z" fill="#6A9A23"/>
<path d="M335.18 -24.8556C335.367 -27.0896 334.385 -27.2164 333.994 -25.0108C333.717 -23.4468 333.449 -21.8414 333.182 -20.0956C333.054 -19.2221 332.92 -18.3146 332.78 -17.3583C332.644 -16.3603 332.501 -15.3135 332.351 -14.2073C332.315 -13.902 332.279 -13.6073 332.272 -13.5479C332.586 -13.2373 332.882 -12.942 333.169 -12.6584C333.357 -12.4774 333.536 -12.2999 333.707 -12.1364C334.053 -11.8034 334.368 -11.5034 334.661 -11.2224C335.252 -10.6673 335.75 -10.1985 336.218 -9.76272C337.155 -8.88931 337.961 -8.13454 339.071 -6.99696C339.768 -6.28315 340.543 -5.4922 341.538 -4.47471C342.213 -4.57105 342.912 -4.67145 343.62 -4.77484C344.209 -4.85527 344.811 -4.93678 345.41 -5.02019C346.613 -5.17905 347.818 -5.34016 348.949 -5.49061C351.408 -5.80659 353.549 -6.08036 354.718 -6.22989C354.939 -6.58062 355.125 -6.88001 355.282 -7.13069C355.375 -7.27301 355.451 -7.3908 355.515 -7.49084C355.643 -7.68865 355.727 -7.81548 355.797 -7.92231C355.981 -8.20051 356.158 -8.48443 356.33 -8.77214C356.622 -9.26111 357.152 -10.1443 358.014 -11.5787C358.936 -13.098 360.217 -15.2044 361.956 -18.0724C361.796 -18.5474 361.552 -19.2816 361.244 -20.2012C360.997 -20.9457 360.704 -21.8414 360.38 -22.8288C359.735 -24.8082 358.978 -27.1597 358.266 -29.4229L357.826 -30.7822L346.487 -34.4322C346.071 -34.566 345.657 -34.698 345.367 -34.7904C344.773 -34.3822 344.196 -33.9902 343.636 -33.6038C343.197 -33.2972 342.767 -33.0018 342.351 -32.7098C341.523 -32.1239 340.738 -31.567 339.98 -31.0334C338.475 -29.9545 337.106 -28.942 335.757 -27.9207C334.187 -26.7334 334.67 -26.0221 336.355 -27.0389C337.803 -27.9114 339.251 -28.8111 340.81 -29.8065C341.585 -30.3101 342.392 -30.8333 343.246 -31.3858C343.996 -31.883 344.784 -32.4066 345.626 -32.9622C345.717 -32.9323 345.846 -32.889 345.978 -32.8479C346.88 -32.5568 348.252 -32.0525 350.06 -31.4015C350.964 -31.0812 351.977 -30.72 353.094 -30.3258C354.069 -29.9928 355.133 -29.6276 356.281 -29.234L356.327 -29.0953L356.539 -28.457C356.685 -28.0332 356.834 -27.6097 356.99 -27.1931C357.543 -25.6967 358.111 -24.0988 358.656 -22.52C359.156 -21.0526 359.648 -19.6076 360.1 -18.2892L360.045 -18.1921C359.979 -18.0815 359.913 -17.975 359.847 -17.8644C359.702 -17.6273 359.56 -17.3947 359.422 -17.1666C359.143 -16.7102 358.876 -16.2737 358.625 -15.8595C358.115 -15.0327 357.658 -14.2923 357.279 -13.6761C356.512 -12.4473 356.05 -11.7043 356.05 -11.7043L353.657 -7.82492L342.05 -6.02149L339.492 -8.60924L334.019 -14.1379L334.03 -14.2332C334.157 -15.2577 334.277 -16.227 334.393 -17.1498C334.503 -18.1077 334.607 -19.0211 334.706 -19.8962C334.896 -21.6521 335.05 -23.2727 335.182 -24.8537L335.18 -24.8556Z" fill="#6A9A23"/>
<path d="M334.463 4.5503C336.378 5.19843 337.423 5.25884 337.511 5.0037C337.601 4.73987 336.74 4.16619 334.878 3.42744C332.352 2.41678 329.793 1.3314 327.049 0.0858865C325.677 -0.538004 324.262 -1.20221 322.786 -1.92192C322.048 -2.2797 321.294 -2.65496 320.524 -3.04353C320.14 -3.23894 319.751 -3.43817 319.356 -3.63893C318.73 -3.96444 318.098 -4.29148 317.454 -4.62388C317.2 -4.26194 316.851 -3.76375 316.498 -3.26103C311.509 3.94451 310.444 5.82245 307.026 10.6635C306.168 11.8814 305.22 13.2246 304.201 14.6705C303.026 16.325 301.771 18.0935 300.448 19.9518C301.609 20.5877 302.784 21.2286 303.958 21.8717C304.893 22.3719 305.832 22.8675 306.756 23.3476C308.612 24.3051 310.431 25.2049 312.103 26.0042C315.451 27.6024 318.222 28.8037 319.543 29.3585C320.099 29.5978 320.659 29.8219 321.228 30.0371C323.093 30.7482 327.879 32.5742 334.242 34.4546C337.42 35.4002 340.99 36.3581 344.761 37.2377C346.647 37.6764 348.582 38.0983 350.545 38.4926C351.525 38.6909 352.513 38.8801 353.502 39.0629L354.99 39.3326L357.469 39.7598C357.512 39.0699 357.618 37.378 357.721 35.7072C358.398 24.2426 358.818 17.1477 359.038 13.4421C359.115 12.082 359.191 10.7661 359.248 9.7981C358.525 9.66145 357.813 9.53015 357.113 9.39776C356.669 9.31034 356.23 9.22673 355.799 9.14241C354.934 8.97185 354.095 8.79914 353.278 8.62651C351.643 8.27935 350.096 7.92461 348.607 7.56898C345.63 6.8513 342.892 6.12137 340.191 5.33367C338.504 4.84208 337.595 4.76975 337.515 5.00334C337.437 5.22408 338.192 5.75453 339.861 6.35052C342.533 7.30237 345.259 8.1655 348.242 8.98542C349.733 9.39329 351.289 9.78932 352.935 10.1691C353.757 10.3622 354.602 10.547 355.474 10.7316C356.136 10.8673 356.819 11.0053 357.52 11.1501C357.485 11.7344 357.434 12.5299 357.383 13.3484C357.181 16.7483 356.524 23.8217 355.888 33.8224C355.843 34.63 355.797 35.4334 355.753 36.2387L355.697 37.4437C355.695 37.5153 355.695 37.488 355.696 37.4963L355.7 37.5001L355.703 37.5145L355.713 37.5494C355.713 37.5494 355.699 37.5569 355.686 37.558C355.653 37.5567 355.753 37.5795 355.443 37.5309C355.007 37.4616 354.566 37.3928 354.124 37.3221C353.241 37.1783 352.344 37.0273 351.449 36.8615C349.654 36.5387 347.844 36.1753 346.062 35.7821C342.497 35.0063 339.05 34.1049 336.046 33.2323C333.043 32.3574 330.487 31.5173 328.681 30.8912C327.778 30.5729 327.064 30.3201 326.573 30.1465C326.083 29.9666 325.818 29.8678 325.818 29.8678C321.699 28.3743 317.646 26.705 313.653 24.9004C311.657 23.995 309.679 23.0544 307.719 22.0745C306.741 21.5843 305.762 21.0859 304.793 20.5802L303.34 19.8144L302.638 19.4367L309.085 10.2353C314.014 3.19229 316.386 -0.198457 317.845 -2.28256C317.896 -2.35617 317.946 -2.42977 317.981 -2.4811C318.602 -2.16773 319.205 -1.86541 319.791 -1.56997C320.573 -1.18248 321.337 -0.814374 322.09 -0.459944C323.592 0.247014 325.035 0.89203 326.437 1.48387C329.24 2.67399 331.869 3.6673 334.463 4.55447L334.463 4.5503Z" fill="#6A9A23"/>
<path d="M266.148 11.4377C265.904 11.241 261.607 11.6973 262.767 12.4218C263.152 12.7388 263.531 12.734 263.685 12.313C263.756 13.154 264.635 12.1 265.004 12.3981C264.83 12.9694 266.069 11.8383 265.807 12.4271C270.358 13.3709 279.961 8.3733 268.469 10.9842C269.573 11.3222 268.502 11.4793 268.006 11.3163C268.775 10.6232 266.63 11.1226 266.225 11.3524C266.878 11.3826 265.768 11.8565 266.15 11.4398L266.148 11.4377Z" fill="#101214"/>
<path d="M273.986 19.0467C273.385 19.0418 270.602 22.9468 270.26 23.3131C269.677 24.2322 271.049 24.4039 271.328 23.6053C271.45 23.4739 271.918 22.3416 272.164 22.8577C273.353 22.6833 273.656 20.6225 274.654 20.5627C274.514 20.2788 274.886 19.9778 274.819 19.7896C275.111 19.8418 275.301 19.4589 275.233 19.4186C276.559 18.4848 275.082 17.1701 274.308 18.5903C274.261 18.5239 273.902 18.7589 273.986 19.0428L273.986 19.0467Z" fill="#101214"/>
<path d="M288.709 27.7641C289.293 27.125 289.207 27.8367 288.919 28.1456C288.477 27.5052 288.381 28.9221 288.518 29.2965C288.558 29.1514 288.815 29.1459 288.75 29.4489C288.158 29.1232 287.385 32.9628 288.995 31.3767C289.003 31.3103 288.513 31.1909 288.68 31.1416C289.409 31.4079 288.987 30.7058 288.958 30.5243C289.347 30.5991 289.013 30.3704 289.181 30.3567C289.67 30.6613 288.959 29.5148 289.438 29.8463C290.383 29.1065 289.625 27.1642 290.464 26.62C289.666 25.994 291.452 23.4009 289.594 24.1887C289.01 25.3404 288.629 26.3014 288.709 27.7641Z" fill="#101214"/>
<path d="M278.52 33.4874C279.672 34.0122 279.857 31.3062 280.471 30.6733C281.323 29.9268 285.341 20.9746 282.563 22.9852C281.37 25.7048 279.916 27.7259 278.886 31.2063C278.677 31.7594 277.666 33.4114 278.52 33.4874Z" fill="#101214"/>
<path d="M272.605 3.22304C273.458 2.36044 274.245 3.76255 275.035 3.06901C276.28 1.6898 267.453 -0.415104 267.475 1.23084C267.685 2.64358 272.067 2.52653 272.605 3.22304Z" fill="#101214"/>
<path d="M353.904 0.605135C351.888 -0.0406305 348.015 0.187959 346.143 -0.686571C344.414 -0.564747 342.931 -1.0713 341.224 -1.48882C341.674 -1.91768 342.883 -2.42509 342.976 -2.90903C346.063 -5.01434 340.805 -2.8555 339.877 -1.40738L339.89 -1.40739C339.89 -1.40739 339.691 -1.15637 339.673 -1.19408C339.802 -0.692643 340.458 -0.0652969 340.454 0.283156C343.482 2.73881 344.616 3.1592 341.381 -0.567943C342.528 -0.296267 343.241 0.288849 344.364 0.147743C344.642 0.54692 350.562 1.43902 348.42 0.717936C348.941 0.404403 350.793 1.07698 349.514 1.05847C350.098 1.25533 359.729 2.18758 358.787 0.832591C358.387 0.926263 357.763 0.58519 357.477 0.747534C357.422 0.905176 357.407 1.02061 357.253 0.965295C357.28 0.632353 356.933 0.630529 356.556 0.701981C356.088 0.866753 355.08 0.903412 355.236 0.665757C355.306 0.46149 353.472 0.982932 353.904 0.607357L353.904 0.605135Z" fill="#101214"/>
</g>
<g clipPath="url(#clip2_783_5660)">
<path d="M13.0459 23.9464C13.2244 23.8029 13.375 23.6514 13.5135 23.5051C13.6519 23.3588 13.7767 23.2242 13.8912 23.0925C14.1165 22.8338 14.2962 22.6063 14.4242 22.4127C14.6826 22.0273 14.7534 21.7777 14.657 21.6812C14.5605 21.5846 14.2987 21.6388 13.898 21.8582C13.6977 21.9679 13.4612 22.1206 13.1927 22.3159C13.0586 22.4156 12.9146 22.5225 12.7657 22.6446C12.6168 22.7666 12.4583 22.8999 12.2783 23.0267C11.7797 23.3994 11.2791 23.7743 10.7705 24.1541C10.2398 24.4959 9.70493 24.8382 9.16244 25.1894C8.60947 25.5164 8.02636 25.8104 7.44957 26.1289C7.15404 26.2784 6.84575 26.4016 6.5389 26.5415C6.23133 26.6731 5.92782 26.8274 5.60858 26.9453C5.28898 27.059 4.96332 27.1754 4.63765 27.2917C4.47464 27.3478 4.31044 27.4145 4.1448 27.4645C3.97464 27.5108 3.80449 27.557 3.63433 27.6032C3.29175 27.6937 2.94835 27.799 2.59636 27.8778C2.24139 27.9463 1.88225 28.0152 1.51931 28.0887C0.0606176 28.3263 -1.49813 28.4258 -3.12925 28.2944C-3.56103 28.2752 -3.97141 28.2121 -4.35537 28.1636C-4.54794 28.1446 -4.73171 28.106 -4.90643 28.075C-4.9938 28.0595 -5.08116 28.0439 -5.16436 28.0281C-5.22411 28.0165 -5.28576 28.0071 -5.34551 27.9955C-5.43287 27.98 -5.5081 27.9593 -5.58713 27.943C-6.21656 27.7731 -6.77491 27.6242 -7.25162 27.4977C-7.70977 27.3675 -8.08591 27.2637 -8.36563 27.183C-8.05452 28.2597 -7.73595 29.277 -7.45896 30.2014C-7.28585 30.7487 -7.12621 31.2616 -6.97515 31.7478C-6.68674 32.6587 -6.42815 33.4671 -6.18005 34.2514C-5.68384 35.8198 -5.22994 37.287 -4.66961 39.2338C-4.04204 41.3763 -3.32537 43.895 -2.58721 46.5167C-2.22004 47.8299 -1.84428 49.1695 -1.4715 50.499C-1.25363 51.2732 -1.04029 52.0436 -0.825398 52.8077C-0.802628 52.877 -0.789367 52.9577 -0.758627 53.0222L-0.551516 53.0882L-0.137285 53.2201L0.276945 53.3521L0.53893 53.4217C0.71283 53.4675 0.884474 53.5113 1.05837 53.5571C1.23346 53.5923 1.40628 53.6256 1.57946 53.663C4.36235 54.2065 7.04848 53.896 9.14027 53.3601C9.66062 53.2143 10.1485 53.0566 10.6086 52.9181C11.0609 52.7614 11.4697 52.5875 11.8496 52.4433C12.2341 52.303 12.5622 52.1424 12.8562 51.9994C13.1502 51.8564 13.4062 51.7356 13.6198 51.6331C13.8785 51.5184 14.1157 51.374 14.3552 51.2316L15.0752 50.7978C15.254 50.6816 15.4828 50.561 15.7156 50.3898C15.9507 50.2204 16.2176 50.0315 16.5119 49.8192C16.8017 49.6032 17.1399 49.3892 17.4667 49.1154C17.7957 48.8435 18.1502 48.5505 18.5283 48.2387C18.716 48.0797 18.9169 47.928 19.1073 47.752C19.2955 47.5741 19.4897 47.3936 19.6897 47.2064C20.0835 46.8344 20.499 46.4459 20.9358 46.0366C21.3513 45.6481 21.7823 45.2457 22.2305 44.8228C22.6881 44.4118 23.1922 44.0282 23.6952 43.609C23.943 43.3924 24.219 43.2111 24.4958 43.015C24.7708 42.8212 25.0517 42.6248 25.3346 42.4262C25.4725 42.3219 25.6221 42.2313 25.772 42.1449C25.9215 42.0543 26.0733 41.9656 26.2248 41.8727C26.5303 41.693 26.8325 41.499 27.1493 41.3288C28.4302 40.6597 29.8119 40.0405 31.3018 39.605C32.7947 39.1798 34.3762 38.9063 36.0024 38.8598C36.8156 38.8249 37.6359 38.8734 38.4607 38.9488L39.0913 39.0347L39.4056 39.0788L40.0042 39.2074C40.8225 39.3777 41.6365 39.5716 42.4509 39.7695C42.1544 38.7398 41.401 36.1362 40.667 33.5875C37.7264 23.5317 35.9053 17.3068 34.9535 14.0573C34.9552 13.7613 34.6651 13.8032 34.4682 13.7342C34.2584 13.6853 34.0485 13.6363 33.8387 13.5874L33.6803 13.5507C33.6311 13.5403 33.6141 13.5376 33.5778 13.5303L33.3902 13.4962L33.0173 13.4299C32.7696 13.38 32.5206 13.3638 32.2744 13.3306L31.9055 13.287L31.5408 13.2662C30.5668 13.1891 29.6218 13.2521 28.7074 13.3293C26.8858 13.5438 25.2051 14.0042 23.6927 14.641C23.3041 14.7817 22.9496 14.9782 22.5817 15.1402C22.4004 15.2272 22.2187 15.3101 22.0393 15.3949C21.8648 15.4877 21.6929 15.5865 21.5206 15.6812C21.1787 15.8766 20.8406 16.0675 20.5024 16.2583C20.1809 16.4708 19.8612 16.6811 19.5415 16.8914C19.3828 16.9974 19.226 17.1013 19.0692 17.2051C18.9128 17.3131 18.7677 17.4305 18.618 17.5442C18.321 17.7735 18.0236 17.9986 17.7304 18.2234C17.4281 18.4405 17.165 18.6983 16.8834 18.9367C16.6064 19.179 16.3335 19.4208 16.0565 19.6631C14.9003 20.7809 14.4954 21.5106 14.6627 21.6744C14.8371 21.8481 15.5686 21.4742 16.7575 20.4689C17.0367 20.2516 17.3182 20.0363 17.6015 19.8187C17.8853 19.6053 18.1547 19.3721 18.455 19.1803C18.7503 18.9805 19.0435 18.7789 19.3427 18.5746C19.4915 18.4757 19.6354 18.3688 19.7888 18.2736C19.9425 18.1827 20.0981 18.0895 20.256 17.9982C20.5672 17.8117 20.8807 17.6272 21.1938 17.4384C21.5194 17.2717 21.8468 17.1028 22.1765 16.9357C22.3434 16.852 22.5062 16.7687 22.675 16.6827C22.8449 16.6092 23.0189 16.5354 23.193 16.4615C23.5419 16.3222 23.8814 16.148 24.2446 16.0284C25.6722 15.4787 27.2231 15.0945 28.8787 14.9259C29.7068 14.8688 30.5609 14.822 31.436 14.8972L31.7652 14.919L32.0939 14.9598C32.3148 14.991 32.5385 15.0052 32.7585 15.0512C32.959 15.0883 33.1636 15.1252 33.3663 15.1642L33.4906 15.1954C33.5296 15.2088 33.5901 15.2057 33.5831 15.2462C33.7626 15.8915 33.9886 16.7112 34.2604 17.6969C34.563 18.8205 34.9173 20.1306 35.3166 21.6214C36.1212 24.6004 37.1258 28.2922 38.3635 32.5933C38.7677 33.9956 39.1924 35.3918 39.6324 36.77L39.7103 37.0171L39.7503 37.1396C39.7503 37.1396 39.7548 37.1434 39.757 37.1453C39.7661 37.1529 39.7713 37.165 39.7789 37.179C39.7935 37.203 39.816 37.2451 39.8321 37.2856C39.8094 37.2897 39.7776 37.2862 39.7337 37.2879L39.7 37.2866L39.6811 37.2861L39.5858 37.2755L39.0005 37.2045C38.6159 37.1477 38.1999 37.1418 37.8004 37.1071C37.3951 37.0793 36.9912 37.0913 36.5855 37.0824C34.9651 37.099 33.3478 37.3232 31.8071 37.7043C28.7091 38.445 25.9889 39.9166 23.8329 41.4107C23.5617 41.6 23.2986 41.7843 23.0374 41.9664C22.7852 42.1562 22.5484 42.355 22.3129 42.5433C22.0774 42.7316 21.8479 42.9172 21.6222 43.0984C21.5105 43.1899 21.3985 43.2772 21.2906 43.3642C21.1876 43.4592 21.0865 43.5519 20.9873 43.6423C20.2001 44.3673 19.5102 45.0041 18.937 45.5343C18.6591 45.7913 18.4082 46.0207 18.1904 46.2201C18.0817 46.3218 17.9806 46.4145 17.8871 46.4981C17.7891 46.578 17.6987 46.6488 17.6204 46.7143C17.3005 46.9707 17.13 47.1093 17.13 47.1093C17.13 47.1093 16.8416 47.342 16.3261 47.7623C16.0647 47.9675 15.7272 48.1898 15.3418 48.4645C15.15 48.6007 14.9442 48.7445 14.7266 48.8976C14.509 49.0508 14.2624 49.1833 14.0092 49.3375C13.758 49.4894 13.4926 49.6487 13.2175 49.8153C12.9446 49.9837 12.637 50.1153 12.3319 50.276C12.0216 50.4246 11.7142 50.6065 11.3733 50.741C11.037 50.8792 10.6885 51.0228 10.3339 51.1689C8.89465 51.7049 7.25528 52.1345 5.51244 52.2646C4.64192 52.34 3.74838 52.3189 2.85551 52.2326L2.18746 52.1499L1.52224 52.0271C1.30062 51.9876 1.08518 51.9223 0.864745 51.8722L0.70406 51.8337L0.64585 51.8157L0.529429 51.7796C0.476824 51.7779 0.495606 51.728 0.478692 51.7022L0.439583 51.565L0.23949 50.8752C0.105343 50.4147 -0.0284482 49.9584 -0.162235 49.5021C-0.429811 48.5895 -0.692493 47.6848 -0.951844 46.7946C-1.99079 43.24 -2.95224 39.9515 -3.66507 37.5017L-5.03013 32.8424L-5.71171 30.5116L-5.92228 29.7975L-5.96736 29.6399L-5.99086 29.5622L-6.00278 29.5213C-6.00278 29.5213 -6.02077 29.4829 -6.00077 29.4959C-5.91685 29.5201 -5.83258 29.5485 -5.74485 29.5681L-5.6163 29.599L-5.29637 29.6594C-5.12807 29.6888 -4.95906 29.7266 -4.78886 29.7539L-4.27933 29.823L-3.7698 29.8921L-3.25864 29.9317C-1.47352 30.0729 0.223859 29.9509 1.8069 29.671C2.20054 29.5886 2.59002 29.5066 2.97117 29.4253C3.3535 29.3334 3.71855 29.2115 4.08731 29.1082C4.27151 29.0545 4.45344 28.9988 4.63347 28.9455C4.81315 28.8879 4.98721 28.8141 5.162 28.7486C5.51122 28.6134 5.85438 28.4808 6.19753 28.3483C6.53616 28.2119 6.85488 28.0395 7.17958 27.8876C7.49939 27.7277 7.82481 27.584 8.13331 27.4146C8.73565 27.0519 9.34051 26.7183 9.90882 26.3501C10.4625 25.958 11.0127 25.5746 11.5478 25.1862C12.0546 24.7625 12.5558 24.3455 13.0547 23.9267L13.0459 23.9464Z" fill="#6A9A23"/>
<path d="M114.495 48.3233C112.222 47.5594 111.865 48.4842 114.065 49.4412C115.623 50.1181 117.228 50.7952 118.977 51.5123C119.855 51.8642 120.766 52.2322 121.724 52.617C122.269 52.8321 122.83 53.0521 123.405 53.2771C123.642 53.3719 123.882 53.4581 124.118 53.5446L124.298 53.6109L124.387 53.6431L124.432 53.658C124.448 53.6672 124.451 53.6354 124.461 53.6282L124.677 53.3074C124.82 53.0915 124.962 52.8714 125.107 52.6532C125.214 52.4803 125.323 52.3051 125.431 52.1299C126.78 49.8413 127.434 48.3201 127.986 46.9923C128.522 45.6576 128.956 44.5121 129.531 42.8088C130.002 41.3663 130.481 39.6442 130.752 37.7826C131.029 35.9289 131.072 33.9297 130.72 32.0614C130.685 31.8273 130.618 31.6003 130.566 31.3718L130.485 31.0327C130.452 30.9243 130.42 30.8201 130.388 30.7117C130.257 30.2887 130.129 29.8759 130.004 29.4734C129.871 29.0758 129.708 28.6954 129.569 28.3277C129.497 28.143 129.427 27.9644 129.357 27.79C129.273 27.619 129.194 27.4517 129.115 27.2886C128.956 26.9624 128.812 26.6518 128.666 26.3665C128.501 26.0891 128.349 25.8296 128.209 25.592C127.945 25.1071 127.656 24.7566 127.474 24.4912L127.134 24.0276L126.744 23.5997C126.627 23.4736 126.483 23.3223 126.319 23.1456C126.159 22.9644 125.94 22.7924 125.717 22.5851C125.273 22.162 124.688 21.7197 124.013 21.241C122.649 20.2913 120.829 19.3789 118.787 18.5467C117.766 18.1211 116.69 17.7191 115.586 17.3008C115.27 17.1814 114.951 17.06 114.628 16.9391C114.367 16.8399 114.105 16.7389 113.84 16.6401L113.446 16.4897L113.246 16.4147L113.146 16.3772L113.096 16.3584C113.096 16.3584 113.082 16.389 113.075 16.4064C112.755 17.2378 112.429 18.0802 112.103 18.9267C111.218 21.2191 110.304 23.5645 109.412 25.8156C108.794 27.4093 108.234 28.851 107.732 30.1514C107.421 30.9526 107.128 31.7103 106.85 32.4268C106.745 32.6982 106.644 32.965 106.543 33.2276L106.506 33.3274C106.489 33.3478 106.52 33.3471 106.533 33.3544L106.583 33.3731L106.78 33.4463C106.91 33.4938 107.038 33.5435 107.168 33.591C107.634 33.7625 108.085 33.9291 108.525 34.0903C109.559 34.458 110.424 34.7754 111.129 35.0899C111.836 35.4021 112.382 35.7072 112.788 35.9826C113.763 36.6283 114.417 37.4256 114.721 38.3225C115.031 39.2209 115.01 40.211 114.85 41.1627C114.514 43.0782 113.723 44.8274 112.888 46.5008C112.427 47.3926 112.339 47.952 112.53 48.0971L112.524 48.1921C112.543 48.1967 112.555 48.1914 112.562 48.174L112.566 48.1192C112.77 48.2253 113.25 47.9025 113.813 47.0312C114.839 45.3874 115.819 43.6386 116.32 41.4445C116.554 40.3541 116.654 39.1054 116.251 37.8205C116.047 37.1856 115.719 36.5657 115.278 36.0207C114.838 35.4734 114.298 35.004 113.712 34.6079C113.257 34.2948 112.658 33.946 111.931 33.5894C111.201 33.2309 110.34 32.8775 109.378 32.5014C109.259 32.4551 109.137 32.4069 109.015 32.3587L108.972 32.3415L108.965 32.3358L108.952 32.3285L108.932 32.3114L108.894 32.2874C108.885 32.2798 108.864 32.2774 108.883 32.2548C108.905 32.2235 108.922 32.1989 108.937 32.1767C109.05 31.9046 109.164 31.6303 109.285 31.345C109.769 30.1721 110.29 28.891 110.842 27.5045C111.2 26.6006 111.535 25.6882 111.85 24.7754C112.189 23.7893 112.548 22.774 112.917 21.7433C113.278 20.7489 113.644 19.7394 114.005 18.745L114.061 18.5681C114.061 18.5681 114.066 18.5489 114.07 18.5485L114.092 18.555L114.135 18.5681L114.223 18.5961L114.268 18.611L114.292 18.6194L114.381 18.6516L114.756 18.7891C115.003 18.881 115.248 18.9709 115.491 19.0632C115.976 19.2435 116.451 19.4227 116.91 19.6032C117.372 19.7793 117.813 19.9613 118.238 20.1365C119.943 20.8405 121.328 21.5682 122.259 22.1505C122.71 22.4597 123.088 22.685 123.314 22.8752C123.546 23.0587 123.675 23.1587 123.675 23.1587C123.675 23.1587 123.72 23.1968 123.812 23.2665C123.898 23.3387 124.044 23.4309 124.196 23.5815C124.355 23.7271 124.549 23.9055 124.772 24.1127C124.829 24.1644 124.886 24.2161 124.948 24.2717C125.001 24.3321 125.059 24.3921 125.117 24.4563C125.233 24.5848 125.355 24.7189 125.483 24.861C126.504 25.9978 127.669 27.8 128.462 30.0309C128.555 30.3103 128.651 30.5957 128.747 30.8812C128.839 31.167 128.95 31.4574 129.012 31.7415C129.087 32.0288 129.164 32.3138 129.211 32.6119L129.291 33.0539C129.312 33.2032 129.325 33.3531 129.347 33.5023C129.488 34.7029 129.464 35.9345 129.335 37.1165C129.074 39.485 128.427 41.6372 127.869 43.2046C127.024 45.5691 126.192 47.2486 125.546 48.5173C124.889 49.7808 124.393 50.6273 124.007 51.2609C123.939 51.3738 123.871 51.4825 123.805 51.589L123.775 51.6377C123.775 51.6377 123.741 51.6281 123.724 51.6254L123.618 51.5863C123.167 51.4156 122.729 51.2521 122.3 51.0921C121.329 50.7356 120.408 50.3979 119.52 50.072C117.742 49.4309 116.096 48.8581 114.486 48.3157L114.495 48.3233Z" fill="#6A9A23"/>
<path d="M63.2213 11.0802C64.3036 11.4417 64.931 11.4901 65.0627 11.2416C65.1871 11.0063 64.7809 10.4561 63.6473 9.96267C62.8457 9.6209 62.0109 9.33237 61.1289 9.10458C60.2473 8.88095 59.3135 8.7101 58.3289 8.65487C57.8413 8.59642 57.3321 8.62798 56.8151 8.61824C56.558 8.63003 56.296 8.65694 56.0313 8.67778C55.898 8.68934 55.7647 8.70089 55.6314 8.71245C55.497 8.7346 55.3648 8.75864 55.2303 8.78079C54.1508 8.93941 53.0339 9.27124 51.9327 9.78634C51.7776 9.86063 51.624 9.9285 51.4775 10.0062C51.3356 10.0878 51.1978 10.169 51.0597 10.246C50.7857 10.4019 50.528 10.5523 50.2994 10.7231C50.0662 10.8902 49.8377 11.038 49.6378 11.2022C49.4383 11.3706 49.2487 11.5318 49.0667 11.684C48.7053 11.9944 48.4124 12.3198 48.1181 12.6055C47.8555 12.9178 47.5991 13.2044 47.3722 13.4927C46.4759 14.6552 45.8317 15.7244 45.0325 17.3317C44.3767 18.7042 43.7657 20.377 43.3437 22.174C42.9124 23.9592 42.6876 25.9258 42.8109 27.7679C42.9178 29.6155 43.3565 31.3442 43.9484 32.684C44.5304 34.031 45.2423 34.9618 45.621 35.485C45.8706 35.776 46.1183 36.0692 46.3915 36.3414C46.8871 36.8083 47.8267 37.6795 49.2654 38.4989C49.6286 38.6962 50.0023 38.9177 50.4196 39.1102C50.8332 39.3072 51.2794 39.4931 51.7434 39.6669C52.6774 40.0119 53.698 40.3137 54.8094 40.5258C57.0183 40.9575 59.6288 40.962 62.1114 40.1404C63.3524 39.7391 64.5396 39.1263 65.6002 38.3608C66.6654 37.5991 67.6064 36.6867 68.4118 35.7104C69.54 34.318 70.3115 32.8999 70.9125 31.5972C71.4954 30.2794 71.8779 29.0712 72.1641 27.9868C72.4458 26.8986 72.6224 25.9307 72.7077 25.0945C72.8141 24.2606 72.8305 23.5521 72.8419 22.9783C72.8528 20.2602 72.1712 17.8559 71.051 15.9366C70.4777 14.9834 69.8234 14.1357 69.0796 13.4176C68.3284 12.7126 67.5418 12.0821 66.6795 11.5966C66.2508 11.3211 65.8679 11.2117 65.5987 11.1553C65.3256 11.1034 65.1518 11.1311 65.0821 11.2231L65.145 11.3687C65.1232 11.335 65.0952 11.3269 65.0588 11.3426L65.0431 11.3062C65.0108 11.4181 65.0816 11.582 65.2604 11.7826C65.4355 11.9877 65.7286 12.1994 66.0982 12.4947C66.8482 13.0172 67.5077 13.6566 68.1348 14.3346C68.7505 15.0261 69.282 15.813 69.7486 16.6727C70.2113 17.5369 70.5551 18.5059 70.8114 19.5559C71.0594 20.6065 71.2063 21.7499 71.1886 22.9789C71.1966 23.2174 71.1654 23.4887 71.1497 23.7922C71.1381 24.0954 71.0911 24.4268 71.0364 24.7903C70.948 25.5156 70.767 26.3601 70.5057 27.2954C69.9645 29.1699 69.1073 31.4663 67.5012 33.7163L67.3088 33.9911L67.1005 34.2525L66.6908 34.7811C66.3873 35.1054 66.1203 35.4642 65.8002 35.7668C65.6299 35.9327 65.4716 36.1164 65.2858 36.273C65.1023 36.4316 64.9187 36.5902 64.7333 36.7511C64.3409 37.0432 63.9478 37.35 63.5114 37.5935C62.6552 38.102 61.7221 38.5228 60.7441 38.7629C58.7947 39.2718 56.7658 39.2231 55.0396 38.865C53.3077 38.5136 51.8735 37.9413 50.9288 37.4483C50.4595 37.1889 50.0869 36.9799 49.8427 36.8249C49.602 36.6611 49.4726 36.5716 49.4726 36.5716C49.4726 36.5716 49.4235 36.5381 49.3322 36.4768C49.2405 36.4113 49.0971 36.3293 48.9364 36.1942C48.772 36.0637 48.5714 35.9027 48.3372 35.7174C48.1201 35.5117 47.8736 35.2813 47.5996 35.0239C47.0988 34.4714 46.5061 33.8031 46.0168 32.9475C45.52 32.1009 45.0877 31.1039 44.7938 30.0068C44.1804 27.8107 44.2512 25.251 44.7058 22.956C45.1626 20.6398 45.9616 18.5919 46.736 17.184C47.8904 15.0487 49.1258 13.7309 50.1581 12.8798C51.1942 12.0241 52.0123 11.5839 52.6484 11.2959C53.6061 10.8457 54.5704 10.5439 55.5178 10.3862C55.6356 10.3655 55.753 10.3406 55.8686 10.318C55.9871 10.3057 56.1034 10.2914 56.2219 10.279C56.4548 10.2546 56.6851 10.2242 56.9142 10.2043C57.3752 10.1979 57.8243 10.1506 58.2681 10.1877C60.0484 10.2243 61.691 10.5855 63.2383 11.0829L63.2213 11.0802Z" fill="#6A9A23"/>
<path d="M149.643 57.1462C149.707 57.1386 149.772 57.135 149.834 57.1296C149.897 57.1284 149.958 57.1335 150.017 57.1368C150.136 57.1434 150.255 57.1393 150.367 57.1485C150.584 57.1884 150.799 57.195 150.983 57.2609C151.077 57.2863 151.167 57.3078 151.257 57.3294C151.342 57.3619 151.422 57.3948 151.5 57.4216C151.58 57.4504 151.654 57.4776 151.725 57.5028C151.793 57.5368 151.859 57.5689 151.92 57.5972C152.179 57.7027 152.367 57.8102 152.516 57.8582C152.665 57.9103 152.768 57.9119 152.818 57.8655C152.869 57.8192 152.863 57.7211 152.795 57.5675C152.727 57.4139 152.604 57.2022 152.364 56.9733C152.304 56.9155 152.242 56.8517 152.176 56.7882C152.104 56.7315 152.021 56.6736 151.936 56.6138C151.851 56.554 151.758 56.4908 151.66 56.4279C151.555 56.3783 151.444 56.3271 151.328 56.2721C151.099 56.1534 150.826 56.0974 150.536 56.0197C150.391 55.9903 150.237 55.9806 150.078 55.9629C149.999 55.955 149.919 55.9452 149.837 55.9418C149.757 55.9445 149.674 55.9476 149.59 55.9506C148.636 55.9788 147.736 56.254 146.905 56.6177C146.068 56.9798 145.315 57.471 144.572 57.9823C144.209 58.2488 143.842 58.5115 143.498 58.8057C143.142 59.0862 142.801 59.3864 142.46 59.695L142.203 59.9229C142.117 59.9975 142.015 60.1008 141.928 60.1902C141.84 60.2818 141.755 60.373 141.675 60.4639L141.463 60.7068L141.37 60.8029C141.341 60.8285 141.308 60.8776 141.28 60.8192L141.196 60.7216L141.177 60.698L141.059 60.5718L140.819 60.3157C140.497 59.9722 140.173 59.6226 139.843 59.2714C139.187 58.5688 138.512 57.8509 137.823 57.1133C136.438 55.6471 134.985 54.105 133.447 52.4758C133.366 52.3925 133.286 52.3093 133.205 52.2261L133.16 52.188C133.113 52.1606 133.152 52.1278 133.173 52.0987L133.224 52.0376C133.316 51.9373 133.407 51.8393 133.497 51.7413C133.679 51.5471 133.86 51.3593 134.04 51.1738C134.763 50.4418 135.456 49.7649 136.09 49.1581C137.34 47.9418 138.448 46.9918 139.511 46.1548C140.576 45.3197 141.597 44.587 142.741 43.9067C143.884 43.2263 145.144 42.5737 146.712 41.9993C147.041 41.8701 147.387 41.775 147.733 41.6568C148.083 41.5489 148.444 41.4588 148.809 41.36C149.549 41.1973 150.314 41.0408 151.105 40.9722C152.687 40.8036 154.367 40.8909 156.008 41.2858C157.649 41.6806 159.244 42.388 160.67 43.3471C162.105 44.2991 163.355 45.4853 164.442 46.7697C165.532 48.0453 166.437 49.3937 167.101 50.744C167.769 52.094 168.2 53.4415 168.453 54.689C168.707 55.9385 168.791 57.0831 168.821 58.0542C168.854 59.0248 168.81 59.826 168.784 60.399L168.72 61.4389C168.704 61.7886 168.699 62.1626 168.693 62.5093C168.686 63.1141 168.656 63.9581 168.694 65.1446C168.711 65.7348 168.755 66.4171 168.886 67.1989C169.02 67.9762 169.253 68.8834 169.791 69.7915C170.053 70.2472 170.391 70.6816 170.799 71.0868C171.204 71.5007 171.727 71.8667 172.326 72.1546C172.941 72.4245 173.637 72.5655 174.345 72.5693C175.051 72.5605 175.743 72.4082 176.418 72.1881C177.747 71.7099 178.979 70.9338 180.172 69.9974C180.767 69.5283 181.354 69.0136 181.936 68.4638C182.23 68.1929 182.508 67.9211 182.801 67.6419C182.857 67.5887 182.911 67.5337 182.968 67.4805L183.01 67.4391C183.026 67.4524 183.042 67.4657 183.06 67.481L183.076 67.4943L183.085 67.5019L183.154 67.5756C183.256 67.6801 183.36 67.7907 183.472 67.9047C183.91 68.3619 184.42 68.8906 184.982 69.4797C186.108 70.6578 187.46 72.0766 188.952 73.6405C189.633 74.3557 190.346 75.1059 191.082 75.8793C191.101 75.907 191.162 75.9353 191.113 75.9669L191.075 76.0121L190.913 76.1856C190.524 76.6075 190.105 77.0278 189.673 77.445C189.235 77.8649 188.793 78.2851 188.349 78.7117C187.9 79.1179 187.462 79.5461 186.997 79.9389C186.087 80.7501 185.126 81.5027 184.164 82.2239C181.541 84.1593 178.922 85.5424 176.438 86.3284C173.956 87.1228 171.629 87.2992 169.639 87.0479C168.643 86.9245 167.728 86.7079 166.902 86.427C166.08 86.1373 165.338 85.8072 164.678 85.449C163.359 84.7303 162.368 83.9392 161.596 83.2591C160.691 82.4521 159.878 81.572 159.161 80.6753C158.43 79.7861 157.823 78.8547 157.303 77.9115C156.265 76.0228 155.669 74.0497 155.387 72.0934C155.235 71.1162 155.172 70.1397 155.141 69.1751C155.104 68.2089 155.139 67.2533 155.147 66.279C155.152 65.3092 155.16 64.358 155.127 63.3873C155.092 62.4231 155.005 61.4381 154.757 60.4609C154.485 59.4059 153.996 58.6741 153.603 58.2822C153.412 58.0785 153.232 57.9619 153.1 57.8936C152.968 57.8253 152.879 57.812 152.832 57.8497L152.701 57.8442C152.697 57.8635 152.703 57.8692 152.722 57.8655L152.829 57.8436L152.808 57.8685C152.77 57.9138 152.772 58.008 152.817 58.1426C152.86 58.2752 152.946 58.4482 153.042 58.6791C153.244 59.1316 153.527 59.7785 153.718 60.7041C153.889 61.5705 153.936 62.4792 153.926 63.4054C153.92 64.3312 153.872 65.2838 153.833 66.2398C153.722 68.1482 153.636 70.1889 153.902 72.2935C154.151 74.3995 154.77 76.593 155.881 78.6747C156.437 79.7134 157.093 80.7371 157.873 81.7018C158.641 82.6759 159.501 83.6149 160.49 84.5006C161.26 85.1829 162.28 86.0177 163.649 86.8244C165.02 87.6183 166.762 88.3758 168.863 88.7476C170.959 89.1156 173.393 89.0683 175.922 88.44C178.453 87.8219 181.043 86.6301 183.565 85.0036C185.208 83.94 186.742 82.7265 188.162 81.4284C188.478 81.1492 188.784 80.8541 189.092 80.5567C189.402 80.2613 189.714 79.9636 190.011 79.665C190.619 79.0668 191.235 78.4573 191.845 77.8107L192.299 77.316C192.345 77.2617 192.523 77.0679 192.639 76.9257L193.021 76.4708L193.391 76.0086L193.486 75.8955C193.48 75.8561 193.425 75.821 193.399 75.7834L193.195 75.566C192.933 75.2761 192.65 74.988 192.374 74.7014C191.761 74.0705 191.146 73.4377 190.534 72.8068C189.331 71.5598 188.135 70.3226 186.969 69.1144C185.625 67.7139 184.318 66.348 183.066 65.0444C182.442 65.6398 181.829 66.2259 181.227 66.8048C181.016 67.0098 180.808 67.2062 180.602 67.3919C180.393 67.5799 180.196 67.7733 179.987 67.9488C179.164 68.6706 178.326 69.2951 177.498 69.7927C176.67 70.2863 175.836 70.6439 175.066 70.7841C174.293 70.9266 173.6 70.8461 173.042 70.5966C172.477 70.3497 172.045 69.936 171.712 69.5326C171.383 69.1289 171.169 68.7362 171.022 68.3965C170.949 68.2266 170.901 68.067 170.85 67.9351C170.811 67.7937 170.778 67.677 170.753 67.5826C170.724 67.4886 170.713 67.4098 170.7 67.3606C170.689 67.309 170.683 67.2844 170.683 67.2844C170.683 67.2844 170.655 67.1757 170.62 66.9647C170.602 66.8571 170.582 66.7245 170.558 66.5692C170.542 66.409 170.522 66.2261 170.5 66.0182C170.428 65.181 170.429 63.9304 170.475 62.3506C170.48 61.578 170.559 60.7172 170.575 59.7653C170.586 58.816 170.584 57.7985 170.473 56.7275C170.366 55.6562 170.183 54.5328 169.879 53.3967C169.563 52.2616 169.12 51.1208 168.563 50.0109C168.013 48.8919 167.297 47.8419 166.532 46.8276C166.332 46.5785 166.135 46.3312 165.933 46.0802C165.729 45.8356 165.508 45.603 165.296 45.3632C165.082 45.1258 164.871 44.886 164.637 44.6587C164.41 44.4287 164.184 44.1965 163.941 43.9846C162.045 42.2207 159.744 40.834 157.312 40.1068C154.881 39.3649 152.383 39.3003 150.19 39.631C147.983 39.9545 146.071 40.6532 144.51 41.353C142.165 42.4333 140.292 43.6636 138.737 44.8286C137.183 45.9978 135.935 47.0964 134.891 48.0807C133.859 49.0556 132.992 49.8798 132.263 50.6501C132.173 50.7481 132.085 50.8439 131.996 50.9355C131.87 51.0807 131.724 51.2361 131.601 51.3915C131.474 51.5473 131.351 51.6986 131.228 51.8498C131.165 51.9245 131.108 52.0008 131.048 52.0732C131.006 52.1461 130.87 52.225 130.986 52.2883C131.232 52.5607 131.465 52.8217 131.709 53.0734C131.889 53.2634 132.062 53.4477 132.23 53.624C133.778 55.2461 135.238 56.775 136.632 58.2363C137.33 58.9626 138.015 59.6733 138.681 60.3688C139.015 60.7154 139.345 61.0583 139.674 61.3969C139.865 61.5964 140.056 61.7918 140.245 61.9894L140.649 62.4098C140.784 62.5428 140.916 62.6615 141.049 62.7885L141.247 62.9748L141.299 63.0185L141.32 63.044C141.325 63.0478 141.329 63.0516 141.332 63.0535L141.343 63.0399L141.444 62.943L141.83 62.5529C142.085 62.3 142.335 62.0077 142.564 61.7213C142.888 61.3177 143.089 61.0967 143.437 60.779C143.751 60.4791 144.068 60.1851 144.395 59.9113C144.712 59.6257 145.047 59.3701 145.374 59.1088C146.043 58.6165 146.72 58.1424 147.435 57.8013C148.146 57.4564 148.886 57.2055 149.62 57.1503L149.643 57.1462Z" fill="#6A9A23"/>
<path d="M80.321 25.3809C80.4416 23.1064 79.4571 23.0281 79.1312 25.2574C78.8942 26.839 78.6434 28.4554 78.3341 30.1965C78.018 31.9318 77.6635 33.8048 77.0533 35.8028C76.9621 36.1317 76.8558 36.4326 76.7629 36.7176C76.7418 36.7887 76.7161 36.8559 76.6904 36.9232C76.6579 37.0079 76.6295 37.0922 76.5966 37.1726C76.5069 37.4217 76.4055 37.6571 76.3015 37.8865C75.8871 38.7743 75.5595 39.4762 75.3454 39.9375C76.5743 39.8079 77.6597 39.6697 78.5962 39.5571C79.1374 39.4829 79.6268 39.4153 80.1059 39.3507C81.0599 39.2218 81.9734 39.109 83.1533 38.9963C85.9529 38.7116 89.7215 38.3996 93.0728 38.1385C93.9107 38.0743 94.7237 38.0122 95.4885 37.9522C95.6782 37.9379 95.8679 37.9235 96.0534 37.9095C96.3908 37.8803 96.7199 37.8518 97.0447 37.8236C97.2132 37.8069 97.3821 37.7943 97.5465 37.778L97.6089 37.7726C97.6204 37.759 97.6182 37.734 97.6228 37.7147L97.6419 37.5956L97.6801 37.3573C97.73 37.0361 97.7788 36.7255 97.826 36.4214C97.9332 35.7428 98.0279 35.1387 98.1097 34.628C98.1809 34.1392 98.241 33.7417 98.2835 33.4568C98.332 33.119 98.3699 32.78 98.4014 32.4394C98.4496 31.9044 98.5308 30.972 98.6212 29.7346C98.6626 29.1205 98.7101 28.4302 98.7605 27.6768C98.8248 26.9389 98.9042 26.1326 98.9956 25.2707C99.1893 23.5523 99.4495 21.6308 99.8761 19.6446C100.088 18.6526 100.35 17.6438 100.688 16.6576C100.777 16.415 100.869 16.172 100.959 15.9271L101.111 15.5677L101.185 15.3871C101.19 15.3678 101.226 15.3017 101.255 15.2447L101.343 15.0755L101.695 14.3903C101.746 14.2788 101.822 14.1569 101.901 14.0346L102.126 13.671C102.421 13.1964 102.713 12.72 103.01 12.2431C102.93 12.2417 102.807 12.2544 102.664 12.2689C102.522 12.2812 102.364 12.2991 102.189 12.3143C101.84 12.3487 101.434 12.3902 100.989 12.433C100.271 12.5015 99.4285 12.5851 98.594 12.6637C92.1629 13.3177 88.1819 13.7215 86.104 13.9331C84.8775 14.0646 83.7301 14.1892 82.6387 14.3069C81.9634 14.3843 81.3068 14.4581 80.6649 14.5326L80.3138 14.5735L80.1393 14.5928L80.054 14.6023C80.054 14.6023 80.0158 14.5972 80.0195 14.6158L80.0129 14.6604C79.9849 14.8958 79.9566 15.1269 79.9306 15.36C79.9042 15.5889 79.8778 15.8178 79.8514 16.0467C79.8379 16.1821 79.824 16.3134 79.8105 16.4489C79.6178 18.4463 79.5162 20.2848 79.4719 22.1057C79.4328 24.1087 80.2926 24.1517 80.5363 22.1855C80.7678 20.3945 81.0108 18.59 81.2991 16.6304C81.3163 16.5135 81.3335 16.3966 81.3507 16.2797L81.3736 16.156L81.3968 16.0365C81.4245 16.0173 81.4801 16.0293 81.5173 16.0219L81.6426 16.0152C81.7592 16.0051 81.8758 15.995 81.9924 15.9849C82.259 15.9618 82.5275 15.9364 82.8005 15.9148C83.891 15.8119 85.0441 15.7036 86.2698 15.5868C88.1772 15.3942 92.1765 15.2259 97.792 14.7013C98.2499 14.6575 98.7073 14.6094 99.1621 14.5553L99.459 14.5191C99.459 14.5191 99.4628 14.5146 99.4666 14.51C99.4723 14.5032 99.4841 14.4938 99.5061 14.4814C99.5282 14.469 99.5786 14.4458 99.6074 14.4391C99.6134 14.4595 99.619 14.4758 99.5928 14.562L99.5732 14.6267L99.4323 14.9872C99.3335 15.2287 99.2457 15.4755 99.1662 15.7216C98.8317 16.7074 98.5712 17.7014 98.3498 18.6858C97.9192 20.6493 97.6406 22.5514 97.4316 24.2145C97.2283 25.8708 97.0684 27.301 96.9964 28.3144C96.9101 29.3081 96.8578 29.8938 96.8578 29.8938C96.8578 29.8938 96.7819 30.8383 96.6206 32.3483C96.541 33.1043 96.4359 34.0009 96.3094 34.9918C96.2578 35.3655 96.2075 35.756 96.1523 36.1615C96.1696 36.2649 96.0622 36.2365 95.9922 36.2509C95.7737 36.272 95.5533 36.2953 95.3287 36.3189C90.738 36.7819 85.3487 37.3267 82.1496 37.6502L79.3959 37.9309L78.3394 38.0392L78.1542 38.0574L78.0607 38.0676L78.0148 38.0716C78.0148 38.0716 77.9678 38.0861 77.9869 38.0635C78.0476 37.9407 78.1061 37.8161 78.1578 37.6857L78.2605 37.4166C78.3084 37.2907 78.3479 37.1656 78.3917 37.0401C78.4791 36.7891 78.5624 36.5385 78.637 36.2845C79.2812 34.1451 79.6012 32.2122 79.8478 30.4262C80.088 28.6386 80.2266 26.9858 80.3206 25.3767L80.321 25.3809Z" fill="#6A9A23"/>
</g>
</g>
<defs>
<clipPath id="clip0_783_5660">
<rect width="421" height="32" fill="white"/>
</clipPath>
<clipPath id="clip1_783_5660">
<rect width="304" height="304.679" fill="white" transform="translate(268.681 74.498) rotate(-105)"/>
</clipPath>
<clipPath id="clip2_783_5660">
<rect width="304" height="304.679" fill="white" transform="translate(-42.3188 346) rotate(-105)"/>
</clipPath>
</defs>
</svg>
`;
const $24c02ea0e14dbe4f$var$$ea8e736e4eb06883$export$3c6f6c6a4ab84ea6 = `data:image/svg+xml;base64,${$24c02ea0e14dbe4f$var$$ea8e736e4eb06883$require$Buffer.from($24c02ea0e14dbe4f$var$$ea8e736e4eb06883$var$learningPathBg).toString("base64")}`;
const $24c02ea0e14dbe4f$var$$0dbf0b63949b5d22$export$8b251419efc915eb = ({ isCourse: isCourse, courseImgUrl: courseImgUrl, title: title, completedItems: completedItems, progress: progress, learningPathSlug: learningPathSlug, courseSlug: courseSlug, navigate: navigate })=>{
    const handleNavigation = (0, $5FkrB.useCallback)(()=>{
        learningPathSlug ? navigate(`/path/${learningPathSlug}`) : navigate(`/course/${courseSlug}`);
    }, [
        learningPathSlug,
        courseSlug,
        navigate
    ]);
    const onKeyDown = $24c02ea0e14dbe4f$export$2a0b6757d41dacb2(handleNavigation);
    return (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
        "data-testid": "sidebar-header",
        css: $24c02ea0e14dbe4f$var$$0dbf0b63949b5d22$var$headerStyles,
        children: [
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("img", {
                css: $24c02ea0e14dbe4f$var$$0dbf0b63949b5d22$var$headerImageStyles,
                src: isCourse ? $24c02ea0e14dbe4f$var$$e48fba9cf5395297$export$d3a66d29d3f047ac : $24c02ea0e14dbe4f$var$$ea8e736e4eb06883$export$3c6f6c6a4ab84ea6,
                alt: title
            }),
            (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                css: [
                    $24c02ea0e14dbe4f$var$$0dbf0b63949b5d22$var$headerContentStyles,
                    isCourse && $24c02ea0e14dbe4f$var$$0dbf0b63949b5d22$var$courseHeaderContentStyles
                ],
                children: [
                    isCourse && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                        css: $24c02ea0e14dbe4f$var$$0dbf0b63949b5d22$var$courseImageContainerStyles,
                        children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("img", {
                            css: $24c02ea0e14dbe4f$var$$0dbf0b63949b5d22$var$courseImageStyles,
                            src: courseImgUrl,
                            alt: title,
                            "data-testid": "course-image"
                        })
                    }),
                    (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                        css: [
                            $24c02ea0e14dbe4f$var$$0dbf0b63949b5d22$var$containerStyles,
                            isCourse && (0, $74Zh5.css)({
                                marginLeft: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.150")
                            })
                        ],
                        children: [
                            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("p", {
                                css: $24c02ea0e14dbe4f$var$$0dbf0b63949b5d22$var$typeStyles,
                                children: isCourse ? "Course" : "Learning Path"
                            }),
                            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                                role: "button",
                                tabIndex: 0,
                                css: $24c02ea0e14dbe4f$var$$0dbf0b63949b5d22$var$titleStyles,
                                "data-testid": "sidebar-title",
                                onClick: handleNavigation,
                                onKeyDown: onKeyDown,
                                children: title
                            })
                        ]
                    }),
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                        "data-testid": "course-progress-circle",
                        css: $24c02ea0e14dbe4f$var$$0dbf0b63949b5d22$var$progressCircleContainerStyles,
                        children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $f188eff9b59fb855$export$5ab97151efedb8c6), {
                            strokeWidth: 8,
                            value: progress,
                            styles: (0, $f188eff9b59fb855$export$5115a192ad9bf57f)({
                                pathColor: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.border.success"),
                                trailColor: "rgba(9, 30, 66, 0.14)"
                            }),
                            children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("p", {
                                css: [
                                    $24c02ea0e14dbe4f$var$$0dbf0b63949b5d22$var$progressStyles,
                                    isCourse && (0, $74Zh5.css)({
                                        fontSize: "14px"
                                    })
                                ],
                                "data-testid": "progress-text",
                                children: completedItems
                            })
                        })
                    })
                ]
            })
        ]
    });
};
const $24c02ea0e14dbe4f$var$$0dbf0b63949b5d22$var$headerStyles = (0, $74Zh5.css)({
    width: "100%",
    marginBottom: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.200")
});
const $24c02ea0e14dbe4f$var$$0dbf0b63949b5d22$var$headerImageStyles = (0, $74Zh5.css)({
    [(0, $cb8cedbc477f5a81$export$987d49ffe1b0900f).below.xs]: {
        width: "100%"
    }
});
const $24c02ea0e14dbe4f$var$$0dbf0b63949b5d22$var$headerContentStyles = (0, $74Zh5.css)({
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    marginTop: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.250"),
    paddingLeft: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.200"),
    paddingRight: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.100")
});
const $24c02ea0e14dbe4f$var$$0dbf0b63949b5d22$var$courseHeaderContentStyles = (0, $74Zh5.css)({
    paddingLeft: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.150"),
    paddingRight: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.150")
});
const $24c02ea0e14dbe4f$var$$0dbf0b63949b5d22$var$progressCircleContainerStyles = (0, $74Zh5.css)({
    maxWidth: "48px",
    marginLeft: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.150")
});
const $24c02ea0e14dbe4f$var$$0dbf0b63949b5d22$var$progressStyles = (0, $74Zh5.css)({
    fontFamily: "Inter, sans-serif",
    fontSize: "16px",
    fontWeight: 400,
    lineHeight: "24px"
});
const $24c02ea0e14dbe4f$var$$0dbf0b63949b5d22$var$courseImageContainerStyles = (0, $74Zh5.css)({
    width: "32px",
    minWidth: "32px",
    minHeight: "32px"
});
const $24c02ea0e14dbe4f$var$$0dbf0b63949b5d22$var$courseImageStyles = (0, $74Zh5.css)({
    width: "100%",
    height: "100%",
    objectFit: "cover"
});
const $24c02ea0e14dbe4f$var$$0dbf0b63949b5d22$var$containerStyles = (0, $74Zh5.css)({
    display: "flex",
    flexDirection: "column",
    marginRight: "auto"
});
const $24c02ea0e14dbe4f$var$$0dbf0b63949b5d22$var$typeStyles = (0, $74Zh5.css)({
    color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text.subtle"),
    fontFamily: "Charlie Display, sans-serif",
    fontSize: "12px",
    lineHeight: "16px",
    fontWeight: 600,
    textTransform: "uppercase",
    marginBottom: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.050")
});
const $24c02ea0e14dbe4f$var$$0dbf0b63949b5d22$var$titleStyles = (0, $74Zh5.css)({
    fontFamily: "Charlie Display, sans-serif",
    fontSize: "20px",
    fontWeight: 600,
    lineHeight: "28px",
    marginTop: 0,
    transition: "color 0.5s ease",
    [(0, $cb8cedbc477f5a81$export$987d49ffe1b0900f).below.xs]: {
        fontSize: "16px",
        lineHeight: "24px"
    },
    "&:hover": {
        cursor: "pointer",
        color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text.selected")
    }
});
const $24c02ea0e14dbe4f$var$$dc9bbc4e728e99ac$export$792ece11a7230884 = 89;
const $24c02ea0e14dbe4f$var$$dc9bbc4e728e99ac$export$1239cfcb7eeed80e = 8;
const $24c02ea0e14dbe4f$var$$dc9bbc4e728e99ac$export$686a18f490557de2 = 16;
const $24c02ea0e14dbe4f$var$$dc9bbc4e728e99ac$export$6a021f56d50c6f44 = 250;
const $24c02ea0e14dbe4f$var$$dc9bbc4e728e99ac$export$789f21e35b72f907 = 68;
const $24c02ea0e14dbe4f$var$$dc9bbc4e728e99ac$export$4ac0ef1183ae81e8 = (positionData)=>{
    const height = positionData.height > $24c02ea0e14dbe4f$var$$dc9bbc4e728e99ac$export$792ece11a7230884 ? $24c02ea0e14dbe4f$var$$dc9bbc4e728e99ac$export$792ece11a7230884 : positionData.height;
    const subnavbarPosition = document.getElementById("subnavbar")?.getBoundingClientRect();
    const offset = subnavbarPosition && subnavbarPosition.y < $24c02ea0e14dbe4f$var$$dc9bbc4e728e99ac$export$789f21e35b72f907 ? $24c02ea0e14dbe4f$var$$dc9bbc4e728e99ac$export$789f21e35b72f907 - subnavbarPosition.y : 0;
    return {
        top: positionData.top - ($24c02ea0e14dbe4f$var$$dc9bbc4e728e99ac$export$6a021f56d50c6f44 / 2 - height / 2) + offset - $24c02ea0e14dbe4f$var$$dc9bbc4e728e99ac$export$686a18f490557de2,
        left: $24c02ea0e14dbe4f$var$$035f8a623e403361$export$780035d9fe48eb32 - $24c02ea0e14dbe4f$var$$dc9bbc4e728e99ac$export$686a18f490557de2
    };
};
const $24c02ea0e14dbe4f$var$$f50e6e435b887166$export$1671b398b5e36be4 = ({ courses: courses, renderPopup: renderPopup })=>{
    const { hoverInfo: hoverInfo, popupRef: popupRef, handleMouseLeave: handleMouseLeave } = $24c02ea0e14dbe4f$var$$32c02b5652036d7a$export$861cd542ff836f0d();
    const courseToShowInPopup = (0, $5FkrB.useMemo)(()=>courses.find(({ sys: sys })=>sys.id === hoverInfo?.courseId), [
        hoverInfo?.courseId,
        courses
    ]);
    const handlePopupLeave = (e)=>{
        const popupId = popupRef.current?.children[0].id;
        const isMovedToOutside = e.target.closest(`#${popupId}`);
        if (isMovedToOutside) handleMouseLeave();
    };
    if (!hoverInfo) return null;
    return (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
        "data-testid": "sidebar-hover-popup",
        ref: popupRef,
        onMouseLeave: handlePopupLeave,
        css: [
            $24c02ea0e14dbe4f$var$$f50e6e435b887166$var$popupStyles,
            (0, $74Zh5.css)($24c02ea0e14dbe4f$var$$dc9bbc4e728e99ac$export$4ac0ef1183ae81e8(hoverInfo.courseCardPosition))
        ],
        children: renderPopup(courseToShowInPopup)
    });
};
const $24c02ea0e14dbe4f$var$$f50e6e435b887166$var$popupStyles = (0, $74Zh5.css)({
    position: "absolute",
    zIndex: 100,
    transform: "translateY(-50%)",
    paddingLeft: `${$24c02ea0e14dbe4f$var$$dc9bbc4e728e99ac$export$686a18f490557de2 + $24c02ea0e14dbe4f$var$$dc9bbc4e728e99ac$export$1239cfcb7eeed80e}px`,
    marginLeft: "-1px",
    [(0, $cb8cedbc477f5a81$export$987d49ffe1b0900f).below.sm]: {
        display: "none"
    }
});
const $24c02ea0e14dbe4f$export$4ff69a78d3a65d6f = ({ isVisible: isVisible = true, isLoading: isLoading, learningPath: learningPath, progressForLessons: progressForLessons, progressForCourses: progressForCourses, expandedCourseIds: expandedCourseIds = [], expandedLessonIds: expandedLessonIds = [], selectedSectionId: selectedSectionId, currentLessonSlug: currentLessonSlug, onSelect: onSelect, navigate: navigate = ()=>{}, renderPopup: renderPopup, onToggleVisibility: onToggleVisibility })=>{
    const [showCurrentLessonButton, setShowCurrentLessonButton] = (0, $5FkrB.useState)(false);
    const scrollContainerRef = (0, $5FkrB.useRef)(null);
    const selectedLessonRef = (0, $5FkrB.useRef)(null);
    const courses = (0, $5FkrB.useMemo)(()=>learningPath?.coursesCollection.items || [], [
        learningPath?.coursesCollection.items
    ]);
    const lessons = (0, $5FkrB.useMemo)(()=>courses.flatMap((course)=>course.lessonsCollection.items), [
        courses
    ]);
    const numberOfCompletedLessons = lessons.filter(({ sys: { id: id } })=>progressForLessons?.lessons.find((lesson)=>lesson.lessonId === id)?.status === $24c02ea0e14dbe4f$var$$035f8a623e403361$export$23d03d0b3065d061.COMPLETED).length;
    const numberOfCompletedCourses = courses.filter(({ sys: { id: id } })=>progressForCourses?.courses.find((course)=>course.courseId === id)?.status === $24c02ea0e14dbe4f$var$$035f8a623e403361$export$23d03d0b3065d061.COMPLETED).length;
    const selectedCourse = courses.find(({ slug: slug })=>$24c02ea0e14dbe4f$var$$48630d5962798e4a$export$15379570ba48f04d(slug));
    const isCourse = !learningPath?.title;
    const courseImage = (courses[0]?.reward?.orangeLogicAsset?.imageUrl ?? courses[0]?.reward?.badgeCdnUrl) || $24c02ea0e14dbe4f$var$$ef44b01e6346ac17$export$44f5f766f3f98994;
    const calculateProgress = ()=>isCourse ? numberOfCompletedLessons / lessons.length * 100 : numberOfCompletedCourses / courses.length * 100;
    const completedEntities = isCourse ? numberOfCompletedLessons : numberOfCompletedCourses;
    const totalEntities = isCourse ? lessons.length : courses.length;
    // Find the selected lesson in either the main lessons array or inside course cards
    const selectedLessonId = (0, $5FkrB.useMemo)(()=>isCourse ? lessons.find(({ slug: slug })=>$24c02ea0e14dbe4f$var$$48630d5962798e4a$export$15379570ba48f04d("", slug)) : courses.reduce((found, course)=>{
            if (found) return found;
            const selectedLesson = course.lessonsCollection.items.find(({ slug: slug })=>$24c02ea0e14dbe4f$var$$48630d5962798e4a$export$15379570ba48f04d("", slug));
            return selectedLesson ? selectedLesson.sys.id : undefined;
        }, undefined), [
        isCourse,
        lessons,
        courses
    ]);
    // Handle scroll event to check if selected lesson is visible
    const handleScroll = (0, $5FkrB.useCallback)(()=>{
        if (!scrollContainerRef.current || !selectedLessonRef.current || !selectedLessonId) return;
        const container = scrollContainerRef.current;
        const selectedLessonElement = selectedLessonRef.current;
        const containerRect = container.getBoundingClientRect();
        const lessonRect = selectedLessonElement.getBoundingClientRect();
        // Check if the selected lesson is above the visible area
        const isLessonAboveViewport = lessonRect.top < containerRect.top;
        setShowCurrentLessonButton(isLessonAboveViewport);
    }, [
        selectedLessonId
    ]);
    const scrollToSelectedLesson = (0, $5FkrB.useCallback)(()=>{
        if (selectedLessonRef.current && scrollContainerRef.current) selectedLessonRef.current.scrollIntoView({
            behavior: "smooth",
            block: "start"
        });
    }, []);
    (0, $5FkrB.useEffect)(()=>{
        const scrollContainer = scrollContainerRef.current;
        if (scrollContainer) {
            scrollContainer.addEventListener("scroll", handleScroll);
            handleScroll();
            return ()=>{
                scrollContainer.removeEventListener("scroll", handleScroll);
            };
        }
    }, [
        selectedLessonId
    ]);
    /* eslint-enable react-hooks/exhaustive-deps */ return (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("aside", {
        "data-testid": "sidebar",
        css: [
            $24c02ea0e14dbe4f$var$$3d76652bb6362040$var$sidebarStyles,
            !isVisible && $24c02ea0e14dbe4f$var$$3d76652bb6362040$var$sidebarClosedStyles
        ],
        children: [
            isVisible && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                role: "button",
                tabIndex: 0,
                css: $24c02ea0e14dbe4f$var$$3d76652bb6362040$var$closeButtonContainerStyles,
                onClick: onToggleVisibility,
                onKeyDown: (e)=>{
                    if (e.key === "Enter" || e.key === " ") {
                        e.preventDefault();
                        onToggleVisibility?.();
                    }
                },
                children: (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("button", {
                    "data-testid": "sidebar-mobile-close-button",
                    css: $24c02ea0e14dbe4f$var$$3d76652bb6362040$var$closeButtonStyles,
                    children: [
                        (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$f04a61298a47a40f, {
                            type: "cross",
                            color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.icon")
                        }),
                        (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("span", {
                            css: $24c02ea0e14dbe4f$var$$3d76652bb6362040$var$closeButtonTextStyles,
                            children: "Close"
                        })
                    ]
                })
            }),
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("button", {
                "data-testid": "sidebar-toggle-button",
                css: [
                    $24c02ea0e14dbe4f$var$$3d76652bb6362040$var$sidebarButton,
                    isCourse && $24c02ea0e14dbe4f$var$$3d76652bb6362040$var$sidebarButtonForCourseStyles
                ],
                onClick: onToggleVisibility,
                "aria-label": isVisible ? "Collapse sidebar" : "Expand sidebar",
                children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$f04a61298a47a40f, {
                    type: isVisible ? "sidebar-collapse" : "sidebar-expand"
                })
            }),
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$var$$0dbf0b63949b5d22$export$8b251419efc915eb, {
                isCourse: isCourse,
                learningPathSlug: learningPath?.slug,
                courseSlug: courses[0]?.slug,
                title: isCourse ? selectedCourse?.title || "" : learningPath?.title || "",
                completedItems: `${completedEntities}/${totalEntities}`,
                progress: calculateProgress(),
                courseImgUrl: courseImage,
                navigate: navigate
            }),
            (0, $6bec4f26b2cb3094$export$25062201e9e25d76)($24c02ea0e14dbe4f$var$$32c02b5652036d7a$export$d8355e8edbcacbe8, {
                children: [
                    (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                        "data-testid": "sidebar-cards-container",
                        css: [
                            $24c02ea0e14dbe4f$var$$3d76652bb6362040$var$cardsContainerStyles,
                            isCourse && $24c02ea0e14dbe4f$var$$3d76652bb6362040$var$cardsContainerForCourseStyles
                        ],
                        children: [
                            showCurrentLessonButton && selectedLessonId && (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("button", {
                                css: $24c02ea0e14dbe4f$var$$3d76652bb6362040$var$currentLessonStyles,
                                onClick: scrollToSelectedLesson,
                                children: [
                                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$f04a61298a47a40f, {
                                        type: "arrow-up",
                                        color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.icon")
                                    }),
                                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("span", {
                                        css: $24c02ea0e14dbe4f$var$$3d76652bb6362040$var$buttonTextStyles,
                                        children: "Current lesson"
                                    })
                                ]
                            }),
                            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                                css: $24c02ea0e14dbe4f$var$$3d76652bb6362040$var$cardsScrollableContainerStyles,
                                ref: scrollContainerRef,
                                children: isCourse ? (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                                    "data-testid": "sidebar-lesson-container",
                                    css: $24c02ea0e14dbe4f$var$$3d76652bb6362040$var$lessonContainerStyles,
                                    children: lessons.map((lesson)=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                                            ref: $24c02ea0e14dbe4f$var$$48630d5962798e4a$export$15379570ba48f04d("", lesson.slug) ? selectedLessonRef : null,
                                            children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$var$$0ca1c0d89e77a13d$export$951debaed2d5c034, {
                                                isCourse: isCourse,
                                                courseSlug: selectedCourse?.slug,
                                                lesson: lesson,
                                                progressForLesson: progressForLessons?.lessons.find((lessonProgress)=>lessonProgress.lessonId === lesson.sys.id),
                                                onSelect: onSelect,
                                                expandedLessonIds: expandedLessonIds,
                                                isLoading: isLoading,
                                                selectedSectionId: selectedSectionId,
                                                currentLessonSlug: currentLessonSlug
                                            })
                                        }, lesson.sys.id))
                                }) : courses.map((course)=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$var$$aefb4e9d0a694068$export$bb61bd2f4f2a772c, {
                                        course: course,
                                        progressForLessons: progressForLessons,
                                        status: $24c02ea0e14dbe4f$var$$48630d5962798e4a$export$272e7ef3ea22070d(progressForCourses?.courses.find((courseProgress)=>courseProgress.courseId === course.sys.id)?.status),
                                        onSelect: onSelect,
                                        isLoading: isLoading,
                                        selectedLessonRef: selectedLessonRef,
                                        expandedLessonIds: expandedLessonIds,
                                        expandedCourseIds: expandedCourseIds,
                                        selectedSectionId: selectedSectionId,
                                        currentLessonSlug: currentLessonSlug,
                                        scrollContainerRef: scrollContainerRef
                                    }, course.sys.id))
                            })
                        ]
                    }),
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$var$$f50e6e435b887166$export$1671b398b5e36be4, {
                        courses: courses,
                        renderPopup: renderPopup
                    })
                ]
            })
        ]
    });
};
const $24c02ea0e14dbe4f$var$$3d76652bb6362040$var$sidebarStyles = (0, $74Zh5.css)({
    position: "relative",
    display: "flex",
    flexDirection: "column",
    backgroundColor: "#FFFFFF",
    height: "100%",
    width: `${$24c02ea0e14dbe4f$var$$035f8a623e403361$export$780035d9fe48eb32}px`,
    borderRight: `1px solid ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.border")}`,
    transition: "transform 0.3s ease",
    [(0, $cb8cedbc477f5a81$export$987d49ffe1b0900f).below.xs]: {
        width: "100%"
    }
});
const $24c02ea0e14dbe4f$var$$3d76652bb6362040$var$sidebarClosedStyles = (0, $74Zh5.css)({
    transform: "translateX(-412px)",
    [(0, $cb8cedbc477f5a81$export$987d49ffe1b0900f).below.xs]: {
        transform: "translateX(-100%)"
    }
});
const $24c02ea0e14dbe4f$var$$3d76652bb6362040$var$closeButtonContainerStyles = (0, $74Zh5.css)({
    padding: `${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.150")} ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.200")}`,
    [(0, $cb8cedbc477f5a81$export$987d49ffe1b0900f).above.xs]: {
        display: "none"
    }
});
const $24c02ea0e14dbe4f$var$$3d76652bb6362040$var$closeButtonStyles = (0, $74Zh5.css)({
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "#FFFFFF",
    border: "none",
    cursor: "pointer"
});
const $24c02ea0e14dbe4f$var$$3d76652bb6362040$var$closeButtonTextStyles = (0, $74Zh5.css)({
    fontFamily: "Inter, sans-serif",
    fontSize: "14px",
    lineHeight: "20px",
    fontWeight: 400,
    color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text"),
    marginLeft: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.100")
});
const $24c02ea0e14dbe4f$var$$3d76652bb6362040$var$sidebarButton = (0, $74Zh5.css)({
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    position: "absolute",
    width: "32px",
    height: "32px",
    top: "84px",
    right: "calc(-32px - 16px)",
    backgroundColor: "#FFFFFF",
    borderRadius: "3px",
    boxShadow: "0px 0px 1px 0px rgba(9, 30, 66, 0.31), 0px 1px 1px 0px rgba(9, 30, 66, 0.25)",
    padding: 0,
    border: "none",
    cursor: "pointer",
    zIndex: 100,
    "&:hover": {
        backgroundColor: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("elevation.surface.hovered")
    },
    "&:active": {
        backgroundColor: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("elevation.surface.pressed")
    },
    svg: {
        width: "24px",
        height: "24px"
    },
    [(0, $cb8cedbc477f5a81$export$987d49ffe1b0900f).below.xs]: {
        display: "none"
    }
});
const $24c02ea0e14dbe4f$var$$3d76652bb6362040$var$sidebarButtonForCourseStyles = (0, $74Zh5.css)({
    top: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.200")
});
const $24c02ea0e14dbe4f$var$$3d76652bb6362040$var$cardsContainerStyles = (0, $74Zh5.css)({
    position: "relative",
    flex: 1,
    display: "flex",
    flexDirection: "column",
    borderTop: `1px solid ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.border")}`,
    minHeight: 0
});
const $24c02ea0e14dbe4f$var$$3d76652bb6362040$var$cardsContainerForCourseStyles = (0, $74Zh5.css)({
    paddingTop: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.100")
});
const $24c02ea0e14dbe4f$var$$3d76652bb6362040$var$currentLessonStyles = (0, $74Zh5.css)({
    position: "absolute",
    zIndex: 100,
    top: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.100"),
    left: "50%",
    transform: "translateX(-50%)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "#fff",
    border: `1px solid ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.border")}`,
    padding: `${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.100")} ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.200")}`,
    cursor: "pointer",
    width: "fit-content",
    borderRadius: "100px",
    boxShadow: "0px 0px 1px 0px rgba(9, 30, 66, 0.31), 0px 8px 12px 0px rgba(9, 30, 66, 0.15), 0px 0px 0px 1px rgba(188, 214, 240, 0.00) inset"
});
const $24c02ea0e14dbe4f$var$$3d76652bb6362040$var$buttonTextStyles = (0, $74Zh5.css)({
    fontFamily: "Inter, sans-serif",
    fontSize: "16px",
    lineHeight: "24px",
    fontWeight: 400,
    marginLeft: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.050"),
    color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text")
});
const $24c02ea0e14dbe4f$var$$3d76652bb6362040$var$lessonContainerStyles = (0, $74Zh5.css)({
    display: "flex",
    flexDirection: "column",
    gap: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.100")
});
const $24c02ea0e14dbe4f$var$$3d76652bb6362040$var$cardsScrollableContainerStyles = (0, $74Zh5.css)({
    flex: 1,
    overflowY: "auto",
    minHeight: 0
});
var $24c02ea0e14dbe4f$var$$764442aba3de2fce$exports = {};
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$764442aba3de2fce$exports, "VIDEO_CONTROL_TYPES", ()=>$24c02ea0e14dbe4f$export$2ffae0f952561172);
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$764442aba3de2fce$exports, "Video", ()=>$24c02ea0e14dbe4f$export$ae01dedf5c052bb);
// using 'plyr' instead of 'plyr/dist/plyr'
// will start executing DOM APIs right away
// and it breaks SSR
const $24c02ea0e14dbe4f$export$2ffae0f952561172 = [
    "play-small",
    "play",
    "progress",
    "current-time",
    "rewind",
    "fast-forward",
    "mute",
    "volume",
    "settings",
    "fullscreen",
    "seektime"
];
const $24c02ea0e14dbe4f$var$$764442aba3de2fce$var$MOBILE_SCREEN_WIDTH = 480;
const $24c02ea0e14dbe4f$var$$764442aba3de2fce$var$LEARNING_PAGE_CUSTOM_PLAYER_WIDTH = 920;
const $24c02ea0e14dbe4f$var$$764442aba3de2fce$var$ORANGE_LOGIC_CDN_LINK_PATH = "/CDNLink/";
const $24c02ea0e14dbe4f$var$$764442aba3de2fce$var$isOrangeLogicCdnLinkUrl = (videoUrl)=>videoUrl?.includes($24c02ea0e14dbe4f$var$$764442aba3de2fce$var$ORANGE_LOGIC_CDN_LINK_PATH) ?? false;
const $24c02ea0e14dbe4f$export$ae01dedf5c052bb = ({ orangeUrl: orangeUrl, vimeoUrl: vimeoUrl, youtubeUrl: youtubeUrl, captions: captions, chapters: chapters, controls: controls, width: width, height: height, videoId: videoId, name: name, poster: poster = "", onControlClick: onControlClick, onProgressUpdate: onProgressUpdate, onError: onError, customControls: customControls, hasResponsiveControls: hasResponsiveControls, preload: preload = "metadata" })=>{
    const videoRef = (0, $5FkrB.useRef)(null);
    const playerRef = (0, $5FkrB.useRef)(null);
    const mobileControls = (0, $5FkrB.useMemo)(()=>customControls?.customMobileControls ?? [
            ...$24c02ea0e14dbe4f$export$2ffae0f952561172
        ], [
        customControls?.customMobileControls
    ]);
    const desktopControls = (0, $5FkrB.useMemo)(()=>customControls?.customDesktopControls ?? [
            ...$24c02ea0e14dbe4f$export$2ffae0f952561172
        ], [
        customControls?.customDesktopControls
    ]);
    const hasCustomDesktopControls = Boolean(customControls?.customDesktopControls?.length);
    const videoSrc = (0, $5FkrB.useMemo)(()=>orangeUrl || vimeoUrl || youtubeUrl, [
        orangeUrl,
        vimeoUrl,
        youtubeUrl
    ]);
    const playerSource = (0, $5FkrB.useMemo)(()=>({
            type: "video",
            sources: [
                {
                    src: videoSrc
                }
            ],
            tracks: [
                {
                    kind: "captions",
                    label: "English",
                    srcLang: "en",
                    src: captions,
                    default: true
                }
            ]
        }), [
        videoSrc,
        captions
    ]);
    const playerOptions = (0, $5FkrB.useMemo)(()=>({
            invertTime: false,
            tooltips: {
                controls: true,
                seek: true
            },
            controls: desktopControls,
            quality: {
                default: 1080,
                options: [
                    1080,
                    720,
                    576,
                    480,
                    360,
                    240
                ]
            },
            markers: {
                enabled: true,
                points: chapters
            },
            preload: preload
        }), [
        desktopControls,
        chapters,
        preload
    ]);
    const playerOptionsMobile = (0, $5FkrB.useMemo)(()=>({
            invertTime: false,
            tooltips: {
                controls: controls,
                seek: true
            },
            controls: controls ? mobileControls : [],
            quality: {
                default: 1080,
                options: [
                    1080,
                    720,
                    576,
                    480,
                    360,
                    240
                ]
            },
            markers: {
                enabled: true,
                points: chapters
            },
            preload: preload
        }), [
        controls,
        mobileControls,
        chapters,
        preload
    ]);
    const addEvents = (0, $5FkrB.useCallback)((instance)=>{
        instance.once("loadeddata", ()=>{
            const addEvent = (event)=>instance.on(event, ()=>onControlClick && onControlClick(event));
            addEvent("play");
            addEvent("pause");
            addEvent("captionsenabled");
            addEvent("captionsdisabled");
        });
        instance.on("timeupdate", ()=>{
            const currentTime = instance.currentTime;
            const duration = instance.duration;
            const percentage = currentTime / duration * 100;
            onProgressUpdate && onProgressUpdate(+percentage.toFixed(2), name, videoId);
        });
        if (onError) instance.on("error", onError);
    }, [
        onControlClick,
        onProgressUpdate,
        onError,
        name,
        videoId
    ]);
    (0, $5FkrB.useEffect)(()=>{
        // ✅ Destroy old player before creating new one
        const destroyPlayer = ()=>{
            if (playerRef.current) {
                playerRef.current.destroy();
                playerRef.current = null;
            }
        };
        const initializePlayer = ()=>{
            if (!videoRef.current) return;
            destroyPlayer(); // ✅ Clean up first
            const isMobileSize = hasResponsiveControls ? window.innerWidth >= $24c02ea0e14dbe4f$var$$764442aba3de2fce$var$LEARNING_PAGE_CUSTOM_PLAYER_WIDTH : window.innerWidth <= $24c02ea0e14dbe4f$var$$764442aba3de2fce$var$MOBILE_SCREEN_WIDTH;
            const player = new (0, (/*@__PURE__*/$parcel$interopDefault($1c94bc9aa532188d$exports)))(videoRef.current, isMobileSize ? playerOptionsMobile : playerOptions);
            player.source = playerSource;
            player.poster = poster;
            addEvents(player);
            if ($24c02ea0e14dbe4f$var$$764442aba3de2fce$var$isOrangeLogicCdnLinkUrl(orangeUrl) && videoRef.current?.hasAttribute("crossorigin")) {
                // Orange Logic CDNLink URLs can fail CORS checks with crossorigin="anonymous".
                // Removing it restores playback for the original asset.
                videoRef.current.removeAttribute("crossorigin");
                videoRef.current.load();
            }
            playerRef.current = player; // ✅ Store reference
            const plyrVideoContainers = document.getElementsByClassName("plyr--video");
            if (plyrVideoContainers.length) Array.from(plyrVideoContainers).forEach((el)=>el.role = "presentation");
        };
        const handleResize = ()=>{
            initializePlayer();
        };
        window.addEventListener("resize", handleResize);
        initializePlayer();
        return ()=>{
            window.removeEventListener("resize", handleResize);
            destroyPlayer();
        };
    }, [
        hasResponsiveControls,
        playerOptions,
        playerOptionsMobile,
        playerSource,
        poster,
        orangeUrl,
        addEvents
    ]);
    if (videoSrc === vimeoUrl) return (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("iframe", {
        role: "region",
        "aria-label": "Video player",
        title: "video",
        // eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex -- iframe needs tabIndex for keyboard access
        tabIndex: 0,
        css: (0, $74Zh5.css)({
            backgroundColor: "transparent",
            width: "100%",
            aspectRatio: "16 / 9",
            ":focus-visible": {
                border: `2px solid ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.border.selected")}`
            }
        }),
        src: vimeoUrl,
        allowFullScreen: true,
        allow: "autoplay"
    });
    else if (videoSrc === youtubeUrl) return (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("iframe", {
        role: "region",
        "aria-label": "Video player",
        title: "video",
        // eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex -- iframe needs tabIndex for keyboard access
        tabIndex: 0,
        css: (0, $74Zh5.css)({
            backgroundColor: "transparent",
            width: "100%",
            aspectRatio: "16 / 9",
            ":focus-visible": {
                border: `2px solid ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.border.selected")}`
            }
        }),
        src: youtubeUrl,
        allowFullScreen: true,
        allow: "autoplay"
    });
    return (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
        css: [
            $24c02ea0e14dbe4f$var$$764442aba3de2fce$var$videoPlayerStyles,
            hasCustomDesktopControls && $24c02ea0e14dbe4f$var$$764442aba3de2fce$var$unsetVolumeWidthStyles
        ],
        children: (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("video", {
            tabIndex: 0,
            ref: videoRef,
            width: width,
            height: height,
            controls: controls,
            crossOrigin: "anonymous",
            title: "video",
            preload: preload,
            children: [
                (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("source", {
                    src: videoSrc,
                    type: "video/mp4"
                }),
                (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("track", {
                    src: captions,
                    kind: "captions",
                    label: "captions",
                    srcLang: "en",
                    default: true
                })
            ]
        })
    });
};
const $24c02ea0e14dbe4f$var$$764442aba3de2fce$var$videoPlayerStyles = (0, $74Zh5.css)({
    ".plyr__time": {
        fontSize: "12px !important",
        fontWeight: "600 !important"
    },
    "--plyr-color-main": "#1D7AFC",
    "--plyr-badge-background": (0, $54ca2d3948378259$export$7d61b15e0da132af),
    "--plyr-audio-control-color": (0, $54ca2d3948378259$export$7d61b15e0da132af),
    "--plyr-menu-color": (0, $54ca2d3948378259$export$7d61b15e0da132af),
    "--plyr-menu-item-arrow-color": "#758195",
    "--plyr-menu-border-color": "#DCDFE4",
    "--plyr-tooltip-color": (0, $54ca2d3948378259$export$7d61b15e0da132af),
    ":focus-visible": {
        border: `2px solid ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.border.selected")}`
    }
});
const $24c02ea0e14dbe4f$var$$764442aba3de2fce$var$unsetVolumeWidthStyles = (0, $74Zh5.css)({
    ".plyr__controls__item.plyr__volume": {
        minWidth: "unset !important",
        width: "unset !important"
    }
});
var $24c02ea0e14dbe4f$var$$77282b3961d82199$exports = {};
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$77282b3961d82199$exports, "Columns", ()=>$24c02ea0e14dbe4f$export$f02cc02ad0e0bba3);
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$77282b3961d82199$exports, "LessonColumns", ()=>$24c02ea0e14dbe4f$export$2dde675552f76fc5);
let $24c02ea0e14dbe4f$export$f02cc02ad0e0bba3;
(function(Columns) {
    Columns["TWO"] = "two";
    Columns["THREE"] = "three";
    Columns["FOUR"] = "four";
})($24c02ea0e14dbe4f$export$f02cc02ad0e0bba3 || ($24c02ea0e14dbe4f$export$f02cc02ad0e0bba3 = {}));
const $24c02ea0e14dbe4f$export$2dde675552f76fc5 = ({ columns: columns = $24c02ea0e14dbe4f$export$f02cc02ad0e0bba3.TWO, children: children })=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("section", {
        css: $24c02ea0e14dbe4f$var$$77282b3961d82199$var$sectionStyles,
        children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
            "data-testid": "lesson-columns",
            css: [
                $24c02ea0e14dbe4f$var$$77282b3961d82199$var$lessonColumnsStyles,
                $24c02ea0e14dbe4f$var$$77282b3961d82199$var$lessonColumnsMDStyles[columns]
            ],
            children: children
        })
    });
const $24c02ea0e14dbe4f$var$$77282b3961d82199$var$sectionStyles = (0, $74Zh5.css)({
    textOverflow: "ellipsis",
    marginTop: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.400"),
    marginBottom: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.400"),
    [(0, $cb8cedbc477f5a81$export$987d49ffe1b0900f).above.lg]: {
        textOverflow: "clip"
    }
});
const $24c02ea0e14dbe4f$var$$77282b3961d82199$var$lessonColumnsStyles = (0, $74Zh5.css)({
    display: "grid",
    columnGap: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.100"),
    gridTemplateColumns: "repeat(1, minmax(0, 1fr))",
    fontSize: "16px",
    [(0, $cb8cedbc477f5a81$export$987d49ffe1b0900f).above.xs]: {
        gridTemplateColumns: "repeat(2, minmax(0, 1fr))"
    }
});
const $24c02ea0e14dbe4f$var$$77282b3961d82199$var$lessonColumnsMDStyles = {
    [$24c02ea0e14dbe4f$export$f02cc02ad0e0bba3.TWO]: (0, $74Zh5.css)({
        [(0, $cb8cedbc477f5a81$export$987d49ffe1b0900f).above.sm]: {
            gridTemplateColumns: "repeat(2, minmax(0, 1fr))"
        }
    }),
    [$24c02ea0e14dbe4f$export$f02cc02ad0e0bba3.THREE]: (0, $74Zh5.css)({
        [(0, $cb8cedbc477f5a81$export$987d49ffe1b0900f).above.sm]: {
            gridTemplateColumns: "repeat(3, minmax(0, 1fr))"
        }
    }),
    [$24c02ea0e14dbe4f$export$f02cc02ad0e0bba3.FOUR]: (0, $74Zh5.css)({
        [(0, $cb8cedbc477f5a81$export$987d49ffe1b0900f).above.sm]: {
            gridTemplateColumns: "repeat(4, minmax(0, 1fr))"
        }
    })
};
var $24c02ea0e14dbe4f$var$$4c35f7fd4ad5f13f$exports = {};
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$4c35f7fd4ad5f13f$exports, "LearningCourseCard", ()=>$24c02ea0e14dbe4f$export$5ae3342de8088f07);
const $24c02ea0e14dbe4f$export$5ae3342de8088f07 = ({ inspectMode: inspectMode, title: title, imageUrl: imageUrl, onClick: onClick, link: link, minHeight: minHeight = 153, learningProgress: learningProgress, onGeneratePdf: onGeneratePdf, shouldDisplayShowMoreButton: shouldDisplayShowMoreButton, shouldDisplayBookmark: shouldDisplayBookmark, onViewUpdates: onViewUpdates, onUpdatedButtonClick: onUpdatedButtonClick, isUpdated: isUpdated, areHistoricalNotifications: areHistoricalNotifications })=>{
    const cardRef = (0, $5FkrB.useRef)(null);
    const onClickHandler = (0, $5FkrB.useCallback)(()=>{
        onClick && onClick();
    }, [
        onClick
    ]);
    const handleUpdatedButtonClick = (0, $5FkrB.useCallback)((event)=>{
        event.stopPropagation();
        event.preventDefault();
        onUpdatedButtonClick && onUpdatedButtonClick();
    }, [
        onUpdatedButtonClick
    ]);
    const onKeyDown = $24c02ea0e14dbe4f$export$2a0b6757d41dacb2(onClickHandler);
    const handleSave = (event)=>{
        if (learningProgress) {
            event.stopPropagation();
            event.preventDefault();
            learningProgress.onSave(!learningProgress.isSaved);
        }
    };
    const isSaved = learningProgress?.completedResources === learningProgress?.resourceCount || learningProgress?.isSaved;
    return (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("a", {
        href: link,
        css: $24c02ea0e14dbe4f$var$$4c35f7fd4ad5f13f$var$linkContainerStyles,
        rel: "noopener noreferrer",
        onClick: (e)=>e.preventDefault(),
        children: (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
            role: "button",
            ref: cardRef,
            css: $24c02ea0e14dbe4f$var$$4c35f7fd4ad5f13f$var$learningCourseCardContainerStyles,
            onClick: onClickHandler,
            onKeyDown: onKeyDown,
            tabIndex: 0,
            "data-testid": "learning-course-card",
            style: {
                minHeight: `${minHeight}px`
            },
            children: [
                (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                    css: $24c02ea0e14dbe4f$var$$4c35f7fd4ad5f13f$var$bodyContainerStyles,
                    children: [
                        (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                            css: $24c02ea0e14dbe4f$var$$4c35f7fd4ad5f13f$var$imageContainerStyles,
                            children: imageUrl ? (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("img", {
                                css: [
                                    $24c02ea0e14dbe4f$var$$4c35f7fd4ad5f13f$var$imageStyles
                                ],
                                "data-testid": "learning-course-card-image",
                                src: imageUrl,
                                alt: "course-img"
                            }) : (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                                "data-testid": "learning-course-card-no-image",
                                css: $24c02ea0e14dbe4f$var$$4c35f7fd4ad5f13f$var$noImageStyles
                            })
                        }),
                        (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                            css: $24c02ea0e14dbe4f$var$$4c35f7fd4ad5f13f$var$titleAndDetailsContainerStyles,
                            children: title && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("p", {
                                "data-testid": "title",
                                ...$24c02ea0e14dbe4f$export$1784ac302bd8ebad("title", inspectMode),
                                css: $24c02ea0e14dbe4f$var$$4c35f7fd4ad5f13f$var$titleStyles,
                                children: title
                            })
                        })
                    ]
                }),
                learningProgress && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                    css: $24c02ea0e14dbe4f$var$$4c35f7fd4ad5f13f$var$learningCourseCardProgressContainerStyles,
                    "data-testid": "learning-course-card-progress-content",
                    children: (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                        css: $24c02ea0e14dbe4f$var$$4c35f7fd4ad5f13f$var$learningCourseCardProgressItemsContainerStyles,
                        children: [
                            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$184a993f673fc83f, {
                                wasPreviouslyCompleted: learningProgress.status === $24c02ea0e14dbe4f$var$$035f8a623e403361$export$23d03d0b3065d061.COMPLETED,
                                completedResources: learningProgress.completedResources,
                                resourceCount: learningProgress.resourceCount,
                                completionDate: learningProgress.completionDate,
                                contentType: $24c02ea0e14dbe4f$export$e2e108cbe2e4f865.COURSE
                            }),
                            (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                                css: $24c02ea0e14dbe4f$var$$4c35f7fd4ad5f13f$var$learningCourseCardIconsContainerStyles,
                                children: [
                                    isUpdated && learningProgress.status !== $24c02ea0e14dbe4f$var$$035f8a623e403361$export$23d03d0b3065d061.NOT_STARTED && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                                        "data-testid": "updated-icon",
                                        css: $24c02ea0e14dbe4f$var$$4c35f7fd4ad5f13f$var$updatedIconContainerStyles,
                                        children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$353f5b6fc5456de1, {
                                            label: "Updated",
                                            iconBefore: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$f04a61298a47a40f, {
                                                type: "editor-panel"
                                            }),
                                            onClick: handleUpdatedButtonClick
                                        })
                                    }),
                                    shouldDisplayShowMoreButton && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$ca7697601dcd7803, {
                                        cardRef: cardRef,
                                        shareOnPdf: true,
                                        onGeneratePdf: onGeneratePdf,
                                        areHistoricalNotifications: areHistoricalNotifications,
                                        onViewUpdates: onViewUpdates
                                    }),
                                    shouldDisplayBookmark && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("button", {
                                        "data-testid": "save-content",
                                        css: $24c02ea0e14dbe4f$var$$4c35f7fd4ad5f13f$var$learningCourseCardBookmarkContainerStyles,
                                        onClick: handleSave,
                                        children: isSaved ? (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$f04a61298a47a40f, {
                                            type: "bookmark-filled"
                                        }) : (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$f04a61298a47a40f, {
                                            type: "bookmark"
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                })
            ]
        })
    });
};
const $24c02ea0e14dbe4f$var$$4c35f7fd4ad5f13f$var$learningCourseCardContainerStyles = (0, $74Zh5.css)({
    display: "flex",
    flexDirection: "column",
    backgroundColor: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.background.input"),
    borderRadius: "8px",
    border: `1px solid ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.border")}`,
    boxShadow: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("elevation.shadow.raised"),
    transition: "box-shadow 0.3s ease-in-out",
    cursor: "pointer",
    width: "100%",
    height: "153px",
    "&:hover": {
        boxShadow: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("elevation.shadow.overlay")
    },
    "&:active": {
        outline: `1px solid ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.border.focused")}`,
        border: `1px solid ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.border.focused")}`
    }
});
const $24c02ea0e14dbe4f$var$$4c35f7fd4ad5f13f$var$bodyContainerStyles = (0, $74Zh5.css)({
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    padding: `${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.200")} ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.300")} ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.200")} ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.075")}`,
    gap: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.200"),
    minHeight: "96px",
    justifyContent: "flex-end",
    "@media (max-width: 1279px)": {
        justifyContent: "flex-start",
        padding: `${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.050")} ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.050")} ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.050")} ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.200")}`
    }
});
const $24c02ea0e14dbe4f$var$$4c35f7fd4ad5f13f$var$linkContainerStyles = (0, $74Zh5.css)({
    textDecoration: "none",
    "&:hover": {
        textDecoration: "none"
    }
});
const $24c02ea0e14dbe4f$var$$4c35f7fd4ad5f13f$var$imageContainerStyles = (0, $74Zh5.css)({
    display: "flex",
    width: "64px",
    height: "64px",
    justifyContent: "center",
    alignItems: "center",
    flexShrink: 0
});
const $24c02ea0e14dbe4f$var$$4c35f7fd4ad5f13f$var$imageStyles = (0, $74Zh5.css)({
    width: "100%",
    height: "100%",
    objectFit: "cover",
    borderRadius: "50%"
});
const $24c02ea0e14dbe4f$var$$4c35f7fd4ad5f13f$var$noImageStyles = (0, $74Zh5.css)({
    background: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.background.accent.gray.subtlest"),
    width: "64px",
    height: "64px",
    borderRadius: "50%"
});
const $24c02ea0e14dbe4f$var$$4c35f7fd4ad5f13f$var$titleAndDetailsContainerStyles = (0, $74Zh5.css)({
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    width: "275px",
    "@media (max-width: 1279px)": {
        width: "232px",
        flexGrow: 1,
        padding: `${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.300")} ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.200")} ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.300")} ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.0")}`
    }
});
const $24c02ea0e14dbe4f$var$$4c35f7fd4ad5f13f$var$learningCourseCardProgressContainerStyles = (0, $74Zh5.css)({
    borderTop: `1px solid ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.border")}`
});
const $24c02ea0e14dbe4f$var$$4c35f7fd4ad5f13f$var$learningCourseCardProgressItemsContainerStyles = (0, $74Zh5.css)({
    display: "flex",
    justifyContent: "space-between",
    padding: `${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.200")} ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.300")}`
});
const $24c02ea0e14dbe4f$var$$4c35f7fd4ad5f13f$var$learningCourseCardIconsContainerStyles = (0, $74Zh5.css)({
    display: "flex",
    alignItems: "center",
    gap: "5px"
});
const $24c02ea0e14dbe4f$var$$4c35f7fd4ad5f13f$var$learningCourseCardBookmarkContainerStyles = (0, $74Zh5.css)({
    height: "24px",
    border: "none",
    background: "none",
    cursor: "pointer",
    outline: "none",
    "&:focus-visible": {
        outline: `2px solid ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.border.selected")}`
    }
});
const $24c02ea0e14dbe4f$var$$4c35f7fd4ad5f13f$var$titleStyles = (0, $74Zh5.css)({
    display: "-webkit-box",
    WebkitBoxOrient: "vertical",
    WebkitLineClamp: 2,
    overflow: "hidden",
    textOverflow: "ellipsis",
    marginTop: "20px",
    marginBottom: 0,
    fontFamily: "Inter",
    fontSize: "16px",
    fontWeight: 400,
    fontStyle: "normal",
    lineHeight: "24px",
    color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text")
});
const $24c02ea0e14dbe4f$var$$4c35f7fd4ad5f13f$var$updatedIconContainerStyles = (0, $74Zh5.css)({
    display: "flex",
    alignItems: "center",
    gap: "5px",
    button: {
        backgroundColor: "transparent",
        height: "auto",
        minHeight: "auto",
        alignItems: "center",
        ":hover": {
            backgroundColor: "transparent"
        }
    },
    span: {
        color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text.selected"),
        fontFamily: "SF Pro, sans-serif",
        fontSize: "14px",
        lineHeight: "20px"
    }
});
var $24c02ea0e14dbe4f$var$$27d686e47ff412fd$exports = {};
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$27d686e47ff412fd$exports, "FeedbackHeader", ()=>$24c02ea0e14dbe4f$export$41cd510048068b0c);
const $24c02ea0e14dbe4f$export$41cd510048068b0c = ({ heading: heading, duration: duration, description: description })=>(0, $6bec4f26b2cb3094$export$25062201e9e25d76)("section", {
        "aria-labelledby": "feedback-header",
        children: [
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                css: $24c02ea0e14dbe4f$var$$27d686e47ff412fd$var$headingWrapperStyles,
                children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("h1", {
                    css: $24c02ea0e14dbe4f$var$$27d686e47ff412fd$var$headingStyles,
                    id: "feedback-header",
                    children: heading
                })
            }),
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                css: $24c02ea0e14dbe4f$var$$27d686e47ff412fd$var$metadataStyles,
                children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                    css: $24c02ea0e14dbe4f$var$$27d686e47ff412fd$var$flexContainerStyles,
                    children: (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                        css: (0, $74Zh5.css)({
                            display: "flex"
                        }),
                        children: [
                            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                                css: $24c02ea0e14dbe4f$var$$27d686e47ff412fd$var$tagStyles,
                                children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$3288d34c523a1192, {
                                    label: duration
                                })
                            }),
                            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                                css: $24c02ea0e14dbe4f$var$$27d686e47ff412fd$var$tagStyles,
                                children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$3288d34c523a1192, {
                                    label: "survey"
                                })
                            })
                        ]
                    })
                })
            }),
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                css: $24c02ea0e14dbe4f$var$$27d686e47ff412fd$var$lineWrapperStyles,
                children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$2e0a83ec2e27ecbb, {
                    color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.border")
                })
            }),
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                css: $24c02ea0e14dbe4f$var$$27d686e47ff412fd$var$descriptionStyles,
                children: description
            })
        ]
    });
const $24c02ea0e14dbe4f$var$$27d686e47ff412fd$var$metadataStyles = (0, $74Zh5.css)({
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between"
});
const $24c02ea0e14dbe4f$var$$27d686e47ff412fd$var$flexContainerStyles = (0, $74Zh5.css)({
    display: "flex"
});
const $24c02ea0e14dbe4f$var$$27d686e47ff412fd$var$tagStyles = (0, $74Zh5.css)({
    marginRight: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.100")
});
const $24c02ea0e14dbe4f$var$$27d686e47ff412fd$var$lineWrapperStyles = (0, $74Zh5.css)({
    padding: `${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.300")} 0 ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.500")} 0`
});
const $24c02ea0e14dbe4f$var$$27d686e47ff412fd$var$headingWrapperStyles = (0, $74Zh5.css)({
    padding: `${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.1000")} 0 ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.300")} 0`
});
const $24c02ea0e14dbe4f$var$$27d686e47ff412fd$var$headingStyles = (0, $74Zh5.css)({
    color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text"),
    fontFamily: "Charlie Display, sans-serif",
    fontSize: "61.333px",
    fontStyle: "normal",
    fontWeight: 600,
    lineHeight: "81.778px"
});
const $24c02ea0e14dbe4f$var$$27d686e47ff412fd$var$descriptionStyles = (0, $74Zh5.css)({
    paddingBottom: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.1000"),
    fontFamily: "Inter, sans-serif",
    fontSize: "20px",
    lineHeight: "32px",
    color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text"),
    p: {
        margin: 0
    }
});
var $24c02ea0e14dbe4f$var$$a4deb03146bf3bfc$exports = {};
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$a4deb03146bf3bfc$exports, "ReportIssueModal", ()=>$24c02ea0e14dbe4f$export$448811829c5d1992);
let $24c02ea0e14dbe4f$var$$a4deb03146bf3bfc$var$DialogWidth;
(function(DialogWidth) {
    DialogWidth["SMALL"] = "small";
    DialogWidth["MEDIUM"] = "medium";
    DialogWidth["LARGE"] = "large";
    DialogWidth["XLARGE"] = "x-large";
})($24c02ea0e14dbe4f$var$$a4deb03146bf3bfc$var$DialogWidth || ($24c02ea0e14dbe4f$var$$a4deb03146bf3bfc$var$DialogWidth = {}));
const $24c02ea0e14dbe4f$export$448811829c5d1992 = ({ isParticipatingInResearch: isParticipatingInResearch, consentToContact: consentToContact, selectValue: selectValue, textAreaValues: textAreaValues, heading: heading, width: width = $24c02ea0e14dbe4f$var$$a4deb03146bf3bfc$var$DialogWidth.LARGE, options: options, isDisabled: isDisabled, closeModal: closeModal, submit: submit, onSelectChange: onSelectChange, onTextChange: onTextChange, onParticipatingInResearch: onParticipatingInResearch, onConsentToContact: onConsentToContact })=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $73c4314b1cf0d4b0$export$2e2bcd8739ae039), {
        onClose: closeModal,
        width: width,
        children: (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
            css: $24c02ea0e14dbe4f$var$$a4deb03146bf3bfc$var$modalContainerStyles,
            children: [
                (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                    css: $24c02ea0e14dbe4f$var$$a4deb03146bf3bfc$var$modalBodyStyles,
                    children: [
                        (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("p", {
                            "data-testid": "modal-heading",
                            css: $24c02ea0e14dbe4f$var$$a4deb03146bf3bfc$var$modalHeadingContainerStyles,
                            children: heading
                        }),
                        (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("p", {
                            css: $24c02ea0e14dbe4f$var$$a4deb03146bf3bfc$var$requiredFieldsStyles,
                            children: [
                                "Required fields are marked with an asterisk",
                                " ",
                                (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("span", {
                                    css: [
                                        $24c02ea0e14dbe4f$var$$a4deb03146bf3bfc$var$requiredFieldsStyles,
                                        (0, $74Zh5.css)({
                                            color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text.accent.red")
                                        })
                                    ],
                                    children: "*"
                                })
                            ]
                        }),
                        (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                            css: (0, $74Zh5.css)({
                                marginBottom: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.050")
                            }),
                            children: (0, $6bec4f26b2cb3094$export$25062201e9e25d76)((0, $5ac1013239c7eb7f$export$b04be29aa201d4f5), {
                                htmlFor: "problem-to-report",
                                children: [
                                    "What problem would you like to report? ",
                                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("span", {
                                        css: (0, $74Zh5.css)({
                                            color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text.accent.red")
                                        }),
                                        children: "*"
                                    })
                                ]
                            })
                        }),
                        (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                            css: $24c02ea0e14dbe4f$var$$a4deb03146bf3bfc$var$selectContainerStyles,
                            children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $6b35e1e8c8ac06e7$export$2e2bcd8739ae039), {
                                inputId: "problem-to-report",
                                options: options,
                                value: selectValue,
                                onChange: (e)=>onSelectChange(e),
                                placeholder: "Select problem"
                            })
                        }),
                        selectValue && (0, $6bec4f26b2cb3094$export$25062201e9e25d76)((0, $6bec4f26b2cb3094$export$ffb0004e005737fa), {
                            children: [
                                (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                                    css: (0, $74Zh5.css)({
                                        marginBottom: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.050")
                                    }),
                                    children: (0, $6bec4f26b2cb3094$export$25062201e9e25d76)((0, $5ac1013239c7eb7f$export$b04be29aa201d4f5), {
                                        htmlFor: "problem-to-report",
                                        children: [
                                            "Provide any other details ",
                                            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("span", {
                                                css: (0, $74Zh5.css)({
                                                    color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text.accent.red")
                                                }),
                                                children: "*"
                                            })
                                        ]
                                    })
                                }),
                                (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                                    css: $24c02ea0e14dbe4f$var$$a4deb03146bf3bfc$var$detailsStyles,
                                    children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $195b49e60159a439$export$2e2bcd8739ae039), {
                                        maxHeight: "156px",
                                        placeholder: "Start typing...",
                                        onChange: onTextChange,
                                        value: textAreaValues
                                    })
                                }),
                                (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                                    css: (0, $74Zh5.css)({
                                        marginBottom: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.100")
                                    }),
                                    children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$48513f6b9f8ce62d, {
                                        label: "I'd like to participate in product research",
                                        onChange: onParticipatingInResearch,
                                        isChecked: isParticipatingInResearch
                                    })
                                }),
                                (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                                    css: $24c02ea0e14dbe4f$var$$a4deb03146bf3bfc$var$policyContainerStyles,
                                    children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$48513f6b9f8ce62d, {
                                        label: (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("span", {
                                            children: [
                                                "Yes, Atlassian teams can contact me to learn about my experiences to improve Atlassian products and services. I acknowledge the Atlassian Privacy Policy",
                                                (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$a6c7ac8248d6e38a, {
                                                    label: "Atlassian Privacy Policy.",
                                                    target: "_blank",
                                                    link: "https://www.atlassian.com/legal/privacy-policy#what-this-policy-covers",
                                                    onClick: ()=>{
                                                        window.open("https://www.atlassian.com/legal/privacy-policy#what-this-policy-covers", "_blank", "noopener");
                                                    }
                                                })
                                            ]
                                        }),
                                        onChange: onConsentToContact,
                                        isChecked: consentToContact
                                    })
                                })
                            ]
                        })
                    ]
                }),
                (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("span", {
                    css: $24c02ea0e14dbe4f$var$$a4deb03146bf3bfc$var$modalCloseButtonStyles,
                    children: [
                        (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                            css: $24c02ea0e14dbe4f$var$$a4deb03146bf3bfc$var$customButtonWrapperStyles,
                            children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $123ba5aab151a241$export$2e2bcd8739ae039), {
                                appearance: $24c02ea0e14dbe4f$export$261c9483fc4a455a.SUBTLE,
                                onClick: closeModal,
                                children: "Cancel"
                            })
                        }),
                        (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$353f5b6fc5456de1, {
                            label: "Submit",
                            appearance: $24c02ea0e14dbe4f$export$261c9483fc4a455a.PRIMARY,
                            disabled: isDisabled,
                            onClick: submit
                        })
                    ]
                })
            ]
        })
    });
const $24c02ea0e14dbe4f$var$$a4deb03146bf3bfc$var$modalContainerStyles = (0, $74Zh5.css)({
    padding: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.300"),
    [(0, $cb8cedbc477f5a81$export$987d49ffe1b0900f).below.sm]: {
        padding: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.200")
    }
});
const $24c02ea0e14dbe4f$var$$a4deb03146bf3bfc$var$modalHeadingContainerStyles = (0, $74Zh5.css)({
    fontFamily: "Charlie Display, sans-serif",
    fontSize: "24px",
    fontWeight: 600,
    lineHeight: "32px"
});
const $24c02ea0e14dbe4f$var$$a4deb03146bf3bfc$var$requiredFieldsStyles = (0, $74Zh5.css)({
    color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text.subtlest"),
    fontFamily: "Inter, sans-serif",
    fontSize: "16px",
    fontWeight: 400,
    lineHeight: "24px",
    marginBottom: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.300")
});
const $24c02ea0e14dbe4f$var$$a4deb03146bf3bfc$var$selectContainerStyles = (0, $74Zh5.css)({
    width: "100%",
    maxWidth: "420px",
    marginBottom: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.300")
});
const $24c02ea0e14dbe4f$var$$a4deb03146bf3bfc$var$detailsStyles = (0, $74Zh5.css)({
    width: "100%",
    marginBottom: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.300")
});
const $24c02ea0e14dbe4f$var$$a4deb03146bf3bfc$var$modalCloseButtonStyles = (0, $74Zh5.css)({
    display: "flex",
    justifyContent: "flex-end",
    [(0, $cb8cedbc477f5a81$export$987d49ffe1b0900f).below.sm]: {
        padding: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.100")
    }
});
const $24c02ea0e14dbe4f$var$$a4deb03146bf3bfc$var$modalBodyStyles = (0, $74Zh5.css)({
    maxWidth: "640px",
    width: "100%",
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    margin: `${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.200")} auto 0`,
    [(0, $cb8cedbc477f5a81$export$987d49ffe1b0900f).below.sm]: {
        marginTop: 0
    }
});
const $24c02ea0e14dbe4f$var$$a4deb03146bf3bfc$var$customButtonWrapperStyles = (0, $74Zh5.css)({
    marginRight: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.100"),
    button: {
        height: "100%",
        color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text"),
        fontSize: "16px",
        lineHeight: "20px",
        padding: `10px ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.150")}`,
        fontWeight: 600
    }
});
const $24c02ea0e14dbe4f$var$$a4deb03146bf3bfc$var$policyContainerStyles = (0, $74Zh5.css)({
    display: "flex",
    a: {
        marginLeft: "5px"
    }
});
var $24c02ea0e14dbe4f$var$$0ae392c3008c8a3e$exports = {};
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$0ae392c3008c8a3e$exports, "FlatContentCardStyle", ()=>$24c02ea0e14dbe4f$export$f2adaabc3a0295ef);
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$0ae392c3008c8a3e$exports, "FlatContentCardType", ()=>$24c02ea0e14dbe4f$export$8023ea0baf29b8db);
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$0ae392c3008c8a3e$exports, "FlatContentCard", ()=>$24c02ea0e14dbe4f$export$bc8a9d98c2eabbb7);
let $24c02ea0e14dbe4f$export$f2adaabc3a0295ef;
(function(FlatContentCardStyle) {
    FlatContentCardStyle["TALL"] = "tall";
    FlatContentCardStyle["FULL"] = "full";
})($24c02ea0e14dbe4f$export$f2adaabc3a0295ef || ($24c02ea0e14dbe4f$export$f2adaabc3a0295ef = {}));
let $24c02ea0e14dbe4f$export$8023ea0baf29b8db;
(function(FlatContentCardType) {
    FlatContentCardType["ROUND"] = "round";
    FlatContentCardType["SQUARE"] = "square";
    FlatContentCardType["RECTANGLE"] = "rectangle";
    FlatContentCardType["FLEXIBLE"] = "flexible";
})($24c02ea0e14dbe4f$export$8023ea0baf29b8db || ($24c02ea0e14dbe4f$export$8023ea0baf29b8db = {}));
const $24c02ea0e14dbe4f$export$bc8a9d98c2eabbb7 = ({ image: image, title: title, text: text, link: link, linkLabel: linkLabel = "Learn more", style: style = $24c02ea0e14dbe4f$export$f2adaabc3a0295ef.TALL, type: type = $24c02ea0e14dbe4f$export$8023ea0baf29b8db.ROUND, headingLevel: headingLevel, bgColor: bgColor = "initial", onClick: onClick, target: target = "_self", maxWidth: maxWidth, minHeight: minHeight, withElevationBorder: withElevationBorder = false })=>{
    const isSquareOrRectangle = type === $24c02ea0e14dbe4f$export$8023ea0baf29b8db.SQUARE || type === $24c02ea0e14dbe4f$export$8023ea0baf29b8db.RECTANGLE;
    const isFlexible = type === $24c02ea0e14dbe4f$export$8023ea0baf29b8db.FLEXIBLE;
    const roundStyles = image ? $24c02ea0e14dbe4f$var$$0ae392c3008c8a3e$var$variantStyles[style].container.withImage : $24c02ea0e14dbe4f$var$$0ae392c3008c8a3e$var$variantStyles[style].container.withoutImage;
    const additionalContainerStyles = isSquareOrRectangle ? $24c02ea0e14dbe4f$var$$0ae392c3008c8a3e$var$squareTypeStyles.container : isFlexible ? $24c02ea0e14dbe4f$var$$0ae392c3008c8a3e$var$flexibleContainerStyles : roundStyles;
    const defaultHeadingLevel = isSquareOrRectangle ? 3 : 4;
    const rectangleStyles = type === $24c02ea0e14dbe4f$export$8023ea0baf29b8db.RECTANGLE && $24c02ea0e14dbe4f$var$$0ae392c3008c8a3e$var$variantStyles[$24c02ea0e14dbe4f$export$f2adaabc3a0295ef.TALL].container.withImage;
    const handleClick = (title)=>{
        onClick && onClick(title);
    };
    return (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
        css: [
            $24c02ea0e14dbe4f$var$$0ae392c3008c8a3e$var$containerStyles,
            additionalContainerStyles,
            rectangleStyles,
            (0, $74Zh5.css)({
                backgroundColor: bgColor
            }),
            maxWidth && (0, $74Zh5.css)({
                maxWidth: maxWidth
            }),
            isFlexible && minHeight && (0, $74Zh5.css)({
                minHeight: minHeight
            }),
            withElevationBorder && $24c02ea0e14dbe4f$var$$0ae392c3008c8a3e$var$elevationBorderStyles
        ],
        "data-testid": "learn-more-card",
        children: [
            image && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("img", {
                src: image.src,
                alt: image.alt,
                width: isFlexible && image.width ? image.width : undefined,
                height: isFlexible && image.height ? image.height : undefined,
                css: [
                    $24c02ea0e14dbe4f$var$$0ae392c3008c8a3e$var$imageBaseStyles,
                    (isSquareOrRectangle || isFlexible) && $24c02ea0e14dbe4f$var$$0ae392c3008c8a3e$var$imageSquareStyles,
                    isFlexible && $24c02ea0e14dbe4f$var$$0ae392c3008c8a3e$var$imageFlexibleStyles,
                    isFlexible && image.width && image.height && (0, $74Zh5.css)({
                        width: `${image.width}px`,
                        height: `${image.height}px`
                    }),
                    style === $24c02ea0e14dbe4f$export$f2adaabc3a0295ef.FULL && $24c02ea0e14dbe4f$var$$0ae392c3008c8a3e$var$fullStyleImageStyles
                ]
            }),
            (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                css: [
                    $24c02ea0e14dbe4f$var$$0ae392c3008c8a3e$var$contentContainerStyles,
                    isSquareOrRectangle && $24c02ea0e14dbe4f$var$$0ae392c3008c8a3e$var$contentContainerSquareStyles
                ],
                children: [
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                        css: (0, $74Zh5.css)([
                            $24c02ea0e14dbe4f$var$$0ae392c3008c8a3e$var$textStyles,
                            type === $24c02ea0e14dbe4f$export$8023ea0baf29b8db.ROUND && $24c02ea0e14dbe4f$var$$0ae392c3008c8a3e$var$variantStyles[style].heading,
                            isSquareOrRectangle && $24c02ea0e14dbe4f$var$$0ae392c3008c8a3e$var$squareTypeStyles.heading,
                            isFlexible && $24c02ea0e14dbe4f$var$$0ae392c3008c8a3e$var$variantStyles[style].heading
                        ]),
                        children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$a8a3e93435678ff9, {
                            level: headingLevel || defaultHeadingLevel,
                            fontWeight: 600,
                            children: title
                        })
                    }),
                    (type === $24c02ea0e14dbe4f$export$8023ea0baf29b8db.ROUND || type === $24c02ea0e14dbe4f$export$8023ea0baf29b8db.RECTANGLE || isFlexible) && text && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                        css: [
                            (0, $74Zh5.css)([
                                $24c02ea0e14dbe4f$var$$0ae392c3008c8a3e$var$textStyles,
                                $24c02ea0e14dbe4f$var$$0ae392c3008c8a3e$var$variantStyles[style].text,
                                $24c02ea0e14dbe4f$var$$0ae392c3008c8a3e$var$textContainerStyles
                            ])
                        ],
                        children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$5f1af8db9871e1d6, {
                            children: text
                        })
                    }),
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$a6c7ac8248d6e38a, {
                        label: linkLabel,
                        link: link,
                        onClick: ()=>handleClick(title),
                        icon: "arrow-right",
                        fontColor: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text.brand"),
                        style: $24c02ea0e14dbe4f$export$2b77966d73aefa77.SEMIBOLD,
                        size: $24c02ea0e14dbe4f$export$be4c932f76c19adf.LARGE,
                        target: target
                    })
                ]
            })
        ]
    });
};
const $24c02ea0e14dbe4f$var$$0ae392c3008c8a3e$var$containerStyles = (0, $74Zh5.css)({
    width: "100%",
    display: "flex",
    flexDirection: "column",
    alignItems: "start",
    padding: `${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.400")} 0`,
    [(0, $cb8cedbc477f5a81$export$987d49ffe1b0900f).below.sm]: {
        padding: `${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.300")} 0`
    }
});
const $24c02ea0e14dbe4f$var$$0ae392c3008c8a3e$var$elevationBorderStyles = (0, $74Zh5.css)({
    border: `1px solid ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.border")}`,
    borderRadius: "8px",
    boxShadow: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("elevation.shadow.raised"),
    transition: "box-shadow 0.3s ease-in-out",
    "&:hover": {
        boxShadow: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("elevation.shadow.overlay")
    }
});
const $24c02ea0e14dbe4f$var$$0ae392c3008c8a3e$var$textStyles = (0, $74Zh5.css)({
    [(0, $cb8cedbc477f5a81$export$987d49ffe1b0900f).above.md]: {
        display: "-webkit-box",
        WebkitBoxOrient: "vertical",
        overflow: "hidden",
        textOverflow: "ellipsis"
    }
});
const $24c02ea0e14dbe4f$var$$0ae392c3008c8a3e$var$imageBaseStyles = (0, $74Zh5.css)({
    height: "80px",
    width: "80px",
    objectFit: "contain",
    borderRadius: "50%",
    marginBottom: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.200"),
    maxWidth: "100%"
});
const $24c02ea0e14dbe4f$var$$0ae392c3008c8a3e$var$imageSquareStyles = (0, $74Zh5.css)({
    borderRadius: 0,
    marginBottom: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.300")
});
const $24c02ea0e14dbe4f$var$$0ae392c3008c8a3e$var$imageFlexibleStyles = (0, $74Zh5.css)({
    maxWidth: "100%",
    objectFit: "contain"
});
const $24c02ea0e14dbe4f$var$$0ae392c3008c8a3e$var$fullStyleImageStyles = (0, $74Zh5.css)({
    width: "100%",
    height: "auto",
    maxHeight: "260px",
    marginBottom: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.500"),
    borderRadius: "initial"
});
const $24c02ea0e14dbe4f$var$$0ae392c3008c8a3e$var$variantStyles = {
    [$24c02ea0e14dbe4f$export$f2adaabc3a0295ef.TALL]: {
        container: {
            withImage: (0, $74Zh5.css)({
                [(0, $cb8cedbc477f5a81$export$987d49ffe1b0900f).above.md]: {
                    height: "352px !important"
                }
            }),
            withoutImage: (0, $74Zh5.css)({
                [(0, $cb8cedbc477f5a81$export$987d49ffe1b0900f).above.md]: {
                    height: "264px !important"
                }
            })
        },
        heading: (0, $74Zh5.css)({
            [(0, $cb8cedbc477f5a81$export$987d49ffe1b0900f).above.md]: {
                WebkitLineClamp: "2"
            }
        }),
        text: (0, $74Zh5.css)({
            [(0, $cb8cedbc477f5a81$export$987d49ffe1b0900f).above.md]: {
                WebkitLineClamp: "3"
            }
        })
    },
    [$24c02ea0e14dbe4f$export$f2adaabc3a0295ef.FULL]: {
        container: {
            withImage: (0, $74Zh5.css)({
                [(0, $cb8cedbc477f5a81$export$987d49ffe1b0900f).above.md]: {
                    height: "auto !important"
                }
            }),
            withoutImage: (0, $74Zh5.css)({
                [(0, $cb8cedbc477f5a81$export$987d49ffe1b0900f).above.md]: {
                    height: "auto !important"
                }
            })
        },
        heading: (0, $74Zh5.css)({
            [(0, $cb8cedbc477f5a81$export$987d49ffe1b0900f).above.md]: {
                WebkitLineClamp: "none"
            }
        }),
        text: (0, $74Zh5.css)({
            [(0, $cb8cedbc477f5a81$export$987d49ffe1b0900f).above.md]: {
                WebkitLineClamp: "none"
            }
        })
    }
};
const $24c02ea0e14dbe4f$var$$0ae392c3008c8a3e$var$squareTypeStyles = {
    container: (0, $74Zh5.css)({
        backgroundColor: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.background.input"),
        padding: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.300"),
        height: "320px",
        width: "324px",
        borderRadius: "8px",
        [(0, $cb8cedbc477f5a81$export$987d49ffe1b0900f).below.md]: {
            minHeight: "360px",
            maxWidth: "unset",
            height: "100%"
        },
        [(0, $cb8cedbc477f5a81$export$987d49ffe1b0900f).below.sm]: {
            minHeight: "264px",
            padding: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.300")
        }
    }),
    heading: (0, $74Zh5.css)({
        marginBottom: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.300")
    })
};
const $24c02ea0e14dbe4f$var$$0ae392c3008c8a3e$var$flexibleContainerStyles = (0, $74Zh5.css)({
    height: "auto",
    padding: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.300"),
    borderRadius: "8px",
    [(0, $cb8cedbc477f5a81$export$987d49ffe1b0900f).below.md]: {
        padding: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.400")
    },
    [(0, $cb8cedbc477f5a81$export$987d49ffe1b0900f).below.sm]: {
        padding: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.300")
    }
});
const $24c02ea0e14dbe4f$var$$0ae392c3008c8a3e$var$contentContainerStyles = (0, $74Zh5.css)({
    marginBottom: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.025"),
    flex: 1,
    display: "flex",
    flexDirection: "column"
});
const $24c02ea0e14dbe4f$var$$0ae392c3008c8a3e$var$contentContainerSquareStyles = (0, $74Zh5.css)({
    justifyContent: "space-between",
    a: {
        fontSize: "20px",
        lineHeight: "24px"
    }
});
const $24c02ea0e14dbe4f$var$$0ae392c3008c8a3e$var$textContainerStyles = (0, $74Zh5.css)({
    marginTop: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.100"),
    marginBottom: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.400"),
    [(0, $cb8cedbc477f5a81$export$987d49ffe1b0900f).below.sm]: {
        marginBottom: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.300")
    }
});
var $24c02ea0e14dbe4f$var$$205ed41b47d90e33$exports = {};
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$205ed41b47d90e33$exports, "RelatedResourcesPanel", ()=>$24c02ea0e14dbe4f$export$3775cdf183cb8274);
const $24c02ea0e14dbe4f$var$$205ed41b47d90e33$var$ResourceItem = ({ title: title, slug: slug, onResourceClick: onResourceClick })=>{
    const handleClick = (0, $5FkrB.useCallback)(()=>onResourceClick(slug), [
        slug,
        onResourceClick
    ]);
    const onKeyDown = $24c02ea0e14dbe4f$export$2a0b6757d41dacb2(handleClick);
    return (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
        role: "button",
        tabIndex: 0,
        css: $24c02ea0e14dbe4f$var$$205ed41b47d90e33$var$resourceStyles,
        onClick: handleClick,
        onKeyDown: onKeyDown,
        children: title
    });
};
const $24c02ea0e14dbe4f$export$3775cdf183cb8274 = ({ title: title, resources: resources, onResourceClick: onResourceClick, onButtonClick: onButtonClick })=>{
    const [isOpen, setIsOpen] = (0, $5FkrB.useState)(false);
    const handleButtonClick = (0, $5FkrB.useCallback)(()=>{
        setIsOpen(!isOpen);
        onButtonClick && onButtonClick();
    }, [
        isOpen,
        onButtonClick
    ]);
    const onKeyDownPanel = $24c02ea0e14dbe4f$export$2a0b6757d41dacb2(handleButtonClick);
    return (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
        role: "button",
        tabIndex: 0,
        "data-testid": "related-resources-panel",
        css: $24c02ea0e14dbe4f$var$$205ed41b47d90e33$var$relatedResourcesPanelStyles,
        onClick: handleButtonClick,
        onKeyDown: onKeyDownPanel,
        children: [
            (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                "data-testid": "related-resources-header",
                css: $24c02ea0e14dbe4f$var$$205ed41b47d90e33$var$headerStyles,
                children: [
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$a8a3e93435678ff9, {
                        level: 6,
                        children: title
                    }),
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $0c4c08ddec83e35f$export$2e2bcd8739ae039), {
                        appearance: "subtle",
                        icon: isOpen ? (0, (/*@__PURE__*/$parcel$interopDefault($30203922e34ab8aa$exports))) : (0, (/*@__PURE__*/$parcel$interopDefault($9486f8503a3e67e2$exports))),
                        label: isOpen ? "Collapse" : "Expand"
                    })
                ]
            }),
            isOpen && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("ul", {
                "data-testid": "related-resources-list",
                css: $24c02ea0e14dbe4f$var$$205ed41b47d90e33$var$resourcesListStyles,
                children: resources.map(({ title: title, slug: slug })=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("li", {
                        "data-testid": `related-resource-item-${slug}`,
                        children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$var$$205ed41b47d90e33$var$ResourceItem, {
                            title: title,
                            slug: slug,
                            onResourceClick: onResourceClick
                        })
                    }, slug))
            })
        ]
    });
};
const $24c02ea0e14dbe4f$var$$205ed41b47d90e33$var$relatedResourcesPanelStyles = (0, $74Zh5.css)({
    display: "flex",
    flexDirection: "column",
    borderRadius: "8px",
    padding: `${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.150")} ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.200")}`,
    boxShadow: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("elevation.shadow.overlay"),
    cursor: "pointer",
    backgroundColor: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.background.input.pressed")
});
const $24c02ea0e14dbe4f$var$$205ed41b47d90e33$var$headerStyles = (0, $74Zh5.css)({
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text")
});
const $24c02ea0e14dbe4f$var$$205ed41b47d90e33$var$resourcesListStyles = (0, $74Zh5.css)({
    display: "flex",
    flexDirection: "column",
    margin: 0,
    paddingLeft: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.250"),
    gap: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.050"),
    marginTop: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.150")
});
const $24c02ea0e14dbe4f$var$$205ed41b47d90e33$var$resourceStyles = (0, $74Zh5.css)({
    color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.link"),
    fontWeight: 400,
    fontSize: "14px",
    lineHeight: "20px",
    cursor: "pointer",
    "&:hover": {
        textDecoration: "underline"
    }
});
var $24c02ea0e14dbe4f$var$$3c691af970e2b3d8$exports = {};
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$3c691af970e2b3d8$exports, "ThumbType", ()=>$24c02ea0e14dbe4f$export$e1c6e381de15460b);
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$3c691af970e2b3d8$exports, "FeedbackButtonType", ()=>$24c02ea0e14dbe4f$export$8eec558e14651de4);
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$3c691af970e2b3d8$exports, "THUMBS_UP_FEEDBACK_OPTIONS", ()=>$24c02ea0e14dbe4f$export$3e6d4d99e8c08756);
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$3c691af970e2b3d8$exports, "THUMBS_DOWN_FEEDBACK_OPTIONS", ()=>$24c02ea0e14dbe4f$export$592a942fdddb4b1a);
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$3c691af970e2b3d8$exports, "QuickFeedback", ()=>$24c02ea0e14dbe4f$export$c6f2bf448101d429);
let $24c02ea0e14dbe4f$export$e1c6e381de15460b;
(function(ThumbType) {
    ThumbType["THUMB_UP"] = "thumb-up";
    ThumbType["THUMB_DOWN"] = "thumb-down";
})($24c02ea0e14dbe4f$export$e1c6e381de15460b || ($24c02ea0e14dbe4f$export$e1c6e381de15460b = {}));
let $24c02ea0e14dbe4f$export$8eec558e14651de4;
(function(FeedbackButtonType) {
    FeedbackButtonType["DISMISS"] = "dismiss";
    FeedbackButtonType["SUBMIT"] = "submit";
})($24c02ea0e14dbe4f$export$8eec558e14651de4 || ($24c02ea0e14dbe4f$export$8eec558e14651de4 = {}));
const $24c02ea0e14dbe4f$export$3e6d4d99e8c08756 = [
    "It was easy to understand",
    "I learned something useful",
    "It was engaging",
    "It improved my confidence in the subject",
    "Other"
];
const $24c02ea0e14dbe4f$export$592a942fdddb4b1a = [
    "It wasn\u2019t clear",
    "It wasn\u2019t accurate",
    "I didn\u2019t learn what I wanted to know",
    "Other"
];
const $24c02ea0e14dbe4f$export$c6f2bf448101d429 = ({ onSubmitFeedback: onSubmitFeedback, onChangeThoughts: onChangeThoughts, onChangeOption: onChangeOption, onThumbClick: onThumbClick, shouldShowDivider: shouldShowDivider = true, buttonText: buttonText = "How was this lesson?" })=>{
    const [isPopupOpened, setIsPopupOpened] = (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).useState({
        isOpen: false,
        thumbType: null
    });
    const [selectedOption, setSelectedOption] = (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).useState("");
    const [selectedThumb, setSelectedThumb] = (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).useState(null);
    const handleThumbClick = (thumbType)=>{
        if (selectedThumb !== thumbType) {
            setSelectedOption("");
            onChangeOption("");
            onChangeThoughts({
                target: {
                    value: ""
                }
            });
        }
        setIsPopupOpened({
            isOpen: true,
            thumbType: thumbType
        });
        setSelectedThumb(thumbType);
        onThumbClick(thumbType);
    };
    const toggleAnswer = (option)=>{
        setSelectedOption(option);
        onChangeOption(option);
    };
    const getOptionStatus = (option)=>selectedOption === option;
    const handleChangeThoughts = (0, $5FkrB.useCallback)((e)=>{
        e.preventDefault();
        if (onChangeThoughts) onChangeThoughts(e);
    }, [
        onChangeThoughts
    ]);
    const handleSubmitFeedback = ()=>{
        setIsPopupOpened({
            isOpen: false,
            thumbType: null
        });
        onSubmitFeedback($24c02ea0e14dbe4f$export$8eec558e14651de4.SUBMIT);
    };
    const handleDismissFeedback = ()=>{
        setIsPopupOpened({
            isOpen: false,
            thumbType: null
        });
        setSelectedOption("");
        onChangeThoughts({
            target: {
                value: ""
            }
        });
        onChangeOption("");
        onSubmitFeedback($24c02ea0e14dbe4f$export$8eec558e14651de4.DISMISS);
    };
    return (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
        "data-testid": "quick-feedback-component",
        css: $24c02ea0e14dbe4f$var$$3c691af970e2b3d8$var$quickFeedbackStyles,
        children: [
            (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                css: $24c02ea0e14dbe4f$var$$3c691af970e2b3d8$var$feedbackContainerStyles,
                children: [
                    (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                        css: $24c02ea0e14dbe4f$var$$3c691af970e2b3d8$var$thumbsContainerStyles,
                        children: [
                            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                                "data-testid": "thumb-down-container",
                                css: [
                                    $24c02ea0e14dbe4f$var$$3c691af970e2b3d8$var$thumbButtonContainerStyles,
                                    selectedThumb === $24c02ea0e14dbe4f$export$e1c6e381de15460b.THUMB_DOWN && {
                                        backgroundColor: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.background.selected")
                                    }
                                ],
                                children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$353f5b6fc5456de1, {
                                    tooltip: "Needs improvement",
                                    iconType: "thumb-down",
                                    label: "",
                                    iconBefore: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$f04a61298a47a40f, {
                                        type: "thumb-down"
                                    }),
                                    appearance: $24c02ea0e14dbe4f$export$261c9483fc4a455a.ICON,
                                    onClick: ()=>handleThumbClick($24c02ea0e14dbe4f$export$e1c6e381de15460b.THUMB_DOWN)
                                })
                            }),
                            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                                css: [
                                    $24c02ea0e14dbe4f$var$$3c691af970e2b3d8$var$thumbButtonContainerStyles,
                                    selectedThumb === $24c02ea0e14dbe4f$export$e1c6e381de15460b.THUMB_UP && {
                                        backgroundColor: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.background.selected")
                                    }
                                ],
                                "data-testid": "thumb-up-container",
                                children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$353f5b6fc5456de1, {
                                    tooltip: "Good",
                                    iconType: "thumb-up",
                                    label: "",
                                    iconBefore: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$f04a61298a47a40f, {
                                        type: "thumb-up"
                                    }),
                                    appearance: $24c02ea0e14dbe4f$export$261c9483fc4a455a.ICON,
                                    onClick: ()=>handleThumbClick($24c02ea0e14dbe4f$export$e1c6e381de15460b.THUMB_UP)
                                })
                            })
                        ]
                    }),
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                        "data-testid": "quick-feedback-text",
                        children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$a8a3e93435678ff9, {
                            level: 6,
                            color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text.subtle"),
                            children: selectedThumb ? "Thanks for your feedback!" : buttonText
                        })
                    })
                ]
            }),
            shouldShowDivider && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                css: $24c02ea0e14dbe4f$var$$3c691af970e2b3d8$var$dividerStyles,
                children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$2e0a83ec2e27ecbb, {
                    color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.border"),
                    height: 2
                })
            }),
            isPopupOpened.isOpen && (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                "data-testid": "popup",
                css: $24c02ea0e14dbe4f$var$$3c691af970e2b3d8$var$popupStyles,
                children: [
                    (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                        children: [
                            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$5f1af8db9871e1d6, {
                                size: "small",
                                fontWeight: "semibold",
                                children: "Why did you choose this response?"
                            }),
                            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                                css: $24c02ea0e14dbe4f$var$$3c691af970e2b3d8$var$optionsContentStyles,
                                children: isPopupOpened.thumbType === $24c02ea0e14dbe4f$export$e1c6e381de15460b.THUMB_UP ? $24c02ea0e14dbe4f$export$3e6d4d99e8c08756.map((option)=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                                        css: $24c02ea0e14dbe4f$var$$3c691af970e2b3d8$var$radioContainerStyles,
                                        children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$d7b12c4107be0d61, {
                                            setIsChecked: ()=>toggleAnswer(option),
                                            isChecked: getOptionStatus(option),
                                            label: option,
                                            name: "thumb-up"
                                        })
                                    }, option)) : $24c02ea0e14dbe4f$export$592a942fdddb4b1a.map((option)=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                                        css: $24c02ea0e14dbe4f$var$$3c691af970e2b3d8$var$radioContainerStyles,
                                        children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$d7b12c4107be0d61, {
                                            setIsChecked: ()=>toggleAnswer(option),
                                            isChecked: getOptionStatus(option),
                                            label: option,
                                            name: "thumb-down"
                                        })
                                    }, option))
                            })
                        ]
                    }),
                    (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                        css: $24c02ea0e14dbe4f$var$$3c691af970e2b3d8$var$feedbackFormStyles,
                        children: [
                            (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                                css: $24c02ea0e14dbe4f$var$$3c691af970e2b3d8$var$inputContainerStyles,
                                children: [
                                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$5f1af8db9871e1d6, {
                                        size: "small",
                                        fontWeight: "semibold",
                                        children: "Share your thoughts"
                                    }),
                                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$2c73285ae9390cec, {
                                        id: "quick-feedback-input",
                                        placeholder: "Start typing...",
                                        onChange: handleChangeThoughts
                                    }, selectedThumb)
                                ]
                            }),
                            (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                                css: $24c02ea0e14dbe4f$var$$3c691af970e2b3d8$var$buttonsContainerStyles,
                                children: [
                                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$353f5b6fc5456de1, {
                                        label: "Dismiss",
                                        appearance: $24c02ea0e14dbe4f$export$261c9483fc4a455a.LINK,
                                        onClick: handleDismissFeedback
                                    }),
                                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$353f5b6fc5456de1, {
                                        label: "Submit",
                                        appearance: $24c02ea0e14dbe4f$export$261c9483fc4a455a.PRIMARY,
                                        onClick: handleSubmitFeedback
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
const $24c02ea0e14dbe4f$var$$3c691af970e2b3d8$var$quickFeedbackStyles = (0, $74Zh5.css)({
    position: "relative",
    maxWidth: "720px",
    width: "100%",
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    justifyContent: "center"
});
const $24c02ea0e14dbe4f$var$$3c691af970e2b3d8$var$feedbackContainerStyles = (0, $74Zh5.css)({
    width: "100%",
    display: "flex",
    gap: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.150"),
    alignItems: "center"
});
const $24c02ea0e14dbe4f$var$$3c691af970e2b3d8$var$thumbsContainerStyles = (0, $74Zh5.css)({
    display: "flex",
    gap: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.100")
});
const $24c02ea0e14dbe4f$var$$3c691af970e2b3d8$var$thumbButtonContainerStyles = (0, $74Zh5.css)({
    backgroundColor: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.background.disabled"),
    borderRadius: "3px"
});
const $24c02ea0e14dbe4f$var$$3c691af970e2b3d8$var$dividerStyles = (0, $74Zh5.css)({
    width: "100%",
    margin: `${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.400")} 0`
});
const $24c02ea0e14dbe4f$var$$3c691af970e2b3d8$var$popupStyles = (0, $74Zh5.css)({
    position: "absolute",
    bottom: "100px",
    maxWidth: "476px",
    width: "100%",
    padding: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.200"),
    borderRadius: "8px",
    background: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.background.input"),
    boxShadow: `0px 0px 1px 0px rgba(9, 30, 66, 0.31), 0px 1px 1px 0px rgba(9, 30, 66, 0.25)`,
    [(0, $cb8cedbc477f5a81$export$987d49ffe1b0900f).below.sm]: {
        position: "relative",
        bottom: "60px"
    }
});
const $24c02ea0e14dbe4f$var$$3c691af970e2b3d8$var$optionsContentStyles = (0, $74Zh5.css)({
    margin: `${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.100")} 0 ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.150")}`
});
const $24c02ea0e14dbe4f$var$$3c691af970e2b3d8$var$radioContainerStyles = (0, $74Zh5.css)({
    marginTop: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.050")
});
const $24c02ea0e14dbe4f$var$$3c691af970e2b3d8$var$feedbackFormStyles = (0, $74Zh5.css)({
    display: "flex",
    flexDirection: "column",
    gap: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.150")
});
const $24c02ea0e14dbe4f$var$$3c691af970e2b3d8$var$inputContainerStyles = (0, $74Zh5.css)({
    display: "flex",
    flexDirection: "column",
    gap: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.050")
});
const $24c02ea0e14dbe4f$var$$3c691af970e2b3d8$var$buttonsContainerStyles = (0, $74Zh5.css)({
    display: "flex",
    justifyContent: "flex-end",
    gap: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.100")
});
var $24c02ea0e14dbe4f$var$$5f9280667c666470$exports = {};
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$5f9280667c666470$exports, "Searchbar", ()=>$24c02ea0e14dbe4f$export$b9f6e7a4c54af1f6);
const $24c02ea0e14dbe4f$var$$9c9ed7a3b666cf11$export$b36c0aa7a63a3911 = ({ item: item, onRemove: onRemove, onSelect: onSelect })=>{
    const deviceSize = $24c02ea0e14dbe4f$export$4616d33c54ae5baf();
    const handleRemoveButton = (e)=>{
        e.stopPropagation();
        onRemove(item);
    };
    const handleItemClick = (0, $5FkrB.useCallback)(()=>{
        onSelect(item);
    }, [
        onSelect,
        item
    ]);
    const handleRemoveKeyboard = (0, $5FkrB.useCallback)(()=>{
        onRemove(item);
    }, [
        onRemove,
        item
    ]);
    const onKeyDownItem = $24c02ea0e14dbe4f$export$2a0b6757d41dacb2(handleItemClick);
    const onKeyDownRemove = $24c02ea0e14dbe4f$export$2a0b6757d41dacb2(handleRemoveKeyboard);
    return (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
        role: "button",
        tabIndex: 0,
        css: $24c02ea0e14dbe4f$var$$9c9ed7a3b666cf11$var$historyItemContainerStyles,
        onClick: handleItemClick,
        onKeyDown: onKeyDownItem,
        "data-testid": "history-item",
        children: [
            (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                css: $24c02ea0e14dbe4f$var$$9c9ed7a3b666cf11$var$historyItemStyles,
                children: [
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$f04a61298a47a40f, {
                        type: "emoji-frequent",
                        color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.icon.subtle")
                    }),
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("span", {
                        css: $24c02ea0e14dbe4f$var$$9c9ed7a3b666cf11$var$itemTextStyles,
                        children: item
                    })
                ]
            }),
            (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                css: [
                    $24c02ea0e14dbe4f$var$$9c9ed7a3b666cf11$var$removeContainerStyles,
                    deviceSize < $24c02ea0e14dbe4f$export$27ed77542911fb0e && (0, $74Zh5.css)({
                        opacity: 1
                    })
                ],
                children: [
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$353f5b6fc5456de1, {
                        onClick: handleRemoveButton,
                        label: "",
                        iconBefore: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$f04a61298a47a40f, {
                            type: "dropdown-cross",
                            color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.icon")
                        })
                    }),
                    deviceSize < $24c02ea0e14dbe4f$export$27ed77542911fb0e && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("span", {
                        role: "button",
                        tabIndex: 0,
                        css: $24c02ea0e14dbe4f$var$$9c9ed7a3b666cf11$var$clearButtonStyles,
                        onClick: handleRemoveButton,
                        onKeyDown: onKeyDownRemove,
                        children: "Clear"
                    })
                ]
            })
        ]
    });
};
const $24c02ea0e14dbe4f$var$$9c9ed7a3b666cf11$var$removeContainerStyles = (0, $74Zh5.css)({
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    opacity: 0,
    button: {
        span: {
            margin: "0px !important"
        }
    }
});
const $24c02ea0e14dbe4f$var$$9c9ed7a3b666cf11$var$historyItemContainerStyles = (0, $74Zh5.css)({
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    width: "100%",
    padding: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.050"),
    cursor: "pointer",
    button: {
        backgroundColor: "transparent",
        border: "none",
        padding: 0,
        margin: 0,
        outline: "none",
        "&:hover": {
            backgroundColor: "transparent"
        }
    },
    "&:hover": {
        backgroundColor: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.background.accent.gray.subtlest")
    },
    "&:hover > div:last-child": {
        opacity: 1
    }
});
const $24c02ea0e14dbe4f$var$$9c9ed7a3b666cf11$var$historyItemStyles = (0, $74Zh5.css)({
    display: "flex",
    alignItems: "center",
    gap: "4px"
});
const $24c02ea0e14dbe4f$var$$9c9ed7a3b666cf11$var$itemTextStyles = (0, $74Zh5.css)({
    fontFamily: "Inter, sans-serif",
    fontSize: "14px",
    fontWeight: 400,
    lineHeight: "20px",
    color: `${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text")}`
});
const $24c02ea0e14dbe4f$var$$9c9ed7a3b666cf11$var$clearButtonStyles = (0, $74Zh5.css)({
    color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text.subtlest"),
    fontFamily: "Inter, sans-serif",
    fontSize: "12px",
    fontWeight: 400,
    lineHeight: "18px"
});
const $24c02ea0e14dbe4f$var$$2f046e897b352baf$export$ed4de3239e2fb964 = ({ items: items, onRemove: onRemove, onSelect: onSelect })=>{
    if (!items.length) return (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $6bec4f26b2cb3094$export$ffb0004e005737fa), {});
    return (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
        css: $24c02ea0e14dbe4f$var$$2f046e897b352baf$var$historyStyles,
        "data-testid": "history-container",
        children: items.slice(-5).reverse().map((item)=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$var$$9c9ed7a3b666cf11$export$b36c0aa7a63a3911, {
                item: item,
                onRemove: onRemove,
                onSelect: onSelect
            }, item))
    });
};
const $24c02ea0e14dbe4f$var$$2f046e897b352baf$var$historyStyles = (0, $74Zh5.css)({
    position: "absolute",
    display: "flex",
    width: "279px",
    borderRadius: "3px",
    padding: `${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.075")} ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.050")}`,
    marginTop: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.075"),
    flexDirection: "column",
    alignItems: "flex-start",
    background: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("elevation.surface.overlay"),
    boxShadow: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("elevation.shadow.overlay"),
    zIndex: 1,
    [(0, $cb8cedbc477f5a81$export$987d49ffe1b0900f).below.md]: {
        width: "327px"
    }
});
const $24c02ea0e14dbe4f$export$b9f6e7a4c54af1f6 = ({ value: value, onChange: onChange, isLoading: isLoading, label: label, isTall: isTall = false })=>{
    const [isHistoryVisible, setIsHistoryVisible] = (0, $5FkrB.useState)(false);
    const [history, setHistory] = (0, $5FkrB.useState)($24c02ea0e14dbe4f$export$7765f5b61937bda1());
    const searchRef = (0, $5FkrB.useRef)(null);
    const deviceSize = $24c02ea0e14dbe4f$export$4616d33c54ae5baf();
    const isRemoveIconVisible = !!value.length && (deviceSize >= $24c02ea0e14dbe4f$export$27ed77542911fb0e || !isLoading);
    (0, $5FkrB.useEffect)(()=>{
        const searchElement = searchRef.current;
        if (!searchElement) return;
        const inputElement = searchElement.querySelector("input");
        if (!inputElement) return;
        const handleFocus = ()=>{
            setIsHistoryVisible(true);
        };
        const handleClickOutside = (event)=>{
            if (searchRef.current && !searchRef.current.contains(event.target)) setIsHistoryVisible(false);
        };
        inputElement.addEventListener("focus", handleFocus);
        document.addEventListener("mousedown", handleClickOutside);
        return ()=>{
            inputElement.removeEventListener("focus", handleFocus);
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);
    const handleRemoveItem = (itemToRemove)=>{
        const newHistory = history.filter((item)=>item !== itemToRemove);
        setHistory(newHistory);
        $24c02ea0e14dbe4f$export$cec0922aa1b64670(newHistory);
    };
    const handleSelectItem = (selectedItem)=>{
        onChange(selectedItem);
        setIsHistoryVisible(false);
    };
    const onKeyDown = (event)=>{
        if (event.key === "Enter" && value.trim()) {
            if (!history.includes(value.trim()) && searchRef.current) {
                const newHistory = [
                    ...history,
                    value.trim()
                ];
                $24c02ea0e14dbe4f$export$cec0922aa1b64670(newHistory);
                const inputElement = searchRef.current.querySelector("input");
                if (inputElement) inputElement.blur();
                setIsHistoryVisible(false);
                setHistory(newHistory);
            }
        }
    };
    const filteredItems = history.filter((item)=>item.toLowerCase().includes(value.toLowerCase()));
    const handleOnChange = (event)=>{
        if (event.target instanceof HTMLInputElement) onChange(event.target.value);
    };
    const onClearSearchClick = ()=>{
        onChange("");
        setIsHistoryVisible(false);
    };
    const onKeyDownClear = $24c02ea0e14dbe4f$export$2a0b6757d41dacb2(onClearSearchClick);
    return (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
        role: "search",
        css: $24c02ea0e14dbe4f$var$$5f9280667c666470$var$searchStyles,
        onKeyDown: onKeyDown,
        tabIndex: 0,
        ref: searchRef,
        children: [
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("span", {
                css: $24c02ea0e14dbe4f$var$$5f9280667c666470$var$searchBeforeIconStyles,
                children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($47b625f21d7ae4a6$exports))), {
                    primaryColor: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text.subtlest"),
                    size: "medium",
                    label: "search icon"
                })
            }),
            !!value.length && isLoading && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("span", {
                "data-testid": "search-loader",
                css: [
                    $24c02ea0e14dbe4f$var$$5f9280667c666470$var$searchAfterIconStyles,
                    $24c02ea0e14dbe4f$var$$5f9280667c666470$var$searchLoaderIconStyles
                ],
                children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $e9bb9e7afd1cf629$export$2e2bcd8739ae039), {
                    size: "small"
                })
            }),
            isRemoveIconVisible && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("span", {
                role: "button",
                tabIndex: 0,
                css: $24c02ea0e14dbe4f$var$$5f9280667c666470$var$searchAfterIconStyles,
                onClick: onClearSearchClick,
                onKeyDown: onKeyDownClear,
                children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$353f5b6fc5456de1, {
                    label: "",
                    size: $24c02ea0e14dbe4f$export$5dd2748b7940a2a0.LARGE,
                    iconBefore: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$f04a61298a47a40f, {
                        type: "cross",
                        alt: "cross icon"
                    }),
                    appearance: $24c02ea0e14dbe4f$export$261c9483fc4a455a.ICON
                })
            }),
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("input", {
                placeholder: label ?? (deviceSize < $24c02ea0e14dbe4f$export$27ed77542911fb0e ? "Search" : "Search catalog"),
                value: value,
                onChange: handleOnChange,
                style: isTall ? {
                    paddingTop: "10px",
                    paddingBottom: "10px"
                } : {}
            }),
            isHistoryVisible && history.length > 0 && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$var$$2f046e897b352baf$export$ed4de3239e2fb964, {
                items: filteredItems,
                onRemove: handleRemoveItem,
                onSelect: handleSelectItem
            })
        ]
    });
};
const $24c02ea0e14dbe4f$var$$5f9280667c666470$var$searchStyles = (0, $74Zh5.css)({
    position: "relative",
    width: "100%",
    maxWidth: "240px",
    [(0, $cb8cedbc477f5a81$export$987d49ffe1b0900f).below.md]: {
        maxWidth: "275px"
    },
    [(0, $cb8cedbc477f5a81$export$987d49ffe1b0900f).below.xs]: {
        maxWidth: "100%"
    },
    input: {
        width: "100%",
        minHeight: "32px",
        border: `1px solid ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.border.input")}`,
        borderRadius: "5px !important",
        padding: `0 30px 0 ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.500")}`,
        color: `${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text")} !important`,
        fontSize: "14px",
        fontWeight: 400,
        lineHeight: "20px",
        outline: "none",
        "&::placeholder": {
            color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text.subtlest"),
            fontFamily: "SF Pro, sans-serif"
        },
        "&:focus": {
            border: `2px solid ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.border.focused")} !important`
        },
        [(0, $cb8cedbc477f5a81$export$987d49ffe1b0900f).below.md]: {
            height: "40px",
            padding: `10px 30px 10px ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.500")}`
        }
    }
});
const $24c02ea0e14dbe4f$var$$5f9280667c666470$var$searchBeforeIconStyles = (0, $74Zh5.css)({
    position: "absolute",
    left: "10px",
    top: 0,
    height: "100%",
    display: "flex",
    alignItems: "center",
    "[role='img']": {
        width: "20px !important",
        height: "20px !important"
    }
});
const $24c02ea0e14dbe4f$var$$5f9280667c666470$var$searchAfterIconStyles = (0, $74Zh5.css)({
    position: "absolute",
    right: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.100"),
    top: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.050"),
    cursor: "pointer",
    "[role='img']": {
        width: "20px !important",
        height: "20px !important"
    },
    [(0, $cb8cedbc477f5a81$export$987d49ffe1b0900f).below.md]: {
        top: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.100")
    }
});
const $24c02ea0e14dbe4f$var$$5f9280667c666470$var$searchLoaderIconStyles = (0, $74Zh5.css)({
    cursor: "default",
    right: "-24px",
    [(0, $cb8cedbc477f5a81$export$987d49ffe1b0900f).below.md]: {
        top: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.050"),
        right: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.200")
    }
});
var $24c02ea0e14dbe4f$var$$ffad026de847a971$exports = {};
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$ffad026de847a971$exports, "CourseStatus", ()=>$24c02ea0e14dbe4f$export$686d6bd87c227b43);
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$ffad026de847a971$exports, "CourseList", ()=>$24c02ea0e14dbe4f$export$96ebd64c4b8b0cf9);
var $24c02ea0e14dbe4f$var$$45c6e177b24a84f5$require$Buffer = (0, $7KfP5.Buffer);
const $24c02ea0e14dbe4f$var$$45c6e177b24a84f5$var$completedGap = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M6.735 12.322C6.55446 12.13 6.30541 12.0171 6.04201 12.0077C5.77861 11.9983 5.52217 12.0933 5.32844 12.272C5.13471 12.4507 5.01937 12.6987 5.00749 12.962C4.99561 13.2253 5.08815 13.4826 5.265 13.678L8.877 17.597C9.414 18.123 10.214 18.123 10.711 17.627L11.075 17.268C12.3895 15.9753 13.7025 14.6809 15.014 13.385L15.054 13.345C16.2797 12.1371 17.499 10.9228 18.712 9.70205C18.8933 9.51225 18.9927 9.25878 18.9887 8.99634C18.9848 8.73391 18.8778 8.48354 18.6909 8.29926C18.504 8.11499 18.2522 8.01158 17.9897 8.01135C17.7273 8.01113 17.4752 8.1141 17.288 8.29805C16.0807 9.51239 14.8673 10.7207 13.648 11.923L13.608 11.963C12.3513 13.2053 11.0929 14.446 9.833 15.685L6.735 12.322Z" fill="#22A06B"/>
</svg>
`;
const $24c02ea0e14dbe4f$var$$45c6e177b24a84f5$export$29aa8664c658caa9 = `data:image/svg+xml;base64,${$24c02ea0e14dbe4f$var$$45c6e177b24a84f5$require$Buffer.from($24c02ea0e14dbe4f$var$$45c6e177b24a84f5$var$completedGap).toString("base64")}`;
const $24c02ea0e14dbe4f$var$$ffad026de847a971$var$TABLET_SCREEN_WIDTH = 900;
let $24c02ea0e14dbe4f$export$686d6bd87c227b43;
(function(CourseStatus) {
    CourseStatus[/** The course is not started */ "DEFAULT"] = "default";
    CourseStatus[/** The course is in progress */ "IN_PROGRESS"] = "in_progress";
    CourseStatus[/** The course is finished */ "FINISHED"] = "finished";
})($24c02ea0e14dbe4f$export$686d6bd87c227b43 || ($24c02ea0e14dbe4f$export$686d6bd87c227b43 = {}));
const $24c02ea0e14dbe4f$export$96ebd64c4b8b0cf9 = ({ course: course, lessons: lessons, onLessonClick: onLessonClick, onCourseTitleClick: onCourseTitleClick, onCourseButtonClick: onCourseButtonClick })=>{
    const [isOpened, setIsOpened] = (0, $5FkrB.useState)(false);
    const deviceSize = $24c02ea0e14dbe4f$export$4616d33c54ae5baf();
    const numberOfCompletedLessons = lessons.filter((lesson)=>lesson.isCompleted).length;
    const calculateProgress = ()=>{
        if (course.courseStatus === $24c02ea0e14dbe4f$export$686d6bd87c227b43.FINISHED) return 100;
        return numberOfCompletedLessons / lessons.length * 100;
    };
    const isCompleted = calculateProgress() === 100;
    const isTablet = deviceSize <= $24c02ea0e14dbe4f$var$$ffad026de847a971$var$TABLET_SCREEN_WIDTH;
    const toggleLessons = ()=>{
        setIsOpened(!isOpened);
    };
    const getButtonText = (status)=>{
        switch(status){
            case $24c02ea0e14dbe4f$export$686d6bd87c227b43.DEFAULT:
                return "Get started";
            case $24c02ea0e14dbe4f$export$686d6bd87c227b43.IN_PROGRESS:
                return "Continue";
            case $24c02ea0e14dbe4f$export$686d6bd87c227b43.FINISHED:
                return "Review course";
            default:
                return "Get started";
        }
    };
    const handleTitleClick = (0, $5FkrB.useCallback)((event)=>{
        if (onCourseTitleClick) {
            event?.preventDefault();
            onCourseTitleClick();
        }
    }, [
        onCourseTitleClick
    ]);
    const handleButtonClick = (0, $5FkrB.useCallback)((event)=>{
        if (onCourseButtonClick) {
            event?.preventDefault();
            onCourseButtonClick();
        }
    }, [
        onCourseButtonClick
    ]);
    return (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
        css: [
            $24c02ea0e14dbe4f$var$$ffad026de847a971$var$wrapperStyles,
            isOpened ? $24c02ea0e14dbe4f$var$$ffad026de847a971$var$wrapperOpenStyles : $24c02ea0e14dbe4f$var$$ffad026de847a971$var$wrapperClosedStyles,
            isCompleted && $24c02ea0e14dbe4f$var$$ffad026de847a971$var$completedCourseStyles
        ],
        "data-testid": "course-list-container",
        children: [
            (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                "data-testid": `course-card-${course?.slug}`,
                css: $24c02ea0e14dbe4f$var$$ffad026de847a971$var$containerStyles,
                children: [
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                        css: $24c02ea0e14dbe4f$var$$ffad026de847a971$var$progressBadgeContainerStyles,
                        "data-testid": "course-progress-badge",
                        children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                            css: $24c02ea0e14dbe4f$var$$ffad026de847a971$var$customProgressBadgeStyles,
                            children: !isCompleted ? (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $f188eff9b59fb855$export$5ab97151efedb8c6), {
                                strokeWidth: 6,
                                value: calculateProgress(),
                                styles: (0, $f188eff9b59fb855$export$5115a192ad9bf57f)({
                                    pathColor: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.border.success"),
                                    trailColor: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.border")
                                }),
                                "data-testid": "course-progress-circle",
                                children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                                    css: $24c02ea0e14dbe4f$var$$ffad026de847a971$var$imageBadgeContainerStyles,
                                    children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("img", {
                                        src: course.imageUrl,
                                        alt: "Course badge",
                                        css: $24c02ea0e14dbe4f$var$$ffad026de847a971$var$imageStyles,
                                        "data-testid": "course-badge-image"
                                    })
                                })
                            }) : (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                                css: $24c02ea0e14dbe4f$var$$ffad026de847a971$var$completedBadgeContainerStyles,
                                "data-testid": "course-completed-badge",
                                children: [
                                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                                        css: $24c02ea0e14dbe4f$var$$ffad026de847a971$var$imageBadgeContainerStyles,
                                        children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("img", {
                                            src: course.imageUrl,
                                            alt: "Course badge",
                                            css: [
                                                $24c02ea0e14dbe4f$var$$ffad026de847a971$var$imageStyles,
                                                $24c02ea0e14dbe4f$var$$ffad026de847a971$var$completedImageStyles
                                            ],
                                            "data-testid": "course-completed-image"
                                        })
                                    }),
                                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                                        css: $24c02ea0e14dbe4f$var$$ffad026de847a971$var$checkmarkOverlayStyles,
                                        children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("img", {
                                            src: $24c02ea0e14dbe4f$var$$45c6e177b24a84f5$export$29aa8664c658caa9,
                                            alt: "Completed",
                                            css: $24c02ea0e14dbe4f$var$$ffad026de847a971$var$checkmarkIconStyles,
                                            "data-testid": "course-completed-checkmark"
                                        })
                                    })
                                ]
                            })
                        })
                    }),
                    (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                        css: $24c02ea0e14dbe4f$var$$ffad026de847a971$var$contentContainerStyles,
                        "data-testid": "course-content",
                        children: [
                            (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                                css: $24c02ea0e14dbe4f$var$$ffad026de847a971$var$topContentStyles,
                                children: [
                                    (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                                        css: $24c02ea0e14dbe4f$var$$ffad026de847a971$var$durationTitleContainerStyles,
                                        children: [
                                            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                                                css: $24c02ea0e14dbe4f$var$$ffad026de847a971$var$durationTextStyles,
                                                "data-testid": "course-duration",
                                                children: course.duration
                                            }),
                                            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$a8a3e93435678ff9, {
                                                level: 5,
                                                children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("a", {
                                                    css: $24c02ea0e14dbe4f$var$$ffad026de847a971$var$titleStyles,
                                                    href: course.href,
                                                    onClick: handleTitleClick,
                                                    "data-testid": "course-title-link",
                                                    children: course.title
                                                })
                                            })
                                        ]
                                    }),
                                    !isTablet && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("a", {
                                        css: $24c02ea0e14dbe4f$var$$ffad026de847a971$var$startCourseButtonStyles,
                                        href: course.href,
                                        onClick: handleButtonClick,
                                        "data-testid": "desktop-course-button",
                                        children: getButtonText(course.courseStatus)
                                    })
                                ]
                            }),
                            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                                css: $24c02ea0e14dbe4f$var$$ffad026de847a971$var$durationTitleContainerStyles,
                                children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("span", {
                                    css: $24c02ea0e14dbe4f$var$$ffad026de847a971$var$subTitleStyles,
                                    "data-testid": "course-subtitle",
                                    children: course.subTitle
                                })
                            })
                        ]
                    })
                ]
            }),
            !isTablet && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                css: [
                    $24c02ea0e14dbe4f$var$$ffad026de847a971$var$buttonContainerStyles,
                    isOpened && $24c02ea0e14dbe4f$var$$ffad026de847a971$var$buttonContainerOpenStyles,
                    !isOpened && $24c02ea0e14dbe4f$var$$ffad026de847a971$var$buttonContainerClosedStyles
                ],
                children: (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("button", {
                    css: $24c02ea0e14dbe4f$var$$ffad026de847a971$var$toggleButtonStyles,
                    onClick: toggleLessons,
                    "data-testid": "toggle-lessons-button",
                    children: [
                        isOpened ? "Hide lessons" : "Show lessons",
                        (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$f04a61298a47a40f, {
                            size: "small",
                            type: isOpened ? "chevron-up" : "chevron-down",
                            color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text.brand")
                        })
                    ]
                })
            }),
            isOpened && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                css: [
                    $24c02ea0e14dbe4f$var$$ffad026de847a971$var$lessonsContentWrapperStyles,
                    isTablet && $24c02ea0e14dbe4f$var$$ffad026de847a971$var$lessonContentWrapperMobileStyles
                ],
                children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$c3b0ae23c563b692, {
                    lessons: lessons,
                    onLessonClick: onLessonClick,
                    isStandalone: false,
                    isTablet: isTablet
                })
            }),
            isTablet && (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                css: [
                    $24c02ea0e14dbe4f$var$$ffad026de847a971$var$buttonContainerStyles,
                    isOpened && $24c02ea0e14dbe4f$var$$ffad026de847a971$var$buttonContainerOpenStyles,
                    !isOpened && $24c02ea0e14dbe4f$var$$ffad026de847a971$var$buttonContainerClosedStyles,
                    $24c02ea0e14dbe4f$var$$ffad026de847a971$var$buttonContainerMobileStyles
                ],
                children: [
                    (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("button", {
                        css: [
                            $24c02ea0e14dbe4f$var$$ffad026de847a971$var$toggleButtonStyles,
                            $24c02ea0e14dbe4f$var$$ffad026de847a971$var$toggleButtonMobileStyles
                        ],
                        onClick: toggleLessons,
                        "data-testid": "toggle-lessons-button-mobile",
                        children: [
                            isOpened ? "Hide lessons" : "Show lessons",
                            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$f04a61298a47a40f, {
                                size: "small",
                                type: isOpened ? "chevron-up" : "chevron-down",
                                color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text.brand")
                            })
                        ]
                    }),
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("a", {
                        css: $24c02ea0e14dbe4f$var$$ffad026de847a971$var$continueButtonStyles,
                        href: course.href,
                        onClick: handleButtonClick,
                        "data-testid": "tablet-course-button",
                        children: getButtonText(course.courseStatus)
                    })
                ]
            })
        ]
    });
};
const $24c02ea0e14dbe4f$var$$ffad026de847a971$var$containerStyles = (0, $74Zh5.css)({
    display: "flex",
    padding: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.200"),
    alignItems: "flex-start",
    gap: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.200"),
    alignSelf: "stretch",
    minHeight: "120px",
    backgroundColor: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.background.input"),
    "&:hover a": {
        opacity: 1
    },
    "@media (max-width: 343px)": {
        minHeight: "148px",
        padding: `${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.200")} ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.100")}`,
        gap: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.100")
    }
});
const $24c02ea0e14dbe4f$var$$ffad026de847a971$var$progressBadgeContainerStyles = (0, $74Zh5.css)({
    width: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.500"),
    height: "41px",
    flexShrink: 0
});
const $24c02ea0e14dbe4f$var$$ffad026de847a971$var$customProgressBadgeStyles = (0, $74Zh5.css)({
    width: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.500"),
    height: "41px"
});
const $24c02ea0e14dbe4f$var$$ffad026de847a971$var$imageBadgeContainerStyles = (0, $74Zh5.css)({
    width: "100%",
    height: "100%",
    padding: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.100")
});
const $24c02ea0e14dbe4f$var$$ffad026de847a971$var$imageStyles = (0, $74Zh5.css)({
    width: "100%",
    height: "100%",
    objectFit: "contain",
    borderRadius: "50%"
});
const $24c02ea0e14dbe4f$var$$ffad026de847a971$var$completedBadgeContainerStyles = (0, $74Zh5.css)({
    position: "relative",
    width: "100%",
    height: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
});
const $24c02ea0e14dbe4f$var$$ffad026de847a971$var$completedImageStyles = (0, $74Zh5.css)({
    opacity: 0.5,
    filter: "grayscale(100%)"
});
const $24c02ea0e14dbe4f$var$$ffad026de847a971$var$checkmarkOverlayStyles = (0, $74Zh5.css)({
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    zIndex: 1,
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
});
const $24c02ea0e14dbe4f$var$$ffad026de847a971$var$checkmarkIconStyles = (0, $74Zh5.css)({
    width: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.300"),
    height: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.300")
});
const $24c02ea0e14dbe4f$var$$ffad026de847a971$var$contentContainerStyles = (0, $74Zh5.css)({
    display: "flex",
    flexDirection: "column",
    marginRight: "auto",
    flex: 1,
    overflow: "hidden",
    minWidth: 0,
    width: "100%"
});
const $24c02ea0e14dbe4f$var$$ffad026de847a971$var$topContentStyles = (0, $74Zh5.css)({
    display: "flex",
    alignItems: "center",
    gap: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.150"),
    marginBottom: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.050"),
    minWidth: 0,
    width: "100%"
});
const $24c02ea0e14dbe4f$var$$ffad026de847a971$var$durationTitleContainerStyles = (0, $74Zh5.css)({
    display: "flex",
    flexDirection: "column",
    flex: 1,
    overflow: "hidden",
    minWidth: 0,
    width: "100%"
});
const $24c02ea0e14dbe4f$var$$ffad026de847a971$var$titleStyles = (0, $74Zh5.css)({
    color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text"),
    fontFamily: "Charlie Display",
    fontSize: "20px",
    fontStyle: "normal",
    margin: 0,
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "normal",
    textDecoration: "none",
    cursor: "pointer",
    lineHeight: "28px",
    fontWeight: 600,
    width: "100%",
    minWidth: 0,
    display: "block",
    maxHeight: "56px",
    wordBreak: "break-word",
    overflowWrap: "break-word",
    "&:hover": {
        textDecoration: "underline",
        color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text")
    },
    "@media (max-width: 343px)": {
        fontSize: "16px",
        lineHeight: "24px",
        whiteSpace: "normal",
        overflow: "hidden",
        textOverflow: "ellipsis",
        wordBreak: "break-word",
        overflowWrap: "break-word",
        maxHeight: "48px"
    }
});
const $24c02ea0e14dbe4f$var$$ffad026de847a971$var$startCourseButtonStyles = (0, $74Zh5.css)({
    color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text.brand"),
    fontFamily: "Charlie Text",
    fontSize: "16px",
    fontStyle: "normal",
    fontWeight: 600,
    lineHeight: "20px",
    background: "none",
    border: "none",
    cursor: "pointer",
    padding: `${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.100")} ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.150")}`,
    display: "flex",
    alignItems: "center",
    opacity: 0,
    transition: "opacity 0.2s ease",
    textDecoration: "none",
    "&:hover": {
        textDecoration: "underline",
        textUnderlineOffset: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.050"),
        color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text.brand")
    },
    "&:visited": {
        color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text.brand")
    }
});
const $24c02ea0e14dbe4f$var$$ffad026de847a971$var$subTitleStyles = (0, $74Zh5.css)({
    color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text"),
    display: "-webkit-box",
    WebkitLineClamp: 2,
    WebkitBoxOrient: "vertical",
    fontFamily: "Inter",
    fontSize: "14px",
    fontStyle: "normal",
    fontWeight: 400,
    lineHeight: "20px",
    margin: 0,
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "normal",
    width: "100%",
    minWidth: 0,
    maxHeight: "40px",
    wordBreak: "break-word",
    overflowWrap: "break-word",
    "@media (max-width: 343px)": {
        lineHeight: "22px",
        whiteSpace: "normal",
        overflow: "hidden",
        textOverflow: "ellipsis",
        wordBreak: "break-word",
        overflowWrap: "break-word",
        maxHeight: "44px"
    }
});
const $24c02ea0e14dbe4f$var$$ffad026de847a971$var$durationTextStyles = (0, $74Zh5.css)({
    color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text.subtlest"),
    fontFamily: "Charlie Text",
    fontSize: "12px",
    fontStyle: "normal",
    fontWeight: 400,
    lineHeight: "16px",
    textTransform: "uppercase",
    marginBottom: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.050")
});
const $24c02ea0e14dbe4f$var$$ffad026de847a971$var$buttonContainerStyles = (0, $74Zh5.css)({
    display: "flex",
    alignItems: "center",
    gap: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.200"),
    alignSelf: "stretch",
    borderTop: `1px solid ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.border")}`,
    padding: `${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.150")} ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.300")}`,
    "@media (max-width: 343px)": {
        gap: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.100"),
        padding: `${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.150")} ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.100")}`
    }
});
const $24c02ea0e14dbe4f$var$$ffad026de847a971$var$toggleButtonStyles = (0, $74Zh5.css)({
    color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text.brand"),
    fontFamily: "Charlie Text",
    fontSize: "16px",
    fontStyle: "normal",
    fontWeight: 600,
    background: "none",
    border: "none",
    cursor: "pointer",
    padding: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.0"),
    display: "flex",
    alignItems: "center",
    gap: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.050"),
    "&:hover": {
        textDecoration: "underline",
        textUnderlineOffset: "4px"
    }
});
const $24c02ea0e14dbe4f$var$$ffad026de847a971$var$toggleButtonMobileStyles = (0, $74Zh5.css)({
    color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text.brand"),
    textAlign: "center",
    fontFamily: "Charlie Text",
    fontSize: "14px",
    fontStyle: "normal",
    fontWeight: 600,
    lineHeight: "20px"
});
const $24c02ea0e14dbe4f$var$$ffad026de847a971$var$buttonContainerOpenStyles = (0, $74Zh5.css)({
    borderBottom: `1px solid ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.border")}`
});
const $24c02ea0e14dbe4f$var$$ffad026de847a971$var$wrapperStyles = (0, $74Zh5.css)({
    border: `1px solid ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.border")}`,
    overflow: "hidden",
    maxWidth: "100%",
    backgroundColor: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.background.input")
});
const $24c02ea0e14dbe4f$var$$ffad026de847a971$var$wrapperClosedStyles = (0, $74Zh5.css)({
    borderRadius: "8px"
});
const $24c02ea0e14dbe4f$var$$ffad026de847a971$var$wrapperOpenStyles = (0, $74Zh5.css)({
    borderRadius: "8px",
    "& > div:last-child": {
        borderRadius: "0 0 8px 8px"
    }
});
const $24c02ea0e14dbe4f$var$$ffad026de847a971$var$lessonsContentWrapperStyles = (0, $74Zh5.css)({
    overflow: "hidden",
    borderRadius: "0 0 8px 8px !important",
    backgroundColor: "#FFFFFF",
    "& > div": {
        borderRadius: "0 0 8px 8px !important"
    },
    "& > div > div:last-child": {
        borderRadius: "0 0 8px 8px !important"
    }
});
const $24c02ea0e14dbe4f$var$$ffad026de847a971$var$lessonContentWrapperMobileStyles = (0, $74Zh5.css)({
    borderRadius: "0 !important",
    "& > div": {
        borderRadius: "0 !important"
    },
    "& > div > div:last-child": {
        borderRadius: "0 !important"
    }
});
const $24c02ea0e14dbe4f$var$$ffad026de847a971$var$completedCourseStyles = (0, $74Zh5.css)({
    borderLeft: `4px solid ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.border.success")}`
});
const $24c02ea0e14dbe4f$var$$ffad026de847a971$var$buttonContainerClosedStyles = (0, $74Zh5.css)({
    justifyContent: "space-between"
});
const $24c02ea0e14dbe4f$var$$ffad026de847a971$var$buttonContainerMobileStyles = (0, $74Zh5.css)({
    padding: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.150"),
    justifyContent: "space-between"
});
const $24c02ea0e14dbe4f$var$$ffad026de847a971$var$continueButtonStyles = (0, $74Zh5.css)({
    color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text.inverse"),
    backgroundColor: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.background.brand.bold"),
    fontFamily: "Charlie Text",
    fontSize: "14px",
    fontStyle: "normal",
    fontWeight: 600,
    lineHeight: "20px",
    height: "32px",
    borderRadius: "4px",
    border: "none",
    cursor: "pointer",
    padding: `${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.100")} ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.150")}`,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    "&:hover": {
        backgroundColor: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.background.brand.bold.hovered"),
        color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text.inverse"),
        textDecoration: "none"
    },
    "&:active": {
        backgroundColor: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.background.brand.bold.pressed")
    }
});
var $24c02ea0e14dbe4f$var$$0f989458047e435a$exports = {};
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$0f989458047e435a$exports, "InformationCardState", ()=>$24c02ea0e14dbe4f$export$cbadcd18ba5a3835);
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$0f989458047e435a$exports, "InformationCard", ()=>$24c02ea0e14dbe4f$export$5a1fe75c0326c1f3);
var $24c02ea0e14dbe4f$var$$a7b3e1c0391fddac$exports = {};
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$a7b3e1c0391fddac$exports, "LearningControlPanel", ()=>$24c02ea0e14dbe4f$export$b0db8dac2b423604);
const $24c02ea0e14dbe4f$export$b0db8dac2b423604 = ({ state: state = $24c02ea0e14dbe4f$export$cbadcd18ba5a3835.DEFAULT, isSaved: isSaved, onSave: onSave, urlToShare: urlToShare, contentType: contentType, onClick: onClick, ctaSlot: ctaSlot })=>{
    const isCourse = contentType === $24c02ea0e14dbe4f$export$e2e108cbe2e4f865.COURSE;
    const buttonLabel = isCourse ? "course" : "learning path";
    const width = $24c02ea0e14dbe4f$export$4616d33c54ae5baf();
    const TABLET_WIDTH = 920;
    const handleOnClick = (event)=>{
        if (onClick) {
            event?.preventDefault();
            onClick();
        }
    };
    const ButtonStateProps = {
        [$24c02ea0e14dbe4f$export$cbadcd18ba5a3835.LOADING]: {
            label: "",
            isLoading: true,
            fullWidth: true
        },
        [$24c02ea0e14dbe4f$export$cbadcd18ba5a3835.DEFAULT]: {
            label: `Start ${buttonLabel}`,
            appearance: $24c02ea0e14dbe4f$export$261c9483fc4a455a.PRIMARY,
            fullWidth: true
        },
        [$24c02ea0e14dbe4f$export$cbadcd18ba5a3835.IN_PROGRESS]: {
            label: `Continue ${buttonLabel}`,
            appearance: $24c02ea0e14dbe4f$export$261c9483fc4a455a.PRIMARY,
            fullWidth: true
        },
        [$24c02ea0e14dbe4f$export$cbadcd18ba5a3835.FINISHED]: {
            label: `Review ${buttonLabel}`,
            appearance: $24c02ea0e14dbe4f$export$261c9483fc4a455a.SECONDARY,
            fullWidth: true
        }
    };
    const handleOnSave = ()=>{
        if (onSave) onSave();
    };
    return (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
        "data-testid": "control-panel-card",
        css: $24c02ea0e14dbe4f$var$$a7b3e1c0391fddac$var$learningControlPanelStyles,
        children: [
            (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                css: $24c02ea0e14dbe4f$var$$a7b3e1c0391fddac$var$iconButtonsContainerStyles,
                children: [
                    onSave && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$353f5b6fc5456de1, {
                        iconColor: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.icon.subtle"),
                        label: "",
                        appearance: $24c02ea0e14dbe4f$export$261c9483fc4a455a.ICON,
                        size: $24c02ea0e14dbe4f$export$5dd2748b7940a2a0.MEDIUM,
                        iconBefore: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$f04a61298a47a40f, {
                            type: isSaved ? "bookmark-filled" : "bookmark"
                        }),
                        onClick: handleOnSave
                    }),
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$477c64ffaba52edf, {
                        urlToShare: urlToShare,
                        alignToTop: width <= TABLET_WIDTH,
                        fullWidth: true
                    })
                ]
            }),
            (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                "data-testid": "control-panel-cta-button",
                css: $24c02ea0e14dbe4f$var$$a7b3e1c0391fddac$var$statusButtonContainerStyles,
                children: [
                    state === $24c02ea0e14dbe4f$export$cbadcd18ba5a3835.LOADING && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$353f5b6fc5456de1, {
                        ...ButtonStateProps[$24c02ea0e14dbe4f$export$cbadcd18ba5a3835.LOADING]
                    }),
                    state === $24c02ea0e14dbe4f$export$cbadcd18ba5a3835.DEFAULT && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$353f5b6fc5456de1, {
                        onClick: handleOnClick,
                        ...ButtonStateProps[$24c02ea0e14dbe4f$export$cbadcd18ba5a3835.DEFAULT]
                    }),
                    state === $24c02ea0e14dbe4f$export$cbadcd18ba5a3835.IN_PROGRESS && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$353f5b6fc5456de1, {
                        onClick: handleOnClick,
                        ...ButtonStateProps[$24c02ea0e14dbe4f$export$cbadcd18ba5a3835.IN_PROGRESS]
                    }),
                    state === $24c02ea0e14dbe4f$export$cbadcd18ba5a3835.FINISHED && (ctaSlot ?? (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$353f5b6fc5456de1, {
                        onClick: handleOnClick,
                        ...ButtonStateProps[$24c02ea0e14dbe4f$export$cbadcd18ba5a3835.FINISHED]
                    }))
                ]
            })
        ]
    });
};
const $24c02ea0e14dbe4f$var$$a7b3e1c0391fddac$var$learningControlPanelStyles = (0, $74Zh5.css)({
    position: "relative",
    padding: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.200"),
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    border: `1px solid ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.border")}`,
    borderRadius: "8px",
    borderTopRightRadius: 0,
    borderTopLeftRadius: 0,
    backgroundColor: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.background.input"),
    zIndex: 2,
    borderLeft: "none",
    borderRight: "none",
    "@media (max-width: 920px)": {
        borderBottom: "none"
    }
});
const $24c02ea0e14dbe4f$var$$a7b3e1c0391fddac$var$iconButtonsContainerStyles = (0, $74Zh5.css)({
    display: "flex",
    justifyContent: "space-between",
    gap: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.150"),
    marginRight: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.150"),
    '[id*="icon-button"]': {
        width: "38px",
        height: "38px",
        backgroundColor: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.background.neutral"),
        ":hover": {
            backgroundColor: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.background.neutral.hovered")
        }
    }
});
const $24c02ea0e14dbe4f$var$$a7b3e1c0391fddac$var$statusButtonContainerStyles = (0, $74Zh5.css)({
    flex: 1,
    width: "100%",
    a: {
        padding: `${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.100")} ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.150")}`
    },
    button: {
        width: "100%",
        height: "38px"
    }
});
let $24c02ea0e14dbe4f$export$cbadcd18ba5a3835;
(function(InformationCardState) {
    InformationCardState["LOADING"] = "loading";
    InformationCardState["DEFAULT"] = "default";
    InformationCardState["IN_PROGRESS"] = "in_progress";
    InformationCardState["FINISHED"] = "finished";
})($24c02ea0e14dbe4f$export$cbadcd18ba5a3835 || ($24c02ea0e14dbe4f$export$cbadcd18ba5a3835 = {}));
const $24c02ea0e14dbe4f$export$5a1fe75c0326c1f3 = ({ contentType: contentType, video: video, badge: badge, progress: progress, duration: duration, description: description, title: title, urlToShare: urlToShare, cardState: cardState, isSaved: isSaved, onSave: onSave, onClick: onClick, ctaSlot: ctaSlot })=>{
    const isCourse = contentType === $24c02ea0e14dbe4f$export$e2e108cbe2e4f865.COURSE;
    const defaultTitle = isCourse ? "After this course, you'll be able to:" : "This learning path is for:";
    const displayTitle = title ?? defaultTitle;
    const titleColor = isCourse ? (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text.accent.blue") : (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text.accent.lime");
    const isCompleted = progress === 100;
    const shouldShowBadge = isCourse && badge && !video;
    const shouldShowVideo = contentType === $24c02ea0e14dbe4f$export$e2e108cbe2e4f865.LEARNING_PATH && video && !badge;
    return (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
        "data-testid": "information-card",
        css: [
            $24c02ea0e14dbe4f$var$$0f989458047e435a$var$informationCardStyles,
            isCourse ? $24c02ea0e14dbe4f$var$$0f989458047e435a$var$courseBorderStyles : $24c02ea0e14dbe4f$var$$0f989458047e435a$var$learningPathBorderStyles,
            shouldShowVideo && (0, $74Zh5.css)({
                borderTop: "none"
            })
        ],
        children: [
            shouldShowBadge && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                css: $24c02ea0e14dbe4f$var$$0f989458047e435a$var$badgeContainerStyles,
                children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                    css: $24c02ea0e14dbe4f$var$$0f989458047e435a$var$badgeStyles,
                    style: {
                        backgroundImage: `url(${badge})`
                    }
                })
            }),
            shouldShowVideo && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                css: $24c02ea0e14dbe4f$var$$0f989458047e435a$var$videoContainerStyles,
                children: video
            }),
            (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                "data-testid": "information-card-top",
                css: [
                    $24c02ea0e14dbe4f$var$$0f989458047e435a$var$informationCardContainerStyles,
                    (0, $74Zh5.css)({
                        marginTop: shouldShowBadge ? (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.250") : "0px"
                    })
                ],
                children: [
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$a8a3e93435678ff9, {
                        level: 5,
                        color: titleColor,
                        children: displayTitle
                    }),
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                        css: $24c02ea0e14dbe4f$var$$0f989458047e435a$var$descriptionStyles,
                        children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$5f1af8db9871e1d6, {
                            size: "small",
                            color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text"),
                            children: description
                        })
                    })
                ]
            }),
            (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                "data-testid": "duration-progress-container",
                css: [
                    $24c02ea0e14dbe4f$var$$0f989458047e435a$var$informationCardContainerStyles,
                    $24c02ea0e14dbe4f$var$$0f989458047e435a$var$durationProgressContainerStyles
                ],
                children: [
                    (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                        "data-testid": "duration-info",
                        css: $24c02ea0e14dbe4f$var$$0f989458047e435a$var$durationContainerStyles,
                        children: [
                            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("span", {
                                css: $24c02ea0e14dbe4f$var$$0f989458047e435a$var$spanStyles,
                                children: "Duration"
                            }),
                            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$3288d34c523a1192, {
                                label: duration
                            })
                        ]
                    }),
                    (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                        "data-testid": "progress-info",
                        css: $24c02ea0e14dbe4f$var$$0f989458047e435a$var$progressContainerStyles,
                        children: [
                            (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                                css: $24c02ea0e14dbe4f$var$$0f989458047e435a$var$progressPercentageStyles,
                                children: [
                                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("span", {
                                        css: $24c02ea0e14dbe4f$var$$0f989458047e435a$var$spanStyles,
                                        children: "Progress "
                                    }),
                                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("span", {
                                        css: [
                                            $24c02ea0e14dbe4f$var$$0f989458047e435a$var$percentageStyles,
                                            isCompleted && (0, $74Zh5.css)({
                                                color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text.success")
                                            })
                                        ],
                                        children: isCompleted ? "Completed" : `${progress}%`
                                    })
                                ]
                            }),
                            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$c17561cb55d4db30, {
                                color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.border.success"),
                                progress: progress
                            })
                        ]
                    })
                ]
            }),
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                css: $24c02ea0e14dbe4f$var$$0f989458047e435a$var$controlPanelContainerStyles,
                children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$b0db8dac2b423604, {
                    onClick: onClick,
                    isSaved: isSaved,
                    onSave: onSave,
                    state: cardState,
                    urlToShare: urlToShare,
                    contentType: contentType,
                    ctaSlot: ctaSlot
                })
            })
        ]
    });
};
const $24c02ea0e14dbe4f$var$$0f989458047e435a$var$informationCardStyles = (0, $74Zh5.css)({
    position: "relative",
    width: "100%",
    border: `1px solid ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.border")}`,
    borderBottom: "unset",
    borderRadius: "8px",
    backgroundColor: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.background.input"),
    boxShadow: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("elevation.shadow.overlay"),
    "@media (max-width: 965px)": {
        borderBottom: `1px solid ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.border")}`,
        boxShadow: "unset"
    }
});
const $24c02ea0e14dbe4f$var$$0f989458047e435a$var$courseBorderStyles = (0, $74Zh5.css)({
    borderTop: `8px solid ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text.accent.blue")}`
});
const $24c02ea0e14dbe4f$var$$0f989458047e435a$var$learningPathBorderStyles = (0, $74Zh5.css)({
    borderTop: "8px solid #6A9A23"
});
const $24c02ea0e14dbe4f$var$$0f989458047e435a$var$badgeContainerStyles = (0, $74Zh5.css)({
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    position: "absolute",
    width: "60px",
    height: "60px",
    borderRadius: "50%",
    border: `4px solid ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text.accent.blue")}`,
    left: "50%",
    top: "0%",
    transform: "translate(-50%, -60%)",
    background: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.background.input"),
    zIndex: 1
});
const $24c02ea0e14dbe4f$var$$0f989458047e435a$var$videoContainerStyles = (0, $74Zh5.css)({
    borderTopLeftRadius: "8px",
    borderTopRightRadius: "8px",
    ".plyr": {
        borderTopLeftRadius: "8px",
        borderTopRightRadius: "8px"
    }
});
const $24c02ea0e14dbe4f$var$$0f989458047e435a$var$badgeStyles = (0, $74Zh5.css)({
    width: "35px",
    height: "35px",
    borderRadius: "50%",
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat"
});
const $24c02ea0e14dbe4f$var$$0f989458047e435a$var$informationCardContainerStyles = (0, $74Zh5.css)({
    padding: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.200")
});
const $24c02ea0e14dbe4f$var$$0f989458047e435a$var$descriptionStyles = (0, $74Zh5.css)({
    marginBottom: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.100"),
    marginTop: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.100"),
    color: `${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text")} !important`,
    fontFamily: "Inter !important",
    fontSize: "14px !important",
    fontWeight: "400 !important",
    lineHeight: "22px !important",
    div: {
        paddingBottom: "0 !important",
        display: "flex !important",
        "@media (max-width: 920px)": {
            display: "flex !important"
        }
    },
    "span, p, li": {
        color: `${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text")} !important`,
        fontFamily: "Inter !important",
        fontSize: "14px !important",
        fontWeight: "400 !important",
        lineHeight: "22px !important"
    },
    li: {
        marginBottom: "6px !important"
    },
    "li:last-child": {
        marginBottom: "0 !important"
    }
});
const $24c02ea0e14dbe4f$var$$0f989458047e435a$var$durationProgressContainerStyles = (0, $74Zh5.css)({
    borderTop: `1px solid ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.border")}`
});
const $24c02ea0e14dbe4f$var$$0f989458047e435a$var$durationContainerStyles = (0, $74Zh5.css)({
    display: "flex",
    alignItems: "center",
    gap: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.200")
});
const $24c02ea0e14dbe4f$var$$0f989458047e435a$var$spanStyles = (0, $74Zh5.css)({
    fontFamily: "Inter, sans-serif",
    fontSize: "14px",
    fontWeight: "700",
    lineHeight: "20px",
    color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text"),
    textTransform: "uppercase"
});
const $24c02ea0e14dbe4f$var$$0f989458047e435a$var$percentageStyles = (0, $74Zh5.css)({
    fontFamily: "Inter, sans-serif",
    fontSize: "14px",
    fontWeight: "400",
    lineHeight: "20px",
    color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text")
});
const $24c02ea0e14dbe4f$var$$0f989458047e435a$var$progressContainerStyles = (0, $74Zh5.css)({
    display: "flex",
    flexDirection: "column",
    gap: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.200"),
    marginTop: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.200")
});
const $24c02ea0e14dbe4f$var$$0f989458047e435a$var$progressPercentageStyles = (0, $74Zh5.css)({
    display: "flex",
    alignItems: "center",
    gap: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.200")
});
const $24c02ea0e14dbe4f$var$$0f989458047e435a$var$controlPanelContainerStyles = (0, $74Zh5.css)({
    "@media (max-width: 965px)": {
        display: "none"
    }
});
var $24c02ea0e14dbe4f$var$$ffc638203e092686$exports = {};
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$ffc638203e092686$exports, "ContentVersioningDialog", ()=>$24c02ea0e14dbe4f$export$3a7bdc050aa55c54);
const $24c02ea0e14dbe4f$export$3a7bdc050aa55c54 = ({ resourceTitle: resourceTitle, subtitle: subtitle, notifications: notifications, onResourceLinkClick: onResourceLinkClick, closeModal: closeModal })=>{
    const handleDismiss = (e)=>{
        e.preventDefault();
        closeModal();
    };
    const handleResourceClick = (e, resourceLink)=>{
        e.preventDefault();
        onResourceLinkClick(resourceLink);
    };
    return (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $73c4314b1cf0d4b0$export$2e2bcd8739ae039), {
        onClose: closeModal,
        children: (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
            "data-testid": "content-versioning-dialog",
            css: $24c02ea0e14dbe4f$var$$ffc638203e092686$var$containerStyles,
            children: [
                (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                    css: $24c02ea0e14dbe4f$var$$ffc638203e092686$var$crossIconContainerStyles,
                    children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$353f5b6fc5456de1, {
                        label: "",
                        appearance: $24c02ea0e14dbe4f$export$261c9483fc4a455a.ICON,
                        iconType: "cross",
                        iconBefore: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$f04a61298a47a40f, {
                            type: "cross",
                            color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.icon")
                        }),
                        onClick: handleDismiss
                    })
                }),
                (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                    children: [
                        (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                            "data-testid": "dialog-title",
                            css: $24c02ea0e14dbe4f$var$$ffc638203e092686$var$dialogTitleStyles,
                            children: [
                                "Update to ",
                                resourceTitle
                            ]
                        }),
                        (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                            "data-testid": "dialog-subtitle",
                            css: $24c02ea0e14dbe4f$var$$ffc638203e092686$var$dialogSubtitleStyles,
                            children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$5f1af8db9871e1d6, {
                                size: "small",
                                color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text"),
                                children: subtitle
                            })
                        }),
                        (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                            children: [
                                (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$5f1af8db9871e1d6, {
                                    size: "small",
                                    color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text"),
                                    children: "Summary of changes:"
                                }),
                                !!notifications.length && notifications.map((notification)=>(0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                                        css: $24c02ea0e14dbe4f$var$$ffc638203e092686$var$notificationContainerStyles,
                                        children: [
                                            (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                                                children: [
                                                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                                                        "data-testid": "notification-title",
                                                        children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$5f1af8db9871e1d6, {
                                                            children: notification.title
                                                        })
                                                    }),
                                                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("span", {
                                                        css: $24c02ea0e14dbe4f$var$$ffc638203e092686$var$notificationDateStyles,
                                                        children: notification.date
                                                    })
                                                ]
                                            }),
                                            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                                                css: $24c02ea0e14dbe4f$var$$ffc638203e092686$var$notificationDescriptionContainerStyles,
                                                children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$5f1af8db9871e1d6, {
                                                    size: "small",
                                                    color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text.subtle"),
                                                    children: notification.description
                                                })
                                            }),
                                            notification.contentType === $24c02ea0e14dbe4f$export$e2e108cbe2e4f865.LESSON && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                                                css: $24c02ea0e14dbe4f$var$$ffc638203e092686$var$linkContainerStyles,
                                                children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$a6c7ac8248d6e38a, {
                                                    target: "_blank",
                                                    label: "View changes",
                                                    link: notification.resourceLink,
                                                    icon: "arrow-right",
                                                    onClick: (e)=>handleResourceClick(e, notification.resourceLink)
                                                })
                                            })
                                        ]
                                    }, notification.id))
                            ]
                        })
                    ]
                }),
                (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                    css: $24c02ea0e14dbe4f$var$$ffc638203e092686$var$buttonContainerStyles,
                    children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$353f5b6fc5456de1, {
                        label: "Dismiss",
                        appearance: $24c02ea0e14dbe4f$export$261c9483fc4a455a.PRIMARY,
                        onClick: handleDismiss
                    })
                })
            ]
        })
    });
};
const $24c02ea0e14dbe4f$var$$ffc638203e092686$var$containerStyles = (0, $74Zh5.css)({
    display: "flex",
    flexDirection: "column",
    padding: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.300"),
    backgroundColor: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.background.input"),
    boxShadow: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("elevation.shadow.raised"),
    borderRadius: "8px"
});
const $24c02ea0e14dbe4f$var$$ffc638203e092686$var$crossIconContainerStyles = (0, $74Zh5.css)({
    alignSelf: "flex-end",
    marginBottom: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.150")
});
const $24c02ea0e14dbe4f$var$$ffc638203e092686$var$dialogTitleStyles = (0, $74Zh5.css)({
    marginBottom: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.100"),
    color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text"),
    fontFamily: "Charlie Display, sans-serif",
    fontSize: "24px",
    fontWeight: 600,
    lineHeight: "32px",
    textAlign: "left"
});
const $24c02ea0e14dbe4f$var$$ffc638203e092686$var$dialogSubtitleStyles = (0, $74Zh5.css)({
    marginBottom: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.300")
});
const $24c02ea0e14dbe4f$var$$ffc638203e092686$var$notificationContainerStyles = (0, $74Zh5.css)({
    border: `1px solid ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.border")}`,
    padding: `${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.150")} ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.200")}`,
    marginTop: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.100"),
    borderRadius: "4px",
    backgroundColor: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.background.input"),
    borderLeft: `4px solid ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.background.accent.blue.subtlest.pressed")}`
});
const $24c02ea0e14dbe4f$var$$ffc638203e092686$var$buttonContainerStyles = (0, $74Zh5.css)({
    alignSelf: "flex-end",
    marginTop: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.400"),
    a: {
        fontFamily: "SF Pro, sans-serif",
        fontSize: "14px",
        fontWeight: 500,
        paddingTop: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.075"),
        paddingBottom: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.075")
    }
});
const $24c02ea0e14dbe4f$var$$ffc638203e092686$var$notificationDateStyles = (0, $74Zh5.css)({
    color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text.subtlest"),
    fontFamily: "Inter, sans-serif",
    fontWeight: 400,
    lineHeight: "18px"
});
const $24c02ea0e14dbe4f$var$$ffc638203e092686$var$notificationDescriptionContainerStyles = (0, $74Zh5.css)({
    marginTop: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.100"),
    marginBottom: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.150")
});
const $24c02ea0e14dbe4f$var$$ffc638203e092686$var$linkContainerStyles = (0, $74Zh5.css)({
    a: {
        "&:hover": {
            textDecoration: "none"
        }
    }
});
var $24c02ea0e14dbe4f$var$$4dfe37aba1865d88$exports = {};
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$4dfe37aba1865d88$exports, "CustomerInfoForm", ()=>$24c02ea0e14dbe4f$export$6415ce2f4ef17e20);
const $24c02ea0e14dbe4f$var$$292473fda2395210$export$1d1c4391ecac81e8 = async ()=>{
    const result = await fetch(`https://www.atlassian.com/hamlet/1.0/public/country/taas/all`);
    if (!result.ok) throw Error("Unable to fetch countries");
    return (await result.json()).countryList;
};
const $24c02ea0e14dbe4f$var$$292473fda2395210$export$2bc3cba6f94d7400 = async (isoCountryCode)=>{
    const result = await fetch(`https://www.atlassian.com/hamlet/1.0/public/country/taas/findByIso/${isoCountryCode}`);
    if (!result.ok) throw Error("Unable to fetch states");
    return result.json();
};
const $24c02ea0e14dbe4f$var$$4dfe37aba1865d88$var$rowStyles = (0, $74Zh5.css)({
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    gap: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.200")
});
const $24c02ea0e14dbe4f$var$$4dfe37aba1865d88$var$fieldBlock = (0, $74Zh5.css)({
    marginBottom: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.200")
});
const $24c02ea0e14dbe4f$var$$4dfe37aba1865d88$var$selectContainer = (0, $74Zh5.css)({
    maxWidth: "420px"
});
const $24c02ea0e14dbe4f$export$6415ce2f4ef17e20 = ({ onSubmit: onSubmit })=>{
    const [countries, setCountries] = (0, $5FkrB.useState)([]);
    const [selectedCountry, setSelectedCountry] = (0, $5FkrB.useState)(null);
    const [states, setStates] = (0, $5FkrB.useState)([]);
    (0, $5FkrB.useEffect)(()=>{
        let mounted = true;
        (async ()=>{
            try {
                const list = await $24c02ea0e14dbe4f$var$$292473fda2395210$export$1d1c4391ecac81e8();
                if (!mounted) return;
                setCountries(list);
                const us = list.find((c)=>c.isoCountryCode === "US" || c.countryIsoCode === "US" || c.displayName === "United States");
                if (us) setSelectedCountry(us);
            } catch  {
            // ignore network errors in Storybook/local environments
            }
        })();
        return ()=>{
            mounted = false;
        };
    }, []);
    (0, $5FkrB.useEffect)(()=>{
        let mounted = true;
        (async ()=>{
            if (!selectedCountry) {
                setStates([]);
                return;
            }
            if (selectedCountry.states && selectedCountry.states.length) {
                setStates(selectedCountry.states);
                return;
            }
            try {
                const detailed = await $24c02ea0e14dbe4f$var$$292473fda2395210$export$2bc3cba6f94d7400(selectedCountry.isoCountryCode || selectedCountry.countryIsoCode);
                if (!mounted) return;
                setStates(detailed.states || []);
            } catch  {
                setStates([]);
            }
        })();
        return ()=>{
            mounted = false;
        };
    }, [
        selectedCountry
    ]);
    const countryOptions = (0, $5FkrB.useMemo)(()=>countries.map((c)=>({
                label: c.displayName || c.countryIsoCode,
                value: c.isoCountryCode || c.countryIsoCode,
                data: c
            })), [
        countries
    ]);
    const stateOptions = (0, $5FkrB.useMemo)(()=>states.map((s)=>({
                label: s.name,
                value: s.code
            })), [
        states
    ]);
    const selectedCountryOption = (0, $5FkrB.useMemo)(()=>{
        if (!selectedCountry) return null;
        return {
            label: selectedCountry.displayName || selectedCountry.countryIsoCode,
            value: selectedCountry.isoCountryCode || selectedCountry.countryIsoCode,
            data: selectedCountry
        };
    }, [
        selectedCountry
    ]);
    return (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $916dd591feb93e13$export$2e2bcd8739ae039), {
        onSubmit: onSubmit,
        children: ({ formProps: formProps })=>(0, $6bec4f26b2cb3094$export$25062201e9e25d76)("form", {
                ...formProps,
                noValidate: true,
                children: [
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                        css: (0, $74Zh5.css)({
                            marginBottom: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.250")
                        }),
                        children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$a8a3e93435678ff9, {
                            level: 4,
                            children: "Customer Information"
                        })
                    }),
                    (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                        css: [
                            $24c02ea0e14dbe4f$var$$4dfe37aba1865d88$var$rowStyles,
                            $24c02ea0e14dbe4f$var$$4dfe37aba1865d88$var$fieldBlock
                        ],
                        children: [
                            (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                                children: [
                                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $5ac1013239c7eb7f$export$b04be29aa201d4f5), {
                                        htmlFor: "first-name",
                                        children: "First Name"
                                    }),
                                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $2111f5e4df021534$export$2e2bcd8739ae039), {
                                        name: "firstName",
                                        defaultValue: "",
                                        children: ({ fieldProps: fieldProps })=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$2c73285ae9390cec, {
                                                ...fieldProps,
                                                id: "first-name",
                                                placeholder: "First Name",
                                                required: true
                                            })
                                    })
                                ]
                            }),
                            (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                                children: [
                                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $5ac1013239c7eb7f$export$b04be29aa201d4f5), {
                                        htmlFor: "last-name",
                                        children: "Last Name"
                                    }),
                                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $2111f5e4df021534$export$2e2bcd8739ae039), {
                                        name: "lastName",
                                        defaultValue: "",
                                        children: ({ fieldProps: fieldProps })=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$2c73285ae9390cec, {
                                                ...fieldProps,
                                                id: "last-name",
                                                placeholder: "Last Name",
                                                required: true
                                            })
                                    })
                                ]
                            })
                        ]
                    }),
                    (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                        css: $24c02ea0e14dbe4f$var$$4dfe37aba1865d88$var$fieldBlock,
                        children: [
                            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $5ac1013239c7eb7f$export$b04be29aa201d4f5), {
                                htmlFor: "address1",
                                children: "Address"
                            }),
                            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $2111f5e4df021534$export$2e2bcd8739ae039), {
                                name: "address1",
                                defaultValue: "",
                                children: ({ fieldProps: fieldProps })=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$2c73285ae9390cec, {
                                        ...fieldProps,
                                        id: "address1",
                                        placeholder: "Address",
                                        required: true
                                    })
                            })
                        ]
                    }),
                    (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                        css: $24c02ea0e14dbe4f$var$$4dfe37aba1865d88$var$fieldBlock,
                        children: [
                            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $5ac1013239c7eb7f$export$b04be29aa201d4f5), {
                                htmlFor: "address2",
                                children: "Address Line 2 (Optional)"
                            }),
                            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $2111f5e4df021534$export$2e2bcd8739ae039), {
                                name: "address2",
                                defaultValue: "",
                                children: ({ fieldProps: fieldProps })=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$2c73285ae9390cec, {
                                        ...fieldProps,
                                        id: "address2",
                                        placeholder: "Address Line 2"
                                    })
                            })
                        ]
                    }),
                    (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                        css: $24c02ea0e14dbe4f$var$$4dfe37aba1865d88$var$fieldBlock,
                        children: [
                            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $5ac1013239c7eb7f$export$b04be29aa201d4f5), {
                                htmlFor: "city",
                                children: "City"
                            }),
                            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $2111f5e4df021534$export$2e2bcd8739ae039), {
                                name: "city",
                                defaultValue: "",
                                children: ({ fieldProps: fieldProps })=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$2c73285ae9390cec, {
                                        ...fieldProps,
                                        id: "city",
                                        placeholder: "City",
                                        required: true
                                    })
                            })
                        ]
                    }),
                    (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                        css: [
                            $24c02ea0e14dbe4f$var$$4dfe37aba1865d88$var$rowStyles,
                            $24c02ea0e14dbe4f$var$$4dfe37aba1865d88$var$fieldBlock
                        ],
                        children: [
                            (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                                children: [
                                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $5ac1013239c7eb7f$export$b04be29aa201d4f5), {
                                        htmlFor: "country",
                                        children: "Country"
                                    }),
                                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $2111f5e4df021534$export$2e2bcd8739ae039), {
                                        name: "country",
                                        defaultValue: selectedCountryOption,
                                        children: ({ fieldProps: { value: value, onChange: onChange } })=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                                                css: $24c02ea0e14dbe4f$var$$4dfe37aba1865d88$var$selectContainer,
                                                children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $6b35e1e8c8ac06e7$export$2e2bcd8739ae039), {
                                                    inputId: "country",
                                                    options: countryOptions,
                                                    value: value || selectedCountryOption,
                                                    placeholder: "Select country",
                                                    onChange: (opt)=>{
                                                        onChange(opt);
                                                        const countryData = opt?.data;
                                                        setSelectedCountry(countryData || null);
                                                    }
                                                })
                                            })
                                    })
                                ]
                            }),
                            (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                                children: [
                                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $5ac1013239c7eb7f$export$b04be29aa201d4f5), {
                                        htmlFor: "state",
                                        children: "State"
                                    }),
                                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $2111f5e4df021534$export$2e2bcd8739ae039), {
                                        name: "state",
                                        defaultValue: null,
                                        children: ({ fieldProps: { value: value, onChange: onChange } })=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                                                css: $24c02ea0e14dbe4f$var$$4dfe37aba1865d88$var$selectContainer,
                                                children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $6b35e1e8c8ac06e7$export$2e2bcd8739ae039), {
                                                    inputId: "state",
                                                    options: stateOptions,
                                                    value: value,
                                                    placeholder: "Select state",
                                                    isDisabled: !selectedCountry,
                                                    onChange: (opt)=>onChange(opt)
                                                })
                                            })
                                    })
                                ]
                            })
                        ]
                    }),
                    (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                        css: [
                            $24c02ea0e14dbe4f$var$$4dfe37aba1865d88$var$rowStyles,
                            $24c02ea0e14dbe4f$var$$4dfe37aba1865d88$var$fieldBlock
                        ],
                        children: [
                            (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                                children: [
                                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $5ac1013239c7eb7f$export$b04be29aa201d4f5), {
                                        htmlFor: "postcode",
                                        children: "Zip Code"
                                    }),
                                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $2111f5e4df021534$export$2e2bcd8739ae039), {
                                        name: "postcode",
                                        defaultValue: "",
                                        children: ({ fieldProps: fieldProps })=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$2c73285ae9390cec, {
                                                ...fieldProps,
                                                id: "postcode",
                                                placeholder: "Zip Code",
                                                required: true
                                            })
                                    })
                                ]
                            }),
                            (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                                children: [
                                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $5ac1013239c7eb7f$export$b04be29aa201d4f5), {
                                        htmlFor: "phone",
                                        children: "Phone Number"
                                    }),
                                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $2111f5e4df021534$export$2e2bcd8739ae039), {
                                        name: "phone",
                                        defaultValue: "",
                                        children: ({ fieldProps: fieldProps })=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$2c73285ae9390cec, {
                                                ...fieldProps,
                                                id: "phone",
                                                placeholder: "Phone Number",
                                                type: "tel",
                                                required: true
                                            })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
    });
};
var $24c02ea0e14dbe4f$var$$556680ce820612ab$exports = {};
$24c02ea0e14dbe4f$var$$parcel$defineInteropFlag($24c02ea0e14dbe4f$var$$556680ce820612ab$exports);
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$556680ce820612ab$exports, "PaymentInfoForm", ()=>$24c02ea0e14dbe4f$export$f950880927ff03db);
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$556680ce820612ab$exports, "default", ()=>$24c02ea0e14dbe4f$var$$556680ce820612ab$export$2e2bcd8739ae039);
const $24c02ea0e14dbe4f$var$$556680ce820612ab$var$rowStyles = (0, $74Zh5.css)({
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    gap: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.200")
});
const $24c02ea0e14dbe4f$var$$556680ce820612ab$var$fieldBlock = (0, $74Zh5.css)({
    marginBottom: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.200")
});
const $24c02ea0e14dbe4f$var$$556680ce820612ab$var$selectContainer = (0, $74Zh5.css)({
    maxWidth: "220px"
});
const $24c02ea0e14dbe4f$var$$556680ce820612ab$var$onlyDigits = (s)=>s.replace(/\D+/g, "");
const $24c02ea0e14dbe4f$var$$556680ce820612ab$var$formatCardNumber = (value)=>{
    const digits = $24c02ea0e14dbe4f$var$$556680ce820612ab$var$onlyDigits(value).slice(0, 19); // support up to 19 digits
    // group into 4s: 4-4-4-4-3
    const groups = [];
    for(let i = 0; i < digits.length; i += 4)groups.push(digits.slice(i, i + 4));
    return groups.join(" ").trim();
};
const $24c02ea0e14dbe4f$var$$556680ce820612ab$var$luhnCheck = (value)=>{
    const digits = $24c02ea0e14dbe4f$var$$556680ce820612ab$var$onlyDigits(value);
    if (digits.length < 12) return false;
    // basic length gate
    let sum = 0;
    let shouldDouble = false;
    for(let i = digits.length - 1; i >= 0; i--){
        let digit = parseInt(digits.charAt(i), 10);
        if (shouldDouble) {
            digit *= 2;
            if (digit > 9) digit -= 9;
        }
        sum += digit;
        shouldDouble = !shouldDouble;
    }
    return sum % 10 === 0;
};
const $24c02ea0e14dbe4f$var$$556680ce820612ab$var$isExpiryInPast = (month, year)=>{
    if (!month || !year) return false;
    // incomplete fields handled elsewhere
    const now = new Date();
    const currentYear = now.getFullYear();
    const currentMonth = now.getMonth() + 1; // 1-12
    if (year < currentYear) return true;
    if (year === currentYear && month < currentMonth) return true;
    return false;
};
const $24c02ea0e14dbe4f$export$f950880927ff03db = ({ onSubmit: onSubmit })=>{
    const monthOptions = (0, $5FkrB.useMemo)(()=>Array.from({
            length: 12
        }, (_, i)=>{
            const m = i + 1;
            const label = m < 10 ? `0${m}` : `${m}`;
            return {
                label: label,
                value: m
            };
        }), []);
    const yearOptions = (0, $5FkrB.useMemo)(()=>{
        const now = new Date();
        const start = now.getFullYear();
        const end = start + 20;
        const arr = [];
        for(let y = start; y <= end; y++)arr.push({
            label: `${y}`,
            value: y
        });
        return arr;
    }, []);
    return (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $916dd591feb93e13$export$2e2bcd8739ae039), {
        onSubmit: (values)=>{
            // normalize values before submit
            const normalized = {
                ...values,
                cardNumber: $24c02ea0e14dbe4f$var$$556680ce820612ab$var$onlyDigits(values.cardNumber || "")
            };
            return onSubmit(normalized);
        },
        children: ({ formProps: formProps })=>(0, $6bec4f26b2cb3094$export$25062201e9e25d76)("form", {
                ...formProps,
                noValidate: true,
                children: [
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                        css: (0, $74Zh5.css)({
                            marginBottom: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.250")
                        }),
                        children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$a8a3e93435678ff9, {
                            level: 4,
                            children: "Payment Information"
                        })
                    }),
                    (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                        css: $24c02ea0e14dbe4f$var$$556680ce820612ab$var$fieldBlock,
                        children: [
                            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $5ac1013239c7eb7f$export$b04be29aa201d4f5), {
                                htmlFor: "cardholder-name",
                                children: "Name on card"
                            }),
                            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $2111f5e4df021534$export$2e2bcd8739ae039), {
                                name: "cardholderName",
                                defaultValue: "",
                                validate: (v)=>!v ? "Required" : undefined,
                                children: ({ fieldProps: fieldProps, error: error })=>(0, $6bec4f26b2cb3094$export$25062201e9e25d76)((0, $6bec4f26b2cb3094$export$ffb0004e005737fa), {
                                        children: [
                                            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$2c73285ae9390cec, {
                                                ...fieldProps,
                                                id: "cardholder-name",
                                                placeholder: "Name on card",
                                                required: true
                                            }),
                                            error && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                                                role: "alert",
                                                style: {
                                                    color: "#C9372C",
                                                    fontSize: 12
                                                },
                                                children: error
                                            })
                                        ]
                                    })
                            })
                        ]
                    }),
                    (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                        css: $24c02ea0e14dbe4f$var$$556680ce820612ab$var$fieldBlock,
                        children: [
                            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $5ac1013239c7eb7f$export$b04be29aa201d4f5), {
                                htmlFor: "card-number",
                                children: "Card number"
                            }),
                            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $2111f5e4df021534$export$2e2bcd8739ae039), {
                                name: "cardNumber",
                                defaultValue: "",
                                validate: (v)=>{
                                    if (!v) return "Required";
                                    const digits = $24c02ea0e14dbe4f$var$$556680ce820612ab$var$onlyDigits(v);
                                    if (digits.length < 12) return "Enter a valid card number";
                                    if (!$24c02ea0e14dbe4f$var$$556680ce820612ab$var$luhnCheck(v)) return "Enter a valid card number";
                                    return undefined;
                                },
                                children: ({ fieldProps: fieldProps, error: error })=>{
                                    const { onChange: onChange, value: value, ...rest } = fieldProps;
                                    return (0, $6bec4f26b2cb3094$export$25062201e9e25d76)((0, $6bec4f26b2cb3094$export$ffb0004e005737fa), {
                                        children: [
                                            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$2c73285ae9390cec, {
                                                ...rest,
                                                id: "card-number",
                                                placeholder: "1234 5678 9012 3456",
                                                inputMode: "numeric",
                                                autoComplete: "cc-number",
                                                value: $24c02ea0e14dbe4f$var$$556680ce820612ab$var$formatCardNumber(String(value ?? "")),
                                                onChange: (e)=>onChange($24c02ea0e14dbe4f$var$$556680ce820612ab$var$formatCardNumber(e.target.value)),
                                                required: true
                                            }),
                                            error && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                                                role: "alert",
                                                style: {
                                                    color: "#C9372C",
                                                    fontSize: 12
                                                },
                                                children: error
                                            })
                                        ]
                                    });
                                }
                            })
                        ]
                    }),
                    (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                        css: [
                            $24c02ea0e14dbe4f$var$$556680ce820612ab$var$rowStyles,
                            $24c02ea0e14dbe4f$var$$556680ce820612ab$var$fieldBlock
                        ],
                        children: [
                            (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                                children: [
                                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $5ac1013239c7eb7f$export$b04be29aa201d4f5), {
                                        htmlFor: "expiry-month",
                                        children: "Expiry month"
                                    }),
                                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $2111f5e4df021534$export$2e2bcd8739ae039), {
                                        name: "expiryMonth",
                                        defaultValue: null,
                                        // @ts-expect-error - @atlaskit/form validate signature doesn't expose proper types for cross-field validation
                                        validate: (v, _, values)=>{
                                            if (!v) return "Required";
                                            const monthVal = v?.value;
                                            const yearVal = values?.expiryYear?.value;
                                            if (monthVal && yearVal && $24c02ea0e14dbe4f$var$$556680ce820612ab$var$isExpiryInPast(monthVal, yearVal)) return "Card has expired";
                                            return undefined;
                                        },
                                        children: ({ fieldProps: { value: value, onChange: onChange }, error: error })=>(0, $6bec4f26b2cb3094$export$25062201e9e25d76)((0, $6bec4f26b2cb3094$export$ffb0004e005737fa), {
                                                children: [
                                                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                                                        css: $24c02ea0e14dbe4f$var$$556680ce820612ab$var$selectContainer,
                                                        children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $6b35e1e8c8ac06e7$export$2e2bcd8739ae039), {
                                                            inputId: "expiry-month",
                                                            options: monthOptions,
                                                            value: value,
                                                            placeholder: "MM",
                                                            onChange: (opt)=>onChange(opt)
                                                        })
                                                    }),
                                                    error && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                                                        role: "alert",
                                                        style: {
                                                            color: "#C9372C",
                                                            fontSize: 12
                                                        },
                                                        children: error
                                                    })
                                                ]
                                            })
                                    })
                                ]
                            }),
                            (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                                children: [
                                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $5ac1013239c7eb7f$export$b04be29aa201d4f5), {
                                        htmlFor: "expiry-year",
                                        children: "Expiry year"
                                    }),
                                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $2111f5e4df021534$export$2e2bcd8739ae039), {
                                        name: "expiryYear",
                                        defaultValue: null,
                                        // @ts-expect-error - @atlaskit/form validate signature doesn't expose proper types for cross-field validation
                                        validate: (v, _, values)=>{
                                            // cross validate month/year when both exist
                                            const monthVal = values?.expiryMonth?.value;
                                            const yearVal = v?.value;
                                            if (!v) return "Required";
                                            if (monthVal && yearVal && $24c02ea0e14dbe4f$var$$556680ce820612ab$var$isExpiryInPast(monthVal, yearVal)) return "Card has expired";
                                            return undefined;
                                        },
                                        children: ({ fieldProps: { value: value, onChange: onChange }, error: error })=>(0, $6bec4f26b2cb3094$export$25062201e9e25d76)((0, $6bec4f26b2cb3094$export$ffb0004e005737fa), {
                                                children: [
                                                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                                                        css: $24c02ea0e14dbe4f$var$$556680ce820612ab$var$selectContainer,
                                                        children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $6b35e1e8c8ac06e7$export$2e2bcd8739ae039), {
                                                            inputId: "expiry-year",
                                                            options: yearOptions,
                                                            value: value,
                                                            placeholder: "YYYY",
                                                            onChange: (opt)=>onChange(opt)
                                                        })
                                                    }),
                                                    error && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                                                        role: "alert",
                                                        style: {
                                                            color: "#C9372C",
                                                            fontSize: 12
                                                        },
                                                        children: error
                                                    })
                                                ]
                                            })
                                    })
                                ]
                            })
                        ]
                    }),
                    (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                        css: $24c02ea0e14dbe4f$var$$556680ce820612ab$var$fieldBlock,
                        children: [
                            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $5ac1013239c7eb7f$export$b04be29aa201d4f5), {
                                htmlFor: "cvc",
                                children: "Security code (CVC)"
                            }),
                            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $2111f5e4df021534$export$2e2bcd8739ae039), {
                                name: "cvc",
                                defaultValue: "",
                                validate: (v)=>{
                                    if (!v) return "Required";
                                    const digits = $24c02ea0e14dbe4f$var$$556680ce820612ab$var$onlyDigits(v);
                                    if (digits.length < 3 || digits.length > 4) return "Enter a valid CVC";
                                    return undefined;
                                },
                                children: ({ fieldProps: fieldProps, error: error })=>{
                                    const { onChange: onChange, value: value, ...rest } = fieldProps;
                                    return (0, $6bec4f26b2cb3094$export$25062201e9e25d76)((0, $6bec4f26b2cb3094$export$ffb0004e005737fa), {
                                        children: [
                                            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$2c73285ae9390cec, {
                                                ...rest,
                                                id: "cvc",
                                                placeholder: "CVC",
                                                type: "password",
                                                inputMode: "numeric",
                                                autoComplete: "cc-csc",
                                                value: $24c02ea0e14dbe4f$var$$556680ce820612ab$var$onlyDigits(String(value ?? "")).slice(0, 4),
                                                onChange: (e)=>onChange($24c02ea0e14dbe4f$var$$556680ce820612ab$var$onlyDigits(e.target.value).slice(0, 4)),
                                                required: true
                                            }),
                                            error && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                                                role: "alert",
                                                style: {
                                                    color: "#C9372C",
                                                    fontSize: 12
                                                },
                                                children: error
                                            })
                                        ]
                                    });
                                }
                            })
                        ]
                    })
                ]
            })
    });
};
var $24c02ea0e14dbe4f$var$$556680ce820612ab$export$2e2bcd8739ae039 = $24c02ea0e14dbe4f$export$f950880927ff03db;
var $24c02ea0e14dbe4f$var$$6a8b328ff2ec0580$exports = {};
$24c02ea0e14dbe4f$var$$parcel$defineInteropFlag($24c02ea0e14dbe4f$var$$6a8b328ff2ec0580$exports);
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$6a8b328ff2ec0580$exports, "CheckoutSummary", ()=>$24c02ea0e14dbe4f$export$fde280adb8350d09);
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$6a8b328ff2ec0580$exports, "default", ()=>$24c02ea0e14dbe4f$var$$6a8b328ff2ec0580$export$2e2bcd8739ae039);
const $24c02ea0e14dbe4f$var$$6a8b328ff2ec0580$var$asCurrency = (amountInCents, currency = "USD")=>{
    try {
        return new Intl.NumberFormat("en-US", {
            style: "currency",
            currency: currency
        }).format(amountInCents / 100);
    } catch  {
        return `$${(amountInCents / 100).toFixed(2)}`;
    }
};
const $24c02ea0e14dbe4f$export$fde280adb8350d09 = ({ subtotal: subtotal, salesTax: salesTax, total: total, items: items, paymentMethod: paymentMethod, currency: currency = "USD" })=>{
    const [isOpen, setIsOpen] = (0, $5FkrB.useState)(false);
    const itemCountText = (0, $5FkrB.useMemo)(()=>`${items.length} item${items.length === 1 ? "" : "s"}`, [
        items.length
    ]);
    return (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
        css: $24c02ea0e14dbe4f$var$$6a8b328ff2ec0580$var$containerStyles,
        children: [
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$a8a3e93435678ff9, {
                level: 4,
                children: "Summary"
            }),
            (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                css: $24c02ea0e14dbe4f$var$$6a8b328ff2ec0580$var$rowStyles,
                children: [
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$5f1af8db9871e1d6, {
                        children: "Subtotal"
                    }),
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$5f1af8db9871e1d6, {
                        children: $24c02ea0e14dbe4f$var$$6a8b328ff2ec0580$var$asCurrency(subtotal, currency)
                    })
                ]
            }),
            (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                css: $24c02ea0e14dbe4f$var$$6a8b328ff2ec0580$var$rowStyles,
                children: [
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$5f1af8db9871e1d6, {
                        children: "Sales Tax"
                    }),
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$5f1af8db9871e1d6, {
                        children: $24c02ea0e14dbe4f$var$$6a8b328ff2ec0580$var$asCurrency(salesTax, currency)
                    })
                ]
            }),
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                css: $24c02ea0e14dbe4f$var$$6a8b328ff2ec0580$var$dividerStyles
            }),
            (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                css: [
                    $24c02ea0e14dbe4f$var$$6a8b328ff2ec0580$var$rowStyles,
                    (0, $74Zh5.css)({
                        marginTop: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.150")
                    })
                ],
                children: [
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$a8a3e93435678ff9, {
                        level: 6,
                        children: "Total"
                    }),
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$a8a3e93435678ff9, {
                        level: 6,
                        children: $24c02ea0e14dbe4f$var$$6a8b328ff2ec0580$var$asCurrency(total, currency)
                    })
                ]
            }),
            (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                css: $24c02ea0e14dbe4f$var$$6a8b328ff2ec0580$var$paymentMethodRowStyles,
                children: [
                    (0, $6bec4f26b2cb3094$export$25062201e9e25d76)($24c02ea0e14dbe4f$export$5f1af8db9871e1d6, {
                        size: "small",
                        color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text.subtlest"),
                        children: [
                            "Payment Method: ",
                            paymentMethod
                        ]
                    }),
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$5f1af8db9871e1d6, {
                        size: "small",
                        color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text.subtlest"),
                        children: itemCountText
                    })
                ]
            }),
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                css: $24c02ea0e14dbe4f$var$$6a8b328ff2ec0580$var$buttonRowStyles,
                children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$353f5b6fc5456de1, {
                    label: "Review Purchase",
                    appearance: $24c02ea0e14dbe4f$export$261c9483fc4a455a.PRIMARY,
                    fullWidth: true,
                    size: $24c02ea0e14dbe4f$export$5dd2748b7940a2a0.LARGE,
                    onClick: ()=>setIsOpen(true)
                })
            }),
            isOpen && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $73c4314b1cf0d4b0$export$2e2bcd8739ae039), {
                onClose: ()=>setIsOpen(false),
                children: (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                    css: $24c02ea0e14dbe4f$var$$6a8b328ff2ec0580$var$modalContainerStyles,
                    children: [
                        (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                            css: $24c02ea0e14dbe4f$var$$6a8b328ff2ec0580$var$modalHeaderStyles,
                            children: [
                                (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$a8a3e93435678ff9, {
                                    level: 3,
                                    children: "Review and Confirm"
                                }),
                                (0, $6bec4f26b2cb3094$export$25062201e9e25d76)($24c02ea0e14dbe4f$export$5f1af8db9871e1d6, {
                                    size: "small",
                                    color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text.subtlest"),
                                    children: [
                                        currency,
                                        " \u2022 ",
                                        paymentMethod
                                    ]
                                })
                            ]
                        }),
                        (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                            css: $24c02ea0e14dbe4f$var$$6a8b328ff2ec0580$var$modalSectionStyles,
                            children: items.map((item, idx)=>(0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                                    css: $24c02ea0e14dbe4f$var$$6a8b328ff2ec0580$var$itemRowStyles,
                                    children: [
                                        (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$5f1af8db9871e1d6, {
                                            children: item.name
                                        }),
                                        (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$5f1af8db9871e1d6, {
                                            children: $24c02ea0e14dbe4f$var$$6a8b328ff2ec0580$var$asCurrency(item.price, currency)
                                        })
                                    ]
                                }, `${item.name}-${idx}`))
                        }),
                        (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                            css: $24c02ea0e14dbe4f$var$$6a8b328ff2ec0580$var$dividerStyles
                        }),
                        (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                            css: $24c02ea0e14dbe4f$var$$6a8b328ff2ec0580$var$modalTotalsStyles,
                            children: [
                                (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                                    css: $24c02ea0e14dbe4f$var$$6a8b328ff2ec0580$var$itemRowStyles,
                                    children: [
                                        (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$5f1af8db9871e1d6, {
                                            children: "Subtotal"
                                        }),
                                        (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$5f1af8db9871e1d6, {
                                            children: $24c02ea0e14dbe4f$var$$6a8b328ff2ec0580$var$asCurrency(subtotal, currency)
                                        })
                                    ]
                                }),
                                (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                                    css: $24c02ea0e14dbe4f$var$$6a8b328ff2ec0580$var$itemRowStyles,
                                    children: [
                                        (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$5f1af8db9871e1d6, {
                                            children: "Sales Tax"
                                        }),
                                        (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$5f1af8db9871e1d6, {
                                            children: $24c02ea0e14dbe4f$var$$6a8b328ff2ec0580$var$asCurrency(salesTax, currency)
                                        })
                                    ]
                                }),
                                (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                                    css: [
                                        $24c02ea0e14dbe4f$var$$6a8b328ff2ec0580$var$itemRowStyles,
                                        (0, $74Zh5.css)({
                                            marginTop: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.150")
                                        })
                                    ],
                                    children: [
                                        (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$a8a3e93435678ff9, {
                                            level: 6,
                                            children: "Total"
                                        }),
                                        (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$a8a3e93435678ff9, {
                                            level: 6,
                                            children: $24c02ea0e14dbe4f$var$$6a8b328ff2ec0580$var$asCurrency(total, currency)
                                        })
                                    ]
                                })
                            ]
                        }),
                        (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                            css: $24c02ea0e14dbe4f$var$$6a8b328ff2ec0580$var$modalButtonRowStyles,
                            children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$353f5b6fc5456de1, {
                                label: "Confirm Purchase",
                                appearance: $24c02ea0e14dbe4f$export$261c9483fc4a455a.PRIMARY,
                                onClick: ()=>setIsOpen(false)
                            })
                        })
                    ]
                })
            })
        ]
    });
};
const $24c02ea0e14dbe4f$var$$6a8b328ff2ec0580$var$containerStyles = (0, $74Zh5.css)({
    padding: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.300"),
    border: `1px solid ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.border")}`,
    borderRadius: "8px",
    backgroundColor: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.background.input")
});
const $24c02ea0e14dbe4f$var$$6a8b328ff2ec0580$var$rowStyles = (0, $74Zh5.css)({
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    paddingTop: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.100")
});
const $24c02ea0e14dbe4f$var$$6a8b328ff2ec0580$var$dividerStyles = (0, $74Zh5.css)({
    height: 1,
    backgroundColor: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.border"),
    marginTop: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.250")
});
const $24c02ea0e14dbe4f$var$$6a8b328ff2ec0580$var$paymentMethodRowStyles = (0, $74Zh5.css)({
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    marginTop: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.100")
});
const $24c02ea0e14dbe4f$var$$6a8b328ff2ec0580$var$buttonRowStyles = (0, $74Zh5.css)({
    marginTop: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.300")
});
const $24c02ea0e14dbe4f$var$$6a8b328ff2ec0580$var$modalContainerStyles = (0, $74Zh5.css)({
    padding: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.300"),
    backgroundColor: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.background.input"),
    borderRadius: "8px",
    minWidth: "560px"
});
const $24c02ea0e14dbe4f$var$$6a8b328ff2ec0580$var$modalHeaderStyles = (0, $74Zh5.css)({
    marginBottom: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.300")
});
const $24c02ea0e14dbe4f$var$$6a8b328ff2ec0580$var$modalSectionStyles = (0, $74Zh5.css)({
    display: "flex",
    flexDirection: "column",
    gap: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.100")
});
const $24c02ea0e14dbe4f$var$$6a8b328ff2ec0580$var$itemRowStyles = (0, $74Zh5.css)({
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between"
});
const $24c02ea0e14dbe4f$var$$6a8b328ff2ec0580$var$modalTotalsStyles = (0, $74Zh5.css)({
    marginTop: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.250")
});
const $24c02ea0e14dbe4f$var$$6a8b328ff2ec0580$var$modalButtonRowStyles = (0, $74Zh5.css)({
    marginTop: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.400"),
    display: "flex",
    justifyContent: "center"
});
var $24c02ea0e14dbe4f$var$$6a8b328ff2ec0580$export$2e2bcd8739ae039 = $24c02ea0e14dbe4f$export$fde280adb8350d09;
var $24c02ea0e14dbe4f$var$$2397677ef2f4ee69$exports = {};
$24c02ea0e14dbe4f$var$$parcel$defineInteropFlag($24c02ea0e14dbe4f$var$$2397677ef2f4ee69$exports);
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$2397677ef2f4ee69$exports, "Orders", ()=>$24c02ea0e14dbe4f$export$ed0df17bf864fd7b);
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$2397677ef2f4ee69$exports, "default", ()=>$24c02ea0e14dbe4f$var$$2397677ef2f4ee69$export$2e2bcd8739ae039);
const $24c02ea0e14dbe4f$var$$2397677ef2f4ee69$var$containerStyles = (0, $74Zh5.css)({
    padding: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.300"),
    border: `1px solid ${(0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.border")}`,
    borderRadius: "8px",
    backgroundColor: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.background.input")
});
const $24c02ea0e14dbe4f$var$$2397677ef2f4ee69$var$headerStyles = (0, $74Zh5.css)({
    marginBottom: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("space.200")
});
const $24c02ea0e14dbe4f$var$$2397677ef2f4ee69$var$amountToUsd = (amount)=>{
    const dollars = (amount / 100).toFixed(2);
    return `USD $${dollars}`;
};
const $24c02ea0e14dbe4f$export$ed0df17bf864fd7b = ({ orders: orders })=>{
    return (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
        css: $24c02ea0e14dbe4f$var$$2397677ef2f4ee69$var$containerStyles,
        children: [
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                css: $24c02ea0e14dbe4f$var$$2397677ef2f4ee69$var$headerStyles,
                children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$a8a3e93435678ff9, {
                    level: 4,
                    children: "Transactions"
                })
            }),
            (0, $6bec4f26b2cb3094$export$25062201e9e25d76)((0, $1c9849e9ca2bf87c$export$2e2bcd8739ae039), {
                children: [
                    (0, $6bec4f26b2cb3094$export$25062201e9e25d76)((0, $46ca8edaccb96b62$export$2e2bcd8739ae039), {
                        children: [
                            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $017ea8a39e3f2896$export$2e2bcd8739ae039), {
                                width: "20%",
                                children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$5f1af8db9871e1d6, {
                                    size: "small",
                                    color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text.subtlest"),
                                    children: "Date"
                                })
                            }),
                            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $017ea8a39e3f2896$export$2e2bcd8739ae039), {
                                children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$5f1af8db9871e1d6, {
                                    size: "small",
                                    color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text.subtlest"),
                                    children: "Purchase Info"
                                })
                            }),
                            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $017ea8a39e3f2896$export$2e2bcd8739ae039), {
                                width: "20%",
                                children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$5f1af8db9871e1d6, {
                                    size: "small",
                                    color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text.subtlest"),
                                    children: "Payment Method"
                                })
                            }),
                            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $017ea8a39e3f2896$export$2e2bcd8739ae039), {
                                width: "20%",
                                children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$5f1af8db9871e1d6, {
                                    size: "small",
                                    color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.text.subtlest"),
                                    children: "Price"
                                })
                            })
                        ]
                    }),
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $722a9df093eb8cc5$export$2e2bcd8739ae039), {
                        children: orders.map((o)=>(0, $6bec4f26b2cb3094$export$25062201e9e25d76)((0, $1df2a8a5055de686$export$2e2bcd8739ae039), {
                                children: [
                                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $db2ca91e0d53ac06$export$9cf5b401f969f5e3), {
                                        children: o.date
                                    }),
                                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $db2ca91e0d53ac06$export$9cf5b401f969f5e3), {
                                        children: o.summary
                                    }),
                                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $db2ca91e0d53ac06$export$9cf5b401f969f5e3), {
                                        children: o.paymentMethod
                                    }),
                                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $db2ca91e0d53ac06$export$9cf5b401f969f5e3), {
                                        children: $24c02ea0e14dbe4f$var$$2397677ef2f4ee69$var$amountToUsd(o.totalAmount)
                                    })
                                ]
                            }, o.id))
                    })
                ]
            })
        ]
    });
};
var $24c02ea0e14dbe4f$var$$2397677ef2f4ee69$export$2e2bcd8739ae039 = $24c02ea0e14dbe4f$export$ed0df17bf864fd7b;
$24c02ea0e14dbe4f$var$$parcel$exportWildcard($24c02ea0e14dbe4f$var$$6e379ec2eca3d7d3$exports, $24c02ea0e14dbe4f$var$$83fc18f8199a12ff$exports);
$24c02ea0e14dbe4f$var$$parcel$exportWildcard($24c02ea0e14dbe4f$var$$6e379ec2eca3d7d3$exports, $24c02ea0e14dbe4f$var$$438c82700c218044$exports);
$24c02ea0e14dbe4f$var$$parcel$exportWildcard($24c02ea0e14dbe4f$var$$6e379ec2eca3d7d3$exports, $24c02ea0e14dbe4f$var$$389dbaf1c04dd698$exports);
$24c02ea0e14dbe4f$var$$parcel$exportWildcard($24c02ea0e14dbe4f$var$$6e379ec2eca3d7d3$exports, $24c02ea0e14dbe4f$var$$c18917e553fd2737$exports);
$24c02ea0e14dbe4f$var$$parcel$exportWildcard($24c02ea0e14dbe4f$var$$6e379ec2eca3d7d3$exports, $24c02ea0e14dbe4f$var$$3ca3d702a74367ba$exports);
$24c02ea0e14dbe4f$var$$parcel$exportWildcard($24c02ea0e14dbe4f$var$$6e379ec2eca3d7d3$exports, $24c02ea0e14dbe4f$var$$e018ab7ed2648ae8$exports);
$24c02ea0e14dbe4f$var$$parcel$exportWildcard($24c02ea0e14dbe4f$var$$6e379ec2eca3d7d3$exports, $24c02ea0e14dbe4f$var$$81dd635d83decaee$exports);
$24c02ea0e14dbe4f$var$$parcel$exportWildcard($24c02ea0e14dbe4f$var$$6e379ec2eca3d7d3$exports, $24c02ea0e14dbe4f$var$$8d99d7c025746ac9$exports);
$24c02ea0e14dbe4f$var$$parcel$exportWildcard($24c02ea0e14dbe4f$var$$6e379ec2eca3d7d3$exports, $24c02ea0e14dbe4f$var$$1f7c4876f10b107b$exports);
$24c02ea0e14dbe4f$var$$parcel$exportWildcard($24c02ea0e14dbe4f$var$$6e379ec2eca3d7d3$exports, $24c02ea0e14dbe4f$var$$c5616d3f1657fc84$exports);
$24c02ea0e14dbe4f$var$$parcel$exportWildcard($24c02ea0e14dbe4f$var$$6e379ec2eca3d7d3$exports, $24c02ea0e14dbe4f$var$$eb6f767c51421421$exports);
$24c02ea0e14dbe4f$var$$parcel$exportWildcard($24c02ea0e14dbe4f$var$$6e379ec2eca3d7d3$exports, $24c02ea0e14dbe4f$var$$7fe7e19d380f3d34$exports);
$24c02ea0e14dbe4f$var$$parcel$exportWildcard($24c02ea0e14dbe4f$var$$6e379ec2eca3d7d3$exports, $24c02ea0e14dbe4f$var$$915f5687b3b07750$exports);
$24c02ea0e14dbe4f$var$$parcel$exportWildcard($24c02ea0e14dbe4f$var$$6e379ec2eca3d7d3$exports, $24c02ea0e14dbe4f$var$$579f9ef2424e0bd8$exports);
$24c02ea0e14dbe4f$var$$parcel$exportWildcard($24c02ea0e14dbe4f$var$$6e379ec2eca3d7d3$exports, $24c02ea0e14dbe4f$var$$d559b1cc82536c49$exports);
$24c02ea0e14dbe4f$var$$parcel$exportWildcard($24c02ea0e14dbe4f$var$$6e379ec2eca3d7d3$exports, $24c02ea0e14dbe4f$var$$fa53e9c0a1746730$exports);
$24c02ea0e14dbe4f$var$$parcel$exportWildcard($24c02ea0e14dbe4f$var$$6e379ec2eca3d7d3$exports, $24c02ea0e14dbe4f$var$$9225344cd5d1f99b$exports);
$24c02ea0e14dbe4f$var$$parcel$exportWildcard($24c02ea0e14dbe4f$var$$6e379ec2eca3d7d3$exports, $24c02ea0e14dbe4f$var$$3b9afd8fe4435353$exports);
$24c02ea0e14dbe4f$var$$parcel$exportWildcard($24c02ea0e14dbe4f$var$$6e379ec2eca3d7d3$exports, $24c02ea0e14dbe4f$var$$050a30fc95775cfd$exports);
$24c02ea0e14dbe4f$var$$parcel$exportWildcard($24c02ea0e14dbe4f$var$$6e379ec2eca3d7d3$exports, $24c02ea0e14dbe4f$var$$65703ff0bcd12648$exports);
$24c02ea0e14dbe4f$var$$parcel$exportWildcard($24c02ea0e14dbe4f$var$$6e379ec2eca3d7d3$exports, $24c02ea0e14dbe4f$var$$8340d81aba797956$exports);
$24c02ea0e14dbe4f$var$$parcel$exportWildcard($24c02ea0e14dbe4f$var$$6e379ec2eca3d7d3$exports, $24c02ea0e14dbe4f$var$$dbb9d5792c296a49$exports);
$24c02ea0e14dbe4f$var$$parcel$exportWildcard($24c02ea0e14dbe4f$var$$6e379ec2eca3d7d3$exports, $24c02ea0e14dbe4f$var$$2cfa64583f556289$exports);
$24c02ea0e14dbe4f$var$$parcel$exportWildcard($24c02ea0e14dbe4f$var$$6e379ec2eca3d7d3$exports, $24c02ea0e14dbe4f$var$$44303f6c3c81eeac$exports);
$24c02ea0e14dbe4f$var$$parcel$exportWildcard($24c02ea0e14dbe4f$var$$6e379ec2eca3d7d3$exports, $24c02ea0e14dbe4f$var$$9c3f769544bb2079$exports);
$24c02ea0e14dbe4f$var$$parcel$exportWildcard($24c02ea0e14dbe4f$var$$6e379ec2eca3d7d3$exports, $24c02ea0e14dbe4f$var$$3d76652bb6362040$exports);
$24c02ea0e14dbe4f$var$$parcel$exportWildcard($24c02ea0e14dbe4f$var$$6e379ec2eca3d7d3$exports, $24c02ea0e14dbe4f$var$$764442aba3de2fce$exports);
$24c02ea0e14dbe4f$var$$parcel$exportWildcard($24c02ea0e14dbe4f$var$$6e379ec2eca3d7d3$exports, $24c02ea0e14dbe4f$var$$77282b3961d82199$exports);
$24c02ea0e14dbe4f$var$$parcel$exportWildcard($24c02ea0e14dbe4f$var$$6e379ec2eca3d7d3$exports, $24c02ea0e14dbe4f$var$$4c35f7fd4ad5f13f$exports);
$24c02ea0e14dbe4f$var$$parcel$exportWildcard($24c02ea0e14dbe4f$var$$6e379ec2eca3d7d3$exports, $24c02ea0e14dbe4f$var$$d8ee29df49af8811$exports);
$24c02ea0e14dbe4f$var$$parcel$exportWildcard($24c02ea0e14dbe4f$var$$6e379ec2eca3d7d3$exports, $24c02ea0e14dbe4f$var$$27d686e47ff412fd$exports);
$24c02ea0e14dbe4f$var$$parcel$exportWildcard($24c02ea0e14dbe4f$var$$6e379ec2eca3d7d3$exports, $24c02ea0e14dbe4f$var$$a4deb03146bf3bfc$exports);
$24c02ea0e14dbe4f$var$$parcel$exportWildcard($24c02ea0e14dbe4f$var$$6e379ec2eca3d7d3$exports, $24c02ea0e14dbe4f$var$$0ae392c3008c8a3e$exports);
$24c02ea0e14dbe4f$var$$parcel$exportWildcard($24c02ea0e14dbe4f$var$$6e379ec2eca3d7d3$exports, $24c02ea0e14dbe4f$var$$205ed41b47d90e33$exports);
$24c02ea0e14dbe4f$var$$parcel$exportWildcard($24c02ea0e14dbe4f$var$$6e379ec2eca3d7d3$exports, $24c02ea0e14dbe4f$var$$3c691af970e2b3d8$exports);
$24c02ea0e14dbe4f$var$$parcel$exportWildcard($24c02ea0e14dbe4f$var$$6e379ec2eca3d7d3$exports, $24c02ea0e14dbe4f$var$$5f9280667c666470$exports);
$24c02ea0e14dbe4f$var$$parcel$exportWildcard($24c02ea0e14dbe4f$var$$6e379ec2eca3d7d3$exports, $24c02ea0e14dbe4f$var$$ec9b8ebbd21bd316$exports);
$24c02ea0e14dbe4f$var$$parcel$exportWildcard($24c02ea0e14dbe4f$var$$6e379ec2eca3d7d3$exports, $24c02ea0e14dbe4f$var$$ffad026de847a971$exports);
$24c02ea0e14dbe4f$var$$parcel$exportWildcard($24c02ea0e14dbe4f$var$$6e379ec2eca3d7d3$exports, $24c02ea0e14dbe4f$var$$0f989458047e435a$exports);
$24c02ea0e14dbe4f$var$$parcel$exportWildcard($24c02ea0e14dbe4f$var$$6e379ec2eca3d7d3$exports, $24c02ea0e14dbe4f$var$$a7b3e1c0391fddac$exports);
$24c02ea0e14dbe4f$var$$parcel$exportWildcard($24c02ea0e14dbe4f$var$$6e379ec2eca3d7d3$exports, $24c02ea0e14dbe4f$var$$ffc638203e092686$exports);
$24c02ea0e14dbe4f$var$$parcel$exportWildcard($24c02ea0e14dbe4f$var$$6e379ec2eca3d7d3$exports, $24c02ea0e14dbe4f$var$$ed20910b93d89c3f$exports);
$24c02ea0e14dbe4f$var$$parcel$exportWildcard($24c02ea0e14dbe4f$var$$6e379ec2eca3d7d3$exports, $24c02ea0e14dbe4f$var$$4dfe37aba1865d88$exports);
$24c02ea0e14dbe4f$var$$parcel$exportWildcard($24c02ea0e14dbe4f$var$$6e379ec2eca3d7d3$exports, $24c02ea0e14dbe4f$var$$556680ce820612ab$exports);
$24c02ea0e14dbe4f$var$$parcel$exportWildcard($24c02ea0e14dbe4f$var$$6e379ec2eca3d7d3$exports, $24c02ea0e14dbe4f$var$$6a8b328ff2ec0580$exports);
$24c02ea0e14dbe4f$var$$parcel$exportWildcard($24c02ea0e14dbe4f$var$$6e379ec2eca3d7d3$exports, $24c02ea0e14dbe4f$var$$2397677ef2f4ee69$exports);
var $24c02ea0e14dbe4f$var$$0cf4554ad00467b5$exports = {};
var $24c02ea0e14dbe4f$var$$a3d28c94a229f94e$exports = {};
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$a3d28c94a229f94e$exports, "CommunityLogo", ()=>$24c02ea0e14dbe4f$export$311e5e9ca09eea69);
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$a3d28c94a229f94e$exports, "CommunityNavigation", ()=>$24c02ea0e14dbe4f$export$901cb8c9de2be2aa);
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$a3d28c94a229f94e$exports, "AnalyticsActivityType", ()=>$24c02ea0e14dbe4f$export$d778a884eb401313);
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$a3d28c94a229f94e$exports, "EventType", ()=>$24c02ea0e14dbe4f$export$3d7865934588d77e);
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$a3d28c94a229f94e$exports, "CommunityApp", ()=>$24c02ea0e14dbe4f$export$93d048dc21eb282a);
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$a3d28c94a229f94e$exports, "MenuItemWithAnalytics", ()=>$24c02ea0e14dbe4f$export$92905cc84b82619c);
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$a3d28c94a229f94e$exports, "APP_BUTTONS", ()=>$24c02ea0e14dbe4f$export$208c68d48dfc9a12);
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$a3d28c94a229f94e$exports, "getAppButtons", ()=>$24c02ea0e14dbe4f$export$67e61a6fa639f224);
const $24c02ea0e14dbe4f$export$311e5e9ca09eea69 = ({ subtitleHref: subtitleHref, analyticsInfo: analyticsInfo })=>{
    return (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$var$$341f96d5922d8aaa$export$5aa64ab1f07d6e00, {
        subtitleHref: subtitleHref,
        label: "Community homepage",
        logoSubtitle: "Community",
        analyticsInfo: analyticsInfo
    });
};
const $24c02ea0e14dbe4f$var$$a3d28c94a229f94e$var$renderAppButtons = (currentApp, subMenuContentByApp, isLoggedIn, analyticsInfo, forumsLoggedInRedirectHref, email, showNewMenu)=>{
    const loginState = isLoggedIn ? "loggedIn" : "loggedOut";
    return $24c02ea0e14dbe4f$export$67e61a6fa639f224(email).map((button)=>{
        if (button.app === $24c02ea0e14dbe4f$export$93d048dc21eb282a.FORUMS && isLoggedIn && forumsLoggedInRedirectHref) button.href[loginState] += forumsLoggedInRedirectHref;
        return (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$var$$341f96d5922d8aaa$export$b18dbc162161ec9c, {
            isSelected: button.app === currentApp,
            link: {
                text: button.label,
                href: button.href[loginState],
                target: button.target
            },
            expandableBodyContent: subMenuContentByApp?.[button.app],
            destinationApp: button.app,
            analyticsInfo: analyticsInfo,
            showNewMenu: showNewMenu
        }, button.app);
    });
};
const $24c02ea0e14dbe4f$export$901cb8c9de2be2aa = ({ currentApp: currentApp, isLoggedIn: isLoggedIn, user: user, loginHref: loginHref, signupHref: signupHref, logoutHref: logoutHref, switchHref: switchHref, subMenuContentByApp: subMenuContentByApp, onAnalyticsSendEvent: onAnalyticsSendEvent, forumsLoggedInRedirectHref: forumsLoggedInRedirectHref, isSticky: isSticky = true, email: email, showAppUpdates: showAppUpdates = false, showNewMenu: showNewMenu = false })=>{
    const loginState = isLoggedIn ? "loggedIn" : "loggedOut";
    const homeHref = (0, $5FkrB.useMemo)(()=>$24c02ea0e14dbe4f$var$$1ff01338112cd7fe$export$d349399b473d7299[loginState], [
        loginState
    ]);
    const isMobileOrTablet = $24c02ea0e14dbe4f$export$32d5543ab307c01(`(max-width: ${$24c02ea0e14dbe4f$var$$f0285f05d4d9f8a0$export$426e07cd0772984d.TABLET.MAX_WIDTH}px)`);
    const analyticsInfo = onAnalyticsSendEvent ? {
        currentApp: currentApp,
        isLoggedIn: isLoggedIn,
        isMobileOrTablet: isMobileOrTablet,
        onAnalyticsSendEvent: onAnalyticsSendEvent
    } : undefined;
    let leftItems = [
        ...$24c02ea0e14dbe4f$var$$a3d28c94a229f94e$var$renderAppButtons(currentApp, subMenuContentByApp, isLoggedIn, analyticsInfo, forumsLoggedInRedirectHref, email, showNewMenu)
    ];
    if (!showAppUpdates) leftItems = leftItems.filter((item)=>item.key !== $24c02ea0e14dbe4f$export$93d048dc21eb282a.APP_UPDATES);
    // Create logo item
    const logoItem = (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$311e5e9ca09eea69, {
        subtitleHref: homeHref,
        analyticsInfo: analyticsInfo
    }, "community-logo");
    return (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$fddd19fbf4d591d8, {
        logoItem: logoItem,
        leftItems: leftItems,
        isLoggedIn: isLoggedIn,
        user: user,
        loginHref: loginHref,
        signupHref: signupHref,
        logoutHref: logoutHref,
        switchHref: switchHref,
        profileHref: $24c02ea0e14dbe4f$var$$1ff01338112cd7fe$export$132b2bf91782e62b,
        settingsHref: $24c02ea0e14dbe4f$var$$1ff01338112cd7fe$export$b9cc8022ec117e91,
        onAnalyticsSendEvent: onAnalyticsSendEvent,
        isSticky: isSticky,
        showNewMenu: showNewMenu,
        currentApp: currentApp
    });
};
var $24c02ea0e14dbe4f$var$$976a3c76bc9fa9bc$exports = {};
var $24c02ea0e14dbe4f$var$$b0e23f9f192d2ea7$exports = {};
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$b0e23f9f192d2ea7$exports, "ForumFeedItem", ()=>$24c02ea0e14dbe4f$export$1074985837f1b2a5);
const $24c02ea0e14dbe4f$var$$c13069d48b7dab65$export$bbef7a8f2307e1f9 = ()=>{
    return (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M14.6668 8.00004C14.6668 11.6819 11.6821 14.6667 8.00016 14.6667C4.31826 14.6667 1.3335 11.6819 1.3335 8.00004C1.3335 4.31814 4.31826 1.33337 8.00016 1.33337C11.6821 1.33337 14.6668 4.31814 14.6668 8.00004ZM6.2551 7.37932C6.33643 7.41426 6.41 7.46505 6.47149 7.52872L7.33349 8.39072L9.52883 6.19539C9.59033 6.13171 9.66389 6.08093 9.74522 6.04599C9.82656 6.01105 9.91404 5.99266 10.0026 5.99189C10.0911 5.99112 10.1789 6.00799 10.2608 6.04151C10.3427 6.07503 10.4172 6.12453 10.4798 6.18712C10.5424 6.24972 10.5919 6.32415 10.6254 6.40608C10.6589 6.48802 10.6758 6.5758 10.675 6.66432C10.6742 6.75284 10.6558 6.84032 10.6209 6.92166C10.586 7.00299 10.5352 7.07656 10.4715 7.13805L7.80483 9.80472C7.67981 9.9297 7.51027 9.99991 7.33349 9.99991C7.15672 9.99991 6.98718 9.9297 6.86216 9.80472L5.52883 8.47139C5.46515 8.40989 5.41437 8.33633 5.37943 8.25499C5.34449 8.17365 5.3261 8.08617 5.32533 7.99765C5.32456 7.90913 5.34143 7.82135 5.37495 7.73942C5.40847 7.65749 5.45797 7.58305 5.52056 7.52046C5.58316 7.45786 5.65759 7.40836 5.73952 7.37484C5.82146 7.34132 5.90924 7.32445 5.99776 7.32522C6.08628 7.32599 6.17376 7.34438 6.2551 7.37932Z",
            fill: "#22A06B"
        })
    });
};
var $24c02ea0e14dbe4f$var$$fa9d4c58bb661680$exports = {};
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$fa9d4c58bb661680$exports, "ForumFeedItemContentType", ()=>$24c02ea0e14dbe4f$export$96b2e747ae3de284);
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$fa9d4c58bb661680$exports, "ForumFeedItemCategoryType", ()=>$24c02ea0e14dbe4f$export$c6c284c40052569e);
$24c02ea0e14dbe4f$var$$parcel$export($24c02ea0e14dbe4f$var$$fa9d4c58bb661680$exports, "ForumFeedItemStatus", ()=>$24c02ea0e14dbe4f$export$88a22e3eec02cfbe);
let $24c02ea0e14dbe4f$export$96b2e747ae3de284;
(function(ForumFeedItemContentType) {
    ForumFeedItemContentType["Question"] = "Question";
    ForumFeedItemContentType["Discussion"] = "Discussion";
    ForumFeedItemContentType["Article"] = "Article";
})($24c02ea0e14dbe4f$export$96b2e747ae3de284 || ($24c02ea0e14dbe4f$export$96b2e747ae3de284 = {}));
let $24c02ea0e14dbe4f$export$c6c284c40052569e;
(function(ForumFeedItemCategoryType) {
    ForumFeedItemCategoryType["Subject"] = "subject";
    ForumFeedItemCategoryType["App"] = "app";
    ForumFeedItemCategoryType["Group"] = "group";
})($24c02ea0e14dbe4f$export$c6c284c40052569e || ($24c02ea0e14dbe4f$export$c6c284c40052569e = {}));
let $24c02ea0e14dbe4f$export$88a22e3eec02cfbe;
(function(ForumFeedItemStatus) {
    ForumFeedItemStatus["AnswerNotAccepted"] = "Answered Not Accepted";
    ForumFeedItemStatus["UnAnswered"] = "Unanswered";
    ForumFeedItemStatus["AnsweredAccepted"] = "Answered Accepted";
})($24c02ea0e14dbe4f$export$88a22e3eec02cfbe || ($24c02ea0e14dbe4f$export$88a22e3eec02cfbe = {}));
const $24c02ea0e14dbe4f$var$$2248ded33c1cc26f$var$getMetricLabel = (value, singular, plural)=>value === 1 ? singular : plural;
const $24c02ea0e14dbe4f$var$$2248ded33c1cc26f$export$9e55f86bc7a20cd4 = ({ likes: likes, responses: responses, views: views, status: status, contentType: contentType })=>{
    const showAnswerText = ()=>{
        switch(status){
            case $24c02ea0e14dbe4f$export$88a22e3eec02cfbe.AnsweredAccepted:
                return (0, $6bec4f26b2cb3094$export$25062201e9e25d76)((0, $0654f583dbdded1e$export$2e2bcd8739ae039), {
                    xcss: $24c02ea0e14dbe4f$var$$2248ded33c1cc26f$var$answerContainerStyles,
                    children: [
                        (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$var$$c13069d48b7dab65$export$bbef7a8f2307e1f9, {}),
                        (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $c9e5a7a14e07f4e4$export$2e2bcd8739ae039), {
                            size: "small",
                            weight: "semibold",
                            children: "ANSWER ACCEPTED"
                        })
                    ]
                });
            case $24c02ea0e14dbe4f$export$88a22e3eec02cfbe.AnswerNotAccepted:
                return (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $0654f583dbdded1e$export$2e2bcd8739ae039), {
                    xcss: $24c02ea0e14dbe4f$var$$2248ded33c1cc26f$var$answerContainerStyles,
                    children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $c9e5a7a14e07f4e4$export$2e2bcd8739ae039), {
                        size: "small",
                        weight: "semibold",
                        children: "ANSWERED"
                    })
                });
            default:
                return (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $0654f583dbdded1e$export$2e2bcd8739ae039), {
                    xcss: $24c02ea0e14dbe4f$var$$2248ded33c1cc26f$var$answerContainerStyles,
                    children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $c9e5a7a14e07f4e4$export$2e2bcd8739ae039), {
                        size: "small",
                        weight: "semibold",
                        children: "UNANSWERED"
                    })
                });
        }
    };
    return (0, $6bec4f26b2cb3094$export$25062201e9e25d76)((0, $0654f583dbdded1e$export$2e2bcd8739ae039), {
        alignItems: "center",
        justifyContent: "space-between",
        gap: "space.200",
        wrap: "wrap",
        children: [
            (0, $6bec4f26b2cb3094$export$25062201e9e25d76)((0, $0654f583dbdded1e$export$2e2bcd8739ae039), {
                alignItems: "center",
                gap: "space.150",
                wrap: "wrap",
                children: [
                    (0, $6bec4f26b2cb3094$export$25062201e9e25d76)((0, $0654f583dbdded1e$export$2e2bcd8739ae039), {
                        alignItems: "center",
                        gap: "space.075",
                        children: [
                            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($d613dcd7cfbb1e58$exports))), {
                                label: "Likes"
                            }),
                            (0, $6bec4f26b2cb3094$export$25062201e9e25d76)((0, $c9e5a7a14e07f4e4$export$2e2bcd8739ae039), {
                                size: "medium",
                                children: [
                                    likes,
                                    " ",
                                    $24c02ea0e14dbe4f$var$$2248ded33c1cc26f$var$getMetricLabel(likes, "like", "likes")
                                ]
                            })
                        ]
                    }),
                    (0, $6bec4f26b2cb3094$export$25062201e9e25d76)((0, $0654f583dbdded1e$export$2e2bcd8739ae039), {
                        alignItems: "center",
                        gap: "space.075",
                        children: [
                            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($0e561d53dcc9f631$exports))), {
                                label: "Responses"
                            }),
                            (0, $6bec4f26b2cb3094$export$25062201e9e25d76)((0, $c9e5a7a14e07f4e4$export$2e2bcd8739ae039), {
                                size: "medium",
                                children: [
                                    responses,
                                    " ",
                                    $24c02ea0e14dbe4f$var$$2248ded33c1cc26f$var$getMetricLabel(responses, "response", "responses")
                                ]
                            })
                        ]
                    }),
                    (0, $6bec4f26b2cb3094$export$25062201e9e25d76)((0, $0654f583dbdded1e$export$2e2bcd8739ae039), {
                        alignItems: "center",
                        gap: "space.075",
                        children: [
                            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($59c4a893ce5f1bf5$exports))), {
                                label: "Views"
                            }),
                            (0, $6bec4f26b2cb3094$export$25062201e9e25d76)((0, $c9e5a7a14e07f4e4$export$2e2bcd8739ae039), {
                                size: "medium",
                                children: [
                                    views,
                                    " ",
                                    $24c02ea0e14dbe4f$var$$2248ded33c1cc26f$var$getMetricLabel(views, "view", "views")
                                ]
                            })
                        ]
                    })
                ]
            }),
            contentType === $24c02ea0e14dbe4f$export$96b2e747ae3de284.Question ? showAnswerText() : null
        ]
    });
};
const $24c02ea0e14dbe4f$var$$2248ded33c1cc26f$var$answerContainerStyles = (0, $7c2f920c3bda89b1$export$f6c783d06584602c)({
    display: "inline-flex",
    alignItems: "center",
    gap: "space.075"
});
const $24c02ea0e14dbe4f$var$$027dbfbbc85481a9$export$a6e7f421a5dba78a = (appName)=>{
    return appName.trim().replace(/[-_]+/g, " ").replace(/\s+/g, " ").split(" ").filter(Boolean).map((word)=>word.charAt(0).toUpperCase() + word.slice(1)).join(" ");
};
const $24c02ea0e14dbe4f$var$$027dbfbbc85481a9$var$getOrdinalSuffix = (day)=>{
    if (day >= 11 && day <= 13) return "th";
    switch(day % 10){
        case 1:
            return "st";
        case 2:
            return "nd";
        case 3:
            return "rd";
        default:
            return "th";
    }
};
const $24c02ea0e14dbe4f$var$$027dbfbbc85481a9$export$a547c17dcfa0a6bc = (value, { locale: locale, timeZone: timeZone } = {})=>{
    const date = value instanceof Date ? value : new Date(value);
    if (Number.isNaN(date.getTime())) return "";
    const resolvedLocale = locale || (typeof navigator !== "undefined" ? navigator.language : "en-US");
    const resolvedTimeZone = timeZone || (typeof Intl !== "undefined" ? Intl.DateTimeFormat().resolvedOptions().timeZone : "UTC");
    const parts = new Intl.DateTimeFormat(resolvedLocale, {
        timeZone: resolvedTimeZone,
        year: "numeric",
        month: "long",
        day: "numeric"
    }).formatToParts(date);
    const month = parts.find((p)=>p.type === "month")?.value;
    const dayString = parts.find((p)=>p.type === "day")?.value;
    const year = parts.find((p)=>p.type === "year")?.value;
    if (!month || !dayString || !year) return "";
    const day = Number(dayString);
    if (Number.isNaN(day)) return "";
    return `${month} ${day}${$24c02ea0e14dbe4f$var$$027dbfbbc85481a9$var$getOrdinalSuffix(day)}, ${year}`;
};
const $24c02ea0e14dbe4f$var$$027dbfbbc85481a9$var$normalizeProductKey = (product)=>{
    return product.trim().toLowerCase().replace(/[\s_]+/g, "-");
};
const $24c02ea0e14dbe4f$var$$027dbfbbc85481a9$var$productLogoMap = {
    // Company
    atlassian: (0, $37844134dd17fb96$export$8a485e2e7ed91e8f),
    "atlassian-analytics": (0, $e5c28807f044a60a$export$c42ad8a0b925c762),
    analytics: (0, $e5c28807f044a60a$export$c42ad8a0b925c762),
    access: (0, $90b44dd97a49007a$export$a825993f361832f7),
    "atlassian-access": (0, $90b44dd97a49007a$export$a825993f361832f7),
    community: (0, $37844134dd17fb96$export$8a485e2e7ed91e8f),
    // Products
    atlas: (0, $e5c28807f044a60a$export$92c8767b874048d),
    focus: (0, $e5c28807f044a60a$export$1e02e7298035a77c),
    crowd: (0, $e5c28807f044a60a$export$eaf73f391f7103bd),
    bitbucket: (0, $e5c28807f044a60a$export$5fc1066e677788d4),
    compass: (0, $e5c28807f044a60a$export$f7857fe64d7161d9),
    confluence: (0, $e5c28807f044a60a$export$68f3db7f6af48bcb),
    guard: (0, $e5c28807f044a60a$export$3f95fcfdc25a741d),
    "atlassian-guard": (0, $e5c28807f044a60a$export$3f95fcfdc25a741d),
    jira: (0, $e5c28807f044a60a$export$c4b5b1f965d8b3eb),
    "jira-software": (0, $e5c28807f044a60a$export$c4b5b1f965d8b3eb),
    "jira-service-management": (0, $e5c28807f044a60a$export$3c6158790f5e01c4),
    "jira-service-desk": (0, $e5c28807f044a60a$export$3c6158790f5e01c4),
    jsm: (0, $e5c28807f044a60a$export$3c6158790f5e01c4),
    "jira-product-discovery": (0, $e5c28807f044a60a$export$21bfbeb62fdcce8d),
    jpd: (0, $e5c28807f044a60a$export$21bfbeb62fdcce8d),
    "jira-align": (0, $e5c28807f044a60a$export$407687b2dd89cc68),
    align: (0, $e5c28807f044a60a$export$407687b2dd89cc68),
    "jira-work-management": (0, $e5c28807f044a60a$export$c4b5b1f965d8b3eb),
    jwm: (0, $e5c28807f044a60a$export$c4b5b1f965d8b3eb),
    bamboo: (0, $e5c28807f044a60a$export$e812398311cab9a3),
    marketplace: (0, $722ae65b25b74a2f$export$94c87d39a54a1894),
    "atlassian-marketplace": (0, $722ae65b25b74a2f$export$94c87d39a54a1894),
    talent: (0, $e5c28807f044a60a$export$4b05688514531169),
    teams: (0, $e5c28807f044a60a$export$1bcbc9c337da86da),
    studio: (0, $e5c28807f044a60a$export$290a0f24614cde9f),
    projects: (0, $e5c28807f044a60a$export$5ed3e1bb3b04fc02),
    goals: (0, $e5c28807f044a60a$export$9eb74917ea768ed4),
    "atlassian-administration": (0, $e5c28807f044a60a$export$ef8e5f836dd989d3),
    "atlassian-admin": (0, $e5c28807f044a60a$export$ef8e5f836dd989d3),
    admin: (0, $e5c28807f044a60a$export$ef8e5f836dd989d3),
    assets: (0, $e5c28807f044a60a$export$d89497e7f33ca6f5),
    "rovo-dev": (0, $e5c28807f044a60a$export$8b784b3227531b3e),
    dx: (0, $e5c28807f044a60a$export$9951d02c2d848122),
    hub: (0, $e5c28807f044a60a$export$80b8b269d8b5014e),
    home: (0, $e5c28807f044a60a$export$92c8767b874048d),
    loom: (0, $e5c28807f044a60a$export$8d789f76fde3e05),
    opsgenie: (0, $e5c28807f044a60a$export$eeccc49dc7a12d9f),
    rovo: (0, $e5c28807f044a60a$export$e23ae35269442b4f),
    "rovo-atlassian-intelligence": (0, $e5c28807f044a60a$export$e23ae35269442b4f),
    statuspage: (0, $e5c28807f044a60a$export$f3f5aa321d88adf9),
    trello: (0, $e5c28807f044a60a$export$4384da9b8b140bf4),
    "customer-service-management": (0, $e5c28807f044a60a$export$6da5aa77c402ba0f)
};
const $24c02ea0e14dbe4f$var$$027dbfbbc85481a9$var$dataCenterProductLogoMap = {
    "jira-service-management": (0, $e5c28807f044a60a$export$65fae0eaf343f2ca),
    jira: (0, $e5c28807f044a60a$export$f8455b5667a3ee0c),
    confluence: (0, $e5c28807f044a60a$export$53305f1f2855d3be),
    bitbucket: (0, $e5c28807f044a60a$export$d3ab16bbf4f954ee)
};
const $24c02ea0e14dbe4f$var$$027dbfbbc85481a9$export$39846976078a8f0d = (product, props, hostingType)=>{
    const key = $24c02ea0e14dbe4f$var$$027dbfbbc85481a9$var$normalizeProductKey(product);
    let Logo;
    if (hostingType === "data-center" && key in $24c02ea0e14dbe4f$var$$027dbfbbc85481a9$var$dataCenterProductLogoMap) Logo = $24c02ea0e14dbe4f$var$$027dbfbbc85481a9$var$dataCenterProductLogoMap[key];
    else Logo = $24c02ea0e14dbe4f$var$$027dbfbbc85481a9$var$productLogoMap[key];
    if (!Logo) return (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $37844134dd17fb96$export$8a485e2e7ed91e8f), {
        size: "xsmall",
        ...props,
        shouldUseNewLogoDesign: true,
        appearance: "brand"
    });
    return (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)(Logo, {
        size: "xsmall",
        ...props,
        shouldUseNewLogoDesign: true,
        appearance: "brand"
    });
};
const $24c02ea0e14dbe4f$var$$eb5a017dbcef9100$export$b8c4492f94f00c1c = {
    color: "color.text",
    cursor: "pointer",
    position: "relative",
    textDecoration: "none",
    fontSize: "14px"
};
const $24c02ea0e14dbe4f$var$$eb5a017dbcef9100$export$37cc822878118153 = {
    textDecoration: "none",
    ":hover": {
        textDecoration: "none",
        color: "color.text"
    }
};
const $24c02ea0e14dbe4f$var$$eb5a017dbcef9100$export$ef0b806eff7008c6 = {
    textDecoration: "none",
    color: "color.text",
    ":hover": {
        color: "color.text",
        textDecoration: "none"
    },
    ":visited": {
        color: "color.text",
        textDecoration: "none"
    }
};
const $24c02ea0e14dbe4f$var$$06e8096ff5ff1247$var$anchorResetStyles = (0, $7c2f920c3bda89b1$export$f6c783d06584602c)($24c02ea0e14dbe4f$var$$eb5a017dbcef9100$export$ef0b806eff7008c6);
const $24c02ea0e14dbe4f$var$$06e8096ff5ff1247$var$anchorDetailStyles = (0, $7c2f920c3bda89b1$export$f6c783d06584602c)($24c02ea0e14dbe4f$var$$eb5a017dbcef9100$export$b8c4492f94f00c1c);
const $24c02ea0e14dbe4f$var$$06e8096ff5ff1247$var$hoverUnderlineStyles = (0, $7c2f920c3bda89b1$export$f6c783d06584602c)($24c02ea0e14dbe4f$var$$eb5a017dbcef9100$export$37cc822878118153);
const $24c02ea0e14dbe4f$var$$06e8096ff5ff1247$var$getContentTypeBackground = (contentType)=>{
    switch(contentType){
        case $24c02ea0e14dbe4f$export$96b2e747ae3de284.Question:
            return (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.background.warning.pressed");
        case $24c02ea0e14dbe4f$export$96b2e747ae3de284.Discussion:
            return (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.background.discovery.pressed");
        case $24c02ea0e14dbe4f$export$96b2e747ae3de284.Article:
            return (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.background.information.pressed");
    }
};
const $24c02ea0e14dbe4f$var$$06e8096ff5ff1247$var$renderProductLogo = (name, hostingType)=>$24c02ea0e14dbe4f$var$$027dbfbbc85481a9$export$39846976078a8f0d(name, {
        size: "xsmall"
    }, hostingType);
const $24c02ea0e14dbe4f$var$$06e8096ff5ff1247$export$7d7346e428084a7e = ({ contentType: contentType, isFeatured: isFeatured, categoryName: categoryName, categoryType: categoryType, categoryHref: categoryHref, menuComponent: menuComponent, hostingType: hostingType, isNew: isNew })=>{
    const categoryShown = ()=>{
        switch(categoryType){
            case $24c02ea0e14dbe4f$export$c6c284c40052569e.App:
                return (0, $6bec4f26b2cb3094$export$25062201e9e25d76)((0, $0654f583dbdded1e$export$2e2bcd8739ae039), {
                    gap: "space.075",
                    alignItems: "center",
                    children: [
                        $24c02ea0e14dbe4f$var$$06e8096ff5ff1247$var$renderProductLogo(categoryName, hostingType),
                        (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $c9e5a7a14e07f4e4$export$2e2bcd8739ae039), {
                            color: "color.text",
                            size: "medium",
                            children: $24c02ea0e14dbe4f$var$$027dbfbbc85481a9$export$a6e7f421a5dba78a(categoryName)
                        })
                    ]
                });
            case $24c02ea0e14dbe4f$export$c6c284c40052569e.Group:
                return (0, $6bec4f26b2cb3094$export$25062201e9e25d76)((0, $0654f583dbdded1e$export$2e2bcd8739ae039), {
                    gap: "space.075",
                    alignItems: "center",
                    children: [
                        (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($be2e2d4d6fde7b33$exports))), {
                            label: "group"
                        }),
                        (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $c9e5a7a14e07f4e4$export$2e2bcd8739ae039), {
                            color: "color.text",
                            size: "medium",
                            children: $24c02ea0e14dbe4f$var$$027dbfbbc85481a9$export$a6e7f421a5dba78a(categoryName)
                        })
                    ]
                });
            case $24c02ea0e14dbe4f$export$c6c284c40052569e.Subject:
                return (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $c9e5a7a14e07f4e4$export$2e2bcd8739ae039), {
                    color: "color.text",
                    size: "medium",
                    children: $24c02ea0e14dbe4f$var$$027dbfbbc85481a9$export$a6e7f421a5dba78a(categoryName)
                });
        }
    };
    return (0, $6bec4f26b2cb3094$export$25062201e9e25d76)((0, $0654f583dbdded1e$export$2e2bcd8739ae039), {
        justifyContent: "space-between",
        alignItems: "stretch",
        children: [
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$3288d34c523a1192, {
                label: contentType,
                isTall: true,
                backgroundColor: $24c02ea0e14dbe4f$var$$06e8096ff5ff1247$var$getContentTypeBackground(contentType),
                borderColor: "transparent"
            }),
            (0, $6bec4f26b2cb3094$export$25062201e9e25d76)((0, $0654f583dbdded1e$export$2e2bcd8739ae039), {
                gap: "space.150",
                alignItems: "center",
                children: [
                    isNew && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$3288d34c523a1192, {
                        label: "New",
                        isTall: true,
                        backgroundColor: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.background.input"),
                        borderColor: "#C97CF4"
                    }),
                    isFeatured && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$3288d34c523a1192, {
                        label: "Featured",
                        isTall: true,
                        backgroundColor: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.background.input"),
                        borderColor: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.border.accent.blue")
                    }),
                    categoryHref ? (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $abf94df1a292a623$export$2e2bcd8739ae039), {
                        as: "a",
                        href: categoryHref,
                        xcss: [
                            $24c02ea0e14dbe4f$var$$06e8096ff5ff1247$var$anchorDetailStyles,
                            $24c02ea0e14dbe4f$var$$06e8096ff5ff1247$var$anchorResetStyles,
                            $24c02ea0e14dbe4f$var$$06e8096ff5ff1247$var$hoverUnderlineStyles,
                            $24c02ea0e14dbe4f$var$$06e8096ff5ff1247$var$categoryLinkStyles
                        ],
                        children: categoryShown()
                    }) : (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $abf94df1a292a623$export$2e2bcd8739ae039), {
                        xcss: $24c02ea0e14dbe4f$var$$06e8096ff5ff1247$var$categoryLinkStyles,
                        children: categoryShown()
                    }),
                    menuComponent
                ]
            })
        ]
    });
};
const $24c02ea0e14dbe4f$var$$06e8096ff5ff1247$var$categoryLinkStyles = (0, $7c2f920c3bda89b1$export$f6c783d06584602c)({
    display: "inline-flex",
    alignItems: "center"
});
const $24c02ea0e14dbe4f$var$$65d6e13fe84e408e$var$anchorResetStyles = (0, $7c2f920c3bda89b1$export$f6c783d06584602c)($24c02ea0e14dbe4f$var$$eb5a017dbcef9100$export$ef0b806eff7008c6);
const $24c02ea0e14dbe4f$var$$65d6e13fe84e408e$var$anchorDetailStyles = (0, $7c2f920c3bda89b1$export$f6c783d06584602c)($24c02ea0e14dbe4f$var$$eb5a017dbcef9100$export$b8c4492f94f00c1c);
const $24c02ea0e14dbe4f$var$$65d6e13fe84e408e$var$hoverUnderlineStyles = (0, $7c2f920c3bda89b1$export$f6c783d06584602c)($24c02ea0e14dbe4f$var$$eb5a017dbcef9100$export$37cc822878118153);
const $24c02ea0e14dbe4f$var$$65d6e13fe84e408e$export$1e30305c33fd8c57 = ({ tags: tags, timestamp: timestamp, authorDetails: authorDetails, authorHref: authorHref, authorHoverContent: authorHoverContent, id: id, onTitleClick: onTitleClick })=>{
    const [isAuthorHoverOpen, setIsAuthorHoverOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).useState(false);
    const authorHoverRef = (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).useRef(null);
    const tagsShown = tags.slice(0, 6);
    const extraTagCount = tags.length - tagsShown.length;
    const handleAuthorHoverOpen = ()=>setIsAuthorHoverOpen(true);
    const handleAuthorHoverClose = (event)=>{
        const relatedTarget = event?.relatedTarget;
        if (relatedTarget instanceof Node && authorHoverRef.current?.contains(relatedTarget)) return;
        setIsAuthorHoverOpen(false);
    };
    const authorContent = (0, $6bec4f26b2cb3094$export$25062201e9e25d76)((0, $0654f583dbdded1e$export$2e2bcd8739ae039), {
        alignItems: "center",
        gap: "space.100",
        children: [
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$3778be82376b06d7, {
                size: $24c02ea0e14dbe4f$export$902867f9afe4e0c1.S,
                src: authorDetails.avatarUrl,
                label: authorDetails.name
            }),
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $c9e5a7a14e07f4e4$export$2e2bcd8739ae039), {
                size: "medium",
                children: authorDetails.name
            })
        ]
    });
    return (0, $6bec4f26b2cb3094$export$25062201e9e25d76)((0, $0654f583dbdded1e$export$2e2bcd8739ae039), {
        wrap: "wrap",
        gap: "space.300",
        justifyContent: "space-between",
        children: [
            (0, $6bec4f26b2cb3094$export$25062201e9e25d76)((0, $0654f583dbdded1e$export$2e2bcd8739ae039), {
                wrap: "wrap",
                alignItems: "center",
                gap: "space.050",
                children: [
                    tagsShown.map((tag)=>{
                        return (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $abf94df1a292a623$export$2e2bcd8739ae039), {
                            as: "a",
                            href: tag.hyperlink,
                            xcss: [
                                $24c02ea0e14dbe4f$var$$65d6e13fe84e408e$var$pillInteractiveStyles,
                                $24c02ea0e14dbe4f$var$$65d6e13fe84e408e$var$anchorResetStyles
                            ],
                            children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$export$3288d34c523a1192, {
                                label: `# ${tag.tag}`,
                                backgroundColor: "transparent",
                                borderColor: "color.border",
                                textTransform: "none",
                                fontWeight: "normal",
                                fontFamily: "Atlassian Sans, sans-serif",
                                maxSize: "250px"
                            })
                        }, tag.tag);
                    }),
                    extraTagCount > 0 ? (0, $6bec4f26b2cb3094$export$25062201e9e25d76)((0, $123ba5aab151a241$export$2e2bcd8739ae039), {
                        onClick: ()=>onTitleClick(id),
                        appearance: "subtle",
                        children: [
                            "+",
                            extraTagCount,
                            " more"
                        ]
                    }) : null
                ]
            }),
            (0, $6bec4f26b2cb3094$export$25062201e9e25d76)((0, $0654f583dbdded1e$export$2e2bcd8739ae039), {
                gap: "space.200",
                alignItems: "center",
                justifyContent: "end",
                xcss: (0, $7c2f920c3bda89b1$export$f6c783d06584602c)({
                    flex: "1"
                }),
                children: [
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $c9e5a7a14e07f4e4$export$2e2bcd8739ae039), {
                        size: "medium",
                        children: $24c02ea0e14dbe4f$var$$027dbfbbc85481a9$export$a547c17dcfa0a6bc(timestamp)
                    }),
                    (0, $6bec4f26b2cb3094$export$25062201e9e25d76)((0, $abf94df1a292a623$export$2e2bcd8739ae039), {
                        xcss: $24c02ea0e14dbe4f$var$$65d6e13fe84e408e$var$authorHoverTargetStyles,
                        onMouseEnter: handleAuthorHoverOpen,
                        onMouseLeave: handleAuthorHoverClose,
                        onFocusCapture: handleAuthorHoverOpen,
                        onBlurCapture: handleAuthorHoverClose,
                        ref: authorHoverRef,
                        children: [
                            authorHref ? (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $abf94df1a292a623$export$2e2bcd8739ae039), {
                                as: "a",
                                href: authorHref,
                                xcss: [
                                    $24c02ea0e14dbe4f$var$$65d6e13fe84e408e$var$anchorDetailStyles,
                                    $24c02ea0e14dbe4f$var$$65d6e13fe84e408e$var$hoverUnderlineStyles
                                ],
                                children: authorContent
                            }) : (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $abf94df1a292a623$export$2e2bcd8739ae039), {
                                xcss: $24c02ea0e14dbe4f$var$$65d6e13fe84e408e$var$anchorDetailStyles,
                                children: authorContent
                            }),
                            authorHoverContent && isAuthorHoverOpen ? authorHoverContent : null
                        ]
                    })
                ]
            })
        ]
    });
};
const $24c02ea0e14dbe4f$var$$65d6e13fe84e408e$var$pillInteractiveStyles = (0, $7c2f920c3bda89b1$export$f6c783d06584602c)({
    cursor: "pointer",
    ":hover": {
        textTransform: "none",
        borderColor: "color.border",
        backgroundColor: "color.background.neutral.subtle.hovered"
    }
});
const $24c02ea0e14dbe4f$var$$65d6e13fe84e408e$var$authorHoverTargetStyles = (0, $7c2f920c3bda89b1$export$f6c783d06584602c)({
    position: "relative"
});
const $24c02ea0e14dbe4f$var$$3ec02f67788713f1$export$f438dff3491d77ab = ({ title: title, onTitleClick: onTitleClick, id: id })=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $abf94df1a292a623$export$2e2bcd8739ae039), {
        as: "button",
        type: "button",
        xcss: $24c02ea0e14dbe4f$var$$3ec02f67788713f1$var$titleButtonStyles,
        onClick: ()=>onTitleClick(id),
        children: (0, $6bec4f26b2cb3094$export$25062201e9e25d76)((0, $0654f583dbdded1e$export$2e2bcd8739ae039), {
            justifyContent: "space-between",
            alignItems: "center",
            gap: "space.100",
            children: [
                (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $abf94df1a292a623$export$2e2bcd8739ae039), {
                    as: "span",
                    style: {
                        fontSize: "24px",
                        fontFamily: "Charlie Display, sans-serif",
                        fontWeight: "600"
                    },
                    children: title
                }),
                (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($c98a967905aaff91$exports))), {
                    label: "Navigate",
                    size: "small"
                })
            ]
        })
    });
const $24c02ea0e14dbe4f$var$$3ec02f67788713f1$var$titleButtonStyles = (0, $7c2f920c3bda89b1$export$f6c783d06584602c)({
    color: "color.text",
    background: "none",
    borderWidth: "border.width.0",
    padding: "space.0",
    cursor: "pointer",
    textAlign: "left",
    ":hover": {
        color: "color.link"
    }
});
const $24c02ea0e14dbe4f$var$$11271ea5e6da2c5e$export$c806476cb62098c9 = ()=>(0, $6bec4f26b2cb3094$export$25062201e9e25d76)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "14",
        height: "14",
        viewBox: "0 0 14 14",
        fill: "none",
        children: [
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("path", {
                d: "M12.5 2C12.5 1.72386 12.2761 1.5 12 1.5H2C1.72386 1.5 1.5 1.72386 1.5 2V12C1.5 12.2761 1.72386 12.5 2 12.5H12C12.2761 12.5 12.5 12.2761 12.5 12V2ZM7.75 3V8H6.25V3H7.75ZM14 12C14 13.1046 13.1046 14 12 14H2C0.895431 14 1.00665e-08 13.1046 0 12V2C1.61066e-07 0.895431 0.89543 1.00665e-08 2 0H12C13.1046 1.61066e-07 14 0.89543 14 2V12Z",
                fill: "#6C6F77"
            }),
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("path", {
                d: "M8 10.25C8 10.8023 7.55228 11.25 7 11.25C6.44772 11.25 6 10.8023 6 10.25C6 9.69771 6.44772 9.25 7 9.25C7.55228 9.25 8 9.69771 8 10.25Z",
                fill: "#6C6F77"
            })
        ]
    });
const $24c02ea0e14dbe4f$var$$ae14dd6ecf20d4c3$export$6d2e2d5b3f4f86b8 = ({ showModerationDetails: showModerationDetails, isModerationReviewed: isModerationReviewed })=>{
    if (!showModerationDetails) return null;
    return (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $abf94df1a292a623$export$2e2bcd8739ae039), {
        padding: "space.075",
        children: isModerationReviewed ? (0, $6bec4f26b2cb3094$export$25062201e9e25d76)((0, $0654f583dbdded1e$export$2e2bcd8739ae039), {
            gap: "space.075",
            alignItems: "center",
            justifyContent: "end",
            children: [
                (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($0dd7a84998b77bec$exports))), {
                    label: "Approved by admin",
                    color: (0, $1ff81f2c5a4c494e$export$2e2bcd8739ae039)("color.icon.success")
                }),
                (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $c9e5a7a14e07f4e4$export$2e2bcd8739ae039), {
                    color: "color.text.success",
                    children: "Approved by admin"
                })
            ]
        }) : (0, $6bec4f26b2cb3094$export$25062201e9e25d76)((0, $0654f583dbdded1e$export$2e2bcd8739ae039), {
            gap: "space.075",
            alignItems: "center",
            justifyContent: "end",
            children: [
                (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$var$$11271ea5e6da2c5e$export$c806476cb62098c9, {}),
                (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $c9e5a7a14e07f4e4$export$2e2bcd8739ae039), {
                    color: "color.text.subtlest",
                    children: "Not yet reviewed"
                })
            ]
        })
    });
};
const $24c02ea0e14dbe4f$export$1074985837f1b2a5 = ({ contentType: contentType = $24c02ea0e14dbe4f$export$96b2e747ae3de284.Question, categoryType: categoryType, isFeatured: isFeatured = false, title: title, id: id, description: description, categoryName: categoryName, tags: tags = [], timestamp: timestamp, showModerationDetails: showModerationDetails = false, isModerationReviewed: isModerationReviewed = false, authorDetails: authorDetails, authorHoverContent: authorHoverContent, likes: likes, responses: responses, views: views, status: status, hostingType: hostingType = "data-center", onTitleClick: onTitleClick, authorHref: authorHref = "", categoryHref: categoryHref = "", menuComponent: menuComponent, isNew: isNew })=>{
    return (0, $6bec4f26b2cb3094$export$25062201e9e25d76)((0, $0654f583dbdded1e$export$2e2bcd8739ae039), {
        direction: "column",
        gap: "space.100",
        children: [
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$var$$ae14dd6ecf20d4c3$export$6d2e2d5b3f4f86b8, {
                showModerationDetails: showModerationDetails,
                isModerationReviewed: isModerationReviewed
            }),
            (0, $6bec4f26b2cb3094$export$25062201e9e25d76)((0, $abf94df1a292a623$export$2e2bcd8739ae039), {
                xcss: $24c02ea0e14dbe4f$var$$b0e23f9f192d2ea7$var$cardStyles,
                children: [
                    (0, $6bec4f26b2cb3094$export$25062201e9e25d76)((0, $0654f583dbdded1e$export$2e2bcd8739ae039), {
                        gap: "space.200",
                        direction: "column",
                        children: [
                            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$var$$06e8096ff5ff1247$export$7d7346e428084a7e, {
                                menuComponent: menuComponent,
                                categoryHref: categoryHref,
                                contentType: contentType,
                                categoryName: categoryName,
                                isFeatured: isFeatured,
                                categoryType: categoryType,
                                hostingType: hostingType,
                                isNew: isNew
                            }),
                            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$var$$3ec02f67788713f1$export$f438dff3491d77ab, {
                                title: title,
                                onTitleClick: onTitleClick,
                                id: id
                            }),
                            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $c9e5a7a14e07f4e4$export$2e2bcd8739ae039), {
                                size: "large",
                                maxLines: 2,
                                children: description
                            }),
                            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$var$$65d6e13fe84e408e$export$1e30305c33fd8c57, {
                                authorHref: authorHref,
                                tags: tags,
                                timestamp: timestamp,
                                authorDetails: authorDetails,
                                authorHoverContent: authorHoverContent,
                                onTitleClick: onTitleClick,
                                id: id
                            })
                        ]
                    }),
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $abf94df1a292a623$export$2e2bcd8739ae039), {
                        xcss: $24c02ea0e14dbe4f$var$$b0e23f9f192d2ea7$var$dividerStyles
                    }),
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($24c02ea0e14dbe4f$var$$2248ded33c1cc26f$export$9e55f86bc7a20cd4, {
                        contentType: contentType,
                        likes: likes,
                        responses: responses,
                        views: views,
                        status: status
                    })
                ]
            })
        ]
    });
};
const $24c02ea0e14dbe4f$var$$b0e23f9f192d2ea7$var$cardStyles = (0, $7c2f920c3bda89b1$export$f6c783d06584602c)({
    display: "flex",
    flexDirection: "column",
    gap: "space.200",
    padding: "space.200",
    backgroundColor: "elevation.surface",
    borderRadius: "border.radius.200",
    boxShadow: "elevation.shadow.raised",
    width: "100%",
    boxSizing: "border-box"
});
const $24c02ea0e14dbe4f$var$$b0e23f9f192d2ea7$var$dividerStyles = (0, $7c2f920c3bda89b1$export$f6c783d06584602c)({
    width: "100%",
    borderTopWidth: "border.width",
    borderTopStyle: "solid",
    borderTopColor: "color.border",
    borderRadius: "border.radius.circle"
});
$24c02ea0e14dbe4f$var$$parcel$exportWildcard($24c02ea0e14dbe4f$var$$976a3c76bc9fa9bc$exports, $24c02ea0e14dbe4f$var$$b0e23f9f192d2ea7$exports);
$24c02ea0e14dbe4f$var$$parcel$exportWildcard($24c02ea0e14dbe4f$var$$976a3c76bc9fa9bc$exports, $24c02ea0e14dbe4f$var$$fa9d4c58bb661680$exports);
$24c02ea0e14dbe4f$var$$parcel$exportWildcard($24c02ea0e14dbe4f$var$$0cf4554ad00467b5$exports, $24c02ea0e14dbe4f$var$$a3d28c94a229f94e$exports);
$24c02ea0e14dbe4f$var$$parcel$exportWildcard($24c02ea0e14dbe4f$var$$0cf4554ad00467b5$exports, $24c02ea0e14dbe4f$var$$976a3c76bc9fa9bc$exports);
$24c02ea0e14dbe4f$var$$parcel$exportWildcard($24c02ea0e14dbe4f$var$$a69491ea5a126553$exports, $24c02ea0e14dbe4f$var$$5d4509b60606b6df$exports);
$24c02ea0e14dbe4f$var$$parcel$exportWildcard($24c02ea0e14dbe4f$var$$a69491ea5a126553$exports, $24c02ea0e14dbe4f$var$$6e379ec2eca3d7d3$exports);
$24c02ea0e14dbe4f$var$$parcel$exportWildcard($24c02ea0e14dbe4f$var$$a69491ea5a126553$exports, $24c02ea0e14dbe4f$var$$a6a41c835fd01d00$exports);
$24c02ea0e14dbe4f$var$$parcel$exportWildcard($24c02ea0e14dbe4f$var$$a69491ea5a126553$exports, $24c02ea0e14dbe4f$var$$0cf4554ad00467b5$exports);


const $6cf738ba21080f36$export$a06f1c675e846f6f = ({ isLoggedIn: isLoggedIn, loggedInUser: loggedInUser })=>/*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $faf30355a80342e4$exports.Fragment), {
        children: /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $24c02ea0e14dbe4f$export$7a92b4adf6bd95bb), {
            isLoggedIn: isLoggedIn,
            email: loggedInUser?.email || 'test@atlassian.com',
            showAppUpdates: true
        })
    });



var $a73be79b54a68660$exports = {};
"use strict";
Object.defineProperty($a73be79b54a68660$exports, "__esModule", {
    value: true
});
var $d9a56230c565b38a$exports = {};
"use strict";
Object.defineProperty($d9a56230c565b38a$exports, "__esModule", {
    value: true
});
var $e70db4c19b26a7d8$exports = {};
"use strict";
Object.defineProperty($e70db4c19b26a7d8$exports, "__esModule", {
    value: true
});
$e70db4c19b26a7d8$exports.TestComponent = void 0;

var $e70db4c19b26a7d8$var$_react = $e70db4c19b26a7d8$var$_interopRequireDefault((parcelRequire("5FkrB")));
function $e70db4c19b26a7d8$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
var $e70db4c19b26a7d8$var$TestComponent = $e70db4c19b26a7d8$exports.TestComponent = function TestComponent(_ref) {
    var text = _ref.text, subtext = _ref.subtext;
    return /*#__PURE__*/ $e70db4c19b26a7d8$var$_react["default"].createElement("div", null, /*#__PURE__*/ $e70db4c19b26a7d8$var$_react["default"].createElement("h1", null, text), subtext ? /*#__PURE__*/ $e70db4c19b26a7d8$var$_react["default"].createElement("div", null, subtext) : null);
};


Object.keys($e70db4c19b26a7d8$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $d9a56230c565b38a$exports && $d9a56230c565b38a$exports[key] === $e70db4c19b26a7d8$exports[key]) return;
    Object.defineProperty($d9a56230c565b38a$exports, key, {
        enumerable: true,
        get: function get() {
            return $e70db4c19b26a7d8$exports[key];
        }
    });
});
var $5533df6f33d2f6e3$exports = {};
/* index.tsx generated by @compiled/babel-plugin v0.31.0 */ "use strict";
Object.defineProperty($5533df6f33d2f6e3$exports, "__esModule", {
    value: true
});
$5533df6f33d2f6e3$exports.ConsentModal = void 0;

var $970q7 = parcelRequire("970q7");

var $5533df6f33d2f6e3$var$_react = $5533df6f33d2f6e3$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $5533df6f33d2f6e3$var$_modalDialog = $5533df6f33d2f6e3$var$_interopRequireDefault((parcelRequire("lnqhJ")));

var $5533df6f33d2f6e3$var$_new = $5533df6f33d2f6e3$var$_interopRequireDefault((parcelRequire("427nl")));
function $5533df6f33d2f6e3$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
// import './ConsentModal.module.css';
/**
 * Component that renders a inline code in topic body
 * @param {ConsentModalProps} ConsentModalProps
 * @returns {React.ReactElement} React.ReactElement
 *
 * @example
 * <ConsentModal onClick={ () => setConsent() } />
 */ var $5533df6f33d2f6e3$var$ConsentModal = $5533df6f33d2f6e3$exports.ConsentModal = function ConsentModal(_ref) {
    var onClick = _ref.onClick;
    return /*#__PURE__*/ $5533df6f33d2f6e3$var$_react["default"].createElement($5533df6f33d2f6e3$var$_modalDialog["default"], {
        shouldScrollInViewport: true
    }, /*#__PURE__*/ $5533df6f33d2f6e3$var$_react["default"].createElement("div", {
        className: (0, $970q7.default)([
            "_1e0c1txw _4cvr1h6o _2lx21bp4 _19pk7vkz _ca0q1ylp _u5f31ylp _n3td1ylp _19bv1ylp"
        ])
    }, /*#__PURE__*/ $5533df6f33d2f6e3$var$_react["default"].createElement("h1", {
        className: (0, $970q7.default)([
            "_ect46nat _1wybzwfg _k48pni7l _vwz41ylp _19pkidpf _otyr7vkz _y3gn1h6o"
        ])
    }, "Welcome to Early Access"), /*#__PURE__*/ $5533df6f33d2f6e3$var$_react["default"].createElement("p", {
        className: (0, $970q7.default)([
            "_ect4oyw7 _1wybgktf _k48p1nn1 _vwz41tcg _y3gn1h6o _otyrzwfg"
        ])
    }, "By signing up for the Early Access Program (\u201CEAP\u201D), you acknowledge the", ' ', /*#__PURE__*/ $5533df6f33d2f6e3$var$_react["default"].createElement("a", {
        href: "http://atlassian.com/legal/privacy-policy",
        className: (0, $970q7.default)([
            "_syaz7g9i"
        ])
    }, "Atlassian Privacy Policy"), ' ', "and that use of the EAP products is governed by the", ' ', /*#__PURE__*/ $5533df6f33d2f6e3$var$_react["default"].createElement("a", {
        href: "https://www.atlassian.com/legal/community-platform-terms-of-use",
        className: (0, $970q7.default)([
            "_syaz7g9i"
        ])
    }, "Online Community Platform Terms of Use"), "."), /*#__PURE__*/ $5533df6f33d2f6e3$var$_react["default"].createElement("div", {
        className: (0, $970q7.default)([
            "_ect4zeyy"
        ])
    }, /*#__PURE__*/ $5533df6f33d2f6e3$var$_react["default"].createElement($5533df6f33d2f6e3$var$_new["default"], {
        appearance: "primary",
        onClick: onClick
    }, "Agree and sign up"))));
};
var $5533df6f33d2f6e3$var$contentStyles = null;
var $5533df6f33d2f6e3$var$headerStyles = null;
var $5533df6f33d2f6e3$var$bodyStyles = null;
var $5533df6f33d2f6e3$var$linkStyles = null;
var $5533df6f33d2f6e3$var$buttonContainerStyles = null;


Object.keys($5533df6f33d2f6e3$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $d9a56230c565b38a$exports && $d9a56230c565b38a$exports[key] === $5533df6f33d2f6e3$exports[key]) return;
    Object.defineProperty($d9a56230c565b38a$exports, key, {
        enumerable: true,
        get: function get() {
            return $5533df6f33d2f6e3$exports[key];
        }
    });
});
var $3506c2b8472f3d94$exports = {};
"use strict";
function $3506c2b8472f3d94$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $3506c2b8472f3d94$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $3506c2b8472f3d94$var$_typeof(o);
}
Object.defineProperty($3506c2b8472f3d94$exports, "__esModule", {
    value: true
});
$3506c2b8472f3d94$exports.ConsentValidator = void 0;

var $3506c2b8472f3d94$var$_react = $3506c2b8472f3d94$var$_interopRequireDefault((parcelRequire("5FkrB")));
var $9274af858143a4bd$exports = {};
"use strict";
function $9274af858143a4bd$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $9274af858143a4bd$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $9274af858143a4bd$var$_typeof(o);
}
Object.defineProperty($9274af858143a4bd$exports, "__esModule", {
    value: true
});
$9274af858143a4bd$exports.userConsentStatuses = $9274af858143a4bd$exports.setUserConsent = $9274af858143a4bd$exports.isUserConsented = void 0;
var $6601efa3d6ce5781$exports = {};
"use strict";
Object.defineProperty($6601efa3d6ce5781$exports, "__esModule", {
    value: true
});
$6601efa3d6ce5781$exports.getUserIsConsentedQuery = $6601efa3d6ce5781$exports.getUserIsAllowedQuery = $6601efa3d6ce5781$exports.getUserAccountQuery = $6601efa3d6ce5781$exports.USER_INFO_QUERY = void 0;
var $6601efa3d6ce5781$var$getUserIsAllowedQuery = $6601efa3d6ce5781$exports.getUserIsAllowedQuery = function getUserIsAllowedQuery(emailId) {
    return "\n  query USER_ALLOWED_QUERY {\n    unified {\n      gating {\n        isEmailIdAllowed(emailId: \"".concat(emailId, "\") {\n          ... on UnifiedQueryError {\n            identifier\n            message\n            extensions {\n              errorType\n              statusCode\n            }\n          }\n          ... on UnifiedAccessStatus {\n            id\n            status\n          }\n        }\n      }\n    }\n  }\n");
};
var $6601efa3d6ce5781$var$USER_INFO_QUERY = $6601efa3d6ce5781$exports.USER_INFO_QUERY = "query USER_INFO_QUERY {\n  me {\n    user {\n      ... on AtlassianAccountUser {\n        email\n        accountId\n        orgId\n        picture\n      }\n    }\n  }\n}";
var $6601efa3d6ce5781$var$getUserIsConsentedQuery = $6601efa3d6ce5781$exports.getUserIsConsentedQuery = function getUserIsConsentedQuery(aaid) {
    return "\n  query USER_CONSENTED_QUERY {\n    unified {\n      consent {\n      getConsent(value: \"".concat(aaid, "\", type: \"AAID\") {\n        ... on UnifiedConsentStatus {\n          id\n          createdAt\n          type\n          updatedAt\n          value\n          consentObj {\n            consentKey\n            consentStatus\n            consenthubStatus\n            createdAt\n            updatedAt\n            uppConsentStatus\n          }\n        }\n        ... on UnifiedQueryError {\n          identifier\n          message\n          code\n        }\n      }\n    }\n  }\n}");
};
var $6601efa3d6ce5781$var$getUserAccountQuery = $6601efa3d6ce5781$exports.getUserAccountQuery = function getUserAccountQuery(aaid) {
    return "\n  query USER_ACCOUNT_QUERY {\n    unified {\n      account(aaid: \"".concat(aaid, "\") {\n        ... on UnifiedAccount {\n          aaid\n          atlassianOneUserId\n          emailId\n          id\n          internalId\n          isLinked\n          isManaged\n          isPrimary\n          isProfileOwnerConsented\n          khorosUserId\n        }\n        ... on UnifiedQueryError {\n          code\n          identifier\n          message\n        }\n      }\n    }\n  }\n");
};


var $6eda9e6c03494bd2$exports = {};
"use strict";
Object.defineProperty($6eda9e6c03494bd2$exports, "__esModule", {
    value: true
});
$6eda9e6c03494bd2$exports.setUserIsConsentedMutation = $6eda9e6c03494bd2$exports.initializeCommunityMutationbyAaid = $6eda9e6c03494bd2$exports.initializeCommunityMutation = $6eda9e6c03494bd2$exports.SUBMIT_CHAMPION_SIGNUP_MUTATION = void 0;
var $6eda9e6c03494bd2$var$setUserIsConsentedMutation = $6eda9e6c03494bd2$exports.setUserIsConsentedMutation = function setUserIsConsentedMutation(aaid, consentKey) {
    return "\n  mutation SET_USER_CONSENTED_MUTATION {\n    unified {\n      consent {\n        setConsent(\n          consentObj: {consentKey: \"".concat(consentKey, "\", consentStatus: \"true\"}\n          type: \"AAID\"\n          value: \"").concat(aaid, "\"\n        ) {\n          errors {\n            message\n          }\n          message\n          success\n      }\n    }\n  }\n}");
};
var $6eda9e6c03494bd2$var$initializeCommunityMutation = $6eda9e6c03494bd2$exports.initializeCommunityMutation = function initializeCommunityMutation(emailId) {
    return "\nmutation INITIALIZE_COMMUNITY_MUTATION {\n  unified {\n    community {\n      initializeCommunity(emailId: \"".concat(emailId, "\") {\n        success\n        errors {\n          code\n          message\n          extensions {\n            errorType\n            statusCode\n          }\n        }\n        forumsProfile {\n          id\n          login\n        }\n        gamificationProfile {\n          firstName\n          userId\n        }\n        unifiedProfile {\n          accountInternalId\n        }\n        isNewForumsProfile\n        isNewGamificationProfile\n        isNewProfile\n      }\n    }\n  }\n}");
};
var $6eda9e6c03494bd2$var$initializeCommunityMutationbyAaid = $6eda9e6c03494bd2$exports.initializeCommunityMutationbyAaid = function initializeCommunityMutationbyAaid(aaid) {
    return "\nmutation INITIALIZE_COMMUNITY_MUTATION {\n  unified {\n    community {\n      initializeCommunity(aaid: \"".concat(aaid, "\") {\n        success\n        errors {\n          code\n          message\n          extensions {\n            errorType\n            statusCode\n          }\n        }\n        forumsProfile {\n          id\n          login\n        }\n        gamificationProfile {\n          firstName\n          userId\n        }\n        unifiedProfile {\n          accountInternalId\n        }\n        isNewForumsProfile\n        isNewGamificationProfile\n        isNewProfile\n      }\n    }\n  }\n}");
};
var $6eda9e6c03494bd2$var$SUBMIT_CHAMPION_SIGNUP_MUTATION = $6eda9e6c03494bd2$exports.SUBMIT_CHAMPION_SIGNUP_MUTATION = "\n  mutation SUBMIT_CHAMPION_SIGNUP_MUTATION($input: UnifiedChampionSignupInput) {\n    champion {\n      championSignup {\n        submitChampionSignup(input: $input) {\n          success\n          message\n        }\n      }\n    }\n  }\n";


var $9b8dc532c3c3f9ae$exports = {};
"use strict";
Object.defineProperty($9b8dc532c3c3f9ae$exports, "__esModule", {
    value: true
});
$9b8dc532c3c3f9ae$exports.shouldUseStargate = $9b8dc532c3c3f9ae$exports.getXidEnvironment = $9b8dc532c3c3f9ae$exports.getUppApiPathFromEnvironment = $9b8dc532c3c3f9ae$exports.getGASv3Environment = $9b8dc532c3c3f9ae$exports.getEnvironment = $9b8dc532c3c3f9ae$exports.getAnalyticsWriteKey = $9b8dc532c3c3f9ae$exports.ENVIRONMENT_CONFIGS = void 0;

var $iVpQc = parcelRequire("iVpQc");
var $a576733921801e90$exports = {};
"use strict";
Object.defineProperty($a576733921801e90$exports, "__esModule", {
    value: true
});

var $l2Z7B = parcelRequire("l2Z7B");

$l2Z7B.__exportStar((parcelRequire("4qBHc")), $a576733921801e90$exports);
var $5cdc7272fdf5cc1c$exports = {};
"use strict";
Object.defineProperty($5cdc7272fdf5cc1c$exports, "__esModule", {
    value: true
});

var $l2Z7B = parcelRequire("l2Z7B");

var $5cdc7272fdf5cc1c$var$promise_polyfill_1 = $l2Z7B.__importDefault((parcelRequire("7UOcZ")));
var $43113123be356ccf$exports = {};
"use strict";
Object.defineProperty($43113123be356ccf$exports, "__esModule", {
    value: true
});

var $l2Z7B = parcelRequire("l2Z7B");
var $0b6506b711105af1$exports = {};
"use strict";
Object.defineProperty($0b6506b711105af1$exports, "__esModule", {
    value: true
});

var $l2Z7B = parcelRequire("l2Z7B");
var $0b6506b711105af1$var$set = function(name, value, options) {
    var str = $0b6506b711105af1$var$encode(name) + '=' + $0b6506b711105af1$var$encode((value || '').toString());
    if (value == null) options.maxage = -1;
    var expiry;
    if (options.maxage) expiry = new Date(+new Date() + options.maxage);
    if (options.path) str += '; path=' + options.path;
    if (options.domain) str += '; domain=' + options.domain;
    if (expiry) str += '; expires=' + expiry.toUTCString();
    if (options.secure) str += '; secure';
    if (options.sameSite) str += '; samesite=' + options.sameSite;
    document.cookie = str;
    return str;
};
var $0b6506b711105af1$var$all = function() {
    try {
        return $0b6506b711105af1$var$parse(document.cookie);
    } catch (err) {
        if (typeof console !== 'undefined' && typeof console.error === 'function') console.error(err.stack || err);
        return {};
    }
};
function $0b6506b711105af1$var$get(name) {
    return $0b6506b711105af1$var$all()[name];
}
function $0b6506b711105af1$var$parse(str) {
    var obj = {};
    var pairs = str.split(/ *; */);
    if (pairs[0] === '') return obj;
    pairs.forEach(function(item) {
        var pair = item.split('=');
        var key = $0b6506b711105af1$var$decode(pair[0]);
        var value = $0b6506b711105af1$var$decode(pair[1]);
        if (key && value) obj[key] = value;
    });
    return obj;
}
function $0b6506b711105af1$var$encode(value) {
    try {
        return encodeURIComponent(value);
    } catch (e) {
        console.log('error `encode(%o)` - %o', value, e);
        return "";
    }
}
function $0b6506b711105af1$var$decode(value) {
    try {
        return decodeURIComponent(value);
    } catch (e) {
        console.log('error `decode(%o)` - %o', value, e);
        return "";
    }
}
function $0b6506b711105af1$var$getCookie(name) {
    return $0b6506b711105af1$var$get(name);
}
$0b6506b711105af1$exports.getCookie = $0b6506b711105af1$var$getCookie;
function $0b6506b711105af1$var$getAllCookies() {
    return $0b6506b711105af1$var$all();
}
$0b6506b711105af1$exports.getAllCookies = $0b6506b711105af1$var$getAllCookies;
function $0b6506b711105af1$var$setCookie(name, value, options) {
    var finalOption = $l2Z7B.__assign({
        maxage: 31536000000,
        secure: true,
        path: '/',
        expires: null,
        domain: null,
        sameSite: 'lax'
    }, options);
    return $0b6506b711105af1$var$set(name, value, finalOption);
}
$0b6506b711105af1$exports.setCookie = $0b6506b711105af1$var$setCookie;
function $0b6506b711105af1$var$getCrossDomainCookieOption() {
    var domain = window.location.hostname.split('.').slice(-2).join('.');
    return {
        sameSite: 'None',
        domain: domain
    };
}
$0b6506b711105af1$exports.getCrossDomainCookieOption = $0b6506b711105af1$var$getCrossDomainCookieOption;



var $4qBHc = parcelRequire("4qBHc");
var $2c0cc5aa0127ff82$exports = {};
"use strict";
Object.defineProperty($2c0cc5aa0127ff82$exports, "__esModule", {
    value: true
});

var $a28e63c01fe9e2bf$exports = {};
"use strict";
Object.defineProperty($a28e63c01fe9e2bf$exports, "__esModule", {
    value: true
});

var $4qBHc = parcelRequire("4qBHc");
$a28e63c01fe9e2bf$exports.checkXidValid = function(xid) {
    return (xid.type === $4qBHc.XIDItemType.UID || xid.type === $4qBHc.XIDItemType.XC) && !!xid.value && !!Date.parse(xid.createdAt);
};


var $2c0cc5aa0127ff82$var$parseCachedXidItem = function(value) {
    try {
        var xid = JSON.parse(value);
        if (xid instanceof Array) {
            var valid = true;
            for(var _i = 0, xid_1 = xid; _i < xid_1.length; _i++){
                var entry = xid_1[_i];
                valid = valid && $a28e63c01fe9e2bf$exports.checkXidValid(entry);
            }
            return valid ? xid : undefined;
        } else return $a28e63c01fe9e2bf$exports.checkXidValid(xid) ? xid : undefined;
    } catch (err) {
        return;
    }
};
function $2c0cc5aa0127ff82$var$getFromLocalStorage(name) {
    try {
        return localStorage.getItem(name) || '';
    } catch (err) {}
}
function $2c0cc5aa0127ff82$var$getXidFromCookie(name) {
    var cookieValue = $0b6506b711105af1$exports.getCookie(name);
    return $2c0cc5aa0127ff82$var$parseCachedXidItem(cookieValue);
}
$2c0cc5aa0127ff82$exports.getXidFromCookie = $2c0cc5aa0127ff82$var$getXidFromCookie;
function $2c0cc5aa0127ff82$var$getXidFromLocalStorage(name) {
    var lsValue = '';
    try {
        lsValue = localStorage.getItem(name) || '';
    } catch (err) {}
    return $2c0cc5aa0127ff82$var$parseCachedXidItem(lsValue);
}
$2c0cc5aa0127ff82$exports.getXidFromLocalStorage = $2c0cc5aa0127ff82$var$getXidFromLocalStorage;
function $2c0cc5aa0127ff82$var$setLocalstorage(name, value) {
    try {
        localStorage.setItem(name, value);
    } catch (err) {}
}
$2c0cc5aa0127ff82$exports.setLocalstorage = $2c0cc5aa0127ff82$var$setLocalstorage;
function $2c0cc5aa0127ff82$var$getCache(name) {
    return $0b6506b711105af1$exports.getCookie(name) || $2c0cc5aa0127ff82$var$getFromLocalStorage(name);
}
$2c0cc5aa0127ff82$exports.getCache = $2c0cc5aa0127ff82$var$getCache;
function $2c0cc5aa0127ff82$var$getXidItemFromCache(name) {
    return $2c0cc5aa0127ff82$var$getXidFromCookie(name) || $2c0cc5aa0127ff82$var$getXidFromLocalStorage(name);
}
$2c0cc5aa0127ff82$exports.getXidItemFromCache = $2c0cc5aa0127ff82$var$getXidItemFromCache;


var $e226362dd6674ff5$exports = {};
"use strict";
Object.defineProperty($e226362dd6674ff5$exports, "__esModule", {
    value: true
});

var $25cd23fdd1b43e03$exports = {};
"use strict";
Object.defineProperty($25cd23fdd1b43e03$exports, "__esModule", {
    value: true
});
$25cd23fdd1b43e03$exports.parse = function(url) {
    var a = document.createElement('a');
    a.href = url;
    return {
        href: a.href,
        host: a.host || location.host,
        port: '0' === a.port || '' === a.port ? $25cd23fdd1b43e03$exports.port(a.protocol) : a.port,
        hash: a.hash,
        hostname: a.hostname || location.hostname,
        pathname: a.pathname.charAt(0) !== '/' ? '/' + a.pathname : a.pathname,
        protocol: !a.protocol || ':' === a.protocol ? location.protocol : a.protocol,
        search: a.search,
        query: a.search.slice(1)
    };
};
$25cd23fdd1b43e03$exports.isAbsolute = function(url) {
    return 0 === url.indexOf('//') || !!~url.indexOf('://');
};
$25cd23fdd1b43e03$exports.isRelative = function(url) {
    return !$25cd23fdd1b43e03$exports.isAbsolute(url);
};
$25cd23fdd1b43e03$exports.isCrossDomain = function(url) {
    var finalUrl = $25cd23fdd1b43e03$exports.parse(url);
    var location1 = $25cd23fdd1b43e03$exports.parse(window.location.href);
    return finalUrl.hostname !== location1.hostname || finalUrl.port !== location1.port || finalUrl.protocol !== location1.protocol;
};
$25cd23fdd1b43e03$exports.port = function(protocol) {
    switch(protocol){
        case 'http:':
            return 80;
        case 'https:':
            return 443;
        default:
            return location.port;
    }
};
$25cd23fdd1b43e03$exports.getParam = function(name) {
    var b = window.location.href.match('[?&]' + name + '=([^&#]+)');
    return b ? b.pop() : '';
};


var $e226362dd6674ff5$var$getLevels = function(url) {
    var host = $25cd23fdd1b43e03$exports.parse(url).hostname;
    var parts = host.split('.');
    var last = parts[parts.length - 1];
    var levels = [];
    if (parts.length === 4 && !isNaN(parseInt(last, 10))) return levels;
    if (parts.length <= 1) return levels;
    for(var i = parts.length - 2; i >= 0; --i)levels.push(parts.slice(i).join('.'));
    return levels;
};
$e226362dd6674ff5$exports.domain = function(url) {
    var domainLevels = $e226362dd6674ff5$var$getLevels(url);
    for(var _i = 0, domainLevels_1 = domainLevels; _i < domainLevels_1.length; _i++){
        var domainLevel = domainLevels_1[_i];
        var cname = '__tld__';
        var opts = {
            domain: '.' + domainLevel
        };
        $0b6506b711105af1$exports.setCookie(cname, 1, opts);
        if ($0b6506b711105af1$exports.getCookie(cname)) {
            $0b6506b711105af1$exports.setCookie(cname, null, opts);
            return domainLevel;
        }
    }
    return '';
};
$e226362dd6674ff5$exports.inIframe = function() {
    try {
        return window.self !== window.top;
    } catch (e) {
        return true;
    }
};
$e226362dd6674ff5$exports.isAtlassianComDomain = function() {
    return /atlassian\.com$/.test(window.location.hostname);
};


var $0efdf1f5ff90e2ff$exports = {};
"use strict";
Object.defineProperty($0efdf1f5ff90e2ff$exports, "__esModule", {
    value: true
});
$0efdf1f5ff90e2ff$exports.uuidv4 = function() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(char) {
        var random = Math.random() * 16 | 0;
        var uuid = char === 'x' ? random : random & 0x3 | 0x8;
        return uuid.toString(16);
    });
};


var $43113123be356ccf$var$UID_REFRESH_PERIOD = 604800000;
var $43113123be356ccf$var$XC_REFRESH_PERIOD = 2592000000;
$43113123be356ccf$exports.XC_CURRENT = 'atl_xid.xc';
var $43113123be356ccf$var$XID_REFRESHED_AT = 'atl_xid.ts';
var $43113123be356ccf$var$XID_CURRENT = 'atl_xid.current';
var $43113123be356ccf$var$UIDS_ALL = 'atl_xid.uid';
var $43113123be356ccf$var$UIDS_STORE_LIMIT = 20;
var $43113123be356ccf$var$Storage = function() {
    function Storage() {}
    Storage.getCachedXID = function() {
        try {
            var currentXID = $2c0cc5aa0127ff82$exports.getXidItemFromCache($43113123be356ccf$var$XID_CURRENT);
            var refreshedAt = $2c0cc5aa0127ff82$exports.getCache($43113123be356ccf$var$XID_REFRESHED_AT);
            var isFresh = false;
            if (currentXID.length > 0 && currentXID[0].type === $4qBHc.XIDItemType.UID) isFresh = parseInt(refreshedAt || '', 10) >= new Date().getTime() - $43113123be356ccf$var$UID_REFRESH_PERIOD;
            else if (currentXID.length > 0 && currentXID[0].type === $4qBHc.XIDItemType.XC) isFresh = parseInt(refreshedAt || '', 10) >= new Date().getTime() - $43113123be356ccf$var$XC_REFRESH_PERIOD;
            if (isFresh) {
                for(var _i = 0, currentXID_1 = currentXID; _i < currentXID_1.length; _i++){
                    var entry = currentXID_1[_i];
                    entry.state = $4qBHc.XIDState.EXISTING;
                }
                return currentXID;
            } else return [];
        } catch (err) {
            return [];
        }
    };
    Storage.saveXid = function(xid) {
        try {
            $0b6506b711105af1$exports.setCookie($43113123be356ccf$var$XID_REFRESHED_AT, new Date().getTime());
            $2c0cc5aa0127ff82$exports.setLocalstorage($43113123be356ccf$var$XID_REFRESHED_AT, new Date().getTime().toString());
            var xidCache = [];
            for(var _i = 0, xid_1 = xid; _i < xid_1.length; _i++){
                var entry = xid_1[_i];
                if (entry.value && entry.createdAt) {
                    xidCache.push({
                        type: entry.type,
                        value: entry.value,
                        createdAt: entry.createdAt
                    });
                    break;
                }
            }
            $0b6506b711105af1$exports.setCookie($43113123be356ccf$var$XID_CURRENT, JSON.stringify(xidCache));
            $2c0cc5aa0127ff82$exports.setLocalstorage($43113123be356ccf$var$XID_CURRENT, JSON.stringify(xidCache));
        } catch (err) {
            console.error('Error setting xid cookie.');
        }
    };
    Storage.updateXc = function(env, xc) {
        try {
            if (env === $4qBHc.Environment.PROD && $e226362dd6674ff5$exports.isAtlassianComDomain()) return Storage.processAtlassianComDomainXc(xc);
            else Storage.saveXcLocalstorage(xc);
        } catch (err) {
            console.error('Error setting xc cookie.');
        }
        return xc;
    };
    Storage.getUids = function() {
        var uid = $2c0cc5aa0127ff82$exports.getXidItemFromCache($43113123be356ccf$var$UIDS_ALL) || [];
        for(var _i = 0, uid_1 = uid; _i < uid_1.length; _i++){
            var entry = uid_1[_i];
            entry.state = $4qBHc.XIDState.EXISTING;
        }
        return uid;
    };
    Storage.saveUids = function(uid) {
        try {
            var uidCache = [];
            for(var _i = 0, uid_2 = uid; _i < uid_2.length; _i++){
                var entry = uid_2[_i];
                if (entry.value && entry.createdAt) uidCache.push({
                    type: entry.type,
                    value: entry.value,
                    createdAt: entry.createdAt
                });
            }
            uidCache.slice(0, $43113123be356ccf$var$UIDS_STORE_LIMIT);
            $2c0cc5aa0127ff82$exports.setLocalstorage($43113123be356ccf$var$UIDS_ALL, JSON.stringify(uidCache));
        } catch (err) {
            console.error('Error setting uid cookie.');
        }
    };
    Storage.saveXcLocalstorage = function(xc) {
        if (xc.value && xc.createdAt) {
            var currentXcCache = $2c0cc5aa0127ff82$exports.getXidFromLocalStorage($43113123be356ccf$exports.XC_CURRENT);
            if (currentXcCache && currentXcCache.value === xc.value) return;
            else if (currentXcCache && currentXcCache.value !== xc.value) xc.state = $4qBHc.XIDState.CHANGED;
            var xidCache = {
                type: xc.type,
                value: xc.value,
                createdAt: xc.createdAt
            };
            $2c0cc5aa0127ff82$exports.setLocalstorage($43113123be356ccf$exports.XC_CURRENT, JSON.stringify(xidCache));
        }
    };
    Storage.processAtlassianComDomainXc = function(xc) {
        if (xc.value && xc.createdAt) {
            var currentXcCache = $2c0cc5aa0127ff82$exports.getXidFromCookie($43113123be356ccf$exports.XC_CURRENT);
            if (currentXcCache) {
                $0b6506b711105af1$exports.setCookie($43113123be356ccf$exports.XC_CURRENT, JSON.stringify(currentXcCache), $0b6506b711105af1$exports.getCrossDomainCookieOption());
                var currentXc = $l2Z7B.__assign({
                    state: $4qBHc.XIDState.EXISTING
                }, currentXcCache);
                Storage.saveXcLocalstorage(currentXc);
                return currentXc;
            } else {
                var newXcCache = {
                    value: $0efdf1f5ff90e2ff$exports.uuidv4(),
                    createdAt: new Date().toISOString(),
                    type: $4qBHc.XIDItemType.XC
                };
                $0b6506b711105af1$exports.setCookie($43113123be356ccf$exports.XC_CURRENT, JSON.stringify(newXcCache), $0b6506b711105af1$exports.getCrossDomainCookieOption());
                var newXc = $l2Z7B.__assign({
                    state: $4qBHc.XIDState.NEW
                }, newXcCache);
                Storage.saveXcLocalstorage(newXc);
                return newXc;
            }
        } else return xc;
    };
    return Storage;
}();
$43113123be356ccf$exports.Storage = $43113123be356ccf$var$Storage;


var $80509bb111a91081$exports = {};
"use strict";
Object.defineProperty($80509bb111a91081$exports, "__esModule", {
    value: true
});

var $l2Z7B = parcelRequire("l2Z7B");
var $3d8c7377a85fa527$exports = {};
"use strict";
Object.defineProperty($3d8c7377a85fa527$exports, "__esModule", {
    value: true
});
var $2f54eebc6872cda3$exports = {};
"use strict";
Object.defineProperty($2f54eebc6872cda3$exports, "__esModule", {
    value: true
});
var $96e78a72aef15085$exports = {};
"use strict";
Object.defineProperty($96e78a72aef15085$exports, "__esModule", {
    value: true
});
$96e78a72aef15085$exports.UNAVAILABLE = "UNAVAILABLE";
$96e78a72aef15085$exports.ERROR = "ERROR";
$96e78a72aef15085$exports.YES = "YES";
$96e78a72aef15085$exports.NO = "NO";


function $2f54eebc6872cda3$var$browserDefaultEvalLength() {
    try {
        return eval.toString().length || 0;
    } catch (err) {
        return $96e78a72aef15085$exports.ERROR;
    }
}
$2f54eebc6872cda3$exports.browserDefaultEvalLength = $2f54eebc6872cda3$var$browserDefaultEvalLength;


$3d8c7377a85fa527$exports.browserDefaultEvalLength = $2f54eebc6872cda3$exports.browserDefaultEvalLength;
var $9603535221c4e017$exports = {};
"use strict";
Object.defineProperty($9603535221c4e017$exports, "__esModule", {
    value: true
});

function $9603535221c4e017$var$canWriteCookie() {
    try {
        document.cookie = "cookietest=1";
        if (document.cookie.indexOf("cookietest=") !== -1) {
            document.cookie = "cookietest=1; expires=Thu, 01-Jan-1970 00:00:01 GMT";
            return $96e78a72aef15085$exports.YES;
        }
        return $96e78a72aef15085$exports.NO;
    } catch (t) {
        return $96e78a72aef15085$exports.ERROR;
    }
}
$9603535221c4e017$exports.canWriteCookie = $9603535221c4e017$var$canWriteCookie;


$3d8c7377a85fa527$exports.canWriteCookie = $9603535221c4e017$exports.canWriteCookie;
var $019da8f0475acef5$exports = {};
"use strict";
Object.defineProperty($019da8f0475acef5$exports, "__esModule", {
    value: true
});

function $019da8f0475acef5$var$getBrowserVendor() {
    try {
        return navigator.vendor || $96e78a72aef15085$exports.UNAVAILABLE;
    } catch (error) {
        return $96e78a72aef15085$exports.ERROR;
    }
}
$019da8f0475acef5$exports.getBrowserVendor = $019da8f0475acef5$var$getBrowserVendor;


$3d8c7377a85fa527$exports.getBrowserVendor = $019da8f0475acef5$exports.getBrowserVendor;
var $2aee7602ca42bd00$exports = {};
"use strict";
Object.defineProperty($2aee7602ca42bd00$exports, "__esModule", {
    value: true
});
function $2aee7602ca42bd00$var$getHardwareConcurrency() {
    try {
        var result = parseInt(navigator.hardwareConcurrency.toString(), 10);
        return isNaN(result) ? 1 : result;
    } catch (t) {
        return 1;
    }
}
$2aee7602ca42bd00$exports.getHardwareConcurrency = $2aee7602ca42bd00$var$getHardwareConcurrency;


$3d8c7377a85fa527$exports.getHardwareConcurrency = $2aee7602ca42bd00$exports.getHardwareConcurrency;
var $2acfbbd4af651a16$exports = {};
"use strict";
Object.defineProperty($2acfbbd4af651a16$exports, "__esModule", {
    value: true
});

function $2acfbbd4af651a16$var$getLanguage() {
    try {
        return navigator.language || $96e78a72aef15085$exports.UNAVAILABLE;
    } catch (error) {
        return $96e78a72aef15085$exports.ERROR;
    }
}
$2acfbbd4af651a16$exports.getLanguage = $2acfbbd4af651a16$var$getLanguage;


$3d8c7377a85fa527$exports.getLanguage = $2acfbbd4af651a16$exports.getLanguage;
var $e6e568cc867e7678$exports = {};
"use strict";
Object.defineProperty($e6e568cc867e7678$exports, "__esModule", {
    value: true
});

function $e6e568cc867e7678$var$getPlatform() {
    try {
        return navigator.platform || $96e78a72aef15085$exports.UNAVAILABLE;
    } catch (error) {
        return $96e78a72aef15085$exports.ERROR;
    }
}
$e6e568cc867e7678$exports.getPlatform = $e6e568cc867e7678$var$getPlatform;


$3d8c7377a85fa527$exports.getPlatform = $e6e568cc867e7678$exports.getPlatform;
var $dd71e8e2a1788002$exports = {};
"use strict";
Object.defineProperty($dd71e8e2a1788002$exports, "__esModule", {
    value: true
});

function $dd71e8e2a1788002$var$getPlugins() {
    try {
        var MSIE = "Microsoft Internet Explorer";
        var NETSCAPE = "Netscape";
        var isIE = navigator.appName === MSIE;
        var isNetscape = navigator.appName === NETSCAPE;
        var isTrident = /Trident/.test(navigator.userAgent);
        if (isIE || isNetscape && isTrident) return $96e78a72aef15085$exports.UNAVAILABLE;
        var navigatorPlugins = navigator.plugins;
        var s = "";
        for(var i = 0; i < navigatorPlugins.length; i++){
            var plugin = navigator.plugins[i];
            var name_1 = plugin.name;
            var fileName = plugin.filename;
            var pluginMimeTypes = plugin.length;
            for(var j = 0; j < pluginMimeTypes; j++){
                var o = plugin[j];
                if (o) s = s + name_1 + "," + fileName + "," + o.type + "|";
            }
        }
        return s;
    } catch (error) {
        return $96e78a72aef15085$exports.ERROR;
    }
}
$dd71e8e2a1788002$exports.getPlugins = $dd71e8e2a1788002$var$getPlugins;


$3d8c7377a85fa527$exports.getPlugins = $dd71e8e2a1788002$exports.getPlugins;
var $7297dc5435e34b8a$exports = {};
"use strict";
Object.defineProperty($7297dc5435e34b8a$exports, "__esModule", {
    value: true
});

function $7297dc5435e34b8a$var$getProductSub() {
    try {
        return navigator.productSub || $96e78a72aef15085$exports.UNAVAILABLE;
    } catch (error) {
        return $96e78a72aef15085$exports.ERROR;
    }
}
$7297dc5435e34b8a$exports.getProductSub = $7297dc5435e34b8a$var$getProductSub;


$3d8c7377a85fa527$exports.getProductSub = $7297dc5435e34b8a$exports.getProductSub;
var $b01884a4f4ec014e$exports = {};
"use strict";
Object.defineProperty($b01884a4f4ec014e$exports, "__esModule", {
    value: true
});

function $b01884a4f4ec014e$var$getTimeZone() {
    try {
        if (window.Intl && window.Intl.DateTimeFormat) return new window.Intl.DateTimeFormat().resolvedOptions().timeZone;
        return $96e78a72aef15085$exports.UNAVAILABLE;
    } catch (error) {
        return $96e78a72aef15085$exports.ERROR;
    }
}
$b01884a4f4ec014e$exports.getTimeZone = $b01884a4f4ec014e$var$getTimeZone;


$3d8c7377a85fa527$exports.getTimeZone = $b01884a4f4ec014e$exports.getTimeZone;
var $01488803c7ffc2e3$exports = {};
"use strict";
Object.defineProperty($01488803c7ffc2e3$exports, "__esModule", {
    value: true
});

function $01488803c7ffc2e3$var$getTimeZoneOffset() {
    try {
        return new Date().getTimezoneOffset() || $96e78a72aef15085$exports.UNAVAILABLE;
    } catch (error) {
        return $96e78a72aef15085$exports.ERROR;
    }
}
$01488803c7ffc2e3$exports.getTimeZoneOffset = $01488803c7ffc2e3$var$getTimeZoneOffset;


$3d8c7377a85fa527$exports.getTimeZoneOffset = $01488803c7ffc2e3$exports.getTimeZoneOffset;
var $c672d82b9e341cab$exports = {};
"use strict";
Object.defineProperty($c672d82b9e341cab$exports, "__esModule", {
    value: true
});

function $c672d82b9e341cab$var$getUserAgent() {
    try {
        return navigator.userAgent || $96e78a72aef15085$exports.UNAVAILABLE;
    } catch (d) {
        return $96e78a72aef15085$exports.ERROR;
    }
}
$c672d82b9e341cab$exports.getUserAgent = $c672d82b9e341cab$var$getUserAgent;


$3d8c7377a85fa527$exports.getUserAgent = $c672d82b9e341cab$exports.getUserAgent;
var $8d01ee7a76e3c9b6$exports = {};
"use strict";
Object.defineProperty($8d01ee7a76e3c9b6$exports, "__esModule", {
    value: true
});

function $8d01ee7a76e3c9b6$var$isIndexedDBAvailable() {
    try {
        return window.indexedDB ? $96e78a72aef15085$exports.YES : $96e78a72aef15085$exports.NO;
    } catch (e) {
        return $96e78a72aef15085$exports.ERROR;
    }
}
$8d01ee7a76e3c9b6$exports.isIndexedDBAvailable = $8d01ee7a76e3c9b6$var$isIndexedDBAvailable;


$3d8c7377a85fa527$exports.isIndexedDBAvailable = $8d01ee7a76e3c9b6$exports.isIndexedDBAvailable;
var $b8d0b1c831619e80$exports = {};
"use strict";
Object.defineProperty($b8d0b1c831619e80$exports, "__esModule", {
    value: true
});

function $b8d0b1c831619e80$var$isLocalStorageAvailable() {
    try {
        return window.localStorage ? $96e78a72aef15085$exports.YES : $96e78a72aef15085$exports.NO;
    } catch (e) {
        return $96e78a72aef15085$exports.ERROR;
    }
}
$b8d0b1c831619e80$exports.isLocalStorageAvailable = $b8d0b1c831619e80$var$isLocalStorageAvailable;


$3d8c7377a85fa527$exports.isLocalStorageAvailable = $b8d0b1c831619e80$exports.isLocalStorageAvailable;
var $486f3558e2350d8b$exports = {};
"use strict";
Object.defineProperty($486f3558e2350d8b$exports, "__esModule", {
    value: true
});

function $486f3558e2350d8b$var$isSessionStorageAvailable() {
    try {
        return window.sessionStorage ? $96e78a72aef15085$exports.YES : $96e78a72aef15085$exports.NO;
    } catch (e) {
        return $96e78a72aef15085$exports.ERROR;
    }
}
$486f3558e2350d8b$exports.isSessionStorageAvailable = $486f3558e2350d8b$var$isSessionStorageAvailable;


$3d8c7377a85fa527$exports.isSessionStorageAvailable = $486f3558e2350d8b$exports.isSessionStorageAvailable;
var $7e69c4765b7c492e$exports = {};
"use strict";
Object.defineProperty($7e69c4765b7c492e$exports, "__esModule", {
    value: true
});

function $7e69c4765b7c492e$var$isTestingBot() {
    try {
        var t = [
            "webdriver" in window,
            "_Selenium_IDE_Recorder" in window,
            "callSelenium" in window,
            "_selenium" in window,
            "__webdriver_script_fn" in document,
            "__driver_evaluate" in document,
            "__webdriver_evaluate" in document,
            "__selenium_evaluate" in document,
            "__fxdriver_evaluate" in document,
            "__driver_unwrapped" in document,
            "__webdriver_unwrapped" in document,
            "__selenium_unwrapped" in document,
            "__fxdriver_unwrapped" in document,
            "__webdriver_script_func" in document,
            null !== document.documentElement.getAttribute("selenium"),
            null !== document.documentElement.getAttribute("webdriver"),
            null !== document.documentElement.getAttribute("driver")
        ];
        return t.some(function(e) {
            return e === true;
        }) ? $96e78a72aef15085$exports.YES : $96e78a72aef15085$exports.NO;
    } catch (error) {
        return $96e78a72aef15085$exports.ERROR;
    }
}
$7e69c4765b7c492e$exports.isTestingBot = $7e69c4765b7c492e$var$isTestingBot;


$3d8c7377a85fa527$exports.isTestingBot = $7e69c4765b7c492e$exports.isTestingBot;
var $5a6afa0234012711$exports = {};
"use strict";
Object.defineProperty($5a6afa0234012711$exports, "__esModule", {
    value: true
});

function $5a6afa0234012711$var$isWebDriver() {
    try {
        return navigator.webdriver ? $96e78a72aef15085$exports.YES : $96e78a72aef15085$exports.NO;
    } catch (error) {
        return $96e78a72aef15085$exports.ERROR;
    }
}
$5a6afa0234012711$exports.isWebDriver = $5a6afa0234012711$var$isWebDriver;


$3d8c7377a85fa527$exports.isWebDriver = $5a6afa0234012711$exports.isWebDriver;


var $b2289a3a1290497e$exports = {};
"use strict";
Object.defineProperty($b2289a3a1290497e$exports, "__esModule", {
    value: true
});
var $f9ea33537480d7a8$exports = {};
"use strict";
Object.defineProperty($f9ea33537480d7a8$exports, "__esModule", {
    value: true
});

function $f9ea33537480d7a8$var$studyPrint() {
    try {
        var canvasElement = document.createElement("canvas");
        canvasElement.width = 240;
        canvasElement.height = 140;
        canvasElement.style.display = "inline";
        var canvasContext = canvasElement.getContext("2d");
        if (canvasContext) {
            canvasContext.rect(0, 0, 10, 10);
            canvasContext.rect(2, 2, 6, 6);
            canvasContext.isPointInPath(5, 5, "evenodd");
            canvasContext.textBaseline = "alphabetic";
            canvasContext.fillStyle = "#f60";
            canvasContext.fillRect(125, 1, 62, 20);
            canvasContext.fillStyle = "#069";
            canvasContext.font = "11pt no-real-font-123";
            canvasContext.fillText("Cwm fjordbank \uD83D\uDE03 gly", 2, 15);
            canvasContext.fillStyle = "rgba(102, 204, 0, 0.2)";
            canvasContext.font = "18pt Arial";
            canvasContext.fillText("Cwm fjordbank \uD83D\uDE03 gly", 4, 45);
            canvasContext.globalCompositeOperation = "multiply";
            canvasContext.fillStyle = "rgb(255,0,255)";
            canvasContext.beginPath();
            canvasContext.arc(50, 50, 50, 0, 2 * Math.PI, !0);
            canvasContext.closePath();
            canvasContext.fill();
            canvasContext.fillStyle = "rgb(0,255,255)";
            canvasContext.beginPath();
            canvasContext.arc(100, 50, 50, 0, 2 * Math.PI, !0);
            canvasContext.closePath();
            canvasContext.fill();
            canvasContext.fillStyle = "rgb(255,255,0)";
            canvasContext.beginPath();
            canvasContext.arc(75, 100, 50, 0, 2 * Math.PI, !0);
            canvasContext.closePath();
            canvasContext.fill();
            canvasContext.fillStyle = "rgb(255,0,255)";
            canvasContext.arc(75, 75, 75, 0, 2 * Math.PI, !0);
            canvasContext.arc(75, 75, 25, 0, 2 * Math.PI, !0);
            canvasContext.fill("evenodd");
            return canvasElement.toDataURL();
        }
        return $96e78a72aef15085$exports.UNAVAILABLE;
    } catch (error) {
        return $96e78a72aef15085$exports.ERROR;
    }
}
$f9ea33537480d7a8$exports.studyPrint = $f9ea33537480d7a8$var$studyPrint;


$b2289a3a1290497e$exports.studyPrint = $f9ea33537480d7a8$exports.studyPrint;



var $d58e2d37ce0b81a6$exports = {};
"use strict";
Object.defineProperty($d58e2d37ce0b81a6$exports, "__esModule", {
    value: true
});
var $351c551dac2f8c7e$exports = {};
"use strict";
Object.defineProperty($351c551dac2f8c7e$exports, "__esModule", {
    value: true
});

var $fdd4c4e3d2a2af74$exports = {};
"use strict";
Object.defineProperty($fdd4c4e3d2a2af74$exports, "__esModule", {
    value: true
});
$fdd4c4e3d2a2af74$exports.fontsToCheck = [
    "Adobe Garamond",
    "Adobe Hebrew",
    "Agency FB",
    "Airstream",
    "Andale Mono",
    "Aparajita",
    "Arial",
    "BN Manson Nights",
    "Baskerville",
    "BlackChancery",
    "Book Antiqua",
    "Bookman Old Style",
    "CG Times",
    "Calibri",
    "Cambria",
    "Cambria Math",
    "Century",
    "Century Gothic",
    "Century Schoolbook",
    "Chalkboard",
    "Comic Sans",
    "Comic Sans MS",
    "Consolas",
    "Cooper Black",
    "Corbel",
    "Courier",
    "Courier New",
    "Curlz MT",
    "DS Sans Serif",
    "Degrassi",
    "Didot",
    "Ebrima",
    "GOST Common",
    "Geneva",
    "Georgia",
    "Gulim",
    "Heiti TC",
    "Helvetica",
    "Helvetica Neue",
    "Hoefler Text",
    "Impact",
    "Kalinga",
    "Letter Gothic",
    "Lithos Pro",
    "Lucida Bright",
    "Lucida Calligraphy",
    "Lucida Console",
    "Lucida Fax",
    "Lucida Handwriting",
    "Lucida Sans",
    "MS Gothic",
    "MS Outlook",
    "MS PGothic",
    "MYRIAD",
    "Malgun Gothic",
    "Mangal",
    "MapInfo Miscellaneous",
    "Meiryo UI",
    "Monaco",
    "Monotype Corsiva",
    "NSimSun",
    "OSAKA",
    "Palatino",
    "Pickwick",
    "Playbill",
    "Pristina",
    "Segoe Print",
    "Segoe Script",
    "Segoe UI",
    "Shonar Bangla",
    "Snell Roundhand",
    "Styllo",
    "Tahoma",
    "Times",
    "Times New Roman",
    "Trebuchet MS",
    "Verdana",
    "Wingdings"
];


var $351c551dac2f8c7e$var$DetectFonts = function() {
    function DetectFonts() {
        var _this = this;
        this.baseFonts = [
            'monospace',
            'sans-serif',
            'serif'
        ];
        this.testString = 'mmmmmmmmmmlli';
        this.testSize = '72px';
        this.defaultWidth = {};
        this.defaultHeight = {};
        this.createSpan = function() {
            var s = document.createElement('span');
            s.style.position = 'absolute';
            s.style.left = '-9999px';
            s.style.fontSize = _this.testSize;
            s.style.fontStyle = 'normal';
            s.style.fontWeight = 'normal';
            s.style.letterSpacing = 'normal';
            s.style.lineBreak = 'auto';
            s.style.lineHeight = 'normal';
            s.style.textTransform = 'none';
            s.style.textAlign = 'left';
            s.style.textDecoration = 'none';
            s.style.textShadow = 'none';
            s.style.whiteSpace = 'normal';
            s.style.wordBreak = 'normal';
            s.style.wordSpacing = 'normal';
            s.innerHTML = _this.testString;
            return s;
        };
        this.createSpanWithFonts = function(fontToDetect, baseFont) {
            var s = _this.createSpan();
            s.style.fontFamily = "'" + fontToDetect + "'," + baseFont;
            return s;
        };
        this.initializeBaseFontsSpans = function() {
            var spans = [];
            for(var _i = 0, _a = _this.baseFonts; _i < _a.length; _i++){
                var font = _a[_i];
                var s = _this.createSpan();
                s.style.fontFamily = font;
                _this.baseFontsDiv.appendChild(s);
                spans.push(s);
            }
            return spans;
        };
        this.initializeFontsSpans = function() {
            var spans = {};
            for(var _i = 0, fontsToCheck_2 = $fdd4c4e3d2a2af74$exports.fontsToCheck; _i < fontsToCheck_2.length; _i++){
                var fontToDetect = fontsToCheck_2[_i];
                var fontSpans = [];
                for(var _a = 0, _b = _this.baseFonts; _a < _b.length; _a++){
                    var baseFont = _b[_a];
                    var s = _this.createSpanWithFonts(fontToDetect, baseFont);
                    _this.fontsDiv.appendChild(s);
                    fontSpans.push(s);
                }
                var key = fontToDetect;
                spans[key] = fontSpans;
            }
            return spans;
        };
        this.isFontAvailable = function(fontSpans) {
            var detected = false;
            for(var i = 0; i < _this.baseFonts.length; i++){
                var fontWidth = fontSpans[i].offsetWidth;
                var fontDefaultWidth = _this.defaultWidth[_this.baseFonts[i]];
                var fontHeight = fontSpans[i].offsetHeight;
                var fontDefaultHeight = _this.defaultHeight[_this.baseFonts[i]];
                detected = fontWidth !== fontDefaultWidth || fontHeight !== fontDefaultHeight;
                if (detected) return detected;
            }
            return detected;
        };
        this.bodyElement = document.getElementsByTagName('body')[0];
        this.baseFontsDiv = document.createElement('div');
        this.fontsDiv = document.createElement('div');
    }
    DetectFonts.prototype.detect = function() {
        var baseFontsSpans = this.initializeBaseFontsSpans();
        this.bodyElement.appendChild(this.baseFontsDiv);
        for(var index = 0; index < this.baseFonts.length; index++){
            this.defaultWidth[this.baseFonts[index]] = baseFontsSpans[index].offsetWidth;
            this.defaultHeight[this.baseFonts[index]] = baseFontsSpans[index].offsetHeight;
        }
        var fontsSpans = this.initializeFontsSpans();
        this.bodyElement.appendChild(this.fontsDiv);
        var available = [];
        for(var _i = 0, fontsToCheck_3 = $fdd4c4e3d2a2af74$exports.fontsToCheck; _i < fontsToCheck_3.length; _i++){
            var fontToCheck = fontsToCheck_3[_i];
            var result = 0;
            if (this.isFontAvailable(fontsSpans[fontToCheck])) result = 1;
            available.push(result);
        }
        this.bodyElement.removeChild(this.fontsDiv);
        this.bodyElement.removeChild(this.baseFontsDiv);
        return available.join("|");
    };
    DetectFonts.prototype.result = function() {
        try {
            return this.detect();
        } catch (error) {
            return $96e78a72aef15085$exports.ERROR;
        }
    };
    return DetectFonts;
}();
$351c551dac2f8c7e$exports.DetectFonts = $351c551dac2f8c7e$var$DetectFonts;


$d58e2d37ce0b81a6$exports.DetectFonts = $351c551dac2f8c7e$exports.DetectFonts;


var $f54acdfa91569540$exports = {};
"use strict";
Object.defineProperty($f54acdfa91569540$exports, "__esModule", {
    value: true
});
var $52b3787dc019b4f3$exports = {};
"use strict";
Object.defineProperty($52b3787dc019b4f3$exports, "__esModule", {
    value: true
});

var $ef24a61a0a1de451$exports = {};
"use strict";
Object.defineProperty($ef24a61a0a1de451$exports, "__esModule", {
    value: true
});

function $ef24a61a0a1de451$var$getContext() {
    if (window.WebGLRenderingContext) {
        var canvasElement = document.createElement("canvas");
        var webGLcontexts = [
            "webgl",
            "experimental-webgl",
            "moz-webgl",
            "webkit-3d"
        ];
        for(var _i = 0, webGLcontexts_1 = webGLcontexts; _i < webGLcontexts_1.length; _i++){
            var contextName = webGLcontexts_1[_i];
            try {
                var canvasRenderingContext = canvasElement.getContext(contextName);
                if (canvasRenderingContext && canvasRenderingContext instanceof WebGLRenderingContext && typeof canvasRenderingContext.getParameter === "function") return {
                    name: contextName,
                    context: canvasRenderingContext
                };
            } catch (p) {
                return $96e78a72aef15085$exports.ERROR;
            }
        }
    }
    return $96e78a72aef15085$exports.UNAVAILABLE;
}
$ef24a61a0a1de451$exports.getContext = $ef24a61a0a1de451$var$getContext;


function $52b3787dc019b4f3$var$getWebGL() {
    try {
        var gl = $ef24a61a0a1de451$exports.getContext();
        if (typeof gl === "undefined") return $96e78a72aef15085$exports.UNAVAILABLE;
        if (gl && typeof gl === "object" && gl.context) {
            var glContext = gl.context;
            var rendererInfo = glContext.getExtension("WEBGL_debug_renderer_info");
            if (rendererInfo !== null) return [
                glContext.getParameter(rendererInfo.UNMASKED_RENDERER_WEBGL),
                glContext.getParameter(glContext.MAX_COMBINED_TEXTURE_IMAGE_UNITS),
                glContext.getParameter(glContext.MAX_CUBE_MAP_TEXTURE_SIZE)
            ].join("|");
            return $96e78a72aef15085$exports.UNAVAILABLE;
        }
    } catch (p) {
        return $96e78a72aef15085$exports.ERROR;
    }
}
$52b3787dc019b4f3$exports.getWebGL = $52b3787dc019b4f3$var$getWebGL;


$f54acdfa91569540$exports.getWebGL = $52b3787dc019b4f3$exports.getWebGL;



var $458d8d5b9f9f3033$exports = {};
"use strict";
Object.defineProperty($458d8d5b9f9f3033$exports, "__esModule", {
    value: true
});
var $458d8d5b9f9f3033$var$x64Add = function(m, n) {
    m = [
        m[0] >>> 16,
        m[0] & 0xffff,
        m[1] >>> 16,
        m[1] & 0xffff
    ];
    n = [
        n[0] >>> 16,
        n[0] & 0xffff,
        n[1] >>> 16,
        n[1] & 0xffff
    ];
    var o = [
        0,
        0,
        0,
        0
    ];
    o[3] += m[3] + n[3];
    o[2] += o[3] >>> 16;
    o[3] &= 0xffff;
    o[2] += m[2] + n[2];
    o[1] += o[2] >>> 16;
    o[2] &= 0xffff;
    o[1] += m[1] + n[1];
    o[0] += o[1] >>> 16;
    o[1] &= 0xffff;
    o[0] += m[0] + n[0];
    o[0] &= 0xffff;
    return [
        o[0] << 16 | o[1],
        o[2] << 16 | o[3]
    ];
};
var $458d8d5b9f9f3033$var$x64Multiply = function(m, n) {
    m = [
        m[0] >>> 16,
        m[0] & 0xffff,
        m[1] >>> 16,
        m[1] & 0xffff
    ];
    n = [
        n[0] >>> 16,
        n[0] & 0xffff,
        n[1] >>> 16,
        n[1] & 0xffff
    ];
    var o = [
        0,
        0,
        0,
        0
    ];
    o[3] += m[3] * n[3];
    o[2] += o[3] >>> 16;
    o[3] &= 0xffff;
    o[2] += m[2] * n[3];
    o[1] += o[2] >>> 16;
    o[2] &= 0xffff;
    o[2] += m[3] * n[2];
    o[1] += o[2] >>> 16;
    o[2] &= 0xffff;
    o[1] += m[1] * n[3];
    o[0] += o[1] >>> 16;
    o[1] &= 0xffff;
    o[1] += m[2] * n[2];
    o[0] += o[1] >>> 16;
    o[1] &= 0xffff;
    o[1] += m[3] * n[1];
    o[0] += o[1] >>> 16;
    o[1] &= 0xffff;
    o[0] += m[0] * n[3] + m[1] * n[2] + m[2] * n[1] + m[3] * n[0];
    o[0] &= 0xffff;
    return [
        o[0] << 16 | o[1],
        o[2] << 16 | o[3]
    ];
};
var $458d8d5b9f9f3033$var$x64Rotl = function(m, n) {
    n %= 64;
    if (n === 32) return [
        m[1],
        m[0]
    ];
    else if (n < 32) return [
        m[0] << n | m[1] >>> 32 - n,
        m[1] << n | m[0] >>> 32 - n
    ];
    else {
        n -= 32;
        return [
            m[1] << n | m[0] >>> 32 - n,
            m[0] << n | m[1] >>> 32 - n
        ];
    }
};
var $458d8d5b9f9f3033$var$x64LeftShift = function(m, n) {
    n %= 64;
    if (n === 0) return m;
    else if (n < 32) return [
        m[0] << n | m[1] >>> 32 - n,
        m[1] << n
    ];
    else return [
        m[1] << n - 32,
        0
    ];
};
var $458d8d5b9f9f3033$var$x64Xor = function(m, n) {
    return [
        m[0] ^ n[0],
        m[1] ^ n[1]
    ];
};
var $458d8d5b9f9f3033$var$x64Fmix = function(h) {
    h = $458d8d5b9f9f3033$var$x64Xor(h, [
        0,
        h[0] >>> 1
    ]);
    h = $458d8d5b9f9f3033$var$x64Multiply(h, [
        0xff51afd7,
        0xed558ccd
    ]);
    h = $458d8d5b9f9f3033$var$x64Xor(h, [
        0,
        h[0] >>> 1
    ]);
    h = $458d8d5b9f9f3033$var$x64Multiply(h, [
        0xc4ceb9fe,
        0x1a85ec53
    ]);
    h = $458d8d5b9f9f3033$var$x64Xor(h, [
        0,
        h[0] >>> 1
    ]);
    return h;
};
$458d8d5b9f9f3033$exports.x64hash128 = function(key, seed) {
    key = key || '';
    seed = seed || 0;
    var remainder = key.length % 16;
    var bytes = key.length - remainder;
    var h1 = [
        0,
        seed
    ];
    var h2 = [
        0,
        seed
    ];
    var k1 = [
        0,
        0
    ];
    var k2 = [
        0,
        0
    ];
    var c1 = [
        0x87c37b91,
        0x114253d5
    ];
    var c2 = [
        0x4cf5ad43,
        0x2745937f
    ];
    for(var i = 0; i < bytes; i = i + 16){
        k1 = [
            key.charCodeAt(i + 4) & 0xff | (key.charCodeAt(i + 5) & 0xff) << 8 | (key.charCodeAt(i + 6) & 0xff) << 16 | (key.charCodeAt(i + 7) & 0xff) << 24,
            key.charCodeAt(i) & 0xff | (key.charCodeAt(i + 1) & 0xff) << 8 | (key.charCodeAt(i + 2) & 0xff) << 16 | (key.charCodeAt(i + 3) & 0xff) << 24
        ];
        k2 = [
            key.charCodeAt(i + 12) & 0xff | (key.charCodeAt(i + 13) & 0xff) << 8 | (key.charCodeAt(i + 14) & 0xff) << 16 | (key.charCodeAt(i + 15) & 0xff) << 24,
            key.charCodeAt(i + 8) & 0xff | (key.charCodeAt(i + 9) & 0xff) << 8 | (key.charCodeAt(i + 10) & 0xff) << 16 | (key.charCodeAt(i + 11) & 0xff) << 24
        ];
        k1 = $458d8d5b9f9f3033$var$x64Multiply(k1, c1);
        k1 = $458d8d5b9f9f3033$var$x64Rotl(k1, 31);
        k1 = $458d8d5b9f9f3033$var$x64Multiply(k1, c2);
        h1 = $458d8d5b9f9f3033$var$x64Xor(h1, k1);
        h1 = $458d8d5b9f9f3033$var$x64Rotl(h1, 27);
        h1 = $458d8d5b9f9f3033$var$x64Add(h1, h2);
        h1 = $458d8d5b9f9f3033$var$x64Add($458d8d5b9f9f3033$var$x64Multiply(h1, [
            0,
            5
        ]), [
            0,
            0x52dce729
        ]);
        k2 = $458d8d5b9f9f3033$var$x64Multiply(k2, c2);
        k2 = $458d8d5b9f9f3033$var$x64Rotl(k2, 33);
        k2 = $458d8d5b9f9f3033$var$x64Multiply(k2, c1);
        h2 = $458d8d5b9f9f3033$var$x64Xor(h2, k2);
        h2 = $458d8d5b9f9f3033$var$x64Rotl(h2, 31);
        h2 = $458d8d5b9f9f3033$var$x64Add(h2, h1);
        h2 = $458d8d5b9f9f3033$var$x64Add($458d8d5b9f9f3033$var$x64Multiply(h2, [
            0,
            5
        ]), [
            0,
            0x38495ab5
        ]);
    }
    k1 = [
        0,
        0
    ];
    k2 = [
        0,
        0
    ];
    var iX = bytes;
    switch(remainder){
        case 15:
            k2 = $458d8d5b9f9f3033$var$x64Xor(k2, $458d8d5b9f9f3033$var$x64LeftShift([
                0,
                key.charCodeAt(iX + 14)
            ], 48));
        case 14:
            k2 = $458d8d5b9f9f3033$var$x64Xor(k2, $458d8d5b9f9f3033$var$x64LeftShift([
                0,
                key.charCodeAt(iX + 13)
            ], 40));
        case 13:
            k2 = $458d8d5b9f9f3033$var$x64Xor(k2, $458d8d5b9f9f3033$var$x64LeftShift([
                0,
                key.charCodeAt(iX + 12)
            ], 32));
        case 12:
            k2 = $458d8d5b9f9f3033$var$x64Xor(k2, $458d8d5b9f9f3033$var$x64LeftShift([
                0,
                key.charCodeAt(iX + 11)
            ], 24));
        case 11:
            k2 = $458d8d5b9f9f3033$var$x64Xor(k2, $458d8d5b9f9f3033$var$x64LeftShift([
                0,
                key.charCodeAt(iX + 10)
            ], 16));
        case 10:
            k2 = $458d8d5b9f9f3033$var$x64Xor(k2, $458d8d5b9f9f3033$var$x64LeftShift([
                0,
                key.charCodeAt(iX + 9)
            ], 8));
        case 9:
            k2 = $458d8d5b9f9f3033$var$x64Xor(k2, [
                0,
                key.charCodeAt(iX + 8)
            ]);
            k2 = $458d8d5b9f9f3033$var$x64Multiply(k2, c2);
            k2 = $458d8d5b9f9f3033$var$x64Rotl(k2, 33);
            k2 = $458d8d5b9f9f3033$var$x64Multiply(k2, c1);
            h2 = $458d8d5b9f9f3033$var$x64Xor(h2, k2);
        case 8:
            k1 = $458d8d5b9f9f3033$var$x64Xor(k1, $458d8d5b9f9f3033$var$x64LeftShift([
                0,
                key.charCodeAt(iX + 7)
            ], 56));
        case 7:
            k1 = $458d8d5b9f9f3033$var$x64Xor(k1, $458d8d5b9f9f3033$var$x64LeftShift([
                0,
                key.charCodeAt(iX + 6)
            ], 48));
        case 6:
            k1 = $458d8d5b9f9f3033$var$x64Xor(k1, $458d8d5b9f9f3033$var$x64LeftShift([
                0,
                key.charCodeAt(iX + 5)
            ], 40));
        case 5:
            k1 = $458d8d5b9f9f3033$var$x64Xor(k1, $458d8d5b9f9f3033$var$x64LeftShift([
                0,
                key.charCodeAt(iX + 4)
            ], 32));
        case 4:
            k1 = $458d8d5b9f9f3033$var$x64Xor(k1, $458d8d5b9f9f3033$var$x64LeftShift([
                0,
                key.charCodeAt(iX + 3)
            ], 24));
        case 3:
            k1 = $458d8d5b9f9f3033$var$x64Xor(k1, $458d8d5b9f9f3033$var$x64LeftShift([
                0,
                key.charCodeAt(iX + 2)
            ], 16));
        case 2:
            k1 = $458d8d5b9f9f3033$var$x64Xor(k1, $458d8d5b9f9f3033$var$x64LeftShift([
                0,
                key.charCodeAt(iX + 1)
            ], 8));
        case 1:
            k1 = $458d8d5b9f9f3033$var$x64Xor(k1, [
                0,
                key.charCodeAt(iX)
            ]);
            k1 = $458d8d5b9f9f3033$var$x64Multiply(k1, c1);
            k1 = $458d8d5b9f9f3033$var$x64Rotl(k1, 31);
            k1 = $458d8d5b9f9f3033$var$x64Multiply(k1, c2);
            h1 = $458d8d5b9f9f3033$var$x64Xor(h1, k1);
    }
    h1 = $458d8d5b9f9f3033$var$x64Xor(h1, [
        0,
        key.length
    ]);
    h2 = $458d8d5b9f9f3033$var$x64Xor(h2, [
        0,
        key.length
    ]);
    h1 = $458d8d5b9f9f3033$var$x64Add(h1, h2);
    h2 = $458d8d5b9f9f3033$var$x64Add(h2, h1);
    h1 = $458d8d5b9f9f3033$var$x64Fmix(h1);
    h2 = $458d8d5b9f9f3033$var$x64Fmix(h2);
    h1 = $458d8d5b9f9f3033$var$x64Add(h1, h2);
    h2 = $458d8d5b9f9f3033$var$x64Add(h2, h1);
    return ('00000000' + (h1[0] >>> 0).toString(16)).slice(-8) + ('00000000' + (h1[1] >>> 0).toString(16)).slice(-8) + ('00000000' + (h2[0] >>> 0).toString(16)).slice(-8) + ('00000000' + (h2[1] >>> 0).toString(16)).slice(-8);
};


var $80509bb111a91081$var$UIDGenerator = function() {
    function UIDGenerator() {}
    UIDGenerator.getDetails = function() {
        try {
            return {
                browser: {
                    browserDefaultEvalLength: $3d8c7377a85fa527$exports.browserDefaultEvalLength(),
                    canWriteCookie: $3d8c7377a85fa527$exports.canWriteCookie(),
                    getBrowserVendor: $3d8c7377a85fa527$exports.getBrowserVendor(),
                    getHardwareConcurrency: $3d8c7377a85fa527$exports.getHardwareConcurrency(),
                    getLanguage: $3d8c7377a85fa527$exports.getLanguage(),
                    getPlatform: $3d8c7377a85fa527$exports.getPlatform(),
                    getPlugins: $3d8c7377a85fa527$exports.getPlugins(),
                    getProductSub: $3d8c7377a85fa527$exports.getProductSub(),
                    getTimeZone: $3d8c7377a85fa527$exports.getTimeZone(),
                    getTimeZoneOffset: $3d8c7377a85fa527$exports.getTimeZoneOffset(),
                    getUserAgent: $3d8c7377a85fa527$exports.getUserAgent(),
                    isIndexedDBAvailable: $3d8c7377a85fa527$exports.isIndexedDBAvailable(),
                    isLocalStorageAvailable: $3d8c7377a85fa527$exports.isLocalStorageAvailable(),
                    isSessionStorageAvailable: $3d8c7377a85fa527$exports.isSessionStorageAvailable(),
                    isTestingBot: $3d8c7377a85fa527$exports.isTestingBot(),
                    isWebDriver: $3d8c7377a85fa527$exports.isWebDriver()
                },
                canvas: {
                    studyPrint: $b2289a3a1290497e$exports.studyPrint()
                },
                font: {
                    jsFonts: new $d58e2d37ce0b81a6$exports.DetectFonts().detect()
                },
                webGL: {
                    getWebGL: $f54acdfa91569540$exports.getWebGL()
                }
            };
        } catch (err) {
            return $96e78a72aef15085$exports.ERROR;
        }
    };
    UIDGenerator.getValue = function(cachedUids) {
        try {
            var values = [
                $3d8c7377a85fa527$exports.browserDefaultEvalLength(),
                $3d8c7377a85fa527$exports.canWriteCookie(),
                $3d8c7377a85fa527$exports.getBrowserVendor(),
                $3d8c7377a85fa527$exports.getHardwareConcurrency(),
                $3d8c7377a85fa527$exports.getLanguage(),
                $3d8c7377a85fa527$exports.getPlatform(),
                $3d8c7377a85fa527$exports.getPlugins(),
                $3d8c7377a85fa527$exports.getProductSub(),
                $3d8c7377a85fa527$exports.getTimeZone(),
                $3d8c7377a85fa527$exports.getTimeZoneOffset(),
                $3d8c7377a85fa527$exports.getUserAgent(),
                $3d8c7377a85fa527$exports.isIndexedDBAvailable(),
                $3d8c7377a85fa527$exports.isLocalStorageAvailable(),
                $3d8c7377a85fa527$exports.isSessionStorageAvailable(),
                $3d8c7377a85fa527$exports.isTestingBot(),
                $3d8c7377a85fa527$exports.isWebDriver(),
                $b2289a3a1290497e$exports.studyPrint(),
                new $d58e2d37ce0b81a6$exports.DetectFonts().result(),
                $f54acdfa91569540$exports.getWebGL()
            ];
            var value = $458d8d5b9f9f3033$exports.x64hash128(values.join("|"), 64);
            var state = void 0;
            if (!cachedUids.length) state = $a576733921801e90$exports.XIDState.NEW;
            else if (cachedUids[0].value === value) state = $a576733921801e90$exports.XIDState.EXISTING;
            else state = $a576733921801e90$exports.XIDState.CHANGED;
            return state === $a576733921801e90$exports.XIDState.EXISTING ? cachedUids : $l2Z7B.__spreadArrays([
                {
                    type: $a576733921801e90$exports.XIDItemType.UID,
                    createdAt: new Date().toISOString(),
                    state: state,
                    value: value
                }
            ], cachedUids);
        } catch (err) {
            return [
                {
                    type: $a576733921801e90$exports.XIDItemType.UID,
                    state: $a576733921801e90$exports.XIDState.ERROR
                }
            ];
        }
    };
    return UIDGenerator;
}();
$80509bb111a91081$exports.UIDGenerator = $80509bb111a91081$var$UIDGenerator;


var $5b77bf485bccaea8$exports = {};
"use strict";
Object.defineProperty($5b77bf485bccaea8$exports, "__esModule", {
    value: true
});

var $l2Z7B = parcelRequire("l2Z7B");

var $5b77bf485bccaea8$var$promise_polyfill_1 = $l2Z7B.__importDefault((parcelRequire("7UOcZ")));



var $5b77bf485bccaea8$var$TEST_HOST = '';
var $5b77bf485bccaea8$var$DEV_HOST = 'xxid.dev.atl-paas.net';
var $5b77bf485bccaea8$var$STG_HOST = 'xxid.staging.atl-paas.net';
var $5b77bf485bccaea8$var$PROD_FALLBACK_HOST = 'xxid.atl-paas.net';
var $5b77bf485bccaea8$var$PROD_HOST = 'xxid.atlassian.com';
var $5b77bf485bccaea8$var$defaultTimeout = 3000;
var $5b77bf485bccaea8$var$XCGenerator = function() {
    function XCGenerator() {}
    XCGenerator.getValue = function(env, timeout, isStorageEnabled) {
        if (timeout === void 0) timeout = $5b77bf485bccaea8$var$defaultTimeout;
        if (isStorageEnabled === void 0) isStorageEnabled = true;
        var xxidHost = XCGenerator.getHost(env);
        var xxidOrigin = xxidHost ? "https://" + xxidHost : '';
        var iframeUrl = xxidOrigin ? xxidOrigin + "?t=" + new Date().getTime() : '';
        var frame = XCGenerator.addFrame(iframeUrl);
        return new $5b77bf485bccaea8$var$promise_polyfill_1.default(function(resolve) {
            var listen = function(event) {
                if (event.data.type === "xcReady" && event.origin === xxidOrigin) {
                    var xc = XCGenerator.messageToXc(event);
                    if (isStorageEnabled) xc = $43113123be356ccf$exports.Storage.updateXc(env, xc);
                    resolve(xc);
                    XCGenerator.removeFrame(frame, listen);
                }
            };
            window.addEventListener('message', listen);
            setTimeout(function() {
                resolve({
                    type: $a576733921801e90$exports.XIDItemType.XC,
                    state: $a576733921801e90$exports.XIDState.TIMEOUT
                });
                XCGenerator.removeFrame(frame, listen);
            }, timeout);
        });
    };
    XCGenerator.messageToXc = function(event) {
        var _a = event.data, xc = _a.xc, ts = _a.ts, state = _a.state;
        if (xc && !!Date.parse(ts) && state) return {
            type: $a576733921801e90$exports.XIDItemType.XC,
            value: xc,
            createdAt: ts,
            state: state
        };
        else return {
            type: $a576733921801e90$exports.XIDItemType.XC,
            state: state ? state : $a576733921801e90$exports.XIDState.MALFORMED
        };
    };
    XCGenerator.addFrame = function(url) {
        var frame = document.createElement('iframe');
        frame.id = "xc-" + new Date().getTime();
        frame.src = url;
        frame.style.display = 'none';
        frame.style.position = 'fixed';
        document.body.appendChild(frame);
        return frame;
    };
    XCGenerator.removeFrame = function(frame, listen) {
        if (document.body.contains(frame)) {
            document.body.removeChild(frame);
            window.removeEventListener('message', listen);
        }
    };
    XCGenerator.getHost = function(env) {
        switch(env){
            case $a576733921801e90$exports.Environment.STAGE:
                return $5b77bf485bccaea8$var$STG_HOST;
            case $a576733921801e90$exports.Environment.PROD:
                return $e226362dd6674ff5$exports.isAtlassianComDomain() ? $5b77bf485bccaea8$var$PROD_FALLBACK_HOST : $5b77bf485bccaea8$var$PROD_HOST;
            case $a576733921801e90$exports.Environment.TEST:
                return $5b77bf485bccaea8$var$TEST_HOST;
            case $a576733921801e90$exports.Environment.LOCAL:
            case $a576733921801e90$exports.Environment.DEV:
            default:
                return $5b77bf485bccaea8$var$DEV_HOST;
        }
    };
    return XCGenerator;
}();
$5b77bf485bccaea8$exports.XCGenerator = $5b77bf485bccaea8$var$XCGenerator;


var $15f92bf84d5e00ff$exports = {};
"use strict";
Object.defineProperty($15f92bf84d5e00ff$exports, "__esModule", {
    value: true
});

var $4qBHc = parcelRequire("4qBHc");
var $15f92bf84d5e00ff$var$maptoNewXidCandidate = function(item, promiseStartTime) {
    var state = item.state, type = item.type, value = item.value, createdAt = item.createdAt;
    if (item && state && type && value && createdAt && (state === $4qBHc.XIDState.NEW || state === $4qBHc.XIDState.CHANGED)) return {
        state: state,
        type: type,
        value: value,
        createdAt: createdAt,
        timeTaken: $15f92bf84d5e00ff$var$getCurrentTime() - promiseStartTime
    };
    return null;
};
var $15f92bf84d5e00ff$var$maptoExistingXid = function(item) {
    var state = item.state, type = item.type, value = item.value, createdAt = item.createdAt;
    if (item && state && type && value && createdAt && state === $4qBHc.XIDState.EXISTING) return {
        state: state,
        type: type,
        value: value,
        createdAt: createdAt
    };
    return null;
};
var $15f92bf84d5e00ff$var$mapToAmbiguousXid = function(item) {
    var state = item.state, type = item.type;
    if (item && state && type) switch(state){
        case $4qBHc.XIDState.TIMEOUT:
        case $4qBHc.XIDState.ERROR:
        case $4qBHc.XIDState.UNAVAILABLE:
        case $4qBHc.XIDState.UNKNOWN:
        case $4qBHc.XIDState.MALFORMED:
            return {
                type: type,
                state: state
            };
    }
    return null;
};
var $15f92bf84d5e00ff$var$mapToMalformedXid = function(item) {
    var type = item.type;
    if (item && type) return {
        type: type,
        state: $4qBHc.XIDState.MALFORMED
    };
    return null;
};
function $15f92bf84d5e00ff$var$promiseWithTimer(fn) {
    var addTimeTaken = function(item) {
        var fallbackXid = {
            type: $4qBHc.XIDItemType.UID,
            state: $4qBHc.XIDState.MALFORMED
        };
        return $15f92bf84d5e00ff$var$maptoNewXidCandidate(item, start) || $15f92bf84d5e00ff$var$maptoExistingXid(item) || $15f92bf84d5e00ff$var$mapToAmbiguousXid(item) || $15f92bf84d5e00ff$var$mapToMalformedXid(item) || fallbackXid;
    };
    var onPromiseDone = function(data) {
        return data.map(function(item) {
            return addTimeTaken(item);
        });
    };
    var start = $15f92bf84d5e00ff$var$getCurrentTime();
    return fn().then(onPromiseDone);
}
$15f92bf84d5e00ff$exports.promiseWithTimer = $15f92bf84d5e00ff$var$promiseWithTimer;
var $15f92bf84d5e00ff$var$getCurrentTime = function() {
    if (performance && performance.now) return performance.now();
    return new Date().getTime();
};



var $4qBHc = parcelRequire("4qBHc");
$5cdc7272fdf5cc1c$exports.defaultTimeout = 5000;
var $5cdc7272fdf5cc1c$var$delayUidGenerate = 1e3;
var $5cdc7272fdf5cc1c$var$nonProdMaxTimeout = 30000;
var $5cdc7272fdf5cc1c$var$prodMaxTimeout = 10000;
var $5cdc7272fdf5cc1c$var$minTimeout = 2000;
var $5cdc7272fdf5cc1c$var$XID = function() {
    function XID(env, timeout) {
        if (env === void 0) env = $4qBHc.Environment.LOCAL;
        if (timeout === void 0) timeout = $5cdc7272fdf5cc1c$exports.defaultTimeout;
        this.storageEnabled = true;
        this.timeoutUid = {
            type: $4qBHc.XIDItemType.UID,
            state: $4qBHc.XIDState.TIMEOUT
        };
        if (!env) throw new Error('Missing env configuration');
        this.env = env;
        var maxTimeout = this.env === $4qBHc.Environment.PROD ? $5cdc7272fdf5cc1c$var$prodMaxTimeout : $5cdc7272fdf5cc1c$var$nonProdMaxTimeout;
        if (timeout >= $5cdc7272fdf5cc1c$var$minTimeout && timeout <= maxTimeout) this.timeout = timeout;
        else {
            if (this.env !== $4qBHc.Environment.PROD) console.log("timeout configuration must be in the range of [" + $5cdc7272fdf5cc1c$var$minTimeout + ", " + maxTimeout + "] seconds");
            this.timeout = $5cdc7272fdf5cc1c$exports.defaultTimeout;
        }
    }
    XID.prototype.getTimeoutPromise = function(timeoutXid) {
        var _this = this;
        return new $5cdc7272fdf5cc1c$var$promise_polyfill_1.default(function(resolve) {
            setTimeout(function() {
                resolve([
                    timeoutXid
                ]);
            }, (_this.timeout - $5cdc7272fdf5cc1c$var$delayUidGenerate) / 2);
        });
    };
    XID.prototype.getXcPromiseAndSave = function() {
        var _this = this;
        return new $5cdc7272fdf5cc1c$var$promise_polyfill_1.default(function(resolve) {
            _this.getXc().then(function(xc) {
                if (_this.storageEnabled) $43113123be356ccf$exports.Storage.saveXid([
                    xc
                ]);
                resolve([
                    xc
                ]);
            });
        });
    };
    XID.prototype.getUidPromiseAndSave = function() {
        var _this = this;
        return new $5cdc7272fdf5cc1c$var$promise_polyfill_1.default(function(resolve) {
            var handleUid = function() {
                var cachedUids = [];
                if (_this.storageEnabled) cachedUids = $43113123be356ccf$exports.Storage.getUids();
                var uids = $80509bb111a91081$exports.UIDGenerator.getValue(cachedUids);
                if (_this.storageEnabled) {
                    $43113123be356ccf$exports.Storage.saveUids(uids);
                    $43113123be356ccf$exports.Storage.saveXid(uids);
                }
                resolve(uids);
            };
            var requestIdleCallback = window.requestIdleCallback;
            requestIdleCallback ? requestIdleCallback(handleUid) : setTimeout(handleUid, $5cdc7272fdf5cc1c$var$delayUidGenerate);
        });
    };
    XID.prototype.getXidPromiseInXcUidOnly = function() {
        var _this = this;
        return this.getXcPromiseAndSave().then(function(xc) {
            if (xc && xc.length > 0 && xc[0].createdAt && xc[0].value) return xc;
            else return _this.getTimeoutPromise(_this.timeoutUid), _this.getUidPromiseAndSave().then(function(uid) {
                return $l2Z7B.__spreadArrays(uid, xc);
            });
        });
    };
    XID.prototype.getXidCallbackForPromise = function(mode, storageEnabled) {
        if (mode === void 0) mode = $4qBHc.XIDGenerateMode.CACHE_XC_UID;
        if (storageEnabled === void 0) storageEnabled = true;
        var transformedXids;
        var transform = function(xids) {
            if (transformedXids) return transformedXids;
            transformedXids = xids.map(function(xid) {
                if (xid.state === $4qBHc.XIDState.NEW || xid.state === $4qBHc.XIDState.CHANGED) return {
                    state: $4qBHc.XIDState.EXISTING,
                    type: xid.type,
                    createdAt: xid.createdAt,
                    value: xid.value
                };
                return xid;
            });
            return xids;
        };
        return this.getXidPromise(mode, storageEnabled).then(function(xid) {
            return function() {
                return transform(xid);
            };
        });
    };
    XID.prototype.getXidPromise = function(mode, storageEnabled) {
        var _this = this;
        if (mode === void 0) mode = $4qBHc.XIDGenerateMode.CACHE_XC_UID;
        if (storageEnabled === void 0) storageEnabled = true;
        this.storageEnabled = storageEnabled;
        var cachedXidValue = mode === $4qBHc.XIDGenerateMode.CACHE_ONLY || mode === $4qBHc.XIDGenerateMode.CACHE_XC_UID ? $43113123be356ccf$exports.Storage.getCachedXID() : [];
        switch(mode){
            case $4qBHc.XIDGenerateMode.XC_ONLY:
                return $15f92bf84d5e00ff$exports.promiseWithTimer(function() {
                    return _this.getXcPromiseAndSave();
                });
            case $4qBHc.XIDGenerateMode.UID_ONLY:
                return $15f92bf84d5e00ff$exports.promiseWithTimer(function() {
                    return $5cdc7272fdf5cc1c$var$promise_polyfill_1.default.race([
                        _this.getTimeoutPromise(_this.timeoutUid),
                        _this.getUidPromiseAndSave()
                    ]);
                });
            case $4qBHc.XIDGenerateMode.XC_UID:
                return $15f92bf84d5e00ff$exports.promiseWithTimer(function() {
                    return _this.getXidPromiseInXcUidOnly();
                });
            case $4qBHc.XIDGenerateMode.CACHE_ONLY:
                return $5cdc7272fdf5cc1c$var$promise_polyfill_1.default.resolve(cachedXidValue);
            case $4qBHc.XIDGenerateMode.CACHE_XC_UID:
            default:
                return cachedXidValue.length > 0 ? $5cdc7272fdf5cc1c$var$promise_polyfill_1.default.resolve(cachedXidValue) : $15f92bf84d5e00ff$exports.promiseWithTimer(function() {
                    return _this.getXidPromiseInXcUidOnly();
                });
        }
    };
    XID.prototype.getXc = function() {
        return $5b77bf485bccaea8$exports.XCGenerator.getValue(this.env, (this.timeout - $5cdc7272fdf5cc1c$var$delayUidGenerate) / 2, this.storageEnabled);
    };
    XID.prototype.getUidDetails = function() {
        return $80509bb111a91081$exports.UIDGenerator.getDetails();
    };
    return XID;
}();
$5cdc7272fdf5cc1c$exports.XID = $5cdc7272fdf5cc1c$var$XID;


$a576733921801e90$exports.XID = $5cdc7272fdf5cc1c$exports.XID;


var $000760bdf95e0c2b$exports = {};
"use strict";
Object.defineProperty($000760bdf95e0c2b$exports, "__esModule", {
    value: true
});
$000760bdf95e0c2b$exports.ENVIRONMENT = $000760bdf95e0c2b$exports.CONSENT_KEY = void 0;
var $000760bdf95e0c2b$var$ENVIRONMENT = $000760bdf95e0c2b$exports.ENVIRONMENT = /*#__PURE__*/ function(ENVIRONMENT) {
    ENVIRONMENT["LOCAL"] = "local";
    ENVIRONMENT["DEV"] = "development";
    ENVIRONMENT["STAGING"] = "staging";
    ENVIRONMENT["PROD"] = "production";
    return ENVIRONMENT;
}({});
var $000760bdf95e0c2b$var$CONSENT_KEY = $000760bdf95e0c2b$exports.CONSENT_KEY = {
    COMMUNITY: 'communityTermsOfService',
    PRIVACY: 'privacyPolicy'
};


function $9b8dc532c3c3f9ae$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $9b8dc532c3c3f9ae$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $9b8dc532c3c3f9ae$var$_typeof(o);
}
function $9b8dc532c3c3f9ae$var$_defineProperty(e, r, t) {
    return (r = $9b8dc532c3c3f9ae$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $9b8dc532c3c3f9ae$var$_toPropertyKey(t) {
    var i = $9b8dc532c3c3f9ae$var$_toPrimitive(t, "string");
    return "symbol" == $9b8dc532c3c3f9ae$var$_typeof(i) ? i : i + "";
}
function $9b8dc532c3c3f9ae$var$_toPrimitive(t, r) {
    if ("object" != $9b8dc532c3c3f9ae$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $9b8dc532c3c3f9ae$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $9b8dc532c3c3f9ae$var$ENV_TO_ANALYTICS_ENV_TYPE = $9b8dc532c3c3f9ae$var$_defineProperty($9b8dc532c3c3f9ae$var$_defineProperty($9b8dc532c3c3f9ae$var$_defineProperty($9b8dc532c3c3f9ae$var$_defineProperty({}, $000760bdf95e0c2b$exports.ENVIRONMENT.LOCAL, $iVpQc.envType.LOCAL), $000760bdf95e0c2b$exports.ENVIRONMENT.DEV, $iVpQc.envType.DEV), $000760bdf95e0c2b$exports.ENVIRONMENT.STAGING, $iVpQc.envType.STAGING), $000760bdf95e0c2b$exports.ENVIRONMENT.PROD, $iVpQc.envType.PROD);
var $9b8dc532c3c3f9ae$var$ENV_TO_XID_ENV = $9b8dc532c3c3f9ae$var$_defineProperty($9b8dc532c3c3f9ae$var$_defineProperty($9b8dc532c3c3f9ae$var$_defineProperty($9b8dc532c3c3f9ae$var$_defineProperty({}, $000760bdf95e0c2b$exports.ENVIRONMENT.LOCAL, $a576733921801e90$exports.Environment.LOCAL), $000760bdf95e0c2b$exports.ENVIRONMENT.DEV, $a576733921801e90$exports.Environment.DEV), $000760bdf95e0c2b$exports.ENVIRONMENT.STAGING, $a576733921801e90$exports.Environment.STAGE), $000760bdf95e0c2b$exports.ENVIRONMENT.PROD, $a576733921801e90$exports.Environment.PROD);
var $9b8dc532c3c3f9ae$var$ENV_TO_ANALYTICS_WRITE_KEY = $9b8dc532c3c3f9ae$var$_defineProperty($9b8dc532c3c3f9ae$var$_defineProperty($9b8dc532c3c3f9ae$var$_defineProperty($9b8dc532c3c3f9ae$var$_defineProperty({}, $000760bdf95e0c2b$exports.ENVIRONMENT.LOCAL, 'SBLZG3ZYcSBcUMeLKLalrtyW8w1Caold'), $000760bdf95e0c2b$exports.ENVIRONMENT.DEV, 'SBLZG3ZYcSBcUMeLKLalrtyW8w1Caold'), $000760bdf95e0c2b$exports.ENVIRONMENT.STAGING, '4J6H7c3XTcpm1dbenkOILSyOachvf9It'), $000760bdf95e0c2b$exports.ENVIRONMENT.PROD, 'TNnhg0QuQfHEpBTzp27kJXNWZoMqSvkw');
var $9b8dc532c3c3f9ae$var$getEnvironment = $9b8dc532c3c3f9ae$exports.getEnvironment = function getEnvironment(env) {
    var _process$env$CLIENT_L, _ref;
    if (env) return env;
    var processEnv = (_process$env$CLIENT_L = undefined, _process$env$CLIENT_L !== void 0) ? _process$env$CLIENT_L : "production";
    return (_ref = processEnv) !== null && _ref !== void 0 ? _ref : $000760bdf95e0c2b$exports.ENVIRONMENT.LOCAL;
};
var $9b8dc532c3c3f9ae$var$getGASv3Environment = $9b8dc532c3c3f9ae$exports.getGASv3Environment = function getGASv3Environment(environment) {
    return $9b8dc532c3c3f9ae$var$ENV_TO_ANALYTICS_ENV_TYPE[environment !== null && environment !== void 0 ? environment : $9b8dc532c3c3f9ae$var$getEnvironment()];
};
var $9b8dc532c3c3f9ae$var$getXidEnvironment = $9b8dc532c3c3f9ae$exports.getXidEnvironment = function getXidEnvironment(environment) {
    return $9b8dc532c3c3f9ae$var$ENV_TO_XID_ENV[environment !== null && environment !== void 0 ? environment : $9b8dc532c3c3f9ae$var$getEnvironment()];
};
var $9b8dc532c3c3f9ae$var$getAnalyticsWriteKey = $9b8dc532c3c3f9ae$exports.getAnalyticsWriteKey = function getAnalyticsWriteKey(environment) {
    return $9b8dc532c3c3f9ae$var$ENV_TO_ANALYTICS_WRITE_KEY[environment !== null && environment !== void 0 ? environment : $9b8dc532c3c3f9ae$var$getEnvironment()];
};
var $9b8dc532c3c3f9ae$var$shouldUseStargate = $9b8dc532c3c3f9ae$exports.shouldUseStargate = function shouldUseStargate(environment) {
    switch(environment !== null && environment !== void 0 ? environment : $9b8dc532c3c3f9ae$var$getEnvironment()){
        case $000760bdf95e0c2b$exports.ENVIRONMENT.PROD:
        case $000760bdf95e0c2b$exports.ENVIRONMENT.STAGING:
            return true;
        case $000760bdf95e0c2b$exports.ENVIRONMENT.DEV:
        default:
            return false;
    }
};
var $9b8dc532c3c3f9ae$var$getUppApiPathFromEnvironment = $9b8dc532c3c3f9ae$exports.getUppApiPathFromEnvironment = function getUppApiPathFromEnvironment(env) {
    var environment = $9b8dc532c3c3f9ae$var$getEnvironment(env);
    switch(environment){
        case $000760bdf95e0c2b$exports.ENVIRONMENT.DEV:
            return '/gateway/api/graphql?serviceOverride=upp_service_api=https://upp-service-api.ap-southeast-2.dev.atl-paas.net/api/graphql';
        default:
            return '/gateway/api/graphql';
    }
};
var $9b8dc532c3c3f9ae$var$ENVIRONMENT_CONFIGS = $9b8dc532c3c3f9ae$exports.ENVIRONMENT_CONFIGS = $9b8dc532c3c3f9ae$var$_defineProperty($9b8dc532c3c3f9ae$var$_defineProperty($9b8dc532c3c3f9ae$var$_defineProperty($9b8dc532c3c3f9ae$var$_defineProperty({}, $000760bdf95e0c2b$exports.ENVIRONMENT.LOCAL, {
    HOME_BASE_URL: 'https://community.dev.atlassian.com',
    KHOROS_ENDPOINT_PATH: 'atlassiandev3',
    IDENTITY_BASE_URL: 'https://id.stg.internal.atlassian.com'
}), $000760bdf95e0c2b$exports.ENVIRONMENT.DEV, {
    HOME_BASE_URL: 'https://community.dev.atlassian.com',
    KHOROS_ENDPOINT_PATH: 'atlassiandev3',
    IDENTITY_BASE_URL: 'https://id.stg.internal.atlassian.com'
}), $000760bdf95e0c2b$exports.ENVIRONMENT.STAGING, {
    HOME_BASE_URL: 'https://community.stg.atlassian.com',
    KHOROS_ENDPOINT_PATH: 'atlassiandev',
    IDENTITY_BASE_URL: 'https://id.stg.internal.atlassian.com'
}), $000760bdf95e0c2b$exports.ENVIRONMENT.PROD, {
    HOME_BASE_URL: 'https://community.atlassian.com',
    KHOROS_ENDPOINT_PATH: 'atlassian',
    IDENTITY_BASE_URL: 'https://id.atlassian.com'
});


var $5af8fa5f3021d79b$exports = {};
"use strict";
Object.defineProperty($5af8fa5f3021d79b$exports, "__esModule", {
    value: true
});
$5af8fa5f3021d79b$exports.hasConsentMutationError = $5af8fa5f3021d79b$var$hasConsentMutationError;
$5af8fa5f3021d79b$exports.isUnifiedAccountQueryError = $5af8fa5f3021d79b$var$isUnifiedAccountQueryError;
$5af8fa5f3021d79b$exports.isUnifiedQueryError = $5af8fa5f3021d79b$var$isUnifiedQueryError;
function $5af8fa5f3021d79b$var$isUnifiedQueryError(response) {
    return 'identifier' in response;
}
function $5af8fa5f3021d79b$var$hasConsentMutationError(response) {
    return response.errors != null && Array.isArray(response.errors) && response.errors.length > 0;
}
function $5af8fa5f3021d79b$var$isUnifiedAccountQueryError(response) {
    return 'identifier' in response;
}


function $9274af858143a4bd$var$_regeneratorRuntime() {
    "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ 
    $9274af858143a4bd$var$_regeneratorRuntime = function _regeneratorRuntime() {
        return e;
    };
    var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function(t, e, r) {
        t[e] = r.value;
    }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag";
    function define(t, e, r) {
        return Object.defineProperty(t, e, {
            value: r,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }), t[e];
    }
    try {
        define({}, "");
    } catch (t) {
        define = function define(t, e, r) {
            return t[e] = r;
        };
    }
    function wrap(t, e, r, n) {
        var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []);
        return o(a, "_invoke", {
            value: makeInvokeMethod(t, r, c)
        }), a;
    }
    function tryCatch(t, e, r) {
        try {
            return {
                type: "normal",
                arg: t.call(e, r)
            };
        } catch (t) {
            return {
                type: "throw",
                arg: t
            };
        }
    }
    e.wrap = wrap;
    var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {};
    function Generator() {}
    function GeneratorFunction() {}
    function GeneratorFunctionPrototype() {}
    var p = {};
    define(p, a, function() {
        return this;
    });
    var d = Object.getPrototypeOf, v = d && d(d(values([])));
    v && v !== r && n.call(v, a) && (p = v);
    var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p);
    function defineIteratorMethods(t) {
        [
            "next",
            "throw",
            "return"
        ].forEach(function(e) {
            define(t, e, function(t) {
                return this._invoke(e, t);
            });
        });
    }
    function AsyncIterator(t, e) {
        function invoke(r, o, i, a) {
            var c = tryCatch(t[r], t, o);
            if ("throw" !== c.type) {
                var u = c.arg, h = u.value;
                return h && "object" == $9274af858143a4bd$var$_typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function(t) {
                    invoke("next", t, i, a);
                }, function(t) {
                    invoke("throw", t, i, a);
                }) : e.resolve(h).then(function(t) {
                    u.value = t, i(u);
                }, function(t) {
                    return invoke("throw", t, i, a);
                });
            }
            a(c.arg);
        }
        var r;
        o(this, "_invoke", {
            value: function value(t, n) {
                function callInvokeWithMethodAndArg() {
                    return new e(function(e, r) {
                        invoke(t, n, e, r);
                    });
                }
                return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
            }
        });
    }
    function makeInvokeMethod(e, r, n) {
        var o = h;
        return function(i, a) {
            if (o === f) throw Error("Generator is already running");
            if (o === s) {
                if ("throw" === i) throw a;
                return {
                    value: t,
                    done: !0
                };
            }
            for(n.method = i, n.arg = a;;){
                var c = n.delegate;
                if (c) {
                    var u = maybeInvokeDelegate(c, n);
                    if (u) {
                        if (u === y) continue;
                        return u;
                    }
                }
                if ("next" === n.method) n.sent = n._sent = n.arg;
                else if ("throw" === n.method) {
                    if (o === h) throw o = s, n.arg;
                    n.dispatchException(n.arg);
                } else "return" === n.method && n.abrupt("return", n.arg);
                o = f;
                var p = tryCatch(e, r, n);
                if ("normal" === p.type) {
                    if (o = n.done ? s : l, p.arg === y) continue;
                    return {
                        value: p.arg,
                        done: n.done
                    };
                }
                "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg);
            }
        };
    }
    function maybeInvokeDelegate(e, r) {
        var n = r.method, o = e.iterator[n];
        if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y;
        var i = tryCatch(o, e.iterator, r.arg);
        if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y;
        var a = i.arg;
        return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y);
    }
    function pushTryEntry(t) {
        var e = {
            tryLoc: t[0]
        };
        1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e);
    }
    function resetTryEntry(t) {
        var e = t.completion || {};
        e.type = "normal", delete e.arg, t.completion = e;
    }
    function Context(t) {
        this.tryEntries = [
            {
                tryLoc: "root"
            }
        ], t.forEach(pushTryEntry, this), this.reset(!0);
    }
    function values(e) {
        if (e || "" === e) {
            var r = e[a];
            if (r) return r.call(e);
            if ("function" == typeof e.next) return e;
            if (!isNaN(e.length)) {
                var o = -1, i = function next() {
                    for(; ++o < e.length;)if (n.call(e, o)) return next.value = e[o], next.done = !1, next;
                    return next.value = t, next.done = !0, next;
                };
                return i.next = i;
            }
        }
        throw new TypeError($9274af858143a4bd$var$_typeof(e) + " is not iterable");
    }
    return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", {
        value: GeneratorFunctionPrototype,
        configurable: !0
    }), o(GeneratorFunctionPrototype, "constructor", {
        value: GeneratorFunction,
        configurable: !0
    }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function(t) {
        var e = "function" == typeof t && t.constructor;
        return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name));
    }, e.mark = function(t) {
        return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t;
    }, e.awrap = function(t) {
        return {
            __await: t
        };
    }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function() {
        return this;
    }), e.AsyncIterator = AsyncIterator, e.async = function(t, r, n, o, i) {
        void 0 === i && (i = Promise);
        var a = new AsyncIterator(wrap(t, r, n, o), i);
        return e.isGeneratorFunction(r) ? a : a.next().then(function(t) {
            return t.done ? t.value : a.next();
        });
    }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function() {
        return this;
    }), define(g, "toString", function() {
        return "[object Generator]";
    }), e.keys = function(t) {
        var e = Object(t), r = [];
        for(var n in e)r.push(n);
        return r.reverse(), function next() {
            for(; r.length;){
                var t = r.pop();
                if (t in e) return next.value = t, next.done = !1, next;
            }
            return next.done = !0, next;
        };
    }, e.values = values, Context.prototype = {
        constructor: Context,
        reset: function reset(e) {
            if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for(var r in this)"t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t);
        },
        stop: function stop() {
            this.done = !0;
            var t = this.tryEntries[0].completion;
            if ("throw" === t.type) throw t.arg;
            return this.rval;
        },
        dispatchException: function dispatchException(e) {
            if (this.done) throw e;
            var r = this;
            function handle(n, o) {
                return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o;
            }
            for(var o = this.tryEntries.length - 1; o >= 0; --o){
                var i = this.tryEntries[o], a = i.completion;
                if ("root" === i.tryLoc) return handle("end");
                if (i.tryLoc <= this.prev) {
                    var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc");
                    if (c && u) {
                        if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
                        if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
                    } else if (c) {
                        if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
                    } else {
                        if (!u) throw Error("try statement without catch or finally");
                        if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
                    }
                }
            }
        },
        abrupt: function abrupt(t, e) {
            for(var r = this.tryEntries.length - 1; r >= 0; --r){
                var o = this.tryEntries[r];
                if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
                    var i = o;
                    break;
                }
            }
            i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
            var a = i ? i.completion : {};
            return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a);
        },
        complete: function complete(t, e) {
            if ("throw" === t.type) throw t.arg;
            return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y;
        },
        finish: function finish(t) {
            for(var e = this.tryEntries.length - 1; e >= 0; --e){
                var r = this.tryEntries[e];
                if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y;
            }
        },
        "catch": function _catch(t) {
            for(var e = this.tryEntries.length - 1; e >= 0; --e){
                var r = this.tryEntries[e];
                if (r.tryLoc === t) {
                    var n = r.completion;
                    if ("throw" === n.type) {
                        var o = n.arg;
                        resetTryEntry(r);
                    }
                    return o;
                }
            }
            throw Error("illegal catch attempt");
        },
        delegateYield: function delegateYield(e, r, n) {
            return this.delegate = {
                iterator: values(e),
                resultName: r,
                nextLoc: n
            }, "next" === this.method && (this.arg = t), y;
        }
    }, e;
}
function $9274af858143a4bd$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $9274af858143a4bd$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $9274af858143a4bd$var$ownKeys(Object(t), !0).forEach(function(r) {
            $9274af858143a4bd$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $9274af858143a4bd$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $9274af858143a4bd$var$_defineProperty(e, r, t) {
    return (r = $9274af858143a4bd$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $9274af858143a4bd$var$_toPropertyKey(t) {
    var i = $9274af858143a4bd$var$_toPrimitive(t, "string");
    return "symbol" == $9274af858143a4bd$var$_typeof(i) ? i : i + "";
}
function $9274af858143a4bd$var$_toPrimitive(t, r) {
    if ("object" != $9274af858143a4bd$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $9274af858143a4bd$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $9274af858143a4bd$var$asyncGeneratorStep(n, t, e, r, o, a, c) {
    try {
        var i = n[a](c), u = i.value;
    } catch (n) {
        return void e(n);
    }
    i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function $9274af858143a4bd$var$_asyncToGenerator(n) {
    return function() {
        var t = this, e = arguments;
        return new Promise(function(r, o) {
            var a = n.apply(t, e);
            function _next(n) {
                $9274af858143a4bd$var$asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
            }
            function _throw(n) {
                $9274af858143a4bd$var$asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
            }
            _next(void 0);
        });
    };
}
var $9274af858143a4bd$var$userConsentStatuses = $9274af858143a4bd$exports.userConsentStatuses = /*#__PURE__*/ function() {
    var _ref = $9274af858143a4bd$var$_asyncToGenerator(/*#__PURE__*/ $9274af858143a4bd$var$_regeneratorRuntime().mark(function _callee(aaid) {
        var baseUrl, Origin, env, apiPath, rawConsentResponse, consentResponse, _args = arguments;
        return $9274af858143a4bd$var$_regeneratorRuntime().wrap(function _callee$(_context) {
            while(true)switch(_context.prev = _context.next){
                case 0:
                    baseUrl = _args.length > 1 && _args[1] !== undefined ? _args[1] : '';
                    Origin = _args.length > 2 ? _args[2] : undefined;
                    env = _args.length > 3 ? _args[3] : undefined;
                    apiPath = (0, $9b8dc532c3c3f9ae$exports.getUppApiPathFromEnvironment)(env);
                    _context.next = 6;
                    return fetch("".concat(baseUrl).concat(apiPath), {
                        method: 'POST',
                        headers: $9274af858143a4bd$var$_objectSpread({
                            'Content-Type': 'application/json'
                        }, Origin ? {
                            Origin: Origin
                        } : {}),
                        body: JSON.stringify({
                            query: (0, $6601efa3d6ce5781$exports.getUserIsConsentedQuery)(aaid),
                            operationName: 'USER_CONSENTED_QUERY'
                        })
                    });
                case 6:
                    rawConsentResponse = _context.sent;
                    _context.next = 9;
                    return rawConsentResponse.json();
                case 9:
                    consentResponse = _context.sent;
                    return _context.abrupt("return", consentResponse);
                case 11:
                case "end":
                    return _context.stop();
            }
        }, _callee);
    }));
    return function userConsentStatuses(_x) {
        return _ref.apply(this, arguments);
    };
}();
var $9274af858143a4bd$var$isUserConsented = $9274af858143a4bd$exports.isUserConsented = /*#__PURE__*/ function() {
    var _ref2 = $9274af858143a4bd$var$_asyncToGenerator(/*#__PURE__*/ $9274af858143a4bd$var$_regeneratorRuntime().mark(function _callee2(consentKeys, aaid) {
        var baseUrl, Origin, _consentStatuses$data, consentStatuses, consentObj, _args2 = arguments;
        return $9274af858143a4bd$var$_regeneratorRuntime().wrap(function _callee2$(_context2) {
            while(true)switch(_context2.prev = _context2.next){
                case 0:
                    baseUrl = _args2.length > 2 && _args2[2] !== undefined ? _args2[2] : '';
                    Origin = _args2.length > 3 ? _args2[3] : undefined;
                    _context2.prev = 2;
                    _context2.next = 5;
                    return $9274af858143a4bd$var$userConsentStatuses(aaid, baseUrl, Origin);
                case 5:
                    consentStatuses = _context2.sent;
                    if (!(0, $5af8fa5f3021d79b$exports.isUnifiedQueryError)(consentStatuses.data.unified.consent.getConsent)) {
                        _context2.next = 8;
                        break;
                    }
                    return _context2.abrupt("return", false);
                case 8:
                    consentObj = consentStatuses === null || consentStatuses === void 0 || (_consentStatuses$data = consentStatuses.data) === null || _consentStatuses$data === void 0 || (_consentStatuses$data = _consentStatuses$data.unified) === null || _consentStatuses$data === void 0 || (_consentStatuses$data = _consentStatuses$data.consent) === null || _consentStatuses$data === void 0 || (_consentStatuses$data = _consentStatuses$data.getConsent) === null || _consentStatuses$data === void 0 ? void 0 : _consentStatuses$data.consentObj;
                    return _context2.abrupt("return", consentKeys.every(function(key) {
                        var consentStatus = consentObj === null || consentObj === void 0 ? void 0 : consentObj.find(function(consent) {
                            return consent.consentKey === key;
                        });
                        if ((consentStatus === null || consentStatus === void 0 ? void 0 : consentStatus.consentStatus) === 'true') return true;
                    }));
                case 12:
                    _context2.prev = 12;
                    _context2.t0 = _context2["catch"](2);
                    console.error(_context2.t0);
                    return _context2.abrupt("return", false);
                case 16:
                case "end":
                    return _context2.stop();
            }
        }, _callee2, null, [
            [
                2,
                12
            ]
        ]);
    }));
    return function isUserConsented(_x2, _x3) {
        return _ref2.apply(this, arguments);
    };
}();
// Set consent on UPP
var $9274af858143a4bd$var$setUserConsent = $9274af858143a4bd$exports.setUserConsent = /*#__PURE__*/ function() {
    var _ref3 = $9274af858143a4bd$var$_asyncToGenerator(/*#__PURE__*/ $9274af858143a4bd$var$_regeneratorRuntime().mark(function _callee3(consentKeys, aaid, env) {
        var baseUrl, cookie, Origin, apiPath, consentPromises, consentResponses, consentValues, _args3 = arguments;
        return $9274af858143a4bd$var$_regeneratorRuntime().wrap(function _callee3$(_context3) {
            while(true)switch(_context3.prev = _context3.next){
                case 0:
                    baseUrl = _args3.length > 3 && _args3[3] !== undefined ? _args3[3] : '';
                    cookie = _args3.length > 4 ? _args3[4] : undefined;
                    Origin = _args3.length > 5 ? _args3[5] : undefined;
                    _context3.prev = 3;
                    apiPath = (0, $9b8dc532c3c3f9ae$exports.getUppApiPathFromEnvironment)(env);
                    consentPromises = [];
                    consentKeys.forEach(function(key) {
                        var consentPromise = fetch("".concat(baseUrl).concat(apiPath), {
                            method: 'POST',
                            credentials: 'include',
                            headers: $9274af858143a4bd$var$_objectSpread($9274af858143a4bd$var$_objectSpread({}, Origin ? {
                                Origin: Origin
                            } : {}), {}, {
                                'Content-Type': 'application/json'
                            }, cookie ? {
                                cookie: cookie
                            } : {}),
                            body: JSON.stringify({
                                query: (0, $6eda9e6c03494bd2$exports.setUserIsConsentedMutation)(aaid, key),
                                operationName: 'SET_USER_CONSENTED_MUTATION'
                            })
                        }).then(function(response) {
                            return response.json();
                        });
                        consentPromises.push(consentPromise);
                    });
                    _context3.next = 9;
                    return Promise.all(consentPromises);
                case 9:
                    consentResponses = _context3.sent;
                    consentValues = consentResponses.map(function(response) {
                        return response.data.unified.consent.setConsent;
                    });
                    consentValues.forEach(function(values) {
                        if ((0, $5af8fa5f3021d79b$exports.hasConsentMutationError)(values)) {
                            if (values.errors && values.errors.length > 0) throw new Error("Error setting consent: ".concat(values.errors[0].message));
                        }
                    });
                    return _context3.abrupt("return", consentValues.every(function(value) {
                        return value.success;
                    }));
                case 15:
                    _context3.prev = 15;
                    _context3.t0 = _context3["catch"](3);
                    console.error('Error setting consent on UPP: ', _context3.t0);
                    return _context3.abrupt("return", false);
                case 19:
                case "end":
                    return _context3.stop();
            }
        }, _callee3, null, [
            [
                3,
                15
            ]
        ]);
    }));
    return function setUserConsent(_x4, _x5, _x6) {
        return _ref3.apply(this, arguments);
    };
}();





/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::db26fca19e3969bcba2e77bc6fe6eb89>>
 * @codegenCommand yarn build tokens
 */ var $d295851e89428aa9$var$tokens = {
    'color.text': '--ds-text',
    'color.text.accent.lime': '--ds-text-accent-lime',
    'color.text.accent.lime.bolder': '--ds-text-accent-lime-bolder',
    'color.text.accent.red': '--ds-text-accent-red',
    'color.text.accent.red.bolder': '--ds-text-accent-red-bolder',
    'color.text.accent.orange': '--ds-text-accent-orange',
    'color.text.accent.orange.bolder': '--ds-text-accent-orange-bolder',
    'color.text.accent.yellow': '--ds-text-accent-yellow',
    'color.text.accent.yellow.bolder': '--ds-text-accent-yellow-bolder',
    'color.text.accent.green': '--ds-text-accent-green',
    'color.text.accent.green.bolder': '--ds-text-accent-green-bolder',
    'color.text.accent.teal': '--ds-text-accent-teal',
    'color.text.accent.teal.bolder': '--ds-text-accent-teal-bolder',
    'color.text.accent.blue': '--ds-text-accent-blue',
    'color.text.accent.blue.bolder': '--ds-text-accent-blue-bolder',
    'color.text.accent.purple': '--ds-text-accent-purple',
    'color.text.accent.purple.bolder': '--ds-text-accent-purple-bolder',
    'color.text.accent.magenta': '--ds-text-accent-magenta',
    'color.text.accent.magenta.bolder': '--ds-text-accent-magenta-bolder',
    'color.text.accent.gray': '--ds-text-accent-gray',
    'color.text.accent.gray.bolder': '--ds-text-accent-gray-bolder',
    'color.text.disabled': '--ds-text-disabled',
    'color.text.inverse': '--ds-text-inverse',
    'color.text.selected': '--ds-text-selected',
    'color.text.brand': '--ds-text-brand',
    'color.text.danger': '--ds-text-danger',
    'color.text.warning': '--ds-text-warning',
    'color.text.warning.inverse': '--ds-text-warning-inverse',
    'color.text.success': '--ds-text-success',
    'color.text.discovery': '--ds-text-discovery',
    'color.text.information': '--ds-text-information',
    'color.text.subtlest': '--ds-text-subtlest',
    'color.text.subtle': '--ds-text-subtle',
    'color.link': '--ds-link',
    'color.link.pressed': '--ds-link-pressed',
    'color.link.visited': '--ds-link-visited',
    'color.link.visited.pressed': '--ds-link-visited-pressed',
    'color.icon': '--ds-icon',
    'color.icon.accent.lime': '--ds-icon-accent-lime',
    'color.icon.accent.red': '--ds-icon-accent-red',
    'color.icon.accent.orange': '--ds-icon-accent-orange',
    'color.icon.accent.yellow': '--ds-icon-accent-yellow',
    'color.icon.accent.green': '--ds-icon-accent-green',
    'color.icon.accent.teal': '--ds-icon-accent-teal',
    'color.icon.accent.blue': '--ds-icon-accent-blue',
    'color.icon.accent.purple': '--ds-icon-accent-purple',
    'color.icon.accent.magenta': '--ds-icon-accent-magenta',
    'color.icon.accent.gray': '--ds-icon-accent-gray',
    'color.icon.disabled': '--ds-icon-disabled',
    'color.icon.inverse': '--ds-icon-inverse',
    'color.icon.selected': '--ds-icon-selected',
    'color.icon.brand': '--ds-icon-brand',
    'color.icon.danger': '--ds-icon-danger',
    'color.icon.warning': '--ds-icon-warning',
    'color.icon.warning.inverse': '--ds-icon-warning-inverse',
    'color.icon.success': '--ds-icon-success',
    'color.icon.discovery': '--ds-icon-discovery',
    'color.icon.information': '--ds-icon-information',
    'color.icon.subtlest': '--ds-icon-subtlest',
    'color.icon.subtle': '--ds-icon-subtle',
    'color.border': '--ds-border',
    'color.border.accent.lime': '--ds-border-accent-lime',
    'color.border.accent.red': '--ds-border-accent-red',
    'color.border.accent.orange': '--ds-border-accent-orange',
    'color.border.accent.yellow': '--ds-border-accent-yellow',
    'color.border.accent.green': '--ds-border-accent-green',
    'color.border.accent.teal': '--ds-border-accent-teal',
    'color.border.accent.blue': '--ds-border-accent-blue',
    'color.border.accent.purple': '--ds-border-accent-purple',
    'color.border.accent.magenta': '--ds-border-accent-magenta',
    'color.border.accent.gray': '--ds-border-accent-gray',
    'color.border.disabled': '--ds-border-disabled',
    'color.border.focused': '--ds-border-focused',
    'color.border.input': '--ds-border-input',
    'color.border.inverse': '--ds-border-inverse',
    'color.border.selected': '--ds-border-selected',
    'color.border.brand': '--ds-border-brand',
    'color.border.danger': '--ds-border-danger',
    'color.border.warning': '--ds-border-warning',
    'color.border.success': '--ds-border-success',
    'color.border.discovery': '--ds-border-discovery',
    'color.border.information': '--ds-border-information',
    'color.border.bold': '--ds-border-bold',
    'color.background.accent.lime.subtlest': '--ds-background-accent-lime-subtlest',
    'color.background.accent.lime.subtlest.hovered': '--ds-background-accent-lime-subtlest-hovered',
    'color.background.accent.lime.subtlest.pressed': '--ds-background-accent-lime-subtlest-pressed',
    'color.background.accent.lime.subtler': '--ds-background-accent-lime-subtler',
    'color.background.accent.lime.subtler.hovered': '--ds-background-accent-lime-subtler-hovered',
    'color.background.accent.lime.subtler.pressed': '--ds-background-accent-lime-subtler-pressed',
    'color.background.accent.lime.subtle': '--ds-background-accent-lime-subtle',
    'color.background.accent.lime.subtle.hovered': '--ds-background-accent-lime-subtle-hovered',
    'color.background.accent.lime.subtle.pressed': '--ds-background-accent-lime-subtle-pressed',
    'color.background.accent.lime.bolder': '--ds-background-accent-lime-bolder',
    'color.background.accent.lime.bolder.hovered': '--ds-background-accent-lime-bolder-hovered',
    'color.background.accent.lime.bolder.pressed': '--ds-background-accent-lime-bolder-pressed',
    'color.background.accent.red.subtlest': '--ds-background-accent-red-subtlest',
    'color.background.accent.red.subtlest.hovered': '--ds-background-accent-red-subtlest-hovered',
    'color.background.accent.red.subtlest.pressed': '--ds-background-accent-red-subtlest-pressed',
    'color.background.accent.red.subtler': '--ds-background-accent-red-subtler',
    'color.background.accent.red.subtler.hovered': '--ds-background-accent-red-subtler-hovered',
    'color.background.accent.red.subtler.pressed': '--ds-background-accent-red-subtler-pressed',
    'color.background.accent.red.subtle': '--ds-background-accent-red-subtle',
    'color.background.accent.red.subtle.hovered': '--ds-background-accent-red-subtle-hovered',
    'color.background.accent.red.subtle.pressed': '--ds-background-accent-red-subtle-pressed',
    'color.background.accent.red.bolder': '--ds-background-accent-red-bolder',
    'color.background.accent.red.bolder.hovered': '--ds-background-accent-red-bolder-hovered',
    'color.background.accent.red.bolder.pressed': '--ds-background-accent-red-bolder-pressed',
    'color.background.accent.orange.subtlest': '--ds-background-accent-orange-subtlest',
    'color.background.accent.orange.subtlest.hovered': '--ds-background-accent-orange-subtlest-hovered',
    'color.background.accent.orange.subtlest.pressed': '--ds-background-accent-orange-subtlest-pressed',
    'color.background.accent.orange.subtler': '--ds-background-accent-orange-subtler',
    'color.background.accent.orange.subtler.hovered': '--ds-background-accent-orange-subtler-hovered',
    'color.background.accent.orange.subtler.pressed': '--ds-background-accent-orange-subtler-pressed',
    'color.background.accent.orange.subtle': '--ds-background-accent-orange-subtle',
    'color.background.accent.orange.subtle.hovered': '--ds-background-accent-orange-subtle-hovered',
    'color.background.accent.orange.subtle.pressed': '--ds-background-accent-orange-subtle-pressed',
    'color.background.accent.orange.bolder': '--ds-background-accent-orange-bolder',
    'color.background.accent.orange.bolder.hovered': '--ds-background-accent-orange-bolder-hovered',
    'color.background.accent.orange.bolder.pressed': '--ds-background-accent-orange-bolder-pressed',
    'color.background.accent.yellow.subtlest': '--ds-background-accent-yellow-subtlest',
    'color.background.accent.yellow.subtlest.hovered': '--ds-background-accent-yellow-subtlest-hovered',
    'color.background.accent.yellow.subtlest.pressed': '--ds-background-accent-yellow-subtlest-pressed',
    'color.background.accent.yellow.subtler': '--ds-background-accent-yellow-subtler',
    'color.background.accent.yellow.subtler.hovered': '--ds-background-accent-yellow-subtler-hovered',
    'color.background.accent.yellow.subtler.pressed': '--ds-background-accent-yellow-subtler-pressed',
    'color.background.accent.yellow.subtle': '--ds-background-accent-yellow-subtle',
    'color.background.accent.yellow.subtle.hovered': '--ds-background-accent-yellow-subtle-hovered',
    'color.background.accent.yellow.subtle.pressed': '--ds-background-accent-yellow-subtle-pressed',
    'color.background.accent.yellow.bolder': '--ds-background-accent-yellow-bolder',
    'color.background.accent.yellow.bolder.hovered': '--ds-background-accent-yellow-bolder-hovered',
    'color.background.accent.yellow.bolder.pressed': '--ds-background-accent-yellow-bolder-pressed',
    'color.background.accent.green.subtlest': '--ds-background-accent-green-subtlest',
    'color.background.accent.green.subtlest.hovered': '--ds-background-accent-green-subtlest-hovered',
    'color.background.accent.green.subtlest.pressed': '--ds-background-accent-green-subtlest-pressed',
    'color.background.accent.green.subtler': '--ds-background-accent-green-subtler',
    'color.background.accent.green.subtler.hovered': '--ds-background-accent-green-subtler-hovered',
    'color.background.accent.green.subtler.pressed': '--ds-background-accent-green-subtler-pressed',
    'color.background.accent.green.subtle': '--ds-background-accent-green-subtle',
    'color.background.accent.green.subtle.hovered': '--ds-background-accent-green-subtle-hovered',
    'color.background.accent.green.subtle.pressed': '--ds-background-accent-green-subtle-pressed',
    'color.background.accent.green.bolder': '--ds-background-accent-green-bolder',
    'color.background.accent.green.bolder.hovered': '--ds-background-accent-green-bolder-hovered',
    'color.background.accent.green.bolder.pressed': '--ds-background-accent-green-bolder-pressed',
    'color.background.accent.teal.subtlest': '--ds-background-accent-teal-subtlest',
    'color.background.accent.teal.subtlest.hovered': '--ds-background-accent-teal-subtlest-hovered',
    'color.background.accent.teal.subtlest.pressed': '--ds-background-accent-teal-subtlest-pressed',
    'color.background.accent.teal.subtler': '--ds-background-accent-teal-subtler',
    'color.background.accent.teal.subtler.hovered': '--ds-background-accent-teal-subtler-hovered',
    'color.background.accent.teal.subtler.pressed': '--ds-background-accent-teal-subtler-pressed',
    'color.background.accent.teal.subtle': '--ds-background-accent-teal-subtle',
    'color.background.accent.teal.subtle.hovered': '--ds-background-accent-teal-subtle-hovered',
    'color.background.accent.teal.subtle.pressed': '--ds-background-accent-teal-subtle-pressed',
    'color.background.accent.teal.bolder': '--ds-background-accent-teal-bolder',
    'color.background.accent.teal.bolder.hovered': '--ds-background-accent-teal-bolder-hovered',
    'color.background.accent.teal.bolder.pressed': '--ds-background-accent-teal-bolder-pressed',
    'color.background.accent.blue.subtlest': '--ds-background-accent-blue-subtlest',
    'color.background.accent.blue.subtlest.hovered': '--ds-background-accent-blue-subtlest-hovered',
    'color.background.accent.blue.subtlest.pressed': '--ds-background-accent-blue-subtlest-pressed',
    'color.background.accent.blue.subtler': '--ds-background-accent-blue-subtler',
    'color.background.accent.blue.subtler.hovered': '--ds-background-accent-blue-subtler-hovered',
    'color.background.accent.blue.subtler.pressed': '--ds-background-accent-blue-subtler-pressed',
    'color.background.accent.blue.subtle': '--ds-background-accent-blue-subtle',
    'color.background.accent.blue.subtle.hovered': '--ds-background-accent-blue-subtle-hovered',
    'color.background.accent.blue.subtle.pressed': '--ds-background-accent-blue-subtle-pressed',
    'color.background.accent.blue.bolder': '--ds-background-accent-blue-bolder',
    'color.background.accent.blue.bolder.hovered': '--ds-background-accent-blue-bolder-hovered',
    'color.background.accent.blue.bolder.pressed': '--ds-background-accent-blue-bolder-pressed',
    'color.background.accent.purple.subtlest': '--ds-background-accent-purple-subtlest',
    'color.background.accent.purple.subtlest.hovered': '--ds-background-accent-purple-subtlest-hovered',
    'color.background.accent.purple.subtlest.pressed': '--ds-background-accent-purple-subtlest-pressed',
    'color.background.accent.purple.subtler': '--ds-background-accent-purple-subtler',
    'color.background.accent.purple.subtler.hovered': '--ds-background-accent-purple-subtler-hovered',
    'color.background.accent.purple.subtler.pressed': '--ds-background-accent-purple-subtler-pressed',
    'color.background.accent.purple.subtle': '--ds-background-accent-purple-subtle',
    'color.background.accent.purple.subtle.hovered': '--ds-background-accent-purple-subtle-hovered',
    'color.background.accent.purple.subtle.pressed': '--ds-background-accent-purple-subtle-pressed',
    'color.background.accent.purple.bolder': '--ds-background-accent-purple-bolder',
    'color.background.accent.purple.bolder.hovered': '--ds-background-accent-purple-bolder-hovered',
    'color.background.accent.purple.bolder.pressed': '--ds-background-accent-purple-bolder-pressed',
    'color.background.accent.magenta.subtlest': '--ds-background-accent-magenta-subtlest',
    'color.background.accent.magenta.subtlest.hovered': '--ds-background-accent-magenta-subtlest-hovered',
    'color.background.accent.magenta.subtlest.pressed': '--ds-background-accent-magenta-subtlest-pressed',
    'color.background.accent.magenta.subtler': '--ds-background-accent-magenta-subtler',
    'color.background.accent.magenta.subtler.hovered': '--ds-background-accent-magenta-subtler-hovered',
    'color.background.accent.magenta.subtler.pressed': '--ds-background-accent-magenta-subtler-pressed',
    'color.background.accent.magenta.subtle': '--ds-background-accent-magenta-subtle',
    'color.background.accent.magenta.subtle.hovered': '--ds-background-accent-magenta-subtle-hovered',
    'color.background.accent.magenta.subtle.pressed': '--ds-background-accent-magenta-subtle-pressed',
    'color.background.accent.magenta.bolder': '--ds-background-accent-magenta-bolder',
    'color.background.accent.magenta.bolder.hovered': '--ds-background-accent-magenta-bolder-hovered',
    'color.background.accent.magenta.bolder.pressed': '--ds-background-accent-magenta-bolder-pressed',
    'color.background.accent.gray.subtlest': '--ds-background-accent-gray-subtlest',
    'color.background.accent.gray.subtlest.hovered': '--ds-background-accent-gray-subtlest-hovered',
    'color.background.accent.gray.subtlest.pressed': '--ds-background-accent-gray-subtlest-pressed',
    'color.background.accent.gray.subtler': '--ds-background-accent-gray-subtler',
    'color.background.accent.gray.subtler.hovered': '--ds-background-accent-gray-subtler-hovered',
    'color.background.accent.gray.subtler.pressed': '--ds-background-accent-gray-subtler-pressed',
    'color.background.accent.gray.subtle': '--ds-background-accent-gray-subtle',
    'color.background.accent.gray.subtle.hovered': '--ds-background-accent-gray-subtle-hovered',
    'color.background.accent.gray.subtle.pressed': '--ds-background-accent-gray-subtle-pressed',
    'color.background.accent.gray.bolder': '--ds-background-accent-gray-bolder',
    'color.background.accent.gray.bolder.hovered': '--ds-background-accent-gray-bolder-hovered',
    'color.background.accent.gray.bolder.pressed': '--ds-background-accent-gray-bolder-pressed',
    'color.background.disabled': '--ds-background-disabled',
    'color.background.input': '--ds-background-input',
    'color.background.input.hovered': '--ds-background-input-hovered',
    'color.background.input.pressed': '--ds-background-input-pressed',
    'color.background.inverse.subtle': '--ds-background-inverse-subtle',
    'color.background.inverse.subtle.hovered': '--ds-background-inverse-subtle-hovered',
    'color.background.inverse.subtle.pressed': '--ds-background-inverse-subtle-pressed',
    'color.background.neutral': '--ds-background-neutral',
    'color.background.neutral.hovered': '--ds-background-neutral-hovered',
    'color.background.neutral.pressed': '--ds-background-neutral-pressed',
    'color.background.neutral.subtle': '--ds-background-neutral-subtle',
    'color.background.neutral.subtle.hovered': '--ds-background-neutral-subtle-hovered',
    'color.background.neutral.subtle.pressed': '--ds-background-neutral-subtle-pressed',
    'color.background.neutral.bold': '--ds-background-neutral-bold',
    'color.background.neutral.bold.hovered': '--ds-background-neutral-bold-hovered',
    'color.background.neutral.bold.pressed': '--ds-background-neutral-bold-pressed',
    'color.background.selected': '--ds-background-selected',
    'color.background.selected.hovered': '--ds-background-selected-hovered',
    'color.background.selected.pressed': '--ds-background-selected-pressed',
    'color.background.selected.bold': '--ds-background-selected-bold',
    'color.background.selected.bold.hovered': '--ds-background-selected-bold-hovered',
    'color.background.selected.bold.pressed': '--ds-background-selected-bold-pressed',
    'color.background.brand.subtlest': '--ds-background-brand-subtlest',
    'color.background.brand.subtlest.hovered': '--ds-background-brand-subtlest-hovered',
    'color.background.brand.subtlest.pressed': '--ds-background-brand-subtlest-pressed',
    'color.background.brand.bold': '--ds-background-brand-bold',
    'color.background.brand.bold.hovered': '--ds-background-brand-bold-hovered',
    'color.background.brand.bold.pressed': '--ds-background-brand-bold-pressed',
    'color.background.brand.boldest': '--ds-background-brand-boldest',
    'color.background.brand.boldest.hovered': '--ds-background-brand-boldest-hovered',
    'color.background.brand.boldest.pressed': '--ds-background-brand-boldest-pressed',
    'color.background.danger': '--ds-background-danger',
    'color.background.danger.hovered': '--ds-background-danger-hovered',
    'color.background.danger.pressed': '--ds-background-danger-pressed',
    'color.background.danger.bold': '--ds-background-danger-bold',
    'color.background.danger.bold.hovered': '--ds-background-danger-bold-hovered',
    'color.background.danger.bold.pressed': '--ds-background-danger-bold-pressed',
    'color.background.warning': '--ds-background-warning',
    'color.background.warning.hovered': '--ds-background-warning-hovered',
    'color.background.warning.pressed': '--ds-background-warning-pressed',
    'color.background.warning.bold': '--ds-background-warning-bold',
    'color.background.warning.bold.hovered': '--ds-background-warning-bold-hovered',
    'color.background.warning.bold.pressed': '--ds-background-warning-bold-pressed',
    'color.background.success': '--ds-background-success',
    'color.background.success.hovered': '--ds-background-success-hovered',
    'color.background.success.pressed': '--ds-background-success-pressed',
    'color.background.success.bold': '--ds-background-success-bold',
    'color.background.success.bold.hovered': '--ds-background-success-bold-hovered',
    'color.background.success.bold.pressed': '--ds-background-success-bold-pressed',
    'color.background.discovery': '--ds-background-discovery',
    'color.background.discovery.hovered': '--ds-background-discovery-hovered',
    'color.background.discovery.pressed': '--ds-background-discovery-pressed',
    'color.background.discovery.bold': '--ds-background-discovery-bold',
    'color.background.discovery.bold.hovered': '--ds-background-discovery-bold-hovered',
    'color.background.discovery.bold.pressed': '--ds-background-discovery-bold-pressed',
    'color.background.information': '--ds-background-information',
    'color.background.information.hovered': '--ds-background-information-hovered',
    'color.background.information.pressed': '--ds-background-information-pressed',
    'color.background.information.bold': '--ds-background-information-bold',
    'color.background.information.bold.hovered': '--ds-background-information-bold-hovered',
    'color.background.information.bold.pressed': '--ds-background-information-bold-pressed',
    'color.blanket': '--ds-blanket',
    'color.blanket.selected': '--ds-blanket-selected',
    'color.blanket.danger': '--ds-blanket-danger',
    'color.interaction.hovered': '--ds-interaction-hovered',
    'color.interaction.pressed': '--ds-interaction-pressed',
    'color.skeleton': '--ds-skeleton',
    'color.skeleton.subtle': '--ds-skeleton-subtle',
    'color.chart.categorical.1': '--ds-chart-categorical-1',
    'color.chart.categorical.1.hovered': '--ds-chart-categorical-1-hovered',
    'color.chart.categorical.2': '--ds-chart-categorical-2',
    'color.chart.categorical.2.hovered': '--ds-chart-categorical-2-hovered',
    'color.chart.categorical.3': '--ds-chart-categorical-3',
    'color.chart.categorical.3.hovered': '--ds-chart-categorical-3-hovered',
    'color.chart.categorical.4': '--ds-chart-categorical-4',
    'color.chart.categorical.4.hovered': '--ds-chart-categorical-4-hovered',
    'color.chart.categorical.5': '--ds-chart-categorical-5',
    'color.chart.categorical.5.hovered': '--ds-chart-categorical-5-hovered',
    'color.chart.categorical.6': '--ds-chart-categorical-6',
    'color.chart.categorical.6.hovered': '--ds-chart-categorical-6-hovered',
    'color.chart.categorical.7': '--ds-chart-categorical-7',
    'color.chart.categorical.7.hovered': '--ds-chart-categorical-7-hovered',
    'color.chart.categorical.8': '--ds-chart-categorical-8',
    'color.chart.categorical.8.hovered': '--ds-chart-categorical-8-hovered',
    'color.chart.lime.bold': '--ds-chart-lime-bold',
    'color.chart.lime.bold.hovered': '--ds-chart-lime-bold-hovered',
    'color.chart.lime.bolder': '--ds-chart-lime-bolder',
    'color.chart.lime.bolder.hovered': '--ds-chart-lime-bolder-hovered',
    'color.chart.lime.boldest': '--ds-chart-lime-boldest',
    'color.chart.lime.boldest.hovered': '--ds-chart-lime-boldest-hovered',
    'color.chart.neutral': '--ds-chart-neutral',
    'color.chart.neutral.hovered': '--ds-chart-neutral-hovered',
    'color.chart.red.bold': '--ds-chart-red-bold',
    'color.chart.red.bold.hovered': '--ds-chart-red-bold-hovered',
    'color.chart.red.bolder': '--ds-chart-red-bolder',
    'color.chart.red.bolder.hovered': '--ds-chart-red-bolder-hovered',
    'color.chart.red.boldest': '--ds-chart-red-boldest',
    'color.chart.red.boldest.hovered': '--ds-chart-red-boldest-hovered',
    'color.chart.orange.bold': '--ds-chart-orange-bold',
    'color.chart.orange.bold.hovered': '--ds-chart-orange-bold-hovered',
    'color.chart.orange.bolder': '--ds-chart-orange-bolder',
    'color.chart.orange.bolder.hovered': '--ds-chart-orange-bolder-hovered',
    'color.chart.orange.boldest': '--ds-chart-orange-boldest',
    'color.chart.orange.boldest.hovered': '--ds-chart-orange-boldest-hovered',
    'color.chart.yellow.bold': '--ds-chart-yellow-bold',
    'color.chart.yellow.bold.hovered': '--ds-chart-yellow-bold-hovered',
    'color.chart.yellow.bolder': '--ds-chart-yellow-bolder',
    'color.chart.yellow.bolder.hovered': '--ds-chart-yellow-bolder-hovered',
    'color.chart.yellow.boldest': '--ds-chart-yellow-boldest',
    'color.chart.yellow.boldest.hovered': '--ds-chart-yellow-boldest-hovered',
    'color.chart.green.bold': '--ds-chart-green-bold',
    'color.chart.green.bold.hovered': '--ds-chart-green-bold-hovered',
    'color.chart.green.bolder': '--ds-chart-green-bolder',
    'color.chart.green.bolder.hovered': '--ds-chart-green-bolder-hovered',
    'color.chart.green.boldest': '--ds-chart-green-boldest',
    'color.chart.green.boldest.hovered': '--ds-chart-green-boldest-hovered',
    'color.chart.teal.bold': '--ds-chart-teal-bold',
    'color.chart.teal.bold.hovered': '--ds-chart-teal-bold-hovered',
    'color.chart.teal.bolder': '--ds-chart-teal-bolder',
    'color.chart.teal.bolder.hovered': '--ds-chart-teal-bolder-hovered',
    'color.chart.teal.boldest': '--ds-chart-teal-boldest',
    'color.chart.teal.boldest.hovered': '--ds-chart-teal-boldest-hovered',
    'color.chart.blue.bold': '--ds-chart-blue-bold',
    'color.chart.blue.bold.hovered': '--ds-chart-blue-bold-hovered',
    'color.chart.blue.bolder': '--ds-chart-blue-bolder',
    'color.chart.blue.bolder.hovered': '--ds-chart-blue-bolder-hovered',
    'color.chart.blue.boldest': '--ds-chart-blue-boldest',
    'color.chart.blue.boldest.hovered': '--ds-chart-blue-boldest-hovered',
    'color.chart.purple.bold': '--ds-chart-purple-bold',
    'color.chart.purple.bold.hovered': '--ds-chart-purple-bold-hovered',
    'color.chart.purple.bolder': '--ds-chart-purple-bolder',
    'color.chart.purple.bolder.hovered': '--ds-chart-purple-bolder-hovered',
    'color.chart.purple.boldest': '--ds-chart-purple-boldest',
    'color.chart.purple.boldest.hovered': '--ds-chart-purple-boldest-hovered',
    'color.chart.magenta.bold': '--ds-chart-magenta-bold',
    'color.chart.magenta.bold.hovered': '--ds-chart-magenta-bold-hovered',
    'color.chart.magenta.bolder': '--ds-chart-magenta-bolder',
    'color.chart.magenta.bolder.hovered': '--ds-chart-magenta-bolder-hovered',
    'color.chart.magenta.boldest': '--ds-chart-magenta-boldest',
    'color.chart.magenta.boldest.hovered': '--ds-chart-magenta-boldest-hovered',
    'color.chart.gray.bold': '--ds-chart-gray-bold',
    'color.chart.gray.bold.hovered': '--ds-chart-gray-bold-hovered',
    'color.chart.gray.bolder': '--ds-chart-gray-bolder',
    'color.chart.gray.bolder.hovered': '--ds-chart-gray-bolder-hovered',
    'color.chart.gray.boldest': '--ds-chart-gray-boldest',
    'color.chart.gray.boldest.hovered': '--ds-chart-gray-boldest-hovered',
    'color.chart.brand': '--ds-chart-brand',
    'color.chart.brand.hovered': '--ds-chart-brand-hovered',
    'color.chart.danger': '--ds-chart-danger',
    'color.chart.danger.hovered': '--ds-chart-danger-hovered',
    'color.chart.danger.bold': '--ds-chart-danger-bold',
    'color.chart.danger.bold.hovered': '--ds-chart-danger-bold-hovered',
    'color.chart.warning': '--ds-chart-warning',
    'color.chart.warning.hovered': '--ds-chart-warning-hovered',
    'color.chart.warning.bold': '--ds-chart-warning-bold',
    'color.chart.warning.bold.hovered': '--ds-chart-warning-bold-hovered',
    'color.chart.success': '--ds-chart-success',
    'color.chart.success.hovered': '--ds-chart-success-hovered',
    'color.chart.success.bold': '--ds-chart-success-bold',
    'color.chart.success.bold.hovered': '--ds-chart-success-bold-hovered',
    'color.chart.discovery': '--ds-chart-discovery',
    'color.chart.discovery.hovered': '--ds-chart-discovery-hovered',
    'color.chart.discovery.bold': '--ds-chart-discovery-bold',
    'color.chart.discovery.bold.hovered': '--ds-chart-discovery-bold-hovered',
    'color.chart.information': '--ds-chart-information',
    'color.chart.information.hovered': '--ds-chart-information-hovered',
    'color.chart.information.bold': '--ds-chart-information-bold',
    'color.chart.information.bold.hovered': '--ds-chart-information-bold-hovered',
    'elevation.surface': '--ds-surface',
    'elevation.surface.hovered': '--ds-surface-hovered',
    'elevation.surface.pressed': '--ds-surface-pressed',
    'elevation.surface.overlay': '--ds-surface-overlay',
    'elevation.surface.overlay.hovered': '--ds-surface-overlay-hovered',
    'elevation.surface.overlay.pressed': '--ds-surface-overlay-pressed',
    'elevation.surface.raised': '--ds-surface-raised',
    'elevation.surface.raised.hovered': '--ds-surface-raised-hovered',
    'elevation.surface.raised.pressed': '--ds-surface-raised-pressed',
    'elevation.surface.sunken': '--ds-surface-sunken',
    'elevation.shadow.overflow': '--ds-shadow-overflow',
    'elevation.shadow.overflow.perimeter': '--ds-shadow-overflow-perimeter',
    'elevation.shadow.overflow.spread': '--ds-shadow-overflow-spread',
    'elevation.shadow.overlay': '--ds-shadow-overlay',
    'elevation.shadow.raised': '--ds-shadow-raised',
    'opacity.disabled': '--ds-opacity-disabled',
    'opacity.loading': '--ds-opacity-loading',
    'utility.UNSAFE.textTransformUppercase': '--ds-UNSAFE-textTransformUppercase',
    'utility.UNSAFE.transparent': '--ds-UNSAFE-transparent',
    'utility.elevation.surface.current': '--ds-elevation-surface-current',
    'border.radius.050': '--ds-border-radius-050',
    'border.radius': '--ds-border-radius',
    'border.radius.100': '--ds-border-radius-100',
    'border.radius.200': '--ds-border-radius-200',
    'border.radius.300': '--ds-border-radius-300',
    'border.radius.400': '--ds-border-radius-400',
    'border.radius.circle': '--ds-border-radius-circle',
    'border.width': '--ds-border-width',
    'border.width.0': '--ds-border-width-0',
    'border.width.indicator': '--ds-border-width-indicator',
    'border.width.outline': '--ds-border-width-outline',
    'space.0': '--ds-space-0',
    'space.025': '--ds-space-025',
    'space.050': '--ds-space-050',
    'space.075': '--ds-space-075',
    'space.100': '--ds-space-100',
    'space.150': '--ds-space-150',
    'space.200': '--ds-space-200',
    'space.250': '--ds-space-250',
    'space.300': '--ds-space-300',
    'space.400': '--ds-space-400',
    'space.500': '--ds-space-500',
    'space.600': '--ds-space-600',
    'space.800': '--ds-space-800',
    'space.1000': '--ds-space-1000',
    'space.negative.025': '--ds-space-negative-025',
    'space.negative.050': '--ds-space-negative-050',
    'space.negative.075': '--ds-space-negative-075',
    'space.negative.100': '--ds-space-negative-100',
    'space.negative.150': '--ds-space-negative-150',
    'space.negative.200': '--ds-space-negative-200',
    'space.negative.250': '--ds-space-negative-250',
    'space.negative.300': '--ds-space-negative-300',
    'space.negative.400': '--ds-space-negative-400',
    'font.letterSpacing.0': '--ds-font-letterSpacing-0',
    'font.letterSpacing.100': '--ds-font-letterSpacing-100',
    'font.letterSpacing.200': '--ds-font-letterSpacing-200',
    'font.letterSpacing.300': '--ds-font-letterSpacing-300',
    'font.letterSpacing.400': '--ds-font-letterSpacing-400',
    'font.heading.xxlarge': '--ds-font-heading-xxlarge',
    'font.heading.xlarge': '--ds-font-heading-xlarge',
    'font.heading.large': '--ds-font-heading-large',
    'font.heading.medium': '--ds-font-heading-medium',
    'font.heading.small': '--ds-font-heading-small',
    'font.heading.xsmall': '--ds-font-heading-xsmall',
    'font.heading.xxsmall': '--ds-font-heading-xxsmall',
    'font.body.large': '--ds-font-body-large',
    'font.body': '--ds-font-body',
    'font.body.small': '--ds-font-body-small',
    'font.body.UNSAFE_small': '--ds-font-body-UNSAFE_small',
    'font.code': '--ds-font-code',
    'font.weight.regular': '--ds-font-weight-regular',
    'font.weight.medium': '--ds-font-weight-medium',
    'font.weight.semibold': '--ds-font-weight-semibold',
    'font.weight.bold': '--ds-font-weight-bold',
    'font.family.heading': '--ds-font-family-heading',
    'font.family.body': '--ds-font-family-body',
    'font.family.code': '--ds-font-family-code',
    'font.family.monospace': '--ds-font-family-monospace',
    'font.family.sans': '--ds-font-family-sans',
    'font.family.brand.heading': '--ds-font-family-brand-heading',
    'font.family.brand.body': '--ds-font-family-brand-body',
    'font.size.050': '--ds-font-size-050',
    'font.size.075': '--ds-font-size-075',
    'font.size.100': '--ds-font-size-100',
    'font.size.200': '--ds-font-size-200',
    'font.size.300': '--ds-font-size-300',
    'font.size.400': '--ds-font-size-400',
    'font.size.500': '--ds-font-size-500',
    'font.size.600': '--ds-font-size-600',
    'font.lineHeight.1': '--ds-font-lineHeight-1',
    'font.lineHeight.100': '--ds-font-lineHeight-100',
    'font.lineHeight.200': '--ds-font-lineHeight-200',
    'font.lineHeight.300': '--ds-font-lineHeight-300',
    'font.lineHeight.400': '--ds-font-lineHeight-400',
    'font.lineHeight.500': '--ds-font-lineHeight-500',
    'font.lineHeight.600': '--ds-font-lineHeight-600'
};
var $d295851e89428aa9$export$2e2bcd8739ae039 = $d295851e89428aa9$var$tokens;


var $afac61f58a76c125$export$4ef52930e33717cd = 'data-theme';
var $afac61f58a76c125$export$a00eac3f8684bcd0 = 'data-color-mode';
var $afac61f58a76c125$export$2112803007239c61 = 'data-contrast-mode';
var $afac61f58a76c125$export$352e418ed5b6193a = 'data-custom-theme';
var $afac61f58a76c125$export$2faeed762aac6741 = 'light';
var $afac61f58a76c125$export$6f0c6fb8c80fcc92 = 'ds';
var $afac61f58a76c125$export$4d0c7bbf80185957 = [
    'opacity',
    'font',
    'space',
    'border'
];
var $afac61f58a76c125$export$dddac1532e822863 = "--".concat($afac61f58a76c125$export$6f0c6fb8c80fcc92, "-token-not-found");
var $afac61f58a76c125$export$9d7b58831ae93caa = "--".concat($afac61f58a76c125$export$6f0c6fb8c80fcc92, "-elevation-surface-current");



var $3ZMUU = parcelRequire("3ZMUU");
/**
 * Takes a dot-separated token name and an optional fallback, and returns the CSS custom property for the corresponding token.
 * This should be used to implement design decisions throughout your application.
 *
 * Note: With `@atlaskit/babel-plugin-tokens`, this function can be pre-compiled and a fallback value automatically inserted.
 *
 * @param {string} path - A dot-separated token name (example: `'color.background.brand'` or `'spacing.scale.100'`).
 * @param {string} [fallback] - The fallback value that should render when token CSS is not present in your app.
 *
 * @example
 * ```
 * <div
 *   css={{
 *     backgroundColor: token('elevation.surface.raised', N0),
 *     boxShadow: token('elevation.shadow.raised', `0 20px 32px -8px ${N50A}, 0 0 1px ${N60A}`),
 *     padding: token('spacing.scale.100', '8px'),
 *     fontWeight: token('font.weight.regular', '400'),
 *   }}
 * />
 * ```
 *
 */ function $4a23d292896bbb64$var$token(path, fallback) {
    var token = (0, $d295851e89428aa9$export$2e2bcd8739ae039)[path];
    typeof $3ZMUU;
    // if the token is not found - replacing it with variable name without any value, to avoid it being undefined which would result in invalid css
    if (!token) token = (0, $afac61f58a76c125$export$dddac1532e822863);
    var tokenCall = fallback ? "var(".concat(token, ", ").concat(fallback, ")") : "var(".concat(token, ")");
    return tokenCall;
}
var $4a23d292896bbb64$export$2e2bcd8739ae039 = $4a23d292896bbb64$var$token;



var $74Zh5 = parcelRequire("74Zh5");

var $5FkrB = parcelRequire("5FkrB");

var $kqp0i = parcelRequire("kqp0i");

var $iYJcE = parcelRequire("iYJcE");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");

var $eVb4V = parcelRequire("eVb4V");

var $kqp0i = parcelRequire("kqp0i");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");

var $74Zh5 = parcelRequire("74Zh5");

var $25nEq = parcelRequire("25nEq");

var $5FkrB = parcelRequire("5FkrB");

var $dLGML = parcelRequire("dLGML");

var $fC8ib = parcelRequire("fC8ib");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $kIXpt = parcelRequire("kIXpt");

var $cYPzS = parcelRequire("cYPzS");

var $lwlXp = parcelRequire("lwlXp");

var $eyuDe = parcelRequire("eyuDe");

var $25nEq = parcelRequire("25nEq");

var $ekGgq = parcelRequire("ekGgq");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $25nEq = parcelRequire("25nEq");
function $ebe7818179375ec0$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $ebe7818179375ec0$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $ebe7818179375ec0$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $ebe7818179375ec0$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $ebe7818179375ec0$export$ad4be5c2ec28cecf = function isAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $ebe7818179375ec0$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === 'AnalyticsEvent';
};
var $ebe7818179375ec0$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function AnalyticsEvent(props) {
        var _this = this;
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, AnalyticsEvent);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "_isAnalyticsEvent", true);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "clone", function() {
            // just a shallow clone, don't change sub refs unless you want to
            // affect the original's too
            var payload = $ebe7818179375ec0$var$_objectSpread({}, _this.payload);
            return new AnalyticsEvent({
                payload: payload
            });
        });
        this.payload = props.payload;
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(AnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (typeof updater === 'function') this.payload = updater(this.payload);
                if ((0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(updater) === 'object') this.payload = $ebe7818179375ec0$var$_objectSpread($ebe7818179375ec0$var$_objectSpread({}, this.payload), updater);
                return this;
            }
        }
    ]);
}();


function $70a0b6f4d107edd0$var$_callSuper(t, o, e) {
    return o = (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(o), (0, (/*@__PURE__*/$parcel$interopDefault($kIXpt)))(t, $70a0b6f4d107edd0$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(t).constructor) : o.apply(t, e));
}
function $70a0b6f4d107edd0$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($70a0b6f4d107edd0$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $70a0b6f4d107edd0$var$_superPropGet(t, o, e, r) {
    var p = (0, (/*@__PURE__*/$parcel$interopDefault($lwlXp)))((0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(1 & r ? t.prototype : t), o, e);
    return 2 & r && "function" == typeof p ? function(t) {
        return p.apply(e, t);
    } : p;
}
var $70a0b6f4d107edd0$export$35f8383928ba8d7 = function isUIAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $70a0b6f4d107edd0$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isUIAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === 'UIAnalyticsEvent';
};
var $70a0b6f4d107edd0$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_AnalyticsEvent) {
    function UIAnalyticsEvent(props) {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, UIAnalyticsEvent);
        _this = $70a0b6f4d107edd0$var$_callSuper(this, UIAnalyticsEvent, [
            props
        ]);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "_isUIAnalyticsEvent", true);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "clone", function() {
            if (_this.hasFired) return null;
            var context = (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(_this.context);
            var handlers = (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(_this.handlers);
            /**
       * A hacky "deep clone" of the object. This is limited in that it wont
       * support functions, regexs, Maps, Sets, etc, but none of those need to
       * be represented in our payload.
       */ var payload = JSON.parse(JSON.stringify(_this.payload));
            return new UIAnalyticsEvent({
                context: context,
                handlers: handlers,
                payload: payload
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "fire", function(channel) {
            if (_this.hasFired) return;
            _this.handlers.forEach(function(handler) {
                return handler(_this, channel);
            });
            _this.hasFired = true;
        });
        _this.context = props.context || [];
        _this.handlers = props.handlers || [];
        _this.hasFired = false;
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($eyuDe)))(UIAnalyticsEvent, _AnalyticsEvent);
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(UIAnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (this.hasFired) return this;
                return $70a0b6f4d107edd0$var$_superPropGet(UIAnalyticsEvent, "update", this, 3)([
                    updater
                ]);
            }
        }
    ]);
}((0, $ebe7818179375ec0$export$2e2bcd8739ae039));



var $5FkrB = parcelRequire("5FkrB");

var $iyyOp = parcelRequire("iyyOp");
var $15bfd899f3695e59$export$d1f587f82ad51c4 = function useAnalyticsContext() {
    return (0, $5FkrB.useContext)((0, $iyyOp.default));
};


function $9f01e7311243f881$export$5bf35293e545f20c() {
    var analyticsContext = (0, $15bfd899f3695e59$export$d1f587f82ad51c4)();
    var createAnalyticsEvent = (0, $dLGML.useCallbackOne)(function(payload) {
        return new (0, $70a0b6f4d107edd0$export$2e2bcd8739ae039)({
            context: analyticsContext.getAtlaskitAnalyticsContext(),
            handlers: analyticsContext.getAtlaskitAnalyticsEventHandlers(),
            payload: payload
        });
    }, [
        analyticsContext
    ]);
    return {
        createAnalyticsEvent: createAnalyticsEvent
    };
}



var $5FkrB = parcelRequire("5FkrB");
var $b135a37d7f049dd6$export$1d27a74659855e44 = function useTrackedRef(value) {
    var ref = (0, $5FkrB.useRef)(value);
    ref.current = value;
    return ref;
};


function $9a80315d150981cc$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $9a80315d150981cc$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $9a80315d150981cc$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $9a80315d150981cc$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $9a80315d150981cc$export$a4687b0234b40e28(_ref) {
    var fn = _ref.fn, action = _ref.action, componentName = _ref.componentName, actionSubject = _ref.actionSubject, packageName = _ref.packageName, packageVersion = _ref.packageVersion, analyticsData = _ref.analyticsData;
    var _useAnalyticsEvents = (0, $9f01e7311243f881$export$5bf35293e545f20c)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
    // We put analyticsData and fn in a ref so that we don't need to break
    // memoization.
    // Generally these could be defined by consumers inline
    // and so we do this to avoid breaking memoization of useCallback
    var dataRef = (0, $b135a37d7f049dd6$export$1d27a74659855e44)(analyticsData);
    var fnRef = (0, $b135a37d7f049dd6$export$1d27a74659855e44)(fn);
    var handler = (0, $5FkrB.useCallback)(function(value) {
        var analyticsEvent = createAnalyticsEvent({
            action: action,
            actionSubject: actionSubject || componentName,
            attributes: {
                componentName: componentName,
                packageName: packageName,
                packageVersion: packageVersion
            }
        });
        // To avoid wrapping this component in AnalyticsContext we manually
        // push the parent context's meta data into the context.
        // Note: this new 'context'
        var context = $9a80315d150981cc$var$_objectSpread({
            componentName: componentName,
            packageName: packageName,
            packageVersion: packageVersion
        }, dataRef.current);
        analyticsEvent.context.push(context);
        // fire an event on the atlaskit channel
        var clone = analyticsEvent.clone();
        if (clone) clone.fire('atlaskit');
        fnRef.current(value, analyticsEvent);
    }, [
        // These are strings and won't change
        action,
        componentName,
        actionSubject,
        packageName,
        packageVersion,
        // This function is memoized in the context
        createAnalyticsEvent,
        // these are a stable ref because of the useTrackedRef hook
        dataRef,
        fnRef
    ]);
    return handler;
}



var $eVb4V = parcelRequire("eVb4V");

var $gpUQB = parcelRequire("gpUQB");

var $eYQvF = parcelRequire("eYQvF");

var $eqVaP = parcelRequire("eqVaP");
// Reds
var $15d97c4884e4ca81$export$4b84fd0e2c617bd = '#FFEBE6';
var $15d97c4884e4ca81$export$b34b069eff244586 = '#FFBDAD';
var $15d97c4884e4ca81$export$be802dd0d8b57f35 = '#FF8F73';
var $15d97c4884e4ca81$export$60847d42f9da92a6 = '#FF7452';
var $15d97c4884e4ca81$export$4a7404f376229999 = '#FF5630';
var $15d97c4884e4ca81$export$2010d0fb4295b346 = '#DE350B';
var $15d97c4884e4ca81$export$2837b5a1a71d5c02 = '#BF2600';
var $15d97c4884e4ca81$export$8d9596b529bbb9cf = '#FFFAE6';
var $15d97c4884e4ca81$export$41060a744ab0b7ae = '#FFF0B3';
var $15d97c4884e4ca81$export$1cc05bbbf340e559 = '#FFE380';
var $15d97c4884e4ca81$export$5aae31392d72caaa = '#FFC400';
var $15d97c4884e4ca81$export$c6930421db9fa514 = '#FFAB00';
var $15d97c4884e4ca81$export$59619663aa6500fb = '#FF991F';
var $15d97c4884e4ca81$export$874739ea9e379ab6 = '#FF8B00';
var $15d97c4884e4ca81$export$8a6341c32b6a3ee6 = '#E3FCEF';
var $15d97c4884e4ca81$export$69a3bf21b9686c2b = '#ABF5D1';
var $15d97c4884e4ca81$export$afbce1382ec95f73 = '#79F2C0';
var $15d97c4884e4ca81$export$747d86715d4175de = '#57D9A3';
var $15d97c4884e4ca81$export$940e1f69e873f202 = '#36B37E';
var $15d97c4884e4ca81$export$a49394138f7b8e85 = '#00875A';
var $15d97c4884e4ca81$export$6fa04827ac68a4fb = '#006644';
var $15d97c4884e4ca81$export$226de0355ed012f8 = '#DEEBFF';
var $15d97c4884e4ca81$export$8c13c2ee36917869 = '#B3D4FF';
var $15d97c4884e4ca81$export$ecfc1dff386a3e7a = '#4C9AFF';
var $15d97c4884e4ca81$export$215b7063051591f1 = '#2684FF';
var $15d97c4884e4ca81$export$e62e8919cca44969 = '#0065FF';
var $15d97c4884e4ca81$export$b3de0ae08da2ce64 = '#0052CC';
var $15d97c4884e4ca81$export$a6ee3d71bc067634 = '#0747A6';
var $15d97c4884e4ca81$export$67f15409e87642a1 = '#669DF1';
var $15d97c4884e4ca81$export$f0539dbc42dbb067 = '#8FB8F6';
var $15d97c4884e4ca81$export$363e4475840015bb = '#EAE6FF';
var $15d97c4884e4ca81$export$4b0a4417ed59760f = '#C0B6F2';
var $15d97c4884e4ca81$export$6011520a64d9a187 = '#998DD9';
var $15d97c4884e4ca81$export$a7175d4e9206bc80 = '#8777D9';
var $15d97c4884e4ca81$export$b48405b95304b5a1 = '#6554C0';
var $15d97c4884e4ca81$export$c71e4279dd54a18d = '#5243AA';
var $15d97c4884e4ca81$export$147899de772240ec = '#403294';
var $15d97c4884e4ca81$export$2cf711fe14c66f06 = '#E6FCFF';
var $15d97c4884e4ca81$export$7a8f4d33f6f9772c = '#B3F5FF';
var $15d97c4884e4ca81$export$776c9c497ef08533 = '#79E2F2';
var $15d97c4884e4ca81$export$69cb3ca10c1e330e = '#00C7E6';
var $15d97c4884e4ca81$export$9dc1ef0f3f48059b = '#00B8D9';
var $15d97c4884e4ca81$export$7c835c78b6fcdef8 = '#00A3BF';
var $15d97c4884e4ca81$export$6036577f95c3877e = '#008DA6';
var $15d97c4884e4ca81$export$29a4f05edc054374 = '#FFFFFF';
var $15d97c4884e4ca81$export$e655ef011c4aa1a2 = '#FAFBFC';
var $15d97c4884e4ca81$export$9fdfb749e33cdf97 = '#F4F5F7';
var $15d97c4884e4ca81$export$3e51e8f1440314ba = '#EBECF0';
var $15d97c4884e4ca81$export$1ce2d1575d444ceb = '#DFE1E6';
var $15d97c4884e4ca81$export$8754fc7e6d8b3000 = '#C1C7D0';
var $15d97c4884e4ca81$export$c2e91cbeada39b8b = '#B3BAC5';
var $15d97c4884e4ca81$export$5f71e19f3a7ad9de = '#A5ADBA';
var $15d97c4884e4ca81$export$eaa8c8a70ac22806 = '#97A0AF';
var $15d97c4884e4ca81$export$7c87d337fb91a97d = '#8993A4';
var $15d97c4884e4ca81$export$d6447c357493214f = '#7A869A';
var $15d97c4884e4ca81$export$f563ee71e9ee74cd = '#6B778C';
var $15d97c4884e4ca81$export$e2ef2124cf4024b1 = '#5E6C84';
var $15d97c4884e4ca81$export$eece5f492e429f08 = '#505F79';
var $15d97c4884e4ca81$export$c39c0fe0f26207ae = '#42526E';
var $15d97c4884e4ca81$export$7090862dc3038a9f = '#344563';
var $15d97c4884e4ca81$export$ad0bacf983b7ddaa = '#253858';
var $15d97c4884e4ca81$export$7d61b15e0da132af = '#172B4D';
var $15d97c4884e4ca81$export$fbda843f0a27fe96 = '#091E42';
var $15d97c4884e4ca81$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
var $15d97c4884e4ca81$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
var $15d97c4884e4ca81$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
var $15d97c4884e4ca81$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
var $15d97c4884e4ca81$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
var $15d97c4884e4ca81$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
var $15d97c4884e4ca81$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
var $15d97c4884e4ca81$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
var $15d97c4884e4ca81$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
var $15d97c4884e4ca81$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
var $15d97c4884e4ca81$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
var $15d97c4884e4ca81$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
var $15d97c4884e4ca81$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
var $15d97c4884e4ca81$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
var $15d97c4884e4ca81$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
var $15d97c4884e4ca81$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
var $15d97c4884e4ca81$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
var $15d97c4884e4ca81$export$2f6319cf7d736c2a = '#E6EDFA';
var $15d97c4884e4ca81$export$95126bc8884d6634 = '#DCE5F5';
var $15d97c4884e4ca81$export$8338d8c35d44ff1 = '#CED9EB';
var $15d97c4884e4ca81$export$5368d76ae4fbbda7 = '#B8C7E0';
var $15d97c4884e4ca81$export$9f0a771d16ec8d36 = '#ABBBD6';
var $15d97c4884e4ca81$export$abcf8c38338b4aa5 = '#9FB0CC';
var $15d97c4884e4ca81$export$97e81faa16a182c7 = '#8C9CB8';
var $15d97c4884e4ca81$export$bfe21c59123ecf33 = '#7988A3';
var $15d97c4884e4ca81$export$ee82aa2ea6a1558 = '#67758F';
var $15d97c4884e4ca81$export$682927c6ed76be02 = '#56637A';
var $15d97c4884e4ca81$export$91fd9994c5be9757 = '#455166';
var $15d97c4884e4ca81$export$d281fbfe3cff2df6 = '#3B475C';
var $15d97c4884e4ca81$export$3902c91d8b98a753 = '#313D52';
var $15d97c4884e4ca81$export$8e8133c1ba5845b5 = '#283447';
var $15d97c4884e4ca81$export$33ff357f6620b39 = '#202B3D';
var $15d97c4884e4ca81$export$633847cf062b69e0 = '#1B2638';
var $15d97c4884e4ca81$export$9776a6e503bdbf76 = '#121A29';
var $15d97c4884e4ca81$export$6c813d5160dff5db = '#0E1624';
var $15d97c4884e4ca81$export$3d4f271a500072a = '#0D1424';
var $15d97c4884e4ca81$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
var $15d97c4884e4ca81$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
var $15d97c4884e4ca81$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
var $15d97c4884e4ca81$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
var $15d97c4884e4ca81$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
var $15d97c4884e4ca81$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
var $15d97c4884e4ca81$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
var $15d97c4884e4ca81$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
var $15d97c4884e4ca81$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
var $15d97c4884e4ca81$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
var $15d97c4884e4ca81$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
var $15d97c4884e4ca81$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
var $15d97c4884e4ca81$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
var $15d97c4884e4ca81$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
var $15d97c4884e4ca81$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
var $15d97c4884e4ca81$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
var $15d97c4884e4ca81$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';
var $15d97c4884e4ca81$export$d2adc5dedf09fced = '#292A2E';
var $15d97c4884e4ca81$export$f51762073d2bb381 = '#94C748';
var $15d97c4884e4ca81$export$95e26d54def96891 = '#B3DF72';


function $4060b3d9ebb9edae$var$abort(event) {
    event.preventDefault();
    event.stopPropagation();
}
var $4060b3d9ebb9edae$var$tabKeyCode = 9;
function $4060b3d9ebb9edae$var$onKey(event) {
    // Allowing tab so that a user can move focus away
    if (event.keyCode === $4060b3d9ebb9edae$var$tabKeyCode) return;
    $4060b3d9ebb9edae$var$abort(event);
}
var $4060b3d9ebb9edae$var$block = {
    onMouseDownCapture: $4060b3d9ebb9edae$var$abort,
    onMouseUpCapture: $4060b3d9ebb9edae$var$abort,
    // because we have tabIndex = -1 when disabled,
    // keyboard events can only occur when there is an overlay
    onKeyDownCapture: $4060b3d9ebb9edae$var$onKey,
    onKeyUpCapture: $4060b3d9ebb9edae$var$onKey,
    onTouchStartCapture: $4060b3d9ebb9edae$var$abort,
    onTouchEndCapture: $4060b3d9ebb9edae$var$abort,
    onPointerDownCapture: $4060b3d9ebb9edae$var$abort,
    onPointerUpCapture: $4060b3d9ebb9edae$var$abort,
    onClickCapture: $4060b3d9ebb9edae$var$abort,
    // Just smashing the existing onClick for good measure
    onClick: $4060b3d9ebb9edae$var$abort
};
var $4060b3d9ebb9edae$var$doNotBlock = {};
function $4060b3d9ebb9edae$export$2e2bcd8739ae039(_ref) {
    var isInteractive = _ref.isInteractive;
    return isInteractive ? $4060b3d9ebb9edae$var$doNotBlock : $4060b3d9ebb9edae$var$block;
}



var $25nEq = parcelRequire("25nEq");

var $74Zh5 = parcelRequire("74Zh5");

var $id6Cu = parcelRequire("id6Cu");
function $89ec118b6543e1e2$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $89ec118b6543e1e2$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $89ec118b6543e1e2$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $89ec118b6543e1e2$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $89ec118b6543e1e2$var$gridSize = 8;
var $89ec118b6543e1e2$var$HAS_DISABLED_BACKGROUND = [
    'default',
    'primary',
    'danger',
    'warning'
];
// ## Button layout
//
// /------------------------------------------------------------------------------------------------------------------\
// |       →  |  ←      |          |      →  |  ←      |           |      →  |  ←      |         |      →  |  ←       |
// |  10px →  |  ← 2px  |   icon   |  2px →  |  ← 2px  |           |  2px →  |  ← 2px  |  icon   |  2px →  |  ← 10px  |
// |  padding |  margin |  before  |  margin |  margin |  content  |  margin |  margin |  after  |  margin |  padding |
// |    (12px total)    |          |    (4px total)    |           |    (4px total)    |         |    (12px total)    |
// |       →  |  ←      |          |      →  |  ←      |           |      →  |  ←      |         |      →  |  ←       |
// \------------------------------------------------------------------------------------------------------------------/
//                                           ↑                               ↑
//                                        Margins don't collapse with inline-flex
//
var $89ec118b6543e1e2$var$heights = {
    default: "".concat(32 / 14, "em"),
    // 32px
    compact: "".concat(24 / 14, "em"),
    none: 'auto'
};
var $89ec118b6543e1e2$var$lineHeights = {
    default: $89ec118b6543e1e2$var$heights.default,
    compact: $89ec118b6543e1e2$var$heights.compact,
    none: 'inherit'
};
var $89ec118b6543e1e2$var$padding = {
    // 10px gutter
    default: "0 ".concat($89ec118b6543e1e2$var$gridSize + $89ec118b6543e1e2$var$gridSize / 4, "px"),
    compact: "0 ".concat($89ec118b6543e1e2$var$gridSize + $89ec118b6543e1e2$var$gridSize / 4, "px"),
    none: '0'
};
var $89ec118b6543e1e2$var$singleIconPadding = {
    // 2px gutter
    compact: "0 ".concat($89ec118b6543e1e2$var$gridSize / 4, "px"),
    default: "0 ".concat($89ec118b6543e1e2$var$gridSize / 4, "px"),
    none: '0'
};
var $89ec118b6543e1e2$var$verticalAlign = {
    default: 'middle',
    compact: 'middle',
    none: 'baseline'
};
var $89ec118b6543e1e2$var$innerMargin = {
    content: "0 ".concat($89ec118b6543e1e2$var$gridSize / 4, "px"),
    icon: "0 ".concat($89ec118b6543e1e2$var$gridSize / 4, "px")
};
var $89ec118b6543e1e2$var$defaultAfterStyles = {
    borderRadius: 'inherit',
    inset: "var(--ds-space-0, 0px)",
    borderStyle: 'solid',
    borderWidth: "var(--ds-border-width, 1px)",
    pointerEvents: 'none',
    position: 'absolute'
};
var $89ec118b6543e1e2$var$defaultStyles = {
    background: "var(--ds-background-neutral-subtle, #00000000)",
    color: "var(--ds-text, #292A2E)",
    '&::after': $89ec118b6543e1e2$var$_objectSpread($89ec118b6543e1e2$var$_objectSpread({}, $89ec118b6543e1e2$var$defaultAfterStyles), {}, {
        content: '""',
        borderColor: "var(--ds-border, #0B120E24)"
    }),
    '&:hover': {
        background: "var(--ds-background-neutral-hovered, #0B120E24)"
    },
    '&:active': {
        background: "var(--ds-background-neutral-pressed, #080F214A)"
    },
    '&[data-has-overlay="true"]:not([disabled]):hover': {
        background: "var(--ds-background-neutral-subtle, #00000000)"
    },
    '&:disabled[disabled]': {
        background: "var(--ds-background-neutral-subtle, #00000000)"
    },
    '&:disabled[disabled]:hover': {
        background: "var(--ds-background-neutral-subtle, #00000000)"
    },
    '&:disabled[disabled]:active': {
        background: "var(--ds-background-neutral-subtle, #00000000)"
    }
};
var $89ec118b6543e1e2$var$primaryStyles = {
    background: "var(--ds-background-brand-bold, #1868DB)",
    color: "var(--ds-text-inverse, #FFFFFF)",
    '&:hover': {
        background: "var(--ds-background-brand-bold-hovered, #1558BC)"
    },
    '&:active': {
        background: "var(--ds-background-brand-bold-pressed, #144794)"
    },
    '&[data-has-overlay="true"]:not([disabled]):hover': {
        background: "var(--ds-background-brand-bold, #1868DB)"
    }
};
var $89ec118b6543e1e2$var$linkStyles = {
    background: 'transparent',
    color: "var(--ds-link, #1868DB)",
    '&:hover': {
        color: "var(--ds-link, #1868DB)",
        textDecoration: 'underline'
    },
    '&:active': {
        color: "var(--ds-link-pressed, #1558BC)",
        textDecoration: 'underline'
    }
};
var $89ec118b6543e1e2$var$subtleStyles = {
    background: 'transparent',
    color: "var(--ds-text-subtle, #505258)",
    '&:hover': {
        background: "var(--ds-background-neutral-subtle-hovered, #0515240F)"
    },
    '&:active': {
        background: "var(--ds-background-neutral-subtle-pressed, #0B120E24)"
    },
    '&[data-has-overlay="true"]:not([disabled]):hover': {
        background: 'transparent'
    }
};
var $89ec118b6543e1e2$var$subtleLinkStyles = {
    background: 'transparent',
    color: "var(--ds-text-subtle, #505258)",
    '&:hover': {
        background: 'transparent',
        color: "var(--ds-text-subtle, #505258)",
        textDecoration: 'underline'
    },
    '&:active': {
        background: 'transparent',
        color: "var(--ds-text, #292A2E)",
        textDecoration: 'underline'
    }
};
var $89ec118b6543e1e2$var$warningStyles = {
    background: "var(--ds-background-warning-bold, #FBC828)",
    color: "var(--ds-text-warning-inverse, #292A2E)",
    '&:hover': {
        background: "var(--ds-background-warning-bold-hovered, #FCA700)"
    },
    '&:active': {
        background: "var(--ds-background-warning-bold-pressed, #F68909)"
    },
    '&[data-has-overlay="true"]:not([disabled]):hover': {
        background: "var(--ds-background-warning-bold, #FBC828)"
    }
};
var $89ec118b6543e1e2$var$dangerStyles = {
    background: "var(--ds-background-danger-bold, #C9372C)",
    color: "var(--ds-text-inverse, #FFFFFF)",
    '&:hover': {
        background: "var(--ds-background-danger-bold-hovered, #AE2E24)"
    },
    '&:active': {
        background: "var(--ds-background-danger-bold-pressed, #872821)"
    },
    '&[data-has-overlay="true"]:not([disabled]):hover': {
        background: "var(--ds-background-danger-bold, #C9372C)"
    }
};
var $89ec118b6543e1e2$var$selectedStyles = {
    background: "var(--ds-background-selected, #E9F2FE)",
    color: "var(--ds-text-selected, #1868DB)",
    '&:not([disabled])::after': $89ec118b6543e1e2$var$_objectSpread($89ec118b6543e1e2$var$_objectSpread({}, $89ec118b6543e1e2$var$defaultAfterStyles), {}, {
        content: '""',
        borderColor: "var(--ds-border-selected, #1868DB)"
    })
};
var $89ec118b6543e1e2$var$hasOverlayStyles = {
    '&[data-has-overlay="true"]': {
        cursor: 'default',
        textDecoration: 'none'
    }
};
function $89ec118b6543e1e2$export$955358618f994a11(_ref) {
    var appearance = _ref.appearance, spacing = _ref.spacing, isSelected = _ref.isSelected, shouldFitContainer = _ref.shouldFitContainer, isOnlySingleIcon = _ref.isOnlySingleIcon;
    return $89ec118b6543e1e2$var$_objectSpread($89ec118b6543e1e2$var$_objectSpread({
        // 0px margin added to css-reset
        alignItems: 'baseline',
        borderWidth: 0,
        borderRadius: (0, $id6Cu.fg)('platform-dst-shape-theme-default') ? "var(--ds-radius-medium, 6px)" : "var(--ds-radius-small, 3px)",
        boxSizing: 'border-box',
        display: 'inline-flex',
        fontSize: 'inherit',
        fontStyle: 'normal',
        // Chrome recently changed button so that they use 'arial' as the font family
        fontFamily: 'inherit',
        fontWeight: "var(--ds-font-weight-medium, 500)",
        // margin for button has been applied to css reset
        maxWidth: '100%',
        // Needed to position overlay
        position: 'relative',
        textAlign: 'center',
        textDecoration: 'none',
        transition: 'background 0.1s ease-out, box-shadow 0.15s cubic-bezier(0.47, 0.03, 0.49, 1.38)',
        whiteSpace: 'nowrap',
        cursor: 'pointer',
        height: $89ec118b6543e1e2$var$heights[spacing],
        lineHeight: $89ec118b6543e1e2$var$lineHeights[spacing],
        padding: isOnlySingleIcon ? $89ec118b6543e1e2$var$singleIconPadding[spacing] : $89ec118b6543e1e2$var$padding[spacing],
        verticalAlign: $89ec118b6543e1e2$var$verticalAlign[spacing],
        width: shouldFitContainer ? '100%' : 'auto',
        // justifyContent required for shouldFitContainer buttons with an icon inside
        justifyContent: 'center'
    }, isSelected ? $89ec118b6543e1e2$var$selectedStyles : $89ec118b6543e1e2$var$_objectSpread($89ec118b6543e1e2$var$_objectSpread($89ec118b6543e1e2$var$_objectSpread($89ec118b6543e1e2$var$_objectSpread($89ec118b6543e1e2$var$_objectSpread($89ec118b6543e1e2$var$_objectSpread($89ec118b6543e1e2$var$_objectSpread($89ec118b6543e1e2$var$_objectSpread({}, appearance === 'default' && $89ec118b6543e1e2$var$defaultStyles), appearance === 'primary' && $89ec118b6543e1e2$var$primaryStyles), appearance === 'link' && $89ec118b6543e1e2$var$linkStyles), appearance === 'subtle' && $89ec118b6543e1e2$var$subtleStyles), appearance === 'subtle-link' && $89ec118b6543e1e2$var$subtleLinkStyles), appearance === 'warning' && $89ec118b6543e1e2$var$warningStyles), appearance === 'danger' && $89ec118b6543e1e2$var$dangerStyles), {}, {
        '&[disabled]': {
            color: "var(--ds-text-disabled, #080F214A)",
            backgroundColor: $89ec118b6543e1e2$var$HAS_DISABLED_BACKGROUND.includes(appearance) ? "var(--ds-background-disabled, #17171708)" : 'transparent',
            cursor: 'not-allowed',
            textDecoration: 'none',
            '&:hovered': {
                backgroundColor: $89ec118b6543e1e2$var$HAS_DISABLED_BACKGROUND.includes(appearance) ? "var(--ds-background-disabled, #17171708)" : 'transparent'
            },
            '&:active': {
                backgroundColor: $89ec118b6543e1e2$var$HAS_DISABLED_BACKGROUND.includes(appearance) ? "var(--ds-background-disabled, #17171708)" : 'transparent'
            }
        }
    }, $89ec118b6543e1e2$var$hasOverlayStyles)), {}, {
        '&::-moz-focus-inner': {
            border: 0,
            margin: 0,
            padding: 0
        }
    });
}
function $89ec118b6543e1e2$export$864eea3f4ec3368f(_ref2) {
    var spacing = _ref2.spacing;
    return (0, $74Zh5.css)({
        display: 'flex',
        // icon size cannot grow and shrink
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        margin: spacing === 'none' ? 0 : $89ec118b6543e1e2$var$innerMargin.icon,
        flexGrow: 0,
        flexShrink: 0,
        alignSelf: 'center',
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        fontSize: 0,
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        lineHeight: 0,
        userSelect: 'none'
    });
}
function $89ec118b6543e1e2$export$7ad0316cc0dd65a(_ref3) {
    var spacing = _ref3.spacing;
    return (0, $74Zh5.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        margin: spacing === 'none' ? 0 : $89ec118b6543e1e2$var$innerMargin.content,
        // content can grow and shrink
        flexGrow: 1,
        flexShrink: 1,
        // ellipsis for overflow text
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap'
    });
}
function $89ec118b6543e1e2$export$1b5827d324e945b1(_ref4) {
    var hasOverlay = _ref4.hasOverlay;
    return (0, $74Zh5.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        opacity: hasOverlay ? 0 : 1,
        transition: 'opacity 0.3s'
    });
}
var $89ec118b6543e1e2$export$1a9fe1b84c876bb5 = {
    // stretching to full width / height of button
    // this is important as we need it to still block
    // event if clicking in the button's own padding
    position: 'absolute',
    left: 0,
    top: 0,
    right: 0,
    bottom: 0,
    // Putting all children in the center
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
};



var $5FkrB = parcelRequire("5FkrB");
/* visually-hidden.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");
var $8056b266ab217caa$var$visuallyHiddenStyles = null;
/**
 * __Visually hidden__
 *
 * A composable element to apply a visually hidden effect to children.
 * Useful for accessibility compliance.
 *
 * @example
 * ```jsx
 * import VisuallyHidden from '@atlaskit/visually-hidden';
 *
 * export default () => (
 *   <div style={{ border: '1px solid black' }}>
 *      There is text hidden between the brackets [
 *      <VisuallyHidden>Can't see me!</VisuallyHidden>]
 *   </div>
 * );
 * ```
 */ var $8056b266ab217caa$var$VisuallyHidden = function VisuallyHidden(_ref) {
    var children = _ref.children, testId = _ref.testId, role = _ref.role, id = _ref.id;
    return /*#__PURE__*/ $5FkrB.createElement("span", {
        id: id,
        "data-testid": testId,
        role: role,
        className: (0, $970q7.default)([
            "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19itidpf _1reo15vq _18m915vq _1bsbt94y _4t3it94y _kqswstnw _ogto7mnp _uiztglyw _o5721q9c"
        ])
    }, children);
};
var $8056b266ab217caa$export$2e2bcd8739ae039 = $8056b266ab217caa$var$VisuallyHidden;


var $1b38ff268f8cb874$export$20bbd2efb0d734c4 = function getIfVisuallyHiddenChildren(children) {
    return children && /*#__PURE__*/ (0, $5FkrB.isValidElement)(children) && children.type === (0, $8056b266ab217caa$export$2e2bcd8739ae039);
};


var $8fd580ad0ac6b1f1$var$_excluded = [
    "analyticsContext",
    "appearance",
    "autoFocus",
    "buttonCss",
    "children",
    "className",
    "href",
    "component",
    "iconAfter",
    "iconBefore",
    "interactionName",
    "isDisabled",
    "isSelected",
    "onBlur",
    "onClick",
    "onFocus",
    "onMouseDown",
    "overlay",
    "shouldFitContainer",
    "spacing",
    "tabIndex",
    "type",
    "testId"
];
// Disabled buttons will still publish events for nested elements in webkit.
// We are disabling pointer events on child elements so that
// the button will always be the target of events
// Note: firefox does not have this behaviour for child elements
var $8fd580ad0ac6b1f1$var$noPointerEventsOnChildrenCss = {
    '> *': {
        pointerEvents: 'none'
    }
};
/**
 * These CSS variables consumed by the new icons, to allow them to have appropriate
 * padding inside Button while also maintaining spacing for the existing icons.
 *
 * These styles can be removed once the new icons are fully rolled out, feature flag
 * platform-visual-refresh-icons is cleaned up,
 * and we bump Button to set padding based on the new icons.
 */ var $8fd580ad0ac6b1f1$var$iconBeforeSpacingFixStyle = (0, $74Zh5.css)({
    '--ds--button--new-icon-padding-end': "var(--ds-space-025, 2px)",
    '--ds--button--new-icon-padding-start': "var(--ds-space-050, 4px)",
    marginInlineStart: "var(--ds-space-negative-025, -2px)"
});
var $8fd580ad0ac6b1f1$var$iconAfterSpacingFixStyle = (0, $74Zh5.css)({
    '--ds--button--new-icon-padding-end': "var(--ds-space-050, 4px)",
    '--ds--button--new-icon-padding-start': "var(--ds-space-025, 2px)",
    marginInlineEnd: "var(--ds-space-negative-025, -2px)"
});
var $8fd580ad0ac6b1f1$var$getSpacingFix = function getSpacingFix(children, spacingStyles) {
    if (!children || (0, $1b38ff268f8cb874$export$20bbd2efb0d734c4)(children)) return null;
    return spacingStyles;
};
var $8fd580ad0ac6b1f1$var$getChildren = function getChildren(children, childrenStyles) {
    if ((0, $1b38ff268f8cb874$export$20bbd2efb0d734c4)(children)) return children;
    return children ? (0, $74Zh5.jsx)("span", {
        css: childrenStyles
    }, children) : null;
};
var $8fd580ad0ac6b1f1$var$ButtonBase = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).forwardRef(function ButtonBase(props, ref) {
    var analyticsContext = props.analyticsContext, _props$appearance = props.appearance, appearance = _props$appearance === void 0 ? 'default' : _props$appearance, _props$autoFocus = props.autoFocus, autoFocus = _props$autoFocus === void 0 ? false : _props$autoFocus, buttonCss = props.buttonCss, children = props.children, className = props.className, href = props.href, _props$component = props.component, Component = _props$component === void 0 ? href ? 'a' : 'button' : _props$component, iconAfter = props.iconAfter, iconBefore = props.iconBefore, interactionName = props.interactionName, _props$isDisabled = props.isDisabled, isDisabled = _props$isDisabled === void 0 ? false : _props$isDisabled, _props$isSelected = props.isSelected, isSelected = _props$isSelected === void 0 ? false : _props$isSelected, onBlur = props.onBlur, _props$onClick = props.onClick, providedOnClick = _props$onClick === void 0 ? (0, $eVb4V.default) : _props$onClick, onFocus = props.onFocus, _props$onMouseDown = props.onMouseDown, providedOnMouseDown = _props$onMouseDown === void 0 ? (0, $eVb4V.default) : _props$onMouseDown, overlay = props.overlay, shouldFitContainer = props.shouldFitContainer, _props$spacing = props.spacing, spacing = _props$spacing === void 0 ? 'default' : _props$spacing, _props$tabIndex = props.tabIndex, tabIndex = _props$tabIndex === void 0 ? 0 : _props$tabIndex, _props$type = props.type, type = _props$type === void 0 ? !href ? 'button' : undefined : _props$type, testId = props.testId, rest = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(props, $8fd580ad0ac6b1f1$var$_excluded);
    var ourRef = (0, $5FkrB.useRef)();
    var setRef = (0, $5FkrB.useCallback)(function(node) {
        ourRef.current = node;
        if (ref == null) return;
        if (typeof ref === 'function') {
            ref(node);
            return;
        }
        // We can write to ref's `current` property, but Typescript does not like it.
        // @ts-ignore
        ref.current = node;
    }, [
        ourRef,
        ref
    ]);
    // Cross browser auto focusing is pretty broken, so we are doing it ourselves
    (0, $gpUQB.default)(ourRef, autoFocus);
    var interactionContext = (0, $5FkrB.useContext)((0, $eqVaP.default));
    var handleClick = (0, $5FkrB.useCallback)(function(e, analyticsEvent) {
        interactionContext && interactionContext.tracePress(interactionName, e.timeStamp);
        providedOnClick(e, analyticsEvent);
    }, [
        providedOnClick,
        interactionContext,
        interactionName
    ]);
    var onClick = (0, $9a80315d150981cc$export$a4687b0234b40e28)({
        fn: handleClick,
        action: 'clicked',
        componentName: 'button',
        packageName: "@atlaskit/button",
        packageVersion: "0.0.0-development",
        analyticsData: analyticsContext
    });
    // Button currently calls preventDefault, which is not standard button behaviour
    var onMouseDown = (0, $5FkrB.useCallback)(function(event) {
        event.preventDefault();
        providedOnMouseDown(event);
    }, [
        providedOnMouseDown
    ]);
    // Lose focus when becoming disabled (standard button behaviour)
    (0, $5FkrB.useEffect)(function() {
        var el = ourRef.current;
        if (isDisabled && el && el === document.activeElement) el.blur();
    }, [
        isDisabled
    ]);
    // we are 'disabling' input with a button when there is an overlay
    var hasOverlay = Boolean(overlay);
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    var fadeStyles = (0, $74Zh5.css)((0, $89ec118b6543e1e2$export$1b5827d324e945b1)({
        hasOverlay: hasOverlay
    }));
    var isInteractive = !isDisabled && !hasOverlay;
    /**
   * HACK: Spinner needs to have different colours in the "new" tokens design compared to the old design.
   * For now, while we support both, these styles reach into Spinner when a theme is set, applies the right color.
   * Ticket to remove: https://product-fabric.atlassian.net/browse/DSP-2067.
   */ var spinnerHackCss = {};
    if (isSelected || isDisabled || appearance === 'warning') spinnerHackCss = {
        '[data-theme] & circle': {
            stroke: "".concat(isSelected || isDisabled ? "var(--ds-icon-subtle, ".concat((0, $15d97c4884e4ca81$export$c39c0fe0f26207ae), ")") : "var(--ds-icon-warning-inverse, ".concat((0, $15d97c4884e4ca81$export$c39c0fe0f26207ae), ")"), " !important")
        }
    };
    return (0, $74Zh5.jsx)((0, $eYQvF.default), null, (0, $74Zh5.jsx)(Component, (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, rest, {
        ref: setRef,
        className: className,
        css: [
            buttonCss,
            isInteractive ? null : $8fd580ad0ac6b1f1$var$noPointerEventsOnChildrenCss
        ],
        "data-has-overlay": hasOverlay ? true : undefined,
        "data-testid": testId,
        disabled: isDisabled,
        href: isInteractive ? href : undefined,
        onBlur: onBlur,
        onClick: onClick,
        onFocus: onFocus,
        onMouseDown: onMouseDown,
        tabIndex: isDisabled ? -1 : tabIndex,
        type: type
    }, (0, $4060b3d9ebb9edae$export$2e2bcd8739ae039)({
        isInteractive: isInteractive
    })), iconBefore ? (0, $74Zh5.jsx)("span", {
        css: [
            fadeStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $89ec118b6543e1e2$export$864eea3f4ec3368f)({
                spacing: spacing
            }),
            $8fd580ad0ac6b1f1$var$getSpacingFix(children, $8fd580ad0ac6b1f1$var$iconBeforeSpacingFixStyle)
        ]
    }, iconBefore) : null, $8fd580ad0ac6b1f1$var$getChildren(children, [
        fadeStyles,
        (0, $89ec118b6543e1e2$export$7ad0316cc0dd65a)({
            spacing: spacing
        })
    ]), iconAfter ? (0, $74Zh5.jsx)("span", {
        css: [
            fadeStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $89ec118b6543e1e2$export$864eea3f4ec3368f)({
                spacing: spacing
            }),
            $8fd580ad0ac6b1f1$var$getSpacingFix(children, $8fd580ad0ac6b1f1$var$iconAfterSpacingFixStyle)
        ]
    }, iconAfter) : null, overlay ? (0, $74Zh5.jsx)("span", {
        css: [
            (0, $89ec118b6543e1e2$export$1a9fe1b84c876bb5),
            spinnerHackCss
        ]
    }, overlay) : null));
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$8fd580ad0ac6b1f1$export$2e2bcd8739ae039 = $8fd580ad0ac6b1f1$var$ButtonBase;




function $047c1d1af168b85e$export$2e2bcd8739ae039(_ref) {
    var children = _ref.children, iconBefore = _ref.iconBefore, iconAfter = _ref.iconAfter;
    if ((0, $1b38ff268f8cb874$export$20bbd2efb0d734c4)(children)) return true;
    if (children) return false;
    if (iconBefore && !iconAfter) return true;
    if (!iconBefore && iconAfter) return true;
    return false;
}


var $c3c8d096647b33a1$var$_excluded = [
    "appearance",
    "children",
    "iconBefore",
    "iconAfter",
    "isSelected",
    "onMouseDown",
    "onMouseUp",
    "shouldFitContainer",
    "spacing"
];
var $c3c8d096647b33a1$var$isFirefox = typeof navigator !== 'undefined' && navigator.userAgent.toLowerCase().indexOf('firefox') > -1;
/**
 * __Button__
 *
 * @deprecated Legacy buttons are deprecated and will be removed from `atlaskit/button` in an upcoming major release. Please use the new Button components from `@atlaskit/button/new`
 *
 * Please refer to the [migration guide](https://atlassian.design/components/button/button-legacy/migration-guide) for further details.
 *
 * A button triggers an event or action. They let users know what will happen next.
 *
 * - [Examples](https://atlassian.design/components/button/button-legacy/examples)
 * - [Code](https://atlassian.design/components/button/button-legacy/code)
 * - [Usage](https://atlassian.design/components/button/button-legacy/usage)
 */ var $c3c8d096647b33a1$var$Button = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).forwardRef(function Button(_ref, ref) {
    var _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'default' : _ref$appearance, children = _ref.children, iconBefore = _ref.iconBefore, iconAfter = _ref.iconAfter, _ref$isSelected = _ref.isSelected, isSelected = _ref$isSelected === void 0 ? false : _ref$isSelected, _ref$onMouseDown = _ref.onMouseDown, providedOnMouseDown = _ref$onMouseDown === void 0 ? (0, $eVb4V.default) : _ref$onMouseDown, _ref$onMouseUp = _ref.onMouseUp, providedOnMouseUp = _ref$onMouseUp === void 0 ? (0, $eVb4V.default) : _ref$onMouseUp, _ref$shouldFitContain = _ref.shouldFitContainer, shouldFitContainer = _ref$shouldFitContain === void 0 ? false : _ref$shouldFitContain, _ref$spacing = _ref.spacing, spacing = _ref$spacing === void 0 ? 'default' : _ref$spacing, rest = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $c3c8d096647b33a1$var$_excluded);
    var isOnlySingleIcon = (0, $047c1d1af168b85e$export$2e2bcd8739ae039)({
        children: children,
        iconBefore: iconBefore,
        iconAfter: iconAfter
    });
    var _useState = (0, $5FkrB.useState)(false), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), isActive = _useState2[0], setIsActive = _useState2[1];
    // Wrap onMouseDown / onMouseUp to manually trigger active state
    //  in Firefox
    var onMouseDown = (0, $5FkrB.useCallback)(function(event) {
        providedOnMouseDown(event);
        if ($c3c8d096647b33a1$var$isFirefox) setIsActive(true);
    }, [
        providedOnMouseDown,
        setIsActive
    ]);
    var onMouseUp = (0, $5FkrB.useCallback)(function(event) {
        providedOnMouseUp(event);
        if ($c3c8d096647b33a1$var$isFirefox) setIsActive(false);
    }, [
        providedOnMouseUp,
        setIsActive
    ]);
    var buttonCss = (0, $5FkrB.useMemo)(function() {
        return (0, $89ec118b6543e1e2$export$955358618f994a11)({
            appearance: appearance,
            spacing: spacing,
            isSelected: isSelected,
            shouldFitContainer: shouldFitContainer,
            isOnlySingleIcon: isOnlySingleIcon
        });
    }, [
        appearance,
        spacing,
        isSelected,
        shouldFitContainer,
        isOnlySingleIcon
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $8fd580ad0ac6b1f1$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, rest, {
        ref: ref,
        appearance: appearance,
        buttonCss: buttonCss,
        children: children,
        "data-firefox-is-active": isActive ? true : undefined,
        iconAfter: iconAfter,
        iconBefore: iconBefore,
        isSelected: isSelected,
        onMouseDown: onMouseDown,
        onMouseUp: onMouseUp,
        spacing: spacing
    }));
}));
// Tools including enzyme rely on components having a display name
$c3c8d096647b33a1$var$Button.displayName = 'Button';
var $c3c8d096647b33a1$export$2e2bcd8739ae039 = $c3c8d096647b33a1$var$Button;


var $kqp0i = parcelRequire("kqp0i");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");


var $5FkrB = parcelRequire("5FkrB");
/* spinner.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $970q7 = parcelRequire("970q7");

var $5FkrB = parcelRequire("5FkrB");

var $eqVaP = parcelRequire("eqVaP");
// Reds
var $cf32bd9b1ce11924$export$4b84fd0e2c617bd = '#FFEBE6';
var $cf32bd9b1ce11924$export$b34b069eff244586 = '#FFBDAD';
var $cf32bd9b1ce11924$export$be802dd0d8b57f35 = '#FF8F73';
var $cf32bd9b1ce11924$export$60847d42f9da92a6 = '#FF7452';
var $cf32bd9b1ce11924$export$4a7404f376229999 = '#FF5630';
var $cf32bd9b1ce11924$export$2010d0fb4295b346 = '#DE350B';
var $cf32bd9b1ce11924$export$2837b5a1a71d5c02 = '#BF2600';
var $cf32bd9b1ce11924$export$8d9596b529bbb9cf = '#FFFAE6';
var $cf32bd9b1ce11924$export$41060a744ab0b7ae = '#FFF0B3';
var $cf32bd9b1ce11924$export$1cc05bbbf340e559 = '#FFE380';
var $cf32bd9b1ce11924$export$5aae31392d72caaa = '#FFC400';
var $cf32bd9b1ce11924$export$c6930421db9fa514 = '#FFAB00';
var $cf32bd9b1ce11924$export$59619663aa6500fb = '#FF991F';
var $cf32bd9b1ce11924$export$874739ea9e379ab6 = '#FF8B00';
var $cf32bd9b1ce11924$export$8a6341c32b6a3ee6 = '#E3FCEF';
var $cf32bd9b1ce11924$export$69a3bf21b9686c2b = '#ABF5D1';
var $cf32bd9b1ce11924$export$afbce1382ec95f73 = '#79F2C0';
var $cf32bd9b1ce11924$export$747d86715d4175de = '#57D9A3';
var $cf32bd9b1ce11924$export$940e1f69e873f202 = '#36B37E';
var $cf32bd9b1ce11924$export$a49394138f7b8e85 = '#00875A';
var $cf32bd9b1ce11924$export$6fa04827ac68a4fb = '#006644';
var $cf32bd9b1ce11924$export$226de0355ed012f8 = '#DEEBFF';
var $cf32bd9b1ce11924$export$8c13c2ee36917869 = '#B3D4FF';
var $cf32bd9b1ce11924$export$ecfc1dff386a3e7a = '#4C9AFF';
var $cf32bd9b1ce11924$export$215b7063051591f1 = '#2684FF';
var $cf32bd9b1ce11924$export$e62e8919cca44969 = '#0065FF';
var $cf32bd9b1ce11924$export$b3de0ae08da2ce64 = '#0052CC';
var $cf32bd9b1ce11924$export$a6ee3d71bc067634 = '#0747A6';
var $cf32bd9b1ce11924$export$67f15409e87642a1 = '#669DF1';
var $cf32bd9b1ce11924$export$f0539dbc42dbb067 = '#8FB8F6';
var $cf32bd9b1ce11924$export$363e4475840015bb = '#EAE6FF';
var $cf32bd9b1ce11924$export$4b0a4417ed59760f = '#C0B6F2';
var $cf32bd9b1ce11924$export$6011520a64d9a187 = '#998DD9';
var $cf32bd9b1ce11924$export$a7175d4e9206bc80 = '#8777D9';
var $cf32bd9b1ce11924$export$b48405b95304b5a1 = '#6554C0';
var $cf32bd9b1ce11924$export$c71e4279dd54a18d = '#5243AA';
var $cf32bd9b1ce11924$export$147899de772240ec = '#403294';
var $cf32bd9b1ce11924$export$2cf711fe14c66f06 = '#E6FCFF';
var $cf32bd9b1ce11924$export$7a8f4d33f6f9772c = '#B3F5FF';
var $cf32bd9b1ce11924$export$776c9c497ef08533 = '#79E2F2';
var $cf32bd9b1ce11924$export$69cb3ca10c1e330e = '#00C7E6';
var $cf32bd9b1ce11924$export$9dc1ef0f3f48059b = '#00B8D9';
var $cf32bd9b1ce11924$export$7c835c78b6fcdef8 = '#00A3BF';
var $cf32bd9b1ce11924$export$6036577f95c3877e = '#008DA6';
var $cf32bd9b1ce11924$export$29a4f05edc054374 = '#FFFFFF';
var $cf32bd9b1ce11924$export$e655ef011c4aa1a2 = '#FAFBFC';
var $cf32bd9b1ce11924$export$9fdfb749e33cdf97 = '#F4F5F7';
var $cf32bd9b1ce11924$export$3e51e8f1440314ba = '#EBECF0';
var $cf32bd9b1ce11924$export$1ce2d1575d444ceb = '#DFE1E6';
var $cf32bd9b1ce11924$export$8754fc7e6d8b3000 = '#C1C7D0';
var $cf32bd9b1ce11924$export$c2e91cbeada39b8b = '#B3BAC5';
var $cf32bd9b1ce11924$export$5f71e19f3a7ad9de = '#A5ADBA';
var $cf32bd9b1ce11924$export$eaa8c8a70ac22806 = '#97A0AF';
var $cf32bd9b1ce11924$export$7c87d337fb91a97d = '#8993A4';
var $cf32bd9b1ce11924$export$d6447c357493214f = '#7A869A';
var $cf32bd9b1ce11924$export$f563ee71e9ee74cd = '#6B778C';
var $cf32bd9b1ce11924$export$e2ef2124cf4024b1 = '#5E6C84';
var $cf32bd9b1ce11924$export$eece5f492e429f08 = '#505F79';
var $cf32bd9b1ce11924$export$c39c0fe0f26207ae = '#42526E';
var $cf32bd9b1ce11924$export$7090862dc3038a9f = '#344563';
var $cf32bd9b1ce11924$export$ad0bacf983b7ddaa = '#253858';
var $cf32bd9b1ce11924$export$7d61b15e0da132af = '#172B4D';
var $cf32bd9b1ce11924$export$fbda843f0a27fe96 = '#091E42';
var $cf32bd9b1ce11924$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
var $cf32bd9b1ce11924$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
var $cf32bd9b1ce11924$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
var $cf32bd9b1ce11924$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
var $cf32bd9b1ce11924$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
var $cf32bd9b1ce11924$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
var $cf32bd9b1ce11924$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
var $cf32bd9b1ce11924$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
var $cf32bd9b1ce11924$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
var $cf32bd9b1ce11924$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
var $cf32bd9b1ce11924$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
var $cf32bd9b1ce11924$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
var $cf32bd9b1ce11924$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
var $cf32bd9b1ce11924$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
var $cf32bd9b1ce11924$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
var $cf32bd9b1ce11924$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
var $cf32bd9b1ce11924$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
var $cf32bd9b1ce11924$export$2f6319cf7d736c2a = '#E6EDFA';
var $cf32bd9b1ce11924$export$95126bc8884d6634 = '#DCE5F5';
var $cf32bd9b1ce11924$export$8338d8c35d44ff1 = '#CED9EB';
var $cf32bd9b1ce11924$export$5368d76ae4fbbda7 = '#B8C7E0';
var $cf32bd9b1ce11924$export$9f0a771d16ec8d36 = '#ABBBD6';
var $cf32bd9b1ce11924$export$abcf8c38338b4aa5 = '#9FB0CC';
var $cf32bd9b1ce11924$export$97e81faa16a182c7 = '#8C9CB8';
var $cf32bd9b1ce11924$export$bfe21c59123ecf33 = '#7988A3';
var $cf32bd9b1ce11924$export$ee82aa2ea6a1558 = '#67758F';
var $cf32bd9b1ce11924$export$682927c6ed76be02 = '#56637A';
var $cf32bd9b1ce11924$export$91fd9994c5be9757 = '#455166';
var $cf32bd9b1ce11924$export$d281fbfe3cff2df6 = '#3B475C';
var $cf32bd9b1ce11924$export$3902c91d8b98a753 = '#313D52';
var $cf32bd9b1ce11924$export$8e8133c1ba5845b5 = '#283447';
var $cf32bd9b1ce11924$export$33ff357f6620b39 = '#202B3D';
var $cf32bd9b1ce11924$export$633847cf062b69e0 = '#1B2638';
var $cf32bd9b1ce11924$export$9776a6e503bdbf76 = '#121A29';
var $cf32bd9b1ce11924$export$6c813d5160dff5db = '#0E1624';
var $cf32bd9b1ce11924$export$3d4f271a500072a = '#0D1424';
var $cf32bd9b1ce11924$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
var $cf32bd9b1ce11924$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
var $cf32bd9b1ce11924$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
var $cf32bd9b1ce11924$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
var $cf32bd9b1ce11924$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
var $cf32bd9b1ce11924$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
var $cf32bd9b1ce11924$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
var $cf32bd9b1ce11924$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
var $cf32bd9b1ce11924$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
var $cf32bd9b1ce11924$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
var $cf32bd9b1ce11924$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
var $cf32bd9b1ce11924$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
var $cf32bd9b1ce11924$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
var $cf32bd9b1ce11924$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
var $cf32bd9b1ce11924$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
var $cf32bd9b1ce11924$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
var $cf32bd9b1ce11924$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';
var $cf32bd9b1ce11924$export$d2adc5dedf09fced = '#292A2E';
var $cf32bd9b1ce11924$export$f51762073d2bb381 = '#94C748';
var $cf32bd9b1ce11924$export$95e26d54def96891 = '#B3DF72';


var $1821a492513e377b$export$4e9f1640bbe7a1a8 = {
    xsmall: 12,
    small: 16,
    medium: 24,
    large: 48,
    xlarge: 96
};


/**
 * Returns the appropriate circle stroke color.
 */ function $925729470282e6a4$var$getStrokeColor(appearance) {
    return appearance === 'inherit' ? "var(--ds-icon-subtle, ".concat((0, $cf32bd9b1ce11924$export$c39c0fe0f26207ae), ")") : "var(--ds-icon-inverse, ".concat((0, $cf32bd9b1ce11924$export$29a4f05edc054374), ")");
}
var $925729470282e6a4$var$rotate = null;
/**
 * There are three parts to the load in animation:
 * 1. Accelerated spin
 * 2. Stretch the spinner line
 */ var $925729470282e6a4$var$loadIn = null;
var $925729470282e6a4$var$styles = {
    rotateStyles: "_j7hqsf8s _5sag12kz _tip812c5 _1pgl2qsq _8hrz1h6o",
    loadInStyles: "_j7hq1ky6 _5sag9cwz _1pgl1ytf _1o51q7pw",
    wrapperStyles: "_1e0c116y _s7n4nkob",
    circleStyles: "_lswuglyw _7ljx1dhp _1snbbs82 _jcxd7g3v _1tjm1onz"
};
/**
 * `useLayoutEffect` is being used in SSR safe form. On the server, this work doesn’t need to run.
 * `useEffect` is used in-place, because `useEffect` is not run on the server and it matches types
 * which makes things simpler than doing an `isServer` check or a `null` check.
 *
 * @see https://hello.atlassian.net/wiki/spaces/DST/pages/2081696628/DSTDACI-010+-+Interaction+Tracing+hooks+in+DS+components
 */ var $925729470282e6a4$var$useLayoutEffect = typeof window === 'undefined' ? (0, $5FkrB.useEffect) : (0, $5FkrB.useLayoutEffect);
/**
 * __Spinner__
 *
 * A spinner is an animated spinning icon that lets users know content is being loaded.
 *
 * - [Examples](https://atlassian.design/components/spinner/examples)
 * - [Code](https://atlassian.design/components/spinner/code)
 * - [Usage](https://atlassian.design/components/spinner/usage)
 */ var $925729470282e6a4$var$Spinner = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).forwardRef(function Spinner(_ref, ref) {
    var _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'inherit' : _ref$appearance, _ref$delay = _ref.delay, delay = _ref$delay === void 0 ? 0 : _ref$delay, interactionName = _ref.interactionName, label = _ref.label, _ref$size = _ref.size, providedSize = _ref$size === void 0 ? 'medium' : _ref$size, testId = _ref.testId;
    var size = typeof providedSize === 'number' ? providedSize : (0, $1821a492513e377b$export$4e9f1640bbe7a1a8)[providedSize];
    var animationDelay = "".concat(delay, "ms");
    var stroke = $925729470282e6a4$var$getStrokeColor(appearance);
    var context = (0, $5FkrB.useContext)((0, $eqVaP.default));
    $925729470282e6a4$var$useLayoutEffect(function() {
        if (context != null) return context.hold(interactionName);
    }, [
        context,
        interactionName
    ]);
    /**
   * The Spinner animation uses a combination of two
   * css animations on two separate elements.
   */ return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("span", {
        "data-testid": testId ? "".concat(testId, "-wrapper") : 'spinner-wrapper',
        style: {
            animationDelay: animationDelay,
            width: size,
            height: size
        },
        className: (0, $970q7.default)([
            $925729470282e6a4$var$styles.wrapperStyles,
            $925729470282e6a4$var$styles.rotateStyles
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("svg", {
        height: size,
        width: size,
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg",
        "data-testid": testId,
        ref: ref,
        "aria-label": label || undefined,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            animationDelay: animationDelay
        },
        role: label ? 'img' : 'none',
        className: (0, $970q7.default)([
            $925729470282e6a4$var$styles.loadInStyles
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("circle", {
        cx: "8",
        cy: "8",
        r: "7",
        style: {
            stroke: stroke
        },
        className: (0, $970q7.default)([
            $925729470282e6a4$var$styles.circleStyles
        ])
    })));
}));
var $925729470282e6a4$export$2e2bcd8739ae039 = $925729470282e6a4$var$Spinner;


function $29683ff766e0a0aa$var$getSpinnerAppearance(_ref) {
    var appearance = _ref.appearance, isDisabled = _ref.isDisabled, isSelected = _ref.isSelected;
    if (isDisabled) return 'inherit';
    if (isSelected) return 'invert';
    if (appearance === 'primary' || appearance === 'danger') return 'invert';
    return 'inherit';
}
function $29683ff766e0a0aa$export$2e2bcd8739ae039(_ref2) {
    var appearance = _ref2.appearance, isDisabled = _ref2.isDisabled, isSelected = _ref2.isSelected, _ref2$spacing = _ref2.spacing, spacing = _ref2$spacing === void 0 ? 'default' : _ref2$spacing;
    var size = spacing === 'default' ? 'medium' : 'small';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $925729470282e6a4$export$2e2bcd8739ae039), {
        size: size,
        label: ", Loading",
        appearance: $29683ff766e0a0aa$var$getSpinnerAppearance({
            appearance: appearance,
            isDisabled: isDisabled,
            isSelected: isSelected
        })
    });
}


var $7fd47546053bbf00$var$_excluded = [
    "appearance",
    "isDisabled",
    "isSelected",
    "isLoading",
    "spacing"
];
/**
 * __Loading button__
 *
 * @deprecated Legacy loading buttons are deprecated and will be removed from `atlaskit/button` in an upcoming major release. Please use the new Button components from `@atlaskit/button/new` with the `isLoading` prop.
 *
 * Please refer to the [migration guide](https://atlassian.design/components/button/button-legacy/migration-guide) for further details.
 *
 * A small wrapper around Button that allows you to show an @atlaskit/spinner as an overlay on the button when you set an isLoading prop to true.
 *
 * - [Examples](https://atlassian.design/components/button/examples#loading-button)
 */ var $7fd47546053bbf00$var$LoadingButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).forwardRef(function LoadingButton(_ref, ref) {
    var appearance = _ref.appearance, isDisabled = _ref.isDisabled, isSelected = _ref.isSelected, _ref$isLoading = _ref.isLoading, isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading, spacing = _ref.spacing, rest = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $7fd47546053bbf00$var$_excluded);
    // Button already has React.memo, so just leaning on that
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $c3c8d096647b33a1$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, rest, {
        ref: ref,
        appearance: appearance,
        "aria-disabled": isLoading || undefined,
        isDisabled: isDisabled,
        isSelected: isSelected,
        overlay: isLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $29683ff766e0a0aa$export$2e2bcd8739ae039), {
            spacing: spacing,
            appearance: appearance,
            isDisabled: isDisabled,
            isSelected: isSelected
        }) : null,
        spacing: spacing
    }));
});
// Tools including enzyme rely on components having a display name
$7fd47546053bbf00$var$LoadingButton.displayName = 'LoadingButton';
var $7fd47546053bbf00$export$2e2bcd8739ae039 = $7fd47546053bbf00$var$LoadingButton;



var $QCI6S = parcelRequire("QCI6S");

var $1oVT1 = parcelRequire("1oVT1");

var $fC8ib = parcelRequire("fC8ib");

var $5FkrB = parcelRequire("5FkrB");

var $74Zh5 = parcelRequire("74Zh5");

var $fC8ib = parcelRequire("fC8ib");

var $25nEq = parcelRequire("25nEq");

var $iYJcE = parcelRequire("iYJcE");

var $ekGgq = parcelRequire("ekGgq");

var $74Zh5 = parcelRequire("74Zh5");

var $25nEq = parcelRequire("25nEq");

var $74Zh5 = parcelRequire("74Zh5");

function $d1c0a8e0523d7d45$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $d1c0a8e0523d7d45$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $d1c0a8e0523d7d45$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $d1c0a8e0523d7d45$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $d1c0a8e0523d7d45$export$6ccdbebca2ee545f = {
    '100%': '100%',
    'size.100': '1rem',
    'size.200': '1.5rem',
    'size.300': '2rem',
    'size.400': '2.5rem',
    'size.500': '3rem',
    'size.600': '6rem',
    'size.1000': '12rem'
};
var $d1c0a8e0523d7d45$export$958d0ae7f2977ae4 = {
    'space.0': "var(--ds-space-0, 0px)",
    'space.025': "var(--ds-space-025, 2px)",
    'space.050': "var(--ds-space-050, 4px)",
    'space.075': "var(--ds-space-075, 6px)",
    'space.100': "var(--ds-space-100, 8px)",
    'space.150': "var(--ds-space-150, 12px)",
    'space.200': "var(--ds-space-200, 16px)",
    'space.250': "var(--ds-space-250, 20px)",
    'space.300': "var(--ds-space-300, 24px)",
    'space.400': "var(--ds-space-400, 32px)",
    'space.500': "var(--ds-space-500, 40px)",
    'space.600': "var(--ds-space-600, 48px)",
    'space.800': "var(--ds-space-800, 64px)",
    'space.1000': "var(--ds-space-1000, 80px)"
};
var $d1c0a8e0523d7d45$export$d2dc61f58390201c = {
    'space.negative.025': "var(--ds-space-negative-025, -2px)",
    'space.negative.050': "var(--ds-space-negative-050, -4px)",
    'space.negative.075': "var(--ds-space-negative-075, -6px)",
    'space.negative.100': "var(--ds-space-negative-100, -8px)",
    'space.negative.150': "var(--ds-space-negative-150, -12px)",
    'space.negative.200': "var(--ds-space-negative-200, -16px)",
    'space.negative.250': "var(--ds-space-negative-250, -20px)",
    'space.negative.300': "var(--ds-space-negative-300, -24px)",
    'space.negative.400': "var(--ds-space-negative-400, -32px)"
};
var $d1c0a8e0523d7d45$export$632685d741f3dbbf = $d1c0a8e0523d7d45$var$_objectSpread($d1c0a8e0523d7d45$var$_objectSpread({}, $d1c0a8e0523d7d45$export$958d0ae7f2977ae4), $d1c0a8e0523d7d45$export$d2dc61f58390201c);
var $d1c0a8e0523d7d45$export$2185ce37f9bdd963 = {
    'color.background.neutral.bold': 'color.text.inverse',
    'color.background.neutral.bold.hovered': 'color.text.inverse',
    'color.background.neutral.bold.pressed': 'color.text.inverse',
    'color.background.selected.bold': 'color.text.inverse',
    'color.background.selected.bold.hovered': 'color.text.inverse',
    'color.background.selected.bold.pressed': 'color.text.inverse',
    'color.background.brand.bold': 'color.text.inverse',
    'color.background.brand.bold.hovered': 'color.text.inverse',
    'color.background.brand.bold.pressed': 'color.text.inverse',
    'color.background.brand.boldest': 'color.text.inverse',
    'color.background.brand.boldest.hovered': 'color.text.inverse',
    'color.background.brand.boldest.pressed': 'color.text.inverse',
    'color.background.danger.bold': 'color.text.inverse',
    'color.background.danger.bold.hovered': 'color.text.inverse',
    'color.background.danger.bold.pressed': 'color.text.inverse',
    'color.background.warning.bold': 'color.text.warning.inverse',
    'color.background.warning.bold.hovered': 'color.text.warning.inverse',
    'color.background.warning.bold.pressed': 'color.text.warning.inverse',
    'color.background.success.bold': 'color.text.inverse',
    'color.background.success.bold.hovered': 'color.text.inverse',
    'color.background.success.bold.pressed': 'color.text.inverse',
    'color.background.discovery.bold': 'color.text.inverse',
    'color.background.discovery.bold.hovered': 'color.text.inverse',
    'color.background.discovery.bold.pressed': 'color.text.inverse',
    'color.background.information.bold': 'color.text.inverse',
    'color.background.information.bold.hovered': 'color.text.inverse',
    'color.background.information.bold.pressed': 'color.text.inverse'
};
var $d1c0a8e0523d7d45$export$daf94a976c798b4f = {
    'opacity.disabled': "var(--ds-opacity-disabled, 0.4)",
    'opacity.loading': "var(--ds-opacity-loading, 0.2)"
};
var $d1c0a8e0523d7d45$export$7aff6e7ba39bb774 = {
    'elevation.shadow.overflow': "var(--ds-shadow-overflow, 0px 0px 8px #091e423f, 0px 0px 1px #091e424f)",
    'elevation.shadow.overflow.perimeter': "var(--ds-shadow-overflow-perimeter, #091e421f)",
    'elevation.shadow.overflow.spread': "var(--ds-shadow-overflow-spread, #091e4229)",
    'elevation.shadow.overlay': "var(--ds-shadow-overlay, 0px 8px 12px #091e423f, 0px 0px 1px #091e424f)",
    'elevation.shadow.raised': "var(--ds-shadow-raised, 0px 1px 1px #091e423f, 0px 0px 1px #091e4221)"
};
var $d1c0a8e0523d7d45$export$41a358c9c2356760 = {
    'elevation.surface': "var(--ds-surface, #FFFFFF)",
    'elevation.surface.hovered': "var(--ds-surface-hovered, #FAFBFC)",
    'elevation.surface.pressed': "var(--ds-surface-pressed, #F4F5F7)",
    'elevation.surface.overlay': "var(--ds-surface-overlay, #FFFFFF)",
    'elevation.surface.overlay.hovered': "var(--ds-surface-overlay-hovered, #FAFBFC)",
    'elevation.surface.overlay.pressed': "var(--ds-surface-overlay-pressed, #F4F5F7)",
    'elevation.surface.raised': "var(--ds-surface-raised, #FFFFFF)",
    'elevation.surface.raised.hovered': "var(--ds-surface-raised-hovered, #FAFBFC)",
    'elevation.surface.raised.pressed': "var(--ds-surface-raised-pressed, #F4F5F7)",
    'elevation.surface.sunken': "var(--ds-surface-sunken, #F4F5F7)"
};
var $d1c0a8e0523d7d45$export$1531ad5bb3fbedac = {
    'color.border': "var(--ds-border, #091e4221)",
    'color.border.accent.lime': "var(--ds-border-accent-lime, #6A9A23)",
    'color.border.accent.red': "var(--ds-border-accent-red, #FF5630)",
    'color.border.accent.orange': "var(--ds-border-accent-orange, #D94008)",
    'color.border.accent.yellow': "var(--ds-border-accent-yellow, #FFAB00)",
    'color.border.accent.green': "var(--ds-border-accent-green, #36B37E)",
    'color.border.accent.teal': "var(--ds-border-accent-teal, #00B8D9)",
    'color.border.accent.blue': "var(--ds-border-accent-blue, #0065FF)",
    'color.border.accent.purple': "var(--ds-border-accent-purple, #6554C0)",
    'color.border.accent.magenta': "var(--ds-border-accent-magenta, #CD519D)",
    'color.border.accent.gray': "var(--ds-border-accent-gray, #5E6C84)",
    'color.border.disabled': "var(--ds-border-disabled, #FAFBFC)",
    'color.border.focused': "var(--ds-border-focused, #2684FF)",
    'color.border.input': "var(--ds-border-input, #FAFBFC)",
    'color.border.inverse': "var(--ds-border-inverse, #FFFFFF)",
    'color.border.selected': "var(--ds-border-selected, #0052CC)",
    'color.border.brand': "var(--ds-border-brand, #0052CC)",
    'color.border.danger': "var(--ds-border-danger, #FF5630)",
    'color.border.warning': "var(--ds-border-warning, #FFC400)",
    'color.border.success': "var(--ds-border-success, #00875A)",
    'color.border.discovery': "var(--ds-border-discovery, #998DD9)",
    'color.border.information': "var(--ds-border-information, #0065FF)",
    'color.border.bold': "var(--ds-border-bold, #344563)"
};
var $d1c0a8e0523d7d45$export$d1d79bf68ac056bd = {
    'color.background.accent.lime.subtlest': "var(--ds-background-accent-lime-subtlest, #EEFBDA)",
    'color.background.accent.lime.subtlest.hovered': "var(--ds-background-accent-lime-subtlest-hovered, #D3F1A7)",
    'color.background.accent.lime.subtlest.pressed': "var(--ds-background-accent-lime-subtlest-pressed, #B3DF72)",
    'color.background.accent.lime.subtler': "var(--ds-background-accent-lime-subtler, #D3F1A7)",
    'color.background.accent.lime.subtler.hovered': "var(--ds-background-accent-lime-subtler-hovered, #B3DF72)",
    'color.background.accent.lime.subtler.pressed': "var(--ds-background-accent-lime-subtler-pressed, #94C748)",
    'color.background.accent.lime.subtle': "var(--ds-background-accent-lime-subtle, #94C748)",
    'color.background.accent.lime.subtle.hovered': "var(--ds-background-accent-lime-subtle-hovered, #B3DF72)",
    'color.background.accent.lime.subtle.pressed': "var(--ds-background-accent-lime-subtle-pressed, #D3F1A7)",
    'color.background.accent.lime.bolder': "var(--ds-background-accent-lime-bolder, #5B7F24)",
    'color.background.accent.lime.bolder.hovered': "var(--ds-background-accent-lime-bolder-hovered, #37471F)",
    'color.background.accent.lime.bolder.pressed': "var(--ds-background-accent-lime-bolder-pressed, #37471F)",
    'color.background.accent.red.subtlest': "var(--ds-background-accent-red-subtlest, #FF8F73)",
    'color.background.accent.red.subtlest.hovered': "var(--ds-background-accent-red-subtlest-hovered, #FF7452)",
    'color.background.accent.red.subtlest.pressed': "var(--ds-background-accent-red-subtlest-pressed, #FF5630)",
    'color.background.accent.red.subtler': "var(--ds-background-accent-red-subtler, #FF7452)",
    'color.background.accent.red.subtler.hovered': "var(--ds-background-accent-red-subtler-hovered, #FF5630)",
    'color.background.accent.red.subtler.pressed': "var(--ds-background-accent-red-subtler-pressed, #DE350B)",
    'color.background.accent.red.subtle': "var(--ds-background-accent-red-subtle, #DE350B)",
    'color.background.accent.red.subtle.hovered': "var(--ds-background-accent-red-subtle-hovered, #FF5630)",
    'color.background.accent.red.subtle.pressed': "var(--ds-background-accent-red-subtle-pressed, #FF7452)",
    'color.background.accent.red.bolder': "var(--ds-background-accent-red-bolder, #DE350B)",
    'color.background.accent.red.bolder.hovered': "var(--ds-background-accent-red-bolder-hovered, #FF5630)",
    'color.background.accent.red.bolder.pressed': "var(--ds-background-accent-red-bolder-pressed, #FF7452)",
    'color.background.accent.orange.subtlest': "var(--ds-background-accent-orange-subtlest, #F18D13)",
    'color.background.accent.orange.subtlest.hovered': "var(--ds-background-accent-orange-subtlest-hovered, #FEC57B)",
    'color.background.accent.orange.subtlest.pressed': "var(--ds-background-accent-orange-subtlest-pressed, #FFE2BD)",
    'color.background.accent.orange.subtler': "var(--ds-background-accent-orange-subtler, #B65C02)",
    'color.background.accent.orange.subtler.hovered': "var(--ds-background-accent-orange-subtler-hovered, #F18D13)",
    'color.background.accent.orange.subtler.pressed': "var(--ds-background-accent-orange-subtler-pressed, #FEC57B)",
    'color.background.accent.orange.subtle': "var(--ds-background-accent-orange-subtle, #5F3811)",
    'color.background.accent.orange.subtle.hovered': "var(--ds-background-accent-orange-subtle-hovered, #974F0C)",
    'color.background.accent.orange.subtle.pressed': "var(--ds-background-accent-orange-subtle-pressed, #B65C02)",
    'color.background.accent.orange.bolder': "var(--ds-background-accent-orange-bolder, #43290F)",
    'color.background.accent.orange.bolder.hovered': "var(--ds-background-accent-orange-bolder-hovered, #5F3811)",
    'color.background.accent.orange.bolder.pressed': "var(--ds-background-accent-orange-bolder-pressed, #974F0C)",
    'color.background.accent.yellow.subtlest': "var(--ds-background-accent-yellow-subtlest, #FFE380)",
    'color.background.accent.yellow.subtlest.hovered': "var(--ds-background-accent-yellow-subtlest-hovered, #FFC400)",
    'color.background.accent.yellow.subtlest.pressed': "var(--ds-background-accent-yellow-subtlest-pressed, #FFAB00)",
    'color.background.accent.yellow.subtler': "var(--ds-background-accent-yellow-subtler, #FFC400)",
    'color.background.accent.yellow.subtler.hovered': "var(--ds-background-accent-yellow-subtler-hovered, #FFAB00)",
    'color.background.accent.yellow.subtler.pressed': "var(--ds-background-accent-yellow-subtler-pressed, #FF991F)",
    'color.background.accent.yellow.subtle': "var(--ds-background-accent-yellow-subtle, #FF991F)",
    'color.background.accent.yellow.subtle.hovered': "var(--ds-background-accent-yellow-subtle-hovered, #FFAB00)",
    'color.background.accent.yellow.subtle.pressed': "var(--ds-background-accent-yellow-subtle-pressed, #FFC400)",
    'color.background.accent.yellow.bolder': "var(--ds-background-accent-yellow-bolder, #FF991F)",
    'color.background.accent.yellow.bolder.hovered': "var(--ds-background-accent-yellow-bolder-hovered, #FFAB00)",
    'color.background.accent.yellow.bolder.pressed': "var(--ds-background-accent-yellow-bolder-pressed, #FFC400)",
    'color.background.accent.green.subtlest': "var(--ds-background-accent-green-subtlest, #79F2C0)",
    'color.background.accent.green.subtlest.hovered': "var(--ds-background-accent-green-subtlest-hovered, #57D9A3)",
    'color.background.accent.green.subtlest.pressed': "var(--ds-background-accent-green-subtlest-pressed, #36B37E)",
    'color.background.accent.green.subtler': "var(--ds-background-accent-green-subtler, #57D9A3)",
    'color.background.accent.green.subtler.hovered': "var(--ds-background-accent-green-subtler-hovered, #36B37E)",
    'color.background.accent.green.subtler.pressed': "var(--ds-background-accent-green-subtler-pressed, #00875A)",
    'color.background.accent.green.subtle': "var(--ds-background-accent-green-subtle, #00875A)",
    'color.background.accent.green.subtle.hovered': "var(--ds-background-accent-green-subtle-hovered, #36B37E)",
    'color.background.accent.green.subtle.pressed': "var(--ds-background-accent-green-subtle-pressed, #57D9A3)",
    'color.background.accent.green.bolder': "var(--ds-background-accent-green-bolder, #00875A)",
    'color.background.accent.green.bolder.hovered': "var(--ds-background-accent-green-bolder-hovered, #36B37E)",
    'color.background.accent.green.bolder.pressed': "var(--ds-background-accent-green-bolder-pressed, #57D9A3)",
    'color.background.accent.teal.subtlest': "var(--ds-background-accent-teal-subtlest, #79E2F2)",
    'color.background.accent.teal.subtlest.hovered': "var(--ds-background-accent-teal-subtlest-hovered, #00C7E6)",
    'color.background.accent.teal.subtlest.pressed': "var(--ds-background-accent-teal-subtlest-pressed, #00B8D9)",
    'color.background.accent.teal.subtler': "var(--ds-background-accent-teal-subtler, #00C7E6)",
    'color.background.accent.teal.subtler.hovered': "var(--ds-background-accent-teal-subtler-hovered, #00B8D9)",
    'color.background.accent.teal.subtler.pressed': "var(--ds-background-accent-teal-subtler-pressed, #00A3BF)",
    'color.background.accent.teal.subtle': "var(--ds-background-accent-teal-subtle, #00A3BF)",
    'color.background.accent.teal.subtle.hovered': "var(--ds-background-accent-teal-subtle-hovered, #00B8D9)",
    'color.background.accent.teal.subtle.pressed': "var(--ds-background-accent-teal-subtle-pressed, #00C7E6)",
    'color.background.accent.teal.bolder': "var(--ds-background-accent-teal-bolder, #00A3BF)",
    'color.background.accent.teal.bolder.hovered': "var(--ds-background-accent-teal-bolder-hovered, #00B8D9)",
    'color.background.accent.teal.bolder.pressed': "var(--ds-background-accent-teal-bolder-pressed, #00C7E6)",
    'color.background.accent.blue.subtlest': "var(--ds-background-accent-blue-subtlest, #4C9AFF)",
    'color.background.accent.blue.subtlest.hovered': "var(--ds-background-accent-blue-subtlest-hovered, #2684FF)",
    'color.background.accent.blue.subtlest.pressed': "var(--ds-background-accent-blue-subtlest-pressed, #0065FF)",
    'color.background.accent.blue.subtler': "var(--ds-background-accent-blue-subtler, #2684FF)",
    'color.background.accent.blue.subtler.hovered': "var(--ds-background-accent-blue-subtler-hovered, #0065FF)",
    'color.background.accent.blue.subtler.pressed': "var(--ds-background-accent-blue-subtler-pressed, #0052CC)",
    'color.background.accent.blue.subtle': "var(--ds-background-accent-blue-subtle, #0052CC)",
    'color.background.accent.blue.subtle.hovered': "var(--ds-background-accent-blue-subtle-hovered, #0065FF)",
    'color.background.accent.blue.subtle.pressed': "var(--ds-background-accent-blue-subtle-pressed, #2684FF)",
    'color.background.accent.blue.bolder': "var(--ds-background-accent-blue-bolder, #0052CC)",
    'color.background.accent.blue.bolder.hovered': "var(--ds-background-accent-blue-bolder-hovered, #0065FF)",
    'color.background.accent.blue.bolder.pressed': "var(--ds-background-accent-blue-bolder-pressed, #2684FF)",
    'color.background.accent.purple.subtlest': "var(--ds-background-accent-purple-subtlest, #998DD9)",
    'color.background.accent.purple.subtlest.hovered': "var(--ds-background-accent-purple-subtlest-hovered, #8777D9)",
    'color.background.accent.purple.subtlest.pressed': "var(--ds-background-accent-purple-subtlest-pressed, #6554C0)",
    'color.background.accent.purple.subtler': "var(--ds-background-accent-purple-subtler, #8777D9)",
    'color.background.accent.purple.subtler.hovered': "var(--ds-background-accent-purple-subtler-hovered, #6554C0)",
    'color.background.accent.purple.subtler.pressed': "var(--ds-background-accent-purple-subtler-pressed, #5243AA)",
    'color.background.accent.purple.subtle': "var(--ds-background-accent-purple-subtle, #5243AA)",
    'color.background.accent.purple.subtle.hovered': "var(--ds-background-accent-purple-subtle-hovered, #6554C0)",
    'color.background.accent.purple.subtle.pressed': "var(--ds-background-accent-purple-subtle-pressed, #8777D9)",
    'color.background.accent.purple.bolder': "var(--ds-background-accent-purple-bolder, #5243AA)",
    'color.background.accent.purple.bolder.hovered': "var(--ds-background-accent-purple-bolder-hovered, #6554C0)",
    'color.background.accent.purple.bolder.pressed': "var(--ds-background-accent-purple-bolder-pressed, #8777D9)",
    'color.background.accent.magenta.subtlest': "var(--ds-background-accent-magenta-subtlest, #FFECF8)",
    'color.background.accent.magenta.subtlest.hovered': "var(--ds-background-accent-magenta-subtlest-hovered, #FDD0EC)",
    'color.background.accent.magenta.subtlest.pressed': "var(--ds-background-accent-magenta-subtlest-pressed, #F797D2)",
    'color.background.accent.magenta.subtler': "var(--ds-background-accent-magenta-subtler, #FDD0EC)",
    'color.background.accent.magenta.subtler.hovered': "var(--ds-background-accent-magenta-subtler-hovered, #F797D2)",
    'color.background.accent.magenta.subtler.pressed': "var(--ds-background-accent-magenta-subtler-pressed, #E774BB)",
    'color.background.accent.magenta.subtle': "var(--ds-background-accent-magenta-subtle, #E774BB)",
    'color.background.accent.magenta.subtle.hovered': "var(--ds-background-accent-magenta-subtle-hovered, #F797D2)",
    'color.background.accent.magenta.subtle.pressed': "var(--ds-background-accent-magenta-subtle-pressed, #FDD0EC)",
    'color.background.accent.magenta.bolder': "var(--ds-background-accent-magenta-bolder, #AE4787)",
    'color.background.accent.magenta.bolder.hovered': "var(--ds-background-accent-magenta-bolder-hovered, #943D73)",
    'color.background.accent.magenta.bolder.pressed': "var(--ds-background-accent-magenta-bolder-pressed, #50253F)",
    'color.background.accent.gray.subtlest': "var(--ds-background-accent-gray-subtlest, #6B778C)",
    'color.background.accent.gray.subtlest.hovered': "var(--ds-background-accent-gray-subtlest-hovered, #5E6C84)",
    'color.background.accent.gray.subtlest.pressed': "var(--ds-background-accent-gray-subtlest-pressed, #505F79)",
    'color.background.accent.gray.subtler': "var(--ds-background-accent-gray-subtler, #5E6C84)",
    'color.background.accent.gray.subtler.hovered': "var(--ds-background-accent-gray-subtler-hovered, #505F79)",
    'color.background.accent.gray.subtler.pressed': "var(--ds-background-accent-gray-subtler-pressed, #42526E)",
    'color.background.accent.gray.subtle': "var(--ds-background-accent-gray-subtle, #505F79)",
    'color.background.accent.gray.subtle.hovered': "var(--ds-background-accent-gray-subtle-hovered, #5E6C84)",
    'color.background.accent.gray.subtle.pressed': "var(--ds-background-accent-gray-subtle-pressed, #6B778C)",
    'color.background.accent.gray.bolder': "var(--ds-background-accent-gray-bolder, #42526E)",
    'color.background.accent.gray.bolder.hovered': "var(--ds-background-accent-gray-bolder-hovered, #344563)",
    'color.background.accent.gray.bolder.pressed': "var(--ds-background-accent-gray-bolder-pressed, #253858)",
    'color.background.disabled': "var(--ds-background-disabled, #091e4289)",
    'color.background.input': "var(--ds-background-input, #FAFBFC)",
    'color.background.input.hovered': "var(--ds-background-input-hovered, #EBECF0)",
    'color.background.input.pressed': "var(--ds-background-input-pressed, #FFFFFF)",
    'color.background.inverse.subtle': "var(--ds-background-inverse-subtle, #00000029)",
    'color.background.inverse.subtle.hovered': "var(--ds-background-inverse-subtle-hovered, #0000003D)",
    'color.background.inverse.subtle.pressed': "var(--ds-background-inverse-subtle-pressed, #00000052)",
    'color.background.neutral': "var(--ds-background-neutral, #DFE1E6)",
    'color.background.neutral.hovered': "var(--ds-background-neutral-hovered, #091e4214)",
    'color.background.neutral.pressed': "var(--ds-background-neutral-pressed, #B3D4FF)",
    'color.background.neutral.subtle': "var(--ds-background-neutral-subtle, transparent)",
    'color.background.neutral.subtle.hovered': "var(--ds-background-neutral-subtle-hovered, #091e4214)",
    'color.background.neutral.subtle.pressed': "var(--ds-background-neutral-subtle-pressed, #B3D4FF)",
    'color.background.neutral.bold': "var(--ds-background-neutral-bold, #42526E)",
    'color.background.neutral.bold.hovered': "var(--ds-background-neutral-bold-hovered, #505F79)",
    'color.background.neutral.bold.pressed': "var(--ds-background-neutral-bold-pressed, #344563)",
    'color.background.selected': "var(--ds-background-selected, #DEEBFF)",
    'color.background.selected.hovered': "var(--ds-background-selected-hovered, #B3D4FF)",
    'color.background.selected.pressed': "var(--ds-background-selected-pressed, #4C9AFF)",
    'color.background.selected.bold': "var(--ds-background-selected-bold, #0052CC)",
    'color.background.selected.bold.hovered': "var(--ds-background-selected-bold-hovered, #2684FF)",
    'color.background.selected.bold.pressed': "var(--ds-background-selected-bold-pressed, #0052CC)",
    'color.background.brand.subtlest': "var(--ds-background-brand-subtlest, #B3D4FF)",
    'color.background.brand.subtlest.hovered': "var(--ds-background-brand-subtlest-hovered, #DEEBFF)",
    'color.background.brand.subtlest.pressed': "var(--ds-background-brand-subtlest-pressed, #4C9AFF)",
    'color.background.brand.bold': "var(--ds-background-brand-bold, #0052CC)",
    'color.background.brand.bold.hovered': "var(--ds-background-brand-bold-hovered, #0065FF)",
    'color.background.brand.bold.pressed': "var(--ds-background-brand-bold-pressed, #0747A6)",
    'color.background.brand.boldest': "var(--ds-background-brand-boldest, #0747A6)",
    'color.background.brand.boldest.hovered': "var(--ds-background-brand-boldest-hovered, #0052CC)",
    'color.background.brand.boldest.pressed': "var(--ds-background-brand-boldest-pressed, #0747A6)",
    'color.background.danger': "var(--ds-background-danger, #FFEBE6)",
    'color.background.danger.hovered': "var(--ds-background-danger-hovered, #FFBDAD)",
    'color.background.danger.pressed': "var(--ds-background-danger-pressed, #FF8F73)",
    'color.background.danger.bold': "var(--ds-background-danger-bold, #DE350B)",
    'color.background.danger.bold.hovered': "var(--ds-background-danger-bold-hovered, #FF5630)",
    'color.background.danger.bold.pressed': "var(--ds-background-danger-bold-pressed, #BF2600)",
    'color.background.warning': "var(--ds-background-warning, #FFFAE6)",
    'color.background.warning.hovered': "var(--ds-background-warning-hovered, #FFF0B3)",
    'color.background.warning.pressed': "var(--ds-background-warning-pressed, #FFE380)",
    'color.background.warning.bold': "var(--ds-background-warning-bold, #FFAB00)",
    'color.background.warning.bold.hovered': "var(--ds-background-warning-bold-hovered, #FFC400)",
    'color.background.warning.bold.pressed': "var(--ds-background-warning-bold-pressed, #FF991F)",
    'color.background.success': "var(--ds-background-success, #E3FCEF)",
    'color.background.success.hovered': "var(--ds-background-success-hovered, #ABF5D1)",
    'color.background.success.pressed': "var(--ds-background-success-pressed, #79F2C0)",
    'color.background.success.bold': "var(--ds-background-success-bold, #00875A)",
    'color.background.success.bold.hovered': "var(--ds-background-success-bold-hovered, #57D9A3)",
    'color.background.success.bold.pressed': "var(--ds-background-success-bold-pressed, #00875A)",
    'color.background.discovery': "var(--ds-background-discovery, #EAE6FF)",
    'color.background.discovery.hovered': "var(--ds-background-discovery-hovered, #C0B6F2)",
    'color.background.discovery.pressed': "var(--ds-background-discovery-pressed, #998DD9)",
    'color.background.discovery.bold': "var(--ds-background-discovery-bold, #5243AA)",
    'color.background.discovery.bold.hovered': "var(--ds-background-discovery-bold-hovered, #8777D9)",
    'color.background.discovery.bold.pressed': "var(--ds-background-discovery-bold-pressed, #5243AA)",
    'color.background.information': "var(--ds-background-information, #DEEBFF)",
    'color.background.information.hovered': "var(--ds-background-information-hovered, #B3D4FF)",
    'color.background.information.pressed': "var(--ds-background-information-pressed, #4C9AFF)",
    'color.background.information.bold': "var(--ds-background-information-bold, #0052CC)",
    'color.background.information.bold.hovered': "var(--ds-background-information-bold-hovered, #2684FF)",
    'color.background.information.bold.pressed': "var(--ds-background-information-bold-pressed, #0052CC)",
    'color.blanket': "var(--ds-blanket, #091e4289)",
    'color.blanket.selected': "var(--ds-blanket-selected, #388BFF14)",
    'color.blanket.danger': "var(--ds-blanket-danger, #EF5C4814)",
    'elevation.surface': "var(--ds-surface, #FFFFFF)",
    'elevation.surface.hovered': "var(--ds-surface-hovered, #FAFBFC)",
    'elevation.surface.pressed': "var(--ds-surface-pressed, #F4F5F7)",
    'elevation.surface.overlay': "var(--ds-surface-overlay, #FFFFFF)",
    'elevation.surface.overlay.hovered': "var(--ds-surface-overlay-hovered, #FAFBFC)",
    'elevation.surface.overlay.pressed': "var(--ds-surface-overlay-pressed, #F4F5F7)",
    'elevation.surface.raised': "var(--ds-surface-raised, #FFFFFF)",
    'elevation.surface.raised.hovered': "var(--ds-surface-raised-hovered, #FAFBFC)",
    'elevation.surface.raised.pressed': "var(--ds-surface-raised-pressed, #F4F5F7)",
    'elevation.surface.sunken': "var(--ds-surface-sunken, #F4F5F7)",
    'utility.elevation.surface.current': "var(--ds-elevation-surface-current, #FFFFFF)"
};
var $d1c0a8e0523d7d45$export$8473307aa00d6ea1 = {
    'color.text': "var(--ds-text, #172B4D)",
    'color.text.accent.lime': "var(--ds-text-accent-lime, #4C6B1F)",
    'color.text.accent.lime.bolder': "var(--ds-text-accent-lime-bolder, #37471F)",
    'color.text.accent.red': "var(--ds-text-accent-red, #DE350B)",
    'color.text.accent.red.bolder': "var(--ds-text-accent-red-bolder, #BF2600)",
    'color.text.accent.orange': "var(--ds-text-accent-orange, #F18D13)",
    'color.text.accent.orange.bolder': "var(--ds-text-accent-orange-bolder, #B65C02)",
    'color.text.accent.yellow': "var(--ds-text-accent-yellow, #FF991F)",
    'color.text.accent.yellow.bolder': "var(--ds-text-accent-yellow-bolder, #FF8B00)",
    'color.text.accent.green': "var(--ds-text-accent-green, #00875A)",
    'color.text.accent.green.bolder': "var(--ds-text-accent-green-bolder, #006644)",
    'color.text.accent.teal': "var(--ds-text-accent-teal, #00A3BF)",
    'color.text.accent.teal.bolder': "var(--ds-text-accent-teal-bolder, #008DA6)",
    'color.text.accent.blue': "var(--ds-text-accent-blue, #0052CC)",
    'color.text.accent.blue.bolder': "var(--ds-text-accent-blue-bolder, #0747A6)",
    'color.text.accent.purple': "var(--ds-text-accent-purple, #5243AA)",
    'color.text.accent.purple.bolder': "var(--ds-text-accent-purple-bolder, #403294)",
    'color.text.accent.magenta': "var(--ds-text-accent-magenta, #E774BB)",
    'color.text.accent.magenta.bolder': "var(--ds-text-accent-magenta-bolder, #DA62AC)",
    'color.text.accent.gray': "var(--ds-text-accent-gray, #505F79)",
    'color.text.accent.gray.bolder': "var(--ds-text-accent-gray-bolder, #172B4D)",
    'color.text.disabled': "var(--ds-text-disabled, #A5ADBA)",
    'color.text.inverse': "var(--ds-text-inverse, #FFFFFF)",
    'color.text.selected': "var(--ds-text-selected, #0052CC)",
    'color.text.brand': "var(--ds-text-brand, #0065FF)",
    'color.text.danger': "var(--ds-text-danger, #DE350B)",
    'color.text.warning': "var(--ds-text-warning, #974F0C)",
    'color.text.warning.inverse': "var(--ds-text-warning-inverse, #172B4D)",
    'color.text.success': "var(--ds-text-success, #006644)",
    'color.text.discovery': "var(--ds-text-discovery, #403294)",
    'color.text.information': "var(--ds-text-information, #0052CC)",
    'color.text.subtlest': "var(--ds-text-subtlest, #7A869A)",
    'color.text.subtle': "var(--ds-text-subtle, #42526E)",
    'color.link': "var(--ds-link, #0052CC)",
    'color.link.pressed': "var(--ds-link-pressed, #0747A6)",
    'color.link.visited': "var(--ds-link-visited, #403294)",
    'color.link.visited.pressed': "var(--ds-link-visited-pressed, #403294)"
};
var $d1c0a8e0523d7d45$export$498780f74be9af68 = {
    'color.icon': "var(--ds-icon, #505F79)",
    'color.icon.accent.lime': "var(--ds-icon-accent-lime, #6A9A23)",
    'color.icon.accent.red': "var(--ds-icon-accent-red, #FF5630)",
    'color.icon.accent.orange': "var(--ds-icon-accent-orange, #D94008)",
    'color.icon.accent.yellow': "var(--ds-icon-accent-yellow, #FFAB00)",
    'color.icon.accent.green': "var(--ds-icon-accent-green, #36B37E)",
    'color.icon.accent.teal': "var(--ds-icon-accent-teal, #00B8D9)",
    'color.icon.accent.blue': "var(--ds-icon-accent-blue, #0065FF)",
    'color.icon.accent.purple': "var(--ds-icon-accent-purple, #6554C0)",
    'color.icon.accent.magenta': "var(--ds-icon-accent-magenta, #CD519D)",
    'color.icon.accent.gray': "var(--ds-icon-accent-gray, #5E6C84)",
    'color.icon.disabled': "var(--ds-icon-disabled, #8993A4)",
    'color.icon.inverse': "var(--ds-icon-inverse, #FFFFFF)",
    'color.icon.selected': "var(--ds-icon-selected, #0052CC)",
    'color.icon.brand': "var(--ds-icon-brand, #0065FF)",
    'color.icon.danger': "var(--ds-icon-danger, #DE350B)",
    'color.icon.warning': "var(--ds-icon-warning, #FFC400)",
    'color.icon.warning.inverse': "var(--ds-icon-warning-inverse, #253858)",
    'color.icon.success': "var(--ds-icon-success, #00875A)",
    'color.icon.discovery': "var(--ds-icon-discovery, #8777D9)",
    'color.icon.information': "var(--ds-icon-information, #0747A6)",
    'color.icon.subtle': "var(--ds-icon-subtle, #6B778C)"
};
var $d1c0a8e0523d7d45$export$b5f31a7e431d2eab = {
    card: 100,
    navigation: 200,
    dialog: 300,
    layer: 400,
    blanket: 500,
    modal: 510,
    flag: 600,
    spotlight: 700,
    tooltip: 800
};
var $d1c0a8e0523d7d45$export$e1b83c5210c471b8 = {
    'border.width': "var(--ds-border-width, 1px)",
    'border.width.0': "var(--ds-border-width-0, 0px)",
    'border.width.indicator': "var(--ds-border-width-indicator, 3px)",
    'border.width.outline': "var(--ds-border-width-outline, 2px)"
};
var $d1c0a8e0523d7d45$export$3c0a6c3e64bb180d = {
    'border.radius.050': "var(--ds-border-radius-050, 2px)",
    'border.radius': "var(--ds-border-radius, 3px)",
    'border.radius.100': "var(--ds-border-radius-100, 3px)",
    'border.radius.200': "var(--ds-border-radius-200, 8px)",
    'border.radius.300': "var(--ds-border-radius-300, 12px)",
    'border.radius.400': "var(--ds-border-radius-400, 16px)",
    'border.radius.circle': "var(--ds-border-radius-circle, 32032px)"
};
var $d1c0a8e0523d7d45$export$6cc560b4dedf3816 = {
    medium: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    UNSAFE_small: "var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    large: "var(--ds-font-body-large, normal 400 16px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    small: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)"
};
var $d1c0a8e0523d7d45$export$303e322c6b1ed114 = {
    bold: "var(--ds-font-weight-bold, 700)",
    medium: "var(--ds-font-weight-medium, 500)",
    regular: "var(--ds-font-weight-regular, 400)",
    semibold: "var(--ds-font-weight-semibold, 600)"
};
var $d1c0a8e0523d7d45$export$3c7e9587132614b4 = {
    'font.family.brand.body': "var(--ds-font-family-brand-body, \"Charlie Text\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    'font.family.brand.heading': "var(--ds-font-family-brand-heading, \"Charlie Display\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)"
};
/**
 * @codegenEnd
 */ // Generate maps for Box props. backgroundColor, padding, etc
var $d1c0a8e0523d7d45$var$spacingProperties = [
    // Used by Box
    'padding',
    'paddingBlock',
    'paddingBlockStart',
    'paddingBlockEnd',
    'paddingInline',
    'paddingInlineStart',
    'paddingInlineEnd',
    // Used by Inline and Stack
    'gap',
    'rowGap',
    'columnGap'
];
var $d1c0a8e0523d7d45$var$getSerializedStylesMap = function getSerializedStylesMap(cssProperty, tokenMap) {
    return Object.keys(tokenMap).reduce(function(emotionSpacingMap, token) {
        emotionSpacingMap[token] = (0, $74Zh5.css)((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, cssProperty, tokenMap[token]));
        return emotionSpacingMap;
    }, {});
};
var $d1c0a8e0523d7d45$export$e615f061ca585a6c = $d1c0a8e0523d7d45$var$spacingProperties.reduce(function(styleMap, spacingProperty) {
    styleMap[spacingProperty] = $d1c0a8e0523d7d45$var$getSerializedStylesMap(spacingProperty, $d1c0a8e0523d7d45$export$958d0ae7f2977ae4);
    return styleMap;
}, {});
var $d1c0a8e0523d7d45$export$bf46c3f9eeafc71f = $d1c0a8e0523d7d45$var$spacingProperties.reduce(function(styleMap, spacingProperty) {
    styleMap[spacingProperty] = $d1c0a8e0523d7d45$var$getSerializedStylesMap(spacingProperty, $d1c0a8e0523d7d45$export$958d0ae7f2977ae4);
    return styleMap;
}, {});
var $d1c0a8e0523d7d45$export$e7af83bafe7f9e63 = $d1c0a8e0523d7d45$var$getSerializedStylesMap('backgroundColor', $d1c0a8e0523d7d45$export$d1d79bf68ac056bd);
var $d1c0a8e0523d7d45$export$3a1bcba60b23d7f0 = $d1c0a8e0523d7d45$var$getSerializedStylesMap('color', $d1c0a8e0523d7d45$export$8473307aa00d6ea1);
var $d1c0a8e0523d7d45$export$45f3f4fe16f9f7d5 = $d1c0a8e0523d7d45$var$getSerializedStylesMap('fontWeight', $d1c0a8e0523d7d45$export$303e322c6b1ed114);
var $d1c0a8e0523d7d45$export$68cc305da27dbaa4 = $d1c0a8e0523d7d45$var$getSerializedStylesMap('fontFamily', $d1c0a8e0523d7d45$export$3c7e9587132614b4);
var $d1c0a8e0523d7d45$export$128f10c238242f83 = $d1c0a8e0523d7d45$var$getSerializedStylesMap('font', $d1c0a8e0523d7d45$export$6cc560b4dedf3816);
var $d1c0a8e0523d7d45$export$ff257d957d48c421 = $d1c0a8e0523d7d45$var$getSerializedStylesMap((0, $afac61f58a76c125$export$9d7b58831ae93caa), $d1c0a8e0523d7d45$export$41a358c9c2356760);
var $d1c0a8e0523d7d45$export$5e65a44e5b6ecadb = function isSurfaceColorToken(color) {
    return $d1c0a8e0523d7d45$export$41a358c9c2356760[color] !== undefined;
};



var $3ZMUU = parcelRequire("3ZMUU");
function $23c4b331751052a3$var$_createForOfIteratorHelper(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (!it) {
        if (Array.isArray(o) || (it = $23c4b331751052a3$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
            if (it) o = it;
            var i = 0;
            var F = function F() {};
            return {
                s: F,
                n: function n() {
                    if (i >= o.length) return {
                        done: true
                    };
                    return {
                        done: false,
                        value: o[i++]
                    };
                },
                e: function e(_e) {
                    throw _e;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var normalCompletion = true, didErr = false, err;
    return {
        s: function s() {
            it = it.call(o);
        },
        n: function n() {
            var step = it.next();
            normalCompletion = step.done;
            return step;
        },
        e: function e(_e2) {
            didErr = true;
            err = _e2;
        },
        f: function f() {
            try {
                if (!normalCompletion && it.return != null) it.return();
            } finally{
                if (didErr) throw err;
            }
        }
    };
}
function $23c4b331751052a3$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $23c4b331751052a3$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $23c4b331751052a3$var$_arrayLikeToArray(o, minLen);
}
function $23c4b331751052a3$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
var $23c4b331751052a3$export$9a199fbafee0014e = {
    backgroundColor: (0, $d1c0a8e0523d7d45$export$d1d79bf68ac056bd),
    blockSize: (0, $d1c0a8e0523d7d45$export$6ccdbebca2ee545f),
    borderBlockColor: (0, $d1c0a8e0523d7d45$export$1531ad5bb3fbedac),
    borderBlockEndColor: (0, $d1c0a8e0523d7d45$export$1531ad5bb3fbedac),
    borderBlockEndWidth: (0, $d1c0a8e0523d7d45$export$e1b83c5210c471b8),
    borderBlockStartColor: (0, $d1c0a8e0523d7d45$export$1531ad5bb3fbedac),
    borderBlockStartWidth: (0, $d1c0a8e0523d7d45$export$e1b83c5210c471b8),
    borderBlockWidth: (0, $d1c0a8e0523d7d45$export$e1b83c5210c471b8),
    borderBottomColor: (0, $d1c0a8e0523d7d45$export$1531ad5bb3fbedac),
    borderBottomLeftRadius: (0, $d1c0a8e0523d7d45$export$3c0a6c3e64bb180d),
    borderBottomRightRadius: (0, $d1c0a8e0523d7d45$export$3c0a6c3e64bb180d),
    borderBottomWidth: (0, $d1c0a8e0523d7d45$export$e1b83c5210c471b8),
    borderColor: (0, $d1c0a8e0523d7d45$export$1531ad5bb3fbedac),
    borderEndEndRadius: (0, $d1c0a8e0523d7d45$export$3c0a6c3e64bb180d),
    borderEndStartRadius: (0, $d1c0a8e0523d7d45$export$3c0a6c3e64bb180d),
    borderInlineColor: (0, $d1c0a8e0523d7d45$export$1531ad5bb3fbedac),
    borderInlineEndColor: (0, $d1c0a8e0523d7d45$export$1531ad5bb3fbedac),
    borderInlineEndWidth: (0, $d1c0a8e0523d7d45$export$e1b83c5210c471b8),
    borderInlineStartColor: (0, $d1c0a8e0523d7d45$export$1531ad5bb3fbedac),
    borderInlineStartWidth: (0, $d1c0a8e0523d7d45$export$e1b83c5210c471b8),
    borderInlineWidth: (0, $d1c0a8e0523d7d45$export$e1b83c5210c471b8),
    borderLeftColor: (0, $d1c0a8e0523d7d45$export$1531ad5bb3fbedac),
    borderLeftWidth: (0, $d1c0a8e0523d7d45$export$e1b83c5210c471b8),
    borderRadius: (0, $d1c0a8e0523d7d45$export$3c0a6c3e64bb180d),
    borderRightColor: (0, $d1c0a8e0523d7d45$export$1531ad5bb3fbedac),
    borderRightWidth: (0, $d1c0a8e0523d7d45$export$e1b83c5210c471b8),
    borderStartEndRadius: (0, $d1c0a8e0523d7d45$export$3c0a6c3e64bb180d),
    borderStartStartRadius: (0, $d1c0a8e0523d7d45$export$3c0a6c3e64bb180d),
    borderTopColor: (0, $d1c0a8e0523d7d45$export$1531ad5bb3fbedac),
    borderTopLeftRadius: (0, $d1c0a8e0523d7d45$export$3c0a6c3e64bb180d),
    borderTopRightRadius: (0, $d1c0a8e0523d7d45$export$3c0a6c3e64bb180d),
    borderTopWidth: (0, $d1c0a8e0523d7d45$export$e1b83c5210c471b8),
    borderWidth: (0, $d1c0a8e0523d7d45$export$e1b83c5210c471b8),
    bottom: (0, $d1c0a8e0523d7d45$export$632685d741f3dbbf),
    boxShadow: (0, $d1c0a8e0523d7d45$export$7aff6e7ba39bb774),
    color: (0, $d1c0a8e0523d7d45$export$8473307aa00d6ea1),
    columnGap: (0, $d1c0a8e0523d7d45$export$958d0ae7f2977ae4),
    gap: (0, $d1c0a8e0523d7d45$export$958d0ae7f2977ae4),
    height: (0, $d1c0a8e0523d7d45$export$6ccdbebca2ee545f),
    inlineSize: (0, $d1c0a8e0523d7d45$export$6ccdbebca2ee545f),
    inset: (0, $d1c0a8e0523d7d45$export$632685d741f3dbbf),
    insetBlock: (0, $d1c0a8e0523d7d45$export$632685d741f3dbbf),
    insetBlockEnd: (0, $d1c0a8e0523d7d45$export$632685d741f3dbbf),
    insetBlockStart: (0, $d1c0a8e0523d7d45$export$632685d741f3dbbf),
    insetInline: (0, $d1c0a8e0523d7d45$export$632685d741f3dbbf),
    insetInlineEnd: (0, $d1c0a8e0523d7d45$export$632685d741f3dbbf),
    insetInlineStart: (0, $d1c0a8e0523d7d45$export$632685d741f3dbbf),
    left: (0, $d1c0a8e0523d7d45$export$632685d741f3dbbf),
    margin: (0, $d1c0a8e0523d7d45$export$632685d741f3dbbf),
    marginBlock: (0, $d1c0a8e0523d7d45$export$632685d741f3dbbf),
    marginBlockEnd: (0, $d1c0a8e0523d7d45$export$632685d741f3dbbf),
    marginBlockStart: (0, $d1c0a8e0523d7d45$export$632685d741f3dbbf),
    marginBottom: (0, $d1c0a8e0523d7d45$export$632685d741f3dbbf),
    marginInline: (0, $d1c0a8e0523d7d45$export$632685d741f3dbbf),
    marginInlineEnd: (0, $d1c0a8e0523d7d45$export$632685d741f3dbbf),
    marginInlineStart: (0, $d1c0a8e0523d7d45$export$632685d741f3dbbf),
    marginLeft: (0, $d1c0a8e0523d7d45$export$632685d741f3dbbf),
    marginRight: (0, $d1c0a8e0523d7d45$export$632685d741f3dbbf),
    marginTop: (0, $d1c0a8e0523d7d45$export$632685d741f3dbbf),
    maxBlockSize: (0, $d1c0a8e0523d7d45$export$6ccdbebca2ee545f),
    maxHeight: (0, $d1c0a8e0523d7d45$export$6ccdbebca2ee545f),
    maxInlineSize: (0, $d1c0a8e0523d7d45$export$6ccdbebca2ee545f),
    maxWidth: (0, $d1c0a8e0523d7d45$export$6ccdbebca2ee545f),
    minBlockSize: (0, $d1c0a8e0523d7d45$export$6ccdbebca2ee545f),
    minHeight: (0, $d1c0a8e0523d7d45$export$6ccdbebca2ee545f),
    minInlineSize: (0, $d1c0a8e0523d7d45$export$6ccdbebca2ee545f),
    minWidth: (0, $d1c0a8e0523d7d45$export$6ccdbebca2ee545f),
    opacity: (0, $d1c0a8e0523d7d45$export$daf94a976c798b4f),
    outlineColor: (0, $d1c0a8e0523d7d45$export$1531ad5bb3fbedac),
    outlineOffset: (0, $d1c0a8e0523d7d45$export$958d0ae7f2977ae4),
    outlineWidth: (0, $d1c0a8e0523d7d45$export$e1b83c5210c471b8),
    padding: (0, $d1c0a8e0523d7d45$export$958d0ae7f2977ae4),
    paddingBlock: (0, $d1c0a8e0523d7d45$export$958d0ae7f2977ae4),
    paddingBlockEnd: (0, $d1c0a8e0523d7d45$export$958d0ae7f2977ae4),
    paddingBlockStart: (0, $d1c0a8e0523d7d45$export$958d0ae7f2977ae4),
    paddingBottom: (0, $d1c0a8e0523d7d45$export$958d0ae7f2977ae4),
    paddingInline: (0, $d1c0a8e0523d7d45$export$958d0ae7f2977ae4),
    paddingInlineEnd: (0, $d1c0a8e0523d7d45$export$958d0ae7f2977ae4),
    paddingInlineStart: (0, $d1c0a8e0523d7d45$export$958d0ae7f2977ae4),
    paddingLeft: (0, $d1c0a8e0523d7d45$export$958d0ae7f2977ae4),
    paddingRight: (0, $d1c0a8e0523d7d45$export$958d0ae7f2977ae4),
    paddingTop: (0, $d1c0a8e0523d7d45$export$958d0ae7f2977ae4),
    right: (0, $d1c0a8e0523d7d45$export$632685d741f3dbbf),
    rowGap: (0, $d1c0a8e0523d7d45$export$958d0ae7f2977ae4),
    top: (0, $d1c0a8e0523d7d45$export$632685d741f3dbbf),
    width: (0, $d1c0a8e0523d7d45$export$6ccdbebca2ee545f),
    zIndex: (0, $d1c0a8e0523d7d45$export$b5f31a7e431d2eab)
};
var $23c4b331751052a3$var$uniqueSymbol = Symbol('UNSAFE_INTERNAL_styles');
var $23c4b331751052a3$var$isSafeEnvToThrow = function isSafeEnvToThrow() {
    return (typeof $3ZMUU === "undefined" ? "undefined" : (0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))($3ZMUU)) === 'object' && (0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))($3ZMUU.env) === 'object' && false;
};
var $23c4b331751052a3$var$reNestedSelectors = /(\.|\s|&+|\*\>|#|\[.*\])/;
var $23c4b331751052a3$var$safeSelectors = /^@media .*$|^::?.*$|^@supports .*$/;
var $23c4b331751052a3$var$transformStyles = function transformStyles(styleObj) {
    if (!styleObj || (0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(styleObj) !== 'object') return styleObj;
    // If styles are defined as a CSSObject[], recursively call on each element until we reach CSSObject
    if (Array.isArray(styleObj)) return styleObj.map(transformStyles);
    // Modifies styleObj in place. Be careful.
    Object.entries(styleObj).forEach(function(_ref) {
        var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_ref, 2), key = _ref2[0], value = _ref2[1];
        // If key is a pseudo class or a pseudo element, then value should be an object.
        // So, call transformStyles on the value
        if ((0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(value) === 'object' && $23c4b331751052a3$var$safeSelectors.test(key)) {
            styleObj[key] = transformStyles(value);
            return;
        }
        if ($23c4b331751052a3$var$isSafeEnvToThrow()) {
            // We don't support `.class`, `[data-testid]`, `> *`, `#some-id`
            if ($23c4b331751052a3$var$reNestedSelectors.test(key)) throw new Error("Styles not supported for key '".concat(key, "'."));
        }
        // We have now dealt with all the special cases, so,
        // check whether what remains is a style property
        // that can be transformed.
        if (!(key in $23c4b331751052a3$export$9a199fbafee0014e)) return;
        var tokenValue = $23c4b331751052a3$export$9a199fbafee0014e[key][value];
        styleObj[key] = tokenValue !== null && tokenValue !== void 0 ? tokenValue : value;
    });
    return styleObj;
};
var $23c4b331751052a3$var$baseXcss = function baseXcss(style) {
    var transformedStyles = $23c4b331751052a3$var$transformStyles(style);
    return (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, $23c4b331751052a3$var$uniqueSymbol, (0, $74Zh5.css)(transformedStyles));
};
var $23c4b331751052a3$export$a9c84988c8f81f2d = function parseXcss(args) {
    if (Array.isArray(args)) {
        var emotion = [];
        var staticArr = [];
        var _iterator = $23c4b331751052a3$var$_createForOfIteratorHelper(args), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var arg = _step.value;
                var result = parseXcss(arg);
                if (result.emotion) emotion.push.apply(emotion, (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(result.emotion));
                if (result.static) staticArr.push(result.static);
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
        return {
            emotion: emotion,
            static: staticArr.join(' ')
        };
    }
    var objArgs = args;
    var _ref4 = objArgs || {}, styles = _ref4[$23c4b331751052a3$var$uniqueSymbol];
    if (styles) return {
        emotion: [
            styles
        ]
    };
    if (args) {
        // We use string interpolation here instead of .toString() just
        // in case the resulting object doesn't have the method available.
        var stringifiedArgs = "".concat(args);
        if (stringifiedArgs) return {
            static: stringifiedArgs
        };
    }
    return {};
};
function $23c4b331751052a3$export$f6c783d06584602c(style) {
    return $23c4b331751052a3$var$baseXcss(style);
}


/** @jsx jsx */ 
var $5FkrB = parcelRequire("5FkrB");

var $74Zh5 = parcelRequire("74Zh5");


var $f95377522291ee01$var$justifyContentMap = {
    start: (0, $74Zh5.css)({
        justifyContent: 'start'
    }),
    center: (0, $74Zh5.css)({
        justifyContent: 'center'
    }),
    end: (0, $74Zh5.css)({
        justifyContent: 'end'
    }),
    'space-between': (0, $74Zh5.css)({
        justifyContent: 'space-between'
    }),
    'space-around': (0, $74Zh5.css)({
        justifyContent: 'space-around'
    }),
    'space-evenly': (0, $74Zh5.css)({
        justifyContent: 'space-evenly'
    }),
    stretch: (0, $74Zh5.css)({
        justifyContent: 'stretch'
    })
};
var $f95377522291ee01$var$flexDirectionMap = {
    column: (0, $74Zh5.css)({
        flexDirection: 'column'
    }),
    row: (0, $74Zh5.css)({
        flexDirection: 'row'
    })
};
var $f95377522291ee01$var$flexWrapMap = {
    wrap: (0, $74Zh5.css)({
        flexWrap: 'wrap'
    }),
    nowrap: (0, $74Zh5.css)({
        flexWrap: 'nowrap'
    })
};
var $f95377522291ee01$var$alignItemsMap = {
    start: (0, $74Zh5.css)({
        alignItems: 'start'
    }),
    center: (0, $74Zh5.css)({
        alignItems: 'center'
    }),
    baseline: (0, $74Zh5.css)({
        alignItems: 'baseline'
    }),
    end: (0, $74Zh5.css)({
        alignItems: 'end'
    }),
    stretch: (0, $74Zh5.css)({
        alignItems: 'stretch'
    })
};
var $f95377522291ee01$var$baseStyles = (0, $74Zh5.css)({
    display: 'flex',
    boxSizing: 'border-box'
});
/**
 * __Flex__
 *
 * `Flex` is a primitive component that implements the CSS Flexbox API.
 *
 * - [Examples](https://atlassian.design/components/primitives/flex/examples)
 * - [Code](https://atlassian.design/components/primitives/flex/code)
 *
 * @example
 * ```tsx
 * import { Flex, Box } from '@atlaskit/primitives'
 *
 * const Component = () => (
 *   <Flex direction="column">
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *   </Flex>
 * )
 * ```
 */ var $f95377522291ee01$var$Flex = /*#__PURE__*/ (0, $5FkrB.memo)(/*#__PURE__*/ (0, $5FkrB.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? 'div' : _ref$as, role = _ref.role, alignItems = _ref.alignItems, justifyContent = _ref.justifyContent, gap = _ref.gap, columnGap = _ref.columnGap, rowGap = _ref.rowGap, children = _ref.children, testId = _ref.testId, direction = _ref.direction, wrap = _ref.wrap, xcss = _ref.xcss;
    var resolvedStyles = (0, $23c4b331751052a3$export$a9c84988c8f81f2d)(xcss);
    return (0, $74Zh5.jsx)(Component, {
        role: role,
        className: resolvedStyles.static,
        css: [
            $f95377522291ee01$var$baseStyles,
            gap && (0, $d1c0a8e0523d7d45$export$bf46c3f9eeafc71f).gap[gap],
            columnGap && (0, $d1c0a8e0523d7d45$export$bf46c3f9eeafc71f).columnGap[columnGap],
            rowGap && (0, $d1c0a8e0523d7d45$export$bf46c3f9eeafc71f).rowGap[rowGap],
            alignItems && $f95377522291ee01$var$alignItemsMap[alignItems],
            direction && $f95377522291ee01$var$flexDirectionMap[direction],
            justifyContent && $f95377522291ee01$var$justifyContentMap[justifyContent],
            wrap && $f95377522291ee01$var$flexWrapMap[wrap],
            // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
            resolvedStyles.emotion
        ],
        "data-testid": testId,
        ref: ref
    }, children);
}));
$f95377522291ee01$var$Flex.displayName = 'Flex';
var $f95377522291ee01$export$2e2bcd8739ae039 = $f95377522291ee01$var$Flex;


var $d363f694d5e41fc5$var$flexGrowMap = {
    hug: (0, $23c4b331751052a3$export$f6c783d06584602c)({
        flexGrow: 0
    }),
    fill: (0, $23c4b331751052a3$export$f6c783d06584602c)({
        width: '100%',
        flexGrow: 1
    })
};
var $d363f694d5e41fc5$var$separatorStyles = (0, $74Zh5.css)({
    color: "var(--ds-text-subtle, #42526E)",
    marginBlock: "var(--ds-space-0, 0px)",
    marginInline: "var(--ds-space-negative-025, -2px)",
    pointerEvents: 'none',
    userSelect: 'none'
});
var $d363f694d5e41fc5$var$Separator = function Separator(_ref) {
    var children = _ref.children;
    return (0, $74Zh5.jsx)("span", {
        css: $d363f694d5e41fc5$var$separatorStyles
    }, children);
};
/**
 * __Inline__
 *
 * Inline is a primitive component based on CSS Flexbox that manages the horizontal layout of direct children.
 *
 * @example
 * ```tsx
 *  <Inline>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *  </Inline>
 * ```
 *
 */ var $d363f694d5e41fc5$var$Inline = /*#__PURE__*/ (0, $5FkrB.memo)(/*#__PURE__*/ (0, $5FkrB.forwardRef)(function(_ref2, ref) {
    var as = _ref2.as, alignInline = _ref2.alignInline, _ref2$alignBlock = _ref2.alignBlock, alignItems = _ref2$alignBlock === void 0 ? 'start' : _ref2$alignBlock, _ref2$shouldWrap = _ref2.shouldWrap, shouldWrap = _ref2$shouldWrap === void 0 ? false : _ref2$shouldWrap, spread = _ref2.spread, grow = _ref2.grow, space = _ref2.space, rowSpace = _ref2.rowSpace, separator = _ref2.separator, xcss = _ref2.xcss, testId = _ref2.testId, role = _ref2.role, rawChildren = _ref2.children;
    var separatorComponent = typeof separator === 'string' ? (0, $74Zh5.jsx)($d363f694d5e41fc5$var$Separator, null, separator) : separator;
    var children = separatorComponent ? (0, $5FkrB.Children).toArray(rawChildren).filter(Boolean).map(function(child, index) {
        return (0, $74Zh5.jsx)((0, $5FkrB.Fragment), {
            key: index
        }, separator && index > 0 ? separatorComponent : null, child);
    }) : rawChildren;
    var justifyContent = spread || alignInline;
    // We're type coercing this as Compiled styles in an array isn't supported by the types
    // But the runtime accepts it none-the-wiser. We can remove this entire block and replace
    // it with cx(defaultStyles, focusRingStyles, xcssStyles) when we've moved away from Emotion.
    var styles = grow ? [
        $d363f694d5e41fc5$var$flexGrowMap[grow]
    ].concat((0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(Array.isArray(xcss) ? xcss : [
        xcss
    ])) : xcss;
    return (0, $74Zh5.jsx)((0, $f95377522291ee01$export$2e2bcd8739ae039), {
        as: as,
        role: role,
        alignItems: alignItems,
        justifyContent: justifyContent,
        direction: "row",
        gap: space,
        rowGap: rowSpace,
        wrap: shouldWrap ? 'wrap' : undefined,
        xcss: styles,
        testId: testId,
        ref: ref
    }, children);
}));
$d363f694d5e41fc5$var$Inline.displayName = 'Inline';
var $d363f694d5e41fc5$export$2e2bcd8739ae039 = $d363f694d5e41fc5$var$Inline;

/**
 * This is an object of usable media query helpers using our internal breakpoints configuration.
 *
 * When using Compiled CSS-in-JS, please ensure that only a single declaration can take effect at a time.
 * This means that you should avoid multiple breakpoints taking effect at the same time,
 * eg. ```{ [media.above.xs]: { color: 'red' }, [media.above.sm]: { color: 'green' }}```.
 * Instead, make sure that only one breakpoint can take effect at a time,
 * e.g, ```{ [media.only.xs]: { color: 'red' }, [media.above.sm]: { color: 'green' }}```.
 * For more details, please see <https://compiledcssinjs.com/docs/atomic-css#selector-specificity>.
 */ var $0bc19dfefbafca8c$export$987d49ffe1b0900f = {
    above: {
        xxs: '@media all',
        xs: '@media (min-width: 30rem)',
        sm: '@media (min-width: 48rem)',
        md: '@media (min-width: 64rem)',
        lg: '@media (min-width: 90rem)',
        xl: '@media (min-width: 110rem)'
    },
    only: {
        xxs: '@media (min-width: 0rem) and (max-width: 29.99rem)',
        xs: '@media (min-width: 30rem) and (max-width: 47.99rem)',
        sm: '@media (min-width: 48rem) and (max-width: 63.99rem)',
        md: '@media (min-width: 64rem) and (max-width: 89.99rem)',
        lg: '@media (min-width: 90rem) and (max-width: 109.99rem)',
        xl: '@media (min-width: 110rem)'
    },
    below: {
        xs: '@media not all and (min-width: 30rem)',
        sm: '@media not all and (min-width: 48rem)',
        md: '@media not all and (min-width: 64rem)',
        lg: '@media not all and (min-width: 90rem)',
        xl: '@media not all and (min-width: 110rem)'
    }
};
var $0bc19dfefbafca8c$export$c881183ca713c214 = $0bc19dfefbafca8c$export$987d49ffe1b0900f;


var $fC8ib = parcelRequire("fC8ib");

var $5FkrB = parcelRequire("5FkrB");

var $74Zh5 = parcelRequire("74Zh5");


var $59963e1859b942f0$var$flexGrowMap = {
    hug: (0, $23c4b331751052a3$export$f6c783d06584602c)({
        flexGrow: 0
    }),
    fill: (0, $23c4b331751052a3$export$f6c783d06584602c)({
        width: '100%',
        flexGrow: 1
    })
};
/**
 * __Stack__
 *
 * Stack is a primitive component based on flexbox that manages the block layout of direct children.
 *
 * @example
 * ```tsx
 *  <Stack>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *  </Stack>
 * ```
 *
 */ var $59963e1859b942f0$var$Stack = /*#__PURE__*/ (0, $5FkrB.memo)(/*#__PURE__*/ (0, $5FkrB.forwardRef)(function(_ref, ref) {
    var as = _ref.as, alignItems = _ref.alignInline, _ref$alignBlock = _ref.alignBlock, alignBlock = _ref$alignBlock === void 0 ? 'stretch' : _ref$alignBlock, spread = _ref.spread, grow = _ref.grow, space = _ref.space, children = _ref.children, testId = _ref.testId, xcss = _ref.xcss, role = _ref.role;
    var justifyContent = spread || alignBlock;
    // We're type coercing this as Compiled styles in an array isn't supported by the types
    // But the runtime accepts it none-the-wiser. We can remove this entire block and replace
    // it with cx(defaultStyles, focusRingStyles, xcssStyles) when we've moved away from Emotion.
    var styles = grow ? [
        $59963e1859b942f0$var$flexGrowMap[grow]
    ].concat((0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(Array.isArray(xcss) ? xcss : [
        xcss
    ])) : xcss;
    return (0, $74Zh5.jsx)((0, $f95377522291ee01$export$2e2bcd8739ae039), {
        as: as,
        role: role,
        gap: space,
        direction: "column",
        alignItems: alignItems,
        justifyContent: justifyContent,
        xcss: styles,
        testId: testId,
        ref: ref
    }, children);
}));
$59963e1859b942f0$var$Stack.displayName = 'Stack';
var $59963e1859b942f0$export$2e2bcd8739ae039 = $59963e1859b942f0$var$Stack;

/** @jsx jsx */ 
var $5FkrB = parcelRequire("5FkrB");

var $74Zh5 = parcelRequire("74Zh5");

var $afMOk = parcelRequire("afMOk");


var $5FkrB = parcelRequire("5FkrB");
var $11a8903532c717f3$export$1ca2a26fecb070ae = /*#__PURE__*/ (0, $5FkrB.createContext)('elevation.surface');
var $11a8903532c717f3$export$1aeb4f6b93c4540d = function useSurface() {
    return (0, $5FkrB.useContext)($11a8903532c717f3$export$1ca2a26fecb070ae);
};
$11a8903532c717f3$export$1ca2a26fecb070ae.displayName = 'SurfaceProvider';


var $e7c05297f099a1fc$var$asAllowlist = [
    'span',
    'p',
    'strong',
    'em'
];
// We're doing this because our CSS reset can add top margins to elements such as `p` which is totally insane.
// Long term we should remove those instances from the reset - it should be a reset to 0.
// For now, at least we know <Text> will be unaffected by this.
var $e7c05297f099a1fc$var$resetStyles = (0, $74Zh5.css)({
    margin: 0
});
var $e7c05297f099a1fc$var$strongStyles = (0, $74Zh5.css)({
    fontWeight: 'bold'
});
var $e7c05297f099a1fc$var$emStyles = (0, $74Zh5.css)({
    fontStyle: 'italic'
});
var $e7c05297f099a1fc$var$textAlignMap = {
    center: (0, $74Zh5.css)({
        textAlign: 'center'
    }),
    end: (0, $74Zh5.css)({
        textAlign: 'end'
    }),
    start: (0, $74Zh5.css)({
        textAlign: 'start'
    })
};
var $e7c05297f099a1fc$var$truncationStyles = (0, $74Zh5.css)({
    display: '-webkit-box',
    overflow: 'hidden',
    WebkitBoxOrient: 'vertical'
});
var $e7c05297f099a1fc$var$wordBreakMap = {
    breakAll: (0, $74Zh5.css)({
        wordBreak: 'break-all'
    })
};
var $e7c05297f099a1fc$var$HasTextAncestorContext = /*#__PURE__*/ (0, $5FkrB.createContext)(false);
var $e7c05297f099a1fc$var$useHasTextAncestor = function useHasTextAncestor() {
    return (0, $5FkrB.useContext)($e7c05297f099a1fc$var$HasTextAncestorContext);
};
/**
 * Custom hook designed to abstract the parsing of the color props and make it clearer in the future how color is reconciled between themes and tokens.
 */ var $e7c05297f099a1fc$var$useColor = function useColor(colorProp, hasTextAncestor) {
    var surface = (0, $11a8903532c717f3$export$1aeb4f6b93c4540d)();
    /**
   * Where the color of the surface is inverted we always override the color
   * as there is no valid choice that is not covered by the override.
   */ if ((0, $d1c0a8e0523d7d45$export$2185ce37f9bdd963).hasOwnProperty(surface)) return (0, $d1c0a8e0523d7d45$export$2185ce37f9bdd963)[surface];
    if (colorProp === 'inherit') return undefined;
    if (!colorProp && hasTextAncestor) return undefined;
    return colorProp || 'color.text';
};
/**
 * __Text__
 *
 * Text is a primitive component that has the Atlassian Design System's design guidelines baked in.
 * This includes considerations for text attributes such as color, font size, font weight, and line height.
 * It renders a `span` by default.
 *
 * @internal
 */ var $e7c05297f099a1fc$var$Text = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? 'span' : _ref$as, colorProp = _ref.color, align = _ref.align, testId = _ref.testId, id = _ref.id, _ref$size = _ref.size, size = _ref$size === void 0 ? 'medium' : _ref$size, weight = _ref.weight, maxLines = _ref.maxLines, children = _ref.children;
    (0, $afMOk.default)($e7c05297f099a1fc$var$asAllowlist.includes(Component), "@atlaskit/primitives: Text received an invalid \"as\" value of \"".concat(Component, "\""));
    var hasTextAncestor = $e7c05297f099a1fc$var$useHasTextAncestor();
    var color = $e7c05297f099a1fc$var$useColor(colorProp, hasTextAncestor);
    var component = (0, $74Zh5.jsx)(Component, {
        ref: ref,
        css: [
            $e7c05297f099a1fc$var$resetStyles,
            (0, $d1c0a8e0523d7d45$export$128f10c238242f83)[size],
            color && (0, $d1c0a8e0523d7d45$export$3a1bcba60b23d7f0)[color],
            maxLines && $e7c05297f099a1fc$var$truncationStyles,
            maxLines === 1 && $e7c05297f099a1fc$var$wordBreakMap.breakAll,
            align && $e7c05297f099a1fc$var$textAlignMap[align],
            weight && (0, $d1c0a8e0523d7d45$export$45f3f4fe16f9f7d5)[weight],
            Component === 'em' && $e7c05297f099a1fc$var$emStyles,
            Component === 'strong' && $e7c05297f099a1fc$var$strongStyles
        ],
        style: {
            WebkitLineClamp: maxLines
        },
        "data-testid": testId,
        id: id
    }, children);
    return hasTextAncestor ? // no need to re-apply context if the text is already wrapped
    component : (0, $74Zh5.jsx)($e7c05297f099a1fc$var$HasTextAncestorContext.Provider, {
        value: true
    }, component);
});
var $e7c05297f099a1fc$export$2e2bcd8739ae039 = $e7c05297f099a1fc$var$Text;


var $3ba3a1ce40cf237e$exports = {};
"use strict";
Object.defineProperty($3ba3a1ce40cf237e$exports, "__esModule", {
    value: true
});
$3ba3a1ce40cf237e$exports.default = void 0;

var $3ba3a1ce40cf237e$var$_react = $3ba3a1ce40cf237e$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $kqp0i = parcelRequire("kqp0i");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");

var $auUAM = parcelRequire("auUAM");

var $kqp0i = parcelRequire("kqp0i");

var $25nEq = parcelRequire("25nEq");

var $5FkrB = parcelRequire("5FkrB");

var $74Zh5 = parcelRequire("74Zh5");
var $22127d8726c255a5$export$c647cb0ee6e282fe = {
    small: '16px',
    medium: '24px',
    large: '32px',
    xlarge: '48px'
};
var $22127d8726c255a5$export$7bd66fc94c81bf84 = {
    small: 'small',
    medium: 'medium',
    large: 'large',
    xlarge: 'xlarge'
};
var $22127d8726c255a5$export$62ad7b0c781000e9 = {
    small: {
        width: $22127d8726c255a5$export$c647cb0ee6e282fe.small,
        height: $22127d8726c255a5$export$c647cb0ee6e282fe.small
    },
    medium: {
        width: $22127d8726c255a5$export$c647cb0ee6e282fe.medium,
        height: $22127d8726c255a5$export$c647cb0ee6e282fe.medium
    },
    large: {
        width: $22127d8726c255a5$export$c647cb0ee6e282fe.large,
        height: $22127d8726c255a5$export$c647cb0ee6e282fe.large
    },
    xlarge: {
        width: $22127d8726c255a5$export$c647cb0ee6e282fe.xlarge,
        height: $22127d8726c255a5$export$c647cb0ee6e282fe.xlarge
    }
};



var $74Zh5 = parcelRequire("74Zh5");
var $451a02c5cbb884e5$export$16374db1c3e6dfba = {
    overflow: 'hidden',
    pointerEvents: 'none',
    /**
   * Stop-color doesn't properly apply in chrome when the inherited/current color changes.
   * We have to initially set stop-color to inherit (either via DOM attribute or an initial CSS
   * rule) and then override it with currentColor for the color changes to be picked up.
   */ stop: {
        stopColor: 'currentColor'
    }
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
var $451a02c5cbb884e5$var$smallStyles = (0, $74Zh5.css)((0, $22127d8726c255a5$export$62ad7b0c781000e9).small);
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
var $451a02c5cbb884e5$var$mediumStyles = (0, $74Zh5.css)((0, $22127d8726c255a5$export$62ad7b0c781000e9).medium);
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
var $451a02c5cbb884e5$var$largeStyles = (0, $74Zh5.css)((0, $22127d8726c255a5$export$62ad7b0c781000e9).large);
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
var $451a02c5cbb884e5$var$xlargeStyles = (0, $74Zh5.css)((0, $22127d8726c255a5$export$62ad7b0c781000e9).xlarge);
var $451a02c5cbb884e5$export$ef0ad74202575b64 = {
    small: $451a02c5cbb884e5$var$smallStyles,
    medium: $451a02c5cbb884e5$var$mediumStyles,
    large: $451a02c5cbb884e5$var$largeStyles,
    xlarge: $451a02c5cbb884e5$var$xlargeStyles
};
var $451a02c5cbb884e5$export$3eb7d6130acfda37 = function getIconSize(_ref) {
    var width = _ref.width, height = _ref.height, size = _ref.size;
    if (width && height) return {
        width: width,
        height: height
    };
    if (size) return (0, $22127d8726c255a5$export$62ad7b0c781000e9)[size];
    return undefined;
};


var $4f498bc0e0b0e9fd$export$18cb9425622d4e06 = function getBackground() {
    return "var(--ds-surface, #FFFFFF)";
};


function $da423c7a70bed31e$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $da423c7a70bed31e$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $da423c7a70bed31e$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $da423c7a70bed31e$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
/**
 * We are hiding these props from consumers as they're used to
 * hack around icon sizing specifically for icon-file-type.
 */ var $da423c7a70bed31e$var$iconStyles = (0, $74Zh5.css)({
    display: 'inline-block',
    flexShrink: 0,
    lineHeight: 1,
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '> svg': $da423c7a70bed31e$var$_objectSpread($da423c7a70bed31e$var$_objectSpread({}, (0, $451a02c5cbb884e5$export$16374db1c3e6dfba)), {}, {
        maxWidth: '100%',
        maxHeight: '100%',
        color: 'var(--icon-primary-color)',
        fill: 'var(--icon-secondary-color)',
        verticalAlign: 'bottom'
    })
});
/**
 * For windows high contrast mode
 */ var $da423c7a70bed31e$var$baseHcmStyles = (0, $74Zh5.css)({
    '@media screen and (forced-colors: active)': {
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '> svg': {
            filter: 'grayscale(1)',
            '--icon-primary-color': 'CanvasText',
            // foreground
            '--icon-secondary-color': 'Canvas' // background
        }
    }
});
var $da423c7a70bed31e$var$primaryEqualsSecondaryHcmStyles = (0, $74Zh5.css)({
    '@media screen and (forced-colors: active)': {
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '> svg': {
            // if the primaryColor is the same as the secondaryColor we
            // set the --icon-primary-color to Canvas
            // this is usually to convey state i.e. Checkbox checked -> not checked
            '--icon-primary-color': 'Canvas' // foreground
        }
    }
});
var $da423c7a70bed31e$var$secondaryTransparentHcmStyles = (0, $74Zh5.css)({
    '@media screen and (forced-colors: active)': {
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '> svg': {
            '--icon-secondary-color': 'transparent' // background
        }
    }
});
var $da423c7a70bed31e$export$f04a61298a47a40f = /*#__PURE__*/ (0, $5FkrB.memo)(function Icon(props) {
    var _ref = props, Glyph = _ref.glyph, dangerouslySetGlyph = _ref.dangerouslySetGlyph, _ref$primaryColor = _ref.primaryColor, primaryColor = _ref$primaryColor === void 0 ? 'currentColor' : _ref$primaryColor, secondaryColor = _ref.secondaryColor, size = _ref.size, testId = _ref.testId, label = _ref.label, width = _ref.width, height = _ref.height, UNSAFE_margin = _ref.UNSAFE_margin;
    var glyphProps = dangerouslySetGlyph ? {
        dangerouslySetInnerHTML: {
            __html: dangerouslySetGlyph
        }
    } : {
        children: Glyph ? (0, $74Zh5.jsx)(Glyph, {
            role: "presentation"
        }) : null
    };
    var dimensions = (0, $451a02c5cbb884e5$export$3eb7d6130acfda37)({
        width: width,
        height: height,
        size: size
    });
    return (0, $74Zh5.jsx)("span", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        "data-testid": testId,
        "data-vc": "icon-".concat(testId),
        role: label ? 'img' : undefined,
        "aria-label": label ? label : undefined,
        "aria-hidden": label ? undefined : true,
        style: {
            '--icon-primary-color': primaryColor,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            '--icon-secondary-color': secondaryColor || (0, $4f498bc0e0b0e9fd$export$18cb9425622d4e06)(),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            margin: UNSAFE_margin
        }
    }, glyphProps, {
        css: [
            $da423c7a70bed31e$var$iconStyles,
            $da423c7a70bed31e$var$baseHcmStyles,
            primaryColor === secondaryColor && $da423c7a70bed31e$var$primaryEqualsSecondaryHcmStyles,
            secondaryColor === 'transparent' && $da423c7a70bed31e$var$secondaryTransparentHcmStyles,
            // NB: This can be resolved if this component, composes base SVG / and/or skeleton
            // We could then simplify how common styles are dealt with simply by encapsulating them
            // at their appropriate level and/or having a singular approach to css variables in the package
            dimensions && // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $74Zh5.css)({
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                width: dimensions.width,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                height: dimensions.height,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                '> svg': dimensions
            })
        ]
    }));
});
var $da423c7a70bed31e$export$2e2bcd8739ae039 = $da423c7a70bed31e$export$f04a61298a47a40f;


var $b2a18d994dfc84a8$var$_excluded = [
    "dangerouslySetGlyph"
];
var $b2a18d994dfc84a8$var$sizeSpacingMap = {
    utility: {
        small: 'compact',
        medium: 'spacious'
    },
    core: {
        small: 'none',
        medium: 'spacious'
    }
};
var $b2a18d994dfc84a8$export$3cfb73f70dfca966 = /*#__PURE__*/ (0, $5FkrB.memo)(function IconFacade(_ref) {
    var _props$size;
    var dangerouslySetGlyph = _ref.dangerouslySetGlyph, props = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $b2a18d994dfc84a8$var$_excluded);
    var NewIcon = props.newIcon;
    // By default, the icon size will be medium for core icons and small for utility icons
    var size = (_props$size = props.size) !== null && _props$size !== void 0 ? _props$size : 'medium';
    var useNewIcon = !props.isFacadeDisabled && // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
    (0, $auUAM.fg)('platform-visual-refresh-icons-legacy-facade');
    if (useNewIcon && NewIcon && (size === 'small' || size === 'medium')) {
        if (props.iconType === 'utility') {
            var Icon = NewIcon;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(Icon, (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, props, {
                spacing: (0, $auUAM.fg)('platform-visual-refresh-icons-facade-button-fix') ? $b2a18d994dfc84a8$var$sizeSpacingMap['utility'][size] : 'none',
                color: props.primaryColor || 'currentColor',
                type: props.iconType
            }));
        } else {
            var _Icon = NewIcon;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(_Icon, (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, props, {
                spacing: $b2a18d994dfc84a8$var$sizeSpacingMap['core'][size],
                color: props.primaryColor || 'currentColor',
                type: props.iconType
            }));
        }
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $da423c7a70bed31e$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        dangerouslySetGlyph: dangerouslySetGlyph
    }, props));
});
var $b2a18d994dfc84a8$export$2e2bcd8739ae039 = $b2a18d994dfc84a8$export$3cfb73f70dfca966;



var $3ba3a1ce40cf237e$var$_close = $3ba3a1ce40cf237e$var$_interopRequireDefault((parcelRequire("iNMs5")));
function $3ba3a1ce40cf237e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $3ba3a1ce40cf237e$var$CrossIcon = (props)=>/*#__PURE__*/ $3ba3a1ce40cf237e$var$_react.default.createElement($b2a18d994dfc84a8$export$3cfb73f70dfca966, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M12 10.586 6.707 5.293a1 1 0 0 0-1.414 1.414L10.586 12l-5.293 5.293a1 1 0 0 0 1.414 1.414L12 13.414l5.293 5.293a1 1 0 0 0 1.414-1.414L13.414 12l5.293-5.293a1 1 0 1 0-1.414-1.414z"/></svg>`
    }, props, {
        newIcon: $3ba3a1ce40cf237e$var$_close.default
    }));
$3ba3a1ce40cf237e$var$CrossIcon.displayName = 'CrossIcon';
var $3ba3a1ce40cf237e$var$_default = $3ba3a1ce40cf237e$exports.default = $3ba3a1ce40cf237e$var$CrossIcon;



var $kdnK6 = parcelRequire("kdnK6");
var $61061e9506c91f48$exports = {};
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c9e42f0bd2701e924d060f406b40f887>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty($61061e9506c91f48$exports, "__esModule", {
    value: true
});
$61061e9506c91f48$exports.default = void 0;

var $61061e9506c91f48$var$_react = $61061e9506c91f48$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $61061e9506c91f48$var$_UNSAFE_baseNew = $61061e9506c91f48$var$_interopRequireDefault((parcelRequire("kjkwu")));
function $61061e9506c91f48$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "AtlassianIntelligence".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for Atlassian Intelligence products or experiences.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $61061e9506c91f48$var$AtlassianIntelligenceIcon = (props)=>/*#__PURE__*/ $61061e9506c91f48$var$_react.default.createElement($61061e9506c91f48$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-width="1.5" d="m2 2 4 4m8 8-4-4m4-8-4 4m-8 8 4-4m2-9v3m0 8v3m7-7h-3M4 8H1"/>`
    }, props));
$61061e9506c91f48$var$AtlassianIntelligenceIcon.displayName = 'AtlassianIntelligenceIcon';
var $61061e9506c91f48$var$_default = $61061e9506c91f48$exports.default = $61061e9506c91f48$var$AtlassianIntelligenceIcon;


var $5a91d22bbe4f675e$exports = {};
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6db9feac5032e1f6cb5923640df1c100>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty($5a91d22bbe4f675e$exports, "__esModule", {
    value: true
});
$5a91d22bbe4f675e$exports.default = void 0;

var $5a91d22bbe4f675e$var$_react = $5a91d22bbe4f675e$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $5a91d22bbe4f675e$var$_UNSAFE_baseNew = $5a91d22bbe4f675e$var$_interopRequireDefault((parcelRequire("kjkwu")));
function $5a91d22bbe4f675e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Calendar".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: date metadata, date input field, calendar view, jira status.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $5a91d22bbe4f675e$var$CalendarIcon = (props)=>/*#__PURE__*/ $5a91d22bbe4f675e$var$_react.default.createElement($5a91d22bbe4f675e$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-width="1.5" d="M1.75 6.75V13c0 .69.56 1.25 1.25 1.25h10c.69 0 1.25-.56 1.25-1.25V6.75m-12.5 0V3c0-.69.56-1.25 1.25-1.25h2.25m-3.5 5h12.5m0 0V3c0-.69-.56-1.25-1.25-1.25h-2.25m-5.5 0V0m0 1.75V4.5m0-2.75h5.5m0 0V0m0 1.75V4.5"/>`
    }, props));
$5a91d22bbe4f675e$var$CalendarIcon.displayName = 'CalendarIcon';
var $5a91d22bbe4f675e$var$_default = $5a91d22bbe4f675e$exports.default = $5a91d22bbe4f675e$var$CalendarIcon;


var $7b258af4b8d0f304$exports = {};
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::48d6c52e2f1120d34c1ed8048cf8da09>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty($7b258af4b8d0f304$exports, "__esModule", {
    value: true
});
$7b258af4b8d0f304$exports.default = void 0;

var $7b258af4b8d0f304$var$_react = $7b258af4b8d0f304$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $7b258af4b8d0f304$var$_UNSAFE_baseNew = $7b258af4b8d0f304$var$_interopRequireDefault((parcelRequire("kjkwu")));
function $7b258af4b8d0f304$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Compass".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: templates.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $7b258af4b8d0f304$var$CompassIcon = (props)=>/*#__PURE__*/ $7b258af4b8d0f304$var$_react.default.createElement($7b258af4b8d0f304$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M8 15.25A7.25 7.25 0 1 0 8 .75a7.25 7.25 0 0 0 0 14.5Z"/><path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="m4.75 11.25 4.5-2-2.5-2.5z"/><path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="m11.25 4.75-4.5 2 2.5 2.5z"/>`
    }, props));
$7b258af4b8d0f304$var$CompassIcon.displayName = 'CompassIcon';
var $7b258af4b8d0f304$var$_default = $7b258af4b8d0f304$exports.default = $7b258af4b8d0f304$var$CompassIcon;



var $6KNbq = parcelRequire("6KNbq");
var $24667df966305327$exports = {};
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::79997d69990d173364910f60504b3516>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty($24667df966305327$exports, "__esModule", {
    value: true
});
$24667df966305327$exports.default = void 0;

var $24667df966305327$var$_react = $24667df966305327$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $24667df966305327$var$_UNSAFE_baseNew = $24667df966305327$var$_interopRequireDefault((parcelRequire("kjkwu")));
function $24667df966305327$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "LinkExternal".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for links that open up a new tab.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $24667df966305327$var$LinkExternalIcon = (props)=>/*#__PURE__*/ $24667df966305327$var$_react.default.createElement($24667df966305327$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M6 1.75H3c-.69 0-1.25.56-1.25 1.25v10c0 .69.56 1.25 1.25 1.25h10c.69 0 1.25-.56 1.25-1.25v-3M7 9l6.75-6.75m.5 3.75V1.75H10"/>`
    }, props));
$24667df966305327$var$LinkExternalIcon.displayName = 'LinkExternalIcon';
var $24667df966305327$var$_default = $24667df966305327$exports.default = $24667df966305327$var$LinkExternalIcon;



var $lD59F = parcelRequire("lD59F");
var $e51c71b0df1b60e6$exports = {};
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::60edb8db9f6bfb3658759225f550b1d1>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty($e51c71b0df1b60e6$exports, "__esModule", {
    value: true
});
$e51c71b0df1b60e6$exports.default = void 0;

var $e51c71b0df1b60e6$var$_react = $e51c71b0df1b60e6$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $e51c71b0df1b60e6$var$_UNSAFE_baseNew = $e51c71b0df1b60e6$var$_interopRequireDefault((parcelRequire("kjkwu")));
function $e51c71b0df1b60e6$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Megaphone".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: feedback in products.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $e51c71b0df1b60e6$var$MegaphoneIcon = (props)=>/*#__PURE__*/ $e51c71b0df1b60e6$var$_react.default.createElement($e51c71b0df1b60e6$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M6.75 4.25H3c-.69 0-1.25.56-1.25 1.25v3.25C1.75 9.44 2.31 10 3 10h1.25m2.5-5.75 5.786-2.314a1.25 1.25 0 0 1 1.714 1.16v8.058a1.25 1.25 0 0 1-1.714 1.16L6.75 10m0-5.75V10m0 0h-2.5m2.5 0v4.25H5.5c-.69 0-1.25-.56-1.25-1.25v-3"/>`
    }, props));
$e51c71b0df1b60e6$var$MegaphoneIcon.displayName = 'MegaphoneIcon';
var $e51c71b0df1b60e6$var$_default = $e51c71b0df1b60e6$exports.default = $e51c71b0df1b60e6$var$MegaphoneIcon;


var $692f0acff770933a$exports = {};
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::1c2c434ab24649808044e93163bd51c1>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty($692f0acff770933a$exports, "__esModule", {
    value: true
});
$692f0acff770933a$exports.default = void 0;

var $692f0acff770933a$var$_react = $692f0acff770933a$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $692f0acff770933a$var$_UNSAFE_baseNew = $692f0acff770933a$var$_interopRequireDefault((parcelRequire("kjkwu")));
function $692f0acff770933a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "PeopleGroup".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Known uses: representing a group or collection of people or users.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $692f0acff770933a$var$PeopleGroupIcon = (props)=>/*#__PURE__*/ $692f0acff770933a$var$_react.default.createElement($692f0acff770933a$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M5 9.75H2.625C1.59 9.75.75 10.59.75 11.625V13m14.5 1v-1.5a2.75 2.75 0 0 0-2.75-2.75h-3a2.75 2.75 0 0 0-2.75 2.75V14m7-9.5a2.75 2.75 0 1 1-5.5 0 2.75 2.75 0 0 1 5.5 0Zm-8 1a1.75 1.75 0 1 1-3.5 0 1.75 1.75 0 0 1 3.5 0Z"/>`
    }, props));
$692f0acff770933a$var$PeopleGroupIcon.displayName = 'PeopleGroupIcon';
var $692f0acff770933a$var$_default = $692f0acff770933a$exports.default = $692f0acff770933a$var$PeopleGroupIcon;


var $dca91df78b4a6141$exports = {};
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::42f87835acc0152c23ae77c3bbeeba86>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty($dca91df78b4a6141$exports, "__esModule", {
    value: true
});
$dca91df78b4a6141$exports.default = void 0;

var $dca91df78b4a6141$var$_react = $dca91df78b4a6141$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $dca91df78b4a6141$var$_UNSAFE_baseNew = $dca91df78b4a6141$var$_interopRequireDefault((parcelRequire("kjkwu")));
function $dca91df78b4a6141$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Person".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Known uses: representing a person or user, owner, contributor.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $dca91df78b4a6141$var$PersonIcon = (props)=>/*#__PURE__*/ $dca91df78b4a6141$var$_react.default.createElement($dca91df78b4a6141$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M13.25 15v-2.25a3 3 0 0 0-3-3h-4.5a3 3 0 0 0-3 3V15m8.5-11a3.25 3.25 0 1 1-6.5 0 3.25 3.25 0 0 1 6.5 0Z"/>`
    }, props));
$dca91df78b4a6141$var$PersonIcon.displayName = 'PersonIcon';
var $dca91df78b4a6141$var$_default = $dca91df78b4a6141$exports.default = $dca91df78b4a6141$var$PersonIcon;


var $8bdd7167f43518f0$exports = {};
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2b1290bc5816db04bbec0542a218c285>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty($8bdd7167f43518f0$exports, "__esModule", {
    value: true
});
$8bdd7167f43518f0$exports.default = void 0;

var $8bdd7167f43518f0$var$_react = $8bdd7167f43518f0$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $8bdd7167f43518f0$var$_UNSAFE_baseNew = $8bdd7167f43518f0$var$_interopRequireDefault((parcelRequire("kjkwu")));
function $8bdd7167f43518f0$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Project".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for projects in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $8bdd7167f43518f0$var$ProjectIcon = (props)=>/*#__PURE__*/ $8bdd7167f43518f0$var$_react.default.createElement($8bdd7167f43518f0$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M1.25 10.25 3.5 8 1.25 5.75l.884-.884a1.25 1.25 0 0 1 .884-.366H7.25l2.384-2.384a1.25 1.25 0 0 1 .884-.366H13c.69 0 1.25.56 1.25 1.25v2.482c0 .332-.132.65-.366.884L11.5 8.75v4.232c0 .332-.132.65-.366.884l-.884.884L8 12.5l-2.25 2.25m-4.5 0 5-5"/><circle cx="11.375" cy="4.625" r="1.125" fill="currentcolor"/>`
    }, props));
$8bdd7167f43518f0$var$ProjectIcon.displayName = 'ProjectIcon';
var $8bdd7167f43518f0$var$_default = $8bdd7167f43518f0$exports.default = $8bdd7167f43518f0$var$ProjectIcon;


var $6cb2217010acc9b5$exports = {};
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::21cc5e8a48fa1ff0264c5abb7df80aa6>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty($6cb2217010acc9b5$exports, "__esModule", {
    value: true
});
$6cb2217010acc9b5$exports.default = void 0;

var $6cb2217010acc9b5$var$_react = $6cb2217010acc9b5$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $6cb2217010acc9b5$var$_UNSAFE_baseNew = $6cb2217010acc9b5$var$_interopRequireDefault((parcelRequire("kjkwu")));
function $6cb2217010acc9b5$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "SidebarCollapse".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for collapsing the navigation sidebar.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $6cb2217010acc9b5$var$SidebarCollapseIcon = (props)=>/*#__PURE__*/ $6cb2217010acc9b5$var$_react.default.createElement($6cb2217010acc9b5$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M4.75 1.75H2C1.31 1.75.75 2.31.75 3v10c0 .69.56 1.25 1.25 1.25h2.75m0-12.5H14c.69 0 1.25.56 1.25 1.25v10c0 .69-.56 1.25-1.25 1.25H4.75m0-12.5v12.5M11 5.5 8.5 8l2.5 2.5"/>`
    }, props));
$6cb2217010acc9b5$var$SidebarCollapseIcon.displayName = 'SidebarCollapseIcon';
var $6cb2217010acc9b5$var$_default = $6cb2217010acc9b5$exports.default = $6cb2217010acc9b5$var$SidebarCollapseIcon;


var $2c12de6c07289b42$exports = {};
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::67bd8e50f260741b99439472e94111fa>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty($2c12de6c07289b42$exports, "__esModule", {
    value: true
});
$2c12de6c07289b42$exports.default = void 0;

var $2c12de6c07289b42$var$_react = $2c12de6c07289b42$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $2c12de6c07289b42$var$_UNSAFE_baseNew = $2c12de6c07289b42$var$_interopRequireDefault((parcelRequire("kjkwu")));
function $2c12de6c07289b42$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "SidebarExpand".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for expanding the navigation sidebar.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $2c12de6c07289b42$var$SidebarExpandIcon = (props)=>/*#__PURE__*/ $2c12de6c07289b42$var$_react.default.createElement($2c12de6c07289b42$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M11.25 1.75H14c.69 0 1.25.56 1.25 1.25v10c0 .69-.56 1.25-1.25 1.25h-2.75m0-12.5H2C1.31 1.75.75 2.31.75 3v10c0 .69.56 1.25 1.25 1.25h9.25m0-12.5v12.5M5 5.5 7.5 8 5 10.5"/>`
    }, props));
$2c12de6c07289b42$var$SidebarExpandIcon.displayName = 'SidebarExpandIcon';
var $2c12de6c07289b42$var$_default = $2c12de6c07289b42$exports.default = $2c12de6c07289b42$var$SidebarExpandIcon;


var $6fd63047ac2df026$exports = {};
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f4906a52ca50c71ce3e4b4da49e7ade3>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty($6fd63047ac2df026$exports, "__esModule", {
    value: true
});
$6fd63047ac2df026$exports.default = void 0;

var $6fd63047ac2df026$var$_react = $6fd63047ac2df026$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $6fd63047ac2df026$var$_UNSAFE_baseNew = $6fd63047ac2df026$var$_interopRequireDefault((parcelRequire("kjkwu")));
function $6fd63047ac2df026$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "ThumbsDown".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: voting, feedback in AI.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $6fd63047ac2df026$var$ThumbsDownIcon = (props)=>/*#__PURE__*/ $6fd63047ac2df026$var$_react.default.createElement($6fd63047ac2df026$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M10.993 9.24c-1.586.69-3.176 2.118-3.176 4.234 0 1.057-4.202 1.586-2.086-3.702-1.058.475-4.98 1.747-4.98-.897 0-3.173-.25-6.346 3.98-6.346 2.453 0 4.06 0 6.036 1.267m0 0A1.25 1.25 0 0 1 12 2.75h2c.69 0 1.25.56 1.25 1.25v4.5c0 .69-.56 1.25-1.25 1.25h-2c-.69 0-1.25-.56-1.25-1.25V4q0-.105.017-.204Z"/>`
    }, props));
$6fd63047ac2df026$var$ThumbsDownIcon.displayName = 'ThumbsDownIcon';
var $6fd63047ac2df026$var$_default = $6fd63047ac2df026$exports.default = $6fd63047ac2df026$var$ThumbsDownIcon;


var $e44667cea1c125ae$exports = {};
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::fc6198fed855ec7c0bf831f638e93e94>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty($e44667cea1c125ae$exports, "__esModule", {
    value: true
});
$e44667cea1c125ae$exports.default = void 0;

var $e44667cea1c125ae$var$_react = $e44667cea1c125ae$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $e44667cea1c125ae$var$_UNSAFE_baseNew = $e44667cea1c125ae$var$_interopRequireDefault((parcelRequire("kjkwu")));
function $e44667cea1c125ae$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "ThumbsUp".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: voting options in Jira, like.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $e44667cea1c125ae$var$ThumbsUpIcon = (props)=>/*#__PURE__*/ $e44667cea1c125ae$var$_react.default.createElement($e44667cea1c125ae$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M5.007 6.76c1.586-.69 3.176-2.117 3.176-4.233 0-1.057 4.202-1.586 2.086 3.702 1.058-.475 4.981-1.747 4.981.897 0 3.173-.25 6.346-4.48 6.346-2.454 0-3.561 0-5.537-1.267m0 0A1.25 1.25 0 0 1 4 13.251H2c-.69 0-1.25-.56-1.25-1.25v-4.5c0-.69.56-1.25 1.25-1.25h2c.69 0 1.25.56 1.25 1.25v4.5q0 .105-.017.204Z"/>`
    }, props));
$e44667cea1c125ae$var$ThumbsUpIcon.displayName = 'ThumbsUpIcon';
var $e44667cea1c125ae$var$_default = $e44667cea1c125ae$exports.default = $e44667cea1c125ae$var$ThumbsUpIcon;


var $b5961c39816b4422$exports = {};
"use strict";
Object.defineProperty($b5961c39816b4422$exports, "__esModule", {
    value: true
});
$b5961c39816b4422$exports.default = void 0;

var $b5961c39816b4422$var$_react = $b5961c39816b4422$var$_interopRequireDefault((parcelRequire("5FkrB")));


var $b5961c39816b4422$var$_add = $b5961c39816b4422$var$_interopRequireDefault((parcelRequire("jzoQw")));
function $b5961c39816b4422$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $b5961c39816b4422$var$AddIcon = (props)=>/*#__PURE__*/ $b5961c39816b4422$var$_react.default.createElement($b2a18d994dfc84a8$export$3cfb73f70dfca966, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M13 11V3.993A.997.997 0 0 0 12 3c-.556 0-1 .445-1 .993V11H3.993A.997.997 0 0 0 3 12c0 .557.445 1 .993 1H11v7.007c0 .548.448.993 1 .993.556 0 1-.445 1-.993V13h7.007A.997.997 0 0 0 21 12c0-.556-.445-1-.993-1z"/></svg>`
    }, props, {
        newIcon: $b5961c39816b4422$var$_add.default
    }));
$b5961c39816b4422$var$AddIcon.displayName = 'AddIcon';
var $b5961c39816b4422$var$_default = $b5961c39816b4422$exports.default = $b5961c39816b4422$var$AddIcon;


var $80468d1e7c2b9ea5$exports = {};
"use strict";
Object.defineProperty($80468d1e7c2b9ea5$exports, "__esModule", {
    value: true
});
$80468d1e7c2b9ea5$exports.default = void 0;

var $80468d1e7c2b9ea5$var$_react = $80468d1e7c2b9ea5$var$_interopRequireDefault((parcelRequire("5FkrB")));


var $80468d1e7c2b9ea5$var$_add = $80468d1e7c2b9ea5$var$_interopRequireDefault((parcelRequire("jzoQw")));
function $80468d1e7c2b9ea5$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $80468d1e7c2b9ea5$var$AddCircleIcon = (props)=>/*#__PURE__*/ $80468d1e7c2b9ea5$var$_react.default.createElement($b2a18d994dfc84a8$export$3cfb73f70dfca966, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><circle cx="12" cy="12" r="10" fill="currentcolor"/><path fill="inherit" d="M11.046 7.958v3.088H7.958a.954.954 0 1 0 0 1.908h3.088v3.088a.954.954 0 1 0 1.908 0v-3.088h3.088a.954.954 0 1 0 0-1.908h-3.088V7.958a.954.954 0 1 0-1.908 0"/></g></svg>`
    }, props, {
        newIcon: $80468d1e7c2b9ea5$var$_add.default
    }));
$80468d1e7c2b9ea5$var$AddCircleIcon.displayName = 'AddCircleIcon';
var $80468d1e7c2b9ea5$var$_default = $80468d1e7c2b9ea5$exports.default = $80468d1e7c2b9ea5$var$AddCircleIcon;


var $ab7ea44a501f28f2$exports = {};
"use strict";
Object.defineProperty($ab7ea44a501f28f2$exports, "__esModule", {
    value: true
});
$ab7ea44a501f28f2$exports.default = void 0;

var $ab7ea44a501f28f2$var$_react = $ab7ea44a501f28f2$var$_interopRequireDefault((parcelRequire("5FkrB")));


var $ab7ea44a501f28f2$var$_arrowLeft = $ab7ea44a501f28f2$var$_interopRequireDefault((parcelRequire("8h205")));
function $ab7ea44a501f28f2$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $ab7ea44a501f28f2$var$ArrowLeftCircleIcon = (props)=>/*#__PURE__*/ $ab7ea44a501f28f2$var$_react.default.createElement($b2a18d994dfc84a8$export$3cfb73f70dfca966, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><circle cx="12" cy="12" r="10" fill="currentcolor"/><path fill="inherit" d="M16 10.995h-5.586l1.272-1.279a1.01 1.01 0 0 0 0-1.421.996.996 0 0 0-1.415 0l-2.978 2.994a1.01 1.01 0 0 0 0 1.423l2.978 2.993a1 1 0 0 0 1.415 0 1.01 1.01 0 0 0 0-1.421l-1.272-1.279H16c.552 0 1-.45 1-1.005s-.448-1.005-1-1.005"/></svg>`
    }, props, {
        newIcon: $ab7ea44a501f28f2$var$_arrowLeft.default
    }));
$ab7ea44a501f28f2$var$ArrowLeftCircleIcon.displayName = 'ArrowLeftCircleIcon';
var $ab7ea44a501f28f2$var$_default = $ab7ea44a501f28f2$exports.default = $ab7ea44a501f28f2$var$ArrowLeftCircleIcon;


var $ef54ef72c2befbb2$exports = {};
"use strict";
Object.defineProperty($ef54ef72c2befbb2$exports, "__esModule", {
    value: true
});
$ef54ef72c2befbb2$exports.default = void 0;

var $ef54ef72c2befbb2$var$_react = $ef54ef72c2befbb2$var$_interopRequireDefault((parcelRequire("5FkrB")));


var $ef54ef72c2befbb2$var$_arrowRight = $ef54ef72c2befbb2$var$_interopRequireDefault((parcelRequire("gNhoZ")));
function $ef54ef72c2befbb2$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $ef54ef72c2befbb2$var$ArrowRightIcon = (props)=>/*#__PURE__*/ $ef54ef72c2befbb2$var$_react.default.createElement($b2a18d994dfc84a8$export$3cfb73f70dfca966, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M11.793 5.793a1 1 0 0 0 0 1.414L15.586 11H6a1 1 0 0 0 0 2h9.586l-3.793 3.793a1 1 0 0 0 0 1.414c.39.39 1.024.39 1.415 0l5.499-5.5a1 1 0 0 0 .293-.679v-.057a1 1 0 0 0-.293-.678l-5.499-5.5a1 1 0 0 0-1.415 0"/></svg>`
    }, props, {
        newIcon: $ef54ef72c2befbb2$var$_arrowRight.default
    }));
$ef54ef72c2befbb2$var$ArrowRightIcon.displayName = 'ArrowRightIcon';
var $ef54ef72c2befbb2$var$_default = $ef54ef72c2befbb2$exports.default = $ef54ef72c2befbb2$var$ArrowRightIcon;


var $765511c537d8b39f$exports = {};
"use strict";
Object.defineProperty($765511c537d8b39f$exports, "__esModule", {
    value: true
});
$765511c537d8b39f$exports.default = void 0;

var $765511c537d8b39f$var$_react = $765511c537d8b39f$var$_interopRequireDefault((parcelRequire("5FkrB")));


var $765511c537d8b39f$var$_arrowRight = $765511c537d8b39f$var$_interopRequireDefault((parcelRequire("gNhoZ")));
function $765511c537d8b39f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $765511c537d8b39f$var$ArrowRightCircleIcon = (props)=>/*#__PURE__*/ $765511c537d8b39f$var$_react.default.createElement($b2a18d994dfc84a8$export$3cfb73f70dfca966, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><circle cx="12" cy="12" r="10" fill="currentcolor" fill-rule="nonzero"/><path fill="inherit" d="M12.314 8.294a1.01 1.01 0 0 0 0 1.422l1.271 1.279H8c-.553 0-1.001.45-1.001 1.005S7.447 13.005 8 13.005h5.585l-1.271 1.279a1.01 1.01 0 0 0 0 1.422 1 1 0 0 0 1.415 0l2.978-2.995a1.01 1.01 0 0 0 0-1.422l-2.978-2.995a1 1 0 0 0-1.415 0"/></g></svg>`
    }, props, {
        newIcon: $765511c537d8b39f$var$_arrowRight.default
    }));
$765511c537d8b39f$var$ArrowRightCircleIcon.displayName = 'ArrowRightCircleIcon';
var $765511c537d8b39f$var$_default = $765511c537d8b39f$exports.default = $765511c537d8b39f$var$ArrowRightCircleIcon;


var $3aadf204787505be$exports = {};
"use strict";
Object.defineProperty($3aadf204787505be$exports, "__esModule", {
    value: true
});
$3aadf204787505be$exports.default = void 0;

var $3aadf204787505be$var$_react = $3aadf204787505be$var$_interopRequireDefault((parcelRequire("5FkrB")));


var $3aadf204787505be$var$_arrowUp = $3aadf204787505be$var$_interopRequireDefault((parcelRequire("daJf6")));
function $3aadf204787505be$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $3aadf204787505be$var$ArrowUpIcon = (props)=>/*#__PURE__*/ $3aadf204787505be$var$_react.default.createElement($b2a18d994dfc84a8$export$3cfb73f70dfca966, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m11.293 5.293-5.5 5.499a1 1 0 0 0 0 1.415 1 1 0 0 0 1.414 0L11 8.414V18a1 1 0 0 0 2 0V8.414l3.793 3.793a1 1 0 1 0 1.414-1.415l-5.5-5.499A1 1 0 0 0 12 5a1 1 0 0 0-.707.293"/></svg>`
    }, props, {
        newIcon: $3aadf204787505be$var$_arrowUp.default
    }));
$3aadf204787505be$var$ArrowUpIcon.displayName = 'ArrowUpIcon';
var $3aadf204787505be$var$_default = $3aadf204787505be$exports.default = $3aadf204787505be$var$ArrowUpIcon;


var $448a87733afcd5e7$exports = {};
"use strict";
Object.defineProperty($448a87733afcd5e7$exports, "__esModule", {
    value: true
});
$448a87733afcd5e7$exports.default = void 0;

var $448a87733afcd5e7$var$_react = $448a87733afcd5e7$var$_interopRequireDefault((parcelRequire("5FkrB")));


var $448a87733afcd5e7$var$_arrowUp = $448a87733afcd5e7$var$_interopRequireDefault((parcelRequire("daJf6")));
function $448a87733afcd5e7$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $448a87733afcd5e7$var$ArrowUpCircleIcon = (props)=>/*#__PURE__*/ $448a87733afcd5e7$var$_react.default.createElement($b2a18d994dfc84a8$export$3cfb73f70dfca966, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><circle cx="12" cy="12" r="10" fill="currentcolor" fill-rule="nonzero"/><path fill="inherit" d="M11.288 7.293 8.294 10.27a1 1 0 0 0 0 1.416 1.01 1.01 0 0 0 1.421 0l1.279-1.272V16c0 .552.451 1 1.006 1s1.005-.448 1.005-1v-5.586l1.279 1.272a1.01 1.01 0 0 0 1.421 0 1 1 0 0 0 0-1.416l-2.994-2.977a1.01 1.01 0 0 0-1.423 0"/></g></svg>`
    }, props, {
        newIcon: $448a87733afcd5e7$var$_arrowUp.default
    }));
$448a87733afcd5e7$var$ArrowUpCircleIcon.displayName = 'ArrowUpCircleIcon';
var $448a87733afcd5e7$var$_default = $448a87733afcd5e7$exports.default = $448a87733afcd5e7$var$ArrowUpCircleIcon;


var $2f24676d61ca54c3$exports = {};
"use strict";
Object.defineProperty($2f24676d61ca54c3$exports, "__esModule", {
    value: true
});
$2f24676d61ca54c3$exports.default = void 0;

var $2f24676d61ca54c3$var$_react = $2f24676d61ca54c3$var$_interopRequireDefault((parcelRequire("5FkrB")));

function $2f24676d61ca54c3$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $2f24676d61ca54c3$var$BitbucketBuildsIcon = (props)=>/*#__PURE__*/ $2f24676d61ca54c3$var$_react.default.createElement($b2a18d994dfc84a8$export$3cfb73f70dfca966, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor"><path d="M10 5a1 1 0 0 0 1 1h3.01a1 1 0 0 0 0-2H11c-.55 0-1 .45-1 1M8 5c0-1.66 1.35-3 3-3h3.01a3 3 0 0 1 0 6H11a3 3 0 0 1-3-3m2 7a1 1 0 0 0 1 1h3.01a1 1 0 0 0 0-2H11c-.55 0-1 .45-1 1m-2 0c0-1.66 1.35-3 3-3h3.01a3 3 0 0 1 0 6H11a3 3 0 0 1-3-3m2 7a1 1 0 0 0 1 1h3.01a1 1 0 0 0 0-2H11c-.55 0-1 .45-1 1m-2 0c0-1.66 1.35-3 3-3h3.01a3 3 0 0 1 0 6H11a3 3 0 0 1-3-3"/><path d="M16.06 6h2.42c.81 0 1.47.66 1.47 1.47v1.95c0 .82-.65 1.47-1.47 1.47H16v2h2.47a3.47 3.47 0 0 0 3.48-3.47V7.47A3.47 3.47 0 0 0 18.48 4h-2.41zm-7.17 5H6.47A3.47 3.47 0 0 0 3 14.47v1.95c0 1.92 1.55 3.47 3.47 3.47h2.48v-2H6.47c-.82 0-1.47-.65-1.47-1.47v-1.95c0-.81.66-1.47 1.47-1.47h2.42z"/></g></svg>`
    }, props));
$2f24676d61ca54c3$var$BitbucketBuildsIcon.displayName = 'BitbucketBuildsIcon';
var $2f24676d61ca54c3$var$_default = $2f24676d61ca54c3$exports.default = $2f24676d61ca54c3$var$BitbucketBuildsIcon;


var $a422246a5e1d8639$exports = {};
"use strict";
Object.defineProperty($a422246a5e1d8639$exports, "__esModule", {
    value: true
});
$a422246a5e1d8639$exports.default = void 0;

var $a422246a5e1d8639$var$_react = $a422246a5e1d8639$var$_interopRequireDefault((parcelRequire("5FkrB")));


var $a422246a5e1d8639$var$_checkMark = $a422246a5e1d8639$var$_interopRequireDefault((parcelRequire("6HR91")));
function $a422246a5e1d8639$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $a422246a5e1d8639$var$CheckIcon = (props)=>/*#__PURE__*/ $a422246a5e1d8639$var$_react.default.createElement($b2a18d994dfc84a8$export$3cfb73f70dfca966, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M6.735 12.322a1 1 0 0 0-1.47 1.356l3.612 3.919c.537.526 1.337.526 1.834.03l.364-.359a2336 2336 0 0 0 3.939-3.883l.04-.04a493 493 0 0 0 3.658-3.643 1 1 0 0 0-1.424-1.404 518 518 0 0 1-3.64 3.625l-.04.04a2049 2049 0 0 1-3.775 3.722z"/></svg>`
    }, props, {
        newIcon: $a422246a5e1d8639$var$_checkMark.default
    }));
$a422246a5e1d8639$var$CheckIcon.displayName = 'CheckIcon';
var $a422246a5e1d8639$var$_default = $a422246a5e1d8639$exports.default = $a422246a5e1d8639$var$CheckIcon;


var $82e5711ea901f746$exports = {};
"use strict";
Object.defineProperty($82e5711ea901f746$exports, "__esModule", {
    value: true
});
$82e5711ea901f746$exports.default = void 0;

var $82e5711ea901f746$var$_react = $82e5711ea901f746$var$_interopRequireDefault((parcelRequire("5FkrB")));


var $82e5711ea901f746$var$_success = $82e5711ea901f746$var$_interopRequireDefault((parcelRequire("bOyku")));
function $82e5711ea901f746$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $82e5711ea901f746$var$CheckCircleIcon = (props)=>/*#__PURE__*/ $82e5711ea901f746$var$_react.default.createElement($b2a18d994dfc84a8$export$3cfb73f70dfca966, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><circle cx="12" cy="12" r="10" fill="currentcolor"/><path fill="inherit" d="M9.707 11.293a1 1 0 1 0-1.414 1.414l2 2a1 1 0 0 0 1.414 0l4-4a1 1 0 1 0-1.414-1.414L11 12.586z"/></g></svg>`
    }, props, {
        newIcon: $82e5711ea901f746$var$_success.default
    }));
$82e5711ea901f746$var$CheckCircleIcon.displayName = 'CheckCircleIcon';
var $82e5711ea901f746$var$_default = $82e5711ea901f746$exports.default = $82e5711ea901f746$var$CheckCircleIcon;


var $1bc5b5a4a06fb4d5$exports = {};
"use strict";
Object.defineProperty($1bc5b5a4a06fb4d5$exports, "__esModule", {
    value: true
});
$1bc5b5a4a06fb4d5$exports.default = void 0;

var $1bc5b5a4a06fb4d5$var$_react = $1bc5b5a4a06fb4d5$var$_interopRequireDefault((parcelRequire("5FkrB")));


var $1bc5b5a4a06fb4d5$var$_checkCircle = $1bc5b5a4a06fb4d5$var$_interopRequireDefault((parcelRequire("1Eagz")));
function $1bc5b5a4a06fb4d5$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $1bc5b5a4a06fb4d5$var$CheckCircleOutlineIcon = (props)=>/*#__PURE__*/ $1bc5b5a4a06fb4d5$var$_react.default.createElement($b2a18d994dfc84a8$export$3cfb73f70dfca966, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path fill-rule="nonzero" d="M12 20a8 8 0 1 0 0-16 8 8 0 0 0 0 16m0 2C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10"/><path d="M9.707 11.293a1 1 0 1 0-1.414 1.414l2 2a1 1 0 0 0 1.414 0l4-4a1 1 0 1 0-1.414-1.414L11 12.586z"/></g></svg>`
    }, props, {
        newIcon: $1bc5b5a4a06fb4d5$var$_checkCircle.default
    }));
$1bc5b5a4a06fb4d5$var$CheckCircleOutlineIcon.displayName = 'CheckCircleOutlineIcon';
var $1bc5b5a4a06fb4d5$var$_default = $1bc5b5a4a06fb4d5$exports.default = $1bc5b5a4a06fb4d5$var$CheckCircleOutlineIcon;


var $338f005fcf21bc2f$exports = {};
"use strict";
Object.defineProperty($338f005fcf21bc2f$exports, "__esModule", {
    value: true
});
$338f005fcf21bc2f$exports.default = void 0;

var $338f005fcf21bc2f$var$_react = $338f005fcf21bc2f$var$_interopRequireDefault((parcelRequire("5FkrB")));


var $338f005fcf21bc2f$var$_chevronDown = $338f005fcf21bc2f$var$_interopRequireDefault((parcelRequire("1u6rG")));
function $338f005fcf21bc2f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $338f005fcf21bc2f$var$ChevronDownIcon = (props)=>/*#__PURE__*/ $338f005fcf21bc2f$var$_react.default.createElement($b2a18d994dfc84a8$export$3cfb73f70dfca966, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M8.292 10.293a1.01 1.01 0 0 0 0 1.419l2.939 2.965c.218.215.5.322.779.322s.556-.107.769-.322l2.93-2.955a1.01 1.01 0 0 0 0-1.419.987.987 0 0 0-1.406 0l-2.298 2.317-2.307-2.327a.99.99 0 0 0-1.406 0"/></svg>`
    }, props, {
        newIcon: $338f005fcf21bc2f$var$_chevronDown.default,
        iconType: "utility"
    }));
$338f005fcf21bc2f$var$ChevronDownIcon.displayName = 'ChevronDownIcon';
var $338f005fcf21bc2f$var$_default = $338f005fcf21bc2f$exports.default = $338f005fcf21bc2f$var$ChevronDownIcon;


var $c56e8f25e4743e9f$exports = {};
"use strict";
Object.defineProperty($c56e8f25e4743e9f$exports, "__esModule", {
    value: true
});
$c56e8f25e4743e9f$exports.default = void 0;

var $c56e8f25e4743e9f$var$_react = $c56e8f25e4743e9f$var$_interopRequireDefault((parcelRequire("5FkrB")));


var $c56e8f25e4743e9f$var$_chevronDown = $c56e8f25e4743e9f$var$_interopRequireDefault((parcelRequire("1u6rG")));
function $c56e8f25e4743e9f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $c56e8f25e4743e9f$var$ChevronDownCircleIcon = (props)=>/*#__PURE__*/ $c56e8f25e4743e9f$var$_react.default.createElement($b2a18d994dfc84a8$export$3cfb73f70dfca966, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><circle cx="12" cy="12" r="10" fill="currentcolor"/><path fill="inherit" d="M8.292 10.293a1.01 1.01 0 0 0 0 1.419l2.939 2.965c.218.215.5.322.779.322s.556-.107.769-.322l2.93-2.955a1.01 1.01 0 0 0 0-1.419.987.987 0 0 0-1.406 0l-2.298 2.317-2.307-2.327a.99.99 0 0 0-1.406 0"/></g></svg>`
    }, props, {
        newIcon: $c56e8f25e4743e9f$var$_chevronDown.default,
        iconType: "utility"
    }));
$c56e8f25e4743e9f$var$ChevronDownCircleIcon.displayName = 'ChevronDownCircleIcon';
var $c56e8f25e4743e9f$var$_default = $c56e8f25e4743e9f$exports.default = $c56e8f25e4743e9f$var$ChevronDownCircleIcon;


var $c6f2693d39d6404a$exports = {};
"use strict";
Object.defineProperty($c6f2693d39d6404a$exports, "__esModule", {
    value: true
});
$c6f2693d39d6404a$exports.default = void 0;

var $c6f2693d39d6404a$var$_react = $c6f2693d39d6404a$var$_interopRequireDefault((parcelRequire("5FkrB")));


var $c6f2693d39d6404a$var$_chevronLeft = $c6f2693d39d6404a$var$_interopRequireDefault((parcelRequire("79sHj")));
function $c6f2693d39d6404a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $c6f2693d39d6404a$var$ChevronLeftIcon = (props)=>/*#__PURE__*/ $c6f2693d39d6404a$var$_react.default.createElement($b2a18d994dfc84a8$export$3cfb73f70dfca966, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M13.706 9.698a.99.99 0 0 0 0-1.407 1.01 1.01 0 0 0-1.419 0l-2.965 2.94a1.09 1.09 0 0 0 0 1.548l2.955 2.93a1.01 1.01 0 0 0 1.42 0 .99.99 0 0 0 0-1.407l-2.318-2.297z"/></svg>`
    }, props, {
        newIcon: $c6f2693d39d6404a$var$_chevronLeft.default,
        iconType: "utility"
    }));
$c6f2693d39d6404a$var$ChevronLeftIcon.displayName = 'ChevronLeftIcon';
var $c6f2693d39d6404a$var$_default = $c6f2693d39d6404a$exports.default = $c6f2693d39d6404a$var$ChevronLeftIcon;


var $3ad42b18b75fd487$exports = {};
"use strict";
Object.defineProperty($3ad42b18b75fd487$exports, "__esModule", {
    value: true
});
$3ad42b18b75fd487$exports.default = void 0;

var $3ad42b18b75fd487$var$_react = $3ad42b18b75fd487$var$_interopRequireDefault((parcelRequire("5FkrB")));


var $3ad42b18b75fd487$var$_chevronLeft = $3ad42b18b75fd487$var$_interopRequireDefault((parcelRequire("79sHj")));
function $3ad42b18b75fd487$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $3ad42b18b75fd487$var$ChevronLeftLargeIcon = (props)=>/*#__PURE__*/ $3ad42b18b75fd487$var$_react.default.createElement($b2a18d994dfc84a8$export$3cfb73f70dfca966, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m9.005 10.995 4.593-4.593a.99.99 0 1 1 1.4 1.4l-3.9 3.9 3.9 3.9a.99.99 0 0 1-1.4 1.4L9.005 12.41a1 1 0 0 1 0-1.414"/></svg>`
    }, props, {
        newIcon: $3ad42b18b75fd487$var$_chevronLeft.default,
        iconType: "utility"
    }));
$3ad42b18b75fd487$var$ChevronLeftLargeIcon.displayName = 'ChevronLeftLargeIcon';
var $3ad42b18b75fd487$var$_default = $3ad42b18b75fd487$exports.default = $3ad42b18b75fd487$var$ChevronLeftLargeIcon;


var $0d48a3e8127c741d$exports = {};
"use strict";
Object.defineProperty($0d48a3e8127c741d$exports, "__esModule", {
    value: true
});
$0d48a3e8127c741d$exports.default = void 0;

var $0d48a3e8127c741d$var$_react = $0d48a3e8127c741d$var$_interopRequireDefault((parcelRequire("5FkrB")));


var $0d48a3e8127c741d$var$_chevronRight = $0d48a3e8127c741d$var$_interopRequireDefault((parcelRequire("61RFB")));
function $0d48a3e8127c741d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $0d48a3e8127c741d$var$ChevronRightIcon = (props)=>/*#__PURE__*/ $0d48a3e8127c741d$var$_react.default.createElement($b2a18d994dfc84a8$export$3cfb73f70dfca966, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M10.294 9.698a.99.99 0 0 1 0-1.407 1.01 1.01 0 0 1 1.419 0l2.965 2.94a1.09 1.09 0 0 1 0 1.548l-2.955 2.93a1.01 1.01 0 0 1-1.42 0 .99.99 0 0 1 0-1.407l2.318-2.297z"/></svg>`
    }, props, {
        newIcon: $0d48a3e8127c741d$var$_chevronRight.default,
        iconType: "utility"
    }));
$0d48a3e8127c741d$var$ChevronRightIcon.displayName = 'ChevronRightIcon';
var $0d48a3e8127c741d$var$_default = $0d48a3e8127c741d$exports.default = $0d48a3e8127c741d$var$ChevronRightIcon;


var $133983fce38e52e1$exports = {};
"use strict";
Object.defineProperty($133983fce38e52e1$exports, "__esModule", {
    value: true
});
$133983fce38e52e1$exports.default = void 0;

var $133983fce38e52e1$var$_react = $133983fce38e52e1$var$_interopRequireDefault((parcelRequire("5FkrB")));


var $133983fce38e52e1$var$_chevronUp = $133983fce38e52e1$var$_interopRequireDefault((parcelRequire("cRECB")));
function $133983fce38e52e1$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $133983fce38e52e1$var$ChevronUpIcon = (props)=>/*#__PURE__*/ $133983fce38e52e1$var$_react.default.createElement($b2a18d994dfc84a8$export$3cfb73f70dfca966, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m11.221 9.322-2.929 2.955a1.01 1.01 0 0 0 0 1.419.986.986 0 0 0 1.405 0l2.298-2.317 2.307 2.327a.99.99 0 0 0 1.407 0 1.01 1.01 0 0 0 0-1.419l-2.94-2.965A1.1 1.1 0 0 0 11.991 9c-.279 0-.557.107-.77.322"/></svg>`
    }, props, {
        newIcon: $133983fce38e52e1$var$_chevronUp.default,
        iconType: "utility"
    }));
$133983fce38e52e1$var$ChevronUpIcon.displayName = 'ChevronUpIcon';
var $133983fce38e52e1$var$_default = $133983fce38e52e1$exports.default = $133983fce38e52e1$var$ChevronUpIcon;


var $11c02ff49b8a774f$exports = {};
"use strict";
Object.defineProperty($11c02ff49b8a774f$exports, "__esModule", {
    value: true
});
$11c02ff49b8a774f$exports.default = void 0;

var $11c02ff49b8a774f$var$_react = $11c02ff49b8a774f$var$_interopRequireDefault((parcelRequire("5FkrB")));


var $11c02ff49b8a774f$var$_copy = $11c02ff49b8a774f$var$_interopRequireDefault((parcelRequire("5xSGp")));
function $11c02ff49b8a774f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $11c02ff49b8a774f$var$CopyIcon = (props)=>/*#__PURE__*/ $11c02ff49b8a774f$var$_react.default.createElement($b2a18d994dfc84a8$export$3cfb73f70dfca966, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor"><path d="M10 19h8V8h-8zM8 7.992C8 6.892 8.902 6 10.009 6h7.982C19.101 6 20 6.893 20 7.992v11.016c0 1.1-.902 1.992-2.009 1.992H10.01A2 2 0 0 1 8 19.008z"/><path d="M5 16V4.992C5 3.892 5.902 3 7.009 3H15v13zm2 0h8V5H7z"/></g></svg>`
    }, props, {
        newIcon: $11c02ff49b8a774f$var$_copy.default
    }));
$11c02ff49b8a774f$var$CopyIcon.displayName = 'CopyIcon';
var $11c02ff49b8a774f$var$_default = $11c02ff49b8a774f$exports.default = $11c02ff49b8a774f$var$CopyIcon;


var $62eae3fe425ce462$exports = {};
"use strict";
Object.defineProperty($62eae3fe425ce462$exports, "__esModule", {
    value: true
});
$62eae3fe425ce462$exports.default = void 0;

var $62eae3fe425ce462$var$_react = $62eae3fe425ce462$var$_interopRequireDefault((parcelRequire("5FkrB")));


var $62eae3fe425ce462$var$_download = $62eae3fe425ce462$var$_interopRequireDefault((parcelRequire("6KNbq")));
function $62eae3fe425ce462$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $62eae3fe425ce462$var$DownloadIcon = (props)=>/*#__PURE__*/ $62eae3fe425ce462$var$_react.default.createElement($b2a18d994dfc84a8$export$3cfb73f70dfca966, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path fill-rule="nonzero" d="M10.687 17.292a.983.983 0 0 0-1.397 0 1 1 0 0 0 0 1.407l1.964 1.98a1.08 1.08 0 0 0 1.538 0l1.919-1.933a1 1 0 0 0 0-1.408.983.983 0 0 0-1.398 0l-1.29 1.3z"/><path fill-rule="nonzero" d="M13.001 19.993 13 10.006C13 9.451 12.552 9 12 9s-1 .45-1 1.007l.001 9.987c0 .555.448 1.006 1 1.006s1-.45 1-1.007"/><path d="M7.938 5.48a5 5 0 0 0-.777-.062C4.356 5.418 2 7.62 2 10.498 2 13.409 4.385 16 7.1 16h2.881v-1.993H7.1c-1.657 0-3.115-1.663-3.115-3.508 0-1.778 1.469-3.087 3.104-3.087h.012c.389 0 .686.05.97.15l.17.063c.605.248.875-.246.875-.246l.15-.267c.73-1.347 2.201-2.096 3.716-2.12a4.14 4.14 0 0 1 4.069 3.645l.046.34s.071.525.665.525c.013 0 .012.005.023.005h.254c1.136 0 1.976.959 1.976 2.158 0 1.207-.987 2.342-2.07 2.342h-3.964V16h3.964C20.105 16 22 13.955 22 11.665c0-2-1.312-3.663-3.138-4.074-.707-2.707-3.053-4.552-5.886-4.591-1.975.02-3.901.9-5.038 2.48"/></g></svg>`
    }, props, {
        newIcon: $62eae3fe425ce462$var$_download.default
    }));
$62eae3fe425ce462$var$DownloadIcon.displayName = 'DownloadIcon';
var $62eae3fe425ce462$var$_default = $62eae3fe425ce462$exports.default = $62eae3fe425ce462$var$DownloadIcon;


var $90cabb7428efe8f9$exports = {};
"use strict";
Object.defineProperty($90cabb7428efe8f9$exports, "__esModule", {
    value: true
});
$90cabb7428efe8f9$exports.default = void 0;

var $90cabb7428efe8f9$var$_react = $90cabb7428efe8f9$var$_interopRequireDefault((parcelRequire("5FkrB")));


var $90cabb7428efe8f9$var$_edit = $90cabb7428efe8f9$var$_interopRequireDefault((parcelRequire("7mI24")));
function $90cabb7428efe8f9$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $90cabb7428efe8f9$var$EditIcon = (props)=>/*#__PURE__*/ $90cabb7428efe8f9$var$_react.default.createElement($b2a18d994dfc84a8$export$3cfb73f70dfca966, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M4.02 19.23a1 1 0 0 0 1.18 1.18l3.81-.78-4.21-4.21zm5.92-2.62-2.12-2.12L16.31 6l2.12 2.12zm9.9-9.9-2.12-2.12A2 2 0 0 0 16.31 4c-.51 0-1.02.2-1.41.59l-9.76 9.76 4.95 4.95 9.76-9.76a2 2 0 0 0 0-2.83"/></svg>`
    }, props, {
        newIcon: $90cabb7428efe8f9$var$_edit.default
    }));
$90cabb7428efe8f9$var$EditIcon.displayName = 'EditIcon';
var $90cabb7428efe8f9$var$_default = $90cabb7428efe8f9$exports.default = $90cabb7428efe8f9$var$EditIcon;


var $20ca2d7ff5212edb$exports = {};
"use strict";
Object.defineProperty($20ca2d7ff5212edb$exports, "__esModule", {
    value: true
});
$20ca2d7ff5212edb$exports.default = void 0;

var $20ca2d7ff5212edb$var$_react = $20ca2d7ff5212edb$var$_interopRequireDefault((parcelRequire("5FkrB")));


var $20ca2d7ff5212edb$var$_edit = $20ca2d7ff5212edb$var$_interopRequireDefault((parcelRequire("7mI24")));
function $20ca2d7ff5212edb$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $20ca2d7ff5212edb$var$EditFilledIcon = (props)=>/*#__PURE__*/ $20ca2d7ff5212edb$var$_react.default.createElement($b2a18d994dfc84a8$export$3cfb73f70dfca966, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M4.02 19.23a1 1 0 0 0 1.18 1.18l3.81-.78-4.21-4.21zM19.84 6.71l-2.12-2.12A2 2 0 0 0 16.31 4c-.51 0-1.02.2-1.41.59l-9.76 9.76 4.95 4.95 9.76-9.76a2 2 0 0 0 0-2.83"/></svg>`
    }, props, {
        newIcon: $20ca2d7ff5212edb$var$_edit.default
    }));
$20ca2d7ff5212edb$var$EditFilledIcon.displayName = 'EditFilledIcon';
var $20ca2d7ff5212edb$var$_default = $20ca2d7ff5212edb$exports.default = $20ca2d7ff5212edb$var$EditFilledIcon;


var $678fbedc7d92a99f$exports = {};
"use strict";
Object.defineProperty($678fbedc7d92a99f$exports, "__esModule", {
    value: true
});
$678fbedc7d92a99f$exports.default = void 0;

var $678fbedc7d92a99f$var$_react = $678fbedc7d92a99f$var$_interopRequireDefault((parcelRequire("5FkrB")));


var $678fbedc7d92a99f$var$_close = $678fbedc7d92a99f$var$_interopRequireDefault((parcelRequire("iNMs5")));
function $678fbedc7d92a99f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $678fbedc7d92a99f$var$EditorCloseIcon = (props)=>/*#__PURE__*/ $678fbedc7d92a99f$var$_react.default.createElement($b2a18d994dfc84a8$export$3cfb73f70dfca966, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m15.185 7.4-3.184 3.185-3.186-3.186a.507.507 0 0 0-.712.003l-.7.701a.496.496 0 0 0-.004.712l3.185 3.184L7.4 15.185a.507.507 0 0 0 .004.712l.7.7c.206.207.516.2.712.004l3.186-3.185 3.184 3.185a.507.507 0 0 0 .712-.004l.701-.7a.496.496 0 0 0 .003-.712l-3.186-3.186 3.186-3.184a.507.507 0 0 0-.003-.712l-.7-.7a.5.5 0 0 0-.36-.153.5.5 0 0 0-.353.15"/></svg>`
    }, props, {
        newIcon: $678fbedc7d92a99f$var$_close.default
    }));
$678fbedc7d92a99f$var$EditorCloseIcon.displayName = 'EditorCloseIcon';
var $678fbedc7d92a99f$var$_default = $678fbedc7d92a99f$exports.default = $678fbedc7d92a99f$var$EditorCloseIcon;


var $bcbb92898bcdb6db$exports = {};
"use strict";
Object.defineProperty($bcbb92898bcdb6db$exports, "__esModule", {
    value: true
});
$bcbb92898bcdb6db$exports.default = void 0;

var $bcbb92898bcdb6db$var$_react = $bcbb92898bcdb6db$var$_interopRequireDefault((parcelRequire("5FkrB")));


var $bcbb92898bcdb6db$var$_contentWrapRight = $bcbb92898bcdb6db$var$_interopRequireDefault((parcelRequire("kR2ul")));
function $bcbb92898bcdb6db$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $bcbb92898bcdb6db$var$EditorMediaWrapRightIcon = (props)=>/*#__PURE__*/ $bcbb92898bcdb6db$var$_react.default.createElement($b2a18d994dfc84a8$export$3cfb73f70dfca966, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M6 17h12a1 1 0 0 1 0 2H6a1 1 0 0 1 0-2m0-8h4a1 1 0 0 1 0 2H6a1 1 0 0 1 0-2m0 4h4a1 1 0 0 1 0 2H6a1 1 0 0 1 0-2m8-4h4a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1h-4a1 1 0 0 1-1-1v-4a1 1 0 0 1 1-1M6 5h12a1 1 0 0 1 0 2H6a1 1 0 1 1 0-2"/></svg>`
    }, props, {
        newIcon: $bcbb92898bcdb6db$var$_contentWrapRight.default
    }));
$bcbb92898bcdb6db$var$EditorMediaWrapRightIcon.displayName = 'EditorMediaWrapRightIcon';
var $bcbb92898bcdb6db$var$_default = $bcbb92898bcdb6db$exports.default = $bcbb92898bcdb6db$var$EditorMediaWrapRightIcon;


var $4ee3e0b98b22e4b3$exports = {};
"use strict";
Object.defineProperty($4ee3e0b98b22e4b3$exports, "__esModule", {
    value: true
});
$4ee3e0b98b22e4b3$exports.default = void 0;

var $4ee3e0b98b22e4b3$var$_react = $4ee3e0b98b22e4b3$var$_interopRequireDefault((parcelRequire("5FkrB")));


var $4ee3e0b98b22e4b3$var$_arrowUpRight = $4ee3e0b98b22e4b3$var$_interopRequireDefault((parcelRequire("kdnK6")));
function $4ee3e0b98b22e4b3$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $4ee3e0b98b22e4b3$var$EditorOpenIcon = (props)=>/*#__PURE__*/ $4ee3e0b98b22e4b3$var$_react.default.createElement($b2a18d994dfc84a8$export$3cfb73f70dfca966, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M9.873 7.63c-.28 0-.344.159-.147.357l2.436 2.436-4.386 4.386a.51.51 0 0 0 0 .713l.7.7a.495.495 0 0 0 .713.001l4.387-4.386 2.436 2.436c.197.197.357.124.357-.147V8.133a.507.507 0 0 0-.503-.503z"/></svg>`
    }, props, {
        newIcon: $4ee3e0b98b22e4b3$var$_arrowUpRight.default
    }));
$4ee3e0b98b22e4b3$var$EditorOpenIcon.displayName = 'EditorOpenIcon';
var $4ee3e0b98b22e4b3$var$_default = $4ee3e0b98b22e4b3$exports.default = $4ee3e0b98b22e4b3$var$EditorOpenIcon;


var $0879f860d82e1dc1$exports = {};
"use strict";
Object.defineProperty($0879f860d82e1dc1$exports, "__esModule", {
    value: true
});
$0879f860d82e1dc1$exports.default = void 0;

var $0879f860d82e1dc1$var$_react = $0879f860d82e1dc1$var$_interopRequireDefault((parcelRequire("5FkrB")));


var $0879f860d82e1dc1$var$_information = $0879f860d82e1dc1$var$_interopRequireDefault((parcelRequire("9lQhd")));
function $0879f860d82e1dc1$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $0879f860d82e1dc1$var$EditorPanelIcon = (props)=>/*#__PURE__*/ $0879f860d82e1dc1$var$_react.default.createElement($b2a18d994dfc84a8$export$3cfb73f70dfca966, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M12 19a7 7 0 1 1 0-14 7 7 0 0 1 0 14m0-1.5a5.5 5.5 0 1 0 0-11 5.5 5.5 0 0 0 0 11m0-6a1 1 0 0 1 1 1v2a1 1 0 0 1-2 0v-2a1 1 0 0 1 1-1m0-3a1 1 0 1 1 0 2 1 1 0 0 1 0-2"/></svg>`
    }, props, {
        newIcon: $0879f860d82e1dc1$var$_information.default
    }));
$0879f860d82e1dc1$var$EditorPanelIcon.displayName = 'EditorPanelIcon';
var $0879f860d82e1dc1$var$_default = $0879f860d82e1dc1$exports.default = $0879f860d82e1dc1$var$EditorPanelIcon;


var $972700bc3f94498f$exports = {};
"use strict";
Object.defineProperty($972700bc3f94498f$exports, "__esModule", {
    value: true
});
$972700bc3f94498f$exports.default = void 0;

var $972700bc3f94498f$var$_react = $972700bc3f94498f$var$_interopRequireDefault((parcelRequire("5FkrB")));


var $972700bc3f94498f$var$_grid = $972700bc3f94498f$var$_interopRequireDefault((parcelRequire("abVHt")));
function $972700bc3f94498f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $972700bc3f94498f$var$EditorTableIcon = (props)=>/*#__PURE__*/ $972700bc3f94498f$var$_react.default.createElement($b2a18d994dfc84a8$export$3cfb73f70dfca966, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M8 6h8a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2m0 2v3h3V8zm5 0v3h3V8zm-5 5v3h3v-3zm5 0v3h3v-3z"/></svg>`
    }, props, {
        newIcon: $972700bc3f94498f$var$_grid.default
    }));
$972700bc3f94498f$var$EditorTableIcon.displayName = 'EditorTableIcon';
var $972700bc3f94498f$var$_default = $972700bc3f94498f$exports.default = $972700bc3f94498f$var$EditorTableIcon;


var $ea6bca7cecbd908e$exports = {};
"use strict";
Object.defineProperty($ea6bca7cecbd908e$exports, "__esModule", {
    value: true
});
$ea6bca7cecbd908e$exports.default = void 0;

var $ea6bca7cecbd908e$var$_react = $ea6bca7cecbd908e$var$_interopRequireDefault((parcelRequire("5FkrB")));

function $ea6bca7cecbd908e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $ea6bca7cecbd908e$var$EmojiAtlassianIcon = (props)=>/*#__PURE__*/ $ea6bca7cecbd908e$var$_react.default.createElement($b2a18d994dfc84a8$export$3cfb73f70dfca966, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M8.7 11.48c-.24-.25-.61-.24-.77.09l-3.88 7.76a.46.46 0 0 0 .42.67h5.41a.45.45 0 0 0 .42-.26c1.17-2.41.46-6.08-1.59-8.27m2.84-7.06c-2.17 3.44-2.03 7.26-.6 10.12l2.61 5.22c.08.16.24.26.42.26h5.41a.46.46 0 0 0 .42-.67S12.53 4.77 12.35 4.41c-.17-.32-.58-.33-.79 0"/></svg>`
    }, props));
$ea6bca7cecbd908e$var$EmojiAtlassianIcon.displayName = 'EmojiAtlassianIcon';
var $ea6bca7cecbd908e$var$_default = $ea6bca7cecbd908e$exports.default = $ea6bca7cecbd908e$var$EmojiAtlassianIcon;


var $868e088250f4aa11$exports = {};
"use strict";
Object.defineProperty($868e088250f4aa11$exports, "__esModule", {
    value: true
});
$868e088250f4aa11$exports.default = void 0;

var $868e088250f4aa11$var$_react = $868e088250f4aa11$var$_interopRequireDefault((parcelRequire("5FkrB")));


var $868e088250f4aa11$var$_clock = $868e088250f4aa11$var$_interopRequireDefault((parcelRequire("1vjAO")));
function $868e088250f4aa11$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $868e088250f4aa11$var$EmojiFrequentIcon = (props)=>/*#__PURE__*/ $868e088250f4aa11$var$_react.default.createElement($b2a18d994dfc84a8$export$3cfb73f70dfca966, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M12 4c-4.412 0-8 3.588-8 8s3.588 8 8 8 8-3.588 8-8-3.588-8-8-8m0 14.222A6.23 6.23 0 0 1 5.778 12 6.23 6.23 0 0 1 12 5.778 6.23 6.23 0 0 1 18.222 12 6.23 6.23 0 0 1 12 18.222m.889-6.59V8.448c0-.489-.4-.889-.889-.889s-.889.4-.889.89v3.555c0 .248.103.471.268.633l2.195 2.194a.89.89 0 0 0 1.257 0 .89.89 0 0 0 0-1.256z"/></svg>`
    }, props, {
        newIcon: $868e088250f4aa11$var$_clock.default
    }));
$868e088250f4aa11$var$EmojiFrequentIcon.displayName = 'EmojiFrequentIcon';
var $868e088250f4aa11$var$_default = $868e088250f4aa11$exports.default = $868e088250f4aa11$var$EmojiFrequentIcon;


var $278856bd9f09e08f$exports = {};
"use strict";
Object.defineProperty($278856bd9f09e08f$exports, "__esModule", {
    value: true
});
$278856bd9f09e08f$exports.default = void 0;

var $278856bd9f09e08f$var$_react = $278856bd9f09e08f$var$_interopRequireDefault((parcelRequire("5FkrB")));


var $278856bd9f09e08f$var$_heart = $278856bd9f09e08f$var$_interopRequireDefault((parcelRequire("iQQkv")));
function $278856bd9f09e08f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $278856bd9f09e08f$var$EmojiSymbolsIcon = (props)=>/*#__PURE__*/ $278856bd9f09e08f$var$_react.default.createElement($b2a18d994dfc84a8$export$3cfb73f70dfca966, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m12 9.44 1.76-1.744a2.505 2.505 0 0 1 3.52 0 2.45 2.45 0 0 1 0 3.488L12 16.417l-5.28-5.232a2.45 2.45 0 0 1 0-3.49 2.505 2.505 0 0 1 3.52 0v.001zm-6.684 3.143.003.004 6.322 6.266a.51.51 0 0 0 .718 0l6.322-6.266.003-.004.004-.003a4.41 4.41 0 0 0 0-6.28 4.51 4.51 0 0 0-6.336 0l-.003.004-.004.003L12 6.65l-.345-.342-.004-.003-.003-.003a4.51 4.51 0 0 0-6.336 0 4.41 4.41 0 0 0 0 6.279z"/></svg>`
    }, props, {
        newIcon: $278856bd9f09e08f$var$_heart.default
    }));
$278856bd9f09e08f$var$EmojiSymbolsIcon.displayName = 'EmojiSymbolsIcon';
var $278856bd9f09e08f$var$_default = $278856bd9f09e08f$exports.default = $278856bd9f09e08f$var$EmojiSymbolsIcon;


var $35a60a094f8bb98e$exports = {};
"use strict";
Object.defineProperty($35a60a094f8bb98e$exports, "__esModule", {
    value: true
});
$35a60a094f8bb98e$exports.default = void 0;

var $35a60a094f8bb98e$var$_react = $35a60a094f8bb98e$var$_interopRequireDefault((parcelRequire("5FkrB")));


var $35a60a094f8bb98e$var$_error = $35a60a094f8bb98e$var$_interopRequireDefault((parcelRequire("584U1")));
function $35a60a094f8bb98e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $35a60a094f8bb98e$var$ErrorIcon = (props)=>/*#__PURE__*/ $35a60a094f8bb98e$var$_react.default.createElement($b2a18d994dfc84a8$export$3cfb73f70dfca966, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><path fill="currentcolor" d="M13.416 4.417a2 2 0 0 0-2.832 0l-6.168 6.167a2 2 0 0 0 0 2.833l6.168 6.167a2 2 0 0 0 2.832 0l6.168-6.167a2 2 0 0 0 0-2.833z"/><path fill="inherit" d="M12 14a1 1 0 0 1-1-1V8a1 1 0 0 1 2 0v5a1 1 0 0 1-1 1m0 3a1 1 0 0 1 0-2 1 1 0 0 1 0 2"/></g></svg>`
    }, props, {
        newIcon: $35a60a094f8bb98e$var$_error.default
    }));
$35a60a094f8bb98e$var$ErrorIcon.displayName = 'ErrorIcon';
var $35a60a094f8bb98e$var$_default = $35a60a094f8bb98e$exports.default = $35a60a094f8bb98e$var$ErrorIcon;


var $b729d471c2df3879$exports = {};
"use strict";
Object.defineProperty($b729d471c2df3879$exports, "__esModule", {
    value: true
});
$b729d471c2df3879$exports.default = void 0;

var $b729d471c2df3879$var$_react = $b729d471c2df3879$var$_interopRequireDefault((parcelRequire("5FkrB")));


var $b729d471c2df3879$var$_upload = $b729d471c2df3879$var$_interopRequireDefault((parcelRequire("5rnGN")));
function $b729d471c2df3879$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $b729d471c2df3879$var$ExportIcon = (props)=>/*#__PURE__*/ $b729d471c2df3879$var$_react.default.createElement($b2a18d994dfc84a8$export$3cfb73f70dfca966, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M13 6.491V16a1 1 0 0 1-2 0V6.491L9.784 7.697a1.05 1.05 0 0 1-1.478 0 1.03 1.03 0 0 1 0-1.465l2.955-2.929a1.05 1.05 0 0 1 1.478 0l2.955 2.93c.408.404.408 1.06 0 1.464a1.05 1.05 0 0 1-1.478 0zM9 9v2H7c-.002 0 0 7.991 0 7.991 0 .004 9.994.009 9.994.009.003 0 .006-7.991.006-7.991 0-.006-2-.009-2-.009V9h2c1.105 0 2 .902 2 2.009v7.982c0 1.11-.897 2.009-2.006 2.009H7.006A2.01 2.01 0 0 1 5 18.991V11.01A2 2 0 0 1 7 9z"/></svg>`
    }, props, {
        newIcon: $b729d471c2df3879$var$_upload.default
    }));
$b729d471c2df3879$var$ExportIcon.displayName = 'ExportIcon';
var $b729d471c2df3879$var$_default = $b729d471c2df3879$exports.default = $b729d471c2df3879$var$ExportIcon;


var $fd02e11c8aa5277c$exports = {};
"use strict";
Object.defineProperty($fd02e11c8aa5277c$exports, "__esModule", {
    value: true
});
$fd02e11c8aa5277c$exports.default = void 0;

var $fd02e11c8aa5277c$var$_react = $fd02e11c8aa5277c$var$_interopRequireDefault((parcelRequire("5FkrB")));


var $fd02e11c8aa5277c$var$_filter = $fd02e11c8aa5277c$var$_interopRequireDefault((parcelRequire("ipSgm")));
function $fd02e11c8aa5277c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $fd02e11c8aa5277c$var$FilterIcon = (props)=>/*#__PURE__*/ $fd02e11c8aa5277c$var$_react.default.createElement($b2a18d994dfc84a8$export$3cfb73f70dfca966, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M7 13h10l1-2H6zM3.99 6c-.55 0-.79.41-.55.9L4 8h16l.55-1.1c.25-.5.01-.9-.54-.9zm6.79 11.56a.87.87 0 0 0 .73.44h.99c.28 0 .61-.2.73-.44L14 16h-4z"/></svg>`
    }, props, {
        newIcon: $fd02e11c8aa5277c$var$_filter.default
    }));
$fd02e11c8aa5277c$var$FilterIcon.displayName = 'FilterIcon';
var $fd02e11c8aa5277c$var$_default = $fd02e11c8aa5277c$exports.default = $fd02e11c8aa5277c$var$FilterIcon;


var $4dc2a9ab647f1d34$exports = {};
"use strict";
Object.defineProperty($4dc2a9ab647f1d34$exports, "__esModule", {
    value: true
});
$4dc2a9ab647f1d34$exports.default = void 0;

var $4dc2a9ab647f1d34$var$_react = $4dc2a9ab647f1d34$var$_interopRequireDefault((parcelRequire("5FkrB")));


var $4dc2a9ab647f1d34$var$_chevronDown = $4dc2a9ab647f1d34$var$_interopRequireDefault((parcelRequire("1u6rG")));
function $4dc2a9ab647f1d34$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $4dc2a9ab647f1d34$var$HipchatChevronDownIcon = (props)=>/*#__PURE__*/ $4dc2a9ab647f1d34$var$_react.default.createElement($b2a18d994dfc84a8$export$3cfb73f70dfca966, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M6.744 8.744a1.053 1.053 0 0 0 0 1.49l4.547 4.557a1 1 0 0 0 1.416 0l4.55-4.558a1.051 1.051 0 1 0-1.488-1.488l-3.77 3.776-3.768-3.776a1.05 1.05 0 0 0-1.487 0"/></svg>`
    }, props, {
        newIcon: $4dc2a9ab647f1d34$var$_chevronDown.default,
        iconType: "utility"
    }));
$4dc2a9ab647f1d34$var$HipchatChevronDownIcon.displayName = 'HipchatChevronDownIcon';
var $4dc2a9ab647f1d34$var$_default = $4dc2a9ab647f1d34$exports.default = $4dc2a9ab647f1d34$var$HipchatChevronDownIcon;


var $d87741190ae2c1bc$exports = {};
"use strict";
Object.defineProperty($d87741190ae2c1bc$exports, "__esModule", {
    value: true
});
$d87741190ae2c1bc$exports.default = void 0;

var $d87741190ae2c1bc$var$_react = $d87741190ae2c1bc$var$_interopRequireDefault((parcelRequire("5FkrB")));


var $d87741190ae2c1bc$var$_chevronUp = $d87741190ae2c1bc$var$_interopRequireDefault((parcelRequire("cRECB")));
function $d87741190ae2c1bc$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $d87741190ae2c1bc$var$HipchatChevronUpIcon = (props)=>/*#__PURE__*/ $d87741190ae2c1bc$var$_react.default.createElement($b2a18d994dfc84a8$export$3cfb73f70dfca966, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m11.294 8.708-4.549 4.559a1.051 1.051 0 1 0 1.486 1.488l.001-.001 3.77-3.776 3.768 3.776a1.05 1.05 0 0 0 1.486.001h.001a1.054 1.054 0 0 0 .001-1.489L12.71 8.708a1 1 0 0 0-1.415-.001"/></svg>`
    }, props, {
        newIcon: $d87741190ae2c1bc$var$_chevronUp.default,
        iconType: "utility"
    }));
$d87741190ae2c1bc$var$HipchatChevronUpIcon.displayName = 'HipchatChevronUpIcon';
var $d87741190ae2c1bc$var$_default = $d87741190ae2c1bc$exports.default = $d87741190ae2c1bc$var$HipchatChevronUpIcon;


var $d83ce7bcb052f208$exports = {};
"use strict";
Object.defineProperty($d83ce7bcb052f208$exports, "__esModule", {
    value: true
});
$d83ce7bcb052f208$exports.default = void 0;

var $d83ce7bcb052f208$var$_react = $d83ce7bcb052f208$var$_interopRequireDefault((parcelRequire("5FkrB")));


var $d83ce7bcb052f208$var$_image = $d83ce7bcb052f208$var$_interopRequireDefault((parcelRequire("kLwd2")));
function $d83ce7bcb052f208$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $d83ce7bcb052f208$var$ImageIcon = (props)=>/*#__PURE__*/ $d83ce7bcb052f208$var$_react.default.createElement($b2a18d994dfc84a8$export$3cfb73f70dfca966, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M3 4.995C3 3.893 3.893 3 4.995 3h14.01C20.107 3 21 3.893 21 4.995v14.01A1.995 1.995 0 0 1 19.005 21H4.995A1.995 1.995 0 0 1 3 19.005zM10.5 16.5 9 15l-3 3h12v-2.7L15 12zM8 10a2 2 0 1 0 0-4 2 2 0 0 0 0 4"/></svg>`
    }, props, {
        newIcon: $d83ce7bcb052f208$var$_image.default
    }));
$d83ce7bcb052f208$var$ImageIcon.displayName = 'ImageIcon';
var $d83ce7bcb052f208$var$_default = $d83ce7bcb052f208$exports.default = $d83ce7bcb052f208$var$ImageIcon;


var $c7379cc75f389fb5$exports = {};
"use strict";
Object.defineProperty($c7379cc75f389fb5$exports, "__esModule", {
    value: true
});
$c7379cc75f389fb5$exports.default = void 0;

var $c7379cc75f389fb5$var$_react = $c7379cc75f389fb5$var$_interopRequireDefault((parcelRequire("5FkrB")));


var $c7379cc75f389fb5$var$_information = $c7379cc75f389fb5$var$_interopRequireDefault((parcelRequire("9lQhd")));
function $c7379cc75f389fb5$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $c7379cc75f389fb5$var$InfoIcon = (props)=>/*#__PURE__*/ $c7379cc75f389fb5$var$_react.default.createElement($b2a18d994dfc84a8$export$3cfb73f70dfca966, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><path fill="currentcolor" d="M2 12c0 5.523 4.477 10 10 10s10-4.477 10-10S17.523 2 12 2 2 6.477 2 12"/><rect width="2" height="7" x="11" y="10" fill="inherit" rx="1"/><circle cx="12" cy="8" r="1" fill="inherit"/></g></svg>`
    }, props, {
        newIcon: $c7379cc75f389fb5$var$_information.default
    }));
$c7379cc75f389fb5$var$InfoIcon.displayName = 'InfoIcon';
var $c7379cc75f389fb5$var$_default = $c7379cc75f389fb5$exports.default = $c7379cc75f389fb5$var$InfoIcon;


var $be2faee5e2e9c87a$exports = {};
"use strict";
Object.defineProperty($be2faee5e2e9c87a$exports, "__esModule", {
    value: true
});
$be2faee5e2e9c87a$exports.default = void 0;

var $be2faee5e2e9c87a$var$_react = $be2faee5e2e9c87a$var$_interopRequireDefault((parcelRequire("5FkrB")));


var $be2faee5e2e9c87a$var$_link = $be2faee5e2e9c87a$var$_interopRequireDefault((parcelRequire("gG4Jd")));
function $be2faee5e2e9c87a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $be2faee5e2e9c87a$var$LinkIcon = (props)=>/*#__PURE__*/ $be2faee5e2e9c87a$var$_react.default.createElement($b2a18d994dfc84a8$export$3cfb73f70dfca966, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path d="m12.856 5.457-.937.92a1 1 0 0 0 0 1.437 1.047 1.047 0 0 0 1.463 0l.984-.966c.967-.95 2.542-1.135 3.602-.288a2.54 2.54 0 0 1 .203 3.81l-2.903 2.852a2.646 2.646 0 0 1-3.696 0l-1.11-1.09L9 13.57l1.108 1.089c1.822 1.788 4.802 1.788 6.622 0l2.905-2.852a4.558 4.558 0 0 0-.357-6.82c-1.893-1.517-4.695-1.226-6.422.47"/><path d="m11.144 19.543.937-.92a1 1 0 0 0 0-1.437 1.047 1.047 0 0 0-1.462 0l-.985.966c-.967.95-2.542 1.135-3.602.288a2.54 2.54 0 0 1-.203-3.81l2.903-2.852a2.646 2.646 0 0 1 3.696 0l1.11 1.09L15 11.43l-1.108-1.089c-1.822-1.788-4.802-1.788-6.622 0l-2.905 2.852a4.558 4.558 0 0 0 .357 6.82c1.893 1.517 4.695 1.226 6.422-.47"/></g></svg>`
    }, props, {
        newIcon: $be2faee5e2e9c87a$var$_link.default
    }));
$be2faee5e2e9c87a$var$LinkIcon.displayName = 'LinkIcon';
var $be2faee5e2e9c87a$var$_default = $be2faee5e2e9c87a$exports.default = $be2faee5e2e9c87a$var$LinkIcon;


var $69c44cfe0477cfd7$exports = {};
"use strict";
Object.defineProperty($69c44cfe0477cfd7$exports, "__esModule", {
    value: true
});
$69c44cfe0477cfd7$exports.default = void 0;

var $69c44cfe0477cfd7$var$_react = $69c44cfe0477cfd7$var$_interopRequireDefault((parcelRequire("5FkrB")));


var $69c44cfe0477cfd7$var$_location = $69c44cfe0477cfd7$var$_interopRequireDefault((parcelRequire("lD59F")));
function $69c44cfe0477cfd7$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $69c44cfe0477cfd7$var$LocationIcon = (props)=>/*#__PURE__*/ $69c44cfe0477cfd7$var$_react.default.createElement($b2a18d994dfc84a8$export$3cfb73f70dfca966, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M12 21c-2.28 0-6-8.686-6-12a6 6 0 1 1 12 0c0 3.314-3.72 12-6 12m0-9a2.912 2.912 0 1 0 0-5.824A2.912 2.912 0 0 0 12 12"/></svg>`
    }, props, {
        newIcon: $69c44cfe0477cfd7$var$_location.default
    }));
$69c44cfe0477cfd7$var$LocationIcon.displayName = 'LocationIcon';
var $69c44cfe0477cfd7$var$_default = $69c44cfe0477cfd7$exports.default = $69c44cfe0477cfd7$var$LocationIcon;


var $045666e2abf7885f$exports = {};
"use strict";
Object.defineProperty($045666e2abf7885f$exports, "__esModule", {
    value: true
});
$045666e2abf7885f$exports.default = void 0;

var $045666e2abf7885f$var$_react = $045666e2abf7885f$var$_interopRequireDefault((parcelRequire("5FkrB")));


var $045666e2abf7885f$var$_zoomIn = $045666e2abf7885f$var$_interopRequireDefault((parcelRequire("dG71V")));
function $045666e2abf7885f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $045666e2abf7885f$var$MediaServicesZoomInIcon = (props)=>/*#__PURE__*/ $045666e2abf7885f$var$_react.default.createElement($b2a18d994dfc84a8$export$3cfb73f70dfca966, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m16.436 15.085 3.94 4.01a1 1 0 0 1-1.425 1.402l-3.938-4.006a7.5 7.5 0 1 1 1.423-1.406M13.5 11.5a1 1 0 0 0 0-2h-2v-2a1 1 0 0 0-2 0v2h-2a1 1 0 0 0 0 2h2v2a1 1 0 0 0 2 0v-2z"/></svg>`
    }, props, {
        newIcon: $045666e2abf7885f$var$_zoomIn.default
    }));
$045666e2abf7885f$var$MediaServicesZoomInIcon.displayName = 'MediaServicesZoomInIcon';
var $045666e2abf7885f$var$_default = $045666e2abf7885f$exports.default = $045666e2abf7885f$var$MediaServicesZoomInIcon;


var $f513021e3e22d820$exports = {};
"use strict";
Object.defineProperty($f513021e3e22d820$exports, "__esModule", {
    value: true
});
$f513021e3e22d820$exports.default = void 0;

var $f513021e3e22d820$var$_react = $f513021e3e22d820$var$_interopRequireDefault((parcelRequire("5FkrB")));


var $f513021e3e22d820$var$_zoomOut = $f513021e3e22d820$var$_interopRequireDefault((parcelRequire("dIlMP")));
function $f513021e3e22d820$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $f513021e3e22d820$var$MediaServicesZoomOutIcon = (props)=>/*#__PURE__*/ $f513021e3e22d820$var$_react.default.createElement($b2a18d994dfc84a8$export$3cfb73f70dfca966, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m16.436 15.085 3.94 4.01a1 1 0 0 1-1.425 1.402l-3.938-4.006a7.5 7.5 0 1 1 1.423-1.406M13.5 11.5h-6a1 1 0 0 1 0-2h6a1 1 0 0 1 0 2"/></svg>`
    }, props, {
        newIcon: $f513021e3e22d820$var$_zoomOut.default
    }));
$f513021e3e22d820$var$MediaServicesZoomOutIcon.displayName = 'MediaServicesZoomOutIcon';
var $f513021e3e22d820$var$_default = $f513021e3e22d820$exports.default = $f513021e3e22d820$var$MediaServicesZoomOutIcon;


var $0da7a47246bb0696$exports = {};
"use strict";
Object.defineProperty($0da7a47246bb0696$exports, "__esModule", {
    value: true
});
$0da7a47246bb0696$exports.default = void 0;

var $0da7a47246bb0696$var$_react = $0da7a47246bb0696$var$_interopRequireDefault((parcelRequire("5FkrB")));


var $0da7a47246bb0696$var$_menu = $0da7a47246bb0696$var$_interopRequireDefault((parcelRequire("1noF8")));
function $0da7a47246bb0696$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $0da7a47246bb0696$var$MenuIcon = (props)=>/*#__PURE__*/ $0da7a47246bb0696$var$_react.default.createElement($b2a18d994dfc84a8$export$3cfb73f70dfca966, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M5 15h14v2H5zm0-8h14v2H5zm0 4h14v2H5z"/></svg>`
    }, props, {
        newIcon: $0da7a47246bb0696$var$_menu.default
    }));
$0da7a47246bb0696$var$MenuIcon.displayName = 'MenuIcon';
var $0da7a47246bb0696$var$_default = $0da7a47246bb0696$exports.default = $0da7a47246bb0696$var$MenuIcon;


var $53b0a183707aafc0$exports = {};
"use strict";
Object.defineProperty($53b0a183707aafc0$exports, "__esModule", {
    value: true
});
$53b0a183707aafc0$exports.default = void 0;

var $53b0a183707aafc0$var$_react = $53b0a183707aafc0$var$_interopRequireDefault((parcelRequire("5FkrB")));


var $53b0a183707aafc0$var$_showMoreVertical = $53b0a183707aafc0$var$_interopRequireDefault((parcelRequire("h6bsN")));
function $53b0a183707aafc0$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $53b0a183707aafc0$var$MoreVerticalIcon = (props)=>/*#__PURE__*/ $53b0a183707aafc0$var$_react.default.createElement($b2a18d994dfc84a8$export$3cfb73f70dfca966, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><circle cx="12" cy="19" r="2"/><circle cx="12" cy="12" r="2"/><circle cx="12" cy="5" r="2"/></g></svg>`
    }, props, {
        newIcon: $53b0a183707aafc0$var$_showMoreVertical.default
    }));
$53b0a183707aafc0$var$MoreVerticalIcon.displayName = 'MoreVerticalIcon';
var $53b0a183707aafc0$var$_default = $53b0a183707aafc0$exports.default = $53b0a183707aafc0$var$MoreVerticalIcon;


var $d83e26c8865ed9f1$exports = {};
"use strict";
Object.defineProperty($d83e26c8865ed9f1$exports, "__esModule", {
    value: true
});
$d83e26c8865ed9f1$exports.default = void 0;

var $d83e26c8865ed9f1$var$_react = $d83e26c8865ed9f1$var$_interopRequireDefault((parcelRequire("5FkrB")));


var $d83e26c8865ed9f1$var$_alignLeft = $d83e26c8865ed9f1$var$_interopRequireDefault((parcelRequire("f3wJC")));
function $d83e26c8865ed9f1$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $d83e26c8865ed9f1$var$OverviewIcon = (props)=>/*#__PURE__*/ $d83e26c8865ed9f1$var$_react.default.createElement($b2a18d994dfc84a8$export$3cfb73f70dfca966, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M8.01 18c.546 0 .99-.444.99-1a1 1 0 0 0-.99-1H3.99A.993.993 0 0 0 3 17a1 1 0 0 0 .99 1zM3 7c0 .552.445 1 .993 1h16.014A.994.994 0 0 0 21 7c0-.552-.445-1-.993-1H3.993A.994.994 0 0 0 3 7m10.998 6A1 1 0 0 0 15 12c0-.552-.456-1-1.002-1H4.002A1 1 0 0 0 3 12c0 .552.456 1 1.002 1z"/></svg>`
    }, props, {
        newIcon: $d83e26c8865ed9f1$var$_alignLeft.default
    }));
$d83e26c8865ed9f1$var$OverviewIcon.displayName = 'OverviewIcon';
var $d83e26c8865ed9f1$var$_default = $d83e26c8865ed9f1$exports.default = $d83e26c8865ed9f1$var$OverviewIcon;


var $74190023c372c031$exports = {};
"use strict";
Object.defineProperty($74190023c372c031$exports, "__esModule", {
    value: true
});
$74190023c372c031$exports.default = void 0;

var $74190023c372c031$var$_react = $74190023c372c031$var$_interopRequireDefault((parcelRequire("5FkrB")));


var $74190023c372c031$var$_questionCircle = $74190023c372c031$var$_interopRequireDefault((parcelRequire("8tqvv")));
function $74190023c372c031$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $74190023c372c031$var$QuestionIcon = (props)=>/*#__PURE__*/ $74190023c372c031$var$_react.default.createElement($b2a18d994dfc84a8$export$3cfb73f70dfca966, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path d="M12 18a1 1 0 0 1 0-2 1 1 0 0 1 0 2m-2-9a1 1 0 1 1-2 0 1 1 0 0 1 2 0"/><path d="M15.89 8.048a3.97 3.97 0 0 0-2.951-2.94A4.005 4.005 0 0 0 8 9.087l.009.008 1.878.022.112-.116A2 2 0 0 1 12 7c1.103 0 2 .897 2 2s-.897 2-2 2h.008a1 1 0 0 0-.998.987v2.014a1 1 0 1 0 2 0v-.782c0-.217.145-.399.349-.472a3.99 3.99 0 0 0 2.53-4.699"/></g></svg>`
    }, props, {
        newIcon: $74190023c372c031$var$_questionCircle.default
    }));
$74190023c372c031$var$QuestionIcon.displayName = 'QuestionIcon';
var $74190023c372c031$var$_default = $74190023c372c031$exports.default = $74190023c372c031$var$QuestionIcon;


var $e149e66b51ba1e58$exports = {};
"use strict";
Object.defineProperty($e149e66b51ba1e58$exports, "__esModule", {
    value: true
});
$e149e66b51ba1e58$exports.default = void 0;

var $e149e66b51ba1e58$var$_react = $e149e66b51ba1e58$var$_interopRequireDefault((parcelRequire("5FkrB")));


var $e149e66b51ba1e58$var$_refresh = $e149e66b51ba1e58$var$_interopRequireDefault((parcelRequire("dvLdE")));
function $e149e66b51ba1e58$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $e149e66b51ba1e58$var$RefreshIcon = (props)=>/*#__PURE__*/ $e149e66b51ba1e58$var$_react.default.createElement($b2a18d994dfc84a8$export$3cfb73f70dfca966, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path fill-rule="nonzero" d="M8 6.003v2.995a1 1 0 1 0 2 0V5.102C10 4.494 9.507 4 8.9 4H5a1 1 0 0 0 0 2.003z"/><path fill-rule="nonzero" d="M9.428 18.018C7.351 16.989 6 14.807 6 12.37c0-2.266 1.167-4.319 3.02-5.425.48-.286.646-.922.371-1.421a.98.98 0 0 0-1.364-.386C5.557 6.611 4 9.35 4 12.37c0 3.248 1.802 6.158 4.57 7.529.498.247 1.095.026 1.332-.493.237-.52.025-1.141-.474-1.388"/><path d="M14 15.002v3.896c0 .608.493 1.102 1.1 1.102H19a1 1 0 0 0 0-2.003h-3v-2.995a1 1 0 1 0-2 0"/><path d="M14.097 4.596c-.237.52-.025 1.14.474 1.387 2.077 1.029 3.428 3.21 3.428 5.647 0 2.266-1.167 4.32-3.021 5.425a1.063 1.063 0 0 0-.37 1.42c.274.5.885.673 1.364.387 2.47-1.473 4.027-4.212 4.027-7.232 0-3.248-1.802-6.158-4.57-7.528A.96.96 0 0 0 15.002 4a1 1 0 0 0-.905.596"/></g></svg>`
    }, props, {
        newIcon: $e149e66b51ba1e58$var$_refresh.default
    }));
$e149e66b51ba1e58$var$RefreshIcon.displayName = 'RefreshIcon';
var $e149e66b51ba1e58$var$_default = $e149e66b51ba1e58$exports.default = $e149e66b51ba1e58$var$RefreshIcon;


var $fefca24f90dbffe4$exports = {};
"use strict";
Object.defineProperty($fefca24f90dbffe4$exports, "__esModule", {
    value: true
});
$fefca24f90dbffe4$exports.default = void 0;

var $fefca24f90dbffe4$var$_react = $fefca24f90dbffe4$var$_interopRequireDefault((parcelRequire("5FkrB")));


var $fefca24f90dbffe4$var$_search = $fefca24f90dbffe4$var$_interopRequireDefault((parcelRequire("5YCyx")));
function $fefca24f90dbffe4$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $fefca24f90dbffe4$var$SearchIcon = (props)=>/*#__PURE__*/ $fefca24f90dbffe4$var$_react.default.createElement($b2a18d994dfc84a8$export$3cfb73f70dfca966, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m16.436 15.085 3.94 4.01a1 1 0 0 1-1.425 1.402l-3.938-4.006a7.5 7.5 0 1 1 1.423-1.406M10.5 16a5.5 5.5 0 1 0 0-11 5.5 5.5 0 0 0 0 11"/></svg>`
    }, props, {
        newIcon: $fefca24f90dbffe4$var$_search.default
    }));
$fefca24f90dbffe4$var$SearchIcon.displayName = 'SearchIcon';
var $fefca24f90dbffe4$var$_default = $fefca24f90dbffe4$exports.default = $fefca24f90dbffe4$var$SearchIcon;


var $f89ba06409979f74$exports = {};
"use strict";
Object.defineProperty($f89ba06409979f74$exports, "__esModule", {
    value: true
});
$f89ba06409979f74$exports.default = void 0;

var $f89ba06409979f74$var$_react = $f89ba06409979f74$var$_interopRequireDefault((parcelRequire("5FkrB")));


var $f89ba06409979f74$var$_settings = $f89ba06409979f74$var$_interopRequireDefault((parcelRequire("69p1m")));
function $f89ba06409979f74$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $f89ba06409979f74$var$SettingsIcon = (props)=>/*#__PURE__*/ $f89ba06409979f74$var$_react.default.createElement($b2a18d994dfc84a8$export$3cfb73f70dfca966, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M11.701 16.7a5.002 5.002 0 1 1 0-10.003 5.002 5.002 0 0 1 0 10.004m8.368-3.117a1.995 1.995 0 0 1-1.346-1.885c0-.876.563-1.613 1.345-1.885a.48.48 0 0 0 .315-.574 9 9 0 0 0-.836-1.993.48.48 0 0 0-.598-.195 2.04 2.04 0 0 1-1.29.08 1.99 1.99 0 0 1-1.404-1.395 2.04 2.04 0 0 1 .076-1.297.48.48 0 0 0-.196-.597 9 9 0 0 0-1.975-.826.48.48 0 0 0-.574.314 1.995 1.995 0 0 1-1.885 1.346 1.99 1.99 0 0 1-1.884-1.345.48.48 0 0 0-.575-.315c-.708.2-1.379.485-2.004.842a.47.47 0 0 0-.198.582A2.002 2.002 0 0 1 4.445 7.06a.48.48 0 0 0-.595.196 9 9 0 0 0-.833 1.994.48.48 0 0 0 .308.572 1.995 1.995 0 0 1 1.323 1.877c0 .867-.552 1.599-1.324 1.877a.48.48 0 0 0-.308.57 9 9 0 0 0 .723 1.79.477.477 0 0 0 .624.194c.595-.273 1.343-.264 2.104.238.117.077.225.185.302.3.527.8.512 1.58.198 2.188a.473.473 0 0 0 .168.628 9 9 0 0 0 2.11.897.474.474 0 0 0 .57-.313 1.995 1.995 0 0 1 1.886-1.353c.878 0 1.618.567 1.887 1.353a.475.475 0 0 0 .57.313 9 9 0 0 0 2.084-.883.473.473 0 0 0 .167-.631c-.318-.608-.337-1.393.191-2.195.077-.116.185-.225.302-.302.772-.511 1.527-.513 2.125-.23a.477.477 0 0 0 .628-.19 9 9 0 0 0 .728-1.793.48.48 0 0 0-.314-.573"/></svg>`
    }, props, {
        newIcon: $f89ba06409979f74$var$_settings.default
    }));
$f89ba06409979f74$var$SettingsIcon.displayName = 'SettingsIcon';
var $f89ba06409979f74$var$_default = $f89ba06409979f74$exports.default = $f89ba06409979f74$var$SettingsIcon;


var $b0ee2c5a0f759aa1$exports = {};
"use strict";
Object.defineProperty($b0ee2c5a0f759aa1$exports, "__esModule", {
    value: true
});
$b0ee2c5a0f759aa1$exports.default = void 0;

var $b0ee2c5a0f759aa1$var$_react = $b0ee2c5a0f759aa1$var$_interopRequireDefault((parcelRequire("5FkrB")));


var $b0ee2c5a0f759aa1$var$_share = $b0ee2c5a0f759aa1$var$_interopRequireDefault((parcelRequire("diyZy")));
function $b0ee2c5a0f759aa1$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $b0ee2c5a0f759aa1$var$ShareIcon = (props)=>/*#__PURE__*/ $b0ee2c5a0f759aa1$var$_react.default.createElement($b2a18d994dfc84a8$export$3cfb73f70dfca966, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path fill-rule="nonzero" d="M6 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6m0-2a1 1 0 1 1 0-2 1 1 0 0 1 0 2m12-4a3 3 0 1 0 0-6 3 3 0 0 0 0 6m0-2a1 1 0 1 1 0-2 1 1 0 0 1 0 2m0 14a3 3 0 1 0 0-6 3 3 0 0 0 0 6m0-2a1 1 0 1 1 0-2 1 1 0 0 1 0 2"/><path d="m7 13.562 8.66 5 1-1.732-8.66-5z"/><path d="m7 10.83 1 1.732 8.66-5-1-1.732z"/></g></svg>`
    }, props, {
        newIcon: $b0ee2c5a0f759aa1$var$_share.default
    }));
$b0ee2c5a0f759aa1$var$ShareIcon.displayName = 'ShareIcon';
var $b0ee2c5a0f759aa1$var$_default = $b0ee2c5a0f759aa1$exports.default = $b0ee2c5a0f759aa1$var$ShareIcon;


var $770578eecee63138$exports = {};
"use strict";
Object.defineProperty($770578eecee63138$exports, "__esModule", {
    value: true
});
$770578eecee63138$exports.default = void 0;

var $770578eecee63138$var$_react = $770578eecee63138$var$_interopRequireDefault((parcelRequire("5FkrB")));


var $770578eecee63138$var$_starUnstarred = $770578eecee63138$var$_interopRequireDefault((parcelRequire("kGA9o")));
function $770578eecee63138$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $770578eecee63138$var$StarIcon = (props)=>/*#__PURE__*/ $770578eecee63138$var$_react.default.createElement($b2a18d994dfc84a8$export$3cfb73f70dfca966, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="m12 16.373 3.98 2.193-.76-4.655 3.276-3.347-4.524-.69L12 5.687l-1.972 4.189-4.524.689L8.78 13.91l-.762 4.655zm0 2.283-3.016 1.662a2 2 0 0 1-2.939-2.075l.599-3.656-2.57-2.624a2 2 0 0 1 1.129-3.377l3.47-.528 1.518-3.224a2 2 0 0 1 3.618 0l1.519 3.224 3.47.528a2 2 0 0 1 1.127 3.377l-2.569 2.624.599 3.656a2 2 0 0 1-2.94 2.075z"/></svg>`
    }, props, {
        newIcon: $770578eecee63138$var$_starUnstarred.default
    }));
$770578eecee63138$var$StarIcon.displayName = 'StarIcon';
var $770578eecee63138$var$_default = $770578eecee63138$exports.default = $770578eecee63138$var$StarIcon;


var $9d80ce0dbce822c2$exports = {};
"use strict";
Object.defineProperty($9d80ce0dbce822c2$exports, "__esModule", {
    value: true
});
$9d80ce0dbce822c2$exports.default = void 0;

var $9d80ce0dbce822c2$var$_react = $9d80ce0dbce822c2$var$_interopRequireDefault((parcelRequire("5FkrB")));


var $9d80ce0dbce822c2$var$_starStarred = $9d80ce0dbce822c2$var$_interopRequireDefault((parcelRequire("5MuEE")));
function $9d80ce0dbce822c2$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $9d80ce0dbce822c2$var$StarFilledIcon = (props)=>/*#__PURE__*/ $9d80ce0dbce822c2$var$_react.default.createElement($b2a18d994dfc84a8$export$3cfb73f70dfca966, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m12.072 17.284-3.905 2.053a1 1 0 0 1-1.451-1.054l.745-4.349-3.159-3.08a1 1 0 0 1 .554-1.705l4.366-.635 1.953-3.956a1 1 0 0 1 1.794 0l1.952 3.956 4.366.635a1 1 0 0 1 .555 1.705l-3.16 3.08.746 4.349a1 1 0 0 1-1.45 1.054z"/></svg>`
    }, props, {
        newIcon: $9d80ce0dbce822c2$var$_starStarred.default
    }));
$9d80ce0dbce822c2$var$StarFilledIcon.displayName = 'StarFilledIcon';
var $9d80ce0dbce822c2$var$_default = $9d80ce0dbce822c2$exports.default = $9d80ce0dbce822c2$var$StarFilledIcon;


var $8921404bff45adb3$exports = {};
"use strict";
Object.defineProperty($8921404bff45adb3$exports, "__esModule", {
    value: true
});
$8921404bff45adb3$exports.default = void 0;

var $8921404bff45adb3$var$_react = $8921404bff45adb3$var$_interopRequireDefault((parcelRequire("5FkrB")));


var $8921404bff45adb3$var$_warning = $8921404bff45adb3$var$_interopRequireDefault((parcelRequire("89fFk")));
function $8921404bff45adb3$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $8921404bff45adb3$var$WarningIcon = (props)=>/*#__PURE__*/ $8921404bff45adb3$var$_react.default.createElement($b2a18d994dfc84a8$export$3cfb73f70dfca966, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><path fill="currentcolor" d="M12.938 4.967c-.518-.978-1.36-.974-1.876 0L3.938 18.425c-.518.978-.045 1.771 1.057 1.771h14.01c1.102 0 1.573-.797 1.057-1.771z"/><path fill="inherit" d="M12 15a1 1 0 0 1-1-1V9a1 1 0 0 1 2 0v5a1 1 0 0 1-1 1m0 3a1 1 0 0 1 0-2 1 1 0 0 1 0 2"/></g></svg>`
    }, props, {
        newIcon: $8921404bff45adb3$var$_warning.default
    }));
$8921404bff45adb3$var$WarningIcon.displayName = 'WarningIcon';
var $8921404bff45adb3$var$_default = $8921404bff45adb3$exports.default = $8921404bff45adb3$var$WarningIcon;


var $d8659b89a0a6aa64$exports = {};
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6b7be9690353c7bf82b96c9a0cc89ae3>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty($d8659b89a0a6aa64$exports, "__esModule", {
    value: true
});
$d8659b89a0a6aa64$exports.default = void 0;

var $d8659b89a0a6aa64$var$_react = $d8659b89a0a6aa64$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $d8659b89a0a6aa64$var$_baseNew = $d8659b89a0a6aa64$var$_interopRequireDefault((parcelRequire("1ZlwN")));
function $d8659b89a0a6aa64$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "RoadmapsPlan".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for representing plans.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $d8659b89a0a6aa64$var$RoadmapsPlanIcon = (props)=>/*#__PURE__*/ $d8659b89a0a6aa64$var$_react.default.createElement($d8659b89a0a6aa64$var$_baseNew.default, Object.assign({
        name: "RoadmapsPlanIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M3.5 2.5a1 1 0 1 0 0 2 1 1 0 0 0 0-2M1 3.5a2.5 2.5 0 0 1 4.886-.75h4.864a3 3 0 1 1 0 6h-5.5a1.5 1.5 0 1 0 0 3h4.865a2.501 2.501 0 1 1 0 1.5H5.25a3 3 0 1 1 0-6h5.5a1.5 1.5 0 0 0 0-3H5.886A2.501 2.501 0 0 1 1 3.5m11.5 8a1 1 0 1 0 0 2 1 1 0 0 0 0-2" clip-rule="evenodd"/>`
    }, props));
$d8659b89a0a6aa64$var$RoadmapsPlanIcon.displayName = 'RoadmapsPlanIcon';
var $d8659b89a0a6aa64$var$_default = $d8659b89a0a6aa64$exports.default = $d8659b89a0a6aa64$var$RoadmapsPlanIcon;


/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ /* eslint-disable prefer-rest-params */ /* eslint-disable no-console */ var $14d8db54b09931bb$var$printed = {};
function $14d8db54b09931bb$export$2e2bcd8739ae039(message) {
    if ($14d8db54b09931bb$var$printed[message]) return;
    $14d8db54b09931bb$var$printed[message] = true;
    if (typeof window !== 'undefined') console.warn(message);
}



var $3ZMUU = parcelRequire("3ZMUU");
function $80e1e7edfe4ac5ff$export$2e2bcd8739ae039(packageName, api, additionalMessage) {
    (0, $14d8db54b09931bb$export$2e2bcd8739ae039)("[".concat(packageName, "]: The ").concat(api, " is deprecated.").concat(additionalMessage && " ".concat(additionalMessage)));
}
function $80e1e7edfe4ac5ff$export$eb1decd851a5ae56(packageName, propName, predicate, deprecationAnnouncementOnDAC) {
    typeof $3ZMUU;
}



var $99aaada6b4006109$export$44ffba16bd48dac6 = '__ATLASKIT_THEME__';
var $99aaada6b4006109$export$c93026a968943f95 = 'light';
var $99aaada6b4006109$export$6ba72c8346b4c57e = [
    'light',
    'dark'
];
var $99aaada6b4006109$export$7a57f79000377ca2 = function borderRadius() {
    return 3;
};
var $99aaada6b4006109$export$6d8204c2cb2e06b8 = function gridSize() {
    return 8;
};
var $99aaada6b4006109$export$85e3c3ca0c6fb93 = function fontSize() {
    return 14;
};
var $99aaada6b4006109$export$6746fe0d9c9fab54 = function fontSizeSmall() {
    return 11;
};
var $99aaada6b4006109$export$a5975749f0374264 = function fontFamily() {
    return "-apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif";
};
var $99aaada6b4006109$export$356129969ee49c55 = function codeFontFamily() {
    return "'SFMono-Medium', 'SF Mono', 'Segoe UI Mono', 'Roboto Mono', 'Ubuntu Mono', Menlo, Consolas, Courier, monospace";
};
var $99aaada6b4006109$export$8e24544ddba725ee = function focusRing() {
    var color = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "var(--ds-border-focused, ".concat((0, $d568d81ef5c2bf7a$export$215b7063051591f1), ")");
    var outlineWidth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $99aaada6b4006109$export$6d8204c2cb2e06b8() / 4;
    (0, $80e1e7edfe4ac5ff$export$2e2bcd8739ae039)('@atlaskit/theme', 'focus ring mixin', 'Please use `@atlaskit/focus-ring` instead.');
    return "\n  &:focus {\n    outline: none;\n    box-shadow: 0px 0px 0px ".concat(outlineWidth, "px ").concat(color, ";\n  }\n");
};
var $99aaada6b4006109$export$c0dd343266bc3261 = function noFocusRing() {
    return "\n  box-shadow: none;\n";
};
var $99aaada6b4006109$export$7be255094ccdc533 = {
    card: function card() {
        return 100;
    },
    navigation: function navigation() {
        return 200;
    },
    dialog: function dialog() {
        return 300;
    },
    layer: function layer() {
        return 400;
    },
    blanket: function blanket() {
        return 500;
    },
    modal: function modal() {
        return 510;
    },
    flag: function flag() {
        return 600;
    },
    spotlight: function spotlight() {
        return 700;
    },
    tooltip: function tooltip() {
        return 9999;
    }
};
var $99aaada6b4006109$export$a1b3edb637fb4f35 = function visuallyHidden() {
    (0, $80e1e7edfe4ac5ff$export$2e2bcd8739ae039)('@atlaskit/theme', 'visually hidden mixin', 'Please use `@atlaskit/visually-hidden` instead.');
    return {
        border: '0 !important',
        clip: 'rect(1px, 1px, 1px, 1px) !important',
        height: '1px !important',
        overflow: 'hidden !important',
        padding: '0 !important',
        position: 'absolute !important',
        width: '1px !important',
        whiteSpace: 'nowrap !important'
    };
};
var $99aaada6b4006109$export$ba1d834b86d72a09 = $99aaada6b4006109$export$a1b3edb637fb4f35;
var $99aaada6b4006109$export$e497e856b4f89fcd = function skeletonShimmer() {
    return {
        css: {
            backgroundColor: "var(--ds-skeleton, ".concat((0, $d568d81ef5c2bf7a$export$2a0674ff2eb10214)(), ")"),
            animationDuration: '1.5s',
            animationIterationCount: 'infinite',
            animationTimingFunction: 'linear',
            animationDirection: 'alternate'
        },
        keyframes: {
            from: {
                backgroundColor: "var(--ds-skeleton, ".concat((0, $d568d81ef5c2bf7a$export$2a0674ff2eb10214)(), ")")
            },
            to: {
                backgroundColor: "var(--ds-skeleton-subtle, ".concat((0, $d568d81ef5c2bf7a$export$920c0d5c49070351), ")")
            }
        }
    };
};


function $3024bfbdec2262ad$export$2e2bcd8739ae039(props) {
    if (props && props.theme) {
        // Theme is the global Atlaskit theme
        if ((0, $99aaada6b4006109$export$44ffba16bd48dac6) in props.theme) return props.theme[0, $99aaada6b4006109$export$44ffba16bd48dac6];
        else if ('mode' in props.theme && (0, $99aaada6b4006109$export$6ba72c8346b4c57e).includes(props.theme.mode)) return props.theme;
    }
    // If format not supported (or no theme provided), return standard theme
    return {
        mode: (0, $99aaada6b4006109$export$c93026a968943f95)
    };
}


// Unpack custom variants, and get correct value for the current theme
function $9718da63677ed9ae$var$themedVariants(variantProp, variants) {
    return function(props) {
        var theme = (0, $3024bfbdec2262ad$export$2e2bcd8739ae039)(props);
        if (props && props[variantProp] && variants) {
            var modes = variants[props[variantProp]];
            if (modes && modes[theme.mode]) {
                var value = modes[theme.mode];
                if (value) return value;
                 // TS believes value can be undefined
            }
        }
        return '';
    };
}
function $9718da63677ed9ae$export$2e2bcd8739ae039(modesOrVariant, variantModes) {
    if (typeof modesOrVariant === 'string') return $9718da63677ed9ae$var$themedVariants(modesOrVariant, variantModes);
    var modes = modesOrVariant;
    return function(props) {
        // Get theme from the user's props
        var theme = (0, $3024bfbdec2262ad$export$2e2bcd8739ae039)(props);
        // User isn't required to provide both light and dark values
        if (theme.mode in modes) {
            var value = modes[theme.mode]; // TS believes value can be undefined
            if (value) return value;
        }
        return '';
    };
}


var $d568d81ef5c2bf7a$export$4b84fd0e2c617bd = '#FFEBE6';
var $d568d81ef5c2bf7a$export$b34b069eff244586 = '#FFBDAD';
var $d568d81ef5c2bf7a$export$be802dd0d8b57f35 = '#FF8F73';
var $d568d81ef5c2bf7a$export$60847d42f9da92a6 = '#FF7452';
var $d568d81ef5c2bf7a$export$4a7404f376229999 = '#FF5630';
var $d568d81ef5c2bf7a$export$2010d0fb4295b346 = '#DE350B';
var $d568d81ef5c2bf7a$export$2837b5a1a71d5c02 = '#BF2600';
var $d568d81ef5c2bf7a$export$8d9596b529bbb9cf = '#FFFAE6';
var $d568d81ef5c2bf7a$export$41060a744ab0b7ae = '#FFF0B3';
var $d568d81ef5c2bf7a$export$1cc05bbbf340e559 = '#FFE380';
var $d568d81ef5c2bf7a$export$5aae31392d72caaa = '#FFC400';
var $d568d81ef5c2bf7a$export$c6930421db9fa514 = '#FFAB00';
var $d568d81ef5c2bf7a$export$59619663aa6500fb = '#FF991F';
var $d568d81ef5c2bf7a$export$874739ea9e379ab6 = '#FF8B00';
var $d568d81ef5c2bf7a$export$8a6341c32b6a3ee6 = '#E3FCEF';
var $d568d81ef5c2bf7a$export$69a3bf21b9686c2b = '#ABF5D1';
var $d568d81ef5c2bf7a$export$afbce1382ec95f73 = '#79F2C0';
var $d568d81ef5c2bf7a$export$747d86715d4175de = '#57D9A3';
var $d568d81ef5c2bf7a$export$940e1f69e873f202 = '#36B37E';
var $d568d81ef5c2bf7a$export$a49394138f7b8e85 = '#00875A';
var $d568d81ef5c2bf7a$export$6fa04827ac68a4fb = '#006644';
var $d568d81ef5c2bf7a$export$226de0355ed012f8 = '#DEEBFF';
var $d568d81ef5c2bf7a$export$8c13c2ee36917869 = '#B3D4FF';
var $d568d81ef5c2bf7a$export$ecfc1dff386a3e7a = '#4C9AFF';
var $d568d81ef5c2bf7a$export$215b7063051591f1 = '#2684FF';
var $d568d81ef5c2bf7a$export$e62e8919cca44969 = '#0065FF';
var $d568d81ef5c2bf7a$export$b3de0ae08da2ce64 = '#0052CC';
var $d568d81ef5c2bf7a$export$a6ee3d71bc067634 = '#0747A6';
var $d568d81ef5c2bf7a$export$363e4475840015bb = '#EAE6FF';
var $d568d81ef5c2bf7a$export$4b0a4417ed59760f = '#C0B6F2';
var $d568d81ef5c2bf7a$export$6011520a64d9a187 = '#998DD9';
var $d568d81ef5c2bf7a$export$a7175d4e9206bc80 = '#8777D9';
var $d568d81ef5c2bf7a$export$b48405b95304b5a1 = '#6554C0';
var $d568d81ef5c2bf7a$export$c71e4279dd54a18d = '#5243AA';
var $d568d81ef5c2bf7a$export$147899de772240ec = '#403294';
var $d568d81ef5c2bf7a$export$2cf711fe14c66f06 = '#E6FCFF';
var $d568d81ef5c2bf7a$export$7a8f4d33f6f9772c = '#B3F5FF';
var $d568d81ef5c2bf7a$export$776c9c497ef08533 = '#79E2F2';
var $d568d81ef5c2bf7a$export$69cb3ca10c1e330e = '#00C7E6';
var $d568d81ef5c2bf7a$export$9dc1ef0f3f48059b = '#00B8D9';
var $d568d81ef5c2bf7a$export$7c835c78b6fcdef8 = '#00A3BF';
var $d568d81ef5c2bf7a$export$6036577f95c3877e = '#008DA6';
var $d568d81ef5c2bf7a$export$29a4f05edc054374 = '#FFFFFF';
var $d568d81ef5c2bf7a$export$e655ef011c4aa1a2 = '#FAFBFC';
var $d568d81ef5c2bf7a$export$9fdfb749e33cdf97 = '#F4F5F7';
var $d568d81ef5c2bf7a$export$3e51e8f1440314ba = '#EBECF0';
var $d568d81ef5c2bf7a$export$1ce2d1575d444ceb = '#DFE1E6';
var $d568d81ef5c2bf7a$export$8754fc7e6d8b3000 = '#C1C7D0';
var $d568d81ef5c2bf7a$export$c2e91cbeada39b8b = '#B3BAC5';
var $d568d81ef5c2bf7a$export$5f71e19f3a7ad9de = '#A5ADBA';
var $d568d81ef5c2bf7a$export$eaa8c8a70ac22806 = '#97A0AF';
var $d568d81ef5c2bf7a$export$7c87d337fb91a97d = '#8993A4';
var $d568d81ef5c2bf7a$export$d6447c357493214f = '#7A869A';
var $d568d81ef5c2bf7a$export$f563ee71e9ee74cd = '#6B778C';
var $d568d81ef5c2bf7a$export$e2ef2124cf4024b1 = '#5E6C84';
var $d568d81ef5c2bf7a$export$eece5f492e429f08 = '#505F79';
var $d568d81ef5c2bf7a$export$c39c0fe0f26207ae = '#42526E';
var $d568d81ef5c2bf7a$export$7090862dc3038a9f = '#344563';
var $d568d81ef5c2bf7a$export$ad0bacf983b7ddaa = '#253858';
var $d568d81ef5c2bf7a$export$7d61b15e0da132af = '#172B4D';
var $d568d81ef5c2bf7a$export$fbda843f0a27fe96 = '#091E42';
var $d568d81ef5c2bf7a$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
var $d568d81ef5c2bf7a$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
var $d568d81ef5c2bf7a$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
var $d568d81ef5c2bf7a$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
var $d568d81ef5c2bf7a$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
var $d568d81ef5c2bf7a$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
var $d568d81ef5c2bf7a$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
var $d568d81ef5c2bf7a$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
var $d568d81ef5c2bf7a$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
var $d568d81ef5c2bf7a$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
var $d568d81ef5c2bf7a$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
var $d568d81ef5c2bf7a$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
var $d568d81ef5c2bf7a$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
var $d568d81ef5c2bf7a$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
var $d568d81ef5c2bf7a$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
var $d568d81ef5c2bf7a$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
var $d568d81ef5c2bf7a$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
var $d568d81ef5c2bf7a$export$2f6319cf7d736c2a = '#E6EDFA';
var $d568d81ef5c2bf7a$export$95126bc8884d6634 = '#DCE5F5';
var $d568d81ef5c2bf7a$export$8338d8c35d44ff1 = '#CED9EB';
var $d568d81ef5c2bf7a$export$5368d76ae4fbbda7 = '#B8C7E0';
var $d568d81ef5c2bf7a$export$9f0a771d16ec8d36 = '#ABBBD6';
var $d568d81ef5c2bf7a$export$abcf8c38338b4aa5 = '#9FB0CC';
var $d568d81ef5c2bf7a$export$97e81faa16a182c7 = '#8C9CB8';
var $d568d81ef5c2bf7a$export$bfe21c59123ecf33 = '#7988A3';
var $d568d81ef5c2bf7a$export$ee82aa2ea6a1558 = '#67758F';
var $d568d81ef5c2bf7a$export$682927c6ed76be02 = '#56637A';
var $d568d81ef5c2bf7a$export$91fd9994c5be9757 = '#455166';
var $d568d81ef5c2bf7a$export$d281fbfe3cff2df6 = '#3B475C';
var $d568d81ef5c2bf7a$export$3902c91d8b98a753 = '#313D52';
var $d568d81ef5c2bf7a$export$8e8133c1ba5845b5 = '#283447';
var $d568d81ef5c2bf7a$export$33ff357f6620b39 = '#202B3D';
var $d568d81ef5c2bf7a$export$633847cf062b69e0 = '#1B2638';
var $d568d81ef5c2bf7a$export$9776a6e503bdbf76 = '#121A29';
var $d568d81ef5c2bf7a$export$6c813d5160dff5db = '#0E1624';
var $d568d81ef5c2bf7a$export$3d4f271a500072a = '#0D1424';
var $d568d81ef5c2bf7a$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
var $d568d81ef5c2bf7a$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
var $d568d81ef5c2bf7a$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
var $d568d81ef5c2bf7a$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
var $d568d81ef5c2bf7a$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
var $d568d81ef5c2bf7a$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
var $d568d81ef5c2bf7a$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
var $d568d81ef5c2bf7a$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
var $d568d81ef5c2bf7a$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
var $d568d81ef5c2bf7a$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
var $d568d81ef5c2bf7a$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
var $d568d81ef5c2bf7a$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
var $d568d81ef5c2bf7a$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
var $d568d81ef5c2bf7a$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
var $d568d81ef5c2bf7a$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
var $d568d81ef5c2bf7a$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
var $d568d81ef5c2bf7a$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';
var $d568d81ef5c2bf7a$export$8ce1fd94bee2f412 = (0, $9718da63677ed9ae$export$2e2bcd8739ae039)({
    light: "var(--ds-surface, ".concat($d568d81ef5c2bf7a$export$29a4f05edc054374, ")"),
    dark: "var(--ds-surface, ".concat($d568d81ef5c2bf7a$export$633847cf062b69e0, ")")
});
var $d568d81ef5c2bf7a$export$b861914ea877b580 = (0, $9718da63677ed9ae$export$2e2bcd8739ae039)({
    light: "var(--ds-background-selected, ".concat($d568d81ef5c2bf7a$export$226de0355ed012f8, ")"),
    dark: "var(--ds-background-selected, ".concat($d568d81ef5c2bf7a$export$8c13c2ee36917869, ")")
});
var $d568d81ef5c2bf7a$export$3f1b020df94387af = (0, $9718da63677ed9ae$export$2e2bcd8739ae039)({
    light: "var(--ds-background-neutral-hovered, ".concat($d568d81ef5c2bf7a$export$3e51e8f1440314ba, ")"),
    dark: "var(--ds-background-neutral-hovered, ".concat($d568d81ef5c2bf7a$export$d281fbfe3cff2df6, ")")
});
var $d568d81ef5c2bf7a$export$c0183dbab98ca63e = (0, $9718da63677ed9ae$export$2e2bcd8739ae039)({
    light: "var(--ds-surface-overlay, ".concat($d568d81ef5c2bf7a$export$29a4f05edc054374, ")"),
    dark: "var(--ds-surface-overlay, ".concat($d568d81ef5c2bf7a$export$8e8133c1ba5845b5, ")")
});
var $d568d81ef5c2bf7a$export$6f093cfa640b7166 = (0, $9718da63677ed9ae$export$2e2bcd8739ae039)({
    light: "var(--ds-text, ".concat($d568d81ef5c2bf7a$export$fbda843f0a27fe96, ")"),
    dark: "var(--ds-text, ".concat($d568d81ef5c2bf7a$export$5368d76ae4fbbda7, ")")
});
var $d568d81ef5c2bf7a$export$42f8e9c698766e7a = (0, $9718da63677ed9ae$export$2e2bcd8739ae039)({
    light: "var(--ds-text, ".concat($d568d81ef5c2bf7a$export$7d61b15e0da132af, ")"),
    dark: "var(--ds-text, ".concat($d568d81ef5c2bf7a$export$5368d76ae4fbbda7, ")")
});
var $d568d81ef5c2bf7a$export$c2d157ca1c34b6e3 = (0, $9718da63677ed9ae$export$2e2bcd8739ae039)({
    light: "var(--ds-text-selected, ".concat($d568d81ef5c2bf7a$export$b3de0ae08da2ce64, ")"),
    dark: "var(--ds-text-selected, ".concat($d568d81ef5c2bf7a$export$b3de0ae08da2ce64, ")")
});
var $d568d81ef5c2bf7a$export$1905ba28d7cf066f = (0, $9718da63677ed9ae$export$2e2bcd8739ae039)({
    light: "var(--ds-text-subtlest, ".concat($d568d81ef5c2bf7a$export$f563ee71e9ee74cd, ")"),
    dark: "var(--ds-text-subtlest, ".concat($d568d81ef5c2bf7a$export$97e81faa16a182c7, ")")
});
var $d568d81ef5c2bf7a$export$bd9002130d306d39 = (0, $9718da63677ed9ae$export$2e2bcd8739ae039)({
    light: "var(--ds-text-subtlest, ".concat($d568d81ef5c2bf7a$export$f563ee71e9ee74cd, ")"),
    dark: "var(--ds-text-subtlest, ".concat($d568d81ef5c2bf7a$export$bfe21c59123ecf33, ")")
});
var $d568d81ef5c2bf7a$export$46e4a324ac90507f = (0, $9718da63677ed9ae$export$2e2bcd8739ae039)({
    light: "var(--ds-text, ".concat($d568d81ef5c2bf7a$export$7d61b15e0da132af, ")"),
    dark: "var(--ds-text, ".concat($d568d81ef5c2bf7a$export$5368d76ae4fbbda7, ")")
});
var $d568d81ef5c2bf7a$export$79f3f2b82beb0d36 = (0, $9718da63677ed9ae$export$2e2bcd8739ae039)({
    light: "var(--ds-text-subtlest, ".concat($d568d81ef5c2bf7a$export$f563ee71e9ee74cd, ")"),
    dark: "var(--ds-text-subtlest, ".concat($d568d81ef5c2bf7a$export$97e81faa16a182c7, ")")
});
var $d568d81ef5c2bf7a$export$7bb0d5c671655cc4 = (0, $9718da63677ed9ae$export$2e2bcd8739ae039)({
    light: $d568d81ef5c2bf7a$export$9fdfb749e33cdf97,
    dark: $d568d81ef5c2bf7a$export$8e8133c1ba5845b5
});
var $d568d81ef5c2bf7a$export$9c30223ca0a664fb = (0, $9718da63677ed9ae$export$2e2bcd8739ae039)({
    light: "var(--ds-link, ".concat($d568d81ef5c2bf7a$export$b3de0ae08da2ce64, ")"),
    dark: "var(--ds-link, ".concat($d568d81ef5c2bf7a$export$ecfc1dff386a3e7a, ")")
});
var $d568d81ef5c2bf7a$export$7ed258b0728b004b = (0, $9718da63677ed9ae$export$2e2bcd8739ae039)({
    light: "var(--ds-link-pressed, ".concat($d568d81ef5c2bf7a$export$e62e8919cca44969, ")"),
    dark: "var(--ds-link-pressed, ".concat($d568d81ef5c2bf7a$export$215b7063051591f1, ")")
});
var $d568d81ef5c2bf7a$export$dfa920d8decc8a59 = (0, $9718da63677ed9ae$export$2e2bcd8739ae039)({
    light: "var(--ds-link-pressed, ".concat($d568d81ef5c2bf7a$export$a6ee3d71bc067634, ")"),
    dark: "var(--ds-link-pressed, ".concat($d568d81ef5c2bf7a$export$ecfc1dff386a3e7a, ")")
});
var $d568d81ef5c2bf7a$export$6069e6ad5c78f632 = (0, $9718da63677ed9ae$export$2e2bcd8739ae039)({
    light: "var(--ds-border-focused, ".concat($d568d81ef5c2bf7a$export$215b7063051591f1, ")"),
    dark: "var(--ds-border-focused, ".concat($d568d81ef5c2bf7a$export$215b7063051591f1, ")")
});
var $d568d81ef5c2bf7a$export$9ad721cf3b3debe0 = (0, $9718da63677ed9ae$export$2e2bcd8739ae039)({
    light: "var(--ds-background-brand-bold, ".concat($d568d81ef5c2bf7a$export$b3de0ae08da2ce64, ")"),
    dark: "var(--ds-background-brand-bold, ".concat($d568d81ef5c2bf7a$export$ecfc1dff386a3e7a, ")")
});
var $d568d81ef5c2bf7a$export$2aa0182783e7e9de = (0, $9718da63677ed9ae$export$2e2bcd8739ae039)({
    light: $d568d81ef5c2bf7a$export$b3de0ae08da2ce64,
    dark: $d568d81ef5c2bf7a$export$ecfc1dff386a3e7a
});
var $d568d81ef5c2bf7a$export$8bf7dff220b82b4a = (0, $9718da63677ed9ae$export$2e2bcd8739ae039)({
    light: $d568d81ef5c2bf7a$export$9dc1ef0f3f48059b,
    dark: $d568d81ef5c2bf7a$export$69cb3ca10c1e330e
});
var $d568d81ef5c2bf7a$export$e13cce2a2d16a9d4 = (0, $9718da63677ed9ae$export$2e2bcd8739ae039)({
    light: $d568d81ef5c2bf7a$export$b48405b95304b5a1,
    dark: $d568d81ef5c2bf7a$export$6011520a64d9a187
});
var $d568d81ef5c2bf7a$export$a90204d1394caf30 = (0, $9718da63677ed9ae$export$2e2bcd8739ae039)({
    light: $d568d81ef5c2bf7a$export$4a7404f376229999,
    dark: $d568d81ef5c2bf7a$export$4a7404f376229999
});
var $d568d81ef5c2bf7a$export$594c5a8758200c32 = (0, $9718da63677ed9ae$export$2e2bcd8739ae039)({
    light: $d568d81ef5c2bf7a$export$c6930421db9fa514,
    dark: $d568d81ef5c2bf7a$export$c6930421db9fa514
});
var $d568d81ef5c2bf7a$export$955a2ebd2fb142ae = (0, $9718da63677ed9ae$export$2e2bcd8739ae039)({
    light: $d568d81ef5c2bf7a$export$940e1f69e873f202,
    dark: $d568d81ef5c2bf7a$export$940e1f69e873f202
});
var $d568d81ef5c2bf7a$export$2a0674ff2eb10214 = function skeleton() {
    return "var(--ds-skeleton, ".concat($d568d81ef5c2bf7a$export$8d43898f60b96a82, ")");
};




var $kqp0i = parcelRequire("kqp0i");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");
/* button-base.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $kqp0i = parcelRequire("kqp0i");

var $1Vcia = parcelRequire("1Vcia");

var $970q7 = parcelRequire("970q7");

var $5FkrB = parcelRequire("5FkrB");
/* index.tsx generated by @compiled/babel-plugin v0.38.1 */ parcelRequire("5FkrB");


var $Pd8py = parcelRequire("Pd8py");
var $8d759d8816b1f54f$var$strictApi = (0, $Pd8py.createStrictAPI)();
var $8d759d8816b1f54f$export$dbf350e5966cf602 = $8d759d8816b1f54f$var$strictApi.css;
var $8d759d8816b1f54f$export$eb1ecd84a24ee424 = $8d759d8816b1f54f$var$strictApi.cssMap;
$8d759d8816b1f54f$var$strictApi.cssMap;
var $8d759d8816b1f54f$export$a274e22fb40f762e = $8d759d8816b1f54f$var$strictApi.cx;
var $8d759d8816b1f54f$var$XCSSProp = $8d759d8816b1f54f$var$strictApi.XCSSProp; // This is to mitigate local TS error TS2315: Type 'StrictXCSSProp' is not generic.
 // Currently for some reason tsc is generating malformed .d.ts in local dev environment, below change fixes it
 /**
 * ## StrictXCSSProp
 *
 * Declare styles your component takes with all other styles marked as violations
 * by the TypeScript compiler. There are two primary use cases for xcss prop:
 *
 * - safe style overrides
 * - inverting style declarations
 *
 * Interverting style declarations is interesting for platform teams as
 * it means apps only pay for styles they use as they're now the ones who declare
 * the styles!
 *
 * The {@link StrictXCSSProp} type has generics two of which must be defined — use to explicitly
 * set what you want to maintain as API. Use {@link XCSSAllProperties} and {@link XCSSAllPseudos}
 * to enable all properties and pseudos.
 *
 * The third generic is used to declare what properties and pseudos should be required.
 *
 * ```tsx
 * interface MyComponentProps {
 *   // Color is accepted, all other properties / pseudos are considered violations.
 *   xcss?: StrictXCSSProp<'color', never>;
 *
 *   // Only background color and hover pseudo are accepted.
 *   xcss?: StrictXCSSProp<'backgroundColor', '&:hover'>;
 *
 *   // All properties are accepted, all pseudos are considered violations.
 *   xcss?: StrictXCSSProp<XCSSAllProperties, never>;
 *
 *   // All properties are accepted, only the hover pseudo is accepted.
 *   xcss?: StrictXCSSProp<XCSSAllProperties, '&:hover'>;
 *
 *   // The xcss prop is required as well as the color property. No pseudos are required.
 *   xcss: StrictXCSSProp<
 *     XCSSAllProperties,
 *     '&:hover',
 *     { requiredProperties: 'color', requiredPseudos: never }
 *   >;
 * }
 *
 * function MyComponent({ xcss }: MyComponentProps) {
 *   return <div css={{ color: 'var(--ds-text-danger)' }} className={xcss} />
 * }
 * ```
 *
 * The xcss prop works with static inline objects and the [cssMap](https://compiledcssinjs.com/docs/api-cssmap) API.
 *
 * ```jsx
 * // Declared as an inline object
 * <Component xcss={{ color: 'var(--ds-text)' }} />
 *
 * // Declared with the cssMap API
 * const styles = cssMap({ text: { color: 'var(--ds-text)' } });
 * <Component xcss={styles.text} />
 * ```
 *
 * To concatenate and conditonally apply styles use the {@link cssMap} and {@link cx} functions.
 */ 



var $iO8GM = parcelRequire("iO8GM");

var $gpUQB = parcelRequire("gpUQB");

var $h8qvJ = parcelRequire("h8qvJ");

var $id6Cu = parcelRequire("id6Cu");
/* pressable.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $kqp0i = parcelRequire("kqp0i");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");

/**
 * This length includes the underscore,
 * e.g. `"_1s4A"` would be a valid atomic group hash.
 */ const $f7cb7c99b2133f21$var$ATOMIC_GROUP_LENGTH = 5;
function $f7cb7c99b2133f21$export$2e2bcd8739ae039(classNames) {
    // Shortcut: nothing to do
    if (!classNames.length) return;
    // Shortcut: don't need to do anything if we only have a single classname
    if (classNames.length === 1 && classNames[0] && // checking to see if `classNames[0]` is a string that contains other classnames
    !classNames[0].includes(' ')) return classNames[0];
    // Using an object rather than a `Map` as it performed better in our benchmarks.
    // Would be happy to move to `Map` if it proved to be better under real conditions.
    const map = {};
    // Note: using loops to minimize iterations over the collection
    for (const value of classNames){
        // Exclude all falsy values, which leaves us with populated strings
        if (!value) continue;
        // a `value` can contain multiple classnames
        const list = value.split(' ');
        for (const className of list){
            /**
             * For atomic style classnames: the `key` is the `group`
             *
             * - Later atomic classnames with the same `group` will override earlier ones
             *   (which is what we want).
             * - Assumes atomic classnames are the only things that start with `_`
             * - Could use a regex to ensure that atomic classnames are structured how we expect,
             *   but did not add that for now as it did slow things down a bit.
             *
             * For other classnames: the `key` is the whole classname
             * - Okay to remove duplicates as doing so does not impact specificity
             *
             * */ const key = className.startsWith('_') ? className.slice(0, $f7cb7c99b2133f21$var$ATOMIC_GROUP_LENGTH) : className;
            map[key] = className;
        }
    }
    /**
     * We are converting the `map` into a string.
     *
     * The simple way to do this would be `Object.values(map).join(' ')`.
     * However, the approach below performs 10%-20% better in benchmarks.
     *
     * For `ax()` it feels right to squeeze as much runtime performance out as we can.
     */ let result = '';
    for(const key in map)result += map[key] + ' ';
    // If we have an empty string, then our `map` was empty.
    if (!result) return;
    // remove last " " from the result (we added " " at the end of every value)
    return result.trimEnd();
}


const $3183c292a73a12a4$export$a274e22fb40f762e = (...styles)=>{
    // At runtime TStyles is resolved down to strings, but not at compile time.
    // We circumvent the type system here because of that.
    const actualStyles = styles;
    // The output should be a union type of passed in styles. This ensures the call
    // site of xcss prop can raise violations when disallowed styles have been passed.
    return (0, $f7cb7c99b2133f21$export$2e2bcd8739ae039)(actualStyles);
};



var $25nEq = parcelRequire("25nEq");

var $5FkrB = parcelRequire("5FkrB");

var $dLGML = parcelRequire("dLGML");

var $fC8ib = parcelRequire("fC8ib");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $kIXpt = parcelRequire("kIXpt");

var $cYPzS = parcelRequire("cYPzS");

var $lwlXp = parcelRequire("lwlXp");

var $eyuDe = parcelRequire("eyuDe");

var $25nEq = parcelRequire("25nEq");

var $ekGgq = parcelRequire("ekGgq");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $25nEq = parcelRequire("25nEq");
function $55d40a811c559e27$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $55d40a811c559e27$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $55d40a811c559e27$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $55d40a811c559e27$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $55d40a811c559e27$export$ad4be5c2ec28cecf = function isAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $55d40a811c559e27$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === 'AnalyticsEvent';
};
var $55d40a811c559e27$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function AnalyticsEvent(props) {
        var _this = this;
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, AnalyticsEvent);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "_isAnalyticsEvent", true);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "clone", function() {
            // just a shallow clone, don't change sub refs unless you want to
            // affect the original's too
            var payload = $55d40a811c559e27$var$_objectSpread({}, _this.payload);
            return new AnalyticsEvent({
                payload: payload
            });
        });
        this.payload = props.payload;
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(AnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (typeof updater === 'function') this.payload = updater(this.payload);
                if ((0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(updater) === 'object') this.payload = $55d40a811c559e27$var$_objectSpread($55d40a811c559e27$var$_objectSpread({}, this.payload), updater);
                return this;
            }
        }
    ]);
}();


function $edc760dda90056f7$var$_callSuper(t, o, e) {
    return o = (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(o), (0, (/*@__PURE__*/$parcel$interopDefault($kIXpt)))(t, $edc760dda90056f7$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(t).constructor) : o.apply(t, e));
}
function $edc760dda90056f7$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($edc760dda90056f7$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $edc760dda90056f7$var$_superPropGet(t, o, e, r) {
    var p = (0, (/*@__PURE__*/$parcel$interopDefault($lwlXp)))((0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(1 & r ? t.prototype : t), o, e);
    return 2 & r && "function" == typeof p ? function(t) {
        return p.apply(e, t);
    } : p;
}
var $edc760dda90056f7$export$35f8383928ba8d7 = function isUIAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $edc760dda90056f7$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isUIAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === 'UIAnalyticsEvent';
};
var $edc760dda90056f7$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_AnalyticsEvent) {
    function UIAnalyticsEvent(props) {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, UIAnalyticsEvent);
        _this = $edc760dda90056f7$var$_callSuper(this, UIAnalyticsEvent, [
            props
        ]);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "_isUIAnalyticsEvent", true);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "clone", function() {
            if (_this.hasFired) return null;
            var context = (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(_this.context);
            var handlers = (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(_this.handlers);
            /**
       * A hacky "deep clone" of the object. This is limited in that it wont
       * support functions, regexs, Maps, Sets, etc, but none of those need to
       * be represented in our payload.
       */ var payload = JSON.parse(JSON.stringify(_this.payload));
            return new UIAnalyticsEvent({
                context: context,
                handlers: handlers,
                payload: payload
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "fire", function(channel) {
            if (_this.hasFired) return;
            _this.handlers.forEach(function(handler) {
                return handler(_this, channel);
            });
            _this.hasFired = true;
        });
        _this.context = props.context || [];
        _this.handlers = props.handlers || [];
        _this.hasFired = false;
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($eyuDe)))(UIAnalyticsEvent, _AnalyticsEvent);
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(UIAnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (this.hasFired) return this;
                return $edc760dda90056f7$var$_superPropGet(UIAnalyticsEvent, "update", this, 3)([
                    updater
                ]);
            }
        }
    ]);
}((0, $55d40a811c559e27$export$2e2bcd8739ae039));



var $5FkrB = parcelRequire("5FkrB");

var $iyyOp = parcelRequire("iyyOp");
var $73efe5874ba10b72$export$d1f587f82ad51c4 = function useAnalyticsContext() {
    return (0, $5FkrB.useContext)((0, $iyyOp.default));
};


function $f4094086a31254dc$export$5bf35293e545f20c() {
    var analyticsContext = (0, $73efe5874ba10b72$export$d1f587f82ad51c4)();
    var createAnalyticsEvent = (0, $dLGML.useCallbackOne)(function(payload) {
        return new (0, $edc760dda90056f7$export$2e2bcd8739ae039)({
            context: analyticsContext.getAtlaskitAnalyticsContext(),
            handlers: analyticsContext.getAtlaskitAnalyticsEventHandlers(),
            payload: payload
        });
    }, [
        analyticsContext
    ]);
    return {
        createAnalyticsEvent: createAnalyticsEvent
    };
}



var $5FkrB = parcelRequire("5FkrB");
var $d04a186192365047$export$1d27a74659855e44 = function useTrackedRef(value) {
    var ref = (0, $5FkrB.useRef)(value);
    ref.current = value;
    return ref;
};


function $208178b23503ab4a$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $208178b23503ab4a$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $208178b23503ab4a$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $208178b23503ab4a$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $208178b23503ab4a$export$a4687b0234b40e28(_ref) {
    var fn = _ref.fn, action = _ref.action, componentName = _ref.componentName, actionSubject = _ref.actionSubject, packageName = _ref.packageName, packageVersion = _ref.packageVersion, analyticsData = _ref.analyticsData;
    var _useAnalyticsEvents = (0, $f4094086a31254dc$export$5bf35293e545f20c)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
    // We put analyticsData and fn in a ref so that we don't need to break
    // memoization.
    // Generally these could be defined by consumers inline
    // and so we do this to avoid breaking memoization of useCallback
    var dataRef = (0, $d04a186192365047$export$1d27a74659855e44)(analyticsData);
    var fnRef = (0, $d04a186192365047$export$1d27a74659855e44)(fn);
    var handler = (0, $5FkrB.useCallback)(function(value) {
        var analyticsEvent = createAnalyticsEvent({
            action: action,
            actionSubject: actionSubject || componentName,
            attributes: {
                componentName: componentName,
                packageName: packageName,
                packageVersion: packageVersion
            }
        });
        // To avoid wrapping this component in AnalyticsContext we manually
        // push the parent context's meta data into the context.
        // Note: this new 'context'
        var context = $208178b23503ab4a$var$_objectSpread({
            componentName: componentName,
            packageName: packageName,
            packageVersion: packageVersion
        }, dataRef.current);
        analyticsEvent.context.push(context);
        // fire an event on the atlaskit channel
        var clone = analyticsEvent.clone();
        if (clone) clone.fire('atlaskit');
        fnRef.current(value, analyticsEvent);
    }, [
        // These are strings and won't change
        action,
        componentName,
        actionSubject,
        packageName,
        packageVersion,
        // This function is memoized in the context
        createAnalyticsEvent,
        // these are a stable ref because of the useTrackedRef hook
        dataRef,
        fnRef
    ]);
    return handler;
}


function $cdea94d60eae4a70$var$testPlatform(re) {
    var _userAgentData;
    return typeof window !== 'undefined' && window.navigator != null ? re.test(((_userAgentData = window.navigator['userAgentData']) === null || _userAgentData === void 0 ? void 0 : _userAgentData.platform) || window.navigator.platform) : false;
}
function $cdea94d60eae4a70$var$isIPhone() {
    return $cdea94d60eae4a70$var$testPlatform(/^iPhone/i);
}
function $cdea94d60eae4a70$var$isMac() {
    return $cdea94d60eae4a70$var$testPlatform(/^Mac/i);
}
function $cdea94d60eae4a70$var$isIPad() {
    return $cdea94d60eae4a70$var$testPlatform(/^iPad/i) || // iPadOS 13 lies and says it's a Mac, but we can distinguish by detecting touch support.
    $cdea94d60eae4a70$var$isMac() && navigator.maxTouchPoints > 1;
}
function $cdea94d60eae4a70$var$isIOS() {
    return $cdea94d60eae4a70$var$isIPhone() || $cdea94d60eae4a70$var$isIPad();
}
function $cdea94d60eae4a70$export$95df08bae54cb4df() {
    if (typeof window !== 'undefined' && window.navigator != null) {
        var _window$navigator$use;
        var ua = (_window$navigator$use = window.navigator.userAgent) === null || _window$navigator$use === void 0 ? void 0 : _window$navigator$use.toLowerCase();
        return ua ? ua.includes('safari') && !ua.includes('chrome') : false;
    }
    return false;
}
function $cdea94d60eae4a70$export$e1865c3bedcd822b() {
    return $cdea94d60eae4a70$var$isMac() || $cdea94d60eae4a70$var$isIOS();
}


/**
 * An empty function which does nothing.
 */ function $2fe03168032cd3f5$export$2e2bcd8739ae039() {}



var $eqVaP = parcelRequire("eqVaP");
/* focusable.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $kqp0i = parcelRequire("kqp0i");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");

var $c7c7a3ecbfcb3564$var$_excluded = [
    "as",
    "children",
    "isInset",
    "testId",
    "style",
    "xcss"
], $c7c7a3ecbfcb3564$var$_excluded2 = [
    "className"
];
var $c7c7a3ecbfcb3564$var$focusRingStyles = null;
var $c7c7a3ecbfcb3564$var$insetFocusRingStyles = null;
/**
 * __Focus ring__
 *
 * A focus ring visually indicates the currently focused item.
 *
 */ var $c7c7a3ecbfcb3564$var$Focusable = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? 'button' : _ref$as, children = _ref.children, isInset = _ref.isInset, testId = _ref.testId, style = _ref.style, xcss = _ref.xcss, htmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $c7c7a3ecbfcb3564$var$_excluded);
    // This is to remove className from safeHtmlAttributes
    // @ts-ignore -- not using expect since it causes issues with help-center local consumption - className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(htmlAttributes, $c7c7a3ecbfcb3564$var$_excluded2);
    return /*#__PURE__*/ $5FkrB.createElement(Component, (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, safeHtmlAttributes, {
        // @ts-ignore Expression produces a union type that is too complex to represent. We may be able to narrow the type here but unsure.
        ref: ref,
        className: (0, $f7cb7c99b2133f21$export$2e2bcd8739ae039)([
            "_ymio1r31 _ypr0glyw _zcxs1o36 _mizu194a _1ah3dkaa _ra3xnqa1 _128mdkaa _1cvmnqa1 _4davt94y",
            isInset && "_1ah31gjf _2mwq1gjf",
            xcss
        ]),
        style: style,
        "data-testid": testId
    }), children);
});
var $c7c7a3ecbfcb3564$export$2e2bcd8739ae039 = $c7c7a3ecbfcb3564$var$Focusable;


var $ada51b3d35ac77c1$var$_excluded = [
    "children",
    "isDisabled",
    "type",
    "onClick",
    "interactionName",
    "componentName",
    "analyticsContext",
    "style",
    "testId",
    "xcss",
    "tabIndex"
], $ada51b3d35ac77c1$var$_excluded2 = [
    "className"
];
var $ada51b3d35ac77c1$var$styles = {
    root: "_19itglyw _vchhusvi _r06hglyw _80omtlke",
    disabled: "_80om13gf"
};
/**
 * __Pressable__
 *
 * A primitive for building custom buttons.
 *
 * - [Examples](https://atlassian.design/components/primitives/pressable/examples)
 * - [Code](https://atlassian.design/components/primitives/pressable/code)
 * - [Usage](https://atlassian.design/components/primitives/pressable/usage)
 */ var $ada51b3d35ac77c1$var$Pressable = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function(_ref, ref) {
    var children = _ref.children, isDisabled = _ref.isDisabled, _ref$type = _ref.type, type = _ref$type === void 0 ? 'button' : _ref$type, _ref$onClick = _ref.onClick, providedOnClick = _ref$onClick === void 0 ? (0, $2fe03168032cd3f5$export$2e2bcd8739ae039) : _ref$onClick, interactionName = _ref.interactionName, componentName = _ref.componentName, analyticsContext = _ref.analyticsContext, style = _ref.style, testId = _ref.testId, xcss = _ref.xcss, tabIndex = _ref.tabIndex, htmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $ada51b3d35ac77c1$var$_excluded);
    var interactionContext = (0, $5FkrB.useContext)((0, $eqVaP.default));
    var handleClick = (0, $5FkrB.useCallback)(function(e, analyticsEvent) {
        interactionContext && interactionContext.tracePress(interactionName, e.timeStamp);
        providedOnClick(e, analyticsEvent);
    }, [
        providedOnClick,
        interactionContext,
        interactionName
    ]);
    var onClick = (0, $208178b23503ab4a$export$a4687b0234b40e28)({
        fn: handleClick,
        action: 'clicked',
        componentName: componentName || 'Pressable',
        packageName: "@atlaskit/primitives",
        packageVersion: "0.0.0-development",
        analyticsData: analyticsContext,
        actionSubject: 'button'
    });
    // This is to remove className from safeHtmlAttributes
    // @ts-expect-error className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(htmlAttributes, $ada51b3d35ac77c1$var$_excluded2);
    return /*#__PURE__*/ $5FkrB.createElement((0, $c7c7a3ecbfcb3564$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        as: "button",
        tabIndex: tabIndex !== null && tabIndex !== void 0 ? tabIndex : (0, $cdea94d60eae4a70$export$95df08bae54cb4df)() && !isDisabled ? 0 : undefined,
        style: style
    }, safeHtmlAttributes, {
        type: type,
        onClick: onClick,
        disabled: isDisabled,
        xcss: (0, $3183c292a73a12a4$export$a274e22fb40f762e)($ada51b3d35ac77c1$var$styles.root, isDisabled && $ada51b3d35ac77c1$var$styles.disabled, xcss),
        testId: testId,
        ref: ref
    }), children);
});
var $ada51b3d35ac77c1$export$2e2bcd8739ae039 = $ada51b3d35ac77c1$var$Pressable;




var $5FkrB = parcelRequire("5FkrB");
var $50907521af6e2d1f$export$4b86304b2c0d7e71 = /*#__PURE__*/ (0, $5FkrB.createContext)(undefined);
var $50907521af6e2d1f$export$47e2c6fdb142d947 = function useSplitButtonContext() {
    var context = (0, $5FkrB.useContext)($50907521af6e2d1f$export$4b86304b2c0d7e71);
    if (!context) return undefined;
    if (context.appearance === 'navigation') {
        var newContext = {
            spacing: 'default',
            appearance: 'subtle',
            isDisabled: false,
            isActiveOverSelected: false,
            isNavigationSplitButton: true,
            isHighlighted: context.isHighlighted
        };
        return newContext;
    }
    var splitButtonContext = {
        spacing: context.spacing,
        appearance: context.appearance,
        isDisabled: context.isDisabled,
        isActiveOverSelected: true,
        isNavigationSplitButton: false,
        isHighlighted: false
    };
    return splitButtonContext;
};


function $991729c2a08d8f43$var$abort(event) {
    event.preventDefault();
    event.stopPropagation();
}
var $991729c2a08d8f43$var$tabKeyCode = 9;
function $991729c2a08d8f43$var$onKey(event) {
    // Allowing tab so that a user can move focus away
    if (event.keyCode === $991729c2a08d8f43$var$tabKeyCode) return;
    $991729c2a08d8f43$var$abort(event);
}
function $991729c2a08d8f43$export$2e2bcd8739ae039(shouldBlockEvents, events) {
    return shouldBlockEvents ? {
        onMouseDownCapture: $991729c2a08d8f43$var$abort,
        onMouseUpCapture: $991729c2a08d8f43$var$abort,
        onKeyDownCapture: $991729c2a08d8f43$var$onKey,
        onKeyUpCapture: $991729c2a08d8f43$var$onKey,
        onTouchStartCapture: $991729c2a08d8f43$var$abort,
        onTouchEndCapture: $991729c2a08d8f43$var$abort,
        onPointerDownCapture: $991729c2a08d8f43$var$abort,
        onPointerUpCapture: $991729c2a08d8f43$var$abort,
        onClickCapture: $991729c2a08d8f43$var$abort,
        // Just smashing the existing onClick for good measure
        onClick: $991729c2a08d8f43$var$abort
    } : events;
}



var $5FkrB = parcelRequire("5FkrB");

function $90fd041fa0c852cc$var$getIconSpacing(spacing) {
    switch(spacing){
        case 'compact':
            return 'small';
        default:
            return 'medium';
    }
}
function $90fd041fa0c852cc$var$getSpinnerAppearance(_ref) {
    var appearance = _ref.appearance, isDisabled = _ref.isDisabled, isSelected = _ref.isSelected;
    if (isDisabled || isSelected) return 'inherit';
    if (appearance === 'primary' || appearance === 'danger' || appearance === 'discovery') return 'invert';
    return 'inherit';
}
function $90fd041fa0c852cc$export$2e2bcd8739ae039(_ref2) {
    var appearance = _ref2.appearance, spacing = _ref2.spacing, isDisabled = _ref2.isDisabled, isSelected = _ref2.isSelected, testId = _ref2.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $925729470282e6a4$export$2e2bcd8739ae039), {
        size: $90fd041fa0c852cc$var$getIconSpacing(spacing),
        appearance: $90fd041fa0c852cc$var$getSpinnerAppearance({
            appearance: appearance,
            isDisabled: isDisabled,
            isSelected: isSelected
        }),
        testId: testId ? "".concat(testId, "--loading-spinner") : undefined
    });
}


var $aa6f0a9cd00d5488$var$_excluded = [
    "appearance",
    "autoFocus",
    "isDisabled",
    "isLoading",
    "isSelected",
    "isIconButton",
    "isCircle",
    "hasIconBefore",
    "hasIconAfter",
    "shouldFitContainer",
    "spacing",
    "ariaLabel",
    "ariaLabelledBy",
    "children",
    "interactionName",
    "onClick",
    "onMouseDown",
    "onMouseDownCapture",
    "onMouseUp",
    "onMouseUpCapture",
    "onKeyDown",
    "onKeyDownCapture",
    "onKeyUp",
    "onKeyUpCapture",
    "onTouchStart",
    "onTouchStartCapture",
    "onTouchEnd",
    "onTouchEndCapture",
    "onPointerDown",
    "onPointerDownCapture",
    "onPointerUp",
    "onPointerUpCapture",
    "onClickCapture",
    "testId",
    "analyticsContext",
    "componentName",
    "role",
    "onMouseOver",
    "onMouseOut",
    "onFocus",
    "onBlur",
    "onMouseMove",
    "type"
], $aa6f0a9cd00d5488$var$_excluded2 = [
    "className",
    "css",
    "as",
    "style"
];
var $aa6f0a9cd00d5488$var$LOADING_LABEL = ', Loading';
var $aa6f0a9cd00d5488$var$styles = {
    base: "_2rkofajl _11c8fhey _v5649dqc _189eidpf _1rjc12x7 _1e0c116y _vchhusvi _1bsb1wug _p12f1osq _kqswh2mm _4cvr1q9y _1bah1h6o _gy1p1b66 _1o9zidpf _4t3iviql _k48p1wq8 _y4tiutpp _bozgutpp _y3gn1h6o _s7n4nkob _14mj1kw7 _9v7aze3t _1tv3nqa1 _39yqe4h9 _11fnglyw _18postnw",
    baseT26Shape: "_2rko1qi0",
    linkDecorationUnset: "_4bfu1r31 _1hmsglyw _ajmmnqa1 _1a3b1r31 _4fprglyw _5goinqa1 _9oik1r31 _1bnxglyw _jf4cnqa1 _1nrm1r31 _c2waglyw _1iohnqa1",
    disabled: "_80om13gf _syaz1gmx _30l31gmx _9h8h1gmx",
    sharedDisabled: "_bfhk1fvb _irr31fvb _1di61fvb",
    spacingCompact: "_1rjcv77o _gy1p1b66 _4t3i1k8s _y4tiutpp _bozgutpp _s7n4nkob",
    spacingCompactT26Shape: "_2rko12b0",
    circle: "_2rko1rr0",
    fullWidth: "_1bsb1osq",
    loading: "_80om15jw",
    iconButton: "_4t3iviql _1bsbviql _y4tize3t _bozgze3t",
    iconButtonCompact: "_4t3i1k8s _1bsb1k8s",
    buttonIconBeforeWithHack: "_bozgu2gc",
    buttonIconAfterWithHack: "_y4tiu2gc",
    buttonIconBefore: "_bozgutpp _gy1p12x7",
    buttonIconAfter: "_y4tiutpp _gy1p12x7",
    splitButton: "_g0pbb4wl",
    loadingOverlay: "_1reo15vq _18m915vq _1e0c1txw _kqswstnw _4cvr1h6o _1bah1h6o _u7coze3t _152tze3t _rjxpze3t _1e02ze3t",
    navigationSplitButton: "_1bsb1tcg _bfhksm61 _y4ti12x7 _bozg12x7"
};
var $aa6f0a9cd00d5488$var$defaultStyles = {
    root: "_bfhksm61 _syazazsu _8l3m1l7x _aetrb3bt _1053azsu _f8pjazsu _30l3azsu _9h8hazsu",
    interactive: "_irr31dpa _30l3azsu _1di6fcek _9h8hazsu",
    disabled: "_bfhk1j28 _8l3mbk0g _irr31j28 _1di61j28"
};
var $aa6f0a9cd00d5488$var$primaryStyles = {
    root: "_bfhkomb0 _syaz15cr _105315cr _f8pj15cr _30l315cr _9h8h15cr",
    interactive: "_30l315cr _irr31wqm _9h8h15cr _1di617hq"
};
var $aa6f0a9cd00d5488$var$warningStyles = {
    root: "_bfhk1ikc _syazal3n _1053al3n _f8pjal3n _30l3al3n _9h8hal3n",
    interactive: "_30l3al3n _irr31j43 _9h8hal3n _1di6h4op"
};
var $aa6f0a9cd00d5488$var$dangerStyles = {
    root: "_bfhk1v7l _syaz15cr _105315cr _f8pj15cr _30l315cr _9h8h15cr",
    interactive: "_30l315cr _irr31rwk _9h8h15cr _1di6yycf"
};
var $aa6f0a9cd00d5488$var$discoveryStyles = {
    root: "_bfhk1vbi _syaz15cr _105315cr _f8pj15cr _30l315cr _9h8h15cr",
    interactive: "_30l315cr _irr37gr8 _9h8h15cr _1di61wu2"
};
var $aa6f0a9cd00d5488$var$subtleStyles = {
    root: "_bfhkqtfy _syazazsu _1053azsu _f8pjazsu _30l3azsu _9h8hazsu",
    interactive: "_irr34mfv _30l3azsu _1di619qy _9h8hazsu",
    disabled: "_bfhk1j28 _8l3mbk0g _irr31j28 _1di61j28"
};
var $aa6f0a9cd00d5488$var$selectedStyles = {
    root: "_bfhk15s3 _syaz1ldt _8l3mcoux _aetrb3bt _10531ldt _f8pj1ldt _30l31ldt _9h8h1ldt",
    insideSplitButton: "_1pbycs5v",
    interactive: "_irr3t71w _30l31pke _1di6yssv _9h8h1pke",
    warning: "_bfhkvdtc _syaz16q2 _30l31pke _irr3vdtc _9h8h1pke _1di6vdtc",
    danger: "_bfhkbeib _syaz1pke _30l31pke _irr3beib _9h8h1pke _1di6beib",
    discovery: "_bfhk1g49 _syaz1pke _30l31pke _irr31g49 _9h8h1pke _1di61g49"
};
/**
 * __button base__
 *
 * - Implements auto focus when enabled.
 * - Appends the `onClick` event with UFO analytics tracking.
 *
 * @private
 */ var $aa6f0a9cd00d5488$var$ButtonBase = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).forwardRef(// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore: to unblock React 18.2.0 -> 18.3.1 version bump in Jira
function(_ref, ref) {
    var propAppearance = _ref.appearance, _ref$autoFocus = _ref.autoFocus, autoFocus = _ref$autoFocus === void 0 ? false : _ref$autoFocus, _ref$isDisabled = _ref.isDisabled, propIsDisabled = _ref$isDisabled === void 0 ? false : _ref$isDisabled, _ref$isLoading = _ref.isLoading, isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading, _ref$isSelected = _ref.isSelected, propIsSelected = _ref$isSelected === void 0 ? false : _ref$isSelected, _ref$isIconButton = _ref.isIconButton, isIconButton = _ref$isIconButton === void 0 ? false : _ref$isIconButton, _ref$isCircle = _ref.isCircle, isCircle = _ref$isCircle === void 0 ? false : _ref$isCircle, _ref$hasIconBefore = _ref.hasIconBefore, hasIconBefore = _ref$hasIconBefore === void 0 ? false : _ref$hasIconBefore, _ref$hasIconAfter = _ref.hasIconAfter, hasIconAfter = _ref$hasIconAfter === void 0 ? false : _ref$hasIconAfter, _ref$shouldFitContain = _ref.shouldFitContainer, shouldFitContainer = _ref$shouldFitContain === void 0 ? false : _ref$shouldFitContain, _ref$spacing = _ref.spacing, propSpacing = _ref$spacing === void 0 ? 'default' : _ref$spacing, ariaLabel = _ref.ariaLabel, ariaLabelledBy = _ref.ariaLabelledBy, children = _ref.children, interactionName = _ref.interactionName, onClick = _ref.onClick, onMouseDown = _ref.onMouseDown, onMouseDownCapture = _ref.onMouseDownCapture, onMouseUp = _ref.onMouseUp, onMouseUpCapture = _ref.onMouseUpCapture, onKeyDown = _ref.onKeyDown, onKeyDownCapture = _ref.onKeyDownCapture, onKeyUp = _ref.onKeyUp, onKeyUpCapture = _ref.onKeyUpCapture, onTouchStart = _ref.onTouchStart, onTouchStartCapture = _ref.onTouchStartCapture, onTouchEnd = _ref.onTouchEnd, onTouchEndCapture = _ref.onTouchEndCapture, onPointerDown = _ref.onPointerDown, onPointerDownCapture = _ref.onPointerDownCapture, onPointerUp = _ref.onPointerUp, onPointerUpCapture = _ref.onPointerUpCapture, onClickCapture = _ref.onClickCapture, testId = _ref.testId, analyticsContext = _ref.analyticsContext, componentName = _ref.componentName, role = _ref.role, onMouseOver = _ref.onMouseOver, onMouseOut = _ref.onMouseOut, onFocus = _ref.onFocus, onBlur = _ref.onBlur, onMouseMove = _ref.onMouseMove, type = _ref.type, unsafeRest = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $aa6f0a9cd00d5488$var$_excluded);
    var localRef = (0, $5FkrB.useRef)(null);
    var splitButtonContext = (0, $50907521af6e2d1f$export$47e2c6fdb142d947)();
    var loadingLabelId = (0, $h8qvJ.useId)();
    var isSplitButton = Boolean(splitButtonContext);
    var isNavigationSplitButton = (splitButtonContext === null || splitButtonContext === void 0 ? void 0 : splitButtonContext.isNavigationSplitButton) || false;
    var isDefaultAppearanceSplitButton = (splitButtonContext === null || splitButtonContext === void 0 ? void 0 : splitButtonContext.appearance) === 'default';
    var appearance = isDefaultAppearanceSplitButton ? 'subtle' : propAppearance || (splitButtonContext === null || splitButtonContext === void 0 ? void 0 : splitButtonContext.appearance) || 'default';
    var spacing = (splitButtonContext === null || splitButtonContext === void 0 ? void 0 : splitButtonContext.spacing) || propSpacing;
    var isDisabled = (splitButtonContext === null || splitButtonContext === void 0 ? void 0 : splitButtonContext.isDisabled) || propIsDisabled;
    var isInteractive = !isDisabled && !isLoading;
    // Also treat loading buttons as disabled
    var isEffectivelyDisabled = isDisabled || isLoading;
    var isSelected = propIsSelected && !isDisabled;
    (0, $gpUQB.default)(localRef, autoFocus);
    // @ts-expect-error
    var _className = unsafeRest.className, _css = unsafeRest.css, _as = unsafeRest.as, _style = unsafeRest.style, saferRest = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(unsafeRest, $aa6f0a9cd00d5488$var$_excluded2);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $ada51b3d35ac77c1$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, saferRest, {
        componentName: componentName || 'button',
        analyticsContext: analyticsContext,
        role: role,
        ref: (0, $iO8GM.default)([
            localRef,
            ref
        ]),
        xcss: (0, $8d759d8816b1f54f$export$a274e22fb40f762e)($aa6f0a9cd00d5488$var$styles.base, (0, $id6Cu.fg)('platform-dst-shape-theme-default') && $aa6f0a9cd00d5488$var$styles.baseT26Shape, appearance === 'default' && $aa6f0a9cd00d5488$var$defaultStyles.root, appearance === 'default' && isInteractive && $aa6f0a9cd00d5488$var$defaultStyles.interactive, appearance === 'primary' && $aa6f0a9cd00d5488$var$primaryStyles.root, appearance === 'primary' && isInteractive && $aa6f0a9cd00d5488$var$primaryStyles.interactive, appearance === 'warning' && $aa6f0a9cd00d5488$var$warningStyles.root, appearance === 'warning' && isInteractive && $aa6f0a9cd00d5488$var$warningStyles.interactive, appearance === 'danger' && $aa6f0a9cd00d5488$var$dangerStyles.root, appearance === 'danger' && isInteractive && $aa6f0a9cd00d5488$var$dangerStyles.interactive, appearance === 'discovery' && $aa6f0a9cd00d5488$var$discoveryStyles.root, appearance === 'discovery' && isInteractive && $aa6f0a9cd00d5488$var$discoveryStyles.interactive, appearance === 'subtle' && $aa6f0a9cd00d5488$var$subtleStyles.root, appearance === 'subtle' && isInteractive && $aa6f0a9cd00d5488$var$subtleStyles.interactive, $aa6f0a9cd00d5488$var$styles.linkDecorationUnset, isSelected && $aa6f0a9cd00d5488$var$selectedStyles.root, isSelected && isSplitButton && $aa6f0a9cd00d5488$var$selectedStyles.insideSplitButton, isSelected && isInteractive && $aa6f0a9cd00d5488$var$selectedStyles.interactive, // TODO: remove me once we kill color fallbacks
        isSelected && appearance === 'danger' && $aa6f0a9cd00d5488$var$selectedStyles.danger, // TODO: remove me once we kill color fallbacks
        isSelected && appearance === 'warning' && $aa6f0a9cd00d5488$var$selectedStyles.warning, // TODO: remove me once we kill color fallbacks
        isSelected && appearance === 'discovery' && $aa6f0a9cd00d5488$var$selectedStyles.discovery, isDisabled && $aa6f0a9cd00d5488$var$styles.disabled, isDisabled && appearance !== 'default' && appearance !== 'subtle' && $aa6f0a9cd00d5488$var$styles.sharedDisabled, isDisabled && appearance === 'default' && $aa6f0a9cd00d5488$var$defaultStyles.disabled, isCircle && !isSplitButton && $aa6f0a9cd00d5488$var$styles.circle, spacing === 'compact' && $aa6f0a9cd00d5488$var$styles.spacingCompact, spacing === 'compact' && (0, $id6Cu.fg)('platform-dst-shape-theme-default') && $aa6f0a9cd00d5488$var$styles.spacingCompactT26Shape, shouldFitContainer && $aa6f0a9cd00d5488$var$styles.fullWidth, hasIconBefore && !(0, $id6Cu.fg)('platform-button-icon-spacing-cleanup') && $aa6f0a9cd00d5488$var$styles.buttonIconBeforeWithHack, //TODO Remove when platform-button-icon-spacing-cleanup is removed
        hasIconAfter && !(0, $id6Cu.fg)('platform-button-icon-spacing-cleanup') && $aa6f0a9cd00d5488$var$styles.buttonIconAfterWithHack, //TODO Remove when platform-button-icon-spacing-cleanup is removed
        hasIconBefore && (0, $id6Cu.fg)('platform-button-icon-spacing-cleanup') && $aa6f0a9cd00d5488$var$styles.buttonIconBefore, //to keep when platform-button-icon-spacing-cleanup is removed
        hasIconAfter && (0, $id6Cu.fg)('platform-button-icon-spacing-cleanup') && $aa6f0a9cd00d5488$var$styles.buttonIconAfter, //to keep when platform-button-icon-spacing-cleanup is removed
        isIconButton && $aa6f0a9cd00d5488$var$styles.iconButton, isIconButton && spacing === 'compact' && $aa6f0a9cd00d5488$var$styles.iconButtonCompact, isLoading && $aa6f0a9cd00d5488$var$styles.loading, isSplitButton && $aa6f0a9cd00d5488$var$styles.splitButton, isNavigationSplitButton && $aa6f0a9cd00d5488$var$styles.navigationSplitButton),
        isDisabled: (0, $id6Cu.fg)('platform-dst_fix_not_focusable_loading_button') ? isDisabled : isEffectivelyDisabled
    }, (0, $id6Cu.fg)('platform-dst_fix_not_focusable_loading_button') && {
        'aria-live': 'polite'
    }, isLoading && (0, $id6Cu.fg)('platform-dst_fix_not_focusable_loading_button') && {
        'aria-disabled': true
    }, {
        "aria-label": isLoading && ariaLabel && !ariaLabelledBy ? "".concat(ariaLabel, " ").concat($aa6f0a9cd00d5488$var$LOADING_LABEL) : ariaLabel,
        "aria-labelledby": isLoading && ariaLabelledBy ? "".concat(ariaLabelledBy, " ").concat(loadingLabelId) : ariaLabelledBy,
        onClick: onClick
    }, (0, $991729c2a08d8f43$export$2e2bcd8739ae039)(isEffectivelyDisabled, {
        onMouseDownCapture: onMouseDownCapture,
        onMouseUpCapture: onMouseUpCapture,
        onKeyDownCapture: onKeyDownCapture,
        onKeyUpCapture: onKeyUpCapture,
        onTouchStartCapture: onTouchStartCapture,
        onTouchEndCapture: onTouchEndCapture,
        onPointerDownCapture: onPointerDownCapture,
        onPointerUpCapture: onPointerUpCapture,
        onClickCapture: onClickCapture
    }), {
        testId: testId,
        onMouseOver: onMouseOver,
        onFocus: onFocus,
        onMouseMove: onMouseMove,
        onBlur: onBlur,
        type: type,
        interactionName: interactionName,
        onMouseDown: onMouseDown,
        onMouseUp: onMouseUp,
        onKeyDown: onKeyDown,
        onMouseOut: onMouseOut,
        onKeyUp: onKeyUp,
        onTouchStart: onTouchStart,
        onTouchEnd: onTouchEnd,
        onPointerDown: onPointerDown,
        onPointerUp: onPointerUp
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $50907521af6e2d1f$export$4b86304b2c0d7e71).Provider, {
        value: undefined
    }, children, isLoading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("span", {
        className: (0, $970q7.default)([
            $aa6f0a9cd00d5488$var$styles.loadingOverlay
        ])
    }, (0, $90fd041fa0c852cc$export$2e2bcd8739ae039)({
        spacing: spacing,
        appearance: appearance,
        isDisabled: isDisabled,
        isSelected: isSelected,
        testId: testId
    })), isLoading && (ariaLabelledBy || !ariaLabel) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $8056b266ab217caa$export$2e2bcd8739ae039), {
        id: loadingLabelId
    }, $aa6f0a9cd00d5488$var$LOADING_LABEL)));
});
var $aa6f0a9cd00d5488$export$2e2bcd8739ae039 = $aa6f0a9cd00d5488$var$ButtonBase;


/* content.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $970q7 = parcelRequire("970q7");

var $5FkrB = parcelRequire("5FkrB");

var $id6Cu = parcelRequire("id6Cu");
var $3279464c7324ff68$var$styles = {
    text: "_1reo15vq _18m915vq _16jlkb7n _1o9zkb7n _1bto1l2s _o5721q9c",
    icon: "_1e0c1txw _16jlidpf _1o9zidpf _1wpz1h6o _1wybidpf _vwz4idpf _uiztglyw",
    common: "_v564g17y",
    fade: "_tzy4idpf",
    beforeIcon: "_1he91b66 _w795v77o",
    afterIcon: "_1he9v77o _w7951b66"
};
/**
 * __Content__
 *
 * Used for slots within a Button, including icons and text content.
 */ var $3279464c7324ff68$var$Content = function Content(_ref) {
    var children = _ref.children, _ref$type = _ref.type, type = _ref$type === void 0 ? 'text' : _ref$type, isLoading = _ref.isLoading, position = _ref.position;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("span", {
        className: (0, $970q7.default)([
            $3279464c7324ff68$var$styles.common,
            type === 'text' && $3279464c7324ff68$var$styles.text,
            type === 'icon' && $3279464c7324ff68$var$styles.icon,
            isLoading && $3279464c7324ff68$var$styles.fade,
            !(0, $id6Cu.fg)('platform-button-icon-spacing-cleanup') && position === 'before' && $3279464c7324ff68$var$styles.beforeIcon,
            !(0, $id6Cu.fg)('platform-button-icon-spacing-cleanup') && position === 'after' && $3279464c7324ff68$var$styles.afterIcon
        ])
    }, children);
};
var $3279464c7324ff68$export$2e2bcd8739ae039 = $3279464c7324ff68$var$Content;



var $5FkrB = parcelRequire("5FkrB");

var $id6Cu = parcelRequire("id6Cu");
function $ed85b23eca664e45$var$isIconRenderProp(func) {
    return !func.displayName && // most function components and class components have a displayName, negate them
    !func.render && // forwardRef doesn't require a display name, however it does include a render function, negate them
    typeof func === 'function' // at the very least we need to be a function
    ;
}
/**
 * __Icon renderer__
 *
 * Used to support render props with icons.
 *
 */ var $ed85b23eca664e45$var$IconRenderer = function IconRenderer(_ref) {
    var Icon = _ref.icon;
    var isRenderProp = $ed85b23eca664e45$var$isIconRenderProp(Icon);
    var iconProps = {
        label: '',
        color: 'currentColor',
        size: (0, $id6Cu.fg)('platform_dst_button_chevron_sizing') ? function(iconName) {
            return iconName.startsWith('Chevron') ? 'small' : 'medium';
        } : undefined
    };
    // @ts-ignore - TS2322 TypeScript 5.9.2 upgrade
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).Fragment, null, isRenderProp ? Icon(iconProps) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(Icon, iconProps));
};
var $ed85b23eca664e45$export$2e2bcd8739ae039 = $ed85b23eca664e45$var$IconRenderer;


var $37328c3a94101dc2$var$_excluded = [
    "analyticsContext",
    "appearance",
    "aria-label",
    "aria-labelledby",
    "autoFocus",
    "children",
    "iconAfter",
    "iconBefore",
    "interactionName",
    "isDisabled",
    "isLoading",
    "isSelected",
    "onClick",
    "onClickCapture",
    "onKeyDownCapture",
    "onKeyUpCapture",
    "onMouseDownCapture",
    "onMouseUpCapture",
    "onPointerDownCapture",
    "onPointerUpCapture",
    "onTouchEndCapture",
    "onTouchStartCapture",
    "shouldFitContainer",
    "spacing",
    "testId",
    "type"
], $37328c3a94101dc2$var$_excluded2 = [
    "className",
    "css",
    "as",
    "style"
];
/**
 * __Button__
 *
 * A button triggers an event or action.
 *
 * - [Examples](https://atlassian.design/components/button/examples)
 * - [Code](https://atlassian.design/components/button/code)
 * - [Usage](https://atlassian.design/components/button/usage)
 */ var $37328c3a94101dc2$var$Button = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).forwardRef(function Button(_ref, ref) {
    var analyticsContext = _ref.analyticsContext, appearance = _ref.appearance, ariaLabel = _ref['aria-label'], ariaLabelledBy = _ref['aria-labelledby'], autoFocus = _ref.autoFocus, children = _ref.children, iconAfter = _ref.iconAfter, iconBefore = _ref.iconBefore, interactionName = _ref.interactionName, isDisabled = _ref.isDisabled, _ref$isLoading = _ref.isLoading, isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading, isSelected = _ref.isSelected, onClick = _ref.onClick, onClickCapture = _ref.onClickCapture, onKeyDownCapture = _ref.onKeyDownCapture, onKeyUpCapture = _ref.onKeyUpCapture, onMouseDownCapture = _ref.onMouseDownCapture, onMouseUpCapture = _ref.onMouseUpCapture, onPointerDownCapture = _ref.onPointerDownCapture, onPointerUpCapture = _ref.onPointerUpCapture, onTouchEndCapture = _ref.onTouchEndCapture, onTouchStartCapture = _ref.onTouchStartCapture, shouldFitContainer = _ref.shouldFitContainer, spacing = _ref.spacing, testId = _ref.testId, _ref$type = _ref.type, type = _ref$type === void 0 ? 'button' : _ref$type, unsafeRest = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $37328c3a94101dc2$var$_excluded);
    // @ts-expect-error
    var _className = unsafeRest.className, _css = unsafeRest.css, _as = unsafeRest.as, _style = unsafeRest.style, saferRest = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(unsafeRest, $37328c3a94101dc2$var$_excluded2);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $aa6f0a9cd00d5488$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        analyticsContext: analyticsContext,
        ref: ref,
        appearance: appearance,
        autoFocus: autoFocus,
        isDisabled: isDisabled,
        isLoading: isLoading,
        isSelected: isSelected,
        hasIconBefore: Boolean(iconBefore),
        hasIconAfter: Boolean(iconAfter),
        shouldFitContainer: shouldFitContainer,
        spacing: spacing,
        ariaLabel: ariaLabel,
        ariaLabelledBy: ariaLabelledBy,
        onClick: onClick,
        onClickCapture: onClickCapture,
        onKeyDownCapture: onKeyDownCapture,
        onKeyUpCapture: onKeyUpCapture,
        onMouseDownCapture: onMouseDownCapture,
        onMouseUpCapture: onMouseUpCapture,
        onPointerDownCapture: onPointerDownCapture,
        onPointerUpCapture: onPointerUpCapture,
        onTouchStartCapture: onTouchStartCapture,
        onTouchEndCapture: onTouchEndCapture,
        testId: testId,
        componentName: "Button",
        type: type,
        interactionName: interactionName
    }, saferRest), iconBefore && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $3279464c7324ff68$export$2e2bcd8739ae039), {
        type: "icon",
        position: "before",
        isLoading: isLoading
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $ed85b23eca664e45$export$2e2bcd8739ae039), {
        icon: iconBefore
    })), children && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $3279464c7324ff68$export$2e2bcd8739ae039), {
        isLoading: isLoading
    }, children), iconAfter && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $3279464c7324ff68$export$2e2bcd8739ae039), {
        type: "icon",
        position: "after",
        isLoading: isLoading
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $ed85b23eca664e45$export$2e2bcd8739ae039), {
        icon: iconAfter
    })));
}));
$37328c3a94101dc2$var$Button.displayName = 'Button';
var $37328c3a94101dc2$export$2e2bcd8739ae039 = $37328c3a94101dc2$var$Button;


var $kqp0i = parcelRequire("kqp0i");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");

var $iO8GM = parcelRequire("iO8GM");

var $kqp0i = parcelRequire("kqp0i");

var $iYJcE = parcelRequire("iYJcE");

var $25nEq = parcelRequire("25nEq");

var $5FkrB = parcelRequire("5FkrB");

var $7QpUe = parcelRequire("7QpUe");

var $25nEq = parcelRequire("25nEq");

var $5FkrB = parcelRequire("5FkrB");


function $33c593f40a34145a$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $33c593f40a34145a$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $33c593f40a34145a$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $33c593f40a34145a$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $33c593f40a34145a$export$1a04351537078b55(_ref) {
    var fn = _ref.fn, action = _ref.action, componentName = _ref.componentName, packageName = _ref.packageName, packageVersion = _ref.packageVersion, analyticsData = _ref.analyticsData;
    var _useAnalyticsEvents = (0, $9f01e7311243f881$export$5bf35293e545f20c)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
    // We put analyticsData and fn in a ref so that we don't need to break
    // memoization.
    // Generally these could be defined by consumers inline
    // and so we do this to avoid breaking memoization of useCallback
    var dataRef = (0, $b135a37d7f049dd6$export$1d27a74659855e44)(analyticsData);
    var fnRef = (0, $b135a37d7f049dd6$export$1d27a74659855e44)(fn);
    var handler = (0, $5FkrB.useCallback)(function() {
        var analyticsEvent = createAnalyticsEvent({
            action: action,
            actionSubject: componentName,
            attributes: {
                componentName: componentName,
                packageName: packageName,
                packageVersion: packageVersion
            }
        });
        // To avoid wrapping this component in AnalyticsContext we manually
        // push the parent context's meta data into the context.
        // Note: this new 'context'
        var context = $33c593f40a34145a$var$_objectSpread({
            componentName: componentName,
            packageName: packageName,
            packageVersion: packageVersion
        }, dataRef.current);
        analyticsEvent.context.push(context);
        // fire an event on the atlaskit channel
        var clone = analyticsEvent.clone();
        if (clone) clone.fire('atlaskit');
        fnRef.current(analyticsEvent);
    }, [
        // These are strings and won't change
        action,
        componentName,
        packageName,
        packageVersion,
        // This function is memoized in the context
        createAnalyticsEvent,
        // these are a stable ref because of the useTrackedRef hook
        dataRef,
        fnRef
    ]);
    return handler;
}



var $eVb4V = parcelRequire("eVb4V");

var $hy47X = parcelRequire("hy47X");

var $3UUXy = parcelRequire("3UUXy");

var $iUCre = parcelRequire("iUCre");

var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");
/**
 * Internally we will be playing with an element that will always have a key defined.
 */ /**
 * Internal data passed to child motions.
 */ // We define empty context here so the object doesn't change.
var $fdeb14207cf3ee90$var$emptyContext = {
    // Motions will always appear if not inside a exiting persistence component.
    appear: true,
    isExiting: false
};
/**
 * __Exiting context__
 *
 * An exiting context.
 */ var $fdeb14207cf3ee90$var$ExitingContext = /*#__PURE__*/ (0, $5FkrB.createContext)($fdeb14207cf3ee90$var$emptyContext);
/**
 * This method will wrap any React element with a context provider. We're using context (instead of
 * cloneElement) so we can communicate between multiple elements without the need of prop drilling
 * (results in a better API for consumers).
 */ var $fdeb14207cf3ee90$var$wrapChildWithContextProvider = function wrapChildWithContextProvider(child) {
    var value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $fdeb14207cf3ee90$var$emptyContext;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement($fdeb14207cf3ee90$var$ExitingContext.Provider, {
        key: "".concat(child.key, "-provider"),
        value: value
    }, child);
};
/**
 * This function will convert all children types to an array while also filtering out non-valid React elements.
 */ var $fdeb14207cf3ee90$var$childrenToArray = function childrenToArray(children) {
    var childrenAsArray = [];
    // We convert children to an array using this helper method as it will add keys to children that do not
    // have them, such as when we have hardcoded children that are conditionally rendered.
    (0, $5FkrB.Children).toArray(children).forEach(function(child) {
        // We ignore any boolean children to make our code a little more simple later on,
        // and also filter out any falsies (empty strings, nulls, and undefined).
        if (typeof child !== 'boolean' && Boolean(child)) // Children WILL have a key after being forced into an array using the React.Children helper.
        childrenAsArray.push(child);
    });
    return childrenAsArray;
};
var $fdeb14207cf3ee90$var$spliceNewElementsIntoPrevious = function spliceNewElementsIntoPrevious(current, previous) {
    var splicedChildren = previous.concat([]);
    var previousMap = $fdeb14207cf3ee90$var$childrenToObj(previous);
    for(var i = 0; i < current.length; i++){
        var child = current[i];
        var childIsNew = !previousMap[child.key];
        if (childIsNew) // This will insert the new element after the previous element.
        splicedChildren.splice(i + 1, 0, child);
    }
    return splicedChildren;
};
var $fdeb14207cf3ee90$var$childrenToObj = function childrenToObj(children) {
    return children.reduce(function(acc, child) {
        acc[child.key] = child;
        return acc;
    }, {});
};
var $fdeb14207cf3ee90$var$getMissingKeys = function getMissingKeys(current, previous) {
    var currentMapKeys = new Set(current.map(function(child) {
        return child.key;
    }));
    var missing = new Set();
    for(var i = 0; i < previous.length; i++){
        var element = previous[i];
        var _key = element.key;
        if (!currentMapKeys.has(_key)) missing.add(_key);
    }
    return missing;
};
/**
 * How does this component work?
 *
 * It looks at changes in its children to see what is removed.
 *
 * If a child is removed it clones it and wraps it with context providing an `onFinish` callback.
 *
 * The cloned child will call the `onFinish` when it finishes its exit animation,
 * which lets `ExitingPersistence` know to stop rendering it.
 */ /**
 * __ExitingPersistence__
 *
 * Useful for enabling elements to persist and animate away when they are removed from the DOM.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/motion/docs/entering-motions)
 */ var $fdeb14207cf3ee90$var$ExitingPersistence = /*#__PURE__*/ (0, $5FkrB.memo)(function(_ref) {
    var _ref$appear = _ref.appear, appear = _ref$appear === void 0 ? false : _ref$appear, children = _ref.children, exitThenEnter = _ref.exitThenEnter;
    var _useState = (0, $5FkrB.useState)([
        null,
        children
    ]), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), stateChildren = _useState2[0], setChildren = _useState2[1];
    var _useState3 = (0, $5FkrB.useState)([]), _useState4 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState3, 2), exitingChildren = _useState4[0], setExitingChildren = _useState4[1];
    var _useState5 = (0, $5FkrB.useState)(function() {
        return {
            appear: appear,
            isExiting: false
        };
    }), _useState6 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState5, 2), defaultContext = _useState6[0], setDefaultContext = _useState6[1];
    (0, $5FkrB.useEffect)(function() {
        if (!defaultContext.appear) setDefaultContext({
            appear: true,
            isExiting: false
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    /**
   * NOTE: This is a workaround for the test case written in Jira where the stateChildren is a boolean value because
   * useState is mocked to return a boolean value.
   */ if (typeof stateChildren === 'boolean') return children;
    var _stateChildren = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(stateChildren, 2), previousChildren = _stateChildren[0], currentChildren = _stateChildren[1];
    var previous = $fdeb14207cf3ee90$var$childrenToArray(previousChildren);
    var current = $fdeb14207cf3ee90$var$childrenToArray(currentChildren);
    if (currentChildren !== children) setChildren([
        currentChildren,
        children
    ]);
    var missingKeys = $fdeb14207cf3ee90$var$getMissingKeys(current, previous);
    var isSomeChildRemoved = !!missingKeys.size;
    var visibleChildren = current;
    if (isSomeChildRemoved) visibleChildren = $fdeb14207cf3ee90$var$spliceNewElementsIntoPrevious(current, previous);
    if (exitThenEnter) {
        if (exitingChildren.length) visibleChildren = exitingChildren;
        else {
            var nextExitingChildren = visibleChildren.filter(function(child) {
                return missingKeys.has(child.key);
            });
            if (nextExitingChildren.length) setExitingChildren(nextExitingChildren);
        }
    }
    if (missingKeys.size) visibleChildren = visibleChildren.map(function(child) {
        var isExiting = missingKeys.has(child.key);
        return $fdeb14207cf3ee90$var$wrapChildWithContextProvider(child, {
            appear: true,
            isExiting: isExiting,
            onFinish: isExiting ? function() {
                missingKeys.delete(child.key);
                if (missingKeys.size === 0) {
                    setChildren([
                        null,
                        children
                    ]);
                    setExitingChildren([]);
                }
            } : undefined
        });
    });
    else visibleChildren = visibleChildren.map(function(child) {
        return $fdeb14207cf3ee90$var$wrapChildWithContextProvider(child, defaultContext);
    });
    return visibleChildren;
});
var $fdeb14207cf3ee90$export$3b6f38abbdcbd000 = function useExitingPersistence() {
    return (0, $5FkrB.useContext)($fdeb14207cf3ee90$var$ExitingContext);
};
$fdeb14207cf3ee90$var$ExitingPersistence.displayName = 'ExitingPersistence';
var $fdeb14207cf3ee90$export$2e2bcd8739ae039 = $fdeb14207cf3ee90$var$ExitingPersistence;


var $5FkrB = parcelRequire("5FkrB");
/* keyframes-motion.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");

var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");

var $7QpUe = parcelRequire("7QpUe");
var $e1919ba90cc2dfd2$var$isMatchMediaAvailable = function isMatchMediaAvailable() {
    return typeof window !== 'undefined' && 'matchMedia' in window;
};
var $e1919ba90cc2dfd2$export$b7baf7667a68d87c = function isReducedMotion() {
    if (!$e1919ba90cc2dfd2$var$isMatchMediaAvailable()) return false;
    var _window$matchMedia = window.matchMedia('(prefers-reduced-motion: reduce)'), matches = _window$matchMedia.matches;
    return matches;
};
var $e1919ba90cc2dfd2$export$c537e63161742ce3 = function useIsReducedMotion() {
    var _useState = (0, $5FkrB.useState)($e1919ba90cc2dfd2$export$b7baf7667a68d87c), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), prefersReducedMotion = _useState2[0], setPrefersReducedMotion = _useState2[1];
    (0, $5FkrB.useEffect)(function() {
        if (!$e1919ba90cc2dfd2$var$isMatchMediaAvailable()) return;
        var mediaQueryList = window.matchMedia('(prefers-reduced-motion: reduce)');
        var onChange = function onChange(event) {
            return setPrefersReducedMotion(event.matches);
        };
        return (0, $7QpUe.bind)(mediaQueryList, {
            type: 'change',
            listener: onChange
        });
    }, []);
    return prefersReducedMotion;
};
var $e1919ba90cc2dfd2$export$f0f789643ba5a83c = {
    '@media (prefers-reduced-motion: reduce)': {
        animation: 'none',
        transition: 'none'
    }
};
var $e1919ba90cc2dfd2$export$ff7706047246b98b = function prefersReducedMotion() {
    return $e1919ba90cc2dfd2$export$f0f789643ba5a83c;
};


/**
 * Think of this as the motion equivalent of the @atlaskit/theme `grid()`.
 */ var $0a573c2b92d11bac$export$368bacef0dacbe05 = 25;
var $0a573c2b92d11bac$export$38b928a7167ce124 = {
    none: 0,
    small: 100,
    medium: 350,
    large: 700
};
/**
 * Used to multiply the initial duration for exiting motions.
 */ var $0a573c2b92d11bac$var$EXITING_MOTION_MULTIPLIER = 0.5;
var $0a573c2b92d11bac$export$30fa1a2e62ae150c = {
    none: $0a573c2b92d11bac$export$38b928a7167ce124.none,
    small: $0a573c2b92d11bac$export$38b928a7167ce124.small * $0a573c2b92d11bac$var$EXITING_MOTION_MULTIPLIER,
    medium: $0a573c2b92d11bac$export$38b928a7167ce124.medium * $0a573c2b92d11bac$var$EXITING_MOTION_MULTIPLIER,
    large: $0a573c2b92d11bac$export$38b928a7167ce124.large * $0a573c2b92d11bac$var$EXITING_MOTION_MULTIPLIER
};



var $5FkrB = parcelRequire("5FkrB");
// Handle both browser and Node.js environments
var $c9f29a2067431b87$var$getHookDeps = function getHookDeps(opts) {
    switch(opts.cleanup){
        case 'next-effect':
            return undefined;
        case 'unmount':
        default:
            return [];
    }
};
var $c9f29a2067431b87$export$1775f27e7c8051ca = function useRequestAnimationFrame() {
    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        cleanup: 'unmount'
    };
    var frames = (0, $5FkrB.useRef)([]);
    (0, $5FkrB.useEffect)(function() {
        return function() {
            if (frames.current.length) {
                frames.current.forEach(function(id) {
                    return cancelAnimationFrame(id);
                });
                frames.current = [];
            }
        };
    // We dynamically set this so we either clean up on the next effect - or on unmount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, $c9f29a2067431b87$var$getHookDeps(opts));
    return (0, $5FkrB.useCallback)(function(handler) {
        var id = requestAnimationFrame(function(time) {
            frames.current = frames.current.filter(function(frameId) {
                return frameId !== id;
            });
            handler(time);
        });
        frames.current.push(id);
    }, []);
};
var $c9f29a2067431b87$export$4f34107a2b00f39c = function useSetTimeout() {
    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        cleanup: 'unmount'
    };
    var timeouts = (0, $5FkrB.useRef)([]);
    (0, $5FkrB.useEffect)(function() {
        return function() {
            if (timeouts.current.length) {
                timeouts.current.forEach(function(id) {
                    return clearTimeout(id);
                });
                timeouts.current = [];
            }
        };
    // We dynamically set this so we either clean up on the next effect - or on unmount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, $c9f29a2067431b87$var$getHookDeps(opts));
    return (0, $5FkrB.useCallback)(function(handler, timeout) {
        for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)args[_key - 2] = arguments[_key];
        var id = setTimeout.apply(void 0, [
            function() {
                timeouts.current = timeouts.current.filter(function(timeoutId) {
                    return timeoutId !== id;
                });
                handler();
            },
            timeout
        ].concat(args));
        timeouts.current.push(id);
    }, []);
};




var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");

var $eVb4V = parcelRequire("eVb4V");

var $5FkrB = parcelRequire("5FkrB");
var $2e88ff792325fae3$export$e5c5a5f917a5871c = typeof window === 'undefined' ? (0, $5FkrB.useEffect) : (0, $5FkrB.useLayoutEffect);


/* eslint-disable @repo/internal/react/disallow-unstable-values */ 
var $5FkrB = parcelRequire("5FkrB");
function $8581d62cf4d85eab$export$c485849f2e393253() {
    var identifier = (0, $5FkrB.useRef)('');
    if (!identifier.current) identifier.current = '_' + (Number(String(Math.random()).slice(2)) + Date.now() + Math.round(performance.now())).toString(36);
    return identifier.current;
}


var $5f5c85fb908e681a$var$StaggeredEntranceContext = /*#__PURE__*/ (0, $5FkrB.createContext)(function() {
    return {
        isReady: true,
        delay: 0,
        ref: (0, $eVb4V.default)
    };
});
var $5f5c85fb908e681a$export$25c7213fc07ec080 = function useStaggeredEntrance() {
    var indentifier = (0, $8581d62cf4d85eab$export$c485849f2e393253)();
    var context = (0, $5FkrB.useContext)($5f5c85fb908e681a$var$StaggeredEntranceContext);
    return context(indentifier);
};
/**
 * For a list of elements that need to animate in,
 * this should be used in conjunction with entering components.
 * This does not need Javascript to execute so it will run immediately for any SSR rendered React apps before the JS has executed.
 *
 * Will dynamically add delay to each child entering component.
 * Unfortunately all entering components _NEED_ to be a direct descendant.
 */ var $5f5c85fb908e681a$var$StaggeredEntrance = function StaggeredEntrance(_ref) {
    var children = _ref.children, column = _ref.column, _ref$columns = _ref.columns, columns = _ref$columns === void 0 ? 'responsive' : _ref$columns, _ref$delayStep = _ref.delayStep, delayStep = _ref$delayStep === void 0 ? 50 : _ref$delayStep;
    var elementRefs = (0, $5FkrB.useRef)([]);
    var indexes = [];
    var _useState = (0, $5FkrB.useState)(function() {
        if (typeof columns === 'number') // A hardcoded columns is set so bail out and set it to that!
        return columns;
        if (typeof column === 'number') // A hardcoded column is set so we will set actualColumns to be 1.
        return 1;
        // We are in "responsive" mode.
        // So we will be calculating when the Javascript executes on the client how many columns there will be.
        return 0;
    }), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), actualColumns = _useState2[0], setActualColumns = _useState2[1];
    (0, $2e88ff792325fae3$export$e5c5a5f917a5871c)(function() {
        // We want to only run this code when we are in "responsive" mode.
        // It is assumed we are in responsive mode if `columns` is "responsive",
        // we have children element refs ready to be read (i.e. if there are no children this won't run as well)
        // and finally that `actualColumns` is `0` - this is because for the first render cycle `actualColumns` will be `0` (set above)
        // and then after this layout effect runs the value for `actualColumns` will then be calculated and set.
        if (columns === 'responsive' && elementRefs.current.length && actualColumns === 0) {
            var currentTop = 0;
            var numberColumns = 0;
            if (elementRefs.current.length <= 1) {
                setActualColumns(1);
                return;
            }
            // We set the current top to the first elements.
            // We will be comparing this and incrementing the column count
            // until we hit an element that has a different offset top (or we run out of elements).
            currentTop = elementRefs.current[0] ? elementRefs.current[0].offsetTop : 0;
            for(var i = 0; i < elementRefs.current.length; i++){
                var child = elementRefs.current[i];
                if (!child) break;
                if (currentTop === child.offsetTop) {
                    numberColumns += 1;
                    if (elementRefs.current.length - 1 === i) setActualColumns(numberColumns);
                    continue;
                }
                setActualColumns(numberColumns);
                break;
            }
        }
    // We only want this effect to run once - on initial mount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement($5f5c85fb908e681a$var$StaggeredEntranceContext.Provider, {
        value: function value(id) {
            if (!indexes.includes(id)) indexes.push(id);
            var isReady = actualColumns > 0;
            var index = indexes.indexOf(id);
            var currentColumn = column || index % actualColumns;
            var currentRow = Math.floor(index / actualColumns);
            var distanceFromTopLeftElement = currentRow + currentColumn;
            // We don't want loads of elements to have the same staggered delay as it ends up looking slow for users.
            // To get around that we calculate the logarithm using `distanceFromTopLeftElement` which ends making
            // elements appear faster the further away from the top left element.
            var delay = Math.ceil(Math.log(distanceFromTopLeftElement + 1) * delayStep * 1.5) || 0;
            return {
                delay: delay,
                isReady: isReady,
                ref: function ref(element) {
                    return elementRefs.current[index] = element;
                }
            };
        }
    }, children);
};
var $5f5c85fb908e681a$export$2e2bcd8739ae039 = $5f5c85fb908e681a$var$StaggeredEntrance;


var $d88e51fe7991e007$var$zoomIn = null;
var $d88e51fe7991e007$var$zoomOut = null;
var $d88e51fe7991e007$var$fadeIn = null;
var $d88e51fe7991e007$var$fadeOut = null;
var $d88e51fe7991e007$var$fadeInFromTop = null;
var $d88e51fe7991e007$var$fadeOutFromTop = null;
var $d88e51fe7991e007$var$fadeInFromLeft = null;
var $d88e51fe7991e007$var$fadeOutFromLeft = null;
var $d88e51fe7991e007$var$fadeInFromBottom = null;
var $d88e51fe7991e007$var$fadeOutFromBottom = null;
var $d88e51fe7991e007$var$fadeInFromRight = null;
var $d88e51fe7991e007$var$fadeOutFromRight = null;
var $d88e51fe7991e007$var$fadeInFromTopConstant = null;
var $d88e51fe7991e007$var$fadeOutFromTopConstant = null;
var $d88e51fe7991e007$var$fadeInFromLeftConstant = null;
var $d88e51fe7991e007$var$fadeOutFromLeftConstant = null;
var $d88e51fe7991e007$var$fadeInFromBottomConstant = null;
var $d88e51fe7991e007$var$fadeOutFromBottomConstant = null;
var $d88e51fe7991e007$var$fadeInFromRightConstant = null;
var $d88e51fe7991e007$var$fadeOutFromRightConstant = null;
var $d88e51fe7991e007$var$slideInFromTop = null;
var $d88e51fe7991e007$var$slideOutFromTop = null;
var $d88e51fe7991e007$var$slideInFromRight = null;
var $d88e51fe7991e007$var$slideOutFromRight = null;
var $d88e51fe7991e007$var$slideInFromBottom = null;
var $d88e51fe7991e007$var$slideOutFromBottom = null;
var $d88e51fe7991e007$var$slideInFromLeft = null;
var $d88e51fe7991e007$var$slideOutFromLeft = null;
/**
 * These are props that motions should use as their external props for consumers.
 * See [FadeIn](packages/helpers/motion/src/entering/fade-in.tsx) for an example usage.
 */ /**
 * This is the base INTERNAL component used for all other entering motions.
 * This does not need Javascript to execute on the client so it will run immediately
 * for any SSR rendered React apps before the JS has executed.
 */ var $d88e51fe7991e007$var$EnteringMotion = function EnteringMotion(_ref) {
    var children = _ref.children, animationTimingFunction = _ref.animationTimingFunction, _ref$animationTimingF = _ref.animationTimingFunctionExiting, animationTimingFunctionExiting = _ref$animationTimingF === void 0 ? animationTimingFunction : _ref$animationTimingF, enteringAnimation = _ref.enteringAnimation, _ref$exitingAnimation = _ref.exitingAnimation, exitingAnimation = _ref$exitingAnimation === void 0 ? enteringAnimation : _ref$exitingAnimation, isPaused = _ref.isPaused, onFinishMotion = _ref.onFinish, _ref$duration = _ref.duration, duration = _ref$duration === void 0 ? 'large' : _ref$duration;
    var staggered = (0, $5f5c85fb908e681a$export$25c7213fc07ec080)();
    var _useExitingPersistenc = (0, $fdeb14207cf3ee90$export$3b6f38abbdcbd000)(), isExiting = _useExitingPersistenc.isExiting, onExitFinished = _useExitingPersistenc.onFinish, appear = _useExitingPersistenc.appear;
    var setTimeout = (0, $c9f29a2067431b87$export$4f34107a2b00f39c)();
    var paused = isPaused || !staggered.isReady;
    var delay = isExiting ? 0 : staggered.delay;
    var state = isExiting ? 'exiting' : 'entering';
    var _useState = (0, $5FkrB.useState)(appear), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), hasAnimationStyles = _useState2[0], setHasAnimationStyles = _useState2[1];
    (0, $5FkrB.useEffect)(function() {
        // Tracking this to prevent changing state on an unmounted component
        var isCancelled = false;
        if (paused) return;
        // On initial mount if elements aren't set to animate on appear, we return early and callback
        if (!appear) {
            onFinishMotion && onFinishMotion(state);
            return;
        }
        /**
     * Updates relevant state.
     * Called when the animation is finished, or immediately with reduced motion.
     */ var onAnimationEnd = function onAnimationEnd() {
            if (state === 'exiting') // Updates the `ExitingPersistence` to remove this child
            onExitFinished === null || onExitFinished === void 0 || onExitFinished();
            if (!isCancelled) setHasAnimationStyles(false);
            onFinishMotion === null || onFinishMotion === void 0 || onFinishMotion(state);
        };
        if ((0, $e1919ba90cc2dfd2$export$b7baf7667a68d87c)()) {
            // If there is reduced motion there is no exit animation, so call this immediately
            onAnimationEnd();
            return;
        }
        // Elements may need animation styles back after initial mount (they could animate out)
        setHasAnimationStyles(true);
        // Queue `onAnimationEnd` for after the animation has finished
        setTimeout(onAnimationEnd, isExiting ? (0, $0a573c2b92d11bac$export$30fa1a2e62ae150c)[duration] : (0, $0a573c2b92d11bac$export$38b928a7167ce124)[duration] + delay);
        return function() {
            isCancelled = true;
        };
    // We ignore this for onFinishMotion as consumers could potentially inline the function
    // which would then trigger this effect every re-render.
    // We want to make it easier for consumers so we go down this path unfortunately.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        onExitFinished,
        state,
        isExiting,
        duration,
        delay,
        paused,
        setTimeout
    ]);
    return children({
        ref: staggered.ref,
        // @ts-expect-error: `ax` is not typed correctly
        className: hasAnimationStyles ? (0, $970q7.default)([
            (0, $970q7.default)([
                "_1o51eoah _1y0co91m _1bumglyw _sedtglyw"
            ]),
            paused && (0, $970q7.default)([
                "_1y0ctrqk"
            ]),
            duration === 'small' && (0, $970q7.default)([
                "_5sag1yx9"
            ]),
            duration === 'medium' && (0, $970q7.default)([
                "_5sag1ttt"
            ]),
            duration === 'large' && (0, $970q7.default)([
                "_5sagpwmj"
            ]),
            isExiting && duration === 'small' && (0, $970q7.default)([
                "_5sag14ed"
            ]),
            isExiting && duration === 'medium' && (0, $970q7.default)([
                "_5sagluct"
            ]),
            isExiting && duration === 'large' && (0, $970q7.default)([
                "_5sag1ttt"
            ]),
            isExiting && (0, $970q7.default)([
                "_ju255cps _1o51q7pw"
            ]),
            !isExiting && animationTimingFunction === 'linear' && (0, $970q7.default)([
                "_1pglp3kn"
            ]),
            !isExiting && animationTimingFunction === 'ease-out' && (0, $970q7.default)([
                "_1pgldkwg"
            ]),
            !isExiting && animationTimingFunction === 'ease-in' && (0, $970q7.default)([
                "_1pgl1nzg"
            ]),
            !isExiting && animationTimingFunction === 'ease-in-40-out' && (0, $970q7.default)([
                "_1pgl5y64"
            ]),
            !isExiting && animationTimingFunction === 'ease-in-60-out' && (0, $970q7.default)([
                "_1pgl1ddy"
            ]),
            !isExiting && animationTimingFunction === 'ease-in-80-out' && (0, $970q7.default)([
                "_1pglannl"
            ]),
            !isExiting && animationTimingFunction === 'ease-in-out' && (0, $970q7.default)([
                "_1pgl1fu8"
            ]),
            isExiting && animationTimingFunction === 'linear' && (0, $970q7.default)([
                "_1pglp3kn"
            ]),
            isExiting && animationTimingFunctionExiting === 'ease-out' && (0, $970q7.default)([
                "_1pgldkwg"
            ]),
            isExiting && animationTimingFunctionExiting === 'ease-in' && (0, $970q7.default)([
                "_1pgl1nzg"
            ]),
            isExiting && animationTimingFunctionExiting === 'ease-in-40-out' && (0, $970q7.default)([
                "_1pgl5y64"
            ]),
            isExiting && animationTimingFunctionExiting === 'ease-in-60-out' && (0, $970q7.default)([
                "_1pgl1ddy"
            ]),
            isExiting && animationTimingFunctionExiting === 'ease-in-80-out' && (0, $970q7.default)([
                "_1pglannl"
            ]),
            isExiting && animationTimingFunctionExiting === 'ease-in-out' && (0, $970q7.default)([
                "_1pgl1fu8"
            ]),
            (!isExiting && enteringAnimation === 'fade-in' || isExiting && exitingAnimation === 'fade-in') && (0, $970q7.default)([
                "_j7hq1cgr"
            ]),
            (!isExiting && enteringAnimation === 'fade-out' || isExiting && exitingAnimation === 'fade-out') && (0, $970q7.default)([
                "_j7hq1lln"
            ]),
            (!isExiting && enteringAnimation === 'zoom-in' || isExiting && exitingAnimation === 'zoom-in') && (0, $970q7.default)([
                "_j7hqe8p0"
            ]),
            (!isExiting && enteringAnimation === 'zoom-out' || isExiting && exitingAnimation === 'zoom-out') && (0, $970q7.default)([
                "_j7hqy6ql"
            ]),
            (!isExiting && enteringAnimation === 'slide-in-from-top' || isExiting && exitingAnimation === 'slide-in-from-top') && (0, $970q7.default)([
                "_j7hqqshu"
            ]),
            (!isExiting && enteringAnimation === 'slide-out-from-top' || isExiting && exitingAnimation === 'slide-out-from-top') && (0, $970q7.default)([
                "_j7hq7ri4"
            ]),
            (!isExiting && enteringAnimation === 'slide-in-from-right' || isExiting && exitingAnimation === 'slide-in-from-right') && (0, $970q7.default)([
                "_j7hqdfjr"
            ]),
            (!isExiting && enteringAnimation === 'slide-out-from-right' || isExiting && exitingAnimation === 'slide-out-from-right') && (0, $970q7.default)([
                "_j7hqonfj"
            ]),
            (!isExiting && enteringAnimation === 'slide-in-from-bottom' || isExiting && exitingAnimation === 'slide-in-from-bottom') && (0, $970q7.default)([
                "_j7hq1liq"
            ]),
            (!isExiting && enteringAnimation === 'slide-out-from-bottom' || isExiting && exitingAnimation === 'slide-out-from-bottom') && (0, $970q7.default)([
                "_j7hqhnf1"
            ]),
            (!isExiting && enteringAnimation === 'slide-in-from-left' || isExiting && exitingAnimation === 'slide-in-from-left') && (0, $970q7.default)([
                "_j7hq1bh1"
            ]),
            (!isExiting && enteringAnimation === 'slide-out-from-left' || isExiting && exitingAnimation === 'slide-out-from-left') && (0, $970q7.default)([
                "_j7hqj08w"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-top' || isExiting && exitingAnimation === 'fade-in-from-top') && (0, $970q7.default)([
                "_j7hq2iua"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-top' || isExiting && exitingAnimation === 'fade-out-from-top') && (0, $970q7.default)([
                "_j7hq39va"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-left' || isExiting && exitingAnimation === 'fade-in-from-left') && (0, $970q7.default)([
                "_j7hq15m2"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-left' || isExiting && exitingAnimation === 'fade-out-from-left') && (0, $970q7.default)([
                "_j7hq1yiv"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-bottom' || isExiting && exitingAnimation === 'fade-in-from-bottom') && (0, $970q7.default)([
                "_j7hq1w00"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-bottom' || isExiting && exitingAnimation === 'fade-out-from-bottom') && (0, $970q7.default)([
                "_j7hqzy3z"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-right' || isExiting && exitingAnimation === 'fade-in-from-right') && (0, $970q7.default)([
                "_j7hqpqak"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-right' || isExiting && exitingAnimation === 'fade-out-from-right') && (0, $970q7.default)([
                "_j7hq1ebg"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-top-constant' || isExiting && exitingAnimation === 'fade-in-from-top-constant') && (0, $970q7.default)([
                "_j7hqm2e2"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-top-constant' || isExiting && exitingAnimation === 'fade-out-from-top-constant') && (0, $970q7.default)([
                "_j7hq97jn"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-left-constant' || isExiting && exitingAnimation === 'fade-in-from-left-constant') && (0, $970q7.default)([
                "_j7hqovgq"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-left-constant' || isExiting && exitingAnimation === 'fade-out-from-left-constant') && (0, $970q7.default)([
                "_j7hq15do"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-bottom-constant' || isExiting && exitingAnimation === 'fade-in-from-bottom-constant') && (0, $970q7.default)([
                "_j7hq797a"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-bottom-constant' || isExiting && exitingAnimation === 'fade-out-from-bottom-constant') && (0, $970q7.default)([
                "_j7hqwo7r"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-right-constant' || isExiting && exitingAnimation === 'fade-in-from-right-constant') && (0, $970q7.default)([
                "_j7hqt8u5"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-right-constant' || isExiting && exitingAnimation === 'fade-out-from-right-constant') && (0, $970q7.default)([
                "_j7hq1pgp"
            ])
        ]) : '',
        style: {
            animationDelay: "".concat(delay, "ms")
        }
    }, state);
};
var $d88e51fe7991e007$export$2e2bcd8739ae039 = $d88e51fe7991e007$var$EnteringMotion;


var $cd25880f7bbea0a3$var$invertedDirection = {
    top: 'bottom',
    bottom: 'top',
    left: 'right',
    right: 'left'
};
/**
 * Props for controlling the behavior of the FadeIn animation
 */ /**
 * __FadeIn__
 *
 * Useful for fading in one or more elements.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/motion/docs/entering-motions)
 */ var $cd25880f7bbea0a3$var$FadeIn = function FadeIn(_ref) {
    var children = _ref.children, _ref$duration = _ref.duration, duration = _ref$duration === void 0 ? 'large' : _ref$duration, entranceDirection = _ref.entranceDirection, exitDirection = _ref.exitDirection, _ref$distance = _ref.distance, distance = _ref$distance === void 0 ? 'proportional' : _ref$distance, onFinish = _ref.onFinish, isPaused = _ref.isPaused;
    var invertedEntranceDirection = entranceDirection !== undefined ? $cd25880f7bbea0a3$var$invertedDirection[entranceDirection] : undefined;
    var isExitDirect = Boolean(exitDirection || invertedEntranceDirection) ? "fade-out-from-".concat(exitDirection || invertedEntranceDirection).concat(distance === 'proportional' ? '' : '-constant') : 'fade-out';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $d88e51fe7991e007$export$2e2bcd8739ae039), {
        duration: duration,
        enteringAnimation: entranceDirection ? "fade-in-from-".concat(entranceDirection).concat(distance === 'proportional' ? '' : '-constant') : 'fade-in',
        exitingAnimation: isExitDirect,
        animationTimingFunction: "ease-in-out",
        onFinish: onFinish,
        isPaused: isPaused
    }, children);
};
var $cd25880f7bbea0a3$export$2e2bcd8739ae039 = $cd25880f7bbea0a3$var$FadeIn;



var $id6Cu = parcelRequire("id6Cu");

var $5K5L9 = parcelRequire("5K5L9");

var $5FkrB = parcelRequire("5FkrB");

var $id6Cu = parcelRequire("id6Cu");

var $5FkrB = parcelRequire("5FkrB");

var $aLeHs = parcelRequire("aLeHs");
/* index.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $kqp0i = parcelRequire("kqp0i");

var $fL8KA = parcelRequire("fL8KA");

var $25nEq = parcelRequire("25nEq");

var $iYJcE = parcelRequire("iYJcE");

var $970q7 = parcelRequire("970q7");

var $6HG4S = parcelRequire("6HG4S");

var $5FkrB = parcelRequire("5FkrB");

var $7QpUe = parcelRequire("7QpUe");

var $id6Cu = parcelRequire("id6Cu");

var $25nEq = parcelRequire("25nEq");

var $id6Cu = parcelRequire("id6Cu");

var $4Q00M = parcelRequire("4Q00M");

var $jOCEz = parcelRequire("jOCEz");

var $ekGgq = parcelRequire("ekGgq");

var $iYJcE = parcelRequire("iYJcE");

var $jOCEz = parcelRequire("jOCEz");
var $e3cd269bafd4ae2b$var$themeKinds = [
    'light',
    'dark',
    'spacing',
    'typography',
    'shape'
];
var $e3cd269bafd4ae2b$var$customThemeOptions = 'UNSAFE_themeOptions';
var $e3cd269bafd4ae2b$var$isThemeKind = function isThemeKind(themeKind) {
    return $e3cd269bafd4ae2b$var$themeKinds.find(function(kind) {
        return kind === themeKind;
    }) !== undefined;
};
var $e3cd269bafd4ae2b$var$isThemeIds = function isThemeIds(themeId) {
    return (0, $jOCEz.themeIds).find(function(id) {
        return id === themeId;
    }) !== undefined;
};
var $e3cd269bafd4ae2b$var$isColorMode = function isColorMode(modeId) {
    return [
        'light',
        'dark',
        'auto'
    ].includes(modeId);
};
var $e3cd269bafd4ae2b$export$f19b488f7c0547ee = function themeStringToObject(themeState) {
    return themeState.split(' ')// @ts-ignore - TS1501 TypeScript 5.9.2 upgrade
    .map(function(theme) {
        return theme.split(/:([^]*)/);
    }).reduce(function(themeObject, _ref) {
        var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_ref, 2), kind = _ref2[0], id = _ref2[1];
        if (kind === 'colorMode' && $e3cd269bafd4ae2b$var$isColorMode(id)) themeObject[kind] = id;
        if ($e3cd269bafd4ae2b$var$isThemeKind(kind) && $e3cd269bafd4ae2b$var$isThemeIds(id)) // @ts-expect-error FIXME - this is a valid ts error
        themeObject[kind] = id;
        if (kind === $e3cd269bafd4ae2b$var$customThemeOptions) try {
            themeObject[$e3cd269bafd4ae2b$var$customThemeOptions] = JSON.parse(id);
        } catch (_unused) {
            new Error('Invalid custom theme string');
        }
        return themeObject;
    }, {});
};
var $e3cd269bafd4ae2b$export$62c37ab81302621a = function themeObjectToString(themeState) {
    return Object.entries(themeState).reduce(function(themeString, _ref3) {
        var _ref4 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_ref3, 2), kind = _ref4[0], id = _ref4[1];
        if (// colorMode theme state
        kind === 'colorMode' && typeof id === 'string' && $e3cd269bafd4ae2b$var$isColorMode(id) || // custom theme state
        kind === $e3cd269bafd4ae2b$var$customThemeOptions && (0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(id) === 'object' || // other theme states
        $e3cd269bafd4ae2b$var$isThemeKind(kind) && typeof id === 'string' && $e3cd269bafd4ae2b$var$isThemeIds(id)) return themeString + "".concat(themeString ? ' ' : '') + "".concat(kind, ":").concat((0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(id) === 'object' ? JSON.stringify(id) : id);
        return themeString;
    }, '');
};



var $j8wi6 = parcelRequire("j8wi6");

var $92luE = parcelRequire("92luE");
function $5e61660cd96d9b4a$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $5e61660cd96d9b4a$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $5e61660cd96d9b4a$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $5e61660cd96d9b4a$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $5e61660cd96d9b4a$var$defaultColorMode = 'light';
var $5e61660cd96d9b4a$var$defaultContrastMode = 'no-preference';
/**
 * Server-side rendering utility. Generates the valid HTML attributes for a given theme.
 * Note: this utility does not handle automatic theme switching.
 *
 * @param {Object<string, string>} themeOptions - Theme options object
 * @param {string} themeState.colorMode Determines which color theme is applied. If set to `auto`, the theme applied will be determined by the OS setting.
 * @param {string} themeState.dark The color theme to be applied when the color mode resolves to 'dark'.
 * @param {string} themeState.light The color theme to be applied when the color mode resolves to 'light'.
 * @param {string} themeState.spacing The spacing theme to be applied.
 * @param {string} themeState.typography The typography theme to be applied.
 * @param {Object} themeState.UNSAFE_themeOptions The custom branding options to be used for custom theme generation
 *
 * @returns {Object} Object of HTML attributes to be applied to the document root
 */ var $5e61660cd96d9b4a$var$getThemeHtmlAttrs = function getThemeHtmlAttrs() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, _ref$colorMode = _ref.colorMode, colorMode = _ref$colorMode === void 0 ? (0, $jOCEz.themeStateDefaults)['colorMode'] : _ref$colorMode, _ref$dark = _ref.dark, dark = _ref$dark === void 0 ? (0, $jOCEz.themeStateDefaults)['dark'] : _ref$dark, _ref$light = _ref.light, light = _ref$light === void 0 ? (0, $jOCEz.themeStateDefaults)['light'] : _ref$light, _ref$contrastMode = _ref.contrastMode, contrastMode = _ref$contrastMode === void 0 ? (0, $jOCEz.themeStateDefaults)['contrastMode'] : _ref$contrastMode, _ref$shape = _ref.shape, shape = _ref$shape === void 0 ? (0, $jOCEz.themeStateDefaults)['shape']() : _ref$shape, _ref$spacing = _ref.spacing, spacing = _ref$spacing === void 0 ? (0, $jOCEz.themeStateDefaults)['spacing'] : _ref$spacing, _ref$typography = _ref.typography, typography = _ref$typography === void 0 ? (0, $jOCEz.themeStateDefaults)['typography'] : _ref$typography, _ref$UNSAFE_themeOpti = _ref.UNSAFE_themeOptions, UNSAFE_themeOptions = _ref$UNSAFE_themeOpti === void 0 ? (0, $jOCEz.themeStateDefaults)['UNSAFE_themeOptions'] : _ref$UNSAFE_themeOpti;
    var themeAttribute = (0, $e3cd269bafd4ae2b$export$62c37ab81302621a)({
        dark: dark,
        light: light,
        shape: shape,
        spacing: spacing,
        typography: typography
    });
    var result = (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, (0, $4Q00M.THEME_DATA_ATTRIBUTE), themeAttribute), (0, $4Q00M.COLOR_MODE_ATTRIBUTE), colorMode === 'auto' ? $5e61660cd96d9b4a$var$defaultColorMode : colorMode);
    if ((0, $id6Cu.fg)('platform_increased-contrast-themes')) result = $5e61660cd96d9b4a$var$_objectSpread($5e61660cd96d9b4a$var$_objectSpread({}, result), {}, (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, (0, $4Q00M.CONTRAST_MODE_ATTRIBUTE), contrastMode === 'auto' ? $5e61660cd96d9b4a$var$defaultContrastMode : contrastMode));
    if (UNSAFE_themeOptions && (0, $j8wi6.isValidBrandHex)(UNSAFE_themeOptions.brandColor)) {
        var optionString = JSON.stringify(UNSAFE_themeOptions);
        var uniqueId = (0, $92luE.hash)(optionString);
        result[0, $4Q00M.CUSTOM_THEME_ATTRIBUTE] = uniqueId;
    }
    return result;
};
var $5e61660cd96d9b4a$export$2e2bcd8739ae039 = $5e61660cd96d9b4a$var$getThemeHtmlAttrs;


var $25nEq = parcelRequire("25nEq");

var $fL8KA = parcelRequire("fL8KA");

var $6HG4S = parcelRequire("6HG4S");

var $id6Cu = parcelRequire("id6Cu");

var $25nEq = parcelRequire("25nEq");

var $4Q00M = parcelRequire("4Q00M");

var $jOCEz = parcelRequire("jOCEz");

function $baa32d2608b04b9c$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $baa32d2608b04b9c$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $baa32d2608b04b9c$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $baa32d2608b04b9c$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $baa32d2608b04b9c$var$isThemeColorMode = function isThemeColorMode(colorMode) {
    return (0, $jOCEz.themeColorModes).find(function(mode) {
        return mode === colorMode;
    }) !== undefined;
};
var $baa32d2608b04b9c$var$getGlobalTheme = function getGlobalTheme() {
    if (typeof document === 'undefined') return {};
    var element = document.documentElement;
    var colorMode = element.getAttribute((0, $4Q00M.COLOR_MODE_ATTRIBUTE)) || '';
    var theme = element.getAttribute((0, $4Q00M.THEME_DATA_ATTRIBUTE)) || '';
    return $baa32d2608b04b9c$var$_objectSpread($baa32d2608b04b9c$var$_objectSpread({}, (0, $e3cd269bafd4ae2b$export$f19b488f7c0547ee)(theme)), $baa32d2608b04b9c$var$isThemeColorMode(colorMode) && {
        colorMode: colorMode
    });
};
var $baa32d2608b04b9c$export$2e2bcd8739ae039 = $baa32d2608b04b9c$var$getGlobalTheme;



var $jOCEz = parcelRequire("jOCEz");

var $j8wi6 = parcelRequire("j8wi6");

var $iYJcE = parcelRequire("iYJcE");

var $id6Cu = parcelRequire("id6Cu");


var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $25nEq = parcelRequire("25nEq");

var $7QpUe = parcelRequire("7QpUe");

var $4Q00M = parcelRequire("4Q00M");

var $fL8KA = parcelRequire("fL8KA");

var $6HG4S = parcelRequire("6HG4S");
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 *
 * This file contains a dynamic import for each theme this package exports.
 * Themes are loaded asynchronously at runtime to minimise the amount of CSS we send to the client.
 * This allows users to compose their themes and only use the tokens that are requested.
 * When a new theme is created, the import should automatically be added to the map
 *
 * @codegen <<SignedSource::926662cc712c2c412c8b6b4cdcd8d64f>>
 * @codegenCommand yarn build tokens
 */ 










var $32fcecf5eab03b46$var$themeImportsMap = {
    'light': function light() {
        return (parcelRequire("2fjgr"));
    },
    'light-future': function lightFuture() {
        return (parcelRequire("hegm5"));
    },
    'light-increased-contrast': function lightIncreasedContrast() {
        return (parcelRequire("cOZbX"));
    },
    'dark': function dark() {
        return (parcelRequire("4oKtr"));
    },
    'dark-future': function darkFuture() {
        return (parcelRequire("evQOy"));
    },
    'dark-increased-contrast': function darkIncreasedContrast() {
        return (parcelRequire("dic3Q"));
    },
    'legacy-light': function legacyLight() {
        return (parcelRequire("hmiLY"));
    },
    'legacy-dark': function legacyDark() {
        return (parcelRequire("3Vrjp"));
    },
    'spacing': function spacing() {
        return (parcelRequire("doBio"));
    },
    'typography': function typography() {
        return (parcelRequire("jvj2B"));
    },
    'shape': function shape() {
        return (parcelRequire("gNA7A"));
    }
};
var $32fcecf5eab03b46$export$2e2bcd8739ae039 = $32fcecf5eab03b46$var$themeImportsMap;



var $4Q00M = parcelRequire("4Q00M");
var $cde95922e46f0e46$export$26cd7ae85c7144e5 = /*#__PURE__*/ function() {
    var _ref = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee(themeId) {
        var themeCss, style;
        return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee$(_context) {
            while(true)switch(_context.prev = _context.next){
                case 0:
                    if (!document.head.querySelector("style[".concat((0, $4Q00M.THEME_DATA_ATTRIBUTE), "=\"").concat(themeId, "\"]:not([").concat((0, $4Q00M.CUSTOM_THEME_ATTRIBUTE), "])"))) {
                        _context.next = 2;
                        break;
                    }
                    return _context.abrupt("return");
                case 2:
                    if (themeId) {
                        _context.next = 4;
                        break;
                    }
                    return _context.abrupt("return");
                case 4:
                    _context.next = 6;
                    return $cde95922e46f0e46$export$8a48286ed7df6720(themeId);
                case 6:
                    themeCss = _context.sent;
                    style = document.createElement('style');
                    style.textContent = themeCss;
                    style.dataset.theme = themeId;
                    document.head.appendChild(style);
                case 11:
                case "end":
                    return _context.stop();
            }
        }, _callee);
    }));
    return function loadAndAppendThemeCss(_x) {
        return _ref.apply(this, arguments);
    };
}();
var $cde95922e46f0e46$export$8a48286ed7df6720 = /*#__PURE__*/ function() {
    var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee2(themeId) {
        var _yield$themeImportMap, themeCss;
        return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee2$(_context2) {
            while(true)switch(_context2.prev = _context2.next){
                case 0:
                    _context2.next = 2;
                    return (0, $32fcecf5eab03b46$export$2e2bcd8739ae039)[themeId]();
                case 2:
                    _yield$themeImportMap = _context2.sent;
                    themeCss = _yield$themeImportMap.default;
                    return _context2.abrupt("return", themeCss);
                case 5:
                case "end":
                    return _context2.stop();
            }
        }, _callee2);
    }));
    return function loadThemeCss(_x2) {
        return _ref2.apply(this, arguments);
    };
}();
var $cde95922e46f0e46$export$bb1e815119d30f8b = '(prefers-color-scheme: dark)';
var $cde95922e46f0e46$export$8662df6937d86fcb = '(prefers-contrast: more)';


var $251a5a9890fef70a$var$isMatchMediaAvailable = typeof window !== 'undefined' && 'matchMedia' in window;
/**
 * Updates the current theme when the system theme changes. Should be bound
 * to an event listener listening on the '(prefers-color-scheme: dark)' query
 * @param e The event representing a change in system theme.
 */ function $251a5a9890fef70a$var$checkNativeListener(e) {
    var element = document.documentElement;
    element.setAttribute((0, $4Q00M.COLOR_MODE_ATTRIBUTE), e.matches ? 'dark' : 'light');
}
var $251a5a9890fef70a$var$darkModeMql = $251a5a9890fef70a$var$isMatchMediaAvailable && window.matchMedia((0, $cde95922e46f0e46$export$bb1e815119d30f8b));
var $251a5a9890fef70a$var$ColorModeObserver = /*#__PURE__*/ function() {
    function ColorModeObserver() {
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, ColorModeObserver);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "unbindThemeChangeListener", null);
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(ColorModeObserver, [
        {
            key: "getColorMode",
            value: function getColorMode() {
                if (!$251a5a9890fef70a$var$darkModeMql) return 'light';
                return $251a5a9890fef70a$var$darkModeMql !== null && $251a5a9890fef70a$var$darkModeMql !== void 0 && $251a5a9890fef70a$var$darkModeMql.matches ? 'dark' : 'light';
            }
        },
        {
            key: "bind",
            value: function bind() {
                if ($251a5a9890fef70a$var$darkModeMql && this.unbindThemeChangeListener === null) this.unbindThemeChangeListener = (0, $7QpUe.bind)($251a5a9890fef70a$var$darkModeMql, {
                    type: 'change',
                    listener: $251a5a9890fef70a$var$checkNativeListener
                });
            }
        },
        {
            key: "unbind",
            value: function unbind() {
                if (this.unbindThemeChangeListener) {
                    this.unbindThemeChangeListener();
                    this.unbindThemeChangeListener = null;
                }
            }
        }
    ]);
}();
/**
 * A singleton color mode observer - binds "auto" switching logic to a single `mediaQueryList` listener
 * that can be unbound by any consumer when no longer needed.
 */ var $251a5a9890fef70a$var$SingletonColorModeObserver = new $251a5a9890fef70a$var$ColorModeObserver();
var $251a5a9890fef70a$export$2e2bcd8739ae039 = $251a5a9890fef70a$var$SingletonColorModeObserver;



var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $25nEq = parcelRequire("25nEq");

var $7QpUe = parcelRequire("7QpUe");

var $4Q00M = parcelRequire("4Q00M");

var $52551b00e3d46e40$var$isMatchMediaAvailable = typeof window !== 'undefined' && 'matchMedia' in window;
/**
 * Updates the current theme when the system contrast preference changes. Should be bound
 * to an event listener listening on the '(prefers-contrast: more)' query
 * @param e The event representing a change in system theme.
 */ function $52551b00e3d46e40$var$checkNativeListener(e) {
    var element = document.documentElement;
    element.setAttribute((0, $4Q00M.CONTRAST_MODE_ATTRIBUTE), e.matches ? 'more' : 'no-preference');
}
var $52551b00e3d46e40$var$contrastModeMql = $52551b00e3d46e40$var$isMatchMediaAvailable && window.matchMedia((0, $cde95922e46f0e46$export$8662df6937d86fcb));
var $52551b00e3d46e40$var$ContrastModeObserver = /*#__PURE__*/ function() {
    function ContrastModeObserver() {
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, ContrastModeObserver);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "unbindContrastChangeListener", null);
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(ContrastModeObserver, [
        {
            key: "getContrastMode",
            value: function getContrastMode() {
                if (!$52551b00e3d46e40$var$contrastModeMql) return 'no-preference';
                return $52551b00e3d46e40$var$contrastModeMql !== null && $52551b00e3d46e40$var$contrastModeMql !== void 0 && $52551b00e3d46e40$var$contrastModeMql.matches ? 'more' : 'no-preference';
            }
        },
        {
            key: "bind",
            value: function bind() {
                if ($52551b00e3d46e40$var$contrastModeMql && this.unbindContrastChangeListener === null) this.unbindContrastChangeListener = (0, $7QpUe.bind)($52551b00e3d46e40$var$contrastModeMql, {
                    type: 'change',
                    listener: $52551b00e3d46e40$var$checkNativeListener
                });
            }
        },
        {
            key: "unbind",
            value: function unbind() {
                if (this.unbindContrastChangeListener) {
                    this.unbindContrastChangeListener();
                    this.unbindContrastChangeListener = null;
                }
            }
        }
    ]);
}();
/**
 * A singleton contrast mode observer - binds "auto" switching logic to a single `mediaQueryList` listener
 * that can be unbound by any consumer when no longer needed.
 */ var $52551b00e3d46e40$var$SingletonContrastModeObserver = new $52551b00e3d46e40$var$ContrastModeObserver();
var $52551b00e3d46e40$export$2e2bcd8739ae039 = $52551b00e3d46e40$var$SingletonContrastModeObserver;


function $ae04c9bc1716bb3e$export$2e2bcd8739ae039(themeState) {
    if (themeState.colorMode === 'auto') {
        // Set colorMode based on the user preference
        themeState.colorMode = (0, $251a5a9890fef70a$export$2e2bcd8739ae039).getColorMode();
        // Bind a listener (if one doesn't already exist) to keep colorMode updated
        (0, $251a5a9890fef70a$export$2e2bcd8739ae039).bind();
    } else (0, $251a5a9890fef70a$export$2e2bcd8739ae039).unbind();
    if ((0, $id6Cu.fg)('platform_increased-contrast-themes')) {
        if (themeState.contrastMode === 'auto') {
            // Set contrastMode based on the user preference
            themeState.contrastMode = (0, $52551b00e3d46e40$export$2e2bcd8739ae039).getContrastMode();
            // Bind a listener (if one doesn't already exist) to keep contrastMode updated
            (0, $52551b00e3d46e40$export$2e2bcd8739ae039).bind();
        } else (0, $52551b00e3d46e40$export$2e2bcd8739ae039).unbind();
    }
    var themeAttributes = (0, $5e61660cd96d9b4a$export$2e2bcd8739ae039)(themeState);
    Object.entries(themeAttributes).forEach(function(_ref) {
        var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_ref, 2), key = _ref2[0], value = _ref2[1];
        document.documentElement.setAttribute(key, value);
    });
    return function() {
        (0, $251a5a9890fef70a$export$2e2bcd8739ae039).unbind();
        if ((0, $id6Cu.fg)('platform_increased-contrast-themes')) (0, $52551b00e3d46e40$export$2e2bcd8739ae039).unbind();
    };
}



var $89dnb = parcelRequire("89dnb");

var $fC8ib = parcelRequire("fC8ib");

var $id6Cu = parcelRequire("id6Cu");

var $iYJcE = parcelRequire("iYJcE");

var $jOCEz = parcelRequire("jOCEz");
function $0b90b5c82255365e$export$2e2bcd8739ae039(themeId) {
    var _Object$entries$find;
    return (_Object$entries$find = Object.entries((0, $jOCEz.default)).find(function(_ref) {
        var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_ref, 2), increasesContrastFor = _ref2[1].increasesContrastFor;
        return increasesContrastFor === themeId;
    })) === null || _Object$entries$find === void 0 ? void 0 : _Object$entries$find[1].id;
}


var $f959ed1c119df874$export$dd6aeb7c823fc03d = function getThemePreferences(themeState) {
    var colorMode = themeState.colorMode, contrastMode = themeState.contrastMode, dark = themeState.dark, light = themeState.light, shape = themeState.shape, spacing = themeState.spacing, typography = themeState.typography;
    var autoColorModeThemes = [
        light,
        dark
    ];
    var themePreferences = [];
    if (colorMode === 'auto') {
        if (contrastMode !== 'no-preference' && (0, $id6Cu.fg)('platform_increased-contrast-themes')) autoColorModeThemes.forEach(function(normalTheme) {
            var increasedContrastTheme = (0, $0b90b5c82255365e$export$2e2bcd8739ae039)(normalTheme);
            if (increasedContrastTheme) autoColorModeThemes.push(increasedContrastTheme);
        });
        themePreferences.push.apply(themePreferences, autoColorModeThemes);
    } else {
        themePreferences.push(themeState[colorMode]);
        if (contrastMode !== 'no-preference' && (0, $id6Cu.fg)('platform_increased-contrast-themes')) {
            var increasedContrastTheme = (0, $0b90b5c82255365e$export$2e2bcd8739ae039)(themeState[colorMode]);
            if (increasedContrastTheme) themePreferences.push(increasedContrastTheme);
        }
    }
    [
        shape,
        spacing,
        typography
    ].forEach(function(themeId) {
        if (themeId) themePreferences.push(themeId);
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(new Set(themePreferences));
};
var $f959ed1c119df874$export$5d76d7014f4a5d08 = function getThemeOverridePreferences(_themeState) {
    var themeOverridePreferences = [];
    return (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(new Set(themeOverridePreferences));
};



function $a2c33e137370f0d9$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $a2c33e137370f0d9$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $a2c33e137370f0d9$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $a2c33e137370f0d9$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $a2c33e137370f0d9$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $a2c33e137370f0d9$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $a2c33e137370f0d9$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $a2c33e137370f0d9$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $a2c33e137370f0d9$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $a2c33e137370f0d9$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}

/**
 * Sets the theme globally at runtime. This updates the `data-theme` and `data-color-mode` attributes on your page's <html> tag.
 *
 * @param {Object<string, string>} themeState The themes and color mode that should be applied.
 * @param {string} themeState.colorMode Determines which color theme is applied. If set to `auto`, the theme applied will be determined by the OS setting.
 * @param {string} themeState.contrastMode The contrast mode theme to be applied. If set to `auto`, the theme applied will be determined by the OS setting.set to `auto`, the theme applied will be determined by the OS setting.
 * @param {string} themeState.dark The color theme to be applied when the color mode resolves to 'dark'.
 * @param {string} themeState.light The color theme to be applied when the color mode resolves to 'light'.
 * @param {string} themeState.shape The shape theme to be applied.
 * @param {string} themeState.spacing The spacing theme to be applied.
 * @param {string} themeState.typography The typography theme to be applied.
 * @param {Object} themeState.UNSAFE_themeOptions The custom branding options to be used for custom theme generation
 * @param {function} themeLoader Callback function used to override the default theme loading functionality.
 *
 * @returns A Promise of an unbind function, that can be used to stop listening for changes to system theme.
 *
 * @example
 * ```
 * setGlobalTheme({colorMode: 'auto', light: 'light', dark: 'dark', spacing: 'spacing'});
 * ```
 */ var $a2c33e137370f0d9$var$setGlobalTheme = /*#__PURE__*/ function() {
    var _ref = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee3() {
        var nextThemeState, themeLoader, _ref2, _ref2$colorMode, colorMode, _ref2$contrastMode, contrastMode, _ref2$dark, dark, _ref2$light, light, _ref2$shape, shape, _ref2$spacing, spacing, _ref2$typography, typography, _ref2$UNSAFE_themeOpt, UNSAFE_themeOptions, themeState, themePreferences, loadingStrategy, loadingTasks, mode, attrOfMissingCustomStyles, themeOverridePreferences, _iterator, _step, themeId, autoUnbind, _args3 = arguments;
        return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee3$(_context3) {
            while(true)switch(_context3.prev = _context3.next){
                case 0:
                    nextThemeState = _args3.length > 0 && _args3[0] !== undefined ? _args3[0] : {};
                    themeLoader = _args3.length > 1 ? _args3[1] : undefined;
                    _ref2 = typeof nextThemeState === 'function' ? nextThemeState($a2c33e137370f0d9$var$_objectSpread($a2c33e137370f0d9$var$_objectSpread({}, (0, $jOCEz.themeStateDefaults)), {}, {
                        typography: (0, $jOCEz.themeStateDefaults)['typography'],
                        shape: (0, $jOCEz.themeStateDefaults)['shape']()
                    }, (0, $baa32d2608b04b9c$export$2e2bcd8739ae039)())) : nextThemeState, _ref2$colorMode = _ref2.colorMode, colorMode = _ref2$colorMode === void 0 ? (0, $jOCEz.themeStateDefaults)['colorMode'] : _ref2$colorMode, _ref2$contrastMode = _ref2.contrastMode, contrastMode = _ref2$contrastMode === void 0 ? (0, $jOCEz.themeStateDefaults)['contrastMode'] : _ref2$contrastMode, _ref2$dark = _ref2.dark, dark = _ref2$dark === void 0 ? (0, $jOCEz.themeStateDefaults)['dark'] : _ref2$dark, _ref2$light = _ref2.light, light = _ref2$light === void 0 ? (0, $jOCEz.themeStateDefaults)['light'] : _ref2$light, _ref2$shape = _ref2.shape, shape = _ref2$shape === void 0 ? (0, $jOCEz.themeStateDefaults)['shape']() : _ref2$shape, _ref2$spacing = _ref2.spacing, spacing = _ref2$spacing === void 0 ? (0, $jOCEz.themeStateDefaults)['spacing'] : _ref2$spacing, _ref2$typography = _ref2.typography, typography = _ref2$typography === void 0 ? (0, $jOCEz.themeStateDefaults)['typography'] : _ref2$typography, _ref2$UNSAFE_themeOpt = _ref2.UNSAFE_themeOptions, UNSAFE_themeOptions = _ref2$UNSAFE_themeOpt === void 0 ? (0, $jOCEz.themeStateDefaults)['UNSAFE_themeOptions'] : _ref2$UNSAFE_themeOpt; // CLEANUP: Remove. This blocks application of increased contrast themes
                    // without the feature flag enabled.
                    if (!(0, $id6Cu.fg)('platform_increased-contrast-themes')) {
                        if (light === 'light-increased-contrast') light = 'light';
                        if (dark === 'dark-increased-contrast') dark = 'dark';
                    }
                    themeState = {
                        colorMode: colorMode,
                        contrastMode: contrastMode,
                        dark: dark,
                        light: light,
                        shape: shape,
                        spacing: spacing,
                        typography: typography,
                        UNSAFE_themeOptions: themeLoader ? undefined : UNSAFE_themeOptions
                    }; // Determine what to load and loading strategy
                    themePreferences = (0, $f959ed1c119df874$export$dd6aeb7c823fc03d)(themeState);
                    loadingStrategy = themeLoader ? themeLoader : (0, $cde95922e46f0e46$export$26cd7ae85c7144e5); // Load standard themes
                    loadingTasks = themePreferences.map(/*#__PURE__*/ function() {
                        var _ref3 = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee(themeId) {
                            return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee$(_context) {
                                while(true)switch(_context.prev = _context.next){
                                    case 0:
                                        _context.next = 2;
                                        return loadingStrategy(themeId);
                                    case 2:
                                        return _context.abrupt("return", _context.sent);
                                    case 3:
                                    case "end":
                                        return _context.stop();
                                }
                            }, _callee);
                        }));
                        return function(_x) {
                            return _ref3.apply(this, arguments);
                        };
                    }()); // Load custom themes if needed
                    if (!themeLoader && UNSAFE_themeOptions && (0, $j8wi6.isValidBrandHex)(UNSAFE_themeOptions === null || UNSAFE_themeOptions === void 0 ? void 0 : UNSAFE_themeOptions.brandColor)) {
                        mode = colorMode || (0, $jOCEz.themeStateDefaults)['colorMode'];
                        attrOfMissingCustomStyles = (0, $89dnb.findMissingCustomStyleElements)(UNSAFE_themeOptions, mode);
                        if (attrOfMissingCustomStyles.length > 0) // Load custom theme styles
                        loadingTasks.push((0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee2() {
                            var _yield$import, loadAndAppendCustomThemeCss;
                            return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee2$(_context2) {
                                while(true)switch(_context2.prev = _context2.next){
                                    case 0:
                                        _context2.next = 2;
                                        return (parcelRequire("ejdjF"));
                                    case 2:
                                        _yield$import = _context2.sent;
                                        loadAndAppendCustomThemeCss = _yield$import.loadAndAppendCustomThemeCss;
                                        loadAndAppendCustomThemeCss({
                                            colorMode: attrOfMissingCustomStyles.length === 2 ? 'auto' : // only load the missing custom theme styles
                                            attrOfMissingCustomStyles[0],
                                            UNSAFE_themeOptions: UNSAFE_themeOptions
                                        });
                                    case 5:
                                    case "end":
                                        return _context2.stop();
                                }
                            }, _callee2);
                        }))());
                    }
                    _context3.next = 11;
                    return Promise.all(loadingTasks);
                case 11:
                    // Load override themes after standard themes
                    themeOverridePreferences = (0, $f959ed1c119df874$export$5d76d7014f4a5d08)(themeState);
                    _iterator = $a2c33e137370f0d9$var$_createForOfIteratorHelper(themeOverridePreferences);
                    _context3.prev = 13;
                    _iterator.s();
                case 15:
                    if ((_step = _iterator.n()).done) {
                        _context3.next = 21;
                        break;
                    }
                    themeId = _step.value;
                    _context3.next = 19;
                    return loadingStrategy(themeId);
                case 19:
                    _context3.next = 15;
                    break;
                case 21:
                    _context3.next = 26;
                    break;
                case 23:
                    _context3.prev = 23;
                    _context3.t0 = _context3["catch"](13);
                    _iterator.e(_context3.t0);
                case 26:
                    _context3.prev = 26;
                    _iterator.f();
                    return _context3.finish(26);
                case 29:
                    autoUnbind = (0, $ae04c9bc1716bb3e$export$2e2bcd8739ae039)(themeState);
                    return _context3.abrupt("return", autoUnbind);
                case 31:
                case "end":
                    return _context3.stop();
            }
        }, _callee3, null, [
            [
                13,
                23,
                26,
                29
            ]
        ]);
    }));
    return function setGlobalTheme() {
        return _ref.apply(this, arguments);
    };
}();
var $a2c33e137370f0d9$export$2e2bcd8739ae039 = $a2c33e137370f0d9$var$setGlobalTheme;


var $4Q00M = parcelRequire("4Q00M");

var $5FkrB = parcelRequire("5FkrB");
var $6688269fdf07ee31$export$7981b2444296e410 = /*#__PURE__*/ (0, $5FkrB.createContext)(false);
var $6688269fdf07ee31$export$26aa23367bfbab0e = function useIsInsideAppProvider() {
    return (0, $5FkrB.useContext)($6688269fdf07ee31$export$7981b2444296e410);
};



var $5FkrB = parcelRequire("5FkrB");
var $59ea5103bf62ab3e$export$49ddd74a6729fdb0 = /*#__PURE__*/ (0, $5FkrB.createContext)(undefined);
var $59ea5103bf62ab3e$export$b06130bad0bbc70f = /*#__PURE__*/ (0, $5FkrB.createContext)(undefined);



var $5FkrB = parcelRequire("5FkrB");
var $c06a9a7d7ff65e3f$export$332347eeb335453c = /*#__PURE__*/ (0, $5FkrB.createContext)(false);



var $5FkrB = parcelRequire("5FkrB");
var $ceeae16bd40c6e56$export$2c657da244d00bd6 = /*#__PURE__*/ (0, $5FkrB.createContext)(undefined);
var $ceeae16bd40c6e56$export$f7a97b47760e2a13 = /*#__PURE__*/ (0, $5FkrB.createContext)(undefined);



var $5FkrB = parcelRequire("5FkrB");

var $cd66dcf42c0c874e$export$7ca11437599d653d = function useIsInsideThemeProvider() {
    var _useContext;
    return (_useContext = (0, $5FkrB.useContext)((0, $c06a9a7d7ff65e3f$export$332347eeb335453c))) !== null && _useContext !== void 0 ? _useContext : false;
};



var $fL8KA = parcelRequire("fL8KA");

var $6HG4S = parcelRequire("6HG4S");

var $hBCYb = parcelRequire("hBCYb");


var $hBCYb = parcelRequire("hBCYb");

var $4Q00M = parcelRequire("4Q00M");
function $38394c79556d6239$export$835a0dc855d02822(themeId) {
    var doc = (0, $hBCYb.getDocument)();
    if (!doc) return false;
    return doc.head.querySelector("style[".concat((0, $4Q00M.THEME_DATA_ATTRIBUTE), "=\"").concat(themeId, "\"]"));
}


var $c17fa23ae42a5a1f$var$loadThemeCss = /*#__PURE__*/ function() {
    var _ref = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee(themeId) {
        var _yield$themeImportMap, themeCss;
        return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee$(_context) {
            while(true)switch(_context.prev = _context.next){
                case 0:
                    if (!(0, $38394c79556d6239$export$835a0dc855d02822)(themeId)) {
                        _context.next = 2;
                        break;
                    }
                    return _context.abrupt("return");
                case 2:
                    if (themeId) {
                        _context.next = 4;
                        break;
                    }
                    return _context.abrupt("return");
                case 4:
                    _context.next = 6;
                    return (0, $32fcecf5eab03b46$export$2e2bcd8739ae039)[themeId]();
                case 6:
                    _yield$themeImportMap = _context.sent;
                    themeCss = _yield$themeImportMap.default;
                    return _context.abrupt("return", themeCss);
                case 9:
                case "end":
                    return _context.stop();
            }
        }, _callee);
    }));
    return function loadThemeCss(_x) {
        return _ref.apply(this, arguments);
    };
}();
var $c17fa23ae42a5a1f$var$mountThemeCss = /*#__PURE__*/ function() {
    var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee2(css, themeId) {
        var doc, style;
        return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee2$(_context2) {
            while(true)switch(_context2.prev = _context2.next){
                case 0:
                    // SSR-safe: Only mount on client side
                    doc = (0, $hBCYb.getDocument)();
                    if (doc) {
                        _context2.next = 3;
                        break;
                    }
                    return _context2.abrupt("return");
                case 3:
                    style = doc.createElement('style');
                    style.textContent = css;
                    style.dataset.theme = themeId;
                    // Prevent duplicate mounting of themes.
                    // It's possible the theme was already being loaded elsewhere.
                    if (!(0, $38394c79556d6239$export$835a0dc855d02822)(themeId)) {
                        _context2.next = 8;
                        break;
                    }
                    return _context2.abrupt("return");
                case 8:
                    doc.head.appendChild(style);
                case 9:
                case "end":
                    return _context2.stop();
            }
        }, _callee2);
    }));
    return function mountThemeCss(_x2, _x3) {
        return _ref2.apply(this, arguments);
    };
}();
var $c17fa23ae42a5a1f$var$loadAndMountThemeCss = /*#__PURE__*/ function() {
    var _ref3 = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee3(themeId) {
        var themeCss;
        return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee3$(_context3) {
            while(true)switch(_context3.prev = _context3.next){
                case 0:
                    _context3.next = 2;
                    return $c17fa23ae42a5a1f$var$loadThemeCss(themeId);
                case 2:
                    themeCss = _context3.sent;
                    if (themeCss) {
                        _context3.next = 5;
                        break;
                    }
                    return _context3.abrupt("return");
                case 5:
                    $c17fa23ae42a5a1f$var$mountThemeCss(themeCss, themeId);
                case 6:
                case "end":
                    return _context3.stop();
            }
        }, _callee3);
    }));
    return function loadAndMountThemeCss(_x4) {
        return _ref3.apply(this, arguments);
    };
}();
var $c17fa23ae42a5a1f$export$7d4a7e812d176b24 = /*#__PURE__*/ function() {
    var _ref4 = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee4(theme) {
        var themesToLoad;
        return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee4$(_context4) {
            while(true)switch(_context4.prev = _context4.next){
                case 0:
                    themesToLoad = Object.values(theme).filter(function(themeId) {
                        return !!themeId;
                    });
                    themesToLoad.forEach($c17fa23ae42a5a1f$var$loadAndMountThemeCss);
                case 2:
                case "end":
                    return _context4.stop();
            }
        }, _callee4);
    }));
    return function loadAndMountThemes(_x5) {
        return _ref4.apply(this, arguments);
    };
}();


function $6ffcc77f4ddb355e$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $6ffcc77f4ddb355e$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $6ffcc77f4ddb355e$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $6ffcc77f4ddb355e$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $6ffcc77f4ddb355e$var$defaultThemeSettings = {
    dark: 'dark',
    light: 'light',
    spacing: 'spacing',
    typography: 'typography'
};
var $6ffcc77f4ddb355e$var$isMatchMediaAvailable = typeof window !== 'undefined' && 'matchMedia' in window;
var $6ffcc77f4ddb355e$var$prefersDarkModeMql = $6ffcc77f4ddb355e$var$isMatchMediaAvailable ? window.matchMedia('(prefers-color-scheme: dark)') : undefined;
// TODO: currently 'auto' color mode will always return 'light' in SSR.
// Additional work required: https://product-fabric.atlassian.net/browse/DSP-9781
function $6ffcc77f4ddb355e$var$getReconciledColorMode(colorMode) {
    if (colorMode === 'auto') return $6ffcc77f4ddb355e$var$prefersDarkModeMql !== null && $6ffcc77f4ddb355e$var$prefersDarkModeMql !== void 0 && $6ffcc77f4ddb355e$var$prefersDarkModeMql.matches ? 'dark' : 'light';
    return colorMode;
}
var $6ffcc77f4ddb355e$var$contentStyles = {
    body: "_1e0c1bgi"
};
/**
 * __Theme provider__
 *
 * Provides global theming configuration.
 */ function $6ffcc77f4ddb355e$var$ThemeProvider(_ref) {
    var children = _ref.children, _ref$defaultColorMode = _ref.defaultColorMode, defaultColorMode = _ref$defaultColorMode === void 0 ? 'auto' : _ref$defaultColorMode, defaultTheme = _ref.defaultTheme;
    var _useState = (0, $5FkrB.useState)(defaultColorMode), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), chosenColorMode = _useState2[0], setChosenColorMode = _useState2[1];
    var _useState3 = (0, $5FkrB.useState)($6ffcc77f4ddb355e$var$getReconciledColorMode(defaultColorMode)), _useState4 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState3, 2), reconciledColorMode = _useState4[0], setReconciledColorMode = _useState4[1];
    var _useState5 = (0, $5FkrB.useState)(function() {
        return $6ffcc77f4ddb355e$var$_objectSpread($6ffcc77f4ddb355e$var$_objectSpread({}, $6ffcc77f4ddb355e$var$defaultThemeSettings), defaultTheme);
    }), _useState6 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState5, 2), theme = _useState6[0], setTheme = _useState6[1];
    var setColorMode = (0, $5FkrB.useCallback)(function(colorMode) {
        setChosenColorMode(colorMode);
        setReconciledColorMode($6ffcc77f4ddb355e$var$getReconciledColorMode(colorMode));
    }, []);
    var setPartialTheme = (0, $5FkrB.useCallback)(function(nextTheme) {
        setTheme(function(theme) {
            return $6ffcc77f4ddb355e$var$_objectSpread($6ffcc77f4ddb355e$var$_objectSpread({}, theme), nextTheme);
        });
    }, []);
    var lastSetGlobalThemePromiseRef = (0, $5FkrB.useRef)(null);
    var isInsideAppProvider = (0, $6688269fdf07ee31$export$26aa23367bfbab0e)();
    var isInsideThemeProvider = (0, $cd66dcf42c0c874e$export$7ca11437599d653d)();
    var isRootThemeProvider = isInsideAppProvider && !isInsideThemeProvider;
    (0, $5FkrB.useEffect)(function() {
        if (/**
     * A top-level ThemeProvider is detected by being the first ThemeProvider inside an AppProvider.
     *
     * This will not use sub-tree theming but instead set the global theme state using the
     * `@atlaskit/tokens` APIs, as it's required for styling root `html` and `body` elements
     * for compatibility with `@atlaskit/css-reset`.
     *
     * In the future we could consider moving away from DOM mutations and require AppProvider to wrap
     * `html` in order to apply global theme state, which would allow a more consistent approach to
     * theme loading.
     */ isRootThemeProvider || /**
     * Or when not behind feature flag, partially revert to legacy behavior.
     * This only affects theme providers that are not inside an AppProvider or a ThemeProvider,
     * as we still need to set global theme state to prevent breaking existing apps,
     * but also prevent multiple theme providers from loading conflicting theme states.
     *
     * After we roll out the feature flag, this will be removed as we will
     * only support sub-tree theming when used outside of AppProvider.
     */ !isInsideAppProvider && !isInsideThemeProvider && !(0, $id6Cu.fg)('platform_dst_subtree_theming')) {
            /**
       * We need to wait for any previous `setGlobalTheme` calls to finish before calling it again.
       * This is to prevent race conditions as `setGlobalTheme` is async and mutates the DOM (e.g. sets the
       * `data-color-mode` attribute on the root element).
       *
       * Since we can't safely abort the `setGlobalTheme` execution, we need to wait for it to properly finish before
       * applying the new theme.
       *
       * Without this, we can end up in the following scenario:
       * 1. app loads with the default 'light' theme, kicking off `setGlobalTheme`
       * 2. app switches to 'dark' theme after retrieving value persisted in local storage, calling `setGlobalTheme` again
       * 3. `setGlobalTheme` function execution for `dark` finishes before the initial `light` execution
       * 4. `setGlobalTheme` function execution for `light` then finishes, resulting in the 'light' theme being applied.
       */ var cleanupLastFnCall = /*#__PURE__*/ function() {
                var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee() {
                    var unbindFn;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee$(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                if (!lastSetGlobalThemePromiseRef.current) {
                                    _context.next = 6;
                                    break;
                                }
                                _context.next = 3;
                                return lastSetGlobalThemePromiseRef.current;
                            case 3:
                                unbindFn = _context.sent;
                                unbindFn();
                                lastSetGlobalThemePromiseRef.current = null;
                            case 6:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee);
                }));
                return function cleanupLastFnCall() {
                    return _ref2.apply(this, arguments);
                };
            }();
            var safelySetGlobalTheme = /*#__PURE__*/ function() {
                var _ref3 = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee2() {
                    var promise;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee2$(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                _context2.next = 2;
                                return cleanupLastFnCall();
                            case 2:
                                promise = (0, $a2c33e137370f0d9$export$2e2bcd8739ae039)($6ffcc77f4ddb355e$var$_objectSpread($6ffcc77f4ddb355e$var$_objectSpread({}, theme), {}, {
                                    colorMode: reconciledColorMode
                                }));
                                lastSetGlobalThemePromiseRef.current = promise;
                            case 4:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2);
                }));
                return function safelySetGlobalTheme() {
                    return _ref3.apply(this, arguments);
                };
            }();
            safelySetGlobalTheme();
            return function cleanup() {
                cleanupLastFnCall();
            };
        } else // For other theme providers (whether outside AppProvider or nested inside a ThemeProvider),
        // we treat them as sub-tree themes that do not load global theme state.
        (0, $c17fa23ae42a5a1f$export$7d4a7e812d176b24)(theme);
    }, [
        isInsideAppProvider,
        isInsideThemeProvider,
        isRootThemeProvider,
        reconciledColorMode,
        theme
    ]);
    (0, $5FkrB.useEffect)(function() {
        if (!$6ffcc77f4ddb355e$var$prefersDarkModeMql) return;
        var unbindListener = (0, $7QpUe.bind)($6ffcc77f4ddb355e$var$prefersDarkModeMql, {
            type: 'change',
            listener: function listener(event) {
                if (chosenColorMode === 'auto') setReconciledColorMode(event.matches ? 'dark' : 'light');
            }
        });
        return unbindListener;
    }, [
        chosenColorMode
    ]);
    var attrs = $6ffcc77f4ddb355e$var$_objectSpread($6ffcc77f4ddb355e$var$_objectSpread({}, (0, $5e61660cd96d9b4a$export$2e2bcd8739ae039)($6ffcc77f4ddb355e$var$_objectSpread($6ffcc77f4ddb355e$var$_objectSpread({}, theme), {}, {
        colorMode: reconciledColorMode
    }))), {}, (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, (0, $4Q00M.SUBTREE_THEME_ATTRIBUTE), true));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $c06a9a7d7ff65e3f$export$332347eeb335453c).Provider, {
        value: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $59ea5103bf62ab3e$export$49ddd74a6729fdb0).Provider, {
        value: reconciledColorMode
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $59ea5103bf62ab3e$export$b06130bad0bbc70f).Provider, {
        value: setColorMode
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $ceeae16bd40c6e56$export$2c657da244d00bd6).Provider, {
        value: theme
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $ceeae16bd40c6e56$export$f7a97b47760e2a13).Provider, {
        value: setPartialTheme
    }, (0, $id6Cu.fg)('platform_dst_subtree_theming') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, attrs, {
        className: (0, $970q7.default)([
            $6ffcc77f4ddb355e$var$contentStyles.body
        ])
    }), children) : children)))));
}
var $6ffcc77f4ddb355e$export$2e2bcd8739ae039 = $6ffcc77f4ddb355e$var$ThemeProvider;


var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $25nEq = parcelRequire("25nEq");

var $4Q00M = parcelRequire("4Q00M");

/**
 * A MutationObserver which watches the `<html>` element for changes to the theme.
 *
 * In React, use the {@link useThemeObserver `useThemeObserver`} hook instead.
 *
 * @param {function} callback - A callback function which fires when the theme changes.
 *
 * @example
 * ```
 * const observer = new ThemeMutationObserver((theme) => {});
 * observer.observe();
 * ```
 */ var $946891a701aab188$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function ThemeMutationObserver(callback) {
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, ThemeMutationObserver);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "legacyObserver", null);
        this.callback = callback;
        ThemeMutationObserver.callbacks.add(callback);
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(ThemeMutationObserver, [
        {
            key: "observe",
            value: function observe() {
                if (!ThemeMutationObserver.observer) {
                    ThemeMutationObserver.observer = new MutationObserver(function() {
                        var theme = (0, $baa32d2608b04b9c$export$2e2bcd8739ae039)();
                        ThemeMutationObserver.callbacks.forEach(function(callback) {
                            return callback(theme);
                        });
                    });
                    // Observer only needs to be configured once
                    ThemeMutationObserver.observer.observe(document.documentElement, {
                        attributeFilter: [
                            (0, $4Q00M.THEME_DATA_ATTRIBUTE),
                            (0, $4Q00M.COLOR_MODE_ATTRIBUTE)
                        ]
                    });
                }
            }
        },
        {
            key: "disconnect",
            value: function disconnect() {
                if (this.callback) ThemeMutationObserver.callbacks.delete(this.callback);
                if (ThemeMutationObserver.callbacks.size === 0 && ThemeMutationObserver.observer) {
                    ThemeMutationObserver.observer.disconnect();
                    ThemeMutationObserver.observer = null;
                }
            }
        }
    ]);
}();
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($946891a701aab188$export$2e2bcd8739ae039, "observer", null);
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($946891a701aab188$export$2e2bcd8739ae039, "callbacks", new Set());



function $c9f6acb1ae43a853$export$20f3076712c8dfa() {
    var value = (0, $5FkrB.useContext)((0, $59ea5103bf62ab3e$export$49ddd74a6729fdb0));
    // TODO: This will only return 'light' or 'dark' but never 'auto', which in some cases
    // may be desirable. We should consider returning both the reconciled color mode (e.g. 'light' or 'dark') and the selected color mode ("auto").
    var theme = (0, $baa32d2608b04b9c$export$2e2bcd8739ae039)();
    var _useState = (0, $5FkrB.useState)((theme === null || theme === void 0 ? void 0 : theme.colorMode) || 'light'), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), resolvedColorMode = _useState2[0], setResolvedColorMode = _useState2[1];
    (0, $5FkrB.useEffect)(function() {
        // We are using theme from context so no need to reference the DOM
        if (value) return;
        var observer = new (0, $946891a701aab188$export$2e2bcd8739ae039)(function(theme) {
            setResolvedColorMode((theme === null || theme === void 0 ? void 0 : theme.colorMode) || 'light');
        });
        observer.observe();
        return function() {
            return observer.disconnect();
        };
    }, [
        value
    ]);
    return value ? value : resolvedColorMode;
}



var $id6Cu = parcelRequire("id6Cu");
var $7eed6458f540121a$export$e4c79eb95c23a0da = 'atlaskit-portal-container';
var $7eed6458f540121a$export$72f415121273627e = 'body > .atlaskit-portal-container';
var $7eed6458f540121a$export$13f57c02915787b3 = 'atlaskit-portal';


var $75cf614393d315a6$export$26ae5ca175b4ec5a = function createContainer(zIndex) {
    var container = document.createElement('div');
    container.className = (0, $7eed6458f540121a$export$13f57c02915787b3);
    container.style.zIndex = "".concat(zIndex);
    return container;
};
/**
 * Returns document body element
 * @return {number} - The document body element
 */ var $75cf614393d315a6$var$getBody = function getBody() {
    return document.body;
};
/**
 * Returns portal parent container. If no container exists already then it creates a new container with class name 'atlaskit-portal-container'
 * @return {Element} - The portal parent container div element
 */ var $75cf614393d315a6$var$getPortalParent = function getPortalParent() {
    var parentElement = document.querySelector((0, $7eed6458f540121a$export$72f415121273627e));
    if (!parentElement) {
        var _getBody;
        var parent = document.createElement('div');
        parent.className = (0, $7eed6458f540121a$export$e4c79eb95c23a0da);
        // we are setting display to flex because we want each portal to create a new stacking context
        // See https://developer.mozilla.org/en-US/docs/Web/CSS/CSS_Positioning/Understanding_z_index/The_stacking_context
        parent.style.display = 'flex';
        (_getBody = $75cf614393d315a6$var$getBody()) === null || _getBody === void 0 || _getBody.appendChild(parent);
        return parent;
    }
    return parentElement;
};
var $75cf614393d315a6$export$da99f98bf3fe55b3 = function removePortalContainer(container) {
    $75cf614393d315a6$var$getPortalParent().removeChild(container);
};
var $75cf614393d315a6$export$c582005add11e141 = function appendPortalContainerIfNotAppended(container) {
    if (!container.parentElement) $75cf614393d315a6$var$getPortalParent().appendChild(container);
};
var $75cf614393d315a6$var$isDocumentDefined = function isDocumentDefined() {
    return document !== undefined;
};
var $75cf614393d315a6$export$fef014d7cef9e543 = function createAtlaskitPortal(zIndex) {
    //atlaskit-portal div
    if ($75cf614393d315a6$var$isDocumentDefined()) {
        var atlaskitportal = document.createElement('div');
        atlaskitportal.className = (0, $7eed6458f540121a$export$13f57c02915787b3);
        atlaskitportal.style.zIndex = "".concat(zIndex);
        return atlaskitportal;
    }
    return;
};
var $75cf614393d315a6$export$95029ca7aca2989e = function createPortalParent() {
    //atlaskit-portal-container div
    if ($75cf614393d315a6$var$isDocumentDefined()) {
        var parentElement = document.querySelector((0, $7eed6458f540121a$export$72f415121273627e));
        if (!parentElement) {
            var _getBody2;
            var parent = document.createElement('div');
            parent.className = (0, $7eed6458f540121a$export$e4c79eb95c23a0da);
            parent.style.display = 'flex';
            (_getBody2 = $75cf614393d315a6$var$getBody()) === null || _getBody2 === void 0 || _getBody2.appendChild(parent);
            return parent;
        }
        return parentElement;
    }
    return;
};


function $753bccad51b74a1e$export$2e2bcd8739ae039(props) {
    var zIndex = props.zIndex, children = props.children;
    var container = (0, $5FkrB.useMemo)(function() {
        return (0, $75cf614393d315a6$export$26ae5ca175b4ec5a)(zIndex);
    }, [
        zIndex
    ]);
    var colorMode = (0, $c9f6acb1ae43a853$export$20f3076712c8dfa)();
    // This is in the render method instead of useEffect so that
    // the portal will be added to the DOM before the children render.
    // For any further changes, ensure that the container does not have a
    // parent besides the portal parent.
    (0, $75cf614393d315a6$export$c582005add11e141)(container);
    (0, $5FkrB.useEffect)(function() {
        return function() {
            (0, $75cf614393d315a6$export$da99f98bf3fe55b3)(container);
        };
    }, [
        container
    ]);
    return /*#__PURE__*/ (0, $aLeHs.createPortal)(colorMode && (0, $id6Cu.fg)('platform_dst_subtree_theming') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $6ffcc77f4ddb355e$export$2e2bcd8739ae039), {
        defaultColorMode: colorMode
    }, children) : children, container);
}



var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");

var $aLeHs = parcelRequire("aLeHs");


var $id6Cu = parcelRequire("id6Cu");

var $5FkrB = parcelRequire("5FkrB");
var $13e3b3f94a06f827$export$700979bc83e7db82 = typeof window !== 'undefined' ? (0, $5FkrB.useLayoutEffect) : (0, $5FkrB.useEffect);



function $70acb359f75aa583$export$2e2bcd8739ae039(props) {
    var zIndex = props.zIndex, children = props.children;
    var _useState = (0, $5FkrB.useState)(null), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), atlaskitPortal = _useState2[0], setAtlaskitPortal = _useState2[1];
    var colorMode = (0, $c9f6acb1ae43a853$export$20f3076712c8dfa)();
    (0, $13e3b3f94a06f827$export$700979bc83e7db82)(function() {
        var tempPortalContainer = (0, $75cf614393d315a6$export$fef014d7cef9e543)(zIndex);
        setAtlaskitPortal(tempPortalContainer);
        var portalParent = (0, $75cf614393d315a6$export$95029ca7aca2989e)();
        if (!tempPortalContainer || !portalParent) return;
        portalParent.appendChild(tempPortalContainer);
        return function() {
            if (tempPortalContainer) portalParent.removeChild(tempPortalContainer);
            setAtlaskitPortal(null);
        };
    }, [
        zIndex
    ]);
    /**
   * We wrap portal children with a Suspense boundary because in React 18 concurrent,
   * if you suspend from _within_ a portal to a Suspense boundary _outside_ the portal,
   * our portal gets in an infinite loop of rendering.
   */ var suspendedChildren = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $5FkrB.Suspense), {
        fallback: null
    }, colorMode && (0, $id6Cu.fg)('platform_dst_subtree_theming') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $6ffcc77f4ddb355e$export$2e2bcd8739ae039), {
        defaultColorMode: colorMode
    }, children) : children);
    return atlaskitPortal ? /*#__PURE__*/ (0, $aLeHs.createPortal)(suspendedChildren, atlaskitPortal) : null;
}



var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");

var $6e9494db0fb7aee0$var$useIsSubsequentRender = function useIsSubsequentRender(mountStrategy) {
    var _useState = (0, $5FkrB.useState)(false), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), isSubsequentRender = _useState2[0], setIsSubsequentRender = _useState2[1];
    var _useState3 = (0, $5FkrB.useState)(function() {
        return mountStrategy === 'layoutEffect' ? (0, $13e3b3f94a06f827$export$700979bc83e7db82) : (0, $5FkrB.useEffect);
    }), _useState4 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState3, 1), useMountEffect = _useState4[0];
    useMountEffect(function() {
        setIsSubsequentRender(true);
    }, []);
    return isSubsequentRender;
};
var $6e9494db0fb7aee0$export$2e2bcd8739ae039 = $6e9494db0fb7aee0$var$useIsSubsequentRender;



var $5FkrB = parcelRequire("5FkrB");
var $2f7eb082d219ea34$export$ed5835cc67e87f72 = 'akPortalMount';
var $2f7eb082d219ea34$export$80816bd900e5bd00 = 'akPortalUnmount';


var $1155d87073fbfdcd$var$zIndexToName = {
    100: 'card',
    200: 'navigation',
    300: 'dialog',
    400: 'layer',
    500: 'blanket',
    510: 'modal',
    600: 'flag',
    700: 'spotlight',
    9999: 'tooltip'
};
/**
 * return layer name in Atlassian design system corresponding to given z-index
 * @param {number} zIndex - z-index value for which layer name is needed
 * @returns {LayerName | null} - The layer name for given z-index. If layer name is not found then null is returned
 */ var $1155d87073fbfdcd$var$getLayerName = function getLayerName(zIndex) {
    return $1155d87073fbfdcd$var$zIndexToName.hasOwnProperty(zIndex) ? $1155d87073fbfdcd$var$zIndexToName[zIndex] : null;
};
/**
 * Creates a PortalEvent object with given eventName, given zIndex and corresponding layer
 * @param {string} eventName - either of Mount or Unmount event name
 * @param {number} zIndex - z-index value which will be included in the event to be dispatched
 * @returns {PortalEvent} - The newly created PortalEvent object
 */ var $1155d87073fbfdcd$var$getEvent = function getEvent(eventName, zIndex) {
    var detail = {
        layer: $1155d87073fbfdcd$var$getLayerName(Number(zIndex)),
        zIndex: zIndex
    };
    return new CustomEvent(eventName, {
        detail: detail
    });
};
function $1155d87073fbfdcd$export$2e2bcd8739ae039(eventName, zIndex) {
    var event = $1155d87073fbfdcd$var$getEvent(eventName, zIndex);
    window.dispatchEvent(event);
}


var $929cdced5e452f55$var$useFirePortalEvent = function useFirePortalEvent(zIndex) {
    var zIndexNumber = Number(zIndex);
    (0, $5FkrB.useEffect)(function() {
        (0, $1155d87073fbfdcd$export$2e2bcd8739ae039)((0, $2f7eb082d219ea34$export$ed5835cc67e87f72), zIndexNumber);
        return function() {
            (0, $1155d87073fbfdcd$export$2e2bcd8739ae039)((0, $2f7eb082d219ea34$export$80816bd900e5bd00), zIndexNumber);
        };
    }, [
        zIndexNumber
    ]);
};
var $929cdced5e452f55$export$2e2bcd8739ae039 = $929cdced5e452f55$var$useFirePortalEvent;


function $7ed1ec6058c2caca$export$2e2bcd8739ae039(_ref) {
    var _ref$zIndex = _ref.zIndex, zIndex = _ref$zIndex === void 0 ? 0 : _ref$zIndex, children = _ref.children, _ref$mountStrategy = _ref.mountStrategy, mountStrategy = _ref$mountStrategy === void 0 ? 'effect' : _ref$mountStrategy;
    var isSubsequentRender = (0, $6e9494db0fb7aee0$export$2e2bcd8739ae039)(mountStrategy);
    (0, $929cdced5e452f55$export$2e2bcd8739ae039)(zIndex);
    return !(0, $id6Cu.fg)('platform_design_system_team_portal_logic_r18_fix') ? isSubsequentRender ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $753bccad51b74a1e$export$2e2bcd8739ae039), {
        zIndex: zIndex
    }, children) : null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $70acb359f75aa583$export$2e2bcd8739ae039), {
        zIndex: zIndex
    }, children);
}



var $kxpsr = parcelRequire("kxpsr");
// Reds
var $c7ac8e5819842838$export$4b84fd0e2c617bd = '#FFEBE6';
var $c7ac8e5819842838$export$b34b069eff244586 = '#FFBDAD';
var $c7ac8e5819842838$export$be802dd0d8b57f35 = '#FF8F73';
var $c7ac8e5819842838$export$60847d42f9da92a6 = '#FF7452';
var $c7ac8e5819842838$export$4a7404f376229999 = '#FF5630';
var $c7ac8e5819842838$export$2010d0fb4295b346 = '#DE350B';
var $c7ac8e5819842838$export$2837b5a1a71d5c02 = '#BF2600';
var $c7ac8e5819842838$export$8d9596b529bbb9cf = '#FFFAE6';
var $c7ac8e5819842838$export$41060a744ab0b7ae = '#FFF0B3';
var $c7ac8e5819842838$export$1cc05bbbf340e559 = '#FFE380';
var $c7ac8e5819842838$export$5aae31392d72caaa = '#FFC400';
var $c7ac8e5819842838$export$c6930421db9fa514 = '#FFAB00';
var $c7ac8e5819842838$export$59619663aa6500fb = '#FF991F';
var $c7ac8e5819842838$export$874739ea9e379ab6 = '#FF8B00';
var $c7ac8e5819842838$export$8a6341c32b6a3ee6 = '#E3FCEF';
var $c7ac8e5819842838$export$69a3bf21b9686c2b = '#ABF5D1';
var $c7ac8e5819842838$export$afbce1382ec95f73 = '#79F2C0';
var $c7ac8e5819842838$export$747d86715d4175de = '#57D9A3';
var $c7ac8e5819842838$export$940e1f69e873f202 = '#36B37E';
var $c7ac8e5819842838$export$a49394138f7b8e85 = '#00875A';
var $c7ac8e5819842838$export$6fa04827ac68a4fb = '#006644';
var $c7ac8e5819842838$export$226de0355ed012f8 = '#DEEBFF';
var $c7ac8e5819842838$export$8c13c2ee36917869 = '#B3D4FF';
var $c7ac8e5819842838$export$ecfc1dff386a3e7a = '#4C9AFF';
var $c7ac8e5819842838$export$215b7063051591f1 = '#2684FF';
var $c7ac8e5819842838$export$e62e8919cca44969 = '#0065FF';
var $c7ac8e5819842838$export$b3de0ae08da2ce64 = '#0052CC';
var $c7ac8e5819842838$export$a6ee3d71bc067634 = '#0747A6';
var $c7ac8e5819842838$export$67f15409e87642a1 = '#669DF1';
var $c7ac8e5819842838$export$f0539dbc42dbb067 = '#8FB8F6';
var $c7ac8e5819842838$export$363e4475840015bb = '#EAE6FF';
var $c7ac8e5819842838$export$4b0a4417ed59760f = '#C0B6F2';
var $c7ac8e5819842838$export$6011520a64d9a187 = '#998DD9';
var $c7ac8e5819842838$export$a7175d4e9206bc80 = '#8777D9';
var $c7ac8e5819842838$export$b48405b95304b5a1 = '#6554C0';
var $c7ac8e5819842838$export$c71e4279dd54a18d = '#5243AA';
var $c7ac8e5819842838$export$147899de772240ec = '#403294';
var $c7ac8e5819842838$export$2cf711fe14c66f06 = '#E6FCFF';
var $c7ac8e5819842838$export$7a8f4d33f6f9772c = '#B3F5FF';
var $c7ac8e5819842838$export$776c9c497ef08533 = '#79E2F2';
var $c7ac8e5819842838$export$69cb3ca10c1e330e = '#00C7E6';
var $c7ac8e5819842838$export$9dc1ef0f3f48059b = '#00B8D9';
var $c7ac8e5819842838$export$7c835c78b6fcdef8 = '#00A3BF';
var $c7ac8e5819842838$export$6036577f95c3877e = '#008DA6';
var $c7ac8e5819842838$export$29a4f05edc054374 = '#FFFFFF';
var $c7ac8e5819842838$export$e655ef011c4aa1a2 = '#FAFBFC';
var $c7ac8e5819842838$export$9fdfb749e33cdf97 = '#F4F5F7';
var $c7ac8e5819842838$export$3e51e8f1440314ba = '#EBECF0';
var $c7ac8e5819842838$export$1ce2d1575d444ceb = '#DFE1E6';
var $c7ac8e5819842838$export$8754fc7e6d8b3000 = '#C1C7D0';
var $c7ac8e5819842838$export$c2e91cbeada39b8b = '#B3BAC5';
var $c7ac8e5819842838$export$5f71e19f3a7ad9de = '#A5ADBA';
var $c7ac8e5819842838$export$eaa8c8a70ac22806 = '#97A0AF';
var $c7ac8e5819842838$export$7c87d337fb91a97d = '#8993A4';
var $c7ac8e5819842838$export$d6447c357493214f = '#7A869A';
var $c7ac8e5819842838$export$f563ee71e9ee74cd = '#6B778C';
var $c7ac8e5819842838$export$e2ef2124cf4024b1 = '#5E6C84';
var $c7ac8e5819842838$export$eece5f492e429f08 = '#505F79';
var $c7ac8e5819842838$export$c39c0fe0f26207ae = '#42526E';
var $c7ac8e5819842838$export$7090862dc3038a9f = '#344563';
var $c7ac8e5819842838$export$ad0bacf983b7ddaa = '#253858';
var $c7ac8e5819842838$export$7d61b15e0da132af = '#172B4D';
var $c7ac8e5819842838$export$fbda843f0a27fe96 = '#091E42';
var $c7ac8e5819842838$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
var $c7ac8e5819842838$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
var $c7ac8e5819842838$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
var $c7ac8e5819842838$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
var $c7ac8e5819842838$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
var $c7ac8e5819842838$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
var $c7ac8e5819842838$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
var $c7ac8e5819842838$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
var $c7ac8e5819842838$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
var $c7ac8e5819842838$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
var $c7ac8e5819842838$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
var $c7ac8e5819842838$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
var $c7ac8e5819842838$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
var $c7ac8e5819842838$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
var $c7ac8e5819842838$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
var $c7ac8e5819842838$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
var $c7ac8e5819842838$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
var $c7ac8e5819842838$export$2f6319cf7d736c2a = '#E6EDFA';
var $c7ac8e5819842838$export$95126bc8884d6634 = '#DCE5F5';
var $c7ac8e5819842838$export$8338d8c35d44ff1 = '#CED9EB';
var $c7ac8e5819842838$export$5368d76ae4fbbda7 = '#B8C7E0';
var $c7ac8e5819842838$export$9f0a771d16ec8d36 = '#ABBBD6';
var $c7ac8e5819842838$export$abcf8c38338b4aa5 = '#9FB0CC';
var $c7ac8e5819842838$export$97e81faa16a182c7 = '#8C9CB8';
var $c7ac8e5819842838$export$bfe21c59123ecf33 = '#7988A3';
var $c7ac8e5819842838$export$ee82aa2ea6a1558 = '#67758F';
var $c7ac8e5819842838$export$682927c6ed76be02 = '#56637A';
var $c7ac8e5819842838$export$91fd9994c5be9757 = '#455166';
var $c7ac8e5819842838$export$d281fbfe3cff2df6 = '#3B475C';
var $c7ac8e5819842838$export$3902c91d8b98a753 = '#313D52';
var $c7ac8e5819842838$export$8e8133c1ba5845b5 = '#283447';
var $c7ac8e5819842838$export$33ff357f6620b39 = '#202B3D';
var $c7ac8e5819842838$export$633847cf062b69e0 = '#1B2638';
var $c7ac8e5819842838$export$9776a6e503bdbf76 = '#121A29';
var $c7ac8e5819842838$export$6c813d5160dff5db = '#0E1624';
var $c7ac8e5819842838$export$3d4f271a500072a = '#0D1424';
var $c7ac8e5819842838$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
var $c7ac8e5819842838$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
var $c7ac8e5819842838$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
var $c7ac8e5819842838$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
var $c7ac8e5819842838$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
var $c7ac8e5819842838$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
var $c7ac8e5819842838$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
var $c7ac8e5819842838$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
var $c7ac8e5819842838$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
var $c7ac8e5819842838$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
var $c7ac8e5819842838$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
var $c7ac8e5819842838$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
var $c7ac8e5819842838$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
var $c7ac8e5819842838$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
var $c7ac8e5819842838$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
var $c7ac8e5819842838$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
var $c7ac8e5819842838$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';
var $c7ac8e5819842838$export$d2adc5dedf09fced = '#292A2E';
var $c7ac8e5819842838$export$f51762073d2bb381 = '#94C748';
var $c7ac8e5819842838$export$95e26d54def96891 = '#B3DF72';


var $e9d0322783570723$export$44ffba16bd48dac6 = '__ATLASKIT_THEME__';
var $e9d0322783570723$export$c93026a968943f95 = 'light';
var $e9d0322783570723$export$6ba72c8346b4c57e = [
    'light',
    'dark'
];
var $e9d0322783570723$export$8e24544ddba725ee = function focusRing() {
    var color = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "var(--ds-border-focused, ".concat((0, $c7ac8e5819842838$export$215b7063051591f1), ")");
    var outlineWidth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
    (0, $kxpsr.default)('@atlaskit/theme', 'focus ring mixin', 'Please use `@atlaskit/focus-ring` instead.');
    return "\n  &:focus {\n    outline: none;\n    box-shadow: 0px 0px 0px ".concat(outlineWidth, "px ").concat(color, ";\n  }\n");
};
var $e9d0322783570723$export$c0dd343266bc3261 = function noFocusRing() {
    return "\n  box-shadow: none;\n";
};
var $e9d0322783570723$export$7be255094ccdc533 = {
    card: function card() {
        return 100;
    },
    navigation: function navigation() {
        return 200;
    },
    dialog: function dialog() {
        return 300;
    },
    layer: function layer() {
        return 400;
    },
    blanket: function blanket() {
        return 500;
    },
    modal: function modal() {
        return 510;
    },
    flag: function flag() {
        return 600;
    },
    spotlight: function spotlight() {
        return 700;
    },
    tooltip: function tooltip() {
        return 9999;
    }
};
var $e9d0322783570723$export$a1b3edb637fb4f35 = function visuallyHidden() {
    (0, $kxpsr.default)('@atlaskit/theme', 'visually hidden mixin', 'Please use `@atlaskit/visually-hidden` instead.');
    return {
        border: '0 !important',
        clip: 'rect(1px, 1px, 1px, 1px) !important',
        height: '1px !important',
        overflow: 'hidden !important',
        padding: '0 !important',
        position: 'absolute !important',
        width: '1px !important',
        whiteSpace: 'nowrap !important'
    };
};
var $e9d0322783570723$export$ba1d834b86d72a09 = $e9d0322783570723$export$a1b3edb637fb4f35;
var $e9d0322783570723$export$e497e856b4f89fcd = function skeletonShimmer() {
    return {
        css: {
            backgroundColor: "var(--ds-skeleton, ".concat((0, $c7ac8e5819842838$export$8d43898f60b96a82), ")"),
            animationDuration: '1.5s',
            animationIterationCount: 'infinite',
            animationTimingFunction: 'linear',
            animationDirection: 'alternate'
        },
        keyframes: {
            from: {
                backgroundColor: "var(--ds-skeleton, ".concat((0, $c7ac8e5819842838$export$8d43898f60b96a82), ")")
            },
            to: {
                backgroundColor: "var(--ds-skeleton-subtle, ".concat((0, $c7ac8e5819842838$export$920c0d5c49070351), ")")
            }
        }
    };
};


/* eslint-disable @atlaskit/design-system/no-direct-use-of-web-platform-drag-and-drop */ /**
 * We are listening directly to drag events instead of using a monitor from
 * `@atlaskit/pragmatic-drag-and-drop` to avoid the bundle size cost, as it
 * would affect almost every view in every app.
 *
 * We can reconsider this choice in the future.
 */ 
var $7QpUe = parcelRequire("7QpUe");
var $e89b943f2315a15f$var$registrations = new Set();
var $e89b943f2315a15f$var$cleanupEndEventListeners = null;
function $e89b943f2315a15f$var$onDragStart() {
    if ($e89b943f2315a15f$var$cleanupEndEventListeners) // If the cleanup function exists then we've already run this
    return;
    $e89b943f2315a15f$var$cleanupEndEventListeners = (0, $7QpUe.bindAll)(window, [
        {
            type: 'dragend',
            listener: $e89b943f2315a15f$var$onDragEnd
        },
        {
            type: 'pointerdown',
            listener: $e89b943f2315a15f$var$onDragEnd
        },
        {
            type: 'pointermove',
            listener: function() {
                var callCount = 0;
                return function listener() {
                    // Using 20 as it is far bigger than the most observed (3)
                    if (callCount < 20) {
                        callCount++;
                        return;
                    }
                    $e89b943f2315a15f$var$onDragEnd();
                };
            }()
        }
    ]);
    var clone = Array.from($e89b943f2315a15f$var$registrations);
    clone.forEach(function(subscriber) {
        subscriber.onDragStart();
    });
}
function $e89b943f2315a15f$var$onDragEnd() {
    var _cleanupEndEventListe;
    (_cleanupEndEventListe = $e89b943f2315a15f$var$cleanupEndEventListeners) === null || _cleanupEndEventListe === void 0 || _cleanupEndEventListe();
    $e89b943f2315a15f$var$cleanupEndEventListeners = null;
    var clone = Array.from($e89b943f2315a15f$var$registrations);
    clone.forEach(function(subscriber) {
        subscriber.onDragEnd();
    });
}
function $e89b943f2315a15f$var$bindStartEvents() {
    return (0, $7QpUe.bindAll)(window, [
        {
            type: 'dragstart',
            listener: $e89b943f2315a15f$var$onDragStart
        },
        {
            type: 'dragenter',
            listener: $e89b943f2315a15f$var$onDragStart
        }
    ]);
}
var $e89b943f2315a15f$var$cleanupStartEventListeners = null;
function $e89b943f2315a15f$export$6503ec6e8aabbaf(registration) {
    // if first registration, bind event listeners
    if (!$e89b943f2315a15f$var$cleanupStartEventListeners) // note: currently never unbinding these event listeners
    $e89b943f2315a15f$var$cleanupStartEventListeners = $e89b943f2315a15f$var$bindStartEvents();
    $e89b943f2315a15f$var$registrations.add(registration);
    /**
   * The reasoning for this behavior is so that if a tooltip mounts during
   * a drag it can still be suppressed.
   *
   * We use a separate callback instead of onDragStart to avoid infinite loops.
   */ registration.onRegister({
        isDragging: $e89b943f2315a15f$var$cleanupEndEventListeners !== null
    });
    return function unregister() {
        $e89b943f2315a15f$var$registrations.delete(registration);
        if ($e89b943f2315a15f$var$registrations.size === 0) {
            var _cleanupStartEventLis;
            (_cleanupStartEventLis = $e89b943f2315a15f$var$cleanupStartEventListeners) === null || _cleanupStartEventLis === void 0 || _cleanupStartEventLis();
            $e89b943f2315a15f$var$cleanupStartEventListeners = null;
        }
    };
}



var $id6Cu = parcelRequire("id6Cu");
var $c41d218ca59a254a$var$delayId = null;
function $c41d218ca59a254a$export$eaf678f6f93f5250() {
    if ($c41d218ca59a254a$var$delayId != null) {
        window.clearTimeout($c41d218ca59a254a$var$delayId);
        $c41d218ca59a254a$var$delayId = null;
    }
}
function $c41d218ca59a254a$export$5f4d6617421d489b(fn, delay) {
    $c41d218ca59a254a$export$eaf678f6f93f5250();
    $c41d218ca59a254a$var$delayId = window.setTimeout(function() {
        $c41d218ca59a254a$var$delayId = null;
        fn();
    }, delay);
}


// This file is a singleton for managing tooltips
var $59257c3cf2f78a4d$var$active = null;
function $59257c3cf2f78a4d$export$57bf213be019eeb0(entry) {
    var phase = 'waiting-to-show';
    function isActive() {
        return Boolean($59257c3cf2f78a4d$var$active && $59257c3cf2f78a4d$var$active.entry === entry);
    }
    function cleanup() {
        if (isActive()) {
            (0, $c41d218ca59a254a$export$eaf678f6f93f5250)();
            $59257c3cf2f78a4d$var$active = null;
        }
    }
    function done() {
        if (isActive()) entry.done();
        phase = 'done';
        cleanup();
    }
    function immediatelyHideAndDone() {
        if (isActive()) entry.hide({
            isImmediate: true
        });
        done();
    }
    function keep() {
        if (!isActive()) return;
        // aborting a wait to hide
        if (phase === 'waiting-to-hide') {
            phase = 'shown';
            (0, $c41d218ca59a254a$export$eaf678f6f93f5250)();
            return;
        }
        // aborting hide animation
        if (phase === 'hide-animating') {
            phase = 'shown';
            (0, $c41d218ca59a254a$export$eaf678f6f93f5250)();
            entry.show({
                isImmediate: false
            });
            return;
        }
    }
    function requestHide(_ref) {
        var isImmediate = _ref.isImmediate;
        if (!isActive()) return;
        // If we were not showing yet anyway; finish straight away
        if (phase === 'waiting-to-show') {
            immediatelyHideAndDone();
            return;
        }
        // already waiting to hide
        if (phase === 'waiting-to-hide') return;
        if (isImmediate) {
            immediatelyHideAndDone();
            return;
        }
        phase = 'waiting-to-hide';
        (0, $c41d218ca59a254a$export$5f4d6617421d489b)(function() {
            phase = 'hide-animating';
            entry.hide({
                isImmediate: false
            });
        }, entry.delay);
    }
    function finishHideAnimation() {
        if (isActive() && phase === 'hide-animating') done();
    }
    function isVisible() {
        return phase === 'shown' || phase === 'waiting-to-hide' || phase === 'hide-animating';
    }
    function getInitialMouse() {
        if (entry.source.type === 'mouse') return entry.source.mouse;
        return null;
    }
    function start() {
        var shouldAlwaysFadeIn = (0, $id6Cu.fg)('platform_dst_nav4_side_nav_resize_tooltip_feedback') ? entry.shouldAlwaysFadeIn : false;
        var showImmediately = Boolean($59257c3cf2f78a4d$var$active && $59257c3cf2f78a4d$var$active.isVisible()) && !shouldAlwaysFadeIn;
        // If there was an active tooltip; we tell it to remove itself at once!
        if ($59257c3cf2f78a4d$var$active) {
            (0, $c41d218ca59a254a$export$eaf678f6f93f5250)();
            $59257c3cf2f78a4d$var$active.entry.hide({
                isImmediate: true
            });
            $59257c3cf2f78a4d$var$active.entry.done();
            $59257c3cf2f78a4d$var$active = null;
        }
        // this tooltip is now the active tooltip
        $59257c3cf2f78a4d$var$active = {
            entry: entry,
            isVisible: isVisible
        };
        function show() {
            phase = 'shown';
            entry.show({
                isImmediate: showImmediately
            });
        }
        if (showImmediately) {
            show();
            return;
        }
        phase = 'waiting-to-show';
        (0, $c41d218ca59a254a$export$5f4d6617421d489b)(show, entry.delay);
    }
    // let's get started!
    start();
    var result = {
        keep: keep,
        abort: cleanup,
        isActive: isActive,
        requestHide: requestHide,
        finishHideAnimation: finishHideAnimation,
        // Removing old `mousePosition` behind gate because it stored a function.
        // With the gate we just store the coords which are easier to work with.
        mousePosition: (0, $id6Cu.fg)('platform_dst_nav4_side_nav_resize_tooltip_feedback') ? undefined : getInitialMouse(),
        mousePos: entry.source.type === 'mouse' && (0, $id6Cu.fg)('platform_dst_nav4_side_nav_resize_tooltip_feedback') ? {
            clientX: entry.source.clientX,
            clientY: entry.source.clientY
        } : null
    };
    return result;
}



var $h8qvJ = parcelRequire("h8qvJ");
function $9dbc54eb0d850599$export$2e2bcd8739ae039(prefix, shouldRenderId) {
    var seed = (0, $h8qvJ.useIdSeed)();
    return shouldRenderId ? "".concat(seed(prefix)) : undefined;
}


/* tooltip-container.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");
/* tooltip-primitive.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");
/* tooltip-shortcut.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");
var $090ea6ae9a048765$var$styles = {
    shortcutSegmentsContainer: "_zulpv77o _1e0c1txw _1q511b66 _85i5v77o",
    shortcutSegment: "_11c8wadc _2rkolb4i _1dqonqa1 _189ee4h9 _1h6d1ihb _1e0c1txw _4cvr1h6o _4t3i1k92 _vchhusvi _1q51v77o _85i5v77o _bozg12x7 _y4ti12x7 _16qsn7od _1254n7od _cgnln7od _syazn7od _ahbqn7od _12l2n7od _1pfhn7od _6rthn7od _1ul9n7od _w19jn7od _bfhk261p"
};
var $090ea6ae9a048765$export$5bcbc43c84236222 = function TooltipShortcut(_ref) {
    var shortcut = _ref.shortcut;
    return /*#__PURE__*/ $5FkrB.createElement("div", {
        className: (0, $970q7.default)([
            $090ea6ae9a048765$var$styles.shortcutSegmentsContainer
        ])
    }, shortcut.map(function(segment, index) {
        return /*#__PURE__*/ $5FkrB.createElement("kbd", {
            key: "".concat(segment, "-").concat(index),
            className: (0, $970q7.default)([
                $090ea6ae9a048765$var$styles.shortcutSegment
            ])
        }, segment);
    }));
};


var $90557aab547daf7e$var$primitiveStyles = null;
/**
 * The lower level component for rendering a tooltip.
 */ var $90557aab547daf7e$var$TooltipPrimitive = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function TooltipPrimitive(_ref, ref) {
    var style = _ref.style, className = _ref.className, children = _ref.children, placement = _ref.placement, testId = _ref.testId, onMouseOut = _ref.onMouseOut, onMouseOver = _ref.onMouseOver, id = _ref.id, shortcut = _ref.shortcut;
    return /*#__PURE__*/ $5FkrB.createElement("div", {
        ref: ref,
        style: style,
        "data-testid": testId ? "".concat(testId, "--wrapper") : undefined
    }, /*#__PURE__*/ $5FkrB.createElement("div", {
        role: "tooltip",
        className: (0, $970q7.default)([
            "_80om73ad",
            className
        ]),
        onMouseOut: onMouseOut,
        onMouseOver: onMouseOver,
        "data-placement": placement,
        "data-testid": testId,
        id: id
    }, children, shortcut && /*#__PURE__*/ $5FkrB.createElement((0, $090ea6ae9a048765$export$5bcbc43c84236222), {
        shortcut: shortcut
    })));
});
$90557aab547daf7e$var$TooltipPrimitive.displayName = 'TooltipPrimitive';
var $90557aab547daf7e$export$2e2bcd8739ae039 = $90557aab547daf7e$var$TooltipPrimitive;


var $5c94a2b9cb31aa0f$var$styles = {
    base: "_2rkofajl _11c8wadc _vchhusvi _p12fp3fh _bfhkgkf6 _syaz15cr _152tze3t _1e02ze3t _1i4q1hna _1q511b66 _85i51b66 _y4ti12x7 _bozg12x7 _slp31hna",
    truncate: "_1reo15vq _18m915vq _p12f1pna _1bto1l2s _o5721q9c"
};
/**
 * Used as the default tooltip container component for the exported `Tooltip` component.
 * Adds some styles to the tooltip primitive.
 */ var $5c94a2b9cb31aa0f$var$TooltipContainer = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function TooltipContainer(_ref, ref) {
    var style = _ref.style, className = _ref.className, children = _ref.children, truncate = _ref.truncate, placement = _ref.placement, testId = _ref.testId, onMouseOut = _ref.onMouseOut, onMouseOver = _ref.onMouseOver, id = _ref.id, shortcut = _ref.shortcut;
    return /*#__PURE__*/ $5FkrB.createElement((0, $90557aab547daf7e$export$2e2bcd8739ae039), {
        ref: ref,
        style: style,
        className: (0, $970q7.default)([
            $5c94a2b9cb31aa0f$var$styles.base,
            truncate && $5c94a2b9cb31aa0f$var$styles.truncate,
            className
        ]),
        placement: placement,
        testId: testId,
        id: id,
        onMouseOut: onMouseOut,
        onMouseOver: onMouseOver,
        shortcut: shortcut
    }, children);
});
$5c94a2b9cb31aa0f$var$TooltipContainer.displayName = 'TooltipContainer';
var $5c94a2b9cb31aa0f$export$2e2bcd8739ae039 = $5c94a2b9cb31aa0f$var$TooltipContainer;


function $ac69b35528df4490$export$642213d516a9b928(mouseCoordinates) {
    var safeMouse = mouseCoordinates || {
        top: 0,
        left: 0
    };
    var getBoundingClientRect = function getBoundingClientRect() {
        return {
            top: safeMouse.top,
            left: safeMouse.left,
            bottom: safeMouse.top,
            right: safeMouse.left,
            width: 0,
            height: 0
        };
    };
    return {
        getBoundingClientRect: getBoundingClientRect,
        clientWidth: 0,
        clientHeight: 0
    };
}
function $ac69b35528df4490$export$2e68479e0a5d8746(mousePos, _ref) {
    var targetElement = _ref.targetElement, tooltipPosition = _ref.tooltipPosition;
    if (tooltipPosition === 'mouse') return {
        getBoundingClientRect: function getBoundingClientRect() {
            return DOMRect.fromRect({
                x: mousePos.clientX,
                y: mousePos.clientY,
                width: 0,
                height: 0
            });
        }
    };
    var targetRect = targetElement.getBoundingClientRect();
    if (tooltipPosition === 'mouse-x') return {
        getBoundingClientRect: function getBoundingClientRect() {
            return DOMRect.fromRect({
                x: mousePos.clientX,
                y: targetRect.top,
                width: 0,
                height: targetRect.height
            });
        }
    };
    if (tooltipPosition === 'mouse-y') return {
        getBoundingClientRect: function getBoundingClientRect() {
            return DOMRect.fromRect({
                x: targetRect.left,
                y: mousePos.clientY,
                width: targetRect.width,
                height: 0
            });
        }
    };
    throw new Error("Invalid tooltip position for virtual element: ".concat(tooltipPosition));
}


function $abccd55e2452d79a$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $abccd55e2452d79a$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $abccd55e2452d79a$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $abccd55e2452d79a$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $abccd55e2452d79a$var$tooltipZIndex = (0, $e9d0322783570723$export$7be255094ccdc533).tooltip();
var $abccd55e2452d79a$var$analyticsAttributes = {
    componentName: 'tooltip',
    packageName: "@atlaskit/tooltip",
    packageVersion: "20.14.1"
};
// Inverts motion direction
var $abccd55e2452d79a$var$invertedDirection = {
    top: 'bottom',
    bottom: 'top',
    left: 'right',
    right: 'left'
};
/**
 * Converts a Popper placement to it's general direction.
 *
 * @param placement - Popper Placement value, e.g. 'top-start'
 * @returns Popper Direction, e.g. 'top'
 */ var $abccd55e2452d79a$var$getDirectionFromPlacement = function getDirectionFromPlacement(placement) {
    return placement.split('-')[0];
};
/**
 * __Tooltip__
 *
 * A tooltip is a floating, non-actionable label used to explain a user interface element or feature.
 */ function $abccd55e2452d79a$var$Tooltip(_ref) {
    var children = _ref.children, _ref$position = _ref.position, position = _ref$position === void 0 ? 'bottom' : _ref$position, _ref$mousePosition = _ref.mousePosition, mousePosition = _ref$mousePosition === void 0 ? 'bottom' : _ref$mousePosition, content = _ref.content, _ref$truncate = _ref.truncate, truncate = _ref$truncate === void 0 ? false : _ref$truncate, _ref$component = _ref.component, Container = _ref$component === void 0 ? (0, $5c94a2b9cb31aa0f$export$2e2bcd8739ae039) : _ref$component, _ref$tag = _ref.tag, TargetContainer = _ref$tag === void 0 ? 'div' : _ref$tag, testId = _ref.testId, _ref$delay = _ref.delay, delay = _ref$delay === void 0 ? 300 : _ref$delay, _ref$onShow = _ref.onShow, onShow = _ref$onShow === void 0 ? (0, $eVb4V.default) : _ref$onShow, _ref$onHide = _ref.onHide, onHide = _ref$onHide === void 0 ? (0, $eVb4V.default) : _ref$onHide, canAppear = _ref.canAppear, _ref$hideTooltipOnCli = _ref.hideTooltipOnClick, hideTooltipOnClick = _ref$hideTooltipOnCli === void 0 ? false : _ref$hideTooltipOnCli, _ref$hideTooltipOnMou = _ref.hideTooltipOnMouseDown, hideTooltipOnMouseDown = _ref$hideTooltipOnMou === void 0 ? false : _ref$hideTooltipOnMou, analyticsContext = _ref.analyticsContext, _ref$strategy = _ref.strategy, strategy = _ref$strategy === void 0 ? 'fixed' : _ref$strategy, _ref$ignoreTooltipPoi = _ref.ignoreTooltipPointerEvents, ignoreTooltipPointerEvents = _ref$ignoreTooltipPoi === void 0 ? false : _ref$ignoreTooltipPoi, _ref$isScreenReaderAn = _ref.isScreenReaderAnnouncementDisabled, isScreenReaderAnnouncementDisabled = _ref$isScreenReaderAn === void 0 ? false : _ref$isScreenReaderAn, shortcut = _ref.shortcut, _ref$UNSAFE_shouldAlw = _ref.UNSAFE_shouldAlwaysFadeIn, shouldAlwaysFadeIn = _ref$UNSAFE_shouldAlw === void 0 ? false : _ref$UNSAFE_shouldAlw, _ref$UNSAFE_shouldRen = _ref.UNSAFE_shouldRenderToParent, UNSAFE_shouldRenderToParent = _ref$UNSAFE_shouldRen === void 0 ? false : _ref$UNSAFE_shouldRen;
    // Not using a gate for this check. When the gate is disabled `mouse-y` and `mouse-x` are treated as `mouse`.
    var isMousePosition = position === 'mouse' || position === 'mouse-y' || position === 'mouse-x';
    var tooltipPosition = isMousePosition ? mousePosition : position;
    var onShowHandler = (0, $33c593f40a34145a$export$1a04351537078b55)($abccd55e2452d79a$var$_objectSpread({
        fn: onShow,
        action: 'displayed',
        analyticsData: analyticsContext
    }, $abccd55e2452d79a$var$analyticsAttributes));
    var onHideHandler = (0, $33c593f40a34145a$export$1a04351537078b55)($abccd55e2452d79a$var$_objectSpread({
        fn: onHide,
        action: 'hidden',
        analyticsData: analyticsContext
    }, $abccd55e2452d79a$var$analyticsAttributes));
    var apiRef = (0, $5FkrB.useRef)(null);
    var _useState = (0, $5FkrB.useState)('hide'), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), state = _useState2[0], setState = _useState2[1];
    var targetRef = (0, $5FkrB.useRef)(null);
    var containerRef = (0, $5FkrB.useRef)(null);
    // This function is deliberately _not_ memoized as it needs to re-run every render
    // to pick up any child ref changes. If you use render props you don't have this issue.
    var setImplicitRefFromChildren = function setImplicitRefFromChildren(node) {
        containerRef.current = node;
        targetRef.current = node ? node.firstElementChild : null;
    };
    // This is memoized and passed into the render props callback.
    var setDirectRef = (0, $5FkrB.useCallback)(function(node) {
        targetRef.current = node;
    }, []);
    // Putting a few things into refs so that we don't have to break memoization
    var stableState = (0, $3UUXy.default)(state);
    // These props are placed in separate refs instead of a single object to reduce memory usage.
    // Placing them in the same object previously caused an increase in the number of JavaScript event listeners
    // before garbage collection.
    var onShowHandlerStable = (0, $3UUXy.default)(onShowHandler);
    var onHideHandlerStable = (0, $3UUXy.default)(onHideHandler);
    var delayStable = (0, $3UUXy.default)(delay);
    var canAppearStable = (0, $3UUXy.default)(canAppear);
    var hasCalledShowHandler = (0, $5FkrB.useRef)(false);
    var shouldAlwaysFadeInStable = (0, $3UUXy.default)(shouldAlwaysFadeIn);
    var start = (0, $5FkrB.useCallback)(function(api) {
        // @ts-ignore
        apiRef.current = api;
        hasCalledShowHandler.current = false;
    }, []);
    var done = (0, $5FkrB.useCallback)(function() {
        if (!apiRef.current) return;
        // Only call onHideHandler if we have called onShowHandler
        if (hasCalledShowHandler.current) onHideHandlerStable.current();
        // @ts-ignore
        apiRef.current = null;
        // @ts-ignore
        hasCalledShowHandler.current = false;
        // just in case
        setState('hide');
    }, [
        onHideHandlerStable
    ]);
    var abort = (0, $5FkrB.useCallback)(function() {
        if (!apiRef.current) return;
        apiRef.current.abort();
        // Only call onHideHandler if we have called onShowHandler
        if (hasCalledShowHandler.current) onHideHandlerStable.current();
        // @ts-ignore
        apiRef.current = null;
    }, [
        onHideHandlerStable
    ]);
    (0, $5FkrB.useEffect)(function mount() {
        return function unmount() {
            if (apiRef.current) abort();
        };
    }, [
        abort
    ]);
    var isDraggingRef = (0, $5FkrB.useRef)(false);
    (0, $5FkrB.useEffect)(function() {
        return (0, $e89b943f2315a15f$export$6503ec6e8aabbaf)({
            onRegister: function onRegister(_ref2) {
                var isDragging = _ref2.isDragging;
                isDraggingRef.current = isDragging;
            },
            onDragStart: function onDragStart() {
                var _apiRef$current;
                /**
         * Hiding any visible tooltips when a drag starts because otherwise it
         * looks janky (disappears and reappears), and is not required.
         */ (_apiRef$current = apiRef.current) === null || _apiRef$current === void 0 || _apiRef$current.requestHide({
                    isImmediate: true
                });
                isDraggingRef.current = true;
            },
            onDragEnd: function onDragEnd() {
                isDraggingRef.current = false;
            }
        });
    }, []);
    var tryShowTooltip = (0, $5FkrB.useCallback)(function(source) {
        var _canAppearStable$curr;
        /**
     * Prevent tooltips from being shown during a drag. This can occur with
     * the native drag and drop API, where some pointer events can fire
     * when they should not and lead to jank with tooltips.
     */ if (isDraggingRef.current) return;
        // Another tooltip is has been active but we still have the old `api`
        // around. We need to finish up the last usage.
        // Note: just being safe - this should not happen
        if (apiRef.current && !apiRef.current.isActive()) abort();
        // This tooltip is already active, we can exit
        if (apiRef.current && apiRef.current.isActive()) {
            apiRef.current.keep();
            return;
        }
        /**
     * Check if tooltip is allowed to show.
     *
     * Once a tooltip has started, or has scheduled to start
     * we won't be checking `canAppear` again.
     *
     * - We don't want tooltips to disappear once they are shown
     * - For consistency, we start after a single positive `canAppear`.
     *   Otherwise the amount of times we ask consumers would depend on
     *   how many times we get a "mousemove", which _could_ lead to situations
     *   where moving the mouse could result in a different outcome to if
     *   the mouse was not moved.
     */ if (canAppearStable.current && !((_canAppearStable$curr = canAppearStable.current) !== null && _canAppearStable$curr !== void 0 && _canAppearStable$curr.call(canAppearStable))) return;
        var entry = {
            source: source,
            delay: delayStable.current,
            show: function show(_ref3) {
                var isImmediate = _ref3.isImmediate;
                // Call the onShow handler if it hasn't been called yet
                if (!hasCalledShowHandler.current) {
                    hasCalledShowHandler.current = true;
                    onShowHandlerStable.current();
                }
                setState(!isImmediate ? 'fade-in' : 'show-immediate');
            },
            hide: function hide(_ref4) {
                var isImmediate = _ref4.isImmediate;
                if (isImmediate) setState('hide');
                else setState('before-fade-out');
            },
            done: done,
            shouldAlwaysFadeIn: (0, $id6Cu.fg)('platform_dst_nav4_side_nav_resize_tooltip_feedback') ? shouldAlwaysFadeInStable.current : false
        };
        var api = (0, $59257c3cf2f78a4d$export$57bf213be019eeb0)(entry);
        start(api);
    }, [
        canAppearStable,
        delayStable,
        done,
        start,
        abort,
        onShowHandlerStable,
        shouldAlwaysFadeInStable
    ]);
    var hideTooltipOnEsc = (0, $5FkrB.useCallback)(function() {
        var _apiRef$current2;
        (_apiRef$current2 = apiRef.current) === null || _apiRef$current2 === void 0 || _apiRef$current2.requestHide({
            isImmediate: true
        });
    }, [
        apiRef
    ]);
    (0, $hy47X.default)({
        onClose: hideTooltipOnEsc,
        isDisabled: state === 'hide' || state === 'fade-out'
    });
    (0, $5FkrB.useEffect)(function() {
        if (state === 'hide') return 0, $eVb4V.default;
        if (state === 'before-fade-out') setState('fade-out');
        var unbind = (0, $7QpUe.bind)(window, {
            type: 'scroll',
            listener: function listener() {
                if (apiRef.current) apiRef.current.requestHide({
                    isImmediate: true
                });
            },
            options: {
                capture: true,
                passive: true,
                once: true
            }
        });
        return unbind;
    }, [
        state
    ]);
    var onMouseDown = (0, $5FkrB.useCallback)(function() {
        if (hideTooltipOnMouseDown && apiRef.current) apiRef.current.requestHide({
            isImmediate: true
        });
    }, [
        hideTooltipOnMouseDown
    ]);
    var onClick = (0, $5FkrB.useCallback)(function() {
        if (hideTooltipOnClick && apiRef.current) apiRef.current.requestHide({
            isImmediate: true
        });
    }, [
        hideTooltipOnClick
    ]);
    // Ideally we would be using onMouseEnter here, but
    // because we are binding the event to the target parent
    // we need to listen for the mouseover of all sub elements
    // This means when moving along a tooltip we are quickly toggling
    // between api.requestHide and api.keep. This it not ideal
    var onMouseOver = (0, $5FkrB.useCallback)(function(event) {
        // Ignoring events from the container ref
        if (containerRef.current && event.target === containerRef.current) return;
        // Using prevent default as a signal that parent tooltips
        if (event.defaultPrevented) return;
        event.preventDefault();
        var source = isMousePosition ? {
            type: 'mouse',
            // TODO: ideally not recalculating this object each time
            // Removing old `mouse` behind gate because it stored a function.
            // With the gate we just store the coords which are easier to work with.
            mouse: (0, $id6Cu.fg)('platform_dst_nav4_side_nav_resize_tooltip_feedback') ? undefined : (0, $ac69b35528df4490$export$642213d516a9b928)({
                left: event.clientX,
                top: event.clientY
            }),
            clientX: event.clientX,
            clientY: event.clientY
        } : {
            type: 'keyboard'
        };
        tryShowTooltip(source);
    }, [
        isMousePosition,
        tryShowTooltip
    ]);
    // Ideally we would be using onMouseEnter here, but
    // because we are binding the event to the target parent
    // we need to listen for the mouseout of all sub elements
    // This means when moving along a tooltip we are quickly toggling
    // between api.requestHide and api.keep. This it not ideal
    var onMouseOut = (0, $5FkrB.useCallback)(function(event) {
        // Ignoring events from the container ref
        if (containerRef.current && event.target === containerRef.current) return;
        // Using prevent default as a signal that parent tooltips
        if (event.defaultPrevented) return;
        event.preventDefault();
        if (apiRef.current) apiRef.current.requestHide({
            isImmediate: false
        });
    }, []);
    var onMouseMove = isMousePosition ? function(event) {
        var _apiRef$current3;
        if ((_apiRef$current3 = apiRef.current) !== null && _apiRef$current3 !== void 0 && _apiRef$current3.isActive()) {
            if (!(0, $id6Cu.fg)('platform_dst_nav4_side_nav_resize_tooltip_feedback')) apiRef.current.mousePosition = (0, $ac69b35528df4490$export$642213d516a9b928)({
                left: event.clientX,
                top: event.clientY
            });
            apiRef.current.mousePos = {
                clientX: event.clientX,
                clientY: event.clientY
            };
        }
    } : undefined;
    var onMouseOverTooltip = (0, $5FkrB.useCallback)(function() {
        if (apiRef.current && apiRef.current.isActive()) {
            apiRef.current.keep();
            return;
        }
    }, []);
    var onFocus = (0, $5FkrB.useCallback)(function(e) {
        // Check if focus-visible
        // Prevents tooltips from showing when focus is not visible,
        // i.e., when focus is moved onto tooltip trigger inside a popup on open
        try {
            if (!e.target.matches(':focus-visible')) return;
        } catch (_unused) {
        // Ignore errors from environments that don't support :focus-visible
        }
        // TODO: this does not play well with `hideTooltipOnMouseDown`
        // as "focus" will occur after the "mousedown".
        tryShowTooltip({
            type: 'keyboard'
        });
    }, [
        tryShowTooltip
    ]);
    var onBlur = (0, $5FkrB.useCallback)(function() {
        if (apiRef.current) apiRef.current.requestHide({
            isImmediate: false
        });
    }, []);
    var onAnimationFinished = (0, $5FkrB.useCallback)(function(transition) {
        // Using lastState here because motion is not picking up the latest value
        if (transition === 'exiting' && stableState.current === 'fade-out' && apiRef.current) // @ts-ignore: refs are writeable
        apiRef.current.finishHideAnimation();
    }, [
        stableState
    ]);
    // Doing a cast because typescript is struggling to narrow the type
    var CastTargetContainer = TargetContainer;
    var shouldRenderTooltipPopup = state !== 'hide' && Boolean(content);
    var shouldRenderHiddenContent = !isScreenReaderAnnouncementDisabled && shouldRenderTooltipPopup;
    var shouldRenderTooltipChildren = state !== 'hide' && state !== 'fade-out';
    var handleOpenLayerObserverCloseSignal = (0, $5FkrB.useCallback)(function() {
        var _apiRef$current4;
        (_apiRef$current4 = apiRef.current) === null || _apiRef$current4 === void 0 || _apiRef$current4.requestHide({
            isImmediate: true
        });
    }, []);
    (0, $iUCre.useNotifyOpenLayerObserver)({
        // Layer is only visually open if both the tooltip popup (container) and children are rendered.
        isOpen: shouldRenderTooltipPopup && shouldRenderTooltipChildren,
        /**
     * We don't strictly need to provide an onClose callback at this time, as there is
     * already code that handles hiding the tooltip when a drag is started (and the only
     * usage right now is closing all layers when the user resizes the side nav).
     *
     * However, for future-proofing and semantic reasons, it makes sense to close the tooltip
     * whenever the open layer observer requests a close.
     */ onClose: handleOpenLayerObserverCloseSignal
    });
    var getReferenceElement = function getReferenceElement() {
        var _apiRef$current5, _apiRef$current6;
        if (isMousePosition && (_apiRef$current5 = apiRef.current) !== null && _apiRef$current5 !== void 0 && _apiRef$current5.mousePos && targetRef.current && (0, $id6Cu.fg)('platform_dst_nav4_side_nav_resize_tooltip_feedback')) return (0, $ac69b35528df4490$export$2e68479e0a5d8746)(apiRef.current.mousePos, {
            targetElement: targetRef.current,
            tooltipPosition: position
        });
        if (isMousePosition && (_apiRef$current6 = apiRef.current) !== null && _apiRef$current6 !== void 0 && _apiRef$current6.mousePosition && !(0, $id6Cu.fg)('platform_dst_nav4_side_nav_resize_tooltip_feedback')) {
            var _apiRef$current7;
            return (_apiRef$current7 = apiRef.current) === null || _apiRef$current7 === void 0 ? void 0 : _apiRef$current7.mousePosition;
        }
        return targetRef.current || undefined;
    };
    var tooltipIdForHiddenContent = (0, $9dbc54eb0d850599$export$2e2bcd8739ae039)('tooltip', shouldRenderHiddenContent);
    var tooltipTriggerProps = {
        onMouseOver: onMouseOver,
        onMouseOut: onMouseOut,
        onMouseMove: onMouseMove,
        onMouseDown: onMouseDown,
        onClick: onClick,
        onFocus: onFocus,
        onBlur: onBlur
    };
    // Don't set `data-testid` unless it's defined, as it's not in the interface.
    if (testId) // Adding `data-testid` to the TriggerProps interface breaks Buttons, so we use type assertion
    tooltipTriggerProps['data-testid'] = "".concat(testId, "--container");
    // This useEffect is purely for managing the aria attribute when using the
    // wrapped children approach.
    var isChildrenAFunction = typeof children === 'function';
    (0, $5FkrB.useEffect)(function() {
        if (isChildrenAFunction) return;
        // If `children` is _not_ a function, we are stepping outside of the public
        // API to add a `aria-describedby` attribute.
        var target = targetRef.current;
        if (!target || !tooltipIdForHiddenContent) return;
        target.setAttribute('aria-describedby', tooltipIdForHiddenContent);
        return function() {
            return target.removeAttribute('aria-describedby');
        };
    }, [
        isChildrenAFunction,
        tooltipIdForHiddenContent
    ]);
    var hiddenContent = shouldRenderHiddenContent ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("span", {
        "data-testid": testId ? "".concat(testId, "-hidden") : undefined,
        hidden: true,
        id: tooltipIdForHiddenContent
    }, typeof content === 'function' ? content({}) : content) : null;
    var PopperWrapper = UNSAFE_shouldRenderToParent && (0, $id6Cu.fg)('platform_dst_nav4_side_nav_resize_tooltip_feedback') ? (0, $5FkrB.Fragment) : $abccd55e2452d79a$var$TooltipPortal;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).Fragment, null, typeof children === 'function' ? /*#__PURE__*/ // once we deprecate the wrapped approach, we can put the aria
    // attribute back into the tooltipTriggerProps and make it required
    // instead of optional in `types`
    (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).Fragment, null, children($abccd55e2452d79a$var$_objectSpread($abccd55e2452d79a$var$_objectSpread({}, tooltipTriggerProps), {}, {
        'aria-describedby': tooltipIdForHiddenContent,
        ref: setDirectRef
    })), hiddenContent) : /*#__PURE__*/ // @ts-ignore
    (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(CastTargetContainer, (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, tooltipTriggerProps, {
        ref: setImplicitRefFromChildren,
        role: "presentation"
    }), children, hiddenContent), shouldRenderTooltipPopup ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(PopperWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $5K5L9.Popper), {
        placement: tooltipPosition,
        referenceElement: getReferenceElement(),
        strategy: strategy
    }, function(_ref5) {
        var ref = _ref5.ref, style = _ref5.style, update = _ref5.update, placement = _ref5.placement;
        // Invert the entrance and exit directions.
        // E.g. a tooltip's position is on the 'right', it should enter from and exit to the 'left'
        // This gives the effect the tooltip is appearing from the target
        var direction = isMousePosition ? undefined : $abccd55e2452d79a$var$invertedDirection[$abccd55e2452d79a$var$getDirectionFromPlacement(placement)];
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $fdeb14207cf3ee90$export$2e2bcd8739ae039), {
            appear: true
        }, shouldRenderTooltipChildren && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $cd25880f7bbea0a3$export$2e2bcd8739ae039), {
            distance: "constant",
            entranceDirection: direction,
            exitDirection: direction,
            onFinish: onAnimationFinished,
            duration: state !== 'show-immediate' ? 'medium' : 'none'
        }, function(_ref6) {
            var className = _ref6.className;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(Container, {
                ref: ref,
                className: "Tooltip ".concat(className),
                style: $abccd55e2452d79a$var$_objectSpread($abccd55e2452d79a$var$_objectSpread({}, style), ignoreTooltipPointerEvents && {
                    pointerEvents: 'none'
                }),
                truncate: truncate,
                placement: tooltipPosition,
                testId: getReferenceElement() ? testId : testId && "".concat(testId, "--unresolved"),
                onMouseOut: onMouseOut,
                onMouseOver: onMouseOverTooltip,
                shortcut: shortcut
            }, typeof content === 'function' ? content({
                update: update
            }) : content);
        }));
    })) : null);
}
var $abccd55e2452d79a$export$2e2bcd8739ae039 = $abccd55e2452d79a$var$Tooltip;
var $abccd55e2452d79a$var$TooltipPortal = function TooltipPortal(_ref7) {
    var children = _ref7.children;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $7ed1ec6058c2caca$export$2e2bcd8739ae039), {
        zIndex: $abccd55e2452d79a$var$tooltipZIndex
    }, children);
};






var $744d288f60bb77dd$var$_excluded = [
    "aria-label",
    "aria-labelledby",
    "analyticsContext",
    "appearance",
    "autoFocus",
    "icon",
    "interactionName",
    "isDisabled",
    "isLoading",
    "isSelected",
    "isTooltipDisabled",
    "label",
    "onClick",
    "onClickCapture",
    "onKeyDownCapture",
    "onKeyUpCapture",
    "onMouseDownCapture",
    "onMouseUpCapture",
    "onPointerDownCapture",
    "onPointerUpCapture",
    "onTouchEndCapture",
    "onTouchStartCapture",
    "shape",
    "spacing",
    "testId",
    "tooltip",
    "type"
], $744d288f60bb77dd$var$_excluded2 = [
    "className",
    "css",
    "as",
    "style"
];
/**
 * __Icon Button__
 *
 * Renders an icon-only button lets people take a common and recognizable action where space is limited.
 *
 * - [Examples](https://atlassian.design/components/button/icon-button/examples)
 * - [Code](https://atlassian.design/components/button/icon-button/code)
 * - [Usage](https://atlassian.design/components/button/icon-button/usage)
 */ var $744d288f60bb77dd$var$IconButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).forwardRef(function Button(_ref, ref) {
    var _tooltip$content;
    var preventedAriaLabel = _ref['aria-label'], ariaLabelledBy = _ref['aria-labelledby'], analyticsContext = _ref.analyticsContext, appearance = _ref.appearance, autoFocus = _ref.autoFocus, icon = _ref.icon, interactionName = _ref.interactionName, isDisabled = _ref.isDisabled, _ref$isLoading = _ref.isLoading, isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading, isSelected = _ref.isSelected, _ref$isTooltipDisable = _ref.isTooltipDisabled, isTooltipDisabled = _ref$isTooltipDisable === void 0 ? true : _ref$isTooltipDisable, label = _ref.label, _onClick = _ref.onClick, onClickCapture = _ref.onClickCapture, onKeyDownCapture = _ref.onKeyDownCapture, onKeyUpCapture = _ref.onKeyUpCapture, onMouseDownCapture = _ref.onMouseDownCapture, onMouseUpCapture = _ref.onMouseUpCapture, onPointerDownCapture = _ref.onPointerDownCapture, onPointerUpCapture = _ref.onPointerUpCapture, onTouchEndCapture = _ref.onTouchEndCapture, onTouchStartCapture = _ref.onTouchStartCapture, shape = _ref.shape, spacing = _ref.spacing, testId = _ref.testId, tooltip = _ref.tooltip, _ref$type = _ref.type, type = _ref$type === void 0 ? 'button' : _ref$type, unsafeRest = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $744d288f60bb77dd$var$_excluded);
    // @ts-expect-error
    var _className = unsafeRest.className, _css = unsafeRest.css, _as = unsafeRest.as, _style = unsafeRest.style, saferRest = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(unsafeRest, $744d288f60bb77dd$var$_excluded2);
    if (isTooltipDisabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $aa6f0a9cd00d5488$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, saferRest, {
        ref: ref,
        appearance: appearance,
        autoFocus: autoFocus,
        isDisabled: isDisabled,
        isLoading: isLoading,
        isSelected: isSelected,
        isIconButton: true,
        isCircle: shape === 'circle',
        hasIconBefore: !!icon,
        spacing: spacing,
        ariaLabelledBy: ariaLabelledBy,
        onClick: _onClick,
        onClickCapture: onClickCapture,
        onKeyDownCapture: onKeyDownCapture,
        onKeyUpCapture: onKeyUpCapture,
        onMouseDownCapture: onMouseDownCapture,
        onMouseUpCapture: onMouseUpCapture,
        onPointerDownCapture: onPointerDownCapture,
        onPointerUpCapture: onPointerUpCapture,
        onTouchStartCapture: onTouchStartCapture,
        onTouchEndCapture: onTouchEndCapture,
        testId: testId,
        componentName: "IconButton",
        analyticsContext: analyticsContext,
        type: type,
        interactionName: interactionName
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $3279464c7324ff68$export$2e2bcd8739ae039), {
        type: "icon",
        isLoading: isLoading
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $ed85b23eca664e45$export$2e2bcd8739ae039), {
        icon: icon
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $8056b266ab217caa$export$2e2bcd8739ae039), null, label)));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $abccd55e2452d79a$export$2e2bcd8739ae039), {
        content: (_tooltip$content = tooltip === null || tooltip === void 0 ? void 0 : tooltip.content) !== null && _tooltip$content !== void 0 ? _tooltip$content : label,
        testId: tooltip === null || tooltip === void 0 ? void 0 : tooltip.testId,
        position: tooltip === null || tooltip === void 0 ? void 0 : tooltip.position,
        delay: tooltip === null || tooltip === void 0 ? void 0 : tooltip.delay,
        onShow: tooltip === null || tooltip === void 0 ? void 0 : tooltip.onShow,
        onHide: tooltip === null || tooltip === void 0 ? void 0 : tooltip.onHide,
        mousePosition: tooltip === null || tooltip === void 0 ? void 0 : tooltip.mousePosition,
        analyticsContext: tooltip === null || tooltip === void 0 ? void 0 : tooltip.analyticsContext,
        strategy: tooltip === null || tooltip === void 0 ? void 0 : tooltip.strategy,
        tag: tooltip === null || tooltip === void 0 ? void 0 : tooltip.tag,
        truncate: tooltip === null || tooltip === void 0 ? void 0 : tooltip.truncate,
        component: tooltip === null || tooltip === void 0 ? void 0 : tooltip.component,
        hideTooltipOnClick: tooltip === null || tooltip === void 0 ? void 0 : tooltip.hideTooltipOnClick,
        hideTooltipOnMouseDown: tooltip === null || tooltip === void 0 ? void 0 : tooltip.hideTooltipOnMouseDown,
        ignoreTooltipPointerEvents: tooltip === null || tooltip === void 0 ? void 0 : tooltip.ignoreTooltipPointerEvents,
        shortcut: tooltip === null || tooltip === void 0 ? void 0 : tooltip.shortcut
    }, function(triggerProps) {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $aa6f0a9cd00d5488$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, saferRest, {
            appearance: appearance,
            autoFocus: autoFocus,
            isDisabled: isDisabled,
            isLoading: isLoading,
            isSelected: isSelected,
            isIconButton: true,
            isCircle: shape === 'circle',
            hasIconBefore: false,
            spacing: spacing,
            ariaLabelledBy: ariaLabelledBy,
            onClick: function onClick(e, analyticsEvent) {
                var _triggerProps$onClick;
                _onClick === null || _onClick === void 0 || _onClick(e, analyticsEvent);
                (_triggerProps$onClick = triggerProps.onClick) === null || _triggerProps$onClick === void 0 || _triggerProps$onClick.call(triggerProps, e);
            },
            onMouseOver: function onMouseOver(e) {
                var _triggerProps$onMouse, _saferRest$onMouseOve;
                (_triggerProps$onMouse = triggerProps.onMouseOver) === null || _triggerProps$onMouse === void 0 || _triggerProps$onMouse.call(triggerProps, e);
                (_saferRest$onMouseOve = saferRest.onMouseOver) === null || _saferRest$onMouseOve === void 0 || _saferRest$onMouseOve.call(saferRest, e);
            },
            onMouseOut: function onMouseOut(e) {
                var _triggerProps$onMouse2, _saferRest$onMouseOut;
                (_triggerProps$onMouse2 = triggerProps.onMouseOut) === null || _triggerProps$onMouse2 === void 0 || _triggerProps$onMouse2.call(triggerProps, e);
                (_saferRest$onMouseOut = saferRest.onMouseOut) === null || _saferRest$onMouseOut === void 0 || _saferRest$onMouseOut.call(saferRest, e);
            },
            onMouseMove: function onMouseMove(e) {
                var _triggerProps$onMouse3, _saferRest$onMouseMov;
                (_triggerProps$onMouse3 = triggerProps.onMouseMove) === null || _triggerProps$onMouse3 === void 0 || _triggerProps$onMouse3.call(triggerProps, e);
                (_saferRest$onMouseMov = saferRest.onMouseMove) === null || _saferRest$onMouseMov === void 0 || _saferRest$onMouseMov.call(saferRest, e);
            },
            onMouseDown: function onMouseDown(e) {
                var _triggerProps$onMouse4, _saferRest$onMouseDow;
                (_triggerProps$onMouse4 = triggerProps.onMouseDown) === null || _triggerProps$onMouse4 === void 0 || _triggerProps$onMouse4.call(triggerProps, e);
                (_saferRest$onMouseDow = saferRest.onMouseDown) === null || _saferRest$onMouseDow === void 0 || _saferRest$onMouseDow.call(saferRest, e);
            },
            onFocus: function onFocus(e) {
                var _triggerProps$onFocus, _saferRest$onFocus;
                (_triggerProps$onFocus = triggerProps.onFocus) === null || _triggerProps$onFocus === void 0 || _triggerProps$onFocus.call(triggerProps, e);
                (_saferRest$onFocus = saferRest.onFocus) === null || _saferRest$onFocus === void 0 || _saferRest$onFocus.call(saferRest, e);
            },
            onBlur: function onBlur(e) {
                var _triggerProps$onBlur, _saferRest$onBlur;
                (_triggerProps$onBlur = triggerProps.onBlur) === null || _triggerProps$onBlur === void 0 || _triggerProps$onBlur.call(triggerProps, e);
                (_saferRest$onBlur = saferRest.onBlur) === null || _saferRest$onBlur === void 0 || _saferRest$onBlur.call(saferRest, e);
            },
            ref: (0, $iO8GM.default)([
                ref,
                triggerProps === null || triggerProps === void 0 ? void 0 : triggerProps.ref
            ].filter(Boolean)),
            onMouseDownCapture: onMouseDownCapture,
            onMouseUpCapture: onMouseUpCapture,
            onKeyDownCapture: onKeyDownCapture,
            onKeyUpCapture: onKeyUpCapture,
            onTouchStartCapture: onTouchStartCapture,
            onTouchEndCapture: onTouchEndCapture,
            onPointerDownCapture: onPointerDownCapture,
            onPointerUpCapture: onPointerUpCapture,
            onClickCapture: onClickCapture,
            type: type,
            testId: testId,
            analyticsContext: analyticsContext,
            interactionName: interactionName,
            componentName: "IconButton"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $3279464c7324ff68$export$2e2bcd8739ae039), {
            type: "icon",
            isLoading: isLoading
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $ed85b23eca664e45$export$2e2bcd8739ae039), {
            icon: icon
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $8056b266ab217caa$export$2e2bcd8739ae039), null, label)));
    });
}));
$744d288f60bb77dd$var$IconButton.displayName = 'IconButton';
var $744d288f60bb77dd$export$2e2bcd8739ae039 = $744d288f60bb77dd$var$IconButton;


/* eslint-disable max-len */ 
var $5FkrB = parcelRequire("5FkrB");

var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");

var $25nEq = parcelRequire("25nEq");
var $9219c05bab3ed5d1$export$4ef52930e33717cd = 'data-theme';
var $9219c05bab3ed5d1$export$a00eac3f8684bcd0 = 'data-color-mode';
var $9219c05bab3ed5d1$export$2112803007239c61 = 'data-contrast-mode';
var $9219c05bab3ed5d1$export$352e418ed5b6193a = 'data-custom-theme';
var $9219c05bab3ed5d1$export$2faeed762aac6741 = 'light';
var $9219c05bab3ed5d1$export$6f0c6fb8c80fcc92 = 'ds';
var $9219c05bab3ed5d1$export$4d0c7bbf80185957 = [
    'opacity',
    'font',
    'space',
    'border'
];
var $9219c05bab3ed5d1$export$dddac1532e822863 = "--".concat($9219c05bab3ed5d1$export$6f0c6fb8c80fcc92, "-token-not-found");
var $9219c05bab3ed5d1$export$9d7b58831ae93caa = "--".concat($9219c05bab3ed5d1$export$6f0c6fb8c80fcc92, "-elevation-surface-current");


var $556f219ca01309c2$var$_ref, $556f219ca01309c2$var$_process, $556f219ca01309c2$var$_process2;
// We can't rely on NODE_ENV === 'test' if its value is already configured by the consumer to some other value, so better to use JEST_WORKER_ID
// https://jestjs.io/docs/environment-variables#jest_worker_id
var $556f219ca01309c2$var$TESTS_MODE = ($556f219ca01309c2$var$_ref = (globalThis === null || globalThis === void 0 || ($556f219ca01309c2$var$_process = globalThis.process) === null || $556f219ca01309c2$var$_process === void 0 || ($556f219ca01309c2$var$_process = $556f219ca01309c2$var$_process.env) === null || $556f219ca01309c2$var$_process === void 0 ? void 0 : $556f219ca01309c2$var$_process.JEST_WORKER_ID) !== undefined, $556f219ca01309c2$var$_ref !== void 0) ? $556f219ca01309c2$var$_ref : false;
var $556f219ca01309c2$var$DEBUG_MODE = !$556f219ca01309c2$var$TESTS_MODE && (globalThis === null || globalThis === void 0 || ($556f219ca01309c2$var$_process2 = globalThis.process) === null || $556f219ca01309c2$var$_process2 === void 0 || ($556f219ca01309c2$var$_process2 = $556f219ca01309c2$var$_process2.env) === null || $556f219ca01309c2$var$_process2 === void 0 ? void 0 : $556f219ca01309c2$var$_process2.NODE_ENV) !== 'production';
var $556f219ca01309c2$export$1c9f709888824e05 = function debug() {
    var _console;
    if (!$556f219ca01309c2$var$DEBUG_MODE) return;
    // eslint-disable-next-line no-console
    (_console = console).debug.apply(_console, arguments);
};



var $3ZMUU = parcelRequire("3ZMUU");
var $223e0bffcecf2e71$var$pkgName = '@atlaskit/platform-feature-flags';
var $223e0bffcecf2e71$export$7e41b1b2bdee3f98 = '__PLATFORM_FEATURE_FLAGS__';
var $223e0bffcecf2e71$var$hasProcessEnv = typeof $3ZMUU !== 'undefined' && typeof $3ZMUU.env !== 'undefined';
// FF global overrides can be configured by test runners or Storybook
var $223e0bffcecf2e71$var$ENV_ENABLE_PLATFORM_FF = $223e0bffcecf2e71$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
// STORYBOOK_ENABLE_PLATFORM_FF is included as storybook only allows env vars prefixed with STORYBOOK
// https://github.com/storybookjs/storybook/issues/12270
var $223e0bffcecf2e71$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF = $223e0bffcecf2e71$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
var $223e0bffcecf2e71$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE = $223e0bffcecf2e71$var$ENV_ENABLE_PLATFORM_FF || $223e0bffcecf2e71$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF;
var $223e0bffcecf2e71$var$DEFAULT_PFF_GLOBAL = {
    // In development mode we want to capture any feature flag checks that happen using the default resolver and log this result when the resolver is replaced.
    // This is because evaluating feature flags when the resolver/FF client is loaded asynchronously could cause unexpected issues.
    earlyResolvedFlags: new Map(),
    booleanResolver: function booleanResolver(flagKey) {
        var unresolvedFlagCount;
        return false;
    }
};
var $223e0bffcecf2e71$var$globalVar = typeof window !== 'undefined' ? window : globalThis;
$223e0bffcecf2e71$var$globalVar[$223e0bffcecf2e71$export$7e41b1b2bdee3f98] = $223e0bffcecf2e71$var$globalVar[$223e0bffcecf2e71$export$7e41b1b2bdee3f98] || $223e0bffcecf2e71$var$DEFAULT_PFF_GLOBAL;
function $223e0bffcecf2e71$export$f2b591175b3e424c(resolver) {
    $223e0bffcecf2e71$var$globalVar[$223e0bffcecf2e71$export$7e41b1b2bdee3f98].booleanResolver = resolver;
    var _globalVar$PFF_GLOBAL;
}
function $223e0bffcecf2e71$export$6333b6aff9fc6275(flagKey) {
    if ($223e0bffcecf2e71$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE) {
        (0, $556f219ca01309c2$export$1c9f709888824e05)('[%s]: The feature flags were enabled while running tests. The flag "%s" will be always enabled.', $223e0bffcecf2e71$var$pkgName, flagKey);
        return true;
    }
    try {
        var _globalVar$PFF_GLOBAL2;
        var result = (_globalVar$PFF_GLOBAL2 = $223e0bffcecf2e71$var$globalVar[$223e0bffcecf2e71$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL2 === void 0 ? void 0 : _globalVar$PFF_GLOBAL2.booleanResolver(flagKey);
        if (typeof result !== 'boolean') {
            // eslint-disable-next-line no-console
            console.warn("".concat(flagKey, " resolved to a non-boolean value, returning false for safety"));
            return false;
        }
        return result;
    } catch (e) {
        return false;
    }
}


function $e53f19c81f613df4$export$ba05d765b8392e5e(flagResolver) {
    (0, $223e0bffcecf2e71$export$f2b591175b3e424c)(flagResolver);
}
function $e53f19c81f613df4$export$470e5c2be1411c89(name) {
    return (0, $223e0bffcecf2e71$export$6333b6aff9fc6275)(name);
}
function $e53f19c81f613df4$export$b40ec24ac8275656(name) {
    return (0, $223e0bffcecf2e71$export$6333b6aff9fc6275)(name);
}


var $41ccb80cbd3d31a9$export$83993de8eb66733 = [
    'light',
    'dark',
    'auto'
];
var $41ccb80cbd3d31a9$export$8ce7e340c74e86c5 = [
    'more',
    'no-preference',
    'auto'
];
var $41ccb80cbd3d31a9$export$7d43e72a58e3283f = [
    'light-increased-contrast',
    'light',
    'light-future',
    'light-brand-refresh',
    'dark',
    'dark-future',
    'dark-increased-contrast',
    'dark-brand-refresh',
    'legacy-light',
    'legacy-dark',
    'spacing',
    'shape',
    'typography-adg3',
    'typography-modernized',
    'typography-refreshed'
];
var $41ccb80cbd3d31a9$export$ba8a43b83ecc69f8 = [];
var $41ccb80cbd3d31a9$export$92ba366331403db2 = [].concat($41ccb80cbd3d31a9$export$7d43e72a58e3283f, $41ccb80cbd3d31a9$export$ba8a43b83ecc69f8);
/**
 * Theme to use a base. This will create the theme as
 * an extension with all token values marked as optional
 * to allow tokens to be overridden as required.
 */ /**
 * Palettes: The set of base tokens a given theme may be populated with.
 * For example: legacy light & dark themes use the "legacyPalette" containing colors from our
 * previous color set.
 */ /**
 * ThemeConfig: the source of truth for all theme meta-data.
 * This object should be used whenever interfacing with themes.
 */ var $41ccb80cbd3d31a9$var$themeConfig = {
    'atlassian-light': {
        id: 'light',
        displayName: 'Light Theme',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'light'
        }
    },
    'atlassian-light-future': {
        id: 'light-future',
        displayName: 'Future Light Theme',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'light'
        },
        override: 'light'
    },
    'atlassian-light-increased-contrast': {
        id: 'light-increased-contrast',
        displayName: 'Light Theme (increased contrast)',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'light'
        },
        extends: 'light',
        increasesContrastFor: 'light'
    },
    'atlassian-dark': {
        id: 'dark',
        displayName: 'Dark Theme',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'dark'
        }
    },
    'atlassian-dark-future': {
        id: 'dark-future',
        displayName: 'Future Dark Theme',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'dark'
        },
        override: 'light'
    },
    'atlassian-dark-increased-contrast': {
        id: 'dark-increased-contrast',
        displayName: 'Dark Theme (increased contrast)',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'dark'
        },
        extends: 'dark',
        increasesContrastFor: 'dark'
    },
    'atlassian-legacy-light': {
        id: 'legacy-light',
        displayName: 'Light Theme (legacy)',
        palette: 'legacyPalette',
        attributes: {
            type: 'color',
            mode: 'light'
        }
    },
    'atlassian-legacy-dark': {
        id: 'legacy-dark',
        displayName: 'Dark Theme (legacy)',
        palette: 'legacyPalette',
        attributes: {
            type: 'color',
            mode: 'dark'
        }
    },
    'atlassian-spacing': {
        id: 'spacing',
        displayName: 'Atlassian Spacing',
        palette: 'spacingScale',
        attributes: {
            type: 'spacing'
        }
    },
    'atlassian-typography-adg3': {
        id: 'typography-adg3',
        displayName: 'ADG3 Typography',
        palette: 'typographyPalette',
        attributes: {
            type: 'typography'
        }
    },
    'atlassian-shape': {
        id: 'shape',
        displayName: 'Atlassian Shape',
        palette: 'shapePalette',
        attributes: {
            type: 'shape'
        }
    },
    'atlassian-typography-modernized': {
        id: 'typography-modernized',
        displayName: 'Atlassian Typography (Modernized)',
        palette: 'typographyPalette',
        attributes: {
            type: 'typography'
        }
    },
    'atlassian-typography-refreshed': {
        id: 'typography-refreshed',
        displayName: 'Atlassian Typography (Refreshed)',
        palette: 'typographyPalette',
        attributes: {
            type: 'typography'
        }
    },
    'atlassian-light-brand-refresh': {
        id: 'light-brand-refresh',
        displayName: 'Light theme (Brand refresh)',
        palette: 'brandRefreshPalette',
        attributes: {
            type: 'color',
            mode: 'light'
        }
    },
    'atlassian-dark-brand-refresh': {
        id: 'dark-brand-refresh',
        displayName: 'Dark theme (Brand refresh)',
        palette: 'brandRefreshPalette',
        attributes: {
            type: 'color',
            mode: 'dark'
        }
    }
};
var $41ccb80cbd3d31a9$export$9aedcfa7336a207 = {
    colorMode: 'auto',
    contrastMode: 'auto',
    dark: 'dark',
    light: 'light',
    shape: undefined,
    spacing: 'spacing',
    typography: function typography() {
        if ((0, $e53f19c81f613df4$export$b40ec24ac8275656)('platform-default-typography-modernized')) return 'typography-modernized';
        return undefined;
    },
    UNSAFE_themeOptions: undefined
};
var /**
 * Represents theme state once mounted to the page
 * (the page doesn't have an "auto" color mode, it's either light or dark)
 */ $41ccb80cbd3d31a9$export$2e2bcd8739ae039 = $41ccb80cbd3d31a9$var$themeConfig;



var $ekGgq = parcelRequire("ekGgq");

var $iYJcE = parcelRequire("iYJcE");

var $4dc03b5b7106bc25$var$themeKinds = [
    'light',
    'dark',
    'spacing',
    'typography',
    'shape'
];
var $4dc03b5b7106bc25$var$customThemeOptions = 'UNSAFE_themeOptions';
var $4dc03b5b7106bc25$var$isThemeKind = function isThemeKind(themeKind) {
    return $4dc03b5b7106bc25$var$themeKinds.find(function(kind) {
        return kind === themeKind;
    }) !== undefined;
};
var $4dc03b5b7106bc25$var$isThemeIds = function isThemeIds(themeId) {
    return (0, $41ccb80cbd3d31a9$export$7d43e72a58e3283f).find(function(id) {
        return id === themeId;
    }) !== undefined;
};
var $4dc03b5b7106bc25$var$isColorMode = function isColorMode(modeId) {
    return [
        'light',
        'dark',
        'auto'
    ].includes(modeId);
};
var $4dc03b5b7106bc25$export$f19b488f7c0547ee = function themeStringToObject(themeState) {
    return themeState.split(' ').map(function(theme) {
        return theme.split(/:([\s\S]*)/);
    }).reduce(function(themeObject, _ref) {
        var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_ref, 2), kind = _ref2[0], id = _ref2[1];
        if (kind === 'colorMode' && $4dc03b5b7106bc25$var$isColorMode(id)) themeObject[kind] = id;
        if ($4dc03b5b7106bc25$var$isThemeKind(kind) && $4dc03b5b7106bc25$var$isThemeIds(id)) // @ts-expect-error FIXME - this is a valid ts error
        themeObject[kind] = id;
        if (kind === $4dc03b5b7106bc25$var$customThemeOptions) try {
            themeObject[$4dc03b5b7106bc25$var$customThemeOptions] = JSON.parse(id);
        } catch (e) {
            new Error('Invalid custom theme string');
        }
        return themeObject;
    }, {});
};
var $4dc03b5b7106bc25$export$62c37ab81302621a = function themeObjectToString(themeState) {
    return Object.entries(themeState).reduce(function(themeString, _ref3) {
        var _ref4 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_ref3, 2), kind = _ref4[0], id = _ref4[1];
        if (// colorMode theme state
        kind === 'colorMode' && typeof id === 'string' && $4dc03b5b7106bc25$var$isColorMode(id) || // custom theme state
        kind === $4dc03b5b7106bc25$var$customThemeOptions && (0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(id) === 'object' || // other theme states
        $4dc03b5b7106bc25$var$isThemeKind(kind) && typeof id === 'string' && $4dc03b5b7106bc25$var$isThemeIds(id)) return themeString + "".concat(themeString ? ' ' : '') + "".concat(kind, ":").concat((0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(id) === 'object' ? JSON.stringify(id) : id);
        return themeString;
    }, '');
};


function $8a2e704ba3a87801$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $8a2e704ba3a87801$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $8a2e704ba3a87801$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $8a2e704ba3a87801$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $8a2e704ba3a87801$var$isThemeColorMode = function isThemeColorMode(colorMode) {
    return (0, $41ccb80cbd3d31a9$export$83993de8eb66733).find(function(mode) {
        return mode === colorMode;
    }) !== undefined;
};
var $8a2e704ba3a87801$var$getGlobalTheme = function getGlobalTheme() {
    if (typeof document === 'undefined') return {};
    var element = document.documentElement;
    var colorMode = element.getAttribute((0, $9219c05bab3ed5d1$export$a00eac3f8684bcd0)) || '';
    var theme = element.getAttribute((0, $9219c05bab3ed5d1$export$4ef52930e33717cd)) || '';
    return $8a2e704ba3a87801$var$_objectSpread($8a2e704ba3a87801$var$_objectSpread({}, (0, $4dc03b5b7106bc25$export$f19b488f7c0547ee)(theme)), $8a2e704ba3a87801$var$isThemeColorMode(colorMode) && {
        colorMode: colorMode
    });
};
var $8a2e704ba3a87801$export$2e2bcd8739ae039 = $8a2e704ba3a87801$var$getGlobalTheme;



var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $25nEq = parcelRequire("25nEq");


/**
 * A MutationObserver which watches the `<html>` element for changes to the theme.
 *
 * In React, use the {@link useThemeObserver `useThemeObserver`} hook instead.
 *
 * @param {function} callback - A callback function which fires when the theme changes.
 *
 * @example
 * ```
 * const observer = new ThemeMutationObserver((theme) => {});
 * observer.observe();
 * ```
 */ var $4e9a166133e557e9$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function ThemeMutationObserver(callback) {
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, ThemeMutationObserver);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "legacyObserver", null);
        this.callback = callback;
        ThemeMutationObserver.callbacks.add(callback);
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(ThemeMutationObserver, [
        {
            key: "observe",
            value: function observe() {
                if (!ThemeMutationObserver.observer) {
                    ThemeMutationObserver.observer = new MutationObserver(function() {
                        var theme = (0, $8a2e704ba3a87801$export$2e2bcd8739ae039)();
                        ThemeMutationObserver.callbacks.forEach(function(callback) {
                            return callback(theme);
                        });
                    });
                    // Observer only needs to be configured once
                    ThemeMutationObserver.observer.observe(document.documentElement, {
                        attributeFilter: [
                            (0, $9219c05bab3ed5d1$export$4ef52930e33717cd),
                            (0, $9219c05bab3ed5d1$export$a00eac3f8684bcd0)
                        ]
                    });
                }
            }
        },
        {
            key: "disconnect",
            value: function disconnect() {
                if (this.callback) ThemeMutationObserver.callbacks.delete(this.callback);
                if (ThemeMutationObserver.callbacks.size === 0 && ThemeMutationObserver.observer) {
                    ThemeMutationObserver.observer.disconnect();
                    ThemeMutationObserver.observer = null;
                }
            }
        }
    ]);
}();
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($4e9a166133e557e9$export$2e2bcd8739ae039, "observer", null);
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($4e9a166133e557e9$export$2e2bcd8739ae039, "callbacks", new Set());


/**
 * A React hook which returns the current themes and color-mode set on `<html>`.
 *
 * @example
 * ```
 * const { colorMode, dark, light, spacing, typography } = useThemeObserver();
 *
 * // Performing side effects when it changes
 * useEffect(() => {
 *   console.log(`The color mode has changed to ${theme.colorMode}`);
 * }, [theme.colorMode]);
 * ```
 */ var $a0365fd0f371a868$var$useThemeObserver = function useThemeObserver() {
    var _useState = (0, $5FkrB.useState)((0, $8a2e704ba3a87801$export$2e2bcd8739ae039)()), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), theme = _useState2[0], setTheme = _useState2[1];
    (0, $5FkrB.useEffect)(function() {
        var observer = new (0, $4e9a166133e557e9$export$2e2bcd8739ae039)(function(theme) {
            return setTheme(theme);
        });
        observer.observe();
        return function() {
            return observer.disconnect();
        };
    }, []);
    return theme;
};
var $a0365fd0f371a868$export$2e2bcd8739ae039 = $a0365fd0f371a868$var$useThemeObserver;


/**
 * These are the default parameters for LogoProps if the user does not specify values.
 */ var $0de94173c2172f93$export$438460117ae6b7ee = {
    iconColor: 'inherit',
    label: '',
    size: 'medium',
    textColor: 'currentColor'
};
var $0de94173c2172f93$export$793fba32aed8942a = {
    iconGradientStart: 'inherit',
    iconGradientStop: 'inherit'
};
var $0de94173c2172f93$export$c647cb0ee6e282fe = {
    xsmall: 16,
    small: 24,
    medium: 32,
    large: 40,
    xlarge: 48
};
var $0de94173c2172f93$export$31d7044b7540a6d8 = $0de94173c2172f93$export$438460117ae6b7ee;


/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ /* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ // Reds
var $44f0f242e9758b94$export$4b84fd0e2c617bd = '#FFEBE6';
var $44f0f242e9758b94$export$b34b069eff244586 = '#FFBDAD';
var $44f0f242e9758b94$export$be802dd0d8b57f35 = '#FF8F73';
var $44f0f242e9758b94$export$60847d42f9da92a6 = '#FF7452';
var $44f0f242e9758b94$export$4a7404f376229999 = '#FF5630';
var $44f0f242e9758b94$export$2010d0fb4295b346 = '#DE350B';
var $44f0f242e9758b94$export$2837b5a1a71d5c02 = '#BF2600';
var $44f0f242e9758b94$export$8d9596b529bbb9cf = '#FFFAE6';
var $44f0f242e9758b94$export$41060a744ab0b7ae = '#FFF0B3';
var $44f0f242e9758b94$export$1cc05bbbf340e559 = '#FFE380';
var $44f0f242e9758b94$export$5aae31392d72caaa = '#FFC400';
var $44f0f242e9758b94$export$c6930421db9fa514 = '#FFAB00';
var $44f0f242e9758b94$export$59619663aa6500fb = '#FF991F';
var $44f0f242e9758b94$export$874739ea9e379ab6 = '#FF8B00';
var $44f0f242e9758b94$export$8a6341c32b6a3ee6 = '#E3FCEF';
var $44f0f242e9758b94$export$69a3bf21b9686c2b = '#ABF5D1';
var $44f0f242e9758b94$export$afbce1382ec95f73 = '#79F2C0';
var $44f0f242e9758b94$export$747d86715d4175de = '#57D9A3';
var $44f0f242e9758b94$export$940e1f69e873f202 = '#36B37E';
var $44f0f242e9758b94$export$a49394138f7b8e85 = '#00875A';
var $44f0f242e9758b94$export$6fa04827ac68a4fb = '#006644';
var $44f0f242e9758b94$export$226de0355ed012f8 = '#DEEBFF';
var $44f0f242e9758b94$export$8c13c2ee36917869 = '#B3D4FF';
var $44f0f242e9758b94$export$ecfc1dff386a3e7a = '#4C9AFF';
var $44f0f242e9758b94$export$215b7063051591f1 = '#2684FF';
var $44f0f242e9758b94$export$e62e8919cca44969 = '#0065FF';
var $44f0f242e9758b94$export$b3de0ae08da2ce64 = '#0052CC';
var $44f0f242e9758b94$export$a6ee3d71bc067634 = '#0747A6';
var $44f0f242e9758b94$export$67f15409e87642a1 = '#669DF1';
var $44f0f242e9758b94$export$f0539dbc42dbb067 = '#8FB8F6';
var $44f0f242e9758b94$export$363e4475840015bb = '#EAE6FF';
var $44f0f242e9758b94$export$4b0a4417ed59760f = '#C0B6F2';
var $44f0f242e9758b94$export$6011520a64d9a187 = '#998DD9';
var $44f0f242e9758b94$export$a7175d4e9206bc80 = '#8777D9';
var $44f0f242e9758b94$export$b48405b95304b5a1 = '#6554C0';
var $44f0f242e9758b94$export$c71e4279dd54a18d = '#5243AA';
var $44f0f242e9758b94$export$147899de772240ec = '#403294';
var $44f0f242e9758b94$export$2cf711fe14c66f06 = '#E6FCFF';
var $44f0f242e9758b94$export$7a8f4d33f6f9772c = '#B3F5FF';
var $44f0f242e9758b94$export$776c9c497ef08533 = '#79E2F2';
var $44f0f242e9758b94$export$69cb3ca10c1e330e = '#00C7E6';
var $44f0f242e9758b94$export$9dc1ef0f3f48059b = '#00B8D9';
var $44f0f242e9758b94$export$7c835c78b6fcdef8 = '#00A3BF';
var $44f0f242e9758b94$export$6036577f95c3877e = '#008DA6';
var $44f0f242e9758b94$export$29a4f05edc054374 = '#FFFFFF';
var $44f0f242e9758b94$export$e655ef011c4aa1a2 = '#FAFBFC';
var $44f0f242e9758b94$export$9fdfb749e33cdf97 = '#F4F5F7';
var $44f0f242e9758b94$export$3e51e8f1440314ba = '#EBECF0';
var $44f0f242e9758b94$export$1ce2d1575d444ceb = '#DFE1E6';
var $44f0f242e9758b94$export$8754fc7e6d8b3000 = '#C1C7D0';
var $44f0f242e9758b94$export$c2e91cbeada39b8b = '#B3BAC5';
var $44f0f242e9758b94$export$5f71e19f3a7ad9de = '#A5ADBA';
var $44f0f242e9758b94$export$eaa8c8a70ac22806 = '#97A0AF';
var $44f0f242e9758b94$export$7c87d337fb91a97d = '#8993A4';
var $44f0f242e9758b94$export$d6447c357493214f = '#7A869A';
var $44f0f242e9758b94$export$f563ee71e9ee74cd = '#6B778C';
var $44f0f242e9758b94$export$e2ef2124cf4024b1 = '#5E6C84';
var $44f0f242e9758b94$export$eece5f492e429f08 = '#505F79';
var $44f0f242e9758b94$export$c39c0fe0f26207ae = '#42526E';
var $44f0f242e9758b94$export$7090862dc3038a9f = '#344563';
var $44f0f242e9758b94$export$ad0bacf983b7ddaa = '#253858';
var $44f0f242e9758b94$export$7d61b15e0da132af = '#172B4D';
var $44f0f242e9758b94$export$fbda843f0a27fe96 = '#091E42';
var $44f0f242e9758b94$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
var $44f0f242e9758b94$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
var $44f0f242e9758b94$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
var $44f0f242e9758b94$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
var $44f0f242e9758b94$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
var $44f0f242e9758b94$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
var $44f0f242e9758b94$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
var $44f0f242e9758b94$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
var $44f0f242e9758b94$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
var $44f0f242e9758b94$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
var $44f0f242e9758b94$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
var $44f0f242e9758b94$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
var $44f0f242e9758b94$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
var $44f0f242e9758b94$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
var $44f0f242e9758b94$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
var $44f0f242e9758b94$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
var $44f0f242e9758b94$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
var $44f0f242e9758b94$export$2f6319cf7d736c2a = '#E6EDFA';
var $44f0f242e9758b94$export$95126bc8884d6634 = '#DCE5F5';
var $44f0f242e9758b94$export$8338d8c35d44ff1 = '#CED9EB';
var $44f0f242e9758b94$export$5368d76ae4fbbda7 = '#B8C7E0';
var $44f0f242e9758b94$export$9f0a771d16ec8d36 = '#ABBBD6';
var $44f0f242e9758b94$export$abcf8c38338b4aa5 = '#9FB0CC';
var $44f0f242e9758b94$export$97e81faa16a182c7 = '#8C9CB8';
var $44f0f242e9758b94$export$bfe21c59123ecf33 = '#7988A3';
var $44f0f242e9758b94$export$ee82aa2ea6a1558 = '#67758F';
var $44f0f242e9758b94$export$682927c6ed76be02 = '#56637A';
var $44f0f242e9758b94$export$91fd9994c5be9757 = '#455166';
var $44f0f242e9758b94$export$d281fbfe3cff2df6 = '#3B475C';
var $44f0f242e9758b94$export$3902c91d8b98a753 = '#313D52';
var $44f0f242e9758b94$export$8e8133c1ba5845b5 = '#283447';
var $44f0f242e9758b94$export$33ff357f6620b39 = '#202B3D';
var $44f0f242e9758b94$export$633847cf062b69e0 = '#1B2638';
var $44f0f242e9758b94$export$9776a6e503bdbf76 = '#121A29';
var $44f0f242e9758b94$export$6c813d5160dff5db = '#0E1624';
var $44f0f242e9758b94$export$3d4f271a500072a = '#0D1424';
var $44f0f242e9758b94$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
var $44f0f242e9758b94$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
var $44f0f242e9758b94$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
var $44f0f242e9758b94$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
var $44f0f242e9758b94$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
var $44f0f242e9758b94$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
var $44f0f242e9758b94$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
var $44f0f242e9758b94$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
var $44f0f242e9758b94$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
var $44f0f242e9758b94$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
var $44f0f242e9758b94$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
var $44f0f242e9758b94$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
var $44f0f242e9758b94$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
var $44f0f242e9758b94$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
var $44f0f242e9758b94$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
var $44f0f242e9758b94$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
var $44f0f242e9758b94$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';
var $44f0f242e9758b94$export$d2adc5dedf09fced = '#292A2E';
var $44f0f242e9758b94$export$f51762073d2bb381 = '#94C748';
var $44f0f242e9758b94$export$95e26d54def96891 = '#B3DF72';


var $50d6276cef9de59f$export$362a25f017e2bc8a = function getColorsFromAppearanceOldLogos(appearance, colorMode) {
    var iconGradientStart, iconGradientStop, iconColor, textColor, atlassianLogoTextColor;
    switch(appearance){
        case 'brand':
            iconGradientStart = (0, $44f0f242e9758b94$export$b3de0ae08da2ce64);
            iconGradientStop = (0, $44f0f242e9758b94$export$215b7063051591f1);
            iconColor = (0, $44f0f242e9758b94$export$215b7063051591f1);
            textColor = "var(--ds-text, ".concat((0, $44f0f242e9758b94$export$7d61b15e0da132af), ")");
            // This is only used for the top level Atlassian wordmark (see AtlassianLogo
            // or AtlassianStartLogo for example), and is only different for the Brand
            // appearance - a bold brand color. For other appearances,
            // atlassianLogoTextColor is the same as textColor.
            atlassianLogoTextColor = (0, $44f0f242e9758b94$export$b3de0ae08da2ce64);
            break;
        case 'neutral':
            iconGradientStart = (0, $44f0f242e9758b94$export$7090862dc3038a9f);
            iconGradientStop = (0, $44f0f242e9758b94$export$d6447c357493214f);
            iconColor = (0, $44f0f242e9758b94$export$d6447c357493214f);
            textColor = (0, $44f0f242e9758b94$export$eece5f492e429f08);
            atlassianLogoTextColor = (0, $44f0f242e9758b94$export$eece5f492e429f08);
            break;
        case 'inverse':
            iconGradientStart = '#FFFFFF66';
            iconGradientStop = '#FFFFFF';
            iconColor = '#FFFFFF';
            textColor = '#FFFFFF';
            atlassianLogoTextColor = '#FFFFFF';
            break;
    }
    if (colorMode === 'dark' && appearance === 'inverse') {
        iconGradientStart = '#161A1D66';
        iconGradientStop = '#161A1D';
        iconColor = '#161A1D';
        textColor = '#161A1D';
        atlassianLogoTextColor = '#161A1D';
    }
    return {
        iconGradientStart: iconGradientStart,
        iconGradientStop: iconGradientStop,
        iconColor: iconColor,
        textColor: textColor,
        atlassianLogoTextColor: atlassianLogoTextColor
    };
};
var $50d6276cef9de59f$export$bbacc3980e0f3029 = function getColorsFromAppearance(appearance, colorMode) {
    var iconColor, textColor, atlassianLogoTextColor;
    if (colorMode === 'dark') switch(appearance){
        case 'brand':
            iconColor = '#357DE8';
            textColor = '#E2E3E4';
            atlassianLogoTextColor = '#357DE8';
            break;
        case 'neutral':
            iconColor = '#96999E';
            textColor = '#BFC1C4';
            atlassianLogoTextColor = '#96999E';
            break;
        case 'inverse':
            iconColor = '#101214';
            textColor = '#101214';
            atlassianLogoTextColor = '#101214';
            break;
    }
    else switch(appearance){
        case 'brand':
            iconColor = '#1868DB';
            textColor = '#101214';
            atlassianLogoTextColor = '#1868DB';
            break;
        case 'neutral':
            iconColor = '#6C6F77';
            textColor = '#3B3D42';
            atlassianLogoTextColor = '#6C6F77';
            break;
        case 'inverse':
            iconColor = (0, $44f0f242e9758b94$export$29a4f05edc054374);
            textColor = (0, $44f0f242e9758b94$export$29a4f05edc054374);
            atlassianLogoTextColor = (0, $44f0f242e9758b94$export$29a4f05edc054374);
            break;
    }
    return {
        iconColor: iconColor,
        textColor: textColor,
        atlassianLogoTextColor: atlassianLogoTextColor
    };
};
var $50d6276cef9de59f$export$7818df200941dbbf = function getColorsForLoom(appearance, colorMode) {
    var iconColor = $50d6276cef9de59f$export$bbacc3980e0f3029(appearance, colorMode).iconColor;
    var textColor = $50d6276cef9de59f$export$bbacc3980e0f3029(appearance, colorMode).textColor;
    if (colorMode === 'dark') switch(appearance){
        case 'brand':
            iconColor = '#625DF5';
            textColor = '#EFF0FF';
            break;
    }
    else switch(appearance){
        case 'brand':
            iconColor = '#625DF5';
            textColor = '#252434';
            break;
    }
    return {
        iconColor: iconColor,
        textColor: textColor
    };
};



var $kqp0i = parcelRequire("kqp0i");

var $25nEq = parcelRequire("25nEq");

var $1Vcia = parcelRequire("1Vcia");

var $iYJcE = parcelRequire("iYJcE");

var $74Zh5 = parcelRequire("74Zh5");

var $c261f4b314386587$var$_excluded = [
    "label",
    "svg",
    "size",
    "appearance",
    "iconColor",
    "textColor",
    "testId"
];
var $c261f4b314386587$var$CSS_VAR_COLOR = '--logo-color';
var $c261f4b314386587$var$CSS_VAR_FILL = '--logo-fill';
var $c261f4b314386587$var$baseWrapperStyles = (0, $74Zh5.css)({
    display: 'inline-block',
    position: 'relative',
    color: "var(".concat($c261f4b314386587$var$CSS_VAR_COLOR, ")"),
    fill: "var(".concat($c261f4b314386587$var$CSS_VAR_FILL, ")"),
    lineHeight: 1,
    userSelect: 'none',
    whiteSpace: 'normal',
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '> svg': {
        height: '100%',
        fill: 'inherit'
    }
});
var $c261f4b314386587$var$stopColorStyles = (0, $74Zh5.css)({
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    stop: {
        stopColor: 'currentColor'
    }
});
var $c261f4b314386587$var$sizeStyles = Object.entries((0, $0de94173c2172f93$export$c647cb0ee6e282fe)).reduce(function(acc, _ref) {
    var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_ref, 2), key = _ref2[0], val = _ref2[1];
    acc[key] = (0, $74Zh5.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        height: "".concat(val, "px")
    });
    return acc;
}, {});
/**
 * __Wrapper__
 *
 * An internal component used by `@atlaskit/logo` to render logo SVGs with correct styles.
 */ var $c261f4b314386587$var$Wrapper = function Wrapper(_ref3) {
    var _ref4;
    var label = _ref3.label, svg = _ref3.svg, size = _ref3.size, appearance = _ref3.appearance, iconColor = _ref3.iconColor, textColor = _ref3.textColor, userDefinedTestId = _ref3.testId, rest = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref3, $c261f4b314386587$var$_excluded);
    // Only required for old logos with gradients, which set gradient values to `inherit` when no appearance is provided
    var shouldApplyStopColor = appearance === undefined;
    var testId = userDefinedTestId && "".concat(userDefinedTestId, "--wrapper");
    return (0, $74Zh5.jsx)("span", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        css: [
            $c261f4b314386587$var$baseWrapperStyles,
            shouldApplyStopColor && $c261f4b314386587$var$stopColorStyles,
            size && $c261f4b314386587$var$sizeStyles[size]
        ],
        "data-testid": testId,
        style: (_ref4 = {}, (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_ref4, $c261f4b314386587$var$CSS_VAR_COLOR, iconColor), (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_ref4, $c261f4b314386587$var$CSS_VAR_FILL, textColor), _ref4),
        "aria-label": label ? label : undefined,
        role: label ? 'img' : undefined,
        dangerouslySetInnerHTML: {
            __html: svg
        }
    }, rest));
};
var $c261f4b314386587$export$2e2bcd8739ae039 = $c261f4b314386587$var$Wrapper;


var $57028745e7fabd90$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor;
    var colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $50d6276cef9de59f$export$bbacc3980e0f3029)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" viewBox=\"0 0 32 32\" focusable=\"false\" aria-hidden=\"true\" xmlns=\"http://www.w3.org/2000/svg\">\n      <path fill=\"".concat(colors.iconColor, "\" d=\"M27.545 24.378 16.96 3.208c-.208-.458-.417-.541-.667-.541-.208 0-.458.083-.708.5-1.5 2.375-2.167 5.125-2.167 8 0 4.001 2.042 7.752 5.042 13.795.334.666.584.791 1.167.791h7.335c.541 0 .833-.208.833-.625 0-.208-.042-.333-.25-.75M12.168 14.377c-.834-1.25-1.084-1.334-1.292-1.334s-.333.083-.708.834L4.875 24.46c-.167.334-.208.459-.208.625 0 .334.291.667.916.667h7.46c.5 0 .875-.416 1.083-1.208.25-1 .334-1.876.334-2.917 0-2.917-1.292-5.751-2.292-7.251\"/>\n    </svg>");
};
var $57028745e7fabd90$export$8a485e2e7ed91e8f = function AtlassianIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Atlassian' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $0de94173c2172f93$export$438460117ae6b7ee).size : _ref2$size, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $0de94173c2172f93$export$438460117ae6b7ee).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $0de94173c2172f93$export$438460117ae6b7ee).textColor : _ref2$textColor, testId = _ref2.testId;
    var _useThemeObserver = (0, $a0365fd0f371a868$export$2e2bcd8739ae039)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $c261f4b314386587$export$2e2bcd8739ae039), {
        appearance: appearance,
        label: label,
        svg: $57028745e7fabd90$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        textColor: textColor,
        size: size,
        testId: testId
    });
};

/* eslint-disable max-len */ 
var $5FkrB = parcelRequire("5FkrB");




var $0ae21ee22a245b70$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconColor: iconColor,
        textColor: textColor,
        // We treat the word "Atlassian" differently to normal product logos, it has a bold brand look
        atlassianLogoTextColor: textColor
    };
    if (appearance) colors = (0, $50d6276cef9de59f$export$bbacc3980e0f3029)(appearance, colorMode);
    return "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 198 32\" focusable=\"false\" aria-hidden=\"true\" height=\"32\" fill=\"none\">\n      <path fill=".concat(colors.iconColor, " d=\"M22.878 24.378 12.293 3.208c-.208-.458-.416-.541-.666-.541-.209 0-.459.083-.709.5-1.5 2.375-2.167 5.125-2.167 8 0 4.001 2.042 7.752 5.043 13.794.333.667.583.792 1.166.792h7.335c.542 0 .833-.208.833-.625 0-.208-.041-.333-.25-.75M7.501 14.377c-.833-1.25-1.083-1.334-1.292-1.334s-.333.083-.708.834L.208 24.46c-.166.334-.208.459-.208.625 0 .334.292.667.917.667h7.46c.5 0 .874-.416 1.083-1.208.25-1 .333-1.876.333-2.917 0-2.917-1.292-5.751-2.292-7.251z\"/>\n      <path fill=").concat(colors.atlassianLogoTextColor, " d=\"M107.447 10.828c0 2.972 1.345 5.308 6.795 6.37 3.185.707 3.893 1.203 3.893 2.265 0 1.061-.708 1.698-2.973 1.698-2.619 0-5.733-.92-7.785-2.123v4.813c1.627.778 3.751 1.698 7.785 1.698 5.662 0 7.856-2.548 7.856-6.228m0 .07c0-3.538-1.84-5.166-7.148-6.298-2.902-.637-3.61-1.274-3.61-2.194 0-1.133 1.062-1.628 2.973-1.628 2.335 0 4.6.708 6.794 1.698v-4.6c-1.557-.779-3.892-1.345-6.653-1.345-5.237 0-7.927 2.265-7.927 5.945m72.475-5.803v20.17h4.318V9.979l1.769 4.035 6.087 11.324h5.379V5.166h-4.247v13.022l-1.628-3.821-4.883-9.201zm-27.319 0h-4.671v20.17h4.671zm-10.05 14.154c0-3.538-1.841-5.166-7.149-6.298-2.902-.637-3.609-1.274-3.609-2.194 0-1.133 1.061-1.628 2.972-1.628 2.336 0 4.601.708 6.795 1.699v-4.6c-1.557-.78-3.893-1.346-6.653-1.346-5.238 0-7.927 2.265-7.927 5.946 0 2.972 1.344 5.308 6.794 6.37 3.185.707 3.893 1.203 3.893 2.264 0 1.062-.708 1.699-2.973 1.699-2.618 0-5.733-.92-7.785-2.123v4.812c1.628.779 3.751 1.699 7.785 1.699 5.592 0 7.857-2.548 7.857-6.3M71.069 5.166v20.17h9.625l1.486-4.387h-6.44V5.166zm-19.039 0v4.317h5.167v15.854h4.741V9.483h5.592V5.166zm-6.866 0h-6.157L32 25.336h5.379l.99-3.396c1.204.353 2.478.566 3.752.566s2.548-.213 3.751-.567l.991 3.398h5.379c-.07 0-7.078-20.171-7.078-20.171M42.05 18.259c-.92 0-1.77-.141-2.548-.354L42.05 9.13l2.548 8.776a9.6 9.6 0 0 1-2.548.354zM97.326 5.166H91.17l-7.078 20.17h5.38l.99-3.396c1.203.353 2.477.566 3.751.566s2.548-.213 3.751-.567l.991 3.398h5.379zm-3.114 13.093c-.92 0-1.77-.141-2.548-.354l2.548-8.776 2.548 8.776a9.6 9.6 0 0 1-2.548.354m75.306-13.093h-6.157l-7.007 20.17h5.379l.991-3.396c1.203.353 2.477.566 3.751.566s2.548-.213 3.751-.567l.991 3.398h5.379zm-3.043 13.093c-.92 0-1.77-.141-2.548-.354l2.548-8.776 2.548 8.776a10 10 0 0 1-2.548.354\"/>\n    </svg>");
};
var $0ae21ee22a245b70$export$765cacec8b0843f3 = function AtlassianLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Atlassian' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $0de94173c2172f93$export$438460117ae6b7ee).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $0de94173c2172f93$export$438460117ae6b7ee).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $0de94173c2172f93$export$438460117ae6b7ee).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $a0365fd0f371a868$export$2e2bcd8739ae039)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $c261f4b314386587$export$2e2bcd8739ae039), {
        appearance: appearance,
        label: label,
        svg: $0ae21ee22a245b70$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};



var $1u6rG = parcelRequire("1u6rG");

var $cRECB = parcelRequire("cRECB");

var $25nEq = parcelRequire("25nEq");

var $lAD7C = parcelRequire("lAD7C");

var $5FkrB = parcelRequire("5FkrB");

var $74Zh5 = parcelRequire("74Zh5");

var $hQ6Uq = parcelRequire("hQ6Uq");

var $ekGgq = parcelRequire("ekGgq");

var $5FkrB = parcelRequire("5FkrB");

var $b5lkZ = parcelRequire("b5lkZ");

var $jZlo3 = parcelRequire("jZlo3");
var $a494a38b5ed4d7d9$var$_process, $a494a38b5ed4d7d9$var$_process2;
// We can't rely on NODE_ENV === 'test' if its value is already configured by the consumer to some other value, so better to use JEST_WORKER_ID
// https://jestjs.io/docs/environment-variables#jest_worker_id
var $a494a38b5ed4d7d9$var$TESTS_MODE = (globalThis === null || globalThis === void 0 || ($a494a38b5ed4d7d9$var$_process = globalThis.process) === null || $a494a38b5ed4d7d9$var$_process === void 0 || ($a494a38b5ed4d7d9$var$_process = $a494a38b5ed4d7d9$var$_process.env) === null || $a494a38b5ed4d7d9$var$_process === void 0 ? void 0 : $a494a38b5ed4d7d9$var$_process.JEST_WORKER_ID) !== undefined;
var $a494a38b5ed4d7d9$var$DEBUG_MODE = !$a494a38b5ed4d7d9$var$TESTS_MODE && (globalThis === null || globalThis === void 0 || ($a494a38b5ed4d7d9$var$_process2 = globalThis.process) === null || $a494a38b5ed4d7d9$var$_process2 === void 0 || ($a494a38b5ed4d7d9$var$_process2 = $a494a38b5ed4d7d9$var$_process2.env) === null || $a494a38b5ed4d7d9$var$_process2 === void 0 ? void 0 : $a494a38b5ed4d7d9$var$_process2.NODE_ENV) !== 'production';
var $a494a38b5ed4d7d9$export$1c9f709888824e05 = function debug() {
    var _console;
    if (!$a494a38b5ed4d7d9$var$DEBUG_MODE) return;
    // eslint-disable-next-line no-console
    (_console = console).debug.apply(_console, arguments);
};



var $3ZMUU = parcelRequire("3ZMUU");
var $6086e5ac12529b5e$var$pkgName = '@atlaskit/platform-feature-flags';
var $6086e5ac12529b5e$export$7e41b1b2bdee3f98 = '__PLATFORM_FEATURE_FLAGS__';
var $6086e5ac12529b5e$var$hasProcessEnv = typeof $3ZMUU !== 'undefined' && typeof $3ZMUU.env !== 'undefined';
// FF global overrides can be configured by test runners or Storybook
var $6086e5ac12529b5e$var$ENV_ENABLE_PLATFORM_FF = $6086e5ac12529b5e$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
// STORYBOOK_ENABLE_PLATFORM_FF is included as storybook only allows env vars prefixed with STORYBOOK
// https://github.com/storybookjs/storybook/issues/12270
var $6086e5ac12529b5e$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF = $6086e5ac12529b5e$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
var $6086e5ac12529b5e$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE = $6086e5ac12529b5e$var$ENV_ENABLE_PLATFORM_FF || $6086e5ac12529b5e$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF;
var $6086e5ac12529b5e$var$DEFAULT_PFF_GLOBAL = {
    booleanResolver: undefined
};
var $6086e5ac12529b5e$var$globalVar = typeof window !== 'undefined' ? window : globalThis;
$6086e5ac12529b5e$var$globalVar[$6086e5ac12529b5e$export$7e41b1b2bdee3f98] = $6086e5ac12529b5e$var$globalVar[$6086e5ac12529b5e$export$7e41b1b2bdee3f98] || $6086e5ac12529b5e$var$DEFAULT_PFF_GLOBAL;
function $6086e5ac12529b5e$export$f2b591175b3e424c(resolver) {
    $6086e5ac12529b5e$var$globalVar[$6086e5ac12529b5e$export$7e41b1b2bdee3f98].booleanResolver = resolver;
}
function $6086e5ac12529b5e$export$6333b6aff9fc6275(flagKey) {
    if ($6086e5ac12529b5e$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE) {
        (0, $a494a38b5ed4d7d9$export$1c9f709888824e05)('[%s]: The feature flags were enabled while running tests. The flag "%s" will be always enabled.', $6086e5ac12529b5e$var$pkgName, flagKey);
        return true;
    }
    try {
        var _globalVar$PFF_GLOBAL, _globalVar$PFF_GLOBAL2, _globalVar$PFF_GLOBAL3;
        // booleanResolver will be empty for products like Trello, Elevate, Recruit etc.
        // Currently only Confluence, Jira and Bitbucket has set it.
        if (((_globalVar$PFF_GLOBAL = $6086e5ac12529b5e$var$globalVar[$6086e5ac12529b5e$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL === void 0 ? void 0 : _globalVar$PFF_GLOBAL.booleanResolver) === undefined || ((_globalVar$PFF_GLOBAL2 = $6086e5ac12529b5e$var$globalVar[$6086e5ac12529b5e$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL2 === void 0 ? void 0 : _globalVar$PFF_GLOBAL2.booleanResolver) === null) // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
        return (0, $jZlo3.default).checkGate(flagKey);
        var result = (_globalVar$PFF_GLOBAL3 = $6086e5ac12529b5e$var$globalVar[$6086e5ac12529b5e$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL3 === void 0 ? void 0 : _globalVar$PFF_GLOBAL3.booleanResolver(flagKey);
        if (typeof result !== 'boolean') {
            // eslint-disable-next-line no-console
            console.warn("".concat(flagKey, " resolved to a non-boolean value, returning false for safety"));
            return false;
        }
        return result;
    } catch (e) {
        return false;
    }
}


function $df03e7cb371a94b8$export$ba05d765b8392e5e(flagResolver) {
    (0, $6086e5ac12529b5e$export$f2b591175b3e424c)(flagResolver);
}
function $df03e7cb371a94b8$export$470e5c2be1411c89(name) {
    return (0, $6086e5ac12529b5e$export$6333b6aff9fc6275)(name);
}
function $df03e7cb371a94b8$export$b40ec24ac8275656(name) {
    return (0, $6086e5ac12529b5e$export$6333b6aff9fc6275)(name);
}


var $4fa12aa31a61e0c7$var$_React$useId;
// Type copied from https://github.com/thearnica/react-uid/blob/0f507fbbdb1ab84acf477ec32698afe3d2191e49/src/hooks.ts#L12
// Copied rather than inferred to make the type transparent
// @ts-ignore - useId is not accessible in React 16
var $4fa12aa31a61e0c7$var$react18UseId = ($4fa12aa31a61e0c7$var$_React$useId = (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).useId) !== null && $4fa12aa31a61e0c7$var$_React$useId !== void 0 ? $4fa12aa31a61e0c7$var$_React$useId : undefined;
function $4fa12aa31a61e0c7$export$f680877a34711e37() {
    if ($4fa12aa31a61e0c7$var$react18UseId && (0, $df03e7cb371a94b8$export$b40ec24ac8275656)('platform.design-system-team.react-18-use-id_mn8q4')) // eslint-disable-next-line react-hooks/rules-of-hooks
    return $4fa12aa31a61e0c7$var$react18UseId();
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return "uid".concat((0, $b5lkZ.useUID)());
}
var $4fa12aa31a61e0c7$export$6be90bcb437e928f = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function(_ref, ref) {
    var children = _ref.children, _ref$postfix = _ref.postfix, postfix = _ref$postfix === void 0 ? '' : _ref$postfix, _ref$prefix = _ref.prefix, prefix = _ref$prefix === void 0 ? '' : _ref$prefix;
    var id = "".concat(prefix).concat($4fa12aa31a61e0c7$export$f680877a34711e37()).concat(postfix);
    (0, $5FkrB.useEffect)(function() {
        if (!ref) return;
        switch((0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(ref)){
            case 'function':
                ref(id);
                break;
            case 'object':
                ref.current = id;
                break;
            default:
                throw new Error("Unreachable case for unsupported type of ref \"".concat((0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(ref), "\""));
        }
    }, [
        id,
        ref
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).Fragment, null, typeof children === 'function' ? children({
        id: id
    }) : children);
});
function $4fa12aa31a61e0c7$export$6ee17796e3d70de2() {
    if ($4fa12aa31a61e0c7$var$react18UseId && (0, $df03e7cb371a94b8$export$b40ec24ac8275656)('platform.design-system-team.react-18-use-id_mn8q4')) {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        var uid = $4fa12aa31a61e0c7$var$react18UseId();
        return function(id) {
            return "".concat(uid, "-").concat(id.toString());
        };
    }
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return (0, $b5lkZ.useUIDSeed)();
}


/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5FkrB = parcelRequire("5FkrB");

var $74Zh5 = parcelRequire("74Zh5");
var $9179ec9f7f8a2038$var$BORDER_WIDTH = 2;
var $9179ec9f7f8a2038$var$baseFocusOutsideStyles = (0, $74Zh5.css)({
    outline: "".concat($9179ec9f7f8a2038$var$BORDER_WIDTH, "px solid ", "var(--ds-border-focused, #2684FF)"),
    outlineOffset: $9179ec9f7f8a2038$var$BORDER_WIDTH
});
var $9179ec9f7f8a2038$var$baseInsetStyles = (0, $74Zh5.css)({
    outlineColor: "var(--ds-border-focused, #2684FF)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    outlineOffset: -$9179ec9f7f8a2038$var$BORDER_WIDTH,
    outlineStyle: 'solid',
    outlineWidth: "var(--ds-border-width-outline, 2px)"
});
var $9179ec9f7f8a2038$var$focusRingStyles = (0, $74Zh5.css)({
    // Focus styles used when :focus-visible isn't supported
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
    '&:focus': $9179ec9f7f8a2038$var$baseFocusOutsideStyles,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
    '&:focus-visible': $9179ec9f7f8a2038$var$baseFocusOutsideStyles,
    // Remove default focus styles for mouse interactions if :focus-visible is supported
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
    '&:focus:not(:focus-visible)': {
        outline: 'none'
    },
    '@media screen and (forced-colors: active), screen and (-ms-high-contrast: active)': {
        '&:focus-visible': {
            outline: '1px solid'
        }
    }
});
var $9179ec9f7f8a2038$var$insetFocusRingStyles = (0, $74Zh5.css)({
    // Focus styles used when :focus-visible isn't supported
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
    '&:focus': $9179ec9f7f8a2038$var$baseInsetStyles,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
    '&:focus-visible': $9179ec9f7f8a2038$var$baseInsetStyles,
    // Remove default focus styles for mouse interactions if :focus-visible is supported
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
    '&:focus:not(:focus-visible)': {
        outline: 'none'
    },
    '@media screen and (forced-colors: active), screen and (-ms-high-contrast: active)': {
        '&:focus-visible': {
            outline: '1px solid',
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
            outlineOffset: '-1px'
        }
    }
});
/**
 * __Focus ring__
 *
 * A focus ring visually indicates the currently focused item.
 *
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/focus-ring)
 *
 * @example
 * ```jsx
 * import FocusRing from '@atlaskit/focus-ring';
 *
 * const InteractiveComponent = () => (
 *   <FocusRing>
 *     <button type="button">Hello</button>
 *   </FocusRing>
 * )
 * ```
 */ var $9179ec9f7f8a2038$var$FocusRing = /*#__PURE__*/ (0, $5FkrB.memo)(function(_ref) {
    var children = _ref.children, isInset = _ref.isInset, focus = _ref.focus;
    var controlledStyles = isInset ? $9179ec9f7f8a2038$var$baseInsetStyles : $9179ec9f7f8a2038$var$baseFocusOutsideStyles;
    var uncontrolledStyles = isInset ? $9179ec9f7f8a2038$var$insetFocusRingStyles : $9179ec9f7f8a2038$var$focusRingStyles;
    var focusCls = typeof focus === 'undefined' ? uncontrolledStyles : focus === 'on' && controlledStyles;
    return (0, $74Zh5.jsx)((0, $74Zh5.ClassNames), null, function(_ref2) {
        var css = _ref2.css, cx = _ref2.cx;
        return (0, $5FkrB.Children).only(// This may look unwieldy but means we skip applying styles / cloning if no className is applicable
        focusCls ? /*#__PURE__*/ // eslint-disable-next-line @repo/internal/react/no-clone-element
        (0, $5FkrB.cloneElement)(children, {
            className: cx([
                css(focusCls),
                children.props.className
            ])
        }) : children);
    });
});
$9179ec9f7f8a2038$var$FocusRing.displayName = 'FocusRing';
var $9179ec9f7f8a2038$export$2e2bcd8739ae039 = $9179ec9f7f8a2038$var$FocusRing;



var $id6Cu = parcelRequire("id6Cu");

var $h0N4L = parcelRequire("h0N4L");

var $25nEq = parcelRequire("25nEq");

var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");

var $74Zh5 = parcelRequire("74Zh5");
var $42f5f93396ee40b4$exports = {};
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::67744cfb74ed451c0181f18c132cbdd7>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty($42f5f93396ee40b4$exports, "__esModule", {
    value: true
});
$42f5f93396ee40b4$exports.default = void 0;

var $42f5f93396ee40b4$var$_react = $42f5f93396ee40b4$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $42f5f93396ee40b4$var$_person = $42f5f93396ee40b4$var$_interopRequireDefault((parcelRequire("6ndzp")));

var $42f5f93396ee40b4$var$_person2 = $42f5f93396ee40b4$var$_interopRequireDefault((parcelRequire("5S8H3")));
function $42f5f93396ee40b4$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for PersonIcon.
 * This component is PersonIcon, with `UNSAFE_fallbackIcon` set to "PersonIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Known uses: representing a person or user, owner, contributor.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $42f5f93396ee40b4$var$PersonIcon = (props)=>/*#__PURE__*/ $42f5f93396ee40b4$var$_react.default.createElement($42f5f93396ee40b4$var$_person.default, Object.assign({
        LEGACY_fallbackIcon: $42f5f93396ee40b4$var$_person2.default
    }, props));
$42f5f93396ee40b4$var$PersonIcon.Name = 'PersonIconMigration';
var $42f5f93396ee40b4$var$_default = $42f5f93396ee40b4$exports.default = $42f5f93396ee40b4$var$PersonIcon;


var $fab0192e59caf120$exports = {};
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::553e71e438a60de37e6f93988cb1bfa5>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty($fab0192e59caf120$exports, "__esModule", {
    value: true
});
$fab0192e59caf120$exports.default = void 0;

var $fab0192e59caf120$var$_react = $fab0192e59caf120$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $fab0192e59caf120$var$_release = $fab0192e59caf120$var$_interopRequireDefault((parcelRequire("kc1v6")));

var $fab0192e59caf120$var$_ship = $fab0192e59caf120$var$_interopRequireDefault((parcelRequire("2CTaT")));
function $fab0192e59caf120$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for ReleaseIcon.
 * This component is ReleaseIcon, with `UNSAFE_fallbackIcon` set to "ShipIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for releases in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $fab0192e59caf120$var$ReleaseIcon = (props)=>/*#__PURE__*/ $fab0192e59caf120$var$_react.default.createElement($fab0192e59caf120$var$_release.default, Object.assign({
        LEGACY_fallbackIcon: $fab0192e59caf120$var$_ship.default
    }, props));
$fab0192e59caf120$var$ReleaseIcon.Name = 'ReleaseIconMigration';
var $fab0192e59caf120$var$_default = $fab0192e59caf120$exports.default = $fab0192e59caf120$var$ReleaseIcon;



var $6ndzp = parcelRequire("6ndzp");

var $kc1v6 = parcelRequire("kc1v6");

var $id6Cu = parcelRequire("id6Cu");

var $h0N4L = parcelRequire("h0N4L");
// eslint-disable-next-line @atlaskit/design-system/no-deprecated-imports

var $7LfsS = parcelRequire("7LfsS");
var $f8f43305fb76f612$export$9a270941bcff7e77 = {
    xsmall: (0, $7LfsS.gridSize)() * 2,
    small: (0, $7LfsS.gridSize)() * 3,
    medium: (0, $7LfsS.gridSize)() * 4,
    large: (0, $7LfsS.gridSize)() * 5,
    xlarge: (0, $7LfsS.gridSize)() * 12,
    xxlarge: (0, $7LfsS.gridSize)() * 16
};
var $f8f43305fb76f612$export$e6da6efe4d1a5c9b = {
    xsmall: 2,
    small: 2,
    medium: 3,
    large: 3,
    xlarge: 6,
    xxlarge: 12
};
var $f8f43305fb76f612$export$e2bd4c1faded7921 = 2;
var $f8f43305fb76f612$export$89a980dfdf90df51 = 0.9;
var $f8f43305fb76f612$export$3c061e31594ebabe = '--avatar-background-color';
var $f8f43305fb76f612$export$fdc820179f1f9be4 = {
    small: 12,
    medium: 14,
    large: 15,
    xlarge: 18
};
var $f8f43305fb76f612$export$382610e783aa2ae8 = {
    small: 0,
    medium: 0,
    large: 1,
    xlarge: 7
};


function $482afe0e6891cf2c$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $482afe0e6891cf2c$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $482afe0e6891cf2c$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $482afe0e6891cf2c$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $482afe0e6891cf2c$var$avatarDefaultIconStyles = (0, $74Zh5.css)({
    display: 'flex',
    width: '100%',
    height: '100%',
    backgroundColor: "var(--ds-icon-subtle, ".concat((0, $h0N4L.N90), ")")
});
var $482afe0e6891cf2c$var$avatarDefaultIconVisualRefreshStyles = (0, $74Zh5.css)({
    display: 'flex',
    width: '100%',
    height: '100%',
    backgroundColor: "var(--ds-background-accent-gray-subtler, #DCDFE4)"
});
var $482afe0e6891cf2c$var$nestedAvatarStyles = Object.entries((0, $f8f43305fb76f612$export$9a270941bcff7e77)).reduce(function(styles, _ref) {
    var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_ref, 2), key = _ref2[0], size = _ref2[1];
    return $482afe0e6891cf2c$var$_objectSpread($482afe0e6891cf2c$var$_objectSpread({}, styles), {}, (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, key, (0, $74Zh5.css)({
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '& svg': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            width: "".concat(size, "px"),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            height: "".concat(size, "px")
        }
    })));
}, {});
var $482afe0e6891cf2c$var$avatarImageStyles = (0, $74Zh5.css)({
    display: 'flex',
    width: '100%',
    height: '100%',
    flex: '1 1 100%'
});
/**
 * __Avatar image__
 *
 * An avatar image is an internal component used to control the rendering phases of an image.
 */ var $482afe0e6891cf2c$var$AvatarImage = function AvatarImage(_ref3) {
    var _ref3$alt = _ref3.alt, alt = _ref3$alt === void 0 ? '' : _ref3$alt, src = _ref3.src, appearance = _ref3.appearance, size = _ref3.size, testId = _ref3.testId;
    var _useState = (0, $5FkrB.useState)(false), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), hasImageErrored = _useState2[0], setHasImageErrored = _useState2[1];
    var borderRadius = appearance === 'circle' ? '50%' : "".concat((0, $f8f43305fb76f612$export$e6da6efe4d1a5c9b)[size], "px");
    var isHidden = !alt ? true : undefined;
    // If src changes, reset state
    (0, $5FkrB.useEffect)(function() {
        setHasImageErrored(false);
    }, [
        src
    ]);
    if (!src || hasImageErrored) return (0, $74Zh5.jsx)("span", {
        css: [
            (0, $id6Cu.fg)('platform-component-visual-refresh') ? $482afe0e6891cf2c$var$avatarDefaultIconVisualRefreshStyles : $482afe0e6891cf2c$var$avatarDefaultIconStyles,
            $482afe0e6891cf2c$var$nestedAvatarStyles[size]
        ]
    }, appearance === 'circle' ? (0, $id6Cu.fg)('platform-component-visual-refresh') ? (0, $74Zh5.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6ndzp))), {
        label: alt,
        color: "var(--ds-icon-subtle, #626F86)",
        testId: testId && "".concat(testId, "--person"),
        spacing: "spacious"
    }) : (0, $74Zh5.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($42f5f93396ee40b4$exports))), {
        label: alt,
        color: "var(--ds-icon-inverse, ".concat((0, $h0N4L.N0), ")"),
        LEGACY_secondaryColor: "var(--ds-icon-subtle, ".concat((0, $h0N4L.N90), ")"),
        testId: testId && "".concat(testId, "--person"),
        spacing: "spacious"
    }) : (0, $id6Cu.fg)('platform-component-visual-refresh') ? (0, $74Zh5.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($kc1v6))), {
        label: alt,
        color: "var(--ds-icon-subtle, #626F86)",
        testId: testId && "".concat(testId, "--ship"),
        spacing: "spacious"
    }) : (0, $74Zh5.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($fab0192e59caf120$exports))), {
        label: alt,
        color: "var(--ds-icon-inverse, ".concat((0, $h0N4L.N0), ")"),
        LEGACY_secondaryColor: "var(--ds-icon-subtle, ".concat((0, $h0N4L.N90), ")"),
        testId: testId && "".concat(testId, "--ship"),
        spacing: "spacious"
    }));
    return (0, $74Zh5.jsx)("img", {
        src: src,
        alt: alt,
        "data-testid": testId && "".concat(testId, "--image"),
        css: $482afe0e6891cf2c$var$avatarImageStyles,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            borderRadius: borderRadius
        },
        onError: function onError() {
            return setHasImageErrored(true);
        },
        "aria-hidden": isHidden,
        "data-vc": testId ? "".concat(testId, "--image") : 'avatar-image',
        "data-ssr-placeholder-ignored": true
    });
};
var $482afe0e6891cf2c$export$2e2bcd8739ae039 = $482afe0e6891cf2c$var$AvatarImage;




var $5FkrB = parcelRequire("5FkrB");
var $e398fef1b16a23dd$export$a20dad690e1279e2 = /*#__PURE__*/ (0, $5FkrB.createContext)(undefined);
var $e398fef1b16a23dd$export$b50b87a1c4086b23 = function useAvatarContext() {
    return (0, $5FkrB.useContext)($e398fef1b16a23dd$export$a20dad690e1279e2);
};



var $5FkrB = parcelRequire("5FkrB");

var $h0N4L = parcelRequire("h0N4L");

/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $74Zh5 = parcelRequire("74Zh5");

var $h0N4L = parcelRequire("h0N4L");

var $63f44751a608f2e3$var$iconWrapperStyles = (0, $74Zh5.css)({
    display: 'flex',
    boxSizing: 'border-box',
    width: '100%',
    height: '100%',
    alignItems: 'center',
    alignContent: 'center',
    borderRadius: "var(--ds-border-radius-circle, 50%)",
    overflow: 'hidden'
});
/**
 * __Icon wrapper__
 *
 * An icon wrapper is used internally only.
 */ var $63f44751a608f2e3$var$IconWrapper = function IconWrapper(_ref) {
    var _ref$bgColor = _ref.bgColor, bgColor = _ref$bgColor === void 0 ? "var(--ds-surface-overlay, ".concat((0, $h0N4L.N0), ")") : _ref$bgColor, children = _ref.children;
    return (0, $74Zh5.jsx)("span", {
        css: $63f44751a608f2e3$var$iconWrapperStyles,
        role: "presentation",
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            border: "".concat((0, $f8f43305fb76f612$export$e2bd4c1faded7921), "px solid ").concat(bgColor),
            backgroundColor: bgColor
        }
    }, children);
};
var $63f44751a608f2e3$export$2e2bcd8739ae039 = $63f44751a608f2e3$var$IconWrapper;


var $113fe5757471baec$var$BusyIndicator = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $5FkrB.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("circle", {
    fill: "var(--ds-icon-danger, ".concat((0, $h0N4L.R300), ")"),
    cx: "4",
    cy: "4",
    r: "4"
}), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("path", {
    fill: "var(--ds-surface-overlay, ".concat((0, $h0N4L.N0), ")"),
    d: "M3.3,1.9l2.8,2.8c0.2,0.2,0.2,0.5,0,0.7L5.4,6.1c-0.2,0.2-0.5,0.2-0.7,0L1.9,3.3c-0.2-0.2-0.2-0.5,0-0.7l0.7-0.7C2.8,1.7,3.1,1.7,3.3,1.9z"
}));
var $113fe5757471baec$var$FocusIndicator = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $5FkrB.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("path", {
    fill: "var(--ds-icon-discovery, ".concat((0, $h0N4L.P300), ")"),
    d: "M4,8 C1.790861,8 0,6.209139 0,4 C0,1.790861 1.790861,0 4,0 C6.209139,0 8,1.790861 8,4 C8,6.209139 6.209139,8 4,8 Z M4,6.66666667 C5.47275933,6.66666667 6.66666667,5.47275933 6.66666667,4 C6.66666667,2.52724067 5.47275933,1.33333333 4,1.33333333 C2.52724067,1.33333333 1.33333333,2.52724067 1.33333333,4 C1.33333333,5.47275933 2.52724067,6.66666667 4,6.66666667 Z M4,5.33333333 C3.26362033,5.33333333 2.66666667,4.73637967 2.66666667,4 C2.66666667,3.26362033 3.26362033,2.66666667 4,2.66666667 C4.73637967,2.66666667 5.33333333,3.26362033 5.33333333,4 C5.33333333,4.73637967 4.73637967,5.33333333 4,5.33333333 Z"
}));
var $113fe5757471baec$var$OfflineIndicator = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $5FkrB.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("path", {
    fill: "var(--ds-text-subtlest, ".concat((0, $h0N4L.N200), ")"),
    d: "M4,8 C6.209139,8 8,6.209139 8,4 C8,1.790861 6.209139,0 4,0 C1.790861,0 0,1.790861 0,4 C0,6.209139 1.790861,8 4,8 Z M4,6 C5.1045695,6 6,5.1045695 6,4 C6,2.8954305 5.1045695,2 4,2 C2.8954305,2 2,2.8954305 2,4 C2,5.1045695 2.8954305,6 4,6 Z"
}), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("path", {
    fill: "var(--ds-surface-overlay, ".concat((0, $h0N4L.N40), ")"),
    d: "M4,6 C5.1045695,6 6,5.1045695 6,4 C6,2.8954305 5.1045695,2 4,2 C2.8954305,2 2,2.8954305 2,4 C2,5.1045695 2.8954305,6 4,6 Z"
}));
var $113fe5757471baec$var$OnlineIndicator = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("circle", {
    fill: "var(--ds-icon-success, ".concat((0, $h0N4L.G300), ")"),
    cx: "4",
    cy: "4",
    r: "4"
});
function $113fe5757471baec$var$getPresence(presence) {
    switch(presence){
        case 'busy':
            return $113fe5757471baec$var$BusyIndicator;
        case 'focus':
            return $113fe5757471baec$var$FocusIndicator;
        case 'offline':
            return $113fe5757471baec$var$OfflineIndicator;
        case 'online':
            return $113fe5757471baec$var$OnlineIndicator;
    }
}
/**
 * __Avatar presence__
 *
 * A presence shows an avatar’s availability.
 *
 * - [Examples](https://atlassian.design/components/avatar/avatar-presence/examples)
 * - [Code](https://atlassian.design/components/avatar/avatar-presence/code)
 * - [Usage](https://atlassian.design/components/avatar/avatar-presence/usage)
 */ var $113fe5757471baec$var$AvatarPresence = function AvatarPresence(_ref) {
    var borderColor = _ref.borderColor, children = _ref.children, presence = _ref.presence;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $63f44751a608f2e3$export$2e2bcd8739ae039), {
        bgColor: borderColor
    }, presence ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("svg", {
        height: "100%",
        version: "1.1",
        viewBox: "0 0 8 8",
        width: "100%",
        xmlns: "http://www.w3.org/2000/svg"
    }, $113fe5757471baec$var$getPresence(presence)) : children);
};
var $113fe5757471baec$export$2e2bcd8739ae039 = $113fe5757471baec$var$AvatarPresence;
var $113fe5757471baec$export$972c5e90200fa0ef = function PresenceWrapper(_ref2) {
    var size = _ref2.size, appearance = _ref2.appearance, children = _ref2.children, borderColor = _ref2.borderColor, presence = _ref2.presence, testId = _ref2.testId;
    var position = appearance === 'square' ? -4 : (0, $f8f43305fb76f612$export$382610e783aa2ae8)[size];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("span", {
        "aria-hidden": "true",
        "data-testid": testId && "".concat(testId, "--presence"),
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            pointerEvents: 'none',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            position: 'absolute',
            bottom: "".concat(position, "px"),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            height: "".concat((0, $f8f43305fb76f612$export$fdc820179f1f9be4)[size], "px"),
            right: "".concat(position, "px"),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            width: "".concat((0, $f8f43305fb76f612$export$fdc820179f1f9be4)[size], "px")
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement($113fe5757471baec$var$AvatarPresence, {
        borderColor: borderColor,
        presence: !children ? presence : undefined
    }, children));
};



var $5FkrB = parcelRequire("5FkrB");

var $h0N4L = parcelRequire("h0N4L");


var $bea5311ec8afcaed$var$ApprovedIndicator = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $5FkrB.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("circle", {
    fill: "var(--ds-icon-success, ".concat((0, $h0N4L.G400), ")"),
    cx: "4",
    cy: "4",
    r: "4"
}), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("path", {
    fill: "var(--ds-surface-overlay, ".concat((0, $h0N4L.N0), ")"),
    d: "M2.47140452,3.52859548 C2.21105499,3.26824595 1.78894501,3.26824595 1.52859548,3.52859548 C1.26824595,3.78894501 1.26824595,4.21105499 1.52859548,4.47140452 L2.86192881,5.80473785 C3.12227834,6.06508738 3.54438833,6.06508738 3.80473785,5.80473785 L6.47140452,3.13807119 C6.73175405,2.87772166 6.73175405,2.45561167 6.47140452,2.19526215 C6.21105499,1.93491262 5.78894501,1.93491262 5.52859548,2.19526215 L3.33333333,4.39052429 L2.47140452,3.52859548 Z"
}));
var $bea5311ec8afcaed$var$DeclinedIndicator = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $5FkrB.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("circle", {
    fill: "var(--ds-icon-danger, ".concat((0, $h0N4L.R400), ")"),
    cx: "4",
    cy: "4",
    r: "4"
}), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("path", {
    fill: "var(--ds-surface-overlay, ".concat((0, $h0N4L.N0), ")"),
    d: "M4.890661,4.0088336 L5.81806461,3.07802178 C6.06167933,2.83351177 6.06048933,2.43826992 5.81540668,2.19522442 C5.57032402,1.95217891 5.17415651,1.95336612 4.93054179,2.19787613 L4.00765946,3.12415007 L3.06906871,2.18377143 C2.82523777,1.93947602 2.42906937,1.93863765 2.18420182,2.18189887 C1.93933427,2.42516008 1.93849394,2.82040282 2.18232488,3.06469822 L3.12544091,4.00961077 L2.20275024,4.93569234 C1.95913552,5.18020236 1.96032551,5.5754442 2.20540817,5.81848971 C2.45049083,6.06153521 2.84665833,6.060348 3.09027306,5.81583799 L4.00844245,4.89429431 L4.9092123,5.79678001 C5.15304324,6.04107541 5.54921164,6.04191379 5.79407919,5.79865257 C6.03894674,5.55539135 6.03978708,5.16014862 5.79595614,4.91585321 L4.890661,4.0088336 Z"
}));
var $bea5311ec8afcaed$var$LockedIndicator = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $5FkrB.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("circle", {
    fill: "var(--ds-text-subtlest, ".concat((0, $h0N4L.N40), ")"),
    cx: "4",
    cy: "4",
    r: "4"
}), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("path", {
    fill: "var(--ds-surface-overlay, ".concat((0, $h0N4L.N500), ")"),
    d: "M4.13074827,1.21766493 L4.10368158,1.21766493 C3.36340745,1.21766493 2.76388015,1.80793503 2.76388015,2.5367787 L2.76388015,3.21632216 L3.44054754,3.21632216 L3.44054754,2.54344089 C3.44054754,2.17901906 3.74031119,1.88388401 4.11044825,1.88388401 L4.1239816,1.88388401 C4.49411866,1.88388401 4.79388232,2.17901906 4.79388232,2.54344089 L4.79388232,3.21632216 L5.47054971,3.21632216 L5.47054971,2.5367787 C5.47054971,1.80793503 4.8710224,1.21766493 4.13074827,1.21766493 M2.76388015,3.21632216 L3.44054754,3.21632216 L3.44054754,3.88254123 L2.76388015,3.88254123 L2.76388015,3.21632216 Z M4.79388232,3.21632216 L5.47054971,3.21632216 L5.47054971,3.88254123 L4.79388232,3.88254123 L4.79388232,3.21632216 Z M4.79401765,3.88254123 L3.44068287,3.88254123 L2.76401548,3.88254123 C2.39049508,3.88254123 2.08734809,4.18100738 2.08734809,4.54876031 L2.08734809,5.54808892 C2.08734809,6.10000287 2.53735205,6.54741753 3.09094491,6.54741753 L5.14375561,6.54741753 C5.69802683,6.54741753 6.14735243,6.10385072 6.14735243,5.54808892 L6.14735243,4.54876031 C6.14735243,4.18100738 5.84420544,3.88254123 5.47068504,3.88254123 L4.79401765,3.88254123 Z"
}));
function $bea5311ec8afcaed$var$getStatus(status) {
    switch(status){
        case 'approved':
            return $bea5311ec8afcaed$var$ApprovedIndicator;
        case 'declined':
            return $bea5311ec8afcaed$var$DeclinedIndicator;
        case 'locked':
            return $bea5311ec8afcaed$var$LockedIndicator;
    }
}
/**
 * __Avatar status__
 *
 * An avatar status shows contextual information, such as if someone approves or declines something.
 *
 * - [Examples](https://atlassian.design/components/avatar/avatar-status/examples)
 * - [Code](https://atlassian.design/components/avatar/avatar-status/code)
 */ var $bea5311ec8afcaed$var$AvatarStatus = function AvatarStatus(_ref) {
    var borderColor = _ref.borderColor, children = _ref.children, status = _ref.status;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $63f44751a608f2e3$export$2e2bcd8739ae039), {
        bgColor: borderColor
    }, status ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("svg", {
        height: "100%",
        version: "1.1",
        viewBox: "0 0 8 8",
        width: "100%",
        xmlns: "http://www.w3.org/2000/svg"
    }, $bea5311ec8afcaed$var$getStatus(status)) : children);
};
var $bea5311ec8afcaed$export$2e2bcd8739ae039 = $bea5311ec8afcaed$var$AvatarStatus;
var $bea5311ec8afcaed$export$8045894f255f9726 = function StatusWrapper(_ref2) {
    var size = _ref2.size, status = _ref2.status, appearance = _ref2.appearance, borderColor = _ref2.borderColor, children = _ref2.children, testId = _ref2.testId;
    var position = appearance === 'square' ? 0 : (0, $f8f43305fb76f612$export$382610e783aa2ae8)[size];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("span", {
        "aria-hidden": "true",
        "data-testid": testId && "".concat(testId, "--status"),
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            position: 'absolute',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            height: "".concat((0, $f8f43305fb76f612$export$fdc820179f1f9be4)[size], "px"),
            right: "".concat(position, "px"),
            top: "".concat(position, "px"),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            width: "".concat((0, $f8f43305fb76f612$export$fdc820179f1f9be4)[size], "px")
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement($bea5311ec8afcaed$var$AvatarStatus, {
        borderColor: borderColor,
        status: !children ? status : undefined
    }, children));
};


var $9129027a73d5e17b$export$60113ebe1cf0ecf = function getLinkProps(href, target) {
    return {
        href: href,
        rel: target === '_blank' ? 'noopener noreferrer' : null,
        target: target
    };
};
var $9129027a73d5e17b$export$cca6f1bef43616d3 = function getButtonProps(onClick) {
    return {
        type: 'button',
        onClick: onClick
    };
};
var $9129027a73d5e17b$export$83ee468102cdf04c = function getCustomElement(isDisabled, href, onClick) {
    if (href && !isDisabled) return 'a';
    if (onClick || isDisabled) return 'button';
    return 'span';
};


var $de63f1e4c3afcd22$var$_templateObject;
function $de63f1e4c3afcd22$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $de63f1e4c3afcd22$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $de63f1e4c3afcd22$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $de63f1e4c3afcd22$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $de63f1e4c3afcd22$var$packageName = "@atlaskit/avatar";
var $de63f1e4c3afcd22$var$packageVersion = "21.18.4";
var $de63f1e4c3afcd22$var$getTestId = function getTestId(testId, children) {
    return !children ? {
        'data-testid': "".concat(testId, "--inner")
    } : {
        testId: "".concat(testId, "--inner")
    };
};
// eslint-disable-next-line @repo/internal/react/consistent-types-definitions
var $de63f1e4c3afcd22$var$getStyles = function getStyles(css, _ref) {
    var size = _ref.size, radius = _ref.radius, appearance = _ref.appearance, _ref$borderColor = _ref.borderColor, borderColor = _ref$borderColor === void 0 ? (0, $id6Cu.fg)('platform-component-visual-refresh') ? "var(--ds-surface, #FFFFFF)" : "var(--ds-surface-overlay, ".concat((0, $h0N4L.N0), ")") : _ref$borderColor, stackIndex = _ref.stackIndex, isInteractive = _ref.isInteractive, isDisabled = _ref.isDisabled;
    return css($de63f1e4c3afcd22$var$_templateObject || ($de63f1e4c3afcd22$var$_templateObject = (0, (/*@__PURE__*/$parcel$interopDefault($lAD7C)))([
        "\n\t\theight: ",
        "px;\n\t\twidth: ",
        "px;\n\t\talign-items: stretch;\n\t\tbackground-color: ",
        ";\n\t\tborder-radius: ",
        ";\n\t\tbox-sizing: content-box;\n\t\tcursor: inherit;\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\tjustify-content: center;\n\t\toutline: none;\n\t\toverflow: hidden;\n\t\tposition: static;\n\t\ttransform: translateZ(0);\n\t\ttransition:\n\t\t\ttransform 200ms,\n\t\t\topacity 200ms;\n\t\tbox-shadow: 0 0 0 ",
        "px ",
        ";\n\t\tborder: none;\n\t\tmargin: ",
        ";\n\t\tpadding: ",
        ";\n\n\t\t&::-moz-focus-inner {\n\t\t\tborder: 0;\n\t\t\tmargin: ",
        ";\n\t\t\tpadding: ",
        ";\n\t\t}\n\n\t\t&::after {\n\t\t\tbackground-color: transparent;\n\t\t\tinset: 0px;\n\n\t\t\t/* Added border-radius style to fix hover issue in safari */\n\t\t\tborder-radius: ",
        ";\n\t\t\tcontent: ' ';\n\t\t\topacity: 0;\n\t\t\tpointer-events: none;\n\t\t\tposition: absolute;\n\t\t\ttransition: opacity 200ms;\n\t\t\twidth: 100%;\n\t\t}\n\n\t\t:focus-visible {\n\t\t\tbox-shadow: none;\n\t\t}\n\n\t\t",
        "\n\n\t\t",
        "\n\n    ",
        "\n\t"
    ])), size, size, borderColor, appearance === 'circle' ? '50%' : "".concat(radius, "px"), (0, $f8f43305fb76f612$export$e2bd4c1faded7921), borderColor, "var(--ds-space-025, 2px)", "var(--ds-space-0, 0px)", "var(--ds-space-0, 0px)", "var(--ds-space-0, 0px)", appearance === 'circle' ? '50%' : "".concat(radius, "px"), stackIndex && "position: relative;", isInteractive && "\n      cursor: pointer;\n\n      :hover {\n        &::after {\n          background-color: ".concat("var(--ds-interaction-hovered, ".concat((0, $h0N4L.N70A), ")"), ";\n          opacity: 1;\n        }\n      }\n\n      :active {\n        &::after {\n          background-color: ", "var(--ds-interaction-pressed, ".concat((0, $h0N4L.N70A), ")"), ";\n          opacity: 1;\n        }\n      }\n\n      :active {\n        transform: scale(", (0, $f8f43305fb76f612$export$89a980dfdf90df51), ");\n      }\n\n      @media screen and (forced-colors: active) {\n        &:focus-visible {\n          outline: 1px solid\n        }\n      }\n    "), isDisabled && "\n        cursor: not-allowed;\n\n        &::after {\n          opacity: ".concat("var(--ds-opacity-disabled, 0.7)", ";\n          pointer-events: none;\n          background-color: ", "var(--ds-surface, ".concat((0, $h0N4L.N0), ")"), ";\n        }\n      "));
};
/**
 * __Avatar__
 *
 * An avatar is a visual representation of a user or entity.
 *
 * - [Examples](https://atlassian.design/components/avatar/examples)
 * - [Code](https://atlassian.design/components/avatar/code)
 * - [Usage](https://atlassian.design/components/avatar/usage)
 */ var $de63f1e4c3afcd22$var$Avatar = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function(_ref2, ref) {
    var _ref3;
    var analyticsContext = _ref2.analyticsContext, _ref2$appearance = _ref2.appearance, appearance = _ref2$appearance === void 0 ? 'circle' : _ref2$appearance, label = _ref2.label, borderColor = _ref2.borderColor, children = _ref2.children, href = _ref2.href, isDisabled = _ref2.isDisabled, name = _ref2.name, onClick = _ref2.onClick, presence = _ref2.presence, sizeProp = _ref2.size, src = _ref2.src, stackIndex = _ref2.stackIndex, status = _ref2.status, target = _ref2.target, testId = _ref2.testId, _ref2$as = _ref2.as, AvatarContainer = _ref2$as === void 0 ? 'div' : _ref2$as;
    var _useAnalyticsEvents = (0, $hQ6Uq.useAnalyticsEvents)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
    var context = (0, $e398fef1b16a23dd$export$b50b87a1c4086b23)();
    var size = (_ref3 = sizeProp !== null && sizeProp !== void 0 ? sizeProp : context === null || context === void 0 ? void 0 : context.size) !== null && _ref3 !== void 0 ? _ref3 : 'medium';
    var customPresenceNode = /*#__PURE__*/ (0, $5FkrB.isValidElement)(presence) ? presence : null;
    var customStatusNode = /*#__PURE__*/ (0, $5FkrB.isValidElement)(status) ? status : null;
    var isValidIconSize = size !== 'xxlarge' && size !== 'xsmall';
    var lastAnalytics = (0, $5FkrB.useRef)(analyticsContext);
    var labelId = (0, $4fa12aa31a61e0c7$export$f680877a34711e37)();
    (0, $5FkrB.useEffect)(function() {
        lastAnalytics.current = analyticsContext;
    }, [
        analyticsContext
    ]);
    var onClickHandler = (0, $5FkrB.useCallback)(function(event) {
        if (isDisabled || typeof onClick !== 'function') return;
        var analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'avatar',
            attributes: {
                componentName: 'avatar',
                packageName: $de63f1e4c3afcd22$var$packageName,
                packageVersion: $de63f1e4c3afcd22$var$packageVersion
            }
        });
        /**
     * To avoid wrapping this component in AnalyticsContext we manually
     * push the parent context's meta data into the context.
     */ var context = $de63f1e4c3afcd22$var$_objectSpread({
            componentName: 'avatar',
            packageName: $de63f1e4c3afcd22$var$packageName,
            packageVersion: $de63f1e4c3afcd22$var$packageVersion
        }, lastAnalytics.current);
        analyticsEvent.context.push(context);
        /**
     * Replicating the logic in the `withAnalyticsEvents` HOC.
     */ var clone = analyticsEvent.clone();
        if (clone) clone.fire('atlaskit');
        onClick(event, analyticsEvent);
    }, [
        createAnalyticsEvent,
        isDisabled,
        onClick
    ]);
    var componentProps = function componentProps() {
        if (isDisabled) return {
            disabled: true
        };
        // return only relevant props for either anchor or button elements
        return $de63f1e4c3afcd22$var$_objectSpread($de63f1e4c3afcd22$var$_objectSpread({}, href && (0, $9129027a73d5e17b$export$60113ebe1cf0ecf)(href, target)), onClick && !href ? (0, $9129027a73d5e17b$export$cca6f1bef43616d3)(onClickHandler) : {
            onClick: onClick
        });
    };
    var isPresence = isValidIconSize && presence && !status;
    var isStatus = isValidIconSize && status;
    // add presence or status to the label by default if presence and status are passed as a string
    // if status or presence are nodes this is not added to the label by default
    var defaultLabel = [
        name,
        isStatus && !customStatusNode && "(".concat(status, ")"),
        isPresence && !customPresenceNode && "(".concat(presence, ")")
    ].filter(Boolean).join(' ');
    var isInteractive = onClick || href || isDisabled;
    var containerShouldBeImage = Boolean(!isInteractive && defaultLabel);
    return (0, $74Zh5.jsx)(AvatarContainer, {
        "data-testid": testId,
        role: containerShouldBeImage ? 'img' : undefined,
        "aria-labelledby": containerShouldBeImage ? labelId : undefined,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            display: 'inline-block',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            position: 'relative',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            outline: 0,
            zIndex: stackIndex
        }
    }, (0, $74Zh5.jsx)((0, $74Zh5.ClassNames), null, function(_ref4) {
        var css = _ref4.css;
        var props = $de63f1e4c3afcd22$var$_objectSpread($de63f1e4c3afcd22$var$_objectSpread($de63f1e4c3afcd22$var$_objectSpread($de63f1e4c3afcd22$var$_objectSpread({
            className: $de63f1e4c3afcd22$var$getStyles(css, {
                size: (0, $f8f43305fb76f612$export$9a270941bcff7e77)[size],
                radius: (0, $f8f43305fb76f612$export$e6da6efe4d1a5c9b)[size],
                appearance: appearance,
                borderColor: borderColor,
                stackIndex: stackIndex,
                isInteractive: Boolean(href || onClick) && !isDisabled,
                isDisabled: isDisabled
            })
        }, componentProps()), testId && $de63f1e4c3afcd22$var$getTestId(testId, children)), (isInteractive || children) && {
            'aria-label': label || defaultLabel
        }), {}, {
            children: (0, $74Zh5.jsx)((0, $482afe0e6891cf2c$export$2e2bcd8739ae039), {
                alt: !containerShouldBeImage && src ? name : undefined,
                appearance: appearance,
                size: size,
                src: src,
                testId: testId
            }),
            ref: ref
        });
        if (children) return children(props);
        var element = (0, $9129027a73d5e17b$export$83ee468102cdf04c)(isDisabled, href, onClick);
        return element === 'a' || element === 'button' ? (0, $74Zh5.jsx)((0, $9179ec9f7f8a2038$export$2e2bcd8739ae039), null, /*#__PURE__*/ (0, $5FkrB.createElement)(element, props)) : /*#__PURE__*/ (0, $5FkrB.createElement)(element, props);
    }), isPresence && (0, $74Zh5.jsx)((0, $113fe5757471baec$export$972c5e90200fa0ef), {
        appearance: appearance,
        size: size,
        presence: typeof presence === 'string' ? presence : undefined,
        testId: testId
    }, customPresenceNode), isStatus && (0, $74Zh5.jsx)((0, $bea5311ec8afcaed$export$8045894f255f9726), {
        appearance: appearance,
        size: size,
        borderColor: borderColor,
        status: typeof status === 'string' ? status : undefined,
        testId: testId
    }, customStatusNode), containerShouldBeImage ? (0, $74Zh5.jsx)("span", {
        "data-testid": testId && "".concat(testId, "--label"),
        id: labelId,
        hidden: true
    }, defaultLabel) : undefined);
});
$de63f1e4c3afcd22$var$Avatar.displayName = 'Avatar';
var $de63f1e4c3afcd22$export$2e2bcd8739ae039 = $de63f1e4c3afcd22$var$Avatar;



/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5FkrB = parcelRequire("5FkrB");

var $74Zh5 = parcelRequire("74Zh5");

var $id6Cu = parcelRequire("id6Cu");

var $ayeN2 = parcelRequire("ayeN2");
var $d7pIx = parcelRequire("d7pIx");
var $2ca90be555fc6ae1$var$baseStylesOld = (0, $d7pIx.xcss)({
    display: 'inline-flex',
    borderRadius: 'border.radius',
    blockSize: 'min-content',
    position: 'static',
    overflow: 'hidden'
});
var $2ca90be555fc6ae1$var$styles = {
    container: (0, $74Zh5.css)({
        display: 'inline-flex',
        boxSizing: 'border-box',
        position: 'static',
        blockSize: 'min-content',
        borderRadius: '3px',
        overflow: 'hidden',
        paddingInline: "var(--ds-space-050, 4px)"
    }),
    containerSubtle: (0, $74Zh5.css)({
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
        outlineOffset: -1
    }),
    background: {
        bold: {
            default: (0, $74Zh5.css)({
                backgroundColor: '#DDDEE1'
            }),
            inprogress: (0, $74Zh5.css)({
                backgroundColor: '#8FB8F6'
            }),
            moved: (0, $74Zh5.css)({
                backgroundColor: '#F9C84E'
            }),
            new: (0, $74Zh5.css)({
                backgroundColor: '#D8A0F7'
            }),
            removed: (0, $74Zh5.css)({
                backgroundColor: '#FD9891'
            }),
            success: (0, $74Zh5.css)({
                backgroundColor: '#B3DF72'
            })
        },
        subtle: {
            default: (0, $74Zh5.css)({
                backgroundColor: "var(--ds-background-neutral-subtle, #00000000)"
            }),
            inprogress: (0, $74Zh5.css)({
                backgroundColor: "var(--ds-background-neutral-subtle, #00000000)"
            }),
            moved: (0, $74Zh5.css)({
                backgroundColor: "var(--ds-background-neutral-subtle, #00000000)"
            }),
            new: (0, $74Zh5.css)({
                backgroundColor: "var(--ds-background-neutral-subtle, #00000000)"
            }),
            removed: (0, $74Zh5.css)({
                backgroundColor: "var(--ds-background-neutral-subtle, #00000000)"
            }),
            success: (0, $74Zh5.css)({
                backgroundColor: "var(--ds-background-neutral-subtle, #00000000)"
            })
        }
    },
    border: {
        subtle: {
            default: (0, $74Zh5.css)({
                border: "1px solid #B7B9BE"
            }),
            inprogress: (0, $74Zh5.css)({
                border: "1px solid #669DF1"
            }),
            moved: (0, $74Zh5.css)({
                border: "1px solid #FCA700"
            }),
            new: (0, $74Zh5.css)({
                border: "1px solid #C97CF4"
            }),
            removed: (0, $74Zh5.css)({
                border: "1px solid #F87168"
            }),
            success: (0, $74Zh5.css)({
                border: "1px solid #94C748"
            })
        }
    },
    outline: {
        subtle: {
            default: (0, $74Zh5.css)({
                outline: "1px solid #B7B9BE"
            }),
            inprogress: (0, $74Zh5.css)({
                outline: "1px solid #669DF1"
            }),
            moved: (0, $74Zh5.css)({
                outline: "1px solid #FCA700"
            }),
            new: (0, $74Zh5.css)({
                outline: "1px solid #C97CF4"
            }),
            removed: (0, $74Zh5.css)({
                outline: "1px solid #F87168"
            }),
            success: (0, $74Zh5.css)({
                outline: "1px solid #94C748"
            })
        }
    },
    text: {
        subtle: (0, $74Zh5.css)({
            color: "var(--ds-text, #172B4D)"
        }),
        bold: (0, $74Zh5.css)({
            color: '#292A2E'
        })
    }
};
var $2ca90be555fc6ae1$var$textStyles = (0, $74Zh5.css)({
    fontFamily: "var(--ds-font-family-body, ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    fontSize: '11px',
    fontStyle: 'normal',
    fontWeight: "var(--ds-font-weight-bold, 700)",
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: '16px',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    textTransform: 'uppercase',
    whiteSpace: 'nowrap'
});
/**
 * __Lozenge__
 *
 * A lozenge is a visual indicator used to highlight an item's status for quick recognition.
 *
 * - [Examples](https://atlassian.design/components/lozenge/examples)
 * - [Code](https://atlassian.design/components/lozenge/code)
 * - [Usage](https://atlassian.design/components/lozenge/usage)
 */ var $2ca90be555fc6ae1$var$Lozenge = /*#__PURE__*/ (0, $5FkrB.memo)(function(_ref) {
    var children = _ref.children, testId = _ref.testId, _ref$isBold = _ref.isBold, isBold = _ref$isBold === void 0 ? false : _ref$isBold, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'default' : _ref$appearance, _ref$maxWidth = _ref.maxWidth, maxWidth = _ref$maxWidth === void 0 ? 200 : _ref$maxWidth, style = _ref.style;
    var appearanceStyle = isBold ? 'bold' : 'subtle';
    var appearanceType = appearance in $2ca90be555fc6ae1$var$styles.background[appearanceStyle] ? appearance : 'default';
    var maxWidthValue = typeof maxWidth === 'string' ? maxWidth : "".concat(maxWidth, "px");
    var maxWidthIsPc = typeof maxWidth === 'string' && /%$/.test(maxWidth);
    if ((0, $id6Cu.fg)('platform-component-visual-refresh')) return (0, $74Zh5.jsx)("span", {
        style: {
            backgroundColor: style === null || style === void 0 ? void 0 : style.backgroundColor,
            maxWidth: maxWidthIsPc ? maxWidth : '100%'
        },
        css: [
            $2ca90be555fc6ae1$var$styles.container,
            $2ca90be555fc6ae1$var$styles.background[appearanceStyle][appearanceType],
            appearanceStyle === 'subtle' && !(0, $id6Cu.fg)('visual-refresh_drop_5') && $2ca90be555fc6ae1$var$styles.border.subtle[appearanceType],
            appearanceStyle === 'subtle' && (0, $id6Cu.fg)('visual-refresh_drop_5') && $2ca90be555fc6ae1$var$styles.outline.subtle[appearanceType],
            appearanceStyle === 'subtle' && (0, $id6Cu.fg)('visual-refresh_drop_5') && $2ca90be555fc6ae1$var$styles.containerSubtle
        ],
        "data-testid": testId
    }, (0, $74Zh5.jsx)("span", {
        css: [
            $2ca90be555fc6ae1$var$textStyles,
            $2ca90be555fc6ae1$var$styles.text[appearanceStyle]
        ],
        style: {
            color: style === null || style === void 0 ? void 0 : style.color,
            // to negate paddingInline specified on Box above
            maxWidth: maxWidthIsPc ? '100%' : "calc(".concat(maxWidthValue, " - ", "var(--ds-space-100, 8px)", ")")
        },
        "data-testid": testId && "".concat(testId, "--text")
    }, children));
    var appearanceTypeOld = appearance in $2ca90be555fc6ae1$var$backgroundColorsOld[appearanceStyle] ? appearance : 'default';
    return (0, $74Zh5.jsx)((0, $ayeN2.default), {
        as: "span",
        backgroundColor: $2ca90be555fc6ae1$var$backgroundColorsOld[appearanceStyle][appearanceTypeOld],
        style: {
            backgroundColor: style === null || style === void 0 ? void 0 : style.backgroundColor,
            maxWidth: maxWidthIsPc ? maxWidth : '100%'
        },
        paddingInline: "space.050",
        xcss: $2ca90be555fc6ae1$var$baseStylesOld,
        testId: testId
    }, (0, $74Zh5.jsx)("span", {
        css: [
            $2ca90be555fc6ae1$var$textStyles,
            $2ca90be555fc6ae1$var$textColorsOld[appearanceStyle][appearanceType]
        ],
        style: {
            color: style === null || style === void 0 ? void 0 : style.color,
            // to negate paddingInline specified on Box above
            maxWidth: maxWidthIsPc ? '100%' : "calc(".concat(maxWidthValue, " - ", "var(--ds-space-100, 8px)", ")")
        },
        "data-testid": testId && "".concat(testId, "--text")
    }, children));
});
$2ca90be555fc6ae1$var$Lozenge.displayName = 'Lozenge';
var $2ca90be555fc6ae1$export$2e2bcd8739ae039 = $2ca90be555fc6ae1$var$Lozenge;
var $2ca90be555fc6ae1$var$backgroundColorsOld = {
    bold: {
        default: 'color.background.neutral.bold',
        inprogress: 'color.background.information.bold',
        moved: 'color.background.warning.bold',
        new: 'color.background.discovery.bold',
        removed: 'color.background.danger.bold',
        success: 'color.background.success.bold'
    },
    subtle: {
        default: 'color.background.neutral',
        inprogress: 'color.background.information',
        moved: 'color.background.warning',
        new: 'color.background.discovery',
        removed: 'color.background.danger',
        success: 'color.background.success'
    }
};
var $2ca90be555fc6ae1$var$textColorsOld = {
    bold: {
        default: (0, $74Zh5.css)({
            color: "var(--ds-text-inverse, #FFFFFF)"
        }),
        inprogress: (0, $74Zh5.css)({
            color: "var(--ds-text-inverse, #FFFFFF)"
        }),
        moved: (0, $74Zh5.css)({
            color: "var(--ds-text-warning-inverse, #172B4D)"
        }),
        new: (0, $74Zh5.css)({
            color: "var(--ds-text-inverse, #FFFFFF)"
        }),
        removed: (0, $74Zh5.css)({
            color: "var(--ds-text-inverse, #FFFFFF)"
        }),
        success: (0, $74Zh5.css)({
            color: "var(--ds-text-inverse, #FFFFFF)"
        })
    },
    subtle: {
        default: (0, $74Zh5.css)({
            color: "var(--ds-text-subtle, #42526E)"
        }),
        inprogress: (0, $74Zh5.css)({
            color: "var(--ds-text-information, #0052CC)"
        }),
        moved: (0, $74Zh5.css)({
            color: "var(--ds-text-warning, #974F0C)"
        }),
        new: (0, $74Zh5.css)({
            color: "var(--ds-text-discovery, #403294)"
        }),
        removed: (0, $74Zh5.css)({
            color: "var(--ds-text-danger, #DE350B)"
        }),
        success: (0, $74Zh5.css)({
            color: "var(--ds-text-success, #006644)"
        })
    }
};



var $kqp0i = parcelRequire("kqp0i");

var $25nEq = parcelRequire("25nEq");

var $1Vcia = parcelRequire("1Vcia");

var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");

var $7QpUe = parcelRequire("7QpUe");

var $2CKum = parcelRequire("2CKum");
/**
 * Character key codes which can be used in keyboard events.
 */ var $ebec22bc85089a5d$export$390330c10ff2b9a1 = 'ArrowUp';
var $ebec22bc85089a5d$export$a80636c6f41931fe = 'ArrowDown';
var $ebec22bc85089a5d$export$4af703091671bc = 'Home';
var $ebec22bc85089a5d$export$e2bc30913faa5db7 = 'End';
var $ebec22bc85089a5d$export$10f6869ed0a7d75b = 'Tab';
var $ebec22bc85089a5d$export$8152f929a25a0ff4 = 'Enter';
var $ebec22bc85089a5d$export$e51a3576c045c8d5 = 'Space';
var $ebec22bc85089a5d$export$2bb790b9008907b4 = 'Escape';


/**
 * Assigns the node to all the refs passed in the argument.
 *
 * @param refs: An array of refs (as function or ref object)
 */ function $e2c87340de9b0062$export$2e2bcd8739ae039(refs) {
    // TODO: could this be wrapped in `useCallback` so we get a stable function?
    return function(value) {
        refs.forEach(function(ref) {
            if (typeof ref === 'function') ref(value);
            else if (ref !== null) ref.current = value;
        });
    };
}


/**
 * An empty function which does nothing.
 */ // eslint-disable-next-line @repo/internal/react/use-noop
function $f729a2485b96e7ca$export$2e2bcd8739ae039() {}



var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");
function $99c3cb855d6cc161$export$2e2bcd8739ae039(propValue) {
    var getDefaultPropValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function() {
        return propValue;
    };
    var isControlled = propValue !== undefined;
    var _useState = (0, $5FkrB.useState)(getDefaultPropValue), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), valueState = _useState2[0], setValue = _useState2[1];
    var isControlledRef = (0, $5FkrB.useRef)(isControlled);
    (0, $5FkrB.useEffect)(function() {
        isControlledRef.current = isControlled;
    }, [
        isControlled
    ]);
    var value = isControlled ? propValue : valueState;
    var setValueIfUncontrolled = (0, $5FkrB.useCallback)(function(newValue) {
        if (!isControlledRef.current) setValue(newValue);
    }, []);
    return [
        value,
        setValueIfUncontrolled
    ];
}



var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");
function $90cc74b2d10bb254$export$2e2bcd8739ae039() {
    var _useState = (0, $5FkrB.useState)(false), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), isFocused = _useState2[0], setIsFocused = _useState2[1];
    // ensure bindFocus has a stable ref
    var bindFocus = (0, $5FkrB.useRef)({
        onFocus: function onFocus() {
            return setIsFocused(true);
        },
        onBlur: function onBlur() {
            return setIsFocused(false);
        }
    });
    (0, $5FkrB.useEffect)(function() {
        // handle the case where a component might
        // unmount while being focused.
        return function() {
            return setIsFocused(false);
        };
    }, []);
    return {
        isFocused: isFocused,
        bindFocus: bindFocus.current
    };
}


var $fe03fbe22ca1a3ef$exports = {};
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4f1feec303b173e7de0228adfc7e7782>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty($fe03fbe22ca1a3ef$exports, "__esModule", {
    value: true
});
$fe03fbe22ca1a3ef$exports.default = void 0;

var $fe03fbe22ca1a3ef$var$_react = $fe03fbe22ca1a3ef$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $fe03fbe22ca1a3ef$var$_chevronDown = $fe03fbe22ca1a3ef$var$_interopRequireDefault((parcelRequire("1SmDc")));

var $fe03fbe22ca1a3ef$var$_chevronDown2 = $fe03fbe22ca1a3ef$var$_interopRequireDefault((parcelRequire("zf9Qj")));
function $fe03fbe22ca1a3ef$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for ChevronDownIcon.
 * This component is ChevronDownIcon, with `UNSAFE_fallbackIcon` set to "ChevronDownIcon".
 *
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for dropdown menus, selects, accordions, and expands.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $fe03fbe22ca1a3ef$var$ChevronDownIcon = (props)=>/*#__PURE__*/ $fe03fbe22ca1a3ef$var$_react.default.createElement($fe03fbe22ca1a3ef$var$_chevronDown.default, Object.assign({
        LEGACY_fallbackIcon: $fe03fbe22ca1a3ef$var$_chevronDown2.default
    }, props));
$fe03fbe22ca1a3ef$var$ChevronDownIcon.Name = 'ChevronDownIconMigration';
var $fe03fbe22ca1a3ef$var$_default = $fe03fbe22ca1a3ef$exports.default = $fe03fbe22ca1a3ef$var$ChevronDownIcon;



var $id6Cu = parcelRequire("id6Cu");

var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");

var $74Zh5 = parcelRequire("74Zh5");

var $ekGgq = parcelRequire("ekGgq");

var $5FkrB = parcelRequire("5FkrB");

var $b5lkZ = parcelRequire("b5lkZ");

var $jZlo3 = parcelRequire("jZlo3");
var $57bcfc679d2b3109$var$_process, $57bcfc679d2b3109$var$_process2;
// We can't rely on NODE_ENV === 'test' if its value is already configured by the consumer to some other value, so better to use JEST_WORKER_ID
// https://jestjs.io/docs/environment-variables#jest_worker_id
var $57bcfc679d2b3109$var$TESTS_MODE = (globalThis === null || globalThis === void 0 || ($57bcfc679d2b3109$var$_process = globalThis.process) === null || $57bcfc679d2b3109$var$_process === void 0 || ($57bcfc679d2b3109$var$_process = $57bcfc679d2b3109$var$_process.env) === null || $57bcfc679d2b3109$var$_process === void 0 ? void 0 : $57bcfc679d2b3109$var$_process.JEST_WORKER_ID) !== undefined;
var $57bcfc679d2b3109$var$DEBUG_MODE = !$57bcfc679d2b3109$var$TESTS_MODE && (globalThis === null || globalThis === void 0 || ($57bcfc679d2b3109$var$_process2 = globalThis.process) === null || $57bcfc679d2b3109$var$_process2 === void 0 || ($57bcfc679d2b3109$var$_process2 = $57bcfc679d2b3109$var$_process2.env) === null || $57bcfc679d2b3109$var$_process2 === void 0 ? void 0 : $57bcfc679d2b3109$var$_process2.NODE_ENV) !== 'production';
var $57bcfc679d2b3109$export$1c9f709888824e05 = function debug() {
    var _console;
    if (!$57bcfc679d2b3109$var$DEBUG_MODE) return;
    // eslint-disable-next-line no-console
    (_console = console).debug.apply(_console, arguments);
};



var $3ZMUU = parcelRequire("3ZMUU");
var $82963170c0a9272a$var$pkgName = '@atlaskit/platform-feature-flags';
var $82963170c0a9272a$export$7e41b1b2bdee3f98 = '__PLATFORM_FEATURE_FLAGS__';
var $82963170c0a9272a$var$hasProcessEnv = typeof $3ZMUU !== 'undefined' && typeof $3ZMUU.env !== 'undefined';
// FF global overrides can be configured by test runners or Storybook
var $82963170c0a9272a$var$ENV_ENABLE_PLATFORM_FF = $82963170c0a9272a$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
// STORYBOOK_ENABLE_PLATFORM_FF is included as storybook only allows env vars prefixed with STORYBOOK
// https://github.com/storybookjs/storybook/issues/12270
var $82963170c0a9272a$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF = $82963170c0a9272a$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
var $82963170c0a9272a$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE = $82963170c0a9272a$var$ENV_ENABLE_PLATFORM_FF || $82963170c0a9272a$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF;
var $82963170c0a9272a$var$DEFAULT_PFF_GLOBAL = {
    booleanResolver: undefined
};
var $82963170c0a9272a$var$globalVar = typeof window !== 'undefined' ? window : globalThis;
$82963170c0a9272a$var$globalVar[$82963170c0a9272a$export$7e41b1b2bdee3f98] = $82963170c0a9272a$var$globalVar[$82963170c0a9272a$export$7e41b1b2bdee3f98] || $82963170c0a9272a$var$DEFAULT_PFF_GLOBAL;
function $82963170c0a9272a$export$f2b591175b3e424c(resolver) {
    $82963170c0a9272a$var$globalVar[$82963170c0a9272a$export$7e41b1b2bdee3f98].booleanResolver = resolver;
}
function $82963170c0a9272a$export$6333b6aff9fc6275(flagKey) {
    if ($82963170c0a9272a$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE) {
        (0, $57bcfc679d2b3109$export$1c9f709888824e05)('[%s]: The feature flags were enabled while running tests. The flag "%s" will be always enabled.', $82963170c0a9272a$var$pkgName, flagKey);
        return true;
    }
    try {
        var _globalVar$PFF_GLOBAL, _globalVar$PFF_GLOBAL2, _globalVar$PFF_GLOBAL3;
        // booleanResolver will be empty for products like Trello, Elevate, Recruit etc.
        // Currently only Confluence, Jira and Bitbucket has set it.
        if (((_globalVar$PFF_GLOBAL = $82963170c0a9272a$var$globalVar[$82963170c0a9272a$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL === void 0 ? void 0 : _globalVar$PFF_GLOBAL.booleanResolver) === undefined || ((_globalVar$PFF_GLOBAL2 = $82963170c0a9272a$var$globalVar[$82963170c0a9272a$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL2 === void 0 ? void 0 : _globalVar$PFF_GLOBAL2.booleanResolver) === null) // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
        return (0, $jZlo3.default).checkGate(flagKey);
        var result = (_globalVar$PFF_GLOBAL3 = $82963170c0a9272a$var$globalVar[$82963170c0a9272a$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL3 === void 0 ? void 0 : _globalVar$PFF_GLOBAL3.booleanResolver(flagKey);
        if (typeof result !== 'boolean') {
            // eslint-disable-next-line no-console
            console.warn("".concat(flagKey, " resolved to a non-boolean value, returning false for safety"));
            return false;
        }
        return result;
    } catch (e) {
        return false;
    }
}


function $5904cf224be9b365$export$ba05d765b8392e5e(flagResolver) {
    (0, $82963170c0a9272a$export$f2b591175b3e424c)(flagResolver);
}
function $5904cf224be9b365$export$470e5c2be1411c89(name) {
    return (0, $82963170c0a9272a$export$6333b6aff9fc6275)(name);
}
function $5904cf224be9b365$export$b40ec24ac8275656(name) {
    return (0, $82963170c0a9272a$export$6333b6aff9fc6275)(name);
}


var $13bc4d6429052436$var$_React$useId;
// Type copied from https://github.com/thearnica/react-uid/blob/0f507fbbdb1ab84acf477ec32698afe3d2191e49/src/hooks.ts#L12
// Copied rather than inferred to make the type transparent
// @ts-ignore - useId is not accessible in React 16
var $13bc4d6429052436$var$react18UseId = ($13bc4d6429052436$var$_React$useId = (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).useId) !== null && $13bc4d6429052436$var$_React$useId !== void 0 ? $13bc4d6429052436$var$_React$useId : undefined;
function $13bc4d6429052436$export$f680877a34711e37() {
    if ($13bc4d6429052436$var$react18UseId && (0, $5904cf224be9b365$export$b40ec24ac8275656)('platform.design-system-team.react-18-use-id_mn8q4')) // eslint-disable-next-line react-hooks/rules-of-hooks
    return $13bc4d6429052436$var$react18UseId();
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return "uid".concat((0, $b5lkZ.useUID)());
}
var $13bc4d6429052436$export$6be90bcb437e928f = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function(_ref, ref) {
    var children = _ref.children, _ref$postfix = _ref.postfix, postfix = _ref$postfix === void 0 ? '' : _ref$postfix, _ref$prefix = _ref.prefix, prefix = _ref$prefix === void 0 ? '' : _ref$prefix;
    var id = "".concat(prefix).concat($13bc4d6429052436$export$f680877a34711e37()).concat(postfix);
    (0, $5FkrB.useEffect)(function() {
        if (!ref) return;
        switch((0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(ref)){
            case 'function':
                ref(id);
                break;
            case 'object':
                ref.current = id;
                break;
            default:
                throw new Error("Unreachable case for unsupported type of ref \"".concat((0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(ref), "\""));
        }
    }, [
        id,
        ref
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).Fragment, null, typeof children === 'function' ? children({
        id: id
    }) : children);
});
function $13bc4d6429052436$export$6ee17796e3d70de2() {
    if ($13bc4d6429052436$var$react18UseId && (0, $5904cf224be9b365$export$b40ec24ac8275656)('platform.design-system-team.react-18-use-id_mn8q4')) {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        var uid = $13bc4d6429052436$var$react18UseId();
        return function(id) {
            return "".concat(uid, "-").concat(id.toString());
        };
    }
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return (0, $b5lkZ.useUIDSeed)();
}



var $5FkrB = parcelRequire("5FkrB");

var $e16c542a93602879$export$650d12d3c2ddb8fc = /*#__PURE__*/ (0, $5FkrB.createContext)(0);
var $e16c542a93602879$export$48b383b280e20440 = /*#__PURE__*/ (0, $5FkrB.createContext)({
    topLevelRef: {
        current: null
    },
    setTopLevel: (0, $f729a2485b96e7ca$export$2e2bcd8739ae039)
});
/**
 *
 *  @internal
 * Context Provider Component which provider the current level of nested layers
 * It handles level management when it mounts and unmounts
 *
 */ var $e16c542a93602879$var$LevelProvider = function LevelProvider(_ref) {
    var children = _ref.children, currentLevel = _ref.currentLevel;
    var _useContext = (0, $5FkrB.useContext)($e16c542a93602879$export$48b383b280e20440), setTopLevel = _useContext.setTopLevel, topLevelRef = _useContext.topLevelRef;
    if (topLevelRef.current === null || currentLevel > topLevelRef.current) setTopLevel(currentLevel);
    (0, $5FkrB.useEffect)(function() {
        return function() {
            // avoid immediate cleanup using setTimeout when component unmount
            // this will make sure non-top layer components can get the correct top level value
            // when multiple layers trigger onClose in sequence
            setTimeout(function() {
                setTopLevel(currentLevel - 1);
            }, 0);
        };
    }, [
        setTopLevel,
        currentLevel
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement($e16c542a93602879$export$650d12d3c2ddb8fc.Provider, {
        value: currentLevel
    }, children);
};
/**
 *
 *  @internal
 * Context Provider Component which provides the top level of all nested layers
 * It provides initial top level ref value as 0 and set top level method
 *
 */ var $e16c542a93602879$var$LayeringProvider = function LayeringProvider(_ref2) {
    var children = _ref2.children;
    var topLevelRef = (0, $5FkrB.useRef)(0);
    var value = (0, $5FkrB.useMemo)(function() {
        return {
            topLevelRef: topLevelRef,
            setTopLevel: function setTopLevel(level) {
                topLevelRef.current = level;
            }
        };
    }, [
        topLevelRef
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement($e16c542a93602879$export$48b383b280e20440.Provider, {
        value: value
    }, children);
};
var $e16c542a93602879$export$7c885f891c940977 = function Layering(_ref3) {
    var children = _ref3.children, _ref3$isDisabled = _ref3.isDisabled, isDisabled = _ref3$isDisabled === void 0 ? true : _ref3$isDisabled;
    var currentLevel = (0, $5FkrB.useContext)($e16c542a93602879$export$650d12d3c2ddb8fc);
    if (isDisabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).Fragment, null, children);
    var isNested = currentLevel > 0;
    var content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement($e16c542a93602879$var$LevelProvider, {
        currentLevel: currentLevel + 1
    }, children);
    return isNested ? content : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement($e16c542a93602879$var$LayeringProvider, null, content);
};



var $5FkrB = parcelRequire("5FkrB");

var $5FkrB = parcelRequire("5FkrB");
var $a2c0f502285bf696$export$5fbf4d7fae6cdc00 = /*#__PURE__*/ (0, $5FkrB.createContext)(null);


function $1b596479f17c86b4$export$469bb693f11edc7f() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, _ref$isOpen = _ref.isOpen, isOpen = _ref$isOpen === void 0 ? true : _ref$isOpen;
    var context = (0, $5FkrB.useContext)((0, $a2c0f502285bf696$export$5fbf4d7fae6cdc00));
    (0, $5FkrB.useEffect)(function() {
        if (context === null) return;
        if (!isOpen) return;
        context.increment();
        return function() {
            context.decrement();
        };
    }, [
        context,
        isOpen
    ]);
}



var $id6Cu = parcelRequire("id6Cu");

var $hvYLl = parcelRequire("hvYLl");
var $agyC9 = parcelRequire("agyC9");

var $5FkrB = parcelRequire("5FkrB");

var $id6Cu = parcelRequire("id6Cu");

var $5FkrB = parcelRequire("5FkrB");

var $aLeHs = parcelRequire("aLeHs");
var $94e710254572b2f6$export$e4c79eb95c23a0da = 'atlaskit-portal-container';
var $94e710254572b2f6$export$72f415121273627e = 'body > .atlaskit-portal-container';
var $94e710254572b2f6$export$13f57c02915787b3 = 'atlaskit-portal';


var $ffb00058682e93a3$export$26ae5ca175b4ec5a = function createContainer(zIndex) {
    var container = document.createElement('div');
    container.className = (0, $94e710254572b2f6$export$13f57c02915787b3);
    container.style.zIndex = "".concat(zIndex);
    return container;
};
/**
 * Returns document body element
 * @return {number} - The document body element
 */ var $ffb00058682e93a3$var$getBody = function getBody() {
    return document.body;
};
/**
 * Returns portal parent container. If no container exists already then it creates a new container with class name 'atlaskit-portal-container'
 * @return {Element} - The portal parent container div element
 */ var $ffb00058682e93a3$var$getPortalParent = function getPortalParent() {
    var parentElement = document.querySelector((0, $94e710254572b2f6$export$72f415121273627e));
    if (!parentElement) {
        var _getBody;
        var parent = document.createElement('div');
        parent.className = (0, $94e710254572b2f6$export$e4c79eb95c23a0da);
        // we are setting display to flex because we want each portal to create a new stacking context
        // See https://developer.mozilla.org/en-US/docs/Web/CSS/CSS_Positioning/Understanding_z_index/The_stacking_context
        parent.style.display = 'flex';
        (_getBody = $ffb00058682e93a3$var$getBody()) === null || _getBody === void 0 || _getBody.appendChild(parent);
        return parent;
    }
    return parentElement;
};
var $ffb00058682e93a3$export$da99f98bf3fe55b3 = function removePortalContainer(container) {
    $ffb00058682e93a3$var$getPortalParent().removeChild(container);
};
var $ffb00058682e93a3$export$c582005add11e141 = function appendPortalContainerIfNotAppended(container) {
    if (!container.parentElement) $ffb00058682e93a3$var$getPortalParent().appendChild(container);
};
var $ffb00058682e93a3$export$842dfe7a9f24298 = function isDocumentDefined() {
    return document !== undefined;
};
var $ffb00058682e93a3$export$fef014d7cef9e543 = function createAtlaskitPortal(zIndex) {
    //atlaskit-portal div
    if ($ffb00058682e93a3$export$842dfe7a9f24298()) {
        var atlaskitportal = document.createElement('div');
        atlaskitportal.className = (0, $94e710254572b2f6$export$13f57c02915787b3);
        atlaskitportal.style.zIndex = "".concat(zIndex);
        return atlaskitportal;
    }
};
var $ffb00058682e93a3$export$95029ca7aca2989e = function createPortalParent() {
    //atlaskit-portal-container div
    if ($ffb00058682e93a3$export$842dfe7a9f24298()) {
        var parentElement = document.querySelector((0, $94e710254572b2f6$export$72f415121273627e));
        if (!parentElement) {
            var _getBody2;
            var parent = document.createElement('div');
            parent.className = (0, $94e710254572b2f6$export$e4c79eb95c23a0da);
            parent.style.display = 'flex';
            (_getBody2 = $ffb00058682e93a3$var$getBody()) === null || _getBody2 === void 0 || _getBody2.appendChild(parent);
            return parent;
        }
        return parentElement;
    }
};


function $62911f31f7395a61$export$2e2bcd8739ae039(props) {
    var zIndex = props.zIndex, children = props.children;
    var container = (0, $5FkrB.useMemo)(function() {
        return (0, $ffb00058682e93a3$export$26ae5ca175b4ec5a)(zIndex);
    }, [
        zIndex
    ]);
    // This is in the render method instead of useEffect so that
    // the portal will be added to the DOM before the children render.
    // For any further changes, ensure that the container does not have a
    // parent besides the portal parent.
    (0, $ffb00058682e93a3$export$c582005add11e141)(container);
    (0, $5FkrB.useEffect)(function() {
        return function() {
            (0, $ffb00058682e93a3$export$da99f98bf3fe55b3)(container);
        };
    }, [
        container
    ]);
    return /*#__PURE__*/ (0, $aLeHs.createPortal)(children, container);
}



var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");

var $aLeHs = parcelRequire("aLeHs");

var $id6Cu = parcelRequire("id6Cu");

var $5FkrB = parcelRequire("5FkrB");
var $51504a5047607ee1$export$700979bc83e7db82 = typeof window !== 'undefined' ? (0, $5FkrB.useLayoutEffect) : (0, $5FkrB.useEffect);



function $4a79a89073e381b1$export$2e2bcd8739ae039(props) {
    var zIndex = props.zIndex, children = props.children;
    var _useState = (0, $5FkrB.useState)(null), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), atlaskitPortal = _useState2[0], setAtlaskitPortal = _useState2[1];
    (0, $51504a5047607ee1$export$700979bc83e7db82)(function() {
        var tempPortalContainer = (0, $ffb00058682e93a3$export$fef014d7cef9e543)(zIndex);
        setAtlaskitPortal(tempPortalContainer);
        var portalParent = (0, $ffb00058682e93a3$export$95029ca7aca2989e)();
        if (!tempPortalContainer || !portalParent) return;
        portalParent.appendChild(tempPortalContainer);
        return function() {
            if (tempPortalContainer) portalParent.removeChild(tempPortalContainer);
            setAtlaskitPortal(null);
        };
    }, [
        zIndex
    ]);
    /**
   * Conditionally wrap ALL portal children with Suspense behind a feature gate for safe rollout.
   *
   * This is here because in React 18 concurrent, if you suspend from _within_ a portal to a
   * suspense boundary _outside_ a portal, our portal gets in an infinite loop of re-rendering.
   */ var conditionallySuspendedChildren = (0, $id6Cu.fg)('platform_design_system_suspend_portal_children') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $5FkrB.Suspense), {
        fallback: null
    }, children) : children;
    return atlaskitPortal ? /*#__PURE__*/ (0, $aLeHs.createPortal)(conditionallySuspendedChildren, atlaskitPortal) : null;
}



var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");

var $eaa77580a82fb698$var$useIsSubsequentRender = function useIsSubsequentRender(mountStrategy) {
    var _useState = (0, $5FkrB.useState)(false), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), isSubsequentRender = _useState2[0], setIsSubsequentRender = _useState2[1];
    var _useState3 = (0, $5FkrB.useState)(function() {
        return mountStrategy === 'layoutEffect' ? (0, $51504a5047607ee1$export$700979bc83e7db82) : (0, $5FkrB.useEffect);
    }), _useState4 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState3, 1), useMountEffect = _useState4[0];
    useMountEffect(function() {
        setIsSubsequentRender(true);
    }, []);
    return isSubsequentRender;
};
var $eaa77580a82fb698$export$2e2bcd8739ae039 = $eaa77580a82fb698$var$useIsSubsequentRender;



var $5FkrB = parcelRequire("5FkrB");
var $9b2a0d431a81de3b$export$ed5835cc67e87f72 = 'akPortalMount';
var $9b2a0d431a81de3b$export$80816bd900e5bd00 = 'akPortalUnmount';


var $27b8dc95e112db48$var$zIndexToName = {
    100: 'card',
    200: 'navigation',
    300: 'dialog',
    400: 'layer',
    500: 'blanket',
    510: 'modal',
    600: 'flag',
    700: 'spotlight',
    9999: 'tooltip'
};
/**
 * return layer name in Atlassian design system corresponding to given z-index
 * @param {number} zIndex - z-index value for which layer name is needed
 * @returns {LayerName | null} - The layer name for given z-index. If layer name is not found then null is returned
 */ var $27b8dc95e112db48$var$getLayerName = function getLayerName(zIndex) {
    return $27b8dc95e112db48$var$zIndexToName.hasOwnProperty(zIndex) ? $27b8dc95e112db48$var$zIndexToName[zIndex] : null;
};
/**
 * Creates a PortalEvent object with given eventName, given zIndex and corresponding layer
 * @param {string} eventName - either of Mount or Unmount event name
 * @param {number} zIndex - z-index value which will be included in the event to be dispatched
 * @returns {PortalEvent} - The newly created PortalEvent object
 */ var $27b8dc95e112db48$var$getEvent = function getEvent(eventName, zIndex) {
    var detail = {
        layer: $27b8dc95e112db48$var$getLayerName(Number(zIndex)),
        zIndex: zIndex
    };
    return new CustomEvent(eventName, {
        detail: detail
    });
};
function $27b8dc95e112db48$export$2e2bcd8739ae039(eventName, zIndex) {
    var event = $27b8dc95e112db48$var$getEvent(eventName, zIndex);
    window.dispatchEvent(event);
}


var $5f24cae5a9edfe51$var$useFirePortalEvent = function useFirePortalEvent(zIndex) {
    var zIndexNumber = Number(zIndex);
    (0, $5FkrB.useEffect)(function() {
        (0, $27b8dc95e112db48$export$2e2bcd8739ae039)((0, $9b2a0d431a81de3b$export$ed5835cc67e87f72), zIndexNumber);
        return function() {
            (0, $27b8dc95e112db48$export$2e2bcd8739ae039)((0, $9b2a0d431a81de3b$export$80816bd900e5bd00), zIndexNumber);
        };
    }, [
        zIndexNumber
    ]);
};
var $5f24cae5a9edfe51$export$2e2bcd8739ae039 = $5f24cae5a9edfe51$var$useFirePortalEvent;


function $4fb6ce5614cd87f1$export$2e2bcd8739ae039(_ref) {
    var _ref$zIndex = _ref.zIndex, zIndex = _ref$zIndex === void 0 ? 0 : _ref$zIndex, children = _ref.children, _ref$mountStrategy = _ref.mountStrategy, mountStrategy = _ref$mountStrategy === void 0 ? 'effect' : _ref$mountStrategy;
    var isSubsequentRender = (0, $eaa77580a82fb698$export$2e2bcd8739ae039)(mountStrategy);
    (0, $5f24cae5a9edfe51$export$2e2bcd8739ae039)(zIndex);
    // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
    return !(0, $id6Cu.fg)('platform_design_system_team_portal_logic_r18_fix') ? isSubsequentRender ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $62911f31f7395a61$export$2e2bcd8739ae039), {
        zIndex: zIndex
    }, children) : null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $4a79a89073e381b1$export$2e2bcd8739ae039), {
        zIndex: zIndex
    }, children);
}



var $ayeN2 = parcelRequire("ayeN2");
var $d7pIx = parcelRequire("d7pIx");

var $7LfsS = parcelRequire("7LfsS");

var $fC8ib = parcelRequire("fC8ib");

var $iYJcE = parcelRequire("iYJcE");

var $kqp0i = parcelRequire("kqp0i");

var $1Vcia = parcelRequire("1Vcia");

var $25nEq = parcelRequire("25nEq");

var $5FkrB = parcelRequire("5FkrB");

var $74Zh5 = parcelRequire("74Zh5");
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5FkrB = parcelRequire("5FkrB");

var $74Zh5 = parcelRequire("74Zh5");
var $6a910524489a0a64$var$BORDER_WIDTH = 2;
var $6a910524489a0a64$var$baseFocusOutsideStyles = (0, $74Zh5.css)({
    outline: "".concat($6a910524489a0a64$var$BORDER_WIDTH, "px solid ", "var(--ds-border-focused, #2684FF)"),
    outlineOffset: $6a910524489a0a64$var$BORDER_WIDTH
});
var $6a910524489a0a64$var$baseInsetStyles = (0, $74Zh5.css)({
    outlineColor: "var(--ds-border-focused, #2684FF)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    outlineOffset: -$6a910524489a0a64$var$BORDER_WIDTH,
    outlineStyle: 'solid',
    outlineWidth: "var(--ds-border-width-outline, 2px)"
});
var $6a910524489a0a64$var$focusRingStyles = (0, $74Zh5.css)({
    // Focus styles used when :focus-visible isn't supported
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
    '&:focus': $6a910524489a0a64$var$baseFocusOutsideStyles,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
    '&:focus-visible': $6a910524489a0a64$var$baseFocusOutsideStyles,
    // Remove default focus styles for mouse interactions if :focus-visible is supported
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
    '&:focus:not(:focus-visible)': {
        outline: 'none'
    },
    '@media screen and (forced-colors: active), screen and (-ms-high-contrast: active)': {
        '&:focus-visible': {
            outline: '1px solid'
        }
    }
});
var $6a910524489a0a64$var$insetFocusRingStyles = (0, $74Zh5.css)({
    // Focus styles used when :focus-visible isn't supported
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
    '&:focus': $6a910524489a0a64$var$baseInsetStyles,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
    '&:focus-visible': $6a910524489a0a64$var$baseInsetStyles,
    // Remove default focus styles for mouse interactions if :focus-visible is supported
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
    '&:focus:not(:focus-visible)': {
        outline: 'none'
    },
    '@media screen and (forced-colors: active), screen and (-ms-high-contrast: active)': {
        '&:focus-visible': {
            outline: '1px solid',
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
            outlineOffset: '-1px'
        }
    }
});
/**
 * __Focus ring__
 *
 * A focus ring visually indicates the currently focused item.
 *
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/focus-ring)
 *
 * @example
 * ```jsx
 * import FocusRing from '@atlaskit/focus-ring';
 *
 * const InteractiveComponent = () => (
 *   <FocusRing>
 *     <button type="button">Hello</button>
 *   </FocusRing>
 * )
 * ```
 */ var $6a910524489a0a64$var$FocusRing = /*#__PURE__*/ (0, $5FkrB.memo)(function(_ref) {
    var children = _ref.children, isInset = _ref.isInset, focus = _ref.focus;
    var controlledStyles = isInset ? $6a910524489a0a64$var$baseInsetStyles : $6a910524489a0a64$var$baseFocusOutsideStyles;
    var uncontrolledStyles = isInset ? $6a910524489a0a64$var$insetFocusRingStyles : $6a910524489a0a64$var$focusRingStyles;
    var focusCls = typeof focus === 'undefined' ? uncontrolledStyles : focus === 'on' && controlledStyles;
    return (0, $74Zh5.jsx)((0, $74Zh5.ClassNames), null, function(_ref2) {
        var css = _ref2.css, cx = _ref2.cx;
        return (0, $5FkrB.Children).only(// This may look unwieldy but means we skip applying styles / cloning if no className is applicable
        focusCls ? /*#__PURE__*/ // eslint-disable-next-line @repo/internal/react/no-clone-element
        (0, $5FkrB.cloneElement)(children, {
            className: cx([
                css(focusCls),
                children.props.className
            ])
        }) : children);
    });
});
$6a910524489a0a64$var$FocusRing.displayName = 'FocusRing';
var $6a910524489a0a64$export$2e2bcd8739ae039 = $6a910524489a0a64$var$FocusRing;



var $5FkrB = parcelRequire("5FkrB");

var $7QpUe = parcelRequire("7QpUe");

var $7c2afb67333dd81e$var$ESCAPE = 'Escape';
function $7c2afb67333dd81e$export$4a4bf067ea9e7886(_ref) {
    var onClose = _ref.onClose, isDisabled = _ref.isDisabled;
    var escapePressed = (0, $5FkrB.useRef)(false);
    var _useLayering = $7c2afb67333dd81e$export$c8b4d54e03dee6ed(), isLayerDisabled = _useLayering.isLayerDisabled;
    var onKeyDown = (0, $5FkrB.useCallback)(function(e) {
        var isDisabledLayer = isLayerDisabled();
        if (isDisabled || escapePressed.current || e.key !== $7c2afb67333dd81e$var$ESCAPE || isDisabledLayer) // We're either already handling the key down event or it's not escape or disabled.
        // Bail early!
        return;
        escapePressed.current = true;
        onClose(e);
    }, [
        onClose,
        isDisabled,
        isLayerDisabled
    ]);
    var onKeyUp = (0, $5FkrB.useCallback)(function() {
        escapePressed.current = false;
    }, []);
    (0, $5FkrB.useEffect)(function() {
        return (0, $7QpUe.bindAll)(window, [
            {
                type: 'keydown',
                listener: onKeyDown
            },
            {
                type: 'keyup',
                listener: onKeyUp
            }
        ], {
            capture: false
        });
    }, [
        onKeyDown,
        onKeyUp
    ]);
}
function $7c2afb67333dd81e$export$c8b4d54e03dee6ed() {
    var currentLevel = (0, $5FkrB.useContext)((0, $e16c542a93602879$export$650d12d3c2ddb8fc));
    var _useContext = (0, $5FkrB.useContext)((0, $e16c542a93602879$export$48b383b280e20440)), topLevelRef = _useContext.topLevelRef;
    var isLayerDisabled = (0, $5FkrB.useCallback)(function() {
        return !!topLevelRef.current && currentLevel !== topLevelRef.current;
    }, [
        currentLevel,
        topLevelRef
    ]);
    return {
        currentLevel: currentLevel,
        topLevelRef: topLevelRef,
        isLayerDisabled: isLayerDisabled
    };
}



var $id6Cu = parcelRequire("id6Cu");

var $fC8ib = parcelRequire("fC8ib");

var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");

var $lsgol = parcelRequire("lsgol");

var $iYJcE = parcelRequire("iYJcE");
function $318bcafdf1a93ec6$export$6d8c2b45c99d6e3f(_ref) {
    var viewportPadding = _ref.viewportPadding;
    return [
        {
            /**
     * Performing DOM measurements in the 'read' phase,
     * which is the convention for popper modifiers
     */ name: 'maxSizeData',
            enabled: true,
            phase: 'read',
            fn: function fn(_ref2) {
                var state = _ref2.state, name = _ref2.name;
                if (!window.visualViewport) return;
                state.modifiersData[name] = {
                    viewport: {
                        width: window.visualViewport.width,
                        height: window.visualViewport.height
                    }
                };
            }
        },
        {
            /**
     * Applying max size CSS
     */ name: 'maxSize',
            enabled: true,
            phase: 'beforeWrite',
            requiresIfExists: [
                'offset',
                'preventOverflow',
                'flip'
            ],
            fn: function fn(_ref3) {
                var _data$viewport, _data$viewport2, _state$modifiersData$2, _state$modifiersData;
                var state = _ref3.state;
                var data = state.modifiersData.maxSizeData;
                if (typeof (data === null || data === void 0 || (_data$viewport = data.viewport) === null || _data$viewport === void 0 ? void 0 : _data$viewport.width) !== 'number' || typeof (data === null || data === void 0 || (_data$viewport2 = data.viewport) === null || _data$viewport2 === void 0 ? void 0 : _data$viewport2.height) !== 'number') // This shouldn't occur in a real browser but might in non-browser test environments
                return;
                var viewport = data.viewport;
                var _state$modifiersData$ = state.modifiersData.popperOffsets, popperOffsets = _state$modifiersData$ === void 0 ? {
                    x: 0,
                    y: 0
                } : _state$modifiersData$;
                var _state$placement$spli = state.placement.split('-'), _state$placement$spli2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_state$placement$spli, 1), basePlacement = _state$placement$spli2[0];
                var placementOffset = (_state$modifiersData$2 = (_state$modifiersData = state.modifiersData) === null || _state$modifiersData === void 0 || (_state$modifiersData = _state$modifiersData.offset) === null || _state$modifiersData === void 0 ? void 0 : _state$modifiersData[state.placement]) !== null && _state$modifiersData$2 !== void 0 ? _state$modifiersData$2 : {
                    x: 0,
                    y: 0
                };
                // By default we set these to the entire viewport (minus padding)
                // Each placement direction will overwrite one of these
                var maxWidth = viewport.width - 2 * viewportPadding;
                var maxHeight = viewport.height - 2 * viewportPadding;
                if (basePlacement === 'top') maxHeight = state.rects.reference.y + // Viewport-relative position of reference element
                placementOffset.y - // Space between popper and reference
                viewportPadding;
                if (basePlacement === 'bottom') maxHeight = viewport.height - popperOffsets.y - // Viewport-relative position of popper
                viewportPadding;
                if (basePlacement === 'left') maxWidth = state.rects.reference.x + // Viewport-relative position of reference element
                placementOffset.x - // Space between popper and reference
                viewportPadding;
                if (basePlacement === 'right') maxWidth = viewport.width - popperOffsets.x - // Viewport-relative position of popper
                viewportPadding;
                state.styles.popper.maxWidth = "".concat(maxWidth, "px");
                state.styles.popper.maxHeight = "".concat(maxHeight, "px");
            }
        }
    ];
}



// Export types from PopperJS / React Popper
var $b5f1341f3f605eaa$var$viewportPadding = 5;
var $b5f1341f3f605eaa$var$constantModifiers = [
    {
        name: 'flip',
        options: {
            flipVariations: false,
            padding: $b5f1341f3f605eaa$var$viewportPadding,
            boundary: 'clippingParents',
            rootBoundary: 'viewport'
        }
    }
];
function $b5f1341f3f605eaa$var$defaultChildrenFn() {
    return null;
}
var $b5f1341f3f605eaa$var$defaultOffset = [
    0,
    8
];
function $b5f1341f3f605eaa$export$badac9ada3a0bdf9(_ref) {
    var _ref$children = _ref.children, children = _ref$children === void 0 ? $b5f1341f3f605eaa$var$defaultChildrenFn : _ref$children, _ref$offset = _ref.offset, offset = _ref$offset === void 0 ? $b5f1341f3f605eaa$var$defaultOffset : _ref$offset, _ref$placement = _ref.placement, placement = _ref$placement === void 0 ? 'bottom-start' : _ref$placement, _ref$referenceElement = _ref.referenceElement, referenceElement = _ref$referenceElement === void 0 ? undefined : _ref$referenceElement, modifiers = _ref.modifiers, _ref$strategy = _ref.strategy, strategy = _ref$strategy === void 0 ? 'fixed' : _ref$strategy, _ref$shouldFitViewpor = _ref.shouldFitViewport, shouldFitViewport = _ref$shouldFitViewpor === void 0 ? false : _ref$shouldFitViewpor;
    var _offset = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(offset, 2), offsetX = _offset[0], offsetY = _offset[1];
    var internalModifiers = (0, $5FkrB.useMemo)(function() {
        var preventOverflowModifier = {
            name: 'preventOverflow',
            options: {
                padding: $b5f1341f3f605eaa$var$viewportPadding,
                rootBoundary: shouldFitViewport ? 'viewport' : 'document'
            }
        };
        var offsetModifier = {
            name: 'offset',
            options: {
                offset: [
                    offsetX,
                    offsetY
                ]
            }
        };
        var maxSizeModifiers = shouldFitViewport ? (0, $318bcafdf1a93ec6$export$6d8c2b45c99d6e3f)({
            viewportPadding: $b5f1341f3f605eaa$var$viewportPadding
        }) : [];
        // @ts-ignore Type errors from incompatible @popperjs/core versions between Jira and AFM Platform... we are using ts-ignore here because ts-expect-error will cause an "Unused '@ts-expect-error' directive." error
        return [].concat($b5f1341f3f605eaa$var$constantModifiers, [
            preventOverflowModifier,
            offsetModifier
        ], (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(maxSizeModifiers));
    }, [
        offsetX,
        offsetY,
        shouldFitViewport
    ]);
    // Merge custom props and memoize
    var mergedModifiers = (0, $5FkrB.useMemo)(function() {
        if (modifiers == null) return internalModifiers;
        return [].concat((0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(internalModifiers), (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(modifiers));
    }, [
        internalModifiers,
        modifiers
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $lsgol.Popper), {
        modifiers: mergedModifiers,
        placement: placement,
        strategy: strategy,
        referenceElement: referenceElement
    }, children);
}



var $h0N4L = parcelRequire("h0N4L");

var $7LfsS = parcelRequire("7LfsS");
var $5e073220336a1840$export$4ef52930e33717cd = 'data-theme';
var $5e073220336a1840$export$a00eac3f8684bcd0 = 'data-color-mode';
var $5e073220336a1840$export$2112803007239c61 = 'data-contrast-mode';
var $5e073220336a1840$export$352e418ed5b6193a = 'data-custom-theme';
var $5e073220336a1840$export$2faeed762aac6741 = 'light';
var $5e073220336a1840$export$6f0c6fb8c80fcc92 = 'ds';
var $5e073220336a1840$export$4d0c7bbf80185957 = [
    'opacity',
    'font',
    'space',
    'border'
];
var $5e073220336a1840$export$dddac1532e822863 = "--".concat($5e073220336a1840$export$6f0c6fb8c80fcc92, "-token-not-found");
var $5e073220336a1840$export$9d7b58831ae93caa = "--".concat($5e073220336a1840$export$6f0c6fb8c80fcc92, "-elevation-surface-current");



var $5FkrB = parcelRequire("5FkrB");
var $ce76fba466fd6140$export$51eddd7655ca235a = function RepositionOnUpdate(_ref) {
    var children = _ref.children, update = _ref.update;
    // Ref used here to skip update on first render (when refs haven't been set)
    var isFirstRenderRef = (0, $5FkrB.useRef)(true);
    (0, $5FkrB.useLayoutEffect)(function() {
        if (isFirstRenderRef.current) {
            isFirstRenderRef.current = false;
            return;
        }
        // callback function from popper that repositions pop-up on content Update
        update();
    }, [
        update
    ]);
    // wrapping in fragment to make TS happy (known issue with FC returning children)
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $5FkrB.Fragment), null, children);
};


// eslint-disable-next-line @typescript-eslint/consistent-type-imports

var $5FkrB = parcelRequire("5FkrB");

var $7QpUe = parcelRequire("7QpUe");



var $id6Cu = parcelRequire("id6Cu");
var $53554f4774e1aa74$var$interactiveTags = [
    'button',
    'a',
    'input',
    'select',
    'textarea'
];
var $53554f4774e1aa74$export$3dee5e4542c672d9 = function isInteractiveElement(element) {
    if ($53554f4774e1aa74$var$interactiveTags.includes(element.tagName.toLowerCase())) return true;
    if (element.getAttribute('tabindex') !== null || element.hasAttribute('contenteditable')) return true;
    return false;
};



var $5FkrB = parcelRequire("5FkrB");
var $ce64637d65754298$export$641fa9c94086b46e = function useAnimationFrame() {
    var animationsRef = (0, $5FkrB.useRef)([]);
    var requestFrame = (0, $5FkrB.useCallback)(function(callback) {
        var id = requestAnimationFrame(callback);
        animationsRef.current.push(id);
        return id;
    }, []);
    var cancelFrame = (0, $5FkrB.useCallback)(function(id) {
        cancelAnimationFrame(id);
        animationsRef.current = animationsRef.current.filter(function(frameId) {
            return frameId !== id;
        });
    }, []);
    var cancelAllFrames = (0, $5FkrB.useCallback)(function() {
        animationsRef.current.forEach(function(id) {
            return cancelAnimationFrame(id);
        });
        animationsRef.current = [];
    }, []);
    return {
        requestFrame: requestFrame,
        cancelFrame: cancelFrame,
        cancelAllFrames: cancelAllFrames
    };
};


var $6b34632a0200977c$export$92dae2778ae88f9d = function useCloseManager(_ref) {
    var isOpen = _ref.isOpen, onClose = _ref.onClose, popupRef = _ref.popupRef, triggerRef = _ref.triggerRef, autoFocus = _ref.autoFocus, shouldDisableFocusTrap = _ref.shouldDisableFocusTrap, capture = _ref.shouldUseCaptureOnOutsideClick, shouldCloseOnTab = _ref.shouldCloseOnTab, shouldRenderToParent = _ref.shouldRenderToParent;
    var _useLayering = (0, $7c2afb67333dd81e$export$c8b4d54e03dee6ed)(), isLayerDisabled = _useLayering.isLayerDisabled, currentLevel = _useLayering.currentLevel;
    var _useAnimationFrame = (0, $ce64637d65754298$export$641fa9c94086b46e)(), requestFrame = _useAnimationFrame.requestFrame, cancelAllFrames = _useAnimationFrame.cancelAllFrames;
    (0, $5FkrB.useEffect)(function() {
        if (!isOpen || !popupRef) return 0, $f729a2485b96e7ca$export$2e2bcd8739ae039;
        var inIframe = window && window.self !== window.top && (0, $id6Cu.fg)('fix-dropdown-close-outside-iframe');
        var closePopup = function closePopup(event) {
            if (onClose) {
                if ((0, $id6Cu.fg)('sibling-dropdown-close-issue')) {
                    var _currentLevel = null;
                    if (event.target instanceof HTMLElement) {
                        var _event$target$closest;
                        _currentLevel = (_event$target$closest = event.target.closest("[data-ds--level]")) === null || _event$target$closest === void 0 ? void 0 : _event$target$closest.getAttribute('data-ds--level');
                    }
                    _currentLevel ? onClose(event, Number(_currentLevel)) : onClose(event);
                } else onClose(event);
            }
            if (shouldDisableFocusTrap && (0, $id6Cu.fg)('platform_dst_popup-disable-focuslock')) // Restoring the normal focus order for trigger.
            requestFrame(function() {
                triggerRef === null || triggerRef === void 0 || triggerRef.setAttribute('tabindex', '0');
                if (popupRef && autoFocus) popupRef.setAttribute('tabindex', '0');
            });
        };
        // This check is required for cases where components like
        // Select or DDM are placed inside a Popup. A click
        // on a MenuItem or Option would close the Popup, without registering
        // a click on DDM/Select.
        // Users would have to call `onClose` manually to close the Popup in these cases.
        // You can see the bug in action here:
        // https://codesandbox.io/s/atlaskitpopup-default-forked-2eb87?file=/example.tsx:0-1788
        var onClick = function onClick(event) {
            var target = event.target;
            var doesDomNodeExist = document.body.contains(target);
            if (!doesDomNodeExist && !inIframe) return;
            if (isLayerDisabled()) {
                if ((0, $id6Cu.fg)('design-system-closed-all-when-click-outside')) {
                    if (target instanceof HTMLElement) {
                        var _target$closest;
                        var layeredElement = (_target$closest = target.closest) === null || _target$closest === void 0 ? void 0 : _target$closest.call(target, "[data-ds--level]");
                        if (layeredElement) {
                            var closeType = layeredElement.getAttribute('[data-ds--close--type]');
                            if (closeType === 'single') // if the close type is single, we won't close other disabled layers when clicking outside
                            return;
                            var levelOfClickedLayer = layeredElement.getAttribute('data-ds--level');
                            if (levelOfClickedLayer && Number(levelOfClickedLayer) > currentLevel) // won't trigger onClick event when we click in a higher layer.
                            return;
                        }
                    }
                } else return;
            }
            var isClickOnPopup = popupRef && popupRef.contains(target);
            var isClickOnTrigger = triggerRef && triggerRef.contains(target);
            if (!isClickOnPopup && !isClickOnTrigger) {
                closePopup(event);
                // If there was an outside click on a non-interactive element, the focus should be on the trigger.
                if (document.activeElement && !(0, $53554f4774e1aa74$export$3dee5e4542c672d9)(document.activeElement) && (0, $id6Cu.fg)('platform_dst_popup-disable-focuslock')) triggerRef === null || triggerRef === void 0 || triggerRef.focus();
            }
        };
        var onKeyDown = function onKeyDown(event) {
            if ((0, $id6Cu.fg)('platform_dst_popup-disable-focuslock')) {
                var key = event.key, shiftKey = event.shiftKey;
                if (shiftKey && key === 'Tab' && !shouldRenderToParent) {
                    if (isLayerDisabled()) return;
                    // We need to move the focus to the popup trigger when the popup is displayed in React.Portal.
                    requestFrame(function() {
                        var isPopupFocusOut = popupRef && !popupRef.contains(document.activeElement);
                        if (isPopupFocusOut) {
                            closePopup(event);
                            if (currentLevel === 1) triggerRef === null || triggerRef === void 0 || triggerRef.focus();
                        }
                    });
                    return;
                }
                if (key === 'Tab') {
                    var _document$activeEleme;
                    // We have cases where we need to close the Popup on Tab press.
                    // Example: DropdownMenu
                    if (shouldCloseOnTab) {
                        if (isLayerDisabled()) return;
                        closePopup(event);
                        return;
                    }
                    if (isLayerDisabled() && (_document$activeEleme = document.activeElement) !== null && _document$activeEleme !== void 0 && _document$activeEleme.closest('[aria-modal]')) return;
                    if (shouldDisableFocusTrap) {
                        if (shouldRenderToParent) // We need to move the focus to the previous interactive element before popup trigger
                        requestFrame(function() {
                            var isPopupFocusOut = popupRef && !popupRef.contains(document.activeElement);
                            if (isPopupFocusOut) closePopup(event);
                        });
                        else requestFrame(function() {
                            if (!document.hasFocus()) closePopup(event);
                        });
                        return;
                    }
                }
                if (isLayerDisabled()) return;
                if (key === 'Escape' || key === 'Esc') {
                    if (triggerRef && autoFocus) triggerRef.focus();
                    closePopup(event);
                }
            } else {
                if (isLayerDisabled()) return;
                var _key = event.key;
                if (_key === 'Escape' || _key === 'Esc' || shouldCloseOnTab && _key === 'Tab') closePopup(event);
            }
        };
        var parentUnbind;
        // if the popup is inside iframe, we want to listen to click events outside iframe,
        // to close the popup correctly in the iframe.
        if (inIframe && isOpen) parentUnbind = (0, $7QpUe.bind)(window.parent.window, {
            type: 'click',
            listener: onClick,
            options: {
                capture: capture
            }
        });
        var unbind = (0, $7QpUe.bindAll)(window, [
            {
                type: 'click',
                listener: onClick,
                options: {
                    capture: capture
                }
            },
            {
                type: 'keydown',
                listener: onKeyDown
            }
        ]);
        // bind onBlur event listener to fix popup not close when clicking on iframe outside
        var unbindBlur = (0, $f729a2485b96e7ca$export$2e2bcd8739ae039);
        unbindBlur = (0, $7QpUe.bind)(window, {
            type: 'blur',
            listener: function onBlur(e) {
                if (isLayerDisabled() || !(document.activeElement instanceof HTMLIFrameElement)) return;
                closePopup(e);
            }
        });
        return function() {
            var _parentUnbind;
            cancelAllFrames();
            unbind();
            (_parentUnbind = parentUnbind) === null || _parentUnbind === void 0 || _parentUnbind();
            unbindBlur();
        };
    }, [
        isOpen,
        onClose,
        popupRef,
        triggerRef,
        autoFocus,
        shouldDisableFocusTrap,
        capture,
        isLayerDisabled,
        shouldCloseOnTab,
        currentLevel,
        shouldRenderToParent,
        requestFrame,
        cancelAllFrames
    ]);
};



var $5FkrB = parcelRequire("5FkrB");

var $b6Hjk = parcelRequire("b6Hjk");



var $id6Cu = parcelRequire("id6Cu");

var $943c1c369cf4b572$export$10c5169755ce7bd7 = function useFocusManager(_ref) {
    var initialFocusRef = _ref.initialFocusRef, popupRef = _ref.popupRef, triggerRef = _ref.triggerRef, autoFocus = _ref.autoFocus, shouldCloseOnTab = _ref.shouldCloseOnTab, shouldDisableFocusTrap = _ref.shouldDisableFocusTrap, shouldReturnFocus = _ref.shouldReturnFocus, shouldRenderToParent = _ref.shouldRenderToParent;
    var _useAnimationFrame = (0, $ce64637d65754298$export$641fa9c94086b46e)(), requestFrame = _useAnimationFrame.requestFrame, cancelAllFrames = _useAnimationFrame.cancelAllFrames;
    var _useLayering = (0, $7c2afb67333dd81e$export$c8b4d54e03dee6ed)(), currentLevel = _useLayering.currentLevel;
    (0, $5FkrB.useEffect)(function() {
        if (!popupRef || shouldCloseOnTab) return 0, $f729a2485b96e7ca$export$2e2bcd8739ae039;
        if (shouldDisableFocusTrap && (0, $id6Cu.fg)('platform_dst_popup-disable-focuslock')) {
            var isDropdown = popupRef.matches('[id^=ds--dropdown--]');
            var popups = document.querySelectorAll("[data-ds--level=\"".concat(currentLevel - 1, "\"]"));
            if (!(popups[popups.length - 1] && !shouldRenderToParent && isDropdown)) {
                // Plucking trigger & popup content container from the tab order so that
                // when we Shift+Tab, the focus moves to the element before trigger
                requestFrame(function() {
                    triggerRef === null || triggerRef === void 0 || triggerRef.setAttribute('tabindex', '-1');
                    if (popupRef && autoFocus) popupRef.setAttribute('tabindex', '-1');
                    (initialFocusRef || popupRef).focus();
                });
                return 0, $f729a2485b96e7ca$export$2e2bcd8739ae039;
            }
        }
        var trapConfig = {
            clickOutsideDeactivates: true,
            escapeDeactivates: true,
            initialFocus: initialFocusRef || popupRef,
            fallbackFocus: popupRef,
            returnFocusOnDeactivate: shouldReturnFocus
        };
        var focusTrap = (0, (/*@__PURE__*/$parcel$interopDefault($b6Hjk)))(popupRef, trapConfig);
        // Wait for the popup to reposition itself before we focus
        requestFrame(function() {
            focusTrap.activate();
        });
        return function() {
            cancelAllFrames();
            focusTrap.deactivate();
        };
    }, [
        popupRef,
        triggerRef,
        autoFocus,
        initialFocusRef,
        shouldCloseOnTab,
        shouldDisableFocusTrap,
        requestFrame,
        cancelAllFrames,
        shouldReturnFocus,
        shouldRenderToParent,
        currentLevel
    ]);
};


var $65ba2aa891dd693f$var$_excluded = [
    "shouldRenderToParent",
    "shouldFitContainer",
    "children",
    "appearance",
    "xcss"
];
var $65ba2aa891dd693f$var$fullWidthStyles = (0, $74Zh5.css)({
    width: '100%'
});
var $65ba2aa891dd693f$var$rootStyles = (0, $74Zh5.css)((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({
    display: 'block',
    boxSizing: 'border-box',
    zIndex: (0, $7LfsS.layers).layer(),
    backgroundColor: "var(--ds-surface-overlay, ".concat((0, $h0N4L.N0), ")"),
    borderRadius: "var(--ds-border-radius, 3px)",
    boxShadow: "var(--ds-shadow-overlay, ".concat("0 4px 8px -2px ".concat((0, $h0N4L.N50A), ", 0 0 1px ").concat((0, $h0N4L.N60A)), ")"),
    // Resetting text color for portal content.
    // Otherwise, when rendering into the parent (not using a portal),
    // the text color can be inherited from the parent.
    color: "var(--ds-text, #172B4D)"
}, (0, $5e073220336a1840$export$9d7b58831ae93caa), "var(--ds-surface-overlay, ".concat((0, $h0N4L.N0), ")")), '&:focus', {
    outline: 'none'
}));
var $65ba2aa891dd693f$var$scrollableStyles = (0, $74Zh5.css)({
    overflow: 'auto'
});
var $65ba2aa891dd693f$var$blanketStyles = (0, $74Zh5.css)({
    position: 'fixed',
    inset: 0,
    backgroundColor: "var(--ds-blanket, #091E427D)"
});
var $65ba2aa891dd693f$var$modalStyles = (0, $74Zh5.css)({
    maxHeight: '50vh',
    position: 'fixed',
    insetBlockStart: "var(--ds-space-050, 4px)",
    insetInline: "var(--ds-space-050, 4px)"
});
var $65ba2aa891dd693f$var$DefaultPopupComponent = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function(props, ref) {
    var shouldRenderToParent = props.shouldRenderToParent, shouldFitContainer = props.shouldFitContainer, children = props.children, appearance = props.appearance, xcss = props.xcss, htmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(props, $65ba2aa891dd693f$var$_excluded);
    return (0, $74Zh5.jsx)("div", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        // Because we're using Emotion local jsx namespace we have to coerce xcss prop to a string.
        // When we're fully on Compiled its local jsx namespace accepts the output of xcss prop.
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- This rule still fails because of the TS assertion
        className: xcss,
        css: [
            $65ba2aa891dd693f$var$rootStyles,
            appearance === 'UNSAFE_modal-below-sm' && $65ba2aa891dd693f$var$modalStyles,
            !shouldRenderToParent && $65ba2aa891dd693f$var$scrollableStyles,
            shouldFitContainer && $65ba2aa891dd693f$var$fullWidthStyles
        ]
    }, htmlAttributes, {
        ref: ref
    }), children);
});
function $65ba2aa891dd693f$var$PopperWrapper(_ref) {
    var xcss = _ref.xcss, isOpen = _ref.isOpen, id = _ref.id, offset = _ref.offset, testId = _ref.testId, content = _ref.content, fallbackPlacements = _ref.fallbackPlacements, onClose = _ref.onClose, boundary = _ref.boundary, rootBoundary = _ref.rootBoundary, shouldFlip = _ref.shouldFlip, _ref$placement = _ref.placement, placement = _ref$placement === void 0 ? 'auto' : _ref$placement, _ref$popupComponent = _ref.popupComponent, PopupContainer = _ref$popupComponent === void 0 ? $65ba2aa891dd693f$var$DefaultPopupComponent : _ref$popupComponent, _ref$autoFocus = _ref.autoFocus, autoFocus = _ref$autoFocus === void 0 ? true : _ref$autoFocus, triggerRef = _ref.triggerRef, shouldUseCaptureOnOutsideClick = _ref.shouldUseCaptureOnOutsideClick, shouldRenderToParent = _ref.shouldRenderToParent, shouldFitContainer = _ref.shouldFitContainer, shouldDisableFocusLock = _ref.shouldDisableFocusLock, _ref$shouldReturnFocu = _ref.shouldReturnFocus, shouldReturnFocus = _ref$shouldReturnFocu === void 0 ? true : _ref$shouldReturnFocu, strategy = _ref.strategy, role = _ref.role, label = _ref.label, titleId = _ref.titleId, modifiers = _ref.modifiers, shouldFitViewport = _ref.shouldFitViewport, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'default' : _ref$appearance;
    var _useState = (0, $5FkrB.useState)(null), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), popupRef = _useState2[0], setPopupRef = _useState2[1];
    var _useState3 = (0, $5FkrB.useState)(null), _useState4 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState3, 2), initialFocusRef = _useState4[0], setInitialFocusRef = _useState4[1];
    // We have cases where we need to close the Popup on Tab press, e.g. DropdownMenu
    var shouldCloseOnTab = shouldRenderToParent && shouldDisableFocusLock;
    var shouldDisableFocusTrap = role !== 'dialog';
    (0, $943c1c369cf4b572$export$10c5169755ce7bd7)({
        initialFocusRef: initialFocusRef,
        popupRef: popupRef,
        shouldCloseOnTab: shouldCloseOnTab,
        triggerRef: triggerRef,
        autoFocus: autoFocus,
        shouldDisableFocusTrap: shouldDisableFocusTrap,
        shouldReturnFocus: shouldReturnFocus
    });
    (0, $6b34632a0200977c$export$92dae2778ae88f9d)({
        isOpen: isOpen,
        onClose: onClose,
        popupRef: popupRef,
        triggerRef: triggerRef,
        shouldUseCaptureOnOutsideClick: shouldUseCaptureOnOutsideClick,
        shouldCloseOnTab: shouldCloseOnTab,
        autoFocus: autoFocus,
        shouldDisableFocusTrap: shouldDisableFocusTrap,
        shouldRenderToParent: shouldRenderToParent
    });
    var _useLayering = (0, $7c2afb67333dd81e$export$c8b4d54e03dee6ed)(), currentLevel = _useLayering.currentLevel;
    var mergedModifiers = (0, $5FkrB.useMemo)(function() {
        return [
            {
                name: 'flip',
                enabled: shouldFlip,
                options: {
                    rootBoundary: rootBoundary,
                    boundary: boundary,
                    fallbackPlacements: fallbackPlacements
                }
            }
        ].concat((0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(modifiers || []));
    }, [
        shouldFlip,
        rootBoundary,
        boundary,
        fallbackPlacements,
        modifiers
    ]);
    return (0, $74Zh5.jsx)((0, $b5f1341f3f605eaa$export$badac9ada3a0bdf9), {
        placement: placement,
        offset: offset,
        modifiers: mergedModifiers,
        strategy: strategy,
        shouldFitViewport: shouldFitViewport
    }, function(_ref2) {
        var _ref3 = _ref2.ref, style = _ref2.style, placement = _ref2.placement, update = _ref2.update;
        var popupContainer = (0, $74Zh5.jsx)(PopupContainer, {
            xcss: xcss,
            appearance: appearance,
            id: id,
            "data-ds--level": currentLevel,
            "data-placement": placement,
            "data-testid": testId,
            role: role,
            "aria-label": label,
            "aria-labelledby": titleId,
            ref: function ref(node) {
                if (node) {
                    if (typeof _ref3 === 'function') _ref3(node);
                    else _ref3.current = node;
                    setPopupRef(node);
                }
            },
            style: appearance === 'UNSAFE_modal-below-sm' ? {} : style,
            tabIndex: autoFocus ? 0 : undefined,
            shouldRenderToParent: shouldRenderToParent,
            shouldFitContainer: shouldFitContainer
        }, (0, $74Zh5.jsx)((0, $ce76fba466fd6140$export$51eddd7655ca235a), {
            update: update
        }, content({
            update: update,
            isOpen: isOpen,
            onClose: onClose,
            setInitialFocusRef: setInitialFocusRef
        })));
        return !initialFocusRef && (0, $id6Cu.fg)('platform-design-system-apply-popup-wrapper-focus') ? (0, $74Zh5.jsx)((0, $5FkrB.Fragment), null, (0, $74Zh5.jsx)((0, $6a910524489a0a64$export$2e2bcd8739ae039), null, popupContainer), appearance === 'UNSAFE_modal-below-sm' && (0, $74Zh5.jsx)("div", {
            css: $65ba2aa891dd693f$var$blanketStyles
        })) : (0, $74Zh5.jsx)((0, $5FkrB.Fragment), null, popupContainer, appearance === 'UNSAFE_modal-below-sm' && (0, $74Zh5.jsx)("div", {
            css: $65ba2aa891dd693f$var$blanketStyles
        }));
    });
}
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$65ba2aa891dd693f$export$2e2bcd8739ae039 = $65ba2aa891dd693f$var$PopperWrapper;



var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");

var $5FkrB = parcelRequire("5FkrB");

var $7QpUe = parcelRequire("7QpUe");

var $5FkrB = parcelRequire("5FkrB");
var $113732f55196fef1$export$e5c5a5f917a5871c = typeof window === 'undefined' ? (0, $5FkrB.useEffect) : (0, $5FkrB.useLayoutEffect);


/**
 * This is an object of usable media query helpers using our internal breakpoints configuration.
 *
 * When using Compiled CSS-in-JS, please ensure that only a single declaration can take effect at a time.
 * This means that you should avoid multiple breakpoints taking effect at the same time,
 * eg. ```{ [media.above.xs]: { color: 'red' }, [media.above.sm]: { color: 'green' }}```.
 * Instead, make sure that only one breakpoint can take effect at a time,
 * e.g, ```{ [media.only.xs]: { color: 'red' }, [media.above.sm]: { color: 'green' }}```.
 * For more details, please see <https://compiledcssinjs.com/docs/atomic-css#selector-specificity>.
 */ var $180152cdde242e72$export$987d49ffe1b0900f = {
    above: {
        xxs: '@media all',
        xs: '@media (min-width: 30rem)',
        sm: '@media (min-width: 48rem)',
        md: '@media (min-width: 64rem)',
        lg: '@media (min-width: 90rem)',
        xl: '@media (min-width: 110.5rem)'
    },
    only: {
        xxs: '@media (min-width: 0rem) and (max-width: 29.99rem)',
        xs: '@media (min-width: 30rem) and (max-width: 47.99rem)',
        sm: '@media (min-width: 48rem) and (max-width: 63.99rem)',
        md: '@media (min-width: 64rem) and (max-width: 89.99rem)',
        lg: '@media (min-width: 90rem) and (max-width: 110.49rem)',
        xl: '@media (min-width: 110.5rem)'
    },
    below: {
        xs: '@media not all and (min-width: 30rem)',
        sm: '@media not all and (min-width: 48rem)',
        md: '@media not all and (min-width: 64rem)',
        lg: '@media not all and (min-width: 90rem)',
        xl: '@media not all and (min-width: 110.5rem)'
    }
};
var $180152cdde242e72$export$c881183ca713c214 = $180152cdde242e72$export$987d49ffe1b0900f;


var $1c5e83c4fee9a7e2$var$_window, $1c5e83c4fee9a7e2$var$_window$matchMedia, $1c5e83c4fee9a7e2$var$_window2, $1c5e83c4fee9a7e2$var$_window2$matchMedia, $1c5e83c4fee9a7e2$var$_window3, $1c5e83c4fee9a7e2$var$_window3$matchMedia, $1c5e83c4fee9a7e2$var$_window4, $1c5e83c4fee9a7e2$var$_window4$matchMedia, $1c5e83c4fee9a7e2$var$_window5, $1c5e83c4fee9a7e2$var$_window5$matchMedia, $1c5e83c4fee9a7e2$var$_window6, $1c5e83c4fee9a7e2$var$_window6$matchMedia, $1c5e83c4fee9a7e2$var$_window7, $1c5e83c4fee9a7e2$var$_window7$matchMedia, $1c5e83c4fee9a7e2$var$_window8, $1c5e83c4fee9a7e2$var$_window8$matchMedia, $1c5e83c4fee9a7e2$var$_window9, $1c5e83c4fee9a7e2$var$_window9$matchMedia, $1c5e83c4fee9a7e2$var$_window10, $1c5e83c4fee9a7e2$var$_window10$matchMedia, $1c5e83c4fee9a7e2$var$_window11, $1c5e83c4fee9a7e2$var$_window11$matchMedia;
var $1c5e83c4fee9a7e2$var$queries = {
    'above.xxs': typeof window === 'undefined' ? undefined : ($1c5e83c4fee9a7e2$var$_window = window) === null || $1c5e83c4fee9a7e2$var$_window === void 0 || ($1c5e83c4fee9a7e2$var$_window$matchMedia = $1c5e83c4fee9a7e2$var$_window.matchMedia) === null || $1c5e83c4fee9a7e2$var$_window$matchMedia === void 0 ? void 0 : $1c5e83c4fee9a7e2$var$_window$matchMedia.call($1c5e83c4fee9a7e2$var$_window, (0, $180152cdde242e72$export$c881183ca713c214).above.xxs.replace('@media ', '').trim()),
    'above.xs': typeof window === 'undefined' ? undefined : ($1c5e83c4fee9a7e2$var$_window2 = window) === null || $1c5e83c4fee9a7e2$var$_window2 === void 0 || ($1c5e83c4fee9a7e2$var$_window2$matchMedia = $1c5e83c4fee9a7e2$var$_window2.matchMedia) === null || $1c5e83c4fee9a7e2$var$_window2$matchMedia === void 0 ? void 0 : $1c5e83c4fee9a7e2$var$_window2$matchMedia.call($1c5e83c4fee9a7e2$var$_window2, (0, $180152cdde242e72$export$c881183ca713c214).above.xs.replace('@media ', '').trim()),
    'above.sm': typeof window === 'undefined' ? undefined : ($1c5e83c4fee9a7e2$var$_window3 = window) === null || $1c5e83c4fee9a7e2$var$_window3 === void 0 || ($1c5e83c4fee9a7e2$var$_window3$matchMedia = $1c5e83c4fee9a7e2$var$_window3.matchMedia) === null || $1c5e83c4fee9a7e2$var$_window3$matchMedia === void 0 ? void 0 : $1c5e83c4fee9a7e2$var$_window3$matchMedia.call($1c5e83c4fee9a7e2$var$_window3, (0, $180152cdde242e72$export$c881183ca713c214).above.sm.replace('@media ', '').trim()),
    'above.md': typeof window === 'undefined' ? undefined : ($1c5e83c4fee9a7e2$var$_window4 = window) === null || $1c5e83c4fee9a7e2$var$_window4 === void 0 || ($1c5e83c4fee9a7e2$var$_window4$matchMedia = $1c5e83c4fee9a7e2$var$_window4.matchMedia) === null || $1c5e83c4fee9a7e2$var$_window4$matchMedia === void 0 ? void 0 : $1c5e83c4fee9a7e2$var$_window4$matchMedia.call($1c5e83c4fee9a7e2$var$_window4, (0, $180152cdde242e72$export$c881183ca713c214).above.md.replace('@media ', '').trim()),
    'above.lg': typeof window === 'undefined' ? undefined : ($1c5e83c4fee9a7e2$var$_window5 = window) === null || $1c5e83c4fee9a7e2$var$_window5 === void 0 || ($1c5e83c4fee9a7e2$var$_window5$matchMedia = $1c5e83c4fee9a7e2$var$_window5.matchMedia) === null || $1c5e83c4fee9a7e2$var$_window5$matchMedia === void 0 ? void 0 : $1c5e83c4fee9a7e2$var$_window5$matchMedia.call($1c5e83c4fee9a7e2$var$_window5, (0, $180152cdde242e72$export$c881183ca713c214).above.lg.replace('@media ', '').trim()),
    'above.xl': typeof window === 'undefined' ? undefined : ($1c5e83c4fee9a7e2$var$_window6 = window) === null || $1c5e83c4fee9a7e2$var$_window6 === void 0 || ($1c5e83c4fee9a7e2$var$_window6$matchMedia = $1c5e83c4fee9a7e2$var$_window6.matchMedia) === null || $1c5e83c4fee9a7e2$var$_window6$matchMedia === void 0 ? void 0 : $1c5e83c4fee9a7e2$var$_window6$matchMedia.call($1c5e83c4fee9a7e2$var$_window6, (0, $180152cdde242e72$export$c881183ca713c214).above.xl.replace('@media ', '').trim()),
    'below.xs': typeof window === 'undefined' ? undefined : ($1c5e83c4fee9a7e2$var$_window7 = window) === null || $1c5e83c4fee9a7e2$var$_window7 === void 0 || ($1c5e83c4fee9a7e2$var$_window7$matchMedia = $1c5e83c4fee9a7e2$var$_window7.matchMedia) === null || $1c5e83c4fee9a7e2$var$_window7$matchMedia === void 0 ? void 0 : $1c5e83c4fee9a7e2$var$_window7$matchMedia.call($1c5e83c4fee9a7e2$var$_window7, (0, $180152cdde242e72$export$c881183ca713c214).below.xs.replace('@media ', '').trim()),
    'below.sm': typeof window === 'undefined' ? undefined : ($1c5e83c4fee9a7e2$var$_window8 = window) === null || $1c5e83c4fee9a7e2$var$_window8 === void 0 || ($1c5e83c4fee9a7e2$var$_window8$matchMedia = $1c5e83c4fee9a7e2$var$_window8.matchMedia) === null || $1c5e83c4fee9a7e2$var$_window8$matchMedia === void 0 ? void 0 : $1c5e83c4fee9a7e2$var$_window8$matchMedia.call($1c5e83c4fee9a7e2$var$_window8, (0, $180152cdde242e72$export$c881183ca713c214).below.sm.replace('@media ', '').trim()),
    'below.md': typeof window === 'undefined' ? undefined : ($1c5e83c4fee9a7e2$var$_window9 = window) === null || $1c5e83c4fee9a7e2$var$_window9 === void 0 || ($1c5e83c4fee9a7e2$var$_window9$matchMedia = $1c5e83c4fee9a7e2$var$_window9.matchMedia) === null || $1c5e83c4fee9a7e2$var$_window9$matchMedia === void 0 ? void 0 : $1c5e83c4fee9a7e2$var$_window9$matchMedia.call($1c5e83c4fee9a7e2$var$_window9, (0, $180152cdde242e72$export$c881183ca713c214).below.md.replace('@media ', '').trim()),
    'below.lg': typeof window === 'undefined' ? undefined : ($1c5e83c4fee9a7e2$var$_window10 = window) === null || $1c5e83c4fee9a7e2$var$_window10 === void 0 || ($1c5e83c4fee9a7e2$var$_window10$matchMedia = $1c5e83c4fee9a7e2$var$_window10.matchMedia) === null || $1c5e83c4fee9a7e2$var$_window10$matchMedia === void 0 ? void 0 : $1c5e83c4fee9a7e2$var$_window10$matchMedia.call($1c5e83c4fee9a7e2$var$_window10, (0, $180152cdde242e72$export$c881183ca713c214).below.lg.replace('@media ', '').trim()),
    'below.xl': typeof window === 'undefined' ? undefined : ($1c5e83c4fee9a7e2$var$_window11 = window) === null || $1c5e83c4fee9a7e2$var$_window11 === void 0 || ($1c5e83c4fee9a7e2$var$_window11$matchMedia = $1c5e83c4fee9a7e2$var$_window11.matchMedia) === null || $1c5e83c4fee9a7e2$var$_window11$matchMedia === void 0 ? void 0 : $1c5e83c4fee9a7e2$var$_window11$matchMedia.call($1c5e83c4fee9a7e2$var$_window11, (0, $180152cdde242e72$export$c881183ca713c214).below.xl.replace('@media ', '').trim())
};
var $1c5e83c4fee9a7e2$export$49e55ae2c03d6045 = function UNSAFE_useMediaQuery(queryString, listener) {
    var listenerRef = (0, $5FkrB.useRef)(listener);
    (0, $5FkrB.useEffect)(function() {
        // Bind the listener if changed so it's called on the next change event; no guarantee on timing.
        listenerRef.current = listener;
    }, [
        listener
    ]);
    /**
   * We explicitly only react to boolean changes for binding our listener
   * Changes to the functional reference are ignored.
   */ var hasListener = !!listener;
    /**
   * The `matchMedia(…)` return value for our breakpoint query.
   */ var mq = $1c5e83c4fee9a7e2$var$queries[queryString];
    (0, $113732f55196fef1$export$e5c5a5f917a5871c)(function() {
        listenerRef.current = listener; // Bind the listener now in case the `useEffect` hasn't fired above yet
        if (!mq || !hasListener || !listenerRef.current) return;
        return (0, $7QpUe.bind)(mq, {
            type: 'change',
            listener: function listener(event) {
                // We explicitly call the current version of the function
                return listenerRef.current(event);
            }
        });
    }, // eslint-disable-next-line react-hooks/exhaustive-deps -- explicitly do not trigger the effect on `listener` reference change, only on a boolean representation of it.
    [
        mq,
        hasListener
    ]);
    return mq || null;
};


function $ee87e607ccd5e78b$export$4065aef1d79a5730(_ref) {
    var _appearance = _ref.appearance, _shouldRenderToParent = _ref.shouldRenderToParent;
    var mq = (0, $1c5e83c4fee9a7e2$export$49e55ae2c03d6045)('below.sm', function(e) {
        setIsSmallViewport(!!e.matches);
    });
    var _useState = (0, $5FkrB.useState)(!!(mq !== null && mq !== void 0 && mq.matches)), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), isSmallViewport = _useState2[0], setIsSmallViewport = _useState2[1];
    var appearance = _appearance === 'UNSAFE_modal-below-sm' && isSmallViewport ? 'UNSAFE_modal-below-sm' : 'default';
    var shouldRenderToParent = _shouldRenderToParent && appearance === 'default';
    return {
        appearance: appearance,
        shouldRenderToParent: shouldRenderToParent
    };
}



var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");

var $cvlyC = parcelRequire("cvlyC");
var $c524fae255ec2239$export$7cc5c058dd769dff = function useGetMemoizedMergedTriggerRef() {
    var _useState = (0, $5FkrB.useState)(function() {
        return (0, $cvlyC.default)(function(ref, setTriggerRef, isOpen) {
            return function(node) {
                if (node && isOpen) {
                    if (typeof ref === 'function') ref(node);
                    else if (ref) ref.current = node;
                    setTriggerRef(node);
                }
            };
        });
    }), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 1), getMemoizedMergedTriggerRef = _useState2[0];
    return getMemoizedMergedTriggerRef;
};



var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");

var $cvlyC = parcelRequire("cvlyC");
var $dfae8385d3369fa4$export$5d3a2de79e07b376 = function useGetMemoizedMergedTriggerRefNew() {
    var _useState = (0, $5FkrB.useState)(function() {
        return (0, $cvlyC.default)(function(ref, setTriggerRef) {
            return function(node) {
                if (node) {
                    if (typeof ref === 'function') ref(node);
                    else if (ref) ref.current = node;
                    setTriggerRef(node);
                }
            };
        });
    }), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 1), getMemoizedMergedTriggerRefNew = _useState2[0];
    return getMemoizedMergedTriggerRefNew;
};


var $bfb6f627239e1427$var$defaultLayer = (0, $7LfsS.layers).layer();
var $bfb6f627239e1427$var$wrapperStyles = (0, $d7pIx.xcss)({
    position: 'relative'
});
var $bfb6f627239e1427$export$129a32eedafa97c5 = /*#__PURE__*/ (0, $5FkrB.memo)(function(_ref) {
    var xcss = _ref.xcss, _ref$appearance = _ref.appearance, inAppearance = _ref$appearance === void 0 ? 'default' : _ref$appearance, isOpen = _ref.isOpen, providedId = _ref.id, offset = _ref.offset, testId = _ref.testId, trigger = _ref.trigger, content = _ref.content, onClose = _ref.onClose, boundary = _ref.boundary, _ref$rootBoundary = _ref.rootBoundary, rootBoundary = _ref$rootBoundary === void 0 ? 'viewport' : _ref$rootBoundary, _ref$shouldFlip = _ref.shouldFlip, shouldFlip = _ref$shouldFlip === void 0 ? true : _ref$shouldFlip, _ref$placement = _ref.placement, placement = _ref$placement === void 0 ? 'auto' : _ref$placement, fallbackPlacements = _ref.fallbackPlacements, PopupContainer = _ref.popupComponent, _ref$autoFocus = _ref.autoFocus, autoFocus = _ref$autoFocus === void 0 ? true : _ref$autoFocus, _ref$zIndex = _ref.zIndex, zIndex = _ref$zIndex === void 0 ? $bfb6f627239e1427$var$defaultLayer : _ref$zIndex, _ref$shouldUseCapture = _ref.shouldUseCaptureOnOutsideClick, shouldUseCaptureOnOutsideClick = _ref$shouldUseCapture === void 0 ? false : _ref$shouldUseCapture, _ref$shouldRenderToPa = _ref.shouldRenderToParent, inShouldRenderToParent = _ref$shouldRenderToPa === void 0 ? false : _ref$shouldRenderToPa, _ref$shouldFitContain = _ref.shouldFitContainer, shouldFitContainer = _ref$shouldFitContain === void 0 ? false : _ref$shouldFitContain, _ref$shouldDisableFoc = _ref.shouldDisableFocusLock, shouldDisableFocusLock = _ref$shouldDisableFoc === void 0 ? false : _ref$shouldDisableFoc, _ref$shouldReturnFocu = _ref.shouldReturnFocus, shouldReturnFocus = _ref$shouldReturnFocu === void 0 ? true : _ref$shouldReturnFocu, strategy = _ref.strategy, role = _ref.role, label = _ref.label, titleId = _ref.titleId, modifiers = _ref.modifiers, shouldFitViewport = _ref.shouldFitViewport;
    var _useState = (0, $5FkrB.useState)(null), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), triggerRef = _useState2[0], setTriggerRef = _useState2[1];
    var getMergedTriggerRef = (0, $c524fae255ec2239$export$7cc5c058dd769dff)();
    var getMergedTriggerRefNew = (0, $dfae8385d3369fa4$export$5d3a2de79e07b376)();
    var generatedId = (0, $13bc4d6429052436$export$f680877a34711e37)();
    var _usePopupAppearance = (0, $ee87e607ccd5e78b$export$4065aef1d79a5730)({
        appearance: inAppearance,
        shouldRenderToParent: inShouldRenderToParent
    }), appearance = _usePopupAppearance.appearance, shouldRenderToParent = _usePopupAppearance.shouldRenderToParent;
    var id = providedId || generatedId;
    (0, $1b596479f17c86b4$export$469bb693f11edc7f)({
        isOpen: isOpen
    });
    var renderPopperWrapper = (0, $74Zh5.jsx)((0, $e16c542a93602879$export$7c885f891c940977), {
        isDisabled: false
    }, (0, $74Zh5.jsx)((0, $65ba2aa891dd693f$export$2e2bcd8739ae039), {
        xcss: xcss,
        appearance: appearance,
        content: content,
        isOpen: isOpen,
        placement: placement,
        fallbackPlacements: fallbackPlacements,
        boundary: boundary,
        rootBoundary: rootBoundary,
        shouldFlip: shouldFlip,
        offset: offset,
        popupComponent: PopupContainer,
        id: id,
        testId: testId,
        onClose: onClose,
        autoFocus: autoFocus,
        shouldUseCaptureOnOutsideClick: shouldUseCaptureOnOutsideClick,
        shouldRenderToParent: shouldRenderToParent || shouldFitContainer,
        shouldFitContainer: shouldFitContainer,
        shouldDisableFocusLock: shouldDisableFocusLock,
        shouldReturnFocus: shouldReturnFocus,
        triggerRef: triggerRef,
        strategy: shouldFitContainer ? 'absolute' : strategy,
        role: role,
        label: label,
        titleId: titleId,
        modifiers: modifiers,
        shouldFitViewport: shouldFitViewport
    }));
    var popupContent = (0, $74Zh5.jsx)((0, $hvYLl.Manager), null, (0, $74Zh5.jsx)((0, $agyC9.Reference), null, function(_ref2) {
        var ref = _ref2.ref;
        return trigger({
            ref: !(0, $id6Cu.fg)('platform-design-system-popup-ref') ? getMergedTriggerRef(ref, setTriggerRef, isOpen) : getMergedTriggerRefNew(ref, setTriggerRef),
            'aria-controls': isOpen ? id : undefined,
            'aria-expanded': isOpen,
            'aria-haspopup': role === 'dialog' && (0, $id6Cu.fg)('platform_dst_popup-disable-focuslock') ? 'dialog' : true
        });
    }), isOpen && (shouldRenderToParent || shouldFitContainer ? renderPopperWrapper : (0, $74Zh5.jsx)((0, $4fb6ce5614cd87f1$export$2e2bcd8739ae039), {
        zIndex: zIndex
    }, renderPopperWrapper)));
    if (shouldFitContainer) return (0, $74Zh5.jsx)((0, $ayeN2.default), {
        xcss: $bfb6f627239e1427$var$wrapperStyles
    }, popupContent);
    return popupContent;
});
var $bfb6f627239e1427$export$2e2bcd8739ae039 = $bfb6f627239e1427$export$129a32eedafa97c5;


var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$48dcb268e58c3c27$export$2e2bcd8739ae039 = (0, $bfb6f627239e1427$export$129a32eedafa97c5);



var $7LfsS = parcelRequire("7LfsS");

var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");

var $7QpUe = parcelRequire("7QpUe");



var $25nEq = parcelRequire("25nEq");


var $id6Cu = parcelRequire("id6Cu");

var $d89fd6a28514603b$export$8a682ae47622dbb9 = 'ds--dropdown--';
function $d89fd6a28514603b$export$2e2bcd8739ae039() {
    var id = (0, $13bc4d6429052436$export$f680877a34711e37)();
    return "".concat($d89fd6a28514603b$export$8a682ae47622dbb9).concat(id);
}


var $4786c8943396b8dd$var$actionMap = (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, (0, $ebec22bc85089a5d$export$a80636c6f41931fe), 'next'), (0, $ebec22bc85089a5d$export$390330c10ff2b9a1), 'prev'), (0, $ebec22bc85089a5d$export$4af703091671bc), 'first'), (0, $ebec22bc85089a5d$export$e2bc30913faa5db7), 'last');
/**
 * `currentFocusedIdx + 1` will not work if the next focusable element
 * is disabled. So, we need to iterate through the following menu items
 * to find one that isn't disabled. If all following elements are disabled,
 * return undefined.
 */ var $4786c8943396b8dd$var$getNextFocusableElement = function getNextFocusableElement(refs, currentFocusedIdx) {
    while(currentFocusedIdx + 1 < refs.length){
        var element = refs[++currentFocusedIdx].current;
        var isValid = !!element && !element.hasAttribute('disabled');
        if (isValid) return element;
    }
};
/**
 * `currentFocusedIdx - 1` will not work if the prev focusable element
 * is disabled. So, we need to iterate through the previous menu items
 * to find one that isn't disabled. If all previous elements are disabled,
 * return undefined.
 */ var $4786c8943396b8dd$var$getPrevFocusableElement = function getPrevFocusableElement(refs, currentFocusedIdx) {
    while(currentFocusedIdx > 0){
        var element = refs[--currentFocusedIdx].current;
        var isValid = !!element && !element.hasAttribute('disabled');
        if (isValid) return element;
    }
};
function $4786c8943396b8dd$export$2e2bcd8739ae039(refs, isLayerDisabled, onClose) {
    return function(e) {
        var _refs$current;
        var currentRefs = (_refs$current = refs.current) !== null && _refs$current !== void 0 ? _refs$current : [];
        var currentFocusedIdx = currentRefs.findIndex(function(_ref) {
            var _document$activeEleme;
            var el = _ref.current;
            return el && ((_document$activeEleme = document.activeElement) === null || _document$activeEleme === void 0 ? void 0 : _document$activeEleme.isSameNode(el));
        });
        if ((0, $id6Cu.fg)('platform_dst_popup-disable-focuslock')) {
            var _document$activeEleme2;
            // if we use a popup as a nested dropdown, we must prevent the dropdown from closing.
            var isNestedDropdown = !!((_document$activeEleme2 = document.activeElement) !== null && _document$activeEleme2 !== void 0 && _document$activeEleme2.closest("[id^=".concat((0, $d89fd6a28514603b$export$8a682ae47622dbb9), "]")));
            if (isLayerDisabled() && isNestedDropdown) {
                if (e.key === (0, $ebec22bc85089a5d$export$10f6869ed0a7d75b) && !e.shiftKey) onClose(e);
                // if it is a nested dropdown and the level of the given dropdown is not the current level,
                // we don't need to have focus on it
                return;
            }
        } else if (isLayerDisabled()) {
            if (e.key === (0, $ebec22bc85089a5d$export$10f6869ed0a7d75b) && !e.shiftKey) onClose(e);
            // if it is a nested dropdown and the level of the given dropdown is not the current level,
            // we don't need to have focus on it
            return;
        }
        var action = $4786c8943396b8dd$var$actionMap[e.key];
        switch(action){
            case 'next':
                // Always cancelling the event to prevent scrolling
                e.preventDefault();
                if (currentFocusedIdx < currentRefs.length - 1) {
                    var _nextFocusableElement = $4786c8943396b8dd$var$getNextFocusableElement(currentRefs, currentFocusedIdx);
                    _nextFocusableElement === null || _nextFocusableElement === void 0 || _nextFocusableElement.focus();
                } else {
                    var firstFocusableElement = $4786c8943396b8dd$var$getNextFocusableElement(currentRefs, -1);
                    firstFocusableElement === null || firstFocusableElement === void 0 || firstFocusableElement.focus();
                }
                break;
            case 'prev':
                // Always cancelling the event to prevent scrolling
                e.preventDefault();
                if (currentFocusedIdx > 0) {
                    var _prevFocusableElement = $4786c8943396b8dd$var$getPrevFocusableElement(currentRefs, currentFocusedIdx);
                    _prevFocusableElement === null || _prevFocusableElement === void 0 || _prevFocusableElement.focus();
                } else {
                    var lastFocusableElement = $4786c8943396b8dd$var$getPrevFocusableElement(currentRefs, currentRefs.length);
                    lastFocusableElement === null || lastFocusableElement === void 0 || lastFocusableElement.focus();
                }
                break;
            case 'first':
                e.preventDefault();
                // Search for first non-disabled element if first element is disabled
                var nextFocusableElement = $4786c8943396b8dd$var$getNextFocusableElement(currentRefs, -1);
                nextFocusableElement === null || nextFocusableElement === void 0 || nextFocusableElement.focus();
                break;
            case 'last':
                e.preventDefault();
                // Search for last non-disabled element if last element is disabled
                var prevFocusableElement = $4786c8943396b8dd$var$getPrevFocusableElement(currentRefs, currentRefs.length);
                prevFocusableElement === null || prevFocusableElement === void 0 || prevFocusableElement.focus();
                break;
            default:
                return;
        }
    };
}


var $b6650f5cfeeb801b$export$f18c1d4fc7326096 = /*#__PURE__*/ (0, $5FkrB.createContext)({
    menuItemRefs: [],
    registerRef: (0, $f729a2485b96e7ca$export$2e2bcd8739ae039)
});
/**
 * Focus manager logic.
 */ var $b6650f5cfeeb801b$var$FocusManager = function FocusManager(_ref) {
    var children = _ref.children, onClose = _ref.onClose;
    var menuItemRefs = (0, $5FkrB.useRef)([]);
    // Used to force a re-render only
    var _useState = (0, $5FkrB.useState)(0), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), refresh = _useState2[0], setRefresh = _useState2[1];
    var registerMode = (0, $5FkrB.useRef)('ordered');
    registerMode.current = 'ordered';
    var registerRef = (0, $5FkrB.useCallback)(function(ref) {
        if (menuItemRefs.current.includes(ref)) return;
        switch(registerMode.current){
            case 'ordered':
                menuItemRefs.current.push(ref);
                break;
            case 'unordered':
                // Reset and force a rerender
                registerMode.current = 'regenerate';
                menuItemRefs.current = [];
                setRefresh(refresh + 1);
                break;
            case 'regenerate':
                break;
            default:
                throw new Error("Unexpected case of ".concat(registerMode.current));
        }
    }, // Updating register ref on force reload will cause `useRegisterItemWithFocusManager` to re-register
    [
        refresh
    ]);
    var _useLayering = (0, $7c2afb67333dd81e$export$c8b4d54e03dee6ed)(), isLayerDisabled = _useLayering.isLayerDisabled;
    // Intentionally rebinding on each render
    (0, $5FkrB.useEffect)(function() {
        if (registerMode.current === 'ordered') // Use effect is called after rendering is complete and useEffects of the children a called first
        registerMode.current = 'unordered';
    });
    (0, $5FkrB.useEffect)(function() {
        return (0, $7QpUe.bind)(window, {
            type: 'keydown',
            listener: (0, $4786c8943396b8dd$export$2e2bcd8739ae039)(menuItemRefs, isLayerDisabled, onClose)
        });
    }, [
        isLayerDisabled,
        onClose
    ]);
    var contextValue = {
        menuItemRefs: menuItemRefs.current,
        registerRef: registerRef
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement($b6650f5cfeeb801b$export$f18c1d4fc7326096.Provider, {
        value: contextValue
    }, children);
};
var $b6650f5cfeeb801b$export$2e2bcd8739ae039 = $b6650f5cfeeb801b$var$FocusManager;


/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5FkrB = parcelRequire("5FkrB");

var $74Zh5 = parcelRequire("74Zh5");

var $kqp0i = parcelRequire("kqp0i");

var $1Vcia = parcelRequire("1Vcia");

var $74Zh5 = parcelRequire("74Zh5");

var $5FkrB = parcelRequire("5FkrB");
var $a69a838f3ece1f03$export$443076ec7ebce042 = /*#__PURE__*/ (0, $5FkrB.createContext)('cozy');
var $a69a838f3ece1f03$export$9ca534b70725964d = /*#__PURE__*/ (0, $5FkrB.createContext)('border');


var $df54efe8f0edd712$var$_excluded = [
    "isLoading",
    "maxWidth",
    "minWidth",
    "minHeight",
    "maxHeight",
    "testId",
    "role",
    "spacing",
    "className"
];
var $df54efe8f0edd712$var$baseStyles = (0, $74Zh5.css)({
    display: 'flex',
    position: 'static',
    flexDirection: 'column',
    overflow: 'auto'
});
/**
 * __Menu group__
 *
 * A menu group includes all the actions or items in a menu.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/menu/docs/menu-group)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/menu)
 */ var $df54efe8f0edd712$var$MenuGroup = function MenuGroup(_ref) {
    var isLoading = _ref.isLoading, maxWidth = _ref.maxWidth, minWidth = _ref.minWidth, minHeight = _ref.minHeight, maxHeight = _ref.maxHeight, testId = _ref.testId, role = _ref.role, _ref$spacing = _ref.spacing, spacing = _ref$spacing === void 0 ? 'cozy' : _ref$spacing, UNSAFE_className = _ref.className, rest = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $df54efe8f0edd712$var$_excluded);
    return (0, $74Zh5.jsx)((0, $a69a838f3ece1f03$export$443076ec7ebce042).Provider, {
        value: spacing
    }, (0, $74Zh5.jsx)((0, $a69a838f3ece1f03$export$9ca534b70725964d).Provider, {
        value: "border"
    }, (0, $74Zh5.jsx)("div", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        "aria-busy": isLoading,
        style: {
            minWidth: minWidth,
            maxWidth: maxWidth,
            minHeight: minHeight,
            maxHeight: maxHeight
        },
        css: $df54efe8f0edd712$var$baseStyles,
        "data-testid": testId,
        role: role,
        className: UNSAFE_className
    }, rest))));
};
var $df54efe8f0edd712$export$2e2bcd8739ae039 = $df54efe8f0edd712$var$MenuGroup;



var $ayeN2 = parcelRequire("ayeN2");
var $d7pIx = parcelRequire("d7pIx");
/* spinner.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $970q7 = parcelRequire("970q7");

var $5FkrB = parcelRequire("5FkrB");

var $5FkrB = parcelRequire("5FkrB");
var $d5945232f5ecfdf7$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $5FkrB.createContext)(null);



var $h0N4L = parcelRequire("h0N4L");
var $7161634275f4a7d5$export$4e9f1640bbe7a1a8 = {
    xsmall: 8,
    small: 16,
    medium: 24,
    large: 48,
    xlarge: 96
};


/**
 * Returns the appropriate circle stroke color.
 */ function $17adbdbd6d48fe78$var$getStrokeColor(appearance) {
    return appearance === 'inherit' ? "var(--ds-icon-subtle, ".concat((0, $h0N4L.N500), ")") : "var(--ds-icon-inverse, ".concat((0, $h0N4L.N0), ")");
}
var $17adbdbd6d48fe78$var$rotate = null;
/**
 * There are three parts to the load in animation:
 * 1. Fade in
 * 2. Accelerated spin
 * 3. Stretch the spinner line
 */ var $17adbdbd6d48fe78$var$loadIn = null;
var $17adbdbd6d48fe78$var$styles = {
    rotateStyles: "_y44v1ozz _1pgl2qsq _8hrz1h6o",
    loadInStyles: "_y44v1a7z _1o51q7pw _tzy4idpf",
    wrapperStyles: "_1e0c116y _s7n4nkob",
    circleStyles: "_lswuglyw _7ljx1dhp _opj11kw7 _134c892t _1snbbs82 _jcxd7g3v _1tjm1onz"
};
/**
 * `useLayoutEffect` is being used in SSR safe form. On the server, this work doesn’t need to run.
 * `useEffect` is used in-place, because `useEffect` is not run on the server and it matches types
 * which makes things simpler than doing an `isServer` check or a `null` check.
 *
 * @see https://hello.atlassian.net/wiki/spaces/DST/pages/2081696628/DSTDACI-010+-+Interaction+Tracing+hooks+in+DS+components
 */ var $17adbdbd6d48fe78$var$useLayoutEffect = typeof window === 'undefined' ? (0, $5FkrB.useEffect) : (0, $5FkrB.useLayoutEffect);
/**
 * __Spinner__
 *
 * A spinner is an animated spinning icon that lets users know content is being loaded.
 *
 * - [Examples](https://atlassian.design/components/spinner/examples)
 * - [Code](https://atlassian.design/components/spinner/code)
 * - [Usage](https://atlassian.design/components/spinner/usage)
 */ var $17adbdbd6d48fe78$var$Spinner = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).forwardRef(function Spinner(_ref, ref) {
    var _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'inherit' : _ref$appearance, _ref$delay = _ref.delay, delay = _ref$delay === void 0 ? 0 : _ref$delay, interactionName = _ref.interactionName, label = _ref.label, _ref$size = _ref.size, providedSize = _ref$size === void 0 ? 'medium' : _ref$size, testId = _ref.testId;
    var size = typeof providedSize === 'number' ? providedSize : (0, $7161634275f4a7d5$export$4e9f1640bbe7a1a8)[providedSize];
    var animationDelay = "".concat(delay, "ms");
    var stroke = $17adbdbd6d48fe78$var$getStrokeColor(appearance);
    var context = (0, $5FkrB.useContext)((0, $d5945232f5ecfdf7$export$2e2bcd8739ae039));
    $17adbdbd6d48fe78$var$useLayoutEffect(function() {
        if (context != null) return context.hold(interactionName);
    }, [
        context,
        interactionName
    ]);
    /**
   * The Spinner animation uses a combination of two
   * css animations on two separate elements.
   */ return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("span", {
        "data-testid": testId ? "".concat(testId, "-wrapper") : 'spinner-wrapper',
        style: {
            animationDelay: animationDelay,
            width: size,
            height: size
        },
        className: (0, $970q7.default)([
            $17adbdbd6d48fe78$var$styles.wrapperStyles,
            $17adbdbd6d48fe78$var$styles.rotateStyles
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("svg", {
        height: size,
        width: size,
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg",
        "data-testid": testId,
        ref: ref,
        "aria-label": label || undefined,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            animationDelay: animationDelay
        },
        role: label ? 'img' : 'none',
        className: (0, $970q7.default)([
            $17adbdbd6d48fe78$var$styles.loadInStyles
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("circle", {
        cx: "8",
        cy: "8",
        r: "7",
        style: {
            stroke: stroke
        },
        className: (0, $970q7.default)([
            $17adbdbd6d48fe78$var$styles.circleStyles
        ])
    })));
}));
var $17adbdbd6d48fe78$export$2e2bcd8739ae039 = $17adbdbd6d48fe78$var$Spinner;


function $a6cbed40d753ce17$export$2e2bcd8739ae039(element) {
    var role = element.getAttribute('role');
    return role === 'checkbox' || role === 'menuitemcheckbox';
}


function $912dcfa14ef54cfd$export$2e2bcd8739ae039(element) {
    var role = element.getAttribute('role');
    return role === 'radio' || role === 'menuitemradio';
}



var $2aafcb309569ef8f$var$spinnerContainerStyles = (0, $d7pIx.xcss)({
    display: 'flex',
    minWidth: '160px',
    padding: 'space.250',
    justifyContent: 'center'
});
var $2aafcb309569ef8f$var$LoadingIndicator = function LoadingIndicator(_ref) {
    var _ref$statusLabel = _ref.statusLabel, statusLabel = _ref$statusLabel === void 0 ? 'Loading' : _ref$statusLabel, testId = _ref.testId;
    return (0, $74Zh5.jsx)((0, $ayeN2.default), {
        xcss: $2aafcb309569ef8f$var$spinnerContainerStyles
    }, (0, $74Zh5.jsx)((0, $17adbdbd6d48fe78$export$2e2bcd8739ae039), {
        size: "small",
        label: statusLabel,
        testId: testId
    }));
};
/**
 *
 * MenuWrapper wraps all the menu items.
 * It handles the logic to close the menu when a MenuItem is clicked, but leaves it open
 * if a CheckboxItem or RadioItem is clicked.
 * It also sets focus to the first menu item when opened.
 */ var $2aafcb309569ef8f$var$MenuWrapper = function MenuWrapper(_ref2) {
    var children = _ref2.children, isLoading = _ref2.isLoading, maxHeight = _ref2.maxHeight, maxWidth = _ref2.maxWidth, onClose = _ref2.onClose, onUpdate = _ref2.onUpdate, statusLabel = _ref2.statusLabel, setInitialFocusRef = _ref2.setInitialFocusRef, shouldRenderToParent = _ref2.shouldRenderToParent, spacing = _ref2.spacing, testId = _ref2.testId, isTriggeredUsingKeyboard = _ref2.isTriggeredUsingKeyboard, autoFocus = _ref2.autoFocus;
    var _useContext = (0, $5FkrB.useContext)((0, $b6650f5cfeeb801b$export$f18c1d4fc7326096)), menuItemRefs = _useContext.menuItemRefs;
    var closeOnMenuItemClick = function closeOnMenuItemClick(e) {
        var isTargetMenuItemOrDescendant = menuItemRefs.some(function(menuItemRef) {
            var menuItem = menuItemRef.current;
            if (!menuItem) return false;
            var isCheckboxOrRadio = (0, $a6cbed40d753ce17$export$2e2bcd8739ae039)(menuItem) || (0, $912dcfa14ef54cfd$export$2e2bcd8739ae039)(menuItem);
            return menuItem.contains(e.target) && !isCheckboxOrRadio;
        });
        // Close menu if the click is triggered from a MenuItem or
        // its descendant. Don't close the menu if the click is triggered
        // from a MenuItemRadio or MenuItemCheckbox so that the user can
        // select multiple items.
        if (isTargetMenuItemOrDescendant && onClose) onClose(e);
    };
    // Using useEffect here causes a flicker.
    // useLayoutEffect ensures that the update and render happen in the same
    // rAF tick.
    (0, $5FkrB.useLayoutEffect)(function() {
        onUpdate();
    }, [
        isLoading,
        onUpdate
    ]);
    (0, $5FkrB.useEffect)(function() {
        var _menuItemRefs$map$fin;
        var firstFocusableRef = (_menuItemRefs$map$fin = menuItemRefs.map(function(_ref3) {
            var current = _ref3.current;
            return current;
        }).find(function(el) {
            return !!el && !el.hasAttribute('disabled');
        })) !== null && _menuItemRefs$map$fin !== void 0 ? _menuItemRefs$map$fin : null;
        if (shouldRenderToParent && (isTriggeredUsingKeyboard || autoFocus)) firstFocusableRef === null || firstFocusableRef === void 0 || firstFocusableRef.focus();
        setInitialFocusRef === null || setInitialFocusRef === void 0 || setInitialFocusRef(firstFocusableRef);
    }, [
        menuItemRefs,
        setInitialFocusRef,
        autoFocus,
        shouldRenderToParent,
        isTriggeredUsingKeyboard
    ]);
    return (0, $74Zh5.jsx)((0, $df54efe8f0edd712$export$2e2bcd8739ae039), {
        isLoading: isLoading,
        maxHeight: maxHeight,
        maxWidth: maxWidth,
        onClick: closeOnMenuItemClick,
        role: "menu",
        spacing: spacing,
        testId: testId && "".concat(testId, "--menu-group")
    }, isLoading ? (0, $74Zh5.jsx)($2aafcb309569ef8f$var$LoadingIndicator, {
        statusLabel: statusLabel,
        testId: testId && "".concat(testId, "--loading-indicator")
    }) : children);
};
var $2aafcb309569ef8f$export$2e2bcd8739ae039 = $2aafcb309569ef8f$var$MenuWrapper;



var $5FkrB = parcelRequire("5FkrB");

var $0ff4847a2f5e8f4c$export$756f795847463ebd = /*#__PURE__*/ (0, $5FkrB.createContext)({
    setItemState: (0, $f729a2485b96e7ca$export$2e2bcd8739ae039),
    getItemState: function getItemState() {
        return undefined;
    },
    setGroupState: (0, $f729a2485b96e7ca$export$2e2bcd8739ae039),
    getGroupState: function getGroupState() {
        return {};
    }
});
/**
 * Selection store will persist data as long as it remains mounted.
 * It handles the uncontrolled story for dropdown menu when the menu
 * items can be mounted/unmounted depending if the menu is open or closed.
 */ var $0ff4847a2f5e8f4c$var$SelectionStore = function SelectionStore(props) {
    var children = props.children;
    var store = (0, $5FkrB.useRef)({});
    var context = (0, $5FkrB.useMemo)(function() {
        return {
            setItemState: function setItemState(group, id, value) {
                if (!store.current[group]) store.current[group] = {};
                store.current[group][id] = value;
            },
            getItemState: function getItemState(group, id) {
                if (!store.current[group]) return undefined;
                return store.current[group][id];
            },
            setGroupState: function setGroupState(group, value) {
                store.current[group] = value;
            },
            getGroupState: function getGroupState(group) {
                return store.current[group] || {};
            }
        };
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement($0ff4847a2f5e8f4c$export$756f795847463ebd.Provider, {
        value: context
    }, children);
};
var $0ff4847a2f5e8f4c$export$2e2bcd8739ae039 = $0ff4847a2f5e8f4c$var$SelectionStore;



var $5FkrB = parcelRequire("5FkrB");

var $id6Cu = parcelRequire("id6Cu");

// This function is called whenever a MenuItem mounts.
// The refs stored in the context are used to programmatically
// control focus on a user navigates using the keyboard.
function $44b6e7ab1a14c674$var$useRegisterItemWithFocusManager() {
    var hasPopup = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    var _useContext = (0, $5FkrB.useContext)((0, $b6650f5cfeeb801b$export$f18c1d4fc7326096)), registerRef = _useContext.registerRef;
    var itemRef = (0, $5FkrB.useRef)(null);
    (0, $5FkrB.useEffect)(function() {
        if (hasPopup && (0, $id6Cu.fg)('select-avoid-duplicated-registered-ref')) return;
        registerRef(itemRef);
    }, [
        registerRef,
        hasPopup
    ]);
    return itemRef;
}
var $44b6e7ab1a14c674$export$2e2bcd8739ae039 = $44b6e7ab1a14c674$var$useRegisterItemWithFocusManager;



var $5a40bdc8514ad3b7$var$_excluded = [
    "ref",
    "aria-controls",
    "aria-expanded",
    "aria-haspopup"
];
function $5a40bdc8514ad3b7$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $5a40bdc8514ad3b7$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $5a40bdc8514ad3b7$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $5a40bdc8514ad3b7$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $5a40bdc8514ad3b7$var$gridSize = (0, $7LfsS.gridSize)();
var $5a40bdc8514ad3b7$var$MAX_HEIGHT = "calc(100vh - ".concat($5a40bdc8514ad3b7$var$gridSize * 2, "px)");
var $5a40bdc8514ad3b7$var$opposites = {
    top: 'bottom',
    bottom: 'top',
    left: 'right',
    right: 'left',
    start: 'end',
    auto: 'auto',
    end: 'start'
};
var $5a40bdc8514ad3b7$var$getFallbackPlacements = function getFallbackPlacements(placement) {
    var placementPieces = placement.split('-');
    var mainAxis = placementPieces[0];
    // Left, right and auto placements can rely on standard popper sliding behaviour
    if (![
        'top',
        'bottom'
    ].includes(mainAxis)) return undefined;
    else if (placementPieces.length === 2 && [
        'start',
        'end'
    ].includes(placementPieces[1])) {
        var crossAxis = placementPieces[1];
        return [
            "".concat(mainAxis),
            "".concat(mainAxis, "-").concat($5a40bdc8514ad3b7$var$opposites[crossAxis]),
            "".concat($5a40bdc8514ad3b7$var$opposites[mainAxis], "-").concat(crossAxis),
            "".concat($5a40bdc8514ad3b7$var$opposites[mainAxis]),
            "".concat($5a40bdc8514ad3b7$var$opposites[mainAxis], "-").concat($5a40bdc8514ad3b7$var$opposites[crossAxis]),
            'auto'
        ];
    } else return [
        "".concat(mainAxis, "-start"),
        "".concat(mainAxis, "-end"),
        "".concat($5a40bdc8514ad3b7$var$opposites[mainAxis]),
        "".concat($5a40bdc8514ad3b7$var$opposites[mainAxis], "-start"),
        "".concat($5a40bdc8514ad3b7$var$opposites[mainAxis], "-end"),
        "auto"
    ];
};
/**
 * __Dropdown menu__
 *
 * A dropdown menu displays a list of actions or options to a user.
 *
 * - [Examples](https://atlassian.design/components/dropdown-menu/examples)
 * - [Code](https://atlassian.design/components/dropdown-menu/code)
 * - [Usage](https://atlassian.design/components/dropdown-menu/usage)
 */ var $5a40bdc8514ad3b7$var$DropdownMenu = function DropdownMenu(_ref) {
    var _ref$autoFocus = _ref.autoFocus, autoFocus = _ref$autoFocus === void 0 ? false : _ref$autoFocus, children = _ref.children, _ref$defaultOpen = _ref.defaultOpen, defaultOpen = _ref$defaultOpen === void 0 ? false : _ref$defaultOpen, _ref$isLoading = _ref.isLoading, isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading, isOpen = _ref.isOpen, _ref$onOpenChange = _ref.onOpenChange, onOpenChange = _ref$onOpenChange === void 0 ? (0, $f729a2485b96e7ca$export$2e2bcd8739ae039) : _ref$onOpenChange, _ref$placement = _ref.placement, placement = _ref$placement === void 0 ? 'bottom-start' : _ref$placement, _ref$shouldFitContain = _ref.shouldFitContainer, shouldFitContainer = _ref$shouldFitContain === void 0 ? false : _ref$shouldFitContain, _ref$shouldFlip = _ref.shouldFlip, shouldFlip = _ref$shouldFlip === void 0 ? true : _ref$shouldFlip, _ref$shouldRenderToPa = _ref.shouldRenderToParent, shouldRenderToParent = _ref$shouldRenderToPa === void 0 ? false : _ref$shouldRenderToPa, returnFocusRef = _ref.returnFocusRef, spacing = _ref.spacing, statusLabel = _ref.statusLabel, testId = _ref.testId, _trigger = _ref.trigger, _ref$zIndex = _ref.zIndex, zIndex = _ref$zIndex === void 0 ? (0, $7LfsS.layers).modal() : _ref$zIndex, label = _ref.label, interactionName = _ref.interactionName, strategy = _ref.strategy;
    var _useControlledState = (0, $99c3cb855d6cc161$export$2e2bcd8739ae039)(isOpen, function() {
        return defaultOpen;
    }), _useControlledState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useControlledState, 2), isLocalOpen = _useControlledState2[0], setLocalIsOpen = _useControlledState2[1];
    var triggerRef = (0, $5FkrB.useRef)(null);
    var _useState = (0, $5FkrB.useState)(false), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), isTriggeredUsingKeyboard = _useState2[0], setTriggeredUsingKeyboard = _useState2[1];
    var id = (0, $d89fd6a28514603b$export$2e2bcd8739ae039)();
    var itemRef = (0, $44b6e7ab1a14c674$export$2e2bcd8739ae039)();
    var fallbackPlacements = (0, $5FkrB.useMemo)(function() {
        return $5a40bdc8514ad3b7$var$getFallbackPlacements(placement);
    }, [
        placement
    ]);
    var handleTriggerClicked = (0, $5FkrB.useCallback)(// TODO: event is an `any` and is being cast incorrectly
    // This means that the public type for `onOpenChange` is incorrect
    // current: (event: React.MouseEvent | React.KeyboardEvent) => void;
    // correct: (event: React.MouseEvent | KeyboardEvent) => void;
    // https://product-fabric.atlassian.net/browse/DSP-4692
    function(event) {
        var newValue = !isLocalOpen;
        var clientX = event.clientX, clientY = event.clientY, type = event.type, detail = event.detail;
        if (type === 'keydown') setTriggeredUsingKeyboard(true);
        else if (clientX === 0 || clientY === 0) // Hitting enter/space is registered as a click
        // with both clientX and clientY === 0
        setTriggeredUsingKeyboard(true);
        else if (detail === 0) // Fix for Safari. clientX and clientY !== 0 in Safari
        setTriggeredUsingKeyboard(true);
        else {
            var _itemRef$current;
            // The trigger element must be focused to avoid problems with an incorrectly focused element after closing DropdownMenu
            itemRef === null || itemRef === void 0 || (_itemRef$current = itemRef.current) === null || _itemRef$current === void 0 || _itemRef$current.focus();
            setTriggeredUsingKeyboard(false);
        }
        setLocalIsOpen(newValue);
        onOpenChange({
            isOpen: newValue,
            event: event
        });
    }, [
        isLocalOpen,
        setLocalIsOpen,
        onOpenChange,
        itemRef
    ]);
    var handleOnClose = (0, $5FkrB.useCallback)(function(event, currentLevel) {
        var _event$target, _event$target$closest;
        if (event.key !== 'Escape' && event.key !== 'Tab' && (_event$target = event.target) !== null && _event$target !== void 0 && (_event$target$closest = _event$target.closest) !== null && _event$target$closest !== void 0 && _event$target$closest.call(_event$target, "[id^=".concat((0, $d89fd6a28514603b$export$8a682ae47622dbb9), "] [aria-haspopup]"))) {
            var _itemRef$current2;
            // Check if it is within dropdown and it is a trigger button
            // if it is a nested dropdown, clicking trigger won't close the dropdown
            // Dropdown can be closed by pressing Escape, Tab or Shift + Tab
            if (!currentLevel) return;
            // if currentLevel is provided, we will compare with the given item's level
            // when it is available and larger than currentLevel, we will proceed the close behavior
            var toCloseLevel = (_itemRef$current2 = itemRef.current) === null || _itemRef$current2 === void 0 ? void 0 : _itemRef$current2.dataset['ds-Level'];
            if (toCloseLevel && Number(toCloseLevel) < currentLevel) return;
        }
        // transfer focus to the element specified by ref
        // if ref is not provided, use old behavior:
        // focus on trigger when <Esc> or <Shift+Tab> is pressed
        if (returnFocusRef) requestAnimationFrame(function() {
            var _returnFocusRef$curre;
            (_returnFocusRef$curre = returnFocusRef.current) === null || _returnFocusRef$curre === void 0 || _returnFocusRef$curre.focus();
        });
        else if (event.key === 'Tab' && event.shiftKey || event.key === 'Escape') requestAnimationFrame(function() {
            var _itemRef$current3;
            (_itemRef$current3 = itemRef.current) === null || _itemRef$current3 === void 0 || _itemRef$current3.focus();
        });
        else if (triggerRef.current) requestAnimationFrame(function() {
            var _triggerRef$current;
            (_triggerRef$current = triggerRef.current) === null || _triggerRef$current === void 0 || _triggerRef$current.focus();
        });
        var newValue = false;
        setLocalIsOpen(newValue);
        onOpenChange({
            isOpen: newValue,
            event: event
        });
    }, [
        itemRef,
        onOpenChange,
        returnFocusRef,
        setLocalIsOpen
    ]);
    var _useFocus = (0, $90cc74b2d10bb254$export$2e2bcd8739ae039)(), isFocused = _useFocus.isFocused, bindFocus = _useFocus.bindFocus;
    // When a trigger is focused, we want to open the dropdown if
    // the user presses the DownArrow
    (0, $5FkrB.useEffect)(function() {
        // Only need to listen for keydown when focused
        if (!isFocused) return 0, $f729a2485b96e7ca$export$2e2bcd8739ae039;
        // Being safe: we don't want to open the dropdown if it is already open
        // Note: This shouldn't happen as the trigger should not be able to get focus
        if (isLocalOpen) return 0, $f729a2485b96e7ca$export$2e2bcd8739ae039;
        return (0, $7QpUe.bind)(window, {
            type: 'keydown',
            listener: function openOnKeyDown(e) {
                var isNestedTriggerButton;
                if (e.target instanceof HTMLElement) isNestedTriggerButton = e.target.closest("[id^=".concat((0, $d89fd6a28514603b$export$8a682ae47622dbb9), "] [aria-haspopup]"));
                if (e.key === (0, $ebec22bc85089a5d$export$a80636c6f41931fe) && !isNestedTriggerButton) {
                    // prevent page scroll
                    e.preventDefault();
                    handleTriggerClicked(e);
                } else if ((e.code === (0, $ebec22bc85089a5d$export$e51a3576c045c8d5) || e.key === (0, $ebec22bc85089a5d$export$8152f929a25a0ff4)) && e.detail === 0) // This allows us to focus on the first element if the dropdown was triggered by a custom trigger with a custom onClick
                setTriggeredUsingKeyboard(true);
                else if (e.key === (0, $ebec22bc85089a5d$export$10f6869ed0a7d75b) && isNestedTriggerButton) // This closes dropdown if it is a nested dropdown
                handleOnClose(e);
            }
        });
    }, [
        isFocused,
        isLocalOpen,
        handleTriggerClicked,
        handleOnClose
    ]);
    /*
   * The Popup component requires either:
   * - shouldFitContainer={true} and shouldRenderToParent={true | undefined}
   * or
   * - shouldFitContainer={false | undefined} and shouldRenderToParent={true | false | undefined}
   *
   * But not:
   * - shouldFitContainer={true} and shouldRenderToParent={false}
   *
   * By only including either shouldFitContainer or shouldRenderToParent, we can ensure that the Popup component
   * types are satisfied.
   */ var conditionalProps = shouldFitContainer ? {
        shouldFitContainer: shouldFitContainer,
        // When shouldFitContainer is true, `fixed` positions are not allowed
        strategy: strategy !== 'fixed' ? strategy : undefined
    } : {
        shouldRenderToParent: shouldRenderToParent,
        strategy: strategy
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $0ff4847a2f5e8f4c$export$2e2bcd8739ae039), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $48dcb268e58c3c27$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        id: isLocalOpen ? id : undefined,
        shouldFlip: shouldFlip,
        isOpen: isLocalOpen,
        shouldReturnFocus: // If returnFocusRef is provided, we **don't** want to return focus to the trigger.
        // Otherwise, Popup will focus on the dropdown trigger after the `returnFocusRef` element is focused.
        returnFocusRef === undefined,
        onClose: handleOnClose,
        zIndex: zIndex,
        placement: placement,
        fallbackPlacements: fallbackPlacements,
        testId: testId && "".concat(testId, "--content"),
        shouldUseCaptureOnOutsideClick: true
    }, conditionalProps, {
        shouldDisableFocusLock: true,
        trigger: function trigger(_ref2) {
            var ref = _ref2.ref, ariaControls = _ref2['aria-controls'], ariaExpanded = _ref2['aria-expanded'], ariaHasPopup = _ref2['aria-haspopup'], rest = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref2, $5a40bdc8514ad3b7$var$_excluded);
            if (typeof _trigger === 'function') return _trigger($5a40bdc8514ad3b7$var$_objectSpread($5a40bdc8514ad3b7$var$_objectSpread($5a40bdc8514ad3b7$var$_objectSpread({
                'aria-controls': ariaControls,
                'aria-expanded': ariaExpanded,
                'aria-haspopup': ariaHasPopup
            }, rest), bindFocus), {}, {
                triggerRef: (0, $e2c87340de9b0062$export$2e2bcd8739ae039)([
                    ref,
                    triggerRef,
                    itemRef
                ]),
                isSelected: isLocalOpen,
                onClick: handleTriggerClicked,
                testId: testId && "".concat(testId, "--trigger")
            }));
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $2CKum.default), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, bindFocus, {
                ref: (0, $e2c87340de9b0062$export$2e2bcd8739ae039)([
                    ref,
                    triggerRef,
                    itemRef
                ]),
                "aria-controls": ariaControls,
                "aria-expanded": ariaExpanded,
                "aria-haspopup": ariaHasPopup,
                isSelected: isLocalOpen,
                iconAfter: (0, (/*@__PURE__*/$parcel$interopDefault($fe03fbe22ca1a3ef$exports))),
                onClick: handleTriggerClicked,
                testId: testId && "".concat(testId, "--trigger"),
                "aria-label": label
            }, (0, $id6Cu.fg)('platform_button_item-add-ufo-metrics') && {
                interactionName: interactionName
            }), _trigger);
        },
        content: function content(_ref3) {
            var setInitialFocusRef = _ref3.setInitialFocusRef, update = _ref3.update;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $b6650f5cfeeb801b$export$2e2bcd8739ae039), {
                onClose: handleOnClose
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $2aafcb309569ef8f$export$2e2bcd8739ae039), {
                spacing: spacing,
                maxHeight: $5a40bdc8514ad3b7$var$MAX_HEIGHT,
                maxWidth: shouldFitContainer ? undefined : 800,
                onClose: handleOnClose,
                onUpdate: update,
                isLoading: isLoading,
                statusLabel: statusLabel,
                setInitialFocusRef: isTriggeredUsingKeyboard || autoFocus ? setInitialFocusRef : undefined,
                shouldRenderToParent: shouldRenderToParent || shouldFitContainer,
                isTriggeredUsingKeyboard: isTriggeredUsingKeyboard,
                autoFocus: autoFocus,
                testId: testId && "".concat(testId, "--menu-wrapper")
            }, children));
        }
    })));
};
var $5a40bdc8514ad3b7$export$2e2bcd8739ae039 = $5a40bdc8514ad3b7$var$DropdownMenu;


var $kqp0i = parcelRequire("kqp0i");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");


var $kqp0i = parcelRequire("kqp0i");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");

var $74Zh5 = parcelRequire("74Zh5");
/* eslint-disable no-console */ var $fb0d176ece0cbd98$var$printed = {};
function $fb0d176ece0cbd98$export$2e2bcd8739ae039(message) {
    if ($fb0d176ece0cbd98$var$printed[message]) return;
    $fb0d176ece0cbd98$var$printed[message] = true;
    if (typeof window !== 'undefined') console.warn(message);
}



var $3ZMUU = parcelRequire("3ZMUU");
function $84f32fdedd952178$export$2e2bcd8739ae039(packageName, api, additionalMessage) {
    (0, $fb0d176ece0cbd98$export$2e2bcd8739ae039)("[".concat(packageName, "]: The ").concat(api, " is deprecated.").concat(additionalMessage && " ".concat(additionalMessage)));
}
function $84f32fdedd952178$export$eb1decd851a5ae56(packageName, propName, predicate, deprecationAnnouncementOnDAC) {
    typeof $3ZMUU;
}


/**
 * An empty function which does nothing.
 */ // eslint-disable-next-line @repo/internal/react/use-noop
function $c7965232083f5e62$export$2e2bcd8739ae039() {}



var $5FkrB = parcelRequire("5FkrB");
var $c94d31e76e0c59c7$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $5FkrB.createContext)(null);



var $id6Cu = parcelRequire("id6Cu");
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5FkrB = parcelRequire("5FkrB");

var $74Zh5 = parcelRequire("74Zh5");

/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5FkrB = parcelRequire("5FkrB");

var $74Zh5 = parcelRequire("74Zh5");
var $987fb186d82a0dd6$var$BORDER_WIDTH = 2;
var $987fb186d82a0dd6$var$baseFocusOutsideStyles = (0, $74Zh5.css)({
    outline: "".concat($987fb186d82a0dd6$var$BORDER_WIDTH, "px solid ", "var(--ds-border-focused, #2684FF)"),
    outlineOffset: $987fb186d82a0dd6$var$BORDER_WIDTH
});
var $987fb186d82a0dd6$var$baseInsetStyles = (0, $74Zh5.css)({
    outlineColor: "var(--ds-border-focused, #2684FF)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    outlineOffset: -$987fb186d82a0dd6$var$BORDER_WIDTH,
    outlineStyle: 'solid',
    outlineWidth: "var(--ds-border-width-outline, 2px)"
});
var $987fb186d82a0dd6$var$focusRingStyles = (0, $74Zh5.css)({
    // Focus styles used when :focus-visible isn't supported
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
    '&:focus': $987fb186d82a0dd6$var$baseFocusOutsideStyles,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
    '&:focus-visible': $987fb186d82a0dd6$var$baseFocusOutsideStyles,
    // Remove default focus styles for mouse interactions if :focus-visible is supported
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
    '&:focus:not(:focus-visible)': {
        outline: 'none'
    },
    '@media screen and (forced-colors: active), screen and (-ms-high-contrast: active)': {
        '&:focus-visible': {
            outline: '1px solid'
        }
    }
});
var $987fb186d82a0dd6$var$insetFocusRingStyles = (0, $74Zh5.css)({
    // Focus styles used when :focus-visible isn't supported
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
    '&:focus': $987fb186d82a0dd6$var$baseInsetStyles,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
    '&:focus-visible': $987fb186d82a0dd6$var$baseInsetStyles,
    // Remove default focus styles for mouse interactions if :focus-visible is supported
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
    '&:focus:not(:focus-visible)': {
        outline: 'none'
    },
    '@media screen and (forced-colors: active), screen and (-ms-high-contrast: active)': {
        '&:focus-visible': {
            outline: '1px solid',
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
            outlineOffset: '-1px'
        }
    }
});
/**
 * __Focus ring__
 *
 * A focus ring visually indicates the currently focused item.
 *
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/focus-ring)
 *
 * @example
 * ```jsx
 * import FocusRing from '@atlaskit/focus-ring';
 *
 * const InteractiveComponent = () => (
 *   <FocusRing>
 *     <button type="button">Hello</button>
 *   </FocusRing>
 * )
 * ```
 */ var $987fb186d82a0dd6$var$FocusRing = /*#__PURE__*/ (0, $5FkrB.memo)(function(_ref) {
    var children = _ref.children, isInset = _ref.isInset, focus = _ref.focus;
    var controlledStyles = isInset ? $987fb186d82a0dd6$var$baseInsetStyles : $987fb186d82a0dd6$var$baseFocusOutsideStyles;
    var uncontrolledStyles = isInset ? $987fb186d82a0dd6$var$insetFocusRingStyles : $987fb186d82a0dd6$var$focusRingStyles;
    var focusCls = typeof focus === 'undefined' ? uncontrolledStyles : focus === 'on' && controlledStyles;
    return (0, $74Zh5.jsx)((0, $74Zh5.ClassNames), null, function(_ref2) {
        var css = _ref2.css, cx = _ref2.cx;
        return (0, $5FkrB.Children).only(// This may look unwieldy but means we skip applying styles / cloning if no className is applicable
        focusCls ? /*#__PURE__*/ // eslint-disable-next-line @repo/internal/react/no-clone-element
        (0, $5FkrB.cloneElement)(children, {
            className: cx([
                css(focusCls),
                children.props.className
            ])
        }) : children);
    });
});
$987fb186d82a0dd6$var$FocusRing.displayName = 'FocusRing';
var $987fb186d82a0dd6$export$2e2bcd8739ae039 = $987fb186d82a0dd6$var$FocusRing;



var $fC8ib = parcelRequire("fC8ib");

var $5FkrB = parcelRequire("5FkrB");

var $74Zh5 = parcelRequire("74Zh5");

var $d7pIx = parcelRequire("d7pIx");
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5FkrB = parcelRequire("5FkrB");

var $74Zh5 = parcelRequire("74Zh5");

var $hkJI5 = parcelRequire("hkJI5");

var $d7pIx = parcelRequire("d7pIx");
var $73afb1bbce1db9ff$var$justifyContentMap = {
    start: (0, $74Zh5.css)({
        justifyContent: 'start'
    }),
    center: (0, $74Zh5.css)({
        justifyContent: 'center'
    }),
    end: (0, $74Zh5.css)({
        justifyContent: 'end'
    }),
    'space-between': (0, $74Zh5.css)({
        justifyContent: 'space-between'
    }),
    'space-around': (0, $74Zh5.css)({
        justifyContent: 'space-around'
    }),
    'space-evenly': (0, $74Zh5.css)({
        justifyContent: 'space-evenly'
    }),
    stretch: (0, $74Zh5.css)({
        justifyContent: 'stretch'
    })
};
var $73afb1bbce1db9ff$var$flexDirectionMap = {
    column: (0, $74Zh5.css)({
        flexDirection: 'column'
    }),
    row: (0, $74Zh5.css)({
        flexDirection: 'row'
    })
};
var $73afb1bbce1db9ff$var$flexWrapMap = {
    wrap: (0, $74Zh5.css)({
        flexWrap: 'wrap'
    }),
    nowrap: (0, $74Zh5.css)({
        flexWrap: 'nowrap'
    })
};
var $73afb1bbce1db9ff$var$alignItemsMap = {
    start: (0, $74Zh5.css)({
        alignItems: 'start'
    }),
    center: (0, $74Zh5.css)({
        alignItems: 'center'
    }),
    baseline: (0, $74Zh5.css)({
        alignItems: 'baseline'
    }),
    end: (0, $74Zh5.css)({
        alignItems: 'end'
    }),
    stretch: (0, $74Zh5.css)({
        alignItems: 'stretch'
    })
};
var $73afb1bbce1db9ff$var$baseStyles = (0, $74Zh5.css)({
    display: 'flex',
    boxSizing: 'border-box'
});
/**
 * __Flex__
 *
 * `Flex` is a primitive component that implements the CSS Flexbox API.
 *
 * - [Examples](https://atlassian.design/components/primitives/flex/examples)
 * - [Code](https://atlassian.design/components/primitives/flex/code)
 *
 * @example
 * ```tsx
 * import { Flex, Box } from '@atlaskit/primitives'
 *
 * const Component = () => (
 *   <Flex direction="column">
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *   </Flex>
 * )
 * ```
 */ var $73afb1bbce1db9ff$var$Flex = /*#__PURE__*/ (0, $5FkrB.memo)(/*#__PURE__*/ (0, $5FkrB.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? 'div' : _ref$as, role = _ref.role, alignItems = _ref.alignItems, justifyContent = _ref.justifyContent, gap = _ref.gap, columnGap = _ref.columnGap, rowGap = _ref.rowGap, children = _ref.children, testId = _ref.testId, direction = _ref.direction, wrap = _ref.wrap, xcss = _ref.xcss;
    var resolvedStyles = (0, $d7pIx.parseXcss)(xcss);
    return (0, $74Zh5.jsx)(Component, {
        role: role,
        className: resolvedStyles.static,
        css: [
            $73afb1bbce1db9ff$var$baseStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            gap && (0, $hkJI5.spaceStylesMap).gap[gap],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            columnGap && (0, $hkJI5.spaceStylesMap).columnGap[columnGap],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            rowGap && (0, $hkJI5.spaceStylesMap).rowGap[rowGap],
            alignItems && $73afb1bbce1db9ff$var$alignItemsMap[alignItems],
            direction && $73afb1bbce1db9ff$var$flexDirectionMap[direction],
            justifyContent && $73afb1bbce1db9ff$var$justifyContentMap[justifyContent],
            wrap && $73afb1bbce1db9ff$var$flexWrapMap[wrap],
            // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
            resolvedStyles.emotion
        ],
        "data-testid": testId,
        ref: ref
    }, children);
}));
$73afb1bbce1db9ff$var$Flex.displayName = 'Flex';
var $73afb1bbce1db9ff$export$2e2bcd8739ae039 = $73afb1bbce1db9ff$var$Flex;


var $2f16c0d1e185543a$var$flexGrowMap = {
    hug: (0, $d7pIx.xcss)({
        flexGrow: 0
    }),
    fill: (0, $d7pIx.xcss)({
        width: '100%',
        flexGrow: 1
    })
};
var $2f16c0d1e185543a$var$separatorStyles = (0, $74Zh5.css)({
    color: "var(--ds-text-subtle, #42526E)",
    marginBlock: "var(--ds-space-0, 0px)",
    marginInline: "var(--ds-space-negative-025, -2px)",
    pointerEvents: 'none',
    userSelect: 'none'
});
var $2f16c0d1e185543a$var$Separator = function Separator(_ref) {
    var children = _ref.children;
    return (0, $74Zh5.jsx)("span", {
        css: $2f16c0d1e185543a$var$separatorStyles
    }, children);
};
/**
 * __Inline__
 *
 * Inline is a primitive component based on CSS Flexbox that manages the horizontal layout of direct children.
 *
 * @example
 * ```tsx
 *  <Inline>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *  </Inline>
 * ```
 *
 */ var $2f16c0d1e185543a$var$Inline = /*#__PURE__*/ (0, $5FkrB.memo)(/*#__PURE__*/ (0, $5FkrB.forwardRef)(function(_ref2, ref) {
    var as = _ref2.as, alignInline = _ref2.alignInline, _ref2$alignBlock = _ref2.alignBlock, alignItems = _ref2$alignBlock === void 0 ? 'start' : _ref2$alignBlock, _ref2$shouldWrap = _ref2.shouldWrap, shouldWrap = _ref2$shouldWrap === void 0 ? false : _ref2$shouldWrap, spread = _ref2.spread, grow = _ref2.grow, space = _ref2.space, rowSpace = _ref2.rowSpace, separator = _ref2.separator, xcss = _ref2.xcss, testId = _ref2.testId, role = _ref2.role, rawChildren = _ref2.children;
    var separatorComponent = typeof separator === 'string' ? (0, $74Zh5.jsx)($2f16c0d1e185543a$var$Separator, null, separator) : separator;
    var children = separatorComponent ? (0, $5FkrB.Children).toArray(rawChildren).filter(Boolean).map(function(child, index) {
        return (0, $74Zh5.jsx)((0, $5FkrB.Fragment), {
            key: index
        }, separator && index > 0 ? separatorComponent : null, child);
    }) : rawChildren;
    var justifyContent = spread || alignInline;
    // We're type coercing this as Compiled styles in an array isn't supported by the types
    // But the runtime accepts it none-the-wiser. We can remove this entire block and replace
    // it with cx(defaultStyles, focusRingStyles, xcssStyles) when we've moved away from Emotion.
    var styles = grow ? [
        $2f16c0d1e185543a$var$flexGrowMap[grow]
    ].concat((0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(Array.isArray(xcss) ? xcss : [
        xcss
    ])) : xcss;
    return (0, $74Zh5.jsx)((0, $73afb1bbce1db9ff$export$2e2bcd8739ae039), {
        as: as,
        role: role,
        alignItems: alignItems,
        justifyContent: justifyContent,
        direction: "row",
        gap: space,
        rowGap: rowSpace,
        wrap: shouldWrap ? 'wrap' : undefined,
        xcss: styles,
        testId: testId,
        ref: ref
    }, children);
}));
$2f16c0d1e185543a$var$Inline.displayName = 'Inline';
var $2f16c0d1e185543a$export$2e2bcd8739ae039 = $2f16c0d1e185543a$var$Inline;


var $fC8ib = parcelRequire("fC8ib");

var $5FkrB = parcelRequire("5FkrB");

var $74Zh5 = parcelRequire("74Zh5");

var $d7pIx = parcelRequire("d7pIx");

var $e406378bc5591b9a$var$flexGrowMap = {
    hug: (0, $d7pIx.xcss)({
        flexGrow: 0
    }),
    fill: (0, $d7pIx.xcss)({
        width: '100%',
        flexGrow: 1
    })
};
/**
 * __Stack__
 *
 * Stack is a primitive component based on flexbox that manages the block layout of direct children.
 *
 * @example
 * ```tsx
 *  <Stack>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *  </Stack>
 * ```
 *
 */ var $e406378bc5591b9a$var$Stack = /*#__PURE__*/ (0, $5FkrB.memo)(/*#__PURE__*/ (0, $5FkrB.forwardRef)(function(_ref, ref) {
    var as = _ref.as, alignItems = _ref.alignInline, _ref$alignBlock = _ref.alignBlock, alignBlock = _ref$alignBlock === void 0 ? 'stretch' : _ref$alignBlock, spread = _ref.spread, grow = _ref.grow, space = _ref.space, children = _ref.children, testId = _ref.testId, xcss = _ref.xcss, role = _ref.role;
    var justifyContent = spread || alignBlock;
    // We're type coercing this as Compiled styles in an array isn't supported by the types
    // But the runtime accepts it none-the-wiser. We can remove this entire block and replace
    // it with cx(defaultStyles, focusRingStyles, xcssStyles) when we've moved away from Emotion.
    var styles = grow ? [
        $e406378bc5591b9a$var$flexGrowMap[grow]
    ].concat((0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(Array.isArray(xcss) ? xcss : [
        xcss
    ])) : xcss;
    return (0, $74Zh5.jsx)((0, $73afb1bbce1db9ff$export$2e2bcd8739ae039), {
        as: as,
        role: role,
        gap: space,
        direction: "column",
        alignItems: alignItems,
        justifyContent: justifyContent,
        xcss: styles,
        testId: testId,
        ref: ref
    }, children);
}));
$e406378bc5591b9a$var$Stack.displayName = 'Stack';
var $e406378bc5591b9a$export$2e2bcd8739ae039 = $e406378bc5591b9a$var$Stack;


var $d7pIx = parcelRequire("d7pIx");

var $h0N4L = parcelRequire("h0N4L");

var $e01129ee1bf08d87$var$defaultRender = function defaultRender(Component, props) {
    return(// eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    (0, $74Zh5.jsx)(Component, props));
};
var $e01129ee1bf08d87$var$beforeAfterElementStyles = (0, $74Zh5.css)({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0
});
var $e01129ee1bf08d87$var$contentStyles = (0, $d7pIx.xcss)({
    outline: 'none',
    overflow: 'hidden',
    textAlign: 'left'
});
var $e01129ee1bf08d87$var$truncateStyles = (0, $74Zh5.css)({
    display: 'block',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
});
var $e01129ee1bf08d87$var$titleStyles = (0, $74Zh5.css)({
    font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)"
});
var $e01129ee1bf08d87$var$wordBreakStyles = (0, $74Zh5.css)({
    wordBreak: 'break-word'
});
var $e01129ee1bf08d87$var$descriptionStyles = (0, $74Zh5.css)({
    color: "var(--ds-text-subtlest, ".concat((0, $h0N4L.N200), ")"),
    font: "var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)"
});
var $e01129ee1bf08d87$var$disabledDescriptionStyles = (0, $74Zh5.css)({
    color: "var(--ds-text-disabled, ".concat((0, $h0N4L.N200), ")")
});
var $e01129ee1bf08d87$var$positionRelativeStyles = (0, $74Zh5.css)({
    position: 'relative'
});
var $e01129ee1bf08d87$var$primitiveStyles = (0, $74Zh5.css)({
    display: 'flex',
    boxSizing: 'border-box',
    width: '100%',
    minHeight: 40,
    margin: "var(--ds-space-0, 0px)",
    alignItems: 'center',
    border: 0,
    outline: 0,
    textDecoration: 'none',
    userSelect: 'none',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '&::-moz-focus-inner': {
        border: 0
    },
    '&:hover': {
        textDecoration: 'none'
    }
});
var $e01129ee1bf08d87$var$spacingMapStyles = {
    cozy: (0, $74Zh5.css)({
        // 8 * 2 (16) + icon (24) === 40
        paddingBlock: "var(--ds-space-100, 8px)",
        paddingInline: "var(--ds-space-200, 16px)"
    }),
    compact: (0, $74Zh5.css)({
        minHeight: 32,
        // 4 * 2 (8) + icon (24) === 32
        paddingBlock: "var(--ds-space-050, 4px)",
        paddingInline: "var(--ds-space-150, 12px)"
    })
};
var $e01129ee1bf08d87$var$interactiveStyles = (0, $74Zh5.css)({
    cursor: 'pointer'
});
var $e01129ee1bf08d87$var$unselectedStyles = (0, $74Zh5.css)({
    backgroundColor: "var(--ds-background-neutral-subtle, transparent)",
    color: 'currentColor',
    '&:visited': {
        color: 'currentColor'
    },
    '&:hover': {
        backgroundColor: "var(--ds-background-neutral-subtle-hovered, ".concat((0, $h0N4L.N20), ")"),
        color: 'currentColor'
    },
    '&:active': {
        backgroundColor: "var(--ds-background-neutral-subtle-pressed, ".concat((0, $h0N4L.N30), ")"),
        boxShadow: 'none',
        color: 'currentColor'
    }
});
var $e01129ee1bf08d87$var$disabledStyles = (0, $74Zh5.css)({
    cursor: 'not-allowed',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '&, :hover, :active': {
        backgroundColor: "var(--ds-background-neutral-subtle, transparent)",
        color: "var(--ds-text-disabled, ".concat((0, $h0N4L.N200), ")")
    }
});
var $e01129ee1bf08d87$var$selectedBorderStyles = (0, $74Zh5.css)({
    '&::before': {
        width: 2,
        position: 'absolute',
        background: "var(--ds-border-selected, transparent)",
        content: '""',
        insetBlockEnd: 0,
        insetBlockStart: 0,
        insetInlineStart: 0
    }
});
var $e01129ee1bf08d87$var$selectedNotchStyles = (0, $74Zh5.css)({
    '&::before': {
        width: 4,
        position: 'absolute',
        background: "var(--ds-border-selected, transparent)",
        borderRadius: "0 ".concat("var(--ds-border-radius, 4px)", " ", "var(--ds-border-radius, 4px)", " 0"),
        content: '""',
        insetBlockEnd: "var(--ds-space-150, 12px)",
        insetBlockStart: "var(--ds-space-150, 12px)",
        insetInlineStart: 0
    }
});
var $e01129ee1bf08d87$var$selectedStyles = (0, $74Zh5.css)({
    backgroundColor: "var(--ds-background-selected, ".concat((0, $h0N4L.N20), ")"),
    // Fallback set as babel plugin inserts one otherwise
    color: "var(--ds-text-selected, currentColor)",
    '&:visited': {
        color: "var(--ds-text-selected, currentColor)"
    },
    '&:hover': {
        backgroundColor: "var(--ds-background-selected-hovered, ".concat((0, $h0N4L.N20), ")"),
        color: "var(--ds-text-selected, currentColor)"
    },
    '&:active': {
        backgroundColor: "var(--ds-background-selected-pressed, ".concat((0, $h0N4L.N30), ")"),
        color: "var(--ds-text-selected, currentColor)"
    }
});
var $e01129ee1bf08d87$var$gapMap = {
    compact: 'space.100',
    cozy: 'space.150'
};
/**
 * __Menu item primitive__
 *
 * Menu item primitive contains all the styles for menu items,
 * including support for selected, disabled, and interaction states.
 *
 * Using children as function prop you wire up this to your own host element.
 *
 * ```jsx
 * <MenuItemPrimitive>
 *   {({ children, ...props }) => <button {...props}>{children}</button>}
 * </MenuItemPrimitive>
 * ```
 */ var $e01129ee1bf08d87$var$MenuItemPrimitive = function MenuItemPrimitive(_ref) {
    var children = _ref.children, title = _ref.title, description = _ref.description, iconAfter = _ref.iconAfter, iconBefore = _ref.iconBefore, overrides = _ref.overrides, UNSAFE_externalClassName = _ref.className, _ref$shouldTitleWrap = _ref.shouldTitleWrap, shouldTitleWrap = _ref$shouldTitleWrap === void 0 ? false : _ref$shouldTitleWrap, _ref$shouldDescriptio = _ref.shouldDescriptionWrap, shouldDescriptionWrap = _ref$shouldDescriptio === void 0 ? false : _ref$shouldDescriptio, _ref$isDisabled = _ref.isDisabled, isDisabled = _ref$isDisabled === void 0 ? false : _ref$isDisabled, _ref$isSelected = _ref.isSelected, isSelected = _ref$isSelected === void 0 ? false : _ref$isSelected, testId = _ref.testId;
    (0, $84f32fdedd952178$export$eb1decd851a5ae56)("@atlaskit/menu", 'overrides', overrides !== undefined, '' // TODO: Create DAC post when primitives/xcss are available as alternatives
    );
    var spacing = (0, $5FkrB.useContext)((0, $a69a838f3ece1f03$export$443076ec7ebce042));
    var selectionStyle = (0, $5FkrB.useContext)((0, $a69a838f3ece1f03$export$9ca534b70725964d));
    var renderTitle = overrides && overrides.Title && overrides.Title.render || $e01129ee1bf08d87$var$defaultRender;
    var UNSAFE_className = UNSAFE_externalClassName;
    return (0, $74Zh5.jsx)((0, $74Zh5.ClassNames), null, function(_ref2) {
        var cn = _ref2.css, cx = _ref2.cx;
        return (0, $74Zh5.jsx)((0, $987fb186d82a0dd6$export$2e2bcd8739ae039), {
            isInset: true
        }, children({
            className: cx([
                cn([
                    $e01129ee1bf08d87$var$positionRelativeStyles,
                    $e01129ee1bf08d87$var$primitiveStyles,
                    $e01129ee1bf08d87$var$spacingMapStyles[spacing],
                    !isDisabled && !isSelected && $e01129ee1bf08d87$var$unselectedStyles,
                    !isDisabled && isSelected && [
                        $e01129ee1bf08d87$var$selectedStyles,
                        [
                            selectionStyle === 'border' && $e01129ee1bf08d87$var$selectedBorderStyles,
                            selectionStyle === 'notch' && $e01129ee1bf08d87$var$selectedNotchStyles
                        ]
                    ],
                    isDisabled ? $e01129ee1bf08d87$var$disabledStyles : $e01129ee1bf08d87$var$interactiveStyles
                ]),
                UNSAFE_className
            ]),
            children: (0, $74Zh5.jsx)((0, $2f16c0d1e185543a$export$2e2bcd8739ae039), {
                as: "span",
                spread: "space-between",
                alignBlock: "center",
                space: $e01129ee1bf08d87$var$gapMap[spacing],
                grow: "fill",
                testId: testId && "".concat(testId, "--container")
            }, iconBefore && (0, $74Zh5.jsx)("span", {
                "data-item-elem-before": true,
                css: $e01129ee1bf08d87$var$beforeAfterElementStyles,
                "data-testid": testId && "".concat(testId, "--icon-before")
            }, iconBefore), title && (0, $74Zh5.jsx)((0, $e406378bc5591b9a$export$2e2bcd8739ae039), {
                alignBlock: "center",
                grow: "fill",
                xcss: $e01129ee1bf08d87$var$contentStyles
            }, renderTitle('span', {
                children: title,
                className: cn($e01129ee1bf08d87$var$titleStyles, shouldTitleWrap ? $e01129ee1bf08d87$var$wordBreakStyles : $e01129ee1bf08d87$var$truncateStyles),
                'data-item-title': true
            }), description && (0, $74Zh5.jsx)("span", {
                "data-item-description": true,
                css: [
                    $e01129ee1bf08d87$var$descriptionStyles,
                    isDisabled && $e01129ee1bf08d87$var$disabledDescriptionStyles,
                    shouldDescriptionWrap ? $e01129ee1bf08d87$var$wordBreakStyles : $e01129ee1bf08d87$var$truncateStyles
                ]
            }, description)), iconAfter && (0, $74Zh5.jsx)("span", {
                "data-item-elem-after": true,
                css: $e01129ee1bf08d87$var$beforeAfterElementStyles,
                "data-testid": testId && "".concat(testId, "--icon-after")
            }, iconAfter))
        }));
    });
};
var $e01129ee1bf08d87$export$2e2bcd8739ae039 = $e01129ee1bf08d87$var$MenuItemPrimitive;


var $597d39da41bbd0cb$var$_excluded = [
    "children",
    "cssFn",
    "description",
    "iconAfter",
    "iconBefore",
    "isDisabled",
    "isSelected",
    "onClick",
    "testId",
    "overrides",
    "onMouseDown",
    "shouldTitleWrap",
    "shouldDescriptionWrap",
    "className",
    "interactionName"
];
/**
 * __Button item__
 *
 * A button item is used to populate a menu with items that are buttons.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/menu/docs/button-item)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/menu)
 */ var $597d39da41bbd0cb$var$ButtonItem = /*#__PURE__*/ (0, $5FkrB.memo)(/*#__PURE__*/ (0, $5FkrB.forwardRef)(// Type needed on props to extract types with extract react types.
function(props, ref) {
    var children = props.children, _props$cssFn = props.cssFn, cssFn = _props$cssFn === void 0 ? (0, $c7965232083f5e62$export$2e2bcd8739ae039) : _props$cssFn, description = props.description, iconAfter = props.iconAfter, iconBefore = props.iconBefore, _props$isDisabled = props.isDisabled, isDisabled = _props$isDisabled === void 0 ? false : _props$isDisabled, _props$isSelected = props.isSelected, isSelected = _props$isSelected === void 0 ? false : _props$isSelected, onClick = props.onClick, testId = props.testId, overrides = props.overrides, onMouseDown = props.onMouseDown, shouldTitleWrap = props.shouldTitleWrap, shouldDescriptionWrap = props.shouldDescriptionWrap, UNSAFE_className = props.className, interactionName = props.interactionName, rest = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(props, $597d39da41bbd0cb$var$_excluded);
    var onMouseDownHandler = onMouseDown;
    var interactionContext = (0, $5FkrB.useContext)((0, $c94d31e76e0c59c7$export$2e2bcd8739ae039));
    var handleClick = (0, $5FkrB.useCallback)(function(e) {
        interactionContext === null || interactionContext === void 0 || interactionContext.tracePress(interactionName, e.timeStamp);
        onClick === null || onClick === void 0 || onClick(e);
    }, [
        onClick,
        interactionContext,
        interactionName
    ]);
    if (!children) return null;
    (0, $84f32fdedd952178$export$eb1decd851a5ae56)("@atlaskit/menu", 'cssFn', cssFn !== (0, $c7965232083f5e62$export$2e2bcd8739ae039), '' // TODO: Create DAC post when primitives/xcss are available as alternatives
    );
    return (0, $74Zh5.jsx)((0, $e01129ee1bf08d87$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        className: UNSAFE_className
    }, rest, {
        // eslint-disable-next-line @repo/internal/react/no-unsafe-overrides
        overrides: overrides,
        iconBefore: iconBefore,
        iconAfter: iconAfter,
        isDisabled: isDisabled,
        isSelected: isSelected,
        description: description,
        title: children,
        shouldTitleWrap: shouldTitleWrap,
        shouldDescriptionWrap: shouldDescriptionWrap,
        css: // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
        cssFn({
            isSelected: isSelected,
            isDisabled: isDisabled
        }),
        testId: testId && "".concat(testId, "--primitive")
    }), function(_ref) {
        var children = _ref.children, className = _ref.className;
        return (0, $74Zh5.jsx)("button", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
            "data-testid": testId
        }, rest, {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: className,
            ref: ref,
            disabled: isDisabled,
            onClick: (0, $id6Cu.fg)('platform_button_item-add-ufo-metrics') ? handleClick : onClick,
            onMouseDown: onMouseDownHandler,
            type: "button"
        }), children);
    });
}));
var $597d39da41bbd0cb$export$2e2bcd8739ae039 = $597d39da41bbd0cb$var$ButtonItem;



var $kqp0i = parcelRequire("kqp0i");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");

var $74Zh5 = parcelRequire("74Zh5");




var $id6Cu = parcelRequire("id6Cu");

var $42b2692ce9fb697a$var$_excluded = [
    "component",
    "cssFn",
    "isDisabled",
    "isSelected",
    "onClick",
    "testId",
    "children",
    "description",
    "iconAfter",
    "iconBefore",
    "overrides",
    "onMouseDown",
    "shouldTitleWrap",
    "shouldDescriptionWrap",
    "className",
    "UNSAFE_isDraggable",
    "interactionName"
];
var $42b2692ce9fb697a$var$preventEvent = function preventEvent(e) {
    e.preventDefault();
};
// Dirty hack to get generics working with forward ref [1/2]
/**
 * __Custom item__
 *
 * A custom item is used to populate a menu with items that can be any element.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/menu/docs/custom-item)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/menu)
 */ var $42b2692ce9fb697a$var$CustomItem = /*#__PURE__*/ (0, $5FkrB.memo)(/*#__PURE__*/ (0, $5FkrB.forwardRef)(function(_ref, ref) {
    var Component = _ref.component, _ref$cssFn = _ref.cssFn, cssFn = _ref$cssFn === void 0 ? (0, $c7965232083f5e62$export$2e2bcd8739ae039) : _ref$cssFn, _ref$isDisabled = _ref.isDisabled, isDisabled = _ref$isDisabled === void 0 ? false : _ref$isDisabled, _ref$isSelected = _ref.isSelected, isSelected = _ref$isSelected === void 0 ? false : _ref$isSelected, onClick = _ref.onClick, testId = _ref.testId, children = _ref.children, description = _ref.description, iconAfter = _ref.iconAfter, iconBefore = _ref.iconBefore, overrides = _ref.overrides, onMouseDown = _ref.onMouseDown, shouldTitleWrap = _ref.shouldTitleWrap, shouldDescriptionWrap = _ref.shouldDescriptionWrap, UNSAFE_className = _ref.className, UNSAFE_isDraggable = _ref.UNSAFE_isDraggable, interactionName = _ref.interactionName, rest = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $42b2692ce9fb697a$var$_excluded);
    var onMouseDownHandler = onMouseDown;
    var interactionContext = (0, $5FkrB.useContext)((0, $c94d31e76e0c59c7$export$2e2bcd8739ae039));
    var handleClick = (0, $5FkrB.useCallback)(function(e) {
        interactionContext === null || interactionContext === void 0 || interactionContext.tracePress(interactionName, e.timeStamp);
        onClick === null || onClick === void 0 || onClick(e);
    }, [
        onClick,
        interactionContext,
        interactionName
    ]);
    if (!Component) return null;
    (0, $84f32fdedd952178$export$eb1decd851a5ae56)("@atlaskit/menu", 'cssFn', cssFn !== (0, $c7965232083f5e62$export$2e2bcd8739ae039), '' // TODO: Create DAC post when primitives/xcss are available as alternatives
    );
    return (0, $74Zh5.jsx)((0, $e01129ee1bf08d87$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        className: UNSAFE_className
    }, rest, {
        // eslint-disable-next-line @repo/internal/react/no-unsafe-overrides
        overrides: overrides,
        description: description,
        iconAfter: iconAfter,
        title: children,
        iconBefore: iconBefore,
        isSelected: isSelected,
        isDisabled: isDisabled,
        shouldTitleWrap: shouldTitleWrap,
        shouldDescriptionWrap: shouldDescriptionWrap,
        css: (0, $74Zh5.css)(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        cssFn({
            isDisabled: isDisabled,
            isSelected: isSelected
        })),
        testId: testId && "".concat(testId, "--primitive")
    }), function(_ref2) {
        var children = _ref2.children, className = _ref2.className;
        return (0, $74Zh5.jsx)(Component, (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
            "data-testid": testId
        }, rest, {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: className,
            ref: ref
        }, UNSAFE_isDraggable ? {} : {
            draggable: false,
            onDragStart: $42b2692ce9fb697a$var$preventEvent
        }, {
            onMouseDown: isDisabled ? $42b2692ce9fb697a$var$preventEvent : onMouseDownHandler,
            onClick: isDisabled ? $42b2692ce9fb697a$var$preventEvent : (0, $id6Cu.fg)('platform_button_item-add-ufo-metrics') ? handleClick : onClick,
            tabIndex: isDisabled ? -1 : undefined,
            "aria-disabled": isDisabled
        }), children);
    });
}));
var $42b2692ce9fb697a$export$2e2bcd8739ae039 = $42b2692ce9fb697a$var$CustomItem;



var $kqp0i = parcelRequire("kqp0i");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");

var $74Zh5 = parcelRequire("74Zh5");

var $ivFqH = parcelRequire("ivFqH");




var $id6Cu = parcelRequire("id6Cu");

var $d4a673358a2339ee$var$_excluded = [
    "children",
    "href",
    "cssFn",
    "description",
    "iconAfter",
    "iconBefore",
    "isDisabled",
    "isSelected",
    "onClick",
    "testId",
    "overrides",
    "onMouseDown",
    "shouldTitleWrap",
    "shouldDescriptionWrap",
    "className",
    "UNSAFE_shouldDisableRouterLink",
    "UNSAFE_isDraggable",
    "interactionName"
];
var $d4a673358a2339ee$var$IS_EXTERNAL_LINK_REGEX = /^(?:(http|https):\/\/)/;
var $d4a673358a2339ee$var$IS_NON_HTTP_BASED = /^(((mailto|tel|sms):)|(#))/;
var $d4a673358a2339ee$var$preventEvent = function preventEvent(e) {
    e.preventDefault();
};
/**
 * __Link item__
 *
 * A link item is used to populate a menu with items that are links.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/menu/docs/link-item)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/menu)
 */ var $d4a673358a2339ee$var$LinkItem = /*#__PURE__*/ (0, $5FkrB.memo)(/*#__PURE__*/ (0, $5FkrB.forwardRef)(// Type needed on props to extract types with extract react types.
function(props, ref) {
    var children = props.children, href = props.href, _props$cssFn = props.cssFn, cssFn = _props$cssFn === void 0 ? (0, $c7965232083f5e62$export$2e2bcd8739ae039) : _props$cssFn, description = props.description, iconAfter = props.iconAfter, iconBefore = props.iconBefore, _props$isDisabled = props.isDisabled, isDisabled = _props$isDisabled === void 0 ? false : _props$isDisabled, _props$isSelected = props.isSelected, isSelected = _props$isSelected === void 0 ? false : _props$isSelected, onClick = props.onClick, testId = props.testId, overrides = props.overrides, onMouseDown = props.onMouseDown, shouldTitleWrap = props.shouldTitleWrap, shouldDescriptionWrap = props.shouldDescriptionWrap, UNSAFE_className = props.className, UNSAFE_shouldDisableRouterLink = props.UNSAFE_shouldDisableRouterLink, UNSAFE_isDraggable = props.UNSAFE_isDraggable, interactionName = props.interactionName, rest = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(props, $d4a673358a2339ee$var$_excluded);
    var onMouseDownHandler = onMouseDown;
    var RouterLink = (0, $ivFqH.default)();
    var interactionContext = (0, $5FkrB.useContext)((0, $c94d31e76e0c59c7$export$2e2bcd8739ae039));
    var handleClick = (0, $5FkrB.useCallback)(function(e) {
        interactionContext === null || interactionContext === void 0 || interactionContext.tracePress(interactionName, e.timeStamp);
        onClick === null || onClick === void 0 || onClick(e);
    }, [
        onClick,
        interactionContext,
        interactionName
    ]);
    if (!children) return null;
    var isExternal = typeof href === 'string' && $d4a673358a2339ee$var$IS_EXTERNAL_LINK_REGEX.test(href);
    var isNonHttpBased = typeof href === 'string' && $d4a673358a2339ee$var$IS_NON_HTTP_BASED.test(href);
    var isEmptyHref = href == null || href === '';
    /**
   * Renders a router link if:
   *
   * - a link component is set in the app provider
   * - it's not an external link (starting with `http://` or `https://`)
   * - it's not a non-HTTP-based link (e.g. emails, phone numbers, hash links etc.)
   * - it doesn't have an empty href (e.g. href="" or href={undefined})
   */ var isRouterLink = !UNSAFE_shouldDisableRouterLink && RouterLink && !isExternal && !isNonHttpBased && !isEmptyHref;
    var Component = isRouterLink ? RouterLink : 'a';
    (0, $84f32fdedd952178$export$eb1decd851a5ae56)("@atlaskit/menu", 'cssFn', cssFn !== (0, $c7965232083f5e62$export$2e2bcd8739ae039), '' // TODO: Create DAC post when primitives/xcss are available as alternatives
    );
    return (0, $74Zh5.jsx)((0, $e01129ee1bf08d87$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, rest, {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: UNSAFE_className,
        overrides: overrides,
        iconBefore: iconBefore,
        iconAfter: iconAfter,
        isSelected: isSelected,
        isDisabled: isDisabled,
        description: description,
        shouldTitleWrap: shouldTitleWrap,
        shouldDescriptionWrap: shouldDescriptionWrap,
        css: // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
        cssFn({
            isSelected: isSelected,
            isDisabled: isDisabled
        }),
        title: children,
        testId: testId && "".concat(testId, "--primitive")
    }), function(_ref) {
        var children = _ref.children, className = _ref.className;
        return (0, $74Zh5.jsx)(Component, (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
            "data-testid": testId,
            "data-is-router-link": testId ? isRouterLink ? 'true' : 'false' : undefined,
            "data-vc": "link-item"
        }, rest, {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: className,
            href: isDisabled ? undefined : href
        }, UNSAFE_isDraggable ? {} : {
            draggable: false,
            onDragStart: $d4a673358a2339ee$var$preventEvent
        }, {
            onMouseDown: isDisabled ? $d4a673358a2339ee$var$preventEvent : onMouseDownHandler,
            onClick: isDisabled ? $d4a673358a2339ee$var$preventEvent : (0, $id6Cu.fg)('platform_button_item-add-ufo-metrics') ? handleClick : onClick,
            "aria-current": isSelected ? 'page' : undefined,
            "aria-disabled": isDisabled,
            ref: ref
        }), children);
    });
}));
var $d4a673358a2339ee$export$2e2bcd8739ae039 = $d4a673358a2339ee$var$LinkItem;



var $id6Cu = parcelRequire("id6Cu");

var $d1103224b1f806e2$var$_excluded = [
    "children",
    "component",
    "description",
    "elemAfter",
    "elemBefore",
    "href",
    "isDisabled",
    "isSelected",
    "onClick",
    "rel",
    "shouldDescriptionWrap",
    "shouldTitleWrap",
    "target",
    "testId",
    "UNSAFE_shouldDisableRouterLink",
    "returnFocusRef",
    "interactionName"
];
/**
 * __Dropdown menu item__
 *
 * A dropdown item populates the dropdown menu with items. Every item should be inside a dropdown item group.
 *
 * - [Examples](https://atlassian.design/components/dropdown-menu/dropdown-item/examples)
 * - [Code](https://atlassian.design/components/dropdown-menu/dropdown-item/code)
 * - [Usage](https://atlassian.design/components/dropdown-menu/dropdown-item/usage)
 */ var $d1103224b1f806e2$var$DropdownMenuItem = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function(_ref, ref) {
    var children = _ref.children, component = _ref.component, description = _ref.description, elemAfter = _ref.elemAfter, elemBefore = _ref.elemBefore, href = _ref.href, isDisabled = _ref.isDisabled, isSelected = _ref.isSelected, onClick = _ref.onClick, rel = _ref.rel, _ref$shouldDescriptio = _ref.shouldDescriptionWrap, shouldDescriptionWrap = _ref$shouldDescriptio === void 0 ? true : _ref$shouldDescriptio, _ref$shouldTitleWrap = _ref.shouldTitleWrap, shouldTitleWrap = _ref$shouldTitleWrap === void 0 ? true : _ref$shouldTitleWrap, target = _ref.target, testId = _ref.testId, UNSAFE_shouldDisableRouterLink = _ref.UNSAFE_shouldDisableRouterLink, returnFocusRef = _ref.returnFocusRef, interactionName = _ref.interactionName, rest = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $d1103224b1f806e2$var$_excluded);
    // if the dropdown item has aria-haspopup, we won't register with focus manager
    // since it is a nested trigger, we have registered inside dropdown-menu
    var itemRef = (0, $44b6e7ab1a14c674$export$2e2bcd8739ae039)(!!rest['aria-haspopup']);
    var handleItemClick = (0, $5FkrB.useCallback)(function(event) {
        if (returnFocusRef !== null && returnFocusRef !== void 0 && returnFocusRef.current) returnFocusRef.current.focus();
        if (onClick) onClick(event);
    }, [
        onClick,
        returnFocusRef
    ]);
    if (component) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $42b2692ce9fb697a$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        component: component,
        description: description,
        iconAfter: elemAfter,
        iconBefore: elemBefore,
        isDisabled: isDisabled,
        isSelected: isSelected,
        onClick: handleItemClick,
        ref: (0, $e2c87340de9b0062$export$2e2bcd8739ae039)([
            ref,
            itemRef
        ]),
        shouldDescriptionWrap: shouldDescriptionWrap,
        shouldTitleWrap: shouldTitleWrap,
        testId: testId,
        href: href,
        target: target,
        rel: rel
    }, (0, $id6Cu.fg)('platform_button_item-add-ufo-metrics') && {
        interactionName: interactionName
    }, rest), children);
    else if (href) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $d4a673358a2339ee$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        description: description,
        href: href,
        iconAfter: elemAfter,
        iconBefore: elemBefore,
        isDisabled: isDisabled,
        isSelected: isSelected,
        onClick: handleItemClick,
        ref: (0, $e2c87340de9b0062$export$2e2bcd8739ae039)([
            ref,
            itemRef
        ]),
        rel: rel,
        role: "menuitem",
        shouldDescriptionWrap: shouldDescriptionWrap,
        shouldTitleWrap: shouldTitleWrap,
        target: target,
        testId: testId,
        UNSAFE_shouldDisableRouterLink: UNSAFE_shouldDisableRouterLink
    }, (0, $id6Cu.fg)('platform_button_item-add-ufo-metrics') && {
        interactionName: interactionName
    }, rest), children);
    else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $597d39da41bbd0cb$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        description: description,
        iconAfter: elemAfter,
        iconBefore: elemBefore,
        isDisabled: isDisabled,
        isSelected: isSelected,
        onClick: handleItemClick,
        ref: (0, $e2c87340de9b0062$export$2e2bcd8739ae039)([
            ref,
            itemRef
        ]),
        role: "menuitem",
        shouldDescriptionWrap: shouldDescriptionWrap,
        shouldTitleWrap: shouldTitleWrap,
        testId: testId,
        target: target,
        rel: rel
    }, (0, $id6Cu.fg)('platform_button_item-add-ufo-metrics') && {
        interactionName: interactionName
    }, rest), children);
});
var $d1103224b1f806e2$export$2e2bcd8739ae039 = $d1103224b1f806e2$var$DropdownMenuItem;


var $kqp0i = parcelRequire("kqp0i");

var $iYJcE = parcelRequire("iYJcE");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");




var $id6Cu = parcelRequire("id6Cu");

var $5FkrB = parcelRequire("5FkrB");
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5FkrB = parcelRequire("5FkrB");

var $74Zh5 = parcelRequire("74Zh5");

var $ccYVa = parcelRequire("ccYVa");

var $8dO48 = parcelRequire("8dO48");
// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
var $cb10e0ad8370a905$var$svgStyles = (0, $74Zh5.css)((0, $8dO48.commonSVGStyles));
/**
 * __SVG__
 *
 * An icon is used as a visual representation of common actions and commands to provide context.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-svgs)
 */ var $cb10e0ad8370a905$var$SVG = /*#__PURE__*/ (0, $5FkrB.memo)(function SVG(_ref) {
    var _ref$size = _ref.size, size = _ref$size === void 0 ? 'medium' : _ref$size, label = _ref.label, _ref$primaryColor = _ref.primaryColor, primaryColor = _ref$primaryColor === void 0 ? 'currentColor' : _ref$primaryColor, secondaryColor = _ref.secondaryColor, testId = _ref.testId, children = _ref.children;
    return (0, $74Zh5.jsx)("svg", {
        viewBox: "0 0 24 24",
        style: {
            color: primaryColor,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            fill: secondaryColor || (0, $ccYVa.getBackground)()
        },
        css: [
            $cb10e0ad8370a905$var$svgStyles,
            (0, $8dO48.sizeStyleMap)[size]
        ],
        "data-testid": testId,
        "aria-label": label || undefined,
        role: label ? 'img' : 'presentation'
    }, children);
});
var $cb10e0ad8370a905$export$2e2bcd8739ae039 = $cb10e0ad8370a905$var$SVG;



var $id6Cu = parcelRequire("id6Cu");

var $h0N4L = parcelRequire("h0N4L");
/**
 * __Checkbox icon__
 *
 * Used to visually represent the selected state in DropdownItemCheckbox
 *
 * @internal
 */ var $216cf0be11e55102$var$CheckboxIcon = function CheckboxIcon(_ref) {
    var checked = _ref.checked;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $cb10e0ad8370a905$export$2e2bcd8739ae039), {
        label: "",
        size: "medium",
        primaryColor: checked ? "var(--ds-background-selected-bold, ".concat((0, $h0N4L.B400), ")") : "var(--ds-background-input, ".concat((0, $h0N4L.N10), ")"),
        secondaryColor: checked ? "var(--ds-icon-inverse, ".concat((0, $h0N4L.N10), ")") : 'transparent'
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("g", {
        fillRule: "evenodd"
    }, // eslint-disable-next-line @atlaskit/platform/no-preconditioning, @atlaskit/platform/ensure-feature-flag-prefix
    (0, $id6Cu.fg)('platform-visual-refresh-icons') && (0, $id6Cu.fg)('platform-icon-control-migration') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("rect", {
        stroke: checked ? "var(--ds-border-selected, ".concat((0, $h0N4L.B400), ")") : "var(--ds-border-input, ".concat((0, $h0N4L.N100), ")"),
        x: "5.5",
        y: "5.5",
        width: "13",
        height: "13",
        rx: "1.5",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M16.3262 9.48011L15.1738 8.51984L10.75 13.8284L8.82616 11.5198L7.67383 12.4801L10.1738 15.4801C10.3163 15.6511 10.5274 15.75 10.75 15.75C10.9726 15.75 11.1837 15.6511 11.3262 15.4801L16.3262 9.48011Z",
        fill: "inherit"
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("rect", {
        fill: "currentColor",
        x: "6",
        y: "6",
        width: "12",
        height: "12",
        rx: "2",
        stroke: checked ? "var(--ds-border-selected, ".concat((0, $h0N4L.B400), ")") : "var(--ds-border-input, ".concat((0, $h0N4L.N100), ")"),
        strokeWidth: 1
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("path", {
        d: "M9.707 11.293a1 1 0 10-1.414 1.414l2 2a1 1 0 001.414 0l4-4a1 1 0 10-1.414-1.414L11 12.586l-1.293-1.293z",
        fill: "inherit"
    }))));
};
var $216cf0be11e55102$export$2e2bcd8739ae039 = $216cf0be11e55102$var$CheckboxIcon;



var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");

var $5FkrB = parcelRequire("5FkrB");
var $1902a215c152e879$export$baf37c4be89255b8 = /*#__PURE__*/ (0, $5FkrB.createContext)('');



/**
 * Custom hook to handle checkbox state for dropdown menu.
 * It works in tandem with the selection store context when the
 * component is uncontrolled.
 */ var $d708a484e4aa3179$var$useCheckboxState = function useCheckboxState(_ref) {
    var isSelected = _ref.isSelected, id = _ref.id, defaultSelected = _ref.defaultSelected;
    var _useContext = (0, $5FkrB.useContext)((0, $0ff4847a2f5e8f4c$export$756f795847463ebd)), setItemState = _useContext.setItemState, getItemState = _useContext.getItemState;
    var groupId = (0, $5FkrB.useContext)((0, $1902a215c152e879$export$baf37c4be89255b8));
    var persistedIsSelected = getItemState(groupId, id);
    var _useState = (0, $5FkrB.useState)(// Initial state is set depending on value being defined or not.
    // This state is only utilised if the checkbox is uncontrolled.
    function() {
        return persistedIsSelected !== undefined ? persistedIsSelected : defaultSelected || false;
    }), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), localIsSelected = _useState2[0], setLocalIsSelected = _useState2[1];
    var setLocalState = (0, $5FkrB.useCallback)(function(newValue) {
        var nextValue = newValue(persistedIsSelected);
        setLocalIsSelected(nextValue);
        setItemState(groupId, id, nextValue);
    }, [
        setItemState,
        persistedIsSelected,
        groupId,
        id
    ]);
    // Checkbox is controlled - do nothing!
    if (typeof isSelected === 'boolean') return [
        isSelected,
        function() {
            return false;
        }
    ];
    // Checkbox is going through its first render pass!
    if (persistedIsSelected === undefined) // Set the item so we have this state to access next time the checkbox renders (either by mounting or re-rendering!)
    setItemState(groupId, id, defaultSelected || false);
    // Return the value and setter!
    // Remember this flow is only returned if the checkbox is uncontrolled.
    return [
        localIsSelected,
        setLocalState
    ];
};
var $d708a484e4aa3179$export$2e2bcd8739ae039 = $d708a484e4aa3179$var$useCheckboxState;




var $3ZMUU = parcelRequire("3ZMUU");
var $709d8ee79761c504$var$_excluded = [
    "children",
    "defaultSelected",
    "description",
    "id",
    "isDisabled",
    "isSelected",
    "onClick",
    "shouldDescriptionWrap",
    "shouldTitleWrap",
    "testId",
    "interactionName"
];
/**
 * __Dropdown item checkbox__
 *
 * A dropdown item checkbox creates groups that have multiple selections.
 *
 * - [Examples](https://atlassian.design/components/dropdown-menu/dropdown-item-checkbox/examples)
 * - [Code](https://atlassian.design/components/dropdown-menu/dropdown-item-checkbox/code)
 * - [Usage](https://atlassian.design/components/dropdown-menu/dropdown-item-checkbox/usage)
 */ var $709d8ee79761c504$var$DropdownItemCheckbox = function DropdownItemCheckbox(_ref) {
    var children = _ref.children, defaultSelected = _ref.defaultSelected, description = _ref.description, id = _ref.id, isDisabled = _ref.isDisabled, isSelected = _ref.isSelected, _ref$onClick = _ref.onClick, providedOnClick = _ref$onClick === void 0 ? (0, $f729a2485b96e7ca$export$2e2bcd8739ae039) : _ref$onClick, _ref$shouldDescriptio = _ref.shouldDescriptionWrap, shouldDescriptionWrap = _ref$shouldDescriptio === void 0 ? true : _ref$shouldDescriptio, _ref$shouldTitleWrap = _ref.shouldTitleWrap, shouldTitleWrap = _ref$shouldTitleWrap === void 0 ? true : _ref$shouldTitleWrap, testId = _ref.testId, interactionName = _ref.interactionName, rest = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $709d8ee79761c504$var$_excluded);
    typeof $3ZMUU;
    var _useCheckboxState = (0, $d708a484e4aa3179$export$2e2bcd8739ae039)({
        id: id,
        isSelected: isSelected,
        defaultSelected: defaultSelected
    }), _useCheckboxState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useCheckboxState, 2), selected = _useCheckboxState2[0], setSelected = _useCheckboxState2[1];
    var onClickHandler = (0, $5FkrB.useCallback)(function(event) {
        setSelected(function(selected) {
            return !selected;
        });
        providedOnClick(event);
    }, [
        providedOnClick,
        setSelected
    ]);
    var itemRef = (0, $44b6e7ab1a14c674$export$2e2bcd8739ae039)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $a69a838f3ece1f03$export$9ca534b70725964d).Provider, {
        value: "none"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $597d39da41bbd0cb$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        "aria-checked": selected,
        description: description,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $216cf0be11e55102$export$2e2bcd8739ae039), {
            checked: selected
        }),
        id: id,
        isDisabled: isDisabled,
        isSelected: selected,
        onClick: onClickHandler,
        ref: itemRef,
        role: "menuitemcheckbox",
        shouldDescriptionWrap: shouldDescriptionWrap,
        shouldTitleWrap: shouldTitleWrap,
        testId: testId
    }, (0, $id6Cu.fg)('platform_button_item-add-ufo-metrics') && {
        interactionName: interactionName
    }, rest), children));
};
var $709d8ee79761c504$export$2e2bcd8739ae039 = $709d8ee79761c504$var$DropdownItemCheckbox;


var $kqp0i = parcelRequire("kqp0i");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");


var $kqp0i = parcelRequire("kqp0i");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");

var $74Zh5 = parcelRequire("74Zh5");


var $h0N4L = parcelRequire("h0N4L");

var $kqp0i = parcelRequire("kqp0i");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");

var $74Zh5 = parcelRequire("74Zh5");



var $h0N4L = parcelRequire("h0N4L");
var $8b89d3badae38240$var$_excluded = [
    "children",
    "testId",
    "headingLevel",
    "id",
    "cssFn",
    "className"
];
var $8b89d3badae38240$var$headingStyles = (0, $74Zh5.css)({
    color: "var(--ds-text-subtle, ".concat((0, $h0N4L.N300), ")"),
    font: "var(--ds-font-heading-xxsmall, normal 600 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    paddingBlock: "var(--ds-space-0, 0px)",
    paddingInline: "var(--ds-space-200, 16px)"
});
/**
 * __Heading item__
 *
 * A heading item is used to describe sibling menu items.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/menu/docs/heading-item)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/menu)
 */ var $8b89d3badae38240$var$HeadingItem = /*#__PURE__*/ (0, $5FkrB.memo)(function(_ref) {
    var children = _ref.children, testId = _ref.testId, _ref$headingLevel = _ref.headingLevel, headingLevel = _ref$headingLevel === void 0 ? 2 : _ref$headingLevel, id = _ref.id, _ref$cssFn = _ref.cssFn, cssFn = _ref$cssFn === void 0 ? (0, $c7965232083f5e62$export$2e2bcd8739ae039) : _ref$cssFn, UNSAFE_className = _ref.className, rest = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $8b89d3badae38240$var$_excluded);
    (0, $84f32fdedd952178$export$eb1decd851a5ae56)("@atlaskit/menu", 'cssFn', cssFn !== (0, $c7965232083f5e62$export$2e2bcd8739ae039), '' // TODO: Create DAC post when primitives/xcss are available as alternatives
    );
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    var UNSAFE_overrides = (0, $74Zh5.css)(cssFn(undefined));
    return (0, $74Zh5.jsx)("div", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        css: [
            $8b89d3badae38240$var$headingStyles,
            // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
            UNSAFE_overrides
        ],
        role: "heading",
        "aria-level": headingLevel,
        "data-testid": testId,
        "data-ds--menu--heading-item": true,
        id: id,
        className: UNSAFE_className
    }, rest), children);
});
var $8b89d3badae38240$export$2e2bcd8739ae039 = $8b89d3badae38240$var$HeadingItem;


var $f551db15834dc6ac$var$_excluded = [
    "children",
    "overrides",
    "title",
    "titleId",
    "testId",
    "isScrollable",
    "hasSeparator",
    "id",
    "isList",
    "className"
];
var $f551db15834dc6ac$var$gridSize = 8;
var $f551db15834dc6ac$var$itemHeadingTopMargin = $f551db15834dc6ac$var$gridSize * 2.5;
var $f551db15834dc6ac$var$itemHeadingBottomMargin = $f551db15834dc6ac$var$gridSize * 0.75;
// Skeleton content is slightly shorter than the real content.
// Because of that we slightly increase the top margin to offset this so the
// containing size both real and skeleton always equal approx 30px.
var $f551db15834dc6ac$var$itemHeadingContentHeight = 16; // Originally headingSizes.h100.lineHeight from '@atlaskit/theme/typography'
var $f551db15834dc6ac$var$skeletonHeadingHeight = $f551db15834dc6ac$var$gridSize;
var $f551db15834dc6ac$var$skeletonHeadingMarginOffset = 3;
var $f551db15834dc6ac$var$skeletonHeadingTopMargin = $f551db15834dc6ac$var$itemHeadingTopMargin + ($f551db15834dc6ac$var$itemHeadingContentHeight - $f551db15834dc6ac$var$skeletonHeadingHeight) - $f551db15834dc6ac$var$skeletonHeadingMarginOffset;
// We want to move the entire body up by 3px without affecting the height of the skeleton container.
var $f551db15834dc6ac$var$skeletonHeadingBottomMargin = $f551db15834dc6ac$var$itemHeadingBottomMargin + $f551db15834dc6ac$var$skeletonHeadingMarginOffset;
var $f551db15834dc6ac$var$sectionPaddingTopBottom = $f551db15834dc6ac$var$gridSize * 0.75;
var $f551db15834dc6ac$var$VAR_SEPARATOR_COLOR = '--ds-menu-seperator-color';
var $f551db15834dc6ac$var$sectionStyles = (0, $74Zh5.css)({
    '&::before, &::after': {
        display: 'block',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        height: $f551db15834dc6ac$var$sectionPaddingTopBottom,
        content: '""'
    },
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& [data-ds--menu--heading-item]': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        marginBlockEnd: $f551db15834dc6ac$var$itemHeadingBottomMargin,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        marginBlockStart: $f551db15834dc6ac$var$itemHeadingTopMargin,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '&:first-of-type': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            marginBlockStart: $f551db15834dc6ac$var$itemHeadingTopMargin - $f551db15834dc6ac$var$sectionPaddingTopBottom
        }
    },
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& [data-ds--menu--skeleton-heading-item]': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        marginBlockEnd: $f551db15834dc6ac$var$skeletonHeadingBottomMargin,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        marginBlockStart: $f551db15834dc6ac$var$skeletonHeadingTopMargin,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '&:first-of-type': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            marginBlockStart: $f551db15834dc6ac$var$skeletonHeadingTopMargin - $f551db15834dc6ac$var$sectionPaddingTopBottom
        }
    },
    '&:focus': {
        // NOTE: Firefox allows elements that have "overflow: auto" to gain focus (as if it had tab-index="0")
        // We have made a deliberate choice to leave this behaviour as is.
        // This makes the outline go inside by 1px so it can actually be displayed
        // else it gets cut off from the overflow: scroll from the parent menu group.
        outlineOffset: -1
    }
});
var $f551db15834dc6ac$var$scrollableStyles = (0, $74Zh5.css)({
    flexShrink: 1,
    overflow: 'auto'
});
var $f551db15834dc6ac$var$unscrollableStyles = (0, $74Zh5.css)({
    flexShrink: 0
});
var $f551db15834dc6ac$var$thinSeparatorStyles = (0, $74Zh5.css)({
    borderBlockStart: "1px solid var(".concat($f551db15834dc6ac$var$VAR_SEPARATOR_COLOR, ", ", "var(--ds-border, ".concat((0, $h0N4L.N30A), ")"), ")")
});
var $f551db15834dc6ac$var$noSeparatorStyles = (0, $74Zh5.css)({
    // this is to ensure that adjacent sections without separators don't get additional margins.
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '[data-section] + &': {
        marginBlockStart: -6
    }
});
/**
 * __Section__
 *
 * A section includes related actions or items in a menu.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/menu/docs/section)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/menu)
 */ var $f551db15834dc6ac$var$Section = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function(_ref, ref) {
    var children = _ref.children, overrides = _ref.overrides, title = _ref.title, titleId = _ref.titleId, testId = _ref.testId, isScrollable = _ref.isScrollable, hasSeparator = _ref.hasSeparator, id = _ref.id, _ref$isList = _ref.isList, isList = _ref$isList === void 0 ? false : _ref$isList, UNSAFE_className = _ref.className, rest = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $f551db15834dc6ac$var$_excluded);
    (0, $84f32fdedd952178$export$eb1decd851a5ae56)("@atlaskit/menu", 'overrides', overrides !== undefined, '' // TODO: Create DAC post when primitives/xcss are available as alternatives
    );
    var UNSAFE_headingOverrides = overrides && overrides.HeadingItem && overrides.HeadingItem.cssFn;
    var content = isList ? (0, $74Zh5.jsx)("ul", {
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            margin: 0,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            padding: 0
        }
    }, (0, $5FkrB.Children).map((0, $5FkrB.Children).toArray(children), function(child, index) {
        return (0, $74Zh5.jsx)("li", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            style: {
                listStyleType: 'none',
                margin: 0,
                padding: 0
            },
            key: index
        }, child);
    })) : children;
    var childrenMarkup = title !== undefined ? (0, $74Zh5.jsx)((0, $5FkrB.Fragment), null, (0, $74Zh5.jsx)((0, $8b89d3badae38240$export$2e2bcd8739ae039), {
        cssFn: UNSAFE_headingOverrides,
        testId: testId && "".concat(testId, "--heading"),
        "aria-hidden": true
    }, title), content) : (0, $74Zh5.jsx)((0, $5FkrB.Fragment), null, content);
    return (0, $74Zh5.jsx)("div", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, rest, {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: UNSAFE_className,
        id: id,
        css: [
            $f551db15834dc6ac$var$sectionStyles,
            isScrollable ? $f551db15834dc6ac$var$scrollableStyles : $f551db15834dc6ac$var$unscrollableStyles,
            hasSeparator ? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            $f551db15834dc6ac$var$thinSeparatorStyles : $f551db15834dc6ac$var$noSeparatorStyles
        ],
        "aria-label": title,
        "aria-labelledby": titleId,
        "data-testid": testId,
        role: "group",
        "data-section": true,
        ref: ref
    }), childrenMarkup);
});
var $f551db15834dc6ac$export$2e2bcd8739ae039 = $f551db15834dc6ac$var$Section;



var $5FkrB = parcelRequire("5FkrB");

var $ayeN2 = parcelRequire("ayeN2");
var $d7pIx = parcelRequire("d7pIx");
var $4cdeb52649143e4d$var$headingStyles = (0, $d7pIx.xcss)({
    color: 'color.text.subtle',
    font: 'font.heading.xxsmall',
    paddingBlock: 'space.0',
    paddingInline: 'space.200'
});
/**
 * __Group title__
 *
 * Used to visually represent the title for DropdownMenu groups
 *
 * @internal
 */ var $4cdeb52649143e4d$var$GroupTitle = function GroupTitle(_ref) {
    var id = _ref.id, title = _ref.title;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $ayeN2.default), {
        "data-ds--menu--heading-item": true,
        role: "menuitem",
        id: id,
        "aria-hidden": "true",
        xcss: $4cdeb52649143e4d$var$headingStyles
    }, title);
};
var $4cdeb52649143e4d$export$2e2bcd8739ae039 = $4cdeb52649143e4d$var$GroupTitle;



var $60db3f2a35859adf$var$_excluded = [
    "children",
    "hasSeparator",
    "id",
    "isList",
    "isScrollable",
    "overrides",
    "testId",
    "title"
];
/**
 * __Dropdown item checkbox group__
 *
 * A wrapping element for dropdown menu checkbox items.
 *
 */ var $60db3f2a35859adf$var$DropdownItemCheckboxGroup = function DropdownItemCheckboxGroup(_ref) {
    var children = _ref.children, hasSeparator = _ref.hasSeparator, id = _ref.id, isList = _ref.isList, isScrollable = _ref.isScrollable, overrides = _ref.overrides, testId = _ref.testId, title = _ref.title, rest = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $60db3f2a35859adf$var$_excluded);
    var uid = (0, $13bc4d6429052436$export$f680877a34711e37)();
    var titleId = "dropdown-menu-item-checkbox-group-title-".concat(uid);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $1902a215c152e879$export$baf37c4be89255b8).Provider, {
        value: id
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $f551db15834dc6ac$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        hasSeparator: hasSeparator,
        id: id,
        isList: isList,
        isScrollable: isScrollable,
        overrides: overrides,
        testId: testId,
        titleId: title ? titleId : undefined
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $4cdeb52649143e4d$export$2e2bcd8739ae039), {
        id: titleId,
        title: title
    }), children));
};
var $60db3f2a35859adf$export$2e2bcd8739ae039 = $60db3f2a35859adf$var$DropdownItemCheckboxGroup;


var $kqp0i = parcelRequire("kqp0i");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");



var $65699b966485ea1d$var$_excluded = [
    "children",
    "id",
    "isList",
    "isScrollable",
    "title",
    "testId",
    "hasSeparator",
    "overrides"
];
/**
 * __Dropdown item checkbox group__
 *
 * A wrapping element for dropdown menu items.
 *
 */ var $65699b966485ea1d$var$DropdownMenuItemGroup = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function(_ref, ref) {
    var children = _ref.children, id = _ref.id, isList = _ref.isList, isScrollable = _ref.isScrollable, title = _ref.title, testId = _ref.testId, hasSeparator = _ref.hasSeparator, overrides = _ref.overrides, rest = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $65699b966485ea1d$var$_excluded);
    var uid = (0, $13bc4d6429052436$export$f680877a34711e37)();
    var titleId = "dropdown-menu-item-group-title-".concat(uid);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $f551db15834dc6ac$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        id: id,
        ref: ref,
        isList: isList,
        isScrollable: isScrollable,
        hasSeparator: hasSeparator,
        testId: testId,
        titleId: title ? titleId : undefined,
        overrides: overrides
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $4cdeb52649143e4d$export$2e2bcd8739ae039), {
        id: titleId,
        title: title
    }), children);
});
var $65699b966485ea1d$export$2e2bcd8739ae039 = $65699b966485ea1d$var$DropdownMenuItemGroup;


var $kqp0i = parcelRequire("kqp0i");

var $iYJcE = parcelRequire("iYJcE");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");




var $id6Cu = parcelRequire("id6Cu");

var $5FkrB = parcelRequire("5FkrB");


var $id6Cu = parcelRequire("id6Cu");

var $h0N4L = parcelRequire("h0N4L");
/**
 * __Radio icon__
 *
 * Used to visually represent the selected state in DropdownItemRadio
 *
 * @internal
 */ var $fdaffba38f4e1e26$var$RadioIcon = function RadioIcon(_ref) {
    var checked = _ref.checked;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $cb10e0ad8370a905$export$2e2bcd8739ae039), {
        label: "",
        size: "medium",
        primaryColor: checked ? "var(--ds-background-selected-bold, ".concat((0, $h0N4L.B400), ")") : "var(--ds-background-input, ".concat((0, $h0N4L.N10), ")"),
        secondaryColor: checked ? "var(--ds-icon-inverse, ".concat((0, $h0N4L.N10), ")") : 'transparent'
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("g", {
        fillRule: "evenodd"
    }, // eslint-disable-next-line @atlaskit/platform/no-preconditioning, @atlaskit/platform/ensure-feature-flag-prefix
    (0, $id6Cu.fg)('platform-visual-refresh-icons') && (0, $id6Cu.fg)('platform-icon-control-migration') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("circle", {
        cx: "12",
        cy: "12",
        r: "7.5",
        fill: "currentColor",
        stroke: checked ? "var(--ds-border-selected, ".concat((0, $h0N4L.B400), ")") : "var(--ds-border-input, ".concat((0, $h0N4L.N100), ")"),
        strokeWidth: "1"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("circle", {
        cx: "12",
        cy: "12",
        r: "3",
        fill: "inherit"
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("circle", {
        fill: "currentColor",
        cx: "12",
        cy: "12",
        r: "6",
        stroke: checked ? "var(--ds-border-selected, ".concat((0, $h0N4L.B400), ")") : "var(--ds-border-input, ".concat((0, $h0N4L.N100), ")"),
        strokeWidth: 1
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("circle", {
        fill: "inherit",
        cx: "12",
        cy: "12",
        r: "2"
    }))));
};
var $fdaffba38f4e1e26$export$2e2bcd8739ae039 = $fdaffba38f4e1e26$var$RadioIcon;



var $25nEq = parcelRequire("25nEq");

var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");

var $kqp0i = parcelRequire("kqp0i");

var $25nEq = parcelRequire("25nEq");

var $iYJcE = parcelRequire("iYJcE");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");






var $25nEq = parcelRequire("25nEq");
function $91f1ec866a08bd06$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $91f1ec866a08bd06$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $91f1ec866a08bd06$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $91f1ec866a08bd06$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $91f1ec866a08bd06$var$resetOptionsInGroup = function resetOptionsInGroup(group) {
    return Object.keys(group || {}).reduce(function(accumulator, current) {
        return $91f1ec866a08bd06$var$_objectSpread($91f1ec866a08bd06$var$_objectSpread({}, accumulator), {}, (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, current, typeof group[current] === 'undefined' ? undefined : false));
    }, {});
};
var $91f1ec866a08bd06$export$2e2bcd8739ae039 = $91f1ec866a08bd06$var$resetOptionsInGroup;


var $077dd7a59909f2d8$var$_excluded = [
    "children",
    "hasSeparator",
    "id",
    "isList",
    "isScrollable",
    "overrides",
    "testId",
    "title"
];
function $077dd7a59909f2d8$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $077dd7a59909f2d8$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $077dd7a59909f2d8$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $077dd7a59909f2d8$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $077dd7a59909f2d8$export$a79eda4ff50e30b6 = /*#__PURE__*/ (0, $5FkrB.createContext)({
    id: '',
    radioGroupState: {},
    selectRadioItem: (0, $f729a2485b96e7ca$export$2e2bcd8739ae039)
});
/**
 * __Dropdown item radio group__
 *  Store which manages the selection state for each DropdownItemRadio
 *  across mount and unmounts.
 *
 */ var $077dd7a59909f2d8$var$DropdownItemRadioGroup = function DropdownItemRadioGroup(_ref) {
    var children = _ref.children, hasSeparator = _ref.hasSeparator, id = _ref.id, isList = _ref.isList, isScrollable = _ref.isScrollable, overrides = _ref.overrides, testId = _ref.testId, title = _ref.title, rest = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $077dd7a59909f2d8$var$_excluded);
    var _useContext = (0, $5FkrB.useContext)((0, $0ff4847a2f5e8f4c$export$756f795847463ebd)), setGroupState = _useContext.setGroupState, getGroupState = _useContext.getGroupState;
    var uid = (0, $13bc4d6429052436$export$f680877a34711e37)();
    var titleId = "dropdown-menu-item-radio-group-title-".concat(uid);
    /**
   *  - initially `radioGroupState` is from selection store, so it's safe to update without re-rendering
   *  - we flush a render by updating this local radio group state
   */ var _useState = (0, $5FkrB.useState)(function() {
        return getGroupState(id);
    }), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), radioGroupState = _useState2[0], setRadioGroupState = _useState2[1];
    var selectRadioItem = function selectRadioItem(childId, value) {
        var newValue = $077dd7a59909f2d8$var$_objectSpread($077dd7a59909f2d8$var$_objectSpread({}, (0, $91f1ec866a08bd06$export$2e2bcd8739ae039)(getGroupState(id))), {}, (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, childId, value));
        setRadioGroupState(newValue);
        setGroupState(id, newValue);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement($077dd7a59909f2d8$export$a79eda4ff50e30b6.Provider, {
        value: {
            id: id,
            radioGroupState: radioGroupState,
            selectRadioItem: selectRadioItem
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $f551db15834dc6ac$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        hasSeparator: hasSeparator,
        id: id,
        isList: isList,
        isScrollable: isScrollable,
        overrides: overrides,
        testId: testId,
        titleId: title ? titleId : undefined
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $4cdeb52649143e4d$export$2e2bcd8739ae039), {
        id: titleId,
        title: title
    }), children));
};
var $077dd7a59909f2d8$export$2e2bcd8739ae039 = $077dd7a59909f2d8$var$DropdownItemRadioGroup;




function $4c3cf42cb6cdc0bc$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $4c3cf42cb6cdc0bc$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $4c3cf42cb6cdc0bc$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $4c3cf42cb6cdc0bc$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $4c3cf42cb6cdc0bc$var$useRadioState(_ref) {
    var id = _ref.id, isSelected = _ref.isSelected, defaultSelected = _ref.defaultSelected;
    var _useContext = (0, $5FkrB.useContext)((0, $0ff4847a2f5e8f4c$export$756f795847463ebd)), setGroupState = _useContext.setGroupState, getGroupState = _useContext.getGroupState;
    var _useContext2 = (0, $5FkrB.useContext)((0, $077dd7a59909f2d8$export$a79eda4ff50e30b6)), group = _useContext2.id, radioGroupState = _useContext2.radioGroupState, selectRadioItem = _useContext2.selectRadioItem;
    var persistedIsSelected = radioGroupState[id];
    var _useState = (0, $5FkrB.useState)(function() {
        return persistedIsSelected !== undefined ? persistedIsSelected : defaultSelected || false;
    }), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), localIsSelected = _useState2[0], setLocalIsSelected = _useState2[1];
    var setLocalState = (0, $5FkrB.useCallback)(function(newValue) {
        if (!persistedIsSelected) {
            var nextValue = newValue(persistedIsSelected);
            selectRadioItem(id, nextValue);
            setLocalIsSelected(nextValue);
        }
    }, [
        persistedIsSelected,
        id,
        selectRadioItem
    ]);
    /**
   * - radio state changes any time a radio child is changed
   * - when it changes we want all radio buttons to update their local state
   * - it takes the value from radio group state and applies it locally if it exists which it will only exist, if it is selected
   */ (0, $5FkrB.useEffect)(function() {
        setLocalIsSelected(function() {
            var existing = radioGroupState[id];
            return existing !== undefined ? existing : defaultSelected || false;
        });
    }, [
        radioGroupState,
        group,
        id,
        defaultSelected
    ]);
    if (typeof isSelected === 'boolean') return [
        isSelected,
        function() {
            return false;
        }
    ];
    if (persistedIsSelected === undefined) {
        var existing = getGroupState(group);
        setGroupState(group, $4c3cf42cb6cdc0bc$var$_objectSpread($4c3cf42cb6cdc0bc$var$_objectSpread({}, (0, $91f1ec866a08bd06$export$2e2bcd8739ae039)(existing || {})), {}, (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, id, defaultSelected || false)));
    }
    return [
        localIsSelected,
        setLocalState
    ];
}
var $4c3cf42cb6cdc0bc$export$2e2bcd8739ae039 = $4c3cf42cb6cdc0bc$var$useRadioState;



var $a90c01acdec9c90d$var$canUseDOM = function canUseDOM() {
    return Boolean(typeof window !== 'undefined' && window.document && window.document.createElement);
};
/*
 * Making sure we can fallback to browsers doesn't support voice over -
 * we would using menuitemcheckbox / menuitemradio for these that supports voice over, and
 * will fallback to checkbox / radio for these doesn't
 */ var $a90c01acdec9c90d$var$isVoiceOverSupported = function isVoiceOverSupported() {
    return /Mac OS X/.test($a90c01acdec9c90d$var$canUseDOM() ? navigator.userAgent : '');
};
var $a90c01acdec9c90d$export$2e2bcd8739ae039 = $a90c01acdec9c90d$var$isVoiceOverSupported;



var $3ZMUU = parcelRequire("3ZMUU");
var $957fbbe730d1bbb2$var$_excluded = [
    "children",
    "defaultSelected",
    "testId",
    "id",
    "title",
    "description",
    "isDisabled",
    "isSelected",
    "onClick",
    "shouldDescriptionWrap",
    "shouldTitleWrap",
    "interactionName"
];
/**
 * __Dropdown item radio__
 *
 * A dropdown item radio displays groups that have a single selection.
 *
 * - [Examples](https://atlassian.design/components/dropdown-menu/dropdown-item-radio/examples)
 * - [Code](https://atlassian.design/components/dropdown-menu/dropdown-item-radio/code)
 * - [Usage](https://atlassian.design/components/dropdown-menu/dropdown-item-radio/usage)
 */ var $957fbbe730d1bbb2$var$DropdownItemRadio = function DropdownItemRadio(_ref) {
    var children = _ref.children, defaultSelected = _ref.defaultSelected, testId = _ref.testId, id = _ref.id, title = _ref.title, description = _ref.description, isDisabled = _ref.isDisabled, isSelected = _ref.isSelected, _ref$onClick = _ref.onClick, providedOnClick = _ref$onClick === void 0 ? (0, $f729a2485b96e7ca$export$2e2bcd8739ae039) : _ref$onClick, _ref$shouldDescriptio = _ref.shouldDescriptionWrap, shouldDescriptionWrap = _ref$shouldDescriptio === void 0 ? true : _ref$shouldDescriptio, _ref$shouldTitleWrap = _ref.shouldTitleWrap, shouldTitleWrap = _ref$shouldTitleWrap === void 0 ? true : _ref$shouldTitleWrap, interactionName = _ref.interactionName, rest = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $957fbbe730d1bbb2$var$_excluded);
    typeof $3ZMUU;
    var _useRadioState = (0, $4c3cf42cb6cdc0bc$export$2e2bcd8739ae039)({
        id: id,
        isSelected: isSelected,
        defaultSelected: defaultSelected
    }), _useRadioState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useRadioState, 2), selected = _useRadioState2[0], setSelected = _useRadioState2[1];
    var onClickHandler = (0, $5FkrB.useCallback)(function(event) {
        setSelected(function(selected) {
            return !selected;
        });
        providedOnClick(event);
    }, [
        providedOnClick,
        setSelected
    ]);
    var itemRef = (0, $44b6e7ab1a14c674$export$2e2bcd8739ae039)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $a69a838f3ece1f03$export$9ca534b70725964d).Provider, {
        value: "none"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $597d39da41bbd0cb$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        "aria-checked": selected,
        description: description,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $fdaffba38f4e1e26$export$2e2bcd8739ae039), {
            checked: selected
        }),
        id: id,
        isDisabled: isDisabled,
        isSelected: selected,
        onClick: onClickHandler,
        ref: itemRef,
        role: (0, $a90c01acdec9c90d$export$2e2bcd8739ae039)() ? 'radio' : 'menuitemradio',
        shouldDescriptionWrap: shouldDescriptionWrap,
        shouldTitleWrap: shouldTitleWrap,
        testId: testId,
        title: title
    }, (0, $id6Cu.fg)('platform_button_item-add-ufo-metrics') && {
        interactionName: interactionName
    }, rest), children));
};
var $957fbbe730d1bbb2$export$2e2bcd8739ae039 = $957fbbe730d1bbb2$var$DropdownItemRadio;




var $kqp0i = parcelRequire("kqp0i");

var $5FkrB = parcelRequire("5FkrB");

var $74Zh5 = parcelRequire("74Zh5");

var $69J3E = parcelRequire("69J3E");

var $3FlkA = parcelRequire("3FlkA");


var $1qBWl = parcelRequire("1qBWl");
/**
 * An empty function which does nothing.
 */ function $3ec7e1df73061c03$export$2e2bcd8739ae039() {}



var $25nEq = parcelRequire("25nEq");

var $5FkrB = parcelRequire("5FkrB");


var $id6Cu = parcelRequire("id6Cu");
function $5cf713b31a166640$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $5cf713b31a166640$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $5cf713b31a166640$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $5cf713b31a166640$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $5cf713b31a166640$export$650d12d3c2ddb8fc = /*#__PURE__*/ (0, $5FkrB.createContext)(0);
var $5cf713b31a166640$export$48b383b280e20440 = /*#__PURE__*/ (0, $5FkrB.createContext)({
    topLevelRef: {
        current: null
    },
    layerList: {
        current: null
    },
    setTopLevel: (0, $3ec7e1df73061c03$export$2e2bcd8739ae039)
});
/**
 *
 *  @internal
 * Context Provider Component which provider the current level of nested layers
 * It handles level management when it mounts and unmounts
 *
 */ var $5cf713b31a166640$var$LevelProvider = function LevelProvider(_ref) {
    var children = _ref.children, currentLevel = _ref.currentLevel;
    var _useContext = (0, $5FkrB.useContext)($5cf713b31a166640$export$48b383b280e20440), setTopLevel = _useContext.setTopLevel, topLevelRef = _useContext.topLevelRef, layerList = _useContext.layerList;
    // This is not unstable, it will run once for ref creation.
    // eslint-disable-next-line  @repo/internal/react/disallow-unstable-values
    var id = (0, $5FkrB.useRef)((0, $id6Cu.fg)('layering-top-level-use-array') ? Math.random().toString(36) : '');
    if (!(0, $id6Cu.fg)('layering-top-level-use-array')) {
        if (topLevelRef.current === null || currentLevel > topLevelRef.current) setTopLevel(currentLevel);
    }
    if (!(0, $id6Cu.fg)('layering-top-level-use-array')) // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $5FkrB.useEffect)(function() {
        return function() {
            // avoid immediate cleanup using setTimeout when component unmount
            // this will make sure non-top layer components can get the correct top level value
            // when multiple layers trigger onClose in sequence
            setTimeout(function() {
                setTopLevel(currentLevel - 1);
            }, 0);
        };
    }, [
        setTopLevel,
        currentLevel,
        topLevelRef
    ]);
    if ((0, $id6Cu.fg)('layering-top-level-use-array')) // Remove eslint error on FG cleanup
    // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $5FkrB.useEffect)(function() {
        var safeLayerList = layerList === null || layerList === void 0 ? void 0 : layerList.current;
        var safeId = id.current;
        if (!safeLayerList) return;
        safeLayerList.push(safeId);
        return function() {
            var index = safeLayerList.indexOf(safeId);
            if (index > -1) safeLayerList.splice(index, 1);
        };
    }, [
        layerList,
        id
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement($5cf713b31a166640$export$650d12d3c2ddb8fc.Provider, {
        value: currentLevel
    }, children);
};
/**
 *
 *  @internal
 * Context Provider Component which provides the top level of all nested layers
 * It provides initial top level ref value as 0 and set top level method
 *
 */ var $5cf713b31a166640$var$LayeringProvider = function LayeringProvider(_ref2) {
    var children = _ref2.children;
    var topLevelRef = (0, $5FkrB.useRef)(0);
    var layerList = (0, $5FkrB.useRef)([]);
    var value = (0, $5FkrB.useMemo)(function() {
        return $5cf713b31a166640$var$_objectSpread({
            topLevelRef: topLevelRef,
            setTopLevel: function setTopLevel(level) {
                topLevelRef.current = level;
            }
        }, (0, $id6Cu.fg)('layering-top-level-use-array') ? {
            layerList: layerList
        } : {});
    }, [
        topLevelRef
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement($5cf713b31a166640$export$48b383b280e20440.Provider, {
        value: value
    }, children);
};
var $5cf713b31a166640$export$7c885f891c940977 = function Layering(_ref3) {
    var children = _ref3.children, _ref3$isDisabled = _ref3.isDisabled, isDisabled = _ref3$isDisabled === void 0 ? true : _ref3$isDisabled;
    var currentLevel = (0, $5FkrB.useContext)($5cf713b31a166640$export$650d12d3c2ddb8fc);
    if (isDisabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).Fragment, null, children);
    var isNested = currentLevel > 0;
    var content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement($5cf713b31a166640$var$LevelProvider, {
        currentLevel: currentLevel + 1
    }, children);
    return isNested ? content : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement($5cf713b31a166640$var$LayeringProvider, null, content);
};



var $eQzrx = parcelRequire("eQzrx");

var $id6Cu = parcelRequire("id6Cu");

var $6bqMl = parcelRequire("6bqMl");
/* eslint-disable no-console */ var $6adb104abc0843d5$var$printed = {};
function $6adb104abc0843d5$export$2e2bcd8739ae039(message) {
    if ($6adb104abc0843d5$var$printed[message]) return;
    $6adb104abc0843d5$var$printed[message] = true;
    if (typeof window !== 'undefined') console.warn(message);
}



var $3ZMUU = parcelRequire("3ZMUU");
function $c933e034ce6dccea$export$2e2bcd8739ae039(packageName, api, additionalMessage) {
    (0, $6adb104abc0843d5$export$2e2bcd8739ae039)("[".concat(packageName, "]: The ").concat(api, " is deprecated.").concat(additionalMessage && " ".concat(additionalMessage)));
}
function $c933e034ce6dccea$export$eb1decd851a5ae56(packageName, propName, predicate, deprecationAnnouncementOnDAC) {
    typeof $3ZMUU;
}


// Reds
var $fc018eea7e59cced$export$4b84fd0e2c617bd = '#FFEBE6';
var $fc018eea7e59cced$export$b34b069eff244586 = '#FFBDAD';
var $fc018eea7e59cced$export$be802dd0d8b57f35 = '#FF8F73';
var $fc018eea7e59cced$export$60847d42f9da92a6 = '#FF7452';
var $fc018eea7e59cced$export$4a7404f376229999 = '#FF5630';
var $fc018eea7e59cced$export$2010d0fb4295b346 = '#DE350B';
var $fc018eea7e59cced$export$2837b5a1a71d5c02 = '#BF2600';
var $fc018eea7e59cced$export$8d9596b529bbb9cf = '#FFFAE6';
var $fc018eea7e59cced$export$41060a744ab0b7ae = '#FFF0B3';
var $fc018eea7e59cced$export$1cc05bbbf340e559 = '#FFE380';
var $fc018eea7e59cced$export$5aae31392d72caaa = '#FFC400';
var $fc018eea7e59cced$export$c6930421db9fa514 = '#FFAB00';
var $fc018eea7e59cced$export$59619663aa6500fb = '#FF991F';
var $fc018eea7e59cced$export$874739ea9e379ab6 = '#FF8B00';
var $fc018eea7e59cced$export$8a6341c32b6a3ee6 = '#E3FCEF';
var $fc018eea7e59cced$export$69a3bf21b9686c2b = '#ABF5D1';
var $fc018eea7e59cced$export$afbce1382ec95f73 = '#79F2C0';
var $fc018eea7e59cced$export$747d86715d4175de = '#57D9A3';
var $fc018eea7e59cced$export$940e1f69e873f202 = '#36B37E';
var $fc018eea7e59cced$export$a49394138f7b8e85 = '#00875A';
var $fc018eea7e59cced$export$6fa04827ac68a4fb = '#006644';
var $fc018eea7e59cced$export$226de0355ed012f8 = '#DEEBFF';
var $fc018eea7e59cced$export$8c13c2ee36917869 = '#B3D4FF';
var $fc018eea7e59cced$export$ecfc1dff386a3e7a = '#4C9AFF';
var $fc018eea7e59cced$export$215b7063051591f1 = '#2684FF';
var $fc018eea7e59cced$export$e62e8919cca44969 = '#0065FF';
var $fc018eea7e59cced$export$b3de0ae08da2ce64 = '#0052CC';
var $fc018eea7e59cced$export$a6ee3d71bc067634 = '#0747A6';
var $fc018eea7e59cced$export$67f15409e87642a1 = '#669DF1';
var $fc018eea7e59cced$export$f0539dbc42dbb067 = '#8FB8F6';
var $fc018eea7e59cced$export$363e4475840015bb = '#EAE6FF';
var $fc018eea7e59cced$export$4b0a4417ed59760f = '#C0B6F2';
var $fc018eea7e59cced$export$6011520a64d9a187 = '#998DD9';
var $fc018eea7e59cced$export$a7175d4e9206bc80 = '#8777D9';
var $fc018eea7e59cced$export$b48405b95304b5a1 = '#6554C0';
var $fc018eea7e59cced$export$c71e4279dd54a18d = '#5243AA';
var $fc018eea7e59cced$export$147899de772240ec = '#403294';
var $fc018eea7e59cced$export$2cf711fe14c66f06 = '#E6FCFF';
var $fc018eea7e59cced$export$7a8f4d33f6f9772c = '#B3F5FF';
var $fc018eea7e59cced$export$776c9c497ef08533 = '#79E2F2';
var $fc018eea7e59cced$export$69cb3ca10c1e330e = '#00C7E6';
var $fc018eea7e59cced$export$9dc1ef0f3f48059b = '#00B8D9';
var $fc018eea7e59cced$export$7c835c78b6fcdef8 = '#00A3BF';
var $fc018eea7e59cced$export$6036577f95c3877e = '#008DA6';
var $fc018eea7e59cced$export$29a4f05edc054374 = '#FFFFFF';
var $fc018eea7e59cced$export$e655ef011c4aa1a2 = '#FAFBFC';
var $fc018eea7e59cced$export$9fdfb749e33cdf97 = '#F4F5F7';
var $fc018eea7e59cced$export$3e51e8f1440314ba = '#EBECF0';
var $fc018eea7e59cced$export$1ce2d1575d444ceb = '#DFE1E6';
var $fc018eea7e59cced$export$8754fc7e6d8b3000 = '#C1C7D0';
var $fc018eea7e59cced$export$c2e91cbeada39b8b = '#B3BAC5';
var $fc018eea7e59cced$export$5f71e19f3a7ad9de = '#A5ADBA';
var $fc018eea7e59cced$export$eaa8c8a70ac22806 = '#97A0AF';
var $fc018eea7e59cced$export$7c87d337fb91a97d = '#8993A4';
var $fc018eea7e59cced$export$d6447c357493214f = '#7A869A';
var $fc018eea7e59cced$export$f563ee71e9ee74cd = '#6B778C';
var $fc018eea7e59cced$export$e2ef2124cf4024b1 = '#5E6C84';
var $fc018eea7e59cced$export$eece5f492e429f08 = '#505F79';
var $fc018eea7e59cced$export$c39c0fe0f26207ae = '#42526E';
var $fc018eea7e59cced$export$7090862dc3038a9f = '#344563';
var $fc018eea7e59cced$export$ad0bacf983b7ddaa = '#253858';
var $fc018eea7e59cced$export$7d61b15e0da132af = '#172B4D';
var $fc018eea7e59cced$export$fbda843f0a27fe96 = '#091E42';
var $fc018eea7e59cced$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
var $fc018eea7e59cced$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
var $fc018eea7e59cced$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
var $fc018eea7e59cced$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
var $fc018eea7e59cced$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
var $fc018eea7e59cced$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
var $fc018eea7e59cced$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
var $fc018eea7e59cced$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
var $fc018eea7e59cced$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
var $fc018eea7e59cced$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
var $fc018eea7e59cced$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
var $fc018eea7e59cced$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
var $fc018eea7e59cced$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
var $fc018eea7e59cced$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
var $fc018eea7e59cced$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
var $fc018eea7e59cced$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
var $fc018eea7e59cced$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
var $fc018eea7e59cced$export$2f6319cf7d736c2a = '#E6EDFA';
var $fc018eea7e59cced$export$95126bc8884d6634 = '#DCE5F5';
var $fc018eea7e59cced$export$8338d8c35d44ff1 = '#CED9EB';
var $fc018eea7e59cced$export$5368d76ae4fbbda7 = '#B8C7E0';
var $fc018eea7e59cced$export$9f0a771d16ec8d36 = '#ABBBD6';
var $fc018eea7e59cced$export$abcf8c38338b4aa5 = '#9FB0CC';
var $fc018eea7e59cced$export$97e81faa16a182c7 = '#8C9CB8';
var $fc018eea7e59cced$export$bfe21c59123ecf33 = '#7988A3';
var $fc018eea7e59cced$export$ee82aa2ea6a1558 = '#67758F';
var $fc018eea7e59cced$export$682927c6ed76be02 = '#56637A';
var $fc018eea7e59cced$export$91fd9994c5be9757 = '#455166';
var $fc018eea7e59cced$export$d281fbfe3cff2df6 = '#3B475C';
var $fc018eea7e59cced$export$3902c91d8b98a753 = '#313D52';
var $fc018eea7e59cced$export$8e8133c1ba5845b5 = '#283447';
var $fc018eea7e59cced$export$33ff357f6620b39 = '#202B3D';
var $fc018eea7e59cced$export$633847cf062b69e0 = '#1B2638';
var $fc018eea7e59cced$export$9776a6e503bdbf76 = '#121A29';
var $fc018eea7e59cced$export$6c813d5160dff5db = '#0E1624';
var $fc018eea7e59cced$export$3d4f271a500072a = '#0D1424';
var $fc018eea7e59cced$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
var $fc018eea7e59cced$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
var $fc018eea7e59cced$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
var $fc018eea7e59cced$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
var $fc018eea7e59cced$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
var $fc018eea7e59cced$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
var $fc018eea7e59cced$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
var $fc018eea7e59cced$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
var $fc018eea7e59cced$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
var $fc018eea7e59cced$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
var $fc018eea7e59cced$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
var $fc018eea7e59cced$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
var $fc018eea7e59cced$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
var $fc018eea7e59cced$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
var $fc018eea7e59cced$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
var $fc018eea7e59cced$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
var $fc018eea7e59cced$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';
var $fc018eea7e59cced$export$d2adc5dedf09fced = '#292A2E';
var $fc018eea7e59cced$export$f51762073d2bb381 = '#94C748';
var $fc018eea7e59cced$export$95e26d54def96891 = '#B3DF72';


var $447ae92c83d36574$export$44ffba16bd48dac6 = '__ATLASKIT_THEME__';
var $447ae92c83d36574$export$c93026a968943f95 = 'light';
var $447ae92c83d36574$export$6ba72c8346b4c57e = [
    'light',
    'dark'
];
var $447ae92c83d36574$export$7a57f79000377ca2 = function borderRadius() {
    return 3;
};
var $447ae92c83d36574$export$6d8204c2cb2e06b8 = function gridSize() {
    return 8;
};
var $447ae92c83d36574$export$8e24544ddba725ee = function focusRing() {
    var color = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "var(--ds-border-focused, ".concat((0, $fc018eea7e59cced$export$215b7063051591f1), ")");
    var outlineWidth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $447ae92c83d36574$export$6d8204c2cb2e06b8() / 4;
    (0, $c933e034ce6dccea$export$2e2bcd8739ae039)('@atlaskit/theme', 'focus ring mixin', 'Please use `@atlaskit/focus-ring` instead.');
    return "\n  &:focus {\n    outline: none;\n    box-shadow: 0px 0px 0px ".concat(outlineWidth, "px ").concat(color, ";\n  }\n");
};
var $447ae92c83d36574$export$c0dd343266bc3261 = function noFocusRing() {
    return "\n  box-shadow: none;\n";
};
var $447ae92c83d36574$export$7be255094ccdc533 = {
    card: function card() {
        return 100;
    },
    navigation: function navigation() {
        return 200;
    },
    dialog: function dialog() {
        return 300;
    },
    layer: function layer() {
        return 400;
    },
    blanket: function blanket() {
        return 500;
    },
    modal: function modal() {
        return 510;
    },
    flag: function flag() {
        return 600;
    },
    spotlight: function spotlight() {
        return 700;
    },
    tooltip: function tooltip() {
        return 9999;
    }
};
var $447ae92c83d36574$export$a1b3edb637fb4f35 = function visuallyHidden() {
    (0, $c933e034ce6dccea$export$2e2bcd8739ae039)('@atlaskit/theme', 'visually hidden mixin', 'Please use `@atlaskit/visually-hidden` instead.');
    return {
        border: '0 !important',
        clip: 'rect(1px, 1px, 1px, 1px) !important',
        height: '1px !important',
        overflow: 'hidden !important',
        padding: '0 !important',
        position: 'absolute !important',
        width: '1px !important',
        whiteSpace: 'nowrap !important'
    };
};
var $447ae92c83d36574$export$ba1d834b86d72a09 = $447ae92c83d36574$export$a1b3edb637fb4f35;
var $447ae92c83d36574$export$e497e856b4f89fcd = function skeletonShimmer() {
    return {
        css: {
            backgroundColor: "var(--ds-skeleton, ".concat((0, $fc018eea7e59cced$export$8d43898f60b96a82), ")"),
            animationDuration: '1.5s',
            animationIterationCount: 'infinite',
            animationTimingFunction: 'linear',
            animationDirection: 'alternate'
        },
        keyframes: {
            from: {
                backgroundColor: "var(--ds-skeleton, ".concat((0, $fc018eea7e59cced$export$8d43898f60b96a82), ")")
            },
            to: {
                backgroundColor: "var(--ds-skeleton-subtle, ".concat((0, $fc018eea7e59cced$export$920c0d5c49070351), ")")
            }
        }
    };
};



var $kqp0i = parcelRequire("kqp0i");

var $iYJcE = parcelRequire("iYJcE");

var $ekGgq = parcelRequire("ekGgq");

var $25nEq = parcelRequire("25nEq");

var $5FkrB = parcelRequire("5FkrB");

var $74Zh5 = parcelRequire("74Zh5");
/**
 * Assigns the node to all the refs passed in the argument.
 *
 * @param refs: An array of refs (as function or ref object)
 */ function $93853b40b059c181$export$2e2bcd8739ae039(refs) {
    // TODO: could this be wrapped in `useCallback` so we get a stable function?
    return function(value) {
        refs.forEach(function(ref) {
            if (typeof ref === 'function') ref(value);
            else if (ref !== null) ref.current = value;
        });
    };
}



var $5FkrB = parcelRequire("5FkrB");
function $cf5316edb3edd9ae$export$2e2bcd8739ae039(ref, autoFocus) {
    var initialMount = (0, $5FkrB.useRef)(true);
    (0, $5FkrB.useEffect)(function() {
        if (ref && initialMount.current && autoFocus && ref.current) ref.current.focus();
        initialMount.current = false;
    }, [
        autoFocus,
        ref
    ]);
}



var $ekGgq = parcelRequire("ekGgq");

var $5FkrB = parcelRequire("5FkrB");

var $b5lkZ = parcelRequire("b5lkZ");

var $id6Cu = parcelRequire("id6Cu");
var $16c8dcce41574d15$var$_React$useId;
// Type copied from https://github.com/thearnica/react-uid/blob/0f507fbbdb1ab84acf477ec32698afe3d2191e49/src/hooks.ts#L12
// Copied rather than inferred to make the type transparent
// @ts-ignore - useId is not accessible in React 16
var $16c8dcce41574d15$var$react18UseId = ($16c8dcce41574d15$var$_React$useId = (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).useId) !== null && $16c8dcce41574d15$var$_React$useId !== void 0 ? $16c8dcce41574d15$var$_React$useId : undefined;
function $16c8dcce41574d15$export$f680877a34711e37() {
    if ($16c8dcce41574d15$var$react18UseId && (0, $id6Cu.fg)('platform-dst-react-18-use-id')) return $16c8dcce41574d15$var$react18UseId();
    return "uid".concat((0, $b5lkZ.useUID)());
}
var $16c8dcce41574d15$export$6be90bcb437e928f = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function(_ref, ref) {
    var children = _ref.children, _ref$postfix = _ref.postfix, postfix = _ref$postfix === void 0 ? '' : _ref$postfix, _ref$prefix = _ref.prefix, prefix = _ref$prefix === void 0 ? '' : _ref$prefix;
    var id = "".concat(prefix).concat($16c8dcce41574d15$export$f680877a34711e37()).concat(postfix);
    (0, $5FkrB.useEffect)(function() {
        if (!ref) return;
        switch((0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(ref)){
            case 'function':
                ref(id);
                break;
            case 'object':
                ref.current = id;
                break;
            default:
                throw new Error("Unreachable case for unsupported type of ref \"".concat((0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(ref), "\""));
        }
    }, [
        id,
        ref
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).Fragment, null, typeof children === 'function' ? children({
        id: id
    }) : children);
});
function $16c8dcce41574d15$export$6ee17796e3d70de2() {
    if ($16c8dcce41574d15$var$react18UseId && (0, $id6Cu.fg)('platform-dst-react-18-use-id')) {
        var uid = $16c8dcce41574d15$var$react18UseId();
        return function(id) {
            return "".concat(uid, "-").concat(id.toString());
        };
    }
    return (0, $b5lkZ.useUIDSeed)();
}



var $eYQvF = parcelRequire("eYQvF");

var $25nEq = parcelRequire("25nEq");

var $5FkrB = parcelRequire("5FkrB");

var $7QpUe = parcelRequire("7QpUe");

var $id6Cu = parcelRequire("id6Cu");

function $261818ab3b11e0a4$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $261818ab3b11e0a4$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $261818ab3b11e0a4$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $261818ab3b11e0a4$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $261818ab3b11e0a4$var$ESCAPE = 'Escape';
function $261818ab3b11e0a4$export$4a4bf067ea9e7886(_ref) {
    var onClose = _ref.onClose, isDisabled = _ref.isDisabled;
    var escapePressed = (0, $5FkrB.useRef)(false);
    var _useLayering = $261818ab3b11e0a4$export$c8b4d54e03dee6ed(), isLayerDisabled = _useLayering.isLayerDisabled;
    var onKeyDown = (0, $5FkrB.useCallback)(function(e) {
        var isDisabledLayer = isLayerDisabled();
        if (isDisabled || escapePressed.current || e.key !== $261818ab3b11e0a4$var$ESCAPE || isDisabledLayer) // We're either already handling the key down event or it's not escape or disabled.
        // Bail early!
        return;
        escapePressed.current = true;
        onClose(e);
    }, [
        onClose,
        isDisabled,
        isLayerDisabled
    ]);
    var onKeyUp = (0, $5FkrB.useCallback)(function() {
        escapePressed.current = false;
    }, []);
    (0, $5FkrB.useEffect)(function() {
        return (0, $7QpUe.bindAll)(window, [
            {
                type: 'keydown',
                listener: onKeyDown
            },
            {
                type: 'keyup',
                listener: onKeyUp
            }
        ], {
            capture: false
        });
    }, [
        onKeyDown,
        onKeyUp
    ]);
}
function $261818ab3b11e0a4$export$c8b4d54e03dee6ed() {
    var currentLevel = (0, $5FkrB.useContext)((0, $5cf713b31a166640$export$650d12d3c2ddb8fc));
    var _useContext = (0, $5FkrB.useContext)((0, $5cf713b31a166640$export$48b383b280e20440)), topLevelRef = _useContext.topLevelRef, layerList = _useContext.layerList;
    var isLayerDisabled = (0, $5FkrB.useCallback)(function() {
        if ((0, $id6Cu.fg)('layering-top-level-use-array')) {
            var _layerList$current$le, _layerList$current;
            return ((_layerList$current$le = layerList === null || layerList === void 0 || (_layerList$current = layerList.current) === null || _layerList$current === void 0 ? void 0 : _layerList$current.length) !== null && _layerList$current$le !== void 0 ? _layerList$current$le : 0) !== currentLevel;
        }
        return !!topLevelRef.current && currentLevel !== topLevelRef.current;
    }, [
        currentLevel,
        topLevelRef,
        layerList
    ]);
    return $261818ab3b11e0a4$var$_objectSpread({
        currentLevel: currentLevel,
        topLevelRef: topLevelRef,
        isLayerDisabled: isLayerDisabled
    }, (0, $id6Cu.fg)('layering-top-level-use-array') ? {
        layerList: layerList
    } : {});
}



var $eQzrx = parcelRequire("eQzrx");
parcelRequire("jkmxD");
var $fGFYU = parcelRequire("fGFYU");
/**
 * This is an object of usable media query helpers using our internal breakpoints configuration.
 *
 * When using Compiled CSS-in-JS, please ensure that only a single declaration can take effect at a time.
 * This means that you should avoid multiple breakpoints taking effect at the same time,
 * eg. ```{ [media.above.xs]: { color: 'red' }, [media.above.sm]: { color: 'green' }}```.
 * Instead, make sure that only one breakpoint can take effect at a time,
 * e.g, ```{ [media.only.xs]: { color: 'red' }, [media.above.sm]: { color: 'green' }}```.
 * For more details, please see <https://compiledcssinjs.com/docs/atomic-css#selector-specificity>.
 */ var $6e0de2f2e2517019$export$987d49ffe1b0900f = {
    above: {
        xxs: '@media all',
        xs: '@media (min-width: 30rem)',
        sm: '@media (min-width: 48rem)',
        md: '@media (min-width: 64rem)',
        lg: '@media (min-width: 90rem)',
        xl: '@media (min-width: 110.5rem)'
    },
    only: {
        xxs: '@media (min-width: 0rem) and (max-width: 29.99rem)',
        xs: '@media (min-width: 30rem) and (max-width: 47.99rem)',
        sm: '@media (min-width: 48rem) and (max-width: 63.99rem)',
        md: '@media (min-width: 64rem) and (max-width: 89.99rem)',
        lg: '@media (min-width: 90rem) and (max-width: 110.49rem)',
        xl: '@media (min-width: 110.5rem)'
    },
    below: {
        xs: '@media not all and (min-width: 30rem)',
        sm: '@media not all and (min-width: 48rem)',
        md: '@media not all and (min-width: 64rem)',
        lg: '@media not all and (min-width: 90rem)',
        xl: '@media not all and (min-width: 110.5rem)'
    }
};
var $6e0de2f2e2517019$export$c881183ca713c214 = $6e0de2f2e2517019$export$987d49ffe1b0900f;



var $da539a4d00daa1a9$export$4ef52930e33717cd = 'data-theme';
var $da539a4d00daa1a9$export$a00eac3f8684bcd0 = 'data-color-mode';
var $da539a4d00daa1a9$export$2112803007239c61 = 'data-contrast-mode';
var $da539a4d00daa1a9$export$352e418ed5b6193a = 'data-custom-theme';
var $da539a4d00daa1a9$export$6f0c6fb8c80fcc92 = 'ds';
var $da539a4d00daa1a9$export$4d0c7bbf80185957 = [
    'opacity',
    'font',
    'space',
    'border'
];
var $da539a4d00daa1a9$export$dddac1532e822863 = "--".concat($da539a4d00daa1a9$export$6f0c6fb8c80fcc92, "-token-not-found");
var $da539a4d00daa1a9$export$9d7b58831ae93caa = "--".concat($da539a4d00daa1a9$export$6f0c6fb8c80fcc92, "-elevation-surface-current");



var $5FkrB = parcelRequire("5FkrB");
var $2cccebc7711963c2$export$ab57792b9b6974a6 = /*#__PURE__*/ (0, $5FkrB.createContext)(null);
var $2cccebc7711963c2$export$dece24112a937f92 = /*#__PURE__*/ (0, $5FkrB.createContext)(null);



var $5FkrB = parcelRequire("5FkrB");
function $1091fb3a05fe3bab$export$2e2bcd8739ae039(_ref) {
    var onOpenComplete = _ref.onOpenComplete, onCloseComplete = _ref.onCloseComplete;
    var motionRef = (0, $5FkrB.useRef)(null);
    var onMotionFinish = (0, $5FkrB.useCallback)(function(state) {
        if (state === 'entering' && onOpenComplete) onOpenComplete(motionRef.current, true);
        if (state === 'exiting' && onCloseComplete) onCloseComplete(motionRef.current);
    }, [
        onOpenComplete,
        onCloseComplete
    ]);
    return [
        motionRef,
        onMotionFinish
    ];
}



var $7QpUe = parcelRequire("7QpUe");
parcelRequire("jkmxD");
var $fGFYU = parcelRequire("fGFYU");
parcelRequire("5ldyY");
var $f8loy = parcelRequire("f8loy");

var $fC8ib = parcelRequire("fC8ib");
parcelRequire("jkmxD");
var $fGFYU = parcelRequire("fGFYU");
/**
 * Set a `style` property on a `HTMLElement`
 *
 * @returns a `cleanup` function to restore the `style` property to it's original state
 */ function $7e4a57158a2aa455$var$setStyle(el, _ref) {
    var property = _ref.property, rule = _ref.rule, _ref$priority = _ref.priority, priority = _ref$priority === void 0 ? '' : _ref$priority;
    var originalValue = el.style.getPropertyValue(property);
    var originalPriority = el.style.getPropertyPriority(property);
    el.style.setProperty(property, rule, priority);
    return function cleanup() {
        el.style.setProperty(property, originalValue, originalPriority);
    };
}
function $7e4a57158a2aa455$var$hasSameOrigin(href1, href2) {
    var url1;
    var url2;
    try {
        url1 = new URL(href1);
        url2 = new URL(href2);
    } catch (error) {
        // failed to parse a href
        return false;
    }
    // https://developer.mozilla.org/en-US/docs/Web/Security/Same-origin_policy
    return url1.protocol === url2.protocol && url1.host === url2.host && url1.port === url2.port;
}
function $7e4a57158a2aa455$var$isIframeOnAnotherDomain(iframe) {
    /**
   * iframe with contents defined inline. Runs on the current origin.
   * `<iframe srcdoc="<!doctype html><body>Hello</body>" />`
   */ if (iframe.srcdoc) return false;
    /**
   * iframe with contents defined inline. Runs on the current origin.
   * `<iframe src={`data:text/html;charset=utf-8,${encodeURI('<!doctype html><body>Hello</body>')}`} />`
   */ if (iframe.src.startsWith('data:')) return false;
    return !$7e4a57158a2aa455$var$hasSameOrigin(window.location.href, iframe.src);
}
var $7e4a57158a2aa455$var$registry = new Map();
function $7e4a57158a2aa455$var$applyFix(watchForEndOfInteraction) {
    var iframes = Array.from(document.querySelectorAll('iframe')).filter($7e4a57158a2aa455$var$isIframeOnAnotherDomain);
    var cleanups = iframes.map(function(iframe) {
        var entry = $7e4a57158a2aa455$var$registry.get(iframe);
        if (!entry) {
            entry = {
                reset: $7e4a57158a2aa455$var$setStyle(iframe, {
                    property: 'pointer-events',
                    rule: 'none',
                    priority: 'important'
                }),
                count: 1
            };
            $7e4a57158a2aa455$var$registry.set(iframe, entry);
        } else // pointer-events:none already applied to the iframe
        // increment how many things requested the fix
        entry.count++;
        return function cleanup() {
            entry.count--;
            if (entry.count < 1) {
                entry.reset();
                $7e4a57158a2aa455$var$registry.delete(iframe);
            }
        };
    });
    function stop() {
        cleanupWatcher();
        (0, $fGFYU.combine).apply(void 0, (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(cleanups))();
    }
    var cleanupWatcher = watchForEndOfInteraction({
        stop: stop
    });
}
function $7e4a57158a2aa455$export$a74bff2507e6126b(_ref2) {
    var watchForInteractionStart = _ref2.watchForInteractionStart, watchForInteractionEnd = _ref2.watchForInteractionEnd;
    var registrationCount = 0;
    var stopWatchingInteractionStart = null;
    function start() {
        $7e4a57158a2aa455$var$applyFix(watchForInteractionEnd);
    }
    function registerUsage() {
        if (registrationCount === 0) stopWatchingInteractionStart = watchForInteractionStart({
            start: start
        });
        registrationCount++;
        return function unregisterUsage() {
            var _stopWatchingInteract;
            registrationCount--;
            if (registrationCount !== 0) return;
            (_stopWatchingInteract = stopWatchingInteractionStart) === null || _stopWatchingInteract === void 0 || _stopWatchingInteract();
            stopWatchingInteractionStart = null;
        };
    }
    return {
        registerUsage: registerUsage
    };
}


function $9e749e5ada313118$var$watchForInteractionEnd(_ref) {
    var stop = _ref.stop;
    var isDragging = false;
    function stopIfNotDragging() {
        if (isDragging) return;
        stop();
    }
    var unbindEvents = (0, $7QpUe.bindAll)(window, [
        {
            // Another interaction is starting, this fix should be removed.
            type: 'pointerdown',
            listener: stop
        },
        {
            // The user did not start a drag
            type: 'pointerup',
            listener: stopIfNotDragging
        },
        {
            // if a "dragstart" occurs and the flag is not set,
            // then a drag has not started.
            // Note: could not use "pointercancel" as it is not
            // published in Safari
            // → https://bugs.webkit.org/show_bug.cgi?id=222632
            type: 'dragstart',
            listener: stopIfNotDragging,
            // Need to come after the element adapter
            options: {
                capture: false
            }
        }
    ], {
        // Listening in the capture phase to increase resilience
        // against events being stopped.
        capture: true,
        // Being super clear these should only run once
        once: true
    });
    var unbindMonitor = (0, $f8loy.monitorForElements)({
        onGenerateDragPreview: function onGenerateDragPreview() {
            isDragging = true;
        },
        onDrop: function onDrop() {
            isDragging = false;
            stop();
        }
    });
    return (0, $fGFYU.combine)(unbindEvents, unbindMonitor);
}
function $9e749e5ada313118$var$watchForInteractionStart(_ref2) {
    var start = _ref2.start;
    return (0, $7QpUe.bind)(window, {
        // Note: Using "mousedown" rather than "pointerdown" due to a Safari bug.
        // Safari not publish a "pointerdown" on the interaction after a drag
        // → https://bugs.webkit.org/show_bug.cgi?id=279749
        type: 'mousedown',
        listener: function listener(event) {
            // Only starting if pressing down inside a draggable element
            // At this point, we are not sure which if:
            // 1. a text selection drag is starting
            // 2. a draggable managed by pdnd is going to be dragged
            // 3. a draggable not managed by pdnd is going to be dragged
            // 4. The user will be dragging anything at all (might be doing a click)
            if (event.target instanceof HTMLElement && event.target.closest('[draggable="true"]')) start();
        }
    });
}
var $9e749e5ada313118$var$api = (0, $7e4a57158a2aa455$export$a74bff2507e6126b)({
    watchForInteractionStart: $9e749e5ada313118$var$watchForInteractionStart,
    watchForInteractionEnd: $9e749e5ada313118$var$watchForInteractionEnd
});
function $9e749e5ada313118$export$ec28e97c7d8b1b35() {
    return $9e749e5ada313118$var$api.registerUsage();
}


parcelRequire("aPh0Z");
var $h6ZPT = parcelRequire("h6ZPT");

function $5753ae00dc40d07b$var$watchForInteractionStart(_ref) {
    var start = _ref.start;
    return (0, $h6ZPT.monitorForExternal)({
        onDragStart: function onDragStart() {
            start();
        }
    });
}
function $5753ae00dc40d07b$var$watchForInteractionEnd(_ref2) {
    var stop = _ref2.stop;
    return (0, $h6ZPT.monitorForExternal)({
        onDrop: function onDrop() {
            stop();
        }
    });
}
var $5753ae00dc40d07b$var$api = (0, $7e4a57158a2aa455$export$a74bff2507e6126b)({
    watchForInteractionStart: $5753ae00dc40d07b$var$watchForInteractionStart,
    watchForInteractionEnd: $5753ae00dc40d07b$var$watchForInteractionEnd
});
function $5753ae00dc40d07b$export$27d79116d3a4e7d5() {
    return $5753ae00dc40d07b$var$api.registerUsage();
}



var $7QpUe = parcelRequire("7QpUe");
parcelRequire("jkmxD");
var $fGFYU = parcelRequire("fGFYU");
parcelRequire("4p4mj");
var $5O7Kz = parcelRequire("5O7Kz");

function $0093068cd5ecd702$var$watchForInteractionEnd(_ref) {
    var stop = _ref.stop;
    var isDragging = false;
    function stopIfNotDragging() {
        if (isDragging) return;
        stop();
    }
    var frameId = null;
    var unbindEvents = (0, $7QpUe.bindAll)(window, [
        {
            // User is starting another interaction
            type: 'pointerdown',
            listener: stop
        },
        {
            // User did not start a drag.
            // "pointerdown" won't be fired if a drag started
            type: 'pointerup',
            listener: stopIfNotDragging
        },
        {
            type: 'dragstart',
            listener: function listener() {
                /**
       * The pdnd `onDragStart()` fires in the frame after "dragstart"
       * So we are delaying our isDragging check to give a chance
       * for `onDragStart()` to set the value correctly.
       *
       * Note: could not use "pointercancel" as it is not
       * published in Safari → https://bugs.webkit.org/show_bug.cgi?id=222632
       */ frameId = requestAnimationFrame(function() {
                    frameId = null;
                    stopIfNotDragging();
                });
            },
            // need to schedule our frame after the text-selection
            // adapter queues it's `onDragStart` frame.
            options: {
                capture: false
            }
        }
    ], {
        // Listening in the capture phase to increase resilience
        // against events being stopped.
        capture: true,
        // being super clear these should only run once
        once: true
    });
    var unbindMonitor = (0, $5O7Kz.monitorForTextSelection)({
        onDragStart: function onDragStart() {
            isDragging = true;
        },
        onDrop: function onDrop() {
            isDragging = false;
            stop();
        }
    });
    return (0, $fGFYU.combine)(unbindEvents, unbindMonitor, function abortFrame() {
        if (frameId != null) cancelAnimationFrame(frameId);
    });
}
function $0093068cd5ecd702$var$watchForInteractionStart(_ref2) {
    var start = _ref2.start;
    return (0, $7QpUe.bind)(window, {
        // Note: Using "mousedown" rather than "pointerdown" due to a Safari bug.
        // Safari not publish a "pointerdown" on the interaction after a drag
        // → https://bugs.webkit.org/show_bug.cgi?id=279749
        type: 'mousedown',
        listener: function listener() {
            // A text selection drag will only start when there is
            // an active text selection.
            var selection = window.getSelection();
            // No selection object found
            if (!selection) return;
            // `isCollapsed` is "true" if there is currently no selected text
            if (selection.isCollapsed) return;
            start();
        }
    });
}
var $0093068cd5ecd702$var$api = (0, $7e4a57158a2aa455$export$a74bff2507e6126b)({
    watchForInteractionStart: $0093068cd5ecd702$var$watchForInteractionStart,
    watchForInteractionEnd: $0093068cd5ecd702$var$watchForInteractionEnd
});
function $0093068cd5ecd702$export$9c0606fcefb5d1e2() {
    return $0093068cd5ecd702$var$api.registerUsage();
}


var $f24888f185b1773b$export$7e3df82ee760448c = {
    values: [
        'small',
        'medium',
        'large',
        'x-large'
    ],
    widths: {
        small: 400,
        medium: 600,
        large: 800,
        'x-large': 968
    },
    defaultValue: 'medium'
};
var $f24888f185b1773b$export$a3da89b899389ed8 = function dialogWidth(input) {
    if (!input) return 'auto';
    var isWidthName = $f24888f185b1773b$export$7e3df82ee760448c.values.indexOf(input.toString()) !== -1;
    var widthName = isWidthName && input;
    if (widthName) return "".concat($f24888f185b1773b$export$7e3df82ee760448c.widths[widthName], "px");
    return typeof input === 'number' ? "".concat(input, "px") : input;
};
var $f24888f185b1773b$export$ceba93bf0bdd16f2 = function dialogHeight(input) {
    if (!input) return 'auto';
    return typeof input === 'number' ? "".concat(input, "px") : input;
};



var $25nEq = parcelRequire("25nEq");

var $74Zh5 = parcelRequire("74Zh5");

var $2HK8I = parcelRequire("2HK8I");

var $fF5v2 = parcelRequire("fF5v2");


var $4acaee348c23dd39$var$gutter = 60;
var $4acaee348c23dd39$var$maxWidthDimensions = "calc(100vw - ".concat($4acaee348c23dd39$var$gutter * 2, "px)");
var $4acaee348c23dd39$var$maxHeightDimensions = "calc(100vh - ".concat($4acaee348c23dd39$var$gutter * 2 - 1, "px)");
// Flex and min-content are set to constrain the height of the body and support multi-column scrolling experiences
var $4acaee348c23dd39$var$positionerStyles = (0, $74Zh5.css)({
    display: 'flex',
    width: '100%',
    maxWidth: '100%',
    height: '100%',
    position: 'fixed',
    zIndex: (0, $447ae92c83d36574$export$7be255094ccdc533).modal(),
    flexDirection: 'column',
    insetBlockStart: 0,
    insetInlineStart: 0
});
var $4acaee348c23dd39$var$viewportScrollStyles = (0, $74Zh5.css)((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({
    height: 'auto',
    position: 'relative'
}, (0, $6e0de2f2e2517019$export$987d49ffe1b0900f).above.xs, {
    margin: "".concat($4acaee348c23dd39$var$gutter, "px auto"),
    pointerEvents: 'none'
}));
var $4acaee348c23dd39$var$bodyScrollStyles = (0, $74Zh5.css)((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, (0, $6e0de2f2e2517019$export$987d49ffe1b0900f).above.xs, {
    maxWidth: $4acaee348c23dd39$var$maxWidthDimensions,
    maxHeight: $4acaee348c23dd39$var$maxHeightDimensions,
    position: 'absolute',
    insetBlockStart: "".concat($4acaee348c23dd39$var$gutter, "px"),
    insetInlineEnd: 0,
    insetInlineStart: 0,
    marginInlineEnd: 'auto',
    marginInlineStart: 'auto',
    pointerEvents: 'none'
}));
var $4acaee348c23dd39$var$stackTransitionStyles = (0, $74Zh5.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
    transitionDuration: "".concat((0, $fF5v2.durations).medium, "ms"),
    transitionProperty: 'transform',
    transitionTimingFunction: (0, $2HK8I.easeInOut),
    /**
   * Duplicated from @atlaskit/motion/accessibility
   * because @repo/internal/styles/consistent-style-ordering
   * doesn't work well with object spreading.
   */ '@media (prefers-reduced-motion: reduce)': {
        animation: 'none',
        transition: 'none'
    }
});
var $4acaee348c23dd39$var$stackTransformStyles = (0, $74Zh5.css)({
    transform: 'translateY(var(--modal-dialog-translate-y))'
});
var $4acaee348c23dd39$var$stackIdleStyles = (0, $74Zh5.css)({
    transform: 'none'
});
var $4acaee348c23dd39$var$Positioner = function Positioner(props) {
    var children = props.children, stackIndex = props.stackIndex, shouldScrollInViewport = props.shouldScrollInViewport, testId = props.testId;
    return (0, $74Zh5.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            '--modal-dialog-translate-y': "calc(".concat(stackIndex, "px * ", "var(--ds-space-100, 8px)", ")")
        },
        css: [
            $4acaee348c23dd39$var$positionerStyles,
            $4acaee348c23dd39$var$stackTransitionStyles,
            /* We only want to apply transform on modals shifting to the back of the stack. */ stackIndex > 0 ? $4acaee348c23dd39$var$stackTransformStyles : $4acaee348c23dd39$var$stackIdleStyles,
            shouldScrollInViewport ? $4acaee348c23dd39$var$viewportScrollStyles : $4acaee348c23dd39$var$bodyScrollStyles
        ],
        "data-testid": testId && "".concat(testId, "--positioner")
    }, children);
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$4acaee348c23dd39$export$2e2bcd8739ae039 = $4acaee348c23dd39$var$Positioner;


var $1256cd9eb2fce1b4$var$dialogStyles = (0, $74Zh5.css)((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({
    display: 'flex',
    width: '100%',
    maxWidth: '100vw',
    height: '100%',
    minHeight: 0,
    maxHeight: '100vh',
    // Flex-grow set to 0 to prevent this element from filling its parent flexbox container
    flex: '0 1 auto',
    flexDirection: 'column',
    backgroundColor: "var(--ds-surface-overlay, ".concat((0, $fc018eea7e59cced$export$29a4f05edc054374), ")"),
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    color: "var(--ds-text, ".concat((0, $fc018eea7e59cced$export$fbda843f0a27fe96), ")")
}, (0, $da539a4d00daa1a9$export$9d7b58831ae93caa), "var(--ds-surface-overlay, ".concat((0, $fc018eea7e59cced$export$29a4f05edc054374), ")")), "pointerEvents", 'auto'), (0, $6e0de2f2e2517019$export$987d49ffe1b0900f).above.xs, {
    width: 'var(--modal-dialog-width)',
    maxWidth: 'inherit',
    borderRadius: "var(--ds-border-radius, 3px)",
    boxShadow: "var(--ds-shadow-overlay, ".concat("0 0 0 1px ".concat((0, $fc018eea7e59cced$export$920c0d5c49070351), ", 0 2px 1px ").concat((0, $fc018eea7e59cced$export$920c0d5c49070351), ", 0 0 20px -6px ").concat((0, $fc018eea7e59cced$export$d2d3bedfb276cac0)), ")"),
    marginInlineEnd: 'inherit',
    marginInlineStart: 'inherit'
}), '& > form:only-child', {
    display: 'inherit',
    maxHeight: 'inherit',
    flexDirection: 'inherit'
}));
var $1256cd9eb2fce1b4$var$viewportScrollStyles = (0, $74Zh5.css)((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({
    /**
   * This ensures that the element fills the viewport on mobile
   * while also allowing it to overflow if its height is larger than
   * the viewport.
   */ minHeight: '100vh',
    maxHeight: 'none'
}, (0, $6e0de2f2e2517019$export$987d49ffe1b0900f).above.xs, {
    minHeight: 'var(--modal-dialog-height)'
}));
var $1256cd9eb2fce1b4$var$bodyScrollStyles = (0, $74Zh5.css)((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, (0, $6e0de2f2e2517019$export$987d49ffe1b0900f).above.xs, {
    height: 'var(--modal-dialog-height)',
    maxHeight: 'inherit'
}));
var $1256cd9eb2fce1b4$var$ModalDialog = function ModalDialog(props) {
    var _props$width = props.width, width = _props$width === void 0 ? 'medium' : _props$width, _props$shouldScrollIn = props.shouldScrollInViewport, shouldScrollInViewport = _props$shouldScrollIn === void 0 ? false : _props$shouldScrollIn, shouldCloseOnEscapePress = props.shouldCloseOnEscapePress, autoFocus = props.autoFocus, stackIndex = props.stackIndex, onClose = props.onClose, onCloseComplete = props.onCloseComplete, onOpenComplete = props.onOpenComplete, height = props.height, children = props.children, label = props.label, testId = props.testId;
    var id = (0, $16c8dcce41574d15$export$f680877a34711e37)();
    var titleId = "modal-dialog-title-".concat(id);
    (0, $5FkrB.useEffect)(function() {
        // Modal dialogs can appear on top of iframe elements that are on another domain.
        // There is a Chrome bug where drag and drop in an element on top of a cross domain
        // iframe is not working. We are applying the workaround for this bug in modal so
        // that consumers of our modal don't have to worry about this bug and are free to
        // create whatever drag and drop experience they like inside a modal
        //
        // Chrome bug: https://issues.chromium.org/issues/362301053
        return (0, $fGFYU.combine)((0, $9e749e5ada313118$export$ec28e97c7d8b1b35)(), (0, $0093068cd5ecd702$export$9c0606fcefb5d1e2)(), (0, $5753ae00dc40d07b$export$27d79116d3a4e7d5)());
    }, []);
    (0, $cf5316edb3edd9ae$export$2e2bcd8739ae039)((0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(autoFocus) === 'object' ? autoFocus : undefined, // When a user supplies  a ref to focus we enable this hook
    (0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(autoFocus) === 'object');
    var _useOnMotionFinish = (0, $1091fb3a05fe3bab$export$2e2bcd8739ae039)({
        onOpenComplete: onOpenComplete,
        onCloseComplete: onCloseComplete
    }), _useOnMotionFinish2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useOnMotionFinish, 2), motionRef = _useOnMotionFinish2[0], onMotionFinish = _useOnMotionFinish2[1];
    var modalDialogContext = (0, $5FkrB.useMemo)(function() {
        return {
            testId: testId,
            titleId: titleId,
            onClose: onClose
        };
    }, [
        testId,
        titleId,
        onClose
    ]);
    (0, $261818ab3b11e0a4$export$4a4bf067ea9e7886)({
        onClose: onClose,
        isDisabled: !shouldCloseOnEscapePress
    });
    var _useLayering = (0, $261818ab3b11e0a4$export$c8b4d54e03dee6ed)(), currentLevel = _useLayering.currentLevel;
    return (0, $74Zh5.jsx)((0, $4acaee348c23dd39$export$2e2bcd8739ae039), {
        stackIndex: stackIndex,
        shouldScrollInViewport: shouldScrollInViewport,
        testId: testId
    }, (0, $74Zh5.jsx)((0, $2cccebc7711963c2$export$ab57792b9b6974a6).Provider, {
        value: modalDialogContext
    }, (0, $74Zh5.jsx)((0, $2cccebc7711963c2$export$dece24112a937f92).Provider, {
        value: shouldScrollInViewport
    }, (0, $74Zh5.jsx)((0, $eQzrx.default), {
        entranceDirection: "bottom",
        onFinish: onMotionFinish
    }, function(bottomFadeInProps) {
        return (0, $74Zh5.jsx)((0, $eYQvF.default), null, (0, $74Zh5.jsx)("section", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, bottomFadeInProps, {
            "aria-label": label,
            ref: (0, $93853b40b059c181$export$2e2bcd8739ae039)([
                bottomFadeInProps.ref,
                motionRef
            ]),
            style: {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                '--modal-dialog-width': (0, $f24888f185b1773b$export$a3da89b899389ed8)(width),
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                '--modal-dialog-height': (0, $f24888f185b1773b$export$ceba93bf0bdd16f2)(height)
            },
            css: [
                $1256cd9eb2fce1b4$var$dialogStyles,
                shouldScrollInViewport ? $1256cd9eb2fce1b4$var$viewportScrollStyles : $1256cd9eb2fce1b4$var$bodyScrollStyles
            ],
            role: "dialog",
            "aria-labelledby": label ? undefined : titleId,
            "data-testid": testId,
            "data-modal-stack": stackIndex,
            tabIndex: -1,
            "aria-modal": true,
            "data-ds--level": currentLevel
        }), children));
    }))));
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$1256cd9eb2fce1b4$export$2e2bcd8739ae039 = $1256cd9eb2fce1b4$var$ModalDialog;



var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");

var $5FkrB = parcelRequire("5FkrB");
var $0c74eb8741cfaeca$var$uniqueReferencedValue = {};
function $0c74eb8741cfaeca$export$2e2bcd8739ae039(initializer) {
    var ref = (0, $5FkrB.useRef)($0c74eb8741cfaeca$var$uniqueReferencedValue);
    if (ref.current === $0c74eb8741cfaeca$var$uniqueReferencedValue) ref.current = initializer();
    return ref;
}


function $167eee0974ce2576$export$2e2bcd8739ae039(callback) {
    var ref = (0, $0c74eb8741cfaeca$export$2e2bcd8739ae039)(function() {
        return callback;
    });
    return ref.current;
}



var $5FkrB = parcelRequire("5FkrB");
function $5f17c154baee2163$export$2e2bcd8739ae039(value) {
    var ref = (0, $5FkrB.useRef)();
    (0, $5FkrB.useEffect)(function() {
        ref.current = value;
    }, [
        value
    ]);
    return ref.current;
}



var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");
function $7276c5b7b08dfaaa$export$2e2bcd8739ae039(initialState) {
    var _useState = (0, $5FkrB.useState)(initialState), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), value = _useState2[0], setValue = _useState2[1];
    var valueRef = (0, $5FkrB.useRef)(value);
    valueRef.current = value;
    return [
        valueRef,
        setValue
    ];
}



var $ZdqJG = parcelRequire("ZdqJG");
/**
 *  ________________________________________________
 * | MAJOR VERSIONS WILL NOT KNOW ABOUT EACH OTHER! |
 *  ------------------------------------------------
 *
 * An array which holds references to all currently open modal dialogs.
 * This will only work for modal dialogs of the same major version,
 * as the reference will be different between them.
 *
 * E.g. V11 won't know about any from V12.
 */ var $849c0ebe640fc8dd$var$modalStackRegister = [];
function $849c0ebe640fc8dd$export$2e2bcd8739ae039(_ref) {
    var onStackChange = _ref.onStackChange;
    var _useExitingPersistenc = (0, $ZdqJG.useExitingPersistence)(), isExiting = _useExitingPersistenc.isExiting;
    var _useStateRef = (0, $7276c5b7b08dfaaa$export$2e2bcd8739ae039)(0), _useStateRef2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useStateRef, 2), stackIndexRef = _useStateRef2[0], setStackIndex = _useStateRef2[1];
    var currentStackIndex = stackIndexRef.current;
    var previousStackIndex = (0, $5f17c154baee2163$export$2e2bcd8739ae039)(stackIndexRef.current);
    // We want to ensure this function **never changes** during the lifecycle of this component.
    // This is why it's assigned to a ref and not in a useMemo/useCallback.
    var updateStack = (0, $167eee0974ce2576$export$2e2bcd8739ae039)(function() {
        var newStackIndex = $849c0ebe640fc8dd$var$modalStackRegister.indexOf(updateStack);
        // We access the stack index ref instead of state because this closure will always only
        // have the initial state and not any of the later values.
        if (stackIndexRef.current !== newStackIndex) {
            setStackIndex(newStackIndex);
            stackIndexRef.current = newStackIndex;
        }
    });
    (0, $5FkrB.useEffect)(function() {
        var currentStackIndex = $849c0ebe640fc8dd$var$modalStackRegister.indexOf(updateStack);
        if (!isExiting && currentStackIndex === -1) // We are opening the modal dialog.
        // Add ourselves to the modal stack register!
        $849c0ebe640fc8dd$var$modalStackRegister.unshift(updateStack);
        if (isExiting && currentStackIndex !== -1) // We are closing the modal dialog using a wrapping modal transition component.
        // Remove ourselves from the modal stack register!
        // NOTE: Modal dialogs that don't have a wrapping modal transition component won't flow through here!
        // For that scenario we cleanup when the component unmounts.
        $849c0ebe640fc8dd$var$modalStackRegister.splice(currentStackIndex, 1);
        // Fire all registered modal dialogs to update their position in the stack.
        $849c0ebe640fc8dd$var$modalStackRegister.forEach(function(cb) {
            return cb();
        });
    }, [
        updateStack,
        isExiting
    ]);
    (0, $5FkrB.useEffect)(function() {
        return function() {
            // Final cleanup just in case this modal dialog did not have a wrapping modal transition.
            var currentStackIndex = $849c0ebe640fc8dd$var$modalStackRegister.indexOf(updateStack);
            if (currentStackIndex !== -1) {
                $849c0ebe640fc8dd$var$modalStackRegister.splice(currentStackIndex, 1);
                $849c0ebe640fc8dd$var$modalStackRegister.forEach(function(cb) {
                    return cb();
                });
            }
        };
    }, [
        updateStack
    ]);
    (0, $5FkrB.useEffect)(function() {
        if (previousStackIndex === undefined) // Initial case that we don't need to notify about.
        return;
        if (previousStackIndex !== currentStackIndex) onStackChange(currentStackIndex);
    }, [
        onStackChange,
        previousStackIndex,
        currentStackIndex
    ]);
    return currentStackIndex;
}



var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");

var $7QpUe = parcelRequire("7QpUe");
/**
 * Returns how far the body is scrolled from the top of the viewport.
 *
 *   ____
 * ||____|| <-- overflow
 *  |    |  <-- viewport
 *  |____|
 *
 * Scroll distance is the height of overflow outside the viewport.
 */ function $2164231806171f7a$var$getScrollDistance() {
    var _document$documentEle, _document$body;
    return window.pageYOffset || ((_document$documentEle = document.documentElement) === null || _document$documentEle === void 0 ? void 0 : _document$documentEle.scrollTop) || ((_document$body = document.body) === null || _document$body === void 0 ? void 0 : _document$body.scrollTop) || 0;
}
function $2164231806171f7a$export$2e2bcd8739ae039() {
    var _useState = (0, $5FkrB.useState)(0), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), scrollTopOffset = _useState2[0], setScrollTopOffset = _useState2[1];
    (0, $5FkrB.useLayoutEffect)(function() {
        setScrollTopOffset($2164231806171f7a$var$getScrollDistance());
    }, []);
    var onWindowScroll = (0, $5FkrB.useCallback)(function() {
        if ($2164231806171f7a$var$getScrollDistance() !== scrollTopOffset) window.scrollTo(window.pageXOffset, scrollTopOffset);
    }, [
        scrollTopOffset
    ]);
    (0, $5FkrB.useEffect)(function() {
        return (0, $7QpUe.bind)(window, {
            type: 'scroll',
            listener: onWindowScroll
        });
    }, [
        onWindowScroll
    ]);
    return scrollTopOffset;
}


var $9406e400bdd02ea1$var$fillScreenStyles = (0, $74Zh5.css)({
    width: '100vw',
    height: '100vh',
    position: 'fixed',
    insetBlockStart: "var(--ds-space-0, 0)",
    insetInlineStart: "var(--ds-space-0, 0)",
    overflowY: 'auto',
    WebkitOverflowScrolling: 'touch'
});
var $9406e400bdd02ea1$var$allowlistElements = function allowlistElements(element, callback) {
    var isAuiDialogAllowlisted = (0, $id6Cu.fg)('platform_dst_allowlist-aui-dialog-for-ak-modal');
    // Allow focus to reach elements outside the modal:
    // if AUI dialog is allowListed and visible
    if (isAuiDialogAllowlisted && !!document.querySelector('.aui-blanket:not([hidden])')) return false;
    // allows to pass a callback function to allow elements be ignored by focus lock
    if (typeof callback === 'function') return callback(element);
    return true;
};
/**
 * __Modal wrapper__
 *
 * A modal wrapper displays content that requires user interaction, in a layer above the page.
 * This component is primary container for other modal components.
 *
 * - [Examples](https://atlassian.design/components/modal-dialog/examples)
 * - [Code](https://atlassian.design/components/modal-dialog/code)
 * - [Usage](https://atlassian.design/components/modal-dialog/usage)
 */ var $9406e400bdd02ea1$var$ModalWrapper = function ModalWrapper(props) {
    var _props$autoFocus = props.autoFocus, autoFocus = _props$autoFocus === void 0 ? true : _props$autoFocus, focusLockAllowlist = props.focusLockAllowlist, _props$shouldCloseOnE = props.shouldCloseOnEscapePress, shouldCloseOnEscapePress = _props$shouldCloseOnE === void 0 ? true : _props$shouldCloseOnE, _props$shouldCloseOnO = props.shouldCloseOnOverlayClick, shouldCloseOnOverlayClick = _props$shouldCloseOnO === void 0 ? true : _props$shouldCloseOnO, _props$shouldScrollIn = props.shouldScrollInViewport, shouldScrollInViewport = _props$shouldScrollIn === void 0 ? false : _props$shouldScrollIn, _props$shouldReturnFo = props.shouldReturnFocus, shouldReturnFocus = _props$shouldReturnFo === void 0 ? true : _props$shouldReturnFo, stackIndexOverride = props.stackIndex, _props$onClose = props.onClose, onClose = _props$onClose === void 0 ? (0, $3ec7e1df73061c03$export$2e2bcd8739ae039) : _props$onClose, _props$onStackChange = props.onStackChange, onStackChange = _props$onStackChange === void 0 ? (0, $3ec7e1df73061c03$export$2e2bcd8739ae039) : _props$onStackChange, isBlanketHidden = props.isBlanketHidden, children = props.children, height = props.height, width = props.width, onCloseComplete = props.onCloseComplete, onOpenComplete = props.onOpenComplete, label = props.label, testId = props.testId;
    var calculatedStackIndex = (0, $849c0ebe640fc8dd$export$2e2bcd8739ae039)({
        onStackChange: onStackChange
    });
    var stackIndex = stackIndexOverride || calculatedStackIndex;
    var isForeground = stackIndex === 0;
    // When a user supplies a ref to focus we skip auto focus via react-focus-lock
    var autoFocusLock = typeof autoFocus === 'boolean' ? autoFocus : false;
    var onCloseHandler = (0, $9a80315d150981cc$export$a4687b0234b40e28)({
        fn: onClose,
        action: 'closed',
        componentName: 'modalDialog',
        packageName: "@atlaskit/modal-dialog",
        packageVersion: "13.1.1"
    });
    var onBlanketClicked = (0, $5FkrB.useCallback)(function(e) {
        if (shouldCloseOnOverlayClick) onCloseHandler(e);
    }, [
        shouldCloseOnOverlayClick,
        onCloseHandler
    ]);
    // This ensures to prevent additional re-renders while nothing is passed to focusLockAllowlist explicitly.
    var allowListCallback = (0, $5FkrB.useCallback)(function(element) {
        return $9406e400bdd02ea1$var$allowlistElements(element, focusLockAllowlist);
    }, [
        focusLockAllowlist
    ]);
    (0, $2164231806171f7a$export$2e2bcd8739ae039)();
    var modalDialogWithBlanket = (0, $74Zh5.jsx)((0, $1qBWl.default), {
        isTinted: !isBlanketHidden,
        onBlanketClicked: onBlanketClicked,
        testId: testId && "".concat(testId, "--blanket")
    }, (0, $74Zh5.jsx)((0, $1256cd9eb2fce1b4$export$2e2bcd8739ae039), {
        testId: testId,
        label: label,
        autoFocus: autoFocus,
        stackIndex: stackIndex,
        onClose: onCloseHandler,
        shouldCloseOnEscapePress: shouldCloseOnEscapePress && isForeground,
        shouldScrollInViewport: shouldScrollInViewport,
        height: height,
        width: width,
        onCloseComplete: onCloseComplete,
        onOpenComplete: onOpenComplete
    }, children));
    var returnFocus = true;
    var onDeactivation;
    if ('boolean' === typeof shouldReturnFocus) returnFocus = shouldReturnFocus;
    else onDeactivation = function onDeactivation() {
        window.setTimeout(function() {
            var _shouldReturnFocus$cu;
            (_shouldReturnFocus$cu = shouldReturnFocus.current) === null || _shouldReturnFocus$cu === void 0 || _shouldReturnFocus$cu.focus();
        }, 0);
    };
    return (0, $74Zh5.jsx)((0, $5cf713b31a166640$export$7c885f891c940977), {
        isDisabled: false
    }, (0, $74Zh5.jsx)((0, $6bqMl.default), {
        zIndex: (0, $447ae92c83d36574$export$7be255094ccdc533).modal()
    }, (0, $74Zh5.jsx)((0, $eQzrx.default), null, function(fadeInProps) {
        return (0, $74Zh5.jsx)("div", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, fadeInProps, {
            css: $9406e400bdd02ea1$var$fillScreenStyles,
            "aria-hidden": !isForeground
        }), (0, $74Zh5.jsx)((0, $69J3E.default), {
            autoFocus: autoFocusLock,
            returnFocus: returnFocus,
            onDeactivation: onDeactivation,
            whiteList: allowListCallback
        }, (0, $74Zh5.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3FlkA))), null), shouldScrollInViewport ? (0, $74Zh5.jsx)((0, $3FlkA.TouchScrollable), null, modalDialogWithBlanket) : modalDialogWithBlanket));
    })));
};
var $9406e400bdd02ea1$export$2e2bcd8739ae039 = $9406e400bdd02ea1$var$ModalWrapper;

/**
 * @jsxRuntime classic
 * @jsx jsx
 */ parcelRequire("5FkrB");

var $74Zh5 = parcelRequire("74Zh5");

var $3FlkA = parcelRequire("3FlkA");

var $5FkrB = parcelRequire("5FkrB");

var $80b9a27bd3af2156$export$33ffd74ebf07f060 = function useModal() {
    var modalContext = (0, $5FkrB.useContext)((0, $2cccebc7711963c2$export$ab57792b9b6974a6));
    if (modalContext == null) throw Error("@atlaskit/modal-dialog: Modal context unavailable \u2013 this component needs to be a child of ModalDialog.");
    return modalContext;
};



var $iYJcE = parcelRequire("iYJcE");

var $25nEq = parcelRequire("25nEq");

var $5FkrB = parcelRequire("5FkrB");

var $74Zh5 = parcelRequire("74Zh5");

var $7QpUe = parcelRequire("7QpUe");

var $45Zis = parcelRequire("45Zis");




var $eYQvF = parcelRequire("eYQvF");


var $b3fbf4c2c9df56cb$var$keylineColor = "var(--ds-border, ".concat((0, $fc018eea7e59cced$export$3e51e8f1440314ba), ")");
var $b3fbf4c2c9df56cb$var$baseStyles = (0, $74Zh5.css)((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({
    display: 'inherit',
    margin: "var(--ds-space-0, 0px)",
    flex: 'inherit',
    flexDirection: 'inherit',
    flexGrow: 1,
    overflowX: 'hidden',
    overflowY: 'auto'
}, (0, $6e0de2f2e2517019$export$987d49ffe1b0900f).above.xs, {
    height: 'unset',
    overflowY: 'auto'
}));
var $b3fbf4c2c9df56cb$var$keylineHeight = 2;
var $b3fbf4c2c9df56cb$var$topKeylineStyles = (0, $74Zh5.css)({
    borderBlockStart: "var(--ds-border-width-outline, 2px)".concat(" solid ", $b3fbf4c2c9df56cb$var$keylineColor)
});
var $b3fbf4c2c9df56cb$var$bottomKeylineStyles = (0, $74Zh5.css)({
    borderBlockEnd: "var(--ds-border-width-outline, 2px)".concat(" solid ", $b3fbf4c2c9df56cb$var$keylineColor)
});
/**
 * A container that shows top and bottom keylines when the
 * content overflows into the scrollable element.
 */ var $b3fbf4c2c9df56cb$var$ScrollContainer = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function(_ref, ref) {
    var testId = _ref.testId, children = _ref.children;
    var scrollableRef = (0, $5FkrB.useRef)(null);
    var _useState = (0, $5FkrB.useState)(false), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), showTopKeyline = _useState2[0], setTopKeyline = _useState2[1];
    var _useState3 = (0, $5FkrB.useState)(false), _useState4 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState3, 2), showBottomKeyline = _useState4[0], setBottomKeyline = _useState4[1];
    var _useState5 = (0, $5FkrB.useState)(false), _useState6 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState5, 2), showContentFocus = _useState6[0], setContentFocus = _useState6[1];
    // Schedule a content focus on the target element
    // WARNING: In theory, `target` may not be available when `rafSchedule` hits in concurrent rendering
    (0, $5FkrB.useEffect)(function() {
        var schedule = (0, $45Zis.default)(function() {
            var target = scrollableRef.current;
            target && setContentFocus(target.scrollHeight > target.clientHeight);
        });
        schedule();
    }, [
        scrollableRef
    ]);
    var setLazyKeylines = (0, $167eee0974ce2576$export$2e2bcd8739ae039)((0, $45Zis.default)(function() {
        var target = scrollableRef.current;
        if (target) {
            var scrollableDistance = target.scrollHeight - target.clientHeight;
            if (target.previousElementSibling) setTopKeyline(target.scrollTop > $b3fbf4c2c9df56cb$var$keylineHeight);
            if (target.nextElementSibling) setBottomKeyline(target.scrollTop <= scrollableDistance - $b3fbf4c2c9df56cb$var$keylineHeight);
        }
    }));
    // On load (and scroll/resize events), we set "keylines"
    // these border the content to indicate scrollability when content underflows the header or footer
    (0, $5FkrB.useEffect)(function() {
        var target = scrollableRef.current;
        setLazyKeylines();
        var unbindWindowEvent = (0, $7QpUe.bind)(window, {
            type: 'resize',
            listener: setLazyKeylines
        });
        var unbindTargetEvent = target ? (0, $7QpUe.bind)(target, {
            type: 'scroll',
            listener: setLazyKeylines
        }) : (0, $3ec7e1df73061c03$export$2e2bcd8739ae039);
        return function() {
            unbindWindowEvent();
            unbindTargetEvent();
        };
    }, [
        setLazyKeylines
    ]);
    return (0, $74Zh5.jsx)((0, $eYQvF.default), {
        isInset: true
    }, (0, $74Zh5.jsx)("div", {
        // tabindex is allowed here so that keyboard users can scroll content
        // eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex
        tabIndex: showContentFocus ? 0 : undefined,
        role: showContentFocus ? 'region' : undefined,
        "aria-label": showContentFocus ? 'Scrollable content' : undefined,
        "data-testid": testId && "".concat(testId, "--scrollable"),
        ref: (0, $93853b40b059c181$export$2e2bcd8739ae039)([
            ref,
            scrollableRef
        ]),
        css: [
            $b3fbf4c2c9df56cb$var$baseStyles,
            showTopKeyline && $b3fbf4c2c9df56cb$var$topKeylineStyles,
            showBottomKeyline && $b3fbf4c2c9df56cb$var$bottomKeylineStyles
        ]
    }, children));
});
$b3fbf4c2c9df56cb$var$ScrollContainer.displayName = 'ScrollContainer';
var $b3fbf4c2c9df56cb$export$2e2bcd8739ae039 = $b3fbf4c2c9df56cb$var$ScrollContainer;



var $5FkrB = parcelRequire("5FkrB");

function $48461d6a1727784a$export$2e2bcd8739ae039() {
    var shouldScrollInViewport = (0, $5FkrB.useContext)((0, $2cccebc7711963c2$export$dece24112a937f92));
    if (shouldScrollInViewport == null) throw Error("@atlaskit/modal-dialog: Scroll context unavailable \u2013 this component needs to be a child of ModalDialog.");
    return shouldScrollInViewport;
}


var $4cfe1b75d32132e5$var$bodyStyles = (0, $74Zh5.css)({
    /* This ensures the body fills the whole space between header and footer. */ flex: '1 1 auto'
});
/**
 * Adding the padding here avoids cropping the keyline on its sides.
 * The combined vertical spacing is maintained by subtracting the
 * keyline height from header and footer using negative margins.
 */ var $4cfe1b75d32132e5$var$bodyScrollStyles = (0, $74Zh5.css)({
    paddingBlock: "var(--ds-border-width-outline, 2px)",
    paddingInline: "var(--ds-space-300, 24px)"
});
/**
 * Keylines will not be shown if scrolling in viewport so we do
 * not account for them in this case.
 */ var $4cfe1b75d32132e5$var$viewportScrollStyles = (0, $74Zh5.css)({
    paddingInline: "var(--ds-space-300, 24px)"
});
/**
 * __Modal body__
 *
 * A modal body is used to display the main content of a modal.
 *
 * - [Examples](https://atlassian.design/components/modal-dialog/examples)
 * - [Code](https://atlassian.design/components/modal-dialog/code#modal-body-props)
 * - [Usage](https://atlassian.design/components/modal-dialog/usage)
 */ var $4cfe1b75d32132e5$var$ModalBody = function ModalBody(props) {
    var children = props.children, userDefinedTestId = props.testId;
    var _useModal = (0, $80b9a27bd3af2156$export$33ffd74ebf07f060)(), modalTestId = _useModal.testId;
    var shouldScrollInViewport = (0, $48461d6a1727784a$export$2e2bcd8739ae039)();
    var testId = userDefinedTestId || modalTestId && "".concat(modalTestId, "--body");
    return shouldScrollInViewport ? (0, $74Zh5.jsx)("div", {
        css: [
            $4cfe1b75d32132e5$var$bodyStyles,
            $4cfe1b75d32132e5$var$viewportScrollStyles
        ],
        "data-testid": testId
    }, children) : (0, $74Zh5.jsx)((0, $3FlkA.TouchScrollable), null, (0, $74Zh5.jsx)((0, $b3fbf4c2c9df56cb$export$2e2bcd8739ae039), {
        testId: userDefinedTestId || modalTestId
    }, (0, $74Zh5.jsx)("div", {
        css: [
            $4cfe1b75d32132e5$var$bodyStyles,
            $4cfe1b75d32132e5$var$bodyScrollStyles
        ],
        "data-testid": testId
    }, children)));
};
var $4cfe1b75d32132e5$export$2e2bcd8739ae039 = $4cfe1b75d32132e5$var$ModalBody;

/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $74Zh5 = parcelRequire("74Zh5");

var $52117b12c3dcd012$var$footerStyles = (0, $74Zh5.css)({
    display: 'flex',
    position: 'relative',
    alignItems: 'center',
    justifyContent: 'flex-end',
    gap: "var(--ds-space-100, 8px)",
    marginBlockStart: "calc(-1 * ".concat("var(--ds-border-width-outline, 2px)", ")"),
    paddingBlockEnd: "var(--ds-space-300, 24px)",
    paddingBlockStart: "var(--ds-space-200, 16px)",
    paddingInline: "var(--ds-space-300, 24px)"
});
/**
 * __Modal footer__
 *
 * A modal footer often contains a primary action and the ability to cancel and close the dialog, though can contain any React element.
 *
 * - [Examples](https://atlassian.design/components/modal-dialog/examples#modal-footer)
 * - [Code](https://atlassian.design/components/modal-dialog/code#modal-footer-props)
 * - [Usage](https://atlassian.design/components/modal-dialog/usage)
 */ var $52117b12c3dcd012$var$ModalFooter = function ModalFooter(props) {
    var children = props.children, userDefinedTestId = props.testId;
    var _useModal = (0, $80b9a27bd3af2156$export$33ffd74ebf07f060)(), modalTestId = _useModal.testId;
    var testId = userDefinedTestId || modalTestId && "".concat(modalTestId, "--footer");
    return (0, $74Zh5.jsx)("div", {
        css: $52117b12c3dcd012$var$footerStyles,
        "data-testid": testId
    }, children);
};
var $52117b12c3dcd012$export$2e2bcd8739ae039 = $52117b12c3dcd012$var$ModalFooter;

/**
 * @jsxRuntime classic
 * @jsx jsx
 */ parcelRequire("5FkrB");

var $74Zh5 = parcelRequire("74Zh5");

var $1f902a1f4757a97e$var$headerStyles = (0, $74Zh5.css)({
    display: 'flex',
    position: 'relative',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBlockEnd: "calc(-1 * ".concat("var(--ds-border-width-outline, 2px)", ")"),
    paddingBlockEnd: "var(--ds-space-200, 16px)",
    paddingBlockStart: "var(--ds-space-300, 24px)",
    paddingInline: "var(--ds-space-300, 24px)"
});
/**
 * __Modal header__
 *
 * A modal header contains the title of the modal and can contain other React elements such as a close button.
 *
 * - [Examples](https://atlassian.design/components/modal-dialog/examples#modal-header)
 * - [Code](https://atlassian.design/components/modal-dialog/code#modal-header-props)
 * - [Usage](https://atlassian.design/components/modal-dialog/usage)
 */ var $1f902a1f4757a97e$var$ModalHeader = function ModalHeader(props) {
    var children = props.children, userDefinedTestId = props.testId;
    var _useModal = (0, $80b9a27bd3af2156$export$33ffd74ebf07f060)(), modalTestId = _useModal.testId;
    var testId = userDefinedTestId || modalTestId && "".concat(modalTestId, "--header");
    return (0, $74Zh5.jsx)("div", {
        css: $1f902a1f4757a97e$var$headerStyles,
        "data-testid": testId
    }, children);
};
var $1f902a1f4757a97e$export$2e2bcd8739ae039 = $1f902a1f4757a97e$var$ModalHeader;


var $5FkrB = parcelRequire("5FkrB");

var $ZdqJG = parcelRequire("ZdqJG");
/**
 * __Modal transition__
 *
 * A modal transition wraps a modal to provide a fluid transition upon opening and closing.
 *
 * - [Examples](https://atlassian.design/components/modal-dialog/examples)
 * - [Code](https://atlassian.design/components/modal-dialog/code)
 * - [Usage](https://atlassian.design/components/modal-dialog/usage)
 */ var $17e48fac63f6a6ba$var$ModalTransition = function ModalTransition(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $ZdqJG.default), {
        appear: true
    }, props.children);
};
var $17e48fac63f6a6ba$export$2e2bcd8739ae039 = $17e48fac63f6a6ba$var$ModalTransition;



var $kqp0i = parcelRequire("kqp0i");

var $25nEq = parcelRequire("25nEq");

var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");

var $6ILNo = parcelRequire("6ILNo");

var $jOmHm = parcelRequire("jOmHm");

var $117fZ = parcelRequire("117fZ");

var $id6Cu = parcelRequire("id6Cu");

var $6ILNo = parcelRequire("6ILNo");
var $761f168af5d5cde9$export$fc06342dc8588d3b = function getFirstErrorField(inputs, errors) {
    // Guaranteed to be of type HTMLInputElement[] due to getInputs function overrided in createDecorator
    var htmlInputs = inputs;
    return htmlInputs.find(function(input) {
        // If input is hidden, do not focus
        if (input.type === 'hidden') return false;
        // If input ID matches the error, focus
        if (input.id && (0, $6ILNo.getIn)(errors, input.id)) return true;
        // Default to base behavior
        return input.name && (0, $6ILNo.getIn)(errors, input.name);
    });
};


function $40d9709490a4246c$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $40d9709490a4246c$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $40d9709490a4246c$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $40d9709490a4246c$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $40d9709490a4246c$export$c24727297075ec6a = /*#__PURE__*/ (0, $5FkrB.createContext)({
    registerField: function registerField() {
        return function() {};
    },
    getCurrentValue: function getCurrentValue() {
        return undefined;
    },
    subscribe: function subscribe() {
        return function() {};
    }
});
var $40d9709490a4246c$export$c17cf6b332a82dbc = /*#__PURE__*/ (0, $5FkrB.createContext)(false);
function $40d9709490a4246c$export$2e2bcd8739ae039(props) {
    var userProvidedFormProps = props.formProps, onSubmit = props.onSubmit, testId = props.testId;
    var formRef = (0, $5FkrB.useRef)(null);
    var onSubmitRef = (0, $5FkrB.useRef)(onSubmit);
    onSubmitRef.current = onSubmit;
    var _useState = (0, $5FkrB.useState)(function() {
        // Types here would break the existing API
        var finalForm = (0, $6ILNo.createForm)({
            onSubmit: function onSubmit() {
                return onSubmitRef.current.apply(onSubmitRef, arguments);
            },
            destroyOnUnregister: true,
            initialValues: {},
            mutators: {
                setDefaultValue: function setDefaultValue(_ref, state) {
                    var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_ref, 2), name = _ref2[0], defaultValue = _ref2[1];
                    if (state.formState.initialValues) {
                        var initialValues = state.formState.initialValues;
                        var values = state.formState.values;
                        var _value = name && typeof defaultValue === 'function' ? defaultValue(initialValues[name]) : defaultValue;
                        (0, (/*@__PURE__*/$parcel$interopDefault($117fZ)))(initialValues, name, _value);
                        (0, (/*@__PURE__*/$parcel$interopDefault($117fZ)))(values, name, _value);
                    }
                }
            }
        });
        (0, $jOmHm.default)(function() {
            return formRef.current ? Array.from(formRef.current.querySelectorAll('input')) : [];
        }, (0, $id6Cu.fg)('platform-form-field-error-focus') ? (0, $761f168af5d5cde9$export$fc06342dc8588d3b) : undefined)(finalForm);
        return finalForm;
    }), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 1), form = _useState2[0];
    var _useState3 = (0, $5FkrB.useState)({
        dirty: false,
        submitting: false
    }), _useState4 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState3, 2), state = _useState4[0], setState = _useState4[1];
    (0, $5FkrB.useEffect)(function() {
        var unsubscribe = form.subscribe(function(_ref3) {
            var dirty = _ref3.dirty, submitting = _ref3.submitting;
            setState({
                dirty: dirty,
                submitting: submitting
            });
        }, {
            dirty: true,
            submitting: true
        });
        return unsubscribe;
    }, [
        form
    ]);
    var registerField = (0, $5FkrB.useCallback)(function(name, defaultValue, subscriber, subscription, config) {
        form.pauseValidation();
        var unsubscribe = form.registerField(name, subscriber, subscription, config);
        form.mutators.setDefaultValue(name, defaultValue);
        form.resumeValidation();
        return unsubscribe;
    }, [
        form
    ]);
    var handleSubmit = function handleSubmit(e) {
        if (e) e.preventDefault();
        form.submit();
    };
    var handleReset = function handleReset(initialValues) {
        form.reset(initialValues);
    };
    var handleKeyDown = function handleKeyDown(e) {
        if (e.key === 'Enter' && (e.ctrlKey || e.metaKey) && formRef.current) {
            var submitButton = formRef.current.querySelector('button:not([type]), button[type="submit"], input[type="submit"]');
            if (submitButton) submitButton.click();
            e.preventDefault();
        }
    };
    var _props$isDisabled = props.isDisabled, isDisabled = _props$isDisabled === void 0 ? false : _props$isDisabled, children = props.children;
    var dirty = state.dirty, submitting = state.submitting;
    /**
   * This method is needed in FormContext to use it on the field level
   * to check the current value of the field in case of the component re-mounting.
   */ var getCurrentValue = (0, $5FkrB.useCallback)(function(name) {
        var formState = form.getState();
        return (formState === null || formState === void 0 ? void 0 : formState.values[name]) || undefined;
    }, [
        form
    ]);
    var FormContextValue = (0, $5FkrB.useMemo)(function() {
        return {
            registerField: registerField,
            getCurrentValue: getCurrentValue,
            subscribe: form.subscribe
        };
    }, [
        registerField,
        getCurrentValue,
        form.subscribe
    ]);
    // Abstracting so we can use the same for both rendering patterns
    var formProps = $40d9709490a4246c$var$_objectSpread({
        onKeyDown: handleKeyDown,
        onSubmit: handleSubmit,
        ref: formRef
    }, testId && {
        'data-testid': testId
    });
    var childrenContent = function() {
        if (typeof children === 'function') {
            var result = children.length > 0 ? children($40d9709490a4246c$var$_objectSpread({
                formProps: formProps,
                dirty: dirty,
                reset: handleReset,
                submitting: submitting,
                disabled: isDisabled,
                getState: function getState() {
                    return form.getState();
                },
                getValues: function getValues() {
                    return form.getState().values;
                },
                setFieldValue: form.change
            }, (0, $id6Cu.fg)('platform-form-reset-field-state') && {
                resetFieldState: form.resetFieldState
            })) : children();
            return result === undefined ? null : result;
        } else return (0, $id6Cu.fg)('platform_design-system-team_form-upgrade') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("form", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, formProps, userProvidedFormProps), children) : children;
    }();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement($40d9709490a4246c$export$c24727297075ec6a.Provider, {
        value: FormContextValue
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement($40d9709490a4246c$export$c17cf6b332a82dbc.Provider, {
        value: isDisabled
    }, childrenContent));
}

/* messages.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");
var $f826ade75e1c4206$exports = {};
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f636032ea4a949f6a3ed21b2a88730cd>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty($f826ade75e1c4206$exports, "__esModule", {
    value: true
});
$f826ade75e1c4206$exports.default = void 0;

var $f826ade75e1c4206$var$_react = $f826ade75e1c4206$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $f826ade75e1c4206$var$_statusError = $f826ade75e1c4206$var$_interopRequireDefault((parcelRequire("3oMHR")));

var $f826ade75e1c4206$var$_error = $f826ade75e1c4206$var$_interopRequireDefault((parcelRequire("e08VJ")));
function $f826ade75e1c4206$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for StatusErrorIcon.
 * This component is StatusErrorIcon, with `UNSAFE_fallbackIcon` set to "ErrorIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for error statuses and messaging.
Filled status icons provide higher visual contrast to draw attention to important information.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $f826ade75e1c4206$var$StatusErrorIcon = (props)=>/*#__PURE__*/ $f826ade75e1c4206$var$_react.default.createElement($f826ade75e1c4206$var$_statusError.default, Object.assign({
        name: "StatusErrorIcon",
        LEGACY_fallbackIcon: $f826ade75e1c4206$var$_error.default
    }, props));
$f826ade75e1c4206$var$StatusErrorIcon.displayName = 'StatusErrorIconMigration';
var $f826ade75e1c4206$var$_default = $f826ade75e1c4206$exports.default = $f826ade75e1c4206$var$StatusErrorIcon;


var $19409cf1cd94fa6e$exports = {};
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::849e146248de3896aa5effb6cb325c8d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty($19409cf1cd94fa6e$exports, "__esModule", {
    value: true
});
$19409cf1cd94fa6e$exports.default = void 0;

var $19409cf1cd94fa6e$var$_react = $19409cf1cd94fa6e$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $19409cf1cd94fa6e$var$_statusSuccess = $19409cf1cd94fa6e$var$_interopRequireDefault((parcelRequire("kxD1Z")));

var $19409cf1cd94fa6e$var$_success = $19409cf1cd94fa6e$var$_interopRequireDefault((parcelRequire("ksBYL")));
function $19409cf1cd94fa6e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for StatusSuccessIcon.
 * This component is StatusSuccessIcon, with `UNSAFE_fallbackIcon` set to "EditorSuccessIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for success statuses and messaging. Filled status icons provide higher visual contrast to draw attention to important information.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $19409cf1cd94fa6e$var$StatusSuccessIcon = (props)=>/*#__PURE__*/ $19409cf1cd94fa6e$var$_react.default.createElement($19409cf1cd94fa6e$var$_statusSuccess.default, Object.assign({
        name: "StatusSuccessIcon",
        LEGACY_fallbackIcon: $19409cf1cd94fa6e$var$_success.default
    }, props));
$19409cf1cd94fa6e$var$StatusSuccessIcon.displayName = 'StatusSuccessIconMigration';
var $19409cf1cd94fa6e$var$_default = $19409cf1cd94fa6e$exports.default = $19409cf1cd94fa6e$var$StatusSuccessIcon;



var $id6Cu = parcelRequire("id6Cu");

var $5FkrB = parcelRequire("5FkrB");
var $2a3a11e1c1b99aac$export$3c4232819458a302 = /*#__PURE__*/ (0, $5FkrB.createContext)(undefined);


/**
 * API for the internal `<Message />` component. This is not public API.
 */ /**
 * Public API of the various message components.
 */ var $7ad32ef433d8ebba$var$messageStyles = null;
var $7ad32ef433d8ebba$var$messageAppearanceStyles = {
    default: "_syaz1wmz",
    error: "_syaze6sf",
    valid: "_syazy73q"
};
var $7ad32ef433d8ebba$var$iconWrapperStyles = {
    root: "_1e0c1txw _4t3i7vkz _4cvr1h6o"
};
var $7ad32ef433d8ebba$var$IconWrapper = function IconWrapper(_ref) {
    var children = _ref.children;
    return /*#__PURE__*/ $5FkrB.createElement("span", {
        className: (0, $970q7.default)([
            $7ad32ef433d8ebba$var$iconWrapperStyles.root
        ])
    }, children);
};
var $7ad32ef433d8ebba$var$messageIcons = {
    error: /*#__PURE__*/ $5FkrB.createElement((0, (/*@__PURE__*/$parcel$interopDefault($f826ade75e1c4206$exports))), {
        LEGACY_margin: "0 -2px 0 0",
        color: "currentColor",
        LEGACY_size: "small",
        label: "error",
        size: "small"
    }),
    valid: /*#__PURE__*/ $5FkrB.createElement((0, (/*@__PURE__*/$parcel$interopDefault($19409cf1cd94fa6e$exports))), {
        LEGACY_margin: "0 -2px 0 0",
        color: "currentColor",
        LEGACY_size: "small",
        label: "success",
        size: "small"
    })
};
var $7ad32ef433d8ebba$var$Message = function Message(_ref2) {
    var children = _ref2.children, _ref2$appearance = _ref2.appearance, appearance = _ref2$appearance === void 0 ? 'default' : _ref2$appearance, fieldId = _ref2.fieldId, testId = _ref2.testId;
    var icon = $7ad32ef433d8ebba$var$messageIcons[appearance];
    var _useContext = (0, $5FkrB.useContext)($7ad32ef433d8ebba$var$MessageWrapperContext), isWrapper = _useContext.isWrapper;
    var _useState = (0, $5FkrB.useState)(false), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), shouldRenderAfterDelay = _useState2[0], setShouldRenderAfterDelay = _useState2[1];
    // TODO: DSP-23603 - To clean up when removing "platform_dst_form_screenreader_message_fix" feature flag
    var isDelayRenderEnabled = (0, $id6Cu.fg)('platform_dst_form_screenreader_message_fix') && !isWrapper;
    (0, $5FkrB.useEffect)(function() {
        if (isDelayRenderEnabled) {
            // Only delay rendering if there is no wrapper and feature flag is enabled
            var timer = setTimeout(function() {
                setShouldRenderAfterDelay(true);
            }, 10);
            return function() {
                return clearTimeout(timer);
            };
        }
    }, [
        isDelayRenderEnabled
    ]);
    /**
   * The wrapping span is necessary to preserve spaces between children.
   * Otherwise the flex layout of the message will remove any whitespace
   * between children.
   *
   * If the child is just a string, this is not required and we can use one
   * less DOM element.
   */ var content = typeof children === 'string' ? children : /*#__PURE__*/ $5FkrB.createElement("span", null, children);
    var childrenToRender = /*#__PURE__*/ $5FkrB.createElement((0, $5FkrB.Fragment), null, icon && /*#__PURE__*/ $5FkrB.createElement($7ad32ef433d8ebba$var$IconWrapper, null, icon), content);
    return /*#__PURE__*/ $5FkrB.createElement("div", {
        "data-testid": testId,
        id: fieldId,
        "aria-live": !isWrapper ? 'polite' : undefined,
        className: (0, $970q7.default)([
            "_zulp12x7 _11c8dcr7 _1e0c1txw _1bah1q9y _1pfh1b66",
            $7ad32ef433d8ebba$var$messageAppearanceStyles[appearance]
        ])
    }, isDelayRenderEnabled ? shouldRenderAfterDelay && childrenToRender : childrenToRender);
};
var $7ad32ef433d8ebba$export$8fbe3c7d0ed2c683 = function HelperMessage(_ref3) {
    var children = _ref3.children, testId = _ref3.testId;
    return /*#__PURE__*/ $5FkrB.createElement((0, $2a3a11e1c1b99aac$export$3c4232819458a302).Consumer, null, function(fieldId) {
        return /*#__PURE__*/ $5FkrB.createElement($7ad32ef433d8ebba$var$Message, {
            fieldId: fieldId ? "".concat(fieldId, "-helper") : undefined,
            testId: testId
        }, children);
    });
};
var $7ad32ef433d8ebba$export$915e9e7bd4f0f96d = function ErrorMessage(_ref4) {
    var children = _ref4.children, testId = _ref4.testId;
    return /*#__PURE__*/ $5FkrB.createElement((0, $2a3a11e1c1b99aac$export$3c4232819458a302).Consumer, null, function(fieldId) {
        return /*#__PURE__*/ $5FkrB.createElement($7ad32ef433d8ebba$var$Message, {
            appearance: "error",
            fieldId: fieldId ? "".concat(fieldId, "-error") : undefined,
            testId: testId
        }, children);
    });
};
var $7ad32ef433d8ebba$export$5505afb209a532c8 = function ValidMessage(_ref5) {
    var children = _ref5.children, testId = _ref5.testId;
    return /*#__PURE__*/ $5FkrB.createElement((0, $2a3a11e1c1b99aac$export$3c4232819458a302).Consumer, null, function(fieldId) {
        return /*#__PURE__*/ $5FkrB.createElement($7ad32ef433d8ebba$var$Message, {
            appearance: "valid",
            fieldId: fieldId ? "".concat(fieldId, "-valid") : undefined,
            testId: testId
        }, children);
    });
};
/**
 * __Message wrapper context__
 *
 * A message wrapper context allows the children to check
 * if it is contained within the MessageWrapper.
 */ var $7ad32ef433d8ebba$var$MessageWrapperContext = /*#__PURE__*/ (0, $5FkrB.createContext)({
    isWrapper: false
});
var $7ad32ef433d8ebba$export$ec445f12f63100a5 = function MessageWrapper(_ref6) {
    var children = _ref6.children;
    var contextValue = {
        isWrapper: true
    };
    return /*#__PURE__*/ $5FkrB.createElement($7ad32ef433d8ebba$var$MessageWrapperContext.Provider, {
        value: contextValue
    }, /*#__PURE__*/ $5FkrB.createElement("div", {
        "aria-live": "polite",
        "data-testid": "message-wrapper"
    }, children));
};

/* field.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $25nEq = parcelRequire("25nEq");

var $iYJcE = parcelRequire("iYJcE");

var $ekGgq = parcelRequire("ekGgq");

var $970q7 = parcelRequire("970q7");

var $5FkrB = parcelRequire("5FkrB");

var $ekGgq = parcelRequire("ekGgq");

var $5FkrB = parcelRequire("5FkrB");

var $b5lkZ = parcelRequire("b5lkZ");

var $id6Cu = parcelRequire("id6Cu");
var $ad3e5f319e72367b$var$_React$useId;
// Type copied from https://github.com/thearnica/react-uid/blob/0f507fbbdb1ab84acf477ec32698afe3d2191e49/src/hooks.ts#L12
// Copied rather than inferred to make the type transparent
// @ts-ignore - useId is not accessible in React 16
var $ad3e5f319e72367b$var$react18UseId = ($ad3e5f319e72367b$var$_React$useId = (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).useId) !== null && $ad3e5f319e72367b$var$_React$useId !== void 0 ? $ad3e5f319e72367b$var$_React$useId : undefined;
function $ad3e5f319e72367b$export$f680877a34711e37() {
    if ($ad3e5f319e72367b$var$react18UseId && (0, $id6Cu.fg)('platform-dst-react-18-use-id')) {
        if ((0, $id6Cu.fg)('platform-dst-react-18-use-id-selector-safe')) // tl;dr: React uses `:` or `«»` in selectors which breaks `document.querySelector(…)`
        // in hundreds of tests. So we replace it with a safe string of `_` to match future
        // React 19 functionality: https://github.com/facebook/react/pull/33422
        return $ad3e5f319e72367b$var$react18UseId().replace(/[:«»]/g, '_');
        return $ad3e5f319e72367b$var$react18UseId();
    }
    return "uid".concat((0, $b5lkZ.useUID)());
}
var $ad3e5f319e72367b$export$6be90bcb437e928f = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function(_ref, ref) {
    var children = _ref.children, _ref$postfix = _ref.postfix, postfix = _ref$postfix === void 0 ? '' : _ref$postfix, _ref$prefix = _ref.prefix, prefix = _ref$prefix === void 0 ? '' : _ref$prefix;
    var id = "".concat(prefix).concat($ad3e5f319e72367b$export$f680877a34711e37()).concat(postfix);
    (0, $5FkrB.useEffect)(function() {
        if (!ref) return;
        switch((0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(ref)){
            case 'function':
                ref(id);
                break;
            case 'object':
                ref.current = id;
                break;
            default:
                throw new Error("Unreachable case for unsupported type of ref \"".concat((0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(ref), "\""));
        }
    }, [
        id,
        ref
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).Fragment, null, typeof children === 'function' ? children({
        id: id
    }) : children);
});
function $ad3e5f319e72367b$export$6ee17796e3d70de2() {
    if ($ad3e5f319e72367b$var$react18UseId && (0, $id6Cu.fg)('platform-dst-react-18-use-id')) {
        // eslint-disable-next-line react-hooks/rules-of-hooks -- cleanup with feature gating
        var uid = $ad3e5f319e72367b$export$f680877a34711e37();
        return function(id) {
            return "".concat(uid, "-").concat(id.toString());
        };
    }
    return (0, $b5lkZ.useUIDSeed)();
}



var $id6Cu = parcelRequire("id6Cu");


/* label.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");
var $e6c825ca43fa4ec5$var$fieldsetLabelStyles = null;
var $e6c825ca43fa4ec5$export$b04be29aa201d4f5 = function Label(_ref) {
    var children = _ref.children, htmlFor = _ref.htmlFor, id = _ref.id, testId = _ref.testId;
    return /*#__PURE__*/ $5FkrB.createElement("label", {
        id: id,
        htmlFor: htmlFor,
        "data-testid": testId,
        className: (0, $970q7.default)([
            "_11c8dcr7 _1e0c1o8l _syaz1gjq _k48pmoej _6rth1b66 _1pfhze3t"
        ])
    }, children);
};
var $e6c825ca43fa4ec5$export$ed247974535929c7 = function Legend(_ref2) {
    var children = _ref2.children;
    return /*#__PURE__*/ $5FkrB.createElement("legend", {
        className: (0, $970q7.default)([
            "_11c8dcr7 _1e0c1o8l _syaz1gjq _k48pmoej _6rth1b66 _1pfhze3t"
        ])
    }, children);
};



/* required-asterisk.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");
var $df8dc48ae4041bc0$var$requiredIndicatorStyles = null;
function $df8dc48ae4041bc0$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ $5FkrB.createElement("span", {
        "aria-hidden": "true",
        title: "required",
        className: (0, $970q7.default)([
            "_syaz1ick _ect41gqc _bozgv77o"
        ])
    }, "*");
}


function $baa25b657b03ab03$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $baa25b657b03ab03$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $baa25b657b03ab03$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $baa25b657b03ab03$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $baa25b657b03ab03$var$fieldWrapperStyles = null;
function $baa25b657b03ab03$var$isEvent(event) {
    return Boolean(event && event.target);
}
function $baa25b657b03ab03$var$isFunction(x) {
    return typeof x === 'function';
}
// Must be exported to satisfy error TS4023 from Jira builds
// src/packages/servicedesk/virtual-agent/common/src/ui/base-text-field/index.tsx(10,14):
// error TS4023: Exported variable `BaseTextField` has or is using name
// `FieldComponentProps` from external module
// `/opt/atlassian/pipelines/agent/build/jira/tsDist/@atlaskit__form/app/src/field`
// but cannot be named.
function $baa25b657b03ab03$var$usePreviousRef(current) {
    var ref = (0, $5FkrB.useRef)(current);
    // will be updated on the next render
    (0, $5FkrB.useEffect)(function() {
        ref.current = current;
    });
    // return the existing current (pre render)
    return ref;
}
function $baa25b657b03ab03$var$isShallowEqual(previousValue, currentValue) {
    if (previousValue === currentValue) return true;
    // not checking functions
    if (typeof previousValue === 'function' && typeof currentValue === 'function') return true;
    if (Array.isArray(previousValue) && Array.isArray(currentValue)) return JSON.stringify(previousValue) === JSON.stringify(currentValue);
    if ((0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(previousValue) === 'object' && (0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(currentValue) === 'object') return JSON.stringify(previousValue) === JSON.stringify(currentValue);
    return false;
}
function $baa25b657b03ab03$export$2e2bcd8739ae039(props) {
    var _getCurrentValue;
    var _props$children = props.children, children = _props$children === void 0 ? function() {
        return null;
    } : _props$children, component = props.component;
    var _useContext = (0, $5FkrB.useContext)((0, $40d9709490a4246c$export$c24727297075ec6a)), registerField = _useContext.registerField, getCurrentValue = _useContext.getCurrentValue;
    var isDisabled = (0, $5FkrB.useContext)((0, $40d9709490a4246c$export$c17cf6b332a82dbc)) || props.isDisabled || false;
    var defaultValue = $baa25b657b03ab03$var$isFunction(props.defaultValue) ? props.defaultValue() : props.defaultValue;
    var latestPropsRef = $baa25b657b03ab03$var$usePreviousRef(props);
    /**
   * HACK: defaultValue can potentially be an array or object which cannot be
   * passed directly into a `useEffect` dependency array, since it will trigger
   * the hook every time.
   */ var isDefaultValueChanged = !$baa25b657b03ab03$var$isShallowEqual(latestPropsRef.current.defaultValue, props.defaultValue);
    var _useState = (0, $5FkrB.useState)({
        fieldProps: {
            onChange: function onChange() {},
            onBlur: function onBlur() {},
            onFocus: function onFocus() {},
            /* Previously, defaultValue was being set as undefined in Field.defaultProps, which
         * effectively made it an optional prop to external consumers of Field. However the
         * prop types defined defaultValue as required, so inside the component it was not
         * valid for defaultValue to be undefined. We need to suppress the error
         * after changing defaultValue to explicitly be an optional prop.
         * If default value has changed we are using new default value.
         * Otherwise we need to check if we already have value for this field
         * (because we are using changing key prop to re-run field level validation, and that
         * cause the component re-mounting) to not override the actual value with the default value.
         */ // @ts-ignore
            value: isDefaultValueChanged ? defaultValue : (_getCurrentValue = getCurrentValue(props.name)) !== null && _getCurrentValue !== void 0 ? _getCurrentValue : defaultValue
        },
        error: undefined,
        valid: false,
        meta: {
            dirty: false,
            dirtySinceLastSubmit: false,
            touched: false,
            valid: false,
            validating: false,
            submitting: false,
            submitFailed: false,
            error: undefined,
            submitError: undefined
        }
    }), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), state = _useState2[0], setState = _useState2[1];
    var latestStateRef = $baa25b657b03ab03$var$usePreviousRef(state);
    (0, $5FkrB.useEffect)(function() {
        function fieldStateToMeta() {
            var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
            return {
                dirty: value.dirty || false,
                dirtySinceLastSubmit: value.dirtySinceLastSubmit || false,
                touched: value.touched || false,
                valid: value.valid || false,
                submitting: value.submitting || false,
                submitFailed: value.submitFailed || false,
                error: value.error,
                submitError: value.submitError,
                validating: !!value.validating
            };
        }
        var unregister = registerField(latestPropsRef.current.name, /**
     * Similar as for setting initial state value.
     * Additionally we are checking if the default value is a function,
     * it is used in checkbox fields, where fields with same name and
     * defaultIsChecked should create array of values. In this situation we can't
     * override the default value on re-registering, but also we don't need to change
     * the key prop to re-run validation.
     */ // @ts-ignore
        isDefaultValueChanged || // @ts-ignore
        $baa25b657b03ab03$var$isFunction(latestPropsRef.current.defaultValue) ? latestPropsRef.current.defaultValue : latestStateRef.current.fieldProps.value, function(fieldState) {
            /**
       * Do not update dirtySinceLastSubmit until submission has finished.
       */ var modifiedDirtySinceLastSubmit = fieldState.submitting ? latestStateRef.current.meta.dirtySinceLastSubmit : fieldState.dirtySinceLastSubmit;
            /**
       * Do not update submitFailed until submission has finished.
       */ var modifiedSubmitFailed = fieldState.submitting ? latestStateRef.current.meta.submitFailed : fieldState.submitFailed;
            /**
       * Do not use submitError if the value has changed.
       */ var modifiedSubmitError = modifiedDirtySinceLastSubmit && latestPropsRef.current.validate ? undefined : fieldState.submitError;
            var modifiedError = modifiedSubmitError || (fieldState.touched || fieldState.dirty) && fieldState.error;
            /**
       * If there has been a submit error, then use logic in modifiedError to determine validity,
       * so we can determine when there is a submit error which we do not want to display
       * because the value has been changed.
       */ var modifiedValid = modifiedSubmitFailed ? modifiedError === undefined : fieldState.valid;
            function getTransform(eventOrValue, currentValue) {
                if (latestPropsRef.current.transform) return latestPropsRef.current.transform(eventOrValue, currentValue);
                if ($baa25b657b03ab03$var$isEvent(eventOrValue)) {
                    var currentTarget = eventOrValue.currentTarget;
                    if (currentTarget.type === 'checkbox') {
                        if (currentTarget.checked) return currentTarget.value || true;
                        return currentTarget.value ? undefined : false;
                    } else if (currentTarget) return currentTarget.value;
                } else return eventOrValue;
            }
            setState({
                fieldProps: {
                    onChange: function onChange(e) {
                        fieldState.change(getTransform(e, fieldState.value));
                    },
                    onBlur: fieldState.blur,
                    onFocus: fieldState.focus,
                    value: fieldState.value
                },
                error: modifiedError || undefined,
                /**
         * The following parameters are optionally typed in final-form to indicate that not all parameters need
         * to be subscribed to. We cast them as booleans (using || false), since this is what they are semantically.
         */ valid: modifiedValid || false,
                meta: fieldStateToMeta(fieldState)
            });
        }, {
            dirty: true,
            dirtySinceLastSubmit: true,
            touched: true,
            valid: true,
            submitting: true,
            submitFailed: true,
            value: true,
            error: true,
            submitError: true,
            validating: true
        }, {
            getValidator: function getValidator() {
                return function validate(value, formState, fieldState) {
                    var supplied = latestPropsRef.current.validate;
                    if (supplied && fieldState) return supplied(value, formState, fieldStateToMeta(fieldState));
                };
            }
        });
        return unregister;
    }, [
        latestPropsRef,
        latestStateRef,
        registerField,
        props.name,
        isDefaultValueChanged
    ]);
    var uid = (0, $ad3e5f319e72367b$export$f680877a34711e37)();
    var fieldId = (0, $5FkrB.useMemo)(function() {
        return props.id ? props.id : "".concat(props.name, "-").concat(uid);
    }, [
        props.id,
        props.name,
        uid
    ]);
    var getDescribedBy = function getDescribedBy() {
        var value = '';
        if (state.error) value += "".concat(fieldId, "-error ");
        if (state.valid) value += "".concat(fieldId, "-valid ");
        return "".concat(value).concat(fieldId, "-helper");
    };
    var extendedFieldProps = $baa25b657b03ab03$var$_objectSpread($baa25b657b03ab03$var$_objectSpread({}, state.fieldProps), {}, {
        name: props.name,
        isDisabled: isDisabled,
        isInvalid: Boolean(state.error),
        isRequired: Boolean(props.isRequired),
        'aria-invalid': state.error ? 'true' : 'false',
        'aria-describedby': getDescribedBy(),
        'aria-labelledby': "".concat(fieldId, "-label"),
        id: fieldId
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("div", {
        "data-testid": props.testId,
        className: (0, $970q7.default)([
            "_1pfhu2gc"
        ])
    }, props.label && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $e6c825ca43fa4ec5$export$b04be29aa201d4f5), {
        htmlFor: fieldId,
        id: "".concat(fieldId, "-label"),
        testId: props.testId && "".concat(props.testId, "--label")
    }, props.label, props.isRequired && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $df8dc48ae4041bc0$export$2e2bcd8739ae039), null), props.elementAfterLabel), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $2a3a11e1c1b99aac$export$3c4232819458a302).Provider, {
        value: fieldId
    }, component && (0, $id6Cu.fg)('platform_design-system-team_field-upgrade') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).Fragment, null, component && component({
        fieldProps: extendedFieldProps
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $7ad32ef433d8ebba$export$ec445f12f63100a5), null, props.helperMessage && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $7ad32ef433d8ebba$export$8fbe3c7d0ed2c683), null, props.helperMessage), state.error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $7ad32ef433d8ebba$export$915e9e7bd4f0f96d), null, props.errorMessage || state.error), state.meta.touched && state.valid && props.validMessage && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $7ad32ef433d8ebba$export$5505afb209a532c8), null, props.validMessage))) : children({
        fieldProps: extendedFieldProps,
        error: state.error,
        valid: state.valid,
        meta: state.meta
    })));
}

/* form-footer.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");
var $f84678374ba6cf7b$var$formFooterWrapperStyles = null;
var $f84678374ba6cf7b$var$justifyContentStyles = null;
function $f84678374ba6cf7b$export$2e2bcd8739ae039(_ref) {
    var _ref$align = _ref.align, align = _ref$align === void 0 ? 'end' : _ref$align, children = _ref.children;
    return /*#__PURE__*/ $5FkrB.createElement("footer", {
        className: (0, $970q7.default)([
            "_1e0c1txw _1bahesu3 _1pfh1ejb",
            align === 'start' && "_1bah1y6m"
        ])
    }, children);
}


var $90374d00f267e742$exports = {};
"use strict";
Object.defineProperty($90374d00f267e742$exports, "__esModule", {
    value: true
});
$90374d00f267e742$exports.default = void 0;

var $90374d00f267e742$var$_react = $90374d00f267e742$var$_interopRequireDefault((parcelRequire("5FkrB")));


var $90374d00f267e742$var$_showMoreHorizontal = $90374d00f267e742$var$_interopRequireDefault((parcelRequire("3j4LJ")));
function $90374d00f267e742$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $90374d00f267e742$var$MoreIcon = (props)=>/*#__PURE__*/ $90374d00f267e742$var$_react.default.createElement($b2a18d994dfc84a8$export$3cfb73f70dfca966, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><circle cx="5" cy="12" r="2"/><circle cx="12" cy="12" r="2"/><circle cx="19" cy="12" r="2"/></g></svg>`
    }, props, {
        newIcon: $90374d00f267e742$var$_showMoreHorizontal.default
    }));
$90374d00f267e742$var$MoreIcon.displayName = 'MoreIcon';
var $90374d00f267e742$var$_default = $90374d00f267e742$exports.default = $90374d00f267e742$var$MoreIcon;



var $7KfP5 = parcelRequire("7KfP5");

var $igbF4 = parcelRequire("igbF4");




/* eslint-disable @repo/internal/react/require-jsdoc */ var $b538421461624312$export$2e2bcd8739ae039 = function(channel) {
    return function(payload) {
        return function(createAnalyticsEvent) {
            var consumerEvent = createAnalyticsEvent(payload);
            var clonedEvent = consumerEvent.clone();
            if (clonedEvent) clonedEvent.fire(channel);
            return consumerEvent;
        };
    };
};


var $kqp0i = parcelRequire("kqp0i");

var $25nEq = parcelRequire("25nEq");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");

var $5FkrB = parcelRequire("5FkrB");

var $id6Cu = parcelRequire("id6Cu");

var $3ZMUU = parcelRequire("3ZMUU");
var $41a208c5706f0663$var$_process$env;
var /// <reference types="node" />
$41a208c5706f0663$export$2e2bcd8739ae039 = typeof $3ZMUU !== 'undefined' && $3ZMUU !== null && (($41a208c5706f0663$var$_process$env = {}, $41a208c5706f0663$var$_process$env === void 0) ? void 0 : $41a208c5706f0663$var$_process$env['ANALYTICS_NEXT_MODERN_CONTEXT']);



var $fC8ib = parcelRequire("fC8ib");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $kIXpt = parcelRequire("kIXpt");

var $cYPzS = parcelRequire("cYPzS");

var $eyuDe = parcelRequire("eyuDe");

var $25nEq = parcelRequire("25nEq");

var $5FkrB = parcelRequire("5FkrB");

var $8vJ0V = parcelRequire("8vJ0V");

var $iyyOp = parcelRequire("iyyOp");
function $7105d621bda65d65$var$_callSuper(t, o, e) {
    return o = (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(o), (0, (/*@__PURE__*/$parcel$interopDefault($kIXpt)))(t, $7105d621bda65d65$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(t).constructor) : o.apply(t, e));
}
function $7105d621bda65d65$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($7105d621bda65d65$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $7105d621bda65d65$var$ContextTypes = {
    getAtlaskitAnalyticsContext: (0, (/*@__PURE__*/$parcel$interopDefault($8vJ0V))).func,
    getAtlaskitAnalyticsEventHandlers: (0, (/*@__PURE__*/$parcel$interopDefault($8vJ0V))).func
};
var $7105d621bda65d65$var$noop = function noop() {
    return [];
};
// eslint-disable-next-line @repo/internal/react/no-class-components
var $7105d621bda65d65$var$AnalyticsContext = /*#__PURE__*/ function(_Component) {
    function AnalyticsContext(props) {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, AnalyticsContext);
        _this = $7105d621bda65d65$var$_callSuper(this, AnalyticsContext, [
            props
        ]);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "getChildContext", function() {
            return {
                getAtlaskitAnalyticsContext: _this.getAnalyticsContext
            };
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "getAnalyticsContext", function() {
            var data = _this.props.data;
            var _this$context$getAtla = _this.context.getAtlaskitAnalyticsContext, getAtlaskitAnalyticsContext = _this$context$getAtla === void 0 ? $7105d621bda65d65$var$noop : _this$context$getAtla;
            return [].concat((0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(getAtlaskitAnalyticsContext()), [
                data
            ]);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "getAnalyticsEventHandlers", function() {
            var _this$context$getAtla2 = _this.context.getAtlaskitAnalyticsEventHandlers, getAtlaskitAnalyticsEventHandlers = _this$context$getAtla2 === void 0 ? $7105d621bda65d65$var$noop : _this$context$getAtla2;
            return getAtlaskitAnalyticsEventHandlers();
        });
        _this.contextValue = {
            getAtlaskitAnalyticsContext: _this.getAnalyticsContext,
            getAtlaskitAnalyticsEventHandlers: _this.getAnalyticsEventHandlers
        };
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($eyuDe)))(AnalyticsContext, _Component);
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(AnalyticsContext, [
        {
            key: "render",
            value: function render() {
                var children = this.props.children;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $iyyOp.default).Provider, {
                    value: this.contextValue
                }, children);
            }
        }
    ]);
}((0, $5FkrB.Component));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($7105d621bda65d65$var$AnalyticsContext, "contextTypes", $7105d621bda65d65$var$ContextTypes);
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($7105d621bda65d65$var$AnalyticsContext, "childContextTypes", $7105d621bda65d65$var$ContextTypes);
var $7105d621bda65d65$export$2e2bcd8739ae039 = $7105d621bda65d65$var$AnalyticsContext;



var $fC8ib = parcelRequire("fC8ib");

var $5FkrB = parcelRequire("5FkrB");

var $iyyOp = parcelRequire("iyyOp");

var $5FkrB = parcelRequire("5FkrB");

var $iyyOp = parcelRequire("iyyOp");
var $d310f08987447be4$export$d1f587f82ad51c4 = function useAnalyticsContext() {
    return (0, $5FkrB.useContext)((0, $iyyOp.default));
};



var $5FkrB = parcelRequire("5FkrB");
var $df18c9122dc12663$export$1d27a74659855e44 = function useTrackedRef(value) {
    var ref = (0, $5FkrB.useRef)(value);
    ref.current = value;
    return ref;
};


var $37c9a222f392cc83$var$AnalyticsContext = function AnalyticsContext(_ref) {
    var data = _ref.data, children = _ref.children;
    var dataRef = (0, $df18c9122dc12663$export$1d27a74659855e44)(data);
    var _useAnalyticsContext = (0, $d310f08987447be4$export$d1f587f82ad51c4)(), getAtlaskitAnalyticsEventHandlers = _useAnalyticsContext.getAtlaskitAnalyticsEventHandlers, getOriginalAnalyticsContext = _useAnalyticsContext.getAtlaskitAnalyticsContext;
    var getAtlaskitAnalyticsContext = (0, $5FkrB.useCallback)(function() {
        return [].concat((0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(getOriginalAnalyticsContext()), [
            dataRef.current
        ]);
    }, [
        getOriginalAnalyticsContext,
        dataRef
    ]);
    var value = (0, $5FkrB.useMemo)(function() {
        return {
            getAtlaskitAnalyticsContext: getAtlaskitAnalyticsContext,
            getAtlaskitAnalyticsEventHandlers: getAtlaskitAnalyticsEventHandlers
        };
    }, [
        getAtlaskitAnalyticsContext,
        getAtlaskitAnalyticsEventHandlers
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $iyyOp.default).Provider, {
        value: value
    }, children);
};
var $37c9a222f392cc83$export$2e2bcd8739ae039 = $37c9a222f392cc83$var$AnalyticsContext;


var $212e543cefe0e97d$var$AnalyticsContext = function AnalyticsContext(props) {
    var isModernContext = (0, $41a208c5706f0663$export$2e2bcd8739ae039) || (0, $id6Cu.fg)('analytics-next-use-legacy-context') === false;
    return isModernContext ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $37c9a222f392cc83$export$2e2bcd8739ae039), props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $7105d621bda65d65$export$2e2bcd8739ae039), props);
};
var $212e543cefe0e97d$export$2e2bcd8739ae039 = $212e543cefe0e97d$var$AnalyticsContext;


var $99c8b6438816a211$var$_excluded = [
    "analyticsContext"
];
function $99c8b6438816a211$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $99c8b6438816a211$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $99c8b6438816a211$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $99c8b6438816a211$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $99c8b6438816a211$var$withAnalyticsContext = function withAnalyticsContext(defaultData) {
    return function(WrappedComponent) {
        var WithAnalyticsContext = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function(_ref, ref) {
            var analyticsContext = _ref.analyticsContext, rest = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $99c8b6438816a211$var$_excluded);
            var analyticsData = (0, $5FkrB.useMemo)(function() {
                return $99c8b6438816a211$var$_objectSpread($99c8b6438816a211$var$_objectSpread({}, defaultData), analyticsContext);
            }, [
                analyticsContext
            ]);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $212e543cefe0e97d$export$2e2bcd8739ae039), {
                data: analyticsData
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(WrappedComponent, (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, rest, {
                ref: ref
            })));
        });
        WithAnalyticsContext.displayName = "WithAnalyticsContext(".concat(WrappedComponent.displayName || WrappedComponent.name, ")");
        return WithAnalyticsContext;
    };
};
var $99c8b6438816a211$export$2e2bcd8739ae039 = $99c8b6438816a211$var$withAnalyticsContext;


var $kqp0i = parcelRequire("kqp0i");

var $5FkrB = parcelRequire("5FkrB");

var $dLGML = parcelRequire("dLGML");

var $fC8ib = parcelRequire("fC8ib");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $kIXpt = parcelRequire("kIXpt");

var $cYPzS = parcelRequire("cYPzS");

var $lwlXp = parcelRequire("lwlXp");

var $eyuDe = parcelRequire("eyuDe");

var $25nEq = parcelRequire("25nEq");

var $ekGgq = parcelRequire("ekGgq");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $25nEq = parcelRequire("25nEq");
function $d9712d0a98e8d549$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $d9712d0a98e8d549$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $d9712d0a98e8d549$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $d9712d0a98e8d549$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $d9712d0a98e8d549$export$ad4be5c2ec28cecf = function isAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $d9712d0a98e8d549$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === 'AnalyticsEvent';
};
var $d9712d0a98e8d549$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function AnalyticsEvent(props) {
        var _this = this;
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, AnalyticsEvent);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "_isAnalyticsEvent", true);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "clone", function() {
            // just a shallow clone, don't change sub refs unless you want to
            // affect the original's too
            var payload = $d9712d0a98e8d549$var$_objectSpread({}, _this.payload);
            return new AnalyticsEvent({
                payload: payload
            });
        });
        this.payload = props.payload;
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(AnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (typeof updater === 'function') this.payload = updater(this.payload);
                if ((0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(updater) === 'object') this.payload = $d9712d0a98e8d549$var$_objectSpread($d9712d0a98e8d549$var$_objectSpread({}, this.payload), updater);
                return this;
            }
        }
    ]);
}();


function $feadde18ab8058e2$var$_callSuper(t, o, e) {
    return o = (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(o), (0, (/*@__PURE__*/$parcel$interopDefault($kIXpt)))(t, $feadde18ab8058e2$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(t).constructor) : o.apply(t, e));
}
function $feadde18ab8058e2$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($feadde18ab8058e2$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $feadde18ab8058e2$var$_superPropGet(t, o, e, r) {
    var p = (0, (/*@__PURE__*/$parcel$interopDefault($lwlXp)))((0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(1 & r ? t.prototype : t), o, e);
    return 2 & r && "function" == typeof p ? function(t) {
        return p.apply(e, t);
    } : p;
}
var $feadde18ab8058e2$export$35f8383928ba8d7 = function isUIAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $feadde18ab8058e2$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isUIAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === 'UIAnalyticsEvent';
};
var $feadde18ab8058e2$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_AnalyticsEvent) {
    function UIAnalyticsEvent(props) {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, UIAnalyticsEvent);
        _this = $feadde18ab8058e2$var$_callSuper(this, UIAnalyticsEvent, [
            props
        ]);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "_isUIAnalyticsEvent", true);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "clone", function() {
            if (_this.hasFired) return null;
            var context = (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(_this.context);
            var handlers = (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(_this.handlers);
            /**
       * A hacky "deep clone" of the object. This is limited in that it wont
       * support functions, regexs, Maps, Sets, etc, but none of those need to
       * be represented in our payload.
       */ var payload = JSON.parse(JSON.stringify(_this.payload));
            return new UIAnalyticsEvent({
                context: context,
                handlers: handlers,
                payload: payload
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "fire", function(channel) {
            if (_this.hasFired) return;
            _this.handlers.forEach(function(handler) {
                return handler(_this, channel);
            });
            _this.hasFired = true;
        });
        _this.context = props.context || [];
        _this.handlers = props.handlers || [];
        _this.hasFired = false;
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($eyuDe)))(UIAnalyticsEvent, _AnalyticsEvent);
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(UIAnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (this.hasFired) return this;
                return $feadde18ab8058e2$var$_superPropGet(UIAnalyticsEvent, "update", this, 3)([
                    updater
                ]);
            }
        }
    ]);
}((0, $d9712d0a98e8d549$export$2e2bcd8739ae039));



function $45df09d9e0e3f872$export$5bf35293e545f20c() {
    var analyticsContext = (0, $d310f08987447be4$export$d1f587f82ad51c4)();
    var createAnalyticsEvent = (0, $dLGML.useCallbackOne)(function(payload) {
        return new (0, $feadde18ab8058e2$export$2e2bcd8739ae039)({
            context: analyticsContext.getAtlaskitAnalyticsContext(),
            handlers: analyticsContext.getAtlaskitAnalyticsEventHandlers(),
            payload: payload
        });
    }, [
        analyticsContext
    ]);
    return {
        createAnalyticsEvent: createAnalyticsEvent
    };
}



var $25nEq = parcelRequire("25nEq");

var $ekGgq = parcelRequire("ekGgq");

var $5FkrB = parcelRequire("5FkrB");

function $b938f71619394bae$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $b938f71619394bae$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $b938f71619394bae$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $b938f71619394bae$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $b938f71619394bae$export$9ebb5a84d17e5d18() {
    var createEventMap = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var wrappedComponentProps = arguments.length > 1 ? arguments[1] : undefined;
    var _useAnalyticsEvents = (0, $45df09d9e0e3f872$export$5bf35293e545f20c)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
    var handlerCache = (0, $5FkrB.useRef)({});
    var patchedProps = (0, $5FkrB.useMemo)(function() {
        var cache = handlerCache.current;
        // Clean up no longer used handlers in cache
        Object.keys(cache).filter(function(key) {
            return !(key in createEventMap);
        }).forEach(function(key) {
            return delete cache[key];
        });
        return Object.keys(createEventMap).reduce(function(p, k) {
            var eventCreator = createEventMap[k];
            if (![
                'object',
                'function'
            ].includes((0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(eventCreator))) return p;
            var propValue = wrappedComponentProps[k];
            if (k in cache && cache[k].eventCreator === eventCreator && cache[k].propValue === propValue) return $b938f71619394bae$var$_objectSpread($b938f71619394bae$var$_objectSpread({}, p), {}, (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, k, cache[k].wrappedCallback));
            var wrappedCallback = function wrappedCallback() {
                var analyticsEvent = typeof eventCreator === 'function' ? eventCreator(createAnalyticsEvent, wrappedComponentProps) : createAnalyticsEvent(eventCreator);
                if (propValue && typeof propValue === 'function') {
                    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                    propValue.apply(void 0, args.concat([
                        analyticsEvent
                    ]));
                }
            };
            cache[k] = {
                eventCreator: eventCreator,
                wrappedCallback: wrappedCallback,
                propValue: propValue
            };
            return $b938f71619394bae$var$_objectSpread($b938f71619394bae$var$_objectSpread({}, p), {}, (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, k, wrappedCallback));
        }, {});
    }, [
        createEventMap,
        wrappedComponentProps,
        createAnalyticsEvent,
        handlerCache
    ]);
    return {
        patchedEventProps: patchedProps
    };
}


var $7af0e6f035c43fdf$var$withAnalyticsEvents = function withAnalyticsEvents() {
    var createEventMap = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return function(WrappedComponent) {
        var WithAnalyticsEvents = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function(props, ref) {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore: to unblock React 18.2.0 -> 18.3.1 version bump in Jira
            var _usePatchedProps = (0, $b938f71619394bae$export$9ebb5a84d17e5d18)(createEventMap, props), patchedEventProps = _usePatchedProps.patchedEventProps;
            var _useAnalyticsEvents = (0, $45df09d9e0e3f872$export$5bf35293e545f20c)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(WrappedComponent, (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, props, patchedEventProps, {
                createAnalyticsEvent: createAnalyticsEvent,
                ref: ref
            }));
        });
        WithAnalyticsEvents.displayName = "WithAnalyticsEvents(".concat(WrappedComponent.displayName || WrappedComponent.name, ")");
        return WithAnalyticsEvents;
    };
};
var $7af0e6f035c43fdf$export$2e2bcd8739ae039 = $7af0e6f035c43fdf$var$withAnalyticsEvents;



var $kqp0i = parcelRequire("kqp0i");

var $5FkrB = parcelRequire("5FkrB");

var $kqp0i = parcelRequire("kqp0i");
parcelRequire("dujqE");

var $ekGgq = parcelRequire("ekGgq");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $kIXpt = parcelRequire("kIXpt");

var $cYPzS = parcelRequire("cYPzS");

var $eyuDe = parcelRequire("eyuDe");

var $25nEq = parcelRequire("25nEq");

var $fC8ib = parcelRequire("fC8ib");

var $5FkrB = parcelRequire("5FkrB");

var $dJ32z = parcelRequire("dJ32z");

var $id6Cu = parcelRequire("id6Cu");
/* eslint-disable @repo/internal/fs/filename-pattern-match */ var $0a1bf1a32914c625$export$f4da216a6ca54656 = function formatGroupLabel(group) {
    return group.label;
};
var $0a1bf1a32914c625$export$dac6ace3020563ca = function getOptionLabel(option) {
    return option.label;
};
var $0a1bf1a32914c625$export$40be908210c5a79c = function getOptionValue(option) {
    return option.value;
};
var $0a1bf1a32914c625$export$56bd0c8d90db075 = function isOptionDisabled(option) {
    return !!option.isDisabled;
};



var $25nEq = parcelRequire("25nEq");
/* containers.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $kqp0i = parcelRequire("kqp0i");

var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");

var $hUFig = parcelRequire("hUFig");

var $iYJcE = parcelRequire("iYJcE");

var $25nEq = parcelRequire("25nEq");

var $1Vcia = parcelRequire("1Vcia");

var $ekGgq = parcelRequire("ekGgq");
var $50a6d89e4bbf23e3$var$_excluded = [
    "className",
    "clearValue",
    "cx",
    "xcss",
    "getStyles",
    "getClassNames",
    "getValue",
    "hasValue",
    "isMulti",
    "isRtl",
    "options",
    "selectOption",
    "selectProps",
    "setValue"
];
function $50a6d89e4bbf23e3$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $50a6d89e4bbf23e3$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $50a6d89e4bbf23e3$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $50a6d89e4bbf23e3$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $50a6d89e4bbf23e3$export$8793edee2d425525 = function noop() {};
// ==============================
// Class Name Prefixer
// ==============================
/**
 * String representation of component state for styling with class names.
 *
 * Expects an array of strings OR a string/object pair:
 * - className(['comp', 'comp-arg', 'comp-arg-2'])
 * @returns 'react-select__comp react-select__comp-arg react-select__comp-arg-2'
 * - className('comp', { some: true, state: false })
 * @returns 'react-select__comp react-select__comp--some'
 */ function $50a6d89e4bbf23e3$var$applyPrefixToName(prefix, name) {
    if (!name) return prefix;
    else if (name[0] === '-') return prefix + name;
    else return prefix + '__' + name;
}
function $50a6d89e4bbf23e3$export$ce4ab0c55987d1ff(prefix, state) {
    for(var _len = arguments.length, classNameList = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)classNameList[_key - 2] = arguments[_key];
    var arr = [].concat(classNameList);
    if (state && prefix) {
        for(var key in state)if (state.hasOwnProperty(key) && state[key]) arr.push("".concat($50a6d89e4bbf23e3$var$applyPrefixToName(prefix, key)));
    }
    return arr.filter(function(i) {
        return i;
    }).map(function(i) {
        return String(i).trim();
    }).join(' ');
}
var $50a6d89e4bbf23e3$export$33f062f47f21a01 = function cleanValue(value) {
    if ($50a6d89e4bbf23e3$var$isArray(value)) return value.filter(Boolean);
    if ((0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(value) === 'object' && value !== null) return [
        value
    ];
    return [];
};
var $50a6d89e4bbf23e3$export$8e9fd4287627890c = function cleanCommonProps(props) {
    //className
    var className = props.className, clearValue = props.clearValue, cx = props.cx, xcss = props.xcss, getStyles = props.getStyles, getClassNames = props.getClassNames, getValue = props.getValue, hasValue = props.hasValue, isMulti = props.isMulti, isRtl = props.isRtl, options = props.options, selectOption = props.selectOption, selectProps = props.selectProps, setValue = props.setValue, innerProps = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(props, $50a6d89e4bbf23e3$var$_excluded);
    return $50a6d89e4bbf23e3$var$_objectSpread({}, innerProps);
};
var $50a6d89e4bbf23e3$export$26417cabd806a658 = function getStyleProps(props, name, classNamesState) {
    var cx = props.cx, getStyles = props.getStyles, getClassNames = props.getClassNames, className = props.className;
    return {
        css: getStyles(name, props),
        className: cx(classNamesState !== null && classNamesState !== void 0 ? classNamesState : {}, getClassNames(name, props), className)
    };
};
function $50a6d89e4bbf23e3$export$2096bae78ecda911(inputValue, actionMeta, onInputChange) {
    if (onInputChange) {
        var newValue = onInputChange(inputValue, actionMeta);
        if (typeof newValue === 'string') return newValue;
    }
    return inputValue;
}
function $50a6d89e4bbf23e3$export$d8a62a489b442872(el) {
    return [
        document.documentElement,
        document.body,
        window
    ].indexOf(el) > -1;
}
function $50a6d89e4bbf23e3$export$2e0654fad740d2e4(el) {
    if ($50a6d89e4bbf23e3$export$d8a62a489b442872(el)) return window.innerHeight;
    return el.clientHeight;
}
function $50a6d89e4bbf23e3$export$c4a223a8ba9e4ea5(el) {
    if ($50a6d89e4bbf23e3$export$d8a62a489b442872(el)) return window.pageYOffset;
    return el.scrollTop;
}
function $50a6d89e4bbf23e3$export$3f99968195accfaf(el, top) {
    // with a scroll distance, we perform scroll on the element
    if ($50a6d89e4bbf23e3$export$d8a62a489b442872(el)) {
        window.scrollTo(0, top);
        return;
    }
    el.scrollTop = top;
}
function $50a6d89e4bbf23e3$export$cfa2225e87938781(element) {
    var style = getComputedStyle(element);
    var excludeStaticParent = style.position === 'absolute';
    var overflowRx = /(auto|scroll)/;
    if (style.position === 'fixed') return document.documentElement;
    for(var parent = element; parent = parent.parentElement;){
        style = getComputedStyle(parent);
        if (excludeStaticParent && style.position === 'static') continue;
        if (overflowRx.test(style.overflow + style.overflowY + style.overflowX)) return parent;
    }
    return document.documentElement;
}
// Animated Scroll To
// ------------------------------
/**
 * @param t: time (elapsed)
 * @param b: initial value
 * @param c: amount of change
 * @param d: duration
 */ function $50a6d89e4bbf23e3$var$easeOutCubic(t, b, c, d) {
    return c * ((t = t / d - 1) * t * t + 1) + b;
}
function $50a6d89e4bbf23e3$export$858c30343199f3af(element, to) {
    var duration = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 200;
    var callback = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : $50a6d89e4bbf23e3$export$8793edee2d425525;
    var start = $50a6d89e4bbf23e3$export$c4a223a8ba9e4ea5(element);
    var change = to - start;
    var increment = 10;
    var currentTime = 0;
    function animateScroll() {
        currentTime += increment;
        var val = $50a6d89e4bbf23e3$var$easeOutCubic(currentTime, start, change, duration);
        $50a6d89e4bbf23e3$export$3f99968195accfaf(element, val);
        if (currentTime < duration) window.requestAnimationFrame(animateScroll);
        else callback(element);
    }
    animateScroll();
}
function $50a6d89e4bbf23e3$export$53a0910f038337bd(menuEl, focusedEl) {
    var menuRect = menuEl.getBoundingClientRect();
    var focusedRect = focusedEl.getBoundingClientRect();
    var overScroll = focusedEl.offsetHeight / 3;
    if (focusedRect.bottom + overScroll > menuRect.bottom) $50a6d89e4bbf23e3$export$3f99968195accfaf(menuEl, Math.min(focusedEl.offsetTop + focusedEl.clientHeight - menuEl.offsetHeight + overScroll, menuEl.scrollHeight));
    else if (focusedRect.top - overScroll < menuRect.top) $50a6d89e4bbf23e3$export$3f99968195accfaf(menuEl, Math.max(focusedEl.offsetTop - overScroll, 0));
}
function $50a6d89e4bbf23e3$export$7807c2a424c2f6d1(element) {
    var rect = element.getBoundingClientRect();
    return {
        bottom: rect.bottom,
        height: rect.height,
        left: rect.left,
        right: rect.right,
        top: rect.top,
        width: rect.width
    };
}
function $50a6d89e4bbf23e3$export$56963d77dbffdde7() {
    try {
        document.createEvent('TouchEvent');
        return true;
    } catch (_unused) {
        return false;
    }
}
function $50a6d89e4bbf23e3$export$44f917bf91becd01() {
    try {
        return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    } catch (_unused2) {
        return false;
    }
}
// ==============================
// Passive Event Detector
// ==============================
// https://github.com/rafgraph/detect-it/blob/main/src/index.ts#L19-L36
var $50a6d89e4bbf23e3$var$passiveOptionAccessed = false;
var $50a6d89e4bbf23e3$var$options = {
    get passive () {
        return $50a6d89e4bbf23e3$var$passiveOptionAccessed = true;
    }
};
// check for SSR
var $50a6d89e4bbf23e3$var$w = typeof window !== 'undefined' ? window : {};
if ($50a6d89e4bbf23e3$var$w.addEventListener && $50a6d89e4bbf23e3$var$w.removeEventListener) {
    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
    $50a6d89e4bbf23e3$var$w.addEventListener('p', $50a6d89e4bbf23e3$export$8793edee2d425525, $50a6d89e4bbf23e3$var$options);
    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
    $50a6d89e4bbf23e3$var$w.removeEventListener('p', $50a6d89e4bbf23e3$export$8793edee2d425525, false);
}
var $50a6d89e4bbf23e3$export$b0622a6911dbeaf5 = $50a6d89e4bbf23e3$var$passiveOptionAccessed;
function $50a6d89e4bbf23e3$export$aedb69ff3e31596c(item) {
    return item != null;
}
function $50a6d89e4bbf23e3$var$isArray(arg) {
    return Array.isArray(arg);
}
function $50a6d89e4bbf23e3$export$40fb9515c784cc3b(isMulti, multiValue, singleValue) {
    return isMulti ? multiValue : singleValue;
}
function $50a6d89e4bbf23e3$export$dea4763e29237f4c(singleValue) {
    return singleValue;
}
function $50a6d89e4bbf23e3$export$d1ca752ec761b95b(multiValue) {
    return multiValue;
}
var $50a6d89e4bbf23e3$export$4213b25a1c4e877 = function removeProps(propsObj) {
    for(var _len2 = arguments.length, properties = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)properties[_key2 - 1] = arguments[_key2];
    var propsMap = Object.entries(propsObj).filter(function(_ref) {
        var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_ref, 1), key = _ref2[0];
        return !properties.includes(key);
    });
    return propsMap.reduce(function(newProps, _ref3) {
        var _ref4 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_ref3, 2), key = _ref4[0], val = _ref4[1];
        newProps[key] = val;
        return newProps;
    }, {});
};
var $50a6d89e4bbf23e3$export$bf2eda47afa5f369 = function filterUnsupportedSelectors(styles) {
    var unsupportedSelectors = [
        ':',
        // pseudo-classes/elements
        '[',
        // attribute selectors
        '>',
        // child combinator
        '+',
        // adjacent sibling combinator
        '~',
        // general sibling combinator
        ' ',
        // descendant combinator
        '*',
        // universal selector
        '#',
        // ID selector
        '.',
        // class selector
        '@',
        // at-rules
        '&',
        // parent selector
        '|',
        // namespace separator
        '^',
        // starts with
        '$',
        // ends with
        '=' // equals
    ];
    return Object.keys(styles).reduce(function(filteredStyles, key) {
        if (!unsupportedSelectors.some(function(selector) {
            return key.includes(selector);
        })) filteredStyles[key] = styles[key];
        return filteredStyles;
    }, {});
};


var $9446594a923771a0$export$949392aeaf7d2e3a = function containerCSS() {
    return {};
};
var $9446594a923771a0$var$containerStyles = {
    default: "_11c81d4k _kqswh2mm _lcxv1rj4 _1tn2fhey",
    rtl: "_1eim1xrj",
    disabled: "_80om13gf"
};
var $9446594a923771a0$export$446eebadefe1123b = function SelectContainer(props) {
    var children = props.children, innerProps = props.innerProps, isDisabled = props.isDisabled, isRtl = props.isRtl, xcss = props.xcss;
    var _getStyleProps = (0, $50a6d89e4bbf23e3$export$26417cabd806a658)(props, 'container', {
        '--is-disabled': isDisabled,
        '--is-rtl': isRtl
    }), className = _getStyleProps.className, css = _getStyleProps.css;
    return /*#__PURE__*/ $5FkrB.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $970q7.default)([
            $9446594a923771a0$var$containerStyles.default,
            isRtl && $9446594a923771a0$var$containerStyles.rtl,
            isDisabled && $9446594a923771a0$var$containerStyles.disabled,
            (0, $hUFig.cx)(className, xcss, '-container')
        ]),
        style: css
    }, innerProps), children);
};
var $9446594a923771a0$export$47aec73c7aa6b9aa = function valueContainerCSS() {
    return {};
};
var $9446594a923771a0$var$valueContainerStyles = {
    default: "_16jlkb7n _1o9zkb7n _i0dlf1ug _1reo15vq _18m915vq _4cvr1h6o _1e0c11p5 _1n261g80 _8am5i4x0 _kqswh2mm _ca0qv77o _u5f312x7 _n3tdv77o _19bv12x7",
    flex: "_1e0c1txw",
    compact: "_ca0qze3t _u5f312x7 _n3tdze3t _19bv12x7"
};
var $9446594a923771a0$export$4dc9f58ad9a1a000 = function ValueContainer(props) {
    var children = props.children, innerProps = props.innerProps, isMulti = props.isMulti, hasValue = props.hasValue, isCompact = props.isCompact, xcss = props.xcss, controlShouldRenderValue = props.selectProps.controlShouldRenderValue;
    var _getStyleProps2 = (0, $50a6d89e4bbf23e3$export$26417cabd806a658)(props, 'valueContainer', {
        'value-container': true,
        'value-container--is-multi': isMulti,
        'value-container--has-value': hasValue
    }), css = _getStyleProps2.css, className = _getStyleProps2.className;
    return /*#__PURE__*/ $5FkrB.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $970q7.default)([
            $9446594a923771a0$var$valueContainerStyles.default,
            isMulti && hasValue && controlShouldRenderValue && $9446594a923771a0$var$valueContainerStyles.flex,
            isCompact && $9446594a923771a0$var$valueContainerStyles.compact,
            (0, $hUFig.cx)(className, xcss, '-ValueContainer')
        ]),
        style: css
    }, innerProps), children);
};
var $9446594a923771a0$export$9d74e3c8b5868ad7 = function indicatorsContainerCSS() {
    return {};
};
var $9446594a923771a0$var$indicatorContainerStyles = null;
var $9446594a923771a0$export$d0ffd7e649cab6f = function IndicatorsContainer(props) {
    var children = props.children, innerProps = props.innerProps, xcss = props.xcss;
    var _getStyleProps3 = (0, $50a6d89e4bbf23e3$export$26417cabd806a658)(props, 'indicatorsContainer', {
        indicators: true
    }), css = _getStyleProps3.css, className = _getStyleProps3.className;
    return /*#__PURE__*/ $5FkrB.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        className: (0, $970q7.default)([
            "_1e0c1txw _4cvr1h6o _1o9zidpf _1wpz1fhb _y4ti1b66",
            (0, $hUFig.cx)(className, xcss, '-IndicatorsContainer')
        ])
    }, innerProps), children);
};


/* control.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $kqp0i = parcelRequire("kqp0i");

var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");

var $hUFig = parcelRequire("hUFig");

var $id6Cu = parcelRequire("id6Cu");

var $78904a7f8b3a46c8$var$styles = {
    default: "_12ji1r31 _1qu2glyw _12y3idpf _2rkofajl _v564r5cv _1h6drsbi _1dqonqa1 _189ee4h9 _4cvr1h6o _80om73ad _1e0c1txw _1n261g80 _1bah1yb4 _kqswh2mm _bfhk1j9a _1tke1ylp _1q51ze3t _y4tize3t _85i5ze3t _bozgze3t _15peftgi _1ke8ftgi _jaboglyw _1u6luvb6 _4cvxrsbi _123byq51 _d0altlke _irr3l4ek _1ogl1caj",
    defaultT26Shape: "_2rko1qi0",
    compact: "_1tkezwfg",
    invalid: "_1h6d1bqt _16qsizbr _1u6lizbr _4cvx1bqt",
    focusedInvalid: "_16qsvyy1",
    disabled: "_1h6dby5v _lcxvglyw _bfhkby5v _1u6l1s3b",
    focused: "_1h6d1v1w _bfhkr01l _16qsvyy1 _1u6lvyy1 _4cvx1v1w _irr3r01l",
    subtle: "_1h6d1j28 _bfhk1j28 _1u6l3sij",
    subtleFocused: "_bfhkvuon",
    none: "_1h6d1j28 _bfhk1j28 _1u6l3sij _4cvx1j28 _irr31j28"
};
var $78904a7f8b3a46c8$export$dbf350e5966cf602 = function css() {
    return {};
};
var $78904a7f8b3a46c8$var$Control = function Control(props) {
    var children = props.children, appearance = props.appearance, isCompact = props.isCompact, isDisabled = props.isDisabled, isFocused = props.isFocused, isInvalid = props.isInvalid, innerRef = props.innerRef, innerProps = props.innerProps, menuIsOpen = props.menuIsOpen, xcss = props.xcss;
    var _getStyleProps = (0, $50a6d89e4bbf23e3$export$26417cabd806a658)(props, 'control', {
        control: true,
        'control--is-disabled': isDisabled,
        'control--is-focused': isFocused,
        'control--menu-is-open': menuIsOpen
    }), css = _getStyleProps.css, className = _getStyleProps.className;
    return /*#__PURE__*/ $5FkrB.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        ref: innerRef,
        className: (0, $970q7.default)([
            $78904a7f8b3a46c8$var$styles.default,
            (0, $id6Cu.fg)('platform-dst-shape-theme-default') && $78904a7f8b3a46c8$var$styles.defaultT26Shape,
            isDisabled && $78904a7f8b3a46c8$var$styles.disabled,
            isInvalid && $78904a7f8b3a46c8$var$styles.invalid,
            isCompact && $78904a7f8b3a46c8$var$styles.compact,
            appearance === 'subtle' && $78904a7f8b3a46c8$var$styles.subtle,
            appearance === 'subtle' && isFocused && $78904a7f8b3a46c8$var$styles.subtleFocused,
            isFocused && $78904a7f8b3a46c8$var$styles.focused,
            appearance === 'none' && $78904a7f8b3a46c8$var$styles.none,
            (0, $hUFig.cx)(className, xcss, '-control')
        ]),
        style: css
    }, innerProps, {
        "aria-disabled": isDisabled || undefined
    }), children);
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$78904a7f8b3a46c8$export$2e2bcd8739ae039 = $78904a7f8b3a46c8$var$Control;


/* group.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $1Vcia = parcelRequire("1Vcia");

var $kqp0i = parcelRequire("kqp0i");

var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");

var $hUFig = parcelRequire("hUFig");

var $91520e83acff37b7$var$_excluded = [
    "data"
];
var $91520e83acff37b7$var$styles = {
    root: "_n3tdu2gc _ca0qu2gc"
};
var $91520e83acff37b7$export$b6794329c1460634 = function groupCSS() {
    return {};
};
var $91520e83acff37b7$var$Group = function Group(props) {
    var children = props.children, builtinCX = props.cx, getStyles = props.getStyles, getClassNames = props.getClassNames, Heading = props.Heading, headingProps = props.headingProps, innerProps = props.innerProps, label = props.label, selectProps = props.selectProps, xcss = props.xcss;
    var _getStyleProps = (0, $50a6d89e4bbf23e3$export$26417cabd806a658)(props, 'group', {
        group: true
    }), css = _getStyleProps.css, className = _getStyleProps.className;
    return /*#__PURE__*/ $5FkrB.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css
    }, innerProps, {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $970q7.default)([
            $91520e83acff37b7$var$styles.root,
            (0, $hUFig.cx)(className, xcss, innerProps === null || innerProps === void 0 ? void 0 : innerProps.className, '-Group')
        ])
    }), label && /*#__PURE__*/ $5FkrB.createElement(Heading, (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, headingProps, {
        selectProps: selectProps,
        getStyles: getStyles,
        getClassNames: getClassNames,
        cx: builtinCX
    }), label), /*#__PURE__*/ $5FkrB.createElement("div", null, children));
};
var $91520e83acff37b7$var$headingStyles = null;
var $91520e83acff37b7$export$e5a7fbb542efcb7d = function groupHeadingCSS() {
    return {};
};
var $91520e83acff37b7$export$85c8b41a3cd87edc = function GroupHeading(props) {
    var xcss = props.xcss;
    var _cleanCommonProps = (0, $50a6d89e4bbf23e3$export$8e9fd4287627890c)(props), data = _cleanCommonProps.data, innerProps = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_cleanCommonProps, $91520e83acff37b7$var$_excluded);
    var _getStyleProps2 = (0, $50a6d89e4bbf23e3$export$26417cabd806a658)(props, 'groupHeading', {
        'group-heading': true
    }), css = _getStyleProps2.css, className = _getStyleProps2.className;
    return /*#__PURE__*/ $5FkrB.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $970q7.default)([
            "_11c8wadc _1e0c1ule _syazazsu _80om73ad _k48pwu06 _6rthpd1z _y4tiutpp _bozgutpp _1p1dglyw",
            (0, $hUFig.cx)(className, xcss, '-group')
        ]),
        style: css
    }, innerProps));
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$91520e83acff37b7$export$2e2bcd8739ae039 = $91520e83acff37b7$var$Group;


/* indicators.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $25nEq = parcelRequire("25nEq");

var $1Vcia = parcelRequire("1Vcia");

var $kqp0i = parcelRequire("kqp0i");

var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");

var $hUFig = parcelRequire("hUFig");
var $6f037d10bfb6391b$exports = {};
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d56e8662eb8a8d2462ec3a39ff3aa40b>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty($6f037d10bfb6391b$exports, "__esModule", {
    value: true
});
$6f037d10bfb6391b$exports.default = void 0;

var $6f037d10bfb6391b$var$_react = $6f037d10bfb6391b$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $6f037d10bfb6391b$var$_baseNew = $6f037d10bfb6391b$var$_interopRequireDefault((parcelRequire("lw4o3")));
function $6f037d10bfb6391b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ChevronDown".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Do not use 16px chevrons within buttons, icon buttons, or dropdowns to maintain visual cohesion with ADS which uses 12px chevrons.
Known uses: Open dropdown menu, expanded tree item, collapse tree item
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $6f037d10bfb6391b$var$ChevronDownIcon = (props)=>/*#__PURE__*/ $6f037d10bfb6391b$var$_react.default.createElement($6f037d10bfb6391b$var$_baseNew.default, Object.assign({
        name: "ChevronDownIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="m14.53 6.03-6 6a.75.75 0 0 1-1.004.052l-.056-.052-6-6 1.06-1.06L8 10.44l5.47-5.47z"/>`
    }, props));
$6f037d10bfb6391b$var$ChevronDownIcon.displayName = 'ChevronDownIcon';
var $6f037d10bfb6391b$var$_default = $6f037d10bfb6391b$exports.default = $6f037d10bfb6391b$var$ChevronDownIcon;


var $bc007dd19254a111$exports = {};
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3eb90e0e095210547df6d71f04e27a56>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty($bc007dd19254a111$exports, "__esModule", {
    value: true
});
$bc007dd19254a111$exports.default = void 0;

var $bc007dd19254a111$var$_react = $bc007dd19254a111$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $bc007dd19254a111$var$_baseNew = $bc007dd19254a111$var$_interopRequireDefault((parcelRequire("lw4o3")));
function $bc007dd19254a111$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "CrossCircle".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: clear text field, error status.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $bc007dd19254a111$var$CrossCircleIcon = (props)=>/*#__PURE__*/ $bc007dd19254a111$var$_react.default.createElement($bc007dd19254a111$var$_baseNew.default, Object.assign({
        name: "CrossCircleIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0m4.03 5.03L9.06 8l2.97 2.97-1.06 1.06L8 9.06l-2.97 2.97-1.06-1.06L6.94 8 3.97 5.03l1.06-1.06L8 6.94l2.97-2.97z" clip-rule="evenodd"/>`
    }, props));
$bc007dd19254a111$var$CrossCircleIcon.displayName = 'CrossCircleIcon';
var $bc007dd19254a111$var$_default = $bc007dd19254a111$exports.default = $bc007dd19254a111$var$CrossCircleIcon;


/* inline.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $kqp0i = parcelRequire("kqp0i");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");

/* flex.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $kqp0i = parcelRequire("kqp0i");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");
var $aec1a0883338d612$var$_excluded = [
    "as",
    "role",
    "alignItems",
    "justifyContent",
    "gap",
    "columnGap",
    "rowGap",
    "children",
    "testId",
    "direction",
    "wrap",
    "xcss"
];
var $aec1a0883338d612$var$rowGapMap = {
    'space.0': "_1p57ze3t",
    'space.025': "_1p57v77o",
    'space.050': "_1p571b66",
    'space.075': "_1p5712x7",
    'space.100': "_1p57u2gc",
    'space.150': "_1p57utpp",
    'space.200': "_1p57pxbi",
    'space.250': "_1p57v47k",
    'space.300': "_1p571ejb",
    'space.400': "_1p57xy5q",
    'space.500': "_1p571jfw",
    'space.600': "_1p57oahv",
    'space.800': "_1p57xncg",
    'space.1000': "_1p571epz"
};
var $aec1a0883338d612$var$columnGapMap = {
    'space.0': "_gy1pze3t",
    'space.025': "_gy1pv77o",
    'space.050': "_gy1p1b66",
    'space.075': "_gy1p12x7",
    'space.100': "_gy1pu2gc",
    'space.150': "_gy1putpp",
    'space.200': "_gy1ppxbi",
    'space.250': "_gy1pv47k",
    'space.300': "_gy1p1ejb",
    'space.400': "_gy1pxy5q",
    'space.500': "_gy1p1jfw",
    'space.600': "_gy1poahv",
    'space.800': "_gy1pxncg",
    'space.1000': "_gy1p1epz"
};
var $aec1a0883338d612$var$justifyContentMap = {
    start: "_1bahv2br",
    center: "_1bah1h6o",
    end: "_1bahh9n0",
    'space-between': "_1bah1yb4",
    'space-around': "_1bah1b1v",
    'space-evenly': "_1bahitcz",
    stretch: "_1bah1fhb"
};
var $aec1a0883338d612$var$flexDirectionMap = {
    column: "_2lx21bp4",
    row: "_2lx2vrvc"
};
var $aec1a0883338d612$var$flexWrapMap = {
    wrap: "_1n261g80",
    nowrap: "_1n261q9c"
};
var $aec1a0883338d612$var$alignItemsMap = {
    start: "_4cvrv2br",
    center: "_4cvr1h6o",
    baseline: "_4cvr1q9y",
    end: "_4cvrh9n0",
    stretch: "_4cvr1fhb"
};
var $aec1a0883338d612$var$styles = {
    root: "_1e0c1txw _vchhusvi"
};
/**
 * __Flex__
 *
 * `Flex` is a primitive component that implements the CSS Flexbox API.
 *
 * - [Examples](https://atlassian.design/components/primitives/flex/examples)
 * - [Code](https://atlassian.design/components/primitives/flex/code)
 *
 * @example
 * ```tsx
 * // eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
 * import { Flex, Box } from '@atlaskit/primitives'
 *
 * const Component = () => (
 *   <Flex direction="column">
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *   </Flex>
 * )
 * ```
 */ var $aec1a0883338d612$var$Flex = /*#__PURE__*/ (0, $5FkrB.memo)(/*#__PURE__*/ (0, $5FkrB.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? 'div' : _ref$as, role = _ref.role, alignItems = _ref.alignItems, justifyContent = _ref.justifyContent, gap = _ref.gap, columnGap = _ref.columnGap, rowGap = _ref.rowGap, children = _ref.children, testId = _ref.testId, direction = _ref.direction, wrap = _ref.wrap, xcss = _ref.xcss, ariaAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $aec1a0883338d612$var$_excluded);
    return /*#__PURE__*/ $5FkrB.createElement(Component, (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, ariaAttributes, {
        role: role,
        className: (0, $970q7.default)([
            $aec1a0883338d612$var$styles.root,
            gap && $aec1a0883338d612$var$columnGapMap[gap],
            columnGap && $aec1a0883338d612$var$columnGapMap[columnGap],
            gap && $aec1a0883338d612$var$rowGapMap[gap],
            rowGap && $aec1a0883338d612$var$rowGapMap[rowGap],
            alignItems && $aec1a0883338d612$var$alignItemsMap[alignItems],
            direction && $aec1a0883338d612$var$flexDirectionMap[direction],
            justifyContent && $aec1a0883338d612$var$justifyContentMap[justifyContent],
            wrap && $aec1a0883338d612$var$flexWrapMap[wrap],
            xcss
        ]),
        "data-testid": testId,
        ref: ref
    }), children);
}));
$aec1a0883338d612$var$Flex.displayName = 'Flex';
var $aec1a0883338d612$export$2e2bcd8739ae039 = $aec1a0883338d612$var$Flex;


var $d3ef6ecc8cb0136a$var$_excluded = [
    "as",
    "alignInline",
    "alignBlock",
    "shouldWrap",
    "spread",
    "grow",
    "space",
    "rowSpace",
    "separator",
    "xcss",
    "testId",
    "role",
    "children"
];
var $d3ef6ecc8cb0136a$var$styles = {
    separator: "_1mouze3t _195g1i6y _syazjjyb _lcxvglyw _uiztglyw",
    hug: "_16jlidpf",
    fill: "_1bsb1osq _16jlkb7n"
};
var $d3ef6ecc8cb0136a$var$Separator = function Separator(_ref) {
    var children = _ref.children;
    return /*#__PURE__*/ $5FkrB.createElement("span", {
        className: (0, $970q7.default)([
            $d3ef6ecc8cb0136a$var$styles.separator
        ])
    }, children);
};
/**
 * __Inline__
 *
 * Inline is a primitive component based on CSS Flexbox that manages the horizontal layout of direct children.
 *
 * @example
 * ```tsx
 *  <Inline>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *  </Inline>
 * ```
 *
 */ var $d3ef6ecc8cb0136a$var$Inline = /*#__PURE__*/ (0, $5FkrB.memo)(/*#__PURE__*/ (0, $5FkrB.forwardRef)(function(_ref2, ref) {
    var as = _ref2.as, alignInline = _ref2.alignInline, _ref2$alignBlock = _ref2.alignBlock, alignItems = _ref2$alignBlock === void 0 ? 'start' : _ref2$alignBlock, _ref2$shouldWrap = _ref2.shouldWrap, shouldWrap = _ref2$shouldWrap === void 0 ? false : _ref2$shouldWrap, spread = _ref2.spread, grow = _ref2.grow, space = _ref2.space, rowSpace = _ref2.rowSpace, separator = _ref2.separator, xcss = _ref2.xcss, testId = _ref2.testId, role = _ref2.role, rawChildren = _ref2.children, ariaAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref2, $d3ef6ecc8cb0136a$var$_excluded);
    var separatorComponent = typeof separator === 'string' ? /*#__PURE__*/ $5FkrB.createElement($d3ef6ecc8cb0136a$var$Separator, null, separator) : separator;
    var children = separatorComponent ? (0, $5FkrB.Children).toArray(rawChildren).filter(Boolean).map(function(child, index) {
        return /*#__PURE__*/ $5FkrB.createElement((0, $5FkrB.Fragment), {
            key: index
        }, separator && index > 0 ? separatorComponent : null, child);
    }) : rawChildren;
    return /*#__PURE__*/ $5FkrB.createElement((0, $aec1a0883338d612$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, ariaAttributes, {
        as: as,
        role: role,
        alignItems: alignItems,
        justifyContent: spread || alignInline,
        direction: "row",
        gap: space,
        rowGap: rowSpace,
        wrap: shouldWrap ? 'wrap' : undefined,
        xcss: (0, $8d759d8816b1f54f$export$a274e22fb40f762e)(grow === 'hug' && $d3ef6ecc8cb0136a$var$styles.hug, grow === 'fill' && $d3ef6ecc8cb0136a$var$styles.fill, xcss),
        testId: testId,
        ref: ref
    }), children);
}));
$d3ef6ecc8cb0136a$var$Inline.displayName = 'Inline';
var $d3ef6ecc8cb0136a$export$2e2bcd8739ae039 = $d3ef6ecc8cb0136a$var$Inline;

/* pressable.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $kqp0i = parcelRequire("kqp0i");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");


var $hUFig = parcelRequire("hUFig");

var $25nEq = parcelRequire("25nEq");

var $5FkrB = parcelRequire("5FkrB");

var $dLGML = parcelRequire("dLGML");

var $fC8ib = parcelRequire("fC8ib");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $kIXpt = parcelRequire("kIXpt");

var $cYPzS = parcelRequire("cYPzS");

var $lwlXp = parcelRequire("lwlXp");

var $eyuDe = parcelRequire("eyuDe");

var $25nEq = parcelRequire("25nEq");

var $ekGgq = parcelRequire("ekGgq");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $25nEq = parcelRequire("25nEq");
function $5ed6587d1229d187$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $5ed6587d1229d187$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $5ed6587d1229d187$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $5ed6587d1229d187$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $5ed6587d1229d187$export$ad4be5c2ec28cecf = function isAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $5ed6587d1229d187$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === 'AnalyticsEvent';
};
var $5ed6587d1229d187$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function AnalyticsEvent(props) {
        var _this = this;
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, AnalyticsEvent);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "_isAnalyticsEvent", true);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "clone", function() {
            // just a shallow clone, don't change sub refs unless you want to
            // affect the original's too
            var payload = $5ed6587d1229d187$var$_objectSpread({}, _this.payload);
            return new AnalyticsEvent({
                payload: payload
            });
        });
        this.payload = props.payload;
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(AnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (typeof updater === 'function') this.payload = updater(this.payload);
                if ((0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(updater) === 'object') this.payload = $5ed6587d1229d187$var$_objectSpread($5ed6587d1229d187$var$_objectSpread({}, this.payload), updater);
                return this;
            }
        }
    ]);
}();


function $1548e1c8fd3d7571$var$_callSuper(t, o, e) {
    return o = (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(o), (0, (/*@__PURE__*/$parcel$interopDefault($kIXpt)))(t, $1548e1c8fd3d7571$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(t).constructor) : o.apply(t, e));
}
function $1548e1c8fd3d7571$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($1548e1c8fd3d7571$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $1548e1c8fd3d7571$var$_superPropGet(t, o, e, r) {
    var p = (0, (/*@__PURE__*/$parcel$interopDefault($lwlXp)))((0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(1 & r ? t.prototype : t), o, e);
    return 2 & r && "function" == typeof p ? function(t) {
        return p.apply(e, t);
    } : p;
}
var $1548e1c8fd3d7571$export$35f8383928ba8d7 = function isUIAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $1548e1c8fd3d7571$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isUIAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === 'UIAnalyticsEvent';
};
var $1548e1c8fd3d7571$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_AnalyticsEvent) {
    function UIAnalyticsEvent(props) {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, UIAnalyticsEvent);
        _this = $1548e1c8fd3d7571$var$_callSuper(this, UIAnalyticsEvent, [
            props
        ]);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "_isUIAnalyticsEvent", true);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "clone", function() {
            if (_this.hasFired) return null;
            var context = (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(_this.context);
            var handlers = (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(_this.handlers);
            /**
       * A hacky "deep clone" of the object. This is limited in that it wont
       * support functions, regexs, Maps, Sets, etc, but none of those need to
       * be represented in our payload.
       */ var payload = JSON.parse(JSON.stringify(_this.payload));
            return new UIAnalyticsEvent({
                context: context,
                handlers: handlers,
                payload: payload
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "fire", function(channel) {
            if (_this.hasFired) return;
            _this.handlers.forEach(function(handler) {
                return handler(_this, channel);
            });
            _this.hasFired = true;
        });
        _this.context = props.context || [];
        _this.handlers = props.handlers || [];
        _this.hasFired = false;
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($eyuDe)))(UIAnalyticsEvent, _AnalyticsEvent);
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(UIAnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (this.hasFired) return this;
                return $1548e1c8fd3d7571$var$_superPropGet(UIAnalyticsEvent, "update", this, 3)([
                    updater
                ]);
            }
        }
    ]);
}((0, $5ed6587d1229d187$export$2e2bcd8739ae039));



var $5FkrB = parcelRequire("5FkrB");

var $iyyOp = parcelRequire("iyyOp");
var $401a65fe0e86e14c$export$d1f587f82ad51c4 = function useAnalyticsContext() {
    return (0, $5FkrB.useContext)((0, $iyyOp.default));
};


function $beb7a8b3094b2462$export$5bf35293e545f20c() {
    var analyticsContext = (0, $401a65fe0e86e14c$export$d1f587f82ad51c4)();
    var createAnalyticsEvent = (0, $dLGML.useCallbackOne)(function(payload) {
        return new (0, $1548e1c8fd3d7571$export$2e2bcd8739ae039)({
            context: analyticsContext.getAtlaskitAnalyticsContext(),
            handlers: analyticsContext.getAtlaskitAnalyticsEventHandlers(),
            payload: payload
        });
    }, [
        analyticsContext
    ]);
    return {
        createAnalyticsEvent: createAnalyticsEvent
    };
}



var $5FkrB = parcelRequire("5FkrB");
var $c9ded1a74a58ff2f$export$1d27a74659855e44 = function useTrackedRef(value) {
    var ref = (0, $5FkrB.useRef)(value);
    ref.current = value;
    return ref;
};


function $e45e91c49e50716d$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $e45e91c49e50716d$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $e45e91c49e50716d$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $e45e91c49e50716d$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $e45e91c49e50716d$export$a4687b0234b40e28(_ref) {
    var fn = _ref.fn, action = _ref.action, componentName = _ref.componentName, actionSubject = _ref.actionSubject, packageName = _ref.packageName, packageVersion = _ref.packageVersion, analyticsData = _ref.analyticsData;
    var _useAnalyticsEvents = (0, $beb7a8b3094b2462$export$5bf35293e545f20c)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
    // We put analyticsData and fn in a ref so that we don't need to break
    // memoization.
    // Generally these could be defined by consumers inline
    // and so we do this to avoid breaking memoization of useCallback
    var dataRef = (0, $c9ded1a74a58ff2f$export$1d27a74659855e44)(analyticsData);
    var fnRef = (0, $c9ded1a74a58ff2f$export$1d27a74659855e44)(fn);
    var handler = (0, $5FkrB.useCallback)(function(value) {
        var analyticsEvent = createAnalyticsEvent({
            action: action,
            actionSubject: actionSubject || componentName,
            attributes: {
                componentName: componentName,
                packageName: packageName,
                packageVersion: packageVersion
            }
        });
        // To avoid wrapping this component in AnalyticsContext we manually
        // push the parent context's meta data into the context.
        // Note: this new 'context'
        var context = $e45e91c49e50716d$var$_objectSpread({
            componentName: componentName,
            packageName: packageName,
            packageVersion: packageVersion
        }, dataRef.current);
        analyticsEvent.context.push(context);
        // fire an event on the atlaskit channel
        var clone = analyticsEvent.clone();
        if (clone) clone.fire('atlaskit');
        fnRef.current(value, analyticsEvent);
    }, [
        // These are strings and won't change
        action,
        componentName,
        actionSubject,
        packageName,
        packageVersion,
        // This function is memoized in the context
        createAnalyticsEvent,
        // these are a stable ref because of the useTrackedRef hook
        dataRef,
        fnRef
    ]);
    return handler;
}



var $dJ32z = parcelRequire("dJ32z");

var $eVb4V = parcelRequire("eVb4V");

var $eqVaP = parcelRequire("eqVaP");
/* focusable.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $kqp0i = parcelRequire("kqp0i");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");
var $d8b833421e7e9160$var$_excluded = [
    "as",
    "children",
    "isInset",
    "testId",
    "style",
    "xcss"
], $d8b833421e7e9160$var$_excluded2 = [
    "className"
];
var $d8b833421e7e9160$var$focusRingStyles = null;
var $d8b833421e7e9160$var$insetFocusRingStyles = null;
/**
 * __Focus ring__
 *
 * A focus ring visually indicates the currently focused item.
 *
 */ var $d8b833421e7e9160$var$Focusable = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? 'button' : _ref$as, children = _ref.children, isInset = _ref.isInset, testId = _ref.testId, style = _ref.style, xcss = _ref.xcss, htmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $d8b833421e7e9160$var$_excluded);
    // This is to remove className from safeHtmlAttributes
    // @ts-ignore -- not using expect since it causes issues with help-center local consumption - className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(htmlAttributes, $d8b833421e7e9160$var$_excluded2);
    return /*#__PURE__*/ $5FkrB.createElement(Component, (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, safeHtmlAttributes, {
        // @ts-ignore Expression produces a union type that is too complex to represent. We may be able to narrow the type here but unsure.
        ref: ref,
        className: (0, $970q7.default)([
            "_ymio1r31 _ypr0glyw _zcxs1o36 _mizu194a _1ah3dkaa _ra3xnqa1 _128mdkaa _1cvmnqa1 _4davt94y",
            isInset && "_1ah31gjf _2mwq1gjf",
            xcss
        ]),
        style: style,
        "data-testid": testId
    }), children);
});
var $d8b833421e7e9160$export$2e2bcd8739ae039 = $d8b833421e7e9160$var$Focusable;


var $5903433786f54b21$var$_excluded = [
    "children",
    "isDisabled",
    "type",
    "onClick",
    "interactionName",
    "componentName",
    "analyticsContext",
    "style",
    "testId",
    "xcss",
    "tabIndex"
], $5903433786f54b21$var$_excluded2 = [
    "className"
];
var $5903433786f54b21$var$styles = {
    root: "_19itglyw _vchhusvi _r06hglyw _80omtlke",
    disabled: "_80om13gf"
};
/**
 * __Pressable__
 *
 * A primitive for building custom buttons.
 *
 * - [Examples](https://atlassian.design/components/primitives/pressable/examples)
 * - [Code](https://atlassian.design/components/primitives/pressable/code)
 * - [Usage](https://atlassian.design/components/primitives/pressable/usage)
 */ var $5903433786f54b21$var$Pressable = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function(_ref, ref) {
    var children = _ref.children, isDisabled = _ref.isDisabled, _ref$type = _ref.type, type = _ref$type === void 0 ? 'button' : _ref$type, _ref$onClick = _ref.onClick, providedOnClick = _ref$onClick === void 0 ? (0, $eVb4V.default) : _ref$onClick, interactionName = _ref.interactionName, componentName = _ref.componentName, analyticsContext = _ref.analyticsContext, style = _ref.style, testId = _ref.testId, xcss = _ref.xcss, tabIndex = _ref.tabIndex, htmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $5903433786f54b21$var$_excluded);
    var interactionContext = (0, $5FkrB.useContext)((0, $eqVaP.default));
    var handleClick = (0, $5FkrB.useCallback)(function(e, analyticsEvent) {
        interactionContext && interactionContext.tracePress(interactionName, e.timeStamp);
        providedOnClick(e, analyticsEvent);
    }, [
        providedOnClick,
        interactionContext,
        interactionName
    ]);
    var onClick = (0, $e45e91c49e50716d$export$a4687b0234b40e28)({
        fn: handleClick,
        action: 'clicked',
        componentName: componentName || 'Pressable',
        packageName: "@atlaskit/primitives",
        packageVersion: "17.1.0",
        analyticsData: analyticsContext,
        actionSubject: 'button'
    });
    // This is to remove className from safeHtmlAttributes
    // @ts-expect-error className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(htmlAttributes, $5903433786f54b21$var$_excluded2);
    return /*#__PURE__*/ $5FkrB.createElement((0, $d8b833421e7e9160$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        as: "button",
        tabIndex: tabIndex !== null && tabIndex !== void 0 ? tabIndex : (0, $dJ32z.isSafari)() && !isDisabled ? 0 : undefined,
        style: style
    }, safeHtmlAttributes, {
        type: type,
        onClick: onClick,
        disabled: isDisabled,
        xcss: (0, $hUFig.cx)($5903433786f54b21$var$styles.root, isDisabled && $5903433786f54b21$var$styles.disabled, xcss),
        testId: testId,
        ref: ref
    }), children);
});
var $5903433786f54b21$export$2e2bcd8739ae039 = $5903433786f54b21$var$Pressable;


/* spinner.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $970q7 = parcelRequire("970q7");

var $5FkrB = parcelRequire("5FkrB");

var $eqVaP = parcelRequire("eqVaP");
// Reds
var $0e66d7748c04bcf9$export$4b84fd0e2c617bd = '#FFEBE6';
var $0e66d7748c04bcf9$export$b34b069eff244586 = '#FFBDAD';
var $0e66d7748c04bcf9$export$be802dd0d8b57f35 = '#FF8F73';
var $0e66d7748c04bcf9$export$60847d42f9da92a6 = '#FF7452';
var $0e66d7748c04bcf9$export$4a7404f376229999 = '#FF5630';
var $0e66d7748c04bcf9$export$2010d0fb4295b346 = '#DE350B';
var $0e66d7748c04bcf9$export$2837b5a1a71d5c02 = '#BF2600';
var $0e66d7748c04bcf9$export$8d9596b529bbb9cf = '#FFFAE6';
var $0e66d7748c04bcf9$export$41060a744ab0b7ae = '#FFF0B3';
var $0e66d7748c04bcf9$export$1cc05bbbf340e559 = '#FFE380';
var $0e66d7748c04bcf9$export$5aae31392d72caaa = '#FFC400';
var $0e66d7748c04bcf9$export$c6930421db9fa514 = '#FFAB00';
var $0e66d7748c04bcf9$export$59619663aa6500fb = '#FF991F';
var $0e66d7748c04bcf9$export$874739ea9e379ab6 = '#FF8B00';
var $0e66d7748c04bcf9$export$8a6341c32b6a3ee6 = '#E3FCEF';
var $0e66d7748c04bcf9$export$69a3bf21b9686c2b = '#ABF5D1';
var $0e66d7748c04bcf9$export$afbce1382ec95f73 = '#79F2C0';
var $0e66d7748c04bcf9$export$747d86715d4175de = '#57D9A3';
var $0e66d7748c04bcf9$export$940e1f69e873f202 = '#36B37E';
var $0e66d7748c04bcf9$export$a49394138f7b8e85 = '#00875A';
var $0e66d7748c04bcf9$export$6fa04827ac68a4fb = '#006644';
var $0e66d7748c04bcf9$export$226de0355ed012f8 = '#DEEBFF';
var $0e66d7748c04bcf9$export$8c13c2ee36917869 = '#B3D4FF';
var $0e66d7748c04bcf9$export$ecfc1dff386a3e7a = '#4C9AFF';
var $0e66d7748c04bcf9$export$215b7063051591f1 = '#2684FF';
var $0e66d7748c04bcf9$export$e62e8919cca44969 = '#0065FF';
var $0e66d7748c04bcf9$export$b3de0ae08da2ce64 = '#0052CC';
var $0e66d7748c04bcf9$export$a6ee3d71bc067634 = '#0747A6';
var $0e66d7748c04bcf9$export$67f15409e87642a1 = '#669DF1';
var $0e66d7748c04bcf9$export$f0539dbc42dbb067 = '#8FB8F6';
var $0e66d7748c04bcf9$export$363e4475840015bb = '#EAE6FF';
var $0e66d7748c04bcf9$export$4b0a4417ed59760f = '#C0B6F2';
var $0e66d7748c04bcf9$export$6011520a64d9a187 = '#998DD9';
var $0e66d7748c04bcf9$export$a7175d4e9206bc80 = '#8777D9';
var $0e66d7748c04bcf9$export$b48405b95304b5a1 = '#6554C0';
var $0e66d7748c04bcf9$export$c71e4279dd54a18d = '#5243AA';
var $0e66d7748c04bcf9$export$147899de772240ec = '#403294';
var $0e66d7748c04bcf9$export$2cf711fe14c66f06 = '#E6FCFF';
var $0e66d7748c04bcf9$export$7a8f4d33f6f9772c = '#B3F5FF';
var $0e66d7748c04bcf9$export$776c9c497ef08533 = '#79E2F2';
var $0e66d7748c04bcf9$export$69cb3ca10c1e330e = '#00C7E6';
var $0e66d7748c04bcf9$export$9dc1ef0f3f48059b = '#00B8D9';
var $0e66d7748c04bcf9$export$7c835c78b6fcdef8 = '#00A3BF';
var $0e66d7748c04bcf9$export$6036577f95c3877e = '#008DA6';
var $0e66d7748c04bcf9$export$29a4f05edc054374 = '#FFFFFF';
var $0e66d7748c04bcf9$export$e655ef011c4aa1a2 = '#FAFBFC';
var $0e66d7748c04bcf9$export$9fdfb749e33cdf97 = '#F4F5F7';
var $0e66d7748c04bcf9$export$3e51e8f1440314ba = '#EBECF0';
var $0e66d7748c04bcf9$export$1ce2d1575d444ceb = '#DFE1E6';
var $0e66d7748c04bcf9$export$8754fc7e6d8b3000 = '#C1C7D0';
var $0e66d7748c04bcf9$export$c2e91cbeada39b8b = '#B3BAC5';
var $0e66d7748c04bcf9$export$5f71e19f3a7ad9de = '#A5ADBA';
var $0e66d7748c04bcf9$export$eaa8c8a70ac22806 = '#97A0AF';
var $0e66d7748c04bcf9$export$7c87d337fb91a97d = '#8993A4';
var $0e66d7748c04bcf9$export$d6447c357493214f = '#7A869A';
var $0e66d7748c04bcf9$export$f563ee71e9ee74cd = '#6B778C';
var $0e66d7748c04bcf9$export$e2ef2124cf4024b1 = '#5E6C84';
var $0e66d7748c04bcf9$export$eece5f492e429f08 = '#505F79';
var $0e66d7748c04bcf9$export$c39c0fe0f26207ae = '#42526E';
var $0e66d7748c04bcf9$export$7090862dc3038a9f = '#344563';
var $0e66d7748c04bcf9$export$ad0bacf983b7ddaa = '#253858';
var $0e66d7748c04bcf9$export$7d61b15e0da132af = '#172B4D';
var $0e66d7748c04bcf9$export$fbda843f0a27fe96 = '#091E42';
var $0e66d7748c04bcf9$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
var $0e66d7748c04bcf9$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
var $0e66d7748c04bcf9$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
var $0e66d7748c04bcf9$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
var $0e66d7748c04bcf9$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
var $0e66d7748c04bcf9$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
var $0e66d7748c04bcf9$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
var $0e66d7748c04bcf9$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
var $0e66d7748c04bcf9$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
var $0e66d7748c04bcf9$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
var $0e66d7748c04bcf9$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
var $0e66d7748c04bcf9$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
var $0e66d7748c04bcf9$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
var $0e66d7748c04bcf9$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
var $0e66d7748c04bcf9$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
var $0e66d7748c04bcf9$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
var $0e66d7748c04bcf9$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
var $0e66d7748c04bcf9$export$2f6319cf7d736c2a = '#E6EDFA';
var $0e66d7748c04bcf9$export$95126bc8884d6634 = '#DCE5F5';
var $0e66d7748c04bcf9$export$8338d8c35d44ff1 = '#CED9EB';
var $0e66d7748c04bcf9$export$5368d76ae4fbbda7 = '#B8C7E0';
var $0e66d7748c04bcf9$export$9f0a771d16ec8d36 = '#ABBBD6';
var $0e66d7748c04bcf9$export$abcf8c38338b4aa5 = '#9FB0CC';
var $0e66d7748c04bcf9$export$97e81faa16a182c7 = '#8C9CB8';
var $0e66d7748c04bcf9$export$bfe21c59123ecf33 = '#7988A3';
var $0e66d7748c04bcf9$export$ee82aa2ea6a1558 = '#67758F';
var $0e66d7748c04bcf9$export$682927c6ed76be02 = '#56637A';
var $0e66d7748c04bcf9$export$91fd9994c5be9757 = '#455166';
var $0e66d7748c04bcf9$export$d281fbfe3cff2df6 = '#3B475C';
var $0e66d7748c04bcf9$export$3902c91d8b98a753 = '#313D52';
var $0e66d7748c04bcf9$export$8e8133c1ba5845b5 = '#283447';
var $0e66d7748c04bcf9$export$33ff357f6620b39 = '#202B3D';
var $0e66d7748c04bcf9$export$633847cf062b69e0 = '#1B2638';
var $0e66d7748c04bcf9$export$9776a6e503bdbf76 = '#121A29';
var $0e66d7748c04bcf9$export$6c813d5160dff5db = '#0E1624';
var $0e66d7748c04bcf9$export$3d4f271a500072a = '#0D1424';
var $0e66d7748c04bcf9$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
var $0e66d7748c04bcf9$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
var $0e66d7748c04bcf9$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
var $0e66d7748c04bcf9$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
var $0e66d7748c04bcf9$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
var $0e66d7748c04bcf9$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
var $0e66d7748c04bcf9$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
var $0e66d7748c04bcf9$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
var $0e66d7748c04bcf9$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
var $0e66d7748c04bcf9$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
var $0e66d7748c04bcf9$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
var $0e66d7748c04bcf9$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
var $0e66d7748c04bcf9$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
var $0e66d7748c04bcf9$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
var $0e66d7748c04bcf9$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
var $0e66d7748c04bcf9$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
var $0e66d7748c04bcf9$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';
var $0e66d7748c04bcf9$export$d2adc5dedf09fced = '#292A2E';
var $0e66d7748c04bcf9$export$f51762073d2bb381 = '#94C748';
var $0e66d7748c04bcf9$export$95e26d54def96891 = '#B3DF72';


var $a0d46f428acbaca2$export$4e9f1640bbe7a1a8 = {
    xsmall: 12,
    small: 16,
    medium: 24,
    large: 48,
    xlarge: 96
};


/**
 * Returns the appropriate circle stroke color.
 */ function $b0f7c2e98ac6f7bd$var$getStrokeColor(appearance) {
    return appearance === 'inherit' ? "var(--ds-icon-subtle, ".concat((0, $0e66d7748c04bcf9$export$c39c0fe0f26207ae), ")") : "var(--ds-icon-inverse, ".concat((0, $0e66d7748c04bcf9$export$29a4f05edc054374), ")");
}
var $b0f7c2e98ac6f7bd$var$rotate = null;
/**
 * There are three parts to the load in animation:
 * 1. Accelerated spin
 * 2. Stretch the spinner line
 */ var $b0f7c2e98ac6f7bd$var$loadIn = null;
var $b0f7c2e98ac6f7bd$var$styles = {
    rotateStyles: "_j7hqsf8s _5sag12kz _tip812c5 _1pgl2qsq _8hrz1h6o",
    loadInStyles: "_j7hq1ky6 _5sag9cwz _1pgl1ytf _1o51q7pw",
    wrapperStyles: "_1e0c116y _s7n4nkob",
    circleStyles: "_lswuglyw _7ljx1dhp _1snbbs82 _jcxd7g3v _1tjm1onz"
};
/**
 * `useLayoutEffect` is being used in SSR safe form. On the server, this work doesn’t need to run.
 * `useEffect` is used in-place, because `useEffect` is not run on the server and it matches types
 * which makes things simpler than doing an `isServer` check or a `null` check.
 *
 * @see https://hello.atlassian.net/wiki/spaces/DST/pages/2081696628/DSTDACI-010+-+Interaction+Tracing+hooks+in+DS+components
 */ var $b0f7c2e98ac6f7bd$var$useLayoutEffect = typeof window === 'undefined' ? (0, $5FkrB.useEffect) : (0, $5FkrB.useLayoutEffect);
/**
 * __Spinner__
 *
 * A spinner is an animated spinning icon that lets users know content is being loaded.
 *
 * - [Examples](https://atlassian.design/components/spinner/examples)
 * - [Code](https://atlassian.design/components/spinner/code)
 * - [Usage](https://atlassian.design/components/spinner/usage)
 */ var $b0f7c2e98ac6f7bd$var$Spinner = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).forwardRef(function Spinner(_ref, ref) {
    var _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'inherit' : _ref$appearance, _ref$delay = _ref.delay, delay = _ref$delay === void 0 ? 0 : _ref$delay, interactionName = _ref.interactionName, label = _ref.label, _ref$size = _ref.size, providedSize = _ref$size === void 0 ? 'medium' : _ref$size, testId = _ref.testId;
    var size = typeof providedSize === 'number' ? providedSize : (0, $a0d46f428acbaca2$export$4e9f1640bbe7a1a8)[providedSize];
    var animationDelay = "".concat(delay, "ms");
    var stroke = $b0f7c2e98ac6f7bd$var$getStrokeColor(appearance);
    var context = (0, $5FkrB.useContext)((0, $eqVaP.default));
    $b0f7c2e98ac6f7bd$var$useLayoutEffect(function() {
        if (context != null) return context.hold(interactionName);
    }, [
        context,
        interactionName
    ]);
    /**
   * The Spinner animation uses a combination of two
   * css animations on two separate elements.
   */ return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("span", {
        "data-testid": testId ? "".concat(testId, "-wrapper") : 'spinner-wrapper',
        style: {
            animationDelay: animationDelay,
            width: size,
            height: size
        },
        className: (0, $970q7.default)([
            $b0f7c2e98ac6f7bd$var$styles.wrapperStyles,
            $b0f7c2e98ac6f7bd$var$styles.rotateStyles
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("svg", {
        height: size,
        width: size,
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg",
        "data-testid": testId,
        ref: ref,
        "aria-label": label || undefined,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            animationDelay: animationDelay
        },
        role: label ? 'img' : 'none',
        className: (0, $970q7.default)([
            $b0f7c2e98ac6f7bd$var$styles.loadInStyles
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("circle", {
        cx: "8",
        cy: "8",
        r: "7",
        style: {
            stroke: stroke
        },
        className: (0, $970q7.default)([
            $b0f7c2e98ac6f7bd$var$styles.circleStyles
        ])
    })));
}));
var $b0f7c2e98ac6f7bd$export$2e2bcd8739ae039 = $b0f7c2e98ac6f7bd$var$Spinner;



var $11f89a596a1a68ee$var$_excluded = [
    "innerProps",
    "isRtl",
    "size",
    "isCompact",
    "xcss"
];
function $11f89a596a1a68ee$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $11f89a596a1a68ee$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $11f89a596a1a68ee$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $11f89a596a1a68ee$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
// ==============================
// Dropdown & Clear Icons
// ==============================
var $11f89a596a1a68ee$var$iconContainerStyles = {
    root: "_kkk2n7od _12ji1r31 _1qu219ly _12y31o36 _1e0c1txw _4cvr1h6o _1bah1h6o _1q51v77o _y4tiv77o _85i5v77o _bozgv77o"
};
var $11f89a596a1a68ee$var$dropdownWrapperStyles = {
    root: "_1q5112x7 _y4ti12x7 _85i512x7 _bozg12x7"
};
// ==============================
// Dropdown & Clear Buttons
// ==============================
var $11f89a596a1a68ee$var$dropdownStyles = {
    default: "_v564vrg3 _1e0c1txw _syazazsu _1q5112x7 _y4tiv77o _85i512x7 _bozgv77o _30l3azsu",
    compact: "_1q51idpf _85i5idpf",
    disabled: "_syaz1gmx"
};
var $11f89a596a1a68ee$export$e1687335805e1230 = function dropdownIndicatorCSS() {
    return {};
};
var $11f89a596a1a68ee$export$ec98719d3db7f2e4 = function DropdownIndicator(props) {
    var innerProps = props.innerProps, children = props.children, isDisabled = props.isDisabled, isCompact = props.isCompact, xcss = props.xcss;
    var _getStyleProps = (0, $50a6d89e4bbf23e3$export$26417cabd806a658)(props, 'dropdownIndicator', {
        indicator: true,
        'dropdown-indicator': true
    }), css = _getStyleProps.css, className = _getStyleProps.className;
    return /*#__PURE__*/ $5FkrB.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        className: (0, $970q7.default)([
            $11f89a596a1a68ee$var$dropdownStyles.default,
            isDisabled && $11f89a596a1a68ee$var$dropdownStyles.disabled,
            isCompact && $11f89a596a1a68ee$var$dropdownStyles.compact,
            (0, $hUFig.cx)(className, xcss, '-indicatorContainer')
        ])
    }, innerProps), children ? children : /*#__PURE__*/ $5FkrB.createElement((0, $d3ef6ecc8cb0136a$export$2e2bcd8739ae039), {
        as: "span",
        xcss: $11f89a596a1a68ee$var$dropdownWrapperStyles.root
    }, /*#__PURE__*/ $5FkrB.createElement((0, (/*@__PURE__*/$parcel$interopDefault($6f037d10bfb6391b$exports))), {
        color: "currentColor",
        label: "open",
        size: "small"
    })));
};
var $11f89a596a1a68ee$export$9c0419fd944c1def = function clearIndicatorCSS() {
    return {};
};
var $11f89a596a1a68ee$var$clearIndicatorStyles = {
    default: "_v564vrg3 _1e0c1txw _syaz1rpy _1q5112x7 _y4tiv77o _85i512x7 _bozgv77o _30l3azsu",
    compact: "_1q51idpf _85i5idpf"
};
var $11f89a596a1a68ee$export$ecf9cf59142dd54a = function ClearIndicator(props) {
    var innerProps = props.innerProps, _props$clearControlLa = props.clearControlLabel, clearControlLabel = _props$clearControlLa === void 0 ? 'clear' : _props$clearControlLa, isCompact = props.isCompact, xcss = props.xcss;
    var _getStyleProps2 = (0, $50a6d89e4bbf23e3$export$26417cabd806a658)(props, 'clearIndicator', {
        indicator: true,
        'clear-indicator': true
    }), css = _getStyleProps2.css, className = _getStyleProps2.className;
    return /*#__PURE__*/ $5FkrB.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        className: (0, $970q7.default)([
            $11f89a596a1a68ee$var$clearIndicatorStyles.default,
            isCompact && $11f89a596a1a68ee$var$clearIndicatorStyles.compact,
            (0, $hUFig.cx)(className, xcss, '-indicatorContainer')
        ])
    }, innerProps), /*#__PURE__*/ $5FkrB.createElement((0, $5903433786f54b21$export$2e2bcd8739ae039), {
        xcss: $11f89a596a1a68ee$var$iconContainerStyles.root,
        tabIndex: -1,
        "aria-label": clearControlLabel
    }, /*#__PURE__*/ $5FkrB.createElement((0, (/*@__PURE__*/$parcel$interopDefault($bc007dd19254a111$exports))), {
        label: "",
        color: "currentColor",
        size: "small"
    })));
};
var $11f89a596a1a68ee$export$1d3f24cde248e6b5 = function loadingIndicatorCSS() {
    return {};
};
var $11f89a596a1a68ee$var$loadingIndicatorStyles = {
    default: "_1q5112x7 _y4tiu2gc _85i512x7 _bozgu2gc",
    compact: "_1q51idpf _85i5idpf"
};
var $11f89a596a1a68ee$export$7c20be4c1d342248 = function LoadingIndicator(_ref) {
    var innerProps = _ref.innerProps, isRtl = _ref.isRtl, _ref$size = _ref.size, size = _ref$size === void 0 ? 4 : _ref$size, isCompact = _ref.isCompact, xcss = _ref.xcss, restProps = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $11f89a596a1a68ee$var$_excluded);
    var _getStyleProps3 = (0, $50a6d89e4bbf23e3$export$26417cabd806a658)($11f89a596a1a68ee$var$_objectSpread($11f89a596a1a68ee$var$_objectSpread({}, restProps), {}, {
        innerProps: innerProps,
        isRtl: isRtl,
        size: size
    }), 'loadingIndicator', {
        indicator: true,
        'loading-indicator': true
    }), css = _getStyleProps3.css, className = _getStyleProps3.className;
    return /*#__PURE__*/ $5FkrB.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        className: (0, $970q7.default)([
            $11f89a596a1a68ee$var$loadingIndicatorStyles.default,
            isCompact && $11f89a596a1a68ee$var$loadingIndicatorStyles.compact,
            (0, $hUFig.cx)(className, xcss, '-loadingIndicator')
        ])
    }, innerProps), /*#__PURE__*/ $5FkrB.createElement((0, $b0f7c2e98ac6f7bd$export$2e2bcd8739ae039), {
        size: "small"
    }));
};


/* input.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $kqp0i = parcelRequire("kqp0i");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");

var $hUFig = parcelRequire("hUFig");

var $id6Cu = parcelRequire("id6Cu");

var $1f35b8bbcacfde3f$var$_excluded = [
    "innerRef",
    "isDisabled",
    "isHidden",
    "inputClassName",
    "testId"
];
var $1f35b8bbcacfde3f$export$14a7781d0ca7abea = function inputCSS() {
    return {};
};
var $1f35b8bbcacfde3f$var$inputStylesOld = {
    root: "_16jlkb7n _1o9zkb7n _i0dl1wug _nd5l1sux _1mouv77o _195gv77o _1rjcv77o _1e0c1n7u _yv0e12qd _syazi7uo _j8d6idpf _1av2idpf _1doyidpf _pfztidpf _uoe3idpf _1recidpf _70xridpf _1k96idpf _eq43idpf _1h9u1kw7 _ckog1yjy _1x651r31 _1nn4glyw _1rzeidpf _1yd8yh40 _aetr11ps _uy7x15vq _1qjlqvpr",
    disabled: "_3um015vq"
};
var $1f35b8bbcacfde3f$var$inputStyles = {
    root: "_16jlkb7n _1o9zkb7n _i0dl1wug _nd5l1sux _1mouv77o _195gv77o _1rjcv77o _kqswh2mm _1e0c1txw _yv0e12qd _syazi7uo _j8d6idpf _1av2idpf _1doyidpf _pfztidpf _uoe3idpf _1recidpf _70xridpf _1k96idpf _eq43idpf _1h9u1kw7 _ckog1yjy _1x651r31 _1nn4glyw _1rzeidpf _1yd8yh40 _aetr11ps _uy7x15vq _1qjlqvpr",
    disabled: "_3um015vq"
};
var $1f35b8bbcacfde3f$var$nativeInputStylesOld = null;
var $1f35b8bbcacfde3f$var$nativeInputStyles = null;
var $1f35b8bbcacfde3f$var$hidden = null;
var $1f35b8bbcacfde3f$var$Input = function Input(props) {
    var builtinCX = props.cx, value = props.value, xcss = props.xcss;
    var _cleanCommonProps = (0, $50a6d89e4bbf23e3$export$8e9fd4287627890c)(props), innerRef = _cleanCommonProps.innerRef, isDisabled = _cleanCommonProps.isDisabled, isHidden = _cleanCommonProps.isHidden, inputClassName = _cleanCommonProps.inputClassName, testId = _cleanCommonProps.testId, innerProps = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_cleanCommonProps, $1f35b8bbcacfde3f$var$_excluded);
    var dataId = testId ? "".concat(testId, "-select--input") : null;
    var _getStyleProps = (0, $50a6d89e4bbf23e3$export$26417cabd806a658)(props, 'input', {
        'input-container': true
    }), css = _getStyleProps.css, className = _getStyleProps.className;
    if ((0, $id6Cu.fg)('platform_do_not_clear_input_for_multiselect')) return /*#__PURE__*/ $5FkrB.createElement("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        className: (0, $970q7.default)([
            $1f35b8bbcacfde3f$var$inputStyles.root,
            isDisabled && $1f35b8bbcacfde3f$var$inputStyles.disabled,
            (0, $hUFig.cx)(className, xcss, '-Input')
        ]),
        "data-value": value || '',
        "data-testid": dataId && "".concat(dataId, "-container")
    }, /*#__PURE__*/ $5FkrB.createElement("input", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $970q7.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1r04idpf _11q7idpf _19itidpf _11c81kw7 _nd5l1yjy _12ji1r31 _1qu2glyw _12y3idpf _1bsb1osq _1ul9yh40 _kqswstnw _syaz1kw7 _tzy4kb7n",
            isHidden && "_tzy4idpf",
            builtinCX({
                input: true
            }, inputClassName, '-input')
        ]),
        ref: innerRef,
        disabled: isDisabled,
        "data-testid": dataId
    }, innerProps)));
    return /*#__PURE__*/ $5FkrB.createElement("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        className: (0, $970q7.default)([
            $1f35b8bbcacfde3f$var$inputStylesOld.root,
            isDisabled && $1f35b8bbcacfde3f$var$inputStylesOld.disabled,
            (0, $hUFig.cx)(className, xcss, '-Input')
        ]),
        "data-value": value || '',
        "data-testid": dataId && "".concat(dataId, "-container")
    }, /*#__PURE__*/ $5FkrB.createElement("input", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $970q7.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _11q7idpf _19itidpf _11c81kw7 _nd5l1yjy _12ji1r31 _1qu2glyw _12y3idpf _1bsb1osq _1ul9yh40 _syaz1kw7 _tzy4kb7n",
            isHidden && "_tzy4idpf",
            builtinCX({
                input: true
            }, inputClassName, '-input')
        ]),
        ref: innerRef,
        disabled: isDisabled,
        "data-testid": dataId
    }, innerProps)));
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$1f35b8bbcacfde3f$export$2e2bcd8739ae039 = $1f35b8bbcacfde3f$var$Input;


/* menu.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $1Vcia = parcelRequire("1Vcia");

var $kqp0i = parcelRequire("kqp0i");

var $25nEq = parcelRequire("25nEq");

var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");

var $hUFig = parcelRequire("hUFig");

var $6I9SI = parcelRequire("6I9SI");

var $aLeHs = parcelRequire("aLeHs");

var $g8g1T = parcelRequire("g8g1T");

var $id6Cu = parcelRequire("id6Cu");
/* text.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");

var $afMOk = parcelRequire("afMOk");

var $5FkrB = parcelRequire("5FkrB");
var $7095b6c15d2d949f$var$HasTextAncestorContext = /*#__PURE__*/ (0, $5FkrB.createContext)(false);
var $7095b6c15d2d949f$export$9322276ec105d055 = function useHasTextAncestor() {
    return (0, $5FkrB.useContext)($7095b6c15d2d949f$var$HasTextAncestorContext);
};
var $7095b6c15d2d949f$export$ae933c6cbe5643ad = $7095b6c15d2d949f$var$HasTextAncestorContext.Provider;



var $5FkrB = parcelRequire("5FkrB");
var $ddec88a2dc977200$export$1ca2a26fecb070ae = /*#__PURE__*/ (0, $5FkrB.createContext)('elevation.surface');
var $ddec88a2dc977200$export$1aeb4f6b93c4540d = function useSurface() {
    return (0, $5FkrB.useContext)($ddec88a2dc977200$export$1ca2a26fecb070ae);
};
$ddec88a2dc977200$export$1ca2a26fecb070ae.displayName = 'SurfaceProvider';


var $b57bea3c225b4a73$var$asAllowlist = [
    'span',
    'p',
    'strong',
    'em'
];
/**
 * Custom hook designed to abstract the parsing of the color props and make it clearer in the future how color is reconciled between themes and tokens.
 */ var $b57bea3c225b4a73$var$useColor = function useColor(colorProp, hasTextAncestor) {
    var surface = (0, $ddec88a2dc977200$export$1aeb4f6b93c4540d)();
    if (colorProp === 'inherit') return undefined;
    if (colorProp) return colorProp;
    if (hasTextAncestor) return undefined;
    if ($b57bea3c225b4a73$export$2185ce37f9bdd963.hasOwnProperty(surface)) return $b57bea3c225b4a73$export$2185ce37f9bdd963[surface];
    return 'color.text';
};
var $b57bea3c225b4a73$var$styles = {
    root: "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _1i4qfg65",
    'as.strong': "_k48pwu06",
    'as.em': "_zg8l1m30",
    'textAlign.center': "_y3gn1h6o",
    'textAlign.end': "_y3gnh9n0",
    'textAlign.start': "_y3gnv2br",
    truncation: "_1reo15vq _18m915vq _1e0ccj1k _sudp1e54",
    breakAll: "_1nmz9jpi"
};
var $b57bea3c225b4a73$var$fontSizeMap = {
    medium: "_11c8fhey",
    UNSAFE_small: "_11c8rymc",
    large: "_11c81d4k",
    small: "_11c8wadc"
};
var $b57bea3c225b4a73$var$fontWeightMap = {
    bold: "_k48pwu06",
    medium: "_k48p1wq8",
    regular: "_k48pi7a9",
    semibold: "_k48p1pd9"
};
var $b57bea3c225b4a73$var$textColorMap = {
    'color.text': "_syazi7uo",
    'color.text.accent.lime': "_syaz1tco",
    'color.text.accent.lime.bolder': "_syaz1ik3",
    'color.text.accent.red': "_syaz9lu1",
    'color.text.accent.red.bolder': "_syazhwvp",
    'color.text.accent.orange': "_syazp1lv",
    'color.text.accent.orange.bolder': "_syaz7i1p",
    'color.text.accent.yellow': "_syazfb2s",
    'color.text.accent.yellow.bolder': "_syazekll",
    'color.text.accent.green': "_syazh55r",
    'color.text.accent.green.bolder': "_syaz1y78",
    'color.text.accent.teal': "_syaz17qg",
    'color.text.accent.teal.bolder': "_syaz12v7",
    'color.text.accent.blue': "_syaz16jw",
    'color.text.accent.blue.bolder': "_syaz1kyx",
    'color.text.accent.purple': "_syazqmo9",
    'color.text.accent.purple.bolder': "_syaz1mn1",
    'color.text.accent.magenta': "_syaz1s8m",
    'color.text.accent.magenta.bolder': "_syaz1qur",
    'color.text.accent.gray': "_syaz1sqi",
    'color.text.accent.gray.bolder': "_syaz1tmo",
    'color.text.disabled': "_syaz1gmx",
    'color.text.inverse': "_syaz15cr",
    'color.text.selected': "_syaz6x5g",
    'color.text.brand': "_syaz1oa5",
    'color.text.danger': "_syaz1tmw",
    'color.text.warning': "_syaz1xn9",
    'color.text.warning.inverse': "_syaz1yd3",
    'color.text.success': "_syazgsak",
    'color.text.discovery': "_syazdv2p",
    'color.text.information': "_syazu3tg",
    'color.text.subtlest': "_syaz1rpy",
    'color.text.subtle': "_syazazsu",
    'color.link': "_syaz13af",
    'color.link.pressed': "_syaz12zz",
    'color.link.visited': "_syaz1ra0",
    'color.link.visited.pressed': "_syaz17z1"
};
var $b57bea3c225b4a73$export$2185ce37f9bdd963 = {
    'color.background.neutral.bold': 'color.text.inverse',
    'color.background.neutral.bold.hovered': 'color.text.inverse',
    'color.background.neutral.bold.pressed': 'color.text.inverse',
    'color.background.selected.bold': 'color.text.inverse',
    'color.background.selected.bold.hovered': 'color.text.inverse',
    'color.background.selected.bold.pressed': 'color.text.inverse',
    'color.background.brand.bold': 'color.text.inverse',
    'color.background.brand.bold.hovered': 'color.text.inverse',
    'color.background.brand.bold.pressed': 'color.text.inverse',
    'color.background.brand.boldest': 'color.text.inverse',
    'color.background.brand.boldest.hovered': 'color.text.inverse',
    'color.background.brand.boldest.pressed': 'color.text.inverse',
    'color.background.danger.bold': 'color.text.inverse',
    'color.background.danger.bold.hovered': 'color.text.inverse',
    'color.background.danger.bold.pressed': 'color.text.inverse',
    'color.background.warning.bold': 'color.text.warning.inverse',
    'color.background.warning.bold.hovered': 'color.text.warning.inverse',
    'color.background.warning.bold.pressed': 'color.text.warning.inverse',
    'color.background.success.bold': 'color.text.inverse',
    'color.background.success.bold.hovered': 'color.text.inverse',
    'color.background.success.bold.pressed': 'color.text.inverse',
    'color.background.discovery.bold': 'color.text.inverse',
    'color.background.discovery.bold.hovered': 'color.text.inverse',
    'color.background.discovery.bold.pressed': 'color.text.inverse',
    'color.background.information.bold': 'color.text.inverse',
    'color.background.information.bold.hovered': 'color.text.inverse',
    'color.background.information.bold.pressed': 'color.text.inverse'
};
/**
 * __Text__
 *
 * Text is a primitive component that has the Atlassian Design System's design guidelines baked in.
 * This includes considerations for text attributes such as color, font size, font weight, and line height.
 * It renders a `span` by default.
 *
 * @internal
 */ var $b57bea3c225b4a73$var$Text = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? 'span' : _ref$as, colorProp = _ref.color, align = _ref.align, testId = _ref.testId, id = _ref.id, size = _ref.size, weight = _ref.weight, maxLines = _ref.maxLines, xcss = _ref.xcss, children = _ref.children;
    (0, $afMOk.default)($b57bea3c225b4a73$var$asAllowlist.includes(Component), "@atlaskit/primitives: Text received an invalid \"as\" value of \"".concat(Component, "\""));
    var hasTextAncestor = (0, $7095b6c15d2d949f$export$9322276ec105d055)();
    var color = $b57bea3c225b4a73$var$useColor(colorProp, hasTextAncestor);
    if (!size && !hasTextAncestor) size = 'medium';
    var component = /*#__PURE__*/ $5FkrB.createElement(Component, {
        id: id,
        className: (0, $970q7.default)([
            $b57bea3c225b4a73$var$styles.root,
            size && $b57bea3c225b4a73$var$fontSizeMap[size],
            color && $b57bea3c225b4a73$var$textColorMap[color],
            maxLines && $b57bea3c225b4a73$var$styles.truncation,
            maxLines === 1 && $b57bea3c225b4a73$var$styles.breakAll,
            align && $b57bea3c225b4a73$var$styles["textAlign.".concat(align)],
            weight && $b57bea3c225b4a73$var$fontWeightMap[weight],
            Component === 'em' && $b57bea3c225b4a73$var$styles['as.em'],
            Component === 'strong' && $b57bea3c225b4a73$var$styles['as.strong'],
            xcss
        ]),
        style: {
            WebkitLineClamp: maxLines
        },
        "data-testid": testId,
        ref: ref
    }, children);
    if (hasTextAncestor) // no need to re-apply context if the text is already wrapped
    return component;
    return /*#__PURE__*/ $5FkrB.createElement((0, $7095b6c15d2d949f$export$ae933c6cbe5643ad), {
        value: true
    }, component);
});
var $b57bea3c225b4a73$export$2e2bcd8739ae039 = $b57bea3c225b4a73$var$Text;



var $a77dc8ff50c99630$var$_excluded = [
    "children",
    "innerProps",
    "xcss"
], $a77dc8ff50c99630$var$_excluded2 = [
    "children",
    "innerProps",
    "xcss"
];
function $a77dc8ff50c99630$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $a77dc8ff50c99630$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $a77dc8ff50c99630$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $a77dc8ff50c99630$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
// ==============================
// Menu
// ==============================
// Get Menu Placement
// ------------------------------
function $a77dc8ff50c99630$var$getMenuPlacement(_ref) {
    var preferredMaxHeight = _ref.maxHeight, menuEl = _ref.menuEl, minHeight = _ref.minHeight, preferredPlacement = _ref.placement, shouldScroll = _ref.shouldScroll, isFixedPosition = _ref.isFixedPosition, controlHeight = _ref.controlHeight;
    var scrollParent = (0, $50a6d89e4bbf23e3$export$cfa2225e87938781)(menuEl);
    var defaultState = {
        placement: 'bottom',
        maxHeight: preferredMaxHeight
    };
    // something went wrong, return default state
    if (!menuEl || !menuEl.offsetParent) return defaultState;
    // we can't trust `scrollParent.scrollHeight` --> it may increase when
    // the menu is rendered
    var _scrollParent$getBoun = scrollParent.getBoundingClientRect(), scrollHeight = _scrollParent$getBoun.height;
    var _menuEl$getBoundingCl = menuEl.getBoundingClientRect(), menuBottom = _menuEl$getBoundingCl.bottom, menuHeight = _menuEl$getBoundingCl.height, menuTop = _menuEl$getBoundingCl.top;
    var _menuEl$offsetParent$ = menuEl.offsetParent.getBoundingClientRect(), containerTop = _menuEl$offsetParent$.top;
    var viewHeight = isFixedPosition ? window.innerHeight : (0, $50a6d89e4bbf23e3$export$2e0654fad740d2e4)(scrollParent);
    var scrollTop = (0, $50a6d89e4bbf23e3$export$c4a223a8ba9e4ea5)(scrollParent);
    var menuTopFromParent = menuTop;
    var marginBottom = parseInt(getComputedStyle(menuEl).marginBottom, 10);
    var marginTop = parseInt(getComputedStyle(menuEl).marginTop, 10);
    var viewSpaceAbove = containerTop - marginTop;
    var viewSpaceBelow = viewHeight - menuTopFromParent;
    var scrollSpaceAbove = viewSpaceAbove + scrollTop;
    var scrollSpaceBelow = scrollHeight - scrollTop - menuTopFromParent;
    var scrollDown = menuBottom - viewHeight + scrollTop + marginBottom;
    var scrollUp = scrollTop + menuTop - marginTop;
    var scrollDuration = 160;
    switch(preferredPlacement){
        case 'auto':
        case 'bottom':
            // 1: the menu will fit, do nothing
            if (viewSpaceBelow >= menuHeight) return {
                placement: 'bottom',
                maxHeight: preferredMaxHeight
            };
            // 2: the menu will fit, if scrolled
            if (scrollSpaceBelow >= menuHeight && !isFixedPosition) {
                if (shouldScroll) (0, $50a6d89e4bbf23e3$export$858c30343199f3af)(scrollParent, scrollDown, scrollDuration);
                return {
                    placement: 'bottom',
                    maxHeight: preferredMaxHeight
                };
            }
            // 3: the menu will fit, if constrained
            if (!isFixedPosition && scrollSpaceBelow >= minHeight || isFixedPosition && viewSpaceBelow >= minHeight) {
                if (shouldScroll) (0, $50a6d89e4bbf23e3$export$858c30343199f3af)(scrollParent, scrollDown, scrollDuration);
                // we want to provide as much of the menu as possible to the user,
                // so give them whatever is available below rather than the minHeight.
                var constrainedHeight = isFixedPosition ? viewSpaceBelow - marginBottom : scrollSpaceBelow - marginBottom;
                return {
                    placement: 'bottom',
                    maxHeight: constrainedHeight
                };
            }
            // 4. Forked beviour when there isn't enough space below
            // AUTO: flip the menu, render above
            if (preferredPlacement === 'auto' || isFixedPosition) {
                // may need to be constrained after flipping
                var _constrainedHeight = preferredMaxHeight;
                var spaceAbove = isFixedPosition ? viewSpaceAbove : scrollSpaceAbove;
                if (spaceAbove >= minHeight) _constrainedHeight = Math.min(spaceAbove - marginBottom - controlHeight, preferredMaxHeight);
                return {
                    placement: 'top',
                    maxHeight: _constrainedHeight
                };
            }
            // BOTTOM: allow browser to increase scrollable area and immediately set scroll
            if (preferredPlacement === 'bottom') {
                if (shouldScroll) (0, $50a6d89e4bbf23e3$export$3f99968195accfaf)(scrollParent, scrollDown);
                return {
                    placement: 'bottom',
                    maxHeight: preferredMaxHeight
                };
            }
            break;
        case 'top':
            // 1: the menu will fit, do nothing
            if (viewSpaceAbove >= menuHeight) return {
                placement: 'top',
                maxHeight: preferredMaxHeight
            };
            // 2: the menu will fit, if scrolled
            if (scrollSpaceAbove >= menuHeight && !isFixedPosition) {
                if (shouldScroll) (0, $50a6d89e4bbf23e3$export$858c30343199f3af)(scrollParent, scrollUp, scrollDuration);
                return {
                    placement: 'top',
                    maxHeight: preferredMaxHeight
                };
            }
            // 3: the menu will fit, if constrained
            if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) {
                var _constrainedHeight2 = preferredMaxHeight;
                // we want to provide as much of the menu as possible to the user,
                // so give them whatever is available below rather than the minHeight.
                if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) _constrainedHeight2 = isFixedPosition ? viewSpaceAbove - marginTop : scrollSpaceAbove - marginTop;
                if (shouldScroll) (0, $50a6d89e4bbf23e3$export$858c30343199f3af)(scrollParent, scrollUp, scrollDuration);
                return {
                    placement: 'top',
                    maxHeight: _constrainedHeight2
                };
            }
            // 4. not enough space, the browser WILL NOT increase scrollable area when
            // absolutely positioned element rendered above the viewport (only below).
            // Flip the menu, render below
            return {
                placement: 'bottom',
                maxHeight: preferredMaxHeight
            };
        default:
            throw new Error("Invalid placement provided \"".concat(preferredPlacement, "\"."));
    }
    return defaultState;
}
// Menu Component
// ------------------------------
var $a77dc8ff50c99630$var$coercePlacement = function coercePlacement(p) {
    return p === 'auto' ? 'bottom' : p;
};
var $a77dc8ff50c99630$var$menuStyles = {
    root: "_2rko12b0 _kqswstnw _1bsb1osq _1pbykb7n _6rthu2gc _1pfhu2gc _bfhk1bhr _16qsd0yg",
    rootT26Shape: "_2rko1mok",
    bottom: "_152t1osq",
    top: "_u7co1osq"
};
var $a77dc8ff50c99630$export$a228922d5ca42a79 = function menuCSS() {
    return {};
};
var $a77dc8ff50c99630$var$PortalPlacementContext = /*#__PURE__*/ (0, $5FkrB.createContext)(null);
var $a77dc8ff50c99630$export$f32337f3a7617699 = function MenuPlacer(props) {
    var children = props.children, minMenuHeight = props.minMenuHeight, maxMenuHeight = props.maxMenuHeight, menuPlacement = props.menuPlacement, menuPosition = props.menuPosition, menuShouldScrollIntoView = props.menuShouldScrollIntoView;
    var _ref2 = (0, $5FkrB.useContext)($a77dc8ff50c99630$var$PortalPlacementContext) || {}, setPortalPlacement = _ref2.setPortalPlacement;
    var ref = (0, $5FkrB.useRef)(null);
    var _useState = (0, $5FkrB.useState)(maxMenuHeight), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), maxHeight = _useState2[0], setMaxHeight = _useState2[1];
    var _useState3 = (0, $5FkrB.useState)(null), _useState4 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState3, 2), placement = _useState4[0], setPlacement = _useState4[1];
    // The minimum height of the control
    var controlHeight = 38;
    (0, $g8g1T.default)(function() {
        var menuEl = ref.current;
        if (!menuEl) return;
        // DO NOT scroll if position is fixed
        var isFixedPosition = menuPosition === 'fixed';
        var shouldScroll = menuShouldScrollIntoView && !isFixedPosition;
        var state = $a77dc8ff50c99630$var$getMenuPlacement({
            maxHeight: maxMenuHeight,
            menuEl: menuEl,
            minHeight: minMenuHeight,
            placement: menuPlacement,
            shouldScroll: shouldScroll,
            isFixedPosition: isFixedPosition,
            controlHeight: controlHeight
        });
        setMaxHeight(state.maxHeight);
        setPlacement(state.placement);
        setPortalPlacement === null || setPortalPlacement === void 0 || setPortalPlacement(state.placement);
    }, [
        maxMenuHeight,
        menuPlacement,
        menuPosition,
        menuShouldScrollIntoView,
        minMenuHeight,
        setPortalPlacement,
        controlHeight
    ]);
    return children({
        ref: ref,
        placerProps: $a77dc8ff50c99630$var$_objectSpread($a77dc8ff50c99630$var$_objectSpread({}, props), {}, {
            placement: placement || $a77dc8ff50c99630$var$coercePlacement(menuPlacement),
            maxHeight: maxHeight
        })
    });
};
var $a77dc8ff50c99630$var$Menu = function Menu(props) {
    var children = props.children, innerRef = props.innerRef, innerProps = props.innerProps, _props$placement = props.placement, placement = _props$placement === void 0 ? 'bottom' : _props$placement, xcss = props.xcss;
    var _getStyleProps = (0, $50a6d89e4bbf23e3$export$26417cabd806a658)(props, 'menu', {
        menu: true
    }), css = _getStyleProps.css, className = _getStyleProps.className;
    return /*#__PURE__*/ $5FkrB.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $970q7.default)([
            $a77dc8ff50c99630$var$menuStyles.root,
            $a77dc8ff50c99630$var$menuStyles[placement],
            (0, $id6Cu.fg)('platform-dst-shape-theme-default') && $a77dc8ff50c99630$var$menuStyles.rootT26Shape,
            (0, $hUFig.cx)(xcss, className, '-menu')
        ]),
        style: css,
        ref: innerRef
    }, innerProps), children);
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$a77dc8ff50c99630$export$2e2bcd8739ae039 = $a77dc8ff50c99630$var$Menu;
var $a77dc8ff50c99630$export$abafed69cff95d5e = function menuListCSS() {
    return {};
};
var $a77dc8ff50c99630$var$menuListStyles = null;
var $a77dc8ff50c99630$export$d4c4e98c5044dc8 = function MenuList(props) {
    var children = props.children, innerProps = props.innerProps, innerRef = props.innerRef, isMulti = props.isMulti, maxHeight = props.maxHeight, xcss = props.xcss;
    var _getStyleProps2 = (0, $50a6d89e4bbf23e3$export$26417cabd806a658)(props, 'menuList', {
        'menu-list': true,
        'menu-list--is-multi': isMulti
    }), css = _getStyleProps2.css, className = _getStyleProps2.className;
    return /*#__PURE__*/ $5FkrB.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $970q7.default)([
            "_kqswh2mm _18m91wug _85i5u2gc _1q51u2gc _8am5i4x0",
            (0, $hUFig.cx)(className, xcss, '-MenuList')
        ]),
        style: $a77dc8ff50c99630$var$_objectSpread($a77dc8ff50c99630$var$_objectSpread({}, css), {}, {
            maxHeight: maxHeight
        }),
        ref: innerRef
    }, innerProps, {
        tabIndex: -1
    }), children);
};
// ==============================
// Menu Notices
// ==============================
var $a77dc8ff50c99630$var$noticeCSS = function noticeCSS() {
    return {};
};
var $a77dc8ff50c99630$var$noticeStyles = null;
var $a77dc8ff50c99630$export$cf0e22534d8b0074 = $a77dc8ff50c99630$var$noticeCSS;
var $a77dc8ff50c99630$export$98ec46397a8cb3cd = $a77dc8ff50c99630$var$noticeCSS;
var $a77dc8ff50c99630$export$d58b72b7d3c4072c = function NoOptionsMessage(_ref3) {
    var _ref3$children = _ref3.children, children = _ref3$children === void 0 ? 'No options' : _ref3$children, innerProps = _ref3.innerProps, xcss = _ref3.xcss, restProps = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref3, $a77dc8ff50c99630$var$_excluded);
    var _getStyleProps3 = (0, $50a6d89e4bbf23e3$export$26417cabd806a658)($a77dc8ff50c99630$var$_objectSpread($a77dc8ff50c99630$var$_objectSpread({}, restProps), {}, {
        children: children,
        innerProps: innerProps
    }), 'noOptionsMessage', {
        'menu-notice': true,
        'menu-notice--no-options': true
    }), css = _getStyleProps3.css, className = _getStyleProps3.className;
    return /*#__PURE__*/ $5FkrB.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $970q7.default)([
            "_85i5u2gc _1q51u2gc _y4tiutpp _bozgutpp _y3gn1h6o",
            (0, $hUFig.cx)(className, xcss, '-NoOptionsMessage')
        ]),
        style: css,
        role: "option"
    }, innerProps), /*#__PURE__*/ $5FkrB.createElement((0, $b57bea3c225b4a73$export$2e2bcd8739ae039), {
        color: "color.text.subtle"
    }, children));
};
var $a77dc8ff50c99630$export$e928a71d039d3102 = function LoadingMessage(_ref4) {
    var _ref4$children = _ref4.children, children = _ref4$children === void 0 ? 'Loading...' : _ref4$children, innerProps = _ref4.innerProps, xcss = _ref4.xcss, restProps = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref4, $a77dc8ff50c99630$var$_excluded2);
    var _getStyleProps4 = (0, $50a6d89e4bbf23e3$export$26417cabd806a658)($a77dc8ff50c99630$var$_objectSpread($a77dc8ff50c99630$var$_objectSpread({}, restProps), {}, {
        children: children,
        innerProps: innerProps
    }), 'loadingMessage', {
        'menu-notice': true,
        'menu-notice--loading': true
    }), css = _getStyleProps4.css, className = _getStyleProps4.className;
    return /*#__PURE__*/ $5FkrB.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $970q7.default)([
            "_85i5u2gc _1q51u2gc _y4tiutpp _bozgutpp _y3gn1h6o",
            (0, $hUFig.cx)(className, xcss, '-LoadingMessage')
        ]),
        style: css
    }, innerProps, {
        // eslint-disable-next-line @atlassian/a11y/role-has-required-aria-props
        role: "option"
    }), /*#__PURE__*/ $5FkrB.createElement((0, $b57bea3c225b4a73$export$2e2bcd8739ae039), {
        color: "color.text.subtle"
    }, children));
};
var $a77dc8ff50c99630$export$1dbbeb9648d1fdc9 = function menuPortalCSS() {
    return {};
};
var $a77dc8ff50c99630$var$menuPortalStyles = {
    root: "_1pbykb7n _1e02a1vk _kqswcp1v _152t1nmo _1bsb1qxj"
};
var $a77dc8ff50c99630$export$793392f970497feb = function MenuPortal(props) {
    var appendTo = props.appendTo, children = props.children, controlElement = props.controlElement, innerProps = props.innerProps, menuPlacement = props.menuPlacement, menuPosition = props.menuPosition, xcss = props.xcss;
    var menuPortalRef = (0, $5FkrB.useRef)(null);
    var cleanupRef = (0, $5FkrB.useRef)(null);
    var _useState5 = (0, $5FkrB.useState)($a77dc8ff50c99630$var$coercePlacement(menuPlacement)), _useState6 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState5, 2), placement = _useState6[0], setPortalPlacement = _useState6[1];
    var portalPlacementContext = (0, $5FkrB.useMemo)(function() {
        return {
            setPortalPlacement: setPortalPlacement
        };
    }, []);
    var _useState7 = (0, $5FkrB.useState)(null), _useState8 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState7, 2), computedPosition = _useState8[0], setComputedPosition = _useState8[1];
    var updateComputedPosition = (0, $5FkrB.useCallback)(function() {
        if (!controlElement) return;
        var rect = (0, $50a6d89e4bbf23e3$export$7807c2a424c2f6d1)(controlElement);
        var scrollDistance = menuPosition === 'fixed' ? 0 : window.pageYOffset;
        var offset = rect[placement] + scrollDistance;
        if (offset !== (computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.offset) || rect.left !== (computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.left) || rect.width !== (computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.width)) setComputedPosition({
            offset: offset,
            rect: rect
        });
    }, [
        controlElement,
        menuPosition,
        placement,
        computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.offset,
        computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.left,
        computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.width
    ]);
    (0, $g8g1T.default)(function() {
        updateComputedPosition();
    }, [
        updateComputedPosition
    ]);
    var runAutoUpdate = (0, $5FkrB.useCallback)(function() {
        if (typeof cleanupRef.current === 'function') {
            cleanupRef.current();
            cleanupRef.current = null;
        }
        if (controlElement && menuPortalRef.current) cleanupRef.current = (0, $6I9SI.autoUpdate)(controlElement, menuPortalRef.current, updateComputedPosition, {
            elementResize: 'ResizeObserver' in window
        });
    }, [
        controlElement,
        updateComputedPosition
    ]);
    (0, $g8g1T.default)(function() {
        runAutoUpdate();
    }, [
        runAutoUpdate
    ]);
    var setMenuPortalElement = (0, $5FkrB.useCallback)(function(menuPortalElement) {
        menuPortalRef.current = menuPortalElement;
        runAutoUpdate();
    }, [
        runAutoUpdate
    ]);
    // bail early if required elements aren't present
    if (!appendTo && menuPosition !== 'fixed' || !computedPosition) return null;
    var _getStyleProps5 = (0, $50a6d89e4bbf23e3$export$26417cabd806a658)($a77dc8ff50c99630$var$_objectSpread($a77dc8ff50c99630$var$_objectSpread({}, props), {}, {
        offset: computedPosition.offset,
        position: menuPosition,
        rect: computedPosition.rect
    }), 'menuPortal', {
        'menu-portal': true
    }), css = _getStyleProps5.css, className = _getStyleProps5.className;
    // same wrapper element whether fixed or portalled
    var menuWrapper = /*#__PURE__*/ $5FkrB.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $970q7.default)([
            $a77dc8ff50c99630$var$menuPortalStyles.root,
            (0, $hUFig.cx)(className, xcss, '-MenuPortal')
        ]),
        ref: setMenuPortalElement,
        style: $a77dc8ff50c99630$var$_objectSpread({
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            '--menu-left': "".concat(computedPosition.rect.left, "px"),
            '--menu-position': menuPosition,
            '--menu-top': "".concat(computedPosition.offset, "px"),
            '--menu-width': "".concat(computedPosition.rect.width, "px")
        }, css)
    }, innerProps), children);
    return /*#__PURE__*/ $5FkrB.createElement($a77dc8ff50c99630$var$PortalPlacementContext.Provider, {
        value: portalPlacementContext
    }, appendTo ? /*#__PURE__*/ (0, $aLeHs.createPortal)(menuWrapper, appendTo) : menuWrapper);
};


/* multi-value.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $25nEq = parcelRequire("25nEq");

var $kqp0i = parcelRequire("kqp0i");

var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");

var $hUFig = parcelRequire("hUFig");
var $6272e7058520f324$exports = {};
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::13080645a1b889dca339823c8ecd9929>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty($6272e7058520f324$exports, "__esModule", {
    value: true
});
$6272e7058520f324$exports.default = void 0;

var $6272e7058520f324$var$_react = $6272e7058520f324$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $6272e7058520f324$var$_baseNew = $6272e7058520f324$var$_interopRequireDefault((parcelRequire("lw4o3")));
function $6272e7058520f324$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Cross".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Known uses: closing modals, panels, and transient views; removing tags
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $6272e7058520f324$var$CrossIcon = (props)=>/*#__PURE__*/ $6272e7058520f324$var$_react.default.createElement($6272e7058520f324$var$_baseNew.default, Object.assign({
        name: "CrossIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M14.03 3.03 9.06 8l4.97 4.97-1.06 1.06L8 9.06l-4.97 4.97-1.06-1.06L6.94 8 1.97 3.03l1.06-1.06L8 6.94l4.97-4.97z"/>`
    }, props));
$6272e7058520f324$var$CrossIcon.displayName = 'CrossIcon';
var $6272e7058520f324$var$_default = $6272e7058520f324$exports.default = $6272e7058520f324$var$CrossIcon;



function $5e48f853c890b93e$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $5e48f853c890b93e$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $5e48f853c890b93e$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $5e48f853c890b93e$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $5e48f853c890b93e$var$multiValueStyles = {
    root: "_2rko12b0 _1h6d14je _1dqonqa1 _189ee4h9 _1e0c1txw _1ul9ze3t _1pfhv77o _12l2v77o _6rthv77o _ahbqv77o _bfhk1j9a _p12f1osq _syazjpor _3yq3glyw",
    disabled: "_syaz1gmx _bfhki8nm",
    focused: "_syaz1wum _bfhk15s3 _16qs7ex6 _1aewe4h9 _6up51j28 _1xdnnqa1"
};
var $5e48f853c890b93e$export$23c213f7717186af = function multiValueCSS() {
    return {};
};
var $5e48f853c890b93e$export$f40612612e0af964 = function multiValueLabelCSS() {
    return {};
};
var $5e48f853c890b93e$var$multiValueLabelStyles = {
    root: "_1reo15vq _18m915vq _2rkolb4i _11c8fhey _o5721q9c _y4tiv77o _bozg1b66 _syaz1kw7",
    disabled: "_syaz1gmx",
    ellipsis: "_1bto1l2s"
};
var $5e48f853c890b93e$export$283467f6c4ac142b = function multiValueRemoveCSS() {
    return {};
};
var $5e48f853c890b93e$var$multiValueRemoveStyles = {
    focused: "_bfhkb1q9 _lswu1rrc",
    root: "_19itglyw _2rko12b0 _4cvr1h6o _1bah1h6o _1wpz1h6o _r06hglyw _bfhksm61 _syazi7uo _1e0c1txw _lswu1dx5 _1q51v77o _y4tiv77o _85i5v77o _bozgv77o _12l2v77o _1ah312gs _irr31dpa _13br1jjn _1di6fcek _i5f81jjn"
};
var $5e48f853c890b93e$export$cf9cf2a30a59265c = function MultiValueContainer(_ref) {
    var children = _ref.children, innerProps = _ref.innerProps, isFocused = _ref.isFocused, isDisabled = _ref.isDisabled, className = _ref.className, xcss = _ref.xcss;
    return /*#__PURE__*/ $5FkrB.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, innerProps, {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $970q7.default)([
            $5e48f853c890b93e$var$multiValueStyles.root,
            isDisabled && $5e48f853c890b93e$var$multiValueStyles.disabled,
            isFocused && $5e48f853c890b93e$var$multiValueStyles.focused,
            (0, $hUFig.cx)(className, xcss, '-multiValue')
        ])
    }), children);
};
var $5e48f853c890b93e$export$544aeea2a5ce08ee = function MultiValueLabel(_ref2) {
    var children = _ref2.children, innerProps = _ref2.innerProps, isDisabled = _ref2.isDisabled, hasEllipsis = _ref2.hasEllipsis, className = _ref2.className, xcss = _ref2.xcss;
    return /*#__PURE__*/ $5FkrB.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, innerProps, {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $970q7.default)([
            $5e48f853c890b93e$var$multiValueLabelStyles.root,
            isDisabled && $5e48f853c890b93e$var$multiValueLabelStyles.disabled,
            hasEllipsis && $5e48f853c890b93e$var$multiValueLabelStyles.ellipsis,
            (0, $hUFig.cx)(className, xcss, '-MultiValueLabel')
        ])
    }), children);
};
var $5e48f853c890b93e$var$disabledStyles = null;
var $5e48f853c890b93e$var$enabledStyles = null;
function $5e48f853c890b93e$export$8e1fd1a40e7a2f4a(_ref3) {
    var isDisabled = _ref3.isDisabled, isFocused = _ref3.isFocused, innerProps = _ref3.innerProps, className = _ref3.className, xcss = _ref3.xcss;
    return /*#__PURE__*/ $5FkrB.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, innerProps, {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $970q7.default)([
            $5e48f853c890b93e$var$multiValueRemoveStyles.root,
            isFocused && $5e48f853c890b93e$var$multiValueRemoveStyles.focused,
            (0, $hUFig.cx)(className, xcss, '-MultiValueRemove')
        ])
    }), /*#__PURE__*/ $5FkrB.createElement("div", {
        "data-testid": isDisabled ? 'hide-clear-icon' : 'show-clear-icon',
        className: (0, $970q7.default)([
            isDisabled && "_1e0cglyw",
            !isDisabled && "_1e0c1kw7"
        ])
    }, /*#__PURE__*/ $5FkrB.createElement((0, (/*@__PURE__*/$parcel$interopDefault($6272e7058520f324$exports))), {
        label: "",
        color: "currentColor",
        size: "small"
    })));
}
var $5e48f853c890b93e$var$MultiValue = function MultiValue(props) {
    var children = props.children, components = props.components, data = props.data, innerProps = props.innerProps, isDisabled = props.isDisabled, isFocused = props.isFocused, removeProps = props.removeProps, selectProps = props.selectProps, cropWithEllipsis = props.cropWithEllipsis;
    var Container = components.Container, Label = components.Label, Remove = components.Remove;
    var ariaLabel = typeof children === 'string' ? children : data.label;
    var _getStyleProps = (0, $50a6d89e4bbf23e3$export$26417cabd806a658)(props, 'multiValue', {
        'multi-value': true,
        'multi-value--is-disabled': isDisabled
    }), containerCss = _getStyleProps.css, containerClassName = _getStyleProps.className;
    var _getStyleProps2 = (0, $50a6d89e4bbf23e3$export$26417cabd806a658)(props, 'multiValueLabel', {
        'multi-value__label': true
    }), labelCss = _getStyleProps2.css, labelClassName = _getStyleProps2.className;
    var _getStyleProps3 = (0, $50a6d89e4bbf23e3$export$26417cabd806a658)(props, 'multiValueRemove', {
        'multi-value__remove': true
    }), removeCss = _getStyleProps3.css, removeClassName = _getStyleProps3.className;
    return /*#__PURE__*/ $5FkrB.createElement(Container, {
        data: data,
        innerProps: $5e48f853c890b93e$var$_objectSpread({
            style: containerCss,
            className: containerClassName
        }, innerProps),
        className: containerClassName,
        isFocused: isFocused,
        isDisabled: isDisabled,
        selectProps: selectProps
    }, /*#__PURE__*/ $5FkrB.createElement(Label, {
        data: data,
        innerProps: {
            style: labelCss,
            className: labelClassName
        },
        className: labelClassName,
        hasEllipsis: cropWithEllipsis || cropWithEllipsis === undefined,
        selectProps: selectProps
    }, children), /*#__PURE__*/ $5FkrB.createElement(Remove, {
        data: data,
        innerProps: $5e48f853c890b93e$var$_objectSpread({
            style: removeCss,
            className: removeClassName,
            role: 'button',
            tabIndex: -1,
            'aria-label': "".concat(ariaLabel || 'option', ", remove")
        }, removeProps),
        className: removeClassName,
        isDisabled: isDisabled,
        selectProps: selectProps
    }));
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$5e48f853c890b93e$export$2e2bcd8739ae039 = $5e48f853c890b93e$var$MultiValue;


/* option.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $kqp0i = parcelRequire("kqp0i");

var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");

var $hUFig = parcelRequire("hUFig");

var $9e21c9d7f93529d8$export$ef897119b7e920ba = function optionCSS() {
    return {};
};
var $9e21c9d7f93529d8$var$optionStyles = {
    root: "_1rjc12x7 _18zrutpp _syazi7uo _80om73ad _1e0c1ule _1wyb1kw7 _1bsb1osq _uiztglyw _18ql1j7p _1di6fcek",
    disabled: "_syaz1gmx _80om13gf _bfhk1j28 _16qsglyw _1di61j28 _112eglyw",
    focused: "_bfhk1dpa _16qs1x9r _112e5u6v",
    selected: "_syaz6x5g _bfhk15s3 _16qs1x9r _1di6nozp _112e5u6v",
    focusedSelected: "_bfhkufnl"
};
var $9e21c9d7f93529d8$var$Option = function Option(props) {
    var children = props.children, isDisabled = props.isDisabled, isFocused = props.isFocused, isSelected = props.isSelected, innerRef = props.innerRef, innerProps = props.innerProps, xcss = props.xcss;
    var _getStyleProps = (0, $50a6d89e4bbf23e3$export$26417cabd806a658)(props, 'option', {
        option: true,
        'option--is-disabled': isDisabled,
        'option--is-focused': isFocused,
        'option--is-selected': isSelected
    }), css = _getStyleProps.css, className = _getStyleProps.className;
    return /*#__PURE__*/ $5FkrB.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        className: (0, $970q7.default)([
            $9e21c9d7f93529d8$var$optionStyles.root,
            isFocused && $9e21c9d7f93529d8$var$optionStyles.focused,
            isSelected && $9e21c9d7f93529d8$var$optionStyles.selected,
            isFocused && isSelected && $9e21c9d7f93529d8$var$optionStyles.focusedSelected,
            isDisabled && $9e21c9d7f93529d8$var$optionStyles.disabled,
            (0, $hUFig.cx)(className, xcss, '-option')
        ]),
        ref: innerRef
    }, innerProps, {
        tabIndex: -1
    }), children);
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$9e21c9d7f93529d8$export$2e2bcd8739ae039 = $9e21c9d7f93529d8$var$Option;


/* placeholder.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $kqp0i = parcelRequire("kqp0i");

var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");

var $hUFig = parcelRequire("hUFig");

var $51ef29b13708ee06$export$5f3ffacd6594d90f = function placeholderCSS() {
    return {};
};
var $51ef29b13708ee06$var$placeholderStyles = {
    root: "_nd5l1sux _19pkidpf _2hwxv77o _otyridpf _18u0v77o _syaz1rpy",
    disabled: "_syaz1gmx"
};
var $51ef29b13708ee06$var$Placeholder = function Placeholder(props) {
    var children = props.children, innerProps = props.innerProps, isDisabled = props.isDisabled, xcss = props.xcss;
    var _getStyleProps = (0, $50a6d89e4bbf23e3$export$26417cabd806a658)(props, 'placeholder', {
        placeholder: true
    }), css = _getStyleProps.css, className = _getStyleProps.className;
    return /*#__PURE__*/ $5FkrB.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        className: (0, $970q7.default)([
            $51ef29b13708ee06$var$placeholderStyles.root,
            isDisabled && $51ef29b13708ee06$var$placeholderStyles.disabled,
            (0, $hUFig.cx)(className, xcss, '-placeholder')
        ])
    }, innerProps), children);
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$51ef29b13708ee06$export$2e2bcd8739ae039 = $51ef29b13708ee06$var$Placeholder;


/* single-value.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $kqp0i = parcelRequire("kqp0i");

var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");

var $hUFig = parcelRequire("hUFig");

var $177c4fffd8459068$export$dbf350e5966cf602 = function css() {
    return {};
};
var $177c4fffd8459068$var$styles = {
    root: "_nd5l1sux _1reo15vq _18m915vq _p12f1osq _1bto1l2s _o5721q9c _19pkidpf _2hwxv77o _otyridpf _18u0v77o _syazi7uo",
    disalbed: "_syaz1gmx"
};
var $177c4fffd8459068$var$SingleValue = function SingleValue(props) {
    var children = props.children, isDisabled = props.isDisabled, innerProps = props.innerProps, xcss = props.xcss;
    var _getStyleProps = (0, $50a6d89e4bbf23e3$export$26417cabd806a658)(props, 'singleValue', {
        'single-value': true,
        'single-value--is-disabled': isDisabled
    }), css = _getStyleProps.css, className = _getStyleProps.className;
    return /*#__PURE__*/ $5FkrB.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        className: (0, $970q7.default)([
            $177c4fffd8459068$var$styles.root,
            isDisabled && $177c4fffd8459068$var$styles.disalbed,
            (0, $hUFig.cx)(className, xcss, '-singleValue')
        ])
    }, innerProps), children);
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$177c4fffd8459068$export$2e2bcd8739ae039 = $177c4fffd8459068$var$SingleValue;


function $2bbff6443466b8f8$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $2bbff6443466b8f8$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $2bbff6443466b8f8$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $2bbff6443466b8f8$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $2bbff6443466b8f8$export$9b5ac10f59f76296 = {
    ClearIndicator: (0, $11f89a596a1a68ee$export$ecf9cf59142dd54a),
    Control: (0, $78904a7f8b3a46c8$export$2e2bcd8739ae039),
    DropdownIndicator: (0, $11f89a596a1a68ee$export$ec98719d3db7f2e4),
    Group: (0, $91520e83acff37b7$export$2e2bcd8739ae039),
    GroupHeading: (0, $91520e83acff37b7$export$85c8b41a3cd87edc),
    IndicatorsContainer: (0, $9446594a923771a0$export$d0ffd7e649cab6f),
    Input: (0, $1f35b8bbcacfde3f$export$2e2bcd8739ae039),
    LoadingIndicator: (0, $11f89a596a1a68ee$export$7c20be4c1d342248),
    Menu: (0, $a77dc8ff50c99630$export$2e2bcd8739ae039),
    MenuList: (0, $a77dc8ff50c99630$export$d4c4e98c5044dc8),
    MenuPortal: (0, $a77dc8ff50c99630$export$793392f970497feb),
    LoadingMessage: (0, $a77dc8ff50c99630$export$e928a71d039d3102),
    NoOptionsMessage: (0, $a77dc8ff50c99630$export$d58b72b7d3c4072c),
    MultiValue: (0, $5e48f853c890b93e$export$2e2bcd8739ae039),
    MultiValueContainer: (0, $5e48f853c890b93e$export$cf9cf2a30a59265c),
    MultiValueLabel: (0, $5e48f853c890b93e$export$544aeea2a5ce08ee),
    MultiValueRemove: (0, $5e48f853c890b93e$export$8e1fd1a40e7a2f4a),
    Option: (0, $9e21c9d7f93529d8$export$2e2bcd8739ae039),
    Placeholder: (0, $51ef29b13708ee06$export$2e2bcd8739ae039),
    SelectContainer: (0, $9446594a923771a0$export$446eebadefe1123b),
    SingleValue: (0, $177c4fffd8459068$export$2e2bcd8739ae039),
    ValueContainer: (0, $9446594a923771a0$export$4dc9f58ad9a1a000)
};
var $2bbff6443466b8f8$export$71abc632aa29e6fe = function defaultComponents(props) {
    return $2bbff6443466b8f8$var$_objectSpread($2bbff6443466b8f8$var$_objectSpread({}, $2bbff6443466b8f8$export$9b5ac10f59f76296), props.components);
};


/* dummy-input.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $kqp0i = parcelRequire("kqp0i");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");

var $0dc5e7e11d80c24e$var$_excluded = [
    "innerRef"
];
var $0dc5e7e11d80c24e$var$dummyInputStyles = null;
function $0dc5e7e11d80c24e$export$2e2bcd8739ae039(_ref) {
    var innerRef = _ref.innerRef, props = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $0dc5e7e11d80c24e$var$_excluded);
    // Remove animation props not meant for HTML elements
    var filteredProps = (0, $50a6d89e4bbf23e3$export$4213b25a1c4e877)(props, 'onExited', 'in', 'enter', 'exit', 'appear');
    // eslint-disable-next-line  @atlaskit/ui-styling-standard/no-classname-prop
    return /*#__PURE__*/ $5FkrB.createElement("input", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        ref: innerRef,
        className: (0, $970q7.default)([
            "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _11q7idpf _19itidpf _nd5l1sux _12ji1r31 _1qu2glyw _12y3idpf _1bsbt94y _kqswh2mm _1n5d1j28 _syaz1j28 _1e02p1rm _tzy4idpf _t9ec1kuz",
            "-dummyInput"
        ])
    }, filteredProps));
}

/* required-input.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");

var $eVb4V = parcelRequire("eVb4V");
var $4cc6f93b0da9c7e2$var$styles = null;
var $4cc6f93b0da9c7e2$var$RequiredInput = function RequiredInput(_ref) {
    var name = _ref.name, onFocus = _ref.onFocus;
    return /*#__PURE__*/ $5FkrB.createElement("input", {
        required: true,
        name: name,
        tabIndex: -1,
        "aria-hidden": "true",
        className: (0, $970q7.default)([
            "_1bsb1osq _kqswstnw _u7coidpf _rjxpidpf _1e02idpf _tzy4idpf _lcxvglyw",
            "-requiredInput"
        ]),
        onFocus: onFocus,
        // Prevent `Switching from uncontrolled to controlled` error
        value: "",
        onChange: (0, $eVb4V.default)
    });
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$4cc6f93b0da9c7e2$export$2e2bcd8739ae039 = $4cc6f93b0da9c7e2$var$RequiredInput;


var $5FkrB = parcelRequire("5FkrB");

var $5FkrB = parcelRequire("5FkrB");

var $72b3925ff87c77e7$var$cancelScroll = function cancelScroll(event) {
    if (event.cancelable) event.preventDefault();
    event.stopPropagation();
};
function $72b3925ff87c77e7$export$2e2bcd8739ae039(_ref) {
    var isEnabled = _ref.isEnabled, onBottomArrive = _ref.onBottomArrive, onBottomLeave = _ref.onBottomLeave, onTopArrive = _ref.onTopArrive, onTopLeave = _ref.onTopLeave;
    var isBottom = (0, $5FkrB.useRef)(false);
    var isTop = (0, $5FkrB.useRef)(false);
    var touchStart = (0, $5FkrB.useRef)(0);
    var scrollTarget = (0, $5FkrB.useRef)(null);
    var handleEventDelta = (0, $5FkrB.useCallback)(function(event, delta) {
        if (scrollTarget.current === null) return;
        var _scrollTarget$current = scrollTarget.current, scrollTop = _scrollTarget$current.scrollTop, scrollHeight = _scrollTarget$current.scrollHeight, clientHeight = _scrollTarget$current.clientHeight;
        var target = scrollTarget.current;
        var isDeltaPositive = delta > 0;
        var availableScroll = scrollHeight - clientHeight - scrollTop;
        var shouldCancelScroll = false;
        // reset bottom/top flags
        if (availableScroll > delta && isBottom.current) {
            if (onBottomLeave) onBottomLeave(event);
            isBottom.current = false;
        }
        if (isDeltaPositive && isTop.current) {
            if (onTopLeave) onTopLeave(event);
            isTop.current = false;
        }
        // bottom limit
        if (isDeltaPositive && delta > availableScroll) {
            if (onBottomArrive && !isBottom.current) onBottomArrive(event);
            target.scrollTop = scrollHeight;
            shouldCancelScroll = true;
            isBottom.current = true;
        // top limit
        } else if (!isDeltaPositive && -delta > scrollTop) {
            if (onTopArrive && !isTop.current) onTopArrive(event);
            target.scrollTop = 0;
            shouldCancelScroll = true;
            isTop.current = true;
        }
        // cancel scroll
        if (shouldCancelScroll) $72b3925ff87c77e7$var$cancelScroll(event);
    }, [
        onBottomArrive,
        onBottomLeave,
        onTopArrive,
        onTopLeave
    ]);
    var onWheel = (0, $5FkrB.useCallback)(function(event) {
        handleEventDelta(event, event.deltaY);
    }, [
        handleEventDelta
    ]);
    var onTouchStart = (0, $5FkrB.useCallback)(function(event) {
        // set touch start so we can calculate touchmove delta
        touchStart.current = event.changedTouches[0].clientY;
    }, []);
    var onTouchMove = (0, $5FkrB.useCallback)(function(event) {
        var deltaY = touchStart.current - event.changedTouches[0].clientY;
        handleEventDelta(event, deltaY);
    }, [
        handleEventDelta
    ]);
    var startListening = (0, $5FkrB.useCallback)(function(el) {
        // bail early if no element is available to attach to
        if (!el) return;
        var notPassive = (0, $50a6d89e4bbf23e3$export$b0622a6911dbeaf5) ? {
            passive: false
        } : false;
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        el.addEventListener('wheel', onWheel, notPassive);
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        el.addEventListener('touchstart', onTouchStart, notPassive);
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        el.addEventListener('touchmove', onTouchMove, notPassive);
    }, [
        onTouchMove,
        onTouchStart,
        onWheel
    ]);
    var stopListening = (0, $5FkrB.useCallback)(function(el) {
        // bail early if no element is available to detach from
        if (!el) return;
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        el.removeEventListener('wheel', onWheel, false);
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        el.removeEventListener('touchstart', onTouchStart, false);
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        el.removeEventListener('touchmove', onTouchMove, false);
    }, [
        onTouchMove,
        onTouchStart,
        onWheel
    ]);
    (0, $5FkrB.useEffect)(function() {
        if (!isEnabled) return;
        var element = scrollTarget.current;
        startListening(element);
        return function() {
            stopListening(element);
        };
    }, [
        isEnabled,
        startListening,
        stopListening
    ]);
    return function(element) {
        scrollTarget.current = element;
    };
}



var $5FkrB = parcelRequire("5FkrB");
var $38b0362a623d56ec$var$STYLE_KEYS = [
    'boxSizing',
    'height',
    'overflow',
    'paddingRight',
    'position'
];
var $38b0362a623d56ec$var$LOCK_STYLES = {
    boxSizing: 'border-box',
    // account for possible declaration `width: 100%;` on body
    overflow: 'hidden',
    position: 'relative',
    height: '100%'
};
function $38b0362a623d56ec$var$preventTouchMove(e) {
    e.preventDefault();
}
function $38b0362a623d56ec$var$allowTouchMove(e) {
    e.stopPropagation();
}
function $38b0362a623d56ec$var$preventInertiaScroll() {
    var top = this.scrollTop;
    var totalScroll = this.scrollHeight;
    var currentScroll = top + this.offsetHeight;
    if (top === 0) this.scrollTop = 1;
    else if (currentScroll === totalScroll) this.scrollTop = top - 1;
}
// `ontouchstart` check works on most browsers
// `maxTouchPoints` works on IE10/11 and Surface
function $38b0362a623d56ec$var$isTouchDevice() {
    return 'ontouchstart' in window || navigator.maxTouchPoints;
}
var $38b0362a623d56ec$var$canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
var $38b0362a623d56ec$var$activeScrollLocks = 0;
var $38b0362a623d56ec$var$listenerOptions = {
    capture: false,
    passive: false
};
function $38b0362a623d56ec$export$2e2bcd8739ae039(_ref) {
    var isEnabled = _ref.isEnabled, _ref$accountForScroll = _ref.accountForScrollbars, accountForScrollbars = _ref$accountForScroll === void 0 ? true : _ref$accountForScroll;
    var originalStyles = (0, $5FkrB.useRef)({});
    var scrollTarget = (0, $5FkrB.useRef)(null);
    var addScrollLock = (0, $5FkrB.useCallback)(function(touchScrollTarget) {
        if (!$38b0362a623d56ec$var$canUseDOM) return;
        var target = document.body;
        var targetStyle = target && target.style;
        if (accountForScrollbars) // store any styles already applied to the body
        $38b0362a623d56ec$var$STYLE_KEYS.forEach(function(key) {
            var val = targetStyle && targetStyle[key];
            originalStyles.current[key] = val;
        });
        // apply the lock styles and padding if this is the first scroll lock
        if (accountForScrollbars && $38b0362a623d56ec$var$activeScrollLocks < 1) {
            var currentPadding = parseInt(originalStyles.current.paddingRight, 10) || 0;
            var clientWidth = document.body ? document.body.clientWidth : 0;
            var adjustedPadding = window.innerWidth - clientWidth + currentPadding || 0;
            Object.keys($38b0362a623d56ec$var$LOCK_STYLES).forEach(function(key) {
                var val = $38b0362a623d56ec$var$LOCK_STYLES[key];
                if (targetStyle) targetStyle[key] = val;
            });
            if (targetStyle) targetStyle.paddingRight = "".concat(adjustedPadding, "px");
        }
        // account for touch devices
        if (target && $38b0362a623d56ec$var$isTouchDevice()) {
            // Mobile Safari ignores { overflow: hidden } declaration on the body.
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            target.addEventListener('touchmove', $38b0362a623d56ec$var$preventTouchMove, $38b0362a623d56ec$var$listenerOptions);
            // Allow scroll on provided target
            if (touchScrollTarget) {
                // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                touchScrollTarget.addEventListener('touchstart', $38b0362a623d56ec$var$preventInertiaScroll, $38b0362a623d56ec$var$listenerOptions);
                // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                touchScrollTarget.addEventListener('touchmove', $38b0362a623d56ec$var$allowTouchMove, $38b0362a623d56ec$var$listenerOptions);
            }
        }
        // increment active scroll locks
        $38b0362a623d56ec$var$activeScrollLocks += 1;
    }, [
        accountForScrollbars
    ]);
    var removeScrollLock = (0, $5FkrB.useCallback)(function(touchScrollTarget) {
        if (!$38b0362a623d56ec$var$canUseDOM) return;
        var target = document.body;
        var targetStyle = target && target.style;
        // safely decrement active scroll locks
        $38b0362a623d56ec$var$activeScrollLocks = Math.max($38b0362a623d56ec$var$activeScrollLocks - 1, 0);
        // reapply original body styles, if any
        if (accountForScrollbars && $38b0362a623d56ec$var$activeScrollLocks < 1) $38b0362a623d56ec$var$STYLE_KEYS.forEach(function(key) {
            var val = originalStyles.current[key];
            if (targetStyle) targetStyle[key] = val;
        });
        // remove touch listeners
        if (target && $38b0362a623d56ec$var$isTouchDevice()) {
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            target.removeEventListener('touchmove', $38b0362a623d56ec$var$preventTouchMove, $38b0362a623d56ec$var$listenerOptions);
            if (touchScrollTarget) {
                // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                touchScrollTarget.removeEventListener('touchstart', $38b0362a623d56ec$var$preventInertiaScroll, $38b0362a623d56ec$var$listenerOptions);
                // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                touchScrollTarget.removeEventListener('touchmove', $38b0362a623d56ec$var$allowTouchMove, $38b0362a623d56ec$var$listenerOptions);
            }
        }
    }, [
        accountForScrollbars
    ]);
    (0, $5FkrB.useEffect)(function() {
        if (!isEnabled) return;
        var element = scrollTarget.current;
        addScrollLock(element);
        return function() {
            removeScrollLock(element);
        };
    }, [
        isEnabled,
        addScrollLock,
        removeScrollLock
    ]);
    return function(element) {
        scrollTarget.current = element;
    };
}


var $54b15de582ede229$var$blurSelectInput = function blurSelectInput(event) {
    var element = event.target;
    return element.ownerDocument.activeElement && element.ownerDocument.activeElement.blur();
};
function $54b15de582ede229$export$2e2bcd8739ae039(_ref) {
    var children = _ref.children, lockEnabled = _ref.lockEnabled, _ref$captureEnabled = _ref.captureEnabled, captureEnabled = _ref$captureEnabled === void 0 ? true : _ref$captureEnabled, onBottomArrive = _ref.onBottomArrive, onBottomLeave = _ref.onBottomLeave, onTopArrive = _ref.onTopArrive, onTopLeave = _ref.onTopLeave;
    var setScrollCaptureTarget = (0, $72b3925ff87c77e7$export$2e2bcd8739ae039)({
        isEnabled: captureEnabled,
        onBottomArrive: onBottomArrive,
        onBottomLeave: onBottomLeave,
        onTopArrive: onTopArrive,
        onTopLeave: onTopLeave
    });
    var setScrollLockTarget = (0, $38b0362a623d56ec$export$2e2bcd8739ae039)({
        isEnabled: lockEnabled
    });
    var targetRef = function targetRef(element) {
        setScrollCaptureTarget(element);
        setScrollLockTarget(element);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $5FkrB.Fragment), null, lockEnabled && /*#__PURE__*/ // eslint-disable-next-line @atlassian/a11y/click-events-have-key-events, @atlassian/a11y/interactive-element-not-keyboard-focusable, @atlassian/a11y/no-static-element-interactions
    (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("div", {
        onClick: $54b15de582ede229$var$blurSelectInput,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            position: 'fixed',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            insetBlockEnd: 0,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            insetBlockStart: 0,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            insetInlineEnd: 0,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            insetInlineStart: 0
        }
    }), children(targetRef));
}



var $iUCre = parcelRequire("iUCre");
function $442ffdf37e3241fb$export$17baa7c95b6ba1b8(_ref) {
    var isOpen = _ref.isOpen, onClose = _ref.onClose;
    // @ts-ignore - hot-116676
    (0, $iUCre.useNotifyOpenLayerObserver)({
        isOpen: isOpen,
        onClose: onClose
    });
    return null;
}



var $25nEq = parcelRequire("25nEq");

var $5FkrB = parcelRequire("5FkrB");
var $1103e6a2814cf926$export$a7265767c78f9bae = {
    onChange: function onChange(props) {
        var action = props.action, _props$label = props.label, label = _props$label === void 0 ? '' : _props$label, isDisabled = props.isDisabled;
        switch(action){
            case 'deselect-option':
            case 'pop-value':
            case 'remove-value':
                return label.length ? "option ".concat(label, ", deselected") : '';
            case 'clear':
                return 'All selected options have been cleared.';
            case 'select-option':
                return label.length && !isDisabled ? "option ".concat(label, ", selected.") : '';
            default:
                return '';
        }
    },
    onFilter: function onFilter(props) {
        var inputValue = props.inputValue, resultsMessage = props.resultsMessage;
        return inputValue ? "".concat(resultsMessage, " for search term ").concat(inputValue, ".") : '';
    }
};


/* a11y-text.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $kqp0i = parcelRequire("kqp0i");

var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");
// Assistive text to describe visual elements. Hidden for sighted users.
var $ff5f76524911c074$var$styles = null;
var $ff5f76524911c074$var$A11yText = function A11yText(props) {
    return /*#__PURE__*/ $5FkrB.createElement("span", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        // eslint-disable-next-line  @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $970q7.default)([
            "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19itidpf _1reo15vq _18m915vq _1bsbt94y _4t3it94y _kqswstnw _1pbydx66 _ogto7mnp _uiztglyw _o5721q9c",
            "-a11yText"
        ])
    }, props));
};
var $ff5f76524911c074$export$2e2bcd8739ae039 = $ff5f76524911c074$var$A11yText;


function $c81d539ea60715b1$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $c81d539ea60715b1$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $c81d539ea60715b1$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $c81d539ea60715b1$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
// ==============================
// Root Container
// ==============================
var $c81d539ea60715b1$var$LiveRegion = function LiveRegion(props) {
    var ariaSelection = props.ariaSelection, focusableOptions = props.focusableOptions, isFocused = props.isFocused, selectValue = props.selectValue, selectProps = props.selectProps, id = props.id;
    var ariaLiveMessages = selectProps.ariaLiveMessages, getOptionLabel = selectProps.getOptionLabel, inputValue = selectProps.inputValue, isOptionDisabled = selectProps.isOptionDisabled, menuIsOpen = selectProps.menuIsOpen, options = selectProps.options, screenReaderStatus = selectProps.screenReaderStatus, isLoading = selectProps.isLoading;
    var ariaLive = selectProps['aria-live'];
    // Update aria live message configuration when prop changes
    var messages = (0, $5FkrB.useMemo)(function() {
        return $c81d539ea60715b1$var$_objectSpread($c81d539ea60715b1$var$_objectSpread({}, (0, $1103e6a2814cf926$export$a7265767c78f9bae)), ariaLiveMessages || {});
    }, [
        ariaLiveMessages
    ]);
    // Update aria live selected option when prop changes
    var ariaSelected = (0, $5FkrB.useMemo)(function() {
        var message = '';
        if (menuIsOpen) // we don't need to have selected message when the menu is open
        return '';
        if (ariaSelection && messages.onChange) {
            var option = ariaSelection.option, selectedOptions = ariaSelection.options, removedValue = ariaSelection.removedValue, removedValues = ariaSelection.removedValues, value = ariaSelection.value;
            // select-option when !isMulti does not return option so we assume selected option is value
            var asOption = function asOption(val) {
                return !Array.isArray(val) ? val : null;
            };
            // If there is just one item from the action then get its label
            var selected = removedValue || option || asOption(value);
            var label = selected ? getOptionLabel(selected) : '';
            // If there are multiple items from the action then return an array of labels
            var multiSelected = selectedOptions || removedValues || undefined;
            var labels = multiSelected ? multiSelected.map(getOptionLabel) : [];
            if (!label && !labels.length) // return empty string if no labels provided
            return '';
            var onChangeProps = $c81d539ea60715b1$var$_objectSpread({
                // multiSelected items are usually items that have already been selected
                // or set by the user as a default value so we assume they are not disabled
                isDisabled: selected && isOptionDisabled(selected, selectValue),
                label: label,
                labels: labels
            }, ariaSelection);
            message = messages.onChange(onChangeProps);
        }
        return message;
    }, [
        ariaSelection,
        messages,
        isOptionDisabled,
        selectValue,
        getOptionLabel,
        menuIsOpen
    ]);
    var ariaResults = (0, $5FkrB.useMemo)(function() {
        var resultsMsg = '';
        if (isLoading) resultsMsg = 'Loading. ';
        if (menuIsOpen && options.length && !isLoading && messages.onFilter) {
            var resultsMessage = screenReaderStatus({
                count: focusableOptions.length
            });
            resultsMsg = messages.onFilter({
                inputValue: inputValue,
                resultsMessage: resultsMessage
            });
        }
        if (options && options.length === 0) resultsMsg = 'No options. ';
        return resultsMsg;
    }, [
        focusableOptions,
        inputValue,
        menuIsOpen,
        messages,
        options,
        screenReaderStatus,
        isLoading
    ]);
    var isInitialFocus = (ariaSelection === null || ariaSelection === void 0 ? void 0 : ariaSelection.action) === 'initial-input-focus';
    var ScreenReaderText = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $5FkrB.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("span", {
        id: "aria-selection"
    }, ariaSelected), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("span", {
        id: "aria-results"
    }, ariaResults));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $5FkrB.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $ff5f76524911c074$export$2e2bcd8739ae039), {
        id: id
    }, isInitialFocus && ScreenReaderText), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $ff5f76524911c074$export$2e2bcd8739ae039), {
        "aria-live": ariaLive // Should be undefined by default unless a specific use case requires it
        ,
        role: "status"
    }, isFocused && !isInitialFocus && ScreenReaderText));
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$c81d539ea60715b1$export$2e2bcd8739ae039 = $c81d539ea60715b1$var$LiveRegion;




var $25nEq = parcelRequire("25nEq");

var $cvlyC = parcelRequire("cvlyC");
var $0a9c376730e95191$var$diacritics = [
    {
        base: 'A',
        letters: "A\u24B6\uFF21\xC0\xC1\xC2\u1EA6\u1EA4\u1EAA\u1EA8\xC3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\xC4\u01DE\u1EA2\xC5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F"
    },
    {
        base: 'AA',
        letters: "\uA732"
    },
    {
        base: 'AE',
        letters: "\xC6\u01FC\u01E2"
    },
    {
        base: 'AO',
        letters: "\uA734"
    },
    {
        base: 'AU',
        letters: "\uA736"
    },
    {
        base: 'AV',
        letters: "\uA738\uA73A"
    },
    {
        base: 'AY',
        letters: "\uA73C"
    },
    {
        base: 'B',
        letters: "B\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181"
    },
    {
        base: 'C',
        letters: "C\u24B8\uFF23\u0106\u0108\u010A\u010C\xC7\u1E08\u0187\u023B\uA73E"
    },
    {
        base: 'D',
        letters: "D\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779"
    },
    {
        base: 'DZ',
        letters: "\u01F1\u01C4"
    },
    {
        base: 'Dz',
        letters: "\u01F2\u01C5"
    },
    {
        base: 'E',
        letters: "E\u24BA\uFF25\xC8\xC9\xCA\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\xCB\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E"
    },
    {
        base: 'F',
        letters: "F\u24BB\uFF26\u1E1E\u0191\uA77B"
    },
    {
        base: 'G',
        letters: "G\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E"
    },
    {
        base: 'H',
        letters: "H\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D"
    },
    {
        base: 'I',
        letters: "I\u24BE\uFF29\xCC\xCD\xCE\u0128\u012A\u012C\u0130\xCF\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197"
    },
    {
        base: 'J',
        letters: "J\u24BF\uFF2A\u0134\u0248"
    },
    {
        base: 'K',
        letters: "K\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2"
    },
    {
        base: 'L',
        letters: "L\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780"
    },
    {
        base: 'LJ',
        letters: "\u01C7"
    },
    {
        base: 'Lj',
        letters: "\u01C8"
    },
    {
        base: 'M',
        letters: "M\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C"
    },
    {
        base: 'N',
        letters: "N\u24C3\uFF2E\u01F8\u0143\xD1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4"
    },
    {
        base: 'NJ',
        letters: "\u01CA"
    },
    {
        base: 'Nj',
        letters: "\u01CB"
    },
    {
        base: 'O',
        letters: "O\u24C4\uFF2F\xD2\xD3\xD4\u1ED2\u1ED0\u1ED6\u1ED4\xD5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\xD6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\xD8\u01FE\u0186\u019F\uA74A\uA74C"
    },
    {
        base: 'OI',
        letters: "\u01A2"
    },
    {
        base: 'OO',
        letters: "\uA74E"
    },
    {
        base: 'OU',
        letters: "\u0222"
    },
    {
        base: 'P',
        letters: "P\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754"
    },
    {
        base: 'Q',
        letters: "Q\u24C6\uFF31\uA756\uA758\u024A"
    },
    {
        base: 'R',
        letters: "R\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782"
    },
    {
        base: 'S',
        letters: "S\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784"
    },
    {
        base: 'T',
        letters: "T\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786"
    },
    {
        base: 'TZ',
        letters: "\uA728"
    },
    {
        base: 'U',
        letters: "U\u24CA\uFF35\xD9\xDA\xDB\u0168\u1E78\u016A\u1E7A\u016C\xDC\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244"
    },
    {
        base: 'V',
        letters: "V\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245"
    },
    {
        base: 'VY',
        letters: "\uA760"
    },
    {
        base: 'W',
        letters: "W\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72"
    },
    {
        base: 'X',
        letters: "X\u24CD\uFF38\u1E8A\u1E8C"
    },
    {
        base: 'Y',
        letters: "Y\u24CE\uFF39\u1EF2\xDD\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE"
    },
    {
        base: 'Z',
        letters: "Z\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762"
    },
    {
        base: 'a',
        letters: "a\u24D0\uFF41\u1E9A\xE0\xE1\xE2\u1EA7\u1EA5\u1EAB\u1EA9\xE3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\xE4\u01DF\u1EA3\xE5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250"
    },
    {
        base: 'aa',
        letters: "\uA733"
    },
    {
        base: 'ae',
        letters: "\xE6\u01FD\u01E3"
    },
    {
        base: 'ao',
        letters: "\uA735"
    },
    {
        base: 'au',
        letters: "\uA737"
    },
    {
        base: 'av',
        letters: "\uA739\uA73B"
    },
    {
        base: 'ay',
        letters: "\uA73D"
    },
    {
        base: 'b',
        letters: "b\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253"
    },
    {
        base: 'c',
        letters: "c\u24D2\uFF43\u0107\u0109\u010B\u010D\xE7\u1E09\u0188\u023C\uA73F\u2184"
    },
    {
        base: 'd',
        letters: "d\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A"
    },
    {
        base: 'dz',
        letters: "\u01F3\u01C6"
    },
    {
        base: 'e',
        letters: "e\u24D4\uFF45\xE8\xE9\xEA\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\xEB\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD"
    },
    {
        base: 'f',
        letters: "f\u24D5\uFF46\u1E1F\u0192\uA77C"
    },
    {
        base: 'g',
        letters: "g\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F"
    },
    {
        base: 'h',
        letters: "h\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265"
    },
    {
        base: 'hv',
        letters: "\u0195"
    },
    {
        base: 'i',
        letters: "i\u24D8\uFF49\xEC\xED\xEE\u0129\u012B\u012D\xEF\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131"
    },
    {
        base: 'j',
        letters: "j\u24D9\uFF4A\u0135\u01F0\u0249"
    },
    {
        base: 'k',
        letters: "k\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3"
    },
    {
        base: 'l',
        letters: "l\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747"
    },
    {
        base: 'lj',
        letters: "\u01C9"
    },
    {
        base: 'm',
        letters: "m\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F"
    },
    {
        base: 'n',
        letters: "n\u24DD\uFF4E\u01F9\u0144\xF1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5"
    },
    {
        base: 'nj',
        letters: "\u01CC"
    },
    {
        base: 'o',
        letters: "o\u24DE\uFF4F\xF2\xF3\xF4\u1ED3\u1ED1\u1ED7\u1ED5\xF5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\xF6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\xF8\u01FF\u0254\uA74B\uA74D\u0275"
    },
    {
        base: 'oi',
        letters: "\u01A3"
    },
    {
        base: 'ou',
        letters: "\u0223"
    },
    {
        base: 'oo',
        letters: "\uA74F"
    },
    {
        base: 'p',
        letters: "p\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755"
    },
    {
        base: 'q',
        letters: "q\u24E0\uFF51\u024B\uA757\uA759"
    },
    {
        base: 'r',
        letters: "r\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783"
    },
    {
        base: 's',
        letters: "s\u24E2\uFF53\xDF\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B"
    },
    {
        base: 't',
        letters: "t\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787"
    },
    {
        base: 'tz',
        letters: "\uA729"
    },
    {
        base: 'u',
        letters: "u\u24E4\uFF55\xF9\xFA\xFB\u0169\u1E79\u016B\u1E7B\u016D\xFC\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289"
    },
    {
        base: 'v',
        letters: "v\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C"
    },
    {
        base: 'vy',
        letters: "\uA761"
    },
    {
        base: 'w',
        letters: "w\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73"
    },
    {
        base: 'x',
        letters: "x\u24E7\uFF58\u1E8B\u1E8D"
    },
    {
        base: 'y',
        letters: "y\u24E8\uFF59\u1EF3\xFD\u0177\u1EF9\u0233\u1E8F\xFF\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF"
    },
    {
        base: 'z',
        letters: "z\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763"
    }
];
var $0a9c376730e95191$var$anyDiacritic = new RegExp('[' + $0a9c376730e95191$var$diacritics.map(function(d) {
    return d.letters;
}).join('') + ']', 'g');
var $0a9c376730e95191$var$diacriticToBase = {};
for(var $0a9c376730e95191$var$i = 0; $0a9c376730e95191$var$i < $0a9c376730e95191$var$diacritics.length; $0a9c376730e95191$var$i++){
    var $0a9c376730e95191$var$diacritic = $0a9c376730e95191$var$diacritics[$0a9c376730e95191$var$i];
    for(var $0a9c376730e95191$var$j = 0; $0a9c376730e95191$var$j < $0a9c376730e95191$var$diacritic.letters.length; $0a9c376730e95191$var$j++)$0a9c376730e95191$var$diacriticToBase[$0a9c376730e95191$var$diacritic.letters[$0a9c376730e95191$var$j]] = $0a9c376730e95191$var$diacritic.base;
}
var $0a9c376730e95191$export$b5bee4b27048330b = function stripDiacritics(str) {
    return str.replace($0a9c376730e95191$var$anyDiacritic, function(match) {
        return $0a9c376730e95191$var$diacriticToBase[match];
    });
};


function $366a84ae22bf27be$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $366a84ae22bf27be$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $366a84ae22bf27be$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $366a84ae22bf27be$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $366a84ae22bf27be$var$memoizedStripDiacriticsForInput = (0, $cvlyC.default)((0, $0a9c376730e95191$export$b5bee4b27048330b));
var $366a84ae22bf27be$var$trimString = function trimString(str) {
    return str.replace(/^\s+|\s+$/g, '');
};
var $366a84ae22bf27be$var$defaultStringify = function defaultStringify(option) {
    return "".concat(option.label, " ").concat(option.value);
};
var $366a84ae22bf27be$export$5d81789ff4aeccdf = function createFilter(config) {
    return function(option, rawInput) {
        if (option.data.__isNew__) return true;
        var _ignoreCase$ignoreAcc = $366a84ae22bf27be$var$_objectSpread({
            ignoreCase: true,
            ignoreAccents: true,
            stringify: $366a84ae22bf27be$var$defaultStringify,
            trim: true,
            matchFrom: 'any'
        }, config), ignoreCase = _ignoreCase$ignoreAcc.ignoreCase, ignoreAccents = _ignoreCase$ignoreAcc.ignoreAccents, stringify = _ignoreCase$ignoreAcc.stringify, trim = _ignoreCase$ignoreAcc.trim, matchFrom = _ignoreCase$ignoreAcc.matchFrom;
        var input = trim ? $366a84ae22bf27be$var$trimString(rawInput) : rawInput;
        var candidate = trim ? $366a84ae22bf27be$var$trimString(stringify(option)) : stringify(option);
        if (ignoreCase) {
            input = input.toLowerCase();
            candidate = candidate.toLowerCase();
        }
        if (ignoreAccents) {
            input = $366a84ae22bf27be$var$memoizedStripDiacriticsForInput(input);
            candidate = (0, $0a9c376730e95191$export$b5bee4b27048330b)(candidate);
        }
        return matchFrom === 'start' ? candidate.substr(0, input.length) === input : candidate.indexOf(input) > -1;
    };
};



var $25nEq = parcelRequire("25nEq");










function $e4177ea1f14f060f$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $e4177ea1f14f060f$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $e4177ea1f14f060f$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $e4177ea1f14f060f$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $e4177ea1f14f060f$export$214b055320e0bf32 = {
    clearIndicator: (0, $11f89a596a1a68ee$export$9c0419fd944c1def),
    container: (0, $9446594a923771a0$export$949392aeaf7d2e3a),
    control: (0, $78904a7f8b3a46c8$export$dbf350e5966cf602),
    dropdownIndicator: (0, $11f89a596a1a68ee$export$e1687335805e1230),
    group: (0, $91520e83acff37b7$export$b6794329c1460634),
    groupHeading: (0, $91520e83acff37b7$export$e5a7fbb542efcb7d),
    indicatorsContainer: (0, $9446594a923771a0$export$9d74e3c8b5868ad7),
    input: (0, $1f35b8bbcacfde3f$export$14a7781d0ca7abea),
    loadingIndicator: (0, $11f89a596a1a68ee$export$1d3f24cde248e6b5),
    loadingMessage: (0, $a77dc8ff50c99630$export$98ec46397a8cb3cd),
    menu: (0, $a77dc8ff50c99630$export$a228922d5ca42a79),
    menuList: (0, $a77dc8ff50c99630$export$abafed69cff95d5e),
    menuPortal: (0, $a77dc8ff50c99630$export$1dbbeb9648d1fdc9),
    multiValue: (0, $5e48f853c890b93e$export$23c213f7717186af),
    multiValueLabel: (0, $5e48f853c890b93e$export$f40612612e0af964),
    multiValueRemove: (0, $5e48f853c890b93e$export$283467f6c4ac142b),
    noOptionsMessage: (0, $a77dc8ff50c99630$export$cf0e22534d8b0074),
    option: (0, $9e21c9d7f93529d8$export$ef897119b7e920ba),
    placeholder: (0, $51ef29b13708ee06$export$5f3ffacd6594d90f),
    singleValue: (0, $177c4fffd8459068$export$dbf350e5966cf602),
    valueContainer: (0, $9446594a923771a0$export$47aec73c7aa6b9aa)
};
function $e4177ea1f14f060f$export$e618dc39ac9ad607(source) {
    var target = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    // initialize with source styles
    var styles = $e4177ea1f14f060f$var$_objectSpread({}, source);
    // massage in target styles
    Object.keys(target).forEach(function(keyAsString) {
        var key = keyAsString;
        if (source[key]) styles[key] = function(rsCss, props) {
            return target[key](source[key](rsCss, props), props);
        };
        else styles[key] = target[key];
    });
    return styles;
}



function $54e95eb3eee12ee7$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $54e95eb3eee12ee7$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $54e95eb3eee12ee7$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $54e95eb3eee12ee7$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $54e95eb3eee12ee7$var$_callSuper(t, o, e) {
    return o = (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(o), (0, (/*@__PURE__*/$parcel$interopDefault($kIXpt)))(t, $54e95eb3eee12ee7$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(t).constructor) : o.apply(t, e));
}
function $54e95eb3eee12ee7$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($54e95eb3eee12ee7$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $54e95eb3eee12ee7$export$9c21a3269931e1e6 = {
    backspaceRemovesValue: true,
    blurInputOnSelect: (0, $50a6d89e4bbf23e3$export$56963d77dbffdde7)(),
    captureMenuScroll: !(0, $50a6d89e4bbf23e3$export$56963d77dbffdde7)(),
    classNames: {},
    closeMenuOnSelect: true,
    closeMenuOnScroll: false,
    components: {},
    controlShouldRenderValue: true,
    escapeClearsValue: false,
    filterOption: (0, $366a84ae22bf27be$export$5d81789ff4aeccdf)(),
    formatGroupLabel: (0, $0a1bf1a32914c625$export$f4da216a6ca54656),
    getOptionLabel: (0, $0a1bf1a32914c625$export$dac6ace3020563ca),
    getOptionValue: (0, $0a1bf1a32914c625$export$40be908210c5a79c),
    isDisabled: false,
    isLoading: false,
    isMulti: false,
    isRtl: false,
    isSearchable: true,
    isOptionDisabled: (0, $0a1bf1a32914c625$export$56bd0c8d90db075),
    loadingMessage: function loadingMessage() {
        return 'Loading...';
    },
    maxMenuHeight: 300,
    minMenuHeight: 140,
    menuIsOpen: false,
    menuPlacement: 'bottom',
    menuPosition: 'absolute',
    menuShouldBlockScroll: false,
    menuShouldScrollIntoView: !(0, $50a6d89e4bbf23e3$export$44f917bf91becd01)(),
    noOptionsMessage: function noOptionsMessage() {
        return 'No options';
    },
    openMenuOnFocus: false,
    openMenuOnClick: true,
    shouldPreventEscapePropagation: false,
    options: [],
    pageSize: 5,
    placeholder: 'Select...',
    screenReaderStatus: function screenReaderStatus(_ref) {
        var count = _ref.count;
        return "".concat(count, " result").concat(count !== 1 ? 's' : '', " available");
    },
    styles: {},
    tabIndex: 0,
    tabSelectsValue: true,
    UNSAFE_is_experimental_generic: false,
    shouldKeepInputOnSelect: false
};
function $54e95eb3eee12ee7$var$toCategorizedOption(props, option, selectValue, index) {
    var isDisabled = $54e95eb3eee12ee7$var$_isOptionDisabled(props, option, selectValue);
    var isSelected = $54e95eb3eee12ee7$var$_isOptionSelected(props, option, selectValue);
    var label = $54e95eb3eee12ee7$var$getOptionLabel(props, option);
    var value = $54e95eb3eee12ee7$var$getOptionValue(props, option);
    return {
        type: 'option',
        data: option,
        isDisabled: isDisabled,
        isSelected: isSelected,
        label: label,
        value: value,
        index: index
    };
}
function $54e95eb3eee12ee7$var$buildCategorizedOptions(props, selectValue) {
    return props.options.map(function(groupOrOption, groupOrOptionIndex) {
        //@ts-ignore
        if ('options' in groupOrOption) {
            var categorizedOptions = groupOrOption.options.map(function(option, optionIndex) {
                return $54e95eb3eee12ee7$var$toCategorizedOption(props, option, selectValue, optionIndex);
            }).filter(function(categorizedOption) {
                return $54e95eb3eee12ee7$var$isFocusable(props, categorizedOption);
            });
            return categorizedOptions.length > 0 ? {
                type: 'group',
                data: groupOrOption,
                options: categorizedOptions,
                index: groupOrOptionIndex
            } : undefined;
        }
        var categorizedOption = $54e95eb3eee12ee7$var$toCategorizedOption(props, groupOrOption, selectValue, groupOrOptionIndex);
        return $54e95eb3eee12ee7$var$isFocusable(props, categorizedOption) ? categorizedOption : undefined;
    }).filter((0, $50a6d89e4bbf23e3$export$aedb69ff3e31596c));
}
function $54e95eb3eee12ee7$var$buildFocusableOptionsFromCategorizedOptions(categorizedOptions) {
    return categorizedOptions.reduce(function(optionsAccumulator, categorizedOption) {
        if (categorizedOption.type === 'group') optionsAccumulator.push.apply(optionsAccumulator, (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(categorizedOption.options.map(function(option) {
            return option.data;
        })));
        else optionsAccumulator.push(categorizedOption.data);
        return optionsAccumulator;
    }, []);
}
function $54e95eb3eee12ee7$var$buildFocusableOptionsWithIds(categorizedOptions, optionId) {
    return categorizedOptions.reduce(function(optionsAccumulator, categorizedOption) {
        if (categorizedOption.type === 'group') optionsAccumulator.push.apply(optionsAccumulator, (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(categorizedOption.options.map(function(option) {
            return {
                data: option.data,
                id: "".concat(optionId, "-").concat(categorizedOption.index, "-").concat(option.index)
            };
        })));
        else optionsAccumulator.push({
            data: categorizedOption.data,
            id: "".concat(optionId, "-").concat(categorizedOption.index)
        });
        return optionsAccumulator;
    }, []);
}
function $54e95eb3eee12ee7$var$buildFocusableOptions(props, selectValue) {
    return $54e95eb3eee12ee7$var$buildFocusableOptionsFromCategorizedOptions($54e95eb3eee12ee7$var$buildCategorizedOptions(props, selectValue));
}
function $54e95eb3eee12ee7$var$isFocusable(props, categorizedOption) {
    var _props$inputValue = props.inputValue, inputValue = _props$inputValue === void 0 ? '' : _props$inputValue;
    var data = categorizedOption.data, isSelected = categorizedOption.isSelected, label = categorizedOption.label, value = categorizedOption.value;
    return (!$54e95eb3eee12ee7$var$shouldHideSelectedOptions(props) || !isSelected) && $54e95eb3eee12ee7$var$_filterOption(props, {
        label: label,
        value: value,
        data: data
    }, inputValue);
}
function $54e95eb3eee12ee7$var$getNextFocusedValue(state, nextSelectValue) {
    var focusedValue = state.focusedValue, lastSelectValue = state.selectValue;
    var lastFocusedIndex = lastSelectValue.indexOf(focusedValue);
    if (lastFocusedIndex > -1) {
        var nextFocusedIndex = nextSelectValue.indexOf(focusedValue);
        if (nextFocusedIndex > -1) // the focused value is still in the selectValue, return it
        return focusedValue;
        else if (lastFocusedIndex < nextSelectValue.length) // the focusedValue is not present in the next selectValue array by
        // reference, so return the new value at the same index
        return nextSelectValue[lastFocusedIndex];
    }
    return null;
}
function $54e95eb3eee12ee7$var$getNextFocusedOption(state, options) {
    var lastFocusedOption = state.focusedOption;
    return lastFocusedOption && options.indexOf(lastFocusedOption) > -1 ? lastFocusedOption : options[0];
}
var $54e95eb3eee12ee7$var$getFocusedOptionId = function getFocusedOptionId(focusableOptionsWithIds, focusedOption) {
    var _focusableOptionsWith;
    var focusedOptionId = (_focusableOptionsWith = focusableOptionsWithIds.find(function(option) {
        return option.data === focusedOption;
    })) === null || _focusableOptionsWith === void 0 ? void 0 : _focusableOptionsWith.id;
    return focusedOptionId || null;
};
var $54e95eb3eee12ee7$var$getOptionLabel = function getOptionLabel(props, data) {
    return props.getOptionLabel(data);
};
var $54e95eb3eee12ee7$var$getOptionValue = function getOptionValue(props, data) {
    return props.getOptionValue(data);
};
function $54e95eb3eee12ee7$var$_isOptionDisabled(props, option, selectValue) {
    return typeof props.isOptionDisabled === 'function' ? props.isOptionDisabled(option, selectValue) : false;
}
function $54e95eb3eee12ee7$var$_isOptionSelected(props, option, selectValue) {
    if (selectValue.indexOf(option) > -1) return true;
    if (typeof props.isOptionSelected === 'function') return props.isOptionSelected(option, selectValue);
    var candidate = $54e95eb3eee12ee7$var$getOptionValue(props, option);
    return selectValue.some(function(i) {
        return $54e95eb3eee12ee7$var$getOptionValue(props, i) === candidate;
    });
}
function $54e95eb3eee12ee7$var$_filterOption(props, option, inputValue) {
    return props.filterOption ? props.filterOption(option, inputValue) : true;
}
var $54e95eb3eee12ee7$var$shouldHideSelectedOptions = function shouldHideSelectedOptions(props) {
    var hideSelectedOptions = props.hideSelectedOptions, isMulti = props.isMulti;
    if (hideSelectedOptions === undefined) return isMulti;
    return hideSelectedOptions;
};
var $54e95eb3eee12ee7$var$instanceId = 1;
// eslint-disable-next-line @repo/internal/react/no-class-components
var $54e95eb3eee12ee7$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_Component) {
    // Lifecycle
    // ------------------------------
    function Select(_props) {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, Select);
        _this = $54e95eb3eee12ee7$var$_callSuper(this, Select, [
            _props
        ]);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "state", {
            ariaSelection: null,
            focusedOption: null,
            focusedOptionId: null,
            focusableOptionsWithIds: [],
            focusedValue: null,
            focusedValueId: null,
            inputIsHidden: false,
            isFocused: false,
            selectValue: [],
            clearFocusValueOnUpdate: false,
            prevWasFocused: false,
            inputIsHiddenAfterUpdate: undefined,
            prevProps: undefined,
            instancePrefix: ''
        });
        // Misc. Instance Properties
        // ------------------------------
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "blockOptionHover", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "isComposing", false);
        // TODO
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "initialTouchX", 0);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "initialTouchY", 0);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "openAfterFocus", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "scrollToFocusedOptionOnUpdate", false);
        // Refs
        // ------------------------------
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "controlRef", null);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "getControlRef", function(ref) {
            _this.controlRef = ref;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "focusedOptionRef", null);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "getFocusedOptionRef", function(ref) {
            _this.focusedOptionRef = ref;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "menuListRef", null);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "getMenuListRef", function(ref) {
            _this.menuListRef = ref;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "inputRef", null);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "getInputRef", function(ref) {
            _this.inputRef = ref;
        });
        // aliased for consumers
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "focus", _this.focusInput);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "blur", _this.blurInput);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "onChange", function(newValue, actionMeta) {
            var _this$props = _this.props, onChange = _this$props.onChange, name = _this$props.name;
            actionMeta.name = name;
            _this.ariaOnChange(newValue, actionMeta);
            onChange(newValue, actionMeta);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "setValue", function(newValue, action, option) {
            var _this$props2 = _this.props, closeMenuOnSelect = _this$props2.closeMenuOnSelect, isMulti = _this$props2.isMulti, inputValue = _this$props2.inputValue, shouldKeepInputOnSelect = _this$props2.shouldKeepInputOnSelect;
            // for multiple selection options, do not clear the search input value
            if (isMulti && shouldKeepInputOnSelect && (0, $id6Cu.fg)('platform_do_not_clear_input_for_multiselect')) _this.onInputChange(inputValue, {
                action: 'set-value',
                prevInputValue: inputValue
            });
            else _this.onInputChange('', {
                action: 'set-value',
                prevInputValue: inputValue
            });
            if (closeMenuOnSelect) {
                _this.setState({
                    inputIsHiddenAfterUpdate: !isMulti
                });
                _this.onMenuClose();
            }
            // when the select value should change, we should reset focusedValue
            _this.setState({
                clearFocusValueOnUpdate: true
            });
            _this.onChange(newValue, {
                action: action,
                option: option
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "selectOption", function(newValue) {
            var _this$props3 = _this.props, blurInputOnSelect = _this$props3.blurInputOnSelect, isMulti = _this$props3.isMulti, name = _this$props3.name;
            var selectValue = _this.state.selectValue;
            var deselected = isMulti && _this.isOptionSelected(newValue, selectValue);
            var isDisabled = _this.isOptionDisabled(newValue, selectValue);
            if (deselected) {
                var candidate = _this.getOptionValue(newValue);
                _this.setValue((0, $50a6d89e4bbf23e3$export$d1ca752ec761b95b)(selectValue.filter(function(i) {
                    return _this.getOptionValue(i) !== candidate;
                })), 'deselect-option', newValue);
            } else if (!isDisabled) {
                // Select option if option is not disabled
                if (isMulti) _this.setValue((0, $50a6d89e4bbf23e3$export$d1ca752ec761b95b)([].concat((0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(selectValue), [
                    newValue
                ])), 'select-option', newValue);
                else _this.setValue((0, $50a6d89e4bbf23e3$export$dea4763e29237f4c)(newValue), 'select-option');
            } else {
                _this.ariaOnChange((0, $50a6d89e4bbf23e3$export$dea4763e29237f4c)(newValue), {
                    action: 'select-option',
                    option: newValue,
                    name: name
                });
                return;
            }
            if (blurInputOnSelect) _this.blurInput();
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "removeValue", function(removedValue) {
            var isMulti = _this.props.isMulti;
            var selectValue = _this.state.selectValue;
            var candidate = _this.getOptionValue(removedValue);
            var newValueArray = selectValue.filter(function(i) {
                return _this.getOptionValue(i) !== candidate;
            });
            var newValue = (0, $50a6d89e4bbf23e3$export$40fb9515c784cc3b)(isMulti, newValueArray, newValueArray[0] || null);
            _this.onChange(newValue, {
                action: 'remove-value',
                removedValue: removedValue
            });
            _this.focusInput();
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "clearValue", function() {
            var selectValue = _this.state.selectValue;
            _this.onChange((0, $50a6d89e4bbf23e3$export$40fb9515c784cc3b)(_this.props.isMulti, [], null), {
                action: 'clear',
                removedValues: selectValue
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "popValue", function() {
            var isMulti = _this.props.isMulti;
            var selectValue = _this.state.selectValue;
            var lastSelectedValue = selectValue[selectValue.length - 1];
            var newValueArray = selectValue.slice(0, selectValue.length - 1);
            var newValue = (0, $50a6d89e4bbf23e3$export$40fb9515c784cc3b)(isMulti, newValueArray, newValueArray[0] || null);
            _this.onChange(newValue, {
                action: 'pop-value',
                removedValue: lastSelectedValue
            });
        });
        // ==============================
        // Getters
        // ==============================
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "getFocusedOptionId", function(focusedOption) {
            return $54e95eb3eee12ee7$var$getFocusedOptionId(_this.state.focusableOptionsWithIds, focusedOption);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "getFocusableOptionsWithIds", function() {
            return $54e95eb3eee12ee7$var$buildFocusableOptionsWithIds($54e95eb3eee12ee7$var$buildCategorizedOptions(_this.props, _this.state.selectValue), _this.getElementId('option'));
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "getValue", function() {
            return _this.state.selectValue;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "cx", function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            return (0, $50a6d89e4bbf23e3$export$ce4ab0c55987d1ff).apply(void 0, [
                _this.props.classNamePrefix
            ].concat(args));
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "getOptionLabel", function(data) {
            return $54e95eb3eee12ee7$var$getOptionLabel(_this.props, data);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "getOptionValue", function(data) {
            return $54e95eb3eee12ee7$var$getOptionValue(_this.props, data);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "getStyles", function(key, props) {
            var base = (0, $e4177ea1f14f060f$export$214b055320e0bf32)[key](props);
            base.boxSizing = 'border-box';
            var custom = _this.props.styles[key];
            if (!custom) return base;
            var customStyles = (0, $50a6d89e4bbf23e3$export$bf2eda47afa5f369)(custom(base, props));
            return customStyles;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "getClassNames", function(key, props) {
            var _this$props$className, _this$props$className2;
            return (_this$props$className = (_this$props$className2 = _this.props.classNames)[key]) === null || _this$props$className === void 0 ? void 0 : _this$props$className.call(_this$props$className2, props);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "getElementId", function(element) {
            return "".concat(_this.state.instancePrefix, "-").concat(element);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "getComponents", function() {
            return (0, $2bbff6443466b8f8$export$71abc632aa29e6fe)(_this.props);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "buildCategorizedOptions", function() {
            return $54e95eb3eee12ee7$var$buildCategorizedOptions(_this.props, _this.state.selectValue);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "getCategorizedOptions", function() {
            return _this.props.menuIsOpen ? _this.buildCategorizedOptions() : [];
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "buildFocusableOptions", function() {
            return $54e95eb3eee12ee7$var$buildFocusableOptionsFromCategorizedOptions(_this.buildCategorizedOptions());
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "getFocusableOptions", function() {
            return _this.props.menuIsOpen ? _this.buildFocusableOptions() : [];
        });
        // ==============================
        // Helpers
        // ==============================
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "ariaOnChange", function(value, actionMeta) {
            _this.setState({
                ariaSelection: $54e95eb3eee12ee7$var$_objectSpread({
                    value: value
                }, actionMeta)
            });
        });
        // ==============================
        // Mouse Handlers
        // ==============================
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "onMenuMouseDown", function(event) {
            if (event.button !== 0) return;
            event.stopPropagation();
            event.preventDefault();
            _this.focusInput();
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "onMenuMouseMove", function(_) {
            _this.blockOptionHover = false;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "onControlMouseDown", function(event) {
            // Event captured by dropdown indicator
            if (event.defaultPrevented) {
                var _this$controlRef;
                // react-dnd will fire preventDefault in mouseDown, which make select is not clickable.
                // temp workaround to check if select is within dnd, we don't do the early return.
                if (!((_this$controlRef = _this.controlRef) !== null && _this$controlRef !== void 0 && _this$controlRef.closest('[data-rbd-draggable-context-id]'))) return;
            }
            var openMenuOnClick = _this.props.openMenuOnClick;
            if (!_this.state.isFocused) {
                if (openMenuOnClick) _this.openAfterFocus = true;
                _this.focusInput();
            } else if (!_this.props.menuIsOpen) {
                if (openMenuOnClick) _this.openMenu('first');
            } else if (event.target.tagName !== 'INPUT' && event.target.tagName !== 'TEXTAREA') _this.onMenuClose();
            if (event.target.tagName !== 'INPUT' && event.target.tagName !== 'TEXTAREA') event.preventDefault();
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "onDropdownIndicatorMouseDown", function(event) {
            // ignore mouse events that weren't triggered by the primary button
            if (event && event.type === 'mousedown' && event.button !== 0) return;
            if (_this.props.isDisabled) return;
            var _this$props4 = _this.props, isMulti = _this$props4.isMulti, menuIsOpen = _this$props4.menuIsOpen;
            _this.focusInput();
            if (menuIsOpen) {
                _this.setState({
                    inputIsHiddenAfterUpdate: !isMulti
                });
                _this.onMenuClose();
            } else _this.openMenu('first');
            event.preventDefault();
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "onClearIndicatorMouseDown", function(event) {
            // ignore mouse events that weren't triggered by the primary button
            if (event && event.type === 'mousedown' && event.button !== 0) return;
            _this.clearValue();
            event.preventDefault();
            _this.openAfterFocus = false;
            if (event.type === 'touchend') _this.focusInput();
            else setTimeout(function() {
                return _this.focusInput();
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "onScroll", function(event) {
            if (typeof _this.props.closeMenuOnScroll === 'boolean') {
                if (event.target instanceof HTMLElement && (0, $50a6d89e4bbf23e3$export$d8a62a489b442872)(event.target)) _this.props.onMenuClose();
            } else if (typeof _this.props.closeMenuOnScroll === 'function') {
                if (_this.props.closeMenuOnScroll(event)) _this.props.onMenuClose();
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "onCompositionStart", function() {
            _this.isComposing = true;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "onCompositionEnd", function() {
            _this.isComposing = false;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "onTouchStart", function(_ref2) {
            var touches = _ref2.touches;
            var touch = touches && touches.item(0);
            if (!touch) return;
            _this.initialTouchX = touch.clientX;
            _this.initialTouchY = touch.clientY;
            _this.userIsDragging = false;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "onTouchMove", function(_ref3) {
            var touches = _ref3.touches;
            var touch = touches && touches.item(0);
            if (!touch) return;
            var deltaX = Math.abs(touch.clientX - _this.initialTouchX);
            var deltaY = Math.abs(touch.clientY - _this.initialTouchY);
            var moveThreshold = 5;
            _this.userIsDragging = deltaX > moveThreshold || deltaY > moveThreshold;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "onTouchEnd", function(event) {
            if (_this.userIsDragging) return;
            // close the menu if the user taps outside
            // we're checking on event.target here instead of event.currentTarget, because we want to assert information
            // on events on child elements, not the document (which we've attached this handler to).
            if (_this.controlRef && !_this.controlRef.contains(event.target) && _this.menuListRef && !_this.menuListRef.contains(event.target)) _this.blurInput();
            // reset move vars
            _this.initialTouchX = 0;
            _this.initialTouchY = 0;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "onControlTouchEnd", function(event) {
            if (_this.userIsDragging) return;
            _this.onControlMouseDown(event);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "onClearIndicatorTouchEnd", function(event) {
            if (_this.userIsDragging) return;
            _this.onClearIndicatorMouseDown(event);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "onDropdownIndicatorTouchEnd", function(event) {
            if (_this.userIsDragging) return;
            _this.onDropdownIndicatorMouseDown(event);
        });
        // ==============================
        // Focus Handlers
        // ==============================
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "handleInputChange", function(event) {
            var prevInputValue = _this.props.inputValue;
            var inputValue = event.currentTarget.value;
            _this.setState({
                inputIsHiddenAfterUpdate: false
            });
            _this.onInputChange(inputValue, {
                action: 'input-change',
                prevInputValue: prevInputValue
            });
            if (!_this.props.menuIsOpen) _this.onMenuOpen();
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "onInputFocus", function(event) {
            if (_this.props.onFocus) _this.props.onFocus(event);
            _this.setState({
                inputIsHiddenAfterUpdate: false,
                isFocused: true
            });
            if (_this.openAfterFocus || _this.props.openMenuOnFocus) _this.openMenu('first');
            _this.openAfterFocus = false;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "onInputBlur", function(event) {
            var prevInputValue = _this.props.inputValue;
            if (_this.menuListRef && _this.menuListRef.contains(document.activeElement)) {
                _this.inputRef.focus();
                return;
            }
            if (_this.props.onBlur) _this.props.onBlur(event);
            _this.onInputChange('', {
                action: 'input-blur',
                prevInputValue: prevInputValue
            });
            if ((0, $id6Cu.fg)('platform_dst_select_menu_close_on_blur')) // when fg is enabled, we only call onMenuClose when this.props.menuIsOpen is true.
            _this.props.menuIsOpen && _this.onMenuClose();
            else _this.onMenuClose();
            _this.setState({
                focusedValue: null,
                isFocused: false
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "onOptionHover", function(focusedOption) {
            if (_this.blockOptionHover || _this.state.focusedOption === focusedOption) return;
            var options = _this.getFocusableOptions();
            var focusedOptionIndex = options.indexOf(focusedOption);
            _this.setState({
                focusedOption: focusedOption,
                focusedOptionId: focusedOptionIndex > -1 ? _this.getFocusedOptionId(focusedOption) : null
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "shouldHideSelectedOptions", function() {
            return $54e95eb3eee12ee7$var$shouldHideSelectedOptions(_this.props);
        });
        // If the hidden input gets focus through form submit,
        // redirect focus to focusable input.
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "onValueInputFocus", function(e) {
            e.preventDefault();
            e.stopPropagation();
            _this.focus();
        });
        // ==============================
        // Keyboard Handlers
        // ==============================
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "onKeyDown", function(event) {
            var _this$props5 = _this.props, isMulti = _this$props5.isMulti, backspaceRemovesValue = _this$props5.backspaceRemovesValue, escapeClearsValue = _this$props5.escapeClearsValue, inputValue = _this$props5.inputValue, isClearable = _this$props5.isClearable, isDisabled = _this$props5.isDisabled, menuIsOpen = _this$props5.menuIsOpen, onKeyDown = _this$props5.onKeyDown, tabSelectsValue = _this$props5.tabSelectsValue, openMenuOnFocus = _this$props5.openMenuOnFocus, shouldPreventEscapePropagation = _this$props5.shouldPreventEscapePropagation;
            var _this$state = _this.state, focusedOption = _this$state.focusedOption, focusedValue = _this$state.focusedValue, selectValue = _this$state.selectValue;
            if (isDisabled) return;
            if (typeof onKeyDown === 'function') {
                onKeyDown(event);
                if (event.defaultPrevented) return;
            }
            // Block option hover events when the user has just pressed a key
            _this.blockOptionHover = true;
            switch(event.key){
                case 'ArrowLeft':
                    if (!isMulti || inputValue) return;
                    _this.focusValue('previous');
                    break;
                case 'ArrowRight':
                    if (!isMulti || inputValue) return;
                    _this.focusValue('next');
                    break;
                case 'Delete':
                case 'Backspace':
                    if (inputValue) return;
                    if (focusedValue) _this.removeValue(focusedValue);
                    else {
                        if (!backspaceRemovesValue) return;
                        if (isMulti) _this.popValue();
                        else if (isClearable) _this.clearValue();
                    }
                    break;
                case 'Tab':
                    if (_this.isComposing) return;
                    if (event.shiftKey || !menuIsOpen || !tabSelectsValue || !focusedOption || // don't capture the event if the menu opens on focus and the focused
                    // option is already selected; it breaks the flow of navigation
                    openMenuOnFocus && _this.isOptionSelected(focusedOption, selectValue)) return;
                    _this.selectOption(focusedOption);
                    break;
                case 'Enter':
                    if (event.keyCode === 229) break;
                    if (focusedValue) _this.removeValue(focusedValue);
                    if (menuIsOpen) {
                        if (!focusedOption) return;
                        if (_this.isComposing) return;
                        _this.selectOption(focusedOption);
                        break;
                    }
                    return;
                case 'Escape':
                    if (menuIsOpen) {
                        _this.setState({
                            inputIsHiddenAfterUpdate: false
                        });
                        _this.onInputChange('', {
                            action: 'menu-close',
                            prevInputValue: inputValue
                        });
                        _this.onMenuClose();
                        if (shouldPreventEscapePropagation && event.target instanceof HTMLElement) event.stopPropagation();
                    } else if (isClearable && escapeClearsValue) _this.clearValue();
                    break;
                case ' ':
                    // space
                    if (inputValue) return;
                    if (!menuIsOpen) {
                        _this.openMenu('first');
                        break;
                    }
                    if (!focusedOption) return;
                    _this.selectOption(focusedOption);
                    break;
                case 'ArrowUp':
                    if (menuIsOpen) _this.focusOption('up');
                    else _this.openMenu('last');
                    break;
                case 'ArrowDown':
                    if (menuIsOpen) _this.focusOption('down');
                    else _this.openMenu('first');
                    break;
                case 'PageUp':
                    if (!menuIsOpen) return;
                    _this.focusOption('pageup');
                    break;
                case 'PageDown':
                    if (!menuIsOpen) return;
                    _this.focusOption('pagedown');
                    break;
                case 'Home':
                    if (!menuIsOpen) return;
                    _this.focusOption('first');
                    break;
                case 'End':
                    if (!menuIsOpen) return;
                    _this.focusOption('last');
                    break;
                default:
                    return;
            }
            event.preventDefault();
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "handleOpenLayerObserverCloseSignal", function() {
            _this.onMenuClose();
        });
        _this.state.instancePrefix = 'react-select-' + (_this.props.instanceId || ++$54e95eb3eee12ee7$var$instanceId);
        _this.state.selectValue = (0, $50a6d89e4bbf23e3$export$33f062f47f21a01)(_props.value);
        // Set focusedOption if menuIsOpen is set on init (e.g. defaultMenuIsOpen)
        if (_props.menuIsOpen) {
            var focusableOptionsWithIds = _this.getFocusableOptionsWithIds();
            var focusableOptions = _this.buildFocusableOptions();
            var optionIndex = focusableOptions.indexOf(_this.state.selectValue[0]);
            _this.state.focusableOptionsWithIds = focusableOptionsWithIds;
            _this.state.focusedOption = focusableOptions[optionIndex];
            _this.state.focusedOptionId = $54e95eb3eee12ee7$var$getFocusedOptionId(focusableOptionsWithIds, focusableOptions[optionIndex]);
        }
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($eyuDe)))(Select, _Component);
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(Select, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this.startListeningComposition();
                this.startListeningToTouch();
                if (this.props.closeMenuOnScroll && document && document.addEventListener) // Listen to all scroll events, and filter them out inside of 'onScroll'
                // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                document.addEventListener('scroll', this.onScroll, true);
                if (this.props.autoFocus) this.focusInput();
                // Scroll focusedOption into view if menuIsOpen is set on mount (e.g. defaultMenuIsOpen)
                if (this.props.menuIsOpen && this.state.focusedOption && this.menuListRef && this.focusedOptionRef) (0, $50a6d89e4bbf23e3$export$53a0910f038337bd)(this.menuListRef, this.focusedOptionRef);
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps) {
                var _this$props6 = this.props, isDisabled = _this$props6.isDisabled, menuIsOpen = _this$props6.menuIsOpen;
                var isFocused = this.state.isFocused;
                if (// ensure focus is restored correctly when the control becomes enabled
                isFocused && !isDisabled && prevProps.isDisabled || // ensure focus is on the Input when the menu opens
                isFocused && menuIsOpen && !prevProps.menuIsOpen) this.focusInput();
                if (isFocused && isDisabled && !prevProps.isDisabled) // ensure select state gets blurred in case Select is programmatically disabled while focused
                this.setState({
                    isFocused: false
                }, this.onMenuClose);
                else if (!isFocused && !isDisabled && prevProps.isDisabled && this.inputRef === document.activeElement) // ensure select state gets focused in case Select is programatically re-enabled while focused (Firefox)
                this.setState({
                    isFocused: true
                });
                // scroll the focused option into view if necessary
                if (this.menuListRef && this.focusedOptionRef && this.scrollToFocusedOptionOnUpdate) {
                    (0, $50a6d89e4bbf23e3$export$53a0910f038337bd)(this.menuListRef, this.focusedOptionRef);
                    this.scrollToFocusedOptionOnUpdate = false;
                }
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this.stopListeningComposition();
                this.stopListeningToTouch();
                // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                document.removeEventListener('scroll', this.onScroll, true);
            }
        },
        {
            key: "onMenuOpen",
            value: function onMenuOpen() {
                this.props.onMenuOpen();
            }
        },
        {
            key: "onMenuClose",
            value: function onMenuClose() {
                this.onInputChange('', {
                    action: 'menu-close',
                    prevInputValue: this.props.inputValue
                });
                this.props.onMenuClose();
            }
        },
        {
            key: "onInputChange",
            value: function onInputChange(newValue, actionMeta) {
                this.props.onInputChange(newValue, actionMeta);
            }
        },
        {
            key: "focusInput",
            value: function focusInput() {
                if (!this.inputRef) return;
                this.inputRef.focus();
            }
        },
        {
            key: "blurInput",
            value: function blurInput() {
                if (!this.inputRef) return;
                this.inputRef.blur();
            }
        },
        {
            key: "openMenu",
            value: function openMenu(focusOption) {
                var _this2 = this;
                var _this$state2 = this.state, selectValue = _this$state2.selectValue, isFocused = _this$state2.isFocused;
                var focusableOptions = this.buildFocusableOptions();
                var openAtIndex = focusOption === 'first' ? 0 : focusableOptions.length - 1;
                if (!this.props.isMulti) {
                    var selectedIndex = focusableOptions.indexOf(selectValue[0]);
                    if (selectedIndex > -1) openAtIndex = selectedIndex;
                }
                var focusedOption = focusableOptions[openAtIndex];
                // only scroll if the menu isn't already open
                this.scrollToFocusedOptionOnUpdate = !(isFocused && this.menuListRef);
                this.setState({
                    inputIsHiddenAfterUpdate: false,
                    focusedValue: null,
                    focusedOption: focusedOption,
                    focusedOptionId: this.getFocusedOptionId(focusedOption)
                }, function() {
                    return _this2.onMenuOpen();
                });
                (0, $dJ32z.isSafari)() && focusedOption && this.updateInputLabel(this.calculateInputLabel(focusedOption, openAtIndex));
            }
        },
        {
            key: "updateInputLabel",
            value: function updateInputLabel(inputLabel) {
                var _this3 = this;
                if (inputLabel) {
                    var _this$inputRef;
                    (_this$inputRef = this.inputRef) === null || _this$inputRef === void 0 || _this$inputRef.setAttribute('aria-label', inputLabel);
                    setTimeout(function() {
                        var normalizedLabel = _this3.props['aria-label'] || _this3.props.label;
                        if (normalizedLabel) {
                            var _this3$inputRef;
                            (_this3$inputRef = _this3.inputRef) === null || _this3$inputRef === void 0 || _this3$inputRef.setAttribute('aria-label', normalizedLabel);
                        } else {
                            var _this3$inputRef2;
                            (_this3$inputRef2 = _this3.inputRef) === null || _this3$inputRef2 === void 0 || _this3$inputRef2.removeAttribute('aria-label');
                        }
                    }, 500);
                }
            }
        },
        {
            key: "calculateInputLabel",
            value: function calculateInputLabel(focusedOption, optionIndex) {
                var _this4 = this;
                var options = this.props.options;
                var isOptionsGrouped = options === null || options === void 0 ? void 0 : options.every(function(obj) {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(obj) === 'object' && obj !== null && 'options' in obj;
                });
                var inputLabel = this.getOptionLabel(focusedOption);
                var isOptionFocused = function isOptionFocused(option) {
                    return _this4.getOptionLabel(option) === inputLabel;
                };
                var groupData = options === null || options === void 0 ? void 0 : options.find(function(option) {
                    var _groupCandidate$optio, _groupCandidate$optio2;
                    var groupCandidate = option;
                    return (_groupCandidate$optio = (_groupCandidate$optio2 = groupCandidate.options) === null || _groupCandidate$optio2 === void 0 ? void 0 : _groupCandidate$optio2.some(isOptionFocused)) !== null && _groupCandidate$optio !== void 0 ? _groupCandidate$optio : false;
                });
                if (isOptionsGrouped) {
                    var _groupData$options$fi;
                    var groupOptionIndex = (_groupData$options$fi = groupData === null || groupData === void 0 ? void 0 : groupData.options.findIndex(isOptionFocused)) !== null && _groupData$options$fi !== void 0 ? _groupData$options$fi : 0;
                    var totalLength = options === null || options === void 0 ? void 0 : options.reduce(function(acc, currentGroup) {
                        var _group$options;
                        var group = currentGroup;
                        acc += group === null || group === void 0 || (_group$options = group.options) === null || _group$options === void 0 ? void 0 : _group$options.length;
                        return acc;
                    }, 0);
                    inputLabel = "".concat(inputLabel, ", ").concat(groupData === null || groupData === void 0 ? void 0 : groupData.label, " (").concat(groupOptionIndex + 1, " of ").concat(totalLength, ")");
                } else inputLabel = "".concat(inputLabel, " (").concat(optionIndex + 1, " of ").concat(options === null || options === void 0 ? void 0 : options.length, ")");
                return inputLabel;
            }
        },
        {
            key: "focusValue",
            value: function focusValue(direction) {
                var _this$state3 = this.state, selectValue = _this$state3.selectValue, focusedValue = _this$state3.focusedValue;
                // Only multiselects support value focusing
                if (!this.props.isMulti) return;
                this.setState({
                    focusedOption: null
                });
                var focusedIndex = selectValue.indexOf(focusedValue);
                if (!focusedValue) focusedIndex = -1;
                var lastIndex = selectValue.length - 1;
                var nextFocus = -1;
                if (!selectValue.length) return;
                switch(direction){
                    case 'previous':
                        if (focusedIndex === 0) // don't cycle from the start to the end
                        nextFocus = 0;
                        else if (focusedIndex === -1) // if nothing is focused, focus the last value first
                        nextFocus = lastIndex;
                        else nextFocus = focusedIndex - 1;
                        break;
                    case 'next':
                        if (focusedIndex > -1 && focusedIndex < lastIndex) nextFocus = focusedIndex + 1;
                        break;
                }
                this.setState({
                    inputIsHidden: nextFocus !== -1,
                    focusedValue: selectValue[nextFocus],
                    focusedValueId: "".concat(this.getElementId('selected-value'), "-").concat(nextFocus, "-remove"),
                    focusedOption: null,
                    focusedOptionId: null
                });
            }
        },
        {
            key: "focusOption",
            value: function focusOption() {
                var direction = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'first';
                var pageSize = this.props.pageSize;
                var focusedOption = this.state.focusedOption;
                var options = this.getFocusableOptions();
                if (!options.length) return;
                var nextFocus = 0; // handles 'first'
                var focusedIndex = options.indexOf(focusedOption);
                if (!focusedOption) focusedIndex = -1;
                if (direction === 'up') nextFocus = focusedIndex > 0 ? focusedIndex - 1 : options.length - 1;
                else if (direction === 'down') nextFocus = (focusedIndex + 1) % options.length;
                else if (direction === 'pageup') {
                    nextFocus = focusedIndex - pageSize;
                    if (nextFocus < 0) nextFocus = 0;
                } else if (direction === 'pagedown') {
                    nextFocus = focusedIndex + pageSize;
                    if (nextFocus > options.length - 1) nextFocus = options.length - 1;
                } else if (direction === 'last') nextFocus = options.length - 1;
                this.scrollToFocusedOptionOnUpdate = true;
                this.setState({
                    focusedOption: options[nextFocus],
                    focusedValue: null,
                    focusedValueId: null,
                    focusedOptionId: this.getFocusedOptionId(options[nextFocus])
                });
            }
        },
        {
            key: "getCommonProps",
            value: function getCommonProps() {
                var clearValue = this.clearValue, cx = this.cx, getStyles = this.getStyles, getClassNames = this.getClassNames, getValue = this.getValue, selectOption = this.selectOption, setValue = this.setValue, props = this.props;
                var isMulti = props.isMulti, isRtl = props.isRtl, options = props.options;
                var hasValue = this.hasValue();
                return {
                    clearValue: clearValue,
                    cx: cx,
                    getStyles: getStyles,
                    getClassNames: getClassNames,
                    getValue: getValue,
                    hasValue: hasValue,
                    isMulti: isMulti,
                    isRtl: isRtl,
                    options: options,
                    selectOption: selectOption,
                    selectProps: props,
                    setValue: setValue
                };
            }
        },
        {
            key: "hasValue",
            value: function hasValue() {
                var selectValue = this.state.selectValue;
                return selectValue.length > 0;
            }
        },
        {
            key: "hasOptions",
            value: function hasOptions() {
                return !!this.getFocusableOptions().length;
            }
        },
        {
            key: "isClearable",
            value: function isClearable() {
                var _this$props7 = this.props, isClearable = _this$props7.isClearable, isMulti = _this$props7.isMulti;
                // single select, by default, IS NOT clearable
                // multi select, by default, IS clearable
                if (isClearable === undefined) return isMulti;
                return isClearable;
            }
        },
        {
            key: "isOptionDisabled",
            value: function isOptionDisabled(option, selectValue) {
                return $54e95eb3eee12ee7$var$_isOptionDisabled(this.props, option, selectValue);
            }
        },
        {
            key: "isOptionSelected",
            value: function isOptionSelected(option, selectValue) {
                return $54e95eb3eee12ee7$var$_isOptionSelected(this.props, option, selectValue);
            }
        },
        {
            key: "filterOption",
            value: function filterOption(option, inputValue) {
                return $54e95eb3eee12ee7$var$_filterOption(this.props, option, inputValue);
            }
        },
        {
            key: "formatOptionLabel",
            value: function formatOptionLabel(data, context) {
                if (typeof this.props.formatOptionLabel === 'function') {
                    var inputValue = this.props.inputValue;
                    var selectValue = this.state.selectValue;
                    return this.props.formatOptionLabel(data, {
                        context: context,
                        inputValue: inputValue,
                        selectValue: selectValue
                    });
                } else return this.getOptionLabel(data);
            }
        },
        {
            key: "formatGroupLabel",
            value: function formatGroupLabel(data) {
                return this.props.formatGroupLabel(data);
            }
        },
        {
            key: "calculateDescription",
            value: function calculateDescription() {
                var descriptionProp = this.props['aria-describedby'] || this.props.descriptionId;
                var isMulti = this.props.isMulti;
                var hasValue = this.state.selectValue.length > 0;
                // Determine base description based on selection state
                var baseDescriptionId = hasValue ? isMulti ? '' : this.getElementId('single-value') : this.getElementId('placeholder');
                // Fast path for single select with no description prop
                if (!isMulti && !descriptionProp) return {
                    'aria-describedby': baseDescriptionId
                };
                // Build the describedby string efficiently
                var describedBy = baseDescriptionId;
                // Add description prop if it exists
                if (descriptionProp) describedBy = describedBy ? "".concat(descriptionProp, " ").concat(describedBy) : descriptionProp;
                // For multi-select, always add multi-message ID
                if (isMulti) {
                    var multiMessage = this.getElementId('multi-message');
                    describedBy = describedBy ? "".concat(describedBy, " ").concat(multiMessage) : multiMessage;
                }
                return {
                    'aria-describedby': describedBy
                };
            }
        },
        {
            key: "startListeningComposition",
            value: // ==============================
            // Composition Handlers
            // ==============================
            function startListeningComposition() {
                if (document && document.addEventListener) {
                    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                    document.addEventListener('compositionstart', this.onCompositionStart, false);
                    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                    document.addEventListener('compositionend', this.onCompositionEnd, false);
                }
            }
        },
        {
            key: "stopListeningComposition",
            value: function stopListeningComposition() {
                if (document && document.removeEventListener) {
                    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                    document.removeEventListener('compositionstart', this.onCompositionStart);
                    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                    document.removeEventListener('compositionend', this.onCompositionEnd);
                }
            }
        },
        {
            key: "startListeningToTouch",
            value: // ==============================
            // Touch Handlers
            // ==============================
            function startListeningToTouch() {
                if (document && document.addEventListener) {
                    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                    document.addEventListener('touchstart', this.onTouchStart, false);
                    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                    document.addEventListener('touchmove', this.onTouchMove, false);
                    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                    document.addEventListener('touchend', this.onTouchEnd, false);
                }
            }
        },
        {
            key: "stopListeningToTouch",
            value: function stopListeningToTouch() {
                if (document && document.removeEventListener) {
                    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                    document.removeEventListener('touchstart', this.onTouchStart);
                    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                    document.removeEventListener('touchmove', this.onTouchMove);
                    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                    document.removeEventListener('touchend', this.onTouchEnd);
                }
            }
        },
        {
            key: "renderInput",
            value: // ==============================
            // Renderers
            // ==============================
            function renderInput() {
                var _this$props8 = this.props, form = _this$props8.form, inputId = _this$props8.inputId, inputValue = _this$props8.inputValue, isDisabled = _this$props8.isDisabled, isInvalid = _this$props8.isInvalid, isRequired = _this$props8.isRequired, isSearchable = _this$props8.isSearchable, label = _this$props8.label, labelId = _this$props8.labelId, menuIsOpen = _this$props8.menuIsOpen, required = _this$props8.required, _this$props8$tabIndex = _this$props8.tabIndex, tabIndex = _this$props8$tabIndex === void 0 ? 0 : _this$props8$tabIndex, testId = _this$props8.testId;
                var _this$getComponents = this.getComponents(), Input = _this$getComponents.Input;
                var inputIsHidden = this.state.inputIsHidden;
                var commonProps = this.commonProps;
                var id = inputId || this.getElementId('input');
                // aria attributes makes the JSX "noisy", separated for clarity
                var ariaAttributes = $54e95eb3eee12ee7$var$_objectSpread($54e95eb3eee12ee7$var$_objectSpread($54e95eb3eee12ee7$var$_objectSpread($54e95eb3eee12ee7$var$_objectSpread({}, !this.props.isSearchable && (0, $id6Cu.fg)('platform_fix_autocomplete_aria_for_select') ? {} : {
                    'aria-autocomplete': 'both'
                }), {}, {
                    'aria-errormessage': this.props['aria-errormessage'],
                    'aria-expanded': menuIsOpen,
                    // TODO: aria-haspopup is implied as listbox with role="combobox" and was deprecated for aria 1.2, we still might need to keep it for back compat
                    'aria-haspopup': this.props['UNSAFE_is_experimental_generic'] ? 'dialog' : 'listbox',
                    'aria-invalid': this.props['aria-invalid'] || isInvalid,
                    'aria-label': this.props['aria-label'] || label,
                    'aria-labelledby': this.props['aria-labelledby'] || labelId,
                    'aria-required': required || isRequired,
                    role: 'combobox',
                    'aria-activedescendant': this.props['UNSAFE_is_experimental_generic'] ? undefined : this.state.focusedOptionId || this.state.focusedValueId || undefined
                }, menuIsOpen && {
                    'aria-controls': this.getElementId('listbox')
                }), !isSearchable && {
                    'aria-readonly': true
                }), this.calculateDescription());
                if (!isSearchable) // use a dummy input to maintain focus/blur functionality
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $0dc5e7e11d80c24e$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
                    id: id,
                    innerRef: this.getInputRef,
                    onBlur: this.onInputBlur,
                    onChange: (0, $50a6d89e4bbf23e3$export$8793edee2d425525),
                    onFocus: this.onInputFocus,
                    disabled: isDisabled,
                    tabIndex: tabIndex,
                    inputMode: "none",
                    form: form,
                    value: "",
                    "data-testid": testId && "".concat(testId, "-select--input")
                }, ariaAttributes));
                // NOTE: Don't add the `name` prop to this Input, `name` is already a prop on the hidden input element that has the value of the select.
                // Adding `name` to this Input will cause unexpected behavior.
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(Input, (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, commonProps, {
                    autoCapitalize: "none",
                    autoComplete: "off",
                    autoCorrect: "off",
                    id: id,
                    testId: testId,
                    innerRef: this.getInputRef,
                    isDisabled: isDisabled,
                    isHidden: inputIsHidden,
                    onBlur: this.onInputBlur,
                    onChange: this.handleInputChange,
                    onFocus: this.onInputFocus,
                    spellCheck: "false",
                    tabIndex: tabIndex,
                    form: form,
                    type: "text",
                    value: inputValue
                }, ariaAttributes));
            }
        },
        {
            key: "renderPlaceholderOrValue",
            value: function renderPlaceholderOrValue() {
                var _this5 = this;
                var _this$getComponents2 = this.getComponents(), MultiValue = _this$getComponents2.MultiValue, MultiValueContainer = _this$getComponents2.MultiValueContainer, MultiValueLabel = _this$getComponents2.MultiValueLabel, MultiValueRemove = _this$getComponents2.MultiValueRemove, SingleValue = _this$getComponents2.SingleValue, Placeholder = _this$getComponents2.Placeholder;
                var commonProps = this.commonProps;
                var _this$props9 = this.props, controlShouldRenderValue = _this$props9.controlShouldRenderValue, isDisabled = _this$props9.isDisabled, isMulti = _this$props9.isMulti, inputValue = _this$props9.inputValue, placeholder = _this$props9.placeholder, testId = _this$props9.testId;
                var _this$state4 = this.state, selectValue = _this$state4.selectValue, focusedValue = _this$state4.focusedValue, isFocused = _this$state4.isFocused;
                if (!this.hasValue() || !controlShouldRenderValue) return inputValue ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(Placeholder, (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, commonProps, {
                    key: "placeholder",
                    isDisabled: isDisabled,
                    isFocused: isFocused,
                    innerProps: $54e95eb3eee12ee7$var$_objectSpread({
                        id: this.getElementId('placeholder')
                    }, testId && {
                        'data-testid': "".concat(testId, "-select--placeholder")
                    })
                }), placeholder);
                if (isMulti) return selectValue.map(function(opt, index) {
                    var isOptionFocused = opt === focusedValue;
                    var key = "".concat(_this5.getOptionLabel(opt), "-").concat(_this5.getOptionValue(opt));
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(MultiValue, (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, commonProps, {
                        components: {
                            Container: MultiValueContainer,
                            Label: MultiValueLabel,
                            Remove: MultiValueRemove
                        },
                        isFocused: isOptionFocused,
                        isDisabled: isDisabled,
                        key: key,
                        index: index,
                        removeProps: $54e95eb3eee12ee7$var$_objectSpread($54e95eb3eee12ee7$var$_objectSpread({
                            onClick: function onClick() {
                                return _this5.removeValue(opt);
                            },
                            onTouchEnd: function onTouchEnd() {
                                return _this5.removeValue(opt);
                            },
                            onMouseDown: function onMouseDown(e) {
                                e.preventDefault();
                            }
                        }, testId && {
                            'data-testid': "".concat(testId, "-select--multivalue-").concat(index, "-remove")
                        }), {}, {
                            id: "".concat(_this5.getElementId('selected-value'), "-").concat(index, "-remove")
                        }),
                        data: opt,
                        innerProps: $54e95eb3eee12ee7$var$_objectSpread($54e95eb3eee12ee7$var$_objectSpread({}, testId && {
                            'data-testid': "".concat(testId, "-select--multivalue-").concat(index)
                        }), {}, {
                            id: "".concat(_this5.getElementId('selected-value'), "-").concat(index)
                        })
                    }), _this5.formatOptionLabel(opt, 'value'));
                });
                if (inputValue) return null;
                var singleValue = selectValue[0];
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(SingleValue, (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, commonProps, {
                    data: singleValue,
                    isDisabled: isDisabled,
                    innerProps: {
                        id: this.getElementId('single-value')
                    }
                }), this.formatOptionLabel(singleValue, 'value'));
            }
        },
        {
            key: "renderClearIndicator",
            value: function renderClearIndicator() {
                var _this$getComponents3 = this.getComponents(), ClearIndicator = _this$getComponents3.ClearIndicator;
                var commonProps = this.commonProps;
                var _this$props0 = this.props, clearControlLabel = _this$props0.clearControlLabel, isDisabled = _this$props0.isDisabled, isLoading = _this$props0.isLoading, spacing = _this$props0.spacing, testId = _this$props0.testId;
                var isFocused = this.state.isFocused;
                if (!this.isClearable() || !ClearIndicator || isDisabled || !this.hasValue() || isLoading) return null;
                var innerProps = $54e95eb3eee12ee7$var$_objectSpread({
                    onMouseDown: this.onClearIndicatorMouseDown,
                    onTouchEnd: this.onClearIndicatorTouchEnd
                }, testId && {
                    'data-testid': "".concat(testId, "-select--clear-indicator")
                });
                var isCompact = spacing === 'compact';
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(ClearIndicator, (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
                    clearControlLabel: clearControlLabel
                }, commonProps, {
                    innerProps: innerProps,
                    isFocused: isFocused,
                    isCompact: isCompact
                }));
            }
        },
        {
            key: "renderLoadingIndicator",
            value: function renderLoadingIndicator() {
                var _this$getComponents4 = this.getComponents(), LoadingIndicator = _this$getComponents4.LoadingIndicator;
                var commonProps = this.commonProps;
                var _this$props1 = this.props, isDisabled = _this$props1.isDisabled, isLoading = _this$props1.isLoading, spacing = _this$props1.spacing, testId = _this$props1.testId;
                var isFocused = this.state.isFocused;
                if (!LoadingIndicator || !isLoading) return null;
                var isCompact = spacing === 'compact';
                var innerProps = {
                    'aria-hidden': 'true'
                };
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(LoadingIndicator, (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
                    "data-testid": testId && "".concat(testId, "-select--loading-indicator")
                }, commonProps, {
                    innerProps: innerProps,
                    isDisabled: isDisabled,
                    isFocused: isFocused,
                    isCompact: isCompact
                }));
            }
        },
        {
            key: "renderDropdownIndicator",
            value: function renderDropdownIndicator() {
                var _this$getComponents5 = this.getComponents(), DropdownIndicator = _this$getComponents5.DropdownIndicator;
                if (!DropdownIndicator) return null;
                var commonProps = this.commonProps;
                var _this$props10 = this.props, isDisabled = _this$props10.isDisabled, spacing = _this$props10.spacing, testId = _this$props10.testId;
                var isFocused = this.state.isFocused;
                var isCompact = spacing === 'compact';
                var innerProps = $54e95eb3eee12ee7$var$_objectSpread({
                    onMouseDown: this.onDropdownIndicatorMouseDown,
                    onTouchEnd: this.onDropdownIndicatorTouchEnd,
                    'aria-hidden': 'true'
                }, testId && {
                    'data-testid': "".concat(testId, "-select--dropdown-indicator")
                });
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(DropdownIndicator, (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, commonProps, {
                    innerProps: innerProps,
                    isDisabled: isDisabled,
                    isFocused: isFocused,
                    isCompact: isCompact
                }));
            }
        },
        {
            key: "renderMenu",
            value: function renderMenu() {
                var _this6 = this;
                var _this$getComponents6 = this.getComponents(), Group = _this$getComponents6.Group, GroupHeading = _this$getComponents6.GroupHeading, Menu = _this$getComponents6.Menu, MenuList = _this$getComponents6.MenuList, MenuPortal = _this$getComponents6.MenuPortal, LoadingMessage = _this$getComponents6.LoadingMessage, NoOptionsMessage = _this$getComponents6.NoOptionsMessage, Option = _this$getComponents6.Option;
                var commonProps = this.commonProps;
                var focusedOption = this.state.focusedOption;
                var _this$props11 = this.props, captureMenuScroll = _this$props11.captureMenuScroll, inputValue = _this$props11.inputValue, isLoading = _this$props11.isLoading, loadingMessage = _this$props11.loadingMessage, minMenuHeight = _this$props11.minMenuHeight, maxMenuHeight = _this$props11.maxMenuHeight, menuIsOpen = _this$props11.menuIsOpen, menuPlacement = _this$props11.menuPlacement, menuPosition = _this$props11.menuPosition, menuPortalTarget = _this$props11.menuPortalTarget, menuShouldBlockScroll = _this$props11.menuShouldBlockScroll, menuShouldScrollIntoView = _this$props11.menuShouldScrollIntoView, noOptionsMessage = _this$props11.noOptionsMessage, onMenuScrollToTop = _this$props11.onMenuScrollToTop, onMenuScrollToBottom = _this$props11.onMenuScrollToBottom, testId = _this$props11.testId;
                if (!menuIsOpen) return null;
                // TODO: Internal Option Type here
                var render = function render(props, id, headingId) {
                    var type = props.type, data = props.data, isDisabled = props.isDisabled, isSelected = props.isSelected, label = props.label, value = props.value;
                    var isFocused = focusedOption === data;
                    var onHover = isDisabled ? undefined : function() {
                        return _this6.onOptionHover(data);
                    };
                    var onSelect = isDisabled ? undefined : function() {
                        return _this6.selectOption(data);
                    };
                    var optionId = "".concat(_this6.getElementId('option'), "-").concat(id);
                    var innerProps = $54e95eb3eee12ee7$var$_objectSpread({
                        id: optionId,
                        onClick: onSelect,
                        onMouseMove: onHover,
                        onMouseOver: onHover,
                        role: _this6.props['UNSAFE_is_experimental_generic'] ? 'listitem' : 'option',
                        'aria-selected': _this6.props['UNSAFE_is_experimental_generic'] ? undefined : isSelected,
                        // We don't want aria-disabled if it's false. It's just noisy.
                        'aria-disabled': !isDisabled ? undefined : isDisabled,
                        'aria-describedby': headingId
                    }, testId && {
                        'data-testid': "".concat(testId, "-select--option-").concat(id)
                    });
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(Option, (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, commonProps, {
                        innerProps: innerProps,
                        data: data,
                        isDisabled: isDisabled,
                        isSelected: isSelected,
                        key: optionId,
                        label: label,
                        type: type,
                        value: value,
                        isFocused: isFocused,
                        innerRef: isFocused ? _this6.getFocusedOptionRef : undefined
                    }), _this6.formatOptionLabel(props.data, 'menu'));
                };
                var menuUI;
                if (this.hasOptions()) {
                    var items = this.getCategorizedOptions();
                    menuUI = items.map(function(item) {
                        if (item.type === 'group') {
                            var data = item.data, options = item.options, groupIndex = item.index;
                            var groupId = "".concat(_this6.getElementId('group'), "-").concat(groupIndex);
                            var headingId = "".concat(groupId, "-heading");
                            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(Group, (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, commonProps, {
                                key: groupId,
                                data: data,
                                options: options,
                                Heading: GroupHeading,
                                headingProps: $54e95eb3eee12ee7$var$_objectSpread({
                                    id: headingId,
                                    data: item.data
                                }, testId && {
                                    'data-testid': "".concat(testId, "-select--group-").concat(groupIndex, "-heading")
                                }),
                                label: _this6.formatGroupLabel(item.data)
                            }), item.options.map(function(option) {
                                return render(option, "".concat(groupIndex, "-").concat(option.index), headingId);
                            }));
                        } else if (item.type === 'option') return render(item, "".concat(item.index));
                        return undefined;
                    });
                } else if (isLoading) {
                    var message = loadingMessage({
                        inputValue: inputValue
                    });
                    if (message === null) return null;
                    menuUI = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(LoadingMessage, commonProps, message);
                } else {
                    var _message = noOptionsMessage({
                        inputValue: inputValue
                    });
                    if (_message === null) return null;
                    menuUI = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(NoOptionsMessage, (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, commonProps, {
                        innerProps: $54e95eb3eee12ee7$var$_objectSpread({}, testId && {
                            'data-testid': "".concat(testId, "-select--no-options")
                        })
                    }), _message);
                }
                var menuPlacementProps = {
                    minMenuHeight: minMenuHeight,
                    maxMenuHeight: maxMenuHeight,
                    menuPlacement: menuPlacement,
                    menuPosition: menuPosition,
                    menuShouldScrollIntoView: menuShouldScrollIntoView
                };
                var menuElement = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $a77dc8ff50c99630$export$f32337f3a7617699), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, commonProps, menuPlacementProps), function(_ref4) {
                    var ref = _ref4.ref, _ref4$placerProps = _ref4.placerProps, placement = _ref4$placerProps.placement, maxHeight = _ref4$placerProps.maxHeight;
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(Menu, (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, commonProps, menuPlacementProps, {
                        innerRef: ref,
                        innerProps: $54e95eb3eee12ee7$var$_objectSpread({
                            onMouseDown: _this6.onMenuMouseDown,
                            onMouseMove: _this6.onMenuMouseMove,
                            id: _this6.props.components.Menu ? _this6.getElementId('listbox') : undefined
                        }, testId && {
                            'data-testid': "".concat(testId, "-select--listbox-container")
                        }),
                        isLoading: isLoading,
                        placement: placement
                    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $54b15de582ede229$export$2e2bcd8739ae039), {
                        captureEnabled: captureMenuScroll,
                        onTopArrive: onMenuScrollToTop,
                        onBottomArrive: onMenuScrollToBottom,
                        lockEnabled: menuShouldBlockScroll
                    }, function(scrollTargetRef) {
                        var _this6$inputRef, _this6$inputRef2;
                        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(MenuList, (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, commonProps, {
                            innerRef: function innerRef(instance) {
                                _this6.getMenuListRef(instance);
                                scrollTargetRef(instance);
                            },
                            innerProps: $54e95eb3eee12ee7$var$_objectSpread($54e95eb3eee12ee7$var$_objectSpread($54e95eb3eee12ee7$var$_objectSpread({
                                role: _this6.props['UNSAFE_is_experimental_generic'] ? 'dialog' : 'listbox'
                            }, _this6.props['UNSAFE_is_experimental_generic'] && {
                                'aria-labelledby': ((_this6$inputRef = _this6.inputRef) === null || _this6$inputRef === void 0 ? void 0 : _this6$inputRef.id) || _this6.getElementId('input')
                            }), {}, {
                                'aria-multiselectable': !commonProps.isMulti || _this6.props['UNSAFE_is_experimental_generic'] ? undefined : commonProps.isMulti,
                                id: _this6.getElementId('listbox')
                            }, testId && {
                                'data-testid': "".concat(testId, "-select--listbox")
                            }), (0, $dJ32z.isSafari)() && !_this6.props['UNSAFE_is_experimental_generic'] && {
                                'aria-describedby': ((_this6$inputRef2 = _this6.inputRef) === null || _this6$inputRef2 === void 0 ? void 0 : _this6$inputRef2.id) || _this6.getElementId('input')
                            }),
                            isLoading: isLoading,
                            maxHeight: maxHeight,
                            focusedOption: focusedOption
                        }), _this6.props['UNSAFE_is_experimental_generic'] ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("div", {
                            role: "list"
                        }, menuUI) : menuUI);
                    }));
                });
                // positioning behaviour is almost identical for portalled and fixed,
                // so we use the same component. the actual portalling logic is forked
                // within the component based on `menuPosition`
                return menuPortalTarget || menuPosition === 'fixed' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(MenuPortal, (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, commonProps, {
                    appendTo: menuPortalTarget,
                    controlElement: this.controlRef,
                    menuPlacement: menuPlacement,
                    menuPosition: menuPosition
                }), menuElement) : menuElement;
            }
        },
        {
            key: "renderFormField",
            value: function renderFormField() {
                var _this7 = this;
                var _this$props12 = this.props, delimiter = _this$props12.delimiter, isDisabled = _this$props12.isDisabled, isMulti = _this$props12.isMulti, required = _this$props12.required, name = _this$props12.name;
                var selectValue = this.state.selectValue;
                if (required && !this.hasValue() && !isDisabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $4cc6f93b0da9c7e2$export$2e2bcd8739ae039), {
                    name: name,
                    onFocus: this.onValueInputFocus
                });
                if (!name || isDisabled) return;
                if (isMulti) {
                    if (delimiter) {
                        var value = selectValue.map(function(opt) {
                            return _this7.getOptionValue(opt);
                        }).join(delimiter);
                        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("input", {
                            name: name,
                            type: "hidden",
                            value: value
                        });
                    } else {
                        var input = selectValue.length > 0 ? selectValue.map(function(opt, i) {
                            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("input", {
                                key: "i-".concat(i),
                                name: name,
                                type: "hidden",
                                value: _this7.getOptionValue(opt)
                            });
                        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("input", {
                            name: name,
                            type: "hidden",
                            value: ""
                        });
                        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("div", null, input);
                    }
                } else {
                    var _value = selectValue[0] ? this.getOptionValue(selectValue[0]) : '';
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("input", {
                        name: name,
                        type: "hidden",
                        value: _value
                    });
                }
            }
        },
        {
            key: "renderLiveRegion",
            value: function renderLiveRegion() {
                var commonProps = this.commonProps;
                var _this$state5 = this.state, ariaSelection = _this$state5.ariaSelection, isFocused = _this$state5.isFocused, selectValue = _this$state5.selectValue;
                var focusableOptions = this.getFocusableOptions();
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $c81d539ea60715b1$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, commonProps, {
                    id: this.getElementId('live-region'),
                    ariaSelection: ariaSelection,
                    isFocused: isFocused,
                    selectValue: selectValue,
                    focusableOptions: focusableOptions
                }));
            }
        },
        {
            key: "renderMultiselectMessage",
            value: function renderMultiselectMessage() {
                // In the future, when we actually support touch devices, we'll need to update this to not be keyboard specific.
                // Also, since this is rendered onscreen, it should be transtlated automatically.
                var msg = ", multiple selections available, ".concat(this.state.selectValue.length ? 'Use left or right arrow keys to navigate selected items' : '');
                return(/*#__PURE__*/ // eslint-disable-next-line @atlaskit/design-system/use-primitives-text
                (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("span", {
                    id: this.getElementId('multi-message'),
                    hidden: true
                }, msg));
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$getComponents7 = this.getComponents(), Control = _this$getComponents7.Control, IndicatorsContainer = _this$getComponents7.IndicatorsContainer, SelectContainer = _this$getComponents7.SelectContainer, ValueContainer = _this$getComponents7.ValueContainer;
                var _this$props13 = this.props, className = _this$props13.className, id = _this$props13.id, isDisabled = _this$props13.isDisabled, menuIsOpen = _this$props13.menuIsOpen, isInvalid = _this$props13.isInvalid, testId = _this$props13.testId, _this$props13$appeara = _this$props13.appearance, appearance = _this$props13$appeara === void 0 ? 'default' : _this$props13$appeara, _this$props13$spacing = _this$props13.spacing, spacing = _this$props13$spacing === void 0 ? 'default' : _this$props13$spacing;
                var isFocused = this.state.isFocused;
                var commonProps = this.commonProps = this.getCommonProps();
                var isCompact = spacing === 'compact';
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(SelectContainer, (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, commonProps, {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
                    className: className,
                    innerProps: $54e95eb3eee12ee7$var$_objectSpread({
                        id: id,
                        onKeyDown: this.onKeyDown
                    }, testId && {
                        'data-testid': testId && "".concat(testId, "-select--container")
                    }),
                    isDisabled: isDisabled,
                    isFocused: isFocused
                }), this.renderLiveRegion(), commonProps.isMulti && this.renderMultiselectMessage(), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(Control, (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, commonProps, {
                    innerRef: this.getControlRef,
                    innerProps: $54e95eb3eee12ee7$var$_objectSpread({
                        onMouseDown: this.onControlMouseDown,
                        onTouchEnd: this.onControlTouchEnd
                    }, testId && {
                        'data-testid': "".concat(testId, "-select--control")
                    }),
                    appearance: appearance,
                    isInvalid: isInvalid,
                    isDisabled: isDisabled,
                    isFocused: isFocused,
                    menuIsOpen: menuIsOpen,
                    isCompact: isCompact
                }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(ValueContainer, (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, commonProps, {
                    isDisabled: isDisabled,
                    isCompact: isCompact,
                    innerProps: $54e95eb3eee12ee7$var$_objectSpread($54e95eb3eee12ee7$var$_objectSpread({}, testId && {
                        'data-testid': "".concat(testId, "-select--value-container")
                    }), commonProps.isMulti && commonProps.hasValue && !(0, $dJ32z.isAppleDevice)() && {
                        // Required to keep JAWS from popping out of forms mode when using LEFT/RIGHT arrow keys.
                        // This is Jedi Master level ARIA and not taken lightly. Do not modify without consulting
                        // DST Accessibility.
                        role: 'application'
                    })
                }), this.renderPlaceholderOrValue(), this.renderInput()), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(IndicatorsContainer, (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, commonProps, {
                    isDisabled: isDisabled,
                    innerProps: $54e95eb3eee12ee7$var$_objectSpread({}, testId && {
                        'data-testid': "".concat(testId, "-select--indicators-container")
                    })
                }), this.renderClearIndicator(), this.renderLoadingIndicator(), this.renderDropdownIndicator())), this.renderMenu(), this.renderFormField(), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $442ffdf37e3241fb$export$17baa7c95b6ba1b8), {
                    isOpen: this.props.menuIsOpen,
                    onClose: this.handleOpenLayerObserverCloseSignal
                }));
            }
        }
    ], [
        {
            key: "getDerivedStateFromProps",
            value: function getDerivedStateFromProps(props, state) {
                var prevProps = state.prevProps, clearFocusValueOnUpdate = state.clearFocusValueOnUpdate, inputIsHiddenAfterUpdate = state.inputIsHiddenAfterUpdate, ariaSelection = state.ariaSelection, isFocused = state.isFocused, prevWasFocused = state.prevWasFocused, instancePrefix = state.instancePrefix;
                var options = props.options, value = props.value, menuIsOpen = props.menuIsOpen, inputValue = props.inputValue, isMulti = props.isMulti;
                var selectValue = (0, $50a6d89e4bbf23e3$export$33f062f47f21a01)(value);
                var newMenuOptionsState = {};
                if (prevProps && (value !== prevProps.value || options !== prevProps.options || menuIsOpen !== prevProps.menuIsOpen || inputValue !== prevProps.inputValue)) {
                    var focusableOptions = menuIsOpen ? $54e95eb3eee12ee7$var$buildFocusableOptions(props, selectValue) : [];
                    var focusableOptionsWithIds = menuIsOpen ? $54e95eb3eee12ee7$var$buildFocusableOptionsWithIds($54e95eb3eee12ee7$var$buildCategorizedOptions(props, selectValue), "".concat(instancePrefix, "-option")) : [];
                    var focusedValue = clearFocusValueOnUpdate ? $54e95eb3eee12ee7$var$getNextFocusedValue(state, selectValue) : null;
                    var focusedOption = $54e95eb3eee12ee7$var$getNextFocusedOption(state, focusableOptions);
                    var focusedOptionId = $54e95eb3eee12ee7$var$getFocusedOptionId(focusableOptionsWithIds, focusedOption);
                    newMenuOptionsState = {
                        selectValue: selectValue,
                        focusedOption: focusedOption,
                        focusedOptionId: focusedOptionId,
                        focusableOptionsWithIds: focusableOptionsWithIds,
                        focusedValue: focusedValue,
                        clearFocusValueOnUpdate: false
                    };
                }
                // some updates should toggle the state of the input visibility
                var newInputIsHiddenState = inputIsHiddenAfterUpdate != null && props !== prevProps ? {
                    inputIsHidden: inputIsHiddenAfterUpdate,
                    inputIsHiddenAfterUpdate: undefined
                } : {};
                var newAriaSelection = ariaSelection;
                var hasKeptFocus = isFocused && prevWasFocused;
                if (isFocused && !hasKeptFocus) {
                    // If `value` or `defaultValue` props are not empty then announce them
                    // when the Select is initially focused
                    newAriaSelection = {
                        value: (0, $50a6d89e4bbf23e3$export$40fb9515c784cc3b)(isMulti, selectValue, selectValue[0] || null),
                        options: selectValue,
                        action: 'initial-input-focus'
                    };
                    hasKeptFocus = !prevWasFocused;
                }
                // If the 'initial-input-focus' action has been set already
                // then reset the ariaSelection to null
                if ((ariaSelection === null || ariaSelection === void 0 ? void 0 : ariaSelection.action) === 'initial-input-focus') newAriaSelection = null;
                return $54e95eb3eee12ee7$var$_objectSpread($54e95eb3eee12ee7$var$_objectSpread($54e95eb3eee12ee7$var$_objectSpread({}, newMenuOptionsState), newInputIsHiddenState), {}, {
                    prevProps: props,
                    ariaSelection: newAriaSelection,
                    prevWasFocused: hasKeptFocus
                });
            }
        }
    ]);
}((0, $5FkrB.Component));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($54e95eb3eee12ee7$export$2e2bcd8739ae039, "defaultProps", $54e95eb3eee12ee7$export$9c21a3269931e1e6);



var $25nEq = parcelRequire("25nEq");

var $iYJcE = parcelRequire("iYJcE");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");

var $1cf55d863bcd54a2$var$_excluded = [
    "defaultOptions",
    "cacheOptions",
    "loadOptions",
    "options",
    "isLoading",
    "onInputChange",
    "filterOption"
];
function $1cf55d863bcd54a2$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $1cf55d863bcd54a2$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $1cf55d863bcd54a2$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $1cf55d863bcd54a2$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $1cf55d863bcd54a2$export$2e2bcd8739ae039(_ref) {
    var _ref$defaultOptions = _ref.defaultOptions, propsDefaultOptions = _ref$defaultOptions === void 0 ? false : _ref$defaultOptions, _ref$cacheOptions = _ref.cacheOptions, cacheOptions = _ref$cacheOptions === void 0 ? false : _ref$cacheOptions, propsLoadOptions = _ref.loadOptions, propsOptions = _ref.options, _ref$isLoading = _ref.isLoading, propsIsLoading = _ref$isLoading === void 0 ? false : _ref$isLoading, propsOnInputChange = _ref.onInputChange, _ref$filterOption = _ref.filterOption, filterOption = _ref$filterOption === void 0 ? null : _ref$filterOption, restSelectProps = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $1cf55d863bcd54a2$var$_excluded);
    var propsInputValue = restSelectProps.inputValue;
    var lastRequest = (0, $5FkrB.useRef)(undefined);
    var mounted = (0, $5FkrB.useRef)(false);
    var _useState = (0, $5FkrB.useState)(Array.isArray(propsDefaultOptions) ? propsDefaultOptions : undefined), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), defaultOptions = _useState2[0], setDefaultOptions = _useState2[1];
    var _useState3 = (0, $5FkrB.useState)(typeof propsInputValue !== 'undefined' ? propsInputValue : ''), _useState4 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState3, 2), stateInputValue = _useState4[0], setStateInputValue = _useState4[1];
    var _useState5 = (0, $5FkrB.useState)(propsDefaultOptions === true), _useState6 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState5, 2), isLoading = _useState6[0], setIsLoading = _useState6[1];
    var _useState7 = (0, $5FkrB.useState)(undefined), _useState8 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState7, 2), loadedInputValue = _useState8[0], setLoadedInputValue = _useState8[1];
    var _useState9 = (0, $5FkrB.useState)([]), _useState0 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState9, 2), loadedOptions = _useState0[0], setLoadedOptions = _useState0[1];
    var _useState1 = (0, $5FkrB.useState)(false), _useState10 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState1, 2), passEmptyOptions = _useState10[0], setPassEmptyOptions = _useState10[1];
    var _useState11 = (0, $5FkrB.useState)({}), _useState12 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState11, 2), optionsCache = _useState12[0], setOptionsCache = _useState12[1];
    var _useState13 = (0, $5FkrB.useState)(undefined), _useState14 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState13, 2), prevDefaultOptions = _useState14[0], setPrevDefaultOptions = _useState14[1];
    var _useState15 = (0, $5FkrB.useState)(undefined), _useState16 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState15, 2), prevCacheOptions = _useState16[0], setPrevCacheOptions = _useState16[1];
    if (cacheOptions !== prevCacheOptions) {
        setOptionsCache({});
        setPrevCacheOptions(cacheOptions);
    }
    if (propsDefaultOptions !== prevDefaultOptions) {
        setDefaultOptions(Array.isArray(propsDefaultOptions) ? propsDefaultOptions : undefined);
        setPrevDefaultOptions(propsDefaultOptions);
    }
    (0, $5FkrB.useEffect)(function() {
        mounted.current = true;
        return function() {
            mounted.current = false;
        };
    }, []);
    var loadOptions = (0, $5FkrB.useCallback)(function(inputValue, callback) {
        if (!propsLoadOptions) return callback();
        var loader = propsLoadOptions(inputValue, callback);
        if (loader && typeof loader.then === 'function') loader.then(callback, function() {
            return callback();
        });
    }, [
        propsLoadOptions
    ]);
    (0, $5FkrB.useEffect)(function() {
        if (propsDefaultOptions === true) loadOptions(stateInputValue, function(options) {
            if (!mounted.current) return;
            setDefaultOptions(options || []);
            setIsLoading(!!lastRequest.current);
        });
    // NOTE: this effect is designed to only run when the component mounts,
    // so we don't want to include any hook dependencies
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    var onInputChange = (0, $5FkrB.useCallback)(function(newValue, actionMeta) {
        var inputValue = (0, $50a6d89e4bbf23e3$export$2096bae78ecda911)(newValue, actionMeta, propsOnInputChange);
        if (!inputValue) {
            lastRequest.current = undefined;
            setStateInputValue('');
            setLoadedInputValue('');
            setLoadedOptions([]);
            setIsLoading(false);
            setPassEmptyOptions(false);
            return;
        }
        if (cacheOptions && optionsCache[inputValue]) {
            setStateInputValue(inputValue);
            setLoadedInputValue(inputValue);
            setLoadedOptions(optionsCache[inputValue]);
            setIsLoading(false);
            setPassEmptyOptions(false);
        } else {
            var request = lastRequest.current = {};
            setStateInputValue(inputValue);
            setIsLoading(true);
            setPassEmptyOptions(!loadedInputValue);
            loadOptions(inputValue, function(options) {
                if (!mounted) return;
                if (request !== lastRequest.current) return;
                lastRequest.current = undefined;
                setIsLoading(false);
                setLoadedInputValue(inputValue);
                setLoadedOptions(options || []);
                setPassEmptyOptions(false);
                setOptionsCache(options ? $1cf55d863bcd54a2$var$_objectSpread($1cf55d863bcd54a2$var$_objectSpread({}, optionsCache), {}, (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, inputValue, options)) : optionsCache);
            });
        }
    }, [
        cacheOptions,
        loadOptions,
        loadedInputValue,
        optionsCache,
        propsOnInputChange
    ]);
    var options = passEmptyOptions ? [] : stateInputValue && loadedInputValue ? loadedOptions : defaultOptions || [];
    return $1cf55d863bcd54a2$var$_objectSpread($1cf55d863bcd54a2$var$_objectSpread({}, restSelectProps), {}, {
        options: options,
        isLoading: isLoading || propsIsLoading,
        onInputChange: onInputChange,
        filterOption: filterOption
    });
}



var $25nEq = parcelRequire("25nEq");

var $iYJcE = parcelRequire("iYJcE");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");
var $1430b93886e05c4f$var$_excluded = [
    "defaultInputValue",
    "defaultMenuIsOpen",
    "defaultValue",
    "inputValue",
    "menuIsOpen",
    "onChange",
    "onInputChange",
    "onMenuClose",
    "onMenuOpen",
    "value"
];
function $1430b93886e05c4f$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $1430b93886e05c4f$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $1430b93886e05c4f$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $1430b93886e05c4f$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $1430b93886e05c4f$export$2e2bcd8739ae039(_ref) {
    var _ref$defaultInputValu = _ref.defaultInputValue, defaultInputValue = _ref$defaultInputValu === void 0 ? '' : _ref$defaultInputValu, _ref$defaultMenuIsOpe = _ref.defaultMenuIsOpen, defaultMenuIsOpen = _ref$defaultMenuIsOpe === void 0 ? false : _ref$defaultMenuIsOpe, _ref$defaultValue = _ref.defaultValue, defaultValue = _ref$defaultValue === void 0 ? null : _ref$defaultValue, propsInputValue = _ref.inputValue, propsMenuIsOpen = _ref.menuIsOpen, propsOnChange = _ref.onChange, propsOnInputChange = _ref.onInputChange, propsOnMenuClose = _ref.onMenuClose, propsOnMenuOpen = _ref.onMenuOpen, propsValue = _ref.value, restSelectProps = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $1430b93886e05c4f$var$_excluded);
    var _useState = (0, $5FkrB.useState)(propsInputValue !== undefined ? propsInputValue : defaultInputValue), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), stateInputValue = _useState2[0], setStateInputValue = _useState2[1];
    var _useState3 = (0, $5FkrB.useState)(propsMenuIsOpen !== undefined ? propsMenuIsOpen : defaultMenuIsOpen), _useState4 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState3, 2), stateMenuIsOpen = _useState4[0], setStateMenuIsOpen = _useState4[1];
    var _useState5 = (0, $5FkrB.useState)(propsValue !== undefined ? propsValue : defaultValue), _useState6 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState5, 2), stateValue = _useState6[0], setStateValue = _useState6[1];
    var onChange = (0, $5FkrB.useCallback)(function(value, actionMeta) {
        if (typeof propsOnChange === 'function') propsOnChange(value, actionMeta);
        setStateValue(value);
    }, [
        propsOnChange
    ]);
    var onInputChange = (0, $5FkrB.useCallback)(function(value, actionMeta) {
        var newValue;
        if (typeof propsOnInputChange === 'function') newValue = propsOnInputChange(value, actionMeta);
        setStateInputValue(newValue !== undefined ? newValue : value);
    }, [
        propsOnInputChange
    ]);
    var onMenuOpen = (0, $5FkrB.useCallback)(function() {
        if (typeof propsOnMenuOpen === 'function') propsOnMenuOpen();
        setStateMenuIsOpen(true);
    }, [
        propsOnMenuOpen
    ]);
    var onMenuClose = (0, $5FkrB.useCallback)(function() {
        if (typeof propsOnMenuClose === 'function') propsOnMenuClose();
        setStateMenuIsOpen(false);
    }, [
        propsOnMenuClose
    ]);
    var inputValue = propsInputValue !== undefined ? propsInputValue : stateInputValue;
    var menuIsOpen = propsMenuIsOpen !== undefined ? propsMenuIsOpen : stateMenuIsOpen;
    var value = propsValue !== undefined ? propsValue : stateValue;
    //@ts-ignore react-select unsupported props
    return $1430b93886e05c4f$var$_objectSpread($1430b93886e05c4f$var$_objectSpread({}, restSelectProps), {}, {
        inputValue: inputValue,
        menuIsOpen: menuIsOpen,
        onChange: onChange,
        onInputChange: onInputChange,
        onMenuClose: onMenuClose,
        onMenuOpen: onMenuOpen,
        value: value
    });
}


var $14b2852a172560bb$var$AsyncSelect = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function(props, ref) {
    // when isAsync is true, options are not provided and async props are used, we will enable async
    var isAsyncEnabledInBaseSelect = props.isAsync && !props.options && (!!props.loadOptions || !!props.defaultOptions);
    var stateManagedProps = (0, $1cf55d863bcd54a2$export$2e2bcd8739ae039)(props);
    // when isAsync is falsy or isAsyncEnabledInBaseSelect is true, we use async props, otherwise we use base props
    var selectAsyncProps = !props.isAsync || isAsyncEnabledInBaseSelect ? stateManagedProps : props;
    var selectProps = (0, $1430b93886e05c4f$export$2e2bcd8739ae039)(selectAsyncProps);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $54e95eb3eee12ee7$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        ref: ref
    }, selectProps));
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$14b2852a172560bb$export$2e2bcd8739ae039 = $14b2852a172560bb$var$AsyncSelect;



var $kqp0i = parcelRequire("kqp0i");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");
var $1edc48046cb74714$var$_excluded = [
    "ariaLiveMessages",
    "isInvalid",
    "onClickPreventDefault",
    "tabSelectsValue",
    "validationState"
];
function $1edc48046cb74714$export$2e2bcd8739ae039(WrappedComponent) {
    var AtlaskitSelect = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function AtlaskitSelect(props, forwardedRef) {
        var ariaLiveMessages = props.ariaLiveMessages, isInvalid = props.isInvalid, _props$onClickPrevent = props.onClickPreventDefault, onClickPreventDefault = _props$onClickPrevent === void 0 ? true : _props$onClickPrevent, _props$tabSelectsValu = props.tabSelectsValue, tabSelectsValue = _props$tabSelectsValu === void 0 ? false : _props$tabSelectsValu, _props$validationStat = props.validationState, validationState = _props$validationStat === void 0 ? 'default' : _props$validationStat, restProps = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(props, $1edc48046cb74714$var$_excluded);
        var internalSelectRef = (0, $5FkrB.useRef)(null);
        /**
     * The following `useImperativeHandle` hook exists for the sake of backwards compatibility.
     * This component used to be a class component which set the value of the `ref` prop to object with the properties and value as below.
     * This has lead to slightly odd usage of refs with this component, e.g. `myRef.current.select.select.controlRef` instead of just `myRef.current.select.controlRef`
     * In the next major release, this should removed and the ref should be passed directly to the wrapped component (given users have updated usage)
     * More info https://stash.atlassian.com/projects/ATLASSIAN/repos/atlassian-frontend-monorepo/pull-requests/88021/overview
     */ (0, $5FkrB.useImperativeHandle)(forwardedRef, function() {
            return {
                select: internalSelectRef.current,
                focus: function focus() {
                    var _internalSelectRef$cu;
                    return (_internalSelectRef$cu = internalSelectRef.current) === null || _internalSelectRef$cu === void 0 ? void 0 : _internalSelectRef$cu.focus();
                },
                blur: function blur() {
                    var _internalSelectRef$cu2;
                    return (_internalSelectRef$cu2 = internalSelectRef.current) === null || _internalSelectRef$cu2 === void 0 ? void 0 : _internalSelectRef$cu2.blur();
                }
            };
        }, []);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(WrappedComponent, (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
            ref: internalSelectRef,
            ariaLiveMessages: ariaLiveMessages,
            tabSelectsValue: tabSelectsValue,
            onClickPreventDefault: onClickPreventDefault,
            isInvalid: isInvalid || validationState === 'error'
        }, restProps, {
            // indicates react-select to be async by default using the base Select component
            // so that makers can pass all async props on the base select to async load options.
            isAsync: true
        }));
    });
    AtlaskitSelect.displayName = 'AtlaskitSelect';
    return AtlaskitSelect;
}


var $f7c144361eb4a177$var$packageName = "@atlaskit/select";
var $f7c144361eb4a177$var$packageVersion = "21.7.7";
var $f7c144361eb4a177$export$d1de3b251ccaa8a3 = (0, $1edc48046cb74714$export$2e2bcd8739ae039)((0, $14b2852a172560bb$export$2e2bcd8739ae039));
var $f7c144361eb4a177$var$createAndFireEventOnAtlaskit = (0, $b538421461624312$export$2e2bcd8739ae039)('atlaskit');
var $f7c144361eb4a177$var$Select = (0, $99c8b6438816a211$export$2e2bcd8739ae039)({
    componentName: 'select',
    packageName: $f7c144361eb4a177$var$packageName,
    packageVersion: $f7c144361eb4a177$var$packageVersion
})((0, $7af0e6f035c43fdf$export$2e2bcd8739ae039)({
    onChange: $f7c144361eb4a177$var$createAndFireEventOnAtlaskit({
        action: 'changed',
        actionSubject: 'option',
        attributes: {
            componentName: 'select',
            packageName: $f7c144361eb4a177$var$packageName,
            packageVersion: $f7c144361eb4a177$var$packageVersion
        }
    })
})($f7c144361eb4a177$export$d1de3b251ccaa8a3));
var $f7c144361eb4a177$export$2e2bcd8739ae039 = $f7c144361eb4a177$var$Select;



function $fc6840133e04adc0$var$$parcel$exportWildcard(dest, source) {
    Object.keys(source).forEach(function(key) {
        if (key === 'default' || key === '__esModule' || dest.hasOwnProperty(key)) return;
        Object.defineProperty(dest, key, {
            enumerable: true,
            get: function get() {
                return source[key];
            }
        });
    });
    return dest;
}
function $fc6840133e04adc0$var$$parcel$export(e, n, v, s) {
    Object.defineProperty(e, n, {
        get: v,
        set: s,
        enumerable: true,
        configurable: true
    });
}
function $fc6840133e04adc0$var$$parcel$defineInteropFlag(a) {
    Object.defineProperty(a, '__esModule', {
        value: true,
        configurable: true
    });
}
/// <reference types="./types/custom.d.ts" />
var $fc6840133e04adc0$var$$a69491ea5a126553$exports = {};
var $fc6840133e04adc0$var$$5d4509b60606b6df$exports = {};
var $fc6840133e04adc0$var$$660bd1c6cb41002a$exports = {};
$fc6840133e04adc0$var$$parcel$export($fc6840133e04adc0$var$$660bd1c6cb41002a$exports, "Blockquote", ()=>$fc6840133e04adc0$export$29a7a275fe11687);
$fc6840133e04adc0$var$$parcel$export($fc6840133e04adc0$var$$660bd1c6cb41002a$exports, "blockquoteStyles", ()=>$fc6840133e04adc0$export$7a77f8e9665fa6b2);
const $fc6840133e04adc0$export$29a7a275fe11687 = ({ children: children })=>{
    return (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("blockquote", {
        css: (0, $74Zh5.css)($fc6840133e04adc0$export$7a77f8e9665fa6b2),
        children: children
    });
};
const $fc6840133e04adc0$var$$660bd1c6cb41002a$var$fontSizeStyles = {
    fontSize: "1.5rem",
    lineHeight: "2.25rem",
    fontWeight: 600
};
const $fc6840133e04adc0$export$7a77f8e9665fa6b2 = {
    paddingLeft: 0,
    fontFamily: "Inter, sans-serif",
    color: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.text"),
    ...$fc6840133e04adc0$var$$660bd1c6cb41002a$var$fontSizeStyles,
    span: $fc6840133e04adc0$var$$660bd1c6cb41002a$var$fontSizeStyles,
    "&:before, &:after": {
        content: "''"
    }
};
var $fc6840133e04adc0$var$$fec02fc26c7e145d$exports = {};
$fc6840133e04adc0$var$$parcel$export($fc6840133e04adc0$var$$fec02fc26c7e145d$exports, "ButtonSize", ()=>$fc6840133e04adc0$export$5dd2748b7940a2a0);
$fc6840133e04adc0$var$$parcel$export($fc6840133e04adc0$var$$fec02fc26c7e145d$exports, "ButtonAppearance", ()=>$fc6840133e04adc0$export$261c9483fc4a455a);
$fc6840133e04adc0$var$$parcel$export($fc6840133e04adc0$var$$fec02fc26c7e145d$exports, "Button", ()=>$fc6840133e04adc0$export$353f5b6fc5456de1);
const $fc6840133e04adc0$var$$ecfd5f2b18d4854e$export$b7c3a2f69225ecf = ({ label: label, type: type, clickHandler: clickHandler, iconBefore: iconBefore, iconAfter: iconAfter, appearance: appearance, testId: testId, href: href, target: target, fullWidth: fullWidth = false, disabled: disabled = false, isLoading: isLoading = false, selected: selected = false })=>{
    return (0, $6bec4f26b2cb3094$export$25062201e9e25d76)((0, $c3c8d096647b33a1$export$2e2bcd8739ae039), {
        "aria-label": label.replaceAll("-", " "),
        type: type,
        onClick: clickHandler,
        iconBefore: iconBefore,
        iconAfter: iconAfter,
        appearance: appearance,
        testId: testId,
        href: href,
        target: target,
        shouldFitContainer: fullWidth,
        isDisabled: disabled || isLoading,
        isSelected: selected,
        css: [
            isLoading && !label && (0, $74Zh5.css)({
                padding: "21px 49px",
                alignItems: "center"
            }),
            fullWidth && (0, $74Zh5.css)({
                width: "100%",
                justifyContent: "center"
            })
        ],
        children: [
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("span", {
                css: [
                    isLoading && label && (0, $74Zh5.css)({
                        marginRight: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.100")
                    })
                ],
                children: label
            }),
            isLoading && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $QCI6S.default), {
                testId: "spinner",
                size: "small"
            })
        ]
    });
};
const $fc6840133e04adc0$var$$384448a6ffd0907f$export$5be053290bf6cd4c = (appearance, selected, disabled)=>{
    let testId = `button-${appearance}`;
    if (selected) testId += "-selected";
    if (disabled) testId += "-disabled";
    return testId;
};
const $fc6840133e04adc0$var$$384448a6ffd0907f$export$99c79d2ae299b19a = (iconType)=>iconType ? iconType.replaceAll("-", " ") : "button icon";
const $fc6840133e04adc0$var$$f0f55be381b0aa07$export$c25acd513dcc8062 = ({ clickHandler: clickHandler, testId: testId, disabled: disabled = false, selected: selected = false, isLoading: isLoading = false, tooltip: tooltip, iconType: iconType, showBeforeIcon: showBeforeIcon, href: href, target: target, iconColor: iconColor })=>{
    const commonProps = {
        tabIndex: 0,
        "aria-label": $fc6840133e04adc0$var$$384448a6ffd0907f$export$99c79d2ae299b19a(iconType),
        "data-testid": testId,
        css: [
            $fc6840133e04adc0$var$$f0f55be381b0aa07$var$learningButtonIconStyles["base"],
            selected && $fc6840133e04adc0$var$$f0f55be381b0aa07$var$learningButtonIconStyles["selected"],
            iconColor && (0, $74Zh5.css)({
                color: iconColor
            })
        ],
        onClick: clickHandler
    };
    const content = (0, $6bec4f26b2cb3094$export$25062201e9e25d76)((0, $6bec4f26b2cb3094$export$ffb0004e005737fa), {
        children: [
            isLoading && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $QCI6S.default), {
                testId: "spinner",
                size: "small"
            }),
            showBeforeIcon
        ]
    });
    let element;
    if (href && !disabled) element = (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("a", {
        ...commonProps,
        href: href,
        target: target,
        rel: target === "_blank" ? "noreferrer" : "",
        children: content
    });
    else element = (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("button", {
        id: "icon-button",
        ...commonProps,
        disabled: disabled,
        children: content
    });
    return tooltip ? (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $1oVT1.default), {
        content: tooltip,
        testId: "tooltip",
        children: element
    }) : element;
};
const $fc6840133e04adc0$var$$f0f55be381b0aa07$var$learningButtonIconStyles = {
    base: (0, $74Zh5.css)({
        width: "24px",
        height: "24px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        borderRadius: "4px",
        border: "none",
        color: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.icon"),
        backgroundColor: "transparent",
        cursor: "pointer",
        "&:hover": {
            backgroundColor: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.background.accent.gray.subtlest.hovered")
        },
        "&:active": {
            backgroundColor: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.background.accent.gray.subtlest.pressed")
        },
        "&:disabled": {
            backgroundColor: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.background.disabled"),
            color: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.icon.disabled"),
            cursor: "not-allowed"
        }
    }),
    selected: (0, $74Zh5.css)({
        backgroundColor: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.background.selected"),
        color: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.icon.selected"),
        "&:hover": {
            backgroundColor: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.background.selected.hovered"),
            color: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.icon.selected")
        }
    })
};
const $fc6840133e04adc0$var$$426d900cf47bc59f$export$8f9833f38f34a075 = {
    basic: (0, $74Zh5.css)({
        fontFamily: "Charlie Text, sans-serif",
        display: "flex",
        alignItems: "center",
        borderRadius: "4px",
        borderStyle: "solid",
        borderWidth: "1px",
        cursor: "pointer",
        textDecoration: "none",
        justifyContent: "center",
        maxWidth: "max-content",
        width: "100%",
        whiteSpace: "nowrap",
        boxSizing: "border-box",
        height: "40px",
        "&:hover": {
            backgroundColor: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.background.selected.bold.hovered"),
            borderColor: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.border.selected"),
            color: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.text.inverse"),
            textDecoration: "none"
        },
        "&:active": {
            backgroundColor: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.background.selected.bold.pressed"),
            borderColor: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.border.selected"),
            color: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.text.inverse")
        },
        "&:disabled": {
            backgroundColor: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.background.disabled"),
            borderColor: "transparent",
            color: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.text.subtle"),
            cursor: "not-allowed"
        }
    }),
    primary: (0, $74Zh5.css)({
        padding: `10px ${(0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.150")}`,
        backgroundColor: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.background.brand.bold"),
        borderColor: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.border.brand"),
        color: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.text.inverse"),
        "&:focus-visible": {
            outline: `2px solid ${(0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.border.focused")}`
        }
    }),
    secondary: (0, $74Zh5.css)({
        padding: `10px ${(0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.150")}`,
        backgroundColor: "transparent",
        borderColor: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.border.brand"),
        color: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.text.brand")
    }),
    danger: (0, $74Zh5.css)({
        padding: `10px ${(0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.150")}`,
        backgroundColor: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.background.danger.bold"),
        borderColor: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.border.danger"),
        color: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.text.inverse")
    }),
    warning: (0, $74Zh5.css)({
        padding: `10px ${(0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.150")}`,
        backgroundColor: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.background.warning.bold"),
        borderColor: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.border.warning"),
        color: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.text.warning.inverse")
    }),
    subtle: (0, $74Zh5.css)({
        padding: `10px ${(0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.150")}`,
        backgroundColor: "transparent",
        borderColor: "transparent",
        color: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.text")
    }),
    success: (0, $74Zh5.css)({
        padding: `10px ${(0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.150")}`,
        backgroundColor: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.background.success.bold"),
        borderColor: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.border.success"),
        color: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.text.inverse")
    }),
    selected: (0, $74Zh5.css)({
        backgroundColor: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.background.selected"),
        borderColor: "transparent",
        color: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.text.brand"),
        "&:hover": {
            backgroundColor: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.background.selected"),
            borderColor: "transparent",
            color: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.text.brand")
        }
    })
};
const $fc6840133e04adc0$var$$426d900cf47bc59f$export$b2e4e24d9c5d7463 = {
    medium: (0, $74Zh5.css)({
        fontSize: "16px",
        lineHeight: "20px",
        fontWeight: 600,
        height: "40px"
    }),
    large: (0, $74Zh5.css)({
        fontSize: "20px",
        lineHeight: "24px",
        fontWeight: 600,
        height: "48px"
    })
};
const $fc6840133e04adc0$var$$426d900cf47bc59f$export$84379743ac6ff850 = {
    medium: (0, $74Zh5.css)({
        padding: `10px ${(0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.150")}`
    }),
    "medium-icon-before": (0, $74Zh5.css)({
        padding: `10px ${(0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.150")} 10px 10px`
    }),
    "medium-icon-after": (0, $74Zh5.css)({
        padding: `10px 10px 10px ${(0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.150")}`
    }),
    large: (0, $74Zh5.css)({
        maxWidth: "max-content",
        padding: `${(0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.150")} ${(0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.200")}`
    }),
    "large-icon-before": (0, $74Zh5.css)({
        padding: `${(0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.150")} ${(0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.200")} ${(0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.150")} ${(0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.150")}`
    }),
    "large-icon-after": (0, $74Zh5.css)({
        padding: `${(0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.150")} ${(0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.150")} ${(0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.150")} ${(0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.200")}`
    })
};
const $fc6840133e04adc0$var$$426d900cf47bc59f$export$6398dd78520de6de = {
    large: (0, $74Zh5.css)({
        [(0, $0bc19dfefbafca8c$export$987d49ffe1b0900f).below.sm]: {
            padding: `10px ${(0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.150")}`
        }
    }),
    "large-icon-before": (0, $74Zh5.css)({
        [(0, $0bc19dfefbafca8c$export$987d49ffe1b0900f).below.sm]: {
            padding: `10px ${(0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.150")} 10px 10px`
        }
    }),
    "large-icon-after": (0, $74Zh5.css)({
        [(0, $0bc19dfefbafca8c$export$987d49ffe1b0900f).below.sm]: {
            padding: `10px 10px 10px ${(0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.150")}`
        }
    })
};
const $fc6840133e04adc0$var$$426d900cf47bc59f$export$9d41b2b2e9b27135 = (0, $74Zh5.css)({
    [(0, $0bc19dfefbafca8c$export$987d49ffe1b0900f).below.sm]: {
        fontSize: "16px",
        lineHeight: "20px"
    }
});
const $fc6840133e04adc0$var$$426d900cf47bc59f$export$1870a7443335e00d = (0, $74Zh5.css)({
    width: "20px",
    height: "20px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0,
    "& > span": {
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
    },
    "& svg": {
        maxWidth: "20px",
        maxHeight: "20px"
    }
});
const $fc6840133e04adc0$var$$426d900cf47bc59f$export$46d009ded5eecf4e = (0, $74Zh5.css)({
    color: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.icon"),
    cursor: "not-allowed"
});
const $fc6840133e04adc0$var$$426d900cf47bc59f$export$d0e85600c25cfb6 = (0, $74Zh5.css)({
    backgroundColor: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.background.disabled"),
    borderColor: "transparent",
    color: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.text.subtle"),
    "&:hover": {
        backgroundColor: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.background.disabled"),
        borderColor: "transparent",
        color: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.text.subtle"),
        cursor: "not-allowed"
    }
});
const $fc6840133e04adc0$var$$6fde84a571ed6267$export$8c0322faba831be3 = (appearance, size)=>[
        $fc6840133e04adc0$var$$426d900cf47bc59f$export$8f9833f38f34a075["basic"],
        $fc6840133e04adc0$var$$426d900cf47bc59f$export$8f9833f38f34a075[appearance],
        $fc6840133e04adc0$var$$426d900cf47bc59f$export$b2e4e24d9c5d7463[size]
    ];
const $fc6840133e04adc0$var$$6fde84a571ed6267$export$18739f551ab326b6 = (size, isButtonWithoutIcon, showBeforeIcon, showAfterIcon)=>{
    const styles = [];
    if (isButtonWithoutIcon) styles.push($fc6840133e04adc0$var$$426d900cf47bc59f$export$84379743ac6ff850[size]);
    if (showBeforeIcon) styles.push($fc6840133e04adc0$var$$426d900cf47bc59f$export$84379743ac6ff850[`${size}-icon-before`]);
    if (showAfterIcon) styles.push($fc6840133e04adc0$var$$426d900cf47bc59f$export$84379743ac6ff850[`${size}-icon-after`]);
    return styles;
};
const $fc6840133e04adc0$var$$6fde84a571ed6267$export$10dac92f1edafe3b = (isResponsiveSpacing, size, showBeforeIcon, showAfterIcon)=>{
    const styles = [
        $fc6840133e04adc0$var$$426d900cf47bc59f$export$6398dd78520de6de[size],
        $fc6840133e04adc0$var$$426d900cf47bc59f$export$9d41b2b2e9b27135
    ];
    if (!isResponsiveSpacing) return [];
    if (showBeforeIcon) styles.push($fc6840133e04adc0$var$$426d900cf47bc59f$export$6398dd78520de6de[`${size}-icon-before`]);
    if (showAfterIcon) styles.push($fc6840133e04adc0$var$$426d900cf47bc59f$export$6398dd78520de6de[`${size}-icon-after`]);
    return styles;
};
const $fc6840133e04adc0$var$$6fde84a571ed6267$export$1bff1bc920069ec8 = (appearance)=>{
    if (appearance === $fc6840133e04adc0$export$261c9483fc4a455a.PRIMARY) return (0, $74Zh5.css)({
        color: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.text.inverse")
    });
    if (appearance === $fc6840133e04adc0$export$261c9483fc4a455a.SECONDARY) return (0, $74Zh5.css)({
        color: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.text.brand")
    });
    return null;
};
const $fc6840133e04adc0$var$$6fde84a571ed6267$export$3f4ba612f3306fd2 = (selected, isLoading, disabled, fullWidth)=>{
    const styles = [];
    if (selected) styles.push($fc6840133e04adc0$var$$426d900cf47bc59f$export$8f9833f38f34a075["selected"]);
    if (isLoading || disabled) styles.push((0, $74Zh5.css)({
        ...$fc6840133e04adc0$var$$426d900cf47bc59f$export$d0e85600c25cfb6,
        pointerEvents: "none",
        cursor: "not-allowed"
    }));
    if (fullWidth) styles.push((0, $74Zh5.css)({
        width: "100%",
        maxWidth: "none",
        justifyContent: "center"
    }));
    return styles;
};
const $fc6840133e04adc0$var$$6fde84a571ed6267$export$a803e3773f881664 = (size, isButtonWithoutIcon, showBeforeIcon, showAfterIcon, withPadding = true)=>{
    const linkButtonSpacingStyles = {
        medium: (0, $74Zh5.css)({
            padding: `10px ${(0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.150")}`
        }),
        "medium-icon-before": (0, $74Zh5.css)({
            padding: `10px ${(0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.150")} 10px 10px`
        }),
        "medium-icon-after": (0, $74Zh5.css)({
            padding: `10px 10px 10px ${(0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.150")}`
        }),
        large: (0, $74Zh5.css)({
            maxWidth: "max-content",
            padding: `${(0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.150")} ${(0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.200")}`
        }),
        "large-icon-before": (0, $74Zh5.css)({
            padding: `${(0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.150")} ${(0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.200")} ${(0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.150")} ${(0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.150")}`
        }),
        "large-icon-after": (0, $74Zh5.css)({
            padding: `${(0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.150")} ${(0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.150")} ${(0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.150")} ${(0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.200")}`
        })
    };
    const styles = [];
    if (isButtonWithoutIcon) styles.push(linkButtonSpacingStyles[size]);
    if (showBeforeIcon) styles.push(linkButtonSpacingStyles[`${size}-icon-before`]);
    if (showAfterIcon) styles.push(linkButtonSpacingStyles[`${size}-icon-after`]);
    if (!withPadding) styles.push((0, $74Zh5.css)({
        padding: 0
    }));
    return styles;
};
const $fc6840133e04adc0$var$$9a690c81e99c8d02$var$getLinkButtonStyles = (disabled)=>[
        $fc6840133e04adc0$var$$9a690c81e99c8d02$var$learningButtonLinkStyles["basic"],
        disabled && $fc6840133e04adc0$var$$9a690c81e99c8d02$var$learningButtonLinkStyles["disabled"]
    ];
const $fc6840133e04adc0$var$$9a690c81e99c8d02$export$29d11c0fe2fc51d8 = ({ label: label, disabled: disabled = false, clickHandler: clickHandler, testId: testId, size: size = $fc6840133e04adc0$export$5dd2748b7940a2a0.MEDIUM, href: href, target: target, withPadding: withPadding = true, showBeforeIcon: showBeforeIcon, showAfterIcon: showAfterIcon, isButtonWithoutIcon: isButtonWithoutIcon })=>{
    const commonProps = {
        "aria-label": label.replaceAll("-", " "),
        "data-testid": testId,
        css: [
            ...$fc6840133e04adc0$var$$9a690c81e99c8d02$var$getLinkButtonStyles(disabled),
            ...$fc6840133e04adc0$var$$6fde84a571ed6267$export$a803e3773f881664(size, isButtonWithoutIcon, showBeforeIcon, showAfterIcon, withPadding)
        ]
    };
    const content = (0, $6bec4f26b2cb3094$export$25062201e9e25d76)((0, $6bec4f26b2cb3094$export$ffb0004e005737fa), {
        children: [
            showBeforeIcon && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("span", {
                css: [
                    $fc6840133e04adc0$var$$9a690c81e99c8d02$var$buttonIconContainerStyles,
                    (0, $74Zh5.css)({
                        marginRight: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.050")
                    })
                ],
                children: showBeforeIcon
            }),
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("span", {
                children: label
            }),
            showAfterIcon && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("span", {
                css: [
                    $fc6840133e04adc0$var$$9a690c81e99c8d02$var$buttonIconContainerStyles,
                    (0, $74Zh5.css)({
                        marginLeft: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.050")
                    }),
                    disabled && $fc6840133e04adc0$var$$9a690c81e99c8d02$var$disabledIconStyles
                ],
                children: showAfterIcon
            })
        ]
    });
    if (href && !disabled) return (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("a", {
        ...commonProps,
        href: href,
        target: target,
        rel: target === "_blank" ? "noreferrer" : "",
        onClick: clickHandler,
        children: content
    });
    return (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("button", {
        ...commonProps,
        disabled: disabled,
        onClick: clickHandler,
        children: content
    });
};
const $fc6840133e04adc0$var$$9a690c81e99c8d02$var$learningButtonLinkStyles = {
    basic: (0, $74Zh5.css)({
        display: "flex",
        width: "fit-content",
        padding: `10px ${(0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.150")}`,
        border: "none",
        alignItems: "center",
        fontFamily: "Charlie Text, sans-serif",
        fontWeight: 600,
        fontSize: "16px",
        lineHeight: "20px",
        color: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.text.brand"),
        background: "transparent",
        outline: "none",
        cursor: "pointer",
        "&:hover": {
            color: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.text.brand"),
            textDecoration: "underline",
            textUnderlineOffset: "4px"
        },
        "&:active": {
            color: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.text.brand"),
            textDecoration: "underline"
        }
    }),
    disabled: (0, $74Zh5.css)({
        color: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.text.disabled"),
        "&:hover": {
            textDecoration: "none"
        },
        "&:active": {
            textDecoration: "none"
        }
    })
};
const $fc6840133e04adc0$var$$9a690c81e99c8d02$var$buttonIconContainerStyles = (0, $74Zh5.css)({
    width: "24px",
    height: "24px"
});
const $fc6840133e04adc0$var$$9a690c81e99c8d02$var$disabledIconStyles = (0, $74Zh5.css)({
    color: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.icon.disabled"),
    cursor: "not-allowed"
});
const $fc6840133e04adc0$var$$73286ba8e7c0bafe$export$9508e056e78f90ef = ({ label: label, appearance: appearance, disabled: disabled = false, isLoading: isLoading = false, clickHandler: clickHandler, testId: testId, href: href, target: target, fullWidth: fullWidth = false, selected: selected = false, size: size = $fc6840133e04adc0$export$5dd2748b7940a2a0.MEDIUM, showBeforeIcon: showBeforeIcon, showAfterIcon: showAfterIcon, isButtonWithoutIcon: isButtonWithoutIcon, isResponsiveSpacing: isResponsiveSpacing, as: as = "a", type: type })=>{
    const commonProps = {
        "aria-label": label.replaceAll("-", " "),
        onClick: disabled || isLoading ? undefined : clickHandler,
        role: as === "button" ? undefined : href ? undefined : "button",
        tabIndex: disabled || isLoading ? -1 : 0,
        "data-testid": testId,
        css: [
            ...$fc6840133e04adc0$var$$6fde84a571ed6267$export$8c0322faba831be3(appearance, size),
            ...$fc6840133e04adc0$var$$6fde84a571ed6267$export$18739f551ab326b6(size, isButtonWithoutIcon, showBeforeIcon, showAfterIcon),
            ...$fc6840133e04adc0$var$$6fde84a571ed6267$export$10dac92f1edafe3b(isResponsiveSpacing, size, showBeforeIcon, showAfterIcon),
            $fc6840133e04adc0$var$$6fde84a571ed6267$export$1bff1bc920069ec8(appearance),
            ...$fc6840133e04adc0$var$$6fde84a571ed6267$export$3f4ba612f3306fd2(selected, isLoading, disabled, fullWidth)
        ]
    };
    const children = (0, $6bec4f26b2cb3094$export$25062201e9e25d76)((0, $6bec4f26b2cb3094$export$ffb0004e005737fa), {
        children: [
            isLoading && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $QCI6S.default), {
                testId: "spinner",
                size: "small"
            }),
            showBeforeIcon && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("span", {
                css: [
                    $fc6840133e04adc0$var$$426d900cf47bc59f$export$1870a7443335e00d,
                    label && (0, $74Zh5.css)({
                        marginRight: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.050"),
                        [(0, $0bc19dfefbafca8c$export$987d49ffe1b0900f).below.md]: {
                            marginRight: 0
                        }
                    })
                ],
                children: showBeforeIcon
            }),
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("span", {
                css: isLoading && (0, $74Zh5.css)({
                    marginLeft: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.100")
                }),
                children: label
            }),
            showAfterIcon && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("span", {
                css: [
                    $fc6840133e04adc0$var$$426d900cf47bc59f$export$1870a7443335e00d,
                    (0, $74Zh5.css)({
                        marginLeft: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.050")
                    }),
                    disabled && $fc6840133e04adc0$var$$426d900cf47bc59f$export$46d009ded5eecf4e
                ],
                children: showAfterIcon
            })
        ]
    });
    if (as === "button") return (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("button", {
        ...commonProps,
        type: type,
        disabled: disabled || isLoading,
        children: children
    });
    return (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("a", {
        ...commonProps,
        href: !disabled && !isLoading ? href : undefined,
        target: target,
        rel: target === "_blank" ? "noreferrer" : "",
        children: children
    });
};
const $fc6840133e04adc0$var$$ea4b236bf0573f71$export$69c6dd121e96df9e = ({ label: label, type: type = "button", appearance: appearance, disabled: disabled = false, isLoading: isLoading = false, clickHandler: clickHandler, testId: testId, fullWidth: fullWidth = false, selected: selected = false, size: size = $fc6840133e04adc0$export$5dd2748b7940a2a0.MEDIUM, showBeforeIcon: showBeforeIcon, showAfterIcon: showAfterIcon, isButtonWithoutIcon: isButtonWithoutIcon, isResponsiveSpacing: isResponsiveSpacing, href: href, target: target })=>{
    const commonProps = {
        "aria-label": label.replaceAll("-", " "),
        "data-testid": testId,
        css: [
            ...$fc6840133e04adc0$var$$6fde84a571ed6267$export$8c0322faba831be3(appearance, size),
            ...$fc6840133e04adc0$var$$6fde84a571ed6267$export$18739f551ab326b6(size, isButtonWithoutIcon, showBeforeIcon, showAfterIcon),
            ...$fc6840133e04adc0$var$$6fde84a571ed6267$export$10dac92f1edafe3b(isResponsiveSpacing, size, showBeforeIcon, showAfterIcon),
            ...$fc6840133e04adc0$var$$6fde84a571ed6267$export$3f4ba612f3306fd2(selected, isLoading, disabled, fullWidth)
        ],
        onClick: clickHandler
    };
    const content = (0, $6bec4f26b2cb3094$export$25062201e9e25d76)((0, $6bec4f26b2cb3094$export$ffb0004e005737fa), {
        children: [
            isLoading && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $QCI6S.default), {
                testId: "spinner",
                size: "small"
            }),
            showBeforeIcon && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("span", {
                css: [
                    $fc6840133e04adc0$var$$426d900cf47bc59f$export$1870a7443335e00d,
                    (0, $74Zh5.css)({
                        marginRight: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.050")
                    })
                ],
                children: showBeforeIcon
            }),
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("span", {
                css: [
                    isLoading && (0, $74Zh5.css)({
                        marginLeft: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.100")
                    })
                ],
                children: label
            }),
            showAfterIcon && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("span", {
                css: [
                    $fc6840133e04adc0$var$$426d900cf47bc59f$export$1870a7443335e00d,
                    (0, $74Zh5.css)({
                        marginLeft: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.050")
                    })
                ],
                children: showAfterIcon
            })
        ]
    });
    if (href && !disabled) return (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("a", {
        ...commonProps,
        href: href,
        target: target,
        rel: target === "_blank" ? "noreferrer" : "",
        children: content
    });
    return (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("button", {
        ...commonProps,
        type: type,
        disabled: disabled || isLoading,
        children: content
    });
};
let $fc6840133e04adc0$export$5dd2748b7940a2a0;
(function(ButtonSize) {
    ButtonSize["MEDIUM"] = "medium";
    ButtonSize["LARGE"] = "large";
})($fc6840133e04adc0$export$5dd2748b7940a2a0 || ($fc6840133e04adc0$export$5dd2748b7940a2a0 = {}));
let $fc6840133e04adc0$export$261c9483fc4a455a;
(function(ButtonAppearance) {
    ButtonAppearance["DEFAULT"] = "default";
    ButtonAppearance["DANGER"] = "danger";
    ButtonAppearance["LINK"] = "link";
    ButtonAppearance["PRIMARY"] = "primary";
    ButtonAppearance["SECONDARY"] = "secondary";
    ButtonAppearance["SUBTLE"] = "subtle";
    ButtonAppearance["WARNING"] = "warning";
    ButtonAppearance["ICON"] = "icon";
    ButtonAppearance["SUCCESS"] = "success";
})($fc6840133e04adc0$export$261c9483fc4a455a || ($fc6840133e04adc0$export$261c9483fc4a455a = {}));
const $fc6840133e04adc0$export$353f5b6fc5456de1 = (props)=>{
    const { appearance: appearance = $fc6840133e04adc0$export$261c9483fc4a455a.DEFAULT, selected: selected = false, disabled: disabled = false, size: size = $fc6840133e04adc0$export$5dd2748b7940a2a0.MEDIUM, onClick: onClick, iconBefore: iconBefore, iconAfter: iconAfter, isLoading: isLoading = false, isResponsive: isResponsive = false } = props;
    const clickHandler = (0, $5FkrB.useCallback)((e)=>{
        if (onClick) onClick(e);
    }, [
        onClick
    ]);
    const isButtonWithoutIcon = !iconBefore && !iconAfter;
    const showBeforeIcon = !isLoading && iconBefore || false;
    const showAfterIcon = !isLoading && iconAfter || false;
    const isResponsiveSpacing = isResponsive && [
        $fc6840133e04adc0$export$261c9483fc4a455a.PRIMARY,
        $fc6840133e04adc0$export$261c9483fc4a455a.SECONDARY
    ].includes(appearance) && size === $fc6840133e04adc0$export$5dd2748b7940a2a0.LARGE;
    const testId = $fc6840133e04adc0$var$$384448a6ffd0907f$export$5be053290bf6cd4c(appearance, selected, disabled);
    const commonProps = {
        ...props,
        clickHandler: clickHandler,
        isButtonWithoutIcon: isButtonWithoutIcon,
        showBeforeIcon: showBeforeIcon,
        showAfterIcon: showAfterIcon,
        isResponsiveSpacing: isResponsiveSpacing,
        testId: testId
    };
    const componentMap = {
        [$fc6840133e04adc0$export$261c9483fc4a455a.DEFAULT]: $fc6840133e04adc0$var$$ecfd5f2b18d4854e$export$b7c3a2f69225ecf,
        [$fc6840133e04adc0$export$261c9483fc4a455a.ICON]: $fc6840133e04adc0$var$$f0f55be381b0aa07$export$c25acd513dcc8062,
        [$fc6840133e04adc0$export$261c9483fc4a455a.LINK]: $fc6840133e04adc0$var$$9a690c81e99c8d02$export$29d11c0fe2fc51d8,
        [$fc6840133e04adc0$export$261c9483fc4a455a.PRIMARY]: $fc6840133e04adc0$var$$73286ba8e7c0bafe$export$9508e056e78f90ef,
        [$fc6840133e04adc0$export$261c9483fc4a455a.SECONDARY]: $fc6840133e04adc0$var$$73286ba8e7c0bafe$export$9508e056e78f90ef
    };
    const Component = componentMap[appearance] ?? $fc6840133e04adc0$var$$ea4b236bf0573f71$export$69c6dd121e96df9e;
    return (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)(Component, {
        ...commonProps
    });
};
var $fc6840133e04adc0$var$$d501466973a9f0a6$exports = {};
$fc6840133e04adc0$var$$parcel$export($fc6840133e04adc0$var$$d501466973a9f0a6$exports, "CheckboxType", ()=>$fc6840133e04adc0$export$138e17770a0a93a6);
$fc6840133e04adc0$var$$parcel$export($fc6840133e04adc0$var$$d501466973a9f0a6$exports, "CheckboxSize", ()=>$fc6840133e04adc0$export$5e435bc8b081a399);
$fc6840133e04adc0$var$$parcel$export($fc6840133e04adc0$var$$d501466973a9f0a6$exports, "Checkbox", ()=>$fc6840133e04adc0$export$48513f6b9f8ce62d);
var $fc6840133e04adc0$var$$633811e9cd66d921$exports = {};
$fc6840133e04adc0$var$$parcel$export($fc6840133e04adc0$var$$633811e9cd66d921$exports, "useKeyboardInteraction", ()=>$fc6840133e04adc0$export$2a0b6757d41dacb2);
const $fc6840133e04adc0$export$2a0b6757d41dacb2 = (handler)=>{
    return (0, $5FkrB.useCallback)((e)=>{
        if (e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            e.stopPropagation();
            handler();
        }
    }, [
        handler
    ]);
};
let $fc6840133e04adc0$export$138e17770a0a93a6;
(function(CheckboxType) {
    CheckboxType["DEFAULT"] = "DEFAULT";
    CheckboxType[/** TODO: remove success styles in scope of the QUIZ component update */ "SUCCESS"] = "SUCCESS";
    CheckboxType["DANGER"] = "DANGER";
    CheckboxType["DISABLED"] = "DISABLED";
})($fc6840133e04adc0$export$138e17770a0a93a6 || ($fc6840133e04adc0$export$138e17770a0a93a6 = {}));
let $fc6840133e04adc0$export$5e435bc8b081a399;
(function(CheckboxSize) {
    CheckboxSize["DEFAULT"] = "DEFAULT";
    CheckboxSize["LARGE"] = "LARGE";
})($fc6840133e04adc0$export$5e435bc8b081a399 || ($fc6840133e04adc0$export$5e435bc8b081a399 = {}));
const $fc6840133e04adc0$export$48513f6b9f8ce62d = ({ label: label, isChecked: isChecked, onChange: onChange, type: type = $fc6840133e04adc0$export$138e17770a0a93a6.DEFAULT, size: size = $fc6840133e04adc0$export$5e435bc8b081a399.DEFAULT, isIndeterminate: isIndeterminate = false, isRequired: isRequired = false, isBold: isBold, tabIndex: tabIndex = 0 })=>{
    const [userHasInteracted, setUserHasInteracted] = (0, $5FkrB.useState)(false);
    const checkboxRef = (0, $5FkrB.useRef)(null);
    const handleChange = (0, $5FkrB.useCallback)(()=>{
        setUserHasInteracted(true);
        if (onChange) onChange();
    }, [
        onChange
    ]);
    const handleKeyDown = $fc6840133e04adc0$export$2a0b6757d41dacb2(handleChange);
    (0, $5FkrB.useEffect)(()=>{
        if (checkboxRef.current) checkboxRef.current.indeterminate = isIndeterminate && !userHasInteracted;
    }, [
        isIndeterminate,
        userHasInteracted
    ]);
    return (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("label", {
        onKeyDown: handleKeyDown,
        css: [
            $fc6840133e04adc0$var$$d501466973a9f0a6$var$labelStyles,
            size === $fc6840133e04adc0$export$5e435bc8b081a399.LARGE && $fc6840133e04adc0$var$$d501466973a9f0a6$var$labelLargeStyles,
            type === $fc6840133e04adc0$export$138e17770a0a93a6.DISABLED && $fc6840133e04adc0$var$$d501466973a9f0a6$var$variants.label.DISABLED,
            isBold && (0, $74Zh5.css)({
                fontWeight: 700
            }),
            !isBold && (0, $74Zh5.css)({
                fontWeight: 400
            })
        ],
        children: [
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("input", {
                ref: checkboxRef,
                tabIndex: -1,
                type: "checkbox",
                checked: isChecked,
                onChange: handleChange,
                css: $fc6840133e04adc0$var$$d501466973a9f0a6$var$inputCheckboxStyles
            }),
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$export$e61786c4aee8d415, {
                children: label
            }),
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("span", {
                tabIndex: tabIndex,
                onKeyDown: handleKeyDown,
                css: [
                    $fc6840133e04adc0$var$$d501466973a9f0a6$var$variants.checkbox[type],
                    $fc6840133e04adc0$var$$d501466973a9f0a6$var$checkmarkStyles,
                    size === $fc6840133e04adc0$export$5e435bc8b081a399.LARGE && $fc6840133e04adc0$var$$d501466973a9f0a6$var$checkmarkLargeStyles,
                    isIndeterminate && !userHasInteracted && $fc6840133e04adc0$var$$d501466973a9f0a6$var$indeterminateCheckmarkStyles,
                    isChecked && $fc6840133e04adc0$var$$d501466973a9f0a6$var$checkedCheckmarkStyles,
                    isChecked && type === $fc6840133e04adc0$export$138e17770a0a93a6.DANGER && (0, $74Zh5.css)({
                        backgroundColor: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.border.danger")
                    })
                ]
            }),
            isRequired && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("span", {
                css: [
                    $fc6840133e04adc0$var$$d501466973a9f0a6$var$requiredMarkStyles,
                    size === $fc6840133e04adc0$export$5e435bc8b081a399.LARGE && (0, $74Zh5.css)({
                        marginLeft: "2px"
                    })
                ],
                children: "*"
            })
        ]
    });
};
const $fc6840133e04adc0$var$$d501466973a9f0a6$var$requiredMarkStyles = (0, $74Zh5.css)({
    color: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.text.subtle"),
    marginLeft: "6px"
});
const $fc6840133e04adc0$var$$d501466973a9f0a6$var$labelStyles = (0, $74Zh5.css)({
    display: "flex",
    position: "relative",
    paddingLeft: "22px",
    marginBottom: 0,
    userSelect: "none",
    color: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.text"),
    fontFamily: "Inter, sans-serif",
    fontSize: "16px",
    lineHeight: "22px",
    "&:hover": {
        cursor: "pointer"
    }
});
const $fc6840133e04adc0$var$$d501466973a9f0a6$var$labelLargeStyles = (0, $74Zh5.css)({
    paddingLeft: "28px",
    fontSize: "20px",
    lineHeight: "32px"
});
const $fc6840133e04adc0$var$$d501466973a9f0a6$var$inputCheckboxStyles = (0, $74Zh5.css)({
    position: "absolute",
    opacity: 0,
    cursor: "pointer",
    height: 0,
    width: 0
});
const $fc6840133e04adc0$var$$d501466973a9f0a6$var$checkmarkStyles = (0, $74Zh5.css)({
    position: "absolute",
    top: 0,
    left: 0,
    width: "16px",
    height: "16px",
    marginTop: "3px",
    backgroundColor: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.background.input"),
    border: `1px solid ${(0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.border.input")}`,
    borderRadius: "2px",
    cursor: "pointer",
    "&:after": {
        content: '""',
        position: "absolute",
        display: "none"
    }
});
const $fc6840133e04adc0$var$$d501466973a9f0a6$var$checkedCheckmarkStyles = (0, $74Zh5.css)({
    backgroundColor: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.background.selected.bold"),
    borderColor: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.border.selected"),
    "&:after": {
        display: "block",
        left: "4px",
        top: "1px",
        width: "4px",
        height: "7px",
        border: `solid ${(0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.text.inverse")}`,
        borderWidth: "0 2px 2px 0",
        transform: "rotate(45deg)"
    }
});
const $fc6840133e04adc0$var$$d501466973a9f0a6$var$checkmarkLargeStyles = (0, $74Zh5.css)({
    width: "20px",
    height: "20px",
    marginRight: "8px",
    marginTop: "6px",
    "&:after": {
        left: "5px !important",
        top: "1px",
        width: "6px !important",
        height: "10px !important",
        border: `solid ${(0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.text.inverse")}`,
        borderWidth: "0 2px 2px 0",
        transform: "rotate(45deg)"
    }
});
const $fc6840133e04adc0$var$$d501466973a9f0a6$var$indeterminateCheckmarkStyles = (0, $74Zh5.css)({
    backgroundColor: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.background.selected.bold"),
    borderColor: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.border.selected"),
    "&:after": {
        display: "block",
        left: "2.5px",
        top: "-1px",
        width: "9px",
        height: "7px",
        borderBottom: `2px solid ${(0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.text.inverse")}`
    }
});
const $fc6840133e04adc0$var$$d501466973a9f0a6$var$variants = {
    label: {
        DISABLED: (0, $74Zh5.css)({
            pointerEvents: "none",
            opacity: "31%"
        })
    },
    checkbox: {
        DEFAULT: (0, $74Zh5.css)({
            "&:hover": {
                borderColor: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.border.selected")
            }
        }),
        SUCCESS: (0, $74Zh5.css)({
            "&, &:hover": {
                borderColor: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.border.selected")
            }
        }),
        DANGER: (0, $74Zh5.css)({
            "&, &:hover": {
                borderColor: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.border.danger")
            }
        }),
        DISABLED: (0, $74Zh5.css)({
            pointerEvents: "none",
            opacity: "31%"
        })
    }
};
var $fc6840133e04adc0$var$$c4979bfceee73878$exports = {};
$fc6840133e04adc0$var$$parcel$export($fc6840133e04adc0$var$$c4979bfceee73878$exports, "CommonModal", ()=>$fc6840133e04adc0$export$8577c1390d697bac);
const $fc6840133e04adc0$export$8577c1390d697bac = ({ isOpen: isOpen, toggleModal: toggleModal, modalDescriptionLabel: modalDescription, children: children, styles: styles })=>{
    const closeModal = (0, $5FkrB.useCallback)((e)=>{
        e?.stopPropagation();
        toggleModal(false);
    }, [
        toggleModal
    ]);
    const modalRef = (0, $5FkrB.useRef)(null);
    const focusOnOpen = (0, $5FkrB.useCallback)(()=>{
        if (isOpen) modalRef?.current?.focus();
    }, [
        isOpen
    ]);
    (0, $5FkrB.useEffect)(()=>{
        focusOnOpen();
        const handleEsc = (event)=>{
            if (event.key === "Escape") toggleModal(false);
        };
        document.addEventListener("keyup", handleEsc, false);
        return ()=>{
            document.removeEventListener("keyup", handleEsc, false);
        };
    // focusOnOpen and toggleModal intentionally excluded to avoid re-creating listener
    /* eslint-disable react-hooks/exhaustive-deps */ }, []);
    (0, $5FkrB.useEffect)(()=>{
        focusOnOpen();
    }, [
        isOpen
    ]);
    if (!isOpen) return null;
    return isOpen && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
        css: [
            $fc6840133e04adc0$var$$c4979bfceee73878$var$backdropStyles,
            styles && styles
        ],
        children: (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
            "aria-modal": true,
            role: "dialog",
            ref: modalRef,
            "aria-label": modalDescription,
            tabIndex: -1,
            css: $fc6840133e04adc0$var$$c4979bfceee73878$var$modalStyles,
            children: [
                (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("button", {
                    type: "button",
                    css: $fc6840133e04adc0$var$$c4979bfceee73878$var$closeButtonStyles,
                    onClick: closeModal,
                    children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($3ba3a1ce40cf237e$exports))), {
                        label: "Close Modal",
                        size: "medium",
                        primaryColor: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.icon")
                    })
                }),
                (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                    css: $fc6840133e04adc0$var$$c4979bfceee73878$var$modalSlotStyles,
                    children: children
                })
            ]
        })
    });
};
const $fc6840133e04adc0$var$$c4979bfceee73878$var$backdropStyles = (0, $74Zh5.css)({
    "&, *": {
        boxSizing: "border-box"
    },
    backgroundColor: "gray",
    position: "fixed",
    padding: "16px",
    width: "100vw",
    height: "100vh",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    left: 0,
    top: 0,
    zIndex: 100000000
});
const $fc6840133e04adc0$var$$c4979bfceee73878$var$modalStyles = (0, $74Zh5.css)({
    position: "relative",
    padding: "16px",
    paddingTop: "48px",
    maxWidth: "100%",
    maxHeight: "100%",
    borderRadius: "8px",
    backgroundColor: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.background.input"),
    boxShadow: "0px 0px 1px 0px rgba(9, 30, 66, 0.31), 0px 1px 1px 0px rgba(9, 30, 66, 0.25)",
    zIndex: 200000000
});
const $fc6840133e04adc0$var$$c4979bfceee73878$var$closeButtonStyles = (0, $74Zh5.css)({
    position: "absolute",
    top: "16px",
    right: "16px",
    border: "none",
    outline: "none",
    background: "transparent",
    padding: 0,
    cursor: "pointer",
    borderRadius: "4px",
    "&:hover": {
        backgroundColor: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.background.neutral.subtle.hovered")
    },
    "&:focus svg": {
        color: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.icon.selected")
    },
    "&:active": {
        backgroundColor: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.background.neutral.subtle.pressed")
    },
    "&:disabled": {
        backgroundColor: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.background.accent.gray.subtle.hovered")
    }
});
const $fc6840133e04adc0$var$$c4979bfceee73878$var$modalSlotStyles = (0, $74Zh5.css)({
    minWidth: "100px",
    minHeight: "25px",
    fontSize: "16px"
});
var $fc6840133e04adc0$var$$0903e93de01b205a$exports = {};
$fc6840133e04adc0$var$$parcel$export($fc6840133e04adc0$var$$0903e93de01b205a$exports, "Divider", ()=>$fc6840133e04adc0$export$2e0a83ec2e27ecbb);
/**
 * Horizontal line acting as divider with custom color and height
 * @param {DividerProps} DividerProps
 * @returns {React.ReactElement} React.ReactElement
 *
 * @example
 * <Divider color={token('color.border')} />
 */ const $fc6840133e04adc0$export$2e0a83ec2e27ecbb = ({ color: color, height: height = 1 })=>{
    const styles = {
        height: height + "px",
        border: `0 solid ${(0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.border")}`,
        margin: 0,
        backgroundColor: color
    };
    return (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("hr", {
        "data-testid": "divider",
        style: styles
    });
};
var $fc6840133e04adc0$var$$a950778dc3003c4a$exports = {};
$fc6840133e04adc0$var$$parcel$export($fc6840133e04adc0$var$$a950778dc3003c4a$exports, "Eyebrow", ()=>$fc6840133e04adc0$export$71f050e2efa708bb);
const $fc6840133e04adc0$export$71f050e2efa708bb = ({ fontWeight: fontWeight = "regular", size: size = "small", color: color = (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.text"), children: children })=>{
    return (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("h4", {
        css: [
            $fc6840133e04adc0$var$$a950778dc3003c4a$var$eyebrowSmallStyles,
            size === "medium" && $fc6840133e04adc0$var$$a950778dc3003c4a$var$eyebrowMediumStyles,
            fontWeight === "semibold" && (0, $74Zh5.css)({
                fontWeight: 600
            }),
            color && (0, $74Zh5.css)({
                color: color
            })
        ],
        children: children
    });
};
const $fc6840133e04adc0$var$$a950778dc3003c4a$var$eyebrowSmallStyles = (0, $74Zh5.css)({
    fontFamily: '"Charlie Text", sans-serif',
    fontWeight: 400,
    fontSize: "12px",
    lineHeight: "16px",
    color: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.text"),
    textTransform: "uppercase"
});
const $fc6840133e04adc0$var$$a950778dc3003c4a$var$eyebrowMediumStyles = (0, $74Zh5.css)({
    fontSize: "14px",
    lineHeight: "18px"
});
var $fc6840133e04adc0$var$$582583ec420fce57$exports = {};
$fc6840133e04adc0$var$$parcel$export($fc6840133e04adc0$var$$582583ec420fce57$exports, "Heading", ()=>$fc6840133e04adc0$export$a8a3e93435678ff9);
var $fc6840133e04adc0$var$$fde9406d76ec24a9$exports = {};
$fc6840133e04adc0$var$$parcel$export($fc6840133e04adc0$var$$fde9406d76ec24a9$exports, "objectValuesToControls", ()=>$fc6840133e04adc0$export$8a8918d045227e35);
$fc6840133e04adc0$var$$parcel$export($fc6840133e04adc0$var$$fde9406d76ec24a9$exports, "inspectorProps", ()=>$fc6840133e04adc0$export$1784ac302bd8ebad);
$fc6840133e04adc0$var$$parcel$export($fc6840133e04adc0$var$$fde9406d76ec24a9$exports, "formatMinutes", ()=>$fc6840133e04adc0$export$30c35cbf580cab77);
$fc6840133e04adc0$var$$parcel$export($fc6840133e04adc0$var$$fde9406d76ec24a9$exports, "getRedirectUrl", ()=>$fc6840133e04adc0$export$93832c3affb240d3);
$fc6840133e04adc0$var$$parcel$export($fc6840133e04adc0$var$$fde9406d76ec24a9$exports, "calculateLearningProgress", ()=>$fc6840133e04adc0$export$6e67b290ed5690f6);
$fc6840133e04adc0$var$$parcel$export($fc6840133e04adc0$var$$fde9406d76ec24a9$exports, "SEARCHBAR_HISTORY_STORAGE_KEY", ()=>$fc6840133e04adc0$export$1059c3e9f228d9b);
$fc6840133e04adc0$var$$parcel$export($fc6840133e04adc0$var$$fde9406d76ec24a9$exports, "getLocalStorageHistory", ()=>$fc6840133e04adc0$export$7765f5b61937bda1);
$fc6840133e04adc0$var$$parcel$export($fc6840133e04adc0$var$$fde9406d76ec24a9$exports, "setLocalStorageItems", ()=>$fc6840133e04adc0$export$cec0922aa1b64670);
$fc6840133e04adc0$var$$parcel$export($fc6840133e04adc0$var$$fde9406d76ec24a9$exports, "generateHashFromLabel", ()=>$fc6840133e04adc0$export$1bdcd43c8c2377cf);
const $fc6840133e04adc0$var$$3dba2111a1a6d39b$var$buildAuthQueryParams = ({ email: email, redirectUrl: redirectUrl, prompt: prompt = "none", experience: experience = "entry-auth" })=>{
    const queryParams = [];
    if (email) queryParams.push(`login_hint=${email}`);
    if (experience) queryParams.push(`application=community--${experience}`);
    if (redirectUrl) queryParams.push(`referer=${redirectUrl}`);
    if (prompt) queryParams.push(`prompt=${prompt}`);
    return queryParams;
};
const $fc6840133e04adc0$var$$3dba2111a1a6d39b$export$1db7da00354b15ed = (queryParamValues)=>{
    const queryParams = $fc6840133e04adc0$var$$3dba2111a1a6d39b$var$buildAuthQueryParams(queryParamValues);
    return `/forums/s/plugins/common/feature/oauth2sso_v2/sso_login_redirect?${queryParams.join("&")}`;
};
let $fc6840133e04adc0$export$7dc6752a22ab011a;
(function(Environment) {
    Environment["LOCAL"] = "local";
    Environment["DEVELOPMENT"] = "development";
    Environment["STAGING"] = "staging";
    Environment["PRODUCTION"] = "production";
})($fc6840133e04adc0$export$7dc6752a22ab011a || ($fc6840133e04adc0$export$7dc6752a22ab011a = {}));
const $fc6840133e04adc0$var$$1ff01338112cd7fe$export$1b5aa7388a6c5e6f = {
    [$fc6840133e04adc0$export$7dc6752a22ab011a.LOCAL]: {
        loggedIn: "https://id.stg.internal.atlassian.com",
        loggedOut: "https://id.stg.internal.atlassian.com"
    },
    [$fc6840133e04adc0$export$7dc6752a22ab011a.DEVELOPMENT]: {
        loggedIn: "https://id.stg.internal.atlassian.com",
        loggedOut: "https://id.stg.internal.atlassian.com"
    },
    [$fc6840133e04adc0$export$7dc6752a22ab011a.STAGING]: {
        loggedIn: "https://id.stg.internal.atlassian.com",
        loggedOut: "https://id.stg.internal.atlassian.com"
    },
    [$fc6840133e04adc0$export$7dc6752a22ab011a.PRODUCTION]: {
        loggedIn: "https://id.atlassian.com",
        loggedOut: "https://id.atlassian.com"
    }
};
const $fc6840133e04adc0$var$$1ff01338112cd7fe$export$d349399b473d7299 = {
    loggedIn: "/",
    loggedOut: "/"
};
let $fc6840133e04adc0$export$93d048dc21eb282a;
(function(CommunityApp) {
    CommunityApp["HOME"] = "home";
    CommunityApp["LEARNING"] = "learning";
    CommunityApp["FORUMS"] = "forums";
    CommunityApp["EVENTS"] = "events";
    CommunityApp["PROFILE"] = "unified-portable-profile";
    CommunityApp["CHAMPIONS"] = "champions";
})($fc6840133e04adc0$export$93d048dc21eb282a || ($fc6840133e04adc0$export$93d048dc21eb282a = {}));
const $fc6840133e04adc0$export$67e61a6fa639f224 = (email)=>[
        {
            app: $fc6840133e04adc0$export$93d048dc21eb282a.FORUMS,
            label: "Forums",
            target: "_self",
            href: {
                loggedIn: $fc6840133e04adc0$var$$3dba2111a1a6d39b$export$1db7da00354b15ed({
                    email: email,
                    redirectUrl: "/forums"
                }),
                loggedOut: "/forums"
            }
        },
        {
            app: $fc6840133e04adc0$export$93d048dc21eb282a.LEARNING,
            label: "Learning",
            href: {
                loggedIn: "/learning",
                loggedOut: "/learning"
            }
        },
        {
            app: $fc6840133e04adc0$export$93d048dc21eb282a.EVENTS,
            label: "Events",
            target: "_self",
            href: {
                loggedIn: "/events",
                loggedOut: "/events"
            }
        },
        {
            app: $fc6840133e04adc0$export$93d048dc21eb282a.CHAMPIONS,
            label: "Champions",
            target: "_self",
            href: {
                loggedIn: "/champions",
                loggedOut: "/champions"
            }
        }
    ];
const $fc6840133e04adc0$export$208c68d48dfc9a12 = $fc6840133e04adc0$export$67e61a6fa639f224();
const $fc6840133e04adc0$var$$1ff01338112cd7fe$export$fe0105b4860d6e11 = {
    [$fc6840133e04adc0$export$93d048dc21eb282a.FORUMS]: "/forums",
    [$fc6840133e04adc0$export$93d048dc21eb282a.LEARNING]: "/learning",
    [$fc6840133e04adc0$export$93d048dc21eb282a.EVENTS]: "/events",
    [$fc6840133e04adc0$export$93d048dc21eb282a.PROFILE]: "/user",
    [$fc6840133e04adc0$export$93d048dc21eb282a.CHAMPIONS]: "/champions"
};
const $fc6840133e04adc0$var$$1ff01338112cd7fe$export$132b2bf91782e62b = "/user";
const $fc6840133e04adc0$var$$1ff01338112cd7fe$export$b9cc8022ec117e91 = "/user/settings";
const $fc6840133e04adc0$var$$1ff01338112cd7fe$export$46dbfbdf99745111 = "Log in";
const $fc6840133e04adc0$var$$1ff01338112cd7fe$export$4fe37309c24221ae = "Sign up";
const $fc6840133e04adc0$var$$1ff01338112cd7fe$export$668d072b293d5f38 = {
    PROFILE: {
        text: "Profile",
        id: "profile"
    },
    SETTINGS: {
        text: "Settings",
        id: "settings"
    },
    SWITCH_ACCOUNT: {
        text: "Switch accounts",
        id: "switch-account"
    },
    LOG_OUT: {
        text: "Log out",
        id: "logout"
    }
};
let $fc6840133e04adc0$export$3d7865934588d77e;
(function(EventType) {
    EventType["TRACK"] = "track";
    EventType["UI"] = "ui";
    EventType["OPERATIONAL"] = "operational";
    EventType["SCREEN"] = "screen";
    EventType["IDENTIFY"] = "identify";
})($fc6840133e04adc0$export$3d7865934588d77e || ($fc6840133e04adc0$export$3d7865934588d77e = {}));
let $fc6840133e04adc0$export$d778a884eb401313;
(function(AnalyticsActivityType) {
    AnalyticsActivityType["NAV_LOGO_CLICK"] = "NAV_LOGO_CLICK";
    AnalyticsActivityType["NAV_ITEM_CLICK"] = "NAV_ITEM_CLICK";
    AnalyticsActivityType["LOG_IN_CLICK"] = "LOG_IN_CLICK";
    AnalyticsActivityType["SIGN_UP_CLICK"] = "SIGN_UP_CLICK";
    AnalyticsActivityType["LOG_OUT_CLICK"] = "LOG_OUT_CLICK";
    AnalyticsActivityType["PROFILE_MENU_OPEN"] = "PROFILE_MENU_OPEN";
    AnalyticsActivityType["PROFILE_MENU_CLOSE"] = "PROFILE_MENU_CLOSE";
    AnalyticsActivityType["PROFILE_MENU_ITEM_CLICK"] = "PROFILE_MENU_ITEM_CLICK";
    AnalyticsActivityType["MOBILE_MENU_OPEN"] = "MOBILE_MENU_OPEN";
    AnalyticsActivityType["MOBILE_MENU_CLOSE"] = "MOBILE_MENU_CLOSE";
})($fc6840133e04adc0$export$d778a884eb401313 || ($fc6840133e04adc0$export$d778a884eb401313 = {}));
const $fc6840133e04adc0$var$$1ff01338112cd7fe$export$bc6e44c7f1ae99f6 = "https://www.atlassian.com/legal/community-platform-terms-of-use";
const $fc6840133e04adc0$var$$1ff01338112cd7fe$export$30786e8ac20c09d8 = "https://www.atlassian.com/legal/privacy-policy#what-this-policy-covers";
const $fc6840133e04adc0$export$8a8918d045227e35 = (obj, control = "select")=>({
        control: control,
        options: Object.values(obj)
    });
const $fc6840133e04adc0$export$1784ac302bd8ebad = (key, inspectMode)=>{
    if (inspectMode && inspectMode[key]) {
        const { entryId: entryId, fieldId: fieldId } = inspectMode[key];
        return {
            "data-contentful-entry-id": entryId,
            "data-contentful-field-id": fieldId
        };
    }
};
const $fc6840133e04adc0$export$30c35cbf580cab77 = (minutes)=>{
    const hours = Math.floor(minutes / 60);
    const remainingMinutes = minutes % 60;
    let output = "";
    if (hours > 0) {
        output += `${hours} hour`;
        if (hours > 1) output += "s";
    }
    if (remainingMinutes > 0) {
        if (hours > 0) output += " and ";
        output += `${remainingMinutes} minute`;
        if (remainingMinutes > 1) output += "s";
    }
    return output;
};
const $fc6840133e04adc0$export$93832c3affb240d3 = (url, environment)=>{
    const idUrl = $fc6840133e04adc0$var$$1ff01338112cd7fe$export$1b5aa7388a6c5e6f[environment] || $fc6840133e04adc0$var$$1ff01338112cd7fe$export$1b5aa7388a6c5e6f[$fc6840133e04adc0$export$7dc6752a22ab011a.STAGING];
    return `${idUrl}/login?continue=${encodeURIComponent(url)}`;
};
const $fc6840133e04adc0$export$6e67b290ed5690f6 = (completed, total)=>{
    if (total === 0) return 0;
    return completed / total * 100;
};
const $fc6840133e04adc0$export$1059c3e9f228d9b = "searchbar_history";
const $fc6840133e04adc0$export$7765f5b61937bda1 = ()=>{
    if (typeof window === "undefined") return [];
    const storedHistory = localStorage.getItem($fc6840133e04adc0$export$1059c3e9f228d9b);
    return storedHistory ? JSON.parse(storedHistory) : [];
};
const $fc6840133e04adc0$export$cec0922aa1b64670 = (items)=>{
    if (typeof window === "undefined") return;
    localStorage.setItem($fc6840133e04adc0$export$1059c3e9f228d9b, JSON.stringify(items));
};
const $fc6840133e04adc0$export$1bdcd43c8c2377cf = (label)=>{
    return `#${label.toLowerCase().replace(/ /g, "-")}`;
};
const $fc6840133e04adc0$export$a8a3e93435678ff9 = ({ children: children, level: level, inspectMode: inspectMode, id: id, color: color = (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.text"), fontWeight: fontWeight })=>{
    const HeadingElement = $fc6840133e04adc0$var$$582583ec420fce57$var$levelToHeadingElementsMap[level];
    const headingStyles = $fc6840133e04adc0$var$$582583ec420fce57$var$levelToHeadingStylesMap[level];
    const additionalProps = inspectMode ? $fc6840133e04adc0$export$1784ac302bd8ebad(Object.keys(inspectMode)[0], inspectMode) : {};
    return (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)(HeadingElement, {
        id: id,
        css: [
            headingStyles,
            fontWeight && (0, $74Zh5.css)({
                fontWeight: fontWeight
            })
        ],
        ...additionalProps,
        style: {
            color: color
        },
        children: children
    });
};
const $fc6840133e04adc0$var$$582583ec420fce57$var$h0Styles = (0, $74Zh5.css)({
    fontFamily: '"Charlie Display", sans-serif',
    fontWeight: 700,
    fontSize: "48px",
    lineHeight: "52px",
    letterSpacing: "-0.144px",
    margin: 0,
    [(0, $0bc19dfefbafca8c$export$987d49ffe1b0900f).above.sm]: {
        fontSize: "56px",
        lineHeight: "64px",
        letterSpacing: "-0.168px"
    }
});
const $fc6840133e04adc0$var$$582583ec420fce57$var$h1Styles = (0, $74Zh5.css)({
    fontFamily: '"Charlie Display", sans-serif',
    fontWeight: 700,
    fontSize: "2.5rem",
    lineHeight: "3rem",
    margin: 0,
    letterSpacing: "-0.144px",
    [(0, $0bc19dfefbafca8c$export$987d49ffe1b0900f).above.sm]: {
        fontSize: "3rem",
        lineHeight: "3.5rem",
        letterSpacing: "-0.168px"
    }
});
const $fc6840133e04adc0$var$$582583ec420fce57$var$h2Styles = (0, $74Zh5.css)({
    fontFamily: '"Charlie Display", sans-serif',
    fontWeight: 700,
    fontSize: "2rem",
    lineHeight: "2.5rem",
    margin: 0,
    letterSpacing: "-0.096px",
    [(0, $0bc19dfefbafca8c$export$987d49ffe1b0900f).above.sm]: {
        fontSize: "2.5rem",
        lineHeight: "3rem",
        letterSpacing: "-0.12px"
    }
});
const $fc6840133e04adc0$var$$582583ec420fce57$var$h3Styles = (0, $74Zh5.css)({
    fontFamily: '"Charlie Display", sans-serif',
    fontWeight: 700,
    fontSize: "1.5rem",
    lineHeight: "2rem",
    margin: 0,
    letterSpacing: "normal",
    [(0, $0bc19dfefbafca8c$export$987d49ffe1b0900f).above.sm]: {
        fontSize: "2rem",
        lineHeight: "2.5rem",
        letterSpacing: "normal"
    }
});
const $fc6840133e04adc0$var$$582583ec420fce57$var$h4Styles = (0, $74Zh5.css)({
    fontFamily: '"Charlie Display", sans-serif',
    fontWeight: 600,
    fontSize: "1.25rem",
    lineHeight: "1.75rem",
    margin: 0,
    letterSpacing: "normal",
    [(0, $0bc19dfefbafca8c$export$987d49ffe1b0900f).above.sm]: {
        fontSize: "1.5rem",
        lineHeight: "2rem",
        letterSpacing: "normal"
    }
});
const $fc6840133e04adc0$var$$582583ec420fce57$var$h5Styles = (0, $74Zh5.css)({
    fontFamily: '"Charlie Display", sans-serif',
    fontWeight: 600,
    fontSize: "1rem",
    lineHeight: "1.5rem",
    margin: 0,
    letterSpacing: "normal",
    [(0, $0bc19dfefbafca8c$export$987d49ffe1b0900f).above.sm]: {
        fontSize: "1.25rem",
        lineHeight: "1.75rem",
        letterSpacing: "normal"
    }
});
const $fc6840133e04adc0$var$$582583ec420fce57$var$h6Styles = (0, $74Zh5.css)({
    fontFamily: '"Charlie Display", sans-serif',
    fontWeight: 600,
    fontSize: "0.875rem",
    lineHeight: "1.375rem",
    textTransform: "unset",
    margin: 0,
    letterSpacing: "normal",
    [(0, $0bc19dfefbafca8c$export$987d49ffe1b0900f).above.sm]: {
        fontSize: "1rem",
        lineHeight: "1.5rem",
        letterSpacing: "normal"
    }
});
const $fc6840133e04adc0$var$$582583ec420fce57$var$levelToHeadingElementsMap = {
    0: "h1",
    1: "h1",
    2: "h2",
    3: "h3",
    4: "h4",
    5: "h5",
    6: "h6"
};
const $fc6840133e04adc0$var$$582583ec420fce57$var$levelToHeadingStylesMap = {
    0: $fc6840133e04adc0$var$$582583ec420fce57$var$h0Styles,
    1: $fc6840133e04adc0$var$$582583ec420fce57$var$h1Styles,
    2: $fc6840133e04adc0$var$$582583ec420fce57$var$h2Styles,
    3: $fc6840133e04adc0$var$$582583ec420fce57$var$h3Styles,
    4: $fc6840133e04adc0$var$$582583ec420fce57$var$h4Styles,
    5: $fc6840133e04adc0$var$$582583ec420fce57$var$h5Styles,
    6: $fc6840133e04adc0$var$$582583ec420fce57$var$h6Styles
};
var $fc6840133e04adc0$var$$a02a6f7de308273b$exports = {};
$fc6840133e04adc0$var$$parcel$export($fc6840133e04adc0$var$$a02a6f7de308273b$exports, "icons", ()=>$fc6840133e04adc0$export$df03f54e09e486fa);
$fc6840133e04adc0$var$$parcel$export($fc6840133e04adc0$var$$a02a6f7de308273b$exports, "IconSize", ()=>$fc6840133e04adc0$export$ff775019b5b6e7df);
$fc6840133e04adc0$var$$parcel$export($fc6840133e04adc0$var$$a02a6f7de308273b$exports, "IconRotation", ()=>$fc6840133e04adc0$export$b3241a99d3e47e02);
$fc6840133e04adc0$var$$parcel$export($fc6840133e04adc0$var$$a02a6f7de308273b$exports, "Icon", ()=>$fc6840133e04adc0$export$f04a61298a47a40f);
// Core icons use 'color' prop and default to 'currentColor' for CSS inheritance
// Glyph icons use 'primaryColor' prop
const $fc6840133e04adc0$var$$a02a6f7de308273b$var$CORE_ICONS = [
    "arrow-up-right",
    "atlassian-intelligence",
    "calendar",
    "compass",
    "download-core",
    "link-external",
    "location-outline",
    "megaphone",
    "people-group",
    "person",
    "project",
    "sidebar-collapse",
    "sidebar-expand",
    "thumb-down",
    "thumb-up",
    "roadmaps-plan"
];
const $fc6840133e04adc0$export$df03f54e09e486fa = {
    filter: (props)=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($fd02e11c8aa5277c$exports))), {
            ...props
        }),
    "chevron-down": (props)=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($338f005fcf21bc2f$exports))), {
            ...props
        }),
    "chevron-up": (props)=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($133983fce38e52e1$exports))), {
            ...props
        }),
    "chevron-left": (props)=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($c6f2693d39d6404a$exports))), {
            ...props
        }),
    "chevron-right": (props)=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($0d48a3e8127c741d$exports))), {
            ...props
        }),
    "chevron-down-circle": (props)=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($c56e8f25e4743e9f$exports))), {
            ...props
        }),
    "arrow-up-circle": (props)=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($448a87733afcd5e7$exports))), {
            ...props
        }),
    "arrow-up": (props)=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($3aadf204787505be$exports))), {
            ...props
        }),
    "arrow-up-right": (props)=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($kdnK6))), {
            ...props
        }),
    "check-circle": (props)=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($82e5711ea901f746$exports))), {
            ...props
        }),
    "check-circle-outline": (props)=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($1bc5b5a4a06fb4d5$exports))), {
            ...props
        }),
    "arrow-right": (props)=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($ef54ef72c2befbb2$exports))), {
            ...props
        }),
    "arrow-left-circle": (props)=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($ab7ea44a501f28f2$exports))), {
            ...props
        }),
    "arrow-right-circle": (props)=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($765511c537d8b39f$exports))), {
            ...props
        }),
    "arrow-right-small": (props)=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("svg", {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M13.908 8L12.8283 9.2021L14.5785 11.1497H7.26318C6.84191 11.1497 6.5 11.5304 6.5 11.9994C6.5 12.4685 6.84191 12.8492 7.26318 12.8492H14.5785L12.8283 14.7979L13.908 16L17.5 11.9994L13.908 8Z",
                fill: props.primaryColor ?? "#1868DB"
            })
        }),
    "atlassian-intelligence": (props)=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($61061e9506c91f48$exports))), {
            ...props
        }),
    "atlassian-logo": (props)=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($ea6bca7cecbd908e$exports))), {
            ...props
        }),
    cross: (props)=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($3ba3a1ce40cf237e$exports))), {
            ...props
        }),
    "dropdown-cross": (props)=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($678fbedc7d92a99f$exports))), {
            ...props
        }),
    "menu-icon": (props)=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($0da7a47246bb0696$exports))), {
            ...props
        }),
    "emoji-frequent": (props)=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($868e088250f4aa11$exports))), {
            ...props
        }),
    "star-filled": (props)=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($9d80ce0dbce822c2$exports))), {
            ...props
        }),
    star: (props)=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($770578eecee63138$exports))), {
            ...props
        }),
    "bitbucket-builds": (props)=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($2f24676d61ca54c3$exports))), {
            ...props
        }),
    "editor-media-wrap-right": (props)=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($bcbb92898bcdb6db$exports))), {
            ...props
        }),
    "editor-table": (props)=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($972700bc3f94498f$exports))), {
            ...props
        }),
    "editor-open": (props)=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($4ee3e0b98b22e4b3$exports))), {
            ...props
        }),
    calendar: (props)=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($5a91d22bbe4f675e$exports))), {
            ...props
        }),
    copy: (props)=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($11c02ff49b8a774f$exports))), {
            ...props
        }),
    warning: (props)=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($8921404bff45adb3$exports))), {
            ...props
        }),
    image: (props)=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($d83ce7bcb052f208$exports))), {
            ...props
        }),
    download: (props)=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($62eae3fe425ce462$exports))), {
            ...props
        }),
    "download-core": (props)=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($6KNbq))), {
            ...props
        }),
    "zoom-in": (props)=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($045666e2abf7885f$exports))), {
            ...props
        }),
    "zoom-out": (props)=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($f513021e3e22d820$exports))), {
            ...props
        }),
    search: (props)=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($fefca24f90dbffe4$exports))), {
            ...props
        }),
    overview: (props)=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($d83e26c8865ed9f1$exports))), {
            ...props
        }),
    add: (props)=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($b5961c39816b4422$exports))), {
            ...props
        }),
    refresh: (props)=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($e149e66b51ba1e58$exports))), {
            ...props
        }),
    "add-circle": (props)=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($80468d1e7c2b9ea5$exports))), {
            ...props
        }),
    edit: (props)=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($90cabb7428efe8f9$exports))), {
            ...props
        }),
    "edit-filled": (props)=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($20ca2d7ff5212edb$exports))), {
            ...props
        }),
    error: (props)=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($35a60a094f8bb98e$exports))), {
            ...props
        }),
    settings: (props)=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($f89ba06409979f74$exports))), {
            ...props
        }),
    info: (props)=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($c7379cc75f389fb5$exports))), {
            ...props
        }),
    question: (props)=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($74190023c372c031$exports))), {
            ...props
        }),
    check: (props)=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($a422246a5e1d8639$exports))), {
            ...props
        }),
    "check-circle-filled": (props)=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($82e5711ea901f746$exports))), {
            ...props
        }),
    "emoji-symbols": (props)=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($278856bd9f09e08f$exports))), {
            ...props
        }),
    compass: (props)=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($7b258af4b8d0f304$exports))), {
            ...props
        }),
    megaphone: (props)=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($e51c71b0df1b60e6$exports))), {
            ...props
        }),
    location: (props)=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($69c44cfe0477cfd7$exports))), {
            ...props
        }),
    "location-outline": (props)=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($lD59F))), {
            ...props
        }),
    "chevron-left-large": (props)=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($3ad42b18b75fd487$exports))), {
            ...props
        }),
    "chevron-right-large": (props)=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($3ad42b18b75fd487$exports))), {
            ...props
        }),
    "hipchat-chevron-up": (props)=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($d87741190ae2c1bc$exports))), {
            ...props
        }),
    "hipchat-chevron-down": (props)=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($4dc2a9ab647f1d34$exports))), {
            ...props
        }),
    export: (props)=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($b729d471c2df3879$exports))), {
            ...props
        }),
    link: (props)=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($be2faee5e2e9c87a$exports))), {
            ...props
        }),
    "roadmaps-plan": (props)=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($d8659b89a0a6aa64$exports))), {
            ...props
        }),
    share: (props)=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($b0ee2c5a0f759aa1$exports))), {
            ...props
        }),
    "sidebar-collapse": (props)=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($6cb2217010acc9b5$exports))), {
            ...props
        }),
    "sidebar-expand": (props)=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($2c12de6c07289b42$exports))), {
            ...props
        }),
    "people-group": (props)=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($692f0acff770933a$exports))), {
            ...props
        }),
    project: (props)=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($8bdd7167f43518f0$exports))), {
            ...props
        }),
    "link-external": (props)=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($24667df966305327$exports))), {
            ...props
        }),
    person: (props)=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($dca91df78b4a6141$exports))), {
            ...props
        }),
    "bookmark-narrow": (props)=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("svg", {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("path", {
                d: "M16.5745 5.49575C16.5745 5.13673 16.2832 4.84567 15.9242 4.84554H8.07595C7.71685 4.84554 7.42574 5.13665 7.42574 5.49575V18.2473L12.0001 15.0318L12.5601 15.4268L16.5745 18.2473V5.49575ZM18.5251 20.0633C18.5248 20.8281 17.717 21.2956 17.0659 20.965L16.9377 20.8875L11.9988 17.4155L7.06253 20.8875C6.39483 21.3569 5.47538 20.8794 5.4751 20.0633V5.49575C5.4751 4.05934 6.63954 2.8949 8.07595 2.8949H15.9242C17.3605 2.89503 18.5251 4.05942 18.5251 5.49575V20.0633Z",
                fill: props.primaryColor ?? "white"
            })
        }),
    "bookmark-narrow-filled": (props)=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("svg", {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("path", {
                d: "M18.525 20.0632C18.5247 20.828 17.7168 21.2955 17.0658 20.9649L16.9375 20.8874L11.9987 17.4154L7.06241 20.8874C6.39471 21.3568 5.47525 20.8792 5.47498 20.0632V5.49563C5.47498 4.05922 6.63942 2.89478 8.07583 2.89478H15.9241C17.3604 2.8949 18.525 4.0593 18.525 5.49563V20.0632Z",
                fill: props.primaryColor ?? "white"
            })
        }),
    bookmark: ()=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("svg", {
            "aria-label": "bookmark",
            "data-testid": "bookmark",
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("g", {
                id: "Icons/bookmark_24px",
                children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("path", {
                    id: "bookmark",
                    d: "M12 18L7.8 19.8C7.13333 20.0833 6.5 20.0292 5.9 19.6375C5.3 19.2458 5 18.6917 5 17.975V5C5 4.45 5.19583 3.97917 5.5875 3.5875C5.97917 3.19583 6.45 3 7 3H17C17.55 3 18.0208 3.19583 18.4125 3.5875C18.8042 3.97917 19 4.45 19 5V17.975C19 18.6917 18.7 19.2458 18.1 19.6375C17.5 20.0292 16.8667 20.0833 16.2 19.8L12 18Z",
                    fill: "transparent",
                    stroke: "#626F86",
                    strokeWidth: "2"
                })
            })
        }),
    "bookmark-filled": ()=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("svg", {
            "aria-label": "bookmark filled",
            "data-testid": "bookmark-filled",
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("g", {
                id: "Icons/bookmark_24px",
                children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("path", {
                    id: "bookmark",
                    d: "M12 18L7.8 19.8C7.13333 20.0833 6.5 20.0292 5.9 19.6375C5.3 19.2458 5 18.6917 5 17.975V5C5 4.45 5.19583 3.97917 5.5875 3.5875C5.97917 3.19583 6.45 3 7 3H17C17.55 3 18.0208 3.19583 18.4125 3.5875C18.8042 3.97917 19 4.45 19 5V17.975C19 18.6917 18.7 19.2458 18.1 19.6375C17.5 20.0292 16.8667 20.0833 16.2 19.8L12 18Z",
                    fill: "#626F86",
                    stroke: "#626F86",
                    strokeWidth: "2"
                })
            })
        }),
    "gap-completed": ()=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("svg", {
            "data-testid": "gap-completed",
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("g", {
                id: "Icon / <CheckCircleIcon>",
                children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("path", {
                    id: "gap",
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12ZM9.3824 11.0689C9.50441 11.1213 9.61475 11.1975 9.707 11.293L11 12.586L14.293 9.29302C14.3852 9.19751 14.4956 9.12133 14.6176 9.06892C14.7396 9.01651 14.8708 8.98892 15.0036 8.98777C15.1364 8.98662 15.2681 9.01192 15.391 9.0622C15.5138 9.11248 15.6255 9.18673 15.7194 9.28063C15.8133 9.37452 15.8875 9.48617 15.9378 9.60907C15.9881 9.73196 16.0134 9.86364 16.0122 9.99642C16.0111 10.1292 15.9835 10.2604 15.9311 10.3824C15.8787 10.5044 15.8025 10.6148 15.707 10.707L11.707 14.707C11.5195 14.8945 11.2652 14.9998 11 14.9998C10.7348 14.9998 10.4805 14.8945 10.293 14.707L8.293 12.707C8.19749 12.6148 8.1213 12.5044 8.0689 12.3824C8.01649 12.2604 7.9889 12.1292 7.98775 11.9964C7.98659 11.8636 8.0119 11.732 8.06218 11.6091C8.11246 11.4862 8.18671 11.3745 8.2806 11.2806C8.3745 11.1867 8.48615 11.1125 8.60904 11.0622C8.73194 11.0119 8.86362 10.9866 8.9964 10.9878C9.12918 10.9889 9.2604 11.0165 9.3824 11.0689Z",
                    fill: "#22A06B"
                })
            })
        }),
    "thumb-down": (props)=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($6fd63047ac2df026$exports))), {
            ...props
        }),
    "thumb-up": (props)=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($e44667cea1c125ae$exports))), {
            ...props
        }),
    "dot-default": ()=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: "8",
            height: "8",
            viewBox: "0 0 8 8",
            fill: "none",
            children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("rect", {
                x: "0.5",
                y: "0.5",
                width: "7",
                height: "7",
                rx: "3.5",
                stroke: "#091E42",
                strokeOpacity: "0.14"
            })
        }),
    "dot-selected": ()=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: "8",
            height: "8",
            viewBox: "0 0 8 8",
            fill: "none",
            children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("rect", {
                x: "0.5",
                y: "0.5",
                width: "7",
                height: "7",
                rx: "3.5",
                stroke: "#0C66E4"
            })
        }),
    "dot-completed": ()=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: "8",
            height: "8",
            viewBox: "0 0 8 8",
            fill: "none",
            children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("rect", {
                width: "8",
                height: "8",
                rx: "4",
                fill: "#22A06B"
            })
        }),
    "mosaic_map-pin": (props)=>(0, $6bec4f26b2cb3094$export$25062201e9e25d76)("svg", {
            width: "32",
            height: "32",
            viewBox: "0 0 32 32",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: [
                (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M15.8088 12.9426L19.8045 18.7363L23.8003 12.9426C23.8715 12.8394 23.938 12.735 24 12.6296C25.8712 9.44592 23.5904 5.33325 19.8045 5.33325C15.8931 5.33325 13.5882 9.72274 15.8088 12.9426ZM19.9234 12.494C21.1444 12.4321 22.1153 11.4225 22.1153 10.1861C22.1153 8.90983 21.0807 7.87521 19.8045 7.87521C18.5909 7.87521 17.5958 8.81071 17.501 9.99992C17.4961 10.0613 17.4938 10.1234 17.4938 10.1861C17.4938 11.4623 18.5284 12.4969 19.8046 12.497M19.8046 12.497C19.8444 12.497 19.8841 12.496 19.9234 12.494L19.8046 12.497Z",
                    fill: props.primaryColor ?? "#172b4d"
                }),
                (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("path", {
                    d: "M21.3333 22.6666V20.0426L24 16.1759V25.3333H8V9.99992H12.9424C12.9149 10.8857 13.0615 11.7906 13.4072 12.6666H10.6667V22.6666H21.3333Z",
                    fill: props.primaryColor ?? "#172b4d"
                })
            ]
        }),
    mosaic_compass: (props)=>(0, $6bec4f26b2cb3094$export$25062201e9e25d76)("svg", {
            width: "32",
            height: "32",
            viewBox: "0 0 32 32",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: [
                (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("mask", {
                    id: "mask0_64467_13333",
                    style: {
                        maskType: "luminance"
                    },
                    maskUnits: "userSpaceOnUse",
                    x: "0",
                    y: "0",
                    width: "32",
                    height: "32",
                    children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("path", {
                        d: "M32 0H0V32H32V0Z",
                        fill: "white"
                    })
                }),
                (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("g", {
                    mask: "url(#mask0_64467_13333)",
                    children: [
                        (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("path", {
                            d: "M14.6665 16.0001C14.6665 15.2667 15.2665 14.6667 15.9998 14.6667C16.7332 14.6667 17.3332 15.2667 17.3332 16.0001C17.3332 16.7334 16.7332 17.3334 15.9998 17.3334C15.2665 17.3334 14.6665 16.7334 14.6665 16.0001Z",
                            fill: props.primaryColor || "#172b4d"
                        }),
                        (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("path", {
                            fillRule: "evenodd",
                            clipRule: "evenodd",
                            d: "M16.0002 26.6666C21.8935 26.6666 26.6668 21.8933 26.6668 15.9999C26.6668 10.1066 21.8935 5.33325 16.0002 5.33325C10.1068 5.33325 5.3335 10.1066 5.3335 15.9999C5.3335 21.8933 10.1068 26.6666 16.0002 26.6666ZM21.3335 10.6666L13.3335 13.3333L10.6668 21.3333L18.6668 18.6666L21.3335 10.6666Z",
                            fill: props.primaryColor || "#172b4d"
                        })
                    ]
                })
            ]
        }),
    mosaic_megaphone: (props)=>(0, $6bec4f26b2cb3094$export$25062201e9e25d76)("svg", {
            width: "32",
            height: "32",
            viewBox: "0 0 32 32",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: [
                (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("mask", {
                    id: "mask0_64493_847",
                    style: {
                        maskType: "luminance"
                    },
                    maskUnits: "userSpaceOnUse",
                    x: "0",
                    y: "0",
                    width: "32",
                    height: "32",
                    children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("path", {
                        d: "M32 0H0V32H32V0Z",
                        fill: "white"
                    })
                }),
                (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("g", {
                    mask: "url(#mask0_64493_847)",
                    children: [
                        (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("path", {
                            d: "M26 5.33325L16 9.33325V19.9999L26 23.9999V5.33325Z",
                            fill: props.primaryColor || "#172b4d"
                        }),
                        (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("path", {
                            d: "M13.3335 10H5.3335V19.3333H9.3335V25.3333H13.3335V10Z",
                            fill: props.primaryColor || "#172b4d"
                        })
                    ]
                })
            ]
        }),
    "more-vertical": (props)=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($53b0a183707aafc0$exports))), {
            ...props
        }),
    "editor-panel": (props)=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($0879f860d82e1dc1$exports))), {
            ...props
        }),
    one: ()=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("span", {
            css: $fc6840133e04adc0$var$$a02a6f7de308273b$var$iconNumberStyles,
            "data-testid": "one",
            children: "1"
        }),
    two: ()=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("span", {
            css: $fc6840133e04adc0$var$$a02a6f7de308273b$var$iconNumberStyles,
            "data-testid": "two",
            children: "2"
        }),
    three: ()=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("span", {
            css: $fc6840133e04adc0$var$$a02a6f7de308273b$var$iconNumberStyles,
            "data-testid": "three",
            children: "3"
        }),
    four: ()=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("span", {
            css: $fc6840133e04adc0$var$$a02a6f7de308273b$var$iconNumberStyles,
            "data-testid": "four",
            children: "4"
        }),
    five: ()=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("span", {
            css: $fc6840133e04adc0$var$$a02a6f7de308273b$var$iconNumberStyles,
            "data-testid": "five",
            children: "5"
        }),
    six: ()=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("span", {
            css: $fc6840133e04adc0$var$$a02a6f7de308273b$var$iconNumberStyles,
            "data-testid": "six",
            children: "6"
        }),
    seven: ()=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("span", {
            css: $fc6840133e04adc0$var$$a02a6f7de308273b$var$iconNumberStyles,
            "data-testid": "seven",
            children: "7"
        }),
    eight: ()=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("span", {
            css: $fc6840133e04adc0$var$$a02a6f7de308273b$var$iconNumberStyles,
            "data-testid": "eight",
            children: "8"
        }),
    nine: ()=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("span", {
            css: $fc6840133e04adc0$var$$a02a6f7de308273b$var$iconNumberStyles,
            "data-testid": "nine",
            children: "9"
        }),
    zero: ()=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("span", {
            css: $fc6840133e04adc0$var$$a02a6f7de308273b$var$iconNumberStyles,
            "data-testid": "zero",
            children: "0"
        })
};
let $fc6840133e04adc0$export$ff775019b5b6e7df;
(function(IconSize) {
    IconSize["SMALL"] = "small";
    IconSize["MEDIUM"] = "medium";
    IconSize["LARGE"] = "large";
    IconSize["XLARGE"] = "xlarge";
})($fc6840133e04adc0$export$ff775019b5b6e7df || ($fc6840133e04adc0$export$ff775019b5b6e7df = {}));
let $fc6840133e04adc0$export$b3241a99d3e47e02;
(function(IconRotation) {
    IconRotation["ZERO"] = "0deg";
    IconRotation["NINETY"] = "90deg";
    IconRotation["ONE_EIGHTY"] = "180deg";
    IconRotation["TWO_SEVENTY"] = "270deg";
})($fc6840133e04adc0$export$b3241a99d3e47e02 || ($fc6840133e04adc0$export$b3241a99d3e47e02 = {}));
const $fc6840133e04adc0$export$f04a61298a47a40f = ({ type: type, size: size = $fc6840133e04adc0$export$ff775019b5b6e7df.MEDIUM, rotation: rotation = $fc6840133e04adc0$export$b3241a99d3e47e02.ZERO, alt: alt = "", color: color, hoverColor: hoverColor, activeColor: activeColor })=>{
    const icon = (0, $5FkrB.useMemo)(()=>$fc6840133e04adc0$export$df03f54e09e486fa[type], [
        type
    ]);
    const isCoreIcon = $fc6840133e04adc0$var$$a02a6f7de308273b$var$CORE_ICONS.includes(type);
    // Core icons use 'color' prop and default to 'currentColor' for CSS inheritance
    // Glyph icons use 'primaryColor' prop
    const iconProps = isCoreIcon ? {
        size: size,
        label: alt,
        color: color || "currentColor",
        testId: type
    } : {
        size: size,
        label: alt,
        primaryColor: color || undefined,
        testId: type
    };
    return (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("span", {
        css: [
            $fc6840133e04adc0$var$$a02a6f7de308273b$var$baseStyles,
            $fc6840133e04adc0$var$$a02a6f7de308273b$var$rotationStyles[rotation],
            hoverColor && {
                "&:hover": {
                    color: hoverColor
                }
            },
            activeColor && {
                "&:active": {
                    color: activeColor
                }
            }
        ],
        "data-testid": `icon-${type}`,
        children: icon ? icon(iconProps) : null
    });
};
const $fc6840133e04adc0$var$$a02a6f7de308273b$var$baseStyles = (0, $74Zh5.css)({
    width: "fit-content",
    height: "fit-content",
    display: "inline-flex"
});
const $fc6840133e04adc0$var$$a02a6f7de308273b$var$rotationStyles = {
    "0deg": (0, $74Zh5.css)({
        transform: "rotate(0deg)"
    }),
    "90deg": (0, $74Zh5.css)({
        transform: "rotate(90deg)"
    }),
    "180deg": (0, $74Zh5.css)({
        transform: "rotate(180deg)"
    }),
    "270deg": (0, $74Zh5.css)({
        transform: "rotate(270deg)"
    })
};
const $fc6840133e04adc0$var$$a02a6f7de308273b$var$iconNumberStyles = (0, $74Zh5.css)({
    fontSize: "16px"
});
var $fc6840133e04adc0$var$$1298c86a7e6a9fc7$exports = {};
$fc6840133e04adc0$var$$parcel$export($fc6840133e04adc0$var$$1298c86a7e6a9fc7$exports, "Image", ()=>$fc6840133e04adc0$export$3e431a229df88919);
/**
 * It takes a url and returns the last part of the url which is the name of the image.
 * @param {string} url - The URL of the image you want to get the name.
 * @returns name of the image file.
 */ const $fc6840133e04adc0$var$$1298c86a7e6a9fc7$var$getImageName = (url)=>{
    const urlSplitted = url.split("/");
    return urlSplitted[urlSplitted.length - 1];
};
/**
 * Convert bytes into KB or MB
 * @param {number} [bytes] - The number of bytes to format.
 * @returns a string with the KB o MB converted
 */ const $fc6840133e04adc0$var$$1298c86a7e6a9fc7$var$formatBytes = (bytes)=>{
    const marker = 1024;
    const decimal = 0;
    const kiloBytes = marker;
    const megaBytes = marker * marker;
    return bytes ? bytes < kiloBytes ? bytes + " Bytes" : bytes < megaBytes ? (bytes / kiloBytes).toFixed(decimal) + " KB" : (bytes / megaBytes).toFixed(decimal) + " MB" : undefined;
};
/**
 * Download image
 * @param {string} src - The URL of the image you want to download.
 * @param {string} name - The name of the file you want to save the image as.
 */ const $fc6840133e04adc0$var$$1298c86a7e6a9fc7$var$downloadImage = async (src, name)=>{
    const image = await fetch(src);
    const imageBlog = await image.blob();
    const imageURL = URL.createObjectURL(imageBlog);
    const link = document.createElement("a");
    link.href = imageURL;
    link.download = name;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
};
const $fc6840133e04adc0$export$3e431a229df88919 = ({ inspectMode: inspectMode, src: src, alt: alt, width: width, height: height, caption: caption = "", size: size, center: center = true, preventModal: preventModal = false, onClick: onClick, ...props })=>{
    const rightToolsRef = (0, $5FkrB.useRef)(null);
    const downloadButtonRef = (0, $5FkrB.useRef)(null);
    const modalImgRef = (0, $5FkrB.useRef)(null);
    const originalImgRef = (0, $5FkrB.useRef)(null);
    const [showModal, setShowModal] = (0, $5FkrB.useState)(false);
    const [showControls, setShowControls] = (0, $5FkrB.useState)(false);
    const [totalZoom, setTotalZoom] = (0, $5FkrB.useState)(100);
    const [initialWidthModalImage, setInitialWidthModalImage] = (0, $5FkrB.useState)(0);
    const [initialHeightImage, setInitialHeightImage] = (0, $5FkrB.useState)(0);
    const [initialWidthOriginalImage, setInitialWidthOriginalImage] = (0, $5FkrB.useState)(0);
    (0, $5FkrB.useEffect)(()=>{
        if (showModal) {
            setShowControls(true);
            setTotalZoom(100);
            if (rightToolsRef.current) rightToolsRef.current.focus();
        }
    }, [
        showModal
    ]);
    (0, $5FkrB.useEffect)(()=>{
        let timer = null;
        if (showControls) timer = setTimeout(()=>setShowControls(false), 5000);
        return ()=>clearTimeout(timer ?? undefined);
    }, [
        showControls
    ]);
    (0, $5FkrB.useEffect)(()=>{
        const close = (e)=>{
            if (e.key === "Escape") setShowModal(false);
        };
        window.addEventListener("keydown", close);
        return ()=>window.removeEventListener("keydown", close);
    }, []);
    const onHoverModal = ()=>{
        setShowControls(true);
    };
    const onZoomOut = ()=>{
        if (totalZoom > 20) {
            setTotalZoom(totalZoom - 20);
            if (modalImgRef.current) {
                const widthImageModal = Math.round(modalImgRef.current?.offsetWidth - initialWidthModalImage * 0.2);
                const heightImageModal = Math.round(modalImgRef.current?.offsetHeight - initialHeightImage * 0.2);
                modalImgRef.current.style.width = `${widthImageModal}px`;
                modalImgRef.current.style.height = `${heightImageModal}px`;
            }
        }
    };
    const onZoomIn = ()=>{
        if (totalZoom < 320) {
            setTotalZoom(totalZoom + 20);
            if (modalImgRef.current) {
                const widthImageModal = Math.round(modalImgRef.current?.offsetWidth + initialWidthModalImage * 0.2);
                const heightImageModal = Math.round(modalImgRef.current?.offsetHeight + initialHeightImage * 0.2);
                modalImgRef.current.style.width = `${widthImageModal}px`;
                modalImgRef.current.style.height = `${heightImageModal}px`;
            }
        }
    };
    const onBlur = ()=>{
        if (rightToolsRef.current && downloadButtonRef.current) {
            rightToolsRef.current.setAttribute("tabIndex", "-1");
            downloadButtonRef.current.focus();
        }
    };
    const onClickImage = (0, $5FkrB.useCallback)(()=>{
        if (onClick) onClick();
        if (!preventModal) setShowModal(true);
    }, [
        onClick,
        preventModal
    ]);
    const onLoadImageModal = ()=>{
        setInitialWidthModalImage(modalImgRef.current?.offsetWidth ?? 0);
        setInitialHeightImage(modalImgRef.current?.offsetHeight ?? 0);
    };
    (0, $5FkrB.useEffect)(()=>{
        if (originalImgRef.current?.offsetWidth) setInitialWidthOriginalImage(originalImgRef.current.offsetWidth);
    }, [
        originalImgRef.current?.offsetWidth
    ]);
    const handleKeyDown = (0, $5FkrB.useCallback)((e)=>{
        if (e.code === "Space") onClickImage();
    }, [
        onClickImage
    ]);
    return (0, $6bec4f26b2cb3094$export$25062201e9e25d76)((0, $6bec4f26b2cb3094$export$ffb0004e005737fa), {
        children: [
            showModal && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                "data-testid": "modal",
                id: "myModal",
                css: $fc6840133e04adc0$var$$1298c86a7e6a9fc7$var$modalStyles,
                onMouseMove: onHoverModal,
                children: (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                    css: $fc6840133e04adc0$var$$1298c86a7e6a9fc7$var$modalContentStyles,
                    children: [
                        (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                            css: [
                                $fc6840133e04adc0$var$$1298c86a7e6a9fc7$var$modalControlsStyles,
                                showControls && (0, $74Zh5.css)({
                                    opacity: 1
                                }),
                                !showControls && (0, $74Zh5.css)({
                                    opacity: 0
                                })
                            ],
                            children: (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                                css: $fc6840133e04adc0$var$$1298c86a7e6a9fc7$var$containerStyles,
                                children: [
                                    (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                                        css: $fc6840133e04adc0$var$$1298c86a7e6a9fc7$var$textContainerStyles,
                                        children: [
                                            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                                                css: $fc6840133e04adc0$var$$1298c86a7e6a9fc7$var$iconContainerStyles,
                                                children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$export$f04a61298a47a40f, {
                                                    type: "image",
                                                    size: "large",
                                                    color: (0, $d568d81ef5c2bf7a$export$c6930421db9fa514)
                                                })
                                            }),
                                            (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                                                css: $fc6840133e04adc0$var$$1298c86a7e6a9fc7$var$imageContainerStyles,
                                                children: [
                                                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("p", {
                                                        css: $fc6840133e04adc0$var$$1298c86a7e6a9fc7$var$badgeContentStyles,
                                                        children: $fc6840133e04adc0$var$$1298c86a7e6a9fc7$var$getImageName(src)
                                                    }),
                                                    (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("p", {
                                                        css: $fc6840133e04adc0$var$$1298c86a7e6a9fc7$var$badgeContentStyles,
                                                        children: [
                                                            "image \xb7 ",
                                                            $fc6840133e04adc0$var$$1298c86a7e6a9fc7$var$formatBytes(size)
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                                        className: "right",
                                        ref: rightToolsRef,
                                        children: [
                                            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("button", {
                                                "data-testid": "download-button",
                                                ref: downloadButtonRef,
                                                tabIndex: 0,
                                                css: (0, $74Zh5.css)({
                                                    marginRight: "1rem",
                                                    border: "none",
                                                    cursor: "pointer"
                                                }),
                                                "aria-label": "download image",
                                                onClick: ()=>{
                                                    $fc6840133e04adc0$var$$1298c86a7e6a9fc7$var$downloadImage(src, $fc6840133e04adc0$var$$1298c86a7e6a9fc7$var$getImageName(src));
                                                },
                                                children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$export$f04a61298a47a40f, {
                                                    type: "download",
                                                    size: "medium"
                                                })
                                            }),
                                            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("button", {
                                                css: {
                                                    border: "none",
                                                    cursor: "pointer"
                                                },
                                                tabIndex: 0,
                                                "data-testid": "close-modal-button",
                                                "aria-label": "close modal",
                                                onClick: ()=>{
                                                    setShowModal(false);
                                                },
                                                children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$export$f04a61298a47a40f, {
                                                    type: "cross",
                                                    size: "medium"
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        }),
                        (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $f9ff4343296b19bf$export$2e2bcd8739ae039), {
                            css: $fc6840133e04adc0$var$$1298c86a7e6a9fc7$var$scrollContainerStyles,
                            children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("img", {
                                src: src,
                                alt: alt,
                                ref: modalImgRef,
                                onLoad: onLoadImageModal,
                                css: (0, $74Zh5.css)({
                                    margin: "auto"
                                })
                            })
                        }),
                        (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                            css: [
                                $fc6840133e04adc0$var$$1298c86a7e6a9fc7$var$modalToolsStyles,
                                (0, $74Zh5.css)({
                                    opacity: showControls ? 1 : 0
                                })
                            ],
                            children: (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                                css: $fc6840133e04adc0$var$$1298c86a7e6a9fc7$var$buttonContainerStyles,
                                children: [
                                    (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                                        children: [
                                            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("button", {
                                                "data-testid": "zoom-out-button",
                                                onClick: ()=>onZoomOut(),
                                                css: (0, $74Zh5.css)({
                                                    marginRight: "0.625rem",
                                                    border: "none",
                                                    cursor: "pointer"
                                                }),
                                                "aria-label": "zoom out",
                                                tabIndex: 0,
                                                children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$export$f04a61298a47a40f, {
                                                    type: "zoom-out"
                                                })
                                            }),
                                            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("button", {
                                                css: {
                                                    border: "none",
                                                    cursor: "pointer"
                                                },
                                                "data-testid": "zoom-in-button",
                                                onClick: ()=>onZoomIn(),
                                                onBlur: onBlur,
                                                "aria-label": "zoom in",
                                                tabIndex: 0,
                                                children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$export$f04a61298a47a40f, {
                                                    type: "zoom-in"
                                                })
                                            })
                                        ]
                                    }),
                                    (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                                        css: (0, $74Zh5.css)({
                                            color: (0, $d568d81ef5c2bf7a$export$5368d76ae4fbbda7)
                                        }),
                                        children: [
                                            totalZoom,
                                            "%"
                                        ]
                                    })
                                ]
                            })
                        })
                    ]
                })
            }),
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                ...$fc6840133e04adc0$export$1784ac302bd8ebad("image", inspectMode),
                css: (0, $74Zh5.css)({
                    width: "100%",
                    overflow: "hidden"
                }),
                "data-testid": "image",
                onClick: onClickImage,
                children: (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("figure", {
                    css: $fc6840133e04adc0$var$$1298c86a7e6a9fc7$var$figureStyles,
                    children: [
                        (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("img", {
                            tabIndex: 0,
                            width: width,
                            height: height,
                            ref: originalImgRef,
                            alt: alt,
                            src: src,
                            onKeyDown: handleKeyDown,
                            css: [
                                (0, $74Zh5.css)({
                                    transform: "scale(1)",
                                    objectFit: "contain",
                                    height: "auto"
                                }),
                                center && (0, $74Zh5.css)({
                                    margin: "auto"
                                }),
                                !preventModal && (0, $74Zh5.css)({
                                    cursor: "pointer"
                                }),
                                !width && (0, $74Zh5.css)({
                                    width: "100%"
                                })
                            ],
                            ...props
                        }),
                        !!initialWidthOriginalImage && !!caption && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("figcaption", {
                            style: {
                                width: `${initialWidthOriginalImage}px`,
                                maxWidth: "100vw"
                            },
                            css: $fc6840133e04adc0$var$$1298c86a7e6a9fc7$var$captionContainerStyles,
                            children: caption
                        })
                    ]
                })
            })
        ]
    });
};
const $fc6840133e04adc0$var$$1298c86a7e6a9fc7$var$modalStyles = (0, $74Zh5.css)({
    position: "fixed",
    zIndex: 100000,
    left: 0,
    top: 0,
    width: "100%",
    height: "100%",
    overflow: "auto",
    backgroundColor: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.background.input"),
    "& button": {
        background: "transparent",
        borderRadius: "3px",
        verticalAlign: "middle",
        display: "inline-flex",
        padding: "0.125rem !important",
        height: "fit-content",
        "&:hover": {
            backgroundColor: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.background.accent.gray.bolder.hovered"),
            borderRadius: "3px"
        }
    }
});
const $fc6840133e04adc0$var$$1298c86a7e6a9fc7$var$modalContentStyles = (0, $74Zh5.css)({
    justifyContent: "center",
    alignItems: "center",
    display: "flex",
    height: "100%",
    flexDirection: "column",
    padding: 0,
    position: "relative",
    overflow: "hidden",
    "& img": {
        maxWidth: "100%",
        maxHeight: "100%",
        objectFit: "contain",
        width: "auto",
        height: "auto"
    }
});
const $fc6840133e04adc0$var$$1298c86a7e6a9fc7$var$modalControlsStyles = (0, $74Zh5.css)({
    backgroundImage: "linear-gradient(rgb(14, 22, 36), rgba(14, 22, 36, 0))",
    position: "fixed",
    top: 0,
    left: 0,
    width: "100%",
    height: "6.125rem",
    zIndex: 1,
    fontWeight: 500,
    padding: "1.5rem",
    transition: "opacity 0.3s ease 0s",
    "& .right:focus": {
        outline: "none"
    },
    "& .right svg": {
        color: `${(0, $d568d81ef5c2bf7a$export$5368d76ae4fbbda7)} !important`
    }
});
const $fc6840133e04adc0$var$$1298c86a7e6a9fc7$var$containerStyles = (0, $74Zh5.css)({
    display: "flex",
    justifyContent: "space-between"
});
const $fc6840133e04adc0$var$$1298c86a7e6a9fc7$var$textContainerStyles = (0, $74Zh5.css)({
    display: "flex",
    color: (0, $d568d81ef5c2bf7a$export$5368d76ae4fbbda7)
});
const $fc6840133e04adc0$var$$1298c86a7e6a9fc7$var$iconContainerStyles = (0, $74Zh5.css)({
    marginRight: "0.75rem",
    display: "flex",
    alignItems: "center"
});
const $fc6840133e04adc0$var$$1298c86a7e6a9fc7$var$imageContainerStyles = (0, $74Zh5.css)({
    display: "flex",
    flexDirection: "column",
    color: "filter",
    fontSize: ".875rem",
    lineHeight: "1.25rem"
});
const $fc6840133e04adc0$var$$1298c86a7e6a9fc7$var$badgeContentStyles = (0, $74Zh5.css)({
    margin: 0
});
const $fc6840133e04adc0$var$$1298c86a7e6a9fc7$var$scrollContainerStyles = (0, $74Zh5.css)({
    height: "100%",
    width: "100%",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    overflow: "auto",
    WebkitOverflowScrolling: "touch"
});
const $fc6840133e04adc0$var$$1298c86a7e6a9fc7$var$modalToolsStyles = (0, $74Zh5.css)({
    display: "flex",
    alignItems: "flex-end",
    justifyContent: "flex-end",
    position: "fixed",
    bottom: 0,
    width: "100%",
    height: "6.125rem",
    padding: "0.625rem",
    backgroundImage: "linear-gradient(rgba(14, 22, 36, 0), rgb(14, 22, 36))",
    "& svg": {
        color: `${(0, $d568d81ef5c2bf7a$export$5368d76ae4fbbda7)} !important`
    }
});
const $fc6840133e04adc0$var$$1298c86a7e6a9fc7$var$buttonContainerStyles = (0, $74Zh5.css)({
    width: "50%",
    display: "flex",
    justifyContent: "space-between"
});
const $fc6840133e04adc0$var$$1298c86a7e6a9fc7$var$figureStyles = (0, $74Zh5.css)({
    display: "flex",
    flexDirection: "column",
    margin: 0,
    textAlign: "center"
});
const $fc6840133e04adc0$var$$1298c86a7e6a9fc7$var$captionContainerStyles = (0, $74Zh5.css)({
    margin: "16px auto",
    textAlign: "center",
    fontStyle: "italic",
    fontSize: ".875rem",
    lineHeight: "1.25rem",
    color: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.text.subtlest")
});
var $fc6840133e04adc0$var$$c0c01354ab9765ae$exports = {};
$fc6840133e04adc0$var$$parcel$export($fc6840133e04adc0$var$$c0c01354ab9765ae$exports, "InvertedIconButton", ()=>$fc6840133e04adc0$export$dd09d7da2da4d16f);
const $fc6840133e04adc0$export$dd09d7da2da4d16f = ({ icon: icon, onClick: onClick, ariaLabel: ariaLabel, disabled: disabled = false, selected: selected = false, tooltip: tooltip, testId: testId = "inverted-icon-button" })=>{
    const button = (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("button", {
        css: [
            $fc6840133e04adc0$var$$c0c01354ab9765ae$var$baseStyles,
            selected && $fc6840133e04adc0$var$$c0c01354ab9765ae$var$selectedStyles,
            disabled && $fc6840133e04adc0$var$$c0c01354ab9765ae$var$disabledStyles
        ],
        onClick: onClick,
        "aria-label": ariaLabel,
        disabled: disabled,
        "data-testid": testId,
        type: "button",
        children: icon
    });
    return tooltip && !disabled ? (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $1oVT1.default), {
        content: tooltip,
        testId: `${testId}-tooltip`,
        children: button
    }) : button;
};
const $fc6840133e04adc0$var$$c0c01354ab9765ae$var$baseStyles = (0, $74Zh5.css)({
    background: "transparent",
    border: "none",
    padding: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.050"),
    cursor: "pointer",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: "4px",
    transition: "background-color 0.2s ease",
    color: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.text.inverse"),
    width: "32px",
    height: "32px",
    "&:hover": {
        backgroundColor: "rgba(255, 255, 255, 0.16)"
    },
    "&:active": {
        backgroundColor: "rgba(255, 255, 255, 0.24)"
    },
    "&:focus": {
        outline: `2px solid ${(0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.border.inverse")}`,
        outlineOffset: "2px"
    },
    // Ensure icon inherits the white color
    "& > span": {
        color: "inherit"
    }
});
const $fc6840133e04adc0$var$$c0c01354ab9765ae$var$selectedStyles = (0, $74Zh5.css)({
    "&:hover": {
        backgroundColor: "rgba(255, 255, 255, 0.32)"
    },
    "&:active": {
        backgroundColor: "rgba(255, 255, 255, 0.40)"
    }
});
const $fc6840133e04adc0$var$$c0c01354ab9765ae$var$disabledStyles = (0, $74Zh5.css)({
    cursor: "not-allowed",
    opacity: 0.4,
    "&:hover": {
        backgroundColor: "transparent"
    },
    "&:active": {
        backgroundColor: "transparent"
    }
});
var $fc6840133e04adc0$var$$4fce8dfc4ce8f546$exports = {};
$fc6840133e04adc0$var$$parcel$export($fc6840133e04adc0$var$$4fce8dfc4ce8f546$exports, "LinkStyle", ()=>$fc6840133e04adc0$export$2b77966d73aefa77);
$fc6840133e04adc0$var$$parcel$export($fc6840133e04adc0$var$$4fce8dfc4ce8f546$exports, "LinkSize", ()=>$fc6840133e04adc0$export$be4c932f76c19adf);
$fc6840133e04adc0$var$$parcel$export($fc6840133e04adc0$var$$4fce8dfc4ce8f546$exports, "Link", ()=>$fc6840133e04adc0$export$a6c7ac8248d6e38a);
let $fc6840133e04adc0$export$2b77966d73aefa77;
(function(LinkStyle) {
    LinkStyle["REGULAR"] = "regular";
    LinkStyle["SEMIBOLD"] = "semibold";
})($fc6840133e04adc0$export$2b77966d73aefa77 || ($fc6840133e04adc0$export$2b77966d73aefa77 = {}));
let $fc6840133e04adc0$export$be4c932f76c19adf;
(function(LinkSize) {
    LinkSize["EXTRA_LARGE"] = "extraLarge";
    LinkSize["LARGE"] = "large";
    LinkSize["MEDIUM"] = "medium";
})($fc6840133e04adc0$export$be4c932f76c19adf || ($fc6840133e04adc0$export$be4c932f76c19adf = {}));
const $fc6840133e04adc0$export$a6c7ac8248d6e38a = ({ label: label, fontColor: fontColor = (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.text.accent.blue"), target: target = "_self", link: link, style: style = $fc6840133e04adc0$export$2b77966d73aefa77.REGULAR, icon: icon, onClick: onClick, size: size = $fc6840133e04adc0$export$be4c932f76c19adf.MEDIUM, ...props })=>{
    const clickHandler = (0, $5FkrB.useCallback)((e)=>{
        e.stopPropagation();
        e.preventDefault();
        if (onClick) onClick(e);
    }, [
        onClick
    ]);
    const onKeyDown = (e)=>(handler)=>{
            if (e.key === "Enter" || e.key === " ") handler(e);
        };
    return (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("a", {
        target: target,
        href: link,
        rel: target === "_blank" ? "noopener noreferrer" : "",
        tabIndex: 0,
        css: [
            $fc6840133e04adc0$var$$4fce8dfc4ce8f546$var$sizeStyles[size],
            $fc6840133e04adc0$var$$4fce8dfc4ce8f546$var$variantStyles[style].base,
            $fc6840133e04adc0$var$$4fce8dfc4ce8f546$var$baseStyles,
            $fc6840133e04adc0$var$$4fce8dfc4ce8f546$var$variantStyles[style].hover,
            (0, $74Zh5.css)({
                color: fontColor
            })
        ],
        style: {
            wordBreak: "break-word",
            overflowWrap: "break-word"
        },
        onClick: clickHandler,
        /** @ts-expect-error - onKeyDown is not typed correctly */ onKeyDown: (e)=>onKeyDown(e)(clickHandler),
        ...props,
        children: [
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("span", {
                children: label
            }),
            icon && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("span", {
                css: $fc6840133e04adc0$var$$4fce8dfc4ce8f546$var$iconContainerStyles,
                children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$export$f04a61298a47a40f, {
                    type: icon,
                    size: "medium"
                })
            })
        ]
    });
};
const $fc6840133e04adc0$var$$4fce8dfc4ce8f546$var$baseStyles = (0, $74Zh5.css)({
    display: "inline",
    alignItems: "center",
    justifyContent: "center",
    columnGap: "2px",
    textDecoration: "none",
    [(0, $0bc19dfefbafca8c$export$987d49ffe1b0900f).below.sm]: {
        fontSize: "16px !important",
        lineHeight: "20px !important"
    }
});
const $fc6840133e04adc0$var$$4fce8dfc4ce8f546$var$sizeStyles = {
    medium: {
        fontSize: "16px",
        lineHeight: "24px"
    },
    large: {
        fontSize: "20px",
        lineHeight: "24px"
    },
    extraLarge: {
        fontSize: "24px",
        lineHeight: "32px"
    }
};
const $fc6840133e04adc0$var$$4fce8dfc4ce8f546$var$variantStyles = {
    regular: {
        base: (0, $74Zh5.css)({
            fontWeight: "normal"
        }),
        hover: (0, $74Zh5.css)({
            "&:hover": {
                color: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.link"),
                textDecoration: "underline",
                cursor: "pointer",
                textUnderlineOffset: "4px",
                textDecorationThickness: "2px",
                textDecorationColor: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.link")
            }
        })
    },
    semibold: {
        base: (0, $74Zh5.css)({
            fontWeight: 600
        }),
        hover: (0, $74Zh5.css)({
            "&:hover": {
                color: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.link"),
                textDecoration: "underline",
                cursor: "pointer",
                textUnderlineOffset: "4px",
                textDecorationThickness: "2px",
                textDecorationColor: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.link")
            }
        })
    }
};
const $fc6840133e04adc0$var$$4fce8dfc4ce8f546$var$iconContainerStyles = {
    display: "inline",
    verticalAlign: "middle"
};
var $fc6840133e04adc0$var$$800df40a54823a3f$exports = {};
$fc6840133e04adc0$var$$parcel$export($fc6840133e04adc0$var$$800df40a54823a3f$exports, "List", ()=>$fc6840133e04adc0$export$54c2e3dc7acea9f5);
$fc6840133e04adc0$var$$parcel$export($fc6840133e04adc0$var$$800df40a54823a3f$exports, "variantsListStyles", ()=>$fc6840133e04adc0$export$6427468642e6e9fe);
const $fc6840133e04adc0$export$54c2e3dc7acea9f5 = ({ type: type = "unordered", textStyleType: textStyleType = "regular", children: children })=>{
    if (type === "ordered") return (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("ol", {
        "aria-label": "ordered",
        css: [
            $fc6840133e04adc0$var$$800df40a54823a3f$var$listStyles,
            (0, $74Zh5.css)($fc6840133e04adc0$export$6427468642e6e9fe.list[type]),
            $fc6840133e04adc0$export$6427468642e6e9fe.textStyle[textStyleType]
        ],
        children: children
    });
    return (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("ul", {
        "aria-label": "unordered",
        css: [
            $fc6840133e04adc0$var$$800df40a54823a3f$var$listStyles,
            (0, $74Zh5.css)($fc6840133e04adc0$export$6427468642e6e9fe.list[type]),
            $fc6840133e04adc0$export$6427468642e6e9fe.textStyle[textStyleType]
        ],
        children: children
    });
};
const $fc6840133e04adc0$var$$800df40a54823a3f$var$fontSizeStyles = {
    fontSize: "1.25rem",
    lineHeight: "2rem",
    [(0, $0bc19dfefbafca8c$export$987d49ffe1b0900f).below.md]: {
        fontSize: "1rem",
        lineHeight: "1.5rem"
    }
};
const $fc6840133e04adc0$var$$800df40a54823a3f$var$listStyles = (0, $74Zh5.css)({
    fontFamily: "Inter, sans-serif",
    letterSpacing: "0.3%",
    color: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.text"),
    ...$fc6840133e04adc0$var$$800df40a54823a3f$var$fontSizeStyles,
    span: $fc6840133e04adc0$var$$800df40a54823a3f$var$fontSizeStyles
});
const $fc6840133e04adc0$export$6427468642e6e9fe = {
    list: {
        unordered: {
            listStyleType: "disc",
            paddingLeft: "1.25rem",
            ul: {
                listStyleType: "circle",
                paddingLeft: "1.25rem"
            },
            "ul ul": {
                listStyleType: "square",
                paddingLeft: "1.25rem"
            },
            "ul:not(:first-of-type), ul li, li + li": {
                marginTop: 0
            }
        },
        ordered: {
            listStyleType: "decimal",
            paddingLeft: "1.25rem",
            ol: {
                listStyleType: "lower-alpha",
                paddingLeft: "1.25rem"
            },
            "ol ol": {
                listStyleType: "lower-roman",
                paddingLeft: "1.25rem"
            },
            "ol:not(:first-of-type), ol li, li + li": {
                marginTop: 0
            }
        }
    },
    textStyle: {
        regular: (0, $74Zh5.css)({
            fontWeight: 400
        }),
        italic: (0, $74Zh5.css)({
            fontStyle: "italic"
        }),
        bold: (0, $74Zh5.css)({
            fontWeight: 700
        }),
        boldItalic: (0, $74Zh5.css)({
            fontWeight: 700,
            fontStyle: "italic"
        })
    }
};
var $fc6840133e04adc0$var$$25cbe9fdb2d8d071$exports = {};
$fc6840133e04adc0$var$$parcel$export($fc6840133e04adc0$var$$25cbe9fdb2d8d071$exports, "NavigationBar", ()=>$fc6840133e04adc0$export$214ae410b202e65a);
$fc6840133e04adc0$var$$parcel$export($fc6840133e04adc0$var$$25cbe9fdb2d8d071$exports, "NavBarLinkItem", ()=>$fc6840133e04adc0$export$e76239e22e3abad);
$fc6840133e04adc0$var$$parcel$export($fc6840133e04adc0$var$$25cbe9fdb2d8d071$exports, "NavBarProfileItem", ()=>$fc6840133e04adc0$export$1cba3806e1f1b01d);
$fc6840133e04adc0$var$$parcel$export($fc6840133e04adc0$var$$25cbe9fdb2d8d071$exports, "AtlassianNavLogo", ()=>$fc6840133e04adc0$export$6ce3be5638d8e2a);
$fc6840133e04adc0$var$$parcel$export($fc6840133e04adc0$var$$25cbe9fdb2d8d071$exports, "MenuItem", ()=>$fc6840133e04adc0$export$2ce376c2cc3355c8);
$fc6840133e04adc0$var$$parcel$export($fc6840133e04adc0$var$$25cbe9fdb2d8d071$exports, "NavBarExpandableItem", ()=>$fc6840133e04adc0$export$1229978ae51a03a8);
$fc6840133e04adc0$var$$parcel$export($fc6840133e04adc0$var$$25cbe9fdb2d8d071$exports, "NavbarSlideMenuItem", ()=>$fc6840133e04adc0$export$c7fcbaf97c146aec);
$fc6840133e04adc0$var$$parcel$export($fc6840133e04adc0$var$$25cbe9fdb2d8d071$exports, "NavBarItemWithMenu", ()=>$fc6840133e04adc0$export$2771c1f4a09ce668);
const $fc6840133e04adc0$var$$6a34d18c8d59b475$var$CloseIcon = ()=>(0, $6bec4f26b2cb3094$export$25062201e9e25d76)("svg", {
        width: "32",
        height: "32",
        viewBox: "0 0 32 32",
        fill: "currentColor",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("path", {
                d: "M7 7L23.9706 23.9706",
                stroke: "currentColor",
                strokeWidth: "3",
                strokeLinecap: "round"
            }),
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("path", {
                d: "M7 24L23.9706 7.02944",
                stroke: "currentColor",
                strokeWidth: "3",
                strokeLinecap: "round"
            })
        ]
    });
var $fc6840133e04adc0$var$$6a34d18c8d59b475$export$2e2bcd8739ae039 = $fc6840133e04adc0$var$$6a34d18c8d59b475$var$CloseIcon;
const $fc6840133e04adc0$var$$5ba5f450ff826a14$var$HamburgerMenuIcon = ()=>(0, $6bec4f26b2cb3094$export$25062201e9e25d76)("svg", {
        width: "32",
        height: "32",
        viewBox: "0 0 32 32",
        fill: "currentColor",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("path", {
                d: "M4 8H28",
                stroke: "currentColor",
                strokeWidth: "3",
                strokeLinecap: "round"
            }),
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("path", {
                d: "M4 16H28",
                stroke: "currentColor",
                strokeWidth: "3",
                strokeLinecap: "round"
            }),
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("path", {
                d: "M4 24H28",
                stroke: "currentColor",
                strokeWidth: "3",
                strokeLinecap: "round"
            })
        ]
    });
var $fc6840133e04adc0$var$$5ba5f450ff826a14$export$2e2bcd8739ae039 = $fc6840133e04adc0$var$$5ba5f450ff826a14$var$HamburgerMenuIcon;
const $fc6840133e04adc0$var$$f0285f05d4d9f8a0$export$426e07cd0772984d = {
    MOBILE: {
        MAX_WIDTH: 767,
        MEDIA_QUERY: "@media (max-width: 767px)"
    },
    TABLET: {
        MIN_WIDTH: 768,
        MAX_WIDTH: 1279,
        MEDIA_QUERY: "@media (min-width: 768px) and (max-width: 1279px)"
    },
    DESKTOP: {
        MIN_WIDTH: 1280,
        MEDIA_QUERY: "@media (min-width: 1280px)"
    }
};
var $fc6840133e04adc0$var$$965a3cfbe886b380$exports = {};
$fc6840133e04adc0$var$$parcel$export($fc6840133e04adc0$var$$965a3cfbe886b380$exports, "useOutsideClickHandler", ()=>$fc6840133e04adc0$export$aa79b0abe3dfeaba);
const $fc6840133e04adc0$export$aa79b0abe3dfeaba = (refs, onOutsideClick)=>{
    (0, $5FkrB.useEffect)(()=>{
        const handleOutsideClick = (event)=>{
            // if click has occurred outside of all refs, then call onOutsideClick
            if (refs.every((ref)=>ref.current && !ref.current.contains(event.target))) onOutsideClick();
        };
        // bind the event listener
        document.addEventListener("mousedown", handleOutsideClick);
        return ()=>{
            // unbind the event listener on clean up
            document.removeEventListener("mousedown", handleOutsideClick);
        };
    }, [
        refs,
        onOutsideClick
    ]);
};
const $fc6840133e04adc0$export$6ce3be5638d8e2a = ({ subtitleHref: subtitleHref, label: label, logoSubtitle: logoSubtitle })=>{
    return (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("span", {
        css: $fc6840133e04adc0$var$$90d3cbebafca1fdb$var$containerStyles,
        children: [
            (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("a", {
                href: "https://www.atlassian.com",
                target: "_blank",
                rel: "noopener noreferrer",
                children: [
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("span", {
                        css: $fc6840133e04adc0$var$$90d3cbebafca1fdb$var$smallAtlassianLogoStyles,
                        children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $57028745e7fabd90$export$8a485e2e7ed91e8f), {
                            testId: "mobile"
                        })
                    }),
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("span", {
                        css: $fc6840133e04adc0$var$$90d3cbebafca1fdb$var$bigAtlassianLogoStyles,
                        children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $0ae21ee22a245b70$export$765cacec8b0843f3), {
                            testId: "desktop"
                        })
                    })
                ]
            }),
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("span", {
                css: $fc6840133e04adc0$var$$90d3cbebafca1fdb$var$dividerStyles
            }),
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("a", {
                href: subtitleHref,
                css: $fc6840133e04adc0$var$$90d3cbebafca1fdb$var$subtitleStyles,
                "data-testid": "logoSubtitle",
                "aria-label": label,
                children: (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("span", {
                    children: [
                        " ",
                        logoSubtitle,
                        " "
                    ]
                })
            })
        ]
    });
};
const $fc6840133e04adc0$var$$90d3cbebafca1fdb$var$containerStyles = (0, $74Zh5.css)({
    display: "flex",
    alignItems: "center",
    background: "none",
    fontFamily: "Charlie Display"
});
const $fc6840133e04adc0$var$$90d3cbebafca1fdb$var$smallAtlassianLogoStyles = (0, $74Zh5.css)({
    [`@media (max-width: ${$fc6840133e04adc0$var$$f0285f05d4d9f8a0$export$426e07cd0772984d.TABLET.MAX_WIDTH}px)`]: {
        display: "flex",
        alignItems: "center",
        svg: {
            color: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.icon.brand"),
            transform: "scale(0.74)"
        }
    },
    [`@media (min-width: ${$fc6840133e04adc0$var$$f0285f05d4d9f8a0$export$426e07cd0772984d.DESKTOP.MIN_WIDTH}px)`]: {
        display: "none"
    }
});
const $fc6840133e04adc0$var$$90d3cbebafca1fdb$var$bigAtlassianLogoStyles = (0, $74Zh5.css)({
    [`@media (min-width: ${$fc6840133e04adc0$var$$f0285f05d4d9f8a0$export$426e07cd0772984d.DESKTOP.MIN_WIDTH}px)`]: {
        display: "flex",
        alignItems: "center",
        span: {
            width: "148px",
            height: "24px"
        },
        svg: {
            color: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.icon.brand")
        }
    },
    [`@media (max-width: ${$fc6840133e04adc0$var$$f0285f05d4d9f8a0$export$426e07cd0772984d.TABLET.MAX_WIDTH}px)`]: {
        display: "none"
    }
});
const $fc6840133e04adc0$var$$90d3cbebafca1fdb$var$dividerStyles = (0, $74Zh5.css)({
    width: "1px",
    height: "32px",
    backgroundColor: "#DDDEE1",
    marginLeft: "24px",
    marginRight: "16px",
    [`@media (max-width: ${$fc6840133e04adc0$var$$f0285f05d4d9f8a0$export$426e07cd0772984d.TABLET.MAX_WIDTH}px)`]: {
        marginLeft: "8px",
        marginRight: "16px"
    }
});
const $fc6840133e04adc0$var$$90d3cbebafca1fdb$var$subtitleStyles = (0, $74Zh5.css)({
    fontSize: "22px",
    fontWeight: 600,
    color: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.text"),
    textDecoration: "none",
    padding: "6px 8px",
    "&:hover": {
        color: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.border.brand"),
        textDecoration: "none"
    }
});
const $fc6840133e04adc0$var$$ff532043ef39c56f$var$SlideMenuContext = (0, $5FkrB.createContext)(undefined);
const $fc6840133e04adc0$var$$ff532043ef39c56f$export$74d704c90f90362c = ()=>{
    const context = (0, $5FkrB.useContext)($fc6840133e04adc0$var$$ff532043ef39c56f$var$SlideMenuContext);
    if (!context) throw new Error("useSlideMenuContext must be used within a SlideMenuContextProvider");
    return context;
};
const $fc6840133e04adc0$var$$ff532043ef39c56f$export$f5c7f2da77f7e7fd = ({ children: children })=>{
    const [slideMenuContent, setSlideMenuContent] = (0, $5FkrB.useState)(null);
    const [isSlideMenuOpen, setIsSlideMenuOpen] = (0, $5FkrB.useState)(false);
    const [containerHeight, setContainerHeight] = (0, $5FkrB.useState)("initial");
    const openSlideMenu = (content)=>{
        setSlideMenuContent(content);
        setIsSlideMenuOpen(true);
    };
    const closeSlideMenu = ()=>{
        setIsSlideMenuOpen(false);
    };
    const contextValue = (0, $5FkrB.useMemo)(()=>({
            slideMenuContent: slideMenuContent,
            isSlideMenuOpen: isSlideMenuOpen,
            openSlideMenu: openSlideMenu,
            closeSlideMenu: closeSlideMenu,
            containerHeight: containerHeight,
            setContainerHeight: setContainerHeight
        }), [
        slideMenuContent,
        isSlideMenuOpen,
        containerHeight
    ]);
    return (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$var$$ff532043ef39c56f$var$SlideMenuContext.Provider, {
        value: contextValue,
        children: children
    });
};
const $fc6840133e04adc0$export$2771c1f4a09ce668 = ({ headerContent: headerContent, bodyContent: bodyContent, isNested: isNested = false, isActive: isActive = false })=>(0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
        css: $fc6840133e04adc0$var$$6295d3d31ca2a786$var$containerStyles,
        role: "group",
        "data-testid": "navbar-menu-item",
        children: [
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                css: [
                    $fc6840133e04adc0$var$$6295d3d31ca2a786$var$headerStyles,
                    isActive && $fc6840133e04adc0$var$$6295d3d31ca2a786$var$headerSelectedStyles,
                    isNested && $fc6840133e04adc0$var$$6295d3d31ca2a786$var$nestedHeaderStyles
                ],
                role: "treeitem",
                "aria-selected": isActive,
                children: headerContent
            }),
            isActive && bodyContent && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("ul", {
                css: [
                    $fc6840133e04adc0$var$$6295d3d31ca2a786$var$bodyContentContainerStyles,
                    isNested && $fc6840133e04adc0$var$$6295d3d31ca2a786$var$nestedBodyContentContainerStyles
                ],
                children: bodyContent
            })
        ]
    });
const $fc6840133e04adc0$var$$6295d3d31ca2a786$var$containerStyles = (0, $74Zh5.css)({
    display: "flex",
    fontSize: "16px",
    alignItems: "flex-start",
    flexDirection: "column",
    width: "100%"
});
const $fc6840133e04adc0$var$$6295d3d31ca2a786$var$headerStyles = (0, $74Zh5.css)({
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    cursor: "pointer",
    height: "32px",
    width: "100%",
    padding: `0 ${(0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.300")}`
});
const $fc6840133e04adc0$var$$6295d3d31ca2a786$var$headerSelectedStyles = (0, $74Zh5.css)({
    color: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.text.selected"),
    "a, span": {
        color: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.text.selected")
    }
});
const $fc6840133e04adc0$var$$6295d3d31ca2a786$var$nestedHeaderStyles = (0, $74Zh5.css)({
    padding: `0 ${(0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.500")}`
});
const $fc6840133e04adc0$var$$6295d3d31ca2a786$var$bodyContentContainerStyles = (0, $74Zh5.css)({
    display: "flex",
    flexDirection: "column",
    width: "100%",
    gap: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.100"),
    paddingLeft: 0,
    margin: 0,
    marginTop: `${(0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.100")} !important`,
    listStyle: "none"
});
const $fc6840133e04adc0$var$$6295d3d31ca2a786$var$nestedBodyContentContainerStyles = (0, $74Zh5.css)({
    li: {
        paddingLeft: "56px"
    }
});
var $fc6840133e04adc0$var$$6e8a4d5d78071ed7$exports = {};
$fc6840133e04adc0$var$$parcel$export($fc6840133e04adc0$var$$6e8a4d5d78071ed7$exports, "useMediaQuery", ()=>$fc6840133e04adc0$export$32d5543ab307c01);
const $fc6840133e04adc0$export$32d5543ab307c01 = (mediaQuery)=>{
    const [targetReached, setTargetReached] = (0, $5FkrB.useState)(false);
    const updateTarget = (0, $5FkrB.useCallback)((e)=>{
        if (e.matches) setTargetReached(true);
        else setTargetReached(false);
    }, []);
    (0, $5FkrB.useEffect)(()=>{
        const media = window.matchMedia(mediaQuery);
        media.addEventListener("change", updateTarget);
        // Check on mount (callback is not called until a change occurs)
        if (media.matches) setTargetReached(true);
        return ()=>media.removeEventListener("change", updateTarget);
    // mediaQuery and updateTarget intentionally excluded to avoid re-creating listener
    /* eslint-disable react-hooks/exhaustive-deps */ }, []);
    /* eslint-enable react-hooks/exhaustive-deps */ return targetReached;
};
const $fc6840133e04adc0$var$$3e3d20b49785004a$export$29d11c0fe2fc51d8 = ({ link: link, shouldRedirect: shouldRedirect, isSelected: isSelected })=>{
    const { text: text, href: href, onClick: onClick, target: target } = link;
    return (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("a", {
        css: [
            $fc6840133e04adc0$var$$3e3d20b49785004a$var$linkStyles.default,
            isSelected && $fc6840133e04adc0$var$$3e3d20b49785004a$var$linkStyles.selected
        ],
        href: shouldRedirect ? href : undefined,
        onClick: onClick,
        target: target || "_self",
        children: text
    });
};
const $fc6840133e04adc0$export$e76239e22e3abad = ({ isSelected: isSelected = false, link: link, expandableBodyContent: expandableBodyContent, isNested: isNested = false, showNewMenu: showNewMenu = false })=>{
    const isBreakpoint = $fc6840133e04adc0$export$32d5543ab307c01(`(max-width: ${$fc6840133e04adc0$var$$f0285f05d4d9f8a0$export$426e07cd0772984d.TABLET.MAX_WIDTH}px)`);
    if (isBreakpoint) return showNewMenu ? (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$export$2771c1f4a09ce668, {
        headerContent: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$var$$3e3d20b49785004a$export$29d11c0fe2fc51d8, {
            link: link,
            isSelected: isSelected,
            shouldRedirect: !expandableBodyContent
        }),
        bodyContent: expandableBodyContent,
        isNested: isNested,
        isActive: isSelected
    }) : (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$export$1229978ae51a03a8, {
        headerContent: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$var$$3e3d20b49785004a$export$29d11c0fe2fc51d8, {
            link: link,
            isSelected: isSelected,
            shouldRedirect: !expandableBodyContent
        }),
        bodyContent: expandableBodyContent,
        isNested: isNested
    });
    return (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
        css: $fc6840133e04adc0$var$$3e3d20b49785004a$var$buttonDivStyles,
        children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$var$$3e3d20b49785004a$export$29d11c0fe2fc51d8, {
            link: link,
            isSelected: isSelected,
            shouldRedirect: true
        })
    });
};
const $fc6840133e04adc0$var$$3e3d20b49785004a$var$buttonDivStyles = (0, $74Zh5.css)({
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    padding: "10px 12px"
});
const $fc6840133e04adc0$var$$3e3d20b49785004a$var$linkStyles = {
    default: (0, $74Zh5.css)({
        color: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.text"),
        fontSize: "1rem",
        fontWeight: 400,
        lineHeight: "20px",
        "&:hover": {
            color: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.text.selected"),
            textDecoration: "none"
        },
        "&:active": {
            color: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.text.information")
        },
        [`@media (max-width: ${$fc6840133e04adc0$var$$f0285f05d4d9f8a0$export$426e07cd0772984d.TABLET.MAX_WIDTH}px)`]: {
            "&:hover, &:active": {
                color: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.text.brand"),
                textDecoration: "none"
            }
        }
    }),
    selected: (0, $74Zh5.css)({
        [`@media (min-width: ${$fc6840133e04adc0$var$$f0285f05d4d9f8a0$export$426e07cd0772984d.DESKTOP.MIN_WIDTH}px)`]: {
            color: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.text.selected")
        }
    })
};
const $fc6840133e04adc0$export$1229978ae51a03a8 = ({ headerContent: headerContent, expandedHeaderContent: expandedHeaderContent, bodyContent: bodyContent, onExpandClick: onExpandClick, isNested: isNested = false })=>{
    const [isOpen, setIsOpen] = (0, $5FkrB.useState)(false);
    const onExpandClickHandler = ()=>{
        setIsOpen(!isOpen);
        if (onExpandClick) onExpandClick(isOpen);
    };
    return (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
        css: $fc6840133e04adc0$var$$3b7e032fd37ae5a5$var$containerStyles,
        role: "group",
        children: bodyContent ? (0, $6bec4f26b2cb3094$export$25062201e9e25d76)((0, $6bec4f26b2cb3094$export$ffb0004e005737fa), {
            children: [
                (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                    css: [
                        $fc6840133e04adc0$var$$3b7e032fd37ae5a5$var$headerStyles,
                        isOpen && $fc6840133e04adc0$var$$3b7e032fd37ae5a5$var$headerSelectedStyles,
                        isNested && $fc6840133e04adc0$var$$3b7e032fd37ae5a5$var$nestedHeaderStyles
                    ],
                    role: "treeitem",
                    tabIndex: 0,
                    "aria-selected": isOpen,
                    onClick: onExpandClickHandler,
                    onKeyDown: (e)=>{
                        if (e.key === "Enter" || e.key === " ") {
                            e.preventDefault();
                            onExpandClickHandler();
                        }
                    },
                    children: [
                        isOpen && expandedHeaderContent ? expandedHeaderContent : headerContent,
                        (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("span", {
                            css: isOpen && $fc6840133e04adc0$var$$3b7e032fd37ae5a5$var$chevronSelectedStyles,
                            children: isOpen ? (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($cRECB))), {
                                label: "Collapse item"
                            }) : (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($1u6rG))), {
                                label: "Expand item"
                            })
                        })
                    ]
                }),
                isOpen && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("ul", {
                    css: [
                        $fc6840133e04adc0$var$$3b7e032fd37ae5a5$var$bodyContentContainerStyles,
                        isNested && $fc6840133e04adc0$var$$3b7e032fd37ae5a5$var$nestedBodyContentContainerStyles
                    ],
                    children: bodyContent
                })
            ]
        }) : (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
            css: $fc6840133e04adc0$var$$3b7e032fd37ae5a5$var$headerStyles,
            role: "treeitem",
            tabIndex: 0,
            "aria-selected": false,
            children: headerContent
        })
    });
};
const $fc6840133e04adc0$var$$3b7e032fd37ae5a5$var$containerStyles = (0, $74Zh5.css)({
    display: "flex",
    fontSize: "1rem",
    alignItems: "flex-start",
    flexDirection: "column",
    width: "100%"
});
const $fc6840133e04adc0$var$$3b7e032fd37ae5a5$var$headerStyles = (0, $74Zh5.css)({
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    cursor: "pointer",
    height: "32px",
    width: "100%",
    padding: "0 24px"
});
// when selected, header text color should appear as selected color (apply to different elements, since headerContent can vary)
const $fc6840133e04adc0$var$$3b7e032fd37ae5a5$var$headerSelectedStyles = (0, $74Zh5.css)({
    color: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.text.selected"),
    a: {
        color: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.text.selected")
    },
    span: {
        color: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.text.selected")
    }
});
const $fc6840133e04adc0$var$$3b7e032fd37ae5a5$var$nestedHeaderStyles = (0, $74Zh5.css)({
    padding: "0 40px"
});
const $fc6840133e04adc0$var$$3b7e032fd37ae5a5$var$bodyContentContainerStyles = (0, $74Zh5.css)({
    display: "flex",
    flexDirection: "column",
    width: "100%",
    gap: "8px",
    paddingTop: "8px",
    paddingLeft: "0",
    margin: 0,
    listStyle: "none"
});
const $fc6840133e04adc0$var$$3b7e032fd37ae5a5$var$nestedBodyContentContainerStyles = (0, $74Zh5.css)({
    li: {
        paddingLeft: "56px"
    }
});
const $fc6840133e04adc0$var$$3b7e032fd37ae5a5$var$chevronSelectedStyles = (0, $74Zh5.css)({
    svg: {
        color: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.text.selected")
    }
});
const $fc6840133e04adc0$export$c7fcbaf97c146aec = ({ title: title, menuHeader: menuHeader, menuContent: menuContent, type: type = "menuItem" })=>{
    const { openSlideMenu: openSlideMenu } = $fc6840133e04adc0$var$$ff532043ef39c56f$export$74d704c90f90362c();
    const handleOpenMenu = (0, $5FkrB.useCallback)(()=>{
        openSlideMenu({
            header: menuHeader || title,
            content: menuContent
        });
    }, [
        openSlideMenu,
        menuHeader,
        title,
        menuContent
    ]);
    const onKeyDown = $fc6840133e04adc0$export$2a0b6757d41dacb2(handleOpenMenu);
    return (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("li", {
        "data-testid": "navbar-slide-menu-item",
        css: [
            $fc6840133e04adc0$var$$67abd1c503eb8615$var$listItemStyles,
            type === "subMenuItem" && $fc6840133e04adc0$var$$67abd1c503eb8615$var$subMenuItemStyles
        ],
        children: (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
            role: "button",
            tabIndex: 0,
            css: $fc6840133e04adc0$var$$67abd1c503eb8615$var$interactiveContentStyles,
            onClick: handleOpenMenu,
            onKeyDown: onKeyDown,
            children: [
                (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("span", {
                    css: $fc6840133e04adc0$var$$67abd1c503eb8615$var$titleStyles,
                    children: title
                }),
                (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$export$f04a61298a47a40f, {
                    type: "chevron-right",
                    size: "medium"
                })
            ]
        })
    });
};
const $fc6840133e04adc0$var$$67abd1c503eb8615$var$titleStyles = (0, $74Zh5.css)({
    fontSize: "16px",
    fontWeight: 400
});
const $fc6840133e04adc0$var$$67abd1c503eb8615$var$listItemStyles = (0, $74Zh5.css)({});
const $fc6840133e04adc0$var$$67abd1c503eb8615$var$interactiveContentStyles = (0, $74Zh5.css)({
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    cursor: "pointer",
    color: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.text"),
    padding: `0 ${(0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.300")}`,
    paddingRight: "18px",
    height: "32px",
    "&:hover": {
        color: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.link")
    }
});
const $fc6840133e04adc0$var$$67abd1c503eb8615$var$subMenuItemStyles = (0, $74Zh5.css)({
    "& > div": {
        padding: `0 18px 0 ${(0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.500")}`
    }
});
const $fc6840133e04adc0$var$$397a78fff494027c$var$getAvatarUserHeaderForMobile = (user, isExpanded)=>(0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
        css: [
            $fc6840133e04adc0$var$$397a78fff494027c$var$headerContentStyles,
            isExpanded && $fc6840133e04adc0$var$$397a78fff494027c$var$avatarUserSelectedStyles
        ],
        children: [
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $de63f1e4c3afcd22$export$2e2bcd8739ae039), {
                appearance: "circle",
                src: user.avatar,
                size: "small",
                name: user.publicName
            }, user.publicName),
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                css: $fc6840133e04adc0$var$$397a78fff494027c$var$nameStyles,
                children: user.publicName
            })
        ]
    });
const $fc6840133e04adc0$export$1cba3806e1f1b01d = ({ user: user, expandableMenuContent: expandableMenuContent, profileMenuContent: profileMenuContent, onProfileMenuClick: onProfileMenuClick, showNewMenu: showNewMenu = false })=>{
    const [isMenuOpen, setIsMenuOpen] = (0, $5FkrB.useState)(false);
    const isBreakpoint = $fc6840133e04adc0$export$32d5543ab307c01(`(max-width: ${$fc6840133e04adc0$var$$f0285f05d4d9f8a0$export$426e07cd0772984d.TABLET.MAX_WIDTH}px)`);
    const avatarMenuRef = (0, $5FkrB.useRef)(null);
    $fc6840133e04adc0$export$aa79b0abe3dfeaba([
        avatarMenuRef
    ], ()=>setIsMenuOpen(false));
    const onProfileMenuClickHandler = ()=>{
        setIsMenuOpen(!isMenuOpen);
        if (onProfileMenuClick) onProfileMenuClick(isMenuOpen);
    };
    if (isBreakpoint) return showNewMenu ? (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$export$c7fcbaf97c146aec, {
        title: $fc6840133e04adc0$var$$397a78fff494027c$var$getAvatarUserHeaderForMobile(user, false),
        menuHeader: $fc6840133e04adc0$var$$397a78fff494027c$var$getAvatarUserHeaderForMobile(user, true),
        menuContent: expandableMenuContent
    }) : (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$export$1229978ae51a03a8, {
        headerContent: $fc6840133e04adc0$var$$397a78fff494027c$var$getAvatarUserHeaderForMobile(user, false),
        expandedHeaderContent: $fc6840133e04adc0$var$$397a78fff494027c$var$getAvatarUserHeaderForMobile(user, true),
        bodyContent: expandableMenuContent,
        onExpandClick: onProfileMenuClick
    });
    return (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("span", {
        ref: avatarMenuRef,
        children: [
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("button", {
                css: [
                    $fc6840133e04adc0$var$$397a78fff494027c$var$avatarStyles,
                    isMenuOpen && $fc6840133e04adc0$var$$397a78fff494027c$var$avatarUserSelectedStyles
                ],
                onClick: onProfileMenuClickHandler,
                children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $de63f1e4c3afcd22$export$2e2bcd8739ae039), {
                    appearance: "circle",
                    src: user.avatar,
                    size: "medium",
                    name: user.publicName
                }, user.publicName)
            }),
            isMenuOpen && profileMenuContent ? (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("ul", {
                css: $fc6840133e04adc0$var$$397a78fff494027c$var$openMenuStyles,
                "aria-label": "Profile menu",
                role: "menu",
                children: profileMenuContent
            }) : null
        ]
    });
};
const $fc6840133e04adc0$var$$397a78fff494027c$var$headerContentStyles = (0, $74Zh5.css)({
    display: "flex",
    gap: "8px",
    fontSize: "1rem",
    lineHeight: "20px"
});
const $fc6840133e04adc0$var$$397a78fff494027c$var$nameStyles = (0, $74Zh5.css)({
    alignSelf: "center"
});
const $fc6840133e04adc0$var$$397a78fff494027c$var$avatarStyles = (0, $74Zh5.css)({
    all: "unset",
    cursor: "pointer",
    marginTop: "3px",
    "&:focus-visible": {
        outline: `1px solid ${(0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.border.selected")}`
    }
});
const $fc6840133e04adc0$var$$397a78fff494027c$var$avatarUserSelectedStyles = (0, $74Zh5.css)({
    "& > * > span": {
        outline: `2px ${(0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.text.selected")} solid`
    }
});
const $fc6840133e04adc0$var$$397a78fff494027c$var$openMenuStyles = (0, $74Zh5.css)({
    backgroundColor: "#FFFFFF",
    position: "absolute",
    display: "flex",
    flexDirection: "column",
    right: 0,
    zIndex: 10,
    borderRadius: "4px",
    boxShadow: "0 0 1px 0 #ccc,0 5px 20px -5px rgba(0,0,0,.1)",
    listStyle: "none",
    margin: 0,
    padding: 0
});
const $fc6840133e04adc0$export$2ce376c2cc3355c8 = ({ link: link, type: type, contentBefore: contentBefore, contentAfter: contentAfter })=>{
    const { href: href, onClick: onClick, text: text, icon: icon } = link;
    const isActive = (0, $5FkrB.useMemo)(()=>href && globalThis ? globalThis.location.pathname === href : false, [
        href
    ]);
    return (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("a", {
        css: $fc6840133e04adc0$var$$3539883ac1727dfc$var$menuLinkStyles,
        href: href,
        onClick: onClick,
        children: (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("li", {
            css: [
                $fc6840133e04adc0$var$$3539883ac1727dfc$var$menuItemContainerBaseStyles,
                $fc6840133e04adc0$var$$3539883ac1727dfc$var$menuItemContainerStyles[type],
                isActive && $fc6840133e04adc0$var$$3539883ac1727dfc$var$activeStyles
            ],
            role: "treeitem",
            "aria-selected": isActive,
            children: [
                contentBefore,
                text,
                icon && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("span", {
                    css: $fc6840133e04adc0$var$$3539883ac1727dfc$var$iconStyles,
                    children: icon
                }),
                contentAfter
            ]
        })
    });
};
const $fc6840133e04adc0$var$$3539883ac1727dfc$var$menuItemContainerBaseStyles = (0, $74Zh5.css)({
    display: "flex",
    alignItems: "center",
    width: "100%"
});
const $fc6840133e04adc0$var$$3539883ac1727dfc$var$menuItemContainerStyles = {
    subMenu: (0, $74Zh5.css)({
        height: "32px",
        padding: "0 40px"
    }),
    profile: (0, $74Zh5.css)({
        height: "48px",
        padding: "0 24px"
    }),
    menuItem: (0, $74Zh5.css)({
        fontFamily: "Inter, sans-serif",
        fontSize: "14px",
        lineHeight: "22px",
        fontWeight: 400,
        height: "32px",
        padding: `0 ${(0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.150")}`
    })
};
const $fc6840133e04adc0$var$$3539883ac1727dfc$var$menuLinkStyles = (0, $74Zh5.css)({
    fontSize: "16px",
    lineHeight: "16px",
    fontWeight: 400,
    color: "#172B4D",
    cursor: "pointer",
    "&:hover": {
        color: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.text.selected"),
        textDecoration: "none"
    },
    "&:active": {
        color: "#0055CC",
        li: {
            background: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.background.accent.blue.subtlest")
        }
    }
});
const $fc6840133e04adc0$var$$3539883ac1727dfc$var$activeStyles = (0, $74Zh5.css)({
    color: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.text.selected")
});
const $fc6840133e04adc0$var$$3539883ac1727dfc$var$iconStyles = (0, $74Zh5.css)({
    display: "inline-flex",
    alignItems: "center",
    marginLeft: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.050")
});
const $fc6840133e04adc0$var$$e2bb601faa5fb56f$export$a24e9349d70a402 = ({ navRef: navRef })=>{
    const navWrapperTopPosition = (0, $5FkrB.useMemo)(()=>navRef.current?.getBoundingClientRect()?.y || 56, [
        navRef
    ]);
    const ref = (0, $5FkrB.useRef)(null);
    const { closeSlideMenu: closeSlideMenu, slideMenuContent: slideMenuContent, isSlideMenuOpen: isSlideMenuOpen, setContainerHeight: setContainerHeight } = $fc6840133e04adc0$var$$ff532043ef39c56f$export$74d704c90f90362c();
    const { header: header, content: content } = slideMenuContent || {};
    const isTitleString = typeof header === "string";
    (0, $5FkrB.useEffect)(()=>{
        const element = ref.current;
        if (!element) return;
        const preventScroll = (e)=>{
            if (element.contains(e.target)) return;
            e.preventDefault();
        };
        element.addEventListener("wheel", preventScroll);
        element.addEventListener("touchmove", preventScroll);
        return ()=>{
            element.removeEventListener("wheel", preventScroll);
            element.removeEventListener("touchmove", preventScroll);
        };
    }, []);
    (0, $5FkrB.useEffect)(()=>{
        if (isSlideMenuOpen) setContainerHeight(ref.current?.getBoundingClientRect().height || "initial");
    // setContainerHeight intentionally excluded (stable setState function)
    /* eslint-disable react-hooks/exhaustive-deps */ }, [
        isSlideMenuOpen
    ]);
    /* eslint-enable react-hooks/exhaustive-deps */ return (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
        ref: ref,
        "data-testid": "slide-menu",
        css: [
            $fc6840133e04adc0$var$$e2bb601faa5fb56f$var$menuStyles,
            (0, $74Zh5.css)({
                maxHeight: `calc(100vh - ${navWrapperTopPosition}px)`
            })
        ],
        "aria-hidden": !isSlideMenuOpen,
        children: [
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                css: $fc6840133e04adc0$var$$e2bb601faa5fb56f$var$backButtonContainerStyles,
                children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$export$353f5b6fc5456de1, {
                    appearance: $fc6840133e04adc0$export$261c9483fc4a455a.LINK,
                    onClick: closeSlideMenu,
                    iconBefore: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$export$f04a61298a47a40f, {
                        type: "chevron-left",
                        size: "medium"
                    }),
                    label: "Back"
                })
            }),
            header && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                css: [
                    !isTitleString && $fc6840133e04adc0$var$$e2bb601faa5fb56f$var$headerStyles,
                    isTitleString && $fc6840133e04adc0$var$$e2bb601faa5fb56f$var$titleStyles
                ],
                children: header
            }),
            content && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                css: $fc6840133e04adc0$var$$e2bb601faa5fb56f$var$contentStyles,
                children: content
            })
        ]
    });
};
const $fc6840133e04adc0$var$$e2bb601faa5fb56f$var$menuStyles = (0, $74Zh5.css)({
    position: "fixed",
    width: "375px",
    overflow: "auto",
    backgroundColor: "#FFFFFF",
    borderRadius: "8px",
    zIndex: 1000,
    padding: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.300"),
    top: 0,
    [(0, $0bc19dfefbafca8c$export$987d49ffe1b0900f).below.sm]: {
        transition: "transform 0.3s cubic-bezier(.4,1,.5,1), opacity 0.3s",
        transform: "translateX(-100%)",
        left: 0,
        width: "100vw"
    }
});
const $fc6840133e04adc0$var$$e2bb601faa5fb56f$var$backButtonContainerStyles = (0, $74Zh5.css)({
    marginBottom: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.250"),
    "& button": {
        padding: 0,
        marginLeft: "-9px",
        fontWeight: 400
    }
});
const $fc6840133e04adc0$var$$e2bb601faa5fb56f$var$headerStyles = (0, $74Zh5.css)({
    textTransform: "uppercase",
    marginLeft: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.100"),
    marginBottom: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.200"),
    "& > div": {
        fontSize: "12px",
        lineHeight: "16px",
        fontWeight: 600,
        fontFamily: "Charlie Text, sans-serif"
    }
});
const $fc6840133e04adc0$var$$e2bb601faa5fb56f$var$titleStyles = (0, $74Zh5.css)({
    fontSize: "12px",
    lineHeight: "16px",
    fontWeight: 600,
    fontFamily: "Charlie Text, sans-serif",
    textTransform: "uppercase",
    marginBottom: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.150"),
    marginTop: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.400")
});
const $fc6840133e04adc0$var$$e2bb601faa5fb56f$var$contentStyles = (0, $74Zh5.css)({
    display: "flex",
    flexDirection: "column",
    gap: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.150")
});
const $fc6840133e04adc0$var$$25cbe9fdb2d8d071$var$DRAWER_WIDTH = 375;
const $fc6840133e04adc0$var$$25cbe9fdb2d8d071$var$ToggleButton = ({ isOpen: isOpen, toggleMenu: toggleMenu })=>{
    const { closeSlideMenu: closeSlideMenu } = $fc6840133e04adc0$var$$ff532043ef39c56f$export$74d704c90f90362c();
    const handleToggle = ()=>{
        toggleMenu();
        if (isOpen) closeSlideMenu();
    };
    return (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $744d288f60bb77dd$export$2e2bcd8739ae039), {
        appearance: "subtle",
        onClick: handleToggle,
        icon: isOpen ? $fc6840133e04adc0$var$$6a34d18c8d59b475$export$2e2bcd8739ae039 : $fc6840133e04adc0$var$$5ba5f450ff826a14$export$2e2bcd8739ae039,
        label: isOpen ? "Close menu" : "Open menu"
    });
};
const $fc6840133e04adc0$export$214ae410b202e65a = ({ leftItems: leftItems, rightItems: rightItems, logoItem: logoItem, isSticky: isSticky = true, onMenuToggleClick: onMenuToggleClick, onMenuOutsideClick: onMenuOutsideClick })=>{
    // open state of mobile/tablet menu
    const [isMenuOpen, setIsMenuOpen] = (0, $5FkrB.useState)(false);
    // ref for the toggle button - necessary for the useOutsideClickHandler
    // useOutsideClickHandler will close menu IF the user clicks outside of the menu or toggle button (necessary to include toggle button prevent double-click)
    // separately, toggle button (close button) should also close the menu
    const toggleRef = (0, $5FkrB.useRef)(null);
    const handleToggle = ()=>{
        setIsMenuOpen(!isMenuOpen);
        if (onMenuToggleClick) onMenuToggleClick(isMenuOpen);
    };
    return (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("nav", {
        css: [
            $fc6840133e04adc0$var$$25cbe9fdb2d8d071$var$containerStyles,
            !isSticky && $fc6840133e04adc0$var$$25cbe9fdb2d8d071$var$stickyStyles
        ],
        "data-testid": "navbar",
        children: (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
            css: $fc6840133e04adc0$var$$25cbe9fdb2d8d071$var$innerContainerStyles,
            children: [
                (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                    css: $fc6840133e04adc0$var$$25cbe9fdb2d8d071$var$logoWrapperStyles,
                    children: logoItem
                }),
                (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                    css: $fc6840133e04adc0$var$$25cbe9fdb2d8d071$var$navContentWrapperStyles,
                    children: (0, $6bec4f26b2cb3094$export$25062201e9e25d76)($fc6840133e04adc0$var$$ff532043ef39c56f$export$f5c7f2da77f7e7fd, {
                        children: [
                            leftItems || rightItems ? (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                                css: $fc6840133e04adc0$var$$25cbe9fdb2d8d071$var$navMenuToggleButtonStyles,
                                ref: toggleRef,
                                children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$var$$25cbe9fdb2d8d071$var$ToggleButton, {
                                    isOpen: isMenuOpen,
                                    toggleMenu: handleToggle
                                })
                            }) : null,
                            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$var$$25cbe9fdb2d8d071$var$DesktopNavItems, {
                                leftItems: leftItems,
                                rightItems: rightItems
                            }),
                            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$var$$25cbe9fdb2d8d071$var$SmallNavItems, {
                                isMenuOpen: isMenuOpen,
                                setIsMenuOpen: setIsMenuOpen,
                                onMenuOutsideClick: onMenuOutsideClick,
                                leftItems: leftItems,
                                rightItems: rightItems,
                                toggleRef: toggleRef
                            })
                        ]
                    })
                })
            ]
        })
    });
};
const $fc6840133e04adc0$var$$25cbe9fdb2d8d071$var$MenuItems = ({ leftItems: leftItems, rightItems: rightItems })=>(0, $6bec4f26b2cb3094$export$25062201e9e25d76)((0, $6bec4f26b2cb3094$export$ffb0004e005737fa), {
        children: [
            leftItems?.map((item, index)=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("li", {
                    css: [
                        $fc6840133e04adc0$var$$25cbe9fdb2d8d071$var$navItemWrapperStyles,
                        $fc6840133e04adc0$var$$25cbe9fdb2d8d071$var$leftItemStyles
                    ],
                    role: "menuitem",
                    children: item
                }, `left-${index}`)),
            rightItems?.map((item, index)=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("li", {
                    css: [
                        $fc6840133e04adc0$var$$25cbe9fdb2d8d071$var$navItemWrapperStyles,
                        $fc6840133e04adc0$var$$25cbe9fdb2d8d071$var$rightItemStyles
                    ],
                    role: "menuitem",
                    children: item
                }, `right-${index}`))
        ]
    });
const $fc6840133e04adc0$var$$25cbe9fdb2d8d071$var$DesktopNavItems = ({ leftItems: leftItems, rightItems: rightItems })=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("ul", {
        css: $fc6840133e04adc0$var$$25cbe9fdb2d8d071$var$desktopNavWrapperStyles,
        role: "menubar",
        "aria-orientation": "horizontal",
        children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$var$$25cbe9fdb2d8d071$var$MenuItems, {
            leftItems: leftItems,
            rightItems: rightItems
        })
    });
const $fc6840133e04adc0$var$$25cbe9fdb2d8d071$var$SmallNavItems = ({ isMenuOpen: isMenuOpen, setIsMenuOpen: setIsMenuOpen, onMenuOutsideClick: onMenuOutsideClick, leftItems: leftItems, rightItems: rightItems, toggleRef: toggleRef })=>{
    const navRef = (0, $5FkrB.useRef)(null);
    const menuRef = (0, $5FkrB.useRef)(null);
    const slideMenuWrapperRef = (0, $5FkrB.useRef)(null);
    const { isSlideMenuOpen: isSlideMenuOpen, containerHeight: containerHeight, closeSlideMenu: closeSlideMenu } = $fc6840133e04adc0$var$$ff532043ef39c56f$export$74d704c90f90362c();
    $fc6840133e04adc0$export$aa79b0abe3dfeaba([
        menuRef,
        slideMenuWrapperRef,
        toggleRef
    ], ()=>{
        if (isMenuOpen) {
            setIsMenuOpen(false);
            closeSlideMenu();
            if (onMenuOutsideClick) onMenuOutsideClick();
        }
    });
    return isMenuOpen ? (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
        ref: navRef,
        css: [
            $fc6840133e04adc0$var$$25cbe9fdb2d8d071$var$smallNavWrapperStyles,
            isSlideMenuOpen && (0, $74Zh5.css)({
                height: containerHeight
            })
        ],
        children: [
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                ref: slideMenuWrapperRef,
                css: [
                    $fc6840133e04adc0$var$$25cbe9fdb2d8d071$var$slideMenuStyles,
                    isSlideMenuOpen && $fc6840133e04adc0$var$$25cbe9fdb2d8d071$var$slideMenuOpenStyles,
                    !isSlideMenuOpen && $fc6840133e04adc0$var$$25cbe9fdb2d8d071$var$slideMenuClosedStyles
                ],
                children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$var$$e2bb601faa5fb56f$export$a24e9349d70a402, {
                    navRef: navRef
                })
            }),
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                css: [
                    $fc6840133e04adc0$var$$25cbe9fdb2d8d071$var$smallNavContentWrapperStyles,
                    isSlideMenuOpen && $fc6840133e04adc0$var$$25cbe9fdb2d8d071$var$smallNavContentShiftedStyles
                ],
                children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("ul", {
                    css: $fc6840133e04adc0$var$$25cbe9fdb2d8d071$var$smallNavUlStyles,
                    ref: menuRef,
                    role: "menubar",
                    "aria-orientation": "vertical",
                    children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$var$$25cbe9fdb2d8d071$var$MenuItems, {
                        leftItems: leftItems,
                        rightItems: rightItems
                    })
                })
            })
        ]
    }) : null;
};
const $fc6840133e04adc0$var$$25cbe9fdb2d8d071$var$navItemWrapperStyles = (0, $74Zh5.css)({
    height: "100%",
    alignSelf: "center",
    margin: "0 auto",
    padding: 0,
    [`@media (max-width: ${$fc6840133e04adc0$var$$f0285f05d4d9f8a0$export$426e07cd0772984d.TABLET.MAX_WIDTH}px)`]: {
        "& > button": {
            width: "100%",
            justifyContent: "center"
        }
    }
});
const $fc6840133e04adc0$var$$25cbe9fdb2d8d071$var$smallNavContentWrapperStyles = (0, $74Zh5.css)({
    position: "relative",
    transition: "transform 0.4s cubic-bezier(.5,1,.5,1)",
    zIndex: 1,
    borderRadius: "8px"
});
const $fc6840133e04adc0$var$$25cbe9fdb2d8d071$var$slideMenuOpenStyles = (0, $74Zh5.css)({
    transform: "translateX(0)",
    opacity: 1,
    [`@media (max-width: ${$fc6840133e04adc0$var$$f0285f05d4d9f8a0$export$426e07cd0772984d.MOBILE.MAX_WIDTH}px)`]: {
        transform: "translateX(100vw)",
        top: "56px"
    }
});
const $fc6840133e04adc0$var$$25cbe9fdb2d8d071$var$slideMenuClosedStyles = (0, $74Zh5.css)({
    transform: "translateX(-100%)",
    opacity: 0,
    [`@media (max-width: ${$fc6840133e04adc0$var$$f0285f05d4d9f8a0$export$426e07cd0772984d.MOBILE.MAX_WIDTH}px)`]: {
        transform: "translateX(-100vw)",
        top: "56px"
    }
});
const $fc6840133e04adc0$var$$25cbe9fdb2d8d071$var$smallNavContentShiftedStyles = (0, $74Zh5.css)({
    transform: `translateX(${$fc6840133e04adc0$var$$25cbe9fdb2d8d071$var$DRAWER_WIDTH}px)`,
    [`@media (max-width: ${$fc6840133e04adc0$var$$f0285f05d4d9f8a0$export$426e07cd0772984d.MOBILE.MAX_WIDTH}px)`]: {
        transform: "translateX(100vw)"
    }
});
const $fc6840133e04adc0$var$$25cbe9fdb2d8d071$var$slideMenuStyles = (0, $74Zh5.css)({
    position: "absolute",
    left: 0,
    top: 0,
    width: `${$fc6840133e04adc0$var$$25cbe9fdb2d8d071$var$DRAWER_WIDTH}px`,
    height: "100%",
    zIndex: 2,
    transition: "height 0.7s cubic-bezier(0.22, 1, 0.36, 1), transform 0.4s cubic-bezier(.5,1,.5,1), opacity 0.2s",
    transform: "translateX(-100%)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    [`@media (max-width: ${$fc6840133e04adc0$var$$f0285f05d4d9f8a0$export$426e07cd0772984d.MOBILE.MAX_WIDTH}px)`]: {
        width: "100vw",
        position: "fixed",
        borderRadius: 0,
        height: "100%"
    }
});
const $fc6840133e04adc0$var$$25cbe9fdb2d8d071$var$containerStyles = (0, $74Zh5.css)({
    backgroundColor: "#FFFFFF",
    position: "sticky",
    width: "100%",
    height: "68px",
    left: 0,
    top: 0,
    padding: "0 16px",
    zIndex: 100,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    [`@media (max-width: ${$fc6840133e04adc0$var$$f0285f05d4d9f8a0$export$426e07cd0772984d.TABLET.MAX_WIDTH}px)`]: {
        height: "56px",
        justifyContent: "space-between"
    }
});
const $fc6840133e04adc0$var$$25cbe9fdb2d8d071$var$stickyStyles = (0, $74Zh5.css)({
    position: "fixed"
});
const $fc6840133e04adc0$var$$25cbe9fdb2d8d071$var$innerContainerStyles = (0, $74Zh5.css)({
    display: "flex",
    alignItems: "center",
    width: "100%",
    maxWidth: "1232px",
    [`@media (min-width: ${$fc6840133e04adc0$var$$f0285f05d4d9f8a0$export$426e07cd0772984d.DESKTOP.MIN_WIDTH}px)`]: {
        width: "1232px"
    }
});
const $fc6840133e04adc0$var$$25cbe9fdb2d8d071$var$navContentWrapperStyles = (0, $74Zh5.css)({
    flex: 1,
    [`@media (max-width: ${$fc6840133e04adc0$var$$f0285f05d4d9f8a0$export$426e07cd0772984d.TABLET.MAX_WIDTH}px)`]: {
        display: "flex",
        flexDirection: "column"
    }
});
const $fc6840133e04adc0$var$$25cbe9fdb2d8d071$var$navMenuToggleButtonStyles = (0, $74Zh5.css)({
    flex: 0,
    alignSelf: "flex-end",
    [`@media (min-width: ${$fc6840133e04adc0$var$$f0285f05d4d9f8a0$export$426e07cd0772984d.DESKTOP.MIN_WIDTH}px)`]: {
        display: "none"
    },
    button: {
        "&:hover, &:active": {
            backgroundColor: "transparent",
            color: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.icon.brand")
        }
    }
});
const $fc6840133e04adc0$var$$25cbe9fdb2d8d071$var$desktopNavWrapperStyles = (0, $74Zh5.css)({
    backgroundColor: "#FFFFFF",
    listStyle: "none",
    display: "none",
    flexDirection: "column",
    width: "100%",
    padding: "16px 12px",
    margin: 0,
    [`@media (min-width: ${$fc6840133e04adc0$var$$f0285f05d4d9f8a0$export$426e07cd0772984d.DESKTOP.MIN_WIDTH}px)`]: {
        display: "block",
        position: "relative",
        gap: "8px",
        padding: 0,
        boxShadow: "none",
        height: "42px"
    }
});
// mobile/tablet open menu
const $fc6840133e04adc0$var$$25cbe9fdb2d8d071$var$smallNavWrapperStyles = (0, $74Zh5.css)({
    backgroundColor: "#FFFFFF",
    position: "absolute",
    right: 0,
    margin: 0,
    width: "100%",
    zIndex: 1000,
    overflow: "hidden",
    transition: "height 0.4s cubic-bezier(.5,1,.5,1)",
    [`@media (max-width: ${$fc6840133e04adc0$var$$f0285f05d4d9f8a0$export$426e07cd0772984d.MOBILE.MAX_WIDTH}px)`]: {
        // full screen menu in mobile view
        height: "100%",
        position: "fixed",
        right: 0,
        top: 0,
        marginTop: "56px"
    },
    [`@media ((min-width: ${$fc6840133e04adc0$var$$f0285f05d4d9f8a0$export$426e07cd0772984d.TABLET.MIN_WIDTH}px) and (max-width: ${$fc6840133e04adc0$var$$f0285f05d4d9f8a0$export$426e07cd0772984d.TABLET.MAX_WIDTH}px))`]: {
        // appearance of floating fixed-width menu in tablet view
        width: `${$fc6840133e04adc0$var$$25cbe9fdb2d8d071$var$DRAWER_WIDTH}px`,
        top: "100%",
        marginTop: "-9px",
        marginRight: "20px",
        borderRadius: "8px",
        boxShadow: "0 0 1px 0 #ccc,0 5px 20px -5px rgba(0,0,0,.1)"
    },
    [`@media (min-width: ${$fc6840133e04adc0$var$$f0285f05d4d9f8a0$export$426e07cd0772984d.DESKTOP.MIN_WIDTH}px)`]: {
        display: "none"
    }
});
const $fc6840133e04adc0$var$$25cbe9fdb2d8d071$var$smallNavUlStyles = (0, $74Zh5.css)({
    display: "flex",
    flexDirection: "column",
    gap: "16px",
    listStyle: "none",
    padding: "16px 0"
});
const $fc6840133e04adc0$var$$25cbe9fdb2d8d071$var$logoWrapperStyles = (0, $74Zh5.css)({
    margin: 0,
    padding: 0,
    paddingRight: "32px",
    flexShrink: 0,
    flexGrow: 0
});
const $fc6840133e04adc0$var$$25cbe9fdb2d8d071$var$leftItemStyles = (0, $74Zh5.css)({
    [`@media (max-width: ${$fc6840133e04adc0$var$$f0285f05d4d9f8a0$export$426e07cd0772984d.TABLET.MAX_WIDTH}px)`]: {
        alignSelf: "flex-start",
        width: "100%"
    },
    [`@media (min-width: ${$fc6840133e04adc0$var$$f0285f05d4d9f8a0$export$426e07cd0772984d.DESKTOP.MIN_WIDTH}px)`]: {
        float: "left",
        marginRight: "8px"
    }
});
const $fc6840133e04adc0$var$$25cbe9fdb2d8d071$var$rightItemStyles = (0, $74Zh5.css)({
    [`@media (max-width: ${$fc6840133e04adc0$var$$f0285f05d4d9f8a0$export$426e07cd0772984d.TABLET.MAX_WIDTH}px)`]: {
        width: "100%"
    },
    [`@media (min-width: ${$fc6840133e04adc0$var$$f0285f05d4d9f8a0$export$426e07cd0772984d.DESKTOP.MIN_WIDTH}px)`]: {
        float: "right"
    }
});
var $fc6840133e04adc0$var$$9efbb38deb40219f$exports = {};
$fc6840133e04adc0$var$$parcel$defineInteropFlag($fc6840133e04adc0$var$$9efbb38deb40219f$exports);
$fc6840133e04adc0$var$$parcel$export($fc6840133e04adc0$var$$9efbb38deb40219f$exports, "NavigationBarWithProfile", ()=>$fc6840133e04adc0$export$fddd19fbf4d591d8);
$fc6840133e04adc0$var$$parcel$export($fc6840133e04adc0$var$$9efbb38deb40219f$exports, "default", ()=>$fc6840133e04adc0$var$$9efbb38deb40219f$export$2e2bcd8739ae039);
/**
 * This file contains the sub-components that are wrapped with the OnClickWrapper component to send analytics events
 * with the relevant payload attributes.
 */ const $fc6840133e04adc0$var$$d97d6cd9a58d7e95$export$bb065923b9250b7b = ({ ...rest })=>{
    return (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$export$e76239e22e3abad, {
        ...rest
    });
};
/**
 * This is a wrapper component that allows passing in an onClick handler to a div. It can be used to wrap components
 * that are meant to be clicked (e.g. buttons and links), for additional click handling.
 */ const $fc6840133e04adc0$var$$d153af7a71e64fa7$export$9c92f94f6e99bc1a = ({ children: children, onClick: onClick })=>{
    const noOp = ()=>{};
    const handleKeyDown = $fc6840133e04adc0$export$2a0b6757d41dacb2(onClick || noOp);
    return (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("span", {
        role: "button",
        tabIndex: 0,
        onClick: onClick,
        onKeyDown: onClick ? handleKeyDown : undefined,
        children: children
    });
};
const $fc6840133e04adc0$var$$341f96d5922d8aaa$export$68280dacbbcb94bd = (payload, analyticsInfo)=>{
    return {
        ...payload,
        source: "communityNavigation",
        attributes: {
            ...payload.attributes || {},
            currentApp: analyticsInfo.currentApp,
            isLoggedIn: analyticsInfo.isLoggedIn,
            isNavMobileOrTablet: analyticsInfo.isMobileOrTablet
        }
    };
};
const $fc6840133e04adc0$var$$341f96d5922d8aaa$export$5aa64ab1f07d6e00 = ({ analyticsInfo: analyticsInfo, subtitleHref: subtitleHref, ...rest })=>{
    const getSendEventFn = (analyticsInfo)=>()=>{
            analyticsInfo.onAnalyticsSendEvent($fc6840133e04adc0$export$3d7865934588d77e.UI, $fc6840133e04adc0$var$$341f96d5922d8aaa$export$68280dacbbcb94bd({
                action: "clicked",
                actionSubject: "logo",
                actionSubjectId: "communityNavigationHome",
                attributes: {
                    href: subtitleHref,
                    destinationApp: $fc6840133e04adc0$export$93d048dc21eb282a.HOME
                }
            }, analyticsInfo), $fc6840133e04adc0$export$d778a884eb401313.NAV_LOGO_CLICK);
        };
    return (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$var$$d153af7a71e64fa7$export$9c92f94f6e99bc1a, {
        onClick: analyticsInfo && getSendEventFn(analyticsInfo),
        children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$export$6ce3be5638d8e2a, {
            subtitleHref: subtitleHref,
            ...rest
        })
    });
};
const $fc6840133e04adc0$var$$341f96d5922d8aaa$export$b18dbc162161ec9c = ({ analyticsInfo: analyticsInfo, destinationApp: destinationApp, link: link, ...rest })=>{
    const getSendEventFn = (analyticsInfo)=>()=>{
            analyticsInfo.onAnalyticsSendEvent($fc6840133e04adc0$export$3d7865934588d77e.UI, $fc6840133e04adc0$var$$341f96d5922d8aaa$export$68280dacbbcb94bd({
                action: "clicked",
                actionSubject: "link",
                actionSubjectId: "communityNavigationLink",
                attributes: {
                    href: link.href,
                    label: link.text,
                    destinationApp: destinationApp
                }
            }, analyticsInfo), $fc6840133e04adc0$export$d778a884eb401313.NAV_ITEM_CLICK);
        };
    return (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$var$$d153af7a71e64fa7$export$9c92f94f6e99bc1a, {
        onClick: analyticsInfo && getSendEventFn(analyticsInfo),
        children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$var$$d97d6cd9a58d7e95$export$bb065923b9250b7b, {
            link: link,
            destinationApp: destinationApp,
            ...rest
        })
    });
};
const $fc6840133e04adc0$var$$341f96d5922d8aaa$var$loginSignupWrapperStyles = (isMobile)=>isMobile ? (0, $74Zh5.css)({
        padding: "0 24px"
    }) : undefined;
const $fc6840133e04adc0$var$$341f96d5922d8aaa$var$loginButtonStyles = (isMobile)=>isMobile ? (0, $74Zh5.css)({
        button: {
            width: "100%",
            borderRadius: "0.25rem",
            borderStyle: "solid",
            borderWidth: "1px",
            fontSize: "1rem",
            fontWeight: 600,
            fontFamily: "Charlie Text",
            color: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.text.brand"),
            borderColor: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.border.brand"),
            "&:active": {
                backgroundColor: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.background.selected.bold.pressed"),
                borderColor: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.border.selected"),
                color: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.text.inverse")
            },
            "&:hover": {
                backgroundColor: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.background.selected.bold.hovered"),
                borderColor: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.border.selected"),
                color: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.text.inverse"),
                textDecoration: "none"
            }
        }
    }) : (0, $74Zh5.css)({
        button: {
            fontWeight: 650,
            fontFamily: "Charlie Text",
            fontSize: "1rem",
            color: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.text"),
            width: "auto",
            "&:hover": {
                backgroundColor: "transparent",
                color: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.text.brand"),
                textDecoration: "none"
            }
        }
    });
const $fc6840133e04adc0$var$$341f96d5922d8aaa$var$signupButtonStyles = (isMobile)=>(0, $74Zh5.css)({
        button: {
            fontWeight: 550,
            fontFamily: "Charlie Text",
            fontSize: "1rem",
            width: isMobile ? "100%" : "auto"
        }
    });
const $fc6840133e04adc0$var$$341f96d5922d8aaa$export$c421b2a9819014e7 = ({ href: href, analyticsInfo: analyticsInfo, isMobile: isMobile = false })=>{
    const getSendEventFn = (analyticsInfo)=>()=>{
            analyticsInfo.onAnalyticsSendEvent($fc6840133e04adc0$export$3d7865934588d77e.UI, $fc6840133e04adc0$var$$341f96d5922d8aaa$export$68280dacbbcb94bd({
                action: "clicked",
                actionSubject: "button",
                actionSubjectId: "communityNavigationLogin",
                attributes: {
                    href: href
                }
            }, analyticsInfo), $fc6840133e04adc0$export$d778a884eb401313.LOG_IN_CLICK);
        };
    return (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$var$$d153af7a71e64fa7$export$9c92f94f6e99bc1a, {
        onClick: analyticsInfo && getSendEventFn(analyticsInfo),
        children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
            css: $fc6840133e04adc0$var$$341f96d5922d8aaa$var$loginSignupWrapperStyles(isMobile),
            children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("a", {
                css: $fc6840133e04adc0$var$$341f96d5922d8aaa$var$loginButtonStyles(isMobile),
                href: href,
                children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $37328c3a94101dc2$export$2e2bcd8739ae039), {
                    appearance: "subtle",
                    children: $fc6840133e04adc0$var$$1ff01338112cd7fe$export$46dbfbdf99745111
                })
            })
        })
    });
};
const $fc6840133e04adc0$var$$341f96d5922d8aaa$export$5f193ccad31822c4 = ({ href: href, analyticsInfo: analyticsInfo, isMobile: isMobile = false })=>{
    const getSendEventFn = (analyticsInfo)=>()=>{
            analyticsInfo.onAnalyticsSendEvent($fc6840133e04adc0$export$3d7865934588d77e.UI, $fc6840133e04adc0$var$$341f96d5922d8aaa$export$68280dacbbcb94bd({
                action: "clicked",
                actionSubject: "button",
                actionSubjectId: "communityNavigationSignup",
                attributes: {
                    href: href
                }
            }, analyticsInfo), $fc6840133e04adc0$export$d778a884eb401313.SIGN_UP_CLICK);
        };
    return (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$var$$d153af7a71e64fa7$export$9c92f94f6e99bc1a, {
        onClick: analyticsInfo && getSendEventFn(analyticsInfo),
        children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
            css: $fc6840133e04adc0$var$$341f96d5922d8aaa$var$loginSignupWrapperStyles(isMobile),
            children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("a", {
                css: $fc6840133e04adc0$var$$341f96d5922d8aaa$var$signupButtonStyles(isMobile),
                href: href,
                children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $37328c3a94101dc2$export$2e2bcd8739ae039), {
                    appearance: "primary",
                    children: $fc6840133e04adc0$var$$1ff01338112cd7fe$export$4fe37309c24221ae
                })
            })
        })
    });
};
const $fc6840133e04adc0$var$$341f96d5922d8aaa$export$55b351f575b2f75b = ({ analyticsInfo: analyticsInfo, ...rest })=>{
    const getSendEventFn = (analyticsInfo)=>(isMenuOpen)=>{
            analyticsInfo.onAnalyticsSendEvent($fc6840133e04adc0$export$3d7865934588d77e.UI, $fc6840133e04adc0$var$$341f96d5922d8aaa$export$68280dacbbcb94bd({
                action: "clicked",
                actionSubject: "button",
                actionSubjectId: !isMenuOpen ? "communityNavigationProfileMenuOpen" : "communityNavigationProfileMenuClose"
            }, analyticsInfo), !isMenuOpen ? $fc6840133e04adc0$export$d778a884eb401313.PROFILE_MENU_OPEN : $fc6840133e04adc0$export$d778a884eb401313.PROFILE_MENU_CLOSE);
        };
    return (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$export$1cba3806e1f1b01d, {
        onProfileMenuClick: analyticsInfo && getSendEventFn(analyticsInfo),
        ...rest
    });
};
const $fc6840133e04adc0$export$92905cc84b82619c = ({ analyticsInfo: analyticsInfo, link: link, type: type, ...rest })=>{
    const getSendEventFn = (analyticsInfo)=>()=>{
            analyticsInfo.onAnalyticsSendEvent($fc6840133e04adc0$export$3d7865934588d77e.UI, $fc6840133e04adc0$var$$341f96d5922d8aaa$export$68280dacbbcb94bd({
                action: "clicked",
                actionSubject: "button",
                actionSubjectId: "communityNavigationMenuItem",
                attributes: {
                    href: link.href,
                    label: link.text,
                    menuItemId: link.id
                }
            }, analyticsInfo), $fc6840133e04adc0$export$d778a884eb401313.PROFILE_MENU_ITEM_CLICK);
        };
    return (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$var$$d153af7a71e64fa7$export$9c92f94f6e99bc1a, {
        onClick: analyticsInfo && getSendEventFn(analyticsInfo),
        children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$export$2ce376c2cc3355c8, {
            type: type,
            link: link,
            ...rest
        })
    });
};
const $fc6840133e04adc0$var$$341f96d5922d8aaa$export$86a131c9ca6f534a = ({ analyticsInfo: analyticsInfo, ...rest })=>{
    // event when clicking on the menu toggle button in mobile/tablet view
    const getSendEventMenuToggleFn = (analyticsInfo)=>(isMenuOpen)=>{
            analyticsInfo.onAnalyticsSendEvent($fc6840133e04adc0$export$3d7865934588d77e.UI, $fc6840133e04adc0$var$$341f96d5922d8aaa$export$68280dacbbcb94bd({
                action: "clicked",
                actionSubject: "button",
                actionSubjectId: !isMenuOpen ? "communityNavigationMobileMenuOpen" : "communityNavigationMobileMenuClose"
            }, analyticsInfo), !isMenuOpen ? $fc6840133e04adc0$export$d778a884eb401313.MOBILE_MENU_OPEN : $fc6840133e04adc0$export$d778a884eb401313.MOBILE_MENU_CLOSE);
        };
    // event when clicking outside of the menu in mobile/tablet view, which closes the menu
    const getSendEventOutsideClickFn = (analyticsInfo)=>()=>{
            analyticsInfo.onAnalyticsSendEvent($fc6840133e04adc0$export$3d7865934588d77e.UI, $fc6840133e04adc0$var$$341f96d5922d8aaa$export$68280dacbbcb94bd({
                action: "clicked",
                actionSubject: "component",
                actionSubjectId: "communityNavigationMobileMenuClose"
            }, analyticsInfo), $fc6840133e04adc0$export$d778a884eb401313.MOBILE_MENU_CLOSE);
        };
    return (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$export$214ae410b202e65a, {
        onMenuToggleClick: analyticsInfo && getSendEventMenuToggleFn(analyticsInfo),
        onMenuOutsideClick: analyticsInfo && getSendEventOutsideClickFn(analyticsInfo),
        ...rest
    });
};
const $fc6840133e04adc0$var$$9efbb38deb40219f$var$getUserDisplayMenuContent = (logoutHref, type, profileHref, settingsHref, switchHref, analyticsInfo)=>{
    const subMenuItems = [];
    if (profileHref) subMenuItems.push({
        ...$fc6840133e04adc0$var$$1ff01338112cd7fe$export$668d072b293d5f38.PROFILE,
        href: profileHref
    });
    if (settingsHref) subMenuItems.push({
        ...$fc6840133e04adc0$var$$1ff01338112cd7fe$export$668d072b293d5f38.SETTINGS,
        href: settingsHref
    });
    if (switchHref) subMenuItems.push({
        ...$fc6840133e04adc0$var$$1ff01338112cd7fe$export$668d072b293d5f38.SWITCH_ACCOUNT,
        href: switchHref
    });
    if (logoutHref) subMenuItems.push({
        ...$fc6840133e04adc0$var$$1ff01338112cd7fe$export$668d072b293d5f38.LOG_OUT,
        href: logoutHref
    });
    return (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $6bec4f26b2cb3094$export$ffb0004e005737fa), {
        children: subMenuItems.map((item, index)=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$export$92905cc84b82619c, {
                link: item,
                type: type,
                analyticsInfo: analyticsInfo
            }, `${item.text}-${index}`))
    });
};
const $fc6840133e04adc0$export$fddd19fbf4d591d8 = ({ logoItem: logoItem, leftItems: leftItems, isLoggedIn: isLoggedIn, user: user, loginHref: loginHref, signupHref: signupHref, logoutHref: logoutHref, switchHref: switchHref, profileHref: profileHref, settingsHref: settingsHref, onAnalyticsSendEvent: onAnalyticsSendEvent, isSticky: isSticky = true, showNewMenu: showNewMenu = false, currentApp: currentApp = "unknown" })=>{
    const isMobileOrTablet = $fc6840133e04adc0$export$32d5543ab307c01(`(max-width: ${$fc6840133e04adc0$var$$f0285f05d4d9f8a0$export$426e07cd0772984d.TABLET.MAX_WIDTH}px)`);
    // Set up analytics info
    const analyticsInfo = onAnalyticsSendEvent ? {
        currentApp: currentApp,
        isLoggedIn: isLoggedIn,
        isMobileOrTablet: isMobileOrTablet,
        onAnalyticsSendEvent: onAnalyticsSendEvent
    } : undefined;
    // Render right items based on login state
    const rightItems = [];
    if (isLoggedIn && user) rightItems.push((0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$var$$341f96d5922d8aaa$export$55b351f575b2f75b, {
        user: user,
        expandableMenuContent: $fc6840133e04adc0$var$$9efbb38deb40219f$var$getUserDisplayMenuContent(logoutHref, showNewMenu ? "menuItem" : "subMenu", profileHref, settingsHref, switchHref, analyticsInfo),
        profileMenuContent: $fc6840133e04adc0$var$$9efbb38deb40219f$var$getUserDisplayMenuContent(logoutHref, "profile", profileHref, settingsHref, switchHref, analyticsInfo),
        analyticsInfo: analyticsInfo,
        showNewMenu: showNewMenu
    }));
    else if (isMobileOrTablet) rightItems.push((0, $6bec4f26b2cb3094$export$25062201e9e25d76)((0, $59963e1859b942f0$export$2e2bcd8739ae039), {
        space: "space.100",
        children: [
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$var$$341f96d5922d8aaa$export$c421b2a9819014e7, {
                href: loginHref,
                analyticsInfo: analyticsInfo,
                isMobile: isMobileOrTablet
            }),
            signupHref && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$var$$341f96d5922d8aaa$export$5f193ccad31822c4, {
                href: signupHref,
                analyticsInfo: analyticsInfo,
                isMobile: isMobileOrTablet
            })
        ]
    }));
    else rightItems.push((0, $6bec4f26b2cb3094$export$25062201e9e25d76)((0, $d363f694d5e41fc5$export$2e2bcd8739ae039), {
        space: "space.100",
        children: [
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$var$$341f96d5922d8aaa$export$c421b2a9819014e7, {
                href: loginHref,
                analyticsInfo: analyticsInfo
            }),
            signupHref && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$var$$341f96d5922d8aaa$export$5f193ccad31822c4, {
                href: signupHref,
                analyticsInfo: analyticsInfo
            })
        ]
    }));
    return (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$var$$341f96d5922d8aaa$export$86a131c9ca6f534a, {
        logoItem: logoItem,
        leftItems: leftItems,
        rightItems: rightItems,
        analyticsInfo: analyticsInfo,
        isSticky: isSticky
    });
};
var $fc6840133e04adc0$var$$9efbb38deb40219f$export$2e2bcd8739ae039 = $fc6840133e04adc0$export$fddd19fbf4d591d8;
var $fc6840133e04adc0$var$$3fbcb32390ca7008$exports = {};
$fc6840133e04adc0$var$$parcel$export($fc6840133e04adc0$var$$3fbcb32390ca7008$exports, "RadioType", ()=>$fc6840133e04adc0$export$f5eff9f4cffe1e46);
$fc6840133e04adc0$var$$parcel$export($fc6840133e04adc0$var$$3fbcb32390ca7008$exports, "RadioSize", ()=>$fc6840133e04adc0$export$4da24539a3bb7d98);
$fc6840133e04adc0$var$$parcel$export($fc6840133e04adc0$var$$3fbcb32390ca7008$exports, "Radio", ()=>$fc6840133e04adc0$export$d7b12c4107be0d61);
let $fc6840133e04adc0$export$f5eff9f4cffe1e46;
(function(RadioType) {
    RadioType["DEFAULT"] = "DEFAULT";
    RadioType[/** TODO: remove success styles in scope of the QUIZ component update */ "SUCCESS"] = "SUCCESS";
    RadioType["DANGER"] = "DANGER";
    RadioType["DISABLED"] = "DISABLED";
})($fc6840133e04adc0$export$f5eff9f4cffe1e46 || ($fc6840133e04adc0$export$f5eff9f4cffe1e46 = {}));
let $fc6840133e04adc0$export$4da24539a3bb7d98;
(function(RadioSize) {
    RadioSize["DEFAULT"] = "DEFAULT";
    RadioSize["LARGE"] = "LARGE";
})($fc6840133e04adc0$export$4da24539a3bb7d98 || ($fc6840133e04adc0$export$4da24539a3bb7d98 = {}));
const $fc6840133e04adc0$export$d7b12c4107be0d61 = ({ label: label = "", name: name, isChecked: isChecked, setIsChecked: setIsChecked, type: type = $fc6840133e04adc0$export$f5eff9f4cffe1e46.DEFAULT, size: size = $fc6840133e04adc0$export$4da24539a3bb7d98.DEFAULT, isRequired: isRequired = false, isBold: isBold, tabIndex: tabIndex = 0 })=>{
    const handleChange = (0, $5FkrB.useCallback)(()=>{
        setIsChecked(!isChecked);
    }, [
        isChecked,
        setIsChecked
    ]);
    const handleKeyDown = $fc6840133e04adc0$export$2a0b6757d41dacb2(handleChange);
    const labelAndInputConnection = name ? `${name}-${label?.toLowerCase().replace(/\s+/g, "-")}` + "-radio-input" : label?.toLowerCase().replace(/\s+/g, "-") + "-radio-input";
    return (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
        css: [
            $fc6840133e04adc0$var$$3fbcb32390ca7008$var$radioContainerStyles,
            size === $fc6840133e04adc0$export$4da24539a3bb7d98.LARGE && (0, $74Zh5.css)({
                columnGap: "8px"
            })
        ],
        children: (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("label", {
            htmlFor: labelAndInputConnection,
            css: [
                $fc6840133e04adc0$var$$3fbcb32390ca7008$var$labelStyles,
                size === $fc6840133e04adc0$export$4da24539a3bb7d98.LARGE && $fc6840133e04adc0$var$$3fbcb32390ca7008$var$labelLargeStyles,
                type === $fc6840133e04adc0$export$f5eff9f4cffe1e46.DISABLED && $fc6840133e04adc0$var$$3fbcb32390ca7008$var$variantClasses.label.DISABLED,
                isBold && (0, $74Zh5.css)({
                    fontWeight: 700
                }),
                !isBold && (0, $74Zh5.css)({
                    fontWeight: 400
                })
            ],
            children: [
                (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("input", {
                    "data-testid": "radio-input",
                    name: name,
                    tabIndex: -1,
                    id: labelAndInputConnection,
                    type: "radio",
                    css: $fc6840133e04adc0$var$$3fbcb32390ca7008$var$inputStyles,
                    checked: isChecked,
                    onChange: (e)=>setIsChecked(e.currentTarget.checked),
                    "aria-checked": isChecked
                }),
                (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$export$e61786c4aee8d415, {
                    children: label
                }),
                (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("span", {
                    role: "radio",
                    "aria-checked": isChecked,
                    "aria-label": label,
                    tabIndex: tabIndex,
                    onKeyDown: handleKeyDown,
                    css: [
                        $fc6840133e04adc0$var$$3fbcb32390ca7008$var$variantClasses.checkbox[type],
                        $fc6840133e04adc0$var$$3fbcb32390ca7008$var$checkmarkStyles,
                        size === $fc6840133e04adc0$export$4da24539a3bb7d98.LARGE && $fc6840133e04adc0$var$$3fbcb32390ca7008$var$checkmarkLargeStyles,
                        isChecked && $fc6840133e04adc0$var$$3fbcb32390ca7008$var$checkedCheckmarkStyles,
                        isChecked && type === $fc6840133e04adc0$export$f5eff9f4cffe1e46.DANGER && (0, $74Zh5.css)({
                            backgroundColor: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.border.danger")
                        })
                    ]
                }),
                isRequired && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("span", {
                    css: [
                        $fc6840133e04adc0$var$$3fbcb32390ca7008$var$requiredMarkStyles,
                        size === $fc6840133e04adc0$export$4da24539a3bb7d98.LARGE && (0, $74Zh5.css)({
                            marginLeft: "4px"
                        })
                    ],
                    children: "*"
                })
            ]
        })
    });
};
const $fc6840133e04adc0$var$$3fbcb32390ca7008$var$radioContainerStyles = (0, $74Zh5.css)({
    display: "flex",
    columnGap: "6px"
});
const $fc6840133e04adc0$var$$3fbcb32390ca7008$var$requiredMarkStyles = (0, $74Zh5.css)({
    color: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.text.subtle"),
    marginLeft: "2px"
});
const $fc6840133e04adc0$var$$3fbcb32390ca7008$var$inputStyles = (0, $74Zh5.css)({
    position: "absolute",
    height: 0,
    width: 0,
    opacity: 0,
    cursor: "pointer"
});
const $fc6840133e04adc0$var$$3fbcb32390ca7008$var$checkmarkStyles = (0, $74Zh5.css)({
    position: "absolute",
    top: 0,
    left: 0,
    width: "16px",
    height: "16px",
    marginTop: "2px",
    backgroundColor: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.background.input"),
    borderRadius: "50%",
    border: `1px solid ${(0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.border.input")}`,
    cursor: "pointer",
    "&:after": {
        content: '""',
        position: "absolute",
        display: "none"
    },
    [(0, $0bc19dfefbafca8c$export$987d49ffe1b0900f).below.xs]: {
        marginTop: "4px"
    }
});
const $fc6840133e04adc0$var$$3fbcb32390ca7008$var$checkmarkLargeStyles = (0, $74Zh5.css)({
    width: "20px",
    height: "20px",
    marginRight: "8px",
    marginTop: "6px",
    "&:after": {
        left: "5px !important",
        top: "5px !important",
        width: "8px !important",
        height: "8px !important"
    }
});
const $fc6840133e04adc0$var$$3fbcb32390ca7008$var$checkedCheckmarkStyles = (0, $74Zh5.css)({
    backgroundColor: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.background.selected.bold"),
    borderColor: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.border.selected"),
    "&:after": {
        display: "block",
        left: "4px",
        top: "4px",
        width: "6px",
        height: "6px",
        borderRadius: "50%",
        backgroundColor: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.background.input")
    }
});
const $fc6840133e04adc0$var$$3fbcb32390ca7008$var$labelStyles = (0, $74Zh5.css)({
    display: "flex",
    position: "relative",
    paddingLeft: "22px",
    userSelect: "none",
    color: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.text"),
    fontFamily: "Inter, sans-serif",
    fontSize: "16px",
    fontWeight: 400,
    lineHeight: "22px"
});
const $fc6840133e04adc0$var$$3fbcb32390ca7008$var$labelLargeStyles = (0, $74Zh5.css)({
    paddingLeft: "28px",
    fontSize: "20px",
    lineHeight: "32px"
});
const $fc6840133e04adc0$var$$3fbcb32390ca7008$var$variantClasses = {
    label: {
        DISABLED: (0, $74Zh5.css)({
            pointerEvents: "none",
            opacity: "31%"
        })
    },
    checkbox: {
        DEFAULT: (0, $74Zh5.css)({
            ":hover": {
                borderColor: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.border.selected")
            }
        }),
        SUCCESS: (0, $74Zh5.css)({
            ":hover": {
                borderColor: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.border.selected")
            }
        }),
        DANGER: (0, $74Zh5.css)({
            "&, &:hover": {
                borderColor: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.border.danger")
            }
        }),
        DISABLED: (0, $74Zh5.css)({
            pointerEvents: "none",
            opacity: "31%"
        })
    }
};
var $fc6840133e04adc0$var$$731a4fd527bab680$exports = {};
$fc6840133e04adc0$var$$parcel$export($fc6840133e04adc0$var$$731a4fd527bab680$exports, "TabsSize", ()=>$fc6840133e04adc0$export$ddadc1228c8dcfa);
$fc6840133e04adc0$var$$parcel$export($fc6840133e04adc0$var$$731a4fd527bab680$exports, "Tab", ()=>$fc6840133e04adc0$export$3e41faf802a29e71);
let $fc6840133e04adc0$export$ddadc1228c8dcfa;
(function(TabsSize) {
    TabsSize["SMALL"] = "small";
    TabsSize["MEDIUM"] = "medium";
    TabsSize["LARGE"] = "large";
})($fc6840133e04adc0$export$ddadc1228c8dcfa || ($fc6840133e04adc0$export$ddadc1228c8dcfa = {}));
const $fc6840133e04adc0$export$3e41faf802a29e71 = ({ label: label, labelColor: labelColor = (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.text"), labelColorSelected: labelColorSelected = (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.text.inverse"), labelColorSelectedHover: labelColorSelectedHover = (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.text.inverse"), onClick: onClick, iconBefore: iconBefore, iconAfter: iconAfter, size: size = $fc6840133e04adc0$export$ddadc1228c8dcfa.MEDIUM, selected: selected = false, selectedColor: selectedColor, selectedHoverColor: selectedHoverColor, isLoading: isLoading })=>{
    const clickHandler = (0, $5FkrB.useCallback)((e)=>{
        if (onClick) onClick(e);
    }, [
        onClick
    ]);
    return (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("button", {
        tabIndex: 0,
        onClick: clickHandler,
        "data-testid": `tab${selected ? "-selected" : ""}`,
        css: [
            $fc6840133e04adc0$var$$731a4fd527bab680$var$tabStyles["basic"],
            selected && $fc6840133e04adc0$var$$731a4fd527bab680$var$tabStyles["selected"],
            !iconBefore && !iconAfter && $fc6840133e04adc0$var$$731a4fd527bab680$var$tabSpacingStyles[size],
            iconBefore && $fc6840133e04adc0$var$$731a4fd527bab680$var$tabSpacingStyles[`${size}-icon-before`],
            iconAfter && $fc6840133e04adc0$var$$731a4fd527bab680$var$tabSpacingStyles[`${size}-icon-after`],
            labelColor && !selected && (0, $74Zh5.css)({
                color: labelColor
            }),
            labelColorSelected && selected && (0, $74Zh5.css)({
                color: labelColorSelected
            }),
            labelColorSelectedHover && selected && (0, $74Zh5.css)({
                "&:hover": {
                    color: labelColorSelectedHover
                }
            }),
            selected && selectedColor && (0, $74Zh5.css)({
                backgroundColor: selectedColor,
                borderColor: selectedColor
            }),
            selected && selectedHoverColor && (0, $74Zh5.css)({
                "&:hover": {
                    backgroundColor: selectedHoverColor,
                    borderColor: selectedHoverColor
                }
            })
        ],
        children: [
            iconBefore && !isLoading && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("span", {
                css: [
                    $fc6840133e04adc0$var$$731a4fd527bab680$var$tabIconContainerStyles,
                    (0, $74Zh5.css)({
                        marginRight: "0.25rem"
                    })
                ],
                children: iconBefore
            }),
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("span", {
                css: [
                    isLoading && (0, $74Zh5.css)({
                        marginRight: "0.5rem"
                    })
                ],
                children: label
            }),
            iconAfter && !isLoading && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("span", {
                css: [
                    $fc6840133e04adc0$var$$731a4fd527bab680$var$tabIconContainerStyles,
                    (0, $74Zh5.css)({
                        marginLeft: "0.25rem"
                    })
                ],
                children: iconAfter
            })
        ]
    });
};
const $fc6840133e04adc0$var$$731a4fd527bab680$var$tabStyles = {
    basic: (0, $74Zh5.css)({
        display: "flex",
        alignItems: "center",
        whiteSpace: "nowrap",
        borderRadius: "3.125rem",
        fontFamily: "Charlie Display, sans-serif",
        fontSize: "1.25rem",
        fontWeight: 600,
        lineHeight: "1.75rem",
        color: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.text"),
        border: `0.125rem solid ${(0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.border")}`,
        cursor: "pointer",
        outline: "none",
        background: "transparent",
        [(0, $0bc19dfefbafca8c$export$987d49ffe1b0900f).below.xs]: {
            fontSize: "1rem",
            lineHeight: "1.5rem",
            padding: "0.5rem 1rem"
        },
        "&:hover": {
            backgroundColor: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.background.accent.gray.subtlest"),
            borderColor: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.border"),
            color: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.text")
        },
        "&:focus-visible": {
            border: `2px solid ${(0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.border.selected")}`
        }
    }),
    selected: (0, $74Zh5.css)({
        backgroundColor: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.background.neutral.bold.pressed"),
        color: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.text.inverse"),
        border: "0.125rem solid",
        "&:hover": {
            backgroundColor: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.background.brand.boldest"),
            color: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.text.inverse"),
            border: "0.125rem solid"
        }
    })
};
const $fc6840133e04adc0$var$$731a4fd527bab680$var$tabSpacingStyles = {
    small: (0, $74Zh5.css)({
        padding: `${(0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.050")} ${(0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.300")}`,
        [(0, $0bc19dfefbafca8c$export$987d49ffe1b0900f).below.xs]: {
            padding: `${(0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.050")} ${(0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.300")}`
        }
    }),
    "small-icon-before": (0, $74Zh5.css)({
        padding: "0.375rem 1rem 0.375rem 0.5rem"
    }),
    "small-icon-after": (0, $74Zh5.css)({
        padding: "0.375rem 0.5rem 0.375rem 1rem"
    }),
    medium: (0, $74Zh5.css)({
        padding: "0.375rem 1.5rem"
    }),
    "medium-icon-before": (0, $74Zh5.css)({
        padding: "0.375rem 1.5rem 0.375rem 1rem"
    }),
    "medium-icon-after": (0, $74Zh5.css)({
        padding: "0.375rem 1rem 0.375rem 1.5rem"
    }),
    large: (0, $74Zh5.css)({
        padding: "0.625rem 1.5rem"
    }),
    "large-icon-before": (0, $74Zh5.css)({
        padding: "0.625rem 1.5rem 0.625rem 1rem"
    }),
    "large-icon-after": (0, $74Zh5.css)({
        padding: "0.625rem 1rem 0.625rem 1.5rem"
    })
};
const $fc6840133e04adc0$var$$731a4fd527bab680$var$tabIconContainerStyles = (0, $74Zh5.css)({
    width: "2rem",
    height: "2rem",
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
});
var $fc6840133e04adc0$var$$5cf70e33bfc6ce73$exports = {};
$fc6840133e04adc0$var$$parcel$export($fc6840133e04adc0$var$$5cf70e33bfc6ce73$exports, "Tag", ()=>$fc6840133e04adc0$export$3288d34c523a1192);
$fc6840133e04adc0$var$$parcel$export($fc6840133e04adc0$var$$5cf70e33bfc6ce73$exports, "tagListStyles", ()=>$fc6840133e04adc0$export$f40d73b6f7f951e9);
const $fc6840133e04adc0$export$3288d34c523a1192 = ({ inspectMode: inspectMode, label: label, onClick: onClick, selected: selected, iconAfter: iconAfter, iconBefore: iconBefore, isLarge: isLarge, isTall: isTall, labelColor: labelColor, borderColor: borderColor, backgroundColor: backgroundColor })=>{
    const customStyles = (0, $74Zh5.css)({
        ...labelColor && {
            color: labelColor
        },
        ...borderColor && {
            borderColor: borderColor
        },
        ...backgroundColor && {
            backgroundColor: backgroundColor
        }
    });
    const noOp = ()=>{};
    const onKeyDown = $fc6840133e04adc0$export$2a0b6757d41dacb2(onClick || noOp);
    return (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
        ...$fc6840133e04adc0$export$1784ac302bd8ebad("tag", inspectMode),
        role: onClick ? "button" : undefined,
        tabIndex: onClick ? 0 : -1,
        css: [
            $fc6840133e04adc0$var$$5cf70e33bfc6ce73$var$tagStyles,
            selected && $fc6840133e04adc0$var$$5cf70e33bfc6ce73$var$selectedTagStyles,
            onClick && $fc6840133e04adc0$var$$5cf70e33bfc6ce73$var$hoverableTagStyles,
            iconBefore && $fc6840133e04adc0$var$$5cf70e33bfc6ce73$var$beforeIconTagStyles,
            iconAfter && $fc6840133e04adc0$var$$5cf70e33bfc6ce73$var$afterIconTagStyles,
            isLarge && $fc6840133e04adc0$var$$5cf70e33bfc6ce73$var$largeTagStyles,
            isTall && $fc6840133e04adc0$var$$5cf70e33bfc6ce73$var$tallTagStyles,
            customStyles
        ],
        onClick: onClick,
        onKeyDown: onClick ? onKeyDown : undefined,
        children: [
            iconBefore && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("span", {
                css: [
                    $fc6840133e04adc0$var$$5cf70e33bfc6ce73$var$iconStyles,
                    $fc6840133e04adc0$var$$5cf70e33bfc6ce73$var$beforeIconStyles
                ],
                children: iconBefore
            }),
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("span", {
                css: [
                    isLarge && $fc6840133e04adc0$var$$5cf70e33bfc6ce73$var$largeTagTextStyles,
                    labelColor && (0, $74Zh5.css)({
                        color: labelColor
                    })
                ],
                children: label
            }),
            iconAfter && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("span", {
                css: [
                    $fc6840133e04adc0$var$$5cf70e33bfc6ce73$var$iconStyles,
                    $fc6840133e04adc0$var$$5cf70e33bfc6ce73$var$afterIconStyles
                ],
                children: iconAfter
            })
        ]
    });
};
const $fc6840133e04adc0$export$f40d73b6f7f951e9 = (0, $74Zh5.css)({
    display: "flex",
    flexWrap: "wrap",
    gap: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.100")
});
const $fc6840133e04adc0$var$$5cf70e33bfc6ce73$var$tagStyles = (0, $74Zh5.css)({
    display: "flex",
    height: "24px",
    padding: `4px ${(0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.100")}`,
    border: `1px solid ${(0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.border")}`,
    borderRadius: "4px",
    alignItems: "center",
    fontFamily: "Charlie Text, sans-serif",
    fontSize: "12px",
    fontWeight: 600,
    lineHeight: "16px",
    textTransform: "uppercase",
    color: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.text"),
    backgroundColor: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.background.input"),
    boxSizing: "border-box",
    whiteSpace: "nowrap"
});
const $fc6840133e04adc0$var$$5cf70e33bfc6ce73$var$hoverableTagStyles = (0, $74Zh5.css)({
    "&:hover": {
        borderColor: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.border.accent.gray"),
        cursor: "pointer"
    }
});
const $fc6840133e04adc0$var$$5cf70e33bfc6ce73$var$selectedTagStyles = (0, $74Zh5.css)({
    borderColor: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.border.selected")
});
const $fc6840133e04adc0$var$$5cf70e33bfc6ce73$var$iconStyles = (0, $74Zh5.css)({
    span: {
        width: "14px",
        height: "14px",
        marginBottom: "2px"
    }
});
const $fc6840133e04adc0$var$$5cf70e33bfc6ce73$var$beforeIconStyles = (0, $74Zh5.css)({
    marginRight: "0.125rem"
});
const $fc6840133e04adc0$var$$5cf70e33bfc6ce73$var$afterIconStyles = (0, $74Zh5.css)({
    marginLeft: "0.125rem"
});
const $fc6840133e04adc0$var$$5cf70e33bfc6ce73$var$beforeIconTagStyles = (0, $74Zh5.css)({
    paddingLeft: "0.375rem"
});
const $fc6840133e04adc0$var$$5cf70e33bfc6ce73$var$afterIconTagStyles = (0, $74Zh5.css)({
    paddingRight: "0.375rem"
});
const $fc6840133e04adc0$var$$5cf70e33bfc6ce73$var$largeTagStyles = (0, $74Zh5.css)({
    display: "flex",
    height: "32px",
    padding: `${(0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.075")} ${(0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.100")}`,
    justifyContent: "center",
    alignItems: "center",
    borderRadius: "4px",
    border: `1px solid ${(0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.border")}`,
    background: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.background.input"),
    textTransform: "uppercase",
    color: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.text"),
    backgroundColor: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.background.input"),
    boxSizing: "border-box",
    whiteSpace: "nowrap"
});
const $fc6840133e04adc0$var$$5cf70e33bfc6ce73$var$largeTagTextStyles = (0, $74Zh5.css)({
    color: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.text"),
    textAlign: "center",
    fontFeatureSettings: "'liga' off, 'clig' off",
    fontFamily: 'var(--Font-Family-Eyebrow, "Charlie Text")',
    fontSize: "12px",
    fontStyle: "normal",
    fontWeight: 600,
    lineHeight: "16px",
    textTransform: "uppercase"
});
const $fc6840133e04adc0$var$$5cf70e33bfc6ce73$var$tallTagStyles = (0, $74Zh5.css)({
    paddingTop: "6px",
    paddingBottom: "6px",
    paddingLeft: "6px",
    paddingRight: "6px",
    height: "auto"
});
var $fc6840133e04adc0$var$$8b54d37779d052e8$exports = {};
$fc6840133e04adc0$var$$parcel$export($fc6840133e04adc0$var$$8b54d37779d052e8$exports, "Text", ()=>$fc6840133e04adc0$export$5f1af8db9871e1d6);
const $fc6840133e04adc0$export$5f1af8db9871e1d6 = ({ fontWeight: fontWeight = "regular", size: size = "regular", color: color = (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.text.accent.gray.bolder"), children: children, backgroundColor: backgroundColor })=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("span", {
        css: [
            $fc6840133e04adc0$var$$8b54d37779d052e8$var$textDefaultStyles,
            backgroundColor && (0, $74Zh5.css)({
                backgroundColor: backgroundColor,
                padding: "4px"
            }),
            color && (0, $74Zh5.css)({
                color: color
            }),
            $fc6840133e04adc0$var$$8b54d37779d052e8$var$variantsStyles.fontWeight[fontWeight],
            $fc6840133e04adc0$var$$8b54d37779d052e8$var$variantsStyles.size[size]
        ],
        children: children
    });
const $fc6840133e04adc0$var$$8b54d37779d052e8$var$textDefaultStyles = (0, $74Zh5.css)({
    fontFamily: "Inter, sans-serif",
    blockquote: $fc6840133e04adc0$export$7a77f8e9665fa6b2,
    ul: $fc6840133e04adc0$export$6427468642e6e9fe.list.unordered,
    ol: $fc6840133e04adc0$export$6427468642e6e9fe.list.ordered
});
const $fc6840133e04adc0$var$$8b54d37779d052e8$var$variantsStyles = {
    size: {
        small: (0, $74Zh5.css)({
            fontSize: "14px",
            lineHeight: "20px",
            [(0, $0bc19dfefbafca8c$export$987d49ffe1b0900f).above.sm]: {
                fontSize: "14px",
                lineHeight: "20px"
            }
        }),
        regular: (0, $74Zh5.css)({
            fontSize: "14px",
            lineHeight: "22px",
            [(0, $0bc19dfefbafca8c$export$987d49ffe1b0900f).above.sm]: {
                fontSize: "16px",
                lineHeight: "24px"
            }
        }),
        large: (0, $74Zh5.css)({
            fontSize: "16px",
            lineHeight: "24px",
            [(0, $0bc19dfefbafca8c$export$987d49ffe1b0900f).above.sm]: {
                fontSize: "20px",
                lineHeight: "32px"
            }
        })
    },
    fontWeight: {
        regular: (0, $74Zh5.css)({
            fontWeight: 400
        }),
        semibold: (0, $74Zh5.css)({
            fontWeight: 600
        }),
        bold: (0, $74Zh5.css)({
            fontWeight: 700
        })
    }
};
var $fc6840133e04adc0$var$$9cfa05d02afa3952$exports = {};
$fc6840133e04adc0$var$$parcel$export($fc6840133e04adc0$var$$9cfa05d02afa3952$exports, "AccordionSize", ()=>$fc6840133e04adc0$export$8f89d78db9c8c41f);
$fc6840133e04adc0$var$$parcel$export($fc6840133e04adc0$var$$9cfa05d02afa3952$exports, "Accordion", ()=>$fc6840133e04adc0$export$a766cd26d0d69044);
const $fc6840133e04adc0$var$$51f57eef4d47f918$var$NAVBAR_HEIGHT = 124;
const $fc6840133e04adc0$var$$51f57eef4d47f918$export$10e5e64ea66c812f = ({ title: title, index: index, children: children, isFirstTab: isFirstTab, isExpanded: isExpanded, shouldSingleTabBeOpen: shouldSingleTabBeOpen, setTabState: setTabState, setExpansionMap: setExpansionMap })=>{
    const tabRef = (0, $5FkrB.useRef)(null);
    const handleExpand = (0, $5FkrB.useCallback)(()=>{
        if (!setExpansionMap) return;
        setExpansionMap((prevState)=>prevState.map((tab, i)=>{
                if (setTabState && index !== undefined && i === index) setTabState({
                    [index + 1]: !tab.isExpanded ? "expand" : "collapse"
                });
                return {
                    ...tab,
                    isExpanded: i === index ? !tab.isExpanded : shouldSingleTabBeOpen ? false : tab.isExpanded
                };
            }));
    }, [
        index,
        setExpansionMap,
        setTabState,
        shouldSingleTabBeOpen
    ]);
    const disableClickEventBubbling = (event)=>event.stopPropagation();
    const handleKeyDown = (0, $5FkrB.useCallback)((event)=>{
        if (event.code === "Space") {
            // to handle cases when there are clickable items within accordion
            if (event.target !== event.currentTarget) {
                event.preventDefault();
                event.stopPropagation();
            } else {
                event.preventDefault();
                handleExpand();
            }
        }
    }, [
        handleExpand
    ]);
    (0, $5FkrB.useEffect)(()=>{
        if (isExpanded && tabRef.current) {
            const topPosition = tabRef.current.getBoundingClientRect().top + window.scrollY - $fc6840133e04adc0$var$$51f57eef4d47f918$var$NAVBAR_HEIGHT;
            window.scrollTo({
                top: topPosition,
                behavior: "smooth"
            });
        }
    }, [
        isExpanded
    ]);
    return (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
        role: "button",
        tabIndex: 0,
        ref: tabRef,
        onKeyDown: handleKeyDown,
        css: [
            $fc6840133e04adc0$var$$51f57eef4d47f918$var$accordionTabStyles,
            isFirstTab && $fc6840133e04adc0$var$$51f57eef4d47f918$var$firstTabStyles,
            isExpanded && $fc6840133e04adc0$var$$51f57eef4d47f918$var$expandedTabStyles
        ],
        onClick: handleExpand,
        "data-testid": `accordion-tab-${title}`,
        children: [
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                css: [
                    isExpanded && $fc6840133e04adc0$var$$51f57eef4d47f918$var$expandedTabContentStyles
                ],
                children: isExpanded ? (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$export$f04a61298a47a40f, {
                    type: "chevron-down",
                    alt: "Chevron down"
                }) : (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$export$f04a61298a47a40f, {
                    type: "chevron-right",
                    alt: "Chevron right"
                })
            }),
            (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                css: $fc6840133e04adc0$var$$51f57eef4d47f918$var$contentContainer,
                children: [
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("p", {
                        css: $fc6840133e04adc0$var$$51f57eef4d47f918$var$titleStyles,
                        children: title
                    }),
                    isExpanded && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                        role: "button",
                        tabIndex: 0,
                        onClick: disableClickEventBubbling,
                        onKeyDown: (e)=>{
                            if (e.key === "Enter" || e.key === " ") {
                                e.preventDefault();
                                e.stopPropagation();
                            }
                        },
                        css: $fc6840133e04adc0$var$$51f57eef4d47f918$var$contentStyles,
                        "data-testid": "accordion-tab-content",
                        children: children
                    })
                ]
            })
        ]
    });
};
const $fc6840133e04adc0$var$$51f57eef4d47f918$var$accordionTabStyles = (0, $74Zh5.css)({
    display: "flex",
    width: "100%",
    alignContent: "center",
    alignItems: "flex-start",
    padding: "24px",
    cursor: "pointer",
    borderBottom: `1px solid ${(0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.border")}`
});
const $fc6840133e04adc0$var$$51f57eef4d47f918$var$firstTabStyles = (0, $74Zh5.css)({
    borderTop: `1px solid ${(0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.border")}`
});
const $fc6840133e04adc0$var$$51f57eef4d47f918$var$expandedTabStyles = (0, $74Zh5.css)({
    borderLeft: `${(0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.100")} solid ${(0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.border.accent.blue")}`
});
const $fc6840133e04adc0$var$$51f57eef4d47f918$var$expandedTabContentStyles = (0, $74Zh5.css)({
    marginLeft: "-0.5rem"
});
const $fc6840133e04adc0$var$$51f57eef4d47f918$var$contentContainer = (0, $74Zh5.css)({
    marginLeft: "0.75rem"
});
const $fc6840133e04adc0$var$$51f57eef4d47f918$var$titleStyles = (0, $74Zh5.css)({
    fontFamily: "Charlie Display, sans-serif",
    fontSize: "20px",
    fontWeight: 600,
    lineHeight: "28px",
    marginTop: 0,
    color: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.text")
});
const $fc6840133e04adc0$var$$51f57eef4d47f918$var$contentStyles = (0, $74Zh5.css)({
    marginTop: "16px",
    fontFamily: "Inter, sans-serif",
    fontSize: "20px",
    fontWeight: 400,
    lineHeight: "30px",
    color: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.text"),
    ol: {
        margin: 0
    },
    ul: {
        margin: 0
    },
    a: {
        fontSize: "20px !important",
        lineHeight: "28px !important"
    }
});
let $fc6840133e04adc0$export$8f89d78db9c8c41f;
(function(AccordionSize) {
    AccordionSize["DEFAULT"] = "default";
    AccordionSize["WIDE"] = "wide";
    AccordionSize["FULL_WIDTH"] = "full-width";
})($fc6840133e04adc0$export$8f89d78db9c8c41f || ($fc6840133e04adc0$export$8f89d78db9c8c41f = {}));
const $fc6840133e04adc0$export$a766cd26d0d69044 = ({ tabsContent: tabsContent, size: size, shouldSingleTabBeOpen: shouldSingleTabBeOpen, onChange: onChange })=>{
    const [expansionMap, setExpansionMap] = (0, $5FkrB.useState)([]);
    const [tabState, setTabState] = (0, $5FkrB.useState)();
    (0, $5FkrB.useEffect)(()=>{
        const initialExpansionMap = tabsContent.map((tabContent)=>({
                ...tabContent,
                isExpanded: false
            }));
        setExpansionMap(initialExpansionMap);
    // tabsContent intentionally excluded to avoid re-initializing on content changes
    /* eslint-disable react-hooks/exhaustive-deps */ }, []);
    (0, $5FkrB.useEffect)(()=>{
        if (!tabState) return;
        onChange(tabState);
    }, [
        expansionMap,
        setExpansionMap
    ]);
    /* eslint-enable react-hooks/exhaustive-deps */ return (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
        css: [
            $fc6840133e04adc0$var$$9cfa05d02afa3952$var$baseAccordionStyles,
            $fc6840133e04adc0$export$8f89d78db9c8c41f.DEFAULT === size && $fc6840133e04adc0$var$$9cfa05d02afa3952$var$accordionDefaultStyles,
            $fc6840133e04adc0$export$8f89d78db9c8c41f.WIDE === size && $fc6840133e04adc0$var$$9cfa05d02afa3952$var$accordionWideStyles
        ],
        "data-testid": "lesson-accordion",
        children: expansionMap.map(({ title: title, children: children, isExpanded: isExpanded }, index)=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$var$$51f57eef4d47f918$export$10e5e64ea66c812f, {
                title: title,
                isFirstTab: index === 0,
                index: index,
                isExpanded: isExpanded,
                shouldSingleTabBeOpen: shouldSingleTabBeOpen,
                setTabState: setTabState,
                setExpansionMap: setExpansionMap,
                children: children
            }, title))
    });
};
const $fc6840133e04adc0$var$$9cfa05d02afa3952$var$baseAccordionStyles = (0, $74Zh5.css)({
    width: "100%",
    display: "flex",
    flexDirection: "column"
});
const $fc6840133e04adc0$var$$9cfa05d02afa3952$var$accordionDefaultStyles = (0, $74Zh5.css)({
    maxWidth: "720px"
});
const $fc6840133e04adc0$var$$9cfa05d02afa3952$var$accordionWideStyles = (0, $74Zh5.css)({
    maxWidth: "1020px",
    [(0, $0bc19dfefbafca8c$export$987d49ffe1b0900f).below.md]: {
        maxWidth: "720px"
    }
});
var $fc6840133e04adc0$var$$7d458ed59bb9c6a8$exports = {};
$fc6840133e04adc0$var$$parcel$export($fc6840133e04adc0$var$$7d458ed59bb9c6a8$exports, "InlineCode", ()=>$fc6840133e04adc0$export$7f1bf47c7f50a6aa);
const $fc6840133e04adc0$export$7f1bf47c7f50a6aa = ({ code: code = "" })=>{
    const lines = code ? code.split(/\r\n|\r|\n/) : null;
    const [isCopied, setIsCopied] = (0, $5FkrB.useState)(false);
    const copy = (code)=>{
        navigator.clipboard.writeText(code);
        setIsCopied(true);
    };
    return (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("code", {
        "data-testid": "code-block",
        css: $fc6840133e04adc0$var$$7d458ed59bb9c6a8$var$inlineCodeStyles,
        children: [
            (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("button", {
                css: [
                    $fc6840133e04adc0$var$$7d458ed59bb9c6a8$var$inlineCodeButtonStyles,
                    isCopied ? (0, $74Zh5.css)({
                        backgroundColor: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.background.selected.bold.pressed"),
                        border: "2px solid"
                    }) : (0, $74Zh5.css)({
                        backgroundColor: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.background.accent.gray.subtlest"),
                        border: `2px solid ${(0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.border.inverse")}`,
                        "&:hover": {
                            backgroundColor: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.background.accent.gray.subtlest.hovered"),
                            border: "2px solid transparent"
                        }
                    })
                ],
                "aria-label": "Copy",
                "aria-haspopup": "true",
                type: "button",
                tabIndex: 0,
                onClick: ()=>copy(code),
                onMouseOut: ()=>setIsCopied(false),
                onBlur: ()=>setIsCopied(false),
                children: [
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("span", {
                        className: "tooltipText",
                        css: $fc6840133e04adc0$var$$7d458ed59bb9c6a8$var$tooltipTextStyles,
                        children: isCopied ? "Copied!" : "Copy"
                    }),
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$export$f04a61298a47a40f, {
                        type: "copy",
                        color: isCopied ? (0, $d568d81ef5c2bf7a$export$29a4f05edc054374) : (0, $d568d81ef5c2bf7a$export$7d61b15e0da132af)
                    })
                ]
            }),
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("span", {
                children: lines?.map((line, index)=>(0, $6bec4f26b2cb3094$export$25062201e9e25d76)("span", {
                        css: $fc6840133e04adc0$var$$7d458ed59bb9c6a8$var$codeLinesStyles,
                        children: [
                            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("span", {
                                css: $fc6840133e04adc0$var$$7d458ed59bb9c6a8$var$lineNumberStyles,
                                children: index + 1
                            }),
                            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("span", {
                                css: $fc6840133e04adc0$var$$7d458ed59bb9c6a8$var$lineTextStyles,
                                children: line
                            })
                        ]
                    }, index))
            })
        ]
    });
};
const $fc6840133e04adc0$var$$7d458ed59bb9c6a8$var$inlineCodeStyles = (0, $74Zh5.css)({
    position: "relative",
    display: "flex",
    maxWidth: "100%",
    margin: "20px 0",
    flexDirection: "column",
    borderRadius: "3px",
    overflowWrap: "normal",
    backgroundColor: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.background.accent.gray.subtlest")
});
const $fc6840133e04adc0$var$$7d458ed59bb9c6a8$var$inlineCodeButtonStyles = (0, $74Zh5.css)({
    position: "absolute",
    right: "8px",
    top: "6px",
    display: "flex",
    padding: "2px",
    borderRadius: "4px",
    transition: "opacity 0.2s ease 0s",
    opacity: 0,
    zIndex: 1,
    cursor: "pointer",
    "&:hover .tooltipText": {
        opacity: 1
    },
    "&:hover": {
        opacity: 1
    }
});
const $fc6840133e04adc0$var$$7d458ed59bb9c6a8$var$tooltipTextStyles = (0, $74Zh5.css)({
    position: "absolute",
    top: "-30px",
    padding: "2px 6px",
    marginLeft: "-5px",
    borderRadius: "6px",
    backgroundColor: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.background.selected.bold.pressed"),
    color: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.text.inverse"),
    textAlign: "center",
    fontSize: "11px",
    opacity: 0,
    zIndex: 1,
    transition: "opacity 0.4s ease 0s",
    "&:hover": {
        opacity: 1
    }
});
const $fc6840133e04adc0$var$$7d458ed59bb9c6a8$var$codeLinesStyles = (0, $74Zh5.css)({
    display: "flex",
    lineHeight: "20px",
    whiteSpace: "pre",
    fontSize: "12px"
});
const $fc6840133e04adc0$var$$7d458ed59bb9c6a8$var$lineNumberStyles = (0, $74Zh5.css)({
    padding: "4px 8px",
    marginRight: "8px",
    backgroundColor: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.background.accent.gray.subtler")
});
const $fc6840133e04adc0$var$$7d458ed59bb9c6a8$var$lineTextStyles = (0, $74Zh5.css)({
    padding: "4px 8px 4px 0"
});
var $fc6840133e04adc0$var$$a467abe0c2c1750b$exports = {};
$fc6840133e04adc0$var$$parcel$export($fc6840133e04adc0$var$$a467abe0c2c1750b$exports, "Lozenge", ()=>$fc6840133e04adc0$export$a31cbe1bf5463979);
const $fc6840133e04adc0$export$a31cbe1bf5463979 = ({ appearance: appearance = "default", text: text, isBold: isBold })=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $2ca90be555fc6ae1$export$2e2bcd8739ae039), {
        isBold: isBold,
        appearance: appearance,
        testId: "lozenge",
        children: text?.toUpperCase()
    });
var $fc6840133e04adc0$var$$52124b9ae1d78e04$exports = {};
$fc6840133e04adc0$var$$parcel$export($fc6840133e04adc0$var$$52124b9ae1d78e04$exports, "SectionMessageAppearance", ()=>$fc6840133e04adc0$export$710836885d72543c);
$fc6840133e04adc0$var$$parcel$export($fc6840133e04adc0$var$$52124b9ae1d78e04$exports, "SectionMessage", ()=>$fc6840133e04adc0$export$a36903bd214cec06);
let $fc6840133e04adc0$export$710836885d72543c;
(function(SectionMessageAppearance) {
    SectionMessageAppearance["INFORMATION"] = "information";
    SectionMessageAppearance["INFORMATION_WHITE"] = "information_white";
})($fc6840133e04adc0$export$710836885d72543c || ($fc6840133e04adc0$export$710836885d72543c = {}));
const $fc6840133e04adc0$export$a36903bd214cec06 = ({ children: children, appearance: appearance, fullWidth: fullWidth = false, padding: padding, title: title })=>{
    const isInfoWhite = appearance === $fc6840133e04adc0$export$710836885d72543c.INFORMATION_WHITE;
    return (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
        css: [
            $fc6840133e04adc0$var$$52124b9ae1d78e04$var$sectionMessageContainerStyles({
                padding: padding
            }),
            isInfoWhite && $fc6840133e04adc0$var$$52124b9ae1d78e04$var$informationWhiteStyles,
            !isInfoWhite && $fc6840133e04adc0$var$$52124b9ae1d78e04$var$informationStyles,
            !fullWidth && (0, $74Zh5.css)({
                maxWidth: "720px"
            })
        ],
        "data-testid": `section-message${isInfoWhite ? "-white" : ""}`,
        children: [
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                css: $fc6840133e04adc0$var$$52124b9ae1d78e04$var$iconContainerStyles,
                children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$export$f04a61298a47a40f, {
                    type: "info",
                    alt: "info icon",
                    color: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.icon.accent.blue")
                })
            }),
            (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                css: $fc6840133e04adc0$var$$52124b9ae1d78e04$var$descriptionStyles,
                children: [
                    title && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$export$a8a3e93435678ff9, {
                        level: 5,
                        children: title
                    }),
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$export$5f1af8db9871e1d6, {
                        children: children
                    })
                ]
            })
        ]
    });
};
const $fc6840133e04adc0$var$$52124b9ae1d78e04$var$sectionMessageContainerStyles = ({ padding: padding = (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.200") })=>(0, $74Zh5.css)({
        display: "flex",
        width: "100%",
        borderRadius: "3px",
        padding: padding,
        columnGap: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.200")
    });
const $fc6840133e04adc0$var$$52124b9ae1d78e04$var$informationStyles = (0, $74Zh5.css)({
    backgroundColor: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.background.information")
});
const $fc6840133e04adc0$var$$52124b9ae1d78e04$var$informationWhiteStyles = (0, $74Zh5.css)({
    border: `1px solid ${(0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.border")}`,
    backgroundColor: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("elevation.surface")
});
const $fc6840133e04adc0$var$$52124b9ae1d78e04$var$iconContainerStyles = (0, $74Zh5.css)({
    marginTop: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.050")
});
const $fc6840133e04adc0$var$$52124b9ae1d78e04$var$descriptionStyles = (0, $74Zh5.css)({
    display: "flex",
    flexDirection: "column",
    gap: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.100"),
    "& *": {
        fontSize: "16px !important"
    }
});
var $fc6840133e04adc0$var$$77696804880d7cdc$exports = {};
$fc6840133e04adc0$var$$parcel$export($fc6840133e04adc0$var$$77696804880d7cdc$exports, "DropdownMenu", ()=>$fc6840133e04adc0$export$e44a253a59704894);
$fc6840133e04adc0$var$$parcel$export($fc6840133e04adc0$var$$77696804880d7cdc$exports, "DropdownMenuCheckbox", ()=>$fc6840133e04adc0$export$2393c31da95977ae);
// Main DropdownMenu component (config-based with items object or custom items array)
const $fc6840133e04adc0$var$$0199732cf5257721$export$e960b0f5cc4a2826 = ({ items: items, onItemClick: onItemClick })=>{
    return (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $60db3f2a35859adf$export$2e2bcd8739ae039), {
        id: "actions",
        children: Object.entries(items).map(([label, value])=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $709d8ee79761c504$export$2e2bcd8739ae039), {
                testId: `dropdown-item-checkbox-${label}`,
                isDisabled: value.isDisabled,
                id: label,
                onClick: ()=>onItemClick(label),
                isSelected: value.isSelected,
                children: label
            }, label))
    });
};
const $fc6840133e04adc0$var$$77e170ce1d4ab374$export$a6155c53cd00116c = ({ items: items, onItemClick: onItemClick })=>{
    return (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $077dd7a59909f2d8$export$2e2bcd8739ae039), {
        id: "actions",
        children: Object.entries(items).map(([label, value])=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $957fbbe730d1bbb2$export$2e2bcd8739ae039), {
                testId: `dropdown-item-checkbox-${label}`,
                isDisabled: value.isDisabled,
                id: label,
                onClick: ()=>onItemClick(label),
                isSelected: value.isSelected,
                children: label
            }, label))
    });
};
const $fc6840133e04adc0$var$$0633f0dbed99c656$var$selectedItemStyles = (0, $74Zh5.css)({
    backgroundColor: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.background.selected.hovered"),
    fontWeight: 600
});
const $fc6840133e04adc0$var$$0633f0dbed99c656$var$iconMenuStyles = (0, $74Zh5.css)({
    "& button > span": {
        gap: `${(0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.100")} !important`
    },
    // Ensure icon and text are vertically aligned
    '& button [role="img"]': {
        display: "flex !important"
    }
});
const $fc6840133e04adc0$var$$0633f0dbed99c656$export$efefb5b75235a614 = ({ items: items, onItemClick: onItemClick })=>{
    return (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
        id: "actions",
        css: $fc6840133e04adc0$var$$0633f0dbed99c656$var$iconMenuStyles,
        children: Object.entries(items).map(([label, value])=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                css: value.isSelected && $fc6840133e04adc0$var$$0633f0dbed99c656$var$selectedItemStyles,
                children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $d1103224b1f806e2$export$2e2bcd8739ae039), {
                    testId: `dropdown-item-${label}`,
                    isDisabled: value.isDisabled,
                    onClick: ()=>onItemClick(label),
                    elemBefore: value.icon,
                    children: label
                })
            }, label))
    });
};
const $fc6840133e04adc0$var$$69215f50d6c9f1e0$export$2165c09f364cf0ee = (0, $74Zh5.css)({
    "& > button": {
        border: `1px solid ${(0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.border.brand")}`,
        padding: `${(0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.100")} ${(0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.100")} ${(0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.100")} ${(0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.150")}`,
        background: "#fff",
        alignItems: "center",
        height: "40px",
        fontSize: "16px",
        lineHeight: "20px",
        fontWeight: 600,
        fontFamily: "Charlie Text, sans-serif",
        color: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.text.brand"),
        borderRadius: "4px",
        ":hover": {
            background: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.background.selected"),
            color: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.text.selected")
        }
    },
    svg: {
        width: "30px",
        height: "30px"
    }
});
const $fc6840133e04adc0$var$$69215f50d6c9f1e0$export$a6df230d684a2658 = (0, $74Zh5.css)({
    "#actions": {
        "button[disabled]": {
            background: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.background.disabled"),
            span: {
                color: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.text.disabled"),
                ":hover": {
                    color: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.text.disabled")
                }
            },
            rect: {
                stroke: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.border.disabled")
            }
        },
        ":before, :after": {
            display: "none"
        },
        button: {
            padding: `${(0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.200")} ${(0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.200")} ${(0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.200")} 24px`,
            width: "220px",
            height: "48px",
            '[aria-checked="true"]:before': {
                content: '""',
                position: "absolute",
                top: 0,
                left: 0,
                width: "2px",
                height: "100%",
                background: `${(0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.text.selected")}`
            },
            span: {
                gap: 0,
                span: {
                    fontFamily: "Inter, sans-serif",
                    fontSize: "16px",
                    lineHeight: "20px"
                }
            }
        }
    }
});
const $fc6840133e04adc0$var$$69215f50d6c9f1e0$export$e42df41f371072da = (0, $74Zh5.css)({
    "& > button": {
        border: 0,
        background: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.background.selected")
    }
});
const $fc6840133e04adc0$var$$69215f50d6c9f1e0$export$9ee5d5d0a4499fc5 = (0, $74Zh5.css)({
    display: "flex",
    alignItems: "center",
    gap: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.150"),
    paddingRight: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.100")
});
const $fc6840133e04adc0$export$e44a253a59704894 = ({ items: items, placement: placement, onItemClick: onItemClick, customItems: customItems, isCheckboxMenu: isCheckboxMenu = false, triggerText: triggerText, customTriggerStyles: customTriggerStyles, customTriggerActiveStyles: customTriggerActiveStyles, customTriggerComponent: customTriggerComponent, isOptionMenu: isOptionMenu = false })=>{
    const [isDropdownOpen, setIsDropdownOpen] = (0, $5FkrB.useState)(false);
    const [itemsList, setItemList] = (0, $5FkrB.useState)(items ?? {});
    const isControlled = (0, $5FkrB.useRef)(false);
    const prevItemsRef = (0, $5FkrB.useRef)(items);
    // Check if we're using custom items mode
    const isCustomItemsMode = customItems && customItems.length > 0;
    (0, $5FkrB.useEffect)(()=>{
        if (!isCustomItemsMode && prevItemsRef.current !== items && items) {
            isControlled.current = true;
            setItemList(items);
            prevItemsRef.current = items;
        }
    }, [
        items,
        isCustomItemsMode
    ]);
    const handleItemClick = (label)=>{
        // Only update internal state if not controlled
        if (!isControlled.current) setItemList((prev)=>{
            const updatedState = {
                ...prev
            };
            if (isCheckboxMenu) updatedState[label].isSelected = !updatedState[label].isSelected;
            else Object.keys(updatedState).forEach((key)=>{
                updatedState[key].isSelected = key === label;
            });
            return updatedState;
        });
        if (onItemClick) onItemClick(label);
    };
    const getTriggerText = (itemsChecked)=>{
        const selectedItems = Object.keys(itemsChecked).filter((key)=>itemsChecked[key].isSelected);
        if (isCheckboxMenu) {
            if (triggerText) return triggerText;
            // For checkbox mode, show count of selected items or first item name
            if (selectedItems.length === 0) return Object.keys(itemsChecked)[0] || "Select items";
            else if (selectedItems.length === 1) return selectedItems[0];
            return `${selectedItems.length} selected`;
        }
        if (triggerText) return triggerText;
        // For radio mode, show the selected item or first item
        return selectedItems[0] || Object.keys(itemsChecked)[0];
    };
    const renderTrigger = ()=>{
        const selectedItems = Object.keys(itemsList).filter((key)=>itemsList[key]?.isSelected);
        // If custom trigger component is provided, use it
        if (customTriggerComponent) return customTriggerComponent;
        // For custom items mode, just use the triggerText
        if (isCustomItemsMode) return triggerText || "Menu";
        // If checkbox mode with custom trigger text and selections, render custom trigger with badge
        if (isCheckboxMenu && triggerText && selectedItems.length > 0) return ({ triggerRef: triggerRef, ...triggerButtonProps })=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("button", {
                ...triggerButtonProps,
                ref: triggerRef,
                children: (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("span", {
                    css: $fc6840133e04adc0$var$$69215f50d6c9f1e0$export$9ee5d5d0a4499fc5,
                    children: [
                        triggerText,
                        (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $2ca90be555fc6ae1$export$2e2bcd8739ae039), {
                            isBold: true,
                            appearance: "inprogress",
                            children: selectedItems.length
                        })
                    ]
                })
            });
        // Otherwise return the text trigger
        return getTriggerText(itemsList);
    };
    const hasAnyIcons = Object.values(itemsList).some((item)=>item?.icon);
    const isAnyItemSelected = isCustomItemsMode ? false : Object.values(itemsList).some(({ isSelected: isSelected })=>isSelected);
    const renderMenuContent = ()=>{
        // Custom items mode - render custom DropdownItems
        if (isCustomItemsMode && customItems) return (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $6bec4f26b2cb3094$export$ffb0004e005737fa), {
            children: customItems.map((item, index)=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $d1103224b1f806e2$export$2e2bcd8739ae039), {
                    onClick: item.onClick,
                    isDisabled: item.isDisabled,
                    description: item.description,
                    elemBefore: item.elemBefore,
                    elemAfter: item.elemAfter,
                    testId: item.testId,
                    children: item.children
                }, item.testId ?? index))
        });
        if (isCheckboxMenu) return (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$var$$0199732cf5257721$export$e960b0f5cc4a2826, {
            items: itemsList,
            onItemClick: handleItemClick
        });
        if (isOptionMenu || hasAnyIcons) return (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$var$$0633f0dbed99c656$export$efefb5b75235a614, {
            items: itemsList,
            onItemClick: handleItemClick
        });
        return (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$var$$77e170ce1d4ab374$export$a6155c53cd00116c, {
            items: itemsList,
            onItemClick: handleItemClick
        });
    };
    // Combine base styles with actions styles for full DropdownMenu styling
    const combinedTriggerStyles = (0, $74Zh5.css)([
        $fc6840133e04adc0$var$$69215f50d6c9f1e0$export$2165c09f364cf0ee,
        $fc6840133e04adc0$var$$69215f50d6c9f1e0$export$a6df230d684a2658
    ]);
    return (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
        css: [
            combinedTriggerStyles,
            customTriggerStyles,
            isAnyItemSelected && isDropdownOpen && $fc6840133e04adc0$var$$69215f50d6c9f1e0$export$e42df41f371072da,
            isAnyItemSelected && isDropdownOpen && customTriggerActiveStyles
        ],
        children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $5a40bdc8514ad3b7$export$2e2bcd8739ae039), {
            onOpenChange: ({ isOpen: isOpen })=>setIsDropdownOpen(isOpen),
            trigger: renderTrigger(),
            shouldRenderToParent: true,
            placement: placement,
            children: renderMenuContent()
        })
    });
};
const $fc6840133e04adc0$export$2393c31da95977ae = (props)=>{
    return (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$export$e44a253a59704894, {
        ...props,
        isCheckboxMenu: false
    });
};
var $fc6840133e04adc0$var$$4366d2b05f9f8f6b$exports = {};
$fc6840133e04adc0$var$$parcel$export($fc6840133e04adc0$var$$4366d2b05f9f8f6b$exports, "GreetingCard", ()=>$fc6840133e04adc0$export$e52b3c28ffecde23);
const $fc6840133e04adc0$var$$7a335ab395aac0f5$export$6b53fc34987132a8 = ()=>(0, $6bec4f26b2cb3094$export$25062201e9e25d76)("svg", {
        viewBox: "0 0 406 37",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("g", {
                clipPath: "url(#clip0_511_7308)",
                children: [
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("path", {
                        d: "M396.155 27.8221H394.244L388.065 11.4229H391.206L396.667 26.4205L402.129 11.4229H405.269L398.818 28.3828C396.906 33.3937 395.814 35.9867 391.479 35.9867C390.011 35.9867 389.192 35.8465 388.338 35.4961V32.9031C389.328 33.2185 390.455 33.3236 391.308 33.3236C393.697 33.3236 394.756 31.6416 396.155 27.8221Z",
                        fill: "#101214"
                    }),
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("path", {
                        d: "M382.705 23.5062C382.705 25.048 383.593 26.0992 385.402 26.0992C386.085 26.0992 386.733 25.9591 387.245 25.854V28.7624C386.733 28.9025 386.153 29.0427 385.265 29.0427C381.613 29.0427 379.838 26.8351 379.838 23.5763V14.2203H377.073V11.417H379.838V7.70264H382.705V11.417H387.245V14.2203H382.705V23.5062Z",
                        fill: "#101214"
                    }),
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("path", {
                        d: "M370.731 6.79681C370.731 5.46524 371.585 4.69434 372.779 4.69434C373.974 4.69434 374.827 5.46524 374.827 6.79681C374.827 8.12837 373.974 8.89928 372.779 8.89928C371.585 8.89928 370.731 8.12837 370.731 6.79681ZM371.278 28.9428V11.4222H374.213V28.9428H371.278Z",
                        fill: "#101214"
                    }),
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("path", {
                        d: "M367.184 18.6738V28.9408H364.248V18.3584C364.248 15.2047 363.019 13.803 360.22 13.803C357.49 13.803 355.612 15.6602 355.612 19.1994V28.9408H352.677V11.4202H355.612V14.2936C356.705 12.2262 358.718 11.0698 361.005 11.0698C364.931 11.0698 367.184 13.8381 367.184 18.6738Z",
                        fill: "#101214"
                    }),
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("path", {
                        d: "M333.733 21.6899V11.4229H336.669V22.0053C336.669 25.159 337.898 26.5606 340.697 26.5606C343.427 26.5606 345.305 24.7035 345.305 21.1643V11.4229H348.24V28.9434H345.305V26.0701C344.212 28.1375 342.199 29.2938 339.912 29.2938C335.986 29.2938 333.733 26.5256 333.733 21.6899Z",
                        fill: "#101214"
                    }),
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("path", {
                        d: "M318.416 19.1994V28.9408H315.48V18.3584C315.48 15.2047 314.252 13.803 311.453 13.803C308.722 13.803 306.845 15.6602 306.845 19.1994V28.9408H303.909V11.4202H306.845V14.2936C307.937 12.2262 309.951 11.0698 312.238 11.0698C315.139 11.0698 317.119 12.5766 317.972 15.3448C318.928 12.6467 321.215 11.0698 324.048 11.0698C327.871 11.0698 329.987 13.733 329.987 18.6738V28.9408H327.052V19.1994C327.052 15.5901 325.823 13.803 323.024 13.803C320.293 13.803 318.416 15.6602 318.416 19.1994Z",
                        fill: "#101214"
                    }),
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("path", {
                        d: "M288.249 19.1994V28.9408H285.314V18.3584C285.314 15.2047 284.085 13.803 281.286 13.803C278.555 13.803 276.678 15.6602 276.678 19.1994V28.9408H273.742V11.4202H276.678V14.2936C277.77 12.2262 279.784 11.0698 282.071 11.0698C284.972 11.0698 286.952 12.5766 287.805 15.3448C288.761 12.6467 291.048 11.0698 293.881 11.0698C297.704 11.0698 299.82 13.733 299.82 18.6738V28.9408H296.885V19.1994C296.885 15.5901 295.656 13.803 292.857 13.803C290.126 13.803 288.249 15.6602 288.249 19.1994Z",
                        fill: "#101214"
                    }),
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("path", {
                        d: "M262.275 29.2912C257.155 29.2912 254.151 25.4017 254.151 20.1455C254.151 14.8893 257.155 11.0698 262.275 11.0698C267.361 11.0698 270.331 14.8893 270.331 20.1455C270.331 25.4017 267.361 29.2912 262.275 29.2912ZM262.275 13.8731C258.623 13.8731 257.019 16.8166 257.019 20.1455C257.019 23.4744 258.623 26.4879 262.275 26.4879C265.893 26.4879 267.464 23.4744 267.464 20.1455C267.464 16.8166 265.893 13.8731 262.275 13.8731Z",
                        fill: "#101214"
                    }),
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("path", {
                        d: "M251.998 24.88V27.9285C250.598 28.8746 248.38 29.2951 246.059 29.2951C238.686 29.2951 234.521 24.7398 234.521 17.4863C234.521 10.478 238.686 5.57227 245.99 5.57227C248.175 5.57227 250.36 5.99276 251.964 7.18416V10.2327C250.36 9.18151 248.585 8.62085 245.99 8.62085C240.734 8.62085 237.594 12.195 237.594 17.4863C237.594 22.7775 240.836 26.2816 246.161 26.2816C248.516 26.2816 250.36 25.7209 251.998 24.88Z",
                        fill: "#101214"
                    }),
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("path", {
                        d: "M119.605 12.4499C119.605 15.8465 121.102 18.5153 127.168 19.7284C130.713 20.5371 131.501 21.1032 131.501 22.3163C131.501 23.5294 130.713 24.2572 128.192 24.2572C125.277 24.2572 121.811 23.2059 119.526 21.8311V27.3304C121.338 28.22 123.702 29.2713 128.192 29.2713C134.494 29.2713 136.936 26.3599 136.936 22.1546M136.936 22.2354C136.936 18.1918 134.888 16.3318 128.98 15.0378C125.75 14.3099 124.962 13.5821 124.962 12.5308C124.962 11.2368 126.144 10.6707 128.271 10.6707C130.87 10.6707 133.391 11.4794 135.833 12.6116V7.35493C134.1 6.46534 131.501 5.81836 128.428 5.81836C122.599 5.81836 119.605 8.40627 119.605 12.6116",
                        fill: "#1868DB"
                    }),
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("path", {
                        d: "M200.274 5.979V29.0276H205.08V11.4783L207.049 16.088L213.824 29.0276H219.811V5.979H215.085V20.8595L213.273 16.4924L207.837 5.979H200.274Z",
                        fill: "#1868DB"
                    }),
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("path", {
                        d: "M169.865 5.979H164.666V29.0276H169.865V5.979Z",
                        fill: "#1868DB"
                    }),
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("path", {
                        d: "M158.679 22.1554C158.679 18.1117 156.631 16.2517 150.723 14.9577C147.493 14.2299 146.705 13.502 146.705 12.4507C146.705 11.1567 147.887 10.5906 150.014 10.5906C152.614 10.5906 155.134 11.3993 157.577 12.5316V7.27485C155.843 6.38526 153.244 5.73828 150.171 5.73828C144.342 5.73828 141.348 8.32619 141.348 12.5316C141.348 15.9282 142.845 18.597 148.911 19.8101C152.456 20.6188 153.244 21.1849 153.244 22.398C153.244 23.6111 152.456 24.3389 149.935 24.3389C147.02 24.3389 143.554 23.2876 141.27 21.9127V27.412C143.081 28.3016 145.445 29.353 149.935 29.353C156.159 29.353 158.679 26.4416 158.679 22.1554Z",
                        fill: "#1868DB"
                    }),
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("path", {
                        d: "M79.1143 5.979V29.0276H89.828L91.4824 24.0135H84.3136V5.979H79.1143Z",
                        fill: "#1868DB"
                    }),
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("path", {
                        d: "M57.9219 5.979V10.9122H63.6727V29.0276H68.9508V10.9122H75.1742V5.979H57.9219Z",
                        fill: "#1868DB"
                    }),
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("path", {
                        d: "M50.2806 5.97412H43.4269L35.6279 29.0227H41.615L42.7179 25.1408C44.0572 25.5452 45.4752 25.7878 46.8932 25.7878C48.3112 25.7878 49.7292 25.5452 51.0684 25.1408L52.1713 29.0227H58.1584C58.0796 29.0227 50.2806 5.97412 50.2806 5.97412ZM46.8144 20.9355C45.7903 20.9355 44.8449 20.7737 43.9784 20.5311L46.8144 10.503L49.6504 20.5311C48.7838 20.7737 47.8385 20.9355 46.8144 20.9355Z",
                        fill: "#1868DB"
                    }),
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("path", {
                        d: "M108.339 5.97363H101.485L93.6074 29.0222H99.5945L100.697 25.1404C102.037 25.5447 103.455 25.7873 104.873 25.7873C106.291 25.7873 107.709 25.5447 109.048 25.1404L110.151 29.0222H116.138L108.339 5.97363ZM104.873 20.935C103.849 20.935 102.903 20.7733 102.037 20.5306L104.873 10.5025L107.709 20.5306C106.842 20.7733 105.897 20.935 104.873 20.935Z",
                        fill: "#1868DB"
                    }),
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("path", {
                        d: "M188.694 5.97363H181.84L174.041 29.0222H180.028L181.131 25.1404C182.47 25.5447 183.888 25.7873 185.306 25.7873C186.724 25.7873 188.142 25.5447 189.481 25.1404L190.584 29.0222H196.571L188.694 5.97363ZM185.306 20.935C184.282 20.935 183.337 20.7733 182.47 20.5306L185.306 10.5025L188.142 20.5306C187.276 20.7733 186.252 20.935 185.306 20.935Z",
                        fill: "#1868DB"
                    }),
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("g", {
                        clipPath: "url(#clip1_511_7308)",
                        children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("path", {
                            d: "M25.4715 28.1859L13.6868 3.70842C13.4549 3.1784 13.2229 3.08203 12.9445 3.08203C12.7125 3.08203 12.4342 3.1784 12.1558 3.66024C10.4855 6.40673 9.74318 9.58688 9.74318 12.9116C9.74318 17.5372 12.0166 21.8738 15.3571 28.8605C15.7283 29.6314 16.0067 29.776 16.6562 29.776H24.8219C25.4251 29.776 25.7498 29.5351 25.7498 29.0532C25.7498 28.8123 25.7034 28.6678 25.4715 28.1859ZM8.3513 16.6217C7.42338 15.1762 7.145 15.0799 6.91302 15.0799C6.68104 15.0799 6.54185 15.1762 6.12429 16.0435L0.231981 28.2823C0.0463961 28.6678 0 28.8123 0 29.005C0 29.3905 0.324773 29.776 1.02071 29.776H9.32562C9.88237 29.776 10.2999 29.2941 10.5319 28.3786C10.8103 27.2222 10.9031 26.2104 10.9031 25.0058C10.9031 21.6329 9.4648 18.3564 8.3513 16.6217Z",
                            fill: "#1868DB"
                        })
                    })
                ]
            }),
            (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("defs", {
                children: [
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("clipPath", {
                        id: "clip0_511_7308",
                        children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("rect", {
                            width: "406",
                            height: "37",
                            fill: "white"
                        })
                    }),
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("clipPath", {
                        id: "clip1_511_7308",
                        children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("rect", {
                            width: "25.7498",
                            height: "26.694",
                            fill: "white",
                            transform: "translate(0 3.08154)"
                        })
                    })
                ]
            })
        ]
    });
const $fc6840133e04adc0$var$$0467da094044eefe$export$590b8cc7d4f1d823 = ()=>(0, $6bec4f26b2cb3094$export$25062201e9e25d76)("svg", {
        viewBox: "0 0 112 113",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("g", {
                id: "icon-launched-new",
                clipPath: "url(#clip0_608_7795)",
                children: (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("g", {
                    id: "Clip path group",
                    children: [
                        (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("mask", {
                            id: "mask0_608_7795",
                            "mask-type": "luminance",
                            maskUnits: "userSpaceOnUse",
                            x: "0",
                            y: "0",
                            width: "112",
                            height: "113",
                            children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("g", {
                                id: "clip0_10_2524",
                                children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("path", {
                                    id: "Vector",
                                    d: "M112 0.5H0V112.5H112V0.5Z",
                                    fill: "white"
                                })
                            })
                        }),
                        (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("g", {
                            mask: "url(#mask0_608_7795)",
                            children: (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("g", {
                                id: "Group",
                                children: [
                                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("path", {
                                        id: "Vector_2",
                                        fillRule: "evenodd",
                                        clipRule: "evenodd",
                                        d: "M69.4245 80.4295C67.168 95.2604 53.3169 105.459 38.486 103.203C23.6551 100.946 13.456 87.0952 15.7126 72.2643C17.9691 57.4334 31.8202 47.2344 46.6512 49.4909C61.4821 51.7475 71.6811 65.5986 69.4245 80.4295ZM39.5994 70.0078C39.926 67.8848 38.4711 65.9103 36.3482 65.5837C34.2253 65.2571 32.2508 66.712 31.9242 68.8349C31.5976 70.9579 33.0524 72.9324 35.1754 73.259C37.2983 73.5856 39.2728 72.1307 39.5994 70.0078ZM54.9499 72.3385C55.2765 70.2156 53.8217 68.2411 51.6987 67.9145C49.5758 67.5879 47.6013 69.0428 47.2747 71.1657C46.9481 73.2887 48.403 75.2632 50.5259 75.5898C52.6488 75.9164 54.6233 74.4615 54.9499 72.3385ZM33.8541 82.7454L32.132 80.3998L27.4407 83.844L29.1628 86.1896C34.6112 93.5828 45.0181 95.1713 52.4262 89.7229L54.7718 88.0008L51.3276 83.3096L48.9819 85.0317C44.1719 88.565 37.4022 87.5406 33.869 82.7306L33.8541 82.7454Z",
                                        fill: "#1868DB"
                                    }),
                                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("path", {
                                        id: "Vector_3",
                                        fillRule: "evenodd",
                                        clipRule: "evenodd",
                                        d: "M67.8214 26.5393C53.0795 29.3006 43.3555 43.4932 46.1169 58.2499C48.8782 72.9917 63.0707 82.7157 77.8125 79.9544C92.5544 77.1931 102.293 63.0005 99.5319 48.2587C96.7706 33.5168 82.5632 23.7929 67.8214 26.5393ZM78.6588 42.2758C80.7669 41.875 82.7859 43.2705 83.1867 45.3786C83.5875 47.4867 82.1921 49.5057 80.084 49.9066C77.9759 50.3074 75.9568 48.9119 75.556 46.8038C75.1552 44.6957 76.5507 42.6767 78.6588 42.2758ZM63.3973 45.1262C65.5054 44.7254 67.5244 46.1209 67.9253 48.229C68.3261 50.3371 66.9306 52.3561 64.8225 52.7569C62.7144 53.1578 60.6954 51.7623 60.2946 49.6542C59.8937 47.5461 61.2892 45.5271 63.3973 45.1262ZM76.3428 72.0713C68.9496 73.4519 61.8534 68.5974 60.4727 61.2339L87.1802 56.2308C88.5609 63.6092 83.6915 70.6906 76.328 72.0713H76.3428Z",
                                        fill: "#82B536"
                                    }),
                                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("path", {
                                        id: "Vector_4",
                                        fillRule: "evenodd",
                                        clipRule: "evenodd",
                                        d: "M69.3206 71.522C64.8966 69.9781 61.4079 66.1776 60.4874 61.2339L64.6145 60.4619C60.5023 54.7463 54.178 50.6341 46.666 49.4909C46.4285 49.4612 46.1761 49.4167 45.9386 49.4019C45.508 52.2671 45.5526 55.2511 46.1167 58.2499C46.7996 61.8575 48.1506 65.1532 50.036 68.0481C50.5556 67.8848 51.1346 67.8403 51.7136 67.9294C53.8217 68.256 55.2914 70.2305 54.9648 72.3534C54.9054 72.7394 54.7866 73.1105 54.6382 73.4371C58.7208 77.1189 63.8871 79.5387 69.4691 80.2217C69.8996 77.2525 69.8254 74.3279 69.3206 71.522Z",
                                        fill: "#09326C"
                                    }),
                                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("path", {
                                        id: "Vector_5",
                                        fillRule: "evenodd",
                                        clipRule: "evenodd",
                                        d: "M69.3206 71.522C64.8966 69.9781 61.4079 66.1776 60.4874 61.2339L64.6145 60.4619C60.5023 54.7463 54.178 50.6341 46.666 49.4909C46.4285 49.4612 46.1761 49.4167 45.9386 49.4019C45.508 52.2671 45.5526 55.2511 46.1167 58.2499C46.7996 61.8575 48.1506 65.1532 50.036 68.0481C50.5556 67.8848 51.1346 67.8403 51.7136 67.9294C53.8217 68.256 55.2914 70.2305 54.9648 72.3534C54.9054 72.7394 54.7866 73.1105 54.6382 73.4371C58.7208 77.1189 63.8871 79.5387 69.4691 80.2217C69.8996 77.2525 69.8254 74.3279 69.3206 71.522Z",
                                        fill: "#09326C"
                                    }),
                                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("path", {
                                        id: "Vector_6",
                                        d: "M37.1105 18.5589C35.4939 18.8626 33.943 19.3745 32.443 19.9453C32.443 19.9453 31.9357 20.0403 31.129 20.2877C30.3129 20.4878 29.2409 20.8857 28.0837 21.3496C25.7784 22.3248 23.3235 23.9635 22.2601 25.3038C18.8575 27.6207 15.8953 30.6524 13.728 34.2501C13.728 34.2501 13.6005 34.5506 13.3796 35.0267C13.172 35.4954 12.8711 36.1395 12.6779 36.8806C12.4487 37.5894 12.2232 38.3664 12.138 39.0812C12.0319 39.7904 11.9544 40.3955 12.0307 40.8082C12.1735 41.8321 12.4667 42.4724 12.8105 42.6457C13.1619 42.8321 13.577 42.5438 13.99 41.6956C14.1653 41.2628 14.3883 40.6978 14.6648 39.9797C14.8788 39.2444 15.2371 38.3922 15.6052 37.3413C15.6582 37.3111 15.7874 37.1677 15.863 37.1775C16.5848 34.9263 18.0622 33.0179 19.7393 31.3996C21.4298 29.7737 23.3598 28.4153 25.3445 27.0607C25.1727 26.9127 25.2076 26.665 25.3929 26.6826L25.5019 26.9363C26.7066 25.8143 27.936 25.2919 29.1048 24.7864C30.2944 24.2867 31.425 23.8377 32.7028 22.9372C32.7028 22.9372 32.4877 23.3925 32.4745 23.4001C34.8719 22.6182 37.6167 22.0775 40.4373 22.1955C43.2427 22.2869 46.1201 22.9688 48.4691 24.5119C50.8752 25.97 52.5652 28.3606 53.6246 30.9689C53.8516 31.6469 54.0785 32.3249 54.2715 33.0045C54.3962 33.6879 54.6001 34.449 54.6797 35.0528C54.8203 36.1657 54.6543 37.2947 54.118 38.2656L54.1709 38.2354L54.2011 38.2884C54.5424 38.0246 55.2229 36.9369 55.3721 35.7473C55.4646 35.1686 55.434 34.5896 55.3732 34.0806C55.3273 33.5979 55.2903 33.2857 55.2903 33.2857C55.5313 33.7102 55.7664 34.1555 55.9486 34.6309C56.0816 35.0815 56.188 35.5472 56.1791 36.0258C56.182 36.9888 55.8574 37.9623 55.2989 38.7703C54.191 40.4338 52.3157 41.2704 50.6424 41.536L50.6095 41.1688C52.0421 41.0046 52.9986 39.9706 53.223 39.5627C52.2579 40.3033 50.7995 40.8856 49.2811 40.5898C48.5361 40.4515 47.7197 40.1255 47.3784 39.7405C47.0447 39.3686 46.8665 38.8385 46.8708 38.0117C46.8985 36.3298 47.86 34.2232 48.8355 32.512C49.8283 30.7383 50.9433 29.211 51.8152 27.9971C51.4767 27.9261 50.7999 29.7309 49.8072 29.5578C50.7472 28.3402 51.6439 27.0771 52.6818 26.0321C53.0988 26.4268 52.386 26.9015 52.3552 27.0943C52.8898 26.7383 55.478 24.1295 59.4933 21.2541C63.5031 18.3996 69.0286 15.4039 74.4857 13.8324C79.9467 12.2062 85.1646 12.1912 88.1909 12.4555C91.1868 12.7897 92.2788 12.6434 89.3823 11.3409L89.7669 11.1225C86.5833 10.3337 83.8919 10.0724 80.3945 9.8125C79.908 9.91315 79.8439 9.86194 79.8865 10.1534C79.7671 10.2212 79.5682 10.334 79.6283 10.4402C79.7549 11.1575 78.6865 10.9748 78.2284 11.0944C78.351 9.91998 75.6295 10.2545 72.8735 11.3625C71.487 11.8865 70.1322 12.6203 69.0219 13.1979C67.9359 13.8492 67.1077 14.3369 66.7535 14.4854C66.0124 13.6432 64.1295 15.7642 63.1568 15.8426C63.1872 15.7728 63.4117 15.3647 63.4497 15.3081C62.9108 15.193 60.0007 17.2655 57.7814 19.2266C55.5546 21.1746 53.9377 22.899 54.9247 21.1462C53.2247 22.1988 51.4934 23.5672 49.7915 25.2347C48.1027 26.8946 46.436 28.8403 45.0442 31.2087C44.369 32.3987 43.6976 33.6567 43.277 35.1406C42.8754 36.5962 42.5394 38.2601 43.0769 40.165C43.2648 40.6195 43.4204 41.11 43.6821 41.5403C43.9836 41.9478 44.2736 42.397 44.6529 42.7255C45.038 43.0331 45.4249 43.3748 45.846 43.5916C46.2598 43.7953 46.6793 43.9782 47.1119 44.1534C48.7601 44.7088 50.6331 44.7333 52.3051 44.1876C55.7004 43.155 58.0935 39.9553 58.4079 36.5849C58.4804 35.7544 58.4471 34.8615 58.3055 34.1175C58.1656 33.4076 58.0184 32.6845 57.8785 31.9745C57.6573 31.2759 57.4569 30.5828 57.2433 29.8973C56.9823 29.2211 56.6814 28.5676 56.4072 27.8989C55.1699 25.2864 53.2694 23.0503 51.087 21.43C48.9049 19.8099 46.507 18.7681 44.2577 18.0804L44.3555 18.2528C44.2347 18.1635 43.7768 18.1603 43.679 17.9879C42.7253 18.0381 41.0604 18.071 39.6751 18.2259C38.2821 18.3675 37.1464 18.5912 37.1464 18.5912L37.1105 18.5589ZM50.547 43.0983C50.547 43.0983 50.5297 43.1608 50.5507 43.1665C50.5355 43.14 49.968 43.1289 49.3872 43.1252C48.7971 43.0743 48.2184 42.9818 48.1883 42.9288L48.2858 42.5753C48.8516 42.5523 49.5324 42.6394 50.2474 42.7248C50.6105 42.7466 50.968 42.7894 51.2971 42.813C51.6319 42.8158 51.9534 42.8262 52.2278 42.8459C52.7538 42.8456 53.1037 42.875 52.9613 43.026C52.8247 43.1561 52.1654 43.4778 50.8016 43.3924C50.6366 43.5035 50.594 43.212 50.547 43.0983ZM48.7248 28.3305C48.9904 28.0569 49.2619 27.7627 49.5787 27.4249C48.4351 29.7051 46.7257 32.0082 45.4672 34.7042C44.9032 36.0592 44.4354 37.5524 44.6239 39.0589C44.6303 39.4411 44.7788 39.7953 44.9272 40.1495C45.0283 40.5131 45.2962 40.7995 45.5166 41.0953C46.0031 41.6434 46.6452 42.0331 47.3106 42.2168C47.0285 42.3067 46.6746 42.3321 46.3172 42.2895C45.9844 42.1978 45.6066 42.0263 45.2194 41.8076C44.8968 41.5172 44.5439 41.1739 44.2898 40.7569C44.1094 40.3155 43.8119 39.853 43.8 39.3686C43.4767 37.3774 44.2801 35.6412 44.7204 34.5319C45.2518 32.0379 47.2732 29.8209 48.738 28.3229L48.7248 28.3305ZM75.3293 11.3017L75.292 11.1124L75.4605 11.0693C75.4605 11.0693 75.4734 11.1848 75.4336 11.2074C75.4222 11.249 75.3634 11.2999 75.3218 11.2885L75.3293 11.3017ZM39.9067 19.252C40.2934 18.9447 41.7287 19.2176 40.7452 19.7406C40.5072 19.6301 39.8026 19.8723 39.9067 19.252ZM52.7887 24.428C52.3491 23.9935 53.6243 22.6559 54.1751 23.2553C53.7406 23.6949 53.2325 24.0358 52.7887 24.428ZM26.807 23.1792C26.6704 23.9581 26.4775 23.2785 26.1416 22.9955C26.2853 23.0016 26.7001 22.8364 26.7504 23.1412L26.807 23.1792ZM20.0624 28.3223C20.1883 28.6368 19.9807 29.1055 19.8459 29.2696C19.2644 29.5119 19.686 28.3081 20.0624 28.3223ZM12.8127 39.961C13.1396 40.0737 13.1576 40.4142 12.8019 40.4056C12.5581 40.3159 12.4933 39.8617 12.8923 39.9158C12.8923 39.9158 12.845 39.9252 12.826 39.9535L12.8127 39.961ZM59.9658 20.1089C60.1746 21.2182 58.4067 21.5025 57.8937 22.2673C57.4082 21.3502 59.1026 20.9673 59.526 20.4464C59.7175 20.3202 59.8616 20.2033 59.9658 20.1089ZM51.5342 25.7714C51.2097 26.0959 50.8889 25.8395 50.5815 25.4527C50.2554 25.0941 49.8839 24.656 49.6192 24.5607L49.8434 24.2757C50.2098 24.4886 50.5195 24.6636 50.8161 24.8461C51.0936 25.0569 51.3198 25.3318 51.5191 25.7448L51.5342 25.7714ZM48.7068 31.8834C48.8548 32.3607 48.2335 32.6255 48.0926 32.9336C47.6072 32.6655 48.3318 31.3773 48.7068 31.8834ZM49.8278 41.2441C49.8866 41.8421 49.2689 41.5263 49.0854 41.5428C49.237 41.4392 49.4801 41.1258 49.6106 41.1394C49.6996 41.1415 49.7239 41.2154 49.8278 41.2441ZM52.2354 25.9873C52.6331 26.5333 53.1404 27.0872 53.4601 27.7125L53.1417 27.8932C52.8087 27.2754 52.3316 26.7745 51.9396 26.2077L52.2221 25.9948L52.2354 25.9873ZM54.8127 32.2588L54.4625 32.3525C53.8595 31.5372 54.7063 31.1442 54.7977 32.2324L54.8127 32.2588ZM44.6137 21.8595C44.7044 21.8958 44.8517 21.97 44.9482 21.9854C46.2715 22.3392 44.0824 23.0555 44.6137 21.8595ZM37.2998 21.7663C37.1672 21.8416 36.9889 21.9602 36.8452 21.9541C35.8442 22.0136 36.8308 21.0328 37.2998 21.7663Z",
                                        fill: "#09326C"
                                    })
                                ]
                            })
                        })
                    ]
                })
            }),
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("defs", {
                children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("clipPath", {
                    id: "clip0_608_7795",
                    children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("rect", {
                        width: "112",
                        height: "112",
                        fill: "white",
                        transform: "translate(0 0.5)"
                    })
                })
            })
        ]
    });
const $fc6840133e04adc0$export$e52b3c28ffecde23 = ({ onClickLogIn: onClickLogIn, onClickContinue: onClickContinue })=>{
    return (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
        css: $fc6840133e04adc0$var$$4366d2b05f9f8f6b$var$overlayStyles,
        children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
            css: $fc6840133e04adc0$var$$4366d2b05f9f8f6b$var$containerStyles,
            children: (0, $6bec4f26b2cb3094$export$25062201e9e25d76)((0, $59963e1859b942f0$export$2e2bcd8739ae039), {
                alignInline: "center",
                alignBlock: "center",
                grow: "fill",
                xcss: $fc6840133e04adc0$var$$4366d2b05f9f8f6b$var$containerStackStyles,
                children: [
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                        css: $fc6840133e04adc0$var$$4366d2b05f9f8f6b$var$logoStyles,
                        children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$var$$0467da094044eefe$export$590b8cc7d4f1d823, {})
                    }),
                    (0, $6bec4f26b2cb3094$export$25062201e9e25d76)((0, $59963e1859b942f0$export$2e2bcd8739ae039), {
                        alignInline: "center",
                        alignBlock: "center",
                        space: "space.200",
                        xcss: $fc6840133e04adc0$var$$4366d2b05f9f8f6b$var$middleStackStyles,
                        children: [
                            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                                css: $fc6840133e04adc0$var$$4366d2b05f9f8f6b$var$communityLogoStyles,
                                children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$var$$7a335ab395aac0f5$export$6b53fc34987132a8, {})
                            }),
                            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$export$a8a3e93435678ff9, {
                                level: 3,
                                children: "We've launched something new"
                            }),
                            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$export$5f1af8db9871e1d6, {
                                children: "We've logged you out. Log back in to see what's changed"
                            })
                        ]
                    }),
                    (0, $6bec4f26b2cb3094$export$25062201e9e25d76)((0, $d363f694d5e41fc5$export$2e2bcd8739ae039), {
                        space: "space.200",
                        shouldWrap: true,
                        children: [
                            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                                css: $fc6840133e04adc0$var$$4366d2b05f9f8f6b$var$buttonContainerStyles,
                                children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$export$353f5b6fc5456de1, {
                                    appearance: $fc6840133e04adc0$export$261c9483fc4a455a.SECONDARY,
                                    label: "Continue without logging in",
                                    fullWidth: true,
                                    onClick: onClickContinue
                                })
                            }),
                            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                                css: $fc6840133e04adc0$var$$4366d2b05f9f8f6b$var$buttonContainerStyles,
                                children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$export$353f5b6fc5456de1, {
                                    appearance: $fc6840133e04adc0$export$261c9483fc4a455a.PRIMARY,
                                    label: "Log back in",
                                    fullWidth: true,
                                    onClick: onClickLogIn
                                })
                            })
                        ]
                    })
                ]
            })
        })
    });
};
const $fc6840133e04adc0$var$$4366d2b05f9f8f6b$var$overlayStyles = (0, $74Zh5.css)({
    position: "fixed",
    zIndex: (0, $99aaada6b4006109$export$7be255094ccdc533).blanket(),
    inset: 0,
    backgroundColor: "white",
    overflowY: "auto",
    pointerEvents: "initial",
    fontFamily: "Charlie Display, sans-serif"
});
const $fc6840133e04adc0$var$$4366d2b05f9f8f6b$var$containerStackStyles = (0, $23c4b331751052a3$export$f6c783d06584602c)({
    height: "100%"
});
const $fc6840133e04adc0$var$$4366d2b05f9f8f6b$var$middleStackStyles = (0, $23c4b331751052a3$export$f6c783d06584602c)({
    marginBottom: "space.500"
});
const $fc6840133e04adc0$var$$4366d2b05f9f8f6b$var$containerStyles = (0, $74Zh5.css)({
    position: "absolute",
    width: "100%",
    marginLeft: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.200"),
    marginRight: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.200"),
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    "@media(min-width: 1280px)": {
        width: "720px",
        height: "480px"
    },
    "@media (min-width: 768px) and (max-width: 1279px)": {
        width: "656px"
    }
});
const $fc6840133e04adc0$var$$4366d2b05f9f8f6b$var$communityLogoStyles = (0, $74Zh5.css)({
    width: "406px",
    "@media(max-width: 767px)": {
        width: "90%"
    }
});
const $fc6840133e04adc0$var$$4366d2b05f9f8f6b$var$logoStyles = (0, $74Zh5.css)({
    width: "112px",
    height: "112px",
    borderRadius: "50%",
    border: "1px solid black",
    marginBottom: "24px"
});
const $fc6840133e04adc0$var$$4366d2b05f9f8f6b$var$buttonContainerStyles = (0, $74Zh5.css)({
    "@media(max-width: 767px)": {
        width: "100%"
    }
});
var $fc6840133e04adc0$var$$be203e745bcefb12$exports = {};
$fc6840133e04adc0$var$$parcel$defineInteropFlag($fc6840133e04adc0$var$$be203e745bcefb12$exports);
$fc6840133e04adc0$var$$parcel$export($fc6840133e04adc0$var$$be203e745bcefb12$exports, "Error", ()=>$fc6840133e04adc0$export$edf27be85e5f6da0);
$fc6840133e04adc0$var$$parcel$export($fc6840133e04adc0$var$$be203e745bcefb12$exports, "default", ()=>$fc6840133e04adc0$var$$be203e745bcefb12$export$2e2bcd8739ae039);
const $fc6840133e04adc0$var$$72560d06a87aac8e$export$87321d307719eaf2 = (props)=>{
    return (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("svg", {
        width: "96",
        height: "89",
        viewBox: "0 0 96 89",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("path", {
                d: "M0.576172 88.4576L0.628536 88.5623H95.366L95.4242 88.4576L48.0002 0.8125L0.576172 88.4576Z",
                fill: "#DDDEE1"
            }),
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("path", {
                d: "M48.1641 32.2012V64.207",
                stroke: "white",
                strokeWidth: "7.33",
                strokeMiterlimit: "10"
            }),
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("path", {
                d: "M50.4025 74.1797C50.4316 74.0284 50.4433 73.8655 50.4433 73.6968C50.4433 73.528 50.4316 73.3593 50.4025 73.208C50.2396 72.2946 49.6054 71.736 48.7153 71.5906C48.564 71.5673 48.4069 71.5557 48.2382 71.5557C48.0694 71.5557 47.9007 71.5673 47.7436 71.5964C46.8534 71.7418 46.2251 72.3062 46.0564 73.2138C46.0273 73.3651 46.0156 73.528 46.0156 73.7026C46.0156 73.8771 46.0273 74.0342 46.0564 74.1855C46.2193 75.0931 46.8534 75.6517 47.7436 75.8029C47.9007 75.832 48.0694 75.8437 48.2382 75.8437C48.4069 75.8437 48.564 75.832 48.7153 75.8088C49.6054 75.6633 50.2396 75.0989 50.4025 74.1913V74.1797Z",
                stroke: "white",
                strokeWidth: "7.33",
                strokeMiterlimit: "10"
            })
        ]
    });
};
const $fc6840133e04adc0$export$edf27be85e5f6da0 = ({ onClickLogout: onClickLogout, errorMessage: errorMessage })=>{
    return (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
        css: $fc6840133e04adc0$var$$be203e745bcefb12$var$pageStyles,
        children: (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
            css: $fc6840133e04adc0$var$$be203e745bcefb12$var$containerStyles,
            children: [
                (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$var$$72560d06a87aac8e$export$87321d307719eaf2, {}),
                (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("h1", {
                    css: $fc6840133e04adc0$var$$be203e745bcefb12$var$headingStyles,
                    children: "Error"
                }),
                (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("p", {
                    css: $fc6840133e04adc0$var$$be203e745bcefb12$var$descriptionStyles,
                    children: errorMessage
                }),
                (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$export$353f5b6fc5456de1, {
                    label: "Log out",
                    appearance: $fc6840133e04adc0$export$261c9483fc4a455a.LINK,
                    onClick: onClickLogout
                })
            ]
        })
    });
};
var $fc6840133e04adc0$var$$be203e745bcefb12$export$2e2bcd8739ae039 = $fc6840133e04adc0$export$edf27be85e5f6da0;
const $fc6840133e04adc0$var$$be203e745bcefb12$var$pageStyles = (0, $74Zh5.css)({
    display: "flex",
    width: "100%",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center"
});
const $fc6840133e04adc0$var$$be203e745bcefb12$var$containerStyles = (0, $74Zh5.css)({
    maxWidth: "800px",
    minWidth: "375px",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    padding: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.600")
});
const $fc6840133e04adc0$var$$be203e745bcefb12$var$headingStyles = (0, $74Zh5.css)({
    marginTop: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.300"),
    marginBottom: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.200"),
    fontFamily: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("font.family.brand.heading"),
    fontSize: "24px",
    fontWeight: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("font.weight.semibold"),
    lineHeight: "32px",
    textAlign: "center"
});
const $fc6840133e04adc0$var$$be203e745bcefb12$var$descriptionStyles = (0, $74Zh5.css)({
    marginBottom: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.200"),
    color: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.text"),
    fontFamily: "Inter",
    fontWeight: "400",
    lineHeight: "20px",
    textAlign: "center",
    fontSize: "16px"
});
var $fc6840133e04adc0$var$$a0eced43682c2d75$exports = {};
$fc6840133e04adc0$var$$parcel$export($fc6840133e04adc0$var$$a0eced43682c2d75$exports, "LicenseModal", ()=>$fc6840133e04adc0$export$bd0c6e28f5d6b66e);
const $fc6840133e04adc0$export$bd0c6e28f5d6b66e = ({ modalTitle: modalTitle, bodyTitle: bodyTitle, bodyDescription: bodyDescription, closeModal: closeModal, licenses: licenses })=>{
    return (0, $6bec4f26b2cb3094$export$25062201e9e25d76)((0, $9406e400bdd02ea1$export$2e2bcd8739ae039), {
        onClose: closeModal,
        shouldScrollInViewport: false,
        children: [
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $1f902a1f4757a97e$export$2e2bcd8739ae039), {
                children: modalTitle && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$export$a8a3e93435678ff9, {
                    level: 3,
                    fontWeight: 600,
                    children: modalTitle
                })
            }),
            (0, $6bec4f26b2cb3094$export$25062201e9e25d76)((0, $4cfe1b75d32132e5$export$2e2bcd8739ae039), {
                children: [
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("span", {
                        css: (0, $74Zh5.css)({
                            color: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.icon.brand")
                        }),
                        children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $0ae21ee22a245b70$export$765cacec8b0843f3), {
                            testId: "desktop"
                        })
                    }),
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                        css: $fc6840133e04adc0$var$$a0eced43682c2d75$var$spacingContainerStyles,
                        children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$export$a8a3e93435678ff9, {
                            level: 4,
                            fontWeight: 500,
                            children: bodyTitle
                        })
                    }),
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                        css: $fc6840133e04adc0$var$$a0eced43682c2d75$var$spacingContainerStyles,
                        children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $e7c05297f099a1fc$export$2e2bcd8739ae039), {
                            children: bodyDescription
                        })
                    }),
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                        css: $fc6840133e04adc0$var$$a0eced43682c2d75$var$spacingContainerStyles,
                        children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$export$a8a3e93435678ff9, {
                            level: 4,
                            fontWeight: 500,
                            children: "Attributions for Open Source Libraries"
                        })
                    }),
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                        css: $fc6840133e04adc0$var$$a0eced43682c2d75$var$spacingContainerStyles,
                        children: licenses?.length && licenses.map((license, index)=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                                css: (0, $74Zh5.css)({
                                    padding: `${(0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.100")} 0`
                                }),
                                children: (0, $6bec4f26b2cb3094$export$25062201e9e25d76)((0, $e7c05297f099a1fc$export$2e2bcd8739ae039), {
                                    children: [
                                        (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("a", {
                                            css: $fc6840133e04adc0$var$$a0eced43682c2d75$var$licenseTitleStyles,
                                            href: license.link,
                                            children: `${license.packageName} ${license.version}`
                                        }),
                                        (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("p", {
                                            css: (0, $74Zh5.css)({
                                                margin: 0
                                            }),
                                            children: license.description
                                        })
                                    ]
                                }, license.packageName)
                            }, license.packageName + index))
                    })
                ]
            }),
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $52117b12c3dcd012$export$2e2bcd8739ae039), {
                children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $37328c3a94101dc2$export$2e2bcd8739ae039), {
                    appearance: $fc6840133e04adc0$export$261c9483fc4a455a.PRIMARY,
                    onClick: closeModal,
                    children: "Close"
                })
            })
        ]
    });
};
const $fc6840133e04adc0$var$$a0eced43682c2d75$var$spacingContainerStyles = (0, $74Zh5.css)({
    padding: `${(0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.100")} 0`
});
const $fc6840133e04adc0$var$$a0eced43682c2d75$var$licenseTitleStyles = (0, $74Zh5.css)({
    fontWeight: 600
});
var $fc6840133e04adc0$var$$1db60c687807de63$exports = {};
$fc6840133e04adc0$var$$parcel$export($fc6840133e04adc0$var$$1db60c687807de63$exports, "SUCCESS_MESSAGE", ()=>$fc6840133e04adc0$export$5620dbefc1cb6f80);
$fc6840133e04adc0$var$$parcel$export($fc6840133e04adc0$var$$1db60c687807de63$exports, "ERROR_MESSAGE", ()=>$fc6840133e04adc0$export$3f27bc10068ef877);
$fc6840133e04adc0$var$$parcel$export($fc6840133e04adc0$var$$1db60c687807de63$exports, "NewsletterSignup", ()=>$fc6840133e04adc0$export$21041608e6399292);
$fc6840133e04adc0$var$$parcel$export($fc6840133e04adc0$var$$1db60c687807de63$exports, "Environment", ()=>$fc6840133e04adc0$export$7dc6752a22ab011a);
var $fc6840133e04adc0$var$$ca43fe01b6155439$exports = {};
var $fc6840133e04adc0$var$$3ced3ef7e9864bf1$exports = {};
$fc6840133e04adc0$var$$parcel$export($fc6840133e04adc0$var$$3ced3ef7e9864bf1$exports, "DESKTOP_SCREEN_WIDTH", ()=>$fc6840133e04adc0$export$27ed77542911fb0e);
$fc6840133e04adc0$var$$parcel$export($fc6840133e04adc0$var$$3ced3ef7e9864bf1$exports, "TABLET_SCREEN_WIDTH", ()=>$fc6840133e04adc0$export$62d1d6124a8e4649);
$fc6840133e04adc0$var$$parcel$export($fc6840133e04adc0$var$$3ced3ef7e9864bf1$exports, "useDeviceSize", ()=>$fc6840133e04adc0$export$4616d33c54ae5baf);
// Default to a common desktop device width (is used to handle window object not being available during SSR)
const $fc6840133e04adc0$var$$3ced3ef7e9864bf1$var$DEFAULT_WIDTH = 1440;
const $fc6840133e04adc0$export$27ed77542911fb0e = 1024;
const $fc6840133e04adc0$export$62d1d6124a8e4649 = 900;
const $fc6840133e04adc0$export$4616d33c54ae5baf = ()=>{
    const [width, setWidth] = (0, $5FkrB.useState)(typeof window !== "undefined" ? window.innerWidth : $fc6840133e04adc0$var$$3ced3ef7e9864bf1$var$DEFAULT_WIDTH);
    const handleWindowResize = ()=>{
        setWidth(window.innerWidth);
    };
    (0, $5FkrB.useEffect)(()=>{
        if (typeof window === "undefined") return;
        if (width === $fc6840133e04adc0$var$$3ced3ef7e9864bf1$var$DEFAULT_WIDTH && width !== window.innerWidth) handleWindowResize();
        window.addEventListener("resize", handleWindowResize);
        return ()=>window.removeEventListener("resize", handleWindowResize);
    // width intentionally excluded (stable state setter)
    /* eslint-disable react-hooks/exhaustive-deps */ }, []);
    /* eslint-enable react-hooks/exhaustive-deps */ return width;
};
var $fc6840133e04adc0$var$$cbd57b1b072c1da3$exports = {};
$fc6840133e04adc0$var$$parcel$export($fc6840133e04adc0$var$$cbd57b1b072c1da3$exports, "usePostNewsletterSignup", ()=>$fc6840133e04adc0$export$ea96d97e8873ca7f);
const $fc6840133e04adc0$var$$cbd57b1b072c1da3$var$NEWSLETTER_FORM_TYPE = "community_learning_signup";
const $fc6840133e04adc0$var$$cbd57b1b072c1da3$var$NEWSLETTER_FORM_DEF = "pointALead";
const $fc6840133e04adc0$var$$cbd57b1b072c1da3$var$WAC_BASE_URL = {
    [$fc6840133e04adc0$export$7dc6752a22ab011a.LOCAL]: "/api/wac",
    [$fc6840133e04adc0$export$7dc6752a22ab011a.DEVELOPMENT]: "https://wac.stg.internal.atlassian.com",
    [$fc6840133e04adc0$export$7dc6752a22ab011a.STAGING]: "https://wac.stg.internal.atlassian.com",
    [$fc6840133e04adc0$export$7dc6752a22ab011a.PRODUCTION]: "https://www.atlassian.com"
};
const $fc6840133e04adc0$export$ea96d97e8873ca7f = ({ environment: environment = $fc6840133e04adc0$export$7dc6752a22ab011a.DEVELOPMENT, onError: onError = ()=>null, onSuccess: onSuccess = ()=>null })=>{
    const [loading, setLoading] = (0, $5FkrB.useState)(false);
    const [error, setError] = (0, $5FkrB.useState)(null);
    const [success, setSuccess] = (0, $5FkrB.useState)(false);
    const handleNewsletterSignup = async (formValues, formUrl)=>{
        setLoading(true);
        setError(null);
        setSuccess(false);
        try {
            const preferencesResponse = await $fc6840133e04adc0$var$$cbd57b1b072c1da3$var$postPreferencesUpdate(formValues, environment, formUrl);
            if (!preferencesResponse.ok || preferencesResponse.status !== 202) throw new Error(`Error in postPreferencesUpdate with status: ${preferencesResponse.status}`);
            const wacResponse = await $fc6840133e04adc0$var$$cbd57b1b072c1da3$var$postWacFormLead(formValues, environment);
            if (!wacResponse.ok || wacResponse.status !== 200) throw new Error(`Error in postWacFormLead with status: ${wacResponse.status}`);
            onSuccess();
            setSuccess(true);
        } catch (error) {
            if (error instanceof Error) setError(error.message);
            onError(error);
        } finally{
            setLoading(false);
        }
    };
    return {
        handleNewsletterSignup: handleNewsletterSignup,
        loading: loading,
        error: error,
        success: success
    };
};
const $fc6840133e04adc0$var$$cbd57b1b072c1da3$var$postPreferencesUpdate = async (formValues, environment, formUrl)=>{
    const locale = navigator.language || Intl.DateTimeFormat().resolvedOptions().locale;
    const region = locale.split("-")[1];
    const requestOptions = {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify({
            consentCheckboxValue: true,
            consentLabelText: "By signing up, you agree to receive promotional emails including product news, events, and more from Atlassian and its affiliates, and acknowledge and accept the Atlassian Privacy Policy.",
            email: formValues.email,
            formUrl: formUrl || "https://community.atlassian.com/",
            formId: "655e8a50-2d1f-4c1c-a782-fb5333e272a8",
            locale: region,
            paramsLocale: region,
            privacyPolicyText: '<p>By signing up, you agree to receive promotional emails including product news, events, and more from Atlassian and its affiliates, and acknowledge and accept the Atlassian Privacy Policy. <a href=\\"https://www.atlassian.com/legal/privacy-policy#what-this-policy-covers\\">Atlassian Privacy Policy</a>.</p>\n',
            site: "atlassian"
        })
    };
    return fetch($fc6840133e04adc0$var$$cbd57b1b072c1da3$var$WAC_BASE_URL[environment] + "/gateway/api/preferencesV2/update", requestOptions);
};
// Initiates POST to /streamhub/wacformlead
// Endpoint in: https://bitbucket.org/atlassian/bxp-express/src/routes/streamhubSubmission.ts
const $fc6840133e04adc0$var$$cbd57b1b072c1da3$var$postWacFormLead = async (formValues, environment)=>{
    const now = new Date();
    const requestOptions = {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify({
            ...formValues,
            formType: $fc6840133e04adc0$var$$cbd57b1b072c1da3$var$NEWSLETTER_FORM_TYPE,
            formDef: $fc6840133e04adc0$var$$cbd57b1b072c1da3$var$NEWSLETTER_FORM_DEF,
            created_at: now.toISOString(),
            submitted: now.toString()
        })
    };
    return fetch($fc6840133e04adc0$var$$cbd57b1b072c1da3$var$WAC_BASE_URL[environment] + "/endpoint/streamhub/wacformlead", requestOptions);
};
var $fc6840133e04adc0$var$$18cdd3872ade1318$exports = {};
$fc6840133e04adc0$var$$parcel$export($fc6840133e04adc0$var$$18cdd3872ade1318$exports, "useScrollActiveSection", ()=>$fc6840133e04adc0$export$c0e9cacf89df0750);
const $fc6840133e04adc0$export$c0e9cacf89df0750 = ({ links: links, containerRef: containerRef, options: options = {} })=>{
    const [activeHref, setActiveHref] = (0, $5FkrB.useState)("");
    const { triggerPoint: triggerPoint = 0.3, topThreshold: topThreshold = 100 } = options;
    (0, $5FkrB.useEffect)(()=>{
        // Derive section IDs from links
        const linkHrefs = links.map((link)=>link.href ? link.href : $fc6840133e04adc0$export$1bdcd43c8c2377cf(link.label));
        const sectionIds = linkHrefs.map((href)=>href.replace("#", ""));
        // Find sections by the IDs we derived from links
        const sections = sectionIds.map((id)=>document.getElementById(id)).filter(Boolean);
        if (sections.length === 0) return;
        const container = containerRef?.current;
        const isWindowScroll = !container;
        let ticking = false;
        const updateActiveSection = ()=>{
            // Get scroll position and dimensions
            const scrollY = isWindowScroll ? window.scrollY : container.scrollTop;
            const viewportHeight = isWindowScroll ? window.innerHeight : container.clientHeight;
            const triggerPointPx = viewportHeight * triggerPoint;
            // If we're at the very top, always select the first section
            if (scrollY < topThreshold) {
                setActiveHref(linkHrefs[0]);
                return;
            }
            // Find which section is currently at the trigger point
            let currentSectionIndex = 0;
            sections.forEach((section, index)=>{
                const rect = section.getBoundingClientRect();
                if (isWindowScroll) {
                    if (rect.top <= triggerPointPx) currentSectionIndex = index;
                } else {
                    // For container scroll, calculate relative position
                    const containerRect = container.getBoundingClientRect();
                    const relativeTop = rect.top - containerRect.top;
                    if (relativeTop <= triggerPointPx) currentSectionIndex = index;
                }
            });
            setActiveHref(linkHrefs[currentSectionIndex]);
        };
        const handleScroll = ()=>{
            if (!ticking) {
                window.requestAnimationFrame(()=>{
                    updateActiveSection();
                    ticking = false;
                });
                ticking = true;
            }
        };
        // Set initial active section
        updateActiveSection();
        // Attach scroll listener to container or window
        if (isWindowScroll) window.addEventListener("scroll", handleScroll, {
            passive: true
        });
        else container.addEventListener("scroll", handleScroll, {
            passive: true
        });
        return ()=>{
            if (isWindowScroll) window.removeEventListener("scroll", handleScroll);
            else container.removeEventListener("scroll", handleScroll);
        };
    }, [
        links,
        containerRef,
        triggerPoint,
        topThreshold
    ]);
    return activeHref;
};
$fc6840133e04adc0$var$$parcel$exportWildcard($fc6840133e04adc0$var$$ca43fe01b6155439$exports, $fc6840133e04adc0$var$$3ced3ef7e9864bf1$exports);
$fc6840133e04adc0$var$$parcel$exportWildcard($fc6840133e04adc0$var$$ca43fe01b6155439$exports, $fc6840133e04adc0$var$$633811e9cd66d921$exports);
$fc6840133e04adc0$var$$parcel$exportWildcard($fc6840133e04adc0$var$$ca43fe01b6155439$exports, $fc6840133e04adc0$var$$6e8a4d5d78071ed7$exports);
$fc6840133e04adc0$var$$parcel$exportWildcard($fc6840133e04adc0$var$$ca43fe01b6155439$exports, $fc6840133e04adc0$var$$965a3cfbe886b380$exports);
$fc6840133e04adc0$var$$parcel$exportWildcard($fc6840133e04adc0$var$$ca43fe01b6155439$exports, $fc6840133e04adc0$var$$cbd57b1b072c1da3$exports);
$fc6840133e04adc0$var$$parcel$exportWildcard($fc6840133e04adc0$var$$ca43fe01b6155439$exports, $fc6840133e04adc0$var$$18cdd3872ade1318$exports);
var $fc6840133e04adc0$var$$a6a41c835fd01d00$exports = {};
var $fc6840133e04adc0$var$$1ca64a7075ab6eae$exports = {};
$fc6840133e04adc0$var$$parcel$export($fc6840133e04adc0$var$$1ca64a7075ab6eae$exports, "TextField", ()=>$fc6840133e04adc0$export$2c73285ae9390cec);
const $fc6840133e04adc0$export$2c73285ae9390cec = ({ isInvalid: isInvalid = false, onChange: onChange = ()=>{
    return null;
}, value: value, isDisabled: isDisabled = false, isRequired: isRequired = false, ...rest })=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("input", {
        css: [
            $fc6840133e04adc0$var$$1ca64a7075ab6eae$var$inputStyles,
            isInvalid && $fc6840133e04adc0$var$$1ca64a7075ab6eae$var$invalidStyles,
            isDisabled && $fc6840133e04adc0$var$$1ca64a7075ab6eae$var$disabledStyles
        ],
        onChange: onChange,
        disabled: isDisabled,
        value: value,
        required: isRequired,
        ...rest
    });
const $fc6840133e04adc0$var$$1ca64a7075ab6eae$var$inputStyles = (0, $74Zh5.css)({
    width: "100%",
    height: "42px",
    fontWeight: 400,
    display: "flex",
    padding: "8px 12px",
    alignItems: "center",
    gap: "6px",
    alignSelf: "stretch",
    borderRadius: "4px",
    border: "1px solid #8590A2",
    background: "#FFFFFF",
    fontFamily: "inter",
    fontSize: "16px",
    "&:hover": {
        background: "#F7F8F9"
    },
    "&:focus": {
        borderColor: "inherit",
        boxShadow: "none",
        border: "1px solid #388BFF",
        outline: "1px solid #388BFF"
    }
});
const $fc6840133e04adc0$var$$1ca64a7075ab6eae$var$invalidStyles = (0, $74Zh5.css)({
    border: "1px solid #C9372C",
    outline: "1px solid #C9372C"
});
const $fc6840133e04adc0$var$$1ca64a7075ab6eae$var$disabledStyles = (0, $74Zh5.css)({
    color: "#091E424F",
    border: "1px solid #091E420F",
    background: "#091E4208"
});
var $fc6840133e04adc0$var$$60ab015507144a2b$exports = {};
$fc6840133e04adc0$var$$parcel$export($fc6840133e04adc0$var$$60ab015507144a2b$exports, "TextFieldMessage", ()=>$fc6840133e04adc0$export$9144c5f9beecc4b7);
const $fc6840133e04adc0$export$9144c5f9beecc4b7 = ({ message: message = "Example text here", type: type = "valid" })=>(0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
        css: $fc6840133e04adc0$var$$60ab015507144a2b$var$spacing,
        children: [
            type === "helper" && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $7ad32ef433d8ebba$export$8fbe3c7d0ed2c683), {
                children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("p", {
                    css: $fc6840133e04adc0$var$$60ab015507144a2b$var$helperMessageStyle,
                    children: message
                })
            }),
            type === "error" && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $7ad32ef433d8ebba$export$915e9e7bd4f0f96d), {
                children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("p", {
                    css: $fc6840133e04adc0$var$$60ab015507144a2b$var$errorMessageStyle,
                    children: message
                })
            }),
            type === "valid" && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $7ad32ef433d8ebba$export$5505afb209a532c8), {
                children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("p", {
                    css: $fc6840133e04adc0$var$$60ab015507144a2b$var$validMessageStyles,
                    children: message
                })
            })
        ]
    });
const $fc6840133e04adc0$var$$60ab015507144a2b$var$spacing = (0, $74Zh5.css)({
    marginTop: "2px"
});
const $fc6840133e04adc0$var$$60ab015507144a2b$var$helperMessageStyle = (0, $74Zh5.css)({
    fontFamily: "Inter",
    fontSize: "12px",
    fontStyle: "normal",
    fontWeight: 400,
    lineHeight: "16px"
});
const $fc6840133e04adc0$var$$60ab015507144a2b$var$errorMessageStyle = (0, $74Zh5.css)({
    paddingLeft: "6px",
    fontFamily: "Inter",
    marginTop: "0.5px",
    fontSize: "12px",
    fontStyle: "normal",
    fontWeight: 400,
    lineHeight: "16px"
});
const $fc6840133e04adc0$var$$60ab015507144a2b$var$validMessageStyles = (0, $74Zh5.css)({
    paddingLeft: "6px",
    fontFamily: "Inter",
    fontSize: "12px",
    fontStyle: "normal",
    fontWeight: 400,
    lineHeight: "16px"
});
var $fc6840133e04adc0$var$$57b1d5df6b5425d4$exports = {};
$fc6840133e04adc0$var$$parcel$export($fc6840133e04adc0$var$$57b1d5df6b5425d4$exports, "TextFieldLabel", ()=>$fc6840133e04adc0$export$76375b2580d1f8ac);
const $fc6840133e04adc0$export$76375b2580d1f8ac = ({ labelText: labelText = "Example label", isRequired: isRequired = true })=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $e6c825ca43fa4ec5$export$b04be29aa201d4f5), {
        htmlFor: "basic-textfield",
        children: (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("p", {
            css: $fc6840133e04adc0$var$$57b1d5df6b5425d4$var$labelStyles,
            children: [
                labelText,
                isRequired && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $df8dc48ae4041bc0$export$2e2bcd8739ae039), {})
            ]
        })
    });
const $fc6840133e04adc0$var$$57b1d5df6b5425d4$var$labelStyles = (0, $74Zh5.css)({
    fontFamily: "Inter",
    color: "#44546F",
    fontSize: "14px",
    fontStyle: "normal",
    fontWeight: 600,
    lineHeight: "20px"
});
var $fc6840133e04adc0$var$$4be7278e65b71184$exports = {};
$fc6840133e04adc0$var$$parcel$export($fc6840133e04adc0$var$$4be7278e65b71184$exports, "UnifiedAccountCardContent", ()=>$fc6840133e04adc0$export$c031b829a2452999);
var $fc6840133e04adc0$var$$fc6addd2061b87dd$exports = {};
$fc6840133e04adc0$var$$parcel$defineInteropFlag($fc6840133e04adc0$var$$fc6addd2061b87dd$exports);
$fc6840133e04adc0$var$$parcel$export($fc6840133e04adc0$var$$fc6addd2061b87dd$exports, "default", ()=>$fc6840133e04adc0$var$$fc6addd2061b87dd$export$2e2bcd8739ae039);
const $fc6840133e04adc0$var$$fc6addd2061b87dd$var$UnifiedMoreDropdownMenu = ({ actions: actions, isDisabled: isDisabled })=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $5a40bdc8514ad3b7$export$2e2bcd8739ae039), {
        trigger: ({ triggerRef: triggerRef, ...props })=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                css: $fc6840133e04adc0$var$$fc6addd2061b87dd$var$buttonWrapperStyle,
                "data-testid": "dropdown-trigger",
                children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $744d288f60bb77dd$export$2e2bcd8739ae039), {
                    ...props,
                    icon: (0, (/*@__PURE__*/$parcel$interopDefault($90374d00f267e742$exports))),
                    label: "more",
                    ref: triggerRef,
                    appearance: "default",
                    isDisabled: isDisabled
                })
            }),
        placement: "bottom-end",
        shouldRenderToParent: true,
        children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $65699b966485ea1d$export$2e2bcd8739ae039), {
            children: actions.map((action, index)=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $d1103224b1f806e2$export$2e2bcd8739ae039), {
                    onClick: action.onClick,
                    children: action.text
                }, index))
        })
    });
var $fc6840133e04adc0$var$$fc6addd2061b87dd$export$2e2bcd8739ae039 = $fc6840133e04adc0$var$$fc6addd2061b87dd$var$UnifiedMoreDropdownMenu;
const $fc6840133e04adc0$var$$fc6addd2061b87dd$var$buttonWrapperStyle = (0, $74Zh5.css)({
    backgroundColor: "#FFFFFF",
    borderRadius: "3px"
});
const $fc6840133e04adc0$export$c031b829a2452999 = ({ email: email, tags: tags, actions: actions, disableMenu: disableMenu })=>{
    return (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
        css: $fc6840133e04adc0$var$$4be7278e65b71184$var$contentWrapperStyles,
        children: [
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                css: $fc6840133e04adc0$var$$4be7278e65b71184$var$dropdownWrapperStyles,
                children: disableMenu ? null : (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$var$$fc6addd2061b87dd$export$2e2bcd8739ae039, {
                    actions: actions,
                    isDisabled: disableMenu
                })
            }),
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                css: $fc6840133e04adc0$var$$4be7278e65b71184$var$coverImageWrapperStyles,
                children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                    css: $fc6840133e04adc0$var$$4be7278e65b71184$var$coverImageStyles,
                    children: (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("svg", {
                        width: "350",
                        height: "82",
                        viewBox: "0 0 350 82",
                        fill: "none",
                        xmlns: "http://www.w3.org/2000/svg",
                        children: [
                            (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("g", {
                                clipPath: "url(#clip0_985_48434)",
                                children: [
                                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("path", {
                                        d: "M167.322 38.821C177.93 34.78 184.789 30.2722 188.858 25.4255C193.11 20.3612 194.263 14.9878 193.538 9.5957C192.822 4.25652 190.271 -1.06544 187.204 -6.12471C185.194 -9.43933 182.915 -12.7134 180.746 -15.8286C179.821 -17.1581 178.915 -18.4586 178.059 -19.7211L221.313 -48.8693C222.054 -47.7618 222.787 -46.6694 223.511 -45.5908C241.665 -18.5315 254.013 -0.126895 247.42 31.5817C243.994 48.0569 230.739 60.1325 218.142 68.1357C211.864 72.1242 205.799 75.0696 201.302 77.0177C199.054 77.9913 197.201 78.7147 195.913 79.1939C195.383 79.3909 194.949 79.5465 194.622 79.6613L167.322 38.821Z",
                                        stroke: "#0C66E4",
                                        strokeWidth: "2"
                                    }),
                                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("path", {
                                        d: "M72.3053 -15.1135C82.328 -17.928 92.5012 -22.9961 101.629 -29.5552C110.755 -36.1128 118.158 -43.5947 123.819 -51.8086L166.607 8.14819C159.501 15.3002 151.561 22.0298 142.555 28.5017C133.545 34.9761 124.385 40.4509 115.146 44.9177L72.3053 -15.1135Z",
                                        stroke: "#0C66E4",
                                        strokeWidth: "2"
                                    }),
                                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("path", {
                                        d: "M145.593 48.2832L177.327 107.164L160.851 130.97L94.7005 121.821L95.1645 67.6983L145.593 48.2832Z",
                                        stroke: "#0C66E4",
                                        strokeWidth: "2"
                                    }),
                                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("path", {
                                        d: "M315.34 72.2206L315.355 72.2331L315.372 72.2449C315.778 72.5416 316.18 72.8355 316.577 73.1258C320.114 75.7149 323.269 78.0239 326.324 79.6083C329.758 81.3894 333.158 82.3068 336.975 81.7093C341.291 81.0335 344.5 78.5429 346.241 74.1008C347.949 69.7418 348.232 63.5491 346.967 55.3884L346.241 50.7055L378.755 45.6149C379.596 48.7568 380.163 52.4046 380.848 56.8254C383.982 77.0371 381.669 92.493 375.423 103.369C369.195 114.213 358.984 120.632 346.012 122.663C327.026 125.636 315.363 118.74 304.711 110.615L304.701 110.608L304.691 110.601C304.22 110.259 303.755 109.92 303.296 109.586C299.84 107.069 296.744 104.815 293.745 103.255C290.311 101.469 286.909 100.54 283.091 101.138L282.103 101.293L282.115 101.369C278.291 102.255 275.438 104.702 273.833 108.804C272.126 113.168 271.843 119.36 273.105 127.5C273.249 128.428 273.503 129.339 273.738 130.185L273.746 130.211C273.89 130.731 274.028 131.226 274.142 131.711L241.242 136.862C240.465 134.058 239.898 130.414 239.159 125.649C236.059 105.652 238.499 90.2821 244.81 79.446C251.105 68.6378 261.321 62.2203 274.06 60.2258C283.596 58.7327 291.242 59.6302 297.818 61.9301C304.407 64.2347 309.975 67.9653 315.34 72.2206Z",
                                        stroke: "#0C66E4",
                                        strokeWidth: "2"
                                    }),
                                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("path", {
                                        d: "M292.179 -56.9295L292.37 -57.2966L292.352 -57.3526L301.854 -75.6471L361.496 -44.2691L338.629 -0.241775C322.356 31.0905 300.658 42.9482 277.565 44.2706C265.48 24.4864 262.733 -0.232558 279.024 -31.6005L292.179 -56.9295Z",
                                        stroke: "#0C66E4",
                                        strokeWidth: "2"
                                    })
                                ]
                            }),
                            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("defs", {
                                children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("clipPath", {
                                    id: "clip0_985_48434",
                                    children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("path", {
                                        d: "M0 8C0 3.58172 3.58172 0 8 0H386C390.418 0 394 3.58172 394 8V96H0V8Z",
                                        fill: "white"
                                    })
                                })
                            })
                        ]
                    })
                })
            }),
            (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                css: $fc6840133e04adc0$var$$4be7278e65b71184$var$textWrapperStyles,
                children: [
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("p", {
                        css: $fc6840133e04adc0$var$$4be7278e65b71184$var$emailStyles,
                        children: email
                    }),
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                        css: $fc6840133e04adc0$var$$4be7278e65b71184$var$tagsWrapperStyles,
                        children: tags.map((tag, index)=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                                css: $fc6840133e04adc0$var$$4be7278e65b71184$var$tagItemStyles,
                                children: tag
                            }, index))
                    })
                ]
            })
        ]
    });
};
const $fc6840133e04adc0$var$$4be7278e65b71184$var$contentWrapperStyles = (0, $74Zh5.css)({
    display: "flex",
    flexDirection: "column",
    width: "100%",
    padding: 0,
    margin: 0,
    height: "100%",
    borderRadius: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.100")
});
const $fc6840133e04adc0$var$$4be7278e65b71184$var$coverImageWrapperStyles = (0, $74Zh5.css)({
    width: "100%",
    overflow: "hidden",
    borderTopLeftRadius: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.100"),
    borderTopRightRadius: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.100")
});
const $fc6840133e04adc0$var$$4be7278e65b71184$var$coverImageStyles = (0, $74Zh5.css)({
    background: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("elevation.surface.sunken"),
    width: "100%",
    height: "82px",
    objectFit: "cover",
    margin: 0,
    padding: 0,
    display: "block"
});
const $fc6840133e04adc0$var$$4be7278e65b71184$var$textWrapperStyles = (0, $74Zh5.css)({
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    padding: "24px",
    boxSizing: "border-box",
    width: "100%"
});
const $fc6840133e04adc0$var$$4be7278e65b71184$var$emailStyles = (0, $74Zh5.css)({
    fontFamily: "Inter",
    marginBottom: "12px",
    fontSize: "16px",
    color: "#44546F",
    lineHeight: "24px"
});
const $fc6840133e04adc0$var$$4be7278e65b71184$var$tagsWrapperStyles = (0, $74Zh5.css)({
    display: "flex",
    flexDirection: "row",
    gap: "8px"
});
const $fc6840133e04adc0$var$$4be7278e65b71184$var$tagItemStyles = (0, $74Zh5.css)({
    display: "inline-block"
});
const $fc6840133e04adc0$var$$4be7278e65b71184$var$dropdownWrapperStyles = (0, $74Zh5.css)({
    position: "absolute",
    top: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.150"),
    right: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.150")
});
var $fc6840133e04adc0$var$$db9d361cdef36cb6$exports = {};
$fc6840133e04adc0$var$$parcel$export($fc6840133e04adc0$var$$db9d361cdef36cb6$exports, "UnifiedAccountContainerCard", ()=>$fc6840133e04adc0$export$c9d2f1697787ae74);
const $fc6840133e04adc0$export$c9d2f1697787ae74 = ({ children: children, testId: testId, onClick: onClick, isAddAccount: isAddAccount = false })=>{
    return (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("button", {
        "data-testid": testId,
        css: [
            $fc6840133e04adc0$var$$db9d361cdef36cb6$var$unstyledButtonStyles,
            $fc6840133e04adc0$var$$db9d361cdef36cb6$var$cardContainerStyles,
            isAddAccount && $fc6840133e04adc0$var$$db9d361cdef36cb6$var$addAccountStyles,
            isAddAccount ? $fc6840133e04adc0$var$$db9d361cdef36cb6$var$hoverEffectStyles : $fc6840133e04adc0$var$$db9d361cdef36cb6$var$noPointerCursorStyles
        ],
        onClick: isAddAccount ? onClick : undefined,
        children: children
    });
};
const $fc6840133e04adc0$var$$db9d361cdef36cb6$var$unstyledButtonStyles = (0, $74Zh5.css)({
    display: "flex",
    textAlign: "inherit",
    textDecoration: "none",
    background: "none",
    color: "inherit",
    border: "none",
    padding: 0,
    fontFamily: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("font.family.brand.body")
});
const $fc6840133e04adc0$var$$db9d361cdef36cb6$var$cardContainerStyles = (0, $74Zh5.css)({
    position: "relative",
    textDecoration: "none",
    display: "flex",
    flexDirection: "column",
    boxSizing: "border-box",
    boxShadow: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("elevation.shadow.raised"),
    borderRadius: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.100"),
    background: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("elevation.surface"),
    alignItems: "center",
    zIndex: 1,
    justifyContent: "center",
    height: "194px",
    transition: "box-shadow 0.2s ease",
    width: "300px",
    "@media (min-width: 768px) and (max-width: 1279px)": {
        width: "290px"
    },
    "@media (min-width: 1280px)": {
        width: "290px"
    }
});
const $fc6840133e04adc0$var$$db9d361cdef36cb6$var$hoverEffectStyles = (0, $74Zh5.css)({
    cursor: "pointer",
    "&:hover": {
        boxShadow: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("elevation.shadow.overlay")
    },
    "&:active": {
        outline: `2px solid ${(0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.border.selected")}`
    }
});
const $fc6840133e04adc0$var$$db9d361cdef36cb6$var$noPointerCursorStyles = (0, $74Zh5.css)({
    cursor: "default"
});
const $fc6840133e04adc0$var$$db9d361cdef36cb6$var$addAccountStyles = (0, $74Zh5.css)({
    border: `1px dashed ${(0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.border")}`,
    boxShadow: "none"
});
var $fc6840133e04adc0$var$$e6da040d2ca2c72a$exports = {};
$fc6840133e04adc0$var$$parcel$export($fc6840133e04adc0$var$$e6da040d2ca2c72a$exports, "UnifiedAccountLinkAccountCard", ()=>$fc6840133e04adc0$export$fc13faf098015d3a);
const $fc6840133e04adc0$var$$5089616a215e9052$var$ellipseStyles = (0, $74Zh5.css)({
    width: "72px",
    height: "72px",
    backgroundColor: "#D3F1A7",
    borderRadius: "50%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
});
const $fc6840133e04adc0$var$$5089616a215e9052$export$f21ab0717a89c77f = ()=>{
    return (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
        css: $fc6840133e04adc0$var$$5089616a215e9052$var$ellipseStyles,
        children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($b5961c39816b4422$exports))), {
            label: "Add",
            size: "large",
            primaryColor: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.icon")
        })
    });
};
const $fc6840133e04adc0$var$$e6da040d2ca2c72a$var$contentStyles = (0, $74Zh5.css)({
    textAlign: "center",
    padding: "17px 48px",
    fontFamily: "Inter, sans-serif",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    height: "100%"
});
const $fc6840133e04adc0$var$$e6da040d2ca2c72a$var$textStyles = (0, $74Zh5.css)({
    marginTop: "16px",
    color: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.icon"),
    fontSize: "16px",
    lineHeight: "24px"
});
const $fc6840133e04adc0$export$fc13faf098015d3a = ()=>{
    return (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
        css: $fc6840133e04adc0$var$$e6da040d2ca2c72a$var$contentStyles,
        children: [
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$var$$5089616a215e9052$export$f21ab0717a89c77f, {}),
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                css: $fc6840133e04adc0$var$$e6da040d2ca2c72a$var$textStyles,
                children: "Link account"
            })
        ]
    });
};
var $fc6840133e04adc0$var$$9c7edcd33b2e220b$exports = {};
$fc6840133e04adc0$var$$parcel$export($fc6840133e04adc0$var$$9c7edcd33b2e220b$exports, "UnifiedAccountTagContainer", ()=>$fc6840133e04adc0$export$b27c6704e245f018);
const $fc6840133e04adc0$export$b27c6704e245f018 = ({ children: children })=>{
    return (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
        css: $fc6840133e04adc0$var$$9c7edcd33b2e220b$var$containerStyles,
        children: children
    });
};
const $fc6840133e04adc0$var$$9c7edcd33b2e220b$var$containerStyles = (0, $74Zh5.css)({
    maxWidth: "84px",
    height: "28px",
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    boxSizing: "border-box",
    borderRadius: "4px"
});
var $fc6840133e04adc0$var$$3ec1f71319ba0295$exports = {};
$fc6840133e04adc0$var$$parcel$export($fc6840133e04adc0$var$$3ec1f71319ba0295$exports, "UnifiedAccountTagLoggedIn", ()=>$fc6840133e04adc0$export$8bee5cfdbbc2fc0c);
const $fc6840133e04adc0$var$$3ec1f71319ba0295$var$loggedInContentStyles = (0, $74Zh5.css)({
    backgroundColor: "#626F86",
    color: "#FFFFFF"
});
const $fc6840133e04adc0$export$8bee5cfdbbc2fc0c = ()=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$export$b27c6704e245f018, {
        children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
            css: [
                $fc6840133e04adc0$var$$3ec1f71319ba0295$var$loggedInContentStyles,
                $fc6840133e04adc0$var$$3ec1f71319ba0295$var$baseContentStyles
            ],
            children: "LOGGED IN"
        })
    });
const $fc6840133e04adc0$var$$3ec1f71319ba0295$var$baseContentStyles = (0, $74Zh5.css)({
    width: "84px",
    height: "28px",
    fontFamily: "Charlie Text",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "6px 8px",
    boxSizing: "border-box",
    fontSize: "12px",
    fontWeight: "600",
    borderRadius: "4px"
});
var $fc6840133e04adc0$var$$7cbc56ac0bc2e1de$exports = {};
$fc6840133e04adc0$var$$parcel$export($fc6840133e04adc0$var$$7cbc56ac0bc2e1de$exports, "UnifiedAccountTagPrimary", ()=>$fc6840133e04adc0$export$be7f7dedc3a0e1ad);
const $fc6840133e04adc0$var$$5f6e50d159d7e8e1$var$StarFilledIcon = ()=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("svg", {
        width: "12",
        height: "12",
        viewBox: "0 0 12 12",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("g", {
            id: "Icon / <StarFilledIcon>",
            children: [
                (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("rect", {
                    width: "12",
                    height: "12",
                    rx: "6",
                    fill: "#44546F"
                }),
                (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("path", {
                    id: "Vector",
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M6.0357 8.64198L4.0832 9.66848C4.00063 9.7119 3.90755 9.73135 3.8145 9.72463C3.72146 9.71791 3.63214 9.68529 3.55666 9.63046C3.48118 9.57563 3.42255 9.50078 3.38739 9.41437C3.35223 9.32796 3.34194 9.23344 3.3577 9.14149L3.7302 6.96698L2.1507 5.42698C2.08399 5.36186 2.03683 5.27937 2.01452 5.18886C1.99222 5.09834 1.99566 5.00338 2.02447 4.91472C2.05328 4.82605 2.10631 4.74721 2.17756 4.68709C2.24881 4.62697 2.33545 4.58797 2.4277 4.57448L4.6107 4.25698L5.5872 2.27898C5.62846 2.19525 5.69234 2.12474 5.7716 2.07544C5.85087 2.02613 5.94235 2 6.0357 2C6.12905 2 6.22053 2.02613 6.29979 2.07544C6.37906 2.12474 6.44294 2.19525 6.4842 2.27898L7.4602 4.25698L9.6432 4.57448C9.73549 4.58789 9.82219 4.62684 9.89351 4.68693C9.96482 4.74701 10.0179 4.82585 10.0468 4.91453C10.0756 5.00321 10.0791 5.09819 10.0569 5.18875C10.0346 5.2793 9.98741 5.36182 9.9207 5.42698L8.3407 6.96698L8.7137 9.14149C8.72939 9.23337 8.71908 9.32781 8.68394 9.41414C8.64879 9.50048 8.59022 9.57527 8.51482 9.63008C8.43942 9.68488 8.3502 9.71752 8.25724 9.72431C8.16427 9.7311 8.07126 9.71176 7.9887 9.66848L6.0357 8.64198Z",
                    fill: "white"
                })
            ]
        })
    });
var $fc6840133e04adc0$var$$5f6e50d159d7e8e1$export$2e2bcd8739ae039 = $fc6840133e04adc0$var$$5f6e50d159d7e8e1$var$StarFilledIcon;
const $fc6840133e04adc0$var$$7cbc56ac0bc2e1de$var$primaryContentStyles = (0, $74Zh5.css)({
    backgroundColor: "#FFFFFF",
    color: "#172B4D",
    border: "1px solid #091E4224"
});
const $fc6840133e04adc0$var$$7cbc56ac0bc2e1de$var$iconWrapperStyles = (0, $74Zh5.css)({
    marginRight: "2px",
    display: "flex",
    alignItems: "center"
});
const $fc6840133e04adc0$export$be7f7dedc3a0e1ad = ()=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$export$b27c6704e245f018, {
        children: (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
            css: [
                $fc6840133e04adc0$var$$7cbc56ac0bc2e1de$var$primaryContentStyles,
                $fc6840133e04adc0$var$$7cbc56ac0bc2e1de$var$baseContentStyles
            ],
            children: [
                (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                    css: $fc6840133e04adc0$var$$7cbc56ac0bc2e1de$var$iconWrapperStyles,
                    children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$var$$5f6e50d159d7e8e1$export$2e2bcd8739ae039, {})
                }),
                "PRIMARY"
            ]
        })
    });
const $fc6840133e04adc0$var$$7cbc56ac0bc2e1de$var$baseContentStyles = (0, $74Zh5.css)({
    width: "84px",
    height: "28px",
    fontFamily: "Charlie Text",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "6px 8px",
    boxSizing: "border-box",
    fontSize: "12px",
    fontWeight: "600",
    borderRadius: "4px"
});
var $fc6840133e04adc0$var$$01ef21c48d795edb$exports = {};
$fc6840133e04adc0$var$$parcel$export($fc6840133e04adc0$var$$01ef21c48d795edb$exports, "UnifiedAccountTagLinked", ()=>$fc6840133e04adc0$export$446c53c437a3d14a);
const $fc6840133e04adc0$var$$01ef21c48d795edb$var$primaryContentStyles = (0, $74Zh5.css)({
    backgroundColor: "#FFFFFF",
    color: "#172B4D",
    border: "1px solid #091E4224"
});
const $fc6840133e04adc0$export$446c53c437a3d14a = ()=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$export$b27c6704e245f018, {
        children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
            css: [
                $fc6840133e04adc0$var$$01ef21c48d795edb$var$primaryContentStyles,
                $fc6840133e04adc0$var$$01ef21c48d795edb$var$baseContentStyles
            ],
            children: "LINKED"
        })
    });
const $fc6840133e04adc0$var$$01ef21c48d795edb$var$baseContentStyles = (0, $74Zh5.css)({
    fontFamily: "Charlie Text",
    height: "28px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "6px 8px",
    boxSizing: "border-box",
    fontSize: "12px",
    fontWeight: "600",
    borderRadius: "4px"
});
var $fc6840133e04adc0$var$$80cd39a44f20f361$exports = {};
$fc6840133e04adc0$var$$parcel$defineInteropFlag($fc6840133e04adc0$var$$80cd39a44f20f361$exports);
$fc6840133e04adc0$var$$parcel$export($fc6840133e04adc0$var$$80cd39a44f20f361$exports, "SharedFooter", ()=>$fc6840133e04adc0$export$7a92b4adf6bd95bb);
$fc6840133e04adc0$var$$parcel$export($fc6840133e04adc0$var$$80cd39a44f20f361$exports, "default", ()=>$fc6840133e04adc0$var$$80cd39a44f20f361$export$2e2bcd8739ae039);
var $fc6840133e04adc0$var$$85d9a99cb49b730f$require$Buffer = (0, $7KfP5.Buffer);
const $fc6840133e04adc0$var$$85d9a99cb49b730f$var$svgStringDesktopFooterWider = `<svg width="3597" height="220" viewBox="0 0 3597 220" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clipPath="url(#clip0_1461_26831)">
<path d="M2132.54 314.529C2146.63 313.033 2161.59 314.218 2177.19 318.272C2192.78 322.325 2207.65 328.995 2219.68 337.581L2245.71 236.527C2232.41 230.415 2218.06 225.333 2202.74 221.351C2187.42 217.369 2172.81 214.822 2158.49 213.604L2132.48 314.564L2132.54 314.529Z" fill="#BF63F3"/>
<path d="M1905.63 13.0095L1932.77 57.7351C1902.11 76.8306 1895.31 95.1589 1908.88 117.522C1922.45 139.884 1942.19 142.885 1973.45 124.776L2000.59 169.502C1939.18 206.46 1898.36 193.057 1867.63 142.412C1836.9 91.7667 1844.25 50.0145 1905.66 13.0565L1905.63 13.0095Z" fill="#BF63F3"/>
<path d="M2653.64 67.1608C2651.12 70.158 2648.74 73.5509 2646.59 77.2837C2644.43 81.0165 2642.62 84.8928 2641.3 88.6374C2633.3 110.896 2640.22 131.445 2658.16 146.049C2661.21 148.541 2664.61 150.872 2668.29 152.996C2671.97 155.121 2675.99 157.022 2679.83 158.505C2701.49 166.665 2722.75 162.381 2737.96 144.444C2740.54 141.43 2742.94 137.998 2745.14 134.187C2747.35 130.375 2749.05 126.695 2750.38 123.013C2758.29 100.911 2751.37 80.3628 2733.5 65.6405C2730.31 63.0181 2726.79 60.6186 2722.96 58.4028C2719.12 56.187 2715.6 54.5204 2711.88 53.1059C2690.25 44.8669 2668.94 49.1675 2653.72 67.2065L2653.64 67.1608Z" fill="#FCA700"/>
<path d="M1895.14 242.555C1892.93 245.176 1890.84 248.144 1888.96 251.41C1887.07 254.676 1885.48 258.069 1884.33 261.347C1877.35 280.834 1883.48 298.855 1899.28 311.691C1901.96 313.881 1904.95 315.93 1908.19 317.8C1911.43 319.669 1914.97 321.344 1918.34 322.652C1937.4 329.85 1956.07 326.142 1969.39 310.457C1971.66 307.822 1973.76 304.819 1975.69 301.484C1977.61 298.149 1979.1 294.929 1980.27 291.705C1987.17 272.356 1981.05 254.335 1965.3 241.396C1962.5 239.091 1959.4 236.981 1956.03 235.031C1952.65 233.081 1949.55 231.613 1946.28 230.365C1927.26 223.099 1908.54 226.821 1895.21 242.595L1895.14 242.555Z" fill="#1868DB"/>
<path d="M2377.56 187.36C2332.41 205.776 2303.33 188.768 2293.49 181.225L2286.73 268.152C2295.75 275.232 2321.35 289.599 2365.56 271.568C2407.5 254.47 2435.57 267.92 2447.25 275.96L2454 189.016C2443.32 181.668 2418.37 170.713 2377.56 187.36Z" fill="#1868DB"/>
<path d="M1956.63 392.322L2067.8 363.764L2103.25 229.834L2021.88 185.761L1956.63 392.322Z" fill="#82B536"/>
<path d="M1814.81 214.821C1777.79 204.861 1754.37 195.571 1741.02 184.518L1735.75 299.502C1749.51 304.079 1764.42 308.373 1780.76 312.342C1816.54 322.129 1838.14 331.724 1849.86 343.657L1855.25 225.91C1842.76 221.962 1829.36 218.25 1814.81 214.821Z" fill="#FCA700"/>
<path d="M1717.71 131.43L1767.34 121.105L1788.77 77.5333L1765.89 33.5097L1715.9 22.1945L1676.46 52.1123L1677.27 100.718L1717.71 131.43Z" fill="#82B536"/>
<path d="M2287.3 0.329368C2292.26 17.6796 2294.03 36.6867 2292.33 57.0839C2290.62 77.481 2285.46 97.5178 2277.28 114.391L2410.19 125.941C2414.99 107.988 2418.26 88.9353 2419.94 68.8981C2421.61 48.8609 2421.63 30.0094 2420.04 11.8036L2287.25 0.264012L2287.3 0.329368Z" fill="#82B536"/>
<path d="M2732.21 188.352C2731.07 192.109 2730.22 196.176 2729.74 200.467C2729.26 204.759 2729.16 209.049 2729.49 213.022C2731.28 236.704 2746.68 252.942 2770.15 259.359C2774.14 260.46 2778.41 261.273 2782.85 261.786C2787.29 262.299 2791.96 262.473 2796.29 262.331C2820.59 261.339 2839.19 249.028 2846.17 226.497C2847.37 222.7 2848.22 218.588 2848.72 214.207C2849.21 209.825 2849.28 205.76 2848.99 201.838C2847.18 178.337 2831.78 162.098 2808.32 155.546C2804.15 154.377 2799.74 153.548 2795.11 153.013C2790.48 152.478 2786.38 152.326 2782.2 152.484C2757.91 153.385 2739.25 165.736 2732.31 188.363L2732.21 188.352Z" fill="#82B536"/>
<path d="M2889.07 147.28C2915.86 136.154 2934.18 130.899 2947.27 131.344L2897.58 60.2224C2887.23 63.8352 2876.31 68.1465 2864.68 73.3134C2838.72 83.9714 2821.36 88.1994 2808.84 86.4762L2859.72 159.306C2869.02 155.908 2878.77 151.943 2889.07 147.28Z" fill="#BF63F3"/>
<path d="M1500.61 92.78C1499.48 96.4691 1498.65 100.462 1498.18 104.676C1497.71 108.89 1497.62 113.103 1497.94 117.004C1499.7 140.257 1514.82 156.202 1537.86 162.503C1541.78 163.584 1545.97 164.382 1550.33 164.886C1554.69 165.39 1559.28 165.56 1563.52 165.421C1587.38 164.447 1605.65 152.359 1612.51 130.235C1613.69 126.507 1614.52 122.47 1615 118.167C1615.49 113.864 1615.56 109.873 1615.27 106.022C1613.5 82.9459 1598.37 67.0012 1575.34 60.5673C1571.24 59.4199 1566.92 58.6058 1562.37 58.0804C1557.82 57.5551 1553.8 57.4053 1549.7 57.5605C1525.84 58.4455 1507.52 70.573 1500.7 92.7908L1500.61 92.78Z" fill="#FCA700"/>
<path d="M2476.23 171.901L2512.57 187.615L2580.4 132.718L2540.7 72.2981L2469.59 84.8102L2476.23 171.901Z" fill="#FCA700"/>
<path d="M1590.18 276.392C1581.18 284.413 1582.82 297.295 1599.18 315.611C1600.94 317.584 1603.22 319.181 1604.98 321.154L1565.44 356.405C1561.81 353.394 1557.79 348.885 1552.5 342.967C1511.68 297.27 1513.72 256.222 1543.27 229.879C1565.29 210.248 1585.75 208.965 1606.41 210.958C1621.55 211.808 1632.33 212.828 1640.38 205.651C1649.37 197.63 1647.78 184.796 1631.38 166.432L1625.63 159.998L1664.69 125.169C1668.74 128.65 1672.77 133.158 1677.63 138.606C1718.87 184.774 1717.35 225.357 1687.28 252.165C1665.26 271.796 1644.39 272.609 1624.1 271.038C1609.01 270.236 1598.18 269.168 1590.13 276.345L1590.18 276.392Z" fill="#BF63F3"/>
<path d="M2627.7 309.01L2674.17 285.958L2684.11 237.19L2650.04 199.408L2597.6 201.079L2566.29 240.945L2579.68 288.97L2627.7 309.01Z" fill="#1868DB"/>
<path d="M2872.12 290.73C2867.27 321.394 2860.18 348.844 2852.92 371.879L2952.23 418.074C2962.37 387.895 2972.61 350.569 2979.35 307.997C2986.08 265.424 2987.84 226.732 2987.52 194.869L2878.89 207.578C2878.69 231.751 2876.97 260.066 2872.12 290.73Z" fill="#1868DB"/>
<path d="M2029.07 76.709L2081.8 60.3305C2094.17 97.6481 2111.48 109.727 2137.85 101.538C2164.21 93.3484 2172.04 73.4588 2160.83 35.7799L2213.56 19.4014C2237.02 93.7899 2213.37 132.978 2153.67 151.525C2093.96 170.071 2052.58 151.08 2029.12 76.6918L2029.07 76.709Z" fill="#1868DB"/>
<path d="M3183.71 263.373L3218.75 257.454C3262.92 249.994 3285.29 225.656 3295.17 194.436C3275.45 168.157 3246.29 152.584 3202.18 160.035L3140.03 170.531L3156.62 268.008L3183.67 263.44L3183.71 263.373Z" fill="#82B536"/>
<path d="M3507.45 240.161L3557.25 236.478L3583.87 196.676L3567.29 150.712L3519.96 133.206L3477.54 157.345L3471.98 204.936L3507.45 240.161Z" fill="#FCA700"/>
<path d="M3409.05 183.497L3432.31 152.723L3395.5 75.4747L3328.88 98.91L3324.57 169.298L3409.05 183.497Z" fill="#BF63F3"/>
<path d="M3096.28 193.6L3071.36 147.313L2999.69 124.541L3013.98 207.767L3075.67 265.657L3096.28 193.6Z" fill="#FCA700"/>
<path d="M3604.18 274.336L3620.24 305.08C3640.49 343.822 3667.68 358.475 3696.55 359.996C3711.89 335.532 3715.4 304.987 3695.17 266.29L3666.68 211.774L3591.71 250.587L3604.11 274.315L3604.18 274.336Z" fill="#1868DB"/>
<path d="M3419.15 246.402C3387.51 238.086 3359.1 229.101 3335.23 220.826L3290.48 267.987C3321.77 279.173 3360.41 291.729 3404.34 303.274C3448.28 314.818 3488.09 322.876 3520.82 328.514L3504.79 265.379C3479.94 260.853 3450.8 254.717 3419.15 246.402Z" fill="#1868DB"/>
<path d="M3194.92 119.479C3224.2 117.038 3243.38 117.413 3255.57 121.325L3234.28 46.2045C3223.2 46.5499 3211.35 47.3509 3198.52 48.703C3170.19 50.9595 3152.29 49.9514 3141.1 45.084L3162.9 122.009C3172.9 121.566 3183.52 120.75 3194.92 119.479Z" fill="#1868DB"/>
<path d="M1080.67 276.053C1089.16 285.428 1102.4 283.893 1120.89 267.24C1122.88 265.447 1124.47 263.118 1126.46 261.324L1163.76 302.525C1160.75 306.228 1156.2 310.327 1150.22 315.707C1104.1 357.253 1061.73 354.658 1033.86 323.868C1013.08 300.924 1011.27 279.808 1012.82 258.521C1013.33 242.923 1014.12 231.819 1006.53 223.431C998.038 214.056 984.845 215.548 966.31 232.244L959.816 238.093L922.961 197.386C926.452 193.256 931.003 189.157 936.501 184.204C983.099 142.231 1024.98 144.284 1053.34 175.616C1074.12 198.56 1075.46 220.103 1074.33 241.006C1073.87 256.561 1073.03 267.708 1080.63 276.096L1080.67 276.053Z" fill="#82B536"/>
<path d="M625.543 193.797C639.63 192.301 654.593 193.486 670.188 197.54C685.782 201.593 700.654 208.263 712.683 216.849L738.712 115.795C725.409 109.683 711.058 104.601 695.739 100.619C680.42 96.6367 665.808 94.0903 651.489 92.8723L625.485 193.832L625.543 193.797Z" fill="#BF63F3"/>
<path d="M1266.86 164.218L1230.53 158.808L1182.68 226.256L1232.61 271.992L1293.45 242.75L1266.86 164.218Z" fill="#FCA700"/>
<path d="M399.069 336.98L422.334 306.205L385.52 228.958L318.902 252.393L314.592 322.781L399.069 336.98Z" fill="#BF63F3"/>
<path d="M388.137 121.823C385.928 124.444 383.843 127.412 381.957 130.678C380.072 133.944 378.484 137.337 377.334 140.615C370.355 160.102 376.477 178.123 392.278 190.959C394.96 193.149 397.955 195.199 401.193 197.068C404.431 198.938 407.967 200.612 411.344 201.92C430.4 209.118 449.068 205.41 462.395 189.725C464.659 187.09 466.763 184.087 468.689 180.752C470.614 177.418 472.102 174.197 473.267 170.973C480.168 151.624 474.045 133.603 458.303 120.664C455.502 118.359 452.403 116.249 449.026 114.299C445.649 112.349 442.55 110.881 439.278 109.634C420.261 102.367 401.539 106.09 388.207 121.863L388.137 121.823Z" fill="#1868DB"/>
<path d="M870.565 66.6285C825.409 85.0438 796.327 68.0356 786.485 60.4931L779.735 147.42C788.749 154.5 814.346 168.867 858.558 150.836C900.496 133.738 928.568 147.188 940.25 155.228L947.002 68.2839C936.315 60.9356 911.368 49.9809 870.565 66.6285Z" fill="#1868DB"/>
<path d="M743.463 217.247C740.532 228.564 734.449 235.337 724.723 239.407C714.173 243.821 704.241 242.98 695.082 237.49L605.16 275.114C646.399 339.254 703.508 358.315 762.522 333.623C817.497 310.622 843.195 267.293 832.726 179.9L743.381 217.282L743.463 217.247Z" fill="#1868DB"/>
<path d="M449.631 271.59L560.8 243.032L596.253 109.102L514.879 65.0287L449.631 271.59Z" fill="#82B536"/>
<path d="M307.812 94.0893C270.79 84.1287 247.365 74.8387 234.016 63.7859L228.75 178.77C242.51 183.347 257.418 187.641 273.761 191.61C309.542 201.397 331.135 210.992 342.854 222.925L348.246 105.178C335.764 101.23 322.362 97.5184 307.812 94.0893Z" fill="#FCA700"/>
<path d="M1225.21 67.6199C1224.07 71.377 1223.22 75.4437 1222.74 79.7352C1222.26 84.0267 1222.16 88.3172 1222.49 92.2903C1224.28 115.972 1239.68 132.21 1263.15 138.627C1267.14 139.728 1271.41 140.541 1275.85 141.054C1280.29 141.567 1284.96 141.741 1289.29 141.599C1313.59 140.607 1332.19 128.296 1339.17 105.765C1340.37 101.968 1341.22 97.8564 1341.72 93.4746C1342.21 89.0927 1342.28 85.0281 1341.99 81.1056C1340.18 57.6047 1324.78 41.3663 1301.32 34.8139C1297.15 33.6454 1292.74 32.8162 1288.11 32.2812C1283.48 31.7462 1279.38 31.5936 1275.2 31.7517C1250.91 32.653 1232.25 45.0039 1225.31 67.631L1225.21 67.6199Z" fill="#82B536"/>
<path d="M83.1762 155.66C74.1789 163.681 75.8177 176.563 92.1789 194.879C93.9408 196.852 96.2182 198.449 97.9802 200.422L58.4398 235.673C54.8145 232.662 50.7872 228.153 45.5013 222.235C4.68234 176.538 6.72077 135.49 36.2695 109.147C58.289 89.5158 78.7491 88.2328 99.414 90.2263C114.549 91.0758 125.328 92.0964 133.378 84.9196C142.375 76.8983 140.778 64.064 124.375 45.7004L118.628 39.2661L157.695 4.43712C161.739 7.91785 165.767 12.4265 170.633 17.8745C211.872 64.0418 210.354 104.625 180.284 131.433C158.265 151.064 137.385 151.877 117.098 150.306C102.005 149.504 91.1843 148.436 83.1342 155.613L83.1762 155.66Z" fill="#BF63F3"/>
<path d="M1120.7 188.278L1167.17 165.226L1177.11 116.458L1143.04 78.6759L1090.6 80.3475L1059.29 120.213L1072.68 168.238L1120.7 188.278Z" fill="#1868DB"/>
<path d="M1365.12 169.998C1360.27 200.662 1353.18 228.112 1345.92 251.147L1445.23 297.342C1455.37 267.164 1465.61 229.838 1472.35 187.265C1479.08 144.692 1480.84 106 1480.52 74.1372L1371.89 86.8457C1371.69 111.019 1369.97 139.334 1365.12 169.998Z" fill="#1868DB"/>
<path d="M184.943 272.962C214.22 270.521 233.398 270.896 245.587 274.808L224.294 199.687C213.221 200.033 201.37 200.834 188.539 202.186C160.208 204.442 142.304 203.434 131.116 198.567L152.92 275.492C162.921 275.048 173.542 274.233 184.943 272.962Z" fill="#1868DB"/>
</g>
<defs>
<clipPath id="clip0_1461_26831">
<rect width="3597" height="220" fill="white"/>
</clipPath>
</defs>
</svg>
`;
const $fc6840133e04adc0$var$$85d9a99cb49b730f$export$f3cfc44c4eba4576 = `data:image/svg+xml;base64,${$fc6840133e04adc0$var$$85d9a99cb49b730f$require$Buffer.from($fc6840133e04adc0$var$$85d9a99cb49b730f$var$svgStringDesktopFooterWider).toString("base64")}`;
const $fc6840133e04adc0$var$$85d9a99cb49b730f$var$svgStringDesktopFooterWide = `<svg width="3305" height="220" viewBox="0 0 3305 220" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clipPath="url(#clip0_1461_26940)">
<path d="M2132.54 314.529C2146.63 313.033 2161.59 314.218 2177.19 318.272C2192.78 322.325 2207.65 328.995 2219.68 337.581L2245.71 236.527C2232.41 230.415 2218.06 225.333 2202.74 221.351C2187.42 217.369 2172.81 214.822 2158.49 213.604L2132.48 314.564L2132.54 314.529Z" fill="#BF63F3"/>
<path d="M1905.63 13.0095L1932.77 57.7351C1902.11 76.8306 1895.31 95.1589 1908.88 117.522C1922.45 139.884 1942.19 142.885 1973.45 124.776L2000.59 169.502C1939.18 206.46 1898.36 193.057 1867.63 142.412C1836.9 91.7667 1844.25 50.0145 1905.66 13.0565L1905.63 13.0095Z" fill="#BF63F3"/>
<path d="M2653.64 67.1608C2651.12 70.158 2648.74 73.5509 2646.59 77.2837C2644.43 81.0165 2642.62 84.8928 2641.3 88.6374C2633.3 110.896 2640.22 131.445 2658.16 146.049C2661.21 148.541 2664.61 150.872 2668.29 152.996C2671.97 155.121 2675.99 157.022 2679.83 158.505C2701.49 166.665 2722.75 162.381 2737.96 144.444C2740.54 141.43 2742.94 137.998 2745.14 134.187C2747.35 130.375 2749.05 126.695 2750.38 123.013C2758.29 100.911 2751.37 80.3628 2733.5 65.6405C2730.31 63.0181 2726.79 60.6186 2722.96 58.4028C2719.12 56.187 2715.6 54.5204 2711.88 53.1059C2690.25 44.8669 2668.94 49.1675 2653.72 67.2065L2653.64 67.1608Z" fill="#FCA700"/>
<path d="M1895.14 242.555C1892.93 245.176 1890.84 248.144 1888.96 251.41C1887.07 254.676 1885.48 258.069 1884.33 261.347C1877.35 280.834 1883.48 298.855 1899.28 311.691C1901.96 313.881 1904.95 315.93 1908.19 317.8C1911.43 319.669 1914.97 321.344 1918.34 322.652C1937.4 329.85 1956.07 326.142 1969.39 310.457C1971.66 307.822 1973.76 304.819 1975.69 301.484C1977.61 298.149 1979.1 294.929 1980.27 291.705C1987.17 272.356 1981.05 254.335 1965.3 241.396C1962.5 239.091 1959.4 236.981 1956.03 235.031C1952.65 233.081 1949.55 231.613 1946.28 230.365C1927.26 223.099 1908.54 226.821 1895.21 242.595L1895.14 242.555Z" fill="#1868DB"/>
<path d="M2377.56 187.36C2332.41 205.776 2303.33 188.768 2293.49 181.225L2286.73 268.152C2295.75 275.232 2321.35 289.599 2365.56 271.568C2407.5 254.47 2435.57 267.92 2447.25 275.96L2454 189.016C2443.32 181.668 2418.37 170.713 2377.56 187.36Z" fill="#1868DB"/>
<path d="M1956.63 392.322L2067.8 363.764L2103.25 229.834L2021.88 185.761L1956.63 392.322Z" fill="#82B536"/>
<path d="M1814.81 214.821C1777.79 204.861 1754.37 195.571 1741.02 184.518L1735.75 299.502C1749.51 304.079 1764.42 308.373 1780.76 312.342C1816.54 322.129 1838.14 331.724 1849.86 343.657L1855.25 225.91C1842.76 221.962 1829.36 218.25 1814.81 214.821Z" fill="#FCA700"/>
<path d="M1717.71 131.43L1767.34 121.105L1788.77 77.5333L1765.89 33.5097L1715.9 22.1945L1676.46 52.1123L1677.27 100.718L1717.71 131.43Z" fill="#82B536"/>
<path d="M2287.3 0.329368C2292.26 17.6796 2294.03 36.6867 2292.33 57.0839C2290.62 77.481 2285.46 97.5178 2277.28 114.391L2410.19 125.941C2414.99 107.988 2418.26 88.9353 2419.94 68.8981C2421.61 48.8609 2421.63 30.0094 2420.04 11.8036L2287.25 0.264012L2287.3 0.329368Z" fill="#82B536"/>
<path d="M2732.21 188.352C2731.07 192.109 2730.22 196.176 2729.74 200.467C2729.26 204.759 2729.16 209.049 2729.49 213.022C2731.28 236.704 2746.68 252.942 2770.15 259.359C2774.14 260.46 2778.41 261.273 2782.85 261.786C2787.29 262.299 2791.96 262.473 2796.29 262.331C2820.59 261.339 2839.19 249.028 2846.17 226.497C2847.37 222.7 2848.22 218.588 2848.72 214.207C2849.21 209.825 2849.28 205.76 2848.99 201.838C2847.18 178.337 2831.78 162.098 2808.32 155.546C2804.15 154.377 2799.74 153.548 2795.11 153.013C2790.48 152.478 2786.38 152.326 2782.2 152.484C2757.91 153.385 2739.25 165.736 2732.31 188.363L2732.21 188.352Z" fill="#82B536"/>
<path d="M2889.07 147.28C2915.86 136.154 2934.18 130.899 2947.27 131.344L2897.58 60.2224C2887.23 63.8352 2876.31 68.1465 2864.68 73.3134C2838.72 83.9714 2821.36 88.1994 2808.84 86.4762L2859.72 159.306C2869.02 155.908 2878.77 151.943 2889.07 147.28Z" fill="#BF63F3"/>
<path d="M1500.61 92.78C1499.48 96.4691 1498.65 100.462 1498.18 104.676C1497.71 108.89 1497.62 113.103 1497.94 117.004C1499.7 140.257 1514.82 156.202 1537.86 162.503C1541.78 163.584 1545.97 164.382 1550.33 164.886C1554.69 165.39 1559.28 165.56 1563.52 165.421C1587.38 164.447 1605.65 152.359 1612.51 130.235C1613.69 126.507 1614.52 122.47 1615 118.167C1615.49 113.864 1615.56 109.873 1615.27 106.022C1613.5 82.9459 1598.37 67.0012 1575.34 60.5673C1571.24 59.4199 1566.92 58.6058 1562.37 58.0804C1557.82 57.5551 1553.8 57.4053 1549.7 57.5605C1525.84 58.4455 1507.52 70.573 1500.7 92.7908L1500.61 92.78Z" fill="#FCA700"/>
<path d="M2476.23 171.901L2512.57 187.615L2580.4 132.718L2540.7 72.2981L2469.59 84.8102L2476.23 171.901Z" fill="#FCA700"/>
<path d="M1590.18 276.392C1581.18 284.413 1582.82 297.295 1599.18 315.611C1600.94 317.584 1603.22 319.181 1604.98 321.154L1565.44 356.405C1561.81 353.394 1557.79 348.885 1552.5 342.967C1511.68 297.27 1513.72 256.222 1543.27 229.879C1565.29 210.248 1585.75 208.965 1606.41 210.958C1621.55 211.808 1632.33 212.828 1640.38 205.651C1649.37 197.63 1647.78 184.796 1631.38 166.432L1625.63 159.998L1664.69 125.169C1668.74 128.65 1672.77 133.158 1677.63 138.606C1718.87 184.774 1717.35 225.357 1687.28 252.165C1665.26 271.796 1644.39 272.609 1624.1 271.038C1609.01 270.236 1598.18 269.168 1590.13 276.345L1590.18 276.392Z" fill="#BF63F3"/>
<path d="M2627.7 309.01L2674.17 285.958L2684.11 237.19L2650.04 199.408L2597.6 201.079L2566.29 240.945L2579.68 288.97L2627.7 309.01Z" fill="#1868DB"/>
<path d="M2872.12 290.73C2867.27 321.394 2860.18 348.844 2852.92 371.879L2952.23 418.074C2962.37 387.895 2972.61 350.569 2979.35 307.997C2986.08 265.424 2987.84 226.732 2987.52 194.869L2878.89 207.578C2878.69 231.751 2876.97 260.066 2872.12 290.73Z" fill="#1868DB"/>
<path d="M2029.07 76.709L2081.8 60.3305C2094.17 97.6481 2111.48 109.727 2137.85 101.538C2164.21 93.3484 2172.04 73.4588 2160.83 35.7799L2213.56 19.4014C2237.02 93.7899 2213.37 132.978 2153.67 151.525C2093.96 170.071 2052.58 151.08 2029.12 76.6918L2029.07 76.709Z" fill="#1868DB"/>
<path d="M3183.71 263.373L3218.75 257.454C3262.92 249.994 3285.29 225.656 3295.17 194.436C3275.45 168.157 3246.29 152.584 3202.18 160.035L3140.03 170.531L3156.62 268.008L3183.67 263.44L3183.71 263.373Z" fill="#82B536"/>
<path d="M3409.05 183.497L3432.31 152.723L3395.5 75.4747L3328.88 98.91L3324.57 169.298L3409.05 183.497Z" fill="#BF63F3"/>
<path d="M3096.28 193.6L3071.36 147.313L2999.69 124.541L3013.98 207.767L3075.67 265.657L3096.28 193.6Z" fill="#FCA700"/>
<path d="M3419.15 246.402C3387.51 238.086 3359.1 229.101 3335.23 220.826L3290.48 267.987C3321.77 279.173 3360.41 291.729 3404.34 303.274C3448.28 314.818 3488.09 322.876 3520.82 328.514L3504.79 265.379C3479.94 260.853 3450.8 254.717 3419.15 246.402Z" fill="#1868DB"/>
<path d="M3194.92 119.479C3224.2 117.038 3243.38 117.413 3255.57 121.325L3234.28 46.2045C3223.2 46.5499 3211.35 47.3509 3198.52 48.703C3170.19 50.9595 3152.29 49.9514 3141.1 45.084L3162.9 122.009C3172.9 121.566 3183.52 120.75 3194.92 119.479Z" fill="#1868DB"/>
<path d="M1080.67 276.053C1089.16 285.428 1102.4 283.893 1120.89 267.24C1122.88 265.447 1124.47 263.118 1126.46 261.324L1163.76 302.525C1160.75 306.228 1156.2 310.327 1150.22 315.707C1104.1 357.253 1061.73 354.658 1033.86 323.868C1013.08 300.924 1011.27 279.808 1012.82 258.521C1013.33 242.923 1014.12 231.819 1006.53 223.431C998.038 214.056 984.845 215.548 966.31 232.244L959.816 238.093L922.961 197.386C926.452 193.256 931.003 189.157 936.501 184.204C983.099 142.231 1024.98 144.284 1053.34 175.616C1074.12 198.56 1075.46 220.103 1074.33 241.006C1073.87 256.561 1073.03 267.708 1080.63 276.096L1080.67 276.053Z" fill="#82B536"/>
<path d="M625.543 193.797C639.63 192.301 654.593 193.486 670.188 197.54C685.782 201.593 700.654 208.263 712.683 216.849L738.712 115.795C725.409 109.683 711.058 104.601 695.739 100.619C680.42 96.6367 665.808 94.0903 651.489 92.8723L625.485 193.832L625.543 193.797Z" fill="#BF63F3"/>
<path d="M1266.86 164.218L1230.53 158.808L1182.68 226.256L1232.61 271.992L1293.45 242.75L1266.86 164.218Z" fill="#FCA700"/>
<path d="M399.069 336.98L422.334 306.205L385.52 228.958L318.902 252.393L314.592 322.781L399.069 336.98Z" fill="#BF63F3"/>
<path d="M388.137 121.823C385.928 124.444 383.843 127.412 381.957 130.678C380.072 133.944 378.484 137.337 377.334 140.615C370.355 160.102 376.477 178.123 392.278 190.959C394.96 193.149 397.955 195.199 401.193 197.068C404.431 198.938 407.967 200.612 411.344 201.92C430.4 209.118 449.068 205.41 462.395 189.725C464.659 187.09 466.763 184.087 468.689 180.752C470.614 177.418 472.102 174.197 473.267 170.973C480.168 151.624 474.045 133.603 458.303 120.664C455.502 118.359 452.403 116.249 449.026 114.299C445.649 112.349 442.55 110.881 439.278 109.634C420.261 102.367 401.539 106.09 388.207 121.863L388.137 121.823Z" fill="#1868DB"/>
<path d="M870.565 66.6285C825.409 85.0438 796.327 68.0356 786.485 60.4931L779.735 147.42C788.749 154.5 814.346 168.867 858.558 150.836C900.496 133.738 928.568 147.188 940.25 155.228L947.002 68.2839C936.315 60.9356 911.368 49.9809 870.565 66.6285Z" fill="#1868DB"/>
<path d="M743.463 217.247C740.532 228.564 734.449 235.337 724.723 239.407C714.173 243.821 704.241 242.98 695.082 237.49L605.16 275.114C646.399 339.254 703.508 358.315 762.522 333.623C817.497 310.622 843.195 267.293 832.726 179.9L743.381 217.282L743.463 217.247Z" fill="#1868DB"/>
<path d="M449.631 271.59L560.8 243.032L596.253 109.102L514.879 65.0287L449.631 271.59Z" fill="#82B536"/>
<path d="M307.812 94.0893C270.79 84.1287 247.365 74.8387 234.016 63.7859L228.75 178.77C242.51 183.347 257.418 187.641 273.761 191.61C309.542 201.397 331.135 210.992 342.854 222.925L348.246 105.178C335.764 101.23 322.362 97.5184 307.812 94.0893Z" fill="#FCA700"/>
<path d="M1225.21 67.6199C1224.07 71.377 1223.22 75.4437 1222.74 79.7352C1222.26 84.0267 1222.16 88.3172 1222.49 92.2903C1224.28 115.972 1239.68 132.21 1263.15 138.627C1267.14 139.728 1271.41 140.541 1275.85 141.054C1280.29 141.567 1284.96 141.741 1289.29 141.599C1313.59 140.607 1332.19 128.296 1339.17 105.765C1340.37 101.968 1341.22 97.8564 1341.72 93.4746C1342.21 89.0927 1342.28 85.0281 1341.99 81.1056C1340.18 57.6047 1324.78 41.3663 1301.32 34.8139C1297.15 33.6454 1292.74 32.8162 1288.11 32.2812C1283.48 31.7462 1279.38 31.5936 1275.2 31.7517C1250.91 32.653 1232.25 45.0039 1225.31 67.631L1225.21 67.6199Z" fill="#82B536"/>
<path d="M83.1762 155.66C74.1789 163.681 75.8177 176.563 92.1789 194.879C93.9408 196.852 96.2182 198.449 97.9802 200.422L58.4398 235.673C54.8145 232.662 50.7872 228.153 45.5013 222.235C4.68234 176.538 6.72077 135.49 36.2695 109.147C58.289 89.5158 78.7491 88.2328 99.414 90.2263C114.549 91.0758 125.328 92.0964 133.378 84.9196C142.375 76.8983 140.778 64.064 124.375 45.7004L118.628 39.2661L157.695 4.43712C161.739 7.91785 165.767 12.4265 170.633 17.8745C211.872 64.0418 210.354 104.625 180.284 131.433C158.265 151.064 137.385 151.877 117.098 150.306C102.005 149.504 91.1843 148.436 83.1342 155.613L83.1762 155.66Z" fill="#BF63F3"/>
<path d="M1120.7 188.278L1167.17 165.226L1177.11 116.458L1143.04 78.6759L1090.6 80.3475L1059.29 120.213L1072.68 168.238L1120.7 188.278Z" fill="#1868DB"/>
<path d="M1365.12 169.998C1360.27 200.662 1353.18 228.112 1345.92 251.147L1445.23 297.342C1455.37 267.164 1465.61 229.838 1472.35 187.265C1479.08 144.692 1480.84 106 1480.52 74.1372L1371.89 86.8457C1371.69 111.019 1369.97 139.334 1365.12 169.998Z" fill="#1868DB"/>
<path d="M184.943 272.962C214.22 270.521 233.398 270.896 245.587 274.808L224.294 199.687C213.221 200.033 201.37 200.834 188.539 202.186C160.208 204.442 142.304 203.434 131.116 198.567L152.92 275.492C162.921 275.048 173.542 274.233 184.943 272.962Z" fill="#1868DB"/>
</g>
<defs>
<clipPath id="clip0_1461_26940">
<rect width="3305" height="220" fill="white"/>
</clipPath>
</defs>
</svg>
`;
const $fc6840133e04adc0$var$$85d9a99cb49b730f$export$7d22dc8c5b0cc81c = `data:image/svg+xml;base64,${$fc6840133e04adc0$var$$85d9a99cb49b730f$require$Buffer.from($fc6840133e04adc0$var$$85d9a99cb49b730f$var$svgStringDesktopFooterWide).toString("base64")}`;
const $fc6840133e04adc0$var$$85d9a99cb49b730f$var$svgStringMobileFooter = `<svg width="907" height="139" viewBox="0 0 907 139" fill="none" xmlns="http://www.w3.org/2000/svg">
<mask id="mask0_1421_26676" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="907" height="139">
<rect width="907" height="138.569" fill="#D9D9D9"/>
</mask>
<g mask="url(#mask0_1421_26676)">
<path d="M395.637 190.948C403.967 189.968 412.814 190.744 422.035 193.4C431.255 196.056 440.048 200.427 447.161 206.052L462.551 139.842C454.685 135.837 446.2 132.507 437.142 129.898C428.085 127.289 419.445 125.62 410.979 124.822L395.603 190.971L395.637 190.948Z" fill="#BF63F3"/>
<path d="M261.469 -6.60718L277.516 22.697C259.386 35.2084 255.368 47.2171 263.392 61.8691C271.415 76.5212 283.086 78.4874 301.57 66.6224L317.617 95.9265C281.308 120.141 257.173 111.36 239.002 78.1771C220.831 44.9945 225.177 17.6384 261.486 -6.57639L261.469 -6.60718Z" fill="#BF63F3"/>
<path d="M703.749 28.8725C702.258 30.8363 700.85 33.0593 699.576 35.505C698.302 37.9507 697.228 40.4904 696.449 42.9439C691.72 57.5278 695.81 70.9912 706.42 80.56C708.221 82.1926 710.233 83.7199 712.408 85.1118C714.584 86.5037 716.96 87.7495 719.23 88.7212C732.041 94.0679 744.608 91.2609 753.601 79.5082C755.128 77.5337 756.55 75.2849 757.851 72.7877C759.152 70.2905 760.158 67.8795 760.948 65.4667C765.623 50.9859 761.533 37.5224 750.963 27.8764C749.082 26.1581 747 24.586 744.731 23.1342C742.462 21.6824 740.379 20.5905 738.179 19.6637C725.396 14.2655 712.792 17.0833 703.796 28.9024L703.749 28.8725Z" fill="#FCA700"/>
<path d="M255.266 143.791C253.96 145.508 252.727 147.453 251.612 149.593C250.497 151.733 249.559 153.956 248.879 156.104C244.752 168.871 248.372 180.679 257.715 189.089C259.3 190.524 261.071 191.867 262.985 193.092C264.9 194.316 266.991 195.414 268.987 196.271C280.255 200.986 291.293 198.557 299.172 188.28C300.511 186.554 301.755 184.587 302.894 182.402C304.032 180.217 304.912 178.106 305.601 175.994C309.681 163.316 306.061 151.509 296.753 143.031C295.097 141.521 293.265 140.139 291.268 138.861C289.271 137.584 287.439 136.622 285.504 135.804C274.26 131.044 263.19 133.482 255.307 143.817L255.266 143.791Z" fill="#1868DB"/>
<path d="M540.511 107.628C513.812 119.693 496.617 108.55 490.798 103.608L486.806 160.563C492.136 165.201 507.271 174.615 533.412 162.8C558.209 151.598 574.807 160.41 581.715 165.678L585.707 108.712C579.388 103.898 564.637 96.7202 540.511 107.628Z" fill="#1868DB"/>
<path d="M291.626 241.918L357.357 223.207L378.319 135.456L330.205 106.579L291.626 241.918Z" fill="#82B536"/>
<path d="M207.772 125.619C185.882 119.093 172.032 113.006 164.139 105.765L161.026 181.102C169.161 184.101 177.976 186.914 187.639 189.515C208.795 195.927 221.563 202.214 228.492 210.032L231.68 132.885C224.3 130.298 216.376 127.866 207.772 125.619Z" fill="#FCA700"/>
<path d="M150.358 70.9821L179.701 64.217L192.375 35.669L178.846 6.8247L149.287 -0.588974L125.967 19.0132L126.445 50.8598L150.358 70.9821Z" fill="#82B536"/>
<path d="M487.144 -14.9153C490.073 -3.54747 491.12 8.90597 490.112 22.2702C489.104 35.6344 486.055 48.7625 481.214 59.8175L559.804 67.3853C562.64 55.6224 564.574 43.1392 565.564 30.0109C566.554 16.8825 566.566 4.53097 565.627 -7.39742L487.11 -14.9582L487.144 -14.9153Z" fill="#82B536"/>
<path d="M750.205 108.277C749.527 110.739 749.028 113.403 748.743 116.215C748.458 119.027 748.402 121.838 748.596 124.441C749.655 139.957 758.761 150.597 772.638 154.801C774.997 155.523 777.517 156.055 780.143 156.391C782.77 156.727 785.533 156.841 788.088 156.748C802.457 156.099 813.458 148.032 817.586 133.27C818.296 130.782 818.798 128.088 819.089 125.217C819.38 122.346 819.421 119.683 819.252 117.113C818.181 101.715 809.075 91.0758 795.207 86.7827C792.738 86.0171 790.133 85.4738 787.394 85.1233C784.655 84.7727 782.233 84.6728 779.762 84.7763C765.4 85.3669 754.367 93.4592 750.262 108.284L750.205 108.277Z" fill="#82B536"/>
<path d="M842.951 81.367C858.788 74.077 869.621 70.6339 877.359 70.9258L847.983 24.3268C841.859 26.6939 835.405 29.5186 828.529 32.904C813.18 39.8871 802.914 42.6573 795.515 41.5283L825.596 89.2466C831.096 87.0197 836.858 84.4222 842.951 81.367Z" fill="#BF63F3"/>
<path d="M21.9939 45.6584C21.3276 48.0755 20.8378 50.6918 20.558 53.4527C20.2782 56.2137 20.2233 58.9739 20.4137 61.5301C21.454 76.7656 30.395 87.2126 44.021 91.3409C46.3368 92.0494 48.8118 92.5722 51.3906 92.9022C53.9694 93.2322 56.6827 93.3439 59.1918 93.2528C73.3009 92.6149 84.1031 84.6944 88.1561 70.199C88.853 67.7564 89.3458 65.111 89.6315 62.292C89.9171 59.4729 89.9574 56.8579 89.7918 54.3344C88.7397 39.2151 79.7987 28.7681 66.1814 24.5527C63.7577 23.8009 61.1995 23.2675 58.5098 22.9233C55.8201 22.5791 53.4424 22.4809 51.0165 22.5826C36.9134 23.1624 26.0805 31.1084 22.0493 45.6655L21.9939 45.6584Z" fill="#FCA700"/>
<path d="M598.85 97.498L620.339 107.794L660.44 71.8259L636.967 32.2385L594.924 40.4365L598.85 97.498Z" fill="#FCA700"/>
<path d="M74.9517 165.961C69.6319 171.216 70.6008 179.656 80.2747 191.657C81.3165 192.95 82.6631 193.996 83.7049 195.289L60.3258 218.385C58.1823 216.412 55.801 213.458 52.6756 209.581C28.5406 179.64 29.7458 152.746 47.2172 135.485C60.2366 122.623 72.3341 121.783 84.5526 123.089C93.5012 123.645 99.8746 124.314 104.634 119.612C109.954 114.356 109.01 105.947 99.3113 93.9154L95.9131 89.6996L119.012 66.8797C121.404 69.1603 123.785 72.1144 126.662 75.6839C151.045 105.933 150.148 132.523 132.369 150.087C119.349 162.95 107.004 163.482 95.0086 162.453C86.0848 161.927 79.6867 161.228 74.9268 165.93L74.9517 165.961Z" fill="#BF63F3"/>
<path d="M688.409 187.332L715.888 172.229L721.763 140.276L701.619 115.521L670.609 116.616L652.097 142.736L660.019 174.202L688.409 187.332Z" fill="#1868DB"/>
<path d="M832.929 175.355C830.063 195.446 825.869 213.432 821.573 228.524L880.295 258.791C886.287 239.018 892.347 214.562 896.327 186.668C900.306 158.775 901.351 133.424 901.158 112.547L836.93 120.874C836.813 136.712 835.795 155.264 832.929 175.355Z" fill="#1868DB"/>
<path d="M334.456 35.1284L365.632 24.3972C372.95 48.8477 383.184 56.7618 398.772 51.3962C414.36 46.0306 418.993 32.9989 412.363 8.3117L443.539 -2.41947C457.409 46.3198 443.431 71.9961 408.128 84.1476C372.826 96.2991 348.359 83.8565 334.489 35.1171L334.456 35.1284Z" fill="#1868DB"/>
</g>
</svg>
`;
const $fc6840133e04adc0$var$$85d9a99cb49b730f$export$eca0cf64e1927e60 = `data:image/svg+xml;base64,${$fc6840133e04adc0$var$$85d9a99cb49b730f$require$Buffer.from($fc6840133e04adc0$var$$85d9a99cb49b730f$var$svgStringMobileFooter).toString("base64")}`;
const $fc6840133e04adc0$var$$80cd39a44f20f361$var$TABLET_MEDIA_QUERY = "@media (min-width: 768px) and (max-width: 1279px)";
const $fc6840133e04adc0$var$$80cd39a44f20f361$var$MOBILE_MEDIA_QUERY = "@media (max-width: 767px)";
const $fc6840133e04adc0$var$$80cd39a44f20f361$var$DESKTOP_MEDIA_QUERY = "@media (min-width: 1280px)";
const $fc6840133e04adc0$var$$80cd39a44f20f361$var$YEAR = new Date().getFullYear();
const $fc6840133e04adc0$var$$80cd39a44f20f361$var$COPYRIGHT = `Copyright \xa9 ${$fc6840133e04adc0$var$$80cd39a44f20f361$var$YEAR} Atlassian`;
const $fc6840133e04adc0$var$$80cd39a44f20f361$var$FooterLink = ({ href: href, onClick: onClick, text: text, styles: styles = [] })=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("a", {
        href: href,
        onClick: onClick,
        css: [
            $fc6840133e04adc0$var$$80cd39a44f20f361$var$linkStyle,
            ...styles
        ],
        children: text
    });
const $fc6840133e04adc0$var$$80cd39a44f20f361$var$FORUMS_URL = $fc6840133e04adc0$var$$1ff01338112cd7fe$export$fe0105b4860d6e11[$fc6840133e04adc0$export$93d048dc21eb282a.FORUMS];
const $fc6840133e04adc0$var$$80cd39a44f20f361$var$getForumsUrl = (url, isLoggedIn, email)=>isLoggedIn ? $fc6840133e04adc0$var$$3dba2111a1a6d39b$export$1db7da00354b15ed({
        email: email,
        redirectUrl: url
    }) : url;
const $fc6840133e04adc0$export$7a92b4adf6bd95bb = ({ reportAProblemCallback: reportAProblemCallback, isLoggedIn: isLoggedIn = false, showChampions: showChampions = false, showNewLearningLinks: showNewLearningLinks = false, email: email, licenseData: licenseData })=>{
    const [isOpen, setIsOpen] = (0, $5FkrB.useState)(false);
    const openModal = (0, $5FkrB.useCallback)(()=>setIsOpen(true), []);
    const closeModal = (0, $5FkrB.useCallback)(()=>setIsOpen(false), []);
    const ABOUT_LEARNING_URL = showNewLearningLinks ? "https://community.atlassian.com/learning/hub/resources-and-support/about-atlassian-learning" : "https://university.atlassian.com/student/activity/836764-about-us";
    const RESOURCES_LEARNING_URL = showNewLearningLinks ? "https://community.atlassian.com/learning/hub/resources-and-support" : "https://university.atlassian.com/student/activity/1938006-resources-and-support";
    return (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
        css: $fc6840133e04adc0$var$$80cd39a44f20f361$var$footerBackgroundStyles,
        children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
            css: $fc6840133e04adc0$var$$80cd39a44f20f361$var$footerWrapperStyles,
            children: (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                css: $fc6840133e04adc0$var$$80cd39a44f20f361$var$footerStyle,
                children: [
                    (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                        css: $fc6840133e04adc0$var$$80cd39a44f20f361$var$innerDivStyle,
                        children: [
                            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                                css: $fc6840133e04adc0$var$$80cd39a44f20f361$var$logoContainerStyle,
                                children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                                    css: $fc6840133e04adc0$var$$80cd39a44f20f361$var$logoStyle,
                                    children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $57028745e7fabd90$export$8a485e2e7ed91e8f), {})
                                })
                            }),
                            (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                                css: $fc6840133e04adc0$var$$80cd39a44f20f361$var$columnsContainerStyle,
                                children: [
                                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                                        css: $fc6840133e04adc0$var$$80cd39a44f20f361$var$columnStyle,
                                        children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                                            css: $fc6840133e04adc0$var$$80cd39a44f20f361$var$headerStyle,
                                            children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("a", {
                                                href: "/",
                                                css: $fc6840133e04adc0$var$$80cd39a44f20f361$var$linkStyle,
                                                children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$export$71f050e2efa708bb, {
                                                    size: "medium",
                                                    fontWeight: "semibold",
                                                    children: "Community"
                                                })
                                            })
                                        })
                                    }),
                                    (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                                        css: $fc6840133e04adc0$var$$80cd39a44f20f361$var$columnStyle,
                                        children: [
                                            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                                                css: $fc6840133e04adc0$var$$80cd39a44f20f361$var$headerStyle,
                                                children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("a", {
                                                    href: $fc6840133e04adc0$var$$80cd39a44f20f361$var$getForumsUrl($fc6840133e04adc0$var$$80cd39a44f20f361$var$FORUMS_URL, isLoggedIn, email),
                                                    css: $fc6840133e04adc0$var$$80cd39a44f20f361$var$linkStyle,
                                                    children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$export$71f050e2efa708bb, {
                                                        size: "medium",
                                                        fontWeight: "semibold",
                                                        children: "Forums"
                                                    })
                                                })
                                            }),
                                            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$var$$80cd39a44f20f361$var$FooterLink, {
                                                href: $fc6840133e04adc0$var$$80cd39a44f20f361$var$getForumsUrl(`${$fc6840133e04adc0$var$$80cd39a44f20f361$var$FORUMS_URL}/help/faqpage`, isLoggedIn, email),
                                                text: "FAQs"
                                            }),
                                            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$var$$80cd39a44f20f361$var$FooterLink, {
                                                href: $fc6840133e04adc0$var$$80cd39a44f20f361$var$getForumsUrl(`${$fc6840133e04adc0$var$$80cd39a44f20f361$var$FORUMS_URL}/custom/page/page-id/rules-of-engagement`, isLoggedIn, email),
                                                text: "Forums guidelines"
                                            })
                                        ]
                                    }),
                                    (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                                        css: $fc6840133e04adc0$var$$80cd39a44f20f361$var$columnStyle,
                                        children: [
                                            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                                                css: $fc6840133e04adc0$var$$80cd39a44f20f361$var$headerStyle,
                                                children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("a", {
                                                    href: $fc6840133e04adc0$var$$1ff01338112cd7fe$export$fe0105b4860d6e11[$fc6840133e04adc0$export$93d048dc21eb282a.LEARNING],
                                                    css: $fc6840133e04adc0$var$$80cd39a44f20f361$var$linkStyle,
                                                    children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$export$71f050e2efa708bb, {
                                                        size: "medium",
                                                        fontWeight: "semibold",
                                                        children: "Learning"
                                                    })
                                                })
                                            }),
                                            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$var$$80cd39a44f20f361$var$FooterLink, {
                                                href: ABOUT_LEARNING_URL,
                                                text: "About learning"
                                            }),
                                            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$var$$80cd39a44f20f361$var$FooterLink, {
                                                href: RESOURCES_LEARNING_URL,
                                                text: "Resources"
                                            })
                                        ]
                                    }),
                                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                                        css: $fc6840133e04adc0$var$$80cd39a44f20f361$var$columnStyle,
                                        children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                                            css: $fc6840133e04adc0$var$$80cd39a44f20f361$var$headerStyle,
                                            children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("a", {
                                                href: $fc6840133e04adc0$var$$1ff01338112cd7fe$export$fe0105b4860d6e11[$fc6840133e04adc0$export$93d048dc21eb282a.EVENTS],
                                                css: $fc6840133e04adc0$var$$80cd39a44f20f361$var$linkStyle,
                                                children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$export$71f050e2efa708bb, {
                                                    size: "medium",
                                                    fontWeight: "semibold",
                                                    children: "Events"
                                                })
                                            })
                                        })
                                    }),
                                    showChampions && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                                        css: $fc6840133e04adc0$var$$80cd39a44f20f361$var$columnStyle,
                                        children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                                            css: $fc6840133e04adc0$var$$80cd39a44f20f361$var$headerStyle,
                                            children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("a", {
                                                href: $fc6840133e04adc0$var$$1ff01338112cd7fe$export$fe0105b4860d6e11[$fc6840133e04adc0$export$93d048dc21eb282a.CHAMPIONS],
                                                css: $fc6840133e04adc0$var$$80cd39a44f20f361$var$linkStyle,
                                                children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$export$71f050e2efa708bb, {
                                                    size: "medium",
                                                    fontWeight: "semibold",
                                                    children: "Champions"
                                                })
                                            })
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                        css: $fc6840133e04adc0$var$$80cd39a44f20f361$var$bottomDivStyle,
                        children: (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                            css: $fc6840133e04adc0$var$$80cd39a44f20f361$var$bottomContentStyle,
                            children: [
                                (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("span", {
                                    css: $fc6840133e04adc0$var$$80cd39a44f20f361$var$copyrightText,
                                    children: $fc6840133e04adc0$var$$80cd39a44f20f361$var$COPYRIGHT
                                }),
                                (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                                    css: $fc6840133e04adc0$var$$80cd39a44f20f361$var$bottomLinksContainerStyle,
                                    children: [
                                        reportAProblemCallback && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$var$$80cd39a44f20f361$var$FooterLink, {
                                            onClick: reportAProblemCallback,
                                            text: "Report a problem",
                                            styles: [
                                                $fc6840133e04adc0$var$$80cd39a44f20f361$var$bottomLinkStyle
                                            ]
                                        }),
                                        (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$var$$80cd39a44f20f361$var$FooterLink, {
                                            href: "https://www.atlassian.com/legal/privacy-policy#what-this-policy-covers",
                                            text: "Privacy Policy",
                                            styles: [
                                                $fc6840133e04adc0$var$$80cd39a44f20f361$var$bottomLinkStyle
                                            ]
                                        }),
                                        (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("a", {
                                            href: "#",
                                            className: "atl-policy-link",
                                            css: $fc6840133e04adc0$var$$80cd39a44f20f361$var$bottomLinkStyle,
                                            children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("span", {
                                                css: $fc6840133e04adc0$var$$80cd39a44f20f361$var$linkStyle,
                                                className: "atl-policy-link-text",
                                                children: "Notice at Collection"
                                            })
                                        }),
                                        (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$var$$80cd39a44f20f361$var$FooterLink, {
                                            href: "https://www.atlassian.com/legal/community-platform-terms-of-use",
                                            text: "Terms",
                                            styles: [
                                                $fc6840133e04adc0$var$$80cd39a44f20f361$var$bottomLinkStyle
                                            ]
                                        }),
                                        (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$var$$80cd39a44f20f361$var$FooterLink, {
                                            href: "https://www.atlassian.com/trust/data-protection",
                                            text: "Security",
                                            styles: [
                                                $fc6840133e04adc0$var$$80cd39a44f20f361$var$bottomLinkStyle
                                            ]
                                        }),
                                        licenseData && (0, $6bec4f26b2cb3094$export$25062201e9e25d76)((0, $6bec4f26b2cb3094$export$ffb0004e005737fa), {
                                            children: [
                                                (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$var$$80cd39a44f20f361$var$FooterLink, {
                                                    onClick: openModal,
                                                    text: "About",
                                                    styles: [
                                                        $fc6840133e04adc0$var$$80cd39a44f20f361$var$bottomLinkStyle
                                                    ]
                                                }),
                                                (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $17e48fac63f6a6ba$export$2e2bcd8739ae039), {
                                                    children: isOpen && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$export$bd0c6e28f5d6b66e, {
                                                        ...licenseData,
                                                        closeModal: closeModal
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                ]
            })
        })
    });
};
const $fc6840133e04adc0$var$$80cd39a44f20f361$var$footerBackgroundStyles = (0, $74Zh5.css)({
    width: "100%",
    backgroundImage: `url(${$fc6840133e04adc0$var$$85d9a99cb49b730f$export$f3cfc44c4eba4576})`,
    backgroundSize: "cover",
    backgroundRepeat: "no-repeat",
    backgroundPosition: "center",
    paddingTop: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.200"),
    paddingBottom: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.200"),
    boxSizing: "border-box",
    [$fc6840133e04adc0$var$$80cd39a44f20f361$var$TABLET_MEDIA_QUERY]: {
        backgroundImage: `url(${$fc6840133e04adc0$var$$85d9a99cb49b730f$export$7d22dc8c5b0cc81c})`
    },
    [$fc6840133e04adc0$var$$80cd39a44f20f361$var$MOBILE_MEDIA_QUERY]: {
        backgroundImage: `url(${$fc6840133e04adc0$var$$85d9a99cb49b730f$export$eca0cf64e1927e60})`
    }
});
const $fc6840133e04adc0$var$$80cd39a44f20f361$var$footerWrapperStyles = (0, $74Zh5.css)({
    width: "100%",
    display: "flex",
    justifyContent: "center",
    margin: "0 auto",
    maxWidth: "100%",
    fontFamily: "Inter, sans-serif",
    [$fc6840133e04adc0$var$$80cd39a44f20f361$var$DESKTOP_MEDIA_QUERY]: {
        maxWidth: "1234px"
    },
    [$fc6840133e04adc0$var$$80cd39a44f20f361$var$TABLET_MEDIA_QUERY]: {
        maxWidth: "720px"
    },
    [$fc6840133e04adc0$var$$80cd39a44f20f361$var$MOBILE_MEDIA_QUERY]: {
        paddingLeft: "20px",
        paddingRight: "20px"
    }
});
const $fc6840133e04adc0$var$$80cd39a44f20f361$var$footerStyle = (0, $74Zh5.css)({
    borderRadius: "0px 0px 24px 24px",
    width: "100%",
    margin: "0 auto",
    backgroundColor: "#F8F8F8",
    textAlign: "center",
    display: "flex",
    alignItems: "center",
    flexDirection: "column",
    [$fc6840133e04adc0$var$$80cd39a44f20f361$var$TABLET_MEDIA_QUERY]: {
        padding: "0 16px"
    },
    [$fc6840133e04adc0$var$$80cd39a44f20f361$var$MOBILE_MEDIA_QUERY]: {
        paddingLeft: "16px",
        paddingRight: "16px",
        paddingTop: "24px",
        textAlign: "left"
    }
});
const $fc6840133e04adc0$var$$80cd39a44f20f361$var$linkStyle = (0, $74Zh5.css)({
    display: "inline",
    fontSize: "12px",
    fontWeight: 400,
    color: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.text"),
    textDecoration: "none",
    "&:hover": {
        textDecoration: "underline",
        textDecorationColor: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.text"),
        color: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.text"),
        cursor: "pointer"
    }
});
const $fc6840133e04adc0$var$$80cd39a44f20f361$var$innerDivStyle = (0, $74Zh5.css)({
    padding: "24px 24px",
    boxSizing: "border-box",
    width: "100%",
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "space-between",
    [$fc6840133e04adc0$var$$80cd39a44f20f361$var$TABLET_MEDIA_QUERY]: {
        flexDirection: "column",
        alignItems: "flex-start"
    },
    [$fc6840133e04adc0$var$$80cd39a44f20f361$var$MOBILE_MEDIA_QUERY]: {
        flexDirection: "column",
        alignItems: "flex-start",
        paddingTop: "0px",
        paddingBottom: "8px"
    }
});
const $fc6840133e04adc0$var$$80cd39a44f20f361$var$logoContainerStyle = (0, $74Zh5.css)({
    width: "420px",
    display: "flex",
    [$fc6840133e04adc0$var$$80cd39a44f20f361$var$TABLET_MEDIA_QUERY]: {
        justifyContent: "flex-start",
        width: "120px"
    },
    [$fc6840133e04adc0$var$$80cd39a44f20f361$var$MOBILE_MEDIA_QUERY]: {
        marginBottom: "16px",
        width: "120px"
    }
});
const $fc6840133e04adc0$var$$80cd39a44f20f361$var$logoStyle = (0, $74Zh5.css)({
    svg: {
        color: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.icon.brand"),
        transform: `scale(0.9)`
    },
    marginLeft: "24px",
    [$fc6840133e04adc0$var$$80cd39a44f20f361$var$TABLET_MEDIA_QUERY]: {
        marginLeft: "0",
        marginBottom: "8px"
    },
    [$fc6840133e04adc0$var$$80cd39a44f20f361$var$MOBILE_MEDIA_QUERY]: {
        marginLeft: "0",
        paddingLeft: "0"
    }
});
const $fc6840133e04adc0$var$$80cd39a44f20f361$var$columnsContainerStyle = (0, $74Zh5.css)({
    display: "flex",
    justifyContent: "space-between",
    gap: "24px",
    [$fc6840133e04adc0$var$$80cd39a44f20f361$var$TABLET_MEDIA_QUERY]: {
        gap: "16px"
    },
    [$fc6840133e04adc0$var$$80cd39a44f20f361$var$MOBILE_MEDIA_QUERY]: {
        width: "100%",
        flexDirection: "column",
        gap: "0"
    }
});
const $fc6840133e04adc0$var$$80cd39a44f20f361$var$columnStyle = (0, $74Zh5.css)({
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    width: "120px",
    textAlign: "left",
    gap: "12px",
    [$fc6840133e04adc0$var$$80cd39a44f20f361$var$MOBILE_MEDIA_QUERY]: {
        width: "100%",
        marginBottom: "16px"
    }
});
const $fc6840133e04adc0$var$$80cd39a44f20f361$var$headerStyle = (0, $74Zh5.css)({
    marginBottom: "4px"
});
const $fc6840133e04adc0$var$$80cd39a44f20f361$var$bottomDivStyle = (0, $74Zh5.css)({
    width: "100%",
    display: "flex",
    justifyContent: "center",
    boxSizing: "border-box",
    [$fc6840133e04adc0$var$$80cd39a44f20f361$var$TABLET_MEDIA_QUERY]: {
        padding: "0 0px"
    },
    [$fc6840133e04adc0$var$$80cd39a44f20f361$var$MOBILE_MEDIA_QUERY]: {
        justifyContent: "flex-start",
        width: "100%",
        paddingLeft: "0",
        paddingRight: "0"
    }
});
const $fc6840133e04adc0$var$$80cd39a44f20f361$var$copyrightText = (0, $74Zh5.css)({
    marginLeft: "0px",
    fontSize: "12px",
    color: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.text.subtle")
});
const $fc6840133e04adc0$var$$80cd39a44f20f361$var$bottomContentStyle = (0, $74Zh5.css)({
    width: "100%",
    maxWidth: "calc(100% - 48px)",
    paddingTop: "16px",
    paddingBottom: "24px",
    paddingLeft: "24px",
    paddingRight: "24px",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    boxSizing: "border-box",
    borderTop: `1px solid ${(0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.border")}`,
    [$fc6840133e04adc0$var$$80cd39a44f20f361$var$TABLET_MEDIA_QUERY]: {
        paddingLeft: "0",
        paddingRight: "0"
    },
    [$fc6840133e04adc0$var$$80cd39a44f20f361$var$MOBILE_MEDIA_QUERY]: {
        maxWidth: "100%",
        justifyContent: "flex-start",
        flexDirection: "column-reverse",
        alignItems: "flex-start",
        paddingLeft: "24px",
        paddingRight: "0"
    }
});
const $fc6840133e04adc0$var$$80cd39a44f20f361$var$bottomLinkStyle = (0, $74Zh5.css)({
    display: "inline",
    marginLeft: "32px",
    [$fc6840133e04adc0$var$$80cd39a44f20f361$var$MOBILE_MEDIA_QUERY]: {
        marginLeft: "0"
    }
});
const $fc6840133e04adc0$var$$80cd39a44f20f361$var$bottomLinksContainerStyle = (0, $74Zh5.css)({
    [$fc6840133e04adc0$var$$80cd39a44f20f361$var$MOBILE_MEDIA_QUERY]: {
        // match columnStyle
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
        width: "100%",
        textAlign: "left",
        marginTop: "0",
        marginBottom: "32px",
        gap: "12px"
    }
});
var $fc6840133e04adc0$var$$80cd39a44f20f361$export$2e2bcd8739ae039 = $fc6840133e04adc0$export$7a92b4adf6bd95bb;
var $fc6840133e04adc0$var$$fff41b96fcd62262$exports = {};
$fc6840133e04adc0$var$$parcel$export($fc6840133e04adc0$var$$fff41b96fcd62262$exports, "WelcomeModal", ()=>$fc6840133e04adc0$export$9d12d42929c3fcf);
const $fc6840133e04adc0$export$9d12d42929c3fcf = ({ onAccept: onAccept, onCancel: onCancel, coverImageSrc: coverImageSrc })=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $9406e400bdd02ea1$export$2e2bcd8739ae039), {
        onClose: onCancel,
        width: "auto",
        shouldCloseOnEscapePress: false,
        shouldCloseOnOverlayClick: false,
        shouldScrollInViewport: true,
        children: (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
            css: $fc6840133e04adc0$var$$fff41b96fcd62262$var$modalContainerStyles,
            children: [
                (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                    css: $fc6840133e04adc0$var$$fff41b96fcd62262$var$modalImageContainerStyles,
                    children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("img", {
                        src: coverImageSrc,
                        alt: "cover",
                        css: $fc6840133e04adc0$var$$fff41b96fcd62262$var$coverImageStyles
                    })
                }),
                (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                    css: $fc6840133e04adc0$var$$fff41b96fcd62262$var$modalBodyStyles,
                    children: [
                        (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("h1", {
                            css: $fc6840133e04adc0$var$$fff41b96fcd62262$var$modalHeadingContainerStyles,
                            children: "Welcome to the new Atlassian Community"
                        }),
                        (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("p", {
                            css: $fc6840133e04adc0$var$$fff41b96fcd62262$var$modalSubheadingContainerStyles,
                            children: "Online forums and learning are now in one easy-to-use experience."
                        }),
                        (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("p", {
                            css: $fc6840133e04adc0$var$$fff41b96fcd62262$var$modalSubheadingContainerStyles,
                            children: [
                                "By continuing, you accept the updated",
                                " ",
                                (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("a", {
                                    href: $fc6840133e04adc0$var$$1ff01338112cd7fe$export$bc6e44c7f1ae99f6,
                                    target: "_blank",
                                    rel: "noreferrer",
                                    children: "Community Terms of Use"
                                }),
                                " ",
                                "and acknowledge the",
                                " ",
                                (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("a", {
                                    href: $fc6840133e04adc0$var$$1ff01338112cd7fe$export$30786e8ac20c09d8,
                                    target: "_blank",
                                    rel: "noreferrer",
                                    children: "Privacy Policy"
                                }),
                                ". Your public name, photo, and achievements may be publicly visible and available in search engines."
                            ]
                        }),
                        (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                            css: $fc6840133e04adc0$var$$fff41b96fcd62262$var$modalButtonContainerStyles,
                            children: [
                                (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                                    css: $fc6840133e04adc0$var$$fff41b96fcd62262$var$buttonStyle,
                                    children: (0, $6bec4f26b2cb3094$export$25062201e9e25d76)((0, $37328c3a94101dc2$export$2e2bcd8739ae039), {
                                        appearance: "subtle",
                                        onClick: onCancel,
                                        children: [
                                            " ",
                                            "Cancel and logout"
                                        ]
                                    })
                                }),
                                (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                                    css: $fc6840133e04adc0$var$$fff41b96fcd62262$var$buttonStyle,
                                    children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $37328c3a94101dc2$export$2e2bcd8739ae039), {
                                        appearance: "primary",
                                        onClick: onAccept,
                                        children: "Accept and continue"
                                    })
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
const $fc6840133e04adc0$var$$fff41b96fcd62262$var$buttonStyle = (0, $74Zh5.css)({
    fontSize: "16px",
    "& span": {
        fontWeight: "600"
    }
});
const $fc6840133e04adc0$var$$fff41b96fcd62262$var$coverImageStyles = (0, $74Zh5.css)({
    width: "100%",
    height: "auto",
    display: "block"
});
const $fc6840133e04adc0$var$$fff41b96fcd62262$var$modalContainerStyles = (0, $74Zh5.css)({
    maxWidth: "600px",
    margin: "0 auto"
});
const $fc6840133e04adc0$var$$fff41b96fcd62262$var$modalImageContainerStyles = (0, $74Zh5.css)({
    width: "100%",
    overflow: "hidden"
});
const $fc6840133e04adc0$var$$fff41b96fcd62262$var$modalBodyStyles = (0, $74Zh5.css)({
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    padding: "24px"
});
const $fc6840133e04adc0$var$$fff41b96fcd62262$var$modalHeadingContainerStyles = (0, $74Zh5.css)({
    fontFamily: "Charlie Display, sans-serif",
    fontSize: "32px",
    paddingTop: "24px",
    fontWeight: 700,
    textAlign: "center"
});
const $fc6840133e04adc0$var$$fff41b96fcd62262$var$modalSubheadingContainerStyles = (0, $74Zh5.css)({
    fontSize: "16px",
    marginTop: "16px",
    fontFamily: "Inter",
    textAlign: "center",
    marginBottom: "24px"
});
const $fc6840133e04adc0$var$$fff41b96fcd62262$var$modalButtonContainerStyles = (0, $74Zh5.css)({
    paddingTop: "16px",
    display: "flex",
    justifyContent: "center",
    gap: "8px"
});
$fc6840133e04adc0$var$$parcel$exportWildcard($fc6840133e04adc0$var$$a6a41c835fd01d00$exports, $fc6840133e04adc0$var$$1ca64a7075ab6eae$exports);
$fc6840133e04adc0$var$$parcel$exportWildcard($fc6840133e04adc0$var$$a6a41c835fd01d00$exports, $fc6840133e04adc0$var$$60ab015507144a2b$exports);
$fc6840133e04adc0$var$$parcel$exportWildcard($fc6840133e04adc0$var$$a6a41c835fd01d00$exports, $fc6840133e04adc0$var$$57b1d5df6b5425d4$exports);
$fc6840133e04adc0$var$$parcel$exportWildcard($fc6840133e04adc0$var$$a6a41c835fd01d00$exports, $fc6840133e04adc0$var$$4be7278e65b71184$exports);
$fc6840133e04adc0$var$$parcel$exportWildcard($fc6840133e04adc0$var$$a6a41c835fd01d00$exports, $fc6840133e04adc0$var$$db9d361cdef36cb6$exports);
$fc6840133e04adc0$var$$parcel$exportWildcard($fc6840133e04adc0$var$$a6a41c835fd01d00$exports, $fc6840133e04adc0$var$$e6da040d2ca2c72a$exports);
$fc6840133e04adc0$var$$parcel$exportWildcard($fc6840133e04adc0$var$$a6a41c835fd01d00$exports, $fc6840133e04adc0$var$$9c7edcd33b2e220b$exports);
$fc6840133e04adc0$var$$parcel$exportWildcard($fc6840133e04adc0$var$$a6a41c835fd01d00$exports, $fc6840133e04adc0$var$$3ec1f71319ba0295$exports);
$fc6840133e04adc0$var$$parcel$exportWildcard($fc6840133e04adc0$var$$a6a41c835fd01d00$exports, $fc6840133e04adc0$var$$7cbc56ac0bc2e1de$exports);
$fc6840133e04adc0$var$$parcel$exportWildcard($fc6840133e04adc0$var$$a6a41c835fd01d00$exports, $fc6840133e04adc0$var$$fc6addd2061b87dd$exports);
$fc6840133e04adc0$var$$parcel$exportWildcard($fc6840133e04adc0$var$$a6a41c835fd01d00$exports, $fc6840133e04adc0$var$$01ef21c48d795edb$exports);
$fc6840133e04adc0$var$$parcel$exportWildcard($fc6840133e04adc0$var$$a6a41c835fd01d00$exports, $fc6840133e04adc0$var$$80cd39a44f20f361$exports);
$fc6840133e04adc0$var$$parcel$exportWildcard($fc6840133e04adc0$var$$a6a41c835fd01d00$exports, $fc6840133e04adc0$var$$fff41b96fcd62262$exports);
const $fc6840133e04adc0$var$$2db63308c0b2527b$export$b56677d67e73c7be = ({ response: response, isLoading: isLoading })=>{
    const { message: message, isError: responseError } = response;
    return (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
        css: $fc6840133e04adc0$var$$2db63308c0b2527b$var$inputStyles,
        children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $baa25b657b03ab03$export$2e2bcd8739ae039), {
            name: "email",
            label: "Email address",
            defaultValue: "",
            children: ({ fieldProps: fieldProps, error: error, meta: meta })=>{
                const validationErrorMessage = meta.dirtySinceLastSubmit ? undefined : error;
                const displayMessage = validationErrorMessage || message;
                const displayType = error || responseError ? "error" : "valid";
                return (0, $6bec4f26b2cb3094$export$25062201e9e25d76)((0, $6bec4f26b2cb3094$export$ffb0004e005737fa), {
                    children: [
                        (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                            css: $fc6840133e04adc0$var$$2db63308c0b2527b$var$inputButtonFlex,
                            children: [
                                (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$export$2c73285ae9390cec, {
                                    ...fieldProps,
                                    required: true,
                                    type: "email",
                                    autoComplete: "off",
                                    placeholder: "yourname@email.com"
                                }),
                                (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                                    css: $fc6840133e04adc0$var$$2db63308c0b2527b$export$a3b9b213fa74e4fd,
                                    children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$export$353f5b6fc5456de1, {
                                        as: "button",
                                        label: "Sign up",
                                        type: "submit",
                                        appearance: $fc6840133e04adc0$export$261c9483fc4a455a.PRIMARY,
                                        isLoading: isLoading
                                    })
                                })
                            ]
                        }),
                        displayMessage ? (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$export$9144c5f9beecc4b7, {
                            type: displayType,
                            message: displayMessage
                        }) : null
                    ]
                });
            }
        })
    });
};
const $fc6840133e04adc0$var$$2db63308c0b2527b$var$inputStyles = (0, $74Zh5.css)({
    "& label": {
        fontWeight: 400
    }
});
const $fc6840133e04adc0$var$$2db63308c0b2527b$var$inputButtonFlex = (0, $74Zh5.css)({
    display: "flex",
    alignContent: "center",
    gap: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.100")
});
const $fc6840133e04adc0$var$$2db63308c0b2527b$export$a3b9b213fa74e4fd = ({ isMobile: isMobile })=>(0, $74Zh5.css)({
        minWidth: "fit-content",
        display: isMobile ? "none" : "block",
        marginTop: isMobile ? (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.200") : 0,
        [$fc6840133e04adc0$var$$f0285f05d4d9f8a0$export$426e07cd0772984d.MOBILE.MEDIA_QUERY]: {
            minWidth: "100%",
            display: isMobile ? "block" : "none"
        }
    });
const $fc6840133e04adc0$var$$d51a9a1c56c91a16$export$eefa3b352a86957 = "https://www.atlassian.com/legal/privacy-policy#what-this-policy-covers";
const $fc6840133e04adc0$var$$d51a9a1c56c91a16$export$ecf6508459835aaf = "By signing up, you agree to receive promotional emails including product news, events, and more from Atlassian and its affiliates, and acknowledge and accept the ";
const $fc6840133e04adc0$var$$d51a9a1c56c91a16$export$ec00f1754868e2a2 = ({ response: response, onSubmit: onSubmit, onPrivacyPolicyClick: onPrivacyPolicyClick })=>{
    const handleSubmit = async (data, form)=>{
        const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        const errors = {
            email: !emailPattern.test(data.email) ? "Enter a valid email address." : undefined
        };
        if (!errors.email) {
            await onSubmit(data);
            form.reset();
        }
        return errors;
    };
    return (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $40d9709490a4246c$export$2e2bcd8739ae039), {
        onSubmit: handleSubmit,
        children: ({ formProps: formProps, submitting: submitting })=>(0, $6bec4f26b2cb3094$export$25062201e9e25d76)("form", {
                ...formProps,
                css: $fc6840133e04adc0$var$$d51a9a1c56c91a16$var$formWrapperStyles,
                "data-testid": "signup-form",
                noValidate: true,
                children: [
                    (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                        css: $fc6840133e04adc0$var$$d51a9a1c56c91a16$var$formActionStyles,
                        children: [
                            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$var$$2db63308c0b2527b$export$b56677d67e73c7be, {
                                response: response,
                                isLoading: submitting
                            }),
                            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                                css: $fc6840133e04adc0$var$$2db63308c0b2527b$export$a3b9b213fa74e4fd({
                                    isMobile: true
                                }),
                                children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$export$353f5b6fc5456de1, {
                                    as: "button",
                                    label: "Sign up",
                                    type: "submit",
                                    appearance: $fc6840133e04adc0$export$261c9483fc4a455a.PRIMARY,
                                    isLoading: submitting,
                                    fullWidth: true
                                })
                            })
                        ]
                    }),
                    (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("p", {
                        css: $fc6840133e04adc0$var$$d51a9a1c56c91a16$var$acknowledgeStyle,
                        children: [
                            $fc6840133e04adc0$var$$d51a9a1c56c91a16$export$ecf6508459835aaf,
                            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("a", {
                                href: $fc6840133e04adc0$var$$d51a9a1c56c91a16$export$eefa3b352a86957,
                                target: "_blank",
                                onClick: onPrivacyPolicyClick,
                                rel: "noreferrer",
                                children: "Atlassian Privacy Policy"
                            }),
                            "."
                        ]
                    })
                ]
            })
    });
};
const $fc6840133e04adc0$var$$d51a9a1c56c91a16$var$formWrapperStyles = (0, $74Zh5.css)({
    width: "100%",
    paddingLeft: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.800"),
    paddingRight: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.800"),
    [$fc6840133e04adc0$var$$f0285f05d4d9f8a0$export$426e07cd0772984d.MOBILE.MEDIA_QUERY]: {
        padding: 0
    },
    [$fc6840133e04adc0$var$$f0285f05d4d9f8a0$export$426e07cd0772984d.TABLET.MEDIA_QUERY]: {
        marginTop: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.300")
    },
    [$fc6840133e04adc0$var$$f0285f05d4d9f8a0$export$426e07cd0772984d.DESKTOP.MEDIA_QUERY]: {
        marginTop: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.400")
    }
});
const $fc6840133e04adc0$var$$d51a9a1c56c91a16$var$formActionStyles = (0, $74Zh5.css)({
    [$fc6840133e04adc0$var$$f0285f05d4d9f8a0$export$426e07cd0772984d.MOBILE.MEDIA_QUERY]: {
        flexDirection: "column",
        gap: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.200")
    }
});
const $fc6840133e04adc0$var$$d51a9a1c56c91a16$var$acknowledgeStyle = (0, $74Zh5.css)({
    fontFamily: "Inter, sans-serif",
    maxWidth: "405px",
    color: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.text.subtlest"),
    fontWeight: "400",
    fontSize: "12px",
    marginTop: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.100"),
    "& a": {
        color: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.text.selected")
    },
    [$fc6840133e04adc0$var$$f0285f05d4d9f8a0$export$426e07cd0772984d.MOBILE.MEDIA_QUERY]: {
        maxWidth: "unset"
    }
});
const $fc6840133e04adc0$var$$eb8aa702a3355ad4$export$260d8f4a67dc36b0 = ()=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("svg", {
        "data-testid": "open-letter",
        width: "124",
        height: "118",
        viewBox: "0 0 124 118",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("g", {
            id: "Spot/Basics/Letter open",
            children: (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("g", {
                id: "Vector",
                children: [
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("path", {
                        id: "Vector_2",
                        d: "M61.8877 12.0239L11 54.5804V105.981H112.775V54.5804L61.8877 12.0239Z",
                        fill: "#1868DB"
                    }),
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("path", {
                        id: "Vector_3",
                        d: "M100.759 28.2393H23.0166V105.981H100.759V28.2393Z",
                        fill: "#FCA700"
                    }),
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("path", {
                        id: "Vector_4",
                        d: "M81.2754 28.2393H42.4938L23.0166 44.5319V105.981H100.759V44.5319L81.2754 28.2393Z",
                        fill: "#164B35"
                    }),
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("path", {
                        id: "Vector_5",
                        d: "M94.3773 34.6199H29.3916V99.6056H94.3773V34.6199Z",
                        fill: "#DDDEE1"
                    }),
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("path", {
                        id: "Vector_6",
                        d: "M88.2168 41.562H36.7148V43.9475H88.2168V41.562Z",
                        fill: "#FCA700"
                    }),
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("path", {
                        id: "Vector_7",
                        d: "M88.2168 51.1689H36.7148V53.5544H88.2168V51.1689Z",
                        fill: "#FCA700"
                    }),
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("path", {
                        id: "Vector_8",
                        d: "M88.2168 60.7825H36.7148V63.1679H88.2168V60.7825Z",
                        fill: "#FCA700"
                    }),
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("path", {
                        id: "Vector_9",
                        d: "M88.2168 70.3901H36.7148V72.7756H88.2168V70.3901Z",
                        fill: "#FCA700"
                    }),
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("path", {
                        id: "Vector_10",
                        d: "M88.2168 80.0034H36.7148V82.3889H88.2168V80.0034Z",
                        fill: "#FCA700"
                    }),
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("path", {
                        id: "Vector_11",
                        d: "M88.2168 89.6106H36.7148V91.9961H88.2168V89.6106Z",
                        fill: "#FCA700"
                    }),
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("path", {
                        id: "Vector_12",
                        d: "M72.2824 105.981L11.1074 54.5923L11.2088 105.981H72.2824Z",
                        fill: "#1868DB"
                    }),
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("path", {
                        id: "Vector_13",
                        d: "M51.4873 105.981L112.662 54.5923L112.567 105.981H51.4873Z",
                        fill: "#1868DB"
                    }),
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("path", {
                        id: "Vector_14",
                        d: "M51.4873 105.981H72.2825L61.8879 97.2446L51.4873 105.981Z",
                        fill: "#09326C"
                    }),
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("path", {
                        id: "Vector_15",
                        d: "M61.8877 12.0239L11 54.5804V105.981H112.775V54.5804L61.8877 12.0239Z",
                        fill: "#1868DB"
                    }),
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("path", {
                        id: "Vector_16",
                        d: "M100.759 28.2393H23.0166V105.981H100.759V28.2393Z",
                        fill: "#FCA700"
                    }),
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("path", {
                        id: "Vector_17",
                        d: "M81.2754 28.2393H42.4938L23.0166 44.5319V105.981H100.759V44.5319L81.2754 28.2393Z",
                        fill: "#164B35"
                    }),
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("path", {
                        id: "Vector_18",
                        d: "M94.3773 34.6199H29.3916V99.6056H94.3773V34.6199Z",
                        fill: "#DDDEE1"
                    }),
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("path", {
                        id: "Vector_19",
                        d: "M51.0637 80.5821L49.6444 80.767C49.6444 80.767 47.1873 80.5642 46.2033 80.9041L42.5059 80.7491C42.5059 80.7491 40.9613 80.8385 40.4961 81.0532C40.2039 81.1844 40.0191 81.3454 39.9773 81.4945C39.8938 81.7927 40.4127 82.0432 41.9036 81.9478C41.9215 81.9656 41.9811 81.9835 41.9871 82.0074C43.5615 81.7987 45.0762 82.1863 46.6804 82.1446C46.6626 82.0551 46.7162 81.9895 46.7639 82.0312L46.746 82.1386C47.8135 81.9239 48.4815 82.2817 49.4595 81.912C49.4595 81.912 49.3402 82.0551 49.3462 82.0551C52.6918 82.0014 57.2241 82.1744 60.85 82.0193L60.8321 82.0014V81.9835C60.5041 81.8702 58.8999 81.7032 58.8999 81.7032C60.1106 81.1784 61.4762 81.739 62.7584 81.7211L62.7465 81.8643C62.1919 81.8583 61.6969 81.9179 61.5001 81.9776C63.4919 82.1803 67.4876 82.234 69.3959 82.0253C69.3482 81.9179 68.7578 82.1505 68.6087 81.7987C69.0978 81.7987 69.5868 81.7509 70.046 81.7569C70.046 81.9835 69.7776 81.906 69.7239 81.9478C70.5171 82.1982 86.7322 82.5441 82.8618 81.5542L82.9632 81.4349C81.9613 81.3812 81.1324 81.3335 80.0947 81.1009C79.9456 81.1188 79.9277 81.1009 79.9277 81.2142C79.886 81.2321 79.8204 81.2679 79.8383 81.3156C79.8502 81.6019 79.5281 81.4886 79.385 81.4945C79.5639 80.6059 76.1527 81.3872 75.6995 81.3514C75.616 80.928 74.8109 81.3335 74.5366 81.1486C74.5545 81.1307 74.6797 81.0413 74.6916 81.0234C74.4471 80.7491 70.4217 81.4826 71.5727 80.9638C66.8196 80.0454 58.1962 81.0771 53.0615 80.272L53.0973 80.3256C53.0556 80.3078 52.9303 80.3316 52.9005 80.272C52.3936 80.439 51.0577 80.5582 51.0577 80.5582L51.0637 80.5821ZM62.8419 81.1486C62.8419 81.1486 62.8479 81.1248 62.8419 81.1188C62.8419 81.1606 63.5039 81.1367 63.5277 81.1486V81.2917C62.8538 81.5601 61.3212 80.588 62.7763 81.0174C62.824 80.9816 62.824 81.1009 62.8359 81.1486H62.8419ZM68.7101 81.1963C68.8234 81.2083 68.9487 81.2202 69.0858 81.2321C67.5651 81.6675 65.5136 81.1069 63.8438 81.3037C64.4163 80.6775 65.77 81.0174 66.4916 81.0592C67.2132 80.922 68.072 81.095 68.7101 81.1963ZM78.5143 81.3514V81.2798H78.574C78.574 81.2977 78.568 81.3216 78.5561 81.3335C78.5501 81.3454 78.5263 81.3633 78.5143 81.3573V81.3514ZM51.8688 80.922C51.9821 80.8087 52.4055 80.8743 52.1252 81.1009C52.0537 81.0651 51.8449 81.1665 51.8688 80.922ZM70.4276 81.3752C70.4276 81.1427 70.9882 81.1009 70.9882 81.417C70.7974 81.417 70.6125 81.3991 70.4276 81.3752ZM47.7121 81.1427C47.5631 81.3872 47.6048 81.1128 47.5571 80.9578C47.5929 80.9936 47.73 81.0055 47.7002 81.1188L47.7121 81.1427ZM45.1001 81.2739C45.0643 81.3931 44.9152 81.4707 44.8436 81.4766C44.6647 81.3812 45.0166 81.1665 45.1001 81.2739ZM40.8003 81.2739C40.7943 81.411 40.6929 81.4587 40.6631 81.3216C40.6751 81.2202 40.8003 81.1427 40.8182 81.2977C40.8182 81.2918 40.8182 81.2798 40.8003 81.2739ZM73.0039 81.8881C72.8489 82.2936 72.342 81.9597 72.0676 82.067C72.1332 81.6615 72.6223 81.9656 72.831 81.8941C72.9025 81.8941 72.9622 81.8941 73.0039 81.8881ZM56.0851 81.6973C56.0851 82.0551 55.5186 81.7688 55.3277 81.8464V81.7032C55.614 81.6675 55.7869 81.578 56.0732 81.6973H56.0851ZM67.7977 81.9776C67.6903 82.1207 67.5114 81.9835 67.3981 81.9835C67.3981 81.7808 67.8692 81.751 67.7977 81.9776ZM63.0447 81.8941C63.0208 81.6734 63.2534 81.7808 63.325 81.7629C63.2772 81.8106 63.1878 81.9478 63.1341 81.9418C63.0983 81.9418 63.0864 81.912 63.0447 81.8941ZM56.2938 81.5601C56.5145 81.5601 56.753 81.5601 56.9796 81.572V81.7152C56.7411 81.7152 56.5145 81.7092 56.2879 81.7032V81.5601H56.2938ZM58.5183 81.7927V81.9358C58.1962 82.067 58.1604 81.7032 58.5123 81.7927H58.5183ZM53.4193 81.7092C53.4551 81.7152 53.5028 81.7271 53.5386 81.7271C53.9978 81.7152 53.3478 82.228 53.4193 81.7092ZM51.01 81.8344C50.9623 81.8523 50.9027 81.8941 50.855 81.8941C50.533 81.8762 50.8908 81.5363 51.01 81.8344Z",
                        fill: "#101214"
                    }),
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("path", {
                        id: "Vector_20",
                        d: "M72.2824 105.981L11.1074 54.5923L11.2088 105.981H72.2824Z",
                        fill: "#1868DB"
                    }),
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("path", {
                        id: "Vector_21",
                        d: "M51.4873 105.981L112.662 54.5923L112.567 105.981H51.4873Z",
                        fill: "#1868DB"
                    }),
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("path", {
                        id: "Vector_22",
                        d: "M51.4873 105.981H72.2825L61.8879 97.2446L51.4873 105.981Z",
                        fill: "#09326C"
                    }),
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("path", {
                        id: "Vector_23",
                        d: "M51.0637 44.3943L49.6444 44.5792C49.6444 44.5792 47.1873 44.3764 46.2033 44.7164L42.5059 44.5613C42.5059 44.5613 40.9613 44.6508 40.4961 44.8655C40.2039 45.0026 40.0191 45.1577 39.9773 45.3068C39.8938 45.605 40.4127 45.8554 41.9036 45.76C41.9215 45.7779 41.9811 45.7958 41.9871 45.8196C43.5615 45.6109 45.0762 45.9986 46.6804 45.9568C46.6626 45.8674 46.7162 45.8018 46.7639 45.8435L46.746 45.9508C47.8135 45.7362 48.4815 46.094 49.4595 45.7242C49.4595 45.7242 49.3402 45.8674 49.3462 45.8674C52.6918 45.8137 57.2241 45.9866 60.85 45.8316L60.8321 45.8137V45.7958C60.5041 45.6825 58.8999 45.5155 58.8999 45.5155C60.1106 44.9907 61.4762 45.5513 62.7584 45.5334L62.7465 45.6765C62.1919 45.6706 61.6969 45.7302 61.5001 45.7898C63.4919 45.9926 67.4876 46.0463 69.3959 45.8375C69.3482 45.7302 68.7578 45.9628 68.6087 45.6109C69.0978 45.6109 69.5868 45.5632 70.046 45.5692C70.046 45.7958 69.7776 45.7183 69.7239 45.76C70.5171 46.0105 86.7322 46.3564 82.8618 45.3664L82.9632 45.2471C81.9613 45.1935 81.1324 45.1458 80.0947 44.9132C79.9456 44.9311 79.9277 44.9132 79.9277 45.0265C79.886 45.0444 79.8204 45.0802 79.8383 45.1279C79.8502 45.4141 79.5281 45.3008 79.385 45.3068C79.5639 44.4182 76.1527 45.1994 75.6995 45.1636C75.616 44.7402 74.8109 45.1458 74.5366 44.9609C74.5545 44.943 74.6797 44.8535 74.6916 44.8356C74.4471 44.5613 70.4217 45.2948 71.5727 44.776C66.8196 43.8576 58.1962 44.8893 53.0615 44.0842L53.0973 44.1379C53.0556 44.12 52.9303 44.1439 52.9005 44.0842C52.3936 44.2512 51.0577 44.3705 51.0577 44.3705L51.0637 44.3943ZM62.8419 44.9549C62.8419 44.9549 62.8479 44.9311 62.8419 44.9251C62.8419 44.9668 63.5039 44.943 63.5277 44.9549V45.098C62.8538 45.3664 61.3212 44.4003 62.7763 44.8237C62.824 44.7879 62.824 44.9072 62.8359 44.9549H62.8419ZM68.7101 45.0026C68.8234 45.0146 68.9487 45.0265 69.0858 45.0384C67.5651 45.4738 65.5136 44.9132 63.8438 45.11C64.4163 44.4838 65.77 44.8237 66.4916 44.8655C67.2132 44.7283 68.072 44.9012 68.7101 45.0026ZM78.5143 45.1577V45.0861H78.574C78.574 45.104 78.568 45.1279 78.5561 45.1398C78.5501 45.1517 78.5263 45.1696 78.5143 45.1636V45.1577ZM51.8688 44.7283C51.9821 44.615 52.4055 44.6806 52.1252 44.9072C52.0537 44.8714 51.8449 44.9728 51.8688 44.7283ZM70.4276 45.1815C70.4276 44.949 70.9882 44.9012 70.9882 45.2233C70.7974 45.2233 70.6125 45.2054 70.4276 45.1815ZM47.7121 44.949C47.5631 45.1935 47.6048 44.9191 47.5571 44.7641C47.5929 44.7999 47.73 44.8118 47.7002 44.9251L47.7121 44.949ZM45.1001 45.0802C45.0643 45.1994 44.9152 45.277 44.8436 45.2829C44.6647 45.1875 45.0166 44.9728 45.1001 45.0802ZM40.8003 45.0802C40.7943 45.2173 40.6929 45.265 40.6631 45.1279C40.6751 45.0265 40.8003 44.949 40.8182 45.104C40.8182 45.098 40.8182 45.0861 40.8003 45.0802ZM73.0039 45.6944C72.8489 46.0999 72.342 45.766 72.0676 45.8733C72.1332 45.4678 72.6223 45.7719 72.831 45.7004C72.9025 45.7004 72.9622 45.7004 73.0039 45.6944ZM56.0851 45.5036C56.0851 45.8614 55.5186 45.5751 55.3277 45.6527V45.5095C55.614 45.4738 55.7869 45.3843 56.0732 45.5036H56.0851ZM67.7977 45.7839C67.6903 45.927 67.5114 45.7898 67.3981 45.7898C67.3981 45.5871 67.8692 45.5572 67.7977 45.7839ZM63.0447 45.7004C63.0208 45.4797 63.2534 45.5871 63.325 45.5692C63.2772 45.6169 63.1878 45.754 63.1341 45.7481C63.0983 45.7481 63.0864 45.7183 63.0447 45.7004ZM56.2938 45.3664C56.5145 45.3664 56.753 45.3664 56.9796 45.3783V45.5215C56.7411 45.5215 56.5145 45.5155 56.2879 45.5095V45.3664H56.2938ZM58.5183 45.599V45.7421C58.1962 45.8733 58.1604 45.5095 58.5123 45.599H58.5183ZM53.4193 45.5155C53.4551 45.5215 53.5028 45.5334 53.5386 45.5334C53.9978 45.5215 53.3478 46.0343 53.4193 45.5155ZM51.01 45.6407C50.9623 45.6586 50.9027 45.7004 50.855 45.6944C50.533 45.6765 50.8908 45.3366 51.01 45.6407Z",
                        fill: "#101214"
                    }),
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("path", {
                        id: "Vector_24",
                        d: "M51.0637 56.4532L49.6444 56.638C49.6444 56.638 47.1873 56.4353 46.2033 56.7752L42.5059 56.6202C42.5059 56.6202 40.9613 56.7096 40.4961 56.9243C40.2039 57.0615 40.0191 57.2165 39.9773 57.3656C39.8938 57.6638 40.4127 57.9143 41.9036 57.8188C41.9215 57.8367 41.9811 57.8546 41.9871 57.8785C43.5615 57.6698 45.0762 58.0574 46.6804 58.0156C46.6626 57.9262 46.7162 57.8606 46.7639 57.9023L46.746 58.0097C47.8135 57.795 48.4815 58.1528 49.4595 57.7831C49.4595 57.7831 49.3402 57.9262 49.3462 57.9262C52.6918 57.8725 57.2241 58.0455 60.85 57.8904L60.8321 57.8725V57.8546C60.5041 57.7413 58.8999 57.5743 58.8999 57.5743C60.1106 57.0495 61.4762 57.6101 62.7584 57.5922L62.7465 57.7354C62.1919 57.7294 61.6969 57.789 61.5001 57.8487C63.4919 58.0514 67.4876 58.1051 69.3959 57.8964C69.3482 57.789 68.7578 58.0216 68.6087 57.6698C69.0978 57.6698 69.5868 57.6221 70.046 57.628C70.046 57.8546 69.7776 57.7771 69.7239 57.8188C70.5171 58.0693 86.7322 58.4152 82.8618 57.4253L82.9632 57.306C81.9613 57.2523 81.1324 57.2046 80.0947 56.972C79.9456 56.9899 79.9277 56.972 79.9277 57.0853C79.886 57.1032 79.8204 57.139 79.8383 57.1867C79.8502 57.473 79.5281 57.3597 79.385 57.3656C79.5639 56.477 76.1527 57.2583 75.6995 57.2225C75.616 56.7991 74.8109 57.2046 74.5366 57.0197C74.5545 57.0018 74.6797 56.9124 74.6916 56.8945C74.4471 56.6202 70.4217 57.3537 71.5727 56.8349C66.8196 55.9165 58.1962 56.9482 53.0615 56.1431L53.0973 56.1967C53.0556 56.1789 52.9303 56.2027 52.9005 56.1431C52.3936 56.31 51.0577 56.4293 51.0577 56.4293L51.0637 56.4532ZM62.8419 57.0197C62.8419 57.0197 62.8479 56.9959 62.8419 56.9899C62.8419 57.0316 63.5039 57.0078 63.5277 57.0197V57.1629C62.8538 57.4312 61.3212 56.4591 62.7763 56.8885C62.824 56.8527 62.824 56.972 62.8359 57.0197H62.8419ZM68.7101 57.0674C68.8234 57.0794 68.9487 57.0913 69.0858 57.1032C67.5651 57.5386 65.5136 56.978 63.8438 57.1748C64.4163 56.5486 65.77 56.8885 66.4916 56.9303C67.2132 56.7931 68.072 56.9661 68.7101 57.0674ZM78.5143 57.2225V57.1509H78.574C78.574 57.1688 78.568 57.1927 78.5561 57.2046C78.5501 57.2225 78.5263 57.2344 78.5143 57.2285V57.2225ZM51.8688 56.7931C51.9821 56.6798 52.4055 56.7454 52.1252 56.972C52.0537 56.9362 51.8449 57.0376 51.8688 56.7931ZM70.4276 57.2463C70.4276 57.0138 70.9882 56.972 70.9882 57.2941C70.7974 57.2941 70.6125 57.2762 70.4276 57.2463ZM47.7121 57.0138C47.5631 57.2583 47.6048 56.9839 47.5571 56.8289C47.5929 56.8647 47.73 56.8766 47.7002 56.9899L47.7121 57.0138ZM45.1001 57.145C45.0643 57.2642 44.9152 57.3418 44.8436 57.3477C44.6647 57.2523 45.0166 57.0376 45.1001 57.145ZM40.8003 57.145C40.7943 57.2821 40.6929 57.3298 40.6631 57.1927C40.6751 57.0913 40.8003 57.0138 40.8182 57.1688C40.8182 57.1628 40.8182 57.1509 40.8003 57.145ZM73.0039 57.7592C72.8489 58.1647 72.342 57.8308 72.0676 57.9381C72.1332 57.5326 72.6223 57.8367 72.831 57.7652C72.9025 57.7652 72.9622 57.7652 73.0039 57.7592ZM56.0851 57.5684C56.0851 57.9262 55.5186 57.6399 55.3277 57.7175V57.5743C55.614 57.5386 55.7869 57.4491 56.0732 57.5684H56.0851ZM67.7977 57.8487C67.6903 57.9918 67.5114 57.8487 67.3981 57.8546C67.3981 57.6519 67.8692 57.622 67.7977 57.8487ZM63.0447 57.7652C63.0208 57.5445 63.2534 57.6519 63.325 57.634C63.2772 57.6817 63.1878 57.8189 63.1341 57.8129C63.0983 57.8129 63.0864 57.7831 63.0447 57.7652ZM56.2938 57.4312C56.5145 57.4312 56.753 57.4312 56.9796 57.4431V57.5863C56.7411 57.5863 56.5145 57.5803 56.2879 57.5743V57.4312H56.2938ZM58.5183 57.6638V57.8069C58.1962 57.9381 58.1604 57.5743 58.5123 57.6638H58.5183ZM53.4193 57.5803C53.4551 57.5863 53.5028 57.5982 53.5386 57.5982C53.9978 57.5863 53.3478 58.0991 53.4193 57.5803ZM51.01 57.7055C50.9623 57.7234 50.9027 57.7652 50.855 57.7592C50.533 57.7413 50.8908 57.4014 51.01 57.7055Z",
                        fill: "#101214"
                    }),
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("path", {
                        id: "Vector_25",
                        d: "M51.0637 68.5174L49.6444 68.7022C49.6444 68.7022 47.1873 68.4995 46.2033 68.8394L42.5059 68.6844C42.5059 68.6844 40.9613 68.7738 40.4961 68.9885C40.2039 69.1257 40.0191 69.2807 39.9773 69.4298C39.8938 69.728 40.4127 69.9785 41.9036 69.8831C41.9215 69.9009 41.9811 69.9188 41.9871 69.9427C43.5615 69.734 45.0762 70.1216 46.6804 70.0799C46.6626 69.9904 46.7162 69.9248 46.7639 69.9665L46.746 70.0739C47.8135 69.8592 48.4815 70.217 49.4595 69.8473C49.4595 69.8473 49.3402 69.9904 49.3462 69.9904C52.6918 69.9367 57.2241 70.1097 60.85 69.9546L60.8321 69.9367V69.9188C60.5041 69.8055 58.8999 69.6385 58.8999 69.6385C60.1106 69.1137 61.4762 69.6743 62.7584 69.6564L62.7465 69.7996C62.1919 69.7936 61.6969 69.8532 61.5001 69.9129C63.4919 70.1156 67.4876 70.1693 69.3959 69.9606C69.3482 69.8532 68.7578 70.0858 68.6087 69.734C69.0978 69.734 69.5868 69.6863 70.046 69.6922C70.046 69.9188 69.7776 69.8413 69.7239 69.8831C70.5171 70.1335 86.7322 70.4794 82.8618 69.4895L82.9632 69.3702C81.9613 69.3165 81.1324 69.2688 80.0947 69.0362C79.9456 69.0541 79.9277 69.0362 79.9277 69.1495C79.886 69.1674 79.8204 69.2032 79.8383 69.2509C79.8502 69.5372 79.5281 69.4238 79.385 69.4298C79.5639 68.5412 76.1527 69.3225 75.6995 69.2867C75.616 68.8633 74.8109 69.2688 74.5366 69.0839C74.5545 69.066 74.6797 68.9766 74.6916 68.9587C74.4471 68.6844 70.4217 69.4179 71.5727 68.8991C66.8196 67.9807 58.1962 69.0124 53.0615 68.2073L53.0973 68.2609C53.0556 68.2431 52.9303 68.2669 52.9005 68.2073C52.3936 68.3743 51.0577 68.4935 51.0577 68.4935L51.0637 68.5174ZM62.8419 69.0839C62.8419 69.0839 62.8479 69.0601 62.8419 69.0541C62.8419 69.0959 63.5039 69.072 63.5277 69.0839V69.2271C62.8538 69.4954 61.3212 68.5233 62.7763 68.9527C62.824 68.9169 62.824 69.0362 62.8359 69.0839H62.8419ZM68.7101 69.1316C68.8234 69.1436 68.9487 69.1555 69.0858 69.1674C67.5651 69.6028 65.5136 69.0422 63.8438 69.239C64.4163 68.6128 65.77 68.9527 66.4916 68.9945C67.2132 68.8573 68.072 69.0302 68.7101 69.1316ZM78.5143 69.2867V69.2151H78.574C78.574 69.233 78.568 69.2569 78.5561 69.2688C78.5501 69.2807 78.5263 69.2986 78.5143 69.2927V69.2867ZM51.8688 68.8573C51.9821 68.744 52.4055 68.8096 52.1252 69.0362C52.0537 69.0004 51.8449 69.1018 51.8688 68.8573ZM70.4276 69.3105C70.4276 69.078 70.9882 69.0362 70.9882 69.3583C70.7974 69.3583 70.6125 69.3404 70.4276 69.3105ZM47.7121 69.078C47.5631 69.3225 47.6048 69.0481 47.5571 68.8931C47.5929 68.9289 47.73 68.9408 47.7002 69.0541L47.7121 69.078ZM45.1001 69.2092C45.0643 69.3284 44.9152 69.406 44.8436 69.4119C44.6647 69.3165 45.0166 69.1018 45.1001 69.2092ZM40.8003 69.2092C40.7943 69.3463 40.6929 69.394 40.6631 69.2569C40.6751 69.1555 40.8003 69.078 40.8182 69.233C40.8182 69.227 40.8182 69.2151 40.8003 69.2092ZM73.0039 69.8234C72.8489 70.2289 72.342 69.895 72.0676 70.0023C72.1332 69.5968 72.6223 69.9009 72.831 69.8294C72.9025 69.8294 72.9622 69.8294 73.0039 69.8234ZM56.0851 69.6326C56.0851 69.9904 55.5186 69.7041 55.3277 69.7817V69.6385C55.614 69.6028 55.7869 69.5133 56.0732 69.6326H56.0851ZM67.7977 69.9129C67.6903 70.056 67.5114 69.9129 67.3981 69.9188C67.3981 69.7161 67.8692 69.6863 67.7977 69.9129ZM63.0447 69.8294C63.0208 69.6087 63.2534 69.7161 63.325 69.6982C63.2772 69.7459 63.1878 69.883 63.1341 69.8771C63.0983 69.8771 63.0864 69.8473 63.0447 69.8294ZM56.2938 69.4954C56.5145 69.4954 56.753 69.4954 56.9796 69.5073V69.6505C56.7411 69.6505 56.5145 69.6445 56.2879 69.6385V69.4954H56.2938ZM58.5183 69.728V69.8711C58.1962 70.0023 58.1604 69.6385 58.5123 69.728H58.5183ZM53.4193 69.6445C53.4551 69.6505 53.5028 69.6624 53.5386 69.6624C53.9978 69.6505 53.3478 70.1633 53.4193 69.6445ZM51.01 69.7697C50.9623 69.7876 50.9027 69.8294 50.855 69.8234C50.533 69.8055 50.8908 69.4656 51.01 69.7697Z",
                        fill: "#101214"
                    })
                ]
            })
        })
    });
const $fc6840133e04adc0$export$5620dbefc1cb6f80 = "You\u2019re on the list! Thanks for signing up.";
const $fc6840133e04adc0$export$3f27bc10068ef877 = "Something went wrong. Try again.";
const $fc6840133e04adc0$export$21041608e6399292 = ({ environment: environment, formUrl: formUrl, atlassianId: atlassianId, anonymousId: anonymousId, eventHandlers: eventHandlers = {} })=>{
    const { handleNewsletterSignup: handleNewsletterSignup, error: error, success: success } = $fc6840133e04adc0$export$ea96d97e8873ca7f({
        environment: environment,
        ...eventHandlers
    });
    const { onSubmit: onSubmit = ()=>null, onPrivacyPolicyClick: onPrivacyPolicyClick } = eventHandlers;
    const handleSubmit = async ({ email: email })=>{
        onSubmit();
        await handleNewsletterSignup({
            email: email,
            anonymousId: anonymousId,
            atlassianId: atlassianId
        }, formUrl);
    };
    const successMessage = success ? $fc6840133e04adc0$export$5620dbefc1cb6f80 : undefined;
    const responseMessage = error ? $fc6840133e04adc0$export$3f27bc10068ef877 : successMessage;
    return (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
        css: $fc6840133e04adc0$var$$1db60c687807de63$var$signUpWrapper,
        children: [
            (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                css: $fc6840133e04adc0$var$$1db60c687807de63$var$stack,
                children: [
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$var$$eb8aa702a3355ad4$export$260d8f4a67dc36b0, {}),
                    (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("h2", {
                        css: $fc6840133e04adc0$var$$1db60c687807de63$var$headingStyles,
                        children: [
                            "Sign up for the community ",
                            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("span", {
                                children: "newsletter"
                            })
                        ]
                    }),
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("p", {
                        css: $fc6840133e04adc0$var$$1db60c687807de63$var$descriptionStyles,
                        children: "Get the latest resources, tips, and trends to help you grow."
                    })
                ]
            }),
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$var$$d51a9a1c56c91a16$export$ec00f1754868e2a2, {
                response: {
                    message: responseMessage,
                    isError: Boolean(error)
                },
                onSubmit: handleSubmit,
                onPrivacyPolicyClick: onPrivacyPolicyClick
            })
        ]
    });
};
const $fc6840133e04adc0$var$$1db60c687807de63$var$signUpWrapper = (0, $74Zh5.css)({
    margin: "0 auto",
    maxWidth: "624px"
});
const $fc6840133e04adc0$var$$1db60c687807de63$var$stack = (0, $74Zh5.css)({
    textAlign: "center",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.100")
});
const $fc6840133e04adc0$var$$1db60c687807de63$var$headingStyles = (0, $74Zh5.css)({
    fontFamily: '"Charlie Display", sans-serif',
    color: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.text"),
    fontSize: "40px",
    fontWeight: 700,
    lineHeight: "48px",
    letterSpacing: "-0.12px",
    marginTop: 0,
    "& span": {
        display: "block",
        [$fc6840133e04adc0$var$$f0285f05d4d9f8a0$export$426e07cd0772984d.MOBILE.MEDIA_QUERY]: {
            display: "inline-block"
        }
    },
    [$fc6840133e04adc0$var$$f0285f05d4d9f8a0$export$426e07cd0772984d.TABLET.MEDIA_QUERY]: {
        fontSize: "32px"
    },
    [$fc6840133e04adc0$var$$f0285f05d4d9f8a0$export$426e07cd0772984d.MOBILE.MEDIA_QUERY]: {
        width: "340px",
        fontSize: "32px"
    }
});
const $fc6840133e04adc0$var$$1db60c687807de63$var$descriptionStyles = (0, $74Zh5.css)({
    fontFamily: "Inter, sans-serif",
    color: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.text"),
    fontSize: "20px",
    fontWeight: "400",
    lineHeight: "32px",
    marginTop: 0,
    [$fc6840133e04adc0$var$$f0285f05d4d9f8a0$export$426e07cd0772984d.TABLET.MEDIA_QUERY]: {
        fontSize: "20px"
    },
    [$fc6840133e04adc0$var$$f0285f05d4d9f8a0$export$426e07cd0772984d.MOBILE.MEDIA_QUERY]: {
        fontSize: "16px",
        lineHeight: "24px"
    }
});
var $fc6840133e04adc0$var$$2f0c862779035c26$exports = {};
$fc6840133e04adc0$var$$parcel$export($fc6840133e04adc0$var$$2f0c862779035c26$exports, "MarkdownWrapper", ()=>$fc6840133e04adc0$export$e61786c4aee8d415);
const $fc6840133e04adc0$export$e61786c4aee8d415 = ({ children: children, overrides: overrides })=>{
    if (!children) return null;
    return (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).isValidElement(children) || typeof children !== "string" ? children : (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $igbF4.default), {
        css: $fc6840133e04adc0$var$$2f0c862779035c26$var$defaultStyles,
        options: {
            overrides: overrides
        },
        children: children
    });
};
const $fc6840133e04adc0$var$$2f0c862779035c26$var$defaultStyles = (0, $74Zh5.css)({
    "& > p:first-of-type": {
        margin: 0
    }
});
var $fc6840133e04adc0$var$$6937e97bac512574$exports = {};
$fc6840133e04adc0$var$$parcel$export($fc6840133e04adc0$var$$6937e97bac512574$exports, "TabbedAccordion", ()=>$fc6840133e04adc0$export$187009fd9803261e);
const $fc6840133e04adc0$var$$76fc9668239269ce$var$ResourceCard = ({ description: description, link: link, type: type })=>{
    const handleClick = ()=>{
        window.open(link.link, link.target);
    };
    const hasType = type && type.length > 0;
    const hasDescription = description && description.length > 0;
    const accessibilityLabel = `${link.label}; ${hasType ? `type: ${type}; ` : ""}${hasDescription ? description : ""}`;
    return (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
        css: $fc6840133e04adc0$var$$76fc9668239269ce$var$containerStyles,
        onClick: handleClick,
        onKeyDown: (e)=>{
            if (e.key === "Enter" || e.key === " ") {
                e.preventDefault();
                handleClick();
            }
        },
        tabIndex: 0,
        role: "button",
        "aria-label": accessibilityLabel,
        children: [
            (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                css: $fc6840133e04adc0$var$$76fc9668239269ce$var$contentStyles,
                children: [
                    hasType && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$export$3288d34c523a1192, {
                        label: type
                    }),
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$export$a6c7ac8248d6e38a, {
                        ...link,
                        style: $fc6840133e04adc0$export$2b77966d73aefa77.SEMIBOLD,
                        onClick: handleClick,
                        tabIndex: -1
                    }),
                    hasDescription && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("p", {
                        css: $fc6840133e04adc0$var$$76fc9668239269ce$var$descriptionStyles,
                        children: description
                    })
                ]
            }),
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$export$f04a61298a47a40f, {
                    type: "arrow-right",
                    alt: "Arrow right",
                    size: $fc6840133e04adc0$export$ff775019b5b6e7df.MEDIUM
                })
            })
        ]
    });
};
const $fc6840133e04adc0$var$$76fc9668239269ce$var$containerStyles = (0, $74Zh5.css)({
    display: "flex",
    flexDirection: "row",
    gap: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.100"),
    padding: `${(0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.300")} ${(0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.300")} ${(0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.300")} ${(0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.250")}`,
    alignItems: "center",
    backgroundColor: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("elevation.surface"),
    justifyContent: "space-between",
    "& a": {
        color: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.link")
    },
    "& a:hover": {
        textDecoration: "none"
    },
    "&:hover": {
        cursor: "pointer",
        boxShadow: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("elevation.shadow.overlay"),
        transition: "box-shadow 0.3s ease-in-out"
    },
    "&:hover svg": {
        color: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.link"),
        transform: "translateX(2px)"
    },
    [(0, $0bc19dfefbafca8c$export$987d49ffe1b0900f).below.md]: {
        padding: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.150")
    }
});
const $fc6840133e04adc0$var$$76fc9668239269ce$var$contentStyles = (0, $74Zh5.css)({
    display: "flex",
    flexDirection: "column",
    gap: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.100"),
    alignItems: "flex-start",
    [(0, $0bc19dfefbafca8c$export$987d49ffe1b0900f).below.md]: {
        gap: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.050")
    }
});
const $fc6840133e04adc0$var$$76fc9668239269ce$var$descriptionStyles = (0, $74Zh5.css)({
    margin: 0,
    color: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.text.subtle"),
    fontFamily: "Atlassian Sans",
    fontSize: "14px",
    fontWeight: "500",
    lineHeight: "20px",
    [(0, $0bc19dfefbafca8c$export$987d49ffe1b0900f).below.md]: {
        fontSize: "12px",
        lineHeight: "16px"
    }
});
var $fc6840133e04adc0$var$$76fc9668239269ce$export$2e2bcd8739ae039 = $fc6840133e04adc0$var$$76fc9668239269ce$var$ResourceCard;
const $fc6840133e04adc0$var$$f3815ecfa3837fcc$var$Expander = ({ title: title, description: description, resources: resources, color: color, expandedByDefault: expandedByDefault = false, onExpandToggle: onExpandToggle, iconType: iconType, expandedContent: expandedContent })=>{
    const [isExpanded, setIsExpanded] = (0, $5FkrB.useState)(expandedByDefault);
    const iconProps = isExpanded ? {
        type: "chevron-down",
        alt: "Chevron down"
    } : {
        type: "chevron-right",
        alt: "Chevron right"
    };
    const toggleExpanded = (0, $5FkrB.useCallback)(()=>{
        setIsExpanded(!isExpanded);
        onExpandToggle?.();
    }, [
        isExpanded,
        onExpandToggle
    ]);
    const handleKeyDown = (0, $5FkrB.useCallback)((event)=>{
        if (event.code === "Space") {
            // to handle cases when there are clickable items within accordion
            if (event.target !== event.currentTarget) {
                event.preventDefault();
                event.stopPropagation();
            } else {
                event.preventDefault();
                toggleExpanded();
            }
        }
    }, [
        toggleExpanded
    ]);
    const accessibilityLabel = `${title}; ${typeof description === "string" ? description : ""}`;
    const hasResources = resources.length > 0;
    return (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
        css: $fc6840133e04adc0$var$$f3815ecfa3837fcc$var$iconAndExpanderContainerStyles,
        role: "button",
        "aria-label": accessibilityLabel,
        "aria-expanded": isExpanded,
        tabIndex: 0,
        onKeyDown: handleKeyDown,
        children: [
            iconType && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                css: [
                    $fc6840133e04adc0$var$$f3815ecfa3837fcc$var$outerIconStyles,
                    (0, $74Zh5.css)({
                        opacity: isExpanded ? 1 : 0.6,
                        "& svg": {
                            color: color
                        }
                    })
                ],
                children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$export$f04a61298a47a40f, {
                    type: iconType,
                    color: color,
                    size: $fc6840133e04adc0$export$ff775019b5b6e7df.LARGE
                })
            }),
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                css: $fc6840133e04adc0$var$$f3815ecfa3837fcc$var$expanderCardStyles,
                style: {
                    borderLeft: `8px solid ${color && isExpanded ? color : "transparent"}`
                },
                children: (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                    css: $fc6840133e04adc0$var$$f3815ecfa3837fcc$var$containerStyles,
                    children: [
                        (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                            role: "button",
                            tabIndex: 0,
                            css: $fc6840133e04adc0$var$$f3815ecfa3837fcc$var$expanderHeaderStyles,
                            onClick: toggleExpanded,
                            onKeyDown: (e)=>{
                                if (e.key === "Enter" || e.key === " ") {
                                    e.preventDefault();
                                    toggleExpanded();
                                }
                            },
                            children: [
                                (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$export$f04a61298a47a40f, {
                                    ...iconProps,
                                    size: $fc6840133e04adc0$export$ff775019b5b6e7df.LARGE
                                }),
                                (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$export$a8a3e93435678ff9, {
                                    level: 5,
                                    children: title
                                })
                            ]
                        }),
                        (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                            css: $fc6840133e04adc0$var$$f3815ecfa3837fcc$var$contentStyles,
                            children: [
                                typeof description === "string" ? (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$export$5f1af8db9871e1d6, {
                                    children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("span", {
                                        css: $fc6840133e04adc0$var$$f3815ecfa3837fcc$var$descriptionStyles,
                                        children: description
                                    })
                                }) : (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                                    css: $fc6840133e04adc0$var$$f3815ecfa3837fcc$var$descriptionStyles,
                                    children: description
                                }),
                                isExpanded && expandedContent && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                                    css: $fc6840133e04adc0$var$$f3815ecfa3837fcc$var$expandedContentStyles,
                                    children: expandedContent
                                }),
                                isExpanded && hasResources && (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                                    css: $fc6840133e04adc0$var$$f3815ecfa3837fcc$var$resourcesStyles,
                                    children: [
                                        (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$export$71f050e2efa708bb, {
                                            fontWeight: "semibold",
                                            children: "Resources"
                                        }),
                                        resources.map((resource)=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$var$$76fc9668239269ce$export$2e2bcd8739ae039, {
                                                description: resource.description,
                                                link: resource.link,
                                                type: resource.type
                                            }, resource.link.link))
                                    ]
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
const $fc6840133e04adc0$var$$f3815ecfa3837fcc$var$iconAndExpanderContainerStyles = (0, $74Zh5.css)({
    display: "flex",
    flexDirection: "row",
    gap: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.300")
});
const $fc6840133e04adc0$var$$f3815ecfa3837fcc$var$expanderCardStyles = (0, $74Zh5.css)({
    display: "flex",
    flex: "auto",
    padding: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.400"),
    flexDirection: "column",
    gap: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.300"),
    alignSelf: "stretch",
    alignItems: "stretch",
    borderRadius: "8px",
    background: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("elevation.surface"),
    boxShadow: "0 0 1px 0 rgba(9, 30, 66, 0.31), 0 1px 1px 0 rgba(9, 30, 66, 0.25)",
    [(0, $0bc19dfefbafca8c$export$987d49ffe1b0900f).below.md]: {
        padding: `${(0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.150")} ${(0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.100")} ${(0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.150")} ${(0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.050")}`
    }
});
const $fc6840133e04adc0$var$$f3815ecfa3837fcc$var$containerStyles = (0, $74Zh5.css)({
    display: "flex",
    flexDirection: "column",
    gap: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.150"),
    [(0, $0bc19dfefbafca8c$export$987d49ffe1b0900f).below.md]: {
        gap: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.100")
    }
});
const $fc6840133e04adc0$var$$f3815ecfa3837fcc$var$expanderHeaderStyles = (0, $74Zh5.css)({
    display: "flex",
    alignItems: "center",
    gap: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.200"),
    cursor: "pointer",
    userSelect: "none",
    [(0, $0bc19dfefbafca8c$export$987d49ffe1b0900f).below.md]: {
        gap: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.100")
    }
});
const $fc6840133e04adc0$var$$f3815ecfa3837fcc$var$contentStyles = (0, $74Zh5.css)({
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "flex-start",
    gap: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.400"),
    marginLeft: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.600"),
    [(0, $0bc19dfefbafca8c$export$987d49ffe1b0900f).below.md]: {
        marginLeft: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.500")
    }
});
const $fc6840133e04adc0$var$$f3815ecfa3837fcc$var$resourcesStyles = (0, $74Zh5.css)({
    display: "flex",
    padding: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.300"),
    flexDirection: "column",
    alignItems: "stretch",
    gap: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.100"),
    alignSelf: "stretch",
    borderRadius: "8px",
    backgroundColor: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("elevation.surface.sunken"),
    [(0, $0bc19dfefbafca8c$export$987d49ffe1b0900f).below.md]: {
        padding: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.150"),
        gap: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.200")
    }
});
const $fc6840133e04adc0$var$$f3815ecfa3837fcc$var$outerIconStyles = (0, $74Zh5.css)({
    "& svg": {
        width: "32px !important",
        height: "32px !important"
    },
    [(0, $0bc19dfefbafca8c$export$987d49ffe1b0900f).below.md]: {
        display: "none"
    }
});
const $fc6840133e04adc0$var$$f3815ecfa3837fcc$var$descriptionStyles = (0, $74Zh5.css)({
    whiteSpace: "pre-wrap"
});
const $fc6840133e04adc0$var$$f3815ecfa3837fcc$var$expandedContentStyles = (0, $74Zh5.css)({
    width: "100%"
});
var $fc6840133e04adc0$var$$f3815ecfa3837fcc$export$2e2bcd8739ae039 = $fc6840133e04adc0$var$$f3815ecfa3837fcc$var$Expander;
const $fc6840133e04adc0$var$$737c57f1a347e52a$var$TabContent = ({ tabExpanders: tabExpanders, color: color, iconType: iconType })=>{
    return (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
        css: $fc6840133e04adc0$var$$737c57f1a347e52a$var$tabContentContainerStyles,
        children: tabExpanders.map((tabItem, index)=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$var$$f3815ecfa3837fcc$export$2e2bcd8739ae039, {
                title: tabItem.title,
                description: tabItem.description,
                resources: tabItem.resources,
                color: color,
                expandedByDefault: index === 0,
                iconType: iconType,
                expandedContent: tabItem.expandedContent
            }, tabItem.title))
    });
};
const $fc6840133e04adc0$var$$737c57f1a347e52a$var$tabContentContainerStyles = (0, $74Zh5.css)({
    display: "flex",
    flexDirection: "column",
    gap: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.300"),
    [(0, $0bc19dfefbafca8c$export$987d49ffe1b0900f).below.md]: {
        gap: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.200")
    }
});
var $fc6840133e04adc0$var$$737c57f1a347e52a$export$2e2bcd8739ae039 = $fc6840133e04adc0$var$$737c57f1a347e52a$var$TabContent;
const $fc6840133e04adc0$export$187009fd9803261e = ({ tabs: tabs, containerStyles: containerStyles, defaultSelectedIndex: defaultSelectedIndex = 0, onTabChange: onTabChange })=>{
    const [selectedTabIndex, setSelectedTabIndex] = (0, $5FkrB.useState)(defaultSelectedIndex);
    const tabRefs = (0, $5FkrB.useRef)([]);
    const contentRef = (0, $5FkrB.useRef)(null);
    const handleSelectTab = (0, $5FkrB.useCallback)((index)=>{
        setSelectedTabIndex(index);
        onTabChange?.(index);
    }, [
        onTabChange
    ]);
    const handleKeyDown = (0, $5FkrB.useCallback)((event)=>{
        let newIndex = selectedTabIndex;
        switch(event.key){
            case "ArrowLeft":
                event.preventDefault();
                newIndex = selectedTabIndex > 0 ? selectedTabIndex - 1 : tabs.length - 1;
                break;
            case "ArrowRight":
                event.preventDefault();
                newIndex = selectedTabIndex < tabs.length - 1 ? selectedTabIndex + 1 : 0;
                break;
            case "Home":
                event.preventDefault();
                newIndex = 0;
                break;
            case "End":
                event.preventDefault();
                newIndex = tabs.length - 1;
                break;
            default:
                return;
        }
        if (newIndex !== selectedTabIndex) {
            contentRef.current?.focus?.();
            handleSelectTab(newIndex);
        }
    }, [
        selectedTabIndex,
        tabs.length,
        handleSelectTab
    ]);
    const selectedTabContent = (0, $5FkrB.useMemo)(()=>{
        const selected = tabs[selectedTabIndex];
        if (!selected) return null;
        return selected;
    }, [
        tabs,
        selectedTabIndex
    ]);
    return (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
        css: [
            $fc6840133e04adc0$var$$6937e97bac512574$var$defaultContainerStyles,
            containerStyles
        ],
        "data-testid": "tabbed-accordion",
        children: [
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                css: $fc6840133e04adc0$var$$6937e97bac512574$var$tabsHeaderStyles,
                children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                    css: $fc6840133e04adc0$var$$6937e97bac512574$var$tabsRowStyles,
                    role: "tablist",
                    "aria-label": "Tabbed accordion tabs",
                    tabIndex: 0,
                    onKeyDown: handleKeyDown,
                    children: tabs.map((tab, index)=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                            css: $fc6840133e04adc0$var$$6937e97bac512574$var$tabWrapperStyles,
                            ref: (el)=>tabRefs.current[index] = el,
                            tabIndex: -1,
                            role: "tab",
                            "aria-selected": index === selectedTabIndex,
                            "aria-controls": `tabpanel-${index}`,
                            "aria-setsize": tabs.length,
                            "aria-posinset": index + 1,
                            id: `tab-${index}`,
                            onClick: ()=>handleSelectTab(index),
                            onKeyDown: (e)=>{
                                if (e.key === "Enter" || e.key === " ") {
                                    e.preventDefault();
                                    handleSelectTab(index);
                                }
                            },
                            children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$export$3e41faf802a29e71, {
                                label: tab.label,
                                labelColor: tab.labelColor || (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.text"),
                                labelColorSelected: tab.labelColorSelected || (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.text"),
                                labelColorSelectedHover: tab.labelColorSelectedHover || (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.text"),
                                selectedColor: tab.color,
                                selectedHoverColor: tab.color,
                                size: $fc6840133e04adc0$export$ddadc1228c8dcfa.SMALL,
                                selected: index === selectedTabIndex
                            })
                        }, tab.label))
                })
            }),
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("hr", {
                css: $fc6840133e04adc0$var$$6937e97bac512574$var$dividerStyles
            }),
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                css: $fc6840133e04adc0$var$$6937e97bac512574$var$accordionContainerStyles,
                ref: contentRef,
                tabIndex: -1,
                role: "tabpanel",
                id: `tabpanel-${selectedTabIndex}`,
                "aria-labelledby": `tab-${selectedTabIndex}`,
                "aria-label": `${tabs[selectedTabIndex]?.label} content`,
                children: selectedTabContent && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$var$$737c57f1a347e52a$export$2e2bcd8739ae039, {
                    tabExpanders: selectedTabContent.tabExpanders,
                    color: selectedTabContent.color,
                    iconType: selectedTabContent.iconType
                })
            })
        ]
    });
};
const $fc6840133e04adc0$var$$6937e97bac512574$var$defaultContainerStyles = (0, $74Zh5.css)({
    width: "100%",
    display: "flex",
    flexDirection: "column",
    gap: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.600"),
    [(0, $0bc19dfefbafca8c$export$987d49ffe1b0900f).below.md]: {
        gap: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.300")
    }
});
const $fc6840133e04adc0$var$$6937e97bac512574$var$tabsHeaderStyles = (0, $74Zh5.css)({
    width: "100%"
});
const $fc6840133e04adc0$var$$6937e97bac512574$var$tabsRowStyles = (0, $74Zh5.css)({
    display: "flex",
    flexWrap: "wrap",
    gap: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.100")
});
const $fc6840133e04adc0$var$$6937e97bac512574$var$dividerStyles = (0, $74Zh5.css)({
    border: `0.5px solid ${(0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.border")}`,
    width: "100%",
    margin: 0,
    [(0, $0bc19dfefbafca8c$export$987d49ffe1b0900f).above.md]: {
        display: "none"
    }
});
const $fc6840133e04adc0$var$$6937e97bac512574$var$tabWrapperStyles = (0, $74Zh5.css)({
    display: "flex",
    // override default pressed style
    '& [data-testid="tab"]:active': {
        backgroundColor: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.background.accent.gray.subtlest.hovered")
    }
});
const $fc6840133e04adc0$var$$6937e97bac512574$var$accordionContainerStyles = (0, $74Zh5.css)({
    width: "100%"
});
var $fc6840133e04adc0$var$$8aff256b69bb18bd$exports = {};
$fc6840133e04adc0$var$$parcel$export($fc6840133e04adc0$var$$8aff256b69bb18bd$exports, "TabbedCards", ()=>$fc6840133e04adc0$export$f0f045459b5b92);
const $fc6840133e04adc0$export$f0f045459b5b92 = ({ cards: cards, containerStyles: containerStyles, defaultSelectedIndex: defaultSelectedIndex = 0, onTabChange: onTabChange, ctaText: ctaText = "Learn more" })=>{
    const safeDefaultSelectedIndex = Math.min(Math.max(0, defaultSelectedIndex), Math.max(0, cards.length - 1));
    const [selectedCardIndex, setSelectedCardIndex] = (0, $5FkrB.useState)(safeDefaultSelectedIndex);
    const tabRefs = (0, $5FkrB.useRef)([]);
    const handleSelectTab = (0, $5FkrB.useCallback)((index)=>{
        setSelectedCardIndex(index);
        onTabChange?.(index);
    }, [
        onTabChange
    ]);
    const selectedCard = (0, $5FkrB.useMemo)(()=>{
        const selected = cards[selectedCardIndex];
        return selected ?? null;
    }, [
        cards,
        selectedCardIndex
    ]);
    if (!cards.length) return null;
    return (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
        css: [
            $fc6840133e04adc0$var$$8aff256b69bb18bd$var$containerBaseStyles,
            containerStyles
        ],
        "data-testid": "tabbed-cards",
        children: [
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                css: $fc6840133e04adc0$var$$8aff256b69bb18bd$var$tabsHeaderStyles,
                children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                    css: $fc6840133e04adc0$var$$8aff256b69bb18bd$var$tabsRowStyles,
                    role: "tablist",
                    "aria-label": "Tabbed cards tabs",
                    children: cards.map((card, index)=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                            css: $fc6840133e04adc0$var$$8aff256b69bb18bd$var$tabWrapperStyles,
                            ref: (el)=>tabRefs.current[index] = el,
                            tabIndex: -1,
                            role: "tab",
                            "aria-selected": index === selectedCardIndex,
                            "aria-controls": `tabpanel-${index}`,
                            "aria-setsize": cards.length,
                            "aria-posinset": index + 1,
                            id: `tab-${index}`,
                            onClick: ()=>handleSelectTab(index),
                            onKeyDown: (e)=>{
                                if (e.key === "Enter" || e.key === " ") {
                                    e.preventDefault();
                                    handleSelectTab(index);
                                }
                            },
                            children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$export$3e41faf802a29e71, {
                                label: card.title,
                                labelColor: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.text"),
                                labelColorSelected: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.text.inverse"),
                                labelColorSelectedHover: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.text.inverse"),
                                selectedColor: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.icon.discovery"),
                                selectedHoverColor: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.icon.discovery"),
                                size: $fc6840133e04adc0$export$ddadc1228c8dcfa.MEDIUM,
                                selected: index === selectedCardIndex
                            })
                        }, card.title))
                })
            }),
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                css: $fc6840133e04adc0$var$$8aff256b69bb18bd$var$panelContainerStyles,
                tabIndex: -1,
                role: "tabpanel",
                id: `tabpanel-${selectedCardIndex}`,
                "aria-labelledby": `tab-${selectedCardIndex}`,
                "aria-label": `${cards[selectedCardIndex]?.title} content`,
                children: selectedCard && (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                    css: $fc6840133e04adc0$var$$8aff256b69bb18bd$var$cardContainerStyles,
                    children: [
                        (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                            css: $fc6840133e04adc0$var$$8aff256b69bb18bd$var$cardLeftStyles,
                            children: [
                                (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                                    css: $fc6840133e04adc0$var$$8aff256b69bb18bd$var$textBlockStyles,
                                    children: [
                                        (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$export$a8a3e93435678ff9, {
                                            level: 3,
                                            children: selectedCard.title
                                        }),
                                        selectedCard.subtitle && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$export$5f1af8db9871e1d6, {
                                            size: "regular",
                                            color: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.text"),
                                            children: selectedCard.subtitle
                                        })
                                    ]
                                }),
                                (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                                    css: $fc6840133e04adc0$var$$8aff256b69bb18bd$var$ctaContainerStyles,
                                    children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$export$353f5b6fc5456de1, {
                                        appearance: $fc6840133e04adc0$export$261c9483fc4a455a.LINK,
                                        label: ctaText,
                                        href: selectedCard.href,
                                        target: selectedCard.target,
                                        iconAfter: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$export$f04a61298a47a40f, {
                                            type: "arrow-right",
                                            alt: "Arrow right",
                                            size: $fc6840133e04adc0$export$ff775019b5b6e7df.MEDIUM
                                        })
                                    })
                                })
                            ]
                        }),
                        (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                            css: $fc6840133e04adc0$var$$8aff256b69bb18bd$var$imageWellStyles,
                            children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("img", {
                                src: selectedCard.img.src,
                                alt: selectedCard.img.alt,
                                width: selectedCard.img.width,
                                height: selectedCard.img.height,
                                css: $fc6840133e04adc0$var$$8aff256b69bb18bd$var$cardImageStyles,
                                loading: selectedCard.img.loading,
                                decoding: selectedCard.img.decoding
                            })
                        })
                    ]
                })
            })
        ]
    });
};
const $fc6840133e04adc0$var$$8aff256b69bb18bd$var$containerBaseStyles = (0, $74Zh5.css)({
    width: "100%",
    display: "flex",
    flexDirection: "column",
    gap: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.600"),
    [(0, $0bc19dfefbafca8c$export$987d49ffe1b0900f).below.md]: {
        gap: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.300")
    }
});
const $fc6840133e04adc0$var$$8aff256b69bb18bd$var$tabsHeaderStyles = (0, $74Zh5.css)({
    width: "100%"
});
const $fc6840133e04adc0$var$$8aff256b69bb18bd$var$tabsRowStyles = (0, $74Zh5.css)({
    display: "flex",
    flexWrap: "nowrap",
    justifyContent: "center",
    gap: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.100"),
    overflowX: "auto",
    [(0, $0bc19dfefbafca8c$export$987d49ffe1b0900f).below.md]: {
        flexWrap: "wrap",
        justifyContent: "flex-start"
    }
});
const $fc6840133e04adc0$var$$8aff256b69bb18bd$var$tabWrapperStyles = (0, $74Zh5.css)({
    display: "flex",
    // override default pressed style
    '& [data-testid="tab-selected"]:active': {
        backgroundColor: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.icon.discovery")
    },
    '& [data-testid="tab"]:active': {
        backgroundColor: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.background.accent.gray.subtlest.hovered")
    }
});
const $fc6840133e04adc0$var$$8aff256b69bb18bd$var$panelContainerStyles = (0, $74Zh5.css)({
    width: "100%"
});
const $fc6840133e04adc0$var$$8aff256b69bb18bd$var$cardContainerStyles = (0, $74Zh5.css)({
    width: "100%",
    backgroundColor: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("elevation.surface"),
    borderRadius: "8px",
    boxShadow: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("elevation.shadow.raised"),
    overflow: "hidden",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    minHeight: "266px",
    gap: "80px",
    paddingLeft: "62px",
    [(0, $0bc19dfefbafca8c$export$987d49ffe1b0900f).below.md]: {
        flexDirection: "column",
        alignItems: "stretch",
        gap: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.400"),
        padding: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.400")
    }
});
const $fc6840133e04adc0$var$$8aff256b69bb18bd$var$cardLeftStyles = (0, $74Zh5.css)({
    display: "flex",
    flexDirection: "column",
    gap: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.300"),
    flex: "1 1 auto",
    minWidth: 0,
    paddingTop: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.400"),
    paddingBottom: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.400"),
    [(0, $0bc19dfefbafca8c$export$987d49ffe1b0900f).below.md]: {
        padding: 0
    }
});
const $fc6840133e04adc0$var$$8aff256b69bb18bd$var$textBlockStyles = (0, $74Zh5.css)({
    display: "flex",
    flexDirection: "column",
    gap: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.100"),
    minWidth: 0
});
const $fc6840133e04adc0$var$$8aff256b69bb18bd$var$ctaContainerStyles = (0, $74Zh5.css)({
    display: "flex",
    alignItems: "center",
    alignSelf: "flex-start",
    // Align button label with heading/subtitle by removing left padding.
    '& [data-testid="button-link"]': {
        paddingLeft: 0
    }
});
const $fc6840133e04adc0$var$$8aff256b69bb18bd$var$imageWellStyles = (0, $74Zh5.css)({
    width: "416px",
    height: "266px",
    backgroundColor: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("elevation.surface.sunken"),
    borderTopRightRadius: "20px",
    borderBottomRightRadius: "20px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0,
    [(0, $0bc19dfefbafca8c$export$987d49ffe1b0900f).below.md]: {
        width: "100%",
        height: "200px",
        borderTopRightRadius: "8px",
        borderBottomRightRadius: "8px",
        borderTopLeftRadius: "8px",
        borderBottomLeftRadius: "8px"
    }
});
const $fc6840133e04adc0$var$$8aff256b69bb18bd$var$cardImageStyles = (0, $74Zh5.css)({
    maxWidth: "100%",
    maxHeight: "100%",
    objectFit: "contain"
});
var $fc6840133e04adc0$var$$271716b3dbf43c41$exports = {};
$fc6840133e04adc0$var$$parcel$export($fc6840133e04adc0$var$$271716b3dbf43c41$exports, "MeatballMenu", ()=>$fc6840133e04adc0$export$ef4a0fdddd7eccb7);
const $fc6840133e04adc0$export$ef4a0fdddd7eccb7 = ({ items: items, placement: placement = "bottom-end", testId: testId = "meatball-menu", ariaLabel: ariaLabel = "More options", isInverted: isInverted = false })=>{
    return (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
        css: $fc6840133e04adc0$var$$271716b3dbf43c41$var$menuContainerStyles,
        "data-testid": testId,
        children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $5a40bdc8514ad3b7$export$2e2bcd8739ae039), {
            trigger: ({ triggerRef: triggerRef, ...props })=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("button", {
                    ...props,
                    ref: triggerRef,
                    css: [
                        $fc6840133e04adc0$var$$271716b3dbf43c41$var$triggerButtonStyles,
                        isInverted && $fc6840133e04adc0$var$$271716b3dbf43c41$var$invertedTriggerButtonStyles
                    ],
                    "aria-label": ariaLabel,
                    "data-testid": `${testId}-trigger`,
                    children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$export$f04a61298a47a40f, {
                        type: "more-vertical",
                        rotation: $fc6840133e04adc0$export$b3241a99d3e47e02.NINETY,
                        alt: ariaLabel,
                        color: isInverted ? "#FFFFFF" : undefined
                    })
                }),
            placement: placement,
            children: items.map((item, index)=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $d1103224b1f806e2$export$2e2bcd8739ae039), {
                    onClick: item.onClick,
                    isDisabled: item.isDisabled,
                    testId: item.testId || `${testId}-item-${index}`,
                    children: item.label
                }, `${item.label}-${index}`))
        })
    });
};
const $fc6840133e04adc0$var$$271716b3dbf43c41$var$menuContainerStyles = (0, $74Zh5.css)({
    display: "inline-flex",
    alignItems: "center"
});
const $fc6840133e04adc0$var$$271716b3dbf43c41$var$triggerButtonStyles = (0, $74Zh5.css)({
    background: "transparent",
    border: "none",
    padding: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.050"),
    cursor: "pointer",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: "4px",
    transition: "background-color 0.2s ease",
    "&:hover": {
        backgroundColor: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.background.neutral.hovered")
    },
    "&:active": {
        backgroundColor: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.background.neutral.pressed")
    },
    "&:focus": {
        outline: `2px solid ${(0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.border.focused")}`,
        outlineOffset: "2px"
    }
});
const $fc6840133e04adc0$var$$271716b3dbf43c41$var$invertedTriggerButtonStyles = (0, $74Zh5.css)({
    "&:hover": {
        backgroundColor: "rgba(255, 255, 255, 0.16)"
    },
    "&:active": {
        backgroundColor: "rgba(255, 255, 255, 0.24)"
    },
    "&:focus": {
        outline: `2px solid ${(0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.border.inverse")}`,
        outlineOffset: "2px"
    }
});
$fc6840133e04adc0$var$$parcel$exportWildcard($fc6840133e04adc0$var$$5d4509b60606b6df$exports, $fc6840133e04adc0$var$$660bd1c6cb41002a$exports);
$fc6840133e04adc0$var$$parcel$exportWildcard($fc6840133e04adc0$var$$5d4509b60606b6df$exports, $fc6840133e04adc0$var$$fec02fc26c7e145d$exports);
$fc6840133e04adc0$var$$parcel$exportWildcard($fc6840133e04adc0$var$$5d4509b60606b6df$exports, $fc6840133e04adc0$var$$d501466973a9f0a6$exports);
$fc6840133e04adc0$var$$parcel$exportWildcard($fc6840133e04adc0$var$$5d4509b60606b6df$exports, $fc6840133e04adc0$var$$c4979bfceee73878$exports);
$fc6840133e04adc0$var$$parcel$exportWildcard($fc6840133e04adc0$var$$5d4509b60606b6df$exports, $fc6840133e04adc0$var$$0903e93de01b205a$exports);
$fc6840133e04adc0$var$$parcel$exportWildcard($fc6840133e04adc0$var$$5d4509b60606b6df$exports, $fc6840133e04adc0$var$$a950778dc3003c4a$exports);
$fc6840133e04adc0$var$$parcel$exportWildcard($fc6840133e04adc0$var$$5d4509b60606b6df$exports, $fc6840133e04adc0$var$$582583ec420fce57$exports);
$fc6840133e04adc0$var$$parcel$exportWildcard($fc6840133e04adc0$var$$5d4509b60606b6df$exports, $fc6840133e04adc0$var$$a02a6f7de308273b$exports);
$fc6840133e04adc0$var$$parcel$exportWildcard($fc6840133e04adc0$var$$5d4509b60606b6df$exports, $fc6840133e04adc0$var$$1298c86a7e6a9fc7$exports);
$fc6840133e04adc0$var$$parcel$exportWildcard($fc6840133e04adc0$var$$5d4509b60606b6df$exports, $fc6840133e04adc0$var$$c0c01354ab9765ae$exports);
$fc6840133e04adc0$var$$parcel$exportWildcard($fc6840133e04adc0$var$$5d4509b60606b6df$exports, $fc6840133e04adc0$var$$4fce8dfc4ce8f546$exports);
$fc6840133e04adc0$var$$parcel$exportWildcard($fc6840133e04adc0$var$$5d4509b60606b6df$exports, $fc6840133e04adc0$var$$800df40a54823a3f$exports);
$fc6840133e04adc0$var$$parcel$exportWildcard($fc6840133e04adc0$var$$5d4509b60606b6df$exports, $fc6840133e04adc0$var$$25cbe9fdb2d8d071$exports);
$fc6840133e04adc0$var$$parcel$exportWildcard($fc6840133e04adc0$var$$5d4509b60606b6df$exports, $fc6840133e04adc0$var$$9efbb38deb40219f$exports);
$fc6840133e04adc0$var$$parcel$exportWildcard($fc6840133e04adc0$var$$5d4509b60606b6df$exports, $fc6840133e04adc0$var$$3fbcb32390ca7008$exports);
$fc6840133e04adc0$var$$parcel$exportWildcard($fc6840133e04adc0$var$$5d4509b60606b6df$exports, $fc6840133e04adc0$var$$731a4fd527bab680$exports);
$fc6840133e04adc0$var$$parcel$exportWildcard($fc6840133e04adc0$var$$5d4509b60606b6df$exports, $fc6840133e04adc0$var$$5cf70e33bfc6ce73$exports);
$fc6840133e04adc0$var$$parcel$exportWildcard($fc6840133e04adc0$var$$5d4509b60606b6df$exports, $fc6840133e04adc0$var$$8b54d37779d052e8$exports);
$fc6840133e04adc0$var$$parcel$exportWildcard($fc6840133e04adc0$var$$5d4509b60606b6df$exports, $fc6840133e04adc0$var$$9cfa05d02afa3952$exports);
$fc6840133e04adc0$var$$parcel$exportWildcard($fc6840133e04adc0$var$$5d4509b60606b6df$exports, $fc6840133e04adc0$var$$7d458ed59bb9c6a8$exports);
$fc6840133e04adc0$var$$parcel$exportWildcard($fc6840133e04adc0$var$$5d4509b60606b6df$exports, $fc6840133e04adc0$var$$a467abe0c2c1750b$exports);
$fc6840133e04adc0$var$$parcel$exportWildcard($fc6840133e04adc0$var$$5d4509b60606b6df$exports, $fc6840133e04adc0$var$$52124b9ae1d78e04$exports);
$fc6840133e04adc0$var$$parcel$exportWildcard($fc6840133e04adc0$var$$5d4509b60606b6df$exports, $fc6840133e04adc0$var$$77696804880d7cdc$exports);
$fc6840133e04adc0$var$$parcel$exportWildcard($fc6840133e04adc0$var$$5d4509b60606b6df$exports, $fc6840133e04adc0$var$$4366d2b05f9f8f6b$exports);
$fc6840133e04adc0$var$$parcel$exportWildcard($fc6840133e04adc0$var$$5d4509b60606b6df$exports, $fc6840133e04adc0$var$$be203e745bcefb12$exports);
$fc6840133e04adc0$var$$parcel$exportWildcard($fc6840133e04adc0$var$$5d4509b60606b6df$exports, $fc6840133e04adc0$var$$a0eced43682c2d75$exports);
$fc6840133e04adc0$var$$parcel$exportWildcard($fc6840133e04adc0$var$$5d4509b60606b6df$exports, $fc6840133e04adc0$var$$1db60c687807de63$exports);
$fc6840133e04adc0$var$$parcel$exportWildcard($fc6840133e04adc0$var$$5d4509b60606b6df$exports, $fc6840133e04adc0$var$$2f0c862779035c26$exports);
$fc6840133e04adc0$var$$parcel$exportWildcard($fc6840133e04adc0$var$$5d4509b60606b6df$exports, $fc6840133e04adc0$var$$6937e97bac512574$exports);
$fc6840133e04adc0$var$$parcel$exportWildcard($fc6840133e04adc0$var$$5d4509b60606b6df$exports, $fc6840133e04adc0$var$$8aff256b69bb18bd$exports);
$fc6840133e04adc0$var$$parcel$exportWildcard($fc6840133e04adc0$var$$5d4509b60606b6df$exports, $fc6840133e04adc0$var$$271716b3dbf43c41$exports);
var $fc6840133e04adc0$var$$6e379ec2eca3d7d3$exports = {};
var $fc6840133e04adc0$var$$83fc18f8199a12ff$exports = {};
$fc6840133e04adc0$var$$parcel$export($fc6840133e04adc0$var$$83fc18f8199a12ff$exports, "AudioPlayer", ()=>$fc6840133e04adc0$export$832cc5475f11d8b4);
// using 'plyr' instead of 'plyr/dist/plyr'
// will start executing DOM APIs right away
// and it breaks SSR
const $fc6840133e04adc0$export$832cc5475f11d8b4 = ({ source: source, isOpened: isOpened, onClose: onClose, onControlClick: onControlClick, onProgressUpdate: onProgressUpdate, onError: onError })=>{
    const audioRef = (0, $5FkrB.useRef)(null);
    const focusRef = (0, $5FkrB.useRef)(null);
    const playerSource = {
        type: "audio",
        sources: [
            {
                src: source
            }
        ]
    };
    const playerOptions = {
        hideControls: true,
        controls: [
            "play",
            "progress",
            "current-time"
        ]
    };
    const addEvent = (0, $5FkrB.useCallback)((instance, event)=>{
        instance.on(event, ()=>onControlClick && onControlClick(event));
        instance.on("timeupdate", ()=>{
            const currentTime = instance.currentTime;
            const duration = instance.duration;
            const percentage = currentTime / duration * 100;
            onProgressUpdate && onProgressUpdate(+percentage.toFixed(2));
        });
    }, [
        onControlClick,
        onProgressUpdate
    ]);
    const addEvents = (0, $5FkrB.useCallback)((instance)=>{
        addEvent(instance, "play");
        addEvent(instance, "pause");
        if (onError) instance.on("error", onError);
    }, [
        addEvent,
        onError
    ]);
    (0, $5FkrB.useEffect)(()=>{
        const player = new (0, (/*@__PURE__*/$parcel$interopDefault($1c94bc9aa532188d$exports)))(audioRef.current, playerOptions);
        player.source = playerSource;
        addEvents(player);
        //To avoid: aria-label attribute is not well supported on a div with no valid role attribute.
        const plyrTimer = document.getElementsByClassName("plyr__time")[0];
        if (plyrTimer) plyrTimer.removeAttribute("aria-label");
        if (isOpened) focusRef.current?.focus();
        const plyrAudioContainer = document.getElementsByClassName("plyr--audio")[0];
        if (plyrAudioContainer) plyrAudioContainer.role = "presentation";
    }, [
        isOpened
    ]);
    /* eslint-enable react-hooks/exhaustive-deps */ const handleKeyDown = (0, $5FkrB.useCallback)((event)=>{
        if (event.code === "Space") {
            event.preventDefault();
            onClose();
        }
    }, [
        onClose
    ]);
    return isOpened && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
        role: "dialog",
        "aria-label": "Audio player",
        ref: focusRef,
        // eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex -- Dialog needs tabIndex for focus management
        tabIndex: 0,
        css: $fc6840133e04adc0$var$$83fc18f8199a12ff$var$audioPlayerStyles,
        children: (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("figure", {
            "data-testid": "audio-player",
            css: $fc6840133e04adc0$var$$83fc18f8199a12ff$var$figureStyles,
            children: [
                (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("audio", {
                    ref: audioRef
                }),
                (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                    role: "button",
                    tabIndex: 0,
                    onKeyDown: handleKeyDown,
                    onClick: onClose,
                    css: $fc6840133e04adc0$var$$83fc18f8199a12ff$var$closeIconStyles,
                    "data-testid": "close-audio",
                    children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$export$f04a61298a47a40f, {
                        type: "cross",
                        color: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.icon.subtle"),
                        alt: "close-audio"
                    })
                })
            ]
        })
    });
};
const $fc6840133e04adc0$var$$83fc18f8199a12ff$var$audioPlayerStyles = (0, $74Zh5.css)({
    borderRadius: "8px",
    maxWidth: "340px",
    padding: "24px",
    boxShadow: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("elevation.shadow.overlay"),
    backgroundColor: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.background.input"),
    ".plyr--audio": {
        width: "100%",
        "--plyr-color-main": (0, $d568d81ef5c2bf7a$export$e62e8919cca44969),
        "--plyr-audio-control-color": (0, $d568d81ef5c2bf7a$export$29a4f05edc054374),
        "--plyr-control-icon-size": "16px",
        "--plyr-range-thumb-height": "8px",
        "--plyr-range-track-height": "8px",
        "--plyr-range-thumb-shadow": "none",
        "--plyr-audio-progress-buffered-background": (0, $d568d81ef5c2bf7a$export$c2e91cbeada39b8b),
        "--plyr-font-family": "Charlie Text",
        "--plyr-tooltip-background": (0, $d568d81ef5c2bf7a$export$c39c0fe0f26207ae),
        "--plyr-tooltip-color": (0, $d568d81ef5c2bf7a$export$29a4f05edc054374),
        "--plyr-tooltip-radius": "8px",
        "--plyr-control-spacing": "16px",
        "--plyr-range-thumb-background": (0, $d568d81ef5c2bf7a$export$e62e8919cca44969)
    },
    ".plyr--audio > .plyr__controls": {
        padding: 0
    },
    ".plyr--audio > .plyr__controls > .plyr__control": {
        width: "40px",
        height: "40px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        marginRight: "16px",
        backgroundColor: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.background.information.bold"),
        borderRadius: "50%"
    },
    ".plyr__progress": {
        marginRight: "16px"
    },
    ".icon--not-pressed": {
        marginRight: "-3px"
    },
    ".plyr__time": {
        fontFamily: "Inter, sans-serif",
        color: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.text.subtlest"),
        fontSize: "14px",
        fontWeight: 600
    },
    ".plyr--audio:focus, .plyr--audio:focus-visible": {
        border: `2px solid ${(0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.border.selected")}`
    }
});
const $fc6840133e04adc0$var$$83fc18f8199a12ff$var$figureStyles = (0, $74Zh5.css)({
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    margin: 0
});
const $fc6840133e04adc0$var$$83fc18f8199a12ff$var$closeIconStyles = (0, $74Zh5.css)({
    display: "flex",
    cursor: "pointer",
    marginLeft: "4px"
});
var $fc6840133e04adc0$var$$438c82700c218044$exports = {};
$fc6840133e04adc0$var$$parcel$export($fc6840133e04adc0$var$$438c82700c218044$exports, "ArticleJumpLinks", ()=>$fc6840133e04adc0$export$e11be3ad528d3c05);
const $fc6840133e04adc0$var$$7af640a6c4cb35c7$export$5972a68b6e54f38f = (0, $74Zh5.css)({
    display: "flex",
    padding: `${(0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.150")} ${(0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.100")}`,
    flexDirection: "column",
    alignItems: "flex-start",
    gap: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.100"),
    borderRadius: "8px",
    backgroundColor: "white",
    boxShadow: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("elevation.shadow.raised"),
    // desktop
    "@media (min-width: 1000px)": {
        padding: `${(0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.200")} ${(0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.100")}`,
        maxWidth: "290px"
    }
});
const $fc6840133e04adc0$var$$7af640a6c4cb35c7$export$2dc6a66a41038997 = (0, $74Zh5.css)({
    listStyle: "none",
    padding: 0,
    margin: 0,
    display: "flex",
    flexDirection: "column",
    gap: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.050")
});
const $fc6840133e04adc0$var$$7af640a6c4cb35c7$export$4ea5976125a01ffa = (0, $74Zh5.css)({
    padding: `${(0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.050")} 0 ${(0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.050")} ${(0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.200")}`,
    position: "relative",
    "&:hover": {
        borderRadius: "4px",
        backgroundColor: "rgba(220, 223, 228, 0.50)"
    },
    "& a": {
        // limit to 2 lines
        display: "-webkit-box",
        WebkitBoxOrient: "vertical",
        WebkitLineClamp: "2",
        wordBreak: "break-word",
        overflow: "hidden",
        color: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.text.subtle"),
        textOverflow: "ellipsis",
        textDecoration: "none",
        fontFamily: "Inter, sans-serif",
        fontSize: "16px",
        fontWeight: "400",
        lineHeight: "24px"
    }
});
const $fc6840133e04adc0$var$$7af640a6c4cb35c7$export$976a5bac7cff1dce = (0, $74Zh5.css)({
    // desktop
    "@media (min-width: 1000px)": {
        backgroundColor: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.background.accent.blue.subtlest"),
        borderRadius: "4px",
        "& a": {
            color: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.text.brand")
        },
        "&:hover": {
            backgroundColor: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.background.accent.blue.subtlest")
        },
        ":before": {
            content: '""',
            display: "block",
            width: "2px",
            height: "16px",
            backgroundColor: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.text.brand"),
            position: "absolute",
            left: "0",
            top: "50%",
            transform: "translateY(-50%)"
        }
    }
});
const $fc6840133e04adc0$var$$7af640a6c4cb35c7$export$405b853093cc10c7 = (0, $74Zh5.css)({
    padding: `0 ${(0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.200")}`,
    "& h6": {
        textOverflow: "ellipsis",
        fontSize: "16px !important",
        lineHeight: "24px !important"
    },
    // desktop
    "@media (min-width: 1000px)": {
        display: "none"
    }
});
const $fc6840133e04adc0$var$$438c82700c218044$var$DEFAULT_TITLE = "On this page";
const $fc6840133e04adc0$export$e11be3ad528d3c05 = ({ links: links, className: className, style: style, onClick: onClick, title: title = $fc6840133e04adc0$var$$438c82700c218044$var$DEFAULT_TITLE, activeHref: activeHref })=>{
    const [internalActiveLink, setInternalActiveLink] = (0, $5FkrB.useState)(null);
    const handleScroll = (0, $5FkrB.useCallback)(()=>{
        internalActiveLink && setInternalActiveLink(null);
    }, [
        internalActiveLink
    ]);
    const handleClick = (0, $5FkrB.useCallback)((link)=>{
        requestAnimationFrame(()=>{
            setInternalActiveLink(link);
        });
        onClick?.(link);
    }, [
        onClick,
        setInternalActiveLink
    ]);
    (0, $5FkrB.useEffect)(()=>{
        // Only add scroll listener if activeHref is not provided (internal state mode)
        if (!activeHref) {
            window.addEventListener("scroll", handleScroll);
            return ()=>{
                window.removeEventListener("scroll", handleScroll);
            };
        }
    }, [
        handleScroll,
        activeHref
    ]);
    const linksWithHref = (0, $5FkrB.useMemo)(()=>{
        return links.map((link)=>{
            const linkHref = link.href ? link.href : $fc6840133e04adc0$export$1bdcd43c8c2377cf(link.label);
            // Use activeHref prop if provided, otherwise fall back to internal state
            const isActive = activeHref ? linkHref === activeHref : internalActiveLink?.label === link.label;
            const onLinkClick = ()=>handleClick?.(link);
            return (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("li", {
                css: [
                    $fc6840133e04adc0$var$$7af640a6c4cb35c7$export$4ea5976125a01ffa,
                    isActive && $fc6840133e04adc0$var$$7af640a6c4cb35c7$export$976a5bac7cff1dce
                ],
                children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("a", {
                    href: linkHref,
                    onClick: onLinkClick,
                    children: link.label
                })
            }, linkHref);
        });
    }, [
        links,
        internalActiveLink,
        activeHref,
        handleClick
    ]);
    return (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
        css: $fc6840133e04adc0$var$$7af640a6c4cb35c7$export$5972a68b6e54f38f,
        children: [
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                css: $fc6840133e04adc0$var$$7af640a6c4cb35c7$export$405b853093cc10c7,
                children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$export$a8a3e93435678ff9, {
                    level: 6,
                    children: title
                })
            }),
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("ul", {
                css: $fc6840133e04adc0$var$$7af640a6c4cb35c7$export$2dc6a66a41038997,
                className: className,
                style: style,
                children: linksWithHref
            })
        ]
    });
};
var $fc6840133e04adc0$var$$389dbaf1c04dd698$exports = {};
$fc6840133e04adc0$var$$parcel$export($fc6840133e04adc0$var$$389dbaf1c04dd698$exports, "BadgeCard", ()=>$fc6840133e04adc0$export$22da447a4012011);
const $fc6840133e04adc0$export$22da447a4012011 = ({ image: image, badgeTitle: badgeTitle, earnedDate: earnedDate, link: link, onClick: onClick })=>{
    const clickHandler = (0, $5FkrB.useCallback)(()=>{
        if (onClick) onClick(link, "_self");
    }, [
        onClick,
        link
    ]);
    const handleKeyDown = $fc6840133e04adc0$export$2a0b6757d41dacb2(clickHandler);
    return (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
        role: "button",
        css: $fc6840133e04adc0$var$$389dbaf1c04dd698$var$containerStyles,
        tabIndex: 0,
        onClick: clickHandler,
        onKeyDown: handleKeyDown,
        "data-testid": "badge-card",
        children: [
            image && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$export$3e431a229df88919, {
                    ...image,
                    width: 64,
                    height: 64,
                    preventModal: true,
                    style: {
                        height: "64px",
                        objectFit: "contain"
                    }
                })
            }),
            (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                css: $fc6840133e04adc0$var$$389dbaf1c04dd698$var$contentContainerStyles,
                children: [
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("p", {
                        css: $fc6840133e04adc0$var$$389dbaf1c04dd698$var$badgeTitleStyles,
                        children: badgeTitle
                    }),
                    (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("p", {
                        css: $fc6840133e04adc0$var$$389dbaf1c04dd698$var$earnedDateStyles,
                        children: [
                            "Earned: ",
                            earnedDate
                        ]
                    })
                ]
            })
        ]
    });
};
const $fc6840133e04adc0$var$$389dbaf1c04dd698$var$containerStyles = (0, $74Zh5.css)({
    width: "100%",
    display: "flex",
    alignItems: "center",
    background: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.background.input"),
    border: `0 solid ${(0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.border")}`,
    borderRadius: "4px",
    padding: "16px 12px",
    transition: "all 0.2s ease-in-out",
    boxShadow: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("elevation.shadow.raised"),
    "&:hover": {
        cursor: "pointer",
        boxShadow: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("elevation.shadow.overlay")
    }
});
const $fc6840133e04adc0$var$$389dbaf1c04dd698$var$contentContainerStyles = (0, $74Zh5.css)({
    marginLeft: "16px"
});
const $fc6840133e04adc0$var$$389dbaf1c04dd698$var$badgeTitleStyles = (0, $74Zh5.css)({
    paddingBottom: "4px",
    fontSize: "16px",
    fontFamily: "system-ui",
    fontWeight: 600,
    lineHeight: "20px",
    color: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.text"),
    wordBreak: "break-word",
    margin: 0
});
const $fc6840133e04adc0$var$$389dbaf1c04dd698$var$earnedDateStyles = (0, $74Zh5.css)({
    fontSize: "14px",
    lineHeight: "20px",
    color: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.text.subtlest"),
    fontFamily: "system-ui",
    fontWeight: "normal",
    wordBreak: "break-word",
    margin: 0
});
var $fc6840133e04adc0$var$$c18917e553fd2737$exports = {};
$fc6840133e04adc0$var$$parcel$export($fc6840133e04adc0$var$$c18917e553fd2737$exports, "CertificateCard", ()=>$fc6840133e04adc0$export$c572aa3e2aa38d2);
const $fc6840133e04adc0$export$c572aa3e2aa38d2 = ({ image: image, backgroundColor: backgroundColor, title: title, link: link, onClick: onClick })=>{
    const clickHandler = (0, $5FkrB.useCallback)(()=>{
        if (onClick) onClick(link, "_self");
    }, [
        onClick,
        link
    ]);
    const handleKeyDown = $fc6840133e04adc0$export$2a0b6757d41dacb2(clickHandler);
    return (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
        role: "button",
        tabIndex: 0,
        css: $fc6840133e04adc0$var$$c18917e553fd2737$var$containerStyles,
        onClick: clickHandler,
        onKeyDown: handleKeyDown,
        "data-testid": "certificate-card",
        children: [
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                css: [
                    $fc6840133e04adc0$var$$c18917e553fd2737$var$cardHeaderStyles,
                    (0, $74Zh5.css)({
                        backgroundColor: backgroundColor
                    })
                ],
                "data-testid": "certificate-card-background",
                children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                    css: $fc6840133e04adc0$var$$c18917e553fd2737$var$imageContainerStyles,
                    children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$export$3e431a229df88919, {
                        ...image,
                        width: 112,
                        height: 112,
                        preventModal: true,
                        style: {
                            objectFit: "contain"
                        }
                    })
                })
            }),
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                css: $fc6840133e04adc0$var$$c18917e553fd2737$var$cardTitleStyles,
                children: title
            })
        ]
    });
};
const $fc6840133e04adc0$var$$c18917e553fd2737$var$containerStyles = (0, $74Zh5.css)({
    maxWidth: "280px",
    background: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.background.input"),
    borderRadius: "5px",
    boxShadow: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("elevation.shadow.raised"),
    transition: "box-shadow 0.2s ease",
    "&:hover": {
        cursor: "pointer",
        boxShadow: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("elevation.shadow.overlay")
    }
});
const $fc6840133e04adc0$var$$c18917e553fd2737$var$cardHeaderStyles = (0, $74Zh5.css)({
    height: "66px",
    padding: "14px 16px 0",
    borderTopLeftRadius: "5px",
    borderTopRightRadius: "5px"
});
const $fc6840133e04adc0$var$$c18917e553fd2737$var$imageContainerStyles = (0, $74Zh5.css)({
    height: "112px",
    width: "112px"
});
const $fc6840133e04adc0$var$$c18917e553fd2737$var$cardTitleStyles = (0, $74Zh5.css)({
    padding: "0 16px 24px",
    marginTop: "76px",
    color: "N800",
    lineHeight: "20px",
    fontSize: "16px",
    fontFamily: "system-ui",
    fontWeight: 600,
    wordBreak: "break-word"
});
var $fc6840133e04adc0$var$$3ca3d702a74367ba$exports = {};
$fc6840133e04adc0$var$$parcel$export($fc6840133e04adc0$var$$3ca3d702a74367ba$exports, "ContentOverviewCardState", ()=>$fc6840133e04adc0$export$84c408eab3fc01b3);
$fc6840133e04adc0$var$$parcel$export($fc6840133e04adc0$var$$3ca3d702a74367ba$exports, "ContentOverviewCard", ()=>$fc6840133e04adc0$export$cb86f63bb5e77777);
var $fc6840133e04adc0$var$$ed20910b93d89c3f$exports = {};
$fc6840133e04adc0$var$$parcel$export($fc6840133e04adc0$var$$ed20910b93d89c3f$exports, "ContentType", ()=>$fc6840133e04adc0$export$e2e108cbe2e4f865);
let $fc6840133e04adc0$export$e2e108cbe2e4f865;
(function(ContentType) {
    ContentType["LEARNING_PATH"] = "LEARNING_PATH";
    ContentType["COURSE"] = "COURSE";
    ContentType["LESSON"] = "LESSON";
})($fc6840133e04adc0$export$e2e108cbe2e4f865 || ($fc6840133e04adc0$export$e2e108cbe2e4f865 = {}));
let $fc6840133e04adc0$export$84c408eab3fc01b3;
(function(ContentOverviewCardState) {
    ContentOverviewCardState["LOADING"] = "loading";
    ContentOverviewCardState["DEFAULT"] = "default";
    ContentOverviewCardState["IN_PROGRESS"] = "in_progress";
    ContentOverviewCardState["FINISHED"] = "finished";
})($fc6840133e04adc0$export$84c408eab3fc01b3 || ($fc6840133e04adc0$export$84c408eab3fc01b3 = {}));
const $fc6840133e04adc0$export$cb86f63bb5e77777 = ({ inspectMode: inspectMode, state: state = $fc6840133e04adc0$export$84c408eab3fc01b3.DEFAULT, heading: heading, subheading: subheading, tags: tags = [], collapsedSectionItems: itemsSectionCollapsed = [], collapsedSectionContent: infoSectionCollapsed = "", collapsedSectionTitle: titleSectionCollapsed, contentType: contentType, onClickButton: onClickButton, href: href })=>{
    const [isOpen, setIsOpen] = (0, $5FkrB.useState)(false);
    const handleClickButton = (0, $5FkrB.useCallback)((event)=>{
        if (onClickButton) {
            event?.preventDefault();
            onClickButton();
        }
    }, [
        onClickButton
    ]);
    const handleToggleVisibility = (0, $5FkrB.useCallback)(()=>{
        setIsOpen((prevIsOpen)=>!prevIsOpen);
    }, []);
    return (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("article", {
        "aria-label": heading,
        css: [
            $fc6840133e04adc0$var$$3ca3d702a74367ba$var$articleContainerStyles,
            state === $fc6840133e04adc0$export$84c408eab3fc01b3.FINISHED && (0, $74Zh5.css)({
                borderLeftColor: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.border.success")
            })
        ],
        children: [
            (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                css: $fc6840133e04adc0$var$$3ca3d702a74367ba$var$containerStyles,
                children: [
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("button", {
                        "data-testid": "toggle-visibility",
                        "aria-label": isOpen ? "collapse" : "expand",
                        onClick: handleToggleVisibility,
                        css: $fc6840133e04adc0$var$$3ca3d702a74367ba$var$buttonStyles,
                        children: isOpen ? (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("span", {
                            css: $fc6840133e04adc0$var$$3ca3d702a74367ba$var$buttonIconSpanStyles,
                            children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$export$f04a61298a47a40f, {
                                type: "chevron-down"
                            })
                        }) : (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("span", {
                            css: $fc6840133e04adc0$var$$3ca3d702a74367ba$var$buttonIconSpanStyles,
                            children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$export$f04a61298a47a40f, {
                                type: "chevron-right"
                            })
                        })
                    }),
                    (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                        css: $fc6840133e04adc0$var$$3ca3d702a74367ba$var$gridContainerStyles,
                        children: [
                            (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                                css: $fc6840133e04adc0$var$$3ca3d702a74367ba$var$gridItemStyles,
                                children: [
                                    tags.length > 0 && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                                        css: $fc6840133e04adc0$var$$3ca3d702a74367ba$var$tagContainerStyles,
                                        children: tags?.map((tag, index)=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                                                css: $fc6840133e04adc0$var$$3ca3d702a74367ba$var$tagStyles,
                                                children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$export$3288d34c523a1192, {
                                                    inspectMode: tag.inspectMode && {
                                                        tag: tag.inspectMode.duration
                                                    },
                                                    label: tag.label
                                                })
                                            }, `tag-${index}`))
                                    }),
                                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                                        ...$fc6840133e04adc0$export$1784ac302bd8ebad("title", inspectMode),
                                        css: $fc6840133e04adc0$var$$3ca3d702a74367ba$var$titleContainerStyles,
                                        children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$export$a8a3e93435678ff9, {
                                            level: 5,
                                            children: heading
                                        })
                                    }),
                                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("p", {
                                        ...$fc6840133e04adc0$export$1784ac302bd8ebad("description", inspectMode),
                                        css: $fc6840133e04adc0$var$$3ca3d702a74367ba$var$descriptionStyles,
                                        children: subheading
                                    })
                                ]
                            }),
                            (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                                css: $fc6840133e04adc0$var$$3ca3d702a74367ba$var$gridSideItemStyles,
                                children: [
                                    state === $fc6840133e04adc0$export$84c408eab3fc01b3.LOADING && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$export$353f5b6fc5456de1, {
                                        label: "",
                                        isLoading: true
                                    }),
                                    state === $fc6840133e04adc0$export$84c408eab3fc01b3.DEFAULT && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$export$353f5b6fc5456de1, {
                                        label: "Get started",
                                        appearance: $fc6840133e04adc0$export$261c9483fc4a455a.PRIMARY,
                                        onClick: handleClickButton,
                                        href: href,
                                        target: "_blank"
                                    }),
                                    state === $fc6840133e04adc0$export$84c408eab3fc01b3.IN_PROGRESS && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$export$353f5b6fc5456de1, {
                                        label: "Continue",
                                        appearance: $fc6840133e04adc0$export$261c9483fc4a455a.SECONDARY,
                                        onClick: handleClickButton,
                                        href: href,
                                        target: "_blank"
                                    }),
                                    state === $fc6840133e04adc0$export$84c408eab3fc01b3.FINISHED && (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                                        css: $fc6840133e04adc0$var$$3ca3d702a74367ba$var$finishedStateContainerStyles,
                                        children: [
                                            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                                                css: (0, $74Zh5.css)({
                                                    marginRight: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.100")
                                                }),
                                                children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$export$a6c7ac8248d6e38a, {
                                                    link: href || "#",
                                                    label: `Review ${$fc6840133e04adc0$export$e2e108cbe2e4f865.COURSE === contentType ? "lesson" : "course"}`,
                                                    onClick: (event)=>handleClickButton(event),
                                                    target: "_blank"
                                                })
                                            }),
                                            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$export$f04a61298a47a40f, {
                                                type: "check-circle",
                                                color: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.icon.success")
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                "data-testid": "section-expanded",
                css: [
                    $fc6840133e04adc0$var$$3ca3d702a74367ba$var$sectionExpandedStyles,
                    (0, $74Zh5.css)({
                        display: isOpen ? "block" : "none"
                    })
                ],
                children: [
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                        css: $fc6840133e04adc0$var$$3ca3d702a74367ba$var$sectionContentStyles,
                        children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$export$2e0a83ec2e27ecbb, {
                            color: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.border"),
                            height: 1
                        })
                    }),
                    (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                        ...$fc6840133e04adc0$export$1784ac302bd8ebad("sectionList", inspectMode),
                        css: $fc6840133e04adc0$var$$3ca3d702a74367ba$var$sectionListStyles,
                        children: [
                            titleSectionCollapsed && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                                css: $fc6840133e04adc0$var$$3ca3d702a74367ba$var$sectionTitleStyles,
                                children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$export$a8a3e93435678ff9, {
                                    level: 6,
                                    children: titleSectionCollapsed
                                })
                            }),
                            itemsSectionCollapsed.length > 0 && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("ul", {
                                css: $fc6840133e04adc0$var$$3ca3d702a74367ba$var$listStyles,
                                "aria-label": "collapsed section items",
                                children: itemsSectionCollapsed?.map((item, index)=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("li", {
                                        css: $fc6840133e04adc0$var$$3ca3d702a74367ba$var$itemStyles,
                                        children: item
                                    }, `item-${index}`))
                            }),
                            infoSectionCollapsed && infoSectionCollapsed
                        ]
                    })
                ]
            })
        ]
    });
};
const $fc6840133e04adc0$var$$3ca3d702a74367ba$var$articleContainerStyles = (0, $74Zh5.css)({
    backgroundColor: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.background.input"),
    borderLeft: `8px solid ${(0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.border.brand")}`,
    borderRadius: "8px",
    padding: "16px 24px",
    boxShadow: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("elevation.shadow.raised")
});
const $fc6840133e04adc0$var$$3ca3d702a74367ba$var$containerStyles = (0, $74Zh5.css)({
    padding: "16px 0",
    display: "flex",
    alignItems: "flex-start"
});
const $fc6840133e04adc0$var$$3ca3d702a74367ba$var$buttonStyles = (0, $74Zh5.css)({
    padding: 0,
    border: "none",
    backgroundColor: "transparent",
    cursor: "pointer"
});
const $fc6840133e04adc0$var$$3ca3d702a74367ba$var$buttonIconSpanStyles = (0, $74Zh5.css)({
    marginRight: "16px"
});
const $fc6840133e04adc0$var$$3ca3d702a74367ba$var$gridContainerStyles = (0, $74Zh5.css)({
    flex: 1,
    display: "grid",
    gridTemplateColumns: "repeat(12, minmax(0, 1fr))",
    [(0, $0bc19dfefbafca8c$export$987d49ffe1b0900f).above.sm]: {
        columnGap: "16px",
        alignItems: "center"
    }
});
const $fc6840133e04adc0$var$$3ca3d702a74367ba$var$gridItemStyles = (0, $74Zh5.css)({
    gridColumn: "span 12",
    color: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.text"),
    [(0, $0bc19dfefbafca8c$export$987d49ffe1b0900f).above.sm]: {
        gridColumn: "span 9",
        color: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.text")
    }
});
const $fc6840133e04adc0$var$$3ca3d702a74367ba$var$tagContainerStyles = (0, $74Zh5.css)({
    display: "flex",
    flexWrap: "wrap"
});
const $fc6840133e04adc0$var$$3ca3d702a74367ba$var$tagStyles = (0, $74Zh5.css)({
    marginRight: "12px",
    "&:last-of-type": {
        marginRight: 0
    }
});
const $fc6840133e04adc0$var$$3ca3d702a74367ba$var$titleContainerStyles = (0, $74Zh5.css)({
    margin: "16px auto",
    [(0, $0bc19dfefbafca8c$export$987d49ffe1b0900f).above.sm]: {
        marginRight: "1px"
    }
});
const $fc6840133e04adc0$var$$3ca3d702a74367ba$var$descriptionStyles = (0, $74Zh5.css)({
    display: "none",
    fontSize: "16px",
    margin: 0,
    color: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.text"),
    fontFamily: "Inter, sans-serif",
    [(0, $0bc19dfefbafca8c$export$987d49ffe1b0900f).above.sm]: {
        overflow: "hidden",
        textOverflow: "ellipsis",
        width: "100%",
        display: "-webkit-box",
        WebkitLineClamp: 2,
        WebkitBoxOrient: "vertical",
        lineHeight: "1.5",
        color: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.text")
    }
});
const $fc6840133e04adc0$var$$3ca3d702a74367ba$var$gridSideItemStyles = (0, $74Zh5.css)({
    gridColumn: "span 12",
    [(0, $0bc19dfefbafca8c$export$987d49ffe1b0900f).above.sm]: {
        gridColumn: "span 3",
        justifySelf: "end"
    }
});
const $fc6840133e04adc0$var$$3ca3d702a74367ba$var$finishedStateContainerStyles = (0, $74Zh5.css)({
    display: "flex",
    marginRight: "4px"
});
const $fc6840133e04adc0$var$$3ca3d702a74367ba$var$sectionExpandedStyles = (0, $74Zh5.css)({
    overflow: "hidden",
    transition: "ease-in-out 1000ms",
    paddingLeft: "40px"
});
const $fc6840133e04adc0$var$$3ca3d702a74367ba$var$sectionContentStyles = (0, $74Zh5.css)({
    margin: "8px 0"
});
const $fc6840133e04adc0$var$$3ca3d702a74367ba$var$sectionListStyles = (0, $74Zh5.css)({
    padding: "24px 0"
});
const $fc6840133e04adc0$var$$3ca3d702a74367ba$var$sectionTitleStyles = (0, $74Zh5.css)({
    marginBottom: "8px",
    textTransform: "uppercase"
});
const $fc6840133e04adc0$var$$3ca3d702a74367ba$var$listStyles = (0, $74Zh5.css)({
    color: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.text"),
    fontSize: "14px",
    lineHeight: "20px",
    listStyleType: "disc",
    listStylePosition: "inside",
    paddingLeft: "4px",
    marginTop: 0,
    fontFamily: "Inter, sans-serif",
    [(0, $0bc19dfefbafca8c$export$987d49ffe1b0900f).above.sm]: {
        fontSize: "16px",
        lineHeight: "1.714"
    }
});
const $fc6840133e04adc0$var$$3ca3d702a74367ba$var$itemStyles = (0, $74Zh5.css)({
    marginTop: 0,
    marginLeft: "20px",
    textIndent: "-20px"
});
var $fc6840133e04adc0$var$$e018ab7ed2648ae8$exports = {};
$fc6840133e04adc0$var$$parcel$export($fc6840133e04adc0$var$$e018ab7ed2648ae8$exports, "EmptyState", ()=>$fc6840133e04adc0$export$fddf379e22a74b00);
const $fc6840133e04adc0$export$fddf379e22a74b00 = ({ image: image, description: description, redirectLink: redirectLink })=>(0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
        css: $fc6840133e04adc0$var$$e018ab7ed2648ae8$var$containerStyles,
        "data-testid": "empty-state",
        children: [
            image && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                css: $fc6840133e04adc0$var$$e018ab7ed2648ae8$var$imageContainerStyles,
                children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$export$3e431a229df88919, {
                    src: image.src,
                    alt: image.alt,
                    preventModal: true,
                    height: 96
                })
            }),
            (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                css: $fc6840133e04adc0$var$$e018ab7ed2648ae8$var$descriptionContainerStyles,
                children: [
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("p", {
                        css: $fc6840133e04adc0$var$$e018ab7ed2648ae8$var$descriptionStyles,
                        tabIndex: 0,
                        children: description
                    }),
                    redirectLink && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$export$a6c7ac8248d6e38a, {
                        label: redirectLink.label,
                        link: redirectLink.link,
                        style: $fc6840133e04adc0$export$2b77966d73aefa77.SEMIBOLD,
                        fontColor: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.link"),
                        css: (0, $74Zh5.css)({
                            fontFamily: "system-ui"
                        })
                    })
                ]
            })
        ]
    });
const $fc6840133e04adc0$var$$e018ab7ed2648ae8$var$containerStyles = (0, $74Zh5.css)({
    width: "100%",
    display: "flex",
    padding: "24px",
    border: "1px dashed",
    borderColor: (0, $d568d81ef5c2bf7a$export$5f71e19f3a7ad9de),
    borderRadius: "4px",
    alignItems: "center"
});
const $fc6840133e04adc0$var$$e018ab7ed2648ae8$var$imageContainerStyles = (0, $74Zh5.css)({
    width: "64px",
    [(0, $0bc19dfefbafca8c$export$987d49ffe1b0900f).above.sm]: {
        width: "96px"
    }
});
const $fc6840133e04adc0$var$$e018ab7ed2648ae8$var$descriptionContainerStyles = (0, $74Zh5.css)({
    marginLeft: "16px",
    lineHeight: "23px"
});
const $fc6840133e04adc0$var$$e018ab7ed2648ae8$var$descriptionStyles = (0, $74Zh5.css)({
    paddingBottom: "2px",
    margin: 0,
    fontFamily: "system-ui",
    fontSize: "16px",
    color: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.text"),
    fontWeight: "normal",
    wordBreak: "break-word",
    lineHeight: 1.714
});
var $fc6840133e04adc0$var$$81dd635d83decaee$exports = {};
$fc6840133e04adc0$var$$parcel$export($fc6840133e04adc0$var$$81dd635d83decaee$exports, "InlineFeedbackMessageAppearance", ()=>$fc6840133e04adc0$export$f9292ef28b7b429a);
$fc6840133e04adc0$var$$parcel$export($fc6840133e04adc0$var$$81dd635d83decaee$exports, "InlineFeedbackMessage", ()=>$fc6840133e04adc0$export$f23c56ac9ab316f);
let $fc6840133e04adc0$export$f9292ef28b7b429a;
(function(InlineFeedbackMessageAppearance) {
    InlineFeedbackMessageAppearance["INCORRECT"] = "INCORRECT";
    InlineFeedbackMessageAppearance["CORRECT"] = "CORRECT";
})($fc6840133e04adc0$export$f9292ef28b7b429a || ($fc6840133e04adc0$export$f9292ef28b7b429a = {}));
const $fc6840133e04adc0$export$f23c56ac9ab316f = ({ title: title, description: description, appearance: appearance = $fc6840133e04adc0$export$f9292ef28b7b429a.CORRECT })=>{
    const isIncorrectAppearance = appearance === $fc6840133e04adc0$export$f9292ef28b7b429a.INCORRECT;
    return (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
        css: $fc6840133e04adc0$var$$81dd635d83decaee$var$feedbackMessageContainerStyles,
        children: [
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                css: [
                    $fc6840133e04adc0$var$$81dd635d83decaee$var$feedbackMessageLeftBorderStyles,
                    (0, $74Zh5.css)({
                        backgroundColor: `${isIncorrectAppearance ? (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.border.danger") : (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.border.success")}`
                    })
                ]
            }),
            (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                "data-testid": `feedback-message-${appearance}`,
                css: $fc6840133e04adc0$var$$81dd635d83decaee$var$feedbackMessageContentContainerStyles,
                children: [
                    isIncorrectAppearance ? (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$export$f04a61298a47a40f, {
                        type: "error",
                        color: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.border.danger")
                    }) : (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$export$f04a61298a47a40f, {
                        type: "check-circle",
                        color: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.border.success")
                    }),
                    (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                        css: $fc6840133e04adc0$var$$81dd635d83decaee$var$feedbackMessageContentStyles,
                        children: [
                            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("p", {
                                css: $fc6840133e04adc0$var$$81dd635d83decaee$var$feedbackMessageTitleStyles,
                                children: title
                            }),
                            description && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("p", {
                                css: $fc6840133e04adc0$var$$81dd635d83decaee$var$feedbackMessageDescriptionStyles,
                                children: description
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
const $fc6840133e04adc0$var$$81dd635d83decaee$var$feedbackMessageContainerStyles = (0, $74Zh5.css)({
    width: "100%",
    display: "flex",
    backgroundColor: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.background.input")
});
const $fc6840133e04adc0$var$$81dd635d83decaee$var$feedbackMessageContentContainerStyles = (0, $74Zh5.css)({
    width: "100%",
    padding: "24px 24px 24px 16px",
    display: "flex",
    border: `1px solid ${(0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.border")}`,
    borderRadius: "0 3px 3px 0",
    borderLeft: "none",
    [(0, $0bc19dfefbafca8c$export$987d49ffe1b0900f).below.xs]: {
        padding: "16px 16px 16px 8px"
    }
});
const $fc6840133e04adc0$var$$81dd635d83decaee$var$feedbackMessageLeftBorderStyles = (0, $74Zh5.css)({
    maxHeight: "100%",
    width: "8px",
    borderRadius: "3px 0 0 3px"
});
const $fc6840133e04adc0$var$$81dd635d83decaee$var$feedbackMessageContentStyles = (0, $74Zh5.css)({
    width: "100%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    marginLeft: "16px",
    [(0, $0bc19dfefbafca8c$export$987d49ffe1b0900f).below.xs]: {
        marginLeft: "8px"
    }
});
const $fc6840133e04adc0$var$$81dd635d83decaee$var$feedbackMessageTitleStyles = (0, $74Zh5.css)({
    fontFamily: "Charlie Display, sans-serif",
    fontWeight: 600,
    fontSize: "20px",
    lineHeight: "24px",
    color: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.text"),
    margin: 0,
    [(0, $0bc19dfefbafca8c$export$987d49ffe1b0900f).below.xs]: {
        fontSize: "16px"
    }
});
const $fc6840133e04adc0$var$$81dd635d83decaee$var$feedbackMessageDescriptionStyles = (0, $74Zh5.css)({
    marginTop: "16px",
    fontFamily: "Inter, sans-serif",
    fontSize: "20px",
    lineHeight: "32px",
    color: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.text"),
    marginBottom: 0,
    p: {
        margin: 0
    },
    [(0, $0bc19dfefbafca8c$export$987d49ffe1b0900f).below.xs]: {
        marginTop: "8px",
        fontSize: "16px",
        lineHeight: "24px"
    }
});
var $fc6840133e04adc0$var$$8d99d7c025746ac9$exports = {};
$fc6840133e04adc0$var$$parcel$export($fc6840133e04adc0$var$$8d99d7c025746ac9$exports, "LearningContentCard", ()=>$fc6840133e04adc0$export$c01be50dd5c433fe);
const $fc6840133e04adc0$var$$94fa590b0c9d9421$export$64ef9b8c11710c47 = ({ title: title, description: description, isLearningProgress: isLearningProgress, inspectMode: inspectMode, disableDescriptionClamp: disableDescriptionClamp })=>(0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
        "data-testid": "card-content",
        css: $fc6840133e04adc0$var$$94fa590b0c9d9421$var$titleAndDetailsContainerStyles,
        children: [
            isLearningProgress ? (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("h4", {
                ...$fc6840133e04adc0$export$1784ac302bd8ebad("title", inspectMode),
                css: $fc6840133e04adc0$var$$94fa590b0c9d9421$var$withProgressTitleStyles,
                children: title
            }) : (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("h5", {
                ...$fc6840133e04adc0$export$1784ac302bd8ebad("title", inspectMode),
                css: $fc6840133e04adc0$var$$94fa590b0c9d9421$var$catalogTitleStyles,
                children: title
            }),
            description && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("p", {
                "data-testid": "description",
                ...$fc6840133e04adc0$export$1784ac302bd8ebad("description", inspectMode),
                css: [
                    $fc6840133e04adc0$var$$94fa590b0c9d9421$var$descriptionStyles,
                    disableDescriptionClamp && $fc6840133e04adc0$var$$94fa590b0c9d9421$var$descriptionNoClampStyles
                ],
                children: description
            })
        ]
    });
const $fc6840133e04adc0$var$$94fa590b0c9d9421$var$titleAndDetailsContainerStyles = (0, $74Zh5.css)({
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    padding: `0 ${(0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.300")} ${(0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.300")}`,
    marginBottom: "-2px"
});
const $fc6840133e04adc0$var$$94fa590b0c9d9421$var$baseTitleStyles = (0, $74Zh5.css)({
    display: "-webkit-box",
    WebkitLineClamp: 3,
    WebkitBoxOrient: "vertical",
    overflow: "hidden",
    marginBottom: 0,
    fontFamily: "Charlie Display, sans-serif",
    color: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.text")
});
const $fc6840133e04adc0$var$$94fa590b0c9d9421$var$learningProgressTitleStyles = (0, $74Zh5.css)({
    display: "-webkit-box",
    WebkitLineClamp: 2,
    WebkitBoxOrient: "vertical",
    overflow: "hidden",
    marginTop: "20px !important",
    marginBottom: 0,
    fontFamily: "Charlie Display, sans-serif",
    fontSize: "24px",
    fontWeight: 600,
    lineHeight: "32px",
    color: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.text"),
    height: "64px"
});
const $fc6840133e04adc0$var$$94fa590b0c9d9421$var$withProgressTitleStyles = (0, $74Zh5.css)([
    $fc6840133e04adc0$var$$94fa590b0c9d9421$var$learningProgressTitleStyles,
    {
        fontSize: "24px",
        lineHeight: "32px",
        marginTop: "0 !important"
    }
]);
const $fc6840133e04adc0$var$$94fa590b0c9d9421$var$catalogTitleStyles = (0, $74Zh5.css)([
    $fc6840133e04adc0$var$$94fa590b0c9d9421$var$baseTitleStyles,
    {
        fontSize: "20px",
        lineHeight: "28px",
        marginTop: `${(0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.150")} !important`
    }
]);
const $fc6840133e04adc0$var$$94fa590b0c9d9421$var$descriptionStyles = (0, $74Zh5.css)({
    display: "-webkit-box",
    WebkitBoxOrient: "vertical",
    WebkitLineClamp: 2,
    overflow: "hidden",
    marginTop: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.250"),
    marginBottom: 0,
    fontFamily: "Inter, sans-serif",
    fontSize: "16px",
    fontWeight: 400,
    lineHeight: "24px",
    color: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.text.subtle")
});
const $fc6840133e04adc0$var$$94fa590b0c9d9421$var$descriptionNoClampStyles = (0, $74Zh5.css)({
    display: "block",
    WebkitLineClamp: "none",
    overflow: "visible"
});
const $fc6840133e04adc0$var$$f73a4551a9d8a3b1$export$8a8c015277a3d77a = ({ imageUrl: imageUrl, backgroundColor: backgroundColor, productIcon: productIcon, isLearningProgress: isLearningProgress, imageHeight: imageHeight })=>{
    let height = isLearningProgress ? "96px" : "80px";
    if (imageHeight) height = `${imageHeight}px`;
    const backgroundSize = imageHeight ? "contain" : "cover";
    const backgroundPosition = imageHeight ? "center" : undefined; // if imageHeight is provided, the image will be displayed at the center of the container
    return (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
        css: [
            $fc6840133e04adc0$var$$f73a4551a9d8a3b1$var$imageBaseStyles,
            !imageUrl && $fc6840133e04adc0$var$$f73a4551a9d8a3b1$var$noImageStyles,
            (0, $74Zh5.css)({
                backgroundColor: backgroundColor,
                height: height,
                backgroundSize: backgroundSize,
                ...backgroundPosition && {
                    backgroundPosition: backgroundPosition
                }
            })
        ],
        style: {
            backgroundImage: `url(${imageUrl})`
        },
        "data-testid": "card-image",
        children: productIcon && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("img", {
            css: (0, $74Zh5.css)({
                marginLeft: "26px"
            }),
            src: productIcon,
            alt: "product icon"
        })
    });
};
const $fc6840133e04adc0$var$$f73a4551a9d8a3b1$var$imageBaseStyles = (0, $74Zh5.css)({
    width: "100%",
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    borderRadius: "7px 7px 0 0",
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "center"
});
const $fc6840133e04adc0$var$$f73a4551a9d8a3b1$var$noImageStyles = (0, $74Zh5.css)({
    background: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.background.accent.gray.subtlest")
});
const $fc6840133e04adc0$var$$70542fe329d53412$export$ce572121d239fe86 = 4;
const $fc6840133e04adc0$var$$70542fe329d53412$export$3b38c99bd0870716 = 290;
const $fc6840133e04adc0$var$$70542fe329d53412$export$bb4069a5b1582edc = 24;
const $fc6840133e04adc0$var$$70542fe329d53412$export$9c6eb1f46b993412 = 3;
const $fc6840133e04adc0$var$$fb345954107134f9$export$331084b24da1eef5 = ({ tags: tags, lastLabelWidth: lastLabelWidth })=>tags.length > 0 && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
        css: $fc6840133e04adc0$var$$fb345954107134f9$var$labelContainerStyles,
        id: "tabs-container",
        children: tags.slice(0, $fc6840133e04adc0$var$$70542fe329d53412$export$9c6eb1f46b993412).map((tag, index, arr)=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                css: index === arr.length - 1 && (0, $74Zh5.css)([
                    {
                        "& > div": {
                            width: lastLabelWidth
                        }
                    },
                    $fc6840133e04adc0$var$$fb345954107134f9$var$truncatedLabelStyles
                ]),
                children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$export$3288d34c523a1192, {
                    ...tag
                })
            }, tag.label + index))
    });
const $fc6840133e04adc0$var$$fb345954107134f9$var$labelContainerStyles = (0, $74Zh5.css)({
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    gap: `${$fc6840133e04adc0$var$$70542fe329d53412$export$ce572121d239fe86}px`,
    padding: `0 ${$fc6840133e04adc0$var$$70542fe329d53412$export$bb4069a5b1582edc}px`,
    overflow: "hidden"
});
const $fc6840133e04adc0$var$$fb345954107134f9$var$truncatedLabelStyles = (0, $74Zh5.css)({
    "& > div": {
        overflow: "hidden",
        textOverflow: "ellipsis",
        display: "block"
    }
});
var $fc6840133e04adc0$var$$d8ee29df49af8811$exports = {};
$fc6840133e04adc0$var$$parcel$export($fc6840133e04adc0$var$$d8ee29df49af8811$exports, "LearningProgressBar", ()=>$fc6840133e04adc0$export$184a993f673fc83f);
const $fc6840133e04adc0$export$184a993f673fc83f = ({ wasPreviouslyCompleted: wasPreviouslyCompleted = false, completedResources: completedResources, resourceCount: resourceCount, completionDate: completionDate, contentType: contentType })=>{
    const getProgressText = ()=>{
        switch(contentType){
            case $fc6840133e04adc0$export$e2e108cbe2e4f865.COURSE:
                return `${completedResources} of ${resourceCount} lessons`;
            case $fc6840133e04adc0$export$e2e108cbe2e4f865.LEARNING_PATH:
                return `${completedResources} of ${resourceCount} courses`;
            default:
                return `${Math.round($fc6840133e04adc0$export$6e67b290ed5690f6(completedResources, resourceCount))}%`;
        }
    };
    if (completedResources === resourceCount || wasPreviouslyCompleted) return (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
        "data-testid": "learning-progress-bar-container",
        css: $fc6840133e04adc0$var$$d8ee29df49af8811$var$progressBarContainerStyles,
        children: [
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                css: $fc6840133e04adc0$var$$d8ee29df49af8811$var$progressBarStyles,
                children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$export$f04a61298a47a40f, {
                    type: "gap-completed"
                })
            }),
            (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("p", {
                css: [
                    $fc6840133e04adc0$var$$d8ee29df49af8811$var$progressTitleStyles,
                    (0, $74Zh5.css)({
                        color: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.text.success")
                    })
                ],
                children: [
                    "Completed ",
                    completionDate
                ]
            })
        ]
    });
    return (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
        "data-testid": "learning-progress-bar-container",
        css: $fc6840133e04adc0$var$$d8ee29df49af8811$var$progressBarContainerStyles,
        children: [
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                css: $fc6840133e04adc0$var$$d8ee29df49af8811$var$progressBarStyles,
                children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $f188eff9b59fb855$export$5ab97151efedb8c6), {
                    strokeWidth: 10,
                    value: $fc6840133e04adc0$export$6e67b290ed5690f6(completedResources, resourceCount),
                    styles: (0, $f188eff9b59fb855$export$5115a192ad9bf57f)({
                        pathColor: completedResources === 0 ? (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.border") : (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.text.success")
                    })
                })
            }),
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("p", {
                css: $fc6840133e04adc0$var$$d8ee29df49af8811$var$progressTitleStyles,
                children: getProgressText()
            })
        ]
    });
};
const $fc6840133e04adc0$var$$d8ee29df49af8811$var$progressBarContainerStyles = (0, $74Zh5.css)({
    display: "flex",
    alignItems: "center",
    gap: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.100")
});
const $fc6840133e04adc0$var$$d8ee29df49af8811$var$progressBarStyles = (0, $74Zh5.css)({
    display: "flex",
    maxWidth: "20px",
    width: "100%"
});
const $fc6840133e04adc0$var$$d8ee29df49af8811$var$progressTitleStyles = (0, $74Zh5.css)({
    marginTop: 0,
    fontSize: "14px",
    fontWeight: 400,
    lineHeight: "20px",
    fontFamily: "Inter, sans-serif",
    color: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.text.subtle")
});
let $fc6840133e04adc0$var$$035f8a623e403361$export$23d03d0b3065d061;
(function(LearningProgressStatus) {
    LearningProgressStatus["NOT_STARTED"] = "NOT_STARTED";
    LearningProgressStatus["IN_PROGRESS"] = "IN_PROGRESS";
    LearningProgressStatus["COMPLETED"] = "COMPLETED";
})($fc6840133e04adc0$var$$035f8a623e403361$export$23d03d0b3065d061 || ($fc6840133e04adc0$var$$035f8a623e403361$export$23d03d0b3065d061 = {}));
let $fc6840133e04adc0$var$$035f8a623e403361$export$490c7ce941281ba8;
(function(CardStatus) {
    CardStatus["COMPLETED"] = "completed";
    CardStatus["DEFAULT"] = "default";
})($fc6840133e04adc0$var$$035f8a623e403361$export$490c7ce941281ba8 || ($fc6840133e04adc0$var$$035f8a623e403361$export$490c7ce941281ba8 = {}));
const $fc6840133e04adc0$var$$035f8a623e403361$export$780035d9fe48eb32 = 420;
var $fc6840133e04adc0$var$$ec9b8ebbd21bd316$exports = {};
$fc6840133e04adc0$var$$parcel$export($fc6840133e04adc0$var$$ec9b8ebbd21bd316$exports, "ShowMore", ()=>$fc6840133e04adc0$export$ca7697601dcd7803);
const $fc6840133e04adc0$export$ca7697601dcd7803 = ({ cardRef: cardRef, shareOnPdf: shareOnPdf, onGeneratePdf: onGeneratePdf, areHistoricalNotifications: areHistoricalNotifications, onViewUpdates: onViewUpdates, alignToRight: alignToRight })=>{
    const [isOpen, setIsOpen] = (0, $5FkrB.useState)(false);
    const dropdownRef = (0, $5FkrB.useRef)(null);
    const handleButtonClick = (event)=>{
        event.stopPropagation();
        event.preventDefault();
        setIsOpen(!isOpen);
    };
    const handleOnGeneratePDF = (event)=>{
        if (onGeneratePdf) {
            event.stopPropagation();
            event.preventDefault();
            onGeneratePdf();
            setIsOpen(!isOpen);
        }
    };
    const handleOnViewUpdates = (event)=>{
        if (onViewUpdates) {
            event.stopPropagation();
            event.preventDefault();
            onViewUpdates();
            setIsOpen(!isOpen);
        }
    };
    const handleGeneratePdf = (0, $5FkrB.useCallback)(()=>{
        if (onGeneratePdf) onGeneratePdf();
    }, [
        onGeneratePdf
    ]);
    const handleViewUpdates = (0, $5FkrB.useCallback)(()=>{
        if (onViewUpdates) onViewUpdates();
    }, [
        onViewUpdates
    ]);
    const onKeyDownGeneratePdf = $fc6840133e04adc0$export$2a0b6757d41dacb2(handleGeneratePdf);
    const onKeyDownViewUpdates = $fc6840133e04adc0$export$2a0b6757d41dacb2(handleViewUpdates);
    (0, $5FkrB.useEffect)(()=>{
        const handleClickOutside = (event)=>{
            const isClickOnThisCard = (cardRef?.current || dropdownRef.current)?.contains(event.target);
            if (!isClickOnThisCard) setIsOpen(false);
        };
        if (isOpen) document.addEventListener("mousedown", handleClickOutside);
        return ()=>{
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [
        isOpen,
        cardRef
    ]);
    return (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
        css: (0, $74Zh5.css)({
            width: "fit-content",
            position: "relative"
        }),
        "data-testid": "show-more",
        ref: dropdownRef,
        children: [
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$export$353f5b6fc5456de1, {
                label: "",
                appearance: $fc6840133e04adc0$export$261c9483fc4a455a.ICON,
                onClick: handleButtonClick,
                selected: isOpen,
                iconBefore: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$export$f04a61298a47a40f, {
                    type: "more-vertical"
                }),
                iconType: "more-vertical"
            }),
            isOpen && (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                "data-testid": "show-more-dropdown",
                css: [
                    $fc6840133e04adc0$var$$ec9b8ebbd21bd316$var$showMoreDropdownStyles,
                    alignToRight && (0, $74Zh5.css)({
                        right: "unset",
                        textAlign: "left"
                    })
                ],
                children: [
                    shareOnPdf && onGeneratePdf && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                        role: "button",
                        tabIndex: 0,
                        css: $fc6840133e04adc0$var$$ec9b8ebbd21bd316$var$optionStyles,
                        onClick: handleOnGeneratePDF,
                        onKeyDown: onKeyDownGeneratePdf,
                        children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("span", {
                            css: $fc6840133e04adc0$var$$ec9b8ebbd21bd316$var$optionTextStyles,
                            children: "Export to PDF"
                        })
                    }),
                    areHistoricalNotifications && onViewUpdates && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                        role: "button",
                        tabIndex: 0,
                        css: $fc6840133e04adc0$var$$ec9b8ebbd21bd316$var$optionStyles,
                        onClick: handleOnViewUpdates,
                        onKeyDown: onKeyDownViewUpdates,
                        children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("span", {
                            css: $fc6840133e04adc0$var$$ec9b8ebbd21bd316$var$optionTextStyles,
                            children: "View updates"
                        })
                    })
                ]
            })
        ]
    });
};
const $fc6840133e04adc0$var$$ec9b8ebbd21bd316$var$showMoreDropdownStyles = (0, $74Zh5.css)({
    position: "absolute",
    right: 0,
    display: "flex",
    flexDirection: "column",
    border: `1px solid ${(0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.border")}`,
    borderRadius: "4px",
    padding: "7px 0",
    marginTop: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.050"),
    zIndex: 2,
    color: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.text"),
    backgroundColor: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.background.input"),
    boxShadow: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("elevation.shadow.overlay")
});
const $fc6840133e04adc0$var$$ec9b8ebbd21bd316$var$optionStyles = (0, $74Zh5.css)({
    width: "220px",
    padding: "7px 24px",
    transition: "background",
    transitionDuration: "300ms",
    transitionTimingFunction: "cubic-bezier(0, 0, 0.2, 1)",
    backgroundColor: "transparent",
    boxSizing: "border-box",
    cursor: "pointer",
    ":hover": {
        backgroundColor: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.background.neutral.subtle.hovered")
    }
});
const $fc6840133e04adc0$var$$ec9b8ebbd21bd316$var$optionTextStyles = (0, $74Zh5.css)({
    fontSize: "16px",
    lineHeight: "20px",
    fontFamily: "Inter, sans-serif",
    fontWeight: "400"
});
const $fc6840133e04adc0$export$c01be50dd5c433fe = ({ inspectMode: inspectMode, title: title, description: description, onClick: onClick, target: target, link: link, tags: tags, disableDescriptionClamp: disableDescriptionClamp, minHeight: minHeight = 248, isLoading: isLoading = false, learningProgress: learningProgress, onGeneratePdf: onGeneratePdf, shouldDisplayShowMoreButton: shouldDisplayShowMoreButton, shouldDisplayBookmark: shouldDisplayBookmark, isUpdated: isUpdated, areHistoricalNotifications: areHistoricalNotifications, onViewUpdates: onViewUpdates, onUpdatedButtonClick: onUpdatedButtonClick, productIcon: productIcon, imageUrl: imageUrl, imageHeight: imageHeight, backgroundColor: backgroundColor })=>{
    const cardRef = (0, $5FkrB.useRef)(null);
    const [lastLabelWidth, setLastLabelWidth] = (0, $5FkrB.useState)("auto");
    const clickHandler = (0, $5FkrB.useCallback)(()=>{
        onClick && onClick();
    }, [
        onClick
    ]);
    const handleKeyDown = $fc6840133e04adc0$export$2a0b6757d41dacb2(clickHandler);
    const handleOnSave = (event)=>{
        if (learningProgress) {
            event.stopPropagation();
            event.preventDefault();
            learningProgress.onSave(!learningProgress.isSaved);
        }
    };
    const handleUpdatedButtonClick = (0, $5FkrB.useCallback)((event)=>{
        event.stopPropagation();
        event.preventDefault();
        onUpdatedButtonClick && onUpdatedButtonClick();
    }, [
        onUpdatedButtonClick
    ]);
    (0, $5FkrB.useEffect)(()=>{
        // truncating the last label if it doesn't fit in the card
        if (tags.length && cardRef.current) {
            const card = cardRef.current;
            const tagsContainer = card.querySelector("#tabs-container");
            const maxTagsContainerWidth = (card?.offsetWidth || $fc6840133e04adc0$var$$70542fe329d53412$export$3b38c99bd0870716) - $fc6840133e04adc0$var$$70542fe329d53412$export$bb4069a5b1582edc * 2;
            let firstTagsWidth = 0;
            let totalTagsWidth = 0;
            if (tagsContainer) {
                Array.from(tagsContainer.children).slice(0, $fc6840133e04adc0$var$$70542fe329d53412$export$9c6eb1f46b993412).forEach((tag, i, arr)=>{
                    if (i < arr.length - 1) firstTagsWidth += tag.clientWidth + $fc6840133e04adc0$var$$70542fe329d53412$export$ce572121d239fe86;
                    totalTagsWidth += tag.clientWidth;
                });
                const shouldTruncate = totalTagsWidth + ($fc6840133e04adc0$var$$70542fe329d53412$export$ce572121d239fe86 * tagsContainer.children.length - 1) + $fc6840133e04adc0$var$$70542fe329d53412$export$bb4069a5b1582edc * 2 > card?.offsetWidth;
                if (shouldTruncate) setLastLabelWidth(maxTagsContainerWidth - firstTagsWidth - 2);
            }
        }
    }, [
        cardRef.current
    ]);
    /* eslint-enable react-hooks/exhaustive-deps */ if (isLoading) return (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
        css: [
            $fc6840133e04adc0$var$$8d99d7c025746ac9$var$learningContentCardContainerStyles,
            $fc6840133e04adc0$var$$8d99d7c025746ac9$var$loadingLearningContentCardContainerStyles
        ],
        "data-testid": "loading-learning-content-card",
        style: {
            minHeight: `${minHeight}px`
        },
        children: [
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                css: [
                    $fc6840133e04adc0$var$$8d99d7c025746ac9$var$imageBaseStyles,
                    $fc6840133e04adc0$var$$8d99d7c025746ac9$var$noImageStyles
                ]
            }),
            (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                css: $fc6840133e04adc0$var$$8d99d7c025746ac9$var$bodyContainerStyles,
                children: [
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                        css: $fc6840133e04adc0$var$$8d99d7c025746ac9$var$labelContainerStyles,
                        children: (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                            children: [
                                (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                                    css: $fc6840133e04adc0$var$$8d99d7c025746ac9$var$smallPillStyles
                                }),
                                (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                                    css: [
                                        $fc6840133e04adc0$var$$8d99d7c025746ac9$var$smallPillStyles,
                                        (0, $74Zh5.css)({
                                            marginLeft: "24px"
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                        css: $fc6840133e04adc0$var$$8d99d7c025746ac9$var$titleAndDetailsContainerStyles,
                        children: (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                            css: (0, $74Zh5.css)({
                                marginTop: "12px"
                            }),
                            children: [
                                (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                                    css: [
                                        $fc6840133e04adc0$var$$8d99d7c025746ac9$var$bigPillStyles,
                                        (0, $74Zh5.css)({
                                            width: "212px"
                                        })
                                    ]
                                }),
                                (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                                    css: $fc6840133e04adc0$var$$8d99d7c025746ac9$var$bigPillStyles
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
    return (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("a", {
        href: link,
        target: target,
        rel: "noopener noreferrer",
        css: $fc6840133e04adc0$var$$8d99d7c025746ac9$var$linkContainerStyles,
        onClick: (e)=>e.preventDefault(),
        tabIndex: -1,
        children: (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
            ref: cardRef,
            role: "link",
            css: $fc6840133e04adc0$var$$8d99d7c025746ac9$var$learningContentCardContainerStyles,
            onClick: clickHandler,
            onKeyDown: handleKeyDown,
            tabIndex: 0,
            "data-testid": "learning-content-card",
            style: {
                minHeight: `${minHeight}px`
            },
            children: [
                (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$var$$f73a4551a9d8a3b1$export$8a8c015277a3d77a, {
                    imageUrl: imageUrl,
                    backgroundColor: backgroundColor,
                    productIcon: productIcon,
                    isLearningProgress: !!learningProgress,
                    imageHeight: imageHeight
                }),
                (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                    css: [
                        $fc6840133e04adc0$var$$8d99d7c025746ac9$var$bodyContainerStyles,
                        learningProgress && $fc6840133e04adc0$var$$8d99d7c025746ac9$var$progressBodyContainerStyles
                    ],
                    children: [
                        (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$var$$fb345954107134f9$export$331084b24da1eef5, {
                            tags: tags,
                            lastLabelWidth: lastLabelWidth
                        }),
                        (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$var$$94fa590b0c9d9421$export$64ef9b8c11710c47, {
                            title: title,
                            description: description,
                            inspectMode: inspectMode,
                            isLearningProgress: !!learningProgress,
                            disableDescriptionClamp: disableDescriptionClamp
                        }),
                        learningProgress && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                            css: $fc6840133e04adc0$var$$8d99d7c025746ac9$var$learningContentCardProgressContainerStyles,
                            "data-testid": "learning-progress-content",
                            children: (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                                css: $fc6840133e04adc0$var$$8d99d7c025746ac9$var$learningContentCardProgressItemsContainerStyles,
                                children: [
                                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$export$184a993f673fc83f, {
                                        wasPreviouslyCompleted: learningProgress.status === $fc6840133e04adc0$var$$035f8a623e403361$export$23d03d0b3065d061.COMPLETED,
                                        completedResources: learningProgress.completedResources,
                                        resourceCount: learningProgress.resourceCount,
                                        completionDate: learningProgress.completionDate,
                                        contentType: $fc6840133e04adc0$export$e2e108cbe2e4f865.LEARNING_PATH
                                    }),
                                    (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                                        css: $fc6840133e04adc0$var$$8d99d7c025746ac9$var$learningContentCardIconsContainerStyles,
                                        children: [
                                            isUpdated && learningProgress.status !== $fc6840133e04adc0$var$$035f8a623e403361$export$23d03d0b3065d061.NOT_STARTED && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                                                "data-testid": "updated-icon",
                                                css: $fc6840133e04adc0$var$$8d99d7c025746ac9$var$updatedIconContainerStyles,
                                                children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$export$353f5b6fc5456de1, {
                                                    label: "Updated",
                                                    iconBefore: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$export$f04a61298a47a40f, {
                                                        type: "editor-panel"
                                                    }),
                                                    onClick: handleUpdatedButtonClick
                                                })
                                            }),
                                            shouldDisplayShowMoreButton && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$export$ca7697601dcd7803, {
                                                cardRef: cardRef,
                                                shareOnPdf: true,
                                                onGeneratePdf: onGeneratePdf,
                                                areHistoricalNotifications: areHistoricalNotifications,
                                                onViewUpdates: onViewUpdates
                                            }),
                                            shouldDisplayBookmark && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("button", {
                                                "data-testid": "save-content",
                                                css: $fc6840133e04adc0$var$$8d99d7c025746ac9$var$learningContentCardBookmarkContainerStyles,
                                                onClick: handleOnSave,
                                                children: learningProgress.isSaved ? (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$export$f04a61298a47a40f, {
                                                    type: "bookmark-filled"
                                                }) : (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$export$f04a61298a47a40f, {
                                                    type: "bookmark"
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    ]
                })
            ]
        })
    });
};
const $fc6840133e04adc0$var$$8d99d7c025746ac9$var$imageBaseStyles = (0, $74Zh5.css)({
    width: "100%",
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    borderRadius: "7px 7px 0px 0px",
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "center",
    height: "80px"
});
const $fc6840133e04adc0$var$$8d99d7c025746ac9$var$noImageStyles = (0, $74Zh5.css)({
    background: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.background.accent.gray.subtlest")
});
const $fc6840133e04adc0$var$$8d99d7c025746ac9$var$bodyContainerStyles = (0, $74Zh5.css)({
    display: "flex",
    flexDirection: "column",
    flexGrow: 1,
    padding: `${$fc6840133e04adc0$var$$70542fe329d53412$export$bb4069a5b1582edc}px 0 0`
});
const $fc6840133e04adc0$var$$8d99d7c025746ac9$var$progressBodyContainerStyles = (0, $74Zh5.css)({
    padding: `21px 0 0`
});
const $fc6840133e04adc0$var$$8d99d7c025746ac9$var$labelContainerStyles = (0, $74Zh5.css)({
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    gap: `${$fc6840133e04adc0$var$$70542fe329d53412$export$ce572121d239fe86}px`,
    padding: `0 ${$fc6840133e04adc0$var$$70542fe329d53412$export$bb4069a5b1582edc}px`,
    overflow: "hidden"
});
const $fc6840133e04adc0$var$$8d99d7c025746ac9$var$linkContainerStyles = (0, $74Zh5.css)({
    textDecoration: "none",
    "&:hover": {
        textDecoration: "none"
    }
});
const $fc6840133e04adc0$var$$8d99d7c025746ac9$var$titleAndDetailsContainerStyles = (0, $74Zh5.css)({
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    padding: `0 ${(0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.300")} ${(0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.300")}`
});
const $fc6840133e04adc0$var$$8d99d7c025746ac9$var$learningContentCardProgressContainerStyles = (0, $74Zh5.css)({
    borderTop: `1px solid ${(0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.border")}`
});
const $fc6840133e04adc0$var$$8d99d7c025746ac9$var$learningContentCardProgressItemsContainerStyles = (0, $74Zh5.css)({
    display: "flex",
    justifyContent: "space-between",
    padding: `18px ${(0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.300")}`
});
const $fc6840133e04adc0$var$$8d99d7c025746ac9$var$learningContentCardIconsContainerStyles = (0, $74Zh5.css)({
    display: "flex",
    alignItems: "center",
    gap: "5px"
});
const $fc6840133e04adc0$var$$8d99d7c025746ac9$var$updatedIconContainerStyles = (0, $74Zh5.css)({
    display: "flex",
    alignItems: "center",
    gap: "5px",
    button: {
        backgroundColor: "transparent",
        height: "auto",
        minHeight: "auto",
        alignItems: "center",
        ":hover": {
            backgroundColor: "transparent"
        }
    },
    span: {
        color: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.text.selected"),
        fontFamily: "SF Pro, sans-serif",
        fontSize: "14px",
        lineHeight: "20px"
    }
});
const $fc6840133e04adc0$var$$8d99d7c025746ac9$var$learningContentCardBookmarkContainerStyles = (0, $74Zh5.css)({
    height: "24px",
    border: "none",
    background: "none",
    cursor: "pointer",
    outline: "none",
    "&:focus-visible": {
        outline: `2px solid ${(0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.border.selected")}`
    }
});
const $fc6840133e04adc0$var$$8d99d7c025746ac9$var$learningContentCardContainerStyles = (0, $74Zh5.css)({
    display: "flex",
    flexDirection: "column",
    backgroundColor: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.background.input"),
    borderRadius: "8px",
    boxShadow: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("elevation.shadow.raised"),
    transition: "box-shadow 0.3s ease-in-out",
    cursor: "pointer",
    minWidth: `${$fc6840133e04adc0$var$$70542fe329d53412$export$3b38c99bd0870716}px`,
    "&:hover": {
        boxShadow: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("elevation.shadow.overlay")
    },
    "&:active": {
        outline: `1px solid ${(0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.border.focused")}`,
        border: `1px solid ${(0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.border.focused")}`
    },
    '&:has([data-testid="show-more"]:active)': {
        outline: "none",
        border: "none"
    }
});
const $fc6840133e04adc0$var$$8d99d7c025746ac9$var$loadingLearningContentCardContainerStyles = (0, $74Zh5.css)({
    boxShadow: "none",
    border: `1px solid ${(0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.background.disabled")}`,
    cursor: "initial",
    "&:hover": {
        boxShadow: "none"
    },
    "&:active": {
        outline: "none",
        border: `1px solid ${(0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.background.disabled")}`
    }
});
const $fc6840133e04adc0$var$$8d99d7c025746ac9$var$smallPillStyles = (0, $74Zh5.css)({
    width: "52px",
    height: "10.5px",
    backgroundColor: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.background.neutral"),
    borderRadius: "15px",
    marginLeft: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.100"),
    display: "inline-block"
});
const $fc6840133e04adc0$var$$8d99d7c025746ac9$var$bigPillStyles = (0, $74Zh5.css)({
    maxWidth: "227px",
    height: "17.5px",
    backgroundColor: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.background.neutral"),
    borderRadius: "25px",
    marginTop: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.100")
});
var $fc6840133e04adc0$var$$1f7c4876f10b107b$exports = {};
$fc6840133e04adc0$var$$parcel$export($fc6840133e04adc0$var$$1f7c4876f10b107b$exports, "Modal", ()=>$fc6840133e04adc0$export$2b77a92f1a5ad772);
let $fc6840133e04adc0$var$$1f7c4876f10b107b$var$DialogWidth;
(function(DialogWidth) {
    DialogWidth["SMALL"] = "small";
    DialogWidth["MEDIUM"] = "medium";
    DialogWidth["LARGE"] = "large";
    DialogWidth["XLARGE"] = "x-large";
})($fc6840133e04adc0$var$$1f7c4876f10b107b$var$DialogWidth || ($fc6840133e04adc0$var$$1f7c4876f10b107b$var$DialogWidth = {}));
const $fc6840133e04adc0$export$2b77a92f1a5ad772 = ({ closeModal: closeModal, width: width = $fc6840133e04adc0$var$$1f7c4876f10b107b$var$DialogWidth.LARGE, imageLink: imageLink, actionButton: actionButton, heading: heading, subheading: subheading, surveyText: surveyText })=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $9406e400bdd02ea1$export$2e2bcd8739ae039), {
        onClose: closeModal,
        width: width,
        children: (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
            css: $fc6840133e04adc0$var$$1f7c4876f10b107b$var$modalContainerStyles,
            children: [
                (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("span", {
                    css: $fc6840133e04adc0$var$$1f7c4876f10b107b$var$modalCloseButtonStyles,
                    children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$export$353f5b6fc5456de1, {
                        label: "close modal button",
                        appearance: $fc6840133e04adc0$export$261c9483fc4a455a.ICON,
                        iconBefore: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$export$f04a61298a47a40f, {
                            type: "cross"
                        }),
                        onClick: closeModal
                    })
                }),
                (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                    css: $fc6840133e04adc0$var$$1f7c4876f10b107b$var$modalBodyStyles,
                    children: [
                        (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("span", {
                            css: $fc6840133e04adc0$var$$1f7c4876f10b107b$var$modalImageContainerStyles,
                            children: imageLink && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("img", {
                                src: imageLink,
                                alt: "modal-image",
                                width: 120,
                                height: 120,
                                css: $fc6840133e04adc0$var$$1f7c4876f10b107b$var$imageStyles
                            })
                        }),
                        (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("p", {
                            "data-testid": "modal-heading",
                            css: $fc6840133e04adc0$var$$1f7c4876f10b107b$var$modalHeadingContainerStyles,
                            children: heading
                        }),
                        (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("span", {
                            "data-testid": "modal-subheading",
                            css: $fc6840133e04adc0$var$$1f7c4876f10b107b$var$modalSubheadingContainerStyles,
                            children: subheading
                        }),
                        surveyText && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("span", {
                            "data-testid": "modal-survey-text",
                            css: [
                                $fc6840133e04adc0$var$$1f7c4876f10b107b$var$modalSubheadingContainerStyles,
                                $fc6840133e04adc0$var$$1f7c4876f10b107b$var$surveyTextStyles
                            ],
                            children: surveyText
                        }),
                        actionButton && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("span", {
                            css: $fc6840133e04adc0$var$$1f7c4876f10b107b$var$modalActionButtonContainerStyles,
                            children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$export$353f5b6fc5456de1, {
                                appearance: $fc6840133e04adc0$export$261c9483fc4a455a.PRIMARY,
                                size: $fc6840133e04adc0$export$5dd2748b7940a2a0.LARGE,
                                onClick: actionButton.onClick,
                                label: actionButton.label,
                                iconBefore: actionButton.iconBefore,
                                iconAfter: actionButton.iconAfter
                            })
                        })
                    ]
                })
            ]
        })
    });
const $fc6840133e04adc0$var$$1f7c4876f10b107b$var$imageStyles = (0, $74Zh5.css)({
    borderRadius: "50%"
});
const $fc6840133e04adc0$var$$1f7c4876f10b107b$var$modalContainerStyles = (0, $74Zh5.css)({
    padding: `${(0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.400")} ${(0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.500")}`,
    [(0, $0bc19dfefbafca8c$export$987d49ffe1b0900f).below.sm]: {
        padding: "16px"
    }
});
const $fc6840133e04adc0$var$$1f7c4876f10b107b$var$modalCloseButtonStyles = (0, $74Zh5.css)({
    width: "100%",
    display: "flex",
    justifyContent: "flex-end",
    [(0, $0bc19dfefbafca8c$export$987d49ffe1b0900f).below.sm]: {
        padding: "8px"
    }
});
const $fc6840133e04adc0$var$$1f7c4876f10b107b$var$modalImageContainerStyles = (0, $74Zh5.css)({
    marginBottom: "24px",
    [(0, $0bc19dfefbafca8c$export$987d49ffe1b0900f).below.sm]: {
        marginBottom: "16px"
    }
});
const $fc6840133e04adc0$var$$1f7c4876f10b107b$var$modalBodyStyles = (0, $74Zh5.css)({
    maxWidth: "640px",
    width: "100%",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    margin: `${(0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.200")} auto 0`,
    [(0, $0bc19dfefbafca8c$export$987d49ffe1b0900f).below.sm]: {
        marginTop: 0
    }
});
const $fc6840133e04adc0$var$$1f7c4876f10b107b$var$modalHeadingContainerStyles = (0, $74Zh5.css)({
    fontFamily: "Charlie Display, sans-serif",
    fontSize: "32px",
    fontWeight: 600,
    lineHeight: "40px",
    marginTop: 0,
    marginBottom: "24px",
    textAlign: "center",
    [(0, $0bc19dfefbafca8c$export$987d49ffe1b0900f).below.sm]: {
        marginTop: 0,
        marginBottom: "16px",
        fontSize: "24px",
        lineHeight: "32px"
    }
});
const $fc6840133e04adc0$var$$1f7c4876f10b107b$var$modalSubheadingContainerStyles = (0, $74Zh5.css)({
    fontFamily: "Inter, sans-serif",
    fontSize: "20px",
    fontWeight: 400,
    lineHeight: "32px",
    color: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.text"),
    textAlign: "center",
    [(0, $0bc19dfefbafca8c$export$987d49ffe1b0900f).below.sm]: {
        marginBottom: "32px",
        fontSize: "16px",
        lineHeight: "24px"
    }
});
const $fc6840133e04adc0$var$$1f7c4876f10b107b$var$surveyTextStyles = (0, $74Zh5.css)({
    marginTop: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.200"),
    a: {
        fontSize: "20px"
    }
});
const $fc6840133e04adc0$var$$1f7c4876f10b107b$var$modalActionButtonContainerStyles = (0, $74Zh5.css)({
    marginTop: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.400"),
    [(0, $0bc19dfefbafca8c$export$987d49ffe1b0900f).below.sm]: {
        margin: 0
    }
});
var $fc6840133e04adc0$var$$c5616d3f1657fc84$exports = {};
$fc6840133e04adc0$var$$parcel$export($fc6840133e04adc0$var$$c5616d3f1657fc84$exports, "LessonsTabContentSize", ()=>$fc6840133e04adc0$export$415b2bdf1346d2d4);
$fc6840133e04adc0$var$$parcel$export($fc6840133e04adc0$var$$c5616d3f1657fc84$exports, "LessonsTabContent", ()=>$fc6840133e04adc0$export$ce96f190f5d3ee14);
let $fc6840133e04adc0$export$415b2bdf1346d2d4;
(function(LessonsTabContentSize) {
    LessonsTabContentSize["DEFAULT"] = "default";
    LessonsTabContentSize["WIDE"] = "wide";
})($fc6840133e04adc0$export$415b2bdf1346d2d4 || ($fc6840133e04adc0$export$415b2bdf1346d2d4 = {}));
const $fc6840133e04adc0$export$ce96f190f5d3ee14 = ({ tabLinks: tabLinks, activeTab: activeTab = 0, onClickTab: onClickTab, children: children, size: size = $fc6840133e04adc0$export$415b2bdf1346d2d4.DEFAULT })=>(0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
        css: [
            $fc6840133e04adc0$var$$c5616d3f1657fc84$var$tabsContainerStyles["base"],
            $fc6840133e04adc0$var$$c5616d3f1657fc84$var$tabsContainerStyles[`${size}-size`]
        ],
        "data-testid": "navtab",
        children: [
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("ul", {
                css: $fc6840133e04adc0$var$$c5616d3f1657fc84$var$tabsButtonGroupContainerStyles,
                children: tabLinks.map((tab, index)=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("li", {
                        "data-testid": `button-${tab}${index === activeTab ? "-selected" : ""}`,
                        css: $fc6840133e04adc0$var$$c5616d3f1657fc84$var$tabsButtonContainerStyles,
                        children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$export$3e41faf802a29e71, {
                            size: $fc6840133e04adc0$export$ddadc1228c8dcfa.LARGE,
                            label: tab,
                            onClick: ()=>onClickTab(index),
                            selected: index === activeTab
                        })
                    }, `li-navtab-${tab}-${index}`))
            }),
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                css: $fc6840133e04adc0$var$$c5616d3f1657fc84$var$tabsContentContainerStyles,
                children: children
            })
        ]
    });
const $fc6840133e04adc0$var$$c5616d3f1657fc84$var$tabsContainerStyles = {
    base: (0, $74Zh5.css)({
        width: "100%",
        borderRadius: "8px",
        boxShadow: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("elevation.shadow.raised"),
        [(0, $0bc19dfefbafca8c$export$987d49ffe1b0900f).below.md]: {
            maxWidth: "720px"
        }
    }),
    "default-size": (0, $74Zh5.css)({
        maxWidth: "720px"
    }),
    "wide-size": (0, $74Zh5.css)({
        maxWidth: "1020px"
    })
};
const $fc6840133e04adc0$var$$c5616d3f1657fc84$var$tabsButtonGroupContainerStyles = (0, $74Zh5.css)({
    padding: "18px",
    overflowX: "auto",
    listStyleType: "none",
    borderBottom: `1px solid ${(0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.border")}`,
    margin: 0,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexWrap: "wrap",
    [(0, $0bc19dfefbafca8c$export$987d49ffe1b0900f).below.xs]: {
        padding: "12px"
    }
});
const $fc6840133e04adc0$var$$c5616d3f1657fc84$var$tabsButtonContainerStyles = (0, $74Zh5.css)({
    margin: "6px",
    [(0, $0bc19dfefbafca8c$export$987d49ffe1b0900f).below.xs]: {
        margin: "4px"
    }
});
const $fc6840133e04adc0$var$$c5616d3f1657fc84$var$tabsContentContainerStyles = (0, $74Zh5.css)({
    fontFamily: "Inter, sans-serif",
    fontSize: "20px",
    fontWeight: 400,
    lineHeight: "32px",
    letterSpacing: "-0.06px",
    padding: "24px",
    color: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.text"),
    a: {
        fontSize: "20px",
        lineHeight: "32px"
    },
    [(0, $0bc19dfefbafca8c$export$987d49ffe1b0900f).below.xs]: {
        padding: "16px",
        fontSize: "16px",
        lineHeight: "24px"
    }
});
var $fc6840133e04adc0$var$$eb6f767c51421421$exports = {};
$fc6840133e04adc0$var$$parcel$export($fc6840133e04adc0$var$$eb6f767c51421421$exports, "Metadata", ()=>$fc6840133e04adc0$export$e7adebdc1ebd2fed);
const $fc6840133e04adc0$export$e7adebdc1ebd2fed = ({ fields: fields })=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
        css: $fc6840133e04adc0$var$$eb6f767c51421421$var$metadataContainerStyles,
        "data-testid": "metadata",
        children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
            css: $fc6840133e04adc0$var$$eb6f767c51421421$var$metadataListStyles,
            children: fields.map((field)=>field.value && (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                    css: $fc6840133e04adc0$var$$eb6f767c51421421$var$metadataItemsStyles,
                    children: [
                        (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("p", {
                            css: $fc6840133e04adc0$var$$eb6f767c51421421$var$metadataTitleStyles,
                            children: field.name
                        }),
                        (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                            css: $fc6840133e04adc0$var$$eb6f767c51421421$var$metadataValueStyles,
                            children: field.value
                        })
                    ]
                }, field.name))
        })
    });
const $fc6840133e04adc0$var$$eb6f767c51421421$var$metadataContainerStyles = (0, $74Zh5.css)({
    display: "flex",
    padding: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.400"),
    alignItems: "flex-start",
    flexDirection: "column",
    backgroundColor: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.background.input"),
    borderRadius: "8px",
    boxShadow: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("elevation.shadow.raised")
});
const $fc6840133e04adc0$var$$eb6f767c51421421$var$metadataListStyles = (0, $74Zh5.css)({
    display: "flex",
    width: "100%",
    flexDirection: "column",
    alignItems: "flex-start",
    gap: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.200")
});
const $fc6840133e04adc0$var$$eb6f767c51421421$var$metadataItemsStyles = (0, $74Zh5.css)({
    display: "flex",
    minHeight: "24px",
    gap: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.300"),
    alignItems: "center"
});
const $fc6840133e04adc0$var$$eb6f767c51421421$var$metadataTitleStyles = (0, $74Zh5.css)({
    margin: 0,
    minWidth: "88px",
    color: "#000",
    fontFamily: "Charlie Text, sans-serif",
    fontSize: "14px",
    fontWeight: 600,
    lineHeight: "18px",
    textTransform: "uppercase"
});
const $fc6840133e04adc0$var$$eb6f767c51421421$var$metadataValueStyles = (0, $74Zh5.css)({
    margin: 0,
    color: "#000",
    fontFamily: "Inter",
    fontSize: "16px",
    fontWeight: 400,
    lineHeight: "24px"
});
var $fc6840133e04adc0$var$$7fe7e19d380f3d34$exports = {};
$fc6840133e04adc0$var$$parcel$export($fc6840133e04adc0$var$$7fe7e19d380f3d34$exports, "ArrowPosition", ()=>$fc6840133e04adc0$export$2d4c84fdfce6f2a9);
$fc6840133e04adc0$var$$parcel$export($fc6840133e04adc0$var$$7fe7e19d380f3d34$exports, "Popup", ()=>$fc6840133e04adc0$export$129a32eedafa97c5);
let $fc6840133e04adc0$export$2d4c84fdfce6f2a9;
(function(ArrowPosition) {
    ArrowPosition["LEFT_START"] = "leftStart";
    ArrowPosition["LEFT_CENTER"] = "leftCenter";
    ArrowPosition["LEFT_END"] = "leftEnd";
    ArrowPosition["TOP_START"] = "topStart";
    ArrowPosition["TOP_CENTER"] = "topCenter";
    ArrowPosition["TOP_END"] = "topEnd";
    ArrowPosition["RIGHT_START"] = "rightStart";
    ArrowPosition["RIGHT_CENTER"] = "rightCenter";
    ArrowPosition["RIGHT_END"] = "rightEnd";
    ArrowPosition["BOTTOM_START"] = "bottomStart";
    ArrowPosition["BOTTOM_CENTER"] = "bottomCenter";
    ArrowPosition["BOTTOM_END"] = "bottomEnd";
})($fc6840133e04adc0$export$2d4c84fdfce6f2a9 || ($fc6840133e04adc0$export$2d4c84fdfce6f2a9 = {}));
const $fc6840133e04adc0$export$129a32eedafa97c5 = (0, $5FkrB.forwardRef)(({ popupHeight: popupHeight, title: title, children: children, step: step, totalSteps: totalSteps, arrowPosition: arrowPosition, onClose: onClose, onPrevious: onPrevious, onNext: onNext, popupStyle: popupStyle }, popoverRef)=>{
    const CONTAINER_SIZE_PX = 88;
    const handlePrevious = ()=>{
        if (onPrevious) onPrevious();
    };
    const handleNext = ()=>{
        if (onNext) onNext();
    };
    const handleClose = ()=>{
        if (onClose) onClose();
    };
    (0, $5FkrB.useEffect)(()=>{
        const handleClickOutside = (event)=>{
            if (popoverRef && !popoverRef.current.contains(event.target)) handleClose();
        };
        document.addEventListener("mousedown", handleClickOutside);
        return ()=>{
            document.removeEventListener("mousedown", handleClickOutside);
        };
    // handleClose and popoverRef intentionally excluded to avoid re-creating listener
    /* eslint-disable react-hooks/exhaustive-deps */ }, [
        onClose
    ]);
    /* eslint-enable react-hooks/exhaustive-deps */ return (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
        role: "dialog",
        "aria-label": title,
        "data-testid": `popup-${arrowPosition}`,
        css: $fc6840133e04adc0$var$$7fe7e19d380f3d34$var$popupContainerStyles,
        style: popupStyle,
        ref: popoverRef,
        // eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex -- Dialog needs tabIndex for focus management
        tabIndex: 0,
        children: (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
            css: [
                $fc6840133e04adc0$var$$7fe7e19d380f3d34$var$popupContentStyles["base"],
                $fc6840133e04adc0$var$$7fe7e19d380f3d34$var$popupContentStyles[arrowPosition]
            ],
            children: [
                (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                    css: $fc6840133e04adc0$var$$7fe7e19d380f3d34$var$contentHeaderStyles,
                    children: [
                        (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("p", {
                            css: $fc6840133e04adc0$var$$7fe7e19d380f3d34$var$counterContainerStyles,
                            children: [
                                step,
                                "/",
                                totalSteps
                            ]
                        }),
                        (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                            css: $fc6840133e04adc0$var$$7fe7e19d380f3d34$var$buttonsContainerStyles,
                            children: [
                                (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$export$353f5b6fc5456de1, {
                                    disabled: step === 1,
                                    appearance: $fc6840133e04adc0$export$261c9483fc4a455a.ICON,
                                    label: "Previous",
                                    iconBefore: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$export$f04a61298a47a40f, {
                                        type: "chevron-left",
                                        alt: "next icon"
                                    }),
                                    onClick: handlePrevious
                                }),
                                (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$export$353f5b6fc5456de1, {
                                    disabled: step === totalSteps,
                                    appearance: $fc6840133e04adc0$export$261c9483fc4a455a.ICON,
                                    label: "Next",
                                    iconBefore: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$export$f04a61298a47a40f, {
                                        type: "chevron-right",
                                        alt: "previous icon"
                                    }),
                                    onClick: handleNext
                                })
                            ]
                        })
                    ]
                }),
                (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                    css: (0, $74Zh5.css)({
                        overflow: "auto",
                        maxHeight: `calc(${popupHeight}px - ${CONTAINER_SIZE_PX}px)`,
                        padding: "0 16px"
                    }),
                    children: [
                        (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("p", {
                            css: $fc6840133e04adc0$var$$7fe7e19d380f3d34$var$titleContainerStyles,
                            children: title
                        }),
                        (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("p", {
                            css: $fc6840133e04adc0$var$$7fe7e19d380f3d34$var$descriptionContainerStyles,
                            children: [
                                " ",
                                children
                            ]
                        })
                    ]
                })
            ]
        })
    });
});
const $fc6840133e04adc0$var$$7fe7e19d380f3d34$var$popupContainerStyles = (0, $74Zh5.css)({
    width: "340px",
    position: "absolute",
    zIndex: 10,
    backgroundColor: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.background.input"),
    borderRadius: "8px",
    boxShadow: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("elevation.shadow.overlay"),
    [`@media (max-width: ${$fc6840133e04adc0$var$$f0285f05d4d9f8a0$export$426e07cd0772984d.TABLET.MAX_WIDTH}px)`]: {
        top: "0 !important",
        left: "0 !important"
    },
    [(0, $0bc19dfefbafca8c$export$987d49ffe1b0900f).below.xs]: {
        height: "100%",
        width: "100%",
        border: "1px solid",
        borderColor: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.border"),
        borderRadius: 0
    }
});
const $fc6840133e04adc0$var$$7fe7e19d380f3d34$var$popupContentStyles = {
    base: (0, $74Zh5.css)({
        position: "relative",
        padding: "24px 8px",
        color: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.text"),
        display: "flex",
        flexDirection: "column",
        "&:after": {
            content: '""',
            display: "block",
            position: "absolute",
            border: "16px solid transparent",
            width: 0,
            height: 0,
            marginTop: "-10px"
        },
        [`@media (max-width: ${$fc6840133e04adc0$var$$f0285f05d4d9f8a0$export$426e07cd0772984d.TABLET.MAX_WIDTH}px)`]: {
            "&:after": {
                display: "none"
            }
        }
    }),
    leftStart: (0, $74Zh5.css)({
        "&::after": {
            top: "35px",
            left: "-5px",
            borderTop: "12px solid transparent",
            borderBottom: "12px solid transparent",
            borderLeft: 0,
            borderRightColor: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.border.inverse"),
            marginLeft: "-10px",
            filter: "drop-shadow(-2px 1px 1px rgb(178, 176, 176))"
        }
    }),
    leftCenter: (0, $74Zh5.css)({
        "&::after": {
            top: "calc(50%)",
            left: "-5px",
            borderTop: "12px solid transparent",
            borderBottom: "12px solid transparent",
            borderLeft: 0,
            borderRightColor: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.border.inverse"),
            marginLeft: "-10px",
            filter: "drop-shadow(-2px 1px 1px rgb(178, 176, 176))"
        }
    }),
    leftEnd: (0, $74Zh5.css)({
        "&::after": {
            left: "-5px",
            bottom: "35px",
            borderTop: "12px solid transparent",
            borderBottom: "12px solid transparent",
            borderLeft: 0,
            borderRightColor: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.border.inverse"),
            marginLeft: "-10px",
            filter: "drop-shadow(-2px 1px 1px rgb(178, 176, 176))"
        }
    }),
    topStart: (0, $74Zh5.css)({
        "&::after": {
            top: "-21px",
            left: "35px",
            borderRight: "12px solid transparent",
            borderLeft: "12px solid transparent",
            borderBottom: `16px solid ${(0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.border.inverse")}`,
            marginRight: "-10px",
            filter: "drop-shadow(0 -1px 0.4px rgb(178, 176, 176))"
        }
    }),
    topCenter: (0, $74Zh5.css)({
        "&::after": {
            top: "-5px",
            left: "calc(50% - 16px)",
            borderRight: "12px solid transparent",
            borderLeft: "12px solid transparent",
            borderBottom: `16px solid ${(0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.border.inverse")}`,
            borderTop: 0,
            marginRight: "-10px",
            filter: "drop-shadow(0 -1px 0.4px rgb(178, 176, 176))"
        }
    }),
    topEnd: (0, $74Zh5.css)({
        "&::after": {
            top: "-5px",
            right: "35px",
            borderRight: "12px solid transparent",
            borderLeft: "12px solid transparent",
            borderBottom: `16px solid ${(0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.border.inverse")}`,
            borderTop: 0,
            marginRight: "-10px",
            filter: "drop-shadow(0 -1px 0.4px rgb(178, 176, 176))"
        }
    }),
    rightStart: (0, $74Zh5.css)({
        "&::after": {
            top: "35px",
            right: "-5px",
            borderTop: "12px solid transparent",
            borderBottom: "12px solid transparent",
            borderLeft: `16px solid ${(0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.border.inverse")}`,
            borderRight: 0,
            marginRight: "-10px",
            filter: "drop-shadow(2px 0 1px #939393)"
        }
    }),
    rightCenter: (0, $74Zh5.css)({
        "&::after": {
            top: "calc(50% - 10px)",
            right: "-5px",
            borderTop: "12px solid transparent",
            borderBottom: "12px solid transparent",
            borderLeft: `16px solid ${(0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.border.inverse")}`,
            borderRight: 0,
            marginRight: "-10px",
            filter: "drop-shadow(2px 0 1px #939393)"
        }
    }),
    rightEnd: (0, $74Zh5.css)({
        "&::after": {
            bottom: "35px",
            right: "-5px",
            borderTop: "12px solid transparent",
            borderBottom: "12px solid transparent",
            borderLeft: `16px solid ${(0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.border.inverse")}`,
            borderRight: 0,
            marginRight: "-10px",
            filter: "drop-shadow(2px 0 1px #939393)"
        }
    }),
    bottomStart: (0, $74Zh5.css)({
        "&::after": {
            left: "35px",
            bottom: "-14px",
            borderLeft: "12px solid transparent",
            borderRight: "12px solid transparent",
            borderTop: `16px solid ${(0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.border.inverse")}`,
            borderBottom: 0,
            filter: "drop-shadow(0 4px 2px #939393)"
        }
    }),
    bottomCenter: (0, $74Zh5.css)({
        "&::after": {
            left: "calc(50% - 16px)",
            bottom: "-14px",
            borderLeft: "12px solid transparent",
            borderRight: "12px solid transparent",
            borderTop: `16px solid ${(0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.border.inverse")}`,
            borderBottom: 0,
            filter: "drop-shadow(0 4px 2px #939393)"
        }
    }),
    bottomEnd: (0, $74Zh5.css)({
        "&::after": {
            right: "35px",
            bottom: "-14px",
            borderLeft: "12px solid transparent",
            borderRight: "12px solid transparent",
            borderTop: `16px solid ${(0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.border.inverse")}`,
            borderBottom: 0,
            filter: "drop-shadow(0 4px 2px #939393)"
        }
    })
};
const $fc6840133e04adc0$var$$7fe7e19d380f3d34$var$contentHeaderStyles = (0, $74Zh5.css)({
    padding: "0 16px",
    marginBottom: "16px",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between"
});
const $fc6840133e04adc0$var$$7fe7e19d380f3d34$var$titleContainerStyles = (0, $74Zh5.css)({
    marginBottom: "16px",
    fontFamily: "Charlie Display, sans-serif",
    fontSize: "16px",
    fontWeight: 600,
    lineHeight: "24px"
});
const $fc6840133e04adc0$var$$7fe7e19d380f3d34$var$descriptionContainerStyles = (0, $74Zh5.css)({
    fontFamily: "Inter, sans-serif",
    fontSize: "16px",
    fontWeight: 400,
    lineHeight: "24px"
});
const $fc6840133e04adc0$var$$7fe7e19d380f3d34$var$counterContainerStyles = (0, $74Zh5.css)({
    fontFamily: "Charlie Text, sans-serif",
    fontSize: "14px",
    fontWeight: 600,
    lineHeight: "18px",
    color: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.text.subtlest")
});
const $fc6840133e04adc0$var$$7fe7e19d380f3d34$var$buttonsContainerStyles = (0, $74Zh5.css)({
    display: "flex",
    alignItems: "center"
});
var $fc6840133e04adc0$var$$915f5687b3b07750$exports = {};
$fc6840133e04adc0$var$$parcel$export($fc6840133e04adc0$var$$915f5687b3b07750$exports, "ProgressBar", ()=>$fc6840133e04adc0$export$c17561cb55d4db30);
const $fc6840133e04adc0$export$c17561cb55d4db30 = ({ progress: progress, color: color })=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
        "data-testid": "progress-bar",
        css: $fc6840133e04adc0$var$$915f5687b3b07750$var$progressBarContainerStyles,
        children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
            "data-testid": `progress-${progress}`,
            css: [
                $fc6840133e04adc0$var$$915f5687b3b07750$var$progressBarContentStyles,
                color && (0, $74Zh5.css)({
                    backgroundColor: color
                }),
                (0, $74Zh5.css)({
                    width: `${progress}%`
                })
            ]
        })
    });
const $fc6840133e04adc0$var$$915f5687b3b07750$var$progressBarContainerStyles = (0, $74Zh5.css)({
    width: "100%",
    height: "8px",
    backgroundColor: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.background.accent.gray.subtler"),
    borderRadius: "100px",
    overflow: "hidden"
});
const $fc6840133e04adc0$var$$915f5687b3b07750$var$progressBarContentStyles = (0, $74Zh5.css)({
    height: "8px",
    backgroundColor: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.text.success"),
    borderRadius: "100px"
});
var $fc6840133e04adc0$var$$579f9ef2424e0bd8$exports = {};
$fc6840133e04adc0$var$$parcel$export($fc6840133e04adc0$var$$579f9ef2424e0bd8$exports, "ProgressStatus", ()=>$fc6840133e04adc0$export$fad76899145ca0c7);
$fc6840133e04adc0$var$$parcel$export($fc6840133e04adc0$var$$579f9ef2424e0bd8$exports, "defineProgressStatus", ()=>$fc6840133e04adc0$export$aa03ab7e1a208875);
$fc6840133e04adc0$var$$parcel$export($fc6840133e04adc0$var$$579f9ef2424e0bd8$exports, "LearningHeader", ()=>$fc6840133e04adc0$export$86f07cccb119409d);
var $fc6840133e04adc0$var$$2cfa64583f556289$exports = {};
$fc6840133e04adc0$var$$parcel$export($fc6840133e04adc0$var$$2cfa64583f556289$exports, "PopupShare", ()=>$fc6840133e04adc0$export$477c64ffaba52edf);
const $fc6840133e04adc0$export$477c64ffaba52edf = ({ cardRef: cardRef, buttonText: buttonText, showCopyLink: showCopyLink = true, shareOnFb: shareOnFb = true, shareOnLinkedin: shareOnLinkedin = true, backgroundColor: backgroundColor = "#FFFFFF", urlToShare: urlToShare, alignToLeft: alignToLeft = false, alignToTop: alignToTop = false, fullWidth: fullWidth = false, color: color = "default", fullHeight: fullHeight = false })=>{
    const [isOpen, setIsOpen] = (0, $5FkrB.useState)(false);
    const [isCopied, setIsCopied] = (0, $5FkrB.useState)(false);
    const dropdownRef = (0, $5FkrB.useRef)(null);
    const handleButtonClick = (event)=>{
        event.stopPropagation();
        event.preventDefault();
        setIsOpen(!isOpen);
    };
    const handleShare = (url)=>{
        window.open(url, "_blank");
    };
    const shareOnFacebook = (0, $5FkrB.useCallback)(()=>{
        const facebookUrl = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(urlToShare)}`;
        handleShare(facebookUrl);
    }, [
        urlToShare
    ]);
    const shareOnLinkedIn = (0, $5FkrB.useCallback)(()=>{
        const shareText = "Check out this training from Atlassian!";
        const linkedinUrl = `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(urlToShare)}&text=${encodeURIComponent(shareText)}`;
        handleShare(linkedinUrl);
    }, [
        urlToShare
    ]);
    const copyToClipboard = (0, $5FkrB.useCallback)(()=>{
        navigator.clipboard.writeText(urlToShare).then(()=>{
            setIsCopied(true);
            setTimeout(()=>{
                setIsCopied(false);
            }, 2000);
        });
    }, [
        urlToShare
    ]);
    const onKeyDownLinkedIn = $fc6840133e04adc0$export$2a0b6757d41dacb2(shareOnLinkedIn);
    const onKeyDownFacebook = $fc6840133e04adc0$export$2a0b6757d41dacb2(shareOnFacebook);
    (0, $5FkrB.useEffect)(()=>{
        const handleClickOutside = (event)=>{
            const isClickOnThisCard = (cardRef?.current || dropdownRef.current)?.contains(event.target);
            if (!isClickOnThisCard) setIsOpen(false);
        };
        if (isOpen) document.addEventListener("mousedown", handleClickOutside);
        return ()=>{
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [
        isOpen,
        cardRef
    ]);
    const primaryColor = (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.text.brand");
    const primaryColorStyles = color === "primary" ? (0, $74Zh5.css)({
        color: primaryColor,
        "& span": {
            color: primaryColor
        },
        "& svg": {
            fill: primaryColor
        }
    }) : undefined;
    return (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
        css: [
            $fc6840133e04adc0$var$$2cfa64583f556289$var$shareButtonStyles,
            fullHeight && $fc6840133e04adc0$var$$2cfa64583f556289$var$fullHeightStyles
        ],
        "data-testid": "popup-share",
        ref: dropdownRef,
        children: [
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$export$353f5b6fc5456de1, {
                label: buttonText ?? "Share",
                appearance: $fc6840133e04adc0$export$261c9483fc4a455a.ICON,
                onClick: handleButtonClick,
                selected: isOpen,
                iconBefore: buttonText ? (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                    css: [
                        $fc6840133e04adc0$var$$2cfa64583f556289$var$buttonWithTextStyles,
                        primaryColorStyles
                    ],
                    "data-testid": "button-with-text",
                    children: [
                        (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("span", {
                            css: $fc6840133e04adc0$var$$2cfa64583f556289$var$buttonTextStyles,
                            children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$export$5f1af8db9871e1d6, {
                                children: buttonText
                            })
                        }),
                        (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$export$f04a61298a47a40f, {
                            type: "share"
                        })
                    ]
                }) : (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("span", {
                    css: primaryColorStyles,
                    children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$export$f04a61298a47a40f, {
                        type: "share"
                    })
                }),
                iconType: "share"
            }),
            isOpen && (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                "data-testid": "popup-share-dropdown",
                css: [
                    $fc6840133e04adc0$var$$2cfa64583f556289$var$popupShareDropdownStyles,
                    alignToLeft && (0, $74Zh5.css)({
                        width: "176px",
                        right: 0
                    }),
                    alignToTop && (0, $74Zh5.css)({
                        bottom: "50px"
                    })
                ],
                style: {
                    backgroundColor: backgroundColor
                },
                children: [
                    showCopyLink && (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("button", {
                        onClick: copyToClipboard,
                        css: [
                            $fc6840133e04adc0$var$$2cfa64583f556289$var$copyToClipboardOptionStyles,
                            fullWidth && $fc6840133e04adc0$var$$2cfa64583f556289$var$fullWidthOptionsStyles
                        ],
                        "aria-label": "copy to clipboard",
                        children: [
                            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$export$f04a61298a47a40f, {
                                type: "link",
                                size: "small"
                            }),
                            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("span", {
                                css: (0, $74Zh5.css)({
                                    marginLeft: "0.5rem",
                                    fontSize: "0.875rem",
                                    lineHeight: "1.25rem",
                                    fontFamily: "Charlie Text, sans-serif",
                                    color: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.text")
                                }),
                                children: "Copy link"
                            }),
                            isCopied && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("span", {
                                css: $fc6840133e04adc0$var$$2cfa64583f556289$var$isCopiedStyles,
                                children: "Copied!"
                            })
                        ]
                    }),
                    shareOnLinkedin && (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                        role: "button",
                        tabIndex: 0,
                        css: [
                            $fc6840133e04adc0$var$$2cfa64583f556289$var$shareOnLinkedInOptionStyles,
                            fullWidth && $fc6840133e04adc0$var$$2cfa64583f556289$var$fullWidthOptionsStyles
                        ],
                        onClick: shareOnLinkedIn,
                        onKeyDown: onKeyDownLinkedIn,
                        children: [
                            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("svg", {
                                xmlns: "http://www.w3.org/2000/svg",
                                xmlnsXlink: "http://www.w3.org/1999/xlink",
                                version: "1.1",
                                viewBox: "0 0 512 512",
                                style: {
                                    fillRule: "evenodd",
                                    clipRule: "evenodd",
                                    strokeLinejoin: "round",
                                    strokeMiterlimit: "2",
                                    width: "1rem",
                                    height: "1rem"
                                },
                                xmlSpace: "preserve",
                                children: (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("g", {
                                    id: "g5891",
                                    children: [
                                        (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("path", {
                                            d: "M512,64c0,-35.323 -28.677,-64 -64,-64l-384,0c-35.323,0 -64,28.677 -64,64l0,384c0,35.323 28.677,64 64,64l384,0c35.323,0 64,-28.677 64,-64l0,-384Z",
                                            id: "background",
                                            style: {
                                                fill: "#2867b2"
                                            }
                                        }),
                                        (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("g", {
                                            id: "shapes",
                                            children: [
                                                (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("rect", {
                                                    height: "257.962",
                                                    id: "rect11",
                                                    style: {
                                                        fill: "#fff"
                                                    },
                                                    width: "85.76",
                                                    x: "61.053",
                                                    y: "178.667"
                                                }),
                                                (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("path", {
                                                    d: "M104.512,54.28c-29.341,0 -48.512,19.29 -48.512,44.573c0,24.752 18.588,44.574 47.377,44.574l0.554,0c29.903,0 48.516,-19.822 48.516,-44.574c-0.555,-25.283 -18.611,-44.573 -47.935,-44.573Z",
                                                    id: "path13-0",
                                                    style: {
                                                        fill: "#fff",
                                                        fillRule: "nonzero"
                                                    }
                                                }),
                                                (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("path", {
                                                    d: "M357.278,172.601c-45.49,0 -65.866,25.017 -77.276,42.589l0,-36.523l-85.738,0c1.137,24.197 0,257.961 0,257.961l85.737,0l0,-144.064c0,-7.711 0.554,-15.42 2.827,-20.931c6.188,-15.4 20.305,-31.352 43.993,-31.352c31.012,0 43.436,23.664 43.436,58.327l0,138.02l85.741,0l0,-147.93c0,-79.237 -42.305,-116.097 -98.72,-116.097Z",
                                                    id: "path15",
                                                    style: {
                                                        fill: "#fff",
                                                        fillRule: "nonzero"
                                                    }
                                                })
                                            ]
                                        })
                                    ]
                                })
                            }),
                            " ",
                            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("span", {
                                css: (0, $74Zh5.css)({
                                    marginLeft: "0.5rem",
                                    fontSize: "0.875rem",
                                    lineHeight: "1.25rem"
                                }),
                                children: "Share on LinkedIn"
                            })
                        ]
                    }),
                    shareOnFb && (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                        role: "button",
                        tabIndex: 0,
                        css: [
                            $fc6840133e04adc0$var$$2cfa64583f556289$var$shareOnFacebookOptionStyles,
                            fullWidth && $fc6840133e04adc0$var$$2cfa64583f556289$var$fullWidthOptionsStyles
                        ],
                        onClick: shareOnFacebook,
                        onKeyDown: onKeyDownFacebook,
                        children: [
                            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("svg", {
                                xmlns: "http://www.w3.org/2000/svg",
                                xmlnsXlink: "http://www.w3.org/1999/xlink",
                                version: "1.1",
                                viewBox: "0 0 512 512",
                                style: {
                                    fillRule: "evenodd",
                                    clipRule: "evenodd",
                                    strokeLinejoin: "round",
                                    strokeMiterlimit: "2",
                                    width: "1rem",
                                    height: "1rem"
                                },
                                xmlSpace: "preserve",
                                children: (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("g", {
                                    children: [
                                        (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("path", {
                                            d: "M512,256c0,-141.385 -114.615,-256 -256,-256c-141.385,0 -256,114.615 -256,256c0,127.777 93.616,233.685 216,252.89l0,-178.89l-65,0l0,-74l65,0l0,-56.4c0,-64.16 38.219,-99.6 96.695,-99.6c28.009,0 57.305,5 57.305,5l0,63l-32.281,0c-31.801,0 -41.719,19.733 -41.719,39.978l0,48.022l71,0l-11.35,74l-59.65,0l0,178.89c122.385,-19.205 216,-125.113 216,-252.89Z",
                                            fill: "#1877f2",
                                            fillRule: "nonzero"
                                        }),
                                        (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("path", {
                                            d: "M355.65,330l11.35,-74l-71,0l0,-48.022c0,-20.245 9.917,-39.978 41.719,-39.978l32.281,0l0,-63c0,0 -29.297,-5 -57.305,-5c-58.476,0 -96.695,35.44 -96.695,99.6l0,56.4l-65,0l0,74l65,0l0,178.89c13.033,2.045 26.392,3.11 40,3.11c13.608,0 26.966,-1.065 40,-3.11l0,-178.89l59.65,0Z",
                                            fill: "#fff",
                                            fillRule: "nonzero"
                                        })
                                    ]
                                })
                            }),
                            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("span", {
                                css: (0, $74Zh5.css)({
                                    marginLeft: "0.5rem",
                                    fontSize: "0.875rem",
                                    lineHeight: "1.25rem"
                                }),
                                children: "Share on Facebook"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
const $fc6840133e04adc0$var$$2cfa64583f556289$var$buttonWithTextStyles = (0, $74Zh5.css)({
    display: "flex",
    alignItems: "center",
    gap: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.100")
});
const $fc6840133e04adc0$var$$2cfa64583f556289$var$buttonTextStyles = (0, $74Zh5.css)({
    [(0, $0bc19dfefbafca8c$export$987d49ffe1b0900f).below.sm]: {
        display: "none"
    }
});
const $fc6840133e04adc0$var$$2cfa64583f556289$var$shareButtonStyles = (0, $74Zh5.css)({
    width: "fit-content",
    position: "relative",
    "& span": {
        fontFamily: "Charlie Text, sans-serif"
    },
    // override fixed sizing when text is included
    '& button[id*="icon-button"]': {
        width: "fit-content !important",
        height: "fit-content !important"
    }
});
const $fc6840133e04adc0$var$$2cfa64583f556289$var$fullHeightStyles = (0, $74Zh5.css)({
    height: "100%",
    '& button[id*="icon-button"]': {
        height: "100% !important"
    }
});
const $fc6840133e04adc0$var$$2cfa64583f556289$var$popupShareDropdownStyles = (0, $74Zh5.css)({
    position: "absolute",
    marginTop: "0.5rem",
    display: "flex",
    flexDirection: "column",
    borderRadius: "0.25rem",
    zIndex: 2,
    color: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.text"),
    boxShadow: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("elevation.shadow.overlay")
});
const $fc6840133e04adc0$var$$2cfa64583f556289$var$fullWidthOptionsStyles = (0, $74Zh5.css)({
    whiteSpace: "nowrap"
});
const $fc6840133e04adc0$var$$2cfa64583f556289$var$copyToClipboardOptionStyles = (0, $74Zh5.css)({
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    whiteSpace: "nowrap",
    paddingTop: "0.5rem",
    paddingBottom: "0.5rem",
    paddingLeft: "0.75rem",
    paddingRight: "1rem",
    border: "none",
    transition: "background",
    transitionDuration: "300ms",
    transitionTimingFunction: "cubic-bezier(0, 0, 0.2, 1)",
    cursor: "pointer",
    backgroundColor: "transparent",
    ":hover": {
        backgroundColor: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.background.neutral.subtle.hovered")
    }
});
const $fc6840133e04adc0$var$$2cfa64583f556289$var$isCopiedStyles = (0, $74Zh5.css)({
    position: "absolute",
    backgroundColor: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.background.accent.gray.subtle.pressed"),
    color: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.text"),
    fontSize: "0.688rem",
    lineHeight: "0.875rem",
    padding: "0.25rem",
    borderRadius: "0.25rem",
    marginTop: "0.25rem",
    right: "1rem"
});
const $fc6840133e04adc0$var$$2cfa64583f556289$var$shareOnLinkedInOptionStyles = (0, $74Zh5.css)({
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    whiteSpace: "nowrap",
    paddingTop: "0.5rem",
    paddingBottom: "0.5rem",
    paddingLeft: "0.75rem",
    paddingRight: "1rem",
    border: "none",
    transition: "background",
    transitionDuration: "300ms",
    transitionTimingFunction: "cubic-bezier(0, 0, 0.2, 1)",
    cursor: "pointer",
    backgroundColor: "transparent",
    ":hover": {
        backgroundColor: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.background.neutral.subtle.hovered")
    }
});
const $fc6840133e04adc0$var$$2cfa64583f556289$var$shareOnFacebookOptionStyles = (0, $74Zh5.css)({
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    whiteSpace: "nowrap",
    paddingTop: "0.5rem",
    paddingBottom: "0.5rem",
    paddingLeft: "0.75rem",
    paddingRight: "1rem",
    border: "none",
    transition: "background",
    transitionDuration: "300ms",
    transitionTimingFunction: "cubic-bezier(0, 0, 0.2, 1)",
    cursor: "pointer",
    backgroundColor: "transparent",
    ":hover": {
        backgroundColor: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.background.neutral.subtle.hovered")
    }
});
let $fc6840133e04adc0$export$fad76899145ca0c7;
(function(ProgressStatus) {
    ProgressStatus["NOT_STARTED"] = "not_started";
    ProgressStatus["IN_PROGRESS"] = "in_progress";
    ProgressStatus["FINISHED"] = "finished";
})($fc6840133e04adc0$export$fad76899145ca0c7 || ($fc6840133e04adc0$export$fad76899145ca0c7 = {}));
const $fc6840133e04adc0$export$aa03ab7e1a208875 = (progressStatus, contentTypeLabel)=>{
    switch(progressStatus){
        case $fc6840133e04adc0$export$fad76899145ca0c7.NOT_STARTED:
            return `Start ${contentTypeLabel}`;
        case $fc6840133e04adc0$export$fad76899145ca0c7.IN_PROGRESS:
            return `Continue ${contentTypeLabel}`;
        case $fc6840133e04adc0$export$fad76899145ca0c7.FINISHED:
            return `Review ${contentTypeLabel}`;
        default:
            return `Start ${contentTypeLabel}`;
    }
};
const $fc6840133e04adc0$export$86f07cccb119409d = ({ inspectMode: inspectMode, heading: heading, anonymousView: anonymousView = true, urlToShare: urlToShare, onSignIn: onSignIn, onStartCourse: onStartCourse, isLoading: isLoading, contentType: contentType, progressStatus: progressStatus, tagLine: tagLine, isSaved: isSaved, onSave: onSave, shouldShowFeedback: shouldShowFeedback, onStartFeedback: onStartFeedback, href: href })=>{
    const handleSignIn = ()=>{
        if (onSignIn) onSignIn();
    };
    const handleStartCourse = (event)=>{
        if (onStartCourse) {
            event?.preventDefault();
            onStartCourse();
        }
    };
    const handleOnSave = ()=>{
        if (onSave) onSave();
    };
    const contentTypeLabel = contentType === $fc6840133e04adc0$export$e2e108cbe2e4f865.COURSE ? "course" : "learning path";
    const status = $fc6840133e04adc0$export$aa03ab7e1a208875(progressStatus, contentTypeLabel);
    const renderActionButtons = ()=>{
        if (isLoading) return (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$export$353f5b6fc5456de1, {
            label: "",
            isLoading: isLoading
        });
        if (anonymousView) return (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
            css: (0, $74Zh5.css)({
                display: "flex"
            }),
            children: [
                (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$export$353f5b6fc5456de1, {
                    label: "Sign in",
                    appearance: $fc6840133e04adc0$export$261c9483fc4a455a.PRIMARY,
                    onClick: handleSignIn,
                    isLoading: isLoading
                }),
                (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                    css: (0, $74Zh5.css)({
                        marginLeft: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.200")
                    }),
                    children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$export$353f5b6fc5456de1, {
                        label: status,
                        appearance: $fc6840133e04adc0$export$261c9483fc4a455a.SECONDARY,
                        onClick: handleStartCourse,
                        isLoading: isLoading,
                        href: href,
                        target: "_blank"
                    })
                })
            ]
        });
        return (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
            css: (0, $74Zh5.css)({
                display: "flex"
            }),
            children: [
                (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$export$353f5b6fc5456de1, {
                    label: status,
                    appearance: $fc6840133e04adc0$export$261c9483fc4a455a.PRIMARY,
                    onClick: handleStartCourse,
                    isLoading: isLoading,
                    href: href,
                    target: "_blank"
                }),
                shouldShowFeedback && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                    css: (0, $74Zh5.css)({
                        marginLeft: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.200")
                    }),
                    children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$export$353f5b6fc5456de1, {
                        label: "Take survey",
                        appearance: $fc6840133e04adc0$export$261c9483fc4a455a.SECONDARY,
                        onClick: onStartFeedback,
                        isLoading: isLoading
                    })
                })
            ]
        });
    };
    return (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("section", {
        "data-testid": "learning-header",
        css: $fc6840133e04adc0$var$$579f9ef2424e0bd8$var$learningHeaderContainerStyles,
        children: [
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                css: [
                    $fc6840133e04adc0$export$f40d73b6f7f951e9
                ],
                children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$export$3288d34c523a1192, {
                    label: contentTypeLabel
                })
            }),
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                css: (0, $74Zh5.css)({
                    margin: `${(0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.300")} 0`
                }),
                ...$fc6840133e04adc0$export$1784ac302bd8ebad("title", inspectMode),
                children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$export$a8a3e93435678ff9, {
                    level: 1,
                    children: heading
                })
            }),
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("p", {
                    css: $fc6840133e04adc0$var$$579f9ef2424e0bd8$var$tagLineStyles,
                    children: tagLine
                })
            }),
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                css: (0, $74Zh5.css)({
                    marginTop: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.300"),
                    marginBottom: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.400")
                }),
                children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$export$2e0a83ec2e27ecbb, {
                    color: (0, $d568d81ef5c2bf7a$export$8754fc7e6d8b3000)
                })
            }),
            (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                css: (0, $74Zh5.css)({
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center"
                }),
                children: [
                    renderActionButtons(),
                    (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                        css: (0, $74Zh5.css)({
                            display: "flex"
                        }),
                        children: [
                            !anonymousView && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("button", {
                                tabIndex: 0,
                                css: $fc6840133e04adc0$var$$579f9ef2424e0bd8$var$learningCourseCardBookmarkContainerStyles,
                                onClick: handleOnSave,
                                "aria-label": isSaved ? "unsave" : "save",
                                children: isSaved ? (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$export$f04a61298a47a40f, {
                                    type: "bookmark-filled"
                                }) : (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$export$f04a61298a47a40f, {
                                    type: "bookmark"
                                })
                            }),
                            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$export$477c64ffaba52edf, {
                                urlToShare: urlToShare,
                                alignToLeft: true
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
const $fc6840133e04adc0$var$$579f9ef2424e0bd8$var$learningHeaderContainerStyles = (0, $74Zh5.css)({
    width: "100%",
    paddingTop: `${(0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.600")}`,
    paddingBottom: `${(0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.400")}`,
    [(0, $0bc19dfefbafca8c$export$987d49ffe1b0900f).above.lg]: {
        paddingTop: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.1000"),
        paddingBottom: `${(0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.400")}`
    }
});
const $fc6840133e04adc0$var$$579f9ef2424e0bd8$var$tagLineStyles = (0, $74Zh5.css)({
    color: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.text"),
    fontFamily: "Inter, sans-serif",
    fontSize: "20px",
    fontWeight: 400,
    lineHeight: "32px"
});
const $fc6840133e04adc0$var$$579f9ef2424e0bd8$var$learningCourseCardBookmarkContainerStyles = (0, $74Zh5.css)({
    height: "24px",
    border: "none",
    padding: 0,
    marginRight: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.100"),
    background: "none",
    cursor: "pointer",
    outline: "none",
    "&:focus-visible": {
        outline: `2px solid ${(0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.border.selected")}`,
        borderRadius: "2px"
    }
});
var $fc6840133e04adc0$var$$d559b1cc82536c49$exports = {};
$fc6840133e04adc0$var$$parcel$export($fc6840133e04adc0$var$$d559b1cc82536c49$exports, "Footer", ()=>$fc6840133e04adc0$export$a06f1c675e846f6f);
const $fc6840133e04adc0$export$a06f1c675e846f6f = ({ onOpenReportProblemModal: onOpenReportProblemModal })=>{
    const noOp = ()=>{};
    const onKeyDownReport = $fc6840133e04adc0$export$2a0b6757d41dacb2(onOpenReportProblemModal || noOp);
    return (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("footer", {
        "data-testid": "footer",
        css: $fc6840133e04adc0$var$$d559b1cc82536c49$var$footerContainerStyles,
        children: [
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("a", {
                href: "https://www.atlassian.com",
                css: [
                    $fc6840133e04adc0$var$$d559b1cc82536c49$var$paddingRightStyles,
                    $fc6840133e04adc0$var$$d559b1cc82536c49$var$logoLinkStyles
                ],
                children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $0ae21ee22a245b70$export$765cacec8b0843f3), {
                    appearance: "neutral",
                    size: "small"
                })
            }),
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                children: (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("ul", {
                    css: $fc6840133e04adc0$var$$d559b1cc82536c49$var$listStyles,
                    "aria-label": "footer navigation",
                    children: [
                        onOpenReportProblemModal && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("li", {
                            css: [
                                $fc6840133e04adc0$var$$d559b1cc82536c49$var$listItemStyles,
                                $fc6840133e04adc0$var$$d559b1cc82536c49$var$paddingRightStyles
                            ],
                            children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("span", {
                                role: "button",
                                tabIndex: 0,
                                css: [
                                    $fc6840133e04adc0$var$$d559b1cc82536c49$var$listItemLinkStyles,
                                    (0, $74Zh5.css)({
                                        cursor: "pointer"
                                    })
                                ],
                                onClick: onOpenReportProblemModal,
                                onKeyDown: onKeyDownReport,
                                children: "Report problem"
                            })
                        }),
                        (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("li", {
                            css: [
                                $fc6840133e04adc0$var$$d559b1cc82536c49$var$listItemStyles,
                                $fc6840133e04adc0$var$$d559b1cc82536c49$var$paddingRightStyles
                            ],
                            children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("a", {
                                css: $fc6840133e04adc0$var$$d559b1cc82536c49$var$listItemLinkStyles,
                                href: "https://www.atlassian.com/legal/privacy-policy",
                                children: "Privacy Policy"
                            })
                        }),
                        (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("li", {
                            css: [
                                $fc6840133e04adc0$var$$d559b1cc82536c49$var$listItemStyles,
                                $fc6840133e04adc0$var$$d559b1cc82536c49$var$paddingRightStyles
                            ],
                            children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("a", {
                                css: $fc6840133e04adc0$var$$d559b1cc82536c49$var$listItemLinkStyles,
                                href: "https://community.atlassian.com/t5/user/termsofservicepage",
                                children: "Terms of Use"
                            })
                        }),
                        (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("li", {
                            css: [
                                $fc6840133e04adc0$var$$d559b1cc82536c49$var$listItemStyles,
                                $fc6840133e04adc0$var$$d559b1cc82536c49$var$paddingRightStyles
                            ],
                            children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("a", {
                                css: $fc6840133e04adc0$var$$d559b1cc82536c49$var$listItemLinkStyles,
                                href: "https://www.atlassian.com/security",
                                children: "Security"
                            })
                        }),
                        (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("li", {
                            css: $fc6840133e04adc0$var$$d559b1cc82536c49$var$listItemStyles,
                            children: [
                                "\xa9 ",
                                new Date().getUTCFullYear(),
                                " Atlassian"
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
const $fc6840133e04adc0$var$$d559b1cc82536c49$var$footerContainerStyles = (0, $74Zh5.css)({
    display: "flex",
    justifyContent: "space-between",
    flexDirection: "row",
    alignItems: "center",
    maxWidth: "1440px",
    backgroundColor: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.background.input"),
    zIndex: 4,
    padding: "48px 104px",
    boxSizing: "border-box",
    margin: "0 auto",
    width: "100%",
    [(0, $0bc19dfefbafca8c$export$987d49ffe1b0900f).below.md]: {
        padding: "48px 60px"
    },
    [(0, $0bc19dfefbafca8c$export$987d49ffe1b0900f).below.sm]: {
        padding: "72px 32px",
        flexDirection: "column",
        alignItems: "flex-start"
    }
});
const $fc6840133e04adc0$var$$d559b1cc82536c49$var$listStyles = (0, $74Zh5.css)({
    display: "flex",
    paddingLeft: 0,
    margin: 0,
    flexDirection: "row",
    justifyContent: "flex-end",
    listStyle: "none",
    [(0, $0bc19dfefbafca8c$export$987d49ffe1b0900f).below.sm]: {
        flexDirection: "column"
    }
});
const $fc6840133e04adc0$var$$d559b1cc82536c49$var$listItemStyles = (0, $74Zh5.css)({
    fontFamily: "Charlie Text, sans-serif",
    fontSize: "14px",
    fontStyle: "normal",
    fontWeight: 500,
    lineHeight: "20px",
    marginTop: 0,
    color: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.text.subtlest"),
    [(0, $0bc19dfefbafca8c$export$987d49ffe1b0900f).below.sm]: {
        paddingTop: "24px"
    }
});
const $fc6840133e04adc0$var$$d559b1cc82536c49$var$paddingRightStyles = (0, $74Zh5.css)({
    paddingRight: "24px"
});
const $fc6840133e04adc0$var$$d559b1cc82536c49$var$logoLinkStyles = (0, $74Zh5.css)({
    lineHeight: "24px"
});
const $fc6840133e04adc0$var$$d559b1cc82536c49$var$listItemLinkStyles = (0, $74Zh5.css)({
    color: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.text.subtlest"),
    textDecoration: "none",
    "&:hover": {
        color: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.text.subtlest"),
        textDecoration: "none"
    }
});
var $fc6840133e04adc0$var$$fa53e9c0a1746730$exports = {};
$fc6840133e04adc0$var$$parcel$export($fc6840133e04adc0$var$$fa53e9c0a1746730$exports, "LabelledGraphic", ()=>$fc6840133e04adc0$export$12b5e3eab33f219b);
const $fc6840133e04adc0$export$12b5e3eab33f219b = ({ image: image, markers: markers, onClickMarker: onClickMarker, onClickNext: onClickNext, onClickPrevious: onClickPrevious, onClickDismiss: onClickDismiss, pulseAnimationColor: pulseAnimationColor = (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.background.input") })=>{
    const [activeId, setActiveId] = (0, $5FkrB.useState)(null);
    const [popoverPosX, setPopoverPosX] = (0, $5FkrB.useState)(null);
    const [popoverPosY, setPopoverPosY] = (0, $5FkrB.useState)(null);
    const [clickedMarkers, setClickedMarkers] = (0, $5FkrB.useState)([]);
    const containerDivRef = (0, $5FkrB.useRef)(null);
    const popupRef = (0, $5FkrB.useRef)(null);
    const imageContainerRef = (0, $5FkrB.useRef)(null);
    const maxPopupHeight = 540;
    const maxPopupWidth = 340;
    const defaultDesktopWidth = 1040;
    const iconNumbers = [
        "one",
        "two",
        "three",
        "four",
        "five",
        "six",
        "seven",
        "eight",
        "nine",
        "zero"
    ];
    const handleNextStep = (idx)=>{
        if (onClickNext) onClickNext();
        setClickedMarkers((prevState)=>[
                ...prevState,
                idx + 1
            ]);
        setActiveId((prevId)=>{
            return prevId !== null ? prevId + 1 : null;
        });
    };
    const handlePreviousStep = (idx)=>{
        if (onClickPrevious) onClickPrevious();
        setClickedMarkers((prevState)=>[
                ...prevState,
                idx - 1
            ]);
        setActiveId((prevId)=>{
            return prevId !== null ? prevId - 1 : null;
        });
    };
    const handleDismiss = (0, $5FkrB.useCallback)(()=>{
        if (onClickDismiss) onClickDismiss();
        setActiveId(null);
    }, [
        onClickDismiss
    ]);
    const handleClickMarker = (0, $5FkrB.useCallback)((idx)=>{
        if (onClickMarker) onClickMarker(idx + 1);
        setClickedMarkers((prevState)=>[
                ...prevState,
                idx
            ]);
        setActiveId(idx);
    }, [
        onClickMarker
    ]);
    (0, $5FkrB.useEffect)(()=>{
        if (containerDivRef.current && activeId != null) {
            const parentWidth = containerDivRef.current.clientWidth;
            const parentHeight = containerDivRef.current.clientHeight;
            const popoverHeight = popupRef?.current?.clientHeight ?? 0;
            let posX = parentWidth * markers[activeId].posX / 100;
            let posY = parentHeight * markers[activeId].posY / 100;
            switch(markers[activeId].arrowPosition){
                case $fc6840133e04adc0$export$2d4c84fdfce6f2a9.LEFT_START:
                    posX = posX + 70;
                    posY = posY - 15;
                    break;
                case $fc6840133e04adc0$export$2d4c84fdfce6f2a9.LEFT_CENTER:
                    posX = posX + 70;
                    posY = posY - Math.ceil(popoverHeight / 2.5) - 15;
                    break;
                case $fc6840133e04adc0$export$2d4c84fdfce6f2a9.LEFT_END:
                    posX = posX + 70;
                    posY = posY - popoverHeight + 70;
                    break;
                case $fc6840133e04adc0$export$2d4c84fdfce6f2a9.TOP_START:
                    posX = posX - 24;
                    posY = posY + 70;
                    break;
                case $fc6840133e04adc0$export$2d4c84fdfce6f2a9.TOP_CENTER:
                    posX = posX - Math.ceil(maxPopupWidth / 2) + 27;
                    posY = posY + 70;
                    break;
                case $fc6840133e04adc0$export$2d4c84fdfce6f2a9.TOP_END:
                    posX = posX - maxPopupWidth + 60;
                    posY = posY + 70;
                    break;
                case $fc6840133e04adc0$export$2d4c84fdfce6f2a9.RIGHT_START:
                    posX = posX - maxPopupWidth - 24;
                    posY = posY - 13;
                    break;
                case $fc6840133e04adc0$export$2d4c84fdfce6f2a9.RIGHT_CENTER:
                    posX = posX - maxPopupWidth - 24;
                    posY = posY - Math.ceil(popoverHeight / 2) + 32;
                    break;
                case $fc6840133e04adc0$export$2d4c84fdfce6f2a9.RIGHT_END:
                    posX = posX - maxPopupWidth - 24;
                    posY = posY - popoverHeight + 70;
                    break;
                case $fc6840133e04adc0$export$2d4c84fdfce6f2a9.BOTTOM_START:
                    posX = posX - 25;
                    posY = posY - popoverHeight - 20;
                    break;
                case $fc6840133e04adc0$export$2d4c84fdfce6f2a9.BOTTOM_CENTER:
                    posX = posX - Math.ceil(maxPopupWidth / 2) + 25;
                    posY = posY - popoverHeight - 20;
                    break;
                case $fc6840133e04adc0$export$2d4c84fdfce6f2a9.BOTTOM_END:
                    posX = posX - maxPopupWidth + 70;
                    posY = posY - popoverHeight - 18;
                    break;
                default:
                    break;
            }
            setPopoverPosX(posX / parentWidth * 100);
            setPopoverPosY(posY / parentHeight * 100);
            // Focus the popup when it is opened
            popupRef.current?.focus();
        }
    }, [
        activeId,
        markers,
        imageContainerRef.current?.clientHeight
    ]);
    const handleKeyDown = (0, $5FkrB.useCallback)((event)=>{
        if (event.code === "Space") {
            event.preventDefault();
            handleClickMarker(Number(event.currentTarget.getAttribute("data-marker-index")));
        }
    }, [
        handleClickMarker
    ]);
    return (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
        css: $fc6840133e04adc0$var$$fa53e9c0a1746730$var$labelledGraphicContainerStyles,
        ref: containerDivRef,
        children: [
            markers?.map((marker, idx)=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                    role: "button",
                    tabIndex: 0,
                    onKeyDown: handleKeyDown,
                    "data-testid": "graphic-marker",
                    css: [
                        $fc6840133e04adc0$var$$fa53e9c0a1746730$var$markerPulseStyles,
                        clickedMarkers.includes(idx) && "none",
                        !clickedMarkers.includes(idx) && pulseAnimationColor === "#FFFFFF" && (0, $74Zh5.css)({
                            animation: `${$fc6840133e04adc0$var$$fa53e9c0a1746730$var$pulseWhiteAnimationStyles} 3000ms cubic-bezier(0.55, 0.06, 0.68, 0.19) infinite`
                        }),
                        !clickedMarkers.includes(idx) && pulseAnimationColor !== "#FFFFFF" && (0, $74Zh5.css)({
                            animation: `${$fc6840133e04adc0$var$$fa53e9c0a1746730$var$pulsePurpleAnimationStyles} 3000ms cubic-bezier(0.55, 0.06, 0.68, 0.19) infinite`
                        })
                    ],
                    style: {
                        left: marker.posX + "%",
                        top: marker.posY + "%"
                    },
                    children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                        role: "button",
                        tabIndex: 0,
                        onClick: (e)=>{
                            e.preventDefault();
                            e.stopPropagation();
                            handleClickMarker(idx);
                        },
                        onKeyDown: (e)=>{
                            if (e.key === "Enter" || e.key === " ") {
                                e.preventDefault();
                                e.stopPropagation();
                                handleClickMarker(idx);
                            }
                        },
                        draggable: true,
                        css: [
                            $fc6840133e04adc0$var$$fa53e9c0a1746730$var$graphicMarkerContainerStyles["base"],
                            activeId === idx && $fc6840133e04adc0$var$$fa53e9c0a1746730$var$graphicMarkerContainerStyles["selected"],
                            (0, $74Zh5.css)({
                                border: `2px solid ${pulseAnimationColor}`
                            })
                        ],
                        children: (0, $6bec4f26b2cb3094$export$25062201e9e25d76)((0, $6bec4f26b2cb3094$export$ffb0004e005737fa), {
                            children: [
                                marker.icon && iconNumbers.includes(marker.icon) && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("span", {
                                    css: [
                                        activeId === idx && (0, $74Zh5.css)({
                                            color: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.text.inverse")
                                        }),
                                        activeId !== idx && (0, $74Zh5.css)({
                                            color: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.text")
                                        })
                                    ],
                                    children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$export$f04a61298a47a40f, {
                                        type: marker.icon
                                    })
                                }),
                                marker.icon && !iconNumbers.includes(marker.icon) && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("span", {
                                    css: (0, $74Zh5.css)({
                                        display: "flex",
                                        alignItems: "center"
                                    }),
                                    children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$export$f04a61298a47a40f, {
                                        size: "small",
                                        color: `${activeId === idx ? (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.icon.inverse") : (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.icon.warning.inverse")}`,
                                        type: marker.icon
                                    })
                                })
                            ]
                        })
                    })
                }, `marker-${idx}`)),
            activeId != null && imageContainerRef.current && containerDivRef.current && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$export$129a32eedafa97c5, {
                popupHeight: imageContainerRef.current.clientHeight > 540 ? 540 : imageContainerRef.current.clientHeight,
                title: markers[activeId].title,
                totalSteps: markers.length,
                step: activeId + 1,
                popupStyle: {
                    position: "absolute",
                    left: popoverPosX + "%",
                    top: popoverPosY + "%",
                    maxHeight: `${maxPopupHeight}px`,
                    maxWidth: `${maxPopupWidth}px`
                },
                arrowPosition: markers[activeId].arrowPosition,
                onNext: ()=>handleNextStep(activeId),
                onPrevious: ()=>handlePreviousStep(activeId),
                onClose: handleDismiss,
                ref: popupRef,
                children: markers[activeId].children
            }),
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                ref: imageContainerRef,
                children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$export$3e431a229df88919, {
                    ...image,
                    css: [
                        $fc6840133e04adc0$var$$fa53e9c0a1746730$var$imageStyles,
                        (0, $74Zh5.css)({
                            maxWidth: `${defaultDesktopWidth}px`
                        })
                    ],
                    preventModal: true
                })
            })
        ]
    });
};
const $fc6840133e04adc0$var$$fa53e9c0a1746730$var$labelledGraphicContainerStyles = (0, $74Zh5.css)({
    position: "relative",
    cursor: "default"
});
const $fc6840133e04adc0$var$$fa53e9c0a1746730$var$pulseWhiteAnimationStyles = (0, $74Zh5.keyframes)({
    "0%": {
        boxShadow: `0 0 0 2px ${(0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.border.inverse")}, 0 0 0 ${(0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.border.inverse")}`
    },
    "33%": {
        boxShadow: `0 0 0 2px ${(0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.border.inverse")}, 0 0 0 ${(0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.border.inverse")}`
    },
    "66%": {
        boxShadow: `0 0 0 2px ${(0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.border.inverse")}, 0 0 0 10px ${(0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.border.inverse")}`
    },
    "100%": {
        transform: `0 0 0 2px ${(0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.border.inverse")}, 0 0 0 10px ${(0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.border.inverse")}`
    }
});
const $fc6840133e04adc0$var$$fa53e9c0a1746730$var$pulsePurpleAnimationStyles = (0, $74Zh5.keyframes)({
    "0%": {
        boxShadow: `0 0 0 2px ${(0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.text.discovery")}, 0 0 0 ${(0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.text.discovery")}`
    },
    "33%": {
        boxShadow: `0 0 0 2px ${(0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.text.discovery")}, 0 0 0 ${(0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.text.discovery")}`
    },
    "66%": {
        boxShadow: `0 0 0 2px ${(0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.text.discovery")}, 0 0 0 10px ${(0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.text.discovery")}`
    },
    "100%": {
        transform: `0 0 0 2px ${(0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.text.discovery")}, 0 0 0 10px ${(0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.text.discovery")}`
    }
});
const $fc6840133e04adc0$var$$fa53e9c0a1746730$var$markerPulseStyles = (0, $74Zh5.css)({
    height: "46px",
    width: "46px",
    padding: "6px 12px",
    backgroundColor: "transparent",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    position: "absolute",
    borderRadius: "50%",
    zIndex: 2,
    cursor: "pointer"
});
const $fc6840133e04adc0$var$$fa53e9c0a1746730$var$graphicMarkerContainerStyles = {
    base: (0, $74Zh5.css)({
        height: "40px",
        width: "40px",
        padding: "6px 12px",
        position: "absolute",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        borderRadius: "50%",
        backgroundColor: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.background.accent.yellow.subtle"),
        fontFamily: "Charlie Display, sans-serif",
        fontSize: "16px",
        fontStyle: "normal",
        fontWeight: 700,
        lineHeight: "24px",
        color: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.text"),
        boxShadow: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("elevation.shadow.overlay"),
        "&:hover": {
            backgroundColor: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.background.accent.yellow.subtle.hovered")
        },
        "&:active": {
            backgroundColor: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.background.accent.yellow.subtle.pressed")
        }
    }),
    selected: (0, $74Zh5.css)({
        backgroundColor: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.text"),
        "&:hover": {
            backgroundColor: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.text")
        },
        "&:active": {
            backgroundColor: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.text")
        }
    })
};
const $fc6840133e04adc0$var$$fa53e9c0a1746730$var$imageStyles = (0, $74Zh5.css)({
    height: "auto",
    width: "100%"
});
var $fc6840133e04adc0$var$$9225344cd5d1f99b$exports = {};
$fc6840133e04adc0$var$$parcel$export($fc6840133e04adc0$var$$9225344cd5d1f99b$exports, "LessonHeader", ()=>$fc6840133e04adc0$export$7bee7638d150bc04);
const $fc6840133e04adc0$export$7bee7638d150bc04 = ({ heading: heading, tags: tags, description: description, urlToShare: urlToShare, onListenClick: onListenClick, showListenButton: showListenButton = true })=>(0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
        children: [
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                css: $fc6840133e04adc0$var$$9225344cd5d1f99b$var$headingWrapperStyles,
                children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$export$a8a3e93435678ff9, {
                    level: 1,
                    children: heading
                })
            }),
            (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                css: $fc6840133e04adc0$var$$9225344cd5d1f99b$var$metadataStyles,
                children: [
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                        css: $fc6840133e04adc0$var$$9225344cd5d1f99b$var$flexContainerStyles,
                        children: tags.map((tag, index)=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                                css: $fc6840133e04adc0$var$$9225344cd5d1f99b$var$tagStyles,
                                children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$export$3288d34c523a1192, {
                                    ...tag
                                })
                            }, index))
                    }),
                    (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                        css: $fc6840133e04adc0$var$$9225344cd5d1f99b$var$flexContainerStyles,
                        children: [
                            showListenButton && (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("button", {
                                css: $fc6840133e04adc0$var$$9225344cd5d1f99b$var$listenButtonStyles,
                                onClick: ()=>onListenClick && onListenClick(),
                                "data-testid": "listen-button",
                                children: [
                                    (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("svg", {
                                        width: "24",
                                        height: "24",
                                        viewBox: "0 0 24 24",
                                        fill: "none",
                                        xmlns: "http://www.w3.org/2000/svg",
                                        children: [
                                            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("path", {
                                                fillRule: "evenodd",
                                                clipRule: "evenodd",
                                                d: "M8.5 17.3333V13.5C8.5 12.9477 8.05228 12.5 7.5 12.5C6.94772 12.5 6.5 12.9477 6.5 13.5V15.6667C6.5 16.6792 7.32081 17.5 8.33333 17.5C8.42538 17.5 8.5 17.4254 8.5 17.3333ZM7.5 11C6.11929 11 5 12.1193 5 13.5V15.6667C5 17.5076 6.49238 19 8.33333 19C9.25381 19 10 18.2538 10 17.3333V13.5C10 12.1193 8.88071 11 7.5 11Z",
                                                fill: "#44546F"
                                            }),
                                            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("path", {
                                                fillRule: "evenodd",
                                                clipRule: "evenodd",
                                                d: "M15.5 17.3333V13.5C15.5 12.9477 15.9477 12.5 16.5 12.5C17.0523 12.5 17.5 12.9477 17.5 13.5V15.6667C17.5 16.6792 16.6792 17.5 15.6667 17.5C15.5746 17.5 15.5 17.4254 15.5 17.3333ZM16.5 11C17.8807 11 19 12.1193 19 13.5V15.6667C19 17.5076 17.5076 19 15.6667 19C14.7462 19 14 18.2538 14 17.3333V13.5C14 12.1193 15.1193 11 16.5 11Z",
                                                fill: "#44546F"
                                            }),
                                            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("path", {
                                                fillRule: "evenodd",
                                                clipRule: "evenodd",
                                                d: "M12 5.5C8.96243 5.5 6.5 7.96243 6.5 11V14.25H5V11C5 7.13401 8.13401 4 12 4C15.866 4 19 7.13401 19 11V14.25H17.5V11C17.5 7.96243 15.0376 5.5 12 5.5Z",
                                                fill: "#44546F"
                                            })
                                        ]
                                    }),
                                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("span", {
                                        css: $fc6840133e04adc0$var$$9225344cd5d1f99b$var$listenTextWrapperStyles,
                                        children: "Listen"
                                    })
                                ]
                            }),
                            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$export$477c64ffaba52edf, {
                                urlToShare: urlToShare,
                                alignToLeft: true
                            })
                        ]
                    })
                ]
            }),
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                css: $fc6840133e04adc0$var$$9225344cd5d1f99b$var$lineWrapperStyles,
                children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$export$2e0a83ec2e27ecbb, {
                    color: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.border")
                })
            }),
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                css: $fc6840133e04adc0$var$$9225344cd5d1f99b$var$descriptionStyles,
                children: description
            })
        ]
    });
const $fc6840133e04adc0$var$$9225344cd5d1f99b$var$metadataStyles = (0, $74Zh5.css)({
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between"
});
const $fc6840133e04adc0$var$$9225344cd5d1f99b$var$flexContainerStyles = (0, $74Zh5.css)({
    display: "flex"
});
const $fc6840133e04adc0$var$$9225344cd5d1f99b$var$listenButtonStyles = (0, $74Zh5.css)({
    display: "flex",
    alignItems: "center",
    marginRight: "1.5rem",
    cursor: "pointer",
    padding: 0,
    border: "none",
    background: "transparent"
});
const $fc6840133e04adc0$var$$9225344cd5d1f99b$var$listenTextWrapperStyles = (0, $74Zh5.css)({
    marginLeft: "0.25rem",
    color: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.text.subtle"),
    fontSize: "16px",
    fontFamily: "Charlie Text, sans-serif"
});
const $fc6840133e04adc0$var$$9225344cd5d1f99b$var$tagStyles = (0, $74Zh5.css)({
    marginRight: "0.5rem"
});
const $fc6840133e04adc0$var$$9225344cd5d1f99b$var$lineWrapperStyles = (0, $74Zh5.css)({
    padding: "1.5rem 0 2.5rem 0"
});
const $fc6840133e04adc0$var$$9225344cd5d1f99b$var$headingWrapperStyles = (0, $74Zh5.css)({
    padding: "5rem 0 1.5rem 0"
});
const $fc6840133e04adc0$var$$9225344cd5d1f99b$var$descriptionStyles = (0, $74Zh5.css)({
    paddingBottom: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.1000"),
    fontFamily: "Inter, sans-serif",
    fontSize: "20px",
    lineHeight: "32px",
    color: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.text"),
    p: {
        margin: 0
    },
    a: {
        fontSize: "20px",
        lineHeight: "32px"
    },
    ul: {
        paddingLeft: "20px",
        marginTop: 0,
        marginBottom: 0,
        li: {
            marginTop: "16px"
        },
        "li + li": {
            marginTop: "16px !important"
        }
    }
});
var $fc6840133e04adc0$var$$3b9afd8fe4435353$exports = {};
$fc6840133e04adc0$var$$parcel$export($fc6840133e04adc0$var$$3b9afd8fe4435353$exports, "LessonList", ()=>$fc6840133e04adc0$export$962a95c44e73eb25);
const $fc6840133e04adc0$var$$057799a99c9f255f$export$b7cafc9b9fbb48b2 = ({ isCompleted: isCompleted, size: size })=>isCompleted ? (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$export$f04a61298a47a40f, {
        type: "check-circle-filled",
        size: size,
        color: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.icon.success")
    }) : (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$export$f04a61298a47a40f, {
        type: "check-circle-outline",
        size: size,
        color: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.background.accent.gray.subtler.pressed")
    });
const $fc6840133e04adc0$var$$7e5a668c3a5a9ea8$export$2c301aad86da9f9a = ({ sectionTitle: sectionTitle, slug: slug, lessonSlug: lessonSlug, isCompleted: isCompleted, onNavigation: onNavigation })=>{
    const handleKeyDown = (0, $5FkrB.useCallback)((event, onNavigation, slug, lessonSlug)=>{
        if (event.code === "Space") {
            event.preventDefault();
            onNavigation({
                sectionSlug: slug,
                lessonSlug: lessonSlug
            });
        }
    }, []);
    return (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
        css: $fc6840133e04adc0$var$$7e5a668c3a5a9ea8$var$sectionStyles,
        children: [
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$var$$057799a99c9f255f$export$b7cafc9b9fbb48b2, {
                isCompleted: isCompleted,
                size: $fc6840133e04adc0$export$ff775019b5b6e7df.SMALL
            }),
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                css: $fc6840133e04adc0$var$$7e5a668c3a5a9ea8$var$sectionLinkStyles,
                children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("span", {
                    role: "link",
                    tabIndex: 0,
                    onKeyDown: (event)=>handleKeyDown(event, onNavigation, slug, lessonSlug),
                    onClick: ()=>onNavigation({
                            sectionSlug: slug,
                            lessonSlug: lessonSlug
                        }),
                    children: sectionTitle
                })
            })
        ]
    });
};
const $fc6840133e04adc0$var$$7e5a668c3a5a9ea8$var$sectionStyles = (0, $74Zh5.css)({
    display: "flex",
    alignItems: "center",
    marginBottom: "0.75rem"
});
const $fc6840133e04adc0$var$$7e5a668c3a5a9ea8$var$sectionLinkStyles = (0, $74Zh5.css)({
    marginLeft: "11px",
    span: {
        fontFamily: "Inter, sans-serif",
        fontSize: "14px",
        lineHeight: "1.5rem",
        fontWeight: 400,
        color: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.text")
    },
    ":hover": {
        span: {
            color: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.text.selected"),
            textDecoration: "none"
        }
    }
});
const $fc6840133e04adc0$var$$fc302bf0bdbf0587$export$e4e5e6361d1b89e2 = ({ lessonTitle: lessonTitle, slug: slug, duration: duration, isCompleted: isCompleted, isCurrentLesson: isCurrentLesson, hasDivider: hasDivider, sections: sections, onNavigation: onNavigation })=>{
    const [isExpanded, setIsExpanded] = (0, $5FkrB.useState)(isCurrentLesson);
    const expandByCard = (event)=>{
        if (event.target === event.currentTarget) setIsExpanded(!isExpanded);
    };
    const expandByButton = ()=>{
        setIsExpanded(!isExpanded);
    };
    (0, $5FkrB.useEffect)(()=>{
        setIsExpanded(isCurrentLesson);
    }, [
        isCurrentLesson
    ]);
    const handleKeyDown = (0, $5FkrB.useCallback)((event, onNavigation, slug)=>{
        if (event.code === "Space") {
            event.preventDefault();
            onNavigation({
                lessonSlug: slug
            });
        }
    }, []);
    return (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("section", {
        // eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex -- Section needs tabIndex for keyboard navigation
        tabIndex: 0,
        "aria-label": `Lesson overview for ${lessonTitle}`,
        css: [
            $fc6840133e04adc0$var$$fc302bf0bdbf0587$var$lessonCardContainerStyles,
            !hasDivider && (0, $74Zh5.css)({
                marginBottom: "16px"
            })
        ],
        children: [
            (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                role: "button",
                tabIndex: 0,
                css: [
                    $fc6840133e04adc0$var$$fc302bf0bdbf0587$var$lessonCardStyles,
                    isCurrentLesson && $fc6840133e04adc0$var$$fc302bf0bdbf0587$var$currentLessonStyles,
                    !isCurrentLesson && $fc6840133e04adc0$var$$fc302bf0bdbf0587$var$hoverLessonStyles
                ],
                onClick: expandByCard,
                onKeyDown: (e)=>{
                    if (e.key === "Enter" || e.key === " ") {
                        e.preventDefault();
                        expandByCard(e);
                    }
                },
                children: [
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("button", {
                        tabIndex: 0,
                        "aria-label": "expand lesson button",
                        css: [
                            $fc6840133e04adc0$var$$fc302bf0bdbf0587$var$expandButtonStyles,
                            !isCurrentLesson && (0, $74Zh5.css)({
                                borderColor: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.background.accent.gray.subtlest.hovered")
                            })
                        ],
                        "data-testid": "expand-button",
                        onClick: expandByButton,
                        children: isExpanded ? (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$export$f04a61298a47a40f, {
                            type: "chevron-down",
                            size: $fc6840133e04adc0$export$ff775019b5b6e7df.MEDIUM,
                            color: isCurrentLesson ? (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.icon.selected") : (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.icon.subtle")
                        }) : (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$export$f04a61298a47a40f, {
                            type: "chevron-right",
                            size: $fc6840133e04adc0$export$ff775019b5b6e7df.MEDIUM,
                            color: isCurrentLesson ? (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.icon.selected") : (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.icon.subtle")
                        })
                    }),
                    (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                        css: $fc6840133e04adc0$var$$fc302bf0bdbf0587$var$mainContentColumnStyles,
                        children: [
                            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("p", {
                                css: [
                                    $fc6840133e04adc0$var$$fc302bf0bdbf0587$var$durationStyles,
                                    !isCurrentLesson && (0, $74Zh5.css)({
                                        color: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.text.subtlest")
                                    })
                                ],
                                children: duration.toUpperCase()
                            }),
                            (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                                css: $fc6840133e04adc0$var$$fc302bf0bdbf0587$var$lessonContainer,
                                children: [
                                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                                        css: $fc6840133e04adc0$var$$fc302bf0bdbf0587$var$lessonTitleStyles,
                                        children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("span", {
                                            role: "button",
                                            tabIndex: 0,
                                            onKeyDown: (event)=>handleKeyDown(event, onNavigation, slug),
                                            onClick: ()=>onNavigation({
                                                    lessonSlug: slug
                                                }),
                                            children: lessonTitle
                                        })
                                    }),
                                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                                        css: (0, $74Zh5.css)({
                                            marginLeft: "1.5rem",
                                            display: "flex"
                                        }),
                                        children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$var$$057799a99c9f255f$export$b7cafc9b9fbb48b2, {
                                            isCompleted: isCompleted,
                                            size: $fc6840133e04adc0$export$ff775019b5b6e7df.MEDIUM
                                        })
                                    })
                                ]
                            }),
                            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                                css: (0, $74Zh5.css)({
                                    marginTop: "0.75rem"
                                }),
                                children: isExpanded && sections.map((section)=>(0, $5FkrB.createElement)($fc6840133e04adc0$var$$7e5a668c3a5a9ea8$export$2c301aad86da9f9a, {
                                        ...section,
                                        lessonSlug: slug,
                                        onNavigation: onNavigation,
                                        key: `section-${section.slug}`
                                    }))
                            })
                        ]
                    })
                ]
            }),
            hasDivider && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                css: (0, $74Zh5.css)({
                    marginTop: "16px",
                    marginBottom: "16px"
                }),
                children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$export$2e0a83ec2e27ecbb, {
                    height: 2,
                    color: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.border")
                })
            })
        ]
    }, slug);
};
const $fc6840133e04adc0$var$$fc302bf0bdbf0587$var$lessonCardContainerStyles = (0, $74Zh5.css)({
    maxWidth: "25.25rem",
    [(0, $0bc19dfefbafca8c$export$987d49ffe1b0900f).below.sm]: {
        maxWidth: "100%",
        paddingRight: "16px"
    }
});
const $fc6840133e04adc0$var$$fc302bf0bdbf0587$var$lessonCardStyles = (0, $74Zh5.css)({
    width: "100%",
    display: "flex",
    padding: "16px",
    borderRadius: "0.25rem",
    cursor: "pointer"
});
const $fc6840133e04adc0$var$$fc302bf0bdbf0587$var$currentLessonStyles = (0, $74Zh5.css)({
    backgroundColor: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.background.selected"),
    borderLeft: `4px solid ${(0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.text.brand")}`
});
const $fc6840133e04adc0$var$$fc302bf0bdbf0587$var$hoverLessonStyles = (0, $74Zh5.css)({
    ":hover": {
        backgroundColor: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.background.accent.gray.subtlest")
    },
    ":hover button": {
        borderColor: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.background.accent.gray.subtlest.pressed")
    }
});
const $fc6840133e04adc0$var$$fc302bf0bdbf0587$var$mainContentColumnStyles = (0, $74Zh5.css)({
    width: "100%",
    display: "flex",
    flexDirection: "column",
    marginLeft: "0.75rem"
});
const $fc6840133e04adc0$var$$fc302bf0bdbf0587$var$expandButtonStyles = (0, $74Zh5.css)({
    width: "1.5rem",
    height: "1.5rem",
    padding: 0,
    border: `1px solid ${(0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.background.accent.blue.subtlest.pressed")}`,
    borderRadius: "0.25rem",
    boxSizing: "content-box",
    background: "transparent",
    outline: "none",
    cursor: "pointer",
    ":focus-visible": {
        border: `2px solid ${(0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.border.selected")}`
    }
});
const $fc6840133e04adc0$var$$fc302bf0bdbf0587$var$durationStyles = (0, $74Zh5.css)({
    width: "100%",
    fontSize: "0.75rem",
    fontWeight: 400,
    lineHeight: "1.125rem",
    color: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.text.selected"),
    marginTop: 0,
    marginBottom: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.075")
});
const $fc6840133e04adc0$var$$fc302bf0bdbf0587$var$lessonContainer = (0, $74Zh5.css)({
    display: "flex",
    alignItems: "center"
});
const $fc6840133e04adc0$var$$fc302bf0bdbf0587$var$lessonTitleStyles = (0, $74Zh5.css)({
    width: "100%",
    fontFamily: "Charlie Display",
    fontSize: "16px",
    fontWeight: 600,
    lineHeight: "1.5rem",
    span: {
        color: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.text")
    },
    ":hover": {
        span: {
            color: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.text.selected"),
            textDecoration: "none"
        }
    }
});
const $fc6840133e04adc0$export$962a95c44e73eb25 = ({ lessons: lessons })=>{
    const currentLessonIndx = lessons.findIndex((lesson)=>lesson.isCurrentLesson);
    const updatedLessons = lessons.map((lesson, indx)=>({
            ...lesson,
            hasDivider: !(indx === currentLessonIndx || indx === currentLessonIndx - 1)
        }));
    return updatedLessons.map((lesson)=>(0, $5FkrB.createElement)($fc6840133e04adc0$var$$fc302bf0bdbf0587$export$e4e5e6361d1b89e2, {
            ...lesson,
            key: `lesson-${lesson.slug}`
        }));
};
var $fc6840133e04adc0$var$$050a30fc95775cfd$exports = {};
$fc6840133e04adc0$var$$parcel$export($fc6840133e04adc0$var$$050a30fc95775cfd$exports, "LessonsList", ()=>$fc6840133e04adc0$export$c3b0ae23c563b692);
const $fc6840133e04adc0$export$c3b0ae23c563b692 = ({ lessons: lessons, onLessonClick: onLessonClick, isStandalone: isStandalone = false, isTablet: isTablet = false })=>{
    return (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
        css: [
            $fc6840133e04adc0$var$$050a30fc95775cfd$var$lessonsListStyles,
            isStandalone && $fc6840133e04adc0$var$$050a30fc95775cfd$var$lessonsListStandaloneStyles,
            isTablet && !isStandalone && (0, $74Zh5.css)({
                borderRadius: "0"
            })
        ],
        children: lessons?.map(({ slug: slug, isCompleted: isCompleted, title: title, duration: duration }, index)=>(0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                role: "button",
                "data-testid": `lesson-list-item-${index}`,
                tabIndex: 0,
                css: [
                    $fc6840133e04adc0$var$$050a30fc95775cfd$var$lessonItemStyles,
                    !isStandalone && !isTablet && index === lessons.length - 1 && $fc6840133e04adc0$var$$050a30fc95775cfd$var$lastLessonItemStyles,
                    isTablet && !isStandalone && index === 0 && $fc6840133e04adc0$var$$050a30fc95775cfd$var$firstLessonItemTabletStyles,
                    isTablet && !isStandalone && index === lessons.length - 1 && $fc6840133e04adc0$var$$050a30fc95775cfd$var$lastLessonItemTabletStyles
                ],
                onClick: ()=>onLessonClick(slug),
                onKeyDown: (event)=>{
                    if (event.key === "Enter") onLessonClick(slug);
                },
                children: [
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                        css: $fc6840133e04adc0$var$$050a30fc95775cfd$var$circleContainerStyles,
                        children: isCompleted ? (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$export$f04a61298a47a40f, {
                            size: "small",
                            type: "check-circle",
                            color: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.border.success")
                        }) : (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                            css: $fc6840133e04adc0$var$$050a30fc95775cfd$var$emptyCircleStyles
                        })
                    }),
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("span", {
                        css: [
                            $fc6840133e04adc0$var$$050a30fc95775cfd$var$textStyles,
                            isCompleted && {
                                color: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.text.success")
                            }
                        ],
                        children: title
                    }),
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                        css: $fc6840133e04adc0$var$$050a30fc95775cfd$var$durationBadgeStyles,
                        children: duration
                    }),
                    isStandalone && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                        css: $fc6840133e04adc0$var$$050a30fc95775cfd$var$chevronContainerStyles,
                        children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$export$f04a61298a47a40f, {
                            size: "medium",
                            type: "chevron-right",
                            color: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.text")
                        })
                    })
                ]
            }, slug))
    });
};
const $fc6840133e04adc0$var$$050a30fc95775cfd$var$lessonsListStyles = (0, $74Zh5.css)({
    backgroundColor: "#FFFFFF",
    maxWidth: "100%",
    borderRadius: "0 0 8px 8px",
    overflow: "hidden"
});
const $fc6840133e04adc0$var$$050a30fc95775cfd$var$lessonsListStandaloneStyles = (0, $74Zh5.css)({
    border: `1px solid ${(0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.border")}`,
    borderRadius: "8px"
});
const $fc6840133e04adc0$var$$050a30fc95775cfd$var$lessonItemStyles = (0, $74Zh5.css)({
    display: "flex",
    flexDirection: "row",
    borderTop: `1px solid ${(0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.border")}`,
    padding: `${(0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.150")} ${(0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.200")}`,
    cursor: "pointer",
    "&:hover": {
        backgroundColor: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.background.accent.gray.subtlest")
    },
    "&:active": {
        backgroundColor: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.background.accent.gray.subtlest.hovered")
    },
    ":first-of-type": {
        borderTop: "none"
    }
});
const $fc6840133e04adc0$var$$050a30fc95775cfd$var$circleContainerStyles = (0, $74Zh5.css)({
    marginTop: "3px"
});
const $fc6840133e04adc0$var$$050a30fc95775cfd$var$emptyCircleStyles = (0, $74Zh5.css)({
    width: "14px",
    height: "14px",
    borderRadius: "50%",
    border: `1.4px solid ${(0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.border")}`,
    padding: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.075"),
    margin: "1px",
    marginTop: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.025")
});
const $fc6840133e04adc0$var$$050a30fc95775cfd$var$textStyles = (0, $74Zh5.css)({
    fontSize: "14px",
    fontWeight: "400",
    lineHeight: "20px",
    fontFamily: "Inter",
    padding: `${(0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.025")} ${(0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.100")}`,
    color: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.text")
});
const $fc6840133e04adc0$var$$050a30fc95775cfd$var$durationBadgeStyles = (0, $74Zh5.css)({
    marginTop: "1px",
    padding: `${(0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.025")} ${(0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.075")}`,
    borderRadius: "8px",
    backgroundColor: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.background.disabled"),
    textTransform: "uppercase",
    fontSize: "12px",
    fontWeight: "400",
    lineHeight: "18px",
    marginLeft: "auto",
    whiteSpace: "nowrap",
    height: "fit-content"
});
const $fc6840133e04adc0$var$$050a30fc95775cfd$var$lastLessonItemStyles = (0, $74Zh5.css)({
    borderRadius: "0 0 8px 8px"
});
const $fc6840133e04adc0$var$$050a30fc95775cfd$var$firstLessonItemTabletStyles = (0, $74Zh5.css)({
    borderTop: `1px solid ${(0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.border")} !important`
});
const $fc6840133e04adc0$var$$050a30fc95775cfd$var$lastLessonItemTabletStyles = (0, $74Zh5.css)({
    borderRadius: "0 !important"
});
const $fc6840133e04adc0$var$$050a30fc95775cfd$var$chevronContainerStyles = (0, $74Zh5.css)({
    display: "none",
    "@media (max-width: 965px)": {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        height: "24px",
        marginLeft: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.050"),
        marginRight: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.negative.100")
    }
});
var $fc6840133e04adc0$var$$65703ff0bcd12648$exports = {};
$fc6840133e04adc0$var$$parcel$export($fc6840133e04adc0$var$$65703ff0bcd12648$exports, "LessonSidebar", ()=>$fc6840133e04adc0$export$c2bf8d11366d1eb0);
const $fc6840133e04adc0$var$$bae5a7f2c1ae6bce$export$7ded8628b71ba75 = ({ progress: progress, pathColor: pathColor, trailColor: trailColor = (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.border"), image: image, title: title, onCourseNavigation: onCourseNavigation })=>{
    const handleClick = (0, $5FkrB.useCallback)(()=>{
        onCourseNavigation && onCourseNavigation();
    }, [
        onCourseNavigation
    ]);
    const handleKeyDown = $fc6840133e04adc0$export$2a0b6757d41dacb2(handleClick);
    return (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
        css: $fc6840133e04adc0$var$$bae5a7f2c1ae6bce$var$progressBadgeContainerStyles,
        children: [
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                css: (0, $74Zh5.css)({
                    maxWidth: "64px",
                    [(0, $0bc19dfefbafca8c$export$987d49ffe1b0900f).above.sm]: {
                        maxWidth: "85px"
                    }
                }),
                "data-testid": "progress-circle",
                children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $f188eff9b59fb855$export$5ab97151efedb8c6), {
                    strokeWidth: 4,
                    value: progress,
                    styles: (0, $f188eff9b59fb855$export$5115a192ad9bf57f)({
                        pathColor: pathColor,
                        trailColor: trailColor
                    }),
                    children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                        css: $fc6840133e04adc0$var$$bae5a7f2c1ae6bce$var$imageBadgeContainerStyles,
                        children: image ? (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("img", {
                            css: $fc6840133e04adc0$var$$bae5a7f2c1ae6bce$var$imageStyles,
                            "data-testid": "badge-image",
                            src: image.src,
                            alt: image.alt
                        }) : (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                            css: [
                                (0, $74Zh5.css)({
                                    backgroundColor: trailColor
                                }),
                                $fc6840133e04adc0$var$$bae5a7f2c1ae6bce$var$innerCircleBackgroundStyles
                            ]
                        })
                    })
                })
            }),
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                    role: "button",
                    tabIndex: 0,
                    onKeyDown: handleKeyDown,
                    css: $fc6840133e04adc0$var$$bae5a7f2c1ae6bce$var$titleStyles,
                    onClick: onCourseNavigation,
                    children: title
                })
            })
        ]
    });
};
const $fc6840133e04adc0$var$$bae5a7f2c1ae6bce$var$progressBadgeContainerStyles = (0, $74Zh5.css)({
    display: "flex",
    alignItems: "center",
    gap: "16px"
});
const $fc6840133e04adc0$var$$bae5a7f2c1ae6bce$var$imageBadgeContainerStyles = (0, $74Zh5.css)({
    width: "100%",
    height: "100%",
    padding: "8px"
});
const $fc6840133e04adc0$var$$bae5a7f2c1ae6bce$var$imageStyles = (0, $74Zh5.css)({
    width: "100%",
    height: "100%",
    objectFit: "contain",
    borderRadius: "50%"
});
const $fc6840133e04adc0$var$$bae5a7f2c1ae6bce$var$innerCircleBackgroundStyles = (0, $74Zh5.css)({
    borderRadius: "9999px",
    width: "100%",
    height: "100%"
});
const $fc6840133e04adc0$var$$bae5a7f2c1ae6bce$var$titleStyles = (0, $74Zh5.css)({
    color: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.text"),
    fontWeight: 600,
    fontSize: "20px",
    lineHeight: "28px",
    fontFamily: "Charlie Display, sans-serif",
    paddingRight: "16px",
    margin: 0,
    "&:hover": {
        cursor: "pointer",
        color: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.text.selected")
    }
});
const $fc6840133e04adc0$export$c2bf8d11366d1eb0 = ({ lessons: lessons, progress: progress, pathColor: pathColor, title: title, image: image, isVisible: isVisible, onChangeMenuVisibility: onChangeMenuVisibility, onCourseNavigation: onCourseNavigation })=>(0, $6bec4f26b2cb3094$export$25062201e9e25d76)($fc6840133e04adc0$export$1ba59dacbcbf90fe, {
        isVisible: isVisible,
        onChangeMenuVisibility: onChangeMenuVisibility,
        children: [
            (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                css: (0, $74Zh5.css)({
                    marginLeft: "16px"
                }),
                children: [
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                        css: (0, $74Zh5.css)({
                            marginBottom: "16px",
                            lineHeight: "24px"
                        }),
                        children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("span", {
                            css: [
                                $fc6840133e04adc0$var$$65703ff0bcd12648$var$subheadingStyles,
                                (0, $74Zh5.css)({
                                    marginBottom: "24px",
                                    marginTop: "24px"
                                })
                            ],
                            children: "Current course"
                        })
                    }),
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$var$$bae5a7f2c1ae6bce$export$7ded8628b71ba75, {
                        progress: progress,
                        pathColor: pathColor,
                        title: title,
                        image: image,
                        onCourseNavigation: onCourseNavigation
                    }),
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                        css: (0, $74Zh5.css)({
                            marginBottom: "24px",
                            marginTop: "24px",
                            lineHeight: "24px"
                        }),
                        children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("span", {
                            css: $fc6840133e04adc0$var$$65703ff0bcd12648$var$subheadingStyles,
                            children: "Lessons in this course"
                        })
                    })
                ]
            }),
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$export$962a95c44e73eb25, {
                lessons: lessons
            })
        ]
    });
const $fc6840133e04adc0$var$$65703ff0bcd12648$var$subheadingStyles = (0, $74Zh5.css)({
    fontFamily: "Charlie Text, sens-serif",
    fontSize: "12px",
    fontWeight: 600,
    lineHeight: "16px",
    textTransform: "uppercase",
    color: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.text")
});
var $fc6840133e04adc0$var$$8340d81aba797956$exports = {};
$fc6840133e04adc0$var$$parcel$export($fc6840133e04adc0$var$$8340d81aba797956$exports, "LearningOverviewCard", ()=>$fc6840133e04adc0$export$60e8035fadc9b8fc);
var $fc6840133e04adc0$var$$8f97e278a4a2a6b3$require$Buffer = (0, $7KfP5.Buffer);
const $fc6840133e04adc0$var$$8f97e278a4a2a6b3$var$svgStringLearningOverviewCardBackground = `<svg width="1003" height="48" viewBox="0 0 1003 48" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_3622_1083)">
      <g clip-path="url(#clip1_3622_1083)">
        <path
          d="M929.87 -106.601C934.923 -113.047 932.654 -115.022 927.128 -108.989C923.208 -104.711 919.232 -100.29 914.973 -95.4457C910.706 -90.547 906.173 -84.8713 902.441 -77.642C901.929 -76.6053 901.438 -75.6223 900.973 -74.6736C900.581 -73.6929 900.196 -72.7546 899.839 -71.8631C899.493 -70.958 899.113 -70.1306 898.849 -69.2729C898.586 -68.4274 898.343 -67.6109 898.101 -66.8314C897.872 -66.0506 897.619 -65.3092 897.435 -64.5795C897.275 -63.835 897.116 -63.1274 896.97 -62.4309C896.673 -61.0446 896.374 -59.7637 896.241 -58.4844C896.079 -57.2144 895.893 -55.9961 895.769 -54.7717C895.695 -53.5422 895.62 -52.3126 895.538 -51.053C895.481 -50.4216 895.48 -49.7785 895.49 -49.1218C895.494 -48.4596 895.492 -47.7918 895.495 -47.0926C895.45 -45.6992 895.57 -44.2212 895.672 -42.6212C895.734 -40.8087 896.046 -38.9029 896.305 -36.9035C896.407 -35.8974 896.663 -34.8941 896.85 -33.8669C897.074 -32.836 897.222 -31.7755 897.514 -30.7316C897.793 -29.6765 898.071 -28.6091 898.36 -27.5159C898.619 -26.4196 899.039 -25.3563 899.372 -24.2525C899.729 -23.1586 900.067 -22.0357 900.524 -20.944C901.095 -19.4758 901.672 -18.0008 902.248 -16.5135C903.686 -16.151 905.125 -15.7886 906.563 -15.4261L908.148 -15.024L909.749 -14.7069C910.816 -14.4996 911.884 -14.2923 912.945 -14.0795C914.015 -13.9338 915.072 -13.7893 916.13 -13.6449C916.659 -13.5788 917.181 -13.4949 917.698 -13.4424C918.222 -13.4077 918.74 -13.3676 919.258 -13.3274C920.294 -13.2594 921.317 -13.1803 922.328 -13.1147C923.342 -13.1108 924.331 -13.1094 925.302 -13.1037C925.79 -13.0974 926.272 -13.098 926.748 -13.093C927.225 -13.1003 927.69 -13.1458 928.161 -13.1722C930.021 -13.305 931.798 -13.3659 933.424 -13.6525C935.06 -13.8885 936.594 -14.073 937.944 -14.4185C939.298 -14.7325 940.538 -14.9593 941.583 -15.2676C942.622 -15.5827 943.499 -15.8526 944.2 -16.0659C944.814 -16.2634 945.445 -16.4282 946.042 -16.6706L947.817 -17.4307C948.868 -17.8993 950.401 -18.4983 952.174 -19.5183C953.072 -20.0086 954.081 -20.5123 955.126 -21.1299C956.149 -21.7869 957.247 -22.4858 958.427 -23.2319C963.03 -26.3399 968.353 -30.7603 973.46 -36.3963C976.055 -39.2319 978.501 -42.2247 981.093 -45.2956C983.684 -48.3664 986.348 -51.5351 989.05 -54.737C994.763 -61.4435 1000.62 -68.3333 1006.26 -74.9487L1008.09 -77.1133L970.879 -109.453C966.364 -113.375 962.194 -116.953 958.273 -120.283C953.7 -124.143 949.449 -127.723 945.42 -131.125C944.678 -130.223 943.943 -129.327 943.214 -128.436C942.856 -127.996 942.499 -127.568 942.141 -127.128C941.939 -126.87 941.731 -126.619 941.535 -126.367C940.74 -125.372 939.959 -124.387 939.189 -123.414C937.664 -121.465 936.17 -119.557 934.69 -117.66C932.576 -114.943 931.934 -113.128 932.4 -112.592L932.334 -112.332C932.406 -112.276 932.468 -112.282 932.515 -112.357L932.544 -112.466C933.134 -112.084 934.804 -113.003 937.144 -115.524C938.768 -117.296 940.405 -119.078 942.08 -120.893C942.908 -121.811 943.75 -122.74 944.611 -123.686C944.824 -123.918 945.032 -124.157 945.245 -124.389L945.523 -124.676C945.697 -124.85 945.871 -125.036 946.051 -125.216C946.212 -125.057 946.378 -124.892 946.551 -124.732L946.789 -124.498C946.872 -124.415 946.884 -124.389 947.164 -124.144C948.023 -123.364 948.906 -122.57 949.794 -121.768C951.584 -120.164 953.428 -118.511 955.343 -116.801C959.18 -113.387 963.311 -109.751 967.813 -105.818C970.585 -103.409 974.75 -99.5537 980.247 -94.53C983.002 -92.0237 986.097 -89.2169 989.489 -86.1324C991.196 -84.5985 992.985 -82.9942 994.853 -81.3264C996.512 -79.8591 998.231 -78.3239 1000.02 -76.7443C1000.02 -76.7443 1000.02 -76.7443 1000.03 -76.7375C1000.03 -76.7375 1000.03 -76.7375 1000.03 -76.7307L999.428 -75.9942C998.608 -74.9765 997.794 -73.9643 996.986 -72.9576C992.58 -67.3803 987.764 -61.4487 983.029 -55.6945C980.656 -52.8241 978.303 -49.9826 976.04 -47.2557C974.903 -45.8928 973.785 -44.5589 972.7 -43.2526C971.603 -41.9845 970.523 -40.8015 969.48 -39.627C968.467 -38.4309 967.35 -37.4185 966.338 -36.4017C965.308 -35.3929 964.34 -34.4148 963.33 -33.6019C962.344 -32.7618 961.416 -31.9716 960.551 -31.2367C959.658 -30.548 958.798 -29.9486 958.034 -29.383C957.263 -28.8364 956.598 -28.2977 955.964 -27.9044C955.336 -27.5166 954.797 -27.1817 954.347 -26.9119C953.472 -26.3698 952.996 -26.0778 952.996 -26.0778C952.138 -25.5031 951.199 -25.0603 950.283 -24.5781C949.361 -24.1149 948.469 -23.5932 947.518 -23.1762C945.607 -22.393 943.74 -21.4938 941.744 -20.9109C937.842 -19.5255 933.722 -18.7251 929.573 -18.2555L926.433 -17.9804L923.272 -17.9363C922.219 -17.8947 921.159 -17.9652 920.098 -18.0234C919.038 -18.1063 917.98 -18.0961 916.922 -18.2406L913.741 -18.6191C912.682 -18.7389 911.629 -18.9819 910.566 -19.1578C909.51 -19.3392 908.455 -19.5329 907.408 -19.8061L905.406 -20.2877L904.553 -22.4154C904.095 -23.4824 903.763 -24.5862 903.387 -25.6759C902.591 -27.8535 902.063 -30.0843 901.455 -32.3048C900.43 -36.7694 899.847 -41.2944 899.708 -45.799C899.617 -54.5172 901.176 -60.7732 902.66 -65.3605C902.844 -65.9356 903.027 -66.4861 903.204 -67.0187C903.288 -67.2822 903.373 -67.5458 903.458 -67.797C903.56 -68.0402 903.663 -68.2833 903.759 -68.521C904.156 -69.4703 904.519 -70.3427 904.855 -71.156C905.02 -71.5599 905.184 -71.9515 905.335 -72.3196C905.517 -72.6785 905.692 -73.0195 905.86 -73.355C906.196 -74.0137 906.505 -74.6256 906.787 -75.1907C907.6 -76.9267 908.616 -78.4937 909.532 -80.0583C910.413 -81.6513 911.478 -83.0586 912.439 -84.4951C912.938 -85.1991 913.381 -85.9272 913.903 -86.5918C914.425 -87.2563 914.927 -87.9166 915.436 -88.5701C916.442 -89.8783 917.421 -91.1521 918.467 -92.4005C922.553 -97.4041 926.266 -102.05 929.852 -106.622L929.87 -106.601Z"
          fill="#ffffff7d"
        />
        <path
          d="M485.107 17.5435C485.157 17.2393 485.206 16.9473 485.261 16.6622C485.278 16.3733 485.284 16.0955 485.3 15.8312C485.322 15.2892 485.33 14.7951 485.324 14.3368C485.343 13.4171 485.158 12.6498 485.022 12.0299C484.719 10.8054 484.323 10.2085 483.928 10.1932C483.526 10.1834 483.114 10.7415 482.773 11.8449C482.59 12.3954 482.499 13.0914 482.264 13.8777C482.161 14.2755 482.069 14.7115 481.982 15.179C481.941 15.4161 481.901 15.6532 481.853 15.9082C481.782 16.1483 481.716 16.3953 481.65 16.6545C480.974 19.6043 479.725 22.3352 477.739 24.515C475.77 26.7027 473.101 28.343 469.989 29.4622C466.875 30.606 463.32 31.2162 459.494 31.4897C458.544 31.5974 457.566 31.6219 456.576 31.6451C455.585 31.6806 454.581 31.7272 453.55 31.6906C452.518 31.6786 451.48 31.6599 450.417 31.6509C449.33 31.6149 448.225 31.5831 447.114 31.5445C442.635 31.4549 438.7 31.3709 437.402 31.3506C437.461 33.0947 437.517 34.758 437.575 36.3721C437.617 37.335 437.653 38.2665 437.691 39.1611C437.768 40.7708 437.837 42.2685 437.903 43.6732C438.049 46.4837 438.178 48.94 438.299 51.2842C438.542 55.9725 438.747 60.2179 438.871 65.9952C438.989 71.3019 439.109 77.3447 439.271 84.7774C442.605 84.9054 446.043 85.0502 449.524 85.1809C452.302 85.302 455.11 85.42 457.906 85.5368C463.561 85.752 469.165 85.7145 474.329 85.3789C479.492 85.0555 484.21 84.4395 488.08 83.7004C491.949 82.9612 494.97 82.1111 496.811 81.5433C498.187 81.1511 499.514 80.6115 500.851 80.0978C502.029 79.5802 503.702 78.8717 505.73 77.7972C506.747 77.2757 507.825 76.6181 509.009 75.928C510.159 75.1726 511.403 74.3834 512.642 73.4081C515.149 71.5039 517.788 69.0935 520.199 66.06C522.609 63.0388 524.767 59.3919 526.368 55.2742C528 51.1658 529.033 46.5883 529.51 41.8369C530 37.0745 529.928 32.156 529.432 27.1513C528.49 17.1591 524.835 6.82357 518.805 -1.52006C514.549 -7.40132 509.649 -11.8944 504.902 -15.2832C503.698 -16.0981 502.525 -16.8914 501.381 -17.6631C500.204 -18.3579 499.057 -19.0433 497.946 -19.7004C496.828 -20.3396 495.706 -20.8803 494.635 -21.4406C494.295 -21.6111 493.962 -21.7871 493.629 -21.9632C493.405 -22.0664 493.158 -22.2337 492.914 -22.3079L492.13 -22.3319C491.5 -22.3463 490.882 -22.3719 490.271 -22.3906C481.737 -22.6506 475.456 -22.8365 471.146 -22.9647C466.13 -23.0903 461.424 -23.2092 457.699 -23.3088L457.377 -18.1211C464.071 -16.6871 469.734 -13.9351 473.851 -9.95455C477.937 -5.97092 480.524 -1.00134 481.726 4.27301C482.155 6.19688 482.534 7.6642 482.859 8.65586C483.208 9.65003 483.595 10.1718 483.947 10.1889C484.305 10.2005 484.622 9.70074 484.85 8.64766C485.091 7.59583 485.137 5.9862 484.816 3.85057C483.934 -1.98513 481.344 -7.93852 476.726 -12.8297C472.089 -17.7166 465.53 -21.0977 458.111 -22.7969L457.845 -18.5252C461.574 -18.3941 466.279 -18.2259 471.299 -18.0566C475.257 -17.9332 481.351 -17.5745 489.372 -17.144C489.878 -17.1174 490.384 -17.0907 490.902 -17.0629L491.679 -17.0211C491.864 -17.0147 491.79 -17.0099 491.827 -17.0061L491.876 -17.0011C491.876 -17.0011 491.906 -16.9672 492.051 -16.8906C492.287 -16.7615 492.523 -16.6324 492.759 -16.5033C493.23 -16.2451 493.715 -15.9857 494.198 -15.7139C495.186 -15.2117 496.131 -14.5776 497.12 -13.97C497.614 -13.6601 498.115 -13.3556 498.622 -13.0444C499.109 -12.7043 499.602 -12.3574 500.095 -12.0104C504.076 -9.24363 508.128 -5.80154 511.761 -1.4742C512.991 -0.0999016 514.024 1.40902 515.133 2.87617L516.629 5.17427C517.149 5.92597 517.586 6.72498 518.024 7.52399C519.044 9.21093 519.835 11.0478 520.681 12.8965C521.038 13.8482 521.389 14.8054 521.745 15.7694C521.936 16.2465 522.095 16.7389 522.224 17.2344L522.652 18.7191C523.758 22.6971 524.486 26.8472 524.689 30.9872C525.268 39.2601 524.188 47.3027 521.595 53.596C520.323 56.7513 518.723 59.4651 517.055 61.7143C515.399 63.977 513.604 65.6937 512.1 67.0998C511.301 67.7547 510.62 68.3784 509.964 68.8499C509.314 69.3283 508.747 69.7347 508.295 70.066C507.343 70.6745 506.828 71.012 506.828 71.012C504.563 72.4459 502.168 73.7183 499.652 74.7619C498.417 75.3293 497.12 75.7605 495.839 76.249C494.529 76.6666 493.237 77.1292 491.9 77.476C486.584 78.9529 481.067 79.9146 475.469 80.435C469.87 80.9678 464.194 81.1277 458.498 81.0197C455.668 80.9799 452.748 80.8629 449.876 80.7879L443.466 80.595L443.003 62.5921L442.312 36.3457L447.253 36.4884C448.371 36.5214 449.476 36.5532 450.557 36.5825C451.664 36.5896 452.764 36.6023 453.845 36.607C454.926 36.6362 455.999 36.5657 457.058 36.5186C458.117 36.4714 459.157 36.4409 460.183 36.3038C464.297 35.9358 468.223 35.1838 471.806 33.7413C475.381 32.329 478.615 30.1893 480.927 27.3127C483.263 24.4509 484.572 20.9901 485.113 17.5626L485.107 17.5435Z"
          fill="#ffffff7d"
        />
        <path
          d="M628.636 -23.6993C627.184 -18.8428 627.285 -16.1605 628.042 -15.9228C628.842 -15.6623 630.281 -17.7738 631.962 -22.3165C632.638 -23.887 633.321 -25.4753 634.004 -27.076C634.766 -28.6378 635.601 -30.1674 636.401 -31.7501C636.774 -32.5596 637.297 -33.2735 637.749 -34.0441C638.219 -34.8067 638.689 -35.5693 639.159 -36.3442C640.136 -37.8656 641.277 -39.3024 642.347 -40.8329C646.985 -46.6464 652.943 -52.2209 660.978 -56.2732C662.164 -56.858 663.294 -57.4299 664.388 -57.8632C664.934 -58.086 665.445 -58.3372 665.959 -58.5077C666.505 -58.7059 667.026 -58.8943 667.522 -59.0729C671.346 -60.2248 674.355 -60.9339 676.118 -61.4106C673.934 -63.5064 671.794 -65.474 669.883 -67.2824C669.186 -67.9284 668.512 -68.5472 667.857 -69.158C667.344 -69.6307 666.85 -70.0829 666.361 -70.5284C664.423 -72.3023 662.67 -73.9028 660.971 -75.4546C657.579 -78.5637 654.391 -81.516 650.316 -85.4491C645.637 -89.9197 640.194 -95.1915 634.538 -100.708C631.719 -103.468 628.828 -106.285 625.968 -109.08C625.255 -109.784 624.535 -110.481 623.827 -111.178L622.162 -112.794L621.685 -113.251L621.448 -113.485L621.329 -113.596C621.329 -113.596 621.229 -113.582 621.179 -113.574L619.975 -113.307L618.771 -113.039L618.209 -112.911L617.847 -112.812L616.408 -112.413C615.469 -112.125 614.541 -111.799 613.625 -111.483C609.996 -110.12 606.696 -108.327 603.832 -106.317C603.47 -106.075 603.114 -105.827 602.751 -105.585C602.413 -105.316 602.075 -105.06 601.742 -104.797C601.078 -104.271 600.433 -103.761 599.794 -103.257C598.6 -102.165 597.433 -101.133 596.389 -100.089C592.2 -95.9121 589.715 -91.9583 588.256 -89.8302C587.419 -88.5482 586.726 -87.1773 585.979 -85.8305C585.374 -84.7971 584.726 -83.2857 583.896 -81.44C583.006 -79.6129 582.202 -77.3255 581.25 -74.7439C580.735 -73.4664 580.356 -72.0451 579.906 -70.5753C579.47 -69.1166 579.012 -67.5796 578.533 -65.9768C578.075 -64.4398 577.589 -62.8438 577.095 -61.1806C576.51 -59.5576 575.868 -57.8971 575.223 -56.175C572.497 -49.3508 568.288 -42.2319 562.402 -35.9698C559.408 -32.8965 555.985 -30.0708 552.167 -27.712C550.27 -26.5128 548.238 -25.4944 546.165 -24.5358L544.574 -23.8869L543.682 -23.5322L542.028 -22.9949C539.834 -22.265 537.606 -21.6005 535.378 -20.9482C537.479 -18.9228 542.769 -13.8396 547.946 -8.84843C558.695 1.42159 567.391 9.73274 574.278 16.3139C577.724 19.6017 580.706 22.4589 583.266 24.8959C584.545 26.1206 585.724 27.2423 586.789 28.2596C587.504 28.9383 588.182 29.5886 588.831 30.2049C589.29 30.6411 589.73 31.0693 590.165 31.4784C590.225 31.5092 590.263 31.6306 590.333 31.5821L590.528 31.5214L590.916 31.4C591.173 31.3209 591.423 31.2473 591.68 31.1682C592.268 30.9929 592.863 30.812 593.445 30.6299C593.795 30.5294 593.902 30.4845 594.078 30.4158L594.574 30.2373C595.233 29.9887 595.903 29.7784 596.534 29.4836C597.169 29.2079 597.793 28.931 598.422 28.6609C599.028 28.3513 599.628 28.0472 600.221 27.7487C600.826 27.4637 601.379 27.1053 601.948 26.7797C602.506 26.4404 603.075 26.1271 603.615 25.7675C604.143 25.4066 604.671 25.0458 605.193 24.6782C605.714 24.3228 606.23 23.9608 606.71 23.558C610.661 20.5014 613.893 17.0563 616.604 13.478C621.912 6.22945 625.281 -1.35211 627.641 -9.08543C629.982 -17.7176 627.486 -18.3668 624.653 -10.2731C621.847 -2.97477 618.23 4.03719 613.054 10.6126C610.418 13.8522 607.349 16.9427 603.702 19.6652C603.261 20.0225 602.791 20.3458 602.302 20.6612C601.825 20.9777 601.342 21.2998 600.853 21.6275C600.364 21.9428 599.84 22.2174 599.332 22.5247C598.814 22.8184 598.312 23.1325 597.77 23.3867C597.228 23.6533 596.691 23.9266 596.149 24.1932C595.582 24.4326 595.022 24.6789 594.456 24.9183C593.895 25.1768 593.294 25.3632 592.71 25.5823L591.926 25.8676L591.619 25.9541C591.538 25.9767 591.456 26.0117 591.375 26.0221C591.322 25.961 591.262 25.9055 591.197 25.8431C591.138 25.7753 591.072 25.713 591.001 25.6439C590.763 25.4095 590.525 25.175 590.269 24.9326C589.277 23.9473 588.177 22.8646 586.976 21.6788C584.593 19.3031 581.8 16.5207 578.639 13.367C572.304 7.05828 564.428 -0.749007 555.093 -9.75596C553.569 -11.2219 552.04 -12.6822 550.497 -14.1192C549.722 -14.8411 548.954 -15.5562 548.185 -16.2713L547.023 -17.3356L546.438 -17.865L546.152 -18.1291L546.093 -18.1969L546.08 -18.1858C545.995 -18.2192 545.856 -18.289 545.699 -18.4038C545.738 -18.4371 545.802 -18.4924 545.891 -18.5453L545.967 -18.587L545.999 -18.6147C546.055 -18.6276 545.923 -18.5853 546.124 -18.6638L547.66 -19.3245C549.706 -20.224 551.69 -21.272 553.622 -22.4058C557.474 -24.6993 561.024 -27.4687 564.189 -30.5123C570.569 -36.582 575.119 -43.8643 578.252 -50.5296C578.645 -51.368 579.024 -52.1831 579.397 -52.9927C579.782 -53.7886 580.044 -54.6218 580.367 -55.4117C580.671 -56.2096 580.968 -56.9774 581.259 -57.7396C581.549 -58.4895 581.839 -59.2271 582.048 -59.9666C582.944 -62.857 583.728 -65.4 584.382 -67.5108C584.702 -68.5361 584.98 -69.4542 585.229 -70.2516C585.472 -71.0558 585.691 -71.7325 585.911 -72.2669C586.326 -73.3505 586.553 -73.9274 586.553 -73.9274C586.553 -73.9274 586.913 -74.8805 587.564 -76.5958C587.883 -77.4541 588.4 -78.447 588.93 -79.6302C589.472 -80.7999 590.059 -82.1629 590.87 -83.5528C591.663 -84.9629 592.457 -86.5524 593.54 -88.094C594.06 -88.8762 594.582 -89.7077 595.141 -90.5355C595.755 -91.3268 596.369 -92.1428 597.015 -92.9741C599.646 -96.2451 602.871 -99.5547 606.768 -102.326C607.258 -102.666 607.748 -103.018 608.238 -103.358C608.746 -103.69 609.277 -103.983 609.791 -104.296C610.813 -104.953 611.929 -105.476 613.021 -106.04C613.565 -106.331 614.148 -106.538 614.715 -106.789C615.281 -107.041 615.854 -107.274 616.443 -107.474C617.032 -107.674 617.605 -107.919 618.211 -108.074L619.106 -108.335L619.556 -108.463L619.693 -108.499L619.768 -108.516L620.049 -108.58C620.049 -108.58 620.15 -108.619 620.186 -108.591L620.287 -108.5L621.186 -107.636C622.186 -106.681 623.185 -105.726 624.185 -104.771C626.179 -102.867 628.149 -100.979 630.09 -99.1241C637.845 -91.7125 645.023 -84.8481 650.362 -79.7354L660.058 -70.4692L664.909 -65.8388L666.201 -64.6006L666.528 -64.289L666.688 -64.1304L666.765 -64.0422C666.765 -64.0422 666.868 -63.9885 666.806 -63.9824C666.538 -63.9169 666.275 -63.8569 666.012 -63.7723C665.881 -63.73 665.75 -63.7 665.624 -63.6509L664.364 -63.2159C662.387 -62.495 660.461 -61.6636 658.599 -60.7207C649.837 -56.2783 643.471 -50.1019 638.705 -43.7384C637.605 -42.0749 636.447 -40.4915 635.471 -38.8401C634.998 -38.0036 634.537 -37.1659 634.071 -36.3472C633.629 -35.5137 633.115 -34.7247 632.758 -33.8579C631.991 -32.1606 631.199 -30.4904 630.488 -28.8183C629.869 -27.1061 629.256 -25.4116 628.649 -23.7227L628.636 -23.6993Z"
          fill="#ffffff7d"
        />
        <path
          d="M802.514 -15.3488C802.255 -15.1958 802.007 -15.0415 801.766 -14.8928C801.549 -14.7169 801.338 -14.5466 801.127 -14.3886C800.718 -14.059 800.353 -13.7435 800.025 -13.4366C799.347 -12.8622 798.925 -12.2246 798.577 -11.7341C797.906 -10.726 797.767 -10.0473 798.052 -9.74631C798.336 -9.44528 799.049 -9.50277 800.095 -9.96575C801.122 -10.4491 802.552 -11.2442 804.398 -12.2444C807.021 -13.6544 809.918 -14.5046 812.946 -14.4571C815.968 -14.4287 819.104 -13.5352 822.187 -11.9667C825.284 -10.4215 828.323 -8.208 831.307 -5.57939C832.074 -4.95732 832.799 -4.24042 833.549 -3.53337C834.3 -2.82631 835.056 -2.12481 835.791 -1.34509C836.533 -0.583212 837.281 0.197792 838.04 0.980018C838.811 1.80046 839.581 2.63321 840.369 3.474C843.542 6.79592 846.33 9.71378 847.249 10.6669C848.471 9.50436 849.642 8.37379 850.774 7.30107C851.45 6.64598 852.094 6.01856 852.712 5.41328C853.832 4.31467 854.857 3.29906 855.829 2.34008C857.762 0.420855 859.456 -1.25662 861.061 -2.85659C864.282 -6.05529 867.225 -8.94207 871.324 -12.7568C875.09 -16.259 879.375 -20.2465 884.651 -25.148C882.323 -27.679 879.919 -30.2858 877.485 -32.9266C875.549 -35.0343 873.595 -37.1748 871.641 -39.3029C867.678 -43.5833 863.565 -47.6625 859.562 -51.2419C855.558 -54.8213 851.676 -57.875 848.315 -60.2386C844.955 -62.6023 842.135 -64.2555 840.376 -65.2443C839.082 -65.9817 837.73 -66.6323 836.371 -67.2651C833.928 -68.3171 829.349 -70.353 822.893 -71.5648C819.678 -72.1633 815.995 -72.5248 812.042 -72.3075C808.089 -72.1025 803.883 -71.3108 799.735 -69.8205C795.57 -68.3505 791.529 -66.1318 787.746 -63.4108C783.945 -60.6977 780.444 -57.4717 777.195 -53.88C770.655 -46.7565 765.856 -37.4398 764.192 -27.6812C763.028 -20.7913 763.322 -14.3287 764.311 -8.68015C764.594 -7.27211 764.866 -5.90225 765.14 -4.56938C765.488 -3.25365 765.832 -1.98167 766.159 -0.742359C766.511 0.487134 766.934 1.65575 767.302 2.80025C767.423 3.15895 767.539 3.51087 767.654 3.87511C767.737 4.10009 767.806 4.38541 767.92 4.61967L768.477 5.20816C768.928 5.68685 769.367 6.15197 769.793 6.61584C775.826 13.0424 780.259 17.7725 783.306 21.0136C786.845 24.7562 790.171 28.2668 792.804 31.0452L796.812 27.9635C792.968 22.1179 790.866 16.1831 790.764 10.6122C790.693 5.05057 792.433 -0.0427144 795.383 -4.31432C796.459 -5.86269 797.251 -7.08128 797.725 -7.95475C798.188 -8.84177 798.288 -9.47491 798.039 -9.73523C797.797 -10.0134 797.199 -9.92557 796.276 -9.41314C795.334 -8.90874 794.131 -7.90512 792.817 -6.30657C789.226 -1.90838 786.78 3.80608 786.583 10.3363C786.404 16.8746 788.698 23.8804 792.878 30.4219L796.178 27.8806C793.571 25.0801 790.284 21.5362 786.776 17.7659C783.985 14.792 779.805 10.0814 774.28 3.91675C773.937 3.52322 773.582 3.14077 773.227 2.74599C773.05 2.54245 772.878 2.34568 772.695 2.14767L772.63 2.07304L772.618 2.05946L772.6 2.03911L772.571 1.99286C772.56 1.95465 772.567 1.94911 772.518 1.78949C772.441 1.53434 772.365 1.2792 772.289 1.02406C772.137 0.513761 771.972 -0.0101045 771.808 -0.533968C771.455 -1.5842 771.234 -2.67674 770.945 -3.79464C770.807 -4.35297 770.663 -4.91808 770.525 -5.48873C770.419 -6.06241 770.313 -6.64842 770.207 -7.23442C769.321 -11.9262 768.883 -17.1107 769.375 -22.5409C769.472 -24.3248 769.82 -26.0523 770.071 -27.802C770.242 -28.663 770.468 -29.5122 770.651 -30.3719C770.755 -30.7943 770.822 -31.2329 770.95 -31.6528L771.335 -32.9003C771.471 -33.3504 771.606 -33.8006 771.749 -34.2562L771.962 -34.9397L772.224 -35.6059C772.582 -36.4974 772.933 -37.3957 773.292 -38.2995C774.16 -40.036 774.986 -41.8201 776.062 -43.4861C778.128 -46.8639 780.613 -50.0569 783.448 -52.8742C789.006 -58.6378 795.609 -63.0458 802.047 -65.2314C805.252 -66.3473 808.392 -66.944 811.234 -67.1876C814.082 -67.4243 816.641 -67.2573 818.754 -67.0615C819.804 -66.8992 820.758 -66.7838 821.581 -66.6385C822.402 -66.4685 823.107 -66.3166 823.677 -66.203C824.816 -65.9266 825.433 -65.7464 825.433 -65.7464C828.131 -65.0335 830.795 -64.0889 833.388 -62.9289C835.995 -61.8046 838.531 -60.4647 841.007 -59.0135C845.958 -56.074 850.673 -52.6574 855.132 -48.8895C859.598 -45.1271 863.848 -41.0711 867.917 -36.8233C869.947 -34.7246 871.99 -32.507 874.023 -30.3522L878.557 -25.5191L865.83 -13.5742L847.266 3.86467L843.846 0.220832C840.742 -3.12502 837.56 -6.39212 834.303 -9.15357C831.04 -11.9341 827.625 -14.3342 823.966 -16.0355C820.332 -17.7465 816.415 -18.7378 812.637 -18.577C808.86 -18.4407 805.395 -17.1595 802.52 -15.342L802.514 -15.3488Z"
          fill="#ffffff7d"
        />
        <path
          d="M896.677 56.1783C892.472 50.562 890.102 52.1214 893.806 58.0641C895.803 61.2605 897.854 64.5057 900.088 67.9488C901.212 69.6648 902.371 71.4339 903.575 73.2819C904.187 74.2037 904.811 75.1392 905.446 76.1005C906.384 77.5009 907.347 78.9283 908.332 80.3953C911.16 80.1752 914.652 79.9049 918.331 79.6164C932.903 78.2748 936.445 77.3663 946.338 76.6075C950.283 76.2781 954.866 75.9453 959.665 75.6159C965.171 75.2469 970.917 74.8714 976.416 74.5079C976.371 72.4312 976.331 70.3736 976.289 68.3653C976.274 67.0586 976.264 65.7834 976.24 64.5439C976.211 62.0606 976.188 59.7265 976.168 57.6153C976.136 53.3874 976.104 50.0627 976.097 48.2497C976.089 47.2344 976.062 46.2112 976.011 45.1854C975.941 43.7247 975.824 41.2696 975.624 37.068C975.434 32.4407 975.156 25.8808 974.762 16.5443C973.11 15.8322 970.49 14.7066 967.178 13.2881C964.633 12.1823 961.564 10.8503 958.168 9.37371C951.382 6.40262 943.322 2.83217 935.648 -0.631174L920.59 -7.28702L908.681 15.5899C902.014 28.4344 897.278 38.1719 892.865 47.868C890.442 53.195 892.708 54.4827 895.67 49.4639C901.067 40.3317 906.334 30.8955 913.044 18.0739C914.017 16.1995 915.482 13.6143 917.4 10.2338C918.352 8.54299 919.419 6.64715 920.598 4.55866C921.185 3.50486 921.798 2.40427 922.445 1.25138C922.605 0.958381 922.771 0.672173 922.931 0.379174L923.158 -0.0307828L923.19 -0.0584499C923.229 -0.0916589 923.261 -0.119349 923.287 -0.141488C923.328 -0.0939942 923.37 -0.0588179 923.393 -0.031678C923.411 -0.011323 923.369 -0.0341659 923.447 0.00475372C923.636 0.0918888 923.83 0.185811 924.036 0.280978C924.431 0.463279 924.843 0.653604 925.268 0.857508C926.961 1.62938 928.843 2.48842 930.798 3.37956C933.366 4.53711 935.962 5.63551 938.548 6.65879C943.946 8.79622 949.698 11.1738 955.309 13.5432C960.426 15.7326 965.434 17.8738 969.858 19.7702C969.896 20.677 969.934 21.5592 969.968 22.3977C970.02 23.708 970.068 24.9623 970.113 26.1483C970.196 28.5133 970.271 30.6117 970.325 32.349C970.431 35.8235 970.496 37.8836 970.496 37.8836L971.644 70.2257L943.162 72.5864C928.788 73.781 921.87 74.3593 917.621 74.7136C916.076 74.8475 914.562 74.9783 913.141 75.1001C912.433 75.1644 911.745 75.2244 911.087 75.2813C910.882 75.3038 910.689 75.3275 910.509 75.3525C908 71.8258 905.724 68.6321 903.589 65.6259C901.183 62.2952 898.91 59.1945 896.652 56.1758L896.677 56.1783Z"
          fill="#ffffff7d"
        />
        <path
          d="M597.353 122.644C597.321 122.504 597.289 122.377 597.257 122.251C597.244 122.119 597.225 121.994 597.217 121.869C597.19 121.619 597.145 121.373 597.13 121.137C597.142 120.674 597.08 120.228 597.152 119.834C597.166 119.631 597.174 119.434 597.188 119.244C597.226 119.056 597.252 118.879 597.284 118.709C597.309 118.532 597.335 118.368 597.36 118.203C597.403 118.047 597.44 117.896 597.477 117.758C597.581 117.168 597.711 116.711 597.738 116.355C597.759 115.992 597.695 115.726 597.534 115.592C597.372 115.458 597.126 115.446 596.773 115.595C596.421 115.745 595.946 116.025 595.478 116.584C595.361 116.72 595.232 116.868 595.101 117.028C594.983 117.201 594.877 117.388 594.763 117.593C594.65 117.798 594.536 118.016 594.409 118.244C594.325 118.495 594.234 118.752 594.142 119.021C593.929 119.562 593.872 120.194 593.777 120.871C593.751 121.214 593.773 121.563 593.777 121.928C593.782 122.114 593.793 122.295 593.804 122.488C593.833 122.676 593.863 122.865 593.892 123.053C594.23 125.234 595.114 127.216 596.16 129.023C597.211 130.85 598.507 132.441 599.847 134.006C600.54 134.763 601.226 135.537 601.969 136.25C602.694 136.991 603.45 137.693 604.214 138.389C606.437 140.427 606.357 139.961 606.372 140.365L606.178 140.568L606.075 140.656L606.036 140.714L605.816 140.964C605.166 141.727 604.511 142.495 603.849 143.269C602.53 144.824 601.174 146.412 599.79 148.047C597.036 151.318 594.151 154.761 591.092 158.39C591.039 158.459 590.987 158.528 590.935 158.597C590.893 158.704 590.821 158.647 590.749 158.603L590.647 158.537L590.593 158.501L590.436 158.386C589.963 158.022 589.507 157.667 589.058 157.318C587.267 155.881 585.586 154.492 584.085 153.232C581.089 150.744 578.706 148.523 576.579 146.378C574.459 144.226 572.571 142.148 570.769 139.794C568.966 137.44 567.199 134.818 565.521 131.524C562.672 126.008 560.589 118.832 561.413 111.629C561.8 108.05 562.864 104.515 564.515 101.318C566.136 98.0866 568.312 95.2209 570.74 92.6593C573.15 90.1019 575.761 87.9422 578.437 86.2963C581.107 84.6437 583.83 83.5037 586.402 82.7565C591.556 81.2879 595.987 81.181 598.452 81.0971L600.716 81.0547C601.478 81.0269 602.303 80.9683 603.053 80.9146C604.356 80.8117 606.189 80.7257 608.761 80.4177C610.041 80.2631 611.534 80.0435 613.228 79.603C614.909 79.149 616.873 78.4514 618.766 77.0539C619.721 76.3715 620.591 75.5134 621.386 74.5055C622.193 73.4988 622.881 72.2388 623.361 70.7906C623.792 69.3127 623.914 67.6613 623.715 66.0144C623.472 64.3815 622.937 62.7994 622.218 61.3039C620.749 58.3528 618.641 55.7513 616.232 53.2677C615.021 52.0314 613.715 50.8289 612.342 49.6379C611.762 49.14 611.17 48.6408 610.573 48.1224L610.369 47.9657C610.369 47.9657 610.416 47.89 610.436 47.8487L610.482 47.773L610.521 47.7398C610.599 47.6241 610.684 47.5152 610.775 47.4007C611.634 46.3621 612.616 45.1567 613.715 43.8271C615.919 41.1622 618.572 37.9553 621.498 34.4174C622.727 32.9401 624.007 31.3938 625.333 29.8089C625.422 29.5891 625.576 29.7655 625.738 29.8748C626.158 30.2019 626.583 30.5357 627.002 30.8752C627.517 31.2985 628.032 31.7218 628.546 32.1452C629.586 33.0301 630.626 33.915 631.678 34.8134C632.686 35.726 633.732 36.5931 634.714 37.5401C636.729 39.3775 638.622 41.3325 640.459 43.3003C645.38 48.6552 649.092 54.0792 651.459 59.2862C653.851 64.4957 654.862 69.4353 654.88 73.7235C654.892 75.8649 654.675 77.847 654.323 79.6607C653.941 81.4651 653.442 83.0968 652.881 84.5677C651.724 87.4934 650.34 89.759 649.124 91.5222C647.674 93.5955 646.045 95.5022 644.343 97.1975C642.666 98.92 640.881 100.39 639.03 101.668C635.34 104.226 631.36 105.869 627.289 106.841C625.265 107.354 623.199 107.676 621.149 107.925C619.098 108.187 617.04 108.3 614.925 108.475C612.828 108.658 610.774 108.827 608.673 109.096C606.585 109.367 604.46 109.764 602.383 110.511C600.137 111.335 598.693 112.617 597.997 113.623C597.631 114.118 597.458 114.564 597.377 114.896C597.301 115.235 597.335 115.455 597.46 115.585L597.512 115.98C597.512 115.98 597.581 115.956 597.564 115.911L597.502 115.62L597.525 115.647C597.676 115.743 597.911 115.754 598.223 115.675C598.529 115.588 598.908 115.404 599.386 115.193C600.338 114.739 601.633 114.085 603.535 113.523C607.106 112.519 611.21 112.552 615.366 112.373C619.512 112.287 623.989 112.141 628.498 111.183C633.018 110.262 637.627 108.515 641.847 105.69C643.957 104.284 645.989 102.659 647.859 100.771C649.752 98.9093 651.542 96.8519 653.182 94.5195C654.443 92.7053 655.981 90.3192 657.364 87.1505C658.723 83.9916 659.911 80.0051 660.141 75.2657C660.376 70.5454 659.595 65.1096 657.494 59.5894C655.399 54.0636 652.045 48.509 647.728 43.203C644.913 39.7504 641.795 36.5825 638.53 33.709C637.82 33.0617 637.079 32.4421 636.337 31.8226C635.59 31.1962 634.849 30.5643 634.106 29.9694C632.622 28.7549 631.102 27.512 629.495 26.285L627.85 25.0666C627.117 24.5468 626.382 24.064 625.654 23.5757L624.552 22.8515L624.414 22.7571C624.414 22.7571 624.372 22.7096 624.347 22.7194L624.289 22.7692L624.088 23.0147L623.679 23.4866C623.134 24.1117 622.583 24.7423 622.055 25.4124C620.76 27.0067 619.471 28.6077 618.182 30.1965C615.865 33.054 613.555 35.8936 611.31 38.6533C608.565 41.9869 605.898 45.2419 603.342 48.3411C604.974 49.7252 606.582 51.0945 608.154 52.4355C609.17 53.2932 610.065 54.0892 610.977 54.9178C612.759 56.5646 614.335 58.2585 615.621 59.9415C616.907 61.6245 617.87 63.3243 618.363 64.8836C618.862 66.4497 618.875 67.8302 618.525 68.9884C618.181 70.1412 617.474 71.0962 616.739 71.8504C616.004 72.5923 615.273 73.0933 614.621 73.4539C614.292 73.6309 613.978 73.7598 613.725 73.895C613.449 74.003 613.21 74.0901 613.022 74.1576C612.639 74.2981 612.427 74.3508 612.427 74.3508C612.427 74.3508 611.579 74.6668 609.824 74.9587C608.074 75.2574 605.4 75.4871 601.98 75.6718C600.33 75.8013 598.451 75.7838 596.367 75.9311C594.302 76.0864 592.087 76.276 589.776 76.7156C587.47 77.1496 585.078 77.7542 582.68 78.6366C580.293 79.5449 577.933 80.7279 575.674 82.1563C573.397 83.5767 571.322 85.333 569.336 87.2035C568.858 87.687 568.369 88.1693 567.892 88.6528C567.408 89.1418 566.979 89.6673 566.519 90.1835C565.606 91.198 564.733 92.2847 563.915 93.4077C560.623 97.892 558.255 103.218 557.363 108.744C556.428 114.259 557.006 119.823 558.369 124.637C559.73 129.476 561.814 133.597 563.8 136.922C566.849 141.92 570.097 145.843 573.095 149.055C576.105 152.267 578.87 154.824 581.332 156.942C583.751 159.025 585.795 160.778 587.707 162.253C588.445 162.816 589.25 163.405 589.984 163.888C590.358 164.136 590.719 164.371 591.08 164.605C591.261 164.723 591.442 164.84 591.617 164.951L591.882 165.126C591.935 165.187 591.957 165.096 591.989 165.069L592.086 164.961C592.604 164.383 593.102 163.846 593.576 163.294C594.044 162.735 594.492 162.193 594.921 161.68C597.951 158.016 600.812 154.559 603.531 151.259C604.884 149.603 606.205 147.986 607.499 146.405C608.144 145.61 608.781 144.834 609.413 144.05C609.894 143.456 610.375 142.874 610.856 142.292C611.408 141.649 611.811 141.028 612.269 140.406L612.603 139.939L612.773 139.709L612.812 139.651C612.812 139.651 612.777 139.611 612.759 139.603L612.639 139.504L611.681 138.726C611.053 138.223 610.43 137.715 609.72 137.247C609.045 136.795 608.197 136.22 607.987 136.057C607.807 135.927 607.663 135.813 607.49 135.666L606.94 135.19C606.199 134.558 605.47 133.939 604.786 133.282C604.076 132.647 603.423 131.975 602.77 131.315C600.231 128.657 598.02 125.705 597.34 122.642L597.353 122.644Z"
          fill="#ffffff7d"
        />
        <path
          d="M905.025 104.617C908.268 104.859 910.596 104.322 912.04 103.776C913.485 103.218 914.096 102.63 913.988 102.248C913.875 101.834 913.048 101.633 911.568 101.532C910.088 101.432 907.949 101.437 905.199 101.09C901.301 100.546 897.6 98.8219 894.302 96.1306C890.979 93.4615 888.092 90.1067 886.444 86.0736C885.591 84.0759 885.092 81.9036 884.855 79.659C884.811 79.3762 884.81 79.0916 884.791 78.8113L884.765 78.3819C884.753 78.2137 884.742 78.1755 884.744 77.8293L884.721 76.1259L884.719 75.699L884.715 75.4883L884.714 75.383C884.714 75.383 884.66 75.3342 884.63 75.3126L883.93 74.7405C882.703 73.7315 881.458 72.7146 880.202 71.684C876.043 68.2867 871.686 64.7148 867.066 60.9429C856.534 52.4702 849.863 47.284 844.067 42.7681C841.173 40.5013 838.494 38.4047 835.636 36.1662C834.216 35.0387 832.755 33.8637 831.198 32.6293C829.498 31.2445 827.702 29.7881 825.745 28.1977C825.123 27.6892 824.488 27.1794 823.86 26.6641C823.543 26.4031 823.219 26.1476 822.902 25.8866L822.417 25.4971C822.26 25.3947 822.069 25.0968 822.006 25.4122C821.299 26.8311 820.573 28.2789 819.833 29.7502C819.557 30.3098 819.268 30.8681 818.986 31.4332C818.751 31.8856 818.534 32.3461 818.317 32.8189C817.877 33.7577 817.437 34.7089 816.996 35.6723C816.089 37.5967 815.284 39.6241 814.409 41.6632C813.632 43.7491 812.757 45.8252 812.043 48.0104C809.022 56.6477 806.809 66.0723 806.012 75.2136C805.771 77.4901 805.691 79.7582 805.607 81.9703C805.61 84.1911 805.553 86.3687 805.702 88.4868C805.864 92.7217 806.395 96.6971 807.016 100.273C808.309 107.431 810.225 112.92 811.332 115.958C812.064 117.727 812.733 119.527 813.615 121.25C815.072 124.354 818.013 130.052 823.031 136.821C827.985 143.621 835.198 151.311 844.23 158.5C848.74 162.081 853.705 165.603 859.117 168.75C864.529 171.885 870.381 174.712 876.587 176.734C882.775 178.759 889.26 180.148 895.734 180.582C902.208 181.041 908.645 180.711 914.787 179.757C923.446 178.304 930.974 175.938 937.461 173.318C943.967 170.694 949.526 167.937 954.295 165.291C959.059 162.639 963.103 160.191 966.488 157.981C968.177 156.878 969.745 155.88 971.126 154.913C972.385 154.051 973.587 153.227 974.726 152.446C975.311 152.047 975.883 151.648 976.443 151.272C976.723 151.077 976.99 150.894 977.263 150.705L977.365 150.641L977.41 150.603C977.41 150.603 977.386 150.576 977.374 150.562L977.177 150.4L976.782 150.075C970.586 145.073 964.791 140.39 959.289 135.941C954.569 132.184 950.114 128.627 945.831 125.217C937.241 118.42 929.312 112.24 921.415 106.175C917.23 102.954 914.707 101.746 914.2 102.195L913.841 102.66C913.927 102.669 913.953 102.634 913.926 102.551L914.115 102.304C913.794 102.902 915.515 105.137 919.53 108.588C927.094 115.083 934.763 121.583 943.177 128.603C947.401 132.1 951.791 135.737 956.439 139.592C960.436 142.868 964.655 146.321 969.155 150.006C969.179 150.033 969.252 150.065 969.232 150.094L969.118 150.169C969.041 150.223 968.959 150.271 968.882 150.325C968.724 150.426 968.559 150.533 968.375 150.644C967.752 151.051 967.091 151.492 966.405 151.941C965.67 152.399 964.908 152.878 964.109 153.378C963.31 153.879 962.473 154.388 961.61 154.931C960.73 155.442 959.817 155.98 958.867 156.539C956.991 157.672 954.913 158.766 952.724 159.979C948.308 162.308 943.298 164.781 937.627 167.1C931.95 169.413 925.605 171.565 918.574 173.109C913.99 174.085 909.349 174.789 904.705 175.128C899.688 175.491 894.42 175.333 889.129 174.53C883.844 173.734 878.535 172.305 873.465 170.324C863.295 166.354 854.154 160.317 846.718 154.33C843.019 151.319 839.715 148.337 836.93 145.512C836.209 144.826 835.584 144.095 834.931 143.422C834.297 142.733 833.655 142.099 833.101 141.437C831.986 140.105 830.883 138.942 830.009 137.783C828.172 135.531 826.851 133.64 825.932 132.353C825.464 131.712 825.157 131.192 824.924 130.846C824.703 130.502 824.58 130.323 824.58 130.323C824.58 130.323 824.406 130.058 824.074 129.548C823.736 129.043 823.247 128.301 822.669 127.302C822.097 126.31 821.329 125.131 820.59 123.677C820.205 122.964 819.797 122.199 819.366 121.382C818.973 120.556 818.557 119.679 818.113 118.756C816.414 115.064 814.643 110.554 813.269 105.417C811.882 100.291 810.891 94.537 810.529 88.5129C810.162 82.482 810.418 76.1866 811.288 69.9782C812.158 63.7699 813.624 57.653 815.434 51.9049C817.238 46.1501 819.429 40.7747 821.671 35.9489C821.95 35.34 822.221 34.749 822.492 34.158C822.755 33.6342 823.011 33.1159 823.267 32.5975C823.341 32.4504 823.415 32.3033 823.489 32.1562L823.597 31.9321L823.65 31.8262C823.65 31.8262 823.717 31.8639 823.741 31.8787C825.04 32.9321 826.255 33.9276 827.38 34.8335C848.06 51.6349 858.015 59.715 864.132 64.678C868.772 68.4209 873.16 71.9652 877.333 75.339C878.195 76.0327 879.058 76.714 879.896 77.3929L880.01 77.4849C880.039 77.5188 880.024 77.5914 880.028 77.6352L880.046 77.9648L880.114 78.8809C880.149 79.2186 880.154 79.5592 880.209 79.8926C880.539 82.5796 881.21 85.2332 882.305 87.6638C883.393 90.0999 884.804 92.34 886.476 94.2724C888.134 96.2159 889.983 97.8881 891.927 99.3472C893.878 100.801 895.972 102.059 898.199 102.953C900.419 103.852 902.739 104.416 905.025 104.617Z"
          fill="#ffffff7d"
        />
        <path
          d="M750.918 46.3522C758.573 45.1128 758.048 42.2019 750.288 42.8307C744.785 43.2804 739.151 43.7848 733.048 44.4087C730.025 44.6895 726.768 45.1259 723.389 45.6428C721.713 45.9736 719.993 46.3063 718.229 46.653C716.491 47.1076 714.704 47.5695 712.867 48.051C704.656 50.6382 699.911 53.2864 696.03 55.8305C695.542 56.1458 695.048 56.4297 694.589 56.7666C694.13 57.1036 693.684 57.4294 693.232 57.7608C692.779 58.0922 692.333 58.418 691.881 58.7494C691.422 59.074 690.976 59.4122 690.546 59.7953C689.669 60.529 688.754 61.2836 687.788 62.0824C686.875 62.9423 685.905 63.852 684.851 64.846C681.414 68.3136 677.817 72.8473 674.903 78.0873C674.182 79.3997 673.527 80.762 672.822 82.1193L671.901 84.2464L671.143 86.0189L670.767 86.9146L670.671 87.14C670.637 87.2169 670.752 87.2719 670.787 87.3373L671.117 87.7172C673.189 90.148 673.774 90.9743 674.941 92.2247C675.48 92.8052 676.025 93.3924 676.558 93.9661L677.364 94.8272L678.215 95.6373C682.663 100.01 687.456 103.478 691.623 105.93C693.74 107.085 695.626 108.154 697.297 108.862C698.123 109.243 698.869 109.585 699.537 109.887C700.213 110.148 700.803 110.375 701.296 110.567C702.473 110.989 703.633 111.485 704.839 111.786C705.916 112.056 707.431 112.507 709.355 112.95C711.288 113.301 713.602 113.869 716.25 114.138C721.545 114.843 728.159 115.205 735.372 114.644C738.976 114.348 742.752 113.939 746.495 113.441C750.273 112.971 754.175 112.489 758.128 111.999C766.026 111.025 774.134 110.061 781.929 109.176L790.783 108.101L783.832 68.3848C782.917 63.2076 782.054 58.4253 781.215 53.9548C780.206 48.6567 779.256 43.7234 778.358 39.0427C777.183 39.2018 776.013 39.3677 774.857 39.5225C774.285 39.6005 773.725 39.6798 773.16 39.7522L772.158 39.9042C770.883 40.1025 769.638 40.2979 768.4 40.4877C765.929 40.8864 763.533 41.2802 761.131 41.6673C757.912 42.2004 756.344 43.068 756.371 43.7574L756.162 43.8785C756.178 43.9604 756.232 43.9968 756.313 43.9865L756.401 43.9336C756.615 44.6048 758.421 45.054 761.689 44.8105C764.121 44.612 766.559 44.4202 769.065 44.2168C770.318 44.109 771.578 43.9956 772.862 43.8848L773.799 43.8005L774.196 43.7789C774.444 43.7669 774.692 43.755 774.946 43.7375C774.986 44.1188 775.032 44.507 775.072 44.9007C775.222 45.9118 775.385 46.9365 775.54 47.9791C775.876 50.079 776.214 52.2473 776.568 54.4852C777.295 58.9692 778.096 63.7575 778.999 68.9335C779.54 72.0563 780.214 76.7884 781.124 83.0166C781.591 86.1319 782.111 89.6175 782.684 93.4612C782.99 95.3849 783.297 97.4016 783.627 99.4947C783.8 100.545 783.967 101.614 784.139 102.714L784.174 102.921L784.194 103.022C784.194 103.022 784.194 103.022 784.2 103.029L784.188 103.04L784.175 103.051C784.156 103.043 784.138 103.035 784.145 103.03L781.976 103.286L779.639 103.593C778.085 103.806 776.53 104.032 774.993 104.278C768.347 105.323 761.182 106.353 754.181 107.312C747.181 108.247 740.314 109.257 734.418 109.667C732.925 109.732 731.488 109.796 730.119 109.861C728.746 109.883 727.424 109.835 726.182 109.827C725.558 109.819 724.952 109.807 724.371 109.798C723.792 109.751 723.225 109.706 722.683 109.663C721.598 109.578 720.593 109.507 719.687 109.434C717.878 109.225 716.441 108.98 715.451 108.849C714.467 108.724 713.94 108.597 713.94 108.597C713.94 108.597 713.149 108.436 711.726 108.143C711.016 107.972 710.136 107.864 709.147 107.566C708.156 107.292 707.019 106.979 705.772 106.63C704.533 106.238 703.205 105.732 701.766 105.24C700.341 104.699 698.861 104.005 697.293 103.338C696.53 102.939 695.755 102.539 694.955 102.124C694.562 101.917 694.156 101.709 693.75 101.5C693.345 101.28 692.966 101.025 692.561 100.792C691.765 100.303 690.956 99.8127 690.129 99.3144C689.342 98.7582 688.542 98.2008 687.731 97.6298C684.548 95.2904 681.374 92.6116 678.556 89.5299C677.819 88.7994 677.14 88.0068 676.468 87.2087L676.019 86.6931C675.99 86.6345 675.9 86.582 675.902 86.5204L675.984 86.3308C676.272 85.6425 676.553 84.9597 676.834 84.2769C677.253 83.404 677.677 82.5379 678.096 81.6773C681.496 74.8288 686.134 69.4791 689.985 66.0103C690.674 65.3195 691.439 64.7539 692.155 64.1709C692.877 63.607 693.538 63.0123 694.25 62.5279C694.956 62.0367 695.643 61.5744 696.305 61.1097C696.635 60.8835 696.96 60.6628 697.278 60.4353C697.602 60.2269 697.937 60.0445 698.266 59.8552C698.912 59.4754 699.539 59.1123 700.141 58.7589C700.736 58.3988 701.319 58.062 701.917 57.7949C703.091 57.2213 704.169 56.6937 705.173 56.1955C706.216 55.7695 707.166 55.3772 708.059 55.0101C708.945 54.6486 709.751 54.2974 710.546 54.0626C712.1 53.5523 713.403 53.1156 714.525 52.7408C716.263 52.2739 717.957 51.8211 719.607 51.3824C721.285 51.0269 722.919 50.6855 724.521 50.3472C727.753 49.7907 730.809 49.2906 733.861 48.889C739.924 48.0384 745.498 47.1939 750.919 46.3153L750.918 46.3522Z"
          fill="#ffffff7d"
        />
        <path
          d="M737.982 -30.5396C732.593 -21.759 735.084 -20.0835 740.952 -28.4568C749.352 -40.2903 758.232 -52.6566 770.032 -68.2584C772.641 -71.7481 774.923 -74.8132 775.687 -75.8304C774.881 -77.2978 774.104 -78.7065 773.355 -80.069C772.865 -80.9414 772.399 -81.7866 771.937 -82.6005C771.02 -84.2213 770.178 -85.7294 769.382 -87.1339C767.784 -89.9496 766.388 -92.417 765.049 -94.7672C762.377 -99.4733 759.978 -103.75 756.841 -109.622C754.559 -113.881 752.054 -118.576 748.766 -124.711C746.283 -121.568 743.683 -118.287 741.024 -114.933C739.035 -112.394 737 -109.793 734.96 -107.198C730.902 -101.981 726.88 -96.7112 723.186 -91.7852C715.782 -81.9413 709.725 -73.4883 707.149 -69.8716C706.263 -68.6192 705.384 -67.3601 704.534 -66.0671C701.497 -61.4703 693.327 -49.0876 683.61 -33.1569C673.857 -17.2423 662.64 2.27826 652.745 20.6217L648.111 29.3675L703.445 35.6948L705.577 31.7609C716.267 12.1249 724.631 -2.31629 732.934 -16.4668C737.533 -24.208 735.393 -25.7118 730.256 -18.2788C720.982 -4.71547 712.04 9.48774 701.254 29.2067C701.107 29.4763 700.947 29.7693 700.574 30.4365C696.645 29.8955 690.711 29.0892 683.012 28.0357C678.849 27.4833 674.212 26.8642 669.126 26.1934C666.586 25.8675 663.935 25.5304 661.173 25.182C659.899 25.0219 658.595 24.8647 657.266 24.6928C657.254 24.6792 657.249 24.6724 657.249 24.6601C657.249 24.6601 657.268 24.6435 657.281 24.6324C657.3 24.6158 657.307 24.598 657.314 24.5801L658.634 22.0606C659.587 20.2151 660.54 18.3697 661.48 16.5352C669.558 0.629919 679.733 -17.1593 688.132 -30.7743C692.323 -37.592 696.033 -43.3885 698.697 -47.4849C701.385 -51.5665 702.973 -53.9723 702.973 -53.9723C710.404 -65.23 718.082 -76.3204 725.964 -87.254C729.908 -92.7174 733.912 -98.1376 737.97 -103.509L744.095 -111.547L748.245 -116.89L755.104 -104.151L769.991 -76.5323L766.066 -71.3824C754.237 -55.6723 745.682 -42.9328 737.982 -30.5396Z"
          fill="#ffffff7d"
        />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_3622_1083">
        <rect width="1003" height="48" fill="white" />
      </clipPath>
      <clipPath id="clip1_3622_1083">
        <rect
          width="3757.37"
          height="4501.65"
          fill="white"
          transform="matrix(0.17533 -0.151453 0.135277 0.155367 247.785 7.06543)"
        />
      </clipPath>
    </defs>
  </svg>`;
const $fc6840133e04adc0$var$$8f97e278a4a2a6b3$export$cdb81064101cb20c = `data:image/svg+xml;base64,${$fc6840133e04adc0$var$$8f97e278a4a2a6b3$require$Buffer.from($fc6840133e04adc0$var$$8f97e278a4a2a6b3$var$svgStringLearningOverviewCardBackground).toString("base64")}`;
const $fc6840133e04adc0$var$$0fd79bc510e2fa30$export$b7c3a2f69225ecf = ({ ...props })=>{
    return (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
        css: $fc6840133e04adc0$var$$0fd79bc510e2fa30$var$defaultButtonStyles,
        children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $37328c3a94101dc2$export$2e2bcd8739ae039), {
            appearance: "default",
            ...props
        })
    });
};
const $fc6840133e04adc0$var$$0fd79bc510e2fa30$var$defaultButtonStyles = (0, $74Zh5.css)({
    "& button": {
        borderRadius: "4px",
        border: `1px solid ${(0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.border")}`,
        backgroundColor: `transparent`
    }
});
const $fc6840133e04adc0$var$$7586a58445419b5a$export$2c3faa04d4773275 = ({ lessons: lessons, onLessonClick: onLessonClick, expandButtonText: expandButtonText = "Show lessons", collapseButtonText: collapseButtonText = "Hide lessons", containerStyles: customContainerStyles, buttonContainerStyles: customButtonContainerStyles })=>{
    const [isOpened, setIsOpened] = (0, $5FkrB.useState)(false);
    const deviceSize = $fc6840133e04adc0$export$4616d33c54ae5baf();
    const isTablet = deviceSize <= $fc6840133e04adc0$export$62d1d6124a8e4649;
    const toggleLessons = ()=>{
        setIsOpened(!isOpened);
    };
    return (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
        css: [
            $fc6840133e04adc0$var$$7586a58445419b5a$var$wrapperStyles,
            customContainerStyles
        ],
        children: [
            !isTablet && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                css: [
                    $fc6840133e04adc0$var$$7586a58445419b5a$var$buttonContainerStyles,
                    isOpened && $fc6840133e04adc0$var$$7586a58445419b5a$var$buttonContainerOpenStyles,
                    !isOpened && $fc6840133e04adc0$var$$7586a58445419b5a$var$buttonContainerClosedStyles,
                    customButtonContainerStyles
                ],
                children: (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("button", {
                    css: $fc6840133e04adc0$var$$7586a58445419b5a$var$toggleButtonStyles,
                    onClick: toggleLessons,
                    "data-testid": "toggle-lessons-button",
                    children: [
                        isOpened ? collapseButtonText : expandButtonText,
                        (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$export$f04a61298a47a40f, {
                            size: "large",
                            type: isOpened ? "chevron-up" : "chevron-down",
                            color: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.text.brand")
                        })
                    ]
                })
            }),
            isOpened && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                css: $fc6840133e04adc0$var$$7586a58445419b5a$var$lessonsContentWrapperStyles,
                children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$export$c3b0ae23c563b692, {
                    lessons: lessons,
                    onLessonClick: onLessonClick,
                    isStandalone: false,
                    isTablet: isTablet
                })
            }),
            isTablet && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                css: [
                    $fc6840133e04adc0$var$$7586a58445419b5a$var$buttonContainerStyles,
                    isOpened && $fc6840133e04adc0$var$$7586a58445419b5a$var$buttonContainerOpenStyles,
                    !isOpened && $fc6840133e04adc0$var$$7586a58445419b5a$var$buttonContainerClosedStyles,
                    $fc6840133e04adc0$var$$7586a58445419b5a$var$buttonContainerMobileStyles,
                    customButtonContainerStyles
                ],
                children: (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("button", {
                    css: [
                        $fc6840133e04adc0$var$$7586a58445419b5a$var$toggleButtonStyles,
                        $fc6840133e04adc0$var$$7586a58445419b5a$var$toggleButtonMobileStyles
                    ],
                    onClick: toggleLessons,
                    "data-testid": "toggle-lessons-button-mobile",
                    children: [
                        isOpened ? collapseButtonText : expandButtonText,
                        (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$export$f04a61298a47a40f, {
                            size: "large",
                            type: isOpened ? "chevron-up" : "chevron-down",
                            color: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.text.brand")
                        })
                    ]
                })
            })
        ]
    });
};
const $fc6840133e04adc0$var$$7586a58445419b5a$var$wrapperStyles = (0, $74Zh5.css)({
    overflow: "hidden",
    maxWidth: "100%"
});
const $fc6840133e04adc0$var$$7586a58445419b5a$var$buttonContainerStyles = (0, $74Zh5.css)({
    display: "flex",
    alignItems: "center",
    gap: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.200"),
    alignSelf: "stretch",
    padding: `${(0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.150")} ${(0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.300")}`,
    borderTop: `1px solid ${(0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.border")}`
});
const $fc6840133e04adc0$var$$7586a58445419b5a$var$toggleButtonStyles = (0, $74Zh5.css)({
    color: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.text.brand"),
    fontFamily: "Charlie Text",
    fontSize: "16px",
    fontStyle: "normal",
    fontWeight: 600,
    background: "none",
    border: "none",
    cursor: "pointer",
    padding: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.0"),
    display: "flex",
    alignItems: "center",
    gap: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.050"),
    "&:hover": {
        textDecoration: "underline",
        textUnderlineOffset: "4px"
    }
});
const $fc6840133e04adc0$var$$7586a58445419b5a$var$toggleButtonMobileStyles = (0, $74Zh5.css)({
    color: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.text.brand"),
    textAlign: "center",
    fontFamily: "Charlie Text",
    fontSize: "14px",
    fontStyle: "normal",
    fontWeight: 600,
    lineHeight: "20px"
});
const $fc6840133e04adc0$var$$7586a58445419b5a$var$buttonContainerOpenStyles = (0, $74Zh5.css)({
    borderBottom: `1px solid ${(0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.border")}`
});
const $fc6840133e04adc0$var$$7586a58445419b5a$var$lessonsContentWrapperStyles = (0, $74Zh5.css)({
    overflow: "hidden",
    backgroundColor: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.background.neutral")
});
const $fc6840133e04adc0$var$$7586a58445419b5a$var$buttonContainerClosedStyles = (0, $74Zh5.css)({
    justifyContent: "space-between"
});
const $fc6840133e04adc0$var$$7586a58445419b5a$var$buttonContainerMobileStyles = (0, $74Zh5.css)({
    padding: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.150"),
    justifyContent: "space-between",
    [(0, $0bc19dfefbafca8c$export$987d49ffe1b0900f).below.md]: {
        borderTop: `1px solid ${(0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.border")}`
    }
});
const $fc6840133e04adc0$var$$bde17c0708419ffe$var$CompletedIcon = ()=>{
    return (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("path", {
                d: "M15.8203 7.04186L15.8028 7.03662L6.61914 16.5773L6.62525 16.5939L21.6161 21.8224L15.8203 7.04186Z",
                fill: "#1868DB"
            }),
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M5.31618 3.19751L10.3213 7.04536L5.25684 6.23896L5.28564 4.75358L5.31618 3.19751Z",
                fill: "#FCA700"
            }),
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("path", {
                d: "M14.6344 9.49606H12.8924L11.1836 4.41504H12.9256L14.6344 9.49606Z",
                fill: "#BF63F3"
            }),
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("path", {
                d: "M9.40688 15.4488L9.37982 15.3764C9.22448 14.9662 8.95742 14.6153 8.60659 14.3631C8.24877 14.1057 7.82811 13.9695 7.39001 13.9695C6.9519 13.9695 6.53211 14.1057 6.17342 14.3631C5.82259 14.6153 5.55553 14.9662 5.40019 15.3764L5.37313 15.4488H3.82666L3.85808 15.3118C4.04397 14.5054 4.49255 13.774 5.12179 13.253C5.43684 12.9921 5.78855 12.7896 6.16644 12.6491C6.5583 12.5042 6.96935 12.4309 7.38913 12.4309C7.80891 12.4309 8.21997 12.5042 8.61182 12.6491C8.99059 12.7887 9.34142 12.9921 9.65648 13.253C10.2857 13.774 10.7352 14.5054 10.9202 15.3118L10.9516 15.4488H9.40513H9.40688Z",
                fill: "#1868DB"
            }),
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("path", {
                d: "M6.51602 10.2929C6.56926 10.2475 6.62075 10.1943 6.66962 10.1349C6.71849 10.0756 6.76126 10.0127 6.79617 9.94989C7.00126 9.58073 6.94017 9.19935 6.66787 8.89215C6.62162 8.83978 6.56926 8.78916 6.51078 8.74204C6.45231 8.69491 6.38773 8.64953 6.32402 8.61287C5.96707 8.40866 5.5822 8.42436 5.26278 8.69666C5.20867 8.74291 5.15631 8.79615 5.10657 8.85724C5.05769 8.91746 5.0158 8.97855 4.98177 9.03964C4.77755 9.40618 4.83951 9.78669 5.11093 10.0965C5.15893 10.1515 5.21304 10.2039 5.27413 10.2536C5.33522 10.3033 5.39195 10.3426 5.45304 10.3775C5.80911 10.5835 6.19486 10.5678 6.51515 10.2929H6.51602Z",
                fill: "#BF63F3"
            }),
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("path", {
                d: "M13.6186 12.9931C13.6718 12.9477 13.7233 12.8945 13.7722 12.8351C13.821 12.7758 13.8638 12.7129 13.8987 12.6501C14.1038 12.2809 14.0427 11.8995 13.7704 11.5923C13.7242 11.54 13.6718 11.4894 13.6133 11.4422C13.5548 11.3951 13.4903 11.3497 13.4266 11.3131C13.0696 11.1089 12.6847 11.1246 12.3653 11.3969C12.3112 11.4431 12.2589 11.4963 12.2091 11.5574C12.1594 11.6185 12.1183 11.6787 12.0843 11.7398C11.8801 12.1064 11.942 12.4869 12.2135 12.7967C12.2615 12.8517 12.3156 12.9041 12.3767 12.9538C12.4378 13.0035 12.4945 13.0428 12.5556 13.0777C12.9117 13.2837 13.2974 13.268 13.6177 12.9931H13.6186Z",
                fill: "#292A2E"
            }),
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("path", {
                d: "M9.3788 15.3765L9.40586 15.449H10.9523L10.9209 15.3119C10.7446 14.5439 10.3283 13.844 9.74535 13.3291L8.68848 14.4279C8.99829 14.674 9.23655 14.9995 9.3788 15.3765Z",
                fill: "#292A2E"
            }),
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("path", {
                d: "M14.6342 9.4961L14.3235 8.57275L13.4351 9.4961H14.6342Z",
                fill: "#292A2E"
            }),
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("path", {
                d: "M9.68084 8.91065L8.87305 10.5713L10.5337 11.3791L11.3415 9.71844L9.68084 8.91065Z",
                fill: "#FCA700"
            }),
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("path", {
                d: "M2.55684 10.4918C2.52717 10.4718 2.49924 10.4726 2.48004 10.4752C2.46084 10.4787 2.45037 10.4883 2.44601 10.5014C2.43728 10.5285 2.45561 10.5599 2.49051 10.5896C2.54113 10.6323 2.57255 10.6934 2.59786 10.7763C2.62491 10.8592 2.63888 10.9605 2.69648 11.0818C2.72964 11.1499 2.77764 11.2014 2.8239 11.2345C2.8719 11.2686 2.91641 11.2834 2.95742 11.2947C3.03946 11.3148 3.12062 11.3104 3.2175 11.2764C3.37982 11.2153 3.52557 11.0539 3.66346 11.0259C3.72804 11.0111 3.79001 11.0294 3.83277 11.0565C3.87291 11.0835 3.89648 11.1115 3.90608 11.1324C3.91306 11.1438 3.92004 11.1542 3.92702 11.1673C3.94011 11.1883 3.96106 11.2336 3.98462 11.3052C4.00993 11.3759 4.03088 11.4763 4.09982 11.5897C4.13473 11.6464 4.19059 11.6997 4.25691 11.7355C4.32324 11.7686 4.3983 11.787 4.47771 11.7843C4.55713 11.7782 4.62957 11.7486 4.68979 11.7136C4.75088 11.6787 4.80062 11.6395 4.8495 11.6046C4.9839 11.4998 5.07815 11.4675 5.15582 11.492C5.23611 11.512 5.27539 11.5548 5.29808 11.5897C5.35393 11.6744 5.3775 11.7878 5.41851 11.8908C5.45517 11.9938 5.52324 12.1029 5.6271 12.1552C5.6847 12.1823 5.72048 12.1666 5.72746 12.1456C5.73531 12.1221 5.71873 12.0924 5.68295 12.0662C5.61924 12.0147 5.58433 11.9406 5.55815 11.8437C5.52848 11.7494 5.51626 11.6307 5.43335 11.499C5.40281 11.4501 5.33561 11.3646 5.21255 11.3253C5.15321 11.3035 5.07466 11.2965 4.99524 11.3139C4.91495 11.3314 4.84426 11.3742 4.77968 11.4178C4.73691 11.4475 4.70026 11.478 4.66535 11.5077C4.62782 11.54 4.58942 11.567 4.55015 11.588C4.51088 11.6054 4.47161 11.6176 4.43146 11.6142C4.41139 11.6142 4.39044 11.608 4.37037 11.6037C4.35204 11.5941 4.33022 11.5915 4.31539 11.5784C4.28048 11.56 4.25779 11.5286 4.2351 11.4981C4.19495 11.4318 4.17575 11.355 4.15917 11.3017C4.14346 11.2467 4.13299 11.2127 4.13299 11.2127C4.13299 11.2127 4.12862 11.2005 4.12164 11.1778C4.11204 11.1542 4.1007 11.1211 4.07801 11.08C4.05706 11.039 4.02215 10.9902 3.97066 10.9491C3.9183 10.9072 3.85197 10.8802 3.77953 10.8671C3.70448 10.8566 3.62331 10.8697 3.55611 10.9003C3.48717 10.9299 3.43306 10.971 3.38157 11.0076C3.28208 11.0844 3.19655 11.1411 3.13197 11.156C3.03684 11.176 2.95917 11.1411 2.91902 11.1088C2.87801 11.0739 2.85706 11.0382 2.84222 11.0094C2.79859 10.9212 2.77677 10.8191 2.74011 10.7266C2.70433 10.6341 2.64499 10.5416 2.55684 10.4927V10.4918Z",
                fill: "#292A2E"
            }),
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("path", {
                d: "M8.03289 2.23406C8.01543 2.20352 7.99012 2.19043 7.97267 2.18432C7.95434 2.17908 7.9395 2.18257 7.93078 2.19217C7.9107 2.21224 7.91245 2.2489 7.93078 2.29079C7.95609 2.35188 7.95609 2.42083 7.94125 2.50635C7.92729 2.59275 7.89412 2.68875 7.88976 2.82315C7.88801 2.89821 7.90721 2.96715 7.93339 3.01777C7.96045 3.07014 7.99361 3.1033 8.02503 3.1321C8.08961 3.18708 8.16292 3.22112 8.26416 3.23421C8.43609 3.25341 8.63943 3.17574 8.77558 3.21414C8.84016 3.23072 8.88641 3.27523 8.9126 3.31886C8.93616 3.36163 8.94401 3.39654 8.94314 3.4201C8.94401 3.43319 8.94576 3.44628 8.94576 3.46024C8.94838 3.48468 8.94576 3.5353 8.93354 3.60948C8.92394 3.68454 8.89601 3.78315 8.90649 3.91494C8.91172 3.98126 8.9379 4.0537 8.97979 4.11566C9.0243 4.17588 9.0819 4.22563 9.15434 4.25966C9.22852 4.29021 9.3062 4.29719 9.37514 4.2937C9.44583 4.29021 9.5078 4.27799 9.56714 4.27014C9.73383 4.23872 9.83332 4.25268 9.89092 4.31028C9.95376 4.36439 9.9686 4.42024 9.97296 4.46214C9.9843 4.5625 9.95376 4.67421 9.94329 4.78504C9.92932 4.89326 9.9398 5.02155 10.0087 5.11581C10.0471 5.16555 10.0873 5.16904 10.1021 5.15246C10.1196 5.13501 10.1187 5.10097 10.0986 5.0617C10.0646 4.98664 10.0681 4.90461 10.089 4.80686C10.1056 4.70912 10.1493 4.59828 10.1353 4.44294C10.1309 4.38621 10.11 4.27886 10.0183 4.1881C9.97558 4.14184 9.90838 4.09995 9.82983 4.07901C9.75041 4.05806 9.66838 4.0633 9.58983 4.07377C9.53834 4.08075 9.49121 4.09123 9.4467 4.1017C9.3987 4.11304 9.35245 4.12003 9.30794 4.1209C9.26518 4.11828 9.22503 4.1113 9.19012 4.09035C9.17267 4.08075 9.15696 4.06592 9.14125 4.05283C9.1299 4.03624 9.1107 4.02315 9.10372 4.00483C9.08103 3.97254 9.07492 3.93414 9.06881 3.89661C9.06358 3.81894 9.08016 3.74214 9.09063 3.68715C9.10198 3.6313 9.10809 3.59552 9.10809 3.59552C9.10809 3.59552 9.10983 3.58243 9.11332 3.55886C9.11507 3.53355 9.12118 3.49952 9.11943 3.45239C9.11943 3.40614 9.1107 3.34679 9.08365 3.28657C9.0566 3.22548 9.00947 3.17137 8.951 3.12599C8.88903 3.08235 8.81049 3.05704 8.7363 3.05355C8.66125 3.04832 8.59405 3.06054 8.53209 3.07014C8.40816 3.09283 8.30692 3.10504 8.24234 3.08934C8.14896 3.06403 8.09572 2.9977 8.0739 2.9497C8.05296 2.89908 8.05034 2.85894 8.05121 2.82577C8.05209 2.72715 8.08001 2.62679 8.08874 2.5273C8.09921 2.42868 8.08874 2.31872 8.03201 2.23581L8.03289 2.23406Z",
                fill: "#292A2E"
            })
        ]
    });
};
var $fc6840133e04adc0$var$$bde17c0708419ffe$export$2e2bcd8739ae039 = $fc6840133e04adc0$var$$bde17c0708419ffe$var$CompletedIcon;
const $fc6840133e04adc0$var$$b16d92af3081158f$var$QuestionIcon = ()=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12ZM14.8284 7.15997C15.3505 7.67945 15.7181 8.3338 15.89 9.04999C16.1223 10.008 15.9918 11.0181 15.5235 11.8856C15.0552 12.7531 14.2824 13.4165 13.354 13.748C13.149 13.821 13.004 14.003 13.004 14.22V15.002C13.004 15.2677 12.8984 15.5226 12.7105 15.7105C12.5226 15.8984 12.2677 16.004 12.002 16.004C11.7363 16.004 11.4814 15.8984 11.2935 15.7105C11.1056 15.5226 11 15.2677 11 15.002V12.988C11.0034 12.725 11.1103 12.474 11.2975 12.2893C11.4846 12.1046 11.7369 12.001 11.9998 12.001H11.993C13.098 12.001 13.996 11.103 13.996 10.001C13.984 9.47739 13.7676 8.97927 13.3929 8.61327C13.0183 8.24727 12.5153 8.04248 11.9915 8.04275C11.4678 8.04301 10.9649 8.2483 10.5907 8.61467C10.2164 8.98104 10.0004 9.47937 9.989 10.003C9.987 10.554 9.539 11.001 8.987 11.001C8.74019 10.9995 8.50281 10.906 8.32123 10.7388C8.13964 10.5717 8.02689 10.3428 8.005 10.097L8 9.94999C8.017 7.44599 10.321 5.51399 12.933 6.10799C13.6501 6.27628 14.3063 6.64048 14.8284 7.15997ZM13 18C13 18.5523 12.5523 19 12 19C11.4477 19 11 18.5523 11 18C11 17.4477 11.4477 17 12 17C12.5523 17 13 17.4477 13 18Z",
            fill: "#44546F"
        })
    });
var $fc6840133e04adc0$var$$b16d92af3081158f$export$2e2bcd8739ae039 = $fc6840133e04adc0$var$$b16d92af3081158f$var$QuestionIcon;
const $fc6840133e04adc0$var$$c68bccd399b510db$var$STATUS_LABELS = {
    [$fc6840133e04adc0$var$$035f8a623e403361$export$23d03d0b3065d061.NOT_STARTED]: "Not started",
    [$fc6840133e04adc0$var$$035f8a623e403361$export$23d03d0b3065d061.COMPLETED]: "Complete!"
};
const $fc6840133e04adc0$var$$c68bccd399b510db$export$cee724c49a9ffe54 = ({ isRetired: isRetired, progress: progress, status: status })=>{
    if (isRetired) return (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$export$71f050e2efa708bb, {
        size: "medium",
        fontWeight: "semibold",
        children: (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("span", {
            css: $fc6840133e04adc0$var$$c68bccd399b510db$var$progressStyles,
            children: [
                (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("span", {
                    children: "Retired content"
                }),
                (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$var$$b16d92af3081158f$export$2e2bcd8739ae039, {})
            ]
        })
    });
    if (status === $fc6840133e04adc0$var$$035f8a623e403361$export$23d03d0b3065d061.NOT_STARTED) return (0, $6bec4f26b2cb3094$export$25062201e9e25d76)((0, $6bec4f26b2cb3094$export$ffb0004e005737fa), {
        children: [
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$export$71f050e2efa708bb, {
                size: "medium",
                fontWeight: "semibold",
                children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("span", {
                    css: (0, $74Zh5.css)({
                        color: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.text.subtle")
                    }),
                    children: $fc6840133e04adc0$var$$c68bccd399b510db$var$STATUS_LABELS[$fc6840133e04adc0$var$$035f8a623e403361$export$23d03d0b3065d061.NOT_STARTED]
                })
            }),
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$export$c17561cb55d4db30, {
                progress: 0
            })
        ]
    });
    if (status === $fc6840133e04adc0$var$$035f8a623e403361$export$23d03d0b3065d061.COMPLETED) return (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$export$71f050e2efa708bb, {
        size: "medium",
        fontWeight: "semibold",
        children: (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("span", {
            css: $fc6840133e04adc0$var$$c68bccd399b510db$var$progressStyles,
            children: [
                (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("span", {
                    children: "Progress"
                }),
                (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("span", {
                    css: (0, $74Zh5.css)({
                        color: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.text.accent.lime")
                    }),
                    children: $fc6840133e04adc0$var$$c68bccd399b510db$var$STATUS_LABELS[$fc6840133e04adc0$var$$035f8a623e403361$export$23d03d0b3065d061.COMPLETED]
                }),
                (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$var$$bde17c0708419ffe$export$2e2bcd8739ae039, {})
            ]
        })
    });
    return (0, $6bec4f26b2cb3094$export$25062201e9e25d76)((0, $6bec4f26b2cb3094$export$ffb0004e005737fa), {
        children: [
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$export$71f050e2efa708bb, {
                size: "medium",
                fontWeight: "semibold",
                children: (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("span", {
                    css: $fc6840133e04adc0$var$$c68bccd399b510db$var$progressStyles,
                    children: [
                        (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("span", {
                            children: "Progress"
                        }),
                        (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("span", {
                            css: (0, $74Zh5.css)({
                                color: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.text.subtle")
                            }),
                            children: [
                                progress,
                                "%"
                            ]
                        })
                    ]
                })
            }),
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$export$c17561cb55d4db30, {
                progress: progress,
                color: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.icon.accent.lime")
            })
        ]
    });
};
const $fc6840133e04adc0$var$$c68bccd399b510db$var$progressStyles = (0, $74Zh5.css)({
    display: "flex",
    alignItems: "center",
    gap: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.100")
});
const $fc6840133e04adc0$var$$e9cd1e314d8acc99$export$aa140c19feb5d492 = ({ title: title, href: href, isRetired: isRetired = false, onTitleClick: onTitleClick })=>{
    const handleClick = (e)=>{
        if (onTitleClick) {
            e.preventDefault();
            onTitleClick();
        }
    };
    const handleKeyboardClick = (0, $5FkrB.useCallback)(()=>{
        if (onTitleClick) onTitleClick();
    }, [
        onTitleClick
    ]);
    const onKeyDown = $fc6840133e04adc0$export$2a0b6757d41dacb2(handleKeyboardClick);
    if (isRetired) return (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
        role: "button",
        tabIndex: 0,
        css: $fc6840133e04adc0$var$$e9cd1e314d8acc99$var$titleContainerStyles,
        onClick: handleClick,
        onKeyDown: onKeyDown,
        children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$export$a8a3e93435678ff9, {
            level: 4,
            color: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.text.subtlest"),
            children: title
        })
    });
    return (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
        css: $fc6840133e04adc0$var$$e9cd1e314d8acc99$var$titleContainerStyles,
        children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$export$a6c7ac8248d6e38a, {
            label: title,
            link: href || "#",
            size: $fc6840133e04adc0$export$be4c932f76c19adf.EXTRA_LARGE,
            style: $fc6840133e04adc0$export$2b77966d73aefa77.SEMIBOLD,
            icon: "arrow-right-small",
            onClick: handleClick
        })
    });
};
const $fc6840133e04adc0$var$$e9cd1e314d8acc99$var$titleContainerStyles = (0, $74Zh5.css)({
    display: "flex",
    alignItems: "center",
    "& *": {
        fontFamily: "Charlie Display, sans-serif"
    },
    "& a:hover": {
        textDecoration: "none"
    },
    "& a span:last-of-type": {
        verticalAlign: "text-bottom"
    },
    [(0, $0bc19dfefbafca8c$export$987d49ffe1b0900f).below.sm]: {
        "& a span:last-of-type": {
            verticalAlign: "bottom"
        }
    }
});
const $fc6840133e04adc0$export$60e8035fadc9b8fc = ({ course: course, lessons: lessons, onLessonClick: onLessonClick, progress: progress, type: type, isSaved: isSaved, isRetired: isRetired, onSave: onSave, tags: tags, status: status, onDownloadPdf: onDownloadPdf, completionBadgeUrl: completionBadgeUrl, dropdownItems: dropdownItems, onTitleClick: onTitleClick, showSaveButton: showSaveButton = true })=>{
    const typeText = (0, $5FkrB.useMemo)(()=>{
        switch(type){
            case $fc6840133e04adc0$export$e2e108cbe2e4f865.COURSE:
                return "Course";
            case $fc6840133e04adc0$export$e2e108cbe2e4f865.LESSON:
                return "Lesson";
            default:
                return "Learning Path";
        }
    }, [
        type
    ]);
    const getBackgroundColor = (0, $5FkrB.useMemo)(()=>{
        if (isRetired) return "#8C8F97"; // neutral 500
        switch(type){
            case $fc6840133e04adc0$export$e2e108cbe2e4f865.COURSE:
                return "#357DE8"; // blue 600
            case $fc6840133e04adc0$export$e2e108cbe2e4f865.LESSON:
                return "#FCA700"; // yellow 400
            default:
                return "#6A9A23"; // lime 600
        }
    }, [
        isRetired,
        type
    ]);
    const expandableTextLabels = (0, $5FkrB.useMemo)(()=>{
        switch(type){
            case $fc6840133e04adc0$export$e2e108cbe2e4f865.COURSE:
                return {
                    expandButtonText: "Show lessons",
                    collapseButtonText: "Hide lessons"
                };
            default:
                return {
                    expandButtonText: "Show courses",
                    collapseButtonText: "Hide courses"
                };
        }
    }, [
        type
    ]);
    const handleSave = ()=>{
        onSave?.(!isSaved);
    };
    const showCourseList = !isRetired && lessons.length > 0;
    const isCompleted = progress === 100;
    return (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
        css: $fc6840133e04adc0$var$$8340d81aba797956$var$containerStyles,
        children: [
            (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                css: $fc6840133e04adc0$var$$8340d81aba797956$var$topControlsStyles,
                style: {
                    backgroundColor: getBackgroundColor
                },
                children: [
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                        css: (0, $74Zh5.css)({
                            flexShrink: 0
                        }),
                        children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$export$71f050e2efa708bb, {
                            size: "medium",
                            color: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.text.inverse"),
                            fontWeight: "semibold",
                            children: typeText
                        })
                    }),
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                        css: $fc6840133e04adc0$var$$8340d81aba797956$var$headerImageStyles,
                        style: {
                            backgroundImage: `url(${$fc6840133e04adc0$var$$8f97e278a4a2a6b3$export$cdb81064101cb20c})`
                        }
                    }),
                    isCompleted && completionBadgeUrl && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                        css: $fc6840133e04adc0$var$$8340d81aba797956$var$badgeOuterContainerStyles,
                        children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                            css: $fc6840133e04adc0$var$$8340d81aba797956$var$badgeInnerContainerStyles,
                            children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$export$3e431a229df88919, {
                                src: completionBadgeUrl,
                                alt: "Completion Badge",
                                width: 48,
                                height: 48
                            })
                        })
                    }),
                    showSaveButton && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$export$dd09d7da2da4d16f, {
                        icon: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$export$f04a61298a47a40f, {
                            type: isSaved ? "bookmark-narrow-filled" : "bookmark-narrow",
                            color: "#FFFFFF"
                        }),
                        ariaLabel: isSaved ? "Saved" : "Save",
                        onClick: handleSave,
                        selected: isSaved
                    }),
                    Boolean(dropdownItems?.length) && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$export$ef4a0fdddd7eccb7, {
                        items: dropdownItems,
                        isInverted: true
                    })
                ]
            }),
            (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                css: $fc6840133e04adc0$var$$8340d81aba797956$var$contentStyles,
                children: [
                    (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                        css: $fc6840133e04adc0$var$$8340d81aba797956$var$leftColumnStyles,
                        children: [
                            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                                css: $fc6840133e04adc0$var$$8340d81aba797956$var$tagsContainerStyles,
                                children: tags.map((tag)=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$export$3288d34c523a1192, {
                                        label: tag.label
                                    }, tag.label))
                            }),
                            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$var$$e9cd1e314d8acc99$export$aa140c19feb5d492, {
                                title: course.title,
                                href: course.href,
                                isRetired: isRetired,
                                onTitleClick: onTitleClick
                            })
                        ]
                    }),
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                        css: $fc6840133e04adc0$var$$8340d81aba797956$var$rightColumnStyles,
                        children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$var$$c68bccd399b510db$export$cee724c49a9ffe54, {
                            isRetired: isRetired,
                            progress: progress,
                            status: status
                        })
                    })
                ]
            }),
            onDownloadPdf && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                css: $fc6840133e04adc0$var$$8340d81aba797956$var$downloadPdfLinkStyles,
                children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$var$$0fd79bc510e2fa30$export$b7c3a2f69225ecf, {
                    appearance: $fc6840133e04adc0$export$261c9483fc4a455a.DEFAULT,
                    iconBefore: (0, (/*@__PURE__*/$parcel$interopDefault($6KNbq))),
                    onClick: onDownloadPdf,
                    children: "Download completion pdf"
                })
            }),
            showCourseList && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$var$$7586a58445419b5a$export$2c3faa04d4773275, {
                lessons: lessons,
                onLessonClick: onLessonClick,
                expandButtonText: expandableTextLabels.expandButtonText,
                collapseButtonText: expandableTextLabels.collapseButtonText,
                containerStyles: $fc6840133e04adc0$var$$8340d81aba797956$var$expandableLessonsListContainerStyles,
                buttonContainerStyles: $fc6840133e04adc0$var$$8340d81aba797956$var$expandableLessonsListButtonContainerStyles
            })
        ]
    });
};
const $fc6840133e04adc0$var$$8340d81aba797956$var$containerStyles = (0, $74Zh5.css)({
    display: "flex",
    flexDirection: "column",
    borderRadius: "8px",
    border: `1px solid ${(0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.border")}`,
    boxShadow: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("elevation.shadow.raised"),
    overflow: "hidden"
});
const $fc6840133e04adc0$var$$8340d81aba797956$var$topControlsStyles = (0, $74Zh5.css)({
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: `0 ${(0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.250")}`
});
const $fc6840133e04adc0$var$$8340d81aba797956$var$contentStyles = (0, $74Zh5.css)({
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.250"),
    flexWrap: "wrap",
    rowGap: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.400")
});
const $fc6840133e04adc0$var$$8340d81aba797956$var$leftColumnStyles = (0, $74Zh5.css)({
    display: "flex",
    flexDirection: "column",
    gap: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.150")
});
const $fc6840133e04adc0$var$$8340d81aba797956$var$rightColumnStyles = (0, $74Zh5.css)({
    display: "flex",
    flexDirection: "column",
    gap: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.100"),
    minWidth: "234px",
    alignSelf: "flex-end"
});
const $fc6840133e04adc0$var$$8340d81aba797956$var$tagsContainerStyles = (0, $74Zh5.css)({
    display: "flex",
    gap: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.100")
});
const $fc6840133e04adc0$var$$8340d81aba797956$var$expandableLessonsListContainerStyles = (0, $74Zh5.css)({
    border: "none",
    borderRadius: "0"
});
const $fc6840133e04adc0$var$$8340d81aba797956$var$expandableLessonsListButtonContainerStyles = (0, $74Zh5.css)({
    paddingLeft: `${(0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.250")} !important`
});
const $fc6840133e04adc0$var$$8340d81aba797956$var$headerImageStyles = (0, $74Zh5.css)({
    display: "flex",
    flexGrow: 1,
    backgroundRepeat: "no-repeat",
    backgroundPosition: "right",
    backgroundSize: "cover",
    minHeight: "48px",
    width: "100%"
});
const $fc6840133e04adc0$var$$8340d81aba797956$var$downloadPdfLinkStyles = (0, $74Zh5.css)({
    padding: `${(0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.150")} 0 ${(0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.250")} ${(0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.250")}`
});
const $fc6840133e04adc0$var$$8340d81aba797956$var$badgeOuterContainerStyles = (0, $74Zh5.css)({
    position: "relative",
    marginTop: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.100"),
    marginRight: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.150"),
    width: "72px",
    [(0, $0bc19dfefbafca8c$export$987d49ffe1b0900f).below.sm]: {
        display: "none"
    }
});
const $fc6840133e04adc0$var$$8340d81aba797956$var$badgeInnerContainerStyles = (0, $74Zh5.css)({
    position: "absolute",
    top: 0,
    right: 0,
    backgroundColor: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.background.input"),
    borderRadius: "50%",
    padding: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.150"),
    boxShadow: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("elevation.shadow.overlay"),
    transform: "translateY(-25%)"
});
var $fc6840133e04adc0$var$$dbb9d5792c296a49$exports = {};
$fc6840133e04adc0$var$$parcel$export($fc6840133e04adc0$var$$dbb9d5792c296a49$exports, "SubmitFeedback", ()=>$fc6840133e04adc0$export$f6dc54b55657f29f);
const $fc6840133e04adc0$export$f6dc54b55657f29f = ({ onSubmit: onSubmit, onChange: onChange, isLoading: isLoading, isSubmitted: isSubmitted, hasError: hasError, opinion: opinion })=>{
    const [isOpen, setIsOpen] = (0, $5FkrB.useState)(false);
    const [isYesSelected, setIsYesSelected] = (0, $5FkrB.useState)(false);
    const [isNoSelected, setIsNoSelected] = (0, $5FkrB.useState)(false);
    const handleChange = (0, $5FkrB.useCallback)((e)=>{
        e.preventDefault();
        if (onChange) onChange(e);
    }, [
        onChange
    ]);
    const handleYes = (0, $5FkrB.useCallback)(()=>{
        setIsOpen(true);
        setIsYesSelected(true);
        setIsNoSelected(false);
    }, []);
    const handleNo = (0, $5FkrB.useCallback)(()=>{
        setIsOpen(true);
        setIsNoSelected(true);
        setIsYesSelected(false);
    }, []);
    const handleCancel = (0, $5FkrB.useCallback)(()=>{
        setIsOpen(false);
        setIsYesSelected(false);
        setIsNoSelected(false);
    }, []);
    const renderButtons = ()=>{
        if (isLoading && !isSubmitted) return (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $7fd47546053bbf00$export$2e2bcd8739ae039), {
            appearance: "primary",
            isLoading: true,
            children: "Submit"
        });
        if (isSubmitted) return null;
        return (0, $6bec4f26b2cb3094$export$25062201e9e25d76)((0, $6bec4f26b2cb3094$export$ffb0004e005737fa), {
            children: [
                (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$export$353f5b6fc5456de1, {
                    type: "submit",
                    appearance: $fc6840133e04adc0$export$261c9483fc4a455a.PRIMARY,
                    label: "Submit",
                    onClick: onSubmit
                }),
                (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$export$353f5b6fc5456de1, {
                    appearance: $fc6840133e04adc0$export$261c9483fc4a455a.LINK,
                    label: "Cancel",
                    onClick: handleCancel
                })
            ]
        });
    };
    const renderFeedbackBox = ()=>{
        if (!isOpen) return null;
        if (!isSubmitted) return (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
            css: {
                label: {
                    fontSize: "13.7143px",
                    color: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.text.subtlest")
                },
                textArea: {
                    borderColor: `${(0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.border")} !important`,
                    "&:focus": {
                        borderColor: `${(0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.border.focused")} !important`
                    }
                }
            },
            children: [
                (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $e6c825ca43fa4ec5$export$b04be29aa201d4f5), {
                    htmlFor: "area",
                    children: "Send us your opinion"
                }),
                (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $195b49e60159a439$export$2e2bcd8739ae039), {
                    placeholder: "Begin typing in here...",
                    defaultValue: opinion,
                    onChange: handleChange
                }),
                (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $f84678374ba6cf7b$export$2e2bcd8739ae039), {
                    children: renderButtons()
                })
            ]
        });
        if (!hasError) return (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("p", {
            css: $fc6840133e04adc0$var$$dbb9d5792c296a49$var$feedbackStyles,
            children: "Thanks for your feedback!"
        });
        return (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("p", {
            css: $fc6840133e04adc0$var$$dbb9d5792c296a49$var$feedbackStyles,
            children: "Error submitting feedback. Try again later."
        });
    };
    return (0, $6bec4f26b2cb3094$export$25062201e9e25d76)((0, $6bec4f26b2cb3094$export$ffb0004e005737fa), {
        children: [
            !isSubmitted && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                children: (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                    css: (0, $74Zh5.css)({
                        display: "flex",
                        alignItems: "center",
                        marginBottom: "10px"
                    }),
                    children: [
                        (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("p", {
                            css: $fc6840133e04adc0$var$$dbb9d5792c296a49$var$labelStyles,
                            children: "Was this content helpful?"
                        }),
                        (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                            css: (0, $74Zh5.css)({
                                marginLeft: "1rem",
                                display: "flex"
                            }),
                            children: [
                                (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("span", {
                                    css: (0, $74Zh5.css)({
                                        marginRight: "0.5rem"
                                    }),
                                    children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$export$353f5b6fc5456de1, {
                                        label: "Yes",
                                        onClick: handleYes,
                                        appearance: $fc6840133e04adc0$export$261c9483fc4a455a.PRIMARY,
                                        disabled: isYesSelected
                                    })
                                }),
                                (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$export$353f5b6fc5456de1, {
                                    label: "No",
                                    onClick: handleNo,
                                    appearance: $fc6840133e04adc0$export$261c9483fc4a455a.PRIMARY,
                                    disabled: isNoSelected
                                })
                            ]
                        })
                    ]
                })
            }),
            renderFeedbackBox()
        ]
    });
};
const $fc6840133e04adc0$var$$dbb9d5792c296a49$var$labelStyles = (0, $74Zh5.css)({
    marginTop: 0,
    marginBottom: 0,
    fontFamily: "Charlie Display, sans-serif",
    fontSize: "1.25rem",
    fontWeight: 600,
    lineHeight: "1.75rem",
    color: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.text")
});
const $fc6840133e04adc0$var$$dbb9d5792c296a49$var$feedbackStyles = (0, $74Zh5.css)({
    fontWeight: 600,
    fontSize: "1.125rem",
    lineHeight: "1.5rem",
    width: "13.813rem",
    height: "1.563rem"
});
var $fc6840133e04adc0$var$$44303f6c3c81eeac$exports = {};
$fc6840133e04adc0$var$$parcel$export($fc6840133e04adc0$var$$44303f6c3c81eeac$exports, "QuestionType", ()=>$fc6840133e04adc0$export$51940fbbacba35d4);
$fc6840133e04adc0$var$$parcel$export($fc6840133e04adc0$var$$44303f6c3c81eeac$exports, "QuizStatus", ()=>$fc6840133e04adc0$export$bf1c1ed72daa392b);
$fc6840133e04adc0$var$$parcel$export($fc6840133e04adc0$var$$44303f6c3c81eeac$exports, "QuestionStatus", ()=>$fc6840133e04adc0$export$602daccbd963b20);
$fc6840133e04adc0$var$$parcel$export($fc6840133e04adc0$var$$44303f6c3c81eeac$exports, "MatchingAnswerStatus", ()=>$fc6840133e04adc0$export$85e3e62cc743c830);
$fc6840133e04adc0$var$$parcel$export($fc6840133e04adc0$var$$44303f6c3c81eeac$exports, "ActionDescription", ()=>$fc6840133e04adc0$export$cb9c858407602327);
$fc6840133e04adc0$var$$parcel$export($fc6840133e04adc0$var$$44303f6c3c81eeac$exports, "Quiz", ()=>$fc6840133e04adc0$export$76709845c4fea6cd);
let $fc6840133e04adc0$var$$b55544cdfa85935b$export$1bd2035254432789;
(function(InputStatus) {
    InputStatus["CORRECT"] = "CORRECT";
    InputStatus["INCORRECT"] = "INCORRECT";
    InputStatus["SELECTED"] = "SELECTED";
    InputStatus["DEFAULT"] = "DEFAULT";
    InputStatus["DISABLED"] = "DISABLED";
})($fc6840133e04adc0$var$$b55544cdfa85935b$export$1bd2035254432789 || ($fc6840133e04adc0$var$$b55544cdfa85935b$export$1bd2035254432789 = {}));
const $fc6840133e04adc0$var$$b55544cdfa85935b$export$56e6c05354470c53 = ({ inspectMode: inspectMode, text: text, elementId: elementId, inputStatus: inputStatus = $fc6840133e04adc0$var$$b55544cdfa85935b$export$1bd2035254432789.DEFAULT, onClick: onClick })=>{
    // Keep original Space-only handler for outer div (used by tests)
    const handleKeyDown = (0, $5FkrB.useCallback)((event)=>{
        if (event.code === "Space") {
            event.preventDefault();
            onClick && onClick();
        }
    }, [
        onClick
    ]);
    // Use keyboard interaction hook for inner div
    const handleClick = (0, $5FkrB.useCallback)(()=>onClick?.(), [
        onClick
    ]);
    const onKeyDownInner = $fc6840133e04adc0$export$2a0b6757d41dacb2(handleClick);
    return (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
        role: "button",
        tabIndex: 0,
        onKeyDown: handleKeyDown,
        css: [
            $fc6840133e04adc0$var$$b55544cdfa85935b$var$quizInputsContainerStyles,
            $fc6840133e04adc0$var$$b55544cdfa85935b$var$quizInputsVariantStyles[inputStatus]
        ],
        children: [
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                css: [
                    $fc6840133e04adc0$var$$b55544cdfa85935b$var$quizInputBorderStyles["DEFAULT"],
                    $fc6840133e04adc0$var$$b55544cdfa85935b$var$quizInputBorderStyles[inputStatus],
                    $fc6840133e04adc0$var$$b55544cdfa85935b$var$quizInputsVariantStyles[inputStatus]
                ]
            }),
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                role: "button",
                tabIndex: 0,
                ...$fc6840133e04adc0$export$1784ac302bd8ebad("title", inspectMode),
                id: elementId ? elementId + "-quiz-input" : "",
                css: [
                    $fc6840133e04adc0$var$$b55544cdfa85935b$var$quizInputsContentStyles,
                    $fc6840133e04adc0$var$$b55544cdfa85935b$var$quizInputsVariantStyles[inputStatus]
                ],
                onClick: onClick,
                onKeyDown: onKeyDownInner,
                children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                    css: $fc6840133e04adc0$var$$b55544cdfa85935b$var$quizInputsTextStyles,
                    children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$export$e61786c4aee8d415, {
                        children: text
                    })
                })
            })
        ]
    });
};
const $fc6840133e04adc0$var$$b55544cdfa85935b$var$quizInputsContainerStyles = (0, $74Zh5.css)({
    width: "50%",
    display: "flex",
    cursor: "pointer",
    borderRadius: "8px",
    boxShadow: "0px 1px 1px 0px rgba(9, 30, 66, 0.25), 0px 0px 1px 0px rgba(9, 30, 66, 0.31)",
    justifyContent: "center"
});
const $fc6840133e04adc0$var$$b55544cdfa85935b$var$quizInputsContentStyles = (0, $74Zh5.css)({
    maxWidth: "300px",
    width: "100%",
    padding: "16px",
    overflow: "hidden",
    display: "flex",
    alignItems: "center",
    border: "1px solid rgba(9, 30, 66, 0.14)",
    borderLeft: "none",
    borderRadius: "0 8px 8px 0"
});
const $fc6840133e04adc0$var$$b55544cdfa85935b$var$quizInputsTextStyles = (0, $74Zh5.css)({
    fontFamily: "Inter, sans-serif",
    fontSize: "16px",
    lineHeight: "24px",
    width: "100%",
    [(0, $0bc19dfefbafca8c$export$987d49ffe1b0900f).below.xs]: {
        fontSize: "14px",
        lineHeight: "20px"
    }
});
const $fc6840133e04adc0$var$$b55544cdfa85935b$var$quizInputBorderStyles = {
    DEFAULT: (0, $74Zh5.css)({
        maxHeight: "100%",
        width: "8px",
        borderRadius: "8px 0 0 8px",
        border: "1px solid rgba(9, 30, 66, 0.14)",
        borderRight: "none",
        backgroundColor: (0, $d568d81ef5c2bf7a$export$29a4f05edc054374),
        [(0, $0bc19dfefbafca8c$export$987d49ffe1b0900f).below.xs]: {
            width: "4px"
        }
    }),
    CORRECT: (0, $74Zh5.css)({
        backgroundColor: "#22A06B",
        border: "1px solid #22A06B"
    }),
    INCORRECT: (0, $74Zh5.css)({
        backgroundColor: "#E2483D",
        border: "1px solid #E2483D"
    }),
    SELECTED: (0, $74Zh5.css)({
        backgroundColor: "#0C66E4",
        border: "1px solid #0C66E4"
    })
};
const $fc6840133e04adc0$var$$b55544cdfa85935b$var$quizInputsVariantStyles = {
    DEFAULT: (0, $74Zh5.css)({
        color: "#000000",
        backgroundColor: (0, $d568d81ef5c2bf7a$export$29a4f05edc054374),
        fontWeight: 400
    }),
    CORRECT: (0, $74Zh5.css)({
        fontWeight: 700
    }),
    INCORRECT: (0, $74Zh5.css)({
        fontWeight: 700
    }),
    SELECTED: (0, $74Zh5.css)({
        fontWeight: 700
    }),
    DISABLED: (0, $74Zh5.css)({
        color: "#626F86",
        fontWeight: 400,
        backgroundColor: "#F7F8F9",
        border: "1px solid #F7F8F9",
        boxShadow: "none",
        transition: "all",
        transitionDuration: "500ms",
        transitionTimingFunction: "cubic-bezier(0, 0, 0.2, 1)",
        pointerEvents: "none"
    })
};
let $fc6840133e04adc0$export$51940fbbacba35d4;
(function(QuestionType) {
    QuestionType["SINGLE_SELECT"] = "SINGLE_SELECT";
    QuestionType["MULTI_SELECT"] = "MULTI_SELECT";
    QuestionType["MATCHING"] = "MATCHING";
})($fc6840133e04adc0$export$51940fbbacba35d4 || ($fc6840133e04adc0$export$51940fbbacba35d4 = {}));
let $fc6840133e04adc0$export$bf1c1ed72daa392b;
(function(QuizStatus) {
    QuizStatus["DEFAULT"] = "DEFAULT";
    QuizStatus["ERROR"] = "ERROR";
    QuizStatus["PARTLY_CORRECT"] = "PARTLY_CORRECT";
    QuizStatus["SUCCESS"] = "SUCCESS";
})($fc6840133e04adc0$export$bf1c1ed72daa392b || ($fc6840133e04adc0$export$bf1c1ed72daa392b = {}));
let $fc6840133e04adc0$export$602daccbd963b20;
(function(QuestionStatus) {
    QuestionStatus["INCORRECT"] = "INCORRECT";
    QuestionStatus["PARTLY_CORRECT"] = "PARTLY_CORRECT";
    QuestionStatus["CORRECT"] = "CORRECT";
})($fc6840133e04adc0$export$602daccbd963b20 || ($fc6840133e04adc0$export$602daccbd963b20 = {}));
let $fc6840133e04adc0$export$85e3e62cc743c830;
(function(MatchingAnswerStatus) {
    MatchingAnswerStatus["DEFAULT"] = "DEFAULT";
    MatchingAnswerStatus["INCORRECT"] = "INCORRECT";
    MatchingAnswerStatus["CORRECT"] = "CORRECT";
})($fc6840133e04adc0$export$85e3e62cc743c830 || ($fc6840133e04adc0$export$85e3e62cc743c830 = {}));
let $fc6840133e04adc0$export$cb9c858407602327;
(function(ActionDescription) {
    ActionDescription["SINGLE_SELECT"] = "Select the correct answer.";
    ActionDescription["MULTI_SELECT"] = "Select all correct responses.";
    ActionDescription["MATCHING"] = "Select the matching pairs.";
})($fc6840133e04adc0$export$cb9c858407602327 || ($fc6840133e04adc0$export$cb9c858407602327 = {}));
const $fc6840133e04adc0$var$$44303f6c3c81eeac$var$QuizStatusToCheckboxType = {
    [$fc6840133e04adc0$export$bf1c1ed72daa392b.DEFAULT]: "DEFAULT",
    [$fc6840133e04adc0$export$bf1c1ed72daa392b.SUCCESS]: "SUCCESS",
    [$fc6840133e04adc0$export$bf1c1ed72daa392b.ERROR]: "DANGER",
    [$fc6840133e04adc0$export$bf1c1ed72daa392b.PARTLY_CORRECT]: "DANGER"
};
const $fc6840133e04adc0$var$$44303f6c3c81eeac$var$QuizStatusToRadioType = {
    [$fc6840133e04adc0$export$bf1c1ed72daa392b.DEFAULT]: "DEFAULT",
    [$fc6840133e04adc0$export$bf1c1ed72daa392b.SUCCESS]: "SUCCESS",
    [$fc6840133e04adc0$export$bf1c1ed72daa392b.ERROR]: "DANGER",
    [$fc6840133e04adc0$export$bf1c1ed72daa392b.PARTLY_CORRECT]: "DANGER"
};
const $fc6840133e04adc0$var$$44303f6c3c81eeac$var$MOBILE_SCREEN_WIDTH = 480;
const $fc6840133e04adc0$var$$44303f6c3c81eeac$var$NAVBAR_HEIGHT = 136;
const $fc6840133e04adc0$export$76709845c4fea6cd = ({ inspectMode: inspectMode, title: title, questions: questions = [], onCompletion: onCompletion, step: step = 0, setStep: setStep, onInteraction: onInteraction, isCompleted: isCompleted = false, setIsCompleted: setIsCompleted, isLoggedInUser: isLoggedInUser, handleUserLogin: handleUserLogin, lessonId: lessonId, onAnswerSubmit: onAnswerSubmit })=>{
    const [questionAnswers, setQuestionAnswers] = (0, $5FkrB.useState)([]);
    const [selectedAnswers, setSelectedAnswers] = (0, $5FkrB.useState)([]);
    const [status, setStatus] = (0, $5FkrB.useState)($fc6840133e04adc0$export$bf1c1ed72daa392b.DEFAULT);
    const [answersStatus, setAnswersStatus] = (0, $5FkrB.useState)({});
    const [matchingAnswersStatus, setMatchingAnswersStatus] = (0, $5FkrB.useState)($fc6840133e04adc0$export$85e3e62cc743c830.DEFAULT);
    const [correctAnswersArray, setCorrectAnswersArray] = (0, $5FkrB.useState)([]);
    const [incorrectAnswersArray, setIncorrectAnswersArray] = (0, $5FkrB.useState)([]);
    const [lastSubmittedQuestion, setLastSubmittedQuestion] = (0, $5FkrB.useState)({
        lessonId: "",
        step: 0
    });
    const width = $fc6840133e04adc0$export$4616d33c54ae5baf();
    const isNextButtonDisabled = step + 1 !== questions.length ? !isCompleted && status !== $fc6840133e04adc0$export$bf1c1ed72daa392b.SUCCESS : true;
    const isMatchingFeedbackVisible = questions[step]?.type === $fc6840133e04adc0$export$51940fbbacba35d4.MATCHING && matchingAnswersStatus === $fc6840133e04adc0$export$85e3e62cc743c830.CORRECT && !isCompleted;
    (0, $5FkrB.useEffect)(()=>{
        if (lastSubmittedQuestion.lessonId !== lessonId) setLastSubmittedQuestion({
            lessonId: lessonId,
            step: 0
        });
        if (isCompleted && lessonId && questions.length) {
            setStatus($fc6840133e04adc0$export$bf1c1ed72daa392b.SUCCESS);
            onSubmittedQuestionsRecheck(questions.length - 1);
        } else {
            setStatus($fc6840133e04adc0$export$bf1c1ed72daa392b.DEFAULT);
            setSelectedAnswers([]);
        }
    // lastSubmittedQuestion.lessonId, onSubmittedQuestionsRecheck, questions.length intentionally excluded
    /* eslint-disable react-hooks/exhaustive-deps */ }, [
        lessonId,
        isCompleted
    ]);
    (0, $5FkrB.useEffect)(()=>{
        setLastSubmittedQuestion((prevState)=>{
            if (prevState.lessonId === lessonId && !prevState.step) return {
                ...prevState,
                step: step
            };
            return {
                ...prevState
            };
        });
    }, [
        step,
        lastSubmittedQuestion.lessonId
    ]);
    (0, $5FkrB.useEffect)(()=>{
        checkMatchingQuestionCompleted();
    }, [
        correctAnswersArray
    ]);
    (0, $5FkrB.useEffect)(()=>{
        const isLastCompletedQuestion = status === $fc6840133e04adc0$export$bf1c1ed72daa392b.SUCCESS && lastSubmittedQuestion.step === questions.length;
        if (questions.length && !isLastCompletedQuestion) setQuestionAnswers(questions[step]?.answers);
    }, [
        step,
        questions
    ]);
    /* eslint-enable react-hooks/exhaustive-deps */ const handleOnAnswerSubmit = (type, status)=>{
        if (onAnswerSubmit) onAnswerSubmit(type, status);
    };
    const toggleAnswer = (answer)=>{
        onInteraction();
        if (status !== $fc6840133e04adc0$export$bf1c1ed72daa392b.DEFAULT) return;
        if (questions[step]?.type === $fc6840133e04adc0$export$51940fbbacba35d4.SINGLE_SELECT) setSelectedAnswers([
            answer
        ]);
        if (questions[step]?.type === $fc6840133e04adc0$export$51940fbbacba35d4.MULTI_SELECT) {
            if (selectedAnswers.includes(answer)) setSelectedAnswers((a)=>a.filter((ans)=>ans !== answer));
            else setSelectedAnswers((a)=>[
                    ...a,
                    answer
                ]);
        }
        if (questions[step]?.type === $fc6840133e04adc0$export$51940fbbacba35d4.MATCHING) {
            if (isLoggedInUser) toggleMatchingQuestion(answer);
            else handleUserLogin();
        }
    };
    const toggleMatchingQuestion = (answer)=>{
        if (selectedAnswers.length && selectedAnswers[0].title !== answer.title && selectedAnswers[0].isLeftMatchingAnswer !== answer.isLeftMatchingAnswer) {
            if (selectedAnswers[0].matchingAnswer?.title === answer.title && !correctAnswersArray.includes(answer)) {
                const correctAnswers = [
                    ...selectedAnswers,
                    answer
                ];
                handleOnAnswerSubmit($fc6840133e04adc0$export$51940fbbacba35d4.MATCHING, $fc6840133e04adc0$export$602daccbd963b20.CORRECT);
                setMatchingAnswersStatus($fc6840133e04adc0$export$85e3e62cc743c830.CORRECT);
                setSelectedAnswers([
                    ...correctAnswers
                ]);
                setCorrectAnswersArray((a)=>[
                        ...a,
                        ...correctAnswers
                    ]);
                setTimeout(()=>{
                    setSelectedAnswers([]);
                    setMatchingAnswersStatus($fc6840133e04adc0$export$85e3e62cc743c830.DEFAULT);
                }, 500);
            } else {
                const incorrectAnswers = [
                    ...selectedAnswers,
                    answer
                ];
                handleOnAnswerSubmit($fc6840133e04adc0$export$51940fbbacba35d4.MATCHING, $fc6840133e04adc0$export$602daccbd963b20.INCORRECT);
                setMatchingAnswersStatus($fc6840133e04adc0$export$85e3e62cc743c830.INCORRECT);
                setSelectedAnswers([
                    ...incorrectAnswers
                ]);
                setIncorrectAnswersArray((a)=>[
                        ...a,
                        ...incorrectAnswers
                    ]);
                setTimeout(()=>{
                    setSelectedAnswers([]);
                    setMatchingAnswersStatus($fc6840133e04adc0$export$85e3e62cc743c830.DEFAULT);
                }, 500);
            }
        } else {
            setSelectedAnswers([
                answer
            ]);
            setIncorrectAnswersArray([]);
        }
    };
    const checkMatchingQuestionCompleted = ()=>{
        const currentQuestion = questions[step];
        if (!currentQuestion?.leftAnswers || !currentQuestion?.rightAnswers) return;
        const leftAnswers = currentQuestion.leftAnswers;
        const rightAnswers = currentQuestion.rightAnswers;
        if (correctAnswersArray.length === leftAnswers.length + rightAnswers.length) {
            setStatus($fc6840133e04adc0$export$bf1c1ed72daa392b.SUCCESS);
            setLastSubmittedQuestion((prevState)=>{
                return {
                    ...prevState,
                    step: step + 1
                };
            });
            const questionOnCompletion = questions[step]?.onCompletion;
            if (questionOnCompletion) questionOnCompletion();
            if (onCompletion && step + 1 === questions.length) {
                onCompletion();
                setIsCompleted(true);
            }
        }
    };
    const handleAnswerSubmit = ()=>{
        if (isLoggedInUser) onSubmit();
        else handleUserLogin();
    };
    const onSubmit = ()=>{
        const answers = questions[step]?.answers;
        const correctAnswers = answers.filter((ans)=>ans.correct);
        const totalSteps = questions.length;
        const questionOnCompletion = questions[step]?.onCompletion;
        const atLeastOneCorrectAnswer = !!correctAnswers.filter((ans)=>selectedAnswers.includes(ans)).length;
        if (correctAnswers.length === selectedAnswers.length && correctAnswers.every((ans)=>selectedAnswers.includes(ans))) {
            if (step + 1 === totalSteps) {
                /** completed quiz */ setIsCompleted(true);
                if (questionOnCompletion) questionOnCompletion();
                if (onCompletion) onCompletion();
            } else /** unfinished quiz */ if (questionOnCompletion) questionOnCompletion();
            setStatus($fc6840133e04adc0$export$bf1c1ed72daa392b.SUCCESS);
            handleOnAnswerSubmit(questions[step]?.type, $fc6840133e04adc0$export$602daccbd963b20.CORRECT);
            setLastSubmittedQuestion((prevState)=>{
                return {
                    ...prevState,
                    step: step + 1
                };
            });
        } else if (atLeastOneCorrectAnswer) {
            setStatus($fc6840133e04adc0$export$bf1c1ed72daa392b.PARTLY_CORRECT);
            handleOnAnswerSubmit(questions[step]?.type, $fc6840133e04adc0$export$602daccbd963b20.PARTLY_CORRECT);
        } else {
            setStatus($fc6840133e04adc0$export$bf1c1ed72daa392b.ERROR);
            handleOnAnswerSubmit(questions[step]?.type, $fc6840133e04adc0$export$602daccbd963b20.INCORRECT);
        }
        setAnswersStatus(selectedAnswers.reduce((prev, curr)=>({
                ...prev,
                [curr.title]: answers.find((a)=>a.title === curr.title)?.correct ? $fc6840133e04adc0$export$bf1c1ed72daa392b.SUCCESS : $fc6840133e04adc0$export$bf1c1ed72daa392b.ERROR
            }), {}));
    };
    const onTryAgain = ()=>{
        const element = document.getElementById("quiz");
        if (element) {
            const topPosition = element.getBoundingClientRect().top + window.scrollY - $fc6840133e04adc0$var$$44303f6c3c81eeac$var$NAVBAR_HEIGHT;
            window.scrollTo({
                top: topPosition,
                behavior: "smooth"
            });
        }
        setStatus($fc6840133e04adc0$export$bf1c1ed72daa392b.DEFAULT);
        setSelectedAnswers([]);
        setAnswersStatus({});
        setQuestionAnswers((prevState)=>(0, (/*@__PURE__*/$parcel$interopDefault($336d3dfe62d84a74$exports)))(prevState));
    };
    const onSubmittedQuestionsRecheck = (step)=>{
        const prevQuestionAnswers = questions[step].answers;
        const correctAnswers = prevQuestionAnswers.filter((answer)=>answer.correct);
        setStep(step);
        setStatus($fc6840133e04adc0$export$bf1c1ed72daa392b.SUCCESS);
        setSelectedAnswers(correctAnswers);
        setAnswersStatus(correctAnswers.reduce((prev, curr)=>({
                ...prev,
                [curr.title]: questions[step].answers.find((a)=>a.title === curr.title)?.correct ? $fc6840133e04adc0$export$bf1c1ed72daa392b.SUCCESS : $fc6840133e04adc0$export$bf1c1ed72daa392b.ERROR
            }), {}));
    };
    const onNextQuestionClick = ()=>{
        const nextQuestionStep = step + 1;
        const element = document.getElementById("quiz");
        if (element) {
            const topPosition = element.getBoundingClientRect().top + window.scrollY - $fc6840133e04adc0$var$$44303f6c3c81eeac$var$NAVBAR_HEIGHT;
            window.scrollTo({
                top: topPosition,
                behavior: "smooth"
            });
        }
        if (nextQuestionStep < lastSubmittedQuestion.step || isCompleted) onSubmittedQuestionsRecheck(step + 1);
        else {
            setStatus($fc6840133e04adc0$export$bf1c1ed72daa392b.DEFAULT);
            setSelectedAnswers([]);
            setCorrectAnswersArray([]);
            setStep(step + 1);
            setAnswersStatus({});
        }
    };
    const onPrevQuestionClick = ()=>{
        onInteraction();
        onSubmittedQuestionsRecheck(step - 1);
    };
    const getQuizProgress = ()=>{
        const progress = isCompleted ? questions.length : lastSubmittedQuestion.step;
        return progress / questions.length * 100;
    };
    const getInputStatus = (answer)=>{
        if (correctAnswersArray.includes(answer) && selectedAnswers.includes(answer)) return $fc6840133e04adc0$var$$b55544cdfa85935b$export$1bd2035254432789.CORRECT;
        if (incorrectAnswersArray.includes(answer) && selectedAnswers.includes(answer)) return $fc6840133e04adc0$var$$b55544cdfa85935b$export$1bd2035254432789.INCORRECT;
        if (correctAnswersArray.includes(answer) || status === $fc6840133e04adc0$export$bf1c1ed72daa392b.SUCCESS) return $fc6840133e04adc0$var$$b55544cdfa85935b$export$1bd2035254432789.DISABLED;
        if (selectedAnswers.includes(answer)) return $fc6840133e04adc0$var$$b55544cdfa85935b$export$1bd2035254432789.SELECTED;
        return $fc6840133e04adc0$var$$b55544cdfa85935b$export$1bd2035254432789.DEFAULT;
    };
    const getAnswerStatus = (answer)=>!!selectedAnswers.find((a)=>a.title === answer.title);
    return (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
        css: $fc6840133e04adc0$var$$44303f6c3c81eeac$var$quizContainerStyles,
        id: "quiz",
        children: [
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("p", {
                ...$fc6840133e04adc0$export$1784ac302bd8ebad("title", inspectMode),
                css: $fc6840133e04adc0$var$$44303f6c3c81eeac$var$quizTitleStyles,
                children: title
            }),
            (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                css: $fc6840133e04adc0$var$$44303f6c3c81eeac$var$quizContentContainerStyles,
                id: "quiz-question-container",
                "data-testid": "quiz-question-container",
                children: [
                    (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                        css: $fc6840133e04adc0$var$$44303f6c3c81eeac$var$quizHeaderContainerStyles,
                        children: [
                            (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                                css: $fc6840133e04adc0$var$$44303f6c3c81eeac$var$quizActionPanelContainerStyles,
                                children: [
                                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$export$353f5b6fc5456de1, {
                                        label: "back-button",
                                        disabled: !step,
                                        iconBefore: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$export$f04a61298a47a40f, {
                                            type: "arrow-left-circle"
                                        }),
                                        appearance: $fc6840133e04adc0$export$261c9483fc4a455a.ICON,
                                        onClick: onPrevQuestionClick,
                                        iconType: "arrow-left-circle"
                                    }),
                                    (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("span", {
                                        css: $fc6840133e04adc0$var$$44303f6c3c81eeac$var$questionsStepStyles,
                                        children: [
                                            "QUESTION ",
                                            step + 1,
                                            " 0F ",
                                            questions.length
                                        ]
                                    }),
                                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("span", {
                                        css: $fc6840133e04adc0$var$$44303f6c3c81eeac$var$desktopScreenProgressContainerStyles,
                                        children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$export$c17561cb55d4db30, {
                                            progress: getQuizProgress()
                                        })
                                    }),
                                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$export$353f5b6fc5456de1, {
                                        label: "next-button",
                                        disabled: isNextButtonDisabled,
                                        iconBefore: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$export$f04a61298a47a40f, {
                                            type: "arrow-right-circle"
                                        }),
                                        appearance: $fc6840133e04adc0$export$261c9483fc4a455a.ICON,
                                        onClick: onNextQuestionClick,
                                        iconType: "arrow-right-circle"
                                    })
                                ]
                            }),
                            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("span", {
                                css: $fc6840133e04adc0$var$$44303f6c3c81eeac$var$mobileScreenProgressContainerStyles,
                                children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$export$c17561cb55d4db30, {
                                    progress: getQuizProgress()
                                })
                            })
                        ]
                    }),
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("p", {
                        ...$fc6840133e04adc0$export$1784ac302bd8ebad("title", questions[step]?.inspectMode),
                        css: $fc6840133e04adc0$var$$44303f6c3c81eeac$var$questionTitleStyles,
                        children: questions[step]?.title
                    }),
                    questions[step] && questions[step].imageUrl && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                        css: $fc6840133e04adc0$var$$44303f6c3c81eeac$var$questionImageStyles,
                        children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$export$3e431a229df88919, {
                            src: questions[step].imageUrl,
                            alt: questions[step]?.title.props.children
                        })
                    }),
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("p", {
                        css: $fc6840133e04adc0$var$$44303f6c3c81eeac$var$chooseCorrectAnswerStyles,
                        children: $fc6840133e04adc0$export$cb9c858407602327[questions[step]?.type]
                    }),
                    questions[step]?.type === $fc6840133e04adc0$export$51940fbbacba35d4.MATCHING && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                        children: questions[step]?.leftAnswers?.map((leftAnswer, index)=>{
                            const rightAnswer = questions[step]?.rightAnswers?.[index];
                            if (!rightAnswer) return null;
                            return (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                                css: $fc6840133e04adc0$var$$44303f6c3c81eeac$var$quizInputsContainerStyles,
                                children: [
                                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$var$$b55544cdfa85935b$export$56e6c05354470c53, {
                                        inspectMode: leftAnswer?.inspectMode,
                                        elementId: leftAnswer.title,
                                        text: leftAnswer.title,
                                        onClick: ()=>toggleAnswer(leftAnswer),
                                        inputStatus: getInputStatus(leftAnswer)
                                    }),
                                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$var$$b55544cdfa85935b$export$56e6c05354470c53, {
                                        inspectMode: rightAnswer.inspectMode,
                                        elementId: rightAnswer.title,
                                        text: rightAnswer.title,
                                        onClick: ()=>toggleAnswer(rightAnswer),
                                        inputStatus: getInputStatus(rightAnswer)
                                    })
                                ]
                            }, leftAnswer.title + rightAnswer.title);
                        })
                    }),
                    (questions[step]?.type === $fc6840133e04adc0$export$51940fbbacba35d4.SINGLE_SELECT || questions[step]?.type === $fc6840133e04adc0$export$51940fbbacba35d4.MULTI_SELECT) && questionAnswers?.map((answer)=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                            css: $fc6840133e04adc0$var$$44303f6c3c81eeac$var$answerContainerStyles,
                            ...$fc6840133e04adc0$export$1784ac302bd8ebad("title", answer?.inspectMode),
                            children: questions[step]?.type === $fc6840133e04adc0$export$51940fbbacba35d4.SINGLE_SELECT ? (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$export$d7b12c4107be0d61, {
                                size: width >= $fc6840133e04adc0$var$$44303f6c3c81eeac$var$MOBILE_SCREEN_WIDTH ? $fc6840133e04adc0$export$4da24539a3bb7d98.LARGE : $fc6840133e04adc0$export$4da24539a3bb7d98.DEFAULT,
                                label: answer.title,
                                isChecked: getAnswerStatus(answer),
                                setIsChecked: ()=>toggleAnswer(answer),
                                type: $fc6840133e04adc0$var$$44303f6c3c81eeac$var$QuizStatusToRadioType[answersStatus[answer.title]],
                                isBold: getAnswerStatus(answer)
                            }) : (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$export$48513f6b9f8ce62d, {
                                size: width >= $fc6840133e04adc0$var$$44303f6c3c81eeac$var$MOBILE_SCREEN_WIDTH ? $fc6840133e04adc0$export$5e435bc8b081a399.LARGE : $fc6840133e04adc0$export$5e435bc8b081a399.DEFAULT,
                                label: answer.title,
                                onChange: ()=>toggleAnswer(answer),
                                isChecked: getAnswerStatus(answer),
                                type: $fc6840133e04adc0$var$$44303f6c3c81eeac$var$QuizStatusToCheckboxType[answersStatus[answer.title]],
                                isBold: getAnswerStatus(answer)
                            })
                        }, answer.title)),
                    !isCompleted && status === $fc6840133e04adc0$export$bf1c1ed72daa392b.DEFAULT && questions[step]?.type !== $fc6840133e04adc0$export$51940fbbacba35d4.MATCHING && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                        css: [
                            $fc6840133e04adc0$var$$44303f6c3c81eeac$var$buttonContainerStyles,
                            (0, $74Zh5.css)({
                                borderTop: `1px solid ${(0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.border")}`,
                                paddingTop: "32px"
                            })
                        ],
                        children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$export$353f5b6fc5456de1, {
                            label: "Submit answer",
                            appearance: $fc6840133e04adc0$export$261c9483fc4a455a.PRIMARY,
                            onClick: handleAnswerSubmit,
                            disabled: selectedAnswers.length === 0
                        })
                    }),
                    (status === $fc6840133e04adc0$export$bf1c1ed72daa392b.SUCCESS || questions[step]?.type === $fc6840133e04adc0$export$51940fbbacba35d4.MATCHING) && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                        css: $fc6840133e04adc0$var$$44303f6c3c81eeac$var$buttonContainerStyles,
                        children: (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                            css: [
                                $fc6840133e04adc0$var$$44303f6c3c81eeac$var$feedbackContainerStyles,
                                status !== $fc6840133e04adc0$export$bf1c1ed72daa392b.SUCCESS && (0, $74Zh5.css)({
                                    borderTop: `1px solid ${(0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.border")}`
                                })
                            ],
                            children: [
                                status === $fc6840133e04adc0$export$bf1c1ed72daa392b.SUCCESS && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$export$f23c56ac9ab316f, {
                                    title: questions[step]?.type === $fc6840133e04adc0$export$51940fbbacba35d4.MATCHING ? "Correct" : "That\u2019s correct",
                                    appearance: $fc6840133e04adc0$export$f9292ef28b7b429a.CORRECT,
                                    description: questions[step]?.feedbackMessage
                                }),
                                (!isCompleted || questions[step]?.type === $fc6840133e04adc0$export$51940fbbacba35d4.MATCHING && !isCompleted) && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("span", {
                                    css: (0, $74Zh5.css)({
                                        marginTop: "32px"
                                    }),
                                    children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$export$353f5b6fc5456de1, {
                                        disabled: status !== $fc6840133e04adc0$export$bf1c1ed72daa392b.SUCCESS,
                                        label: "Next question",
                                        appearance: $fc6840133e04adc0$export$261c9483fc4a455a.PRIMARY,
                                        onClick: onNextQuestionClick,
                                        iconAfter: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$export$f04a61298a47a40f, {
                                            type: "arrow-right"
                                        })
                                    })
                                })
                            ]
                        })
                    }),
                    (status === $fc6840133e04adc0$export$bf1c1ed72daa392b.ERROR || status === $fc6840133e04adc0$export$bf1c1ed72daa392b.PARTLY_CORRECT) && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                        css: $fc6840133e04adc0$var$$44303f6c3c81eeac$var$buttonContainerStyles,
                        children: (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                            css: $fc6840133e04adc0$var$$44303f6c3c81eeac$var$feedbackContainerStyles,
                            children: [
                                (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$export$f23c56ac9ab316f, {
                                    title: status === $fc6840133e04adc0$export$bf1c1ed72daa392b.PARTLY_CORRECT ? "That\u2019s partly correct" : "That\u2019s not correct",
                                    appearance: $fc6840133e04adc0$export$f9292ef28b7b429a.INCORRECT,
                                    description: questions[step]?.feedbackMessage
                                }),
                                (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("span", {
                                    css: (0, $74Zh5.css)({
                                        marginTop: "32px"
                                    }),
                                    children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$export$353f5b6fc5456de1, {
                                        label: "Try again",
                                        iconBefore: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$export$f04a61298a47a40f, {
                                            type: "refresh"
                                        }),
                                        appearance: $fc6840133e04adc0$export$261c9483fc4a455a.PRIMARY,
                                        onClick: onTryAgain
                                    })
                                })
                            ]
                        })
                    }),
                    isCompleted && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("p", {
                        css: $fc6840133e04adc0$var$$44303f6c3c81eeac$var$completionMessageStyles,
                        children: "\uD83C\uDF89 Quiz complete! Great work."
                    })
                ]
            }),
            isMatchingFeedbackVisible && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("span", {
                css: $fc6840133e04adc0$var$$44303f6c3c81eeac$var$matchingFeedbackContainerStyles,
                children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$export$f23c56ac9ab316f, {
                    title: "That\u2019s correct",
                    appearance: $fc6840133e04adc0$export$f9292ef28b7b429a.CORRECT
                })
            })
        ]
    });
};
const $fc6840133e04adc0$var$$44303f6c3c81eeac$var$quizContainerStyles = (0, $74Zh5.css)({
    display: "flex",
    flexDirection: "column",
    alignItems: "center"
});
const $fc6840133e04adc0$var$$44303f6c3c81eeac$var$quizContentContainerStyles = (0, $74Zh5.css)({
    padding: "32px 48px",
    borderRadius: "8px",
    boxShadow: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("elevation.shadow.raised"),
    maxWidth: "720px",
    width: "100%",
    backgroundColor: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.background.input"),
    [(0, $0bc19dfefbafca8c$export$987d49ffe1b0900f).below.md]: {
        maxWidth: "720px",
        width: "100%"
    },
    [(0, $0bc19dfefbafca8c$export$987d49ffe1b0900f).below.xs]: {
        padding: "24px 16px"
    }
});
const $fc6840133e04adc0$var$$44303f6c3c81eeac$var$quizHeaderContainerStyles = (0, $74Zh5.css)({
    marginBottom: "32px",
    paddingBottom: "28px",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    borderBottom: `1px solid ${(0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.border")}`,
    flexDirection: "row",
    [(0, $0bc19dfefbafca8c$export$987d49ffe1b0900f).below.sm]: {
        flexDirection: "column"
    },
    [(0, $0bc19dfefbafca8c$export$987d49ffe1b0900f).below.xs]: {
        marginBottom: "24px",
        paddingBottom: "24px"
    }
});
const $fc6840133e04adc0$var$$44303f6c3c81eeac$var$quizActionPanelContainerStyles = (0, $74Zh5.css)({
    width: "100%",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center"
});
const $fc6840133e04adc0$var$$44303f6c3c81eeac$var$quizTitleStyles = (0, $74Zh5.css)({
    fontFamily: "Charlie Display, sans-serif",
    fontSize: "40px",
    fontWeight: 700,
    lineHeight: "48px",
    letterSpacing: "-0.12px",
    marginTop: 0,
    marginBottom: "32px",
    textAlign: "center",
    [(0, $0bc19dfefbafca8c$export$987d49ffe1b0900f).below.xs]: {
        display: "none"
    }
});
const $fc6840133e04adc0$var$$44303f6c3c81eeac$var$questionTitleStyles = (0, $74Zh5.css)({
    fontFamily: "Charlie Display, sans-serif",
    fontSize: "20px",
    fontWeight: 600,
    lineHeight: "28px",
    color: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.text"),
    marginTop: 0,
    marginBottom: "32px",
    [(0, $0bc19dfefbafca8c$export$987d49ffe1b0900f).below.xs]: {
        fontSize: "16px",
        lineHeight: "24px",
        marginBottom: "24px"
    }
});
const $fc6840133e04adc0$var$$44303f6c3c81eeac$var$questionImageStyles = (0, $74Zh5.css)({
    padding: "24px 0"
});
const $fc6840133e04adc0$var$$44303f6c3c81eeac$var$desktopScreenProgressContainerStyles = (0, $74Zh5.css)({
    width: "100%",
    margin: "0 24px 0 13px",
    [(0, $0bc19dfefbafca8c$export$987d49ffe1b0900f).below.sm]: {
        display: "none"
    }
});
const $fc6840133e04adc0$var$$44303f6c3c81eeac$var$mobileScreenProgressContainerStyles = (0, $74Zh5.css)({
    [(0, $0bc19dfefbafca8c$export$987d49ffe1b0900f).below.sm]: {
        width: "100%",
        margin: 0,
        marginTop: "12px"
    }
});
const $fc6840133e04adc0$var$$44303f6c3c81eeac$var$chooseCorrectAnswerStyles = (0, $74Zh5.css)({
    fontFamily: "Charlie Display, sans-serif",
    fontSize: "16px",
    fontWeight: 600,
    lineHeight: "24px",
    color: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.text.subtlest"),
    marginTop: 0,
    marginBottom: "24px",
    [(0, $0bc19dfefbafca8c$export$987d49ffe1b0900f).below.xs]: {
        fontSize: "14px",
        lineHeight: "22px",
        marginBottom: "16px"
    }
});
const $fc6840133e04adc0$var$$44303f6c3c81eeac$var$answerContainerStyles = (0, $74Zh5.css)({
    marginBottom: "24px",
    [(0, $0bc19dfefbafca8c$export$987d49ffe1b0900f).below.xs]: {
        marginBottom: "20px"
    }
});
const $fc6840133e04adc0$var$$44303f6c3c81eeac$var$quizInputsContainerStyles = (0, $74Zh5.css)({
    display: "flex",
    justifyContent: "space-between",
    width: "100%",
    gap: "24px",
    marginTop: "24px"
});
const $fc6840133e04adc0$var$$44303f6c3c81eeac$var$buttonContainerStyles = (0, $74Zh5.css)({
    display: "flex",
    alignItems: "center",
    marginTop: "32px",
    [(0, $0bc19dfefbafca8c$export$987d49ffe1b0900f).below.xs]: {
        marginTop: "24px"
    }
});
const $fc6840133e04adc0$var$$44303f6c3c81eeac$var$feedbackContainerStyles = (0, $74Zh5.css)({
    display: "flex",
    flexDirection: "column",
    width: "100%"
});
const $fc6840133e04adc0$var$$44303f6c3c81eeac$var$questionsStepStyles = (0, $74Zh5.css)({
    minWidth: "115px",
    marginLeft: "24px",
    color: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.text"),
    fontFamily: "Charlie Text, sans-serif",
    fontSize: "14px",
    fontWeight: 600,
    lineHeight: "18px"
});
const $fc6840133e04adc0$var$$44303f6c3c81eeac$var$completionMessageStyles = (0, $74Zh5.css)({
    marginTop: "40px",
    marginBottom: 0,
    color: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.text"),
    fontFamily: "Charlie Display, sans-serif",
    fontSize: "20px",
    fontWeight: 600,
    lineHeight: "28px",
    textAlign: "center"
});
const $fc6840133e04adc0$var$$44303f6c3c81eeac$var$matchingFeedbackContainerStyles = (0, $74Zh5.css)({
    marginTop: "40px",
    maxWidth: "624px",
    width: "100%",
    [(0, $0bc19dfefbafca8c$export$987d49ffe1b0900f).below.xs]: {
        display: "none"
    }
});
var $fc6840133e04adc0$var$$9c3f769544bb2079$exports = {};
$fc6840133e04adc0$var$$parcel$export($fc6840133e04adc0$var$$9c3f769544bb2079$exports, "Sidebar", ()=>$fc6840133e04adc0$export$1ba59dacbcbf90fe);
const $fc6840133e04adc0$export$1ba59dacbcbf90fe = ({ onChangeMenuVisibility: onChangeMenuVisibility, isVisible: isVisible = true, children: children })=>{
    const toggleMenu = ()=>{
        if (onChangeMenuVisibility) onChangeMenuVisibility(!isVisible);
    };
    return (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
        css: $fc6840133e04adc0$var$$9c3f769544bb2079$var$sidebarNavContainerStyles,
        children: [
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("button", {
                "data-testid": "button-toggle-menu-toggle",
                css: [
                    $fc6840133e04adc0$var$$9c3f769544bb2079$var$buttonToggleMenuStyles,
                    !isVisible && $fc6840133e04adc0$var$$9c3f769544bb2079$var$buttonToggleMenuClosedStyles,
                    isVisible && $fc6840133e04adc0$var$$9c3f769544bb2079$var$buttonToggleMenuOpenStyles
                ],
                onClick: toggleMenu,
                "aria-label": "toggle menu",
                children: isVisible ? (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$export$f04a61298a47a40f, {
                    type: "chevron-left",
                    color: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.icon")
                }) : (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$export$f04a61298a47a40f, {
                    type: "chevron-right",
                    color: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.icon")
                })
            }),
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                css: $fc6840133e04adc0$var$$9c3f769544bb2079$var$mobileButtonToggleMenuContainerStyles,
                children: (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("button", {
                    "data-testid": "button-toggle-menu-show",
                    css: $fc6840133e04adc0$var$$9c3f769544bb2079$var$mobileButtonToggleMenuStyles,
                    onClick: toggleMenu,
                    "aria-label": "show menu",
                    children: [
                        isVisible ? (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$export$f04a61298a47a40f, {
                            type: "dropdown-cross",
                            color: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.icon")
                        }) : (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$export$f04a61298a47a40f, {
                            type: "menu-icon",
                            color: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.icon")
                        }),
                        isVisible ? (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                            css: (0, $74Zh5.css)({
                                span: {
                                    color: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.icon")
                                }
                            }),
                            children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$export$5f1af8db9871e1d6, {
                                children: "Close"
                            })
                        }) : (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                            css: (0, $74Zh5.css)({
                                span: {
                                    color: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.icon")
                                }
                            }),
                            children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$export$5f1af8db9871e1d6, {
                                children: "Menu"
                            })
                        })
                    ]
                })
            }),
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                css: [
                    isVisible && $fc6840133e04adc0$var$$9c3f769544bb2079$var$sidebarOpenStyles,
                    !isVisible && $fc6840133e04adc0$var$$9c3f769544bb2079$var$sidebarClosedStyles,
                    $fc6840133e04adc0$var$$9c3f769544bb2079$var$sidebarStyles
                ],
                "data-testid": "sidebar",
                children: isVisible && children
            })
        ]
    });
};
const $fc6840133e04adc0$var$$9c3f769544bb2079$var$sidebarNavContainerStyles = (0, $74Zh5.css)({
    position: "absolute",
    height: "100%",
    opacity: 1,
    display: "block",
    transform: "translateX(0px)",
    [(0, $0bc19dfefbafca8c$export$987d49ffe1b0900f).below.sm]: {
        width: "100%",
        position: "absolute"
    }
});
const $fc6840133e04adc0$var$$9c3f769544bb2079$var$sidebarStyles = (0, $74Zh5.css)({
    transition: "all",
    transitionTimingFunction: "cubic-bezier(0.4, 0, 0.2, 1)",
    transitionDuration: "300ms",
    height: "100%",
    paddingTop: "1.75rem",
    paddingRight: "7px",
    paddingLeft: "0.5rem",
    top: 0,
    bottom: 0,
    left: 0,
    borderRightWidth: "1px",
    borderStyle: "solid",
    borderColor: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.border"),
    borderTop: "none",
    borderLeft: "none",
    backgroundColor: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("elevation.surface.sunken"),
    overflowY: "auto",
    overflowX: "hidden"
});
const $fc6840133e04adc0$var$$9c3f769544bb2079$var$sidebarClosedStyles = (0, $74Zh5.css)({
    width: "1.25rem",
    [(0, $0bc19dfefbafca8c$export$987d49ffe1b0900f).below.sm]: {
        top: 0,
        borderRightWidth: 0,
        paddingTop: 0,
        height: 0,
        width: "100%",
        position: "absolute"
    }
});
const $fc6840133e04adc0$var$$9c3f769544bb2079$var$sidebarOpenStyles = (0, $74Zh5.css)({
    display: "block",
    transform: "translateX(0px)",
    paddingTop: "1.75rem",
    position: "fixed",
    [(0, $0bc19dfefbafca8c$export$987d49ffe1b0900f).below.sm]: {
        width: "100vw",
        marginTop: "3rem",
        position: "absolute"
    },
    [(0, $0bc19dfefbafca8c$export$987d49ffe1b0900f).above.sm]: {
        width: "26.25rem",
        position: "absolute"
    },
    [(0, $0bc19dfefbafca8c$export$987d49ffe1b0900f).below.md]: {
        boxShadow: `0 0 0 10000px ${(0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.blanket")}`
    },
    [(0, $0bc19dfefbafca8c$export$987d49ffe1b0900f).above.lg]: {
        position: "relative",
        boxShadow: "none"
    }
});
const $fc6840133e04adc0$var$$9c3f769544bb2079$var$mobileButtonToggleMenuContainerStyles = (0, $74Zh5.css)({
    display: "none",
    alignItems: "center",
    justifyContent: "align-start",
    width: "100vw",
    paddingLeft: "1rem",
    height: "3rem",
    borderBottom: `1px solid ${(0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.border")}`,
    borderLeft: "none",
    borderRight: "none",
    backgroundColor: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.background.input"),
    position: "relative",
    zIndex: 200,
    [(0, $0bc19dfefbafca8c$export$987d49ffe1b0900f).below.sm]: {
        display: "flex"
    }
});
const $fc6840133e04adc0$var$$9c3f769544bb2079$var$mobileButtonToggleMenuStyles = (0, $74Zh5.css)({
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: 0,
    border: "none",
    background: "transparent",
    outline: "none"
});
const $fc6840133e04adc0$var$$9c3f769544bb2079$var$buttonToggleMenuStyles = (0, $74Zh5.css)({
    transition: "all",
    transitionTimingFunction: "cubic-bezier(0.4, 0, 0.2, 1)",
    transitionDuration: "300ms",
    border: "none",
    borderRadius: "9999px",
    backgroundColor: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.background.input"),
    width: "1.5rem",
    height: "1.5rem",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    boxShadow: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("elevation.shadow.overlay"),
    position: "absolute",
    top: "1.75rem",
    zIndex: 200,
    cursor: "pointer",
    [(0, $0bc19dfefbafca8c$export$987d49ffe1b0900f).below.sm]: {
        display: "none"
    }
});
const $fc6840133e04adc0$var$$9c3f769544bb2079$var$buttonToggleMenuOpenStyles = (0, $74Zh5.css)({
    marginLeft: "25.5rem"
});
const $fc6840133e04adc0$var$$9c3f769544bb2079$var$buttonToggleMenuClosedStyles = (0, $74Zh5.css)({
    marginLeft: "0.5rem"
});
var $fc6840133e04adc0$var$$3d76652bb6362040$exports = {};
$fc6840133e04adc0$var$$parcel$export($fc6840133e04adc0$var$$3d76652bb6362040$exports, "LearningSidebar", ()=>$fc6840133e04adc0$export$4ff69a78d3a65d6f);
var $fc6840133e04adc0$var$$ef44b01e6346ac17$require$Buffer = (0, $7KfP5.Buffer);
const $fc6840133e04adc0$var$$ef44b01e6346ac17$var$badge = `<svg width="120" height="120" viewBox="0 0 120 120" fill="none" xmlns="http://www.w3.org/2000/svg">
<mask id="mask0_2407_668" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="120" height="120">
<path d="M60 120C93.1371 120 120 93.1371 120 60C120 26.8629 93.1371 0 60 0C26.8629 0 0 26.8629 0 60C0 93.1371 26.8629 120 60 120Z" fill="#FCA700"/>
</mask>
<g mask="url(#mask0_2407_668)">
<path d="M59.9919 120.001C93.129 120.001 119.992 93.1381 119.992 60.001C119.992 26.8639 93.129 0.00100708 59.9919 0.00100708C26.8549 0.00100708 -0.00805664 26.8639 -0.00805664 60.001C-0.00805664 93.1381 26.8549 120.001 59.9919 120.001Z" fill="#F0F1F2"/>
<path d="M114.195 48.5778C139.041 82.736 131.616 130.479 97.5729 155.447L75.6838 125.554C93.1971 112.63 97.0229 88.0317 84.2648 70.3823L114.195 48.5778Z" stroke="#1868DB" stroke-width="0.5"/>
<path d="M61.381 -11.1668L61.381 -11.1667L61.3875 -11.1713C66.9496 -15.1726 72.2687 -18.6935 77.3965 -21.8258L116.987 15.9668C109.215 16.5818 99.355 21.2346 85.3825 30.54L85.3825 30.5399L85.3765 30.5441C79.0802 35.0076 73.098 38.8783 67.3602 42.2665L28.6585 5.32281C36.6192 3.90769 46.9288 -1.45355 61.381 -11.1668Z" stroke="#1868DB" stroke-width="0.5"/>
<path d="M-4.01227 93.1467L46.5982 80.1918L59.4265 130.835L8.81594 143.79L-4.01227 93.1467Z" stroke="#1868DB" stroke-width="0.5"/>
<path d="M3.67239 23.827L3.68518 23.7211L3.66478 23.6962C4.43632 16.9412 1.0124 10.0403 -2.57376 4.84886C-4.3803 2.23367 -6.23694 0.0395466 -7.64175 -1.5007C-8.34432 -2.27099 -8.93428 -2.8782 -9.34902 -3.29322C-9.39083 -3.33506 -9.43086 -3.37495 -9.46905 -3.41285L13.9267 -0.587166C22.5213 4.49206 28.577 10.8772 32.2178 18.2212C35.8649 25.5781 37.096 33.9122 36.0121 42.8863C34.4107 56.146 27.9882 65.8687 18.1125 72.3709C8.28951 78.8384 -4.96514 82.1287 -20.3194 82.5128L-15.6409 43.7758C-9.8996 42.5993 -5.41093 40.3431 -2.18767 37.026C1.06994 33.6736 3.01663 29.2565 3.67239 23.827Z" stroke="#1868DB" stroke-width="0.5"/>
<path d="M98.1255 59.8467C98.1255 81.1403 81.101 98.3963 60.1074 98.3963C39.1139 98.3963 22.0894 81.1403 22.0894 59.8467C22.0894 38.5531 39.1139 21.2971 60.1074 21.2971C81.101 21.2971 98.1255 38.5531 98.1255 59.8467Z" stroke="#1868DB" stroke-width="0.5"/>
<path d="M35.4794 65.1887C35.2675 65.5337 35.0269 65.9381 34.84 66.2562C34.66 66.5631 34.7569 66.9575 35.06 67.1444L39.3062 69.765C39.6175 69.9569 40.025 69.8581 40.2106 69.5431C40.3794 69.2575 40.5981 68.89 40.8369 68.495C42.52 65.7175 44.2125 66.0562 47.2619 67.5056L51.4731 69.5075C51.805 69.6656 52.2019 69.5181 52.3512 69.1819L54.3737 64.6156C54.5175 64.2906 54.3762 63.9112 54.055 63.76C53.1656 63.3419 51.3981 62.5075 49.8156 61.7412C44.0656 58.9569 39.2 59.1406 35.48 65.1887H35.4794Z" fill="url(#paint0_linear_2407_668)"/>
<path d="M54.5206 54.8113C54.7325 54.4663 54.9731 54.0619 55.16 53.7438C55.34 53.4369 55.2431 53.0425 54.94 52.8556L50.6938 50.235C50.3825 50.0431 49.975 50.1419 49.7894 50.4569C49.6206 50.7425 49.4019 51.11 49.1631 51.505C47.48 54.2825 45.7875 53.9438 42.7381 52.4944L38.5269 50.4925C38.195 50.3344 37.7981 50.4819 37.6488 50.8181L35.6263 55.3844C35.4825 55.7094 35.6238 56.0888 35.945 56.24C36.8344 56.6581 38.6019 57.4925 40.1844 58.2588C45.9344 61.0431 50.8 60.8594 54.52 54.8113H54.5206Z" fill="url(#paint1_linear_2407_668)"/>
<path d="M85.1263 49.5188H73.8275C73.8275 52.335 76.1106 54.6175 78.9263 54.6175H81.0069V56.6256C81.0069 59.4419 83.29 61.7244 86.1056 61.7244V50.4988C86.1056 49.9575 85.6669 49.5188 85.1256 49.5188H85.1263Z" fill="#1D7AFC"/>
<path d="M79.5345 55.1475H68.2357C68.2357 57.9638 70.5188 60.2463 73.3345 60.2463H75.4151V62.2544C75.4151 65.0706 77.6982 67.3531 80.5138 67.3531V56.1275C80.5138 55.5863 80.0751 55.1475 79.5338 55.1475H79.5345Z" fill="url(#paint2_linear_2407_668)"/>
<path d="M73.9425 60.7756H62.6438C62.6438 63.5919 64.9269 65.8744 67.7425 65.8744H69.8232V67.8825C69.8232 70.6988 72.1063 72.9813 74.9219 72.9813V61.7556C74.9219 61.2144 74.4832 60.7756 73.9419 60.7756H73.9425Z" fill="url(#paint3_linear_2407_668)"/>
</g>
<defs>
<linearGradient id="paint0_linear_2407_668" x1="54.2475" y1="71.11" x2="41.3981" y2="63.7263" gradientUnits="userSpaceOnUse">
<stop stop-color="#0055CC"/>
<stop offset="0.972" stop-color="#1C78FA"/>
<stop offset="1" stop-color="#1D7AFC"/>
</linearGradient>
<linearGradient id="paint1_linear_2407_668" x1="35.7519" y1="48.89" x2="48.6019" y2="56.2738" gradientUnits="userSpaceOnUse">
<stop stop-color="#0055CC"/>
<stop offset="0.972" stop-color="#1C78FA"/>
<stop offset="1" stop-color="#1D7AFC"/>
</linearGradient>
<linearGradient id="paint2_linear_2407_668" x1="80.2745" y1="55.1663" x2="75.4682" y2="60.1225" gradientUnits="userSpaceOnUse">
<stop offset="0.176" stop-color="#0055CC"/>
<stop offset="1" stop-color="#1D7AFC"/>
</linearGradient>
<linearGradient id="paint3_linear_2407_668" x1="75.0019" y1="60.8281" x2="69.445" y2="66.2344" gradientUnits="userSpaceOnUse">
<stop offset="0.176" stop-color="#0055CC"/>
<stop offset="1" stop-color="#1D7AFC"/>
</linearGradient>
</defs>
</svg>`;
const $fc6840133e04adc0$var$$ef44b01e6346ac17$export$44f5f766f3f98994 = `data:image/svg+xml;base64,${$fc6840133e04adc0$var$$ef44b01e6346ac17$require$Buffer.from($fc6840133e04adc0$var$$ef44b01e6346ac17$var$badge).toString("base64")}`;
const $fc6840133e04adc0$var$$32c02b5652036d7a$var$SidebarContext = (0, $5FkrB.createContext)(undefined);
const $fc6840133e04adc0$var$$32c02b5652036d7a$export$861cd542ff836f0d = ()=>{
    const context = (0, $5FkrB.useContext)($fc6840133e04adc0$var$$32c02b5652036d7a$var$SidebarContext);
    if (!context) throw new Error("useSidebarContext must be used within a SidebarContextProvider");
    return context;
};
const $fc6840133e04adc0$var$$32c02b5652036d7a$export$d8355e8edbcacbe8 = ({ children: children })=>{
    const [hoverInfo, setHoverInfo] = (0, $5FkrB.useState)(null);
    const popupRef = (0, $5FkrB.useRef)(null);
    const lastIdRef = (0, $5FkrB.useRef)(null);
    const timeoutRef = (0, $5FkrB.useRef)(null);
    const clear = (0, $5FkrB.useCallback)(()=>{
        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
            timeoutRef.current = null;
        }
    }, []);
    const handleMouseEnter = (0, $5FkrB.useCallback)((data)=>{
        clear();
        if (lastIdRef.current !== data.courseId) setHoverInfo(null);
        lastIdRef.current = data.courseId;
        timeoutRef.current = setTimeout(()=>{
            if (lastIdRef.current === data.courseId) setHoverInfo(data);
        }, 1000);
    }, [
        clear
    ]);
    const handleMouseLeave = (0, $5FkrB.useCallback)((id)=>{
        clear();
        if (!id || lastIdRef.current === id) {
            lastIdRef.current = null;
            setHoverInfo(null);
        }
    }, [
        clear
    ]);
    const contextValue = (0, $5FkrB.useMemo)(()=>({
            hoverInfo: hoverInfo,
            handleMouseEnter: handleMouseEnter,
            handleMouseLeave: handleMouseLeave,
            popupRef: popupRef
        }), [
        hoverInfo,
        handleMouseEnter,
        handleMouseLeave
    ]);
    return (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$var$$32c02b5652036d7a$var$SidebarContext.Provider, {
        value: contextValue,
        children: children
    });
};
const $fc6840133e04adc0$var$$48630d5962798e4a$export$272e7ef3ea22070d = (status)=>{
    switch(status){
        case $fc6840133e04adc0$var$$035f8a623e403361$export$23d03d0b3065d061.COMPLETED:
            return $fc6840133e04adc0$var$$035f8a623e403361$export$490c7ce941281ba8.COMPLETED;
        case $fc6840133e04adc0$var$$035f8a623e403361$export$23d03d0b3065d061.IN_PROGRESS:
        case $fc6840133e04adc0$var$$035f8a623e403361$export$23d03d0b3065d061.NOT_STARTED:
        default:
            return $fc6840133e04adc0$var$$035f8a623e403361$export$490c7ce941281ba8.DEFAULT;
    }
};
const $fc6840133e04adc0$var$$48630d5962798e4a$export$15379570ba48f04d = (courseSlug, lessonSlug, sectionSlug)=>{
    const currentPath = globalThis.location.pathname;
    const currentHash = globalThis.location.hash;
    if (courseSlug) return currentPath.includes(`/course/${courseSlug}`);
    if (sectionSlug === "quiz") return currentPath.includes(`lesson/${lessonSlug}`) && currentHash === "#quiz";
    if (sectionSlug) return currentPath.includes(`/lesson/${lessonSlug}`) && currentHash === `#${sectionSlug}`;
    if (lessonSlug) {
        const lessonPath = `/lesson/${lessonSlug}`;
        return currentPath.endsWith(lessonPath) || currentPath.includes(lessonPath + "/");
    }
    return currentHash === `#${sectionSlug}`;
};
const $fc6840133e04adc0$var$$48630d5962798e4a$export$1308f255697e8777 = (lessonsCollection, progressForLessons)=>{
    const numberOfCompletedLessons = lessonsCollection.items.filter(({ sys: { id: id } })=>$fc6840133e04adc0$var$$48630d5962798e4a$export$272e7ef3ea22070d(progressForLessons?.lessons.find((lesson)=>lesson.lessonId === id)?.status) === $fc6840133e04adc0$var$$035f8a623e403361$export$490c7ce941281ba8.COMPLETED).length;
    const numberOfTotalLessons = lessonsCollection.items.length;
    const progress = numberOfTotalLessons === 0 ? 0 : numberOfCompletedLessons / numberOfTotalLessons * 100;
    const isStatusCompleted = progress === 100;
    return {
        progress: progress,
        isStatusCompleted: isStatusCompleted
    };
};
const $fc6840133e04adc0$var$$6cca9b298ff547cb$export$a9a23386c3e0c05f = ({ lessonsCollection: lessonsCollection, progressForLessons: progressForLessons, reward: reward, title: title })=>{
    const { progress: progress, isStatusCompleted: isStatusCompleted } = (0, $5FkrB.useMemo)(()=>$fc6840133e04adc0$var$$48630d5962798e4a$export$1308f255697e8777(lessonsCollection, progressForLessons), [
        lessonsCollection,
        progressForLessons
    ]);
    return (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
        css: $fc6840133e04adc0$var$$6cca9b298ff547cb$var$progressCircleContainerStyles,
        "data-testid": "course-progress-circle",
        children: [
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $f188eff9b59fb855$export$5ab97151efedb8c6), {
                strokeWidth: 8,
                value: progress,
                styles: (0, $f188eff9b59fb855$export$5115a192ad9bf57f)({
                    pathColor: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.border.success"),
                    trailColor: "rgba(9, 30, 66, 0.14)"
                }),
                css: [
                    isStatusCompleted && $fc6840133e04adc0$var$$6cca9b298ff547cb$var$completedCourseProgressStyles
                ],
                children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                    css: [
                        $fc6840133e04adc0$var$$6cca9b298ff547cb$var$imageBadgeContainerStyles,
                        isStatusCompleted && $fc6840133e04adc0$var$$6cca9b298ff547cb$var$completedCourseProgressStyles
                    ],
                    children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("img", {
                        css: $fc6840133e04adc0$var$$6cca9b298ff547cb$var$imageStyles,
                        "data-testid": "course-badge-image",
                        src: reward?.badgeCdnUrl || $fc6840133e04adc0$var$$ef44b01e6346ac17$export$44f5f766f3f98994,
                        alt: title
                    })
                })
            }),
            isStatusCompleted && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$export$f04a61298a47a40f, {
                type: "check",
                color: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.icon.success")
            })
        ]
    });
};
const $fc6840133e04adc0$var$$6cca9b298ff547cb$var$completedCourseProgressStyles = (0, $74Zh5.css)({
    opacity: "0.2"
});
const $fc6840133e04adc0$var$$6cca9b298ff547cb$var$progressCircleContainerStyles = (0, $74Zh5.css)({
    position: "relative",
    maxWidth: "32px",
    span: {
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)"
    }
});
const $fc6840133e04adc0$var$$6cca9b298ff547cb$var$imageBadgeContainerStyles = (0, $74Zh5.css)({
    width: "100%",
    height: "100%",
    padding: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.100")
});
const $fc6840133e04adc0$var$$6cca9b298ff547cb$var$imageStyles = (0, $74Zh5.css)({
    width: "100%",
    height: "100%",
    objectFit: "contain",
    borderRadius: "50%"
});
let $fc6840133e04adc0$var$$47b694880a211b2b$export$40bdb27f2137fcf;
(function(Appearance) {
    Appearance["COURSE"] = "course";
    Appearance["LESSON"] = "lesson";
    Appearance["SECTION"] = "section";
})($fc6840133e04adc0$var$$47b694880a211b2b$export$40bdb27f2137fcf || ($fc6840133e04adc0$var$$47b694880a211b2b$export$40bdb27f2137fcf = {}));
/**
 * Props for the TextTooltip component
 * @param {string} text - Text to display in the tooltip
 * @param {CardStatus} status - Current status of the item (completed, or default)
 * @param {Appearance} appearance - Whether the item is a course card or lesson card
 * @param {boolean} isSelected - Whether the item is selected
 */ const $fc6840133e04adc0$var$$47b694880a211b2b$var$MOBILE_SCREEN_WIDTH = 650;
const $fc6840133e04adc0$var$$47b694880a211b2b$export$c0d3d8bfa41e2e2a = ({ text: text, status: status, appearance: appearance, isSelected: isSelected })=>{
    const [isTruncated, setIsTruncated] = (0, $5FkrB.useState)(false);
    const textRef = (0, $5FkrB.useRef)(null);
    const deviceSize = $fc6840133e04adc0$export$4616d33c54ae5baf();
    const isMobile = deviceSize <= $fc6840133e04adc0$var$$47b694880a211b2b$var$MOBILE_SCREEN_WIDTH;
    (0, $5FkrB.useEffect)(()=>{
        const checkTruncation = ()=>{
            if (textRef.current) setIsTruncated(textRef.current.scrollWidth > textRef.current.clientWidth);
        };
        checkTruncation();
        window.addEventListener("resize", checkTruncation);
        return ()=>{
            window.removeEventListener("resize", checkTruncation);
        };
    }, [
        text
    ]);
    const isLesson = appearance === $fc6840133e04adc0$var$$47b694880a211b2b$export$40bdb27f2137fcf.LESSON;
    const isCourse = appearance === $fc6840133e04adc0$var$$47b694880a211b2b$export$40bdb27f2137fcf.COURSE;
    const isSection = appearance === $fc6840133e04adc0$var$$47b694880a211b2b$export$40bdb27f2137fcf.SECTION;
    const textElement = (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("p", {
        "data-testid": "sidebar-text-tooltip",
        ref: textRef,
        css: [
            isCourse && $fc6840133e04adc0$var$$47b694880a211b2b$var$courseTitleStyles,
            isCourse && isSelected && $fc6840133e04adc0$var$$47b694880a211b2b$var$titleSelectedStyles,
            isLesson && $fc6840133e04adc0$var$$47b694880a211b2b$var$lessonTitleStyles,
            isMobile && isLesson && $fc6840133e04adc0$var$$47b694880a211b2b$var$regularDecorationStyles,
            isLesson && isSelected && $fc6840133e04adc0$var$$47b694880a211b2b$var$titleSelectedStyles,
            $fc6840133e04adc0$var$$47b694880a211b2b$var$sectionTitleStyles,
            isCourse && $fc6840133e04adc0$var$$47b694880a211b2b$var$courseMaxWidth,
            isLesson && $fc6840133e04adc0$var$$47b694880a211b2b$var$lessonMaxWidth,
            status === $fc6840133e04adc0$var$$035f8a623e403361$export$490c7ce941281ba8.COMPLETED && $fc6840133e04adc0$var$$47b694880a211b2b$var$sectionTitleCompletedStyles,
            status === $fc6840133e04adc0$var$$035f8a623e403361$export$490c7ce941281ba8.DEFAULT && $fc6840133e04adc0$var$$47b694880a211b2b$var$sectionTitleDefaultStyles,
            isSection && isSelected && $fc6840133e04adc0$var$$47b694880a211b2b$var$sectionTitleSelectedStyles
        ],
        children: text
    });
    return isTruncated ? (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $1oVT1.default), {
        content: text,
        position: isMobile ? "bottom" : "right",
        children: textElement
    }) : textElement;
};
const $fc6840133e04adc0$var$$47b694880a211b2b$var$sectionTitleStyles = (0, $74Zh5.css)({
    fontFamily: "Inter, sans-serif",
    fontWeight: 400,
    lineHeight: "24px",
    fontSize: "16px",
    marginTop: 0,
    marginLeft: "10px",
    maxWidth: "330px",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    [(0, $0bc19dfefbafca8c$export$987d49ffe1b0900f).below.xs]: {
        maxWidth: "290px"
    }
});
const $fc6840133e04adc0$var$$47b694880a211b2b$var$sectionTitleSelectedStyles = (0, $74Zh5.css)({
    fontWeight: 600,
    color: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.text.selected")
});
const $fc6840133e04adc0$var$$47b694880a211b2b$var$sectionTitleCompletedStyles = (0, $74Zh5.css)({
    color: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.text.subtlest")
});
const $fc6840133e04adc0$var$$47b694880a211b2b$var$sectionTitleDefaultStyles = (0, $74Zh5.css)({
    color: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.text.subtle")
});
const $fc6840133e04adc0$var$$47b694880a211b2b$var$lessonTitleStyles = (0, $74Zh5.css)({
    fontFamily: "Inter, sans-serif",
    fontWeight: 400,
    lineHeight: "24px",
    fontSize: "16px",
    color: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.text.subtle"),
    marginTop: 0,
    marginRight: "auto",
    marginLeft: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.025"),
    "&:hover": {
        textDecoration: "underline"
    }
});
const $fc6840133e04adc0$var$$47b694880a211b2b$var$regularDecorationStyles = (0, $74Zh5.css)({
    "&:hover": {
        textDecoration: "none"
    }
});
const $fc6840133e04adc0$var$$47b694880a211b2b$var$titleSelectedStyles = (0, $74Zh5.css)({
    fontWeight: "500 !important",
    color: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.text")
});
const $fc6840133e04adc0$var$$47b694880a211b2b$var$courseTitleStyles = (0, $74Zh5.css)({
    color: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.text.subtlest"),
    fontFamily: "Inter, sans-serif",
    fontSize: "16px",
    fontWeight: 500,
    lineHeight: "24px",
    marginTop: 0
});
const $fc6840133e04adc0$var$$47b694880a211b2b$var$courseMaxWidth = (0, $74Zh5.css)({
    marginLeft: 0,
    maxWidth: "320px"
});
const $fc6840133e04adc0$var$$47b694880a211b2b$var$lessonMaxWidth = (0, $74Zh5.css)({
    marginLeft: 0,
    marginRight: "auto",
    maxWidth: "290px",
    [(0, $0bc19dfefbafca8c$export$987d49ffe1b0900f).below.xs]: {
        maxWidth: "270px"
    }
});
const $fc6840133e04adc0$var$$0efd93166e145c77$export$a3b47b9708ebe4f0 = {
    [$fc6840133e04adc0$var$$035f8a623e403361$export$490c7ce941281ba8.DEFAULT]: "dot-default",
    [$fc6840133e04adc0$var$$035f8a623e403361$export$490c7ce941281ba8.COMPLETED]: "dot-completed"
};
const $fc6840133e04adc0$var$$0efd93166e145c77$export$411533295806dc51 = (sectionContentfulId, seenSectionObserver)=>{
    const element = document.getElementById(`${sectionContentfulId}`);
    if (element) seenSectionObserver.unobserve(element);
};
const $fc6840133e04adc0$var$$0efd93166e145c77$export$a1fd357e7aacc4df = (0, $5FkrB.memo)(({ section: { title: title, id: id }, status: status, courseSlug: courseSlug, lessonSlug: lessonSlug, onSelect: onSelect, isSelected: isSelected })=>{
    const handleSectionClick = (e)=>{
        e.stopPropagation();
        onSelect(courseSlug || "", lessonSlug, id);
    };
    const handleKeyboardClick = (0, $5FkrB.useCallback)(()=>{
        onSelect(courseSlug || "", lessonSlug, id);
    }, [
        onSelect,
        courseSlug,
        lessonSlug,
        id
    ]);
    const onKeyDown = $fc6840133e04adc0$export$2a0b6757d41dacb2(handleKeyboardClick);
    const getIconType = ()=>{
        if (isSelected && status === $fc6840133e04adc0$var$$035f8a623e403361$export$490c7ce941281ba8.COMPLETED) return $fc6840133e04adc0$var$$0efd93166e145c77$export$a3b47b9708ebe4f0[status];
        if (isSelected) return "dot-selected";
        return $fc6840133e04adc0$var$$0efd93166e145c77$export$a3b47b9708ebe4f0[status];
    };
    const type = getIconType();
    return (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
        role: "button",
        tabIndex: 0,
        "data-testid": "sidebar-section-item",
        css: [
            $fc6840133e04adc0$var$$0efd93166e145c77$var$sectionBarStyles,
            isSelected && $fc6840133e04adc0$var$$0efd93166e145c77$var$sectionBarSelectedStyles
        ],
        onClick: handleSectionClick,
        onKeyDown: onKeyDown,
        children: [
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$export$f04a61298a47a40f, {
                type: type,
                color: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.icon")
            }),
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$var$$47b694880a211b2b$export$c0d3d8bfa41e2e2a, {
                text: title,
                status: status,
                isSelected: isSelected,
                appearance: $fc6840133e04adc0$var$$47b694880a211b2b$export$40bdb27f2137fcf.SECTION
            })
        ]
    });
});
const $fc6840133e04adc0$var$$0efd93166e145c77$var$sectionBarStyles = (0, $74Zh5.css)({
    position: "relative",
    display: "flex",
    alignItems: "center",
    width: "100%",
    padding: "4px 0 4px 10px",
    borderRadius: "4px",
    cursor: "pointer",
    "&:active": {
        background: `${(0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.background.accent.gray.subtlest.hovered")} !important`
    },
    "&:hover": {
        background: "rgba(220, 223, 228, 0.50)",
        "&::before": {
            content: '""',
            display: "block",
            width: "2px",
            height: "12px",
            position: "absolute",
            left: 0,
            top: "50%",
            transform: "translateY(-50%)",
            background: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.background.neutral")
        }
    }
});
const $fc6840133e04adc0$var$$0efd93166e145c77$var$sectionBarSelectedStyles = (0, $74Zh5.css)({
    "&::before": {
        content: '""',
        display: "block",
        width: "2px",
        height: "12px",
        position: "absolute",
        left: 0,
        top: "50%",
        transform: "translateY(-50%)",
        background: `${(0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.text.selected")} !important`
    }
});
const $fc6840133e04adc0$var$$4baed82dabfd5555$var$loadingFlash = (0, $74Zh5.keyframes)`
  0% {
    background-position: -10px;
  }
  100% {
    background-position: calc(100% + 250px);
  }
`;
const $fc6840133e04adc0$var$$4baed82dabfd5555$var$skeletonStyles = (0, $74Zh5.css)({
    width: "100%",
    height: "100%",
    backgroundColor: "rgba(241, 242, 244, 1)",
    borderRadius: "4px",
    position: "relative",
    "&::before": {
        content: '""',
        display: "block",
        width: "100%",
        height: "100%",
        borderRadius: "4px",
        background: `linear-gradient(
      90deg,
      rgba(241, 242, 244, 1) 0,
      #f9f9f9 calc(50% - 25px),
      #f9f9f9 calc(50% + 25px),
      rgba(241, 242, 244, 1) 100%
    )`,
        backgroundSize: "35%",
        backgroundPosition: 0,
        backgroundRepeat: "no-repeat",
        animation: `${$fc6840133e04adc0$var$$4baed82dabfd5555$var$loadingFlash} 2.5s infinite linear`
    }
});
const $fc6840133e04adc0$var$$4baed82dabfd5555$export$27a22c945b52f415 = ()=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
        css: $fc6840133e04adc0$var$$4baed82dabfd5555$var$skeletonStyles,
        "data-testid": "skeleton-loader"
    });
const $fc6840133e04adc0$var$$193bb26965d10640$export$9794789a1567361c = (0, $5FkrB.memo)(()=>(0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
        css: $fc6840133e04adc0$var$$193bb26965d10640$var$loaderContainerStyles,
        children: [
            [
                ...Array(4)
            ].map((_, index)=>(0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                    css: $fc6840133e04adc0$var$$193bb26965d10640$var$sectionBarStyles,
                    children: [
                        (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$export$f04a61298a47a40f, {
                            type: $fc6840133e04adc0$var$$0ca1c0d89e77a13d$export$a3b47b9708ebe4f0[$fc6840133e04adc0$var$$035f8a623e403361$export$490c7ce941281ba8.DEFAULT],
                            color: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.icon")
                        }),
                        (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                            css: $fc6840133e04adc0$var$$193bb26965d10640$var$skeletonLoaderBarStyles,
                            children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$var$$4baed82dabfd5555$export$27a22c945b52f415, {})
                        })
                    ]
                }, index)),
            (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                css: $fc6840133e04adc0$var$$193bb26965d10640$var$sectionBarStyles,
                children: [
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$export$f04a61298a47a40f, {
                        type: $fc6840133e04adc0$var$$0ca1c0d89e77a13d$export$a3b47b9708ebe4f0[$fc6840133e04adc0$var$$035f8a623e403361$export$490c7ce941281ba8.DEFAULT],
                        color: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.icon")
                    }),
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$var$$47b694880a211b2b$export$c0d3d8bfa41e2e2a, {
                        text: "Quiz",
                        status: $fc6840133e04adc0$var$$035f8a623e403361$export$490c7ce941281ba8.DEFAULT,
                        isSelected: false
                    })
                ]
            })
        ]
    }));
const $fc6840133e04adc0$var$$193bb26965d10640$var$loaderContainerStyles = (0, $74Zh5.css)({
    display: "flex",
    flexDirection: "column",
    gap: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.100"),
    padding: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.100")
});
const $fc6840133e04adc0$var$$193bb26965d10640$var$skeletonLoaderBarStyles = (0, $74Zh5.css)({
    width: "100%",
    height: "20px",
    marginLeft: "10px"
});
const $fc6840133e04adc0$var$$193bb26965d10640$var$sectionBarStyles = (0, $74Zh5.css)({
    position: "relative",
    display: "flex",
    alignItems: "center",
    width: "100%",
    padding: "4px 0 4px 10px",
    borderRadius: "4px",
    cursor: "pointer",
    "&:hover": {
        background: "rgba(220, 223, 228, 0.50)",
        "&::before": {
            content: '""',
            display: "block",
            width: "2px",
            height: "12px",
            position: "absolute",
            left: 0,
            top: "50%",
            transform: "translateY(-50%)",
            background: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.background.neutral")
        }
    }
});
const $fc6840133e04adc0$var$$fd3fa057a77982d6$export$1f81c5947c983f13 = (0, $5FkrB.memo)((props)=>{
    const { lesson: { slug: slug, sectionListCollection: sectionListCollection }, progressForLesson: progressForLesson, isLoading: isLoading, courseSlug: courseSlug, selectedSectionId: selectedSectionId, currentLessonSlug: currentLessonSlug, onSelect: onSelect, isLessonCardExpanded: isLessonCardExpanded, isMobile: isMobile } = props;
    if (isLoading && isLessonCardExpanded) return (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$var$$193bb26965d10640$export$9794789a1567361c, {});
    if (!isLessonCardExpanded || isMobile) return null;
    const status = $fc6840133e04adc0$var$$48630d5962798e4a$export$272e7ef3ea22070d(progressForLesson?.status);
    return (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
        css: $fc6840133e04adc0$var$$fd3fa057a77982d6$var$sectionContainerStyles,
        children: sectionListCollection.items.map((section)=>{
            const sectionStatus = section.id === "quiz" && status === $fc6840133e04adc0$var$$035f8a623e403361$export$490c7ce941281ba8.COMPLETED ? $fc6840133e04adc0$var$$035f8a623e403361$export$490c7ce941281ba8.COMPLETED : $fc6840133e04adc0$var$$48630d5962798e4a$export$272e7ef3ea22070d(progressForLesson?.section.find((sectionProgress)=>sectionProgress.sectionId === section.sys.id)?.status);
            return (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$var$$0efd93166e145c77$export$a1fd357e7aacc4df, {
                section: section,
                status: sectionStatus,
                onSelect: onSelect,
                lessonSlug: slug,
                courseSlug: courseSlug,
                isSelected: currentLessonSlug === slug && section.sys.id === selectedSectionId
            }, section.id);
        })
    });
});
const $fc6840133e04adc0$var$$fd3fa057a77982d6$var$sectionContainerStyles = (0, $74Zh5.css)({
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "column",
    marginLeft: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.200"),
    marginTop: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.100")
});
const $fc6840133e04adc0$var$$d1d0f9af78cf2050$export$5496f515fa03c54e = (totalMinutes)=>{
    if (totalMinutes > 59) {
        const hours = Math.floor(totalMinutes / 60);
        const minutes = totalMinutes % 60;
        if (minutes === 0) return `${hours} h`;
        return `${hours} h ${minutes} min`;
    }
    return `${totalMinutes} min`;
};
const $fc6840133e04adc0$var$$0ca1c0d89e77a13d$export$db6f237c151666ee = 480;
const $fc6840133e04adc0$var$$0ca1c0d89e77a13d$export$a3b47b9708ebe4f0 = {
    [$fc6840133e04adc0$var$$035f8a623e403361$export$490c7ce941281ba8.DEFAULT]: "dot-default",
    [$fc6840133e04adc0$var$$035f8a623e403361$export$490c7ce941281ba8.COMPLETED]: "dot-completed"
};
const $fc6840133e04adc0$var$$0ca1c0d89e77a13d$export$951debaed2d5c034 = (0, $5FkrB.memo)((props)=>{
    const { lesson: { sys: sys, slug: slug, title: title, duration: duration }, courseSlug: courseSlug, isLoading: isLoading, progressForLesson: progressForLesson, onSelect: onSelect, expandedLessonIds: expandedLessonIds, selectedSectionId: selectedSectionId, currentLessonSlug: currentLessonSlug, isCourse: isCourse } = props;
    const deviceSize = $fc6840133e04adc0$export$4616d33c54ae5baf();
    const isMobile = deviceSize <= $fc6840133e04adc0$var$$0ca1c0d89e77a13d$export$db6f237c151666ee;
    const isSelected = $fc6840133e04adc0$var$$48630d5962798e4a$export$15379570ba48f04d("", slug);
    const status = $fc6840133e04adc0$var$$48630d5962798e4a$export$272e7ef3ea22070d(progressForLesson?.status);
    const [isLessonCardExpanded, setIsLessonCardExpanded] = (0, $5FkrB.useState)(false);
    (0, $5FkrB.useEffect)(()=>{
        const isExpanded = expandedLessonIds?.includes(sys.id);
        setIsLessonCardExpanded(isExpanded || false);
    }, [
        expandedLessonIds
    ]);
    /* eslint-enable react-hooks/exhaustive-deps */ const handleExpandClick = (e)=>{
        e.stopPropagation();
        setIsLessonCardExpanded(!isLessonCardExpanded);
    };
    const handleCardClick = (0, $5FkrB.useCallback)(()=>{
        setIsLessonCardExpanded(true);
        onSelect(courseSlug || "", slug);
    }, [
        courseSlug,
        slug,
        onSelect
    ]);
    const handleExpandKeyboard = (0, $5FkrB.useCallback)(()=>{
        setIsLessonCardExpanded(!isLessonCardExpanded);
    }, [
        isLessonCardExpanded
    ]);
    const onKeyDownCard = $fc6840133e04adc0$export$2a0b6757d41dacb2(handleCardClick);
    const onKeyDownExpand = $fc6840133e04adc0$export$2a0b6757d41dacb2(handleExpandKeyboard);
    const renderStatusIndicator = ()=>{
        if (status === $fc6840133e04adc0$var$$035f8a623e403361$export$490c7ce941281ba8.COMPLETED) return (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$export$f04a61298a47a40f, {
            type: "check-circle-outline",
            color: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.icon.success")
        });
        return (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
            css: [
                $fc6840133e04adc0$var$$0ca1c0d89e77a13d$var$lessonTimeBadgeStyles,
                isSelected && $fc6840133e04adc0$var$$0ca1c0d89e77a13d$var$lessonTimeBadgeSelectedStyles
            ],
            children: $fc6840133e04adc0$var$$d1d0f9af78cf2050$export$5496f515fa03c54e(duration)
        });
    };
    return (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
        "data-testid": "sidebar-lesson-card",
        css: [
            $fc6840133e04adc0$var$$0ca1c0d89e77a13d$var$lessonCardStyles,
            isSelected && $fc6840133e04adc0$var$$0ca1c0d89e77a13d$var$lessonCardSelectedStyles
        ],
        children: [
            (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                role: "button",
                tabIndex: 0,
                css: [
                    $fc6840133e04adc0$var$$0ca1c0d89e77a13d$var$lessonCardHeaderStyles,
                    isMobile && $fc6840133e04adc0$var$$0ca1c0d89e77a13d$var$lessonCardHeaderMobileStyles,
                    isCourse && isMobile && $fc6840133e04adc0$var$$0ca1c0d89e77a13d$var$lessonCardHeaderCourseStyles
                ],
                onClick: handleCardClick,
                onKeyDown: onKeyDownCard,
                children: [
                    !isMobile && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                        role: "button",
                        tabIndex: 0,
                        css: $fc6840133e04adc0$var$$0ca1c0d89e77a13d$var$lessonExpanderStyles,
                        onClick: handleExpandClick,
                        onKeyDown: onKeyDownExpand,
                        children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$export$f04a61298a47a40f, {
                            type: isLessonCardExpanded ? "chevron-down" : "chevron-right",
                            color: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.icon")
                        })
                    }),
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$var$$47b694880a211b2b$export$c0d3d8bfa41e2e2a, {
                        text: title,
                        isSelected: isSelected,
                        appearance: $fc6840133e04adc0$var$$47b694880a211b2b$export$40bdb27f2137fcf.LESSON
                    }),
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                        css: $fc6840133e04adc0$var$$0ca1c0d89e77a13d$var$lessonTimeBadgeContainerStyles,
                        children: renderStatusIndicator()
                    })
                ]
            }),
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$var$$fd3fa057a77982d6$export$1f81c5947c983f13, {
                lesson: props.lesson,
                progressForLesson: progressForLesson,
                isLoading: isLoading,
                courseSlug: courseSlug,
                selectedSectionId: selectedSectionId,
                currentLessonSlug: currentLessonSlug,
                onSelect: onSelect,
                isLessonCardExpanded: isLessonCardExpanded,
                isMobile: isMobile
            })
        ]
    });
});
const $fc6840133e04adc0$var$$0ca1c0d89e77a13d$var$lessonCardStyles = (0, $74Zh5.css)({
    display: "flex",
    width: "100%",
    flexDirection: "column",
    paddingTop: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.100"),
    paddingBottom: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.100"),
    paddingLeft: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.250"),
    paddingRight: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.100"),
    "&:active": {
        background: "#F1F2F4 !important"
    },
    "&:hover": {
        background: "#F7F8F9"
    }
});
const $fc6840133e04adc0$var$$0ca1c0d89e77a13d$var$lessonCardSelectedStyles = (0, $74Zh5.css)({
    background: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.background.input.hovered"),
    "&:active": {
        background: `${(0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.background.input.hovered")} !important`
    }
});
const $fc6840133e04adc0$var$$0ca1c0d89e77a13d$var$lessonCardHeaderStyles = (0, $74Zh5.css)({
    display: "flex",
    justifyContent: "start",
    alignItems: "center",
    cursor: "pointer"
});
const $fc6840133e04adc0$var$$0ca1c0d89e77a13d$var$lessonCardHeaderMobileStyles = (0, $74Zh5.css)({
    marginLeft: `calc(${(0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.300")} + ${(0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.025")})`
});
const $fc6840133e04adc0$var$$0ca1c0d89e77a13d$var$lessonCardHeaderCourseStyles = (0, $74Zh5.css)({
    marginLeft: 0
});
const $fc6840133e04adc0$var$$0ca1c0d89e77a13d$var$lessonExpanderStyles = (0, $74Zh5.css)({
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "24px",
    height: "24px",
    borderRadius: "4px",
    cursor: "pointer",
    marginRight: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.025"),
    "&:hover": {
        background: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("elevation.surface.pressed")
    }
});
const $fc6840133e04adc0$var$$0ca1c0d89e77a13d$var$lessonTimeBadgeStyles = (0, $74Zh5.css)({
    fontFamily: "Inter, sans-serif",
    fontSize: "12px",
    lineHeight: "18px",
    fontWeight: 400,
    color: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.text"),
    padding: `${(0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.025")} ${(0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.075")}`,
    borderRadius: "8px",
    background: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.background.neutral"),
    marginLeft: "auto"
});
const $fc6840133e04adc0$var$$0ca1c0d89e77a13d$var$lessonTimeBadgeSelectedStyles = (0, $74Zh5.css)({
    color: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.text.brand"),
    background: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.background.brand.subtlest")
});
const $fc6840133e04adc0$var$$0ca1c0d89e77a13d$var$lessonTimeBadgeContainerStyles = (0, $74Zh5.css)({
    marginLeft: "auto"
});
const $fc6840133e04adc0$var$$11732cc088354996$export$748c6b3a71d1e268 = (0, $5FkrB.memo)(()=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $6bec4f26b2cb3094$export$ffb0004e005737fa), {
        children: [
            ...Array(4)
        ].map((_, index)=>(0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                css: $fc6840133e04adc0$var$$11732cc088354996$var$lessonCardHeaderStyles,
                children: [
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                        css: $fc6840133e04adc0$var$$11732cc088354996$var$lessonExpanderStyles,
                        children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$export$f04a61298a47a40f, {
                            type: "chevron-right",
                            color: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.icon")
                        })
                    }),
                    (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                        css: $fc6840133e04adc0$var$$11732cc088354996$var$skeletonLoaderBarStyles,
                        children: [
                            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$var$$4baed82dabfd5555$export$27a22c945b52f415, {}),
                            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                                css: $fc6840133e04adc0$var$$11732cc088354996$var$skeletonTimeLoaderBarStyles,
                                children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$var$$4baed82dabfd5555$export$27a22c945b52f415, {})
                            })
                        ]
                    })
                ]
            }, index))
    }));
const $fc6840133e04adc0$var$$11732cc088354996$var$lessonCardHeaderStyles = (0, $74Zh5.css)({
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    paddingTop: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.100"),
    paddingBottom: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.100"),
    paddingLeft: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.250"),
    paddingRight: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.100")
});
const $fc6840133e04adc0$var$$11732cc088354996$var$lessonExpanderStyles = (0, $74Zh5.css)({
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "24px",
    height: "24px",
    borderRadius: "4px"
});
const $fc6840133e04adc0$var$$11732cc088354996$var$skeletonTimeLoaderBarStyles = (0, $74Zh5.css)({
    width: "50px",
    height: "20px",
    marginLeft: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.300")
});
const $fc6840133e04adc0$var$$11732cc088354996$var$skeletonLoaderBarStyles = (0, $74Zh5.css)({
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "100%",
    height: "20px",
    marginLeft: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.025")
});
const $fc6840133e04adc0$var$$aefb4e9d0a694068$var$COURSE_CARD_TITLE = {
    [$fc6840133e04adc0$var$$035f8a623e403361$export$490c7ce941281ba8.COMPLETED]: "Completed",
    [$fc6840133e04adc0$var$$035f8a623e403361$export$490c7ce941281ba8.DEFAULT]: "Course"
};
const $fc6840133e04adc0$var$$aefb4e9d0a694068$var$CourseCardHeaderContent = ({ isCourseExpanded: isCourseExpanded, isSelected: isSelected, status: status, title: title })=>(0, $6bec4f26b2cb3094$export$25062201e9e25d76)((0, $6bec4f26b2cb3094$export$ffb0004e005737fa), {
        children: [
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                css: [
                    $fc6840133e04adc0$var$$aefb4e9d0a694068$var$courseExpanderStyles,
                    isCourseExpanded && $fc6840133e04adc0$var$$aefb4e9d0a694068$var$courseExpanderSelectedStyles
                ],
                children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$export$f04a61298a47a40f, {
                    type: isCourseExpanded ? "chevron-down" : "chevron-right",
                    color: isCourseExpanded ? (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.icon.selected") : (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.icon")
                })
            }),
            (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                css: $fc6840133e04adc0$var$$aefb4e9d0a694068$var$courseTitleContainerStyles,
                children: [
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("p", {
                        css: [
                            $fc6840133e04adc0$var$$aefb4e9d0a694068$var$courseCardTitleStyles,
                            status === $fc6840133e04adc0$var$$035f8a623e403361$export$490c7ce941281ba8.COMPLETED && $fc6840133e04adc0$var$$aefb4e9d0a694068$var$courseCardTitleCompletedStyles,
                            status === $fc6840133e04adc0$var$$035f8a623e403361$export$490c7ce941281ba8.DEFAULT && $fc6840133e04adc0$var$$aefb4e9d0a694068$var$courseCardTitleDefaultStyles,
                            isSelected && $fc6840133e04adc0$var$$aefb4e9d0a694068$var$courseCardTitleSelectedStyles
                        ],
                        children: isSelected ? "Current course".toUpperCase() : $fc6840133e04adc0$var$$aefb4e9d0a694068$var$COURSE_CARD_TITLE[status].toUpperCase()
                    }),
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$var$$47b694880a211b2b$export$c0d3d8bfa41e2e2a, {
                        text: title,
                        isSelected: isSelected,
                        appearance: $fc6840133e04adc0$var$$47b694880a211b2b$export$40bdb27f2137fcf.COURSE
                    })
                ]
            })
        ]
    });
const $fc6840133e04adc0$var$$aefb4e9d0a694068$export$bb61bd2f4f2a772c = (props)=>{
    const { handleMouseEnter: handleMouseEnter, handleMouseLeave: handleMouseLeave, popupRef: popupRef } = $fc6840133e04adc0$var$$32c02b5652036d7a$export$861cd542ff836f0d();
    const mouseLeaveHandler = (0, $5FkrB.useCallback)((e, id, courseCardRef)=>{
        const lessonPage = document.getElementById("lesson-page-body");
        const isMovedToSidebar = e.relatedTarget?.tagName === "ASIDE";
        if (!e.relatedTarget || !e.relatedTarget.nodeType || isMovedToSidebar || e.relatedTarget === props.scrollContainerRef.current || lessonPage?.contains(e.relatedTarget)) {
            handleMouseLeave();
            return;
        }
        if (e.currentTarget === courseCardRef.current || e.relatedTarget === popupRef.current) return;
        handleMouseLeave(id);
    }, [
        handleMouseLeave,
        popupRef,
        props.scrollContainerRef
    ]);
    return (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$var$$aefb4e9d0a694068$export$7b8f328152f30a2c, {
        ...props,
        onHover: handleMouseEnter,
        onMouseLeave: mouseLeaveHandler,
        popupRef: popupRef
    });
};
const $fc6840133e04adc0$var$$aefb4e9d0a694068$export$7b8f328152f30a2c = (0, $5FkrB.memo)(({ course: { sys: sys, title: title, reward: reward, slug: slug, lessonsCollection: lessonsCollection }, status: status, isLoading: isLoading, selectedLessonRef: selectedLessonRef, progressForLessons: progressForLessons, onHover: onHover, onMouseLeave: onMouseLeave, onSelect: onSelect, expandedLessonIds: expandedLessonIds = [], expandedCourseIds: expandedCourseIds = [], selectedSectionId: selectedSectionId, currentLessonSlug: currentLessonSlug })=>{
    const courseCardRef = (0, $5FkrB.useRef)(null);
    const isSelected = $fc6840133e04adc0$var$$48630d5962798e4a$export$15379570ba48f04d(slug);
    const [isCourseExpanded, setIsCourseExpanded] = (0, $5FkrB.useState)(false);
    (0, $5FkrB.useEffect)(()=>{
        const isExpanded = expandedCourseIds.includes(sys.id);
        setIsCourseExpanded(isExpanded || false);
    }, [
        expandedCourseIds
    ]);
    /* eslint-enable react-hooks/exhaustive-deps */ const handleCourseCardExpand = (0, $5FkrB.useCallback)(()=>{
        setIsCourseExpanded(!isCourseExpanded);
        onSelect(slug);
    }, [
        isCourseExpanded,
        onSelect,
        slug
    ]);
    const showCoursePopup = (0, $5FkrB.useCallback)(()=>{
        if (courseCardRef.current) onHover({
            courseId: sys.id,
            courseCardPosition: courseCardRef.current.getBoundingClientRect()
        });
    }, [
        sys.id,
        onHover
    ]);
    const hideCoursePopup = (0, $5FkrB.useCallback)((e)=>{
        onMouseLeave(e, sys.id, courseCardRef);
    }, [
        onMouseLeave,
        sys.id,
        courseCardRef
    ]);
    const onKeyDown = $fc6840133e04adc0$export$2a0b6757d41dacb2(handleCourseCardExpand);
    return (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
        "data-testid": "sidebar-course-card",
        css: [
            $fc6840133e04adc0$var$$aefb4e9d0a694068$var$courseCardStyles,
            isCourseExpanded && $fc6840133e04adc0$var$$aefb4e9d0a694068$var$courseCardOpenedStyles
        ],
        ref: courseCardRef,
        onMouseEnter: showCoursePopup,
        onMouseLeave: hideCoursePopup,
        children: [
            (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                role: "button",
                tabIndex: 0,
                css: [
                    $fc6840133e04adc0$var$$aefb4e9d0a694068$var$courseCardHeaderStyles,
                    isCourseExpanded && $fc6840133e04adc0$var$$aefb4e9d0a694068$var$courseCardHeaderOpenedStyles
                ],
                onClick: handleCourseCardExpand,
                onKeyDown: onKeyDown,
                onMouseEnter: showCoursePopup,
                "data-testid": "course-card-header",
                children: [
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$var$$aefb4e9d0a694068$var$CourseCardHeaderContent, {
                        isCourseExpanded: isCourseExpanded,
                        isSelected: isSelected,
                        status: status,
                        title: title
                    }),
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$var$$6cca9b298ff547cb$export$a9a23386c3e0c05f, {
                        lessonsCollection: lessonsCollection,
                        progressForLessons: progressForLessons,
                        reward: reward,
                        title: title
                    })
                ]
            }),
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                css: $fc6840133e04adc0$var$$aefb4e9d0a694068$var$lessonContainerStyles,
                onMouseEnter: hideCoursePopup,
                children: isLoading && isCourseExpanded ? (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$var$$11732cc088354996$export$748c6b3a71d1e268, {}) : isCourseExpanded && lessonsCollection.items.map((lesson)=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                        ref: $fc6840133e04adc0$var$$48630d5962798e4a$export$15379570ba48f04d("", lesson.slug) ? selectedLessonRef : null,
                        children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$var$$0ca1c0d89e77a13d$export$951debaed2d5c034, {
                            lesson: lesson,
                            courseSlug: slug,
                            progressForLesson: progressForLessons?.lessons.find((lessonProgress)=>lessonProgress.lessonId === lesson.sys.id),
                            onSelect: onSelect,
                            isLoading: isLoading,
                            expandedLessonIds: expandedLessonIds,
                            selectedSectionId: selectedSectionId,
                            currentLessonSlug: currentLessonSlug
                        })
                    }, lesson.sys.id))
            })
        ]
    });
});
const $fc6840133e04adc0$var$$aefb4e9d0a694068$var$courseCardStyles = (0, $74Zh5.css)({
    display: "flex",
    width: "100%",
    flexDirection: "column",
    paddingTop: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.300"),
    paddingBottom: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.300"),
    borderBottom: `1px solid ${(0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.border")}`,
    "&:hover": {
        background: "#F7F8F9"
    }
});
const $fc6840133e04adc0$var$$aefb4e9d0a694068$var$courseCardOpenedStyles = (0, $74Zh5.css)({
    paddingBottom: 0,
    "&:hover": {
        background: "none"
    }
});
const $fc6840133e04adc0$var$$aefb4e9d0a694068$var$courseCardHeaderStyles = (0, $74Zh5.css)({
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    cursor: "pointer",
    paddingLeft: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.100"),
    paddingRight: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.100")
});
const $fc6840133e04adc0$var$$aefb4e9d0a694068$var$courseCardHeaderOpenedStyles = (0, $74Zh5.css)({
    marginBottom: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.100")
});
const $fc6840133e04adc0$var$$aefb4e9d0a694068$var$courseExpanderStyles = (0, $74Zh5.css)({
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "24px",
    height: "24px",
    borderRadius: "4px",
    border: `1px solid ${(0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.background.accent.gray.subtlest")}`,
    cursor: "pointer"
});
const $fc6840133e04adc0$var$$aefb4e9d0a694068$var$courseExpanderSelectedStyles = (0, $74Zh5.css)({
    border: `1px solid ${(0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.background.accent.blue.subtler")}`
});
const $fc6840133e04adc0$var$$aefb4e9d0a694068$var$courseTitleContainerStyles = (0, $74Zh5.css)({
    display: "flex",
    flexDirection: "column",
    marginLeft: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.100"),
    marginRight: "auto"
});
const $fc6840133e04adc0$var$$aefb4e9d0a694068$var$courseCardTitleStyles = (0, $74Zh5.css)({
    fontFamily: "Charlie Display, sans-serif",
    fontSize: "12px",
    fontWeight: 600,
    lineHeight: "16px"
});
const $fc6840133e04adc0$var$$aefb4e9d0a694068$var$courseCardTitleSelectedStyles = (0, $74Zh5.css)({
    color: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.text.selected")
});
const $fc6840133e04adc0$var$$aefb4e9d0a694068$var$courseCardTitleCompletedStyles = (0, $74Zh5.css)({
    color: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.text.success")
});
const $fc6840133e04adc0$var$$aefb4e9d0a694068$var$courseCardTitleDefaultStyles = (0, $74Zh5.css)({
    color: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.text.subtlest")
});
const $fc6840133e04adc0$var$$aefb4e9d0a694068$var$lessonContainerStyles = (0, $74Zh5.css)({
    display: "flex",
    flexDirection: "column",
    gap: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.100")
});
var $fc6840133e04adc0$var$$e48fba9cf5395297$require$Buffer = (0, $7KfP5.Buffer);
const $fc6840133e04adc0$var$$e48fba9cf5395297$var$courseBg = `<svg width="419" height="16" viewBox="0 0 419 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clipPath="url(#clip0_550_14457)">
<rect width="419" height="16" fill="#CCE0FF"/>
<g clipPath="url(#clip1_550_14457)">
<path d="M419.987 -18.5349C419.996 -18.6007 420.003 -18.6684 420.014 -18.7323C420.032 -18.7947 420.048 -18.8548 420.064 -18.915C420.099 -19.0356 420.114 -19.1585 420.159 -19.2632C420.248 -19.4786 420.309 -19.6895 420.416 -19.8625C420.463 -19.9546 420.508 -20.0404 420.551 -20.1238C420.603 -20.2039 420.653 -20.2775 420.702 -20.3488C420.75 -20.4201 420.79 -20.4949 420.836 -20.5598C420.888 -20.6209 420.931 -20.6813 420.974 -20.7375C421.14 -20.9764 421.288 -21.1424 421.37 -21.2817C421.452 -21.421 421.479 -21.522 421.443 -21.5797C421.407 -21.6374 421.307 -21.6518 421.142 -21.6124C420.978 -21.5729 420.733 -21.4929 420.458 -21.2992C420.387 -21.251 420.313 -21.2006 420.234 -21.1476C420.159 -21.0907 420.086 -21.0172 420.006 -20.9452C419.928 -20.8714 419.847 -20.793 419.762 -20.7101C419.686 -20.6195 419.613 -20.5188 419.533 -20.4154C419.364 -20.214 419.244 -19.956 419.102 -19.6814C419.032 -19.5431 418.992 -19.3907 418.936 -19.2369C418.91 -19.159 418.885 -19.0793 418.86 -18.9995C418.838 -18.9178 418.826 -18.835 418.809 -18.7495C418.615 -17.7843 418.69 -16.8131 418.876 -15.8955C419.059 -14.9692 419.392 -14.1022 419.756 -13.244C419.947 -12.82 420.142 -12.3941 420.364 -11.9832C420.574 -11.563 420.81 -11.1596 421.049 -10.7501L421.231 -10.4386C421.302 -10.321 421.379 -10.2101 421.453 -10.1053C421.527 -10.0006 421.606 -9.89614 421.681 -9.80195L421.834 -9.60333C421.861 -9.56574 421.887 -9.52816 421.909 -9.49438C421.917 -9.47618 421.939 -9.45715 421.93 -9.44167L421.87 -9.4071L421.756 -9.34475C421.555 -9.2203 421.349 -9.09548 421.146 -8.96877C420.732 -8.71463 420.314 -8.45596 419.889 -8.19466C419.043 -7.67017 418.178 -7.13781 417.292 -6.58888C415.522 -5.48495 413.666 -4.32951 411.701 -3.10375C411.569 -3.02103 411.438 -2.9383 411.311 -2.85594L411.263 -2.82245C411.247 -2.81267 411.23 -2.79231 411.213 -2.79503L411.176 -2.83796L411.129 -2.89683C411.053 -2.99935 410.979 -3.09997 410.908 -3.19868C410.748 -3.42193 410.595 -3.64364 410.445 -3.8657C409.853 -4.75016 409.317 -5.59122 408.833 -6.35712C407.867 -7.87642 407.139 -9.19183 406.523 -10.4477C405.911 -11.704 405.395 -12.8909 404.961 -14.1983C404.532 -15.5018 404.156 -16.9191 403.941 -18.6294C403.764 -20.0724 403.734 -21.6582 403.948 -23.2902C404.067 -24.102 404.224 -24.9319 404.485 -25.7435C404.596 -26.156 404.761 -26.5543 404.909 -26.9594C405.08 -27.3562 405.245 -27.7586 405.453 -28.1438C405.847 -28.925 406.311 -29.6786 406.85 -30.3841C407.385 -31.0935 407.973 -31.7656 408.624 -32.3738C408.936 -32.6905 409.287 -32.9706 409.619 -33.2637C409.969 -33.5374 410.311 -33.821 410.678 -34.0689C411.033 -34.3347 411.41 -34.5667 411.777 -34.8021C412.152 -35.0318 412.539 -35.2437 412.914 -35.465C414.436 -36.3062 415.99 -36.9507 417.497 -37.3604C419.003 -37.7742 420.458 -37.9529 421.776 -37.9727C423.096 -37.9948 424.276 -37.8642 425.269 -37.709C426.262 -37.5579 427.07 -37.3657 427.646 -37.233L428.69 -36.9731C429.045 -36.8906 429.419 -36.816 429.771 -36.7438C430.378 -36.6242 431.227 -36.4356 432.428 -36.2523C433.028 -36.1615 433.721 -36.0769 434.532 -36.0632C435.339 -36.0534 436.29 -36.1149 437.298 -36.4729C437.804 -36.6385 438.302 -36.8957 438.794 -37.2048C439.033 -37.3787 439.288 -37.5351 439.516 -37.7605C439.63 -37.869 439.756 -37.968 439.863 -38.0906C439.969 -38.2173 440.076 -38.3441 440.183 -38.4708C440.585 -39.0093 440.922 -39.6533 441.087 -40.36C441.245 -41.0619 441.295 -41.8006 441.211 -42.5236C441.061 -43.9793 440.534 -45.3835 439.853 -46.7869C439.509 -47.4894 439.114 -48.1853 438.684 -48.8866C438.47 -49.2437 438.255 -49.5754 438.036 -49.9299C437.987 -50.0054 437.941 -50.0791 437.892 -50.1546L437.861 -50.2043C437.876 -50.2183 437.894 -50.2303 437.914 -50.2446C437.836 -50.198 438.202 -50.4311 438.461 -50.5962C439.016 -50.9486 439.658 -51.3547 440.372 -51.809C441.803 -52.7114 443.524 -53.7985 445.425 -54.9977C446.336 -55.5719 447.291 -56.1709 448.275 -56.789L448.326 -56.8229C448.342 -56.8285 448.363 -56.8575 448.374 -56.8291L448.412 -56.782L448.504 -56.6579C448.854 -56.1741 449.194 -55.6643 449.531 -55.1417C449.866 -54.6085 450.202 -54.0711 450.54 -53.5318C450.86 -52.9887 451.204 -52.4562 451.506 -51.9012C452.14 -50.8042 452.697 -49.6712 453.218 -48.5372C454.609 -45.4748 455.414 -42.5189 455.622 -39.8407C455.835 -37.1587 455.451 -34.7733 454.708 -32.833C453.969 -30.8848 452.931 -29.3702 451.906 -28.2006C450.869 -27.0365 449.854 -26.1974 448.994 -25.5647C448.74 -25.3769 448.489 -25.1936 448.225 -25.0259C447.964 -24.8543 447.711 -24.6813 447.441 -24.5299C447.177 -24.3728 446.912 -24.2175 446.652 -24.0608C446.391 -23.9059 446.118 -23.7795 445.858 -23.6394C445.335 -23.3486 444.792 -23.1336 444.267 -22.8909C444.001 -22.7819 443.73 -22.6891 443.467 -22.5865L443.07 -22.4368L442.67 -22.3139C441.607 -21.9637 440.54 -21.7558 439.49 -21.6187C438.439 -21.4751 437.397 -21.4582 436.377 -21.4936C435.354 -21.5266 434.349 -21.6452 433.361 -21.7966C432.866 -21.869 432.377 -21.9631 431.889 -22.0529C431.396 -22.1508 430.914 -22.258 430.418 -22.3472C429.434 -22.5326 428.468 -22.7237 427.477 -22.8686C426.491 -23.014 425.476 -23.1064 424.439 -23.0396C423.318 -22.955 422.489 -22.6083 422.02 -22.2885C421.775 -22.1351 421.62 -21.979 421.526 -21.8617C421.431 -21.7444 421.396 -21.6575 421.422 -21.6051L421.393 -21.4788C421.408 -21.4697 421.421 -21.4749 421.419 -21.4957L421.417 -21.6089L421.441 -21.5816C421.478 -21.5345 421.572 -21.5216 421.717 -21.5384C421.86 -21.5571 422.053 -21.6116 422.306 -21.665C422.804 -21.7878 423.52 -21.9506 424.501 -21.9791C426.333 -22.0036 428.217 -21.4933 430.151 -21.0651C432.069 -20.5956 434.122 -20.121 436.309 -19.9979C437.401 -19.9331 438.53 -19.9303 439.679 -20.0655C440.824 -20.1921 441.997 -20.4071 443.155 -20.7739L443.593 -20.9042L444.026 -21.0614C444.313 -21.168 444.608 -21.2671 444.896 -21.3844C445.464 -21.6371 446.054 -21.8709 446.616 -22.1755C446.899 -22.3238 447.191 -22.4604 447.471 -22.6231C447.751 -22.7858 448.03 -22.9527 448.316 -23.1181C448.602 -23.2793 448.877 -23.4647 449.157 -23.6505C449.44 -23.8303 449.714 -24.0282 449.988 -24.2304C450.841 -24.8582 451.905 -25.7016 453.021 -26.8957C453.309 -27.1871 453.571 -27.5225 453.863 -27.8605C454.004 -28.0321 454.137 -28.2178 454.276 -28.4019C454.418 -28.5841 454.554 -28.7744 454.686 -28.9767C455.233 -29.7648 455.74 -30.6669 456.174 -31.6739C457.054 -33.6806 457.614 -36.1379 457.566 -38.8279C457.534 -41.5171 456.936 -44.407 455.846 -47.313C455.131 -49.2086 454.232 -51.0191 453.22 -52.7275C453 -53.1092 452.768 -53.4857 452.531 -53.8595C452.294 -54.2398 452.058 -54.6159 451.817 -54.9852C451.333 -55.728 450.844 -56.4872 450.306 -57.24C450.171 -57.4276 450.035 -57.6151 449.893 -57.8043C449.653 -58.1255 449.383 -58.4567 449.123 -58.7678L448.927 -59.0067L448.828 -59.1241L448.779 -59.1849L448.713 -59.1435L448.187 -58.821L447.222 -58.2106C446.463 -57.721 445.702 -57.2332 444.944 -56.7458C443.425 -55.7748 441.918 -54.8133 440.448 -53.8739C438.753 -52.7996 437.104 -51.7523 435.527 -50.7531C435.991 -50.0108 436.451 -49.2806 436.903 -48.5602C437.066 -48.3037 437.217 -48.0566 437.362 -47.8111C437.505 -47.5633 437.664 -47.3253 437.793 -47.0784C438.349 -46.1047 438.792 -45.1297 439.105 -44.1938C439.417 -43.2556 439.58 -42.3464 439.535 -41.5453C439.493 -40.7422 439.25 -40.0623 438.851 -39.5598C438.46 -39.0496 437.954 -38.691 437.475 -38.4375C436.995 -38.1882 436.554 -38.0451 436.181 -37.9645C435.996 -37.9233 435.825 -37.9043 435.679 -37.8769C435.529 -37.8639 435.404 -37.8531 435.302 -37.8421C435.2 -37.8312 435.122 -37.8308 435.068 -37.8302C435.013 -37.8297 434.988 -37.8275 434.988 -37.8275C434.988 -37.8275 434.871 -37.8258 434.651 -37.8214C434.54 -37.8264 434.399 -37.8289 434.237 -37.8337C434.073 -37.8405 433.88 -37.8594 433.667 -37.8766C432.801 -37.959 431.531 -38.193 429.936 -38.5373C429.151 -38.6875 428.292 -38.9299 427.33 -39.1213C426.369 -39.3108 425.335 -39.5003 424.228 -39.5889C423.123 -39.684 421.952 -39.7105 420.741 -39.6161C419.533 -39.5114 418.291 -39.2883 417.058 -38.9422C415.82 -38.5999 414.613 -38.0966 413.43 -37.5304C412.848 -37.2281 412.256 -36.9335 411.697 -36.5849C411.125 -36.2584 410.565 -35.8951 410.019 -35.512C407.837 -33.9779 405.925 -31.9888 404.62 -29.7209C403.3 -27.462 402.621 -24.9776 402.422 -22.6921C402.327 -21.5467 402.342 -20.4485 402.416 -19.4205C402.469 -18.9089 402.508 -18.4129 402.588 -17.9394C402.625 -17.7034 402.656 -17.469 402.697 -17.2417C402.742 -17.0148 402.786 -16.792 402.83 -16.5776C403.106 -15.2754 403.444 -14.0752 403.836 -12.9845C404.024 -12.4364 404.237 -11.9177 404.431 -11.4142C404.65 -10.9212 404.839 -10.434 405.058 -9.98298C405.906 -8.16173 406.754 -6.6679 407.532 -5.40717C408.303 -4.16047 408.956 -3.11338 409.589 -2.21778C409.677 -2.09742 409.763 -1.97896 409.846 -1.8624C409.972 -1.69494 410.097 -1.53165 410.231 -1.36908C410.364 -1.21067 410.493 -1.0519 410.619 -0.899205C410.683 -0.822855 410.748 -0.748768 410.811 -0.672419C410.838 -0.607579 410.885 -0.664166 410.925 -0.684437L411.049 -0.758101C411.375 -0.947891 411.688 -1.14077 411.994 -1.33518C412.199 -1.46416 412.396 -1.58825 412.583 -1.70518C414.541 -2.94081 416.392 -4.10837 418.154 -5.22217C419.034 -5.78098 419.891 -6.32738 420.73 -6.86175C421.15 -7.13101 421.563 -7.39348 421.975 -7.65786C422.182 -7.7891 422.388 -7.9245 422.593 -8.05348L423.1 -8.37651L423.351 -8.53671L423.58 -8.69928L424.035 -9.02403L424.063 -9.04323L424.074 -9.05681C424.074 -9.05681 424.071 -9.06287 424.069 -9.06894L424.03 -9.12852L423.95 -9.24961L423.794 -9.48571C423.591 -9.79544 423.369 -10.1056 423.118 -10.405L422.846 -10.7381L422.646 -10.9914C422.584 -11.0742 422.525 -11.1592 422.472 -11.2385L422.296 -11.5213C422.062 -11.9038 421.823 -12.2818 421.616 -12.6688C421.392 -13.0502 421.203 -13.4408 421.015 -13.8274C420.658 -14.6063 420.324 -15.3894 420.137 -16.1874C419.943 -16.9804 419.861 -17.7833 419.977 -18.536L419.987 -18.5349Z" fill="#0055CC"/>
<path d="M375.063 24.9613C374.963 24.9469 374.87 24.934 374.776 24.9211C374.684 24.9207 374.594 24.9181 374.507 24.9151C374.335 24.9132 374.174 24.9167 374.025 24.9233C373.73 24.9258 373.486 24.9952 373.295 25.0474C372.911 25.1605 372.732 25.2998 372.737 25.4357C372.745 25.5735 372.937 25.7079 373.298 25.8109C373.477 25.8688 373.704 25.8932 373.964 25.9651C374.095 25.9937 374.236 26.0234 374.387 26.046C374.461 26.0584 374.54 26.0705 374.623 26.0822C374.702 26.1026 374.783 26.1207 374.867 26.1407C375.825 26.3325 376.729 26.7137 377.473 27.3312C378.22 27.9441 378.807 28.785 379.24 29.7755C379.678 30.7657 379.967 31.901 380.15 33.1252C380.208 33.4286 380.237 33.7429 380.273 34.0629C380.311 34.3807 380.35 34.7026 380.365 35.0327C380.388 35.3644 380.408 35.6983 380.431 36.0384C380.447 36.3874 380.465 36.7426 380.481 37.1C380.568 38.5486 380.642 39.8241 380.666 40.2417C381.225 40.2059 381.762 40.1741 382.279 40.1418C382.607 40.1197 382.919 40.0968 383.222 40.0768C383.739 40.0362 384.218 39.9989 384.668 39.964C385.568 39.8902 386.356 39.8262 387.106 39.7653C388.606 39.6437 389.965 39.5385 391.821 39.449C393.519 39.3668 395.452 39.2727 397.832 39.1566C397.789 38.0735 397.747 36.9566 397.702 35.8254C397.669 34.9323 397.636 34.0245 397.605 33.125C397.53 31.3039 397.376 29.4981 397.138 27.8338C396.902 26.1715 396.583 24.6549 396.247 23.4104C395.91 22.1659 395.554 21.1981 395.327 20.6092C395.161 20.1725 394.959 19.7431 394.754 19.3202C394.367 18.5733 393.65 17.1667 392.278 15.5734C391.593 14.7809 390.741 13.9525 389.693 13.2062C388.648 12.4595 387.41 11.801 386.039 11.3281C384.669 10.8447 383.165 10.5723 381.624 10.4666C380.079 10.3572 378.499 10.4312 376.908 10.6467C373.722 11.0467 370.51 12.3407 368.007 14.3579C366.235 15.781 364.937 17.3979 363.976 18.95C363.746 19.3434 363.514 19.7244 363.305 20.1013C363.11 20.4854 362.924 20.8582 362.739 21.2205C362.569 21.5877 362.42 21.9489 362.268 22.3C362.215 22.422 362.163 22.544 362.112 22.6638C362.01 22.8133 362.067 22.9888 362.062 23.1549C362.073 23.3492 362.081 23.5415 362.091 23.7274C362.225 26.4708 362.325 28.491 362.392 29.8763C362.478 31.4741 362.561 32.9734 362.623 34.1577L364.386 34.2336C364.674 32.0726 365.411 30.2357 366.575 28.8843C367.741 27.5432 369.26 26.6687 370.916 26.2336C371.517 26.0786 371.977 25.9401 372.284 25.8233C372.59 25.6982 372.75 25.5626 372.742 25.4437C372.74 25.3221 372.569 25.2173 372.224 25.1508C371.88 25.0778 371.359 25.0726 370.681 25.1943C368.823 25.5253 366.976 26.4093 365.521 27.937C364.067 29.4689 363.142 31.6116 362.786 34.0198L364.239 34.0827C364.187 32.8954 364.122 31.3966 364.054 29.7974C363.992 28.5249 363.955 26.5621 363.894 23.9844C363.891 23.8231 363.885 23.66 363.883 23.4923L363.878 23.2409L363.877 23.1781L363.878 23.1675L363.881 23.1505C363.881 23.1505 363.892 23.1327 363.903 23.1108C363.934 23.0409 363.966 22.971 364 22.903C364.071 22.75 364.141 22.5928 364.214 22.4376C364.35 22.1194 364.523 21.8086 364.694 21.4895C364.779 21.329 364.866 21.1662 364.953 21.0034C365.043 20.8403 365.147 20.6844 365.242 20.5209C366.022 19.2216 367.014 17.8998 368.295 16.6977C368.509 16.507 368.703 16.2951 368.929 16.1223L369.589 15.5804C369.811 15.3996 370.05 15.2488 370.278 15.0779L370.624 14.8277L370.986 14.6032C371.25 14.4461 371.505 14.2666 371.785 14.127C372.062 13.9854 372.345 13.8413 372.625 13.6975C373.21 13.4516 373.797 13.1846 374.426 13.0021C374.736 12.8997 375.044 12.7954 375.367 12.7275C375.686 12.6516 376.006 12.5651 376.327 12.4994C376.979 12.3905 377.629 12.2649 378.288 12.2204C380.921 11.946 383.526 12.209 385.614 12.968C386.66 13.3411 387.579 13.8238 388.345 14.3365C389.111 14.8534 389.716 15.401 390.206 15.8705C390.437 16.1191 390.649 16.3399 390.826 16.5386C390.997 16.7441 391.142 16.9203 391.259 17.0654C391.379 17.2083 391.454 17.3297 391.516 17.4083C391.573 17.4873 391.601 17.5268 391.601 17.5268C391.873 17.8747 392.103 18.2575 392.347 18.6288C392.569 19.0166 392.801 19.393 392.997 19.7977C393.412 20.5906 393.761 21.4207 394.07 22.2646C394.683 23.9614 395.133 25.7269 395.443 27.5254C395.758 29.3236 395.953 31.1448 396.065 32.9773C396.125 33.8891 396.162 34.828 396.208 35.7514L396.305 37.7845L390.608 38.0895L382.223 38.5415L382.147 37.0331C382.088 35.6115 381.988 34.1912 381.763 32.8742C381.542 31.5526 381.199 30.294 380.646 29.1459C380.101 28.0035 379.328 26.971 378.338 26.2428C377.353 25.5077 376.197 25.1148 375.079 24.9746L375.063 24.9613Z" fill="#0055CC"/>
<path d="M402.801 24.9656C402.203 22.6548 401.239 22.8832 401.63 25.2097C401.897 26.8631 402.16 28.5525 402.386 30.3878C402.496 31.3035 402.599 32.2556 402.664 33.2487C402.731 34.2438 402.77 35.2853 402.721 36.368C402.716 36.4986 402.712 36.6269 402.706 36.7533C402.692 36.9308 402.68 37.106 402.667 37.2728C402.649 37.501 402.616 37.7284 402.587 37.947C402.549 38.1706 402.513 38.3836 402.478 38.5859C402.35 39.3629 402.251 39.9632 402.194 40.3059C402.264 40.2831 402.36 40.2328 402.447 40.1938C402.536 40.1525 402.622 40.1093 402.707 40.0684C402.88 39.9863 403.049 39.9045 403.212 39.8253C403.541 39.6688 403.857 39.5134 404.161 39.3675C404.461 39.2218 404.753 39.0811 405.035 38.9434C405.166 38.8796 405.295 38.8181 405.42 38.7569C405.494 38.719 405.569 38.681 405.641 38.6454C406.222 38.3495 406.739 38.0886 407.235 37.8379C408.23 37.334 409.152 36.8765 410.402 36.3086C413.075 35.0677 416.694 33.4635 419.925 32.0504C420.732 31.6972 421.514 31.3587 422.252 31.0366C422.623 30.8766 422.982 30.7195 423.328 30.5699C423.651 30.4244 423.969 30.2815 424.278 30.1435L424.51 30.0373L424.627 29.9852C424.643 29.9754 424.67 29.971 424.679 29.9555L424.669 29.8934C424.645 29.7298 424.621 29.5703 424.596 29.4109C424.469 28.5658 424.357 27.8075 424.263 27.1716C424.181 26.6584 424.115 26.2443 424.066 25.9443C424.009 25.5906 423.941 25.2398 423.864 24.8897C423.747 24.3627 423.548 23.4609 423.258 22.267C423.115 21.6751 422.945 20.9912 422.762 20.281C422.599 19.5649 422.429 18.7845 422.257 17.937C421.919 16.25 421.588 14.3419 421.404 12.3017C421.312 11.2815 421.271 10.2275 421.314 9.17048C421.331 8.90671 421.348 8.64295 421.367 8.37693L421.413 7.98269L421.436 7.78557L421.445 7.71975C421.453 7.66451 421.46 7.64713 421.465 7.60892L421.506 7.4081C421.68 6.38378 422.084 5.13595 422.384 4.06711C422.287 4.10077 422.129 4.17316 421.956 4.25533C421.78 4.3356 421.585 4.42601 421.371 4.52428C420.941 4.7231 420.436 4.95568 419.886 5.21114C419.131 5.55774 418.245 5.96396 417.367 6.3653C411.226 9.21824 407.424 10.9851 405.438 11.9042C404.269 12.4546 403.174 12.9712 402.136 13.462C401.618 13.7104 401.117 13.9532 400.623 14.1911C400.196 14.396 399.771 14.5986 399.352 14.7986C399.183 14.8195 399.29 14.9823 399.295 15.091L399.363 15.446C399.409 15.6812 399.454 15.9123 399.497 16.1457C399.555 16.4219 399.614 16.6958 399.671 16.9678C399.726 17.219 399.783 17.4679 399.838 17.715C399.952 18.2087 400.069 18.6937 400.19 19.17C400.43 20.1249 400.684 21.0492 400.954 21.9637C401.557 23.9739 402.388 23.7488 401.992 21.7122C401.823 20.7825 401.653 19.851 401.478 18.8926C401.397 18.415 401.313 17.9312 401.226 17.4373C401.149 16.9592 401.07 16.4752 400.989 15.9786L400.974 15.8456L400.966 15.7812C400.966 15.7623 400.949 15.7324 400.982 15.7295L401.11 15.6785L401.173 15.6542L401.28 15.6092C401.78 15.3876 402.289 15.1588 402.814 14.9244C403.86 14.4477 404.962 13.9451 406.136 13.4069C407.958 12.5628 411.855 11.0143 417.234 8.56739C417.672 8.36786 418.107 8.16225 418.54 7.95474L419.186 7.63645L419.508 7.47429C419.526 7.46225 419.52 7.46071 419.527 7.45166C419.541 7.43581 419.56 7.41318 419.589 7.38756L419.638 7.34764L419.667 7.32619C419.667 7.32619 419.691 7.30737 419.688 7.31606C419.694 7.34069 419.694 7.39103 419.696 7.4622L419.696 7.51671L419.663 7.87844C419.633 8.14329 419.62 8.40669 419.607 8.67009C419.56 9.72334 419.595 10.7652 419.667 11.7724C419.824 13.7898 420.128 15.6834 420.427 17.3172C420.573 18.1354 420.726 18.8859 420.861 19.5603C421 20.2365 421.126 20.8298 421.25 21.3122C421.469 22.2689 421.597 22.8286 421.597 22.8286C421.597 22.8286 421.823 23.7951 422.142 25.3537C422.301 26.133 422.48 27.0597 422.663 28.0908C422.702 28.3203 422.743 28.5559 422.785 28.7957L422.803 28.9075L422.812 28.9654C422.818 28.9859 422.785 28.9846 422.771 28.9963C422.384 29.1767 421.984 29.3624 421.575 29.5511C417.19 31.5824 412.042 33.9717 408.986 35.3886L405.982 36.7841L404.671 37.3929L404.467 37.4882L404.366 37.5347L404.316 37.558L404.289 37.5708C404.289 37.5708 404.28 37.5779 404.277 37.576L404.28 37.5631C404.303 37.4584 404.319 37.3521 404.328 37.2442L404.345 37.0687C404.365 36.8613 404.372 36.6551 404.381 36.4465C404.431 35.2672 404.374 34.1685 404.284 33.1272C404.194 32.0859 404.057 31.1094 403.903 30.1765C403.593 28.3087 403.216 26.6124 402.802 24.9739L402.801 24.9656Z" fill="#0055CC"/>
<path d="M384.78 4.00317C387.938 3.20902 387.727 2.24328 384.526 2.8355C382.254 3.25484 379.932 3.70159 377.414 4.2115C376.157 4.47157 374.85 4.74014 373.477 5.02282C372.791 5.16832 372.086 5.31754 371.367 5.47009L371.218 5.49975C371.197 5.50156 371.166 5.52111 371.163 5.48779C371.092 5.3198 371.022 5.14955 370.951 4.97739C369.623 1.76683 368.946 -0.312608 368.381 -2.12056C367.842 -3.9371 367.411 -5.50071 367.051 -7.83206C366.893 -8.815 366.773 -9.88939 366.688 -11.0193C366.622 -12.1487 366.576 -13.3344 366.64 -14.536C366.704 -15.7375 366.819 -16.9582 367.064 -18.1397C367.308 -19.3212 367.637 -20.4743 368.076 -21.5384C368.18 -21.8056 368.312 -22.0583 368.428 -22.3159C368.488 -22.4429 368.547 -22.5717 368.605 -22.6964C368.676 -22.8221 368.743 -22.9475 368.812 -23.071C369.086 -23.5669 369.355 -24.0518 369.614 -24.5212C369.889 -24.9814 370.184 -25.4057 370.452 -25.8255C370.59 -26.0304 370.716 -26.2407 370.855 -26.4332C371 -26.62 371.14 -26.8041 371.278 -26.9818C371.556 -27.3353 371.803 -27.6799 372.06 -27.9813C372.327 -28.2708 372.576 -28.5442 372.802 -28.7905C373.238 -29.3046 373.671 -29.64 373.952 -29.9099L374.459 -30.3798L375.001 -30.8128C375.161 -30.9442 375.356 -31.1016 375.579 -31.2847C375.688 -31.3822 375.817 -31.471 375.954 -31.5606C376.091 -31.6542 376.237 -31.7509 376.39 -31.8543C376.986 -32.2879 377.767 -32.7207 378.666 -33.1973C380.483 -34.1269 382.926 -34.9702 385.749 -35.687C386.452 -35.8718 387.182 -36.0463 387.929 -36.2181C388.673 -36.3959 389.442 -36.5611 390.222 -36.7357C390.745 -36.8524 391.276 -36.9698 391.811 -37.0875C391.827 -37.0973 391.829 -37.0806 391.834 -37.0685L391.843 -37.0295L391.877 -36.8813C391.965 -36.4755 392.052 -36.0698 392.138 -35.6618C392.826 -32.3978 393.535 -29.0517 394.215 -25.8333C394.699 -23.5608 395.138 -21.507 395.533 -19.657C395.709 -18.833 395.874 -18.0563 396.03 -17.3228L396.047 -17.2508C396.046 -17.2319 396.008 -17.237 395.99 -17.2291C395.759 -17.1839 395.532 -17.139 395.315 -17.0972C393.858 -16.8198 392.563 -16.5564 391.456 -16.2549C390.349 -15.9574 389.427 -15.6237 388.695 -15.2811C387.829 -14.8809 387.014 -14.3843 386.312 -13.7653C385.606 -13.1501 385.025 -12.4137 384.602 -11.6258C384.182 -10.8319 383.945 -10.0036 383.788 -9.19684C383.737 -8.79165 383.662 -8.39072 383.656 -7.99783C383.648 -7.79989 383.64 -7.60612 383.631 -7.41235C383.631 -7.2193 383.643 -7.02734 383.649 -6.83691C383.805 -3.79328 384.714 -1.22835 385.709 1.20748C386.262 2.50247 386.762 3.06972 386.983 3.0044L386.993 2.90906C386.995 2.92988 387.006 2.93939 387.029 2.93532L387.023 2.9883C387.233 2.86729 387.157 2.12695 386.709 0.831265C385.907 -1.60452 385.185 -4.13535 385.149 -6.8662C385.149 -7.03616 385.145 -7.20576 385.149 -7.37608C385.164 -7.54521 385.174 -7.71399 385.187 -7.88504C385.199 -8.2302 385.278 -8.56223 385.326 -8.90422C385.476 -9.57396 385.682 -10.2423 386.022 -10.8571C386.365 -11.4682 386.82 -12.0321 387.389 -12.52C387.957 -13.0078 388.635 -13.4232 389.39 -13.7698C389.972 -14.0448 390.76 -14.3208 391.748 -14.5722C392.735 -14.8236 393.919 -15.0374 395.292 -15.2697C395.66 -15.3352 396.039 -15.3995 396.429 -15.469C396.772 -15.5364 397.118 -15.6043 397.469 -15.6724C397.646 -15.7088 397.826 -15.7432 398.003 -15.7796L398.137 -15.8059L398.206 -15.8181C398.206 -15.8181 398.218 -15.8192 398.222 -15.8237L398.22 -15.8404L398.213 -15.8733L398.161 -16.1416C397.961 -17.1481 397.754 -18.2066 397.532 -19.3163C397.2 -21.0059 396.833 -22.8478 396.421 -24.8327C396.152 -26.1249 395.86 -27.4132 395.553 -28.6874C394.886 -31.4349 394.198 -34.3926 393.546 -37.2862L393.341 -38.2231L393.235 -38.7028L393.183 -38.9396L393.156 -39.0589C393.152 -39.0775 393.15 -39.1025 393.141 -39.1143L393.079 -39.1005C392.467 -38.9657 391.858 -38.8289 391.251 -38.6944C390.541 -38.5343 389.839 -38.3748 389.149 -38.2206C387.771 -37.9081 386.435 -37.6014 385.194 -37.2777C382.705 -36.6507 380.584 -35.9233 379.116 -35.303C378.753 -35.1373 378.426 -34.9872 378.141 -34.8597C377.997 -34.7948 377.866 -34.7352 377.745 -34.6785C377.627 -34.6158 377.521 -34.5583 377.422 -34.5058C377.038 -34.2962 376.829 -34.1816 376.829 -34.1816C376.829 -34.1816 376.751 -34.1391 376.605 -34.0572C376.459 -33.9712 376.233 -33.8676 375.972 -33.6855C375.704 -33.5091 375.379 -33.2921 374.999 -33.0431C374.904 -32.9803 374.807 -32.9152 374.705 -32.8498C374.611 -32.7744 374.511 -32.6965 374.413 -32.6167C374.213 -32.4566 373.998 -32.2891 373.775 -32.1102C373.313 -31.7722 372.875 -31.3252 372.39 -30.8677C371.887 -30.4254 371.447 -29.8606 370.947 -29.3074C370.689 -29.0333 370.468 -28.7245 370.238 -28.4087C370.006 -28.097 369.77 -27.7743 369.529 -27.4513C369.295 -27.1226 369.093 -26.7673 368.869 -26.4185C368.652 -26.0639 368.416 -25.714 368.211 -25.3458C368.012 -24.9719 367.81 -24.5935 367.61 -24.2131C367.412 -23.8267 367.19 -23.4612 367.018 -23.0414C366.838 -22.6334 366.644 -22.2242 366.501 -21.7963L366.27 -21.1595C366.194 -20.9452 366.142 -20.7266 366.076 -20.5111C365.569 -18.7781 365.306 -16.9907 365.209 -15.2722C365.017 -11.8291 365.44 -8.6765 365.857 -6.37103C366.505 -2.89797 367.285 -0.399449 367.899 1.48819C368.53 3.37439 369.032 4.64646 369.43 5.61072C369.519 5.81702 369.604 6.02368 369.693 6.2258C369.821 6.52311 369.954 6.82006 370.092 7.11438L370.193 7.33434L370.219 7.39085C370.227 7.40905 370.255 7.38986 370.274 7.39032L370.391 7.36545L370.861 7.27014C371.154 7.20702 371.444 7.142 371.732 7.07923C372.451 6.91835 373.155 6.76081 373.838 6.60923C375.206 6.2955 376.507 5.99813 377.757 5.70926C380.258 5.1232 382.558 4.56506 384.799 4.00364L384.78 4.00317Z" fill="#0055CC"/>
<path d="M289.604 -5.95927C289.825 -7.16812 289.658 -7.81042 289.394 -7.85468C289.12 -7.90012 288.748 -7.36645 288.444 -6.25107C287.978 -4.67267 287.331 -3.1185 286.404 -1.58822C285.451 -0.0788647 284.202 1.41638 282.444 2.63884C282.187 2.81642 281.946 2.9884 281.706 3.1267C281.648 3.16317 281.588 3.19774 281.53 3.23421L281.447 3.28762C281.447 3.28762 281.409 3.30978 281.377 3.32517L281.29 3.36835C281.059 3.48283 280.835 3.59242 280.626 3.69867C280.424 3.80645 280.211 3.89829 280.009 3.98299C279.81 4.06733 279.626 4.14832 279.454 4.2199C279.131 4.36125 278.862 4.47897 278.656 4.5682C278.704 4.61647 278.78 4.66864 278.853 4.71892C278.925 4.77146 278.996 4.81983 279.068 4.87237C279.209 4.97138 279.347 5.07265 279.484 5.16786C279.754 5.36053 280.016 5.54559 280.268 5.72304C280.518 5.89859 280.76 6.0707 280.994 6.2371C281.17 6.35821 281.342 6.47968 281.508 6.59544C282.011 6.93785 282.46 7.2452 282.899 7.54495C283.773 8.1448 284.593 8.71793 285.64 9.49792C286.838 10.3781 288.231 11.4219 289.677 12.5177C290.398 13.0658 291.134 13.6272 291.868 14.1826C292.068 14.3352 292.27 14.4898 292.47 14.6424L292.955 15.0033L293.076 15.0935L293.136 15.1365L293.166 15.1612C293.166 15.1612 293.19 15.1507 293.202 15.1455L293.482 15.0373L294.04 14.8189L294.428 14.6468C294.65 14.5436 294.865 14.4306 295.078 14.3198C295.921 13.8585 296.673 13.3087 297.317 12.722C297.483 12.5796 297.641 12.4338 297.785 12.2807C297.933 12.1314 298.078 11.9825 298.221 11.84C298.484 11.5361 298.742 11.243 298.969 10.9548C299.883 9.79918 300.394 8.76454 300.697 8.20105C300.87 7.86299 301.007 7.51115 301.151 7.16086C301.27 6.89033 301.388 6.50663 301.543 6.03374C301.71 5.56394 301.847 4.99179 302.013 4.33953C302.105 4.01476 302.163 3.66562 302.234 3.29648C302.303 2.93376 302.376 2.55402 302.45 2.15726C302.521 1.78395 302.597 1.39552 302.673 0.992327C302.769 0.593762 302.883 0.187326 302.989 -0.237315C303.46 -1.91903 304.268 -3.72008 305.478 -5.37976C306.096 -6.19706 306.82 -6.9753 307.642 -7.65926C308.05 -8.00731 308.494 -8.31432 308.949 -8.61183L309.48 -8.92643C309.722 -9.05865 309.971 -9.18934 310.24 -9.31123C310.758 -9.55548 311.278 -9.80199 311.8 -10.0466C311.202 -10.492 309.695 -11.6078 308.218 -12.703C305.465 -14.7241 303.236 -16.3585 301.476 -17.6495C300.595 -18.2971 299.83 -18.8559 299.173 -19.3383C298.846 -19.5785 298.546 -19.8001 298.271 -20.0007C298.038 -20.1694 297.818 -20.3308 297.61 -20.4827C297.494 -20.565 297.378 -20.6472 297.27 -20.726C297.244 -20.7594 297.213 -20.7357 297.182 -20.7226L297.092 -20.6791C297.033 -20.6509 296.971 -20.6224 296.914 -20.5965C296.644 -20.4641 296.349 -20.3377 296.113 -20.204C295.961 -20.1194 295.804 -20.0429 295.661 -19.9466C295.516 -19.8563 295.37 -19.7661 295.229 -19.6762C295.09 -19.5803 294.954 -19.4824 294.82 -19.3869C294.549 -19.1934 294.3 -18.9851 294.054 -18.7791C293.819 -18.5594 293.574 -18.3598 293.365 -18.1298C292.493 -17.2443 291.803 -16.2907 291.244 -15.3315C290.158 -13.3931 289.552 -11.4542 289.197 -9.52671C288.87 -7.38335 289.73 -7.29835 290.238 -9.28538C290.758 -11.0888 291.464 -12.8475 292.528 -14.5574C293.072 -15.4019 293.716 -16.2236 294.498 -16.9838C294.687 -17.1806 294.905 -17.3485 295.111 -17.5384C295.329 -17.7105 295.547 -17.8909 295.782 -18.0519C295.901 -18.1335 296.018 -18.2129 296.139 -18.2968C296.263 -18.3705 296.386 -18.4483 296.512 -18.5243C296.637 -18.6044 296.768 -18.6682 296.898 -18.7403C296.958 -18.7749 296.982 -18.7854 297.027 -18.806C297.043 -18.8116 297.059 -18.8214 297.075 -18.827C297.089 -18.8156 297.105 -18.8023 297.118 -18.7909C297.157 -18.7585 297.195 -18.7262 297.236 -18.692C297.49 -18.4937 297.769 -18.2786 298.075 -18.0408C298.684 -17.5628 299.393 -17.0053 300.204 -16.3705C301.821 -15.1028 303.83 -13.5417 306.218 -11.7617C306.608 -11.4723 307 -11.1853 307.395 -10.9069L307.991 -10.4907L308.141 -10.3882C308.141 -10.3882 308.145 -10.3886 308.149 -10.389C308.156 -10.3874 308.164 -10.3881 308.172 -10.3889C308.198 -10.3869 308.247 -10.3723 308.287 -10.3505C308.274 -10.3264 308.253 -10.3015 308.185 -10.2431L308.026 -10.1412L307.856 -10.0215L307.515 -9.7822C307.288 -9.6219 307.077 -9.44412 306.856 -9.27395C305.994 -8.57388 305.217 -7.77012 304.539 -6.92241C303.169 -5.22782 302.263 -3.31968 301.676 -1.61952C301.604 -1.40558 301.532 -1.1958 301.461 -0.992448C301.389 -0.786833 301.346 -0.579579 301.287 -0.381476C301.185 0.0197139 301.063 0.395451 300.994 0.762334C300.848 1.4779 300.721 2.10572 300.615 2.62689C300.509 3.12497 300.445 3.52707 300.363 3.79018C300.29 4.05674 300.25 4.20078 300.25 4.20078C300.25 4.20078 300.188 4.43483 300.074 4.86019C300.018 5.07269 299.922 5.32023 299.824 5.6162C299.724 5.91027 299.618 6.24672 299.46 6.60036C299.308 6.95554 299.158 7.35463 298.943 7.75307C298.84 7.95289 298.734 8.1614 298.625 8.37859C298.502 8.58437 298.376 8.79468 298.248 9.01141C297.713 9.8635 297.042 10.7483 296.207 11.5257C296.102 11.623 295.997 11.7202 295.892 11.8174C295.785 11.9127 295.666 11.9985 295.555 12.09C295.334 12.2791 295.092 12.4386 294.853 12.6083C294.734 12.6941 294.604 12.7621 294.482 12.8418C294.359 12.9197 294.233 12.9956 294.101 13.0617C293.97 13.1296 293.844 13.2056 293.709 13.2614L293.533 13.3417C293.509 13.3522 293.493 13.3619 293.472 13.3679C293.433 13.3734 293.389 13.4255 293.358 13.3799L293.237 13.2897C292.982 13.102 292.724 12.9124 292.469 12.7247C291.958 12.3494 291.452 11.9778 290.954 11.6139C288.967 10.1558 287.13 8.80428 285.762 7.80036L283.266 5.96879L282.16 5.15826L281.992 5.03643L281.909 4.97438L281.868 4.94015C281.868 4.94015 281.82 4.91912 281.851 4.91433C281.973 4.86601 282.09 4.80973 282.204 4.74737L282.226 4.73497L282.264 4.71279L282.428 4.61469L282.757 4.42037C282.977 4.29221 283.184 4.13788 283.397 3.99986C285.383 2.6065 286.754 0.888816 287.729 -0.813492C288.682 -2.53899 289.266 -4.26186 289.612 -5.96416L289.604 -5.95927Z" fill="#0055CC"/>
<path d="M335.18 -24.8556C335.367 -27.0896 334.385 -27.2164 333.994 -25.0108C333.717 -23.4468 333.449 -21.8414 333.182 -20.0956C333.054 -19.2221 332.92 -18.3146 332.78 -17.3583C332.644 -16.3603 332.501 -15.3135 332.351 -14.2073C332.315 -13.902 332.279 -13.6073 332.272 -13.5479C332.586 -13.2373 332.882 -12.942 333.169 -12.6584C333.357 -12.4774 333.536 -12.2999 333.707 -12.1364C334.053 -11.8034 334.368 -11.5034 334.661 -11.2224C335.252 -10.6673 335.75 -10.1985 336.218 -9.76272C337.155 -8.88931 337.961 -8.13454 339.071 -6.99696C339.768 -6.28315 340.543 -5.4922 341.538 -4.47471C342.213 -4.57105 342.912 -4.67145 343.62 -4.77484C344.209 -4.85527 344.811 -4.93678 345.41 -5.02019C346.613 -5.17905 347.818 -5.34016 348.949 -5.49061C351.408 -5.80659 353.549 -6.08036 354.718 -6.22989C354.939 -6.58062 355.125 -6.88001 355.282 -7.13069C355.375 -7.27301 355.451 -7.3908 355.515 -7.49084C355.643 -7.68865 355.727 -7.81548 355.797 -7.92231C355.981 -8.20051 356.158 -8.48443 356.33 -8.77214C356.622 -9.26111 357.152 -10.1443 358.014 -11.5787C358.936 -13.098 360.217 -15.2044 361.956 -18.0724C361.796 -18.5474 361.552 -19.2816 361.244 -20.2012C360.997 -20.9457 360.704 -21.8414 360.38 -22.8288C359.735 -24.8082 358.978 -27.1597 358.266 -29.4229L357.826 -30.7822L346.487 -34.4322C346.071 -34.566 345.657 -34.698 345.367 -34.7904C344.773 -34.3822 344.196 -33.9902 343.636 -33.6038C343.197 -33.2972 342.767 -33.0018 342.351 -32.7098C341.523 -32.1239 340.738 -31.567 339.98 -31.0334C338.475 -29.9545 337.106 -28.942 335.757 -27.9207C334.187 -26.7334 334.67 -26.0221 336.355 -27.0389C337.803 -27.9114 339.251 -28.8111 340.81 -29.8065C341.585 -30.3101 342.392 -30.8333 343.246 -31.3858C343.996 -31.883 344.784 -32.4066 345.626 -32.9622C345.717 -32.9323 345.846 -32.889 345.978 -32.8479C346.88 -32.5568 348.252 -32.0525 350.06 -31.4015C350.964 -31.0812 351.977 -30.72 353.094 -30.3258C354.069 -29.9928 355.133 -29.6276 356.281 -29.234L356.327 -29.0953L356.539 -28.457C356.685 -28.0332 356.834 -27.6097 356.99 -27.1931C357.543 -25.6967 358.111 -24.0988 358.656 -22.52C359.156 -21.0526 359.648 -19.6076 360.1 -18.2892L360.045 -18.1921C359.979 -18.0815 359.913 -17.975 359.847 -17.8644C359.702 -17.6273 359.56 -17.3947 359.422 -17.1666C359.143 -16.7102 358.876 -16.2737 358.625 -15.8595C358.115 -15.0327 357.658 -14.2923 357.279 -13.6761C356.512 -12.4473 356.05 -11.7043 356.05 -11.7043L353.657 -7.82492L342.05 -6.02149L339.492 -8.60924L334.019 -14.1379L334.03 -14.2332C334.157 -15.2577 334.277 -16.227 334.393 -17.1498C334.503 -18.1077 334.607 -19.0211 334.706 -19.8962C334.896 -21.6521 335.05 -23.2727 335.182 -24.8537L335.18 -24.8556Z" fill="#0055CC"/>
<path d="M334.463 4.55043C336.378 5.19855 337.423 5.25896 337.511 5.00382C337.601 4.73999 336.74 4.16631 334.878 3.42756C332.352 2.4169 329.793 1.33152 327.049 0.0860085C325.677 -0.537881 324.262 -1.20208 322.786 -1.9218C322.048 -2.27958 321.294 -2.65483 320.524 -3.0434C320.14 -3.23882 319.751 -3.43804 319.356 -3.63881C318.73 -3.96432 318.098 -4.29136 317.454 -4.62376C317.2 -4.26182 316.851 -3.76363 316.498 -3.26091C311.509 3.94463 310.444 5.82257 307.026 10.6636C306.168 11.8815 305.22 13.2247 304.201 14.6706C303.026 16.3251 301.771 18.0936 300.448 19.9519C301.609 20.5878 302.784 21.2287 303.958 21.8718C304.893 22.372 305.832 22.8676 306.756 23.3477C308.612 24.3052 310.431 25.205 312.103 26.0043C315.451 27.6025 318.222 28.8038 319.543 29.3586C320.099 29.5979 320.659 29.8221 321.228 30.0372C323.093 30.7483 327.879 32.5744 334.242 34.4547C337.42 35.4003 340.99 36.3582 344.761 37.2378C346.647 37.6765 348.582 38.0984 350.545 38.4927C351.525 38.691 352.513 38.8802 353.502 39.0631L354.99 39.3328L357.469 39.7599C357.512 39.07 357.618 37.3781 357.721 35.7073C358.398 24.2427 358.818 17.1478 359.038 13.4422C359.115 12.0821 359.191 10.7663 359.248 9.79823C358.525 9.66157 357.813 9.53027 357.113 9.39788C356.669 9.31047 356.23 9.22686 355.799 9.14253C354.934 8.97197 354.095 8.79926 353.278 8.62663C351.643 8.27947 350.096 7.92473 348.607 7.5691C345.63 6.85142 342.892 6.12149 340.191 5.33379C338.504 4.8422 337.595 4.76987 337.515 5.00346C337.437 5.2242 338.192 5.75466 339.861 6.35065C342.533 7.3025 345.259 8.16562 348.242 8.98554C349.733 9.39341 351.289 9.78944 352.935 10.1692C353.757 10.3623 354.602 10.5471 355.474 10.7317C356.136 10.8674 356.819 11.0054 357.52 11.1503C357.485 11.7346 357.434 12.53 357.383 13.3486C357.181 16.7484 356.524 23.8218 355.888 33.8225C355.843 34.6301 355.797 35.4335 355.753 36.2389L355.697 37.4438C355.695 37.5154 355.695 37.4881 355.696 37.4965L355.7 37.5003L355.703 37.5147L355.713 37.5495C355.713 37.5495 355.699 37.557 355.686 37.5581C355.653 37.5568 355.753 37.5796 355.443 37.531C355.007 37.4618 354.566 37.3929 354.124 37.3222C353.241 37.1784 352.344 37.0274 351.449 36.8616C349.654 36.5388 347.844 36.1754 346.062 35.7822C342.497 35.0064 339.05 34.105 336.046 33.2324C333.043 32.3575 330.487 31.5175 328.681 30.8914C327.778 30.573 327.064 30.3202 326.573 30.1467C326.083 29.9667 325.818 29.8679 325.818 29.8679C321.699 28.3744 317.646 26.7051 313.653 24.9006C311.657 23.9951 309.679 23.0545 307.719 22.0746C306.741 21.5844 305.762 21.086 304.793 20.5804L303.34 19.8146L302.638 19.4369L309.085 10.2354C314.014 3.19241 316.386 -0.198335 317.845 -2.28244C317.896 -2.35604 317.946 -2.42965 317.981 -2.48098C318.602 -2.1676 319.205 -1.86528 319.791 -1.56985C320.573 -1.18236 321.337 -0.814252 322.09 -0.459821C323.592 0.247136 325.035 0.892152 326.437 1.484C329.24 2.67411 331.869 3.66742 334.463 4.55459L334.463 4.55043Z" fill="#0055CC"/>
<path d="M266.148 11.4376C265.904 11.2409 261.607 11.6971 262.767 12.4216C263.152 12.7387 263.531 12.7338 263.685 12.3129C263.756 13.1539 264.635 12.0998 265.004 12.398C264.83 12.9693 266.069 11.8381 265.807 12.4269C270.358 13.3708 279.961 8.37317 268.469 10.984C269.573 11.3221 268.502 11.4792 268.006 11.3161C268.775 10.623 266.63 11.1225 266.225 11.3523C266.878 11.3825 265.768 11.8563 266.15 11.4397L266.148 11.4376Z" fill="#101214"/>
<path d="M272.605 3.22316C273.458 2.36056 274.245 3.76267 275.035 3.06913C276.28 1.68993 267.453 -0.414982 267.475 1.23096C267.685 2.6437 272.067 2.52666 272.605 3.22316Z" fill="#101214"/>
<path d="M353.904 0.605135C351.888 -0.0406305 348.015 0.187959 346.143 -0.686571C344.414 -0.564747 342.931 -1.0713 341.224 -1.48882C341.674 -1.91768 342.883 -2.42509 342.976 -2.90903C346.063 -5.01434 340.805 -2.8555 339.877 -1.40738L339.89 -1.40739C339.89 -1.40739 339.691 -1.15637 339.673 -1.19408C339.802 -0.692643 340.458 -0.0652969 340.454 0.283156C343.482 2.73881 344.616 3.1592 341.381 -0.567943C342.528 -0.296267 343.241 0.288849 344.364 0.147743C344.642 0.54692 350.562 1.43902 348.42 0.717936C348.941 0.404403 350.793 1.07698 349.514 1.05847C350.098 1.25533 359.729 2.18758 358.787 0.832591C358.387 0.926263 357.763 0.58519 357.477 0.747534C357.422 0.905176 357.407 1.02061 357.253 0.965295C357.28 0.632353 356.933 0.630529 356.556 0.701981C356.088 0.866753 355.08 0.903412 355.236 0.665757C355.306 0.46149 353.472 0.982932 353.904 0.607357L353.904 0.605135Z" fill="#101214"/>
</g>
<g clipPath="url(#clip2_550_14457)">
<path d="M13.0459 7.94648C13.2244 7.80301 13.375 7.65148 13.5135 7.50519C13.6519 7.3589 13.7767 7.22429 13.8912 7.09266C14.1165 6.83394 14.2962 6.60644 14.4242 6.41279C14.6826 6.0274 14.7534 5.77787 14.657 5.68132C14.5605 5.58477 14.2987 5.63893 13.898 5.85831C13.6977 5.968 13.4612 6.12069 13.1927 6.31602C13.0586 6.41577 12.9146 6.52266 12.7657 6.64468C12.6168 6.7667 12.4583 6.90004 12.2783 7.02685C11.7797 7.3995 11.2791 7.7744 10.7705 8.1542C10.2398 8.49606 9.70493 8.83827 9.16244 9.18954C8.60947 9.51654 8.02636 9.81049 7.44957 10.1291C7.15404 10.2785 6.84575 10.4017 6.5389 10.5416C6.23133 10.6732 5.92782 10.8275 5.60858 10.9454C5.28898 11.0591 4.96332 11.1755 4.63765 11.2918C4.47464 11.3479 4.31044 11.4146 4.1448 11.4646C3.97464 11.5109 3.80449 11.5571 3.63433 11.6033C3.29175 11.6939 2.94835 11.7992 2.59636 11.8779C2.24139 11.9465 1.88225 12.0154 1.51931 12.0888C0.0606176 12.3264 -1.49813 12.4259 -3.12925 12.2945C-3.56103 12.2753 -3.97141 12.2123 -4.35537 12.1637C-4.54794 12.1447 -4.73171 12.1061 -4.90643 12.0751C-4.9938 12.0596 -5.08116 12.0441 -5.16436 12.0282C-5.22411 12.0166 -5.28576 12.0072 -5.34551 11.9956C-5.43287 11.9801 -5.5081 11.9594 -5.58713 11.9432C-6.21656 11.7732 -6.77491 11.6244 -7.25162 11.4978C-7.70977 11.3676 -8.08591 11.2638 -8.36563 11.1831C-8.05452 12.2599 -7.73595 13.2771 -7.45896 14.2015C-7.28585 14.7489 -7.12621 15.2617 -6.97515 15.748C-6.68674 16.6588 -6.42815 17.4673 -6.18005 18.2515C-5.68384 19.8199 -5.22994 21.2871 -4.66961 23.2339C-4.04204 25.3764 -3.32537 27.8951 -2.58721 30.5168C-2.22004 31.83 -1.84428 33.1696 -1.4715 34.4991C-1.25363 35.2733 -1.04029 36.0438 -0.825398 36.8078C-0.802628 36.8772 -0.789367 36.9578 -0.758627 37.0223L-0.551516 37.0883L-0.137285 37.2202L0.276945 37.3522L0.53893 37.4218C0.71283 37.4676 0.884474 37.5114 1.05837 37.5572C1.23346 37.5924 1.40628 37.6257 1.57946 37.6631C4.36235 38.2066 7.04848 37.8962 9.14027 37.3602C9.66062 37.2144 10.1485 37.0567 10.6086 36.9182C11.0609 36.7615 11.4697 36.5876 11.8496 36.4434C12.2341 36.3031 12.5622 36.1425 12.8562 35.9995C13.1502 35.8565 13.4062 35.7357 13.6198 35.6332C13.8785 35.5185 14.1157 35.3742 14.3552 35.2317L15.0752 34.7979C15.254 34.6817 15.4828 34.5611 15.7156 34.3899C15.9507 34.2205 16.2176 34.0316 16.5119 33.8194C16.8017 33.6033 17.1399 33.3894 17.4667 33.1155C17.7957 32.8436 18.1502 32.5506 18.5283 32.2388C18.716 32.0798 18.9169 31.9281 19.1073 31.7521C19.2955 31.5743 19.4897 31.3938 19.6897 31.2065C20.0835 30.8345 20.499 30.446 20.9358 30.0368C21.3513 29.6482 21.7823 29.2458 22.2305 28.8229C22.6881 28.4119 23.1922 28.0283 23.6952 27.6091C23.943 27.3925 24.219 27.2112 24.4958 27.0152C24.7708 26.8214 25.0517 26.625 25.3346 26.4263C25.4725 26.322 25.6221 26.2314 25.772 26.145C25.9215 26.0544 26.0733 25.9657 26.2248 25.8728C26.5303 25.6932 26.8325 25.4991 27.1493 25.329C28.4302 24.6598 29.8119 24.0406 31.3018 23.6052C32.7947 23.1799 34.3762 22.9064 36.0024 22.8599C36.8156 22.8251 37.6359 22.8736 38.4607 22.9489L39.0913 23.0348L39.4056 23.0789L40.0042 23.2075C40.8225 23.3779 41.6365 23.5717 42.4509 23.7697C42.1544 22.74 41.401 20.1363 40.667 17.5876C37.7264 7.53183 35.9053 1.30688 34.9535 -1.94261C34.9552 -2.23861 34.6651 -2.19668 34.4682 -2.26564C34.2584 -2.3146 34.0485 -2.36355 33.8387 -2.41251L33.6803 -2.44913C33.6311 -2.45956 33.6141 -2.46227 33.5778 -2.46961L33.3902 -2.50372L33.0173 -2.57001C32.7696 -2.61988 32.5206 -2.63607 32.2744 -2.66928L31.9055 -2.71284L31.5408 -2.73367C30.5668 -2.81081 29.6218 -2.74779 28.7074 -2.67062C26.8858 -2.45607 25.2051 -1.99564 23.6927 -1.35886C23.3041 -1.21817 22.9496 -1.02168 22.5817 -0.859698C22.4004 -0.772642 22.2187 -0.689742 22.0393 -0.604949C21.8648 -0.512183 21.6929 -0.413354 21.5206 -0.318686C21.1787 -0.123287 20.8406 0.0675779 20.5024 0.258452C20.1809 0.47097 19.8612 0.681234 19.5415 0.89149C19.3828 0.99757 19.226 1.10138 19.0692 1.20519C18.9128 1.31317 18.7677 1.43066 18.618 1.54435C18.321 1.77363 18.0236 1.99874 17.7304 2.22349C17.4281 2.44063 17.165 2.69844 16.8834 2.93687C16.6064 3.1791 16.3335 3.42097 16.0565 3.6632C14.9003 4.78106 14.4954 5.51069 14.6627 5.67453C14.8371 5.84825 15.5686 5.4743 16.7575 4.469C17.0367 4.25176 17.3182 4.03643 17.6015 3.81883C17.8853 3.60539 18.1547 3.37221 18.455 3.18042C18.7503 2.98066 19.0435 2.77901 19.3427 2.57472C19.4915 2.47579 19.6354 2.36889 19.7888 2.27377C19.9425 2.18281 20.0981 2.08959 20.256 1.99827C20.5672 1.81183 20.8807 1.62728 21.1938 1.43857C21.5194 1.27187 21.8468 1.10292 22.1765 0.935855C22.3434 0.852145 22.5062 0.768783 22.675 0.682808C22.8449 0.60933 23.0189 0.535501 23.193 0.461662C23.5419 0.322314 23.8814 0.148096 24.2446 0.0284898C25.6722 -0.5212 27.2231 -0.905332 28.8787 -1.07402C29.7068 -1.13111 30.5609 -1.17788 31.436 -1.10266L31.7652 -1.08084L32.0939 -1.04009C32.3148 -1.00888 32.5385 -0.994695 32.7585 -0.948727C32.959 -0.911546 33.1636 -0.874721 33.3663 -0.835639L33.4906 -0.804459C33.5296 -0.791045 33.5901 -0.794202 33.5831 -0.753728C33.7626 -0.108343 33.9886 0.711361 34.2604 1.69705C34.563 2.82065 34.9173 4.13071 35.3166 5.62151C36.1212 8.60049 37.1258 12.2923 38.3635 16.5934C38.7677 17.9957 39.1924 19.3919 39.6324 20.7701L39.7103 21.0172L39.7503 21.1397C39.7503 21.1397 39.7548 21.1435 39.757 21.1454C39.7661 21.153 39.7713 21.1651 39.7789 21.1792C39.7935 21.2031 39.816 21.2452 39.8321 21.2858C39.8094 21.2898 39.7776 21.2863 39.7337 21.288L39.7 21.2867L39.6811 21.2863L39.5858 21.2756L39.0005 21.2047C38.6159 21.1478 38.1999 21.1419 37.8004 21.1073C37.3951 21.0795 36.9912 21.0914 36.5855 21.0825C34.9651 21.0992 33.3478 21.3233 31.8071 21.7044C28.7091 22.4451 25.9889 23.9167 23.8329 25.4108C23.5617 25.6001 23.2986 25.7845 23.0374 25.9666C22.7852 26.1563 22.5484 26.3552 22.3129 26.5434C22.0774 26.7317 21.8479 26.9174 21.6222 27.0985C21.5105 27.19 21.3985 27.2773 21.2906 27.3643C21.1876 27.4593 21.0865 27.552 20.9873 27.6424C20.2001 28.3674 19.5102 29.0042 18.937 29.5344C18.6591 29.7914 18.4082 30.0209 18.1904 30.2202C18.0817 30.3219 17.9806 30.4146 17.8871 30.4983C17.7891 30.5781 17.6987 30.6489 17.6204 30.7144C17.3005 30.9709 17.13 31.1094 17.13 31.1094C17.13 31.1094 16.8416 31.3422 16.3261 31.7624C16.0647 31.9676 15.7272 32.1899 15.3418 32.4646C15.15 32.6009 14.9442 32.7446 14.7266 32.8977C14.509 33.0509 14.2624 33.1835 14.0092 33.3376C13.758 33.4895 13.4926 33.6489 13.2175 33.8154C12.9446 33.9838 12.637 34.1154 12.3319 34.2761C12.0216 34.4247 11.7142 34.6066 11.3733 34.7411C11.037 34.8794 10.6885 35.0229 10.3339 35.169C8.89465 35.705 7.25528 36.1346 5.51244 36.2647C4.64192 36.3402 3.74838 36.319 2.85551 36.2327L2.18746 36.1501L1.52224 36.0273C1.30062 35.9877 1.08518 35.9225 0.864745 35.8723L0.70406 35.8338L0.64585 35.8158L0.529429 35.7797C0.476824 35.778 0.495606 35.7281 0.478692 35.7023L0.439583 35.5651L0.23949 34.8753C0.105343 34.4149 -0.0284482 33.9585 -0.162235 33.5022C-0.429811 32.5896 -0.692493 31.685 -0.951844 30.7947C-1.99079 27.2401 -2.95224 23.9516 -3.66507 21.5018L-5.03013 16.8425L-5.71171 14.5117L-5.92228 13.7977L-5.96736 13.64L-5.99086 13.5623L-6.00278 13.5214C-6.00278 13.5214 -6.02077 13.4831 -6.00077 13.496C-5.91685 13.5202 -5.83258 13.5486 -5.74485 13.5683L-5.6163 13.5991L-5.29637 13.6595C-5.12807 13.689 -4.95906 13.7268 -4.78886 13.754L-4.27933 13.8231L-3.7698 13.8922L-3.25864 13.9319C-1.47352 14.073 0.223859 13.951 1.8069 13.6711C2.20054 13.5887 2.59002 13.5067 2.97117 13.4254C3.3535 13.3335 3.71855 13.2116 4.08731 13.1083C4.27151 13.0546 4.45344 12.999 4.63347 12.9456C4.81315 12.8881 4.98721 12.8142 5.162 12.7487C5.51122 12.6135 5.85438 12.481 6.19753 12.3484C6.53616 12.212 6.85488 12.0396 7.17958 11.8877C7.49939 11.7278 7.82481 11.5842 8.13331 11.4148C8.73565 11.052 9.34051 10.7184 9.90882 10.3502C10.4625 9.95811 11.0127 9.57471 11.5478 9.18631C12.0546 8.7626 12.5558 8.34566 13.0547 7.92683L13.0459 7.94648Z" fill="#0055CC"/>
<path d="M114.495 32.3233C112.222 31.5594 111.865 32.4842 114.065 33.4412C115.623 34.1181 117.228 34.7952 118.977 35.5123C119.855 35.8642 120.766 36.2322 121.724 36.617C122.269 36.8321 122.83 37.0521 123.405 37.2771C123.642 37.3719 123.882 37.4581 124.118 37.5446L124.298 37.6109L124.387 37.6431L124.432 37.658C124.448 37.6672 124.451 37.6354 124.461 37.6282L124.677 37.3074C124.82 37.0915 124.962 36.8714 125.107 36.6532C125.214 36.4803 125.323 36.3051 125.431 36.1299C126.78 33.8413 127.434 32.3201 127.986 30.9923C128.522 29.6576 128.956 28.5121 129.531 26.8088C130.002 25.3663 130.481 23.6442 130.752 21.7826C131.029 19.9289 131.072 17.9297 130.72 16.0614C130.685 15.8273 130.618 15.6003 130.566 15.3718L130.485 15.0327C130.452 14.9243 130.42 14.8201 130.388 14.7117C130.257 14.2887 130.129 13.8759 130.004 13.4734C129.871 13.0758 129.708 12.6954 129.569 12.3277C129.497 12.143 129.427 11.9644 129.357 11.79C129.273 11.619 129.194 11.4517 129.115 11.2886C128.956 10.9624 128.812 10.6518 128.666 10.3665C128.501 10.0891 128.349 9.82956 128.209 9.59201C127.945 9.10715 127.656 8.75656 127.474 8.4912L127.134 8.0276L126.744 7.59974C126.627 7.47357 126.483 7.32232 126.319 7.14562C126.159 6.96439 125.94 6.79237 125.717 6.58514C125.273 6.16197 124.688 5.71968 124.013 5.24104C122.649 4.29127 120.829 3.37894 118.787 2.5467C117.766 2.12111 116.69 1.71915 115.586 1.30078C115.27 1.18135 114.951 1.06003 114.628 0.93906C114.367 0.83993 114.105 0.738895 113.84 0.640126L113.446 0.4897L113.246 0.41467L113.146 0.37717L113.096 0.35841C113.096 0.35841 113.082 0.389005 113.075 0.406389C112.755 1.2378 112.429 2.08018 112.103 2.92671C111.218 5.21915 110.304 7.56446 109.412 9.8156C108.794 11.4093 108.234 12.851 107.732 14.1514C107.421 14.9526 107.128 15.7103 106.85 16.4268C106.745 16.6982 106.644 16.965 106.543 17.2276L106.506 17.3274C106.489 17.3478 106.52 17.3471 106.533 17.3544L106.583 17.3731L106.78 17.4463C106.91 17.4938 107.038 17.5435 107.168 17.591C107.634 17.7625 108.085 17.9291 108.525 18.0903C109.559 18.458 110.424 18.7754 111.129 19.0899C111.836 19.4021 112.382 19.7072 112.788 19.9826C113.763 20.6283 114.417 21.4256 114.721 22.3225C115.031 23.2209 115.01 24.211 114.85 25.1627C114.514 27.0782 113.723 28.8274 112.888 30.5008C112.427 31.3926 112.339 31.952 112.53 32.0971L112.524 32.1921C112.543 32.1967 112.555 32.1914 112.562 32.174L112.566 32.1192C112.77 32.2253 113.25 31.9025 113.813 31.0312C114.839 29.3874 115.819 27.6386 116.32 25.4445C116.554 24.3541 116.654 23.1054 116.251 21.8205C116.047 21.1856 115.719 20.5657 115.278 20.0207C114.838 19.4734 114.298 19.004 113.712 18.6079C113.257 18.2948 112.658 17.946 111.931 17.5894C111.201 17.2309 110.34 16.8775 109.378 16.5014C109.259 16.4551 109.137 16.4069 109.015 16.3587L108.972 16.3415L108.965 16.3358L108.952 16.3285L108.932 16.3114L108.894 16.2874C108.885 16.2798 108.864 16.2774 108.883 16.2548C108.905 16.2235 108.922 16.1989 108.937 16.1767C109.05 15.9046 109.164 15.6303 109.285 15.345C109.769 14.1721 110.29 12.891 110.842 11.5045C111.2 10.6006 111.535 9.68824 111.85 8.77542C112.189 7.78926 112.548 6.77404 112.917 5.74334C113.278 4.74895 113.644 3.73943 114.005 2.74504L114.061 2.56814C114.061 2.56814 114.066 2.54885 114.07 2.54849L114.092 2.555L114.135 2.56806L114.223 2.59607L114.268 2.61102L114.292 2.61945L114.381 2.65161L114.756 2.78908C115.003 2.88097 115.248 2.97094 115.491 3.06319C115.976 3.24351 116.451 3.42266 116.91 3.60324C117.372 3.77931 117.813 3.96134 118.238 4.13648C119.943 4.84051 121.328 5.56817 122.259 6.15047C122.71 6.45973 123.088 6.68503 123.314 6.87524C123.546 7.05866 123.675 7.15875 123.675 7.15875C123.675 7.15875 123.72 7.1968 123.812 7.26645C123.898 7.33873 124.044 7.43095 124.196 7.58148C124.355 7.72712 124.549 7.90546 124.772 8.1127C124.829 8.16442 124.886 8.21615 124.948 8.27167C125.001 8.33208 125.059 8.39212 125.117 8.45634C125.233 8.58477 125.355 8.7189 125.483 8.861C126.504 9.99784 127.669 11.8 128.462 14.0309C128.555 14.3103 128.651 14.5957 128.747 14.8812C128.839 15.167 128.95 15.4574 129.012 15.7415C129.087 16.0288 129.164 16.3138 129.211 16.6119L129.291 17.0539C129.312 17.2032 129.325 17.3531 129.347 17.5023C129.488 18.7029 129.464 19.9345 129.335 21.1165C129.074 23.485 128.427 25.6372 127.869 27.2046C127.024 29.5691 126.192 31.2486 125.546 32.5173C124.889 33.7808 124.393 34.6273 124.007 35.2609C123.939 35.3738 123.871 35.4825 123.805 35.589L123.775 35.6377C123.775 35.6377 123.741 35.6281 123.724 35.6254L123.618 35.5863C123.167 35.4156 122.729 35.2521 122.3 35.0921C121.329 34.7356 120.408 34.3979 119.52 34.072C117.742 33.4309 116.096 32.8581 114.486 32.3157L114.495 32.3233Z" fill="#0055CC"/>
<path d="M63.2213 -4.91981C64.3036 -4.55832 64.931 -4.50988 65.0627 -4.7584C65.1871 -4.9937 64.7809 -5.5439 63.6473 -6.03733C62.8457 -6.3791 62.0109 -6.66763 61.1289 -6.89542C60.2473 -7.11905 59.3135 -7.2899 58.3289 -7.34513C57.8413 -7.40358 57.3321 -7.37202 56.8151 -7.38176C56.558 -7.36997 56.296 -7.34306 56.0313 -7.32222C55.898 -7.31066 55.7647 -7.29911 55.6314 -7.28755C55.497 -7.2654 55.3648 -7.24136 55.2303 -7.21921C54.1508 -7.06059 53.0339 -6.72876 51.9327 -6.21366C51.7776 -6.13937 51.624 -6.0715 51.4775 -5.99376C51.3356 -5.91221 51.1978 -5.83104 51.0597 -5.75402C50.7857 -5.59808 50.528 -5.44774 50.2994 -5.27685C50.0662 -5.10976 49.8377 -4.96196 49.6378 -4.79776C49.4383 -4.6294 49.2487 -4.46819 49.0667 -4.31603C48.7053 -4.00564 48.4124 -3.68019 48.1181 -3.3945C47.8555 -3.08218 47.5991 -2.79557 47.3722 -2.50733C46.4759 -1.34485 45.8317 -0.275565 45.0325 1.33172C44.3767 2.70416 43.7657 4.37696 43.3437 6.17395C42.9124 7.95917 42.6876 9.9258 42.8109 11.7679C42.9178 13.6155 43.3565 15.3442 43.9484 16.684C44.5304 18.031 45.2423 18.9618 45.621 19.485C45.8706 19.776 46.1183 20.0692 46.3915 20.3414C46.8871 20.8083 47.8267 21.6795 49.2654 22.4989C49.6286 22.6962 50.0023 22.9177 50.4196 23.1102C50.8332 23.3072 51.2794 23.4931 51.7434 23.6669C52.6774 24.0119 53.698 24.3137 54.8094 24.5258C57.0183 24.9575 59.6288 24.962 62.1114 24.1404C63.3524 23.7391 64.5396 23.1263 65.6002 22.3608C66.6654 21.5991 67.6064 20.6867 68.4118 19.7104C69.54 18.318 70.3115 16.8999 70.9125 15.5972C71.4954 14.2794 71.8779 13.0712 72.1641 11.9868C72.4458 10.8986 72.6224 9.93065 72.7077 9.09447C72.8141 8.26064 72.8305 7.55211 72.8419 6.97831C72.8528 4.26015 72.1712 1.85591 71.051 -0.0633815C70.4777 -1.01665 69.8234 -1.86426 69.0796 -2.58242C68.3284 -3.28736 67.5418 -3.9179 66.6795 -4.40338C66.2508 -4.67885 65.8679 -4.78834 65.5987 -4.84473C65.3256 -4.8966 65.1518 -4.86894 65.0821 -4.77687L65.145 -4.63126C65.1232 -4.66504 65.0952 -4.67311 65.0588 -4.65736L65.0431 -4.69376C65.0108 -4.58185 65.0816 -4.41803 65.2604 -4.21742C65.4355 -4.01228 65.7286 -3.80058 66.0982 -3.50529C66.8482 -2.98281 67.5077 -2.34335 68.1348 -1.66543C68.7505 -0.973925 69.282 -0.187015 69.7486 0.672685C70.2113 1.53691 70.5551 2.50588 70.8114 3.55585C71.0594 4.60655 71.2063 5.74994 71.1886 6.97894C71.1966 7.21745 71.1654 7.48872 71.1497 7.79223C71.1381 8.09539 71.0911 8.42678 71.0364 8.79032C70.948 9.51559 70.767 10.3601 70.5057 11.2954C69.9645 13.1699 69.1073 15.4663 67.5012 17.7163L67.3088 17.9911L67.1005 18.2525L66.6908 18.7811C66.3873 19.1054 66.1203 19.4642 65.8002 19.7668C65.6299 19.9327 65.4716 20.1164 65.2858 20.273C65.1023 20.4316 64.9187 20.5902 64.7333 20.7511C64.3409 21.0432 63.9478 21.35 63.5114 21.5935C62.6552 22.102 61.7221 22.5228 60.7441 22.7629C58.7947 23.2718 56.7658 23.2231 55.0396 22.865C53.3077 22.5136 51.8735 21.9413 50.9288 21.4483C50.4595 21.1889 50.0869 20.9799 49.8427 20.8249C49.602 20.6611 49.4726 20.5716 49.4726 20.5716C49.4726 20.5716 49.4235 20.5381 49.3322 20.4768C49.2405 20.4113 49.0971 20.3293 48.9364 20.1942C48.772 20.0637 48.5714 19.9027 48.3372 19.7174C48.1201 19.5117 47.8736 19.2813 47.5996 19.0239C47.0988 18.4714 46.5061 17.8031 46.0168 16.9475C45.52 16.1009 45.0877 15.1039 44.7938 14.0068C44.1804 11.8107 44.2512 9.25102 44.7058 6.95602C45.1626 4.63984 45.9616 2.59194 46.736 1.18404C47.8904 -0.951311 49.1258 -2.26907 50.1581 -3.12021C51.1942 -3.97588 52.0123 -4.41609 52.6484 -4.70413C53.6061 -5.15434 54.5704 -5.45614 55.5178 -5.6138C55.6356 -5.6345 55.753 -5.65937 55.8686 -5.68198C55.9871 -5.69435 56.1034 -5.70862 56.2219 -5.72099C56.4548 -5.74538 56.6851 -5.77583 56.9142 -5.79569C57.3752 -5.80208 57.8243 -5.8494 58.2681 -5.81234C60.0484 -5.77572 61.691 -5.41453 63.2383 -4.91709L63.2213 -4.91981Z" fill="#0055CC"/>
<path d="M149.643 41.1462C149.707 41.1386 149.772 41.135 149.834 41.1296C149.897 41.1284 149.958 41.1335 150.017 41.1368C150.136 41.1434 150.255 41.1393 150.367 41.1485C150.584 41.1884 150.799 41.195 150.983 41.2609C151.077 41.2863 151.167 41.3078 151.257 41.3294C151.342 41.3619 151.422 41.3948 151.5 41.4216C151.58 41.4504 151.654 41.4776 151.725 41.5028C151.793 41.5368 151.859 41.5689 151.92 41.5972C152.179 41.7027 152.367 41.8102 152.516 41.8582C152.665 41.9103 152.768 41.9119 152.818 41.8655C152.869 41.8192 152.863 41.7211 152.795 41.5675C152.727 41.4139 152.604 41.2022 152.364 40.9733C152.304 40.9155 152.242 40.8517 152.176 40.7882C152.104 40.7315 152.021 40.6736 151.936 40.6138C151.851 40.554 151.758 40.4908 151.66 40.4279C151.555 40.3783 151.444 40.3271 151.328 40.2721C151.099 40.1534 150.826 40.0974 150.536 40.0197C150.391 39.9903 150.237 39.9806 150.078 39.9629C149.999 39.955 149.919 39.9452 149.837 39.9418C149.757 39.9445 149.674 39.9476 149.59 39.9506C148.636 39.9788 147.736 40.254 146.905 40.6177C146.068 40.9798 145.315 41.471 144.572 41.9823C144.209 42.2488 143.842 42.5115 143.498 42.8057C143.142 43.0862 142.801 43.3864 142.46 43.695L142.203 43.9229C142.117 43.9975 142.015 44.1008 141.928 44.1902C141.84 44.2818 141.755 44.373 141.675 44.4639L141.463 44.7068L141.37 44.8029C141.341 44.8285 141.308 44.8776 141.28 44.8192L141.196 44.7216L141.177 44.698L141.059 44.5718L140.819 44.3157C140.497 43.9722 140.173 43.6226 139.843 43.2714C139.187 42.5688 138.512 41.8509 137.823 41.1133C136.438 39.6471 134.985 38.105 133.447 36.4758C133.366 36.3925 133.286 36.3093 133.205 36.2261L133.16 36.188C133.113 36.1606 133.152 36.1278 133.173 36.0987L133.224 36.0376C133.316 35.9373 133.407 35.8393 133.497 35.7413C133.679 35.5471 133.86 35.3593 134.04 35.1738C134.763 34.4418 135.456 33.7649 136.09 33.1581C137.34 31.9418 138.448 30.9918 139.511 30.1548C140.576 29.3197 141.597 28.587 142.741 27.9067C143.884 27.2263 145.144 26.5737 146.712 25.9993C147.041 25.8701 147.387 25.775 147.733 25.6568C148.083 25.5489 148.444 25.4588 148.809 25.36C149.549 25.1973 150.314 25.0408 151.105 24.9722C152.687 24.8036 154.367 24.8909 156.008 25.2858C157.649 25.6806 159.244 26.388 160.67 27.3471C162.105 28.2991 163.355 29.4853 164.442 30.7697C165.532 32.0453 166.437 33.3937 167.101 34.744C167.769 36.094 168.2 37.4415 168.453 38.689C168.707 39.9385 168.791 41.0831 168.821 42.0542C168.854 43.0248 168.81 43.826 168.784 44.399L168.72 45.4389C168.704 45.7886 168.699 46.1626 168.693 46.5093C168.686 47.1141 168.656 47.9581 168.694 49.1446C168.711 49.7348 168.755 50.4171 168.886 51.1989C169.02 51.9762 169.253 52.8834 169.791 53.7915C170.053 54.2472 170.391 54.6816 170.799 55.0868C171.204 55.5007 171.727 55.8667 172.326 56.1546C172.941 56.4245 173.637 56.5655 174.345 56.5693C175.051 56.5605 175.743 56.4082 176.418 56.1881C177.747 55.7099 178.979 54.9338 180.172 53.9974C180.767 53.5283 181.354 53.0136 181.936 52.4638C182.23 52.1929 182.508 51.9211 182.801 51.6419C182.857 51.5887 182.911 51.5337 182.968 51.4805L183.01 51.4391C183.026 51.4524 183.042 51.4657 183.06 51.481L183.076 51.4943L183.085 51.5019L183.154 51.5756C183.256 51.6801 183.36 51.7907 183.472 51.9047C183.91 52.3619 184.42 52.8906 184.982 53.4797C186.108 54.6578 187.46 56.0766 188.952 57.6405C189.633 58.3557 190.346 59.1059 191.082 59.8793C191.101 59.907 191.162 59.9353 191.113 59.9669L191.075 60.0121L190.913 60.1856C190.524 60.6075 190.105 61.0278 189.673 61.445C189.235 61.8649 188.793 62.2851 188.349 62.7117C187.9 63.1179 187.462 63.5461 186.997 63.9389C186.087 64.7501 185.126 65.5027 184.164 66.2239C181.541 68.1593 178.922 69.5424 176.438 70.3284C173.956 71.1228 171.629 71.2992 169.639 71.0479C168.643 70.9245 167.728 70.7079 166.902 70.427C166.08 70.1373 165.338 69.8072 164.678 69.449C163.359 68.7303 162.368 67.9392 161.596 67.2591C160.691 66.4521 159.878 65.572 159.161 64.6753C158.43 63.7861 157.823 62.8547 157.303 61.9115C156.265 60.0228 155.669 58.0497 155.387 56.0934C155.235 55.1162 155.172 54.1397 155.141 53.1751C155.104 52.2089 155.139 51.2533 155.147 50.279C155.152 49.3092 155.16 48.358 155.127 47.3873C155.092 46.4231 155.005 45.4381 154.757 44.4609C154.485 43.4059 153.996 42.6741 153.603 42.2822C153.412 42.0785 153.232 41.9619 153.1 41.8936C152.968 41.8253 152.879 41.812 152.832 41.8497L152.701 41.8442C152.697 41.8635 152.703 41.8692 152.722 41.8655L152.829 41.8436L152.808 41.8685C152.77 41.9138 152.772 42.008 152.817 42.1426C152.86 42.2752 152.946 42.4482 153.042 42.6791C153.244 43.1316 153.527 43.7785 153.718 44.7041C153.889 45.5705 153.936 46.4792 153.926 47.4054C153.92 48.3312 153.872 49.2838 153.833 50.2398C153.722 52.1482 153.636 54.1889 153.902 56.2935C154.151 58.3995 154.77 60.593 155.881 62.6747C156.437 63.7134 157.093 64.7371 157.873 65.7018C158.641 66.6759 159.501 67.6149 160.49 68.5006C161.26 69.1829 162.28 70.0177 163.649 70.8244C165.02 71.6183 166.762 72.3758 168.863 72.7476C170.959 73.1156 173.393 73.0683 175.922 72.44C178.453 71.8219 181.043 70.6301 183.565 69.0036C185.208 67.94 186.742 66.7265 188.162 65.4284C188.478 65.1492 188.784 64.8541 189.092 64.5567C189.402 64.2613 189.714 63.9636 190.011 63.665C190.619 63.0668 191.235 62.4573 191.845 61.8107L192.299 61.316C192.345 61.2617 192.523 61.0679 192.639 60.9257L193.021 60.4708L193.391 60.0086L193.486 59.8955C193.48 59.8561 193.425 59.821 193.399 59.7834L193.195 59.566C192.933 59.2761 192.65 58.988 192.374 58.7014C191.761 58.0705 191.146 57.4377 190.534 56.8068C189.331 55.5598 188.135 54.3226 186.969 53.1144C185.625 51.7139 184.318 50.348 183.066 49.0444C182.442 49.6398 181.829 50.2259 181.227 50.8048C181.016 51.0098 180.808 51.2062 180.602 51.3919C180.393 51.5799 180.196 51.7733 179.987 51.9488C179.164 52.6706 178.326 53.2951 177.498 53.7927C176.67 54.2863 175.836 54.6439 175.066 54.7841C174.293 54.9266 173.6 54.8461 173.042 54.5966C172.477 54.3497 172.045 53.936 171.712 53.5326C171.383 53.1289 171.169 52.7362 171.022 52.3965C170.949 52.2266 170.901 52.067 170.85 51.9351C170.811 51.7937 170.778 51.677 170.753 51.5826C170.724 51.4886 170.713 51.4098 170.7 51.3606C170.689 51.309 170.683 51.2844 170.683 51.2844C170.683 51.2844 170.655 51.1757 170.62 50.9647C170.602 50.8571 170.582 50.7245 170.558 50.5692C170.542 50.409 170.522 50.2261 170.5 50.0182C170.428 49.181 170.429 47.9304 170.475 46.3506C170.48 45.578 170.559 44.7172 170.575 43.7653C170.586 42.816 170.584 41.7985 170.473 40.7275C170.366 39.6562 170.183 38.5328 169.879 37.3967C169.563 36.2616 169.12 35.1208 168.563 34.0109C168.013 32.8919 167.297 31.8419 166.532 30.8276C166.332 30.5785 166.135 30.3312 165.933 30.0802C165.729 29.8356 165.508 29.603 165.296 29.3632C165.082 29.1258 164.871 28.886 164.637 28.6587C164.41 28.4287 164.184 28.1965 163.941 27.9846C162.045 26.2207 159.744 24.834 157.312 24.1068C154.881 23.3649 152.383 23.3003 150.19 23.631C147.983 23.9545 146.071 24.6532 144.51 25.353C142.165 26.4333 140.292 27.6636 138.737 28.8286C137.183 29.9978 135.935 31.0964 134.891 32.0807C133.859 33.0556 132.992 33.8798 132.263 34.6501C132.173 34.7481 132.085 34.8439 131.996 34.9355C131.87 35.0807 131.724 35.2361 131.601 35.3915C131.474 35.5473 131.351 35.6986 131.228 35.8498C131.165 35.9245 131.108 36.0008 131.048 36.0732C131.006 36.1461 130.87 36.225 130.986 36.2883C131.232 36.5607 131.465 36.8217 131.709 37.0734C131.889 37.2634 132.062 37.4477 132.23 37.624C133.778 39.2461 135.238 40.775 136.632 42.2363C137.33 42.9626 138.015 43.6733 138.681 44.3688C139.015 44.7154 139.345 45.0583 139.674 45.3969C139.865 45.5964 140.056 45.7918 140.245 45.9894L140.649 46.4098C140.784 46.5428 140.916 46.6615 141.049 46.7885L141.247 46.9748L141.299 47.0185L141.32 47.044C141.325 47.0478 141.329 47.0516 141.332 47.0535L141.343 47.0399L141.444 46.943L141.83 46.5529C142.085 46.3 142.335 46.0077 142.564 45.7213C142.888 45.3177 143.089 45.0967 143.437 44.779C143.751 44.4791 144.068 44.1851 144.395 43.9113C144.712 43.6257 145.047 43.3701 145.374 43.1088C146.043 42.6165 146.72 42.1424 147.435 41.8013C148.146 41.4564 148.886 41.2055 149.62 41.1503L149.643 41.1462Z" fill="#0055CC"/>
<path d="M80.321 9.381C80.4416 7.10655 79.4571 7.02823 79.1312 9.25752C78.8942 10.8392 78.6434 12.4555 78.3341 14.1966C78.018 15.932 77.6635 17.8049 77.0533 19.8029C76.9621 20.1318 76.8558 20.4327 76.7629 20.7177C76.7418 20.7888 76.7161 20.8561 76.6904 20.9233C76.6579 21.008 76.6295 21.0923 76.5966 21.1728C76.5069 21.4218 76.4055 21.6573 76.3015 21.8866C75.8871 22.7744 75.5595 23.4763 75.3454 23.9376C76.5743 23.808 77.6597 23.6698 78.5962 23.5572C79.1374 23.483 79.6268 23.4154 80.1059 23.3508C81.0599 23.2219 81.9734 23.1092 83.1533 22.9964C85.9529 22.7118 89.7215 22.3998 93.0728 22.1386C93.9107 22.0744 94.7237 22.0123 95.4885 21.9523C95.6782 21.938 95.8679 21.9236 96.0534 21.9097C96.3908 21.8804 96.7199 21.8519 97.0447 21.8237C97.2132 21.807 97.3821 21.7945 97.5465 21.7781L97.6089 21.7727C97.6204 21.7591 97.6182 21.7341 97.6228 21.7148L97.6419 21.5957L97.6801 21.3574C97.73 21.0362 97.7788 20.7257 97.826 20.4215C97.9332 19.7429 98.0279 19.1388 98.1097 18.6281C98.1809 18.1394 98.241 17.7418 98.2835 17.4569C98.332 17.1191 98.3699 16.7801 98.4014 16.4396C98.4496 15.9045 98.5308 14.9722 98.6212 13.7348C98.6626 13.1206 98.7101 12.4304 98.7605 11.6769C98.8248 10.9391 98.9042 10.1327 98.9956 9.27083C99.1893 7.55237 99.4495 5.63093 99.8761 3.6447C100.088 2.65271 100.35 1.64389 100.688 0.657733C100.777 0.415087 100.869 0.172091 100.959 -0.0728197L101.111 -0.432169L101.185 -0.612789C101.19 -0.632072 101.226 -0.698169 101.255 -0.755205L101.343 -0.924419L101.695 -1.60959C101.746 -1.72103 101.822 -1.84298 101.901 -1.96529L102.126 -2.32887C102.421 -2.80344 102.713 -3.27991 103.01 -3.75675C102.93 -3.75822 102.807 -3.74549 102.664 -3.73095C102.522 -3.71867 102.364 -3.70079 102.189 -3.68563C101.84 -3.65113 101.434 -3.60967 100.989 -3.56688C100.271 -3.49835 99.4285 -3.41482 98.594 -3.33619C92.1629 -2.6822 88.1819 -2.27836 86.104 -2.06678C84.8775 -1.93528 83.7301 -1.81063 82.6387 -1.69294C81.9634 -1.61553 81.3068 -1.54182 80.6649 -1.4673L80.3138 -1.42637L80.1393 -1.40705L80.054 -1.39756C80.054 -1.39756 80.0158 -1.40264 80.0195 -1.38408L80.0129 -1.33944C79.9849 -1.10411 79.9566 -0.872952 79.9306 -0.639888C79.9042 -0.410991 79.8778 -0.182091 79.8514 0.046808C79.8379 0.182264 79.824 0.313557 79.8105 0.449013C79.6178 2.44645 79.5162 4.28491 79.4719 6.10582C79.4328 8.10883 80.2926 8.15179 80.5363 6.1856C80.7678 4.39463 81.0108 2.59008 81.2991 0.630513C81.3163 0.51362 81.3335 0.396721 81.3507 0.279829L81.3736 0.156149L81.3968 0.0366324C81.4245 0.0174448 81.4801 0.0294168 81.5173 0.0220026L81.6426 0.0153272C81.7592 0.00521753 81.8758 -0.00488413 81.9924 -0.0149939C82.259 -0.0381019 82.5275 -0.0634723 82.8005 -0.0850388C83.891 -0.187965 85.0441 -0.296311 86.2698 -0.413054C88.1772 -0.605671 92.1765 -0.77399 97.792 -1.29854C98.2499 -1.34242 98.7073 -1.39046 99.1621 -1.44458L99.459 -1.4808C99.459 -1.4808 99.4628 -1.48532 99.4666 -1.48985C99.4723 -1.49664 99.4841 -1.50606 99.5061 -1.51846C99.5282 -1.53086 99.5786 -1.55412 99.6074 -1.56081C99.6134 -1.54035 99.619 -1.52404 99.5928 -1.43784L99.5732 -1.37321L99.4323 -1.01267C99.3335 -0.771204 99.2457 -0.524399 99.1662 -0.278311C98.8317 0.707485 98.5712 1.70154 98.3498 2.68592C97.9192 4.64943 97.6406 6.5515 97.4316 8.21463C97.2283 9.87097 97.0684 11.3011 96.9964 12.3145C96.9101 13.3082 96.8578 13.8939 96.8578 13.8939C96.8578 13.8939 96.7819 14.8384 96.6206 16.3484C96.541 17.1044 96.4359 18.0011 96.3094 18.9919C96.2578 19.3657 96.2075 19.7561 96.1523 20.1616C96.1696 20.265 96.0622 20.2366 95.9922 20.2511C95.7737 20.2721 95.5533 20.2954 95.3287 20.3191C90.738 20.782 85.3487 21.3268 82.1496 21.6503L79.3959 21.931L78.3394 22.0393L78.1542 22.0575L78.0607 22.0677L78.0148 22.0717C78.0148 22.0717 77.9678 22.0862 77.9869 22.0636C78.0476 21.9408 78.1061 21.8162 78.1578 21.6858L78.2605 21.4167C78.3084 21.2909 78.3479 21.1657 78.3917 21.0402C78.4791 20.7893 78.5624 20.5387 78.637 20.2846C79.2812 18.1452 79.6012 16.2123 79.8478 14.4263C80.088 12.6388 80.2266 10.9859 80.3206 9.37683L80.321 9.381Z" fill="#0055CC"/>
</g>
</g>
<defs>
<clipPath id="clip0_550_14457">
<rect width="419" height="16" fill="white"/>
</clipPath>
<clipPath id="clip1_550_14457">
<rect width="304" height="304.679" fill="white" transform="translate(268.681 74.498) rotate(-105)"/>
</clipPath>
<clipPath id="clip2_550_14457">
<rect width="304" height="304.679" fill="white" transform="translate(-42.3188 330) rotate(-105)"/>
</clipPath>
</defs>
</svg>
`;
const $fc6840133e04adc0$var$$e48fba9cf5395297$export$d3a66d29d3f047ac = `data:image/svg+xml;base64,${$fc6840133e04adc0$var$$e48fba9cf5395297$require$Buffer.from($fc6840133e04adc0$var$$e48fba9cf5395297$var$courseBg).toString("base64")}`;
var $fc6840133e04adc0$var$$ea8e736e4eb06883$require$Buffer = (0, $7KfP5.Buffer);
const $fc6840133e04adc0$var$$ea8e736e4eb06883$var$learningPathBg = `<svg width="420" height="32" viewBox="0 0 420 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clipPath="url(#clip0_783_5660)">
<rect width="421" height="32" fill="#D3F1A7"/>
<g clipPath="url(#clip1_783_5660)">
<path d="M419.987 -18.535C419.996 -18.6008 420.003 -18.6685 420.014 -18.7325C420.032 -18.7948 420.048 -18.855 420.064 -18.9151C420.099 -19.0357 420.114 -19.1586 420.159 -19.2633C420.248 -19.4787 420.309 -19.6897 420.416 -19.8626C420.463 -19.9547 420.508 -20.0405 420.551 -20.1239C420.603 -20.204 420.653 -20.2776 420.702 -20.3489C420.75 -20.4203 420.79 -20.495 420.836 -20.56C420.888 -20.6211 420.931 -20.6814 420.974 -20.7377C421.14 -20.9766 421.288 -21.1425 421.37 -21.2818C421.452 -21.4212 421.479 -21.5221 421.443 -21.5798C421.407 -21.6375 421.307 -21.6519 421.142 -21.6125C420.978 -21.5731 420.733 -21.4931 420.458 -21.2993C420.387 -21.2511 420.313 -21.2007 420.234 -21.1477C420.159 -21.0908 420.086 -21.0173 420.006 -20.9454C419.928 -20.8715 419.847 -20.7931 419.762 -20.7102C419.686 -20.6197 419.613 -20.5189 419.533 -20.4155C419.364 -20.2141 419.244 -19.9561 419.102 -19.6815C419.032 -19.5432 418.992 -19.3908 418.936 -19.237C418.91 -19.1592 418.885 -19.0794 418.86 -18.9996C418.838 -18.918 418.826 -18.8351 418.809 -18.7496C418.615 -17.7845 418.69 -16.8132 418.876 -15.8956C419.059 -14.9694 419.392 -14.1023 419.756 -13.2441C419.947 -12.8201 420.142 -12.3942 420.364 -11.9834C420.574 -11.5631 420.81 -11.1597 421.049 -10.7503L421.231 -10.4387C421.302 -10.3211 421.379 -10.2102 421.453 -10.1055C421.527 -10.0007 421.606 -9.89626 421.681 -9.80207L421.834 -9.60345C421.861 -9.56587 421.887 -9.52828 421.909 -9.4945C421.917 -9.4763 421.939 -9.45727 421.93 -9.44179L421.87 -9.40722L421.756 -9.34487C421.555 -9.22042 421.349 -9.0956 421.146 -8.96889C420.732 -8.71475 420.314 -8.45608 419.889 -8.19478C419.043 -7.67029 418.178 -7.13793 417.292 -6.589C415.522 -5.48507 413.666 -4.32963 411.701 -3.10388C411.569 -3.02115 411.438 -2.93843 411.311 -2.85606L411.263 -2.82257C411.247 -2.8128 411.23 -2.79243 411.213 -2.79515L411.176 -2.83808L411.129 -2.89695C411.053 -2.99948 410.979 -3.10009 410.908 -3.19881C410.748 -3.42205 410.595 -3.64376 410.445 -3.86582C409.853 -4.75028 409.317 -5.59134 408.833 -6.35724C407.867 -7.87654 407.139 -9.19195 406.523 -10.4478C405.911 -11.7041 405.395 -12.8911 404.961 -14.1984C404.532 -15.502 404.156 -16.9192 403.941 -18.6296C403.764 -20.0725 403.734 -21.6583 403.948 -23.2903C404.067 -24.1022 404.224 -24.932 404.485 -25.7436C404.596 -26.1561 404.761 -26.5544 404.909 -26.9595C405.08 -27.3563 405.245 -27.7587 405.453 -28.1439C405.847 -28.9251 406.311 -29.6787 406.85 -30.3843C407.385 -31.0937 407.973 -31.7657 408.624 -32.3739C408.936 -32.6906 409.287 -32.9707 409.619 -33.2638C409.969 -33.5376 410.311 -33.8212 410.678 -34.0691C411.033 -34.3348 411.41 -34.5668 411.777 -34.8022C412.152 -35.0319 412.539 -35.2438 412.914 -35.4652C414.436 -36.3063 415.99 -36.9508 417.497 -37.3605C419.003 -37.7744 420.458 -37.953 421.776 -37.9728C423.096 -37.9949 424.276 -37.8643 425.269 -37.7091C426.262 -37.5581 427.07 -37.3658 427.646 -37.2332L428.69 -36.9733C429.045 -36.8908 429.419 -36.8161 429.771 -36.7439C430.378 -36.6244 431.227 -36.4357 432.428 -36.2524C433.028 -36.1617 433.721 -36.077 434.532 -36.0634C435.339 -36.0536 436.29 -36.115 437.298 -36.4731C437.804 -36.6386 438.302 -36.8958 438.794 -37.2049C439.033 -37.3788 439.288 -37.5352 439.516 -37.7606C439.63 -37.8691 439.756 -37.9682 439.863 -38.0907C439.969 -38.2175 440.076 -38.3442 440.183 -38.4709C440.585 -39.0094 440.922 -39.6534 441.087 -40.3602C441.245 -41.0621 441.295 -41.8007 441.211 -42.5237C441.061 -43.9794 440.534 -45.3837 439.853 -46.7871C439.509 -47.4895 439.114 -48.1854 438.684 -48.8867C438.47 -49.2438 438.255 -49.5756 438.036 -49.93C437.987 -50.0056 437.941 -50.0792 437.892 -50.1547L437.861 -50.2044C437.876 -50.2184 437.894 -50.2304 437.914 -50.2447C437.836 -50.1981 438.202 -50.4313 438.461 -50.5964C439.016 -50.9487 439.658 -51.3548 440.372 -51.8091C441.803 -52.7116 443.524 -53.7987 445.425 -54.9978C446.336 -55.572 447.291 -56.171 448.275 -56.7892L448.326 -56.823C448.342 -56.8286 448.363 -56.8577 448.374 -56.8292L448.412 -56.7821L448.504 -56.658C448.854 -56.1743 449.194 -55.6645 449.531 -55.1418C449.866 -54.6086 450.202 -54.0712 450.54 -53.5319C450.86 -52.9889 451.204 -52.4564 451.506 -51.9013C452.14 -50.8043 452.697 -49.6713 453.218 -48.5373C454.609 -45.4749 455.414 -42.519 455.622 -39.8408C455.835 -37.1588 455.451 -34.7734 454.708 -32.8332C453.969 -30.885 452.931 -29.3703 451.906 -28.2008C450.869 -27.0366 449.854 -26.1975 448.994 -25.5648C448.74 -25.377 448.489 -25.1937 448.225 -25.026C447.964 -24.8545 447.711 -24.6814 447.441 -24.53C447.177 -24.3729 446.912 -24.2176 446.652 -24.0609C446.391 -23.906 446.118 -23.7796 445.858 -23.6395C445.335 -23.3487 444.792 -23.1337 444.267 -22.891C444.001 -22.782 443.73 -22.6893 443.467 -22.5866L443.07 -22.4369L442.67 -22.314C441.607 -21.9638 440.54 -21.7559 439.49 -21.6188C438.439 -21.4752 437.397 -21.4584 436.377 -21.4937C435.354 -21.5267 434.349 -21.6453 433.361 -21.7967C432.866 -21.8692 432.377 -21.9632 431.889 -22.0531C431.396 -22.1509 430.914 -22.2581 430.418 -22.3473C429.434 -22.5327 428.468 -22.7238 427.477 -22.8687C426.491 -23.0141 425.476 -23.1065 424.439 -23.0397C423.318 -22.9551 422.489 -22.6084 422.02 -22.2886C421.775 -22.1352 421.62 -21.9792 421.526 -21.8618C421.431 -21.7445 421.396 -21.6576 421.422 -21.6053L421.393 -21.479C421.408 -21.4698 421.421 -21.475 421.419 -21.4959L421.417 -21.6091L421.441 -21.5817C421.478 -21.5346 421.572 -21.5217 421.717 -21.5385C421.86 -21.5572 422.053 -21.6117 422.306 -21.6651C422.804 -21.788 423.52 -21.9508 424.501 -21.9792C426.333 -22.0037 428.217 -21.4935 430.151 -21.0652C432.069 -20.5957 434.122 -20.1211 436.309 -19.998C437.401 -19.9333 438.53 -19.9304 439.679 -20.0657C440.824 -20.1922 441.997 -20.4072 443.155 -20.774L443.593 -20.9043L444.026 -21.0615C444.313 -21.1682 444.608 -21.2672 444.896 -21.3845C445.464 -21.6372 446.054 -21.871 446.616 -22.1756C446.899 -22.3239 447.191 -22.4605 447.471 -22.6232C447.751 -22.7859 448.03 -22.9528 448.316 -23.1182C448.602 -23.2794 448.877 -23.4648 449.157 -23.6507C449.44 -23.8304 449.714 -24.0284 449.988 -24.2305C450.841 -24.8583 451.905 -25.7017 453.021 -26.8958C453.309 -27.1872 453.571 -27.5226 453.863 -27.8606C454.004 -28.0322 454.137 -28.2179 454.276 -28.402C454.418 -28.5843 454.554 -28.7745 454.686 -28.9768C455.233 -29.7649 455.74 -30.6671 456.174 -31.674C457.054 -33.6807 457.614 -36.138 457.566 -38.828C457.534 -41.5172 456.936 -44.4071 455.846 -47.3131C455.131 -49.2087 454.232 -51.0192 453.22 -52.7276C453 -53.1093 452.768 -53.4858 452.531 -53.8597C452.294 -54.2399 452.058 -54.616 451.817 -54.9854C451.333 -55.7282 450.844 -56.4873 450.306 -57.2401C450.171 -57.4277 450.035 -57.6153 449.893 -57.8044C449.653 -58.1256 449.383 -58.4568 449.123 -58.7679L448.927 -59.0068L448.828 -59.1242L448.779 -59.185L448.713 -59.1436L448.187 -58.8211L447.222 -58.2108C446.463 -57.7211 445.702 -57.2334 444.944 -56.746C443.425 -55.775 441.918 -54.8134 440.448 -53.874C438.753 -52.7997 437.104 -51.7524 435.527 -50.7533C435.991 -50.0109 436.451 -49.2807 436.903 -48.5604C437.066 -48.3038 437.217 -48.0567 437.362 -47.8112C437.505 -47.5634 437.664 -47.3254 437.793 -47.0785C438.349 -46.1048 438.792 -45.1298 439.105 -44.1939C439.417 -43.2557 439.58 -42.3466 439.535 -41.5454C439.493 -40.7424 439.25 -40.0624 438.851 -39.5599C438.46 -39.0497 437.954 -38.6911 437.475 -38.4376C436.995 -38.1883 436.554 -38.0452 436.181 -37.9646C435.996 -37.9234 435.825 -37.9044 435.679 -37.877C435.529 -37.864 435.404 -37.8532 435.302 -37.8423C435.2 -37.8313 435.122 -37.8309 435.068 -37.8304C435.013 -37.8298 434.988 -37.8277 434.988 -37.8277C434.988 -37.8277 434.871 -37.8259 434.651 -37.8215C434.54 -37.8265 434.399 -37.829 434.237 -37.8338C434.073 -37.8406 433.88 -37.8596 433.667 -37.8767C432.801 -37.9591 431.531 -38.1931 429.936 -38.5374C429.151 -38.6876 428.292 -38.93 427.33 -39.1214C426.369 -39.3109 425.335 -39.5004 424.228 -39.5891C423.123 -39.6842 421.952 -39.7107 420.741 -39.6162C419.533 -39.5115 418.291 -39.2884 417.058 -38.9423C415.82 -38.6 414.613 -38.0967 413.43 -37.5305C412.848 -37.2282 412.256 -36.9336 411.697 -36.585C411.125 -36.2585 410.565 -35.8952 410.019 -35.5121C407.837 -33.978 405.925 -31.9889 404.62 -29.721C403.3 -27.4622 402.621 -24.9777 402.422 -22.6922C402.327 -21.5468 402.342 -20.4487 402.416 -19.4206C402.469 -18.909 402.508 -18.413 402.588 -17.9395C402.625 -17.7035 402.656 -17.4691 402.697 -17.2418C402.742 -17.0149 402.786 -16.7921 402.83 -16.5777C403.106 -15.2755 403.444 -14.0753 403.836 -12.9846C404.024 -12.4365 404.237 -11.9178 404.431 -11.4143C404.65 -10.9213 404.839 -10.4341 405.058 -9.9831C405.906 -8.16185 406.754 -6.66802 407.532 -5.40729C408.303 -4.16059 408.956 -3.11351 409.589 -2.2179C409.677 -2.09754 409.763 -1.97908 409.846 -1.86252C409.972 -1.69507 410.097 -1.53177 410.231 -1.3692C410.364 -1.2108 410.493 -1.05203 410.619 -0.899327C410.683 -0.822977 410.748 -0.74889 410.811 -0.672541C410.838 -0.607701 410.885 -0.664288 410.925 -0.684559L411.049 -0.758224C411.375 -0.948013 411.688 -1.14089 411.994 -1.3353C412.199 -1.46428 412.396 -1.58837 412.583 -1.70531C414.541 -2.94093 416.392 -4.10849 418.154 -5.2223C419.034 -5.7811 419.891 -6.3275 420.73 -6.86187C421.15 -7.13113 421.563 -7.39361 421.975 -7.65798C422.182 -7.78922 422.388 -7.92463 422.593 -8.0536L423.1 -8.37663L423.351 -8.53683L423.58 -8.6994L424.035 -9.02415L424.063 -9.04335L424.074 -9.05693C424.074 -9.05693 424.071 -9.06299 424.069 -9.06906L424.03 -9.12865L423.95 -9.24973L423.794 -9.48584C423.591 -9.79557 423.369 -10.1058 423.118 -10.4051L422.846 -10.7382L422.646 -10.9915C422.584 -11.0743 422.525 -11.1593 422.472 -11.2387L422.296 -11.5214C422.062 -11.9039 421.823 -12.282 421.616 -12.6689C421.392 -13.0503 421.203 -13.441 421.015 -13.8275C420.658 -14.6065 420.324 -15.3895 420.137 -16.1875C419.943 -16.9806 419.861 -17.7834 419.977 -18.5362L419.987 -18.535Z" fill="#6A9A23"/>
<path d="M375.063 24.9613C374.963 24.9469 374.87 24.934 374.776 24.9211C374.684 24.9207 374.594 24.9181 374.507 24.9151C374.335 24.9132 374.174 24.9167 374.025 24.9233C373.73 24.9258 373.486 24.9952 373.295 25.0474C372.911 25.1605 372.732 25.2998 372.737 25.4357C372.745 25.5735 372.937 25.7079 373.298 25.8109C373.477 25.8688 373.704 25.8932 373.964 25.9651C374.095 25.9937 374.236 26.0234 374.387 26.046C374.461 26.0584 374.54 26.0705 374.623 26.0822C374.702 26.1026 374.783 26.1207 374.867 26.1407C375.825 26.3325 376.729 26.7137 377.473 27.3312C378.22 27.9441 378.807 28.785 379.24 29.7755C379.678 30.7657 379.967 31.901 380.15 33.1252C380.208 33.4286 380.237 33.7429 380.273 34.0629C380.311 34.3807 380.35 34.7026 380.365 35.0327C380.388 35.3644 380.408 35.6983 380.431 36.0384C380.447 36.3874 380.465 36.7426 380.481 37.1C380.568 38.5486 380.642 39.8241 380.666 40.2417C381.225 40.2059 381.762 40.1741 382.279 40.1418C382.607 40.1197 382.919 40.0968 383.222 40.0768C383.739 40.0362 384.218 39.9989 384.668 39.964C385.568 39.8902 386.356 39.8262 387.106 39.7653C388.606 39.6437 389.965 39.5385 391.821 39.449C393.519 39.3668 395.452 39.2727 397.832 39.1566C397.789 38.0735 397.747 36.9566 397.702 35.8254C397.669 34.9323 397.636 34.0245 397.605 33.125C397.53 31.3039 397.376 29.4981 397.138 27.8338C396.902 26.1715 396.583 24.6549 396.247 23.4104C395.91 22.1659 395.554 21.1981 395.327 20.6092C395.161 20.1725 394.959 19.7431 394.754 19.3202C394.367 18.5733 393.65 17.1667 392.278 15.5734C391.593 14.7809 390.741 13.9525 389.693 13.2062C388.648 12.4595 387.41 11.801 386.039 11.3281C384.669 10.8447 383.165 10.5723 381.624 10.4666C380.079 10.3572 378.499 10.4312 376.908 10.6467C373.722 11.0467 370.51 12.3407 368.007 14.3579C366.235 15.781 364.937 17.3979 363.976 18.95C363.746 19.3434 363.514 19.7244 363.305 20.1013C363.11 20.4854 362.924 20.8582 362.739 21.2205C362.569 21.5877 362.42 21.9489 362.268 22.3C362.215 22.422 362.163 22.544 362.112 22.6638C362.01 22.8133 362.067 22.9888 362.062 23.1549C362.073 23.3492 362.081 23.5415 362.091 23.7274C362.225 26.4708 362.325 28.491 362.392 29.8763C362.478 31.4741 362.561 32.9734 362.623 34.1577L364.386 34.2336C364.674 32.0726 365.411 30.2357 366.575 28.8843C367.741 27.5432 369.26 26.6687 370.916 26.2336C371.517 26.0786 371.977 25.9401 372.284 25.8233C372.59 25.6982 372.75 25.5626 372.742 25.4437C372.74 25.3221 372.569 25.2173 372.224 25.1508C371.88 25.0778 371.359 25.0726 370.681 25.1943C368.823 25.5253 366.976 26.4093 365.521 27.937C364.067 29.4689 363.142 31.6116 362.786 34.0198L364.239 34.0827C364.187 32.8954 364.122 31.3966 364.054 29.7974C363.992 28.5249 363.955 26.5621 363.894 23.9844C363.891 23.8231 363.885 23.66 363.883 23.4923L363.878 23.2409L363.877 23.1781L363.878 23.1675L363.881 23.1505C363.881 23.1505 363.892 23.1327 363.903 23.1108C363.934 23.0409 363.966 22.971 364 22.903C364.071 22.75 364.141 22.5928 364.214 22.4376C364.35 22.1194 364.523 21.8086 364.694 21.4895C364.779 21.329 364.866 21.1662 364.953 21.0034C365.043 20.8403 365.147 20.6844 365.242 20.5209C366.022 19.2216 367.014 17.8998 368.295 16.6977C368.509 16.507 368.703 16.2951 368.929 16.1223L369.589 15.5804C369.811 15.3996 370.05 15.2488 370.278 15.0779L370.624 14.8277L370.986 14.6032C371.25 14.4461 371.505 14.2666 371.785 14.127C372.062 13.9854 372.345 13.8413 372.625 13.6975C373.21 13.4516 373.797 13.1846 374.426 13.0021C374.736 12.8997 375.044 12.7954 375.367 12.7275C375.686 12.6516 376.006 12.5651 376.327 12.4994C376.979 12.3905 377.629 12.2649 378.288 12.2204C380.921 11.946 383.526 12.209 385.614 12.968C386.66 13.3411 387.579 13.8238 388.345 14.3365C389.111 14.8534 389.716 15.401 390.206 15.8705C390.437 16.1191 390.649 16.3399 390.826 16.5386C390.997 16.7441 391.142 16.9203 391.259 17.0654C391.379 17.2083 391.454 17.3297 391.516 17.4083C391.573 17.4873 391.601 17.5268 391.601 17.5268C391.873 17.8747 392.103 18.2575 392.347 18.6288C392.569 19.0166 392.801 19.393 392.997 19.7977C393.412 20.5906 393.761 21.4207 394.07 22.2646C394.683 23.9614 395.133 25.7269 395.443 27.5254C395.758 29.3236 395.953 31.1448 396.065 32.9773C396.125 33.8891 396.162 34.828 396.208 35.7514L396.305 37.7845L390.608 38.0895L382.223 38.5415L382.147 37.0331C382.088 35.6115 381.988 34.1912 381.763 32.8742C381.542 31.5526 381.199 30.294 380.646 29.1459C380.101 28.0035 379.328 26.971 378.338 26.2428C377.353 25.5077 376.197 25.1148 375.079 24.9746L375.063 24.9613Z" fill="#6A9A23"/>
<path d="M402.801 24.9656C402.203 22.6548 401.239 22.8832 401.63 25.2097C401.897 26.8631 402.16 28.5525 402.386 30.3878C402.496 31.3035 402.599 32.2556 402.664 33.2487C402.731 34.2438 402.77 35.2853 402.721 36.368C402.716 36.4986 402.712 36.6269 402.706 36.7533C402.692 36.9308 402.68 37.106 402.667 37.2728C402.649 37.501 402.616 37.7284 402.587 37.947C402.549 38.1706 402.513 38.3836 402.478 38.5859C402.35 39.3629 402.251 39.9632 402.194 40.3059C402.264 40.2831 402.36 40.2328 402.447 40.1938C402.536 40.1525 402.622 40.1093 402.707 40.0684C402.88 39.9863 403.049 39.9045 403.212 39.8253C403.541 39.6688 403.857 39.5134 404.161 39.3675C404.461 39.2218 404.753 39.0811 405.035 38.9434C405.166 38.8796 405.295 38.8181 405.42 38.7569C405.494 38.719 405.569 38.681 405.641 38.6454C406.222 38.3495 406.739 38.0886 407.235 37.8379C408.23 37.334 409.152 36.8765 410.402 36.3086C413.075 35.0677 416.694 33.4635 419.925 32.0504C420.732 31.6972 421.514 31.3587 422.252 31.0366C422.623 30.8766 422.982 30.7195 423.328 30.5699C423.651 30.4244 423.969 30.2815 424.278 30.1435L424.51 30.0373L424.627 29.9852C424.643 29.9754 424.67 29.971 424.679 29.9555L424.669 29.8934C424.645 29.7298 424.621 29.5703 424.596 29.4109C424.469 28.5658 424.357 27.8075 424.263 27.1716C424.181 26.6584 424.115 26.2443 424.066 25.9443C424.009 25.5906 423.941 25.2398 423.864 24.8897C423.747 24.3627 423.548 23.4609 423.258 22.267C423.115 21.6751 422.945 20.9912 422.762 20.281C422.599 19.5649 422.429 18.7845 422.257 17.937C421.919 16.25 421.588 14.3419 421.404 12.3017C421.312 11.2815 421.271 10.2275 421.314 9.17048C421.331 8.90671 421.348 8.64295 421.367 8.37693L421.413 7.98269L421.436 7.78557L421.445 7.71975C421.453 7.66451 421.46 7.64713 421.465 7.60892L421.506 7.4081C421.68 6.38378 422.084 5.13595 422.384 4.06711C422.287 4.10077 422.129 4.17316 421.956 4.25533C421.78 4.3356 421.585 4.42601 421.371 4.52428C420.941 4.7231 420.436 4.95568 419.886 5.21114C419.131 5.55774 418.245 5.96396 417.367 6.3653C411.226 9.21824 407.424 10.9851 405.438 11.9042C404.269 12.4546 403.174 12.9712 402.136 13.462C401.618 13.7104 401.117 13.9532 400.623 14.1911C400.196 14.396 399.771 14.5986 399.352 14.7986C399.183 14.8195 399.29 14.9823 399.295 15.091L399.363 15.446C399.409 15.6812 399.454 15.9123 399.497 16.1457C399.555 16.4219 399.614 16.6958 399.671 16.9678C399.726 17.219 399.783 17.4679 399.838 17.715C399.952 18.2087 400.069 18.6937 400.19 19.17C400.43 20.1249 400.684 21.0492 400.954 21.9637C401.557 23.9739 402.388 23.7488 401.992 21.7122C401.823 20.7825 401.653 19.851 401.478 18.8926C401.397 18.415 401.313 17.9312 401.226 17.4373C401.149 16.9592 401.07 16.4752 400.989 15.9786L400.974 15.8456L400.966 15.7812C400.966 15.7623 400.949 15.7324 400.982 15.7295L401.11 15.6785L401.173 15.6542L401.28 15.6092C401.78 15.3876 402.289 15.1588 402.814 14.9244C403.86 14.4477 404.962 13.9451 406.136 13.4069C407.958 12.5628 411.855 11.0143 417.234 8.56739C417.672 8.36786 418.107 8.16225 418.54 7.95474L419.186 7.63645L419.508 7.47429C419.526 7.46225 419.52 7.46071 419.527 7.45166C419.541 7.43581 419.56 7.41318 419.589 7.38756L419.638 7.34764L419.667 7.32619C419.667 7.32619 419.691 7.30737 419.688 7.31606C419.694 7.34069 419.694 7.39103 419.696 7.4622L419.696 7.51671L419.663 7.87844C419.633 8.14329 419.62 8.40669 419.607 8.67009C419.56 9.72334 419.595 10.7652 419.667 11.7724C419.824 13.7898 420.128 15.6834 420.427 17.3172C420.573 18.1354 420.726 18.8859 420.861 19.5603C421 20.2365 421.126 20.8298 421.25 21.3122C421.469 22.2689 421.597 22.8286 421.597 22.8286C421.597 22.8286 421.823 23.7951 422.142 25.3537C422.301 26.133 422.48 27.0597 422.663 28.0908C422.702 28.3203 422.743 28.5559 422.785 28.7957L422.803 28.9075L422.812 28.9654C422.818 28.9859 422.785 28.9846 422.771 28.9963C422.384 29.1767 421.984 29.3624 421.575 29.5511C417.19 31.5824 412.042 33.9717 408.986 35.3886L405.982 36.7841L404.671 37.3929L404.467 37.4882L404.366 37.5347L404.316 37.558L404.289 37.5708C404.289 37.5708 404.28 37.5779 404.277 37.576L404.28 37.5631C404.303 37.4584 404.319 37.3521 404.328 37.2442L404.345 37.0687C404.365 36.8613 404.372 36.6551 404.381 36.4465C404.431 35.2672 404.374 34.1685 404.284 33.1272C404.194 32.0859 404.057 31.1094 403.903 30.1765C403.593 28.3087 403.216 26.6124 402.802 24.9739L402.801 24.9656Z" fill="#6A9A23"/>
<path d="M384.78 4.00329C387.938 3.20915 387.727 2.24341 384.526 2.83562C382.254 3.25496 379.932 3.70171 377.414 4.21162C376.157 4.47169 374.85 4.74026 373.477 5.02294C372.791 5.16845 372.086 5.31766 371.367 5.47022L371.218 5.49987C371.197 5.50168 371.166 5.52123 371.163 5.48791C371.092 5.31992 371.022 5.14967 370.951 4.97752C369.623 1.76695 368.946 -0.312486 368.381 -2.12043C367.842 -3.93698 367.411 -5.50059 367.051 -7.83194C366.893 -8.81488 366.773 -9.88927 366.688 -11.0192C366.622 -12.1486 366.576 -13.3343 366.64 -14.5359C366.704 -15.7374 366.819 -16.9581 367.064 -18.1396C367.308 -19.3211 367.637 -20.4742 368.076 -21.5383C368.18 -21.8055 368.312 -22.0581 368.428 -22.3158C368.488 -22.4427 368.547 -22.5716 368.605 -22.6962C368.676 -22.822 368.743 -22.9474 368.812 -23.0709C369.086 -23.5667 369.355 -24.0516 369.614 -24.5211C369.889 -24.9813 370.184 -25.4056 370.452 -25.8254C370.59 -26.0303 370.716 -26.2406 370.855 -26.4331C371 -26.6199 371.14 -26.804 371.278 -26.9817C371.556 -27.3352 371.803 -27.6798 372.06 -27.9811C372.327 -28.2707 372.576 -28.5441 372.802 -28.7903C373.238 -29.3044 373.671 -29.6399 373.952 -29.9097L374.459 -30.3796L375.001 -30.8127C375.161 -30.9441 375.356 -31.1015 375.579 -31.2845C375.688 -31.3821 375.817 -31.4709 375.954 -31.5604C376.091 -31.6541 376.237 -31.7508 376.39 -31.8542C376.986 -32.2878 377.767 -32.7206 378.666 -33.1972C380.483 -34.1268 382.926 -34.9701 385.749 -35.6869C386.452 -35.8717 387.182 -36.0462 387.929 -36.2179C388.673 -36.3957 389.442 -36.561 390.222 -36.7356C390.745 -36.8523 391.276 -36.9696 391.811 -37.0874C391.827 -37.0972 391.829 -37.0805 391.834 -37.0684L391.843 -37.0293L391.877 -36.8812C391.965 -36.4754 392.052 -36.0697 392.138 -35.6616C392.826 -32.3977 393.535 -29.0516 394.215 -25.8332C394.699 -23.5607 395.138 -21.5069 395.533 -19.6569C395.709 -18.8328 395.874 -18.0562 396.03 -17.3227L396.047 -17.2507C396.046 -17.2318 396.008 -17.2368 395.99 -17.229C395.759 -17.1838 395.532 -17.1389 395.315 -17.097C393.858 -16.8196 392.563 -16.5563 391.456 -16.2547C390.349 -15.9573 389.427 -15.6235 388.695 -15.281C387.829 -14.8808 387.014 -14.3841 386.312 -13.7652C385.606 -13.15 385.025 -12.4135 384.602 -11.6257C384.182 -10.8318 383.945 -10.0035 383.788 -9.19671C383.737 -8.79153 383.662 -8.39059 383.656 -7.99771C383.648 -7.79977 383.64 -7.606 383.631 -7.41223C383.631 -7.21918 383.643 -7.02722 383.649 -6.83679C383.805 -3.79316 384.714 -1.22823 385.709 1.20761C386.262 2.50259 386.762 3.06984 386.983 3.00452L386.993 2.90918C386.995 2.93001 387.006 2.93951 387.029 2.93545L387.023 2.98842C387.233 2.86741 387.157 2.12707 386.709 0.831387C385.907 -1.6044 385.185 -4.13523 385.149 -6.86608C385.149 -7.03604 385.145 -7.20563 385.149 -7.37595C385.164 -7.54509 385.174 -7.71387 385.187 -7.88491C385.199 -8.23008 385.278 -8.56211 385.326 -8.9041C385.476 -9.57384 385.682 -10.2422 386.022 -10.857C386.365 -11.468 386.82 -12.032 387.389 -12.5198C387.957 -13.0076 388.635 -13.4231 389.39 -13.7697C389.972 -14.0447 390.76 -14.3207 391.748 -14.5721C392.735 -14.8234 393.919 -15.0373 395.292 -15.2696C395.66 -15.3351 396.039 -15.3993 396.429 -15.4689C396.772 -15.5363 397.118 -15.6041 397.469 -15.6723C397.646 -15.7087 397.826 -15.7431 398.003 -15.7795L398.137 -15.8058L398.206 -15.818C398.206 -15.818 398.218 -15.8191 398.222 -15.8236L398.22 -15.8403L398.213 -15.8732L398.161 -16.1414C397.961 -17.148 397.754 -18.2065 397.532 -19.3161C397.2 -21.0058 396.833 -22.8477 396.421 -24.8325C396.152 -26.1248 395.86 -27.413 395.553 -28.6873C394.886 -31.4348 394.198 -34.3925 393.546 -37.286L393.341 -38.223L393.235 -38.7027L393.183 -38.9395L393.156 -39.0588C393.152 -39.0774 393.15 -39.1024 393.141 -39.1141L393.079 -39.1004C392.467 -38.9655 391.858 -38.8288 391.251 -38.6943C390.541 -38.5342 389.839 -38.3747 389.149 -38.2205C387.771 -37.908 386.435 -37.6013 385.194 -37.2776C382.705 -36.6506 380.584 -35.9232 379.116 -35.3029C378.753 -35.1371 378.426 -34.9871 378.141 -34.8596C377.997 -34.7947 377.866 -34.7351 377.745 -34.6784C377.627 -34.6157 377.521 -34.5582 377.422 -34.5056C377.038 -34.296 376.829 -34.1815 376.829 -34.1815C376.829 -34.1815 376.751 -34.139 376.605 -34.0571C376.459 -33.971 376.233 -33.8675 375.972 -33.6854C375.704 -33.509 375.379 -33.292 374.999 -33.043C374.904 -32.9802 374.807 -32.9151 374.705 -32.8496C374.611 -32.7743 374.511 -32.6964 374.413 -32.6165C374.213 -32.4565 373.998 -32.289 373.775 -32.1101C373.313 -31.7721 372.875 -31.325 372.39 -30.8675C371.887 -30.4253 371.447 -29.8604 370.947 -29.3072C370.689 -29.0331 370.468 -28.7244 370.238 -28.4086C370.006 -28.0969 369.77 -27.7742 369.529 -27.4512C369.295 -27.1225 369.093 -26.7672 368.869 -26.4183C368.652 -26.0638 368.416 -25.7139 368.211 -25.3457C368.012 -24.9718 367.81 -24.5934 367.61 -24.213C367.412 -23.8266 367.19 -23.4611 367.018 -23.0413C366.838 -22.6332 366.644 -22.2241 366.501 -21.7962L366.27 -21.1594C366.194 -20.9451 366.142 -20.7265 366.076 -20.511C365.569 -18.778 365.306 -16.9905 365.209 -15.272C365.017 -11.829 365.44 -8.67637 365.857 -6.37091C366.505 -2.89785 367.285 -0.399327 367.899 1.48832C368.53 3.37452 369.032 4.64658 369.43 5.61085C369.519 5.81714 369.604 6.0238 369.693 6.22593C369.821 6.52323 369.954 6.82018 370.092 7.1145L370.193 7.33446L370.219 7.39097C370.227 7.40918 370.255 7.38998 370.274 7.39044L370.391 7.36557L370.861 7.27026C371.154 7.20714 371.444 7.14212 371.732 7.07936C372.451 6.91847 373.155 6.76093 373.838 6.60936C375.206 6.29562 376.507 5.99825 377.757 5.70939C380.258 5.12332 382.558 4.56518 384.799 4.00376L384.78 4.00329Z" fill="#6A9A23"/>
<path d="M289.604 -5.95927C289.825 -7.16812 289.658 -7.81042 289.394 -7.85468C289.12 -7.90012 288.748 -7.36645 288.444 -6.25107C287.978 -4.67267 287.331 -3.1185 286.404 -1.58822C285.451 -0.0788647 284.202 1.41638 282.444 2.63884C282.187 2.81642 281.946 2.9884 281.706 3.1267C281.648 3.16317 281.588 3.19774 281.53 3.23421L281.447 3.28762C281.447 3.28762 281.409 3.30978 281.377 3.32517L281.29 3.36835C281.059 3.48283 280.835 3.59242 280.626 3.69867C280.424 3.80645 280.211 3.89829 280.009 3.98299C279.81 4.06733 279.626 4.14832 279.454 4.2199C279.131 4.36125 278.862 4.47897 278.656 4.5682C278.704 4.61647 278.78 4.66864 278.853 4.71892C278.925 4.77146 278.996 4.81983 279.068 4.87237C279.209 4.97138 279.347 5.07265 279.484 5.16786C279.754 5.36053 280.016 5.54559 280.268 5.72304C280.518 5.89859 280.76 6.0707 280.994 6.2371C281.17 6.35821 281.342 6.47968 281.508 6.59544C282.011 6.93785 282.46 7.2452 282.899 7.54495C283.773 8.1448 284.593 8.71793 285.64 9.49792C286.838 10.3781 288.231 11.4219 289.677 12.5177C290.398 13.0658 291.134 13.6272 291.868 14.1826C292.068 14.3352 292.27 14.4898 292.47 14.6424L292.955 15.0033L293.076 15.0935L293.136 15.1365L293.166 15.1612C293.166 15.1612 293.19 15.1507 293.202 15.1455L293.482 15.0373L294.04 14.8189L294.428 14.6468C294.65 14.5436 294.865 14.4306 295.078 14.3198C295.921 13.8585 296.673 13.3087 297.317 12.722C297.483 12.5796 297.641 12.4338 297.785 12.2807C297.933 12.1314 298.078 11.9825 298.221 11.84C298.484 11.5361 298.742 11.243 298.969 10.9548C299.883 9.79918 300.394 8.76454 300.697 8.20105C300.87 7.86299 301.007 7.51115 301.151 7.16086C301.27 6.89033 301.388 6.50663 301.543 6.03374C301.71 5.56394 301.847 4.99179 302.013 4.33953C302.105 4.01476 302.163 3.66562 302.234 3.29648C302.303 2.93376 302.376 2.55402 302.45 2.15726C302.521 1.78395 302.597 1.39552 302.673 0.992327C302.769 0.593762 302.883 0.187326 302.989 -0.237315C303.46 -1.91903 304.268 -3.72008 305.478 -5.37976C306.096 -6.19706 306.82 -6.9753 307.642 -7.65926C308.05 -8.00731 308.494 -8.31432 308.949 -8.61183L309.48 -8.92643C309.722 -9.05865 309.971 -9.18934 310.24 -9.31123C310.758 -9.55548 311.278 -9.80199 311.8 -10.0466C311.202 -10.492 309.695 -11.6078 308.218 -12.703C305.465 -14.7241 303.236 -16.3585 301.476 -17.6495C300.595 -18.2971 299.83 -18.8559 299.173 -19.3383C298.846 -19.5785 298.546 -19.8001 298.271 -20.0007C298.038 -20.1694 297.818 -20.3308 297.61 -20.4827C297.494 -20.565 297.378 -20.6472 297.27 -20.726C297.244 -20.7594 297.213 -20.7357 297.182 -20.7226L297.092 -20.6791C297.033 -20.6509 296.971 -20.6224 296.914 -20.5965C296.644 -20.4641 296.349 -20.3377 296.113 -20.204C295.961 -20.1194 295.804 -20.0429 295.661 -19.9466C295.516 -19.8563 295.37 -19.7661 295.229 -19.6762C295.09 -19.5803 294.954 -19.4824 294.82 -19.3869C294.549 -19.1934 294.3 -18.9851 294.054 -18.7791C293.819 -18.5594 293.574 -18.3598 293.365 -18.1298C292.493 -17.2443 291.803 -16.2907 291.244 -15.3315C290.158 -13.3931 289.552 -11.4542 289.197 -9.52671C288.87 -7.38335 289.73 -7.29835 290.238 -9.28538C290.758 -11.0888 291.464 -12.8475 292.528 -14.5574C293.072 -15.4019 293.716 -16.2236 294.498 -16.9838C294.687 -17.1806 294.905 -17.3485 295.111 -17.5384C295.329 -17.7105 295.547 -17.8909 295.782 -18.0519C295.901 -18.1335 296.018 -18.2129 296.139 -18.2968C296.263 -18.3705 296.386 -18.4483 296.512 -18.5243C296.637 -18.6044 296.768 -18.6682 296.898 -18.7403C296.958 -18.7749 296.982 -18.7854 297.027 -18.806C297.043 -18.8116 297.059 -18.8214 297.075 -18.827C297.089 -18.8156 297.105 -18.8023 297.118 -18.7909C297.157 -18.7585 297.195 -18.7262 297.236 -18.692C297.49 -18.4937 297.769 -18.2786 298.075 -18.0408C298.684 -17.5628 299.393 -17.0053 300.204 -16.3705C301.821 -15.1028 303.83 -13.5417 306.218 -11.7617C306.608 -11.4723 307 -11.1853 307.395 -10.9069L307.991 -10.4907L308.141 -10.3882C308.141 -10.3882 308.145 -10.3886 308.149 -10.389C308.156 -10.3874 308.164 -10.3881 308.172 -10.3889C308.198 -10.3869 308.247 -10.3723 308.287 -10.3505C308.274 -10.3264 308.253 -10.3015 308.185 -10.2431L308.026 -10.1412L307.856 -10.0215L307.515 -9.7822C307.288 -9.6219 307.077 -9.44412 306.856 -9.27395C305.994 -8.57388 305.217 -7.77012 304.539 -6.92241C303.169 -5.22782 302.263 -3.31968 301.676 -1.61952C301.604 -1.40558 301.532 -1.1958 301.461 -0.992448C301.389 -0.786833 301.346 -0.579579 301.287 -0.381476C301.185 0.0197139 301.063 0.395451 300.994 0.762334C300.848 1.4779 300.721 2.10572 300.615 2.62689C300.509 3.12497 300.445 3.52707 300.363 3.79018C300.29 4.05674 300.25 4.20078 300.25 4.20078C300.25 4.20078 300.188 4.43483 300.074 4.86019C300.018 5.07269 299.922 5.32023 299.824 5.6162C299.724 5.91027 299.618 6.24672 299.46 6.60036C299.308 6.95554 299.158 7.35463 298.943 7.75307C298.84 7.95289 298.734 8.1614 298.625 8.37859C298.502 8.58437 298.376 8.79468 298.248 9.01141C297.713 9.8635 297.042 10.7483 296.207 11.5257C296.102 11.623 295.997 11.7202 295.892 11.8174C295.785 11.9127 295.666 11.9985 295.555 12.09C295.334 12.2791 295.092 12.4386 294.853 12.6083C294.734 12.6941 294.604 12.7621 294.482 12.8418C294.359 12.9197 294.233 12.9956 294.101 13.0617C293.97 13.1296 293.844 13.2056 293.709 13.2614L293.533 13.3417C293.509 13.3522 293.493 13.3619 293.472 13.3679C293.433 13.3734 293.389 13.4255 293.358 13.3799L293.237 13.2897C292.982 13.102 292.724 12.9124 292.469 12.7247C291.958 12.3494 291.452 11.9778 290.954 11.6139C288.967 10.1558 287.13 8.80428 285.762 7.80036L283.266 5.96879L282.16 5.15826L281.992 5.03643L281.909 4.97438L281.868 4.94015C281.868 4.94015 281.82 4.91912 281.851 4.91433C281.973 4.86601 282.09 4.80973 282.204 4.74737L282.226 4.73497L282.264 4.71279L282.428 4.61469L282.757 4.42037C282.977 4.29221 283.184 4.13788 283.397 3.99986C285.383 2.6065 286.754 0.888816 287.729 -0.813492C288.682 -2.53899 289.266 -4.26186 289.612 -5.96416L289.604 -5.95927Z" fill="#6A9A23"/>
<path d="M335.18 -24.8556C335.367 -27.0896 334.385 -27.2164 333.994 -25.0108C333.717 -23.4468 333.449 -21.8414 333.182 -20.0956C333.054 -19.2221 332.92 -18.3146 332.78 -17.3583C332.644 -16.3603 332.501 -15.3135 332.351 -14.2073C332.315 -13.902 332.279 -13.6073 332.272 -13.5479C332.586 -13.2373 332.882 -12.942 333.169 -12.6584C333.357 -12.4774 333.536 -12.2999 333.707 -12.1364C334.053 -11.8034 334.368 -11.5034 334.661 -11.2224C335.252 -10.6673 335.75 -10.1985 336.218 -9.76272C337.155 -8.88931 337.961 -8.13454 339.071 -6.99696C339.768 -6.28315 340.543 -5.4922 341.538 -4.47471C342.213 -4.57105 342.912 -4.67145 343.62 -4.77484C344.209 -4.85527 344.811 -4.93678 345.41 -5.02019C346.613 -5.17905 347.818 -5.34016 348.949 -5.49061C351.408 -5.80659 353.549 -6.08036 354.718 -6.22989C354.939 -6.58062 355.125 -6.88001 355.282 -7.13069C355.375 -7.27301 355.451 -7.3908 355.515 -7.49084C355.643 -7.68865 355.727 -7.81548 355.797 -7.92231C355.981 -8.20051 356.158 -8.48443 356.33 -8.77214C356.622 -9.26111 357.152 -10.1443 358.014 -11.5787C358.936 -13.098 360.217 -15.2044 361.956 -18.0724C361.796 -18.5474 361.552 -19.2816 361.244 -20.2012C360.997 -20.9457 360.704 -21.8414 360.38 -22.8288C359.735 -24.8082 358.978 -27.1597 358.266 -29.4229L357.826 -30.7822L346.487 -34.4322C346.071 -34.566 345.657 -34.698 345.367 -34.7904C344.773 -34.3822 344.196 -33.9902 343.636 -33.6038C343.197 -33.2972 342.767 -33.0018 342.351 -32.7098C341.523 -32.1239 340.738 -31.567 339.98 -31.0334C338.475 -29.9545 337.106 -28.942 335.757 -27.9207C334.187 -26.7334 334.67 -26.0221 336.355 -27.0389C337.803 -27.9114 339.251 -28.8111 340.81 -29.8065C341.585 -30.3101 342.392 -30.8333 343.246 -31.3858C343.996 -31.883 344.784 -32.4066 345.626 -32.9622C345.717 -32.9323 345.846 -32.889 345.978 -32.8479C346.88 -32.5568 348.252 -32.0525 350.06 -31.4015C350.964 -31.0812 351.977 -30.72 353.094 -30.3258C354.069 -29.9928 355.133 -29.6276 356.281 -29.234L356.327 -29.0953L356.539 -28.457C356.685 -28.0332 356.834 -27.6097 356.99 -27.1931C357.543 -25.6967 358.111 -24.0988 358.656 -22.52C359.156 -21.0526 359.648 -19.6076 360.1 -18.2892L360.045 -18.1921C359.979 -18.0815 359.913 -17.975 359.847 -17.8644C359.702 -17.6273 359.56 -17.3947 359.422 -17.1666C359.143 -16.7102 358.876 -16.2737 358.625 -15.8595C358.115 -15.0327 357.658 -14.2923 357.279 -13.6761C356.512 -12.4473 356.05 -11.7043 356.05 -11.7043L353.657 -7.82492L342.05 -6.02149L339.492 -8.60924L334.019 -14.1379L334.03 -14.2332C334.157 -15.2577 334.277 -16.227 334.393 -17.1498C334.503 -18.1077 334.607 -19.0211 334.706 -19.8962C334.896 -21.6521 335.05 -23.2727 335.182 -24.8537L335.18 -24.8556Z" fill="#6A9A23"/>
<path d="M334.463 4.5503C336.378 5.19843 337.423 5.25884 337.511 5.0037C337.601 4.73987 336.74 4.16619 334.878 3.42744C332.352 2.41678 329.793 1.3314 327.049 0.0858865C325.677 -0.538004 324.262 -1.20221 322.786 -1.92192C322.048 -2.2797 321.294 -2.65496 320.524 -3.04353C320.14 -3.23894 319.751 -3.43817 319.356 -3.63893C318.73 -3.96444 318.098 -4.29148 317.454 -4.62388C317.2 -4.26194 316.851 -3.76375 316.498 -3.26103C311.509 3.94451 310.444 5.82245 307.026 10.6635C306.168 11.8814 305.22 13.2246 304.201 14.6705C303.026 16.325 301.771 18.0935 300.448 19.9518C301.609 20.5877 302.784 21.2286 303.958 21.8717C304.893 22.3719 305.832 22.8675 306.756 23.3476C308.612 24.3051 310.431 25.2049 312.103 26.0042C315.451 27.6024 318.222 28.8037 319.543 29.3585C320.099 29.5978 320.659 29.8219 321.228 30.0371C323.093 30.7482 327.879 32.5742 334.242 34.4546C337.42 35.4002 340.99 36.3581 344.761 37.2377C346.647 37.6764 348.582 38.0983 350.545 38.4926C351.525 38.6909 352.513 38.8801 353.502 39.0629L354.99 39.3326L357.469 39.7598C357.512 39.0699 357.618 37.378 357.721 35.7072C358.398 24.2426 358.818 17.1477 359.038 13.4421C359.115 12.082 359.191 10.7661 359.248 9.7981C358.525 9.66145 357.813 9.53015 357.113 9.39776C356.669 9.31034 356.23 9.22673 355.799 9.14241C354.934 8.97185 354.095 8.79914 353.278 8.62651C351.643 8.27935 350.096 7.92461 348.607 7.56898C345.63 6.8513 342.892 6.12137 340.191 5.33367C338.504 4.84208 337.595 4.76975 337.515 5.00334C337.437 5.22408 338.192 5.75453 339.861 6.35052C342.533 7.30237 345.259 8.1655 348.242 8.98542C349.733 9.39329 351.289 9.78932 352.935 10.1691C353.757 10.3622 354.602 10.547 355.474 10.7316C356.136 10.8673 356.819 11.0053 357.52 11.1501C357.485 11.7344 357.434 12.5299 357.383 13.3484C357.181 16.7483 356.524 23.8217 355.888 33.8224C355.843 34.63 355.797 35.4334 355.753 36.2387L355.697 37.4437C355.695 37.5153 355.695 37.488 355.696 37.4963L355.7 37.5001L355.703 37.5145L355.713 37.5494C355.713 37.5494 355.699 37.5569 355.686 37.558C355.653 37.5567 355.753 37.5795 355.443 37.5309C355.007 37.4616 354.566 37.3928 354.124 37.3221C353.241 37.1783 352.344 37.0273 351.449 36.8615C349.654 36.5387 347.844 36.1753 346.062 35.7821C342.497 35.0063 339.05 34.1049 336.046 33.2323C333.043 32.3574 330.487 31.5173 328.681 30.8912C327.778 30.5729 327.064 30.3201 326.573 30.1465C326.083 29.9666 325.818 29.8678 325.818 29.8678C321.699 28.3743 317.646 26.705 313.653 24.9004C311.657 23.995 309.679 23.0544 307.719 22.0745C306.741 21.5843 305.762 21.0859 304.793 20.5802L303.34 19.8144L302.638 19.4367L309.085 10.2353C314.014 3.19229 316.386 -0.198457 317.845 -2.28256C317.896 -2.35617 317.946 -2.42977 317.981 -2.4811C318.602 -2.16773 319.205 -1.86541 319.791 -1.56997C320.573 -1.18248 321.337 -0.814374 322.09 -0.459944C323.592 0.247014 325.035 0.89203 326.437 1.48387C329.24 2.67399 331.869 3.6673 334.463 4.55447L334.463 4.5503Z" fill="#6A9A23"/>
<path d="M266.148 11.4377C265.904 11.241 261.607 11.6973 262.767 12.4218C263.152 12.7388 263.531 12.734 263.685 12.313C263.756 13.154 264.635 12.1 265.004 12.3981C264.83 12.9694 266.069 11.8383 265.807 12.4271C270.358 13.3709 279.961 8.3733 268.469 10.9842C269.573 11.3222 268.502 11.4793 268.006 11.3163C268.775 10.6232 266.63 11.1226 266.225 11.3524C266.878 11.3826 265.768 11.8565 266.15 11.4398L266.148 11.4377Z" fill="#101214"/>
<path d="M273.986 19.0467C273.385 19.0418 270.602 22.9468 270.26 23.3131C269.677 24.2322 271.049 24.4039 271.328 23.6053C271.45 23.4739 271.918 22.3416 272.164 22.8577C273.353 22.6833 273.656 20.6225 274.654 20.5627C274.514 20.2788 274.886 19.9778 274.819 19.7896C275.111 19.8418 275.301 19.4589 275.233 19.4186C276.559 18.4848 275.082 17.1701 274.308 18.5903C274.261 18.5239 273.902 18.7589 273.986 19.0428L273.986 19.0467Z" fill="#101214"/>
<path d="M288.709 27.7641C289.293 27.125 289.207 27.8367 288.919 28.1456C288.477 27.5052 288.381 28.9221 288.518 29.2965C288.558 29.1514 288.815 29.1459 288.75 29.4489C288.158 29.1232 287.385 32.9628 288.995 31.3767C289.003 31.3103 288.513 31.1909 288.68 31.1416C289.409 31.4079 288.987 30.7058 288.958 30.5243C289.347 30.5991 289.013 30.3704 289.181 30.3567C289.67 30.6613 288.959 29.5148 289.438 29.8463C290.383 29.1065 289.625 27.1642 290.464 26.62C289.666 25.994 291.452 23.4009 289.594 24.1887C289.01 25.3404 288.629 26.3014 288.709 27.7641Z" fill="#101214"/>
<path d="M278.52 33.4874C279.672 34.0122 279.857 31.3062 280.471 30.6733C281.323 29.9268 285.341 20.9746 282.563 22.9852C281.37 25.7048 279.916 27.7259 278.886 31.2063C278.677 31.7594 277.666 33.4114 278.52 33.4874Z" fill="#101214"/>
<path d="M272.605 3.22304C273.458 2.36044 274.245 3.76255 275.035 3.06901C276.28 1.6898 267.453 -0.415104 267.475 1.23084C267.685 2.64358 272.067 2.52653 272.605 3.22304Z" fill="#101214"/>
<path d="M353.904 0.605135C351.888 -0.0406305 348.015 0.187959 346.143 -0.686571C344.414 -0.564747 342.931 -1.0713 341.224 -1.48882C341.674 -1.91768 342.883 -2.42509 342.976 -2.90903C346.063 -5.01434 340.805 -2.8555 339.877 -1.40738L339.89 -1.40739C339.89 -1.40739 339.691 -1.15637 339.673 -1.19408C339.802 -0.692643 340.458 -0.0652969 340.454 0.283156C343.482 2.73881 344.616 3.1592 341.381 -0.567943C342.528 -0.296267 343.241 0.288849 344.364 0.147743C344.642 0.54692 350.562 1.43902 348.42 0.717936C348.941 0.404403 350.793 1.07698 349.514 1.05847C350.098 1.25533 359.729 2.18758 358.787 0.832591C358.387 0.926263 357.763 0.58519 357.477 0.747534C357.422 0.905176 357.407 1.02061 357.253 0.965295C357.28 0.632353 356.933 0.630529 356.556 0.701981C356.088 0.866753 355.08 0.903412 355.236 0.665757C355.306 0.46149 353.472 0.982932 353.904 0.607357L353.904 0.605135Z" fill="#101214"/>
</g>
<g clipPath="url(#clip2_783_5660)">
<path d="M13.0459 23.9464C13.2244 23.8029 13.375 23.6514 13.5135 23.5051C13.6519 23.3588 13.7767 23.2242 13.8912 23.0925C14.1165 22.8338 14.2962 22.6063 14.4242 22.4127C14.6826 22.0273 14.7534 21.7777 14.657 21.6812C14.5605 21.5846 14.2987 21.6388 13.898 21.8582C13.6977 21.9679 13.4612 22.1206 13.1927 22.3159C13.0586 22.4156 12.9146 22.5225 12.7657 22.6446C12.6168 22.7666 12.4583 22.8999 12.2783 23.0267C11.7797 23.3994 11.2791 23.7743 10.7705 24.1541C10.2398 24.4959 9.70493 24.8382 9.16244 25.1894C8.60947 25.5164 8.02636 25.8104 7.44957 26.1289C7.15404 26.2784 6.84575 26.4016 6.5389 26.5415C6.23133 26.6731 5.92782 26.8274 5.60858 26.9453C5.28898 27.059 4.96332 27.1754 4.63765 27.2917C4.47464 27.3478 4.31044 27.4145 4.1448 27.4645C3.97464 27.5108 3.80449 27.557 3.63433 27.6032C3.29175 27.6937 2.94835 27.799 2.59636 27.8778C2.24139 27.9463 1.88225 28.0152 1.51931 28.0887C0.0606176 28.3263 -1.49813 28.4258 -3.12925 28.2944C-3.56103 28.2752 -3.97141 28.2121 -4.35537 28.1636C-4.54794 28.1446 -4.73171 28.106 -4.90643 28.075C-4.9938 28.0595 -5.08116 28.0439 -5.16436 28.0281C-5.22411 28.0165 -5.28576 28.0071 -5.34551 27.9955C-5.43287 27.98 -5.5081 27.9593 -5.58713 27.943C-6.21656 27.7731 -6.77491 27.6242 -7.25162 27.4977C-7.70977 27.3675 -8.08591 27.2637 -8.36563 27.183C-8.05452 28.2597 -7.73595 29.277 -7.45896 30.2014C-7.28585 30.7487 -7.12621 31.2616 -6.97515 31.7478C-6.68674 32.6587 -6.42815 33.4671 -6.18005 34.2514C-5.68384 35.8198 -5.22994 37.287 -4.66961 39.2338C-4.04204 41.3763 -3.32537 43.895 -2.58721 46.5167C-2.22004 47.8299 -1.84428 49.1695 -1.4715 50.499C-1.25363 51.2732 -1.04029 52.0436 -0.825398 52.8077C-0.802628 52.877 -0.789367 52.9577 -0.758627 53.0222L-0.551516 53.0882L-0.137285 53.2201L0.276945 53.3521L0.53893 53.4217C0.71283 53.4675 0.884474 53.5113 1.05837 53.5571C1.23346 53.5923 1.40628 53.6256 1.57946 53.663C4.36235 54.2065 7.04848 53.896 9.14027 53.3601C9.66062 53.2143 10.1485 53.0566 10.6086 52.9181C11.0609 52.7614 11.4697 52.5875 11.8496 52.4433C12.2341 52.303 12.5622 52.1424 12.8562 51.9994C13.1502 51.8564 13.4062 51.7356 13.6198 51.6331C13.8785 51.5184 14.1157 51.374 14.3552 51.2316L15.0752 50.7978C15.254 50.6816 15.4828 50.561 15.7156 50.3898C15.9507 50.2204 16.2176 50.0315 16.5119 49.8192C16.8017 49.6032 17.1399 49.3892 17.4667 49.1154C17.7957 48.8435 18.1502 48.5505 18.5283 48.2387C18.716 48.0797 18.9169 47.928 19.1073 47.752C19.2955 47.5741 19.4897 47.3936 19.6897 47.2064C20.0835 46.8344 20.499 46.4459 20.9358 46.0366C21.3513 45.6481 21.7823 45.2457 22.2305 44.8228C22.6881 44.4118 23.1922 44.0282 23.6952 43.609C23.943 43.3924 24.219 43.2111 24.4958 43.015C24.7708 42.8212 25.0517 42.6248 25.3346 42.4262C25.4725 42.3219 25.6221 42.2313 25.772 42.1449C25.9215 42.0543 26.0733 41.9656 26.2248 41.8727C26.5303 41.693 26.8325 41.499 27.1493 41.3288C28.4302 40.6597 29.8119 40.0405 31.3018 39.605C32.7947 39.1798 34.3762 38.9063 36.0024 38.8598C36.8156 38.8249 37.6359 38.8734 38.4607 38.9488L39.0913 39.0347L39.4056 39.0788L40.0042 39.2074C40.8225 39.3777 41.6365 39.5716 42.4509 39.7695C42.1544 38.7398 41.401 36.1362 40.667 33.5875C37.7264 23.5317 35.9053 17.3068 34.9535 14.0573C34.9552 13.7613 34.6651 13.8032 34.4682 13.7342C34.2584 13.6853 34.0485 13.6363 33.8387 13.5874L33.6803 13.5507C33.6311 13.5403 33.6141 13.5376 33.5778 13.5303L33.3902 13.4962L33.0173 13.4299C32.7696 13.38 32.5206 13.3638 32.2744 13.3306L31.9055 13.287L31.5408 13.2662C30.5668 13.1891 29.6218 13.2521 28.7074 13.3293C26.8858 13.5438 25.2051 14.0042 23.6927 14.641C23.3041 14.7817 22.9496 14.9782 22.5817 15.1402C22.4004 15.2272 22.2187 15.3101 22.0393 15.3949C21.8648 15.4877 21.6929 15.5865 21.5206 15.6812C21.1787 15.8766 20.8406 16.0675 20.5024 16.2583C20.1809 16.4708 19.8612 16.6811 19.5415 16.8914C19.3828 16.9974 19.226 17.1013 19.0692 17.2051C18.9128 17.3131 18.7677 17.4305 18.618 17.5442C18.321 17.7735 18.0236 17.9986 17.7304 18.2234C17.4281 18.4405 17.165 18.6983 16.8834 18.9367C16.6064 19.179 16.3335 19.4208 16.0565 19.6631C14.9003 20.7809 14.4954 21.5106 14.6627 21.6744C14.8371 21.8481 15.5686 21.4742 16.7575 20.4689C17.0367 20.2516 17.3182 20.0363 17.6015 19.8187C17.8853 19.6053 18.1547 19.3721 18.455 19.1803C18.7503 18.9805 19.0435 18.7789 19.3427 18.5746C19.4915 18.4757 19.6354 18.3688 19.7888 18.2736C19.9425 18.1827 20.0981 18.0895 20.256 17.9982C20.5672 17.8117 20.8807 17.6272 21.1938 17.4384C21.5194 17.2717 21.8468 17.1028 22.1765 16.9357C22.3434 16.852 22.5062 16.7687 22.675 16.6827C22.8449 16.6092 23.0189 16.5354 23.193 16.4615C23.5419 16.3222 23.8814 16.148 24.2446 16.0284C25.6722 15.4787 27.2231 15.0945 28.8787 14.9259C29.7068 14.8688 30.5609 14.822 31.436 14.8972L31.7652 14.919L32.0939 14.9598C32.3148 14.991 32.5385 15.0052 32.7585 15.0512C32.959 15.0883 33.1636 15.1252 33.3663 15.1642L33.4906 15.1954C33.5296 15.2088 33.5901 15.2057 33.5831 15.2462C33.7626 15.8915 33.9886 16.7112 34.2604 17.6969C34.563 18.8205 34.9173 20.1306 35.3166 21.6214C36.1212 24.6004 37.1258 28.2922 38.3635 32.5933C38.7677 33.9956 39.1924 35.3918 39.6324 36.77L39.7103 37.0171L39.7503 37.1396C39.7503 37.1396 39.7548 37.1434 39.757 37.1453C39.7661 37.1529 39.7713 37.165 39.7789 37.179C39.7935 37.203 39.816 37.2451 39.8321 37.2856C39.8094 37.2897 39.7776 37.2862 39.7337 37.2879L39.7 37.2866L39.6811 37.2861L39.5858 37.2755L39.0005 37.2045C38.6159 37.1477 38.1999 37.1418 37.8004 37.1071C37.3951 37.0793 36.9912 37.0913 36.5855 37.0824C34.9651 37.099 33.3478 37.3232 31.8071 37.7043C28.7091 38.445 25.9889 39.9166 23.8329 41.4107C23.5617 41.6 23.2986 41.7843 23.0374 41.9664C22.7852 42.1562 22.5484 42.355 22.3129 42.5433C22.0774 42.7316 21.8479 42.9172 21.6222 43.0984C21.5105 43.1899 21.3985 43.2772 21.2906 43.3642C21.1876 43.4592 21.0865 43.5519 20.9873 43.6423C20.2001 44.3673 19.5102 45.0041 18.937 45.5343C18.6591 45.7913 18.4082 46.0207 18.1904 46.2201C18.0817 46.3218 17.9806 46.4145 17.8871 46.4981C17.7891 46.578 17.6987 46.6488 17.6204 46.7143C17.3005 46.9707 17.13 47.1093 17.13 47.1093C17.13 47.1093 16.8416 47.342 16.3261 47.7623C16.0647 47.9675 15.7272 48.1898 15.3418 48.4645C15.15 48.6007 14.9442 48.7445 14.7266 48.8976C14.509 49.0508 14.2624 49.1833 14.0092 49.3375C13.758 49.4894 13.4926 49.6487 13.2175 49.8153C12.9446 49.9837 12.637 50.1153 12.3319 50.276C12.0216 50.4246 11.7142 50.6065 11.3733 50.741C11.037 50.8792 10.6885 51.0228 10.3339 51.1689C8.89465 51.7049 7.25528 52.1345 5.51244 52.2646C4.64192 52.34 3.74838 52.3189 2.85551 52.2326L2.18746 52.1499L1.52224 52.0271C1.30062 51.9876 1.08518 51.9223 0.864745 51.8722L0.70406 51.8337L0.64585 51.8157L0.529429 51.7796C0.476824 51.7779 0.495606 51.728 0.478692 51.7022L0.439583 51.565L0.23949 50.8752C0.105343 50.4147 -0.0284482 49.9584 -0.162235 49.5021C-0.429811 48.5895 -0.692493 47.6848 -0.951844 46.7946C-1.99079 43.24 -2.95224 39.9515 -3.66507 37.5017L-5.03013 32.8424L-5.71171 30.5116L-5.92228 29.7975L-5.96736 29.6399L-5.99086 29.5622L-6.00278 29.5213C-6.00278 29.5213 -6.02077 29.4829 -6.00077 29.4959C-5.91685 29.5201 -5.83258 29.5485 -5.74485 29.5681L-5.6163 29.599L-5.29637 29.6594C-5.12807 29.6888 -4.95906 29.7266 -4.78886 29.7539L-4.27933 29.823L-3.7698 29.8921L-3.25864 29.9317C-1.47352 30.0729 0.223859 29.9509 1.8069 29.671C2.20054 29.5886 2.59002 29.5066 2.97117 29.4253C3.3535 29.3334 3.71855 29.2115 4.08731 29.1082C4.27151 29.0545 4.45344 28.9988 4.63347 28.9455C4.81315 28.8879 4.98721 28.8141 5.162 28.7486C5.51122 28.6134 5.85438 28.4808 6.19753 28.3483C6.53616 28.2119 6.85488 28.0395 7.17958 27.8876C7.49939 27.7277 7.82481 27.584 8.13331 27.4146C8.73565 27.0519 9.34051 26.7183 9.90882 26.3501C10.4625 25.958 11.0127 25.5746 11.5478 25.1862C12.0546 24.7625 12.5558 24.3455 13.0547 23.9267L13.0459 23.9464Z" fill="#6A9A23"/>
<path d="M114.495 48.3233C112.222 47.5594 111.865 48.4842 114.065 49.4412C115.623 50.1181 117.228 50.7952 118.977 51.5123C119.855 51.8642 120.766 52.2322 121.724 52.617C122.269 52.8321 122.83 53.0521 123.405 53.2771C123.642 53.3719 123.882 53.4581 124.118 53.5446L124.298 53.6109L124.387 53.6431L124.432 53.658C124.448 53.6672 124.451 53.6354 124.461 53.6282L124.677 53.3074C124.82 53.0915 124.962 52.8714 125.107 52.6532C125.214 52.4803 125.323 52.3051 125.431 52.1299C126.78 49.8413 127.434 48.3201 127.986 46.9923C128.522 45.6576 128.956 44.5121 129.531 42.8088C130.002 41.3663 130.481 39.6442 130.752 37.7826C131.029 35.9289 131.072 33.9297 130.72 32.0614C130.685 31.8273 130.618 31.6003 130.566 31.3718L130.485 31.0327C130.452 30.9243 130.42 30.8201 130.388 30.7117C130.257 30.2887 130.129 29.8759 130.004 29.4734C129.871 29.0758 129.708 28.6954 129.569 28.3277C129.497 28.143 129.427 27.9644 129.357 27.79C129.273 27.619 129.194 27.4517 129.115 27.2886C128.956 26.9624 128.812 26.6518 128.666 26.3665C128.501 26.0891 128.349 25.8296 128.209 25.592C127.945 25.1071 127.656 24.7566 127.474 24.4912L127.134 24.0276L126.744 23.5997C126.627 23.4736 126.483 23.3223 126.319 23.1456C126.159 22.9644 125.94 22.7924 125.717 22.5851C125.273 22.162 124.688 21.7197 124.013 21.241C122.649 20.2913 120.829 19.3789 118.787 18.5467C117.766 18.1211 116.69 17.7191 115.586 17.3008C115.27 17.1814 114.951 17.06 114.628 16.9391C114.367 16.8399 114.105 16.7389 113.84 16.6401L113.446 16.4897L113.246 16.4147L113.146 16.3772L113.096 16.3584C113.096 16.3584 113.082 16.389 113.075 16.4064C112.755 17.2378 112.429 18.0802 112.103 18.9267C111.218 21.2191 110.304 23.5645 109.412 25.8156C108.794 27.4093 108.234 28.851 107.732 30.1514C107.421 30.9526 107.128 31.7103 106.85 32.4268C106.745 32.6982 106.644 32.965 106.543 33.2276L106.506 33.3274C106.489 33.3478 106.52 33.3471 106.533 33.3544L106.583 33.3731L106.78 33.4463C106.91 33.4938 107.038 33.5435 107.168 33.591C107.634 33.7625 108.085 33.9291 108.525 34.0903C109.559 34.458 110.424 34.7754 111.129 35.0899C111.836 35.4021 112.382 35.7072 112.788 35.9826C113.763 36.6283 114.417 37.4256 114.721 38.3225C115.031 39.2209 115.01 40.211 114.85 41.1627C114.514 43.0782 113.723 44.8274 112.888 46.5008C112.427 47.3926 112.339 47.952 112.53 48.0971L112.524 48.1921C112.543 48.1967 112.555 48.1914 112.562 48.174L112.566 48.1192C112.77 48.2253 113.25 47.9025 113.813 47.0312C114.839 45.3874 115.819 43.6386 116.32 41.4445C116.554 40.3541 116.654 39.1054 116.251 37.8205C116.047 37.1856 115.719 36.5657 115.278 36.0207C114.838 35.4734 114.298 35.004 113.712 34.6079C113.257 34.2948 112.658 33.946 111.931 33.5894C111.201 33.2309 110.34 32.8775 109.378 32.5014C109.259 32.4551 109.137 32.4069 109.015 32.3587L108.972 32.3415L108.965 32.3358L108.952 32.3285L108.932 32.3114L108.894 32.2874C108.885 32.2798 108.864 32.2774 108.883 32.2548C108.905 32.2235 108.922 32.1989 108.937 32.1767C109.05 31.9046 109.164 31.6303 109.285 31.345C109.769 30.1721 110.29 28.891 110.842 27.5045C111.2 26.6006 111.535 25.6882 111.85 24.7754C112.189 23.7893 112.548 22.774 112.917 21.7433C113.278 20.7489 113.644 19.7394 114.005 18.745L114.061 18.5681C114.061 18.5681 114.066 18.5489 114.07 18.5485L114.092 18.555L114.135 18.5681L114.223 18.5961L114.268 18.611L114.292 18.6194L114.381 18.6516L114.756 18.7891C115.003 18.881 115.248 18.9709 115.491 19.0632C115.976 19.2435 116.451 19.4227 116.91 19.6032C117.372 19.7793 117.813 19.9613 118.238 20.1365C119.943 20.8405 121.328 21.5682 122.259 22.1505C122.71 22.4597 123.088 22.685 123.314 22.8752C123.546 23.0587 123.675 23.1587 123.675 23.1587C123.675 23.1587 123.72 23.1968 123.812 23.2665C123.898 23.3387 124.044 23.4309 124.196 23.5815C124.355 23.7271 124.549 23.9055 124.772 24.1127C124.829 24.1644 124.886 24.2161 124.948 24.2717C125.001 24.3321 125.059 24.3921 125.117 24.4563C125.233 24.5848 125.355 24.7189 125.483 24.861C126.504 25.9978 127.669 27.8 128.462 30.0309C128.555 30.3103 128.651 30.5957 128.747 30.8812C128.839 31.167 128.95 31.4574 129.012 31.7415C129.087 32.0288 129.164 32.3138 129.211 32.6119L129.291 33.0539C129.312 33.2032 129.325 33.3531 129.347 33.5023C129.488 34.7029 129.464 35.9345 129.335 37.1165C129.074 39.485 128.427 41.6372 127.869 43.2046C127.024 45.5691 126.192 47.2486 125.546 48.5173C124.889 49.7808 124.393 50.6273 124.007 51.2609C123.939 51.3738 123.871 51.4825 123.805 51.589L123.775 51.6377C123.775 51.6377 123.741 51.6281 123.724 51.6254L123.618 51.5863C123.167 51.4156 122.729 51.2521 122.3 51.0921C121.329 50.7356 120.408 50.3979 119.52 50.072C117.742 49.4309 116.096 48.8581 114.486 48.3157L114.495 48.3233Z" fill="#6A9A23"/>
<path d="M63.2213 11.0802C64.3036 11.4417 64.931 11.4901 65.0627 11.2416C65.1871 11.0063 64.7809 10.4561 63.6473 9.96267C62.8457 9.6209 62.0109 9.33237 61.1289 9.10458C60.2473 8.88095 59.3135 8.7101 58.3289 8.65487C57.8413 8.59642 57.3321 8.62798 56.8151 8.61824C56.558 8.63003 56.296 8.65694 56.0313 8.67778C55.898 8.68934 55.7647 8.70089 55.6314 8.71245C55.497 8.7346 55.3648 8.75864 55.2303 8.78079C54.1508 8.93941 53.0339 9.27124 51.9327 9.78634C51.7776 9.86063 51.624 9.9285 51.4775 10.0062C51.3356 10.0878 51.1978 10.169 51.0597 10.246C50.7857 10.4019 50.528 10.5523 50.2994 10.7231C50.0662 10.8902 49.8377 11.038 49.6378 11.2022C49.4383 11.3706 49.2487 11.5318 49.0667 11.684C48.7053 11.9944 48.4124 12.3198 48.1181 12.6055C47.8555 12.9178 47.5991 13.2044 47.3722 13.4927C46.4759 14.6552 45.8317 15.7244 45.0325 17.3317C44.3767 18.7042 43.7657 20.377 43.3437 22.174C42.9124 23.9592 42.6876 25.9258 42.8109 27.7679C42.9178 29.6155 43.3565 31.3442 43.9484 32.684C44.5304 34.031 45.2423 34.9618 45.621 35.485C45.8706 35.776 46.1183 36.0692 46.3915 36.3414C46.8871 36.8083 47.8267 37.6795 49.2654 38.4989C49.6286 38.6962 50.0023 38.9177 50.4196 39.1102C50.8332 39.3072 51.2794 39.4931 51.7434 39.6669C52.6774 40.0119 53.698 40.3137 54.8094 40.5258C57.0183 40.9575 59.6288 40.962 62.1114 40.1404C63.3524 39.7391 64.5396 39.1263 65.6002 38.3608C66.6654 37.5991 67.6064 36.6867 68.4118 35.7104C69.54 34.318 70.3115 32.8999 70.9125 31.5972C71.4954 30.2794 71.8779 29.0712 72.1641 27.9868C72.4458 26.8986 72.6224 25.9307 72.7077 25.0945C72.8141 24.2606 72.8305 23.5521 72.8419 22.9783C72.8528 20.2602 72.1712 17.8559 71.051 15.9366C70.4777 14.9834 69.8234 14.1357 69.0796 13.4176C68.3284 12.7126 67.5418 12.0821 66.6795 11.5966C66.2508 11.3211 65.8679 11.2117 65.5987 11.1553C65.3256 11.1034 65.1518 11.1311 65.0821 11.2231L65.145 11.3687C65.1232 11.335 65.0952 11.3269 65.0588 11.3426L65.0431 11.3062C65.0108 11.4181 65.0816 11.582 65.2604 11.7826C65.4355 11.9877 65.7286 12.1994 66.0982 12.4947C66.8482 13.0172 67.5077 13.6566 68.1348 14.3346C68.7505 15.0261 69.282 15.813 69.7486 16.6727C70.2113 17.5369 70.5551 18.5059 70.8114 19.5559C71.0594 20.6065 71.2063 21.7499 71.1886 22.9789C71.1966 23.2174 71.1654 23.4887 71.1497 23.7922C71.1381 24.0954 71.0911 24.4268 71.0364 24.7903C70.948 25.5156 70.767 26.3601 70.5057 27.2954C69.9645 29.1699 69.1073 31.4663 67.5012 33.7163L67.3088 33.9911L67.1005 34.2525L66.6908 34.7811C66.3873 35.1054 66.1203 35.4642 65.8002 35.7668C65.6299 35.9327 65.4716 36.1164 65.2858 36.273C65.1023 36.4316 64.9187 36.5902 64.7333 36.7511C64.3409 37.0432 63.9478 37.35 63.5114 37.5935C62.6552 38.102 61.7221 38.5228 60.7441 38.7629C58.7947 39.2718 56.7658 39.2231 55.0396 38.865C53.3077 38.5136 51.8735 37.9413 50.9288 37.4483C50.4595 37.1889 50.0869 36.9799 49.8427 36.8249C49.602 36.6611 49.4726 36.5716 49.4726 36.5716C49.4726 36.5716 49.4235 36.5381 49.3322 36.4768C49.2405 36.4113 49.0971 36.3293 48.9364 36.1942C48.772 36.0637 48.5714 35.9027 48.3372 35.7174C48.1201 35.5117 47.8736 35.2813 47.5996 35.0239C47.0988 34.4714 46.5061 33.8031 46.0168 32.9475C45.52 32.1009 45.0877 31.1039 44.7938 30.0068C44.1804 27.8107 44.2512 25.251 44.7058 22.956C45.1626 20.6398 45.9616 18.5919 46.736 17.184C47.8904 15.0487 49.1258 13.7309 50.1581 12.8798C51.1942 12.0241 52.0123 11.5839 52.6484 11.2959C53.6061 10.8457 54.5704 10.5439 55.5178 10.3862C55.6356 10.3655 55.753 10.3406 55.8686 10.318C55.9871 10.3057 56.1034 10.2914 56.2219 10.279C56.4548 10.2546 56.6851 10.2242 56.9142 10.2043C57.3752 10.1979 57.8243 10.1506 58.2681 10.1877C60.0484 10.2243 61.691 10.5855 63.2383 11.0829L63.2213 11.0802Z" fill="#6A9A23"/>
<path d="M149.643 57.1462C149.707 57.1386 149.772 57.135 149.834 57.1296C149.897 57.1284 149.958 57.1335 150.017 57.1368C150.136 57.1434 150.255 57.1393 150.367 57.1485C150.584 57.1884 150.799 57.195 150.983 57.2609C151.077 57.2863 151.167 57.3078 151.257 57.3294C151.342 57.3619 151.422 57.3948 151.5 57.4216C151.58 57.4504 151.654 57.4776 151.725 57.5028C151.793 57.5368 151.859 57.5689 151.92 57.5972C152.179 57.7027 152.367 57.8102 152.516 57.8582C152.665 57.9103 152.768 57.9119 152.818 57.8655C152.869 57.8192 152.863 57.7211 152.795 57.5675C152.727 57.4139 152.604 57.2022 152.364 56.9733C152.304 56.9155 152.242 56.8517 152.176 56.7882C152.104 56.7315 152.021 56.6736 151.936 56.6138C151.851 56.554 151.758 56.4908 151.66 56.4279C151.555 56.3783 151.444 56.3271 151.328 56.2721C151.099 56.1534 150.826 56.0974 150.536 56.0197C150.391 55.9903 150.237 55.9806 150.078 55.9629C149.999 55.955 149.919 55.9452 149.837 55.9418C149.757 55.9445 149.674 55.9476 149.59 55.9506C148.636 55.9788 147.736 56.254 146.905 56.6177C146.068 56.9798 145.315 57.471 144.572 57.9823C144.209 58.2488 143.842 58.5115 143.498 58.8057C143.142 59.0862 142.801 59.3864 142.46 59.695L142.203 59.9229C142.117 59.9975 142.015 60.1008 141.928 60.1902C141.84 60.2818 141.755 60.373 141.675 60.4639L141.463 60.7068L141.37 60.8029C141.341 60.8285 141.308 60.8776 141.28 60.8192L141.196 60.7216L141.177 60.698L141.059 60.5718L140.819 60.3157C140.497 59.9722 140.173 59.6226 139.843 59.2714C139.187 58.5688 138.512 57.8509 137.823 57.1133C136.438 55.6471 134.985 54.105 133.447 52.4758C133.366 52.3925 133.286 52.3093 133.205 52.2261L133.16 52.188C133.113 52.1606 133.152 52.1278 133.173 52.0987L133.224 52.0376C133.316 51.9373 133.407 51.8393 133.497 51.7413C133.679 51.5471 133.86 51.3593 134.04 51.1738C134.763 50.4418 135.456 49.7649 136.09 49.1581C137.34 47.9418 138.448 46.9918 139.511 46.1548C140.576 45.3197 141.597 44.587 142.741 43.9067C143.884 43.2263 145.144 42.5737 146.712 41.9993C147.041 41.8701 147.387 41.775 147.733 41.6568C148.083 41.5489 148.444 41.4588 148.809 41.36C149.549 41.1973 150.314 41.0408 151.105 40.9722C152.687 40.8036 154.367 40.8909 156.008 41.2858C157.649 41.6806 159.244 42.388 160.67 43.3471C162.105 44.2991 163.355 45.4853 164.442 46.7697C165.532 48.0453 166.437 49.3937 167.101 50.744C167.769 52.094 168.2 53.4415 168.453 54.689C168.707 55.9385 168.791 57.0831 168.821 58.0542C168.854 59.0248 168.81 59.826 168.784 60.399L168.72 61.4389C168.704 61.7886 168.699 62.1626 168.693 62.5093C168.686 63.1141 168.656 63.9581 168.694 65.1446C168.711 65.7348 168.755 66.4171 168.886 67.1989C169.02 67.9762 169.253 68.8834 169.791 69.7915C170.053 70.2472 170.391 70.6816 170.799 71.0868C171.204 71.5007 171.727 71.8667 172.326 72.1546C172.941 72.4245 173.637 72.5655 174.345 72.5693C175.051 72.5605 175.743 72.4082 176.418 72.1881C177.747 71.7099 178.979 70.9338 180.172 69.9974C180.767 69.5283 181.354 69.0136 181.936 68.4638C182.23 68.1929 182.508 67.9211 182.801 67.6419C182.857 67.5887 182.911 67.5337 182.968 67.4805L183.01 67.4391C183.026 67.4524 183.042 67.4657 183.06 67.481L183.076 67.4943L183.085 67.5019L183.154 67.5756C183.256 67.6801 183.36 67.7907 183.472 67.9047C183.91 68.3619 184.42 68.8906 184.982 69.4797C186.108 70.6578 187.46 72.0766 188.952 73.6405C189.633 74.3557 190.346 75.1059 191.082 75.8793C191.101 75.907 191.162 75.9353 191.113 75.9669L191.075 76.0121L190.913 76.1856C190.524 76.6075 190.105 77.0278 189.673 77.445C189.235 77.8649 188.793 78.2851 188.349 78.7117C187.9 79.1179 187.462 79.5461 186.997 79.9389C186.087 80.7501 185.126 81.5027 184.164 82.2239C181.541 84.1593 178.922 85.5424 176.438 86.3284C173.956 87.1228 171.629 87.2992 169.639 87.0479C168.643 86.9245 167.728 86.7079 166.902 86.427C166.08 86.1373 165.338 85.8072 164.678 85.449C163.359 84.7303 162.368 83.9392 161.596 83.2591C160.691 82.4521 159.878 81.572 159.161 80.6753C158.43 79.7861 157.823 78.8547 157.303 77.9115C156.265 76.0228 155.669 74.0497 155.387 72.0934C155.235 71.1162 155.172 70.1397 155.141 69.1751C155.104 68.2089 155.139 67.2533 155.147 66.279C155.152 65.3092 155.16 64.358 155.127 63.3873C155.092 62.4231 155.005 61.4381 154.757 60.4609C154.485 59.4059 153.996 58.6741 153.603 58.2822C153.412 58.0785 153.232 57.9619 153.1 57.8936C152.968 57.8253 152.879 57.812 152.832 57.8497L152.701 57.8442C152.697 57.8635 152.703 57.8692 152.722 57.8655L152.829 57.8436L152.808 57.8685C152.77 57.9138 152.772 58.008 152.817 58.1426C152.86 58.2752 152.946 58.4482 153.042 58.6791C153.244 59.1316 153.527 59.7785 153.718 60.7041C153.889 61.5705 153.936 62.4792 153.926 63.4054C153.92 64.3312 153.872 65.2838 153.833 66.2398C153.722 68.1482 153.636 70.1889 153.902 72.2935C154.151 74.3995 154.77 76.593 155.881 78.6747C156.437 79.7134 157.093 80.7371 157.873 81.7018C158.641 82.6759 159.501 83.6149 160.49 84.5006C161.26 85.1829 162.28 86.0177 163.649 86.8244C165.02 87.6183 166.762 88.3758 168.863 88.7476C170.959 89.1156 173.393 89.0683 175.922 88.44C178.453 87.8219 181.043 86.6301 183.565 85.0036C185.208 83.94 186.742 82.7265 188.162 81.4284C188.478 81.1492 188.784 80.8541 189.092 80.5567C189.402 80.2613 189.714 79.9636 190.011 79.665C190.619 79.0668 191.235 78.4573 191.845 77.8107L192.299 77.316C192.345 77.2617 192.523 77.0679 192.639 76.9257L193.021 76.4708L193.391 76.0086L193.486 75.8955C193.48 75.8561 193.425 75.821 193.399 75.7834L193.195 75.566C192.933 75.2761 192.65 74.988 192.374 74.7014C191.761 74.0705 191.146 73.4377 190.534 72.8068C189.331 71.5598 188.135 70.3226 186.969 69.1144C185.625 67.7139 184.318 66.348 183.066 65.0444C182.442 65.6398 181.829 66.2259 181.227 66.8048C181.016 67.0098 180.808 67.2062 180.602 67.3919C180.393 67.5799 180.196 67.7733 179.987 67.9488C179.164 68.6706 178.326 69.2951 177.498 69.7927C176.67 70.2863 175.836 70.6439 175.066 70.7841C174.293 70.9266 173.6 70.8461 173.042 70.5966C172.477 70.3497 172.045 69.936 171.712 69.5326C171.383 69.1289 171.169 68.7362 171.022 68.3965C170.949 68.2266 170.901 68.067 170.85 67.9351C170.811 67.7937 170.778 67.677 170.753 67.5826C170.724 67.4886 170.713 67.4098 170.7 67.3606C170.689 67.309 170.683 67.2844 170.683 67.2844C170.683 67.2844 170.655 67.1757 170.62 66.9647C170.602 66.8571 170.582 66.7245 170.558 66.5692C170.542 66.409 170.522 66.2261 170.5 66.0182C170.428 65.181 170.429 63.9304 170.475 62.3506C170.48 61.578 170.559 60.7172 170.575 59.7653C170.586 58.816 170.584 57.7985 170.473 56.7275C170.366 55.6562 170.183 54.5328 169.879 53.3967C169.563 52.2616 169.12 51.1208 168.563 50.0109C168.013 48.8919 167.297 47.8419 166.532 46.8276C166.332 46.5785 166.135 46.3312 165.933 46.0802C165.729 45.8356 165.508 45.603 165.296 45.3632C165.082 45.1258 164.871 44.886 164.637 44.6587C164.41 44.4287 164.184 44.1965 163.941 43.9846C162.045 42.2207 159.744 40.834 157.312 40.1068C154.881 39.3649 152.383 39.3003 150.19 39.631C147.983 39.9545 146.071 40.6532 144.51 41.353C142.165 42.4333 140.292 43.6636 138.737 44.8286C137.183 45.9978 135.935 47.0964 134.891 48.0807C133.859 49.0556 132.992 49.8798 132.263 50.6501C132.173 50.7481 132.085 50.8439 131.996 50.9355C131.87 51.0807 131.724 51.2361 131.601 51.3915C131.474 51.5473 131.351 51.6986 131.228 51.8498C131.165 51.9245 131.108 52.0008 131.048 52.0732C131.006 52.1461 130.87 52.225 130.986 52.2883C131.232 52.5607 131.465 52.8217 131.709 53.0734C131.889 53.2634 132.062 53.4477 132.23 53.624C133.778 55.2461 135.238 56.775 136.632 58.2363C137.33 58.9626 138.015 59.6733 138.681 60.3688C139.015 60.7154 139.345 61.0583 139.674 61.3969C139.865 61.5964 140.056 61.7918 140.245 61.9894L140.649 62.4098C140.784 62.5428 140.916 62.6615 141.049 62.7885L141.247 62.9748L141.299 63.0185L141.32 63.044C141.325 63.0478 141.329 63.0516 141.332 63.0535L141.343 63.0399L141.444 62.943L141.83 62.5529C142.085 62.3 142.335 62.0077 142.564 61.7213C142.888 61.3177 143.089 61.0967 143.437 60.779C143.751 60.4791 144.068 60.1851 144.395 59.9113C144.712 59.6257 145.047 59.3701 145.374 59.1088C146.043 58.6165 146.72 58.1424 147.435 57.8013C148.146 57.4564 148.886 57.2055 149.62 57.1503L149.643 57.1462Z" fill="#6A9A23"/>
<path d="M80.321 25.3809C80.4416 23.1064 79.4571 23.0281 79.1312 25.2574C78.8942 26.839 78.6434 28.4554 78.3341 30.1965C78.018 31.9318 77.6635 33.8048 77.0533 35.8028C76.9621 36.1317 76.8558 36.4326 76.7629 36.7176C76.7418 36.7887 76.7161 36.8559 76.6904 36.9232C76.6579 37.0079 76.6295 37.0922 76.5966 37.1726C76.5069 37.4217 76.4055 37.6571 76.3015 37.8865C75.8871 38.7743 75.5595 39.4762 75.3454 39.9375C76.5743 39.8079 77.6597 39.6697 78.5962 39.5571C79.1374 39.4829 79.6268 39.4153 80.1059 39.3507C81.0599 39.2218 81.9734 39.109 83.1533 38.9963C85.9529 38.7116 89.7215 38.3996 93.0728 38.1385C93.9107 38.0743 94.7237 38.0122 95.4885 37.9522C95.6782 37.9379 95.8679 37.9235 96.0534 37.9095C96.3908 37.8803 96.7199 37.8518 97.0447 37.8236C97.2132 37.8069 97.3821 37.7943 97.5465 37.778L97.6089 37.7726C97.6204 37.759 97.6182 37.734 97.6228 37.7147L97.6419 37.5956L97.6801 37.3573C97.73 37.0361 97.7788 36.7255 97.826 36.4214C97.9332 35.7428 98.0279 35.1387 98.1097 34.628C98.1809 34.1392 98.241 33.7417 98.2835 33.4568C98.332 33.119 98.3699 32.78 98.4014 32.4394C98.4496 31.9044 98.5308 30.972 98.6212 29.7346C98.6626 29.1205 98.7101 28.4302 98.7605 27.6768C98.8248 26.9389 98.9042 26.1326 98.9956 25.2707C99.1893 23.5523 99.4495 21.6308 99.8761 19.6446C100.088 18.6526 100.35 17.6438 100.688 16.6576C100.777 16.415 100.869 16.172 100.959 15.9271L101.111 15.5677L101.185 15.3871C101.19 15.3678 101.226 15.3017 101.255 15.2447L101.343 15.0755L101.695 14.3903C101.746 14.2788 101.822 14.1569 101.901 14.0346L102.126 13.671C102.421 13.1964 102.713 12.72 103.01 12.2431C102.93 12.2417 102.807 12.2544 102.664 12.2689C102.522 12.2812 102.364 12.2991 102.189 12.3143C101.84 12.3487 101.434 12.3902 100.989 12.433C100.271 12.5015 99.4285 12.5851 98.594 12.6637C92.1629 13.3177 88.1819 13.7215 86.104 13.9331C84.8775 14.0646 83.7301 14.1892 82.6387 14.3069C81.9634 14.3843 81.3068 14.4581 80.6649 14.5326L80.3138 14.5735L80.1393 14.5928L80.054 14.6023C80.054 14.6023 80.0158 14.5972 80.0195 14.6158L80.0129 14.6604C79.9849 14.8958 79.9566 15.1269 79.9306 15.36C79.9042 15.5889 79.8778 15.8178 79.8514 16.0467C79.8379 16.1821 79.824 16.3134 79.8105 16.4489C79.6178 18.4463 79.5162 20.2848 79.4719 22.1057C79.4328 24.1087 80.2926 24.1517 80.5363 22.1855C80.7678 20.3945 81.0108 18.59 81.2991 16.6304C81.3163 16.5135 81.3335 16.3966 81.3507 16.2797L81.3736 16.156L81.3968 16.0365C81.4245 16.0173 81.4801 16.0293 81.5173 16.0219L81.6426 16.0152C81.7592 16.0051 81.8758 15.995 81.9924 15.9849C82.259 15.9618 82.5275 15.9364 82.8005 15.9148C83.891 15.8119 85.0441 15.7036 86.2698 15.5868C88.1772 15.3942 92.1765 15.2259 97.792 14.7013C98.2499 14.6575 98.7073 14.6094 99.1621 14.5553L99.459 14.5191C99.459 14.5191 99.4628 14.5146 99.4666 14.51C99.4723 14.5032 99.4841 14.4938 99.5061 14.4814C99.5282 14.469 99.5786 14.4458 99.6074 14.4391C99.6134 14.4595 99.619 14.4758 99.5928 14.562L99.5732 14.6267L99.4323 14.9872C99.3335 15.2287 99.2457 15.4755 99.1662 15.7216C98.8317 16.7074 98.5712 17.7014 98.3498 18.6858C97.9192 20.6493 97.6406 22.5514 97.4316 24.2145C97.2283 25.8708 97.0684 27.301 96.9964 28.3144C96.9101 29.3081 96.8578 29.8938 96.8578 29.8938C96.8578 29.8938 96.7819 30.8383 96.6206 32.3483C96.541 33.1043 96.4359 34.0009 96.3094 34.9918C96.2578 35.3655 96.2075 35.756 96.1523 36.1615C96.1696 36.2649 96.0622 36.2365 95.9922 36.2509C95.7737 36.272 95.5533 36.2953 95.3287 36.3189C90.738 36.7819 85.3487 37.3267 82.1496 37.6502L79.3959 37.9309L78.3394 38.0392L78.1542 38.0574L78.0607 38.0676L78.0148 38.0716C78.0148 38.0716 77.9678 38.0861 77.9869 38.0635C78.0476 37.9407 78.1061 37.8161 78.1578 37.6857L78.2605 37.4166C78.3084 37.2907 78.3479 37.1656 78.3917 37.0401C78.4791 36.7891 78.5624 36.5385 78.637 36.2845C79.2812 34.1451 79.6012 32.2122 79.8478 30.4262C80.088 28.6386 80.2266 26.9858 80.3206 25.3767L80.321 25.3809Z" fill="#6A9A23"/>
</g>
</g>
<defs>
<clipPath id="clip0_783_5660">
<rect width="421" height="32" fill="white"/>
</clipPath>
<clipPath id="clip1_783_5660">
<rect width="304" height="304.679" fill="white" transform="translate(268.681 74.498) rotate(-105)"/>
</clipPath>
<clipPath id="clip2_783_5660">
<rect width="304" height="304.679" fill="white" transform="translate(-42.3188 346) rotate(-105)"/>
</clipPath>
</defs>
</svg>
`;
const $fc6840133e04adc0$var$$ea8e736e4eb06883$export$3c6f6c6a4ab84ea6 = `data:image/svg+xml;base64,${$fc6840133e04adc0$var$$ea8e736e4eb06883$require$Buffer.from($fc6840133e04adc0$var$$ea8e736e4eb06883$var$learningPathBg).toString("base64")}`;
const $fc6840133e04adc0$var$$0dbf0b63949b5d22$export$8b251419efc915eb = ({ isCourse: isCourse, courseImgUrl: courseImgUrl, title: title, completedItems: completedItems, progress: progress, learningPathSlug: learningPathSlug, courseSlug: courseSlug, navigate: navigate })=>{
    const handleNavigation = (0, $5FkrB.useCallback)(()=>{
        learningPathSlug ? navigate(`/path/${learningPathSlug}`) : navigate(`/course/${courseSlug}`);
    }, [
        learningPathSlug,
        courseSlug,
        navigate
    ]);
    const onKeyDown = $fc6840133e04adc0$export$2a0b6757d41dacb2(handleNavigation);
    return (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
        "data-testid": "sidebar-header",
        css: $fc6840133e04adc0$var$$0dbf0b63949b5d22$var$headerStyles,
        children: [
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("img", {
                css: $fc6840133e04adc0$var$$0dbf0b63949b5d22$var$headerImageStyles,
                src: isCourse ? $fc6840133e04adc0$var$$e48fba9cf5395297$export$d3a66d29d3f047ac : $fc6840133e04adc0$var$$ea8e736e4eb06883$export$3c6f6c6a4ab84ea6,
                alt: title
            }),
            (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                css: [
                    $fc6840133e04adc0$var$$0dbf0b63949b5d22$var$headerContentStyles,
                    isCourse && $fc6840133e04adc0$var$$0dbf0b63949b5d22$var$courseHeaderContentStyles
                ],
                children: [
                    isCourse && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                        css: $fc6840133e04adc0$var$$0dbf0b63949b5d22$var$courseImageContainerStyles,
                        children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("img", {
                            css: $fc6840133e04adc0$var$$0dbf0b63949b5d22$var$courseImageStyles,
                            src: courseImgUrl,
                            alt: title,
                            "data-testid": "course-image"
                        })
                    }),
                    (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                        css: [
                            $fc6840133e04adc0$var$$0dbf0b63949b5d22$var$containerStyles,
                            isCourse && (0, $74Zh5.css)({
                                marginLeft: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.150")
                            })
                        ],
                        children: [
                            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("p", {
                                css: $fc6840133e04adc0$var$$0dbf0b63949b5d22$var$typeStyles,
                                children: isCourse ? "Course" : "Learning Path"
                            }),
                            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                                role: "button",
                                tabIndex: 0,
                                css: $fc6840133e04adc0$var$$0dbf0b63949b5d22$var$titleStyles,
                                "data-testid": "sidebar-title",
                                onClick: handleNavigation,
                                onKeyDown: onKeyDown,
                                children: title
                            })
                        ]
                    }),
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                        "data-testid": "course-progress-circle",
                        css: $fc6840133e04adc0$var$$0dbf0b63949b5d22$var$progressCircleContainerStyles,
                        children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $f188eff9b59fb855$export$5ab97151efedb8c6), {
                            strokeWidth: 8,
                            value: progress,
                            styles: (0, $f188eff9b59fb855$export$5115a192ad9bf57f)({
                                pathColor: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.border.success"),
                                trailColor: "rgba(9, 30, 66, 0.14)"
                            }),
                            children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("p", {
                                css: [
                                    $fc6840133e04adc0$var$$0dbf0b63949b5d22$var$progressStyles,
                                    isCourse && (0, $74Zh5.css)({
                                        fontSize: "14px"
                                    })
                                ],
                                "data-testid": "progress-text",
                                children: completedItems
                            })
                        })
                    })
                ]
            })
        ]
    });
};
const $fc6840133e04adc0$var$$0dbf0b63949b5d22$var$headerStyles = (0, $74Zh5.css)({
    width: "100%",
    marginBottom: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.200")
});
const $fc6840133e04adc0$var$$0dbf0b63949b5d22$var$headerImageStyles = (0, $74Zh5.css)({
    [(0, $0bc19dfefbafca8c$export$987d49ffe1b0900f).below.xs]: {
        width: "100%"
    }
});
const $fc6840133e04adc0$var$$0dbf0b63949b5d22$var$headerContentStyles = (0, $74Zh5.css)({
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    marginTop: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.250"),
    paddingLeft: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.200"),
    paddingRight: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.100")
});
const $fc6840133e04adc0$var$$0dbf0b63949b5d22$var$courseHeaderContentStyles = (0, $74Zh5.css)({
    paddingLeft: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.150"),
    paddingRight: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.150")
});
const $fc6840133e04adc0$var$$0dbf0b63949b5d22$var$progressCircleContainerStyles = (0, $74Zh5.css)({
    maxWidth: "48px",
    marginLeft: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.150")
});
const $fc6840133e04adc0$var$$0dbf0b63949b5d22$var$progressStyles = (0, $74Zh5.css)({
    fontFamily: "Inter, sans-serif",
    fontSize: "16px",
    fontWeight: 400,
    lineHeight: "24px"
});
const $fc6840133e04adc0$var$$0dbf0b63949b5d22$var$courseImageContainerStyles = (0, $74Zh5.css)({
    width: "32px",
    minWidth: "32px",
    minHeight: "32px"
});
const $fc6840133e04adc0$var$$0dbf0b63949b5d22$var$courseImageStyles = (0, $74Zh5.css)({
    width: "100%",
    height: "100%",
    objectFit: "cover"
});
const $fc6840133e04adc0$var$$0dbf0b63949b5d22$var$containerStyles = (0, $74Zh5.css)({
    display: "flex",
    flexDirection: "column",
    marginRight: "auto"
});
const $fc6840133e04adc0$var$$0dbf0b63949b5d22$var$typeStyles = (0, $74Zh5.css)({
    color: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.text.subtle"),
    fontFamily: "Charlie Display, sans-serif",
    fontSize: "12px",
    lineHeight: "16px",
    fontWeight: 600,
    textTransform: "uppercase",
    marginBottom: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.050")
});
const $fc6840133e04adc0$var$$0dbf0b63949b5d22$var$titleStyles = (0, $74Zh5.css)({
    fontFamily: "Charlie Display, sans-serif",
    fontSize: "20px",
    fontWeight: 600,
    lineHeight: "28px",
    marginTop: 0,
    transition: "color 0.5s ease",
    [(0, $0bc19dfefbafca8c$export$987d49ffe1b0900f).below.xs]: {
        fontSize: "16px",
        lineHeight: "24px"
    },
    "&:hover": {
        cursor: "pointer",
        color: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.text.selected")
    }
});
const $fc6840133e04adc0$var$$dc9bbc4e728e99ac$export$792ece11a7230884 = 89;
const $fc6840133e04adc0$var$$dc9bbc4e728e99ac$export$1239cfcb7eeed80e = 8;
const $fc6840133e04adc0$var$$dc9bbc4e728e99ac$export$686a18f490557de2 = 16;
const $fc6840133e04adc0$var$$dc9bbc4e728e99ac$export$6a021f56d50c6f44 = 250;
const $fc6840133e04adc0$var$$dc9bbc4e728e99ac$export$789f21e35b72f907 = 68;
const $fc6840133e04adc0$var$$dc9bbc4e728e99ac$export$4ac0ef1183ae81e8 = (positionData)=>{
    const height = positionData.height > $fc6840133e04adc0$var$$dc9bbc4e728e99ac$export$792ece11a7230884 ? $fc6840133e04adc0$var$$dc9bbc4e728e99ac$export$792ece11a7230884 : positionData.height;
    const subnavbarPosition = document.getElementById("subnavbar")?.getBoundingClientRect();
    const offset = subnavbarPosition && subnavbarPosition.y < $fc6840133e04adc0$var$$dc9bbc4e728e99ac$export$789f21e35b72f907 ? $fc6840133e04adc0$var$$dc9bbc4e728e99ac$export$789f21e35b72f907 - subnavbarPosition.y : 0;
    return {
        top: positionData.top - ($fc6840133e04adc0$var$$dc9bbc4e728e99ac$export$6a021f56d50c6f44 / 2 - height / 2) + offset - $fc6840133e04adc0$var$$dc9bbc4e728e99ac$export$686a18f490557de2,
        left: $fc6840133e04adc0$var$$035f8a623e403361$export$780035d9fe48eb32 - $fc6840133e04adc0$var$$dc9bbc4e728e99ac$export$686a18f490557de2
    };
};
const $fc6840133e04adc0$var$$f50e6e435b887166$export$1671b398b5e36be4 = ({ courses: courses, renderPopup: renderPopup })=>{
    const { hoverInfo: hoverInfo, popupRef: popupRef, handleMouseLeave: handleMouseLeave } = $fc6840133e04adc0$var$$32c02b5652036d7a$export$861cd542ff836f0d();
    const courseToShowInPopup = (0, $5FkrB.useMemo)(()=>courses.find(({ sys: sys })=>sys.id === hoverInfo?.courseId), [
        hoverInfo?.courseId,
        courses
    ]);
    const handlePopupLeave = (e)=>{
        const popupId = popupRef.current?.children[0].id;
        const isMovedToOutside = e.target.closest(`#${popupId}`);
        if (isMovedToOutside) handleMouseLeave();
    };
    if (!hoverInfo) return null;
    return (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
        "data-testid": "sidebar-hover-popup",
        ref: popupRef,
        onMouseLeave: handlePopupLeave,
        css: [
            $fc6840133e04adc0$var$$f50e6e435b887166$var$popupStyles,
            (0, $74Zh5.css)($fc6840133e04adc0$var$$dc9bbc4e728e99ac$export$4ac0ef1183ae81e8(hoverInfo.courseCardPosition))
        ],
        children: renderPopup(courseToShowInPopup)
    });
};
const $fc6840133e04adc0$var$$f50e6e435b887166$var$popupStyles = (0, $74Zh5.css)({
    position: "absolute",
    zIndex: 100,
    transform: "translateY(-50%)",
    paddingLeft: `${$fc6840133e04adc0$var$$dc9bbc4e728e99ac$export$686a18f490557de2 + $fc6840133e04adc0$var$$dc9bbc4e728e99ac$export$1239cfcb7eeed80e}px`,
    marginLeft: "-1px",
    [(0, $0bc19dfefbafca8c$export$987d49ffe1b0900f).below.sm]: {
        display: "none"
    }
});
const $fc6840133e04adc0$export$4ff69a78d3a65d6f = ({ isVisible: isVisible = true, isLoading: isLoading, learningPath: learningPath, progressForLessons: progressForLessons, progressForCourses: progressForCourses, expandedCourseIds: expandedCourseIds = [], expandedLessonIds: expandedLessonIds = [], selectedSectionId: selectedSectionId, currentLessonSlug: currentLessonSlug, onSelect: onSelect, navigate: navigate = ()=>{}, renderPopup: renderPopup, onToggleVisibility: onToggleVisibility })=>{
    const [showCurrentLessonButton, setShowCurrentLessonButton] = (0, $5FkrB.useState)(false);
    const scrollContainerRef = (0, $5FkrB.useRef)(null);
    const selectedLessonRef = (0, $5FkrB.useRef)(null);
    const courses = (0, $5FkrB.useMemo)(()=>learningPath?.coursesCollection.items || [], [
        learningPath?.coursesCollection.items
    ]);
    const lessons = (0, $5FkrB.useMemo)(()=>courses.flatMap((course)=>course.lessonsCollection.items), [
        courses
    ]);
    const numberOfCompletedLessons = lessons.filter(({ sys: { id: id } })=>progressForLessons?.lessons.find((lesson)=>lesson.lessonId === id)?.status === $fc6840133e04adc0$var$$035f8a623e403361$export$23d03d0b3065d061.COMPLETED).length;
    const numberOfCompletedCourses = courses.filter(({ sys: { id: id } })=>progressForCourses?.courses.find((course)=>course.courseId === id)?.status === $fc6840133e04adc0$var$$035f8a623e403361$export$23d03d0b3065d061.COMPLETED).length;
    const selectedCourse = courses.find(({ slug: slug })=>$fc6840133e04adc0$var$$48630d5962798e4a$export$15379570ba48f04d(slug));
    const isCourse = !learningPath?.title;
    const courseImage = (courses[0]?.reward?.orangeLogicAsset?.imageUrl ?? courses[0]?.reward?.badgeCdnUrl) || $fc6840133e04adc0$var$$ef44b01e6346ac17$export$44f5f766f3f98994;
    const calculateProgress = ()=>isCourse ? numberOfCompletedLessons / lessons.length * 100 : numberOfCompletedCourses / courses.length * 100;
    const completedEntities = isCourse ? numberOfCompletedLessons : numberOfCompletedCourses;
    const totalEntities = isCourse ? lessons.length : courses.length;
    // Find the selected lesson in either the main lessons array or inside course cards
    const selectedLessonId = (0, $5FkrB.useMemo)(()=>isCourse ? lessons.find(({ slug: slug })=>$fc6840133e04adc0$var$$48630d5962798e4a$export$15379570ba48f04d("", slug)) : courses.reduce((found, course)=>{
            if (found) return found;
            const selectedLesson = course.lessonsCollection.items.find(({ slug: slug })=>$fc6840133e04adc0$var$$48630d5962798e4a$export$15379570ba48f04d("", slug));
            return selectedLesson ? selectedLesson.sys.id : undefined;
        }, undefined), [
        isCourse,
        lessons,
        courses
    ]);
    // Handle scroll event to check if selected lesson is visible
    const handleScroll = (0, $5FkrB.useCallback)(()=>{
        if (!scrollContainerRef.current || !selectedLessonRef.current || !selectedLessonId) return;
        const container = scrollContainerRef.current;
        const selectedLessonElement = selectedLessonRef.current;
        const containerRect = container.getBoundingClientRect();
        const lessonRect = selectedLessonElement.getBoundingClientRect();
        // Check if the selected lesson is above the visible area
        const isLessonAboveViewport = lessonRect.top < containerRect.top;
        setShowCurrentLessonButton(isLessonAboveViewport);
    }, [
        selectedLessonId
    ]);
    const scrollToSelectedLesson = (0, $5FkrB.useCallback)(()=>{
        if (selectedLessonRef.current && scrollContainerRef.current) selectedLessonRef.current.scrollIntoView({
            behavior: "smooth",
            block: "start"
        });
    }, []);
    (0, $5FkrB.useEffect)(()=>{
        const scrollContainer = scrollContainerRef.current;
        if (scrollContainer) {
            scrollContainer.addEventListener("scroll", handleScroll);
            handleScroll();
            return ()=>{
                scrollContainer.removeEventListener("scroll", handleScroll);
            };
        }
    }, [
        selectedLessonId
    ]);
    /* eslint-enable react-hooks/exhaustive-deps */ return (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("aside", {
        "data-testid": "sidebar",
        css: [
            $fc6840133e04adc0$var$$3d76652bb6362040$var$sidebarStyles,
            !isVisible && $fc6840133e04adc0$var$$3d76652bb6362040$var$sidebarClosedStyles
        ],
        children: [
            isVisible && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                role: "button",
                tabIndex: 0,
                css: $fc6840133e04adc0$var$$3d76652bb6362040$var$closeButtonContainerStyles,
                onClick: onToggleVisibility,
                onKeyDown: (e)=>{
                    if (e.key === "Enter" || e.key === " ") {
                        e.preventDefault();
                        onToggleVisibility?.();
                    }
                },
                children: (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("button", {
                    "data-testid": "sidebar-mobile-close-button",
                    css: $fc6840133e04adc0$var$$3d76652bb6362040$var$closeButtonStyles,
                    children: [
                        (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$export$f04a61298a47a40f, {
                            type: "cross",
                            color: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.icon")
                        }),
                        (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("span", {
                            css: $fc6840133e04adc0$var$$3d76652bb6362040$var$closeButtonTextStyles,
                            children: "Close"
                        })
                    ]
                })
            }),
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("button", {
                "data-testid": "sidebar-toggle-button",
                css: [
                    $fc6840133e04adc0$var$$3d76652bb6362040$var$sidebarButton,
                    isCourse && $fc6840133e04adc0$var$$3d76652bb6362040$var$sidebarButtonForCourseStyles
                ],
                onClick: onToggleVisibility,
                "aria-label": isVisible ? "Collapse sidebar" : "Expand sidebar",
                children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$export$f04a61298a47a40f, {
                    type: isVisible ? "sidebar-collapse" : "sidebar-expand"
                })
            }),
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$var$$0dbf0b63949b5d22$export$8b251419efc915eb, {
                isCourse: isCourse,
                learningPathSlug: learningPath?.slug,
                courseSlug: courses[0]?.slug,
                title: isCourse ? selectedCourse?.title || "" : learningPath?.title || "",
                completedItems: `${completedEntities}/${totalEntities}`,
                progress: calculateProgress(),
                courseImgUrl: courseImage,
                navigate: navigate
            }),
            (0, $6bec4f26b2cb3094$export$25062201e9e25d76)($fc6840133e04adc0$var$$32c02b5652036d7a$export$d8355e8edbcacbe8, {
                children: [
                    (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                        "data-testid": "sidebar-cards-container",
                        css: [
                            $fc6840133e04adc0$var$$3d76652bb6362040$var$cardsContainerStyles,
                            isCourse && $fc6840133e04adc0$var$$3d76652bb6362040$var$cardsContainerForCourseStyles
                        ],
                        children: [
                            showCurrentLessonButton && selectedLessonId && (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("button", {
                                css: $fc6840133e04adc0$var$$3d76652bb6362040$var$currentLessonStyles,
                                onClick: scrollToSelectedLesson,
                                children: [
                                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$export$f04a61298a47a40f, {
                                        type: "arrow-up",
                                        color: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.icon")
                                    }),
                                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("span", {
                                        css: $fc6840133e04adc0$var$$3d76652bb6362040$var$buttonTextStyles,
                                        children: "Current lesson"
                                    })
                                ]
                            }),
                            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                                css: $fc6840133e04adc0$var$$3d76652bb6362040$var$cardsScrollableContainerStyles,
                                ref: scrollContainerRef,
                                children: isCourse ? (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                                    "data-testid": "sidebar-lesson-container",
                                    css: $fc6840133e04adc0$var$$3d76652bb6362040$var$lessonContainerStyles,
                                    children: lessons.map((lesson)=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                                            ref: $fc6840133e04adc0$var$$48630d5962798e4a$export$15379570ba48f04d("", lesson.slug) ? selectedLessonRef : null,
                                            children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$var$$0ca1c0d89e77a13d$export$951debaed2d5c034, {
                                                isCourse: isCourse,
                                                courseSlug: selectedCourse?.slug,
                                                lesson: lesson,
                                                progressForLesson: progressForLessons?.lessons.find((lessonProgress)=>lessonProgress.lessonId === lesson.sys.id),
                                                onSelect: onSelect,
                                                expandedLessonIds: expandedLessonIds,
                                                isLoading: isLoading,
                                                selectedSectionId: selectedSectionId,
                                                currentLessonSlug: currentLessonSlug
                                            })
                                        }, lesson.sys.id))
                                }) : courses.map((course)=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$var$$aefb4e9d0a694068$export$bb61bd2f4f2a772c, {
                                        course: course,
                                        progressForLessons: progressForLessons,
                                        status: $fc6840133e04adc0$var$$48630d5962798e4a$export$272e7ef3ea22070d(progressForCourses?.courses.find((courseProgress)=>courseProgress.courseId === course.sys.id)?.status),
                                        onSelect: onSelect,
                                        isLoading: isLoading,
                                        selectedLessonRef: selectedLessonRef,
                                        expandedLessonIds: expandedLessonIds,
                                        expandedCourseIds: expandedCourseIds,
                                        selectedSectionId: selectedSectionId,
                                        currentLessonSlug: currentLessonSlug,
                                        scrollContainerRef: scrollContainerRef
                                    }, course.sys.id))
                            })
                        ]
                    }),
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$var$$f50e6e435b887166$export$1671b398b5e36be4, {
                        courses: courses,
                        renderPopup: renderPopup
                    })
                ]
            })
        ]
    });
};
const $fc6840133e04adc0$var$$3d76652bb6362040$var$sidebarStyles = (0, $74Zh5.css)({
    position: "relative",
    display: "flex",
    flexDirection: "column",
    backgroundColor: "#FFFFFF",
    height: "100%",
    width: `${$fc6840133e04adc0$var$$035f8a623e403361$export$780035d9fe48eb32}px`,
    borderRight: `1px solid ${(0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.border")}`,
    transition: "transform 0.3s ease",
    [(0, $0bc19dfefbafca8c$export$987d49ffe1b0900f).below.xs]: {
        width: "100%"
    }
});
const $fc6840133e04adc0$var$$3d76652bb6362040$var$sidebarClosedStyles = (0, $74Zh5.css)({
    transform: "translateX(-412px)",
    [(0, $0bc19dfefbafca8c$export$987d49ffe1b0900f).below.xs]: {
        transform: "translateX(-100%)"
    }
});
const $fc6840133e04adc0$var$$3d76652bb6362040$var$closeButtonContainerStyles = (0, $74Zh5.css)({
    padding: `${(0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.150")} ${(0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.200")}`,
    [(0, $0bc19dfefbafca8c$export$987d49ffe1b0900f).above.xs]: {
        display: "none"
    }
});
const $fc6840133e04adc0$var$$3d76652bb6362040$var$closeButtonStyles = (0, $74Zh5.css)({
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "#FFFFFF",
    border: "none",
    cursor: "pointer"
});
const $fc6840133e04adc0$var$$3d76652bb6362040$var$closeButtonTextStyles = (0, $74Zh5.css)({
    fontFamily: "Inter, sans-serif",
    fontSize: "14px",
    lineHeight: "20px",
    fontWeight: 400,
    color: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.text"),
    marginLeft: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.100")
});
const $fc6840133e04adc0$var$$3d76652bb6362040$var$sidebarButton = (0, $74Zh5.css)({
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    position: "absolute",
    width: "32px",
    height: "32px",
    top: "84px",
    right: "calc(-32px - 16px)",
    backgroundColor: "#FFFFFF",
    borderRadius: "3px",
    boxShadow: "0px 0px 1px 0px rgba(9, 30, 66, 0.31), 0px 1px 1px 0px rgba(9, 30, 66, 0.25)",
    padding: 0,
    border: "none",
    cursor: "pointer",
    zIndex: 100,
    "&:hover": {
        backgroundColor: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("elevation.surface.hovered")
    },
    "&:active": {
        backgroundColor: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("elevation.surface.pressed")
    },
    svg: {
        width: "24px",
        height: "24px"
    },
    [(0, $0bc19dfefbafca8c$export$987d49ffe1b0900f).below.xs]: {
        display: "none"
    }
});
const $fc6840133e04adc0$var$$3d76652bb6362040$var$sidebarButtonForCourseStyles = (0, $74Zh5.css)({
    top: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.200")
});
const $fc6840133e04adc0$var$$3d76652bb6362040$var$cardsContainerStyles = (0, $74Zh5.css)({
    position: "relative",
    flex: 1,
    display: "flex",
    flexDirection: "column",
    borderTop: `1px solid ${(0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.border")}`,
    minHeight: 0
});
const $fc6840133e04adc0$var$$3d76652bb6362040$var$cardsContainerForCourseStyles = (0, $74Zh5.css)({
    paddingTop: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.100")
});
const $fc6840133e04adc0$var$$3d76652bb6362040$var$currentLessonStyles = (0, $74Zh5.css)({
    position: "absolute",
    zIndex: 100,
    top: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.100"),
    left: "50%",
    transform: "translateX(-50%)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "#fff",
    border: `1px solid ${(0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.border")}`,
    padding: `${(0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.100")} ${(0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.200")}`,
    cursor: "pointer",
    width: "fit-content",
    borderRadius: "100px",
    boxShadow: "0px 0px 1px 0px rgba(9, 30, 66, 0.31), 0px 8px 12px 0px rgba(9, 30, 66, 0.15), 0px 0px 0px 1px rgba(188, 214, 240, 0.00) inset"
});
const $fc6840133e04adc0$var$$3d76652bb6362040$var$buttonTextStyles = (0, $74Zh5.css)({
    fontFamily: "Inter, sans-serif",
    fontSize: "16px",
    lineHeight: "24px",
    fontWeight: 400,
    marginLeft: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.050"),
    color: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.text")
});
const $fc6840133e04adc0$var$$3d76652bb6362040$var$lessonContainerStyles = (0, $74Zh5.css)({
    display: "flex",
    flexDirection: "column",
    gap: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.100")
});
const $fc6840133e04adc0$var$$3d76652bb6362040$var$cardsScrollableContainerStyles = (0, $74Zh5.css)({
    flex: 1,
    overflowY: "auto",
    minHeight: 0
});
var $fc6840133e04adc0$var$$764442aba3de2fce$exports = {};
$fc6840133e04adc0$var$$parcel$export($fc6840133e04adc0$var$$764442aba3de2fce$exports, "VIDEO_CONTROL_TYPES", ()=>$fc6840133e04adc0$export$2ffae0f952561172);
$fc6840133e04adc0$var$$parcel$export($fc6840133e04adc0$var$$764442aba3de2fce$exports, "Video", ()=>$fc6840133e04adc0$export$ae01dedf5c052bb);
// using 'plyr' instead of 'plyr/dist/plyr'
// will start executing DOM APIs right away
// and it breaks SSR
const $fc6840133e04adc0$export$2ffae0f952561172 = [
    "play-small",
    "play",
    "progress",
    "current-time",
    "rewind",
    "fast-forward",
    "mute",
    "volume",
    "settings",
    "fullscreen",
    "seektime"
];
const $fc6840133e04adc0$var$$764442aba3de2fce$var$MOBILE_SCREEN_WIDTH = 480;
const $fc6840133e04adc0$var$$764442aba3de2fce$var$LEARNING_PAGE_CUSTOM_PLAYER_WIDTH = 920;
const $fc6840133e04adc0$export$ae01dedf5c052bb = ({ orangeUrl: orangeUrl, vimeoUrl: vimeoUrl, youtubeUrl: youtubeUrl, captions: captions, chapters: chapters, controls: controls, width: width, height: height, videoId: videoId, name: name, poster: poster = "", onControlClick: onControlClick, onProgressUpdate: onProgressUpdate, onError: onError, customControls: customControls, hasResponsiveControls: hasResponsiveControls, preload: preload = "metadata" })=>{
    const videoRef = (0, $5FkrB.useRef)(null);
    const playerRef = (0, $5FkrB.useRef)(null);
    const mobileControls = (0, $5FkrB.useMemo)(()=>customControls?.customMobileControls ?? [
            ...$fc6840133e04adc0$export$2ffae0f952561172
        ], [
        customControls?.customMobileControls
    ]);
    const desktopControls = (0, $5FkrB.useMemo)(()=>customControls?.customDesktopControls ?? [
            ...$fc6840133e04adc0$export$2ffae0f952561172
        ], [
        customControls?.customDesktopControls
    ]);
    const hasCustomDesktopControls = Boolean(customControls?.customDesktopControls?.length);
    const videoSrc = (0, $5FkrB.useMemo)(()=>orangeUrl || vimeoUrl || youtubeUrl, [
        orangeUrl,
        vimeoUrl,
        youtubeUrl
    ]);
    const playerSource = (0, $5FkrB.useMemo)(()=>({
            type: "video",
            sources: [
                {
                    src: videoSrc
                }
            ],
            tracks: [
                {
                    kind: "captions",
                    label: "English",
                    srcLang: "en",
                    src: captions,
                    default: true
                }
            ]
        }), [
        videoSrc,
        captions
    ]);
    const playerOptions = (0, $5FkrB.useMemo)(()=>({
            invertTime: false,
            tooltips: {
                controls: true,
                seek: true
            },
            controls: desktopControls,
            quality: {
                default: 1080,
                options: [
                    1080,
                    720,
                    576,
                    480,
                    360,
                    240
                ]
            },
            markers: {
                enabled: true,
                points: chapters
            },
            preload: preload
        }), [
        desktopControls,
        chapters,
        preload
    ]);
    const playerOptionsMobile = (0, $5FkrB.useMemo)(()=>({
            invertTime: false,
            tooltips: {
                controls: controls,
                seek: true
            },
            controls: controls ? mobileControls : [],
            quality: {
                default: 1080,
                options: [
                    1080,
                    720,
                    576,
                    480,
                    360,
                    240
                ]
            },
            markers: {
                enabled: true,
                points: chapters
            },
            preload: preload
        }), [
        controls,
        mobileControls,
        chapters,
        preload
    ]);
    const addEvents = (0, $5FkrB.useCallback)((instance)=>{
        instance.once("loadeddata", ()=>{
            const addEvent = (event)=>instance.on(event, ()=>onControlClick && onControlClick(event));
            addEvent("play");
            addEvent("pause");
            addEvent("captionsenabled");
            addEvent("captionsdisabled");
        });
        instance.on("timeupdate", ()=>{
            const currentTime = instance.currentTime;
            const duration = instance.duration;
            const percentage = currentTime / duration * 100;
            onProgressUpdate && onProgressUpdate(+percentage.toFixed(2), name, videoId);
        });
        if (onError) instance.on("error", onError);
    }, [
        onControlClick,
        onProgressUpdate,
        onError,
        name,
        videoId
    ]);
    (0, $5FkrB.useEffect)(()=>{
        // ✅ Destroy old player before creating new one
        const destroyPlayer = ()=>{
            if (playerRef.current) {
                playerRef.current.destroy();
                playerRef.current = null;
            }
        };
        const initializePlayer = ()=>{
            if (!videoRef.current) return;
            destroyPlayer(); // ✅ Clean up first
            const isMobileSize = hasResponsiveControls ? window.innerWidth >= $fc6840133e04adc0$var$$764442aba3de2fce$var$LEARNING_PAGE_CUSTOM_PLAYER_WIDTH : window.innerWidth <= $fc6840133e04adc0$var$$764442aba3de2fce$var$MOBILE_SCREEN_WIDTH;
            const player = new (0, (/*@__PURE__*/$parcel$interopDefault($1c94bc9aa532188d$exports)))(videoRef.current, isMobileSize ? playerOptionsMobile : playerOptions);
            player.source = playerSource;
            player.poster = poster;
            addEvents(player);
            playerRef.current = player; // ✅ Store reference
            const plyrVideoContainers = document.getElementsByClassName("plyr--video");
            if (plyrVideoContainers.length) Array.from(plyrVideoContainers).forEach((el)=>el.role = "presentation");
        };
        const handleResize = ()=>{
            initializePlayer();
        };
        window.addEventListener("resize", handleResize);
        initializePlayer();
        return ()=>{
            window.removeEventListener("resize", handleResize);
            destroyPlayer();
        };
    }, [
        hasResponsiveControls,
        playerOptions,
        playerOptionsMobile,
        playerSource,
        poster,
        addEvents
    ]);
    if (videoSrc === vimeoUrl) return (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("iframe", {
        role: "region",
        "aria-label": "Video player",
        title: "video",
        // eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex -- iframe needs tabIndex for keyboard access
        tabIndex: 0,
        css: (0, $74Zh5.css)({
            backgroundColor: "transparent",
            width: "100%",
            aspectRatio: "16 / 9",
            ":focus-visible": {
                border: `2px solid ${(0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.border.selected")}`
            }
        }),
        src: vimeoUrl,
        allowFullScreen: true,
        allow: "autoplay"
    });
    else if (videoSrc === youtubeUrl) return (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("iframe", {
        role: "region",
        "aria-label": "Video player",
        title: "video",
        // eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex -- iframe needs tabIndex for keyboard access
        tabIndex: 0,
        css: (0, $74Zh5.css)({
            backgroundColor: "transparent",
            width: "100%",
            aspectRatio: "16 / 9",
            ":focus-visible": {
                border: `2px solid ${(0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.border.selected")}`
            }
        }),
        src: youtubeUrl,
        allowFullScreen: true,
        allow: "autoplay"
    });
    return (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
        css: [
            $fc6840133e04adc0$var$$764442aba3de2fce$var$videoPlayerStyles,
            hasCustomDesktopControls && $fc6840133e04adc0$var$$764442aba3de2fce$var$unsetVolumeWidthStyles
        ],
        children: (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("video", {
            tabIndex: 0,
            ref: videoRef,
            width: width,
            height: height,
            controls: controls,
            crossOrigin: "anonymous",
            title: "video",
            preload: preload,
            children: [
                (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("source", {
                    src: videoSrc,
                    type: "video/mp4"
                }),
                (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("track", {
                    src: captions,
                    kind: "captions",
                    label: "captions",
                    srcLang: "en",
                    default: true
                })
            ]
        })
    });
};
const $fc6840133e04adc0$var$$764442aba3de2fce$var$videoPlayerStyles = (0, $74Zh5.css)({
    ".plyr__time": {
        fontSize: "12px !important",
        fontWeight: "600 !important"
    },
    "--plyr-color-main": "#1D7AFC",
    "--plyr-badge-background": (0, $d568d81ef5c2bf7a$export$7d61b15e0da132af),
    "--plyr-audio-control-color": (0, $d568d81ef5c2bf7a$export$7d61b15e0da132af),
    "--plyr-menu-color": (0, $d568d81ef5c2bf7a$export$7d61b15e0da132af),
    "--plyr-menu-item-arrow-color": "#758195",
    "--plyr-menu-border-color": "#DCDFE4",
    "--plyr-tooltip-color": (0, $d568d81ef5c2bf7a$export$7d61b15e0da132af),
    ":focus-visible": {
        border: `2px solid ${(0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.border.selected")}`
    }
});
const $fc6840133e04adc0$var$$764442aba3de2fce$var$unsetVolumeWidthStyles = (0, $74Zh5.css)({
    ".plyr__controls__item.plyr__volume": {
        minWidth: "unset !important",
        width: "unset !important"
    }
});
var $fc6840133e04adc0$var$$77282b3961d82199$exports = {};
$fc6840133e04adc0$var$$parcel$export($fc6840133e04adc0$var$$77282b3961d82199$exports, "Columns", ()=>$fc6840133e04adc0$export$f02cc02ad0e0bba3);
$fc6840133e04adc0$var$$parcel$export($fc6840133e04adc0$var$$77282b3961d82199$exports, "LessonColumns", ()=>$fc6840133e04adc0$export$2dde675552f76fc5);
let $fc6840133e04adc0$export$f02cc02ad0e0bba3;
(function(Columns) {
    Columns["TWO"] = "two";
    Columns["THREE"] = "three";
    Columns["FOUR"] = "four";
})($fc6840133e04adc0$export$f02cc02ad0e0bba3 || ($fc6840133e04adc0$export$f02cc02ad0e0bba3 = {}));
const $fc6840133e04adc0$export$2dde675552f76fc5 = ({ columns: columns = $fc6840133e04adc0$export$f02cc02ad0e0bba3.TWO, children: children })=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("section", {
        css: $fc6840133e04adc0$var$$77282b3961d82199$var$sectionStyles,
        children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
            "data-testid": "lesson-columns",
            css: [
                $fc6840133e04adc0$var$$77282b3961d82199$var$lessonColumnsStyles,
                $fc6840133e04adc0$var$$77282b3961d82199$var$lessonColumnsMDStyles[columns]
            ],
            children: children
        })
    });
const $fc6840133e04adc0$var$$77282b3961d82199$var$sectionStyles = (0, $74Zh5.css)({
    textOverflow: "ellipsis",
    marginTop: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.400"),
    marginBottom: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.400"),
    [(0, $0bc19dfefbafca8c$export$987d49ffe1b0900f).above.lg]: {
        textOverflow: "clip"
    }
});
const $fc6840133e04adc0$var$$77282b3961d82199$var$lessonColumnsStyles = (0, $74Zh5.css)({
    display: "grid",
    columnGap: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.100"),
    gridTemplateColumns: "repeat(1, minmax(0, 1fr))",
    fontSize: "16px",
    [(0, $0bc19dfefbafca8c$export$987d49ffe1b0900f).above.xs]: {
        gridTemplateColumns: "repeat(2, minmax(0, 1fr))"
    }
});
const $fc6840133e04adc0$var$$77282b3961d82199$var$lessonColumnsMDStyles = {
    [$fc6840133e04adc0$export$f02cc02ad0e0bba3.TWO]: (0, $74Zh5.css)({
        [(0, $0bc19dfefbafca8c$export$987d49ffe1b0900f).above.sm]: {
            gridTemplateColumns: "repeat(2, minmax(0, 1fr))"
        }
    }),
    [$fc6840133e04adc0$export$f02cc02ad0e0bba3.THREE]: (0, $74Zh5.css)({
        [(0, $0bc19dfefbafca8c$export$987d49ffe1b0900f).above.sm]: {
            gridTemplateColumns: "repeat(3, minmax(0, 1fr))"
        }
    }),
    [$fc6840133e04adc0$export$f02cc02ad0e0bba3.FOUR]: (0, $74Zh5.css)({
        [(0, $0bc19dfefbafca8c$export$987d49ffe1b0900f).above.sm]: {
            gridTemplateColumns: "repeat(4, minmax(0, 1fr))"
        }
    })
};
var $fc6840133e04adc0$var$$4c35f7fd4ad5f13f$exports = {};
$fc6840133e04adc0$var$$parcel$export($fc6840133e04adc0$var$$4c35f7fd4ad5f13f$exports, "LearningCourseCard", ()=>$fc6840133e04adc0$export$5ae3342de8088f07);
const $fc6840133e04adc0$export$5ae3342de8088f07 = ({ inspectMode: inspectMode, title: title, imageUrl: imageUrl, onClick: onClick, link: link, minHeight: minHeight = 153, learningProgress: learningProgress, onGeneratePdf: onGeneratePdf, shouldDisplayShowMoreButton: shouldDisplayShowMoreButton, shouldDisplayBookmark: shouldDisplayBookmark, onViewUpdates: onViewUpdates, onUpdatedButtonClick: onUpdatedButtonClick, isUpdated: isUpdated, areHistoricalNotifications: areHistoricalNotifications })=>{
    const cardRef = (0, $5FkrB.useRef)(null);
    const onClickHandler = (0, $5FkrB.useCallback)(()=>{
        onClick && onClick();
    }, [
        onClick
    ]);
    const handleUpdatedButtonClick = (0, $5FkrB.useCallback)((event)=>{
        event.stopPropagation();
        event.preventDefault();
        onUpdatedButtonClick && onUpdatedButtonClick();
    }, [
        onUpdatedButtonClick
    ]);
    const onKeyDown = $fc6840133e04adc0$export$2a0b6757d41dacb2(onClickHandler);
    const handleSave = (event)=>{
        if (learningProgress) {
            event.stopPropagation();
            event.preventDefault();
            learningProgress.onSave(!learningProgress.isSaved);
        }
    };
    const isSaved = learningProgress?.completedResources === learningProgress?.resourceCount || learningProgress?.isSaved;
    return (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("a", {
        href: link,
        css: $fc6840133e04adc0$var$$4c35f7fd4ad5f13f$var$linkContainerStyles,
        rel: "noopener noreferrer",
        onClick: (e)=>e.preventDefault(),
        children: (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
            role: "button",
            ref: cardRef,
            css: $fc6840133e04adc0$var$$4c35f7fd4ad5f13f$var$learningCourseCardContainerStyles,
            onClick: onClickHandler,
            onKeyDown: onKeyDown,
            tabIndex: 0,
            "data-testid": "learning-course-card",
            style: {
                minHeight: `${minHeight}px`
            },
            children: [
                (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                    css: $fc6840133e04adc0$var$$4c35f7fd4ad5f13f$var$bodyContainerStyles,
                    children: [
                        (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                            css: $fc6840133e04adc0$var$$4c35f7fd4ad5f13f$var$imageContainerStyles,
                            children: imageUrl ? (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("img", {
                                css: [
                                    $fc6840133e04adc0$var$$4c35f7fd4ad5f13f$var$imageStyles
                                ],
                                "data-testid": "learning-course-card-image",
                                src: imageUrl,
                                alt: "course-img"
                            }) : (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                                "data-testid": "learning-course-card-no-image",
                                css: $fc6840133e04adc0$var$$4c35f7fd4ad5f13f$var$noImageStyles
                            })
                        }),
                        (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                            css: $fc6840133e04adc0$var$$4c35f7fd4ad5f13f$var$titleAndDetailsContainerStyles,
                            children: title && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("p", {
                                "data-testid": "title",
                                ...$fc6840133e04adc0$export$1784ac302bd8ebad("title", inspectMode),
                                css: $fc6840133e04adc0$var$$4c35f7fd4ad5f13f$var$titleStyles,
                                children: title
                            })
                        })
                    ]
                }),
                learningProgress && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                    css: $fc6840133e04adc0$var$$4c35f7fd4ad5f13f$var$learningCourseCardProgressContainerStyles,
                    "data-testid": "learning-course-card-progress-content",
                    children: (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                        css: $fc6840133e04adc0$var$$4c35f7fd4ad5f13f$var$learningCourseCardProgressItemsContainerStyles,
                        children: [
                            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$export$184a993f673fc83f, {
                                wasPreviouslyCompleted: learningProgress.status === $fc6840133e04adc0$var$$035f8a623e403361$export$23d03d0b3065d061.COMPLETED,
                                completedResources: learningProgress.completedResources,
                                resourceCount: learningProgress.resourceCount,
                                completionDate: learningProgress.completionDate,
                                contentType: $fc6840133e04adc0$export$e2e108cbe2e4f865.COURSE
                            }),
                            (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                                css: $fc6840133e04adc0$var$$4c35f7fd4ad5f13f$var$learningCourseCardIconsContainerStyles,
                                children: [
                                    isUpdated && learningProgress.status !== $fc6840133e04adc0$var$$035f8a623e403361$export$23d03d0b3065d061.NOT_STARTED && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                                        "data-testid": "updated-icon",
                                        css: $fc6840133e04adc0$var$$4c35f7fd4ad5f13f$var$updatedIconContainerStyles,
                                        children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$export$353f5b6fc5456de1, {
                                            label: "Updated",
                                            iconBefore: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$export$f04a61298a47a40f, {
                                                type: "editor-panel"
                                            }),
                                            onClick: handleUpdatedButtonClick
                                        })
                                    }),
                                    shouldDisplayShowMoreButton && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$export$ca7697601dcd7803, {
                                        cardRef: cardRef,
                                        shareOnPdf: true,
                                        onGeneratePdf: onGeneratePdf,
                                        areHistoricalNotifications: areHistoricalNotifications,
                                        onViewUpdates: onViewUpdates
                                    }),
                                    shouldDisplayBookmark && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("button", {
                                        "data-testid": "save-content",
                                        css: $fc6840133e04adc0$var$$4c35f7fd4ad5f13f$var$learningCourseCardBookmarkContainerStyles,
                                        onClick: handleSave,
                                        children: isSaved ? (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$export$f04a61298a47a40f, {
                                            type: "bookmark-filled"
                                        }) : (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$export$f04a61298a47a40f, {
                                            type: "bookmark"
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                })
            ]
        })
    });
};
const $fc6840133e04adc0$var$$4c35f7fd4ad5f13f$var$learningCourseCardContainerStyles = (0, $74Zh5.css)({
    display: "flex",
    flexDirection: "column",
    backgroundColor: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.background.input"),
    borderRadius: "8px",
    border: `1px solid ${(0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.border")}`,
    boxShadow: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("elevation.shadow.raised"),
    transition: "box-shadow 0.3s ease-in-out",
    cursor: "pointer",
    width: "100%",
    height: "153px",
    "&:hover": {
        boxShadow: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("elevation.shadow.overlay")
    },
    "&:active": {
        outline: `1px solid ${(0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.border.focused")}`,
        border: `1px solid ${(0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.border.focused")}`
    }
});
const $fc6840133e04adc0$var$$4c35f7fd4ad5f13f$var$bodyContainerStyles = (0, $74Zh5.css)({
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    padding: `${(0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.200")} ${(0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.300")} ${(0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.200")} ${(0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.075")}`,
    gap: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.200"),
    minHeight: "96px",
    justifyContent: "flex-end",
    "@media (max-width: 1279px)": {
        justifyContent: "flex-start",
        padding: `${(0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.050")} ${(0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.050")} ${(0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.050")} ${(0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.200")}`
    }
});
const $fc6840133e04adc0$var$$4c35f7fd4ad5f13f$var$linkContainerStyles = (0, $74Zh5.css)({
    textDecoration: "none",
    "&:hover": {
        textDecoration: "none"
    }
});
const $fc6840133e04adc0$var$$4c35f7fd4ad5f13f$var$imageContainerStyles = (0, $74Zh5.css)({
    display: "flex",
    width: "64px",
    height: "64px",
    justifyContent: "center",
    alignItems: "center",
    flexShrink: 0
});
const $fc6840133e04adc0$var$$4c35f7fd4ad5f13f$var$imageStyles = (0, $74Zh5.css)({
    width: "100%",
    height: "100%",
    objectFit: "cover",
    borderRadius: "50%"
});
const $fc6840133e04adc0$var$$4c35f7fd4ad5f13f$var$noImageStyles = (0, $74Zh5.css)({
    background: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.background.accent.gray.subtlest"),
    width: "64px",
    height: "64px",
    borderRadius: "50%"
});
const $fc6840133e04adc0$var$$4c35f7fd4ad5f13f$var$titleAndDetailsContainerStyles = (0, $74Zh5.css)({
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    width: "275px",
    "@media (max-width: 1279px)": {
        width: "232px",
        flexGrow: 1,
        padding: `${(0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.300")} ${(0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.200")} ${(0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.300")} ${(0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.0")}`
    }
});
const $fc6840133e04adc0$var$$4c35f7fd4ad5f13f$var$learningCourseCardProgressContainerStyles = (0, $74Zh5.css)({
    borderTop: `1px solid ${(0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.border")}`
});
const $fc6840133e04adc0$var$$4c35f7fd4ad5f13f$var$learningCourseCardProgressItemsContainerStyles = (0, $74Zh5.css)({
    display: "flex",
    justifyContent: "space-between",
    padding: `${(0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.200")} ${(0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.300")}`
});
const $fc6840133e04adc0$var$$4c35f7fd4ad5f13f$var$learningCourseCardIconsContainerStyles = (0, $74Zh5.css)({
    display: "flex",
    alignItems: "center",
    gap: "5px"
});
const $fc6840133e04adc0$var$$4c35f7fd4ad5f13f$var$learningCourseCardBookmarkContainerStyles = (0, $74Zh5.css)({
    height: "24px",
    border: "none",
    background: "none",
    cursor: "pointer",
    outline: "none",
    "&:focus-visible": {
        outline: `2px solid ${(0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.border.selected")}`
    }
});
const $fc6840133e04adc0$var$$4c35f7fd4ad5f13f$var$titleStyles = (0, $74Zh5.css)({
    display: "-webkit-box",
    WebkitBoxOrient: "vertical",
    WebkitLineClamp: 2,
    overflow: "hidden",
    textOverflow: "ellipsis",
    marginTop: "20px",
    marginBottom: 0,
    fontFamily: "Inter",
    fontSize: "16px",
    fontWeight: 400,
    fontStyle: "normal",
    lineHeight: "24px",
    color: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.text")
});
const $fc6840133e04adc0$var$$4c35f7fd4ad5f13f$var$updatedIconContainerStyles = (0, $74Zh5.css)({
    display: "flex",
    alignItems: "center",
    gap: "5px",
    button: {
        backgroundColor: "transparent",
        height: "auto",
        minHeight: "auto",
        alignItems: "center",
        ":hover": {
            backgroundColor: "transparent"
        }
    },
    span: {
        color: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.text.selected"),
        fontFamily: "SF Pro, sans-serif",
        fontSize: "14px",
        lineHeight: "20px"
    }
});
var $fc6840133e04adc0$var$$27d686e47ff412fd$exports = {};
$fc6840133e04adc0$var$$parcel$export($fc6840133e04adc0$var$$27d686e47ff412fd$exports, "FeedbackHeader", ()=>$fc6840133e04adc0$export$41cd510048068b0c);
const $fc6840133e04adc0$export$41cd510048068b0c = ({ heading: heading, duration: duration, description: description })=>(0, $6bec4f26b2cb3094$export$25062201e9e25d76)("section", {
        "aria-labelledby": "feedback-header",
        children: [
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                css: $fc6840133e04adc0$var$$27d686e47ff412fd$var$headingWrapperStyles,
                children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("h1", {
                    css: $fc6840133e04adc0$var$$27d686e47ff412fd$var$headingStyles,
                    id: "feedback-header",
                    children: heading
                })
            }),
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                css: $fc6840133e04adc0$var$$27d686e47ff412fd$var$metadataStyles,
                children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                    css: $fc6840133e04adc0$var$$27d686e47ff412fd$var$flexContainerStyles,
                    children: (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                        css: (0, $74Zh5.css)({
                            display: "flex"
                        }),
                        children: [
                            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                                css: $fc6840133e04adc0$var$$27d686e47ff412fd$var$tagStyles,
                                children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$export$3288d34c523a1192, {
                                    label: duration
                                })
                            }),
                            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                                css: $fc6840133e04adc0$var$$27d686e47ff412fd$var$tagStyles,
                                children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$export$3288d34c523a1192, {
                                    label: "survey"
                                })
                            })
                        ]
                    })
                })
            }),
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                css: $fc6840133e04adc0$var$$27d686e47ff412fd$var$lineWrapperStyles,
                children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$export$2e0a83ec2e27ecbb, {
                    color: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.border")
                })
            }),
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                css: $fc6840133e04adc0$var$$27d686e47ff412fd$var$descriptionStyles,
                children: description
            })
        ]
    });
const $fc6840133e04adc0$var$$27d686e47ff412fd$var$metadataStyles = (0, $74Zh5.css)({
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between"
});
const $fc6840133e04adc0$var$$27d686e47ff412fd$var$flexContainerStyles = (0, $74Zh5.css)({
    display: "flex"
});
const $fc6840133e04adc0$var$$27d686e47ff412fd$var$tagStyles = (0, $74Zh5.css)({
    marginRight: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.100")
});
const $fc6840133e04adc0$var$$27d686e47ff412fd$var$lineWrapperStyles = (0, $74Zh5.css)({
    padding: `${(0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.300")} 0 ${(0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.500")} 0`
});
const $fc6840133e04adc0$var$$27d686e47ff412fd$var$headingWrapperStyles = (0, $74Zh5.css)({
    padding: `${(0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.1000")} 0 ${(0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.300")} 0`
});
const $fc6840133e04adc0$var$$27d686e47ff412fd$var$headingStyles = (0, $74Zh5.css)({
    color: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.text"),
    fontFamily: "Charlie Display, sans-serif",
    fontSize: "61.333px",
    fontStyle: "normal",
    fontWeight: 600,
    lineHeight: "81.778px"
});
const $fc6840133e04adc0$var$$27d686e47ff412fd$var$descriptionStyles = (0, $74Zh5.css)({
    paddingBottom: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.1000"),
    fontFamily: "Inter, sans-serif",
    fontSize: "20px",
    lineHeight: "32px",
    color: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.text"),
    p: {
        margin: 0
    }
});
var $fc6840133e04adc0$var$$a4deb03146bf3bfc$exports = {};
$fc6840133e04adc0$var$$parcel$export($fc6840133e04adc0$var$$a4deb03146bf3bfc$exports, "ReportIssueModal", ()=>$fc6840133e04adc0$export$448811829c5d1992);
let $fc6840133e04adc0$var$$a4deb03146bf3bfc$var$DialogWidth;
(function(DialogWidth) {
    DialogWidth["SMALL"] = "small";
    DialogWidth["MEDIUM"] = "medium";
    DialogWidth["LARGE"] = "large";
    DialogWidth["XLARGE"] = "x-large";
})($fc6840133e04adc0$var$$a4deb03146bf3bfc$var$DialogWidth || ($fc6840133e04adc0$var$$a4deb03146bf3bfc$var$DialogWidth = {}));
const $fc6840133e04adc0$export$448811829c5d1992 = ({ isParticipatingInResearch: isParticipatingInResearch, consentToContact: consentToContact, selectValue: selectValue, textAreaValues: textAreaValues, heading: heading, width: width = $fc6840133e04adc0$var$$a4deb03146bf3bfc$var$DialogWidth.LARGE, options: options, isDisabled: isDisabled, closeModal: closeModal, submit: submit, onSelectChange: onSelectChange, onTextChange: onTextChange, onParticipatingInResearch: onParticipatingInResearch, onConsentToContact: onConsentToContact })=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $9406e400bdd02ea1$export$2e2bcd8739ae039), {
        onClose: closeModal,
        width: width,
        children: (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
            css: $fc6840133e04adc0$var$$a4deb03146bf3bfc$var$modalContainerStyles,
            children: [
                (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                    css: $fc6840133e04adc0$var$$a4deb03146bf3bfc$var$modalBodyStyles,
                    children: [
                        (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("p", {
                            "data-testid": "modal-heading",
                            css: $fc6840133e04adc0$var$$a4deb03146bf3bfc$var$modalHeadingContainerStyles,
                            children: heading
                        }),
                        (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("p", {
                            css: $fc6840133e04adc0$var$$a4deb03146bf3bfc$var$requiredFieldsStyles,
                            children: [
                                "Required fields are marked with an asterisk",
                                " ",
                                (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("span", {
                                    css: [
                                        $fc6840133e04adc0$var$$a4deb03146bf3bfc$var$requiredFieldsStyles,
                                        (0, $74Zh5.css)({
                                            color: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.text.accent.red")
                                        })
                                    ],
                                    children: "*"
                                })
                            ]
                        }),
                        (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                            css: (0, $74Zh5.css)({
                                marginBottom: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.050")
                            }),
                            children: (0, $6bec4f26b2cb3094$export$25062201e9e25d76)((0, $e6c825ca43fa4ec5$export$b04be29aa201d4f5), {
                                htmlFor: "problem-to-report",
                                children: [
                                    "What problem would you like to report? ",
                                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("span", {
                                        css: (0, $74Zh5.css)({
                                            color: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.text.accent.red")
                                        }),
                                        children: "*"
                                    })
                                ]
                            })
                        }),
                        (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                            css: $fc6840133e04adc0$var$$a4deb03146bf3bfc$var$selectContainerStyles,
                            children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $f7c144361eb4a177$export$2e2bcd8739ae039), {
                                inputId: "problem-to-report",
                                options: options,
                                value: selectValue,
                                onChange: (e)=>onSelectChange(e),
                                placeholder: "Select problem"
                            })
                        }),
                        selectValue && (0, $6bec4f26b2cb3094$export$25062201e9e25d76)((0, $6bec4f26b2cb3094$export$ffb0004e005737fa), {
                            children: [
                                (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                                    css: (0, $74Zh5.css)({
                                        marginBottom: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.050")
                                    }),
                                    children: (0, $6bec4f26b2cb3094$export$25062201e9e25d76)((0, $e6c825ca43fa4ec5$export$b04be29aa201d4f5), {
                                        htmlFor: "problem-to-report",
                                        children: [
                                            "Provide any other details ",
                                            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("span", {
                                                css: (0, $74Zh5.css)({
                                                    color: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.text.accent.red")
                                                }),
                                                children: "*"
                                            })
                                        ]
                                    })
                                }),
                                (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                                    css: $fc6840133e04adc0$var$$a4deb03146bf3bfc$var$detailsStyles,
                                    children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $195b49e60159a439$export$2e2bcd8739ae039), {
                                        maxHeight: "156px",
                                        placeholder: "Start typing...",
                                        onChange: onTextChange,
                                        value: textAreaValues
                                    })
                                }),
                                (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                                    css: (0, $74Zh5.css)({
                                        marginBottom: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.100")
                                    }),
                                    children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$export$48513f6b9f8ce62d, {
                                        label: "I'd like to participate in product research",
                                        onChange: onParticipatingInResearch,
                                        isChecked: isParticipatingInResearch
                                    })
                                }),
                                (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                                    css: $fc6840133e04adc0$var$$a4deb03146bf3bfc$var$policyContainerStyles,
                                    children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$export$48513f6b9f8ce62d, {
                                        label: (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("span", {
                                            children: [
                                                "Yes, Atlassian teams can contact me to learn about my experiences to improve Atlassian products and services. I acknowledge the Atlassian Privacy Policy",
                                                (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$export$a6c7ac8248d6e38a, {
                                                    label: "Atlassian Privacy Policy.",
                                                    target: "_blank",
                                                    link: "https://www.atlassian.com/legal/privacy-policy#what-this-policy-covers",
                                                    onClick: ()=>{
                                                        window.open("https://www.atlassian.com/legal/privacy-policy#what-this-policy-covers", "_blank", "noopener");
                                                    }
                                                })
                                            ]
                                        }),
                                        onChange: onConsentToContact,
                                        isChecked: consentToContact
                                    })
                                })
                            ]
                        })
                    ]
                }),
                (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("span", {
                    css: $fc6840133e04adc0$var$$a4deb03146bf3bfc$var$modalCloseButtonStyles,
                    children: [
                        (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                            css: $fc6840133e04adc0$var$$a4deb03146bf3bfc$var$customButtonWrapperStyles,
                            children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $37328c3a94101dc2$export$2e2bcd8739ae039), {
                                appearance: $fc6840133e04adc0$export$261c9483fc4a455a.SUBTLE,
                                onClick: closeModal,
                                children: "Cancel"
                            })
                        }),
                        (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$export$353f5b6fc5456de1, {
                            label: "Submit",
                            appearance: $fc6840133e04adc0$export$261c9483fc4a455a.PRIMARY,
                            disabled: isDisabled,
                            onClick: submit
                        })
                    ]
                })
            ]
        })
    });
const $fc6840133e04adc0$var$$a4deb03146bf3bfc$var$modalContainerStyles = (0, $74Zh5.css)({
    padding: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.300"),
    [(0, $0bc19dfefbafca8c$export$987d49ffe1b0900f).below.sm]: {
        padding: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.200")
    }
});
const $fc6840133e04adc0$var$$a4deb03146bf3bfc$var$modalHeadingContainerStyles = (0, $74Zh5.css)({
    fontFamily: "Charlie Display, sans-serif",
    fontSize: "24px",
    fontWeight: 600,
    lineHeight: "32px"
});
const $fc6840133e04adc0$var$$a4deb03146bf3bfc$var$requiredFieldsStyles = (0, $74Zh5.css)({
    color: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.text.subtlest"),
    fontFamily: "Inter, sans-serif",
    fontSize: "16px",
    fontWeight: 400,
    lineHeight: "24px",
    marginBottom: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.300")
});
const $fc6840133e04adc0$var$$a4deb03146bf3bfc$var$selectContainerStyles = (0, $74Zh5.css)({
    width: "100%",
    maxWidth: "420px",
    marginBottom: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.300")
});
const $fc6840133e04adc0$var$$a4deb03146bf3bfc$var$detailsStyles = (0, $74Zh5.css)({
    width: "100%",
    marginBottom: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.300")
});
const $fc6840133e04adc0$var$$a4deb03146bf3bfc$var$modalCloseButtonStyles = (0, $74Zh5.css)({
    display: "flex",
    justifyContent: "flex-end",
    [(0, $0bc19dfefbafca8c$export$987d49ffe1b0900f).below.sm]: {
        padding: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.100")
    }
});
const $fc6840133e04adc0$var$$a4deb03146bf3bfc$var$modalBodyStyles = (0, $74Zh5.css)({
    maxWidth: "640px",
    width: "100%",
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    margin: `${(0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.200")} auto 0`,
    [(0, $0bc19dfefbafca8c$export$987d49ffe1b0900f).below.sm]: {
        marginTop: 0
    }
});
const $fc6840133e04adc0$var$$a4deb03146bf3bfc$var$customButtonWrapperStyles = (0, $74Zh5.css)({
    marginRight: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.100"),
    button: {
        height: "100%",
        color: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.text"),
        fontSize: "16px",
        lineHeight: "20px",
        padding: `10px ${(0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.150")}`,
        fontWeight: 600
    }
});
const $fc6840133e04adc0$var$$a4deb03146bf3bfc$var$policyContainerStyles = (0, $74Zh5.css)({
    display: "flex",
    a: {
        marginLeft: "5px"
    }
});
var $fc6840133e04adc0$var$$0ae392c3008c8a3e$exports = {};
$fc6840133e04adc0$var$$parcel$export($fc6840133e04adc0$var$$0ae392c3008c8a3e$exports, "FlatContentCardStyle", ()=>$fc6840133e04adc0$export$f2adaabc3a0295ef);
$fc6840133e04adc0$var$$parcel$export($fc6840133e04adc0$var$$0ae392c3008c8a3e$exports, "FlatContentCardType", ()=>$fc6840133e04adc0$export$8023ea0baf29b8db);
$fc6840133e04adc0$var$$parcel$export($fc6840133e04adc0$var$$0ae392c3008c8a3e$exports, "FlatContentCard", ()=>$fc6840133e04adc0$export$bc8a9d98c2eabbb7);
let $fc6840133e04adc0$export$f2adaabc3a0295ef;
(function(FlatContentCardStyle) {
    FlatContentCardStyle["TALL"] = "tall";
    FlatContentCardStyle["FULL"] = "full";
})($fc6840133e04adc0$export$f2adaabc3a0295ef || ($fc6840133e04adc0$export$f2adaabc3a0295ef = {}));
let $fc6840133e04adc0$export$8023ea0baf29b8db;
(function(FlatContentCardType) {
    FlatContentCardType["ROUND"] = "round";
    FlatContentCardType["SQUARE"] = "square";
    FlatContentCardType["RECTANGLE"] = "rectangle";
    FlatContentCardType["FLEXIBLE"] = "flexible";
})($fc6840133e04adc0$export$8023ea0baf29b8db || ($fc6840133e04adc0$export$8023ea0baf29b8db = {}));
const $fc6840133e04adc0$export$bc8a9d98c2eabbb7 = ({ image: image, title: title, text: text, link: link, linkLabel: linkLabel = "Learn more", style: style = $fc6840133e04adc0$export$f2adaabc3a0295ef.TALL, type: type = $fc6840133e04adc0$export$8023ea0baf29b8db.ROUND, headingLevel: headingLevel, bgColor: bgColor = "initial", onClick: onClick, target: target = "_self", maxWidth: maxWidth, minHeight: minHeight, withElevationBorder: withElevationBorder = false })=>{
    const isSquareOrRectangle = type === $fc6840133e04adc0$export$8023ea0baf29b8db.SQUARE || type === $fc6840133e04adc0$export$8023ea0baf29b8db.RECTANGLE;
    const isFlexible = type === $fc6840133e04adc0$export$8023ea0baf29b8db.FLEXIBLE;
    const roundStyles = image ? $fc6840133e04adc0$var$$0ae392c3008c8a3e$var$variantStyles[style].container.withImage : $fc6840133e04adc0$var$$0ae392c3008c8a3e$var$variantStyles[style].container.withoutImage;
    const additionalContainerStyles = isSquareOrRectangle ? $fc6840133e04adc0$var$$0ae392c3008c8a3e$var$squareTypeStyles.container : isFlexible ? $fc6840133e04adc0$var$$0ae392c3008c8a3e$var$flexibleContainerStyles : roundStyles;
    const defaultHeadingLevel = isSquareOrRectangle ? 3 : 4;
    const rectangleStyles = type === $fc6840133e04adc0$export$8023ea0baf29b8db.RECTANGLE && $fc6840133e04adc0$var$$0ae392c3008c8a3e$var$variantStyles[$fc6840133e04adc0$export$f2adaabc3a0295ef.TALL].container.withImage;
    const handleClick = (title)=>{
        onClick && onClick(title);
    };
    return (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
        css: [
            $fc6840133e04adc0$var$$0ae392c3008c8a3e$var$containerStyles,
            additionalContainerStyles,
            rectangleStyles,
            (0, $74Zh5.css)({
                backgroundColor: bgColor
            }),
            maxWidth && (0, $74Zh5.css)({
                maxWidth: maxWidth
            }),
            isFlexible && minHeight && (0, $74Zh5.css)({
                minHeight: minHeight
            }),
            withElevationBorder && $fc6840133e04adc0$var$$0ae392c3008c8a3e$var$elevationBorderStyles
        ],
        "data-testid": "learn-more-card",
        children: [
            image && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("img", {
                src: image.src,
                alt: image.alt,
                width: isFlexible && image.width ? image.width : undefined,
                height: isFlexible && image.height ? image.height : undefined,
                css: [
                    $fc6840133e04adc0$var$$0ae392c3008c8a3e$var$imageBaseStyles,
                    (isSquareOrRectangle || isFlexible) && $fc6840133e04adc0$var$$0ae392c3008c8a3e$var$imageSquareStyles,
                    isFlexible && $fc6840133e04adc0$var$$0ae392c3008c8a3e$var$imageFlexibleStyles,
                    isFlexible && image.width && image.height && (0, $74Zh5.css)({
                        width: `${image.width}px`,
                        height: `${image.height}px`
                    }),
                    style === $fc6840133e04adc0$export$f2adaabc3a0295ef.FULL && $fc6840133e04adc0$var$$0ae392c3008c8a3e$var$fullStyleImageStyles
                ]
            }),
            (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                css: [
                    $fc6840133e04adc0$var$$0ae392c3008c8a3e$var$contentContainerStyles,
                    isSquareOrRectangle && $fc6840133e04adc0$var$$0ae392c3008c8a3e$var$contentContainerSquareStyles
                ],
                children: [
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                        css: (0, $74Zh5.css)([
                            $fc6840133e04adc0$var$$0ae392c3008c8a3e$var$textStyles,
                            type === $fc6840133e04adc0$export$8023ea0baf29b8db.ROUND && $fc6840133e04adc0$var$$0ae392c3008c8a3e$var$variantStyles[style].heading,
                            isSquareOrRectangle && $fc6840133e04adc0$var$$0ae392c3008c8a3e$var$squareTypeStyles.heading,
                            isFlexible && $fc6840133e04adc0$var$$0ae392c3008c8a3e$var$variantStyles[style].heading
                        ]),
                        children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$export$a8a3e93435678ff9, {
                            level: headingLevel || defaultHeadingLevel,
                            fontWeight: 600,
                            children: title
                        })
                    }),
                    (type === $fc6840133e04adc0$export$8023ea0baf29b8db.ROUND || type === $fc6840133e04adc0$export$8023ea0baf29b8db.RECTANGLE || isFlexible) && text && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                        css: [
                            (0, $74Zh5.css)([
                                $fc6840133e04adc0$var$$0ae392c3008c8a3e$var$textStyles,
                                $fc6840133e04adc0$var$$0ae392c3008c8a3e$var$variantStyles[style].text,
                                $fc6840133e04adc0$var$$0ae392c3008c8a3e$var$textContainerStyles
                            ])
                        ],
                        children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$export$5f1af8db9871e1d6, {
                            children: text
                        })
                    }),
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$export$a6c7ac8248d6e38a, {
                        label: linkLabel,
                        link: link,
                        onClick: ()=>handleClick(title),
                        icon: "arrow-right",
                        fontColor: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.text.brand"),
                        style: $fc6840133e04adc0$export$2b77966d73aefa77.SEMIBOLD,
                        size: $fc6840133e04adc0$export$be4c932f76c19adf.LARGE,
                        target: target
                    })
                ]
            })
        ]
    });
};
const $fc6840133e04adc0$var$$0ae392c3008c8a3e$var$containerStyles = (0, $74Zh5.css)({
    width: "100%",
    display: "flex",
    flexDirection: "column",
    alignItems: "start",
    padding: `${(0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.400")} 0`,
    [(0, $0bc19dfefbafca8c$export$987d49ffe1b0900f).below.sm]: {
        padding: `${(0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.300")} 0`
    }
});
const $fc6840133e04adc0$var$$0ae392c3008c8a3e$var$elevationBorderStyles = (0, $74Zh5.css)({
    border: `1px solid ${(0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.border")}`,
    borderRadius: "8px",
    boxShadow: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("elevation.shadow.raised"),
    transition: "box-shadow 0.3s ease-in-out",
    "&:hover": {
        boxShadow: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("elevation.shadow.overlay")
    }
});
const $fc6840133e04adc0$var$$0ae392c3008c8a3e$var$textStyles = (0, $74Zh5.css)({
    [(0, $0bc19dfefbafca8c$export$987d49ffe1b0900f).above.md]: {
        display: "-webkit-box",
        WebkitBoxOrient: "vertical",
        overflow: "hidden",
        textOverflow: "ellipsis"
    }
});
const $fc6840133e04adc0$var$$0ae392c3008c8a3e$var$imageBaseStyles = (0, $74Zh5.css)({
    height: "80px",
    width: "80px",
    objectFit: "contain",
    borderRadius: "50%",
    marginBottom: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.200"),
    maxWidth: "100%"
});
const $fc6840133e04adc0$var$$0ae392c3008c8a3e$var$imageSquareStyles = (0, $74Zh5.css)({
    borderRadius: 0,
    marginBottom: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.300")
});
const $fc6840133e04adc0$var$$0ae392c3008c8a3e$var$imageFlexibleStyles = (0, $74Zh5.css)({
    maxWidth: "100%",
    objectFit: "contain"
});
const $fc6840133e04adc0$var$$0ae392c3008c8a3e$var$fullStyleImageStyles = (0, $74Zh5.css)({
    width: "100%",
    height: "auto",
    maxHeight: "260px",
    marginBottom: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.500"),
    borderRadius: "initial"
});
const $fc6840133e04adc0$var$$0ae392c3008c8a3e$var$variantStyles = {
    [$fc6840133e04adc0$export$f2adaabc3a0295ef.TALL]: {
        container: {
            withImage: (0, $74Zh5.css)({
                [(0, $0bc19dfefbafca8c$export$987d49ffe1b0900f).above.md]: {
                    height: "352px !important"
                }
            }),
            withoutImage: (0, $74Zh5.css)({
                [(0, $0bc19dfefbafca8c$export$987d49ffe1b0900f).above.md]: {
                    height: "264px !important"
                }
            })
        },
        heading: (0, $74Zh5.css)({
            [(0, $0bc19dfefbafca8c$export$987d49ffe1b0900f).above.md]: {
                WebkitLineClamp: "2"
            }
        }),
        text: (0, $74Zh5.css)({
            [(0, $0bc19dfefbafca8c$export$987d49ffe1b0900f).above.md]: {
                WebkitLineClamp: "3"
            }
        })
    },
    [$fc6840133e04adc0$export$f2adaabc3a0295ef.FULL]: {
        container: {
            withImage: (0, $74Zh5.css)({
                [(0, $0bc19dfefbafca8c$export$987d49ffe1b0900f).above.md]: {
                    height: "auto !important"
                }
            }),
            withoutImage: (0, $74Zh5.css)({
                [(0, $0bc19dfefbafca8c$export$987d49ffe1b0900f).above.md]: {
                    height: "auto !important"
                }
            })
        },
        heading: (0, $74Zh5.css)({
            [(0, $0bc19dfefbafca8c$export$987d49ffe1b0900f).above.md]: {
                WebkitLineClamp: "none"
            }
        }),
        text: (0, $74Zh5.css)({
            [(0, $0bc19dfefbafca8c$export$987d49ffe1b0900f).above.md]: {
                WebkitLineClamp: "none"
            }
        })
    }
};
const $fc6840133e04adc0$var$$0ae392c3008c8a3e$var$squareTypeStyles = {
    container: (0, $74Zh5.css)({
        backgroundColor: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.background.input"),
        padding: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.300"),
        height: "320px",
        width: "324px",
        borderRadius: "8px",
        [(0, $0bc19dfefbafca8c$export$987d49ffe1b0900f).below.md]: {
            minHeight: "360px",
            maxWidth: "unset",
            height: "100%"
        },
        [(0, $0bc19dfefbafca8c$export$987d49ffe1b0900f).below.sm]: {
            minHeight: "264px",
            padding: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.300")
        }
    }),
    heading: (0, $74Zh5.css)({
        marginBottom: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.300")
    })
};
const $fc6840133e04adc0$var$$0ae392c3008c8a3e$var$flexibleContainerStyles = (0, $74Zh5.css)({
    height: "auto",
    padding: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.300"),
    borderRadius: "8px",
    [(0, $0bc19dfefbafca8c$export$987d49ffe1b0900f).below.md]: {
        padding: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.400")
    },
    [(0, $0bc19dfefbafca8c$export$987d49ffe1b0900f).below.sm]: {
        padding: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.300")
    }
});
const $fc6840133e04adc0$var$$0ae392c3008c8a3e$var$contentContainerStyles = (0, $74Zh5.css)({
    marginBottom: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.025"),
    flex: 1,
    display: "flex",
    flexDirection: "column"
});
const $fc6840133e04adc0$var$$0ae392c3008c8a3e$var$contentContainerSquareStyles = (0, $74Zh5.css)({
    justifyContent: "space-between",
    a: {
        fontSize: "20px",
        lineHeight: "24px"
    }
});
const $fc6840133e04adc0$var$$0ae392c3008c8a3e$var$textContainerStyles = (0, $74Zh5.css)({
    marginTop: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.100"),
    marginBottom: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.400"),
    [(0, $0bc19dfefbafca8c$export$987d49ffe1b0900f).below.sm]: {
        marginBottom: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.300")
    }
});
var $fc6840133e04adc0$var$$205ed41b47d90e33$exports = {};
$fc6840133e04adc0$var$$parcel$export($fc6840133e04adc0$var$$205ed41b47d90e33$exports, "RelatedResourcesPanel", ()=>$fc6840133e04adc0$export$3775cdf183cb8274);
const $fc6840133e04adc0$var$$205ed41b47d90e33$var$ResourceItem = ({ title: title, slug: slug, onResourceClick: onResourceClick })=>{
    const handleClick = (0, $5FkrB.useCallback)(()=>onResourceClick(slug), [
        slug,
        onResourceClick
    ]);
    const onKeyDown = $fc6840133e04adc0$export$2a0b6757d41dacb2(handleClick);
    return (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
        role: "button",
        tabIndex: 0,
        css: $fc6840133e04adc0$var$$205ed41b47d90e33$var$resourceStyles,
        onClick: handleClick,
        onKeyDown: onKeyDown,
        children: title
    });
};
const $fc6840133e04adc0$export$3775cdf183cb8274 = ({ title: title, resources: resources, onResourceClick: onResourceClick, onButtonClick: onButtonClick })=>{
    const [isOpen, setIsOpen] = (0, $5FkrB.useState)(false);
    const handleButtonClick = (0, $5FkrB.useCallback)(()=>{
        setIsOpen(!isOpen);
        onButtonClick && onButtonClick();
    }, [
        isOpen,
        onButtonClick
    ]);
    const onKeyDownPanel = $fc6840133e04adc0$export$2a0b6757d41dacb2(handleButtonClick);
    return (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
        role: "button",
        tabIndex: 0,
        "data-testid": "related-resources-panel",
        css: $fc6840133e04adc0$var$$205ed41b47d90e33$var$relatedResourcesPanelStyles,
        onClick: handleButtonClick,
        onKeyDown: onKeyDownPanel,
        children: [
            (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                "data-testid": "related-resources-header",
                css: $fc6840133e04adc0$var$$205ed41b47d90e33$var$headerStyles,
                children: [
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$export$a8a3e93435678ff9, {
                        level: 6,
                        children: title
                    }),
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $744d288f60bb77dd$export$2e2bcd8739ae039), {
                        appearance: "subtle",
                        icon: isOpen ? (0, (/*@__PURE__*/$parcel$interopDefault($133983fce38e52e1$exports))) : (0, (/*@__PURE__*/$parcel$interopDefault($338f005fcf21bc2f$exports))),
                        label: isOpen ? "Collapse" : "Expand"
                    })
                ]
            }),
            isOpen && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("ul", {
                "data-testid": "related-resources-list",
                css: $fc6840133e04adc0$var$$205ed41b47d90e33$var$resourcesListStyles,
                children: resources.map(({ title: title, slug: slug })=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("li", {
                        "data-testid": `related-resource-item-${slug}`,
                        children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$var$$205ed41b47d90e33$var$ResourceItem, {
                            title: title,
                            slug: slug,
                            onResourceClick: onResourceClick
                        })
                    }, slug))
            })
        ]
    });
};
const $fc6840133e04adc0$var$$205ed41b47d90e33$var$relatedResourcesPanelStyles = (0, $74Zh5.css)({
    display: "flex",
    flexDirection: "column",
    borderRadius: "8px",
    padding: `${(0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.150")} ${(0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.200")}`,
    boxShadow: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("elevation.shadow.overlay"),
    cursor: "pointer",
    backgroundColor: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.background.input.pressed")
});
const $fc6840133e04adc0$var$$205ed41b47d90e33$var$headerStyles = (0, $74Zh5.css)({
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    color: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.text")
});
const $fc6840133e04adc0$var$$205ed41b47d90e33$var$resourcesListStyles = (0, $74Zh5.css)({
    display: "flex",
    flexDirection: "column",
    margin: 0,
    paddingLeft: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.250"),
    gap: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.050"),
    marginTop: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.150")
});
const $fc6840133e04adc0$var$$205ed41b47d90e33$var$resourceStyles = (0, $74Zh5.css)({
    color: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.link"),
    fontWeight: 400,
    fontSize: "14px",
    lineHeight: "20px",
    cursor: "pointer",
    "&:hover": {
        textDecoration: "underline"
    }
});
var $fc6840133e04adc0$var$$3c691af970e2b3d8$exports = {};
$fc6840133e04adc0$var$$parcel$export($fc6840133e04adc0$var$$3c691af970e2b3d8$exports, "ThumbType", ()=>$fc6840133e04adc0$export$e1c6e381de15460b);
$fc6840133e04adc0$var$$parcel$export($fc6840133e04adc0$var$$3c691af970e2b3d8$exports, "FeedbackButtonType", ()=>$fc6840133e04adc0$export$8eec558e14651de4);
$fc6840133e04adc0$var$$parcel$export($fc6840133e04adc0$var$$3c691af970e2b3d8$exports, "THUMBS_UP_FEEDBACK_OPTIONS", ()=>$fc6840133e04adc0$export$3e6d4d99e8c08756);
$fc6840133e04adc0$var$$parcel$export($fc6840133e04adc0$var$$3c691af970e2b3d8$exports, "THUMBS_DOWN_FEEDBACK_OPTIONS", ()=>$fc6840133e04adc0$export$592a942fdddb4b1a);
$fc6840133e04adc0$var$$parcel$export($fc6840133e04adc0$var$$3c691af970e2b3d8$exports, "QuickFeedback", ()=>$fc6840133e04adc0$export$c6f2bf448101d429);
let $fc6840133e04adc0$export$e1c6e381de15460b;
(function(ThumbType) {
    ThumbType["THUMB_UP"] = "thumb-up";
    ThumbType["THUMB_DOWN"] = "thumb-down";
})($fc6840133e04adc0$export$e1c6e381de15460b || ($fc6840133e04adc0$export$e1c6e381de15460b = {}));
let $fc6840133e04adc0$export$8eec558e14651de4;
(function(FeedbackButtonType) {
    FeedbackButtonType["DISMISS"] = "dismiss";
    FeedbackButtonType["SUBMIT"] = "submit";
})($fc6840133e04adc0$export$8eec558e14651de4 || ($fc6840133e04adc0$export$8eec558e14651de4 = {}));
const $fc6840133e04adc0$export$3e6d4d99e8c08756 = [
    "It was easy to understand",
    "I learned something useful",
    "It was engaging",
    "It improved my confidence in the subject",
    "Other"
];
const $fc6840133e04adc0$export$592a942fdddb4b1a = [
    "It wasn\u2019t clear",
    "It wasn\u2019t accurate",
    "I didn\u2019t learn what I wanted to know",
    "Other"
];
const $fc6840133e04adc0$export$c6f2bf448101d429 = ({ onSubmitFeedback: onSubmitFeedback, onChangeThoughts: onChangeThoughts, onChangeOption: onChangeOption, onThumbClick: onThumbClick, shouldShowDivider: shouldShowDivider = true, buttonText: buttonText = "How was this lesson?" })=>{
    const [isPopupOpened, setIsPopupOpened] = (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).useState({
        isOpen: false,
        thumbType: null
    });
    const [selectedOption, setSelectedOption] = (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).useState("");
    const [selectedThumb, setSelectedThumb] = (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).useState(null);
    const handleThumbClick = (thumbType)=>{
        if (selectedThumb !== thumbType) {
            setSelectedOption("");
            onChangeOption("");
            onChangeThoughts({
                target: {
                    value: ""
                }
            });
        }
        setIsPopupOpened({
            isOpen: true,
            thumbType: thumbType
        });
        setSelectedThumb(thumbType);
        onThumbClick(thumbType);
    };
    const toggleAnswer = (option)=>{
        setSelectedOption(option);
        onChangeOption(option);
    };
    const getOptionStatus = (option)=>selectedOption === option;
    const handleChangeThoughts = (0, $5FkrB.useCallback)((e)=>{
        e.preventDefault();
        if (onChangeThoughts) onChangeThoughts(e);
    }, [
        onChangeThoughts
    ]);
    const handleSubmitFeedback = ()=>{
        setIsPopupOpened({
            isOpen: false,
            thumbType: null
        });
        onSubmitFeedback($fc6840133e04adc0$export$8eec558e14651de4.SUBMIT);
    };
    const handleDismissFeedback = ()=>{
        setIsPopupOpened({
            isOpen: false,
            thumbType: null
        });
        setSelectedOption("");
        onChangeThoughts({
            target: {
                value: ""
            }
        });
        onChangeOption("");
        onSubmitFeedback($fc6840133e04adc0$export$8eec558e14651de4.DISMISS);
    };
    return (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
        "data-testid": "quick-feedback-component",
        css: $fc6840133e04adc0$var$$3c691af970e2b3d8$var$quickFeedbackStyles,
        children: [
            (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                css: $fc6840133e04adc0$var$$3c691af970e2b3d8$var$feedbackContainerStyles,
                children: [
                    (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                        css: $fc6840133e04adc0$var$$3c691af970e2b3d8$var$thumbsContainerStyles,
                        children: [
                            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                                "data-testid": "thumb-down-container",
                                css: [
                                    $fc6840133e04adc0$var$$3c691af970e2b3d8$var$thumbButtonContainerStyles,
                                    selectedThumb === $fc6840133e04adc0$export$e1c6e381de15460b.THUMB_DOWN && {
                                        backgroundColor: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.background.selected")
                                    }
                                ],
                                children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$export$353f5b6fc5456de1, {
                                    tooltip: "Needs improvement",
                                    iconType: "thumb-down",
                                    label: "",
                                    iconBefore: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$export$f04a61298a47a40f, {
                                        type: "thumb-down"
                                    }),
                                    appearance: $fc6840133e04adc0$export$261c9483fc4a455a.ICON,
                                    onClick: ()=>handleThumbClick($fc6840133e04adc0$export$e1c6e381de15460b.THUMB_DOWN)
                                })
                            }),
                            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                                css: [
                                    $fc6840133e04adc0$var$$3c691af970e2b3d8$var$thumbButtonContainerStyles,
                                    selectedThumb === $fc6840133e04adc0$export$e1c6e381de15460b.THUMB_UP && {
                                        backgroundColor: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.background.selected")
                                    }
                                ],
                                "data-testid": "thumb-up-container",
                                children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$export$353f5b6fc5456de1, {
                                    tooltip: "Good",
                                    iconType: "thumb-up",
                                    label: "",
                                    iconBefore: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$export$f04a61298a47a40f, {
                                        type: "thumb-up"
                                    }),
                                    appearance: $fc6840133e04adc0$export$261c9483fc4a455a.ICON,
                                    onClick: ()=>handleThumbClick($fc6840133e04adc0$export$e1c6e381de15460b.THUMB_UP)
                                })
                            })
                        ]
                    }),
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                        "data-testid": "quick-feedback-text",
                        children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$export$a8a3e93435678ff9, {
                            level: 6,
                            color: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.text.subtle"),
                            children: selectedThumb ? "Thanks for your feedback!" : buttonText
                        })
                    })
                ]
            }),
            shouldShowDivider && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                css: $fc6840133e04adc0$var$$3c691af970e2b3d8$var$dividerStyles,
                children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$export$2e0a83ec2e27ecbb, {
                    color: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.border"),
                    height: 2
                })
            }),
            isPopupOpened.isOpen && (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                "data-testid": "popup",
                css: $fc6840133e04adc0$var$$3c691af970e2b3d8$var$popupStyles,
                children: [
                    (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                        children: [
                            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$export$5f1af8db9871e1d6, {
                                size: "small",
                                fontWeight: "semibold",
                                children: "Why did you choose this response?"
                            }),
                            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                                css: $fc6840133e04adc0$var$$3c691af970e2b3d8$var$optionsContentStyles,
                                children: isPopupOpened.thumbType === $fc6840133e04adc0$export$e1c6e381de15460b.THUMB_UP ? $fc6840133e04adc0$export$3e6d4d99e8c08756.map((option)=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                                        css: $fc6840133e04adc0$var$$3c691af970e2b3d8$var$radioContainerStyles,
                                        children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$export$d7b12c4107be0d61, {
                                            setIsChecked: ()=>toggleAnswer(option),
                                            isChecked: getOptionStatus(option),
                                            label: option,
                                            name: "thumb-up"
                                        })
                                    }, option)) : $fc6840133e04adc0$export$592a942fdddb4b1a.map((option)=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                                        css: $fc6840133e04adc0$var$$3c691af970e2b3d8$var$radioContainerStyles,
                                        children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$export$d7b12c4107be0d61, {
                                            setIsChecked: ()=>toggleAnswer(option),
                                            isChecked: getOptionStatus(option),
                                            label: option,
                                            name: "thumb-down"
                                        })
                                    }, option))
                            })
                        ]
                    }),
                    (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                        css: $fc6840133e04adc0$var$$3c691af970e2b3d8$var$feedbackFormStyles,
                        children: [
                            (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                                css: $fc6840133e04adc0$var$$3c691af970e2b3d8$var$inputContainerStyles,
                                children: [
                                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$export$5f1af8db9871e1d6, {
                                        size: "small",
                                        fontWeight: "semibold",
                                        children: "Share your thoughts"
                                    }),
                                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$export$2c73285ae9390cec, {
                                        id: "quick-feedback-input",
                                        placeholder: "Start typing...",
                                        onChange: handleChangeThoughts
                                    }, selectedThumb)
                                ]
                            }),
                            (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                                css: $fc6840133e04adc0$var$$3c691af970e2b3d8$var$buttonsContainerStyles,
                                children: [
                                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$export$353f5b6fc5456de1, {
                                        label: "Dismiss",
                                        appearance: $fc6840133e04adc0$export$261c9483fc4a455a.LINK,
                                        onClick: handleDismissFeedback
                                    }),
                                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$export$353f5b6fc5456de1, {
                                        label: "Submit",
                                        appearance: $fc6840133e04adc0$export$261c9483fc4a455a.PRIMARY,
                                        onClick: handleSubmitFeedback
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
const $fc6840133e04adc0$var$$3c691af970e2b3d8$var$quickFeedbackStyles = (0, $74Zh5.css)({
    position: "relative",
    maxWidth: "720px",
    width: "100%",
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    justifyContent: "center"
});
const $fc6840133e04adc0$var$$3c691af970e2b3d8$var$feedbackContainerStyles = (0, $74Zh5.css)({
    width: "100%",
    display: "flex",
    gap: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.150"),
    alignItems: "center"
});
const $fc6840133e04adc0$var$$3c691af970e2b3d8$var$thumbsContainerStyles = (0, $74Zh5.css)({
    display: "flex",
    gap: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.100")
});
const $fc6840133e04adc0$var$$3c691af970e2b3d8$var$thumbButtonContainerStyles = (0, $74Zh5.css)({
    backgroundColor: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.background.disabled"),
    borderRadius: "3px"
});
const $fc6840133e04adc0$var$$3c691af970e2b3d8$var$dividerStyles = (0, $74Zh5.css)({
    width: "100%",
    margin: `${(0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.400")} 0`
});
const $fc6840133e04adc0$var$$3c691af970e2b3d8$var$popupStyles = (0, $74Zh5.css)({
    position: "absolute",
    bottom: "100px",
    maxWidth: "476px",
    width: "100%",
    padding: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.200"),
    borderRadius: "8px",
    background: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.background.input"),
    boxShadow: `0px 0px 1px 0px rgba(9, 30, 66, 0.31), 0px 1px 1px 0px rgba(9, 30, 66, 0.25)`,
    [(0, $0bc19dfefbafca8c$export$987d49ffe1b0900f).below.sm]: {
        position: "relative",
        bottom: "60px"
    }
});
const $fc6840133e04adc0$var$$3c691af970e2b3d8$var$optionsContentStyles = (0, $74Zh5.css)({
    margin: `${(0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.100")} 0 ${(0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.150")}`
});
const $fc6840133e04adc0$var$$3c691af970e2b3d8$var$radioContainerStyles = (0, $74Zh5.css)({
    marginTop: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.050")
});
const $fc6840133e04adc0$var$$3c691af970e2b3d8$var$feedbackFormStyles = (0, $74Zh5.css)({
    display: "flex",
    flexDirection: "column",
    gap: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.150")
});
const $fc6840133e04adc0$var$$3c691af970e2b3d8$var$inputContainerStyles = (0, $74Zh5.css)({
    display: "flex",
    flexDirection: "column",
    gap: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.050")
});
const $fc6840133e04adc0$var$$3c691af970e2b3d8$var$buttonsContainerStyles = (0, $74Zh5.css)({
    display: "flex",
    justifyContent: "flex-end",
    gap: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.100")
});
var $fc6840133e04adc0$var$$5f9280667c666470$exports = {};
$fc6840133e04adc0$var$$parcel$export($fc6840133e04adc0$var$$5f9280667c666470$exports, "Searchbar", ()=>$fc6840133e04adc0$export$b9f6e7a4c54af1f6);
const $fc6840133e04adc0$var$$9c9ed7a3b666cf11$export$b36c0aa7a63a3911 = ({ item: item, onRemove: onRemove, onSelect: onSelect })=>{
    const deviceSize = $fc6840133e04adc0$export$4616d33c54ae5baf();
    const handleRemoveButton = (e)=>{
        e.stopPropagation();
        onRemove(item);
    };
    const handleItemClick = (0, $5FkrB.useCallback)(()=>{
        onSelect(item);
    }, [
        onSelect,
        item
    ]);
    const handleRemoveKeyboard = (0, $5FkrB.useCallback)(()=>{
        onRemove(item);
    }, [
        onRemove,
        item
    ]);
    const onKeyDownItem = $fc6840133e04adc0$export$2a0b6757d41dacb2(handleItemClick);
    const onKeyDownRemove = $fc6840133e04adc0$export$2a0b6757d41dacb2(handleRemoveKeyboard);
    return (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
        role: "button",
        tabIndex: 0,
        css: $fc6840133e04adc0$var$$9c9ed7a3b666cf11$var$historyItemContainerStyles,
        onClick: handleItemClick,
        onKeyDown: onKeyDownItem,
        "data-testid": "history-item",
        children: [
            (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                css: $fc6840133e04adc0$var$$9c9ed7a3b666cf11$var$historyItemStyles,
                children: [
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$export$f04a61298a47a40f, {
                        type: "emoji-frequent",
                        color: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.icon.subtle")
                    }),
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("span", {
                        css: $fc6840133e04adc0$var$$9c9ed7a3b666cf11$var$itemTextStyles,
                        children: item
                    })
                ]
            }),
            (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                css: [
                    $fc6840133e04adc0$var$$9c9ed7a3b666cf11$var$removeContainerStyles,
                    deviceSize < $fc6840133e04adc0$export$27ed77542911fb0e && (0, $74Zh5.css)({
                        opacity: 1
                    })
                ],
                children: [
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$export$353f5b6fc5456de1, {
                        onClick: handleRemoveButton,
                        label: "",
                        iconBefore: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$export$f04a61298a47a40f, {
                            type: "dropdown-cross",
                            color: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.icon")
                        })
                    }),
                    deviceSize < $fc6840133e04adc0$export$27ed77542911fb0e && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("span", {
                        role: "button",
                        tabIndex: 0,
                        css: $fc6840133e04adc0$var$$9c9ed7a3b666cf11$var$clearButtonStyles,
                        onClick: handleRemoveButton,
                        onKeyDown: onKeyDownRemove,
                        children: "Clear"
                    })
                ]
            })
        ]
    });
};
const $fc6840133e04adc0$var$$9c9ed7a3b666cf11$var$removeContainerStyles = (0, $74Zh5.css)({
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    opacity: 0,
    button: {
        span: {
            margin: "0px !important"
        }
    }
});
const $fc6840133e04adc0$var$$9c9ed7a3b666cf11$var$historyItemContainerStyles = (0, $74Zh5.css)({
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    width: "100%",
    padding: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.050"),
    cursor: "pointer",
    button: {
        backgroundColor: "transparent",
        border: "none",
        padding: 0,
        margin: 0,
        outline: "none",
        "&:hover": {
            backgroundColor: "transparent"
        }
    },
    "&:hover": {
        backgroundColor: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.background.accent.gray.subtlest")
    },
    "&:hover > div:last-child": {
        opacity: 1
    }
});
const $fc6840133e04adc0$var$$9c9ed7a3b666cf11$var$historyItemStyles = (0, $74Zh5.css)({
    display: "flex",
    alignItems: "center",
    gap: "4px"
});
const $fc6840133e04adc0$var$$9c9ed7a3b666cf11$var$itemTextStyles = (0, $74Zh5.css)({
    fontFamily: "Inter, sans-serif",
    fontSize: "14px",
    fontWeight: 400,
    lineHeight: "20px",
    color: `${(0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.text")}`
});
const $fc6840133e04adc0$var$$9c9ed7a3b666cf11$var$clearButtonStyles = (0, $74Zh5.css)({
    color: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.text.subtlest"),
    fontFamily: "Inter, sans-serif",
    fontSize: "12px",
    fontWeight: 400,
    lineHeight: "18px"
});
const $fc6840133e04adc0$var$$2f046e897b352baf$export$ed4de3239e2fb964 = ({ items: items, onRemove: onRemove, onSelect: onSelect })=>{
    if (!items.length) return (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $6bec4f26b2cb3094$export$ffb0004e005737fa), {});
    return (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
        css: $fc6840133e04adc0$var$$2f046e897b352baf$var$historyStyles,
        "data-testid": "history-container",
        children: items.slice(-5).reverse().map((item)=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$var$$9c9ed7a3b666cf11$export$b36c0aa7a63a3911, {
                item: item,
                onRemove: onRemove,
                onSelect: onSelect
            }, item))
    });
};
const $fc6840133e04adc0$var$$2f046e897b352baf$var$historyStyles = (0, $74Zh5.css)({
    position: "absolute",
    display: "flex",
    width: "279px",
    borderRadius: "3px",
    padding: `${(0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.075")} ${(0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.050")}`,
    marginTop: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.075"),
    flexDirection: "column",
    alignItems: "flex-start",
    background: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("elevation.surface.overlay"),
    boxShadow: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("elevation.shadow.overlay"),
    zIndex: 1,
    [(0, $0bc19dfefbafca8c$export$987d49ffe1b0900f).below.md]: {
        width: "327px"
    }
});
const $fc6840133e04adc0$export$b9f6e7a4c54af1f6 = ({ value: value, onChange: onChange, isLoading: isLoading, label: label, isTall: isTall = false })=>{
    const [isHistoryVisible, setIsHistoryVisible] = (0, $5FkrB.useState)(false);
    const [history, setHistory] = (0, $5FkrB.useState)($fc6840133e04adc0$export$7765f5b61937bda1());
    const searchRef = (0, $5FkrB.useRef)(null);
    const deviceSize = $fc6840133e04adc0$export$4616d33c54ae5baf();
    const isRemoveIconVisible = !!value.length && (deviceSize >= $fc6840133e04adc0$export$27ed77542911fb0e || !isLoading);
    (0, $5FkrB.useEffect)(()=>{
        const searchElement = searchRef.current;
        if (!searchElement) return;
        const inputElement = searchElement.querySelector("input");
        if (!inputElement) return;
        const handleFocus = ()=>{
            setIsHistoryVisible(true);
        };
        const handleClickOutside = (event)=>{
            if (searchRef.current && !searchRef.current.contains(event.target)) setIsHistoryVisible(false);
        };
        inputElement.addEventListener("focus", handleFocus);
        document.addEventListener("mousedown", handleClickOutside);
        return ()=>{
            inputElement.removeEventListener("focus", handleFocus);
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);
    const handleRemoveItem = (itemToRemove)=>{
        const newHistory = history.filter((item)=>item !== itemToRemove);
        setHistory(newHistory);
        $fc6840133e04adc0$export$cec0922aa1b64670(newHistory);
    };
    const handleSelectItem = (selectedItem)=>{
        onChange(selectedItem);
        setIsHistoryVisible(false);
    };
    const onKeyDown = (event)=>{
        if (event.key === "Enter" && value.trim()) {
            if (!history.includes(value.trim()) && searchRef.current) {
                const newHistory = [
                    ...history,
                    value.trim()
                ];
                $fc6840133e04adc0$export$cec0922aa1b64670(newHistory);
                const inputElement = searchRef.current.querySelector("input");
                if (inputElement) inputElement.blur();
                setIsHistoryVisible(false);
                setHistory(newHistory);
            }
        }
    };
    const filteredItems = history.filter((item)=>item.toLowerCase().includes(value.toLowerCase()));
    const handleOnChange = (event)=>{
        if (event.target instanceof HTMLInputElement) onChange(event.target.value);
    };
    const onClearSearchClick = ()=>{
        onChange("");
        setIsHistoryVisible(false);
    };
    const onKeyDownClear = $fc6840133e04adc0$export$2a0b6757d41dacb2(onClearSearchClick);
    return (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
        role: "search",
        css: $fc6840133e04adc0$var$$5f9280667c666470$var$searchStyles,
        onKeyDown: onKeyDown,
        tabIndex: 0,
        ref: searchRef,
        children: [
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("span", {
                css: $fc6840133e04adc0$var$$5f9280667c666470$var$searchBeforeIconStyles,
                children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($fefca24f90dbffe4$exports))), {
                    primaryColor: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.text.subtlest"),
                    size: "medium",
                    label: "search icon"
                })
            }),
            !!value.length && isLoading && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("span", {
                "data-testid": "search-loader",
                css: [
                    $fc6840133e04adc0$var$$5f9280667c666470$var$searchAfterIconStyles,
                    $fc6840133e04adc0$var$$5f9280667c666470$var$searchLoaderIconStyles
                ],
                children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $QCI6S.default), {
                    size: "small"
                })
            }),
            isRemoveIconVisible && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("span", {
                role: "button",
                tabIndex: 0,
                css: $fc6840133e04adc0$var$$5f9280667c666470$var$searchAfterIconStyles,
                onClick: onClearSearchClick,
                onKeyDown: onKeyDownClear,
                children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$export$353f5b6fc5456de1, {
                    label: "",
                    size: $fc6840133e04adc0$export$5dd2748b7940a2a0.LARGE,
                    iconBefore: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$export$f04a61298a47a40f, {
                        type: "cross",
                        alt: "cross icon"
                    }),
                    appearance: $fc6840133e04adc0$export$261c9483fc4a455a.ICON
                })
            }),
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("input", {
                placeholder: label ?? (deviceSize < $fc6840133e04adc0$export$27ed77542911fb0e ? "Search" : "Search catalog"),
                value: value,
                onChange: handleOnChange,
                style: isTall ? {
                    paddingTop: "10px",
                    paddingBottom: "10px"
                } : {}
            }),
            isHistoryVisible && history.length > 0 && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$var$$2f046e897b352baf$export$ed4de3239e2fb964, {
                items: filteredItems,
                onRemove: handleRemoveItem,
                onSelect: handleSelectItem
            })
        ]
    });
};
const $fc6840133e04adc0$var$$5f9280667c666470$var$searchStyles = (0, $74Zh5.css)({
    position: "relative",
    width: "100%",
    maxWidth: "240px",
    [(0, $0bc19dfefbafca8c$export$987d49ffe1b0900f).below.md]: {
        maxWidth: "275px"
    },
    [(0, $0bc19dfefbafca8c$export$987d49ffe1b0900f).below.xs]: {
        maxWidth: "100%"
    },
    input: {
        width: "100%",
        minHeight: "32px",
        border: `1px solid ${(0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.border.input")}`,
        borderRadius: "5px !important",
        padding: `0 30px 0 ${(0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.500")}`,
        color: `${(0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.text")} !important`,
        fontSize: "14px",
        fontWeight: 400,
        lineHeight: "20px",
        outline: "none",
        "&::placeholder": {
            color: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.text.subtlest"),
            fontFamily: "SF Pro, sans-serif"
        },
        "&:focus": {
            border: `2px solid ${(0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.border.focused")} !important`
        },
        [(0, $0bc19dfefbafca8c$export$987d49ffe1b0900f).below.md]: {
            height: "40px",
            padding: `10px 30px 10px ${(0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.500")}`
        }
    }
});
const $fc6840133e04adc0$var$$5f9280667c666470$var$searchBeforeIconStyles = (0, $74Zh5.css)({
    position: "absolute",
    left: "10px",
    top: 0,
    height: "100%",
    display: "flex",
    alignItems: "center",
    "[role='img']": {
        width: "20px !important",
        height: "20px !important"
    }
});
const $fc6840133e04adc0$var$$5f9280667c666470$var$searchAfterIconStyles = (0, $74Zh5.css)({
    position: "absolute",
    right: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.100"),
    top: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.050"),
    cursor: "pointer",
    "[role='img']": {
        width: "20px !important",
        height: "20px !important"
    },
    [(0, $0bc19dfefbafca8c$export$987d49ffe1b0900f).below.md]: {
        top: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.100")
    }
});
const $fc6840133e04adc0$var$$5f9280667c666470$var$searchLoaderIconStyles = (0, $74Zh5.css)({
    cursor: "default",
    right: "-24px",
    [(0, $0bc19dfefbafca8c$export$987d49ffe1b0900f).below.md]: {
        top: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.050"),
        right: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.200")
    }
});
var $fc6840133e04adc0$var$$ffad026de847a971$exports = {};
$fc6840133e04adc0$var$$parcel$export($fc6840133e04adc0$var$$ffad026de847a971$exports, "CourseStatus", ()=>$fc6840133e04adc0$export$686d6bd87c227b43);
$fc6840133e04adc0$var$$parcel$export($fc6840133e04adc0$var$$ffad026de847a971$exports, "CourseList", ()=>$fc6840133e04adc0$export$96ebd64c4b8b0cf9);
var $fc6840133e04adc0$var$$45c6e177b24a84f5$require$Buffer = (0, $7KfP5.Buffer);
const $fc6840133e04adc0$var$$45c6e177b24a84f5$var$completedGap = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M6.735 12.322C6.55446 12.13 6.30541 12.0171 6.04201 12.0077C5.77861 11.9983 5.52217 12.0933 5.32844 12.272C5.13471 12.4507 5.01937 12.6987 5.00749 12.962C4.99561 13.2253 5.08815 13.4826 5.265 13.678L8.877 17.597C9.414 18.123 10.214 18.123 10.711 17.627L11.075 17.268C12.3895 15.9753 13.7025 14.6809 15.014 13.385L15.054 13.345C16.2797 12.1371 17.499 10.9228 18.712 9.70205C18.8933 9.51225 18.9927 9.25878 18.9887 8.99634C18.9848 8.73391 18.8778 8.48354 18.6909 8.29926C18.504 8.11499 18.2522 8.01158 17.9897 8.01135C17.7273 8.01113 17.4752 8.1141 17.288 8.29805C16.0807 9.51239 14.8673 10.7207 13.648 11.923L13.608 11.963C12.3513 13.2053 11.0929 14.446 9.833 15.685L6.735 12.322Z" fill="#22A06B"/>
</svg>
`;
const $fc6840133e04adc0$var$$45c6e177b24a84f5$export$29aa8664c658caa9 = `data:image/svg+xml;base64,${$fc6840133e04adc0$var$$45c6e177b24a84f5$require$Buffer.from($fc6840133e04adc0$var$$45c6e177b24a84f5$var$completedGap).toString("base64")}`;
const $fc6840133e04adc0$var$$ffad026de847a971$var$TABLET_SCREEN_WIDTH = 900;
let $fc6840133e04adc0$export$686d6bd87c227b43;
(function(CourseStatus) {
    CourseStatus[/** The course is not started */ "DEFAULT"] = "default";
    CourseStatus[/** The course is in progress */ "IN_PROGRESS"] = "in_progress";
    CourseStatus[/** The course is finished */ "FINISHED"] = "finished";
})($fc6840133e04adc0$export$686d6bd87c227b43 || ($fc6840133e04adc0$export$686d6bd87c227b43 = {}));
const $fc6840133e04adc0$export$96ebd64c4b8b0cf9 = ({ course: course, lessons: lessons, onLessonClick: onLessonClick, onCourseTitleClick: onCourseTitleClick, onCourseButtonClick: onCourseButtonClick })=>{
    const [isOpened, setIsOpened] = (0, $5FkrB.useState)(false);
    const deviceSize = $fc6840133e04adc0$export$4616d33c54ae5baf();
    const numberOfCompletedLessons = lessons.filter((lesson)=>lesson.isCompleted).length;
    const calculateProgress = ()=>{
        if (course.courseStatus === $fc6840133e04adc0$export$686d6bd87c227b43.FINISHED) return 100;
        return numberOfCompletedLessons / lessons.length * 100;
    };
    const isCompleted = calculateProgress() === 100;
    const isTablet = deviceSize <= $fc6840133e04adc0$var$$ffad026de847a971$var$TABLET_SCREEN_WIDTH;
    const toggleLessons = ()=>{
        setIsOpened(!isOpened);
    };
    const getButtonText = (status)=>{
        switch(status){
            case $fc6840133e04adc0$export$686d6bd87c227b43.DEFAULT:
                return "Get started";
            case $fc6840133e04adc0$export$686d6bd87c227b43.IN_PROGRESS:
                return "Continue";
            case $fc6840133e04adc0$export$686d6bd87c227b43.FINISHED:
                return "Review course";
            default:
                return "Get started";
        }
    };
    const handleTitleClick = (0, $5FkrB.useCallback)((event)=>{
        if (onCourseTitleClick) {
            event?.preventDefault();
            onCourseTitleClick();
        }
    }, [
        onCourseTitleClick
    ]);
    const handleButtonClick = (0, $5FkrB.useCallback)((event)=>{
        if (onCourseButtonClick) {
            event?.preventDefault();
            onCourseButtonClick();
        }
    }, [
        onCourseButtonClick
    ]);
    return (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
        css: [
            $fc6840133e04adc0$var$$ffad026de847a971$var$wrapperStyles,
            isOpened ? $fc6840133e04adc0$var$$ffad026de847a971$var$wrapperOpenStyles : $fc6840133e04adc0$var$$ffad026de847a971$var$wrapperClosedStyles,
            isCompleted && $fc6840133e04adc0$var$$ffad026de847a971$var$completedCourseStyles
        ],
        "data-testid": "course-list-container",
        children: [
            (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                "data-testid": `course-card-${course?.slug}`,
                css: $fc6840133e04adc0$var$$ffad026de847a971$var$containerStyles,
                children: [
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                        css: $fc6840133e04adc0$var$$ffad026de847a971$var$progressBadgeContainerStyles,
                        "data-testid": "course-progress-badge",
                        children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                            css: $fc6840133e04adc0$var$$ffad026de847a971$var$customProgressBadgeStyles,
                            children: !isCompleted ? (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $f188eff9b59fb855$export$5ab97151efedb8c6), {
                                strokeWidth: 6,
                                value: calculateProgress(),
                                styles: (0, $f188eff9b59fb855$export$5115a192ad9bf57f)({
                                    pathColor: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.border.success"),
                                    trailColor: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.border")
                                }),
                                "data-testid": "course-progress-circle",
                                children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                                    css: $fc6840133e04adc0$var$$ffad026de847a971$var$imageBadgeContainerStyles,
                                    children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("img", {
                                        src: course.imageUrl,
                                        alt: "Course badge",
                                        css: $fc6840133e04adc0$var$$ffad026de847a971$var$imageStyles,
                                        "data-testid": "course-badge-image"
                                    })
                                })
                            }) : (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                                css: $fc6840133e04adc0$var$$ffad026de847a971$var$completedBadgeContainerStyles,
                                "data-testid": "course-completed-badge",
                                children: [
                                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                                        css: $fc6840133e04adc0$var$$ffad026de847a971$var$imageBadgeContainerStyles,
                                        children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("img", {
                                            src: course.imageUrl,
                                            alt: "Course badge",
                                            css: [
                                                $fc6840133e04adc0$var$$ffad026de847a971$var$imageStyles,
                                                $fc6840133e04adc0$var$$ffad026de847a971$var$completedImageStyles
                                            ],
                                            "data-testid": "course-completed-image"
                                        })
                                    }),
                                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                                        css: $fc6840133e04adc0$var$$ffad026de847a971$var$checkmarkOverlayStyles,
                                        children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("img", {
                                            src: $fc6840133e04adc0$var$$45c6e177b24a84f5$export$29aa8664c658caa9,
                                            alt: "Completed",
                                            css: $fc6840133e04adc0$var$$ffad026de847a971$var$checkmarkIconStyles,
                                            "data-testid": "course-completed-checkmark"
                                        })
                                    })
                                ]
                            })
                        })
                    }),
                    (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                        css: $fc6840133e04adc0$var$$ffad026de847a971$var$contentContainerStyles,
                        "data-testid": "course-content",
                        children: [
                            (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                                css: $fc6840133e04adc0$var$$ffad026de847a971$var$topContentStyles,
                                children: [
                                    (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                                        css: $fc6840133e04adc0$var$$ffad026de847a971$var$durationTitleContainerStyles,
                                        children: [
                                            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                                                css: $fc6840133e04adc0$var$$ffad026de847a971$var$durationTextStyles,
                                                "data-testid": "course-duration",
                                                children: course.duration
                                            }),
                                            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$export$a8a3e93435678ff9, {
                                                level: 5,
                                                children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("a", {
                                                    css: $fc6840133e04adc0$var$$ffad026de847a971$var$titleStyles,
                                                    href: course.href,
                                                    onClick: handleTitleClick,
                                                    "data-testid": "course-title-link",
                                                    children: course.title
                                                })
                                            })
                                        ]
                                    }),
                                    !isTablet && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("a", {
                                        css: $fc6840133e04adc0$var$$ffad026de847a971$var$startCourseButtonStyles,
                                        href: course.href,
                                        onClick: handleButtonClick,
                                        "data-testid": "desktop-course-button",
                                        children: getButtonText(course.courseStatus)
                                    })
                                ]
                            }),
                            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                                css: $fc6840133e04adc0$var$$ffad026de847a971$var$durationTitleContainerStyles,
                                children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("span", {
                                    css: $fc6840133e04adc0$var$$ffad026de847a971$var$subTitleStyles,
                                    "data-testid": "course-subtitle",
                                    children: course.subTitle
                                })
                            })
                        ]
                    })
                ]
            }),
            !isTablet && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                css: [
                    $fc6840133e04adc0$var$$ffad026de847a971$var$buttonContainerStyles,
                    isOpened && $fc6840133e04adc0$var$$ffad026de847a971$var$buttonContainerOpenStyles,
                    !isOpened && $fc6840133e04adc0$var$$ffad026de847a971$var$buttonContainerClosedStyles
                ],
                children: (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("button", {
                    css: $fc6840133e04adc0$var$$ffad026de847a971$var$toggleButtonStyles,
                    onClick: toggleLessons,
                    "data-testid": "toggle-lessons-button",
                    children: [
                        isOpened ? "Hide lessons" : "Show lessons",
                        (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$export$f04a61298a47a40f, {
                            size: "small",
                            type: isOpened ? "chevron-up" : "chevron-down",
                            color: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.text.brand")
                        })
                    ]
                })
            }),
            isOpened && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                css: [
                    $fc6840133e04adc0$var$$ffad026de847a971$var$lessonsContentWrapperStyles,
                    isTablet && $fc6840133e04adc0$var$$ffad026de847a971$var$lessonContentWrapperMobileStyles
                ],
                children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$export$c3b0ae23c563b692, {
                    lessons: lessons,
                    onLessonClick: onLessonClick,
                    isStandalone: false,
                    isTablet: isTablet
                })
            }),
            isTablet && (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                css: [
                    $fc6840133e04adc0$var$$ffad026de847a971$var$buttonContainerStyles,
                    isOpened && $fc6840133e04adc0$var$$ffad026de847a971$var$buttonContainerOpenStyles,
                    !isOpened && $fc6840133e04adc0$var$$ffad026de847a971$var$buttonContainerClosedStyles,
                    $fc6840133e04adc0$var$$ffad026de847a971$var$buttonContainerMobileStyles
                ],
                children: [
                    (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("button", {
                        css: [
                            $fc6840133e04adc0$var$$ffad026de847a971$var$toggleButtonStyles,
                            $fc6840133e04adc0$var$$ffad026de847a971$var$toggleButtonMobileStyles
                        ],
                        onClick: toggleLessons,
                        "data-testid": "toggle-lessons-button-mobile",
                        children: [
                            isOpened ? "Hide lessons" : "Show lessons",
                            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$export$f04a61298a47a40f, {
                                size: "small",
                                type: isOpened ? "chevron-up" : "chevron-down",
                                color: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.text.brand")
                            })
                        ]
                    }),
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("a", {
                        css: $fc6840133e04adc0$var$$ffad026de847a971$var$continueButtonStyles,
                        href: course.href,
                        onClick: handleButtonClick,
                        "data-testid": "tablet-course-button",
                        children: getButtonText(course.courseStatus)
                    })
                ]
            })
        ]
    });
};
const $fc6840133e04adc0$var$$ffad026de847a971$var$containerStyles = (0, $74Zh5.css)({
    display: "flex",
    padding: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.200"),
    alignItems: "flex-start",
    gap: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.200"),
    alignSelf: "stretch",
    minHeight: "120px",
    backgroundColor: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.background.input"),
    "&:hover a": {
        opacity: 1
    },
    "@media (max-width: 343px)": {
        minHeight: "148px",
        padding: `${(0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.200")} ${(0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.100")}`,
        gap: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.100")
    }
});
const $fc6840133e04adc0$var$$ffad026de847a971$var$progressBadgeContainerStyles = (0, $74Zh5.css)({
    width: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.500"),
    height: "41px",
    flexShrink: 0
});
const $fc6840133e04adc0$var$$ffad026de847a971$var$customProgressBadgeStyles = (0, $74Zh5.css)({
    width: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.500"),
    height: "41px"
});
const $fc6840133e04adc0$var$$ffad026de847a971$var$imageBadgeContainerStyles = (0, $74Zh5.css)({
    width: "100%",
    height: "100%",
    padding: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.100")
});
const $fc6840133e04adc0$var$$ffad026de847a971$var$imageStyles = (0, $74Zh5.css)({
    width: "100%",
    height: "100%",
    objectFit: "contain",
    borderRadius: "50%"
});
const $fc6840133e04adc0$var$$ffad026de847a971$var$completedBadgeContainerStyles = (0, $74Zh5.css)({
    position: "relative",
    width: "100%",
    height: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
});
const $fc6840133e04adc0$var$$ffad026de847a971$var$completedImageStyles = (0, $74Zh5.css)({
    opacity: 0.5,
    filter: "grayscale(100%)"
});
const $fc6840133e04adc0$var$$ffad026de847a971$var$checkmarkOverlayStyles = (0, $74Zh5.css)({
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    zIndex: 1,
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
});
const $fc6840133e04adc0$var$$ffad026de847a971$var$checkmarkIconStyles = (0, $74Zh5.css)({
    width: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.300"),
    height: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.300")
});
const $fc6840133e04adc0$var$$ffad026de847a971$var$contentContainerStyles = (0, $74Zh5.css)({
    display: "flex",
    flexDirection: "column",
    marginRight: "auto",
    flex: 1,
    overflow: "hidden",
    minWidth: 0,
    width: "100%"
});
const $fc6840133e04adc0$var$$ffad026de847a971$var$topContentStyles = (0, $74Zh5.css)({
    display: "flex",
    alignItems: "center",
    gap: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.150"),
    marginBottom: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.050"),
    minWidth: 0,
    width: "100%"
});
const $fc6840133e04adc0$var$$ffad026de847a971$var$durationTitleContainerStyles = (0, $74Zh5.css)({
    display: "flex",
    flexDirection: "column",
    flex: 1,
    overflow: "hidden",
    minWidth: 0,
    width: "100%"
});
const $fc6840133e04adc0$var$$ffad026de847a971$var$titleStyles = (0, $74Zh5.css)({
    color: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.text"),
    fontFamily: "Charlie Display",
    fontSize: "20px",
    fontStyle: "normal",
    margin: 0,
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "normal",
    textDecoration: "none",
    cursor: "pointer",
    lineHeight: "28px",
    fontWeight: 600,
    width: "100%",
    minWidth: 0,
    display: "block",
    maxHeight: "56px",
    wordBreak: "break-word",
    overflowWrap: "break-word",
    "&:hover": {
        textDecoration: "underline",
        color: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.text")
    },
    "@media (max-width: 343px)": {
        fontSize: "16px",
        lineHeight: "24px",
        whiteSpace: "normal",
        overflow: "hidden",
        textOverflow: "ellipsis",
        wordBreak: "break-word",
        overflowWrap: "break-word",
        maxHeight: "48px"
    }
});
const $fc6840133e04adc0$var$$ffad026de847a971$var$startCourseButtonStyles = (0, $74Zh5.css)({
    color: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.text.brand"),
    fontFamily: "Charlie Text",
    fontSize: "16px",
    fontStyle: "normal",
    fontWeight: 600,
    lineHeight: "20px",
    background: "none",
    border: "none",
    cursor: "pointer",
    padding: `${(0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.100")} ${(0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.150")}`,
    display: "flex",
    alignItems: "center",
    opacity: 0,
    transition: "opacity 0.2s ease",
    textDecoration: "none",
    "&:hover": {
        textDecoration: "underline",
        textUnderlineOffset: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.050"),
        color: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.text.brand")
    },
    "&:visited": {
        color: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.text.brand")
    }
});
const $fc6840133e04adc0$var$$ffad026de847a971$var$subTitleStyles = (0, $74Zh5.css)({
    color: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.text"),
    display: "-webkit-box",
    WebkitLineClamp: 2,
    WebkitBoxOrient: "vertical",
    fontFamily: "Inter",
    fontSize: "14px",
    fontStyle: "normal",
    fontWeight: 400,
    lineHeight: "20px",
    margin: 0,
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "normal",
    width: "100%",
    minWidth: 0,
    maxHeight: "40px",
    wordBreak: "break-word",
    overflowWrap: "break-word",
    "@media (max-width: 343px)": {
        lineHeight: "22px",
        whiteSpace: "normal",
        overflow: "hidden",
        textOverflow: "ellipsis",
        wordBreak: "break-word",
        overflowWrap: "break-word",
        maxHeight: "44px"
    }
});
const $fc6840133e04adc0$var$$ffad026de847a971$var$durationTextStyles = (0, $74Zh5.css)({
    color: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.text.subtlest"),
    fontFamily: "Charlie Text",
    fontSize: "12px",
    fontStyle: "normal",
    fontWeight: 400,
    lineHeight: "16px",
    textTransform: "uppercase",
    marginBottom: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.050")
});
const $fc6840133e04adc0$var$$ffad026de847a971$var$buttonContainerStyles = (0, $74Zh5.css)({
    display: "flex",
    alignItems: "center",
    gap: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.200"),
    alignSelf: "stretch",
    borderTop: `1px solid ${(0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.border")}`,
    padding: `${(0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.150")} ${(0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.300")}`,
    "@media (max-width: 343px)": {
        gap: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.100"),
        padding: `${(0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.150")} ${(0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.100")}`
    }
});
const $fc6840133e04adc0$var$$ffad026de847a971$var$toggleButtonStyles = (0, $74Zh5.css)({
    color: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.text.brand"),
    fontFamily: "Charlie Text",
    fontSize: "16px",
    fontStyle: "normal",
    fontWeight: 600,
    background: "none",
    border: "none",
    cursor: "pointer",
    padding: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.0"),
    display: "flex",
    alignItems: "center",
    gap: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.050"),
    "&:hover": {
        textDecoration: "underline",
        textUnderlineOffset: "4px"
    }
});
const $fc6840133e04adc0$var$$ffad026de847a971$var$toggleButtonMobileStyles = (0, $74Zh5.css)({
    color: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.text.brand"),
    textAlign: "center",
    fontFamily: "Charlie Text",
    fontSize: "14px",
    fontStyle: "normal",
    fontWeight: 600,
    lineHeight: "20px"
});
const $fc6840133e04adc0$var$$ffad026de847a971$var$buttonContainerOpenStyles = (0, $74Zh5.css)({
    borderBottom: `1px solid ${(0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.border")}`
});
const $fc6840133e04adc0$var$$ffad026de847a971$var$wrapperStyles = (0, $74Zh5.css)({
    border: `1px solid ${(0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.border")}`,
    overflow: "hidden",
    maxWidth: "100%",
    backgroundColor: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.background.input")
});
const $fc6840133e04adc0$var$$ffad026de847a971$var$wrapperClosedStyles = (0, $74Zh5.css)({
    borderRadius: "8px"
});
const $fc6840133e04adc0$var$$ffad026de847a971$var$wrapperOpenStyles = (0, $74Zh5.css)({
    borderRadius: "8px",
    "& > div:last-child": {
        borderRadius: "0 0 8px 8px"
    }
});
const $fc6840133e04adc0$var$$ffad026de847a971$var$lessonsContentWrapperStyles = (0, $74Zh5.css)({
    overflow: "hidden",
    borderRadius: "0 0 8px 8px !important",
    backgroundColor: "#FFFFFF",
    "& > div": {
        borderRadius: "0 0 8px 8px !important"
    },
    "& > div > div:last-child": {
        borderRadius: "0 0 8px 8px !important"
    }
});
const $fc6840133e04adc0$var$$ffad026de847a971$var$lessonContentWrapperMobileStyles = (0, $74Zh5.css)({
    borderRadius: "0 !important",
    "& > div": {
        borderRadius: "0 !important"
    },
    "& > div > div:last-child": {
        borderRadius: "0 !important"
    }
});
const $fc6840133e04adc0$var$$ffad026de847a971$var$completedCourseStyles = (0, $74Zh5.css)({
    borderLeft: `4px solid ${(0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.border.success")}`
});
const $fc6840133e04adc0$var$$ffad026de847a971$var$buttonContainerClosedStyles = (0, $74Zh5.css)({
    justifyContent: "space-between"
});
const $fc6840133e04adc0$var$$ffad026de847a971$var$buttonContainerMobileStyles = (0, $74Zh5.css)({
    padding: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.150"),
    justifyContent: "space-between"
});
const $fc6840133e04adc0$var$$ffad026de847a971$var$continueButtonStyles = (0, $74Zh5.css)({
    color: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.text.inverse"),
    backgroundColor: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.background.brand.bold"),
    fontFamily: "Charlie Text",
    fontSize: "14px",
    fontStyle: "normal",
    fontWeight: 600,
    lineHeight: "20px",
    height: "32px",
    borderRadius: "4px",
    border: "none",
    cursor: "pointer",
    padding: `${(0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.100")} ${(0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.150")}`,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    "&:hover": {
        backgroundColor: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.background.brand.bold.hovered"),
        color: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.text.inverse"),
        textDecoration: "none"
    },
    "&:active": {
        backgroundColor: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.background.brand.bold.pressed")
    }
});
var $fc6840133e04adc0$var$$0f989458047e435a$exports = {};
$fc6840133e04adc0$var$$parcel$export($fc6840133e04adc0$var$$0f989458047e435a$exports, "InformationCardState", ()=>$fc6840133e04adc0$export$cbadcd18ba5a3835);
$fc6840133e04adc0$var$$parcel$export($fc6840133e04adc0$var$$0f989458047e435a$exports, "InformationCard", ()=>$fc6840133e04adc0$export$5a1fe75c0326c1f3);
var $fc6840133e04adc0$var$$a7b3e1c0391fddac$exports = {};
$fc6840133e04adc0$var$$parcel$export($fc6840133e04adc0$var$$a7b3e1c0391fddac$exports, "LearningControlPanel", ()=>$fc6840133e04adc0$export$b0db8dac2b423604);
const $fc6840133e04adc0$export$b0db8dac2b423604 = ({ state: state = $fc6840133e04adc0$export$cbadcd18ba5a3835.DEFAULT, isSaved: isSaved, onSave: onSave, urlToShare: urlToShare, contentType: contentType, onClick: onClick })=>{
    const isCourse = contentType === $fc6840133e04adc0$export$e2e108cbe2e4f865.COURSE;
    const buttonLabel = isCourse ? "course" : "learning path";
    const width = $fc6840133e04adc0$export$4616d33c54ae5baf();
    const TABLET_WIDTH = 920;
    const handleOnClick = (event)=>{
        if (onClick) {
            event?.preventDefault();
            onClick();
        }
    };
    const ButtonStateProps = {
        [$fc6840133e04adc0$export$cbadcd18ba5a3835.LOADING]: {
            label: "",
            isLoading: true,
            fullWidth: true
        },
        [$fc6840133e04adc0$export$cbadcd18ba5a3835.DEFAULT]: {
            label: `Start ${buttonLabel}`,
            appearance: $fc6840133e04adc0$export$261c9483fc4a455a.PRIMARY,
            fullWidth: true
        },
        [$fc6840133e04adc0$export$cbadcd18ba5a3835.IN_PROGRESS]: {
            label: `Continue ${buttonLabel}`,
            appearance: $fc6840133e04adc0$export$261c9483fc4a455a.PRIMARY,
            fullWidth: true
        },
        [$fc6840133e04adc0$export$cbadcd18ba5a3835.FINISHED]: {
            label: `Review ${buttonLabel}`,
            appearance: $fc6840133e04adc0$export$261c9483fc4a455a.SECONDARY,
            fullWidth: true
        }
    };
    const handleOnSave = ()=>{
        if (onSave) onSave();
    };
    return (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
        "data-testid": "control-panel-card",
        css: $fc6840133e04adc0$var$$a7b3e1c0391fddac$var$learningControlPanelStyles,
        children: [
            (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                css: $fc6840133e04adc0$var$$a7b3e1c0391fddac$var$iconButtonsContainerStyles,
                children: [
                    onSave && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$export$353f5b6fc5456de1, {
                        iconColor: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.icon.subtle"),
                        label: "",
                        appearance: $fc6840133e04adc0$export$261c9483fc4a455a.ICON,
                        iconBefore: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$export$f04a61298a47a40f, {
                            type: isSaved ? "bookmark-filled" : "bookmark"
                        }),
                        onClick: handleOnSave
                    }),
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$export$477c64ffaba52edf, {
                        urlToShare: urlToShare,
                        alignToTop: width <= TABLET_WIDTH,
                        fullWidth: true
                    })
                ]
            }),
            (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                "data-testid": "control-panel-cta-button",
                css: $fc6840133e04adc0$var$$a7b3e1c0391fddac$var$statusButtonContainerStyles,
                children: [
                    state === $fc6840133e04adc0$export$cbadcd18ba5a3835.LOADING && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$export$353f5b6fc5456de1, {
                        ...ButtonStateProps[$fc6840133e04adc0$export$cbadcd18ba5a3835.LOADING]
                    }),
                    state === $fc6840133e04adc0$export$cbadcd18ba5a3835.DEFAULT && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$export$353f5b6fc5456de1, {
                        onClick: handleOnClick,
                        ...ButtonStateProps[$fc6840133e04adc0$export$cbadcd18ba5a3835.DEFAULT]
                    }),
                    state === $fc6840133e04adc0$export$cbadcd18ba5a3835.IN_PROGRESS && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$export$353f5b6fc5456de1, {
                        onClick: handleOnClick,
                        ...ButtonStateProps[$fc6840133e04adc0$export$cbadcd18ba5a3835.IN_PROGRESS]
                    }),
                    state === $fc6840133e04adc0$export$cbadcd18ba5a3835.FINISHED && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$export$353f5b6fc5456de1, {
                        onClick: handleOnClick,
                        ...ButtonStateProps[$fc6840133e04adc0$export$cbadcd18ba5a3835.FINISHED]
                    })
                ]
            })
        ]
    });
};
const $fc6840133e04adc0$var$$a7b3e1c0391fddac$var$learningControlPanelStyles = (0, $74Zh5.css)({
    position: "relative",
    padding: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.200"),
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    border: `1px solid ${(0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.border")}`,
    borderRadius: "8px",
    borderTopRightRadius: 0,
    borderTopLeftRadius: 0,
    backgroundColor: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.background.input"),
    zIndex: 2,
    borderLeft: "none",
    borderRight: "none",
    "@media (max-width: 920px)": {
        borderBottom: "none"
    }
});
const $fc6840133e04adc0$var$$a7b3e1c0391fddac$var$iconButtonsContainerStyles = (0, $74Zh5.css)({
    display: "flex",
    justifyContent: "space-between",
    gap: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.150"),
    marginRight: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.150"),
    '[id*="icon-button"]': {
        width: "38px",
        height: "38px",
        backgroundColor: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.background.neutral"),
        ":hover": {
            backgroundColor: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.background.neutral.hovered")
        }
    }
});
const $fc6840133e04adc0$var$$a7b3e1c0391fddac$var$statusButtonContainerStyles = (0, $74Zh5.css)({
    flex: 1,
    width: "100%",
    a: {
        padding: `${(0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.100")} ${(0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.150")}`
    },
    button: {
        width: "100%",
        height: "38px"
    }
});
let $fc6840133e04adc0$export$cbadcd18ba5a3835;
(function(InformationCardState) {
    InformationCardState["LOADING"] = "loading";
    InformationCardState["DEFAULT"] = "default";
    InformationCardState["IN_PROGRESS"] = "in_progress";
    InformationCardState["FINISHED"] = "finished";
})($fc6840133e04adc0$export$cbadcd18ba5a3835 || ($fc6840133e04adc0$export$cbadcd18ba5a3835 = {}));
const $fc6840133e04adc0$export$5a1fe75c0326c1f3 = ({ contentType: contentType, video: video, badge: badge, progress: progress, duration: duration, description: description, title: title, urlToShare: urlToShare, cardState: cardState, isSaved: isSaved, onSave: onSave, onClick: onClick })=>{
    const isCourse = contentType === $fc6840133e04adc0$export$e2e108cbe2e4f865.COURSE;
    const defaultTitle = isCourse ? "After this course, you'll be able to:" : "This learning path is for:";
    const displayTitle = title ?? defaultTitle;
    const titleColor = isCourse ? (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.text.accent.blue") : (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.text.accent.lime");
    const isCompleted = progress === 100;
    const shouldShowBadge = isCourse && badge && !video;
    const shouldShowVideo = contentType === $fc6840133e04adc0$export$e2e108cbe2e4f865.LEARNING_PATH && video && !badge;
    return (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
        "data-testid": "information-card",
        css: [
            $fc6840133e04adc0$var$$0f989458047e435a$var$informationCardStyles,
            isCourse ? $fc6840133e04adc0$var$$0f989458047e435a$var$courseBorderStyles : $fc6840133e04adc0$var$$0f989458047e435a$var$learningPathBorderStyles,
            shouldShowVideo && (0, $74Zh5.css)({
                borderTop: "none"
            })
        ],
        children: [
            shouldShowBadge && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                css: $fc6840133e04adc0$var$$0f989458047e435a$var$badgeContainerStyles,
                children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                    css: $fc6840133e04adc0$var$$0f989458047e435a$var$badgeStyles,
                    style: {
                        backgroundImage: `url(${badge})`
                    }
                })
            }),
            shouldShowVideo && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                css: $fc6840133e04adc0$var$$0f989458047e435a$var$videoContainerStyles,
                children: video
            }),
            (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                "data-testid": "information-card-top",
                css: [
                    $fc6840133e04adc0$var$$0f989458047e435a$var$informationCardContainerStyles,
                    (0, $74Zh5.css)({
                        marginTop: shouldShowBadge ? (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.250") : "0px"
                    })
                ],
                children: [
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$export$a8a3e93435678ff9, {
                        level: 5,
                        color: titleColor,
                        children: displayTitle
                    }),
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                        css: $fc6840133e04adc0$var$$0f989458047e435a$var$descriptionStyles,
                        children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$export$5f1af8db9871e1d6, {
                            size: "small",
                            color: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.text"),
                            children: description
                        })
                    })
                ]
            }),
            (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                "data-testid": "duration-progress-container",
                css: [
                    $fc6840133e04adc0$var$$0f989458047e435a$var$informationCardContainerStyles,
                    $fc6840133e04adc0$var$$0f989458047e435a$var$durationProgressContainerStyles
                ],
                children: [
                    (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                        "data-testid": "duration-info",
                        css: $fc6840133e04adc0$var$$0f989458047e435a$var$durationContainerStyles,
                        children: [
                            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("span", {
                                css: $fc6840133e04adc0$var$$0f989458047e435a$var$spanStyles,
                                children: "Duration"
                            }),
                            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$export$3288d34c523a1192, {
                                label: duration
                            })
                        ]
                    }),
                    (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                        "data-testid": "progress-info",
                        css: $fc6840133e04adc0$var$$0f989458047e435a$var$progressContainerStyles,
                        children: [
                            (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                                css: $fc6840133e04adc0$var$$0f989458047e435a$var$progressPercentageStyles,
                                children: [
                                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("span", {
                                        css: $fc6840133e04adc0$var$$0f989458047e435a$var$spanStyles,
                                        children: "Progress "
                                    }),
                                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("span", {
                                        css: [
                                            $fc6840133e04adc0$var$$0f989458047e435a$var$percentageStyles,
                                            isCompleted && (0, $74Zh5.css)({
                                                color: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.text.success")
                                            })
                                        ],
                                        children: isCompleted ? "Completed" : `${progress}%`
                                    })
                                ]
                            }),
                            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$export$c17561cb55d4db30, {
                                color: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.border.success"),
                                progress: progress
                            })
                        ]
                    })
                ]
            }),
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                css: $fc6840133e04adc0$var$$0f989458047e435a$var$controlPanelContainerStyles,
                children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$export$b0db8dac2b423604, {
                    onClick: onClick,
                    isSaved: isSaved,
                    onSave: onSave,
                    state: cardState,
                    urlToShare: urlToShare,
                    contentType: contentType
                })
            })
        ]
    });
};
const $fc6840133e04adc0$var$$0f989458047e435a$var$informationCardStyles = (0, $74Zh5.css)({
    position: "relative",
    width: "100%",
    border: `1px solid ${(0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.border")}`,
    borderBottom: "unset",
    borderRadius: "8px",
    backgroundColor: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.background.input"),
    boxShadow: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("elevation.shadow.overlay"),
    "@media (max-width: 965px)": {
        borderBottom: `1px solid ${(0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.border")}`,
        boxShadow: "unset"
    }
});
const $fc6840133e04adc0$var$$0f989458047e435a$var$courseBorderStyles = (0, $74Zh5.css)({
    borderTop: `8px solid ${(0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.text.accent.blue")}`
});
const $fc6840133e04adc0$var$$0f989458047e435a$var$learningPathBorderStyles = (0, $74Zh5.css)({
    borderTop: "8px solid #6A9A23"
});
const $fc6840133e04adc0$var$$0f989458047e435a$var$badgeContainerStyles = (0, $74Zh5.css)({
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    position: "absolute",
    width: "60px",
    height: "60px",
    borderRadius: "50%",
    border: `4px solid ${(0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.text.accent.blue")}`,
    left: "50%",
    top: "0%",
    transform: "translate(-50%, -60%)",
    background: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.background.input"),
    zIndex: 1
});
const $fc6840133e04adc0$var$$0f989458047e435a$var$videoContainerStyles = (0, $74Zh5.css)({
    borderTopLeftRadius: "8px",
    borderTopRightRadius: "8px",
    ".plyr": {
        borderTopLeftRadius: "8px",
        borderTopRightRadius: "8px"
    }
});
const $fc6840133e04adc0$var$$0f989458047e435a$var$badgeStyles = (0, $74Zh5.css)({
    width: "35px",
    height: "35px",
    borderRadius: "50%",
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat"
});
const $fc6840133e04adc0$var$$0f989458047e435a$var$informationCardContainerStyles = (0, $74Zh5.css)({
    padding: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.200")
});
const $fc6840133e04adc0$var$$0f989458047e435a$var$descriptionStyles = (0, $74Zh5.css)({
    marginBottom: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.100"),
    marginTop: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.100"),
    color: `${(0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.text")} !important`,
    fontFamily: "Inter !important",
    fontSize: "14px !important",
    fontWeight: "400 !important",
    lineHeight: "22px !important",
    div: {
        paddingBottom: "0 !important",
        display: "flex !important",
        "@media (max-width: 920px)": {
            display: "flex !important"
        }
    },
    "span, p, li": {
        color: `${(0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.text")} !important`,
        fontFamily: "Inter !important",
        fontSize: "14px !important",
        fontWeight: "400 !important",
        lineHeight: "22px !important"
    },
    li: {
        marginBottom: "6px !important"
    },
    "li:last-child": {
        marginBottom: "0 !important"
    }
});
const $fc6840133e04adc0$var$$0f989458047e435a$var$durationProgressContainerStyles = (0, $74Zh5.css)({
    borderTop: `1px solid ${(0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.border")}`
});
const $fc6840133e04adc0$var$$0f989458047e435a$var$durationContainerStyles = (0, $74Zh5.css)({
    display: "flex",
    alignItems: "center",
    gap: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.200")
});
const $fc6840133e04adc0$var$$0f989458047e435a$var$spanStyles = (0, $74Zh5.css)({
    fontFamily: "Inter, sans-serif",
    fontSize: "14px",
    fontWeight: "700",
    lineHeight: "20px",
    color: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.text"),
    textTransform: "uppercase"
});
const $fc6840133e04adc0$var$$0f989458047e435a$var$percentageStyles = (0, $74Zh5.css)({
    fontFamily: "Inter, sans-serif",
    fontSize: "14px",
    fontWeight: "400",
    lineHeight: "20px",
    color: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.text")
});
const $fc6840133e04adc0$var$$0f989458047e435a$var$progressContainerStyles = (0, $74Zh5.css)({
    display: "flex",
    flexDirection: "column",
    gap: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.200"),
    marginTop: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.200")
});
const $fc6840133e04adc0$var$$0f989458047e435a$var$progressPercentageStyles = (0, $74Zh5.css)({
    display: "flex",
    alignItems: "center",
    gap: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.200")
});
const $fc6840133e04adc0$var$$0f989458047e435a$var$controlPanelContainerStyles = (0, $74Zh5.css)({
    "@media (max-width: 965px)": {
        display: "none"
    }
});
var $fc6840133e04adc0$var$$ffc638203e092686$exports = {};
$fc6840133e04adc0$var$$parcel$export($fc6840133e04adc0$var$$ffc638203e092686$exports, "ContentVersioningDialog", ()=>$fc6840133e04adc0$export$3a7bdc050aa55c54);
const $fc6840133e04adc0$export$3a7bdc050aa55c54 = ({ resourceTitle: resourceTitle, subtitle: subtitle, notifications: notifications, onResourceLinkClick: onResourceLinkClick, closeModal: closeModal })=>{
    const handleDismiss = (e)=>{
        e.preventDefault();
        closeModal();
    };
    const handleResourceClick = (e, resourceLink)=>{
        e.preventDefault();
        onResourceLinkClick(resourceLink);
    };
    return (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $9406e400bdd02ea1$export$2e2bcd8739ae039), {
        onClose: closeModal,
        children: (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
            "data-testid": "content-versioning-dialog",
            css: $fc6840133e04adc0$var$$ffc638203e092686$var$containerStyles,
            children: [
                (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                    css: $fc6840133e04adc0$var$$ffc638203e092686$var$crossIconContainerStyles,
                    children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$export$353f5b6fc5456de1, {
                        label: "",
                        appearance: $fc6840133e04adc0$export$261c9483fc4a455a.ICON,
                        iconType: "cross",
                        iconBefore: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$export$f04a61298a47a40f, {
                            type: "cross",
                            color: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.icon")
                        }),
                        onClick: handleDismiss
                    })
                }),
                (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                    children: [
                        (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                            "data-testid": "dialog-title",
                            css: $fc6840133e04adc0$var$$ffc638203e092686$var$dialogTitleStyles,
                            children: [
                                "Update to ",
                                resourceTitle
                            ]
                        }),
                        (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                            "data-testid": "dialog-subtitle",
                            css: $fc6840133e04adc0$var$$ffc638203e092686$var$dialogSubtitleStyles,
                            children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$export$5f1af8db9871e1d6, {
                                size: "small",
                                color: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.text"),
                                children: subtitle
                            })
                        }),
                        (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                            children: [
                                (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$export$5f1af8db9871e1d6, {
                                    size: "small",
                                    color: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.text"),
                                    children: "Summary of changes:"
                                }),
                                !!notifications.length && notifications.map((notification)=>(0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                                        css: $fc6840133e04adc0$var$$ffc638203e092686$var$notificationContainerStyles,
                                        children: [
                                            (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                                                children: [
                                                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                                                        "data-testid": "notification-title",
                                                        children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$export$5f1af8db9871e1d6, {
                                                            children: notification.title
                                                        })
                                                    }),
                                                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("span", {
                                                        css: $fc6840133e04adc0$var$$ffc638203e092686$var$notificationDateStyles,
                                                        children: notification.date
                                                    })
                                                ]
                                            }),
                                            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                                                css: $fc6840133e04adc0$var$$ffc638203e092686$var$notificationDescriptionContainerStyles,
                                                children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$export$5f1af8db9871e1d6, {
                                                    size: "small",
                                                    color: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.text.subtle"),
                                                    children: notification.description
                                                })
                                            }),
                                            notification.contentType === $fc6840133e04adc0$export$e2e108cbe2e4f865.LESSON && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                                                css: $fc6840133e04adc0$var$$ffc638203e092686$var$linkContainerStyles,
                                                children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$export$a6c7ac8248d6e38a, {
                                                    target: "_blank",
                                                    label: "View changes",
                                                    link: notification.resourceLink,
                                                    icon: "arrow-right",
                                                    onClick: (e)=>handleResourceClick(e, notification.resourceLink)
                                                })
                                            })
                                        ]
                                    }, notification.id))
                            ]
                        })
                    ]
                }),
                (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                    css: $fc6840133e04adc0$var$$ffc638203e092686$var$buttonContainerStyles,
                    children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$export$353f5b6fc5456de1, {
                        label: "Dismiss",
                        appearance: $fc6840133e04adc0$export$261c9483fc4a455a.PRIMARY,
                        onClick: handleDismiss
                    })
                })
            ]
        })
    });
};
const $fc6840133e04adc0$var$$ffc638203e092686$var$containerStyles = (0, $74Zh5.css)({
    display: "flex",
    flexDirection: "column",
    padding: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.300"),
    backgroundColor: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.background.input"),
    boxShadow: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("elevation.shadow.raised"),
    borderRadius: "8px"
});
const $fc6840133e04adc0$var$$ffc638203e092686$var$crossIconContainerStyles = (0, $74Zh5.css)({
    alignSelf: "flex-end",
    marginBottom: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.150")
});
const $fc6840133e04adc0$var$$ffc638203e092686$var$dialogTitleStyles = (0, $74Zh5.css)({
    marginBottom: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.100"),
    color: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.text"),
    fontFamily: "Charlie Display, sans-serif",
    fontSize: "24px",
    fontWeight: 600,
    lineHeight: "32px",
    textAlign: "left"
});
const $fc6840133e04adc0$var$$ffc638203e092686$var$dialogSubtitleStyles = (0, $74Zh5.css)({
    marginBottom: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.300")
});
const $fc6840133e04adc0$var$$ffc638203e092686$var$notificationContainerStyles = (0, $74Zh5.css)({
    border: `1px solid ${(0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.border")}`,
    padding: `${(0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.150")} ${(0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.200")}`,
    marginTop: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.100"),
    borderRadius: "4px",
    backgroundColor: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.background.input"),
    borderLeft: `4px solid ${(0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.background.accent.blue.subtlest.pressed")}`
});
const $fc6840133e04adc0$var$$ffc638203e092686$var$buttonContainerStyles = (0, $74Zh5.css)({
    alignSelf: "flex-end",
    marginTop: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.400"),
    a: {
        fontFamily: "SF Pro, sans-serif",
        fontSize: "14px",
        fontWeight: 500,
        paddingTop: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.075"),
        paddingBottom: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.075")
    }
});
const $fc6840133e04adc0$var$$ffc638203e092686$var$notificationDateStyles = (0, $74Zh5.css)({
    color: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.text.subtlest"),
    fontFamily: "Inter, sans-serif",
    fontWeight: 400,
    lineHeight: "18px"
});
const $fc6840133e04adc0$var$$ffc638203e092686$var$notificationDescriptionContainerStyles = (0, $74Zh5.css)({
    marginTop: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.100"),
    marginBottom: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.150")
});
const $fc6840133e04adc0$var$$ffc638203e092686$var$linkContainerStyles = (0, $74Zh5.css)({
    a: {
        "&:hover": {
            textDecoration: "none"
        }
    }
});
var $fc6840133e04adc0$var$$4dfe37aba1865d88$exports = {};
$fc6840133e04adc0$var$$parcel$export($fc6840133e04adc0$var$$4dfe37aba1865d88$exports, "CustomerInfoForm", ()=>$fc6840133e04adc0$export$6415ce2f4ef17e20);
const $fc6840133e04adc0$var$$292473fda2395210$export$1d1c4391ecac81e8 = async ()=>{
    const result = await fetch(`https://www.atlassian.com/hamlet/1.0/public/country/taas/all`);
    if (!result.ok) throw Error("Unable to fetch countries");
    return (await result.json()).countryList;
};
const $fc6840133e04adc0$var$$292473fda2395210$export$2bc3cba6f94d7400 = async (isoCountryCode)=>{
    const result = await fetch(`https://www.atlassian.com/hamlet/1.0/public/country/taas/findByIso/${isoCountryCode}`);
    if (!result.ok) throw Error("Unable to fetch states");
    return result.json();
};
const $fc6840133e04adc0$var$$4dfe37aba1865d88$var$rowStyles = (0, $74Zh5.css)({
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    gap: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.200")
});
const $fc6840133e04adc0$var$$4dfe37aba1865d88$var$fieldBlock = (0, $74Zh5.css)({
    marginBottom: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.200")
});
const $fc6840133e04adc0$var$$4dfe37aba1865d88$var$selectContainer = (0, $74Zh5.css)({
    maxWidth: "420px"
});
const $fc6840133e04adc0$export$6415ce2f4ef17e20 = ({ onSubmit: onSubmit })=>{
    const [countries, setCountries] = (0, $5FkrB.useState)([]);
    const [selectedCountry, setSelectedCountry] = (0, $5FkrB.useState)(null);
    const [states, setStates] = (0, $5FkrB.useState)([]);
    (0, $5FkrB.useEffect)(()=>{
        let mounted = true;
        (async ()=>{
            try {
                const list = await $fc6840133e04adc0$var$$292473fda2395210$export$1d1c4391ecac81e8();
                if (!mounted) return;
                setCountries(list);
                const us = list.find((c)=>c.isoCountryCode === "US" || c.countryIsoCode === "US" || c.displayName === "United States");
                if (us) setSelectedCountry(us);
            } catch  {
            // ignore network errors in Storybook/local environments
            }
        })();
        return ()=>{
            mounted = false;
        };
    }, []);
    (0, $5FkrB.useEffect)(()=>{
        let mounted = true;
        (async ()=>{
            if (!selectedCountry) {
                setStates([]);
                return;
            }
            if (selectedCountry.states && selectedCountry.states.length) {
                setStates(selectedCountry.states);
                return;
            }
            try {
                const detailed = await $fc6840133e04adc0$var$$292473fda2395210$export$2bc3cba6f94d7400(selectedCountry.isoCountryCode || selectedCountry.countryIsoCode);
                if (!mounted) return;
                setStates(detailed.states || []);
            } catch  {
                setStates([]);
            }
        })();
        return ()=>{
            mounted = false;
        };
    }, [
        selectedCountry
    ]);
    const countryOptions = (0, $5FkrB.useMemo)(()=>countries.map((c)=>({
                label: c.displayName || c.countryIsoCode,
                value: c.isoCountryCode || c.countryIsoCode,
                data: c
            })), [
        countries
    ]);
    const stateOptions = (0, $5FkrB.useMemo)(()=>states.map((s)=>({
                label: s.name,
                value: s.code
            })), [
        states
    ]);
    const selectedCountryOption = (0, $5FkrB.useMemo)(()=>{
        if (!selectedCountry) return null;
        return {
            label: selectedCountry.displayName || selectedCountry.countryIsoCode,
            value: selectedCountry.isoCountryCode || selectedCountry.countryIsoCode,
            data: selectedCountry
        };
    }, [
        selectedCountry
    ]);
    return (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $40d9709490a4246c$export$2e2bcd8739ae039), {
        onSubmit: onSubmit,
        children: ({ formProps: formProps })=>(0, $6bec4f26b2cb3094$export$25062201e9e25d76)("form", {
                ...formProps,
                noValidate: true,
                children: [
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                        css: (0, $74Zh5.css)({
                            marginBottom: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.250")
                        }),
                        children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$export$a8a3e93435678ff9, {
                            level: 4,
                            children: "Customer Information"
                        })
                    }),
                    (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                        css: [
                            $fc6840133e04adc0$var$$4dfe37aba1865d88$var$rowStyles,
                            $fc6840133e04adc0$var$$4dfe37aba1865d88$var$fieldBlock
                        ],
                        children: [
                            (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                                children: [
                                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $e6c825ca43fa4ec5$export$b04be29aa201d4f5), {
                                        htmlFor: "first-name",
                                        children: "First Name"
                                    }),
                                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $baa25b657b03ab03$export$2e2bcd8739ae039), {
                                        name: "firstName",
                                        defaultValue: "",
                                        children: ({ fieldProps: fieldProps })=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$export$2c73285ae9390cec, {
                                                ...fieldProps,
                                                id: "first-name",
                                                placeholder: "First Name",
                                                required: true
                                            })
                                    })
                                ]
                            }),
                            (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                                children: [
                                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $e6c825ca43fa4ec5$export$b04be29aa201d4f5), {
                                        htmlFor: "last-name",
                                        children: "Last Name"
                                    }),
                                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $baa25b657b03ab03$export$2e2bcd8739ae039), {
                                        name: "lastName",
                                        defaultValue: "",
                                        children: ({ fieldProps: fieldProps })=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$export$2c73285ae9390cec, {
                                                ...fieldProps,
                                                id: "last-name",
                                                placeholder: "Last Name",
                                                required: true
                                            })
                                    })
                                ]
                            })
                        ]
                    }),
                    (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                        css: $fc6840133e04adc0$var$$4dfe37aba1865d88$var$fieldBlock,
                        children: [
                            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $e6c825ca43fa4ec5$export$b04be29aa201d4f5), {
                                htmlFor: "address1",
                                children: "Address"
                            }),
                            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $baa25b657b03ab03$export$2e2bcd8739ae039), {
                                name: "address1",
                                defaultValue: "",
                                children: ({ fieldProps: fieldProps })=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$export$2c73285ae9390cec, {
                                        ...fieldProps,
                                        id: "address1",
                                        placeholder: "Address",
                                        required: true
                                    })
                            })
                        ]
                    }),
                    (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                        css: $fc6840133e04adc0$var$$4dfe37aba1865d88$var$fieldBlock,
                        children: [
                            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $e6c825ca43fa4ec5$export$b04be29aa201d4f5), {
                                htmlFor: "address2",
                                children: "Address Line 2 (Optional)"
                            }),
                            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $baa25b657b03ab03$export$2e2bcd8739ae039), {
                                name: "address2",
                                defaultValue: "",
                                children: ({ fieldProps: fieldProps })=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$export$2c73285ae9390cec, {
                                        ...fieldProps,
                                        id: "address2",
                                        placeholder: "Address Line 2"
                                    })
                            })
                        ]
                    }),
                    (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                        css: $fc6840133e04adc0$var$$4dfe37aba1865d88$var$fieldBlock,
                        children: [
                            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $e6c825ca43fa4ec5$export$b04be29aa201d4f5), {
                                htmlFor: "city",
                                children: "City"
                            }),
                            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $baa25b657b03ab03$export$2e2bcd8739ae039), {
                                name: "city",
                                defaultValue: "",
                                children: ({ fieldProps: fieldProps })=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$export$2c73285ae9390cec, {
                                        ...fieldProps,
                                        id: "city",
                                        placeholder: "City",
                                        required: true
                                    })
                            })
                        ]
                    }),
                    (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                        css: [
                            $fc6840133e04adc0$var$$4dfe37aba1865d88$var$rowStyles,
                            $fc6840133e04adc0$var$$4dfe37aba1865d88$var$fieldBlock
                        ],
                        children: [
                            (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                                children: [
                                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $e6c825ca43fa4ec5$export$b04be29aa201d4f5), {
                                        htmlFor: "country",
                                        children: "Country"
                                    }),
                                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $baa25b657b03ab03$export$2e2bcd8739ae039), {
                                        name: "country",
                                        defaultValue: selectedCountryOption,
                                        children: ({ fieldProps: { value: value, onChange: onChange } })=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                                                css: $fc6840133e04adc0$var$$4dfe37aba1865d88$var$selectContainer,
                                                children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $f7c144361eb4a177$export$2e2bcd8739ae039), {
                                                    inputId: "country",
                                                    options: countryOptions,
                                                    value: value || selectedCountryOption,
                                                    placeholder: "Select country",
                                                    onChange: (opt)=>{
                                                        onChange(opt);
                                                        const countryData = opt?.data;
                                                        setSelectedCountry(countryData || null);
                                                    }
                                                })
                                            })
                                    })
                                ]
                            }),
                            (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                                children: [
                                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $e6c825ca43fa4ec5$export$b04be29aa201d4f5), {
                                        htmlFor: "state",
                                        children: "State"
                                    }),
                                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $baa25b657b03ab03$export$2e2bcd8739ae039), {
                                        name: "state",
                                        defaultValue: null,
                                        children: ({ fieldProps: { value: value, onChange: onChange } })=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                                                css: $fc6840133e04adc0$var$$4dfe37aba1865d88$var$selectContainer,
                                                children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $f7c144361eb4a177$export$2e2bcd8739ae039), {
                                                    inputId: "state",
                                                    options: stateOptions,
                                                    value: value,
                                                    placeholder: "Select state",
                                                    isDisabled: !selectedCountry,
                                                    onChange: (opt)=>onChange(opt)
                                                })
                                            })
                                    })
                                ]
                            })
                        ]
                    }),
                    (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                        css: [
                            $fc6840133e04adc0$var$$4dfe37aba1865d88$var$rowStyles,
                            $fc6840133e04adc0$var$$4dfe37aba1865d88$var$fieldBlock
                        ],
                        children: [
                            (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                                children: [
                                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $e6c825ca43fa4ec5$export$b04be29aa201d4f5), {
                                        htmlFor: "postcode",
                                        children: "Zip Code"
                                    }),
                                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $baa25b657b03ab03$export$2e2bcd8739ae039), {
                                        name: "postcode",
                                        defaultValue: "",
                                        children: ({ fieldProps: fieldProps })=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$export$2c73285ae9390cec, {
                                                ...fieldProps,
                                                id: "postcode",
                                                placeholder: "Zip Code",
                                                required: true
                                            })
                                    })
                                ]
                            }),
                            (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                                children: [
                                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $e6c825ca43fa4ec5$export$b04be29aa201d4f5), {
                                        htmlFor: "phone",
                                        children: "Phone Number"
                                    }),
                                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $baa25b657b03ab03$export$2e2bcd8739ae039), {
                                        name: "phone",
                                        defaultValue: "",
                                        children: ({ fieldProps: fieldProps })=>(0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$export$2c73285ae9390cec, {
                                                ...fieldProps,
                                                id: "phone",
                                                placeholder: "Phone Number",
                                                type: "tel",
                                                required: true
                                            })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
    });
};
var $fc6840133e04adc0$var$$556680ce820612ab$exports = {};
$fc6840133e04adc0$var$$parcel$defineInteropFlag($fc6840133e04adc0$var$$556680ce820612ab$exports);
$fc6840133e04adc0$var$$parcel$export($fc6840133e04adc0$var$$556680ce820612ab$exports, "PaymentInfoForm", ()=>$fc6840133e04adc0$export$f950880927ff03db);
$fc6840133e04adc0$var$$parcel$export($fc6840133e04adc0$var$$556680ce820612ab$exports, "default", ()=>$fc6840133e04adc0$var$$556680ce820612ab$export$2e2bcd8739ae039);
const $fc6840133e04adc0$var$$556680ce820612ab$var$rowStyles = (0, $74Zh5.css)({
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    gap: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.200")
});
const $fc6840133e04adc0$var$$556680ce820612ab$var$fieldBlock = (0, $74Zh5.css)({
    marginBottom: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.200")
});
const $fc6840133e04adc0$var$$556680ce820612ab$var$selectContainer = (0, $74Zh5.css)({
    maxWidth: "220px"
});
const $fc6840133e04adc0$var$$556680ce820612ab$var$onlyDigits = (s)=>s.replace(/\D+/g, "");
const $fc6840133e04adc0$var$$556680ce820612ab$var$formatCardNumber = (value)=>{
    const digits = $fc6840133e04adc0$var$$556680ce820612ab$var$onlyDigits(value).slice(0, 19); // support up to 19 digits
    // group into 4s: 4-4-4-4-3
    const groups = [];
    for(let i = 0; i < digits.length; i += 4)groups.push(digits.slice(i, i + 4));
    return groups.join(" ").trim();
};
const $fc6840133e04adc0$var$$556680ce820612ab$var$luhnCheck = (value)=>{
    const digits = $fc6840133e04adc0$var$$556680ce820612ab$var$onlyDigits(value);
    if (digits.length < 12) return false;
    // basic length gate
    let sum = 0;
    let shouldDouble = false;
    for(let i = digits.length - 1; i >= 0; i--){
        let digit = parseInt(digits.charAt(i), 10);
        if (shouldDouble) {
            digit *= 2;
            if (digit > 9) digit -= 9;
        }
        sum += digit;
        shouldDouble = !shouldDouble;
    }
    return sum % 10 === 0;
};
const $fc6840133e04adc0$var$$556680ce820612ab$var$isExpiryInPast = (month, year)=>{
    if (!month || !year) return false;
    // incomplete fields handled elsewhere
    const now = new Date();
    const currentYear = now.getFullYear();
    const currentMonth = now.getMonth() + 1; // 1-12
    if (year < currentYear) return true;
    if (year === currentYear && month < currentMonth) return true;
    return false;
};
const $fc6840133e04adc0$export$f950880927ff03db = ({ onSubmit: onSubmit })=>{
    const monthOptions = (0, $5FkrB.useMemo)(()=>Array.from({
            length: 12
        }, (_, i)=>{
            const m = i + 1;
            const label = m < 10 ? `0${m}` : `${m}`;
            return {
                label: label,
                value: m
            };
        }), []);
    const yearOptions = (0, $5FkrB.useMemo)(()=>{
        const now = new Date();
        const start = now.getFullYear();
        const end = start + 20;
        const arr = [];
        for(let y = start; y <= end; y++)arr.push({
            label: `${y}`,
            value: y
        });
        return arr;
    }, []);
    return (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $40d9709490a4246c$export$2e2bcd8739ae039), {
        onSubmit: (values)=>{
            // normalize values before submit
            const normalized = {
                ...values,
                cardNumber: $fc6840133e04adc0$var$$556680ce820612ab$var$onlyDigits(values.cardNumber || "")
            };
            return onSubmit(normalized);
        },
        children: ({ formProps: formProps })=>(0, $6bec4f26b2cb3094$export$25062201e9e25d76)("form", {
                ...formProps,
                noValidate: true,
                children: [
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                        css: (0, $74Zh5.css)({
                            marginBottom: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.250")
                        }),
                        children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$export$a8a3e93435678ff9, {
                            level: 4,
                            children: "Payment Information"
                        })
                    }),
                    (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                        css: $fc6840133e04adc0$var$$556680ce820612ab$var$fieldBlock,
                        children: [
                            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $e6c825ca43fa4ec5$export$b04be29aa201d4f5), {
                                htmlFor: "cardholder-name",
                                children: "Name on card"
                            }),
                            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $baa25b657b03ab03$export$2e2bcd8739ae039), {
                                name: "cardholderName",
                                defaultValue: "",
                                validate: (v)=>!v ? "Required" : undefined,
                                children: ({ fieldProps: fieldProps, error: error })=>(0, $6bec4f26b2cb3094$export$25062201e9e25d76)((0, $6bec4f26b2cb3094$export$ffb0004e005737fa), {
                                        children: [
                                            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$export$2c73285ae9390cec, {
                                                ...fieldProps,
                                                id: "cardholder-name",
                                                placeholder: "Name on card",
                                                required: true
                                            }),
                                            error && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                                                role: "alert",
                                                style: {
                                                    color: "#C9372C",
                                                    fontSize: 12
                                                },
                                                children: error
                                            })
                                        ]
                                    })
                            })
                        ]
                    }),
                    (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                        css: $fc6840133e04adc0$var$$556680ce820612ab$var$fieldBlock,
                        children: [
                            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $e6c825ca43fa4ec5$export$b04be29aa201d4f5), {
                                htmlFor: "card-number",
                                children: "Card number"
                            }),
                            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $baa25b657b03ab03$export$2e2bcd8739ae039), {
                                name: "cardNumber",
                                defaultValue: "",
                                validate: (v)=>{
                                    if (!v) return "Required";
                                    const digits = $fc6840133e04adc0$var$$556680ce820612ab$var$onlyDigits(v);
                                    if (digits.length < 12) return "Enter a valid card number";
                                    if (!$fc6840133e04adc0$var$$556680ce820612ab$var$luhnCheck(v)) return "Enter a valid card number";
                                    return undefined;
                                },
                                children: ({ fieldProps: fieldProps, error: error })=>{
                                    const { onChange: onChange, value: value, ...rest } = fieldProps;
                                    return (0, $6bec4f26b2cb3094$export$25062201e9e25d76)((0, $6bec4f26b2cb3094$export$ffb0004e005737fa), {
                                        children: [
                                            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$export$2c73285ae9390cec, {
                                                ...rest,
                                                id: "card-number",
                                                placeholder: "1234 5678 9012 3456",
                                                inputMode: "numeric",
                                                autoComplete: "cc-number",
                                                value: $fc6840133e04adc0$var$$556680ce820612ab$var$formatCardNumber(String(value ?? "")),
                                                onChange: (e)=>onChange($fc6840133e04adc0$var$$556680ce820612ab$var$formatCardNumber(e.target.value)),
                                                required: true
                                            }),
                                            error && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                                                role: "alert",
                                                style: {
                                                    color: "#C9372C",
                                                    fontSize: 12
                                                },
                                                children: error
                                            })
                                        ]
                                    });
                                }
                            })
                        ]
                    }),
                    (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                        css: [
                            $fc6840133e04adc0$var$$556680ce820612ab$var$rowStyles,
                            $fc6840133e04adc0$var$$556680ce820612ab$var$fieldBlock
                        ],
                        children: [
                            (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                                children: [
                                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $e6c825ca43fa4ec5$export$b04be29aa201d4f5), {
                                        htmlFor: "expiry-month",
                                        children: "Expiry month"
                                    }),
                                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $baa25b657b03ab03$export$2e2bcd8739ae039), {
                                        name: "expiryMonth",
                                        defaultValue: null,
                                        // @ts-expect-error - @atlaskit/form validate signature doesn't expose proper types for cross-field validation
                                        validate: (v, _, values)=>{
                                            if (!v) return "Required";
                                            const monthVal = v?.value;
                                            const yearVal = values?.expiryYear?.value;
                                            if (monthVal && yearVal && $fc6840133e04adc0$var$$556680ce820612ab$var$isExpiryInPast(monthVal, yearVal)) return "Card has expired";
                                            return undefined;
                                        },
                                        children: ({ fieldProps: { value: value, onChange: onChange }, error: error })=>(0, $6bec4f26b2cb3094$export$25062201e9e25d76)((0, $6bec4f26b2cb3094$export$ffb0004e005737fa), {
                                                children: [
                                                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                                                        css: $fc6840133e04adc0$var$$556680ce820612ab$var$selectContainer,
                                                        children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $f7c144361eb4a177$export$2e2bcd8739ae039), {
                                                            inputId: "expiry-month",
                                                            options: monthOptions,
                                                            value: value,
                                                            placeholder: "MM",
                                                            onChange: (opt)=>onChange(opt)
                                                        })
                                                    }),
                                                    error && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                                                        role: "alert",
                                                        style: {
                                                            color: "#C9372C",
                                                            fontSize: 12
                                                        },
                                                        children: error
                                                    })
                                                ]
                                            })
                                    })
                                ]
                            }),
                            (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                                children: [
                                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $e6c825ca43fa4ec5$export$b04be29aa201d4f5), {
                                        htmlFor: "expiry-year",
                                        children: "Expiry year"
                                    }),
                                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $baa25b657b03ab03$export$2e2bcd8739ae039), {
                                        name: "expiryYear",
                                        defaultValue: null,
                                        // @ts-expect-error - @atlaskit/form validate signature doesn't expose proper types for cross-field validation
                                        validate: (v, _, values)=>{
                                            // cross validate month/year when both exist
                                            const monthVal = values?.expiryMonth?.value;
                                            const yearVal = v?.value;
                                            if (!v) return "Required";
                                            if (monthVal && yearVal && $fc6840133e04adc0$var$$556680ce820612ab$var$isExpiryInPast(monthVal, yearVal)) return "Card has expired";
                                            return undefined;
                                        },
                                        children: ({ fieldProps: { value: value, onChange: onChange }, error: error })=>(0, $6bec4f26b2cb3094$export$25062201e9e25d76)((0, $6bec4f26b2cb3094$export$ffb0004e005737fa), {
                                                children: [
                                                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                                                        css: $fc6840133e04adc0$var$$556680ce820612ab$var$selectContainer,
                                                        children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $f7c144361eb4a177$export$2e2bcd8739ae039), {
                                                            inputId: "expiry-year",
                                                            options: yearOptions,
                                                            value: value,
                                                            placeholder: "YYYY",
                                                            onChange: (opt)=>onChange(opt)
                                                        })
                                                    }),
                                                    error && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                                                        role: "alert",
                                                        style: {
                                                            color: "#C9372C",
                                                            fontSize: 12
                                                        },
                                                        children: error
                                                    })
                                                ]
                                            })
                                    })
                                ]
                            })
                        ]
                    }),
                    (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                        css: $fc6840133e04adc0$var$$556680ce820612ab$var$fieldBlock,
                        children: [
                            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $e6c825ca43fa4ec5$export$b04be29aa201d4f5), {
                                htmlFor: "cvc",
                                children: "Security code (CVC)"
                            }),
                            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $baa25b657b03ab03$export$2e2bcd8739ae039), {
                                name: "cvc",
                                defaultValue: "",
                                validate: (v)=>{
                                    if (!v) return "Required";
                                    const digits = $fc6840133e04adc0$var$$556680ce820612ab$var$onlyDigits(v);
                                    if (digits.length < 3 || digits.length > 4) return "Enter a valid CVC";
                                    return undefined;
                                },
                                children: ({ fieldProps: fieldProps, error: error })=>{
                                    const { onChange: onChange, value: value, ...rest } = fieldProps;
                                    return (0, $6bec4f26b2cb3094$export$25062201e9e25d76)((0, $6bec4f26b2cb3094$export$ffb0004e005737fa), {
                                        children: [
                                            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$export$2c73285ae9390cec, {
                                                ...rest,
                                                id: "cvc",
                                                placeholder: "CVC",
                                                type: "password",
                                                inputMode: "numeric",
                                                autoComplete: "cc-csc",
                                                value: $fc6840133e04adc0$var$$556680ce820612ab$var$onlyDigits(String(value ?? "")).slice(0, 4),
                                                onChange: (e)=>onChange($fc6840133e04adc0$var$$556680ce820612ab$var$onlyDigits(e.target.value).slice(0, 4)),
                                                required: true
                                            }),
                                            error && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                                                role: "alert",
                                                style: {
                                                    color: "#C9372C",
                                                    fontSize: 12
                                                },
                                                children: error
                                            })
                                        ]
                                    });
                                }
                            })
                        ]
                    })
                ]
            })
    });
};
var $fc6840133e04adc0$var$$556680ce820612ab$export$2e2bcd8739ae039 = $fc6840133e04adc0$export$f950880927ff03db;
var $fc6840133e04adc0$var$$6a8b328ff2ec0580$exports = {};
$fc6840133e04adc0$var$$parcel$defineInteropFlag($fc6840133e04adc0$var$$6a8b328ff2ec0580$exports);
$fc6840133e04adc0$var$$parcel$export($fc6840133e04adc0$var$$6a8b328ff2ec0580$exports, "CheckoutSummary", ()=>$fc6840133e04adc0$export$fde280adb8350d09);
$fc6840133e04adc0$var$$parcel$export($fc6840133e04adc0$var$$6a8b328ff2ec0580$exports, "default", ()=>$fc6840133e04adc0$var$$6a8b328ff2ec0580$export$2e2bcd8739ae039);
const $fc6840133e04adc0$var$$6a8b328ff2ec0580$var$asCurrency = (amountInCents, currency = "USD")=>{
    try {
        return new Intl.NumberFormat("en-US", {
            style: "currency",
            currency: currency
        }).format(amountInCents / 100);
    } catch  {
        return `$${(amountInCents / 100).toFixed(2)}`;
    }
};
const $fc6840133e04adc0$export$fde280adb8350d09 = ({ subtotal: subtotal, salesTax: salesTax, total: total, items: items, paymentMethod: paymentMethod, currency: currency = "USD" })=>{
    const [isOpen, setIsOpen] = (0, $5FkrB.useState)(false);
    const itemCountText = (0, $5FkrB.useMemo)(()=>`${items.length} item${items.length === 1 ? "" : "s"}`, [
        items.length
    ]);
    return (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
        css: $fc6840133e04adc0$var$$6a8b328ff2ec0580$var$containerStyles,
        children: [
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$export$a8a3e93435678ff9, {
                level: 4,
                children: "Summary"
            }),
            (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                css: $fc6840133e04adc0$var$$6a8b328ff2ec0580$var$rowStyles,
                children: [
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$export$5f1af8db9871e1d6, {
                        children: "Subtotal"
                    }),
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$export$5f1af8db9871e1d6, {
                        children: $fc6840133e04adc0$var$$6a8b328ff2ec0580$var$asCurrency(subtotal, currency)
                    })
                ]
            }),
            (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                css: $fc6840133e04adc0$var$$6a8b328ff2ec0580$var$rowStyles,
                children: [
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$export$5f1af8db9871e1d6, {
                        children: "Sales Tax"
                    }),
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$export$5f1af8db9871e1d6, {
                        children: $fc6840133e04adc0$var$$6a8b328ff2ec0580$var$asCurrency(salesTax, currency)
                    })
                ]
            }),
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                css: $fc6840133e04adc0$var$$6a8b328ff2ec0580$var$dividerStyles
            }),
            (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                css: [
                    $fc6840133e04adc0$var$$6a8b328ff2ec0580$var$rowStyles,
                    (0, $74Zh5.css)({
                        marginTop: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.150")
                    })
                ],
                children: [
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$export$a8a3e93435678ff9, {
                        level: 6,
                        children: "Total"
                    }),
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$export$a8a3e93435678ff9, {
                        level: 6,
                        children: $fc6840133e04adc0$var$$6a8b328ff2ec0580$var$asCurrency(total, currency)
                    })
                ]
            }),
            (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                css: $fc6840133e04adc0$var$$6a8b328ff2ec0580$var$paymentMethodRowStyles,
                children: [
                    (0, $6bec4f26b2cb3094$export$25062201e9e25d76)($fc6840133e04adc0$export$5f1af8db9871e1d6, {
                        size: "small",
                        color: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.text.subtlest"),
                        children: [
                            "Payment Method: ",
                            paymentMethod
                        ]
                    }),
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$export$5f1af8db9871e1d6, {
                        size: "small",
                        color: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.text.subtlest"),
                        children: itemCountText
                    })
                ]
            }),
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                css: $fc6840133e04adc0$var$$6a8b328ff2ec0580$var$buttonRowStyles,
                children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$export$353f5b6fc5456de1, {
                    label: "Review Purchase",
                    appearance: $fc6840133e04adc0$export$261c9483fc4a455a.PRIMARY,
                    fullWidth: true,
                    size: $fc6840133e04adc0$export$5dd2748b7940a2a0.LARGE,
                    onClick: ()=>setIsOpen(true)
                })
            }),
            isOpen && (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $9406e400bdd02ea1$export$2e2bcd8739ae039), {
                onClose: ()=>setIsOpen(false),
                children: (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                    css: $fc6840133e04adc0$var$$6a8b328ff2ec0580$var$modalContainerStyles,
                    children: [
                        (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                            css: $fc6840133e04adc0$var$$6a8b328ff2ec0580$var$modalHeaderStyles,
                            children: [
                                (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$export$a8a3e93435678ff9, {
                                    level: 3,
                                    children: "Review and Confirm"
                                }),
                                (0, $6bec4f26b2cb3094$export$25062201e9e25d76)($fc6840133e04adc0$export$5f1af8db9871e1d6, {
                                    size: "small",
                                    color: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.text.subtlest"),
                                    children: [
                                        currency,
                                        " \u2022 ",
                                        paymentMethod
                                    ]
                                })
                            ]
                        }),
                        (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                            css: $fc6840133e04adc0$var$$6a8b328ff2ec0580$var$modalSectionStyles,
                            children: items.map((item, idx)=>(0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                                    css: $fc6840133e04adc0$var$$6a8b328ff2ec0580$var$itemRowStyles,
                                    children: [
                                        (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$export$5f1af8db9871e1d6, {
                                            children: item.name
                                        }),
                                        (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$export$5f1af8db9871e1d6, {
                                            children: $fc6840133e04adc0$var$$6a8b328ff2ec0580$var$asCurrency(item.price, currency)
                                        })
                                    ]
                                }, `${item.name}-${idx}`))
                        }),
                        (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                            css: $fc6840133e04adc0$var$$6a8b328ff2ec0580$var$dividerStyles
                        }),
                        (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                            css: $fc6840133e04adc0$var$$6a8b328ff2ec0580$var$modalTotalsStyles,
                            children: [
                                (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                                    css: $fc6840133e04adc0$var$$6a8b328ff2ec0580$var$itemRowStyles,
                                    children: [
                                        (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$export$5f1af8db9871e1d6, {
                                            children: "Subtotal"
                                        }),
                                        (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$export$5f1af8db9871e1d6, {
                                            children: $fc6840133e04adc0$var$$6a8b328ff2ec0580$var$asCurrency(subtotal, currency)
                                        })
                                    ]
                                }),
                                (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                                    css: $fc6840133e04adc0$var$$6a8b328ff2ec0580$var$itemRowStyles,
                                    children: [
                                        (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$export$5f1af8db9871e1d6, {
                                            children: "Sales Tax"
                                        }),
                                        (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$export$5f1af8db9871e1d6, {
                                            children: $fc6840133e04adc0$var$$6a8b328ff2ec0580$var$asCurrency(salesTax, currency)
                                        })
                                    ]
                                }),
                                (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
                                    css: [
                                        $fc6840133e04adc0$var$$6a8b328ff2ec0580$var$itemRowStyles,
                                        (0, $74Zh5.css)({
                                            marginTop: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.150")
                                        })
                                    ],
                                    children: [
                                        (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$export$a8a3e93435678ff9, {
                                            level: 6,
                                            children: "Total"
                                        }),
                                        (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$export$a8a3e93435678ff9, {
                                            level: 6,
                                            children: $fc6840133e04adc0$var$$6a8b328ff2ec0580$var$asCurrency(total, currency)
                                        })
                                    ]
                                })
                            ]
                        }),
                        (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                            css: $fc6840133e04adc0$var$$6a8b328ff2ec0580$var$modalButtonRowStyles,
                            children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$export$353f5b6fc5456de1, {
                                label: "Confirm Purchase",
                                appearance: $fc6840133e04adc0$export$261c9483fc4a455a.PRIMARY,
                                onClick: ()=>setIsOpen(false)
                            })
                        })
                    ]
                })
            })
        ]
    });
};
const $fc6840133e04adc0$var$$6a8b328ff2ec0580$var$containerStyles = (0, $74Zh5.css)({
    padding: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.300"),
    border: `1px solid ${(0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.border")}`,
    borderRadius: "8px",
    backgroundColor: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.background.input")
});
const $fc6840133e04adc0$var$$6a8b328ff2ec0580$var$rowStyles = (0, $74Zh5.css)({
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    paddingTop: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.100")
});
const $fc6840133e04adc0$var$$6a8b328ff2ec0580$var$dividerStyles = (0, $74Zh5.css)({
    height: 1,
    backgroundColor: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.border"),
    marginTop: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.250")
});
const $fc6840133e04adc0$var$$6a8b328ff2ec0580$var$paymentMethodRowStyles = (0, $74Zh5.css)({
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    marginTop: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.100")
});
const $fc6840133e04adc0$var$$6a8b328ff2ec0580$var$buttonRowStyles = (0, $74Zh5.css)({
    marginTop: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.300")
});
const $fc6840133e04adc0$var$$6a8b328ff2ec0580$var$modalContainerStyles = (0, $74Zh5.css)({
    padding: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.300"),
    backgroundColor: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.background.input"),
    borderRadius: "8px",
    minWidth: "560px"
});
const $fc6840133e04adc0$var$$6a8b328ff2ec0580$var$modalHeaderStyles = (0, $74Zh5.css)({
    marginBottom: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.300")
});
const $fc6840133e04adc0$var$$6a8b328ff2ec0580$var$modalSectionStyles = (0, $74Zh5.css)({
    display: "flex",
    flexDirection: "column",
    gap: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.100")
});
const $fc6840133e04adc0$var$$6a8b328ff2ec0580$var$itemRowStyles = (0, $74Zh5.css)({
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between"
});
const $fc6840133e04adc0$var$$6a8b328ff2ec0580$var$modalTotalsStyles = (0, $74Zh5.css)({
    marginTop: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.250")
});
const $fc6840133e04adc0$var$$6a8b328ff2ec0580$var$modalButtonRowStyles = (0, $74Zh5.css)({
    marginTop: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.400"),
    display: "flex",
    justifyContent: "center"
});
var $fc6840133e04adc0$var$$6a8b328ff2ec0580$export$2e2bcd8739ae039 = $fc6840133e04adc0$export$fde280adb8350d09;
var $fc6840133e04adc0$var$$2397677ef2f4ee69$exports = {};
$fc6840133e04adc0$var$$parcel$defineInteropFlag($fc6840133e04adc0$var$$2397677ef2f4ee69$exports);
$fc6840133e04adc0$var$$parcel$export($fc6840133e04adc0$var$$2397677ef2f4ee69$exports, "Orders", ()=>$fc6840133e04adc0$export$ed0df17bf864fd7b);
$fc6840133e04adc0$var$$parcel$export($fc6840133e04adc0$var$$2397677ef2f4ee69$exports, "default", ()=>$fc6840133e04adc0$var$$2397677ef2f4ee69$export$2e2bcd8739ae039);
const $fc6840133e04adc0$var$$2397677ef2f4ee69$var$containerStyles = (0, $74Zh5.css)({
    padding: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.300"),
    border: `1px solid ${(0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.border")}`,
    borderRadius: "8px",
    backgroundColor: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.background.input")
});
const $fc6840133e04adc0$var$$2397677ef2f4ee69$var$headerStyles = (0, $74Zh5.css)({
    marginBottom: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("space.200")
});
const $fc6840133e04adc0$var$$2397677ef2f4ee69$var$amountToUsd = (amount)=>{
    const dollars = (amount / 100).toFixed(2);
    return `USD $${dollars}`;
};
const $fc6840133e04adc0$export$ed0df17bf864fd7b = ({ orders: orders })=>{
    return (0, $6bec4f26b2cb3094$export$25062201e9e25d76)("div", {
        css: $fc6840133e04adc0$var$$2397677ef2f4ee69$var$containerStyles,
        children: [
            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)("div", {
                css: $fc6840133e04adc0$var$$2397677ef2f4ee69$var$headerStyles,
                children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$export$a8a3e93435678ff9, {
                    level: 4,
                    children: "Transactions"
                })
            }),
            (0, $6bec4f26b2cb3094$export$25062201e9e25d76)((0, $1c9849e9ca2bf87c$export$2e2bcd8739ae039), {
                children: [
                    (0, $6bec4f26b2cb3094$export$25062201e9e25d76)((0, $46ca8edaccb96b62$export$2e2bcd8739ae039), {
                        children: [
                            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $017ea8a39e3f2896$export$2e2bcd8739ae039), {
                                width: "20%",
                                children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$export$5f1af8db9871e1d6, {
                                    size: "small",
                                    color: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.text.subtlest"),
                                    children: "Date"
                                })
                            }),
                            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $017ea8a39e3f2896$export$2e2bcd8739ae039), {
                                children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$export$5f1af8db9871e1d6, {
                                    size: "small",
                                    color: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.text.subtlest"),
                                    children: "Purchase Info"
                                })
                            }),
                            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $017ea8a39e3f2896$export$2e2bcd8739ae039), {
                                width: "20%",
                                children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$export$5f1af8db9871e1d6, {
                                    size: "small",
                                    color: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.text.subtlest"),
                                    children: "Payment Method"
                                })
                            }),
                            (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $017ea8a39e3f2896$export$2e2bcd8739ae039), {
                                width: "20%",
                                children: (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$export$5f1af8db9871e1d6, {
                                    size: "small",
                                    color: (0, $4a23d292896bbb64$export$2e2bcd8739ae039)("color.text.subtlest"),
                                    children: "Price"
                                })
                            })
                        ]
                    }),
                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $722a9df093eb8cc5$export$2e2bcd8739ae039), {
                        children: orders.map((o)=>(0, $6bec4f26b2cb3094$export$25062201e9e25d76)((0, $1df2a8a5055de686$export$2e2bcd8739ae039), {
                                children: [
                                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $db2ca91e0d53ac06$export$9cf5b401f969f5e3), {
                                        children: o.date
                                    }),
                                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $db2ca91e0d53ac06$export$9cf5b401f969f5e3), {
                                        children: o.summary
                                    }),
                                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $db2ca91e0d53ac06$export$9cf5b401f969f5e3), {
                                        children: o.paymentMethod
                                    }),
                                    (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)((0, $db2ca91e0d53ac06$export$9cf5b401f969f5e3), {
                                        children: $fc6840133e04adc0$var$$2397677ef2f4ee69$var$amountToUsd(o.totalAmount)
                                    })
                                ]
                            }, o.id))
                    })
                ]
            })
        ]
    });
};
var $fc6840133e04adc0$var$$2397677ef2f4ee69$export$2e2bcd8739ae039 = $fc6840133e04adc0$export$ed0df17bf864fd7b;
$fc6840133e04adc0$var$$parcel$exportWildcard($fc6840133e04adc0$var$$6e379ec2eca3d7d3$exports, $fc6840133e04adc0$var$$83fc18f8199a12ff$exports);
$fc6840133e04adc0$var$$parcel$exportWildcard($fc6840133e04adc0$var$$6e379ec2eca3d7d3$exports, $fc6840133e04adc0$var$$438c82700c218044$exports);
$fc6840133e04adc0$var$$parcel$exportWildcard($fc6840133e04adc0$var$$6e379ec2eca3d7d3$exports, $fc6840133e04adc0$var$$389dbaf1c04dd698$exports);
$fc6840133e04adc0$var$$parcel$exportWildcard($fc6840133e04adc0$var$$6e379ec2eca3d7d3$exports, $fc6840133e04adc0$var$$c18917e553fd2737$exports);
$fc6840133e04adc0$var$$parcel$exportWildcard($fc6840133e04adc0$var$$6e379ec2eca3d7d3$exports, $fc6840133e04adc0$var$$3ca3d702a74367ba$exports);
$fc6840133e04adc0$var$$parcel$exportWildcard($fc6840133e04adc0$var$$6e379ec2eca3d7d3$exports, $fc6840133e04adc0$var$$e018ab7ed2648ae8$exports);
$fc6840133e04adc0$var$$parcel$exportWildcard($fc6840133e04adc0$var$$6e379ec2eca3d7d3$exports, $fc6840133e04adc0$var$$81dd635d83decaee$exports);
$fc6840133e04adc0$var$$parcel$exportWildcard($fc6840133e04adc0$var$$6e379ec2eca3d7d3$exports, $fc6840133e04adc0$var$$8d99d7c025746ac9$exports);
$fc6840133e04adc0$var$$parcel$exportWildcard($fc6840133e04adc0$var$$6e379ec2eca3d7d3$exports, $fc6840133e04adc0$var$$1f7c4876f10b107b$exports);
$fc6840133e04adc0$var$$parcel$exportWildcard($fc6840133e04adc0$var$$6e379ec2eca3d7d3$exports, $fc6840133e04adc0$var$$c5616d3f1657fc84$exports);
$fc6840133e04adc0$var$$parcel$exportWildcard($fc6840133e04adc0$var$$6e379ec2eca3d7d3$exports, $fc6840133e04adc0$var$$eb6f767c51421421$exports);
$fc6840133e04adc0$var$$parcel$exportWildcard($fc6840133e04adc0$var$$6e379ec2eca3d7d3$exports, $fc6840133e04adc0$var$$7fe7e19d380f3d34$exports);
$fc6840133e04adc0$var$$parcel$exportWildcard($fc6840133e04adc0$var$$6e379ec2eca3d7d3$exports, $fc6840133e04adc0$var$$915f5687b3b07750$exports);
$fc6840133e04adc0$var$$parcel$exportWildcard($fc6840133e04adc0$var$$6e379ec2eca3d7d3$exports, $fc6840133e04adc0$var$$579f9ef2424e0bd8$exports);
$fc6840133e04adc0$var$$parcel$exportWildcard($fc6840133e04adc0$var$$6e379ec2eca3d7d3$exports, $fc6840133e04adc0$var$$d559b1cc82536c49$exports);
$fc6840133e04adc0$var$$parcel$exportWildcard($fc6840133e04adc0$var$$6e379ec2eca3d7d3$exports, $fc6840133e04adc0$var$$fa53e9c0a1746730$exports);
$fc6840133e04adc0$var$$parcel$exportWildcard($fc6840133e04adc0$var$$6e379ec2eca3d7d3$exports, $fc6840133e04adc0$var$$9225344cd5d1f99b$exports);
$fc6840133e04adc0$var$$parcel$exportWildcard($fc6840133e04adc0$var$$6e379ec2eca3d7d3$exports, $fc6840133e04adc0$var$$3b9afd8fe4435353$exports);
$fc6840133e04adc0$var$$parcel$exportWildcard($fc6840133e04adc0$var$$6e379ec2eca3d7d3$exports, $fc6840133e04adc0$var$$050a30fc95775cfd$exports);
$fc6840133e04adc0$var$$parcel$exportWildcard($fc6840133e04adc0$var$$6e379ec2eca3d7d3$exports, $fc6840133e04adc0$var$$65703ff0bcd12648$exports);
$fc6840133e04adc0$var$$parcel$exportWildcard($fc6840133e04adc0$var$$6e379ec2eca3d7d3$exports, $fc6840133e04adc0$var$$8340d81aba797956$exports);
$fc6840133e04adc0$var$$parcel$exportWildcard($fc6840133e04adc0$var$$6e379ec2eca3d7d3$exports, $fc6840133e04adc0$var$$dbb9d5792c296a49$exports);
$fc6840133e04adc0$var$$parcel$exportWildcard($fc6840133e04adc0$var$$6e379ec2eca3d7d3$exports, $fc6840133e04adc0$var$$2cfa64583f556289$exports);
$fc6840133e04adc0$var$$parcel$exportWildcard($fc6840133e04adc0$var$$6e379ec2eca3d7d3$exports, $fc6840133e04adc0$var$$44303f6c3c81eeac$exports);
$fc6840133e04adc0$var$$parcel$exportWildcard($fc6840133e04adc0$var$$6e379ec2eca3d7d3$exports, $fc6840133e04adc0$var$$9c3f769544bb2079$exports);
$fc6840133e04adc0$var$$parcel$exportWildcard($fc6840133e04adc0$var$$6e379ec2eca3d7d3$exports, $fc6840133e04adc0$var$$3d76652bb6362040$exports);
$fc6840133e04adc0$var$$parcel$exportWildcard($fc6840133e04adc0$var$$6e379ec2eca3d7d3$exports, $fc6840133e04adc0$var$$764442aba3de2fce$exports);
$fc6840133e04adc0$var$$parcel$exportWildcard($fc6840133e04adc0$var$$6e379ec2eca3d7d3$exports, $fc6840133e04adc0$var$$77282b3961d82199$exports);
$fc6840133e04adc0$var$$parcel$exportWildcard($fc6840133e04adc0$var$$6e379ec2eca3d7d3$exports, $fc6840133e04adc0$var$$4c35f7fd4ad5f13f$exports);
$fc6840133e04adc0$var$$parcel$exportWildcard($fc6840133e04adc0$var$$6e379ec2eca3d7d3$exports, $fc6840133e04adc0$var$$d8ee29df49af8811$exports);
$fc6840133e04adc0$var$$parcel$exportWildcard($fc6840133e04adc0$var$$6e379ec2eca3d7d3$exports, $fc6840133e04adc0$var$$27d686e47ff412fd$exports);
$fc6840133e04adc0$var$$parcel$exportWildcard($fc6840133e04adc0$var$$6e379ec2eca3d7d3$exports, $fc6840133e04adc0$var$$a4deb03146bf3bfc$exports);
$fc6840133e04adc0$var$$parcel$exportWildcard($fc6840133e04adc0$var$$6e379ec2eca3d7d3$exports, $fc6840133e04adc0$var$$0ae392c3008c8a3e$exports);
$fc6840133e04adc0$var$$parcel$exportWildcard($fc6840133e04adc0$var$$6e379ec2eca3d7d3$exports, $fc6840133e04adc0$var$$205ed41b47d90e33$exports);
$fc6840133e04adc0$var$$parcel$exportWildcard($fc6840133e04adc0$var$$6e379ec2eca3d7d3$exports, $fc6840133e04adc0$var$$3c691af970e2b3d8$exports);
$fc6840133e04adc0$var$$parcel$exportWildcard($fc6840133e04adc0$var$$6e379ec2eca3d7d3$exports, $fc6840133e04adc0$var$$5f9280667c666470$exports);
$fc6840133e04adc0$var$$parcel$exportWildcard($fc6840133e04adc0$var$$6e379ec2eca3d7d3$exports, $fc6840133e04adc0$var$$ec9b8ebbd21bd316$exports);
$fc6840133e04adc0$var$$parcel$exportWildcard($fc6840133e04adc0$var$$6e379ec2eca3d7d3$exports, $fc6840133e04adc0$var$$ffad026de847a971$exports);
$fc6840133e04adc0$var$$parcel$exportWildcard($fc6840133e04adc0$var$$6e379ec2eca3d7d3$exports, $fc6840133e04adc0$var$$0f989458047e435a$exports);
$fc6840133e04adc0$var$$parcel$exportWildcard($fc6840133e04adc0$var$$6e379ec2eca3d7d3$exports, $fc6840133e04adc0$var$$a7b3e1c0391fddac$exports);
$fc6840133e04adc0$var$$parcel$exportWildcard($fc6840133e04adc0$var$$6e379ec2eca3d7d3$exports, $fc6840133e04adc0$var$$ffc638203e092686$exports);
$fc6840133e04adc0$var$$parcel$exportWildcard($fc6840133e04adc0$var$$6e379ec2eca3d7d3$exports, $fc6840133e04adc0$var$$ed20910b93d89c3f$exports);
$fc6840133e04adc0$var$$parcel$exportWildcard($fc6840133e04adc0$var$$6e379ec2eca3d7d3$exports, $fc6840133e04adc0$var$$4dfe37aba1865d88$exports);
$fc6840133e04adc0$var$$parcel$exportWildcard($fc6840133e04adc0$var$$6e379ec2eca3d7d3$exports, $fc6840133e04adc0$var$$556680ce820612ab$exports);
$fc6840133e04adc0$var$$parcel$exportWildcard($fc6840133e04adc0$var$$6e379ec2eca3d7d3$exports, $fc6840133e04adc0$var$$6a8b328ff2ec0580$exports);
$fc6840133e04adc0$var$$parcel$exportWildcard($fc6840133e04adc0$var$$6e379ec2eca3d7d3$exports, $fc6840133e04adc0$var$$2397677ef2f4ee69$exports);
var $fc6840133e04adc0$var$$0cf4554ad00467b5$exports = {};
var $fc6840133e04adc0$var$$a3d28c94a229f94e$exports = {};
$fc6840133e04adc0$var$$parcel$export($fc6840133e04adc0$var$$a3d28c94a229f94e$exports, "CommunityLogo", ()=>$fc6840133e04adc0$export$311e5e9ca09eea69);
$fc6840133e04adc0$var$$parcel$export($fc6840133e04adc0$var$$a3d28c94a229f94e$exports, "CommunityNavigation", ()=>$fc6840133e04adc0$export$901cb8c9de2be2aa);
$fc6840133e04adc0$var$$parcel$export($fc6840133e04adc0$var$$a3d28c94a229f94e$exports, "AnalyticsActivityType", ()=>$fc6840133e04adc0$export$d778a884eb401313);
$fc6840133e04adc0$var$$parcel$export($fc6840133e04adc0$var$$a3d28c94a229f94e$exports, "EventType", ()=>$fc6840133e04adc0$export$3d7865934588d77e);
$fc6840133e04adc0$var$$parcel$export($fc6840133e04adc0$var$$a3d28c94a229f94e$exports, "CommunityApp", ()=>$fc6840133e04adc0$export$93d048dc21eb282a);
$fc6840133e04adc0$var$$parcel$export($fc6840133e04adc0$var$$a3d28c94a229f94e$exports, "MenuItemWithAnalytics", ()=>$fc6840133e04adc0$export$92905cc84b82619c);
$fc6840133e04adc0$var$$parcel$export($fc6840133e04adc0$var$$a3d28c94a229f94e$exports, "APP_BUTTONS", ()=>$fc6840133e04adc0$export$208c68d48dfc9a12);
$fc6840133e04adc0$var$$parcel$export($fc6840133e04adc0$var$$a3d28c94a229f94e$exports, "getAppButtons", ()=>$fc6840133e04adc0$export$67e61a6fa639f224);
const $fc6840133e04adc0$export$311e5e9ca09eea69 = ({ subtitleHref: subtitleHref, analyticsInfo: analyticsInfo })=>{
    return (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$var$$341f96d5922d8aaa$export$5aa64ab1f07d6e00, {
        subtitleHref: subtitleHref,
        label: "Community homepage",
        logoSubtitle: "Community",
        analyticsInfo: analyticsInfo
    });
};
const $fc6840133e04adc0$var$$a3d28c94a229f94e$var$renderAppButtons = (currentApp, subMenuContentByApp, isLoggedIn, analyticsInfo, forumsLoggedInRedirectHref, email, showNewMenu)=>{
    const loginState = isLoggedIn ? "loggedIn" : "loggedOut";
    return $fc6840133e04adc0$export$67e61a6fa639f224(email).map((button)=>{
        if (button.app === $fc6840133e04adc0$export$93d048dc21eb282a.FORUMS && isLoggedIn && forumsLoggedInRedirectHref) button.href[loginState] += forumsLoggedInRedirectHref;
        return (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$var$$341f96d5922d8aaa$export$b18dbc162161ec9c, {
            isSelected: button.app === currentApp,
            link: {
                text: button.label,
                href: button.href[loginState],
                target: button.target
            },
            expandableBodyContent: subMenuContentByApp?.[button.app],
            destinationApp: button.app,
            analyticsInfo: analyticsInfo,
            showNewMenu: showNewMenu
        }, button.app);
    });
};
const $fc6840133e04adc0$export$901cb8c9de2be2aa = ({ currentApp: currentApp, isLoggedIn: isLoggedIn, user: user, loginHref: loginHref, signupHref: signupHref, logoutHref: logoutHref, switchHref: switchHref, subMenuContentByApp: subMenuContentByApp, onAnalyticsSendEvent: onAnalyticsSendEvent, forumsLoggedInRedirectHref: forumsLoggedInRedirectHref, isSticky: isSticky = true, showChampions: showChampions = false, email: email, showNewMenu: showNewMenu = false })=>{
    const loginState = isLoggedIn ? "loggedIn" : "loggedOut";
    const homeHref = (0, $5FkrB.useMemo)(()=>$fc6840133e04adc0$var$$1ff01338112cd7fe$export$d349399b473d7299[loginState], [
        loginState
    ]);
    const isMobileOrTablet = $fc6840133e04adc0$export$32d5543ab307c01(`(max-width: ${$fc6840133e04adc0$var$$f0285f05d4d9f8a0$export$426e07cd0772984d.TABLET.MAX_WIDTH}px)`);
    const analyticsInfo = onAnalyticsSendEvent ? {
        currentApp: currentApp,
        isLoggedIn: isLoggedIn,
        isMobileOrTablet: isMobileOrTablet,
        onAnalyticsSendEvent: onAnalyticsSendEvent
    } : undefined;
    // Build left items
    let leftItems = [
        ...$fc6840133e04adc0$var$$a3d28c94a229f94e$var$renderAppButtons(currentApp, subMenuContentByApp, isLoggedIn, analyticsInfo, forumsLoggedInRedirectHref, email, showNewMenu)
    ];
    if (!showChampions) leftItems = leftItems.filter((item)=>item.key !== $fc6840133e04adc0$export$93d048dc21eb282a.CHAMPIONS);
    // Create logo item
    const logoItem = (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$export$311e5e9ca09eea69, {
        subtitleHref: homeHref,
        analyticsInfo: analyticsInfo
    }, "community-logo");
    return (0, $6bec4f26b2cb3094$export$34b9dba7ce09269b)($fc6840133e04adc0$export$fddd19fbf4d591d8, {
        logoItem: logoItem,
        leftItems: leftItems,
        isLoggedIn: isLoggedIn,
        user: user,
        loginHref: loginHref,
        signupHref: signupHref,
        logoutHref: logoutHref,
        switchHref: switchHref,
        profileHref: $fc6840133e04adc0$var$$1ff01338112cd7fe$export$132b2bf91782e62b,
        settingsHref: $fc6840133e04adc0$var$$1ff01338112cd7fe$export$b9cc8022ec117e91,
        onAnalyticsSendEvent: onAnalyticsSendEvent,
        isSticky: isSticky,
        showNewMenu: showNewMenu,
        currentApp: currentApp
    });
};
$fc6840133e04adc0$var$$parcel$exportWildcard($fc6840133e04adc0$var$$0cf4554ad00467b5$exports, $fc6840133e04adc0$var$$a3d28c94a229f94e$exports);
$fc6840133e04adc0$var$$parcel$exportWildcard($fc6840133e04adc0$var$$a69491ea5a126553$exports, $fc6840133e04adc0$var$$5d4509b60606b6df$exports);
$fc6840133e04adc0$var$$parcel$exportWildcard($fc6840133e04adc0$var$$a69491ea5a126553$exports, $fc6840133e04adc0$var$$6e379ec2eca3d7d3$exports);
$fc6840133e04adc0$var$$parcel$exportWildcard($fc6840133e04adc0$var$$a69491ea5a126553$exports, $fc6840133e04adc0$var$$a6a41c835fd01d00$exports);
$fc6840133e04adc0$var$$parcel$exportWildcard($fc6840133e04adc0$var$$a69491ea5a126553$exports, $fc6840133e04adc0$var$$0cf4554ad00467b5$exports);




var $3506c2b8472f3d94$var$_loadingSpinner = $3506c2b8472f3d94$var$_interopRequireDefault((parcelRequire("bAhZ8")));
function $3506c2b8472f3d94$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
function $3506c2b8472f3d94$var$_regeneratorRuntime() {
    "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ 
    $3506c2b8472f3d94$var$_regeneratorRuntime = function _regeneratorRuntime() {
        return e;
    };
    var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function(t, e, r) {
        t[e] = r.value;
    }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag";
    function define(t, e, r) {
        return Object.defineProperty(t, e, {
            value: r,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }), t[e];
    }
    try {
        define({}, "");
    } catch (t) {
        define = function define(t, e, r) {
            return t[e] = r;
        };
    }
    function wrap(t, e, r, n) {
        var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []);
        return o(a, "_invoke", {
            value: makeInvokeMethod(t, r, c)
        }), a;
    }
    function tryCatch(t, e, r) {
        try {
            return {
                type: "normal",
                arg: t.call(e, r)
            };
        } catch (t) {
            return {
                type: "throw",
                arg: t
            };
        }
    }
    e.wrap = wrap;
    var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {};
    function Generator() {}
    function GeneratorFunction() {}
    function GeneratorFunctionPrototype() {}
    var p = {};
    define(p, a, function() {
        return this;
    });
    var d = Object.getPrototypeOf, v = d && d(d(values([])));
    v && v !== r && n.call(v, a) && (p = v);
    var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p);
    function defineIteratorMethods(t) {
        [
            "next",
            "throw",
            "return"
        ].forEach(function(e) {
            define(t, e, function(t) {
                return this._invoke(e, t);
            });
        });
    }
    function AsyncIterator(t, e) {
        function invoke(r, o, i, a) {
            var c = tryCatch(t[r], t, o);
            if ("throw" !== c.type) {
                var u = c.arg, h = u.value;
                return h && "object" == $3506c2b8472f3d94$var$_typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function(t) {
                    invoke("next", t, i, a);
                }, function(t) {
                    invoke("throw", t, i, a);
                }) : e.resolve(h).then(function(t) {
                    u.value = t, i(u);
                }, function(t) {
                    return invoke("throw", t, i, a);
                });
            }
            a(c.arg);
        }
        var r;
        o(this, "_invoke", {
            value: function value(t, n) {
                function callInvokeWithMethodAndArg() {
                    return new e(function(e, r) {
                        invoke(t, n, e, r);
                    });
                }
                return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
            }
        });
    }
    function makeInvokeMethod(e, r, n) {
        var o = h;
        return function(i, a) {
            if (o === f) throw Error("Generator is already running");
            if (o === s) {
                if ("throw" === i) throw a;
                return {
                    value: t,
                    done: !0
                };
            }
            for(n.method = i, n.arg = a;;){
                var c = n.delegate;
                if (c) {
                    var u = maybeInvokeDelegate(c, n);
                    if (u) {
                        if (u === y) continue;
                        return u;
                    }
                }
                if ("next" === n.method) n.sent = n._sent = n.arg;
                else if ("throw" === n.method) {
                    if (o === h) throw o = s, n.arg;
                    n.dispatchException(n.arg);
                } else "return" === n.method && n.abrupt("return", n.arg);
                o = f;
                var p = tryCatch(e, r, n);
                if ("normal" === p.type) {
                    if (o = n.done ? s : l, p.arg === y) continue;
                    return {
                        value: p.arg,
                        done: n.done
                    };
                }
                "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg);
            }
        };
    }
    function maybeInvokeDelegate(e, r) {
        var n = r.method, o = e.iterator[n];
        if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y;
        var i = tryCatch(o, e.iterator, r.arg);
        if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y;
        var a = i.arg;
        return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y);
    }
    function pushTryEntry(t) {
        var e = {
            tryLoc: t[0]
        };
        1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e);
    }
    function resetTryEntry(t) {
        var e = t.completion || {};
        e.type = "normal", delete e.arg, t.completion = e;
    }
    function Context(t) {
        this.tryEntries = [
            {
                tryLoc: "root"
            }
        ], t.forEach(pushTryEntry, this), this.reset(!0);
    }
    function values(e) {
        if (e || "" === e) {
            var r = e[a];
            if (r) return r.call(e);
            if ("function" == typeof e.next) return e;
            if (!isNaN(e.length)) {
                var o = -1, i = function next() {
                    for(; ++o < e.length;)if (n.call(e, o)) return next.value = e[o], next.done = !1, next;
                    return next.value = t, next.done = !0, next;
                };
                return i.next = i;
            }
        }
        throw new TypeError($3506c2b8472f3d94$var$_typeof(e) + " is not iterable");
    }
    return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", {
        value: GeneratorFunctionPrototype,
        configurable: !0
    }), o(GeneratorFunctionPrototype, "constructor", {
        value: GeneratorFunction,
        configurable: !0
    }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function(t) {
        var e = "function" == typeof t && t.constructor;
        return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name));
    }, e.mark = function(t) {
        return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t;
    }, e.awrap = function(t) {
        return {
            __await: t
        };
    }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function() {
        return this;
    }), e.AsyncIterator = AsyncIterator, e.async = function(t, r, n, o, i) {
        void 0 === i && (i = Promise);
        var a = new AsyncIterator(wrap(t, r, n, o), i);
        return e.isGeneratorFunction(r) ? a : a.next().then(function(t) {
            return t.done ? t.value : a.next();
        });
    }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function() {
        return this;
    }), define(g, "toString", function() {
        return "[object Generator]";
    }), e.keys = function(t) {
        var e = Object(t), r = [];
        for(var n in e)r.push(n);
        return r.reverse(), function next() {
            for(; r.length;){
                var t = r.pop();
                if (t in e) return next.value = t, next.done = !1, next;
            }
            return next.done = !0, next;
        };
    }, e.values = values, Context.prototype = {
        constructor: Context,
        reset: function reset(e) {
            if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for(var r in this)"t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t);
        },
        stop: function stop() {
            this.done = !0;
            var t = this.tryEntries[0].completion;
            if ("throw" === t.type) throw t.arg;
            return this.rval;
        },
        dispatchException: function dispatchException(e) {
            if (this.done) throw e;
            var r = this;
            function handle(n, o) {
                return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o;
            }
            for(var o = this.tryEntries.length - 1; o >= 0; --o){
                var i = this.tryEntries[o], a = i.completion;
                if ("root" === i.tryLoc) return handle("end");
                if (i.tryLoc <= this.prev) {
                    var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc");
                    if (c && u) {
                        if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
                        if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
                    } else if (c) {
                        if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
                    } else {
                        if (!u) throw Error("try statement without catch or finally");
                        if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
                    }
                }
            }
        },
        abrupt: function abrupt(t, e) {
            for(var r = this.tryEntries.length - 1; r >= 0; --r){
                var o = this.tryEntries[r];
                if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
                    var i = o;
                    break;
                }
            }
            i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
            var a = i ? i.completion : {};
            return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a);
        },
        complete: function complete(t, e) {
            if ("throw" === t.type) throw t.arg;
            return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y;
        },
        finish: function finish(t) {
            for(var e = this.tryEntries.length - 1; e >= 0; --e){
                var r = this.tryEntries[e];
                if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y;
            }
        },
        "catch": function _catch(t) {
            for(var e = this.tryEntries.length - 1; e >= 0; --e){
                var r = this.tryEntries[e];
                if (r.tryLoc === t) {
                    var n = r.completion;
                    if ("throw" === n.type) {
                        var o = n.arg;
                        resetTryEntry(r);
                    }
                    return o;
                }
            }
            throw Error("illegal catch attempt");
        },
        delegateYield: function delegateYield(e, r, n) {
            return this.delegate = {
                iterator: values(e),
                resultName: r,
                nextLoc: n
            }, "next" === this.method && (this.arg = t), y;
        }
    }, e;
}
function $3506c2b8472f3d94$var$asyncGeneratorStep(n, t, e, r, o, a, c) {
    try {
        var i = n[a](c), u = i.value;
    } catch (n) {
        return void e(n);
    }
    i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function $3506c2b8472f3d94$var$_asyncToGenerator(n) {
    return function() {
        var t = this, e = arguments;
        return new Promise(function(r, o) {
            var a = n.apply(t, e);
            function _next(n) {
                $3506c2b8472f3d94$var$asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
            }
            function _throw(n) {
                $3506c2b8472f3d94$var$asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
            }
            _next(void 0);
        });
    };
}
function $3506c2b8472f3d94$var$_slicedToArray(r, e) {
    return $3506c2b8472f3d94$var$_arrayWithHoles(r) || $3506c2b8472f3d94$var$_iterableToArrayLimit(r, e) || $3506c2b8472f3d94$var$_unsupportedIterableToArray(r, e) || $3506c2b8472f3d94$var$_nonIterableRest();
}
function $3506c2b8472f3d94$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $3506c2b8472f3d94$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $3506c2b8472f3d94$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $3506c2b8472f3d94$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $3506c2b8472f3d94$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $3506c2b8472f3d94$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $3506c2b8472f3d94$var$_arrayWithHoles(r) {
    if (Array.isArray(r)) return r;
}
var $3506c2b8472f3d94$var$ConsentValidator = $3506c2b8472f3d94$exports.ConsentValidator = function ConsentValidator(_ref) {
    var coverImageSrc = _ref.coverImageSrc, children = _ref.children, onLogout = _ref.onLogout, aaid = _ref.aaid, isUserConsented = _ref.isUserConsented, onConsentError = _ref.onConsentError, onConsentSuccess = _ref.onConsentSuccess, env = _ref.env;
    var _React$useState = $3506c2b8472f3d94$var$_react["default"].useState(false), _React$useState2 = $3506c2b8472f3d94$var$_slicedToArray(_React$useState, 2), handledConsent = _React$useState2[0], setHandledConsent = _React$useState2[1];
    var _React$useState3 = $3506c2b8472f3d94$var$_react["default"].useState(false), _React$useState4 = $3506c2b8472f3d94$var$_slicedToArray(_React$useState3, 2), isLoading = _React$useState4[0], setIsLoading = _React$useState4[1];
    var _React$useState5 = $3506c2b8472f3d94$var$_react["default"].useState(false), _React$useState6 = $3506c2b8472f3d94$var$_slicedToArray(_React$useState5, 2), consentError = _React$useState6[0], setConsentError = _React$useState6[1];
    var handleConsentError = function handleConsentError() {
        onConsentError();
        setConsentError(true);
    };
    var handleUserConsent = function handleUserConsent() {
        $3506c2b8472f3d94$var$_asyncToGenerator(/*#__PURE__*/ $3506c2b8472f3d94$var$_regeneratorRuntime().mark(function _callee() {
            var consentResponse;
            return $3506c2b8472f3d94$var$_regeneratorRuntime().wrap(function _callee$(_context) {
                while(true)switch(_context.prev = _context.next){
                    case 0:
                        _context.prev = 0;
                        if (!(aaid && !consentError)) {
                            _context.next = 7;
                            break;
                        }
                        setIsLoading(true);
                        _context.next = 5;
                        return (0, $9274af858143a4bd$exports.setUserConsent)([
                            $000760bdf95e0c2b$exports.CONSENT_KEY.COMMUNITY,
                            $000760bdf95e0c2b$exports.CONSENT_KEY.PRIVACY
                        ], aaid, env);
                    case 5:
                        consentResponse = _context.sent;
                        // Tried to set consent but still false
                        if (!consentResponse) handleConsentError();
                        else if (onConsentSuccess) onConsentSuccess();
                    case 7:
                        _context.next = 12;
                        break;
                    case 9:
                        _context.prev = 9;
                        _context.t0 = _context["catch"](0);
                        handleConsentError();
                    case 12:
                        _context.prev = 12;
                        setIsLoading(false);
                        // We have either handled the error or succesfully consented
                        setHandledConsent(true);
                        return _context.finish(12);
                    case 16:
                    case "end":
                        return _context.stop();
                }
            }, _callee, null, [
                [
                    0,
                    9,
                    12,
                    16
                ]
            ]);
        }))();
    };
    if (isLoading) return /*#__PURE__*/ $3506c2b8472f3d94$var$_react["default"].createElement($3506c2b8472f3d94$var$_loadingSpinner["default"], null);
    // If not logged in, consent is true, or there is an error
    return !aaid || isUserConsented || handledConsent ? children : /*#__PURE__*/ $3506c2b8472f3d94$var$_react["default"].createElement($fc6840133e04adc0$export$9d12d42929c3fcf, {
        coverImageSrc: coverImageSrc,
        onAccept: handleUserConsent,
        onCancel: onLogout
    });
};


Object.keys($3506c2b8472f3d94$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $d9a56230c565b38a$exports && $d9a56230c565b38a$exports[key] === $3506c2b8472f3d94$exports[key]) return;
    Object.defineProperty($d9a56230c565b38a$exports, key, {
        enumerable: true,
        get: function get() {
            return $3506c2b8472f3d94$exports[key];
        }
    });
});
var $b50c793e04f4978b$exports = {};
"use strict";
function $b50c793e04f4978b$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $b50c793e04f4978b$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $b50c793e04f4978b$var$_typeof(o);
}
Object.defineProperty($b50c793e04f4978b$exports, "__esModule", {
    value: true
});
$b50c793e04f4978b$exports.ConsentValidator2 = void 0;

var $b50c793e04f4978b$var$_react = $b50c793e04f4978b$var$_interopRequireDefault((parcelRequire("5FkrB")));




var $b50c793e04f4978b$var$_loadingSpinner = $b50c793e04f4978b$var$_interopRequireDefault((parcelRequire("bAhZ8")));
function $b50c793e04f4978b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
function $b50c793e04f4978b$var$_regeneratorRuntime() {
    "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ 
    $b50c793e04f4978b$var$_regeneratorRuntime = function _regeneratorRuntime() {
        return e;
    };
    var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function(t, e, r) {
        t[e] = r.value;
    }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag";
    function define(t, e, r) {
        return Object.defineProperty(t, e, {
            value: r,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }), t[e];
    }
    try {
        define({}, "");
    } catch (t) {
        define = function define(t, e, r) {
            return t[e] = r;
        };
    }
    function wrap(t, e, r, n) {
        var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []);
        return o(a, "_invoke", {
            value: makeInvokeMethod(t, r, c)
        }), a;
    }
    function tryCatch(t, e, r) {
        try {
            return {
                type: "normal",
                arg: t.call(e, r)
            };
        } catch (t) {
            return {
                type: "throw",
                arg: t
            };
        }
    }
    e.wrap = wrap;
    var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {};
    function Generator() {}
    function GeneratorFunction() {}
    function GeneratorFunctionPrototype() {}
    var p = {};
    define(p, a, function() {
        return this;
    });
    var d = Object.getPrototypeOf, v = d && d(d(values([])));
    v && v !== r && n.call(v, a) && (p = v);
    var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p);
    function defineIteratorMethods(t) {
        [
            "next",
            "throw",
            "return"
        ].forEach(function(e) {
            define(t, e, function(t) {
                return this._invoke(e, t);
            });
        });
    }
    function AsyncIterator(t, e) {
        function invoke(r, o, i, a) {
            var c = tryCatch(t[r], t, o);
            if ("throw" !== c.type) {
                var u = c.arg, h = u.value;
                return h && "object" == $b50c793e04f4978b$var$_typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function(t) {
                    invoke("next", t, i, a);
                }, function(t) {
                    invoke("throw", t, i, a);
                }) : e.resolve(h).then(function(t) {
                    u.value = t, i(u);
                }, function(t) {
                    return invoke("throw", t, i, a);
                });
            }
            a(c.arg);
        }
        var r;
        o(this, "_invoke", {
            value: function value(t, n) {
                function callInvokeWithMethodAndArg() {
                    return new e(function(e, r) {
                        invoke(t, n, e, r);
                    });
                }
                return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
            }
        });
    }
    function makeInvokeMethod(e, r, n) {
        var o = h;
        return function(i, a) {
            if (o === f) throw Error("Generator is already running");
            if (o === s) {
                if ("throw" === i) throw a;
                return {
                    value: t,
                    done: !0
                };
            }
            for(n.method = i, n.arg = a;;){
                var c = n.delegate;
                if (c) {
                    var u = maybeInvokeDelegate(c, n);
                    if (u) {
                        if (u === y) continue;
                        return u;
                    }
                }
                if ("next" === n.method) n.sent = n._sent = n.arg;
                else if ("throw" === n.method) {
                    if (o === h) throw o = s, n.arg;
                    n.dispatchException(n.arg);
                } else "return" === n.method && n.abrupt("return", n.arg);
                o = f;
                var p = tryCatch(e, r, n);
                if ("normal" === p.type) {
                    if (o = n.done ? s : l, p.arg === y) continue;
                    return {
                        value: p.arg,
                        done: n.done
                    };
                }
                "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg);
            }
        };
    }
    function maybeInvokeDelegate(e, r) {
        var n = r.method, o = e.iterator[n];
        if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y;
        var i = tryCatch(o, e.iterator, r.arg);
        if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y;
        var a = i.arg;
        return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y);
    }
    function pushTryEntry(t) {
        var e = {
            tryLoc: t[0]
        };
        1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e);
    }
    function resetTryEntry(t) {
        var e = t.completion || {};
        e.type = "normal", delete e.arg, t.completion = e;
    }
    function Context(t) {
        this.tryEntries = [
            {
                tryLoc: "root"
            }
        ], t.forEach(pushTryEntry, this), this.reset(!0);
    }
    function values(e) {
        if (e || "" === e) {
            var r = e[a];
            if (r) return r.call(e);
            if ("function" == typeof e.next) return e;
            if (!isNaN(e.length)) {
                var o = -1, i = function next() {
                    for(; ++o < e.length;)if (n.call(e, o)) return next.value = e[o], next.done = !1, next;
                    return next.value = t, next.done = !0, next;
                };
                return i.next = i;
            }
        }
        throw new TypeError($b50c793e04f4978b$var$_typeof(e) + " is not iterable");
    }
    return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", {
        value: GeneratorFunctionPrototype,
        configurable: !0
    }), o(GeneratorFunctionPrototype, "constructor", {
        value: GeneratorFunction,
        configurable: !0
    }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function(t) {
        var e = "function" == typeof t && t.constructor;
        return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name));
    }, e.mark = function(t) {
        return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t;
    }, e.awrap = function(t) {
        return {
            __await: t
        };
    }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function() {
        return this;
    }), e.AsyncIterator = AsyncIterator, e.async = function(t, r, n, o, i) {
        void 0 === i && (i = Promise);
        var a = new AsyncIterator(wrap(t, r, n, o), i);
        return e.isGeneratorFunction(r) ? a : a.next().then(function(t) {
            return t.done ? t.value : a.next();
        });
    }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function() {
        return this;
    }), define(g, "toString", function() {
        return "[object Generator]";
    }), e.keys = function(t) {
        var e = Object(t), r = [];
        for(var n in e)r.push(n);
        return r.reverse(), function next() {
            for(; r.length;){
                var t = r.pop();
                if (t in e) return next.value = t, next.done = !1, next;
            }
            return next.done = !0, next;
        };
    }, e.values = values, Context.prototype = {
        constructor: Context,
        reset: function reset(e) {
            if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for(var r in this)"t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t);
        },
        stop: function stop() {
            this.done = !0;
            var t = this.tryEntries[0].completion;
            if ("throw" === t.type) throw t.arg;
            return this.rval;
        },
        dispatchException: function dispatchException(e) {
            if (this.done) throw e;
            var r = this;
            function handle(n, o) {
                return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o;
            }
            for(var o = this.tryEntries.length - 1; o >= 0; --o){
                var i = this.tryEntries[o], a = i.completion;
                if ("root" === i.tryLoc) return handle("end");
                if (i.tryLoc <= this.prev) {
                    var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc");
                    if (c && u) {
                        if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
                        if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
                    } else if (c) {
                        if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
                    } else {
                        if (!u) throw Error("try statement without catch or finally");
                        if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
                    }
                }
            }
        },
        abrupt: function abrupt(t, e) {
            for(var r = this.tryEntries.length - 1; r >= 0; --r){
                var o = this.tryEntries[r];
                if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
                    var i = o;
                    break;
                }
            }
            i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
            var a = i ? i.completion : {};
            return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a);
        },
        complete: function complete(t, e) {
            if ("throw" === t.type) throw t.arg;
            return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y;
        },
        finish: function finish(t) {
            for(var e = this.tryEntries.length - 1; e >= 0; --e){
                var r = this.tryEntries[e];
                if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y;
            }
        },
        "catch": function _catch(t) {
            for(var e = this.tryEntries.length - 1; e >= 0; --e){
                var r = this.tryEntries[e];
                if (r.tryLoc === t) {
                    var n = r.completion;
                    if ("throw" === n.type) {
                        var o = n.arg;
                        resetTryEntry(r);
                    }
                    return o;
                }
            }
            throw Error("illegal catch attempt");
        },
        delegateYield: function delegateYield(e, r, n) {
            return this.delegate = {
                iterator: values(e),
                resultName: r,
                nextLoc: n
            }, "next" === this.method && (this.arg = t), y;
        }
    }, e;
}
function $b50c793e04f4978b$var$asyncGeneratorStep(n, t, e, r, o, a, c) {
    try {
        var i = n[a](c), u = i.value;
    } catch (n) {
        return void e(n);
    }
    i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function $b50c793e04f4978b$var$_asyncToGenerator(n) {
    return function() {
        var t = this, e = arguments;
        return new Promise(function(r, o) {
            var a = n.apply(t, e);
            function _next(n) {
                $b50c793e04f4978b$var$asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
            }
            function _throw(n) {
                $b50c793e04f4978b$var$asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
            }
            _next(void 0);
        });
    };
}
function $b50c793e04f4978b$var$_slicedToArray(r, e) {
    return $b50c793e04f4978b$var$_arrayWithHoles(r) || $b50c793e04f4978b$var$_iterableToArrayLimit(r, e) || $b50c793e04f4978b$var$_unsupportedIterableToArray(r, e) || $b50c793e04f4978b$var$_nonIterableRest();
}
function $b50c793e04f4978b$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $b50c793e04f4978b$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $b50c793e04f4978b$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $b50c793e04f4978b$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $b50c793e04f4978b$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $b50c793e04f4978b$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $b50c793e04f4978b$var$_arrayWithHoles(r) {
    if (Array.isArray(r)) return r;
}
var $b50c793e04f4978b$var$ConsentValidator2 = $b50c793e04f4978b$exports.ConsentValidator2 = function ConsentValidator2(_ref) {
    var coverImageSrc = _ref.coverImageSrc, children = _ref.children, onLogout = _ref.onLogout, aaid = _ref.aaid, isUserConsented = _ref.isUserConsented, onConsentError = _ref.onConsentError, onConsentSuccess = _ref.onConsentSuccess, onConsentComplete = _ref.onConsentComplete, env = _ref.env;
    var _React$useState = $b50c793e04f4978b$var$_react["default"].useState(false), _React$useState2 = $b50c793e04f4978b$var$_slicedToArray(_React$useState, 2), isLoading = _React$useState2[0], setIsLoading = _React$useState2[1];
    var handleUserConsent = function handleUserConsent() {
        $b50c793e04f4978b$var$_asyncToGenerator(/*#__PURE__*/ $b50c793e04f4978b$var$_regeneratorRuntime().mark(function _callee() {
            var consentResponse;
            return $b50c793e04f4978b$var$_regeneratorRuntime().wrap(function _callee$(_context) {
                while(true)switch(_context.prev = _context.next){
                    case 0:
                        _context.prev = 0;
                        if (aaid) {
                            _context.next = 5;
                            break;
                        }
                        onConsentError('missing_aaid', 'AAID is required');
                        _context.next = 10;
                        break;
                    case 5:
                        setIsLoading(true);
                        _context.next = 8;
                        return (0, $9274af858143a4bd$exports.setUserConsent)([
                            $000760bdf95e0c2b$exports.CONSENT_KEY.COMMUNITY,
                            $000760bdf95e0c2b$exports.CONSENT_KEY.PRIVACY
                        ], aaid, env);
                    case 8:
                        consentResponse = _context.sent;
                        // Tried to set consent but still false
                        if (!consentResponse) onConsentError('consent_failed', 'Failed to set consent');
                        else onConsentSuccess();
                    case 10:
                        _context.next = 15;
                        break;
                    case 12:
                        _context.prev = 12;
                        _context.t0 = _context["catch"](0);
                        onConsentError('consent_failed', 'Failed to set consent' + _context.t0.message);
                    case 15:
                        _context.prev = 15;
                        setIsLoading(false);
                        if (onConsentComplete) onConsentComplete();
                        return _context.finish(15);
                    case 19:
                    case "end":
                        return _context.stop();
                }
            }, _callee, null, [
                [
                    0,
                    12,
                    15,
                    19
                ]
            ]);
        }))();
    };
    if (isLoading) return /*#__PURE__*/ $b50c793e04f4978b$var$_react["default"].createElement($b50c793e04f4978b$var$_loadingSpinner["default"], null);
    // If not logged in, consent is true, or there is an error
    return isUserConsented ? children : /*#__PURE__*/ $b50c793e04f4978b$var$_react["default"].createElement($fc6840133e04adc0$export$9d12d42929c3fcf, {
        coverImageSrc: coverImageSrc,
        onAccept: handleUserConsent,
        onCancel: onLogout
    });
};


Object.keys($b50c793e04f4978b$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $d9a56230c565b38a$exports && $d9a56230c565b38a$exports[key] === $b50c793e04f4978b$exports[key]) return;
    Object.defineProperty($d9a56230c565b38a$exports, key, {
        enumerable: true,
        get: function get() {
            return $b50c793e04f4978b$exports[key];
        }
    });
});
var $5901c0f352881320$exports = {};
"use strict";
function $5901c0f352881320$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $5901c0f352881320$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $5901c0f352881320$var$_typeof(o);
}
Object.defineProperty($5901c0f352881320$exports, "__esModule", {
    value: true
});
$5901c0f352881320$exports.SuspenseExtender = void 0;

var $5901c0f352881320$var$_react = $5901c0f352881320$var$_interopRequireWildcard((parcelRequire("5FkrB")));
function $5901c0f352881320$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($5901c0f352881320$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $5901c0f352881320$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != $5901c0f352881320$var$_typeof(e) && "function" != typeof e) return {
        "default": e
    };
    var t = $5901c0f352881320$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
var $5901c0f352881320$var$SuspenseExtender = $5901c0f352881320$exports.SuspenseExtender = function SuspenseExtender(_ref) {
    var children = _ref.children, fallback = _ref.fallback, isReady = _ref.isReady;
    return /*#__PURE__*/ $5901c0f352881320$var$_react["default"].createElement($5901c0f352881320$var$_react.Suspense, {
        fallback: fallback
    }, isReady === null || isReady === undefined || isReady ? children : fallback);
};


Object.keys($5901c0f352881320$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $d9a56230c565b38a$exports && $d9a56230c565b38a$exports[key] === $5901c0f352881320$exports[key]) return;
    Object.defineProperty($d9a56230c565b38a$exports, key, {
        enumerable: true,
        get: function get() {
            return $5901c0f352881320$exports[key];
        }
    });
});

var $bAhZ8 = parcelRequire("bAhZ8");
Object.keys($bAhZ8).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $d9a56230c565b38a$exports && $d9a56230c565b38a$exports[key] === $bAhZ8[key]) return;
    Object.defineProperty($d9a56230c565b38a$exports, key, {
        enumerable: true,
        get: function get() {
            return $bAhZ8[key];
        }
    });
});
var $1964ee7f51f79709$exports = {};
"use strict";
function $1964ee7f51f79709$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $1964ee7f51f79709$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $1964ee7f51f79709$var$_typeof(o);
}
Object.defineProperty($1964ee7f51f79709$exports, "__esModule", {
    value: true
});
$1964ee7f51f79709$exports.Initializer = void 0;

var $1964ee7f51f79709$var$_react = $1964ee7f51f79709$var$_interopRequireWildcard((parcelRequire("5FkrB")));

var $1964ee7f51f79709$var$_loadingSpinner = $1964ee7f51f79709$var$_interopRequireDefault((parcelRequire("bAhZ8")));
var $bd858cf878484440$exports = {};
"use strict";
Object.defineProperty($bd858cf878484440$exports, "__esModule", {
    value: true
});
var $b39c9956eebb23a1$exports = {};
"use strict";
Object.defineProperty($b39c9956eebb23a1$exports, "__esModule", {
    value: true
});
var $eeec4b79607b6553$exports = {};
"use strict";
Object.defineProperty($eeec4b79607b6553$exports, "__esModule", {
    value: true
});
Object.defineProperty($eeec4b79607b6553$exports, "InitializeAutoAtlAnalytics", {
    enumerable: true,
    get: function get() {
        return $edca2caa766c402a$exports.InitializeAutoAtlAnalytics;
    }
});
var $edca2caa766c402a$exports = {};
"use strict";
Object.defineProperty($edca2caa766c402a$exports, "__esModule", {
    value: true
});
$edca2caa766c402a$exports.InitializeAutoAtlAnalytics = void 0;

var $5FkrB = parcelRequire("5FkrB");

var $kqp0i = parcelRequire("kqp0i");

var $5FkrB = parcelRequire("5FkrB");

var $hQ6Uq = parcelRequire("hQ6Uq");

var $25nEq = parcelRequire("25nEq");

var $ekGgq = parcelRequire("ekGgq");

var $5FkrB = parcelRequire("5FkrB");

var $hQ6Uq = parcelRequire("hQ6Uq");
function $64381d03c394a173$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $64381d03c394a173$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $64381d03c394a173$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $64381d03c394a173$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $64381d03c394a173$export$9ebb5a84d17e5d18() {
    var createEventMap = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var wrappedComponentProps = arguments.length > 1 ? arguments[1] : undefined;
    var _useAnalyticsEvents = (0, $hQ6Uq.useAnalyticsEvents)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
    var handlerCache = (0, $5FkrB.useRef)({});
    var patchedProps = (0, $5FkrB.useMemo)(function() {
        var cache = handlerCache.current;
        // Clean up no longer used handlers in cache
        Object.keys(cache).filter(function(key) {
            return !(key in createEventMap);
        }).forEach(function(key) {
            return delete cache[key];
        });
        return Object.keys(createEventMap).reduce(function(p, k) {
            var eventCreator = createEventMap[k];
            if (![
                'object',
                'function'
            ].includes((0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(eventCreator))) return p;
            var propValue = wrappedComponentProps[k];
            if (k in cache && cache[k].eventCreator === eventCreator && cache[k].propValue === propValue) return $64381d03c394a173$var$_objectSpread($64381d03c394a173$var$_objectSpread({}, p), {}, (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, k, cache[k].wrappedCallback));
            var wrappedCallback = function wrappedCallback() {
                var analyticsEvent = typeof eventCreator === 'function' ? eventCreator(createAnalyticsEvent, wrappedComponentProps) : createAnalyticsEvent(eventCreator);
                if (propValue && typeof propValue === 'function') {
                    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                    propValue.apply(void 0, args.concat([
                        analyticsEvent
                    ]));
                }
            };
            cache[k] = {
                eventCreator: eventCreator,
                wrappedCallback: wrappedCallback,
                propValue: propValue
            };
            return $64381d03c394a173$var$_objectSpread($64381d03c394a173$var$_objectSpread({}, p), {}, (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, k, wrappedCallback));
        }, {});
    }, [
        createEventMap,
        wrappedComponentProps,
        createAnalyticsEvent,
        handlerCache
    ]);
    return {
        patchedEventProps: patchedProps
    };
}


var $d5f32e7562891e94$var$withAnalyticsEvents = function withAnalyticsEvents() {
    var createEventMap = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return function(WrappedComponent) {
        var WithAnalyticsEvents = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function(props, ref) {
            var _usePatchedProps = (0, $64381d03c394a173$export$9ebb5a84d17e5d18)(createEventMap, props), patchedEventProps = _usePatchedProps.patchedEventProps;
            var _useAnalyticsEvents = (0, $hQ6Uq.useAnalyticsEvents)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(WrappedComponent, (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, props, patchedEventProps, {
                createAnalyticsEvent: createAnalyticsEvent,
                ref: ref
            }));
        });
        WithAnalyticsEvents.displayName = "WithAnalyticsEvents(".concat(WrappedComponent.displayName || WrappedComponent.name, ")");
        return WithAnalyticsEvents;
    };
};
var $d5f32e7562891e94$export$2e2bcd8739ae039 = $d5f32e7562891e94$var$withAnalyticsEvents;


var $611eba94e0709501$exports = {};
"use strict";
Object.defineProperty($611eba94e0709501$exports, "__esModule", {
    value: true
});
$611eba94e0709501$exports.useAnalyticsClient = $611eba94e0709501$exports.CommunityAnalyticsListener = $611eba94e0709501$exports.CommunityAnalyticsClientProvider = $611eba94e0709501$exports.AnalyticsWebClientContext = void 0;

var $611eba94e0709501$var$_react = $611eba94e0709501$var$_interopRequireWildcard((parcelRequire("5FkrB")));

var $5FkrB = parcelRequire("5FkrB");

var $jZlo3 = parcelRequire("jZlo3");
var $7cebc1a497019d4b$var$_process, $7cebc1a497019d4b$var$_process2;
// We can't rely on NODE_ENV === 'test' if its value is already configured by the consumer to some other value, so better to use JEST_WORKER_ID
// https://jestjs.io/docs/environment-variables#jest_worker_id
var $7cebc1a497019d4b$var$TESTS_MODE = (globalThis === null || globalThis === void 0 || ($7cebc1a497019d4b$var$_process = globalThis.process) === null || $7cebc1a497019d4b$var$_process === void 0 || ($7cebc1a497019d4b$var$_process = $7cebc1a497019d4b$var$_process.env) === null || $7cebc1a497019d4b$var$_process === void 0 ? void 0 : $7cebc1a497019d4b$var$_process.JEST_WORKER_ID) !== undefined;
var $7cebc1a497019d4b$var$DEBUG_MODE = !$7cebc1a497019d4b$var$TESTS_MODE && (globalThis === null || globalThis === void 0 || ($7cebc1a497019d4b$var$_process2 = globalThis.process) === null || $7cebc1a497019d4b$var$_process2 === void 0 || ($7cebc1a497019d4b$var$_process2 = $7cebc1a497019d4b$var$_process2.env) === null || $7cebc1a497019d4b$var$_process2 === void 0 ? void 0 : $7cebc1a497019d4b$var$_process2.NODE_ENV) !== 'production';
var $7cebc1a497019d4b$export$1c9f709888824e05 = function debug() {
    var _console;
    if (!$7cebc1a497019d4b$var$DEBUG_MODE) return;
    // eslint-disable-next-line no-console
    (_console = console).debug.apply(_console, arguments);
};



var $3ZMUU = parcelRequire("3ZMUU");
var $4b063ea43d2750ec$var$pkgName = '@atlaskit/platform-feature-flags';
var $4b063ea43d2750ec$export$7e41b1b2bdee3f98 = '__PLATFORM_FEATURE_FLAGS__';
var $4b063ea43d2750ec$var$hasProcessEnv = typeof $3ZMUU !== 'undefined' && typeof $3ZMUU.env !== 'undefined';
// FF global overrides can be configured by test runners or Storybook
var $4b063ea43d2750ec$var$ENV_ENABLE_PLATFORM_FF = $4b063ea43d2750ec$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
// STORYBOOK_ENABLE_PLATFORM_FF is included as storybook only allows env vars prefixed with STORYBOOK
// https://github.com/storybookjs/storybook/issues/12270
var $4b063ea43d2750ec$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF = $4b063ea43d2750ec$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
var $4b063ea43d2750ec$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE = $4b063ea43d2750ec$var$ENV_ENABLE_PLATFORM_FF || $4b063ea43d2750ec$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF;
var $4b063ea43d2750ec$var$DEFAULT_PFF_GLOBAL = {
    booleanResolver: undefined
};
var $4b063ea43d2750ec$var$globalVar = typeof window !== 'undefined' ? window : globalThis;
$4b063ea43d2750ec$var$globalVar[$4b063ea43d2750ec$export$7e41b1b2bdee3f98] = $4b063ea43d2750ec$var$globalVar[$4b063ea43d2750ec$export$7e41b1b2bdee3f98] || $4b063ea43d2750ec$var$DEFAULT_PFF_GLOBAL;
function $4b063ea43d2750ec$export$f2b591175b3e424c(resolver) {
    $4b063ea43d2750ec$var$globalVar[$4b063ea43d2750ec$export$7e41b1b2bdee3f98].booleanResolver = resolver;
}
function $4b063ea43d2750ec$export$6333b6aff9fc6275(flagKey) {
    if ($4b063ea43d2750ec$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE) {
        (0, $7cebc1a497019d4b$export$1c9f709888824e05)('[%s]: The feature flags were enabled while running tests. The flag "%s" will be always enabled.', $4b063ea43d2750ec$var$pkgName, flagKey);
        return true;
    }
    try {
        var _globalVar$PFF_GLOBAL, _globalVar$PFF_GLOBAL2, _globalVar$PFF_GLOBAL3;
        // booleanResolver will be empty for products like Trello, Elevate, Recruit etc.
        // Currently only Confluence, Jira and Bitbucket has set it.
        if (((_globalVar$PFF_GLOBAL = $4b063ea43d2750ec$var$globalVar[$4b063ea43d2750ec$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL === void 0 ? void 0 : _globalVar$PFF_GLOBAL.booleanResolver) === undefined || ((_globalVar$PFF_GLOBAL2 = $4b063ea43d2750ec$var$globalVar[$4b063ea43d2750ec$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL2 === void 0 ? void 0 : _globalVar$PFF_GLOBAL2.booleanResolver) === null) // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
        return (0, $jZlo3.default).checkGate(flagKey);
        var result = (_globalVar$PFF_GLOBAL3 = $4b063ea43d2750ec$var$globalVar[$4b063ea43d2750ec$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL3 === void 0 ? void 0 : _globalVar$PFF_GLOBAL3.booleanResolver(flagKey);
        if (typeof result !== 'boolean') {
            // eslint-disable-next-line no-console
            console.warn("".concat(flagKey, " resolved to a non-boolean value, returning false for safety"));
            return false;
        }
        return result;
    } catch (e) {
        return false;
    }
}


function $becc7ed5e3e052cc$export$ba05d765b8392e5e(flagResolver) {
    (0, $4b063ea43d2750ec$export$f2b591175b3e424c)(flagResolver);
}
function $becc7ed5e3e052cc$export$470e5c2be1411c89(name) {
    return (0, $4b063ea43d2750ec$export$6333b6aff9fc6275)(name);
}
function $becc7ed5e3e052cc$export$b40ec24ac8275656(name) {
    return (0, $4b063ea43d2750ec$export$6333b6aff9fc6275)(name);
}



var $3ZMUU = parcelRequire("3ZMUU");
var $ca9d768b23f35126$var$_process$env;
var /// <reference types="node" />
$ca9d768b23f35126$export$2e2bcd8739ae039 = typeof $3ZMUU !== 'undefined' && $3ZMUU !== null && (($ca9d768b23f35126$var$_process$env = {}, $ca9d768b23f35126$var$_process$env === void 0) ? void 0 : $ca9d768b23f35126$var$_process$env['ANALYTICS_NEXT_MODERN_CONTEXT']);



var $fC8ib = parcelRequire("fC8ib");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $kIXpt = parcelRequire("kIXpt");

var $cYPzS = parcelRequire("cYPzS");

var $eyuDe = parcelRequire("eyuDe");

var $25nEq = parcelRequire("25nEq");

var $5FkrB = parcelRequire("5FkrB");

var $8vJ0V = parcelRequire("8vJ0V");

var $iyyOp = parcelRequire("iyyOp");
function $f436cf4b258cc0fb$var$_callSuper(t, o, e) {
    return o = (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(o), (0, (/*@__PURE__*/$parcel$interopDefault($kIXpt)))(t, $f436cf4b258cc0fb$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(t).constructor) : o.apply(t, e));
}
function $f436cf4b258cc0fb$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($f436cf4b258cc0fb$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $f436cf4b258cc0fb$var$ContextTypes = {
    getAtlaskitAnalyticsEventHandlers: (0, (/*@__PURE__*/$parcel$interopDefault($8vJ0V))).func,
    getAtlaskitAnalyticsContext: (0, (/*@__PURE__*/$parcel$interopDefault($8vJ0V))).func
};
var $f436cf4b258cc0fb$var$noop = function noop() {
    return [];
};
// eslint-disable-next-line @repo/internal/react/no-class-components
var $f436cf4b258cc0fb$var$AnalyticsListener = /*#__PURE__*/ function(_Component) {
    function AnalyticsListener(props) {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, AnalyticsListener);
        _this = $f436cf4b258cc0fb$var$_callSuper(this, AnalyticsListener, [
            props
        ]);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "getChildContext", function() {
            return {
                getAtlaskitAnalyticsEventHandlers: _this.getAnalyticsEventHandlers,
                getAtlaskitAnalyticsContext: _this.getAtlaskitAnalyticsContext
            };
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "getAnalyticsEventHandlers", function() {
            var _this$props = _this.props, channel = _this$props.channel, onEvent = _this$props.onEvent;
            var _this$context$getAtla = _this.context.getAtlaskitAnalyticsEventHandlers, getAtlaskitAnalyticsEventHandlers = _this$context$getAtla === void 0 ? $f436cf4b258cc0fb$var$noop : _this$context$getAtla;
            var handler = function handler(event, eventChannel) {
                if (channel === '*' || channel === eventChannel) onEvent(event, eventChannel);
            };
            return [
                handler
            ].concat((0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(getAtlaskitAnalyticsEventHandlers()));
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "getAtlaskitAnalyticsContext", function() {
            var _this$context$getAtla2 = _this.context.getAtlaskitAnalyticsContext, getAtlaskitAnalyticsContext = _this$context$getAtla2 === void 0 ? $f436cf4b258cc0fb$var$noop : _this$context$getAtla2;
            return getAtlaskitAnalyticsContext();
        });
        _this.contextValue = {
            getAtlaskitAnalyticsContext: _this.getAtlaskitAnalyticsContext,
            getAtlaskitAnalyticsEventHandlers: _this.getAnalyticsEventHandlers
        };
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($eyuDe)))(AnalyticsListener, _Component);
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(AnalyticsListener, [
        {
            key: "render",
            value: function render() {
                var children = this.props.children;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $iyyOp.default).Provider, {
                    value: this.contextValue
                }, children);
            }
        }
    ]);
}((0, $5FkrB.Component));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($f436cf4b258cc0fb$var$AnalyticsListener, "contextTypes", $f436cf4b258cc0fb$var$ContextTypes);
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($f436cf4b258cc0fb$var$AnalyticsListener, "childContextTypes", $f436cf4b258cc0fb$var$ContextTypes);
var $f436cf4b258cc0fb$export$2e2bcd8739ae039 = $f436cf4b258cc0fb$var$AnalyticsListener;



var $fC8ib = parcelRequire("fC8ib");

var $5FkrB = parcelRequire("5FkrB");

var $iyyOp = parcelRequire("iyyOp");

var $ePFpc = parcelRequire("ePFpc");

var $aFyjd = parcelRequire("aFyjd");
var $aef46461767049c5$var$AnalyticsListener = function AnalyticsListener(_ref) {
    var children = _ref.children, channel = _ref.channel, onEvent = _ref.onEvent;
    var _useAnalyticsContext = (0, $ePFpc.useAnalyticsContext)(), _useAnalyticsContext$ = _useAnalyticsContext.getAtlaskitAnalyticsEventHandlers, getAtlaskitAnalyticsEventHandlers = _useAnalyticsContext$ === void 0 ? function() {
        return [];
    } : _useAnalyticsContext$, getAtlaskitAnalyticsContext = _useAnalyticsContext.getAtlaskitAnalyticsContext;
    var onEventRef = (0, $aFyjd.useTrackedRef)(onEvent);
    var channelRef = (0, $aFyjd.useTrackedRef)(channel);
    var getAnalyticsEventHandlers = (0, $5FkrB.useCallback)(function() {
        var thisHandler = function thisHandler(event, eventChannel) {
            if (channelRef.current === '*' || channelRef.current === eventChannel) onEventRef.current(event, eventChannel);
        };
        return [
            thisHandler
        ].concat((0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(getAtlaskitAnalyticsEventHandlers()));
    }, [
        channelRef,
        onEventRef,
        getAtlaskitAnalyticsEventHandlers
    ]);
    var value = (0, $5FkrB.useMemo)(function() {
        return {
            getAtlaskitAnalyticsContext: getAtlaskitAnalyticsContext,
            getAtlaskitAnalyticsEventHandlers: getAnalyticsEventHandlers
        };
    }, [
        getAtlaskitAnalyticsContext,
        getAnalyticsEventHandlers
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $iyyOp.default).Provider, {
        value: value
    }, children);
};
var $aef46461767049c5$export$2e2bcd8739ae039 = $aef46461767049c5$var$AnalyticsListener;


var $01b5b1a5740294b4$var$ExportedAnalyticsListener = function ExportedAnalyticsListener(props) {
    var isModernContext = (0, $ca9d768b23f35126$export$2e2bcd8739ae039) || (0, $becc7ed5e3e052cc$export$b40ec24ac8275656)('analytics-next-use-modern-context_jira');
    return isModernContext ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $aef46461767049c5$export$2e2bcd8739ae039), props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $f436cf4b258cc0fb$export$2e2bcd8739ae039), props);
};
var $01b5b1a5740294b4$export$2e2bcd8739ae039 = $01b5b1a5740294b4$var$ExportedAnalyticsListener;



var $iVpQc = parcelRequire("iVpQc");
var $35247c7511184ad3$exports = {};
"use strict";
Object.defineProperty($35247c7511184ad3$exports, "__esModule", {
    value: true
});
$35247c7511184ad3$exports.Identity = void 0;
var $767eab9fde59e2ab$exports = {};
"use strict";
Object.defineProperty($767eab9fde59e2ab$exports, "__esModule", {
    value: true
});
$767eab9fde59e2ab$exports.Cookie = void 0;
function $767eab9fde59e2ab$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $767eab9fde59e2ab$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $767eab9fde59e2ab$var$_typeof(o);
}
function $767eab9fde59e2ab$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $767eab9fde59e2ab$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t["return"] || t["return"]();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $767eab9fde59e2ab$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $767eab9fde59e2ab$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $767eab9fde59e2ab$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $767eab9fde59e2ab$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $767eab9fde59e2ab$var$_classCallCheck(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function $767eab9fde59e2ab$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, $767eab9fde59e2ab$var$_toPropertyKey(o.key), o);
    }
}
function $767eab9fde59e2ab$var$_createClass(e, r, t) {
    return r && $767eab9fde59e2ab$var$_defineProperties(e.prototype, r), t && $767eab9fde59e2ab$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}
function $767eab9fde59e2ab$var$_toPropertyKey(t) {
    var i = $767eab9fde59e2ab$var$_toPrimitive(t, "string");
    return "symbol" == $767eab9fde59e2ab$var$_typeof(i) ? i : i + "";
}
function $767eab9fde59e2ab$var$_toPrimitive(t, r) {
    if ("object" != $767eab9fde59e2ab$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $767eab9fde59e2ab$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $767eab9fde59e2ab$var$Cookie = $767eab9fde59e2ab$exports.Cookie = /*#__PURE__*/ function() {
    function Cookie() {
        $767eab9fde59e2ab$var$_classCallCheck(this, Cookie);
    }
    return $767eab9fde59e2ab$var$_createClass(Cookie, null, [
        {
            key: "getCookieUrl",
            value: function getCookieUrl(cookieName, defaultUrl) {
                var cookieUrl = Cookie.readCookie(cookieName);
                if (cookieUrl !== null) return cookieUrl;
                return defaultUrl;
            }
        },
        {
            key: "readCookie",
            value: function readCookie(name) {
                try {
                    var nameEQ = name + '=';
                    var ca = document.cookie.split(';');
                    var _iterator = $767eab9fde59e2ab$var$_createForOfIteratorHelper(ca), _step;
                    try {
                        for(_iterator.s(); !(_step = _iterator.n()).done;){
                            var c = _step.value;
                            while(c.startsWith(' '))c = c.substring(1, c.length);
                            if (c.startsWith(nameEQ)) return c.substring(nameEQ.length, c.length);
                        }
                    } catch (err) {
                        _iterator.e(err);
                    } finally{
                        _iterator.f();
                    }
                } catch (e) {
                    // Helpers.sendWrapperLoadError uses this method to get some context
                    // for the reported error, so we don't want to call that here, otherwise
                    // we would get stuck in an infinite loop
                    // Missing login_user_detected cookie is expected for logged out users, so no need to log it.
                    if (name !== 'login_user_detected') console.warn("Error reading cookie - ".concat(name), e);
                }
                return null;
            }
        },
        {
            key: "writeCookie",
            value: function writeCookie(name, value, days, topLevelDomain) {
                var seconds = days ? days * 86400 : null;
                Cookie.writeCookieInSeconds(name, value, seconds, topLevelDomain);
            }
        },
        {
            key: "writeCookieInSeconds",
            value: function writeCookieInSeconds(name, value, seconds, topLevelDomain) {
                try {
                    var expires = '';
                    if (seconds) {
                        var date = new Date();
                        date.setTime(date.getTime() + seconds * 1000);
                        expires = '; expires=' + date.toUTCString();
                    }
                    var cookie = name + '=' + value + expires + '; path=/;';
                    var domain = window.location.hostname;
                    if (domain !== 'localhost' && topLevelDomain) {
                        var domainTokens = domain.split('.');
                        if (domainTokens.length > 1) {
                            var lastToken = domainTokens[domainTokens.length - 1];
                            var secondLastToken = domainTokens[domainTokens.length - 2];
                            if (isNaN(Number(lastToken)) || isNaN(Number(secondLastToken))) domain = '.' + secondLastToken + '.' + lastToken;
                        }
                        cookie += ' domain=' + domain + ';';
                    }
                    document.cookie = cookie;
                } catch (e) {
                    console.warn("Error writing cookie - ".concat(name), e);
                }
            }
        }
    ]);
}();


var $adbd9ab2eaa40909$exports = {};
"use strict";
Object.defineProperty($adbd9ab2eaa40909$exports, "__esModule", {
    value: true
});
$adbd9ab2eaa40909$exports.AnalyticsState = void 0;
function $adbd9ab2eaa40909$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $adbd9ab2eaa40909$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $adbd9ab2eaa40909$var$_typeof(o);
}
function $adbd9ab2eaa40909$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, $adbd9ab2eaa40909$var$_toPropertyKey(o.key), o);
    }
}
function $adbd9ab2eaa40909$var$_createClass(e, r, t) {
    return r && $adbd9ab2eaa40909$var$_defineProperties(e.prototype, r), t && $adbd9ab2eaa40909$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}
function $adbd9ab2eaa40909$var$_classCallCheck(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function $adbd9ab2eaa40909$var$_defineProperty(e, r, t) {
    return (r = $adbd9ab2eaa40909$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $adbd9ab2eaa40909$var$_toPropertyKey(t) {
    var i = $adbd9ab2eaa40909$var$_toPrimitive(t, "string");
    return "symbol" == $adbd9ab2eaa40909$var$_typeof(i) ? i : i + "";
}
function $adbd9ab2eaa40909$var$_toPrimitive(t, r) {
    if ("object" != $adbd9ab2eaa40909$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $adbd9ab2eaa40909$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $adbd9ab2eaa40909$var$AnalyticsState = $adbd9ab2eaa40909$exports.AnalyticsState = /*#__PURE__*/ $adbd9ab2eaa40909$var$_createClass(function AnalyticsState() {
    $adbd9ab2eaa40909$var$_classCallCheck(this, AnalyticsState);
});
$adbd9ab2eaa40909$var$_defineProperty($adbd9ab2eaa40909$var$AnalyticsState, "pageViewOptions", {});


var $062e0101ba16ec7d$exports = {};
"use strict";
Object.defineProperty($062e0101ba16ec7d$exports, "__esModule", {
    value: true
});
$062e0101ba16ec7d$exports.requiredBucketAttributeKeys = $062e0101ba16ec7d$exports.Cohort = $062e0101ba16ec7d$exports.COHORT_VERSION = $062e0101ba16ec7d$exports.ATL_COHORT = void 0;

var $d568c1b4cd0cc27f$exports = {};
"use strict";
Object.defineProperty($d568c1b4cd0cc27f$exports, "__esModule", {
    value: true
});
$d568c1b4cd0cc27f$exports.Guid = void 0;

var $6JfQX = parcelRequire("6JfQX");
var $4fb91a309ed42af5$exports = {};
"use strict";
Object.defineProperty($4fb91a309ed42af5$exports, "__esModule", {
    value: true
});
$4fb91a309ed42af5$exports.Helpers = void 0;

var $4fb91a309ed42af5$var$_queryString = $4fb91a309ed42af5$var$_interopRequireDefault((parcelRequire("lSdkB")));
function $4fb91a309ed42af5$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
function $4fb91a309ed42af5$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $4fb91a309ed42af5$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $4fb91a309ed42af5$var$_typeof(o);
}
function $4fb91a309ed42af5$var$_slicedToArray(r, e) {
    return $4fb91a309ed42af5$var$_arrayWithHoles(r) || $4fb91a309ed42af5$var$_iterableToArrayLimit(r, e) || $4fb91a309ed42af5$var$_unsupportedIterableToArray(r, e) || $4fb91a309ed42af5$var$_nonIterableRest();
}
function $4fb91a309ed42af5$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $4fb91a309ed42af5$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $4fb91a309ed42af5$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $4fb91a309ed42af5$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $4fb91a309ed42af5$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $4fb91a309ed42af5$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $4fb91a309ed42af5$var$_arrayWithHoles(r) {
    if (Array.isArray(r)) return r;
}
function $4fb91a309ed42af5$var$_classCallCheck(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function $4fb91a309ed42af5$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, $4fb91a309ed42af5$var$_toPropertyKey(o.key), o);
    }
}
function $4fb91a309ed42af5$var$_createClass(e, r, t) {
    return r && $4fb91a309ed42af5$var$_defineProperties(e.prototype, r), t && $4fb91a309ed42af5$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}
function $4fb91a309ed42af5$var$_toPropertyKey(t) {
    var i = $4fb91a309ed42af5$var$_toPrimitive(t, "string");
    return "symbol" == $4fb91a309ed42af5$var$_typeof(i) ? i : i + "";
}
function $4fb91a309ed42af5$var$_toPrimitive(t, r) {
    if ("object" != $4fb91a309ed42af5$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $4fb91a309ed42af5$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
// This regex is the simplified RFC 5322 expression from http://www.regular-expressions.info/email.html
var $4fb91a309ed42af5$var$EMAIL_REGEX = /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/i;
var $4fb91a309ed42af5$var$PATH_OVERRIDE = '/path-contained-email-address';
var $4fb91a309ed42af5$var$Helpers = $4fb91a309ed42af5$exports.Helpers = /*#__PURE__*/ function() {
    function Helpers() {
        $4fb91a309ed42af5$var$_classCallCheck(this, Helpers);
    }
    return $4fb91a309ed42af5$var$_createClass(Helpers, null, [
        {
            key: "sendWrapperLoadError",
            value: function sendWrapperLoadError(message, data) {
                // TODO: Handle sending error somewhere, reference atl-analytics if needed
                console.warn("Error loading wrapper: ".concat(message), data);
            }
        },
        {
            key: "getParameterByName",
            value: function getParameterByName(name) {
                //eslint-disable-next-line
                name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
                var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
                var results = regex.exec(window.location.search);
                var value = results && results.length >= 2 ? results[1] : null;
                return !value ? '' : decodeURIComponent(value.replace(/\+/g, ' '));
            }
        },
        {
            key: "getUtms",
            value: function getUtms(utms) {
                if (window.location.search.includes('utm_')) {
                    for(var utmKey in utms)//eslint-disable-next-line
                    if (utms.hasOwnProperty(utmKey)) utms[utmKey] = Helpers.getParameterByName(utmKey);
                    return utms;
                }
                return null;
            }
        },
        {
            key: "canonical",
            value: function canonical() {
                var tags = Array.from(document.getElementsByTagName('link'));
                for(var _i = 0, _tags = tags; _i < _tags.length; _i++){
                    var tag = _tags[_i];
                    if (tag && tag.getAttribute('rel') === 'canonical') return tag.getAttribute('href');
                }
                return null;
            }
        },
        {
            key: "getCanonicalUrl",
            value: function getCanonicalUrl() {
                var canon = Helpers.canonical();
                if (canon) return canon;
                var url = window.location.href;
                var i = url.indexOf('#');
                return i === -1 ? url : url.slice(0, i);
            }
        },
        {
            key: "getUrlFragment",
            value: function getUrlFragment() {
                var url = window.location.href;
                var i = url.indexOf('#');
                if (i === -1) return '';
                var fragment = url.slice(i + 1); // fragment after '#'
                var _fragment$split = fragment.split('?'), _fragment$split2 = $4fb91a309ed42af5$var$_slicedToArray(_fragment$split, 1), path = _fragment$split2[0]; // discard query string
                return "#".concat(path);
            }
        },
        {
            key: "addActualUrl",
            value: function addActualUrl(obj) {
                if (window.location.href !== Helpers.getCanonicalUrl()) {
                    // respect cleaned url
                    if (obj['url']) obj['actualUrl'] = obj['url'];
                    else obj['actualUrl'] = Helpers.maskURL(window.location.href);
                }
            }
        },
        {
            key: "isObject",
            value: function isObject(o) {
                return o !== null && $4fb91a309ed42af5$var$_typeof(o) === 'object' && Array.isArray(o) === false;
            }
        },
        {
            key: "urlContainsEmail",
            value: function urlContainsEmail(url) {
                return Boolean($4fb91a309ed42af5$var$EMAIL_REGEX.exec(decodeURIComponent(url)));
            }
        },
        {
            key: "dropEmailQueryParams",
            value: function dropEmailQueryParams(obj) {
                var sanitizedObj = {};
                Object.entries(obj).forEach(function(_ref) {
                    var _ref2 = $4fb91a309ed42af5$var$_slicedToArray(_ref, 2), key = _ref2[0], value = _ref2[1];
                    if (!Helpers.urlContainsEmail(value)) sanitizedObj[key] = value;
                });
                return sanitizedObj;
            }
        },
        {
            key: "maskSearchTerms",
            value: function maskSearchTerms(obj) {
                var sanitizedObj = {};
                Object.entries(obj).forEach(function(_ref3) {
                    var _ref4 = $4fb91a309ed42af5$var$_slicedToArray(_ref3, 2), key = _ref4[0], value = _ref4[1];
                    if (key === 'term' || key === 'q') sanitizedObj[key] = '[REDACTED]';
                    else sanitizedObj[key] = value;
                });
                return sanitizedObj;
            }
        },
        {
            key: "dropEmailFromPath",
            value: function dropEmailFromPath(path) {
                var newPath = '';
                if (Helpers.urlContainsEmail(path)) {
                    var pathArray = path.split('/');
                    pathArray.forEach(function(value) {
                        if (value !== '' && !Helpers.urlContainsEmail(value)) newPath = newPath + '/' + value;
                    });
                }
                return newPath === '' ? path : newPath;
            }
        },
        {
            key: "convertQueryObjToString",
            value: function convertQueryObjToString(obj) {
                var queryString = new URLSearchParams(obj).toString();
                if (queryString !== '') queryString = '?' + queryString;
                return queryString;
            }
        },
        {
            key: "emailAddressIsDetected",
            value: function emailAddressIsDetected() {
                return Helpers.urlContainsEmail(window.location.href) || Helpers.urlContainsEmail(document.referrer);
            }
        },
        {
            key: "hostnameFromUrl",
            value: function hostnameFromUrl(url) {
                return url.replace(/http(s|):\/\//g, '').split(/(\/|:)/g)[0];
            }
        },
        {
            key: "addCleanedUrlAndPaths",
            value: function addCleanedUrlAndPaths(obj) {
                obj['url'] = window.location.origin + $4fb91a309ed42af5$var$PATH_OVERRIDE;
                obj['path'] = $4fb91a309ed42af5$var$PATH_OVERRIDE;
                obj['search'] = '';
                return obj;
            }
        },
        {
            key: "addCleanedReferrer",
            value: function addCleanedReferrer(obj) {
                obj['referrer'] = Helpers.urlWithoutPath(document.referrer) + $4fb91a309ed42af5$var$PATH_OVERRIDE;
                return obj;
            }
        },
        {
            key: "urlWithoutPath",
            value: function urlWithoutPath(url) {
                var fakeTag = document.createElement('a');
                fakeTag.href = url;
                return fakeTag.protocol + '//' + fakeTag.host;
            }
        },
        {
            key: "maskURL",
            value: function maskURL(input) {
                if (input === '' || input === undefined) return input;
                var url = new URL(input);
                var obj = $4fb91a309ed42af5$var$_queryString["default"].parse(url.search);
                obj = Helpers.dropEmailQueryParams(obj);
                if (url.pathname.includes('/search')) obj = Helpers.maskSearchTerms(obj);
                return url.origin + Helpers.dropEmailFromPath(url.pathname) + Helpers.convertQueryObjToString(obj);
            }
        }
    ]);
}();


var $06626edace7f812b$exports = {};
"use strict";
Object.defineProperty($06626edace7f812b$exports, "__esModule", {
    value: true
});
$06626edace7f812b$exports.mathGuid = void 0;
function $06626edace7f812b$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $06626edace7f812b$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t["return"] || t["return"]();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $06626edace7f812b$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $06626edace7f812b$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $06626edace7f812b$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $06626edace7f812b$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
/**
 * See:
 *  - http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript/24891600#24891600
 * for more context around the issue of psuedo-randomness used by browsers and the solution used below.
 *
 * and:
 *  - http://web.archive.org/web/20120503063359/http://baagoe.com/en/RandomMusings/javascript/
 * for info regarding the Alea code used below.
 */ var $06626edace7f812b$var$trueRandom = function() {
    function Mash() {
        var n = 0xefc8249d;
        var mash = function mash(data) {
            for(var i = 0; i < data.length; i++){
                n += data.charCodeAt(i);
                var h = 0.02519603282416938 * n;
                n = h >>> 0;
                h -= n;
                h *= n;
                n = h >>> 0;
                h -= n;
                n += h * 0x100000000; // 2^32
            }
            return (n >>> 0) * 2.3283064365386963e-10; // 2^-32
        };
        return mash;
    }
    function Alea() {
        return function(args) {
            // Johannes BaagÃ¸e <baagoe@baagoe.com>, 2010
            var s0 = 0;
            var s1 = 0;
            var s2 = 0;
            var c = 1;
            if (args.length == 0) args = [
                +new Date()
            ];
            var mash = Mash();
            s0 = mash(' ');
            s1 = mash(' ');
            s2 = mash(' ');
            var _iterator = $06626edace7f812b$var$_createForOfIteratorHelper(args), _step;
            try {
                for(_iterator.s(); !(_step = _iterator.n()).done;){
                    var item = _step.value;
                    s0 -= mash(item);
                    if (s0 < 0) s0 += 1;
                    s1 -= mash(item);
                    if (s1 < 0) s1 += 1;
                    s2 -= mash(item);
                    if (s2 < 0) s2 += 1;
                }
            } catch (err) {
                _iterator.e(err);
            } finally{
                _iterator.f();
            }
            var random = function random() {
                var t = 2091639 * s0 + c * 2.3283064365386963e-10; // 2^-32
                s0 = s1;
                s1 = s2;
                return s2 = t - (c = t | 0);
            };
            random.uint32 = function() {
                return random() * 0x100000000; // 2^32
            };
            random.fract53 = function() {
                return random() + (random() * 0x200000 | 0) * 1.1102230246251565e-16; // 2^-53
            };
            random.version = 'Alea 0.9';
            random.args = args;
            return random;
        }(Array.prototype.slice.call(arguments));
    }
    return Alea();
}();
var $06626edace7f812b$var$mathGuid = $06626edace7f812b$exports.mathGuid = function mathGuid() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
        var r = $06626edace7f812b$var$trueRandom() * 16 | 0, v = c == 'x' ? r : r & 0x3 | 0x8;
        return v.toString(16);
    });
};


function $d568c1b4cd0cc27f$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $d568c1b4cd0cc27f$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $d568c1b4cd0cc27f$var$_typeof(o);
}
function $d568c1b4cd0cc27f$var$_classCallCheck(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function $d568c1b4cd0cc27f$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, $d568c1b4cd0cc27f$var$_toPropertyKey(o.key), o);
    }
}
function $d568c1b4cd0cc27f$var$_createClass(e, r, t) {
    return r && $d568c1b4cd0cc27f$var$_defineProperties(e.prototype, r), t && $d568c1b4cd0cc27f$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}
function $d568c1b4cd0cc27f$var$_toPropertyKey(t) {
    var i = $d568c1b4cd0cc27f$var$_toPrimitive(t, "string");
    return "symbol" == $d568c1b4cd0cc27f$var$_typeof(i) ? i : i + "";
}
function $d568c1b4cd0cc27f$var$_toPrimitive(t, r) {
    if ("object" != $d568c1b4cd0cc27f$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $d568c1b4cd0cc27f$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $d568c1b4cd0cc27f$var$Guid = $d568c1b4cd0cc27f$exports.Guid = /*#__PURE__*/ function() {
    function Guid() {
        $d568c1b4cd0cc27f$var$_classCallCheck(this, Guid);
    }
    return $d568c1b4cd0cc27f$var$_createClass(Guid, null, [
        {
            key: "guid",
            value: function guid() {
                try {
                    return (0, $6JfQX.default)();
                } catch (e) {
                    $4fb91a309ed42af5$exports.Helpers.sendWrapperLoadError('Error getting uuidV4');
                    return (0, $06626edace7f812b$exports.mathGuid)();
                }
            }
        },
        {
            key: "guidNoDashes",
            value: function guidNoDashes() {
                return (0, $6JfQX.default)().replace(/-/g, '');
            }
        },
        {
            key: "addNumberToGUID",
            value: function addNumberToGUID(guid, number) {
                // take the last 4 digits and convert to a hex string representation
                var hex = guid.slice(-4);
                var value = parseInt(hex, 16);
                if (isNaN(value)) return guid;
                var valLength = value.toString(16).length;
                value += number;
                // clamp to 2 bytes
                if (value > 65535) value -= 65536;
                else if (value < 0) value += 65536;
                // convert back to hex and make sure its as long as many digits as the initial value
                // This is needed for subtraction
                hex = value.toString(16);
                if (hex.length < valLength) hex = ('00000' + hex).slice(-valLength);
                // replace the last 4 digits of the guid with the last 4 digits of the converted value
                return guid.slice(0, guid.length - hex.length) + hex;
            }
        },
        {
            key: "guidHashCode",
            value: function guidHashCode(guid) {
                var hash = 0;
                for(var i = 0; i < guid.length; i++){
                    hash += Math.pow(guid.charCodeAt(i) * 31, guid.length - i);
                    hash = hash & hash; // Convert to 32bit integer
                }
                return Math.abs(hash);
            }
        }
    ]);
}();



function $062e0101ba16ec7d$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $062e0101ba16ec7d$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $062e0101ba16ec7d$var$_typeof(o);
}
function $062e0101ba16ec7d$var$_classCallCheck(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function $062e0101ba16ec7d$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, $062e0101ba16ec7d$var$_toPropertyKey(o.key), o);
    }
}
function $062e0101ba16ec7d$var$_createClass(e, r, t) {
    return r && $062e0101ba16ec7d$var$_defineProperties(e.prototype, r), t && $062e0101ba16ec7d$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}
function $062e0101ba16ec7d$var$_toPropertyKey(t) {
    var i = $062e0101ba16ec7d$var$_toPrimitive(t, "string");
    return "symbol" == $062e0101ba16ec7d$var$_typeof(i) ? i : i + "";
}
function $062e0101ba16ec7d$var$_toPrimitive(t, r) {
    if ("object" != $062e0101ba16ec7d$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $062e0101ba16ec7d$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
} /**
 * @typedef {object} Cohort
 * @property {string} ATL_COHORT The cookie name
 * @property {object | null} readWriteAtlCohort The cohort object or null
 * @property {object | null} readAtlCohort The cohort object or null
 */ 
var $062e0101ba16ec7d$var$ATL_COHORT = $062e0101ba16ec7d$exports.ATL_COHORT = 'atlCohort';
var $062e0101ba16ec7d$var$COHORT_VERSION = $062e0101ba16ec7d$exports.COHORT_VERSION = '2';
var $062e0101ba16ec7d$var$requiredBucketAttributeKeys = $062e0101ba16ec7d$exports.requiredBucketAttributeKeys = [
    'index',
    'bucketedAtUTC',
    'version',
    'bucketId'
];
var $062e0101ba16ec7d$var$cohortBuckets = {
    bucketAll: {
        bucketId: 0
    }
};
/**
 * Provides public access to cohort cookie name and methods for reading and writing that cookie
 * @module Cohort
 */ var $062e0101ba16ec7d$var$Cohort = $062e0101ba16ec7d$exports.Cohort = /*#__PURE__*/ function() {
    function Cohort() {
        $062e0101ba16ec7d$var$_classCallCheck(this, Cohort);
    }
    return $062e0101ba16ec7d$var$_createClass(Cohort, null, [
        {
            key: "readAtlCohort",
            value: /*
       Hypothetical way to add other buckets (adding their name to the types above):
           if (isMobileDevice()) {
              cohortBuckets.bucket_mobile = {
                  bucketId: 1
              };
          }
           if (isEnglishSpeaking()) {
              cohortBuckets.bucket_english = {};
          }
           function isMobileDevice() {
              // some logic here...
              return true;
          }
           function isEnglishSpeaking() {
              // some logic here...
              return false;
          }
      */ /**
     * Tries to read the ATL_COHORT cookie and return it
     * @function readAtlCohort
     * @return {object | null} the cohort object or null
     */ function readAtlCohort() {
                var atlCohort;
                var atlCohortCookie = $767eab9fde59e2ab$exports.Cookie.readCookie($062e0101ba16ec7d$var$ATL_COHORT);
                try {
                    atlCohort = atlCohortCookie ? JSON.parse(atlCohortCookie) : null;
                    return $4fb91a309ed42af5$exports.Helpers.isObject(atlCohort) ? atlCohort : null;
                } catch (e) {
                    $4fb91a309ed42af5$exports.Helpers.sendWrapperLoadError('Error reading ALT_COHORT Cookie');
                    return null;
                }
            }
        },
        {
            key: "writeAtlCohort",
            value: function writeAtlCohort(atlCohort) {
                if ($4fb91a309ed42af5$exports.Helpers.isObject(atlCohort)) $767eab9fde59e2ab$exports.Cookie.writeCookie($062e0101ba16ec7d$var$ATL_COHORT, JSON.stringify(atlCohort), 3650, true);
            }
        },
        {
            key: "bucketExists",
            value: function bucketExists(key, atlCohort) {
                if ($4fb91a309ed42af5$exports.Helpers.isObject(atlCohort)) {
                    var bucket = atlCohort[key];
                    if (bucket && $4fb91a309ed42af5$exports.Helpers.isObject(bucket)) return $062e0101ba16ec7d$var$requiredBucketAttributeKeys.every(function(bucketAttribute) {
                        return typeof bucket[bucketAttribute] !== 'undefined';
                    });
                }
                return false;
            }
        },
        {
            key: "createBucket",
            value: function createBucket(bucketKey) {
                var bucketAttributes = $062e0101ba16ec7d$var$cohortBuckets[bucketKey];
                var anonymousId = $767eab9fde59e2ab$exports.Cookie.readCookie('ajs_anonymous_id');
                var bucket = {
                    bucketedAtUTC: new Date().toISOString(),
                    version: $062e0101ba16ec7d$var$COHORT_VERSION,
                    index: anonymousId ? $d568c1b4cd0cc27f$exports.Guid.guidHashCode($d568c1b4cd0cc27f$exports.Guid.addNumberToGUID(anonymousId, bucketAttributes.bucketId)) % 100 : Math.ceil(Math.random() * 100),
                    bucketId: bucketAttributes.bucketId
                };
                return bucket;
            }
        },
        {
            key: "readWriteAtlCohort",
            value: function readWriteAtlCohort(writeOverride) {
                // if overriding the cohort, do not read the existing cohort; set to empty to force a write
                var atlCohort = writeOverride ? {} : Cohort.readAtlCohort() || {};
                var missingBuckets = Object.keys($062e0101ba16ec7d$var$cohortBuckets)// Find missing buckets
                .filter(function(bucket) {
                    return !Cohort.bucketExists(bucket, atlCohort);
                });
                if (missingBuckets.length) {
                    missingBuckets.forEach(function(missingBucket) {
                        return atlCohort[missingBucket] = Cohort.createBucket(missingBucket);
                    });
                    Cohort.writeAtlCohort(atlCohort);
                }
                return atlCohort;
            }
        }
    ]);
}();



var $3f4554f5dd6755f8$exports = {};
"use strict";
Object.defineProperty($3f4554f5dd6755f8$exports, "__esModule", {
    value: true
});
$3f4554f5dd6755f8$exports.Tracking = void 0;



var $077fd9c14d82a85a$exports = {};
"use strict";
Object.defineProperty($077fd9c14d82a85a$exports, "__esModule", {
    value: true
});
$077fd9c14d82a85a$exports.GASv3 = void 0;
var $3bef5a1e67ea5779$export$2e2bcd8739ae039 = function(channel) {
    return function(payload) {
        return function(createAnalyticsEvent) {
            var consumerEvent = createAnalyticsEvent(payload);
            var clonedEvent = consumerEvent.clone();
            if (clonedEvent) clonedEvent.fire(channel);
            return consumerEvent;
        };
    };
};



var $iVpQc = parcelRequire("iVpQc");






var $a49bd8faafbfa6f8$exports = {};
"use strict";
Object.defineProperty($a49bd8faafbfa6f8$exports, "__esModule", {
    value: true
});
$a49bd8faafbfa6f8$exports.TrelloUrlScrubber = void 0;
function $a49bd8faafbfa6f8$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $a49bd8faafbfa6f8$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $a49bd8faafbfa6f8$var$_typeof(o);
}
function $a49bd8faafbfa6f8$var$_classCallCheck(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function $a49bd8faafbfa6f8$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, $a49bd8faafbfa6f8$var$_toPropertyKey(o.key), o);
    }
}
function $a49bd8faafbfa6f8$var$_createClass(e, r, t) {
    return r && $a49bd8faafbfa6f8$var$_defineProperties(e.prototype, r), t && $a49bd8faafbfa6f8$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}
function $a49bd8faafbfa6f8$var$_toPropertyKey(t) {
    var i = $a49bd8faafbfa6f8$var$_toPrimitive(t, "string");
    return "symbol" == $a49bd8faafbfa6f8$var$_typeof(i) ? i : i + "";
}
function $a49bd8faafbfa6f8$var$_toPrimitive(t, r) {
    if ("object" != $a49bd8faafbfa6f8$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $a49bd8faafbfa6f8$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $a49bd8faafbfa6f8$var$routeTypes = {
    BOARD: 'board',
    BOARD_BUTLER: 'board-butler',
    BOARD_BUTLER_PAGE: 'board-butler-page',
    BOARD_RECOMMEND: 'board-recommend',
    CARD: 'card',
    ENTERPRISE_ADMIN: 'enterprise-admin',
    ENTERPRISE_ADMIN_TAB: 'enterprise-admin-tab',
    ENTERPRISE_ADMIN_TAB_SUBSECTION: 'enterprise-admin-tab-subsection',
    HOME: 'home',
    TEMPLATES: 'templates',
    TEMPLATES_CATEGORIES: 'templates-categories',
    TEMPLATES_STORY: 'templates-story',
    TEMPLATES_RECOMMEND: 'templates-recommend',
    TEMPLATES_SUBMIT: 'templates-submit',
    TEMPLATE: 'template',
    USER: 'user',
    USER_TABS: 'user-tabs',
    USER_CARDS_WORKSPACE: 'user-cards-workspace',
    VIEW: 'view',
    WORKSPACE: 'workspace',
    WORKSPACE_SECTION: 'workspace-section',
    WORKSPACE_MEMBERS_SUBSECTION: 'workspace-members-subsection',
    WORKSPACE_VIEWS_SUBSECTION: 'workspace-views-subsection',
    POWER_UPS_HOME: 'power-ups-home',
    POWER_UPS_ALL: 'power-ups-all',
    POWER_UPS_TRELLO: 'power-ups-trello',
    POWER_UPS_CATEGORIES: 'power-ups-categories',
    UPGRADE_TEAM: 'select-team-to-upgrade',
    SHORTCUTS: 'shortcuts'
};
// Trello indices of non UGC/PII in the pathname depending on their route type
var $a49bd8faafbfa6f8$var$ALLOWLIST_INDICES = {
    ROUTE_IDENTIFIER: 0,
    ROUTE_SHORTLINK: 1,
    B_ROUTE_BUTLER: 3,
    B_ROUTE_BUTLER_PAGE: 4,
    B_ROUTE_RECOMMEND: 4,
    E_ROUTE_ADMIN: 2,
    E_ROUTE_ADMIN_TAB_NAME: 3,
    E_ROUTE_ADMIN_TAB_SUBSECTION_NAME: 4,
    POWER_UPS_ROUTE_PAGE: 1,
    POWER_UPS_ROUTE_CATEGORY: 1,
    POWER_UPS_ROUTE_CATEGORY_NAME: 2,
    TEMPLATES_ROUTE_PAGE: 1,
    TEMPLATES_ROUTE_CATEGORY: 1,
    TEMPLATES_ROUTE_TEMPLATE_NAME: 2,
    TEMPLATES_ROUTE_RECOMMEND: 4,
    U_ROUTE_TAB_NAME: 2,
    W_ROUTE_PAGE: 2,
    W_ROUTE_PAGE_SUBSECTION: 3
};
var $a49bd8faafbfa6f8$var$routePatternMap = new Map([
    [
        $a49bd8faafbfa6f8$var$routeTypes.BOARD_RECOMMEND,
        {
            id: $a49bd8faafbfa6f8$var$routeTypes.BOARD_RECOMMEND,
            regExp: new RegExp('^/b/([^/]+)/([^/]+)/([^/]+)/recommend$'),
            allowlist: [
                $a49bd8faafbfa6f8$var$ALLOWLIST_INDICES.ROUTE_IDENTIFIER,
                $a49bd8faafbfa6f8$var$ALLOWLIST_INDICES.ROUTE_SHORTLINK,
                $a49bd8faafbfa6f8$var$ALLOWLIST_INDICES.B_ROUTE_RECOMMEND
            ]
        }
    ],
    [
        $a49bd8faafbfa6f8$var$routeTypes.BOARD_BUTLER_PAGE,
        {
            id: $a49bd8faafbfa6f8$var$routeTypes.BOARD_BUTLER_PAGE,
            regExp: new RegExp('^/b/([^/]+)/([^/]+)/butler/(rules|card-buttons|board-buttons|schedule|on-dates|connected-apps)$'),
            allowlist: [
                $a49bd8faafbfa6f8$var$ALLOWLIST_INDICES.ROUTE_IDENTIFIER,
                $a49bd8faafbfa6f8$var$ALLOWLIST_INDICES.ROUTE_SHORTLINK,
                $a49bd8faafbfa6f8$var$ALLOWLIST_INDICES.B_ROUTE_BUTLER,
                $a49bd8faafbfa6f8$var$ALLOWLIST_INDICES.B_ROUTE_BUTLER_PAGE
            ]
        }
    ],
    [
        $a49bd8faafbfa6f8$var$routeTypes.BOARD_BUTLER,
        {
            id: $a49bd8faafbfa6f8$var$routeTypes.BOARD_BUTLER,
            regExp: new RegExp('^/b/([^/]+)/([^/]+)/butler/$'),
            allowlist: [
                $a49bd8faafbfa6f8$var$ALLOWLIST_INDICES.ROUTE_IDENTIFIER,
                $a49bd8faafbfa6f8$var$ALLOWLIST_INDICES.ROUTE_SHORTLINK,
                $a49bd8faafbfa6f8$var$ALLOWLIST_INDICES.B_ROUTE_BUTLER
            ]
        }
    ],
    [
        $a49bd8faafbfa6f8$var$routeTypes.BOARD,
        {
            id: $a49bd8faafbfa6f8$var$routeTypes.BOARD,
            regExp: new RegExp('^/b/([^/]+)(?:/(.*?))?$'),
            allowlist: [
                $a49bd8faafbfa6f8$var$ALLOWLIST_INDICES.ROUTE_IDENTIFIER,
                $a49bd8faafbfa6f8$var$ALLOWLIST_INDICES.ROUTE_SHORTLINK
            ]
        }
    ],
    [
        $a49bd8faafbfa6f8$var$routeTypes.CARD,
        {
            id: $a49bd8faafbfa6f8$var$routeTypes.CARD,
            regExp: new RegExp('^/c/'),
            allowlist: [
                $a49bd8faafbfa6f8$var$ALLOWLIST_INDICES.ROUTE_IDENTIFIER,
                $a49bd8faafbfa6f8$var$ALLOWLIST_INDICES.ROUTE_SHORTLINK
            ]
        }
    ],
    [
        $a49bd8faafbfa6f8$var$routeTypes.ENTERPRISE_ADMIN_TAB_SUBSECTION,
        {
            id: $a49bd8faafbfa6f8$var$routeTypes.ENTERPRISE_ADMIN_TAB_SUBSECTION,
            regExp: new RegExp('^/e/([^/]+)/admin/(members|workspaces|boards)/(managed|boardguests|deactivated|non-enterprise|pending|public)$'),
            allowlist: [
                $a49bd8faafbfa6f8$var$ALLOWLIST_INDICES.ROUTE_IDENTIFIER,
                $a49bd8faafbfa6f8$var$ALLOWLIST_INDICES.E_ROUTE_ADMIN,
                $a49bd8faafbfa6f8$var$ALLOWLIST_INDICES.E_ROUTE_ADMIN_TAB_NAME,
                $a49bd8faafbfa6f8$var$ALLOWLIST_INDICES.E_ROUTE_ADMIN_TAB_SUBSECTION_NAME
            ]
        }
    ],
    [
        $a49bd8faafbfa6f8$var$routeTypes.ENTERPRISE_ADMIN_TAB,
        {
            id: $a49bd8faafbfa6f8$var$routeTypes.ENTERPRISE_ADMIN_TAB,
            regExp: new RegExp('^/e/([^/]+)/admin/(members|workspaces|settings|attachment-restrictions|boards|power-ups|auditlog|account-administration|sso|api-tokens)$'),
            allowlist: [
                $a49bd8faafbfa6f8$var$ALLOWLIST_INDICES.ROUTE_IDENTIFIER,
                $a49bd8faafbfa6f8$var$ALLOWLIST_INDICES.E_ROUTE_ADMIN,
                $a49bd8faafbfa6f8$var$ALLOWLIST_INDICES.E_ROUTE_ADMIN_TAB_NAME
            ]
        }
    ],
    [
        $a49bd8faafbfa6f8$var$routeTypes.ENTERPRISE_ADMIN,
        {
            id: $a49bd8faafbfa6f8$var$routeTypes.ENTERPRISE_ADMIN,
            regExp: new RegExp('^/e/([^/]+)/admin$'),
            allowlist: [
                $a49bd8faafbfa6f8$var$ALLOWLIST_INDICES.ROUTE_IDENTIFIER,
                $a49bd8faafbfa6f8$var$ALLOWLIST_INDICES.E_ROUTE_ADMIN
            ]
        }
    ],
    [
        $a49bd8faafbfa6f8$var$routeTypes.POWER_UPS_HOME,
        {
            id: $a49bd8faafbfa6f8$var$routeTypes.POWER_UPS_HOME,
            regExp: new RegExp('^/power-ups$'),
            allowlist: [
                $a49bd8faafbfa6f8$var$ALLOWLIST_INDICES.ROUTE_IDENTIFIER
            ]
        }
    ],
    [
        $a49bd8faafbfa6f8$var$routeTypes.POWER_UPS_ALL,
        {
            id: $a49bd8faafbfa6f8$var$routeTypes.POWER_UPS_ALL,
            regExp: new RegExp('^/power-ups/all$'),
            allowlist: [
                $a49bd8faafbfa6f8$var$ALLOWLIST_INDICES.ROUTE_IDENTIFIER,
                $a49bd8faafbfa6f8$var$ALLOWLIST_INDICES.POWER_UPS_ROUTE_PAGE
            ]
        }
    ],
    [
        $a49bd8faafbfa6f8$var$routeTypes.POWER_UPS_TRELLO,
        {
            id: $a49bd8faafbfa6f8$var$routeTypes.POWER_UPS_TRELLO,
            regExp: new RegExp('^/power-ups/made-by-trello$'),
            allowlist: [
                $a49bd8faafbfa6f8$var$ALLOWLIST_INDICES.ROUTE_IDENTIFIER,
                $a49bd8faafbfa6f8$var$ALLOWLIST_INDICES.POWER_UPS_ROUTE_PAGE
            ]
        }
    ],
    [
        $a49bd8faafbfa6f8$var$routeTypes.POWER_UPS_CATEGORIES,
        {
            id: $a49bd8faafbfa6f8$var$routeTypes.POWER_UPS_CATEGORIES,
            regExp: new RegExp('^/power-ups/category/(automation|analytics-reporting|board-utilities|communication-collaboration|developer-tools|file-management|hr-operations|it-project-management|marketing-social-media|product-design|sales-support)$'),
            allowlist: [
                $a49bd8faafbfa6f8$var$ALLOWLIST_INDICES.ROUTE_IDENTIFIER,
                $a49bd8faafbfa6f8$var$ALLOWLIST_INDICES.POWER_UPS_ROUTE_CATEGORY,
                $a49bd8faafbfa6f8$var$ALLOWLIST_INDICES.POWER_UPS_ROUTE_CATEGORY_NAME
            ]
        }
    ],
    [
        $a49bd8faafbfa6f8$var$routeTypes.HOME,
        {
            id: $a49bd8faafbfa6f8$var$routeTypes.HOME,
            regExp: new RegExp('^/$'),
            allowlist: [
                $a49bd8faafbfa6f8$var$ALLOWLIST_INDICES.ROUTE_IDENTIFIER
            ]
        }
    ],
    [
        $a49bd8faafbfa6f8$var$routeTypes.UPGRADE_TEAM,
        {
            id: $a49bd8faafbfa6f8$var$routeTypes.UPGRADE_TEAM,
            regExp: new RegExp('^/select-team-to-upgrade$'),
            allowlist: [
                $a49bd8faafbfa6f8$var$ALLOWLIST_INDICES.ROUTE_IDENTIFIER
            ]
        }
    ],
    [
        $a49bd8faafbfa6f8$var$routeTypes.SHORTCUTS,
        {
            id: $a49bd8faafbfa6f8$var$routeTypes.SHORTCUTS,
            regExp: new RegExp('^/shortcuts$'),
            allowlist: [
                $a49bd8faafbfa6f8$var$ALLOWLIST_INDICES.ROUTE_IDENTIFIER
            ]
        }
    ],
    [
        $a49bd8faafbfa6f8$var$routeTypes.TEMPLATES_SUBMIT,
        {
            id: $a49bd8faafbfa6f8$var$routeTypes.TEMPLATES_SUBMIT,
            regExp: new RegExp('^/templates/submit$'),
            allowlist: [
                $a49bd8faafbfa6f8$var$ALLOWLIST_INDICES.ROUTE_IDENTIFIER,
                $a49bd8faafbfa6f8$var$ALLOWLIST_INDICES.TEMPLATES_ROUTE_PAGE
            ]
        }
    ],
    [
        $a49bd8faafbfa6f8$var$routeTypes.TEMPLATES_RECOMMEND,
        {
            id: $a49bd8faafbfa6f8$var$routeTypes.TEMPLATES_RECOMMEND,
            regExp: new RegExp('^/templates/([^/]+)/([^/]+)/([^/]+)/recommend$'),
            allowlist: [
                $a49bd8faafbfa6f8$var$ALLOWLIST_INDICES.ROUTE_IDENTIFIER,
                $a49bd8faafbfa6f8$var$ALLOWLIST_INDICES.TEMPLATES_ROUTE_CATEGORY,
                $a49bd8faafbfa6f8$var$ALLOWLIST_INDICES.TEMPLATES_ROUTE_TEMPLATE_NAME,
                $a49bd8faafbfa6f8$var$ALLOWLIST_INDICES.TEMPLATES_ROUTE_RECOMMEND
            ]
        }
    ],
    [
        $a49bd8faafbfa6f8$var$routeTypes.TEMPLATES_CATEGORIES,
        {
            id: $a49bd8faafbfa6f8$var$routeTypes.TEMPLATES_CATEGORIES,
            regExp: new RegExp('^/templates/(business|design|education|engineering|marketing|operations-hr|personal|productivity|product-management|project-management|remote-work|sales|support|team-management)$'),
            allowlist: [
                $a49bd8faafbfa6f8$var$ALLOWLIST_INDICES.ROUTE_IDENTIFIER,
                $a49bd8faafbfa6f8$var$ALLOWLIST_INDICES.TEMPLATES_ROUTE_CATEGORY
            ]
        }
    ],
    [
        $a49bd8faafbfa6f8$var$routeTypes.TEMPLATES_STORY,
        {
            id: $a49bd8faafbfa6f8$var$routeTypes.TEMPLATES_STORY,
            regExp: new RegExp('^/templates/([^/]+)/([^/]+)$'),
            allowlist: [
                $a49bd8faafbfa6f8$var$ALLOWLIST_INDICES.ROUTE_IDENTIFIER,
                $a49bd8faafbfa6f8$var$ALLOWLIST_INDICES.TEMPLATES_ROUTE_CATEGORY,
                $a49bd8faafbfa6f8$var$ALLOWLIST_INDICES.TEMPLATES_ROUTE_TEMPLATE_NAME
            ]
        }
    ],
    [
        $a49bd8faafbfa6f8$var$routeTypes.TEMPLATES,
        {
            id: $a49bd8faafbfa6f8$var$routeTypes.TEMPLATES,
            regExp: new RegExp('^/templates$'),
            allowlist: [
                $a49bd8faafbfa6f8$var$ALLOWLIST_INDICES.ROUTE_IDENTIFIER
            ]
        }
    ],
    [
        $a49bd8faafbfa6f8$var$routeTypes.USER_CARDS_WORKSPACE,
        {
            id: $a49bd8faafbfa6f8$var$routeTypes.USER_CARDS_WORKSPACE,
            regExp: new RegExp('^/u/([^/]+)/cards/([^/]+)$'),
            allowlist: [
                $a49bd8faafbfa6f8$var$ALLOWLIST_INDICES.ROUTE_IDENTIFIER,
                $a49bd8faafbfa6f8$var$ALLOWLIST_INDICES.U_ROUTE_TAB_NAME
            ]
        }
    ],
    [
        $a49bd8faafbfa6f8$var$routeTypes.USER_TABS,
        {
            id: $a49bd8faafbfa6f8$var$routeTypes.USER_TABS,
            regExp: new RegExp('^/u/([^/]+)/(profile|activity|boards|cards|labs|tasks)$'),
            allowlist: [
                $a49bd8faafbfa6f8$var$ALLOWLIST_INDICES.ROUTE_IDENTIFIER,
                $a49bd8faafbfa6f8$var$ALLOWLIST_INDICES.U_ROUTE_TAB_NAME
            ]
        }
    ],
    [
        $a49bd8faafbfa6f8$var$routeTypes.USER,
        {
            id: $a49bd8faafbfa6f8$var$routeTypes.USER,
            regExp: new RegExp('^/u/'),
            allowlist: [
                $a49bd8faafbfa6f8$var$ALLOWLIST_INDICES.ROUTE_IDENTIFIER
            ]
        }
    ],
    [
        $a49bd8faafbfa6f8$var$routeTypes.VIEW,
        {
            id: $a49bd8faafbfa6f8$var$routeTypes.VIEW,
            regExp: new RegExp('^/v/'),
            allowlist: [
                $a49bd8faafbfa6f8$var$ALLOWLIST_INDICES.ROUTE_IDENTIFIER,
                $a49bd8faafbfa6f8$var$ALLOWLIST_INDICES.ROUTE_SHORTLINK
            ]
        }
    ],
    [
        $a49bd8faafbfa6f8$var$routeTypes.WORKSPACE_SECTION,
        {
            id: $a49bd8faafbfa6f8$var$routeTypes.WORKSPACE_SECTION,
            regExp: new RegExp('^/w/([^/]+)/(account|billing|home|export|free-trial|members|tables|getting-started|highlights|reports)$'),
            allowlist: [
                $a49bd8faafbfa6f8$var$ALLOWLIST_INDICES.ROUTE_IDENTIFIER,
                $a49bd8faafbfa6f8$var$ALLOWLIST_INDICES.W_ROUTE_PAGE
            ]
        }
    ],
    [
        $a49bd8faafbfa6f8$var$routeTypes.WORKSPACE_MEMBERS_SUBSECTION,
        {
            id: $a49bd8faafbfa6f8$var$routeTypes.WORKSPACE_MEMBERS_SUBSECTION,
            regExp: new RegExp('^/w/([^/]+)/members/(guests|requests)$'),
            allowlist: [
                $a49bd8faafbfa6f8$var$ALLOWLIST_INDICES.ROUTE_IDENTIFIER,
                $a49bd8faafbfa6f8$var$ALLOWLIST_INDICES.W_ROUTE_PAGE,
                $a49bd8faafbfa6f8$var$ALLOWLIST_INDICES.W_ROUTE_PAGE_SUBSECTION
            ]
        }
    ],
    [
        $a49bd8faafbfa6f8$var$routeTypes.WORKSPACE_VIEWS_SUBSECTION,
        {
            id: $a49bd8faafbfa6f8$var$routeTypes.WORKSPACE_VIEWS_SUBSECTION,
            regExp: new RegExp('^/w/([^/]+)/views/(table|calendar|)$'),
            allowlist: [
                $a49bd8faafbfa6f8$var$ALLOWLIST_INDICES.ROUTE_IDENTIFIER,
                $a49bd8faafbfa6f8$var$ALLOWLIST_INDICES.W_ROUTE_PAGE,
                $a49bd8faafbfa6f8$var$ALLOWLIST_INDICES.W_ROUTE_PAGE_SUBSECTION
            ]
        }
    ],
    [
        $a49bd8faafbfa6f8$var$routeTypes.WORKSPACE,
        {
            id: $a49bd8faafbfa6f8$var$routeTypes.WORKSPACE,
            regExp: new RegExp('^/w/'),
            allowlist: [
                $a49bd8faafbfa6f8$var$ALLOWLIST_INDICES.ROUTE_IDENTIFIER
            ]
        }
    ]
]);
var $a49bd8faafbfa6f8$var$TrelloUrlScrubber = $a49bd8faafbfa6f8$exports.TrelloUrlScrubber = /*#__PURE__*/ function() {
    function TrelloUrlScrubber() {
        $a49bd8faafbfa6f8$var$_classCallCheck(this, TrelloUrlScrubber);
    }
    return $a49bd8faafbfa6f8$var$_createClass(TrelloUrlScrubber, null, [
        {
            key: "_determineRoute",
            value: function _determineRoute(urlPathname) {
                var routePatternArray = Array.from($a49bd8faafbfa6f8$var$routePatternMap.values());
                for(var _i = 0, _routePatternArray = routePatternArray; _i < _routePatternArray.length; _i++){
                    var routeDefinition = _routePatternArray[_i];
                    if (routeDefinition.regExp.exec(urlPathname)) return routeDefinition;
                }
                return null;
            }
        },
        {
            key: "_reconstructPathname",
            value: function _reconstructPathname(pathnameSections, sectionsToKeep) {
                var reconstructedUrl = '';
                for(var i = 0; i < pathnameSections.length; i++)if (sectionsToKeep.includes(i)) reconstructedUrl += '/' + pathnameSections[i];
                return reconstructedUrl;
            }
        },
        {
            key: "scrubUrl",
            value: function scrubUrl(urlPathname, defaultPathname) {
                var matchingRoute = TrelloUrlScrubber._determineRoute(urlPathname);
                // remove starting slash to allow matchers to use ^ properly
                var partialUrl = urlPathname.substring(1, urlPathname.length);
                var pathnameSections = partialUrl.split('/');
                // to avoid UGC/PII related HOTs, we should be extra cautious & return a
                // generic path for URLs that don't follow a known pattern
                return matchingRoute ? TrelloUrlScrubber._reconstructPathname(pathnameSections, matchingRoute.allowlist) : defaultPathname;
            }
        }
    ]);
}();


function $077fd9c14d82a85a$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $077fd9c14d82a85a$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $077fd9c14d82a85a$var$_typeof(o);
}
function $077fd9c14d82a85a$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $077fd9c14d82a85a$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $077fd9c14d82a85a$var$ownKeys(Object(t), !0).forEach(function(r) {
            $077fd9c14d82a85a$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $077fd9c14d82a85a$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $077fd9c14d82a85a$var$_classCallCheck(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function $077fd9c14d82a85a$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, $077fd9c14d82a85a$var$_toPropertyKey(o.key), o);
    }
}
function $077fd9c14d82a85a$var$_createClass(e, r, t) {
    return r && $077fd9c14d82a85a$var$_defineProperties(e.prototype, r), t && $077fd9c14d82a85a$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}
function $077fd9c14d82a85a$var$_defineProperty(e, r, t) {
    return (r = $077fd9c14d82a85a$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $077fd9c14d82a85a$var$_toPropertyKey(t) {
    var i = $077fd9c14d82a85a$var$_toPrimitive(t, "string");
    return "symbol" == $077fd9c14d82a85a$var$_typeof(i) ? i : i + "";
}
function $077fd9c14d82a85a$var$_toPrimitive(t, r) {
    if ("object" != $077fd9c14d82a85a$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $077fd9c14d82a85a$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}

var $lSdkB = parcelRequire("lSdkB");
var $077fd9c14d82a85a$var$attributeWhiteList = [
    'atlCohort',
    'featureFlags'
];
var $077fd9c14d82a85a$var$ATL_USER_HASH = 'atlUserHash';
/**
 * Module for GASv3 tracking events.
 * @module GASv3
 */ var $077fd9c14d82a85a$var$GASv3 = $077fd9c14d82a85a$exports.GASv3 = /*#__PURE__*/ function() {
    function GASv3() {
        $077fd9c14d82a85a$var$_classCallCheck(this, GASv3);
    }
    return $077fd9c14d82a85a$var$_createClass(GASv3, null, [
        {
            key: "sendUIEvent",
            value: /**
     * Sends a UI event to GASv3
     * @function sendUIEvent
     * @param {string} name
     * @param {object} data
     * @param {object} skipEnrichment - whether to add additional data
     */ function sendUIEvent(name, data, skipEnrichment) {
                var attributes = data.attributes || {};
                if (!skipEnrichment) attributes = GASv3.enrichEventData(data.attributes);
                attributes['trackEventName'] = name;
                var source = GASv3.setSource(data);
                var uiEvent = {
                    action: data.action || 'clicked',
                    actionSubject: data.actionSubject || 'component',
                    actionSubjectId: data.actionSubjectId || undefined,
                    source: source,
                    attributes: attributes
                };
                this._createAndFireEvent($iVpQc.eventType.UI, uiEvent);
            }
        },
        {
            key: "sendScreenEvent",
            value: function sendScreenEvent(name, data, skipEnrichment) {
                var attributes = data.attributes || {};
                if (!skipEnrichment) attributes = GASv3.enrichEventData(data.attributes);
                attributes['name'] = name || data['name'];
                var screenName = data['name'] || attributes['screenNameOverride'] || 'page';
                delete attributes['screenNameOverride'];
                this._createAndFireEvent($iVpQc.eventType.SCREEN, {
                    name: screenName,
                    attributes: attributes
                });
                GASv3.sendIdentityEvent();
            }
        },
        {
            key: "sendTrackEvent",
            value: function sendTrackEvent(name, data, skipEnrichment) {
                var attributes = data.attributes || {};
                if (!skipEnrichment) attributes = GASv3.enrichEventData(data.attributes);
                attributes['trackEventName'] = name;
                data.source = GASv3.setSource(data);
                data.attributes = attributes;
                this._createAndFireEvent($iVpQc.eventType.TRACK, data);
            }
        },
        {
            key: "sendOperationalEvent",
            value: function sendOperationalEvent(name, data, skipEnrichment) {
                var attributes = data.attributes || {};
                if (!skipEnrichment) attributes = GASv3.enrichEventData(data.attributes);
                attributes['trackEventName'] = name;
                data.source = GASv3.setSource(data);
                data.attributes = attributes;
                this._createAndFireEvent($iVpQc.eventType.OPERATIONAL, data);
            }
        },
        {
            key: "sendIdentityEvent",
            value: function sendIdentityEvent() {
                // load the identity hash cookie
                var atlUserHash = $767eab9fde59e2ab$exports.Cookie.readCookie($077fd9c14d82a85a$var$ATL_USER_HASH);
                // get the user identifiers
                var identifiers = GASv3.getUserIdentifiers();
                // calculate the data hash of the known identifiers
                var calculatedHash = $d568c1b4cd0cc27f$exports.Guid.guidHashCode(JSON.stringify(identifiers)).toString();
                if (!atlUserHash || atlUserHash !== calculatedHash) {
                    // save new hash and send UI event
                    $767eab9fde59e2ab$exports.Cookie.writeCookie($077fd9c14d82a85a$var$ATL_USER_HASH, calculatedHash, 3650, true);
                    var data = {
                        action: 'identified',
                        actionSubject: 'user',
                        identifiers: identifiers,
                        writeKey: $adbd9ab2eaa40909$exports.AnalyticsState.writeKey
                    };
                    GASv3.sendUIEvent('', data, true);
                }
            }
        },
        {
            key: "getUserIdentifiers",
            value: function getUserIdentifiers() {
                return {
                    anonymousId: $adbd9ab2eaa40909$exports.AnalyticsState.anonymousId,
                    atlassianAccountId: $35247c7511184ad3$exports.Identity.getAtlassianUserId(),
                    crossDomainId: $3f4554f5dd6755f8$exports.Tracking.xid,
                    optimizelyEndUserId: null,
                    trelloUserId: $35247c7511184ad3$exports.Identity.getTrelloUserId()
                };
            }
        },
        {
            key: "setSource",
            value: function setSource(data) {
                var set = false;
                var source = data.source || '';
                if (source) set = true;
                if (data['eventContainer']) {
                    source += data['eventContainer'].split(' ')[0];
                    set = true;
                }
                if (data['eventColumn']) {
                    source += data['eventColumn'].split(' ')[0];
                    set = true;
                }
                if (!set) source = 'none';
                return source;
            }
        },
        {
            key: "getReferrerURL",
            value: function getReferrerURL(ref) {
                if ($35247c7511184ad3$exports.Identity.isReferrerTrello()) {
                    var referrer = new URL(ref);
                    return referrer.hostname + $a49bd8faafbfa6f8$exports.TrelloUrlScrubber.scrubUrl(referrer.pathname, '');
                }
                return ref;
            }
        },
        {
            key: "_createAndFireEvent",
            value: function _createAndFireEvent(eventType, payload) {
                // using analytics-next createAndFireEvent to send event
                if ($adbd9ab2eaa40909$exports.AnalyticsState.createAnalyticsEvent) (0, $3bef5a1e67ea5779$export$2e2bcd8739ae039)('atl-global')($077fd9c14d82a85a$var$_objectSpread($077fd9c14d82a85a$var$_objectSpread({}, payload), {}, {
                    eventType: eventType
                }))($adbd9ab2eaa40909$exports.AnalyticsState.createAnalyticsEvent);
                // using analytics-web-client to send event
                if (GASv3.client) switch(eventType){
                    case 'ui':
                        GASv3.client.sendUIEvent(payload, null);
                        break;
                    case 'screen':
                        GASv3.client.sendScreenEvent(payload, null);
                        break;
                    case 'operational':
                        GASv3.client.sendOperationalEvent(payload, null);
                        break;
                    case 'track':
                        GASv3.client.sendTrackEvent(payload, null);
                        break;
                }
            }
        },
        {
            key: "enrichEventData",
            value: function enrichEventData(inputData) {
                var data = {};
                if ($077fd9c14d82a85a$var$_typeof(inputData) !== 'object' || inputData === null) {
                    var dataValue = inputData;
                    if (typeof dataValue !== 'undefined') data.data = dataValue;
                } else data = inputData;
                var newData = JSON.parse(JSON.stringify(data));
                newData.writeKey = $adbd9ab2eaa40909$exports.AnalyticsState.writeKey;
                newData.isMarketingEvent = GASv3.isMarketingEvent;
                var page;
                var ref;
                var page_canonical_url;
                try {
                    var _page;
                    // convert all passed in values to string if they are currently objects
                    Object.keys(newData).forEach(function(inputKey) {
                        var key = inputKey;
                        if (newData[key] && $077fd9c14d82a85a$var$_typeof(newData[key]) === 'object' && !Array.isArray(newData[key]) && !$077fd9c14d82a85a$var$attributeWhiteList.includes(key)) // @ts-ignore
                        newData[key] = JSON.stringify(newData[key]);
                    });
                    var href = GASv3.getLocation();
                    page = href ? new URL($4fb91a309ed42af5$exports.Helpers.maskURL(href)) : null;
                    var referredByJiraDotCom = ((_page = page) === null || _page === void 0 ? void 0 : _page.searchParams.get('referer')) === 'jira.com';
                    ref = referredByJiraDotCom ? new URL('https://www.jira.com') : document.referrer ? new URL($4fb91a309ed42af5$exports.Helpers.maskURL(document.referrer)) : null;
                    var canonical_url = $4fb91a309ed42af5$exports.Helpers.getCanonicalUrl();
                    page_canonical_url = canonical_url ? $4fb91a309ed42af5$exports.Helpers.maskURL($4fb91a309ed42af5$exports.Helpers.getCanonicalUrl()) : undefined;
                    newData.page_title = newData.page_title || document.title || '';
                    newData.page_domain = page ? page.hostname || '' : '';
                    newData.page_subdomain = page ? page.hostname || '' : '';
                    // referrer attributes
                    newData.page_referrer_domain = ref ? ref.hostname || '' : '';
                    newData.page_referrer_subdomain = ref ? ref.hostname || '' : '';
                    if ($35247c7511184ad3$exports.Identity.isReferrerTrello()) {
                        // fix for hot-99118
                        newData.page_canonical_url = page ? $a49bd8faafbfa6f8$exports.TrelloUrlScrubber.scrubUrl(page.href, page.origin) || '' : '';
                        newData.page_url = page ? $a49bd8faafbfa6f8$exports.TrelloUrlScrubber.scrubUrl(page.href, page.origin) || '' : '';
                        newData.page_path = page ? $a49bd8faafbfa6f8$exports.TrelloUrlScrubber.scrubUrl(page.pathname, new URL(page.href).pathname) || '' : '';
                        newData.page_url_parameters = page ? $a49bd8faafbfa6f8$exports.TrelloUrlScrubber.scrubUrl(page.search, '') : '';
                        newData.page_url_params_json = page ? JSON.stringify($lSdkB.parse($a49bd8faafbfa6f8$exports.TrelloUrlScrubber.scrubUrl(page.search, new URL(page.origin).pathname))) : '';
                        newData.page_referrer_url_params_json = ref ? JSON.stringify($lSdkB.parse($a49bd8faafbfa6f8$exports.TrelloUrlScrubber.scrubUrl(ref.search, new URL(ref.origin).pathname))) : '';
                        newData.page_referrer_path = ref ? $a49bd8faafbfa6f8$exports.TrelloUrlScrubber.scrubUrl(ref.pathname, new URL(ref.origin).pathname) || '' : '';
                        newData.page_referrer_url = ref ? ref.origin + $a49bd8faafbfa6f8$exports.TrelloUrlScrubber.scrubUrl(ref.pathname, new URL(ref.origin).pathname) || '' : '';
                    } else {
                        newData.page_canonical_url = page_canonical_url;
                        newData.page_url = page ? page.href || '' : '';
                        newData.page_path = page ? page.pathname || '' : '';
                        newData.page_url_parameters = page ? page.search || '' : '';
                        newData.page_url_params_json = page ? JSON.stringify($lSdkB.parse(page.search)) : '';
                        newData.page_url_fragment = page ? $4fb91a309ed42af5$exports.Helpers.getUrlFragment() : ''; // added for community client
                        newData.page_referrer_url_params_json = ref ? JSON.stringify($lSdkB.parse(ref.search)) : '';
                        newData.page_referrer_path = ref ? ref.pathname || '' : '';
                        newData.page_referrer_url = ref ? ref.href || '' : '';
                    }
                    newData.cookiesEnabled = window.navigator ? window.navigator.cookieEnabled : 'unknown';
                    newData.activeGroups = window.OnetrustActiveGroups ? window.OnetrustActiveGroups : '';
                    // add additionalEventData
                    for(var _key in GASv3.additionalEventData)// eslint-disable-next-line no-prototype-builtins
                    if (GASv3.additionalEventData.hasOwnProperty(_key)) newData[_key] = GASv3.additionalEventData[_key];
                } catch (e) {
                    // fix for hot-99118
                    var additionalData = {
                        error: e instanceof Error ? e.message : JSON.stringify(e),
                        href: location ? location.href : 'no location',
                        referrer: document ? document.referrer ? GASv3.getReferrerURL(document.referrer) : 'no referrer' : 'no document'
                    };
                    $4fb91a309ed42af5$exports.Helpers.sendWrapperLoadError('GASv3 enrichEventData error', JSON.stringify(additionalData));
                }
                return newData;
            }
        },
        {
            key: "getLocation",
            value: function getLocation() {
                return location.href;
            }
        }
    ]);
}();
// set this value with attributes that should be sent on every event, set during event enrichment
$077fd9c14d82a85a$var$_defineProperty($077fd9c14d82a85a$var$GASv3, "additionalEventData", {});


var $6428f42409a4abae$exports = {};
"use strict";
Object.defineProperty($6428f42409a4abae$exports, "__esModule", {
    value: true
});
$6428f42409a4abae$exports.Gtm = void 0;

function $6428f42409a4abae$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $6428f42409a4abae$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $6428f42409a4abae$var$_typeof(o);
}
function $6428f42409a4abae$var$_classCallCheck(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function $6428f42409a4abae$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, $6428f42409a4abae$var$_toPropertyKey(o.key), o);
    }
}
function $6428f42409a4abae$var$_createClass(e, r, t) {
    return r && $6428f42409a4abae$var$_defineProperties(e.prototype, r), t && $6428f42409a4abae$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}
function $6428f42409a4abae$var$_toPropertyKey(t) {
    var i = $6428f42409a4abae$var$_toPrimitive(t, "string");
    return "symbol" == $6428f42409a4abae$var$_typeof(i) ? i : i + "";
}
function $6428f42409a4abae$var$_toPrimitive(t, r) {
    if ("object" != $6428f42409a4abae$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $6428f42409a4abae$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
} /**
 * Internal module for initializing Snowplow and making Snowplow-specific event calls. Public init functions can be found in Initializer module
 * @module Gtm
 */ 
var $6428f42409a4abae$var$Gtm = $6428f42409a4abae$exports.Gtm = /*#__PURE__*/ function() {
    function Gtm() {
        $6428f42409a4abae$var$_classCallCheck(this, Gtm);
    }
    return $6428f42409a4abae$var$_createClass(Gtm, null, [
        {
            key: "initialize",
            value: /**
     * Initializes Google Tag Manager
     * @function initialize
     */ function initialize(writeKey) {
                var containerId = Gtm.getContainerId(writeKey);
                if (containerId) {
                    var _firstScript$parentNo;
                    window['dataLayer'] = window['dataLayer'] || [];
                    window['dataLayer'].push({
                        'gtm.start': new Date().getTime(),
                        event: 'gtm.js'
                    });
                    var firstScript = document.getElementsByTagName('script')[0];
                    var gtmScript = document.createElement('script');
                    gtmScript.defer = true;
                    gtmScript.src = 'https://www.googletagmanager.com/gtm.js?id=' + containerId;
                    firstScript === null || firstScript === void 0 || (_firstScript$parentNo = firstScript.parentNode) === null || _firstScript$parentNo === void 0 || _firstScript$parentNo.appendChild(gtmScript);
                }
            }
        },
        {
            key: "page",
            value: function page(name, category, data) {
                var event = 'Loaded a Page';
                Gtm.track(data, event);
                if (category) {
                    event = 'Viewed ' + name + ' ' + category + ' Page';
                    Gtm.track(data, event);
                }
                if (name) {
                    event = 'Viewed ' + name + ' Page';
                    Gtm.track(data, event);
                }
            }
        },
        {
            key: "track",
            value: function track(data, event) {
                var props = typeof data !== 'undefined' ? JSON.parse(JSON.stringify(data)) : {};
                var anonId = $adbd9ab2eaa40909$exports.AnalyticsState.anonymousId;
                if (anonId) props.gasv3AnonymousId = anonId;
                if (event) props.event = event;
                var dataLayer = 'dataLayer';
                window[dataLayer] = window[dataLayer] || [];
                window[dataLayer].push(props);
            }
        },
        {
            key: "getContainerId",
            value: function getContainerId(writeKey) {
                var containerIds = Gtm.getContainerIdMapping();
                return containerIds[writeKey];
            }
        },
        {
            key: "getContainerIdMapping",
            value: function getContainerIdMapping() {
                return {
                    // Production
                    ycih1ygfsk: 'GTM-MR6PJQR',
                    // support.atlassian.com
                    '9nfqb81km3': 'GTM-TSGXFNC',
                    // confluence.atlassian.com
                    kFTUHPhH9Q: 'GTM-TRS3MV',
                    // bitbucket
                    u7y09b0olq: 'GTM-5VS67RK',
                    // developer.atlassian.com
                    eNVsl3NOQquS5E0YXjD4prfiNVqVP3mr: 'GTM-KZLJPX4',
                    // opsgenie
                    bvsetm1g1y: 'GTM-5RJSBR',
                    // atlassian.com-cart
                    kiv6wyh2nw: 'GTM-5RJSBR',
                    // atlassian.com
                    r4n974s99s: 'GTM-5RJSBR',
                    // blogs.atlassian.com
                    swoogo: 'GTM-5RJSBR',
                    // events.atlassian.com
                    '8oi64no': 'GTM-K7MDT22',
                    // statuspage.io
                    xjtlog1hqa: 'GTM-KQ6R2C3',
                    // marketplace.atlassian.com
                    bNSPpYAL9OiAkamBRvfRJoRu9YANW14I: 'GTM-MGV77B',
                    // docs.atlassian.com-aui
                    TNnhg0QuQfHEpBTzp27kJXNWZoMqSvkw: 'GTM-TQZMFCL',
                    // community.atlassian.com
                    trello: 'GTM-PJ8M5SK',
                    // trello
                    // Test
                    '4J6H7c3XTcpm1dbenkOILSyOachvf9It': 'GTM-TQZMFCL',
                    // community.stg.atlassian.com
                    SBLZG3ZYcSBcUMeLKLalrtyW8w1Caold: 'GTM-TQZMFCL',
                    // community.dev1.dev.atlassian.com
                    QVFu18jjHlCNaBXizZ3mtiqlBXVRkg1M: 'GTM-TQZMFCL',
                    // community.dev2.dev.atlassian.com
                    QmWM6iw7auEJw5gDQi6910Xk1wqyZ6bE: 'GTM-TQZMFCL',
                    // community.dev3.dev.atlassian.com
                    hWTszOAQMuItRdv8J30A3mNpCWd891bx: 'GTM-TQZMFCL',
                    // community.dev4.dev.atlassian.com
                    EWfeqJKJ0rPNOe3fcXrh2dg7bVXZNi2I: 'GTM-5RJSBR',
                    // qa-wac.internal.atlassian.com
                    Z2S07IGcRYkPJ7XHy3OIXcjpYoy9E6bs: 'GTM-5RJSBR' // CXP Local Dev
                };
            }
        }
    ]);
}();





var $55a1880d3758202a$exports = {};
"use strict";
Object.defineProperty($55a1880d3758202a$exports, "__esModule", {
    value: true
});
$55a1880d3758202a$exports.eventType = void 0;
// this is a 'const enum' copy of eventType from '@atlassiansox/analytics-web-client'
// exporting it here allows importing the enum directly from this package - it cannot be directly exported, as
// enums have issues being accessed during runtime from *.d.ts files
// https://stackoverflow.com/a/50511773
// https://stackoverflow.com/a/66939542
var $55a1880d3758202a$var$eventType = $55a1880d3758202a$exports.eventType = /*#__PURE__*/ function(eventType) {
    eventType["TRACK"] = "track";
    eventType["UI"] = "ui";
    eventType["OPERATIONAL"] = "operational";
    eventType["SCREEN"] = "screen";
    eventType["IDENTIFY"] = "identify";
    return eventType;
}({});


function $3f4554f5dd6755f8$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $3f4554f5dd6755f8$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $3f4554f5dd6755f8$var$_typeof(o);
}
function $3f4554f5dd6755f8$var$_classCallCheck(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function $3f4554f5dd6755f8$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, $3f4554f5dd6755f8$var$_toPropertyKey(o.key), o);
    }
}
function $3f4554f5dd6755f8$var$_createClass(e, r, t) {
    return r && $3f4554f5dd6755f8$var$_defineProperties(e.prototype, r), t && $3f4554f5dd6755f8$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}
function $3f4554f5dd6755f8$var$_toPropertyKey(t) {
    var i = $3f4554f5dd6755f8$var$_toPrimitive(t, "string");
    return "symbol" == $3f4554f5dd6755f8$var$_typeof(i) ? i : i + "";
}
function $3f4554f5dd6755f8$var$_toPrimitive(t, r) {
    if ("object" != $3f4554f5dd6755f8$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $3f4554f5dd6755f8$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $3f4554f5dd6755f8$var$Tracking = $3f4554f5dd6755f8$exports.Tracking = /*#__PURE__*/ function() {
    function Tracking() {
        $3f4554f5dd6755f8$var$_classCallCheck(this, Tracking);
    }
    return $3f4554f5dd6755f8$var$_createClass(Tracking, null, [
        {
            key: "_getEventDomain",
            value: function _getEventDomain() {
                return location && location.href ? new URL(location.href).hostname : '';
            }
        },
        {
            key: "_browserSupportsPromises",
            value: function _browserSupportsPromises() {
                return typeof Promise === 'function';
            }
        },
        {
            key: "_userOptedOutOfTrackingCookies",
            value: function _userOptedOutOfTrackingCookies() {
                return false;
            }
        },
        {
            key: "_shouldUsePromise",
            value: function _shouldUsePromise() {
                // return false for now, since Marketo is not supported with new community core apps;
                // the promise logic is used to retrieve the Marketo ID cookie
                // see atl-analytics atl-events.js for more details about marketo domains
                //return Tracking._browserSupportsPromises() && !Tracking._userOptedOutOfTrackingCookies();
                return false;
            }
        },
        {
            key: "trackEvent",
            value: function trackEvent(event, data) {
                var type = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : $55a1880d3758202a$exports.eventType.UI;
                if (Tracking._shouldUsePromise()) Tracking.enrichEventDataPromise(data).then(function(enrichedData) {
                    return Tracking._trackEvent(event, enrichedData, type);
                })["catch"](function(e) {
                    console.warn('enrich Event + tracking._trackEvent invocation failed', e);
                });
                else try {
                    data = Tracking.enrichEventData(data);
                    Tracking._trackEvent(event, data, type);
                } catch (e) {
                    console.warn('enrich Event + tracking._trackEvent invocation failed', e);
                }
            }
        },
        {
            key: "_trackEvent",
            value: function _trackEvent(event, enrichedData, type) {
                switch(type){
                    case $55a1880d3758202a$exports.eventType.SCREEN:
                        $077fd9c14d82a85a$exports.GASv3.sendScreenEvent(event, enrichedData);
                        break;
                    case $55a1880d3758202a$exports.eventType.TRACK:
                        $077fd9c14d82a85a$exports.GASv3.sendTrackEvent(event, enrichedData);
                        break;
                    case $55a1880d3758202a$exports.eventType.OPERATIONAL:
                        $077fd9c14d82a85a$exports.GASv3.sendOperationalEvent(event, enrichedData);
                        break;
                    case $55a1880d3758202a$exports.eventType.UI:
                    default:
                        $077fd9c14d82a85a$exports.GASv3.sendUIEvent(event, enrichedData);
                        break;
                }
            }
        },
        {
            key: "pageView",
            value: function pageView(pageViewProperties) {
                if (Tracking._shouldUsePromise()) Tracking.enrichEventDataPromise(pageViewProperties).then(function(enrichedPageViewProperties) {
                    Tracking._pageView(enrichedPageViewProperties);
                })["catch"](function(e) {
                    console.warn('enrich Event + tracking._pageView invocation failed', e);
                });
                else try {
                    pageViewProperties = Tracking.enrichEventData(pageViewProperties);
                    Tracking._pageView(pageViewProperties);
                } catch (e) {
                    console.warn('enrich Event + tracking._pageView invocation failed', e);
                }
            }
        },
        {
            key: "_pageView",
            value: function _pageView(enrichedPageViewProperties) {
                enrichedPageViewProperties.wrapperName = 'atl-global';
                enrichedPageViewProperties.destinationFlag = 'gasv3';
                if (window.cmsPageVariant) enrichedPageViewProperties.cmsPageVariant = window.cmsPageVariant;
                $6428f42409a4abae$exports.Gtm.page(null, null, enrichedPageViewProperties);
                $077fd9c14d82a85a$exports.GASv3.sendScreenEvent(null, enrichedPageViewProperties);
            }
        },
        {
            key: "getPageViewId",
            value: function getPageViewId() {
                if (!Tracking.pageViewId) Tracking.pageViewId = $d568c1b4cd0cc27f$exports.Guid.guid();
                return Tracking.pageViewId;
            }
        },
        {
            key: "enrichEventDataPromise",
            value: function enrichEventDataPromise(data) {
                // If the data contains a href, then we have clicked a link and are navigating away
                // to a different page, so we don't have time to wait for the retry logic.
                var enableRetryForMarketoId = !(data !== null && data !== void 0 && data.href) && !(data !== null && data !== void 0 && data.form);
                return new Promise(function(resolve) {
                    $35247c7511184ad3$exports.Identity.getMarketoIdPromise(enableRetryForMarketoId).then(function(marketoId) {
                        resolve(Tracking._enrichEventData(data, marketoId));
                    });
                });
            }
        },
        {
            key: "enrichEventData",
            value: function enrichEventData(data) {
                return Tracking._enrichEventData(data, $35247c7511184ad3$exports.Identity.getMarketoId());
            }
        },
        {
            key: "_enrichEventData",
            value: function _enrichEventData(inputData, marketoId) {
                var data = {};
                if ($3f4554f5dd6755f8$var$_typeof(inputData) !== 'object' || inputData === null) {
                    var dataValue = inputData;
                    if (typeof dataValue !== 'undefined') data['data'] = dataValue;
                } else data = inputData;
                // if not already done, read the request Id cookie set by bxp-gateway
                if (!Tracking.bxpGatewayRequestId) Tracking.bxpGatewayRequestId = $767eab9fde59e2ab$exports.Cookie.readCookie('bxp_gateway_request_id');
                // Only set the property if the cookie was there and readCookie didn't return null
                if (Tracking.bxpGatewayRequestId) data['bxpGatewayRequestId'] = Tracking.bxpGatewayRequestId;
                data['pageViewId'] = Tracking.getPageViewId();
                // add identity data, if not present
                data['atlEventId'] = $d568c1b4cd0cc27f$exports.Guid.guid();
                data['atlJSVersion'] = $adbd9ab2eaa40909$exports.AnalyticsState.version || '1.0.0';
                data['browserLanguages'] = navigator.languages;
                // add category, if not present
                data['category'] = data['category'] || (document.title !== 'undefined' ? document.title.trim().replace(/\W+/g, '_') : '');
                // add the cohort to the object
                data[$062e0101ba16ec7d$exports.ATL_COHORT] = $062e0101ba16ec7d$exports.Cohort.readWriteAtlCohort();
                var utms = $adbd9ab2eaa40909$exports.AnalyticsState.utms;
                if (utms) data['campaign'] = {
                    name: utms['utm_campaign'],
                    medium: utms['utm_medium'],
                    source: utms['utm_source'],
                    content: utms['utm_content'],
                    term: utms['utm_term']
                };
                data['clientSessionId'] = Tracking.readWriteSessionCookie();
                if (Tracking.xid) data['atlXid'] = Tracking.xid;
                data['marketoId'] = marketoId ? marketoId : '';
                return data;
            }
        },
        {
            key: "buildTrackEventProperties",
            value: function buildTrackEventProperties(el, dataset, label, href) {
                if (!dataset) return;
                var trackEventProperties = {
                    label: label,
                    href: href
                };
                if (el && el.nodeName === 'BUTTON') {
                    var form = el.getAttribute('form');
                    if (form) trackEventProperties.form = form;
                }
                var expectedProperties = [
                    'actionSubjectId',
                    'eventContainer',
                    'eventColumn',
                    'eventComponent',
                    'uuid',
                    'event',
                    'inputValue',
                    'parentLabel',
                    'label',
                    'labelEnglish',
                    'productKey',
                    'productVersion',
                    'productEdition',
                    'productPlatform',
                    'schemaVersion',
                    'name'
                ];
                var isExpectedProperty = function isExpectedProperty(value) {
                    return expectedProperties.includes(value);
                };
                var dataSetEntries = [];
                for(var dataProperty in dataset)// eslint-disable-next-line no-prototype-builtins
                if (dataProperty !== 'track-event' && dataset.hasOwnProperty(dataProperty)) {
                    var dataPropertyValue = dataset[dataProperty];
                    if (dataPropertyValue) {
                        if (isExpectedProperty(dataProperty)) trackEventProperties[dataProperty] = dataPropertyValue;
                        else {
                            var dataEntry = {};
                            dataEntry[dataProperty] = dataPropertyValue;
                            dataSetEntries.push(dataEntry);
                        }
                    }
                }
                trackEventProperties.dataSet = dataSetEntries;
                return trackEventProperties;
            }
        },
        {
            key: "_autoTrackClickEvent",
            value: function _autoTrackClickEvent(event) {
                try {
                    var currentTargetElem = event.currentTarget;
                    var targetElem = event.target;
                    var rawText = targetElem.textContent;
                    var isInput = function isInput(elem) {
                        return elem.tagName === 'INPUT';
                    };
                    var isAnchor = function isAnchor(elem) {
                        return elem.hasAttribute('href');
                    };
                    var isSelect = function isSelect(elem) {
                        return elem.tagName === 'SELECT';
                    };
                    // handle form buttons differently
                    if (isInput(targetElem)) // targetElem.value of an input text field is considered UGC and should not be tracked
                    rawText = targetElem.type === 'text' ? '[REDACTED]' : targetElem.value !== '' ? targetElem.value : targetElem.textContent;
                    else if (isSelect(targetElem)) {
                        targetElem = targetElem.options[targetElem.selectedIndex] || targetElem;
                        rawText = targetElem.getAttribute('data-label') || targetElem.textContent || targetElem.ariaLabel || targetElem.className;
                    } else if (rawText === '') {
                        var _targetElem$parentNod;
                        rawText = ((_targetElem$parentNod = targetElem.parentNode) === null || _targetElem$parentNod === void 0 ? void 0 : _targetElem$parentNod.textContent) || targetElem.title || targetElem.ariaLabel || targetElem.className;
                    }
                    var href = isAnchor(targetElem) ? targetElem.href : isAnchor(currentTargetElem) ? currentTargetElem.href : '';
                    var trackEventName = targetElem.getAttribute('data-track-event') || currentTargetElem.getAttribute('data-track-event') || 'Clicked-Auto-CTA';
                    var eventLabel = rawText ? rawText.toLowerCase().trim().replace(/ /g, '-') : '';
                    var trackEventProperties = Tracking.buildTrackEventProperties(currentTargetElem, currentTargetElem.dataset, eventLabel, href);
                    //@ts-ignore
                    Tracking.trackEvent(trackEventName, trackEventProperties);
                } catch (err) {
                    $4fb91a309ed42af5$exports.Helpers.sendWrapperLoadError('Error auto-tracking click event');
                }
            }
        },
        {
            key: "autoTrackSelects",
            value: function autoTrackSelects() {
                try {
                    var selects = Array.from(document.querySelectorAll('select'));
                    for(var _i = 0, _selects = selects; _i < _selects.length; _i++){
                        var select = _selects[_i];
                        if (!Tracking.isAutoTrackingDisabled(select)) {
                            select.removeEventListener('change', Tracking._autoTrackClickEvent);
                            select.addEventListener('change', Tracking._autoTrackClickEvent);
                        }
                    }
                } catch (e) {
                    $4fb91a309ed42af5$exports.Helpers.sendWrapperLoadError('Error auto-tracking select event');
                }
            }
        },
        {
            key: "autoTrackButtons",
            value: function autoTrackButtons(trackAll) {
                try {
                    var selector = trackAll ? "button, input[type='submit'], input[type='button']" : "button, input[type='submit']";
                    var btns = Array.from(document.querySelectorAll(selector));
                    for(var _i2 = 0, _btns = btns; _i2 < _btns.length; _i2++){
                        var btn = _btns[_i2];
                        if (!Tracking.isAutoTrackingDisabled(btn)) {
                            // remove existing event listener (to prevent redundant listeners from useEffect hooks)
                            btn.removeEventListener('click', Tracking._autoTrackClickEvent);
                            // add an event listener
                            btn.addEventListener('click', Tracking._autoTrackClickEvent);
                        }
                    }
                } catch (e) {
                    $4fb91a309ed42af5$exports.Helpers.sendWrapperLoadError('Error auto-tracking button event');
                }
            }
        },
        {
            key: "autoTrackLinks",
            value: function autoTrackLinks(trackAll) {
                try {
                    var links = [], selector = trackAll ? 'a, .external-link' : "a[class*='button'], a[class*='btn'], .external-link", btnyLinks = Array.from(document.querySelectorAll(selector));
                    for(var _i3 = 0, _btnyLinks = btnyLinks; _i3 < _btnyLinks.length; _i3++){
                        var el = _btnyLinks[_i3];
                        var htmlEl = el;
                        if (trackAll || htmlEl.offsetWidth >= 50 || el.className.includes('cta') || el.className.includes('external-link')) links.push(el);
                    }
                    for(var _i4 = 0, _links = links; _i4 < _links.length; _i4++){
                        var link = _links[_i4];
                        if (!Tracking.isAutoTrackingDisabled(link)) {
                            link.removeEventListener('click', Tracking._autoTrackClickEvent);
                            link.addEventListener('click', Tracking._autoTrackClickEvent);
                        }
                    }
                } catch (e) {
                    $4fb91a309ed42af5$exports.Helpers.sendWrapperLoadError('Error auto-tracking link event');
                }
            }
        },
        {
            key: "_autoTrackVideoEvent",
            value: function _autoTrackVideoEvent(element, eventName) {
                try {
                    var _element$parentElemen;
                    var className = typeof element.className !== 'undefined' ? element.className : (_element$parentElemen = element.parentElement) === null || _element$parentElemen === void 0 ? void 0 : _element$parentElemen.className, eventLabel = typeof element.textContent !== 'undefined' ? element.textContent : '', eventCategory = typeof document.title !== 'undefined' ? document.title.replace(/\W+/g, '_').trim() : '';
                    Tracking.trackEvent(eventName, {
                        className: className,
                        category: eventCategory,
                        label: eventLabel,
                        _sio: $767eab9fde59e2ab$exports.Cookie.readCookie('_sio') || '',
                        _atl_path: $767eab9fde59e2ab$exports.Cookie.readCookie('__atl_path') || ''
                    });
                } catch (e) {
                    $4fb91a309ed42af5$exports.Helpers.sendWrapperLoadError('Error auto-tracking video event');
                }
            }
        },
        {
            key: "autoTrackVideos",
            value: function autoTrackVideos() {
                try {
                    var videoOpenLinks = Array.from(document.querySelectorAll("div[class*='videoPlayButton'], .video-link, .video_link, .customer-story-video-link"));
                    var videoCloseLinks = Array.from(document.querySelectorAll("div[class='overlay'], .modal.video .close"));
                    var trackVideoOpenEvent = function trackVideoOpenEvent(ev) {
                        var currentTargetElem = ev.currentTarget;
                        Tracking._autoTrackVideoEvent(currentTargetElem, 'Opened Video');
                    };
                    var trackVideoCloseEvent = function trackVideoCloseEvent(ev) {
                        var currentTargetElem = ev.currentTarget;
                        Tracking._autoTrackVideoEvent(currentTargetElem, 'Closed Video');
                    };
                    for(var _i5 = 0, _videoOpenLinks = videoOpenLinks; _i5 < _videoOpenLinks.length; _i5++){
                        var videoOpenLink = _videoOpenLinks[_i5];
                        videoOpenLink.removeEventListener('click', trackVideoOpenEvent);
                        videoOpenLink.addEventListener('click', trackVideoOpenEvent);
                    }
                    for(var _i6 = 0, _videoCloseLinks = videoCloseLinks; _i6 < _videoCloseLinks.length; _i6++){
                        var videoCloseLink = _videoCloseLinks[_i6];
                        videoCloseLink.removeEventListener('click', trackVideoCloseEvent);
                        videoCloseLink.addEventListener('click', trackVideoCloseEvent);
                    }
                } catch (e) {
                    $4fb91a309ed42af5$exports.Helpers.sendWrapperLoadError('Error auto-tracking video event');
                }
            }
        },
        {
            key: "autoTrackTabs",
            value: function autoTrackTabs() {
                try {
                    var selector = "[role='tab']";
                    var tabs = Array.from(document.querySelectorAll(selector));
                    for(var _i7 = 0, _tabs = tabs; _i7 < _tabs.length; _i7++){
                        var tab = _tabs[_i7];
                        if (!Tracking.isAutoTrackingDisabled(tab)) {
                            // remove existing event listener (to prevent redundant listeners from useEffect hooks)
                            tab.removeEventListener('select', Tracking._autoTrackClickEvent);
                            // add an event listener
                            tab.addEventListener('select', Tracking._autoTrackClickEvent);
                        }
                    }
                } catch (e) {
                    $4fb91a309ed42af5$exports.Helpers.sendWrapperLoadError('Error auto-tracking tab event');
                }
            }
        },
        {
            key: "isAutoTrackingDisabled",
            value: function isAutoTrackingDisabled(element) {
                return element.classList.contains('doNotAutoTrack');
            }
        },
        {
            key: "readWriteSessionCookie",
            value: function readWriteSessionCookie() {
                var cookie = $767eab9fde59e2ab$exports.Cookie.readCookie('atl_session');
                var name = 'atl_session';
                var value = cookie || $d568c1b4cd0cc27f$exports.Guid.guid();
                var seconds = 1800;
                if ($767eab9fde59e2ab$exports.Cookie.writeCookieInSeconds) $767eab9fde59e2ab$exports.Cookie.writeCookieInSeconds(name, value, seconds);
                return value;
            }
        }
    ]);
}();


function $35247c7511184ad3$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $35247c7511184ad3$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $35247c7511184ad3$var$_typeof(o);
}
function $35247c7511184ad3$var$_classCallCheck(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function $35247c7511184ad3$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, $35247c7511184ad3$var$_toPropertyKey(o.key), o);
    }
}
function $35247c7511184ad3$var$_createClass(e, r, t) {
    return r && $35247c7511184ad3$var$_defineProperties(e.prototype, r), t && $35247c7511184ad3$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}
function $35247c7511184ad3$var$_toPropertyKey(t) {
    var i = $35247c7511184ad3$var$_toPrimitive(t, "string");
    return "symbol" == $35247c7511184ad3$var$_typeof(i) ? i : i + "";
}
function $35247c7511184ad3$var$_toPrimitive(t, r) {
    if ("object" != $35247c7511184ad3$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $35247c7511184ad3$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $35247c7511184ad3$var$TRELLO_USER_ID = 'token';
var $35247c7511184ad3$var$XID = 'seg_xid';
var $35247c7511184ad3$var$pageViewProperties = {};
// cookie used by Marketo to track interactions, allows a website to link visitor behavior across sites and campaigns
var $35247c7511184ad3$var$MARKETO_ID = '_mkto_trk';
var $35247c7511184ad3$var$REFERRER_TRELLO_DOMAINS = [
    'trello.com',
    'trellis.coffee'
];
var $35247c7511184ad3$var$Identity = $35247c7511184ad3$exports.Identity = /*#__PURE__*/ function() {
    function Identity() {
        $35247c7511184ad3$var$_classCallCheck(this, Identity);
    }
    return $35247c7511184ad3$var$_createClass(Identity, null, [
        {
            key: "identify",
            value: /**
     * Sends a track event with known identifiers
     * @function identify
     * @param {string} userId - required
     * @param {object} traits - optional, dictionary of custom traits to send
     */ function identify(userId, traits) {
                traits = !!traits && $35247c7511184ad3$var$_typeof(traits) === 'object' ? traits : {};
                var data = traits;
                data['atlassian_id'] = userId;
                data['atlJSVersion'] = $adbd9ab2eaa40909$exports.AnalyticsState.version || '1.0.0';
                try {
                    data['ga_clientid'] = $767eab9fde59e2ab$exports.Cookie.readCookie('_ga');
                } catch (e) {
                    $4fb91a309ed42af5$exports.Helpers.sendWrapperLoadError('Error reading _ga cookie');
                }
                $3f4554f5dd6755f8$exports.Tracking.trackEvent('known_identifiers', data);
            }
        },
        {
            key: "autoIdentify",
            value: function autoIdentify() {
                var emailDetected = $4fb91a309ed42af5$exports.Helpers.emailAddressIsDetected();
                var userId = Identity.getAtlassianUserId();
                var xid = $767eab9fde59e2ab$exports.Cookie.readCookie($35247c7511184ad3$var$XID);
                if (emailDetected) {
                    var integrations = {
                        All: false,
                        'Google Analytics': true
                    };
                    if (!$adbd9ab2eaa40909$exports.AnalyticsState.pageViewOptions) $adbd9ab2eaa40909$exports.AnalyticsState.pageViewOptions = {
                        integrations: integrations
                    };
                    else $adbd9ab2eaa40909$exports.AnalyticsState.pageViewOptions['integrations'] = integrations;
                    if ($4fb91a309ed42af5$exports.Helpers.urlContainsEmail(window.location.href)) $4fb91a309ed42af5$exports.Helpers.addCleanedUrlAndPaths($35247c7511184ad3$var$pageViewProperties);
                    if ($4fb91a309ed42af5$exports.Helpers.urlContainsEmail(document.referrer)) $4fb91a309ed42af5$exports.Helpers.addCleanedReferrer($35247c7511184ad3$var$pageViewProperties);
                }
                try {
                    $35247c7511184ad3$var$pageViewProperties['anonymous_id'] = $adbd9ab2eaa40909$exports.AnalyticsState.anonymousId;
                } catch (e) {
                    $4fb91a309ed42af5$exports.Helpers.sendWrapperLoadError('Error reading segment anonymousId');
                }
                try {
                    $35247c7511184ad3$var$pageViewProperties[$062e0101ba16ec7d$exports.ATL_COHORT] = $062e0101ba16ec7d$exports.Cohort.readWriteAtlCohort();
                } catch (e) {
                    $4fb91a309ed42af5$exports.Helpers.sendWrapperLoadError('Error read / writing atlCohort cookie');
                }
                if (userId || xid) Identity.identify(userId, $35247c7511184ad3$var$pageViewProperties);
            }
        },
        {
            key: "getAtlassianUserId",
            value: function getAtlassianUserId() {
                var userId = $767eab9fde59e2ab$exports.Cookie.readCookie('__aid_user_id');
                if (userId) return decodeURIComponent(userId);
                return null;
            }
        },
        {
            key: "getTrelloUserId",
            value: function getTrelloUserId() {
                try {
                    var page = location.href ? new URL(location.href) : null;
                    // since the trello cookie is such a common name. check to make sure we're actually on a trello page
                    if (page && (page.hostname.includes('trello.com') || page.hostname.includes('trellis.coffee'))) {
                        var token = $767eab9fde59e2ab$exports.Cookie.readCookie($35247c7511184ad3$var$TRELLO_USER_ID);
                        if (token) return decodeURIComponent(token).split('/')[0];
                    }
                } catch (e) {
                    $4fb91a309ed42af5$exports.Helpers.sendWrapperLoadError('Error reading Trello userId');
                }
                return null;
            }
        },
        {
            key: "getMarketoId",
            value: function getMarketoId() {
                var marketoId = $767eab9fde59e2ab$exports.Cookie.readCookie($35247c7511184ad3$var$MARKETO_ID);
                if (marketoId) return decodeURIComponent(marketoId);
                return null;
            }
        },
        {
            key: "getMarketoIdPromise",
            value: function getMarketoIdPromise() {
                var enableRetry = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
                var waitCount = 0;
                var maxWait = enableRetry ? 5000 : 0;
                return new Promise(function(resolve) {
                    Identity._internalMarketoPromise(waitCount, maxWait, resolve);
                });
            }
        },
        {
            key: "_internalMarketoPromise",
            value: function _internalMarketoPromise(waitCount, maxWait, resolve) {
                var delay = 500;
                var marketoId = $767eab9fde59e2ab$exports.Cookie.readCookie($35247c7511184ad3$var$MARKETO_ID);
                // wait for up to 5 seconds for the marketo cookie to show up
                if (marketoId) resolve(decodeURIComponent(marketoId));
                else {
                    waitCount += delay;
                    if (waitCount >= maxWait) {
                        $4fb91a309ed42af5$exports.Helpers.sendWrapperLoadError('getMarketoIdPromise error');
                        resolve('');
                    } else if (typeof setTimeout === 'function') setTimeout(function() {
                        Identity._internalMarketoPromise(waitCount, maxWait, resolve);
                    }, delay);
                    else {
                        // handle the case where setTimeout is not a function
                        $4fb91a309ed42af5$exports.Helpers.sendWrapperLoadError('getMarketoIdPromise error - setTimeout is not a function');
                        resolve('');
                    }
                }
            }
        },
        {
            key: "isReferrerTrello",
            value: function isReferrerTrello() {
                if (!document.referrer) return false;
                var ref = new URL(document.referrer);
                return $35247c7511184ad3$var$REFERRER_TRELLO_DOMAINS.includes(ref.hostname);
            }
        }
    ]);
}();


var $77649b04a9131230$exports = {};
"use strict";
Object.defineProperty($77649b04a9131230$exports, "__esModule", {
    value: true
});
Object.defineProperty($77649b04a9131230$exports, "AnalyticsWebClient", {
    enumerable: true,
    get: function get() {
        return $77649b04a9131230$var$_analyticsWebClient["default"];
    }
});
$77649b04a9131230$exports.CommunityAnalyticsClient = void 0;

var $77649b04a9131230$var$_analyticsWebClient = $77649b04a9131230$var$_interopRequireWildcard((parcelRequire("1q4dW")));


var $a16418a003617505$exports = {};
"use strict";
Object.defineProperty($a16418a003617505$exports, "__esModule", {
    value: true
});
$a16418a003617505$exports.Initializer = void 0;




var $648460a2ac9885d9$exports = {};
"use strict";
Object.defineProperty($648460a2ac9885d9$exports, "__esModule", {
    value: true
});
$648460a2ac9885d9$exports.Metrics = $648460a2ac9885d9$exports.MetricKey = void 0;




function $648460a2ac9885d9$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $648460a2ac9885d9$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $648460a2ac9885d9$var$_typeof(o);
}
function $648460a2ac9885d9$var$_slicedToArray(r, e) {
    return $648460a2ac9885d9$var$_arrayWithHoles(r) || $648460a2ac9885d9$var$_iterableToArrayLimit(r, e) || $648460a2ac9885d9$var$_unsupportedIterableToArray(r, e) || $648460a2ac9885d9$var$_nonIterableRest();
}
function $648460a2ac9885d9$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $648460a2ac9885d9$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $648460a2ac9885d9$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $648460a2ac9885d9$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $648460a2ac9885d9$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $648460a2ac9885d9$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $648460a2ac9885d9$var$_arrayWithHoles(r) {
    if (Array.isArray(r)) return r;
}
function $648460a2ac9885d9$var$_classCallCheck(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function $648460a2ac9885d9$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, $648460a2ac9885d9$var$_toPropertyKey(o.key), o);
    }
}
function $648460a2ac9885d9$var$_createClass(e, r, t) {
    return r && $648460a2ac9885d9$var$_defineProperties(e.prototype, r), t && $648460a2ac9885d9$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}
function $648460a2ac9885d9$var$_defineProperty(e, r, t) {
    return (r = $648460a2ac9885d9$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $648460a2ac9885d9$var$_toPropertyKey(t) {
    var i = $648460a2ac9885d9$var$_toPrimitive(t, "string");
    return "symbol" == $648460a2ac9885d9$var$_typeof(i) ? i : i + "";
}
function $648460a2ac9885d9$var$_toPrimitive(t, r) {
    if ("object" != $648460a2ac9885d9$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $648460a2ac9885d9$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
} /**
 * Module for segment metrics tracking events.
 * @module Metrics
 */ 
var $648460a2ac9885d9$var$MetricKey = $648460a2ac9885d9$exports.MetricKey = /*#__PURE__*/ function(MetricKey) {
    MetricKey["TIME_TO_LOAD"] = "timeToLoad";
    MetricKey["TIME_TO_SEGMENT_LOAD"] = "timeToSegmentLoad";
    MetricKey["TIME_TO_AVAILABLE"] = "timeToAvailable";
    MetricKey["TIME_TO_READY"] = "timeToReady";
    MetricKey["TIME_TO_START_LOAD_XID"] = "timeToStartLoadXID";
    MetricKey["TIME_TO_START_GET_XID"] = "timeToStartGetXID";
    MetricKey["TIME_TO_LOAD_XID"] = "timeToLoadXID";
    return MetricKey;
}({});
var $648460a2ac9885d9$var$Metrics = $648460a2ac9885d9$exports.Metrics = /*#__PURE__*/ function() {
    function Metrics() {
        $648460a2ac9885d9$var$_classCallCheck(this, Metrics);
    }
    return $648460a2ac9885d9$var$_createClass(Metrics, null, [
        {
            key: "logMetric",
            value: /**
     * Store the value of a single performance metric
     * @function logMetrics
     * @param {MetricKey} metricKey - the metric to log
     * @param {number} mockDate - a mock timestamp
     */ function logMetric(metricKey, mockDate) {
                Metrics.metricsData[metricKey] = mockDate || Date.now();
            }
        },
        {
            key: "setLoadTimestamp",
            value: function setLoadTimestamp(loadTimestamp) {
                Metrics.loadTimestamp = loadTimestamp;
            }
        },
        {
            key: "sendMetrics",
            value: function sendMetrics(mockReq) {
                var loadTimestamp = Metrics.loadTimestamp;
                if (!loadTimestamp) return;
                // calculate all of the times
                Object.entries(Metrics.metricsData).forEach(function(_ref) {
                    var _ref2 = $648460a2ac9885d9$var$_slicedToArray(_ref, 2), key = _ref2[0], value = _ref2[1];
                    if (value > 0) // Todo .. should this be > loadTimestamp ??
                    Metrics.metricsData[key] = value - loadTimestamp;
                });
                var cohort = $062e0101ba16ec7d$exports.Cohort.readAtlCohort();
                var properties = {
                    action: 'metrics',
                    actionSubject: 'atlGlobal',
                    metrics: Metrics.metricsData,
                    atlJSVersion: $adbd9ab2eaa40909$exports.AnalyticsState.version,
                    cohort: cohort ? cohort.bucketAll.index : null,
                    host: mockReq ? mockReq.hostFake : window.location.host,
                    path: mockReq ? mockReq.pathFake : window.location.pathname,
                    pageViewId: $3f4554f5dd6755f8$exports.Tracking.getPageViewId() // used to tie to other events
                };
                $077fd9c14d82a85a$exports.GASv3.sendUIEvent('', properties, true);
                Metrics.resetMetrics();
            }
        },
        {
            key: "resetMetrics",
            value: function resetMetrics() {
                Metrics.metricsData = {};
            }
        }
    ]);
}();
$648460a2ac9885d9$var$_defineProperty($648460a2ac9885d9$var$Metrics, "metricsData", {});



function $a16418a003617505$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $a16418a003617505$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $a16418a003617505$var$_typeof(o);
}
function $a16418a003617505$var$_classCallCheck(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function $a16418a003617505$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, $a16418a003617505$var$_toPropertyKey(o.key), o);
    }
}
function $a16418a003617505$var$_createClass(e, r, t) {
    return r && $a16418a003617505$var$_defineProperties(e.prototype, r), t && $a16418a003617505$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}
function $a16418a003617505$var$_toPropertyKey(t) {
    var i = $a16418a003617505$var$_toPrimitive(t, "string");
    return "symbol" == $a16418a003617505$var$_typeof(i) ? i : i + "";
}
function $a16418a003617505$var$_toPrimitive(t, r) {
    if ("object" != $a16418a003617505$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $a16418a003617505$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
/**
 * Module for initializing the wrapper.
 * @module Initializer
 */ var $a16418a003617505$var$Initializer = $a16418a003617505$exports.Initializer = /*#__PURE__*/ function() {
    function Initializer() {
        $a16418a003617505$var$_classCallCheck(this, Initializer);
    }
    return $a16418a003617505$var$_createClass(Initializer, null, [
        {
            key: "initWithPageAnalytics",
            value: /**
     * Initializes auto-tracking and page view tracking.
     * @function initWithPageAnalytics
     * @param {string} writeKey - required, historically used as Segment.io key, now just sent as a property (not sure if used, but keep sending it)
     * @param {object} pageViewProperties - optional, dictionary of properties of the page
     * @param {number} loadTimestamp - optional, the timestamp at which the initializing site loaded this script
     * @param {string} anonymousId - GASv3 analytics client anonymous id
     * @param {function} createAnalyticsEvent - analytics-next CreateUIAnalyticsEvent
     */ function initWithPageAnalytics(writeKey) {
                var pageViewProperties = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var loadTimestamp = arguments.length > 2 ? arguments[2] : undefined;
                var anonymousId = arguments.length > 3 ? arguments[3] : undefined;
                var createAnalyticsEvent = arguments.length > 4 ? arguments[4] : undefined;
                $adbd9ab2eaa40909$exports.AnalyticsState.anonymousId = anonymousId;
                $adbd9ab2eaa40909$exports.AnalyticsState.createAnalyticsEvent = createAnalyticsEvent;
                // set load timestamp for calculating metrics
                $648460a2ac9885d9$exports.Metrics.setLoadTimestamp(loadTimestamp);
                // TODO: Switch these params to dynamically config based on writeKey
                $6428f42409a4abae$exports.Gtm.initialize(writeKey);
                Initializer.captureUTMs();
                // adding marketing boolean if current product comes under marketing domain
                Initializer.setIsMarketingEvent(pageViewProperties);
                // store params for later reporting if necessary.
                $adbd9ab2eaa40909$exports.AnalyticsState.writeKey = writeKey;
                // auto-fire page view
                $4fb91a309ed42af5$exports.Helpers.addActualUrl(pageViewProperties);
                $3f4554f5dd6755f8$exports.Tracking.pageView(pageViewProperties);
                // add auto tracking and configure google analytics integration
                Initializer.autoTrack();
                Initializer.gaIntegration();
                Initializer.globalCallReady();
            }
        },
        {
            key: "globalCallReady",
            value: function globalCallReady() {
                if (typeof window.analyticsPageReady === 'function') window.analyticsPageReady();
                $648460a2ac9885d9$exports.Metrics.logMetric($648460a2ac9885d9$exports.MetricKey.TIME_TO_READY);
                $648460a2ac9885d9$exports.Metrics.sendMetrics();
            }
        },
        {
            key: "captureUTMs",
            value: function captureUTMs() {
                var utmKeys = {
                    utm_campaign: '',
                    utm_medium: '',
                    utm_source: '',
                    utm_content: '',
                    utm_term: ''
                };
                $adbd9ab2eaa40909$exports.AnalyticsState.utms = $4fb91a309ed42af5$exports.Helpers.getUtms(utmKeys);
            }
        },
        {
            key: "autoTrack",
            value: function autoTrack() {
                $3f4554f5dd6755f8$exports.Tracking.autoTrackButtons(true);
                $3f4554f5dd6755f8$exports.Tracking.autoTrackLinks(true);
                $3f4554f5dd6755f8$exports.Tracking.autoTrackVideos();
                $3f4554f5dd6755f8$exports.Tracking.autoTrackSelects();
                $3f4554f5dd6755f8$exports.Tracking.autoTrackTabs();
            }
        },
        {
            key: "gaIntegration",
            value: function gaIntegration() {
                var emailDetected = $4fb91a309ed42af5$exports.Helpers.emailAddressIsDetected();
                var pathOverride = '/path-contained-email-address';
                if (typeof window.ga !== 'undefined') {
                    window.ga('require', 'linker');
                    window.ga('linker:autoLink', [
                        'atlassian.com',
                        'bitbucket.org',
                        'hipchat.com',
                        'attendease.com',
                        'get.atlassian.com',
                        'eegeventsite.secure.force.com',
                        'atlassian.swoogo.com'
                    ]);
                    if (emailDetected) {
                        // only override what is needed
                        if ($4fb91a309ed42af5$exports.Helpers.urlContainsEmail(window.location.href)) {
                            window.ga('set', 'location', window.location.origin + pathOverride);
                            window.ga('set', 'path', pathOverride);
                        }
                        if ($4fb91a309ed42af5$exports.Helpers.urlContainsEmail(document.referrer)) window.ga('set', 'referrer', $4fb91a309ed42af5$exports.Helpers.hostnameFromUrl(document.referrer) + pathOverride);
                    }
                }
            }
        },
        {
            key: "setIsMarketingEvent",
            value: function setIsMarketingEvent(pageViewProperties) {
                if (typeof pageViewProperties['isMarketingEvent'] !== 'boolean') $077fd9c14d82a85a$exports.GASv3.isMarketingEvent = true;
                else $077fd9c14d82a85a$exports.GASv3.isMarketingEvent = pageViewProperties['isMarketingEvent'];
            }
        },
        {
            key: "setXID",
            value: function setXID(xid) {
                $3f4554f5dd6755f8$exports.Tracking.xid = xid;
            }
        }
    ]);
}();






function $77649b04a9131230$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($77649b04a9131230$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $77649b04a9131230$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != $77649b04a9131230$var$_typeof(e) && "function" != typeof e) return {
        "default": e
    };
    var t = $77649b04a9131230$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $77649b04a9131230$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $77649b04a9131230$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $77649b04a9131230$var$_typeof(o);
}
function $77649b04a9131230$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $77649b04a9131230$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $77649b04a9131230$var$ownKeys(Object(t), !0).forEach(function(r) {
            $77649b04a9131230$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $77649b04a9131230$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $77649b04a9131230$var$_classCallCheck(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function $77649b04a9131230$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, $77649b04a9131230$var$_toPropertyKey(o.key), o);
    }
}
function $77649b04a9131230$var$_createClass(e, r, t) {
    return r && $77649b04a9131230$var$_defineProperties(e.prototype, r), t && $77649b04a9131230$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}
function $77649b04a9131230$var$_defineProperty(e, r, t) {
    return (r = $77649b04a9131230$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $77649b04a9131230$var$_toPropertyKey(t) {
    var i = $77649b04a9131230$var$_toPrimitive(t, "string");
    return "symbol" == $77649b04a9131230$var$_typeof(i) ? i : i + "";
}
function $77649b04a9131230$var$_toPrimitive(t, r) {
    if ("object" != $77649b04a9131230$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $77649b04a9131230$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
} /**
 * Service to interact with analytics client, send GASv3 events
 */ 
var $77649b04a9131230$var$CommunityAnalyticsClient = $77649b04a9131230$exports.CommunityAnalyticsClient = /*#__PURE__*/ function() {
    function CommunityAnalyticsClient() {
        $77649b04a9131230$var$_classCallCheck(this, CommunityAnalyticsClient);
    }
    return $77649b04a9131230$var$_createClass(CommunityAnalyticsClient, null, [
        {
            key: "init",
            value: function init() {
                var _this = this;
                if (typeof window !== 'undefined') {
                    var settings = $77649b04a9131230$var$_objectSpread({
                        useStargate: (0, $9b8dc532c3c3f9ae$exports.shouldUseStargate)(this.clientEnvironment),
                        xidConsent: true,
                        xidPromiseFn: function xidPromiseFn() {
                            return new $a576733921801e90$exports.XID((0, $9b8dc532c3c3f9ae$exports.getXidEnvironment)(_this.clientEnvironment)).getXidCallbackForPromise();
                        }
                    }, this.clientSettings);
                    return new $77649b04a9131230$var$_analyticsWebClient["default"]({
                        env: (0, $9b8dc532c3c3f9ae$exports.getGASv3Environment)(this.clientEnvironment),
                        product: this.PRODUCT,
                        version: '1.0.0',
                        locale: 'en-us'
                    }, settings);
                }
                throw new Error('window is not defined');
            }
        },
        {
            key: "initializeClient",
            value: function initializeClient(communitySubApp, settings, environment) {
                var userId = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
                var writeKey = (0, $9b8dc532c3c3f9ae$exports.getAnalyticsWriteKey)(this.clientEnvironment);
                this.writeKey = writeKey;
                this.clientSettings = settings;
                this.clientEnvironment = environment;
                this.analyticsClient = this.init();
                // set static analytics client instance on GASv3 class
                $077fd9c14d82a85a$exports.GASv3.client = this.analyticsClient;
                // TODO: change this (currently sets AAID from identity cookie on client)
                var clientUserId = userId || $35247c7511184ad3$exports.Identity.getAtlassianUserId();
                if (clientUserId) this.setAnalyticsUserInfo(clientUserId);
                // set global community attributes to be sent on each event
                $077fd9c14d82a85a$exports.GASv3.additionalEventData = this.getGlobalAttributes(communitySubApp);
                return this.analyticsClient;
            }
        },
        {
            key: "initWithPageAnalytics",
            value: function initWithPageAnalytics(communitySubApp, settings, environment) {
                var pageViewProperties = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var userId = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
                if (!this.analyticsClient) this.analyticsClient = this.initializeClient(communitySubApp, settings, environment, userId);
                this.setUpPageAnalytics(pageViewProperties);
                return this.analyticsClient;
            }
        },
        {
            key: "setUpPageAnalytics",
            value: function setUpPageAnalytics() {
                var pageViewProperties = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                if (!this.analyticsClient) throw new Error('Initialize the analytics client before calling setUpPageAnalytics()');
                // set up auto-tracking for page views and other activity
                $a16418a003617505$exports.Initializer.initWithPageAnalytics((0, $9b8dc532c3c3f9ae$exports.getAnalyticsWriteKey)(this.clientEnvironment), $77649b04a9131230$var$deepClone(pageViewProperties), Date.now(), this.analyticsClient.getAnonymousId(), null // createAnalyticsEvent only needed for analytics-next
                );
            }
        },
        {
            key: "hasAnalyticsClient",
            value: function hasAnalyticsClient() {
                return !!this.analyticsClient;
            }
        },
        {
            key: "getAnalyticsClient",
            value: function getAnalyticsClient() {
                return this.analyticsClient;
            }
        },
        {
            key: "setAnalyticsUserInfo",
            value: function setAnalyticsUserInfo(userId) {
                if (userId && this.hasAnalyticsClient()) this.getAnalyticsClient().setUserInfo($77649b04a9131230$var$_analyticsWebClient.userType.ATLASSIAN_ACCOUNT, userId);
            }
        },
        {
            key: "sendEvent",
            value: function sendEvent() {
                var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : $55a1880d3758202a$exports.eventType.UI;
                var payload = arguments.length > 1 ? arguments[1] : undefined;
                if (this.isAnalyticsEnabled()) $3f4554f5dd6755f8$exports.Tracking.trackEvent('', payload, type);
            }
        },
        {
            key: "getGlobalAttributes",
            value: function getGlobalAttributes(subApp) {
                return {
                    app: this.APP,
                    subApp: subApp
                };
            }
        }
    ]);
}();
/** Payload for eventType.UI and TRACK events
 * @property {string} action - action being performed
 * @property {string} actionSubject - subject of the action
 * @property {string} [actionSubjectId] - (optional) action subject id
 * @property {Record<string, string>} [attributes] - (optional) additional attributes
 * @property {string} [source] - source of the event, where (e.g. a screen) in the product
 */ $77649b04a9131230$var$_defineProperty($77649b04a9131230$var$CommunityAnalyticsClient, "PRODUCT", 'marketing');
$77649b04a9131230$var$_defineProperty($77649b04a9131230$var$CommunityAnalyticsClient, "APP", 'community');
$77649b04a9131230$var$_defineProperty($77649b04a9131230$var$CommunityAnalyticsClient, "SUB_APP", {
    HOME: 'home',
    FORUMS: 'forums',
    LEARNING: 'learning',
    EVENTS: 'events',
    UNIFIED_PORTABLE_PROFILE: 'unified-portable-profile'
});
$77649b04a9131230$var$_defineProperty($77649b04a9131230$var$CommunityAnalyticsClient, "writeKey", null);
$77649b04a9131230$var$_defineProperty($77649b04a9131230$var$CommunityAnalyticsClient, "analyticsClient", null);
$77649b04a9131230$var$_defineProperty($77649b04a9131230$var$CommunityAnalyticsClient, "clientSettings", null);
$77649b04a9131230$var$_defineProperty($77649b04a9131230$var$CommunityAnalyticsClient, "clientEnvironment", null);
/**
 * Analytics is always enabled regardless of cookie consent status.
 * As part of the GDPR/ERM compliance change (Option 7 - Strictly Necessary ID), the analytics
 * wrapper must be loaded unconditionally for all users. Operational events are fired with a
 * strictly necessary ID by atl-analytics, ensuring GDPR compliance without requiring
 * performance cookie consent to load the wrapper.
 */ $77649b04a9131230$var$_defineProperty($77649b04a9131230$var$CommunityAnalyticsClient, "isAnalyticsEnabled", function() {
    return true;
});
/**
 * Payload for eventType.SCREEN events
 * @property {string} name - name of the screen being viewed
 * @property {Record<string, string>} [attributes] - additional attributes
 */ // type constrained to community sub-app string values (as defined by CommunityAnalyticsClient.SUB_APP)
var $77649b04a9131230$var$deepClone = function deepClone(obj) {
    return JSON.parse(JSON.stringify(obj));
};


function $611eba94e0709501$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($611eba94e0709501$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $611eba94e0709501$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != $611eba94e0709501$var$_typeof(e) && "function" != typeof e) return {
        "default": e
    };
    var t = $611eba94e0709501$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $611eba94e0709501$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $611eba94e0709501$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $611eba94e0709501$var$_typeof(o);
}
function $611eba94e0709501$var$_slicedToArray(r, e) {
    return $611eba94e0709501$var$_arrayWithHoles(r) || $611eba94e0709501$var$_iterableToArrayLimit(r, e) || $611eba94e0709501$var$_unsupportedIterableToArray(r, e) || $611eba94e0709501$var$_nonIterableRest();
}
function $611eba94e0709501$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $611eba94e0709501$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $611eba94e0709501$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $611eba94e0709501$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $611eba94e0709501$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $611eba94e0709501$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $611eba94e0709501$var$_arrayWithHoles(r) {
    if (Array.isArray(r)) return r;
}
function $611eba94e0709501$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $611eba94e0709501$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $611eba94e0709501$var$ownKeys(Object(t), !0).forEach(function(r) {
            $611eba94e0709501$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $611eba94e0709501$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $611eba94e0709501$var$_defineProperty(e, r, t) {
    return (r = $611eba94e0709501$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $611eba94e0709501$var$_toPropertyKey(t) {
    var i = $611eba94e0709501$var$_toPrimitive(t, "string");
    return "symbol" == $611eba94e0709501$var$_typeof(i) ? i : i + "";
}
function $611eba94e0709501$var$_toPrimitive(t, r) {
    if ("object" != $611eba94e0709501$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $611eba94e0709501$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
} /**
 * WARNING: Not yet ready for use, do not use - use the CommunityAnalyticsClient in analytics-client instead.
 *
 * This file contains the context and provider for the analytics client (@atlaskit/analytics-next pattern) - these React
 * components can be wrapped around the app to provide the analytics client to the rest of the application.
 *
 * Note: As part of the GDPR/ERM compliance change (Option 7 - Strictly Necessary ID), the analytics
 * client is initialized unconditionally for all users, regardless of cookie consent status.
 * Operational events are fired with a strictly necessary ID by atl-analytics.
 */ 
var $611eba94e0709501$var$AnalyticsWebClientContext = $611eba94e0709501$exports.AnalyticsWebClientContext = /*#__PURE__*/ (0, $611eba94e0709501$var$_react.createContext)({
    analyticsWebClientInstance: null
});
/**
 * This listener component listens for analytics events and sends them to the analytics client (analytics-next pattern).
 */ var $611eba94e0709501$var$CommunityAnalyticsListener = $611eba94e0709501$exports.CommunityAnalyticsListener = function CommunityAnalyticsListener(_ref) {
    var children = _ref.children;
    var analyticsClient = $611eba94e0709501$var$useAnalyticsClient();
    var onEvent = (0, $611eba94e0709501$var$_react.useCallback)(function(event) {
        if (!analyticsClient) return;
        // TODO: modify this?
        var processedEventPayload = $611eba94e0709501$var$_objectSpread($611eba94e0709501$var$_objectSpread({
            actionSubject: 'component',
            eventType: 'ui',
            source: 'default'
        }, event.payload), {}, {
            attributes: $611eba94e0709501$var$_objectSpread({}, event.payload['attributes'] || {})
        });
        var ANALYTICS_TYPE = 'console';
        if (ANALYTICS_TYPE === 'console') {
            // eslint-disable-next-line
            console.log({
                event: processedEventPayload
            });
            analyticsClient.onEvent(null, processedEventPayload);
        } else analyticsClient.onEvent(null, processedEventPayload);
    }, [
        analyticsClient
    ]);
    return /*#__PURE__*/ $611eba94e0709501$var$_react["default"].createElement($01b5b1a5740294b4$export$2e2bcd8739ae039, {
        channel: '*',
        onEvent: onEvent
    }, children);
};
/**
 * This provider component initializes the analytics client and provides it to the rest of the application (analytics-next
 * pattern).
 * @param settings
 * @param environment
 * @param children
 * @constructor
 */ var $611eba94e0709501$var$CommunityAnalyticsClientProvider = $611eba94e0709501$exports.CommunityAnalyticsClientProvider = function CommunityAnalyticsClientProvider(_ref2) {
    var settings = _ref2.settings, environment = _ref2.environment, children = _ref2.children;
    var _useState = (0, $611eba94e0709501$var$_react.useState)(null), _useState2 = $611eba94e0709501$var$_slicedToArray(_useState, 2), analyticsWebClientInstance = _useState2[0], setAnalyticsWebClientInstance = _useState2[1];
    (0, $611eba94e0709501$var$_react.useEffect)(function() {
        if (typeof window !== 'undefined') {
            // Initialize the analytics client unconditionally, regardless of cookie consent status.
            // As part of the GDPR/ERM compliance change (Option 7 - Strictly Necessary ID), the wrapper
            // must always be loaded so operational events with strictly necessary IDs are not lost.
            $77649b04a9131230$exports.CommunityAnalyticsClient.clientSettings = settings;
            $77649b04a9131230$exports.CommunityAnalyticsClient.clientEnvironment = environment;
            var client = $77649b04a9131230$exports.CommunityAnalyticsClient.init();
            var aaid = $35247c7511184ad3$exports.Identity.getAtlassianUserId();
            if (aaid) client.setUserInfo($iVpQc.userType.ATLASSIAN_ACCOUNT, aaid);
            setAnalyticsWebClientInstance(client);
        }
    }, []);
    return /*#__PURE__*/ $611eba94e0709501$var$_react["default"].createElement($611eba94e0709501$var$AnalyticsWebClientContext.Provider, {
        value: {
            analyticsWebClientInstance: analyticsWebClientInstance
        }
    }, children);
};
var $611eba94e0709501$var$useAnalyticsClient = $611eba94e0709501$exports.useAnalyticsClient = function useAnalyticsClient() {
    var context = (0, $611eba94e0709501$var$_react.useContext)($611eba94e0709501$var$AnalyticsWebClientContext);
    if (!context) throw new Error('calls to useAnalyticsClient must be wrapped in <WacAnalyticsClientProvider>!');
    return context.analyticsWebClientInstance;
};



var $edca2caa766c402a$var$deepClone = function deepClone(obj) {
    return JSON.parse(JSON.stringify(obj));
};
var $edca2caa766c402a$var$InitializeAutoAtlAnalyticsImpl = function InitializeAutoAtlAnalyticsImpl(_ref) {
    var _ref$pageViewProperti = _ref.pageViewProperties, pageViewProperties = _ref$pageViewProperti === void 0 ? {} : _ref$pageViewProperti, createAnalyticsEvent = _ref.createAnalyticsEvent;
    var analyticsClient = (0, $611eba94e0709501$exports.useAnalyticsClient)();
    var ANALYTICS_WRITE_KEY = '';
    (0, $5FkrB.useEffect)(function() {
        if (!analyticsClient) return;
        $a16418a003617505$exports.Initializer.initWithPageAnalytics(ANALYTICS_WRITE_KEY, $edca2caa766c402a$var$deepClone(pageViewProperties), Date.now(), analyticsClient.getAnonymousId(), createAnalyticsEvent || null);
    }, [
        analyticsClient,
        ANALYTICS_WRITE_KEY,
        createAnalyticsEvent,
        pageViewProperties
    ]);
    return null;
};
var $edca2caa766c402a$var$InitializeAutoAtlAnalytics = $edca2caa766c402a$exports.InitializeAutoAtlAnalytics = (0, $d5f32e7562891e94$export$2e2bcd8739ae039)()($edca2caa766c402a$var$InitializeAutoAtlAnalyticsImpl);




Object.keys($eeec4b79607b6553$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $b39c9956eebb23a1$exports && $b39c9956eebb23a1$exports[key] === $eeec4b79607b6553$exports[key]) return;
    Object.defineProperty($b39c9956eebb23a1$exports, key, {
        enumerable: true,
        get: function get() {
            return $eeec4b79607b6553$exports[key];
        }
    });
});
var $c9a10b8dc262d1c2$exports = {};
"use strict";
Object.defineProperty($c9a10b8dc262d1c2$exports, "__esModule", {
    value: true
});

Object.keys($611eba94e0709501$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $c9a10b8dc262d1c2$exports && $c9a10b8dc262d1c2$exports[key] === $611eba94e0709501$exports[key]) return;
    Object.defineProperty($c9a10b8dc262d1c2$exports, key, {
        enumerable: true,
        get: function get() {
            return $611eba94e0709501$exports[key];
        }
    });
});

Object.keys($77649b04a9131230$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $c9a10b8dc262d1c2$exports && $c9a10b8dc262d1c2$exports[key] === $77649b04a9131230$exports[key]) return;
    Object.defineProperty($c9a10b8dc262d1c2$exports, key, {
        enumerable: true,
        get: function get() {
            return $77649b04a9131230$exports[key];
        }
    });
});

Object.keys($55a1880d3758202a$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $c9a10b8dc262d1c2$exports && $c9a10b8dc262d1c2$exports[key] === $55a1880d3758202a$exports[key]) return;
    Object.defineProperty($c9a10b8dc262d1c2$exports, key, {
        enumerable: true,
        get: function get() {
            return $55a1880d3758202a$exports[key];
        }
    });
});


Object.keys($c9a10b8dc262d1c2$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $b39c9956eebb23a1$exports && $b39c9956eebb23a1$exports[key] === $c9a10b8dc262d1c2$exports[key]) return;
    Object.defineProperty($b39c9956eebb23a1$exports, key, {
        enumerable: true,
        get: function get() {
            return $c9a10b8dc262d1c2$exports[key];
        }
    });
});


Object.keys($b39c9956eebb23a1$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $bd858cf878484440$exports && $bd858cf878484440$exports[key] === $b39c9956eebb23a1$exports[key]) return;
    Object.defineProperty($bd858cf878484440$exports, key, {
        enumerable: true,
        get: function get() {
            return $b39c9956eebb23a1$exports[key];
        }
    });
});
var $209e8d31241d8aca$exports = {};
"use strict";
function $209e8d31241d8aca$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $209e8d31241d8aca$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $209e8d31241d8aca$var$_typeof(o);
}
Object.defineProperty($209e8d31241d8aca$exports, "__esModule", {
    value: true
});
$209e8d31241d8aca$exports.isUserInAllowList = $209e8d31241d8aca$exports.isUserAllowedForEaExperience = $209e8d31241d8aca$exports.getUserInfo = void 0;


function $209e8d31241d8aca$var$_regeneratorRuntime() {
    "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ 
    $209e8d31241d8aca$var$_regeneratorRuntime = function _regeneratorRuntime() {
        return e;
    };
    var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function(t, e, r) {
        t[e] = r.value;
    }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag";
    function define(t, e, r) {
        return Object.defineProperty(t, e, {
            value: r,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }), t[e];
    }
    try {
        define({}, "");
    } catch (t) {
        define = function define(t, e, r) {
            return t[e] = r;
        };
    }
    function wrap(t, e, r, n) {
        var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []);
        return o(a, "_invoke", {
            value: makeInvokeMethod(t, r, c)
        }), a;
    }
    function tryCatch(t, e, r) {
        try {
            return {
                type: "normal",
                arg: t.call(e, r)
            };
        } catch (t) {
            return {
                type: "throw",
                arg: t
            };
        }
    }
    e.wrap = wrap;
    var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {};
    function Generator() {}
    function GeneratorFunction() {}
    function GeneratorFunctionPrototype() {}
    var p = {};
    define(p, a, function() {
        return this;
    });
    var d = Object.getPrototypeOf, v = d && d(d(values([])));
    v && v !== r && n.call(v, a) && (p = v);
    var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p);
    function defineIteratorMethods(t) {
        [
            "next",
            "throw",
            "return"
        ].forEach(function(e) {
            define(t, e, function(t) {
                return this._invoke(e, t);
            });
        });
    }
    function AsyncIterator(t, e) {
        function invoke(r, o, i, a) {
            var c = tryCatch(t[r], t, o);
            if ("throw" !== c.type) {
                var u = c.arg, h = u.value;
                return h && "object" == $209e8d31241d8aca$var$_typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function(t) {
                    invoke("next", t, i, a);
                }, function(t) {
                    invoke("throw", t, i, a);
                }) : e.resolve(h).then(function(t) {
                    u.value = t, i(u);
                }, function(t) {
                    return invoke("throw", t, i, a);
                });
            }
            a(c.arg);
        }
        var r;
        o(this, "_invoke", {
            value: function value(t, n) {
                function callInvokeWithMethodAndArg() {
                    return new e(function(e, r) {
                        invoke(t, n, e, r);
                    });
                }
                return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
            }
        });
    }
    function makeInvokeMethod(e, r, n) {
        var o = h;
        return function(i, a) {
            if (o === f) throw Error("Generator is already running");
            if (o === s) {
                if ("throw" === i) throw a;
                return {
                    value: t,
                    done: !0
                };
            }
            for(n.method = i, n.arg = a;;){
                var c = n.delegate;
                if (c) {
                    var u = maybeInvokeDelegate(c, n);
                    if (u) {
                        if (u === y) continue;
                        return u;
                    }
                }
                if ("next" === n.method) n.sent = n._sent = n.arg;
                else if ("throw" === n.method) {
                    if (o === h) throw o = s, n.arg;
                    n.dispatchException(n.arg);
                } else "return" === n.method && n.abrupt("return", n.arg);
                o = f;
                var p = tryCatch(e, r, n);
                if ("normal" === p.type) {
                    if (o = n.done ? s : l, p.arg === y) continue;
                    return {
                        value: p.arg,
                        done: n.done
                    };
                }
                "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg);
            }
        };
    }
    function maybeInvokeDelegate(e, r) {
        var n = r.method, o = e.iterator[n];
        if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y;
        var i = tryCatch(o, e.iterator, r.arg);
        if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y;
        var a = i.arg;
        return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y);
    }
    function pushTryEntry(t) {
        var e = {
            tryLoc: t[0]
        };
        1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e);
    }
    function resetTryEntry(t) {
        var e = t.completion || {};
        e.type = "normal", delete e.arg, t.completion = e;
    }
    function Context(t) {
        this.tryEntries = [
            {
                tryLoc: "root"
            }
        ], t.forEach(pushTryEntry, this), this.reset(!0);
    }
    function values(e) {
        if (e || "" === e) {
            var r = e[a];
            if (r) return r.call(e);
            if ("function" == typeof e.next) return e;
            if (!isNaN(e.length)) {
                var o = -1, i = function next() {
                    for(; ++o < e.length;)if (n.call(e, o)) return next.value = e[o], next.done = !1, next;
                    return next.value = t, next.done = !0, next;
                };
                return i.next = i;
            }
        }
        throw new TypeError($209e8d31241d8aca$var$_typeof(e) + " is not iterable");
    }
    return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", {
        value: GeneratorFunctionPrototype,
        configurable: !0
    }), o(GeneratorFunctionPrototype, "constructor", {
        value: GeneratorFunction,
        configurable: !0
    }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function(t) {
        var e = "function" == typeof t && t.constructor;
        return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name));
    }, e.mark = function(t) {
        return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t;
    }, e.awrap = function(t) {
        return {
            __await: t
        };
    }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function() {
        return this;
    }), e.AsyncIterator = AsyncIterator, e.async = function(t, r, n, o, i) {
        void 0 === i && (i = Promise);
        var a = new AsyncIterator(wrap(t, r, n, o), i);
        return e.isGeneratorFunction(r) ? a : a.next().then(function(t) {
            return t.done ? t.value : a.next();
        });
    }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function() {
        return this;
    }), define(g, "toString", function() {
        return "[object Generator]";
    }), e.keys = function(t) {
        var e = Object(t), r = [];
        for(var n in e)r.push(n);
        return r.reverse(), function next() {
            for(; r.length;){
                var t = r.pop();
                if (t in e) return next.value = t, next.done = !1, next;
            }
            return next.done = !0, next;
        };
    }, e.values = values, Context.prototype = {
        constructor: Context,
        reset: function reset(e) {
            if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for(var r in this)"t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t);
        },
        stop: function stop() {
            this.done = !0;
            var t = this.tryEntries[0].completion;
            if ("throw" === t.type) throw t.arg;
            return this.rval;
        },
        dispatchException: function dispatchException(e) {
            if (this.done) throw e;
            var r = this;
            function handle(n, o) {
                return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o;
            }
            for(var o = this.tryEntries.length - 1; o >= 0; --o){
                var i = this.tryEntries[o], a = i.completion;
                if ("root" === i.tryLoc) return handle("end");
                if (i.tryLoc <= this.prev) {
                    var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc");
                    if (c && u) {
                        if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
                        if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
                    } else if (c) {
                        if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
                    } else {
                        if (!u) throw Error("try statement without catch or finally");
                        if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
                    }
                }
            }
        },
        abrupt: function abrupt(t, e) {
            for(var r = this.tryEntries.length - 1; r >= 0; --r){
                var o = this.tryEntries[r];
                if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
                    var i = o;
                    break;
                }
            }
            i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
            var a = i ? i.completion : {};
            return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a);
        },
        complete: function complete(t, e) {
            if ("throw" === t.type) throw t.arg;
            return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y;
        },
        finish: function finish(t) {
            for(var e = this.tryEntries.length - 1; e >= 0; --e){
                var r = this.tryEntries[e];
                if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y;
            }
        },
        "catch": function _catch(t) {
            for(var e = this.tryEntries.length - 1; e >= 0; --e){
                var r = this.tryEntries[e];
                if (r.tryLoc === t) {
                    var n = r.completion;
                    if ("throw" === n.type) {
                        var o = n.arg;
                        resetTryEntry(r);
                    }
                    return o;
                }
            }
            throw Error("illegal catch attempt");
        },
        delegateYield: function delegateYield(e, r, n) {
            return this.delegate = {
                iterator: values(e),
                resultName: r,
                nextLoc: n
            }, "next" === this.method && (this.arg = t), y;
        }
    }, e;
}
function $209e8d31241d8aca$var$asyncGeneratorStep(n, t, e, r, o, a, c) {
    try {
        var i = n[a](c), u = i.value;
    } catch (n) {
        return void e(n);
    }
    i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function $209e8d31241d8aca$var$_asyncToGenerator(n) {
    return function() {
        var t = this, e = arguments;
        return new Promise(function(r, o) {
            var a = n.apply(t, e);
            function _next(n) {
                $209e8d31241d8aca$var$asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
            }
            function _throw(n) {
                $209e8d31241d8aca$var$asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
            }
            _next(void 0);
        });
    };
}
var $209e8d31241d8aca$var$getUserInfo = $209e8d31241d8aca$exports.getUserInfo = /*#__PURE__*/ function() {
    var _ref = $209e8d31241d8aca$var$_asyncToGenerator(/*#__PURE__*/ $209e8d31241d8aca$var$_regeneratorRuntime().mark(function _callee() {
        var baseUrl, _responseBody$data, apiPath, response, responseBody, _args = arguments;
        return $209e8d31241d8aca$var$_regeneratorRuntime().wrap(function _callee$(_context) {
            while(true)switch(_context.prev = _context.next){
                case 0:
                    baseUrl = _args.length > 0 && _args[0] !== undefined ? _args[0] : '';
                    _context.prev = 1;
                    apiPath = (0, $9b8dc532c3c3f9ae$exports.getUppApiPathFromEnvironment)();
                    _context.next = 5;
                    return fetch("".concat(baseUrl).concat(apiPath), {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        body: JSON.stringify({
                            query: $6601efa3d6ce5781$exports.USER_INFO_QUERY,
                            operationName: 'USER_INFO_QUERY'
                        })
                    });
                case 5:
                    response = _context.sent;
                    _context.next = 8;
                    return response.json();
                case 8:
                    responseBody = _context.sent;
                    return _context.abrupt("return", ((_responseBody$data = responseBody.data) === null || _responseBody$data === void 0 || (_responseBody$data = _responseBody$data.me) === null || _responseBody$data === void 0 ? void 0 : _responseBody$data.user) || null);
                case 12:
                    _context.prev = 12;
                    _context.t0 = _context["catch"](1);
                    return _context.abrupt("return", null);
                case 15:
                case "end":
                    return _context.stop();
            }
        }, _callee, null, [
            [
                1,
                12
            ]
        ]);
    }));
    return function getUserInfo() {
        return _ref.apply(this, arguments);
    };
}();
var $209e8d31241d8aca$var$isUserInAllowList = $209e8d31241d8aca$exports.isUserInAllowList = /*#__PURE__*/ function() {
    var _ref2 = $209e8d31241d8aca$var$_asyncToGenerator(/*#__PURE__*/ $209e8d31241d8aca$var$_regeneratorRuntime().mark(function _callee2(emailId) {
        var baseUrl, _responseBody$data2, apiPath, response, responseBody, _args2 = arguments;
        return $209e8d31241d8aca$var$_regeneratorRuntime().wrap(function _callee2$(_context2) {
            while(true)switch(_context2.prev = _context2.next){
                case 0:
                    baseUrl = _args2.length > 1 && _args2[1] !== undefined ? _args2[1] : '';
                    if (emailId) {
                        _context2.next = 3;
                        break;
                    }
                    return _context2.abrupt("return", false);
                case 3:
                    _context2.prev = 3;
                    apiPath = (0, $9b8dc532c3c3f9ae$exports.getUppApiPathFromEnvironment)();
                    _context2.next = 7;
                    return fetch("".concat(baseUrl).concat(apiPath), {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        body: JSON.stringify({
                            query: (0, $6601efa3d6ce5781$exports.getUserIsAllowedQuery)(emailId),
                            operationName: 'USER_ALLOWED_QUERY'
                        })
                    });
                case 7:
                    response = _context2.sent;
                    _context2.next = 10;
                    return response.json();
                case 10:
                    responseBody = _context2.sent;
                    return _context2.abrupt("return", !!((_responseBody$data2 = responseBody.data) !== null && _responseBody$data2 !== void 0 && (_responseBody$data2 = _responseBody$data2.unified) !== null && _responseBody$data2 !== void 0 && (_responseBody$data2 = _responseBody$data2.gating) !== null && _responseBody$data2 !== void 0 && (_responseBody$data2 = _responseBody$data2.isEmailIdAllowed) !== null && _responseBody$data2 !== void 0 && _responseBody$data2.status));
                case 14:
                    _context2.prev = 14;
                    _context2.t0 = _context2["catch"](3);
                    return _context2.abrupt("return", false);
                case 17:
                case "end":
                    return _context2.stop();
            }
        }, _callee2, null, [
            [
                3,
                14
            ]
        ]);
    }));
    return function isUserInAllowList(_x) {
        return _ref2.apply(this, arguments);
    };
}();
var $209e8d31241d8aca$var$isUserAllowedForEaExperience = $209e8d31241d8aca$exports.isUserAllowedForEaExperience = /*#__PURE__*/ function() {
    var _ref3 = $209e8d31241d8aca$var$_asyncToGenerator(/*#__PURE__*/ $209e8d31241d8aca$var$_regeneratorRuntime().mark(function _callee3() {
        var baseUrl, userInfo, _args3 = arguments;
        return $209e8d31241d8aca$var$_regeneratorRuntime().wrap(function _callee3$(_context3) {
            while(true)switch(_context3.prev = _context3.next){
                case 0:
                    baseUrl = _args3.length > 0 && _args3[0] !== undefined ? _args3[0] : '';
                    _context3.next = 3;
                    return $209e8d31241d8aca$var$getUserInfo(baseUrl);
                case 3:
                    userInfo = _context3.sent;
                    if (userInfo) {
                        _context3.next = 6;
                        break;
                    }
                    return _context3.abrupt("return", false);
                case 6:
                    _context3.next = 8;
                    return $209e8d31241d8aca$var$isUserInAllowList(userInfo.email);
                case 8:
                    return _context3.abrupt("return", _context3.sent);
                case 9:
                case "end":
                    return _context3.stop();
            }
        }, _callee3);
    }));
    return function isUserAllowedForEaExperience() {
        return _ref3.apply(this, arguments);
    };
}();


Object.keys($209e8d31241d8aca$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $bd858cf878484440$exports && $bd858cf878484440$exports[key] === $209e8d31241d8aca$exports[key]) return;
    Object.defineProperty($bd858cf878484440$exports, key, {
        enumerable: true,
        get: function get() {
            return $209e8d31241d8aca$exports[key];
        }
    });
});

Object.keys($9274af858143a4bd$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $bd858cf878484440$exports && $bd858cf878484440$exports[key] === $9274af858143a4bd$exports[key]) return;
    Object.defineProperty($bd858cf878484440$exports, key, {
        enumerable: true,
        get: function get() {
            return $9274af858143a4bd$exports[key];
        }
    });
});
var $6476a8cf69414f97$exports = {};
"use strict";
function $6476a8cf69414f97$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $6476a8cf69414f97$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $6476a8cf69414f97$var$_typeof(o);
}
Object.defineProperty($6476a8cf69414f97$exports, "__esModule", {
    value: true
});
$6476a8cf69414f97$exports.initializeCommunitybyAaid = $6476a8cf69414f97$exports.initializeCommunity = $6476a8cf69414f97$exports.getCommunityLogoutUrl = $6476a8cf69414f97$exports.getCommunityLoginUrl = void 0;


var $62fb03ede952ca54$exports = {};
"use strict";
Object.defineProperty($62fb03ede952ca54$exports, "__esModule", {
    value: true
});
$62fb03ede952ca54$exports.getLogoutUrl = $62fb03ede952ca54$exports.getLoginUrl = $62fb03ede952ca54$exports.getForumsSignOutUrl = $62fb03ede952ca54$exports.getForumsSignInUrl = $62fb03ede952ca54$exports.getAuthUrl = void 0;

function $62fb03ede952ca54$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $62fb03ede952ca54$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $62fb03ede952ca54$var$_typeof(o);
}
function $62fb03ede952ca54$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $62fb03ede952ca54$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $62fb03ede952ca54$var$ownKeys(Object(t), !0).forEach(function(r) {
            $62fb03ede952ca54$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $62fb03ede952ca54$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $62fb03ede952ca54$var$_defineProperty(e, r, t) {
    return (r = $62fb03ede952ca54$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $62fb03ede952ca54$var$_toPropertyKey(t) {
    var i = $62fb03ede952ca54$var$_toPrimitive(t, "string");
    return "symbol" == $62fb03ede952ca54$var$_typeof(i) ? i : i + "";
}
function $62fb03ede952ca54$var$_toPrimitive(t, r) {
    if ("object" != $62fb03ede952ca54$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $62fb03ede952ca54$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $62fb03ede952ca54$var$buildAuthQueryParams = function buildAuthQueryParams(urlType, _ref) {
    var email = _ref.email, redirectUrl = _ref.redirectUrl, prompt = _ref.prompt, _ref$experience = _ref.experience, experience = _ref$experience === void 0 ? 'entry-auth' : _ref$experience;
    var queryParams = [];
    if (email) queryParams.push("login_hint=".concat(email));
    if (experience) queryParams.push("application=community--".concat(experience));
    if (redirectUrl) {
        // Encode the redirectUrl to handle special characters in paths (e.g. nested article paths)
        var encodedRedirectUrl = encodeURIComponent(redirectUrl);
        queryParams.push(urlType === 'identity' ? "continue=".concat(encodedRedirectUrl) : "referer=".concat(encodedRedirectUrl));
    }
    if (prompt) queryParams.push("prompt=".concat(prompt));
    return queryParams;
};
var $62fb03ede952ca54$var$getAuthUrl = $62fb03ede952ca54$exports.getAuthUrl = function getAuthUrl(type, queryParamValues, env) {
    var environment = (0, $9b8dc532c3c3f9ae$exports.getEnvironment)(env);
    var config = $9b8dc532c3c3f9ae$exports.ENVIRONMENT_CONFIGS[environment];
    var queryParams = $62fb03ede952ca54$var$buildAuthQueryParams('identity', queryParamValues);
    return "".concat(config.IDENTITY_BASE_URL, "/").concat(type, "?").concat(queryParams.join('&'));
};
var $62fb03ede952ca54$var$getForumsSignInUrl = $62fb03ede952ca54$exports.getForumsSignInUrl = function getForumsSignInUrl(queryParamValues, env) {
    var environment = (0, $9b8dc532c3c3f9ae$exports.getEnvironment)(env);
    var config = $9b8dc532c3c3f9ae$exports.ENVIRONMENT_CONFIGS[environment];
    // Only include referer parameter for OAuth2 SSO redirect
    var queryParams = [];
    if (queryParamValues.redirectUrl) // Encode the redirectUrl to handle special characters in paths (e.g. nested article paths)
    queryParams.push("referer=".concat(encodeURIComponent(queryParamValues.redirectUrl)));
    var queryString = queryParams.length > 0 ? "?".concat(queryParams.join('&')) : '';
    return encodeURIComponent("".concat(config.HOME_BASE_URL, "/forums/s/plugins/common/feature/oauth2sso_v2/sso_login_redirect").concat(queryString));
};
var $62fb03ede952ca54$var$getForumsSignOutUrl = $62fb03ede952ca54$exports.getForumsSignOutUrl = function getForumsSignOutUrl(redirectUrl, env) {
    var environment = (0, $9b8dc532c3c3f9ae$exports.getEnvironment)(env);
    var config = $9b8dc532c3c3f9ae$exports.ENVIRONMENT_CONFIGS[environment];
    // Encode the redirectUrl to handle special characters in paths (e.g. nested article paths)
    var encodedRedirectUrl = redirectUrl ? encodeURIComponent(redirectUrl) : '';
    return encodeURIComponent("".concat(config.HOME_BASE_URL, "/forums/s/plugins/custom/atlassian/").concat(config.KHOROS_ENDPOINT_PATH, "/khoros_logout?referer=").concat(encodedRedirectUrl));
};
var $62fb03ede952ca54$var$getLoginUrl = $62fb03ede952ca54$exports.getLoginUrl = function getLoginUrl(queryParamValues, env) {
    // Build the forums signin URL with the redirect URL
    var forumsSignInUrl = $62fb03ede952ca54$var$getForumsSignInUrl(queryParamValues);
    // redirect the identity login to the forums signin url
    var identityLoginUrl = $62fb03ede952ca54$var$getAuthUrl('login', $62fb03ede952ca54$var$_objectSpread($62fb03ede952ca54$var$_objectSpread({}, queryParamValues), {}, {
        redirectUrl: "".concat(forumsSignInUrl)
    }), env);
    return identityLoginUrl;
};
var $62fb03ede952ca54$var$getLogoutUrl = $62fb03ede952ca54$exports.getLogoutUrl = function getLogoutUrl(queryParamValues, env) {
    // Build the forums signout URL with the redirect URL
    var forumsSignOutUrl = $62fb03ede952ca54$var$getForumsSignOutUrl(queryParamValues.redirectUrl, env);
    // redirect the identity logout to the forums signout url
    var identityLogoutUrl = $62fb03ede952ca54$var$getAuthUrl('logout', $62fb03ede952ca54$var$_objectSpread($62fb03ede952ca54$var$_objectSpread({}, queryParamValues), {}, {
        redirectUrl: "".concat(forumsSignOutUrl)
    }), env);
    return identityLogoutUrl;
};


function $6476a8cf69414f97$var$_regeneratorRuntime() {
    "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ 
    $6476a8cf69414f97$var$_regeneratorRuntime = function _regeneratorRuntime() {
        return e;
    };
    var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function(t, e, r) {
        t[e] = r.value;
    }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag";
    function define(t, e, r) {
        return Object.defineProperty(t, e, {
            value: r,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }), t[e];
    }
    try {
        define({}, "");
    } catch (t) {
        define = function define(t, e, r) {
            return t[e] = r;
        };
    }
    function wrap(t, e, r, n) {
        var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []);
        return o(a, "_invoke", {
            value: makeInvokeMethod(t, r, c)
        }), a;
    }
    function tryCatch(t, e, r) {
        try {
            return {
                type: "normal",
                arg: t.call(e, r)
            };
        } catch (t) {
            return {
                type: "throw",
                arg: t
            };
        }
    }
    e.wrap = wrap;
    var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {};
    function Generator() {}
    function GeneratorFunction() {}
    function GeneratorFunctionPrototype() {}
    var p = {};
    define(p, a, function() {
        return this;
    });
    var d = Object.getPrototypeOf, v = d && d(d(values([])));
    v && v !== r && n.call(v, a) && (p = v);
    var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p);
    function defineIteratorMethods(t) {
        [
            "next",
            "throw",
            "return"
        ].forEach(function(e) {
            define(t, e, function(t) {
                return this._invoke(e, t);
            });
        });
    }
    function AsyncIterator(t, e) {
        function invoke(r, o, i, a) {
            var c = tryCatch(t[r], t, o);
            if ("throw" !== c.type) {
                var u = c.arg, h = u.value;
                return h && "object" == $6476a8cf69414f97$var$_typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function(t) {
                    invoke("next", t, i, a);
                }, function(t) {
                    invoke("throw", t, i, a);
                }) : e.resolve(h).then(function(t) {
                    u.value = t, i(u);
                }, function(t) {
                    return invoke("throw", t, i, a);
                });
            }
            a(c.arg);
        }
        var r;
        o(this, "_invoke", {
            value: function value(t, n) {
                function callInvokeWithMethodAndArg() {
                    return new e(function(e, r) {
                        invoke(t, n, e, r);
                    });
                }
                return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
            }
        });
    }
    function makeInvokeMethod(e, r, n) {
        var o = h;
        return function(i, a) {
            if (o === f) throw Error("Generator is already running");
            if (o === s) {
                if ("throw" === i) throw a;
                return {
                    value: t,
                    done: !0
                };
            }
            for(n.method = i, n.arg = a;;){
                var c = n.delegate;
                if (c) {
                    var u = maybeInvokeDelegate(c, n);
                    if (u) {
                        if (u === y) continue;
                        return u;
                    }
                }
                if ("next" === n.method) n.sent = n._sent = n.arg;
                else if ("throw" === n.method) {
                    if (o === h) throw o = s, n.arg;
                    n.dispatchException(n.arg);
                } else "return" === n.method && n.abrupt("return", n.arg);
                o = f;
                var p = tryCatch(e, r, n);
                if ("normal" === p.type) {
                    if (o = n.done ? s : l, p.arg === y) continue;
                    return {
                        value: p.arg,
                        done: n.done
                    };
                }
                "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg);
            }
        };
    }
    function maybeInvokeDelegate(e, r) {
        var n = r.method, o = e.iterator[n];
        if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y;
        var i = tryCatch(o, e.iterator, r.arg);
        if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y;
        var a = i.arg;
        return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y);
    }
    function pushTryEntry(t) {
        var e = {
            tryLoc: t[0]
        };
        1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e);
    }
    function resetTryEntry(t) {
        var e = t.completion || {};
        e.type = "normal", delete e.arg, t.completion = e;
    }
    function Context(t) {
        this.tryEntries = [
            {
                tryLoc: "root"
            }
        ], t.forEach(pushTryEntry, this), this.reset(!0);
    }
    function values(e) {
        if (e || "" === e) {
            var r = e[a];
            if (r) return r.call(e);
            if ("function" == typeof e.next) return e;
            if (!isNaN(e.length)) {
                var o = -1, i = function next() {
                    for(; ++o < e.length;)if (n.call(e, o)) return next.value = e[o], next.done = !1, next;
                    return next.value = t, next.done = !0, next;
                };
                return i.next = i;
            }
        }
        throw new TypeError($6476a8cf69414f97$var$_typeof(e) + " is not iterable");
    }
    return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", {
        value: GeneratorFunctionPrototype,
        configurable: !0
    }), o(GeneratorFunctionPrototype, "constructor", {
        value: GeneratorFunction,
        configurable: !0
    }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function(t) {
        var e = "function" == typeof t && t.constructor;
        return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name));
    }, e.mark = function(t) {
        return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t;
    }, e.awrap = function(t) {
        return {
            __await: t
        };
    }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function() {
        return this;
    }), e.AsyncIterator = AsyncIterator, e.async = function(t, r, n, o, i) {
        void 0 === i && (i = Promise);
        var a = new AsyncIterator(wrap(t, r, n, o), i);
        return e.isGeneratorFunction(r) ? a : a.next().then(function(t) {
            return t.done ? t.value : a.next();
        });
    }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function() {
        return this;
    }), define(g, "toString", function() {
        return "[object Generator]";
    }), e.keys = function(t) {
        var e = Object(t), r = [];
        for(var n in e)r.push(n);
        return r.reverse(), function next() {
            for(; r.length;){
                var t = r.pop();
                if (t in e) return next.value = t, next.done = !1, next;
            }
            return next.done = !0, next;
        };
    }, e.values = values, Context.prototype = {
        constructor: Context,
        reset: function reset(e) {
            if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for(var r in this)"t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t);
        },
        stop: function stop() {
            this.done = !0;
            var t = this.tryEntries[0].completion;
            if ("throw" === t.type) throw t.arg;
            return this.rval;
        },
        dispatchException: function dispatchException(e) {
            if (this.done) throw e;
            var r = this;
            function handle(n, o) {
                return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o;
            }
            for(var o = this.tryEntries.length - 1; o >= 0; --o){
                var i = this.tryEntries[o], a = i.completion;
                if ("root" === i.tryLoc) return handle("end");
                if (i.tryLoc <= this.prev) {
                    var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc");
                    if (c && u) {
                        if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
                        if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
                    } else if (c) {
                        if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
                    } else {
                        if (!u) throw Error("try statement without catch or finally");
                        if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
                    }
                }
            }
        },
        abrupt: function abrupt(t, e) {
            for(var r = this.tryEntries.length - 1; r >= 0; --r){
                var o = this.tryEntries[r];
                if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
                    var i = o;
                    break;
                }
            }
            i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
            var a = i ? i.completion : {};
            return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a);
        },
        complete: function complete(t, e) {
            if ("throw" === t.type) throw t.arg;
            return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y;
        },
        finish: function finish(t) {
            for(var e = this.tryEntries.length - 1; e >= 0; --e){
                var r = this.tryEntries[e];
                if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y;
            }
        },
        "catch": function _catch(t) {
            for(var e = this.tryEntries.length - 1; e >= 0; --e){
                var r = this.tryEntries[e];
                if (r.tryLoc === t) {
                    var n = r.completion;
                    if ("throw" === n.type) {
                        var o = n.arg;
                        resetTryEntry(r);
                    }
                    return o;
                }
            }
            throw Error("illegal catch attempt");
        },
        delegateYield: function delegateYield(e, r, n) {
            return this.delegate = {
                iterator: values(e),
                resultName: r,
                nextLoc: n
            }, "next" === this.method && (this.arg = t), y;
        }
    }, e;
}
function $6476a8cf69414f97$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $6476a8cf69414f97$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $6476a8cf69414f97$var$ownKeys(Object(t), !0).forEach(function(r) {
            $6476a8cf69414f97$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $6476a8cf69414f97$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $6476a8cf69414f97$var$_defineProperty(e, r, t) {
    return (r = $6476a8cf69414f97$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $6476a8cf69414f97$var$_toPropertyKey(t) {
    var i = $6476a8cf69414f97$var$_toPrimitive(t, "string");
    return "symbol" == $6476a8cf69414f97$var$_typeof(i) ? i : i + "";
}
function $6476a8cf69414f97$var$_toPrimitive(t, r) {
    if ("object" != $6476a8cf69414f97$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $6476a8cf69414f97$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $6476a8cf69414f97$var$asyncGeneratorStep(n, t, e, r, o, a, c) {
    try {
        var i = n[a](c), u = i.value;
    } catch (n) {
        return void e(n);
    }
    i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function $6476a8cf69414f97$var$_asyncToGenerator(n) {
    return function() {
        var t = this, e = arguments;
        return new Promise(function(r, o) {
            var a = n.apply(t, e);
            function _next(n) {
                $6476a8cf69414f97$var$asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
            }
            function _throw(n) {
                $6476a8cf69414f97$var$asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
            }
            _next(void 0);
        });
    };
}
var $6476a8cf69414f97$var$getCommunityLoginUrl = $6476a8cf69414f97$exports.getCommunityLoginUrl = function getCommunityLoginUrl(queryParamValues, env) {
    return (0, $62fb03ede952ca54$exports.getLoginUrl)(queryParamValues, env);
};
var $6476a8cf69414f97$var$getCommunityLogoutUrl = $6476a8cf69414f97$exports.getCommunityLogoutUrl = function getCommunityLogoutUrl(queryParamValues, env) {
    return (0, $62fb03ede952ca54$exports.getLogoutUrl)(queryParamValues, env);
};
// Initialize Community on UPP
var $6476a8cf69414f97$var$initializeCommunity = $6476a8cf69414f97$exports.initializeCommunity = /*#__PURE__*/ function() {
    var _ref = $6476a8cf69414f97$var$_asyncToGenerator(/*#__PURE__*/ $6476a8cf69414f97$var$_regeneratorRuntime().mark(function _callee(emailId) {
        var baseUrl, Origin, env, _graphqlResponseBody$, apiPath, graphqlResponse, graphqlResponseBody, _args = arguments;
        return $6476a8cf69414f97$var$_regeneratorRuntime().wrap(function _callee$(_context) {
            while(true)switch(_context.prev = _context.next){
                case 0:
                    baseUrl = _args.length > 1 && _args[1] !== undefined ? _args[1] : '';
                    Origin = _args.length > 2 ? _args[2] : undefined;
                    env = _args.length > 3 ? _args[3] : undefined;
                    _context.prev = 3;
                    apiPath = (0, $9b8dc532c3c3f9ae$exports.getUppApiPathFromEnvironment)(env);
                    _context.next = 7;
                    return fetch("".concat(baseUrl).concat(apiPath), {
                        method: 'POST',
                        headers: $6476a8cf69414f97$var$_objectSpread({
                            'Content-Type': 'application/json'
                        }, Origin ? {
                            Origin: Origin
                        } : {}),
                        body: JSON.stringify({
                            query: (0, $6eda9e6c03494bd2$exports.initializeCommunityMutation)(emailId),
                            operationName: 'INITIALIZE_COMMUNITY_MUTATION'
                        })
                    });
                case 7:
                    graphqlResponse = _context.sent;
                    _context.next = 10;
                    return graphqlResponse.json();
                case 10:
                    graphqlResponseBody = _context.sent;
                    return _context.abrupt("return", graphqlResponseBody === null || graphqlResponseBody === void 0 || (_graphqlResponseBody$ = graphqlResponseBody.data) === null || _graphqlResponseBody$ === void 0 || (_graphqlResponseBody$ = _graphqlResponseBody$.unified) === null || _graphqlResponseBody$ === void 0 || (_graphqlResponseBody$ = _graphqlResponseBody$.community) === null || _graphqlResponseBody$ === void 0 ? void 0 : _graphqlResponseBody$.initializeCommunity);
                case 14:
                    _context.prev = 14;
                    _context.t0 = _context["catch"](3);
                    console.error('Error setting consent on UPP: ', _context.t0);
                    return _context.abrupt("return", false);
                case 18:
                case "end":
                    return _context.stop();
            }
        }, _callee, null, [
            [
                3,
                14
            ]
        ]);
    }));
    return function initializeCommunity(_x) {
        return _ref.apply(this, arguments);
    };
}();
var $6476a8cf69414f97$var$initializeCommunitybyAaid = $6476a8cf69414f97$exports.initializeCommunitybyAaid = /*#__PURE__*/ function() {
    var _ref2 = $6476a8cf69414f97$var$_asyncToGenerator(/*#__PURE__*/ $6476a8cf69414f97$var$_regeneratorRuntime().mark(function _callee2(aaid) {
        var baseUrl, Origin, env, _graphqlResponseBody$2, apiPath, graphqlResponse, graphqlResponseBody, _args2 = arguments;
        return $6476a8cf69414f97$var$_regeneratorRuntime().wrap(function _callee2$(_context2) {
            while(true)switch(_context2.prev = _context2.next){
                case 0:
                    baseUrl = _args2.length > 1 && _args2[1] !== undefined ? _args2[1] : '';
                    Origin = _args2.length > 2 ? _args2[2] : undefined;
                    env = _args2.length > 3 ? _args2[3] : undefined;
                    _context2.prev = 3;
                    apiPath = (0, $9b8dc532c3c3f9ae$exports.getUppApiPathFromEnvironment)(env);
                    _context2.next = 7;
                    return fetch("".concat(baseUrl).concat(apiPath), {
                        method: 'POST',
                        headers: $6476a8cf69414f97$var$_objectSpread({
                            'Content-Type': 'application/json'
                        }, Origin ? {
                            Origin: Origin
                        } : {}),
                        body: JSON.stringify({
                            query: (0, $6eda9e6c03494bd2$exports.initializeCommunityMutationbyAaid)(aaid),
                            operationName: 'INITIALIZE_COMMUNITY_MUTATION'
                        })
                    });
                case 7:
                    graphqlResponse = _context2.sent;
                    _context2.next = 10;
                    return graphqlResponse.json();
                case 10:
                    graphqlResponseBody = _context2.sent;
                    return _context2.abrupt("return", graphqlResponseBody === null || graphqlResponseBody === void 0 || (_graphqlResponseBody$2 = graphqlResponseBody.data) === null || _graphqlResponseBody$2 === void 0 || (_graphqlResponseBody$2 = _graphqlResponseBody$2.unified) === null || _graphqlResponseBody$2 === void 0 || (_graphqlResponseBody$2 = _graphqlResponseBody$2.community) === null || _graphqlResponseBody$2 === void 0 ? void 0 : _graphqlResponseBody$2.initializeCommunity);
                case 14:
                    _context2.prev = 14;
                    _context2.t0 = _context2["catch"](3);
                    console.error('Error setting consent on UPP: ', _context2.t0);
                    return _context2.abrupt("return", false);
                case 18:
                case "end":
                    return _context2.stop();
            }
        }, _callee2, null, [
            [
                3,
                14
            ]
        ]);
    }));
    return function initializeCommunitybyAaid(_x2) {
        return _ref2.apply(this, arguments);
    };
}();


Object.keys($6476a8cf69414f97$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $bd858cf878484440$exports && $bd858cf878484440$exports[key] === $6476a8cf69414f97$exports[key]) return;
    Object.defineProperty($bd858cf878484440$exports, key, {
        enumerable: true,
        get: function get() {
            return $6476a8cf69414f97$exports[key];
        }
    });
});
var $0fb329e9144e036b$exports = {};
"use strict";
function $0fb329e9144e036b$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $0fb329e9144e036b$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $0fb329e9144e036b$var$_typeof(o);
}
Object.defineProperty($0fb329e9144e036b$exports, "__esModule", {
    value: true
});
$0fb329e9144e036b$exports.isUserManaged = $0fb329e9144e036b$exports.getUserAccountStatuses = void 0;



function $0fb329e9144e036b$var$_regeneratorRuntime() {
    "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ 
    $0fb329e9144e036b$var$_regeneratorRuntime = function _regeneratorRuntime() {
        return e;
    };
    var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function(t, e, r) {
        t[e] = r.value;
    }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag";
    function define(t, e, r) {
        return Object.defineProperty(t, e, {
            value: r,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }), t[e];
    }
    try {
        define({}, "");
    } catch (t) {
        define = function define(t, e, r) {
            return t[e] = r;
        };
    }
    function wrap(t, e, r, n) {
        var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []);
        return o(a, "_invoke", {
            value: makeInvokeMethod(t, r, c)
        }), a;
    }
    function tryCatch(t, e, r) {
        try {
            return {
                type: "normal",
                arg: t.call(e, r)
            };
        } catch (t) {
            return {
                type: "throw",
                arg: t
            };
        }
    }
    e.wrap = wrap;
    var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {};
    function Generator() {}
    function GeneratorFunction() {}
    function GeneratorFunctionPrototype() {}
    var p = {};
    define(p, a, function() {
        return this;
    });
    var d = Object.getPrototypeOf, v = d && d(d(values([])));
    v && v !== r && n.call(v, a) && (p = v);
    var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p);
    function defineIteratorMethods(t) {
        [
            "next",
            "throw",
            "return"
        ].forEach(function(e) {
            define(t, e, function(t) {
                return this._invoke(e, t);
            });
        });
    }
    function AsyncIterator(t, e) {
        function invoke(r, o, i, a) {
            var c = tryCatch(t[r], t, o);
            if ("throw" !== c.type) {
                var u = c.arg, h = u.value;
                return h && "object" == $0fb329e9144e036b$var$_typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function(t) {
                    invoke("next", t, i, a);
                }, function(t) {
                    invoke("throw", t, i, a);
                }) : e.resolve(h).then(function(t) {
                    u.value = t, i(u);
                }, function(t) {
                    return invoke("throw", t, i, a);
                });
            }
            a(c.arg);
        }
        var r;
        o(this, "_invoke", {
            value: function value(t, n) {
                function callInvokeWithMethodAndArg() {
                    return new e(function(e, r) {
                        invoke(t, n, e, r);
                    });
                }
                return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
            }
        });
    }
    function makeInvokeMethod(e, r, n) {
        var o = h;
        return function(i, a) {
            if (o === f) throw Error("Generator is already running");
            if (o === s) {
                if ("throw" === i) throw a;
                return {
                    value: t,
                    done: !0
                };
            }
            for(n.method = i, n.arg = a;;){
                var c = n.delegate;
                if (c) {
                    var u = maybeInvokeDelegate(c, n);
                    if (u) {
                        if (u === y) continue;
                        return u;
                    }
                }
                if ("next" === n.method) n.sent = n._sent = n.arg;
                else if ("throw" === n.method) {
                    if (o === h) throw o = s, n.arg;
                    n.dispatchException(n.arg);
                } else "return" === n.method && n.abrupt("return", n.arg);
                o = f;
                var p = tryCatch(e, r, n);
                if ("normal" === p.type) {
                    if (o = n.done ? s : l, p.arg === y) continue;
                    return {
                        value: p.arg,
                        done: n.done
                    };
                }
                "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg);
            }
        };
    }
    function maybeInvokeDelegate(e, r) {
        var n = r.method, o = e.iterator[n];
        if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y;
        var i = tryCatch(o, e.iterator, r.arg);
        if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y;
        var a = i.arg;
        return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y);
    }
    function pushTryEntry(t) {
        var e = {
            tryLoc: t[0]
        };
        1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e);
    }
    function resetTryEntry(t) {
        var e = t.completion || {};
        e.type = "normal", delete e.arg, t.completion = e;
    }
    function Context(t) {
        this.tryEntries = [
            {
                tryLoc: "root"
            }
        ], t.forEach(pushTryEntry, this), this.reset(!0);
    }
    function values(e) {
        if (e || "" === e) {
            var r = e[a];
            if (r) return r.call(e);
            if ("function" == typeof e.next) return e;
            if (!isNaN(e.length)) {
                var o = -1, i = function next() {
                    for(; ++o < e.length;)if (n.call(e, o)) return next.value = e[o], next.done = !1, next;
                    return next.value = t, next.done = !0, next;
                };
                return i.next = i;
            }
        }
        throw new TypeError($0fb329e9144e036b$var$_typeof(e) + " is not iterable");
    }
    return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", {
        value: GeneratorFunctionPrototype,
        configurable: !0
    }), o(GeneratorFunctionPrototype, "constructor", {
        value: GeneratorFunction,
        configurable: !0
    }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function(t) {
        var e = "function" == typeof t && t.constructor;
        return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name));
    }, e.mark = function(t) {
        return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t;
    }, e.awrap = function(t) {
        return {
            __await: t
        };
    }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function() {
        return this;
    }), e.AsyncIterator = AsyncIterator, e.async = function(t, r, n, o, i) {
        void 0 === i && (i = Promise);
        var a = new AsyncIterator(wrap(t, r, n, o), i);
        return e.isGeneratorFunction(r) ? a : a.next().then(function(t) {
            return t.done ? t.value : a.next();
        });
    }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function() {
        return this;
    }), define(g, "toString", function() {
        return "[object Generator]";
    }), e.keys = function(t) {
        var e = Object(t), r = [];
        for(var n in e)r.push(n);
        return r.reverse(), function next() {
            for(; r.length;){
                var t = r.pop();
                if (t in e) return next.value = t, next.done = !1, next;
            }
            return next.done = !0, next;
        };
    }, e.values = values, Context.prototype = {
        constructor: Context,
        reset: function reset(e) {
            if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for(var r in this)"t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t);
        },
        stop: function stop() {
            this.done = !0;
            var t = this.tryEntries[0].completion;
            if ("throw" === t.type) throw t.arg;
            return this.rval;
        },
        dispatchException: function dispatchException(e) {
            if (this.done) throw e;
            var r = this;
            function handle(n, o) {
                return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o;
            }
            for(var o = this.tryEntries.length - 1; o >= 0; --o){
                var i = this.tryEntries[o], a = i.completion;
                if ("root" === i.tryLoc) return handle("end");
                if (i.tryLoc <= this.prev) {
                    var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc");
                    if (c && u) {
                        if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
                        if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
                    } else if (c) {
                        if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
                    } else {
                        if (!u) throw Error("try statement without catch or finally");
                        if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
                    }
                }
            }
        },
        abrupt: function abrupt(t, e) {
            for(var r = this.tryEntries.length - 1; r >= 0; --r){
                var o = this.tryEntries[r];
                if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
                    var i = o;
                    break;
                }
            }
            i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
            var a = i ? i.completion : {};
            return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a);
        },
        complete: function complete(t, e) {
            if ("throw" === t.type) throw t.arg;
            return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y;
        },
        finish: function finish(t) {
            for(var e = this.tryEntries.length - 1; e >= 0; --e){
                var r = this.tryEntries[e];
                if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y;
            }
        },
        "catch": function _catch(t) {
            for(var e = this.tryEntries.length - 1; e >= 0; --e){
                var r = this.tryEntries[e];
                if (r.tryLoc === t) {
                    var n = r.completion;
                    if ("throw" === n.type) {
                        var o = n.arg;
                        resetTryEntry(r);
                    }
                    return o;
                }
            }
            throw Error("illegal catch attempt");
        },
        delegateYield: function delegateYield(e, r, n) {
            return this.delegate = {
                iterator: values(e),
                resultName: r,
                nextLoc: n
            }, "next" === this.method && (this.arg = t), y;
        }
    }, e;
}
function $0fb329e9144e036b$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $0fb329e9144e036b$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $0fb329e9144e036b$var$ownKeys(Object(t), !0).forEach(function(r) {
            $0fb329e9144e036b$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $0fb329e9144e036b$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $0fb329e9144e036b$var$_defineProperty(e, r, t) {
    return (r = $0fb329e9144e036b$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $0fb329e9144e036b$var$_toPropertyKey(t) {
    var i = $0fb329e9144e036b$var$_toPrimitive(t, "string");
    return "symbol" == $0fb329e9144e036b$var$_typeof(i) ? i : i + "";
}
function $0fb329e9144e036b$var$_toPrimitive(t, r) {
    if ("object" != $0fb329e9144e036b$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $0fb329e9144e036b$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $0fb329e9144e036b$var$asyncGeneratorStep(n, t, e, r, o, a, c) {
    try {
        var i = n[a](c), u = i.value;
    } catch (n) {
        return void e(n);
    }
    i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function $0fb329e9144e036b$var$_asyncToGenerator(n) {
    return function() {
        var t = this, e = arguments;
        return new Promise(function(r, o) {
            var a = n.apply(t, e);
            function _next(n) {
                $0fb329e9144e036b$var$asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
            }
            function _throw(n) {
                $0fb329e9144e036b$var$asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
            }
            _next(void 0);
        });
    };
}
var $0fb329e9144e036b$var$getUserAccountStatuses = $0fb329e9144e036b$exports.getUserAccountStatuses = /*#__PURE__*/ function() {
    var _ref = $0fb329e9144e036b$var$_asyncToGenerator(/*#__PURE__*/ $0fb329e9144e036b$var$_regeneratorRuntime().mark(function _callee(aaid) {
        var baseUrl, Origin, env, apiPath, rawResponse, json, _args = arguments;
        return $0fb329e9144e036b$var$_regeneratorRuntime().wrap(function _callee$(_context) {
            while(true)switch(_context.prev = _context.next){
                case 0:
                    baseUrl = _args.length > 1 && _args[1] !== undefined ? _args[1] : '';
                    Origin = _args.length > 2 ? _args[2] : undefined;
                    env = _args.length > 3 ? _args[3] : undefined;
                    apiPath = (0, $9b8dc532c3c3f9ae$exports.getUppApiPathFromEnvironment)(env);
                    _context.next = 6;
                    return fetch("".concat(baseUrl).concat(apiPath), {
                        method: 'POST',
                        headers: $0fb329e9144e036b$var$_objectSpread({
                            'Content-Type': 'application/json'
                        }, Origin ? {
                            Origin: Origin
                        } : {}),
                        body: JSON.stringify({
                            query: (0, $6601efa3d6ce5781$exports.getUserAccountQuery)(aaid),
                            operationName: 'USER_ACCOUNT_QUERY'
                        })
                    });
                case 6:
                    rawResponse = _context.sent;
                    _context.next = 9;
                    return rawResponse.json();
                case 9:
                    json = _context.sent;
                    return _context.abrupt("return", json);
                case 11:
                case "end":
                    return _context.stop();
            }
        }, _callee);
    }));
    return function getUserAccountStatuses(_x) {
        return _ref.apply(this, arguments);
    };
}();
var $0fb329e9144e036b$var$isUserManaged = $0fb329e9144e036b$exports.isUserManaged = /*#__PURE__*/ function() {
    var _ref2 = $0fb329e9144e036b$var$_asyncToGenerator(/*#__PURE__*/ $0fb329e9144e036b$var$_regeneratorRuntime().mark(function _callee2(aaid) {
        var baseUrl, Origin, env, _response$data, response, account, _args2 = arguments;
        return $0fb329e9144e036b$var$_regeneratorRuntime().wrap(function _callee2$(_context2) {
            while(true)switch(_context2.prev = _context2.next){
                case 0:
                    baseUrl = _args2.length > 1 && _args2[1] !== undefined ? _args2[1] : '';
                    Origin = _args2.length > 2 ? _args2[2] : undefined;
                    env = _args2.length > 3 ? _args2[3] : undefined;
                    _context2.prev = 3;
                    _context2.next = 6;
                    return $0fb329e9144e036b$var$getUserAccountStatuses(aaid, baseUrl, Origin, env);
                case 6:
                    response = _context2.sent;
                    account = response === null || response === void 0 || (_response$data = response.data) === null || _response$data === void 0 || (_response$data = _response$data.unified) === null || _response$data === void 0 ? void 0 : _response$data.account;
                    if (!(!account || (0, $5af8fa5f3021d79b$exports.isUnifiedAccountQueryError)(account))) {
                        _context2.next = 10;
                        break;
                    }
                    return _context2.abrupt("return", null);
                case 10:
                    if (!(typeof account.isManaged !== 'boolean')) {
                        _context2.next = 12;
                        break;
                    }
                    return _context2.abrupt("return", null);
                case 12:
                    return _context2.abrupt("return", account.isManaged);
                case 15:
                    _context2.prev = 15;
                    _context2.t0 = _context2["catch"](3);
                    console.error('[isUserManaged] Error fetching unified account:', _context2.t0);
                    return _context2.abrupt("return", null);
                case 19:
                case "end":
                    return _context2.stop();
            }
        }, _callee2, null, [
            [
                3,
                15
            ]
        ]);
    }));
    return function isUserManaged(_x2) {
        return _ref2.apply(this, arguments);
    };
}();


Object.keys($0fb329e9144e036b$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $bd858cf878484440$exports && $bd858cf878484440$exports[key] === $0fb329e9144e036b$exports[key]) return;
    Object.defineProperty($bd858cf878484440$exports, key, {
        enumerable: true,
        get: function get() {
            return $0fb329e9144e036b$exports[key];
        }
    });
});
var $39032f18861f088c$exports = {};
"use strict";
function $39032f18861f088c$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $39032f18861f088c$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $39032f18861f088c$var$_typeof(o);
}
Object.defineProperty($39032f18861f088c$exports, "__esModule", {
    value: true
});
$39032f18861f088c$exports.submitChampionSignup = void 0;


function $39032f18861f088c$var$_regeneratorRuntime() {
    "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ 
    $39032f18861f088c$var$_regeneratorRuntime = function _regeneratorRuntime() {
        return e;
    };
    var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function(t, e, r) {
        t[e] = r.value;
    }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag";
    function define(t, e, r) {
        return Object.defineProperty(t, e, {
            value: r,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }), t[e];
    }
    try {
        define({}, "");
    } catch (t) {
        define = function define(t, e, r) {
            return t[e] = r;
        };
    }
    function wrap(t, e, r, n) {
        var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []);
        return o(a, "_invoke", {
            value: makeInvokeMethod(t, r, c)
        }), a;
    }
    function tryCatch(t, e, r) {
        try {
            return {
                type: "normal",
                arg: t.call(e, r)
            };
        } catch (t) {
            return {
                type: "throw",
                arg: t
            };
        }
    }
    e.wrap = wrap;
    var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {};
    function Generator() {}
    function GeneratorFunction() {}
    function GeneratorFunctionPrototype() {}
    var p = {};
    define(p, a, function() {
        return this;
    });
    var d = Object.getPrototypeOf, v = d && d(d(values([])));
    v && v !== r && n.call(v, a) && (p = v);
    var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p);
    function defineIteratorMethods(t) {
        [
            "next",
            "throw",
            "return"
        ].forEach(function(e) {
            define(t, e, function(t) {
                return this._invoke(e, t);
            });
        });
    }
    function AsyncIterator(t, e) {
        function invoke(r, o, i, a) {
            var c = tryCatch(t[r], t, o);
            if ("throw" !== c.type) {
                var u = c.arg, h = u.value;
                return h && "object" == $39032f18861f088c$var$_typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function(t) {
                    invoke("next", t, i, a);
                }, function(t) {
                    invoke("throw", t, i, a);
                }) : e.resolve(h).then(function(t) {
                    u.value = t, i(u);
                }, function(t) {
                    return invoke("throw", t, i, a);
                });
            }
            a(c.arg);
        }
        var r;
        o(this, "_invoke", {
            value: function value(t, n) {
                function callInvokeWithMethodAndArg() {
                    return new e(function(e, r) {
                        invoke(t, n, e, r);
                    });
                }
                return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
            }
        });
    }
    function makeInvokeMethod(e, r, n) {
        var o = h;
        return function(i, a) {
            if (o === f) throw Error("Generator is already running");
            if (o === s) {
                if ("throw" === i) throw a;
                return {
                    value: t,
                    done: !0
                };
            }
            for(n.method = i, n.arg = a;;){
                var c = n.delegate;
                if (c) {
                    var u = maybeInvokeDelegate(c, n);
                    if (u) {
                        if (u === y) continue;
                        return u;
                    }
                }
                if ("next" === n.method) n.sent = n._sent = n.arg;
                else if ("throw" === n.method) {
                    if (o === h) throw o = s, n.arg;
                    n.dispatchException(n.arg);
                } else "return" === n.method && n.abrupt("return", n.arg);
                o = f;
                var p = tryCatch(e, r, n);
                if ("normal" === p.type) {
                    if (o = n.done ? s : l, p.arg === y) continue;
                    return {
                        value: p.arg,
                        done: n.done
                    };
                }
                "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg);
            }
        };
    }
    function maybeInvokeDelegate(e, r) {
        var n = r.method, o = e.iterator[n];
        if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y;
        var i = tryCatch(o, e.iterator, r.arg);
        if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y;
        var a = i.arg;
        return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y);
    }
    function pushTryEntry(t) {
        var e = {
            tryLoc: t[0]
        };
        1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e);
    }
    function resetTryEntry(t) {
        var e = t.completion || {};
        e.type = "normal", delete e.arg, t.completion = e;
    }
    function Context(t) {
        this.tryEntries = [
            {
                tryLoc: "root"
            }
        ], t.forEach(pushTryEntry, this), this.reset(!0);
    }
    function values(e) {
        if (e || "" === e) {
            var r = e[a];
            if (r) return r.call(e);
            if ("function" == typeof e.next) return e;
            if (!isNaN(e.length)) {
                var o = -1, i = function next() {
                    for(; ++o < e.length;)if (n.call(e, o)) return next.value = e[o], next.done = !1, next;
                    return next.value = t, next.done = !0, next;
                };
                return i.next = i;
            }
        }
        throw new TypeError($39032f18861f088c$var$_typeof(e) + " is not iterable");
    }
    return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", {
        value: GeneratorFunctionPrototype,
        configurable: !0
    }), o(GeneratorFunctionPrototype, "constructor", {
        value: GeneratorFunction,
        configurable: !0
    }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function(t) {
        var e = "function" == typeof t && t.constructor;
        return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name));
    }, e.mark = function(t) {
        return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t;
    }, e.awrap = function(t) {
        return {
            __await: t
        };
    }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function() {
        return this;
    }), e.AsyncIterator = AsyncIterator, e.async = function(t, r, n, o, i) {
        void 0 === i && (i = Promise);
        var a = new AsyncIterator(wrap(t, r, n, o), i);
        return e.isGeneratorFunction(r) ? a : a.next().then(function(t) {
            return t.done ? t.value : a.next();
        });
    }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function() {
        return this;
    }), define(g, "toString", function() {
        return "[object Generator]";
    }), e.keys = function(t) {
        var e = Object(t), r = [];
        for(var n in e)r.push(n);
        return r.reverse(), function next() {
            for(; r.length;){
                var t = r.pop();
                if (t in e) return next.value = t, next.done = !1, next;
            }
            return next.done = !0, next;
        };
    }, e.values = values, Context.prototype = {
        constructor: Context,
        reset: function reset(e) {
            if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for(var r in this)"t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t);
        },
        stop: function stop() {
            this.done = !0;
            var t = this.tryEntries[0].completion;
            if ("throw" === t.type) throw t.arg;
            return this.rval;
        },
        dispatchException: function dispatchException(e) {
            if (this.done) throw e;
            var r = this;
            function handle(n, o) {
                return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o;
            }
            for(var o = this.tryEntries.length - 1; o >= 0; --o){
                var i = this.tryEntries[o], a = i.completion;
                if ("root" === i.tryLoc) return handle("end");
                if (i.tryLoc <= this.prev) {
                    var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc");
                    if (c && u) {
                        if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
                        if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
                    } else if (c) {
                        if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
                    } else {
                        if (!u) throw Error("try statement without catch or finally");
                        if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
                    }
                }
            }
        },
        abrupt: function abrupt(t, e) {
            for(var r = this.tryEntries.length - 1; r >= 0; --r){
                var o = this.tryEntries[r];
                if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
                    var i = o;
                    break;
                }
            }
            i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
            var a = i ? i.completion : {};
            return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a);
        },
        complete: function complete(t, e) {
            if ("throw" === t.type) throw t.arg;
            return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y;
        },
        finish: function finish(t) {
            for(var e = this.tryEntries.length - 1; e >= 0; --e){
                var r = this.tryEntries[e];
                if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y;
            }
        },
        "catch": function _catch(t) {
            for(var e = this.tryEntries.length - 1; e >= 0; --e){
                var r = this.tryEntries[e];
                if (r.tryLoc === t) {
                    var n = r.completion;
                    if ("throw" === n.type) {
                        var o = n.arg;
                        resetTryEntry(r);
                    }
                    return o;
                }
            }
            throw Error("illegal catch attempt");
        },
        delegateYield: function delegateYield(e, r, n) {
            return this.delegate = {
                iterator: values(e),
                resultName: r,
                nextLoc: n
            }, "next" === this.method && (this.arg = t), y;
        }
    }, e;
}
function $39032f18861f088c$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $39032f18861f088c$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $39032f18861f088c$var$ownKeys(Object(t), !0).forEach(function(r) {
            $39032f18861f088c$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $39032f18861f088c$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $39032f18861f088c$var$_defineProperty(e, r, t) {
    return (r = $39032f18861f088c$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $39032f18861f088c$var$_toPropertyKey(t) {
    var i = $39032f18861f088c$var$_toPrimitive(t, "string");
    return "symbol" == $39032f18861f088c$var$_typeof(i) ? i : i + "";
}
function $39032f18861f088c$var$_toPrimitive(t, r) {
    if ("object" != $39032f18861f088c$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $39032f18861f088c$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $39032f18861f088c$var$asyncGeneratorStep(n, t, e, r, o, a, c) {
    try {
        var i = n[a](c), u = i.value;
    } catch (n) {
        return void e(n);
    }
    i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function $39032f18861f088c$var$_asyncToGenerator(n) {
    return function() {
        var t = this, e = arguments;
        return new Promise(function(r, o) {
            var a = n.apply(t, e);
            function _next(n) {
                $39032f18861f088c$var$asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
            }
            function _throw(n) {
                $39032f18861f088c$var$asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
            }
            _next(void 0);
        });
    };
}
var $39032f18861f088c$var$submitChampionSignup = $39032f18861f088c$exports.submitChampionSignup = /*#__PURE__*/ function() {
    var _ref = $39032f18861f088c$var$_asyncToGenerator(/*#__PURE__*/ $39032f18861f088c$var$_regeneratorRuntime().mark(function _callee(input) {
        var baseUrl, Origin, env, _json$data$champion$c, _json$data, apiPath, rawResponse, json, _args = arguments;
        return $39032f18861f088c$var$_regeneratorRuntime().wrap(function _callee$(_context) {
            while(true)switch(_context.prev = _context.next){
                case 0:
                    baseUrl = _args.length > 1 && _args[1] !== undefined ? _args[1] : '';
                    Origin = _args.length > 2 ? _args[2] : undefined;
                    env = _args.length > 3 ? _args[3] : undefined;
                    _context.prev = 3;
                    apiPath = (0, $9b8dc532c3c3f9ae$exports.getUppApiPathFromEnvironment)(env);
                    _context.next = 7;
                    return fetch("".concat(baseUrl).concat(apiPath), {
                        method: 'POST',
                        credentials: 'include',
                        headers: $39032f18861f088c$var$_objectSpread({
                            'Content-Type': 'application/json'
                        }, Origin ? {
                            Origin: Origin
                        } : {}),
                        body: JSON.stringify({
                            query: $6eda9e6c03494bd2$exports.SUBMIT_CHAMPION_SIGNUP_MUTATION,
                            operationName: 'SUBMIT_CHAMPION_SIGNUP_MUTATION',
                            variables: {
                                input: input
                            }
                        })
                    });
                case 7:
                    rawResponse = _context.sent;
                    _context.next = 10;
                    return rawResponse.json();
                case 10:
                    json = _context.sent;
                    return _context.abrupt("return", (_json$data$champion$c = json === null || json === void 0 || (_json$data = json.data) === null || _json$data === void 0 || (_json$data = _json$data.champion) === null || _json$data === void 0 || (_json$data = _json$data.championSignup) === null || _json$data === void 0 ? void 0 : _json$data.submitChampionSignup) !== null && _json$data$champion$c !== void 0 ? _json$data$champion$c : null);
                case 14:
                    _context.prev = 14;
                    _context.t0 = _context["catch"](3);
                    console.error('Error submitting champion signup: ', _context.t0);
                    return _context.abrupt("return", null);
                case 18:
                case "end":
                    return _context.stop();
            }
        }, _callee, null, [
            [
                3,
                14
            ]
        ]);
    }));
    return function submitChampionSignup(_x) {
        return _ref.apply(this, arguments);
    };
}();


Object.keys($39032f18861f088c$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $bd858cf878484440$exports && $bd858cf878484440$exports[key] === $39032f18861f088c$exports[key]) return;
    Object.defineProperty($bd858cf878484440$exports, key, {
        enumerable: true,
        get: function get() {
            return $39032f18861f088c$exports[key];
        }
    });
});


function $1964ee7f51f79709$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
function $1964ee7f51f79709$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($1964ee7f51f79709$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $1964ee7f51f79709$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != $1964ee7f51f79709$var$_typeof(e) && "function" != typeof e) return {
        "default": e
    };
    var t = $1964ee7f51f79709$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $1964ee7f51f79709$var$_regeneratorRuntime() {
    "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ 
    $1964ee7f51f79709$var$_regeneratorRuntime = function _regeneratorRuntime() {
        return e;
    };
    var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function(t, e, r) {
        t[e] = r.value;
    }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag";
    function define(t, e, r) {
        return Object.defineProperty(t, e, {
            value: r,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }), t[e];
    }
    try {
        define({}, "");
    } catch (t) {
        define = function define(t, e, r) {
            return t[e] = r;
        };
    }
    function wrap(t, e, r, n) {
        var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []);
        return o(a, "_invoke", {
            value: makeInvokeMethod(t, r, c)
        }), a;
    }
    function tryCatch(t, e, r) {
        try {
            return {
                type: "normal",
                arg: t.call(e, r)
            };
        } catch (t) {
            return {
                type: "throw",
                arg: t
            };
        }
    }
    e.wrap = wrap;
    var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {};
    function Generator() {}
    function GeneratorFunction() {}
    function GeneratorFunctionPrototype() {}
    var p = {};
    define(p, a, function() {
        return this;
    });
    var d = Object.getPrototypeOf, v = d && d(d(values([])));
    v && v !== r && n.call(v, a) && (p = v);
    var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p);
    function defineIteratorMethods(t) {
        [
            "next",
            "throw",
            "return"
        ].forEach(function(e) {
            define(t, e, function(t) {
                return this._invoke(e, t);
            });
        });
    }
    function AsyncIterator(t, e) {
        function invoke(r, o, i, a) {
            var c = tryCatch(t[r], t, o);
            if ("throw" !== c.type) {
                var u = c.arg, h = u.value;
                return h && "object" == $1964ee7f51f79709$var$_typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function(t) {
                    invoke("next", t, i, a);
                }, function(t) {
                    invoke("throw", t, i, a);
                }) : e.resolve(h).then(function(t) {
                    u.value = t, i(u);
                }, function(t) {
                    return invoke("throw", t, i, a);
                });
            }
            a(c.arg);
        }
        var r;
        o(this, "_invoke", {
            value: function value(t, n) {
                function callInvokeWithMethodAndArg() {
                    return new e(function(e, r) {
                        invoke(t, n, e, r);
                    });
                }
                return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
            }
        });
    }
    function makeInvokeMethod(e, r, n) {
        var o = h;
        return function(i, a) {
            if (o === f) throw Error("Generator is already running");
            if (o === s) {
                if ("throw" === i) throw a;
                return {
                    value: t,
                    done: !0
                };
            }
            for(n.method = i, n.arg = a;;){
                var c = n.delegate;
                if (c) {
                    var u = maybeInvokeDelegate(c, n);
                    if (u) {
                        if (u === y) continue;
                        return u;
                    }
                }
                if ("next" === n.method) n.sent = n._sent = n.arg;
                else if ("throw" === n.method) {
                    if (o === h) throw o = s, n.arg;
                    n.dispatchException(n.arg);
                } else "return" === n.method && n.abrupt("return", n.arg);
                o = f;
                var p = tryCatch(e, r, n);
                if ("normal" === p.type) {
                    if (o = n.done ? s : l, p.arg === y) continue;
                    return {
                        value: p.arg,
                        done: n.done
                    };
                }
                "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg);
            }
        };
    }
    function maybeInvokeDelegate(e, r) {
        var n = r.method, o = e.iterator[n];
        if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y;
        var i = tryCatch(o, e.iterator, r.arg);
        if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y;
        var a = i.arg;
        return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y);
    }
    function pushTryEntry(t) {
        var e = {
            tryLoc: t[0]
        };
        1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e);
    }
    function resetTryEntry(t) {
        var e = t.completion || {};
        e.type = "normal", delete e.arg, t.completion = e;
    }
    function Context(t) {
        this.tryEntries = [
            {
                tryLoc: "root"
            }
        ], t.forEach(pushTryEntry, this), this.reset(!0);
    }
    function values(e) {
        if (e || "" === e) {
            var r = e[a];
            if (r) return r.call(e);
            if ("function" == typeof e.next) return e;
            if (!isNaN(e.length)) {
                var o = -1, i = function next() {
                    for(; ++o < e.length;)if (n.call(e, o)) return next.value = e[o], next.done = !1, next;
                    return next.value = t, next.done = !0, next;
                };
                return i.next = i;
            }
        }
        throw new TypeError($1964ee7f51f79709$var$_typeof(e) + " is not iterable");
    }
    return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", {
        value: GeneratorFunctionPrototype,
        configurable: !0
    }), o(GeneratorFunctionPrototype, "constructor", {
        value: GeneratorFunction,
        configurable: !0
    }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function(t) {
        var e = "function" == typeof t && t.constructor;
        return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name));
    }, e.mark = function(t) {
        return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t;
    }, e.awrap = function(t) {
        return {
            __await: t
        };
    }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function() {
        return this;
    }), e.AsyncIterator = AsyncIterator, e.async = function(t, r, n, o, i) {
        void 0 === i && (i = Promise);
        var a = new AsyncIterator(wrap(t, r, n, o), i);
        return e.isGeneratorFunction(r) ? a : a.next().then(function(t) {
            return t.done ? t.value : a.next();
        });
    }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function() {
        return this;
    }), define(g, "toString", function() {
        return "[object Generator]";
    }), e.keys = function(t) {
        var e = Object(t), r = [];
        for(var n in e)r.push(n);
        return r.reverse(), function next() {
            for(; r.length;){
                var t = r.pop();
                if (t in e) return next.value = t, next.done = !1, next;
            }
            return next.done = !0, next;
        };
    }, e.values = values, Context.prototype = {
        constructor: Context,
        reset: function reset(e) {
            if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for(var r in this)"t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t);
        },
        stop: function stop() {
            this.done = !0;
            var t = this.tryEntries[0].completion;
            if ("throw" === t.type) throw t.arg;
            return this.rval;
        },
        dispatchException: function dispatchException(e) {
            if (this.done) throw e;
            var r = this;
            function handle(n, o) {
                return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o;
            }
            for(var o = this.tryEntries.length - 1; o >= 0; --o){
                var i = this.tryEntries[o], a = i.completion;
                if ("root" === i.tryLoc) return handle("end");
                if (i.tryLoc <= this.prev) {
                    var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc");
                    if (c && u) {
                        if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
                        if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
                    } else if (c) {
                        if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
                    } else {
                        if (!u) throw Error("try statement without catch or finally");
                        if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
                    }
                }
            }
        },
        abrupt: function abrupt(t, e) {
            for(var r = this.tryEntries.length - 1; r >= 0; --r){
                var o = this.tryEntries[r];
                if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
                    var i = o;
                    break;
                }
            }
            i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
            var a = i ? i.completion : {};
            return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a);
        },
        complete: function complete(t, e) {
            if ("throw" === t.type) throw t.arg;
            return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y;
        },
        finish: function finish(t) {
            for(var e = this.tryEntries.length - 1; e >= 0; --e){
                var r = this.tryEntries[e];
                if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y;
            }
        },
        "catch": function _catch(t) {
            for(var e = this.tryEntries.length - 1; e >= 0; --e){
                var r = this.tryEntries[e];
                if (r.tryLoc === t) {
                    var n = r.completion;
                    if ("throw" === n.type) {
                        var o = n.arg;
                        resetTryEntry(r);
                    }
                    return o;
                }
            }
            throw Error("illegal catch attempt");
        },
        delegateYield: function delegateYield(e, r, n) {
            return this.delegate = {
                iterator: values(e),
                resultName: r,
                nextLoc: n
            }, "next" === this.method && (this.arg = t), y;
        }
    }, e;
}
function $1964ee7f51f79709$var$asyncGeneratorStep(n, t, e, r, o, a, c) {
    try {
        var i = n[a](c), u = i.value;
    } catch (n) {
        return void e(n);
    }
    i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function $1964ee7f51f79709$var$_asyncToGenerator(n) {
    return function() {
        var t = this, e = arguments;
        return new Promise(function(r, o) {
            var a = n.apply(t, e);
            function _next(n) {
                $1964ee7f51f79709$var$asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
            }
            function _throw(n) {
                $1964ee7f51f79709$var$asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
            }
            _next(void 0);
        });
    };
}
function $1964ee7f51f79709$var$_slicedToArray(r, e) {
    return $1964ee7f51f79709$var$_arrayWithHoles(r) || $1964ee7f51f79709$var$_iterableToArrayLimit(r, e) || $1964ee7f51f79709$var$_unsupportedIterableToArray(r, e) || $1964ee7f51f79709$var$_nonIterableRest();
}
function $1964ee7f51f79709$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $1964ee7f51f79709$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $1964ee7f51f79709$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $1964ee7f51f79709$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $1964ee7f51f79709$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $1964ee7f51f79709$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $1964ee7f51f79709$var$_arrayWithHoles(r) {
    if (Array.isArray(r)) return r;
}
var $1964ee7f51f79709$var$Initializer = $1964ee7f51f79709$exports.Initializer = function Initializer(_ref) {
    var emailId = _ref.emailId, aaid = _ref.aaid, onError = _ref.onError, onSuccess = _ref.onSuccess, onComplete = _ref.onComplete, isInitialized = _ref.isInitialized, children = _ref.children;
    var _React$useState = $1964ee7f51f79709$var$_react["default"].useState(false), _React$useState2 = $1964ee7f51f79709$var$_slicedToArray(_React$useState, 2), isLoading = _React$useState2[0], setIsLoading = _React$useState2[1];
    var initializeCommunityAccounts = /*#__PURE__*/ function() {
        var _ref2 = $1964ee7f51f79709$var$_asyncToGenerator(/*#__PURE__*/ $1964ee7f51f79709$var$_regeneratorRuntime().mark(function _callee() {
            var response;
            return $1964ee7f51f79709$var$_regeneratorRuntime().wrap(function _callee$(_context) {
                while(true)switch(_context.prev = _context.next){
                    case 0:
                        _context.prev = 0;
                        setIsLoading(true);
                        if (!aaid) {
                            _context.next = 8;
                            break;
                        }
                        _context.next = 5;
                        return (0, $bd858cf878484440$exports.initializeCommunitybyAaid)(aaid);
                    case 5:
                        response = _context.sent;
                        _context.next = 15;
                        break;
                    case 8:
                        if (!emailId) {
                            _context.next = 14;
                            break;
                        }
                        _context.next = 11;
                        return (0, $bd858cf878484440$exports.initializeCommunity)(emailId);
                    case 11:
                        response = _context.sent;
                        _context.next = 15;
                        break;
                    case 14:
                        onError('missing_aaid_emailid', 'AAID or emailId is required');
                    case 15:
                        if (!response) onError('consent_failed', 'Failed to initialize');
                        else onSuccess();
                        _context.next = 21;
                        break;
                    case 18:
                        _context.prev = 18;
                        _context.t0 = _context["catch"](0);
                        onError('initialization_failed', 'Failed to initialize' + _context.t0.message);
                    case 21:
                        _context.prev = 21;
                        setIsLoading(false);
                        if (onComplete) onComplete();
                        return _context.finish(21);
                    case 25:
                    case "end":
                        return _context.stop();
                }
            }, _callee, null, [
                [
                    0,
                    18,
                    21,
                    25
                ]
            ]);
        }));
        return function initializeCommunityAccounts() {
            return _ref2.apply(this, arguments);
        };
    }();
    (0, $1964ee7f51f79709$var$_react.useEffect)(function() {
        $1964ee7f51f79709$var$_asyncToGenerator(/*#__PURE__*/ $1964ee7f51f79709$var$_regeneratorRuntime().mark(function _callee2() {
            return $1964ee7f51f79709$var$_regeneratorRuntime().wrap(function _callee2$(_context2) {
                while(true)switch(_context2.prev = _context2.next){
                    case 0:
                        _context2.next = 2;
                        return initializeCommunityAccounts();
                    case 2:
                    case "end":
                        return _context2.stop();
                }
            }, _callee2);
        }))();
    }, [
        aaid,
        emailId
    ]);
    if (isLoading) return /*#__PURE__*/ $1964ee7f51f79709$var$_react["default"].createElement($1964ee7f51f79709$var$_loadingSpinner["default"], null);
    // If not logged in, consent is true, or there is an error
    return isInitialized ? children : null;
};


Object.keys($1964ee7f51f79709$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $d9a56230c565b38a$exports && $d9a56230c565b38a$exports[key] === $1964ee7f51f79709$exports[key]) return;
    Object.defineProperty($d9a56230c565b38a$exports, key, {
        enumerable: true,
        get: function get() {
            return $1964ee7f51f79709$exports[key];
        }
    });
});


Object.keys($d9a56230c565b38a$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $a73be79b54a68660$exports && $a73be79b54a68660$exports[key] === $d9a56230c565b38a$exports[key]) return;
    Object.defineProperty($a73be79b54a68660$exports, key, {
        enumerable: true,
        get: function get() {
            return $d9a56230c565b38a$exports[key];
        }
    });
});

Object.keys($bd858cf878484440$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $a73be79b54a68660$exports && $a73be79b54a68660$exports[key] === $bd858cf878484440$exports[key]) return;
    Object.defineProperty($a73be79b54a68660$exports, key, {
        enumerable: true,
        get: function get() {
            return $bd858cf878484440$exports[key];
        }
    });
});



/**
 * Returns the current page URL.
 * Extracted into its own module so it can be mocked in unit tests,
 * since window.location.href is non-configurable in jsdom.
 */ const $dbdd82f2c97f07d1$export$e28ecc88271c1c41 = ()=>window.location.href;


const $b512f1dc2d07f0c5$var$SSO_REDIRECT_PATH = '/forums/s/plugins/common/feature/oauth2sso_v2/sso_login_redirect';
const $b512f1dc2d07f0c5$var$COMMUNITY_PARAM = 'application=community--entry-auth';
const $b512f1dc2d07f0c5$export$c539662d478decb = ()=>{
    const env = (0, $09e3b90497c94454$export$e6ab37cc923d2afa)();
    const khorosEndpoint = env === 'production' ? 'atlassian' : 'atlassiandev';
    return `/forums/s/plugins/custom/atlassian/${khorosEndpoint}/khoros_logout`;
};
const $b512f1dc2d07f0c5$export$1db7da00354b15ed = ()=>{
    const homeBaseUrl = "https://community.atlassian.com";
    const referer = encodeURIComponent((0, $dbdd82f2c97f07d1$export$e28ecc88271c1c41)());
    const forumsUrl = `${homeBaseUrl}${$b512f1dc2d07f0c5$var$SSO_REDIRECT_PATH}?referer=${referer}`;
    return encodeURIComponent(forumsUrl);
};
const $b512f1dc2d07f0c5$export$f6a03fcc87267edf = ()=>{
    const homeBaseUrl = "https://community.atlassian.com";
    const referer = encodeURIComponent((0, $dbdd82f2c97f07d1$export$e28ecc88271c1c41)());
    const forumsUrl = `${homeBaseUrl}${$b512f1dc2d07f0c5$export$c539662d478decb()}?referer=${referer}`;
    return encodeURIComponent(forumsUrl);
};
const $b512f1dc2d07f0c5$export$f1dab1a322d2e5c = (email)=>{
    const identityBaseUrl = "https://id.atlassian.com";
    const params = [
        $b512f1dc2d07f0c5$var$COMMUNITY_PARAM
    ];
    if (email) params.push(`login_hint=${email}`);
    // getForumsSignInUrl already returns an encoded URL — use it directly as continue= value
    params.push(`continue=${$b512f1dc2d07f0c5$export$1db7da00354b15ed()}`);
    return `${identityBaseUrl}/login?${params.join('&')}`;
};
const $b512f1dc2d07f0c5$export$35bc0a4a03944143 = (email)=>{
    const identityBaseUrl = "https://id.atlassian.com";
    const params = [
        $b512f1dc2d07f0c5$var$COMMUNITY_PARAM
    ];
    if (email) params.push(`login_hint=${email}`);
    // getForumsSignOutUrl already returns an encoded URL — use it directly as continue= value
    params.push(`continue=${$b512f1dc2d07f0c5$export$f6a03fcc87267edf()}`);
    return `${identityBaseUrl}/logout?${params.join('&')}`;
};
const $b512f1dc2d07f0c5$export$82e6520baed18150 = (email)=>{
    const identityBaseUrl = "https://id.atlassian.com";
    const params = [
        $b512f1dc2d07f0c5$var$COMMUNITY_PARAM
    ];
    if (email) params.push(`login_hint=${email}`);
    // Signup goes directly back to the page, so encode the raw URL once
    params.push(`continue=${encodeURIComponent((0, $dbdd82f2c97f07d1$export$e28ecc88271c1c41)())}`);
    return `${identityBaseUrl}/signup?${params.join('&')}`;
};
const $b512f1dc2d07f0c5$export$e43e4e187350fb69 = ()=>{
    const identityBaseUrl = "https://id.atlassian.com";
    const params = [
        $b512f1dc2d07f0c5$var$COMMUNITY_PARAM
    ];
    params.push(`continue=${$b512f1dc2d07f0c5$export$1db7da00354b15ed()}`);
    params.push(`prompt=select_account`);
    return `${identityBaseUrl}/login?${params.join('&')}`;
};


const $12fc361ebcaf5b04$export$3151da8f6716d1a2 = ({ isLoggedIn: isLoggedIn, loggedInUser: loggedInUser })=>{
    // Auth href utils read window.location.href internally at call time, ensuring the correct
    // page URL is used even on the details page (/release-notes/:id)
    const email = loggedInUser?.email || '';
    const loginHref = (0, $b512f1dc2d07f0c5$export$f1dab1a322d2e5c)(email);
    const logoutHref = (0, $b512f1dc2d07f0c5$export$35bc0a4a03944143)(email);
    const signupHref = (0, $b512f1dc2d07f0c5$export$82e6520baed18150)(email);
    const switchHref = (0, $b512f1dc2d07f0c5$export$e43e4e187350fb69)();
    return /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $24c02ea0e14dbe4f$export$901cb8c9de2be2aa), {
        currentApp: (0, $24c02ea0e14dbe4f$export$93d048dc21eb282a).APP_UPDATES,
        isLoggedIn: isLoggedIn,
        user: loggedInUser,
        loginHref: loginHref,
        logoutHref: logoutHref,
        signupHref: signupHref,
        switchHref: switchHref,
        onAnalyticsSendEvent: (type, payload)=>(0, $a73be79b54a68660$exports.CommunityAnalyticsClient).sendEvent(type, payload),
        email: loggedInUser?.email,
        showAppUpdates: true,
        showNewMenu: true
    });
};



var $5FkrB = parcelRequire("5FkrB");



var $aRMzY = parcelRequire("aRMzY");
var $6Wx3K = parcelRequire("6Wx3K");
// src/index.tsx

var $5FkrB = parcelRequire("5FkrB");

var $dcrmD = parcelRequire("dcrmD");

var $jSI6G = parcelRequire("jSI6G");
var $12b11248680fdff3$exports = {};
//
$12b11248680fdff3$exports = function shallowEqual(objA, objB, compare, compareContext) {
    var ret = compare ? compare.call(compareContext, objA, objB) : void 0;
    if (ret !== void 0) return !!ret;
    if (objA === objB) return true;
    if (typeof objA !== "object" || !objA || typeof objB !== "object" || !objB) return false;
    var keysA = Object.keys(objA);
    var keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
    // Test for A's keys different from B.
    for(var idx = 0; idx < keysA.length; idx++){
        var key = keysA[idx];
        if (!bHasOwnProperty(key)) return false;
        var valueA = objA[key];
        var valueB = objB[key];
        ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;
        if (ret === false || ret === void 0 && valueA !== valueB) return false;
    }
    return true;
};


// src/constants.ts
var $448e9b7b3295f6e4$var$TAG_NAMES = /* @__PURE__ */ ((TAG_NAMES2)=>{
    TAG_NAMES2["BASE"] = "base";
    TAG_NAMES2["BODY"] = "body";
    TAG_NAMES2["HEAD"] = "head";
    TAG_NAMES2["HTML"] = "html";
    TAG_NAMES2["LINK"] = "link";
    TAG_NAMES2["META"] = "meta";
    TAG_NAMES2["NOSCRIPT"] = "noscript";
    TAG_NAMES2["SCRIPT"] = "script";
    TAG_NAMES2["STYLE"] = "style";
    TAG_NAMES2["TITLE"] = "title";
    TAG_NAMES2["FRAGMENT"] = "Symbol(react.fragment)";
    return TAG_NAMES2;
})($448e9b7b3295f6e4$var$TAG_NAMES || {});
var $448e9b7b3295f6e4$var$SEO_PRIORITY_TAGS = {
    link: {
        rel: [
            "amphtml",
            "canonical",
            "alternate"
        ]
    },
    script: {
        type: [
            "application/ld+json"
        ]
    },
    meta: {
        charset: "",
        name: [
            "generator",
            "robots",
            "description"
        ],
        property: [
            "og:type",
            "og:title",
            "og:url",
            "og:image",
            "og:image:alt",
            "og:description",
            "twitter:url",
            "twitter:title",
            "twitter:description",
            "twitter:image",
            "twitter:image:alt",
            "twitter:card",
            "twitter:site"
        ]
    }
};
var $448e9b7b3295f6e4$var$VALID_TAG_NAMES = Object.values($448e9b7b3295f6e4$var$TAG_NAMES);
var $448e9b7b3295f6e4$var$REACT_TAG_MAP = {
    accesskey: "accessKey",
    charset: "charSet",
    class: "className",
    contenteditable: "contentEditable",
    contextmenu: "contextMenu",
    "http-equiv": "httpEquiv",
    itemprop: "itemProp",
    tabindex: "tabIndex"
};
var $448e9b7b3295f6e4$var$HTML_TAG_MAP = Object.entries($448e9b7b3295f6e4$var$REACT_TAG_MAP).reduce((carry, [key, value])=>{
    carry[value] = key;
    return carry;
}, {});
var $448e9b7b3295f6e4$var$HELMET_ATTRIBUTE = "data-rh";
// src/utils.ts
var $448e9b7b3295f6e4$var$HELMET_PROPS = {
    DEFAULT_TITLE: "defaultTitle",
    DEFER: "defer",
    ENCODE_SPECIAL_CHARACTERS: "encodeSpecialCharacters",
    ON_CHANGE_CLIENT_STATE: "onChangeClientState",
    TITLE_TEMPLATE: "titleTemplate",
    PRIORITIZE_SEO_TAGS: "prioritizeSeoTags"
};
var $448e9b7b3295f6e4$var$getInnermostProperty = (propsList, property)=>{
    for(let i = propsList.length - 1; i >= 0; i -= 1){
        const props = propsList[i];
        if (Object.prototype.hasOwnProperty.call(props, property)) return props[property];
    }
    return null;
};
var $448e9b7b3295f6e4$var$getTitleFromPropsList = (propsList)=>{
    let innermostTitle = $448e9b7b3295f6e4$var$getInnermostProperty(propsList, "title" /* TITLE */ );
    const innermostTemplate = $448e9b7b3295f6e4$var$getInnermostProperty(propsList, $448e9b7b3295f6e4$var$HELMET_PROPS.TITLE_TEMPLATE);
    if (Array.isArray(innermostTitle)) innermostTitle = innermostTitle.join("");
    if (innermostTemplate && innermostTitle) return innermostTemplate.replace(/%s/g, ()=>innermostTitle);
    const innermostDefaultTitle = $448e9b7b3295f6e4$var$getInnermostProperty(propsList, $448e9b7b3295f6e4$var$HELMET_PROPS.DEFAULT_TITLE);
    return innermostTitle || innermostDefaultTitle || void 0;
};
var $448e9b7b3295f6e4$var$getOnChangeClientState = (propsList)=>$448e9b7b3295f6e4$var$getInnermostProperty(propsList, $448e9b7b3295f6e4$var$HELMET_PROPS.ON_CHANGE_CLIENT_STATE) || (()=>{});
var $448e9b7b3295f6e4$var$getAttributesFromPropsList = (tagType, propsList)=>propsList.filter((props)=>typeof props[tagType] !== "undefined").map((props)=>props[tagType]).reduce((tagAttrs, current)=>({
            ...tagAttrs,
            ...current
        }), {});
var $448e9b7b3295f6e4$var$getBaseTagFromPropsList = (primaryAttributes, propsList)=>propsList.filter((props)=>typeof props["base" /* BASE */ ] !== "undefined").map((props)=>props["base" /* BASE */ ]).reverse().reduce((innermostBaseTag, tag)=>{
        if (!innermostBaseTag.length) {
            const keys = Object.keys(tag);
            for(let i = 0; i < keys.length; i += 1){
                const attributeKey = keys[i];
                const lowerCaseAttributeKey = attributeKey.toLowerCase();
                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && tag[lowerCaseAttributeKey]) return innermostBaseTag.concat(tag);
            }
        }
        return innermostBaseTag;
    }, []);
var $448e9b7b3295f6e4$var$warn = (msg)=>console && typeof console.warn === "function" && console.warn(msg);
var $448e9b7b3295f6e4$var$getTagsFromPropsList = (tagName, primaryAttributes, propsList)=>{
    const approvedSeenTags = {};
    return propsList.filter((props)=>{
        if (Array.isArray(props[tagName])) return true;
        if (typeof props[tagName] !== "undefined") $448e9b7b3295f6e4$var$warn(`Helmet: ${tagName} should be of type "Array". Instead found type "${typeof props[tagName]}"`);
        return false;
    }).map((props)=>props[tagName]).reverse().reduce((approvedTags, instanceTags)=>{
        const instanceSeenTags = {};
        instanceTags.filter((tag)=>{
            let primaryAttributeKey;
            const keys2 = Object.keys(tag);
            for(let i = 0; i < keys2.length; i += 1){
                const attributeKey = keys2[i];
                const lowerCaseAttributeKey = attributeKey.toLowerCase();
                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && !(primaryAttributeKey === "rel" /* REL */  && tag[primaryAttributeKey].toLowerCase() === "canonical") && !(lowerCaseAttributeKey === "rel" /* REL */  && tag[lowerCaseAttributeKey].toLowerCase() === "stylesheet")) primaryAttributeKey = lowerCaseAttributeKey;
                if (primaryAttributes.indexOf(attributeKey) !== -1 && (attributeKey === "innerHTML" /* INNER_HTML */  || attributeKey === "cssText" /* CSS_TEXT */  || attributeKey === "itemprop" /* ITEM_PROP */ )) primaryAttributeKey = attributeKey;
            }
            if (!primaryAttributeKey || !tag[primaryAttributeKey]) return false;
            const value = tag[primaryAttributeKey].toLowerCase();
            if (!approvedSeenTags[primaryAttributeKey]) approvedSeenTags[primaryAttributeKey] = {};
            if (!instanceSeenTags[primaryAttributeKey]) instanceSeenTags[primaryAttributeKey] = {};
            if (!approvedSeenTags[primaryAttributeKey][value]) {
                instanceSeenTags[primaryAttributeKey][value] = true;
                return true;
            }
            return false;
        }).reverse().forEach((tag)=>approvedTags.push(tag));
        const keys = Object.keys(instanceSeenTags);
        for(let i = 0; i < keys.length; i += 1){
            const attributeKey = keys[i];
            const tagUnion = {
                ...approvedSeenTags[attributeKey],
                ...instanceSeenTags[attributeKey]
            };
            approvedSeenTags[attributeKey] = tagUnion;
        }
        return approvedTags;
    }, []).reverse();
};
var $448e9b7b3295f6e4$var$getAnyTrueFromPropsList = (propsList, checkedTag)=>{
    if (Array.isArray(propsList) && propsList.length) for(let index = 0; index < propsList.length; index += 1){
        const prop = propsList[index];
        if (prop[checkedTag]) return true;
    }
    return false;
};
var $448e9b7b3295f6e4$var$reducePropsToState = (propsList)=>({
        baseTag: $448e9b7b3295f6e4$var$getBaseTagFromPropsList([
            "href" /* HREF */ 
        ], propsList),
        bodyAttributes: $448e9b7b3295f6e4$var$getAttributesFromPropsList("bodyAttributes" /* BODY */ , propsList),
        defer: $448e9b7b3295f6e4$var$getInnermostProperty(propsList, $448e9b7b3295f6e4$var$HELMET_PROPS.DEFER),
        encode: $448e9b7b3295f6e4$var$getInnermostProperty(propsList, $448e9b7b3295f6e4$var$HELMET_PROPS.ENCODE_SPECIAL_CHARACTERS),
        htmlAttributes: $448e9b7b3295f6e4$var$getAttributesFromPropsList("htmlAttributes" /* HTML */ , propsList),
        linkTags: $448e9b7b3295f6e4$var$getTagsFromPropsList("link" /* LINK */ , [
            "rel" /* REL */ ,
            "href" /* HREF */ 
        ], propsList),
        metaTags: $448e9b7b3295f6e4$var$getTagsFromPropsList("meta" /* META */ , [
            "name" /* NAME */ ,
            "charset" /* CHARSET */ ,
            "http-equiv" /* HTTPEQUIV */ ,
            "property" /* PROPERTY */ ,
            "itemprop" /* ITEM_PROP */ 
        ], propsList),
        noscriptTags: $448e9b7b3295f6e4$var$getTagsFromPropsList("noscript" /* NOSCRIPT */ , [
            "innerHTML" /* INNER_HTML */ 
        ], propsList),
        onChangeClientState: $448e9b7b3295f6e4$var$getOnChangeClientState(propsList),
        scriptTags: $448e9b7b3295f6e4$var$getTagsFromPropsList("script" /* SCRIPT */ , [
            "src" /* SRC */ ,
            "innerHTML" /* INNER_HTML */ 
        ], propsList),
        styleTags: $448e9b7b3295f6e4$var$getTagsFromPropsList("style" /* STYLE */ , [
            "cssText" /* CSS_TEXT */ 
        ], propsList),
        title: $448e9b7b3295f6e4$var$getTitleFromPropsList(propsList),
        titleAttributes: $448e9b7b3295f6e4$var$getAttributesFromPropsList("titleAttributes" /* TITLE */ , propsList),
        prioritizeSeoTags: $448e9b7b3295f6e4$var$getAnyTrueFromPropsList(propsList, $448e9b7b3295f6e4$var$HELMET_PROPS.PRIORITIZE_SEO_TAGS)
    });
var $448e9b7b3295f6e4$var$flattenArray = (possibleArray)=>Array.isArray(possibleArray) ? possibleArray.join("") : possibleArray;
var $448e9b7b3295f6e4$var$checkIfPropsMatch = (props, toMatch)=>{
    const keys = Object.keys(props);
    for(let i = 0; i < keys.length; i += 1){
        if (toMatch[keys[i]] && toMatch[keys[i]].includes(props[keys[i]])) return true;
    }
    return false;
};
var $448e9b7b3295f6e4$var$prioritizer = (elementsList, propsToMatch)=>{
    if (Array.isArray(elementsList)) return elementsList.reduce((acc, elementAttrs)=>{
        if ($448e9b7b3295f6e4$var$checkIfPropsMatch(elementAttrs, propsToMatch)) acc.priority.push(elementAttrs);
        else acc.default.push(elementAttrs);
        return acc;
    }, {
        priority: [],
        default: []
    });
    return {
        default: elementsList,
        priority: []
    };
};
var $448e9b7b3295f6e4$var$without = (obj, key)=>{
    return {
        ...obj,
        [key]: void 0
    };
};
// src/server.ts
var $448e9b7b3295f6e4$var$SELF_CLOSING_TAGS = [
    "noscript" /* NOSCRIPT */ ,
    "script" /* SCRIPT */ ,
    "style" /* STYLE */ 
];
var $448e9b7b3295f6e4$var$encodeSpecialCharacters = (str, encode = true)=>{
    if (encode === false) return String(str);
    return String(str).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#x27;");
};
var $448e9b7b3295f6e4$var$generateElementAttributesAsString = (attributes)=>Object.keys(attributes).reduce((str, key)=>{
        const attr = typeof attributes[key] !== "undefined" ? `${key}="${attributes[key]}"` : `${key}`;
        return str ? `${str} ${attr}` : attr;
    }, "");
var $448e9b7b3295f6e4$var$generateTitleAsString = (type, title, attributes, encode)=>{
    const attributeString = $448e9b7b3295f6e4$var$generateElementAttributesAsString(attributes);
    const flattenedTitle = $448e9b7b3295f6e4$var$flattenArray(title);
    return attributeString ? `<${type} ${$448e9b7b3295f6e4$var$HELMET_ATTRIBUTE}="true" ${attributeString}>${$448e9b7b3295f6e4$var$encodeSpecialCharacters(flattenedTitle, encode)}</${type}>` : `<${type} ${$448e9b7b3295f6e4$var$HELMET_ATTRIBUTE}="true">${$448e9b7b3295f6e4$var$encodeSpecialCharacters(flattenedTitle, encode)}</${type}>`;
};
var $448e9b7b3295f6e4$var$generateTagsAsString = (type, tags, encode = true)=>tags.reduce((str, t)=>{
        const tag = t;
        const attributeHtml = Object.keys(tag).filter((attribute)=>!(attribute === "innerHTML" /* INNER_HTML */  || attribute === "cssText" /* CSS_TEXT */ )).reduce((string, attribute)=>{
            const attr = typeof tag[attribute] === "undefined" ? attribute : `${attribute}="${$448e9b7b3295f6e4$var$encodeSpecialCharacters(tag[attribute], encode)}"`;
            return string ? `${string} ${attr}` : attr;
        }, "");
        const tagContent = tag.innerHTML || tag.cssText || "";
        const isSelfClosing = $448e9b7b3295f6e4$var$SELF_CLOSING_TAGS.indexOf(type) === -1;
        return `${str}<${type} ${$448e9b7b3295f6e4$var$HELMET_ATTRIBUTE}="true" ${attributeHtml}${isSelfClosing ? `/>` : `>${tagContent}</${type}>`}`;
    }, "");
var $448e9b7b3295f6e4$var$convertElementAttributesToReactProps = (attributes, initProps = {})=>Object.keys(attributes).reduce((obj, key)=>{
        const mapped = $448e9b7b3295f6e4$var$REACT_TAG_MAP[key];
        obj[mapped || key] = attributes[key];
        return obj;
    }, initProps);
var $448e9b7b3295f6e4$var$generateTitleAsReactComponent = (_type, title, attributes)=>{
    const initProps = {
        key: title,
        [$448e9b7b3295f6e4$var$HELMET_ATTRIBUTE]: true
    };
    const props = $448e9b7b3295f6e4$var$convertElementAttributesToReactProps(attributes, initProps);
    return [
        (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("title" /* TITLE */ , props, title)
    ];
};
var $448e9b7b3295f6e4$var$generateTagsAsReactComponent = (type, tags)=>tags.map((tag, i)=>{
        const mappedTag = {
            key: i,
            [$448e9b7b3295f6e4$var$HELMET_ATTRIBUTE]: true
        };
        Object.keys(tag).forEach((attribute)=>{
            const mapped = $448e9b7b3295f6e4$var$REACT_TAG_MAP[attribute];
            const mappedAttribute = mapped || attribute;
            if (mappedAttribute === "innerHTML" /* INNER_HTML */  || mappedAttribute === "cssText" /* CSS_TEXT */ ) {
                const content = tag.innerHTML || tag.cssText;
                mappedTag.dangerouslySetInnerHTML = {
                    __html: content
                };
            } else mappedTag[mappedAttribute] = tag[attribute];
        });
        return (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(type, mappedTag);
    });
var $448e9b7b3295f6e4$var$getMethodsForTag = (type, tags, encode = true)=>{
    switch(type){
        case "title" /* TITLE */ :
            return {
                toComponent: ()=>$448e9b7b3295f6e4$var$generateTitleAsReactComponent(type, tags.title, tags.titleAttributes),
                toString: ()=>$448e9b7b3295f6e4$var$generateTitleAsString(type, tags.title, tags.titleAttributes, encode)
            };
        case "bodyAttributes" /* BODY */ :
        case "htmlAttributes" /* HTML */ :
            return {
                toComponent: ()=>$448e9b7b3295f6e4$var$convertElementAttributesToReactProps(tags),
                toString: ()=>$448e9b7b3295f6e4$var$generateElementAttributesAsString(tags)
            };
        default:
            return {
                toComponent: ()=>$448e9b7b3295f6e4$var$generateTagsAsReactComponent(type, tags),
                toString: ()=>$448e9b7b3295f6e4$var$generateTagsAsString(type, tags, encode)
            };
    }
};
var $448e9b7b3295f6e4$var$getPriorityMethods = ({ metaTags: metaTags, linkTags: linkTags, scriptTags: scriptTags, encode: encode })=>{
    const meta = $448e9b7b3295f6e4$var$prioritizer(metaTags, $448e9b7b3295f6e4$var$SEO_PRIORITY_TAGS.meta);
    const link = $448e9b7b3295f6e4$var$prioritizer(linkTags, $448e9b7b3295f6e4$var$SEO_PRIORITY_TAGS.link);
    const script = $448e9b7b3295f6e4$var$prioritizer(scriptTags, $448e9b7b3295f6e4$var$SEO_PRIORITY_TAGS.script);
    const priorityMethods = {
        toComponent: ()=>[
                ...$448e9b7b3295f6e4$var$generateTagsAsReactComponent("meta" /* META */ , meta.priority),
                ...$448e9b7b3295f6e4$var$generateTagsAsReactComponent("link" /* LINK */ , link.priority),
                ...$448e9b7b3295f6e4$var$generateTagsAsReactComponent("script" /* SCRIPT */ , script.priority)
            ],
        toString: ()=>// generate all the tags as strings and concatenate them
            `${$448e9b7b3295f6e4$var$getMethodsForTag("meta" /* META */ , meta.priority, encode)} ${$448e9b7b3295f6e4$var$getMethodsForTag("link" /* LINK */ , link.priority, encode)} ${$448e9b7b3295f6e4$var$getMethodsForTag("script" /* SCRIPT */ , script.priority, encode)}`
    };
    return {
        priorityMethods: priorityMethods,
        metaTags: meta.default,
        linkTags: link.default,
        scriptTags: script.default
    };
};
var $448e9b7b3295f6e4$var$mapStateOnServer = (props)=>{
    const { baseTag: baseTag, bodyAttributes: bodyAttributes, encode: encode = true, htmlAttributes: htmlAttributes, noscriptTags: noscriptTags, styleTags: styleTags, title: title = "", titleAttributes: titleAttributes, prioritizeSeoTags: prioritizeSeoTags } = props;
    let { linkTags: linkTags, metaTags: metaTags, scriptTags: scriptTags } = props;
    let priorityMethods = {
        toComponent: ()=>[],
        toString: ()=>""
    };
    if (prioritizeSeoTags) ({ priorityMethods: priorityMethods, linkTags: linkTags, metaTags: metaTags, scriptTags: scriptTags } = $448e9b7b3295f6e4$var$getPriorityMethods(props));
    return {
        priority: priorityMethods,
        base: $448e9b7b3295f6e4$var$getMethodsForTag("base" /* BASE */ , baseTag, encode),
        bodyAttributes: $448e9b7b3295f6e4$var$getMethodsForTag("bodyAttributes" /* BODY */ , bodyAttributes, encode),
        htmlAttributes: $448e9b7b3295f6e4$var$getMethodsForTag("htmlAttributes" /* HTML */ , htmlAttributes, encode),
        link: $448e9b7b3295f6e4$var$getMethodsForTag("link" /* LINK */ , linkTags, encode),
        meta: $448e9b7b3295f6e4$var$getMethodsForTag("meta" /* META */ , metaTags, encode),
        noscript: $448e9b7b3295f6e4$var$getMethodsForTag("noscript" /* NOSCRIPT */ , noscriptTags, encode),
        script: $448e9b7b3295f6e4$var$getMethodsForTag("script" /* SCRIPT */ , scriptTags, encode),
        style: $448e9b7b3295f6e4$var$getMethodsForTag("style" /* STYLE */ , styleTags, encode),
        title: $448e9b7b3295f6e4$var$getMethodsForTag("title" /* TITLE */ , {
            title: title,
            titleAttributes: titleAttributes
        }, encode)
    };
};
var $448e9b7b3295f6e4$var$server_default = $448e9b7b3295f6e4$var$mapStateOnServer;
// src/HelmetData.ts
var $448e9b7b3295f6e4$var$instances = [];
var $448e9b7b3295f6e4$var$isDocument = !!(typeof window !== "undefined" && window.document && window.document.createElement);
var $448e9b7b3295f6e4$export$a9cf6990c9c7feb9 = class {
    instances = [];
    canUseDOM = $448e9b7b3295f6e4$var$isDocument;
    context;
    value = {
        setHelmet: (serverState)=>{
            this.context.helmet = serverState;
        },
        helmetInstances: {
            get: ()=>this.canUseDOM ? $448e9b7b3295f6e4$var$instances : this.instances,
            add: (instance)=>{
                (this.canUseDOM ? $448e9b7b3295f6e4$var$instances : this.instances).push(instance);
            },
            remove: (instance)=>{
                const index = (this.canUseDOM ? $448e9b7b3295f6e4$var$instances : this.instances).indexOf(instance);
                (this.canUseDOM ? $448e9b7b3295f6e4$var$instances : this.instances).splice(index, 1);
            }
        }
    };
    constructor(context, canUseDOM){
        this.context = context;
        this.canUseDOM = canUseDOM || false;
        if (!canUseDOM) context.helmet = $448e9b7b3295f6e4$var$server_default({
            baseTag: [],
            bodyAttributes: {},
            encodeSpecialCharacters: true,
            htmlAttributes: {},
            linkTags: [],
            metaTags: [],
            noscriptTags: [],
            scriptTags: [],
            styleTags: [],
            title: "",
            titleAttributes: {}
        });
    }
};
var $448e9b7b3295f6e4$var$major = parseInt((0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).version.split(".")[0], 10);
var $448e9b7b3295f6e4$var$isReact19 = $448e9b7b3295f6e4$var$major >= 19;
// src/Provider.tsx
var $448e9b7b3295f6e4$var$defaultValue = {};
var $448e9b7b3295f6e4$var$Context = (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createContext($448e9b7b3295f6e4$var$defaultValue);
var $448e9b7b3295f6e4$export$4719288a8f5f7e71 = class _HelmetProvider extends (0, $5FkrB.Component) {
    static canUseDOM = $448e9b7b3295f6e4$var$isDocument;
    helmetData;
    constructor(props){
        super(props);
        if ($448e9b7b3295f6e4$var$isReact19) this.helmetData = null;
        else this.helmetData = new $448e9b7b3295f6e4$export$a9cf6990c9c7feb9(this.props.context || {}, _HelmetProvider.canUseDOM);
    }
    render() {
        if ($448e9b7b3295f6e4$var$isReact19) return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).Fragment, null, this.props.children);
        return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement($448e9b7b3295f6e4$var$Context.Provider, {
            value: this.helmetData.value
        }, this.props.children);
    }
};
// src/client.ts
var $448e9b7b3295f6e4$var$updateTags = (type, tags)=>{
    const headElement = document.head || document.querySelector("head" /* HEAD */ );
    const tagNodes = headElement.querySelectorAll(`${type}[${$448e9b7b3295f6e4$var$HELMET_ATTRIBUTE}]`);
    const oldTags = [].slice.call(tagNodes);
    const newTags = [];
    let indexToDelete;
    if (tags && tags.length) tags.forEach((tag)=>{
        const newElement = document.createElement(type);
        for(const attribute in tag)if (Object.prototype.hasOwnProperty.call(tag, attribute)) {
            if (attribute === "innerHTML" /* INNER_HTML */ ) newElement.innerHTML = tag.innerHTML;
            else if (attribute === "cssText" /* CSS_TEXT */ ) {
                const cssText = tag.cssText;
                newElement.appendChild(document.createTextNode(cssText));
            } else {
                const attr = attribute;
                const value = typeof tag[attr] === "undefined" ? "" : tag[attr];
                newElement.setAttribute(attribute, value);
            }
        }
        newElement.setAttribute($448e9b7b3295f6e4$var$HELMET_ATTRIBUTE, "true");
        if (oldTags.some((existingTag, index)=>{
            indexToDelete = index;
            return newElement.isEqualNode(existingTag);
        })) oldTags.splice(indexToDelete, 1);
        else newTags.push(newElement);
    });
    oldTags.forEach((tag)=>tag.parentNode?.removeChild(tag));
    newTags.forEach((tag)=>headElement.appendChild(tag));
    return {
        oldTags: oldTags,
        newTags: newTags
    };
};
var $448e9b7b3295f6e4$var$updateAttributes = (tagName, attributes)=>{
    const elementTag = document.getElementsByTagName(tagName)[0];
    if (!elementTag) return;
    const helmetAttributeString = elementTag.getAttribute($448e9b7b3295f6e4$var$HELMET_ATTRIBUTE);
    const helmetAttributes = helmetAttributeString ? helmetAttributeString.split(",") : [];
    const attributesToRemove = [
        ...helmetAttributes
    ];
    const attributeKeys = Object.keys(attributes);
    for (const attribute of attributeKeys){
        const value = attributes[attribute] || "";
        if (elementTag.getAttribute(attribute) !== value) elementTag.setAttribute(attribute, value);
        if (helmetAttributes.indexOf(attribute) === -1) helmetAttributes.push(attribute);
        const indexToSave = attributesToRemove.indexOf(attribute);
        if (indexToSave !== -1) attributesToRemove.splice(indexToSave, 1);
    }
    for(let i = attributesToRemove.length - 1; i >= 0; i -= 1)elementTag.removeAttribute(attributesToRemove[i]);
    if (helmetAttributes.length === attributesToRemove.length) elementTag.removeAttribute($448e9b7b3295f6e4$var$HELMET_ATTRIBUTE);
    else if (elementTag.getAttribute($448e9b7b3295f6e4$var$HELMET_ATTRIBUTE) !== attributeKeys.join(",")) elementTag.setAttribute($448e9b7b3295f6e4$var$HELMET_ATTRIBUTE, attributeKeys.join(","));
};
var $448e9b7b3295f6e4$var$updateTitle = (title, attributes)=>{
    if (typeof title !== "undefined" && document.title !== title) document.title = $448e9b7b3295f6e4$var$flattenArray(title);
    $448e9b7b3295f6e4$var$updateAttributes("title" /* TITLE */ , attributes);
};
var $448e9b7b3295f6e4$var$commitTagChanges = (newState, cb)=>{
    const { baseTag: baseTag, bodyAttributes: bodyAttributes, htmlAttributes: htmlAttributes, linkTags: linkTags, metaTags: metaTags, noscriptTags: noscriptTags, onChangeClientState: onChangeClientState, scriptTags: scriptTags, styleTags: styleTags, title: title, titleAttributes: titleAttributes } = newState;
    $448e9b7b3295f6e4$var$updateAttributes("body" /* BODY */ , bodyAttributes);
    $448e9b7b3295f6e4$var$updateAttributes("html" /* HTML */ , htmlAttributes);
    $448e9b7b3295f6e4$var$updateTitle(title, titleAttributes);
    const tagUpdates = {
        baseTag: $448e9b7b3295f6e4$var$updateTags("base" /* BASE */ , baseTag),
        linkTags: $448e9b7b3295f6e4$var$updateTags("link" /* LINK */ , linkTags),
        metaTags: $448e9b7b3295f6e4$var$updateTags("meta" /* META */ , metaTags),
        noscriptTags: $448e9b7b3295f6e4$var$updateTags("noscript" /* NOSCRIPT */ , noscriptTags),
        scriptTags: $448e9b7b3295f6e4$var$updateTags("script" /* SCRIPT */ , scriptTags),
        styleTags: $448e9b7b3295f6e4$var$updateTags("style" /* STYLE */ , styleTags)
    };
    const addedTags = {};
    const removedTags = {};
    Object.keys(tagUpdates).forEach((tagType)=>{
        const { newTags: newTags, oldTags: oldTags } = tagUpdates[tagType];
        if (newTags.length) addedTags[tagType] = newTags;
        if (oldTags.length) removedTags[tagType] = tagUpdates[tagType].oldTags;
    });
    if (cb) cb();
    onChangeClientState(newState, addedTags, removedTags);
};
var $448e9b7b3295f6e4$var$_helmetCallback = null;
var $448e9b7b3295f6e4$var$handleStateChangeOnClient = (newState)=>{
    if ($448e9b7b3295f6e4$var$_helmetCallback) cancelAnimationFrame($448e9b7b3295f6e4$var$_helmetCallback);
    if (newState.defer) $448e9b7b3295f6e4$var$_helmetCallback = requestAnimationFrame(()=>{
        $448e9b7b3295f6e4$var$commitTagChanges(newState, ()=>{
            $448e9b7b3295f6e4$var$_helmetCallback = null;
        });
    });
    else {
        $448e9b7b3295f6e4$var$commitTagChanges(newState);
        $448e9b7b3295f6e4$var$_helmetCallback = null;
    }
};
var $448e9b7b3295f6e4$var$client_default = $448e9b7b3295f6e4$var$handleStateChangeOnClient;
// src/Dispatcher.tsx
var $448e9b7b3295f6e4$var$HelmetDispatcher = class extends (0, $5FkrB.Component) {
    rendered = false;
    shouldComponentUpdate(nextProps) {
        return !(0, (/*@__PURE__*/$parcel$interopDefault($12b11248680fdff3$exports)))(nextProps, this.props);
    }
    componentDidUpdate() {
        this.emitChange();
    }
    componentWillUnmount() {
        const { helmetInstances: helmetInstances } = this.props.context;
        helmetInstances.remove(this);
        this.emitChange();
    }
    emitChange() {
        const { helmetInstances: helmetInstances, setHelmet: setHelmet } = this.props.context;
        let serverState = null;
        const state = $448e9b7b3295f6e4$var$reducePropsToState(helmetInstances.get().map((instance)=>{
            const { context: _context, ...props } = instance.props;
            return props;
        }));
        if ($448e9b7b3295f6e4$export$4719288a8f5f7e71.canUseDOM) $448e9b7b3295f6e4$var$client_default(state);
        else if ($448e9b7b3295f6e4$var$server_default) serverState = $448e9b7b3295f6e4$var$server_default(state);
        setHelmet(serverState);
    }
    // componentWillMount will be deprecated
    // for SSR, initialize on first render
    // constructor is also unsafe in StrictMode
    init() {
        if (this.rendered) return;
        this.rendered = true;
        const { helmetInstances: helmetInstances } = this.props.context;
        helmetInstances.add(this);
        this.emitChange();
    }
    render() {
        this.init();
        return null;
    }
};
var $448e9b7b3295f6e4$var$react19Instances = [];
var $448e9b7b3295f6e4$var$toHtmlAttributes = (props)=>{
    const result = {};
    for (const key of Object.keys(props))result[$448e9b7b3295f6e4$var$HTML_TAG_MAP[key] || key] = props[key];
    return result;
};
var $448e9b7b3295f6e4$var$toReactProps = (attrs)=>{
    const result = {};
    for (const key of Object.keys(attrs)){
        const mapped = $448e9b7b3295f6e4$var$REACT_TAG_MAP[key];
        result[mapped || key] = attrs[key];
    }
    return result;
};
var $448e9b7b3295f6e4$var$applyAttributes = (tagName, attributes)=>{
    if (!$448e9b7b3295f6e4$var$isDocument) return;
    const el = document.getElementsByTagName(tagName)[0];
    if (!el) return;
    const managedAttr = "data-rh-managed";
    const prev = el.getAttribute(managedAttr);
    const prevKeys = prev ? prev.split(",") : [];
    const nextKeys = Object.keys(attributes);
    for (const key of prevKeys)if (!nextKeys.includes(key)) el.removeAttribute(key);
    for (const key of nextKeys){
        const value = attributes[key];
        if (value === void 0 || value === null || value === false) el.removeAttribute(key);
        else if (value === true) el.setAttribute(key, "");
        else el.setAttribute(key, String(value));
    }
    if (nextKeys.length > 0) el.setAttribute(managedAttr, nextKeys.join(","));
    else el.removeAttribute(managedAttr);
};
var $448e9b7b3295f6e4$var$syncAllAttributes = ()=>{
    const htmlAttrs = {};
    const bodyAttrs = {};
    for (const instance of $448e9b7b3295f6e4$var$react19Instances){
        const { htmlAttributes: htmlAttributes, bodyAttributes: bodyAttributes } = instance.props;
        if (htmlAttributes) Object.assign(htmlAttrs, $448e9b7b3295f6e4$var$toHtmlAttributes(htmlAttributes));
        if (bodyAttributes) Object.assign(bodyAttrs, $448e9b7b3295f6e4$var$toHtmlAttributes(bodyAttributes));
    }
    $448e9b7b3295f6e4$var$applyAttributes("html" /* HTML */ , htmlAttrs);
    $448e9b7b3295f6e4$var$applyAttributes("body" /* BODY */ , bodyAttrs);
};
var $448e9b7b3295f6e4$var$React19Dispatcher = class extends (0, $5FkrB.Component) {
    componentDidMount() {
        $448e9b7b3295f6e4$var$react19Instances.push(this);
        $448e9b7b3295f6e4$var$syncAllAttributes();
    }
    componentDidUpdate() {
        $448e9b7b3295f6e4$var$syncAllAttributes();
    }
    componentWillUnmount() {
        const index = $448e9b7b3295f6e4$var$react19Instances.indexOf(this);
        if (index !== -1) $448e9b7b3295f6e4$var$react19Instances.splice(index, 1);
        $448e9b7b3295f6e4$var$syncAllAttributes();
    }
    resolveTitle() {
        const { title: title, titleTemplate: titleTemplate, defaultTitle: defaultTitle } = this.props;
        if (title && titleTemplate) return titleTemplate.replace(/%s/g, ()=>Array.isArray(title) ? title.join("") : title);
        return title || defaultTitle || void 0;
    }
    renderTitle() {
        const title = this.resolveTitle();
        if (title === void 0) return null;
        const titleAttributes = this.props.titleAttributes || {};
        return (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("title" /* TITLE */ , $448e9b7b3295f6e4$var$toReactProps(titleAttributes), title);
    }
    renderBase() {
        const { base: base } = this.props;
        if (!base) return null;
        return (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("base" /* BASE */ , $448e9b7b3295f6e4$var$toReactProps(base));
    }
    renderMeta() {
        const { meta: meta } = this.props;
        if (!meta || !Array.isArray(meta)) return null;
        return meta.map((attrs, i)=>(0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("meta" /* META */ , {
                key: i,
                ...$448e9b7b3295f6e4$var$toReactProps(attrs)
            }));
    }
    renderLink() {
        const { link: link } = this.props;
        if (!link || !Array.isArray(link)) return null;
        return link.map((attrs, i)=>(0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("link" /* LINK */ , {
                key: i,
                ...$448e9b7b3295f6e4$var$toReactProps(attrs)
            }));
    }
    renderScript() {
        const { script: script } = this.props;
        if (!script || !Array.isArray(script)) return null;
        return script.map((attrs, i)=>{
            const { innerHTML: innerHTML, ...rest } = attrs;
            const props = $448e9b7b3295f6e4$var$toReactProps(rest);
            if (innerHTML) props.dangerouslySetInnerHTML = {
                __html: innerHTML
            };
            return (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("script" /* SCRIPT */ , {
                key: i,
                ...props
            });
        });
    }
    renderStyle() {
        const { style: style } = this.props;
        if (!style || !Array.isArray(style)) return null;
        return style.map((attrs, i)=>{
            const { cssText: cssText, ...rest } = attrs;
            const props = $448e9b7b3295f6e4$var$toReactProps(rest);
            if (cssText) props.dangerouslySetInnerHTML = {
                __html: cssText
            };
            return (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("style" /* STYLE */ , {
                key: i,
                ...props
            });
        });
    }
    renderNoscript() {
        const { noscript: noscript } = this.props;
        if (!noscript || !Array.isArray(noscript)) return null;
        return noscript.map((attrs, i)=>{
            const { innerHTML: innerHTML, ...rest } = attrs;
            const props = $448e9b7b3295f6e4$var$toReactProps(rest);
            if (innerHTML) props.dangerouslySetInnerHTML = {
                __html: innerHTML
            };
            return (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("noscript" /* NOSCRIPT */ , {
                key: i,
                ...props
            });
        });
    }
    render() {
        return (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).Fragment, null, this.renderTitle(), this.renderBase(), this.renderMeta(), this.renderLink(), this.renderScript(), this.renderStyle(), this.renderNoscript());
    }
};
// src/index.tsx
var $448e9b7b3295f6e4$export$dcef8f9bb9a41431 = class extends (0, $5FkrB.Component) {
    static defaultProps = {
        defer: true,
        encodeSpecialCharacters: true,
        prioritizeSeoTags: false
    };
    shouldComponentUpdate(nextProps) {
        return !(0, (/*@__PURE__*/$parcel$interopDefault($dcrmD)))($448e9b7b3295f6e4$var$without(this.props, "helmetData"), $448e9b7b3295f6e4$var$without(nextProps, "helmetData"));
    }
    mapNestedChildrenToProps(child, nestedChildren) {
        if (!nestedChildren) return null;
        switch(child.type){
            case "script" /* SCRIPT */ :
            case "noscript" /* NOSCRIPT */ :
                return {
                    innerHTML: nestedChildren
                };
            case "style" /* STYLE */ :
                return {
                    cssText: nestedChildren
                };
            default:
                throw new Error(`<${child.type} /> elements are self-closing and can not contain children. Refer to our API for more information.`);
        }
    }
    flattenArrayTypeChildren(child, arrayTypeChildren, newChildProps, nestedChildren) {
        return {
            ...arrayTypeChildren,
            [child.type]: [
                ...arrayTypeChildren[child.type] || [],
                {
                    ...newChildProps,
                    ...this.mapNestedChildrenToProps(child, nestedChildren)
                }
            ]
        };
    }
    mapObjectTypeChildren(child, newProps, newChildProps, nestedChildren) {
        switch(child.type){
            case "title" /* TITLE */ :
                return {
                    ...newProps,
                    [child.type]: nestedChildren,
                    titleAttributes: {
                        ...newChildProps
                    }
                };
            case "body" /* BODY */ :
                return {
                    ...newProps,
                    bodyAttributes: {
                        ...newChildProps
                    }
                };
            case "html" /* HTML */ :
                return {
                    ...newProps,
                    htmlAttributes: {
                        ...newChildProps
                    }
                };
            default:
                return {
                    ...newProps,
                    [child.type]: {
                        ...newChildProps
                    }
                };
        }
    }
    mapArrayTypeChildrenToProps(arrayTypeChildren, newProps) {
        let newFlattenedProps = {
            ...newProps
        };
        Object.keys(arrayTypeChildren).forEach((arrayChildName)=>{
            newFlattenedProps = {
                ...newFlattenedProps,
                [arrayChildName]: arrayTypeChildren[arrayChildName]
            };
        });
        return newFlattenedProps;
    }
    warnOnInvalidChildren(child, nestedChildren) {
        (0, (/*@__PURE__*/$parcel$interopDefault($jSI6G)))($448e9b7b3295f6e4$var$VALID_TAG_NAMES.some((name)=>child.type === name), typeof child.type === "function" ? `You may be attempting to nest <Helmet> components within each other, which is not allowed. Refer to our API for more information.` : `Only elements types ${$448e9b7b3295f6e4$var$VALID_TAG_NAMES.join(", ")} are allowed. Helmet does not support rendering <${child.type}> elements. Refer to our API for more information.`);
        (0, (/*@__PURE__*/$parcel$interopDefault($jSI6G)))(!nestedChildren || typeof nestedChildren === "string" || Array.isArray(nestedChildren) && !nestedChildren.some((nestedChild)=>typeof nestedChild !== "string"), `Helmet expects a string as a child of <${child.type}>. Did you forget to wrap your children in braces? ( <${child.type}>{\`\`}</${child.type}> ) Refer to our API for more information.`);
        return true;
    }
    mapChildrenToProps(children, newProps) {
        let arrayTypeChildren = {};
        (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).Children.forEach(children, (child)=>{
            if (!child || !child.props) return;
            const { children: nestedChildren, ...childProps } = child.props;
            const newChildProps = Object.keys(childProps).reduce((obj, key)=>{
                obj[$448e9b7b3295f6e4$var$HTML_TAG_MAP[key] || key] = childProps[key];
                return obj;
            }, {});
            let { type: type } = child;
            if (typeof type === "symbol") type = type.toString();
            else this.warnOnInvalidChildren(child, nestedChildren);
            switch(type){
                case "Symbol(react.fragment)" /* FRAGMENT */ :
                    newProps = this.mapChildrenToProps(nestedChildren, newProps);
                    break;
                case "link" /* LINK */ :
                case "meta" /* META */ :
                case "noscript" /* NOSCRIPT */ :
                case "script" /* SCRIPT */ :
                case "style" /* STYLE */ :
                    arrayTypeChildren = this.flattenArrayTypeChildren(child, arrayTypeChildren, newChildProps, nestedChildren);
                    break;
                default:
                    newProps = this.mapObjectTypeChildren(child, newProps, newChildProps, nestedChildren);
                    break;
            }
        });
        return this.mapArrayTypeChildrenToProps(arrayTypeChildren, newProps);
    }
    render() {
        const { children: children, ...props } = this.props;
        let newProps = {
            ...props
        };
        let { helmetData: helmetData } = props;
        if (children) newProps = this.mapChildrenToProps(children, newProps);
        if (helmetData && !(helmetData instanceof $448e9b7b3295f6e4$export$a9cf6990c9c7feb9)) {
            const data = helmetData;
            helmetData = new $448e9b7b3295f6e4$export$a9cf6990c9c7feb9(data.context, true);
            delete newProps.helmetData;
        }
        if ($448e9b7b3295f6e4$var$isReact19) return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement($448e9b7b3295f6e4$var$React19Dispatcher, {
            ...newProps
        });
        return helmetData ? /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement($448e9b7b3295f6e4$var$HelmetDispatcher, {
            ...newProps,
            context: helmetData.value
        }) : /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement($448e9b7b3295f6e4$var$Context.Consumer, null, (context)=>/* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement($448e9b7b3295f6e4$var$HelmetDispatcher, {
                ...newProps,
                context: context
            }));
    }
};




var $fC8ib = parcelRequire("fC8ib");

var $5FkrB = parcelRequire("5FkrB");

var $74Zh5 = parcelRequire("74Zh5");


var $c8dbef6c41cfa689$var$flexGrowMap = {
    hug: (0, $c1bec583fa49072f$export$f6c783d06584602c)({
        flexGrow: 0
    }),
    fill: (0, $c1bec583fa49072f$export$f6c783d06584602c)({
        width: '100%',
        flexGrow: 1
    })
};
/**
 * __Stack__
 *
 * Stack is a primitive component based on flexbox that manages the block layout of direct children.
 *
 * @example
 * ```tsx
 *  <Stack>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *  </Stack>
 * ```
 *
 */ var $c8dbef6c41cfa689$var$Stack = /*#__PURE__*/ (0, $5FkrB.memo)(/*#__PURE__*/ (0, $5FkrB.forwardRef)(function(_ref, ref) {
    var as = _ref.as, alignItems = _ref.alignInline, _ref$alignBlock = _ref.alignBlock, alignBlock = _ref$alignBlock === void 0 ? 'stretch' : _ref$alignBlock, spread = _ref.spread, grow = _ref.grow, space = _ref.space, children = _ref.children, testId = _ref.testId, xcss = _ref.xcss, role = _ref.role, id = _ref.id;
    var justifyContent = spread || alignBlock;
    // We're type coercing this as Compiled styles in an array isn't supported by the types
    // But the runtime accepts it none-the-wiser. We can remove this entire block and replace
    // it with cx(defaultStyles, focusRingStyles, xcssStyles) when we've moved away from Emotion.
    var styles = grow ? [
        $c8dbef6c41cfa689$var$flexGrowMap[grow]
    ].concat((0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(Array.isArray(xcss) ? xcss : [
        xcss
    ])) : xcss;
    return (0, $74Zh5.jsx)((0, $1b254ba6a068f2f1$export$2e2bcd8739ae039), {
        id: id,
        as: as,
        role: role,
        gap: space,
        direction: "column",
        alignItems: alignItems,
        justifyContent: justifyContent,
        xcss: styles,
        testId: testId,
        ref: ref
    }, children);
}));
$c8dbef6c41cfa689$var$Stack.displayName = 'Stack';
var $c8dbef6c41cfa689$export$2e2bcd8739ae039 = $c8dbef6c41cfa689$var$Stack;

/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5FkrB = parcelRequire("5FkrB");

var $74Zh5 = parcelRequire("74Zh5");

var $afMOk = parcelRequire("afMOk");

var $5FkrB = parcelRequire("5FkrB");
var $5f141e5f4d88626f$var$HasTextAncestorContext = /*#__PURE__*/ (0, $5FkrB.createContext)(false);
var $5f141e5f4d88626f$export$9322276ec105d055 = function useHasTextAncestor() {
    return (0, $5FkrB.useContext)($5f141e5f4d88626f$var$HasTextAncestorContext);
};
var $5f141e5f4d88626f$export$ae933c6cbe5643ad = $5f141e5f4d88626f$var$HasTextAncestorContext.Provider;




var $d48daa9a522ca942$var$asAllowlist = [
    'span',
    'p',
    'strong',
    'em'
];
// We're doing this because our CSS reset can add top margins to elements such as `p` which is totally insane.
// Long term we should remove those instances from the reset - it should be a reset to 0.
// For now, at least we know <Text> will be unaffected by this.
var $d48daa9a522ca942$var$resetStyles = (0, $74Zh5.css)({
    margin: 0,
    overflowWrap: 'anywhere'
});
var $d48daa9a522ca942$var$strongStyles = (0, $74Zh5.css)({
    fontWeight: "var(--ds-font-weight-bold, 653)"
});
var $d48daa9a522ca942$var$emStyles = (0, $74Zh5.css)({
    fontStyle: 'italic'
});
var $d48daa9a522ca942$var$textAlignMap = {
    center: (0, $74Zh5.css)({
        textAlign: 'center'
    }),
    end: (0, $74Zh5.css)({
        textAlign: 'end'
    }),
    start: (0, $74Zh5.css)({
        textAlign: 'start'
    })
};
var $d48daa9a522ca942$var$truncationStyles = (0, $74Zh5.css)({
    display: '-webkit-box',
    overflow: 'hidden',
    WebkitBoxOrient: 'vertical'
});
var $d48daa9a522ca942$var$wordBreakMap = {
    breakAll: (0, $74Zh5.css)({
        wordBreak: 'break-all'
    })
};
/**
 * Custom hook designed to abstract the parsing of the color props and make it clearer in the future how color is reconciled between themes and tokens.
 */ var $d48daa9a522ca942$var$useColor = function useColor(colorProp, hasTextAncestor) {
    var surface = (0, $6aab085817c2aae8$export$1aeb4f6b93c4540d)();
    if (colorProp === 'inherit') return undefined;
    if (colorProp) return colorProp;
    if (hasTextAncestor) return undefined;
    if ((0, $e955727b9ac9b5b6$export$2185ce37f9bdd963).hasOwnProperty(surface)) return (0, $e955727b9ac9b5b6$export$2185ce37f9bdd963)[surface];
    return 'color.text';
};
/**
 * __Text__
 *
 * Text is a primitive component that has the Atlassian Design System's design guidelines baked in.
 * This includes considerations for text attributes such as color, font size, font weight, and line height.
 * It renders a `span` by default.
 *
 * @internal
 */ var $d48daa9a522ca942$var$Text = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? 'span' : _ref$as, colorProp = _ref.color, align = _ref.align, testId = _ref.testId, id = _ref.id, size = _ref.size, weight = _ref.weight, maxLines = _ref.maxLines, children = _ref.children;
    (0, $afMOk.default)($d48daa9a522ca942$var$asAllowlist.includes(Component), "@atlaskit/primitives: Text received an invalid \"as\" value of \"".concat(Component, "\""));
    var hasTextAncestor = (0, $5f141e5f4d88626f$export$9322276ec105d055)();
    var color = $d48daa9a522ca942$var$useColor(colorProp, hasTextAncestor);
    if (!size && !hasTextAncestor) size = 'medium';
    var component = (0, $74Zh5.jsx)(Component, {
        ref: ref,
        css: [
            $d48daa9a522ca942$var$resetStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            size && (0, $e955727b9ac9b5b6$export$219d364c0da35ae4)[size],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            color && (0, $e955727b9ac9b5b6$export$3a1bcba60b23d7f0)[color],
            maxLines && $d48daa9a522ca942$var$truncationStyles,
            maxLines === 1 && $d48daa9a522ca942$var$wordBreakMap.breakAll,
            align && $d48daa9a522ca942$var$textAlignMap[align],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            weight && (0, $e955727b9ac9b5b6$export$38845ca010b93505)[weight],
            Component === 'em' && $d48daa9a522ca942$var$emStyles,
            Component === 'strong' && $d48daa9a522ca942$var$strongStyles
        ],
        style: {
            WebkitLineClamp: maxLines
        },
        "data-testid": testId,
        id: id
    }, children);
    return hasTextAncestor ? // no need to re-apply context if the text is already wrapped
    component : (0, $74Zh5.jsx)((0, $5f141e5f4d88626f$export$ae933c6cbe5643ad), {
        value: true
    }, component);
});
var $d48daa9a522ca942$export$2e2bcd8739ae039 = $d48daa9a522ca942$var$Text;



var $bb0Oq = parcelRequire("bb0Oq");
/* tabs.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $25nEq = parcelRequire("25nEq");
var $1e638cafe0c7118a$exports = {};

var $4rHdx = parcelRequire("4rHdx");

var $2XfV2 = parcelRequire("2XfV2");

var $ccaOk = parcelRequire("ccaOk");

var $lzFPZ = parcelRequire("lzFPZ");
function $1e638cafe0c7118a$var$_toArray(r) {
    return $4rHdx(r) || $2XfV2(r) || $ccaOk(r) || $lzFPZ();
}
$1e638cafe0c7118a$exports = $1e638cafe0c7118a$var$_toArray, $1e638cafe0c7118a$exports.__esModule = true, $1e638cafe0c7118a$exports["default"] = $1e638cafe0c7118a$exports;



var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");
/**
 * This length includes the underscore,
 * e.g. `"_1s4A"` would be a valid atomic group hash.
 */ const $ef5895cebbb13c02$var$ATOMIC_GROUP_LENGTH = 5;
function $ef5895cebbb13c02$export$2e2bcd8739ae039(classNames) {
    // Shortcut: nothing to do
    if (!classNames.length) return;
    // Shortcut: don't need to do anything if we only have a single classname
    if (classNames.length === 1 && classNames[0] && // checking to see if `classNames[0]` is a string that contains other classnames
    !classNames[0].includes(' ')) return classNames[0];
    // Using an object rather than a `Map` as it performed better in our benchmarks.
    // Would be happy to move to `Map` if it proved to be better under real conditions.
    const map = {};
    // Note: using loops to minimize iterations over the collection
    for (const value of classNames){
        // Exclude all falsy values, which leaves us with populated strings
        if (!value) continue;
        // a `value` can contain multiple classnames
        const list = value.split(' ');
        for (const className of list){
            /**
             * For atomic style classnames: the `key` is the `group`
             *
             * - Later atomic classnames with the same `group` will override earlier ones
             *   (which is what we want).
             * - Assumes atomic classnames are the only things that start with `_`
             * - Could use a regex to ensure that atomic classnames are structured how we expect,
             *   but did not add that for now as it did slow things down a bit.
             *
             * For other classnames: the `key` is the whole classname
             * - Okay to remove duplicates as doing so does not impact specificity
             *
             * */ const key = className.startsWith('_') ? className.slice(0, $ef5895cebbb13c02$var$ATOMIC_GROUP_LENGTH) : className;
            map[key] = className;
        }
    }
    /**
     * We are converting the `map` into a string.
     *
     * The simple way to do this would be `Object.values(map).join(' ')`.
     * However, the approach below performs 10%-20% better in benchmarks.
     *
     * For `ax()` it feels right to squeeze as much runtime performance out as we can.
     */ let result = '';
    for(const key in map)result += map[key] + ' ';
    // If we have an empty string, then our `map` was empty.
    if (!result) return;
    // remove last " " from the result (we added " " at the end of every value)
    return result.trimEnd();
}



var $25nEq = parcelRequire("25nEq");

var $5FkrB = parcelRequire("5FkrB");

var $dLGML = parcelRequire("dLGML");

var $fC8ib = parcelRequire("fC8ib");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $kIXpt = parcelRequire("kIXpt");

var $cYPzS = parcelRequire("cYPzS");

var $lwlXp = parcelRequire("lwlXp");

var $eyuDe = parcelRequire("eyuDe");

var $25nEq = parcelRequire("25nEq");

var $ekGgq = parcelRequire("ekGgq");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $25nEq = parcelRequire("25nEq");
function $d66ac9a63e6855e6$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $d66ac9a63e6855e6$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $d66ac9a63e6855e6$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $d66ac9a63e6855e6$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $d66ac9a63e6855e6$export$ad4be5c2ec28cecf = function isAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $d66ac9a63e6855e6$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === 'AnalyticsEvent';
};
var $d66ac9a63e6855e6$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function AnalyticsEvent(props) {
        var _this = this;
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, AnalyticsEvent);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "_isAnalyticsEvent", true);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "clone", function() {
            // just a shallow clone, don't change sub refs unless you want to
            // affect the original's too
            var payload = $d66ac9a63e6855e6$var$_objectSpread({}, _this.payload);
            return new AnalyticsEvent({
                payload: payload
            });
        });
        this.payload = props.payload;
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(AnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (typeof updater === 'function') this.payload = updater(this.payload);
                if ((0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(updater) === 'object') this.payload = $d66ac9a63e6855e6$var$_objectSpread($d66ac9a63e6855e6$var$_objectSpread({}, this.payload), updater);
                return this;
            }
        }
    ]);
}();


function $ceb7c3b8f4a239f0$var$_callSuper(t, o, e) {
    return o = (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(o), (0, (/*@__PURE__*/$parcel$interopDefault($kIXpt)))(t, $ceb7c3b8f4a239f0$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(t).constructor) : o.apply(t, e));
}
function $ceb7c3b8f4a239f0$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($ceb7c3b8f4a239f0$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $ceb7c3b8f4a239f0$var$_superPropGet(t, o, e, r) {
    var p = (0, (/*@__PURE__*/$parcel$interopDefault($lwlXp)))((0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(1 & r ? t.prototype : t), o, e);
    return 2 & r && "function" == typeof p ? function(t) {
        return p.apply(e, t);
    } : p;
}
var $ceb7c3b8f4a239f0$export$35f8383928ba8d7 = function isUIAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $ceb7c3b8f4a239f0$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isUIAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === 'UIAnalyticsEvent';
};
var $ceb7c3b8f4a239f0$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_AnalyticsEvent) {
    function UIAnalyticsEvent(props) {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, UIAnalyticsEvent);
        _this = $ceb7c3b8f4a239f0$var$_callSuper(this, UIAnalyticsEvent, [
            props
        ]);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "_isUIAnalyticsEvent", true);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "clone", function() {
            if (_this.hasFired) return null;
            var context = (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(_this.context);
            var handlers = (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(_this.handlers);
            /**
       * A hacky "deep clone" of the object. This is limited in that it wont
       * support functions, regexs, Maps, Sets, etc, but none of those need to
       * be represented in our payload.
       */ var payload = JSON.parse(JSON.stringify(_this.payload));
            return new UIAnalyticsEvent({
                context: context,
                handlers: handlers,
                payload: payload
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "fire", function(channel) {
            if (_this.hasFired) return;
            _this.handlers.forEach(function(handler) {
                return handler(_this, channel);
            });
            _this.hasFired = true;
        });
        _this.context = props.context || [];
        _this.handlers = props.handlers || [];
        _this.hasFired = false;
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($eyuDe)))(UIAnalyticsEvent, _AnalyticsEvent);
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(UIAnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (this.hasFired) return this;
                return $ceb7c3b8f4a239f0$var$_superPropGet(UIAnalyticsEvent, "update", this, 3)([
                    updater
                ]);
            }
        }
    ]);
}((0, $d66ac9a63e6855e6$export$2e2bcd8739ae039));



var $5FkrB = parcelRequire("5FkrB");

var $iyyOp = parcelRequire("iyyOp");
var $28992e84b84c5d72$export$d1f587f82ad51c4 = function useAnalyticsContext() {
    return (0, $5FkrB.useContext)((0, $iyyOp.default));
};


function $4d2d9c691a63ac85$export$5bf35293e545f20c() {
    var analyticsContext = (0, $28992e84b84c5d72$export$d1f587f82ad51c4)();
    var createAnalyticsEvent = (0, $dLGML.useCallbackOne)(function(payload) {
        return new (0, $ceb7c3b8f4a239f0$export$2e2bcd8739ae039)({
            context: analyticsContext.getAtlaskitAnalyticsContext(),
            handlers: analyticsContext.getAtlaskitAnalyticsEventHandlers(),
            payload: payload
        });
    }, [
        analyticsContext
    ]);
    return {
        createAnalyticsEvent: createAnalyticsEvent
    };
}



var $5FkrB = parcelRequire("5FkrB");
var $3fccc81f2be12d3f$export$1d27a74659855e44 = function useTrackedRef(value) {
    var ref = (0, $5FkrB.useRef)(value);
    ref.current = value;
    return ref;
};


function $28dd7960e0e7bf3b$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $28dd7960e0e7bf3b$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $28dd7960e0e7bf3b$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $28dd7960e0e7bf3b$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $28dd7960e0e7bf3b$export$a4687b0234b40e28(_ref) {
    var fn = _ref.fn, action = _ref.action, componentName = _ref.componentName, actionSubject = _ref.actionSubject, packageName = _ref.packageName, packageVersion = _ref.packageVersion, analyticsData = _ref.analyticsData;
    var _useAnalyticsEvents = (0, $4d2d9c691a63ac85$export$5bf35293e545f20c)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
    // We put analyticsData and fn in a ref so that we don't need to break
    // memoization.
    // Generally these could be defined by consumers inline
    // and so we do this to avoid breaking memoization of useCallback
    var dataRef = (0, $3fccc81f2be12d3f$export$1d27a74659855e44)(analyticsData);
    var fnRef = (0, $3fccc81f2be12d3f$export$1d27a74659855e44)(fn);
    var handler = (0, $5FkrB.useCallback)(function(value) {
        var analyticsEvent = createAnalyticsEvent({
            action: action,
            actionSubject: actionSubject || componentName,
            attributes: {
                componentName: componentName,
                packageName: packageName,
                packageVersion: packageVersion
            }
        });
        // To avoid wrapping this component in AnalyticsContext we manually
        // push the parent context's meta data into the context.
        // Note: this new 'context'
        var context = $28dd7960e0e7bf3b$var$_objectSpread({
            componentName: componentName,
            packageName: packageName,
            packageVersion: packageVersion
        }, dataRef.current);
        analyticsEvent.context.push(context);
        // fire an event on the atlaskit channel
        var clone = analyticsEvent.clone();
        if (clone) clone.fire('atlaskit');
        fnRef.current(value, analyticsEvent);
    }, [
        // These are strings and won't change
        action,
        componentName,
        actionSubject,
        packageName,
        packageVersion,
        // This function is memoized in the context
        createAnalyticsEvent,
        // these are a stable ref because of the useTrackedRef hook
        dataRef,
        fnRef
    ]);
    return handler;
}


/* eslint-disable @repo/internal/react/require-jsdoc */ 
var $5FkrB = parcelRequire("5FkrB");
var $1b23a6d8f9b96f86$export$aa6907f9fd69e93b = /*#__PURE__*/ (0, $5FkrB.createContext)(null);


/* eslint-disable @repo/internal/react/require-jsdoc */ 
var $5FkrB = parcelRequire("5FkrB");
var $105b2b73664cf5fe$export$2054129d247c3102 = /*#__PURE__*/ (0, $5FkrB.createContext)(null);


function $f4929bb9d46c4aaa$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $f4929bb9d46c4aaa$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $f4929bb9d46c4aaa$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $f4929bb9d46c4aaa$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $f4929bb9d46c4aaa$var$baseStyles = null;
var $f4929bb9d46c4aaa$var$tabsStyles = null;
var $f4929bb9d46c4aaa$var$analyticsAttributes = {
    componentName: 'tabs',
    packageName: "@atlaskit/tabs",
    packageVersion: "0.0.0-development"
};
var $f4929bb9d46c4aaa$var$getTabPanelWithContext = function getTabPanelWithContext(_ref) {
    var tabPanel = _ref.tabPanel, index = _ref.index, isSelected = _ref.isSelected, tabsId = _ref.tabsId;
    return(// Ensure tabPanel exists in case it has been removed
    tabPanel && /*#__PURE__*/ $5FkrB.createElement((0, $105b2b73664cf5fe$export$2054129d247c3102).Provider, {
        value: {
            role: 'tabpanel',
            id: "".concat(tabsId, "-").concat(index, "-tab"),
            hidden: isSelected ? undefined : true,
            'aria-labelledby': "".concat(tabsId, "-").concat(index),
            tabIndex: isSelected ? 0 : -1
        },
        key: index
    }, tabPanel));
};
/**
 * __Tabs__
 *
 * Tabs acts as a container for all Tab components.
 *
 * - [Examples](https://atlassian.design/components/tabs/examples)
 * - [Code](https://atlassian.design/components/tabs/code)
 * - [Usage](https://atlassian.design/components/tabs/usage)
 */ var $f4929bb9d46c4aaa$var$Tabs = function Tabs(props) {
    var _props$shouldUnmountT = props.shouldUnmountTabPanelOnChange, shouldUnmountTabPanelOnChange = _props$shouldUnmountT === void 0 ? false : _props$shouldUnmountT, SelectedType = props.selected, defaultSelected = props.defaultSelected, onChangeProp = props.onChange, id = props.id, analyticsContext = props.analyticsContext, children = props.children, testId = props.testId;
    var _useState = (0, $5FkrB.useState)(SelectedType || defaultSelected || 0), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), selectedState = _useState2[0], setSelected = _useState2[1];
    var selected = SelectedType === undefined ? selectedState : SelectedType;
    var childrenArray = (0, $5FkrB.Children).toArray(children)// Don't include any conditional children
    .filter(function(child) {
        return Boolean(child);
    });
    // First child should be a tabList followed by tab panels
    var _childrenArray = (0, (/*@__PURE__*/$parcel$interopDefault($1e638cafe0c7118a$exports)))(childrenArray), tabList = _childrenArray[0], tabPanels = _childrenArray.slice(1);
    // Keep track of visited and add to a set
    var visited = (0, $5FkrB.useRef)(new Set([
        selected
    ]));
    if (!visited.current.has(selected)) visited.current.add(selected);
    var onChange = (0, $5FkrB.useCallback)(function(index, analyticsEvent) {
        if (onChangeProp) onChangeProp(index, analyticsEvent);
        setSelected(index);
    }, [
        onChangeProp
    ]);
    var onChangeAnalytics = (0, $28dd7960e0e7bf3b$export$a4687b0234b40e28)($f4929bb9d46c4aaa$var$_objectSpread({
        fn: onChange,
        action: 'clicked',
        analyticsData: analyticsContext
    }, $f4929bb9d46c4aaa$var$analyticsAttributes));
    var tabPanelsWithContext = shouldUnmountTabPanelOnChange ? $f4929bb9d46c4aaa$var$getTabPanelWithContext({
        tabPanel: tabPanels[selected],
        index: selected,
        isSelected: true,
        tabsId: id
    }) : // If a panel has already been visited, don't unmount it
    Array.from(visited.current).map(function(tabIndex) {
        return $f4929bb9d46c4aaa$var$getTabPanelWithContext({
            tabPanel: tabPanels[tabIndex],
            index: tabIndex,
            isSelected: tabIndex === selected,
            tabsId: id
        });
    });
    return /*#__PURE__*/ $5FkrB.createElement("div", {
        "data-testid": testId,
        className: (0, $ef5895cebbb13c02$export$2e2bcd8739ae039)([
            "_1e0c1txw _p12f1osq _1tkeidpf _i0dl1osq _2lx21bp4 _16jlkb7n",
            "_1c3y1txw _ftfaidpf _18i0kb7n _185bglyw"
        ])
    }, /*#__PURE__*/ $5FkrB.createElement((0, $1b23a6d8f9b96f86$export$aa6907f9fd69e93b).Provider, {
        value: {
            selected: selected,
            onChange: onChangeAnalytics,
            tabsId: id
        }
    }, tabList), /*#__PURE__*/ $5FkrB.createElement((0, $5FkrB.Fragment), null, tabPanelsWithContext));
};
var $f4929bb9d46c4aaa$export$2e2bcd8739ae039 = $f4929bb9d46c4aaa$var$Tabs;


var $5FkrB = parcelRequire("5FkrB");
/* focusable.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $kqp0i = parcelRequire("kqp0i");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");

var $e70776888036db59$var$_excluded = [
    "as",
    "children",
    "isInset",
    "testId",
    "style",
    "xcss"
], $e70776888036db59$var$_excluded2 = [
    "className"
];
var $e70776888036db59$var$focusRingStyles = null;
var $e70776888036db59$var$insetFocusRingStyles = null;
/**
 * __Focus ring__
 *
 * A focus ring visually indicates the currently focused item.
 *
 */ var $e70776888036db59$var$Focusable = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? 'button' : _ref$as, children = _ref.children, isInset = _ref.isInset, testId = _ref.testId, style = _ref.style, xcss = _ref.xcss, htmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $e70776888036db59$var$_excluded);
    // This is to remove className from safeHtmlAttributes
    // @ts-ignore -- not using expect since it causes issues with help-center local consumption - className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(htmlAttributes, $e70776888036db59$var$_excluded2);
    return /*#__PURE__*/ $5FkrB.createElement(Component, (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, safeHtmlAttributes, {
        // @ts-ignore Expression produces a union type that is too complex to represent. We may be able to narrow the type here but unsure.
        ref: ref,
        className: (0, $ef5895cebbb13c02$export$2e2bcd8739ae039)([
            "_ymio1r31 _ypr0glyw _zcxs1o36 _mizu194a _1ah3dkaa _ra3xnqa1 _128mdkaa _1cvmnqa1 _4davt94y",
            isInset && "_1ah31gjf _2mwq1gjf",
            xcss
        ]),
        style: style,
        "data-testid": testId
    }), children);
});
var $e70776888036db59$export$2e2bcd8739ae039 = $e70776888036db59$var$Focusable;

/* text.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $5FkrB = parcelRequire("5FkrB");


var $afMOk = parcelRequire("afMOk");

var $5FkrB = parcelRequire("5FkrB");
var $4f9ce98fa74be29b$var$HasTextAncestorContext = /*#__PURE__*/ (0, $5FkrB.createContext)(false);
var $4f9ce98fa74be29b$export$9322276ec105d055 = function useHasTextAncestor() {
    return (0, $5FkrB.useContext)($4f9ce98fa74be29b$var$HasTextAncestorContext);
};
var $4f9ce98fa74be29b$export$ae933c6cbe5643ad = $4f9ce98fa74be29b$var$HasTextAncestorContext.Provider;



var $5FkrB = parcelRequire("5FkrB");
var $f6218f2de609f61e$export$1ca2a26fecb070ae = /*#__PURE__*/ (0, $5FkrB.createContext)('elevation.surface');
var $f6218f2de609f61e$export$1aeb4f6b93c4540d = function useSurface() {
    return (0, $5FkrB.useContext)($f6218f2de609f61e$export$1ca2a26fecb070ae);
};
$f6218f2de609f61e$export$1ca2a26fecb070ae.displayName = 'SurfaceProvider';


var $57ba788fdac691c2$var$asAllowlist = [
    'span',
    'p',
    'strong',
    'em'
];
/**
 * Custom hook designed to abstract the parsing of the color props and make it clearer in the future how color is reconciled between themes and tokens.
 */ var $57ba788fdac691c2$var$useColor = function useColor(colorProp, hasTextAncestor) {
    var surface = (0, $f6218f2de609f61e$export$1aeb4f6b93c4540d)();
    if (colorProp === 'inherit') return undefined;
    if (colorProp) return colorProp;
    if (hasTextAncestor) return undefined;
    if ($57ba788fdac691c2$export$2185ce37f9bdd963.hasOwnProperty(surface)) return $57ba788fdac691c2$export$2185ce37f9bdd963[surface];
    return 'color.text';
};
var $57ba788fdac691c2$var$styles = {
    root: "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _1i4qfg65",
    'as.strong': "_k48pwu06",
    'as.em': "_zg8l1m30",
    'textAlign.center': "_y3gn1h6o",
    'textAlign.end': "_y3gnh9n0",
    'textAlign.start': "_y3gnv2br",
    truncation: "_1reo15vq _18m915vq _1e0ccj1k _sudp1e54",
    breakAll: "_1nmz9jpi"
};
var $57ba788fdac691c2$var$fontSizeMap = {
    medium: "_11c8fhey",
    UNSAFE_small: "_11c8rymc",
    large: "_11c81d4k",
    small: "_11c8wadc"
};
var $57ba788fdac691c2$var$fontWeightMap = {
    bold: "_k48pwu06",
    medium: "_k48p1wq8",
    regular: "_k48pi7a9",
    semibold: "_k48p1pd9"
};
var $57ba788fdac691c2$var$textColorMap = {
    'color.text': "_syazi7uo",
    'color.text.accent.lime': "_syaz1tco",
    'color.text.accent.lime.bolder': "_syaz1ik3",
    'color.text.accent.red': "_syaz9lu1",
    'color.text.accent.red.bolder': "_syazhwvp",
    'color.text.accent.orange': "_syazp1lv",
    'color.text.accent.orange.bolder': "_syaz7i1p",
    'color.text.accent.yellow': "_syazfb2s",
    'color.text.accent.yellow.bolder': "_syazekll",
    'color.text.accent.green': "_syazh55r",
    'color.text.accent.green.bolder': "_syaz1y78",
    'color.text.accent.teal': "_syaz17qg",
    'color.text.accent.teal.bolder': "_syaz12v7",
    'color.text.accent.blue': "_syaz16jw",
    'color.text.accent.blue.bolder': "_syaz1kyx",
    'color.text.accent.purple': "_syazqmo9",
    'color.text.accent.purple.bolder': "_syaz1mn1",
    'color.text.accent.magenta': "_syaz1s8m",
    'color.text.accent.magenta.bolder': "_syaz1qur",
    'color.text.accent.gray': "_syaz1sqi",
    'color.text.accent.gray.bolder': "_syaz1tmo",
    'color.text.disabled': "_syaz1gmx",
    'color.text.inverse': "_syaz15cr",
    'color.text.selected': "_syaz6x5g",
    'color.text.brand': "_syaz1oa5",
    'color.text.danger': "_syaz1tmw",
    'color.text.warning': "_syaz1xn9",
    'color.text.warning.inverse': "_syaz1yd3",
    'color.text.success': "_syazgsak",
    'color.text.discovery': "_syazdv2p",
    'color.text.information': "_syazu3tg",
    'color.text.subtlest': "_syaz1rpy",
    'color.text.subtle': "_syazazsu",
    'color.link': "_syaz13af",
    'color.link.pressed': "_syaz12zz",
    'color.link.visited': "_syaz1ra0",
    'color.link.visited.pressed': "_syaz17z1"
};
var $57ba788fdac691c2$export$2185ce37f9bdd963 = {
    'color.background.neutral.bold': 'color.text.inverse',
    'color.background.neutral.bold.hovered': 'color.text.inverse',
    'color.background.neutral.bold.pressed': 'color.text.inverse',
    'color.background.selected.bold': 'color.text.inverse',
    'color.background.selected.bold.hovered': 'color.text.inverse',
    'color.background.selected.bold.pressed': 'color.text.inverse',
    'color.background.brand.bold': 'color.text.inverse',
    'color.background.brand.bold.hovered': 'color.text.inverse',
    'color.background.brand.bold.pressed': 'color.text.inverse',
    'color.background.brand.boldest': 'color.text.inverse',
    'color.background.brand.boldest.hovered': 'color.text.inverse',
    'color.background.brand.boldest.pressed': 'color.text.inverse',
    'color.background.danger.bold': 'color.text.inverse',
    'color.background.danger.bold.hovered': 'color.text.inverse',
    'color.background.danger.bold.pressed': 'color.text.inverse',
    'color.background.warning.bold': 'color.text.warning.inverse',
    'color.background.warning.bold.hovered': 'color.text.warning.inverse',
    'color.background.warning.bold.pressed': 'color.text.warning.inverse',
    'color.background.success.bold': 'color.text.inverse',
    'color.background.success.bold.hovered': 'color.text.inverse',
    'color.background.success.bold.pressed': 'color.text.inverse',
    'color.background.discovery.bold': 'color.text.inverse',
    'color.background.discovery.bold.hovered': 'color.text.inverse',
    'color.background.discovery.bold.pressed': 'color.text.inverse',
    'color.background.information.bold': 'color.text.inverse',
    'color.background.information.bold.hovered': 'color.text.inverse',
    'color.background.information.bold.pressed': 'color.text.inverse'
};
/**
 * __Text__
 *
 * Text is a primitive component that has the Atlassian Design System's design guidelines baked in.
 * This includes considerations for text attributes such as color, font size, font weight, and line height.
 * It renders a `span` by default.
 *
 * @internal
 */ var $57ba788fdac691c2$var$Text = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? 'span' : _ref$as, colorProp = _ref.color, align = _ref.align, testId = _ref.testId, id = _ref.id, size = _ref.size, weight = _ref.weight, maxLines = _ref.maxLines, xcss = _ref.xcss, children = _ref.children;
    (0, $afMOk.default)($57ba788fdac691c2$var$asAllowlist.includes(Component), "@atlaskit/primitives: Text received an invalid \"as\" value of \"".concat(Component, "\""));
    var hasTextAncestor = (0, $4f9ce98fa74be29b$export$9322276ec105d055)();
    var color = $57ba788fdac691c2$var$useColor(colorProp, hasTextAncestor);
    if (!size && !hasTextAncestor) size = 'medium';
    var component = /*#__PURE__*/ $5FkrB.createElement(Component, {
        id: id,
        className: (0, $ef5895cebbb13c02$export$2e2bcd8739ae039)([
            $57ba788fdac691c2$var$styles.root,
            size && $57ba788fdac691c2$var$fontSizeMap[size],
            color && $57ba788fdac691c2$var$textColorMap[color],
            maxLines && $57ba788fdac691c2$var$styles.truncation,
            maxLines === 1 && $57ba788fdac691c2$var$styles.breakAll,
            align && $57ba788fdac691c2$var$styles["textAlign.".concat(align)],
            weight && $57ba788fdac691c2$var$fontWeightMap[weight],
            Component === 'em' && $57ba788fdac691c2$var$styles['as.em'],
            Component === 'strong' && $57ba788fdac691c2$var$styles['as.strong'],
            xcss
        ]),
        style: {
            WebkitLineClamp: maxLines
        },
        "data-testid": testId,
        ref: ref
    }, children);
    if (hasTextAncestor) // no need to re-apply context if the text is already wrapped
    return component;
    return /*#__PURE__*/ $5FkrB.createElement((0, $4f9ce98fa74be29b$export$ae933c6cbe5643ad), {
        value: true
    }, component);
});
var $57ba788fdac691c2$export$2e2bcd8739ae039 = $57ba788fdac691c2$var$Text;



var $5FkrB = parcelRequire("5FkrB");
/* eslint-disable @repo/internal/react/require-jsdoc */ 
var $5FkrB = parcelRequire("5FkrB");
var $72410aac6635c6c0$export$5a5d356ca5f10a0a = /*#__PURE__*/ (0, $5FkrB.createContext)(null);


function $62881b5e01ed5a8e$export$2e2bcd8739ae039() {
    var tabData = (0, $5FkrB.useContext)((0, $72410aac6635c6c0$export$5a5d356ca5f10a0a));
    if (tabData == null || typeof tabData === 'undefined') throw Error('@atlaskit/tabs: A Tab must have a TabList parent.');
    return tabData;
}


/**
 * __Tab__
 *
 * Tab represents an individual Tab displayed in a TabList.
 *
 * - [Examples](https://atlassian.design/components/tabs/examples)
 * - [Code](https://atlassian.design/components/tabs/code)
 * - [Usage](https://atlassian.design/components/tabs/usage)
 */ var $e23e17c0c75104db$var$Tab = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function Tab(_ref, ref) {
    var children = _ref.children, testId = _ref.testId;
    var _useTab = (0, $62881b5e01ed5a8e$export$2e2bcd8739ae039)(), onClick = _useTab.onClick, id = _useTab.id, ariaControls = _useTab['aria-controls'], ariaPosinset = _useTab['aria-posinset'], ariaSelected = _useTab['aria-selected'], ariaSetsize = _useTab['aria-setsize'], onKeyDown = _useTab.onKeyDown, role = _useTab.role, tabIndex = _useTab.tabIndex;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $e70776888036db59$export$2e2bcd8739ae039), {
        as: "div",
        isInset: true,
        testId: testId,
        onClick: onClick,
        id: id,
        "aria-controls": ariaControls,
        "aria-posinset": ariaPosinset,
        "aria-selected": ariaSelected,
        "aria-setsize": ariaSetsize,
        onKeyDown: onKeyDown,
        role: role,
        tabIndex: tabIndex,
        ref: ref
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $57ba788fdac691c2$export$2e2bcd8739ae039), {
        weight: "medium",
        color: "inherit",
        maxLines: 1
    }, children));
});
var $e23e17c0c75104db$export$2e2bcd8739ae039 = $e23e17c0c75104db$var$Tab;

/* tab-list.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $5FkrB = parcelRequire("5FkrB");



var $5FkrB = parcelRequire("5FkrB");

function $6c8e7e396623eae7$export$2e2bcd8739ae039() {
    var tabListData = (0, $5FkrB.useContext)((0, $1b23a6d8f9b96f86$export$aa6907f9fd69e93b));
    if (tabListData === null || typeof tabListData === 'undefined') throw Error('@atlaskit/tabs: A TabList must have a Tabs parent.');
    return tabListData;
}


var $62b7beffa12a0bc3$var$baseStyles = null;
var $62b7beffa12a0bc3$var$tabListStyles = null;
/**
 * __TabList__
 *
 * A TabList groups `Tab` components together.
 *
 * - [Examples](https://atlassian.design/components/tabs/examples)
 * - [Code](https://atlassian.design/components/tabs/code)
 * - [Usage](https://atlassian.design/components/tabs/usage)
 */ var $62b7beffa12a0bc3$var$TabList = function TabList(_ref) {
    var children = _ref.children;
    var _useTabList = (0, $6c8e7e396623eae7$export$2e2bcd8739ae039)(), tabsId = _useTabList.tabsId, selected = _useTabList.selected, onChange = _useTabList.onChange;
    var ref = /*#__PURE__*/ (0, $5FkrB.createRef)();
    // Don't include any conditional children
    var childrenArray = (0, $5FkrB.Children).toArray(children).filter(Boolean);
    var length = childrenArray.length;
    var selectTabByIndex = (0, $5FkrB.useCallback)(function(index) {
        var _ref$current;
        var newSelectedNode = (_ref$current = ref.current) === null || _ref$current === void 0 ? void 0 : _ref$current.querySelector("[id='".concat(tabsId, "-").concat(index, "']"));
        if (newSelectedNode) newSelectedNode.focus();
        onChange(index);
    }, [
        tabsId,
        ref,
        onChange
    ]);
    var onKeyDown = (0, $5FkrB.useCallback)(function(e) {
        if (![
            'ArrowRight',
            'ArrowLeft',
            'Home',
            'End'
        ].includes(e.key)) return;
        // preventing horizontal or vertical scroll
        e.preventDefault();
        var lastTabIndex = length - 1;
        if ([
            'Home',
            'End'
        ].includes(e.key)) {
            var _newSelected = e.key === 'Home' ? 0 : lastTabIndex;
            selectTabByIndex(_newSelected);
            return;
        }
        // We use aria-posinset so we don't rely on the selected variable
        // If we used the selected variable this would regenerate each time
        // and create an unstable reference
        var selectedIndex = parseInt(e.currentTarget.getAttribute('aria-posinset') || '0') - 1;
        var modifier = e.key === 'ArrowRight' ? 1 : -1;
        var newSelected = selectedIndex + modifier;
        if (newSelected < 0 || newSelected >= length) // Cycling focus to move from last to first and from first to last
        newSelected = newSelected < 0 ? lastTabIndex : 0;
        selectTabByIndex(newSelected);
    }, [
        length,
        selectTabByIndex
    ]);
    // Memoized so the function isn't recreated each time
    var getTabWithContext = (0, $5FkrB.useCallback)(function(_ref2) {
        var tab = _ref2.tab, isSelected = _ref2.isSelected, index = _ref2.index;
        return /*#__PURE__*/ $5FkrB.createElement((0, $72410aac6635c6c0$export$5a5d356ca5f10a0a).Provider, {
            value: {
                onClick: function onClick() {
                    return onChange(index);
                },
                onKeyDown: onKeyDown,
                'aria-setsize': length,
                role: 'tab',
                id: "".concat(tabsId, "-").concat(index),
                'aria-posinset': index + 1,
                'aria-selected': isSelected,
                'aria-controls': "".concat(tabsId, "-").concat(index, "-tab"),
                tabIndex: isSelected ? 0 : -1
            },
            key: index
        }, tab);
    }, [
        length,
        onKeyDown,
        onChange,
        tabsId
    ]);
    return /*#__PURE__*/ $5FkrB.createElement("div", {
        role: "tablist",
        ref: ref,
        className: (0, $ef5895cebbb13c02$export$2e2bcd8739ae039)([
            "_1e0c1txw _kqswh2mm _85i5ze3t _1q51ze3t _y4tize3t _bozgze3t",
            "_k48p1wq8 _ahbqx0bf _gpbcidpf _10vzidpf _1mmwidpf _15plidpf _qwyt1qi0 _7hip15vq _1fud15vq _bb0mh2mm _1quzazsu _rzxytlke _1ofh12x7 _pryi12x7 _1a85u2gc _rmpau2gc _1dze1l2s _1tms1q9c _fiizidpf _1xrmidpf _xyihidpf _166qidpf _1lzu1uh4 _24g71kw7 _140sidpf _lycustnw _15d8b3bt _1fztidpf _wd7eu2gc _1olcu2gc _1oazazsu _w9ewidpf _170tidpf _y1g1idpf _1nvfidpf _1b8d1uh4 _1n121kw7 _7p9oidpf _o2e1stnw _16u6b3bt _1yk1idpf _1lbou2gc _1c9uu2gc _1i20i7uo _bppridpf _1mbxidpf _kn0bidpf _wsgdidpf _rsmzz0c1 _1m0e1kw7 _93pdidpf _1sglstnw _1ksob3bt _1p9sidpf _1qa1u2gc _1jjcu2gc _fiem6x5g _pascidpf _eid3idpf _zr3eidpf _fntnidpf _1mp41kw7 _kfgte4h9 _1cs8stnw _1rus1l7x _1kt9b3bt _1fkridpf _1enwidpf _z5wtu2gc"
        ])
    }, childrenArray.map(function(child, index) {
        return getTabWithContext({
            tab: child,
            index: index,
            isSelected: index === selected
        });
    }));
};
var $62b7beffa12a0bc3$export$2e2bcd8739ae039 = $62b7beffa12a0bc3$var$TabList;


var $5FkrB = parcelRequire("5FkrB");


var $5FkrB = parcelRequire("5FkrB");

function $33cc981e165181ff$export$2e2bcd8739ae039() {
    var tabPanelData = (0, $5FkrB.useContext)((0, $105b2b73664cf5fe$export$2054129d247c3102));
    if (tabPanelData === null || typeof tabPanelData === 'undefined') throw Error('@atlaskit/tabs:  A TabPanel must have a Tabs parent.');
    return tabPanelData;
}


// Note this is not being memoized as children is an unstable reference
/**
 * __TabPanel__
 *
 * A TabPanel houses the contents of a Tab.
 *
 * - [Examples](https://atlassian.design/components/tabs/examples)
 * - [Code](https://atlassian.design/components/tabs/code)
 * - [Usage](https://atlassian.design/components/tabs/usage)
 */ var $9620d31b6d3b6773$var$TabPanel = function TabPanel(_ref) {
    var children = _ref.children, testId = _ref.testId;
    var _useTabPanel = (0, $33cc981e165181ff$export$2e2bcd8739ae039)(), role = _useTabPanel.role, id = _useTabPanel.id, hidden = _useTabPanel.hidden, ariaLabelledBy = _useTabPanel['aria-labelledby'], tabIndex = _useTabPanel.tabIndex;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $e70776888036db59$export$2e2bcd8739ae039), {
        as: "div",
        isInset: true,
        testId: testId,
        role: role,
        id: id,
        hidden: hidden,
        "aria-labelledby": ariaLabelledBy,
        tabIndex: tabIndex
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $5FkrB.Fragment), null, children));
};
var $9620d31b6d3b6773$export$2e2bcd8739ae039 = $9620d31b6d3b6773$var$TabPanel;


/**
 * URL route constants for the App Updates application
 */ const $749a6437bd4ec017$export$cd891b82501bb412 = {
    /**
   * Base route for the app updates list page (the "All changes" tab)
   */ RELEASE_NOTES: '/release-notes',
    /**
   * Route for the app updates list page with the "Release tracks changes" tab active
   */ RELEASE_TRACKS_CHANGES: '/release-notes/release-tracks-changes',
    /**
   * Legacy route for the Release tracks changes tab. Keep this redirect path
   * working for existing customer links.
   */ LEGACY_BUNDLED_CHANGES: '/release-notes/bundled-changes',
    /**
   * Route for app update details page
   * @param id - The update ID
   * @returns The complete route path
   */ RELEASE_NOTE_DETAILS: (id)=>`/release-notes/${id}`
};




var $aRMzY = parcelRequire("aRMzY");
var $6Wx3K = parcelRequire("6Wx3K");


var $eMiEC = parcelRequire("eMiEC");/* section-message-action.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");

var $jgNUw = parcelRequire("jgNUw");
/* index.tsx generated by @compiled/babel-plugin v0.38.1 */ parcelRequire("5FkrB");


var $Pd8py = parcelRequire("Pd8py");
var $b5cd78e10bc362b2$var$strictApi = (0, $Pd8py.createStrictAPI)();
var $b5cd78e10bc362b2$export$dbf350e5966cf602 = $b5cd78e10bc362b2$var$strictApi.css;
var $b5cd78e10bc362b2$export$eb1ecd84a24ee424 = $b5cd78e10bc362b2$var$strictApi.cssMap;
$b5cd78e10bc362b2$var$strictApi.cssMap;
var $b5cd78e10bc362b2$export$a274e22fb40f762e = $b5cd78e10bc362b2$var$strictApi.cx;
var $b5cd78e10bc362b2$var$XCSSProp = $b5cd78e10bc362b2$var$strictApi.XCSSProp; // This is to mitigate local TS error TS2315: Type 'StrictXCSSProp' is not generic.
 // Currently for some reason tsc is generating malformed .d.ts in local dev environment, below change fixes it
 /**
 * ## StrictXCSSProp
 *
 * Declare styles your component takes with all other styles marked as violations
 * by the TypeScript compiler. There are two primary use cases for xcss prop:
 *
 * - safe style overrides
 * - inverting style declarations
 *
 * Interverting style declarations is interesting for platform teams as
 * it means apps only pay for styles they use as they're now the ones who declare
 * the styles!
 *
 * The {@link StrictXCSSProp} type has generics two of which must be defined — use to explicitly
 * set what you want to maintain as API. Use {@link XCSSAllProperties} and {@link XCSSAllPseudos}
 * to enable all properties and pseudos.
 *
 * The third generic is used to declare what properties and pseudos should be required.
 *
 * ```tsx
 * interface MyComponentProps {
 *   // Color is accepted, all other properties / pseudos are considered violations.
 *   xcss?: StrictXCSSProp<'color', never>;
 *
 *   // Only background color and hover pseudo are accepted.
 *   xcss?: StrictXCSSProp<'backgroundColor', '&:hover'>;
 *
 *   // All properties are accepted, all pseudos are considered violations.
 *   xcss?: StrictXCSSProp<XCSSAllProperties, never>;
 *
 *   // All properties are accepted, only the hover pseudo is accepted.
 *   xcss?: StrictXCSSProp<XCSSAllProperties, '&:hover'>;
 *
 *   // The xcss prop is required as well as the color property. No pseudos are required.
 *   xcss: StrictXCSSProp<
 *     XCSSAllProperties,
 *     '&:hover',
 *     { requiredProperties: 'color', requiredPseudos: never }
 *   >;
 * }
 *
 * function MyComponent({ xcss }: MyComponentProps) {
 *   return <div css={{ color: 'var(--ds-text-danger)' }} className={xcss} />
 * }
 * ```
 *
 * The xcss prop works with static inline objects and the [cssMap](https://compiledcssinjs.com/docs/api-cssmap) API.
 *
 * ```jsx
 * // Declared as an inline object
 * <Component xcss={{ color: 'var(--ds-text)' }} />
 *
 * // Declared with the cssMap API
 * const styles = cssMap({ text: { color: 'var(--ds-text)' } });
 * <Component xcss={styles.text} />
 * ```
 *
 * To concatenate and conditonally apply styles use the {@link cssMap} and {@link cx} functions.
 */ 


/* index.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $kqp0i = parcelRequire("kqp0i");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");


var $9Zzpd = parcelRequire("9Zzpd");
/* anchor.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $kqp0i = parcelRequire("kqp0i");

var $ekGgq = parcelRequire("ekGgq");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");


var $hUFig = parcelRequire("hUFig");

var $afMOk = parcelRequire("afMOk");

var $25nEq = parcelRequire("25nEq");

var $5FkrB = parcelRequire("5FkrB");

var $dLGML = parcelRequire("dLGML");

var $fC8ib = parcelRequire("fC8ib");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $kIXpt = parcelRequire("kIXpt");

var $cYPzS = parcelRequire("cYPzS");

var $lwlXp = parcelRequire("lwlXp");

var $eyuDe = parcelRequire("eyuDe");

var $25nEq = parcelRequire("25nEq");

var $ekGgq = parcelRequire("ekGgq");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $25nEq = parcelRequire("25nEq");
function $963a3e8bf93037d5$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $963a3e8bf93037d5$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $963a3e8bf93037d5$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $963a3e8bf93037d5$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $963a3e8bf93037d5$export$ad4be5c2ec28cecf = function isAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $963a3e8bf93037d5$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === 'AnalyticsEvent';
};
var $963a3e8bf93037d5$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function AnalyticsEvent(props) {
        var _this = this;
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, AnalyticsEvent);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "_isAnalyticsEvent", true);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "clone", function() {
            // just a shallow clone, don't change sub refs unless you want to
            // affect the original's too
            var payload = $963a3e8bf93037d5$var$_objectSpread({}, _this.payload);
            return new AnalyticsEvent({
                payload: payload
            });
        });
        this.payload = props.payload;
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(AnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (typeof updater === 'function') this.payload = updater(this.payload);
                if ((0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(updater) === 'object') this.payload = $963a3e8bf93037d5$var$_objectSpread($963a3e8bf93037d5$var$_objectSpread({}, this.payload), updater);
                return this;
            }
        }
    ]);
}();


function $cdd4371cb8fb2c52$var$_callSuper(t, o, e) {
    return o = (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(o), (0, (/*@__PURE__*/$parcel$interopDefault($kIXpt)))(t, $cdd4371cb8fb2c52$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(t).constructor) : o.apply(t, e));
}
function $cdd4371cb8fb2c52$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($cdd4371cb8fb2c52$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $cdd4371cb8fb2c52$var$_superPropGet(t, o, e, r) {
    var p = (0, (/*@__PURE__*/$parcel$interopDefault($lwlXp)))((0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(1 & r ? t.prototype : t), o, e);
    return 2 & r && "function" == typeof p ? function(t) {
        return p.apply(e, t);
    } : p;
}
var $cdd4371cb8fb2c52$export$35f8383928ba8d7 = function isUIAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $cdd4371cb8fb2c52$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isUIAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === 'UIAnalyticsEvent';
};
var $cdd4371cb8fb2c52$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_AnalyticsEvent) {
    function UIAnalyticsEvent(props) {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, UIAnalyticsEvent);
        _this = $cdd4371cb8fb2c52$var$_callSuper(this, UIAnalyticsEvent, [
            props
        ]);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "_isUIAnalyticsEvent", true);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "clone", function() {
            if (_this.hasFired) return null;
            var context = (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(_this.context);
            var handlers = (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(_this.handlers);
            /**
       * A hacky "deep clone" of the object. This is limited in that it wont
       * support functions, regexs, Maps, Sets, etc, but none of those need to
       * be represented in our payload.
       */ var payload = JSON.parse(JSON.stringify(_this.payload));
            return new UIAnalyticsEvent({
                context: context,
                handlers: handlers,
                payload: payload
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "fire", function(channel) {
            if (_this.hasFired) return;
            _this.handlers.forEach(function(handler) {
                return handler(_this, channel);
            });
            _this.hasFired = true;
        });
        _this.context = props.context || [];
        _this.handlers = props.handlers || [];
        _this.hasFired = false;
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($eyuDe)))(UIAnalyticsEvent, _AnalyticsEvent);
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(UIAnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (this.hasFired) return this;
                return $cdd4371cb8fb2c52$var$_superPropGet(UIAnalyticsEvent, "update", this, 3)([
                    updater
                ]);
            }
        }
    ]);
}((0, $963a3e8bf93037d5$export$2e2bcd8739ae039));



var $5FkrB = parcelRequire("5FkrB");

var $iyyOp = parcelRequire("iyyOp");
var $cb8c2722202daf65$export$d1f587f82ad51c4 = function useAnalyticsContext() {
    return (0, $5FkrB.useContext)((0, $iyyOp.default));
};


function $e8f979d3de6c70c6$export$5bf35293e545f20c() {
    var analyticsContext = (0, $cb8c2722202daf65$export$d1f587f82ad51c4)();
    var createAnalyticsEvent = (0, $dLGML.useCallbackOne)(function(payload) {
        return new (0, $cdd4371cb8fb2c52$export$2e2bcd8739ae039)({
            context: analyticsContext.getAtlaskitAnalyticsContext(),
            handlers: analyticsContext.getAtlaskitAnalyticsEventHandlers(),
            payload: payload
        });
    }, [
        analyticsContext
    ]);
    return {
        createAnalyticsEvent: createAnalyticsEvent
    };
}



var $5FkrB = parcelRequire("5FkrB");
var $8bc92b0cd5f28aa3$export$1d27a74659855e44 = function useTrackedRef(value) {
    var ref = (0, $5FkrB.useRef)(value);
    ref.current = value;
    return ref;
};


function $75b909bb27e39354$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $75b909bb27e39354$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $75b909bb27e39354$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $75b909bb27e39354$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $75b909bb27e39354$export$a4687b0234b40e28(_ref) {
    var fn = _ref.fn, action = _ref.action, componentName = _ref.componentName, actionSubject = _ref.actionSubject, packageName = _ref.packageName, packageVersion = _ref.packageVersion, analyticsData = _ref.analyticsData;
    var _useAnalyticsEvents = (0, $e8f979d3de6c70c6$export$5bf35293e545f20c)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
    // We put analyticsData and fn in a ref so that we don't need to break
    // memoization.
    // Generally these could be defined by consumers inline
    // and so we do this to avoid breaking memoization of useCallback
    var dataRef = (0, $8bc92b0cd5f28aa3$export$1d27a74659855e44)(analyticsData);
    var fnRef = (0, $8bc92b0cd5f28aa3$export$1d27a74659855e44)(fn);
    var handler = (0, $5FkrB.useCallback)(function(value) {
        var analyticsEvent = createAnalyticsEvent({
            action: action,
            actionSubject: actionSubject || componentName,
            attributes: {
                componentName: componentName,
                packageName: packageName,
                packageVersion: packageVersion
            }
        });
        // To avoid wrapping this component in AnalyticsContext we manually
        // push the parent context's meta data into the context.
        // Note: this new 'context'
        var context = $75b909bb27e39354$var$_objectSpread({
            componentName: componentName,
            packageName: packageName,
            packageVersion: packageVersion
        }, dataRef.current);
        analyticsEvent.context.push(context);
        // fire an event on the atlaskit channel
        var clone = analyticsEvent.clone();
        if (clone) clone.fire('atlaskit');
        fnRef.current(value, analyticsEvent);
    }, [
        // These are strings and won't change
        action,
        componentName,
        actionSubject,
        packageName,
        packageVersion,
        // This function is memoized in the context
        createAnalyticsEvent,
        // these are a stable ref because of the useTrackedRef hook
        dataRef,
        fnRef
    ]);
    return handler;
}



var $5FkrB = parcelRequire("5FkrB");

var $5FkrB = parcelRequire("5FkrB");
var $1bc0380b43b287f3$export$2931e0ee690eee88 = /*#__PURE__*/ (0, $5FkrB.createContext)({});
/**
 * __RouterLinkProvider__
 *
 * Provides a configured router link component for use
 * within Design System components.
 */ var $1bc0380b43b287f3$var$RouterLinkProvider = function RouterLinkProvider(_ref) {
    var routerLinkComponent = _ref.routerLinkComponent, children = _ref.children;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement($1bc0380b43b287f3$export$2931e0ee690eee88.Provider, {
        value: {
            routerLinkComponent: routerLinkComponent
        }
    }, children);
};
var $1bc0380b43b287f3$export$2e2bcd8739ae039 = $1bc0380b43b287f3$var$RouterLinkProvider;


/**
 * __useRouterLink()__
 *
 * Hook: Returns app-configured router link component.
 *
 * A generic can be passed to define advanced link configuration:
 * ```
 * type MyRouterLinkConfig = {
 *  to: string;
 *  replace?: boolean;
 * }
 *
 * const RouterLink = useRouterLink<MyRouterLinkConfig>();
 * ```
 */ var $d5bb4ddc0a0a73ba$var$useRouterLink = function useRouterLink() {
    var _useContext = (0, $5FkrB.useContext)((0, $1bc0380b43b287f3$export$2931e0ee690eee88)), routerLinkComponent = _useContext.routerLinkComponent;
    if (routerLinkComponent) return routerLinkComponent;
    return;
};
var $d5bb4ddc0a0a73ba$export$2e2bcd8739ae039 = $d5bb4ddc0a0a73ba$var$useRouterLink;



var $eVb4V = parcelRequire("eVb4V");

var $h8qvJ = parcelRequire("h8qvJ");

var $eqVaP = parcelRequire("eqVaP");

var $e8kqY = parcelRequire("e8kqY");
/* focusable.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $kqp0i = parcelRequire("kqp0i");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");
var $0013faf18cfa29e2$var$_excluded = [
    "as",
    "children",
    "isInset",
    "testId",
    "style",
    "xcss"
], $0013faf18cfa29e2$var$_excluded2 = [
    "className"
];
var $0013faf18cfa29e2$var$focusRingStyles = null;
var $0013faf18cfa29e2$var$insetFocusRingStyles = null;
/**
 * __Focus ring__
 *
 * A focus ring visually indicates the currently focused item.
 *
 */ var $0013faf18cfa29e2$var$Focusable = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? 'button' : _ref$as, children = _ref.children, isInset = _ref.isInset, testId = _ref.testId, style = _ref.style, xcss = _ref.xcss, htmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $0013faf18cfa29e2$var$_excluded);
    // This is to remove className from safeHtmlAttributes
    // @ts-ignore -- not using expect since it causes issues with help-center local consumption - className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(htmlAttributes, $0013faf18cfa29e2$var$_excluded2);
    return /*#__PURE__*/ $5FkrB.createElement(Component, (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, safeHtmlAttributes, {
        // @ts-ignore Expression produces a union type that is too complex to represent. We may be able to narrow the type here but unsure.
        ref: ref,
        className: (0, $970q7.default)([
            "_ymio1r31 _ypr0glyw _zcxs1o36 _mizu194a _1ah3dkaa _ra3xnqa1 _128mdkaa _1cvmnqa1 _4davt94y",
            isInset && "_1ah31gjf _2mwq1gjf",
            xcss
        ]),
        style: style,
        "data-testid": testId
    }), children);
});
var $0013faf18cfa29e2$export$2e2bcd8739ae039 = $0013faf18cfa29e2$var$Focusable;


var $f7402c8717b4416e$var$_excluded = [
    "href",
    "children",
    "onClick",
    "interactionName",
    "componentName",
    "analyticsContext",
    "aria-label",
    "aria-labelledby",
    "style",
    "target",
    "testId",
    "xcss",
    "newWindowLabel"
], $f7402c8717b4416e$var$_excluded2 = [
    "className"
];
var $f7402c8717b4416e$var$styles = {
    root: "_4bfu1r31 _1hms8stv _ajmmnqa1 _vchhusvi",
    position: "_kqswh2mm"
};
var $f7402c8717b4416e$var$IS_EXTERNAL_LINK_REGEX = /^(?:(http|https):\/\/)/;
var $f7402c8717b4416e$var$IS_NON_HTTP_BASED = /^(((mailto|tel|sms|blob):)|(#))/;
/**
 * __Anchor__
 *
 * A primitive for building custom anchor links.
 *
 * - [Examples](https://atlassian.design/components/primitives/anchor/examples)
 * - [Code](https://atlassian.design/components/primitives/anchor/code)
 * - [Usage](https://atlassian.design/components/primitives/anchor/usage)
 */ var $f7402c8717b4416e$var$AnchorNoRef = function AnchorNoRef(_ref, ref) {
    var href = _ref.href, children = _ref.children, _ref$onClick = _ref.onClick, providedOnClick = _ref$onClick === void 0 ? (0, $eVb4V.default) : _ref$onClick, interactionName = _ref.interactionName, componentName = _ref.componentName, analyticsContext = _ref.analyticsContext, ariaLabel = _ref['aria-label'], ariaLabelledBy = _ref['aria-labelledby'], style = _ref.style, target = _ref.target, testId = _ref.testId, xcss = _ref.xcss, _ref$newWindowLabel = _ref.newWindowLabel, newWindowLabel = _ref$newWindowLabel === void 0 ? '(opens new window)' : _ref$newWindowLabel, htmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $f7402c8717b4416e$var$_excluded);
    var interactionContext = (0, $5FkrB.useContext)((0, $eqVaP.default));
    var handleClick = (0, $5FkrB.useCallback)(function(e, analyticsEvent) {
        interactionContext && interactionContext.tracePress(interactionName, e.timeStamp);
        providedOnClick(e, analyticsEvent);
    }, [
        providedOnClick,
        interactionContext,
        interactionName
    ]);
    var opensNewWindowLabelId = (0, $h8qvJ.useId)();
    var onClick = (0, $75b909bb27e39354$export$a4687b0234b40e28)({
        fn: handleClick,
        action: 'clicked',
        componentName: componentName || 'Anchor',
        packageName: "@atlaskit/primitives",
        packageVersion: "16.4.4",
        analyticsData: analyticsContext,
        actionSubject: 'link'
    });
    // This is to remove className from safeHtmlAttributes
    // @ts-expect-error className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(htmlAttributes, $f7402c8717b4416e$var$_excluded2);
    var RouterLink = (0, $d5bb4ddc0a0a73ba$export$2e2bcd8739ae039)();
    var isExternal = typeof href === 'string' && $f7402c8717b4416e$var$IS_EXTERNAL_LINK_REGEX.test(href);
    var isNonHttpBased = typeof href === 'string' && $f7402c8717b4416e$var$IS_NON_HTTP_BASED.test(href);
    /**
   * Renders a router link if:
   *
   * - a link component is set in the app provider
   * - it's not an external link (starting with `http://` or `https://`)
   * - it's not a non-HTTP-based link (e.g. emails, phone numbers, hash links etc.).
   */ var isRouterLink = RouterLink && !isExternal && !isNonHttpBased;
    var hrefObjectUsedWithoutRouterLink = RouterLink === undefined && (0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(href) === 'object';
    (0, $afMOk.default)(!hrefObjectUsedWithoutRouterLink, "@atlaskit/primitives: Anchor primitive cannot pass an object to 'href' unless a router link is configured in the AppProvider");
    var Component = isRouterLink ? RouterLink : 'a';
    return /*#__PURE__*/ $5FkrB.createElement((0, $0013faf18cfa29e2$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        as: Component,
        className: xcss,
        style: style,
        ref: ref
    }, safeHtmlAttributes, {
        href: !isRouterLink && typeof href !== 'string' ? undefined : href,
        target: target,
        onClick: onClick,
        "aria-label": ariaLabel && target === '_blank' && !ariaLabelledBy ? "".concat(ariaLabel, " , ").concat(newWindowLabel) : ariaLabel,
        "aria-labelledby": ariaLabelledBy && target === '_blank' ? "".concat(ariaLabelledBy, " ").concat(opensNewWindowLabelId) : ariaLabelledBy,
        xcss: (0, $hUFig.cx)($f7402c8717b4416e$var$styles.root, $f7402c8717b4416e$var$styles.position, xcss),
        testId: testId,
        "data-is-router-link": testId ? isRouterLink ? 'true' : 'false' : undefined
    }), children, target === '_blank' && (children && !ariaLabel && !ariaLabelledBy || ariaLabelledBy) && /*#__PURE__*/ $5FkrB.createElement((0, $e8kqY.default), {
        id: opensNewWindowLabelId
    }, ", ".concat(newWindowLabel)));
};
// Workarounds to support generic types with forwardRef
/**
 * __Anchor__
 *
 * Anchor is a primitive for building custom anchor links. It's a wrapper around the HTML `<a>` element that provides a consistent API for handling client-side routing and Atlassian Design System styling.
 *
 * - [Examples](https://atlassian.design/components/primitives/anchor/examples)
 * - [Code](https://atlassian.design/components/primitives/anchor/code)
 * - [Usage](https://atlassian.design/components/primitives/anchor/usage)
 */ var $f7402c8717b4416e$var$Anchor = /*#__PURE__*/ (0, $5FkrB.forwardRef)($f7402c8717b4416e$var$AnchorNoRef);
var $f7402c8717b4416e$export$2e2bcd8739ae039 = $f7402c8717b4416e$var$Anchor;

/* box.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $kqp0i = parcelRequire("kqp0i");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");

var $bemp3 = parcelRequire("bemp3");
var $f3b0d8b8c6613242$var$_excluded = [
    "as",
    "children",
    "backgroundColor",
    "padding",
    "paddingBlock",
    "paddingBlockStart",
    "paddingBlockEnd",
    "paddingInline",
    "paddingInlineStart",
    "paddingInlineEnd",
    "style",
    "testId",
    "xcss"
], $f3b0d8b8c6613242$var$_excluded2 = [
    "className"
];
// Can either Exclude or Extract - here we're excluding all SVG-related elements, <button> elements (handled by Pressable), and <a> elements (handled by Anchor)
// Basically just ElementType but without ComponentType, it makes sense to keep the "Type" suffix
// eslint-disable-next-line @repo/internal/react/consistent-types-definitions
var $f3b0d8b8c6613242$var$baseStyles = null;
var $f3b0d8b8c6613242$var$backgroundColorMap = {
    'color.background.accent.lime.subtlest': "_bfhkm890",
    'color.background.accent.lime.subtlest.hovered': "_bfhkd4y8",
    'color.background.accent.lime.subtlest.pressed': "_bfhkkuup",
    'color.background.accent.lime.subtler': "_bfhkz2ec",
    'color.background.accent.lime.subtler.hovered': "_bfhk1gf0",
    'color.background.accent.lime.subtler.pressed': "_bfhk2kxc",
    'color.background.accent.lime.subtle': "_bfhkbq5w",
    'color.background.accent.lime.subtle.hovered': "_bfhkfoww",
    'color.background.accent.lime.subtle.pressed': "_bfhk1jbd",
    'color.background.accent.lime.bolder': "_bfhktde4",
    'color.background.accent.lime.bolder.hovered': "_bfhknzpa",
    'color.background.accent.lime.bolder.pressed': "_bfhkh0j0",
    'color.background.accent.red.subtlest': "_bfhk1vk5",
    'color.background.accent.red.subtlest.hovered': "_bfhk1i6i",
    'color.background.accent.red.subtlest.pressed': "_bfhknbir",
    'color.background.accent.red.subtler': "_bfhk1rtt",
    'color.background.accent.red.subtler.hovered': "_bfhkaffd",
    'color.background.accent.red.subtler.pressed': "_bfhk1j5a",
    'color.background.accent.red.subtle': "_bfhkkrt9",
    'color.background.accent.red.subtle.hovered': "_bfhk1sou",
    'color.background.accent.red.subtle.pressed': "_bfhk1fnn",
    'color.background.accent.red.bolder': "_bfhkuibq",
    'color.background.accent.red.bolder.hovered': "_bfhk100f",
    'color.background.accent.red.bolder.pressed': "_bfhk1cl6",
    'color.background.accent.orange.subtlest': "_bfhkf5uh",
    'color.background.accent.orange.subtlest.hovered': "_bfhk19yr",
    'color.background.accent.orange.subtlest.pressed': "_bfhkf90x",
    'color.background.accent.orange.subtler': "_bfhk165s",
    'color.background.accent.orange.subtler.hovered': "_bfhk1ei0",
    'color.background.accent.orange.subtler.pressed': "_bfhkdpo3",
    'color.background.accent.orange.subtle': "_bfhk1kkj",
    'color.background.accent.orange.subtle.hovered': "_bfhk9mfs",
    'color.background.accent.orange.subtle.pressed': "_bfhkaxpp",
    'color.background.accent.orange.bolder': "_bfhk1qg1",
    'color.background.accent.orange.bolder.hovered': "_bfhk12qo",
    'color.background.accent.orange.bolder.pressed': "_bfhk1fyq",
    'color.background.accent.yellow.subtlest': "_bfhkibhp",
    'color.background.accent.yellow.subtlest.hovered': "_bfhkaetg",
    'color.background.accent.yellow.subtlest.pressed': "_bfhk1o1l",
    'color.background.accent.yellow.subtler': "_bfhk1773",
    'color.background.accent.yellow.subtler.hovered': "_bfhk1uw7",
    'color.background.accent.yellow.subtler.pressed': "_bfhk1r9w",
    'color.background.accent.yellow.subtle': "_bfhk8y3s",
    'color.background.accent.yellow.subtle.hovered': "_bfhk819w",
    'color.background.accent.yellow.subtle.pressed': "_bfhk1jx0",
    'color.background.accent.yellow.bolder': "_bfhk1vop",
    'color.background.accent.yellow.bolder.hovered': "_bfhkkjqf",
    'color.background.accent.yellow.bolder.pressed': "_bfhk1okt",
    'color.background.accent.green.subtlest': "_bfhkn729",
    'color.background.accent.green.subtlest.hovered': "_bfhk3utz",
    'color.background.accent.green.subtlest.pressed': "_bfhkyfny",
    'color.background.accent.green.subtler': "_bfhk1wnw",
    'color.background.accent.green.subtler.hovered': "_bfhk1e2h",
    'color.background.accent.green.subtler.pressed': "_bfhkybhx",
    'color.background.accent.green.subtle': "_bfhk1rsu",
    'color.background.accent.green.subtle.hovered': "_bfhk12e3",
    'color.background.accent.green.subtle.pressed': "_bfhk1g86",
    'color.background.accent.green.bolder': "_bfhk1e5c",
    'color.background.accent.green.bolder.hovered': "_bfhka5yi",
    'color.background.accent.green.bolder.pressed': "_bfhk1j68",
    'color.background.accent.teal.subtlest': "_bfhk7xuz",
    'color.background.accent.teal.subtlest.hovered': "_bfhk108c",
    'color.background.accent.teal.subtlest.pressed': "_bfhk1cxp",
    'color.background.accent.teal.subtler': "_bfhk1a17",
    'color.background.accent.teal.subtler.hovered': "_bfhkkwwr",
    'color.background.accent.teal.subtler.pressed': "_bfhk1jb0",
    'color.background.accent.teal.subtle': "_bfhktdv8",
    'color.background.accent.teal.subtle.hovered': "_bfhkzh8h",
    'color.background.accent.teal.subtle.pressed': "_bfhk16zl",
    'color.background.accent.teal.bolder': "_bfhk2c8p",
    'color.background.accent.teal.bolder.hovered': "_bfhkl3ve",
    'color.background.accent.teal.bolder.pressed': "_bfhktor0",
    'color.background.accent.blue.subtlest': "_bfhk1s93",
    'color.background.accent.blue.subtlest.hovered': "_bfhkdaj9",
    'color.background.accent.blue.subtlest.pressed': "_bfhkxm0g",
    'color.background.accent.blue.subtler': "_bfhk1dy8",
    'color.background.accent.blue.subtler.hovered': "_bfhk815t",
    'color.background.accent.blue.subtler.pressed': "_bfhkrwxf",
    'color.background.accent.blue.subtle': "_bfhk115i",
    'color.background.accent.blue.subtle.hovered': "_bfhk9pr4",
    'color.background.accent.blue.subtle.pressed': "_bfhknpx7",
    'color.background.accent.blue.bolder': "_bfhk16e3",
    'color.background.accent.blue.bolder.hovered': "_bfhk1vbm",
    'color.background.accent.blue.bolder.pressed': "_bfhk1xwi",
    'color.background.accent.purple.subtlest': "_bfhkp2ly",
    'color.background.accent.purple.subtlest.hovered': "_bfhkkca2",
    'color.background.accent.purple.subtlest.pressed': "_bfhk1jbm",
    'color.background.accent.purple.subtler': "_bfhk1nm4",
    'color.background.accent.purple.subtler.hovered': "_bfhkattl",
    'color.background.accent.purple.subtler.pressed': "_bfhk3nfk",
    'color.background.accent.purple.subtle': "_bfhk18ah",
    'color.background.accent.purple.subtle.hovered': "_bfhk8bp1",
    'color.background.accent.purple.subtle.pressed': "_bfhk1cd2",
    'color.background.accent.purple.bolder': "_bfhkya33",
    'color.background.accent.purple.bolder.hovered': "_bfhk1af5",
    'color.background.accent.purple.bolder.pressed': "_bfhk6cze",
    'color.background.accent.magenta.subtlest': "_bfhk8tvm",
    'color.background.accent.magenta.subtlest.hovered': "_bfhkr3zd",
    'color.background.accent.magenta.subtlest.pressed': "_bfhk1ckf",
    'color.background.accent.magenta.subtler': "_bfhkv9ra",
    'color.background.accent.magenta.subtler.hovered': "_bfhk1axx",
    'color.background.accent.magenta.subtler.pressed': "_bfhk42ri",
    'color.background.accent.magenta.subtle': "_bfhk1mi6",
    'color.background.accent.magenta.subtle.hovered': "_bfhkrwyz",
    'color.background.accent.magenta.subtle.pressed': "_bfhk6c15",
    'color.background.accent.magenta.bolder': "_bfhkc3uk",
    'color.background.accent.magenta.bolder.hovered': "_bfhk1ok8",
    'color.background.accent.magenta.bolder.pressed': "_bfhkeawv",
    'color.background.accent.gray.subtlest': "_bfhkysee",
    'color.background.accent.gray.subtlest.hovered': "_bfhkwejn",
    'color.background.accent.gray.subtlest.pressed': "_bfhk18ut",
    'color.background.accent.gray.subtler': "_bfhk7qp0",
    'color.background.accent.gray.subtler.hovered': "_bfhk10ef",
    'color.background.accent.gray.subtler.pressed': "_bfhk1rk9",
    'color.background.accent.gray.subtle': "_bfhk18j9",
    'color.background.accent.gray.subtle.hovered': "_bfhk1nv3",
    'color.background.accent.gray.subtle.pressed': "_bfhkq9tj",
    'color.background.accent.gray.bolder': "_bfhk1i45",
    'color.background.accent.gray.bolder.hovered': "_bfhkbyip",
    'color.background.accent.gray.bolder.pressed': "_bfhk1van",
    'color.background.disabled': "_bfhkby5v",
    'color.background.input': "_bfhk1j9a",
    'color.background.input.hovered': "_bfhkl4ek",
    'color.background.input.pressed': "_bfhkr01l",
    'color.background.inverse.subtle': "_bfhk1vck",
    'color.background.inverse.subtle.hovered': "_bfhkmpja",
    'color.background.inverse.subtle.pressed': "_bfhk1gii",
    'color.background.neutral': "_bfhki8nm",
    'color.background.neutral.hovered': "_bfhkplhp",
    'color.background.neutral.pressed': "_bfhk1gdz",
    'color.background.neutral.subtle': "_bfhksm61",
    'color.background.neutral.subtle.hovered': "_bfhk1dpa",
    'color.background.neutral.subtle.pressed': "_bfhkfcek",
    'color.background.neutral.bold': "_bfhk1aqn",
    'color.background.neutral.bold.hovered': "_bfhk1ibz",
    'color.background.neutral.bold.pressed': "_bfhkof27",
    'color.background.selected': "_bfhk15s3",
    'color.background.selected.hovered': "_bfhkufnl",
    'color.background.selected.pressed': "_bfhknozp",
    'color.background.selected.bold': "_bfhkjmqp",
    'color.background.selected.bold.hovered': "_bfhk1q28",
    'color.background.selected.bold.pressed': "_bfhk12kk",
    'color.background.brand.subtlest': "_bfhk1gmr",
    'color.background.brand.subtlest.hovered': "_bfhk3v15",
    'color.background.brand.subtlest.pressed': "_bfhku02c",
    'color.background.brand.bold': "_bfhk1856",
    'color.background.brand.bold.hovered': "_bfhkhf2y",
    'color.background.brand.bold.pressed': "_bfhkg6ey",
    'color.background.brand.boldest': "_bfhk1o4i",
    'color.background.brand.boldest.hovered': "_bfhklefx",
    'color.background.brand.boldest.pressed': "_bfhk16k6",
    'color.background.danger': "_bfhk1gly",
    'color.background.danger.hovered': "_bfhk1yvi",
    'color.background.danger.pressed': "_bfhk1r4b",
    'color.background.danger.bold': "_bfhkybec",
    'color.background.danger.bold.hovered': "_bfhks9hg",
    'color.background.danger.bold.pressed': "_bfhk13a9",
    'color.background.warning': "_bfhk1917",
    'color.background.warning.hovered': "_bfhk19zu",
    'color.background.warning.pressed': "_bfhkzr32",
    'color.background.warning.bold': "_bfhk1kmu",
    'color.background.warning.bold.hovered': "_bfhk1spp",
    'color.background.warning.bold.pressed': "_bfhk4m4m",
    'color.background.success': "_bfhk1y9u",
    'color.background.success.hovered': "_bfhk1vfx",
    'color.background.success.pressed': "_bfhk1wl5",
    'color.background.success.bold': "_bfhkkcmj",
    'color.background.success.bold.hovered': "_bfhky7x8",
    'color.background.success.bold.pressed': "_bfhkwcbh",
    'color.background.discovery': "_bfhk6vm6",
    'color.background.discovery.hovered': "_bfhk12eq",
    'color.background.discovery.pressed': "_bfhk18vq",
    'color.background.discovery.bold': "_bfhku5tj",
    'color.background.discovery.bold.hovered': "_bfhkfqeg",
    'color.background.discovery.bold.pressed': "_bfhk1f1m",
    'color.background.information': "_bfhk19ip",
    'color.background.information.hovered': "_bfhk86z5",
    'color.background.information.pressed': "_bfhk1c1j",
    'color.background.information.bold': "_bfhkx4w0",
    'color.background.information.bold.hovered': "_bfhkq2ii",
    'color.background.information.bold.pressed': "_bfhkf89v",
    'color.blanket': "_bfhk1i5c",
    'color.blanket.selected': "_bfhk7wq0",
    'color.blanket.danger': "_bfhkrprw",
    'color.skeleton': "_bfhkizff",
    'color.skeleton.subtle': "_bfhkvkf5",
    'elevation.surface': "_bfhkvuon",
    'elevation.surface.hovered': "_bfhk19i6",
    'elevation.surface.pressed': "_bfhk13ro",
    'elevation.surface.overlay': "_bfhk1bhr",
    'elevation.surface.overlay.hovered': "_bfhk6o2t",
    'elevation.surface.overlay.pressed': "_bfhkm8nx",
    'elevation.surface.raised': "_bfhkhp5a",
    'elevation.surface.raised.hovered': "_bfhk116u",
    'elevation.surface.raised.pressed': "_bfhk14aj",
    'elevation.surface.sunken': "_bfhkhfxm",
    'utility.elevation.surface.current': "_bfhkchd4"
};
var $f3b0d8b8c6613242$var$CURRENT_SURFACE_CSS_VAR = "--ds-elevation-surface-current";
var $f3b0d8b8c6613242$var$setSurfaceTokenMap = {
    'elevation.surface': "_1q1lvuon",
    'elevation.surface.hovered': "_1q1l19i6",
    'elevation.surface.pressed': "_1q1l13ro",
    'elevation.surface.overlay': "_1q1l1bhr",
    'elevation.surface.overlay.hovered': "_1q1l6o2t",
    'elevation.surface.overlay.pressed': "_1q1lm8nx",
    'elevation.surface.raised': "_1q1lhp5a",
    'elevation.surface.raised.hovered': "_1q1l116u",
    'elevation.surface.raised.pressed': "_1q1l14aj",
    'elevation.surface.sunken': "_1q1lhfxm"
};
var $f3b0d8b8c6613242$var$paddingBlockStartMap = {
    'space.0': "_1q51ze3t",
    'space.025': "_1q51v77o",
    'space.050': "_1q511b66",
    'space.075': "_1q5112x7",
    'space.100': "_1q51u2gc",
    'space.150': "_1q51utpp",
    'space.200': "_1q51pxbi",
    'space.250': "_1q51v47k",
    'space.300': "_1q511ejb",
    'space.400': "_1q51xy5q",
    'space.500': "_1q511jfw",
    'space.600': "_1q51oahv",
    'space.800': "_1q51xncg",
    'space.1000': "_1q511epz"
};
var $f3b0d8b8c6613242$var$paddingBlockEndMap = {
    'space.0': "_85i5ze3t",
    'space.025': "_85i5v77o",
    'space.050': "_85i51b66",
    'space.075': "_85i512x7",
    'space.100': "_85i5u2gc",
    'space.150': "_85i5utpp",
    'space.200': "_85i5pxbi",
    'space.250': "_85i5v47k",
    'space.300': "_85i51ejb",
    'space.400': "_85i5xy5q",
    'space.500': "_85i51jfw",
    'space.600': "_85i5oahv",
    'space.800': "_85i5xncg",
    'space.1000': "_85i51epz"
};
var $f3b0d8b8c6613242$var$paddingInlineStartMap = {
    'space.0': "_bozgze3t",
    'space.025': "_bozgv77o",
    'space.050': "_bozg1b66",
    'space.075': "_bozg12x7",
    'space.100': "_bozgu2gc",
    'space.150': "_bozgutpp",
    'space.200': "_bozgpxbi",
    'space.250': "_bozgv47k",
    'space.300': "_bozg1ejb",
    'space.400': "_bozgxy5q",
    'space.500': "_bozg1jfw",
    'space.600': "_bozgoahv",
    'space.800': "_bozgxncg",
    'space.1000': "_bozg1epz"
};
var $f3b0d8b8c6613242$var$paddingInlineEndMap = {
    'space.0': "_y4tize3t",
    'space.025': "_y4tiv77o",
    'space.050': "_y4ti1b66",
    'space.075': "_y4ti12x7",
    'space.100': "_y4tiu2gc",
    'space.150': "_y4tiutpp",
    'space.200': "_y4tipxbi",
    'space.250': "_y4tiv47k",
    'space.300': "_y4ti1ejb",
    'space.400': "_y4tixy5q",
    'space.500': "_y4ti1jfw",
    'space.600': "_y4tioahv",
    'space.800': "_y4tixncg",
    'space.1000': "_y4ti1epz"
};
/**
 * __Box__
 *
 * A Box is a primitive component that has the design decisions of the Atlassian Design System baked in.
 * Renders a `div` by default.
 *
 * - [Examples](https://atlassian.design/components/primitives/box/examples)
 * - [Code](https://atlassian.design/components/primitives/box/code)
 * - [Usage](https://atlassian.design/components/primitives/box/usage)
 */ var $f3b0d8b8c6613242$var$Box = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? 'div' : _ref$as, children = _ref.children, backgroundColor = _ref.backgroundColor, padding = _ref.padding, _ref$paddingBlock = _ref.paddingBlock, paddingBlock = _ref$paddingBlock === void 0 ? padding : _ref$paddingBlock, _ref$paddingBlockStar = _ref.paddingBlockStart, paddingBlockStart = _ref$paddingBlockStar === void 0 ? paddingBlock : _ref$paddingBlockStar, _ref$paddingBlockEnd = _ref.paddingBlockEnd, paddingBlockEnd = _ref$paddingBlockEnd === void 0 ? paddingBlock : _ref$paddingBlockEnd, _ref$paddingInline = _ref.paddingInline, paddingInline = _ref$paddingInline === void 0 ? padding : _ref$paddingInline, _ref$paddingInlineSta = _ref.paddingInlineStart, paddingInlineStart = _ref$paddingInlineSta === void 0 ? paddingInline : _ref$paddingInlineSta, _ref$paddingInlineEnd = _ref.paddingInlineEnd, paddingInlineEnd = _ref$paddingInlineEnd === void 0 ? paddingInline : _ref$paddingInlineEnd, style = _ref.style, testId = _ref.testId, xcss = _ref.xcss, htmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $f3b0d8b8c6613242$var$_excluded);
    // This is to remove className from safeHtmlAttributes
    // @ts-ignore -- not using expect since it causes issues with help-center local consumption - className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(htmlAttributes, $f3b0d8b8c6613242$var$_excluded2);
    var node = /*#__PURE__*/ $5FkrB.createElement(Component, (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        style: style,
        ref: ref,
        className: (0, $970q7.default)([
            "_19itglyw _vchhusvi _r06hglyw",
            backgroundColor && $f3b0d8b8c6613242$var$backgroundColorMap[backgroundColor],
            backgroundColor && $f3b0d8b8c6613242$var$isSurfaceToken(backgroundColor) && $f3b0d8b8c6613242$var$setSurfaceTokenMap[backgroundColor],
            paddingBlockStart && $f3b0d8b8c6613242$var$paddingBlockStartMap[paddingBlockStart],
            paddingBlockEnd && $f3b0d8b8c6613242$var$paddingBlockEndMap[paddingBlockEnd],
            paddingInlineStart && $f3b0d8b8c6613242$var$paddingInlineStartMap[paddingInlineStart],
            paddingInlineEnd && $f3b0d8b8c6613242$var$paddingInlineEndMap[paddingInlineEnd],
            xcss
        ])
    }, safeHtmlAttributes, {
        "data-testid": testId
    }), children);
    if (backgroundColor) return /*#__PURE__*/ $5FkrB.createElement((0, $bemp3.SurfaceContext).Provider, {
        value: backgroundColor
    }, node);
    return node;
});
var $f3b0d8b8c6613242$export$2e2bcd8739ae039 = $f3b0d8b8c6613242$var$Box;
function $f3b0d8b8c6613242$var$isSurfaceToken(backgroundColor) {
    return backgroundColor in $f3b0d8b8c6613242$var$setSurfaceTokenMap;
}


var $5ab605e96ac109d3$var$_excluded = [
    "children",
    "testId",
    "appearance",
    "newWindowLabel",
    "target",
    "className",
    "style"
];
var $5ab605e96ac109d3$var$styles = {
    visitedLink: "_ect41gqc _10531ra0 _1ien1ra0 _n0fx1ra0 _1vhv17z1",
    defaultAppearance: "_4bfu1r31 _1hms8stv _ajmmnqa1 _syaz13af _ect41gqc _1a3b1r31 _4fpr8stv _5goinqa1 _f8pj13af _9oik1r31 _1bnxglyw _jf4cnqa1 _30l313af _1nrm1r31 _c2waglyw _1iohnqa1 _9h8h12zz",
    subtleAppearance: "_4bfu1r31 _1hmsglyw _ajmmnqa1 _ect41gqc _syazazsu _1a3b1r31 _4fprglyw _5goinqa1 _f8pjazsu _9oik1r31 _1bnx8stv _jf4cnqa1 _30l3azsu _1nrm1r31 _c2wa8stv _1iohnqa1 _9h8hi7uo",
    inverseAppearance: "_4bfu1r31 _1hms8stv _ajmmnqa1 _ect41gqc _syaz15cr _105315cr _1a3b1r31 _4fpr8stv _5goinqa1 _f8pj15cr _9oik1r31 _1bnxglyw _jf4cnqa1 _30l315cr _1nrm1r31 _c2waglyw _1iohnqa1 _9h8h15cr",
    iconWrapper: "_1e0c1nu9 _o5721q9c _s7n41q9y _kqswh2mm _152ttb3r"
};
var $5ab605e96ac109d3$var$iconStyles = null;
var $5ab605e96ac109d3$var$LinkWithoutRef = function LinkWithoutRef(_ref, ref) {
    var children = _ref.children, testId = _ref.testId, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'default' : _ref$appearance, newWindowLabel = _ref.newWindowLabel, target = _ref.target, preventedClassName = _ref.className, preventedStyle = _ref.style, htmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $5ab605e96ac109d3$var$_excluded);
    return /*#__PURE__*/ $5FkrB.createElement((0, $f7402c8717b4416e$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, htmlAttributes, {
        target: target,
        ref: ref,
        xcss: (0, $b5cd78e10bc362b2$export$a274e22fb40f762e)(appearance === 'default' && $5ab605e96ac109d3$var$styles.defaultAppearance, appearance === 'subtle' && $5ab605e96ac109d3$var$styles.subtleAppearance, appearance === 'inverse' && $5ab605e96ac109d3$var$styles.inverseAppearance, // Visited styles are not supported for inverse links due to contrast issues
        appearance !== 'inverse' && $5ab605e96ac109d3$var$styles.visitedLink),
        testId: testId,
        componentName: "Link",
        newWindowLabel: newWindowLabel
    }), children, target === '_blank' && /*#__PURE__*/ $5FkrB.createElement((0, $f3b0d8b8c6613242$export$2e2bcd8739ae039), {
        as: "span",
        xcss: $5ab605e96ac109d3$var$styles.iconWrapper,
        testId: testId && "".concat(testId, "__icon")
    }, "\uFEFF", (0, $9Zzpd.fg)('platform-visual-refresh-icons') ? /*#__PURE__*/ $5FkrB.createElement("svg", {
        width: "12",
        height: "12",
        viewBox: "0 0 12 12",
        fill: "none",
        className: (0, $970q7.default)([
            "_1bsbgm0b _4t3igm0b _ahbqzjw7"
        ])
    }, /*#__PURE__*/ $5FkrB.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M0 1.82609C0 0.817938 0.817938 0 1.82609 0H3.91304V1.04348H1.82609C1.39424 1.04348 1.04348 1.39424 1.04348 1.82609V10.1739C1.04348 10.6058 1.39424 10.9565 1.82609 10.9565H10.1739C10.6058 10.9565 10.9565 10.6058 10.9565 10.1739V8.08696H12V10.1739C12 11.1821 11.1821 12 10.1739 12H1.82609C0.817938 12 0 11.1821 0 10.1739V1.82609ZM7.04348 0H12V4.95652H10.9565V1.78133L6.36893 6.36893L5.63107 5.63107L10.2187 1.04348H7.04348V0Z",
        fill: "currentColor"
    })) : /*#__PURE__*/ $5FkrB.createElement("svg", {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        className: (0, $970q7.default)([
            "_1bsbgm0b _4t3igm0b _ahbqzjw7"
        ])
    }, /*#__PURE__*/ $5FkrB.createElement("path", {
        d: "M17.5715 3.95926L10.7587 10.772C10.5546 10.9692 10.2811 11.0784 9.99723 11.0759C9.71338 11.0734 9.44185 10.9596 9.24113 10.7589C9.04041 10.5581 8.92655 10.2866 8.92409 10.0027C8.92162 9.7189 9.03074 9.44543 9.22794 9.24125L16.0407 2.4285H14.3237C14.0366 2.4285 13.7613 2.31444 13.5582 2.11142C13.3552 1.90839 13.2411 1.63303 13.2411 1.34591C13.2411 1.05879 13.3552 0.783424 13.5582 0.580399C13.7613 0.377373 14.0366 0.263314 14.3237 0.263314H18.4981C18.5509 0.254962 18.6043 0.250507 18.658 0.250041C18.8017 0.248792 18.9443 0.276183 19.0773 0.330617C19.2104 0.385051 19.3313 0.465437 19.4329 0.567084C19.5346 0.668732 19.6149 0.789606 19.6694 0.922652C19.7238 1.0557 19.7512 1.19825 19.75 1.342C19.7495 1.3956 19.7451 1.44896 19.7367 1.50165V5.67628C19.7367 5.9634 19.6227 6.23877 19.4196 6.44179C19.2166 6.64482 18.9412 6.75888 18.6541 6.75888C18.367 6.75888 18.0916 6.64482 17.8886 6.44179C17.6856 6.23877 17.5715 5.9634 17.5715 5.67628V3.95926Z"
    }), /*#__PURE__*/ $5FkrB.createElement("path", {
        d: "M2.41519 17.5848V2.4285H8.91076V0.263314H2.41194C1.22001 0.263314 0.25 1.23007 0.25 2.42201V17.5913C0.250574 18.1638 0.47834 18.7127 0.883283 19.1175C1.28823 19.5222 1.83724 19.7497 2.40978 19.75H17.5769C17.8608 19.7499 18.1418 19.6938 18.404 19.585C18.6662 19.4762 18.9044 19.3168 19.105 19.116C19.3055 18.9151 19.4646 18.6767 19.573 18.4143C19.6814 18.152 19.737 17.8708 19.7367 17.587V11.0893H17.5715V17.5848H2.41519Z"
    }))));
};
// Workarounds to support generic types with forwardRef
/**
 * __Link__
 *
 * A link is an inline text element that navigates to a new location when clicked.
 *
 * - [Examples](https://atlassian.design/components/primitives/link/examples)
 * - [Code](https://atlassian.design/components/primitives/link/code)
 * - [Usage](https://atlassian.design/components/primitives/link/usage)
 */ var $5ab605e96ac109d3$var$Link = /*#__PURE__*/ (0, $5FkrB.forwardRef)($5ab605e96ac109d3$var$LinkWithoutRef);
var $5ab605e96ac109d3$export$2e2bcd8739ae039 = $5ab605e96ac109d3$var$Link;


/* pressable.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $kqp0i = parcelRequire("kqp0i");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");


var $hUFig = parcelRequire("hUFig");


var $dJ32z = parcelRequire("dJ32z");

var $eVb4V = parcelRequire("eVb4V");

var $eqVaP = parcelRequire("eqVaP");

var $605ff0fe25231d2b$var$_excluded = [
    "children",
    "isDisabled",
    "type",
    "onClick",
    "interactionName",
    "componentName",
    "analyticsContext",
    "style",
    "testId",
    "xcss",
    "tabIndex"
], $605ff0fe25231d2b$var$_excluded2 = [
    "className"
];
var $605ff0fe25231d2b$var$styles = {
    root: "_19itglyw _vchhusvi _r06hglyw _80omtlke",
    disabled: "_80om13gf"
};
/**
 * __Pressable__
 *
 * A primitive for building custom buttons.
 *
 * - [Examples](https://atlassian.design/components/primitives/pressable/examples)
 * - [Code](https://atlassian.design/components/primitives/pressable/code)
 * - [Usage](https://atlassian.design/components/primitives/pressable/usage)
 */ var $605ff0fe25231d2b$var$Pressable = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function(_ref, ref) {
    var children = _ref.children, isDisabled = _ref.isDisabled, _ref$type = _ref.type, type = _ref$type === void 0 ? 'button' : _ref$type, _ref$onClick = _ref.onClick, providedOnClick = _ref$onClick === void 0 ? (0, $eVb4V.default) : _ref$onClick, interactionName = _ref.interactionName, componentName = _ref.componentName, analyticsContext = _ref.analyticsContext, style = _ref.style, testId = _ref.testId, xcss = _ref.xcss, tabIndex = _ref.tabIndex, htmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $605ff0fe25231d2b$var$_excluded);
    var interactionContext = (0, $5FkrB.useContext)((0, $eqVaP.default));
    var handleClick = (0, $5FkrB.useCallback)(function(e, analyticsEvent) {
        interactionContext && interactionContext.tracePress(interactionName, e.timeStamp);
        providedOnClick(e, analyticsEvent);
    }, [
        providedOnClick,
        interactionContext,
        interactionName
    ]);
    var onClick = (0, $75b909bb27e39354$export$a4687b0234b40e28)({
        fn: handleClick,
        action: 'clicked',
        componentName: componentName || 'Pressable',
        packageName: "@atlaskit/primitives",
        packageVersion: "16.4.4",
        analyticsData: analyticsContext,
        actionSubject: 'button'
    });
    // This is to remove className from safeHtmlAttributes
    // @ts-expect-error className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(htmlAttributes, $605ff0fe25231d2b$var$_excluded2);
    return /*#__PURE__*/ $5FkrB.createElement((0, $0013faf18cfa29e2$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        as: "button",
        tabIndex: tabIndex !== null && tabIndex !== void 0 ? tabIndex : (0, $dJ32z.isSafari)() && !isDisabled ? 0 : undefined,
        style: style
    }, safeHtmlAttributes, {
        type: type,
        onClick: onClick,
        disabled: isDisabled,
        xcss: (0, $hUFig.cx)($605ff0fe25231d2b$var$styles.root, isDisabled && $605ff0fe25231d2b$var$styles.disabled, xcss),
        testId: testId,
        ref: ref
    }), children);
});
var $605ff0fe25231d2b$export$2e2bcd8739ae039 = $605ff0fe25231d2b$var$Pressable;


var $3fe662b077bc761a$var$styles = {
    common: "_11c82smr",
    anchor: "_k48pi7a9",
    pressable: "_syaz13af _k48p1wq8 _bfhk1j28 _ca0qze3t _u5f3ze3t _n3tdze3t _19bvze3t _9oik1r31 _1bnx8stv _jf4cnqa1 _30l313af _9h8h12zz"
};
/**
 * __Section message action__
 *
 * A section message action is designed to work with the `action` prop from
 * `SectionMessage`. It renders either a button or a link depending on whether
 * an `onClick` or `href` prop is supplied, with a dot separator in between actions.
 *
 * - [Examples](https://atlassian.design/components/section-message/examples#actions)
 */ var $3fe662b077bc761a$var$SectionMessageAction = /*#__PURE__*/ (0, $5FkrB.memo)(function SectionMessageAction(_ref) {
    var children = _ref.children, onClick = _ref.onClick, href = _ref.href, testId = _ref.testId, linkComponent = _ref.linkComponent, target = _ref.target;
    if (!linkComponent) {
        if (href) return /*#__PURE__*/ $5FkrB.createElement("span", {
            className: (0, $970q7.default)([
                $3fe662b077bc761a$var$styles.common,
                $3fe662b077bc761a$var$styles.anchor
            ])
        }, /*#__PURE__*/ $5FkrB.createElement((0, $5ab605e96ac109d3$export$2e2bcd8739ae039), {
            testId: testId,
            onClick: onClick,
            href: href,
            target: target
        }, children));
        if (onClick) return /*#__PURE__*/ $5FkrB.createElement((0, $605ff0fe25231d2b$export$2e2bcd8739ae039), {
            testId: testId,
            onClick: onClick,
            xcss: (0, $b5cd78e10bc362b2$export$a274e22fb40f762e)($3fe662b077bc761a$var$styles.common, $3fe662b077bc761a$var$styles.pressable)
        }, children);
        return /*#__PURE__*/ $5FkrB.createElement((0, $f3b0d8b8c6613242$export$2e2bcd8739ae039), {
            as: "span",
            testId: testId,
            xcss: $3fe662b077bc761a$var$styles.common
        }, children);
    }
    // TODO: Remove this once the deprecated `linkComponent` prop is removed.
    return onClick || href ? /*#__PURE__*/ $5FkrB.createElement((0, $jgNUw.default), {
        testId: testId,
        appearance: "link",
        spacing: "none",
        onClick: onClick,
        href: href,
        component: href ? linkComponent : undefined
    }, children) : /*#__PURE__*/ $5FkrB.createElement((0, $5FkrB.Fragment), null, children);
});
var $3fe662b077bc761a$export$2e2bcd8739ae039 = $3fe662b077bc761a$var$SectionMessageAction;


const $010bee42faeab737$var$messages = (0, $aRMzY.defineMessages)({
    launchTitle: {
        id: 'app.updates.launch.banner.title',
        defaultMessage: 'New ways to stay on top of release notes',
        description: 'Title for the launch banner on the app updates list page'
    },
    launchBody: {
        id: 'app.updates.launch.banner.body',
        defaultMessage: "Quickly catch up on recent changes with the <strong>New this week</strong> filter and unread indicators, or switch to <strong>Release tracks changes</strong> to review what\u2019s included in upcoming Preview and Bundled releases.",
        description: 'Body text for the launch banner on the app updates list page'
    },
    launchLink: {
        id: 'app.updates.launch.banner.link',
        defaultMessage: 'Learn more on Community',
        description: 'Link text for the launch banner on the app updates list page'
    }
});
const $010bee42faeab737$var$RELEASE_NOTES_LAUNCH_POST_URL = 'https://community.atlassian.com/forums/Community-Announcements-articles/Two-new-ways-to-stay-on-top-of-Atlassian-Cloud-release-notes/ba-p/3252956';
const $010bee42faeab737$export$92843d20b8ec0118 = ()=>{
    const { formatMessage: formatMessage } = (0, $6Wx3K.default)();
    return /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $eMiEC.default), {
        appearance: "discovery",
        title: formatMessage($010bee42faeab737$var$messages.launchTitle),
        actions: [
            /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $3fe662b077bc761a$export$2e2bcd8739ae039), {
                href: $010bee42faeab737$var$RELEASE_NOTES_LAUNCH_POST_URL,
                target: "_blank",
                children: formatMessage($010bee42faeab737$var$messages.launchLink)
            })
        ],
        children: /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $d48daa9a522ca942$export$2e2bcd8739ae039), {
            children: formatMessage($010bee42faeab737$var$messages.launchBody, {
                strong: (chunks)=>/*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $d48daa9a522ca942$export$2e2bcd8739ae039), {
                        as: "span",
                        weight: "bold",
                        children: chunks
                    })
            })
        })
    });
};
var $010bee42faeab737$export$2e2bcd8739ae039 = $010bee42faeab737$export$92843d20b8ec0118;




var $5FkrB = parcelRequire("5FkrB");
var $a0cb2f29b373067e$var$__typeError = (msg)=>{
    throw TypeError(msg);
};
var $a0cb2f29b373067e$var$__accessCheck = (obj, member, msg)=>member.has(obj) || $a0cb2f29b373067e$var$__typeError("Cannot " + msg);
var $a0cb2f29b373067e$export$18a094aefa070634 = (obj, member, getter)=>($a0cb2f29b373067e$var$__accessCheck(obj, member, "read from private field"), getter ? getter.call(obj) : member.get(obj));
var $a0cb2f29b373067e$export$addf369becd23283 = (obj, member, value1)=>member.has(obj) ? $a0cb2f29b373067e$var$__typeError("Cannot add the same private member more than once") : member instanceof WeakSet ? member.add(obj) : member.set(obj, value1);
var $a0cb2f29b373067e$export$42432efe6614d3b4 = (obj, member, value1, setter)=>($a0cb2f29b373067e$var$__accessCheck(obj, member, "write to private field"), setter ? setter.call(obj, value1) : member.set(obj, value1), value1);
var $a0cb2f29b373067e$export$fa92d15b718fce20 = (obj, member, method)=>($a0cb2f29b373067e$var$__accessCheck(obj, member, "access private method"), method);
var $a0cb2f29b373067e$export$b1fe7cbb4502036b = (obj, member, setter, getter)=>({
        set _ (value){
            $a0cb2f29b373067e$export$42432efe6614d3b4(obj, member, value, setter);
        },
        get _ () {
            return $a0cb2f29b373067e$export$18a094aefa070634(obj, member, getter);
        }
    });




// src/subscribable.ts
var $78d76f0c1d823036$export$d26086b469ecdbcc = class {
    constructor(){
        this.listeners = /* @__PURE__ */ new Set();
        this.subscribe = this.subscribe.bind(this);
    }
    subscribe(listener) {
        this.listeners.add(listener);
        this.onSubscribe();
        return ()=>{
            this.listeners.delete(listener);
            this.onUnsubscribe();
        };
    }
    hasListeners() {
        return this.listeners.size > 0;
    }
    onSubscribe() {}
    onUnsubscribe() {}
};




// src/timeoutManager.ts
var $c256c6d36f9f33f6$export$d235812f9125bf47 = {
    // We need the wrapper function syntax below instead of direct references to
    // global setTimeout etc.
    //
    // BAD: `setTimeout: setTimeout`
    // GOOD: `setTimeout: (cb, delay) => setTimeout(cb, delay)`
    //
    // If we use direct references here, then anything that wants to spy on or
    // replace the global setTimeout (like tests) won't work since we'll already
    // have a hard reference to the original implementation at the time when this
    // file was imported.
    setTimeout: (callback, delay)=>setTimeout(callback, delay),
    clearTimeout: (timeoutId)=>clearTimeout(timeoutId),
    setInterval: (callback, delay)=>setInterval(callback, delay),
    clearInterval: (intervalId)=>clearInterval(intervalId)
};
var $c256c6d36f9f33f6$var$_provider, $c256c6d36f9f33f6$var$_providerCalled;
var $c256c6d36f9f33f6$export$6336d90323f0ab52 = class {
    constructor(){
        // We cannot have TimeoutManager<T> as we must instantiate it with a concrete
        // type at app boot; and if we leave that type, then any new timer provider
        // would need to support ReturnType<typeof setTimeout>, which is infeasible.
        //
        // We settle for type safety for the TimeoutProvider type, and accept that
        // this class is unsafe internally to allow for extension.
        (0, $a0cb2f29b373067e$export$addf369becd23283)(this, $c256c6d36f9f33f6$var$_provider, $c256c6d36f9f33f6$export$d235812f9125bf47);
        (0, $a0cb2f29b373067e$export$addf369becd23283)(this, $c256c6d36f9f33f6$var$_providerCalled, false);
    }
    setTimeoutProvider(provider) {
        (0, $a0cb2f29b373067e$export$42432efe6614d3b4)(this, $c256c6d36f9f33f6$var$_provider, provider);
    }
    setTimeout(callback, delay) {
        return (0, $a0cb2f29b373067e$export$18a094aefa070634)(this, $c256c6d36f9f33f6$var$_provider).setTimeout(callback, delay);
    }
    clearTimeout(timeoutId) {
        (0, $a0cb2f29b373067e$export$18a094aefa070634)(this, $c256c6d36f9f33f6$var$_provider).clearTimeout(timeoutId);
    }
    setInterval(callback, delay) {
        return (0, $a0cb2f29b373067e$export$18a094aefa070634)(this, $c256c6d36f9f33f6$var$_provider).setInterval(callback, delay);
    }
    clearInterval(intervalId) {
        (0, $a0cb2f29b373067e$export$18a094aefa070634)(this, $c256c6d36f9f33f6$var$_provider).clearInterval(intervalId);
    }
};
$c256c6d36f9f33f6$var$_provider = new WeakMap();
$c256c6d36f9f33f6$var$_providerCalled = new WeakMap();
var $c256c6d36f9f33f6$export$94a2700736e69372 = new $c256c6d36f9f33f6$export$6336d90323f0ab52();
function $c256c6d36f9f33f6$export$5086591e51e32a18(callback) {
    setTimeout(callback, 0);
}


var $e9d6dc959f196f70$export$6acf61af03e62db = typeof window === "undefined" || "Deno" in globalThis;
function $e9d6dc959f196f70$export$8793edee2d425525() {}
function $e9d6dc959f196f70$export$7f095f455ad5af3f(updater, input) {
    return typeof updater === "function" ? updater(input) : updater;
}
function $e9d6dc959f196f70$export$e539f754e934e270(value) {
    return typeof value === "number" && value >= 0 && value !== Infinity;
}
function $e9d6dc959f196f70$export$811b83d62bcf47f0(updatedAt, staleTime) {
    return Math.max(updatedAt + (staleTime || 0) - Date.now(), 0);
}
function $e9d6dc959f196f70$export$cb3145f011bda3ac(staleTime, query) {
    return typeof staleTime === "function" ? staleTime(query) : staleTime;
}
function $e9d6dc959f196f70$export$8c88ee6f2357230d(enabled, query) {
    return typeof enabled === "function" ? enabled(query) : enabled;
}
function $e9d6dc959f196f70$export$c5d1efe363797780(filters, query) {
    const { type: type = "all", exact: exact, fetchStatus: fetchStatus, predicate: predicate, queryKey: queryKey, stale: stale } = filters;
    if (queryKey) {
        if (exact) {
            if (query.queryHash !== $e9d6dc959f196f70$export$cc90ca97bc0d73fd(queryKey, query.options)) return false;
        } else if (!$e9d6dc959f196f70$export$2f07189bb9fa26a7(query.queryKey, queryKey)) return false;
    }
    if (type !== "all") {
        const isActive = query.isActive();
        if (type === "active" && !isActive) return false;
        if (type === "inactive" && isActive) return false;
    }
    if (typeof stale === "boolean" && query.isStale() !== stale) return false;
    if (fetchStatus && fetchStatus !== query.state.fetchStatus) return false;
    if (predicate && !predicate(query)) return false;
    return true;
}
function $e9d6dc959f196f70$export$a1ea5fb559f63ae3(filters, mutation) {
    const { exact: exact, status: status, predicate: predicate, mutationKey: mutationKey } = filters;
    if (mutationKey) {
        if (!mutation.options.mutationKey) return false;
        if (exact) {
            if ($e9d6dc959f196f70$export$1e87d19d4aab5805(mutation.options.mutationKey) !== $e9d6dc959f196f70$export$1e87d19d4aab5805(mutationKey)) return false;
        } else if (!$e9d6dc959f196f70$export$2f07189bb9fa26a7(mutation.options.mutationKey, mutationKey)) return false;
    }
    if (status && mutation.state.status !== status) return false;
    if (predicate && !predicate(mutation)) return false;
    return true;
}
function $e9d6dc959f196f70$export$cc90ca97bc0d73fd(queryKey, options) {
    const hashFn = (options == null ? void 0 : options.queryKeyHashFn) || $e9d6dc959f196f70$export$1e87d19d4aab5805;
    return hashFn(queryKey);
}
function $e9d6dc959f196f70$export$1e87d19d4aab5805(queryKey) {
    return JSON.stringify(queryKey, (_, val)=>$e9d6dc959f196f70$export$53b83ca8eaab0383(val) ? Object.keys(val).sort().reduce((result, key)=>{
            result[key] = val[key];
            return result;
        }, {}) : val);
}
function $e9d6dc959f196f70$export$2f07189bb9fa26a7(a, b) {
    if (a === b) return true;
    if (typeof a !== typeof b) return false;
    if (a && b && typeof a === "object" && typeof b === "object") return Object.keys(b).every((key)=>$e9d6dc959f196f70$export$2f07189bb9fa26a7(a[key], b[key]));
    return false;
}
var $e9d6dc959f196f70$var$hasOwn = Object.prototype.hasOwnProperty;
function $e9d6dc959f196f70$export$77a71fc411098696(a, b) {
    if (a === b) return a;
    const array = $e9d6dc959f196f70$export$7a8558113332b71e(a) && $e9d6dc959f196f70$export$7a8558113332b71e(b);
    if (!array && !($e9d6dc959f196f70$export$53b83ca8eaab0383(a) && $e9d6dc959f196f70$export$53b83ca8eaab0383(b))) return b;
    const aItems = array ? a : Object.keys(a);
    const aSize = aItems.length;
    const bItems = array ? b : Object.keys(b);
    const bSize = bItems.length;
    const copy = array ? new Array(bSize) : {};
    let equalItems = 0;
    for(let i = 0; i < bSize; i++){
        const key = array ? i : bItems[i];
        const aItem = a[key];
        const bItem = b[key];
        if (aItem === bItem) {
            copy[key] = aItem;
            if (array ? i < aSize : $e9d6dc959f196f70$var$hasOwn.call(a, key)) equalItems++;
            continue;
        }
        if (aItem === null || bItem === null || typeof aItem !== "object" || typeof bItem !== "object") {
            copy[key] = bItem;
            continue;
        }
        const v = $e9d6dc959f196f70$export$77a71fc411098696(aItem, bItem);
        copy[key] = v;
        if (v === aItem) equalItems++;
    }
    return aSize === bSize && equalItems === aSize ? a : copy;
}
function $e9d6dc959f196f70$export$3e67810a3f0e9f1c(a, b) {
    if (!b || Object.keys(a).length !== Object.keys(b).length) return false;
    for(const key in a){
        if (a[key] !== b[key]) return false;
    }
    return true;
}
function $e9d6dc959f196f70$export$7a8558113332b71e(value) {
    return Array.isArray(value) && value.length === Object.keys(value).length;
}
function $e9d6dc959f196f70$export$53b83ca8eaab0383(o) {
    if (!$e9d6dc959f196f70$var$hasObjectPrototype(o)) return false;
    const ctor = o.constructor;
    if (ctor === void 0) return true;
    const prot = ctor.prototype;
    if (!$e9d6dc959f196f70$var$hasObjectPrototype(prot)) return false;
    if (!prot.hasOwnProperty("isPrototypeOf")) return false;
    if (Object.getPrototypeOf(o) !== Object.prototype) return false;
    return true;
}
function $e9d6dc959f196f70$var$hasObjectPrototype(o) {
    return Object.prototype.toString.call(o) === "[object Object]";
}
function $e9d6dc959f196f70$export$e772c8ff12451969(timeout) {
    return new Promise((resolve)=>{
        (0, $c256c6d36f9f33f6$export$94a2700736e69372).setTimeout(resolve, timeout);
    });
}
function $e9d6dc959f196f70$export$17619bac5b909b23(prevData, data, options) {
    if (typeof options.structuralSharing === "function") return options.structuralSharing(prevData, data);
    else if (options.structuralSharing !== false) {
        var error;
        return $e9d6dc959f196f70$export$77a71fc411098696(prevData, data);
    }
    return data;
}
function $e9d6dc959f196f70$export$f537417e7e421eac(previousData) {
    return previousData;
}
function $e9d6dc959f196f70$export$ccce65a22a26f2bc(items, item, max = 0) {
    const newItems = [
        ...items,
        item
    ];
    return max && newItems.length > max ? newItems.slice(1) : newItems;
}
function $e9d6dc959f196f70$export$8c6246b73dd61f4a(items, item, max = 0) {
    const newItems = [
        item,
        ...items
    ];
    return max && newItems.length > max ? newItems.slice(0, -1) : newItems;
}
var $e9d6dc959f196f70$export$1aa5a89531b7670d = Symbol();
function $e9d6dc959f196f70$export$c71c44209368a3bc(options, fetchOptions) {
    if (!options.queryFn && (fetchOptions == null ? void 0 : fetchOptions.initialPromise)) return ()=>fetchOptions.initialPromise;
    if (!options.queryFn || options.queryFn === $e9d6dc959f196f70$export$1aa5a89531b7670d) return ()=>Promise.reject(new Error(`Missing queryFn: '${options.queryHash}'`));
    return options.queryFn;
}
function $e9d6dc959f196f70$export$2072f68e6c3507cf(throwOnError, params) {
    if (typeof throwOnError === "function") return throwOnError(...params);
    return !!throwOnError;
}


var $780e8903dcf2df97$var$_focused, $780e8903dcf2df97$var$_cleanup, $780e8903dcf2df97$var$_setup;
var $780e8903dcf2df97$export$86f1af424b2ca4de = class extends (0, $78d76f0c1d823036$export$d26086b469ecdbcc) {
    constructor(){
        super();
        (0, $a0cb2f29b373067e$export$addf369becd23283)(this, $780e8903dcf2df97$var$_focused);
        (0, $a0cb2f29b373067e$export$addf369becd23283)(this, $780e8903dcf2df97$var$_cleanup);
        (0, $a0cb2f29b373067e$export$addf369becd23283)(this, $780e8903dcf2df97$var$_setup);
        (0, $a0cb2f29b373067e$export$42432efe6614d3b4)(this, $780e8903dcf2df97$var$_setup, (onFocus)=>{
            if (!(0, $e9d6dc959f196f70$export$6acf61af03e62db) && window.addEventListener) {
                const listener = ()=>onFocus();
                window.addEventListener("visibilitychange", listener, false);
                return ()=>{
                    window.removeEventListener("visibilitychange", listener);
                };
            }
            return;
        });
    }
    onSubscribe() {
        if (!(0, $a0cb2f29b373067e$export$18a094aefa070634)(this, $780e8903dcf2df97$var$_cleanup)) this.setEventListener((0, $a0cb2f29b373067e$export$18a094aefa070634)(this, $780e8903dcf2df97$var$_setup));
    }
    onUnsubscribe() {
        var _a;
        if (!this.hasListeners()) {
            (_a = (0, $a0cb2f29b373067e$export$18a094aefa070634)(this, $780e8903dcf2df97$var$_cleanup)) == null || _a.call(this);
            (0, $a0cb2f29b373067e$export$42432efe6614d3b4)(this, $780e8903dcf2df97$var$_cleanup, void 0);
        }
    }
    setEventListener(setup) {
        var _a;
        (0, $a0cb2f29b373067e$export$42432efe6614d3b4)(this, $780e8903dcf2df97$var$_setup, setup);
        (_a = (0, $a0cb2f29b373067e$export$18a094aefa070634)(this, $780e8903dcf2df97$var$_cleanup)) == null || _a.call(this);
        (0, $a0cb2f29b373067e$export$42432efe6614d3b4)(this, $780e8903dcf2df97$var$_cleanup, setup((focused)=>{
            if (typeof focused === "boolean") this.setFocused(focused);
            else this.onFocus();
        }));
    }
    setFocused(focused) {
        const changed = (0, $a0cb2f29b373067e$export$18a094aefa070634)(this, $780e8903dcf2df97$var$_focused) !== focused;
        if (changed) {
            (0, $a0cb2f29b373067e$export$42432efe6614d3b4)(this, $780e8903dcf2df97$var$_focused, focused);
            this.onFocus();
        }
    }
    onFocus() {
        const isFocused = this.isFocused();
        this.listeners.forEach((listener)=>{
            listener(isFocused);
        });
    }
    isFocused() {
        var _a;
        if (typeof (0, $a0cb2f29b373067e$export$18a094aefa070634)(this, $780e8903dcf2df97$var$_focused) === "boolean") return (0, $a0cb2f29b373067e$export$18a094aefa070634)(this, $780e8903dcf2df97$var$_focused);
        return ((_a = globalThis.document) == null ? void 0 : _a.visibilityState) !== "hidden";
    }
};
$780e8903dcf2df97$var$_focused = new WeakMap();
$780e8903dcf2df97$var$_cleanup = new WeakMap();
$780e8903dcf2df97$var$_setup = new WeakMap();
var $780e8903dcf2df97$export$6bf54661be5b02cf = new $780e8903dcf2df97$export$86f1af424b2ca4de();




var $a37b31dc4086690f$export$7c76da44185e6090 = (0, $c256c6d36f9f33f6$export$5086591e51e32a18);
function $a37b31dc4086690f$export$316a8efd03cd1458() {
    let queue = [];
    let transactions = 0;
    let notifyFn = (callback)=>{
        callback();
    };
    let batchNotifyFn = (callback)=>{
        callback();
    };
    let scheduleFn = $a37b31dc4086690f$export$7c76da44185e6090;
    const schedule = (callback)=>{
        if (transactions) queue.push(callback);
        else scheduleFn(()=>{
            notifyFn(callback);
        });
    };
    const flush = ()=>{
        const originalQueue = queue;
        queue = [];
        if (originalQueue.length) scheduleFn(()=>{
            batchNotifyFn(()=>{
                originalQueue.forEach((callback)=>{
                    notifyFn(callback);
                });
            });
        });
    };
    return {
        batch: (callback)=>{
            let result;
            transactions++;
            try {
                result = callback();
            } finally{
                transactions--;
                if (!transactions) flush();
            }
            return result;
        },
        /**
     * All calls to the wrapped function will be batched.
     */ batchCalls: (callback)=>{
            return (...args)=>{
                schedule(()=>{
                    callback(...args);
                });
            };
        },
        schedule: schedule,
        /**
     * Use this method to set a custom notify function.
     * This can be used to for example wrap notifications with `React.act` while running tests.
     */ setNotifyFunction: (fn)=>{
            notifyFn = fn;
        },
        /**
     * Use this method to set a custom function to batch notifications together into a single tick.
     * By default React Query will use the batch function provided by ReactDOM or React Native.
     */ setBatchNotifyFunction: (fn)=>{
            batchNotifyFn = fn;
        },
        setScheduler: (fn)=>{
            scheduleFn = fn;
        }
    };
}
var $a37b31dc4086690f$export$520687f44db6e1ab = $a37b31dc4086690f$export$316a8efd03cd1458();










var $3b7c5eeebfe845db$var$_online, $3b7c5eeebfe845db$var$_cleanup, $3b7c5eeebfe845db$var$_setup;
var $3b7c5eeebfe845db$export$58774fb55d5ff7fc = class extends (0, $78d76f0c1d823036$export$d26086b469ecdbcc) {
    constructor(){
        super();
        (0, $a0cb2f29b373067e$export$addf369becd23283)(this, $3b7c5eeebfe845db$var$_online, true);
        (0, $a0cb2f29b373067e$export$addf369becd23283)(this, $3b7c5eeebfe845db$var$_cleanup);
        (0, $a0cb2f29b373067e$export$addf369becd23283)(this, $3b7c5eeebfe845db$var$_setup);
        (0, $a0cb2f29b373067e$export$42432efe6614d3b4)(this, $3b7c5eeebfe845db$var$_setup, (onOnline)=>{
            if (!(0, $e9d6dc959f196f70$export$6acf61af03e62db) && window.addEventListener) {
                const onlineListener = ()=>onOnline(true);
                const offlineListener = ()=>onOnline(false);
                window.addEventListener("online", onlineListener, false);
                window.addEventListener("offline", offlineListener, false);
                return ()=>{
                    window.removeEventListener("online", onlineListener);
                    window.removeEventListener("offline", offlineListener);
                };
            }
            return;
        });
    }
    onSubscribe() {
        if (!(0, $a0cb2f29b373067e$export$18a094aefa070634)(this, $3b7c5eeebfe845db$var$_cleanup)) this.setEventListener((0, $a0cb2f29b373067e$export$18a094aefa070634)(this, $3b7c5eeebfe845db$var$_setup));
    }
    onUnsubscribe() {
        var _a;
        if (!this.hasListeners()) {
            (_a = (0, $a0cb2f29b373067e$export$18a094aefa070634)(this, $3b7c5eeebfe845db$var$_cleanup)) == null || _a.call(this);
            (0, $a0cb2f29b373067e$export$42432efe6614d3b4)(this, $3b7c5eeebfe845db$var$_cleanup, void 0);
        }
    }
    setEventListener(setup) {
        var _a;
        (0, $a0cb2f29b373067e$export$42432efe6614d3b4)(this, $3b7c5eeebfe845db$var$_setup, setup);
        (_a = (0, $a0cb2f29b373067e$export$18a094aefa070634)(this, $3b7c5eeebfe845db$var$_cleanup)) == null || _a.call(this);
        (0, $a0cb2f29b373067e$export$42432efe6614d3b4)(this, $3b7c5eeebfe845db$var$_cleanup, setup(this.setOnline.bind(this)));
    }
    setOnline(online) {
        const changed = (0, $a0cb2f29b373067e$export$18a094aefa070634)(this, $3b7c5eeebfe845db$var$_online) !== online;
        if (changed) {
            (0, $a0cb2f29b373067e$export$42432efe6614d3b4)(this, $3b7c5eeebfe845db$var$_online, online);
            this.listeners.forEach((listener)=>{
                listener(online);
            });
        }
    }
    isOnline() {
        return (0, $a0cb2f29b373067e$export$18a094aefa070634)(this, $3b7c5eeebfe845db$var$_online);
    }
};
$3b7c5eeebfe845db$var$_online = new WeakMap();
$3b7c5eeebfe845db$var$_cleanup = new WeakMap();
$3b7c5eeebfe845db$var$_setup = new WeakMap();
var $3b7c5eeebfe845db$export$b113e788b2dd3fdc = new $3b7c5eeebfe845db$export$58774fb55d5ff7fc();




function $62cc4beebf37142c$export$d54630db02a12b72() {
    let resolve;
    let reject;
    const thenable = new Promise((_resolve, _reject)=>{
        resolve = _resolve;
        reject = _reject;
    });
    thenable.status = "pending";
    thenable.catch(()=>{});
    function finalize(data) {
        Object.assign(thenable, data);
        delete thenable.resolve;
        delete thenable.reject;
    }
    thenable.resolve = (value)=>{
        finalize({
            status: "fulfilled",
            value: value
        });
        resolve(value);
    };
    thenable.reject = (reason)=>{
        finalize({
            status: "rejected",
            reason: reason
        });
        reject(reason);
    };
    return thenable;
}
function $62cc4beebf37142c$export$216296c47a9d1275(promise) {
    var _a;
    let data;
    (_a = promise.then((result)=>{
        data = result;
        return result;
    }, (0, $e9d6dc959f196f70$export$8793edee2d425525))) == null || _a.catch((0, $e9d6dc959f196f70$export$8793edee2d425525));
    if (data !== void 0) return {
        data: data
    };
    return void 0;
}



function $c0d8ccc060892ed3$var$defaultRetryDelay(failureCount) {
    return Math.min(1e3 * 2 ** failureCount, 3e4);
}
function $c0d8ccc060892ed3$export$61b92f63f30245cf(networkMode) {
    return (networkMode ?? "online") === "online" ? (0, $3b7c5eeebfe845db$export$b113e788b2dd3fdc).isOnline() : true;
}
var $c0d8ccc060892ed3$export$a8430ed4188f35a9 = class extends Error {
    constructor(options){
        super("CancelledError");
        this.revert = options == null ? void 0 : options.revert;
        this.silent = options == null ? void 0 : options.silent;
    }
};
function $c0d8ccc060892ed3$export$986cc6445c1d323(value) {
    return value instanceof $c0d8ccc060892ed3$export$a8430ed4188f35a9;
}
function $c0d8ccc060892ed3$export$2cbd00fe8a2c8d85(config) {
    let isRetryCancelled = false;
    let failureCount = 0;
    let continueFn;
    const thenable = (0, $62cc4beebf37142c$export$d54630db02a12b72)();
    const isResolved = ()=>thenable.status !== "pending";
    const cancel = (cancelOptions)=>{
        var _a;
        if (!isResolved()) {
            const error = new $c0d8ccc060892ed3$export$a8430ed4188f35a9(cancelOptions);
            reject(error);
            (_a = config.onCancel) == null || _a.call(config, error);
        }
    };
    const cancelRetry = ()=>{
        isRetryCancelled = true;
    };
    const continueRetry = ()=>{
        isRetryCancelled = false;
    };
    const canContinue = ()=>(0, $780e8903dcf2df97$export$6bf54661be5b02cf).isFocused() && (config.networkMode === "always" || (0, $3b7c5eeebfe845db$export$b113e788b2dd3fdc).isOnline()) && config.canRun();
    const canStart = ()=>$c0d8ccc060892ed3$export$61b92f63f30245cf(config.networkMode) && config.canRun();
    const resolve = (value)=>{
        if (!isResolved()) {
            continueFn == null || continueFn();
            thenable.resolve(value);
        }
    };
    const reject = (value)=>{
        if (!isResolved()) {
            continueFn == null || continueFn();
            thenable.reject(value);
        }
    };
    const pause = ()=>{
        return new Promise((continueResolve)=>{
            var _a;
            continueFn = (value)=>{
                if (isResolved() || canContinue()) continueResolve(value);
            };
            (_a = config.onPause) == null || _a.call(config);
        }).then(()=>{
            var _a;
            continueFn = void 0;
            if (!isResolved()) (_a = config.onContinue) == null || _a.call(config);
        });
    };
    const run = ()=>{
        if (isResolved()) return;
        let promiseOrValue;
        const initialPromise = failureCount === 0 ? config.initialPromise : void 0;
        try {
            promiseOrValue = initialPromise ?? config.fn();
        } catch (error) {
            promiseOrValue = Promise.reject(error);
        }
        Promise.resolve(promiseOrValue).then(resolve).catch((error)=>{
            var _a;
            if (isResolved()) return;
            const retry = config.retry ?? ((0, $e9d6dc959f196f70$export$6acf61af03e62db) ? 0 : 3);
            const retryDelay = config.retryDelay ?? $c0d8ccc060892ed3$var$defaultRetryDelay;
            const delay = typeof retryDelay === "function" ? retryDelay(failureCount, error) : retryDelay;
            const shouldRetry = retry === true || typeof retry === "number" && failureCount < retry || typeof retry === "function" && retry(failureCount, error);
            if (isRetryCancelled || !shouldRetry) {
                reject(error);
                return;
            }
            failureCount++;
            (_a = config.onFail) == null || _a.call(config, failureCount, error);
            (0, $e9d6dc959f196f70$export$e772c8ff12451969)(delay).then(()=>{
                return canContinue() ? void 0 : pause();
            }).then(()=>{
                if (isRetryCancelled) reject(error);
                else run();
            });
        });
    };
    return {
        promise: thenable,
        status: ()=>thenable.status,
        cancel: cancel,
        continue: ()=>{
            continueFn == null || continueFn();
            return thenable;
        },
        cancelRetry: cancelRetry,
        continueRetry: continueRetry,
        canStart: canStart,
        start: ()=>{
            if (canStart()) run();
            else pause().then(run);
            return thenable;
        }
    };
}





var $b5f33a596cb9c395$var$_gcTimeout;
var $b5f33a596cb9c395$export$e09608847fcc8c59 = class {
    constructor(){
        (0, $a0cb2f29b373067e$export$addf369becd23283)(this, $b5f33a596cb9c395$var$_gcTimeout);
    }
    destroy() {
        this.clearGcTimeout();
    }
    scheduleGc() {
        this.clearGcTimeout();
        if ((0, $e9d6dc959f196f70$export$e539f754e934e270)(this.gcTime)) (0, $a0cb2f29b373067e$export$42432efe6614d3b4)(this, $b5f33a596cb9c395$var$_gcTimeout, (0, $c256c6d36f9f33f6$export$94a2700736e69372).setTimeout(()=>{
            this.optionalRemove();
        }, this.gcTime));
    }
    updateGcTime(newGcTime) {
        this.gcTime = Math.max(this.gcTime || 0, newGcTime ?? ((0, $e9d6dc959f196f70$export$6acf61af03e62db) ? Infinity : 300000));
    }
    clearGcTimeout() {
        if ((0, $a0cb2f29b373067e$export$18a094aefa070634)(this, $b5f33a596cb9c395$var$_gcTimeout)) {
            (0, $c256c6d36f9f33f6$export$94a2700736e69372).clearTimeout((0, $a0cb2f29b373067e$export$18a094aefa070634)(this, $b5f33a596cb9c395$var$_gcTimeout));
            (0, $a0cb2f29b373067e$export$42432efe6614d3b4)(this, $b5f33a596cb9c395$var$_gcTimeout, void 0);
        }
    }
};
$b5f33a596cb9c395$var$_gcTimeout = new WeakMap();


var $d3cc80c94d2af732$var$_initialState, $d3cc80c94d2af732$var$_revertState, $d3cc80c94d2af732$var$_cache, $d3cc80c94d2af732$var$_client, $d3cc80c94d2af732$var$_retryer, $d3cc80c94d2af732$var$_defaultOptions, $d3cc80c94d2af732$var$_abortSignalConsumed, $d3cc80c94d2af732$var$_Query_instances, $d3cc80c94d2af732$var$dispatch_fn;
var $d3cc80c94d2af732$export$62297b13309008b2 = class extends (0, $b5f33a596cb9c395$export$e09608847fcc8c59) {
    constructor(config){
        super();
        (0, $a0cb2f29b373067e$export$addf369becd23283)(this, $d3cc80c94d2af732$var$_Query_instances);
        (0, $a0cb2f29b373067e$export$addf369becd23283)(this, $d3cc80c94d2af732$var$_initialState);
        (0, $a0cb2f29b373067e$export$addf369becd23283)(this, $d3cc80c94d2af732$var$_revertState);
        (0, $a0cb2f29b373067e$export$addf369becd23283)(this, $d3cc80c94d2af732$var$_cache);
        (0, $a0cb2f29b373067e$export$addf369becd23283)(this, $d3cc80c94d2af732$var$_client);
        (0, $a0cb2f29b373067e$export$addf369becd23283)(this, $d3cc80c94d2af732$var$_retryer);
        (0, $a0cb2f29b373067e$export$addf369becd23283)(this, $d3cc80c94d2af732$var$_defaultOptions);
        (0, $a0cb2f29b373067e$export$addf369becd23283)(this, $d3cc80c94d2af732$var$_abortSignalConsumed);
        (0, $a0cb2f29b373067e$export$42432efe6614d3b4)(this, $d3cc80c94d2af732$var$_abortSignalConsumed, false);
        (0, $a0cb2f29b373067e$export$42432efe6614d3b4)(this, $d3cc80c94d2af732$var$_defaultOptions, config.defaultOptions);
        this.setOptions(config.options);
        this.observers = [];
        (0, $a0cb2f29b373067e$export$42432efe6614d3b4)(this, $d3cc80c94d2af732$var$_client, config.client);
        (0, $a0cb2f29b373067e$export$42432efe6614d3b4)(this, $d3cc80c94d2af732$var$_cache, (0, $a0cb2f29b373067e$export$18a094aefa070634)(this, $d3cc80c94d2af732$var$_client).getQueryCache());
        this.queryKey = config.queryKey;
        this.queryHash = config.queryHash;
        (0, $a0cb2f29b373067e$export$42432efe6614d3b4)(this, $d3cc80c94d2af732$var$_initialState, $d3cc80c94d2af732$var$getDefaultState(this.options));
        this.state = config.state ?? (0, $a0cb2f29b373067e$export$18a094aefa070634)(this, $d3cc80c94d2af732$var$_initialState);
        this.scheduleGc();
    }
    get meta() {
        return this.options.meta;
    }
    get promise() {
        var _a;
        return (_a = (0, $a0cb2f29b373067e$export$18a094aefa070634)(this, $d3cc80c94d2af732$var$_retryer)) == null ? void 0 : _a.promise;
    }
    setOptions(options) {
        this.options = {
            ...(0, $a0cb2f29b373067e$export$18a094aefa070634)(this, $d3cc80c94d2af732$var$_defaultOptions),
            ...options
        };
        this.updateGcTime(this.options.gcTime);
        if (this.state && this.state.data === void 0) {
            const defaultState = $d3cc80c94d2af732$var$getDefaultState(this.options);
            if (defaultState.data !== void 0) {
                this.setState($d3cc80c94d2af732$var$successState(defaultState.data, defaultState.dataUpdatedAt));
                (0, $a0cb2f29b373067e$export$42432efe6614d3b4)(this, $d3cc80c94d2af732$var$_initialState, defaultState);
            }
        }
    }
    optionalRemove() {
        if (!this.observers.length && this.state.fetchStatus === "idle") (0, $a0cb2f29b373067e$export$18a094aefa070634)(this, $d3cc80c94d2af732$var$_cache).remove(this);
    }
    setData(newData, options) {
        const data = (0, $e9d6dc959f196f70$export$17619bac5b909b23)(this.state.data, newData, this.options);
        (0, $a0cb2f29b373067e$export$fa92d15b718fce20)(this, $d3cc80c94d2af732$var$_Query_instances, $d3cc80c94d2af732$var$dispatch_fn).call(this, {
            data: data,
            type: "success",
            dataUpdatedAt: options == null ? void 0 : options.updatedAt,
            manual: options == null ? void 0 : options.manual
        });
        return data;
    }
    setState(state, setStateOptions) {
        (0, $a0cb2f29b373067e$export$fa92d15b718fce20)(this, $d3cc80c94d2af732$var$_Query_instances, $d3cc80c94d2af732$var$dispatch_fn).call(this, {
            type: "setState",
            state: state,
            setStateOptions: setStateOptions
        });
    }
    cancel(options) {
        var _a, _b;
        const promise = (_a = (0, $a0cb2f29b373067e$export$18a094aefa070634)(this, $d3cc80c94d2af732$var$_retryer)) == null ? void 0 : _a.promise;
        (_b = (0, $a0cb2f29b373067e$export$18a094aefa070634)(this, $d3cc80c94d2af732$var$_retryer)) == null || _b.cancel(options);
        return promise ? promise.then((0, $e9d6dc959f196f70$export$8793edee2d425525)).catch((0, $e9d6dc959f196f70$export$8793edee2d425525)) : Promise.resolve();
    }
    destroy() {
        super.destroy();
        this.cancel({
            silent: true
        });
    }
    reset() {
        this.destroy();
        this.setState((0, $a0cb2f29b373067e$export$18a094aefa070634)(this, $d3cc80c94d2af732$var$_initialState));
    }
    isActive() {
        return this.observers.some((observer)=>(0, $e9d6dc959f196f70$export$8c88ee6f2357230d)(observer.options.enabled, this) !== false);
    }
    isDisabled() {
        if (this.getObserversCount() > 0) return !this.isActive();
        return this.options.queryFn === (0, $e9d6dc959f196f70$export$1aa5a89531b7670d) || this.state.dataUpdateCount + this.state.errorUpdateCount === 0;
    }
    isStatic() {
        if (this.getObserversCount() > 0) return this.observers.some((observer)=>(0, $e9d6dc959f196f70$export$cb3145f011bda3ac)(observer.options.staleTime, this) === "static");
        return false;
    }
    isStale() {
        if (this.getObserversCount() > 0) return this.observers.some((observer)=>observer.getCurrentResult().isStale);
        return this.state.data === void 0 || this.state.isInvalidated;
    }
    isStaleByTime(staleTime = 0) {
        if (this.state.data === void 0) return true;
        if (staleTime === "static") return false;
        if (this.state.isInvalidated) return true;
        return !(0, $e9d6dc959f196f70$export$811b83d62bcf47f0)(this.state.dataUpdatedAt, staleTime);
    }
    onFocus() {
        var _a;
        const observer = this.observers.find((x)=>x.shouldFetchOnWindowFocus());
        observer == null || observer.refetch({
            cancelRefetch: false
        });
        (_a = (0, $a0cb2f29b373067e$export$18a094aefa070634)(this, $d3cc80c94d2af732$var$_retryer)) == null || _a.continue();
    }
    onOnline() {
        var _a;
        const observer = this.observers.find((x)=>x.shouldFetchOnReconnect());
        observer == null || observer.refetch({
            cancelRefetch: false
        });
        (_a = (0, $a0cb2f29b373067e$export$18a094aefa070634)(this, $d3cc80c94d2af732$var$_retryer)) == null || _a.continue();
    }
    addObserver(observer) {
        if (!this.observers.includes(observer)) {
            this.observers.push(observer);
            this.clearGcTimeout();
            (0, $a0cb2f29b373067e$export$18a094aefa070634)(this, $d3cc80c94d2af732$var$_cache).notify({
                type: "observerAdded",
                query: this,
                observer: observer
            });
        }
    }
    removeObserver(observer) {
        if (this.observers.includes(observer)) {
            this.observers = this.observers.filter((x)=>x !== observer);
            if (!this.observers.length) {
                if ((0, $a0cb2f29b373067e$export$18a094aefa070634)(this, $d3cc80c94d2af732$var$_retryer)) {
                    if ((0, $a0cb2f29b373067e$export$18a094aefa070634)(this, $d3cc80c94d2af732$var$_abortSignalConsumed)) (0, $a0cb2f29b373067e$export$18a094aefa070634)(this, $d3cc80c94d2af732$var$_retryer).cancel({
                        revert: true
                    });
                    else (0, $a0cb2f29b373067e$export$18a094aefa070634)(this, $d3cc80c94d2af732$var$_retryer).cancelRetry();
                }
                this.scheduleGc();
            }
            (0, $a0cb2f29b373067e$export$18a094aefa070634)(this, $d3cc80c94d2af732$var$_cache).notify({
                type: "observerRemoved",
                query: this,
                observer: observer
            });
        }
    }
    getObserversCount() {
        return this.observers.length;
    }
    invalidate() {
        if (!this.state.isInvalidated) (0, $a0cb2f29b373067e$export$fa92d15b718fce20)(this, $d3cc80c94d2af732$var$_Query_instances, $d3cc80c94d2af732$var$dispatch_fn).call(this, {
            type: "invalidate"
        });
    }
    async fetch(options, fetchOptions) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l;
        if (this.state.fetchStatus !== "idle" && // If the promise in the retyer is already rejected, we have to definitely
        // re-start the fetch; there is a chance that the query is still in a
        // pending state when that happens
        ((_a = (0, $a0cb2f29b373067e$export$18a094aefa070634)(this, $d3cc80c94d2af732$var$_retryer)) == null ? void 0 : _a.status()) !== "rejected") {
            if (this.state.data !== void 0 && (fetchOptions == null ? void 0 : fetchOptions.cancelRefetch)) this.cancel({
                silent: true
            });
            else if ((0, $a0cb2f29b373067e$export$18a094aefa070634)(this, $d3cc80c94d2af732$var$_retryer)) {
                (0, $a0cb2f29b373067e$export$18a094aefa070634)(this, $d3cc80c94d2af732$var$_retryer).continueRetry();
                return (0, $a0cb2f29b373067e$export$18a094aefa070634)(this, $d3cc80c94d2af732$var$_retryer).promise;
            }
        }
        if (options) this.setOptions(options);
        if (!this.options.queryFn) {
            const observer = this.observers.find((x)=>x.options.queryFn);
            if (observer) this.setOptions(observer.options);
        }
        const abortController = new AbortController();
        const addSignalProperty = (object)=>{
            Object.defineProperty(object, "signal", {
                enumerable: true,
                get: ()=>{
                    (0, $a0cb2f29b373067e$export$42432efe6614d3b4)(this, $d3cc80c94d2af732$var$_abortSignalConsumed, true);
                    return abortController.signal;
                }
            });
        };
        const fetchFn = ()=>{
            const queryFn = (0, $e9d6dc959f196f70$export$c71c44209368a3bc)(this.options, fetchOptions);
            const createQueryFnContext = ()=>{
                const queryFnContext2 = {
                    client: (0, $a0cb2f29b373067e$export$18a094aefa070634)(this, $d3cc80c94d2af732$var$_client),
                    queryKey: this.queryKey,
                    meta: this.meta
                };
                addSignalProperty(queryFnContext2);
                return queryFnContext2;
            };
            const queryFnContext = createQueryFnContext();
            (0, $a0cb2f29b373067e$export$42432efe6614d3b4)(this, $d3cc80c94d2af732$var$_abortSignalConsumed, false);
            if (this.options.persister) return this.options.persister(queryFn, queryFnContext, this);
            return queryFn(queryFnContext);
        };
        const createFetchContext = ()=>{
            const context2 = {
                fetchOptions: fetchOptions,
                options: this.options,
                queryKey: this.queryKey,
                client: (0, $a0cb2f29b373067e$export$18a094aefa070634)(this, $d3cc80c94d2af732$var$_client),
                state: this.state,
                fetchFn: fetchFn
            };
            addSignalProperty(context2);
            return context2;
        };
        const context = createFetchContext();
        (_b = this.options.behavior) == null || _b.onFetch(context, this);
        (0, $a0cb2f29b373067e$export$42432efe6614d3b4)(this, $d3cc80c94d2af732$var$_revertState, this.state);
        if (this.state.fetchStatus === "idle" || this.state.fetchMeta !== ((_c = context.fetchOptions) == null ? void 0 : _c.meta)) (0, $a0cb2f29b373067e$export$fa92d15b718fce20)(this, $d3cc80c94d2af732$var$_Query_instances, $d3cc80c94d2af732$var$dispatch_fn).call(this, {
            type: "fetch",
            meta: (_d = context.fetchOptions) == null ? void 0 : _d.meta
        });
        (0, $a0cb2f29b373067e$export$42432efe6614d3b4)(this, $d3cc80c94d2af732$var$_retryer, (0, $c0d8ccc060892ed3$export$2cbd00fe8a2c8d85)({
            initialPromise: fetchOptions == null ? void 0 : fetchOptions.initialPromise,
            fn: context.fetchFn,
            onCancel: (error)=>{
                if (error instanceof (0, $c0d8ccc060892ed3$export$a8430ed4188f35a9) && error.revert) this.setState({
                    ...(0, $a0cb2f29b373067e$export$18a094aefa070634)(this, $d3cc80c94d2af732$var$_revertState),
                    fetchStatus: "idle"
                });
                abortController.abort();
            },
            onFail: (failureCount, error)=>{
                (0, $a0cb2f29b373067e$export$fa92d15b718fce20)(this, $d3cc80c94d2af732$var$_Query_instances, $d3cc80c94d2af732$var$dispatch_fn).call(this, {
                    type: "failed",
                    failureCount: failureCount,
                    error: error
                });
            },
            onPause: ()=>{
                (0, $a0cb2f29b373067e$export$fa92d15b718fce20)(this, $d3cc80c94d2af732$var$_Query_instances, $d3cc80c94d2af732$var$dispatch_fn).call(this, {
                    type: "pause"
                });
            },
            onContinue: ()=>{
                (0, $a0cb2f29b373067e$export$fa92d15b718fce20)(this, $d3cc80c94d2af732$var$_Query_instances, $d3cc80c94d2af732$var$dispatch_fn).call(this, {
                    type: "continue"
                });
            },
            retry: context.options.retry,
            retryDelay: context.options.retryDelay,
            networkMode: context.options.networkMode,
            canRun: ()=>true
        }));
        try {
            const data = await (0, $a0cb2f29b373067e$export$18a094aefa070634)(this, $d3cc80c94d2af732$var$_retryer).start();
            if (data === void 0) throw new Error(`${this.queryHash} data is undefined`);
            this.setData(data);
            (_f = (_e = (0, $a0cb2f29b373067e$export$18a094aefa070634)(this, $d3cc80c94d2af732$var$_cache).config).onSuccess) == null || _f.call(_e, data, this);
            (_h = (_g = (0, $a0cb2f29b373067e$export$18a094aefa070634)(this, $d3cc80c94d2af732$var$_cache).config).onSettled) == null || _h.call(_g, data, this.state.error, this);
            return data;
        } catch (error) {
            if (error instanceof (0, $c0d8ccc060892ed3$export$a8430ed4188f35a9)) {
                if (error.silent) return (0, $a0cb2f29b373067e$export$18a094aefa070634)(this, $d3cc80c94d2af732$var$_retryer).promise;
                else if (error.revert) {
                    if (this.state.data === void 0) throw error;
                    return this.state.data;
                }
            }
            (0, $a0cb2f29b373067e$export$fa92d15b718fce20)(this, $d3cc80c94d2af732$var$_Query_instances, $d3cc80c94d2af732$var$dispatch_fn).call(this, {
                type: "error",
                error: error
            });
            (_j = (_i = (0, $a0cb2f29b373067e$export$18a094aefa070634)(this, $d3cc80c94d2af732$var$_cache).config).onError) == null || _j.call(_i, error, this);
            (_l = (_k = (0, $a0cb2f29b373067e$export$18a094aefa070634)(this, $d3cc80c94d2af732$var$_cache).config).onSettled) == null || _l.call(_k, this.state.data, error, this);
            throw error;
        } finally{
            this.scheduleGc();
        }
    }
};
$d3cc80c94d2af732$var$_initialState = new WeakMap();
$d3cc80c94d2af732$var$_revertState = new WeakMap();
$d3cc80c94d2af732$var$_cache = new WeakMap();
$d3cc80c94d2af732$var$_client = new WeakMap();
$d3cc80c94d2af732$var$_retryer = new WeakMap();
$d3cc80c94d2af732$var$_defaultOptions = new WeakMap();
$d3cc80c94d2af732$var$_abortSignalConsumed = new WeakMap();
$d3cc80c94d2af732$var$_Query_instances = new WeakSet();
$d3cc80c94d2af732$var$dispatch_fn = function(action) {
    const reducer = (state)=>{
        switch(action.type){
            case "failed":
                return {
                    ...state,
                    fetchFailureCount: action.failureCount,
                    fetchFailureReason: action.error
                };
            case "pause":
                return {
                    ...state,
                    fetchStatus: "paused"
                };
            case "continue":
                return {
                    ...state,
                    fetchStatus: "fetching"
                };
            case "fetch":
                return {
                    ...state,
                    ...$d3cc80c94d2af732$export$f3df9013f2b58bce(state.data, this.options),
                    fetchMeta: action.meta ?? null
                };
            case "success":
                const newState = {
                    ...state,
                    ...$d3cc80c94d2af732$var$successState(action.data, action.dataUpdatedAt),
                    dataUpdateCount: state.dataUpdateCount + 1,
                    ...!action.manual && {
                        fetchStatus: "idle",
                        fetchFailureCount: 0,
                        fetchFailureReason: null
                    }
                };
                (0, $a0cb2f29b373067e$export$42432efe6614d3b4)(this, $d3cc80c94d2af732$var$_revertState, action.manual ? newState : void 0);
                return newState;
            case "error":
                const error = action.error;
                return {
                    ...state,
                    error: error,
                    errorUpdateCount: state.errorUpdateCount + 1,
                    errorUpdatedAt: Date.now(),
                    fetchFailureCount: state.fetchFailureCount + 1,
                    fetchFailureReason: error,
                    fetchStatus: "idle",
                    status: "error"
                };
            case "invalidate":
                return {
                    ...state,
                    isInvalidated: true
                };
            case "setState":
                return {
                    ...state,
                    ...action.state
                };
        }
    };
    this.state = reducer(this.state);
    (0, $a37b31dc4086690f$export$520687f44db6e1ab).batch(()=>{
        this.observers.forEach((observer)=>{
            observer.onQueryUpdate();
        });
        (0, $a0cb2f29b373067e$export$18a094aefa070634)(this, $d3cc80c94d2af732$var$_cache).notify({
            query: this,
            type: "updated",
            action: action
        });
    });
};
function $d3cc80c94d2af732$export$f3df9013f2b58bce(data, options) {
    return {
        fetchFailureCount: 0,
        fetchFailureReason: null,
        fetchStatus: (0, $c0d8ccc060892ed3$export$61b92f63f30245cf)(options.networkMode) ? "fetching" : "paused",
        ...data === void 0 && {
            error: null,
            status: "pending"
        }
    };
}
function $d3cc80c94d2af732$var$successState(data, dataUpdatedAt) {
    return {
        data: data,
        dataUpdatedAt: dataUpdatedAt ?? Date.now(),
        error: null,
        isInvalidated: false,
        status: "success"
    };
}
function $d3cc80c94d2af732$var$getDefaultState(options) {
    const data = typeof options.initialData === "function" ? options.initialData() : options.initialData;
    const hasData = data !== void 0;
    const initialDataUpdatedAt = hasData ? typeof options.initialDataUpdatedAt === "function" ? options.initialDataUpdatedAt() : options.initialDataUpdatedAt : 0;
    return {
        data: data,
        dataUpdateCount: 0,
        dataUpdatedAt: hasData ? initialDataUpdatedAt ?? Date.now() : 0,
        error: null,
        errorUpdateCount: 0,
        errorUpdatedAt: 0,
        fetchFailureCount: 0,
        fetchFailureReason: null,
        fetchMeta: null,
        isInvalidated: false,
        status: hasData ? "success" : "pending",
        fetchStatus: "idle"
    };
}






var $f34a2001660d7650$var$_client, $f34a2001660d7650$var$_currentQuery, $f34a2001660d7650$var$_currentQueryInitialState, $f34a2001660d7650$var$_currentResult, $f34a2001660d7650$var$_currentResultState, $f34a2001660d7650$var$_currentResultOptions, $f34a2001660d7650$var$_currentThenable, $f34a2001660d7650$var$_selectError, $f34a2001660d7650$var$_selectFn, $f34a2001660d7650$var$_selectResult, $f34a2001660d7650$var$_lastQueryWithDefinedData, $f34a2001660d7650$var$_staleTimeoutId, $f34a2001660d7650$var$_refetchIntervalId, $f34a2001660d7650$var$_currentRefetchInterval, $f34a2001660d7650$var$_trackedProps, $f34a2001660d7650$var$_QueryObserver_instances, $f34a2001660d7650$var$executeFetch_fn, $f34a2001660d7650$var$updateStaleTimeout_fn, $f34a2001660d7650$var$computeRefetchInterval_fn, $f34a2001660d7650$var$updateRefetchInterval_fn, $f34a2001660d7650$var$updateTimers_fn, $f34a2001660d7650$var$clearStaleTimeout_fn, $f34a2001660d7650$var$clearRefetchInterval_fn, $f34a2001660d7650$var$updateQuery_fn, $f34a2001660d7650$var$notify_fn;
var $f34a2001660d7650$export$a06cf8c0066f0d4c = class extends (0, $78d76f0c1d823036$export$d26086b469ecdbcc) {
    constructor(client, options){
        super();
        this.options = options;
        (0, $a0cb2f29b373067e$export$addf369becd23283)(this, $f34a2001660d7650$var$_QueryObserver_instances);
        (0, $a0cb2f29b373067e$export$addf369becd23283)(this, $f34a2001660d7650$var$_client);
        (0, $a0cb2f29b373067e$export$addf369becd23283)(this, $f34a2001660d7650$var$_currentQuery);
        (0, $a0cb2f29b373067e$export$addf369becd23283)(this, $f34a2001660d7650$var$_currentQueryInitialState);
        (0, $a0cb2f29b373067e$export$addf369becd23283)(this, $f34a2001660d7650$var$_currentResult);
        (0, $a0cb2f29b373067e$export$addf369becd23283)(this, $f34a2001660d7650$var$_currentResultState);
        (0, $a0cb2f29b373067e$export$addf369becd23283)(this, $f34a2001660d7650$var$_currentResultOptions);
        (0, $a0cb2f29b373067e$export$addf369becd23283)(this, $f34a2001660d7650$var$_currentThenable);
        (0, $a0cb2f29b373067e$export$addf369becd23283)(this, $f34a2001660d7650$var$_selectError);
        (0, $a0cb2f29b373067e$export$addf369becd23283)(this, $f34a2001660d7650$var$_selectFn);
        (0, $a0cb2f29b373067e$export$addf369becd23283)(this, $f34a2001660d7650$var$_selectResult);
        // This property keeps track of the last query with defined data.
        // It will be used to pass the previous data and query to the placeholder function between renders.
        (0, $a0cb2f29b373067e$export$addf369becd23283)(this, $f34a2001660d7650$var$_lastQueryWithDefinedData);
        (0, $a0cb2f29b373067e$export$addf369becd23283)(this, $f34a2001660d7650$var$_staleTimeoutId);
        (0, $a0cb2f29b373067e$export$addf369becd23283)(this, $f34a2001660d7650$var$_refetchIntervalId);
        (0, $a0cb2f29b373067e$export$addf369becd23283)(this, $f34a2001660d7650$var$_currentRefetchInterval);
        (0, $a0cb2f29b373067e$export$addf369becd23283)(this, $f34a2001660d7650$var$_trackedProps, /* @__PURE__ */ new Set());
        (0, $a0cb2f29b373067e$export$42432efe6614d3b4)(this, $f34a2001660d7650$var$_client, client);
        (0, $a0cb2f29b373067e$export$42432efe6614d3b4)(this, $f34a2001660d7650$var$_selectError, null);
        (0, $a0cb2f29b373067e$export$42432efe6614d3b4)(this, $f34a2001660d7650$var$_currentThenable, (0, $62cc4beebf37142c$export$d54630db02a12b72)());
        this.bindMethods();
        this.setOptions(options);
    }
    bindMethods() {
        this.refetch = this.refetch.bind(this);
    }
    onSubscribe() {
        if (this.listeners.size === 1) {
            (0, $a0cb2f29b373067e$export$18a094aefa070634)(this, $f34a2001660d7650$var$_currentQuery).addObserver(this);
            if ($f34a2001660d7650$var$shouldFetchOnMount((0, $a0cb2f29b373067e$export$18a094aefa070634)(this, $f34a2001660d7650$var$_currentQuery), this.options)) (0, $a0cb2f29b373067e$export$fa92d15b718fce20)(this, $f34a2001660d7650$var$_QueryObserver_instances, $f34a2001660d7650$var$executeFetch_fn).call(this);
            else this.updateResult();
            (0, $a0cb2f29b373067e$export$fa92d15b718fce20)(this, $f34a2001660d7650$var$_QueryObserver_instances, $f34a2001660d7650$var$updateTimers_fn).call(this);
        }
    }
    onUnsubscribe() {
        if (!this.hasListeners()) this.destroy();
    }
    shouldFetchOnReconnect() {
        return $f34a2001660d7650$var$shouldFetchOn((0, $a0cb2f29b373067e$export$18a094aefa070634)(this, $f34a2001660d7650$var$_currentQuery), this.options, this.options.refetchOnReconnect);
    }
    shouldFetchOnWindowFocus() {
        return $f34a2001660d7650$var$shouldFetchOn((0, $a0cb2f29b373067e$export$18a094aefa070634)(this, $f34a2001660d7650$var$_currentQuery), this.options, this.options.refetchOnWindowFocus);
    }
    destroy() {
        this.listeners = /* @__PURE__ */ new Set();
        (0, $a0cb2f29b373067e$export$fa92d15b718fce20)(this, $f34a2001660d7650$var$_QueryObserver_instances, $f34a2001660d7650$var$clearStaleTimeout_fn).call(this);
        (0, $a0cb2f29b373067e$export$fa92d15b718fce20)(this, $f34a2001660d7650$var$_QueryObserver_instances, $f34a2001660d7650$var$clearRefetchInterval_fn).call(this);
        (0, $a0cb2f29b373067e$export$18a094aefa070634)(this, $f34a2001660d7650$var$_currentQuery).removeObserver(this);
    }
    setOptions(options) {
        const prevOptions = this.options;
        const prevQuery = (0, $a0cb2f29b373067e$export$18a094aefa070634)(this, $f34a2001660d7650$var$_currentQuery);
        this.options = (0, $a0cb2f29b373067e$export$18a094aefa070634)(this, $f34a2001660d7650$var$_client).defaultQueryOptions(options);
        if (this.options.enabled !== void 0 && typeof this.options.enabled !== "boolean" && typeof this.options.enabled !== "function" && typeof (0, $e9d6dc959f196f70$export$8c88ee6f2357230d)(this.options.enabled, (0, $a0cb2f29b373067e$export$18a094aefa070634)(this, $f34a2001660d7650$var$_currentQuery)) !== "boolean") throw new Error("Expected enabled to be a boolean or a callback that returns a boolean");
        (0, $a0cb2f29b373067e$export$fa92d15b718fce20)(this, $f34a2001660d7650$var$_QueryObserver_instances, $f34a2001660d7650$var$updateQuery_fn).call(this);
        (0, $a0cb2f29b373067e$export$18a094aefa070634)(this, $f34a2001660d7650$var$_currentQuery).setOptions(this.options);
        if (prevOptions._defaulted && !(0, $e9d6dc959f196f70$export$3e67810a3f0e9f1c)(this.options, prevOptions)) (0, $a0cb2f29b373067e$export$18a094aefa070634)(this, $f34a2001660d7650$var$_client).getQueryCache().notify({
            type: "observerOptionsUpdated",
            query: (0, $a0cb2f29b373067e$export$18a094aefa070634)(this, $f34a2001660d7650$var$_currentQuery),
            observer: this
        });
        const mounted = this.hasListeners();
        if (mounted && $f34a2001660d7650$var$shouldFetchOptionally((0, $a0cb2f29b373067e$export$18a094aefa070634)(this, $f34a2001660d7650$var$_currentQuery), prevQuery, this.options, prevOptions)) (0, $a0cb2f29b373067e$export$fa92d15b718fce20)(this, $f34a2001660d7650$var$_QueryObserver_instances, $f34a2001660d7650$var$executeFetch_fn).call(this);
        this.updateResult();
        if (mounted && ((0, $a0cb2f29b373067e$export$18a094aefa070634)(this, $f34a2001660d7650$var$_currentQuery) !== prevQuery || (0, $e9d6dc959f196f70$export$8c88ee6f2357230d)(this.options.enabled, (0, $a0cb2f29b373067e$export$18a094aefa070634)(this, $f34a2001660d7650$var$_currentQuery)) !== (0, $e9d6dc959f196f70$export$8c88ee6f2357230d)(prevOptions.enabled, (0, $a0cb2f29b373067e$export$18a094aefa070634)(this, $f34a2001660d7650$var$_currentQuery)) || (0, $e9d6dc959f196f70$export$cb3145f011bda3ac)(this.options.staleTime, (0, $a0cb2f29b373067e$export$18a094aefa070634)(this, $f34a2001660d7650$var$_currentQuery)) !== (0, $e9d6dc959f196f70$export$cb3145f011bda3ac)(prevOptions.staleTime, (0, $a0cb2f29b373067e$export$18a094aefa070634)(this, $f34a2001660d7650$var$_currentQuery)))) (0, $a0cb2f29b373067e$export$fa92d15b718fce20)(this, $f34a2001660d7650$var$_QueryObserver_instances, $f34a2001660d7650$var$updateStaleTimeout_fn).call(this);
        const nextRefetchInterval = (0, $a0cb2f29b373067e$export$fa92d15b718fce20)(this, $f34a2001660d7650$var$_QueryObserver_instances, $f34a2001660d7650$var$computeRefetchInterval_fn).call(this);
        if (mounted && ((0, $a0cb2f29b373067e$export$18a094aefa070634)(this, $f34a2001660d7650$var$_currentQuery) !== prevQuery || (0, $e9d6dc959f196f70$export$8c88ee6f2357230d)(this.options.enabled, (0, $a0cb2f29b373067e$export$18a094aefa070634)(this, $f34a2001660d7650$var$_currentQuery)) !== (0, $e9d6dc959f196f70$export$8c88ee6f2357230d)(prevOptions.enabled, (0, $a0cb2f29b373067e$export$18a094aefa070634)(this, $f34a2001660d7650$var$_currentQuery)) || nextRefetchInterval !== (0, $a0cb2f29b373067e$export$18a094aefa070634)(this, $f34a2001660d7650$var$_currentRefetchInterval))) (0, $a0cb2f29b373067e$export$fa92d15b718fce20)(this, $f34a2001660d7650$var$_QueryObserver_instances, $f34a2001660d7650$var$updateRefetchInterval_fn).call(this, nextRefetchInterval);
    }
    getOptimisticResult(options) {
        const query = (0, $a0cb2f29b373067e$export$18a094aefa070634)(this, $f34a2001660d7650$var$_client).getQueryCache().build((0, $a0cb2f29b373067e$export$18a094aefa070634)(this, $f34a2001660d7650$var$_client), options);
        const result = this.createResult(query, options);
        if ($f34a2001660d7650$var$shouldAssignObserverCurrentProperties(this, result)) {
            (0, $a0cb2f29b373067e$export$42432efe6614d3b4)(this, $f34a2001660d7650$var$_currentResult, result);
            (0, $a0cb2f29b373067e$export$42432efe6614d3b4)(this, $f34a2001660d7650$var$_currentResultOptions, this.options);
            (0, $a0cb2f29b373067e$export$42432efe6614d3b4)(this, $f34a2001660d7650$var$_currentResultState, (0, $a0cb2f29b373067e$export$18a094aefa070634)(this, $f34a2001660d7650$var$_currentQuery).state);
        }
        return result;
    }
    getCurrentResult() {
        return (0, $a0cb2f29b373067e$export$18a094aefa070634)(this, $f34a2001660d7650$var$_currentResult);
    }
    trackResult(result, onPropTracked) {
        return new Proxy(result, {
            get: (target, key)=>{
                this.trackProp(key);
                onPropTracked == null || onPropTracked(key);
                if (key === "promise") {
                    this.trackProp("data");
                    if (!this.options.experimental_prefetchInRender && (0, $a0cb2f29b373067e$export$18a094aefa070634)(this, $f34a2001660d7650$var$_currentThenable).status === "pending") (0, $a0cb2f29b373067e$export$18a094aefa070634)(this, $f34a2001660d7650$var$_currentThenable).reject(new Error("experimental_prefetchInRender feature flag is not enabled"));
                }
                return Reflect.get(target, key);
            }
        });
    }
    trackProp(key) {
        (0, $a0cb2f29b373067e$export$18a094aefa070634)(this, $f34a2001660d7650$var$_trackedProps).add(key);
    }
    getCurrentQuery() {
        return (0, $a0cb2f29b373067e$export$18a094aefa070634)(this, $f34a2001660d7650$var$_currentQuery);
    }
    refetch({ ...options } = {}) {
        return this.fetch({
            ...options
        });
    }
    fetchOptimistic(options) {
        const defaultedOptions = (0, $a0cb2f29b373067e$export$18a094aefa070634)(this, $f34a2001660d7650$var$_client).defaultQueryOptions(options);
        const query = (0, $a0cb2f29b373067e$export$18a094aefa070634)(this, $f34a2001660d7650$var$_client).getQueryCache().build((0, $a0cb2f29b373067e$export$18a094aefa070634)(this, $f34a2001660d7650$var$_client), defaultedOptions);
        return query.fetch().then(()=>this.createResult(query, defaultedOptions));
    }
    fetch(fetchOptions) {
        return (0, $a0cb2f29b373067e$export$fa92d15b718fce20)(this, $f34a2001660d7650$var$_QueryObserver_instances, $f34a2001660d7650$var$executeFetch_fn).call(this, {
            ...fetchOptions,
            cancelRefetch: fetchOptions.cancelRefetch ?? true
        }).then(()=>{
            this.updateResult();
            return (0, $a0cb2f29b373067e$export$18a094aefa070634)(this, $f34a2001660d7650$var$_currentResult);
        });
    }
    createResult(query, options) {
        var _a;
        const prevQuery = (0, $a0cb2f29b373067e$export$18a094aefa070634)(this, $f34a2001660d7650$var$_currentQuery);
        const prevOptions = this.options;
        const prevResult = (0, $a0cb2f29b373067e$export$18a094aefa070634)(this, $f34a2001660d7650$var$_currentResult);
        const prevResultState = (0, $a0cb2f29b373067e$export$18a094aefa070634)(this, $f34a2001660d7650$var$_currentResultState);
        const prevResultOptions = (0, $a0cb2f29b373067e$export$18a094aefa070634)(this, $f34a2001660d7650$var$_currentResultOptions);
        const queryChange = query !== prevQuery;
        const queryInitialState = queryChange ? query.state : (0, $a0cb2f29b373067e$export$18a094aefa070634)(this, $f34a2001660d7650$var$_currentQueryInitialState);
        const { state: state } = query;
        let newState = {
            ...state
        };
        let isPlaceholderData = false;
        let data;
        if (options._optimisticResults) {
            const mounted = this.hasListeners();
            const fetchOnMount = !mounted && $f34a2001660d7650$var$shouldFetchOnMount(query, options);
            const fetchOptionally = mounted && $f34a2001660d7650$var$shouldFetchOptionally(query, prevQuery, options, prevOptions);
            if (fetchOnMount || fetchOptionally) newState = {
                ...newState,
                ...(0, $d3cc80c94d2af732$export$f3df9013f2b58bce)(state.data, query.options)
            };
            if (options._optimisticResults === "isRestoring") newState.fetchStatus = "idle";
        }
        let { error: error, errorUpdatedAt: errorUpdatedAt, status: status } = newState;
        data = newState.data;
        let skipSelect = false;
        if (options.placeholderData !== void 0 && data === void 0 && status === "pending") {
            let placeholderData;
            if ((prevResult == null ? void 0 : prevResult.isPlaceholderData) && options.placeholderData === (prevResultOptions == null ? void 0 : prevResultOptions.placeholderData)) {
                placeholderData = prevResult.data;
                skipSelect = true;
            } else placeholderData = typeof options.placeholderData === "function" ? options.placeholderData((_a = (0, $a0cb2f29b373067e$export$18a094aefa070634)(this, $f34a2001660d7650$var$_lastQueryWithDefinedData)) == null ? void 0 : _a.state.data, (0, $a0cb2f29b373067e$export$18a094aefa070634)(this, $f34a2001660d7650$var$_lastQueryWithDefinedData)) : options.placeholderData;
            if (placeholderData !== void 0) {
                status = "success";
                data = (0, $e9d6dc959f196f70$export$17619bac5b909b23)(prevResult == null ? void 0 : prevResult.data, placeholderData, options);
                isPlaceholderData = true;
            }
        }
        if (options.select && data !== void 0 && !skipSelect) {
            if (prevResult && data === (prevResultState == null ? void 0 : prevResultState.data) && options.select === (0, $a0cb2f29b373067e$export$18a094aefa070634)(this, $f34a2001660d7650$var$_selectFn)) data = (0, $a0cb2f29b373067e$export$18a094aefa070634)(this, $f34a2001660d7650$var$_selectResult);
            else try {
                (0, $a0cb2f29b373067e$export$42432efe6614d3b4)(this, $f34a2001660d7650$var$_selectFn, options.select);
                data = options.select(data);
                data = (0, $e9d6dc959f196f70$export$17619bac5b909b23)(prevResult == null ? void 0 : prevResult.data, data, options);
                (0, $a0cb2f29b373067e$export$42432efe6614d3b4)(this, $f34a2001660d7650$var$_selectResult, data);
                (0, $a0cb2f29b373067e$export$42432efe6614d3b4)(this, $f34a2001660d7650$var$_selectError, null);
            } catch (selectError) {
                (0, $a0cb2f29b373067e$export$42432efe6614d3b4)(this, $f34a2001660d7650$var$_selectError, selectError);
            }
        }
        if ((0, $a0cb2f29b373067e$export$18a094aefa070634)(this, $f34a2001660d7650$var$_selectError)) {
            error = (0, $a0cb2f29b373067e$export$18a094aefa070634)(this, $f34a2001660d7650$var$_selectError);
            data = (0, $a0cb2f29b373067e$export$18a094aefa070634)(this, $f34a2001660d7650$var$_selectResult);
            errorUpdatedAt = Date.now();
            status = "error";
        }
        const isFetching = newState.fetchStatus === "fetching";
        const isPending = status === "pending";
        const isError = status === "error";
        const isLoading = isPending && isFetching;
        const hasData = data !== void 0;
        const result = {
            status: status,
            fetchStatus: newState.fetchStatus,
            isPending: isPending,
            isSuccess: status === "success",
            isError: isError,
            isInitialLoading: isLoading,
            isLoading: isLoading,
            data: data,
            dataUpdatedAt: newState.dataUpdatedAt,
            error: error,
            errorUpdatedAt: errorUpdatedAt,
            failureCount: newState.fetchFailureCount,
            failureReason: newState.fetchFailureReason,
            errorUpdateCount: newState.errorUpdateCount,
            isFetched: newState.dataUpdateCount > 0 || newState.errorUpdateCount > 0,
            isFetchedAfterMount: newState.dataUpdateCount > queryInitialState.dataUpdateCount || newState.errorUpdateCount > queryInitialState.errorUpdateCount,
            isFetching: isFetching,
            isRefetching: isFetching && !isPending,
            isLoadingError: isError && !hasData,
            isPaused: newState.fetchStatus === "paused",
            isPlaceholderData: isPlaceholderData,
            isRefetchError: isError && hasData,
            isStale: $f34a2001660d7650$var$isStale(query, options),
            refetch: this.refetch,
            promise: (0, $a0cb2f29b373067e$export$18a094aefa070634)(this, $f34a2001660d7650$var$_currentThenable),
            isEnabled: (0, $e9d6dc959f196f70$export$8c88ee6f2357230d)(options.enabled, query) !== false
        };
        const nextResult = result;
        if (this.options.experimental_prefetchInRender) {
            const finalizeThenableIfPossible = (thenable)=>{
                if (nextResult.status === "error") thenable.reject(nextResult.error);
                else if (nextResult.data !== void 0) thenable.resolve(nextResult.data);
            };
            const recreateThenable = ()=>{
                const pending = (0, $a0cb2f29b373067e$export$42432efe6614d3b4)(this, $f34a2001660d7650$var$_currentThenable, nextResult.promise = (0, $62cc4beebf37142c$export$d54630db02a12b72)());
                finalizeThenableIfPossible(pending);
            };
            const prevThenable = (0, $a0cb2f29b373067e$export$18a094aefa070634)(this, $f34a2001660d7650$var$_currentThenable);
            switch(prevThenable.status){
                case "pending":
                    if (query.queryHash === prevQuery.queryHash) finalizeThenableIfPossible(prevThenable);
                    break;
                case "fulfilled":
                    if (nextResult.status === "error" || nextResult.data !== prevThenable.value) recreateThenable();
                    break;
                case "rejected":
                    if (nextResult.status !== "error" || nextResult.error !== prevThenable.reason) recreateThenable();
                    break;
            }
        }
        return nextResult;
    }
    updateResult() {
        const prevResult = (0, $a0cb2f29b373067e$export$18a094aefa070634)(this, $f34a2001660d7650$var$_currentResult);
        const nextResult = this.createResult((0, $a0cb2f29b373067e$export$18a094aefa070634)(this, $f34a2001660d7650$var$_currentQuery), this.options);
        (0, $a0cb2f29b373067e$export$42432efe6614d3b4)(this, $f34a2001660d7650$var$_currentResultState, (0, $a0cb2f29b373067e$export$18a094aefa070634)(this, $f34a2001660d7650$var$_currentQuery).state);
        (0, $a0cb2f29b373067e$export$42432efe6614d3b4)(this, $f34a2001660d7650$var$_currentResultOptions, this.options);
        if ((0, $a0cb2f29b373067e$export$18a094aefa070634)(this, $f34a2001660d7650$var$_currentResultState).data !== void 0) (0, $a0cb2f29b373067e$export$42432efe6614d3b4)(this, $f34a2001660d7650$var$_lastQueryWithDefinedData, (0, $a0cb2f29b373067e$export$18a094aefa070634)(this, $f34a2001660d7650$var$_currentQuery));
        if ((0, $e9d6dc959f196f70$export$3e67810a3f0e9f1c)(nextResult, prevResult)) return;
        (0, $a0cb2f29b373067e$export$42432efe6614d3b4)(this, $f34a2001660d7650$var$_currentResult, nextResult);
        const shouldNotifyListeners = ()=>{
            if (!prevResult) return true;
            const { notifyOnChangeProps: notifyOnChangeProps } = this.options;
            const notifyOnChangePropsValue = typeof notifyOnChangeProps === "function" ? notifyOnChangeProps() : notifyOnChangeProps;
            if (notifyOnChangePropsValue === "all" || !notifyOnChangePropsValue && !(0, $a0cb2f29b373067e$export$18a094aefa070634)(this, $f34a2001660d7650$var$_trackedProps).size) return true;
            const includedProps = new Set(notifyOnChangePropsValue ?? (0, $a0cb2f29b373067e$export$18a094aefa070634)(this, $f34a2001660d7650$var$_trackedProps));
            if (this.options.throwOnError) includedProps.add("error");
            return Object.keys((0, $a0cb2f29b373067e$export$18a094aefa070634)(this, $f34a2001660d7650$var$_currentResult)).some((key)=>{
                const typedKey = key;
                const changed = (0, $a0cb2f29b373067e$export$18a094aefa070634)(this, $f34a2001660d7650$var$_currentResult)[typedKey] !== prevResult[typedKey];
                return changed && includedProps.has(typedKey);
            });
        };
        (0, $a0cb2f29b373067e$export$fa92d15b718fce20)(this, $f34a2001660d7650$var$_QueryObserver_instances, $f34a2001660d7650$var$notify_fn).call(this, {
            listeners: shouldNotifyListeners()
        });
    }
    onQueryUpdate() {
        this.updateResult();
        if (this.hasListeners()) (0, $a0cb2f29b373067e$export$fa92d15b718fce20)(this, $f34a2001660d7650$var$_QueryObserver_instances, $f34a2001660d7650$var$updateTimers_fn).call(this);
    }
};
$f34a2001660d7650$var$_client = new WeakMap();
$f34a2001660d7650$var$_currentQuery = new WeakMap();
$f34a2001660d7650$var$_currentQueryInitialState = new WeakMap();
$f34a2001660d7650$var$_currentResult = new WeakMap();
$f34a2001660d7650$var$_currentResultState = new WeakMap();
$f34a2001660d7650$var$_currentResultOptions = new WeakMap();
$f34a2001660d7650$var$_currentThenable = new WeakMap();
$f34a2001660d7650$var$_selectError = new WeakMap();
$f34a2001660d7650$var$_selectFn = new WeakMap();
$f34a2001660d7650$var$_selectResult = new WeakMap();
$f34a2001660d7650$var$_lastQueryWithDefinedData = new WeakMap();
$f34a2001660d7650$var$_staleTimeoutId = new WeakMap();
$f34a2001660d7650$var$_refetchIntervalId = new WeakMap();
$f34a2001660d7650$var$_currentRefetchInterval = new WeakMap();
$f34a2001660d7650$var$_trackedProps = new WeakMap();
$f34a2001660d7650$var$_QueryObserver_instances = new WeakSet();
$f34a2001660d7650$var$executeFetch_fn = function(fetchOptions) {
    (0, $a0cb2f29b373067e$export$fa92d15b718fce20)(this, $f34a2001660d7650$var$_QueryObserver_instances, $f34a2001660d7650$var$updateQuery_fn).call(this);
    let promise = (0, $a0cb2f29b373067e$export$18a094aefa070634)(this, $f34a2001660d7650$var$_currentQuery).fetch(this.options, fetchOptions);
    if (!(fetchOptions == null ? void 0 : fetchOptions.throwOnError)) promise = promise.catch((0, $e9d6dc959f196f70$export$8793edee2d425525));
    return promise;
};
$f34a2001660d7650$var$updateStaleTimeout_fn = function() {
    (0, $a0cb2f29b373067e$export$fa92d15b718fce20)(this, $f34a2001660d7650$var$_QueryObserver_instances, $f34a2001660d7650$var$clearStaleTimeout_fn).call(this);
    const staleTime = (0, $e9d6dc959f196f70$export$cb3145f011bda3ac)(this.options.staleTime, (0, $a0cb2f29b373067e$export$18a094aefa070634)(this, $f34a2001660d7650$var$_currentQuery));
    if ((0, $e9d6dc959f196f70$export$6acf61af03e62db) || (0, $a0cb2f29b373067e$export$18a094aefa070634)(this, $f34a2001660d7650$var$_currentResult).isStale || !(0, $e9d6dc959f196f70$export$e539f754e934e270)(staleTime)) return;
    const time = (0, $e9d6dc959f196f70$export$811b83d62bcf47f0)((0, $a0cb2f29b373067e$export$18a094aefa070634)(this, $f34a2001660d7650$var$_currentResult).dataUpdatedAt, staleTime);
    const timeout = time + 1;
    (0, $a0cb2f29b373067e$export$42432efe6614d3b4)(this, $f34a2001660d7650$var$_staleTimeoutId, (0, $c256c6d36f9f33f6$export$94a2700736e69372).setTimeout(()=>{
        if (!(0, $a0cb2f29b373067e$export$18a094aefa070634)(this, $f34a2001660d7650$var$_currentResult).isStale) this.updateResult();
    }, timeout));
};
$f34a2001660d7650$var$computeRefetchInterval_fn = function() {
    return (typeof this.options.refetchInterval === "function" ? this.options.refetchInterval((0, $a0cb2f29b373067e$export$18a094aefa070634)(this, $f34a2001660d7650$var$_currentQuery)) : this.options.refetchInterval) ?? false;
};
$f34a2001660d7650$var$updateRefetchInterval_fn = function(nextInterval) {
    (0, $a0cb2f29b373067e$export$fa92d15b718fce20)(this, $f34a2001660d7650$var$_QueryObserver_instances, $f34a2001660d7650$var$clearRefetchInterval_fn).call(this);
    (0, $a0cb2f29b373067e$export$42432efe6614d3b4)(this, $f34a2001660d7650$var$_currentRefetchInterval, nextInterval);
    if ((0, $e9d6dc959f196f70$export$6acf61af03e62db) || (0, $e9d6dc959f196f70$export$8c88ee6f2357230d)(this.options.enabled, (0, $a0cb2f29b373067e$export$18a094aefa070634)(this, $f34a2001660d7650$var$_currentQuery)) === false || !(0, $e9d6dc959f196f70$export$e539f754e934e270)((0, $a0cb2f29b373067e$export$18a094aefa070634)(this, $f34a2001660d7650$var$_currentRefetchInterval)) || (0, $a0cb2f29b373067e$export$18a094aefa070634)(this, $f34a2001660d7650$var$_currentRefetchInterval) === 0) return;
    (0, $a0cb2f29b373067e$export$42432efe6614d3b4)(this, $f34a2001660d7650$var$_refetchIntervalId, (0, $c256c6d36f9f33f6$export$94a2700736e69372).setInterval(()=>{
        if (this.options.refetchIntervalInBackground || (0, $780e8903dcf2df97$export$6bf54661be5b02cf).isFocused()) (0, $a0cb2f29b373067e$export$fa92d15b718fce20)(this, $f34a2001660d7650$var$_QueryObserver_instances, $f34a2001660d7650$var$executeFetch_fn).call(this);
    }, (0, $a0cb2f29b373067e$export$18a094aefa070634)(this, $f34a2001660d7650$var$_currentRefetchInterval)));
};
$f34a2001660d7650$var$updateTimers_fn = function() {
    (0, $a0cb2f29b373067e$export$fa92d15b718fce20)(this, $f34a2001660d7650$var$_QueryObserver_instances, $f34a2001660d7650$var$updateStaleTimeout_fn).call(this);
    (0, $a0cb2f29b373067e$export$fa92d15b718fce20)(this, $f34a2001660d7650$var$_QueryObserver_instances, $f34a2001660d7650$var$updateRefetchInterval_fn).call(this, (0, $a0cb2f29b373067e$export$fa92d15b718fce20)(this, $f34a2001660d7650$var$_QueryObserver_instances, $f34a2001660d7650$var$computeRefetchInterval_fn).call(this));
};
$f34a2001660d7650$var$clearStaleTimeout_fn = function() {
    if ((0, $a0cb2f29b373067e$export$18a094aefa070634)(this, $f34a2001660d7650$var$_staleTimeoutId)) {
        (0, $c256c6d36f9f33f6$export$94a2700736e69372).clearTimeout((0, $a0cb2f29b373067e$export$18a094aefa070634)(this, $f34a2001660d7650$var$_staleTimeoutId));
        (0, $a0cb2f29b373067e$export$42432efe6614d3b4)(this, $f34a2001660d7650$var$_staleTimeoutId, void 0);
    }
};
$f34a2001660d7650$var$clearRefetchInterval_fn = function() {
    if ((0, $a0cb2f29b373067e$export$18a094aefa070634)(this, $f34a2001660d7650$var$_refetchIntervalId)) {
        (0, $c256c6d36f9f33f6$export$94a2700736e69372).clearInterval((0, $a0cb2f29b373067e$export$18a094aefa070634)(this, $f34a2001660d7650$var$_refetchIntervalId));
        (0, $a0cb2f29b373067e$export$42432efe6614d3b4)(this, $f34a2001660d7650$var$_refetchIntervalId, void 0);
    }
};
$f34a2001660d7650$var$updateQuery_fn = function() {
    const query = (0, $a0cb2f29b373067e$export$18a094aefa070634)(this, $f34a2001660d7650$var$_client).getQueryCache().build((0, $a0cb2f29b373067e$export$18a094aefa070634)(this, $f34a2001660d7650$var$_client), this.options);
    if (query === (0, $a0cb2f29b373067e$export$18a094aefa070634)(this, $f34a2001660d7650$var$_currentQuery)) return;
    const prevQuery = (0, $a0cb2f29b373067e$export$18a094aefa070634)(this, $f34a2001660d7650$var$_currentQuery);
    (0, $a0cb2f29b373067e$export$42432efe6614d3b4)(this, $f34a2001660d7650$var$_currentQuery, query);
    (0, $a0cb2f29b373067e$export$42432efe6614d3b4)(this, $f34a2001660d7650$var$_currentQueryInitialState, query.state);
    if (this.hasListeners()) {
        prevQuery == null || prevQuery.removeObserver(this);
        query.addObserver(this);
    }
};
$f34a2001660d7650$var$notify_fn = function(notifyOptions) {
    (0, $a37b31dc4086690f$export$520687f44db6e1ab).batch(()=>{
        if (notifyOptions.listeners) this.listeners.forEach((listener)=>{
            listener((0, $a0cb2f29b373067e$export$18a094aefa070634)(this, $f34a2001660d7650$var$_currentResult));
        });
        (0, $a0cb2f29b373067e$export$18a094aefa070634)(this, $f34a2001660d7650$var$_client).getQueryCache().notify({
            query: (0, $a0cb2f29b373067e$export$18a094aefa070634)(this, $f34a2001660d7650$var$_currentQuery),
            type: "observerResultsUpdated"
        });
    });
};
function $f34a2001660d7650$var$shouldLoadOnMount(query, options) {
    return (0, $e9d6dc959f196f70$export$8c88ee6f2357230d)(options.enabled, query) !== false && query.state.data === void 0 && !(query.state.status === "error" && options.retryOnMount === false);
}
function $f34a2001660d7650$var$shouldFetchOnMount(query, options) {
    return $f34a2001660d7650$var$shouldLoadOnMount(query, options) || query.state.data !== void 0 && $f34a2001660d7650$var$shouldFetchOn(query, options, options.refetchOnMount);
}
function $f34a2001660d7650$var$shouldFetchOn(query, options, field) {
    if ((0, $e9d6dc959f196f70$export$8c88ee6f2357230d)(options.enabled, query) !== false && (0, $e9d6dc959f196f70$export$cb3145f011bda3ac)(options.staleTime, query) !== "static") {
        const value = typeof field === "function" ? field(query) : field;
        return value === "always" || value !== false && $f34a2001660d7650$var$isStale(query, options);
    }
    return false;
}
function $f34a2001660d7650$var$shouldFetchOptionally(query, prevQuery, options, prevOptions) {
    return (query !== prevQuery || (0, $e9d6dc959f196f70$export$8c88ee6f2357230d)(prevOptions.enabled, query) === false) && (!options.suspense || query.state.status !== "error") && $f34a2001660d7650$var$isStale(query, options);
}
function $f34a2001660d7650$var$isStale(query, options) {
    return (0, $e9d6dc959f196f70$export$8c88ee6f2357230d)(options.enabled, query) !== false && query.isStaleByTime((0, $e9d6dc959f196f70$export$cb3145f011bda3ac)(options.staleTime, query));
}
function $f34a2001660d7650$var$shouldAssignObserverCurrentProperties(observer, optimisticResult) {
    if (!(0, $e9d6dc959f196f70$export$3e67810a3f0e9f1c)(observer.getCurrentResult(), optimisticResult)) return true;
    return false;
}



var $5FkrB = parcelRequire("5FkrB");



var $5FkrB = parcelRequire("5FkrB");

"use client";
function $68e16a09567a1394$var$createValue() {
    let isReset = false;
    return {
        clearReset: ()=>{
            isReset = false;
        },
        reset: ()=>{
            isReset = true;
        },
        isReset: ()=>{
            return isReset;
        }
    };
}
var $68e16a09567a1394$var$QueryErrorResetBoundaryContext = $5FkrB.createContext($68e16a09567a1394$var$createValue());
var $68e16a09567a1394$export$50dfac555130cafd = ()=>$5FkrB.useContext($68e16a09567a1394$var$QueryErrorResetBoundaryContext);
var $68e16a09567a1394$export$ddb9962d870f2330 = ({ children: children })=>{
    const [value] = $5FkrB.useState(()=>$68e16a09567a1394$var$createValue());
    return /* @__PURE__ */ (0, $faf30355a80342e4$exports.jsx)($68e16a09567a1394$var$QueryErrorResetBoundaryContext.Provider, {
        value: value,
        children: typeof children === "function" ? children(value) : children
    });
};



var $5FkrB = parcelRequire("5FkrB");

"use client";
var $b95e72c01d14ad05$export$ae8adb3de3d77633 = (options, errorResetBoundary)=>{
    if (options.suspense || options.throwOnError || options.experimental_prefetchInRender) {
        if (!errorResetBoundary.isReset()) options.retryOnMount = false;
    }
};
var $b95e72c01d14ad05$export$b2b17ca3a1fb0229 = (errorResetBoundary)=>{
    $5FkrB.useEffect(()=>{
        errorResetBoundary.clearReset();
    }, [
        errorResetBoundary
    ]);
};
var $b95e72c01d14ad05$export$1fbcf724762d607 = ({ result: result, errorResetBoundary: errorResetBoundary, throwOnError: throwOnError, query: query, suspense: suspense })=>{
    return result.isError && !errorResetBoundary.isReset() && !result.isFetching && query && (suspense && result.data === void 0 || (0, $e9d6dc959f196f70$export$2072f68e6c3507cf)(throwOnError, [
        result.error,
        query
    ]));
};



var $5FkrB = parcelRequire("5FkrB");
"use client";
var $fc8ae81a69ed1932$var$IsRestoringContext = $5FkrB.createContext(false);
var $fc8ae81a69ed1932$export$4da0178d6b5f553 = ()=>$5FkrB.useContext($fc8ae81a69ed1932$var$IsRestoringContext);
var $fc8ae81a69ed1932$export$593807d4e94f9621 = $fc8ae81a69ed1932$var$IsRestoringContext.Provider;


// src/suspense.ts
var $ffbdf52ffadc6ec6$export$8bed2f8d02206063 = (_error, query)=>query.state.data === void 0;
var $ffbdf52ffadc6ec6$export$274d2a1db5a20c09 = (defaultedOptions)=>{
    if (defaultedOptions.suspense) {
        const MIN_SUSPENSE_TIME_MS = 1e3;
        const clamp = (value)=>value === "static" ? value : Math.max(value ?? MIN_SUSPENSE_TIME_MS, MIN_SUSPENSE_TIME_MS);
        const originalStaleTime = defaultedOptions.staleTime;
        defaultedOptions.staleTime = typeof originalStaleTime === "function" ? (...args)=>clamp(originalStaleTime(...args)) : clamp(originalStaleTime);
        if (typeof defaultedOptions.gcTime === "number") defaultedOptions.gcTime = Math.max(defaultedOptions.gcTime, MIN_SUSPENSE_TIME_MS);
    }
};
var $ffbdf52ffadc6ec6$export$e0a3f29513afe430 = (result, isRestoring)=>result.isLoading && result.isFetching && !isRestoring;
var $ffbdf52ffadc6ec6$export$88d3586dfed64df9 = (defaultedOptions, result)=>(defaultedOptions == null ? void 0 : defaultedOptions.suspense) && result.isPending;
var $ffbdf52ffadc6ec6$export$defdc11a9c9acfcf = (defaultedOptions, observer, errorResetBoundary)=>observer.fetchOptimistic(defaultedOptions).catch(()=>{
        errorResetBoundary.clearReset();
    });


"use client";
function $bccea28e74b4fdc0$export$fff0865807e996c5(options, Observer, queryClient) {
    var _a, _b, _c, _d, _e;
    const isRestoring = (0, $fc8ae81a69ed1932$export$4da0178d6b5f553)();
    const errorResetBoundary = (0, $68e16a09567a1394$export$50dfac555130cafd)();
    const client = (0, $a0fe68b284b4365c$export$22e77b9572c4fded)(queryClient);
    const defaultedOptions = client.defaultQueryOptions(options);
    (_b = (_a = client.getDefaultOptions().queries) == null ? void 0 : _a._experimental_beforeQuery) == null || _b.call(_a, defaultedOptions);
    defaultedOptions._optimisticResults = isRestoring ? "isRestoring" : "optimistic";
    (0, $ffbdf52ffadc6ec6$export$274d2a1db5a20c09)(defaultedOptions);
    (0, $b95e72c01d14ad05$export$ae8adb3de3d77633)(defaultedOptions, errorResetBoundary);
    (0, $b95e72c01d14ad05$export$b2b17ca3a1fb0229)(errorResetBoundary);
    const isNewCacheEntry = !client.getQueryCache().get(defaultedOptions.queryHash);
    const [observer] = $5FkrB.useState(()=>new Observer(client, defaultedOptions));
    const result = observer.getOptimisticResult(defaultedOptions);
    const shouldSubscribe = !isRestoring && options.subscribed !== false;
    $5FkrB.useSyncExternalStore($5FkrB.useCallback((onStoreChange)=>{
        const unsubscribe = shouldSubscribe ? observer.subscribe((0, $a37b31dc4086690f$export$520687f44db6e1ab).batchCalls(onStoreChange)) : (0, $e9d6dc959f196f70$export$8793edee2d425525);
        observer.updateResult();
        return unsubscribe;
    }, [
        observer,
        shouldSubscribe
    ]), ()=>observer.getCurrentResult(), ()=>observer.getCurrentResult());
    $5FkrB.useEffect(()=>{
        observer.setOptions(defaultedOptions);
    }, [
        defaultedOptions,
        observer
    ]);
    if ((0, $ffbdf52ffadc6ec6$export$88d3586dfed64df9)(defaultedOptions, result)) throw (0, $ffbdf52ffadc6ec6$export$defdc11a9c9acfcf)(defaultedOptions, observer, errorResetBoundary);
    if ((0, $b95e72c01d14ad05$export$1fbcf724762d607)({
        result: result,
        errorResetBoundary: errorResetBoundary,
        throwOnError: defaultedOptions.throwOnError,
        query: client.getQueryCache().get(defaultedOptions.queryHash),
        suspense: defaultedOptions.suspense
    })) throw result.error;
    (_d = (_c = client.getDefaultOptions().queries) == null ? void 0 : _c._experimental_afterQuery) == null || _d.call(_c, defaultedOptions, result);
    if (defaultedOptions.experimental_prefetchInRender && !(0, $e9d6dc959f196f70$export$6acf61af03e62db) && (0, $ffbdf52ffadc6ec6$export$e0a3f29513afe430)(result, isRestoring)) {
        const promise = isNewCacheEntry ? // Fetch immediately on render in order to ensure `.promise` is resolved even if the component is unmounted
        (0, $ffbdf52ffadc6ec6$export$defdc11a9c9acfcf)(defaultedOptions, observer, errorResetBoundary) : // subscribe to the "cache promise" so that we can finalize the currentThenable once data comes in
        (_e = client.getQueryCache().get(defaultedOptions.queryHash)) == null ? void 0 : _e.promise;
        promise == null || promise.catch((0, $e9d6dc959f196f70$export$8793edee2d425525)).finally(()=>{
            observer.updateResult();
        });
    }
    return !defaultedOptions.notifyOnChangeProps ? observer.trackResult(result) : result;
}


"use client";
function $4b398c1589a0f1e2$export$dd0a697e1782aedd(options, queryClient) {
    return (0, $bccea28e74b4fdc0$export$fff0865807e996c5)(options, (0, $f34a2001660d7650$export$a06cf8c0066f0d4c), queryClient);
}





var $5FkrB = parcelRequire("5FkrB");
const $ff8369db971fa1a8$export$237dc0bae177ad41 = {
    user: null,
    isLoggedIn: false,
    loggedInUser: undefined
};
function $ff8369db971fa1a8$export$299abcbcbe81ab38(user) {
    if (!user) return {
        isLoggedIn: false,
        loggedInUser: undefined
    };
    return {
        isLoggedIn: true,
        loggedInUser: {
            id: user.account_id,
            publicName: user.name || user.nickname || user.email || '',
            avatar: user.picture || '',
            email: user.email
        }
    };
}
const $ff8369db971fa1a8$export$b3aa4dbb59e7857d = (state, action)=>{
    switch(action.type){
        case 'AUTHENTICATE':
            {
                const user = action.payload.user;
                return {
                    user: user,
                    ...$ff8369db971fa1a8$export$299abcbcbe81ab38(user)
                };
            }
        default:
            return state;
    }
};


parcelRequire("5FkrB");

var $aRMzY = parcelRequire("aRMzY");
var $6Wx3K = parcelRequire("6Wx3K");

var $3UCXU = parcelRequire("3UCXU");
const $d3185276e14a4c2b$export$b8c7f5b0854d3581 = {
    // All UiProductType values mapped to logo configurations
    access: {
        icon: 'AdminIcon',
        displayName: 'Atlassian Administration',
        productKey: 'access'
    },
    analytics: {
        icon: 'AtlassianAnalyticsIcon',
        displayName: 'Analytics',
        productKey: 'avp'
    },
    cmdb: {
        icon: 'AssetsIcon',
        displayName: 'Assets',
        productKey: 'cmdb'
    },
    atlassian_together: {
        icon: 'AtlassianIcon',
        displayName: 'Atlassian Together',
        productKey: 'atlassian-together'
    },
    avocado: {
        icon: 'AtlassianIcon',
        displayName: 'Avocado',
        productKey: 'avocado'
    },
    beacon: {
        icon: 'GuardIcon',
        displayName: 'Guard Detect',
        productKey: 'beacon'
    },
    bitbucket: {
        logo: 'BitbucketLogo',
        icon: 'BitbucketIcon',
        displayName: 'Bitbucket',
        productKey: 'bitbucket'
    },
    cloud_admin: {
        logo: 'AtlassianAdministrationLogo',
        icon: 'AtlassianAdministrationIcon',
        displayName: 'Atlassian Administration',
        productKey: 'cloud-admin'
    },
    compass: {
        logo: 'CompassLogo',
        icon: 'CompassIcon',
        displayName: 'Compass',
        productKey: 'compass'
    },
    confluence: {
        logo: 'ConfluenceLogo',
        icon: 'ConfluenceIcon',
        displayName: 'Confluence',
        productKey: 'confluence'
    },
    devai: {
        icon: 'RovoDevIcon',
        displayName: 'Rovo Dev',
        productKey: 'devai'
    },
    fabric: {
        icon: 'AtlassianIcon',
        displayName: 'Fabric',
        productKey: 'canvas'
    },
    feedback: {
        icon: 'AtlassianIcon',
        displayName: 'Feedback',
        productKey: 'feedback'
    },
    goal: {
        icon: 'GoalsIcon',
        displayName: 'Goals',
        productKey: 'goal'
    },
    jira_admin: {
        logo: 'JiraLogo',
        icon: 'JiraIcon',
        displayName: 'Jira Administration',
        productKey: 'jira-admin'
    },
    jira_align: {
        logo: 'JiraAlignLogo',
        icon: 'JiraAlignIcon',
        displayName: 'Jira Align',
        productKey: 'jira-align'
    },
    jira_core: {
        logo: 'JiraLogo',
        icon: 'JiraIcon',
        displayName: 'Jira',
        productKey: 'jira-core'
    },
    jira_customer_service: {
        logo: 'JiraServiceManagementLogo',
        icon: 'JiraServiceManagementIcon',
        displayName: 'Jira Customer Service',
        productKey: 'jira-customer-service'
    },
    jira_family: {
        logo: 'JiraLogo',
        icon: 'JiraIcon',
        displayName: 'Jira',
        productKey: 'jira-family'
    },
    jira_incident_manager: {
        logo: 'JiraServiceManagementLogo',
        icon: 'JiraServiceManagementIcon',
        displayName: 'Jira Incident Manager',
        productKey: 'jira-incident-manager'
    },
    jira_product_discovery: {
        logo: 'JiraProductDiscoveryLogo',
        icon: 'JiraProductDiscoveryIcon',
        displayName: 'Jira Product Discovery',
        productKey: 'jira-product-discovery'
    },
    jira_service_management: {
        logo: 'JiraServiceManagementLogo',
        icon: 'JiraServiceManagementIcon',
        displayName: 'Jira Service Management',
        productKey: 'jira-servicedesk'
    },
    jira_software: {
        logo: 'JiraLogo',
        icon: 'JiraIcon',
        displayName: 'Jira',
        productKey: 'jira-software'
    },
    jira_work_management: {
        logo: 'JiraWorkManagementLogo',
        icon: 'JiraWorkManagementIcon',
        displayName: 'Jira Work Management',
        productKey: 'jira-work-management'
    },
    loom: {
        logo: 'LoomLogo',
        icon: 'LoomIcon',
        displayName: 'Loom',
        productKey: 'loom'
    },
    loom_attribution: {
        logo: 'LoomLogo',
        icon: 'LoomIcon',
        displayName: 'Loom Attribution',
        productKey: 'loom-attribution'
    },
    mercury: {
        icon: 'FocusIcon',
        displayName: 'Focus',
        productKey: 'mercury'
    },
    opsgenie: {
        logo: 'OpsgenieLogo',
        icon: 'OpsgenieIcon',
        displayName: 'Opsgenie',
        productKey: 'opsgenie'
    },
    passionfruit: {
        icon: 'AtlassianIcon',
        displayName: 'Passionfruit',
        productKey: 'passionfruit'
    },
    project: {
        icon: 'ProjectsIcon',
        displayName: 'Projects',
        productKey: 'project'
    },
    radar: {
        icon: 'TalentIcon',
        displayName: 'Talent',
        productKey: 'radar'
    },
    rovo: {
        logo: 'RovoLogo',
        icon: 'RovoIcon',
        displayName: 'Rovo',
        productKey: 'rovo'
    },
    statuspage: {
        logo: 'StatuspageLogo',
        icon: 'StatuspageIcon',
        displayName: 'Statuspage',
        productKey: 'statuspage'
    },
    stride: {
        icon: 'AtlassianIcon',
        displayName: 'Stride',
        productKey: 'hipchat.cloud'
    },
    studio: {
        icon: 'StudioIcon',
        displayName: 'Studio',
        productKey: 'studio'
    },
    teamcentral: {
        icon: 'AtlassianIcon',
        displayName: 'Team Central',
        productKey: 'townsquare'
    },
    teams: {
        icon: 'TeamsIcon',
        displayName: 'Teams',
        productKey: 'teams'
    },
    trello: {
        logo: 'TrelloLogo',
        icon: 'TrelloIcon',
        displayName: 'Trello',
        productKey: 'trello'
    },
    unified_help: {
        icon: 'AtlassianIcon',
        displayName: 'Unified Help',
        productKey: 'unified-help'
    },
    unknown_atlassian: {
        icon: 'AtlassianIcon',
        displayName: 'Unknown Atlassian',
        productKey: 'unknown-atlassian'
    }
};
function $d3185276e14a4c2b$export$7524c8b3bd6ccb7f(productType) {
    const config = $d3185276e14a4c2b$export$b8c7f5b0854d3581[productType.toLowerCase()];
    return config || null;
}
function $d3185276e14a4c2b$export$4f572bfb89b8eab9() {
    return Object.values($d3185276e14a4c2b$export$b8c7f5b0854d3581);
}
const $d3185276e14a4c2b$export$44fea6589b7ddc92 = (productType)=>{
    const config = $d3185276e14a4c2b$export$7524c8b3bd6ccb7f(productType);
    return config?.displayName || productType;
};
const $d3185276e14a4c2b$export$27e53caf66bae1d = (productKey)=>{
    // Find the UiProductType key that matches the productKey
    const productTypeEntry = Object.entries($d3185276e14a4c2b$export$b8c7f5b0854d3581).find(([, value])=>value.productKey === productKey);
    return productTypeEntry ? productTypeEntry[0] : null;
};
const $d3185276e14a4c2b$export$a3ce53670861b599 = (productKey)=>{
    const config = Object.values($d3185276e14a4c2b$export$b8c7f5b0854d3581).find((config)=>config.productKey === productKey);
    return config || null;
};


const $7397f708924e0bda$var$messages = (0, $aRMzY.defineMessages)({
    productIconAlt: {
        id: 'appUpdates.productIcon.alt',
        defaultMessage: '{productName} icon',
        description: 'Alt text for app icon'
    },
    unknownProductIcon: {
        id: 'appUpdates.productIcon.unknown',
        defaultMessage: 'App icon',
        description: 'Alt text for unknown app icon'
    }
});
const $7397f708924e0bda$export$1a199e029d5e93d6 = ({ productType: productType, size: size = 'small', useIcon: useIcon = true, testId: testId })=>{
    const { formatMessage: formatMessage } = (0, $6Wx3K.default)();
    const productConfig = productType ? (0, $d3185276e14a4c2b$export$7524c8b3bd6ccb7f)(productType) : null;
    // If no product config found, fallback to AtlassianIcon
    if (!productConfig) return /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)($3UCXU.AtlassianIcon, {
        size: size,
        appearance: "brand",
        shouldUseNewLogoDesign: true,
        testId: testId || 'product-icon-fallback',
        label: formatMessage($7397f708924e0bda$var$messages.unknownProductIcon)
    });
    // Determine which component to use (icon or logo)
    const componentName = useIcon ? productConfig.icon : productConfig.logo || productConfig.icon;
    // Get the component from AtlasKit logo library with type assertion
    const LogoComponent = $3UCXU[componentName];
    if (!LogoComponent || typeof LogoComponent !== 'function') // Fallback to AtlassianIcon if component not found
    return /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)($3UCXU.AtlassianIcon, {
        size: size,
        appearance: "brand",
        shouldUseNewLogoDesign: true,
        testId: testId || 'product-icon-fallback',
        label: formatMessage($7397f708924e0bda$var$messages.unknownProductIcon)
    });
    return /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)(LogoComponent, {
        size: size,
        appearance: "brand",
        shouldUseNewLogoDesign: true,
        testId: testId || `product-icon-${componentName}`,
        label: formatMessage($7397f708924e0bda$var$messages.productIconAlt, {
            productName: productConfig.displayName
        })
    });
};




/**
 * Product keys of apps that are supported by the backend and should be visible in the UI.
 * Derived from the backend's supported apps enum (context IDs).
 */ const $50e94d71524dc43e$var$VISIBLE_PRODUCT_KEYS = new Set([
    'cmdb',
    'avp',
    'bitbucket',
    'cloud-admin',
    'compass',
    'confluence',
    'jira-customer-service',
    'mercury',
    'goal',
    'jira-software',
    'jira-align',
    'jira-product-discovery',
    'jira-servicedesk',
    'loom',
    'opsgenie',
    'project',
    'radar',
    'rovo',
    'devai',
    'statuspage',
    'studio',
    'teams',
    'trello'
]);
const $50e94d71524dc43e$export$c6f09e1afd88c25a = ()=>{
    return Object.fromEntries(Object.entries((0, $d3185276e14a4c2b$export$b8c7f5b0854d3581)).filter(([, config])=>$50e94d71524dc43e$var$VISIBLE_PRODUCT_KEYS.has(config.productKey))// PRODUCT_LOGO_MAP keys are Lowercase<UiProductType>, so toUpperCase() gives UiProductType
    .map(([key, config])=>[
            key.toUpperCase(),
            config
        ]));
};
const $50e94d71524dc43e$export$fd35fa3fda96a6c2 = (productKey)=>{
    return $50e94d71524dc43e$var$VISIBLE_PRODUCT_KEYS.has(productKey);
};



/**
 * Priority order for displaying impacted products.
 * Key products like Jira and Confluence are shown first.
 * Products not in this list will appear at the end in their original order.
 */ const $ace4c485fd808422$var$PRODUCT_PRIORITY_ORDER = [
    'JIRA_SOFTWARE',
    'JIRA_CORE',
    'CONFLUENCE',
    'CLOUD_ADMIN',
    'ROVO',
    'JIRA_SERVICE_MANAGEMENT',
    'JIRA_WORK_MANAGEMENT',
    'JIRA_PRODUCT_DISCOVERY',
    'LOOM',
    'TRELLO',
    'BITBUCKET',
    'COMPASS',
    'OPSGENIE',
    'STATUSPAGE',
    'JIRA_ALIGN',
    'JIRA_ADMIN',
    'JIRA_CUSTOMER_SERVICE',
    'JIRA_INCIDENT_MANAGER'
];
/**
 * Normalizes a product type to uppercase for comparison.
 * Handles both uppercase (JIRA_SOFTWARE) and lowercase (jira_software) inputs.
 */ const $ace4c485fd808422$var$normalizeProductType = (product)=>product.toUpperCase();
const $ace4c485fd808422$export$e3760658a711f2d3 = (products)=>{
    if (products.length === 0) return [];
    const productsCopy = [
        ...products
    ];
    const normalizedPriorityOrder = $ace4c485fd808422$var$PRODUCT_PRIORITY_ORDER.map($ace4c485fd808422$var$normalizeProductType);
    const sorted = productsCopy.sort((a, b)=>{
        const weightA = normalizedPriorityOrder.indexOf($ace4c485fd808422$var$normalizeProductType(a));
        const weightB = normalizedPriorityOrder.indexOf($ace4c485fd808422$var$normalizeProductType(b));
        return (weightA === -1 ? Infinity : weightA) - (weightB === -1 ? Infinity : weightB);
    });
    // Deduplicate by display name — keep the first (highest priority) occurrence
    const seenDisplayNames = new Set();
    return sorted.filter((product)=>{
        const displayName = (0, $d3185276e14a4c2b$export$44fea6589b7ddc92)(product);
        if (seenDisplayNames.has(displayName)) return false;
        seenDisplayNames.add(displayName);
        return true;
    });
};




const $51e43113ed6c9475$export$c2352a34eb11a9e9 = [
    'COMING_SOON',
    'PLANNED',
    'ROLLING_OUT',
    'GENERALLY_AVAILABLE',
    'ROLLED_BACK'
];
const $51e43113ed6c9475$export$94a5323e67ff7814 = [
    'IMPROVEMENT',
    'FIX',
    'EXPERIMENT',
    'REMOVED',
    'ANNOUNCEMENT'
];
const $51e43113ed6c9475$export$aafe24a01710fa9a = [
    'HIGH',
    'MEDIUM',
    'LOW'
];
const $51e43113ed6c9475$export$5926fcb263ea10c4 = {
    HIGH: 'High',
    MEDIUM: 'Medium',
    LOW: 'Low'
};
const $51e43113ed6c9475$export$f3e6ae23d6c89755 = [
    'EXPERIMENT',
    'SEASONAL_RELEASE',
    'UI_RELATED',
    'BUG_FIX',
    'PERFORMANCE_IMPROVEMENT',
    'NEW_FEATURE',
    'DEPRECATION_REMOVAL',
    'INTEGRATION_API_CHANGE',
    'PERMISSIONS_ACCESS_CONTROL',
    'AI_RELATED'
];
const $51e43113ed6c9475$export$d9b81c96441d0617 = {
    EXPERIMENT: '#Experiment',
    SEASONAL_RELEASE: '#Seasonal-release',
    UI_RELATED: '#UI',
    BUG_FIX: '#Bug-fix',
    PERFORMANCE_IMPROVEMENT: '#Performance',
    NEW_FEATURE: '#New-feature',
    DEPRECATION_REMOVAL: '#Deprecation',
    INTEGRATION_API_CHANGE: '#API-change',
    PERMISSIONS_ACCESS_CONTROL: '#Permissions',
    AI_RELATED: '#AI'
};
const $51e43113ed6c9475$export$4bbe71e8edfbf0cd = (tagId)=>$51e43113ed6c9475$export$d9b81c96441d0617[tagId] ?? tagId;


const $ea567f1e5717897c$export$e582c11b604ddc57 = (filters)=>{
    const params = {};
    if (filters.searchQuery) params.search = filters.searchQuery;
    if (filters.selectedProducts && filters.selectedProducts.length > 0) params.products = filters.selectedProducts.map((p)=>p.id).join(',');
    if (filters.selectedStatuses && filters.selectedStatuses.length > 0) params.statuses = filters.selectedStatuses.map((p)=>p.id).join(',');
    if (filters.selectedChangeTypes && filters.selectedChangeTypes.length > 0) params.changeTypes = filters.selectedChangeTypes.map((p)=>p.id).join(',');
    if (filters.selectedImpactRatings && filters.selectedImpactRatings.length > 0) params.impactRatings = filters.selectedImpactRatings.map((p)=>p.id).join(',');
    if (filters.selectedTags && filters.selectedTags.length > 0) params.tags = filters.selectedTags.map((p)=>p.id).join(',');
    if (filters.selectedBundleDate) params.bundleDate = filters.selectedBundleDate;
    if (filters.cursor) params.cursor = filters.cursor;
    if (typeof filters.limit === 'number' && Number.isFinite(filters.limit)) params.limit = String(filters.limit);
    return params;
};
const $ea567f1e5717897c$export$e0663cb7e2aca336 = Object.entries((0, $50e94d71524dc43e$export$c6f09e1afd88c25a)()).map(([key, config])=>({
        id: key,
        name: config.displayName,
        icon: config.icon
    }));
const $ea567f1e5717897c$var$availableStatuses = (0, $51e43113ed6c9475$export$c2352a34eb11a9e9).map((statusId)=>({
        id: statusId,
        name: statusId
    }));
const $ea567f1e5717897c$var$availableChangeTypes = (0, $51e43113ed6c9475$export$94a5323e67ff7814).map((changeTypeId)=>({
        id: changeTypeId,
        name: changeTypeId
    }));
const $ea567f1e5717897c$var$availableImpactRatings = (0, $51e43113ed6c9475$export$aafe24a01710fa9a).map((ratingId)=>({
        id: ratingId,
        name: (0, $51e43113ed6c9475$export$5926fcb263ea10c4)[ratingId]
    }));
const $ea567f1e5717897c$var$availableTags = (0, $51e43113ed6c9475$export$f3e6ae23d6c89755).map((tagId)=>({
        id: tagId,
        name: tagId
    }));
const $ea567f1e5717897c$export$227523e113d14c22 = ()=>{
    if (typeof window === 'undefined') return {};
    const params = new URLSearchParams(window.location.search);
    const filters = {};
    const search = params.get('search');
    if (search) filters.searchQuery = search;
    const products = params.get('products');
    if (products) {
        const productKeys = products.split(',').filter(Boolean);
        filters.selectedProducts = $ea567f1e5717897c$export$e0663cb7e2aca336.filter((p)=>productKeys.includes(p.id));
    }
    const statuses = params.get('statuses');
    if (statuses) {
        const statusIds = statuses.split(',').filter(Boolean);
        filters.selectedStatuses = $ea567f1e5717897c$var$availableStatuses.filter((s)=>statusIds.includes(s.id));
    }
    const changeTypes = params.get('changeTypes');
    if (changeTypes) {
        const changeTypeIds = changeTypes.split(',').filter(Boolean);
        filters.selectedChangeTypes = $ea567f1e5717897c$var$availableChangeTypes.filter((c)=>changeTypeIds.includes(c.id));
    }
    const impactRatings = params.get('impactRatings');
    if (impactRatings) {
        const ratingIds = impactRatings.split(',').filter(Boolean);
        filters.selectedImpactRatings = $ea567f1e5717897c$var$availableImpactRatings.filter((r)=>ratingIds.includes(r.id));
    }
    const tags = params.get('tags');
    if (tags) {
        const tagIds = tags.split(',').filter(Boolean);
        filters.selectedTags = $ea567f1e5717897c$var$availableTags.filter((t)=>tagIds.includes(t.id));
    }
    const bundleDate = params.get('bundleDate');
    if (bundleDate) filters.selectedBundleDate = bundleDate;
    const cursor = params.get('cursor');
    if (cursor) filters.cursor = cursor;
    const limit = params.get('limit');
    if (limit) {
        const parsedLimit = Number(limit);
        if (Number.isFinite(parsedLimit) && parsedLimit > 0) filters.limit = parsedLimit;
    }
    return filters;
};
const $ea567f1e5717897c$export$de85dd96eb599379 = (params)=>{
    const searchParams = new URLSearchParams();
    Object.entries(params).forEach(([key, value])=>{
        if (value) searchParams.set(key, value);
    });
    const searchString = searchParams.toString();
    return searchString ? `?${searchString}` : '';
};


const $cb707c631f92bf69$var$urlFilters = (0, $ea567f1e5717897c$export$227523e113d14c22)();
const $cb707c631f92bf69$var$initialFiltersState = {
    selectedProducts: $cb707c631f92bf69$var$urlFilters.selectedProducts ?? null,
    selectedBundleDate: $cb707c631f92bf69$var$urlFilters.selectedBundleDate ?? null,
    searchQuery: $cb707c631f92bf69$var$urlFilters.searchQuery ?? null
};
const $cb707c631f92bf69$var$emptyFiltersState = {
    selectedProducts: null,
    selectedBundleDate: null,
    searchQuery: null
};
const $cb707c631f92bf69$export$4ea9a80dc2aa2583 = {
    data: [],
    isLoading: false,
    error: null,
    links: {
        prev: null,
        self: '',
        next: null
    },
    pagination: {
        cursor: $cb707c631f92bf69$var$urlFilters.cursor,
        limit: $cb707c631f92bf69$var$urlFilters.limit ?? 100
    },
    draftFilters: {
        ...$cb707c631f92bf69$var$initialFiltersState
    },
    committedFilters: {
        ...$cb707c631f92bf69$var$initialFiltersState,
        committedFiltersVersion: 0
    }
};
const $cb707c631f92bf69$export$fb2ad06510f736b4 = (state, action)=>{
    switch(action.type){
        case 'BUNDLE_FILTER_APP_SELECT':
            return {
                ...state,
                draftFilters: {
                    ...state.draftFilters,
                    selectedProducts: action.payload.selectedProducts
                }
            };
        case 'BUNDLE_FILTER_DATE_SELECT':
            return {
                ...state,
                draftFilters: {
                    ...state.draftFilters,
                    selectedBundleDate: action.payload.selectedBundleDate
                }
            };
        case 'BUNDLE_FILTER_SEARCH_SELECT':
            return {
                ...state,
                draftFilters: {
                    ...state.draftFilters,
                    searchQuery: action.payload.searchQuery
                }
            };
        case 'BUNDLES_FILTERS_APPLY':
            return {
                ...state,
                committedFilters: {
                    ...state.draftFilters,
                    committedFiltersVersion: state.committedFilters.committedFiltersVersion + 1
                },
                pagination: {
                    ...state.pagination,
                    cursor: undefined
                }
            };
        case 'BUNDLES_FILTERS_RESET':
            return {
                ...state,
                draftFilters: {
                    ...$cb707c631f92bf69$var$emptyFiltersState,
                    selectedBundleDate: action.payload.selectedBundleDate
                },
                committedFilters: {
                    ...$cb707c631f92bf69$var$emptyFiltersState,
                    selectedBundleDate: action.payload.selectedBundleDate,
                    committedFiltersVersion: state.committedFilters.committedFiltersVersion + 1
                },
                pagination: {
                    ...state.pagination,
                    cursor: undefined
                }
            };
        case 'BUNDLES_DRAFT_FILTERS_RESET':
            return {
                ...state,
                draftFilters: {
                    ...$cb707c631f92bf69$var$emptyFiltersState,
                    selectedBundleDate: action.payload.selectedBundleDate
                }
            };
        case 'BUNDLES_DATA_LINKS_SET':
            return {
                ...state,
                data: action.payload.data,
                links: action.payload.links
            };
        case 'BUNDLES_LOADING_SET':
            return {
                ...state,
                isLoading: action.payload.isLoading
            };
        case 'BUNDLES_ERROR_SET':
            return {
                ...state,
                error: action.payload.error
            };
        case 'BUNDLES_CURSOR_SET':
            return {
                ...state,
                pagination: {
                    ...state.pagination,
                    cursor: action.payload.cursor
                }
            };
        case 'BUNDLES_LIMIT_SET':
            return {
                ...state,
                pagination: {
                    ...state.pagination,
                    limit: action.payload.limit,
                    cursor: undefined
                }
            };
        default:
            return state;
    }
};


const $add35b76dd84c7d0$var$urlFilters = (0, $ea567f1e5717897c$export$227523e113d14c22)();
const $add35b76dd84c7d0$var$initialFiltersState = {
    selectedProducts: $add35b76dd84c7d0$var$urlFilters.selectedProducts ?? null,
    selectedStatuses: $add35b76dd84c7d0$var$urlFilters.selectedStatuses ?? null,
    selectedChangeTypes: $add35b76dd84c7d0$var$urlFilters.selectedChangeTypes ?? null,
    selectedImpactRatings: $add35b76dd84c7d0$var$urlFilters.selectedImpactRatings ?? null,
    selectedTags: $add35b76dd84c7d0$var$urlFilters.selectedTags ?? null,
    searchQuery: $add35b76dd84c7d0$var$urlFilters.searchQuery ?? null,
    effectiveFrom: null
};
const $add35b76dd84c7d0$export$fc84e809bad5f75a = {
    data: [],
    isLoading: false,
    error: null,
    links: {
        self: '',
        next: null,
        prev: null
    },
    pagination: {
        cursor: $add35b76dd84c7d0$var$urlFilters.cursor,
        limit: $add35b76dd84c7d0$var$urlFilters.limit ?? 20
    },
    draftFilters: {
        ...$add35b76dd84c7d0$var$initialFiltersState
    },
    committedFilters: {
        ...$add35b76dd84c7d0$var$initialFiltersState,
        committedFiltersVersion: 0
    }
};
const $add35b76dd84c7d0$export$ad0c6bbc0e9460d8 = (state, action)=>{
    switch(action.type){
        case 'UPDATES_DATA_LINKS_SET':
            return {
                ...state,
                data: action.payload.updates,
                links: action.payload.links
            };
        case 'UPDATES_CURSOR_SET':
            return {
                ...state,
                pagination: {
                    ...state.pagination,
                    cursor: action.payload.cursor
                }
            };
        case 'UPDATES_LIMIT_SET':
            return {
                ...state,
                pagination: {
                    ...state.pagination,
                    limit: action.payload.limit,
                    cursor: undefined
                }
            };
        case 'UPDATES_LOADING_SET':
            return {
                ...state,
                isLoading: action.payload.isLoading
            };
        case 'UPDATES_ERROR_SET':
            return {
                ...state,
                error: action.payload.error
            };
        case 'FILTER_APP_SELECT':
            return {
                ...state,
                draftFilters: {
                    ...state.draftFilters,
                    selectedProducts: action.payload.selectedProducts
                }
            };
        case 'FILTER_STATUS_SELECT':
            return {
                ...state,
                draftFilters: {
                    ...state.draftFilters,
                    selectedStatuses: action.payload.selectedStatuses
                }
            };
        case 'FILTER_CHANGE_TYPE_SELECT':
            return {
                ...state,
                draftFilters: {
                    ...state.draftFilters,
                    selectedChangeTypes: action.payload.selectedChangeTypes
                }
            };
        case 'FILTER_IMPACT_RATING_SELECT':
            return {
                ...state,
                draftFilters: {
                    ...state.draftFilters,
                    selectedImpactRatings: action.payload.selectedImpactRatings
                }
            };
        case 'FILTER_TAG_SELECT':
            return {
                ...state,
                draftFilters: {
                    ...state.draftFilters,
                    selectedTags: action.payload.selectedTags
                }
            };
        case 'FILTER_SEARCH_SELECT':
            return {
                ...state,
                draftFilters: {
                    ...state.draftFilters,
                    searchQuery: action.payload.searchQuery
                }
            };
        case 'UPDATES_FILTERS_APPLY':
            return {
                ...state,
                committedFilters: {
                    ...state.draftFilters,
                    committedFiltersVersion: state.committedFilters.committedFiltersVersion + 1
                },
                pagination: {
                    ...state.pagination,
                    cursor: undefined
                }
            };
        case 'FILTER_EFFECTIVE_FROM_TOGGLE':
            return {
                ...state,
                draftFilters: {
                    ...state.draftFilters,
                    effectiveFrom: action.payload.effectiveFrom
                },
                committedFilters: {
                    ...state.committedFilters,
                    effectiveFrom: action.payload.effectiveFrom,
                    committedFiltersVersion: state.committedFilters.committedFiltersVersion + 1
                },
                pagination: {
                    ...state.pagination,
                    cursor: undefined
                }
            };
        case 'UPDATES_FILTERS_RESET':
            return {
                ...state,
                draftFilters: {
                    selectedProducts: null,
                    selectedStatuses: null,
                    selectedChangeTypes: null,
                    selectedImpactRatings: null,
                    selectedTags: null,
                    searchQuery: null,
                    effectiveFrom: null
                },
                committedFilters: {
                    selectedProducts: null,
                    selectedStatuses: null,
                    selectedChangeTypes: null,
                    selectedImpactRatings: null,
                    selectedTags: null,
                    searchQuery: null,
                    effectiveFrom: null,
                    committedFiltersVersion: state.committedFilters.committedFiltersVersion + 1
                },
                pagination: {
                    ...state.pagination,
                    cursor: undefined
                }
            };
        case 'UPDATES_DRAFT_FILTERS_RESET':
            return {
                ...state,
                draftFilters: {
                    selectedProducts: null,
                    selectedStatuses: null,
                    selectedChangeTypes: null,
                    selectedImpactRatings: null,
                    selectedTags: null,
                    searchQuery: null,
                    effectiveFrom: null
                }
            };
        default:
            return state;
    }
};


const $4933e76bd0ca959e$var$INITIAL_STATE = {
    ...(0, $ff8369db971fa1a8$export$237dc0bae177ad41),
    updates: (0, $add35b76dd84c7d0$export$fc84e809bad5f75a),
    bundles: (0, $cb707c631f92bf69$export$4ea9a80dc2aa2583)
};
function $4933e76bd0ca959e$var$reducer(state, action) {
    switch(action.type){
        case 'AUTHENTICATE':
            {
                const authState = (0, $ff8369db971fa1a8$export$b3aa4dbb59e7857d)({
                    user: state.user,
                    isLoggedIn: state.isLoggedIn,
                    loggedInUser: state.loggedInUser
                }, action);
                return {
                    ...state,
                    ...authState
                };
            }
        case 'UPDATES_CURSOR_SET':
        case 'UPDATES_LIMIT_SET':
        case 'UPDATES_DATA_LINKS_SET':
        case 'UPDATES_LOADING_SET':
        case 'UPDATES_ERROR_SET':
        case 'FILTER_APP_SELECT':
        case 'FILTER_STATUS_SELECT':
        case 'FILTER_CHANGE_TYPE_SELECT':
        case 'FILTER_IMPACT_RATING_SELECT':
        case 'FILTER_TAG_SELECT':
        case 'FILTER_SEARCH_SELECT':
        case 'UPDATES_FILTERS_APPLY':
        case 'UPDATES_FILTERS_RESET':
        case 'UPDATES_DRAFT_FILTERS_RESET':
        case 'FILTER_EFFECTIVE_FROM_TOGGLE':
            return {
                ...state,
                updates: (0, $add35b76dd84c7d0$export$ad0c6bbc0e9460d8)(state.updates, action)
            };
        case 'BUNDLE_FILTER_APP_SELECT':
        case 'BUNDLE_FILTER_DATE_SELECT':
        case 'BUNDLE_FILTER_SEARCH_SELECT':
        case 'BUNDLES_FILTERS_APPLY':
        case 'BUNDLES_FILTERS_RESET':
        case 'BUNDLES_DRAFT_FILTERS_RESET':
        case 'BUNDLES_DATA_LINKS_SET':
        case 'BUNDLES_LOADING_SET':
        case 'BUNDLES_ERROR_SET':
        case 'BUNDLES_CURSOR_SET':
        case 'BUNDLES_LIMIT_SET':
            return {
                ...state,
                bundles: (0, $cb707c631f92bf69$export$fb2ad06510f736b4)(state.bundles, action)
            };
        default:
            return state;
    }
}
const $4933e76bd0ca959e$var$AppUpdatesContext = /*#__PURE__*/ (0, $5FkrB.createContext)(null);
const $4933e76bd0ca959e$export$7653fec709d1e7bb = ()=>{
    const ctx = (0, $5FkrB.useContext)($4933e76bd0ca959e$var$AppUpdatesContext);
    if (!ctx) throw new Error('useAppUpdatesContext must be used within <AppUpdatesContextProvider>');
    return ctx;
};
const $4933e76bd0ca959e$export$5d107a7783183624 = ({ children: children, api: api, initialState: initialState })=>{
    const initialUser = initialState?.user ?? $4933e76bd0ca959e$var$INITIAL_STATE.user;
    const initialStateMerged = {
        user: initialUser,
        ...(0, $ff8369db971fa1a8$export$299abcbcbe81ab38)(initialUser),
        updates: {
            ...$4933e76bd0ca959e$var$INITIAL_STATE.updates,
            ...initialState?.updates,
            pagination: {
                ...$4933e76bd0ca959e$var$INITIAL_STATE.updates.pagination,
                ...initialState?.updates?.pagination
            },
            draftFilters: {
                ...$4933e76bd0ca959e$var$INITIAL_STATE.updates.draftFilters,
                ...initialState?.updates?.draftFilters
            },
            committedFilters: {
                ...$4933e76bd0ca959e$var$INITIAL_STATE.updates.committedFilters,
                ...initialState?.updates?.committedFilters
            }
        },
        bundles: {
            ...$4933e76bd0ca959e$var$INITIAL_STATE.bundles,
            ...initialState?.bundles,
            pagination: {
                ...$4933e76bd0ca959e$var$INITIAL_STATE.bundles.pagination,
                ...initialState?.bundles?.pagination
            },
            draftFilters: {
                ...$4933e76bd0ca959e$var$INITIAL_STATE.bundles.draftFilters,
                ...initialState?.bundles?.draftFilters
            },
            committedFilters: {
                ...$4933e76bd0ca959e$var$INITIAL_STATE.bundles.committedFilters,
                ...initialState?.bundles?.committedFilters
            }
        }
    };
    const [state, dispatch] = (0, $5FkrB.useReducer)($4933e76bd0ca959e$var$reducer, initialStateMerged);
    const value = (0, $5FkrB.useMemo)(()=>({
            state: state,
            dispatch: dispatch,
            api: api
        }), [
        state,
        dispatch,
        api
    ]);
    return /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)($4933e76bd0ca959e$var$AppUpdatesContext.Provider, {
        value: value,
        children: children
    });
};





var $aRMzY = parcelRequire("aRMzY");
var $6Wx3K = parcelRequire("6Wx3K");
/* index.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $kqp0i = parcelRequire("kqp0i");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");
/**
 * This length includes the underscore,
 * e.g. `"_1s4A"` would be a valid atomic group hash.
 */ const $38d65157ec43a82c$var$ATOMIC_GROUP_LENGTH = 5;
function $38d65157ec43a82c$export$2e2bcd8739ae039(classNames) {
    // Shortcut: nothing to do
    if (!classNames.length) return;
    // Shortcut: don't need to do anything if we only have a single classname
    if (classNames.length === 1 && classNames[0] && // checking to see if `classNames[0]` is a string that contains other classnames
    !classNames[0].includes(' ')) return classNames[0];
    // Using an object rather than a `Map` as it performed better in our benchmarks.
    // Would be happy to move to `Map` if it proved to be better under real conditions.
    const map = {};
    // Note: using loops to minimize iterations over the collection
    for (const value of classNames){
        // Exclude all falsy values, which leaves us with populated strings
        if (!value) continue;
        // a `value` can contain multiple classnames
        const list = value.split(' ');
        for (const className of list){
            /**
             * For atomic style classnames: the `key` is the `group`
             *
             * - Later atomic classnames with the same `group` will override earlier ones
             *   (which is what we want).
             * - Assumes atomic classnames are the only things that start with `_`
             * - Could use a regex to ensure that atomic classnames are structured how we expect,
             *   but did not add that for now as it did slow things down a bit.
             *
             * For other classnames: the `key` is the whole classname
             * - Okay to remove duplicates as doing so does not impact specificity
             *
             * */ const key = className.startsWith('_') ? className.slice(0, $38d65157ec43a82c$var$ATOMIC_GROUP_LENGTH) : className;
            map[key] = className;
        }
    }
    /**
     * We are converting the `map` into a string.
     *
     * The simple way to do this would be `Object.values(map).join(' ')`.
     * However, the approach below performs 10%-20% better in benchmarks.
     *
     * For `ax()` it feels right to squeeze as much runtime performance out as we can.
     */ let result = '';
    for(const key in map)result += map[key] + ' ';
    // If we have an empty string, then our `map` was empty.
    if (!result) return;
    // remove last " " from the result (we added " " at the end of every value)
    return result.trimEnd();
}



var $hRJ5R = parcelRequire("hRJ5R");

var $ISKn7 = parcelRequire("ISKn7");
var $0451700bcb4c47f9$var$_process, $0451700bcb4c47f9$var$_process2;
// We can't rely on NODE_ENV === 'test' if its value is already configured by the consumer to some other value, so better to use JEST_WORKER_ID
// https://jestjs.io/docs/environment-variables#jest_worker_id
var $0451700bcb4c47f9$var$TESTS_MODE = (globalThis === null || globalThis === void 0 || ($0451700bcb4c47f9$var$_process = globalThis.process) === null || $0451700bcb4c47f9$var$_process === void 0 || ($0451700bcb4c47f9$var$_process = $0451700bcb4c47f9$var$_process.env) === null || $0451700bcb4c47f9$var$_process === void 0 ? void 0 : $0451700bcb4c47f9$var$_process.JEST_WORKER_ID) !== undefined;
var $0451700bcb4c47f9$var$DEBUG_MODE = !$0451700bcb4c47f9$var$TESTS_MODE && (globalThis === null || globalThis === void 0 || ($0451700bcb4c47f9$var$_process2 = globalThis.process) === null || $0451700bcb4c47f9$var$_process2 === void 0 || ($0451700bcb4c47f9$var$_process2 = $0451700bcb4c47f9$var$_process2.env) === null || $0451700bcb4c47f9$var$_process2 === void 0 ? void 0 : $0451700bcb4c47f9$var$_process2.NODE_ENV) !== 'production';
var $0451700bcb4c47f9$export$1c9f709888824e05 = function debug() {
    var _console;
    if (!$0451700bcb4c47f9$var$DEBUG_MODE) return;
    // eslint-disable-next-line no-console
    (_console = console).debug.apply(_console, arguments);
};



var $3ZMUU = parcelRequire("3ZMUU");
var $6f36a53848257378$var$pkgName = '@atlaskit/platform-feature-flags';
var $6f36a53848257378$export$7e41b1b2bdee3f98 = '__PLATFORM_FEATURE_FLAGS__';
var $6f36a53848257378$var$hasProcessEnv = typeof $3ZMUU !== 'undefined' && typeof $3ZMUU.env !== 'undefined';
// FF global overrides can be configured by test runners or Storybook
var $6f36a53848257378$var$ENV_ENABLE_PLATFORM_FF = $6f36a53848257378$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
// STORYBOOK_ENABLE_PLATFORM_FF is included as storybook only allows env vars prefixed with STORYBOOK
// https://github.com/storybookjs/storybook/issues/12270
var $6f36a53848257378$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF = $6f36a53848257378$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
var $6f36a53848257378$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE = $6f36a53848257378$var$ENV_ENABLE_PLATFORM_FF || $6f36a53848257378$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF;
var $6f36a53848257378$var$DEFAULT_PFF_GLOBAL = {
    booleanResolver: undefined
};
var $6f36a53848257378$var$globalVar = typeof window !== 'undefined' ? window : globalThis;
$6f36a53848257378$var$globalVar[$6f36a53848257378$export$7e41b1b2bdee3f98] = $6f36a53848257378$var$globalVar[$6f36a53848257378$export$7e41b1b2bdee3f98] || $6f36a53848257378$var$DEFAULT_PFF_GLOBAL;
function $6f36a53848257378$export$f2b591175b3e424c(resolver) {
    $6f36a53848257378$var$globalVar[$6f36a53848257378$export$7e41b1b2bdee3f98].booleanResolver = resolver;
}
function $6f36a53848257378$export$6333b6aff9fc6275(flagKey) {
    if ($6f36a53848257378$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE) {
        (0, $0451700bcb4c47f9$export$1c9f709888824e05)('[%s]: The feature flags were enabled while running tests. The flag "%s" will be always enabled.', $6f36a53848257378$var$pkgName, flagKey);
        return true;
    }
    try {
        var _globalVar$PFF_GLOBAL, _globalVar$PFF_GLOBAL2, _globalVar$PFF_GLOBAL3;
        // booleanResolver will be empty for products like Trello, Elevate, Recruit etc.
        // Currently only Confluence, Jira and Bitbucket has set it.
        if (((_globalVar$PFF_GLOBAL = $6f36a53848257378$var$globalVar[$6f36a53848257378$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL === void 0 ? void 0 : _globalVar$PFF_GLOBAL.booleanResolver) === undefined || ((_globalVar$PFF_GLOBAL2 = $6f36a53848257378$var$globalVar[$6f36a53848257378$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL2 === void 0 ? void 0 : _globalVar$PFF_GLOBAL2.booleanResolver) === null) // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
        return (0, $ISKn7.default).checkGate(flagKey);
        var result = (_globalVar$PFF_GLOBAL3 = $6f36a53848257378$var$globalVar[$6f36a53848257378$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL3 === void 0 ? void 0 : _globalVar$PFF_GLOBAL3.booleanResolver(flagKey);
        if (typeof result !== 'boolean') {
            // eslint-disable-next-line no-console
            console.warn("".concat(flagKey, " resolved to a non-boolean value, returning false for safety"));
            return false;
        }
        return result;
    } catch (e) {
        return false;
    }
}


function $29c5ad3390847ec7$export$ba05d765b8392e5e(flagResolver) {
    (0, $6f36a53848257378$export$f2b591175b3e424c)(flagResolver);
}
function $29c5ad3390847ec7$export$470e5c2be1411c89(name) {
    return (0, $6f36a53848257378$export$6333b6aff9fc6275)(name);
}
function $29c5ad3390847ec7$export$b40ec24ac8275656(name) {
    return (0, $6f36a53848257378$export$6333b6aff9fc6275)(name);
}


/* anchor.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $kqp0i = parcelRequire("kqp0i");

var $ekGgq = parcelRequire("ekGgq");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");


const $9986544026cab6ed$export$a274e22fb40f762e = (...styles)=>{
    // At runtime TStyles is resolved down to strings, but not at compile time.
    // We circumvent the type system here because of that.
    const actualStyles = styles;
    // The output should be a union type of passed in styles. This ensures the call
    // site of xcss prop can raise violations when disallowed styles have been passed.
    return (0, $38d65157ec43a82c$export$2e2bcd8739ae039)(actualStyles);
};



var $afMOk = parcelRequire("afMOk");

var $25nEq = parcelRequire("25nEq");

var $5FkrB = parcelRequire("5FkrB");

var $dLGML = parcelRequire("dLGML");

var $fC8ib = parcelRequire("fC8ib");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $kIXpt = parcelRequire("kIXpt");

var $cYPzS = parcelRequire("cYPzS");

var $lwlXp = parcelRequire("lwlXp");

var $eyuDe = parcelRequire("eyuDe");

var $25nEq = parcelRequire("25nEq");

var $ekGgq = parcelRequire("ekGgq");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $25nEq = parcelRequire("25nEq");
function $427d60da9e7e5d8e$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $427d60da9e7e5d8e$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $427d60da9e7e5d8e$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $427d60da9e7e5d8e$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $427d60da9e7e5d8e$export$ad4be5c2ec28cecf = function isAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $427d60da9e7e5d8e$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === 'AnalyticsEvent';
};
// eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
var $427d60da9e7e5d8e$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function AnalyticsEvent(props) {
        var _this = this;
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, AnalyticsEvent);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "_isAnalyticsEvent", true);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "clone", function() {
            // just a shallow clone, don't change sub refs unless you want to
            // affect the original's too
            var payload = $427d60da9e7e5d8e$var$_objectSpread({}, _this.payload);
            return new AnalyticsEvent({
                payload: payload
            });
        });
        this.payload = props.payload;
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(AnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (typeof updater === 'function') this.payload = updater(this.payload);
                if ((0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(updater) === 'object') this.payload = $427d60da9e7e5d8e$var$_objectSpread($427d60da9e7e5d8e$var$_objectSpread({}, this.payload), updater);
                return this;
            }
        }
    ]);
}();


function $1a7fd2698bd070cf$var$_callSuper(t, o, e) {
    return o = (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(o), (0, (/*@__PURE__*/$parcel$interopDefault($kIXpt)))(t, $1a7fd2698bd070cf$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(t).constructor) : o.apply(t, e));
}
function $1a7fd2698bd070cf$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($1a7fd2698bd070cf$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $1a7fd2698bd070cf$var$_superPropGet(t, o, e, r) {
    var p = (0, (/*@__PURE__*/$parcel$interopDefault($lwlXp)))((0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(1 & r ? t.prototype : t), o, e);
    return 2 & r && "function" == typeof p ? function(t) {
        return p.apply(e, t);
    } : p;
}
var $1a7fd2698bd070cf$export$35f8383928ba8d7 = function isUIAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $1a7fd2698bd070cf$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isUIAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === 'UIAnalyticsEvent';
};
// eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
var $1a7fd2698bd070cf$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_AnalyticsEvent) {
    function UIAnalyticsEvent(props) {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, UIAnalyticsEvent);
        _this = $1a7fd2698bd070cf$var$_callSuper(this, UIAnalyticsEvent, [
            props
        ]);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "_isUIAnalyticsEvent", true);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "clone", function() {
            if (_this.hasFired) return null;
            var context = (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(_this.context);
            var handlers = (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(_this.handlers);
            /**
       * A hacky "deep clone" of the object. This is limited in that it wont
       * support functions, regexs, Maps, Sets, etc, but none of those need to
       * be represented in our payload.
       */ var payload = JSON.parse(JSON.stringify(_this.payload));
            return new UIAnalyticsEvent({
                context: context,
                handlers: handlers,
                payload: payload
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "fire", function(channel) {
            if (_this.hasFired) return;
            _this.handlers.forEach(function(handler) {
                try {
                    handler(_this, channel);
                } catch (e) {}
            });
            _this.hasFired = true;
        });
        _this.context = props.context || [];
        _this.handlers = props.handlers || [];
        _this.hasFired = false;
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($eyuDe)))(UIAnalyticsEvent, _AnalyticsEvent);
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(UIAnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (this.hasFired) return this;
                return $1a7fd2698bd070cf$var$_superPropGet(UIAnalyticsEvent, "update", this, 3)([
                    updater
                ]);
            }
        }
    ]);
}((0, $427d60da9e7e5d8e$export$2e2bcd8739ae039));



var $5FkrB = parcelRequire("5FkrB");

var $iyyOp = parcelRequire("iyyOp");
var $9932a820a8e26dfa$export$d1f587f82ad51c4 = function useAnalyticsContext() {
    return (0, $5FkrB.useContext)((0, $iyyOp.default));
};


function $b22f7131922934a4$export$5bf35293e545f20c() {
    var analyticsContext = (0, $9932a820a8e26dfa$export$d1f587f82ad51c4)();
    var createAnalyticsEvent = (0, $dLGML.useCallbackOne)(function(payload) {
        return new (0, $1a7fd2698bd070cf$export$2e2bcd8739ae039)({
            context: analyticsContext.getAtlaskitAnalyticsContext(),
            handlers: analyticsContext.getAtlaskitAnalyticsEventHandlers(),
            payload: payload
        });
    }, [
        analyticsContext
    ]);
    return {
        createAnalyticsEvent: createAnalyticsEvent
    };
}



var $5FkrB = parcelRequire("5FkrB");
var $208d62e16eee951c$export$1d27a74659855e44 = function useTrackedRef(value) {
    var ref = (0, $5FkrB.useRef)(value);
    ref.current = value;
    return ref;
};


function $73e78cee963588e3$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $73e78cee963588e3$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $73e78cee963588e3$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $73e78cee963588e3$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $73e78cee963588e3$export$a4687b0234b40e28(_ref) {
    var fn = _ref.fn, action = _ref.action, componentName = _ref.componentName, actionSubject = _ref.actionSubject, packageName = _ref.packageName, packageVersion = _ref.packageVersion, analyticsData = _ref.analyticsData;
    var _useAnalyticsEvents = (0, $b22f7131922934a4$export$5bf35293e545f20c)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
    // We put analyticsData and fn in a ref so that we don't need to break
    // memoization.
    // Generally these could be defined by consumers inline
    // and so we do this to avoid breaking memoization of useCallback
    var dataRef = (0, $208d62e16eee951c$export$1d27a74659855e44)(analyticsData);
    var fnRef = (0, $208d62e16eee951c$export$1d27a74659855e44)(fn);
    var handler = (0, $5FkrB.useCallback)(function(value) {
        var analyticsEvent = createAnalyticsEvent({
            action: action,
            actionSubject: actionSubject || componentName,
            attributes: {
                componentName: componentName,
                packageName: packageName,
                packageVersion: packageVersion
            }
        });
        // To avoid wrapping this component in AnalyticsContext we manually
        // push the parent context's meta data into the context.
        // Note: this new 'context'
        var context = $73e78cee963588e3$var$_objectSpread({
            componentName: componentName,
            packageName: packageName,
            packageVersion: packageVersion
        }, dataRef.current);
        analyticsEvent.context.push(context);
        // fire an event on the atlaskit channel
        var clone = analyticsEvent.clone();
        if (clone) clone.fire('atlaskit');
        fnRef.current(value, analyticsEvent);
    }, [
        // These are strings and won't change
        action,
        componentName,
        actionSubject,
        packageName,
        packageVersion,
        // This function is memoized in the context
        createAnalyticsEvent,
        // these are a stable ref because of the useTrackedRef hook
        dataRef,
        fnRef
    ]);
    return handler;
}



var $5FkrB = parcelRequire("5FkrB");

var $5FkrB = parcelRequire("5FkrB");
var $7330b8b30881a453$export$2931e0ee690eee88 = /*#__PURE__*/ (0, $5FkrB.createContext)({});
/**
 * __RouterLinkProvider__
 *
 * Provides a configured router link component for use
 * within Design System components.
 */ var $7330b8b30881a453$var$RouterLinkProvider = function RouterLinkProvider(_ref) {
    var routerLinkComponent = _ref.routerLinkComponent, children = _ref.children;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement($7330b8b30881a453$export$2931e0ee690eee88.Provider, {
        value: {
            routerLinkComponent: routerLinkComponent
        }
    }, children);
};
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$7330b8b30881a453$export$2e2bcd8739ae039 = $7330b8b30881a453$var$RouterLinkProvider;


/**
 * __useRouterLink()__
 *
 * Hook: Returns app-configured router link component.
 *
 * A generic can be passed to define advanced link configuration:
 * ```
 * type MyRouterLinkConfig = {
 *  to: string;
 *  replace?: boolean;
 * }
 *
 * const RouterLink = useRouterLink<MyRouterLinkConfig>();
 * ```
 */ var $bfb7249c3c1ef356$var$useRouterLink = function useRouterLink() {
    var _useContext = (0, $5FkrB.useContext)((0, $7330b8b30881a453$export$2931e0ee690eee88)), routerLinkComponent = _useContext.routerLinkComponent;
    if (routerLinkComponent) return routerLinkComponent;
    return;
};
var $bfb7249c3c1ef356$export$2e2bcd8739ae039 = $bfb7249c3c1ef356$var$useRouterLink;


/**
 * An empty function which does nothing.
 */ function $08fd0bf6b46217fb$export$2e2bcd8739ae039() {}



var $5FkrB = parcelRequire("5FkrB");
function $eaad20606efcca83$export$f680877a34711e37() {
    // React uses `:` or `«»` in selectors which breaks `document.querySelector(…)`.
    // Replace with `_` to match future React 19 functionality.
    return (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).useId().replace(/[:«»]/g, '_');
}



var $5FkrB = parcelRequire("5FkrB");
var $2aa168dcc4862f6e$var$interactionContext = /*#__PURE__*/ (0, $5FkrB.createContext)(null);
var $2aa168dcc4862f6e$export$2e2bcd8739ae039 = $2aa168dcc4862f6e$var$interactionContext;


/* visually-hidden.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $5FkrB = parcelRequire("5FkrB");

var $18eafb5d6736b659$var$visuallyHiddenStyles = null;
/**
 * __Visually hidden__
 *
 * A composable element to apply a visually hidden effect to children.
 * Useful for accessibility compliance.
 *
 * @example
 * ```jsx
 * import VisuallyHidden from '@atlaskit/visually-hidden';
 *
 * export default () => (
 *   <div style={{ border: '1px solid black' }}>
 *      There is text hidden between the brackets [
 *      <VisuallyHidden>Can't see me!</VisuallyHidden>]
 *   </div>
 * );
 * ```
 */ var $18eafb5d6736b659$var$VisuallyHidden = function VisuallyHidden(_ref) {
    var children = _ref.children, testId = _ref.testId, role = _ref.role, id = _ref.id;
    return /*#__PURE__*/ $5FkrB.createElement("span", {
        id: id,
        "data-testid": testId,
        role: role,
        className: (0, $38d65157ec43a82c$export$2e2bcd8739ae039)([
            "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19itidpf _1reo15vq _18m915vq _1bsbt94y _4t3it94y _kqswstnw _ogto7mnp _uiztglyw _o5721q9c"
        ])
    }, children);
};
$18eafb5d6736b659$var$VisuallyHidden.displayName = 'VisuallyHidden';
var $18eafb5d6736b659$export$2e2bcd8739ae039 = $18eafb5d6736b659$var$VisuallyHidden;


/* focusable.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $kqp0i = parcelRequire("kqp0i");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");

var $0892b67300d3cad3$var$_excluded = [
    "as",
    "children",
    "isInset",
    "testId",
    "style",
    "xcss"
], $0892b67300d3cad3$var$_excluded2 = [
    "className"
];
var $0892b67300d3cad3$var$focusRingStyles = null;
var $0892b67300d3cad3$var$insetFocusRingStyles = null;
/**
 * __Focus ring__
 *
 * A focus ring visually indicates the currently focused item.
 *
 */ var $0892b67300d3cad3$var$Focusable = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? 'button' : _ref$as, children = _ref.children, isInset = _ref.isInset, testId = _ref.testId, style = _ref.style, xcss = _ref.xcss, htmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $0892b67300d3cad3$var$_excluded);
    // This is to remove className from safeHtmlAttributes
    // @ts-ignore -- not using expect since it causes issues with help-center local consumption - className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(htmlAttributes, $0892b67300d3cad3$var$_excluded2);
    return /*#__PURE__*/ $5FkrB.createElement(Component, (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, safeHtmlAttributes, {
        // @ts-ignore Expression produces a union type that is too complex to represent. We may be able to narrow the type here but unsure.
        ref: ref,
        className: (0, $38d65157ec43a82c$export$2e2bcd8739ae039)([
            "_ymio1r31 _ypr0glyw _zcxs1o36 _mizu194a _1ah3dkaa _ra3xnqa1 _128mdkaa _1cvmnqa1 _4davt94y",
            isInset && "_1ah31gjf _2mwq1gjf",
            xcss
        ]),
        style: style,
        "data-testid": testId
    }), children);
});
var $0892b67300d3cad3$export$2e2bcd8739ae039 = $0892b67300d3cad3$var$Focusable;


var $8ad8e55618b90d53$var$_excluded = [
    "href",
    "children",
    "onClick",
    "interactionName",
    "componentName",
    "analyticsContext",
    "aria-label",
    "aria-labelledby",
    "style",
    "target",
    "testId",
    "xcss",
    "newWindowLabel"
], $8ad8e55618b90d53$var$_excluded2 = [
    "className"
];
var $8ad8e55618b90d53$var$styles = {
    root: "_4bfu1r31 _1hms8stv _ajmmnqa1 _vchhusvi",
    position: "_kqswh2mm"
};
var $8ad8e55618b90d53$var$IS_EXTERNAL_LINK_REGEX = /^(?:(http|https):\/\/)/;
var $8ad8e55618b90d53$var$IS_NON_HTTP_BASED = /^(((mailto|tel|sms|blob):)|(#))/;
/**
 * __Anchor__
 *
 * A primitive for building custom anchor links.
 *
 * - [Examples](https://atlassian.design/components/primitives/anchor/examples)
 * - [Code](https://atlassian.design/components/primitives/anchor/code)
 * - [Usage](https://atlassian.design/components/primitives/anchor/usage)
 */ var $8ad8e55618b90d53$var$AnchorNoRef = function AnchorNoRef(_ref, ref) {
    var href = _ref.href, children = _ref.children, _ref$onClick = _ref.onClick, providedOnClick = _ref$onClick === void 0 ? (0, $08fd0bf6b46217fb$export$2e2bcd8739ae039) : _ref$onClick, interactionName = _ref.interactionName, componentName = _ref.componentName, analyticsContext = _ref.analyticsContext, ariaLabel = _ref['aria-label'], ariaLabelledBy = _ref['aria-labelledby'], style = _ref.style, target = _ref.target, testId = _ref.testId, xcss = _ref.xcss, _ref$newWindowLabel = _ref.newWindowLabel, newWindowLabel = _ref$newWindowLabel === void 0 ? '(opens new window)' : _ref$newWindowLabel, htmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $8ad8e55618b90d53$var$_excluded);
    var interactionContext = (0, $5FkrB.useContext)((0, $2aa168dcc4862f6e$export$2e2bcd8739ae039));
    var handleClick = (0, $5FkrB.useCallback)(function(e, analyticsEvent) {
        interactionContext && interactionContext.tracePress(interactionName, e.timeStamp);
        providedOnClick(e, analyticsEvent);
    }, [
        providedOnClick,
        interactionContext,
        interactionName
    ]);
    var opensNewWindowLabelId = (0, $eaad20606efcca83$export$f680877a34711e37)();
    var onClick = (0, $73e78cee963588e3$export$a4687b0234b40e28)({
        fn: handleClick,
        action: 'clicked',
        componentName: componentName || 'Anchor',
        packageName: "@atlaskit/primitives",
        packageVersion: "20.2.0",
        analyticsData: analyticsContext,
        actionSubject: 'link'
    });
    // This is to remove className from safeHtmlAttributes
    // @ts-expect-error className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(htmlAttributes, $8ad8e55618b90d53$var$_excluded2);
    var RouterLink = (0, $bfb7249c3c1ef356$export$2e2bcd8739ae039)();
    var isExternal = typeof href === 'string' && $8ad8e55618b90d53$var$IS_EXTERNAL_LINK_REGEX.test(href);
    var isNonHttpBased = typeof href === 'string' && $8ad8e55618b90d53$var$IS_NON_HTTP_BASED.test(href);
    /**
   * Renders a router link if:
   *
   * - a link component is set in the app provider
   * - it's not an external link (starting with `http://` or `https://`)
   * - it's not a non-HTTP-based link (e.g. emails, phone numbers, hash links etc.).
   */ var isRouterLink = RouterLink && !isExternal && !isNonHttpBased;
    var hrefObjectUsedWithoutRouterLink = RouterLink === undefined && (0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(href) === 'object';
    (0, $afMOk.default)(!hrefObjectUsedWithoutRouterLink, "@atlaskit/primitives: Anchor primitive cannot pass an object to 'href' unless a router link is configured in the AppProvider");
    var Component = isRouterLink ? RouterLink : 'a';
    return /*#__PURE__*/ $5FkrB.createElement((0, $0892b67300d3cad3$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        as: Component,
        className: xcss,
        style: style,
        ref: ref
    }, safeHtmlAttributes, {
        href: !isRouterLink && typeof href !== 'string' ? undefined : href,
        target: target,
        onClick: onClick,
        "aria-label": ariaLabel && target === '_blank' && !ariaLabelledBy ? "".concat(ariaLabel, " , ").concat(newWindowLabel) : ariaLabel,
        "aria-labelledby": ariaLabelledBy && target === '_blank' ? "".concat(ariaLabelledBy, " ").concat(opensNewWindowLabelId) : ariaLabelledBy,
        xcss: (0, $9986544026cab6ed$export$a274e22fb40f762e)($8ad8e55618b90d53$var$styles.root, $8ad8e55618b90d53$var$styles.position, xcss),
        testId: testId,
        "data-is-router-link": testId ? isRouterLink ? 'true' : 'false' : undefined
    }), children, target === '_blank' && (children && !ariaLabel && !ariaLabelledBy || ariaLabelledBy) && /*#__PURE__*/ $5FkrB.createElement((0, $18eafb5d6736b659$export$2e2bcd8739ae039), {
        id: opensNewWindowLabelId
    }, ", ".concat(newWindowLabel)));
};
// Workarounds to support generic types with forwardRef
/**
 * __Anchor__
 *
 * Anchor is a primitive for building custom anchor links. It's a wrapper around the HTML `<a>` element that provides a consistent API for handling client-side routing and Atlassian Design System styling.
 *
 * - [Examples](https://atlassian.design/components/primitives/anchor/examples)
 * - [Code](https://atlassian.design/components/primitives/anchor/code)
 * - [Usage](https://atlassian.design/components/primitives/anchor/usage)
 */ var $8ad8e55618b90d53$var$Anchor = /*#__PURE__*/ (0, $5FkrB.forwardRef)($8ad8e55618b90d53$var$AnchorNoRef);
var $8ad8e55618b90d53$export$2e2bcd8739ae039 = $8ad8e55618b90d53$var$Anchor;

/* box.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $kqp0i = parcelRequire("kqp0i");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");


var $5FkrB = parcelRequire("5FkrB");
var $5b9f730e423c70ca$export$1ca2a26fecb070ae = /*#__PURE__*/ (0, $5FkrB.createContext)('elevation.surface');


var $486e85222e48a5c3$var$_excluded = [
    "as",
    "children",
    "backgroundColor",
    "padding",
    "paddingBlock",
    "paddingBlockStart",
    "paddingBlockEnd",
    "paddingInline",
    "paddingInlineStart",
    "paddingInlineEnd",
    "style",
    "testId",
    "xcss"
], $486e85222e48a5c3$var$_excluded2 = [
    "className"
];
// Can either Exclude or Extract - here we're excluding all SVG-related elements, <button> elements (handled by Pressable), and <a> elements (handled by Anchor)
// Basically just ElementType but without ComponentType, it makes sense to keep the "Type" suffix
// eslint-disable-next-line @repo/internal/react/consistent-types-definitions
var $486e85222e48a5c3$var$baseStyles = null;
var $486e85222e48a5c3$var$backgroundColorMap = {
    'color.background.accent.lime.subtlest': "_bfhkm890",
    'color.background.accent.lime.subtlest.hovered': "_bfhkd4y8",
    'color.background.accent.lime.subtlest.pressed': "_bfhkkuup",
    'color.background.accent.lime.subtler': "_bfhkz2ec",
    'color.background.accent.lime.subtler.hovered': "_bfhk1gf0",
    'color.background.accent.lime.subtler.pressed': "_bfhk2kxc",
    'color.background.accent.lime.subtle': "_bfhkbq5w",
    'color.background.accent.lime.subtle.hovered': "_bfhkfoww",
    'color.background.accent.lime.subtle.pressed': "_bfhk1jbd",
    'color.background.accent.lime.bolder': "_bfhktde4",
    'color.background.accent.lime.bolder.hovered': "_bfhknzpa",
    'color.background.accent.lime.bolder.pressed': "_bfhkh0j0",
    'color.background.accent.red.subtlest': "_bfhk1vk5",
    'color.background.accent.red.subtlest.hovered': "_bfhk1i6i",
    'color.background.accent.red.subtlest.pressed': "_bfhknbir",
    'color.background.accent.red.subtler': "_bfhk1rtt",
    'color.background.accent.red.subtler.hovered': "_bfhkaffd",
    'color.background.accent.red.subtler.pressed': "_bfhk1j5a",
    'color.background.accent.red.subtle': "_bfhkkrt9",
    'color.background.accent.red.subtle.hovered': "_bfhk1sou",
    'color.background.accent.red.subtle.pressed': "_bfhk1fnn",
    'color.background.accent.red.bolder': "_bfhkuibq",
    'color.background.accent.red.bolder.hovered': "_bfhk100f",
    'color.background.accent.red.bolder.pressed': "_bfhk1cl6",
    'color.background.accent.orange.subtlest': "_bfhkf5uh",
    'color.background.accent.orange.subtlest.hovered': "_bfhk19yr",
    'color.background.accent.orange.subtlest.pressed': "_bfhkf90x",
    'color.background.accent.orange.subtler': "_bfhk165s",
    'color.background.accent.orange.subtler.hovered': "_bfhk1ei0",
    'color.background.accent.orange.subtler.pressed': "_bfhkdpo3",
    'color.background.accent.orange.subtle': "_bfhk1kkj",
    'color.background.accent.orange.subtle.hovered': "_bfhk9mfs",
    'color.background.accent.orange.subtle.pressed': "_bfhkaxpp",
    'color.background.accent.orange.bolder': "_bfhk1qg1",
    'color.background.accent.orange.bolder.hovered': "_bfhk12qo",
    'color.background.accent.orange.bolder.pressed': "_bfhk1fyq",
    'color.background.accent.yellow.subtlest': "_bfhkibhp",
    'color.background.accent.yellow.subtlest.hovered': "_bfhkaetg",
    'color.background.accent.yellow.subtlest.pressed': "_bfhk1o1l",
    'color.background.accent.yellow.subtler': "_bfhk1773",
    'color.background.accent.yellow.subtler.hovered': "_bfhk1uw7",
    'color.background.accent.yellow.subtler.pressed': "_bfhk1r9w",
    'color.background.accent.yellow.subtle': "_bfhk8y3s",
    'color.background.accent.yellow.subtle.hovered': "_bfhk819w",
    'color.background.accent.yellow.subtle.pressed': "_bfhk1jx0",
    'color.background.accent.yellow.bolder': "_bfhk1vop",
    'color.background.accent.yellow.bolder.hovered': "_bfhkkjqf",
    'color.background.accent.yellow.bolder.pressed': "_bfhk1okt",
    'color.background.accent.green.subtlest': "_bfhkn729",
    'color.background.accent.green.subtlest.hovered': "_bfhk3utz",
    'color.background.accent.green.subtlest.pressed': "_bfhkyfny",
    'color.background.accent.green.subtler': "_bfhk1wnw",
    'color.background.accent.green.subtler.hovered': "_bfhk1e2h",
    'color.background.accent.green.subtler.pressed': "_bfhkybhx",
    'color.background.accent.green.subtle': "_bfhk1rsu",
    'color.background.accent.green.subtle.hovered': "_bfhk12e3",
    'color.background.accent.green.subtle.pressed': "_bfhk1g86",
    'color.background.accent.green.bolder': "_bfhk1e5c",
    'color.background.accent.green.bolder.hovered': "_bfhka5yi",
    'color.background.accent.green.bolder.pressed': "_bfhk1j68",
    'color.background.accent.teal.subtlest': "_bfhk7xuz",
    'color.background.accent.teal.subtlest.hovered': "_bfhk108c",
    'color.background.accent.teal.subtlest.pressed': "_bfhk1cxp",
    'color.background.accent.teal.subtler': "_bfhk1a17",
    'color.background.accent.teal.subtler.hovered': "_bfhkkwwr",
    'color.background.accent.teal.subtler.pressed': "_bfhk1jb0",
    'color.background.accent.teal.subtle': "_bfhktdv8",
    'color.background.accent.teal.subtle.hovered': "_bfhkzh8h",
    'color.background.accent.teal.subtle.pressed': "_bfhk16zl",
    'color.background.accent.teal.bolder': "_bfhk2c8p",
    'color.background.accent.teal.bolder.hovered': "_bfhkl3ve",
    'color.background.accent.teal.bolder.pressed': "_bfhktor0",
    'color.background.accent.blue.subtlest': "_bfhk1s93",
    'color.background.accent.blue.subtlest.hovered': "_bfhkdaj9",
    'color.background.accent.blue.subtlest.pressed': "_bfhkxm0g",
    'color.background.accent.blue.subtler': "_bfhk1dy8",
    'color.background.accent.blue.subtler.hovered': "_bfhk815t",
    'color.background.accent.blue.subtler.pressed': "_bfhkrwxf",
    'color.background.accent.blue.subtle': "_bfhk115i",
    'color.background.accent.blue.subtle.hovered': "_bfhk9pr4",
    'color.background.accent.blue.subtle.pressed': "_bfhknpx7",
    'color.background.accent.blue.bolder': "_bfhk16e3",
    'color.background.accent.blue.bolder.hovered': "_bfhk1vbm",
    'color.background.accent.blue.bolder.pressed': "_bfhk1xwi",
    'color.background.accent.purple.subtlest': "_bfhkp2ly",
    'color.background.accent.purple.subtlest.hovered': "_bfhkkca2",
    'color.background.accent.purple.subtlest.pressed': "_bfhk1jbm",
    'color.background.accent.purple.subtler': "_bfhk1nm4",
    'color.background.accent.purple.subtler.hovered': "_bfhkattl",
    'color.background.accent.purple.subtler.pressed': "_bfhk3nfk",
    'color.background.accent.purple.subtle': "_bfhk18ah",
    'color.background.accent.purple.subtle.hovered': "_bfhk8bp1",
    'color.background.accent.purple.subtle.pressed': "_bfhk1cd2",
    'color.background.accent.purple.bolder': "_bfhkya33",
    'color.background.accent.purple.bolder.hovered': "_bfhk1af5",
    'color.background.accent.purple.bolder.pressed': "_bfhk6cze",
    'color.background.accent.magenta.subtlest': "_bfhk8tvm",
    'color.background.accent.magenta.subtlest.hovered': "_bfhkr3zd",
    'color.background.accent.magenta.subtlest.pressed': "_bfhk1ckf",
    'color.background.accent.magenta.subtler': "_bfhkv9ra",
    'color.background.accent.magenta.subtler.hovered': "_bfhk1axx",
    'color.background.accent.magenta.subtler.pressed': "_bfhk42ri",
    'color.background.accent.magenta.subtle': "_bfhk1mi6",
    'color.background.accent.magenta.subtle.hovered': "_bfhkrwyz",
    'color.background.accent.magenta.subtle.pressed': "_bfhk6c15",
    'color.background.accent.magenta.bolder': "_bfhkc3uk",
    'color.background.accent.magenta.bolder.hovered': "_bfhk1ok8",
    'color.background.accent.magenta.bolder.pressed': "_bfhkeawv",
    'color.background.accent.gray.subtlest': "_bfhkysee",
    'color.background.accent.gray.subtlest.hovered': "_bfhkwejn",
    'color.background.accent.gray.subtlest.pressed': "_bfhk18ut",
    'color.background.accent.gray.subtler': "_bfhk7qp0",
    'color.background.accent.gray.subtler.hovered': "_bfhk10ef",
    'color.background.accent.gray.subtler.pressed': "_bfhk1rk9",
    'color.background.accent.gray.subtle': "_bfhk18j9",
    'color.background.accent.gray.subtle.hovered': "_bfhk1nv3",
    'color.background.accent.gray.subtle.pressed': "_bfhkq9tj",
    'color.background.accent.gray.bolder': "_bfhk1i45",
    'color.background.accent.gray.bolder.hovered': "_bfhkbyip",
    'color.background.accent.gray.bolder.pressed': "_bfhk1van",
    'color.background.disabled': "_bfhk187o",
    'color.background.input': "_bfhk1j9a",
    'color.background.input.hovered': "_bfhkl4ek",
    'color.background.input.pressed': "_bfhkr01l",
    'color.background.inverse.subtle': "_bfhk1vck",
    'color.background.inverse.subtle.hovered': "_bfhkmpja",
    'color.background.inverse.subtle.pressed': "_bfhk1gii",
    'color.background.neutral': "_bfhki8nm",
    'color.background.neutral.hovered': "_bfhkplhp",
    'color.background.neutral.pressed': "_bfhk1gdz",
    'color.background.neutral.subtle': "_bfhksm61",
    'color.background.neutral.subtle.hovered': "_bfhk1dpa",
    'color.background.neutral.subtle.pressed': "_bfhkfcek",
    'color.background.neutral.bold': "_bfhk1aqn",
    'color.background.neutral.bold.hovered': "_bfhk1ibz",
    'color.background.neutral.bold.pressed': "_bfhkof27",
    'color.background.selected': "_bfhk15s3",
    'color.background.selected.hovered': "_bfhkufnl",
    'color.background.selected.pressed': "_bfhknozp",
    'color.background.selected.bold': "_bfhkjmqp",
    'color.background.selected.bold.hovered': "_bfhk1q28",
    'color.background.selected.bold.pressed': "_bfhk12kk",
    'color.background.brand.subtlest': "_bfhk1gmr",
    'color.background.brand.subtlest.hovered': "_bfhk3v15",
    'color.background.brand.subtlest.pressed': "_bfhku02c",
    'color.background.brand.bold': "_bfhk1856",
    'color.background.brand.bold.hovered': "_bfhkhf2y",
    'color.background.brand.bold.pressed': "_bfhkg6ey",
    'color.background.brand.boldest': "_bfhk1o4i",
    'color.background.brand.boldest.hovered': "_bfhklefx",
    'color.background.brand.boldest.pressed': "_bfhk16k6",
    'color.background.danger': "_bfhk1gly",
    'color.background.danger.hovered': "_bfhk1yvi",
    'color.background.danger.pressed': "_bfhk1r4b",
    'color.background.danger.bold': "_bfhkybec",
    'color.background.danger.bold.hovered': "_bfhks9hg",
    'color.background.danger.bold.pressed': "_bfhk13a9",
    'color.background.warning': "_bfhk1917",
    'color.background.warning.hovered': "_bfhk19zu",
    'color.background.warning.pressed': "_bfhkzr32",
    'color.background.warning.bold': "_bfhk1kmu",
    'color.background.warning.bold.hovered': "_bfhk1spp",
    'color.background.warning.bold.pressed': "_bfhk4m4m",
    'color.background.success': "_bfhk1y9u",
    'color.background.success.hovered': "_bfhk1vfx",
    'color.background.success.pressed': "_bfhk1wl5",
    'color.background.success.bold': "_bfhkkcmj",
    'color.background.success.bold.hovered': "_bfhky7x8",
    'color.background.success.bold.pressed': "_bfhkwcbh",
    'color.background.discovery': "_bfhk6vm6",
    'color.background.discovery.hovered': "_bfhk12eq",
    'color.background.discovery.pressed': "_bfhk18vq",
    'color.background.discovery.bold': "_bfhku5tj",
    'color.background.discovery.bold.hovered': "_bfhkfqeg",
    'color.background.discovery.bold.pressed': "_bfhk1f1m",
    'color.background.information': "_bfhk19ip",
    'color.background.information.hovered': "_bfhk86z5",
    'color.background.information.pressed': "_bfhk1c1j",
    'color.background.information.bold': "_bfhkx4w0",
    'color.background.information.bold.hovered': "_bfhkq2ii",
    'color.background.information.bold.pressed': "_bfhkf89v",
    'color.blanket': "_bfhk1i5c",
    'color.blanket.selected': "_bfhk7wq0",
    'color.blanket.danger': "_bfhkrprw",
    'color.skeleton': "_bfhkizff",
    'color.skeleton.subtle': "_bfhkvkf5",
    'elevation.surface': "_bfhkvuon",
    'elevation.surface.hovered': "_bfhk19i6",
    'elevation.surface.pressed': "_bfhk13ro",
    'elevation.surface.overlay': "_bfhk1bhr",
    'elevation.surface.overlay.hovered': "_bfhk6o2t",
    'elevation.surface.overlay.pressed': "_bfhkm8nx",
    'elevation.surface.raised': "_bfhkhp5a",
    'elevation.surface.raised.hovered': "_bfhk116u",
    'elevation.surface.raised.pressed': "_bfhk14aj",
    'elevation.surface.sunken': "_bfhkhfxm",
    'utility.elevation.surface.current': "_bfhkchd4"
};
var $486e85222e48a5c3$var$CURRENT_SURFACE_CSS_VAR = "--ds-elevation-surface-current";
var $486e85222e48a5c3$var$setSurfaceTokenMap = {
    'elevation.surface': "_1q1lvuon",
    'elevation.surface.hovered': "_1q1l19i6",
    'elevation.surface.pressed': "_1q1l13ro",
    'elevation.surface.overlay': "_1q1l1bhr",
    'elevation.surface.overlay.hovered': "_1q1l6o2t",
    'elevation.surface.overlay.pressed': "_1q1lm8nx",
    'elevation.surface.raised': "_1q1lhp5a",
    'elevation.surface.raised.hovered': "_1q1l116u",
    'elevation.surface.raised.pressed': "_1q1l14aj",
    'elevation.surface.sunken': "_1q1lhfxm"
};
var $486e85222e48a5c3$var$paddingBlockStartMap = {
    'space.0': "_1q51ze3t",
    'space.025': "_1q51v77o",
    'space.050': "_1q511b66",
    'space.075': "_1q5112x7",
    'space.100': "_1q51u2gc",
    'space.150': "_1q51utpp",
    'space.200': "_1q51pxbi",
    'space.250': "_1q51v47k",
    'space.300': "_1q511ejb",
    'space.400': "_1q51xy5q",
    'space.500': "_1q511jfw",
    'space.600': "_1q51oahv",
    'space.800': "_1q51xncg",
    'space.1000': "_1q511epz"
};
var $486e85222e48a5c3$var$paddingBlockEndMap = {
    'space.0': "_85i5ze3t",
    'space.025': "_85i5v77o",
    'space.050': "_85i51b66",
    'space.075': "_85i512x7",
    'space.100': "_85i5u2gc",
    'space.150': "_85i5utpp",
    'space.200': "_85i5pxbi",
    'space.250': "_85i5v47k",
    'space.300': "_85i51ejb",
    'space.400': "_85i5xy5q",
    'space.500': "_85i51jfw",
    'space.600': "_85i5oahv",
    'space.800': "_85i5xncg",
    'space.1000': "_85i51epz"
};
var $486e85222e48a5c3$var$paddingInlineStartMap = {
    'space.0': "_bozgze3t",
    'space.025': "_bozgv77o",
    'space.050': "_bozg1b66",
    'space.075': "_bozg12x7",
    'space.100': "_bozgu2gc",
    'space.150': "_bozgutpp",
    'space.200': "_bozgpxbi",
    'space.250': "_bozgv47k",
    'space.300': "_bozg1ejb",
    'space.400': "_bozgxy5q",
    'space.500': "_bozg1jfw",
    'space.600': "_bozgoahv",
    'space.800': "_bozgxncg",
    'space.1000': "_bozg1epz"
};
var $486e85222e48a5c3$var$paddingInlineEndMap = {
    'space.0': "_y4tize3t",
    'space.025': "_y4tiv77o",
    'space.050': "_y4ti1b66",
    'space.075': "_y4ti12x7",
    'space.100': "_y4tiu2gc",
    'space.150': "_y4tiutpp",
    'space.200': "_y4tipxbi",
    'space.250': "_y4tiv47k",
    'space.300': "_y4ti1ejb",
    'space.400': "_y4tixy5q",
    'space.500': "_y4ti1jfw",
    'space.600': "_y4tioahv",
    'space.800': "_y4tixncg",
    'space.1000': "_y4ti1epz"
};
/**
 * __Box__
 *
 * A Box is a primitive component that has the design decisions of the Atlassian Design System baked in.
 * Renders a `div` by default.
 *
 * - [Examples](https://atlassian.design/components/primitives/box/examples)
 * - [Code](https://atlassian.design/components/primitives/box/code)
 * - [Usage](https://atlassian.design/components/primitives/box/usage)
 */ var $486e85222e48a5c3$var$Box = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? 'div' : _ref$as, children = _ref.children, backgroundColor = _ref.backgroundColor, padding = _ref.padding, _ref$paddingBlock = _ref.paddingBlock, paddingBlock = _ref$paddingBlock === void 0 ? padding : _ref$paddingBlock, _ref$paddingBlockStar = _ref.paddingBlockStart, paddingBlockStart = _ref$paddingBlockStar === void 0 ? paddingBlock : _ref$paddingBlockStar, _ref$paddingBlockEnd = _ref.paddingBlockEnd, paddingBlockEnd = _ref$paddingBlockEnd === void 0 ? paddingBlock : _ref$paddingBlockEnd, _ref$paddingInline = _ref.paddingInline, paddingInline = _ref$paddingInline === void 0 ? padding : _ref$paddingInline, _ref$paddingInlineSta = _ref.paddingInlineStart, paddingInlineStart = _ref$paddingInlineSta === void 0 ? paddingInline : _ref$paddingInlineSta, _ref$paddingInlineEnd = _ref.paddingInlineEnd, paddingInlineEnd = _ref$paddingInlineEnd === void 0 ? paddingInline : _ref$paddingInlineEnd, style = _ref.style, testId = _ref.testId, xcss = _ref.xcss, htmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $486e85222e48a5c3$var$_excluded);
    // This is to remove className from safeHtmlAttributes
    // @ts-ignore -- not using expect since it causes issues with help-center local consumption - className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(htmlAttributes, $486e85222e48a5c3$var$_excluded2);
    var node = /*#__PURE__*/ $5FkrB.createElement(Component, (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        style: style,
        ref: ref,
        className: (0, $38d65157ec43a82c$export$2e2bcd8739ae039)([
            "_19itglyw _vchhusvi _r06hglyw",
            backgroundColor && $486e85222e48a5c3$var$backgroundColorMap[backgroundColor],
            backgroundColor && $486e85222e48a5c3$var$isSurfaceToken(backgroundColor) && $486e85222e48a5c3$var$setSurfaceTokenMap[backgroundColor],
            paddingBlockStart && $486e85222e48a5c3$var$paddingBlockStartMap[paddingBlockStart],
            paddingBlockEnd && $486e85222e48a5c3$var$paddingBlockEndMap[paddingBlockEnd],
            paddingInlineStart && $486e85222e48a5c3$var$paddingInlineStartMap[paddingInlineStart],
            paddingInlineEnd && $486e85222e48a5c3$var$paddingInlineEndMap[paddingInlineEnd],
            xcss
        ])
    }, safeHtmlAttributes, {
        "data-testid": testId
    }), children);
    if (backgroundColor) return /*#__PURE__*/ $5FkrB.createElement((0, $5b9f730e423c70ca$export$1ca2a26fecb070ae).Provider, {
        value: backgroundColor
    }, node);
    return node;
});
var $486e85222e48a5c3$export$2e2bcd8739ae039 = $486e85222e48a5c3$var$Box;
function $486e85222e48a5c3$var$isSurfaceToken(backgroundColor) {
    return backgroundColor in $486e85222e48a5c3$var$setSurfaceTokenMap;
}


var $64e95b69a05329e9$var$_excluded = [
    "children",
    "testId",
    "appearance",
    "newWindowLabel",
    "target",
    "className",
    "style"
];
var $64e95b69a05329e9$var$styles = {
    base: "_ect4ttxp",
    baseT26Shape: "_2rkolb4i",
    visitedLink: "_10531ra0 _1ien1ra0 _n0fx1ra0 _1vhv17z1",
    defaultAppearance: "_4bfu1r31 _1hms8stv _ajmmnqa1 _syaz13af _1a3b1r31 _4fpr8stv _5goinqa1 _f8pj13af _9oik1r31 _1bnxglyw _jf4cnqa1 _30l313af _1nrm1r31 _c2waglyw _1iohnqa1 _9h8h12zz",
    subtleAppearance: "_4bfu1r31 _1hmsglyw _ajmmnqa1 _syazazsu _1a3b1r31 _4fprglyw _5goinqa1 _f8pjazsu _9oik1r31 _1bnx8stv _jf4cnqa1 _30l3azsu _1nrm1r31 _c2wa8stv _1iohnqa1 _9h8hi7uo",
    inverseAppearance: "_4bfu1r31 _1hms8stv _ajmmnqa1 _syaz15cr _105315cr _1a3b1r31 _4fpr8stv _5goinqa1 _f8pj15cr _9oik1r31 _1bnxglyw _jf4cnqa1 _30l315cr _1nrm1r31 _c2waglyw _1iohnqa1 _9h8h15cr",
    iconWrapper: "_1e0c1nu9 _o5721q9c _s7n41q9y _kqswh2mm _152ttb3r"
};
var $64e95b69a05329e9$var$iconStyles = null;
var $64e95b69a05329e9$var$LinkWithoutRef = function LinkWithoutRef(_ref, ref) {
    var children = _ref.children, testId = _ref.testId, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'default' : _ref$appearance, newWindowLabel = _ref.newWindowLabel, target = _ref.target, _preventedClassName = _ref.className, _preventedStyle = _ref.style, htmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $64e95b69a05329e9$var$_excluded);
    return /*#__PURE__*/ $5FkrB.createElement((0, $8ad8e55618b90d53$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, htmlAttributes, {
        target: target,
        ref: ref,
        xcss: (0, $hRJ5R.cx)($64e95b69a05329e9$var$styles.base, (0, $29c5ad3390847ec7$export$b40ec24ac8275656)('platform-dst-shape-theme-default') && $64e95b69a05329e9$var$styles.baseT26Shape, appearance === 'default' && $64e95b69a05329e9$var$styles.defaultAppearance, appearance === 'subtle' && $64e95b69a05329e9$var$styles.subtleAppearance, appearance === 'inverse' && $64e95b69a05329e9$var$styles.inverseAppearance, // Visited styles are not supported for inverse links due to contrast issues
        appearance !== 'inverse' && $64e95b69a05329e9$var$styles.visitedLink),
        testId: testId,
        componentName: "Link",
        newWindowLabel: newWindowLabel
    }), children, target === '_blank' && /*#__PURE__*/ $5FkrB.createElement((0, $486e85222e48a5c3$export$2e2bcd8739ae039), {
        as: "span",
        xcss: $64e95b69a05329e9$var$styles.iconWrapper,
        testId: testId && "".concat(testId, "__icon")
    }, "\uFEFF", /*#__PURE__*/ $5FkrB.createElement("svg", {
        width: "12",
        height: "12",
        viewBox: "0 0 12 12",
        fill: "none",
        className: (0, $38d65157ec43a82c$export$2e2bcd8739ae039)([
            "_1bsbgm0b _4t3igm0b _ahbqzjw7"
        ])
    }, /*#__PURE__*/ $5FkrB.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M0 1.82609C0 0.817938 0.817938 0 1.82609 0H3.91304V1.04348H1.82609C1.39424 1.04348 1.04348 1.39424 1.04348 1.82609V10.1739C1.04348 10.6058 1.39424 10.9565 1.82609 10.9565H10.1739C10.6058 10.9565 10.9565 10.6058 10.9565 10.1739V8.08696H12V10.1739C12 11.1821 11.1821 12 10.1739 12H1.82609C0.817938 12 0 11.1821 0 10.1739V1.82609ZM7.04348 0H12V4.95652H10.9565V1.78133L6.36893 6.36893L5.63107 5.63107L10.2187 1.04348H7.04348V0Z",
        fill: "currentColor"
    }))));
};
// Workarounds to support generic types with forwardRef
/**
 * __Link__
 *
 * A link is an inline text element that navigates to a new location when clicked.
 *
 * - [Examples](https://atlassian.design/components/primitives/link/examples)
 * - [Code](https://atlassian.design/components/primitives/link/code)
 * - [Usage](https://atlassian.design/components/primitives/link/usage)
 */ var $64e95b69a05329e9$var$Link = /*#__PURE__*/ (0, $5FkrB.forwardRef)($64e95b69a05329e9$var$LinkWithoutRef);
var $64e95b69a05329e9$export$2e2bcd8739ae039 = $64e95b69a05329e9$var$Link;





var $9TAkY = parcelRequire("9TAkY");


var $5FkrB = parcelRequire("5FkrB");
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5FkrB = parcelRequire("5FkrB");

var $74Zh5 = parcelRequire("74Zh5");
var $385d7f6a627d2e5f$var$buttonGroupStyles = (0, $74Zh5.css)({
    display: 'inline-flex',
    gap: "var(--ds-space-050, 4px)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '> *': {
        flex: '1 0 auto'
    }
});
function $385d7f6a627d2e5f$export$2e2bcd8739ae039(_ref) {
    var children = _ref.children, testId = _ref.testId, label = _ref.label, titleId = _ref.titleId;
    return (0, $74Zh5.jsx)("div", {
        css: $385d7f6a627d2e5f$var$buttonGroupStyles,
        "data-testid": testId,
        role: "group",
        "aria-label": label,
        "aria-labelledby": titleId
    }, (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).Children.map((0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).Children.toArray(children), function(child, idx) {
        if (!child) return null;
        return (0, $74Zh5.jsx)((0, $5FkrB.Fragment), {
            key: idx
        }, child);
    }));
}


/* heading.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");
/**
 * This length includes the underscore,
 * e.g. `"_1s4A"` would be a valid atomic group hash.
 */ const $9192463de1c280ec$var$ATOMIC_GROUP_LENGTH = 5;
function $9192463de1c280ec$export$2e2bcd8739ae039(classNames) {
    // Shortcut: nothing to do
    if (!classNames.length) return;
    // Shortcut: don't need to do anything if we only have a single classname
    if (classNames.length === 1 && classNames[0] && // checking to see if `classNames[0]` is a string that contains other classnames
    !classNames[0].includes(' ')) return classNames[0];
    // Using an object rather than a `Map` as it performed better in our benchmarks.
    // Would be happy to move to `Map` if it proved to be better under real conditions.
    const map = {};
    // Note: using loops to minimize iterations over the collection
    for (const value of classNames){
        // Exclude all falsy values, which leaves us with populated strings
        if (!value) continue;
        // a `value` can contain multiple classnames
        const list = value.split(' ');
        for (const className of list){
            /**
             * For atomic style classnames: the `key` is the `group`
             *
             * - Later atomic classnames with the same `group` will override earlier ones
             *   (which is what we want).
             * - Assumes atomic classnames are the only things that start with `_`
             * - Could use a regex to ensure that atomic classnames are structured how we expect,
             *   but did not add that for now as it did slow things down a bit.
             *
             * For other classnames: the `key` is the whole classname
             * - Okay to remove duplicates as doing so does not impact specificity
             *
             * */ const key = className.startsWith('_') ? className.slice(0, $9192463de1c280ec$var$ATOMIC_GROUP_LENGTH) : className;
            map[key] = className;
        }
    }
    /**
     * We are converting the `map` into a string.
     *
     * The simple way to do this would be `Object.values(map).join(' ')`.
     * However, the approach below performs 10%-20% better in benchmarks.
     *
     * For `ax()` it feels right to squeeze as much runtime performance out as we can.
     */ let result = '';
    for(const key in map)result += map[key] + ' ';
    // If we have an empty string, then our `map` was empty.
    if (!result) return;
    // remove last " " from the result (we added " " at the end of every value)
    return result.trimEnd();
}



var $25nEq = parcelRequire("25nEq");

var $74Zh5 = parcelRequire("74Zh5");
var $d061f3568ed8e1f6$export$4ef52930e33717cd = 'data-theme';
var $d061f3568ed8e1f6$export$cb374d25ded7f6ab = 'data-subtree-theme';
var $d061f3568ed8e1f6$export$a00eac3f8684bcd0 = 'data-color-mode';
var $d061f3568ed8e1f6$export$2112803007239c61 = 'data-contrast-mode';
var $d061f3568ed8e1f6$export$352e418ed5b6193a = 'data-custom-theme';
var $d061f3568ed8e1f6$export$6f0c6fb8c80fcc92 = 'ds';
var $d061f3568ed8e1f6$export$4d0c7bbf80185957 = [
    'opacity',
    'font',
    'space',
    'border',
    'radius'
];
var $d061f3568ed8e1f6$export$dddac1532e822863 = "--".concat($d061f3568ed8e1f6$export$6f0c6fb8c80fcc92, "-token-not-found");
var $d061f3568ed8e1f6$export$9d7b58831ae93caa = "--".concat($d061f3568ed8e1f6$export$6f0c6fb8c80fcc92, "-elevation-surface-current");


function $409b8db60ea39aa2$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $409b8db60ea39aa2$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $409b8db60ea39aa2$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $409b8db60ea39aa2$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $409b8db60ea39aa2$export$6ccdbebca2ee545f = {
    '100%': '100%',
    'size.100': '1rem',
    'size.200': '1.5rem',
    'size.300': '2rem',
    'size.400': '2.5rem',
    'size.500': '3rem',
    'size.600': '6rem',
    'size.1000': '12rem'
};
var $409b8db60ea39aa2$export$958d0ae7f2977ae4 = {
    'space.0': "var(--ds-space-0, 0px)",
    'space.025': "var(--ds-space-025, 2px)",
    'space.050': "var(--ds-space-050, 4px)",
    'space.075': "var(--ds-space-075, 6px)",
    'space.100': "var(--ds-space-100, 8px)",
    'space.150': "var(--ds-space-150, 12px)",
    'space.200': "var(--ds-space-200, 16px)",
    'space.250': "var(--ds-space-250, 20px)",
    'space.300': "var(--ds-space-300, 24px)",
    'space.400': "var(--ds-space-400, 32px)",
    'space.500': "var(--ds-space-500, 40px)",
    'space.600': "var(--ds-space-600, 48px)",
    'space.800': "var(--ds-space-800, 64px)",
    'space.1000': "var(--ds-space-1000, 80px)"
};
var $409b8db60ea39aa2$export$d2dc61f58390201c = {
    'space.negative.025': "var(--ds-space-negative-025, -2px)",
    'space.negative.050': "var(--ds-space-negative-050, -4px)",
    'space.negative.075': "var(--ds-space-negative-075, -6px)",
    'space.negative.100': "var(--ds-space-negative-100, -8px)",
    'space.negative.150': "var(--ds-space-negative-150, -12px)",
    'space.negative.200': "var(--ds-space-negative-200, -16px)",
    'space.negative.250': "var(--ds-space-negative-250, -20px)",
    'space.negative.300': "var(--ds-space-negative-300, -24px)",
    'space.negative.400': "var(--ds-space-negative-400, -32px)"
};
var $409b8db60ea39aa2$export$632685d741f3dbbf = $409b8db60ea39aa2$var$_objectSpread($409b8db60ea39aa2$var$_objectSpread({}, $409b8db60ea39aa2$export$958d0ae7f2977ae4), $409b8db60ea39aa2$export$d2dc61f58390201c);
var $409b8db60ea39aa2$export$2185ce37f9bdd963 = {
    'color.background.neutral.bold': 'color.text.inverse',
    'color.background.neutral.bold.hovered': 'color.text.inverse',
    'color.background.neutral.bold.pressed': 'color.text.inverse',
    'color.background.selected.bold': 'color.text.inverse',
    'color.background.selected.bold.hovered': 'color.text.inverse',
    'color.background.selected.bold.pressed': 'color.text.inverse',
    'color.background.brand.bold': 'color.text.inverse',
    'color.background.brand.bold.hovered': 'color.text.inverse',
    'color.background.brand.bold.pressed': 'color.text.inverse',
    'color.background.brand.boldest': 'color.text.inverse',
    'color.background.brand.boldest.hovered': 'color.text.inverse',
    'color.background.brand.boldest.pressed': 'color.text.inverse',
    'color.background.danger.bold': 'color.text.inverse',
    'color.background.danger.bold.hovered': 'color.text.inverse',
    'color.background.danger.bold.pressed': 'color.text.inverse',
    'color.background.warning.bold': 'color.text.warning.inverse',
    'color.background.warning.bold.hovered': 'color.text.warning.inverse',
    'color.background.warning.bold.pressed': 'color.text.warning.inverse',
    'color.background.success.bold': 'color.text.inverse',
    'color.background.success.bold.hovered': 'color.text.inverse',
    'color.background.success.bold.pressed': 'color.text.inverse',
    'color.background.discovery.bold': 'color.text.inverse',
    'color.background.discovery.bold.hovered': 'color.text.inverse',
    'color.background.discovery.bold.pressed': 'color.text.inverse',
    'color.background.information.bold': 'color.text.inverse',
    'color.background.information.bold.hovered': 'color.text.inverse',
    'color.background.information.bold.pressed': 'color.text.inverse',
    'color.rovo.background.brand.bold': 'color.text.inverse',
    'color.rovo.background.brand.bold.hovered': 'color.text.inverse',
    'color.rovo.background.brand.bold.pressed': 'color.text.inverse'
};
var $409b8db60ea39aa2$export$daf94a976c798b4f = {
    'opacity.disabled': "var(--ds-opacity-disabled, 0.4)",
    'opacity.loading': "var(--ds-opacity-loading, 0.2)"
};
var $409b8db60ea39aa2$export$7aff6e7ba39bb774 = {
    'elevation.shadow.overflow': "var(--ds-shadow-overflow, 0px 0px 8px #1E1F21, 0px 0px 1px #1E1F21)",
    'elevation.shadow.overflow.perimeter': "var(--ds-shadow-overflow-perimeter, #1E1F211f)",
    'elevation.shadow.overflow.spread': "var(--ds-shadow-overflow-spread, #1E1F2129)",
    'elevation.shadow.overlay': "var(--ds-shadow-overlay, 0px 8px 12px #1E1F21, 0px 0px 1px #1E1F21)",
    'elevation.shadow.raised': "var(--ds-shadow-raised, 0px 1px 1px #1E1F21, 0px 0px 1px #1E1F21)"
};
var $409b8db60ea39aa2$export$41a358c9c2356760 = {
    'elevation.surface': "var(--ds-surface, #FFFFFF)",
    'elevation.surface.hovered': "var(--ds-surface-hovered, #F0F1F2)",
    'elevation.surface.pressed': "var(--ds-surface-pressed, #DDDEE1)",
    'elevation.surface.container': "var(--ds-surface-container, #17171708)",
    'elevation.surface.container.hovered': "var(--ds-surface-container-hovered, #0515240F)",
    'elevation.surface.container.pressed': "var(--ds-surface-container-pressed, #0B120E24)",
    'elevation.surface.overlay': "var(--ds-surface-overlay, #FFFFFF)",
    'elevation.surface.overlay.hovered': "var(--ds-surface-overlay-hovered, #F0F1F2)",
    'elevation.surface.overlay.pressed': "var(--ds-surface-overlay-pressed, #DDDEE1)",
    'elevation.surface.raised': "var(--ds-surface-raised, #FFFFFF)",
    'elevation.surface.raised.hovered': "var(--ds-surface-raised-hovered, #F0F1F2)",
    'elevation.surface.raised.pressed': "var(--ds-surface-raised-pressed, #DDDEE1)",
    'elevation.surface.sunken': "var(--ds-surface-sunken, #F8F8F8)"
};
var $409b8db60ea39aa2$export$1531ad5bb3fbedac = {
    'color.border': "var(--ds-border, #0B120E24)",
    'color.border.accent.lime': "var(--ds-border-accent-lime, #6A9A23)",
    'color.border.accent.lime.subtle': "var(--ds-border-accent-lime-subtle, #B3DF72)",
    'color.border.accent.red': "var(--ds-border-accent-red, #E2483D)",
    'color.border.accent.red.subtle': "var(--ds-border-accent-red-subtle, #FD9891)",
    'color.border.accent.orange': "var(--ds-border-accent-orange, #E06C00)",
    'color.border.accent.orange.subtle': "var(--ds-border-accent-orange-subtle, #FBC828)",
    'color.border.accent.yellow': "var(--ds-border-accent-yellow, #B38600)",
    'color.border.accent.yellow.subtle': "var(--ds-border-accent-yellow-subtle, #EED12B)",
    'color.border.accent.green': "var(--ds-border-accent-green, #22A06B)",
    'color.border.accent.green.subtle': "var(--ds-border-accent-green-subtle, #7EE2B8)",
    'color.border.accent.teal': "var(--ds-border-accent-teal, #2898BD)",
    'color.border.accent.teal.subtle': "var(--ds-border-accent-teal-subtle, #9DD9EE)",
    'color.border.accent.blue': "var(--ds-border-accent-blue, #357DE8)",
    'color.border.accent.blue.subtle': "var(--ds-border-accent-blue-subtle, #8FB8F6)",
    'color.border.accent.purple': "var(--ds-border-accent-purple, #AF59E1)",
    'color.border.accent.purple.subtle': "var(--ds-border-accent-purple-subtle, #D8A0F7)",
    'color.border.accent.magenta': "var(--ds-border-accent-magenta, #CD519D)",
    'color.border.accent.magenta.subtle': "var(--ds-border-accent-magenta-subtle, #F797D2)",
    'color.border.accent.gray': "var(--ds-border-accent-gray, #7D818A)",
    'color.border.accent.gray.subtle': "var(--ds-border-accent-gray-subtle, #B7B9BE)",
    'color.border.disabled': "var(--ds-border-disabled, #0515240F)",
    'color.border.focused': "var(--ds-border-focused, #4688EC)",
    'color.border.input': "var(--ds-border-input, #8C8F97)",
    'color.border.inverse': "var(--ds-border-inverse, #FFFFFF)",
    'color.border.selected': "var(--ds-border-selected, #1868DB)",
    'color.border.brand': "var(--ds-border-brand, #1868DB)",
    'color.border.danger': "var(--ds-border-danger, #E2483D)",
    'color.border.danger.subtle': "var(--ds-border-danger-subtle, #FD9891)",
    'color.border.warning': "var(--ds-border-warning, #E06C00)",
    'color.border.warning.subtle': "var(--ds-border-warning-subtle, #FBC828)",
    'color.border.success': "var(--ds-border-success, #6A9A23)",
    'color.border.success.subtle': "var(--ds-border-success-subtle, #B3DF72)",
    'color.border.discovery': "var(--ds-border-discovery, #AF59E1)",
    'color.border.discovery.subtle': "var(--ds-border-discovery-subtle, #D8A0F7)",
    'color.border.information': "var(--ds-border-information, #357DE8)",
    'color.border.information.subtle': "var(--ds-border-information-subtle, #8FB8F6)",
    'color.border.bold': "var(--ds-border-bold, #7D818A)"
};
var $409b8db60ea39aa2$export$d1d79bf68ac056bd = {
    'color.background.accent.lime.subtlest': "var(--ds-background-accent-lime-subtlest, #EFFFD6)",
    'color.background.accent.lime.subtlest.hovered': "var(--ds-background-accent-lime-subtlest-hovered, #D3F1A7)",
    'color.background.accent.lime.subtlest.pressed': "var(--ds-background-accent-lime-subtlest-pressed, #BDE97C)",
    'color.background.accent.lime.subtler': "var(--ds-background-accent-lime-subtler, #D3F1A7)",
    'color.background.accent.lime.subtler.hovered': "var(--ds-background-accent-lime-subtler-hovered, #BDE97C)",
    'color.background.accent.lime.subtler.pressed': "var(--ds-background-accent-lime-subtler-pressed, #B3DF72)",
    'color.background.accent.lime.subtle': "var(--ds-background-accent-lime-subtle, #94C748)",
    'color.background.accent.lime.subtle.hovered': "var(--ds-background-accent-lime-subtle-hovered, #B3DF72)",
    'color.background.accent.lime.subtle.pressed': "var(--ds-background-accent-lime-subtle-pressed, #BDE97C)",
    'color.background.accent.lime.bolder': "var(--ds-background-accent-lime-bolder, #5B7F24)",
    'color.background.accent.lime.bolder.hovered': "var(--ds-background-accent-lime-bolder-hovered, #4C6B1F)",
    'color.background.accent.lime.bolder.pressed': "var(--ds-background-accent-lime-bolder-pressed, #3F5224)",
    'color.background.accent.red.subtlest': "var(--ds-background-accent-red-subtlest, #FFECEB)",
    'color.background.accent.red.subtlest.hovered': "var(--ds-background-accent-red-subtlest-hovered, #FFD5D2)",
    'color.background.accent.red.subtlest.pressed': "var(--ds-background-accent-red-subtlest-pressed, #FFB8B2)",
    'color.background.accent.red.subtler': "var(--ds-background-accent-red-subtler, #FFD5D2)",
    'color.background.accent.red.subtler.hovered': "var(--ds-background-accent-red-subtler-hovered, #FFB8B2)",
    'color.background.accent.red.subtler.pressed': "var(--ds-background-accent-red-subtler-pressed, #FD9891)",
    'color.background.accent.red.subtle': "var(--ds-background-accent-red-subtle, #F87168)",
    'color.background.accent.red.subtle.hovered': "var(--ds-background-accent-red-subtle-hovered, #FD9891)",
    'color.background.accent.red.subtle.pressed': "var(--ds-background-accent-red-subtle-pressed, #FFB8B2)",
    'color.background.accent.red.bolder': "var(--ds-background-accent-red-bolder, #C9372C)",
    'color.background.accent.red.bolder.hovered': "var(--ds-background-accent-red-bolder-hovered, #AE2E24)",
    'color.background.accent.red.bolder.pressed': "var(--ds-background-accent-red-bolder-pressed, #872821)",
    'color.background.accent.orange.subtlest': "var(--ds-background-accent-orange-subtlest, #FFF5DB)",
    'color.background.accent.orange.subtlest.hovered': "var(--ds-background-accent-orange-subtlest-hovered, #FCE4A6)",
    'color.background.accent.orange.subtlest.pressed': "var(--ds-background-accent-orange-subtlest-pressed, #FBD779)",
    'color.background.accent.orange.subtler': "var(--ds-background-accent-orange-subtler, #FCE4A6)",
    'color.background.accent.orange.subtler.hovered': "var(--ds-background-accent-orange-subtler-hovered, #FBD779)",
    'color.background.accent.orange.subtler.pressed': "var(--ds-background-accent-orange-subtler-pressed, #FBC828)",
    'color.background.accent.orange.subtle': "var(--ds-background-accent-orange-subtle, #FCA700)",
    'color.background.accent.orange.subtle.hovered': "var(--ds-background-accent-orange-subtle-hovered, #FBC828)",
    'color.background.accent.orange.subtle.pressed': "var(--ds-background-accent-orange-subtle-pressed, #FBD779)",
    'color.background.accent.orange.bolder': "var(--ds-background-accent-orange-bolder, #BD5B00)",
    'color.background.accent.orange.bolder.hovered': "var(--ds-background-accent-orange-bolder-hovered, #9E4C00)",
    'color.background.accent.orange.bolder.pressed': "var(--ds-background-accent-orange-bolder-pressed, #7A3B00)",
    'color.background.accent.yellow.subtlest': "var(--ds-background-accent-yellow-subtlest, #FEF7C8)",
    'color.background.accent.yellow.subtlest.hovered': "var(--ds-background-accent-yellow-subtlest-hovered, #F5E989)",
    'color.background.accent.yellow.subtlest.pressed': "var(--ds-background-accent-yellow-subtlest-pressed, #EFDD4E)",
    'color.background.accent.yellow.subtler': "var(--ds-background-accent-yellow-subtler, #F5E989)",
    'color.background.accent.yellow.subtler.hovered': "var(--ds-background-accent-yellow-subtler-hovered, #EFDD4E)",
    'color.background.accent.yellow.subtler.pressed': "var(--ds-background-accent-yellow-subtler-pressed, #EED12B)",
    'color.background.accent.yellow.subtle': "var(--ds-background-accent-yellow-subtle, #EED12B)",
    'color.background.accent.yellow.subtle.hovered': "var(--ds-background-accent-yellow-subtle-hovered, #DDB30E)",
    'color.background.accent.yellow.subtle.pressed': "var(--ds-background-accent-yellow-subtle-pressed, #EFDD4E)",
    'color.background.accent.yellow.bolder': "var(--ds-background-accent-yellow-bolder, #946F00)",
    'color.background.accent.yellow.bolder.hovered': "var(--ds-background-accent-yellow-bolder-hovered, #7F5F01)",
    'color.background.accent.yellow.bolder.pressed': "var(--ds-background-accent-yellow-bolder-pressed, #614A05)",
    'color.background.accent.green.subtlest': "var(--ds-background-accent-green-subtlest, #DCFFF1)",
    'color.background.accent.green.subtlest.hovered': "var(--ds-background-accent-green-subtlest-hovered, #BAF3DB)",
    'color.background.accent.green.subtlest.pressed': "var(--ds-background-accent-green-subtlest-pressed, #97EDC9)",
    'color.background.accent.green.subtler': "var(--ds-background-accent-green-subtler, #BAF3DB)",
    'color.background.accent.green.subtler.hovered': "var(--ds-background-accent-green-subtler-hovered, #97EDC9)",
    'color.background.accent.green.subtler.pressed': "var(--ds-background-accent-green-subtler-pressed, #7EE2B8)",
    'color.background.accent.green.subtle': "var(--ds-background-accent-green-subtle, #4BCE97)",
    'color.background.accent.green.subtle.hovered': "var(--ds-background-accent-green-subtle-hovered, #7EE2B8)",
    'color.background.accent.green.subtle.pressed': "var(--ds-background-accent-green-subtle-pressed, #97EDC9)",
    'color.background.accent.green.bolder': "var(--ds-background-accent-green-bolder, #1F845A)",
    'color.background.accent.green.bolder.hovered': "var(--ds-background-accent-green-bolder-hovered, #216E4E)",
    'color.background.accent.green.bolder.pressed': "var(--ds-background-accent-green-bolder-pressed, #19573D)",
    'color.background.accent.teal.subtlest': "var(--ds-background-accent-teal-subtlest, #E7F9FF)",
    'color.background.accent.teal.subtlest.hovered': "var(--ds-background-accent-teal-subtlest-hovered, #C6EDFB)",
    'color.background.accent.teal.subtlest.pressed': "var(--ds-background-accent-teal-subtlest-pressed, #B1E4F7)",
    'color.background.accent.teal.subtler': "var(--ds-background-accent-teal-subtler, #C6EDFB)",
    'color.background.accent.teal.subtler.hovered': "var(--ds-background-accent-teal-subtler-hovered, #B1E4F7)",
    'color.background.accent.teal.subtler.pressed': "var(--ds-background-accent-teal-subtler-pressed, #9DD9EE)",
    'color.background.accent.teal.subtle': "var(--ds-background-accent-teal-subtle, #6CC3E0)",
    'color.background.accent.teal.subtle.hovered': "var(--ds-background-accent-teal-subtle-hovered, #9DD9EE)",
    'color.background.accent.teal.subtle.pressed': "var(--ds-background-accent-teal-subtle-pressed, #B1E4F7)",
    'color.background.accent.teal.bolder': "var(--ds-background-accent-teal-bolder, #227D9B)",
    'color.background.accent.teal.bolder.hovered': "var(--ds-background-accent-teal-bolder-hovered, #206A83)",
    'color.background.accent.teal.bolder.pressed': "var(--ds-background-accent-teal-bolder-pressed, #1A5265)",
    'color.background.accent.blue.subtlest': "var(--ds-background-accent-blue-subtlest, #E9F2FE)",
    'color.background.accent.blue.subtlest.hovered': "var(--ds-background-accent-blue-subtlest-hovered, #CFE1FD)",
    'color.background.accent.blue.subtlest.pressed': "var(--ds-background-accent-blue-subtlest-pressed, #ADCBFB)",
    'color.background.accent.blue.subtler': "var(--ds-background-accent-blue-subtler, #CFE1FD)",
    'color.background.accent.blue.subtler.hovered': "var(--ds-background-accent-blue-subtler-hovered, #ADCBFB)",
    'color.background.accent.blue.subtler.pressed': "var(--ds-background-accent-blue-subtler-pressed, #8FB8F6)",
    'color.background.accent.blue.subtle': "var(--ds-background-accent-blue-subtle, #669DF1)",
    'color.background.accent.blue.subtle.hovered': "var(--ds-background-accent-blue-subtle-hovered, #8FB8F6)",
    'color.background.accent.blue.subtle.pressed': "var(--ds-background-accent-blue-subtle-pressed, #ADCBFB)",
    'color.background.accent.blue.bolder': "var(--ds-background-accent-blue-bolder, #1868DB)",
    'color.background.accent.blue.bolder.hovered': "var(--ds-background-accent-blue-bolder-hovered, #1558BC)",
    'color.background.accent.blue.bolder.pressed': "var(--ds-background-accent-blue-bolder-pressed, #144794)",
    'color.background.accent.purple.subtlest': "var(--ds-background-accent-purple-subtlest, #F8EEFE)",
    'color.background.accent.purple.subtlest.hovered': "var(--ds-background-accent-purple-subtlest-hovered, #EED7FC)",
    'color.background.accent.purple.subtlest.pressed': "var(--ds-background-accent-purple-subtlest-pressed, #E3BDFA)",
    'color.background.accent.purple.subtler': "var(--ds-background-accent-purple-subtler, #EED7FC)",
    'color.background.accent.purple.subtler.hovered': "var(--ds-background-accent-purple-subtler-hovered, #E3BDFA)",
    'color.background.accent.purple.subtler.pressed': "var(--ds-background-accent-purple-subtler-pressed, #D8A0F7)",
    'color.background.accent.purple.subtle': "var(--ds-background-accent-purple-subtle, #C97CF4)",
    'color.background.accent.purple.subtle.hovered': "var(--ds-background-accent-purple-subtle-hovered, #D8A0F7)",
    'color.background.accent.purple.subtle.pressed': "var(--ds-background-accent-purple-subtle-pressed, #E3BDFA)",
    'color.background.accent.purple.bolder': "var(--ds-background-accent-purple-bolder, #964AC0)",
    'color.background.accent.purple.bolder.hovered': "var(--ds-background-accent-purple-bolder-hovered, #803FA5)",
    'color.background.accent.purple.bolder.pressed': "var(--ds-background-accent-purple-bolder-pressed, #673286)",
    'color.background.accent.magenta.subtlest': "var(--ds-background-accent-magenta-subtlest, #FFECF8)",
    'color.background.accent.magenta.subtlest.hovered': "var(--ds-background-accent-magenta-subtlest-hovered, #FDD0EC)",
    'color.background.accent.magenta.subtlest.pressed': "var(--ds-background-accent-magenta-subtlest-pressed, #FCB6E1)",
    'color.background.accent.magenta.subtler': "var(--ds-background-accent-magenta-subtler, #FDD0EC)",
    'color.background.accent.magenta.subtler.hovered': "var(--ds-background-accent-magenta-subtler-hovered, #FCB6E1)",
    'color.background.accent.magenta.subtler.pressed': "var(--ds-background-accent-magenta-subtler-pressed, #F797D2)",
    'color.background.accent.magenta.subtle': "var(--ds-background-accent-magenta-subtle, #E774BB)",
    'color.background.accent.magenta.subtle.hovered': "var(--ds-background-accent-magenta-subtle-hovered, #F797D2)",
    'color.background.accent.magenta.subtle.pressed': "var(--ds-background-accent-magenta-subtle-pressed, #FCB6E1)",
    'color.background.accent.magenta.bolder': "var(--ds-background-accent-magenta-bolder, #AE4787)",
    'color.background.accent.magenta.bolder.hovered': "var(--ds-background-accent-magenta-bolder-hovered, #943D73)",
    'color.background.accent.magenta.bolder.pressed': "var(--ds-background-accent-magenta-bolder-pressed, #77325B)",
    'color.background.accent.gray.subtlest': "var(--ds-background-accent-gray-subtlest, #F0F1F2)",
    'color.background.accent.gray.subtlest.hovered': "var(--ds-background-accent-gray-subtlest-hovered, #DDDEE1)",
    'color.background.accent.gray.subtlest.pressed': "var(--ds-background-accent-gray-subtlest-pressed, #B7B9BE)",
    'color.background.accent.gray.subtler': "var(--ds-background-accent-gray-subtler, #DDDEE1)",
    'color.background.accent.gray.subtler.hovered': "var(--ds-background-accent-gray-subtler-hovered, #B7B9BE)",
    'color.background.accent.gray.subtler.pressed': "var(--ds-background-accent-gray-subtler-pressed, #8C8F97)",
    'color.background.accent.gray.subtle': "var(--ds-background-accent-gray-subtle, #8C8F97)",
    'color.background.accent.gray.subtle.hovered': "var(--ds-background-accent-gray-subtle-hovered, #B7B9BE)",
    'color.background.accent.gray.subtle.pressed': "var(--ds-background-accent-gray-subtle-pressed, #DDDEE1)",
    'color.background.accent.gray.bolder': "var(--ds-background-accent-gray-bolder, #6B6E76)",
    'color.background.accent.gray.bolder.hovered': "var(--ds-background-accent-gray-bolder-hovered, #505258)",
    'color.background.accent.gray.bolder.pressed': "var(--ds-background-accent-gray-bolder-pressed, #3B3D42)",
    'color.background.disabled': "var(--ds-background-disabled, #0515240F)",
    'color.background.input': "var(--ds-background-input, #FFFFFF)",
    'color.background.input.hovered': "var(--ds-background-input-hovered, #F8F8F8)",
    'color.background.input.pressed': "var(--ds-background-input-pressed, #FFFFFF)",
    'color.background.inverse.subtle': "var(--ds-background-inverse-subtle, #00000029)",
    'color.background.inverse.subtle.hovered': "var(--ds-background-inverse-subtle-hovered, #0000003D)",
    'color.background.inverse.subtle.pressed': "var(--ds-background-inverse-subtle-pressed, #00000052)",
    'color.background.neutral': "var(--ds-background-neutral, #0515240F)",
    'color.background.neutral.hovered': "var(--ds-background-neutral-hovered, #0B120E24)",
    'color.background.neutral.pressed': "var(--ds-background-neutral-pressed, #080F214A)",
    'color.background.neutral.subtle': "var(--ds-background-neutral-subtle, #00000000)",
    'color.background.neutral.subtle.hovered': "var(--ds-background-neutral-subtle-hovered, #0515240F)",
    'color.background.neutral.subtle.pressed': "var(--ds-background-neutral-subtle-pressed, #0B120E24)",
    'color.background.neutral.bold': "var(--ds-background-neutral-bold, #292A2E)",
    'color.background.neutral.bold.hovered': "var(--ds-background-neutral-bold-hovered, #3B3D42)",
    'color.background.neutral.bold.pressed': "var(--ds-background-neutral-bold-pressed, #505258)",
    'color.background.selected': "var(--ds-background-selected, #E9F2FE)",
    'color.background.selected.hovered': "var(--ds-background-selected-hovered, #CFE1FD)",
    'color.background.selected.pressed': "var(--ds-background-selected-pressed, #8FB8F6)",
    'color.background.selected.bold': "var(--ds-background-selected-bold, #1868DB)",
    'color.background.selected.bold.hovered': "var(--ds-background-selected-bold-hovered, #1558BC)",
    'color.background.selected.bold.pressed': "var(--ds-background-selected-bold-pressed, #123263)",
    'color.background.brand.subtlest': "var(--ds-background-brand-subtlest, #E9F2FE)",
    'color.background.brand.subtlest.hovered': "var(--ds-background-brand-subtlest-hovered, #CFE1FD)",
    'color.background.brand.subtlest.pressed': "var(--ds-background-brand-subtlest-pressed, #ADCBFB)",
    'color.background.brand.bold': "var(--ds-background-brand-bold, #1868DB)",
    'color.background.brand.bold.hovered': "var(--ds-background-brand-bold-hovered, #1558BC)",
    'color.background.brand.bold.pressed': "var(--ds-background-brand-bold-pressed, #144794)",
    'color.background.brand.boldest': "var(--ds-background-brand-boldest, #1C2B42)",
    'color.background.brand.boldest.hovered': "var(--ds-background-brand-boldest-hovered, #123263)",
    'color.background.brand.boldest.pressed': "var(--ds-background-brand-boldest-pressed, #144794)",
    'color.background.danger': "var(--ds-background-danger, #FFECEB)",
    'color.background.danger.hovered': "var(--ds-background-danger-hovered, #FFD5D2)",
    'color.background.danger.pressed': "var(--ds-background-danger-pressed, #FFB8B2)",
    'color.background.danger.subtler': "var(--ds-background-danger-subtler, #FFD5D2)",
    'color.background.danger.subtler.hovered': "var(--ds-background-danger-subtler-hovered, #FFB8B2)",
    'color.background.danger.subtler.pressed': "var(--ds-background-danger-subtler-pressed, #FD9891)",
    'color.background.danger.subtle': "var(--ds-background-danger-subtle, #FD9891)",
    'color.background.danger.bold': "var(--ds-background-danger-bold, #C9372C)",
    'color.background.danger.bold.hovered': "var(--ds-background-danger-bold-hovered, #AE2E24)",
    'color.background.danger.bold.pressed': "var(--ds-background-danger-bold-pressed, #872821)",
    'color.background.warning': "var(--ds-background-warning, #FFF5DB)",
    'color.background.warning.hovered': "var(--ds-background-warning-hovered, #FCE4A6)",
    'color.background.warning.pressed': "var(--ds-background-warning-pressed, #FBD779)",
    'color.background.warning.subtler': "var(--ds-background-warning-subtler, #FCE4A6)",
    'color.background.warning.subtler.hovered': "var(--ds-background-warning-subtler-hovered, #FBD779)",
    'color.background.warning.subtler.pressed': "var(--ds-background-warning-subtler-pressed, #FBC828)",
    'color.background.warning.subtle': "var(--ds-background-warning-subtle, #FBD779)",
    'color.background.warning.bold': "var(--ds-background-warning-bold, #FBC828)",
    'color.background.warning.bold.hovered': "var(--ds-background-warning-bold-hovered, #FCA700)",
    'color.background.warning.bold.pressed': "var(--ds-background-warning-bold-pressed, #F68909)",
    'color.background.success': "var(--ds-background-success, #EFFFD6)",
    'color.background.success.hovered': "var(--ds-background-success-hovered, #D3F1A7)",
    'color.background.success.pressed': "var(--ds-background-success-pressed, #BDE97C)",
    'color.background.success.subtler': "var(--ds-background-success-subtler, #D3F1A7)",
    'color.background.success.subtler.hovered': "var(--ds-background-success-subtler-hovered, #BDE97C)",
    'color.background.success.subtler.pressed': "var(--ds-background-success-subtler-pressed, #B3DF72)",
    'color.background.success.subtle': "var(--ds-background-success-subtle, #B3DF72)",
    'color.background.success.bold': "var(--ds-background-success-bold, #5B7F24)",
    'color.background.success.bold.hovered': "var(--ds-background-success-bold-hovered, #4C6B1F)",
    'color.background.success.bold.pressed': "var(--ds-background-success-bold-pressed, #3F5224)",
    'color.background.discovery': "var(--ds-background-discovery, #F8EEFE)",
    'color.background.discovery.hovered': "var(--ds-background-discovery-hovered, #EED7FC)",
    'color.background.discovery.pressed': "var(--ds-background-discovery-pressed, #E3BDFA)",
    'color.background.discovery.subtler': "var(--ds-background-discovery-subtler, #EED7FC)",
    'color.background.discovery.subtler.hovered': "var(--ds-background-discovery-subtler-hovered, #E3BDFA)",
    'color.background.discovery.subtler.pressed': "var(--ds-background-discovery-subtler-pressed, #D8A0F7)",
    'color.background.discovery.subtle': "var(--ds-background-discovery-subtle, #D8A0F7)",
    'color.background.discovery.bold': "var(--ds-background-discovery-bold, #964AC0)",
    'color.background.discovery.bold.hovered': "var(--ds-background-discovery-bold-hovered, #803FA5)",
    'color.background.discovery.bold.pressed': "var(--ds-background-discovery-bold-pressed, #673286)",
    'color.background.information': "var(--ds-background-information, #E9F2FE)",
    'color.background.information.hovered': "var(--ds-background-information-hovered, #CFE1FD)",
    'color.background.information.pressed': "var(--ds-background-information-pressed, #ADCBFB)",
    'color.background.information.subtler': "var(--ds-background-information-subtler, #CFE1FD)",
    'color.background.information.subtler.hovered': "var(--ds-background-information-subtler-hovered, #ADCBFB)",
    'color.background.information.subtler.pressed': "var(--ds-background-information-subtler-pressed, #8FB8F6)",
    'color.background.information.subtle': "var(--ds-background-information-subtle, #8FB8F6)",
    'color.background.information.bold': "var(--ds-background-information-bold, #1868DB)",
    'color.background.information.bold.hovered': "var(--ds-background-information-bold-hovered, #1558BC)",
    'color.background.information.bold.pressed': "var(--ds-background-information-bold-pressed, #144794)",
    'color.skeleton': "var(--ds-skeleton, #0515240F)",
    'color.skeleton.subtle': "var(--ds-skeleton-subtle, #17171708)",
    'color.blanket': "var(--ds-blanket, #050C1F75)",
    'color.blanket.selected': "var(--ds-blanket-selected, #388BFF14)",
    'color.blanket.danger': "var(--ds-blanket-danger, #EF5C4814)",
    'color.rovo.background.brand.bold': "var(--ds-rovo-background-brand-bold, #000000)",
    'color.rovo.background.brand.bold.hovered': "var(--ds-rovo-background-brand-bold-hovered, #1E1F21)",
    'color.rovo.background.brand.bold.pressed': "var(--ds-rovo-background-brand-bold-pressed, #292A2E)",
    'elevation.surface': "var(--ds-surface, #FFFFFF)",
    'elevation.surface.hovered': "var(--ds-surface-hovered, #F0F1F2)",
    'elevation.surface.pressed': "var(--ds-surface-pressed, #DDDEE1)",
    'elevation.surface.container': "var(--ds-surface-container, #17171708)",
    'elevation.surface.container.hovered': "var(--ds-surface-container-hovered, #0515240F)",
    'elevation.surface.container.pressed': "var(--ds-surface-container-pressed, #0B120E24)",
    'elevation.surface.overlay': "var(--ds-surface-overlay, #FFFFFF)",
    'elevation.surface.overlay.hovered': "var(--ds-surface-overlay-hovered, #F0F1F2)",
    'elevation.surface.overlay.pressed': "var(--ds-surface-overlay-pressed, #DDDEE1)",
    'elevation.surface.raised': "var(--ds-surface-raised, #FFFFFF)",
    'elevation.surface.raised.hovered': "var(--ds-surface-raised-hovered, #F0F1F2)",
    'elevation.surface.raised.pressed': "var(--ds-surface-raised-pressed, #DDDEE1)",
    'elevation.surface.sunken': "var(--ds-surface-sunken, #F8F8F8)",
    'utility.elevation.surface.current': "var(--ds-elevation-surface-current, #FFFFFF)"
};
var $409b8db60ea39aa2$export$8473307aa00d6ea1 = {
    'color.text': "var(--ds-text, #292A2E)",
    'color.text.accent.lime': "var(--ds-text-accent-lime, #4C6B1F)",
    'color.text.accent.lime.bolder': "var(--ds-text-accent-lime-bolder, #37471F)",
    'color.text.accent.red': "var(--ds-text-accent-red, #AE2E24)",
    'color.text.accent.red.bolder': "var(--ds-text-accent-red-bolder, #5D1F1A)",
    'color.text.accent.orange': "var(--ds-text-accent-orange, #9E4C00)",
    'color.text.accent.orange.bolder': "var(--ds-text-accent-orange-bolder, #693200)",
    'color.text.accent.yellow': "var(--ds-text-accent-yellow, #7F5F01)",
    'color.text.accent.yellow.bolder': "var(--ds-text-accent-yellow-bolder, #533F04)",
    'color.text.accent.green': "var(--ds-text-accent-green, #216E4E)",
    'color.text.accent.green.bolder': "var(--ds-text-accent-green-bolder, #164B35)",
    'color.text.accent.teal': "var(--ds-text-accent-teal, #206A83)",
    'color.text.accent.teal.bolder': "var(--ds-text-accent-teal-bolder, #164555)",
    'color.text.accent.blue': "var(--ds-text-accent-blue, #1558BC)",
    'color.text.accent.blue.bolder': "var(--ds-text-accent-blue-bolder, #123263)",
    'color.text.accent.purple': "var(--ds-text-accent-purple, #803FA5)",
    'color.text.accent.purple.bolder': "var(--ds-text-accent-purple-bolder, #48245D)",
    'color.text.accent.magenta': "var(--ds-text-accent-magenta, #943D73)",
    'color.text.accent.magenta.bolder': "var(--ds-text-accent-magenta-bolder, #50253F)",
    'color.text.accent.gray': "var(--ds-text-accent-gray, #505258)",
    'color.text.accent.gray.bolder': "var(--ds-text-accent-gray-bolder, #1E1F21)",
    'color.text.disabled': "var(--ds-text-disabled, #080F214A)",
    'color.text.inverse': "var(--ds-text-inverse, #FFFFFF)",
    'color.text.selected': "var(--ds-text-selected, #1868DB)",
    'color.text.brand': "var(--ds-text-brand, #1868DB)",
    'color.text.danger': "var(--ds-text-danger, #AE2E24)",
    'color.text.danger.bolder': "var(--ds-text-danger-bolder, #5D1F1A)",
    'color.text.warning': "var(--ds-text-warning, #9E4C00)",
    'color.text.warning.inverse': "var(--ds-text-warning-inverse, #292A2E)",
    'color.text.warning.bolder': "var(--ds-text-warning-bolder, #693200)",
    'color.text.success': "var(--ds-text-success, #4C6B1F)",
    'color.text.success.bolder': "var(--ds-text-success-bolder, #37471F)",
    'color.text.discovery': "var(--ds-text-discovery, #803FA5)",
    'color.text.discovery.bolder': "var(--ds-text-discovery-bolder, #48245D)",
    'color.text.information': "var(--ds-text-information, #1558BC)",
    'color.text.information.bolder': "var(--ds-text-information-bolder, #123263)",
    'color.text.subtlest': "var(--ds-text-subtlest, #6B6E76)",
    'color.text.subtle': "var(--ds-text-subtle, #505258)",
    'color.link': "var(--ds-link, #1868DB)",
    'color.link.pressed': "var(--ds-link-pressed, #1558BC)",
    'color.link.visited': "var(--ds-link-visited, #803FA5)",
    'color.link.visited.pressed': "var(--ds-link-visited-pressed, #48245D)"
};
var $409b8db60ea39aa2$export$498780f74be9af68 = {
    'color.icon': "var(--ds-icon, #292A2E)",
    'color.icon.accent.lime': "var(--ds-icon-accent-lime, #6A9A23)",
    'color.icon.accent.red': "var(--ds-icon-accent-red, #C9372C)",
    'color.icon.accent.orange': "var(--ds-icon-accent-orange, #E06C00)",
    'color.icon.accent.yellow': "var(--ds-icon-accent-yellow, #B38600)",
    'color.icon.accent.green': "var(--ds-icon-accent-green, #22A06B)",
    'color.icon.accent.teal': "var(--ds-icon-accent-teal, #2898BD)",
    'color.icon.accent.blue': "var(--ds-icon-accent-blue, #357DE8)",
    'color.icon.accent.purple': "var(--ds-icon-accent-purple, #AF59E1)",
    'color.icon.accent.magenta': "var(--ds-icon-accent-magenta, #CD519D)",
    'color.icon.accent.gray': "var(--ds-icon-accent-gray, #7D818A)",
    'color.icon.disabled': "var(--ds-icon-disabled, #080F214A)",
    'color.icon.inverse': "var(--ds-icon-inverse, #FFFFFF)",
    'color.icon.selected': "var(--ds-icon-selected, #1868DB)",
    'color.icon.brand': "var(--ds-icon-brand, #1868DB)",
    'color.icon.danger': "var(--ds-icon-danger, #C9372C)",
    'color.icon.warning': "var(--ds-icon-warning, #E06C00)",
    'color.icon.warning.inverse': "var(--ds-icon-warning-inverse, #292A2E)",
    'color.icon.success': "var(--ds-icon-success, #6A9A23)",
    'color.icon.discovery': "var(--ds-icon-discovery, #AF59E1)",
    'color.icon.information': "var(--ds-icon-information, #357DE8)",
    'color.icon.subtlest': "var(--ds-icon-subtlest, #6B6E76)",
    'color.icon.subtle': "var(--ds-icon-subtle, #505258)"
};
var $409b8db60ea39aa2$export$b5f31a7e431d2eab = {
    '1': 1,
    card: 100,
    navigation: 200,
    dialog: 300,
    layer: 400,
    blanket: 500,
    modal: 510,
    flag: 600,
    spotlight: 700,
    tooltip: 800
};
var $409b8db60ea39aa2$export$e1b83c5210c471b8 = {
    'border.width': "var(--ds-border-width, 1px)",
    'border.width.selected': "var(--ds-border-width-selected, 2px)",
    'border.width.focused': "var(--ds-border-width-focused, 2px)"
};
var $409b8db60ea39aa2$export$3c0a6c3e64bb180d = {
    'radius.xsmall': "var(--ds-radius-xsmall, 2px)",
    'radius.small': "var(--ds-radius-small, 3px)",
    'radius.medium': "var(--ds-radius-medium, 6px)",
    'radius.large': "var(--ds-radius-large, 8px)",
    'radius.xlarge': "var(--ds-radius-xlarge, 12px)",
    'radius.xxlarge': "var(--ds-radius-xxlarge, 16px)",
    'radius.full': "var(--ds-radius-full, 9999px)",
    'radius.tile': "var(--ds-radius-tile, 25%)"
};
var $409b8db60ea39aa2$export$6ffa317d5e70375 = {
    'font.body': "var(--ds-font-body, normal 400 14px/20px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.body.large': "var(--ds-font-body-large, normal 400 16px/24px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.body.small': "var(--ds-font-body-small, normal 400 12px/16px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.code': "var(--ds-font-code, normal 400 0.875em/1 \"Atlassian Mono\", ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)",
    'font.heading.large': "var(--ds-font-heading-large, normal 653 24px/28px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.heading.medium': "var(--ds-font-heading-medium, normal 653 20px/24px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.heading.small': "var(--ds-font-heading-small, normal 653 16px/20px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.heading.xlarge': "var(--ds-font-heading-xlarge, normal 653 28px/32px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.heading.xsmall': "var(--ds-font-heading-xsmall, normal 653 14px/20px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.heading.xxlarge': "var(--ds-font-heading-xxlarge, normal 653 32px/36px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.heading.xxsmall': "var(--ds-font-heading-xxsmall, normal 653 12px/16px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.metric.large': "var(--ds-font-metric-large, normal 653 28px/32px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.metric.medium': "var(--ds-font-metric-medium, normal 653 24px/28px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.metric.small': "var(--ds-font-metric-small, normal 653 16px/20px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
};
var $409b8db60ea39aa2$export$303e322c6b1ed114 = {
    'font.weight.bold': "var(--ds-font-weight-bold, 653)",
    'font.weight.medium': "var(--ds-font-weight-medium, 500)",
    'font.weight.regular': "var(--ds-font-weight-regular, 400)",
    'font.weight.semibold': "var(--ds-font-weight-semibold, 600)"
};
var $409b8db60ea39aa2$export$3c7e9587132614b4 = {
    'font.family.body': "var(--ds-font-family-body, \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.family.brand.body': "var(--ds-font-family-brand-body, \"Charlie Text\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.family.brand.heading': "var(--ds-font-family-brand-heading, \"Charlie Display\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.family.code': "var(--ds-font-family-code, \"Atlassian Mono\", ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)",
    'font.family.heading': "var(--ds-font-family-heading, \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
};
var $409b8db60ea39aa2$export$236bfe3a33ef1292 = {
    medium: "var(--ds-font-body, normal 400 14px/20px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    large: "var(--ds-font-body-large, normal 400 16px/24px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    small: "var(--ds-font-body-small, normal 400 12px/16px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
};
var $409b8db60ea39aa2$export$855cfd311192d666 = {
    bold: "var(--ds-font-weight-bold, 653)",
    medium: "var(--ds-font-weight-medium, 500)",
    regular: "var(--ds-font-weight-regular, 400)",
    semibold: "var(--ds-font-weight-semibold, 600)"
};
var $409b8db60ea39aa2$export$b805719bc8cb376 = {
    large: "var(--ds-font-metric-large, normal 653 28px/32px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    medium: "var(--ds-font-metric-medium, normal 653 24px/28px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    small: "var(--ds-font-metric-small, normal 653 16px/20px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
};
/**
 * @codegenEnd
 */ // Margin needs some bespoke types: https://atlassian.slack.com/archives/CKRHB23K8/p1712623192772909
/**
 * Token functions are currently allowed for borderRadius in xcss to ease migration.
 * Because 'radius.small' defaults to 3px, we need a mechanism to allow for 4px values to be provided:
 * This is done by calling the token function - token('radius.small')
 *
 * TODO: Remove once shape them is rolled out and fg platform-dst-shape-theme-default removed
 */ // Generate maps for Box props. backgroundColor, padding, etc
var $409b8db60ea39aa2$var$spacingProperties = [
    // Used by Box
    'padding',
    'paddingBlock',
    'paddingBlockStart',
    'paddingBlockEnd',
    'paddingInline',
    'paddingInlineStart',
    'paddingInlineEnd',
    // Used by Inline and Stack
    'gap',
    'rowGap',
    'columnGap'
];
var $409b8db60ea39aa2$export$ca0f9c2de39ffed7 = function getSerializedStylesMap(cssProperty, tokenMap) {
    return Object.keys(tokenMap).reduce(function(emotionSpacingMap, token) {
        // eslint-disable-next-line @repo/internal/styles/no-exported-styles
        emotionSpacingMap[token] = (0, $74Zh5.css)((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, cssProperty, tokenMap[token]));
        return emotionSpacingMap;
    }, {});
};
var $409b8db60ea39aa2$export$e615f061ca585a6c = $409b8db60ea39aa2$var$spacingProperties.reduce(function(styleMap, spacingProperty) {
    styleMap[spacingProperty] = $409b8db60ea39aa2$export$ca0f9c2de39ffed7(spacingProperty, $409b8db60ea39aa2$export$958d0ae7f2977ae4);
    return styleMap;
}, {});
var $409b8db60ea39aa2$export$bf46c3f9eeafc71f = $409b8db60ea39aa2$var$spacingProperties.reduce(function(styleMap, spacingProperty) {
    styleMap[spacingProperty] = $409b8db60ea39aa2$export$ca0f9c2de39ffed7(spacingProperty, $409b8db60ea39aa2$export$958d0ae7f2977ae4);
    return styleMap;
}, {});
var $409b8db60ea39aa2$export$e7af83bafe7f9e63 = $409b8db60ea39aa2$export$ca0f9c2de39ffed7('backgroundColor', $409b8db60ea39aa2$export$d1d79bf68ac056bd);
var $409b8db60ea39aa2$export$3a1bcba60b23d7f0 = $409b8db60ea39aa2$export$ca0f9c2de39ffed7('color', $409b8db60ea39aa2$export$8473307aa00d6ea1);
var $409b8db60ea39aa2$export$45f3f4fe16f9f7d5 = $409b8db60ea39aa2$export$ca0f9c2de39ffed7('fontWeight', $409b8db60ea39aa2$export$303e322c6b1ed114);
var $409b8db60ea39aa2$export$68cc305da27dbaa4 = $409b8db60ea39aa2$export$ca0f9c2de39ffed7('fontFamily', $409b8db60ea39aa2$export$3c7e9587132614b4);
var $409b8db60ea39aa2$export$128f10c238242f83 = $409b8db60ea39aa2$export$ca0f9c2de39ffed7('font', $409b8db60ea39aa2$export$6ffa317d5e70375);
var $409b8db60ea39aa2$export$219d364c0da35ae4 = $409b8db60ea39aa2$export$ca0f9c2de39ffed7('font', $409b8db60ea39aa2$export$236bfe3a33ef1292);
var $409b8db60ea39aa2$export$38845ca010b93505 = $409b8db60ea39aa2$export$ca0f9c2de39ffed7('fontWeight', $409b8db60ea39aa2$export$855cfd311192d666);
var $409b8db60ea39aa2$export$ff257d957d48c421 = $409b8db60ea39aa2$export$ca0f9c2de39ffed7((0, $d061f3568ed8e1f6$export$9d7b58831ae93caa), $409b8db60ea39aa2$export$41a358c9c2356760);
var $409b8db60ea39aa2$export$5e65a44e5b6ecadb = function isSurfaceColorToken(color) {
    return $409b8db60ea39aa2$export$41a358c9c2356760[color] !== undefined;
};
var $409b8db60ea39aa2$export$7001ce64d9ff7c7f = $409b8db60ea39aa2$export$ca0f9c2de39ffed7('font', $409b8db60ea39aa2$export$b805719bc8cb376);



var $5FkrB = parcelRequire("5FkrB");

var $5FkrB = parcelRequire("5FkrB");
var $0f927b4c00a3c8f7$export$1ca2a26fecb070ae = /*#__PURE__*/ (0, $5FkrB.createContext)('elevation.surface');


var $103886b9883299a1$export$1aeb4f6b93c4540d = function useSurface() {
    return (0, $5FkrB.useContext)((0, $0f927b4c00a3c8f7$export$1ca2a26fecb070ae));
};
(0, $0f927b4c00a3c8f7$export$1ca2a26fecb070ae).displayName = 'SurfaceProvider';



var $5FkrB = parcelRequire("5FkrB");

var $5FkrB = parcelRequire("5FkrB");
var $9e1402c6a82b1460$export$d1fa8a19e192bc63 = /*#__PURE__*/ (0, $5FkrB.createContext)(0);


var $7983d3034ceacae2$export$6a64a1e2d0bbbf75 = function useHeadingLevel() {
    return (0, $5FkrB.useContext)((0, $9e1402c6a82b1460$export$d1fa8a19e192bc63));
};


var $b11a642b52a5818c$export$97a37b1befbbf9b1 = function useHeading(fallback) {
    var hLevel = (0, $7983d3034ceacae2$export$6a64a1e2d0bbbf75)();
    /**
   * Order here is important, we for now apply
   * 1. inferred a11y level (this only applies if context is present)
   * 2. default final fallback
   */ return [
        hLevel,
        hLevel && (hLevel > 6 ? 'div' : "h".concat(hLevel)) || fallback
    ];
};



var $3ZMUU = parcelRequire("3ZMUU");
var $9203416ce7d4106b$var$sizeTagMap = {
    xxlarge: 'h1',
    xlarge: 'h1',
    large: 'h2',
    medium: 'h3',
    small: 'h4',
    xsmall: 'h5',
    xxsmall: 'h6'
};
/**
 * Using '&&' here to increase specificity of Heading styles such that app styles like ".wiki-content h4" cannot override this component.
 */ var $9203416ce7d4106b$var$styles = {
    reset: "_dxsyidpf _1i144jg8 _nmk4glyw"
};
/**
 * Using '&&' here to increase specificity of Heading styles such that app styles like ".wiki-content h4" cannot override this component.
 */ var $9203416ce7d4106b$var$headingColorStyles = {
    'color.text': "_1w90i7uo",
    'color.text.inverse': "_1w9015cr",
    'color.text.warning.inverse': "_1w901yd3"
};
/**
 * Using '&&' here to increase specificity of Heading styles such that app styles like ".wiki-content h4" cannot override this component.
 */ var $9203416ce7d4106b$var$headingSizeStyles = {
    xxlarge: "_fqox1iff",
    xlarge: "_fqox12ln",
    large: "_fqox10sd",
    medium: "_fqox1af2",
    small: "_fqox1e3o",
    xsmall: "_fqox1qyo",
    xxsmall: "_fqoxi4vh"
};
/**
 * @codegenEnd
 */ var $9203416ce7d4106b$var$useColor = function useColor(colorProp) {
    var surface = (0, $103886b9883299a1$export$1aeb4f6b93c4540d)();
    if (colorProp) return colorProp;
    if ((0, $409b8db60ea39aa2$export$2185ce37f9bdd963).hasOwnProperty(surface)) return (0, $409b8db60ea39aa2$export$2185ce37f9bdd963)[surface];
    return 'color.text';
};
/**
 * __Heading__
 *
 * Heading is a typography component used to display text in defined sizes and styles.
 *
 * @example
 *
 * ```jsx
 * <Heading size="xxlarge">Page title</Heading>
 * ```
 */ var $9203416ce7d4106b$var$Heading = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function(props, ref) {
    var children = props.children, size = props.size, id = props.id, testId = props.testId, as = props.as, colorProp = props.color;
    typeof $3ZMUU;
    var _useHeading = (0, $b11a642b52a5818c$export$97a37b1befbbf9b1)($9203416ce7d4106b$var$sizeTagMap[size]), _useHeading2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useHeading, 2), hLevel = _useHeading2[0], inferredElement = _useHeading2[1];
    var Component = as || inferredElement;
    var needsAriaRole = Component === 'div' && hLevel;
    var color = $9203416ce7d4106b$var$useColor(colorProp);
    return /*#__PURE__*/ $5FkrB.createElement(Component, {
        id: id,
        ref: ref,
        "data-testid": testId,
        role: needsAriaRole ? 'heading' : undefined,
        "aria-level": needsAriaRole ? hLevel : undefined,
        className: (0, $9192463de1c280ec$export$2e2bcd8739ae039)([
            $9203416ce7d4106b$var$styles.reset,
            $9203416ce7d4106b$var$headingSizeStyles[size],
            $9203416ce7d4106b$var$headingColorStyles[color]
        ])
    }, children);
});
var $9203416ce7d4106b$export$2e2bcd8739ae039 = $9203416ce7d4106b$var$Heading;


/* box.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $kqp0i = parcelRequire("kqp0i");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");


var $5FkrB = parcelRequire("5FkrB");
var $7c2c4d0c1c57a2e5$export$1ca2a26fecb070ae = /*#__PURE__*/ (0, $5FkrB.createContext)('elevation.surface');


var $4ef4de01d234760c$var$_excluded = [
    "as",
    "children",
    "backgroundColor",
    "padding",
    "paddingBlock",
    "paddingBlockStart",
    "paddingBlockEnd",
    "paddingInline",
    "paddingInlineStart",
    "paddingInlineEnd",
    "style",
    "testId",
    "xcss"
], $4ef4de01d234760c$var$_excluded2 = [
    "className"
];
// Can either Exclude or Extract - here we're excluding all SVG-related elements, <button> elements (handled by Pressable), and <a> elements (handled by Anchor)
// Basically just ElementType but without ComponentType, it makes sense to keep the "Type" suffix
// eslint-disable-next-line @repo/internal/react/consistent-types-definitions
var $4ef4de01d234760c$var$baseStyles = null;
var $4ef4de01d234760c$var$backgroundColorMap = {
    'color.background.accent.lime.subtlest': "_bfhkm890",
    'color.background.accent.lime.subtlest.hovered': "_bfhkd4y8",
    'color.background.accent.lime.subtlest.pressed': "_bfhkkuup",
    'color.background.accent.lime.subtler': "_bfhkz2ec",
    'color.background.accent.lime.subtler.hovered': "_bfhk1gf0",
    'color.background.accent.lime.subtler.pressed': "_bfhk2kxc",
    'color.background.accent.lime.subtle': "_bfhkbq5w",
    'color.background.accent.lime.subtle.hovered': "_bfhkfoww",
    'color.background.accent.lime.subtle.pressed': "_bfhk1jbd",
    'color.background.accent.lime.bolder': "_bfhktde4",
    'color.background.accent.lime.bolder.hovered': "_bfhknzpa",
    'color.background.accent.lime.bolder.pressed': "_bfhkh0j0",
    'color.background.accent.red.subtlest': "_bfhk1vk5",
    'color.background.accent.red.subtlest.hovered': "_bfhk1i6i",
    'color.background.accent.red.subtlest.pressed': "_bfhknbir",
    'color.background.accent.red.subtler': "_bfhk1rtt",
    'color.background.accent.red.subtler.hovered': "_bfhkaffd",
    'color.background.accent.red.subtler.pressed': "_bfhk1j5a",
    'color.background.accent.red.subtle': "_bfhkkrt9",
    'color.background.accent.red.subtle.hovered': "_bfhk1sou",
    'color.background.accent.red.subtle.pressed': "_bfhk1fnn",
    'color.background.accent.red.bolder': "_bfhkuibq",
    'color.background.accent.red.bolder.hovered': "_bfhk100f",
    'color.background.accent.red.bolder.pressed': "_bfhk1cl6",
    'color.background.accent.orange.subtlest': "_bfhkf5uh",
    'color.background.accent.orange.subtlest.hovered': "_bfhk19yr",
    'color.background.accent.orange.subtlest.pressed': "_bfhkf90x",
    'color.background.accent.orange.subtler': "_bfhk165s",
    'color.background.accent.orange.subtler.hovered': "_bfhk1ei0",
    'color.background.accent.orange.subtler.pressed': "_bfhkdpo3",
    'color.background.accent.orange.subtle': "_bfhk1kkj",
    'color.background.accent.orange.subtle.hovered': "_bfhk9mfs",
    'color.background.accent.orange.subtle.pressed': "_bfhkaxpp",
    'color.background.accent.orange.bolder': "_bfhk1qg1",
    'color.background.accent.orange.bolder.hovered': "_bfhk12qo",
    'color.background.accent.orange.bolder.pressed': "_bfhk1fyq",
    'color.background.accent.yellow.subtlest': "_bfhkibhp",
    'color.background.accent.yellow.subtlest.hovered': "_bfhkaetg",
    'color.background.accent.yellow.subtlest.pressed': "_bfhk1o1l",
    'color.background.accent.yellow.subtler': "_bfhk1773",
    'color.background.accent.yellow.subtler.hovered': "_bfhk1uw7",
    'color.background.accent.yellow.subtler.pressed': "_bfhk1r9w",
    'color.background.accent.yellow.subtle': "_bfhk8y3s",
    'color.background.accent.yellow.subtle.hovered': "_bfhk819w",
    'color.background.accent.yellow.subtle.pressed': "_bfhk1jx0",
    'color.background.accent.yellow.bolder': "_bfhk1vop",
    'color.background.accent.yellow.bolder.hovered': "_bfhkkjqf",
    'color.background.accent.yellow.bolder.pressed': "_bfhk1okt",
    'color.background.accent.green.subtlest': "_bfhkn729",
    'color.background.accent.green.subtlest.hovered': "_bfhk3utz",
    'color.background.accent.green.subtlest.pressed': "_bfhkyfny",
    'color.background.accent.green.subtler': "_bfhk1wnw",
    'color.background.accent.green.subtler.hovered': "_bfhk1e2h",
    'color.background.accent.green.subtler.pressed': "_bfhkybhx",
    'color.background.accent.green.subtle': "_bfhk1rsu",
    'color.background.accent.green.subtle.hovered': "_bfhk12e3",
    'color.background.accent.green.subtle.pressed': "_bfhk1g86",
    'color.background.accent.green.bolder': "_bfhk1e5c",
    'color.background.accent.green.bolder.hovered': "_bfhka5yi",
    'color.background.accent.green.bolder.pressed': "_bfhk1j68",
    'color.background.accent.teal.subtlest': "_bfhk7xuz",
    'color.background.accent.teal.subtlest.hovered': "_bfhk108c",
    'color.background.accent.teal.subtlest.pressed': "_bfhk1cxp",
    'color.background.accent.teal.subtler': "_bfhk1a17",
    'color.background.accent.teal.subtler.hovered': "_bfhkkwwr",
    'color.background.accent.teal.subtler.pressed': "_bfhk1jb0",
    'color.background.accent.teal.subtle': "_bfhktdv8",
    'color.background.accent.teal.subtle.hovered': "_bfhkzh8h",
    'color.background.accent.teal.subtle.pressed': "_bfhk16zl",
    'color.background.accent.teal.bolder': "_bfhk2c8p",
    'color.background.accent.teal.bolder.hovered': "_bfhkl3ve",
    'color.background.accent.teal.bolder.pressed': "_bfhktor0",
    'color.background.accent.blue.subtlest': "_bfhk1s93",
    'color.background.accent.blue.subtlest.hovered': "_bfhkdaj9",
    'color.background.accent.blue.subtlest.pressed': "_bfhkxm0g",
    'color.background.accent.blue.subtler': "_bfhk1dy8",
    'color.background.accent.blue.subtler.hovered': "_bfhk815t",
    'color.background.accent.blue.subtler.pressed': "_bfhkrwxf",
    'color.background.accent.blue.subtle': "_bfhk115i",
    'color.background.accent.blue.subtle.hovered': "_bfhk9pr4",
    'color.background.accent.blue.subtle.pressed': "_bfhknpx7",
    'color.background.accent.blue.bolder': "_bfhk16e3",
    'color.background.accent.blue.bolder.hovered': "_bfhk1vbm",
    'color.background.accent.blue.bolder.pressed': "_bfhk1xwi",
    'color.background.accent.purple.subtlest': "_bfhkp2ly",
    'color.background.accent.purple.subtlest.hovered': "_bfhkkca2",
    'color.background.accent.purple.subtlest.pressed': "_bfhk1jbm",
    'color.background.accent.purple.subtler': "_bfhk1nm4",
    'color.background.accent.purple.subtler.hovered': "_bfhkattl",
    'color.background.accent.purple.subtler.pressed': "_bfhk3nfk",
    'color.background.accent.purple.subtle': "_bfhk18ah",
    'color.background.accent.purple.subtle.hovered': "_bfhk8bp1",
    'color.background.accent.purple.subtle.pressed': "_bfhk1cd2",
    'color.background.accent.purple.bolder': "_bfhkya33",
    'color.background.accent.purple.bolder.hovered': "_bfhk1af5",
    'color.background.accent.purple.bolder.pressed': "_bfhk6cze",
    'color.background.accent.magenta.subtlest': "_bfhk8tvm",
    'color.background.accent.magenta.subtlest.hovered': "_bfhkr3zd",
    'color.background.accent.magenta.subtlest.pressed': "_bfhk1ckf",
    'color.background.accent.magenta.subtler': "_bfhkv9ra",
    'color.background.accent.magenta.subtler.hovered': "_bfhk1axx",
    'color.background.accent.magenta.subtler.pressed': "_bfhk42ri",
    'color.background.accent.magenta.subtle': "_bfhk1mi6",
    'color.background.accent.magenta.subtle.hovered': "_bfhkrwyz",
    'color.background.accent.magenta.subtle.pressed': "_bfhk6c15",
    'color.background.accent.magenta.bolder': "_bfhkc3uk",
    'color.background.accent.magenta.bolder.hovered': "_bfhk1ok8",
    'color.background.accent.magenta.bolder.pressed': "_bfhkeawv",
    'color.background.accent.gray.subtlest': "_bfhkysee",
    'color.background.accent.gray.subtlest.hovered': "_bfhkwejn",
    'color.background.accent.gray.subtlest.pressed': "_bfhk18ut",
    'color.background.accent.gray.subtler': "_bfhk7qp0",
    'color.background.accent.gray.subtler.hovered': "_bfhk10ef",
    'color.background.accent.gray.subtler.pressed': "_bfhk1rk9",
    'color.background.accent.gray.subtle': "_bfhk18j9",
    'color.background.accent.gray.subtle.hovered': "_bfhk1nv3",
    'color.background.accent.gray.subtle.pressed': "_bfhkq9tj",
    'color.background.accent.gray.bolder': "_bfhk1i45",
    'color.background.accent.gray.bolder.hovered': "_bfhkbyip",
    'color.background.accent.gray.bolder.pressed': "_bfhk1van",
    'color.background.disabled': "_bfhk187o",
    'color.background.input': "_bfhk1j9a",
    'color.background.input.hovered': "_bfhkl4ek",
    'color.background.input.pressed': "_bfhkr01l",
    'color.background.inverse.subtle': "_bfhk1vck",
    'color.background.inverse.subtle.hovered': "_bfhkmpja",
    'color.background.inverse.subtle.pressed': "_bfhk1gii",
    'color.background.neutral': "_bfhki8nm",
    'color.background.neutral.hovered': "_bfhkplhp",
    'color.background.neutral.pressed': "_bfhk1gdz",
    'color.background.neutral.subtle': "_bfhksm61",
    'color.background.neutral.subtle.hovered': "_bfhk1dpa",
    'color.background.neutral.subtle.pressed': "_bfhkfcek",
    'color.background.neutral.bold': "_bfhk1aqn",
    'color.background.neutral.bold.hovered': "_bfhk1ibz",
    'color.background.neutral.bold.pressed': "_bfhkof27",
    'color.background.selected': "_bfhk15s3",
    'color.background.selected.hovered': "_bfhkufnl",
    'color.background.selected.pressed': "_bfhknozp",
    'color.background.selected.bold': "_bfhkjmqp",
    'color.background.selected.bold.hovered': "_bfhk1q28",
    'color.background.selected.bold.pressed': "_bfhk12kk",
    'color.background.brand.subtlest': "_bfhk1gmr",
    'color.background.brand.subtlest.hovered': "_bfhk3v15",
    'color.background.brand.subtlest.pressed': "_bfhku02c",
    'color.background.brand.bold': "_bfhk1856",
    'color.background.brand.bold.hovered': "_bfhkhf2y",
    'color.background.brand.bold.pressed': "_bfhkg6ey",
    'color.background.brand.boldest': "_bfhk1o4i",
    'color.background.brand.boldest.hovered': "_bfhklefx",
    'color.background.brand.boldest.pressed': "_bfhk16k6",
    'color.background.danger': "_bfhk1gly",
    'color.background.danger.hovered': "_bfhk1yvi",
    'color.background.danger.pressed': "_bfhk1r4b",
    'color.background.danger.bold': "_bfhkybec",
    'color.background.danger.bold.hovered': "_bfhks9hg",
    'color.background.danger.bold.pressed': "_bfhk13a9",
    'color.background.warning': "_bfhk1917",
    'color.background.warning.hovered': "_bfhk19zu",
    'color.background.warning.pressed': "_bfhkzr32",
    'color.background.warning.bold': "_bfhk1kmu",
    'color.background.warning.bold.hovered': "_bfhk1spp",
    'color.background.warning.bold.pressed': "_bfhk4m4m",
    'color.background.success': "_bfhk1y9u",
    'color.background.success.hovered': "_bfhk1vfx",
    'color.background.success.pressed': "_bfhk1wl5",
    'color.background.success.bold': "_bfhkkcmj",
    'color.background.success.bold.hovered': "_bfhky7x8",
    'color.background.success.bold.pressed': "_bfhkwcbh",
    'color.background.discovery': "_bfhk6vm6",
    'color.background.discovery.hovered': "_bfhk12eq",
    'color.background.discovery.pressed': "_bfhk18vq",
    'color.background.discovery.bold': "_bfhku5tj",
    'color.background.discovery.bold.hovered': "_bfhkfqeg",
    'color.background.discovery.bold.pressed': "_bfhk1f1m",
    'color.background.information': "_bfhk19ip",
    'color.background.information.hovered': "_bfhk86z5",
    'color.background.information.pressed': "_bfhk1c1j",
    'color.background.information.bold': "_bfhkx4w0",
    'color.background.information.bold.hovered': "_bfhkq2ii",
    'color.background.information.bold.pressed': "_bfhkf89v",
    'color.blanket': "_bfhk1i5c",
    'color.blanket.selected': "_bfhk7wq0",
    'color.blanket.danger': "_bfhkrprw",
    'color.skeleton': "_bfhkizff",
    'color.skeleton.subtle': "_bfhkvkf5",
    'elevation.surface': "_bfhkvuon",
    'elevation.surface.hovered': "_bfhk19i6",
    'elevation.surface.pressed': "_bfhk13ro",
    'elevation.surface.overlay': "_bfhk1bhr",
    'elevation.surface.overlay.hovered': "_bfhk6o2t",
    'elevation.surface.overlay.pressed': "_bfhkm8nx",
    'elevation.surface.raised': "_bfhkhp5a",
    'elevation.surface.raised.hovered': "_bfhk116u",
    'elevation.surface.raised.pressed': "_bfhk14aj",
    'elevation.surface.sunken': "_bfhkhfxm",
    'utility.elevation.surface.current': "_bfhkchd4"
};
var $4ef4de01d234760c$var$CURRENT_SURFACE_CSS_VAR = "--ds-elevation-surface-current";
var $4ef4de01d234760c$var$setSurfaceTokenMap = {
    'elevation.surface': "_1q1lvuon",
    'elevation.surface.hovered': "_1q1l19i6",
    'elevation.surface.pressed': "_1q1l13ro",
    'elevation.surface.overlay': "_1q1l1bhr",
    'elevation.surface.overlay.hovered': "_1q1l6o2t",
    'elevation.surface.overlay.pressed': "_1q1lm8nx",
    'elevation.surface.raised': "_1q1lhp5a",
    'elevation.surface.raised.hovered': "_1q1l116u",
    'elevation.surface.raised.pressed': "_1q1l14aj",
    'elevation.surface.sunken': "_1q1lhfxm"
};
var $4ef4de01d234760c$var$paddingBlockStartMap = {
    'space.0': "_1q51ze3t",
    'space.025': "_1q51v77o",
    'space.050': "_1q511b66",
    'space.075': "_1q5112x7",
    'space.100': "_1q51u2gc",
    'space.150': "_1q51utpp",
    'space.200': "_1q51pxbi",
    'space.250': "_1q51v47k",
    'space.300': "_1q511ejb",
    'space.400': "_1q51xy5q",
    'space.500': "_1q511jfw",
    'space.600': "_1q51oahv",
    'space.800': "_1q51xncg",
    'space.1000': "_1q511epz"
};
var $4ef4de01d234760c$var$paddingBlockEndMap = {
    'space.0': "_85i5ze3t",
    'space.025': "_85i5v77o",
    'space.050': "_85i51b66",
    'space.075': "_85i512x7",
    'space.100': "_85i5u2gc",
    'space.150': "_85i5utpp",
    'space.200': "_85i5pxbi",
    'space.250': "_85i5v47k",
    'space.300': "_85i51ejb",
    'space.400': "_85i5xy5q",
    'space.500': "_85i51jfw",
    'space.600': "_85i5oahv",
    'space.800': "_85i5xncg",
    'space.1000': "_85i51epz"
};
var $4ef4de01d234760c$var$paddingInlineStartMap = {
    'space.0': "_bozgze3t",
    'space.025': "_bozgv77o",
    'space.050': "_bozg1b66",
    'space.075': "_bozg12x7",
    'space.100': "_bozgu2gc",
    'space.150': "_bozgutpp",
    'space.200': "_bozgpxbi",
    'space.250': "_bozgv47k",
    'space.300': "_bozg1ejb",
    'space.400': "_bozgxy5q",
    'space.500': "_bozg1jfw",
    'space.600': "_bozgoahv",
    'space.800': "_bozgxncg",
    'space.1000': "_bozg1epz"
};
var $4ef4de01d234760c$var$paddingInlineEndMap = {
    'space.0': "_y4tize3t",
    'space.025': "_y4tiv77o",
    'space.050': "_y4ti1b66",
    'space.075': "_y4ti12x7",
    'space.100': "_y4tiu2gc",
    'space.150': "_y4tiutpp",
    'space.200': "_y4tipxbi",
    'space.250': "_y4tiv47k",
    'space.300': "_y4ti1ejb",
    'space.400': "_y4tixy5q",
    'space.500': "_y4ti1jfw",
    'space.600': "_y4tioahv",
    'space.800': "_y4tixncg",
    'space.1000': "_y4ti1epz"
};
/**
 * __Box__
 *
 * A Box is a primitive component that has the design decisions of the Atlassian Design System baked in.
 * Renders a `div` by default.
 *
 * - [Examples](https://atlassian.design/components/primitives/box/examples)
 * - [Code](https://atlassian.design/components/primitives/box/code)
 * - [Usage](https://atlassian.design/components/primitives/box/usage)
 */ var $4ef4de01d234760c$var$Box = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? 'div' : _ref$as, children = _ref.children, backgroundColor = _ref.backgroundColor, padding = _ref.padding, _ref$paddingBlock = _ref.paddingBlock, paddingBlock = _ref$paddingBlock === void 0 ? padding : _ref$paddingBlock, _ref$paddingBlockStar = _ref.paddingBlockStart, paddingBlockStart = _ref$paddingBlockStar === void 0 ? paddingBlock : _ref$paddingBlockStar, _ref$paddingBlockEnd = _ref.paddingBlockEnd, paddingBlockEnd = _ref$paddingBlockEnd === void 0 ? paddingBlock : _ref$paddingBlockEnd, _ref$paddingInline = _ref.paddingInline, paddingInline = _ref$paddingInline === void 0 ? padding : _ref$paddingInline, _ref$paddingInlineSta = _ref.paddingInlineStart, paddingInlineStart = _ref$paddingInlineSta === void 0 ? paddingInline : _ref$paddingInlineSta, _ref$paddingInlineEnd = _ref.paddingInlineEnd, paddingInlineEnd = _ref$paddingInlineEnd === void 0 ? paddingInline : _ref$paddingInlineEnd, style = _ref.style, testId = _ref.testId, xcss = _ref.xcss, htmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $4ef4de01d234760c$var$_excluded);
    // This is to remove className from safeHtmlAttributes
    // @ts-ignore -- not using expect since it causes issues with help-center local consumption - className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(htmlAttributes, $4ef4de01d234760c$var$_excluded2);
    var node = /*#__PURE__*/ $5FkrB.createElement(Component, (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        style: style,
        ref: ref,
        className: (0, $9192463de1c280ec$export$2e2bcd8739ae039)([
            "_19itglyw _vchhusvi _r06hglyw",
            backgroundColor && $4ef4de01d234760c$var$backgroundColorMap[backgroundColor],
            backgroundColor && $4ef4de01d234760c$var$isSurfaceToken(backgroundColor) && $4ef4de01d234760c$var$setSurfaceTokenMap[backgroundColor],
            paddingBlockStart && $4ef4de01d234760c$var$paddingBlockStartMap[paddingBlockStart],
            paddingBlockEnd && $4ef4de01d234760c$var$paddingBlockEndMap[paddingBlockEnd],
            paddingInlineStart && $4ef4de01d234760c$var$paddingInlineStartMap[paddingInlineStart],
            paddingInlineEnd && $4ef4de01d234760c$var$paddingInlineEndMap[paddingInlineEnd],
            xcss
        ])
    }, safeHtmlAttributes, {
        "data-testid": testId
    }), children);
    if (backgroundColor) return /*#__PURE__*/ $5FkrB.createElement((0, $7c2c4d0c1c57a2e5$export$1ca2a26fecb070ae).Provider, {
        value: backgroundColor
    }, node);
    return node;
});
var $4ef4de01d234760c$export$2e2bcd8739ae039 = $4ef4de01d234760c$var$Box;
function $4ef4de01d234760c$var$isSurfaceToken(backgroundColor) {
    return backgroundColor in $4ef4de01d234760c$var$setSurfaceTokenMap;
}

/* text.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $5FkrB = parcelRequire("5FkrB");


var $afMOk = parcelRequire("afMOk");

var $5FkrB = parcelRequire("5FkrB");
var $e4a052dade122de3$var$HasTextAncestorContext = /*#__PURE__*/ (0, $5FkrB.createContext)(false);
var $e4a052dade122de3$export$9322276ec105d055 = function useHasTextAncestor() {
    return (0, $5FkrB.useContext)($e4a052dade122de3$var$HasTextAncestorContext);
};
var $e4a052dade122de3$export$ae933c6cbe5643ad = $e4a052dade122de3$var$HasTextAncestorContext.Provider;



var $5FkrB = parcelRequire("5FkrB");

var $296bf42a62e0ce42$export$1aeb4f6b93c4540d = function useSurface() {
    return (0, $5FkrB.useContext)((0, $7c2c4d0c1c57a2e5$export$1ca2a26fecb070ae));
};
(0, $7c2c4d0c1c57a2e5$export$1ca2a26fecb070ae).displayName = 'SurfaceProvider';


var $b338a934a9edecef$var$asAllowlist = [
    'span',
    'p',
    'strong',
    'em'
];
/**
 * Custom hook designed to abstract the parsing of the color props and make it clearer in the future how color is reconciled between themes and tokens.
 */ var $b338a934a9edecef$var$useColor = function useColor(colorProp, hasTextAncestor) {
    var surface = (0, $296bf42a62e0ce42$export$1aeb4f6b93c4540d)();
    if (colorProp === 'inherit') return undefined;
    if (colorProp) return colorProp;
    if (hasTextAncestor) return undefined;
    if ($b338a934a9edecef$export$2185ce37f9bdd963.hasOwnProperty(surface)) return $b338a934a9edecef$export$2185ce37f9bdd963[surface];
    return 'color.text';
};
var $b338a934a9edecef$var$styles = {
    root: "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _1i4qfg65",
    'as.strong': "_k48pwu06",
    'as.em': "_zg8l1m30",
    'textAlign.center': "_y3gn1h6o",
    'textAlign.end': "_y3gnh9n0",
    'textAlign.start': "_y3gnv2br",
    truncation: "_1reo15vq _18m915vq _1e0ccj1k _sudp1e54",
    breakAll: "_1nmz9jpi"
};
var $b338a934a9edecef$var$fontSizeMap = {
    medium: "_11c8fhey",
    large: "_11c81d4k",
    small: "_11c8wadc"
};
var $b338a934a9edecef$var$fontWeightMap = {
    bold: "_k48pwu06",
    medium: "_k48p1wq8",
    regular: "_k48pi7a9",
    semibold: "_k48p1pd9"
};
var $b338a934a9edecef$var$textColorMap = {
    'color.text': "_syazi7uo",
    'color.text.accent.lime': "_syaz1tco",
    'color.text.accent.lime.bolder': "_syaz1ik3",
    'color.text.accent.red': "_syaz9lu1",
    'color.text.accent.red.bolder': "_syazhwvp",
    'color.text.accent.orange': "_syazp1lv",
    'color.text.accent.orange.bolder': "_syaz7i1p",
    'color.text.accent.yellow': "_syazfb2s",
    'color.text.accent.yellow.bolder': "_syazekll",
    'color.text.accent.green': "_syazh55r",
    'color.text.accent.green.bolder': "_syaz1y78",
    'color.text.accent.teal': "_syaz17qg",
    'color.text.accent.teal.bolder': "_syaz12v7",
    'color.text.accent.blue': "_syaz16jw",
    'color.text.accent.blue.bolder': "_syaz1kyx",
    'color.text.accent.purple': "_syazqmo9",
    'color.text.accent.purple.bolder': "_syaz1mn1",
    'color.text.accent.magenta': "_syaz1s8m",
    'color.text.accent.magenta.bolder': "_syaz1qur",
    'color.text.accent.gray': "_syaz1sqi",
    'color.text.accent.gray.bolder': "_syaz1tmo",
    'color.text.disabled': "_syaz1gmx",
    'color.text.inverse': "_syaz15cr",
    'color.text.selected': "_syaz6x5g",
    'color.text.brand': "_syaz1oa5",
    'color.text.danger': "_syaz1tmw",
    'color.text.warning': "_syaz1xn9",
    'color.text.warning.inverse': "_syaz1yd3",
    'color.text.success': "_syazgsak",
    'color.text.discovery': "_syazdv2p",
    'color.text.information': "_syazu3tg",
    'color.text.subtlest': "_syaz1rpy",
    'color.text.subtle': "_syazazsu",
    'color.link': "_syaz13af",
    'color.link.pressed': "_syaz12zz",
    'color.link.visited': "_syaz1ra0",
    'color.link.visited.pressed': "_syaz17z1"
};
var $b338a934a9edecef$export$2185ce37f9bdd963 = {
    'color.background.neutral.bold': 'color.text.inverse',
    'color.background.neutral.bold.hovered': 'color.text.inverse',
    'color.background.neutral.bold.pressed': 'color.text.inverse',
    'color.background.selected.bold': 'color.text.inverse',
    'color.background.selected.bold.hovered': 'color.text.inverse',
    'color.background.selected.bold.pressed': 'color.text.inverse',
    'color.background.brand.bold': 'color.text.inverse',
    'color.background.brand.bold.hovered': 'color.text.inverse',
    'color.background.brand.bold.pressed': 'color.text.inverse',
    'color.background.brand.boldest': 'color.text.inverse',
    'color.background.brand.boldest.hovered': 'color.text.inverse',
    'color.background.brand.boldest.pressed': 'color.text.inverse',
    'color.background.danger.bold': 'color.text.inverse',
    'color.background.danger.bold.hovered': 'color.text.inverse',
    'color.background.danger.bold.pressed': 'color.text.inverse',
    'color.background.warning.bold': 'color.text.warning.inverse',
    'color.background.warning.bold.hovered': 'color.text.warning.inverse',
    'color.background.warning.bold.pressed': 'color.text.warning.inverse',
    'color.background.success.bold': 'color.text.inverse',
    'color.background.success.bold.hovered': 'color.text.inverse',
    'color.background.success.bold.pressed': 'color.text.inverse',
    'color.background.discovery.bold': 'color.text.inverse',
    'color.background.discovery.bold.hovered': 'color.text.inverse',
    'color.background.discovery.bold.pressed': 'color.text.inverse',
    'color.background.information.bold': 'color.text.inverse',
    'color.background.information.bold.hovered': 'color.text.inverse',
    'color.background.information.bold.pressed': 'color.text.inverse'
};
/**
 * __Text__
 *
 * Text is a primitive component that has the Atlassian Design System's design guidelines baked in.
 * This includes considerations for text attributes such as color, font size, font weight, and line height.
 * It renders a `span` by default.
 *
 * @internal
 */ var $b338a934a9edecef$var$Text = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? 'span' : _ref$as, colorProp = _ref.color, align = _ref.align, testId = _ref.testId, id = _ref.id, size = _ref.size, weight = _ref.weight, maxLines = _ref.maxLines, xcss = _ref.xcss, children = _ref.children;
    (0, $afMOk.default)($b338a934a9edecef$var$asAllowlist.includes(Component), "@atlaskit/primitives: Text received an invalid \"as\" value of \"".concat(Component, "\""));
    var hasTextAncestor = (0, $e4a052dade122de3$export$9322276ec105d055)();
    var color = $b338a934a9edecef$var$useColor(colorProp, hasTextAncestor);
    if (!size && !hasTextAncestor) size = 'medium';
    var component = /*#__PURE__*/ $5FkrB.createElement(Component, {
        id: id,
        className: (0, $9192463de1c280ec$export$2e2bcd8739ae039)([
            $b338a934a9edecef$var$styles.root,
            size && $b338a934a9edecef$var$fontSizeMap[size],
            color && $b338a934a9edecef$var$textColorMap[color],
            maxLines && $b338a934a9edecef$var$styles.truncation,
            maxLines === 1 && $b338a934a9edecef$var$styles.breakAll,
            align && $b338a934a9edecef$var$styles["textAlign.".concat(align)],
            weight && $b338a934a9edecef$var$fontWeightMap[weight],
            Component === 'em' && $b338a934a9edecef$var$styles['as.em'],
            Component === 'strong' && $b338a934a9edecef$var$styles['as.strong'],
            xcss
        ]),
        style: {
            WebkitLineClamp: maxLines
        },
        "data-testid": testId,
        ref: ref
    }, children);
    if (hasTextAncestor) // no need to re-apply context if the text is already wrapped
    return component;
    return /*#__PURE__*/ $5FkrB.createElement((0, $e4a052dade122de3$export$ae933c6cbe5643ad), {
        value: true
    }, component);
});
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$b338a934a9edecef$export$2e2bcd8739ae039 = $b338a934a9edecef$var$Text;


/* spinner.tsx generated by @compiled/babel-plugin v0.39.1 */ 

var $5FkrB = parcelRequire("5FkrB");

var $5FkrB = parcelRequire("5FkrB");
var $b22f9bcaf04feab4$var$interactionContext = /*#__PURE__*/ (0, $5FkrB.createContext)(null);
var $b22f9bcaf04feab4$export$2e2bcd8739ae039 = $b22f9bcaf04feab4$var$interactionContext;


var $400a8cdb1499473a$export$4e9f1640bbe7a1a8 = {
    xsmall: 12,
    small: 16,
    medium: 24,
    large: 48,
    xlarge: 96
};


/**
 * Returns the appropriate circle stroke color.
 */ function $850617ac1366743f$var$getStrokeColor(appearance) {
    return appearance === 'inherit' ? "var(--ds-icon-subtle, #505258)" : "var(--ds-icon-inverse, #FFFFFF)";
}
var $850617ac1366743f$var$rotate = null;
/**
 * There are three parts to the load in animation:
 * 1. Accelerated spin
 * 2. Stretch the spinner line
 */ var $850617ac1366743f$var$loadIn = null;
var $850617ac1366743f$var$styles = {
    rotateStyles: "_j7hqsf8s _5sag12kz _tip812c5 _1pgl2qsq _8hrz1h6o",
    loadInStyles: "_j7hq1ky6 _5sag9cwz _1pgl1ytf _1o51q7pw",
    wrapperStyles: "_1e0c116y _s7n4nkob",
    circleStyles: "_lswuglyw _7ljx1dhp _1snbbs82 _jcxd7g3v _1tjm1onz"
};
/**
 * `useLayoutEffect` is being used in SSR safe form. On the server, this work doesn’t need to run.
 * `useEffect` is used in-place, because `useEffect` is not run on the server and it matches types
 * which makes things simpler than doing an `isServer` check or a `null` check.
 *
 * @see https://hello.atlassian.net/wiki/spaces/DST/pages/2081696628/DSTDACI-010+-+Interaction+Tracing+hooks+in+DS+components
 */ var $850617ac1366743f$var$useLayoutEffect = typeof window === 'undefined' ? (0, $5FkrB.useEffect) : (0, $5FkrB.useLayoutEffect);
/**
 * __Spinner__
 *
 * A spinner is an animated spinning icon that lets users know content is being loaded.
 *
 * - [Examples](https://atlassian.design/components/spinner/examples)
 * - [Code](https://atlassian.design/components/spinner/code)
 * - [Usage](https://atlassian.design/components/spinner/usage)
 */ var $850617ac1366743f$var$Spinner = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).forwardRef(function Spinner(_ref, ref) {
    var _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'inherit' : _ref$appearance, _ref$delay = _ref.delay, delay = _ref$delay === void 0 ? 0 : _ref$delay, interactionName = _ref.interactionName, label = _ref.label, _ref$size = _ref.size, providedSize = _ref$size === void 0 ? 'medium' : _ref$size, testId = _ref.testId;
    var size = typeof providedSize === 'number' ? providedSize : (0, $400a8cdb1499473a$export$4e9f1640bbe7a1a8)[providedSize];
    var animationDelay = "".concat(delay, "ms");
    var stroke = $850617ac1366743f$var$getStrokeColor(appearance);
    var context = (0, $5FkrB.useContext)((0, $b22f9bcaf04feab4$export$2e2bcd8739ae039));
    $850617ac1366743f$var$useLayoutEffect(function() {
        if (context != null) return context.hold(interactionName);
    }, [
        context,
        interactionName
    ]);
    /**
   * The Spinner animation uses a combination of two
   * css animations on two separate elements.
   */ return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("span", {
        "data-testid": testId ? "".concat(testId, "-wrapper") : 'spinner-wrapper',
        style: {
            animationDelay: animationDelay,
            width: size,
            height: size
        },
        className: (0, $9192463de1c280ec$export$2e2bcd8739ae039)([
            $850617ac1366743f$var$styles.wrapperStyles,
            $850617ac1366743f$var$styles.rotateStyles
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("svg", {
        height: size,
        width: size,
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg",
        "data-testid": testId,
        ref: ref,
        "aria-label": label || undefined,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            animationDelay: animationDelay
        },
        role: label ? 'img' : 'none',
        className: (0, $9192463de1c280ec$export$2e2bcd8739ae039)([
            $850617ac1366743f$var$styles.loadInStyles
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("circle", {
        cx: "8",
        cy: "8",
        r: "7",
        style: {
            stroke: stroke
        },
        className: (0, $9192463de1c280ec$export$2e2bcd8739ae039)([
            $850617ac1366743f$var$styles.circleStyles
        ])
    })));
}));
var $850617ac1366743f$export$2e2bcd8739ae039 = $850617ac1366743f$var$Spinner;


/* actions-container.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $5FkrB = parcelRequire("5FkrB");

var $44124a981e9227cb$var$actionsStyles = null;
/**
 * __Actions container__
 *
 * A container for actions: primary action, secondary action, and tertiary action.
 *
 * @internal
 */ var $44124a981e9227cb$var$ActionsContainer = function ActionsContainer(_ref) {
    var children = _ref.children;
    return /*#__PURE__*/ $5FkrB.createElement("div", {
        className: (0, $9192463de1c280ec$export$2e2bcd8739ae039)([
            "_1e0c1txw _4cvr1h6o _1bah1h6o _6rthu2gc _bozg1jfw"
        ])
    }, children);
};
var $44124a981e9227cb$export$2e2bcd8739ae039 = $44124a981e9227cb$var$ActionsContainer;


/* container.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $5FkrB = parcelRequire("5FkrB");

var $3a73f390fa3336aa$var$containerStyles = null;
/* Use max-width so the component can shrink on smaller viewports. */ var $3a73f390fa3336aa$var$wideContainerStyles = null;
var $3a73f390fa3336aa$var$narrowContainerStyles = null;
/**
 * __Container__
 *
 * Upper level container for Empty State.
 *
 * @internal
 */ var $3a73f390fa3336aa$var$Container = function Container(_ref) {
    var children = _ref.children, width = _ref.width, testId = _ref.testId;
    return /*#__PURE__*/ $5FkrB.createElement("div", {
        "data-testid": testId,
        className: (0, $9192463de1c280ec$export$2e2bcd8739ae039)([
            "_6rthoahv _1pfhoahv _12l21wug _ahbq1wug _y3gn1h6o",
            width === 'narrow' ? "_p12fko4j" : "_p12f1pl1"
        ])
    }, children);
};
var $3a73f390fa3336aa$export$2e2bcd8739ae039 = $3a73f390fa3336aa$var$Container;


/* image.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $25nEq = parcelRequire("25nEq");

var $5FkrB = parcelRequire("5FkrB");
/**
 * Returns a CSS custom property value with an optional suffix & prefix.
 * Prefix will only be added if there is a suffix.
 * If the value is undefined a fallback value will be returned to prevent children inheriting parent values.
 *
 * @param value
 * @param suffix
 * @param prefix
 */ function $7dec43d9cc7ffae8$export$2e2bcd8739ae039(value, suffix, prefix) {
    if (value != undefined) {
        if (suffix) {
            if (prefix) return prefix + value + suffix;
            return value + suffix;
        }
        return value;
    }
    // Currently React trims these values so we can't use a space " " to block the value.
    // Instead we use a CSS variable that doesn't exist which falls back to " ".
    // Bug raised here: https://github.com/facebook/react/issues/20497
    return 'var(--c-, )';
}


function $3cc2c4b28ad7dbd4$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $3cc2c4b28ad7dbd4$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $3cc2c4b28ad7dbd4$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $3cc2c4b28ad7dbd4$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $3cc2c4b28ad7dbd4$var$CSS_VAR_MAX_WIDTH = '--max-width';
var $3cc2c4b28ad7dbd4$var$CSS_VAR_MAX_HEIGHT = '--max-height';
var $3cc2c4b28ad7dbd4$var$imageStyles = null;
/**
 * __Image__
 *
 * Image in Empty State.
 *
 * @internal
 */ var $3cc2c4b28ad7dbd4$var$Image = function Image(_ref) {
    var maxHeight = _ref.maxHeight, maxWidth = _ref.maxWidth, _ref$height = _ref.height, height = _ref$height === void 0 ? 'auto' : _ref$height, _ref$width = _ref.width, width = _ref$width === void 0 ? 'auto' : _ref$width, src = _ref.src;
    return /*#__PURE__*/ $5FkrB.createElement("img", {
        width: width,
        height: height,
        alt: "",
        role: "presentation",
        src: src,
        className: (0, $9192463de1c280ec$export$2e2bcd8739ae039)([
            "_1e0c1ule _p12f163m _c71l649k _6rth1ejb _1pfhidpf _12l21wug _ahbq1wug"
        ]),
        style: $3cc2c4b28ad7dbd4$var$_objectSpread($3cc2c4b28ad7dbd4$var$_objectSpread({}, (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, $3cc2c4b28ad7dbd4$var$CSS_VAR_MAX_WIDTH, "".concat(maxWidth, "px")), $3cc2c4b28ad7dbd4$var$CSS_VAR_MAX_HEIGHT, "".concat(maxHeight, "px"))), {}, {
            "--_11x3y0": (0, $7dec43d9cc7ffae8$export$2e2bcd8739ae039)("var(".concat($3cc2c4b28ad7dbd4$var$CSS_VAR_MAX_WIDTH, ")")),
            "--_zsxb2b": (0, $7dec43d9cc7ffae8$export$2e2bcd8739ae039)("var(".concat($3cc2c4b28ad7dbd4$var$CSS_VAR_MAX_HEIGHT, ")"))
        })
    });
};
var $3cc2c4b28ad7dbd4$export$2e2bcd8739ae039 = $3cc2c4b28ad7dbd4$var$Image;


/* spinner-container.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $5FkrB = parcelRequire("5FkrB");

var $a934e1bd7cb5d22f$var$spinnerContainerStyles = null;
/**
 * __Spinner container__
 *
 * A spinner container for loading state of Empty State.
 *
 * @internal
 */ var $a934e1bd7cb5d22f$var$SpinnerContainer = function SpinnerContainer(_ref) {
    var children = _ref.children;
    return /*#__PURE__*/ $5FkrB.createElement("div", {
        className: (0, $9192463de1c280ec$export$2e2bcd8739ae039)([
            "_1bsb1ejb _ahbqpxbi"
        ])
    }, children);
};
var $a934e1bd7cb5d22f$export$2e2bcd8739ae039 = $a934e1bd7cb5d22f$var$SpinnerContainer;


/**
 * __Empty state__
 *
 * A component used for presenting various empty states.
 * e.g. (no items, empty search, broken link, welcome screen etc.)
 *
 * @example
 * ```tsx
 * import EmptyState from '@atlaskit/empty-state';
 *
 * // An example of a 404 state
 * export default () => {
 *  <EmptyState
 *   header="Page not found"
 *   imageUrl="https://cdn.io/images/404"
 *   description="Looks like you've stumbled off track. Sorry about that! This page either doesn't exist or has been removed."
 *   primaryAction={<Button appearance="primary">Home Page</Button>}
 *   secondaryAction={<Button>Report a problem</Button>}
 *  />;
 * };
 * ```
 */ var $9a28bb334efe6ee5$var$EmptyState = function EmptyState(_ref) {
    var buttonGroupLabel = _ref.buttonGroupLabel, description = _ref.description, header = _ref.header, _ref$headingLevel = _ref.headingLevel, headingLevel = _ref$headingLevel === void 0 ? 4 : _ref$headingLevel, _ref$headingSize = _ref.headingSize, headingSize = _ref$headingSize === void 0 ? 'medium' : _ref$headingSize, imageHeight = _ref.imageHeight, imageUrl = _ref.imageUrl, imageWidth = _ref.imageWidth, isLoading = _ref.isLoading, _ref$maxImageHeight = _ref.maxImageHeight, maxImageHeight = _ref$maxImageHeight === void 0 ? 160 : _ref$maxImageHeight, _ref$maxImageWidth = _ref.maxImageWidth, maxImageWidth = _ref$maxImageWidth === void 0 ? 160 : _ref$maxImageWidth, primaryAction = _ref.primaryAction, renderImage = _ref.renderImage, secondaryAction = _ref.secondaryAction, width = _ref.width, tertiaryAction = _ref.tertiaryAction, testId = _ref.testId;
    var actionsContainer = primaryAction || secondaryAction || isLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $44124a981e9227cb$export$2e2bcd8739ae039), null, primaryAction && secondaryAction ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $385d7f6a627d2e5f$export$2e2bcd8739ae039), {
        label: buttonGroupLabel || 'Button group',
        testId: testId && "".concat(testId, "-button-group")
    }, secondaryAction, primaryAction) : primaryAction || secondaryAction, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $a934e1bd7cb5d22f$export$2e2bcd8739ae039), null, isLoading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $850617ac1366743f$export$2e2bcd8739ae039), {
        testId: "empty-state-spinner"
    }))) : null;
    var tag = "h".concat(headingLevel > 0 && headingLevel < 7 ? headingLevel : headingLevel > 6 ? 6 : 4);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $3a73f390fa3336aa$export$2e2bcd8739ae039), {
        testId: testId,
        width: width || 'wide'
    }, imageUrl ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $3cc2c4b28ad7dbd4$export$2e2bcd8739ae039), {
        src: imageUrl,
        maxWidth: maxImageWidth,
        maxHeight: maxImageHeight,
        width: imageWidth,
        height: imageHeight
    }) : renderImage && renderImage({
        maxImageWidth: maxImageWidth,
        maxImageHeight: maxImageHeight,
        imageWidth: imageWidth,
        imageHeight: imageHeight
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $4ef4de01d234760c$export$2e2bcd8739ae039), {
        paddingBlockEnd: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $9203416ce7d4106b$export$2e2bcd8739ae039), {
        size: headingSize,
        as: tag
    }, header)), description && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $4ef4de01d234760c$export$2e2bcd8739ae039), {
        paddingBlockEnd: "space.300"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $b338a934a9edecef$export$2e2bcd8739ae039), {
        as: "p"
    }, description)), actionsContainer, tertiaryAction);
};
var $9a28bb334efe6ee5$export$2e2bcd8739ae039 = $9a28bb334efe6ee5$var$EmptyState;



/* index.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $kqp0i = parcelRequire("kqp0i");

var $1Vcia = parcelRequire("1Vcia");

var $iYJcE = parcelRequire("iYJcE");

var $970q7 = parcelRequire("970q7");

var $5FkrB = parcelRequire("5FkrB");

var $iBNQo = parcelRequire("iBNQo");
var $6Wx3K = parcelRequire("6Wx3K");

var $6JfQX = parcelRequire("6JfQX");

var $dUWEU = parcelRequire("dUWEU");

var $kqp0i = parcelRequire("kqp0i");

var $25nEq = parcelRequire("25nEq");

var $1Vcia = parcelRequire("1Vcia");

var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");

var $7QpUe = parcelRequire("7QpUe");

var $dUWEU = parcelRequire("dUWEU");

var $lmG37 = parcelRequire("lmG37");

var $iO8GM = parcelRequire("iO8GM");

var $eVb4V = parcelRequire("eVb4V");

var $2oF7I = parcelRequire("2oF7I");

var $h7zHk = parcelRequire("h7zHk");

var $8KvTb = parcelRequire("8KvTb");

var $5FkrB = parcelRequire("5FkrB");

var $7QpUe = parcelRequire("7QpUe");

var $5FkrB = parcelRequire("5FkrB");

var $fC8ib = parcelRequire("fC8ib");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");
var $0a55f707b07eda25$export$da4f61fd78d35243 = /*#__PURE__*/ function() {
    function LayerNode(id, parent) {
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, LayerNode);
        this.id = id;
        this.childNodes = [];
        this.parent = parent;
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(LayerNode, [
        {
            key: "addChild",
            value: function addChild(node) {
                this.childNodes.push(node);
            }
        },
        {
            key: "removeChild",
            value: function removeChild(node) {
                this.childNodes = this.childNodes.filter(function(child) {
                    return child.id !== node.id;
                });
            }
        },
        {
            key: "getLevel",
            value: function getLevel() {
                if (!this.parent) return 1;
                return this.parent.getLevel() + 1;
            }
        },
        {
            key: "getHeight",
            value: function getHeight() {
                if (this.childNodes.length === 0) return 1;
                return Math.max.apply(Math, (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(this.childNodes.map(function(child) {
                    return child.getHeight();
                }))) + 1;
            }
        }
    ]);
}();


var $a894418b37f9339d$export$650d12d3c2ddb8fc = /*#__PURE__*/ (0, $5FkrB.createContext)(0);
var $a894418b37f9339d$export$18f4d8b5b3a77f59 = /*#__PURE__*/ (0, $5FkrB.createContext)({
    current: null
});
var $a894418b37f9339d$export$fa973f110e8f6ca8 = /*#__PURE__*/ (0, $5FkrB.createContext)({
    current: null
});
/**
 *
 *  @internal
 * Context Provider Component which provider the current level of nested layers
 * It handles level management when it mounts and unmounts
 *
 */ var $a894418b37f9339d$var$LevelProvider = function LevelProvider(_ref) {
    var children = _ref.children, currentLevel = _ref.currentLevel, levelNode = _ref.node;
    (0, $5FkrB.useEffect)(function() {
        var levelNodeSafe = levelNode.current;
        var parentNode = levelNodeSafe.parent;
        parentNode === null || parentNode === void 0 || parentNode.addChild(levelNodeSafe);
        return function() {
            parentNode === null || parentNode === void 0 || parentNode.removeChild(levelNodeSafe);
        };
    }, [
        levelNode
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement($a894418b37f9339d$export$650d12d3c2ddb8fc.Provider, {
        value: currentLevel
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement($a894418b37f9339d$export$18f4d8b5b3a77f59.Provider, {
        value: levelNode
    }, children));
};
var $a894418b37f9339d$export$7c885f891c940977 = function Layering(_ref2) {
    var children = _ref2.children, _ref2$isDisabled = _ref2.isDisabled, isDisabled = _ref2$isDisabled === void 0 ? true : _ref2$isDisabled;
    var currentLevel = (0, $5FkrB.useContext)($a894418b37f9339d$export$650d12d3c2ddb8fc);
    var parentNode = (0, $5FkrB.useContext)($a894418b37f9339d$export$18f4d8b5b3a77f59);
    // eslint-disable-next-line  @repo/internal/react/disallow-unstable-values
    var newNode = (0, $5FkrB.useRef)(new (0, $0a55f707b07eda25$export$da4f61fd78d35243)(Math.random().toString(36), parentNode.current));
    if (isDisabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).Fragment, null, children);
    var isNested = currentLevel > 0;
    var content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement($a894418b37f9339d$var$LevelProvider, {
        currentLevel: currentLevel + 1,
        node: newNode
    }, children);
    return isNested ? content : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement($a894418b37f9339d$export$fa973f110e8f6ca8.Provider, {
        value: newNode
    }, content);
};


var $06d0721b7d6dfd7c$var$ESCAPE = 'Escape';
function $06d0721b7d6dfd7c$export$4a4bf067ea9e7886(_ref) {
    var onClose = _ref.onClose, isDisabled = _ref.isDisabled;
    var escapePressed = (0, $5FkrB.useRef)(false);
    var _useLayering = $06d0721b7d6dfd7c$export$c8b4d54e03dee6ed(), isLayerDisabled = _useLayering.isLayerDisabled;
    var onKeyDown = (0, $5FkrB.useCallback)(function(e) {
        var isDisabledLayer = isLayerDisabled();
        if (isDisabled || escapePressed.current || e.key !== $06d0721b7d6dfd7c$var$ESCAPE || isDisabledLayer) // We're either already handling the key down event or it's not escape or disabled.
        // Bail early!
        return;
        escapePressed.current = true;
        onClose(e);
    }, [
        onClose,
        isDisabled,
        isLayerDisabled
    ]);
    var onKeyUp = (0, $5FkrB.useCallback)(function() {
        escapePressed.current = false;
    }, []);
    (0, $5FkrB.useEffect)(function() {
        return (0, $7QpUe.bindAll)(window, [
            {
                type: 'keydown',
                listener: onKeyDown
            },
            {
                type: 'keyup',
                listener: onKeyUp
            }
        ], {
            capture: false
        });
    }, [
        onKeyDown,
        onKeyUp
    ]);
}
function $06d0721b7d6dfd7c$export$c8b4d54e03dee6ed() {
    var currentLevel = (0, $5FkrB.useContext)((0, $a894418b37f9339d$export$650d12d3c2ddb8fc));
    var layerNode = (0, $5FkrB.useContext)((0, $a894418b37f9339d$export$18f4d8b5b3a77f59));
    var rootNode = (0, $5FkrB.useContext)((0, $a894418b37f9339d$export$fa973f110e8f6ca8));
    var isLayerDisabled = (0, $5FkrB.useCallback)(function() {
        // This is an impossible case, added for type safety
        if (!(layerNode !== null && layerNode !== void 0 && layerNode.current) || !(rootNode !== null && rootNode !== void 0 && rootNode.current)) return false;
        return layerNode.current.getLevel() < rootNode.current.getHeight();
    }, [
        layerNode,
        rootNode
    ]);
    var getTopLevel = (0, $5FkrB.useCallback)(function() {
        return rootNode !== null && rootNode !== void 0 && rootNode.current ? rootNode.current.getHeight() : null;
    }, [
        rootNode
    ]);
    return {
        currentLevel: currentLevel,
        isLayerDisabled: isLayerDisabled,
        getTopLevel: getTopLevel
    };
}



var $9Zzpd = parcelRequire("9Zzpd");

var $jnGKX = parcelRequire("jnGKX");

var $kxpsr = parcelRequire("kxpsr");
// Reds
var $b93ef7db89830714$export$4b84fd0e2c617bd = '#FFEBE6';
var $b93ef7db89830714$export$b34b069eff244586 = '#FFBDAD';
var $b93ef7db89830714$export$be802dd0d8b57f35 = '#FF8F73';
var $b93ef7db89830714$export$60847d42f9da92a6 = '#FF7452';
var $b93ef7db89830714$export$4a7404f376229999 = '#FF5630';
var $b93ef7db89830714$export$2010d0fb4295b346 = '#DE350B';
var $b93ef7db89830714$export$2837b5a1a71d5c02 = '#BF2600';
var $b93ef7db89830714$export$8d9596b529bbb9cf = '#FFFAE6';
var $b93ef7db89830714$export$41060a744ab0b7ae = '#FFF0B3';
var $b93ef7db89830714$export$1cc05bbbf340e559 = '#FFE380';
var $b93ef7db89830714$export$5aae31392d72caaa = '#FFC400';
var $b93ef7db89830714$export$c6930421db9fa514 = '#FFAB00';
var $b93ef7db89830714$export$59619663aa6500fb = '#FF991F';
var $b93ef7db89830714$export$874739ea9e379ab6 = '#FF8B00';
var $b93ef7db89830714$export$8a6341c32b6a3ee6 = '#E3FCEF';
var $b93ef7db89830714$export$69a3bf21b9686c2b = '#ABF5D1';
var $b93ef7db89830714$export$afbce1382ec95f73 = '#79F2C0';
var $b93ef7db89830714$export$747d86715d4175de = '#57D9A3';
var $b93ef7db89830714$export$940e1f69e873f202 = '#36B37E';
var $b93ef7db89830714$export$a49394138f7b8e85 = '#00875A';
var $b93ef7db89830714$export$6fa04827ac68a4fb = '#006644';
var $b93ef7db89830714$export$226de0355ed012f8 = '#DEEBFF';
var $b93ef7db89830714$export$8c13c2ee36917869 = '#B3D4FF';
var $b93ef7db89830714$export$ecfc1dff386a3e7a = '#4C9AFF';
var $b93ef7db89830714$export$215b7063051591f1 = '#2684FF';
var $b93ef7db89830714$export$e62e8919cca44969 = '#0065FF';
var $b93ef7db89830714$export$b3de0ae08da2ce64 = '#0052CC';
var $b93ef7db89830714$export$a6ee3d71bc067634 = '#0747A6';
var $b93ef7db89830714$export$67f15409e87642a1 = '#669DF1';
var $b93ef7db89830714$export$f0539dbc42dbb067 = '#8FB8F6';
var $b93ef7db89830714$export$363e4475840015bb = '#EAE6FF';
var $b93ef7db89830714$export$4b0a4417ed59760f = '#C0B6F2';
var $b93ef7db89830714$export$6011520a64d9a187 = '#998DD9';
var $b93ef7db89830714$export$a7175d4e9206bc80 = '#8777D9';
var $b93ef7db89830714$export$b48405b95304b5a1 = '#6554C0';
var $b93ef7db89830714$export$c71e4279dd54a18d = '#5243AA';
var $b93ef7db89830714$export$147899de772240ec = '#403294';
var $b93ef7db89830714$export$2cf711fe14c66f06 = '#E6FCFF';
var $b93ef7db89830714$export$7a8f4d33f6f9772c = '#B3F5FF';
var $b93ef7db89830714$export$776c9c497ef08533 = '#79E2F2';
var $b93ef7db89830714$export$69cb3ca10c1e330e = '#00C7E6';
var $b93ef7db89830714$export$9dc1ef0f3f48059b = '#00B8D9';
var $b93ef7db89830714$export$7c835c78b6fcdef8 = '#00A3BF';
var $b93ef7db89830714$export$6036577f95c3877e = '#008DA6';
var $b93ef7db89830714$export$29a4f05edc054374 = '#FFFFFF';
var $b93ef7db89830714$export$e655ef011c4aa1a2 = '#FAFBFC';
var $b93ef7db89830714$export$9fdfb749e33cdf97 = '#F4F5F7';
var $b93ef7db89830714$export$3e51e8f1440314ba = '#EBECF0';
var $b93ef7db89830714$export$1ce2d1575d444ceb = '#DFE1E6';
var $b93ef7db89830714$export$8754fc7e6d8b3000 = '#C1C7D0';
var $b93ef7db89830714$export$c2e91cbeada39b8b = '#B3BAC5';
var $b93ef7db89830714$export$5f71e19f3a7ad9de = '#A5ADBA';
var $b93ef7db89830714$export$eaa8c8a70ac22806 = '#97A0AF';
var $b93ef7db89830714$export$7c87d337fb91a97d = '#8993A4';
var $b93ef7db89830714$export$d6447c357493214f = '#7A869A';
var $b93ef7db89830714$export$f563ee71e9ee74cd = '#6B778C';
var $b93ef7db89830714$export$e2ef2124cf4024b1 = '#5E6C84';
var $b93ef7db89830714$export$eece5f492e429f08 = '#505F79';
var $b93ef7db89830714$export$c39c0fe0f26207ae = '#42526E';
var $b93ef7db89830714$export$7090862dc3038a9f = '#344563';
var $b93ef7db89830714$export$ad0bacf983b7ddaa = '#253858';
var $b93ef7db89830714$export$7d61b15e0da132af = '#172B4D';
var $b93ef7db89830714$export$fbda843f0a27fe96 = '#091E42';
var $b93ef7db89830714$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
var $b93ef7db89830714$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
var $b93ef7db89830714$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
var $b93ef7db89830714$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
var $b93ef7db89830714$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
var $b93ef7db89830714$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
var $b93ef7db89830714$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
var $b93ef7db89830714$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
var $b93ef7db89830714$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
var $b93ef7db89830714$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
var $b93ef7db89830714$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
var $b93ef7db89830714$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
var $b93ef7db89830714$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
var $b93ef7db89830714$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
var $b93ef7db89830714$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
var $b93ef7db89830714$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
var $b93ef7db89830714$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
var $b93ef7db89830714$export$2f6319cf7d736c2a = '#E6EDFA';
var $b93ef7db89830714$export$95126bc8884d6634 = '#DCE5F5';
var $b93ef7db89830714$export$8338d8c35d44ff1 = '#CED9EB';
var $b93ef7db89830714$export$5368d76ae4fbbda7 = '#B8C7E0';
var $b93ef7db89830714$export$9f0a771d16ec8d36 = '#ABBBD6';
var $b93ef7db89830714$export$abcf8c38338b4aa5 = '#9FB0CC';
var $b93ef7db89830714$export$97e81faa16a182c7 = '#8C9CB8';
var $b93ef7db89830714$export$bfe21c59123ecf33 = '#7988A3';
var $b93ef7db89830714$export$ee82aa2ea6a1558 = '#67758F';
var $b93ef7db89830714$export$682927c6ed76be02 = '#56637A';
var $b93ef7db89830714$export$91fd9994c5be9757 = '#455166';
var $b93ef7db89830714$export$d281fbfe3cff2df6 = '#3B475C';
var $b93ef7db89830714$export$3902c91d8b98a753 = '#313D52';
var $b93ef7db89830714$export$8e8133c1ba5845b5 = '#283447';
var $b93ef7db89830714$export$33ff357f6620b39 = '#202B3D';
var $b93ef7db89830714$export$633847cf062b69e0 = '#1B2638';
var $b93ef7db89830714$export$9776a6e503bdbf76 = '#121A29';
var $b93ef7db89830714$export$6c813d5160dff5db = '#0E1624';
var $b93ef7db89830714$export$3d4f271a500072a = '#0D1424';
var $b93ef7db89830714$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
var $b93ef7db89830714$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
var $b93ef7db89830714$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
var $b93ef7db89830714$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
var $b93ef7db89830714$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
var $b93ef7db89830714$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
var $b93ef7db89830714$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
var $b93ef7db89830714$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
var $b93ef7db89830714$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
var $b93ef7db89830714$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
var $b93ef7db89830714$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
var $b93ef7db89830714$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
var $b93ef7db89830714$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
var $b93ef7db89830714$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
var $b93ef7db89830714$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
var $b93ef7db89830714$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
var $b93ef7db89830714$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';
var $b93ef7db89830714$export$d2adc5dedf09fced = '#292A2E';
var $b93ef7db89830714$export$f51762073d2bb381 = '#94C748';
var $b93ef7db89830714$export$95e26d54def96891 = '#B3DF72';


var $bbdb01765230c0ca$export$44ffba16bd48dac6 = '__ATLASKIT_THEME__';
var $bbdb01765230c0ca$export$c93026a968943f95 = 'light';
var $bbdb01765230c0ca$export$6ba72c8346b4c57e = [
    'light',
    'dark'
];
var $bbdb01765230c0ca$export$8e24544ddba725ee = function focusRing() {
    var color = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "var(--ds-border-focused, ".concat((0, $b93ef7db89830714$export$215b7063051591f1), ")");
    var outlineWidth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
    (0, $kxpsr.default)('@atlaskit/theme', 'focus ring mixin', 'Please use `@atlaskit/focus-ring` instead.');
    return "\n  &:focus {\n    outline: none;\n    box-shadow: 0px 0px 0px ".concat(outlineWidth, "px ").concat(color, ";\n  }\n");
};
var $bbdb01765230c0ca$export$c0dd343266bc3261 = function noFocusRing() {
    return "\n  box-shadow: none;\n";
};
var $bbdb01765230c0ca$export$7be255094ccdc533 = {
    card: function card() {
        return 100;
    },
    navigation: function navigation() {
        return 200;
    },
    dialog: function dialog() {
        return 300;
    },
    layer: function layer() {
        return 400;
    },
    blanket: function blanket() {
        return 500;
    },
    modal: function modal() {
        return 510;
    },
    flag: function flag() {
        return 600;
    },
    spotlight: function spotlight() {
        return 700;
    },
    tooltip: function tooltip() {
        return 9999;
    }
};
var $bbdb01765230c0ca$export$a1b3edb637fb4f35 = function visuallyHidden() {
    (0, $kxpsr.default)('@atlaskit/theme', 'visually hidden mixin', 'Please use `@atlaskit/visually-hidden` instead.');
    return {
        border: '0 !important',
        clip: 'rect(1px, 1px, 1px, 1px) !important',
        height: '1px !important',
        overflow: 'hidden !important',
        padding: '0 !important',
        position: 'absolute !important',
        width: '1px !important',
        whiteSpace: 'nowrap !important'
    };
};
var $bbdb01765230c0ca$export$ba1d834b86d72a09 = $bbdb01765230c0ca$export$a1b3edb637fb4f35;
var $bbdb01765230c0ca$export$e497e856b4f89fcd = function skeletonShimmer() {
    return {
        css: {
            backgroundColor: "var(--ds-skeleton, ".concat((0, $b93ef7db89830714$export$8d43898f60b96a82), ")"),
            animationDuration: '1.5s',
            animationIterationCount: 'infinite',
            animationTimingFunction: 'linear',
            animationDirection: 'alternate'
        },
        keyframes: {
            from: {
                backgroundColor: "var(--ds-skeleton, ".concat((0, $b93ef7db89830714$export$8d43898f60b96a82), ")")
            },
            to: {
                backgroundColor: "var(--ds-skeleton-subtle, ".concat((0, $b93ef7db89830714$export$920c0d5c49070351), ")")
            }
        }
    };
};



var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");

var $7QpUe = parcelRequire("7QpUe");

var $eVb4V = parcelRequire("eVb4V");


var $25nEq = parcelRequire("25nEq");

var $lmG37 = parcelRequire("lmG37");

var $9Zzpd = parcelRequire("9Zzpd");

var $h8qvJ = parcelRequire("h8qvJ");
var $f506947dac9932b3$export$8a682ae47622dbb9 = 'ds--dropdown--';
function $f506947dac9932b3$export$2e2bcd8739ae039() {
    var id = (0, $h8qvJ.useId)();
    return "".concat($f506947dac9932b3$export$8a682ae47622dbb9).concat(id);
}


var $cdbf8757b5038333$var$actionMap = (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, (0, $lmG37.KEY_DOWN), 'next'), (0, $lmG37.KEY_UP), 'prev'), (0, $lmG37.KEY_HOME), 'first'), (0, $lmG37.KEY_END), 'last');
/**
 * `currentFocusedIdx + 1` will not work if the next focusable element
 * is disabled. So, we need to iterate through the following menu items
 * to find one that isn't disabled. If all following elements are disabled,
 * return undefined.
 */ var $cdbf8757b5038333$var$getNextFocusableElement = function getNextFocusableElement(refs, currentFocusedIdx) {
    for(var i = 0; i < refs.length - 1; i++){
        if (currentFocusedIdx + 1 === refs.length) currentFocusedIdx = 0;
        else currentFocusedIdx++;
        var element = refs[currentFocusedIdx].current;
        var isValid = !!element && !element.hasAttribute('disabled');
        if (isValid) return element;
    }
    return;
};
/**
 * `currentFocusedIdx - 1` will not work if the prev focusable element
 * is disabled. So, we need to iterate through the previous menu items
 * to find one that isn't disabled. If all previous elements are disabled,
 * return undefined.
 */ var $cdbf8757b5038333$var$getPrevFocusableElement = function getPrevFocusableElement(refs, currentFocusedIdx) {
    for(var i = 0; i < refs.length - 1; i++){
        if (currentFocusedIdx === 0) currentFocusedIdx = refs.length - 1;
        else currentFocusedIdx--;
        var element = refs[currentFocusedIdx].current;
        var isValid = !!element && !element.hasAttribute('disabled');
        if (isValid) return element;
    }
    return;
};
function $cdbf8757b5038333$export$2e2bcd8739ae039(refs, isLayerDisabled, onClose) {
    return function(e) {
        var _refs$current;
        var currentRefs = (_refs$current = refs.current) !== null && _refs$current !== void 0 ? _refs$current : [];
        var currentFocusedIdx = currentRefs.findIndex(function(_ref) {
            var _document$activeEleme;
            var el = _ref.current;
            return el && ((_document$activeEleme = document.activeElement) === null || _document$activeEleme === void 0 ? void 0 : _document$activeEleme.isSameNode(el));
        });
        if ((0, $9Zzpd.fg)('platform_dst_popup-disable-focuslock')) {
            var _document$activeEleme2;
            // if we use a popup as a nested dropdown, we must prevent the dropdown from closing.
            var isNestedDropdown = !!((_document$activeEleme2 = document.activeElement) !== null && _document$activeEleme2 !== void 0 && _document$activeEleme2.closest("[id^=".concat((0, $f506947dac9932b3$export$8a682ae47622dbb9), "]")));
            if (isLayerDisabled() && isNestedDropdown) {
                if (e.key === (0, $lmG37.KEY_TAB) && !e.shiftKey) onClose(e);
                // if it is a nested dropdown and the level of the given dropdown is not the current level,
                // we don't need to have focus on it
                return;
            }
        } else if (isLayerDisabled()) {
            if (e.key === (0, $lmG37.KEY_TAB) && !e.shiftKey) onClose(e);
            // if it is a nested dropdown and the level of the given dropdown is not the current level,
            // we don't need to have focus on it
            return;
        }
        var action = $cdbf8757b5038333$var$actionMap[e.key];
        switch(action){
            case 'next':
                // Always cancelling the event to prevent scrolling
                e.preventDefault();
                var nextFocusableElement = $cdbf8757b5038333$var$getNextFocusableElement(currentRefs, currentFocusedIdx);
                nextFocusableElement === null || nextFocusableElement === void 0 || nextFocusableElement.focus();
                break;
            case 'prev':
                // Always cancelling the event to prevent scrolling
                e.preventDefault();
                var prevFocusableElement = $cdbf8757b5038333$var$getPrevFocusableElement(currentRefs, currentFocusedIdx);
                prevFocusableElement === null || prevFocusableElement === void 0 || prevFocusableElement.focus();
                break;
            case 'first':
                e.preventDefault();
                // Search for first non-disabled element if first element is disabled
                var firstFocusableElement = $cdbf8757b5038333$var$getNextFocusableElement(currentRefs, -1);
                firstFocusableElement === null || firstFocusableElement === void 0 || firstFocusableElement.focus();
                break;
            case 'last':
                e.preventDefault();
                // Search for last non-disabled element if last element is disabled
                var lastFocusableElement = $cdbf8757b5038333$var$getPrevFocusableElement(currentRefs, currentRefs.length);
                lastFocusableElement === null || lastFocusableElement === void 0 || lastFocusableElement.focus();
                break;
            default:
                return;
        }
    };
}


var $3222b4b178ad4080$export$f18c1d4fc7326096 = /*#__PURE__*/ (0, $5FkrB.createContext)({
    menuItemRefs: [],
    registerRef: (0, $eVb4V.default)
});
/**
 * Focus manager logic.
 */ var $3222b4b178ad4080$var$FocusManager = function FocusManager(_ref) {
    var children = _ref.children, onClose = _ref.onClose;
    var menuItemRefs = (0, $5FkrB.useRef)([]);
    // Used to force a re-render only
    var _useState = (0, $5FkrB.useState)(0), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), refresh = _useState2[0], setRefresh = _useState2[1];
    var registerMode = (0, $5FkrB.useRef)('ordered');
    registerMode.current = 'ordered';
    var registerRef = (0, $5FkrB.useCallback)(function(ref) {
        if (menuItemRefs.current.includes(ref)) return;
        switch(registerMode.current){
            case 'ordered':
                menuItemRefs.current.push(ref);
                break;
            case 'unordered':
                // Reset and force a rerender
                registerMode.current = 'regenerate';
                menuItemRefs.current = [];
                setRefresh(refresh + 1);
                break;
            case 'regenerate':
                break;
            default:
                throw new Error("Unexpected case of ".concat(registerMode.current));
        }
    }, // Updating register ref on force reload will cause `useRegisterItemWithFocusManager` to re-register
    [
        refresh
    ]);
    var _useLayering = (0, $06d0721b7d6dfd7c$export$c8b4d54e03dee6ed)(), isLayerDisabled = _useLayering.isLayerDisabled;
    // Intentionally rebinding on each render
    (0, $5FkrB.useEffect)(function() {
        if (registerMode.current === 'ordered') // Use effect is called after rendering is complete and useEffects of the children a called first
        registerMode.current = 'unordered';
    });
    (0, $5FkrB.useEffect)(function() {
        return (0, $7QpUe.bind)(window, {
            type: 'keydown',
            listener: (0, $cdbf8757b5038333$export$2e2bcd8739ae039)(menuItemRefs, isLayerDisabled, onClose)
        });
    }, [
        isLayerDisabled,
        onClose
    ]);
    var contextValue = {
        menuItemRefs: menuItemRefs.current,
        registerRef: registerRef
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement($3222b4b178ad4080$export$f18c1d4fc7326096.Provider, {
        value: contextValue
    }, children);
};
var $3222b4b178ad4080$export$2e2bcd8739ae039 = $3222b4b178ad4080$var$FocusManager;


/* menu-wrapper.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $5FkrB = parcelRequire("5FkrB");


var $deSpz = parcelRequire("deSpz");
/* box.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $kqp0i = parcelRequire("kqp0i");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");

var $5FkrB = parcelRequire("5FkrB");
var $a38218bf9f9fa545$export$1ca2a26fecb070ae = /*#__PURE__*/ (0, $5FkrB.createContext)('elevation.surface');
var $a38218bf9f9fa545$export$1aeb4f6b93c4540d = function useSurface() {
    return (0, $5FkrB.useContext)($a38218bf9f9fa545$export$1ca2a26fecb070ae);
};
$a38218bf9f9fa545$export$1ca2a26fecb070ae.displayName = 'SurfaceProvider';


var $587e6e70fb05b93e$var$_excluded = [
    "as",
    "children",
    "backgroundColor",
    "padding",
    "paddingBlock",
    "paddingBlockStart",
    "paddingBlockEnd",
    "paddingInline",
    "paddingInlineStart",
    "paddingInlineEnd",
    "style",
    "testId",
    "xcss"
], $587e6e70fb05b93e$var$_excluded2 = [
    "className"
];
// Can either Exclude or Extract - here we're excluding all SVG-related elements, <button> elements (handled by Pressable), and <a> elements (handled by Anchor)
// Basically just ElementType but without ComponentType, it makes sense to keep the "Type" suffix
// eslint-disable-next-line @repo/internal/react/consistent-types-definitions
var $587e6e70fb05b93e$var$baseStyles = null;
var $587e6e70fb05b93e$var$backgroundColorMap = {
    'color.background.accent.lime.subtlest': "_bfhkm890",
    'color.background.accent.lime.subtlest.hovered': "_bfhkd4y8",
    'color.background.accent.lime.subtlest.pressed': "_bfhkkuup",
    'color.background.accent.lime.subtler': "_bfhkz2ec",
    'color.background.accent.lime.subtler.hovered': "_bfhk1gf0",
    'color.background.accent.lime.subtler.pressed': "_bfhk2kxc",
    'color.background.accent.lime.subtle': "_bfhkbq5w",
    'color.background.accent.lime.subtle.hovered': "_bfhkfoww",
    'color.background.accent.lime.subtle.pressed': "_bfhk1jbd",
    'color.background.accent.lime.bolder': "_bfhktde4",
    'color.background.accent.lime.bolder.hovered': "_bfhknzpa",
    'color.background.accent.lime.bolder.pressed': "_bfhkh0j0",
    'color.background.accent.red.subtlest': "_bfhk1vk5",
    'color.background.accent.red.subtlest.hovered': "_bfhk1i6i",
    'color.background.accent.red.subtlest.pressed': "_bfhknbir",
    'color.background.accent.red.subtler': "_bfhk1rtt",
    'color.background.accent.red.subtler.hovered': "_bfhkaffd",
    'color.background.accent.red.subtler.pressed': "_bfhk1j5a",
    'color.background.accent.red.subtle': "_bfhkkrt9",
    'color.background.accent.red.subtle.hovered': "_bfhk1sou",
    'color.background.accent.red.subtle.pressed': "_bfhk1fnn",
    'color.background.accent.red.bolder': "_bfhkuibq",
    'color.background.accent.red.bolder.hovered': "_bfhk100f",
    'color.background.accent.red.bolder.pressed': "_bfhk1cl6",
    'color.background.accent.orange.subtlest': "_bfhkf5uh",
    'color.background.accent.orange.subtlest.hovered': "_bfhk19yr",
    'color.background.accent.orange.subtlest.pressed': "_bfhkf90x",
    'color.background.accent.orange.subtler': "_bfhk165s",
    'color.background.accent.orange.subtler.hovered': "_bfhk1ei0",
    'color.background.accent.orange.subtler.pressed': "_bfhkdpo3",
    'color.background.accent.orange.subtle': "_bfhk1kkj",
    'color.background.accent.orange.subtle.hovered': "_bfhk9mfs",
    'color.background.accent.orange.subtle.pressed': "_bfhkaxpp",
    'color.background.accent.orange.bolder': "_bfhk1qg1",
    'color.background.accent.orange.bolder.hovered': "_bfhk12qo",
    'color.background.accent.orange.bolder.pressed': "_bfhk1fyq",
    'color.background.accent.yellow.subtlest': "_bfhkibhp",
    'color.background.accent.yellow.subtlest.hovered': "_bfhkaetg",
    'color.background.accent.yellow.subtlest.pressed': "_bfhk1o1l",
    'color.background.accent.yellow.subtler': "_bfhk1773",
    'color.background.accent.yellow.subtler.hovered': "_bfhk1uw7",
    'color.background.accent.yellow.subtler.pressed': "_bfhk1r9w",
    'color.background.accent.yellow.subtle': "_bfhk8y3s",
    'color.background.accent.yellow.subtle.hovered': "_bfhk819w",
    'color.background.accent.yellow.subtle.pressed': "_bfhk1jx0",
    'color.background.accent.yellow.bolder': "_bfhk1vop",
    'color.background.accent.yellow.bolder.hovered': "_bfhkkjqf",
    'color.background.accent.yellow.bolder.pressed': "_bfhk1okt",
    'color.background.accent.green.subtlest': "_bfhkn729",
    'color.background.accent.green.subtlest.hovered': "_bfhk3utz",
    'color.background.accent.green.subtlest.pressed': "_bfhkyfny",
    'color.background.accent.green.subtler': "_bfhk1wnw",
    'color.background.accent.green.subtler.hovered': "_bfhk1e2h",
    'color.background.accent.green.subtler.pressed': "_bfhkybhx",
    'color.background.accent.green.subtle': "_bfhk1rsu",
    'color.background.accent.green.subtle.hovered': "_bfhk12e3",
    'color.background.accent.green.subtle.pressed': "_bfhk1g86",
    'color.background.accent.green.bolder': "_bfhk1e5c",
    'color.background.accent.green.bolder.hovered': "_bfhka5yi",
    'color.background.accent.green.bolder.pressed': "_bfhk1j68",
    'color.background.accent.teal.subtlest': "_bfhk7xuz",
    'color.background.accent.teal.subtlest.hovered': "_bfhk108c",
    'color.background.accent.teal.subtlest.pressed': "_bfhk1cxp",
    'color.background.accent.teal.subtler': "_bfhk1a17",
    'color.background.accent.teal.subtler.hovered': "_bfhkkwwr",
    'color.background.accent.teal.subtler.pressed': "_bfhk1jb0",
    'color.background.accent.teal.subtle': "_bfhktdv8",
    'color.background.accent.teal.subtle.hovered': "_bfhkzh8h",
    'color.background.accent.teal.subtle.pressed': "_bfhk16zl",
    'color.background.accent.teal.bolder': "_bfhk2c8p",
    'color.background.accent.teal.bolder.hovered': "_bfhkl3ve",
    'color.background.accent.teal.bolder.pressed': "_bfhktor0",
    'color.background.accent.blue.subtlest': "_bfhk1s93",
    'color.background.accent.blue.subtlest.hovered': "_bfhkdaj9",
    'color.background.accent.blue.subtlest.pressed': "_bfhkxm0g",
    'color.background.accent.blue.subtler': "_bfhk1dy8",
    'color.background.accent.blue.subtler.hovered': "_bfhk815t",
    'color.background.accent.blue.subtler.pressed': "_bfhkrwxf",
    'color.background.accent.blue.subtle': "_bfhk115i",
    'color.background.accent.blue.subtle.hovered': "_bfhk9pr4",
    'color.background.accent.blue.subtle.pressed': "_bfhknpx7",
    'color.background.accent.blue.bolder': "_bfhk16e3",
    'color.background.accent.blue.bolder.hovered': "_bfhk1vbm",
    'color.background.accent.blue.bolder.pressed': "_bfhk1xwi",
    'color.background.accent.purple.subtlest': "_bfhkp2ly",
    'color.background.accent.purple.subtlest.hovered': "_bfhkkca2",
    'color.background.accent.purple.subtlest.pressed': "_bfhk1jbm",
    'color.background.accent.purple.subtler': "_bfhk1nm4",
    'color.background.accent.purple.subtler.hovered': "_bfhkattl",
    'color.background.accent.purple.subtler.pressed': "_bfhk3nfk",
    'color.background.accent.purple.subtle': "_bfhk18ah",
    'color.background.accent.purple.subtle.hovered': "_bfhk8bp1",
    'color.background.accent.purple.subtle.pressed': "_bfhk1cd2",
    'color.background.accent.purple.bolder': "_bfhkya33",
    'color.background.accent.purple.bolder.hovered': "_bfhk1af5",
    'color.background.accent.purple.bolder.pressed': "_bfhk6cze",
    'color.background.accent.magenta.subtlest': "_bfhk8tvm",
    'color.background.accent.magenta.subtlest.hovered': "_bfhkr3zd",
    'color.background.accent.magenta.subtlest.pressed': "_bfhk1ckf",
    'color.background.accent.magenta.subtler': "_bfhkv9ra",
    'color.background.accent.magenta.subtler.hovered': "_bfhk1axx",
    'color.background.accent.magenta.subtler.pressed': "_bfhk42ri",
    'color.background.accent.magenta.subtle': "_bfhk1mi6",
    'color.background.accent.magenta.subtle.hovered': "_bfhkrwyz",
    'color.background.accent.magenta.subtle.pressed': "_bfhk6c15",
    'color.background.accent.magenta.bolder': "_bfhkc3uk",
    'color.background.accent.magenta.bolder.hovered': "_bfhk1ok8",
    'color.background.accent.magenta.bolder.pressed': "_bfhkeawv",
    'color.background.accent.gray.subtlest': "_bfhkysee",
    'color.background.accent.gray.subtlest.hovered': "_bfhkwejn",
    'color.background.accent.gray.subtlest.pressed': "_bfhk18ut",
    'color.background.accent.gray.subtler': "_bfhk7qp0",
    'color.background.accent.gray.subtler.hovered': "_bfhk10ef",
    'color.background.accent.gray.subtler.pressed': "_bfhk1rk9",
    'color.background.accent.gray.subtle': "_bfhk18j9",
    'color.background.accent.gray.subtle.hovered': "_bfhk1nv3",
    'color.background.accent.gray.subtle.pressed': "_bfhkq9tj",
    'color.background.accent.gray.bolder': "_bfhk1i45",
    'color.background.accent.gray.bolder.hovered': "_bfhkbyip",
    'color.background.accent.gray.bolder.pressed': "_bfhk1van",
    'color.background.disabled': "_bfhkby5v",
    'color.background.input': "_bfhk1j9a",
    'color.background.input.hovered': "_bfhkl4ek",
    'color.background.input.pressed': "_bfhkr01l",
    'color.background.inverse.subtle': "_bfhk1vck",
    'color.background.inverse.subtle.hovered': "_bfhkmpja",
    'color.background.inverse.subtle.pressed': "_bfhk1gii",
    'color.background.neutral': "_bfhki8nm",
    'color.background.neutral.hovered': "_bfhkplhp",
    'color.background.neutral.pressed': "_bfhk1gdz",
    'color.background.neutral.subtle': "_bfhksm61",
    'color.background.neutral.subtle.hovered': "_bfhk1dpa",
    'color.background.neutral.subtle.pressed': "_bfhkfcek",
    'color.background.neutral.bold': "_bfhk1aqn",
    'color.background.neutral.bold.hovered': "_bfhk1ibz",
    'color.background.neutral.bold.pressed': "_bfhkof27",
    'color.background.selected': "_bfhk15s3",
    'color.background.selected.hovered': "_bfhkufnl",
    'color.background.selected.pressed': "_bfhknozp",
    'color.background.selected.bold': "_bfhkjmqp",
    'color.background.selected.bold.hovered': "_bfhk1q28",
    'color.background.selected.bold.pressed': "_bfhk12kk",
    'color.background.brand.subtlest': "_bfhk1gmr",
    'color.background.brand.subtlest.hovered': "_bfhk3v15",
    'color.background.brand.subtlest.pressed': "_bfhku02c",
    'color.background.brand.bold': "_bfhk1856",
    'color.background.brand.bold.hovered': "_bfhkhf2y",
    'color.background.brand.bold.pressed': "_bfhkg6ey",
    'color.background.brand.boldest': "_bfhk1o4i",
    'color.background.brand.boldest.hovered': "_bfhklefx",
    'color.background.brand.boldest.pressed': "_bfhk16k6",
    'color.background.danger': "_bfhk1gly",
    'color.background.danger.hovered': "_bfhk1yvi",
    'color.background.danger.pressed': "_bfhk1r4b",
    'color.background.danger.bold': "_bfhkybec",
    'color.background.danger.bold.hovered': "_bfhks9hg",
    'color.background.danger.bold.pressed': "_bfhk13a9",
    'color.background.warning': "_bfhk1917",
    'color.background.warning.hovered': "_bfhk19zu",
    'color.background.warning.pressed': "_bfhkzr32",
    'color.background.warning.bold': "_bfhk1kmu",
    'color.background.warning.bold.hovered': "_bfhk1spp",
    'color.background.warning.bold.pressed': "_bfhk4m4m",
    'color.background.success': "_bfhk1y9u",
    'color.background.success.hovered': "_bfhk1vfx",
    'color.background.success.pressed': "_bfhk1wl5",
    'color.background.success.bold': "_bfhkkcmj",
    'color.background.success.bold.hovered': "_bfhky7x8",
    'color.background.success.bold.pressed': "_bfhkwcbh",
    'color.background.discovery': "_bfhk6vm6",
    'color.background.discovery.hovered': "_bfhk12eq",
    'color.background.discovery.pressed': "_bfhk18vq",
    'color.background.discovery.bold': "_bfhku5tj",
    'color.background.discovery.bold.hovered': "_bfhkfqeg",
    'color.background.discovery.bold.pressed': "_bfhk1f1m",
    'color.background.information': "_bfhk19ip",
    'color.background.information.hovered': "_bfhk86z5",
    'color.background.information.pressed': "_bfhk1c1j",
    'color.background.information.bold': "_bfhkx4w0",
    'color.background.information.bold.hovered': "_bfhkq2ii",
    'color.background.information.bold.pressed': "_bfhkf89v",
    'color.blanket': "_bfhk1i5c",
    'color.blanket.selected': "_bfhk7wq0",
    'color.blanket.danger': "_bfhkrprw",
    'color.skeleton': "_bfhkizff",
    'color.skeleton.subtle': "_bfhkvkf5",
    'elevation.surface': "_bfhkvuon",
    'elevation.surface.hovered': "_bfhk19i6",
    'elevation.surface.pressed': "_bfhk13ro",
    'elevation.surface.overlay': "_bfhk1bhr",
    'elevation.surface.overlay.hovered': "_bfhk6o2t",
    'elevation.surface.overlay.pressed': "_bfhkm8nx",
    'elevation.surface.raised': "_bfhkhp5a",
    'elevation.surface.raised.hovered': "_bfhk116u",
    'elevation.surface.raised.pressed': "_bfhk14aj",
    'elevation.surface.sunken': "_bfhkhfxm",
    'utility.elevation.surface.current': "_bfhkchd4"
};
var $587e6e70fb05b93e$var$CURRENT_SURFACE_CSS_VAR = "--ds-elevation-surface-current";
var $587e6e70fb05b93e$var$setSurfaceTokenMap = {
    'elevation.surface': "_1q1lvuon",
    'elevation.surface.hovered': "_1q1l19i6",
    'elevation.surface.pressed': "_1q1l13ro",
    'elevation.surface.overlay': "_1q1l1bhr",
    'elevation.surface.overlay.hovered': "_1q1l6o2t",
    'elevation.surface.overlay.pressed': "_1q1lm8nx",
    'elevation.surface.raised': "_1q1lhp5a",
    'elevation.surface.raised.hovered': "_1q1l116u",
    'elevation.surface.raised.pressed': "_1q1l14aj",
    'elevation.surface.sunken': "_1q1lhfxm"
};
var $587e6e70fb05b93e$var$paddingBlockStartMap = {
    'space.0': "_1q51ze3t",
    'space.025': "_1q51v77o",
    'space.050': "_1q511b66",
    'space.075': "_1q5112x7",
    'space.100': "_1q51u2gc",
    'space.150': "_1q51utpp",
    'space.200': "_1q51pxbi",
    'space.250': "_1q51v47k",
    'space.300': "_1q511ejb",
    'space.400': "_1q51xy5q",
    'space.500': "_1q511jfw",
    'space.600': "_1q51oahv",
    'space.800': "_1q51xncg",
    'space.1000': "_1q511epz"
};
var $587e6e70fb05b93e$var$paddingBlockEndMap = {
    'space.0': "_85i5ze3t",
    'space.025': "_85i5v77o",
    'space.050': "_85i51b66",
    'space.075': "_85i512x7",
    'space.100': "_85i5u2gc",
    'space.150': "_85i5utpp",
    'space.200': "_85i5pxbi",
    'space.250': "_85i5v47k",
    'space.300': "_85i51ejb",
    'space.400': "_85i5xy5q",
    'space.500': "_85i51jfw",
    'space.600': "_85i5oahv",
    'space.800': "_85i5xncg",
    'space.1000': "_85i51epz"
};
var $587e6e70fb05b93e$var$paddingInlineStartMap = {
    'space.0': "_bozgze3t",
    'space.025': "_bozgv77o",
    'space.050': "_bozg1b66",
    'space.075': "_bozg12x7",
    'space.100': "_bozgu2gc",
    'space.150': "_bozgutpp",
    'space.200': "_bozgpxbi",
    'space.250': "_bozgv47k",
    'space.300': "_bozg1ejb",
    'space.400': "_bozgxy5q",
    'space.500': "_bozg1jfw",
    'space.600': "_bozgoahv",
    'space.800': "_bozgxncg",
    'space.1000': "_bozg1epz"
};
var $587e6e70fb05b93e$var$paddingInlineEndMap = {
    'space.0': "_y4tize3t",
    'space.025': "_y4tiv77o",
    'space.050': "_y4ti1b66",
    'space.075': "_y4ti12x7",
    'space.100': "_y4tiu2gc",
    'space.150': "_y4tiutpp",
    'space.200': "_y4tipxbi",
    'space.250': "_y4tiv47k",
    'space.300': "_y4ti1ejb",
    'space.400': "_y4tixy5q",
    'space.500': "_y4ti1jfw",
    'space.600': "_y4tioahv",
    'space.800': "_y4tixncg",
    'space.1000': "_y4ti1epz"
};
/**
 * __Box__
 *
 * A Box is a primitive component that has the design decisions of the Atlassian Design System baked in.
 * Renders a `div` by default.
 *
 * - [Examples](https://atlassian.design/components/primitives/box/examples)
 * - [Code](https://atlassian.design/components/primitives/box/code)
 * - [Usage](https://atlassian.design/components/primitives/box/usage)
 */ var $587e6e70fb05b93e$var$Box = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? 'div' : _ref$as, children = _ref.children, backgroundColor = _ref.backgroundColor, padding = _ref.padding, _ref$paddingBlock = _ref.paddingBlock, paddingBlock = _ref$paddingBlock === void 0 ? padding : _ref$paddingBlock, _ref$paddingBlockStar = _ref.paddingBlockStart, paddingBlockStart = _ref$paddingBlockStar === void 0 ? paddingBlock : _ref$paddingBlockStar, _ref$paddingBlockEnd = _ref.paddingBlockEnd, paddingBlockEnd = _ref$paddingBlockEnd === void 0 ? paddingBlock : _ref$paddingBlockEnd, _ref$paddingInline = _ref.paddingInline, paddingInline = _ref$paddingInline === void 0 ? padding : _ref$paddingInline, _ref$paddingInlineSta = _ref.paddingInlineStart, paddingInlineStart = _ref$paddingInlineSta === void 0 ? paddingInline : _ref$paddingInlineSta, _ref$paddingInlineEnd = _ref.paddingInlineEnd, paddingInlineEnd = _ref$paddingInlineEnd === void 0 ? paddingInline : _ref$paddingInlineEnd, style = _ref.style, testId = _ref.testId, xcss = _ref.xcss, htmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $587e6e70fb05b93e$var$_excluded);
    // This is to remove className from safeHtmlAttributes
    // @ts-ignore -- not using expect since it causes issues with help-center local consumption - className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(htmlAttributes, $587e6e70fb05b93e$var$_excluded2);
    var node = /*#__PURE__*/ $5FkrB.createElement(Component, (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        style: style,
        ref: ref,
        className: (0, $970q7.default)([
            "_19itglyw _vchhusvi _r06hglyw",
            backgroundColor && $587e6e70fb05b93e$var$backgroundColorMap[backgroundColor],
            backgroundColor && $587e6e70fb05b93e$var$isSurfaceToken(backgroundColor) && $587e6e70fb05b93e$var$setSurfaceTokenMap[backgroundColor],
            paddingBlockStart && $587e6e70fb05b93e$var$paddingBlockStartMap[paddingBlockStart],
            paddingBlockEnd && $587e6e70fb05b93e$var$paddingBlockEndMap[paddingBlockEnd],
            paddingInlineStart && $587e6e70fb05b93e$var$paddingInlineStartMap[paddingInlineStart],
            paddingInlineEnd && $587e6e70fb05b93e$var$paddingInlineEndMap[paddingInlineEnd],
            xcss
        ])
    }, safeHtmlAttributes, {
        "data-testid": testId
    }), children);
    if (backgroundColor) return /*#__PURE__*/ $5FkrB.createElement((0, $a38218bf9f9fa545$export$1ca2a26fecb070ae).Provider, {
        value: backgroundColor
    }, node);
    return node;
});
var $587e6e70fb05b93e$export$2e2bcd8739ae039 = $587e6e70fb05b93e$var$Box;
function $587e6e70fb05b93e$var$isSurfaceToken(backgroundColor) {
    return backgroundColor in $587e6e70fb05b93e$var$setSurfaceTokenMap;
}



var $9ztDu = parcelRequire("9ztDu");
function $b125a43f74d2157f$export$2e2bcd8739ae039(element) {
    var role = element.getAttribute('role');
    return role === 'checkbox' || role === 'menuitemcheckbox';
}


function $18592c78b3c4237c$export$2e2bcd8739ae039(element) {
    var role = element.getAttribute('role');
    return role === 'radio' || role === 'menuitemradio';
}



var $f06bf9ec6c91dfbd$var$styles = {
    spinnerContainer: "_1e0c1txw _1ul91lit _1bah1h6o _ca0qv47k _u5f3v47k _n3tdv47k _19bvv47k"
};
var $f06bf9ec6c91dfbd$var$LoadingIndicator = function LoadingIndicator(_ref) {
    var _ref$statusLabel = _ref.statusLabel, statusLabel = _ref$statusLabel === void 0 ? 'Loading' : _ref$statusLabel, testId = _ref.testId;
    return /*#__PURE__*/ $5FkrB.createElement((0, $587e6e70fb05b93e$export$2e2bcd8739ae039), {
        xcss: $f06bf9ec6c91dfbd$var$styles.spinnerContainer,
        role: "menuitem"
    }, /*#__PURE__*/ $5FkrB.createElement((0, $9ztDu.default), {
        size: "small",
        label: statusLabel,
        testId: testId
    }));
};
/**
 *
 * MenuWrapper wraps all the menu items.
 * It handles the logic to close the menu when a MenuItem is clicked, but leaves it open
 * if a CheckboxItem or RadioItem is clicked.
 * It also sets focus to the first menu item when opened.
 */ var $f06bf9ec6c91dfbd$var$MenuWrapper = function MenuWrapper(_ref2) {
    var children = _ref2.children, isLoading = _ref2.isLoading, maxHeight = _ref2.maxHeight, maxWidth = _ref2.maxWidth, onClose = _ref2.onClose, onUpdate = _ref2.onUpdate, statusLabel = _ref2.statusLabel, setInitialFocusRef = _ref2.setInitialFocusRef, shouldRenderToParent = _ref2.shouldRenderToParent, spacing = _ref2.spacing, testId = _ref2.testId, isTriggeredUsingKeyboard = _ref2.isTriggeredUsingKeyboard, autoFocus = _ref2.autoFocus, menuLabel = _ref2.menuLabel;
    var _useContext = (0, $5FkrB.useContext)((0, $3222b4b178ad4080$export$f18c1d4fc7326096)), menuItemRefs = _useContext.menuItemRefs;
    var closeOnMenuItemClick = function closeOnMenuItemClick(e) {
        var isTargetMenuItemOrDescendant = menuItemRefs.some(function(menuItemRef) {
            var menuItem = menuItemRef.current;
            if (!menuItem) return false;
            var isCheckboxOrRadio = (0, $b125a43f74d2157f$export$2e2bcd8739ae039)(menuItem) || (0, $18592c78b3c4237c$export$2e2bcd8739ae039)(menuItem);
            return menuItem.contains(e.target) && !isCheckboxOrRadio;
        });
        // Close menu if the click is triggered from a MenuItem or
        // its descendant. Don't close the menu if the click is triggered
        // from a MenuItemRadio or MenuItemCheckbox so that the user can
        // select multiple items.
        if (isTargetMenuItemOrDescendant && onClose) onClose(e);
    };
    // Using useEffect here causes a flicker.
    // useLayoutEffect ensures that the update and render happen in the same
    // rAF tick.
    (0, $5FkrB.useLayoutEffect)(function() {
        onUpdate();
    }, [
        isLoading,
        onUpdate
    ]);
    (0, $5FkrB.useEffect)(function() {
        var _menuItemRefs$map$fin;
        var firstFocusableRef = (_menuItemRefs$map$fin = menuItemRefs.map(function(_ref3) {
            var current = _ref3.current;
            return current;
        }).find(function(el) {
            return !!el && !el.hasAttribute('disabled');
        })) !== null && _menuItemRefs$map$fin !== void 0 ? _menuItemRefs$map$fin : null;
        if (shouldRenderToParent && (isTriggeredUsingKeyboard || autoFocus)) firstFocusableRef === null || firstFocusableRef === void 0 || firstFocusableRef.focus();
        setInitialFocusRef === null || setInitialFocusRef === void 0 || setInitialFocusRef(firstFocusableRef);
    }, [
        menuItemRefs,
        setInitialFocusRef,
        autoFocus,
        shouldRenderToParent,
        isTriggeredUsingKeyboard
    ]);
    return /*#__PURE__*/ $5FkrB.createElement((0, $deSpz.default), {
        isLoading: isLoading,
        maxHeight: maxHeight,
        maxWidth: maxWidth,
        onClick: closeOnMenuItemClick,
        role: "menu",
        spacing: spacing,
        testId: testId && "".concat(testId, "--menu-group"),
        menuLabel: menuLabel
    }, isLoading ? /*#__PURE__*/ $5FkrB.createElement($f06bf9ec6c91dfbd$var$LoadingIndicator, {
        statusLabel: statusLabel,
        testId: testId && "".concat(testId, "--loading-indicator")
    }) : children);
};
var $f06bf9ec6c91dfbd$export$2e2bcd8739ae039 = $f06bf9ec6c91dfbd$var$MenuWrapper;



var $5FkrB = parcelRequire("5FkrB");

var $eVb4V = parcelRequire("eVb4V");
var $b51d913cd9209fb5$export$756f795847463ebd = /*#__PURE__*/ (0, $5FkrB.createContext)({
    setItemState: (0, $eVb4V.default),
    getItemState: function getItemState() {
        return undefined;
    },
    setGroupState: (0, $eVb4V.default),
    getGroupState: function getGroupState() {
        return {};
    }
});
/**
 * Selection store will persist data as long as it remains mounted.
 * It handles the uncontrolled story for dropdown menu when the menu
 * items can be mounted/unmounted depending if the menu is open or closed.
 */ var $b51d913cd9209fb5$var$SelectionStore = function SelectionStore(props) {
    var children = props.children;
    var store = (0, $5FkrB.useRef)({});
    var context = (0, $5FkrB.useMemo)(function() {
        return {
            setItemState: function setItemState(group, id, value) {
                if (!store.current[group]) store.current[group] = {};
                store.current[group][id] = value;
            },
            getItemState: function getItemState(group, id) {
                if (!store.current[group]) return undefined;
                return store.current[group][id];
            },
            setGroupState: function setGroupState(group, value) {
                store.current[group] = value;
            },
            getGroupState: function getGroupState(group) {
                return store.current[group] || {};
            }
        };
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement($b51d913cd9209fb5$export$756f795847463ebd.Provider, {
        value: context
    }, children);
};
var $b51d913cd9209fb5$export$2e2bcd8739ae039 = $b51d913cd9209fb5$var$SelectionStore;



var $5FkrB = parcelRequire("5FkrB");

var $9Zzpd = parcelRequire("9Zzpd");

// This function is called whenever a MenuItem mounts.
// The refs stored in the context are used to programmatically
// control focus on a user navigates using the keyboard.
function $f64b7069f60f29e6$var$useRegisterItemWithFocusManager() {
    var hasPopup = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    var _useContext = (0, $5FkrB.useContext)((0, $3222b4b178ad4080$export$f18c1d4fc7326096)), registerRef = _useContext.registerRef;
    var itemRef = (0, $5FkrB.useRef)(null);
    (0, $5FkrB.useEffect)(function() {
        if (hasPopup && (0, $9Zzpd.fg)('select-avoid-duplicated-registered-ref')) return;
        registerRef(itemRef);
    }, [
        registerRef,
        hasPopup
    ]);
    return itemRef;
}
var $f64b7069f60f29e6$export$2e2bcd8739ae039 = $f64b7069f60f29e6$var$useRegisterItemWithFocusManager;



var $c363b5f13d60772d$var$_excluded = [
    "ref",
    "aria-controls",
    "aria-expanded",
    "aria-haspopup"
];
function $c363b5f13d60772d$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $c363b5f13d60772d$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $c363b5f13d60772d$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $c363b5f13d60772d$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $c363b5f13d60772d$var$MAX_HEIGHT = "calc(100vh - 16px)";
var $c363b5f13d60772d$var$opposites = {
    top: 'bottom',
    bottom: 'top',
    left: 'right',
    right: 'left',
    start: 'end',
    auto: 'auto',
    end: 'start'
};
var $c363b5f13d60772d$var$getFallbackPlacements = function getFallbackPlacements(placement) {
    var placementPieces = placement.split('-');
    var mainAxis = placementPieces[0];
    // Left, right and auto placements can rely on standard popper sliding behaviour
    if (![
        'top',
        'bottom'
    ].includes(mainAxis)) return undefined;
    else if (placementPieces.length === 2 && [
        'start',
        'end'
    ].includes(placementPieces[1])) {
        var crossAxis = placementPieces[1];
        return [
            "".concat(mainAxis),
            "".concat(mainAxis, "-").concat($c363b5f13d60772d$var$opposites[crossAxis]),
            "".concat($c363b5f13d60772d$var$opposites[mainAxis], "-").concat(crossAxis),
            "".concat($c363b5f13d60772d$var$opposites[mainAxis]),
            "".concat($c363b5f13d60772d$var$opposites[mainAxis], "-").concat($c363b5f13d60772d$var$opposites[crossAxis]),
            'auto'
        ];
    } else return [
        "".concat(mainAxis, "-start"),
        "".concat(mainAxis, "-end"),
        "".concat($c363b5f13d60772d$var$opposites[mainAxis]),
        "".concat($c363b5f13d60772d$var$opposites[mainAxis], "-start"),
        "".concat($c363b5f13d60772d$var$opposites[mainAxis], "-end"),
        "auto"
    ];
};
function $c363b5f13d60772d$var$isKeyboardEvent(event) {
    return event !== null && (event instanceof KeyboardEvent || 'nativeEvent' in event && event.nativeEvent instanceof KeyboardEvent);
}
/**
 * __Dropdown menu__
 *
 * A dropdown menu displays a list of actions or options to a user.
 *
 * - [Examples](https://atlassian.design/components/dropdown-menu/examples)
 * - [Code](https://atlassian.design/components/dropdown-menu/code)
 * - [Usage](https://atlassian.design/components/dropdown-menu/usage)
 */ var $c363b5f13d60772d$var$DropdownMenu = function DropdownMenu(_ref) {
    var _ref$autoFocus = _ref.autoFocus, autoFocus = _ref$autoFocus === void 0 ? false : _ref$autoFocus, children = _ref.children, _ref$defaultOpen = _ref.defaultOpen, defaultOpen = _ref$defaultOpen === void 0 ? false : _ref$defaultOpen, _ref$isLoading = _ref.isLoading, isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading, isOpen = _ref.isOpen, _ref$onOpenChange = _ref.onOpenChange, onOpenChange = _ref$onOpenChange === void 0 ? (0, $eVb4V.default) : _ref$onOpenChange, _ref$placement = _ref.placement, placement = _ref$placement === void 0 ? 'bottom-start' : _ref$placement, _ref$shouldFitContain = _ref.shouldFitContainer, shouldFitContainer = _ref$shouldFitContain === void 0 ? false : _ref$shouldFitContain, _ref$shouldFlip = _ref.shouldFlip, shouldFlip = _ref$shouldFlip === void 0 ? true : _ref$shouldFlip, _ref$shouldRenderToPa = _ref.shouldRenderToParent, shouldRenderToParent = _ref$shouldRenderToPa === void 0 ? false : _ref$shouldRenderToPa, returnFocusRef = _ref.returnFocusRef, spacing = _ref.spacing, statusLabel = _ref.statusLabel, testId = _ref.testId, _trigger = _ref.trigger, _ref$zIndex = _ref.zIndex, zIndex = _ref$zIndex === void 0 ? (0, $bbdb01765230c0ca$export$7be255094ccdc533).modal() : _ref$zIndex, label = _ref.label, interactionName = _ref.interactionName, strategy = _ref.strategy, menuLabel = _ref.menuLabel;
    var _useControlledState = (0, $2oF7I.default)(isOpen, function() {
        return defaultOpen;
    }), _useControlledState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useControlledState, 2), isLocalOpen = _useControlledState2[0], setLocalIsOpen = _useControlledState2[1];
    var triggerRef = (0, $5FkrB.useRef)(null);
    var _useState = (0, $5FkrB.useState)(false), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), isTriggeredUsingKeyboard = _useState2[0], setTriggeredUsingKeyboard = _useState2[1];
    var id = (0, $f506947dac9932b3$export$2e2bcd8739ae039)();
    var itemRef = (0, $f64b7069f60f29e6$export$2e2bcd8739ae039)();
    var _useLayering = (0, $06d0721b7d6dfd7c$export$c8b4d54e03dee6ed)(), currentLevel = _useLayering.currentLevel;
    var fallbackPlacements = (0, $5FkrB.useMemo)(function() {
        return $c363b5f13d60772d$var$getFallbackPlacements(placement);
    }, [
        placement
    ]);
    var handleTriggerClicked = (0, $5FkrB.useCallback)(// TODO: event is an `any` and is being cast incorrectly
    // This means that the public type for `onOpenChange` is incorrect
    // current: (event: React.MouseEvent | React.KeyboardEvent) => void;
    // correct: (event: React.MouseEvent | KeyboardEvent) => void;
    // https://product-fabric.atlassian.net/browse/DSP-4692
    function(event) {
        var newValue = !isLocalOpen;
        var clientX = event.clientX, clientY = event.clientY, type = event.type, detail = event.detail;
        if (type === 'keydown') setTriggeredUsingKeyboard(true);
        else if (clientX === 0 || clientY === 0) // Hitting enter/space is registered as a click
        // with both clientX and clientY === 0
        setTriggeredUsingKeyboard(true);
        else if (detail === 0) // Fix for Safari. clientX and clientY !== 0 in Safari
        setTriggeredUsingKeyboard(true);
        else {
            var _itemRef$current;
            // The trigger element must be focused to avoid problems with an incorrectly focused element after closing DropdownMenu
            itemRef === null || itemRef === void 0 || (_itemRef$current = itemRef.current) === null || _itemRef$current === void 0 || _itemRef$current.focus();
            setTriggeredUsingKeyboard(false);
        }
        setLocalIsOpen(newValue);
        onOpenChange({
            isOpen: newValue,
            event: event
        });
    }, [
        isLocalOpen,
        setLocalIsOpen,
        onOpenChange,
        itemRef
    ]);
    var handleOnClose = (0, $5FkrB.useCallback)(function(event, currentLevel) {
        var _event$target$closest, _event$target;
        var isTabOrEscapeKey = $c363b5f13d60772d$var$isKeyboardEvent(event) && (event.key === 'Tab' || event.key === 'Escape');
        if (event !== null && !isTabOrEscapeKey && event.target instanceof HTMLElement && (_event$target$closest = (_event$target = event.target).closest) !== null && _event$target$closest !== void 0 && _event$target$closest.call(_event$target, "[id^=".concat((0, $f506947dac9932b3$export$8a682ae47622dbb9), "] [aria-haspopup]"))) {
            var _itemRef$current2;
            // Check if it is within dropdown and it is a trigger button
            // if it is a nested dropdown, clicking trigger won't close the dropdown
            // Dropdown can be closed by pressing Escape, Tab or Shift + Tab
            if (!currentLevel) return;
            // if currentLevel is provided, we will compare with the given item's level
            // when it is available and larger than currentLevel, we will proceed the close behavior
            var toCloseLevel = (_itemRef$current2 = itemRef.current) === null || _itemRef$current2 === void 0 ? void 0 : _itemRef$current2.dataset['ds-Level'];
            if (toCloseLevel && Number(toCloseLevel) < currentLevel) return;
        }
        // transfer focus to the element specified by ref
        // if ref is not provided, use old behavior:
        // focus on trigger when <Esc> or <Shift+Tab> is pressed
        if (returnFocusRef) requestAnimationFrame(function() {
            var _returnFocusRef$curre;
            (_returnFocusRef$curre = returnFocusRef.current) === null || _returnFocusRef$curre === void 0 || _returnFocusRef$curre.focus();
        });
        else if ($c363b5f13d60772d$var$isKeyboardEvent(event) && (event.key === 'Tab' && event.shiftKey || event.key === 'Escape')) requestAnimationFrame(function() {
            var _itemRef$current3;
            (_itemRef$current3 = itemRef.current) === null || _itemRef$current3 === void 0 || _itemRef$current3.focus();
        });
        else if (triggerRef.current) {
            var _event$target$closest2, _event$target2;
            // Don't focus the trigger if the click was outside of the menu
            var isClickOutsideMenu = (event === null || event === void 0 ? void 0 : event.target) instanceof HTMLElement && ((_event$target$closest2 = (_event$target2 = event.target).closest) === null || _event$target$closest2 === void 0 ? void 0 : _event$target$closest2.call(_event$target2, '[role="menu"]')) === null;
            var shouldPreventFocus = isClickOutsideMenu && document.activeElement !== document.body; // except if clicking on the body
            if (!shouldPreventFocus) requestAnimationFrame(function() {
                var _triggerRef$current;
                (_triggerRef$current = triggerRef.current) === null || _triggerRef$current === void 0 || _triggerRef$current.focus();
            });
        }
        var newValue = false;
        setLocalIsOpen(newValue);
        onOpenChange({
            isOpen: newValue,
            event: event
        });
    }, [
        itemRef,
        onOpenChange,
        returnFocusRef,
        setLocalIsOpen
    ]);
    var _useFocus = (0, $h7zHk.default)(), isFocused = _useFocus.isFocused, bindFocus = _useFocus.bindFocus;
    // When a trigger is focused, we want to open the dropdown if
    // the user presses the DownArrow
    (0, $5FkrB.useEffect)(function() {
        // Only need to listen for keydown when focused
        if (!isFocused) return 0, $eVb4V.default;
        // Being safe: we don't want to open the dropdown if it is already open
        // Note: This shouldn't happen as the trigger should not be able to get focus
        if (isLocalOpen) return 0, $eVb4V.default;
        return (0, $7QpUe.bind)(window, {
            type: 'keydown',
            listener: function openOnKeyDown(e) {
                var isNestedTriggerButton;
                if (e.target instanceof HTMLElement) isNestedTriggerButton = e.target.closest("[id^=".concat((0, $f506947dac9932b3$export$8a682ae47622dbb9), "] [aria-haspopup]"));
                if (e.key === (0, $lmG37.KEY_DOWN) && !isNestedTriggerButton) {
                    // prevent page scroll
                    e.preventDefault();
                    handleTriggerClicked(e);
                } else if ((e.code === (0, $lmG37.KEY_SPACE) || e.key === (0, $lmG37.KEY_ENTER)) && e.detail === 0) // This allows us to focus on the first element if the dropdown was triggered by a custom trigger with a custom onClick
                setTriggeredUsingKeyboard(true);
                else if (e.key === (0, $lmG37.KEY_TAB) && isNestedTriggerButton) // This closes dropdown if it is a nested dropdown
                handleOnClose(e);
            }
        });
    }, [
        isFocused,
        isLocalOpen,
        handleTriggerClicked,
        handleOnClose
    ]);
    /*
   * The Popup component requires either:
   * - shouldFitContainer={true} and shouldRenderToParent={true | undefined}
   * or
   * - shouldFitContainer={false | undefined} and shouldRenderToParent={true | false | undefined}
   *
   * But not:
   * - shouldFitContainer={true} and shouldRenderToParent={false}
   *
   * By only including either shouldFitContainer or shouldRenderToParent, we can ensure that the Popup component
   * types are satisfied.
   */ var conditionalProps = shouldFitContainer ? {
        shouldFitContainer: shouldFitContainer,
        // When shouldFitContainer is true, `fixed` positions are not allowed
        strategy: strategy !== 'fixed' ? strategy : undefined
    } : {
        shouldRenderToParent: shouldRenderToParent,
        strategy: strategy
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $b51d913cd9209fb5$export$2e2bcd8739ae039), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $jnGKX.default), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        id: isLocalOpen ? id : undefined,
        shouldFlip: shouldFlip,
        isOpen: isLocalOpen,
        shouldReturnFocus: // If returnFocusRef is provided, we **don't** want to return focus to the trigger.
        // Otherwise, Popup will focus on the dropdown trigger after the `returnFocusRef` element is focused.
        returnFocusRef === undefined,
        onClose: handleOnClose,
        zIndex: zIndex,
        placement: placement,
        role: shouldRenderToParent && currentLevel > 0 && (0, $9Zzpd.fg)('platform-dst-nested-dropdown-menu-role') ? 'group' : undefined,
        fallbackPlacements: fallbackPlacements,
        testId: testId && "".concat(testId, "--content"),
        shouldUseCaptureOnOutsideClick: true
    }, conditionalProps, {
        shouldDisableFocusLock: true,
        trigger: function trigger(_ref2) {
            var ref = _ref2.ref, ariaControls = _ref2['aria-controls'], ariaExpanded = _ref2['aria-expanded'], ariaHasPopup = _ref2['aria-haspopup'], rest = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref2, $c363b5f13d60772d$var$_excluded);
            if (typeof _trigger === 'function') return _trigger($c363b5f13d60772d$var$_objectSpread($c363b5f13d60772d$var$_objectSpread($c363b5f13d60772d$var$_objectSpread({
                'aria-controls': ariaControls,
                'aria-expanded': ariaExpanded,
                'aria-haspopup': ariaHasPopup
            }, rest), bindFocus), {}, {
                triggerRef: (0, $iO8GM.default)([
                    ref,
                    triggerRef,
                    itemRef
                ]),
                isSelected: isLocalOpen,
                onClick: handleTriggerClicked,
                testId: testId && "".concat(testId, "--trigger")
            }));
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $dUWEU.default), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, bindFocus, {
                ref: (0, $iO8GM.default)([
                    ref,
                    triggerRef,
                    itemRef
                ]),
                "aria-controls": ariaControls,
                "aria-expanded": ariaExpanded,
                "aria-haspopup": ariaHasPopup,
                isSelected: isLocalOpen,
                iconAfter: function iconAfter(iconProps) {
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8KvTb))), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, iconProps, {
                        size: "small"
                    }));
                },
                onClick: handleTriggerClicked,
                testId: testId && "".concat(testId, "--trigger"),
                "aria-label": label,
                interactionName: interactionName
            }), _trigger);
        },
        content: function content(_ref3) {
            var setInitialFocusRef = _ref3.setInitialFocusRef, update = _ref3.update;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $3222b4b178ad4080$export$2e2bcd8739ae039), {
                onClose: handleOnClose
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $f06bf9ec6c91dfbd$export$2e2bcd8739ae039), {
                spacing: spacing,
                maxHeight: $c363b5f13d60772d$var$MAX_HEIGHT,
                maxWidth: shouldFitContainer ? undefined : 800,
                onClose: handleOnClose,
                onUpdate: update,
                isLoading: isLoading,
                statusLabel: statusLabel,
                setInitialFocusRef: isTriggeredUsingKeyboard || autoFocus ? setInitialFocusRef : undefined,
                shouldRenderToParent: shouldRenderToParent || shouldFitContainer,
                isTriggeredUsingKeyboard: isTriggeredUsingKeyboard,
                autoFocus: autoFocus,
                testId: testId && "".concat(testId, "--menu-wrapper"),
                menuLabel: menuLabel
            }, children));
        }
    })));
};
var $c363b5f13d60772d$export$2e2bcd8739ae039 = $c363b5f13d60772d$var$DropdownMenu;


var $kqp0i = parcelRequire("kqp0i");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");

var $iO8GM = parcelRequire("iO8GM");

var $9vsww = parcelRequire("9vsww");

var $iB6Kj = parcelRequire("iB6Kj");

var $9oB2j = parcelRequire("9oB2j");

var $8bb47f256b42530f$var$_excluded = [
    "children",
    "component",
    "description",
    "elemAfter",
    "elemBefore",
    "href",
    "isDisabled",
    "isSelected",
    "onClick",
    "rel",
    "shouldDescriptionWrap",
    "shouldTitleWrap",
    "target",
    "testId",
    "UNSAFE_shouldDisableRouterLink",
    "returnFocusRef",
    "interactionName",
    "role"
];
/**
 * __Dropdown menu item__
 *
 * A dropdown item populates the dropdown menu with items. Every item should be inside a dropdown item group.
 *
 * - [Examples](https://atlassian.design/components/dropdown-menu/dropdown-item/examples)
 * - [Code](https://atlassian.design/components/dropdown-menu/dropdown-item/code)
 * - [Usage](https://atlassian.design/components/dropdown-menu/dropdown-item/usage)
 */ var $8bb47f256b42530f$var$DropdownMenuItem = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function(_ref, ref) {
    var children = _ref.children, component = _ref.component, description = _ref.description, elemAfter = _ref.elemAfter, elemBefore = _ref.elemBefore, href = _ref.href, isDisabled = _ref.isDisabled, isSelected = _ref.isSelected, onClick = _ref.onClick, rel = _ref.rel, _ref$shouldDescriptio = _ref.shouldDescriptionWrap, shouldDescriptionWrap = _ref$shouldDescriptio === void 0 ? true : _ref$shouldDescriptio, _ref$shouldTitleWrap = _ref.shouldTitleWrap, shouldTitleWrap = _ref$shouldTitleWrap === void 0 ? true : _ref$shouldTitleWrap, target = _ref.target, testId = _ref.testId, UNSAFE_shouldDisableRouterLink = _ref.UNSAFE_shouldDisableRouterLink, returnFocusRef = _ref.returnFocusRef, interactionName = _ref.interactionName, role = _ref.role, rest = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $8bb47f256b42530f$var$_excluded);
    // if the dropdown item has aria-haspopup, we won't register with focus manager
    // since it is a nested trigger, we have registered inside dropdown-menu
    var itemRef = (0, $f64b7069f60f29e6$export$2e2bcd8739ae039)(!!rest['aria-haspopup']);
    var handleItemClick = (0, $5FkrB.useCallback)(function(event) {
        if (returnFocusRef !== null && returnFocusRef !== void 0 && returnFocusRef.current) returnFocusRef.current.focus();
        if (onClick) onClick(event);
    }, [
        onClick,
        returnFocusRef
    ]);
    if (component) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $iB6Kj.default), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        component: component,
        description: description,
        iconAfter: elemAfter,
        iconBefore: elemBefore,
        isDisabled: isDisabled,
        isSelected: isSelected,
        onClick: handleItemClick,
        ref: (0, $iO8GM.default)([
            ref,
            itemRef
        ]),
        shouldDescriptionWrap: shouldDescriptionWrap,
        shouldTitleWrap: shouldTitleWrap,
        testId: testId,
        href: href,
        target: target,
        rel: rel,
        interactionName: interactionName
    }, rest), children);
    else if (href) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $9oB2j.default), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        description: description,
        href: href,
        iconAfter: elemAfter,
        iconBefore: elemBefore,
        isDisabled: isDisabled,
        isSelected: isSelected,
        onClick: handleItemClick,
        ref: (0, $iO8GM.default)([
            ref,
            itemRef
        ]),
        rel: rel,
        role: "menuitem",
        shouldDescriptionWrap: shouldDescriptionWrap,
        shouldTitleWrap: shouldTitleWrap,
        target: target,
        testId: testId,
        UNSAFE_shouldDisableRouterLink: UNSAFE_shouldDisableRouterLink,
        interactionName: interactionName
    }, rest), children);
    else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $9vsww.default), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        description: description,
        iconAfter: elemAfter,
        iconBefore: elemBefore,
        isDisabled: isDisabled,
        isSelected: isSelected,
        onClick: handleItemClick,
        ref: (0, $iO8GM.default)([
            ref,
            itemRef
        ]),
        role: role || 'menuitem',
        shouldDescriptionWrap: shouldDescriptionWrap,
        shouldTitleWrap: shouldTitleWrap,
        testId: testId,
        target: target,
        rel: rel,
        interactionName: interactionName
    }, rest), children);
});
var $8bb47f256b42530f$export$2e2bcd8739ae039 = $8bb47f256b42530f$var$DropdownMenuItem;


var $kqp0i = parcelRequire("kqp0i");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");

var $h8qvJ = parcelRequire("h8qvJ");

var $dP4A1 = parcelRequire("dP4A1");
/* group-title.tsx generated by @compiled/babel-plugin v0.38.1 */ 

var $5FkrB = parcelRequire("5FkrB");

var $e6e2ebcef42e9d72$var$styles = {
    heading: "_11c81vhk _1rjcze3t _18zrpxbi _syazazsu"
};
/**
 * __Group title__
 *
 * Used to visually represent the title for DropdownMenu groups
 *
 * @internal
 */ var $e6e2ebcef42e9d72$var$GroupTitle = function GroupTitle(_ref) {
    var id = _ref.id, title = _ref.title;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $587e6e70fb05b93e$export$2e2bcd8739ae039), {
        "data-ds--menu--heading-item": true,
        role: "menuitem",
        id: id,
        "aria-hidden": "true",
        xcss: $e6e2ebcef42e9d72$var$styles.heading
    }, title);
};
var $e6e2ebcef42e9d72$export$2e2bcd8739ae039 = $e6e2ebcef42e9d72$var$GroupTitle;


var $37db8934527dab08$var$_excluded = [
    "children",
    "id",
    "isList",
    "isScrollable",
    "title",
    "testId",
    "hasSeparator"
];
/**
 * __Dropdown item checkbox group__
 *
 * A wrapping element for dropdown menu items.
 *
 */ var $37db8934527dab08$var$DropdownMenuItemGroup = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function(_ref, ref) {
    var children = _ref.children, id = _ref.id, isList = _ref.isList, isScrollable = _ref.isScrollable, title = _ref.title, testId = _ref.testId, hasSeparator = _ref.hasSeparator, rest = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $37db8934527dab08$var$_excluded);
    var uid = (0, $h8qvJ.useId)();
    var titleId = "dropdown-menu-item-group-title-".concat(uid);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $dP4A1.default), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        id: id,
        ref: ref,
        isList: isList,
        isScrollable: isScrollable,
        hasSeparator: hasSeparator,
        testId: testId,
        titleId: title ? titleId : undefined
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $e6e2ebcef42e9d72$export$2e2bcd8739ae039), {
        id: titleId,
        title: title
    }), children);
});
var $37db8934527dab08$export$2e2bcd8739ae039 = $37db8934527dab08$var$DropdownMenuItemGroup;



var $8KvTb = parcelRequire("8KvTb");
var $b9527ade8db9b437$exports = {};
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ed67385932c28268624e9041c909717e>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty($b9527ade8db9b437$exports, "__esModule", {
    value: true
});
$b9527ade8db9b437$exports.default = void 0;

var $b9527ade8db9b437$var$_react = $b9527ade8db9b437$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $b9527ade8db9b437$var$_chevronLeft = $b9527ade8db9b437$var$_interopRequireDefault((parcelRequire("4r3Kr")));

var $b9527ade8db9b437$var$_chevronLeft2 = $b9527ade8db9b437$var$_interopRequireDefault((parcelRequire("5FzFD")));
function $b9527ade8db9b437$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for ChevronLeftIcon.
 * This component is ChevronLeftIcon, with `UNSAFE_fallbackIcon` set to "ChevronLeftIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Do not use 16px chevrons within buttons, icon buttons, or dropdowns to maintain visual cohesion with ADS which uses 12px chevrons.
Known uses: Navigate back, show previous page of pagination results
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $b9527ade8db9b437$var$ChevronLeftIcon = (props)=>/*#__PURE__*/ $b9527ade8db9b437$var$_react.default.createElement($b9527ade8db9b437$var$_chevronLeft.default, Object.assign({
        name: "ChevronLeftIcon",
        LEGACY_fallbackIcon: $b9527ade8db9b437$var$_chevronLeft2.default
    }, props));
$b9527ade8db9b437$var$ChevronLeftIcon.displayName = 'ChevronLeftIconMigration';
var $b9527ade8db9b437$var$_default = $b9527ade8db9b437$exports.default = $b9527ade8db9b437$var$ChevronLeftIcon;


var $d7744ebe7bbb5920$exports = {};
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::22c67ae37e737f127366f67bd91f64bc>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty($d7744ebe7bbb5920$exports, "__esModule", {
    value: true
});
$d7744ebe7bbb5920$exports.default = void 0;

var $d7744ebe7bbb5920$var$_react = $d7744ebe7bbb5920$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $d7744ebe7bbb5920$var$_chevronRight = $d7744ebe7bbb5920$var$_interopRequireDefault((parcelRequire("aMiKe")));

var $d7744ebe7bbb5920$var$_chevronRight2 = $d7744ebe7bbb5920$var$_interopRequireDefault((parcelRequire("APOYr")));
function $d7744ebe7bbb5920$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for ChevronRightIcon.
 * This component is ChevronRightIcon, with `UNSAFE_fallbackIcon` set to "ChevronRightIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Do not use 16px chevrons within buttons, icon buttons, or dropdowns to maintain visual cohesion with ADS which uses 12px chevrons.
Known uses: Next page of pagination results, collapsed tree item, expand tree item
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $d7744ebe7bbb5920$var$ChevronRightIcon = (props)=>/*#__PURE__*/ $d7744ebe7bbb5920$var$_react.default.createElement($d7744ebe7bbb5920$var$_chevronRight.default, Object.assign({
        name: "ChevronRightIcon",
        LEGACY_fallbackIcon: $d7744ebe7bbb5920$var$_chevronRight2.default
    }, props));
$d7744ebe7bbb5920$var$ChevronRightIcon.displayName = 'ChevronRightIconMigration';
var $d7744ebe7bbb5920$var$_default = $d7744ebe7bbb5920$exports.default = $d7744ebe7bbb5920$var$ChevronRightIcon;



var $fL8KA = parcelRequire("fL8KA");

var $6HG4S = parcelRequire("6HG4S");

var $5FkrB = parcelRequire("5FkrB");

var $5tQm9 = parcelRequire("5tQm9");

var $i2C5U = parcelRequire("i2C5U");
// https://parceljs.org/features/dependency-resolution/#glob-specifiers

























var $1937f0450e0b52d4$export$3770c7a7737d463c = {
    cs: function cs() {
        return (parcelRequire("7BOim"));
    },
    da: function da() {
        return (parcelRequire("lBZGT"));
    },
    de: function de() {
        return (parcelRequire("bGn3J"));
    },
    'en-GB': function enGB() {
        return (parcelRequire("kbs14"));
    },
    'en-ZZ': function enZZ() {
        return (parcelRequire("he924"));
    },
    en: function en() {
        return Promise.resolve((parcelRequire("i2C5U")));
    },
    es: function es() {
        return (parcelRequire("6n0tt"));
    },
    fi: function fi() {
        return (parcelRequire("jpANc"));
    },
    fr: function fr() {
        return (parcelRequire("a0R1n"));
    },
    hu: function hu() {
        return (parcelRequire("8oykS"));
    },
    it: function it() {
        return (parcelRequire("4GjoG"));
    },
    ja: function ja() {
        return (parcelRequire("inXrq"));
    },
    ko: function ko() {
        return (parcelRequire("ix375"));
    },
    nb: function nb() {
        return (parcelRequire("8NjuC"));
    },
    nl: function nl() {
        return (parcelRequire("5kzPX"));
    },
    pl: function pl() {
        return (parcelRequire("7jwnm"));
    },
    'pt-BR': function ptBR() {
        return (parcelRequire("73JLl"));
    },
    ru: function ru() {
        return (parcelRequire("01W4K"));
    },
    sv: function sv() {
        return (parcelRequire("hGuAk"));
    },
    th: function th() {
        return (parcelRequire("e2uAj"));
    },
    tr: function tr() {
        return (parcelRequire("b9qm9"));
    },
    uk: function uk() {
        return (parcelRequire("hk4dg"));
    },
    vi: function vi() {
        return (parcelRequire("Jx3pr"));
    },
    zh_TW: function zh_TW() {
        return (parcelRequire("cFvPh"));
    },
    zh: function zh() {
        return (parcelRequire("hwI6q"));
    }
};


var $c58a4616776b6c56$var$fetchMessagesForLocale = /*#__PURE__*/ function() {
    var _ref = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee(locale) {
        var _asyncLanguages$langu, _localeMessages$defau, languageLocale, localeMessages;
        return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee$(_context) {
            while(true)switch(_context.prev = _context.next){
                case 0:
                    _context.prev = 0;
                    // Fallback to the generic locale if specified one is not found
                    languageLocale = locale in (0, $1937f0450e0b52d4$export$3770c7a7737d463c) ? locale : locale.split(/[-_]/)[0] || ''; // Dynamic import of the locale file
                    _context.next = 4;
                    return (_asyncLanguages$langu = (0, $1937f0450e0b52d4$export$3770c7a7737d463c)[languageLocale]) === null || _asyncLanguages$langu === void 0 ? void 0 : _asyncLanguages$langu.call((0, $1937f0450e0b52d4$export$3770c7a7737d463c));
                case 4:
                    localeMessages = _context.sent;
                    return _context.abrupt("return", (_localeMessages$defau = localeMessages === null || localeMessages === void 0 ? void 0 : localeMessages.default) !== null && _localeMessages$defau !== void 0 ? _localeMessages$defau : (0, $i2C5U.default));
                case 8:
                    _context.prev = 8;
                    _context.t0 = _context["catch"](0);
                case 10:
                    return _context.abrupt("return", (0, $i2C5U.default));
                case 11:
                case "end":
                    return _context.stop();
            }
        }, _callee, null, [
            [
                0,
                8
            ]
        ]);
    }));
    return function fetchMessagesForLocale(_x) {
        return _ref.apply(this, arguments);
    };
}();
var $c58a4616776b6c56$export$460e64eacd3ef998 = function AdminhubIntlProvider(_ref2) {
    var children = _ref2.children;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $5tQm9.default), {
        defaultMessages: (0, $i2C5U.default),
        loaderFn: $c58a4616776b6c56$var$fetchMessagesForLocale
    }, children);
};



var $aRMzY = parcelRequire("aRMzY");
var $97c8fa4180da01bc$export$defe85febe8b728c = (0, $aRMzY.defineMessages)({
    pagination: {
        id: 'admin-hub-pagination.pagination',
        defaultMessage: 'Pagination',
        description: 'Pagination navigation'
    },
    nextPageButton: {
        id: 'admin-hub-pagination.next.page.button',
        defaultMessage: 'Next',
        description: 'Button to go the next page on a paginated table or list'
    },
    previousPageButton: {
        id: 'admin-hub-pagination.previous.page.button',
        defaultMessage: 'Previous',
        description: 'Button to go the previous page on a paginated table or list'
    },
    pageRange: {
        id: 'admin-hub-pagination.page.range',
        defaultMessage: '{itemsStart} to {itemsEnd} results',
        description: 'Indicates which items are currently being shown in the paginated table. example of full sentence "21 to 40 of many results"'
    },
    pageRangeWithTotal: {
        id: 'admin-hub-pagination.page.range.with.total',
        defaultMessage: '{itemsStart} to {itemsEnd} of {totalCount, plural, one {# result} other {# results}}',
        description: 'Indicates which items are currently being shown in the paginated table, total included. example of full sentence "1 to 20 of 678 result."'
    },
    resultsPerPage: {
        id: 'admin-hub-pagination.result.per.page',
        defaultMessage: 'Results per page:',
        description: 'Label for page size selector'
    },
    count: {
        id: 'admin-hub-pagination.refresh.count.total',
        defaultMessage: 'Showing {totalCount} {label}',
        description: 'Table count. This will display count of total number of items in the table.'
    },
    currentCount: {
        id: 'admin-hub-pagination.refresh.count.current',
        defaultMessage: 'Showing {currentCount, plural, one {# result} other {# results}} out of {totalCount} {label}',
        description: 'Table count. This will display filtered count of items in the table.'
    },
    loading: {
        id: 'admin-hub-pagination.refresh.loading',
        defaultMessage: 'Checking for updates',
        description: 'Message to show next to table count while product results are loading'
    },
    defaultItemLabel: {
        id: 'admin-hub-pagination.refresh.item.default.label',
        defaultMessage: '{totalCount, plural, one {Item} other {Items}}',
        description: 'Default label for single record'
    },
    refreshLabel: {
        id: 'admin-hub-pagination.refresh.label',
        defaultMessage: 'Refresh',
        description: 'Accessible label for refresh icon button'
    }
});


var $de3e24ee9809fb70$var$_excluded = [
    "triggerRef"
];
var $de3e24ee9809fb70$var$mediaStyles = {
    paginationBar: "_zulpu2gc _1e0c1txw _1n261g80 _1jxw15zi _1w2v1bp4",
    paginationButtons: "_zulp1b66 _1e0c1txw _4cvr1h6o _2mzuglyw _19pkidpf _19bvze3t _ge25166c",
    paginationSizeSelector: "_zulpu2gc _1e0c1txw _4cvr1h6o _1bahesu3 _4t3i1ejb",
    dropdownWrapper: "_1e0c1txw _4cvr1h6o _1bahesu3 _c71l1ejb",
    paginationContainer: "_1e0c1txw _1bah1yb4 _4t3i1ejb _ge25n7od _1wvzn7od",
    paginationList: "_19pkidpf _1g5lu2gc",
    results: "_1wpz1h6o _2vqh4jg8 _1r8nze3t _1g5lu2gc"
};
var $de3e24ee9809fb70$export$7a33151a69952680 = 'large';
var $de3e24ee9809fb70$export$e256cdbfdb42e93c = {
    small: [
        10,
        20
    ],
    large: [
        20,
        40
    ]
};
var $de3e24ee9809fb70$export$5716e8bcb003888d = $de3e24ee9809fb70$export$e256cdbfdb42e93c[$de3e24ee9809fb70$export$7a33151a69952680][0];
var $de3e24ee9809fb70$export$b4f25c536698a4fa = function PaginationImpl(_ref) {
    var onNextPageClicked = _ref.onNextPageClicked, onPreviousPageClicked = _ref.onPreviousPageClicked, onPageSizeChange = _ref.onPageSizeChange, currentPageStart = _ref.currentPageStart, currentPageEnd = _ref.currentPageEnd, totalItems = _ref.totalItems, hasPreviousPage = _ref.hasPreviousPage, hasNextPage = _ref.hasNextPage, pageSize = _ref.pageSize, pageSizeOptions = _ref.pageSizeOptions, defaultPageSizeOption = _ref.defaultPageSizeOption, menuPlacement = _ref.menuPlacement, nextButtonTestId = _ref.nextButtonTestId, previousButtonTestId = _ref.previousButtonTestId, ariaPreviousLabel = _ref.ariaPreviousLabel, ariaNextLabel = _ref.ariaNextLabel, ariaLabelledBy = _ref.ariaLabelledBy, selectIdProp = _ref.selectId;
    var intl = (0, $6Wx3K.default)();
    var options = pageSizeOptions || $de3e24ee9809fb70$export$e256cdbfdb42e93c[pageSize !== null && pageSize !== void 0 ? pageSize : $de3e24ee9809fb70$export$7a33151a69952680].map(function(value) {
        return {
            label: intl.formatNumber(value),
            value: value
        };
    });
    var defaultValue = defaultPageSizeOption || options[0];
    // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
    var _useState = (0, $5FkrB.useState)((0, $6JfQX.default)()), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 1), fallbackSelectId = _useState2[0];
    var selectId = selectIdProp !== null && selectIdProp !== void 0 ? selectIdProp : fallbackSelectId;
    var _useState3 = (0, $5FkrB.useState)(defaultValue), _useState4 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState3, 2), selectedOption = _useState4[0], setSelectedOption = _useState4[1];
    return hasPreviousPage || hasNextPage ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("div", {
        "data-testid": "pagination",
        className: (0, $970q7.default)([
            $de3e24ee9809fb70$var$mediaStyles.paginationContainer
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("div", {
        className: (0, $970q7.default)([
            $de3e24ee9809fb70$var$mediaStyles.paginationSizeSelector
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("label", {
        id: ariaLabelledBy,
        htmlFor: selectId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $iBNQo.default), (0, $97c8fa4180da01bc$export$defe85febe8b728c).resultsPerPage)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("div", {
        className: (0, $970q7.default)([
            $de3e24ee9809fb70$var$mediaStyles.dropdownWrapper
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $c363b5f13d60772d$export$2e2bcd8739ae039), {
        trigger: function trigger(_ref2) {
            var triggerRef = _ref2.triggerRef, props = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref2, $de3e24ee9809fb70$var$_excluded);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $dUWEU.default), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
                ref: triggerRef
            }, props, {
                iconAfter: function iconAfter(iconProps) {
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8KvTb))), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, iconProps, {
                        size: "small"
                    }));
                },
                spacing: "compact"
            }), selectedOption.label);
        },
        spacing: "compact",
        testId: "pagination-dropdown",
        placement: menuPlacement !== null && menuPlacement !== void 0 ? menuPlacement : 'bottom-start',
        shouldFitContainer: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $37db8934527dab08$export$2e2bcd8739ae039), null, options.map(function(option) {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $8bb47f256b42530f$export$2e2bcd8739ae039), {
            key: option.value,
            onClick: function onClick() {
                setSelectedOption(option);
                onPageSizeChange(option, {
                    action: 'select-option'
                });
            }
        }, option.label);
    }))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("nav", {
        "data-testid": "pagination-nav",
        "aria-label": intl.formatMessage((0, $97c8fa4180da01bc$export$defe85febe8b728c).pagination),
        className: (0, $970q7.default)([
            $de3e24ee9809fb70$var$mediaStyles.paginationBar
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("div", {
        className: (0, $970q7.default)([
            $de3e24ee9809fb70$var$mediaStyles.results
        ])
    }, currentPageStart && currentPageStart > 0 && currentPageEnd && currentPageEnd > 0 && currentPageEnd <= Number(totalItems || currentPageEnd) ? totalItems && totalItems > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $iBNQo.default), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, (0, $97c8fa4180da01bc$export$defe85febe8b728c).pageRangeWithTotal, {
        values: {
            itemsStart: currentPageStart,
            itemsEnd: currentPageEnd,
            totalCount: totalItems
        }
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $iBNQo.default), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, (0, $97c8fa4180da01bc$export$defe85febe8b728c).pageRange, {
        values: {
            itemsStart: currentPageStart,
            itemsEnd: currentPageEnd
        }
    })) : null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("ul", {
        className: (0, $970q7.default)([
            $de3e24ee9809fb70$var$mediaStyles.paginationButtons
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("li", {
        className: (0, $970q7.default)([
            $de3e24ee9809fb70$var$mediaStyles.paginationList
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $dUWEU.default), {
        "aria-label": ariaPreviousLabel ? ariaPreviousLabel : intl.formatMessage((0, $97c8fa4180da01bc$export$defe85febe8b728c).previousPageButton),
        isDisabled: !hasPreviousPage,
        iconBefore: function iconBefore(iconProps) {
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($b9527ade8db9b437$exports))), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, iconProps, {
                size: "small"
            }));
        },
        spacing: "compact",
        testId: nextButtonTestId || 'pagination-previous-button',
        onClick: onPreviousPageClicked
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $iBNQo.default), (0, $97c8fa4180da01bc$export$defe85febe8b728c).previousPageButton))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("li", {
        className: (0, $970q7.default)([
            $de3e24ee9809fb70$var$mediaStyles.paginationList
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $dUWEU.default), {
        "aria-label": ariaNextLabel ? ariaNextLabel : intl.formatMessage((0, $97c8fa4180da01bc$export$defe85febe8b728c).nextPageButton),
        isDisabled: !hasNextPage,
        iconAfter: function iconAfter(iconProps) {
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($d7744ebe7bbb5920$exports))), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, iconProps, {
                size: "small"
            }));
        },
        spacing: "compact",
        testId: previousButtonTestId || 'pagination-next-button',
        onClick: onNextPageClicked
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $iBNQo.default), (0, $97c8fa4180da01bc$export$defe85febe8b728c).nextPageButton)))))) : null;
};
var $de3e24ee9809fb70$export$68f5e1453c188a82 = function Pagination(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $c58a4616776b6c56$export$460e64eacd3ef998), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement($de3e24ee9809fb70$export$b4f25c536698a4fa, props));
};
var $de3e24ee9809fb70$export$2e2bcd8739ae039 = $de3e24ee9809fb70$export$68f5e1453c188a82;



var $5FkrB = parcelRequire("5FkrB");

// Components

parcelRequire("5FkrB");

var $aRMzY = parcelRequire("aRMzY");
var $6Wx3K = parcelRequire("6Wx3K");


var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");

var $7WAD0 = parcelRequire("7WAD0");
/* box.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $kqp0i = parcelRequire("kqp0i");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");
/**
 * This length includes the underscore,
 * e.g. `"_1s4A"` would be a valid atomic group hash.
 */ const $c852510e41af74c4$var$ATOMIC_GROUP_LENGTH = 5;
function $c852510e41af74c4$export$2e2bcd8739ae039(classNames) {
    // Shortcut: nothing to do
    if (!classNames.length) return;
    // Shortcut: don't need to do anything if we only have a single classname
    if (classNames.length === 1 && classNames[0] && // checking to see if `classNames[0]` is a string that contains other classnames
    !classNames[0].includes(' ')) return classNames[0];
    // Using an object rather than a `Map` as it performed better in our benchmarks.
    // Would be happy to move to `Map` if it proved to be better under real conditions.
    const map = {};
    // Note: using loops to minimize iterations over the collection
    for (const value of classNames){
        // Exclude all falsy values, which leaves us with populated strings
        if (!value) continue;
        // a `value` can contain multiple classnames
        const list = value.split(' ');
        for (const className of list){
            /**
             * For atomic style classnames: the `key` is the `group`
             *
             * - Later atomic classnames with the same `group` will override earlier ones
             *   (which is what we want).
             * - Assumes atomic classnames are the only things that start with `_`
             * - Could use a regex to ensure that atomic classnames are structured how we expect,
             *   but did not add that for now as it did slow things down a bit.
             *
             * For other classnames: the `key` is the whole classname
             * - Okay to remove duplicates as doing so does not impact specificity
             *
             * */ const key = className.startsWith('_') ? className.slice(0, $c852510e41af74c4$var$ATOMIC_GROUP_LENGTH) : className;
            map[key] = className;
        }
    }
    /**
     * We are converting the `map` into a string.
     *
     * The simple way to do this would be `Object.values(map).join(' ')`.
     * However, the approach below performs 10%-20% better in benchmarks.
     *
     * For `ax()` it feels right to squeeze as much runtime performance out as we can.
     */ let result = '';
    for(const key in map)result += map[key] + ' ';
    // If we have an empty string, then our `map` was empty.
    if (!result) return;
    // remove last " " from the result (we added " " at the end of every value)
    return result.trimEnd();
}



var $5FkrB = parcelRequire("5FkrB");
var $40a63e0b6a6364d1$export$1ca2a26fecb070ae = /*#__PURE__*/ (0, $5FkrB.createContext)('elevation.surface');
var $40a63e0b6a6364d1$export$1aeb4f6b93c4540d = function useSurface() {
    return (0, $5FkrB.useContext)($40a63e0b6a6364d1$export$1ca2a26fecb070ae);
};
$40a63e0b6a6364d1$export$1ca2a26fecb070ae.displayName = 'SurfaceProvider';


var $3d0c4bddb991ba57$var$_excluded = [
    "as",
    "children",
    "backgroundColor",
    "padding",
    "paddingBlock",
    "paddingBlockStart",
    "paddingBlockEnd",
    "paddingInline",
    "paddingInlineStart",
    "paddingInlineEnd",
    "style",
    "testId",
    "xcss"
], $3d0c4bddb991ba57$var$_excluded2 = [
    "className"
];
// Can either Exclude or Extract - here we're excluding all SVG-related elements, <button> elements (handled by Pressable), and <a> elements (handled by Anchor)
// Basically just ElementType but without ComponentType, it makes sense to keep the "Type" suffix
// eslint-disable-next-line @repo/internal/react/consistent-types-definitions
var $3d0c4bddb991ba57$var$baseStyles = null;
var $3d0c4bddb991ba57$var$backgroundColorMap = {
    'color.background.accent.lime.subtlest': "_bfhkm890",
    'color.background.accent.lime.subtlest.hovered': "_bfhkd4y8",
    'color.background.accent.lime.subtlest.pressed': "_bfhkkuup",
    'color.background.accent.lime.subtler': "_bfhkz2ec",
    'color.background.accent.lime.subtler.hovered': "_bfhk1gf0",
    'color.background.accent.lime.subtler.pressed': "_bfhk2kxc",
    'color.background.accent.lime.subtle': "_bfhkbq5w",
    'color.background.accent.lime.subtle.hovered': "_bfhkfoww",
    'color.background.accent.lime.subtle.pressed': "_bfhk1jbd",
    'color.background.accent.lime.bolder': "_bfhktde4",
    'color.background.accent.lime.bolder.hovered': "_bfhknzpa",
    'color.background.accent.lime.bolder.pressed': "_bfhkh0j0",
    'color.background.accent.red.subtlest': "_bfhk1vk5",
    'color.background.accent.red.subtlest.hovered': "_bfhk1i6i",
    'color.background.accent.red.subtlest.pressed': "_bfhknbir",
    'color.background.accent.red.subtler': "_bfhk1rtt",
    'color.background.accent.red.subtler.hovered': "_bfhkaffd",
    'color.background.accent.red.subtler.pressed': "_bfhk1j5a",
    'color.background.accent.red.subtle': "_bfhkkrt9",
    'color.background.accent.red.subtle.hovered': "_bfhk1sou",
    'color.background.accent.red.subtle.pressed': "_bfhk1fnn",
    'color.background.accent.red.bolder': "_bfhkuibq",
    'color.background.accent.red.bolder.hovered': "_bfhk100f",
    'color.background.accent.red.bolder.pressed': "_bfhk1cl6",
    'color.background.accent.orange.subtlest': "_bfhkf5uh",
    'color.background.accent.orange.subtlest.hovered': "_bfhk19yr",
    'color.background.accent.orange.subtlest.pressed': "_bfhkf90x",
    'color.background.accent.orange.subtler': "_bfhk165s",
    'color.background.accent.orange.subtler.hovered': "_bfhk1ei0",
    'color.background.accent.orange.subtler.pressed': "_bfhkdpo3",
    'color.background.accent.orange.subtle': "_bfhk1kkj",
    'color.background.accent.orange.subtle.hovered': "_bfhk9mfs",
    'color.background.accent.orange.subtle.pressed': "_bfhkaxpp",
    'color.background.accent.orange.bolder': "_bfhk1qg1",
    'color.background.accent.orange.bolder.hovered': "_bfhk12qo",
    'color.background.accent.orange.bolder.pressed': "_bfhk1fyq",
    'color.background.accent.yellow.subtlest': "_bfhkibhp",
    'color.background.accent.yellow.subtlest.hovered': "_bfhkaetg",
    'color.background.accent.yellow.subtlest.pressed': "_bfhk1o1l",
    'color.background.accent.yellow.subtler': "_bfhk1773",
    'color.background.accent.yellow.subtler.hovered': "_bfhk1uw7",
    'color.background.accent.yellow.subtler.pressed': "_bfhk1r9w",
    'color.background.accent.yellow.subtle': "_bfhk8y3s",
    'color.background.accent.yellow.subtle.hovered': "_bfhk819w",
    'color.background.accent.yellow.subtle.pressed': "_bfhk1jx0",
    'color.background.accent.yellow.bolder': "_bfhk1vop",
    'color.background.accent.yellow.bolder.hovered': "_bfhkkjqf",
    'color.background.accent.yellow.bolder.pressed': "_bfhk1okt",
    'color.background.accent.green.subtlest': "_bfhkn729",
    'color.background.accent.green.subtlest.hovered': "_bfhk3utz",
    'color.background.accent.green.subtlest.pressed': "_bfhkyfny",
    'color.background.accent.green.subtler': "_bfhk1wnw",
    'color.background.accent.green.subtler.hovered': "_bfhk1e2h",
    'color.background.accent.green.subtler.pressed': "_bfhkybhx",
    'color.background.accent.green.subtle': "_bfhk1rsu",
    'color.background.accent.green.subtle.hovered': "_bfhk12e3",
    'color.background.accent.green.subtle.pressed': "_bfhk1g86",
    'color.background.accent.green.bolder': "_bfhk1e5c",
    'color.background.accent.green.bolder.hovered': "_bfhka5yi",
    'color.background.accent.green.bolder.pressed': "_bfhk1j68",
    'color.background.accent.teal.subtlest': "_bfhk7xuz",
    'color.background.accent.teal.subtlest.hovered': "_bfhk108c",
    'color.background.accent.teal.subtlest.pressed': "_bfhk1cxp",
    'color.background.accent.teal.subtler': "_bfhk1a17",
    'color.background.accent.teal.subtler.hovered': "_bfhkkwwr",
    'color.background.accent.teal.subtler.pressed': "_bfhk1jb0",
    'color.background.accent.teal.subtle': "_bfhktdv8",
    'color.background.accent.teal.subtle.hovered': "_bfhkzh8h",
    'color.background.accent.teal.subtle.pressed': "_bfhk16zl",
    'color.background.accent.teal.bolder': "_bfhk2c8p",
    'color.background.accent.teal.bolder.hovered': "_bfhkl3ve",
    'color.background.accent.teal.bolder.pressed': "_bfhktor0",
    'color.background.accent.blue.subtlest': "_bfhk1s93",
    'color.background.accent.blue.subtlest.hovered': "_bfhkdaj9",
    'color.background.accent.blue.subtlest.pressed': "_bfhkxm0g",
    'color.background.accent.blue.subtler': "_bfhk1dy8",
    'color.background.accent.blue.subtler.hovered': "_bfhk815t",
    'color.background.accent.blue.subtler.pressed': "_bfhkrwxf",
    'color.background.accent.blue.subtle': "_bfhk115i",
    'color.background.accent.blue.subtle.hovered': "_bfhk9pr4",
    'color.background.accent.blue.subtle.pressed': "_bfhknpx7",
    'color.background.accent.blue.bolder': "_bfhk16e3",
    'color.background.accent.blue.bolder.hovered': "_bfhk1vbm",
    'color.background.accent.blue.bolder.pressed': "_bfhk1xwi",
    'color.background.accent.purple.subtlest': "_bfhkp2ly",
    'color.background.accent.purple.subtlest.hovered': "_bfhkkca2",
    'color.background.accent.purple.subtlest.pressed': "_bfhk1jbm",
    'color.background.accent.purple.subtler': "_bfhk1nm4",
    'color.background.accent.purple.subtler.hovered': "_bfhkattl",
    'color.background.accent.purple.subtler.pressed': "_bfhk3nfk",
    'color.background.accent.purple.subtle': "_bfhk18ah",
    'color.background.accent.purple.subtle.hovered': "_bfhk8bp1",
    'color.background.accent.purple.subtle.pressed': "_bfhk1cd2",
    'color.background.accent.purple.bolder': "_bfhkya33",
    'color.background.accent.purple.bolder.hovered': "_bfhk1af5",
    'color.background.accent.purple.bolder.pressed': "_bfhk6cze",
    'color.background.accent.magenta.subtlest': "_bfhk8tvm",
    'color.background.accent.magenta.subtlest.hovered': "_bfhkr3zd",
    'color.background.accent.magenta.subtlest.pressed': "_bfhk1ckf",
    'color.background.accent.magenta.subtler': "_bfhkv9ra",
    'color.background.accent.magenta.subtler.hovered': "_bfhk1axx",
    'color.background.accent.magenta.subtler.pressed': "_bfhk42ri",
    'color.background.accent.magenta.subtle': "_bfhk1mi6",
    'color.background.accent.magenta.subtle.hovered': "_bfhkrwyz",
    'color.background.accent.magenta.subtle.pressed': "_bfhk6c15",
    'color.background.accent.magenta.bolder': "_bfhkc3uk",
    'color.background.accent.magenta.bolder.hovered': "_bfhk1ok8",
    'color.background.accent.magenta.bolder.pressed': "_bfhkeawv",
    'color.background.accent.gray.subtlest': "_bfhkysee",
    'color.background.accent.gray.subtlest.hovered': "_bfhkwejn",
    'color.background.accent.gray.subtlest.pressed': "_bfhk18ut",
    'color.background.accent.gray.subtler': "_bfhk7qp0",
    'color.background.accent.gray.subtler.hovered': "_bfhk10ef",
    'color.background.accent.gray.subtler.pressed': "_bfhk1rk9",
    'color.background.accent.gray.subtle': "_bfhk18j9",
    'color.background.accent.gray.subtle.hovered': "_bfhk1nv3",
    'color.background.accent.gray.subtle.pressed': "_bfhkq9tj",
    'color.background.accent.gray.bolder': "_bfhk1i45",
    'color.background.accent.gray.bolder.hovered': "_bfhkbyip",
    'color.background.accent.gray.bolder.pressed': "_bfhk1van",
    'color.background.disabled': "_bfhkby5v",
    'color.background.input': "_bfhk1j9a",
    'color.background.input.hovered': "_bfhkl4ek",
    'color.background.input.pressed': "_bfhkr01l",
    'color.background.inverse.subtle': "_bfhk1vck",
    'color.background.inverse.subtle.hovered': "_bfhkmpja",
    'color.background.inverse.subtle.pressed': "_bfhk1gii",
    'color.background.neutral': "_bfhki8nm",
    'color.background.neutral.hovered': "_bfhkplhp",
    'color.background.neutral.pressed': "_bfhk1gdz",
    'color.background.neutral.subtle': "_bfhksm61",
    'color.background.neutral.subtle.hovered': "_bfhk1dpa",
    'color.background.neutral.subtle.pressed': "_bfhkfcek",
    'color.background.neutral.bold': "_bfhk1aqn",
    'color.background.neutral.bold.hovered': "_bfhk1ibz",
    'color.background.neutral.bold.pressed': "_bfhkof27",
    'color.background.selected': "_bfhk15s3",
    'color.background.selected.hovered': "_bfhkufnl",
    'color.background.selected.pressed': "_bfhknozp",
    'color.background.selected.bold': "_bfhkjmqp",
    'color.background.selected.bold.hovered': "_bfhk1q28",
    'color.background.selected.bold.pressed': "_bfhk12kk",
    'color.background.brand.subtlest': "_bfhk1gmr",
    'color.background.brand.subtlest.hovered': "_bfhk3v15",
    'color.background.brand.subtlest.pressed': "_bfhku02c",
    'color.background.brand.bold': "_bfhk1856",
    'color.background.brand.bold.hovered': "_bfhkhf2y",
    'color.background.brand.bold.pressed': "_bfhkg6ey",
    'color.background.brand.boldest': "_bfhk1o4i",
    'color.background.brand.boldest.hovered': "_bfhklefx",
    'color.background.brand.boldest.pressed': "_bfhk16k6",
    'color.background.danger': "_bfhk1gly",
    'color.background.danger.hovered': "_bfhk1yvi",
    'color.background.danger.pressed': "_bfhk1r4b",
    'color.background.danger.bold': "_bfhkybec",
    'color.background.danger.bold.hovered': "_bfhks9hg",
    'color.background.danger.bold.pressed': "_bfhk13a9",
    'color.background.warning': "_bfhk1917",
    'color.background.warning.hovered': "_bfhk19zu",
    'color.background.warning.pressed': "_bfhkzr32",
    'color.background.warning.bold': "_bfhk1kmu",
    'color.background.warning.bold.hovered': "_bfhk1spp",
    'color.background.warning.bold.pressed': "_bfhk4m4m",
    'color.background.success': "_bfhk1y9u",
    'color.background.success.hovered': "_bfhk1vfx",
    'color.background.success.pressed': "_bfhk1wl5",
    'color.background.success.bold': "_bfhkkcmj",
    'color.background.success.bold.hovered': "_bfhky7x8",
    'color.background.success.bold.pressed': "_bfhkwcbh",
    'color.background.discovery': "_bfhk6vm6",
    'color.background.discovery.hovered': "_bfhk12eq",
    'color.background.discovery.pressed': "_bfhk18vq",
    'color.background.discovery.bold': "_bfhku5tj",
    'color.background.discovery.bold.hovered': "_bfhkfqeg",
    'color.background.discovery.bold.pressed': "_bfhk1f1m",
    'color.background.information': "_bfhk19ip",
    'color.background.information.hovered': "_bfhk86z5",
    'color.background.information.pressed': "_bfhk1c1j",
    'color.background.information.bold': "_bfhkx4w0",
    'color.background.information.bold.hovered': "_bfhkq2ii",
    'color.background.information.bold.pressed': "_bfhkf89v",
    'color.blanket': "_bfhk1i5c",
    'color.blanket.selected': "_bfhk7wq0",
    'color.blanket.danger': "_bfhkrprw",
    'color.skeleton': "_bfhkizff",
    'color.skeleton.subtle': "_bfhkvkf5",
    'elevation.surface': "_bfhkvuon",
    'elevation.surface.hovered': "_bfhk19i6",
    'elevation.surface.pressed': "_bfhk13ro",
    'elevation.surface.overlay': "_bfhk1bhr",
    'elevation.surface.overlay.hovered': "_bfhk6o2t",
    'elevation.surface.overlay.pressed': "_bfhkm8nx",
    'elevation.surface.raised': "_bfhkhp5a",
    'elevation.surface.raised.hovered': "_bfhk116u",
    'elevation.surface.raised.pressed': "_bfhk14aj",
    'elevation.surface.sunken': "_bfhkhfxm",
    'utility.elevation.surface.current': "_bfhkchd4"
};
var $3d0c4bddb991ba57$var$CURRENT_SURFACE_CSS_VAR = "--ds-elevation-surface-current";
var $3d0c4bddb991ba57$var$setSurfaceTokenMap = {
    'elevation.surface': "_1q1lvuon",
    'elevation.surface.hovered': "_1q1l19i6",
    'elevation.surface.pressed': "_1q1l13ro",
    'elevation.surface.overlay': "_1q1l1bhr",
    'elevation.surface.overlay.hovered': "_1q1l6o2t",
    'elevation.surface.overlay.pressed': "_1q1lm8nx",
    'elevation.surface.raised': "_1q1lhp5a",
    'elevation.surface.raised.hovered': "_1q1l116u",
    'elevation.surface.raised.pressed': "_1q1l14aj",
    'elevation.surface.sunken': "_1q1lhfxm"
};
var $3d0c4bddb991ba57$var$paddingBlockStartMap = {
    'space.0': "_1q51ze3t",
    'space.025': "_1q51v77o",
    'space.050': "_1q511b66",
    'space.075': "_1q5112x7",
    'space.100': "_1q51u2gc",
    'space.150': "_1q51utpp",
    'space.200': "_1q51pxbi",
    'space.250': "_1q51v47k",
    'space.300': "_1q511ejb",
    'space.400': "_1q51xy5q",
    'space.500': "_1q511jfw",
    'space.600': "_1q51oahv",
    'space.800': "_1q51xncg",
    'space.1000': "_1q511epz"
};
var $3d0c4bddb991ba57$var$paddingBlockEndMap = {
    'space.0': "_85i5ze3t",
    'space.025': "_85i5v77o",
    'space.050': "_85i51b66",
    'space.075': "_85i512x7",
    'space.100': "_85i5u2gc",
    'space.150': "_85i5utpp",
    'space.200': "_85i5pxbi",
    'space.250': "_85i5v47k",
    'space.300': "_85i51ejb",
    'space.400': "_85i5xy5q",
    'space.500': "_85i51jfw",
    'space.600': "_85i5oahv",
    'space.800': "_85i5xncg",
    'space.1000': "_85i51epz"
};
var $3d0c4bddb991ba57$var$paddingInlineStartMap = {
    'space.0': "_bozgze3t",
    'space.025': "_bozgv77o",
    'space.050': "_bozg1b66",
    'space.075': "_bozg12x7",
    'space.100': "_bozgu2gc",
    'space.150': "_bozgutpp",
    'space.200': "_bozgpxbi",
    'space.250': "_bozgv47k",
    'space.300': "_bozg1ejb",
    'space.400': "_bozgxy5q",
    'space.500': "_bozg1jfw",
    'space.600': "_bozgoahv",
    'space.800': "_bozgxncg",
    'space.1000': "_bozg1epz"
};
var $3d0c4bddb991ba57$var$paddingInlineEndMap = {
    'space.0': "_y4tize3t",
    'space.025': "_y4tiv77o",
    'space.050': "_y4ti1b66",
    'space.075': "_y4ti12x7",
    'space.100': "_y4tiu2gc",
    'space.150': "_y4tiutpp",
    'space.200': "_y4tipxbi",
    'space.250': "_y4tiv47k",
    'space.300': "_y4ti1ejb",
    'space.400': "_y4tixy5q",
    'space.500': "_y4ti1jfw",
    'space.600': "_y4tioahv",
    'space.800': "_y4tixncg",
    'space.1000': "_y4ti1epz"
};
/**
 * __Box__
 *
 * A Box is a primitive component that has the design decisions of the Atlassian Design System baked in.
 * Renders a `div` by default.
 *
 * - [Examples](https://atlassian.design/components/primitives/box/examples)
 * - [Code](https://atlassian.design/components/primitives/box/code)
 * - [Usage](https://atlassian.design/components/primitives/box/usage)
 */ var $3d0c4bddb991ba57$var$Box = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? 'div' : _ref$as, children = _ref.children, backgroundColor = _ref.backgroundColor, padding = _ref.padding, _ref$paddingBlock = _ref.paddingBlock, paddingBlock = _ref$paddingBlock === void 0 ? padding : _ref$paddingBlock, _ref$paddingBlockStar = _ref.paddingBlockStart, paddingBlockStart = _ref$paddingBlockStar === void 0 ? paddingBlock : _ref$paddingBlockStar, _ref$paddingBlockEnd = _ref.paddingBlockEnd, paddingBlockEnd = _ref$paddingBlockEnd === void 0 ? paddingBlock : _ref$paddingBlockEnd, _ref$paddingInline = _ref.paddingInline, paddingInline = _ref$paddingInline === void 0 ? padding : _ref$paddingInline, _ref$paddingInlineSta = _ref.paddingInlineStart, paddingInlineStart = _ref$paddingInlineSta === void 0 ? paddingInline : _ref$paddingInlineSta, _ref$paddingInlineEnd = _ref.paddingInlineEnd, paddingInlineEnd = _ref$paddingInlineEnd === void 0 ? paddingInline : _ref$paddingInlineEnd, style = _ref.style, testId = _ref.testId, xcss = _ref.xcss, htmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $3d0c4bddb991ba57$var$_excluded);
    // This is to remove className from safeHtmlAttributes
    // @ts-ignore -- not using expect since it causes issues with help-center local consumption - className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(htmlAttributes, $3d0c4bddb991ba57$var$_excluded2);
    var node = /*#__PURE__*/ $5FkrB.createElement(Component, (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        style: style,
        ref: ref,
        className: (0, $c852510e41af74c4$export$2e2bcd8739ae039)([
            "_19itglyw _vchhusvi _r06hglyw",
            backgroundColor && $3d0c4bddb991ba57$var$backgroundColorMap[backgroundColor],
            backgroundColor && $3d0c4bddb991ba57$var$isSurfaceToken(backgroundColor) && $3d0c4bddb991ba57$var$setSurfaceTokenMap[backgroundColor],
            paddingBlockStart && $3d0c4bddb991ba57$var$paddingBlockStartMap[paddingBlockStart],
            paddingBlockEnd && $3d0c4bddb991ba57$var$paddingBlockEndMap[paddingBlockEnd],
            paddingInlineStart && $3d0c4bddb991ba57$var$paddingInlineStartMap[paddingInlineStart],
            paddingInlineEnd && $3d0c4bddb991ba57$var$paddingInlineEndMap[paddingInlineEnd],
            xcss
        ])
    }, safeHtmlAttributes, {
        "data-testid": testId
    }), children);
    if (backgroundColor) return /*#__PURE__*/ $5FkrB.createElement((0, $40a63e0b6a6364d1$export$1ca2a26fecb070ae).Provider, {
        value: backgroundColor
    }, node);
    return node;
});
var $3d0c4bddb991ba57$export$2e2bcd8739ae039 = $3d0c4bddb991ba57$var$Box;
function $3d0c4bddb991ba57$var$isSurfaceToken(backgroundColor) {
    return backgroundColor in $3d0c4bddb991ba57$var$setSurfaceTokenMap;
}



var $kxpsr = parcelRequire("kxpsr");
// Reds
var $84873b2431594582$export$4b84fd0e2c617bd = '#FFEBE6';
var $84873b2431594582$export$b34b069eff244586 = '#FFBDAD';
var $84873b2431594582$export$be802dd0d8b57f35 = '#FF8F73';
var $84873b2431594582$export$60847d42f9da92a6 = '#FF7452';
var $84873b2431594582$export$4a7404f376229999 = '#FF5630';
var $84873b2431594582$export$2010d0fb4295b346 = '#DE350B';
var $84873b2431594582$export$2837b5a1a71d5c02 = '#BF2600';
var $84873b2431594582$export$8d9596b529bbb9cf = '#FFFAE6';
var $84873b2431594582$export$41060a744ab0b7ae = '#FFF0B3';
var $84873b2431594582$export$1cc05bbbf340e559 = '#FFE380';
var $84873b2431594582$export$5aae31392d72caaa = '#FFC400';
var $84873b2431594582$export$c6930421db9fa514 = '#FFAB00';
var $84873b2431594582$export$59619663aa6500fb = '#FF991F';
var $84873b2431594582$export$874739ea9e379ab6 = '#FF8B00';
var $84873b2431594582$export$8a6341c32b6a3ee6 = '#E3FCEF';
var $84873b2431594582$export$69a3bf21b9686c2b = '#ABF5D1';
var $84873b2431594582$export$afbce1382ec95f73 = '#79F2C0';
var $84873b2431594582$export$747d86715d4175de = '#57D9A3';
var $84873b2431594582$export$940e1f69e873f202 = '#36B37E';
var $84873b2431594582$export$a49394138f7b8e85 = '#00875A';
var $84873b2431594582$export$6fa04827ac68a4fb = '#006644';
var $84873b2431594582$export$226de0355ed012f8 = '#DEEBFF';
var $84873b2431594582$export$8c13c2ee36917869 = '#B3D4FF';
var $84873b2431594582$export$ecfc1dff386a3e7a = '#4C9AFF';
var $84873b2431594582$export$215b7063051591f1 = '#2684FF';
var $84873b2431594582$export$e62e8919cca44969 = '#0065FF';
var $84873b2431594582$export$b3de0ae08da2ce64 = '#0052CC';
var $84873b2431594582$export$a6ee3d71bc067634 = '#0747A6';
var $84873b2431594582$export$67f15409e87642a1 = '#669DF1';
var $84873b2431594582$export$f0539dbc42dbb067 = '#8FB8F6';
var $84873b2431594582$export$363e4475840015bb = '#EAE6FF';
var $84873b2431594582$export$4b0a4417ed59760f = '#C0B6F2';
var $84873b2431594582$export$6011520a64d9a187 = '#998DD9';
var $84873b2431594582$export$a7175d4e9206bc80 = '#8777D9';
var $84873b2431594582$export$b48405b95304b5a1 = '#6554C0';
var $84873b2431594582$export$c71e4279dd54a18d = '#5243AA';
var $84873b2431594582$export$147899de772240ec = '#403294';
var $84873b2431594582$export$2cf711fe14c66f06 = '#E6FCFF';
var $84873b2431594582$export$7a8f4d33f6f9772c = '#B3F5FF';
var $84873b2431594582$export$776c9c497ef08533 = '#79E2F2';
var $84873b2431594582$export$69cb3ca10c1e330e = '#00C7E6';
var $84873b2431594582$export$9dc1ef0f3f48059b = '#00B8D9';
var $84873b2431594582$export$7c835c78b6fcdef8 = '#00A3BF';
var $84873b2431594582$export$6036577f95c3877e = '#008DA6';
var $84873b2431594582$export$29a4f05edc054374 = '#FFFFFF';
var $84873b2431594582$export$e655ef011c4aa1a2 = '#FAFBFC';
var $84873b2431594582$export$9fdfb749e33cdf97 = '#F4F5F7';
var $84873b2431594582$export$3e51e8f1440314ba = '#EBECF0';
var $84873b2431594582$export$1ce2d1575d444ceb = '#DFE1E6';
var $84873b2431594582$export$8754fc7e6d8b3000 = '#C1C7D0';
var $84873b2431594582$export$c2e91cbeada39b8b = '#B3BAC5';
var $84873b2431594582$export$5f71e19f3a7ad9de = '#A5ADBA';
var $84873b2431594582$export$eaa8c8a70ac22806 = '#97A0AF';
var $84873b2431594582$export$7c87d337fb91a97d = '#8993A4';
var $84873b2431594582$export$d6447c357493214f = '#7A869A';
var $84873b2431594582$export$f563ee71e9ee74cd = '#6B778C';
var $84873b2431594582$export$e2ef2124cf4024b1 = '#5E6C84';
var $84873b2431594582$export$eece5f492e429f08 = '#505F79';
var $84873b2431594582$export$c39c0fe0f26207ae = '#42526E';
var $84873b2431594582$export$7090862dc3038a9f = '#344563';
var $84873b2431594582$export$ad0bacf983b7ddaa = '#253858';
var $84873b2431594582$export$7d61b15e0da132af = '#172B4D';
var $84873b2431594582$export$fbda843f0a27fe96 = '#091E42';
var $84873b2431594582$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
var $84873b2431594582$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
var $84873b2431594582$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
var $84873b2431594582$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
var $84873b2431594582$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
var $84873b2431594582$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
var $84873b2431594582$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
var $84873b2431594582$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
var $84873b2431594582$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
var $84873b2431594582$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
var $84873b2431594582$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
var $84873b2431594582$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
var $84873b2431594582$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
var $84873b2431594582$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
var $84873b2431594582$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
var $84873b2431594582$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
var $84873b2431594582$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
var $84873b2431594582$export$2f6319cf7d736c2a = '#E6EDFA';
var $84873b2431594582$export$95126bc8884d6634 = '#DCE5F5';
var $84873b2431594582$export$8338d8c35d44ff1 = '#CED9EB';
var $84873b2431594582$export$5368d76ae4fbbda7 = '#B8C7E0';
var $84873b2431594582$export$9f0a771d16ec8d36 = '#ABBBD6';
var $84873b2431594582$export$abcf8c38338b4aa5 = '#9FB0CC';
var $84873b2431594582$export$97e81faa16a182c7 = '#8C9CB8';
var $84873b2431594582$export$bfe21c59123ecf33 = '#7988A3';
var $84873b2431594582$export$ee82aa2ea6a1558 = '#67758F';
var $84873b2431594582$export$682927c6ed76be02 = '#56637A';
var $84873b2431594582$export$91fd9994c5be9757 = '#455166';
var $84873b2431594582$export$d281fbfe3cff2df6 = '#3B475C';
var $84873b2431594582$export$3902c91d8b98a753 = '#313D52';
var $84873b2431594582$export$8e8133c1ba5845b5 = '#283447';
var $84873b2431594582$export$33ff357f6620b39 = '#202B3D';
var $84873b2431594582$export$633847cf062b69e0 = '#1B2638';
var $84873b2431594582$export$9776a6e503bdbf76 = '#121A29';
var $84873b2431594582$export$6c813d5160dff5db = '#0E1624';
var $84873b2431594582$export$3d4f271a500072a = '#0D1424';
var $84873b2431594582$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
var $84873b2431594582$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
var $84873b2431594582$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
var $84873b2431594582$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
var $84873b2431594582$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
var $84873b2431594582$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
var $84873b2431594582$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
var $84873b2431594582$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
var $84873b2431594582$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
var $84873b2431594582$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
var $84873b2431594582$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
var $84873b2431594582$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
var $84873b2431594582$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
var $84873b2431594582$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
var $84873b2431594582$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
var $84873b2431594582$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
var $84873b2431594582$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';
var $84873b2431594582$export$d2adc5dedf09fced = '#292A2E';
var $84873b2431594582$export$f51762073d2bb381 = '#94C748';
var $84873b2431594582$export$95e26d54def96891 = '#B3DF72';


var $0a8491a5f0c98b2c$export$44ffba16bd48dac6 = '__ATLASKIT_THEME__';
var $0a8491a5f0c98b2c$export$c93026a968943f95 = 'light';
var $0a8491a5f0c98b2c$export$6ba72c8346b4c57e = [
    'light',
    'dark'
];
var $0a8491a5f0c98b2c$export$8e24544ddba725ee = function focusRing() {
    var color = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "var(--ds-border-focused, ".concat((0, $84873b2431594582$export$215b7063051591f1), ")");
    var outlineWidth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
    (0, $kxpsr.default)('@atlaskit/theme', 'focus ring mixin', 'Please use `@atlaskit/focus-ring` instead.');
    return "\n  &:focus {\n    outline: none;\n    box-shadow: 0px 0px 0px ".concat(outlineWidth, "px ").concat(color, ";\n  }\n");
};
var $0a8491a5f0c98b2c$export$c0dd343266bc3261 = function noFocusRing() {
    return "\n  box-shadow: none;\n";
};
var $0a8491a5f0c98b2c$export$7be255094ccdc533 = {
    card: function card() {
        return 100;
    },
    navigation: function navigation() {
        return 200;
    },
    dialog: function dialog() {
        return 300;
    },
    layer: function layer() {
        return 400;
    },
    blanket: function blanket() {
        return 500;
    },
    modal: function modal() {
        return 510;
    },
    flag: function flag() {
        return 600;
    },
    spotlight: function spotlight() {
        return 700;
    },
    tooltip: function tooltip() {
        return 9999;
    }
};
var $0a8491a5f0c98b2c$export$a1b3edb637fb4f35 = function visuallyHidden() {
    (0, $kxpsr.default)('@atlaskit/theme', 'visually hidden mixin', 'Please use `@atlaskit/visually-hidden` instead.');
    return {
        border: '0 !important',
        clip: 'rect(1px, 1px, 1px, 1px) !important',
        height: '1px !important',
        overflow: 'hidden !important',
        padding: '0 !important',
        position: 'absolute !important',
        width: '1px !important',
        whiteSpace: 'nowrap !important'
    };
};
var $0a8491a5f0c98b2c$export$ba1d834b86d72a09 = $0a8491a5f0c98b2c$export$a1b3edb637fb4f35;
var $0a8491a5f0c98b2c$export$e497e856b4f89fcd = function skeletonShimmer() {
    return {
        css: {
            backgroundColor: "var(--ds-skeleton, ".concat((0, $84873b2431594582$export$8d43898f60b96a82), ")"),
            animationDuration: '1.5s',
            animationIterationCount: 'infinite',
            animationTimingFunction: 'linear',
            animationDirection: 'alternate'
        },
        keyframes: {
            from: {
                backgroundColor: "var(--ds-skeleton, ".concat((0, $84873b2431594582$export$8d43898f60b96a82), ")")
            },
            to: {
                backgroundColor: "var(--ds-skeleton-subtle, ".concat((0, $84873b2431594582$export$920c0d5c49070351), ")")
            }
        }
    };
};



var $kqp0i = parcelRequire("kqp0i");

var $5FkrB = parcelRequire("5FkrB");
/* popup.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");


var $h8qvJ = parcelRequire("h8qvJ");

var $8IltX = parcelRequire("8IltX");

var $iUCre = parcelRequire("iUCre");

var $9Zzpd = parcelRequire("9Zzpd");

var $hvYLl = parcelRequire("hvYLl");
var $agyC9 = parcelRequire("agyC9");

var $5FkrB = parcelRequire("5FkrB");

var $9Zzpd = parcelRequire("9Zzpd");

var $5FkrB = parcelRequire("5FkrB");

var $aLeHs = parcelRequire("aLeHs");
/* index.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $kqp0i = parcelRequire("kqp0i");

var $fL8KA = parcelRequire("fL8KA");

var $25nEq = parcelRequire("25nEq");

var $iYJcE = parcelRequire("iYJcE");

var $970q7 = parcelRequire("970q7");

var $6HG4S = parcelRequire("6HG4S");

var $5FkrB = parcelRequire("5FkrB");

var $7QpUe = parcelRequire("7QpUe");

var $9Zzpd = parcelRequire("9Zzpd");

var $25nEq = parcelRequire("25nEq");

var $9Zzpd = parcelRequire("9Zzpd");

var $iy6kx = parcelRequire("iy6kx");

var $4ZYyc = parcelRequire("4ZYyc");

var $ekGgq = parcelRequire("ekGgq");

var $iYJcE = parcelRequire("iYJcE");

var $4ZYyc = parcelRequire("4ZYyc");
var $34d8d50b2823f882$var$themeKinds = [
    'light',
    'dark',
    'spacing',
    'typography',
    'shape'
];
var $34d8d50b2823f882$var$customThemeOptions = 'UNSAFE_themeOptions';
var $34d8d50b2823f882$var$isThemeKind = function isThemeKind(themeKind) {
    return $34d8d50b2823f882$var$themeKinds.find(function(kind) {
        return kind === themeKind;
    }) !== undefined;
};
var $34d8d50b2823f882$var$isThemeIds = function isThemeIds(themeId) {
    return (0, $4ZYyc.themeIds).find(function(id) {
        return id === themeId;
    }) !== undefined;
};
var $34d8d50b2823f882$var$isColorMode = function isColorMode(modeId) {
    return [
        'light',
        'dark',
        'auto'
    ].includes(modeId);
};
var $34d8d50b2823f882$export$f19b488f7c0547ee = function themeStringToObject(themeState) {
    return themeState.split(' ')// @ts-ignore - TS1501 TypeScript 5.9.2 upgrade
    .map(function(theme) {
        return theme.split(/:([^]*)/);
    }).reduce(function(themeObject, _ref) {
        var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_ref, 2), kind = _ref2[0], id = _ref2[1];
        if (kind === 'colorMode' && $34d8d50b2823f882$var$isColorMode(id)) themeObject[kind] = id;
        if ($34d8d50b2823f882$var$isThemeKind(kind) && $34d8d50b2823f882$var$isThemeIds(id)) // @ts-expect-error FIXME - this is a valid ts error
        themeObject[kind] = id;
        if (kind === $34d8d50b2823f882$var$customThemeOptions) try {
            themeObject[$34d8d50b2823f882$var$customThemeOptions] = JSON.parse(id);
        } catch (_unused) {
            new Error('Invalid custom theme string');
        }
        return themeObject;
    }, {});
};
var $34d8d50b2823f882$export$62c37ab81302621a = function themeObjectToString(themeState) {
    return Object.entries(themeState).reduce(function(themeString, _ref3) {
        var _ref4 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_ref3, 2), kind = _ref4[0], id = _ref4[1];
        if (// colorMode theme state
        kind === 'colorMode' && typeof id === 'string' && $34d8d50b2823f882$var$isColorMode(id) || // custom theme state
        kind === $34d8d50b2823f882$var$customThemeOptions && (0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(id) === 'object' || // other theme states
        $34d8d50b2823f882$var$isThemeKind(kind) && typeof id === 'string' && $34d8d50b2823f882$var$isThemeIds(id)) return themeString + "".concat(themeString ? ' ' : '') + "".concat(kind, ":").concat((0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(id) === 'object' ? JSON.stringify(id) : id);
        return themeString;
    }, '');
};



var $cp9Zt = parcelRequire("cp9Zt");

var $8jjS7 = parcelRequire("8jjS7");
function $41d75aa14cb33765$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $41d75aa14cb33765$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $41d75aa14cb33765$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $41d75aa14cb33765$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $41d75aa14cb33765$var$defaultColorMode = 'light';
var $41d75aa14cb33765$var$defaultContrastMode = 'no-preference';
/**
 * Server-side rendering utility. Generates the valid HTML attributes for a given theme.
 * Note: this utility does not handle automatic theme switching.
 *
 * @param {Object<string, string>} themeOptions - Theme options object
 * @param {string} themeState.colorMode Determines which color theme is applied. If set to `auto`, the theme applied will be determined by the OS setting.
 * @param {string} themeState.dark The color theme to be applied when the color mode resolves to 'dark'.
 * @param {string} themeState.light The color theme to be applied when the color mode resolves to 'light'.
 * @param {string} themeState.spacing The spacing theme to be applied.
 * @param {string} themeState.typography The typography theme to be applied.
 * @param {Object} themeState.UNSAFE_themeOptions The custom branding options to be used for custom theme generation
 *
 * @returns {Object} Object of HTML attributes to be applied to the document root
 */ var $41d75aa14cb33765$var$getThemeHtmlAttrs = function getThemeHtmlAttrs() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, _ref$colorMode = _ref.colorMode, colorMode = _ref$colorMode === void 0 ? (0, $4ZYyc.themeStateDefaults)['colorMode'] : _ref$colorMode, _ref$dark = _ref.dark, dark = _ref$dark === void 0 ? (0, $4ZYyc.themeStateDefaults)['dark'] : _ref$dark, _ref$light = _ref.light, light = _ref$light === void 0 ? (0, $4ZYyc.themeStateDefaults)['light'] : _ref$light, _ref$contrastMode = _ref.contrastMode, contrastMode = _ref$contrastMode === void 0 ? (0, $4ZYyc.themeStateDefaults)['contrastMode'] : _ref$contrastMode, _ref$shape = _ref.shape, shape = _ref$shape === void 0 ? (0, $4ZYyc.themeStateDefaults)['shape']() : _ref$shape, _ref$spacing = _ref.spacing, spacing = _ref$spacing === void 0 ? (0, $4ZYyc.themeStateDefaults)['spacing'] : _ref$spacing, _ref$typography = _ref.typography, typography = _ref$typography === void 0 ? (0, $4ZYyc.themeStateDefaults)['typography'] : _ref$typography, _ref$UNSAFE_themeOpti = _ref.UNSAFE_themeOptions, UNSAFE_themeOptions = _ref$UNSAFE_themeOpti === void 0 ? (0, $4ZYyc.themeStateDefaults)['UNSAFE_themeOptions'] : _ref$UNSAFE_themeOpti;
    var themeAttribute = (0, $34d8d50b2823f882$export$62c37ab81302621a)({
        dark: dark,
        light: light,
        shape: shape,
        spacing: spacing,
        typography: typography
    });
    var result = (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, (0, $iy6kx.THEME_DATA_ATTRIBUTE), themeAttribute), (0, $iy6kx.COLOR_MODE_ATTRIBUTE), colorMode === 'auto' ? $41d75aa14cb33765$var$defaultColorMode : colorMode);
    if ((0, $9Zzpd.fg)('platform_increased-contrast-themes')) result = $41d75aa14cb33765$var$_objectSpread($41d75aa14cb33765$var$_objectSpread({}, result), {}, (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, (0, $iy6kx.CONTRAST_MODE_ATTRIBUTE), contrastMode === 'auto' ? $41d75aa14cb33765$var$defaultContrastMode : contrastMode));
    if (UNSAFE_themeOptions && (0, $cp9Zt.isValidBrandHex)(UNSAFE_themeOptions.brandColor)) {
        var optionString = JSON.stringify(UNSAFE_themeOptions);
        var uniqueId = (0, $8jjS7.hash)(optionString);
        result[0, $iy6kx.CUSTOM_THEME_ATTRIBUTE] = uniqueId;
    }
    return result;
};
var $41d75aa14cb33765$export$2e2bcd8739ae039 = $41d75aa14cb33765$var$getThemeHtmlAttrs;


var $25nEq = parcelRequire("25nEq");

var $fL8KA = parcelRequire("fL8KA");

var $6HG4S = parcelRequire("6HG4S");

var $9Zzpd = parcelRequire("9Zzpd");

var $25nEq = parcelRequire("25nEq");

var $iy6kx = parcelRequire("iy6kx");

var $4ZYyc = parcelRequire("4ZYyc");

function $6e1f29b6969d643f$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $6e1f29b6969d643f$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $6e1f29b6969d643f$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $6e1f29b6969d643f$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $6e1f29b6969d643f$var$isThemeColorMode = function isThemeColorMode(colorMode) {
    return (0, $4ZYyc.themeColorModes).find(function(mode) {
        return mode === colorMode;
    }) !== undefined;
};
var $6e1f29b6969d643f$var$getGlobalTheme = function getGlobalTheme() {
    if (typeof document === 'undefined') return {};
    var element = document.documentElement;
    var colorMode = element.getAttribute((0, $iy6kx.COLOR_MODE_ATTRIBUTE)) || '';
    var theme = element.getAttribute((0, $iy6kx.THEME_DATA_ATTRIBUTE)) || '';
    return $6e1f29b6969d643f$var$_objectSpread($6e1f29b6969d643f$var$_objectSpread({}, (0, $34d8d50b2823f882$export$f19b488f7c0547ee)(theme)), $6e1f29b6969d643f$var$isThemeColorMode(colorMode) && {
        colorMode: colorMode
    });
};
var $6e1f29b6969d643f$export$2e2bcd8739ae039 = $6e1f29b6969d643f$var$getGlobalTheme;



var $4ZYyc = parcelRequire("4ZYyc");

var $cp9Zt = parcelRequire("cp9Zt");

var $iYJcE = parcelRequire("iYJcE");

var $9Zzpd = parcelRequire("9Zzpd");


var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $25nEq = parcelRequire("25nEq");

var $7QpUe = parcelRequire("7QpUe");

var $iy6kx = parcelRequire("iy6kx");

var $fL8KA = parcelRequire("fL8KA");

var $6HG4S = parcelRequire("6HG4S");
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 *
 * This file contains a dynamic import for each theme this package exports.
 * Themes are loaded asynchronously at runtime to minimise the amount of CSS we send to the client.
 * This allows users to compose their themes and only use the tokens that are requested.
 * When a new theme is created, the import should automatically be added to the map
 *
 * @codegen <<SignedSource::926662cc712c2c412c8b6b4cdcd8d64f>>
 * @codegenCommand yarn build tokens
 */ 










var $0f156a5e996217a5$var$themeImportsMap = {
    'light': function light() {
        return (parcelRequire("c2YxD"));
    },
    'light-future': function lightFuture() {
        return (parcelRequire("71lDz"));
    },
    'light-increased-contrast': function lightIncreasedContrast() {
        return (parcelRequire("gID4c"));
    },
    'dark': function dark() {
        return (parcelRequire("e9VLP"));
    },
    'dark-future': function darkFuture() {
        return (parcelRequire("80flm"));
    },
    'dark-increased-contrast': function darkIncreasedContrast() {
        return (parcelRequire("kp4iJ"));
    },
    'legacy-light': function legacyLight() {
        return (parcelRequire("2ttq9"));
    },
    'legacy-dark': function legacyDark() {
        return (parcelRequire("l0jav"));
    },
    'spacing': function spacing() {
        return (parcelRequire("dwO5k"));
    },
    'typography': function typography() {
        return (parcelRequire("01DTH"));
    },
    'shape': function shape() {
        return (parcelRequire("4enTl"));
    }
};
var $0f156a5e996217a5$export$2e2bcd8739ae039 = $0f156a5e996217a5$var$themeImportsMap;



var $iy6kx = parcelRequire("iy6kx");
var $93121ced7575746f$export$26cd7ae85c7144e5 = /*#__PURE__*/ function() {
    var _ref = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee(themeId) {
        var themeCss, style;
        return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee$(_context) {
            while(true)switch(_context.prev = _context.next){
                case 0:
                    if (!document.head.querySelector("style[".concat((0, $iy6kx.THEME_DATA_ATTRIBUTE), "=\"").concat(themeId, "\"]:not([").concat((0, $iy6kx.CUSTOM_THEME_ATTRIBUTE), "])"))) {
                        _context.next = 2;
                        break;
                    }
                    return _context.abrupt("return");
                case 2:
                    if (themeId) {
                        _context.next = 4;
                        break;
                    }
                    return _context.abrupt("return");
                case 4:
                    _context.next = 6;
                    return $93121ced7575746f$export$8a48286ed7df6720(themeId);
                case 6:
                    themeCss = _context.sent;
                    style = document.createElement('style');
                    style.textContent = themeCss;
                    style.dataset.theme = themeId;
                    document.head.appendChild(style);
                case 11:
                case "end":
                    return _context.stop();
            }
        }, _callee);
    }));
    return function loadAndAppendThemeCss(_x) {
        return _ref.apply(this, arguments);
    };
}();
var $93121ced7575746f$export$8a48286ed7df6720 = /*#__PURE__*/ function() {
    var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee2(themeId) {
        var _yield$themeImportMap, themeCss;
        return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee2$(_context2) {
            while(true)switch(_context2.prev = _context2.next){
                case 0:
                    _context2.next = 2;
                    return (0, $0f156a5e996217a5$export$2e2bcd8739ae039)[themeId]();
                case 2:
                    _yield$themeImportMap = _context2.sent;
                    themeCss = _yield$themeImportMap.default;
                    return _context2.abrupt("return", themeCss);
                case 5:
                case "end":
                    return _context2.stop();
            }
        }, _callee2);
    }));
    return function loadThemeCss(_x2) {
        return _ref2.apply(this, arguments);
    };
}();
var $93121ced7575746f$export$bb1e815119d30f8b = '(prefers-color-scheme: dark)';
var $93121ced7575746f$export$8662df6937d86fcb = '(prefers-contrast: more)';


var $67b638d9cfe2c103$var$isMatchMediaAvailable = typeof window !== 'undefined' && 'matchMedia' in window;
/**
 * Updates the current theme when the system theme changes. Should be bound
 * to an event listener listening on the '(prefers-color-scheme: dark)' query
 * @param e The event representing a change in system theme.
 */ function $67b638d9cfe2c103$var$checkNativeListener(e) {
    var element = document.documentElement;
    element.setAttribute((0, $iy6kx.COLOR_MODE_ATTRIBUTE), e.matches ? 'dark' : 'light');
}
var $67b638d9cfe2c103$var$darkModeMql = $67b638d9cfe2c103$var$isMatchMediaAvailable && window.matchMedia((0, $93121ced7575746f$export$bb1e815119d30f8b));
var $67b638d9cfe2c103$var$ColorModeObserver = /*#__PURE__*/ function() {
    function ColorModeObserver() {
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, ColorModeObserver);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "unbindThemeChangeListener", null);
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(ColorModeObserver, [
        {
            key: "getColorMode",
            value: function getColorMode() {
                if (!$67b638d9cfe2c103$var$darkModeMql) return 'light';
                return $67b638d9cfe2c103$var$darkModeMql !== null && $67b638d9cfe2c103$var$darkModeMql !== void 0 && $67b638d9cfe2c103$var$darkModeMql.matches ? 'dark' : 'light';
            }
        },
        {
            key: "bind",
            value: function bind() {
                if ($67b638d9cfe2c103$var$darkModeMql && this.unbindThemeChangeListener === null) this.unbindThemeChangeListener = (0, $7QpUe.bind)($67b638d9cfe2c103$var$darkModeMql, {
                    type: 'change',
                    listener: $67b638d9cfe2c103$var$checkNativeListener
                });
            }
        },
        {
            key: "unbind",
            value: function unbind() {
                if (this.unbindThemeChangeListener) {
                    this.unbindThemeChangeListener();
                    this.unbindThemeChangeListener = null;
                }
            }
        }
    ]);
}();
/**
 * A singleton color mode observer - binds "auto" switching logic to a single `mediaQueryList` listener
 * that can be unbound by any consumer when no longer needed.
 */ var $67b638d9cfe2c103$var$SingletonColorModeObserver = new $67b638d9cfe2c103$var$ColorModeObserver();
var $67b638d9cfe2c103$export$2e2bcd8739ae039 = $67b638d9cfe2c103$var$SingletonColorModeObserver;



var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $25nEq = parcelRequire("25nEq");

var $7QpUe = parcelRequire("7QpUe");

var $iy6kx = parcelRequire("iy6kx");

var $de5d818a744f5116$var$isMatchMediaAvailable = typeof window !== 'undefined' && 'matchMedia' in window;
/**
 * Updates the current theme when the system contrast preference changes. Should be bound
 * to an event listener listening on the '(prefers-contrast: more)' query
 * @param e The event representing a change in system theme.
 */ function $de5d818a744f5116$var$checkNativeListener(e) {
    var element = document.documentElement;
    element.setAttribute((0, $iy6kx.CONTRAST_MODE_ATTRIBUTE), e.matches ? 'more' : 'no-preference');
}
var $de5d818a744f5116$var$contrastModeMql = $de5d818a744f5116$var$isMatchMediaAvailable && window.matchMedia((0, $93121ced7575746f$export$8662df6937d86fcb));
var $de5d818a744f5116$var$ContrastModeObserver = /*#__PURE__*/ function() {
    function ContrastModeObserver() {
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, ContrastModeObserver);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "unbindContrastChangeListener", null);
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(ContrastModeObserver, [
        {
            key: "getContrastMode",
            value: function getContrastMode() {
                if (!$de5d818a744f5116$var$contrastModeMql) return 'no-preference';
                return $de5d818a744f5116$var$contrastModeMql !== null && $de5d818a744f5116$var$contrastModeMql !== void 0 && $de5d818a744f5116$var$contrastModeMql.matches ? 'more' : 'no-preference';
            }
        },
        {
            key: "bind",
            value: function bind() {
                if ($de5d818a744f5116$var$contrastModeMql && this.unbindContrastChangeListener === null) this.unbindContrastChangeListener = (0, $7QpUe.bind)($de5d818a744f5116$var$contrastModeMql, {
                    type: 'change',
                    listener: $de5d818a744f5116$var$checkNativeListener
                });
            }
        },
        {
            key: "unbind",
            value: function unbind() {
                if (this.unbindContrastChangeListener) {
                    this.unbindContrastChangeListener();
                    this.unbindContrastChangeListener = null;
                }
            }
        }
    ]);
}();
/**
 * A singleton contrast mode observer - binds "auto" switching logic to a single `mediaQueryList` listener
 * that can be unbound by any consumer when no longer needed.
 */ var $de5d818a744f5116$var$SingletonContrastModeObserver = new $de5d818a744f5116$var$ContrastModeObserver();
var $de5d818a744f5116$export$2e2bcd8739ae039 = $de5d818a744f5116$var$SingletonContrastModeObserver;


function $7b1b786b1365b933$export$2e2bcd8739ae039(themeState) {
    if (themeState.colorMode === 'auto') {
        // Set colorMode based on the user preference
        themeState.colorMode = (0, $67b638d9cfe2c103$export$2e2bcd8739ae039).getColorMode();
        // Bind a listener (if one doesn't already exist) to keep colorMode updated
        (0, $67b638d9cfe2c103$export$2e2bcd8739ae039).bind();
    } else (0, $67b638d9cfe2c103$export$2e2bcd8739ae039).unbind();
    if ((0, $9Zzpd.fg)('platform_increased-contrast-themes')) {
        if (themeState.contrastMode === 'auto') {
            // Set contrastMode based on the user preference
            themeState.contrastMode = (0, $de5d818a744f5116$export$2e2bcd8739ae039).getContrastMode();
            // Bind a listener (if one doesn't already exist) to keep contrastMode updated
            (0, $de5d818a744f5116$export$2e2bcd8739ae039).bind();
        } else (0, $de5d818a744f5116$export$2e2bcd8739ae039).unbind();
    }
    var themeAttributes = (0, $41d75aa14cb33765$export$2e2bcd8739ae039)(themeState);
    Object.entries(themeAttributes).forEach(function(_ref) {
        var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_ref, 2), key = _ref2[0], value = _ref2[1];
        document.documentElement.setAttribute(key, value);
    });
    return function() {
        (0, $67b638d9cfe2c103$export$2e2bcd8739ae039).unbind();
        if ((0, $9Zzpd.fg)('platform_increased-contrast-themes')) (0, $de5d818a744f5116$export$2e2bcd8739ae039).unbind();
    };
}



var $4LdXN = parcelRequire("4LdXN");

var $fC8ib = parcelRequire("fC8ib");

var $9Zzpd = parcelRequire("9Zzpd");

var $iYJcE = parcelRequire("iYJcE");

var $4ZYyc = parcelRequire("4ZYyc");
function $0f2e42f377e5e84b$export$2e2bcd8739ae039(themeId) {
    var _Object$entries$find;
    return (_Object$entries$find = Object.entries((0, $4ZYyc.default)).find(function(_ref) {
        var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_ref, 2), increasesContrastFor = _ref2[1].increasesContrastFor;
        return increasesContrastFor === themeId;
    })) === null || _Object$entries$find === void 0 ? void 0 : _Object$entries$find[1].id;
}


var $99d3160ed3ffa3d0$export$dd6aeb7c823fc03d = function getThemePreferences(themeState) {
    var colorMode = themeState.colorMode, contrastMode = themeState.contrastMode, dark = themeState.dark, light = themeState.light, shape = themeState.shape, spacing = themeState.spacing, typography = themeState.typography;
    var autoColorModeThemes = [
        light,
        dark
    ];
    var themePreferences = [];
    if (colorMode === 'auto') {
        if (contrastMode !== 'no-preference' && (0, $9Zzpd.fg)('platform_increased-contrast-themes')) autoColorModeThemes.forEach(function(normalTheme) {
            var increasedContrastTheme = (0, $0f2e42f377e5e84b$export$2e2bcd8739ae039)(normalTheme);
            if (increasedContrastTheme) autoColorModeThemes.push(increasedContrastTheme);
        });
        themePreferences.push.apply(themePreferences, autoColorModeThemes);
    } else {
        themePreferences.push(themeState[colorMode]);
        if (contrastMode !== 'no-preference' && (0, $9Zzpd.fg)('platform_increased-contrast-themes')) {
            var increasedContrastTheme = (0, $0f2e42f377e5e84b$export$2e2bcd8739ae039)(themeState[colorMode]);
            if (increasedContrastTheme) themePreferences.push(increasedContrastTheme);
        }
    }
    [
        shape,
        spacing,
        typography
    ].forEach(function(themeId) {
        if (themeId) themePreferences.push(themeId);
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(new Set(themePreferences));
};
var $99d3160ed3ffa3d0$export$5d76d7014f4a5d08 = function getThemeOverridePreferences(_themeState) {
    var themeOverridePreferences = [];
    return (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(new Set(themeOverridePreferences));
};



function $98b4e3b8dd0f013a$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $98b4e3b8dd0f013a$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $98b4e3b8dd0f013a$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $98b4e3b8dd0f013a$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $98b4e3b8dd0f013a$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $98b4e3b8dd0f013a$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $98b4e3b8dd0f013a$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $98b4e3b8dd0f013a$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $98b4e3b8dd0f013a$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $98b4e3b8dd0f013a$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}

/**
 * Sets the theme globally at runtime. This updates the `data-theme` and `data-color-mode` attributes on your page's <html> tag.
 *
 * @param {Object<string, string>} themeState The themes and color mode that should be applied.
 * @param {string} themeState.colorMode Determines which color theme is applied. If set to `auto`, the theme applied will be determined by the OS setting.
 * @param {string} themeState.contrastMode The contrast mode theme to be applied. If set to `auto`, the theme applied will be determined by the OS setting.set to `auto`, the theme applied will be determined by the OS setting.
 * @param {string} themeState.dark The color theme to be applied when the color mode resolves to 'dark'.
 * @param {string} themeState.light The color theme to be applied when the color mode resolves to 'light'.
 * @param {string} themeState.shape The shape theme to be applied.
 * @param {string} themeState.spacing The spacing theme to be applied.
 * @param {string} themeState.typography The typography theme to be applied.
 * @param {Object} themeState.UNSAFE_themeOptions The custom branding options to be used for custom theme generation
 * @param {function} themeLoader Callback function used to override the default theme loading functionality.
 *
 * @returns A Promise of an unbind function, that can be used to stop listening for changes to system theme.
 *
 * @example
 * ```
 * setGlobalTheme({colorMode: 'auto', light: 'light', dark: 'dark', spacing: 'spacing'});
 * ```
 */ var $98b4e3b8dd0f013a$var$setGlobalTheme = /*#__PURE__*/ function() {
    var _ref = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee3() {
        var nextThemeState, themeLoader, _ref2, _ref2$colorMode, colorMode, _ref2$contrastMode, contrastMode, _ref2$dark, dark, _ref2$light, light, _ref2$shape, shape, _ref2$spacing, spacing, _ref2$typography, typography, _ref2$UNSAFE_themeOpt, UNSAFE_themeOptions, themeState, themePreferences, loadingStrategy, loadingTasks, mode, attrOfMissingCustomStyles, themeOverridePreferences, _iterator, _step, themeId, autoUnbind, _args3 = arguments;
        return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee3$(_context3) {
            while(true)switch(_context3.prev = _context3.next){
                case 0:
                    nextThemeState = _args3.length > 0 && _args3[0] !== undefined ? _args3[0] : {};
                    themeLoader = _args3.length > 1 ? _args3[1] : undefined;
                    _ref2 = typeof nextThemeState === 'function' ? nextThemeState($98b4e3b8dd0f013a$var$_objectSpread($98b4e3b8dd0f013a$var$_objectSpread({}, (0, $4ZYyc.themeStateDefaults)), {}, {
                        typography: (0, $4ZYyc.themeStateDefaults)['typography'],
                        shape: (0, $4ZYyc.themeStateDefaults)['shape']()
                    }, (0, $6e1f29b6969d643f$export$2e2bcd8739ae039)())) : nextThemeState, _ref2$colorMode = _ref2.colorMode, colorMode = _ref2$colorMode === void 0 ? (0, $4ZYyc.themeStateDefaults)['colorMode'] : _ref2$colorMode, _ref2$contrastMode = _ref2.contrastMode, contrastMode = _ref2$contrastMode === void 0 ? (0, $4ZYyc.themeStateDefaults)['contrastMode'] : _ref2$contrastMode, _ref2$dark = _ref2.dark, dark = _ref2$dark === void 0 ? (0, $4ZYyc.themeStateDefaults)['dark'] : _ref2$dark, _ref2$light = _ref2.light, light = _ref2$light === void 0 ? (0, $4ZYyc.themeStateDefaults)['light'] : _ref2$light, _ref2$shape = _ref2.shape, shape = _ref2$shape === void 0 ? (0, $4ZYyc.themeStateDefaults)['shape']() : _ref2$shape, _ref2$spacing = _ref2.spacing, spacing = _ref2$spacing === void 0 ? (0, $4ZYyc.themeStateDefaults)['spacing'] : _ref2$spacing, _ref2$typography = _ref2.typography, typography = _ref2$typography === void 0 ? (0, $4ZYyc.themeStateDefaults)['typography'] : _ref2$typography, _ref2$UNSAFE_themeOpt = _ref2.UNSAFE_themeOptions, UNSAFE_themeOptions = _ref2$UNSAFE_themeOpt === void 0 ? (0, $4ZYyc.themeStateDefaults)['UNSAFE_themeOptions'] : _ref2$UNSAFE_themeOpt; // CLEANUP: Remove. This blocks application of increased contrast themes
                    // without the feature flag enabled.
                    if (!(0, $9Zzpd.fg)('platform_increased-contrast-themes')) {
                        if (light === 'light-increased-contrast') light = 'light';
                        if (dark === 'dark-increased-contrast') dark = 'dark';
                    }
                    themeState = {
                        colorMode: colorMode,
                        contrastMode: contrastMode,
                        dark: dark,
                        light: light,
                        shape: shape,
                        spacing: spacing,
                        typography: typography,
                        UNSAFE_themeOptions: themeLoader ? undefined : UNSAFE_themeOptions
                    }; // Determine what to load and loading strategy
                    themePreferences = (0, $99d3160ed3ffa3d0$export$dd6aeb7c823fc03d)(themeState);
                    loadingStrategy = themeLoader ? themeLoader : (0, $93121ced7575746f$export$26cd7ae85c7144e5); // Load standard themes
                    loadingTasks = themePreferences.map(/*#__PURE__*/ function() {
                        var _ref3 = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee(themeId) {
                            return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee$(_context) {
                                while(true)switch(_context.prev = _context.next){
                                    case 0:
                                        _context.next = 2;
                                        return loadingStrategy(themeId);
                                    case 2:
                                        return _context.abrupt("return", _context.sent);
                                    case 3:
                                    case "end":
                                        return _context.stop();
                                }
                            }, _callee);
                        }));
                        return function(_x) {
                            return _ref3.apply(this, arguments);
                        };
                    }()); // Load custom themes if needed
                    if (!themeLoader && UNSAFE_themeOptions && (0, $cp9Zt.isValidBrandHex)(UNSAFE_themeOptions === null || UNSAFE_themeOptions === void 0 ? void 0 : UNSAFE_themeOptions.brandColor)) {
                        mode = colorMode || (0, $4ZYyc.themeStateDefaults)['colorMode'];
                        attrOfMissingCustomStyles = (0, $4LdXN.findMissingCustomStyleElements)(UNSAFE_themeOptions, mode);
                        if (attrOfMissingCustomStyles.length > 0) // Load custom theme styles
                        loadingTasks.push((0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee2() {
                            var _yield$import, loadAndAppendCustomThemeCss;
                            return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee2$(_context2) {
                                while(true)switch(_context2.prev = _context2.next){
                                    case 0:
                                        _context2.next = 2;
                                        return (parcelRequire("gLJAe"));
                                    case 2:
                                        _yield$import = _context2.sent;
                                        loadAndAppendCustomThemeCss = _yield$import.loadAndAppendCustomThemeCss;
                                        loadAndAppendCustomThemeCss({
                                            colorMode: attrOfMissingCustomStyles.length === 2 ? 'auto' : // only load the missing custom theme styles
                                            attrOfMissingCustomStyles[0],
                                            UNSAFE_themeOptions: UNSAFE_themeOptions
                                        });
                                    case 5:
                                    case "end":
                                        return _context2.stop();
                                }
                            }, _callee2);
                        }))());
                    }
                    _context3.next = 11;
                    return Promise.all(loadingTasks);
                case 11:
                    // Load override themes after standard themes
                    themeOverridePreferences = (0, $99d3160ed3ffa3d0$export$5d76d7014f4a5d08)(themeState);
                    _iterator = $98b4e3b8dd0f013a$var$_createForOfIteratorHelper(themeOverridePreferences);
                    _context3.prev = 13;
                    _iterator.s();
                case 15:
                    if ((_step = _iterator.n()).done) {
                        _context3.next = 21;
                        break;
                    }
                    themeId = _step.value;
                    _context3.next = 19;
                    return loadingStrategy(themeId);
                case 19:
                    _context3.next = 15;
                    break;
                case 21:
                    _context3.next = 26;
                    break;
                case 23:
                    _context3.prev = 23;
                    _context3.t0 = _context3["catch"](13);
                    _iterator.e(_context3.t0);
                case 26:
                    _context3.prev = 26;
                    _iterator.f();
                    return _context3.finish(26);
                case 29:
                    autoUnbind = (0, $7b1b786b1365b933$export$2e2bcd8739ae039)(themeState);
                    return _context3.abrupt("return", autoUnbind);
                case 31:
                case "end":
                    return _context3.stop();
            }
        }, _callee3, null, [
            [
                13,
                23,
                26,
                29
            ]
        ]);
    }));
    return function setGlobalTheme() {
        return _ref.apply(this, arguments);
    };
}();
var $98b4e3b8dd0f013a$export$2e2bcd8739ae039 = $98b4e3b8dd0f013a$var$setGlobalTheme;


var $iy6kx = parcelRequire("iy6kx");

var $5FkrB = parcelRequire("5FkrB");
var $6a1fe94c2206becb$export$7981b2444296e410 = /*#__PURE__*/ (0, $5FkrB.createContext)(false);
var $6a1fe94c2206becb$export$26aa23367bfbab0e = function useIsInsideAppProvider() {
    return (0, $5FkrB.useContext)($6a1fe94c2206becb$export$7981b2444296e410);
};



var $5FkrB = parcelRequire("5FkrB");
var $c5041f41d0f8bd67$export$49ddd74a6729fdb0 = /*#__PURE__*/ (0, $5FkrB.createContext)(undefined);
var $c5041f41d0f8bd67$export$b06130bad0bbc70f = /*#__PURE__*/ (0, $5FkrB.createContext)(undefined);



var $5FkrB = parcelRequire("5FkrB");
var $8dbba1c1f1547112$export$332347eeb335453c = /*#__PURE__*/ (0, $5FkrB.createContext)(false);



var $5FkrB = parcelRequire("5FkrB");
var $ad63e859484c8f24$export$2c657da244d00bd6 = /*#__PURE__*/ (0, $5FkrB.createContext)(undefined);
var $ad63e859484c8f24$export$f7a97b47760e2a13 = /*#__PURE__*/ (0, $5FkrB.createContext)(undefined);



var $5FkrB = parcelRequire("5FkrB");

var $569c94cca7e9dcf1$export$7ca11437599d653d = function useIsInsideThemeProvider() {
    var _useContext;
    return (_useContext = (0, $5FkrB.useContext)((0, $8dbba1c1f1547112$export$332347eeb335453c))) !== null && _useContext !== void 0 ? _useContext : false;
};



var $fL8KA = parcelRequire("fL8KA");

var $6HG4S = parcelRequire("6HG4S");

var $hBCYb = parcelRequire("hBCYb");


var $hBCYb = parcelRequire("hBCYb");

var $iy6kx = parcelRequire("iy6kx");
function $d68f2a40edc5cacb$export$835a0dc855d02822(themeId) {
    var doc = (0, $hBCYb.getDocument)();
    if (!doc) return false;
    return doc.head.querySelector("style[".concat((0, $iy6kx.THEME_DATA_ATTRIBUTE), "=\"").concat(themeId, "\"]"));
}


var $095b9fd6a536177d$var$loadThemeCss = /*#__PURE__*/ function() {
    var _ref = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee(themeId) {
        var _yield$themeImportMap, themeCss;
        return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee$(_context) {
            while(true)switch(_context.prev = _context.next){
                case 0:
                    if (!(0, $d68f2a40edc5cacb$export$835a0dc855d02822)(themeId)) {
                        _context.next = 2;
                        break;
                    }
                    return _context.abrupt("return");
                case 2:
                    if (themeId) {
                        _context.next = 4;
                        break;
                    }
                    return _context.abrupt("return");
                case 4:
                    _context.next = 6;
                    return (0, $0f156a5e996217a5$export$2e2bcd8739ae039)[themeId]();
                case 6:
                    _yield$themeImportMap = _context.sent;
                    themeCss = _yield$themeImportMap.default;
                    return _context.abrupt("return", themeCss);
                case 9:
                case "end":
                    return _context.stop();
            }
        }, _callee);
    }));
    return function loadThemeCss(_x) {
        return _ref.apply(this, arguments);
    };
}();
var $095b9fd6a536177d$var$mountThemeCss = /*#__PURE__*/ function() {
    var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee2(css, themeId) {
        var doc, style;
        return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee2$(_context2) {
            while(true)switch(_context2.prev = _context2.next){
                case 0:
                    // SSR-safe: Only mount on client side
                    doc = (0, $hBCYb.getDocument)();
                    if (doc) {
                        _context2.next = 3;
                        break;
                    }
                    return _context2.abrupt("return");
                case 3:
                    style = doc.createElement('style');
                    style.textContent = css;
                    style.dataset.theme = themeId;
                    // Prevent duplicate mounting of themes.
                    // It's possible the theme was already being loaded elsewhere.
                    if (!(0, $d68f2a40edc5cacb$export$835a0dc855d02822)(themeId)) {
                        _context2.next = 8;
                        break;
                    }
                    return _context2.abrupt("return");
                case 8:
                    doc.head.appendChild(style);
                case 9:
                case "end":
                    return _context2.stop();
            }
        }, _callee2);
    }));
    return function mountThemeCss(_x2, _x3) {
        return _ref2.apply(this, arguments);
    };
}();
var $095b9fd6a536177d$var$loadAndMountThemeCss = /*#__PURE__*/ function() {
    var _ref3 = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee3(themeId) {
        var themeCss;
        return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee3$(_context3) {
            while(true)switch(_context3.prev = _context3.next){
                case 0:
                    _context3.next = 2;
                    return $095b9fd6a536177d$var$loadThemeCss(themeId);
                case 2:
                    themeCss = _context3.sent;
                    if (themeCss) {
                        _context3.next = 5;
                        break;
                    }
                    return _context3.abrupt("return");
                case 5:
                    $095b9fd6a536177d$var$mountThemeCss(themeCss, themeId);
                case 6:
                case "end":
                    return _context3.stop();
            }
        }, _callee3);
    }));
    return function loadAndMountThemeCss(_x4) {
        return _ref3.apply(this, arguments);
    };
}();
var $095b9fd6a536177d$export$7d4a7e812d176b24 = /*#__PURE__*/ function() {
    var _ref4 = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee4(theme) {
        var themesToLoad;
        return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee4$(_context4) {
            while(true)switch(_context4.prev = _context4.next){
                case 0:
                    themesToLoad = Object.values(theme).filter(function(themeId) {
                        return !!themeId;
                    });
                    themesToLoad.forEach($095b9fd6a536177d$var$loadAndMountThemeCss);
                case 2:
                case "end":
                    return _context4.stop();
            }
        }, _callee4);
    }));
    return function loadAndMountThemes(_x5) {
        return _ref4.apply(this, arguments);
    };
}();


function $cc6e8e5caffb0863$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $cc6e8e5caffb0863$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $cc6e8e5caffb0863$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $cc6e8e5caffb0863$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $cc6e8e5caffb0863$var$defaultThemeSettings = {
    dark: 'dark',
    light: 'light',
    spacing: 'spacing',
    typography: 'typography'
};
var $cc6e8e5caffb0863$var$isMatchMediaAvailable = typeof window !== 'undefined' && 'matchMedia' in window;
var $cc6e8e5caffb0863$var$prefersDarkModeMql = $cc6e8e5caffb0863$var$isMatchMediaAvailable ? window.matchMedia('(prefers-color-scheme: dark)') : undefined;
// TODO: currently 'auto' color mode will always return 'light' in SSR.
// Additional work required: https://product-fabric.atlassian.net/browse/DSP-9781
function $cc6e8e5caffb0863$var$getReconciledColorMode(colorMode) {
    if (colorMode === 'auto') return $cc6e8e5caffb0863$var$prefersDarkModeMql !== null && $cc6e8e5caffb0863$var$prefersDarkModeMql !== void 0 && $cc6e8e5caffb0863$var$prefersDarkModeMql.matches ? 'dark' : 'light';
    return colorMode;
}
var $cc6e8e5caffb0863$var$contentStyles = {
    body: "_1e0c1bgi"
};
/**
 * __Theme provider__
 *
 * Provides global theming configuration.
 */ function $cc6e8e5caffb0863$var$ThemeProvider(_ref) {
    var children = _ref.children, _ref$defaultColorMode = _ref.defaultColorMode, defaultColorMode = _ref$defaultColorMode === void 0 ? 'auto' : _ref$defaultColorMode, defaultTheme = _ref.defaultTheme;
    var _useState = (0, $5FkrB.useState)(defaultColorMode), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), chosenColorMode = _useState2[0], setChosenColorMode = _useState2[1];
    var _useState3 = (0, $5FkrB.useState)($cc6e8e5caffb0863$var$getReconciledColorMode(defaultColorMode)), _useState4 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState3, 2), reconciledColorMode = _useState4[0], setReconciledColorMode = _useState4[1];
    var _useState5 = (0, $5FkrB.useState)(function() {
        return $cc6e8e5caffb0863$var$_objectSpread($cc6e8e5caffb0863$var$_objectSpread({}, $cc6e8e5caffb0863$var$defaultThemeSettings), defaultTheme);
    }), _useState6 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState5, 2), theme = _useState6[0], setTheme = _useState6[1];
    var setColorMode = (0, $5FkrB.useCallback)(function(colorMode) {
        setChosenColorMode(colorMode);
        setReconciledColorMode($cc6e8e5caffb0863$var$getReconciledColorMode(colorMode));
    }, []);
    var setPartialTheme = (0, $5FkrB.useCallback)(function(nextTheme) {
        setTheme(function(theme) {
            return $cc6e8e5caffb0863$var$_objectSpread($cc6e8e5caffb0863$var$_objectSpread({}, theme), nextTheme);
        });
    }, []);
    var lastSetGlobalThemePromiseRef = (0, $5FkrB.useRef)(null);
    var isInsideAppProvider = (0, $6a1fe94c2206becb$export$26aa23367bfbab0e)();
    var isInsideThemeProvider = (0, $569c94cca7e9dcf1$export$7ca11437599d653d)();
    var isRootThemeProvider = isInsideAppProvider && !isInsideThemeProvider;
    (0, $5FkrB.useEffect)(function() {
        if (/**
     * A top-level ThemeProvider is detected by being the first ThemeProvider inside an AppProvider.
     *
     * This will not use sub-tree theming but instead set the global theme state using the
     * `@atlaskit/tokens` APIs, as it's required for styling root `html` and `body` elements
     * for compatibility with `@atlaskit/css-reset`.
     *
     * In the future we could consider moving away from DOM mutations and require AppProvider to wrap
     * `html` in order to apply global theme state, which would allow a more consistent approach to
     * theme loading.
     */ isRootThemeProvider || /**
     * Or when not behind feature flag, partially revert to legacy behavior.
     * This only affects theme providers that are not inside an AppProvider or a ThemeProvider,
     * as we still need to set global theme state to prevent breaking existing apps,
     * but also prevent multiple theme providers from loading conflicting theme states.
     *
     * After we roll out the feature flag, this will be removed as we will
     * only support sub-tree theming when used outside of AppProvider.
     */ !isInsideAppProvider && !isInsideThemeProvider && !(0, $9Zzpd.fg)('platform_dst_subtree_theming')) {
            /**
       * We need to wait for any previous `setGlobalTheme` calls to finish before calling it again.
       * This is to prevent race conditions as `setGlobalTheme` is async and mutates the DOM (e.g. sets the
       * `data-color-mode` attribute on the root element).
       *
       * Since we can't safely abort the `setGlobalTheme` execution, we need to wait for it to properly finish before
       * applying the new theme.
       *
       * Without this, we can end up in the following scenario:
       * 1. app loads with the default 'light' theme, kicking off `setGlobalTheme`
       * 2. app switches to 'dark' theme after retrieving value persisted in local storage, calling `setGlobalTheme` again
       * 3. `setGlobalTheme` function execution for `dark` finishes before the initial `light` execution
       * 4. `setGlobalTheme` function execution for `light` then finishes, resulting in the 'light' theme being applied.
       */ var cleanupLastFnCall = /*#__PURE__*/ function() {
                var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee() {
                    var unbindFn;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee$(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                if (!lastSetGlobalThemePromiseRef.current) {
                                    _context.next = 6;
                                    break;
                                }
                                _context.next = 3;
                                return lastSetGlobalThemePromiseRef.current;
                            case 3:
                                unbindFn = _context.sent;
                                unbindFn();
                                lastSetGlobalThemePromiseRef.current = null;
                            case 6:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee);
                }));
                return function cleanupLastFnCall() {
                    return _ref2.apply(this, arguments);
                };
            }();
            var safelySetGlobalTheme = /*#__PURE__*/ function() {
                var _ref3 = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee2() {
                    var promise;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee2$(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                _context2.next = 2;
                                return cleanupLastFnCall();
                            case 2:
                                promise = (0, $98b4e3b8dd0f013a$export$2e2bcd8739ae039)($cc6e8e5caffb0863$var$_objectSpread($cc6e8e5caffb0863$var$_objectSpread({}, theme), {}, {
                                    colorMode: reconciledColorMode
                                }));
                                lastSetGlobalThemePromiseRef.current = promise;
                            case 4:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2);
                }));
                return function safelySetGlobalTheme() {
                    return _ref3.apply(this, arguments);
                };
            }();
            safelySetGlobalTheme();
            return function cleanup() {
                cleanupLastFnCall();
            };
        } else // For other theme providers (whether outside AppProvider or nested inside a ThemeProvider),
        // we treat them as sub-tree themes that do not load global theme state.
        (0, $095b9fd6a536177d$export$7d4a7e812d176b24)(theme);
    }, [
        isInsideAppProvider,
        isInsideThemeProvider,
        isRootThemeProvider,
        reconciledColorMode,
        theme
    ]);
    (0, $5FkrB.useEffect)(function() {
        if (!$cc6e8e5caffb0863$var$prefersDarkModeMql) return;
        var unbindListener = (0, $7QpUe.bind)($cc6e8e5caffb0863$var$prefersDarkModeMql, {
            type: 'change',
            listener: function listener(event) {
                if (chosenColorMode === 'auto') setReconciledColorMode(event.matches ? 'dark' : 'light');
            }
        });
        return unbindListener;
    }, [
        chosenColorMode
    ]);
    var attrs = $cc6e8e5caffb0863$var$_objectSpread($cc6e8e5caffb0863$var$_objectSpread({}, (0, $41d75aa14cb33765$export$2e2bcd8739ae039)($cc6e8e5caffb0863$var$_objectSpread($cc6e8e5caffb0863$var$_objectSpread({}, theme), {}, {
        colorMode: reconciledColorMode
    }))), {}, (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, (0, $iy6kx.SUBTREE_THEME_ATTRIBUTE), true));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $8dbba1c1f1547112$export$332347eeb335453c).Provider, {
        value: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $c5041f41d0f8bd67$export$49ddd74a6729fdb0).Provider, {
        value: reconciledColorMode
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $c5041f41d0f8bd67$export$b06130bad0bbc70f).Provider, {
        value: setColorMode
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $ad63e859484c8f24$export$2c657da244d00bd6).Provider, {
        value: theme
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $ad63e859484c8f24$export$f7a97b47760e2a13).Provider, {
        value: setPartialTheme
    }, (0, $9Zzpd.fg)('platform_dst_subtree_theming') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, attrs, {
        className: (0, $970q7.default)([
            $cc6e8e5caffb0863$var$contentStyles.body
        ])
    }), children) : children)))));
}
var $cc6e8e5caffb0863$export$2e2bcd8739ae039 = $cc6e8e5caffb0863$var$ThemeProvider;


var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $25nEq = parcelRequire("25nEq");

var $iy6kx = parcelRequire("iy6kx");

/**
 * A MutationObserver which watches the `<html>` element for changes to the theme.
 *
 * In React, use the {@link useThemeObserver `useThemeObserver`} hook instead.
 *
 * @param {function} callback - A callback function which fires when the theme changes.
 *
 * @example
 * ```
 * const observer = new ThemeMutationObserver((theme) => {});
 * observer.observe();
 * ```
 */ var $3da2a93717cb61fd$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function ThemeMutationObserver(callback) {
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, ThemeMutationObserver);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "legacyObserver", null);
        this.callback = callback;
        ThemeMutationObserver.callbacks.add(callback);
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(ThemeMutationObserver, [
        {
            key: "observe",
            value: function observe() {
                if (!ThemeMutationObserver.observer) {
                    ThemeMutationObserver.observer = new MutationObserver(function() {
                        var theme = (0, $6e1f29b6969d643f$export$2e2bcd8739ae039)();
                        ThemeMutationObserver.callbacks.forEach(function(callback) {
                            return callback(theme);
                        });
                    });
                    // Observer only needs to be configured once
                    ThemeMutationObserver.observer.observe(document.documentElement, {
                        attributeFilter: [
                            (0, $iy6kx.THEME_DATA_ATTRIBUTE),
                            (0, $iy6kx.COLOR_MODE_ATTRIBUTE)
                        ]
                    });
                }
            }
        },
        {
            key: "disconnect",
            value: function disconnect() {
                if (this.callback) ThemeMutationObserver.callbacks.delete(this.callback);
                if (ThemeMutationObserver.callbacks.size === 0 && ThemeMutationObserver.observer) {
                    ThemeMutationObserver.observer.disconnect();
                    ThemeMutationObserver.observer = null;
                }
            }
        }
    ]);
}();
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($3da2a93717cb61fd$export$2e2bcd8739ae039, "observer", null);
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($3da2a93717cb61fd$export$2e2bcd8739ae039, "callbacks", new Set());



function $fa138d0de9db9ddd$export$20f3076712c8dfa() {
    var value = (0, $5FkrB.useContext)((0, $c5041f41d0f8bd67$export$49ddd74a6729fdb0));
    // TODO: This will only return 'light' or 'dark' but never 'auto', which in some cases
    // may be desirable. We should consider returning both the reconciled color mode (e.g. 'light' or 'dark') and the selected color mode ("auto").
    var theme = (0, $6e1f29b6969d643f$export$2e2bcd8739ae039)();
    var _useState = (0, $5FkrB.useState)((theme === null || theme === void 0 ? void 0 : theme.colorMode) || 'light'), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), resolvedColorMode = _useState2[0], setResolvedColorMode = _useState2[1];
    (0, $5FkrB.useEffect)(function() {
        // We are using theme from context so no need to reference the DOM
        if (value) return;
        var observer = new (0, $3da2a93717cb61fd$export$2e2bcd8739ae039)(function(theme) {
            setResolvedColorMode((theme === null || theme === void 0 ? void 0 : theme.colorMode) || 'light');
        });
        observer.observe();
        return function() {
            return observer.disconnect();
        };
    }, [
        value
    ]);
    return value ? value : resolvedColorMode;
}



var $9Zzpd = parcelRequire("9Zzpd");
var $76c078d68b54402f$export$e4c79eb95c23a0da = 'atlaskit-portal-container';
var $76c078d68b54402f$export$72f415121273627e = 'body > .atlaskit-portal-container';
var $76c078d68b54402f$export$13f57c02915787b3 = 'atlaskit-portal';


var $a5e574843a6b9197$export$26ae5ca175b4ec5a = function createContainer(zIndex) {
    var container = document.createElement('div');
    container.className = (0, $76c078d68b54402f$export$13f57c02915787b3);
    container.style.zIndex = "".concat(zIndex);
    return container;
};
/**
 * Returns document body element
 * @return {number} - The document body element
 */ var $a5e574843a6b9197$var$getBody = function getBody() {
    return document.body;
};
/**
 * Returns portal parent container. If no container exists already then it creates a new container with class name 'atlaskit-portal-container'
 * @return {Element} - The portal parent container div element
 */ var $a5e574843a6b9197$var$getPortalParent = function getPortalParent() {
    var parentElement = document.querySelector((0, $76c078d68b54402f$export$72f415121273627e));
    if (!parentElement) {
        var _getBody;
        var parent = document.createElement('div');
        parent.className = (0, $76c078d68b54402f$export$e4c79eb95c23a0da);
        // we are setting display to flex because we want each portal to create a new stacking context
        // See https://developer.mozilla.org/en-US/docs/Web/CSS/CSS_Positioning/Understanding_z_index/The_stacking_context
        parent.style.display = 'flex';
        (_getBody = $a5e574843a6b9197$var$getBody()) === null || _getBody === void 0 || _getBody.appendChild(parent);
        return parent;
    }
    return parentElement;
};
var $a5e574843a6b9197$export$da99f98bf3fe55b3 = function removePortalContainer(container) {
    $a5e574843a6b9197$var$getPortalParent().removeChild(container);
};
var $a5e574843a6b9197$export$c582005add11e141 = function appendPortalContainerIfNotAppended(container) {
    if (!container.parentElement) $a5e574843a6b9197$var$getPortalParent().appendChild(container);
};
var $a5e574843a6b9197$var$isDocumentDefined = function isDocumentDefined() {
    return document !== undefined;
};
var $a5e574843a6b9197$export$fef014d7cef9e543 = function createAtlaskitPortal(zIndex) {
    //atlaskit-portal div
    if ($a5e574843a6b9197$var$isDocumentDefined()) {
        var atlaskitportal = document.createElement('div');
        atlaskitportal.className = (0, $76c078d68b54402f$export$13f57c02915787b3);
        atlaskitportal.style.zIndex = "".concat(zIndex);
        return atlaskitportal;
    }
    return;
};
var $a5e574843a6b9197$export$95029ca7aca2989e = function createPortalParent() {
    //atlaskit-portal-container div
    if ($a5e574843a6b9197$var$isDocumentDefined()) {
        var parentElement = document.querySelector((0, $76c078d68b54402f$export$72f415121273627e));
        if (!parentElement) {
            var _getBody2;
            var parent = document.createElement('div');
            parent.className = (0, $76c078d68b54402f$export$e4c79eb95c23a0da);
            parent.style.display = 'flex';
            (_getBody2 = $a5e574843a6b9197$var$getBody()) === null || _getBody2 === void 0 || _getBody2.appendChild(parent);
            return parent;
        }
        return parentElement;
    }
    return;
};


function $616f0bb1ee61b963$export$2e2bcd8739ae039(props) {
    var zIndex = props.zIndex, children = props.children;
    var container = (0, $5FkrB.useMemo)(function() {
        return (0, $a5e574843a6b9197$export$26ae5ca175b4ec5a)(zIndex);
    }, [
        zIndex
    ]);
    var colorMode = (0, $fa138d0de9db9ddd$export$20f3076712c8dfa)();
    // This is in the render method instead of useEffect so that
    // the portal will be added to the DOM before the children render.
    // For any further changes, ensure that the container does not have a
    // parent besides the portal parent.
    (0, $a5e574843a6b9197$export$c582005add11e141)(container);
    (0, $5FkrB.useEffect)(function() {
        return function() {
            (0, $a5e574843a6b9197$export$da99f98bf3fe55b3)(container);
        };
    }, [
        container
    ]);
    return /*#__PURE__*/ (0, $aLeHs.createPortal)(colorMode && (0, $9Zzpd.fg)('platform_dst_subtree_theming') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $cc6e8e5caffb0863$export$2e2bcd8739ae039), {
        defaultColorMode: colorMode
    }, children) : children, container);
}



var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");

var $aLeHs = parcelRequire("aLeHs");


var $9Zzpd = parcelRequire("9Zzpd");

var $5FkrB = parcelRequire("5FkrB");
var $176e52a7c3bf96eb$export$700979bc83e7db82 = typeof window !== 'undefined' ? (0, $5FkrB.useLayoutEffect) : (0, $5FkrB.useEffect);



function $828cbcbc3eca3545$export$2e2bcd8739ae039(props) {
    var zIndex = props.zIndex, children = props.children;
    var _useState = (0, $5FkrB.useState)(null), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), atlaskitPortal = _useState2[0], setAtlaskitPortal = _useState2[1];
    var colorMode = (0, $fa138d0de9db9ddd$export$20f3076712c8dfa)();
    (0, $176e52a7c3bf96eb$export$700979bc83e7db82)(function() {
        var tempPortalContainer = (0, $a5e574843a6b9197$export$fef014d7cef9e543)(zIndex);
        setAtlaskitPortal(tempPortalContainer);
        var portalParent = (0, $a5e574843a6b9197$export$95029ca7aca2989e)();
        if (!tempPortalContainer || !portalParent) return;
        portalParent.appendChild(tempPortalContainer);
        return function() {
            if (tempPortalContainer) portalParent.removeChild(tempPortalContainer);
            setAtlaskitPortal(null);
        };
    }, [
        zIndex
    ]);
    /**
   * We wrap portal children with a Suspense boundary because in React 18 concurrent,
   * if you suspend from _within_ a portal to a Suspense boundary _outside_ the portal,
   * our portal gets in an infinite loop of rendering.
   */ var suspendedChildren = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $5FkrB.Suspense), {
        fallback: null
    }, colorMode && (0, $9Zzpd.fg)('platform_dst_subtree_theming') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $cc6e8e5caffb0863$export$2e2bcd8739ae039), {
        defaultColorMode: colorMode
    }, children) : children);
    return atlaskitPortal ? /*#__PURE__*/ (0, $aLeHs.createPortal)(suspendedChildren, atlaskitPortal) : null;
}



var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");

var $ec82e5ba4880f640$var$useIsSubsequentRender = function useIsSubsequentRender(mountStrategy) {
    var _useState = (0, $5FkrB.useState)(false), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), isSubsequentRender = _useState2[0], setIsSubsequentRender = _useState2[1];
    var _useState3 = (0, $5FkrB.useState)(function() {
        return mountStrategy === 'layoutEffect' ? (0, $176e52a7c3bf96eb$export$700979bc83e7db82) : (0, $5FkrB.useEffect);
    }), _useState4 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState3, 1), useMountEffect = _useState4[0];
    useMountEffect(function() {
        setIsSubsequentRender(true);
    }, []);
    return isSubsequentRender;
};
var $ec82e5ba4880f640$export$2e2bcd8739ae039 = $ec82e5ba4880f640$var$useIsSubsequentRender;



var $5FkrB = parcelRequire("5FkrB");
var $b847e1081452ed9e$export$ed5835cc67e87f72 = 'akPortalMount';
var $b847e1081452ed9e$export$80816bd900e5bd00 = 'akPortalUnmount';


var $407e2dcd180c0ea4$var$zIndexToName = {
    100: 'card',
    200: 'navigation',
    300: 'dialog',
    400: 'layer',
    500: 'blanket',
    510: 'modal',
    600: 'flag',
    700: 'spotlight',
    9999: 'tooltip'
};
/**
 * return layer name in Atlassian design system corresponding to given z-index
 * @param {number} zIndex - z-index value for which layer name is needed
 * @returns {LayerName | null} - The layer name for given z-index. If layer name is not found then null is returned
 */ var $407e2dcd180c0ea4$var$getLayerName = function getLayerName(zIndex) {
    return $407e2dcd180c0ea4$var$zIndexToName.hasOwnProperty(zIndex) ? $407e2dcd180c0ea4$var$zIndexToName[zIndex] : null;
};
/**
 * Creates a PortalEvent object with given eventName, given zIndex and corresponding layer
 * @param {string} eventName - either of Mount or Unmount event name
 * @param {number} zIndex - z-index value which will be included in the event to be dispatched
 * @returns {PortalEvent} - The newly created PortalEvent object
 */ var $407e2dcd180c0ea4$var$getEvent = function getEvent(eventName, zIndex) {
    var detail = {
        layer: $407e2dcd180c0ea4$var$getLayerName(Number(zIndex)),
        zIndex: zIndex
    };
    return new CustomEvent(eventName, {
        detail: detail
    });
};
function $407e2dcd180c0ea4$export$2e2bcd8739ae039(eventName, zIndex) {
    var event = $407e2dcd180c0ea4$var$getEvent(eventName, zIndex);
    window.dispatchEvent(event);
}


var $334ecd1085ee4e40$var$useFirePortalEvent = function useFirePortalEvent(zIndex) {
    var zIndexNumber = Number(zIndex);
    (0, $5FkrB.useEffect)(function() {
        (0, $407e2dcd180c0ea4$export$2e2bcd8739ae039)((0, $b847e1081452ed9e$export$ed5835cc67e87f72), zIndexNumber);
        return function() {
            (0, $407e2dcd180c0ea4$export$2e2bcd8739ae039)((0, $b847e1081452ed9e$export$80816bd900e5bd00), zIndexNumber);
        };
    }, [
        zIndexNumber
    ]);
};
var $334ecd1085ee4e40$export$2e2bcd8739ae039 = $334ecd1085ee4e40$var$useFirePortalEvent;


function $e1c760c467d2ecc0$export$2e2bcd8739ae039(_ref) {
    var _ref$zIndex = _ref.zIndex, zIndex = _ref$zIndex === void 0 ? 0 : _ref$zIndex, children = _ref.children, _ref$mountStrategy = _ref.mountStrategy, mountStrategy = _ref$mountStrategy === void 0 ? 'effect' : _ref$mountStrategy;
    var isSubsequentRender = (0, $ec82e5ba4880f640$export$2e2bcd8739ae039)(mountStrategy);
    (0, $334ecd1085ee4e40$export$2e2bcd8739ae039)(zIndex);
    return !(0, $9Zzpd.fg)('platform_design_system_team_portal_logic_r18_fix') ? isSubsequentRender ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $616f0bb1ee61b963$export$2e2bcd8739ae039), {
        zIndex: zIndex
    }, children) : null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $828cbcbc3eca3545$export$2e2bcd8739ae039), {
        zIndex: zIndex
    }, children);
}


/* box.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $kqp0i = parcelRequire("kqp0i");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");

var $5FkrB = parcelRequire("5FkrB");
var $5819f5812836f95c$export$1ca2a26fecb070ae = /*#__PURE__*/ (0, $5FkrB.createContext)('elevation.surface');
var $5819f5812836f95c$export$1aeb4f6b93c4540d = function useSurface() {
    return (0, $5FkrB.useContext)($5819f5812836f95c$export$1ca2a26fecb070ae);
};
$5819f5812836f95c$export$1ca2a26fecb070ae.displayName = 'SurfaceProvider';


var $e742d9ca3a0f53ff$var$_excluded = [
    "as",
    "children",
    "backgroundColor",
    "padding",
    "paddingBlock",
    "paddingBlockStart",
    "paddingBlockEnd",
    "paddingInline",
    "paddingInlineStart",
    "paddingInlineEnd",
    "style",
    "testId",
    "xcss"
], $e742d9ca3a0f53ff$var$_excluded2 = [
    "className"
];
// Can either Exclude or Extract - here we're excluding all SVG-related elements, <button> elements (handled by Pressable), and <a> elements (handled by Anchor)
// Basically just ElementType but without ComponentType, it makes sense to keep the "Type" suffix
// eslint-disable-next-line @repo/internal/react/consistent-types-definitions
var $e742d9ca3a0f53ff$var$baseStyles = null;
var $e742d9ca3a0f53ff$var$backgroundColorMap = {
    'color.background.accent.lime.subtlest': "_bfhkm890",
    'color.background.accent.lime.subtlest.hovered': "_bfhkd4y8",
    'color.background.accent.lime.subtlest.pressed': "_bfhkkuup",
    'color.background.accent.lime.subtler': "_bfhkz2ec",
    'color.background.accent.lime.subtler.hovered': "_bfhk1gf0",
    'color.background.accent.lime.subtler.pressed': "_bfhk2kxc",
    'color.background.accent.lime.subtle': "_bfhkbq5w",
    'color.background.accent.lime.subtle.hovered': "_bfhkfoww",
    'color.background.accent.lime.subtle.pressed': "_bfhk1jbd",
    'color.background.accent.lime.bolder': "_bfhktde4",
    'color.background.accent.lime.bolder.hovered': "_bfhknzpa",
    'color.background.accent.lime.bolder.pressed': "_bfhkh0j0",
    'color.background.accent.red.subtlest': "_bfhk1vk5",
    'color.background.accent.red.subtlest.hovered': "_bfhk1i6i",
    'color.background.accent.red.subtlest.pressed': "_bfhknbir",
    'color.background.accent.red.subtler': "_bfhk1rtt",
    'color.background.accent.red.subtler.hovered': "_bfhkaffd",
    'color.background.accent.red.subtler.pressed': "_bfhk1j5a",
    'color.background.accent.red.subtle': "_bfhkkrt9",
    'color.background.accent.red.subtle.hovered': "_bfhk1sou",
    'color.background.accent.red.subtle.pressed': "_bfhk1fnn",
    'color.background.accent.red.bolder': "_bfhkuibq",
    'color.background.accent.red.bolder.hovered': "_bfhk100f",
    'color.background.accent.red.bolder.pressed': "_bfhk1cl6",
    'color.background.accent.orange.subtlest': "_bfhkf5uh",
    'color.background.accent.orange.subtlest.hovered': "_bfhk19yr",
    'color.background.accent.orange.subtlest.pressed': "_bfhkf90x",
    'color.background.accent.orange.subtler': "_bfhk165s",
    'color.background.accent.orange.subtler.hovered': "_bfhk1ei0",
    'color.background.accent.orange.subtler.pressed': "_bfhkdpo3",
    'color.background.accent.orange.subtle': "_bfhk1kkj",
    'color.background.accent.orange.subtle.hovered': "_bfhk9mfs",
    'color.background.accent.orange.subtle.pressed': "_bfhkaxpp",
    'color.background.accent.orange.bolder': "_bfhk1qg1",
    'color.background.accent.orange.bolder.hovered': "_bfhk12qo",
    'color.background.accent.orange.bolder.pressed': "_bfhk1fyq",
    'color.background.accent.yellow.subtlest': "_bfhkibhp",
    'color.background.accent.yellow.subtlest.hovered': "_bfhkaetg",
    'color.background.accent.yellow.subtlest.pressed': "_bfhk1o1l",
    'color.background.accent.yellow.subtler': "_bfhk1773",
    'color.background.accent.yellow.subtler.hovered': "_bfhk1uw7",
    'color.background.accent.yellow.subtler.pressed': "_bfhk1r9w",
    'color.background.accent.yellow.subtle': "_bfhk8y3s",
    'color.background.accent.yellow.subtle.hovered': "_bfhk819w",
    'color.background.accent.yellow.subtle.pressed': "_bfhk1jx0",
    'color.background.accent.yellow.bolder': "_bfhk1vop",
    'color.background.accent.yellow.bolder.hovered': "_bfhkkjqf",
    'color.background.accent.yellow.bolder.pressed': "_bfhk1okt",
    'color.background.accent.green.subtlest': "_bfhkn729",
    'color.background.accent.green.subtlest.hovered': "_bfhk3utz",
    'color.background.accent.green.subtlest.pressed': "_bfhkyfny",
    'color.background.accent.green.subtler': "_bfhk1wnw",
    'color.background.accent.green.subtler.hovered': "_bfhk1e2h",
    'color.background.accent.green.subtler.pressed': "_bfhkybhx",
    'color.background.accent.green.subtle': "_bfhk1rsu",
    'color.background.accent.green.subtle.hovered': "_bfhk12e3",
    'color.background.accent.green.subtle.pressed': "_bfhk1g86",
    'color.background.accent.green.bolder': "_bfhk1e5c",
    'color.background.accent.green.bolder.hovered': "_bfhka5yi",
    'color.background.accent.green.bolder.pressed': "_bfhk1j68",
    'color.background.accent.teal.subtlest': "_bfhk7xuz",
    'color.background.accent.teal.subtlest.hovered': "_bfhk108c",
    'color.background.accent.teal.subtlest.pressed': "_bfhk1cxp",
    'color.background.accent.teal.subtler': "_bfhk1a17",
    'color.background.accent.teal.subtler.hovered': "_bfhkkwwr",
    'color.background.accent.teal.subtler.pressed': "_bfhk1jb0",
    'color.background.accent.teal.subtle': "_bfhktdv8",
    'color.background.accent.teal.subtle.hovered': "_bfhkzh8h",
    'color.background.accent.teal.subtle.pressed': "_bfhk16zl",
    'color.background.accent.teal.bolder': "_bfhk2c8p",
    'color.background.accent.teal.bolder.hovered': "_bfhkl3ve",
    'color.background.accent.teal.bolder.pressed': "_bfhktor0",
    'color.background.accent.blue.subtlest': "_bfhk1s93",
    'color.background.accent.blue.subtlest.hovered': "_bfhkdaj9",
    'color.background.accent.blue.subtlest.pressed': "_bfhkxm0g",
    'color.background.accent.blue.subtler': "_bfhk1dy8",
    'color.background.accent.blue.subtler.hovered': "_bfhk815t",
    'color.background.accent.blue.subtler.pressed': "_bfhkrwxf",
    'color.background.accent.blue.subtle': "_bfhk115i",
    'color.background.accent.blue.subtle.hovered': "_bfhk9pr4",
    'color.background.accent.blue.subtle.pressed': "_bfhknpx7",
    'color.background.accent.blue.bolder': "_bfhk16e3",
    'color.background.accent.blue.bolder.hovered': "_bfhk1vbm",
    'color.background.accent.blue.bolder.pressed': "_bfhk1xwi",
    'color.background.accent.purple.subtlest': "_bfhkp2ly",
    'color.background.accent.purple.subtlest.hovered': "_bfhkkca2",
    'color.background.accent.purple.subtlest.pressed': "_bfhk1jbm",
    'color.background.accent.purple.subtler': "_bfhk1nm4",
    'color.background.accent.purple.subtler.hovered': "_bfhkattl",
    'color.background.accent.purple.subtler.pressed': "_bfhk3nfk",
    'color.background.accent.purple.subtle': "_bfhk18ah",
    'color.background.accent.purple.subtle.hovered': "_bfhk8bp1",
    'color.background.accent.purple.subtle.pressed': "_bfhk1cd2",
    'color.background.accent.purple.bolder': "_bfhkya33",
    'color.background.accent.purple.bolder.hovered': "_bfhk1af5",
    'color.background.accent.purple.bolder.pressed': "_bfhk6cze",
    'color.background.accent.magenta.subtlest': "_bfhk8tvm",
    'color.background.accent.magenta.subtlest.hovered': "_bfhkr3zd",
    'color.background.accent.magenta.subtlest.pressed': "_bfhk1ckf",
    'color.background.accent.magenta.subtler': "_bfhkv9ra",
    'color.background.accent.magenta.subtler.hovered': "_bfhk1axx",
    'color.background.accent.magenta.subtler.pressed': "_bfhk42ri",
    'color.background.accent.magenta.subtle': "_bfhk1mi6",
    'color.background.accent.magenta.subtle.hovered': "_bfhkrwyz",
    'color.background.accent.magenta.subtle.pressed': "_bfhk6c15",
    'color.background.accent.magenta.bolder': "_bfhkc3uk",
    'color.background.accent.magenta.bolder.hovered': "_bfhk1ok8",
    'color.background.accent.magenta.bolder.pressed': "_bfhkeawv",
    'color.background.accent.gray.subtlest': "_bfhkysee",
    'color.background.accent.gray.subtlest.hovered': "_bfhkwejn",
    'color.background.accent.gray.subtlest.pressed': "_bfhk18ut",
    'color.background.accent.gray.subtler': "_bfhk7qp0",
    'color.background.accent.gray.subtler.hovered': "_bfhk10ef",
    'color.background.accent.gray.subtler.pressed': "_bfhk1rk9",
    'color.background.accent.gray.subtle': "_bfhk18j9",
    'color.background.accent.gray.subtle.hovered': "_bfhk1nv3",
    'color.background.accent.gray.subtle.pressed': "_bfhkq9tj",
    'color.background.accent.gray.bolder': "_bfhk1i45",
    'color.background.accent.gray.bolder.hovered': "_bfhkbyip",
    'color.background.accent.gray.bolder.pressed': "_bfhk1van",
    'color.background.disabled': "_bfhkby5v",
    'color.background.input': "_bfhk1j9a",
    'color.background.input.hovered': "_bfhkl4ek",
    'color.background.input.pressed': "_bfhkr01l",
    'color.background.inverse.subtle': "_bfhk1vck",
    'color.background.inverse.subtle.hovered': "_bfhkmpja",
    'color.background.inverse.subtle.pressed': "_bfhk1gii",
    'color.background.neutral': "_bfhki8nm",
    'color.background.neutral.hovered': "_bfhkplhp",
    'color.background.neutral.pressed': "_bfhk1gdz",
    'color.background.neutral.subtle': "_bfhksm61",
    'color.background.neutral.subtle.hovered': "_bfhk1dpa",
    'color.background.neutral.subtle.pressed': "_bfhkfcek",
    'color.background.neutral.bold': "_bfhk1aqn",
    'color.background.neutral.bold.hovered': "_bfhk1ibz",
    'color.background.neutral.bold.pressed': "_bfhkof27",
    'color.background.selected': "_bfhk15s3",
    'color.background.selected.hovered': "_bfhkufnl",
    'color.background.selected.pressed': "_bfhknozp",
    'color.background.selected.bold': "_bfhkjmqp",
    'color.background.selected.bold.hovered': "_bfhk1q28",
    'color.background.selected.bold.pressed': "_bfhk12kk",
    'color.background.brand.subtlest': "_bfhk1gmr",
    'color.background.brand.subtlest.hovered': "_bfhk3v15",
    'color.background.brand.subtlest.pressed': "_bfhku02c",
    'color.background.brand.bold': "_bfhk1856",
    'color.background.brand.bold.hovered': "_bfhkhf2y",
    'color.background.brand.bold.pressed': "_bfhkg6ey",
    'color.background.brand.boldest': "_bfhk1o4i",
    'color.background.brand.boldest.hovered': "_bfhklefx",
    'color.background.brand.boldest.pressed': "_bfhk16k6",
    'color.background.danger': "_bfhk1gly",
    'color.background.danger.hovered': "_bfhk1yvi",
    'color.background.danger.pressed': "_bfhk1r4b",
    'color.background.danger.bold': "_bfhkybec",
    'color.background.danger.bold.hovered': "_bfhks9hg",
    'color.background.danger.bold.pressed': "_bfhk13a9",
    'color.background.warning': "_bfhk1917",
    'color.background.warning.hovered': "_bfhk19zu",
    'color.background.warning.pressed': "_bfhkzr32",
    'color.background.warning.bold': "_bfhk1kmu",
    'color.background.warning.bold.hovered': "_bfhk1spp",
    'color.background.warning.bold.pressed': "_bfhk4m4m",
    'color.background.success': "_bfhk1y9u",
    'color.background.success.hovered': "_bfhk1vfx",
    'color.background.success.pressed': "_bfhk1wl5",
    'color.background.success.bold': "_bfhkkcmj",
    'color.background.success.bold.hovered': "_bfhky7x8",
    'color.background.success.bold.pressed': "_bfhkwcbh",
    'color.background.discovery': "_bfhk6vm6",
    'color.background.discovery.hovered': "_bfhk12eq",
    'color.background.discovery.pressed': "_bfhk18vq",
    'color.background.discovery.bold': "_bfhku5tj",
    'color.background.discovery.bold.hovered': "_bfhkfqeg",
    'color.background.discovery.bold.pressed': "_bfhk1f1m",
    'color.background.information': "_bfhk19ip",
    'color.background.information.hovered': "_bfhk86z5",
    'color.background.information.pressed': "_bfhk1c1j",
    'color.background.information.bold': "_bfhkx4w0",
    'color.background.information.bold.hovered': "_bfhkq2ii",
    'color.background.information.bold.pressed': "_bfhkf89v",
    'color.blanket': "_bfhk1i5c",
    'color.blanket.selected': "_bfhk7wq0",
    'color.blanket.danger': "_bfhkrprw",
    'color.skeleton': "_bfhkizff",
    'color.skeleton.subtle': "_bfhkvkf5",
    'elevation.surface': "_bfhkvuon",
    'elevation.surface.hovered': "_bfhk19i6",
    'elevation.surface.pressed': "_bfhk13ro",
    'elevation.surface.overlay': "_bfhk1bhr",
    'elevation.surface.overlay.hovered': "_bfhk6o2t",
    'elevation.surface.overlay.pressed': "_bfhkm8nx",
    'elevation.surface.raised': "_bfhkhp5a",
    'elevation.surface.raised.hovered': "_bfhk116u",
    'elevation.surface.raised.pressed': "_bfhk14aj",
    'elevation.surface.sunken': "_bfhkhfxm",
    'utility.elevation.surface.current': "_bfhkchd4"
};
var $e742d9ca3a0f53ff$var$CURRENT_SURFACE_CSS_VAR = "--ds-elevation-surface-current";
var $e742d9ca3a0f53ff$var$setSurfaceTokenMap = {
    'elevation.surface': "_1q1lvuon",
    'elevation.surface.hovered': "_1q1l19i6",
    'elevation.surface.pressed': "_1q1l13ro",
    'elevation.surface.overlay': "_1q1l1bhr",
    'elevation.surface.overlay.hovered': "_1q1l6o2t",
    'elevation.surface.overlay.pressed': "_1q1lm8nx",
    'elevation.surface.raised': "_1q1lhp5a",
    'elevation.surface.raised.hovered': "_1q1l116u",
    'elevation.surface.raised.pressed': "_1q1l14aj",
    'elevation.surface.sunken': "_1q1lhfxm"
};
var $e742d9ca3a0f53ff$var$paddingBlockStartMap = {
    'space.0': "_1q51ze3t",
    'space.025': "_1q51v77o",
    'space.050': "_1q511b66",
    'space.075': "_1q5112x7",
    'space.100': "_1q51u2gc",
    'space.150': "_1q51utpp",
    'space.200': "_1q51pxbi",
    'space.250': "_1q51v47k",
    'space.300': "_1q511ejb",
    'space.400': "_1q51xy5q",
    'space.500': "_1q511jfw",
    'space.600': "_1q51oahv",
    'space.800': "_1q51xncg",
    'space.1000': "_1q511epz"
};
var $e742d9ca3a0f53ff$var$paddingBlockEndMap = {
    'space.0': "_85i5ze3t",
    'space.025': "_85i5v77o",
    'space.050': "_85i51b66",
    'space.075': "_85i512x7",
    'space.100': "_85i5u2gc",
    'space.150': "_85i5utpp",
    'space.200': "_85i5pxbi",
    'space.250': "_85i5v47k",
    'space.300': "_85i51ejb",
    'space.400': "_85i5xy5q",
    'space.500': "_85i51jfw",
    'space.600': "_85i5oahv",
    'space.800': "_85i5xncg",
    'space.1000': "_85i51epz"
};
var $e742d9ca3a0f53ff$var$paddingInlineStartMap = {
    'space.0': "_bozgze3t",
    'space.025': "_bozgv77o",
    'space.050': "_bozg1b66",
    'space.075': "_bozg12x7",
    'space.100': "_bozgu2gc",
    'space.150': "_bozgutpp",
    'space.200': "_bozgpxbi",
    'space.250': "_bozgv47k",
    'space.300': "_bozg1ejb",
    'space.400': "_bozgxy5q",
    'space.500': "_bozg1jfw",
    'space.600': "_bozgoahv",
    'space.800': "_bozgxncg",
    'space.1000': "_bozg1epz"
};
var $e742d9ca3a0f53ff$var$paddingInlineEndMap = {
    'space.0': "_y4tize3t",
    'space.025': "_y4tiv77o",
    'space.050': "_y4ti1b66",
    'space.075': "_y4ti12x7",
    'space.100': "_y4tiu2gc",
    'space.150': "_y4tiutpp",
    'space.200': "_y4tipxbi",
    'space.250': "_y4tiv47k",
    'space.300': "_y4ti1ejb",
    'space.400': "_y4tixy5q",
    'space.500': "_y4ti1jfw",
    'space.600': "_y4tioahv",
    'space.800': "_y4tixncg",
    'space.1000': "_y4ti1epz"
};
/**
 * __Box__
 *
 * A Box is a primitive component that has the design decisions of the Atlassian Design System baked in.
 * Renders a `div` by default.
 *
 * - [Examples](https://atlassian.design/components/primitives/box/examples)
 * - [Code](https://atlassian.design/components/primitives/box/code)
 * - [Usage](https://atlassian.design/components/primitives/box/usage)
 */ var $e742d9ca3a0f53ff$var$Box = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? 'div' : _ref$as, children = _ref.children, backgroundColor = _ref.backgroundColor, padding = _ref.padding, _ref$paddingBlock = _ref.paddingBlock, paddingBlock = _ref$paddingBlock === void 0 ? padding : _ref$paddingBlock, _ref$paddingBlockStar = _ref.paddingBlockStart, paddingBlockStart = _ref$paddingBlockStar === void 0 ? paddingBlock : _ref$paddingBlockStar, _ref$paddingBlockEnd = _ref.paddingBlockEnd, paddingBlockEnd = _ref$paddingBlockEnd === void 0 ? paddingBlock : _ref$paddingBlockEnd, _ref$paddingInline = _ref.paddingInline, paddingInline = _ref$paddingInline === void 0 ? padding : _ref$paddingInline, _ref$paddingInlineSta = _ref.paddingInlineStart, paddingInlineStart = _ref$paddingInlineSta === void 0 ? paddingInline : _ref$paddingInlineSta, _ref$paddingInlineEnd = _ref.paddingInlineEnd, paddingInlineEnd = _ref$paddingInlineEnd === void 0 ? paddingInline : _ref$paddingInlineEnd, style = _ref.style, testId = _ref.testId, xcss = _ref.xcss, htmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $e742d9ca3a0f53ff$var$_excluded);
    // This is to remove className from safeHtmlAttributes
    // @ts-ignore -- not using expect since it causes issues with help-center local consumption - className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(htmlAttributes, $e742d9ca3a0f53ff$var$_excluded2);
    var node = /*#__PURE__*/ $5FkrB.createElement(Component, (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        style: style,
        ref: ref,
        className: (0, $970q7.default)([
            "_19itglyw _vchhusvi _r06hglyw",
            backgroundColor && $e742d9ca3a0f53ff$var$backgroundColorMap[backgroundColor],
            backgroundColor && $e742d9ca3a0f53ff$var$isSurfaceToken(backgroundColor) && $e742d9ca3a0f53ff$var$setSurfaceTokenMap[backgroundColor],
            paddingBlockStart && $e742d9ca3a0f53ff$var$paddingBlockStartMap[paddingBlockStart],
            paddingBlockEnd && $e742d9ca3a0f53ff$var$paddingBlockEndMap[paddingBlockEnd],
            paddingInlineStart && $e742d9ca3a0f53ff$var$paddingInlineStartMap[paddingInlineStart],
            paddingInlineEnd && $e742d9ca3a0f53ff$var$paddingInlineEndMap[paddingInlineEnd],
            xcss
        ])
    }, safeHtmlAttributes, {
        "data-testid": testId
    }), children);
    if (backgroundColor) return /*#__PURE__*/ $5FkrB.createElement((0, $5819f5812836f95c$export$1ca2a26fecb070ae).Provider, {
        value: backgroundColor
    }, node);
    return node;
});
var $e742d9ca3a0f53ff$export$2e2bcd8739ae039 = $e742d9ca3a0f53ff$var$Box;
function $e742d9ca3a0f53ff$var$isSurfaceToken(backgroundColor) {
    return backgroundColor in $e742d9ca3a0f53ff$var$setSurfaceTokenMap;
}


/* popper-wrapper.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $fC8ib = parcelRequire("fC8ib");

var $iYJcE = parcelRequire("iYJcE");

var $kqp0i = parcelRequire("kqp0i");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");

var $d0sVE = parcelRequire("d0sVE");

var $9Zzpd = parcelRequire("9Zzpd");

var $5K5L9 = parcelRequire("5K5L9");

var $5FkrB = parcelRequire("5FkrB");
var $9ff21690e81854db$export$51eddd7655ca235a = function RepositionOnUpdate(_ref) {
    var children = _ref.children, update = _ref.update;
    // Ref used here to skip update on first render (when refs haven't been set)
    var isFirstRenderRef = (0, $5FkrB.useRef)(true);
    (0, $5FkrB.useLayoutEffect)(function() {
        if (isFirstRenderRef.current) {
            isFirstRenderRef.current = false;
            return;
        }
        // callback function from popper that repositions pop-up on content Update
        update();
    }, [
        update
    ]);
    // wrapping in fragment to make TS happy (known issue with FC returning children)
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $5FkrB.Fragment), null, children);
};


// eslint-disable-next-line no-duplicate-imports

var $5FkrB = parcelRequire("5FkrB");

var $7QpUe = parcelRequire("7QpUe");

var $eVb4V = parcelRequire("eVb4V");

var $d0sVE = parcelRequire("d0sVE");

var $9Zzpd = parcelRequire("9Zzpd");
var $e962dfc5f504308f$var$interactiveTags = [
    'button',
    'a',
    'input',
    'select',
    'textarea'
];
var $e962dfc5f504308f$export$3dee5e4542c672d9 = function isInteractiveElement(element) {
    if ($e962dfc5f504308f$var$interactiveTags.includes(element.tagName.toLowerCase())) return true;
    if (element.getAttribute('tabindex') !== null || element.hasAttribute('contenteditable')) return true;
    return false;
};



var $5FkrB = parcelRequire("5FkrB");
var $2a61597e2c62c9d6$export$641fa9c94086b46e = function useAnimationFrame() {
    var animationsRef = (0, $5FkrB.useRef)([]);
    var requestFrame = (0, $5FkrB.useCallback)(function(callback) {
        var id = requestAnimationFrame(callback);
        animationsRef.current.push(id);
        return id;
    }, []);
    var cancelFrame = (0, $5FkrB.useCallback)(function(id) {
        cancelAnimationFrame(id);
        animationsRef.current = animationsRef.current.filter(function(frameId) {
            return frameId !== id;
        });
    }, []);
    var cancelAllFrames = (0, $5FkrB.useCallback)(function() {
        animationsRef.current.forEach(function(id) {
            return cancelAnimationFrame(id);
        });
        animationsRef.current = [];
    }, []);
    return {
        requestFrame: requestFrame,
        cancelFrame: cancelFrame,
        cancelAllFrames: cancelAllFrames
    };
};


var $2b02c5c2ea73e4af$export$92dae2778ae88f9d = function useCloseManager(_ref) {
    var isOpen = _ref.isOpen, onClose = _ref.onClose, popupRef = _ref.popupRef, triggerRef = _ref.triggerRef, autoFocus = _ref.autoFocus, shouldDisableFocusTrap = _ref.shouldDisableFocusTrap, capture = _ref.shouldUseCaptureOnOutsideClick, shouldCloseOnTab = _ref.shouldCloseOnTab, shouldRenderToParent = _ref.shouldRenderToParent;
    var _useLayering = (0, $d0sVE.useLayering)(), isLayerDisabled = _useLayering.isLayerDisabled, currentLevel = _useLayering.currentLevel;
    var _useAnimationFrame = (0, $2a61597e2c62c9d6$export$641fa9c94086b46e)(), requestFrame = _useAnimationFrame.requestFrame, cancelAllFrames = _useAnimationFrame.cancelAllFrames;
    var mouseDownTarget = (0, $5FkrB.useRef)(null);
    (0, $5FkrB.useEffect)(function() {
        if (!isOpen || !popupRef) return 0, $eVb4V.default;
        var closePopup = function closePopup(event) {
            if (onClose) {
                var _currentLevel = null;
                if (event.target instanceof HTMLElement) {
                    var _event$target$closest, _event$target$closest2;
                    _currentLevel = (_event$target$closest = (_event$target$closest2 = event.target.closest("[data-ds--level]")) === null || _event$target$closest2 === void 0 ? void 0 : _event$target$closest2.getAttribute('data-ds--level')) !== null && _event$target$closest !== void 0 ? _event$target$closest : null;
                }
                _currentLevel ? onClose(event, Number(_currentLevel)) : onClose(event);
            }
            if (shouldDisableFocusTrap && (0, $9Zzpd.fg)('platform_dst_popup-disable-focuslock')) // Restoring the normal focus order for trigger.
            requestFrame(function() {
                triggerRef === null || triggerRef === void 0 || triggerRef.setAttribute('tabindex', '0');
                if (popupRef && autoFocus) popupRef.setAttribute('tabindex', '0');
            });
        };
        // This check is required for cases where components like
        // Select or DDM are placed inside a Popup. A click
        // on a MenuItem or Option would close the Popup, without registering
        // a click on DDM/Select.
        // Users would have to call `onClose` manually to close the Popup in these cases.
        // You can see the bug in action here:
        // https://codesandbox.io/s/atlaskitpopup-default-forked-2eb87?file=/example.tsx:0-1788
        var onClick = function onClick(event) {
            var target = event.target;
            var doesDomNodeExist = document.body.contains(target);
            if (!doesDomNodeExist) return;
            if (isLayerDisabled()) {
                if (target instanceof HTMLElement) {
                    var _target$closest;
                    var layeredElement = (_target$closest = target.closest) === null || _target$closest === void 0 ? void 0 : _target$closest.call(target, "[data-ds--level]");
                    if (layeredElement) {
                        var closeType = layeredElement.getAttribute('[data-ds--close--type]');
                        if (closeType === 'single') // if the close type is single, we won't close other disabled layers when clicking outside
                        return;
                        var levelOfClickedLayer = layeredElement.getAttribute('data-ds--level');
                        if (levelOfClickedLayer && Number(levelOfClickedLayer) > currentLevel) // won't trigger onClick event when we click in a higher layer.
                        return;
                    }
                }
            }
            var isClickOnPopup = popupRef && popupRef.contains(target);
            var isClickOnTrigger = triggerRef && triggerRef.contains(target);
            var didClickStartInsidePopup = popupRef && mouseDownTarget.current instanceof Node && popupRef.contains(mouseDownTarget.current);
            if (!isClickOnPopup && !isClickOnTrigger && !didClickStartInsidePopup) {
                closePopup(event);
                // If there was an outside click on a non-interactive element, the focus should be on the trigger.
                if (document.activeElement && !(0, $e962dfc5f504308f$export$3dee5e4542c672d9)(document.activeElement) && (0, $9Zzpd.fg)('platform_dst_popup-disable-focuslock')) triggerRef === null || triggerRef === void 0 || triggerRef.focus();
            }
        };
        var onMouseDown = function onMouseDown(event) {
            /**
       * Tracking the target of the mouse down event.
       * This is used to prevent the popup from closing when the user mouses down inside the popup, but then
       * moves the mouse outside the popup before releasing the mouse button.
       *
       * This is a common user interaction - users may have mistakenly clicked on something, or changed their mind,
       * so they try to cancel their click by moving their mouse away from what they had moused down on.
       *
       * Blanket uses the same technique.
       */ mouseDownTarget.current = event.target;
        };
        var onKeyDown = function onKeyDown(event) {
            if ((0, $9Zzpd.fg)('platform_dst_popup-disable-focuslock')) {
                var key = event.key, shiftKey = event.shiftKey;
                if (shiftKey && key === 'Tab' && !shouldRenderToParent) {
                    if (isLayerDisabled()) return;
                    // We need to move the focus to the popup trigger when the popup is displayed in React.Portal.
                    requestFrame(function() {
                        var isPopupFocusOut = popupRef && !popupRef.contains(document.activeElement);
                        if (isPopupFocusOut) {
                            closePopup(event);
                            if (currentLevel === 1) triggerRef === null || triggerRef === void 0 || triggerRef.focus();
                        }
                    });
                    return;
                }
                if (key === 'Tab') {
                    var _document$activeEleme;
                    // We have cases where we need to close the Popup on Tab press.
                    // Example: DropdownMenu
                    if (shouldCloseOnTab) {
                        if (isLayerDisabled()) return;
                        closePopup(event);
                        return;
                    }
                    if (isLayerDisabled() && (_document$activeEleme = document.activeElement) !== null && _document$activeEleme !== void 0 && _document$activeEleme.closest('[aria-modal]')) return;
                    if (shouldDisableFocusTrap) {
                        if (shouldRenderToParent) // We need to move the focus to the previous interactive element before popup trigger
                        requestFrame(function() {
                            var isPopupFocusOut = popupRef && !popupRef.contains(document.activeElement);
                            if (isPopupFocusOut) closePopup(event);
                        });
                        else requestFrame(function() {
                            if (!document.hasFocus()) closePopup(event);
                        });
                        return;
                    }
                }
                if (isLayerDisabled()) return;
                if (key === 'Escape' || key === 'Esc') {
                    if (triggerRef && autoFocus) triggerRef.focus();
                    closePopup(event);
                }
            } else {
                if (isLayerDisabled()) return;
                var _key = event.key;
                if (_key === 'Escape' || _key === 'Esc' || shouldCloseOnTab && _key === 'Tab') closePopup(event);
            }
        };
        var unbind = (0, $eVb4V.default);
        if ((0, $9Zzpd.fg)('popup-onclose-fix')) setTimeout(function() {
            unbind = (0, $7QpUe.bindAll)(window, [
                {
                    type: 'click',
                    listener: onClick,
                    options: {
                        capture: capture
                    }
                },
                {
                    type: 'keydown',
                    listener: onKeyDown
                },
                {
                    type: 'mousedown',
                    listener: onMouseDown
                }
            ]);
        }, 0);
        else unbind = (0, $7QpUe.bindAll)(window, [
            {
                type: 'click',
                listener: onClick,
                options: {
                    capture: capture
                }
            },
            {
                type: 'keydown',
                listener: onKeyDown
            },
            {
                type: 'mousedown',
                listener: onMouseDown
            }
        ]);
        // bind onBlur event listener to fix popup not close when clicking on iframe outside
        var unbindBlur = (0, $eVb4V.default);
        unbindBlur = (0, $7QpUe.bind)(window, {
            type: 'blur',
            listener: function onBlur(e) {
                if (isLayerDisabled() || !(document.activeElement instanceof HTMLIFrameElement)) return;
                closePopup(e);
            }
        });
        return function() {
            if ((0, $9Zzpd.fg)('popup-onclose-fix')) setTimeout(function() {
                unbind();
            }, 0);
            else unbind();
            cancelAllFrames();
            unbindBlur();
        };
    }, [
        isOpen,
        onClose,
        popupRef,
        triggerRef,
        autoFocus,
        shouldDisableFocusTrap,
        capture,
        isLayerDisabled,
        shouldCloseOnTab,
        currentLevel,
        shouldRenderToParent,
        requestFrame,
        cancelAllFrames
    ]);
};



var $5FkrB = parcelRequire("5FkrB");

var $b6Hjk = parcelRequire("b6Hjk");

var $eVb4V = parcelRequire("eVb4V");

var $d0sVE = parcelRequire("d0sVE");

var $9Zzpd = parcelRequire("9Zzpd");

var $f59e68d18d0b7a21$export$10c5169755ce7bd7 = function useFocusManager(_ref) {
    var initialFocusRef = _ref.initialFocusRef, popupRef = _ref.popupRef, triggerRef = _ref.triggerRef, autoFocus = _ref.autoFocus, shouldCloseOnTab = _ref.shouldCloseOnTab, shouldDisableFocusTrap = _ref.shouldDisableFocusTrap, shouldReturnFocus = _ref.shouldReturnFocus, shouldRenderToParent = _ref.shouldRenderToParent;
    var _useAnimationFrame = (0, $2a61597e2c62c9d6$export$641fa9c94086b46e)(), requestFrame = _useAnimationFrame.requestFrame, cancelAllFrames = _useAnimationFrame.cancelAllFrames;
    var _useLayering = (0, $d0sVE.useLayering)(), currentLevel = _useLayering.currentLevel;
    (0, $5FkrB.useEffect)(function() {
        if (!popupRef || shouldCloseOnTab) return 0, $eVb4V.default;
        if (shouldDisableFocusTrap && (0, $9Zzpd.fg)('platform_dst_popup-disable-focuslock')) {
            var isDropdown = popupRef.matches('[id^=ds--dropdown--]');
            var popups = document.querySelectorAll("[data-ds--level=\"".concat(currentLevel - 1, "\"]"));
            if (!(popups[popups.length - 1] && !shouldRenderToParent && isDropdown)) {
                // Plucking trigger & popup content container from the tab order so that
                // when we Shift+Tab, the focus moves to the element before trigger
                requestFrame(function() {
                    triggerRef === null || triggerRef === void 0 || triggerRef.setAttribute('tabindex', '-1');
                    if (popupRef && autoFocus) popupRef.setAttribute('tabindex', '-1');
                    (initialFocusRef || popupRef).focus();
                });
                return 0, $eVb4V.default;
            }
        }
        var trapConfig = {
            clickOutsideDeactivates: true,
            escapeDeactivates: true,
            initialFocus: initialFocusRef || popupRef,
            fallbackFocus: popupRef,
            returnFocusOnDeactivate: shouldReturnFocus
        };
        var focusTrap = (0, (/*@__PURE__*/$parcel$interopDefault($b6Hjk)))(popupRef, trapConfig);
        // Wait for the popup to reposition itself before we focus
        requestFrame(function() {
            focusTrap.activate();
        });
        return function() {
            cancelAllFrames();
            focusTrap.deactivate();
        };
    }, [
        popupRef,
        triggerRef,
        autoFocus,
        initialFocusRef,
        shouldCloseOnTab,
        shouldDisableFocusTrap,
        requestFrame,
        cancelAllFrames,
        shouldReturnFocus,
        shouldRenderToParent,
        currentLevel
    ]);
};


var $3196b959b9338ecd$var$_excluded = [
    "shouldRenderToParent",
    "shouldFitContainer",
    "children",
    "appearance",
    "className",
    "isReferenceHidden",
    "shouldFitViewport"
];
var $3196b959b9338ecd$var$LOCAL_CURRENT_SURFACE_CSS_VAR = '--ds-elevation-surface-current';
var $3196b959b9338ecd$var$fullWidthStyles = null;
var $3196b959b9338ecd$var$wrapperStyles = {
    root: "_2rko12b0 _1e0c1ule _vchhusvi _1pby1nn1 _bfhk1bhr _16qs130s _syazi7uo _1q1l1bhr _nt751r31 _49pcglyw _1hvw1o36",
    rootT26Shape: "_2rko1mok"
};
var $3196b959b9338ecd$var$scrollableStyles = null;
var $3196b959b9338ecd$var$blanketStyles = null;
var $3196b959b9338ecd$var$modalStyles = null;
var $3196b959b9338ecd$var$newModalStyles = null;
var $3196b959b9338ecd$var$focusRingStyles = {
    root: "_mizu194a _1ah3dkaa _ra3xnqa1 _128mdkaa _1cvmnqa1 _4davt94y"
};
var $3196b959b9338ecd$var$DefaultPopupComponent = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function(props, ref) {
    var shouldRenderToParent = props.shouldRenderToParent, shouldFitContainer = props.shouldFitContainer, children = props.children, appearance = props.appearance, className = props.className, _isReferenceHidden = props.isReferenceHidden, shouldFitViewport = props.shouldFitViewport, htmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(props, $3196b959b9338ecd$var$_excluded);
    return /*#__PURE__*/ $5FkrB.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $970q7.default)([
            $3196b959b9338ecd$var$wrapperStyles.root,
            (0, $9Zzpd.fg)('platform-dst-shape-theme-default') && $3196b959b9338ecd$var$wrapperStyles.rootT26Shape,
            appearance === 'UNSAFE_modal-below-sm' && !(0, $9Zzpd.fg)('platform_dst_nav4_flyout_menu_slots_close_button') && "_dk5d1b66 _c71ldtre _kqsw1n9t _152t1b66",
            appearance === 'UNSAFE_modal-below-sm' && (0, $9Zzpd.fg)('platform_dst_nav4_flyout_menu_slots_close_button') && "_dk5d1b66 _c71l1ei0 _kqsw1n9t _152t1b66",
            (!shouldRenderToParent || shouldFitViewport && (0, $9Zzpd.fg)('platform_dst_nav4_flyoutmenuitem_render_to_parent')) && "_1reo1wug _18m91wug",
            shouldFitContainer && "_1bsb1osq",
            className
        ])
    }, htmlAttributes, {
        ref: ref
    }), children);
});
function $3196b959b9338ecd$var$PopperWrapper(_ref) {
    var xcss = _ref.xcss, isOpen = _ref.isOpen, id = _ref.id, offset = _ref.offset, testId = _ref.testId, content = _ref.content, fallbackPlacements = _ref.fallbackPlacements, onClose = _ref.onClose, boundary = _ref.boundary, rootBoundary = _ref.rootBoundary, shouldFlip = _ref.shouldFlip, _ref$placement = _ref.placement, placement = _ref$placement === void 0 ? 'auto' : _ref$placement, _ref$popupComponent = _ref.popupComponent, PopupContainer = _ref$popupComponent === void 0 ? $3196b959b9338ecd$var$DefaultPopupComponent : _ref$popupComponent, _ref$autoFocus = _ref.autoFocus, autoFocus = _ref$autoFocus === void 0 ? true : _ref$autoFocus, triggerRef = _ref.triggerRef, shouldUseCaptureOnOutsideClick = _ref.shouldUseCaptureOnOutsideClick, shouldRenderToParent = _ref.shouldRenderToParent, shouldFitContainer = _ref.shouldFitContainer, shouldDisableFocusLock = _ref.shouldDisableFocusLock, _ref$shouldReturnFocu = _ref.shouldReturnFocus, shouldReturnFocus = _ref$shouldReturnFocu === void 0 ? true : _ref$shouldReturnFocu, strategy = _ref.strategy, role = _ref.role, label = _ref.label, titleId = _ref.titleId, modifiers = _ref.modifiers, shouldFitViewport = _ref.shouldFitViewport, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'default' : _ref$appearance;
    var _useState = (0, $5FkrB.useState)(null), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), popupRef = _useState2[0], setPopupRef = _useState2[1];
    var _useState3 = (0, $5FkrB.useState)(null), _useState4 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState3, 2), initialFocusRef = _useState4[0], setInitialFocusRef = _useState4[1];
    // We have cases where we need to close the Popup on Tab press, e.g. DropdownMenu
    var shouldCloseOnTab = shouldRenderToParent && shouldDisableFocusLock;
    var shouldDisableFocusTrap = role !== 'dialog';
    (0, $f59e68d18d0b7a21$export$10c5169755ce7bd7)({
        initialFocusRef: initialFocusRef,
        popupRef: popupRef,
        shouldCloseOnTab: shouldCloseOnTab,
        triggerRef: triggerRef,
        autoFocus: autoFocus,
        shouldDisableFocusTrap: shouldDisableFocusTrap,
        shouldReturnFocus: shouldReturnFocus
    });
    (0, $2b02c5c2ea73e4af$export$92dae2778ae88f9d)({
        isOpen: isOpen,
        onClose: onClose,
        popupRef: popupRef,
        triggerRef: triggerRef,
        shouldUseCaptureOnOutsideClick: shouldUseCaptureOnOutsideClick,
        shouldCloseOnTab: shouldCloseOnTab,
        autoFocus: autoFocus,
        shouldDisableFocusTrap: shouldDisableFocusTrap,
        shouldRenderToParent: shouldRenderToParent
    });
    var _useLayering = (0, $d0sVE.useLayering)(), currentLevel = _useLayering.currentLevel;
    var mergedModifiers = (0, $5FkrB.useMemo)(function() {
        return [
            {
                name: 'flip',
                enabled: shouldFlip,
                options: {
                    rootBoundary: rootBoundary,
                    boundary: boundary,
                    fallbackPlacements: fallbackPlacements
                }
            }
        ].concat((0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(modifiers || []));
    }, [
        shouldFlip,
        rootBoundary,
        boundary,
        fallbackPlacements,
        modifiers
    ]);
    return /*#__PURE__*/ $5FkrB.createElement((0, $5K5L9.Popper), {
        placement: placement,
        offset: offset,
        modifiers: mergedModifiers,
        strategy: strategy,
        shouldFitViewport: shouldFitViewport
    }, function(_ref2) {
        var _ref3 = _ref2.ref, style = _ref2.style, placement = _ref2.placement, update = _ref2.update, isReferenceHidden = _ref2.isReferenceHidden;
        var popupContainer = /*#__PURE__*/ $5FkrB.createElement(PopupContainer, {
            className: (0, $970q7.default)([
                xcss,
                // @ts-expect-error: `ax` is not typed correctly
                !initialFocusRef && (0, $9Zzpd.fg)('platform-design-system-apply-popup-wrapper-focus') && $3196b959b9338ecd$var$focusRingStyles.root
            ]),
            appearance: appearance,
            id: id,
            "data-ds--level": currentLevel,
            "data-placement": placement,
            "data-testid": testId,
            role: role,
            "aria-label": label,
            "aria-labelledby": titleId,
            ref: function ref(node) {
                if (node) {
                    if (typeof _ref3 === 'function') _ref3(node);
                    else _ref3.current = node;
                    setPopupRef(node);
                }
            },
            style: appearance === 'UNSAFE_modal-below-sm' ? {} : style,
            tabIndex: autoFocus ? 0 : undefined,
            shouldRenderToParent: shouldRenderToParent,
            shouldFitContainer: shouldFitContainer,
            shouldFitViewport: shouldFitViewport,
            isReferenceHidden: isReferenceHidden
        }, /*#__PURE__*/ $5FkrB.createElement((0, $9ff21690e81854db$export$51eddd7655ca235a), {
            update: update
        }, content({
            update: update,
            isOpen: isOpen,
            onClose: onClose,
            setInitialFocusRef: setInitialFocusRef
        })));
        return /*#__PURE__*/ $5FkrB.createElement((0, $5FkrB.Fragment), null, popupContainer, appearance === 'UNSAFE_modal-below-sm' && /*#__PURE__*/ $5FkrB.createElement("div", {
            className: (0, $970q7.default)([
                "_1r04idpf _kqsw1n9t _bfhk1i5c"
            ])
        }));
    });
}
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$3196b959b9338ecd$export$2e2bcd8739ae039 = $3196b959b9338ecd$var$PopperWrapper;



var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");

var $5FkrB = parcelRequire("5FkrB");

var $7QpUe = parcelRequire("7QpUe");
/**
 * This is an object of usable media query helpers using our internal breakpoints configuration.
 *
 * When using Compiled CSS-in-JS, please ensure that only a single declaration can take effect at a time.
 * This means that you should avoid multiple breakpoints taking effect at the same time,
 * eg. ```{ [media.above.xs]: { color: 'red' }, [media.above.sm]: { color: 'green' }}```.
 * Instead, make sure that only one breakpoint can take effect at a time,
 * e.g, ```{ [media.only.xs]: { color: 'red' }, [media.above.sm]: { color: 'green' }}```.
 * For more details, please see <https://compiledcssinjs.com/docs/atomic-css#selector-specificity>.
 */ var $31397d21cdb1c0e3$export$987d49ffe1b0900f = {
    above: {
        // TODO: Should this even exist, we don't want `css({ [media.above.xxs]: { … } })` because that just adds duplicates styles!
        xxs: '@media all',
        xs: '@media (min-width: 30rem)',
        sm: '@media (min-width: 48rem)',
        md: '@media (min-width: 64rem)',
        lg: '@media (min-width: 90rem)',
        xl: '@media (min-width: 110.5rem)'
    },
    only: {
        xxs: '@media (min-width: 0rem) and (max-width: 29.99rem)',
        xs: '@media (min-width: 30rem) and (max-width: 47.99rem)',
        sm: '@media (min-width: 48rem) and (max-width: 63.99rem)',
        md: '@media (min-width: 64rem) and (max-width: 89.99rem)',
        lg: '@media (min-width: 90rem) and (max-width: 110.49rem)',
        xl: '@media (min-width: 110.5rem)'
    },
    below: {
        xs: '@media not all and (min-width: 30rem)',
        sm: '@media not all and (min-width: 48rem)',
        md: '@media not all and (min-width: 64rem)',
        lg: '@media not all and (min-width: 90rem)',
        xl: '@media not all and (min-width: 110.5rem)'
    }
};


var $9920808c70af0ef3$var$_window, $9920808c70af0ef3$var$_window$matchMedia, $9920808c70af0ef3$var$_window2, $9920808c70af0ef3$var$_window2$matchMedia, $9920808c70af0ef3$var$_window3, $9920808c70af0ef3$var$_window3$matchMedia, $9920808c70af0ef3$var$_window4, $9920808c70af0ef3$var$_window4$matchMedia, $9920808c70af0ef3$var$_window5, $9920808c70af0ef3$var$_window5$matchMedia, $9920808c70af0ef3$var$_window6, $9920808c70af0ef3$var$_window6$matchMedia, $9920808c70af0ef3$var$_window7, $9920808c70af0ef3$var$_window7$matchMedia, $9920808c70af0ef3$var$_window8, $9920808c70af0ef3$var$_window8$matchMedia, $9920808c70af0ef3$var$_window9, $9920808c70af0ef3$var$_window9$matchMedia, $9920808c70af0ef3$var$_window0, $9920808c70af0ef3$var$_window0$matchMedia, $9920808c70af0ef3$var$_window1, $9920808c70af0ef3$var$_window1$matchMedia;
var $9920808c70af0ef3$var$queries = {
    'above.xxs': typeof window === 'undefined' ? undefined : ($9920808c70af0ef3$var$_window = window) === null || $9920808c70af0ef3$var$_window === void 0 || ($9920808c70af0ef3$var$_window$matchMedia = $9920808c70af0ef3$var$_window.matchMedia) === null || $9920808c70af0ef3$var$_window$matchMedia === void 0 ? void 0 : $9920808c70af0ef3$var$_window$matchMedia.call($9920808c70af0ef3$var$_window, (0, $31397d21cdb1c0e3$export$987d49ffe1b0900f).above.xxs.replace('@media ', '').trim()),
    'above.xs': typeof window === 'undefined' ? undefined : ($9920808c70af0ef3$var$_window2 = window) === null || $9920808c70af0ef3$var$_window2 === void 0 || ($9920808c70af0ef3$var$_window2$matchMedia = $9920808c70af0ef3$var$_window2.matchMedia) === null || $9920808c70af0ef3$var$_window2$matchMedia === void 0 ? void 0 : $9920808c70af0ef3$var$_window2$matchMedia.call($9920808c70af0ef3$var$_window2, (0, $31397d21cdb1c0e3$export$987d49ffe1b0900f).above.xs.replace('@media ', '').trim()),
    'above.sm': typeof window === 'undefined' ? undefined : ($9920808c70af0ef3$var$_window3 = window) === null || $9920808c70af0ef3$var$_window3 === void 0 || ($9920808c70af0ef3$var$_window3$matchMedia = $9920808c70af0ef3$var$_window3.matchMedia) === null || $9920808c70af0ef3$var$_window3$matchMedia === void 0 ? void 0 : $9920808c70af0ef3$var$_window3$matchMedia.call($9920808c70af0ef3$var$_window3, (0, $31397d21cdb1c0e3$export$987d49ffe1b0900f).above.sm.replace('@media ', '').trim()),
    'above.md': typeof window === 'undefined' ? undefined : ($9920808c70af0ef3$var$_window4 = window) === null || $9920808c70af0ef3$var$_window4 === void 0 || ($9920808c70af0ef3$var$_window4$matchMedia = $9920808c70af0ef3$var$_window4.matchMedia) === null || $9920808c70af0ef3$var$_window4$matchMedia === void 0 ? void 0 : $9920808c70af0ef3$var$_window4$matchMedia.call($9920808c70af0ef3$var$_window4, (0, $31397d21cdb1c0e3$export$987d49ffe1b0900f).above.md.replace('@media ', '').trim()),
    'above.lg': typeof window === 'undefined' ? undefined : ($9920808c70af0ef3$var$_window5 = window) === null || $9920808c70af0ef3$var$_window5 === void 0 || ($9920808c70af0ef3$var$_window5$matchMedia = $9920808c70af0ef3$var$_window5.matchMedia) === null || $9920808c70af0ef3$var$_window5$matchMedia === void 0 ? void 0 : $9920808c70af0ef3$var$_window5$matchMedia.call($9920808c70af0ef3$var$_window5, (0, $31397d21cdb1c0e3$export$987d49ffe1b0900f).above.lg.replace('@media ', '').trim()),
    'above.xl': typeof window === 'undefined' ? undefined : ($9920808c70af0ef3$var$_window6 = window) === null || $9920808c70af0ef3$var$_window6 === void 0 || ($9920808c70af0ef3$var$_window6$matchMedia = $9920808c70af0ef3$var$_window6.matchMedia) === null || $9920808c70af0ef3$var$_window6$matchMedia === void 0 ? void 0 : $9920808c70af0ef3$var$_window6$matchMedia.call($9920808c70af0ef3$var$_window6, (0, $31397d21cdb1c0e3$export$987d49ffe1b0900f).above.xl.replace('@media ', '').trim()),
    'below.xs': typeof window === 'undefined' ? undefined : ($9920808c70af0ef3$var$_window7 = window) === null || $9920808c70af0ef3$var$_window7 === void 0 || ($9920808c70af0ef3$var$_window7$matchMedia = $9920808c70af0ef3$var$_window7.matchMedia) === null || $9920808c70af0ef3$var$_window7$matchMedia === void 0 ? void 0 : $9920808c70af0ef3$var$_window7$matchMedia.call($9920808c70af0ef3$var$_window7, (0, $31397d21cdb1c0e3$export$987d49ffe1b0900f).below.xs.replace('@media ', '').trim()),
    'below.sm': typeof window === 'undefined' ? undefined : ($9920808c70af0ef3$var$_window8 = window) === null || $9920808c70af0ef3$var$_window8 === void 0 || ($9920808c70af0ef3$var$_window8$matchMedia = $9920808c70af0ef3$var$_window8.matchMedia) === null || $9920808c70af0ef3$var$_window8$matchMedia === void 0 ? void 0 : $9920808c70af0ef3$var$_window8$matchMedia.call($9920808c70af0ef3$var$_window8, (0, $31397d21cdb1c0e3$export$987d49ffe1b0900f).below.sm.replace('@media ', '').trim()),
    'below.md': typeof window === 'undefined' ? undefined : ($9920808c70af0ef3$var$_window9 = window) === null || $9920808c70af0ef3$var$_window9 === void 0 || ($9920808c70af0ef3$var$_window9$matchMedia = $9920808c70af0ef3$var$_window9.matchMedia) === null || $9920808c70af0ef3$var$_window9$matchMedia === void 0 ? void 0 : $9920808c70af0ef3$var$_window9$matchMedia.call($9920808c70af0ef3$var$_window9, (0, $31397d21cdb1c0e3$export$987d49ffe1b0900f).below.md.replace('@media ', '').trim()),
    'below.lg': typeof window === 'undefined' ? undefined : ($9920808c70af0ef3$var$_window0 = window) === null || $9920808c70af0ef3$var$_window0 === void 0 || ($9920808c70af0ef3$var$_window0$matchMedia = $9920808c70af0ef3$var$_window0.matchMedia) === null || $9920808c70af0ef3$var$_window0$matchMedia === void 0 ? void 0 : $9920808c70af0ef3$var$_window0$matchMedia.call($9920808c70af0ef3$var$_window0, (0, $31397d21cdb1c0e3$export$987d49ffe1b0900f).below.lg.replace('@media ', '').trim()),
    'below.xl': typeof window === 'undefined' ? undefined : ($9920808c70af0ef3$var$_window1 = window) === null || $9920808c70af0ef3$var$_window1 === void 0 || ($9920808c70af0ef3$var$_window1$matchMedia = $9920808c70af0ef3$var$_window1.matchMedia) === null || $9920808c70af0ef3$var$_window1$matchMedia === void 0 ? void 0 : $9920808c70af0ef3$var$_window1$matchMedia.call($9920808c70af0ef3$var$_window1, (0, $31397d21cdb1c0e3$export$987d49ffe1b0900f).below.xl.replace('@media ', '').trim())
};
var $9920808c70af0ef3$export$49e55ae2c03d6045 = function UNSAFE_useMediaQuery(queryString, listener) {
    var listenerRef = (0, $5FkrB.useRef)(listener);
    (0, $5FkrB.useEffect)(function() {
        // Bind the listener if changed so it's called on the next change event; no guarantee on timing.
        listenerRef.current = listener;
    }, [
        listener
    ]);
    /**
   * We explicitly only react to boolean changes for binding our listener
   * Changes to the functional reference are ignored.
   */ var hasListener = !!listener;
    /**
   * The `matchMedia(…)` return value for our breakpoint query.
   */ var mq = $9920808c70af0ef3$var$queries[queryString];
    (0, $5FkrB.useLayoutEffect)(function() {
        listenerRef.current = listener; // Bind the listener now in case the `useEffect` hasn't fired above yet
        if (!mq || !hasListener || !listenerRef.current) return;
        return (0, $7QpUe.bind)(mq, {
            type: 'change',
            listener: function listener(event) {
                // We explicitly call the current version of the function
                return listenerRef.current(event);
            }
        });
    }, // eslint-disable-next-line react-hooks/exhaustive-deps -- explicitly do not trigger the effect on `listener` reference change, only on a boolean representation of it.
    [
        mq,
        hasListener
    ]);
    return mq || null;
};


function $9313bd10ed4c57ff$export$4065aef1d79a5730(_ref) {
    var _appearance = _ref.appearance, _shouldRenderToParent = _ref.shouldRenderToParent;
    var mq = (0, $9920808c70af0ef3$export$49e55ae2c03d6045)('below.sm', function(e) {
        setIsSmallViewport(!!e.matches);
    });
    var _useState = (0, $5FkrB.useState)(!!(mq !== null && mq !== void 0 && mq.matches)), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), isSmallViewport = _useState2[0], setIsSmallViewport = _useState2[1];
    var appearance = _appearance === 'UNSAFE_modal-below-sm' && isSmallViewport ? 'UNSAFE_modal-below-sm' : 'default';
    var shouldRenderToParent = _shouldRenderToParent && appearance === 'default';
    return {
        appearance: appearance,
        shouldRenderToParent: shouldRenderToParent
    };
}



var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");

var $cvlyC = parcelRequire("cvlyC");
var $9f325bf03c7180e2$export$7cc5c058dd769dff = function useGetMemoizedMergedTriggerRef() {
    var _useState = (0, $5FkrB.useState)(function() {
        return (0, $cvlyC.default)(function(ref, setTriggerRef, isOpen) {
            return function(node) {
                if (node && isOpen) {
                    if (typeof ref === 'function') ref(node);
                    else if (ref) ref.current = node;
                    setTriggerRef(node);
                }
            };
        });
    }), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 1), getMemoizedMergedTriggerRef = _useState2[0];
    return getMemoizedMergedTriggerRef;
};



var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");

var $cvlyC = parcelRequire("cvlyC");
var $77d52a86d0d65f2b$export$5d3a2de79e07b376 = function useGetMemoizedMergedTriggerRefNew() {
    var _useState = (0, $5FkrB.useState)(function() {
        return (0, $cvlyC.default)(function(ref, setTriggerRef) {
            return function(node) {
                if (node) {
                    if (typeof ref === 'function') ref(node);
                    else if (ref) ref.current = node;
                    setTriggerRef(node);
                }
            };
        });
    }), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 1), getMemoizedMergedTriggerRefNew = _useState2[0];
    return getMemoizedMergedTriggerRefNew;
};


var $c7d50085b2abee47$var$defaultLayer = 400;
var $c7d50085b2abee47$var$wrapperStyles = {
    root: "_kqswh2mm"
};
var $c7d50085b2abee47$export$129a32eedafa97c5 = /*#__PURE__*/ (0, $5FkrB.memo)(function(_ref) {
    var xcss = _ref.xcss, _ref$appearance = _ref.appearance, inAppearance = _ref$appearance === void 0 ? 'default' : _ref$appearance, isOpen = _ref.isOpen, providedId = _ref.id, offset = _ref.offset, testId = _ref.testId, trigger = _ref.trigger, content = _ref.content, onClose = _ref.onClose, boundary = _ref.boundary, _ref$rootBoundary = _ref.rootBoundary, rootBoundary = _ref$rootBoundary === void 0 ? 'viewport' : _ref$rootBoundary, _ref$shouldFlip = _ref.shouldFlip, shouldFlip = _ref$shouldFlip === void 0 ? true : _ref$shouldFlip, _ref$placement = _ref.placement, placement = _ref$placement === void 0 ? 'auto' : _ref$placement, fallbackPlacements = _ref.fallbackPlacements, PopupContainer = _ref.popupComponent, _ref$autoFocus = _ref.autoFocus, autoFocus = _ref$autoFocus === void 0 ? true : _ref$autoFocus, _ref$zIndex = _ref.zIndex, zIndex = _ref$zIndex === void 0 ? $c7d50085b2abee47$var$defaultLayer : _ref$zIndex, _ref$shouldUseCapture = _ref.shouldUseCaptureOnOutsideClick, shouldUseCaptureOnOutsideClick = _ref$shouldUseCapture === void 0 ? false : _ref$shouldUseCapture, _ref$shouldRenderToPa = _ref.shouldRenderToParent, inShouldRenderToParent = _ref$shouldRenderToPa === void 0 ? false : _ref$shouldRenderToPa, _ref$shouldFitContain = _ref.shouldFitContainer, shouldFitContainer = _ref$shouldFitContain === void 0 ? false : _ref$shouldFitContain, _ref$shouldDisableFoc = _ref.shouldDisableFocusLock, shouldDisableFocusLock = _ref$shouldDisableFoc === void 0 ? false : _ref$shouldDisableFoc, _ref$shouldReturnFocu = _ref.shouldReturnFocus, shouldReturnFocus = _ref$shouldReturnFocu === void 0 ? true : _ref$shouldReturnFocu, strategy = _ref.strategy, role = _ref.role, label = _ref.label, titleId = _ref.titleId, modifiers = _ref.modifiers, shouldFitViewport = _ref.shouldFitViewport;
    var _useState = (0, $5FkrB.useState)(null), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), triggerRef = _useState2[0], setTriggerRef = _useState2[1];
    var getMergedTriggerRef = (0, $9f325bf03c7180e2$export$7cc5c058dd769dff)();
    var getMergedTriggerRefNew = (0, $77d52a86d0d65f2b$export$5d3a2de79e07b376)();
    var generatedId = (0, $h8qvJ.useId)();
    var _usePopupAppearance = (0, $9313bd10ed4c57ff$export$4065aef1d79a5730)({
        appearance: inAppearance,
        shouldRenderToParent: inShouldRenderToParent
    }), appearance = _usePopupAppearance.appearance, shouldRenderToParent = _usePopupAppearance.shouldRenderToParent;
    var id = providedId || generatedId;
    var handleOpenLayerObserverCloseSignal = (0, $5FkrB.useCallback)(function() {
        onClose === null || onClose === void 0 || onClose(null);
    }, [
        onClose
    ]);
    (0, $iUCre.useNotifyOpenLayerObserver)({
        isOpen: isOpen,
        onClose: handleOpenLayerObserverCloseSignal,
        type: 'popup'
    });
    var renderPopperWrapper = /*#__PURE__*/ $5FkrB.createElement((0, $8IltX.Layering), {
        isDisabled: false
    }, /*#__PURE__*/ $5FkrB.createElement((0, $3196b959b9338ecd$export$2e2bcd8739ae039), {
        xcss: xcss,
        appearance: appearance,
        content: content,
        isOpen: isOpen,
        placement: placement,
        fallbackPlacements: fallbackPlacements,
        boundary: boundary,
        rootBoundary: rootBoundary,
        shouldFlip: shouldFlip,
        offset: offset,
        popupComponent: PopupContainer,
        id: id,
        testId: testId,
        onClose: onClose,
        autoFocus: autoFocus,
        shouldUseCaptureOnOutsideClick: shouldUseCaptureOnOutsideClick,
        shouldRenderToParent: shouldRenderToParent || shouldFitContainer,
        shouldFitContainer: shouldFitContainer,
        shouldDisableFocusLock: shouldDisableFocusLock,
        shouldReturnFocus: shouldReturnFocus,
        triggerRef: triggerRef,
        strategy: shouldFitContainer ? 'absolute' : strategy,
        role: role,
        label: label,
        titleId: titleId,
        modifiers: modifiers,
        shouldFitViewport: shouldFitViewport
    }));
    var popupContent = /*#__PURE__*/ $5FkrB.createElement((0, $hvYLl.Manager), null, /*#__PURE__*/ $5FkrB.createElement((0, $agyC9.Reference), null, function(_ref2) {
        var ref = _ref2.ref;
        return trigger({
            ref: !(0, $9Zzpd.fg)('platform-design-system-popup-ref') ? getMergedTriggerRef(ref, setTriggerRef, isOpen) : getMergedTriggerRefNew(ref, setTriggerRef),
            'aria-controls': isOpen ? id : undefined,
            'aria-expanded': isOpen,
            'aria-haspopup': role === 'dialog' && (0, $9Zzpd.fg)('platform_dst_popup-disable-focuslock') ? 'dialog' : true
        });
    }), isOpen && (shouldRenderToParent || shouldFitContainer ? renderPopperWrapper : /*#__PURE__*/ $5FkrB.createElement((0, $e1c760c467d2ecc0$export$2e2bcd8739ae039), {
        zIndex: zIndex
    }, renderPopperWrapper)));
    if (shouldFitContainer) return /*#__PURE__*/ $5FkrB.createElement((0, $e742d9ca3a0f53ff$export$2e2bcd8739ae039), {
        xcss: $c7d50085b2abee47$var$wrapperStyles.root
    }, popupContent);
    return popupContent;
});


var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$37263ce7a04262dd$export$2e2bcd8739ae039 = (0, $c7d50085b2abee47$export$129a32eedafa97c5);



var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");

var $2DGGf = parcelRequire("2DGGf");
var $6Wx3K = parcelRequire("6Wx3K");
var $15c7c6c64f7dbb65$exports = {};
$parcel$export($15c7c6c64f7dbb65$exports, "cs", () => $f778192929d615e6$export$2e2bcd8739ae039);
$parcel$export($15c7c6c64f7dbb65$exports, "da", () => $513689cb9afbe568$export$2e2bcd8739ae039);
$parcel$export($15c7c6c64f7dbb65$exports, "de", () => $63516fbaa854958a$export$2e2bcd8739ae039);
$parcel$export($15c7c6c64f7dbb65$exports, "en", () => $fbb6eced2a7d4a3c$export$2e2bcd8739ae039);
$parcel$export($15c7c6c64f7dbb65$exports, "en_GB", () => $6c4e2d9665570ab4$export$2e2bcd8739ae039);
$parcel$export($15c7c6c64f7dbb65$exports, "en_ZZ", () => $422bde3a218084aa$export$2e2bcd8739ae039);
$parcel$export($15c7c6c64f7dbb65$exports, "es", () => $6a4689726812de84$export$2e2bcd8739ae039);
$parcel$export($15c7c6c64f7dbb65$exports, "fi", () => $09869420abb44a23$export$2e2bcd8739ae039);
$parcel$export($15c7c6c64f7dbb65$exports, "fr", () => $1328f674a59d0aa0$export$2e2bcd8739ae039);
$parcel$export($15c7c6c64f7dbb65$exports, "hu", () => $45d628e1091a2efe$export$2e2bcd8739ae039);
$parcel$export($15c7c6c64f7dbb65$exports, "it", () => $fb00c6c4f8c31700$export$2e2bcd8739ae039);
$parcel$export($15c7c6c64f7dbb65$exports, "ja", () => $688b346be6dde492$export$2e2bcd8739ae039);
$parcel$export($15c7c6c64f7dbb65$exports, "ko", () => $f99446cfcb1d2ce6$export$2e2bcd8739ae039);
$parcel$export($15c7c6c64f7dbb65$exports, "nb", () => $dab6e1e417fda7d5$export$2e2bcd8739ae039);
$parcel$export($15c7c6c64f7dbb65$exports, "nl", () => $0c8d4aa2309ca961$export$2e2bcd8739ae039);
$parcel$export($15c7c6c64f7dbb65$exports, "pl", () => $a0e2398a69bcb52a$export$2e2bcd8739ae039);
$parcel$export($15c7c6c64f7dbb65$exports, "pt_BR", () => $6d78ab289a9c58a1$export$2e2bcd8739ae039);
$parcel$export($15c7c6c64f7dbb65$exports, "ru", () => $544a2b122f346130$export$2e2bcd8739ae039);
$parcel$export($15c7c6c64f7dbb65$exports, "sv", () => $4d5ccfbfe4233800$export$2e2bcd8739ae039);
$parcel$export($15c7c6c64f7dbb65$exports, "th", () => $f3009342da39b126$export$2e2bcd8739ae039);
$parcel$export($15c7c6c64f7dbb65$exports, "tr", () => $b91128ccca4f1611$export$2e2bcd8739ae039);
$parcel$export($15c7c6c64f7dbb65$exports, "uk", () => $3aa24677afac3d4b$export$2e2bcd8739ae039);
$parcel$export($15c7c6c64f7dbb65$exports, "vi", () => $0207029ecfae51b3$export$2e2bcd8739ae039);
$parcel$export($15c7c6c64f7dbb65$exports, "zh", () => $c975d8a4f50dbfd3$export$2e2bcd8739ae039);
$parcel$export($15c7c6c64f7dbb65$exports, "zh_TW", () => $323984d90a77ff12$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ /* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Czech
var $4672bf1808c68b64$export$2e2bcd8739ae039 = {
    'paginated-picker.async-select.clear-selection-button.clear-all-selected-items-button-text': "Zru\u0161it v\xfdb\u011Br",
    'paginated-picker.async-select.menu-list.error-message.error-message': "Na\u010Dten\xed dat se nezda\u0159ilo.",
    'paginated-picker.async-select.menu-list.error-message.retry-message': "Kliknut\xedm opakovat",
    'paginated-picker.async-select.menu-list.loading-message.loading-message': "Na\u010D\xedt\xe1n\xed\u2026",
    'paginated-picker.async-select.menu-list.show-more-button.show-more-button-text': "Zobrazit v\xedce",
    'paginated-picker.async-select.pagination-details.of-total-count': "{itemsCount} z\xa0{totalCount}",
    'paginated-picker.async-select.select.no-options-message.no-options-message': "Nebyly nalezeny \u017E\xe1dn\xe9 shody",
    'paginated-picker.async-select.select.option.error-message': "Na\u010Dten\xed dat se nezda\u0159ilo.",
    'paginated-picker.async-select.select.option.retry-message': "Kliknut\xedm opakovat",
    'paginated-picker.async-select.select.search-placeholder': 'Vyhledat',
    'paginated-picker.async-select.show-full-list-button.show-full-list-button-text': "Zobrazit \xfapln\xfd seznam"
};


var $f778192929d615e6$export$2e2bcd8739ae039 = (0, $4672bf1808c68b64$export$2e2bcd8739ae039);


/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ /* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Danish (Denmark)
var $d8fef0778e15d1d6$export$2e2bcd8739ae039 = {
    'paginated-picker.async-select.clear-selection-button.clear-all-selected-items-button-text': 'Ryd valgte',
    'paginated-picker.async-select.menu-list.error-message.error-message': 'Data kunne ikke hentes',
    'paginated-picker.async-select.menu-list.error-message.retry-message': "Klik for at pr\xf8ve igen",
    'paginated-picker.async-select.menu-list.loading-message.loading-message': "Indl\xe6ser ...",
    'paginated-picker.async-select.menu-list.show-more-button.show-more-button-text': 'Vis mere',
    'paginated-picker.async-select.pagination-details.of-total-count': '{itemsCount} af {totalCount}',
    'paginated-picker.async-select.select.no-options-message.no-options-message': 'Ingen match fundet',
    'paginated-picker.async-select.select.option.error-message': 'Data kunne ikke hentes',
    'paginated-picker.async-select.select.option.retry-message': "Klik for at pr\xf8ve igen",
    'paginated-picker.async-select.select.search-placeholder': "S\xf8g",
    'paginated-picker.async-select.show-full-list-button.show-full-list-button-text': 'Vis hele listen'
};


var $513689cb9afbe568$export$2e2bcd8739ae039 = (0, $d8fef0778e15d1d6$export$2e2bcd8739ae039);


/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ /* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //German (Germany)
var $daf8b42b91e86c10$export$2e2bcd8739ae039 = {
    'paginated-picker.async-select.clear-selection-button.clear-all-selected-items-button-text': "Auswahl l\xf6schen",
    'paginated-picker.async-select.menu-list.error-message.error-message': 'Daten konnten nicht abgerufen werden.',
    'paginated-picker.async-select.menu-list.error-message.retry-message': 'Klicken, um es erneut zu versuchen',
    'paginated-picker.async-select.menu-list.loading-message.loading-message': "L\xe4dt\xa0...",
    'paginated-picker.async-select.menu-list.show-more-button.show-more-button-text': 'Mehr anzeigen',
    'paginated-picker.async-select.pagination-details.of-total-count': '{itemsCount} von {totalCount}',
    'paginated-picker.async-select.select.no-options-message.no-options-message': 'Keine Treffer gefunden',
    'paginated-picker.async-select.select.option.error-message': 'Daten konnten nicht abgerufen werden.',
    'paginated-picker.async-select.select.option.retry-message': 'Klicken, um es erneut zu versuchen',
    'paginated-picker.async-select.select.search-placeholder': 'Suchen',
    'paginated-picker.async-select.show-full-list-button.show-full-list-button-text': "Vollst\xe4ndige Liste anzeigen"
};


var $63516fbaa854958a$export$2e2bcd8739ae039 = (0, $daf8b42b91e86c10$export$2e2bcd8739ae039);


/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ /* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //
var $37c30cb00c70704e$export$2e2bcd8739ae039 = {
    'paginated-picker.async-select.clear-selection-button.clear-all-selected-items-button-text': 'Clear selection',
    'paginated-picker.async-select.menu-list.error-message.error-message': "Couldn't retrieve data",
    'paginated-picker.async-select.menu-list.error-message.retry-message': 'Click to retry',
    'paginated-picker.async-select.menu-list.loading-message.loading-message': 'Loading...',
    'paginated-picker.async-select.menu-list.show-more-button.show-more-button-text': 'Show more',
    'paginated-picker.async-select.pagination-details.of-total-count': '{itemsCount} of {totalCount}',
    'paginated-picker.async-select.select.no-options-message.no-options-message': 'No matches found',
    'paginated-picker.async-select.select.option.error-message': "Couldn't retrieve data",
    'paginated-picker.async-select.select.option.retry-message': 'Click to retry',
    'paginated-picker.async-select.select.search-placeholder': 'Search',
    'paginated-picker.async-select.show-full-list-button.show-full-list-button-text': 'Show full list'
};


var $fbb6eced2a7d4a3c$export$2e2bcd8739ae039 = (0, $37c30cb00c70704e$export$2e2bcd8739ae039);


/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ /* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //English (United Kingdom)
var $2543f25c18640596$export$2e2bcd8739ae039 = {
    'paginated-picker.async-select.clear-selection-button.clear-all-selected-items-button-text': 'Clear selection',
    'paginated-picker.async-select.menu-list.error-message.error-message': "Couldn't retrieve data",
    'paginated-picker.async-select.menu-list.error-message.retry-message': 'Click to retry',
    'paginated-picker.async-select.menu-list.loading-message.loading-message': 'Loading...',
    'paginated-picker.async-select.menu-list.show-more-button.show-more-button-text': 'Show more',
    'paginated-picker.async-select.pagination-details.of-total-count': '{itemsCount} of {totalCount}',
    'paginated-picker.async-select.select.no-options-message.no-options-message': 'No matches found',
    'paginated-picker.async-select.select.option.error-message': "Couldn't retrieve data",
    'paginated-picker.async-select.select.option.retry-message': 'Click to retry',
    'paginated-picker.async-select.select.search-placeholder': 'Search',
    'paginated-picker.async-select.show-full-list-button.show-full-list-button-text': 'Show full list'
};


var $6c4e2d9665570ab4$export$2e2bcd8739ae039 = (0, $2543f25c18640596$export$2e2bcd8739ae039);


/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ /* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //
var $051b7696dac56d44$export$2e2bcd8739ae039 = {
    'paginated-picker.async-select.clear-selection-button.clear-all-selected-items-button-text': "\u2063\u2062Clear selection\u206E\x9d\u206B\u2060\u206D\x8f\u206B\u200C\u200D\u206C\x9d\u206E\u200C\u206B\u206D\u200C\u206C\u206F\u206F\u206B\u206E\x81\u2060\u206F\u206A\u200D\x8d\u206D\u200C\x8d\u2060\u061C\u2063\u2064",
    'paginated-picker.async-select.menu-list.error-message.error-message': "\u2063\u2062Couldn't retrieve data\x81\u206A\u206D\u2060\u2061\u206F\x8d\u206E\u2060\x8d\u2060\u206C\u206E\u2061\u206E\x90\u206E\u200C\u200D\x81\u200D\u206F\u206C\u206D\x8d\u206B\x81\u206A\x8d\u200D\u206A\u200C\u2063\u2064",
    'paginated-picker.async-select.menu-list.error-message.retry-message': "\u2063\u2062Click to retry\u206A\u200C\u206C\x8d\x9d\u206D\u2060\u200C\u206C\u206F\u206A\u206B\u206D\u206B\x8f\u206F\u206F\u206D\u206F\x8f\u206B\u206C\u2061\u061C\u206F\u061C\x8f\u206F\u200D\u2060\u206D\u206D\u2063\u2064",
    'paginated-picker.async-select.menu-list.loading-message.loading-message': "\u2063\u2062Loading...\u200D\u206C\u206E\x8f\u061C\u206D\u206D\u206B\u206D\x9d\u200D\x9d\u2061\x8f\u061C\u200C\x9d\u2060\x90\u2060\x90\u200C\u2061\u2061\x8d\x8f\x81\x8f\u2060\u206E\u206C\u200C\u2063\u2064",
    'paginated-picker.async-select.menu-list.show-more-button.show-more-button-text': "\u2063\u2062Show more\u206E\x81\x8f\u2060\x8d\u206A\u2061\u2060\x8d\x8d\x90\x8f\x8f\u200C\x90\u061C\x8f\u206A\x9d\u206C\u206F\x8d\u206D\u206D\u206F\u061C\x8d\x9d\u206C\u206B\u200D\u206D\u2063\u2064",
    'paginated-picker.async-select.pagination-details.of-total-count': "\u2063\u2062{itemsCount} of {totalCount}\u206D\u206B\u061C\u206C\x8f\u206F\u206F\x8d\x90\u061C\u2060\u061C\u206D\u206C\x8f\u200D\x9d\u2060\u206E\x8f\u200D\u200C\u200D\u206F\u206D\u206A\x8d\x8d\u206C\u2060\x81\x8d\u2063\u2064",
    'paginated-picker.async-select.select.no-options-message.no-options-message': "\u2063\u2062No matches found\u061C\x9d\x81\u2060\u206E\u200C\u200D\u206E\u206F\x9d\x8f\u206F\u206A\u200C\u2061\u206A\u2060\u200C\u2060\x9d\u206E\x90\x8d\u206C\x8d\u206E\x9d\u200C\u206A\x81\x9d\u206C\u2063\u2064",
    'paginated-picker.async-select.select.option.error-message': "\u2063\u2062Couldn't retrieve data\u206C\u206E\x90\u2060\x8d\u200C\u061C\u2061\u2061\x90\u206F\u206B\u200D\u200D\x9d\u206C\u206E\u206D\u200D\x9d\u206B\u206D\u206B\u206D\u206E\u206F\x90\x81\u200C\u206A\u206C\u206D\u2063\u2064",
    'paginated-picker.async-select.select.option.retry-message': "\u2063\u2062Click to retry\x8f\u206C\u200C\x81\u061C\u206E\u061C\u206B\u206C\x9d\u206D\u206C\u206F\u206F\u206C\u206E\x8d\u200C\u200D\x90\u206D\x8d\u206F\u206B\x81\u2060\u206F\x8d\u206E\u206A\x90\u206A\u2063\u2064",
    'paginated-picker.async-select.select.search-placeholder': "\u2063\u2062Search\u200D\u206D\x90\u061C\u200D\u206A\u206E\x90\u206A\u206C\u206F\u061C\u200C\u206A\x90\u206D\x81\u206C\x9d\u061C\u200D\u200D\x8f\u206D\u206D\x8d\x8f\u206E\x9d\u2060\u206F\u2060\u2063\u2064",
    'paginated-picker.async-select.show-full-list-button.show-full-list-button-text': "\u2063\u2062Show full list\x90\u206D\u2061\u206E\u206A\u206B\u061C\u206C\u206B\u206E\u206A\u206E\u206D\x9d\u2061\x8f\x9d\u206B\u2060\u200D\x9d\u2061\u206B\u206B\u206A\x90\x81\u206C\x81\u200C\u206D\u200D\u2063\u2064"
};


var $422bde3a218084aa$export$2e2bcd8739ae039 = (0, $051b7696dac56d44$export$2e2bcd8739ae039);


/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ /* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Spanish (International)
var $9b16e9f3d1b81c88$export$2e2bcd8739ae039 = {
    'paginated-picker.async-select.clear-selection-button.clear-all-selected-items-button-text': "Borrar selecci\xf3n",
    'paginated-picker.async-select.menu-list.error-message.error-message': 'No se han podido recuperar los datos',
    'paginated-picker.async-select.menu-list.error-message.retry-message': 'Haz clic para intentarlo de nuevo',
    'paginated-picker.async-select.menu-list.loading-message.loading-message': "Cargando\u2026",
    'paginated-picker.async-select.menu-list.show-more-button.show-more-button-text': "Mostrar m\xe1s",
    'paginated-picker.async-select.pagination-details.of-total-count': '{itemsCount} de {totalCount}',
    'paginated-picker.async-select.select.no-options-message.no-options-message': 'No se han encontrado coincidencias',
    'paginated-picker.async-select.select.option.error-message': 'No se han podido recuperar los datos',
    'paginated-picker.async-select.select.option.retry-message': 'Haz clic para intentarlo de nuevo',
    'paginated-picker.async-select.select.search-placeholder': 'Buscar',
    'paginated-picker.async-select.show-full-list-button.show-full-list-button-text': 'Mostrar lista completa'
};


var $6a4689726812de84$export$2e2bcd8739ae039 = (0, $9b16e9f3d1b81c88$export$2e2bcd8739ae039);


/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ /* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Finnish
var $5f52fc96a507bb1a$export$2e2bcd8739ae039 = {
    'paginated-picker.async-select.clear-selection-button.clear-all-selected-items-button-text': "Tyhjenn\xe4 valinta",
    'paginated-picker.async-select.menu-list.error-message.error-message': 'Tietoja ei voitu noutaa',
    'paginated-picker.async-select.menu-list.error-message.retry-message': "Yrit\xe4 uudelleen napsauttamalla",
    'paginated-picker.async-select.menu-list.loading-message.loading-message': 'Ladataan...',
    'paginated-picker.async-select.menu-list.show-more-button.show-more-button-text': "N\xe4yt\xe4 lis\xe4\xe4",
    'paginated-picker.async-select.pagination-details.of-total-count': '{itemsCount}/{totalCount}',
    'paginated-picker.async-select.select.no-options-message.no-options-message': 'Ei hakutuloksia',
    'paginated-picker.async-select.select.option.error-message': 'Tietoja ei voitu noutaa',
    'paginated-picker.async-select.select.option.retry-message': "Yrit\xe4 uudelleen napsauttamalla",
    'paginated-picker.async-select.select.search-placeholder': 'Hae',
    'paginated-picker.async-select.show-full-list-button.show-full-list-button-text': "N\xe4yt\xe4 koko luettelo"
};


var $09869420abb44a23$export$2e2bcd8739ae039 = (0, $5f52fc96a507bb1a$export$2e2bcd8739ae039);


/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ /* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //French (France)
var $2d51f53e504b141a$export$2e2bcd8739ae039 = {
    'paginated-picker.async-select.clear-selection-button.clear-all-selected-items-button-text': "Effacer la s\xe9lection",
    'paginated-picker.async-select.menu-list.error-message.error-message': "Impossible de r\xe9cup\xe9rer les donn\xe9es",
    'paginated-picker.async-select.menu-list.error-message.retry-message': "Cliquez pour r\xe9essayer",
    'paginated-picker.async-select.menu-list.loading-message.loading-message': "Chargement en cours\u2026",
    'paginated-picker.async-select.menu-list.show-more-button.show-more-button-text': 'Afficher plus',
    'paginated-picker.async-select.pagination-details.of-total-count': '{itemsCount} sur {totalCount}',
    'paginated-picker.async-select.select.no-options-message.no-options-message': "R\xe9sultats introuvables",
    'paginated-picker.async-select.select.option.error-message': "Impossible de r\xe9cup\xe9rer les donn\xe9es",
    'paginated-picker.async-select.select.option.retry-message': "Cliquez pour r\xe9essayer",
    'paginated-picker.async-select.select.search-placeholder': 'Rechercher',
    'paginated-picker.async-select.show-full-list-button.show-full-list-button-text': 'Afficher toute la liste'
};


var $1328f674a59d0aa0$export$2e2bcd8739ae039 = (0, $2d51f53e504b141a$export$2e2bcd8739ae039);


/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ /* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Hungarian
var $d2e9b503a006f69b$export$2e2bcd8739ae039 = {
    'paginated-picker.async-select.clear-selection-button.clear-all-selected-items-button-text': "Kijel\xf6l\xe9s megsz\xfcntet\xe9se",
    'paginated-picker.async-select.menu-list.error-message.error-message': "Nem siker\xfclt lek\xe9rni az adatokat",
    'paginated-picker.async-select.menu-list.error-message.retry-message': "Kattints az \xfajrapr\xf3b\xe1lkoz\xe1shoz",
    'paginated-picker.async-select.menu-list.loading-message.loading-message': "Bet\xf6lt\xe9s\u2026",
    'paginated-picker.async-select.menu-list.show-more-button.show-more-button-text': "T\xf6bb",
    'paginated-picker.async-select.pagination-details.of-total-count': '{itemsCount}/{totalCount}',
    'paginated-picker.async-select.select.no-options-message.no-options-message': "Nincs egyez\xe9s",
    'paginated-picker.async-select.select.option.error-message': "Nem siker\xfclt lek\xe9rni az adatokat",
    'paginated-picker.async-select.select.option.retry-message': "Kattints az \xfajrapr\xf3b\xe1lkoz\xe1shoz",
    'paginated-picker.async-select.select.search-placeholder': "Keres\xe9s",
    'paginated-picker.async-select.show-full-list-button.show-full-list-button-text': "Teljes lista megjelen\xedt\xe9se"
};


var $45d628e1091a2efe$export$2e2bcd8739ae039 = (0, $d2e9b503a006f69b$export$2e2bcd8739ae039);


/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ /* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Italian (Italy)
var $def3dfa3a7cdc286$export$2e2bcd8739ae039 = {
    'paginated-picker.async-select.clear-selection-button.clear-all-selected-items-button-text': 'Cancella selezione',
    'paginated-picker.async-select.menu-list.error-message.error-message': 'Impossibile recuperare i dati',
    'paginated-picker.async-select.menu-list.error-message.retry-message': 'Clicca per riprovare',
    'paginated-picker.async-select.menu-list.loading-message.loading-message': 'Caricamento in corso...',
    'paginated-picker.async-select.menu-list.show-more-button.show-more-button-text': 'Mostra altro',
    'paginated-picker.async-select.pagination-details.of-total-count': '{itemsCount} di {totalCount}',
    'paginated-picker.async-select.select.no-options-message.no-options-message': 'Nessuna corrispondenza trovata',
    'paginated-picker.async-select.select.option.error-message': 'Impossibile recuperare i dati',
    'paginated-picker.async-select.select.option.retry-message': 'Clicca per riprovare',
    'paginated-picker.async-select.select.search-placeholder': 'Ricerca',
    'paginated-picker.async-select.show-full-list-button.show-full-list-button-text': "Mostra l'elenco completo"
};


var $fb00c6c4f8c31700$export$2e2bcd8739ae039 = (0, $def3dfa3a7cdc286$export$2e2bcd8739ae039);


/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ /* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Japanese
var $e7171fbe3766ae77$export$2e2bcd8739ae039 = {
    'paginated-picker.async-select.clear-selection-button.clear-all-selected-items-button-text': "\u9078\u629E\u3092\u89E3\u9664",
    'paginated-picker.async-select.menu-list.error-message.error-message': "\u30C7\u30FC\u30BF\u3092\u53D6\u5F97\u3067\u304D\u307E\u305B\u3093\u3067\u3057\u305F",
    'paginated-picker.async-select.menu-list.error-message.retry-message': "\u30AF\u30EA\u30C3\u30AF\u3057\u3066\u518D\u8A66\u884C",
    'paginated-picker.async-select.menu-list.loading-message.loading-message': "\u8AAD\u307F\u8FBC\u307F\u4E2D\u2026",
    'paginated-picker.async-select.menu-list.show-more-button.show-more-button-text': "\u8868\u793A\u3092\u5897\u3084\u3059",
    'paginated-picker.async-select.pagination-details.of-total-count': "{totalCount} \u4EF6\u4E2D {itemsCount} \u4EF6",
    'paginated-picker.async-select.select.no-options-message.no-options-message': "\u4E00\u81F4\u3059\u308B\u3082\u306E\u304C\u898B\u3064\u304B\u308A\u307E\u305B\u3093\u3067\u3057\u305F",
    'paginated-picker.async-select.select.option.error-message': "\u30C7\u30FC\u30BF\u3092\u53D6\u5F97\u3067\u304D\u307E\u305B\u3093\u3067\u3057\u305F",
    'paginated-picker.async-select.select.option.retry-message': "\u30AF\u30EA\u30C3\u30AF\u3057\u3066\u518D\u8A66\u884C",
    'paginated-picker.async-select.select.search-placeholder': "\u691C\u7D22",
    'paginated-picker.async-select.show-full-list-button.show-full-list-button-text': "\u30EA\u30B9\u30C8\u5168\u4F53\u3092\u8868\u793A"
};


var $688b346be6dde492$export$2e2bcd8739ae039 = (0, $e7171fbe3766ae77$export$2e2bcd8739ae039);


/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ /* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Korean
var $ca82c1416e813941$export$2e2bcd8739ae039 = {
    'paginated-picker.async-select.clear-selection-button.clear-all-selected-items-button-text': "\uC120\uD0DD \uD56D\uBAA9 \uC9C0\uC6B0\uAE30",
    'paginated-picker.async-select.menu-list.error-message.error-message': "\uB370\uC774\uD130\uB97C \uAC80\uC0C9\uD560 \uC218 \uC5C6\uC74C",
    'paginated-picker.async-select.menu-list.error-message.retry-message': "\uD074\uB9AD\uD558\uC5EC \uB2E4\uC2DC \uC2DC\uB3C4",
    'paginated-picker.async-select.menu-list.loading-message.loading-message': "\uB85C\uB4DC \uC911...",
    'paginated-picker.async-select.menu-list.show-more-button.show-more-button-text': "\uB354 \uBCF4\uAE30",
    'paginated-picker.async-select.pagination-details.of-total-count': '{itemsCount}/{totalCount}',
    'paginated-picker.async-select.select.no-options-message.no-options-message': "\uC77C\uCE58\uD558\uB294 \uD56D\uBAA9 \uC5C6\uC74C",
    'paginated-picker.async-select.select.option.error-message': "\uB370\uC774\uD130\uB97C \uAC80\uC0C9\uD560 \uC218 \uC5C6\uC74C",
    'paginated-picker.async-select.select.option.retry-message': "\uD074\uB9AD\uD558\uC5EC \uB2E4\uC2DC \uC2DC\uB3C4",
    'paginated-picker.async-select.select.search-placeholder': "\uAC80\uC0C9",
    'paginated-picker.async-select.show-full-list-button.show-full-list-button-text': "\uC804\uCCB4 \uBAA9\uB85D \uD45C\uC2DC"
};


var $f99446cfcb1d2ce6$export$2e2bcd8739ae039 = (0, $ca82c1416e813941$export$2e2bcd8739ae039);


/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ /* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Norwegian (Bokmål)
var $d79b90167a859e15$export$2e2bcd8739ae039 = {
    'paginated-picker.async-select.clear-selection-button.clear-all-selected-items-button-text': 'Fjern valg',
    'paginated-picker.async-select.menu-list.error-message.error-message': 'Kan ikke hente data',
    'paginated-picker.async-select.menu-list.error-message.retry-message': "Klikk for \xe5 pr\xf8ve igjen",
    'paginated-picker.async-select.menu-list.loading-message.loading-message': "Laster\xa0\u2026",
    'paginated-picker.async-select.menu-list.show-more-button.show-more-button-text': 'Vis mer',
    'paginated-picker.async-select.pagination-details.of-total-count': '{itemsCount} av {totalCount}',
    'paginated-picker.async-select.select.no-options-message.no-options-message': 'Finner ingen treff',
    'paginated-picker.async-select.select.option.error-message': 'Kan ikke hente data',
    'paginated-picker.async-select.select.option.retry-message': "Klikk for \xe5 pr\xf8ve igjen",
    'paginated-picker.async-select.select.search-placeholder': "S\xf8k",
    'paginated-picker.async-select.show-full-list-button.show-full-list-button-text': 'Vis fullstendig liste'
};


var $dab6e1e417fda7d5$export$2e2bcd8739ae039 = (0, $d79b90167a859e15$export$2e2bcd8739ae039);


/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ /* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Dutch (Netherlands)
var $76df351252d58f57$export$2e2bcd8739ae039 = {
    'paginated-picker.async-select.clear-selection-button.clear-all-selected-items-button-text': 'Selectie wissen',
    'paginated-picker.async-select.menu-list.error-message.error-message': 'Gegevens konden niet worden opgehaald',
    'paginated-picker.async-select.menu-list.error-message.retry-message': 'Klik om het opnieuw te proberen',
    'paginated-picker.async-select.menu-list.loading-message.loading-message': 'Laden...',
    'paginated-picker.async-select.menu-list.show-more-button.show-more-button-text': 'Meer tonen',
    'paginated-picker.async-select.pagination-details.of-total-count': '{itemsCount} van {totalCount}',
    'paginated-picker.async-select.select.no-options-message.no-options-message': 'Geen overeenkomsten gevonden',
    'paginated-picker.async-select.select.option.error-message': 'Gegevens konden niet worden opgehaald',
    'paginated-picker.async-select.select.option.retry-message': 'Klik om het opnieuw te proberen',
    'paginated-picker.async-select.select.search-placeholder': 'Zoeken',
    'paginated-picker.async-select.show-full-list-button.show-full-list-button-text': 'Volledige lijst weergeven'
};


var $0c8d4aa2309ca961$export$2e2bcd8739ae039 = (0, $76df351252d58f57$export$2e2bcd8739ae039);


/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ /* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Polish (Poland)
var $19526a32e57df974$export$2e2bcd8739ae039 = {
    'paginated-picker.async-select.clear-selection-button.clear-all-selected-items-button-text': "Wyczy\u015B\u0107 wyb\xf3r",
    'paginated-picker.async-select.menu-list.error-message.error-message': "Nie mo\u017Cna pobra\u0107 danych",
    'paginated-picker.async-select.menu-list.error-message.retry-message': "Kliknij, aby spr\xf3bowa\u0107 ponownie",
    'paginated-picker.async-select.menu-list.loading-message.loading-message': "\u0141adowanie...",
    'paginated-picker.async-select.menu-list.show-more-button.show-more-button-text': "Poka\u017C wi\u0119cej",
    'paginated-picker.async-select.pagination-details.of-total-count': '{itemsCount} z {totalCount}',
    'paginated-picker.async-select.select.no-options-message.no-options-message': "Nie znaleziono dopasowa\u0144",
    'paginated-picker.async-select.select.option.error-message': "Nie mo\u017Cna pobra\u0107 danych",
    'paginated-picker.async-select.select.option.retry-message': "Kliknij, aby spr\xf3bowa\u0107 ponownie",
    'paginated-picker.async-select.select.search-placeholder': 'Szukaj',
    'paginated-picker.async-select.show-full-list-button.show-full-list-button-text': "Poka\u017C pe\u0142n\u0105 list\u0119"
};


var $a0e2398a69bcb52a$export$2e2bcd8739ae039 = (0, $19526a32e57df974$export$2e2bcd8739ae039);


/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ /* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Portuguese (Brazil)
var $12269785a5c698e5$export$2e2bcd8739ae039 = {
    'paginated-picker.async-select.clear-selection-button.clear-all-selected-items-button-text': "Limpar sele\xe7\xe3o",
    'paginated-picker.async-select.menu-list.error-message.error-message': "N\xe3o foi poss\xedvel recuperar os dados",
    'paginated-picker.async-select.menu-list.error-message.retry-message': 'Clique para tentar de novo',
    'paginated-picker.async-select.menu-list.loading-message.loading-message': 'Carregando...',
    'paginated-picker.async-select.menu-list.show-more-button.show-more-button-text': 'Ver mais',
    'paginated-picker.async-select.pagination-details.of-total-count': '{itemsCount} de {totalCount}',
    'paginated-picker.async-select.select.no-options-message.no-options-message': "Nenhuma correspond\xeancia encontrada",
    'paginated-picker.async-select.select.option.error-message': "N\xe3o foi poss\xedvel recuperar os dados",
    'paginated-picker.async-select.select.option.retry-message': 'Clique para tentar de novo',
    'paginated-picker.async-select.select.search-placeholder': 'Pesquisar',
    'paginated-picker.async-select.show-full-list-button.show-full-list-button-text': 'Mostrar lista completa'
};


var $6d78ab289a9c58a1$export$2e2bcd8739ae039 = (0, $12269785a5c698e5$export$2e2bcd8739ae039);


/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ /* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Russian
var $f44dd606d8f7c8f1$export$2e2bcd8739ae039 = {
    'paginated-picker.async-select.clear-selection-button.clear-all-selected-items-button-text': "\u0421\u043D\u044F\u0442\u044C \u0432\u044B\u0434\u0435\u043B\u0435\u043D\u0438\u0435",
    'paginated-picker.async-select.menu-list.error-message.error-message': "\u041D\u0435 \u0443\u0434\u0430\u043B\u043E\u0441\u044C \u043F\u043E\u043B\u0443\u0447\u0438\u0442\u044C \u0434\u0430\u043D\u043D\u044B\u0435",
    'paginated-picker.async-select.menu-list.error-message.retry-message': "\u041D\u0430\u0436\u043C\u0438\u0442\u0435, \u0447\u0442\u043E\u0431\u044B \u043F\u043E\u0432\u0442\u043E\u0440\u0438\u0442\u044C \u043F\u043E\u043F\u044B\u0442\u043A\u0443",
    'paginated-picker.async-select.menu-list.loading-message.loading-message': "\u0417\u0430\u0433\u0440\u0443\u0437\u043A\u0430\u2026",
    'paginated-picker.async-select.menu-list.show-more-button.show-more-button-text': "\u0420\u0430\u0437\u0432\u0435\u0440\u043D\u0443\u0442\u044C",
    'paginated-picker.async-select.pagination-details.of-total-count': "{itemsCount} \u0438\u0437 {totalCount}",
    'paginated-picker.async-select.select.no-options-message.no-options-message': "\u0421\u043E\u0432\u043F\u0430\u0434\u0435\u043D\u0438\u044F \u043D\u0435 \u043D\u0430\u0439\u0434\u0435\u043D\u044B",
    'paginated-picker.async-select.select.option.error-message': "\u041D\u0435 \u0443\u0434\u0430\u043B\u043E\u0441\u044C \u043F\u043E\u043B\u0443\u0447\u0438\u0442\u044C \u0434\u0430\u043D\u043D\u044B\u0435",
    'paginated-picker.async-select.select.option.retry-message': "\u041D\u0430\u0436\u043C\u0438\u0442\u0435, \u0447\u0442\u043E\u0431\u044B \u043F\u043E\u0432\u0442\u043E\u0440\u0438\u0442\u044C \u043F\u043E\u043F\u044B\u0442\u043A\u0443",
    'paginated-picker.async-select.select.search-placeholder': "\u041F\u043E\u0438\u0441\u043A",
    'paginated-picker.async-select.show-full-list-button.show-full-list-button-text': "\u041F\u043E\u043A\u0430\u0437\u0430\u0442\u044C \u043F\u043E\u043B\u043D\u044B\u0439 \u0441\u043F\u0438\u0441\u043E\u043A"
};


var $544a2b122f346130$export$2e2bcd8739ae039 = (0, $f44dd606d8f7c8f1$export$2e2bcd8739ae039);


/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ /* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Swedish
var $fd9dfbf5aab9861b$export$2e2bcd8739ae039 = {
    'paginated-picker.async-select.clear-selection-button.clear-all-selected-items-button-text': 'Rensa urval',
    'paginated-picker.async-select.menu-list.error-message.error-message': "Det gick inte att h\xe4mta data",
    'paginated-picker.async-select.menu-list.error-message.retry-message': "Klicka f\xf6r att f\xf6rs\xf6ka igen",
    'paginated-picker.async-select.menu-list.loading-message.loading-message': "L\xe4ser in ...",
    'paginated-picker.async-select.menu-list.show-more-button.show-more-button-text': 'Visa mer',
    'paginated-picker.async-select.pagination-details.of-total-count': '{itemsCount} av {totalCount}',
    'paginated-picker.async-select.select.no-options-message.no-options-message': "Inga tr\xe4ffar hittades",
    'paginated-picker.async-select.select.option.error-message': "Det gick inte att h\xe4mta data",
    'paginated-picker.async-select.select.option.retry-message': "Klicka f\xf6r att f\xf6rs\xf6ka igen",
    'paginated-picker.async-select.select.search-placeholder': "S\xf6k",
    'paginated-picker.async-select.show-full-list-button.show-full-list-button-text': "Visa fullst\xe4ndig lista"
};


var $4d5ccfbfe4233800$export$2e2bcd8739ae039 = (0, $fd9dfbf5aab9861b$export$2e2bcd8739ae039);


/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ /* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Thai (Thailand)
var $f540d690ae612fab$export$2e2bcd8739ae039 = {
    'paginated-picker.async-select.clear-selection-button.clear-all-selected-items-button-text': "\u0E25\u0E49\u0E32\u0E07\u0E15\u0E31\u0E27\u0E40\u0E25\u0E37\u0E2D\u0E01",
    'paginated-picker.async-select.menu-list.error-message.error-message': "\u0E44\u0E21\u0E48\u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E40\u0E23\u0E35\u0E22\u0E01\u0E14\u0E39\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E44\u0E14\u0E49",
    'paginated-picker.async-select.menu-list.error-message.retry-message': "\u0E04\u0E25\u0E34\u0E01\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E25\u0E2D\u0E07\u0E2D\u0E35\u0E01\u0E04\u0E23\u0E31\u0E49\u0E07",
    'paginated-picker.async-select.menu-list.loading-message.loading-message': "\u0E01\u0E33\u0E25\u0E31\u0E07\u0E42\u0E2B\u0E25\u0E14...",
    'paginated-picker.async-select.menu-list.show-more-button.show-more-button-text': "\u0E41\u0E2A\u0E14\u0E07\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E40\u0E15\u0E34\u0E21",
    'paginated-picker.async-select.pagination-details.of-total-count': "{itemsCount} \u0E08\u0E32\u0E01 {totalCount}",
    'paginated-picker.async-select.select.no-options-message.no-options-message': "\u0E44\u0E21\u0E48\u0E1E\u0E1A\u0E23\u0E32\u0E22\u0E01\u0E32\u0E23\u0E17\u0E35\u0E48\u0E15\u0E23\u0E07\u0E01\u0E31\u0E19",
    'paginated-picker.async-select.select.option.error-message': "\u0E44\u0E21\u0E48\u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E40\u0E23\u0E35\u0E22\u0E01\u0E14\u0E39\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E44\u0E14\u0E49",
    'paginated-picker.async-select.select.option.retry-message': "\u0E04\u0E25\u0E34\u0E01\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E25\u0E2D\u0E07\u0E2D\u0E35\u0E01\u0E04\u0E23\u0E31\u0E49\u0E07",
    'paginated-picker.async-select.select.search-placeholder': "\u0E04\u0E49\u0E19\u0E2B\u0E32",
    'paginated-picker.async-select.show-full-list-button.show-full-list-button-text': "\u0E41\u0E2A\u0E14\u0E07\u0E23\u0E32\u0E22\u0E01\u0E32\u0E23\u0E17\u0E31\u0E49\u0E07\u0E2B\u0E21\u0E14"
};


var $f3009342da39b126$export$2e2bcd8739ae039 = (0, $f540d690ae612fab$export$2e2bcd8739ae039);


/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ /* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Turkish (Turkey)
var $78593addc10c97f1$export$2e2bcd8739ae039 = {
    'paginated-picker.async-select.clear-selection-button.clear-all-selected-items-button-text': "Se\xe7imi temizle",
    'paginated-picker.async-select.menu-list.error-message.error-message': "Veriler al\u0131namad\u0131",
    'paginated-picker.async-select.menu-list.error-message.retry-message': "Yeniden denemek i\xe7in t\u0131klay\u0131n",
    'paginated-picker.async-select.menu-list.loading-message.loading-message': "Y\xfckleniyor...",
    'paginated-picker.async-select.menu-list.show-more-button.show-more-button-text': "Daha fazla g\xf6ster",
    'paginated-picker.async-select.pagination-details.of-total-count': '{itemsCount}/{totalCount}',
    'paginated-picker.async-select.select.no-options-message.no-options-message': "E\u015Fle\u015Fme bulunamad\u0131",
    'paginated-picker.async-select.select.option.error-message': "Veriler al\u0131namad\u0131",
    'paginated-picker.async-select.select.option.retry-message': "Yeniden denemek i\xe7in t\u0131klay\u0131n",
    'paginated-picker.async-select.select.search-placeholder': 'Ara',
    'paginated-picker.async-select.show-full-list-button.show-full-list-button-text': "Tam listeyi g\xf6ster"
};


var $b91128ccca4f1611$export$2e2bcd8739ae039 = (0, $78593addc10c97f1$export$2e2bcd8739ae039);


/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ /* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Ukrainian (Ukraine)
var $e512b385403e4bbf$export$2e2bcd8739ae039 = {
    'paginated-picker.async-select.clear-selection-button.clear-all-selected-items-button-text': "\u0421\u043A\u0430\u0441\u0443\u0432\u0430\u0442\u0438 \u0432\u0438\u0431\u0456\u0440",
    'paginated-picker.async-select.menu-list.error-message.error-message': "\u041D\u0435 \u0432\u0434\u0430\u043B\u043E\u0441\u044C \u043E\u0442\u0440\u0438\u043C\u0430\u0442\u0438 \u0434\u0430\u043D\u0456",
    'paginated-picker.async-select.menu-list.error-message.retry-message': "\u041D\u0430\u0442\u0438\u0441\u043D\u0456\u0442\u044C, \u0449\u043E\u0431 \u043F\u043E\u0432\u0442\u043E\u0440\u0438\u0442\u0438 \u0441\u043F\u0440\u043E\u0431\u0443",
    'paginated-picker.async-select.menu-list.loading-message.loading-message': "\u0417\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0435\u043D\u043D\u044F...",
    'paginated-picker.async-select.menu-list.show-more-button.show-more-button-text': "\u041F\u043E\u043A\u0430\u0437\u0430\u0442\u0438 \u0431\u0456\u043B\u044C\u0448\u0435",
    'paginated-picker.async-select.pagination-details.of-total-count': "{itemsCount} \u0437 {totalCount}",
    'paginated-picker.async-select.select.no-options-message.no-options-message': "\u041D\u0456\u0447\u043E\u0433\u043E \u043D\u0435 \u0437\u043D\u0430\u0439\u0434\u0435\u043D\u043E",
    'paginated-picker.async-select.select.option.error-message': "\u041D\u0435 \u0432\u0434\u0430\u043B\u043E\u0441\u044C \u043E\u0442\u0440\u0438\u043C\u0430\u0442\u0438 \u0434\u0430\u043D\u0456",
    'paginated-picker.async-select.select.option.retry-message': "\u041D\u0430\u0442\u0438\u0441\u043D\u0456\u0442\u044C, \u0449\u043E\u0431 \u043F\u043E\u0432\u0442\u043E\u0440\u0438\u0442\u0438 \u0441\u043F\u0440\u043E\u0431\u0443",
    'paginated-picker.async-select.select.search-placeholder': "\u041F\u043E\u0448\u0443\u043A",
    'paginated-picker.async-select.show-full-list-button.show-full-list-button-text': "\u041F\u043E\u043A\u0430\u0437\u0430\u0442\u0438 \u043F\u043E\u0432\u043D\u0438\u0439 \u0441\u043F\u0438\u0441\u043E\u043A"
};


var $3aa24677afac3d4b$export$2e2bcd8739ae039 = (0, $e512b385403e4bbf$export$2e2bcd8739ae039);


/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ /* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Vietnamese (Vietnam)
var $5f911a695ffa4182$export$2e2bcd8739ae039 = {
    'paginated-picker.async-select.clear-selection-button.clear-all-selected-items-button-text': "X\xf3a m\u1EE5c \u0111\xe3 ch\u1ECDn",
    'paginated-picker.async-select.menu-list.error-message.error-message': "Kh\xf4ng th\u1EC3 truy xu\u1EA5t d\u1EEF li\u1EC7u",
    'paginated-picker.async-select.menu-list.error-message.retry-message': "Nh\u1EA5p v\xe0o \u0111\u1EC3 th\u1EED l\u1EA1i",
    'paginated-picker.async-select.menu-list.loading-message.loading-message': "\u0110ang t\u1EA3i...",
    'paginated-picker.async-select.menu-list.show-more-button.show-more-button-text': "Hi\u1EC3n th\u1ECB th\xeam",
    'paginated-picker.async-select.pagination-details.of-total-count': '{itemsCount}/{totalCount}',
    'paginated-picker.async-select.select.no-options-message.no-options-message': "Kh\xf4ng t\xecm th\u1EA5y k\u1EBFt qu\u1EA3 ph\xf9 h\u1EE3p n\xe0o",
    'paginated-picker.async-select.select.option.error-message': "Kh\xf4ng th\u1EC3 truy xu\u1EA5t d\u1EEF li\u1EC7u",
    'paginated-picker.async-select.select.option.retry-message': "Nh\u1EA5p v\xe0o \u0111\u1EC3 th\u1EED l\u1EA1i",
    'paginated-picker.async-select.select.search-placeholder': "T\xecm ki\u1EBFm",
    'paginated-picker.async-select.show-full-list-button.show-full-list-button-text': "Hi\u1EC3n th\u1ECB danh s\xe1ch \u0111\u1EA7y \u0111\u1EE7"
};


var $0207029ecfae51b3$export$2e2bcd8739ae039 = (0, $5f911a695ffa4182$export$2e2bcd8739ae039);


/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ /* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Chinese (Simplified)
var $627df7a03880c013$export$2e2bcd8739ae039 = {
    'paginated-picker.async-select.clear-selection-button.clear-all-selected-items-button-text': "\u6E05\u7A7A\u9009\u62E9",
    'paginated-picker.async-select.menu-list.error-message.error-message': "\u65E0\u6CD5\u68C0\u7D22\u6570\u636E",
    'paginated-picker.async-select.menu-list.error-message.retry-message': "\u70B9\u51FB\u91CD\u8BD5",
    'paginated-picker.async-select.menu-list.loading-message.loading-message': "\u6B63\u5728\u52A0\u8F7D...",
    'paginated-picker.async-select.menu-list.show-more-button.show-more-button-text': "\u663E\u793A\u66F4\u591A",
    'paginated-picker.async-select.pagination-details.of-total-count': '{itemsCount}/{totalCount}',
    'paginated-picker.async-select.select.no-options-message.no-options-message': "\u672A\u627E\u5230\u5339\u914D\u9879",
    'paginated-picker.async-select.select.option.error-message': "\u65E0\u6CD5\u68C0\u7D22\u6570\u636E",
    'paginated-picker.async-select.select.option.retry-message': "\u70B9\u51FB\u91CD\u8BD5",
    'paginated-picker.async-select.select.search-placeholder': "\u641C\u7D22",
    'paginated-picker.async-select.show-full-list-button.show-full-list-button-text': "\u663E\u793A\u5B8C\u6574\u5217\u8868"
};


var $c975d8a4f50dbfd3$export$2e2bcd8739ae039 = (0, $627df7a03880c013$export$2e2bcd8739ae039);


/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ /* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Chinese (Traditional)
var $349cff05777e10b4$export$2e2bcd8739ae039 = {
    'paginated-picker.async-select.clear-selection-button.clear-all-selected-items-button-text': "\u6E05\u9664\u9078\u53D6\u5167\u5BB9",
    'paginated-picker.async-select.menu-list.error-message.error-message': "\u7121\u6CD5\u64F7\u53D6\u8CC7\u6599",
    'paginated-picker.async-select.menu-list.error-message.retry-message': "\u6309\u4E00\u4E0B\u4EE5\u91CD\u8A66",
    'paginated-picker.async-select.menu-list.loading-message.loading-message': "\u6B63\u5728\u8F09\u5165...",
    'paginated-picker.async-select.menu-list.show-more-button.show-more-button-text': "\u986F\u793A\u8F03\u591A",
    'paginated-picker.async-select.pagination-details.of-total-count': "\u7B2C {itemsCount} \u500B\uFF0C\u5171 {totalCount} \u500B",
    'paginated-picker.async-select.select.no-options-message.no-options-message': "\u627E\u4E0D\u5230\u76F8\u7B26\u9805\u76EE",
    'paginated-picker.async-select.select.option.error-message': "\u7121\u6CD5\u64F7\u53D6\u8CC7\u6599",
    'paginated-picker.async-select.select.option.retry-message': "\u6309\u4E00\u4E0B\u4EE5\u91CD\u8A66",
    'paginated-picker.async-select.select.search-placeholder': "\u641C\u5C0B",
    'paginated-picker.async-select.show-full-list-button.show-full-list-button-text': "\u986F\u793A\u5B8C\u6574\u6E05\u55AE"
};


var $323984d90a77ff12$export$2e2bcd8739ae039 = (0, $349cff05777e10b4$export$2e2bcd8739ae039);




var $de01b096d7a510fa$var$i18n = $15c7c6c64f7dbb65$exports;
var $de01b096d7a510fa$var$getCodesFromLocale = function getCodesFromLocale(locale) {
    var match = /([a-z]*)[_-]?([A-Z]*)/i.exec(locale || '');
    if (!match) throw Error('Unable to get language and country from invalid Locale');
    var _match = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(match, 3), language = _match[1], country = _match[2];
    return {
        language: language.toLowerCase(),
        country: country.toUpperCase()
    };
};
var $de01b096d7a510fa$export$b61655080b0a1f32 = function PaginatedPickerIntlProvider(_ref) {
    var children = _ref.children;
    var intl = (0, $6Wx3K.default)();
    var _getCodesFromLocale = $de01b096d7a510fa$var$getCodesFromLocale(intl.locale.toString()), language = _getCodesFromLocale.language, country = _getCodesFromLocale.country;
    var messages = $de01b096d7a510fa$var$i18n["".concat(language, "_").concat(country)] || $de01b096d7a510fa$var$i18n[language] || $de01b096d7a510fa$var$i18n.en;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $2DGGf.default), {
        messages: messages,
        locale: intl.locale
    }, children);
};



var $iYJcE = parcelRequire("iYJcE");

var $kqp0i = parcelRequire("kqp0i");

var $1Vcia = parcelRequire("1Vcia");

var $25nEq = parcelRequire("25nEq");

var $5FkrB = parcelRequire("5FkrB");
var $1099937d2cc3db76$exports = {};
var $a2610537d9d155d0$exports = {};
/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $a2610537d9d155d0$var$baseFindIndex(array, predicate, fromIndex, fromRight) {
    var length = array.length, index = fromIndex + (fromRight ? 1 : -1);
    while(fromRight ? index-- : ++index < length){
        if (predicate(array[index], index, array)) return index;
    }
    return -1;
}
$a2610537d9d155d0$exports = $a2610537d9d155d0$var$baseFindIndex;



var $rM88w = parcelRequire("rM88w");

var $ll6bk = parcelRequire("ll6bk");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $1099937d2cc3db76$var$nativeMax = Math.max;
/**
 * This method is like `_.find` except that it returns the index of the first
 * element `predicate` returns truthy for instead of the element itself.
 *
 * @static
 * @memberOf _
 * @since 1.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=0] The index to search from.
 * @returns {number} Returns the index of the found element, else `-1`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'active': false },
 *   { 'user': 'fred',    'active': false },
 *   { 'user': 'pebbles', 'active': true }
 * ];
 *
 * _.findIndex(users, function(o) { return o.user == 'barney'; });
 * // => 0
 *
 * // The `_.matches` iteratee shorthand.
 * _.findIndex(users, { 'user': 'fred', 'active': false });
 * // => 1
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.findIndex(users, ['active', false]);
 * // => 0
 *
 * // The `_.property` iteratee shorthand.
 * _.findIndex(users, 'active');
 * // => 2
 */ function $1099937d2cc3db76$var$findIndex(array, predicate, fromIndex) {
    var length = array == null ? 0 : array.length;
    if (!length) return -1;
    var index = fromIndex == null ? 0 : $ll6bk(fromIndex);
    if (index < 0) index = $1099937d2cc3db76$var$nativeMax(length + index, 0);
    return $a2610537d9d155d0$exports(array, $rM88w(predicate, 3), index);
}
$1099937d2cc3db76$exports = $1099937d2cc3db76$var$findIndex;


var $3a70dcab3a7aadc2$exports = {};
var $dd16f1123f2f3099$exports = {};

var $rM88w = parcelRequire("rM88w");

var $8Ak9r = parcelRequire("8Ak9r");

var $8XuRV = parcelRequire("8XuRV");
/**
 * Creates a `_.find` or `_.findLast` function.
 *
 * @private
 * @param {Function} findIndexFunc The function to find the collection index.
 * @returns {Function} Returns the new find function.
 */ function $dd16f1123f2f3099$var$createFind(findIndexFunc) {
    return function(collection, predicate, fromIndex) {
        var iterable = Object(collection);
        if (!$8Ak9r(collection)) {
            var iteratee = $rM88w(predicate, 3);
            collection = $8XuRV(collection);
            predicate = function(key) {
                return iteratee(iterable[key], key, iterable);
            };
        }
        var index = findIndexFunc(collection, predicate, fromIndex);
        return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
    };
}
$dd16f1123f2f3099$exports = $dd16f1123f2f3099$var$createFind;


var $6544f0c1d2ee6d4e$exports = {};


var $rM88w = parcelRequire("rM88w");

var $ll6bk = parcelRequire("ll6bk");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $6544f0c1d2ee6d4e$var$nativeMax = Math.max, $6544f0c1d2ee6d4e$var$nativeMin = Math.min;
/**
 * This method is like `_.findIndex` except that it iterates over elements
 * of `collection` from right to left.
 *
 * @static
 * @memberOf _
 * @since 2.0.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=array.length-1] The index to search from.
 * @returns {number} Returns the index of the found element, else `-1`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'active': true },
 *   { 'user': 'fred',    'active': false },
 *   { 'user': 'pebbles', 'active': false }
 * ];
 *
 * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
 * // => 2
 *
 * // The `_.matches` iteratee shorthand.
 * _.findLastIndex(users, { 'user': 'barney', 'active': true });
 * // => 0
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.findLastIndex(users, ['active', false]);
 * // => 2
 *
 * // The `_.property` iteratee shorthand.
 * _.findLastIndex(users, 'active');
 * // => 0
 */ function $6544f0c1d2ee6d4e$var$findLastIndex(array, predicate, fromIndex) {
    var length = array == null ? 0 : array.length;
    if (!length) return -1;
    var index = length - 1;
    if (fromIndex !== undefined) {
        index = $ll6bk(fromIndex);
        index = fromIndex < 0 ? $6544f0c1d2ee6d4e$var$nativeMax(length + index, 0) : $6544f0c1d2ee6d4e$var$nativeMin(index, length - 1);
    }
    return $a2610537d9d155d0$exports(array, $rM88w(predicate, 3), index, true);
}
$6544f0c1d2ee6d4e$exports = $6544f0c1d2ee6d4e$var$findLastIndex;


/**
 * This method is like `_.find` except that it iterates over elements of
 * `collection` from right to left.
 *
 * @static
 * @memberOf _
 * @since 2.0.0
 * @category Collection
 * @param {Array|Object} collection The collection to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=collection.length-1] The index to search from.
 * @returns {*} Returns the matched element, else `undefined`.
 * @example
 *
 * _.findLast([1, 2, 3, 4], function(n) {
 *   return n % 2 == 1;
 * });
 * // => 3
 */ var $3a70dcab3a7aadc2$var$findLast = $dd16f1123f2f3099$exports($6544f0c1d2ee6d4e$exports);
$3a70dcab3a7aadc2$exports = $3a70dcab3a7aadc2$var$findLast;



var $kqp0i = parcelRequire("kqp0i");

var $5FkrB = parcelRequire("5FkrB");

var $kqp0i = parcelRequire("kqp0i");
parcelRequire("dujqE");

var $ekGgq = parcelRequire("ekGgq");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $kIXpt = parcelRequire("kIXpt");

var $cYPzS = parcelRequire("cYPzS");

var $eyuDe = parcelRequire("eyuDe");

var $25nEq = parcelRequire("25nEq");

var $fC8ib = parcelRequire("fC8ib");

var $5FkrB = parcelRequire("5FkrB");

var $dJ32z = parcelRequire("dJ32z");

var $9Zzpd = parcelRequire("9Zzpd");
/* eslint-disable @repo/internal/fs/filename-pattern-match */ var $ca89d9b058c99608$export$f4da216a6ca54656 = function formatGroupLabel(group) {
    return group.label;
};
var $ca89d9b058c99608$export$dac6ace3020563ca = function getOptionLabel(option) {
    return option.label;
};
var $ca89d9b058c99608$export$40be908210c5a79c = function getOptionValue(option) {
    return option.value;
};
var $ca89d9b058c99608$export$56bd0c8d90db075 = function isOptionDisabled(option) {
    return !!option.isDisabled;
};



var $25nEq = parcelRequire("25nEq");
/* containers.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $kqp0i = parcelRequire("kqp0i");

var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");

var $hUFig = parcelRequire("hUFig");

var $iYJcE = parcelRequire("iYJcE");

var $25nEq = parcelRequire("25nEq");

var $1Vcia = parcelRequire("1Vcia");

var $ekGgq = parcelRequire("ekGgq");
var $27e7f6ca7209680a$var$_excluded = [
    "className",
    "clearValue",
    "cx",
    "xcss",
    "getStyles",
    "getClassNames",
    "getValue",
    "hasValue",
    "isMulti",
    "isRtl",
    "options",
    "selectOption",
    "selectProps",
    "setValue"
];
function $27e7f6ca7209680a$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $27e7f6ca7209680a$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $27e7f6ca7209680a$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $27e7f6ca7209680a$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $27e7f6ca7209680a$export$8793edee2d425525 = function noop() {};
// ==============================
// Class Name Prefixer
// ==============================
/**
 * String representation of component state for styling with class names.
 *
 * Expects an array of strings OR a string/object pair:
 * - className(['comp', 'comp-arg', 'comp-arg-2'])
 * @returns 'react-select__comp react-select__comp-arg react-select__comp-arg-2'
 * - className('comp', { some: true, state: false })
 * @returns 'react-select__comp react-select__comp--some'
 */ function $27e7f6ca7209680a$var$applyPrefixToName(prefix, name) {
    if (!name) return prefix;
    else if (name[0] === '-') return prefix + name;
    else return prefix + '__' + name;
}
function $27e7f6ca7209680a$export$ce4ab0c55987d1ff(prefix, state) {
    for(var _len = arguments.length, classNameList = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)classNameList[_key - 2] = arguments[_key];
    var arr = [].concat(classNameList);
    if (state && prefix) {
        for(var key in state)if (state.hasOwnProperty(key) && state[key]) arr.push("".concat($27e7f6ca7209680a$var$applyPrefixToName(prefix, key)));
    }
    return arr.filter(function(i) {
        return i;
    }).map(function(i) {
        return String(i).trim();
    }).join(' ');
}
var $27e7f6ca7209680a$export$33f062f47f21a01 = function cleanValue(value) {
    if ($27e7f6ca7209680a$var$isArray(value)) return value.filter(Boolean);
    if ((0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(value) === 'object' && value !== null) return [
        value
    ];
    return [];
};
var $27e7f6ca7209680a$export$8e9fd4287627890c = function cleanCommonProps(props) {
    //className
    var className = props.className, clearValue = props.clearValue, cx = props.cx, xcss = props.xcss, getStyles = props.getStyles, getClassNames = props.getClassNames, getValue = props.getValue, hasValue = props.hasValue, isMulti = props.isMulti, isRtl = props.isRtl, options = props.options, selectOption = props.selectOption, selectProps = props.selectProps, setValue = props.setValue, innerProps = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(props, $27e7f6ca7209680a$var$_excluded);
    return $27e7f6ca7209680a$var$_objectSpread({}, innerProps);
};
var $27e7f6ca7209680a$export$26417cabd806a658 = function getStyleProps(props, name, classNamesState) {
    var cx = props.cx, getStyles = props.getStyles, getClassNames = props.getClassNames, className = props.className;
    return {
        css: getStyles(name, props),
        className: cx(classNamesState !== null && classNamesState !== void 0 ? classNamesState : {}, getClassNames(name, props), className)
    };
};
function $27e7f6ca7209680a$export$2096bae78ecda911(inputValue, actionMeta, onInputChange) {
    if (onInputChange) {
        var newValue = onInputChange(inputValue, actionMeta);
        if (typeof newValue === 'string') return newValue;
    }
    return inputValue;
}
function $27e7f6ca7209680a$export$d8a62a489b442872(el) {
    return [
        document.documentElement,
        document.body,
        window
    ].indexOf(el) > -1;
}
function $27e7f6ca7209680a$export$2e0654fad740d2e4(el) {
    if ($27e7f6ca7209680a$export$d8a62a489b442872(el)) return window.innerHeight;
    return el.clientHeight;
}
function $27e7f6ca7209680a$export$c4a223a8ba9e4ea5(el) {
    if ($27e7f6ca7209680a$export$d8a62a489b442872(el)) return window.pageYOffset;
    return el.scrollTop;
}
function $27e7f6ca7209680a$export$3f99968195accfaf(el, top) {
    // with a scroll distance, we perform scroll on the element
    if ($27e7f6ca7209680a$export$d8a62a489b442872(el)) {
        window.scrollTo(0, top);
        return;
    }
    el.scrollTop = top;
}
function $27e7f6ca7209680a$export$cfa2225e87938781(element) {
    var style = getComputedStyle(element);
    var excludeStaticParent = style.position === 'absolute';
    var overflowRx = /(auto|scroll)/;
    if (style.position === 'fixed') return document.documentElement;
    for(var parent = element; parent = parent.parentElement;){
        style = getComputedStyle(parent);
        if (excludeStaticParent && style.position === 'static') continue;
        if (overflowRx.test(style.overflow + style.overflowY + style.overflowX)) return parent;
    }
    return document.documentElement;
}
// Animated Scroll To
// ------------------------------
/**
 * @param t: time (elapsed)
 * @param b: initial value
 * @param c: amount of change
 * @param d: duration
 */ function $27e7f6ca7209680a$var$easeOutCubic(t, b, c, d) {
    return c * ((t = t / d - 1) * t * t + 1) + b;
}
function $27e7f6ca7209680a$export$858c30343199f3af(element, to) {
    var duration = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 200;
    var callback = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : $27e7f6ca7209680a$export$8793edee2d425525;
    var start = $27e7f6ca7209680a$export$c4a223a8ba9e4ea5(element);
    var change = to - start;
    var increment = 10;
    var currentTime = 0;
    function animateScroll() {
        currentTime += increment;
        var val = $27e7f6ca7209680a$var$easeOutCubic(currentTime, start, change, duration);
        $27e7f6ca7209680a$export$3f99968195accfaf(element, val);
        if (currentTime < duration) window.requestAnimationFrame(animateScroll);
        else callback(element);
    }
    animateScroll();
}
function $27e7f6ca7209680a$export$53a0910f038337bd(menuEl, focusedEl) {
    var menuRect = menuEl.getBoundingClientRect();
    var focusedRect = focusedEl.getBoundingClientRect();
    var overScroll = focusedEl.offsetHeight / 3;
    if (focusedRect.bottom + overScroll > menuRect.bottom) $27e7f6ca7209680a$export$3f99968195accfaf(menuEl, Math.min(focusedEl.offsetTop + focusedEl.clientHeight - menuEl.offsetHeight + overScroll, menuEl.scrollHeight));
    else if (focusedRect.top - overScroll < menuRect.top) $27e7f6ca7209680a$export$3f99968195accfaf(menuEl, Math.max(focusedEl.offsetTop - overScroll, 0));
}
function $27e7f6ca7209680a$export$7807c2a424c2f6d1(element) {
    var rect = element.getBoundingClientRect();
    return {
        bottom: rect.bottom,
        height: rect.height,
        left: rect.left,
        right: rect.right,
        top: rect.top,
        width: rect.width
    };
}
function $27e7f6ca7209680a$export$56963d77dbffdde7() {
    try {
        document.createEvent('TouchEvent');
        return true;
    } catch (_unused) {
        return false;
    }
}
function $27e7f6ca7209680a$export$44f917bf91becd01() {
    try {
        return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    } catch (_unused2) {
        return false;
    }
}
// ==============================
// Passive Event Detector
// ==============================
// https://github.com/rafgraph/detect-it/blob/main/src/index.ts#L19-L36
var $27e7f6ca7209680a$var$passiveOptionAccessed = false;
var $27e7f6ca7209680a$var$options = {
    get passive () {
        return $27e7f6ca7209680a$var$passiveOptionAccessed = true;
    }
};
// check for SSR
var $27e7f6ca7209680a$var$w = typeof window !== 'undefined' ? window : {};
if ($27e7f6ca7209680a$var$w.addEventListener && $27e7f6ca7209680a$var$w.removeEventListener) {
    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
    $27e7f6ca7209680a$var$w.addEventListener('p', $27e7f6ca7209680a$export$8793edee2d425525, $27e7f6ca7209680a$var$options);
    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
    $27e7f6ca7209680a$var$w.removeEventListener('p', $27e7f6ca7209680a$export$8793edee2d425525, false);
}
var $27e7f6ca7209680a$export$b0622a6911dbeaf5 = $27e7f6ca7209680a$var$passiveOptionAccessed;
function $27e7f6ca7209680a$export$aedb69ff3e31596c(item) {
    return item != null;
}
function $27e7f6ca7209680a$var$isArray(arg) {
    return Array.isArray(arg);
}
function $27e7f6ca7209680a$export$40fb9515c784cc3b(isMulti, multiValue, singleValue) {
    return isMulti ? multiValue : singleValue;
}
function $27e7f6ca7209680a$export$dea4763e29237f4c(singleValue) {
    return singleValue;
}
function $27e7f6ca7209680a$export$d1ca752ec761b95b(multiValue) {
    return multiValue;
}
var $27e7f6ca7209680a$export$4213b25a1c4e877 = function removeProps(propsObj) {
    for(var _len2 = arguments.length, properties = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)properties[_key2 - 1] = arguments[_key2];
    var propsMap = Object.entries(propsObj).filter(function(_ref) {
        var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_ref, 1), key = _ref2[0];
        return !properties.includes(key);
    });
    return propsMap.reduce(function(newProps, _ref3) {
        var _ref4 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_ref3, 2), key = _ref4[0], val = _ref4[1];
        newProps[key] = val;
        return newProps;
    }, {});
};
var $27e7f6ca7209680a$export$bf2eda47afa5f369 = function filterUnsupportedSelectors(styles) {
    var unsupportedSelectors = [
        ':',
        // pseudo-classes/elements
        '[',
        // attribute selectors
        '>',
        // child combinator
        '+',
        // adjacent sibling combinator
        '~',
        // general sibling combinator
        ' ',
        // descendant combinator
        '*',
        // universal selector
        '#',
        // ID selector
        '.',
        // class selector
        '@',
        // at-rules
        '&',
        // parent selector
        '|',
        // namespace separator
        '^',
        // starts with
        '$',
        // ends with
        '=' // equals
    ];
    return Object.keys(styles).reduce(function(filteredStyles, key) {
        if (!unsupportedSelectors.some(function(selector) {
            return key.includes(selector);
        })) filteredStyles[key] = styles[key];
        return filteredStyles;
    }, {});
};


var $c0f39bc847fa02f8$export$949392aeaf7d2e3a = function containerCSS() {
    return {};
};
var $c0f39bc847fa02f8$var$containerStyles = {
    default: "_11c81d4k _kqswh2mm _lcxv1rj4 _1tn2fhey",
    rtl: "_1eim1xrj",
    disabled: "_80om13gf"
};
var $c0f39bc847fa02f8$export$446eebadefe1123b = function SelectContainer(props) {
    var children = props.children, innerProps = props.innerProps, isDisabled = props.isDisabled, isRtl = props.isRtl, xcss = props.xcss;
    var _getStyleProps = (0, $27e7f6ca7209680a$export$26417cabd806a658)(props, 'container', {
        '--is-disabled': isDisabled,
        '--is-rtl': isRtl
    }), className = _getStyleProps.className, css = _getStyleProps.css;
    return /*#__PURE__*/ $5FkrB.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $970q7.default)([
            $c0f39bc847fa02f8$var$containerStyles.default,
            isRtl && $c0f39bc847fa02f8$var$containerStyles.rtl,
            isDisabled && $c0f39bc847fa02f8$var$containerStyles.disabled,
            (0, $hUFig.cx)(className, xcss, '-container')
        ]),
        style: css
    }, innerProps), children);
};
var $c0f39bc847fa02f8$export$47aec73c7aa6b9aa = function valueContainerCSS() {
    return {};
};
var $c0f39bc847fa02f8$var$valueContainerStyles = {
    default: "_16jlkb7n _1o9zkb7n _i0dlf1ug _1reo15vq _18m915vq _4cvr1h6o _1e0c11p5 _1n261g80 _8am5i4x0 _kqswh2mm _ca0qv77o _u5f312x7 _n3tdv77o _19bv12x7",
    flex: "_1e0c1txw",
    compact: "_ca0qze3t _u5f312x7 _n3tdze3t _19bv12x7"
};
var $c0f39bc847fa02f8$export$4dc9f58ad9a1a000 = function ValueContainer(props) {
    var children = props.children, innerProps = props.innerProps, isMulti = props.isMulti, hasValue = props.hasValue, isCompact = props.isCompact, xcss = props.xcss, controlShouldRenderValue = props.selectProps.controlShouldRenderValue;
    var _getStyleProps2 = (0, $27e7f6ca7209680a$export$26417cabd806a658)(props, 'valueContainer', {
        'value-container': true,
        'value-container--is-multi': isMulti,
        'value-container--has-value': hasValue
    }), css = _getStyleProps2.css, className = _getStyleProps2.className;
    return /*#__PURE__*/ $5FkrB.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $970q7.default)([
            $c0f39bc847fa02f8$var$valueContainerStyles.default,
            isMulti && hasValue && controlShouldRenderValue && $c0f39bc847fa02f8$var$valueContainerStyles.flex,
            isCompact && $c0f39bc847fa02f8$var$valueContainerStyles.compact,
            (0, $hUFig.cx)(className, xcss, '-ValueContainer')
        ]),
        style: css
    }, innerProps), children);
};
var $c0f39bc847fa02f8$export$9d74e3c8b5868ad7 = function indicatorsContainerCSS() {
    return {};
};
var $c0f39bc847fa02f8$var$indicatorContainerStyles = null;
var $c0f39bc847fa02f8$export$d0ffd7e649cab6f = function IndicatorsContainer(props) {
    var children = props.children, innerProps = props.innerProps, xcss = props.xcss;
    var _getStyleProps3 = (0, $27e7f6ca7209680a$export$26417cabd806a658)(props, 'indicatorsContainer', {
        indicators: true
    }), css = _getStyleProps3.css, className = _getStyleProps3.className;
    return /*#__PURE__*/ $5FkrB.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        className: (0, $970q7.default)([
            "_1e0c1txw _4cvr1h6o _1o9zidpf _1wpz1fhb _y4ti1b66",
            (0, $hUFig.cx)(className, xcss, '-IndicatorsContainer')
        ])
    }, innerProps), children);
};


/* control.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $kqp0i = parcelRequire("kqp0i");

var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");

var $hUFig = parcelRequire("hUFig");

var $9Zzpd = parcelRequire("9Zzpd");

var $27b5b8d4b6d6631c$var$styles = {
    default: "_12ji1r31 _1qu2glyw _12y3idpf _2rkofajl _v564r5cv _1h6drsbi _1dqonqa1 _189ee4h9 _4cvr1h6o _80om73ad _1e0c1txw _1n261g80 _1bah1yb4 _kqswh2mm _bfhk1j9a _1tke1ylp _1q51ze3t _y4tize3t _85i5ze3t _bozgze3t _15peftgi _1ke8ftgi _jaboglyw _1u6luvb6 _4cvxrsbi _123byq51 _d0altlke _irr3l4ek _1ogl1caj",
    defaultT26Shape: "_2rko1qi0",
    compact: "_1tkezwfg",
    invalid: "_1h6d1bqt _16qsizbr _1u6lizbr _4cvx1bqt",
    focusedInvalid: "_16qsvyy1",
    disabled: "_1h6dby5v _lcxvglyw _bfhkby5v _1u6l1s3b",
    focused: "_1h6d1v1w _bfhkr01l _16qsvyy1 _1u6lvyy1 _4cvx1v1w _irr3r01l",
    subtle: "_1h6d1j28 _bfhk1j28 _1u6l3sij",
    subtleFocused: "_bfhkvuon",
    none: "_1h6d1j28 _bfhk1j28 _1u6l3sij _4cvx1j28 _irr31j28"
};
var $27b5b8d4b6d6631c$export$dbf350e5966cf602 = function css() {
    return {};
};
var $27b5b8d4b6d6631c$var$Control = function Control(props) {
    var children = props.children, appearance = props.appearance, isCompact = props.isCompact, isDisabled = props.isDisabled, isFocused = props.isFocused, isInvalid = props.isInvalid, innerRef = props.innerRef, innerProps = props.innerProps, menuIsOpen = props.menuIsOpen, xcss = props.xcss;
    var _getStyleProps = (0, $27e7f6ca7209680a$export$26417cabd806a658)(props, 'control', {
        control: true,
        'control--is-disabled': isDisabled,
        'control--is-focused': isFocused,
        'control--menu-is-open': menuIsOpen
    }), css = _getStyleProps.css, className = _getStyleProps.className;
    return /*#__PURE__*/ $5FkrB.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        ref: innerRef,
        className: (0, $970q7.default)([
            $27b5b8d4b6d6631c$var$styles.default,
            (0, $9Zzpd.fg)('platform-dst-shape-theme-default') && $27b5b8d4b6d6631c$var$styles.defaultT26Shape,
            isDisabled && $27b5b8d4b6d6631c$var$styles.disabled,
            isInvalid && $27b5b8d4b6d6631c$var$styles.invalid,
            isCompact && $27b5b8d4b6d6631c$var$styles.compact,
            appearance === 'subtle' && $27b5b8d4b6d6631c$var$styles.subtle,
            appearance === 'subtle' && isFocused && $27b5b8d4b6d6631c$var$styles.subtleFocused,
            isFocused && $27b5b8d4b6d6631c$var$styles.focused,
            appearance === 'none' && $27b5b8d4b6d6631c$var$styles.none,
            (0, $hUFig.cx)(className, xcss, '-control')
        ]),
        style: css
    }, innerProps, {
        "aria-disabled": isDisabled || undefined
    }), children);
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$27b5b8d4b6d6631c$export$2e2bcd8739ae039 = $27b5b8d4b6d6631c$var$Control;


/* group.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $1Vcia = parcelRequire("1Vcia");

var $kqp0i = parcelRequire("kqp0i");

var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");

var $hUFig = parcelRequire("hUFig");

var $846292368a23d009$var$_excluded = [
    "data"
];
var $846292368a23d009$var$styles = {
    root: "_n3tdu2gc _ca0qu2gc"
};
var $846292368a23d009$export$b6794329c1460634 = function groupCSS() {
    return {};
};
var $846292368a23d009$var$Group = function Group(props) {
    var children = props.children, builtinCX = props.cx, getStyles = props.getStyles, getClassNames = props.getClassNames, Heading = props.Heading, headingProps = props.headingProps, innerProps = props.innerProps, label = props.label, selectProps = props.selectProps, xcss = props.xcss;
    var _getStyleProps = (0, $27e7f6ca7209680a$export$26417cabd806a658)(props, 'group', {
        group: true
    }), css = _getStyleProps.css, className = _getStyleProps.className;
    return /*#__PURE__*/ $5FkrB.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css
    }, innerProps, {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $970q7.default)([
            $846292368a23d009$var$styles.root,
            (0, $hUFig.cx)(className, xcss, innerProps === null || innerProps === void 0 ? void 0 : innerProps.className, '-Group')
        ])
    }), label && /*#__PURE__*/ $5FkrB.createElement(Heading, (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, headingProps, {
        selectProps: selectProps,
        getStyles: getStyles,
        getClassNames: getClassNames,
        cx: builtinCX
    }), label), /*#__PURE__*/ $5FkrB.createElement("div", null, children));
};
var $846292368a23d009$var$headingStyles = null;
var $846292368a23d009$export$e5a7fbb542efcb7d = function groupHeadingCSS() {
    return {};
};
var $846292368a23d009$export$85c8b41a3cd87edc = function GroupHeading(props) {
    var xcss = props.xcss;
    var _cleanCommonProps = (0, $27e7f6ca7209680a$export$8e9fd4287627890c)(props), data = _cleanCommonProps.data, innerProps = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_cleanCommonProps, $846292368a23d009$var$_excluded);
    var _getStyleProps2 = (0, $27e7f6ca7209680a$export$26417cabd806a658)(props, 'groupHeading', {
        'group-heading': true
    }), css = _getStyleProps2.css, className = _getStyleProps2.className;
    return /*#__PURE__*/ $5FkrB.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $970q7.default)([
            "_11c8wadc _1e0c1ule _syazazsu _80om73ad _k48pwu06 _6rthpd1z _y4tiutpp _bozgutpp _1p1dglyw",
            (0, $hUFig.cx)(className, xcss, '-group')
        ]),
        style: css
    }, innerProps));
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$846292368a23d009$export$2e2bcd8739ae039 = $846292368a23d009$var$Group;


/* indicators.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $25nEq = parcelRequire("25nEq");

var $1Vcia = parcelRequire("1Vcia");

var $kqp0i = parcelRequire("kqp0i");

var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");

var $hUFig = parcelRequire("hUFig");
var $8b2dd9bf72c54e50$exports = {};
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d56e8662eb8a8d2462ec3a39ff3aa40b>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty($8b2dd9bf72c54e50$exports, "__esModule", {
    value: true
});
$8b2dd9bf72c54e50$exports.default = void 0;

var $8b2dd9bf72c54e50$var$_react = $8b2dd9bf72c54e50$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $8b2dd9bf72c54e50$var$_baseNew = $8b2dd9bf72c54e50$var$_interopRequireDefault((parcelRequire("eRJCC")));
function $8b2dd9bf72c54e50$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ChevronDown".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Do not use 16px chevrons within buttons, icon buttons, or dropdowns to maintain visual cohesion with ADS which uses 12px chevrons.
Known uses: Open dropdown menu, expanded tree item, collapse tree item
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $8b2dd9bf72c54e50$var$ChevronDownIcon = (props)=>/*#__PURE__*/ $8b2dd9bf72c54e50$var$_react.default.createElement($8b2dd9bf72c54e50$var$_baseNew.default, Object.assign({
        name: "ChevronDownIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="m14.53 6.03-6 6a.75.75 0 0 1-1.004.052l-.056-.052-6-6 1.06-1.06L8 10.44l5.47-5.47z"/>`
    }, props));
$8b2dd9bf72c54e50$var$ChevronDownIcon.displayName = 'ChevronDownIcon';
var $8b2dd9bf72c54e50$var$_default = $8b2dd9bf72c54e50$exports.default = $8b2dd9bf72c54e50$var$ChevronDownIcon;


var $b8fbe79318730926$exports = {};
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3eb90e0e095210547df6d71f04e27a56>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty($b8fbe79318730926$exports, "__esModule", {
    value: true
});
$b8fbe79318730926$exports.default = void 0;

var $b8fbe79318730926$var$_react = $b8fbe79318730926$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $b8fbe79318730926$var$_baseNew = $b8fbe79318730926$var$_interopRequireDefault((parcelRequire("eRJCC")));
function $b8fbe79318730926$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "CrossCircle".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: clear text field, error status.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $b8fbe79318730926$var$CrossCircleIcon = (props)=>/*#__PURE__*/ $b8fbe79318730926$var$_react.default.createElement($b8fbe79318730926$var$_baseNew.default, Object.assign({
        name: "CrossCircleIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0m4.03 5.03L9.06 8l2.97 2.97-1.06 1.06L8 9.06l-2.97 2.97-1.06-1.06L6.94 8 3.97 5.03l1.06-1.06L8 6.94l2.97-2.97z" clip-rule="evenodd"/>`
    }, props));
$b8fbe79318730926$var$CrossCircleIcon.displayName = 'CrossCircleIcon';
var $b8fbe79318730926$var$_default = $b8fbe79318730926$exports.default = $b8fbe79318730926$var$CrossCircleIcon;


/* inline.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $kqp0i = parcelRequire("kqp0i");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");
/* index.tsx generated by @compiled/babel-plugin v0.38.1 */ parcelRequire("5FkrB");


var $Pd8py = parcelRequire("Pd8py");
var $947a6ea09ef50dc7$var$strictApi = (0, $Pd8py.createStrictAPI)();
var $947a6ea09ef50dc7$export$dbf350e5966cf602 = $947a6ea09ef50dc7$var$strictApi.css;
var $947a6ea09ef50dc7$export$eb1ecd84a24ee424 = $947a6ea09ef50dc7$var$strictApi.cssMap;
$947a6ea09ef50dc7$var$strictApi.cssMap;
var $947a6ea09ef50dc7$export$a274e22fb40f762e = $947a6ea09ef50dc7$var$strictApi.cx;
var $947a6ea09ef50dc7$var$XCSSProp = $947a6ea09ef50dc7$var$strictApi.XCSSProp; // This is to mitigate local TS error TS2315: Type 'StrictXCSSProp' is not generic.
 // Currently for some reason tsc is generating malformed .d.ts in local dev environment, below change fixes it
 /**
 * ## StrictXCSSProp
 *
 * Declare styles your component takes with all other styles marked as violations
 * by the TypeScript compiler. There are two primary use cases for xcss prop:
 *
 * - safe style overrides
 * - inverting style declarations
 *
 * Interverting style declarations is interesting for platform teams as
 * it means apps only pay for styles they use as they're now the ones who declare
 * the styles!
 *
 * The {@link StrictXCSSProp} type has generics two of which must be defined — use to explicitly
 * set what you want to maintain as API. Use {@link XCSSAllProperties} and {@link XCSSAllPseudos}
 * to enable all properties and pseudos.
 *
 * The third generic is used to declare what properties and pseudos should be required.
 *
 * ```tsx
 * interface MyComponentProps {
 *   // Color is accepted, all other properties / pseudos are considered violations.
 *   xcss?: StrictXCSSProp<'color', never>;
 *
 *   // Only background color and hover pseudo are accepted.
 *   xcss?: StrictXCSSProp<'backgroundColor', '&:hover'>;
 *
 *   // All properties are accepted, all pseudos are considered violations.
 *   xcss?: StrictXCSSProp<XCSSAllProperties, never>;
 *
 *   // All properties are accepted, only the hover pseudo is accepted.
 *   xcss?: StrictXCSSProp<XCSSAllProperties, '&:hover'>;
 *
 *   // The xcss prop is required as well as the color property. No pseudos are required.
 *   xcss: StrictXCSSProp<
 *     XCSSAllProperties,
 *     '&:hover',
 *     { requiredProperties: 'color', requiredPseudos: never }
 *   >;
 * }
 *
 * function MyComponent({ xcss }: MyComponentProps) {
 *   return <div css={{ color: 'var(--ds-text-danger)' }} className={xcss} />
 * }
 * ```
 *
 * The xcss prop works with static inline objects and the [cssMap](https://compiledcssinjs.com/docs/api-cssmap) API.
 *
 * ```jsx
 * // Declared as an inline object
 * <Component xcss={{ color: 'var(--ds-text)' }} />
 *
 * // Declared with the cssMap API
 * const styles = cssMap({ text: { color: 'var(--ds-text)' } });
 * <Component xcss={styles.text} />
 * ```
 *
 * To concatenate and conditonally apply styles use the {@link cssMap} and {@link cx} functions.
 */ 


/* flex.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $kqp0i = parcelRequire("kqp0i");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");
var $fa5e0167080aa6a2$var$_excluded = [
    "as",
    "role",
    "alignItems",
    "justifyContent",
    "gap",
    "columnGap",
    "rowGap",
    "children",
    "testId",
    "direction",
    "wrap",
    "xcss"
];
var $fa5e0167080aa6a2$var$rowGapMap = {
    'space.0': "_1p57ze3t",
    'space.025': "_1p57v77o",
    'space.050': "_1p571b66",
    'space.075': "_1p5712x7",
    'space.100': "_1p57u2gc",
    'space.150': "_1p57utpp",
    'space.200': "_1p57pxbi",
    'space.250': "_1p57v47k",
    'space.300': "_1p571ejb",
    'space.400': "_1p57xy5q",
    'space.500': "_1p571jfw",
    'space.600': "_1p57oahv",
    'space.800': "_1p57xncg",
    'space.1000': "_1p571epz"
};
var $fa5e0167080aa6a2$var$columnGapMap = {
    'space.0': "_gy1pze3t",
    'space.025': "_gy1pv77o",
    'space.050': "_gy1p1b66",
    'space.075': "_gy1p12x7",
    'space.100': "_gy1pu2gc",
    'space.150': "_gy1putpp",
    'space.200': "_gy1ppxbi",
    'space.250': "_gy1pv47k",
    'space.300': "_gy1p1ejb",
    'space.400': "_gy1pxy5q",
    'space.500': "_gy1p1jfw",
    'space.600': "_gy1poahv",
    'space.800': "_gy1pxncg",
    'space.1000': "_gy1p1epz"
};
var $fa5e0167080aa6a2$var$justifyContentMap = {
    start: "_1bahv2br",
    center: "_1bah1h6o",
    end: "_1bahh9n0",
    'space-between': "_1bah1yb4",
    'space-around': "_1bah1b1v",
    'space-evenly': "_1bahitcz",
    stretch: "_1bah1fhb"
};
var $fa5e0167080aa6a2$var$flexDirectionMap = {
    column: "_2lx21bp4",
    row: "_2lx2vrvc"
};
var $fa5e0167080aa6a2$var$flexWrapMap = {
    wrap: "_1n261g80",
    nowrap: "_1n261q9c"
};
var $fa5e0167080aa6a2$var$alignItemsMap = {
    start: "_4cvrv2br",
    center: "_4cvr1h6o",
    baseline: "_4cvr1q9y",
    end: "_4cvrh9n0",
    stretch: "_4cvr1fhb"
};
var $fa5e0167080aa6a2$var$styles = {
    root: "_1e0c1txw _vchhusvi"
};
/**
 * __Flex__
 *
 * `Flex` is a primitive component that implements the CSS Flexbox API.
 *
 * - [Examples](https://atlassian.design/components/primitives/flex/examples)
 * - [Code](https://atlassian.design/components/primitives/flex/code)
 *
 * @example
 * ```tsx
 * // eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
 * import { Flex, Box } from '@atlaskit/primitives'
 *
 * const Component = () => (
 *   <Flex direction="column">
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *   </Flex>
 * )
 * ```
 */ var $fa5e0167080aa6a2$var$Flex = /*#__PURE__*/ (0, $5FkrB.memo)(/*#__PURE__*/ (0, $5FkrB.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? 'div' : _ref$as, role = _ref.role, alignItems = _ref.alignItems, justifyContent = _ref.justifyContent, gap = _ref.gap, columnGap = _ref.columnGap, rowGap = _ref.rowGap, children = _ref.children, testId = _ref.testId, direction = _ref.direction, wrap = _ref.wrap, xcss = _ref.xcss, ariaAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $fa5e0167080aa6a2$var$_excluded);
    return /*#__PURE__*/ $5FkrB.createElement(Component, (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, ariaAttributes, {
        role: role,
        className: (0, $970q7.default)([
            $fa5e0167080aa6a2$var$styles.root,
            gap && $fa5e0167080aa6a2$var$columnGapMap[gap],
            columnGap && $fa5e0167080aa6a2$var$columnGapMap[columnGap],
            gap && $fa5e0167080aa6a2$var$rowGapMap[gap],
            rowGap && $fa5e0167080aa6a2$var$rowGapMap[rowGap],
            alignItems && $fa5e0167080aa6a2$var$alignItemsMap[alignItems],
            direction && $fa5e0167080aa6a2$var$flexDirectionMap[direction],
            justifyContent && $fa5e0167080aa6a2$var$justifyContentMap[justifyContent],
            wrap && $fa5e0167080aa6a2$var$flexWrapMap[wrap],
            xcss
        ]),
        "data-testid": testId,
        ref: ref
    }), children);
}));
$fa5e0167080aa6a2$var$Flex.displayName = 'Flex';
var $fa5e0167080aa6a2$export$2e2bcd8739ae039 = $fa5e0167080aa6a2$var$Flex;


var $3d2f4b22f964133c$var$_excluded = [
    "as",
    "alignInline",
    "alignBlock",
    "shouldWrap",
    "spread",
    "grow",
    "space",
    "rowSpace",
    "separator",
    "xcss",
    "testId",
    "role",
    "children"
];
var $3d2f4b22f964133c$var$styles = {
    separator: "_1mouze3t _195g1i6y _syazjjyb _lcxvglyw _uiztglyw",
    hug: "_16jlidpf",
    fill: "_1bsb1osq _16jlkb7n"
};
var $3d2f4b22f964133c$var$Separator = function Separator(_ref) {
    var children = _ref.children;
    return /*#__PURE__*/ $5FkrB.createElement("span", {
        className: (0, $970q7.default)([
            $3d2f4b22f964133c$var$styles.separator
        ])
    }, children);
};
/**
 * __Inline__
 *
 * Inline is a primitive component based on CSS Flexbox that manages the horizontal layout of direct children.
 *
 * @example
 * ```tsx
 *  <Inline>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *  </Inline>
 * ```
 *
 */ var $3d2f4b22f964133c$var$Inline = /*#__PURE__*/ (0, $5FkrB.memo)(/*#__PURE__*/ (0, $5FkrB.forwardRef)(function(_ref2, ref) {
    var as = _ref2.as, alignInline = _ref2.alignInline, _ref2$alignBlock = _ref2.alignBlock, alignItems = _ref2$alignBlock === void 0 ? 'start' : _ref2$alignBlock, _ref2$shouldWrap = _ref2.shouldWrap, shouldWrap = _ref2$shouldWrap === void 0 ? false : _ref2$shouldWrap, spread = _ref2.spread, grow = _ref2.grow, space = _ref2.space, rowSpace = _ref2.rowSpace, separator = _ref2.separator, xcss = _ref2.xcss, testId = _ref2.testId, role = _ref2.role, rawChildren = _ref2.children, ariaAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref2, $3d2f4b22f964133c$var$_excluded);
    var separatorComponent = typeof separator === 'string' ? /*#__PURE__*/ $5FkrB.createElement($3d2f4b22f964133c$var$Separator, null, separator) : separator;
    var children = separatorComponent ? (0, $5FkrB.Children).toArray(rawChildren).filter(Boolean).map(function(child, index) {
        return /*#__PURE__*/ $5FkrB.createElement((0, $5FkrB.Fragment), {
            key: index
        }, separator && index > 0 ? separatorComponent : null, child);
    }) : rawChildren;
    return /*#__PURE__*/ $5FkrB.createElement((0, $fa5e0167080aa6a2$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, ariaAttributes, {
        as: as,
        role: role,
        alignItems: alignItems,
        justifyContent: spread || alignInline,
        direction: "row",
        gap: space,
        rowGap: rowSpace,
        wrap: shouldWrap ? 'wrap' : undefined,
        xcss: (0, $947a6ea09ef50dc7$export$a274e22fb40f762e)(grow === 'hug' && $3d2f4b22f964133c$var$styles.hug, grow === 'fill' && $3d2f4b22f964133c$var$styles.fill, xcss),
        testId: testId,
        ref: ref
    }), children);
}));
$3d2f4b22f964133c$var$Inline.displayName = 'Inline';
var $3d2f4b22f964133c$export$2e2bcd8739ae039 = $3d2f4b22f964133c$var$Inline;

/* pressable.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $kqp0i = parcelRequire("kqp0i");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");


var $hUFig = parcelRequire("hUFig");

var $25nEq = parcelRequire("25nEq");

var $5FkrB = parcelRequire("5FkrB");

var $dLGML = parcelRequire("dLGML");

var $fC8ib = parcelRequire("fC8ib");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $kIXpt = parcelRequire("kIXpt");

var $cYPzS = parcelRequire("cYPzS");

var $lwlXp = parcelRequire("lwlXp");

var $eyuDe = parcelRequire("eyuDe");

var $25nEq = parcelRequire("25nEq");

var $ekGgq = parcelRequire("ekGgq");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $25nEq = parcelRequire("25nEq");
function $95ff901dcc288d80$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $95ff901dcc288d80$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $95ff901dcc288d80$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $95ff901dcc288d80$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $95ff901dcc288d80$export$ad4be5c2ec28cecf = function isAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $95ff901dcc288d80$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === 'AnalyticsEvent';
};
var $95ff901dcc288d80$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function AnalyticsEvent(props) {
        var _this = this;
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, AnalyticsEvent);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "_isAnalyticsEvent", true);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "clone", function() {
            // just a shallow clone, don't change sub refs unless you want to
            // affect the original's too
            var payload = $95ff901dcc288d80$var$_objectSpread({}, _this.payload);
            return new AnalyticsEvent({
                payload: payload
            });
        });
        this.payload = props.payload;
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(AnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (typeof updater === 'function') this.payload = updater(this.payload);
                if ((0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(updater) === 'object') this.payload = $95ff901dcc288d80$var$_objectSpread($95ff901dcc288d80$var$_objectSpread({}, this.payload), updater);
                return this;
            }
        }
    ]);
}();


function $f00b43f448a01a93$var$_callSuper(t, o, e) {
    return o = (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(o), (0, (/*@__PURE__*/$parcel$interopDefault($kIXpt)))(t, $f00b43f448a01a93$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(t).constructor) : o.apply(t, e));
}
function $f00b43f448a01a93$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($f00b43f448a01a93$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $f00b43f448a01a93$var$_superPropGet(t, o, e, r) {
    var p = (0, (/*@__PURE__*/$parcel$interopDefault($lwlXp)))((0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(1 & r ? t.prototype : t), o, e);
    return 2 & r && "function" == typeof p ? function(t) {
        return p.apply(e, t);
    } : p;
}
var $f00b43f448a01a93$export$35f8383928ba8d7 = function isUIAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $f00b43f448a01a93$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isUIAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === 'UIAnalyticsEvent';
};
var $f00b43f448a01a93$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_AnalyticsEvent) {
    function UIAnalyticsEvent(props) {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, UIAnalyticsEvent);
        _this = $f00b43f448a01a93$var$_callSuper(this, UIAnalyticsEvent, [
            props
        ]);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "_isUIAnalyticsEvent", true);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "clone", function() {
            if (_this.hasFired) return null;
            var context = (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(_this.context);
            var handlers = (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(_this.handlers);
            /**
       * A hacky "deep clone" of the object. This is limited in that it wont
       * support functions, regexs, Maps, Sets, etc, but none of those need to
       * be represented in our payload.
       */ var payload = JSON.parse(JSON.stringify(_this.payload));
            return new UIAnalyticsEvent({
                context: context,
                handlers: handlers,
                payload: payload
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "fire", function(channel) {
            if (_this.hasFired) return;
            _this.handlers.forEach(function(handler) {
                return handler(_this, channel);
            });
            _this.hasFired = true;
        });
        _this.context = props.context || [];
        _this.handlers = props.handlers || [];
        _this.hasFired = false;
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($eyuDe)))(UIAnalyticsEvent, _AnalyticsEvent);
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(UIAnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (this.hasFired) return this;
                return $f00b43f448a01a93$var$_superPropGet(UIAnalyticsEvent, "update", this, 3)([
                    updater
                ]);
            }
        }
    ]);
}((0, $95ff901dcc288d80$export$2e2bcd8739ae039));



var $5FkrB = parcelRequire("5FkrB");

var $iyyOp = parcelRequire("iyyOp");
var $e9ae543f50fe0e07$export$d1f587f82ad51c4 = function useAnalyticsContext() {
    return (0, $5FkrB.useContext)((0, $iyyOp.default));
};


function $46fdcdf47a9cc549$export$5bf35293e545f20c() {
    var analyticsContext = (0, $e9ae543f50fe0e07$export$d1f587f82ad51c4)();
    var createAnalyticsEvent = (0, $dLGML.useCallbackOne)(function(payload) {
        return new (0, $f00b43f448a01a93$export$2e2bcd8739ae039)({
            context: analyticsContext.getAtlaskitAnalyticsContext(),
            handlers: analyticsContext.getAtlaskitAnalyticsEventHandlers(),
            payload: payload
        });
    }, [
        analyticsContext
    ]);
    return {
        createAnalyticsEvent: createAnalyticsEvent
    };
}



var $5FkrB = parcelRequire("5FkrB");
var $14e8c2f4d76a321c$export$1d27a74659855e44 = function useTrackedRef(value) {
    var ref = (0, $5FkrB.useRef)(value);
    ref.current = value;
    return ref;
};


function $a4990a43141cc076$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $a4990a43141cc076$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $a4990a43141cc076$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $a4990a43141cc076$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $a4990a43141cc076$export$a4687b0234b40e28(_ref) {
    var fn = _ref.fn, action = _ref.action, componentName = _ref.componentName, actionSubject = _ref.actionSubject, packageName = _ref.packageName, packageVersion = _ref.packageVersion, analyticsData = _ref.analyticsData;
    var _useAnalyticsEvents = (0, $46fdcdf47a9cc549$export$5bf35293e545f20c)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
    // We put analyticsData and fn in a ref so that we don't need to break
    // memoization.
    // Generally these could be defined by consumers inline
    // and so we do this to avoid breaking memoization of useCallback
    var dataRef = (0, $14e8c2f4d76a321c$export$1d27a74659855e44)(analyticsData);
    var fnRef = (0, $14e8c2f4d76a321c$export$1d27a74659855e44)(fn);
    var handler = (0, $5FkrB.useCallback)(function(value) {
        var analyticsEvent = createAnalyticsEvent({
            action: action,
            actionSubject: actionSubject || componentName,
            attributes: {
                componentName: componentName,
                packageName: packageName,
                packageVersion: packageVersion
            }
        });
        // To avoid wrapping this component in AnalyticsContext we manually
        // push the parent context's meta data into the context.
        // Note: this new 'context'
        var context = $a4990a43141cc076$var$_objectSpread({
            componentName: componentName,
            packageName: packageName,
            packageVersion: packageVersion
        }, dataRef.current);
        analyticsEvent.context.push(context);
        // fire an event on the atlaskit channel
        var clone = analyticsEvent.clone();
        if (clone) clone.fire('atlaskit');
        fnRef.current(value, analyticsEvent);
    }, [
        // These are strings and won't change
        action,
        componentName,
        actionSubject,
        packageName,
        packageVersion,
        // This function is memoized in the context
        createAnalyticsEvent,
        // these are a stable ref because of the useTrackedRef hook
        dataRef,
        fnRef
    ]);
    return handler;
}



var $dJ32z = parcelRequire("dJ32z");

var $eVb4V = parcelRequire("eVb4V");

var $eqVaP = parcelRequire("eqVaP");
/* focusable.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $kqp0i = parcelRequire("kqp0i");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");
var $232943cd6bb124d1$var$_excluded = [
    "as",
    "children",
    "isInset",
    "testId",
    "style",
    "xcss"
], $232943cd6bb124d1$var$_excluded2 = [
    "className"
];
var $232943cd6bb124d1$var$focusRingStyles = null;
var $232943cd6bb124d1$var$insetFocusRingStyles = null;
/**
 * __Focus ring__
 *
 * A focus ring visually indicates the currently focused item.
 *
 */ var $232943cd6bb124d1$var$Focusable = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? 'button' : _ref$as, children = _ref.children, isInset = _ref.isInset, testId = _ref.testId, style = _ref.style, xcss = _ref.xcss, htmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $232943cd6bb124d1$var$_excluded);
    // This is to remove className from safeHtmlAttributes
    // @ts-ignore -- not using expect since it causes issues with help-center local consumption - className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(htmlAttributes, $232943cd6bb124d1$var$_excluded2);
    return /*#__PURE__*/ $5FkrB.createElement(Component, (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, safeHtmlAttributes, {
        // @ts-ignore Expression produces a union type that is too complex to represent. We may be able to narrow the type here but unsure.
        ref: ref,
        className: (0, $970q7.default)([
            "_ymio1r31 _ypr0glyw _zcxs1o36 _mizu194a _1ah3dkaa _ra3xnqa1 _128mdkaa _1cvmnqa1 _4davt94y",
            isInset && "_1ah31gjf _2mwq1gjf",
            xcss
        ]),
        style: style,
        "data-testid": testId
    }), children);
});
var $232943cd6bb124d1$export$2e2bcd8739ae039 = $232943cd6bb124d1$var$Focusable;


var $fd0e72e5d7e204f4$var$_excluded = [
    "children",
    "isDisabled",
    "type",
    "onClick",
    "interactionName",
    "componentName",
    "analyticsContext",
    "style",
    "testId",
    "xcss",
    "tabIndex"
], $fd0e72e5d7e204f4$var$_excluded2 = [
    "className"
];
var $fd0e72e5d7e204f4$var$styles = {
    root: "_19itglyw _vchhusvi _r06hglyw _80omtlke",
    disabled: "_80om13gf"
};
/**
 * __Pressable__
 *
 * A primitive for building custom buttons.
 *
 * - [Examples](https://atlassian.design/components/primitives/pressable/examples)
 * - [Code](https://atlassian.design/components/primitives/pressable/code)
 * - [Usage](https://atlassian.design/components/primitives/pressable/usage)
 */ var $fd0e72e5d7e204f4$var$Pressable = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function(_ref, ref) {
    var children = _ref.children, isDisabled = _ref.isDisabled, _ref$type = _ref.type, type = _ref$type === void 0 ? 'button' : _ref$type, _ref$onClick = _ref.onClick, providedOnClick = _ref$onClick === void 0 ? (0, $eVb4V.default) : _ref$onClick, interactionName = _ref.interactionName, componentName = _ref.componentName, analyticsContext = _ref.analyticsContext, style = _ref.style, testId = _ref.testId, xcss = _ref.xcss, tabIndex = _ref.tabIndex, htmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $fd0e72e5d7e204f4$var$_excluded);
    var interactionContext = (0, $5FkrB.useContext)((0, $eqVaP.default));
    var handleClick = (0, $5FkrB.useCallback)(function(e, analyticsEvent) {
        interactionContext && interactionContext.tracePress(interactionName, e.timeStamp);
        providedOnClick(e, analyticsEvent);
    }, [
        providedOnClick,
        interactionContext,
        interactionName
    ]);
    var onClick = (0, $a4990a43141cc076$export$a4687b0234b40e28)({
        fn: handleClick,
        action: 'clicked',
        componentName: componentName || 'Pressable',
        packageName: "@atlaskit/primitives",
        packageVersion: "17.1.0",
        analyticsData: analyticsContext,
        actionSubject: 'button'
    });
    // This is to remove className from safeHtmlAttributes
    // @ts-expect-error className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(htmlAttributes, $fd0e72e5d7e204f4$var$_excluded2);
    return /*#__PURE__*/ $5FkrB.createElement((0, $232943cd6bb124d1$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        as: "button",
        tabIndex: tabIndex !== null && tabIndex !== void 0 ? tabIndex : (0, $dJ32z.isSafari)() && !isDisabled ? 0 : undefined,
        style: style
    }, safeHtmlAttributes, {
        type: type,
        onClick: onClick,
        disabled: isDisabled,
        xcss: (0, $hUFig.cx)($fd0e72e5d7e204f4$var$styles.root, isDisabled && $fd0e72e5d7e204f4$var$styles.disabled, xcss),
        testId: testId,
        ref: ref
    }), children);
});
var $fd0e72e5d7e204f4$export$2e2bcd8739ae039 = $fd0e72e5d7e204f4$var$Pressable;



var $9ztDu = parcelRequire("9ztDu");

var $ecf42a684385bf78$var$_excluded = [
    "innerProps",
    "isRtl",
    "size",
    "isCompact",
    "xcss"
];
function $ecf42a684385bf78$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $ecf42a684385bf78$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $ecf42a684385bf78$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $ecf42a684385bf78$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
// ==============================
// Dropdown & Clear Icons
// ==============================
var $ecf42a684385bf78$var$iconContainerStyles = {
    root: "_kkk2n7od _12ji1r31 _1qu219ly _12y31o36 _1e0c1txw _4cvr1h6o _1bah1h6o _1q51v77o _y4tiv77o _85i5v77o _bozgv77o"
};
var $ecf42a684385bf78$var$dropdownWrapperStyles = {
    root: "_1q5112x7 _y4ti12x7 _85i512x7 _bozg12x7"
};
// ==============================
// Dropdown & Clear Buttons
// ==============================
var $ecf42a684385bf78$var$dropdownStyles = {
    default: "_v564vrg3 _1e0c1txw _syazazsu _1q5112x7 _y4tiv77o _85i512x7 _bozgv77o _30l3azsu",
    compact: "_1q51idpf _85i5idpf",
    disabled: "_syaz1gmx"
};
var $ecf42a684385bf78$export$e1687335805e1230 = function dropdownIndicatorCSS() {
    return {};
};
var $ecf42a684385bf78$export$ec98719d3db7f2e4 = function DropdownIndicator(props) {
    var innerProps = props.innerProps, children = props.children, isDisabled = props.isDisabled, isCompact = props.isCompact, xcss = props.xcss;
    var _getStyleProps = (0, $27e7f6ca7209680a$export$26417cabd806a658)(props, 'dropdownIndicator', {
        indicator: true,
        'dropdown-indicator': true
    }), css = _getStyleProps.css, className = _getStyleProps.className;
    return /*#__PURE__*/ $5FkrB.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        className: (0, $970q7.default)([
            $ecf42a684385bf78$var$dropdownStyles.default,
            isDisabled && $ecf42a684385bf78$var$dropdownStyles.disabled,
            isCompact && $ecf42a684385bf78$var$dropdownStyles.compact,
            (0, $hUFig.cx)(className, xcss, '-indicatorContainer')
        ])
    }, innerProps), children ? children : /*#__PURE__*/ $5FkrB.createElement((0, $3d2f4b22f964133c$export$2e2bcd8739ae039), {
        as: "span",
        xcss: $ecf42a684385bf78$var$dropdownWrapperStyles.root
    }, /*#__PURE__*/ $5FkrB.createElement((0, (/*@__PURE__*/$parcel$interopDefault($8b2dd9bf72c54e50$exports))), {
        color: "currentColor",
        label: "open",
        size: "small"
    })));
};
var $ecf42a684385bf78$export$9c0419fd944c1def = function clearIndicatorCSS() {
    return {};
};
var $ecf42a684385bf78$var$clearIndicatorStyles = {
    default: "_v564vrg3 _1e0c1txw _syaz1rpy _1q5112x7 _y4tiv77o _85i512x7 _bozgv77o _30l3azsu",
    compact: "_1q51idpf _85i5idpf"
};
var $ecf42a684385bf78$export$ecf9cf59142dd54a = function ClearIndicator(props) {
    var innerProps = props.innerProps, _props$clearControlLa = props.clearControlLabel, clearControlLabel = _props$clearControlLa === void 0 ? 'clear' : _props$clearControlLa, isCompact = props.isCompact, xcss = props.xcss;
    var _getStyleProps2 = (0, $27e7f6ca7209680a$export$26417cabd806a658)(props, 'clearIndicator', {
        indicator: true,
        'clear-indicator': true
    }), css = _getStyleProps2.css, className = _getStyleProps2.className;
    return /*#__PURE__*/ $5FkrB.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        className: (0, $970q7.default)([
            $ecf42a684385bf78$var$clearIndicatorStyles.default,
            isCompact && $ecf42a684385bf78$var$clearIndicatorStyles.compact,
            (0, $hUFig.cx)(className, xcss, '-indicatorContainer')
        ])
    }, innerProps), /*#__PURE__*/ $5FkrB.createElement((0, $fd0e72e5d7e204f4$export$2e2bcd8739ae039), {
        xcss: $ecf42a684385bf78$var$iconContainerStyles.root,
        tabIndex: -1,
        "aria-label": clearControlLabel
    }, /*#__PURE__*/ $5FkrB.createElement((0, (/*@__PURE__*/$parcel$interopDefault($b8fbe79318730926$exports))), {
        label: "",
        color: "currentColor",
        size: "small"
    })));
};
var $ecf42a684385bf78$export$1d3f24cde248e6b5 = function loadingIndicatorCSS() {
    return {};
};
var $ecf42a684385bf78$var$loadingIndicatorStyles = {
    default: "_1q5112x7 _y4tiu2gc _85i512x7 _bozgu2gc",
    compact: "_1q51idpf _85i5idpf"
};
var $ecf42a684385bf78$export$7c20be4c1d342248 = function LoadingIndicator(_ref) {
    var innerProps = _ref.innerProps, isRtl = _ref.isRtl, _ref$size = _ref.size, size = _ref$size === void 0 ? 4 : _ref$size, isCompact = _ref.isCompact, xcss = _ref.xcss, restProps = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $ecf42a684385bf78$var$_excluded);
    var _getStyleProps3 = (0, $27e7f6ca7209680a$export$26417cabd806a658)($ecf42a684385bf78$var$_objectSpread($ecf42a684385bf78$var$_objectSpread({}, restProps), {}, {
        innerProps: innerProps,
        isRtl: isRtl,
        size: size
    }), 'loadingIndicator', {
        indicator: true,
        'loading-indicator': true
    }), css = _getStyleProps3.css, className = _getStyleProps3.className;
    return /*#__PURE__*/ $5FkrB.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        className: (0, $970q7.default)([
            $ecf42a684385bf78$var$loadingIndicatorStyles.default,
            isCompact && $ecf42a684385bf78$var$loadingIndicatorStyles.compact,
            (0, $hUFig.cx)(className, xcss, '-loadingIndicator')
        ])
    }, innerProps), /*#__PURE__*/ $5FkrB.createElement((0, $9ztDu.default), {
        size: "small"
    }));
};


/* input.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $kqp0i = parcelRequire("kqp0i");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");

var $hUFig = parcelRequire("hUFig");

var $9Zzpd = parcelRequire("9Zzpd");

var $7bd4eb6f381d9e4c$var$_excluded = [
    "innerRef",
    "isDisabled",
    "isHidden",
    "inputClassName",
    "testId"
];
var $7bd4eb6f381d9e4c$export$14a7781d0ca7abea = function inputCSS() {
    return {};
};
var $7bd4eb6f381d9e4c$var$inputStylesOld = {
    root: "_16jlkb7n _1o9zkb7n _i0dl1wug _nd5l1sux _1mouv77o _195gv77o _1rjcv77o _1e0c1n7u _yv0e12qd _syazi7uo _j8d6idpf _1av2idpf _1doyidpf _pfztidpf _uoe3idpf _1recidpf _70xridpf _1k96idpf _eq43idpf _1h9u1kw7 _ckog1yjy _1x651r31 _1nn4glyw _1rzeidpf _1yd8yh40 _aetr11ps _uy7x15vq _1qjlqvpr",
    disabled: "_3um015vq"
};
var $7bd4eb6f381d9e4c$var$inputStyles = {
    root: "_16jlkb7n _1o9zkb7n _i0dl1wug _nd5l1sux _1mouv77o _195gv77o _1rjcv77o _kqswh2mm _1e0c1txw _yv0e12qd _syazi7uo _j8d6idpf _1av2idpf _1doyidpf _pfztidpf _uoe3idpf _1recidpf _70xridpf _1k96idpf _eq43idpf _1h9u1kw7 _ckog1yjy _1x651r31 _1nn4glyw _1rzeidpf _1yd8yh40 _aetr11ps _uy7x15vq _1qjlqvpr",
    disabled: "_3um015vq"
};
var $7bd4eb6f381d9e4c$var$nativeInputStylesOld = null;
var $7bd4eb6f381d9e4c$var$nativeInputStyles = null;
var $7bd4eb6f381d9e4c$var$hidden = null;
var $7bd4eb6f381d9e4c$var$Input = function Input(props) {
    var builtinCX = props.cx, value = props.value, xcss = props.xcss;
    var _cleanCommonProps = (0, $27e7f6ca7209680a$export$8e9fd4287627890c)(props), innerRef = _cleanCommonProps.innerRef, isDisabled = _cleanCommonProps.isDisabled, isHidden = _cleanCommonProps.isHidden, inputClassName = _cleanCommonProps.inputClassName, testId = _cleanCommonProps.testId, innerProps = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_cleanCommonProps, $7bd4eb6f381d9e4c$var$_excluded);
    var dataId = testId ? "".concat(testId, "-select--input") : null;
    var _getStyleProps = (0, $27e7f6ca7209680a$export$26417cabd806a658)(props, 'input', {
        'input-container': true
    }), css = _getStyleProps.css, className = _getStyleProps.className;
    if ((0, $9Zzpd.fg)('platform_do_not_clear_input_for_multiselect')) return /*#__PURE__*/ $5FkrB.createElement("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        className: (0, $970q7.default)([
            $7bd4eb6f381d9e4c$var$inputStyles.root,
            isDisabled && $7bd4eb6f381d9e4c$var$inputStyles.disabled,
            (0, $hUFig.cx)(className, xcss, '-Input')
        ]),
        "data-value": value || '',
        "data-testid": dataId && "".concat(dataId, "-container")
    }, /*#__PURE__*/ $5FkrB.createElement("input", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $970q7.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1r04idpf _11q7idpf _19itidpf _11c81kw7 _nd5l1yjy _12ji1r31 _1qu2glyw _12y3idpf _1bsb1osq _1ul9yh40 _kqswstnw _syaz1kw7 _tzy4kb7n",
            isHidden && "_tzy4idpf",
            builtinCX({
                input: true
            }, inputClassName, '-input')
        ]),
        ref: innerRef,
        disabled: isDisabled,
        "data-testid": dataId
    }, innerProps)));
    return /*#__PURE__*/ $5FkrB.createElement("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        className: (0, $970q7.default)([
            $7bd4eb6f381d9e4c$var$inputStylesOld.root,
            isDisabled && $7bd4eb6f381d9e4c$var$inputStylesOld.disabled,
            (0, $hUFig.cx)(className, xcss, '-Input')
        ]),
        "data-value": value || '',
        "data-testid": dataId && "".concat(dataId, "-container")
    }, /*#__PURE__*/ $5FkrB.createElement("input", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $970q7.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _11q7idpf _19itidpf _11c81kw7 _nd5l1yjy _12ji1r31 _1qu2glyw _12y3idpf _1bsb1osq _1ul9yh40 _syaz1kw7 _tzy4kb7n",
            isHidden && "_tzy4idpf",
            builtinCX({
                input: true
            }, inputClassName, '-input')
        ]),
        ref: innerRef,
        disabled: isDisabled,
        "data-testid": dataId
    }, innerProps)));
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$7bd4eb6f381d9e4c$export$2e2bcd8739ae039 = $7bd4eb6f381d9e4c$var$Input;


/* menu.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $1Vcia = parcelRequire("1Vcia");

var $kqp0i = parcelRequire("kqp0i");

var $25nEq = parcelRequire("25nEq");

var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");

var $hUFig = parcelRequire("hUFig");

var $6I9SI = parcelRequire("6I9SI");

var $aLeHs = parcelRequire("aLeHs");

var $g8g1T = parcelRequire("g8g1T");

var $9Zzpd = parcelRequire("9Zzpd");
/* text.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");

var $afMOk = parcelRequire("afMOk");

var $5FkrB = parcelRequire("5FkrB");
var $236e81321d318a01$var$HasTextAncestorContext = /*#__PURE__*/ (0, $5FkrB.createContext)(false);
var $236e81321d318a01$export$9322276ec105d055 = function useHasTextAncestor() {
    return (0, $5FkrB.useContext)($236e81321d318a01$var$HasTextAncestorContext);
};
var $236e81321d318a01$export$ae933c6cbe5643ad = $236e81321d318a01$var$HasTextAncestorContext.Provider;



var $5FkrB = parcelRequire("5FkrB");
var $b96cd1d69358f1d4$export$1ca2a26fecb070ae = /*#__PURE__*/ (0, $5FkrB.createContext)('elevation.surface');
var $b96cd1d69358f1d4$export$1aeb4f6b93c4540d = function useSurface() {
    return (0, $5FkrB.useContext)($b96cd1d69358f1d4$export$1ca2a26fecb070ae);
};
$b96cd1d69358f1d4$export$1ca2a26fecb070ae.displayName = 'SurfaceProvider';


var $8fe74c11e3374335$var$asAllowlist = [
    'span',
    'p',
    'strong',
    'em'
];
/**
 * Custom hook designed to abstract the parsing of the color props and make it clearer in the future how color is reconciled between themes and tokens.
 */ var $8fe74c11e3374335$var$useColor = function useColor(colorProp, hasTextAncestor) {
    var surface = (0, $b96cd1d69358f1d4$export$1aeb4f6b93c4540d)();
    if (colorProp === 'inherit') return undefined;
    if (colorProp) return colorProp;
    if (hasTextAncestor) return undefined;
    if ($8fe74c11e3374335$export$2185ce37f9bdd963.hasOwnProperty(surface)) return $8fe74c11e3374335$export$2185ce37f9bdd963[surface];
    return 'color.text';
};
var $8fe74c11e3374335$var$styles = {
    root: "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _1i4qfg65",
    'as.strong': "_k48pwu06",
    'as.em': "_zg8l1m30",
    'textAlign.center': "_y3gn1h6o",
    'textAlign.end': "_y3gnh9n0",
    'textAlign.start': "_y3gnv2br",
    truncation: "_1reo15vq _18m915vq _1e0ccj1k _sudp1e54",
    breakAll: "_1nmz9jpi"
};
var $8fe74c11e3374335$var$fontSizeMap = {
    medium: "_11c8fhey",
    UNSAFE_small: "_11c8rymc",
    large: "_11c81d4k",
    small: "_11c8wadc"
};
var $8fe74c11e3374335$var$fontWeightMap = {
    bold: "_k48pwu06",
    medium: "_k48p1wq8",
    regular: "_k48pi7a9",
    semibold: "_k48p1pd9"
};
var $8fe74c11e3374335$var$textColorMap = {
    'color.text': "_syazi7uo",
    'color.text.accent.lime': "_syaz1tco",
    'color.text.accent.lime.bolder': "_syaz1ik3",
    'color.text.accent.red': "_syaz9lu1",
    'color.text.accent.red.bolder': "_syazhwvp",
    'color.text.accent.orange': "_syazp1lv",
    'color.text.accent.orange.bolder': "_syaz7i1p",
    'color.text.accent.yellow': "_syazfb2s",
    'color.text.accent.yellow.bolder': "_syazekll",
    'color.text.accent.green': "_syazh55r",
    'color.text.accent.green.bolder': "_syaz1y78",
    'color.text.accent.teal': "_syaz17qg",
    'color.text.accent.teal.bolder': "_syaz12v7",
    'color.text.accent.blue': "_syaz16jw",
    'color.text.accent.blue.bolder': "_syaz1kyx",
    'color.text.accent.purple': "_syazqmo9",
    'color.text.accent.purple.bolder': "_syaz1mn1",
    'color.text.accent.magenta': "_syaz1s8m",
    'color.text.accent.magenta.bolder': "_syaz1qur",
    'color.text.accent.gray': "_syaz1sqi",
    'color.text.accent.gray.bolder': "_syaz1tmo",
    'color.text.disabled': "_syaz1gmx",
    'color.text.inverse': "_syaz15cr",
    'color.text.selected': "_syaz6x5g",
    'color.text.brand': "_syaz1oa5",
    'color.text.danger': "_syaz1tmw",
    'color.text.warning': "_syaz1xn9",
    'color.text.warning.inverse': "_syaz1yd3",
    'color.text.success': "_syazgsak",
    'color.text.discovery': "_syazdv2p",
    'color.text.information': "_syazu3tg",
    'color.text.subtlest': "_syaz1rpy",
    'color.text.subtle': "_syazazsu",
    'color.link': "_syaz13af",
    'color.link.pressed': "_syaz12zz",
    'color.link.visited': "_syaz1ra0",
    'color.link.visited.pressed': "_syaz17z1"
};
var $8fe74c11e3374335$export$2185ce37f9bdd963 = {
    'color.background.neutral.bold': 'color.text.inverse',
    'color.background.neutral.bold.hovered': 'color.text.inverse',
    'color.background.neutral.bold.pressed': 'color.text.inverse',
    'color.background.selected.bold': 'color.text.inverse',
    'color.background.selected.bold.hovered': 'color.text.inverse',
    'color.background.selected.bold.pressed': 'color.text.inverse',
    'color.background.brand.bold': 'color.text.inverse',
    'color.background.brand.bold.hovered': 'color.text.inverse',
    'color.background.brand.bold.pressed': 'color.text.inverse',
    'color.background.brand.boldest': 'color.text.inverse',
    'color.background.brand.boldest.hovered': 'color.text.inverse',
    'color.background.brand.boldest.pressed': 'color.text.inverse',
    'color.background.danger.bold': 'color.text.inverse',
    'color.background.danger.bold.hovered': 'color.text.inverse',
    'color.background.danger.bold.pressed': 'color.text.inverse',
    'color.background.warning.bold': 'color.text.warning.inverse',
    'color.background.warning.bold.hovered': 'color.text.warning.inverse',
    'color.background.warning.bold.pressed': 'color.text.warning.inverse',
    'color.background.success.bold': 'color.text.inverse',
    'color.background.success.bold.hovered': 'color.text.inverse',
    'color.background.success.bold.pressed': 'color.text.inverse',
    'color.background.discovery.bold': 'color.text.inverse',
    'color.background.discovery.bold.hovered': 'color.text.inverse',
    'color.background.discovery.bold.pressed': 'color.text.inverse',
    'color.background.information.bold': 'color.text.inverse',
    'color.background.information.bold.hovered': 'color.text.inverse',
    'color.background.information.bold.pressed': 'color.text.inverse'
};
/**
 * __Text__
 *
 * Text is a primitive component that has the Atlassian Design System's design guidelines baked in.
 * This includes considerations for text attributes such as color, font size, font weight, and line height.
 * It renders a `span` by default.
 *
 * @internal
 */ var $8fe74c11e3374335$var$Text = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? 'span' : _ref$as, colorProp = _ref.color, align = _ref.align, testId = _ref.testId, id = _ref.id, size = _ref.size, weight = _ref.weight, maxLines = _ref.maxLines, xcss = _ref.xcss, children = _ref.children;
    (0, $afMOk.default)($8fe74c11e3374335$var$asAllowlist.includes(Component), "@atlaskit/primitives: Text received an invalid \"as\" value of \"".concat(Component, "\""));
    var hasTextAncestor = (0, $236e81321d318a01$export$9322276ec105d055)();
    var color = $8fe74c11e3374335$var$useColor(colorProp, hasTextAncestor);
    if (!size && !hasTextAncestor) size = 'medium';
    var component = /*#__PURE__*/ $5FkrB.createElement(Component, {
        id: id,
        className: (0, $970q7.default)([
            $8fe74c11e3374335$var$styles.root,
            size && $8fe74c11e3374335$var$fontSizeMap[size],
            color && $8fe74c11e3374335$var$textColorMap[color],
            maxLines && $8fe74c11e3374335$var$styles.truncation,
            maxLines === 1 && $8fe74c11e3374335$var$styles.breakAll,
            align && $8fe74c11e3374335$var$styles["textAlign.".concat(align)],
            weight && $8fe74c11e3374335$var$fontWeightMap[weight],
            Component === 'em' && $8fe74c11e3374335$var$styles['as.em'],
            Component === 'strong' && $8fe74c11e3374335$var$styles['as.strong'],
            xcss
        ]),
        style: {
            WebkitLineClamp: maxLines
        },
        "data-testid": testId,
        ref: ref
    }, children);
    if (hasTextAncestor) // no need to re-apply context if the text is already wrapped
    return component;
    return /*#__PURE__*/ $5FkrB.createElement((0, $236e81321d318a01$export$ae933c6cbe5643ad), {
        value: true
    }, component);
});
var $8fe74c11e3374335$export$2e2bcd8739ae039 = $8fe74c11e3374335$var$Text;



var $13242eb59811c5b2$var$_excluded = [
    "children",
    "innerProps",
    "xcss"
], $13242eb59811c5b2$var$_excluded2 = [
    "children",
    "innerProps",
    "xcss"
];
function $13242eb59811c5b2$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $13242eb59811c5b2$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $13242eb59811c5b2$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $13242eb59811c5b2$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
// ==============================
// Menu
// ==============================
// Get Menu Placement
// ------------------------------
function $13242eb59811c5b2$var$getMenuPlacement(_ref) {
    var preferredMaxHeight = _ref.maxHeight, menuEl = _ref.menuEl, minHeight = _ref.minHeight, preferredPlacement = _ref.placement, shouldScroll = _ref.shouldScroll, isFixedPosition = _ref.isFixedPosition, controlHeight = _ref.controlHeight;
    var scrollParent = (0, $27e7f6ca7209680a$export$cfa2225e87938781)(menuEl);
    var defaultState = {
        placement: 'bottom',
        maxHeight: preferredMaxHeight
    };
    // something went wrong, return default state
    if (!menuEl || !menuEl.offsetParent) return defaultState;
    // we can't trust `scrollParent.scrollHeight` --> it may increase when
    // the menu is rendered
    var _scrollParent$getBoun = scrollParent.getBoundingClientRect(), scrollHeight = _scrollParent$getBoun.height;
    var _menuEl$getBoundingCl = menuEl.getBoundingClientRect(), menuBottom = _menuEl$getBoundingCl.bottom, menuHeight = _menuEl$getBoundingCl.height, menuTop = _menuEl$getBoundingCl.top;
    var _menuEl$offsetParent$ = menuEl.offsetParent.getBoundingClientRect(), containerTop = _menuEl$offsetParent$.top;
    var viewHeight = isFixedPosition ? window.innerHeight : (0, $27e7f6ca7209680a$export$2e0654fad740d2e4)(scrollParent);
    var scrollTop = (0, $27e7f6ca7209680a$export$c4a223a8ba9e4ea5)(scrollParent);
    var menuTopFromParent = menuTop;
    var marginBottom = parseInt(getComputedStyle(menuEl).marginBottom, 10);
    var marginTop = parseInt(getComputedStyle(menuEl).marginTop, 10);
    var viewSpaceAbove = containerTop - marginTop;
    var viewSpaceBelow = viewHeight - menuTopFromParent;
    var scrollSpaceAbove = viewSpaceAbove + scrollTop;
    var scrollSpaceBelow = scrollHeight - scrollTop - menuTopFromParent;
    var scrollDown = menuBottom - viewHeight + scrollTop + marginBottom;
    var scrollUp = scrollTop + menuTop - marginTop;
    var scrollDuration = 160;
    switch(preferredPlacement){
        case 'auto':
        case 'bottom':
            // 1: the menu will fit, do nothing
            if (viewSpaceBelow >= menuHeight) return {
                placement: 'bottom',
                maxHeight: preferredMaxHeight
            };
            // 2: the menu will fit, if scrolled
            if (scrollSpaceBelow >= menuHeight && !isFixedPosition) {
                if (shouldScroll) (0, $27e7f6ca7209680a$export$858c30343199f3af)(scrollParent, scrollDown, scrollDuration);
                return {
                    placement: 'bottom',
                    maxHeight: preferredMaxHeight
                };
            }
            // 3: the menu will fit, if constrained
            if (!isFixedPosition && scrollSpaceBelow >= minHeight || isFixedPosition && viewSpaceBelow >= minHeight) {
                if (shouldScroll) (0, $27e7f6ca7209680a$export$858c30343199f3af)(scrollParent, scrollDown, scrollDuration);
                // we want to provide as much of the menu as possible to the user,
                // so give them whatever is available below rather than the minHeight.
                var constrainedHeight = isFixedPosition ? viewSpaceBelow - marginBottom : scrollSpaceBelow - marginBottom;
                return {
                    placement: 'bottom',
                    maxHeight: constrainedHeight
                };
            }
            // 4. Forked beviour when there isn't enough space below
            // AUTO: flip the menu, render above
            if (preferredPlacement === 'auto' || isFixedPosition) {
                // may need to be constrained after flipping
                var _constrainedHeight = preferredMaxHeight;
                var spaceAbove = isFixedPosition ? viewSpaceAbove : scrollSpaceAbove;
                if (spaceAbove >= minHeight) _constrainedHeight = Math.min(spaceAbove - marginBottom - controlHeight, preferredMaxHeight);
                return {
                    placement: 'top',
                    maxHeight: _constrainedHeight
                };
            }
            // BOTTOM: allow browser to increase scrollable area and immediately set scroll
            if (preferredPlacement === 'bottom') {
                if (shouldScroll) (0, $27e7f6ca7209680a$export$3f99968195accfaf)(scrollParent, scrollDown);
                return {
                    placement: 'bottom',
                    maxHeight: preferredMaxHeight
                };
            }
            break;
        case 'top':
            // 1: the menu will fit, do nothing
            if (viewSpaceAbove >= menuHeight) return {
                placement: 'top',
                maxHeight: preferredMaxHeight
            };
            // 2: the menu will fit, if scrolled
            if (scrollSpaceAbove >= menuHeight && !isFixedPosition) {
                if (shouldScroll) (0, $27e7f6ca7209680a$export$858c30343199f3af)(scrollParent, scrollUp, scrollDuration);
                return {
                    placement: 'top',
                    maxHeight: preferredMaxHeight
                };
            }
            // 3: the menu will fit, if constrained
            if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) {
                var _constrainedHeight2 = preferredMaxHeight;
                // we want to provide as much of the menu as possible to the user,
                // so give them whatever is available below rather than the minHeight.
                if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) _constrainedHeight2 = isFixedPosition ? viewSpaceAbove - marginTop : scrollSpaceAbove - marginTop;
                if (shouldScroll) (0, $27e7f6ca7209680a$export$858c30343199f3af)(scrollParent, scrollUp, scrollDuration);
                return {
                    placement: 'top',
                    maxHeight: _constrainedHeight2
                };
            }
            // 4. not enough space, the browser WILL NOT increase scrollable area when
            // absolutely positioned element rendered above the viewport (only below).
            // Flip the menu, render below
            return {
                placement: 'bottom',
                maxHeight: preferredMaxHeight
            };
        default:
            throw new Error("Invalid placement provided \"".concat(preferredPlacement, "\"."));
    }
    return defaultState;
}
// Menu Component
// ------------------------------
var $13242eb59811c5b2$var$coercePlacement = function coercePlacement(p) {
    return p === 'auto' ? 'bottom' : p;
};
var $13242eb59811c5b2$var$menuStyles = {
    root: "_2rko12b0 _kqswstnw _1bsb1osq _1pbykb7n _6rthu2gc _1pfhu2gc _bfhk1bhr _16qsd0yg",
    rootT26Shape: "_2rko1mok",
    bottom: "_152t1osq",
    top: "_u7co1osq"
};
var $13242eb59811c5b2$export$a228922d5ca42a79 = function menuCSS() {
    return {};
};
var $13242eb59811c5b2$var$PortalPlacementContext = /*#__PURE__*/ (0, $5FkrB.createContext)(null);
var $13242eb59811c5b2$export$f32337f3a7617699 = function MenuPlacer(props) {
    var children = props.children, minMenuHeight = props.minMenuHeight, maxMenuHeight = props.maxMenuHeight, menuPlacement = props.menuPlacement, menuPosition = props.menuPosition, menuShouldScrollIntoView = props.menuShouldScrollIntoView;
    var _ref2 = (0, $5FkrB.useContext)($13242eb59811c5b2$var$PortalPlacementContext) || {}, setPortalPlacement = _ref2.setPortalPlacement;
    var ref = (0, $5FkrB.useRef)(null);
    var _useState = (0, $5FkrB.useState)(maxMenuHeight), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), maxHeight = _useState2[0], setMaxHeight = _useState2[1];
    var _useState3 = (0, $5FkrB.useState)(null), _useState4 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState3, 2), placement = _useState4[0], setPlacement = _useState4[1];
    // The minimum height of the control
    var controlHeight = 38;
    (0, $g8g1T.default)(function() {
        var menuEl = ref.current;
        if (!menuEl) return;
        // DO NOT scroll if position is fixed
        var isFixedPosition = menuPosition === 'fixed';
        var shouldScroll = menuShouldScrollIntoView && !isFixedPosition;
        var state = $13242eb59811c5b2$var$getMenuPlacement({
            maxHeight: maxMenuHeight,
            menuEl: menuEl,
            minHeight: minMenuHeight,
            placement: menuPlacement,
            shouldScroll: shouldScroll,
            isFixedPosition: isFixedPosition,
            controlHeight: controlHeight
        });
        setMaxHeight(state.maxHeight);
        setPlacement(state.placement);
        setPortalPlacement === null || setPortalPlacement === void 0 || setPortalPlacement(state.placement);
    }, [
        maxMenuHeight,
        menuPlacement,
        menuPosition,
        menuShouldScrollIntoView,
        minMenuHeight,
        setPortalPlacement,
        controlHeight
    ]);
    return children({
        ref: ref,
        placerProps: $13242eb59811c5b2$var$_objectSpread($13242eb59811c5b2$var$_objectSpread({}, props), {}, {
            placement: placement || $13242eb59811c5b2$var$coercePlacement(menuPlacement),
            maxHeight: maxHeight
        })
    });
};
var $13242eb59811c5b2$var$Menu = function Menu(props) {
    var children = props.children, innerRef = props.innerRef, innerProps = props.innerProps, _props$placement = props.placement, placement = _props$placement === void 0 ? 'bottom' : _props$placement, xcss = props.xcss;
    var _getStyleProps = (0, $27e7f6ca7209680a$export$26417cabd806a658)(props, 'menu', {
        menu: true
    }), css = _getStyleProps.css, className = _getStyleProps.className;
    return /*#__PURE__*/ $5FkrB.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $970q7.default)([
            $13242eb59811c5b2$var$menuStyles.root,
            $13242eb59811c5b2$var$menuStyles[placement],
            (0, $9Zzpd.fg)('platform-dst-shape-theme-default') && $13242eb59811c5b2$var$menuStyles.rootT26Shape,
            (0, $hUFig.cx)(xcss, className, '-menu')
        ]),
        style: css,
        ref: innerRef
    }, innerProps), children);
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$13242eb59811c5b2$export$2e2bcd8739ae039 = $13242eb59811c5b2$var$Menu;
var $13242eb59811c5b2$export$abafed69cff95d5e = function menuListCSS() {
    return {};
};
var $13242eb59811c5b2$var$menuListStyles = null;
var $13242eb59811c5b2$export$d4c4e98c5044dc8 = function MenuList(props) {
    var children = props.children, innerProps = props.innerProps, innerRef = props.innerRef, isMulti = props.isMulti, maxHeight = props.maxHeight, xcss = props.xcss;
    var _getStyleProps2 = (0, $27e7f6ca7209680a$export$26417cabd806a658)(props, 'menuList', {
        'menu-list': true,
        'menu-list--is-multi': isMulti
    }), css = _getStyleProps2.css, className = _getStyleProps2.className;
    return /*#__PURE__*/ $5FkrB.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $970q7.default)([
            "_kqswh2mm _18m91wug _85i5u2gc _1q51u2gc _8am5i4x0",
            (0, $hUFig.cx)(className, xcss, '-MenuList')
        ]),
        style: $13242eb59811c5b2$var$_objectSpread($13242eb59811c5b2$var$_objectSpread({}, css), {}, {
            maxHeight: maxHeight
        }),
        ref: innerRef
    }, innerProps, {
        tabIndex: -1
    }), children);
};
// ==============================
// Menu Notices
// ==============================
var $13242eb59811c5b2$var$noticeCSS = function noticeCSS() {
    return {};
};
var $13242eb59811c5b2$var$noticeStyles = null;
var $13242eb59811c5b2$export$cf0e22534d8b0074 = $13242eb59811c5b2$var$noticeCSS;
var $13242eb59811c5b2$export$98ec46397a8cb3cd = $13242eb59811c5b2$var$noticeCSS;
var $13242eb59811c5b2$export$d58b72b7d3c4072c = function NoOptionsMessage(_ref3) {
    var _ref3$children = _ref3.children, children = _ref3$children === void 0 ? 'No options' : _ref3$children, innerProps = _ref3.innerProps, xcss = _ref3.xcss, restProps = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref3, $13242eb59811c5b2$var$_excluded);
    var _getStyleProps3 = (0, $27e7f6ca7209680a$export$26417cabd806a658)($13242eb59811c5b2$var$_objectSpread($13242eb59811c5b2$var$_objectSpread({}, restProps), {}, {
        children: children,
        innerProps: innerProps
    }), 'noOptionsMessage', {
        'menu-notice': true,
        'menu-notice--no-options': true
    }), css = _getStyleProps3.css, className = _getStyleProps3.className;
    return /*#__PURE__*/ $5FkrB.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $970q7.default)([
            "_85i5u2gc _1q51u2gc _y4tiutpp _bozgutpp _y3gn1h6o",
            (0, $hUFig.cx)(className, xcss, '-NoOptionsMessage')
        ]),
        style: css,
        role: "option"
    }, innerProps), /*#__PURE__*/ $5FkrB.createElement((0, $8fe74c11e3374335$export$2e2bcd8739ae039), {
        color: "color.text.subtle"
    }, children));
};
var $13242eb59811c5b2$export$e928a71d039d3102 = function LoadingMessage(_ref4) {
    var _ref4$children = _ref4.children, children = _ref4$children === void 0 ? 'Loading...' : _ref4$children, innerProps = _ref4.innerProps, xcss = _ref4.xcss, restProps = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref4, $13242eb59811c5b2$var$_excluded2);
    var _getStyleProps4 = (0, $27e7f6ca7209680a$export$26417cabd806a658)($13242eb59811c5b2$var$_objectSpread($13242eb59811c5b2$var$_objectSpread({}, restProps), {}, {
        children: children,
        innerProps: innerProps
    }), 'loadingMessage', {
        'menu-notice': true,
        'menu-notice--loading': true
    }), css = _getStyleProps4.css, className = _getStyleProps4.className;
    return /*#__PURE__*/ $5FkrB.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $970q7.default)([
            "_85i5u2gc _1q51u2gc _y4tiutpp _bozgutpp _y3gn1h6o",
            (0, $hUFig.cx)(className, xcss, '-LoadingMessage')
        ]),
        style: css
    }, innerProps, {
        // eslint-disable-next-line @atlassian/a11y/role-has-required-aria-props
        role: "option"
    }), /*#__PURE__*/ $5FkrB.createElement((0, $8fe74c11e3374335$export$2e2bcd8739ae039), {
        color: "color.text.subtle"
    }, children));
};
var $13242eb59811c5b2$export$1dbbeb9648d1fdc9 = function menuPortalCSS() {
    return {};
};
var $13242eb59811c5b2$var$menuPortalStyles = {
    root: "_1pbykb7n _1e02a1vk _kqswcp1v _152t1nmo _1bsb1qxj"
};
var $13242eb59811c5b2$export$793392f970497feb = function MenuPortal(props) {
    var appendTo = props.appendTo, children = props.children, controlElement = props.controlElement, innerProps = props.innerProps, menuPlacement = props.menuPlacement, menuPosition = props.menuPosition, xcss = props.xcss;
    var menuPortalRef = (0, $5FkrB.useRef)(null);
    var cleanupRef = (0, $5FkrB.useRef)(null);
    var _useState5 = (0, $5FkrB.useState)($13242eb59811c5b2$var$coercePlacement(menuPlacement)), _useState6 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState5, 2), placement = _useState6[0], setPortalPlacement = _useState6[1];
    var portalPlacementContext = (0, $5FkrB.useMemo)(function() {
        return {
            setPortalPlacement: setPortalPlacement
        };
    }, []);
    var _useState7 = (0, $5FkrB.useState)(null), _useState8 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState7, 2), computedPosition = _useState8[0], setComputedPosition = _useState8[1];
    var updateComputedPosition = (0, $5FkrB.useCallback)(function() {
        if (!controlElement) return;
        var rect = (0, $27e7f6ca7209680a$export$7807c2a424c2f6d1)(controlElement);
        var scrollDistance = menuPosition === 'fixed' ? 0 : window.pageYOffset;
        var offset = rect[placement] + scrollDistance;
        if (offset !== (computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.offset) || rect.left !== (computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.left) || rect.width !== (computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.width)) setComputedPosition({
            offset: offset,
            rect: rect
        });
    }, [
        controlElement,
        menuPosition,
        placement,
        computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.offset,
        computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.left,
        computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.width
    ]);
    (0, $g8g1T.default)(function() {
        updateComputedPosition();
    }, [
        updateComputedPosition
    ]);
    var runAutoUpdate = (0, $5FkrB.useCallback)(function() {
        if (typeof cleanupRef.current === 'function') {
            cleanupRef.current();
            cleanupRef.current = null;
        }
        if (controlElement && menuPortalRef.current) cleanupRef.current = (0, $6I9SI.autoUpdate)(controlElement, menuPortalRef.current, updateComputedPosition, {
            elementResize: 'ResizeObserver' in window
        });
    }, [
        controlElement,
        updateComputedPosition
    ]);
    (0, $g8g1T.default)(function() {
        runAutoUpdate();
    }, [
        runAutoUpdate
    ]);
    var setMenuPortalElement = (0, $5FkrB.useCallback)(function(menuPortalElement) {
        menuPortalRef.current = menuPortalElement;
        runAutoUpdate();
    }, [
        runAutoUpdate
    ]);
    // bail early if required elements aren't present
    if (!appendTo && menuPosition !== 'fixed' || !computedPosition) return null;
    var _getStyleProps5 = (0, $27e7f6ca7209680a$export$26417cabd806a658)($13242eb59811c5b2$var$_objectSpread($13242eb59811c5b2$var$_objectSpread({}, props), {}, {
        offset: computedPosition.offset,
        position: menuPosition,
        rect: computedPosition.rect
    }), 'menuPortal', {
        'menu-portal': true
    }), css = _getStyleProps5.css, className = _getStyleProps5.className;
    // same wrapper element whether fixed or portalled
    var menuWrapper = /*#__PURE__*/ $5FkrB.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $970q7.default)([
            $13242eb59811c5b2$var$menuPortalStyles.root,
            (0, $hUFig.cx)(className, xcss, '-MenuPortal')
        ]),
        ref: setMenuPortalElement,
        style: $13242eb59811c5b2$var$_objectSpread({
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            '--menu-left': "".concat(computedPosition.rect.left, "px"),
            '--menu-position': menuPosition,
            '--menu-top': "".concat(computedPosition.offset, "px"),
            '--menu-width': "".concat(computedPosition.rect.width, "px")
        }, css)
    }, innerProps), children);
    return /*#__PURE__*/ $5FkrB.createElement($13242eb59811c5b2$var$PortalPlacementContext.Provider, {
        value: portalPlacementContext
    }, appendTo ? /*#__PURE__*/ (0, $aLeHs.createPortal)(menuWrapper, appendTo) : menuWrapper);
};


/* multi-value.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $25nEq = parcelRequire("25nEq");

var $kqp0i = parcelRequire("kqp0i");

var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");

var $hUFig = parcelRequire("hUFig");
var $af87215eeccde75b$exports = {};
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::13080645a1b889dca339823c8ecd9929>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty($af87215eeccde75b$exports, "__esModule", {
    value: true
});
$af87215eeccde75b$exports.default = void 0;

var $af87215eeccde75b$var$_react = $af87215eeccde75b$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $af87215eeccde75b$var$_baseNew = $af87215eeccde75b$var$_interopRequireDefault((parcelRequire("eRJCC")));
function $af87215eeccde75b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Cross".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Known uses: closing modals, panels, and transient views; removing tags
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $af87215eeccde75b$var$CrossIcon = (props)=>/*#__PURE__*/ $af87215eeccde75b$var$_react.default.createElement($af87215eeccde75b$var$_baseNew.default, Object.assign({
        name: "CrossIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M14.03 3.03 9.06 8l4.97 4.97-1.06 1.06L8 9.06l-4.97 4.97-1.06-1.06L6.94 8 1.97 3.03l1.06-1.06L8 6.94l4.97-4.97z"/>`
    }, props));
$af87215eeccde75b$var$CrossIcon.displayName = 'CrossIcon';
var $af87215eeccde75b$var$_default = $af87215eeccde75b$exports.default = $af87215eeccde75b$var$CrossIcon;



function $56bf53657e0b15f4$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $56bf53657e0b15f4$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $56bf53657e0b15f4$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $56bf53657e0b15f4$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $56bf53657e0b15f4$var$multiValueStyles = {
    root: "_2rko12b0 _1h6d14je _1dqonqa1 _189ee4h9 _1e0c1txw _1ul9ze3t _1pfhv77o _12l2v77o _6rthv77o _ahbqv77o _bfhk1j9a _p12f1osq _syazjpor _3yq3glyw",
    disabled: "_syaz1gmx _bfhki8nm",
    focused: "_syaz1wum _bfhk15s3 _16qs7ex6 _1aewe4h9 _6up51j28 _1xdnnqa1"
};
var $56bf53657e0b15f4$export$23c213f7717186af = function multiValueCSS() {
    return {};
};
var $56bf53657e0b15f4$export$f40612612e0af964 = function multiValueLabelCSS() {
    return {};
};
var $56bf53657e0b15f4$var$multiValueLabelStyles = {
    root: "_1reo15vq _18m915vq _2rkolb4i _11c8fhey _o5721q9c _y4tiv77o _bozg1b66 _syaz1kw7",
    disabled: "_syaz1gmx",
    ellipsis: "_1bto1l2s"
};
var $56bf53657e0b15f4$export$283467f6c4ac142b = function multiValueRemoveCSS() {
    return {};
};
var $56bf53657e0b15f4$var$multiValueRemoveStyles = {
    focused: "_bfhkb1q9 _lswu1rrc",
    root: "_19itglyw _2rko12b0 _4cvr1h6o _1bah1h6o _1wpz1h6o _r06hglyw _bfhksm61 _syazi7uo _1e0c1txw _lswu1dx5 _1q51v77o _y4tiv77o _85i5v77o _bozgv77o _12l2v77o _1ah312gs _irr31dpa _13br1jjn _1di6fcek _i5f81jjn"
};
var $56bf53657e0b15f4$export$cf9cf2a30a59265c = function MultiValueContainer(_ref) {
    var children = _ref.children, innerProps = _ref.innerProps, isFocused = _ref.isFocused, isDisabled = _ref.isDisabled, className = _ref.className, xcss = _ref.xcss;
    return /*#__PURE__*/ $5FkrB.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, innerProps, {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $970q7.default)([
            $56bf53657e0b15f4$var$multiValueStyles.root,
            isDisabled && $56bf53657e0b15f4$var$multiValueStyles.disabled,
            isFocused && $56bf53657e0b15f4$var$multiValueStyles.focused,
            (0, $hUFig.cx)(className, xcss, '-multiValue')
        ])
    }), children);
};
var $56bf53657e0b15f4$export$544aeea2a5ce08ee = function MultiValueLabel(_ref2) {
    var children = _ref2.children, innerProps = _ref2.innerProps, isDisabled = _ref2.isDisabled, hasEllipsis = _ref2.hasEllipsis, className = _ref2.className, xcss = _ref2.xcss;
    return /*#__PURE__*/ $5FkrB.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, innerProps, {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $970q7.default)([
            $56bf53657e0b15f4$var$multiValueLabelStyles.root,
            isDisabled && $56bf53657e0b15f4$var$multiValueLabelStyles.disabled,
            hasEllipsis && $56bf53657e0b15f4$var$multiValueLabelStyles.ellipsis,
            (0, $hUFig.cx)(className, xcss, '-MultiValueLabel')
        ])
    }), children);
};
var $56bf53657e0b15f4$var$disabledStyles = null;
var $56bf53657e0b15f4$var$enabledStyles = null;
function $56bf53657e0b15f4$export$8e1fd1a40e7a2f4a(_ref3) {
    var isDisabled = _ref3.isDisabled, isFocused = _ref3.isFocused, innerProps = _ref3.innerProps, className = _ref3.className, xcss = _ref3.xcss;
    return /*#__PURE__*/ $5FkrB.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, innerProps, {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $970q7.default)([
            $56bf53657e0b15f4$var$multiValueRemoveStyles.root,
            isFocused && $56bf53657e0b15f4$var$multiValueRemoveStyles.focused,
            (0, $hUFig.cx)(className, xcss, '-MultiValueRemove')
        ])
    }), /*#__PURE__*/ $5FkrB.createElement("div", {
        "data-testid": isDisabled ? 'hide-clear-icon' : 'show-clear-icon',
        className: (0, $970q7.default)([
            isDisabled && "_1e0cglyw",
            !isDisabled && "_1e0c1kw7"
        ])
    }, /*#__PURE__*/ $5FkrB.createElement((0, (/*@__PURE__*/$parcel$interopDefault($af87215eeccde75b$exports))), {
        label: "",
        color: "currentColor",
        size: "small"
    })));
}
var $56bf53657e0b15f4$var$MultiValue = function MultiValue(props) {
    var children = props.children, components = props.components, data = props.data, innerProps = props.innerProps, isDisabled = props.isDisabled, isFocused = props.isFocused, removeProps = props.removeProps, selectProps = props.selectProps, cropWithEllipsis = props.cropWithEllipsis;
    var Container = components.Container, Label = components.Label, Remove = components.Remove;
    var ariaLabel = typeof children === 'string' ? children : data.label;
    var _getStyleProps = (0, $27e7f6ca7209680a$export$26417cabd806a658)(props, 'multiValue', {
        'multi-value': true,
        'multi-value--is-disabled': isDisabled
    }), containerCss = _getStyleProps.css, containerClassName = _getStyleProps.className;
    var _getStyleProps2 = (0, $27e7f6ca7209680a$export$26417cabd806a658)(props, 'multiValueLabel', {
        'multi-value__label': true
    }), labelCss = _getStyleProps2.css, labelClassName = _getStyleProps2.className;
    var _getStyleProps3 = (0, $27e7f6ca7209680a$export$26417cabd806a658)(props, 'multiValueRemove', {
        'multi-value__remove': true
    }), removeCss = _getStyleProps3.css, removeClassName = _getStyleProps3.className;
    return /*#__PURE__*/ $5FkrB.createElement(Container, {
        data: data,
        innerProps: $56bf53657e0b15f4$var$_objectSpread({
            style: containerCss,
            className: containerClassName
        }, innerProps),
        className: containerClassName,
        isFocused: isFocused,
        isDisabled: isDisabled,
        selectProps: selectProps
    }, /*#__PURE__*/ $5FkrB.createElement(Label, {
        data: data,
        innerProps: {
            style: labelCss,
            className: labelClassName
        },
        className: labelClassName,
        hasEllipsis: cropWithEllipsis || cropWithEllipsis === undefined,
        selectProps: selectProps
    }, children), /*#__PURE__*/ $5FkrB.createElement(Remove, {
        data: data,
        innerProps: $56bf53657e0b15f4$var$_objectSpread({
            style: removeCss,
            className: removeClassName,
            role: 'button',
            tabIndex: -1,
            'aria-label': "".concat(ariaLabel || 'option', ", remove")
        }, removeProps),
        className: removeClassName,
        isDisabled: isDisabled,
        selectProps: selectProps
    }));
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$56bf53657e0b15f4$export$2e2bcd8739ae039 = $56bf53657e0b15f4$var$MultiValue;


/* option.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $kqp0i = parcelRequire("kqp0i");

var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");

var $hUFig = parcelRequire("hUFig");

var $615d38e48222e6b5$export$ef897119b7e920ba = function optionCSS() {
    return {};
};
var $615d38e48222e6b5$var$optionStyles = {
    root: "_1rjc12x7 _18zrutpp _syazi7uo _80om73ad _1e0c1ule _1wyb1kw7 _1bsb1osq _uiztglyw _18ql1j7p _1di6fcek",
    disabled: "_syaz1gmx _80om13gf _bfhk1j28 _16qsglyw _1di61j28 _112eglyw",
    focused: "_bfhk1dpa _16qs1x9r _112e5u6v",
    selected: "_syaz6x5g _bfhk15s3 _16qs1x9r _1di6nozp _112e5u6v",
    focusedSelected: "_bfhkufnl"
};
var $615d38e48222e6b5$var$Option = function Option(props) {
    var children = props.children, isDisabled = props.isDisabled, isFocused = props.isFocused, isSelected = props.isSelected, innerRef = props.innerRef, innerProps = props.innerProps, xcss = props.xcss;
    var _getStyleProps = (0, $27e7f6ca7209680a$export$26417cabd806a658)(props, 'option', {
        option: true,
        'option--is-disabled': isDisabled,
        'option--is-focused': isFocused,
        'option--is-selected': isSelected
    }), css = _getStyleProps.css, className = _getStyleProps.className;
    return /*#__PURE__*/ $5FkrB.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        className: (0, $970q7.default)([
            $615d38e48222e6b5$var$optionStyles.root,
            isFocused && $615d38e48222e6b5$var$optionStyles.focused,
            isSelected && $615d38e48222e6b5$var$optionStyles.selected,
            isFocused && isSelected && $615d38e48222e6b5$var$optionStyles.focusedSelected,
            isDisabled && $615d38e48222e6b5$var$optionStyles.disabled,
            (0, $hUFig.cx)(className, xcss, '-option')
        ]),
        ref: innerRef
    }, innerProps, {
        tabIndex: -1
    }), children);
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$615d38e48222e6b5$export$2e2bcd8739ae039 = $615d38e48222e6b5$var$Option;


/* placeholder.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $kqp0i = parcelRequire("kqp0i");

var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");

var $hUFig = parcelRequire("hUFig");

var $0db5d8fa4306e7a3$export$5f3ffacd6594d90f = function placeholderCSS() {
    return {};
};
var $0db5d8fa4306e7a3$var$placeholderStyles = {
    root: "_nd5l1sux _19pkidpf _2hwxv77o _otyridpf _18u0v77o _syaz1rpy",
    disabled: "_syaz1gmx"
};
var $0db5d8fa4306e7a3$var$Placeholder = function Placeholder(props) {
    var children = props.children, innerProps = props.innerProps, isDisabled = props.isDisabled, xcss = props.xcss;
    var _getStyleProps = (0, $27e7f6ca7209680a$export$26417cabd806a658)(props, 'placeholder', {
        placeholder: true
    }), css = _getStyleProps.css, className = _getStyleProps.className;
    return /*#__PURE__*/ $5FkrB.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        className: (0, $970q7.default)([
            $0db5d8fa4306e7a3$var$placeholderStyles.root,
            isDisabled && $0db5d8fa4306e7a3$var$placeholderStyles.disabled,
            (0, $hUFig.cx)(className, xcss, '-placeholder')
        ])
    }, innerProps), children);
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$0db5d8fa4306e7a3$export$2e2bcd8739ae039 = $0db5d8fa4306e7a3$var$Placeholder;


/* single-value.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $kqp0i = parcelRequire("kqp0i");

var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");

var $hUFig = parcelRequire("hUFig");

var $15b6a7a1d8e4c081$export$dbf350e5966cf602 = function css() {
    return {};
};
var $15b6a7a1d8e4c081$var$styles = {
    root: "_nd5l1sux _1reo15vq _18m915vq _p12f1osq _1bto1l2s _o5721q9c _19pkidpf _2hwxv77o _otyridpf _18u0v77o _syazi7uo",
    disalbed: "_syaz1gmx"
};
var $15b6a7a1d8e4c081$var$SingleValue = function SingleValue(props) {
    var children = props.children, isDisabled = props.isDisabled, innerProps = props.innerProps, xcss = props.xcss;
    var _getStyleProps = (0, $27e7f6ca7209680a$export$26417cabd806a658)(props, 'singleValue', {
        'single-value': true,
        'single-value--is-disabled': isDisabled
    }), css = _getStyleProps.css, className = _getStyleProps.className;
    return /*#__PURE__*/ $5FkrB.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        className: (0, $970q7.default)([
            $15b6a7a1d8e4c081$var$styles.root,
            isDisabled && $15b6a7a1d8e4c081$var$styles.disalbed,
            (0, $hUFig.cx)(className, xcss, '-singleValue')
        ])
    }, innerProps), children);
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$15b6a7a1d8e4c081$export$2e2bcd8739ae039 = $15b6a7a1d8e4c081$var$SingleValue;


function $eef74442e0ac473a$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $eef74442e0ac473a$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $eef74442e0ac473a$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $eef74442e0ac473a$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $eef74442e0ac473a$export$9b5ac10f59f76296 = {
    ClearIndicator: (0, $ecf42a684385bf78$export$ecf9cf59142dd54a),
    Control: (0, $27b5b8d4b6d6631c$export$2e2bcd8739ae039),
    DropdownIndicator: (0, $ecf42a684385bf78$export$ec98719d3db7f2e4),
    Group: (0, $846292368a23d009$export$2e2bcd8739ae039),
    GroupHeading: (0, $846292368a23d009$export$85c8b41a3cd87edc),
    IndicatorsContainer: (0, $c0f39bc847fa02f8$export$d0ffd7e649cab6f),
    Input: (0, $7bd4eb6f381d9e4c$export$2e2bcd8739ae039),
    LoadingIndicator: (0, $ecf42a684385bf78$export$7c20be4c1d342248),
    Menu: (0, $13242eb59811c5b2$export$2e2bcd8739ae039),
    MenuList: (0, $13242eb59811c5b2$export$d4c4e98c5044dc8),
    MenuPortal: (0, $13242eb59811c5b2$export$793392f970497feb),
    LoadingMessage: (0, $13242eb59811c5b2$export$e928a71d039d3102),
    NoOptionsMessage: (0, $13242eb59811c5b2$export$d58b72b7d3c4072c),
    MultiValue: (0, $56bf53657e0b15f4$export$2e2bcd8739ae039),
    MultiValueContainer: (0, $56bf53657e0b15f4$export$cf9cf2a30a59265c),
    MultiValueLabel: (0, $56bf53657e0b15f4$export$544aeea2a5ce08ee),
    MultiValueRemove: (0, $56bf53657e0b15f4$export$8e1fd1a40e7a2f4a),
    Option: (0, $615d38e48222e6b5$export$2e2bcd8739ae039),
    Placeholder: (0, $0db5d8fa4306e7a3$export$2e2bcd8739ae039),
    SelectContainer: (0, $c0f39bc847fa02f8$export$446eebadefe1123b),
    SingleValue: (0, $15b6a7a1d8e4c081$export$2e2bcd8739ae039),
    ValueContainer: (0, $c0f39bc847fa02f8$export$4dc9f58ad9a1a000)
};
var $eef74442e0ac473a$export$71abc632aa29e6fe = function defaultComponents(props) {
    return $eef74442e0ac473a$var$_objectSpread($eef74442e0ac473a$var$_objectSpread({}, $eef74442e0ac473a$export$9b5ac10f59f76296), props.components);
};


/* dummy-input.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $kqp0i = parcelRequire("kqp0i");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");

var $0fcd7b315b703ebc$var$_excluded = [
    "innerRef"
];
var $0fcd7b315b703ebc$var$dummyInputStyles = null;
function $0fcd7b315b703ebc$export$2e2bcd8739ae039(_ref) {
    var innerRef = _ref.innerRef, props = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $0fcd7b315b703ebc$var$_excluded);
    // Remove animation props not meant for HTML elements
    var filteredProps = (0, $27e7f6ca7209680a$export$4213b25a1c4e877)(props, 'onExited', 'in', 'enter', 'exit', 'appear');
    // eslint-disable-next-line  @atlaskit/ui-styling-standard/no-classname-prop
    return /*#__PURE__*/ $5FkrB.createElement("input", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        ref: innerRef,
        className: (0, $970q7.default)([
            "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _11q7idpf _19itidpf _nd5l1sux _12ji1r31 _1qu2glyw _12y3idpf _1bsbt94y _kqswh2mm _1n5d1j28 _syaz1j28 _1e02p1rm _tzy4idpf _t9ec1kuz",
            "-dummyInput"
        ])
    }, filteredProps));
}

/* required-input.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");

var $eVb4V = parcelRequire("eVb4V");
var $545436dadbd2bc6f$var$styles = null;
var $545436dadbd2bc6f$var$RequiredInput = function RequiredInput(_ref) {
    var name = _ref.name, onFocus = _ref.onFocus;
    return /*#__PURE__*/ $5FkrB.createElement("input", {
        required: true,
        name: name,
        tabIndex: -1,
        "aria-hidden": "true",
        className: (0, $970q7.default)([
            "_1bsb1osq _kqswstnw _u7coidpf _rjxpidpf _1e02idpf _tzy4idpf _lcxvglyw",
            "-requiredInput"
        ]),
        onFocus: onFocus,
        // Prevent `Switching from uncontrolled to controlled` error
        value: "",
        onChange: (0, $eVb4V.default)
    });
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$545436dadbd2bc6f$export$2e2bcd8739ae039 = $545436dadbd2bc6f$var$RequiredInput;


var $5FkrB = parcelRequire("5FkrB");

var $5FkrB = parcelRequire("5FkrB");

var $4219590b2e2b9bd3$var$cancelScroll = function cancelScroll(event) {
    if (event.cancelable) event.preventDefault();
    event.stopPropagation();
};
function $4219590b2e2b9bd3$export$2e2bcd8739ae039(_ref) {
    var isEnabled = _ref.isEnabled, onBottomArrive = _ref.onBottomArrive, onBottomLeave = _ref.onBottomLeave, onTopArrive = _ref.onTopArrive, onTopLeave = _ref.onTopLeave;
    var isBottom = (0, $5FkrB.useRef)(false);
    var isTop = (0, $5FkrB.useRef)(false);
    var touchStart = (0, $5FkrB.useRef)(0);
    var scrollTarget = (0, $5FkrB.useRef)(null);
    var handleEventDelta = (0, $5FkrB.useCallback)(function(event, delta) {
        if (scrollTarget.current === null) return;
        var _scrollTarget$current = scrollTarget.current, scrollTop = _scrollTarget$current.scrollTop, scrollHeight = _scrollTarget$current.scrollHeight, clientHeight = _scrollTarget$current.clientHeight;
        var target = scrollTarget.current;
        var isDeltaPositive = delta > 0;
        var availableScroll = scrollHeight - clientHeight - scrollTop;
        var shouldCancelScroll = false;
        // reset bottom/top flags
        if (availableScroll > delta && isBottom.current) {
            if (onBottomLeave) onBottomLeave(event);
            isBottom.current = false;
        }
        if (isDeltaPositive && isTop.current) {
            if (onTopLeave) onTopLeave(event);
            isTop.current = false;
        }
        // bottom limit
        if (isDeltaPositive && delta > availableScroll) {
            if (onBottomArrive && !isBottom.current) onBottomArrive(event);
            target.scrollTop = scrollHeight;
            shouldCancelScroll = true;
            isBottom.current = true;
        // top limit
        } else if (!isDeltaPositive && -delta > scrollTop) {
            if (onTopArrive && !isTop.current) onTopArrive(event);
            target.scrollTop = 0;
            shouldCancelScroll = true;
            isTop.current = true;
        }
        // cancel scroll
        if (shouldCancelScroll) $4219590b2e2b9bd3$var$cancelScroll(event);
    }, [
        onBottomArrive,
        onBottomLeave,
        onTopArrive,
        onTopLeave
    ]);
    var onWheel = (0, $5FkrB.useCallback)(function(event) {
        handleEventDelta(event, event.deltaY);
    }, [
        handleEventDelta
    ]);
    var onTouchStart = (0, $5FkrB.useCallback)(function(event) {
        // set touch start so we can calculate touchmove delta
        touchStart.current = event.changedTouches[0].clientY;
    }, []);
    var onTouchMove = (0, $5FkrB.useCallback)(function(event) {
        var deltaY = touchStart.current - event.changedTouches[0].clientY;
        handleEventDelta(event, deltaY);
    }, [
        handleEventDelta
    ]);
    var startListening = (0, $5FkrB.useCallback)(function(el) {
        // bail early if no element is available to attach to
        if (!el) return;
        var notPassive = (0, $27e7f6ca7209680a$export$b0622a6911dbeaf5) ? {
            passive: false
        } : false;
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        el.addEventListener('wheel', onWheel, notPassive);
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        el.addEventListener('touchstart', onTouchStart, notPassive);
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        el.addEventListener('touchmove', onTouchMove, notPassive);
    }, [
        onTouchMove,
        onTouchStart,
        onWheel
    ]);
    var stopListening = (0, $5FkrB.useCallback)(function(el) {
        // bail early if no element is available to detach from
        if (!el) return;
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        el.removeEventListener('wheel', onWheel, false);
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        el.removeEventListener('touchstart', onTouchStart, false);
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        el.removeEventListener('touchmove', onTouchMove, false);
    }, [
        onTouchMove,
        onTouchStart,
        onWheel
    ]);
    (0, $5FkrB.useEffect)(function() {
        if (!isEnabled) return;
        var element = scrollTarget.current;
        startListening(element);
        return function() {
            stopListening(element);
        };
    }, [
        isEnabled,
        startListening,
        stopListening
    ]);
    return function(element) {
        scrollTarget.current = element;
    };
}



var $5FkrB = parcelRequire("5FkrB");
var $439a8ca4ac3b22de$var$STYLE_KEYS = [
    'boxSizing',
    'height',
    'overflow',
    'paddingRight',
    'position'
];
var $439a8ca4ac3b22de$var$LOCK_STYLES = {
    boxSizing: 'border-box',
    // account for possible declaration `width: 100%;` on body
    overflow: 'hidden',
    position: 'relative',
    height: '100%'
};
function $439a8ca4ac3b22de$var$preventTouchMove(e) {
    e.preventDefault();
}
function $439a8ca4ac3b22de$var$allowTouchMove(e) {
    e.stopPropagation();
}
function $439a8ca4ac3b22de$var$preventInertiaScroll() {
    var top = this.scrollTop;
    var totalScroll = this.scrollHeight;
    var currentScroll = top + this.offsetHeight;
    if (top === 0) this.scrollTop = 1;
    else if (currentScroll === totalScroll) this.scrollTop = top - 1;
}
// `ontouchstart` check works on most browsers
// `maxTouchPoints` works on IE10/11 and Surface
function $439a8ca4ac3b22de$var$isTouchDevice() {
    return 'ontouchstart' in window || navigator.maxTouchPoints;
}
var $439a8ca4ac3b22de$var$canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
var $439a8ca4ac3b22de$var$activeScrollLocks = 0;
var $439a8ca4ac3b22de$var$listenerOptions = {
    capture: false,
    passive: false
};
function $439a8ca4ac3b22de$export$2e2bcd8739ae039(_ref) {
    var isEnabled = _ref.isEnabled, _ref$accountForScroll = _ref.accountForScrollbars, accountForScrollbars = _ref$accountForScroll === void 0 ? true : _ref$accountForScroll;
    var originalStyles = (0, $5FkrB.useRef)({});
    var scrollTarget = (0, $5FkrB.useRef)(null);
    var addScrollLock = (0, $5FkrB.useCallback)(function(touchScrollTarget) {
        if (!$439a8ca4ac3b22de$var$canUseDOM) return;
        var target = document.body;
        var targetStyle = target && target.style;
        if (accountForScrollbars) // store any styles already applied to the body
        $439a8ca4ac3b22de$var$STYLE_KEYS.forEach(function(key) {
            var val = targetStyle && targetStyle[key];
            originalStyles.current[key] = val;
        });
        // apply the lock styles and padding if this is the first scroll lock
        if (accountForScrollbars && $439a8ca4ac3b22de$var$activeScrollLocks < 1) {
            var currentPadding = parseInt(originalStyles.current.paddingRight, 10) || 0;
            var clientWidth = document.body ? document.body.clientWidth : 0;
            var adjustedPadding = window.innerWidth - clientWidth + currentPadding || 0;
            Object.keys($439a8ca4ac3b22de$var$LOCK_STYLES).forEach(function(key) {
                var val = $439a8ca4ac3b22de$var$LOCK_STYLES[key];
                if (targetStyle) targetStyle[key] = val;
            });
            if (targetStyle) targetStyle.paddingRight = "".concat(adjustedPadding, "px");
        }
        // account for touch devices
        if (target && $439a8ca4ac3b22de$var$isTouchDevice()) {
            // Mobile Safari ignores { overflow: hidden } declaration on the body.
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            target.addEventListener('touchmove', $439a8ca4ac3b22de$var$preventTouchMove, $439a8ca4ac3b22de$var$listenerOptions);
            // Allow scroll on provided target
            if (touchScrollTarget) {
                // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                touchScrollTarget.addEventListener('touchstart', $439a8ca4ac3b22de$var$preventInertiaScroll, $439a8ca4ac3b22de$var$listenerOptions);
                // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                touchScrollTarget.addEventListener('touchmove', $439a8ca4ac3b22de$var$allowTouchMove, $439a8ca4ac3b22de$var$listenerOptions);
            }
        }
        // increment active scroll locks
        $439a8ca4ac3b22de$var$activeScrollLocks += 1;
    }, [
        accountForScrollbars
    ]);
    var removeScrollLock = (0, $5FkrB.useCallback)(function(touchScrollTarget) {
        if (!$439a8ca4ac3b22de$var$canUseDOM) return;
        var target = document.body;
        var targetStyle = target && target.style;
        // safely decrement active scroll locks
        $439a8ca4ac3b22de$var$activeScrollLocks = Math.max($439a8ca4ac3b22de$var$activeScrollLocks - 1, 0);
        // reapply original body styles, if any
        if (accountForScrollbars && $439a8ca4ac3b22de$var$activeScrollLocks < 1) $439a8ca4ac3b22de$var$STYLE_KEYS.forEach(function(key) {
            var val = originalStyles.current[key];
            if (targetStyle) targetStyle[key] = val;
        });
        // remove touch listeners
        if (target && $439a8ca4ac3b22de$var$isTouchDevice()) {
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            target.removeEventListener('touchmove', $439a8ca4ac3b22de$var$preventTouchMove, $439a8ca4ac3b22de$var$listenerOptions);
            if (touchScrollTarget) {
                // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                touchScrollTarget.removeEventListener('touchstart', $439a8ca4ac3b22de$var$preventInertiaScroll, $439a8ca4ac3b22de$var$listenerOptions);
                // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                touchScrollTarget.removeEventListener('touchmove', $439a8ca4ac3b22de$var$allowTouchMove, $439a8ca4ac3b22de$var$listenerOptions);
            }
        }
    }, [
        accountForScrollbars
    ]);
    (0, $5FkrB.useEffect)(function() {
        if (!isEnabled) return;
        var element = scrollTarget.current;
        addScrollLock(element);
        return function() {
            removeScrollLock(element);
        };
    }, [
        isEnabled,
        addScrollLock,
        removeScrollLock
    ]);
    return function(element) {
        scrollTarget.current = element;
    };
}


var $1405968ad37a8a1b$var$blurSelectInput = function blurSelectInput(event) {
    var element = event.target;
    return element.ownerDocument.activeElement && element.ownerDocument.activeElement.blur();
};
function $1405968ad37a8a1b$export$2e2bcd8739ae039(_ref) {
    var children = _ref.children, lockEnabled = _ref.lockEnabled, _ref$captureEnabled = _ref.captureEnabled, captureEnabled = _ref$captureEnabled === void 0 ? true : _ref$captureEnabled, onBottomArrive = _ref.onBottomArrive, onBottomLeave = _ref.onBottomLeave, onTopArrive = _ref.onTopArrive, onTopLeave = _ref.onTopLeave;
    var setScrollCaptureTarget = (0, $4219590b2e2b9bd3$export$2e2bcd8739ae039)({
        isEnabled: captureEnabled,
        onBottomArrive: onBottomArrive,
        onBottomLeave: onBottomLeave,
        onTopArrive: onTopArrive,
        onTopLeave: onTopLeave
    });
    var setScrollLockTarget = (0, $439a8ca4ac3b22de$export$2e2bcd8739ae039)({
        isEnabled: lockEnabled
    });
    var targetRef = function targetRef(element) {
        setScrollCaptureTarget(element);
        setScrollLockTarget(element);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $5FkrB.Fragment), null, lockEnabled && /*#__PURE__*/ // eslint-disable-next-line @atlassian/a11y/click-events-have-key-events, @atlassian/a11y/interactive-element-not-keyboard-focusable, @atlassian/a11y/no-static-element-interactions
    (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("div", {
        onClick: $1405968ad37a8a1b$var$blurSelectInput,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            position: 'fixed',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            insetBlockEnd: 0,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            insetBlockStart: 0,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            insetInlineEnd: 0,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            insetInlineStart: 0
        }
    }), children(targetRef));
}



var $iUCre = parcelRequire("iUCre");
function $146caa2c2bee098b$export$17baa7c95b6ba1b8(_ref) {
    var isOpen = _ref.isOpen, onClose = _ref.onClose;
    // @ts-ignore - hot-116676
    (0, $iUCre.useNotifyOpenLayerObserver)({
        isOpen: isOpen,
        onClose: onClose
    });
    return null;
}



var $25nEq = parcelRequire("25nEq");

var $5FkrB = parcelRequire("5FkrB");
var $9dabf209849ee95b$export$a7265767c78f9bae = {
    onChange: function onChange(props) {
        var action = props.action, _props$label = props.label, label = _props$label === void 0 ? '' : _props$label, isDisabled = props.isDisabled;
        switch(action){
            case 'deselect-option':
            case 'pop-value':
            case 'remove-value':
                return label.length ? "option ".concat(label, ", deselected") : '';
            case 'clear':
                return 'All selected options have been cleared.';
            case 'select-option':
                return label.length && !isDisabled ? "option ".concat(label, ", selected.") : '';
            default:
                return '';
        }
    },
    onFilter: function onFilter(props) {
        var inputValue = props.inputValue, resultsMessage = props.resultsMessage;
        return inputValue ? "".concat(resultsMessage, " for search term ").concat(inputValue, ".") : '';
    }
};


/* a11y-text.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $kqp0i = parcelRequire("kqp0i");

var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");
// Assistive text to describe visual elements. Hidden for sighted users.
var $b70286700f6c1630$var$styles = null;
var $b70286700f6c1630$var$A11yText = function A11yText(props) {
    return /*#__PURE__*/ $5FkrB.createElement("span", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        // eslint-disable-next-line  @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $970q7.default)([
            "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19itidpf _1reo15vq _18m915vq _1bsbt94y _4t3it94y _kqswstnw _1pbydx66 _ogto7mnp _uiztglyw _o5721q9c",
            "-a11yText"
        ])
    }, props));
};
var $b70286700f6c1630$export$2e2bcd8739ae039 = $b70286700f6c1630$var$A11yText;


function $3ed34eec60e5eb84$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $3ed34eec60e5eb84$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $3ed34eec60e5eb84$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $3ed34eec60e5eb84$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
// ==============================
// Root Container
// ==============================
var $3ed34eec60e5eb84$var$LiveRegion = function LiveRegion(props) {
    var ariaSelection = props.ariaSelection, focusableOptions = props.focusableOptions, isFocused = props.isFocused, selectValue = props.selectValue, selectProps = props.selectProps, id = props.id;
    var ariaLiveMessages = selectProps.ariaLiveMessages, getOptionLabel = selectProps.getOptionLabel, inputValue = selectProps.inputValue, isOptionDisabled = selectProps.isOptionDisabled, menuIsOpen = selectProps.menuIsOpen, options = selectProps.options, screenReaderStatus = selectProps.screenReaderStatus, isLoading = selectProps.isLoading;
    var ariaLive = selectProps['aria-live'];
    // Update aria live message configuration when prop changes
    var messages = (0, $5FkrB.useMemo)(function() {
        return $3ed34eec60e5eb84$var$_objectSpread($3ed34eec60e5eb84$var$_objectSpread({}, (0, $9dabf209849ee95b$export$a7265767c78f9bae)), ariaLiveMessages || {});
    }, [
        ariaLiveMessages
    ]);
    // Update aria live selected option when prop changes
    var ariaSelected = (0, $5FkrB.useMemo)(function() {
        var message = '';
        if (menuIsOpen) // we don't need to have selected message when the menu is open
        return '';
        if (ariaSelection && messages.onChange) {
            var option = ariaSelection.option, selectedOptions = ariaSelection.options, removedValue = ariaSelection.removedValue, removedValues = ariaSelection.removedValues, value = ariaSelection.value;
            // select-option when !isMulti does not return option so we assume selected option is value
            var asOption = function asOption(val) {
                return !Array.isArray(val) ? val : null;
            };
            // If there is just one item from the action then get its label
            var selected = removedValue || option || asOption(value);
            var label = selected ? getOptionLabel(selected) : '';
            // If there are multiple items from the action then return an array of labels
            var multiSelected = selectedOptions || removedValues || undefined;
            var labels = multiSelected ? multiSelected.map(getOptionLabel) : [];
            if (!label && !labels.length) // return empty string if no labels provided
            return '';
            var onChangeProps = $3ed34eec60e5eb84$var$_objectSpread({
                // multiSelected items are usually items that have already been selected
                // or set by the user as a default value so we assume they are not disabled
                isDisabled: selected && isOptionDisabled(selected, selectValue),
                label: label,
                labels: labels
            }, ariaSelection);
            message = messages.onChange(onChangeProps);
        }
        return message;
    }, [
        ariaSelection,
        messages,
        isOptionDisabled,
        selectValue,
        getOptionLabel,
        menuIsOpen
    ]);
    var ariaResults = (0, $5FkrB.useMemo)(function() {
        var resultsMsg = '';
        if (isLoading) resultsMsg = 'Loading. ';
        if (menuIsOpen && options.length && !isLoading && messages.onFilter) {
            var resultsMessage = screenReaderStatus({
                count: focusableOptions.length
            });
            resultsMsg = messages.onFilter({
                inputValue: inputValue,
                resultsMessage: resultsMessage
            });
        }
        if (options && options.length === 0) resultsMsg = 'No options. ';
        return resultsMsg;
    }, [
        focusableOptions,
        inputValue,
        menuIsOpen,
        messages,
        options,
        screenReaderStatus,
        isLoading
    ]);
    var isInitialFocus = (ariaSelection === null || ariaSelection === void 0 ? void 0 : ariaSelection.action) === 'initial-input-focus';
    var ScreenReaderText = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $5FkrB.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("span", {
        id: "aria-selection"
    }, ariaSelected), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("span", {
        id: "aria-results"
    }, ariaResults));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $5FkrB.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $b70286700f6c1630$export$2e2bcd8739ae039), {
        id: id
    }, isInitialFocus && ScreenReaderText), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $b70286700f6c1630$export$2e2bcd8739ae039), {
        "aria-live": ariaLive // Should be undefined by default unless a specific use case requires it
        ,
        role: "status"
    }, isFocused && !isInitialFocus && ScreenReaderText));
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$3ed34eec60e5eb84$export$2e2bcd8739ae039 = $3ed34eec60e5eb84$var$LiveRegion;




var $25nEq = parcelRequire("25nEq");

var $cvlyC = parcelRequire("cvlyC");
var $fb3a803afa7de967$var$diacritics = [
    {
        base: 'A',
        letters: "A\u24B6\uFF21\xC0\xC1\xC2\u1EA6\u1EA4\u1EAA\u1EA8\xC3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\xC4\u01DE\u1EA2\xC5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F"
    },
    {
        base: 'AA',
        letters: "\uA732"
    },
    {
        base: 'AE',
        letters: "\xC6\u01FC\u01E2"
    },
    {
        base: 'AO',
        letters: "\uA734"
    },
    {
        base: 'AU',
        letters: "\uA736"
    },
    {
        base: 'AV',
        letters: "\uA738\uA73A"
    },
    {
        base: 'AY',
        letters: "\uA73C"
    },
    {
        base: 'B',
        letters: "B\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181"
    },
    {
        base: 'C',
        letters: "C\u24B8\uFF23\u0106\u0108\u010A\u010C\xC7\u1E08\u0187\u023B\uA73E"
    },
    {
        base: 'D',
        letters: "D\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779"
    },
    {
        base: 'DZ',
        letters: "\u01F1\u01C4"
    },
    {
        base: 'Dz',
        letters: "\u01F2\u01C5"
    },
    {
        base: 'E',
        letters: "E\u24BA\uFF25\xC8\xC9\xCA\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\xCB\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E"
    },
    {
        base: 'F',
        letters: "F\u24BB\uFF26\u1E1E\u0191\uA77B"
    },
    {
        base: 'G',
        letters: "G\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E"
    },
    {
        base: 'H',
        letters: "H\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D"
    },
    {
        base: 'I',
        letters: "I\u24BE\uFF29\xCC\xCD\xCE\u0128\u012A\u012C\u0130\xCF\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197"
    },
    {
        base: 'J',
        letters: "J\u24BF\uFF2A\u0134\u0248"
    },
    {
        base: 'K',
        letters: "K\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2"
    },
    {
        base: 'L',
        letters: "L\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780"
    },
    {
        base: 'LJ',
        letters: "\u01C7"
    },
    {
        base: 'Lj',
        letters: "\u01C8"
    },
    {
        base: 'M',
        letters: "M\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C"
    },
    {
        base: 'N',
        letters: "N\u24C3\uFF2E\u01F8\u0143\xD1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4"
    },
    {
        base: 'NJ',
        letters: "\u01CA"
    },
    {
        base: 'Nj',
        letters: "\u01CB"
    },
    {
        base: 'O',
        letters: "O\u24C4\uFF2F\xD2\xD3\xD4\u1ED2\u1ED0\u1ED6\u1ED4\xD5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\xD6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\xD8\u01FE\u0186\u019F\uA74A\uA74C"
    },
    {
        base: 'OI',
        letters: "\u01A2"
    },
    {
        base: 'OO',
        letters: "\uA74E"
    },
    {
        base: 'OU',
        letters: "\u0222"
    },
    {
        base: 'P',
        letters: "P\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754"
    },
    {
        base: 'Q',
        letters: "Q\u24C6\uFF31\uA756\uA758\u024A"
    },
    {
        base: 'R',
        letters: "R\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782"
    },
    {
        base: 'S',
        letters: "S\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784"
    },
    {
        base: 'T',
        letters: "T\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786"
    },
    {
        base: 'TZ',
        letters: "\uA728"
    },
    {
        base: 'U',
        letters: "U\u24CA\uFF35\xD9\xDA\xDB\u0168\u1E78\u016A\u1E7A\u016C\xDC\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244"
    },
    {
        base: 'V',
        letters: "V\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245"
    },
    {
        base: 'VY',
        letters: "\uA760"
    },
    {
        base: 'W',
        letters: "W\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72"
    },
    {
        base: 'X',
        letters: "X\u24CD\uFF38\u1E8A\u1E8C"
    },
    {
        base: 'Y',
        letters: "Y\u24CE\uFF39\u1EF2\xDD\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE"
    },
    {
        base: 'Z',
        letters: "Z\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762"
    },
    {
        base: 'a',
        letters: "a\u24D0\uFF41\u1E9A\xE0\xE1\xE2\u1EA7\u1EA5\u1EAB\u1EA9\xE3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\xE4\u01DF\u1EA3\xE5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250"
    },
    {
        base: 'aa',
        letters: "\uA733"
    },
    {
        base: 'ae',
        letters: "\xE6\u01FD\u01E3"
    },
    {
        base: 'ao',
        letters: "\uA735"
    },
    {
        base: 'au',
        letters: "\uA737"
    },
    {
        base: 'av',
        letters: "\uA739\uA73B"
    },
    {
        base: 'ay',
        letters: "\uA73D"
    },
    {
        base: 'b',
        letters: "b\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253"
    },
    {
        base: 'c',
        letters: "c\u24D2\uFF43\u0107\u0109\u010B\u010D\xE7\u1E09\u0188\u023C\uA73F\u2184"
    },
    {
        base: 'd',
        letters: "d\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A"
    },
    {
        base: 'dz',
        letters: "\u01F3\u01C6"
    },
    {
        base: 'e',
        letters: "e\u24D4\uFF45\xE8\xE9\xEA\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\xEB\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD"
    },
    {
        base: 'f',
        letters: "f\u24D5\uFF46\u1E1F\u0192\uA77C"
    },
    {
        base: 'g',
        letters: "g\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F"
    },
    {
        base: 'h',
        letters: "h\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265"
    },
    {
        base: 'hv',
        letters: "\u0195"
    },
    {
        base: 'i',
        letters: "i\u24D8\uFF49\xEC\xED\xEE\u0129\u012B\u012D\xEF\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131"
    },
    {
        base: 'j',
        letters: "j\u24D9\uFF4A\u0135\u01F0\u0249"
    },
    {
        base: 'k',
        letters: "k\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3"
    },
    {
        base: 'l',
        letters: "l\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747"
    },
    {
        base: 'lj',
        letters: "\u01C9"
    },
    {
        base: 'm',
        letters: "m\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F"
    },
    {
        base: 'n',
        letters: "n\u24DD\uFF4E\u01F9\u0144\xF1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5"
    },
    {
        base: 'nj',
        letters: "\u01CC"
    },
    {
        base: 'o',
        letters: "o\u24DE\uFF4F\xF2\xF3\xF4\u1ED3\u1ED1\u1ED7\u1ED5\xF5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\xF6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\xF8\u01FF\u0254\uA74B\uA74D\u0275"
    },
    {
        base: 'oi',
        letters: "\u01A3"
    },
    {
        base: 'ou',
        letters: "\u0223"
    },
    {
        base: 'oo',
        letters: "\uA74F"
    },
    {
        base: 'p',
        letters: "p\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755"
    },
    {
        base: 'q',
        letters: "q\u24E0\uFF51\u024B\uA757\uA759"
    },
    {
        base: 'r',
        letters: "r\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783"
    },
    {
        base: 's',
        letters: "s\u24E2\uFF53\xDF\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B"
    },
    {
        base: 't',
        letters: "t\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787"
    },
    {
        base: 'tz',
        letters: "\uA729"
    },
    {
        base: 'u',
        letters: "u\u24E4\uFF55\xF9\xFA\xFB\u0169\u1E79\u016B\u1E7B\u016D\xFC\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289"
    },
    {
        base: 'v',
        letters: "v\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C"
    },
    {
        base: 'vy',
        letters: "\uA761"
    },
    {
        base: 'w',
        letters: "w\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73"
    },
    {
        base: 'x',
        letters: "x\u24E7\uFF58\u1E8B\u1E8D"
    },
    {
        base: 'y',
        letters: "y\u24E8\uFF59\u1EF3\xFD\u0177\u1EF9\u0233\u1E8F\xFF\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF"
    },
    {
        base: 'z',
        letters: "z\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763"
    }
];
var $fb3a803afa7de967$var$anyDiacritic = new RegExp('[' + $fb3a803afa7de967$var$diacritics.map(function(d) {
    return d.letters;
}).join('') + ']', 'g');
var $fb3a803afa7de967$var$diacriticToBase = {};
for(var $fb3a803afa7de967$var$i = 0; $fb3a803afa7de967$var$i < $fb3a803afa7de967$var$diacritics.length; $fb3a803afa7de967$var$i++){
    var $fb3a803afa7de967$var$diacritic = $fb3a803afa7de967$var$diacritics[$fb3a803afa7de967$var$i];
    for(var $fb3a803afa7de967$var$j = 0; $fb3a803afa7de967$var$j < $fb3a803afa7de967$var$diacritic.letters.length; $fb3a803afa7de967$var$j++)$fb3a803afa7de967$var$diacriticToBase[$fb3a803afa7de967$var$diacritic.letters[$fb3a803afa7de967$var$j]] = $fb3a803afa7de967$var$diacritic.base;
}
var $fb3a803afa7de967$export$b5bee4b27048330b = function stripDiacritics(str) {
    return str.replace($fb3a803afa7de967$var$anyDiacritic, function(match) {
        return $fb3a803afa7de967$var$diacriticToBase[match];
    });
};


function $8a62cf442824743d$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $8a62cf442824743d$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $8a62cf442824743d$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $8a62cf442824743d$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $8a62cf442824743d$var$memoizedStripDiacriticsForInput = (0, $cvlyC.default)((0, $fb3a803afa7de967$export$b5bee4b27048330b));
var $8a62cf442824743d$var$trimString = function trimString(str) {
    return str.replace(/^\s+|\s+$/g, '');
};
var $8a62cf442824743d$var$defaultStringify = function defaultStringify(option) {
    return "".concat(option.label, " ").concat(option.value);
};
var $8a62cf442824743d$export$5d81789ff4aeccdf = function createFilter(config) {
    return function(option, rawInput) {
        if (option.data.__isNew__) return true;
        var _ignoreCase$ignoreAcc = $8a62cf442824743d$var$_objectSpread({
            ignoreCase: true,
            ignoreAccents: true,
            stringify: $8a62cf442824743d$var$defaultStringify,
            trim: true,
            matchFrom: 'any'
        }, config), ignoreCase = _ignoreCase$ignoreAcc.ignoreCase, ignoreAccents = _ignoreCase$ignoreAcc.ignoreAccents, stringify = _ignoreCase$ignoreAcc.stringify, trim = _ignoreCase$ignoreAcc.trim, matchFrom = _ignoreCase$ignoreAcc.matchFrom;
        var input = trim ? $8a62cf442824743d$var$trimString(rawInput) : rawInput;
        var candidate = trim ? $8a62cf442824743d$var$trimString(stringify(option)) : stringify(option);
        if (ignoreCase) {
            input = input.toLowerCase();
            candidate = candidate.toLowerCase();
        }
        if (ignoreAccents) {
            input = $8a62cf442824743d$var$memoizedStripDiacriticsForInput(input);
            candidate = (0, $fb3a803afa7de967$export$b5bee4b27048330b)(candidate);
        }
        return matchFrom === 'start' ? candidate.substr(0, input.length) === input : candidate.indexOf(input) > -1;
    };
};



var $25nEq = parcelRequire("25nEq");










function $fc64564d6dbd70b3$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $fc64564d6dbd70b3$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $fc64564d6dbd70b3$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $fc64564d6dbd70b3$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $fc64564d6dbd70b3$export$214b055320e0bf32 = {
    clearIndicator: (0, $ecf42a684385bf78$export$9c0419fd944c1def),
    container: (0, $c0f39bc847fa02f8$export$949392aeaf7d2e3a),
    control: (0, $27b5b8d4b6d6631c$export$dbf350e5966cf602),
    dropdownIndicator: (0, $ecf42a684385bf78$export$e1687335805e1230),
    group: (0, $846292368a23d009$export$b6794329c1460634),
    groupHeading: (0, $846292368a23d009$export$e5a7fbb542efcb7d),
    indicatorsContainer: (0, $c0f39bc847fa02f8$export$9d74e3c8b5868ad7),
    input: (0, $7bd4eb6f381d9e4c$export$14a7781d0ca7abea),
    loadingIndicator: (0, $ecf42a684385bf78$export$1d3f24cde248e6b5),
    loadingMessage: (0, $13242eb59811c5b2$export$98ec46397a8cb3cd),
    menu: (0, $13242eb59811c5b2$export$a228922d5ca42a79),
    menuList: (0, $13242eb59811c5b2$export$abafed69cff95d5e),
    menuPortal: (0, $13242eb59811c5b2$export$1dbbeb9648d1fdc9),
    multiValue: (0, $56bf53657e0b15f4$export$23c213f7717186af),
    multiValueLabel: (0, $56bf53657e0b15f4$export$f40612612e0af964),
    multiValueRemove: (0, $56bf53657e0b15f4$export$283467f6c4ac142b),
    noOptionsMessage: (0, $13242eb59811c5b2$export$cf0e22534d8b0074),
    option: (0, $615d38e48222e6b5$export$ef897119b7e920ba),
    placeholder: (0, $0db5d8fa4306e7a3$export$5f3ffacd6594d90f),
    singleValue: (0, $15b6a7a1d8e4c081$export$dbf350e5966cf602),
    valueContainer: (0, $c0f39bc847fa02f8$export$47aec73c7aa6b9aa)
};
function $fc64564d6dbd70b3$export$e618dc39ac9ad607(source) {
    var target = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    // initialize with source styles
    var styles = $fc64564d6dbd70b3$var$_objectSpread({}, source);
    // massage in target styles
    Object.keys(target).forEach(function(keyAsString) {
        var key = keyAsString;
        if (source[key]) styles[key] = function(rsCss, props) {
            return target[key](source[key](rsCss, props), props);
        };
        else styles[key] = target[key];
    });
    return styles;
}



function $1b50e9ea35e97ef8$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $1b50e9ea35e97ef8$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $1b50e9ea35e97ef8$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $1b50e9ea35e97ef8$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $1b50e9ea35e97ef8$var$_callSuper(t, o, e) {
    return o = (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(o), (0, (/*@__PURE__*/$parcel$interopDefault($kIXpt)))(t, $1b50e9ea35e97ef8$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(t).constructor) : o.apply(t, e));
}
function $1b50e9ea35e97ef8$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($1b50e9ea35e97ef8$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $1b50e9ea35e97ef8$export$9c21a3269931e1e6 = {
    backspaceRemovesValue: true,
    blurInputOnSelect: (0, $27e7f6ca7209680a$export$56963d77dbffdde7)(),
    captureMenuScroll: !(0, $27e7f6ca7209680a$export$56963d77dbffdde7)(),
    classNames: {},
    closeMenuOnSelect: true,
    closeMenuOnScroll: false,
    components: {},
    controlShouldRenderValue: true,
    escapeClearsValue: false,
    filterOption: (0, $8a62cf442824743d$export$5d81789ff4aeccdf)(),
    formatGroupLabel: (0, $ca89d9b058c99608$export$f4da216a6ca54656),
    getOptionLabel: (0, $ca89d9b058c99608$export$dac6ace3020563ca),
    getOptionValue: (0, $ca89d9b058c99608$export$40be908210c5a79c),
    isDisabled: false,
    isLoading: false,
    isMulti: false,
    isRtl: false,
    isSearchable: true,
    isOptionDisabled: (0, $ca89d9b058c99608$export$56bd0c8d90db075),
    loadingMessage: function loadingMessage() {
        return 'Loading...';
    },
    maxMenuHeight: 300,
    minMenuHeight: 140,
    menuIsOpen: false,
    menuPlacement: 'bottom',
    menuPosition: 'absolute',
    menuShouldBlockScroll: false,
    menuShouldScrollIntoView: !(0, $27e7f6ca7209680a$export$44f917bf91becd01)(),
    noOptionsMessage: function noOptionsMessage() {
        return 'No options';
    },
    openMenuOnFocus: false,
    openMenuOnClick: true,
    shouldPreventEscapePropagation: false,
    options: [],
    pageSize: 5,
    placeholder: 'Select...',
    screenReaderStatus: function screenReaderStatus(_ref) {
        var count = _ref.count;
        return "".concat(count, " result").concat(count !== 1 ? 's' : '', " available");
    },
    styles: {},
    tabIndex: 0,
    tabSelectsValue: true,
    UNSAFE_is_experimental_generic: false,
    shouldKeepInputOnSelect: false
};
function $1b50e9ea35e97ef8$var$toCategorizedOption(props, option, selectValue, index) {
    var isDisabled = $1b50e9ea35e97ef8$var$_isOptionDisabled(props, option, selectValue);
    var isSelected = $1b50e9ea35e97ef8$var$_isOptionSelected(props, option, selectValue);
    var label = $1b50e9ea35e97ef8$var$getOptionLabel(props, option);
    var value = $1b50e9ea35e97ef8$var$getOptionValue(props, option);
    return {
        type: 'option',
        data: option,
        isDisabled: isDisabled,
        isSelected: isSelected,
        label: label,
        value: value,
        index: index
    };
}
function $1b50e9ea35e97ef8$var$buildCategorizedOptions(props, selectValue) {
    return props.options.map(function(groupOrOption, groupOrOptionIndex) {
        //@ts-ignore
        if ('options' in groupOrOption) {
            var categorizedOptions = groupOrOption.options.map(function(option, optionIndex) {
                return $1b50e9ea35e97ef8$var$toCategorizedOption(props, option, selectValue, optionIndex);
            }).filter(function(categorizedOption) {
                return $1b50e9ea35e97ef8$var$isFocusable(props, categorizedOption);
            });
            return categorizedOptions.length > 0 ? {
                type: 'group',
                data: groupOrOption,
                options: categorizedOptions,
                index: groupOrOptionIndex
            } : undefined;
        }
        var categorizedOption = $1b50e9ea35e97ef8$var$toCategorizedOption(props, groupOrOption, selectValue, groupOrOptionIndex);
        return $1b50e9ea35e97ef8$var$isFocusable(props, categorizedOption) ? categorizedOption : undefined;
    }).filter((0, $27e7f6ca7209680a$export$aedb69ff3e31596c));
}
function $1b50e9ea35e97ef8$var$buildFocusableOptionsFromCategorizedOptions(categorizedOptions) {
    return categorizedOptions.reduce(function(optionsAccumulator, categorizedOption) {
        if (categorizedOption.type === 'group') optionsAccumulator.push.apply(optionsAccumulator, (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(categorizedOption.options.map(function(option) {
            return option.data;
        })));
        else optionsAccumulator.push(categorizedOption.data);
        return optionsAccumulator;
    }, []);
}
function $1b50e9ea35e97ef8$var$buildFocusableOptionsWithIds(categorizedOptions, optionId) {
    return categorizedOptions.reduce(function(optionsAccumulator, categorizedOption) {
        if (categorizedOption.type === 'group') optionsAccumulator.push.apply(optionsAccumulator, (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(categorizedOption.options.map(function(option) {
            return {
                data: option.data,
                id: "".concat(optionId, "-").concat(categorizedOption.index, "-").concat(option.index)
            };
        })));
        else optionsAccumulator.push({
            data: categorizedOption.data,
            id: "".concat(optionId, "-").concat(categorizedOption.index)
        });
        return optionsAccumulator;
    }, []);
}
function $1b50e9ea35e97ef8$var$buildFocusableOptions(props, selectValue) {
    return $1b50e9ea35e97ef8$var$buildFocusableOptionsFromCategorizedOptions($1b50e9ea35e97ef8$var$buildCategorizedOptions(props, selectValue));
}
function $1b50e9ea35e97ef8$var$isFocusable(props, categorizedOption) {
    var _props$inputValue = props.inputValue, inputValue = _props$inputValue === void 0 ? '' : _props$inputValue;
    var data = categorizedOption.data, isSelected = categorizedOption.isSelected, label = categorizedOption.label, value = categorizedOption.value;
    return (!$1b50e9ea35e97ef8$var$shouldHideSelectedOptions(props) || !isSelected) && $1b50e9ea35e97ef8$var$_filterOption(props, {
        label: label,
        value: value,
        data: data
    }, inputValue);
}
function $1b50e9ea35e97ef8$var$getNextFocusedValue(state, nextSelectValue) {
    var focusedValue = state.focusedValue, lastSelectValue = state.selectValue;
    var lastFocusedIndex = lastSelectValue.indexOf(focusedValue);
    if (lastFocusedIndex > -1) {
        var nextFocusedIndex = nextSelectValue.indexOf(focusedValue);
        if (nextFocusedIndex > -1) // the focused value is still in the selectValue, return it
        return focusedValue;
        else if (lastFocusedIndex < nextSelectValue.length) // the focusedValue is not present in the next selectValue array by
        // reference, so return the new value at the same index
        return nextSelectValue[lastFocusedIndex];
    }
    return null;
}
function $1b50e9ea35e97ef8$var$getNextFocusedOption(state, options) {
    var lastFocusedOption = state.focusedOption;
    return lastFocusedOption && options.indexOf(lastFocusedOption) > -1 ? lastFocusedOption : options[0];
}
var $1b50e9ea35e97ef8$var$getFocusedOptionId = function getFocusedOptionId(focusableOptionsWithIds, focusedOption) {
    var _focusableOptionsWith;
    var focusedOptionId = (_focusableOptionsWith = focusableOptionsWithIds.find(function(option) {
        return option.data === focusedOption;
    })) === null || _focusableOptionsWith === void 0 ? void 0 : _focusableOptionsWith.id;
    return focusedOptionId || null;
};
var $1b50e9ea35e97ef8$var$getOptionLabel = function getOptionLabel(props, data) {
    return props.getOptionLabel(data);
};
var $1b50e9ea35e97ef8$var$getOptionValue = function getOptionValue(props, data) {
    return props.getOptionValue(data);
};
function $1b50e9ea35e97ef8$var$_isOptionDisabled(props, option, selectValue) {
    return typeof props.isOptionDisabled === 'function' ? props.isOptionDisabled(option, selectValue) : false;
}
function $1b50e9ea35e97ef8$var$_isOptionSelected(props, option, selectValue) {
    if (selectValue.indexOf(option) > -1) return true;
    if (typeof props.isOptionSelected === 'function') return props.isOptionSelected(option, selectValue);
    var candidate = $1b50e9ea35e97ef8$var$getOptionValue(props, option);
    return selectValue.some(function(i) {
        return $1b50e9ea35e97ef8$var$getOptionValue(props, i) === candidate;
    });
}
function $1b50e9ea35e97ef8$var$_filterOption(props, option, inputValue) {
    return props.filterOption ? props.filterOption(option, inputValue) : true;
}
var $1b50e9ea35e97ef8$var$shouldHideSelectedOptions = function shouldHideSelectedOptions(props) {
    var hideSelectedOptions = props.hideSelectedOptions, isMulti = props.isMulti;
    if (hideSelectedOptions === undefined) return isMulti;
    return hideSelectedOptions;
};
var $1b50e9ea35e97ef8$var$instanceId = 1;
// eslint-disable-next-line @repo/internal/react/no-class-components
var $1b50e9ea35e97ef8$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_Component) {
    // Lifecycle
    // ------------------------------
    function Select(_props) {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, Select);
        _this = $1b50e9ea35e97ef8$var$_callSuper(this, Select, [
            _props
        ]);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "state", {
            ariaSelection: null,
            focusedOption: null,
            focusedOptionId: null,
            focusableOptionsWithIds: [],
            focusedValue: null,
            focusedValueId: null,
            inputIsHidden: false,
            isFocused: false,
            selectValue: [],
            clearFocusValueOnUpdate: false,
            prevWasFocused: false,
            inputIsHiddenAfterUpdate: undefined,
            prevProps: undefined,
            instancePrefix: ''
        });
        // Misc. Instance Properties
        // ------------------------------
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "blockOptionHover", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "isComposing", false);
        // TODO
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "initialTouchX", 0);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "initialTouchY", 0);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "openAfterFocus", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "scrollToFocusedOptionOnUpdate", false);
        // Refs
        // ------------------------------
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "controlRef", null);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "getControlRef", function(ref) {
            _this.controlRef = ref;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "focusedOptionRef", null);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "getFocusedOptionRef", function(ref) {
            _this.focusedOptionRef = ref;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "menuListRef", null);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "getMenuListRef", function(ref) {
            _this.menuListRef = ref;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "inputRef", null);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "getInputRef", function(ref) {
            _this.inputRef = ref;
        });
        // aliased for consumers
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "focus", _this.focusInput);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "blur", _this.blurInput);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "onChange", function(newValue, actionMeta) {
            var _this$props = _this.props, onChange = _this$props.onChange, name = _this$props.name;
            actionMeta.name = name;
            _this.ariaOnChange(newValue, actionMeta);
            onChange(newValue, actionMeta);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "setValue", function(newValue, action, option) {
            var _this$props2 = _this.props, closeMenuOnSelect = _this$props2.closeMenuOnSelect, isMulti = _this$props2.isMulti, inputValue = _this$props2.inputValue, shouldKeepInputOnSelect = _this$props2.shouldKeepInputOnSelect;
            // for multiple selection options, do not clear the search input value
            if (isMulti && shouldKeepInputOnSelect && (0, $9Zzpd.fg)('platform_do_not_clear_input_for_multiselect')) _this.onInputChange(inputValue, {
                action: 'set-value',
                prevInputValue: inputValue
            });
            else _this.onInputChange('', {
                action: 'set-value',
                prevInputValue: inputValue
            });
            if (closeMenuOnSelect) {
                _this.setState({
                    inputIsHiddenAfterUpdate: !isMulti
                });
                _this.onMenuClose();
            }
            // when the select value should change, we should reset focusedValue
            _this.setState({
                clearFocusValueOnUpdate: true
            });
            _this.onChange(newValue, {
                action: action,
                option: option
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "selectOption", function(newValue) {
            var _this$props3 = _this.props, blurInputOnSelect = _this$props3.blurInputOnSelect, isMulti = _this$props3.isMulti, name = _this$props3.name;
            var selectValue = _this.state.selectValue;
            var deselected = isMulti && _this.isOptionSelected(newValue, selectValue);
            var isDisabled = _this.isOptionDisabled(newValue, selectValue);
            if (deselected) {
                var candidate = _this.getOptionValue(newValue);
                _this.setValue((0, $27e7f6ca7209680a$export$d1ca752ec761b95b)(selectValue.filter(function(i) {
                    return _this.getOptionValue(i) !== candidate;
                })), 'deselect-option', newValue);
            } else if (!isDisabled) {
                // Select option if option is not disabled
                if (isMulti) _this.setValue((0, $27e7f6ca7209680a$export$d1ca752ec761b95b)([].concat((0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(selectValue), [
                    newValue
                ])), 'select-option', newValue);
                else _this.setValue((0, $27e7f6ca7209680a$export$dea4763e29237f4c)(newValue), 'select-option');
            } else {
                _this.ariaOnChange((0, $27e7f6ca7209680a$export$dea4763e29237f4c)(newValue), {
                    action: 'select-option',
                    option: newValue,
                    name: name
                });
                return;
            }
            if (blurInputOnSelect) _this.blurInput();
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "removeValue", function(removedValue) {
            var isMulti = _this.props.isMulti;
            var selectValue = _this.state.selectValue;
            var candidate = _this.getOptionValue(removedValue);
            var newValueArray = selectValue.filter(function(i) {
                return _this.getOptionValue(i) !== candidate;
            });
            var newValue = (0, $27e7f6ca7209680a$export$40fb9515c784cc3b)(isMulti, newValueArray, newValueArray[0] || null);
            _this.onChange(newValue, {
                action: 'remove-value',
                removedValue: removedValue
            });
            _this.focusInput();
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "clearValue", function() {
            var selectValue = _this.state.selectValue;
            _this.onChange((0, $27e7f6ca7209680a$export$40fb9515c784cc3b)(_this.props.isMulti, [], null), {
                action: 'clear',
                removedValues: selectValue
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "popValue", function() {
            var isMulti = _this.props.isMulti;
            var selectValue = _this.state.selectValue;
            var lastSelectedValue = selectValue[selectValue.length - 1];
            var newValueArray = selectValue.slice(0, selectValue.length - 1);
            var newValue = (0, $27e7f6ca7209680a$export$40fb9515c784cc3b)(isMulti, newValueArray, newValueArray[0] || null);
            _this.onChange(newValue, {
                action: 'pop-value',
                removedValue: lastSelectedValue
            });
        });
        // ==============================
        // Getters
        // ==============================
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "getFocusedOptionId", function(focusedOption) {
            return $1b50e9ea35e97ef8$var$getFocusedOptionId(_this.state.focusableOptionsWithIds, focusedOption);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "getFocusableOptionsWithIds", function() {
            return $1b50e9ea35e97ef8$var$buildFocusableOptionsWithIds($1b50e9ea35e97ef8$var$buildCategorizedOptions(_this.props, _this.state.selectValue), _this.getElementId('option'));
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "getValue", function() {
            return _this.state.selectValue;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "cx", function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            return (0, $27e7f6ca7209680a$export$ce4ab0c55987d1ff).apply(void 0, [
                _this.props.classNamePrefix
            ].concat(args));
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "getOptionLabel", function(data) {
            return $1b50e9ea35e97ef8$var$getOptionLabel(_this.props, data);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "getOptionValue", function(data) {
            return $1b50e9ea35e97ef8$var$getOptionValue(_this.props, data);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "getStyles", function(key, props) {
            var base = (0, $fc64564d6dbd70b3$export$214b055320e0bf32)[key](props);
            base.boxSizing = 'border-box';
            var custom = _this.props.styles[key];
            if (!custom) return base;
            var customStyles = (0, $27e7f6ca7209680a$export$bf2eda47afa5f369)(custom(base, props));
            return customStyles;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "getClassNames", function(key, props) {
            var _this$props$className, _this$props$className2;
            return (_this$props$className = (_this$props$className2 = _this.props.classNames)[key]) === null || _this$props$className === void 0 ? void 0 : _this$props$className.call(_this$props$className2, props);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "getElementId", function(element) {
            return "".concat(_this.state.instancePrefix, "-").concat(element);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "getComponents", function() {
            return (0, $eef74442e0ac473a$export$71abc632aa29e6fe)(_this.props);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "buildCategorizedOptions", function() {
            return $1b50e9ea35e97ef8$var$buildCategorizedOptions(_this.props, _this.state.selectValue);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "getCategorizedOptions", function() {
            return _this.props.menuIsOpen ? _this.buildCategorizedOptions() : [];
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "buildFocusableOptions", function() {
            return $1b50e9ea35e97ef8$var$buildFocusableOptionsFromCategorizedOptions(_this.buildCategorizedOptions());
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "getFocusableOptions", function() {
            return _this.props.menuIsOpen ? _this.buildFocusableOptions() : [];
        });
        // ==============================
        // Helpers
        // ==============================
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "ariaOnChange", function(value, actionMeta) {
            _this.setState({
                ariaSelection: $1b50e9ea35e97ef8$var$_objectSpread({
                    value: value
                }, actionMeta)
            });
        });
        // ==============================
        // Mouse Handlers
        // ==============================
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "onMenuMouseDown", function(event) {
            if (event.button !== 0) return;
            event.stopPropagation();
            event.preventDefault();
            _this.focusInput();
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "onMenuMouseMove", function(_) {
            _this.blockOptionHover = false;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "onControlMouseDown", function(event) {
            // Event captured by dropdown indicator
            if (event.defaultPrevented) {
                var _this$controlRef;
                // react-dnd will fire preventDefault in mouseDown, which make select is not clickable.
                // temp workaround to check if select is within dnd, we don't do the early return.
                if (!((_this$controlRef = _this.controlRef) !== null && _this$controlRef !== void 0 && _this$controlRef.closest('[data-rbd-draggable-context-id]'))) return;
            }
            var openMenuOnClick = _this.props.openMenuOnClick;
            if (!_this.state.isFocused) {
                if (openMenuOnClick) _this.openAfterFocus = true;
                _this.focusInput();
            } else if (!_this.props.menuIsOpen) {
                if (openMenuOnClick) _this.openMenu('first');
            } else if (event.target.tagName !== 'INPUT' && event.target.tagName !== 'TEXTAREA') _this.onMenuClose();
            if (event.target.tagName !== 'INPUT' && event.target.tagName !== 'TEXTAREA') event.preventDefault();
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "onDropdownIndicatorMouseDown", function(event) {
            // ignore mouse events that weren't triggered by the primary button
            if (event && event.type === 'mousedown' && event.button !== 0) return;
            if (_this.props.isDisabled) return;
            var _this$props4 = _this.props, isMulti = _this$props4.isMulti, menuIsOpen = _this$props4.menuIsOpen;
            _this.focusInput();
            if (menuIsOpen) {
                _this.setState({
                    inputIsHiddenAfterUpdate: !isMulti
                });
                _this.onMenuClose();
            } else _this.openMenu('first');
            event.preventDefault();
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "onClearIndicatorMouseDown", function(event) {
            // ignore mouse events that weren't triggered by the primary button
            if (event && event.type === 'mousedown' && event.button !== 0) return;
            _this.clearValue();
            event.preventDefault();
            _this.openAfterFocus = false;
            if (event.type === 'touchend') _this.focusInput();
            else setTimeout(function() {
                return _this.focusInput();
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "onScroll", function(event) {
            if (typeof _this.props.closeMenuOnScroll === 'boolean') {
                if (event.target instanceof HTMLElement && (0, $27e7f6ca7209680a$export$d8a62a489b442872)(event.target)) _this.props.onMenuClose();
            } else if (typeof _this.props.closeMenuOnScroll === 'function') {
                if (_this.props.closeMenuOnScroll(event)) _this.props.onMenuClose();
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "onCompositionStart", function() {
            _this.isComposing = true;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "onCompositionEnd", function() {
            _this.isComposing = false;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "onTouchStart", function(_ref2) {
            var touches = _ref2.touches;
            var touch = touches && touches.item(0);
            if (!touch) return;
            _this.initialTouchX = touch.clientX;
            _this.initialTouchY = touch.clientY;
            _this.userIsDragging = false;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "onTouchMove", function(_ref3) {
            var touches = _ref3.touches;
            var touch = touches && touches.item(0);
            if (!touch) return;
            var deltaX = Math.abs(touch.clientX - _this.initialTouchX);
            var deltaY = Math.abs(touch.clientY - _this.initialTouchY);
            var moveThreshold = 5;
            _this.userIsDragging = deltaX > moveThreshold || deltaY > moveThreshold;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "onTouchEnd", function(event) {
            if (_this.userIsDragging) return;
            // close the menu if the user taps outside
            // we're checking on event.target here instead of event.currentTarget, because we want to assert information
            // on events on child elements, not the document (which we've attached this handler to).
            if (_this.controlRef && !_this.controlRef.contains(event.target) && _this.menuListRef && !_this.menuListRef.contains(event.target)) _this.blurInput();
            // reset move vars
            _this.initialTouchX = 0;
            _this.initialTouchY = 0;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "onControlTouchEnd", function(event) {
            if (_this.userIsDragging) return;
            _this.onControlMouseDown(event);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "onClearIndicatorTouchEnd", function(event) {
            if (_this.userIsDragging) return;
            _this.onClearIndicatorMouseDown(event);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "onDropdownIndicatorTouchEnd", function(event) {
            if (_this.userIsDragging) return;
            _this.onDropdownIndicatorMouseDown(event);
        });
        // ==============================
        // Focus Handlers
        // ==============================
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "handleInputChange", function(event) {
            var prevInputValue = _this.props.inputValue;
            var inputValue = event.currentTarget.value;
            _this.setState({
                inputIsHiddenAfterUpdate: false
            });
            _this.onInputChange(inputValue, {
                action: 'input-change',
                prevInputValue: prevInputValue
            });
            if (!_this.props.menuIsOpen) _this.onMenuOpen();
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "onInputFocus", function(event) {
            if (_this.props.onFocus) _this.props.onFocus(event);
            _this.setState({
                inputIsHiddenAfterUpdate: false,
                isFocused: true
            });
            if (_this.openAfterFocus || _this.props.openMenuOnFocus) _this.openMenu('first');
            _this.openAfterFocus = false;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "onInputBlur", function(event) {
            var prevInputValue = _this.props.inputValue;
            if (_this.menuListRef && _this.menuListRef.contains(document.activeElement)) {
                _this.inputRef.focus();
                return;
            }
            if (_this.props.onBlur) _this.props.onBlur(event);
            _this.onInputChange('', {
                action: 'input-blur',
                prevInputValue: prevInputValue
            });
            if ((0, $9Zzpd.fg)('platform_dst_select_menu_close_on_blur')) // when fg is enabled, we only call onMenuClose when this.props.menuIsOpen is true.
            _this.props.menuIsOpen && _this.onMenuClose();
            else _this.onMenuClose();
            _this.setState({
                focusedValue: null,
                isFocused: false
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "onOptionHover", function(focusedOption) {
            if (_this.blockOptionHover || _this.state.focusedOption === focusedOption) return;
            var options = _this.getFocusableOptions();
            var focusedOptionIndex = options.indexOf(focusedOption);
            _this.setState({
                focusedOption: focusedOption,
                focusedOptionId: focusedOptionIndex > -1 ? _this.getFocusedOptionId(focusedOption) : null
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "shouldHideSelectedOptions", function() {
            return $1b50e9ea35e97ef8$var$shouldHideSelectedOptions(_this.props);
        });
        // If the hidden input gets focus through form submit,
        // redirect focus to focusable input.
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "onValueInputFocus", function(e) {
            e.preventDefault();
            e.stopPropagation();
            _this.focus();
        });
        // ==============================
        // Keyboard Handlers
        // ==============================
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "onKeyDown", function(event) {
            var _this$props5 = _this.props, isMulti = _this$props5.isMulti, backspaceRemovesValue = _this$props5.backspaceRemovesValue, escapeClearsValue = _this$props5.escapeClearsValue, inputValue = _this$props5.inputValue, isClearable = _this$props5.isClearable, isDisabled = _this$props5.isDisabled, menuIsOpen = _this$props5.menuIsOpen, onKeyDown = _this$props5.onKeyDown, tabSelectsValue = _this$props5.tabSelectsValue, openMenuOnFocus = _this$props5.openMenuOnFocus, shouldPreventEscapePropagation = _this$props5.shouldPreventEscapePropagation;
            var _this$state = _this.state, focusedOption = _this$state.focusedOption, focusedValue = _this$state.focusedValue, selectValue = _this$state.selectValue;
            if (isDisabled) return;
            if (typeof onKeyDown === 'function') {
                onKeyDown(event);
                if (event.defaultPrevented) return;
            }
            // Block option hover events when the user has just pressed a key
            _this.blockOptionHover = true;
            switch(event.key){
                case 'ArrowLeft':
                    if (!isMulti || inputValue) return;
                    _this.focusValue('previous');
                    break;
                case 'ArrowRight':
                    if (!isMulti || inputValue) return;
                    _this.focusValue('next');
                    break;
                case 'Delete':
                case 'Backspace':
                    if (inputValue) return;
                    if (focusedValue) _this.removeValue(focusedValue);
                    else {
                        if (!backspaceRemovesValue) return;
                        if (isMulti) _this.popValue();
                        else if (isClearable) _this.clearValue();
                    }
                    break;
                case 'Tab':
                    if (_this.isComposing) return;
                    if (event.shiftKey || !menuIsOpen || !tabSelectsValue || !focusedOption || // don't capture the event if the menu opens on focus and the focused
                    // option is already selected; it breaks the flow of navigation
                    openMenuOnFocus && _this.isOptionSelected(focusedOption, selectValue)) return;
                    _this.selectOption(focusedOption);
                    break;
                case 'Enter':
                    if (event.keyCode === 229) break;
                    if (focusedValue) _this.removeValue(focusedValue);
                    if (menuIsOpen) {
                        if (!focusedOption) return;
                        if (_this.isComposing) return;
                        _this.selectOption(focusedOption);
                        break;
                    }
                    return;
                case 'Escape':
                    if (menuIsOpen) {
                        _this.setState({
                            inputIsHiddenAfterUpdate: false
                        });
                        _this.onInputChange('', {
                            action: 'menu-close',
                            prevInputValue: inputValue
                        });
                        _this.onMenuClose();
                        if (shouldPreventEscapePropagation && event.target instanceof HTMLElement) event.stopPropagation();
                    } else if (isClearable && escapeClearsValue) _this.clearValue();
                    break;
                case ' ':
                    // space
                    if (inputValue) return;
                    if (!menuIsOpen) {
                        _this.openMenu('first');
                        break;
                    }
                    if (!focusedOption) return;
                    _this.selectOption(focusedOption);
                    break;
                case 'ArrowUp':
                    if (menuIsOpen) _this.focusOption('up');
                    else _this.openMenu('last');
                    break;
                case 'ArrowDown':
                    if (menuIsOpen) _this.focusOption('down');
                    else _this.openMenu('first');
                    break;
                case 'PageUp':
                    if (!menuIsOpen) return;
                    _this.focusOption('pageup');
                    break;
                case 'PageDown':
                    if (!menuIsOpen) return;
                    _this.focusOption('pagedown');
                    break;
                case 'Home':
                    if (!menuIsOpen) return;
                    _this.focusOption('first');
                    break;
                case 'End':
                    if (!menuIsOpen) return;
                    _this.focusOption('last');
                    break;
                default:
                    return;
            }
            event.preventDefault();
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "handleOpenLayerObserverCloseSignal", function() {
            _this.onMenuClose();
        });
        _this.state.instancePrefix = 'react-select-' + (_this.props.instanceId || ++$1b50e9ea35e97ef8$var$instanceId);
        _this.state.selectValue = (0, $27e7f6ca7209680a$export$33f062f47f21a01)(_props.value);
        // Set focusedOption if menuIsOpen is set on init (e.g. defaultMenuIsOpen)
        if (_props.menuIsOpen) {
            var focusableOptionsWithIds = _this.getFocusableOptionsWithIds();
            var focusableOptions = _this.buildFocusableOptions();
            var optionIndex = focusableOptions.indexOf(_this.state.selectValue[0]);
            _this.state.focusableOptionsWithIds = focusableOptionsWithIds;
            _this.state.focusedOption = focusableOptions[optionIndex];
            _this.state.focusedOptionId = $1b50e9ea35e97ef8$var$getFocusedOptionId(focusableOptionsWithIds, focusableOptions[optionIndex]);
        }
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($eyuDe)))(Select, _Component);
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(Select, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this.startListeningComposition();
                this.startListeningToTouch();
                if (this.props.closeMenuOnScroll && document && document.addEventListener) // Listen to all scroll events, and filter them out inside of 'onScroll'
                // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                document.addEventListener('scroll', this.onScroll, true);
                if (this.props.autoFocus) this.focusInput();
                // Scroll focusedOption into view if menuIsOpen is set on mount (e.g. defaultMenuIsOpen)
                if (this.props.menuIsOpen && this.state.focusedOption && this.menuListRef && this.focusedOptionRef) (0, $27e7f6ca7209680a$export$53a0910f038337bd)(this.menuListRef, this.focusedOptionRef);
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps) {
                var _this$props6 = this.props, isDisabled = _this$props6.isDisabled, menuIsOpen = _this$props6.menuIsOpen;
                var isFocused = this.state.isFocused;
                if (// ensure focus is restored correctly when the control becomes enabled
                isFocused && !isDisabled && prevProps.isDisabled || // ensure focus is on the Input when the menu opens
                isFocused && menuIsOpen && !prevProps.menuIsOpen) this.focusInput();
                if (isFocused && isDisabled && !prevProps.isDisabled) // ensure select state gets blurred in case Select is programmatically disabled while focused
                this.setState({
                    isFocused: false
                }, this.onMenuClose);
                else if (!isFocused && !isDisabled && prevProps.isDisabled && this.inputRef === document.activeElement) // ensure select state gets focused in case Select is programatically re-enabled while focused (Firefox)
                this.setState({
                    isFocused: true
                });
                // scroll the focused option into view if necessary
                if (this.menuListRef && this.focusedOptionRef && this.scrollToFocusedOptionOnUpdate) {
                    (0, $27e7f6ca7209680a$export$53a0910f038337bd)(this.menuListRef, this.focusedOptionRef);
                    this.scrollToFocusedOptionOnUpdate = false;
                }
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this.stopListeningComposition();
                this.stopListeningToTouch();
                // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                document.removeEventListener('scroll', this.onScroll, true);
            }
        },
        {
            key: "onMenuOpen",
            value: function onMenuOpen() {
                this.props.onMenuOpen();
            }
        },
        {
            key: "onMenuClose",
            value: function onMenuClose() {
                this.onInputChange('', {
                    action: 'menu-close',
                    prevInputValue: this.props.inputValue
                });
                this.props.onMenuClose();
            }
        },
        {
            key: "onInputChange",
            value: function onInputChange(newValue, actionMeta) {
                this.props.onInputChange(newValue, actionMeta);
            }
        },
        {
            key: "focusInput",
            value: function focusInput() {
                if (!this.inputRef) return;
                this.inputRef.focus();
            }
        },
        {
            key: "blurInput",
            value: function blurInput() {
                if (!this.inputRef) return;
                this.inputRef.blur();
            }
        },
        {
            key: "openMenu",
            value: function openMenu(focusOption) {
                var _this2 = this;
                var _this$state2 = this.state, selectValue = _this$state2.selectValue, isFocused = _this$state2.isFocused;
                var focusableOptions = this.buildFocusableOptions();
                var openAtIndex = focusOption === 'first' ? 0 : focusableOptions.length - 1;
                if (!this.props.isMulti) {
                    var selectedIndex = focusableOptions.indexOf(selectValue[0]);
                    if (selectedIndex > -1) openAtIndex = selectedIndex;
                }
                var focusedOption = focusableOptions[openAtIndex];
                // only scroll if the menu isn't already open
                this.scrollToFocusedOptionOnUpdate = !(isFocused && this.menuListRef);
                this.setState({
                    inputIsHiddenAfterUpdate: false,
                    focusedValue: null,
                    focusedOption: focusedOption,
                    focusedOptionId: this.getFocusedOptionId(focusedOption)
                }, function() {
                    return _this2.onMenuOpen();
                });
                (0, $dJ32z.isSafari)() && focusedOption && this.updateInputLabel(this.calculateInputLabel(focusedOption, openAtIndex));
            }
        },
        {
            key: "updateInputLabel",
            value: function updateInputLabel(inputLabel) {
                var _this3 = this;
                if (inputLabel) {
                    var _this$inputRef;
                    (_this$inputRef = this.inputRef) === null || _this$inputRef === void 0 || _this$inputRef.setAttribute('aria-label', inputLabel);
                    setTimeout(function() {
                        var normalizedLabel = _this3.props['aria-label'] || _this3.props.label;
                        if (normalizedLabel) {
                            var _this3$inputRef;
                            (_this3$inputRef = _this3.inputRef) === null || _this3$inputRef === void 0 || _this3$inputRef.setAttribute('aria-label', normalizedLabel);
                        } else {
                            var _this3$inputRef2;
                            (_this3$inputRef2 = _this3.inputRef) === null || _this3$inputRef2 === void 0 || _this3$inputRef2.removeAttribute('aria-label');
                        }
                    }, 500);
                }
            }
        },
        {
            key: "calculateInputLabel",
            value: function calculateInputLabel(focusedOption, optionIndex) {
                var _this4 = this;
                var options = this.props.options;
                var isOptionsGrouped = options === null || options === void 0 ? void 0 : options.every(function(obj) {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(obj) === 'object' && obj !== null && 'options' in obj;
                });
                var inputLabel = this.getOptionLabel(focusedOption);
                var isOptionFocused = function isOptionFocused(option) {
                    return _this4.getOptionLabel(option) === inputLabel;
                };
                var groupData = options === null || options === void 0 ? void 0 : options.find(function(option) {
                    var _groupCandidate$optio, _groupCandidate$optio2;
                    var groupCandidate = option;
                    return (_groupCandidate$optio = (_groupCandidate$optio2 = groupCandidate.options) === null || _groupCandidate$optio2 === void 0 ? void 0 : _groupCandidate$optio2.some(isOptionFocused)) !== null && _groupCandidate$optio !== void 0 ? _groupCandidate$optio : false;
                });
                if (isOptionsGrouped) {
                    var _groupData$options$fi;
                    var groupOptionIndex = (_groupData$options$fi = groupData === null || groupData === void 0 ? void 0 : groupData.options.findIndex(isOptionFocused)) !== null && _groupData$options$fi !== void 0 ? _groupData$options$fi : 0;
                    var totalLength = options === null || options === void 0 ? void 0 : options.reduce(function(acc, currentGroup) {
                        var _group$options;
                        var group = currentGroup;
                        acc += group === null || group === void 0 || (_group$options = group.options) === null || _group$options === void 0 ? void 0 : _group$options.length;
                        return acc;
                    }, 0);
                    inputLabel = "".concat(inputLabel, ", ").concat(groupData === null || groupData === void 0 ? void 0 : groupData.label, " (").concat(groupOptionIndex + 1, " of ").concat(totalLength, ")");
                } else inputLabel = "".concat(inputLabel, " (").concat(optionIndex + 1, " of ").concat(options === null || options === void 0 ? void 0 : options.length, ")");
                return inputLabel;
            }
        },
        {
            key: "focusValue",
            value: function focusValue(direction) {
                var _this$state3 = this.state, selectValue = _this$state3.selectValue, focusedValue = _this$state3.focusedValue;
                // Only multiselects support value focusing
                if (!this.props.isMulti) return;
                this.setState({
                    focusedOption: null
                });
                var focusedIndex = selectValue.indexOf(focusedValue);
                if (!focusedValue) focusedIndex = -1;
                var lastIndex = selectValue.length - 1;
                var nextFocus = -1;
                if (!selectValue.length) return;
                switch(direction){
                    case 'previous':
                        if (focusedIndex === 0) // don't cycle from the start to the end
                        nextFocus = 0;
                        else if (focusedIndex === -1) // if nothing is focused, focus the last value first
                        nextFocus = lastIndex;
                        else nextFocus = focusedIndex - 1;
                        break;
                    case 'next':
                        if (focusedIndex > -1 && focusedIndex < lastIndex) nextFocus = focusedIndex + 1;
                        break;
                }
                this.setState({
                    inputIsHidden: nextFocus !== -1,
                    focusedValue: selectValue[nextFocus],
                    focusedValueId: "".concat(this.getElementId('selected-value'), "-").concat(nextFocus, "-remove"),
                    focusedOption: null,
                    focusedOptionId: null
                });
            }
        },
        {
            key: "focusOption",
            value: function focusOption() {
                var direction = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'first';
                var pageSize = this.props.pageSize;
                var focusedOption = this.state.focusedOption;
                var options = this.getFocusableOptions();
                if (!options.length) return;
                var nextFocus = 0; // handles 'first'
                var focusedIndex = options.indexOf(focusedOption);
                if (!focusedOption) focusedIndex = -1;
                if (direction === 'up') nextFocus = focusedIndex > 0 ? focusedIndex - 1 : options.length - 1;
                else if (direction === 'down') nextFocus = (focusedIndex + 1) % options.length;
                else if (direction === 'pageup') {
                    nextFocus = focusedIndex - pageSize;
                    if (nextFocus < 0) nextFocus = 0;
                } else if (direction === 'pagedown') {
                    nextFocus = focusedIndex + pageSize;
                    if (nextFocus > options.length - 1) nextFocus = options.length - 1;
                } else if (direction === 'last') nextFocus = options.length - 1;
                this.scrollToFocusedOptionOnUpdate = true;
                this.setState({
                    focusedOption: options[nextFocus],
                    focusedValue: null,
                    focusedValueId: null,
                    focusedOptionId: this.getFocusedOptionId(options[nextFocus])
                });
            }
        },
        {
            key: "getCommonProps",
            value: function getCommonProps() {
                var clearValue = this.clearValue, cx = this.cx, getStyles = this.getStyles, getClassNames = this.getClassNames, getValue = this.getValue, selectOption = this.selectOption, setValue = this.setValue, props = this.props;
                var isMulti = props.isMulti, isRtl = props.isRtl, options = props.options;
                var hasValue = this.hasValue();
                return {
                    clearValue: clearValue,
                    cx: cx,
                    getStyles: getStyles,
                    getClassNames: getClassNames,
                    getValue: getValue,
                    hasValue: hasValue,
                    isMulti: isMulti,
                    isRtl: isRtl,
                    options: options,
                    selectOption: selectOption,
                    selectProps: props,
                    setValue: setValue
                };
            }
        },
        {
            key: "hasValue",
            value: function hasValue() {
                var selectValue = this.state.selectValue;
                return selectValue.length > 0;
            }
        },
        {
            key: "hasOptions",
            value: function hasOptions() {
                return !!this.getFocusableOptions().length;
            }
        },
        {
            key: "isClearable",
            value: function isClearable() {
                var _this$props7 = this.props, isClearable = _this$props7.isClearable, isMulti = _this$props7.isMulti;
                // single select, by default, IS NOT clearable
                // multi select, by default, IS clearable
                if (isClearable === undefined) return isMulti;
                return isClearable;
            }
        },
        {
            key: "isOptionDisabled",
            value: function isOptionDisabled(option, selectValue) {
                return $1b50e9ea35e97ef8$var$_isOptionDisabled(this.props, option, selectValue);
            }
        },
        {
            key: "isOptionSelected",
            value: function isOptionSelected(option, selectValue) {
                return $1b50e9ea35e97ef8$var$_isOptionSelected(this.props, option, selectValue);
            }
        },
        {
            key: "filterOption",
            value: function filterOption(option, inputValue) {
                return $1b50e9ea35e97ef8$var$_filterOption(this.props, option, inputValue);
            }
        },
        {
            key: "formatOptionLabel",
            value: function formatOptionLabel(data, context) {
                if (typeof this.props.formatOptionLabel === 'function') {
                    var inputValue = this.props.inputValue;
                    var selectValue = this.state.selectValue;
                    return this.props.formatOptionLabel(data, {
                        context: context,
                        inputValue: inputValue,
                        selectValue: selectValue
                    });
                } else return this.getOptionLabel(data);
            }
        },
        {
            key: "formatGroupLabel",
            value: function formatGroupLabel(data) {
                return this.props.formatGroupLabel(data);
            }
        },
        {
            key: "calculateDescription",
            value: function calculateDescription() {
                var descriptionProp = this.props['aria-describedby'] || this.props.descriptionId;
                var isMulti = this.props.isMulti;
                var hasValue = this.state.selectValue.length > 0;
                // Determine base description based on selection state
                var baseDescriptionId = hasValue ? isMulti ? '' : this.getElementId('single-value') : this.getElementId('placeholder');
                // Fast path for single select with no description prop
                if (!isMulti && !descriptionProp) return {
                    'aria-describedby': baseDescriptionId
                };
                // Build the describedby string efficiently
                var describedBy = baseDescriptionId;
                // Add description prop if it exists
                if (descriptionProp) describedBy = describedBy ? "".concat(descriptionProp, " ").concat(describedBy) : descriptionProp;
                // For multi-select, always add multi-message ID
                if (isMulti) {
                    var multiMessage = this.getElementId('multi-message');
                    describedBy = describedBy ? "".concat(describedBy, " ").concat(multiMessage) : multiMessage;
                }
                return {
                    'aria-describedby': describedBy
                };
            }
        },
        {
            key: "startListeningComposition",
            value: // ==============================
            // Composition Handlers
            // ==============================
            function startListeningComposition() {
                if (document && document.addEventListener) {
                    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                    document.addEventListener('compositionstart', this.onCompositionStart, false);
                    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                    document.addEventListener('compositionend', this.onCompositionEnd, false);
                }
            }
        },
        {
            key: "stopListeningComposition",
            value: function stopListeningComposition() {
                if (document && document.removeEventListener) {
                    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                    document.removeEventListener('compositionstart', this.onCompositionStart);
                    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                    document.removeEventListener('compositionend', this.onCompositionEnd);
                }
            }
        },
        {
            key: "startListeningToTouch",
            value: // ==============================
            // Touch Handlers
            // ==============================
            function startListeningToTouch() {
                if (document && document.addEventListener) {
                    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                    document.addEventListener('touchstart', this.onTouchStart, false);
                    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                    document.addEventListener('touchmove', this.onTouchMove, false);
                    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                    document.addEventListener('touchend', this.onTouchEnd, false);
                }
            }
        },
        {
            key: "stopListeningToTouch",
            value: function stopListeningToTouch() {
                if (document && document.removeEventListener) {
                    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                    document.removeEventListener('touchstart', this.onTouchStart);
                    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                    document.removeEventListener('touchmove', this.onTouchMove);
                    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                    document.removeEventListener('touchend', this.onTouchEnd);
                }
            }
        },
        {
            key: "renderInput",
            value: // ==============================
            // Renderers
            // ==============================
            function renderInput() {
                var _this$props8 = this.props, form = _this$props8.form, inputId = _this$props8.inputId, inputValue = _this$props8.inputValue, isDisabled = _this$props8.isDisabled, isInvalid = _this$props8.isInvalid, isRequired = _this$props8.isRequired, isSearchable = _this$props8.isSearchable, label = _this$props8.label, labelId = _this$props8.labelId, menuIsOpen = _this$props8.menuIsOpen, required = _this$props8.required, _this$props8$tabIndex = _this$props8.tabIndex, tabIndex = _this$props8$tabIndex === void 0 ? 0 : _this$props8$tabIndex, testId = _this$props8.testId;
                var _this$getComponents = this.getComponents(), Input = _this$getComponents.Input;
                var inputIsHidden = this.state.inputIsHidden;
                var commonProps = this.commonProps;
                var id = inputId || this.getElementId('input');
                // aria attributes makes the JSX "noisy", separated for clarity
                var ariaAttributes = $1b50e9ea35e97ef8$var$_objectSpread($1b50e9ea35e97ef8$var$_objectSpread($1b50e9ea35e97ef8$var$_objectSpread($1b50e9ea35e97ef8$var$_objectSpread({}, !this.props.isSearchable && (0, $9Zzpd.fg)('platform_fix_autocomplete_aria_for_select') ? {} : {
                    'aria-autocomplete': 'both'
                }), {}, {
                    'aria-errormessage': this.props['aria-errormessage'],
                    'aria-expanded': menuIsOpen,
                    // TODO: aria-haspopup is implied as listbox with role="combobox" and was deprecated for aria 1.2, we still might need to keep it for back compat
                    'aria-haspopup': this.props['UNSAFE_is_experimental_generic'] ? 'dialog' : 'listbox',
                    'aria-invalid': this.props['aria-invalid'] || isInvalid,
                    'aria-label': this.props['aria-label'] || label,
                    'aria-labelledby': this.props['aria-labelledby'] || labelId,
                    'aria-required': required || isRequired,
                    role: 'combobox',
                    'aria-activedescendant': this.props['UNSAFE_is_experimental_generic'] ? undefined : this.state.focusedOptionId || this.state.focusedValueId || undefined
                }, menuIsOpen && {
                    'aria-controls': this.getElementId('listbox')
                }), !isSearchable && {
                    'aria-readonly': true
                }), this.calculateDescription());
                if (!isSearchable) // use a dummy input to maintain focus/blur functionality
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $0fcd7b315b703ebc$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
                    id: id,
                    innerRef: this.getInputRef,
                    onBlur: this.onInputBlur,
                    onChange: (0, $27e7f6ca7209680a$export$8793edee2d425525),
                    onFocus: this.onInputFocus,
                    disabled: isDisabled,
                    tabIndex: tabIndex,
                    inputMode: "none",
                    form: form,
                    value: "",
                    "data-testid": testId && "".concat(testId, "-select--input")
                }, ariaAttributes));
                // NOTE: Don't add the `name` prop to this Input, `name` is already a prop on the hidden input element that has the value of the select.
                // Adding `name` to this Input will cause unexpected behavior.
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(Input, (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, commonProps, {
                    autoCapitalize: "none",
                    autoComplete: "off",
                    autoCorrect: "off",
                    id: id,
                    testId: testId,
                    innerRef: this.getInputRef,
                    isDisabled: isDisabled,
                    isHidden: inputIsHidden,
                    onBlur: this.onInputBlur,
                    onChange: this.handleInputChange,
                    onFocus: this.onInputFocus,
                    spellCheck: "false",
                    tabIndex: tabIndex,
                    form: form,
                    type: "text",
                    value: inputValue
                }, ariaAttributes));
            }
        },
        {
            key: "renderPlaceholderOrValue",
            value: function renderPlaceholderOrValue() {
                var _this5 = this;
                var _this$getComponents2 = this.getComponents(), MultiValue = _this$getComponents2.MultiValue, MultiValueContainer = _this$getComponents2.MultiValueContainer, MultiValueLabel = _this$getComponents2.MultiValueLabel, MultiValueRemove = _this$getComponents2.MultiValueRemove, SingleValue = _this$getComponents2.SingleValue, Placeholder = _this$getComponents2.Placeholder;
                var commonProps = this.commonProps;
                var _this$props9 = this.props, controlShouldRenderValue = _this$props9.controlShouldRenderValue, isDisabled = _this$props9.isDisabled, isMulti = _this$props9.isMulti, inputValue = _this$props9.inputValue, placeholder = _this$props9.placeholder, testId = _this$props9.testId;
                var _this$state4 = this.state, selectValue = _this$state4.selectValue, focusedValue = _this$state4.focusedValue, isFocused = _this$state4.isFocused;
                if (!this.hasValue() || !controlShouldRenderValue) return inputValue ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(Placeholder, (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, commonProps, {
                    key: "placeholder",
                    isDisabled: isDisabled,
                    isFocused: isFocused,
                    innerProps: $1b50e9ea35e97ef8$var$_objectSpread({
                        id: this.getElementId('placeholder')
                    }, testId && {
                        'data-testid': "".concat(testId, "-select--placeholder")
                    })
                }), placeholder);
                if (isMulti) return selectValue.map(function(opt, index) {
                    var isOptionFocused = opt === focusedValue;
                    var key = "".concat(_this5.getOptionLabel(opt), "-").concat(_this5.getOptionValue(opt));
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(MultiValue, (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, commonProps, {
                        components: {
                            Container: MultiValueContainer,
                            Label: MultiValueLabel,
                            Remove: MultiValueRemove
                        },
                        isFocused: isOptionFocused,
                        isDisabled: isDisabled,
                        key: key,
                        index: index,
                        removeProps: $1b50e9ea35e97ef8$var$_objectSpread($1b50e9ea35e97ef8$var$_objectSpread({
                            onClick: function onClick() {
                                return _this5.removeValue(opt);
                            },
                            onTouchEnd: function onTouchEnd() {
                                return _this5.removeValue(opt);
                            },
                            onMouseDown: function onMouseDown(e) {
                                e.preventDefault();
                            }
                        }, testId && {
                            'data-testid': "".concat(testId, "-select--multivalue-").concat(index, "-remove")
                        }), {}, {
                            id: "".concat(_this5.getElementId('selected-value'), "-").concat(index, "-remove")
                        }),
                        data: opt,
                        innerProps: $1b50e9ea35e97ef8$var$_objectSpread($1b50e9ea35e97ef8$var$_objectSpread({}, testId && {
                            'data-testid': "".concat(testId, "-select--multivalue-").concat(index)
                        }), {}, {
                            id: "".concat(_this5.getElementId('selected-value'), "-").concat(index)
                        })
                    }), _this5.formatOptionLabel(opt, 'value'));
                });
                if (inputValue) return null;
                var singleValue = selectValue[0];
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(SingleValue, (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, commonProps, {
                    data: singleValue,
                    isDisabled: isDisabled,
                    innerProps: {
                        id: this.getElementId('single-value')
                    }
                }), this.formatOptionLabel(singleValue, 'value'));
            }
        },
        {
            key: "renderClearIndicator",
            value: function renderClearIndicator() {
                var _this$getComponents3 = this.getComponents(), ClearIndicator = _this$getComponents3.ClearIndicator;
                var commonProps = this.commonProps;
                var _this$props0 = this.props, clearControlLabel = _this$props0.clearControlLabel, isDisabled = _this$props0.isDisabled, isLoading = _this$props0.isLoading, spacing = _this$props0.spacing, testId = _this$props0.testId;
                var isFocused = this.state.isFocused;
                if (!this.isClearable() || !ClearIndicator || isDisabled || !this.hasValue() || isLoading) return null;
                var innerProps = $1b50e9ea35e97ef8$var$_objectSpread({
                    onMouseDown: this.onClearIndicatorMouseDown,
                    onTouchEnd: this.onClearIndicatorTouchEnd
                }, testId && {
                    'data-testid': "".concat(testId, "-select--clear-indicator")
                });
                var isCompact = spacing === 'compact';
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(ClearIndicator, (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
                    clearControlLabel: clearControlLabel
                }, commonProps, {
                    innerProps: innerProps,
                    isFocused: isFocused,
                    isCompact: isCompact
                }));
            }
        },
        {
            key: "renderLoadingIndicator",
            value: function renderLoadingIndicator() {
                var _this$getComponents4 = this.getComponents(), LoadingIndicator = _this$getComponents4.LoadingIndicator;
                var commonProps = this.commonProps;
                var _this$props1 = this.props, isDisabled = _this$props1.isDisabled, isLoading = _this$props1.isLoading, spacing = _this$props1.spacing, testId = _this$props1.testId;
                var isFocused = this.state.isFocused;
                if (!LoadingIndicator || !isLoading) return null;
                var isCompact = spacing === 'compact';
                var innerProps = {
                    'aria-hidden': 'true'
                };
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(LoadingIndicator, (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
                    "data-testid": testId && "".concat(testId, "-select--loading-indicator")
                }, commonProps, {
                    innerProps: innerProps,
                    isDisabled: isDisabled,
                    isFocused: isFocused,
                    isCompact: isCompact
                }));
            }
        },
        {
            key: "renderDropdownIndicator",
            value: function renderDropdownIndicator() {
                var _this$getComponents5 = this.getComponents(), DropdownIndicator = _this$getComponents5.DropdownIndicator;
                if (!DropdownIndicator) return null;
                var commonProps = this.commonProps;
                var _this$props10 = this.props, isDisabled = _this$props10.isDisabled, spacing = _this$props10.spacing, testId = _this$props10.testId;
                var isFocused = this.state.isFocused;
                var isCompact = spacing === 'compact';
                var innerProps = $1b50e9ea35e97ef8$var$_objectSpread({
                    onMouseDown: this.onDropdownIndicatorMouseDown,
                    onTouchEnd: this.onDropdownIndicatorTouchEnd,
                    'aria-hidden': 'true'
                }, testId && {
                    'data-testid': "".concat(testId, "-select--dropdown-indicator")
                });
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(DropdownIndicator, (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, commonProps, {
                    innerProps: innerProps,
                    isDisabled: isDisabled,
                    isFocused: isFocused,
                    isCompact: isCompact
                }));
            }
        },
        {
            key: "renderMenu",
            value: function renderMenu() {
                var _this6 = this;
                var _this$getComponents6 = this.getComponents(), Group = _this$getComponents6.Group, GroupHeading = _this$getComponents6.GroupHeading, Menu = _this$getComponents6.Menu, MenuList = _this$getComponents6.MenuList, MenuPortal = _this$getComponents6.MenuPortal, LoadingMessage = _this$getComponents6.LoadingMessage, NoOptionsMessage = _this$getComponents6.NoOptionsMessage, Option = _this$getComponents6.Option;
                var commonProps = this.commonProps;
                var focusedOption = this.state.focusedOption;
                var _this$props11 = this.props, captureMenuScroll = _this$props11.captureMenuScroll, inputValue = _this$props11.inputValue, isLoading = _this$props11.isLoading, loadingMessage = _this$props11.loadingMessage, minMenuHeight = _this$props11.minMenuHeight, maxMenuHeight = _this$props11.maxMenuHeight, menuIsOpen = _this$props11.menuIsOpen, menuPlacement = _this$props11.menuPlacement, menuPosition = _this$props11.menuPosition, menuPortalTarget = _this$props11.menuPortalTarget, menuShouldBlockScroll = _this$props11.menuShouldBlockScroll, menuShouldScrollIntoView = _this$props11.menuShouldScrollIntoView, noOptionsMessage = _this$props11.noOptionsMessage, onMenuScrollToTop = _this$props11.onMenuScrollToTop, onMenuScrollToBottom = _this$props11.onMenuScrollToBottom, testId = _this$props11.testId;
                if (!menuIsOpen) return null;
                // TODO: Internal Option Type here
                var render = function render(props, id, headingId) {
                    var type = props.type, data = props.data, isDisabled = props.isDisabled, isSelected = props.isSelected, label = props.label, value = props.value;
                    var isFocused = focusedOption === data;
                    var onHover = isDisabled ? undefined : function() {
                        return _this6.onOptionHover(data);
                    };
                    var onSelect = isDisabled ? undefined : function() {
                        return _this6.selectOption(data);
                    };
                    var optionId = "".concat(_this6.getElementId('option'), "-").concat(id);
                    var innerProps = $1b50e9ea35e97ef8$var$_objectSpread({
                        id: optionId,
                        onClick: onSelect,
                        onMouseMove: onHover,
                        onMouseOver: onHover,
                        role: _this6.props['UNSAFE_is_experimental_generic'] ? 'listitem' : 'option',
                        'aria-selected': _this6.props['UNSAFE_is_experimental_generic'] ? undefined : isSelected,
                        // We don't want aria-disabled if it's false. It's just noisy.
                        'aria-disabled': !isDisabled ? undefined : isDisabled,
                        'aria-describedby': headingId
                    }, testId && {
                        'data-testid': "".concat(testId, "-select--option-").concat(id)
                    });
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(Option, (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, commonProps, {
                        innerProps: innerProps,
                        data: data,
                        isDisabled: isDisabled,
                        isSelected: isSelected,
                        key: optionId,
                        label: label,
                        type: type,
                        value: value,
                        isFocused: isFocused,
                        innerRef: isFocused ? _this6.getFocusedOptionRef : undefined
                    }), _this6.formatOptionLabel(props.data, 'menu'));
                };
                var menuUI;
                if (this.hasOptions()) {
                    var items = this.getCategorizedOptions();
                    menuUI = items.map(function(item) {
                        if (item.type === 'group') {
                            var data = item.data, options = item.options, groupIndex = item.index;
                            var groupId = "".concat(_this6.getElementId('group'), "-").concat(groupIndex);
                            var headingId = "".concat(groupId, "-heading");
                            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(Group, (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, commonProps, {
                                key: groupId,
                                data: data,
                                options: options,
                                Heading: GroupHeading,
                                headingProps: $1b50e9ea35e97ef8$var$_objectSpread({
                                    id: headingId,
                                    data: item.data
                                }, testId && {
                                    'data-testid': "".concat(testId, "-select--group-").concat(groupIndex, "-heading")
                                }),
                                label: _this6.formatGroupLabel(item.data)
                            }), item.options.map(function(option) {
                                return render(option, "".concat(groupIndex, "-").concat(option.index), headingId);
                            }));
                        } else if (item.type === 'option') return render(item, "".concat(item.index));
                        return undefined;
                    });
                } else if (isLoading) {
                    var message = loadingMessage({
                        inputValue: inputValue
                    });
                    if (message === null) return null;
                    menuUI = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(LoadingMessage, commonProps, message);
                } else {
                    var _message = noOptionsMessage({
                        inputValue: inputValue
                    });
                    if (_message === null) return null;
                    menuUI = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(NoOptionsMessage, (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, commonProps, {
                        innerProps: $1b50e9ea35e97ef8$var$_objectSpread({}, testId && {
                            'data-testid': "".concat(testId, "-select--no-options")
                        })
                    }), _message);
                }
                var menuPlacementProps = {
                    minMenuHeight: minMenuHeight,
                    maxMenuHeight: maxMenuHeight,
                    menuPlacement: menuPlacement,
                    menuPosition: menuPosition,
                    menuShouldScrollIntoView: menuShouldScrollIntoView
                };
                var menuElement = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $13242eb59811c5b2$export$f32337f3a7617699), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, commonProps, menuPlacementProps), function(_ref4) {
                    var ref = _ref4.ref, _ref4$placerProps = _ref4.placerProps, placement = _ref4$placerProps.placement, maxHeight = _ref4$placerProps.maxHeight;
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(Menu, (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, commonProps, menuPlacementProps, {
                        innerRef: ref,
                        innerProps: $1b50e9ea35e97ef8$var$_objectSpread({
                            onMouseDown: _this6.onMenuMouseDown,
                            onMouseMove: _this6.onMenuMouseMove,
                            id: _this6.props.components.Menu ? _this6.getElementId('listbox') : undefined
                        }, testId && {
                            'data-testid': "".concat(testId, "-select--listbox-container")
                        }),
                        isLoading: isLoading,
                        placement: placement
                    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $1405968ad37a8a1b$export$2e2bcd8739ae039), {
                        captureEnabled: captureMenuScroll,
                        onTopArrive: onMenuScrollToTop,
                        onBottomArrive: onMenuScrollToBottom,
                        lockEnabled: menuShouldBlockScroll
                    }, function(scrollTargetRef) {
                        var _this6$inputRef, _this6$inputRef2;
                        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(MenuList, (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, commonProps, {
                            innerRef: function innerRef(instance) {
                                _this6.getMenuListRef(instance);
                                scrollTargetRef(instance);
                            },
                            innerProps: $1b50e9ea35e97ef8$var$_objectSpread($1b50e9ea35e97ef8$var$_objectSpread($1b50e9ea35e97ef8$var$_objectSpread({
                                role: _this6.props['UNSAFE_is_experimental_generic'] ? 'dialog' : 'listbox'
                            }, _this6.props['UNSAFE_is_experimental_generic'] && {
                                'aria-labelledby': ((_this6$inputRef = _this6.inputRef) === null || _this6$inputRef === void 0 ? void 0 : _this6$inputRef.id) || _this6.getElementId('input')
                            }), {}, {
                                'aria-multiselectable': !commonProps.isMulti || _this6.props['UNSAFE_is_experimental_generic'] ? undefined : commonProps.isMulti,
                                id: _this6.getElementId('listbox')
                            }, testId && {
                                'data-testid': "".concat(testId, "-select--listbox")
                            }), (0, $dJ32z.isSafari)() && !_this6.props['UNSAFE_is_experimental_generic'] && {
                                'aria-describedby': ((_this6$inputRef2 = _this6.inputRef) === null || _this6$inputRef2 === void 0 ? void 0 : _this6$inputRef2.id) || _this6.getElementId('input')
                            }),
                            isLoading: isLoading,
                            maxHeight: maxHeight,
                            focusedOption: focusedOption
                        }), _this6.props['UNSAFE_is_experimental_generic'] ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("div", {
                            role: "list"
                        }, menuUI) : menuUI);
                    }));
                });
                // positioning behaviour is almost identical for portalled and fixed,
                // so we use the same component. the actual portalling logic is forked
                // within the component based on `menuPosition`
                return menuPortalTarget || menuPosition === 'fixed' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(MenuPortal, (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, commonProps, {
                    appendTo: menuPortalTarget,
                    controlElement: this.controlRef,
                    menuPlacement: menuPlacement,
                    menuPosition: menuPosition
                }), menuElement) : menuElement;
            }
        },
        {
            key: "renderFormField",
            value: function renderFormField() {
                var _this7 = this;
                var _this$props12 = this.props, delimiter = _this$props12.delimiter, isDisabled = _this$props12.isDisabled, isMulti = _this$props12.isMulti, required = _this$props12.required, name = _this$props12.name;
                var selectValue = this.state.selectValue;
                if (required && !this.hasValue() && !isDisabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $545436dadbd2bc6f$export$2e2bcd8739ae039), {
                    name: name,
                    onFocus: this.onValueInputFocus
                });
                if (!name || isDisabled) return;
                if (isMulti) {
                    if (delimiter) {
                        var value = selectValue.map(function(opt) {
                            return _this7.getOptionValue(opt);
                        }).join(delimiter);
                        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("input", {
                            name: name,
                            type: "hidden",
                            value: value
                        });
                    } else {
                        var input = selectValue.length > 0 ? selectValue.map(function(opt, i) {
                            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("input", {
                                key: "i-".concat(i),
                                name: name,
                                type: "hidden",
                                value: _this7.getOptionValue(opt)
                            });
                        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("input", {
                            name: name,
                            type: "hidden",
                            value: ""
                        });
                        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("div", null, input);
                    }
                } else {
                    var _value = selectValue[0] ? this.getOptionValue(selectValue[0]) : '';
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("input", {
                        name: name,
                        type: "hidden",
                        value: _value
                    });
                }
            }
        },
        {
            key: "renderLiveRegion",
            value: function renderLiveRegion() {
                var commonProps = this.commonProps;
                var _this$state5 = this.state, ariaSelection = _this$state5.ariaSelection, isFocused = _this$state5.isFocused, selectValue = _this$state5.selectValue;
                var focusableOptions = this.getFocusableOptions();
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $3ed34eec60e5eb84$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, commonProps, {
                    id: this.getElementId('live-region'),
                    ariaSelection: ariaSelection,
                    isFocused: isFocused,
                    selectValue: selectValue,
                    focusableOptions: focusableOptions
                }));
            }
        },
        {
            key: "renderMultiselectMessage",
            value: function renderMultiselectMessage() {
                // In the future, when we actually support touch devices, we'll need to update this to not be keyboard specific.
                // Also, since this is rendered onscreen, it should be transtlated automatically.
                var msg = ", multiple selections available, ".concat(this.state.selectValue.length ? 'Use left or right arrow keys to navigate selected items' : '');
                return(/*#__PURE__*/ // eslint-disable-next-line @atlaskit/design-system/use-primitives-text
                (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("span", {
                    id: this.getElementId('multi-message'),
                    hidden: true
                }, msg));
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$getComponents7 = this.getComponents(), Control = _this$getComponents7.Control, IndicatorsContainer = _this$getComponents7.IndicatorsContainer, SelectContainer = _this$getComponents7.SelectContainer, ValueContainer = _this$getComponents7.ValueContainer;
                var _this$props13 = this.props, className = _this$props13.className, id = _this$props13.id, isDisabled = _this$props13.isDisabled, menuIsOpen = _this$props13.menuIsOpen, isInvalid = _this$props13.isInvalid, testId = _this$props13.testId, _this$props13$appeara = _this$props13.appearance, appearance = _this$props13$appeara === void 0 ? 'default' : _this$props13$appeara, _this$props13$spacing = _this$props13.spacing, spacing = _this$props13$spacing === void 0 ? 'default' : _this$props13$spacing;
                var isFocused = this.state.isFocused;
                var commonProps = this.commonProps = this.getCommonProps();
                var isCompact = spacing === 'compact';
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(SelectContainer, (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, commonProps, {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
                    className: className,
                    innerProps: $1b50e9ea35e97ef8$var$_objectSpread({
                        id: id,
                        onKeyDown: this.onKeyDown
                    }, testId && {
                        'data-testid': testId && "".concat(testId, "-select--container")
                    }),
                    isDisabled: isDisabled,
                    isFocused: isFocused
                }), this.renderLiveRegion(), commonProps.isMulti && this.renderMultiselectMessage(), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(Control, (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, commonProps, {
                    innerRef: this.getControlRef,
                    innerProps: $1b50e9ea35e97ef8$var$_objectSpread({
                        onMouseDown: this.onControlMouseDown,
                        onTouchEnd: this.onControlTouchEnd
                    }, testId && {
                        'data-testid': "".concat(testId, "-select--control")
                    }),
                    appearance: appearance,
                    isInvalid: isInvalid,
                    isDisabled: isDisabled,
                    isFocused: isFocused,
                    menuIsOpen: menuIsOpen,
                    isCompact: isCompact
                }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(ValueContainer, (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, commonProps, {
                    isDisabled: isDisabled,
                    isCompact: isCompact,
                    innerProps: $1b50e9ea35e97ef8$var$_objectSpread($1b50e9ea35e97ef8$var$_objectSpread({}, testId && {
                        'data-testid': "".concat(testId, "-select--value-container")
                    }), commonProps.isMulti && commonProps.hasValue && !(0, $dJ32z.isAppleDevice)() && {
                        // Required to keep JAWS from popping out of forms mode when using LEFT/RIGHT arrow keys.
                        // This is Jedi Master level ARIA and not taken lightly. Do not modify without consulting
                        // DST Accessibility.
                        role: 'application'
                    })
                }), this.renderPlaceholderOrValue(), this.renderInput()), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(IndicatorsContainer, (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, commonProps, {
                    isDisabled: isDisabled,
                    innerProps: $1b50e9ea35e97ef8$var$_objectSpread({}, testId && {
                        'data-testid': "".concat(testId, "-select--indicators-container")
                    })
                }), this.renderClearIndicator(), this.renderLoadingIndicator(), this.renderDropdownIndicator())), this.renderMenu(), this.renderFormField(), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $146caa2c2bee098b$export$17baa7c95b6ba1b8), {
                    isOpen: this.props.menuIsOpen,
                    onClose: this.handleOpenLayerObserverCloseSignal
                }));
            }
        }
    ], [
        {
            key: "getDerivedStateFromProps",
            value: function getDerivedStateFromProps(props, state) {
                var prevProps = state.prevProps, clearFocusValueOnUpdate = state.clearFocusValueOnUpdate, inputIsHiddenAfterUpdate = state.inputIsHiddenAfterUpdate, ariaSelection = state.ariaSelection, isFocused = state.isFocused, prevWasFocused = state.prevWasFocused, instancePrefix = state.instancePrefix;
                var options = props.options, value = props.value, menuIsOpen = props.menuIsOpen, inputValue = props.inputValue, isMulti = props.isMulti;
                var selectValue = (0, $27e7f6ca7209680a$export$33f062f47f21a01)(value);
                var newMenuOptionsState = {};
                if (prevProps && (value !== prevProps.value || options !== prevProps.options || menuIsOpen !== prevProps.menuIsOpen || inputValue !== prevProps.inputValue)) {
                    var focusableOptions = menuIsOpen ? $1b50e9ea35e97ef8$var$buildFocusableOptions(props, selectValue) : [];
                    var focusableOptionsWithIds = menuIsOpen ? $1b50e9ea35e97ef8$var$buildFocusableOptionsWithIds($1b50e9ea35e97ef8$var$buildCategorizedOptions(props, selectValue), "".concat(instancePrefix, "-option")) : [];
                    var focusedValue = clearFocusValueOnUpdate ? $1b50e9ea35e97ef8$var$getNextFocusedValue(state, selectValue) : null;
                    var focusedOption = $1b50e9ea35e97ef8$var$getNextFocusedOption(state, focusableOptions);
                    var focusedOptionId = $1b50e9ea35e97ef8$var$getFocusedOptionId(focusableOptionsWithIds, focusedOption);
                    newMenuOptionsState = {
                        selectValue: selectValue,
                        focusedOption: focusedOption,
                        focusedOptionId: focusedOptionId,
                        focusableOptionsWithIds: focusableOptionsWithIds,
                        focusedValue: focusedValue,
                        clearFocusValueOnUpdate: false
                    };
                }
                // some updates should toggle the state of the input visibility
                var newInputIsHiddenState = inputIsHiddenAfterUpdate != null && props !== prevProps ? {
                    inputIsHidden: inputIsHiddenAfterUpdate,
                    inputIsHiddenAfterUpdate: undefined
                } : {};
                var newAriaSelection = ariaSelection;
                var hasKeptFocus = isFocused && prevWasFocused;
                if (isFocused && !hasKeptFocus) {
                    // If `value` or `defaultValue` props are not empty then announce them
                    // when the Select is initially focused
                    newAriaSelection = {
                        value: (0, $27e7f6ca7209680a$export$40fb9515c784cc3b)(isMulti, selectValue, selectValue[0] || null),
                        options: selectValue,
                        action: 'initial-input-focus'
                    };
                    hasKeptFocus = !prevWasFocused;
                }
                // If the 'initial-input-focus' action has been set already
                // then reset the ariaSelection to null
                if ((ariaSelection === null || ariaSelection === void 0 ? void 0 : ariaSelection.action) === 'initial-input-focus') newAriaSelection = null;
                return $1b50e9ea35e97ef8$var$_objectSpread($1b50e9ea35e97ef8$var$_objectSpread($1b50e9ea35e97ef8$var$_objectSpread({}, newMenuOptionsState), newInputIsHiddenState), {}, {
                    prevProps: props,
                    ariaSelection: newAriaSelection,
                    prevWasFocused: hasKeptFocus
                });
            }
        }
    ]);
}((0, $5FkrB.Component));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($1b50e9ea35e97ef8$export$2e2bcd8739ae039, "defaultProps", $1b50e9ea35e97ef8$export$9c21a3269931e1e6);



var $25nEq = parcelRequire("25nEq");

var $iYJcE = parcelRequire("iYJcE");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");

var $4188c2226d921c1d$var$_excluded = [
    "defaultOptions",
    "cacheOptions",
    "loadOptions",
    "options",
    "isLoading",
    "onInputChange",
    "filterOption"
];
function $4188c2226d921c1d$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $4188c2226d921c1d$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $4188c2226d921c1d$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $4188c2226d921c1d$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $4188c2226d921c1d$export$2e2bcd8739ae039(_ref) {
    var _ref$defaultOptions = _ref.defaultOptions, propsDefaultOptions = _ref$defaultOptions === void 0 ? false : _ref$defaultOptions, _ref$cacheOptions = _ref.cacheOptions, cacheOptions = _ref$cacheOptions === void 0 ? false : _ref$cacheOptions, propsLoadOptions = _ref.loadOptions, propsOptions = _ref.options, _ref$isLoading = _ref.isLoading, propsIsLoading = _ref$isLoading === void 0 ? false : _ref$isLoading, propsOnInputChange = _ref.onInputChange, _ref$filterOption = _ref.filterOption, filterOption = _ref$filterOption === void 0 ? null : _ref$filterOption, restSelectProps = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $4188c2226d921c1d$var$_excluded);
    var propsInputValue = restSelectProps.inputValue;
    var lastRequest = (0, $5FkrB.useRef)(undefined);
    var mounted = (0, $5FkrB.useRef)(false);
    var _useState = (0, $5FkrB.useState)(Array.isArray(propsDefaultOptions) ? propsDefaultOptions : undefined), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), defaultOptions = _useState2[0], setDefaultOptions = _useState2[1];
    var _useState3 = (0, $5FkrB.useState)(typeof propsInputValue !== 'undefined' ? propsInputValue : ''), _useState4 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState3, 2), stateInputValue = _useState4[0], setStateInputValue = _useState4[1];
    var _useState5 = (0, $5FkrB.useState)(propsDefaultOptions === true), _useState6 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState5, 2), isLoading = _useState6[0], setIsLoading = _useState6[1];
    var _useState7 = (0, $5FkrB.useState)(undefined), _useState8 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState7, 2), loadedInputValue = _useState8[0], setLoadedInputValue = _useState8[1];
    var _useState9 = (0, $5FkrB.useState)([]), _useState0 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState9, 2), loadedOptions = _useState0[0], setLoadedOptions = _useState0[1];
    var _useState1 = (0, $5FkrB.useState)(false), _useState10 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState1, 2), passEmptyOptions = _useState10[0], setPassEmptyOptions = _useState10[1];
    var _useState11 = (0, $5FkrB.useState)({}), _useState12 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState11, 2), optionsCache = _useState12[0], setOptionsCache = _useState12[1];
    var _useState13 = (0, $5FkrB.useState)(undefined), _useState14 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState13, 2), prevDefaultOptions = _useState14[0], setPrevDefaultOptions = _useState14[1];
    var _useState15 = (0, $5FkrB.useState)(undefined), _useState16 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState15, 2), prevCacheOptions = _useState16[0], setPrevCacheOptions = _useState16[1];
    if (cacheOptions !== prevCacheOptions) {
        setOptionsCache({});
        setPrevCacheOptions(cacheOptions);
    }
    if (propsDefaultOptions !== prevDefaultOptions) {
        setDefaultOptions(Array.isArray(propsDefaultOptions) ? propsDefaultOptions : undefined);
        setPrevDefaultOptions(propsDefaultOptions);
    }
    (0, $5FkrB.useEffect)(function() {
        mounted.current = true;
        return function() {
            mounted.current = false;
        };
    }, []);
    var loadOptions = (0, $5FkrB.useCallback)(function(inputValue, callback) {
        if (!propsLoadOptions) return callback();
        var loader = propsLoadOptions(inputValue, callback);
        if (loader && typeof loader.then === 'function') loader.then(callback, function() {
            return callback();
        });
    }, [
        propsLoadOptions
    ]);
    (0, $5FkrB.useEffect)(function() {
        if (propsDefaultOptions === true) loadOptions(stateInputValue, function(options) {
            if (!mounted.current) return;
            setDefaultOptions(options || []);
            setIsLoading(!!lastRequest.current);
        });
    // NOTE: this effect is designed to only run when the component mounts,
    // so we don't want to include any hook dependencies
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    var onInputChange = (0, $5FkrB.useCallback)(function(newValue, actionMeta) {
        var inputValue = (0, $27e7f6ca7209680a$export$2096bae78ecda911)(newValue, actionMeta, propsOnInputChange);
        if (!inputValue) {
            lastRequest.current = undefined;
            setStateInputValue('');
            setLoadedInputValue('');
            setLoadedOptions([]);
            setIsLoading(false);
            setPassEmptyOptions(false);
            return;
        }
        if (cacheOptions && optionsCache[inputValue]) {
            setStateInputValue(inputValue);
            setLoadedInputValue(inputValue);
            setLoadedOptions(optionsCache[inputValue]);
            setIsLoading(false);
            setPassEmptyOptions(false);
        } else {
            var request = lastRequest.current = {};
            setStateInputValue(inputValue);
            setIsLoading(true);
            setPassEmptyOptions(!loadedInputValue);
            loadOptions(inputValue, function(options) {
                if (!mounted) return;
                if (request !== lastRequest.current) return;
                lastRequest.current = undefined;
                setIsLoading(false);
                setLoadedInputValue(inputValue);
                setLoadedOptions(options || []);
                setPassEmptyOptions(false);
                setOptionsCache(options ? $4188c2226d921c1d$var$_objectSpread($4188c2226d921c1d$var$_objectSpread({}, optionsCache), {}, (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, inputValue, options)) : optionsCache);
            });
        }
    }, [
        cacheOptions,
        loadOptions,
        loadedInputValue,
        optionsCache,
        propsOnInputChange
    ]);
    var options = passEmptyOptions ? [] : stateInputValue && loadedInputValue ? loadedOptions : defaultOptions || [];
    return $4188c2226d921c1d$var$_objectSpread($4188c2226d921c1d$var$_objectSpread({}, restSelectProps), {}, {
        options: options,
        isLoading: isLoading || propsIsLoading,
        onInputChange: onInputChange,
        filterOption: filterOption
    });
}



var $25nEq = parcelRequire("25nEq");

var $iYJcE = parcelRequire("iYJcE");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");
var $429ee2bce40219e3$var$_excluded = [
    "defaultInputValue",
    "defaultMenuIsOpen",
    "defaultValue",
    "inputValue",
    "menuIsOpen",
    "onChange",
    "onInputChange",
    "onMenuClose",
    "onMenuOpen",
    "value"
];
function $429ee2bce40219e3$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $429ee2bce40219e3$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $429ee2bce40219e3$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $429ee2bce40219e3$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $429ee2bce40219e3$export$2e2bcd8739ae039(_ref) {
    var _ref$defaultInputValu = _ref.defaultInputValue, defaultInputValue = _ref$defaultInputValu === void 0 ? '' : _ref$defaultInputValu, _ref$defaultMenuIsOpe = _ref.defaultMenuIsOpen, defaultMenuIsOpen = _ref$defaultMenuIsOpe === void 0 ? false : _ref$defaultMenuIsOpe, _ref$defaultValue = _ref.defaultValue, defaultValue = _ref$defaultValue === void 0 ? null : _ref$defaultValue, propsInputValue = _ref.inputValue, propsMenuIsOpen = _ref.menuIsOpen, propsOnChange = _ref.onChange, propsOnInputChange = _ref.onInputChange, propsOnMenuClose = _ref.onMenuClose, propsOnMenuOpen = _ref.onMenuOpen, propsValue = _ref.value, restSelectProps = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $429ee2bce40219e3$var$_excluded);
    var _useState = (0, $5FkrB.useState)(propsInputValue !== undefined ? propsInputValue : defaultInputValue), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), stateInputValue = _useState2[0], setStateInputValue = _useState2[1];
    var _useState3 = (0, $5FkrB.useState)(propsMenuIsOpen !== undefined ? propsMenuIsOpen : defaultMenuIsOpen), _useState4 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState3, 2), stateMenuIsOpen = _useState4[0], setStateMenuIsOpen = _useState4[1];
    var _useState5 = (0, $5FkrB.useState)(propsValue !== undefined ? propsValue : defaultValue), _useState6 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState5, 2), stateValue = _useState6[0], setStateValue = _useState6[1];
    var onChange = (0, $5FkrB.useCallback)(function(value, actionMeta) {
        if (typeof propsOnChange === 'function') propsOnChange(value, actionMeta);
        setStateValue(value);
    }, [
        propsOnChange
    ]);
    var onInputChange = (0, $5FkrB.useCallback)(function(value, actionMeta) {
        var newValue;
        if (typeof propsOnInputChange === 'function') newValue = propsOnInputChange(value, actionMeta);
        setStateInputValue(newValue !== undefined ? newValue : value);
    }, [
        propsOnInputChange
    ]);
    var onMenuOpen = (0, $5FkrB.useCallback)(function() {
        if (typeof propsOnMenuOpen === 'function') propsOnMenuOpen();
        setStateMenuIsOpen(true);
    }, [
        propsOnMenuOpen
    ]);
    var onMenuClose = (0, $5FkrB.useCallback)(function() {
        if (typeof propsOnMenuClose === 'function') propsOnMenuClose();
        setStateMenuIsOpen(false);
    }, [
        propsOnMenuClose
    ]);
    var inputValue = propsInputValue !== undefined ? propsInputValue : stateInputValue;
    var menuIsOpen = propsMenuIsOpen !== undefined ? propsMenuIsOpen : stateMenuIsOpen;
    var value = propsValue !== undefined ? propsValue : stateValue;
    //@ts-ignore react-select unsupported props
    return $429ee2bce40219e3$var$_objectSpread($429ee2bce40219e3$var$_objectSpread({}, restSelectProps), {}, {
        inputValue: inputValue,
        menuIsOpen: menuIsOpen,
        onChange: onChange,
        onInputChange: onInputChange,
        onMenuClose: onMenuClose,
        onMenuOpen: onMenuOpen,
        value: value
    });
}


var $dc5cf7a1de30265f$var$AsyncSelect = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function(props, ref) {
    // when isAsync is true, options are not provided and async props are used, we will enable async
    var isAsyncEnabledInBaseSelect = props.isAsync && !props.options && (!!props.loadOptions || !!props.defaultOptions);
    var stateManagedProps = (0, $4188c2226d921c1d$export$2e2bcd8739ae039)(props);
    // when isAsync is falsy or isAsyncEnabledInBaseSelect is true, we use async props, otherwise we use base props
    var selectAsyncProps = !props.isAsync || isAsyncEnabledInBaseSelect ? stateManagedProps : props;
    var selectProps = (0, $429ee2bce40219e3$export$2e2bcd8739ae039)(selectAsyncProps);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $1b50e9ea35e97ef8$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        ref: ref
    }, selectProps));
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$dc5cf7a1de30265f$export$2e2bcd8739ae039 = $dc5cf7a1de30265f$var$AsyncSelect;



var $5FkrB = parcelRequire("5FkrB");

var $iBNQo = parcelRequire("iBNQo");

var $kqp0i = parcelRequire("kqp0i");

var $iYJcE = parcelRequire("iYJcE");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");

var $eVb4V = parcelRequire("eVb4V");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");
var $afcbb1c069a66f27$var$_excluded = [
    "children"
];
function $afcbb1c069a66f27$export$25d302a5b900a763(defaultGetTokens) {
    var emptyThemeFn = function emptyThemeFn(getTokens, props) {
        return getTokens(props);
    };
    /**
   * Internally, Theme uses React Context, with internal providers and consumers.
   * The React Context passes only a function that gets props, and turns them into tokens. This
   * function gets mixed as more Providers with their own themes are added. This mixed function
   * is ultimately picked up by Consumers, which implement a context consumer internally to fetch
   * the theme.
   */ var ThemeContext = /*#__PURE__*/ (0, $5FkrB.createContext)(defaultGetTokens);
    function useTheme(themeProps) {
        var theme = (0, $5FkrB.useContext)(ThemeContext);
        var themeFn = theme || emptyThemeFn;
        var tokens = themeFn(themeProps);
        return tokens;
    }
    // The Theme Consumer takes a function as its child - this function takes tokens, and the
    // return value is generally a set of nodes with the tokens applied appropriately.
    function Consumer(props) {
        var children = props.children, themeProps = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(props, $afcbb1c069a66f27$var$_excluded);
        // @ts-ignore See issue for more info: https://github.com/Microsoft/TypeScript/issues/10727
        // Argument of type 'Pick<ThemeProps & { children: (tokens: ThemeTokens) => ReactNode; }, Exclude<keyof ThemeProps, "children">>' is not assignable to parameter of type 'ThemeProps'.ts(2345)
        var tokens = useTheme(themeProps);
        // We add a fragment to ensure we don't break people upgrading.
        // Previously they may have been able to pass in undefined without things blowing up.
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).Fragment, null, children(tokens));
    }
    /**
   * The Theme Provider takes regular nodes as its children, but also takes a *theme function*
   * - The theme function takes a set of props, as well as a function (getTokens) that can turn props into tokens.
   * - The getTokens function isn't called immediately - instead the props are passed
   *    through a mix of parent theming functions
   * Children of this provider will receive this mixed theme
   */ function Provider(props) {
        var themeFn = (0, $5FkrB.useContext)(ThemeContext);
        var valueFn = props.value || emptyThemeFn;
        var mixedFn = (0, $5FkrB.useCallback)(function(themeProps) {
            return valueFn(themeFn, themeProps);
        }, [
            themeFn,
            valueFn
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(ThemeContext.Provider, {
            value: mixedFn
        }, props.children);
    }
    return {
        Consumer: Consumer,
        Provider: Provider,
        useTheme: useTheme
    };
}


// Create default global light theme
var $decabc00c2109e50$var$_createTheme = (0, $afcbb1c069a66f27$export$25d302a5b900a763)(function() {
    return {
        mode: 'light'
    };
}), $decabc00c2109e50$var$Provider = $decabc00c2109e50$var$_createTheme.Provider, $decabc00c2109e50$var$Consumer = $decabc00c2109e50$var$_createTheme.Consumer, $decabc00c2109e50$export$7692396083754928 = $decabc00c2109e50$var$_createTheme.useTheme;
var $decabc00c2109e50$var$Theme = {
    Provider: $decabc00c2109e50$var$Provider,
    Consumer: $decabc00c2109e50$var$Consumer
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$decabc00c2109e50$export$2e2bcd8739ae039 = $decabc00c2109e50$var$Theme;



var $kqp0i = parcelRequire("kqp0i");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");

var $74Zh5 = parcelRequire("74Zh5");


var $eVb4V = parcelRequire("eVb4V");

var $gpUQB = parcelRequire("gpUQB");

var $eYQvF = parcelRequire("eYQvF");

var $eqVaP = parcelRequire("eqVaP");

function $560344d8e4093add$var$abort(event) {
    event.preventDefault();
    event.stopPropagation();
}
var $560344d8e4093add$var$tabKeyCode = 9;
function $560344d8e4093add$var$onKey(event) {
    // Allowing tab so that a user can move focus away
    if (event.keyCode === $560344d8e4093add$var$tabKeyCode) return;
    $560344d8e4093add$var$abort(event);
}
var $560344d8e4093add$var$block = {
    onMouseDownCapture: $560344d8e4093add$var$abort,
    onMouseUpCapture: $560344d8e4093add$var$abort,
    // because we have tabIndex = -1 when disabled,
    // keyboard events can only occur when there is an overlay
    onKeyDownCapture: $560344d8e4093add$var$onKey,
    onKeyUpCapture: $560344d8e4093add$var$onKey,
    onTouchStartCapture: $560344d8e4093add$var$abort,
    onTouchEndCapture: $560344d8e4093add$var$abort,
    onPointerDownCapture: $560344d8e4093add$var$abort,
    onPointerUpCapture: $560344d8e4093add$var$abort,
    onClickCapture: $560344d8e4093add$var$abort,
    // Just smashing the existing onClick for good measure
    onClick: $560344d8e4093add$var$abort
};
var $560344d8e4093add$var$doNotBlock = {};
function $560344d8e4093add$export$2e2bcd8739ae039(_ref) {
    var isInteractive = _ref.isInteractive;
    return isInteractive ? $560344d8e4093add$var$doNotBlock : $560344d8e4093add$var$block;
}



var $25nEq = parcelRequire("25nEq");

var $74Zh5 = parcelRequire("74Zh5");

var $9Zzpd = parcelRequire("9Zzpd");
function $d8709136c62849ac$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $d8709136c62849ac$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $d8709136c62849ac$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $d8709136c62849ac$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $d8709136c62849ac$var$gridSize = 8;
var $d8709136c62849ac$var$HAS_DISABLED_BACKGROUND = [
    'default',
    'primary',
    'danger',
    'warning'
];
// ## Button layout
//
// /------------------------------------------------------------------------------------------------------------------\
// |       →  |  ←      |          |      →  |  ←      |           |      →  |  ←      |         |      →  |  ←       |
// |  10px →  |  ← 2px  |   icon   |  2px →  |  ← 2px  |           |  2px →  |  ← 2px  |  icon   |  2px →  |  ← 10px  |
// |  padding |  margin |  before  |  margin |  margin |  content  |  margin |  margin |  after  |  margin |  padding |
// |    (12px total)    |          |    (4px total)    |           |    (4px total)    |         |    (12px total)    |
// |       →  |  ←      |          |      →  |  ←      |           |      →  |  ←      |         |      →  |  ←       |
// \------------------------------------------------------------------------------------------------------------------/
//                                           ↑                               ↑
//                                        Margins don't collapse with inline-flex
//
var $d8709136c62849ac$var$heights = {
    default: "".concat(32 / 14, "em"),
    // 32px
    compact: "".concat(24 / 14, "em"),
    none: 'auto'
};
var $d8709136c62849ac$var$lineHeights = {
    default: $d8709136c62849ac$var$heights.default,
    compact: $d8709136c62849ac$var$heights.compact,
    none: 'inherit'
};
var $d8709136c62849ac$var$padding = {
    // 10px gutter
    default: "0 ".concat($d8709136c62849ac$var$gridSize + $d8709136c62849ac$var$gridSize / 4, "px"),
    compact: "0 ".concat($d8709136c62849ac$var$gridSize + $d8709136c62849ac$var$gridSize / 4, "px"),
    none: '0'
};
var $d8709136c62849ac$var$singleIconPadding = {
    // 2px gutter
    compact: "0 ".concat($d8709136c62849ac$var$gridSize / 4, "px"),
    default: "0 ".concat($d8709136c62849ac$var$gridSize / 4, "px"),
    none: '0'
};
var $d8709136c62849ac$var$verticalAlign = {
    default: 'middle',
    compact: 'middle',
    none: 'baseline'
};
var $d8709136c62849ac$var$innerMargin = {
    content: "0 ".concat($d8709136c62849ac$var$gridSize / 4, "px"),
    icon: "0 ".concat($d8709136c62849ac$var$gridSize / 4, "px")
};
var $d8709136c62849ac$var$defaultAfterStyles = {
    borderRadius: 'inherit',
    inset: "var(--ds-space-0, 0px)",
    borderStyle: 'solid',
    borderWidth: "var(--ds-border-width, 1px)",
    pointerEvents: 'none',
    position: 'absolute'
};
var $d8709136c62849ac$var$defaultStyles = {
    background: "var(--ds-background-neutral-subtle, #00000000)",
    color: "var(--ds-text, #292A2E)",
    '&::after': $d8709136c62849ac$var$_objectSpread($d8709136c62849ac$var$_objectSpread({}, $d8709136c62849ac$var$defaultAfterStyles), {}, {
        content: '""',
        borderColor: "var(--ds-border, #0B120E24)"
    }),
    '&:hover': {
        background: "var(--ds-background-neutral-hovered, #0B120E24)"
    },
    '&:active': {
        background: "var(--ds-background-neutral-pressed, #080F214A)"
    },
    '&[data-has-overlay="true"]:not([disabled]):hover': {
        background: "var(--ds-background-neutral-subtle, #00000000)"
    },
    '&:disabled[disabled]': {
        background: "var(--ds-background-neutral-subtle, #00000000)"
    },
    '&:disabled[disabled]:hover': {
        background: "var(--ds-background-neutral-subtle, #00000000)"
    },
    '&:disabled[disabled]:active': {
        background: "var(--ds-background-neutral-subtle, #00000000)"
    }
};
var $d8709136c62849ac$var$primaryStyles = {
    background: "var(--ds-background-brand-bold, #1868DB)",
    color: "var(--ds-text-inverse, #FFFFFF)",
    '&:hover': {
        background: "var(--ds-background-brand-bold-hovered, #1558BC)"
    },
    '&:active': {
        background: "var(--ds-background-brand-bold-pressed, #144794)"
    },
    '&[data-has-overlay="true"]:not([disabled]):hover': {
        background: "var(--ds-background-brand-bold, #1868DB)"
    }
};
var $d8709136c62849ac$var$linkStyles = {
    background: 'transparent',
    color: "var(--ds-link, #1868DB)",
    '&:hover': {
        color: "var(--ds-link, #1868DB)",
        textDecoration: 'underline'
    },
    '&:active': {
        color: "var(--ds-link-pressed, #1558BC)",
        textDecoration: 'underline'
    }
};
var $d8709136c62849ac$var$subtleStyles = {
    background: 'transparent',
    color: "var(--ds-text-subtle, #505258)",
    '&:hover': {
        background: "var(--ds-background-neutral-subtle-hovered, #0515240F)"
    },
    '&:active': {
        background: "var(--ds-background-neutral-subtle-pressed, #0B120E24)"
    },
    '&[data-has-overlay="true"]:not([disabled]):hover': {
        background: 'transparent'
    }
};
var $d8709136c62849ac$var$subtleLinkStyles = {
    background: 'transparent',
    color: "var(--ds-text-subtle, #505258)",
    '&:hover': {
        background: 'transparent',
        color: "var(--ds-text-subtle, #505258)",
        textDecoration: 'underline'
    },
    '&:active': {
        background: 'transparent',
        color: "var(--ds-text, #292A2E)",
        textDecoration: 'underline'
    }
};
var $d8709136c62849ac$var$warningStyles = {
    background: "var(--ds-background-warning-bold, #FBC828)",
    color: "var(--ds-text-warning-inverse, #292A2E)",
    '&:hover': {
        background: "var(--ds-background-warning-bold-hovered, #FCA700)"
    },
    '&:active': {
        background: "var(--ds-background-warning-bold-pressed, #F68909)"
    },
    '&[data-has-overlay="true"]:not([disabled]):hover': {
        background: "var(--ds-background-warning-bold, #FBC828)"
    }
};
var $d8709136c62849ac$var$dangerStyles = {
    background: "var(--ds-background-danger-bold, #C9372C)",
    color: "var(--ds-text-inverse, #FFFFFF)",
    '&:hover': {
        background: "var(--ds-background-danger-bold-hovered, #AE2E24)"
    },
    '&:active': {
        background: "var(--ds-background-danger-bold-pressed, #872821)"
    },
    '&[data-has-overlay="true"]:not([disabled]):hover': {
        background: "var(--ds-background-danger-bold, #C9372C)"
    }
};
var $d8709136c62849ac$var$selectedStyles = {
    background: "var(--ds-background-selected, #E9F2FE)",
    color: "var(--ds-text-selected, #1868DB)",
    '&:not([disabled])::after': $d8709136c62849ac$var$_objectSpread($d8709136c62849ac$var$_objectSpread({}, $d8709136c62849ac$var$defaultAfterStyles), {}, {
        content: '""',
        borderColor: "var(--ds-border-selected, #1868DB)"
    })
};
var $d8709136c62849ac$var$hasOverlayStyles = {
    '&[data-has-overlay="true"]': {
        cursor: 'default',
        textDecoration: 'none'
    }
};
function $d8709136c62849ac$export$955358618f994a11(_ref) {
    var appearance = _ref.appearance, spacing = _ref.spacing, isSelected = _ref.isSelected, shouldFitContainer = _ref.shouldFitContainer, isOnlySingleIcon = _ref.isOnlySingleIcon;
    return $d8709136c62849ac$var$_objectSpread($d8709136c62849ac$var$_objectSpread({
        // 0px margin added to css-reset
        alignItems: 'baseline',
        borderWidth: 0,
        borderRadius: (0, $9Zzpd.fg)('platform-dst-shape-theme-default') ? "var(--ds-radius-medium, 6px)" : "var(--ds-radius-small, 3px)",
        boxSizing: 'border-box',
        display: 'inline-flex',
        fontSize: 'inherit',
        fontStyle: 'normal',
        // Chrome recently changed button so that they use 'arial' as the font family
        fontFamily: 'inherit',
        fontWeight: "var(--ds-font-weight-medium, 500)",
        // margin for button has been applied to css reset
        maxWidth: '100%',
        // Needed to position overlay
        position: 'relative',
        textAlign: 'center',
        textDecoration: 'none',
        transition: 'background 0.1s ease-out, box-shadow 0.15s cubic-bezier(0.47, 0.03, 0.49, 1.38)',
        whiteSpace: 'nowrap',
        cursor: 'pointer',
        height: $d8709136c62849ac$var$heights[spacing],
        lineHeight: $d8709136c62849ac$var$lineHeights[spacing],
        padding: isOnlySingleIcon ? $d8709136c62849ac$var$singleIconPadding[spacing] : $d8709136c62849ac$var$padding[spacing],
        verticalAlign: $d8709136c62849ac$var$verticalAlign[spacing],
        width: shouldFitContainer ? '100%' : 'auto',
        // justifyContent required for shouldFitContainer buttons with an icon inside
        justifyContent: 'center'
    }, isSelected ? $d8709136c62849ac$var$selectedStyles : $d8709136c62849ac$var$_objectSpread($d8709136c62849ac$var$_objectSpread($d8709136c62849ac$var$_objectSpread($d8709136c62849ac$var$_objectSpread($d8709136c62849ac$var$_objectSpread($d8709136c62849ac$var$_objectSpread($d8709136c62849ac$var$_objectSpread($d8709136c62849ac$var$_objectSpread({}, appearance === 'default' && $d8709136c62849ac$var$defaultStyles), appearance === 'primary' && $d8709136c62849ac$var$primaryStyles), appearance === 'link' && $d8709136c62849ac$var$linkStyles), appearance === 'subtle' && $d8709136c62849ac$var$subtleStyles), appearance === 'subtle-link' && $d8709136c62849ac$var$subtleLinkStyles), appearance === 'warning' && $d8709136c62849ac$var$warningStyles), appearance === 'danger' && $d8709136c62849ac$var$dangerStyles), {}, {
        '&[disabled]': {
            color: "var(--ds-text-disabled, #080F214A)",
            backgroundColor: $d8709136c62849ac$var$HAS_DISABLED_BACKGROUND.includes(appearance) ? "var(--ds-background-disabled, #17171708)" : 'transparent',
            cursor: 'not-allowed',
            textDecoration: 'none',
            '&:hovered': {
                backgroundColor: $d8709136c62849ac$var$HAS_DISABLED_BACKGROUND.includes(appearance) ? "var(--ds-background-disabled, #17171708)" : 'transparent'
            },
            '&:active': {
                backgroundColor: $d8709136c62849ac$var$HAS_DISABLED_BACKGROUND.includes(appearance) ? "var(--ds-background-disabled, #17171708)" : 'transparent'
            }
        }
    }, $d8709136c62849ac$var$hasOverlayStyles)), {}, {
        '&::-moz-focus-inner': {
            border: 0,
            margin: 0,
            padding: 0
        }
    });
}
function $d8709136c62849ac$export$864eea3f4ec3368f(_ref2) {
    var spacing = _ref2.spacing;
    return (0, $74Zh5.css)({
        display: 'flex',
        // icon size cannot grow and shrink
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        margin: spacing === 'none' ? 0 : $d8709136c62849ac$var$innerMargin.icon,
        flexGrow: 0,
        flexShrink: 0,
        alignSelf: 'center',
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        fontSize: 0,
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        lineHeight: 0,
        userSelect: 'none'
    });
}
function $d8709136c62849ac$export$7ad0316cc0dd65a(_ref3) {
    var spacing = _ref3.spacing;
    return (0, $74Zh5.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        margin: spacing === 'none' ? 0 : $d8709136c62849ac$var$innerMargin.content,
        // content can grow and shrink
        flexGrow: 1,
        flexShrink: 1,
        // ellipsis for overflow text
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap'
    });
}
function $d8709136c62849ac$export$1b5827d324e945b1(_ref4) {
    var hasOverlay = _ref4.hasOverlay;
    return (0, $74Zh5.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        opacity: hasOverlay ? 0 : 1,
        transition: 'opacity 0.3s'
    });
}
var $d8709136c62849ac$export$1a9fe1b84c876bb5 = {
    // stretching to full width / height of button
    // this is important as we need it to still block
    // event if clicking in the button's own padding
    position: 'absolute',
    left: 0,
    top: 0,
    right: 0,
    bottom: 0,
    // Putting all children in the center
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
};



var $5FkrB = parcelRequire("5FkrB");

var $e8kqY = parcelRequire("e8kqY");
var $90d470485e0e1196$export$20bbd2efb0d734c4 = function getIfVisuallyHiddenChildren(children) {
    return children && /*#__PURE__*/ (0, $5FkrB.isValidElement)(children) && children.type === (0, $e8kqY.default);
};


var $8d69d0a167bc601f$var$_excluded = [
    "analyticsContext",
    "appearance",
    "autoFocus",
    "buttonCss",
    "children",
    "className",
    "href",
    "component",
    "iconAfter",
    "iconBefore",
    "interactionName",
    "isDisabled",
    "isSelected",
    "onBlur",
    "onClick",
    "onFocus",
    "onMouseDown",
    "overlay",
    "shouldFitContainer",
    "spacing",
    "tabIndex",
    "type",
    "testId"
];
// Disabled buttons will still publish events for nested elements in webkit.
// We are disabling pointer events on child elements so that
// the button will always be the target of events
// Note: firefox does not have this behaviour for child elements
var $8d69d0a167bc601f$var$noPointerEventsOnChildrenCss = {
    '> *': {
        pointerEvents: 'none'
    }
};
/**
 * These CSS variables consumed by the new icons, to allow them to have appropriate
 * padding inside Button while also maintaining spacing for the existing icons.
 *
 * These styles can be removed once the new icons are fully rolled out, feature flag
 * platform-visual-refresh-icons is cleaned up,
 * and we bump Button to set padding based on the new icons.
 */ var $8d69d0a167bc601f$var$iconBeforeSpacingFixStyle = (0, $74Zh5.css)({
    '--ds--button--new-icon-padding-end': "var(--ds-space-025, 2px)",
    '--ds--button--new-icon-padding-start': "var(--ds-space-050, 4px)",
    marginInlineStart: "var(--ds-space-negative-025, -2px)"
});
var $8d69d0a167bc601f$var$iconAfterSpacingFixStyle = (0, $74Zh5.css)({
    '--ds--button--new-icon-padding-end': "var(--ds-space-050, 4px)",
    '--ds--button--new-icon-padding-start': "var(--ds-space-025, 2px)",
    marginInlineEnd: "var(--ds-space-negative-025, -2px)"
});
var $8d69d0a167bc601f$var$getSpacingFix = function getSpacingFix(children, spacingStyles) {
    if (!children || (0, $90d470485e0e1196$export$20bbd2efb0d734c4)(children)) return null;
    return spacingStyles;
};
var $8d69d0a167bc601f$var$getChildren = function getChildren(children, childrenStyles) {
    if ((0, $90d470485e0e1196$export$20bbd2efb0d734c4)(children)) return children;
    return children ? (0, $74Zh5.jsx)("span", {
        css: childrenStyles
    }, children) : null;
};
var $8d69d0a167bc601f$var$ButtonBase = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).forwardRef(function ButtonBase(props, ref) {
    var analyticsContext = props.analyticsContext, _props$appearance = props.appearance, appearance = _props$appearance === void 0 ? 'default' : _props$appearance, _props$autoFocus = props.autoFocus, autoFocus = _props$autoFocus === void 0 ? false : _props$autoFocus, buttonCss = props.buttonCss, children = props.children, className = props.className, href = props.href, _props$component = props.component, Component = _props$component === void 0 ? href ? 'a' : 'button' : _props$component, iconAfter = props.iconAfter, iconBefore = props.iconBefore, interactionName = props.interactionName, _props$isDisabled = props.isDisabled, isDisabled = _props$isDisabled === void 0 ? false : _props$isDisabled, _props$isSelected = props.isSelected, isSelected = _props$isSelected === void 0 ? false : _props$isSelected, onBlur = props.onBlur, _props$onClick = props.onClick, providedOnClick = _props$onClick === void 0 ? (0, $eVb4V.default) : _props$onClick, onFocus = props.onFocus, _props$onMouseDown = props.onMouseDown, providedOnMouseDown = _props$onMouseDown === void 0 ? (0, $eVb4V.default) : _props$onMouseDown, overlay = props.overlay, shouldFitContainer = props.shouldFitContainer, _props$spacing = props.spacing, spacing = _props$spacing === void 0 ? 'default' : _props$spacing, _props$tabIndex = props.tabIndex, tabIndex = _props$tabIndex === void 0 ? 0 : _props$tabIndex, _props$type = props.type, type = _props$type === void 0 ? !href ? 'button' : undefined : _props$type, testId = props.testId, rest = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(props, $8d69d0a167bc601f$var$_excluded);
    var ourRef = (0, $5FkrB.useRef)();
    var setRef = (0, $5FkrB.useCallback)(function(node) {
        ourRef.current = node;
        if (ref == null) return;
        if (typeof ref === 'function') {
            ref(node);
            return;
        }
        // We can write to ref's `current` property, but Typescript does not like it.
        // @ts-ignore
        ref.current = node;
    }, [
        ourRef,
        ref
    ]);
    // Cross browser auto focusing is pretty broken, so we are doing it ourselves
    (0, $gpUQB.default)(ourRef, autoFocus);
    var interactionContext = (0, $5FkrB.useContext)((0, $eqVaP.default));
    var handleClick = (0, $5FkrB.useCallback)(function(e, analyticsEvent) {
        interactionContext && interactionContext.tracePress(interactionName, e.timeStamp);
        providedOnClick(e, analyticsEvent);
    }, [
        providedOnClick,
        interactionContext,
        interactionName
    ]);
    var onClick = (0, $a4990a43141cc076$export$a4687b0234b40e28)({
        fn: handleClick,
        action: 'clicked',
        componentName: 'button',
        packageName: "@atlaskit/button",
        packageVersion: "23.9.3",
        analyticsData: analyticsContext
    });
    // Button currently calls preventDefault, which is not standard button behaviour
    var onMouseDown = (0, $5FkrB.useCallback)(function(event) {
        event.preventDefault();
        providedOnMouseDown(event);
    }, [
        providedOnMouseDown
    ]);
    // Lose focus when becoming disabled (standard button behaviour)
    (0, $5FkrB.useEffect)(function() {
        var el = ourRef.current;
        if (isDisabled && el && el === document.activeElement) el.blur();
    }, [
        isDisabled
    ]);
    // we are 'disabling' input with a button when there is an overlay
    var hasOverlay = Boolean(overlay);
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    var fadeStyles = (0, $74Zh5.css)((0, $d8709136c62849ac$export$1b5827d324e945b1)({
        hasOverlay: hasOverlay
    }));
    var isInteractive = !isDisabled && !hasOverlay;
    /**
   * HACK: Spinner needs to have different colours in the "new" tokens design compared to the old design.
   * For now, while we support both, these styles reach into Spinner when a theme is set, applies the right color.
   * Ticket to remove: https://product-fabric.atlassian.net/browse/DSP-2067.
   */ var spinnerHackCss = {};
    if (isSelected || isDisabled || appearance === 'warning') spinnerHackCss = {
        '[data-theme] & circle': {
            stroke: "".concat(isSelected || isDisabled ? "var(--ds-icon-subtle, ".concat((0, $84873b2431594582$export$c39c0fe0f26207ae), ")") : "var(--ds-icon-warning-inverse, ".concat((0, $84873b2431594582$export$c39c0fe0f26207ae), ")"), " !important")
        }
    };
    return (0, $74Zh5.jsx)((0, $eYQvF.default), null, (0, $74Zh5.jsx)(Component, (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, rest, {
        ref: setRef,
        className: className,
        css: [
            buttonCss,
            isInteractive ? null : $8d69d0a167bc601f$var$noPointerEventsOnChildrenCss
        ],
        "data-has-overlay": hasOverlay ? true : undefined,
        "data-testid": testId,
        disabled: isDisabled,
        href: isInteractive ? href : undefined,
        onBlur: onBlur,
        onClick: onClick,
        onFocus: onFocus,
        onMouseDown: onMouseDown,
        tabIndex: isDisabled ? -1 : tabIndex,
        type: type
    }, (0, $560344d8e4093add$export$2e2bcd8739ae039)({
        isInteractive: isInteractive
    })), iconBefore ? (0, $74Zh5.jsx)("span", {
        css: [
            fadeStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $d8709136c62849ac$export$864eea3f4ec3368f)({
                spacing: spacing
            }),
            $8d69d0a167bc601f$var$getSpacingFix(children, $8d69d0a167bc601f$var$iconBeforeSpacingFixStyle)
        ]
    }, iconBefore) : null, $8d69d0a167bc601f$var$getChildren(children, [
        fadeStyles,
        (0, $d8709136c62849ac$export$7ad0316cc0dd65a)({
            spacing: spacing
        })
    ]), iconAfter ? (0, $74Zh5.jsx)("span", {
        css: [
            fadeStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $d8709136c62849ac$export$864eea3f4ec3368f)({
                spacing: spacing
            }),
            $8d69d0a167bc601f$var$getSpacingFix(children, $8d69d0a167bc601f$var$iconAfterSpacingFixStyle)
        ]
    }, iconAfter) : null, overlay ? (0, $74Zh5.jsx)("span", {
        css: [
            (0, $d8709136c62849ac$export$1a9fe1b84c876bb5),
            spinnerHackCss
        ]
    }, overlay) : null));
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$8d69d0a167bc601f$export$2e2bcd8739ae039 = $8d69d0a167bc601f$var$ButtonBase;




function $1de63c8cb05eb82f$export$2e2bcd8739ae039(_ref) {
    var children = _ref.children, iconBefore = _ref.iconBefore, iconAfter = _ref.iconAfter;
    if ((0, $90d470485e0e1196$export$20bbd2efb0d734c4)(children)) return true;
    if (children) return false;
    if (iconBefore && !iconAfter) return true;
    if (!iconBefore && iconAfter) return true;
    return false;
}


var $e42f2717f86c66ea$var$_excluded = [
    "appearance",
    "children",
    "iconBefore",
    "iconAfter",
    "isSelected",
    "onMouseDown",
    "onMouseUp",
    "shouldFitContainer",
    "spacing"
];
var $e42f2717f86c66ea$var$isFirefox = typeof navigator !== 'undefined' && navigator.userAgent.toLowerCase().indexOf('firefox') > -1;
/**
 * __Button__
 *
 * @deprecated Legacy buttons are deprecated and will be removed from `atlaskit/button` in an upcoming major release. Please use the new Button components from `@atlaskit/button/new`
 *
 * Please refer to the [migration guide](https://atlassian.design/components/button/button-legacy/migration-guide) for further details.
 *
 * A button triggers an event or action. They let users know what will happen next.
 *
 * - [Examples](https://atlassian.design/components/button/button-legacy/examples)
 * - [Code](https://atlassian.design/components/button/button-legacy/code)
 * - [Usage](https://atlassian.design/components/button/button-legacy/usage)
 */ var $e42f2717f86c66ea$var$Button = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).forwardRef(function Button(_ref, ref) {
    var _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'default' : _ref$appearance, children = _ref.children, iconBefore = _ref.iconBefore, iconAfter = _ref.iconAfter, _ref$isSelected = _ref.isSelected, isSelected = _ref$isSelected === void 0 ? false : _ref$isSelected, _ref$onMouseDown = _ref.onMouseDown, providedOnMouseDown = _ref$onMouseDown === void 0 ? (0, $eVb4V.default) : _ref$onMouseDown, _ref$onMouseUp = _ref.onMouseUp, providedOnMouseUp = _ref$onMouseUp === void 0 ? (0, $eVb4V.default) : _ref$onMouseUp, _ref$shouldFitContain = _ref.shouldFitContainer, shouldFitContainer = _ref$shouldFitContain === void 0 ? false : _ref$shouldFitContain, _ref$spacing = _ref.spacing, spacing = _ref$spacing === void 0 ? 'default' : _ref$spacing, rest = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $e42f2717f86c66ea$var$_excluded);
    var _useGlobalTheme = (0, $decabc00c2109e50$export$7692396083754928)(), mode = _useGlobalTheme.mode;
    var isOnlySingleIcon = (0, $1de63c8cb05eb82f$export$2e2bcd8739ae039)({
        children: children,
        iconBefore: iconBefore,
        iconAfter: iconAfter
    });
    var _useState = (0, $5FkrB.useState)(false), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), isActive = _useState2[0], setIsActive = _useState2[1];
    // Wrap onMouseDown / onMouseUp to manually trigger active state
    //  in Firefox
    var onMouseDown = (0, $5FkrB.useCallback)(function(event) {
        providedOnMouseDown(event);
        if ($e42f2717f86c66ea$var$isFirefox) setIsActive(true);
    }, [
        providedOnMouseDown,
        setIsActive
    ]);
    var onMouseUp = (0, $5FkrB.useCallback)(function(event) {
        providedOnMouseUp(event);
        if ($e42f2717f86c66ea$var$isFirefox) setIsActive(false);
    }, [
        providedOnMouseUp,
        setIsActive
    ]);
    var buttonCss = (0, $5FkrB.useMemo)(function() {
        return (0, $d8709136c62849ac$export$955358618f994a11)({
            appearance: appearance,
            spacing: spacing,
            mode: mode,
            isSelected: isSelected,
            shouldFitContainer: shouldFitContainer,
            isOnlySingleIcon: isOnlySingleIcon
        });
    }, [
        appearance,
        spacing,
        mode,
        isSelected,
        shouldFitContainer,
        isOnlySingleIcon
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $8d69d0a167bc601f$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, rest, {
        ref: ref,
        appearance: appearance,
        buttonCss: buttonCss,
        children: children,
        "data-firefox-is-active": isActive ? true : undefined,
        iconAfter: iconAfter,
        iconBefore: iconBefore,
        isSelected: isSelected,
        onMouseDown: onMouseDown,
        onMouseUp: onMouseUp,
        spacing: spacing
    }));
}));
// Tools including enzyme rely on components having a display name
$e42f2717f86c66ea$var$Button.displayName = 'Button';
var $e42f2717f86c66ea$export$2e2bcd8739ae039 = $e42f2717f86c66ea$var$Button;



var $aRMzY = parcelRequire("aRMzY");
var $224fba08f26ec284$export$2e2bcd8739ae039 = (0, $aRMzY.defineMessages)({
    clearAllSelectedItemsButtonText: {
        id: 'paginated-picker.async-select.clear-selection-button.clear-all-selected-items-button-text',
        defaultMessage: 'Clear selection',
        description: 'Clicking this button will unselect all the selected items in the dropdown'
    }
});


var $2ae93fbe0749172b$export$1d4b7cda9e589b53 = function ClearSelectedItemsButton(_ref) {
    var onClear = _ref.onClear;
    // const { createAnalyticsEvent } = useAnalyticsEvents();
    var onClearSelectedItems = (0, $5FkrB.useCallback)(function() {
        // sendAnalytics({
        //   actionSubjectId: 'filterSearchClearSelectedItems',
        //   createAnalyticsEvent,
        //   type,
        // });
        onClear && onClear();
    }, [
        onClear
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $e42f2717f86c66ea$export$2e2bcd8739ae039), {
        onClick: onClearSelectedItems,
        appearance: "subtle-link",
        testId: "paginated-picker.ui.async-select.clear-selection-button.clear-selected-items"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $iBNQo.default), (0, $224fba08f26ec284$export$2e2bcd8739ae039).clearAllSelectedItemsButtonText));
};
var $2ae93fbe0749172b$export$2e2bcd8739ae039 = $2ae93fbe0749172b$export$1d4b7cda9e589b53;



var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");


var $9ztDu = parcelRequire("9ztDu");

var $5FkrB = parcelRequire("5FkrB");

var $iBNQo = parcelRequire("iBNQo");

var $656c973b7454adeb$exports = {};
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3f93f06e22108e36edaead143b4f646b>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty($656c973b7454adeb$exports, "__esModule", {
    value: true
});
$656c973b7454adeb$exports.default = void 0;

var $656c973b7454adeb$var$_react = $656c973b7454adeb$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $656c973b7454adeb$var$_baseNew = $656c973b7454adeb$var$_interopRequireDefault((parcelRequire("eRJCC")));
function $656c973b7454adeb$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "StatusError".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for error statuses and messaging.
Filled status icons provide higher visual contrast to draw attention to important information.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $656c973b7454adeb$var$StatusErrorIcon = (props)=>/*#__PURE__*/ $656c973b7454adeb$var$_react.default.createElement($656c973b7454adeb$var$_baseNew.default, Object.assign({
        name: "StatusErrorIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6.586.603a2 2 0 0 1 2.828 0l5.983 5.983a2 2 0 0 1 0 2.828l-5.983 5.982a2 2 0 0 1-2.828 0L.604 9.414a2 2 0 0 1 0-2.828zM8 10.25a1 1 0 1 0 0 2 1 1 0 0 0 0-2m-.75-6.5V9h1.5V3.75z" clip-rule="evenodd"/>`
    }, props));
$656c973b7454adeb$var$StatusErrorIcon.displayName = 'StatusErrorIcon';
var $656c973b7454adeb$var$_default = $656c973b7454adeb$exports.default = $656c973b7454adeb$var$StatusErrorIcon;



// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
var $241e3cc488d6456b$exports = {};
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */ 'use strict';
var $04981e00d1613787$exports = {};
'use strict';
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */ var $04981e00d1613787$var$_uppercasePattern = /([A-Z])/g;
/**
 * Hyphenates a camelcased string, for example:
 *
 *   > hyphenate('backgroundColor')
 *   < "background-color"
 *
 * For CSS style names, use `hyphenateStyleName` instead which works properly
 * with all vendor prefixes, including `ms`.
 *
 * @param {string} string
 * @return {string}
 */ function $04981e00d1613787$var$hyphenate(string) {
    return string.replace($04981e00d1613787$var$_uppercasePattern, '-$1').toLowerCase();
}
$04981e00d1613787$exports = $04981e00d1613787$var$hyphenate;


var $241e3cc488d6456b$var$msPattern = /^ms-/;
/**
 * Hyphenates a camelcased CSS property name, for example:
 *
 *   > hyphenateStyleName('backgroundColor')
 *   < "background-color"
 *   > hyphenateStyleName('MozTransition')
 *   < "-moz-transition"
 *   > hyphenateStyleName('msTransition')
 *   < "-ms-transition"
 *
 * As Modernizr suggests (http://modernizr.com/docs/#prefixed), an `ms` prefix
 * is converted to `-ms-`.
 *
 * @param {string} string
 * @return {string}
 */ function $241e3cc488d6456b$var$hyphenateStyleName(string) {
    return $04981e00d1613787$exports(string).replace($241e3cc488d6456b$var$msPattern, '-ms-');
}
$241e3cc488d6456b$exports = $241e3cc488d6456b$var$hyphenateStyleName;



var $5FkrB = parcelRequire("5FkrB");
var $7c02449dc3656828$exports = {};
/*
 *          __        ___
 *    _____/ /___  __/ (_)____
 *   / ___/ __/ / / / / / ___/
 *  (__  ) /_/ /_/ / / (__  )
 * /____/\__/\__, /_/_/____/
 *          /____/
 *
 * light - weight css preprocessor @licence MIT
 */ (function(factory) {
    $7c02449dc3656828$exports = factory(null);
})(/** @param {*=} options */ function factory(options) {
    'use strict';
    /**
	 * Notes
	 *
	 * The ['<method name>'] pattern is used to support closure compiler
	 * the jsdoc signatures are also used to the same effect
	 *
	 * ----
	 *
	 * int + int + int === n4 [faster]
	 *
	 * vs
	 *
	 * int === n1 && int === n2 && int === n3
	 *
	 * ----
	 *
	 * switch (int) { case ints...} [faster]
	 *
	 * vs
	 *
	 * if (int == 1 && int === 2 ...)
	 *
	 * ----
	 *
	 * The (first*n1 + second*n2 + third*n3) format used in the property parser
	 * is a simple way to hash the sequence of characters
	 * taking into account the index they occur in
	 * since any number of 3 character sequences could produce duplicates.
	 *
	 * On the other hand sequences that are directly tied to the index of the character
	 * resolve a far more accurate measure, it's also faster
	 * to evaluate one condition in a switch statement
	 * than three in an if statement regardless of the added math.
	 *
	 * This allows the vendor prefixer to be both small and fast.
	 */ var nullptn = /^\0+/g /* matches leading null characters */ ;
    var formatptn = /[\0\r\f]/g /* matches new line, null and formfeed characters */ ;
    var colonptn = /: */g /* splits animation rules */ ;
    var cursorptn = /zoo|gra/ /* assert cursor varient */ ;
    var transformptn = /([,: ])(transform)/g /* vendor prefix transform, older webkit */ ;
    var animationptn = /,+\s*(?![^(]*[)])/g /* splits multiple shorthand notation animations */ ;
    var propertiesptn = / +\s*(?![^(]*[)])/g /* animation properties */ ;
    var elementptn = / *[\0] */g /* selector elements */ ;
    var selectorptn = /,\r+?/g /* splits selectors */ ;
    var andptn = /([\t\r\n ])*\f?&/g /* match & */ ;
    var escapeptn = /:global\(((?:[^\(\)\[\]]*|\[.*\]|\([^\(\)]*\))*)\)/g /* matches :global(.*) */ ;
    var invalidptn = /\W+/g /* removes invalid characters from keyframes */ ;
    var keyframeptn = /@(k\w+)\s*(\S*)\s*/ /* matches @keyframes $1 */ ;
    var plcholdrptn = /::(place)/g /* match ::placeholder varient */ ;
    var readonlyptn = /:(read-only)/g /* match :read-only varient */ ;
    var beforeptn = /\s+(?=[{\];=:>])/g /* matches \s before ] ; = : */ ;
    var afterptn = /([[}=:>])\s+/g /* matches \s after characters [ } = : */ ;
    var tailptn = /(\{[^{]+?);(?=\})/g /* matches tail semi-colons ;} */ ;
    var whiteptn = /\s{2,}/g /* matches repeating whitespace */ ;
    var pseudoptn = /([^\(])(:+) */g /* pseudo element */ ;
    var writingptn = /[svh]\w+-[tblr]{2}/ /* match writing mode property values */ ;
    var gradientptn = /([\w-]+t\()/g /* match *gradient property */ ;
    var supportsptn = /\(\s*(.*)\s*\)/g /* match supports (groups) */ ;
    var propertyptn = /([\s\S]*?);/g /* match properties leading semicolon */ ;
    var selfptn = /-self|flex-/g /* match flex- and -self in align-self: flex-*; */ ;
    var pseudofmt = /[^]*?(:[rp][el]a[\w-]+)[^]*/ /* extrats :readonly or :placholder from selector */ ;
    var trimptn = /[ \t]+$/ /* match tail whitspace */ ;
    var dimensionptn = /stretch|:\s*\w+\-(?:conte|avail)/ /* match max/min/fit-content, fill-available */ ;
    var imgsrcptn = /([^-])(image-set\()/;
    /* vendors */ var webkit = '-webkit-';
    var moz = '-moz-';
    var ms = '-ms-';
    /* character codes */ var SEMICOLON = 59 /* ; */ ;
    var CLOSEBRACES = 125 /* } */ ;
    var OPENBRACES = 123 /* { */ ;
    var OPENPARENTHESES = 40 /* ( */ ;
    var CLOSEPARENTHESES = 41 /* ) */ ;
    var OPENBRACKET = 91 /* [ */ ;
    var CLOSEBRACKET = 93 /* ] */ ;
    var NEWLINE = 10 /* \n */ ;
    var CARRIAGE = 13 /* \r */ ;
    var TAB = 9 /* \t */ ;
    var AT = 64 /* @ */ ;
    var SPACE = 32 /*   */ ;
    var AND = 38 /* & */ ;
    var DASH = 45 /* - */ ;
    var UNDERSCORE = 95 /* _ */ ;
    var STAR = 42 /* * */ ;
    var COMMA = 44 /* , */ ;
    var COLON = 58 /* : */ ;
    var SINGLEQUOTE = 39 /* ' */ ;
    var DOUBLEQUOTE = 34 /* " */ ;
    var FOWARDSLASH = 47 /* / */ ;
    var GREATERTHAN = 62 /* > */ ;
    var PLUS = 43 /* + */ ;
    var TILDE = 126 /* ~ */ ;
    var NULL = 0 /* \0 */ ;
    var FORMFEED = 12 /* \f */ ;
    var VERTICALTAB = 11 /* \v */ ;
    /* special identifiers */ var KEYFRAME = 107 /* k */ ;
    var MEDIA = 109 /* m */ ;
    var SUPPORTS = 115 /* s */ ;
    var PLACEHOLDER = 112 /* p */ ;
    var READONLY = 111 /* o */ ;
    var IMPORT = 105 /* <at>i */ ;
    var CHARSET = 99 /* <at>c */ ;
    var DOCUMENT = 100 /* <at>d */ ;
    var PAGE = 112 /* <at>p */ ;
    var column = 1 /* current column */ ;
    var line = 1 /* current line numebr */ ;
    var pattern = 0 /* :pattern */ ;
    var cascade = 1 /* #id h1 h2 vs h1#id h2#id  */ ;
    var prefix = 1 /* vendor prefix */ ;
    var escape = 1 /* escape :global() pattern */ ;
    var compress = 0 /* compress output */ ;
    var semicolon = 0 /* no/semicolon option */ ;
    var preserve = 0 /* preserve empty selectors */ ;
    /* empty reference */ var array = [];
    /* plugins */ var plugins = [];
    var plugged = 0;
    var should = null;
    /* plugin context */ var POSTS = -2;
    var PREPS = -1;
    var UNKWN = 0;
    var PROPS = 1;
    var BLCKS = 2;
    var ATRUL = 3;
    /* plugin newline context */ var unkwn = 0;
    /* keyframe animation */ var keyed = 1;
    var key = '';
    /* selector namespace */ var nscopealt = '';
    var nscope = '';
    /**
	 * Compile
	 *
	 * @param {Array<string>} parent
	 * @param {Array<string>} current
	 * @param {string} body
	 * @param {number} id
	 * @param {number} depth
	 * @return {string}
	 */ function compile(parent, current, body, id, depth) {
        var bracket = 0 /* brackets [] */ ;
        var comment = 0 /* comments /* // or /* */ ;
        var parentheses = 0 /* functions () */ ;
        var quote = 0 /* quotes '', "" */ ;
        var first = 0 /* first character code */ ;
        var second = 0 /* second character code */ ;
        var code = 0 /* current character code */ ;
        var tail = 0 /* previous character code */ ;
        var trail = 0 /* character before previous code */ ;
        var peak = 0 /* previous non-whitespace code */ ;
        var counter = 0 /* count sequence termination */ ;
        var context = 0 /* track current context */ ;
        var atrule = 0 /* track @at-rule context */ ;
        var pseudo = 0 /* track pseudo token index */ ;
        var caret = 0 /* current character index */ ;
        var format = 0 /* control character formating context */ ;
        var insert = 0 /* auto semicolon insertion */ ;
        var invert = 0 /* inverted selector pattern */ ;
        var length = 0 /* generic length address */ ;
        var eof = body.length /* end of file(length) */ ;
        var eol = eof - 1 /* end of file(characters) */ ;
        var char = '' /* current character */ ;
        var chars = '' /* current buffer of characters */ ;
        var child = '' /* next buffer of characters */ ;
        var out = '' /* compiled body */ ;
        var children = '' /* compiled children */ ;
        var flat = '' /* compiled leafs */ ;
        var selector /* generic selector address */ ;
        var result /* generic address */ ;
        // ...build body
        while(caret < eof){
            code = body.charCodeAt(caret);
            // eof varient
            if (caret === eol) // last character + noop context, add synthetic padding for noop context to terminate
            {
                if (comment + quote + parentheses + bracket !== 0) {
                    if (comment !== 0) code = comment === FOWARDSLASH ? NEWLINE : FOWARDSLASH;
                    quote = parentheses = bracket = 0;
                    eof++;
                    eol++;
                }
            }
            if (comment + quote + parentheses + bracket === 0) {
                // eof varient
                if (caret === eol) {
                    if (format > 0) chars = chars.replace(formatptn, '');
                    if (chars.trim().length > 0) {
                        switch(code){
                            case SPACE:
                            case TAB:
                            case SEMICOLON:
                            case CARRIAGE:
                            case NEWLINE:
                                break;
                            default:
                                chars += body.charAt(caret);
                        }
                        code = SEMICOLON;
                    }
                }
                // auto semicolon insertion
                if (insert === 1) switch(code){
                    // false flags
                    case OPENBRACES:
                    case CLOSEBRACES:
                    case SEMICOLON:
                    case DOUBLEQUOTE:
                    case SINGLEQUOTE:
                    case OPENPARENTHESES:
                    case CLOSEPARENTHESES:
                    case COMMA:
                        insert = 0;
                    // ignore
                    case TAB:
                    case CARRIAGE:
                    case NEWLINE:
                    case SPACE:
                        break;
                    // valid
                    default:
                        insert = 0;
                        length = caret;
                        first = code;
                        caret--;
                        code = SEMICOLON;
                        while(length < eof)switch(body.charCodeAt(length++)){
                            case NEWLINE:
                            case CARRIAGE:
                            case SEMICOLON:
                                ++caret;
                                code = first;
                                length = eof;
                                break;
                            case COLON:
                                if (format > 0) {
                                    ++caret;
                                    code = first;
                                }
                            case OPENBRACES:
                                length = eof;
                        }
                }
                // token varient
                switch(code){
                    case OPENBRACES:
                        chars = chars.trim();
                        first = chars.charCodeAt(0);
                        counter = 1;
                        length = ++caret;
                        while(caret < eof){
                            switch(code = body.charCodeAt(caret)){
                                case OPENBRACES:
                                    counter++;
                                    break;
                                case CLOSEBRACES:
                                    counter--;
                                    break;
                                case FOWARDSLASH:
                                    switch(second = body.charCodeAt(caret + 1)){
                                        // /*, //
                                        case STAR:
                                        case FOWARDSLASH:
                                            caret = delimited(second, caret, eol, body);
                                    }
                                    break;
                                // given "[" === 91 & "]" === 93 hence forth 91 + 1 + 1 === 93
                                case OPENBRACKET:
                                    code++;
                                // given "(" === 40 & ")" === 41 hence forth 40 + 1 === 41
                                case OPENPARENTHESES:
                                    code++;
                                // quote tail delimiter is identical to the head delimiter hence noop,
                                // fallthrough clauses have been shifted to the correct tail delimiter
                                case DOUBLEQUOTE:
                                case SINGLEQUOTE:
                                    while(caret++ < eol){
                                        if (body.charCodeAt(caret) === code) break;
                                    }
                            }
                            if (counter === 0) break;
                            caret++;
                        }
                        child = body.substring(length, caret);
                        if (first === NULL) first = (chars = chars.replace(nullptn, '').trim()).charCodeAt(0);
                        switch(first){
                            // @at-rule
                            case AT:
                                if (format > 0) chars = chars.replace(formatptn, '');
                                second = chars.charCodeAt(1);
                                switch(second){
                                    case DOCUMENT:
                                    case MEDIA:
                                    case SUPPORTS:
                                    case DASH:
                                        selector = current;
                                        break;
                                    default:
                                        selector = array;
                                }
                                child = compile(current, selector, child, second, depth + 1);
                                length = child.length;
                                // preserve empty @at-rule
                                if (preserve > 0 && length === 0) length = chars.length;
                                // execute plugins, @at-rule context
                                if (plugged > 0) {
                                    selector = select(array, chars, invert);
                                    result = proxy(ATRUL, child, selector, current, line, column, length, second, depth, id);
                                    chars = selector.join('');
                                    if (result !== void 0) {
                                        if ((length = (child = result.trim()).length) === 0) {
                                            second = 0;
                                            child = '';
                                        }
                                    }
                                }
                                if (length > 0) switch(second){
                                    case SUPPORTS:
                                        chars = chars.replace(supportsptn, supports);
                                    case DOCUMENT:
                                    case MEDIA:
                                    case DASH:
                                        child = chars + '{' + child + '}';
                                        break;
                                    case KEYFRAME:
                                        chars = chars.replace(keyframeptn, '$1 $2' + (keyed > 0 ? key : ''));
                                        child = chars + '{' + child + '}';
                                        if (prefix === 1 || prefix === 2 && vendor('@' + child, 3)) child = '@' + webkit + child + '@' + child;
                                        else child = '@' + child;
                                        break;
                                    default:
                                        child = chars + child;
                                        if (id === PAGE) child = (out += child, '');
                                }
                                else child = '';
                                break;
                            // selector
                            default:
                                child = compile(current, select(current, chars, invert), child, id, depth + 1);
                        }
                        children += child;
                        // reset
                        context = 0;
                        insert = 0;
                        pseudo = 0;
                        format = 0;
                        invert = 0;
                        atrule = 0;
                        chars = '';
                        child = '';
                        code = body.charCodeAt(++caret);
                        break;
                    case CLOSEBRACES:
                    case SEMICOLON:
                        chars = (format > 0 ? chars.replace(formatptn, '') : chars).trim();
                        if ((length = chars.length) > 1) {
                            // monkey-patch missing colon
                            if (pseudo === 0) {
                                first = chars.charCodeAt(0);
                                // first character is a letter or dash, buffer has a space character
                                if (first === DASH || first > 96 && first < 123) length = (chars = chars.replace(' ', ':')).length;
                            }
                            // execute plugins, property context
                            if (plugged > 0) {
                                if ((result = proxy(PROPS, chars, current, parent, line, column, out.length, id, depth, id)) !== void 0) {
                                    if ((length = (chars = result.trim()).length) === 0) chars = '\0\0';
                                }
                            }
                            first = chars.charCodeAt(0);
                            second = chars.charCodeAt(1);
                            switch(first){
                                case NULL:
                                    break;
                                case AT:
                                    if (second === IMPORT || second === CHARSET) {
                                        flat += chars + body.charAt(caret);
                                        break;
                                    }
                                default:
                                    if (chars.charCodeAt(length - 1) === COLON) break;
                                    out += property(chars, first, second, chars.charCodeAt(2));
                            }
                        }
                        // reset
                        context = 0;
                        insert = 0;
                        pseudo = 0;
                        format = 0;
                        invert = 0;
                        chars = '';
                        code = body.charCodeAt(++caret);
                        break;
                }
            }
            // parse characters
            switch(code){
                case CARRIAGE:
                case NEWLINE:
                    // auto insert semicolon
                    if (comment + quote + parentheses + bracket + semicolon === 0) // valid non-whitespace characters that
                    // may precede a newline
                    switch(peak){
                        case CLOSEPARENTHESES:
                        case SINGLEQUOTE:
                        case DOUBLEQUOTE:
                        case AT:
                        case TILDE:
                        case GREATERTHAN:
                        case STAR:
                        case PLUS:
                        case FOWARDSLASH:
                        case DASH:
                        case COLON:
                        case COMMA:
                        case SEMICOLON:
                        case OPENBRACES:
                        case CLOSEBRACES:
                            break;
                        default:
                            // current buffer has a colon
                            if (pseudo > 0) insert = 1;
                    }
                    // terminate line comment
                    if (comment === FOWARDSLASH) comment = 0;
                    else if (cascade + context === 0 && id !== KEYFRAME && chars.length > 0) {
                        format = 1;
                        chars += '\0';
                    }
                    // execute plugins, newline context
                    if (plugged * unkwn > 0) proxy(UNKWN, chars, current, parent, line, column, out.length, id, depth, id);
                    // next line, reset column position
                    column = 1;
                    line++;
                    break;
                case SEMICOLON:
                case CLOSEBRACES:
                    if (comment + quote + parentheses + bracket === 0) {
                        column++;
                        break;
                    }
                default:
                    // increment column position
                    column++;
                    // current character
                    char = body.charAt(caret);
                    // remove comments, escape functions, strings, attributes and prepare selectors
                    switch(code){
                        case TAB:
                        case SPACE:
                            if (quote + bracket + comment === 0) switch(tail){
                                case COMMA:
                                case COLON:
                                case TAB:
                                case SPACE:
                                    char = '';
                                    break;
                                default:
                                    if (code !== SPACE) char = ' ';
                            }
                            break;
                        // escape breaking control characters
                        case NULL:
                            char = '\\0';
                            break;
                        case FORMFEED:
                            char = '\\f';
                            break;
                        case VERTICALTAB:
                            char = '\\v';
                            break;
                        // &
                        case AND:
                            // inverted selector pattern i.e html &
                            if (quote + comment + bracket === 0 && cascade > 0) {
                                invert = 1;
                                format = 1;
                                char = '\f' + char;
                            }
                            break;
                        // ::p<l>aceholder, l
                        // :read-on<l>y, l
                        case 108:
                            if (quote + comment + bracket + pattern === 0 && pseudo > 0) switch(caret - pseudo){
                                // ::placeholder
                                case 2:
                                    if (tail === PLACEHOLDER && body.charCodeAt(caret - 3) === COLON) pattern = tail;
                                // :read-only
                                case 8:
                                    if (trail === READONLY) pattern = trail;
                            }
                            break;
                        // :<pattern>
                        case COLON:
                            if (quote + comment + bracket === 0) pseudo = caret;
                            break;
                        // selectors
                        case COMMA:
                            if (comment + parentheses + quote + bracket === 0) {
                                format = 1;
                                char += '\r';
                            }
                            break;
                        // quotes
                        case DOUBLEQUOTE:
                        case SINGLEQUOTE:
                            if (comment === 0) quote = quote === code ? 0 : quote === 0 ? code : quote;
                            break;
                        // attributes
                        case OPENBRACKET:
                            if (quote + comment + parentheses === 0) bracket++;
                            break;
                        case CLOSEBRACKET:
                            if (quote + comment + parentheses === 0) bracket--;
                            break;
                        // functions
                        case CLOSEPARENTHESES:
                            if (quote + comment + bracket === 0) parentheses--;
                            break;
                        case OPENPARENTHESES:
                            if (quote + comment + bracket === 0) {
                                if (context === 0) switch(tail * 2 + trail * 3){
                                    // :matches
                                    case 533:
                                        break;
                                    // :global, :not, :nth-child etc...
                                    default:
                                        counter = 0;
                                        context = 1;
                                }
                                parentheses++;
                            }
                            break;
                        case AT:
                            if (comment + parentheses + quote + bracket + pseudo + atrule === 0) atrule = 1;
                            break;
                        // block/line comments
                        case STAR:
                        case FOWARDSLASH:
                            if (quote + bracket + parentheses > 0) break;
                            switch(comment){
                                // initialize line/block comment context
                                case 0:
                                    switch(code * 2 + body.charCodeAt(caret + 1) * 3){
                                        // //
                                        case 235:
                                            comment = FOWARDSLASH;
                                            break;
                                        // /*
                                        case 220:
                                            length = caret;
                                            comment = STAR;
                                            break;
                                    }
                                    break;
                                // end block comment context
                                case STAR:
                                    if (code === FOWARDSLASH && tail === STAR && length + 2 !== caret) {
                                        // /*<!> ... */, !
                                        if (body.charCodeAt(length + 2) === 33) out += body.substring(length, caret + 1);
                                        char = '';
                                        comment = 0;
                                    }
                            }
                    }
                    // ignore comment blocks
                    if (comment === 0) {
                        // aggressive isolation mode, divide each individual selector
                        // including selectors in :not function but excluding selectors in :global function
                        if (cascade + quote + bracket + atrule === 0 && id !== KEYFRAME && code !== SEMICOLON) switch(code){
                            case COMMA:
                            case TILDE:
                            case GREATERTHAN:
                            case PLUS:
                            case CLOSEPARENTHESES:
                            case OPENPARENTHESES:
                                if (context === 0) {
                                    // outside of an isolated context i.e nth-child(<...>)
                                    switch(tail){
                                        case TAB:
                                        case SPACE:
                                        case NEWLINE:
                                        case CARRIAGE:
                                            char = char + '\0';
                                            break;
                                        default:
                                            char = '\0' + char + (code === COMMA ? '' : '\0');
                                    }
                                    format = 1;
                                } else // within an isolated context, sleep untill it's terminated
                                switch(code){
                                    case OPENPARENTHESES:
                                        // :globa<l>(
                                        if (pseudo + 7 === caret && tail === 108) pseudo = 0;
                                        context = ++counter;
                                        break;
                                    case CLOSEPARENTHESES:
                                        if ((context = --counter) === 0) {
                                            format = 1;
                                            char += '\0';
                                        }
                                        break;
                                }
                                break;
                            case TAB:
                            case SPACE:
                                switch(tail){
                                    case NULL:
                                    case OPENBRACES:
                                    case CLOSEBRACES:
                                    case SEMICOLON:
                                    case COMMA:
                                    case FORMFEED:
                                    case TAB:
                                    case SPACE:
                                    case NEWLINE:
                                    case CARRIAGE:
                                        break;
                                    default:
                                        // ignore in isolated contexts
                                        if (context === 0) {
                                            format = 1;
                                            char += '\0';
                                        }
                                }
                        }
                        // concat buffer of characters
                        chars += char;
                        // previous non-whitespace character code
                        if (code !== SPACE && code !== TAB) peak = code;
                    }
            }
            // tail character codes
            trail = tail;
            tail = code;
            // visit every character
            caret++;
        }
        length = out.length;
        // preserve empty selector
        if (preserve > 0) {
            if (length === 0 && children.length === 0 && current[0].length === 0 === false) {
                if (id !== MEDIA || current.length === 1 && (cascade > 0 ? nscopealt : nscope) === current[0]) length = current.join(',').length + 2;
            }
        }
        if (length > 0) {
            // cascade isolation mode?
            selector = cascade === 0 && id !== KEYFRAME ? isolate(current) : current;
            // execute plugins, block context
            if (plugged > 0) {
                result = proxy(BLCKS, out, selector, parent, line, column, length, id, depth, id);
                if (result !== void 0 && (out = result).length === 0) return flat + out + children;
            }
            out = selector.join(',') + '{' + out + '}';
            if (prefix * pattern !== 0) {
                if (prefix === 2 && !vendor(out, 2)) pattern = 0;
                switch(pattern){
                    // ::read-only
                    case READONLY:
                        out = out.replace(readonlyptn, ':' + moz + '$1') + out;
                        break;
                    // ::placeholder
                    case PLACEHOLDER:
                        out = out.replace(plcholdrptn, '::' + webkit + 'input-$1') + out.replace(plcholdrptn, '::' + moz + '$1') + out.replace(plcholdrptn, ':' + ms + 'input-$1') + out;
                        break;
                }
                pattern = 0;
            }
        }
        return flat + out + children;
    }
    /**
	 * Select
	 *
	 * @param {Array<string>} parent
	 * @param {string} current
	 * @param {number} invert
	 * @return {Array<string>}
	 */ function select(parent, current, invert) {
        var selectors = current.trim().split(selectorptn);
        var out = selectors;
        var length = selectors.length;
        var l = parent.length;
        switch(l){
            // 0-1 parent selectors
            case 0:
            case 1:
                for(var i = 0, selector = l === 0 ? '' : parent[0] + ' '; i < length; ++i)out[i] = scope(selector, out[i], invert, l).trim();
                break;
            // >2 parent selectors, nested
            default:
                for(var i = 0, j = 0, out = []; i < length; ++i)for(var k = 0; k < l; ++k)out[j++] = scope(parent[k] + ' ', selectors[i], invert, l).trim();
        }
        return out;
    }
    /**
	 * Scope
	 *
	 * @param {string} parent
	 * @param {string} current
	 * @param {number} invert
	 * @param {number} level
	 * @return {string}
	 */ function scope(parent, current, invert, level) {
        var selector = current;
        var code = selector.charCodeAt(0);
        // trim leading whitespace
        if (code < 33) code = (selector = selector.trim()).charCodeAt(0);
        switch(code){
            // &
            case AND:
                switch(cascade + level){
                    case 0:
                    case 1:
                        if (parent.trim().length === 0) break;
                    default:
                        return selector.replace(andptn, '$1' + parent.trim());
                }
                break;
            // :
            case COLON:
                switch(selector.charCodeAt(1)){
                    // g in :global
                    case 103:
                        if (escape > 0 && cascade > 0) return selector.replace(escapeptn, '$1').replace(andptn, '$1' + nscope);
                        break;
                    default:
                        // :hover
                        return parent.trim() + selector.replace(andptn, '$1' + parent.trim());
                }
            default:
                // html &
                if (invert * cascade > 0 && selector.indexOf('\f') > 0) return selector.replace(andptn, (parent.charCodeAt(0) === COLON ? '' : '$1') + parent.trim());
        }
        return parent + selector;
    }
    /**
	 * Property
	 *
	 * @param {string} input
	 * @param {number} first
	 * @param {number} second
	 * @param {number} third
	 * @return {string}
	 */ function property(input, first, second, third) {
        var index = 0;
        var out = input + ';';
        var hash = first * 2 + second * 3 + third * 4;
        var cache;
        // animation: a, n, i characters
        if (hash === 944) return animation(out);
        else if (prefix === 0 || prefix === 2 && !vendor(out, 1)) return out;
        // vendor prefix
        switch(hash){
            // text-decoration/text-size-adjust/text-shadow/text-align/text-transform: t, e, x
            case 1015:
                // text-shadow/text-align/text-transform, a
                return out.charCodeAt(10) === 97 ? webkit + out + out : out;
            // filter/fill f, i, l
            case 951:
                // filter, t
                return out.charCodeAt(3) === 116 ? webkit + out + out : out;
            // color/column, c, o, l
            case 963:
                // column, n
                return out.charCodeAt(5) === 110 ? webkit + out + out : out;
            // box-decoration-break, b, o, x
            case 1009:
                if (out.charCodeAt(4) !== 100) break;
            // mask, m, a, s
            // clip-path, c, l, i
            case 969:
            case 942:
                return webkit + out + out;
            // appearance: a, p, p
            case 978:
                return webkit + out + moz + out + out;
            // hyphens: h, y, p
            // user-select: u, s, e
            case 1019:
            case 983:
                return webkit + out + moz + out + ms + out + out;
            // background/backface-visibility, b, a, c
            case 883:
                // backface-visibility, -
                if (out.charCodeAt(8) === DASH) return webkit + out + out;
                // image-set(...)
                if (out.indexOf('image-set(', 11) > 0) return out.replace(imgsrcptn, '$1' + webkit + '$2') + out;
                return out;
            // flex: f, l, e
            case 932:
                if (out.charCodeAt(4) === DASH) switch(out.charCodeAt(5)){
                    // flex-grow, g
                    case 103:
                        return webkit + 'box-' + out.replace('-grow', '') + webkit + out + ms + out.replace('grow', 'positive') + out;
                    // flex-shrink, s
                    case 115:
                        return webkit + out + ms + out.replace('shrink', 'negative') + out;
                    // flex-basis, b
                    case 98:
                        return webkit + out + ms + out.replace('basis', 'preferred-size') + out;
                }
                return webkit + out + ms + out + out;
            // order: o, r, d
            case 964:
                return webkit + out + ms + 'flex' + '-' + out + out;
            // justify-items/justify-content, j, u, s
            case 1023:
                // justify-content, c
                if (out.charCodeAt(8) !== 99) break;
                cache = out.substring(out.indexOf(':', 15)).replace('flex-', '').replace('space-between', 'justify');
                return webkit + 'box-pack' + cache + webkit + out + ms + 'flex-pack' + cache + out;
            // cursor, c, u, r
            case 1005:
                return cursorptn.test(out) ? out.replace(colonptn, ':' + webkit) + out.replace(colonptn, ':' + moz) + out : out;
            // writing-mode, w, r, i
            case 1000:
                cache = out.substring(13).trim();
                index = cache.indexOf('-') + 1;
                switch(cache.charCodeAt(0) + cache.charCodeAt(index)){
                    // vertical-lr
                    case 226:
                        cache = out.replace(writingptn, 'tb');
                        break;
                    // vertical-rl
                    case 232:
                        cache = out.replace(writingptn, 'tb-rl');
                        break;
                    // horizontal-tb
                    case 220:
                        cache = out.replace(writingptn, 'lr');
                        break;
                    default:
                        return out;
                }
                return webkit + out + ms + cache + out;
            // position: sticky
            case 1017:
                if (out.indexOf('sticky', 9) === -1) return out;
            // display(flex/inline-flex/inline-box): d, i, s
            case 975:
                index = (out = input).length - 10;
                cache = (out.charCodeAt(index) === 33 ? out.substring(0, index) : out).substring(input.indexOf(':', 7) + 1).trim();
                switch(hash = cache.charCodeAt(0) + (cache.charCodeAt(7) | 0)){
                    // inline-
                    case 203:
                        // inline-box
                        if (cache.charCodeAt(8) < 111) break;
                    // inline-box/sticky
                    case 115:
                        out = out.replace(cache, webkit + cache) + ';' + out;
                        break;
                    // inline-flex
                    // flex
                    case 207:
                    case 102:
                        out = out.replace(cache, webkit + (hash > 102 ? 'inline-' : '') + 'box') + ';' + out.replace(cache, webkit + cache) + ';' + out.replace(cache, ms + cache + 'box') + ';' + out;
                }
                return out + ';';
            // align-items, align-center, align-self: a, l, i, -
            case 938:
                if (out.charCodeAt(5) === DASH) switch(out.charCodeAt(6)){
                    // align-items, i
                    case 105:
                        cache = out.replace('-items', '');
                        return webkit + out + webkit + 'box-' + cache + ms + 'flex-' + cache + out;
                    // align-self, s
                    case 115:
                        return webkit + out + ms + 'flex-item-' + out.replace(selfptn, '') + out;
                    // align-content
                    default:
                        return webkit + out + ms + 'flex-line-pack' + out.replace('align-content', '').replace(selfptn, '') + out;
                }
                break;
            // min/max
            case 973:
            case 989:
                // min-/max- height/width/block-size/inline-size
                if (out.charCodeAt(3) !== DASH || out.charCodeAt(4) === 122) break;
            // height/width: min-content / width: max-content
            case 931:
            case 953:
                if (dimensionptn.test(input) === true) {
                    // stretch
                    if ((cache = input.substring(input.indexOf(':') + 1)).charCodeAt(0) === 115) return property(input.replace('stretch', 'fill-available'), first, second, third).replace(':fill-available', ':stretch');
                    else return out.replace(cache, webkit + cache) + out.replace(cache, moz + cache.replace('fill-', '')) + out;
                }
                break;
            // transform, transition: t, r, a
            case 962:
                out = webkit + out + (out.charCodeAt(5) === 102 ? ms + out : '') + out;
                // transitions
                if (second + third === 211 && out.charCodeAt(13) === 105 && out.indexOf('transform', 10) > 0) return out.substring(0, out.indexOf(';', 27) + 1).replace(transformptn, '$1' + webkit + '$2') + out;
                break;
        }
        return out;
    }
    /**
	 * Vendor
	 *
	 * @param {string} content
	 * @param {number} context
	 * @return {boolean}
	 */ function vendor(content, context) {
        var index = content.indexOf(context === 1 ? ':' : '{');
        var key = content.substring(0, context !== 3 ? index : 10);
        var value = content.substring(index + 1, content.length - 1);
        return should(context !== 2 ? key : key.replace(pseudofmt, '$1'), value, context);
    }
    /**
	 * Supports
	 *
	 * @param {string} match
	 * @param {string} group
	 * @return {string}
	 */ function supports(match, group) {
        var out = property(group, group.charCodeAt(0), group.charCodeAt(1), group.charCodeAt(2));
        return out !== group + ';' ? out.replace(propertyptn, ' or ($1)').substring(4) : '(' + group + ')';
    }
    /**
	 * Animation
	 *
	 * @param {string} input
	 * @return {string}
	 */ function animation(input) {
        var length = input.length;
        var index = input.indexOf(':', 9) + 1;
        var declare = input.substring(0, index).trim();
        var out = input.substring(index, length - 1).trim();
        switch(input.charCodeAt(9) * keyed){
            case 0:
                break;
            // animation-*, -
            case DASH:
                // animation-name, n
                if (input.charCodeAt(10) !== 110) break;
            // animation/animation-name
            default:
                // split in case of multiple animations
                var list = out.split((out = '', animationptn));
                for(var i = 0, index = 0, length = list.length; i < length; index = 0, ++i){
                    var value = list[i];
                    var items = value.split(propertiesptn);
                    while(value = items[index]){
                        var peak = value.charCodeAt(0);
                        if (keyed === 1 && (// letters
                        peak > AT && peak < 90 || peak > 96 && peak < 123 || peak === UNDERSCORE || // dash but not in sequence i.e --
                        peak === DASH && value.charCodeAt(1) !== DASH)) // not a number/function
                        switch(isNaN(parseFloat(value)) + (value.indexOf('(') !== -1)){
                            case 1:
                                switch(value){
                                    // not a valid reserved keyword
                                    case 'infinite':
                                    case 'alternate':
                                    case 'backwards':
                                    case 'running':
                                    case 'normal':
                                    case 'forwards':
                                    case 'both':
                                    case 'none':
                                    case 'linear':
                                    case 'ease':
                                    case 'ease-in':
                                    case 'ease-out':
                                    case 'ease-in-out':
                                    case 'paused':
                                    case 'reverse':
                                    case 'alternate-reverse':
                                    case 'inherit':
                                    case 'initial':
                                    case 'unset':
                                    case 'step-start':
                                    case 'step-end':
                                        break;
                                    default:
                                        value += key;
                                }
                        }
                        items[index++] = value;
                    }
                    out += (i === 0 ? '' : ',') + items.join(' ');
                }
        }
        out = declare + out + ';';
        if (prefix === 1 || prefix === 2 && vendor(out, 1)) return webkit + out + out;
        return out;
    }
    /**
	 * Isolate
	 *
	 * @param {Array<string>} current
	 */ function isolate(current) {
        for(var i = 0, length = current.length, selector = Array(length), padding, element; i < length; ++i){
            // split individual elements in a selector i.e h1 h2 === [h1, h2]
            var elements = current[i].split(elementptn);
            var out = '';
            for(var j = 0, size = 0, tail = 0, code = 0, l = elements.length; j < l; ++j){
                // empty element
                if ((size = (element = elements[j]).length) === 0 && l > 1) continue;
                tail = out.charCodeAt(out.length - 1);
                code = element.charCodeAt(0);
                padding = '';
                if (j !== 0) // determine if we need padding
                switch(tail){
                    case STAR:
                    case TILDE:
                    case GREATERTHAN:
                    case PLUS:
                    case SPACE:
                    case OPENPARENTHESES:
                        break;
                    default:
                        padding = ' ';
                }
                switch(code){
                    case AND:
                        element = padding + nscopealt;
                    case TILDE:
                    case GREATERTHAN:
                    case PLUS:
                    case SPACE:
                    case CLOSEPARENTHESES:
                    case OPENPARENTHESES:
                        break;
                    case OPENBRACKET:
                        element = padding + element + nscopealt;
                        break;
                    case COLON:
                        switch(element.charCodeAt(1) * 2 + element.charCodeAt(2) * 3){
                            // :global
                            case 530:
                                if (escape > 0) {
                                    element = padding + element.substring(8, size - 1);
                                    break;
                                }
                            // :hover, :nth-child(), ...
                            default:
                                if (j < 1 || elements[j - 1].length < 1) element = padding + nscopealt + element;
                        }
                        break;
                    case COMMA:
                        padding = '';
                    default:
                        if (size > 1 && element.indexOf(':') > 0) element = padding + element.replace(pseudoptn, '$1' + nscopealt + '$2');
                        else element = padding + element + nscopealt;
                }
                out += element;
            }
            selector[i] = out.replace(formatptn, '').trim();
        }
        return selector;
    }
    /**
	 * Proxy
	 *
	 * @param {number} context
	 * @param {string} content
	 * @param {Array<string>} selectors
	 * @param {Array<string>} parents
	 * @param {number} line
	 * @param {number} column
	 * @param {number} length
	 * @param {number} id
	 * @param {number} depth
	 * @param {number} at
	 * @return {(string|void|*)}
	 */ function proxy(context, content, selectors, parents, line, column, length, id, depth, at) {
        for(var i = 0, out = content, next; i < plugged; ++i)switch(next = plugins[i].call(stylis, context, out, selectors, parents, line, column, length, id, depth, at)){
            case void 0:
            case false:
            case true:
            case null:
                break;
            default:
                out = next;
        }
        if (out !== content) return out;
    }
    /**
	 * @param {number} code
	 * @param {number} index
	 * @param {number} length
	 * @param {string} body
	 * @return {number}
	 */ function delimited(code, index, length, body) {
        for(var i = index + 1; i < length; ++i)switch(body.charCodeAt(i)){
            // /*
            case FOWARDSLASH:
                if (code === STAR) {
                    if (body.charCodeAt(i - 1) === STAR && index + 2 !== i) return i + 1;
                }
                break;
            // //
            case NEWLINE:
                if (code === FOWARDSLASH) return i + 1;
        }
        return i;
    }
    /**
	 * @param {number} type
	 * @param {number} index
	 * @param {number} length
	 * @param {number} find
	 * @param {string} body
	 * @return {number}
	 */ function match(type, index, length, body) {
        for(var i = index + 1; i < length; ++i)switch(body.charCodeAt(i)){
            case type:
                return i;
        }
        return i;
    }
    /**
	 * Minify
	 *
	 * @param {(string|*)} output
	 * @return {string}
	 */ function minify(output) {
        return output.replace(formatptn, '').replace(beforeptn, '').replace(afterptn, '$1').replace(tailptn, '$1').replace(whiteptn, ' ');
    }
    /**
	 * Use
	 *
	 * @param {(Array<function(...?)>|function(...?)|number|void)?} plugin
	 */ function use(plugin) {
        switch(plugin){
            case void 0:
            case null:
                plugged = plugins.length = 0;
                break;
            default:
                if (typeof plugin === 'function') plugins[plugged++] = plugin;
                else if (typeof plugin === 'object') for(var i = 0, length = plugin.length; i < length; ++i)use(plugin[i]);
                else unkwn = !!plugin | 0;
        }
        return use;
    }
    /**
	 * Set
	 *
	 * @param {*} options
	 */ function set(options) {
        for(var name in options){
            var value = options[name];
            switch(name){
                case 'keyframe':
                    keyed = value | 0;
                    break;
                case 'global':
                    escape = value | 0;
                    break;
                case 'cascade':
                    cascade = value | 0;
                    break;
                case 'compress':
                    compress = value | 0;
                    break;
                case 'semicolon':
                    semicolon = value | 0;
                    break;
                case 'preserve':
                    preserve = value | 0;
                    break;
                case 'prefix':
                    should = null;
                    if (!value) prefix = 0;
                    else if (typeof value !== 'function') prefix = 1;
                    else {
                        prefix = 2;
                        should = value;
                    }
            }
        }
        return set;
    }
    /**
	 * Stylis
	 *
	 * @param {string} selector
	 * @param {string} input
	 * @return {*}
	 */ function stylis(selector, input) {
        if (this !== void 0 && this.constructor === stylis) return factory(selector);
        // setup
        var ns = selector;
        var code = ns.charCodeAt(0);
        // trim leading whitespace
        if (code < 33) code = (ns = ns.trim()).charCodeAt(0);
        // keyframe/animation namespace
        if (keyed > 0) key = ns.replace(invalidptn, code === OPENBRACKET ? '' : '-');
        // reset, used to assert if a plugin is moneky-patching the return value
        code = 1;
        // cascade/isolate
        if (cascade === 1) nscope = ns;
        else nscopealt = ns;
        var selectors = [
            nscope
        ];
        var result;
        // execute plugins, pre-process context
        if (plugged > 0) {
            result = proxy(PREPS, input, selectors, selectors, line, column, 0, 0, 0, 0);
            if (result !== void 0 && typeof result === 'string') input = result;
        }
        // build
        var output = compile(array, selectors, input, 0, 0);
        // execute plugins, post-process context
        if (plugged > 0) {
            result = proxy(POSTS, output, selectors, selectors, line, column, output.length, 0, 0, 0);
            // bypass minification
            if (result !== void 0 && typeof (output = result) !== 'string') code = 0;
        }
        // reset
        key = '';
        nscope = '';
        nscopealt = '';
        pattern = 0;
        line = 1;
        column = 1;
        return compress * code === 0 ? output : minify(output);
    }
    stylis['use'] = use;
    stylis['set'] = set;
    if (options !== void 0) set(options);
    return stylis;
});


var $7fc04fdd1bed7963$exports = {};
(function(factory) {
    $7fc04fdd1bed7963$exports = factory();
})(function() {
    'use strict';
    return function(insertRule) {
        var delimiter = '/*|*/';
        var needle = delimiter + '}';
        function toSheet(block) {
            if (block) try {
                insertRule(block + '}');
            } catch (e) {}
        }
        return function ruleSheet(context, content, selectors, parents, line, column, length, ns, depth, at) {
            switch(context){
                // property
                case 1:
                    // @import
                    if (depth === 0 && content.charCodeAt(0) === 64) return insertRule(content + ';'), '';
                    break;
                // selector
                case 2:
                    if (ns === 0) return content + delimiter;
                    break;
                // at-rule
                case 3:
                    switch(ns){
                        // @font-face, @page
                        case 102:
                        case 112:
                            return insertRule(selectors[0] + content), '';
                        default:
                            return content + (at === 0 ? delimiter : '');
                    }
                case -2:
                    content.split(needle).forEach(toSheet);
            }
        };
    };
});



var $8vJ0V = parcelRequire("8vJ0V");
var $7587df36c2dc3210$exports = {};
'use strict';
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */ var $7587df36c2dc3210$var$REACT_STATICS = {
    childContextTypes: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $7587df36c2dc3210$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $7587df36c2dc3210$var$defineProperty = Object.defineProperty;
var $7587df36c2dc3210$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $7587df36c2dc3210$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $7587df36c2dc3210$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $7587df36c2dc3210$var$getPrototypeOf = Object.getPrototypeOf;
var $7587df36c2dc3210$var$objectPrototype = $7587df36c2dc3210$var$getPrototypeOf && $7587df36c2dc3210$var$getPrototypeOf(Object);
function $7587df36c2dc3210$var$hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') {
        if ($7587df36c2dc3210$var$objectPrototype) {
            var inheritedComponent = $7587df36c2dc3210$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $7587df36c2dc3210$var$objectPrototype) $7587df36c2dc3210$var$hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
        }
        var keys = $7587df36c2dc3210$var$getOwnPropertyNames(sourceComponent);
        if ($7587df36c2dc3210$var$getOwnPropertySymbols) keys = keys.concat($7587df36c2dc3210$var$getOwnPropertySymbols(sourceComponent));
        for(var i = 0; i < keys.length; ++i){
            var key = keys[i];
            if (!$7587df36c2dc3210$var$REACT_STATICS[key] && !$7587df36c2dc3210$var$KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
                var descriptor = $7587df36c2dc3210$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    $7587df36c2dc3210$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
        return targetComponent;
    }
    return targetComponent;
}
$7587df36c2dc3210$exports = $7587df36c2dc3210$var$hoistNonReactStatics;



var $lwfCu = parcelRequire("lwfCu");

var $3ZMUU = parcelRequire("3ZMUU");
var $0b1eca56b0789a79$var$_typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
    return typeof obj;
} : function(obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};
var $0b1eca56b0789a79$var$classCallCheck = function(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
};
var $0b1eca56b0789a79$var$createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
var $0b1eca56b0789a79$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $0b1eca56b0789a79$var$inherits = function(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};
var $0b1eca56b0789a79$var$objectWithoutProperties = function(obj, keys) {
    var target = {};
    for(var i in obj){
        if (keys.indexOf(i) >= 0) continue;
        if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
        target[i] = obj[i];
    }
    return target;
};
var $0b1eca56b0789a79$var$possibleConstructorReturn = function(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
};
// 
var $0b1eca56b0789a79$var$isPlainObject = function(x) {
    return (typeof x === 'undefined' ? 'undefined' : $0b1eca56b0789a79$var$_typeof(x)) === 'object' && x.constructor === Object;
};
// 
/**
 * Parse errors.md and turn it into a simple hash of code: message
 */ var $0b1eca56b0789a79$var$ERRORS = {};
/**
 * super basic version of sprintf
 */ function $0b1eca56b0789a79$var$format() {
    for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    var a = args[0];
    var b = [];
    var c = void 0;
    for(c = 1; c < args.length; c += 1)b.push(args[c]);
    b.forEach(function(d) {
        a = a.replace(/%[a-z]/, d);
    });
    return a;
}
/**
 * Create an error file out of errors.md for development and a simple web link to the full errors
 * in production mode.
 */ var $0b1eca56b0789a79$var$StyledComponentsError = function(_Error) {
    $0b1eca56b0789a79$var$inherits(StyledComponentsError, _Error);
    function StyledComponentsError(code) {
        $0b1eca56b0789a79$var$classCallCheck(this, StyledComponentsError);
        for(var _len2 = arguments.length, interpolations = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)interpolations[_key2 - 1] = arguments[_key2];
        var _this;
        var _this = $0b1eca56b0789a79$var$possibleConstructorReturn(this, _Error.call(this, 'An error occurred. See https://github.com/styled-components/styled-components/blob/master/src/utils/errors.md#' + code + ' for more information. ' + (interpolations ? 'Additional arguments: ' + interpolations.join(', ') : '')));
        return $0b1eca56b0789a79$var$possibleConstructorReturn(_this);
    }
    return StyledComponentsError;
}(Error);
// 
var $0b1eca56b0789a79$var$objToCss = function objToCss(obj, prevKey) {
    var css = Object.keys(obj).filter(function(key) {
        var chunk = obj[key];
        return chunk !== undefined && chunk !== null && chunk !== false && chunk !== '';
    }).map(function(key) {
        if ($0b1eca56b0789a79$var$isPlainObject(obj[key])) return objToCss(obj[key], key);
        return (0, (/*@__PURE__*/$parcel$interopDefault($241e3cc488d6456b$exports)))(key) + ': ' + obj[key] + ';';
    }).join(' ');
    return prevKey ? prevKey + ' {\n  ' + css + '\n}' : css;
};
var $0b1eca56b0789a79$var$flatten = function flatten(chunks, executionContext) {
    return chunks.reduce(function(ruleSet, chunk) {
        /* Remove falsey values */ if (chunk === undefined || chunk === null || chunk === false || chunk === '') return ruleSet;
        /* Flatten ruleSet */ if (Array.isArray(chunk)) {
            ruleSet.push.apply(ruleSet, flatten(chunk, executionContext));
            return ruleSet;
        }
        /* Handle other components */ if (chunk.hasOwnProperty('styledComponentId')) {
            // $FlowFixMe not sure how to make this pass
            ruleSet.push('.' + chunk.styledComponentId);
            return ruleSet;
        }
        /* Either execute or defer the function */ if (typeof chunk === 'function') {
            if (executionContext) {
                var nextChunk = chunk(executionContext);
                /* Throw if a React Element was given styles */ if ((0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).isValidElement(nextChunk)) {
                    var elementName = chunk.displayName || chunk.name;
                    throw new $0b1eca56b0789a79$var$StyledComponentsError(11, elementName);
                }
                ruleSet.push.apply(ruleSet, flatten([
                    nextChunk
                ], executionContext));
            } else ruleSet.push(chunk);
            return ruleSet;
        }
        /* Handle objects */ ruleSet.push(// $FlowFixMe have to add %checks somehow to isPlainObject
        $0b1eca56b0789a79$var$isPlainObject(chunk) ? $0b1eca56b0789a79$var$objToCss(chunk) : chunk.toString());
        return ruleSet;
    }, []);
};
// 
var $0b1eca56b0789a79$var$COMMENT_REGEX = /^\s*\/\/.*$/gm;
// NOTE: This stylis instance is only used to split rules from SSR'd style tags
var $0b1eca56b0789a79$var$stylisSplitter = new (0, (/*@__PURE__*/$parcel$interopDefault($7c02449dc3656828$exports)))({
    global: false,
    cascade: true,
    keyframe: false,
    prefix: false,
    compress: false,
    semicolon: true
});
var $0b1eca56b0789a79$var$stylis = new (0, (/*@__PURE__*/$parcel$interopDefault($7c02449dc3656828$exports)))({
    global: false,
    cascade: true,
    keyframe: false,
    prefix: true,
    compress: false,
    semicolon: false // NOTE: This means "autocomplete missing semicolons"
});
// Wrap `insertRulePlugin to build a list of rules,
// and then make our own plugin to return the rules. This
// makes it easier to hook into the existing SSR architecture
var $0b1eca56b0789a79$var$parsingRules = [];
// eslint-disable-next-line consistent-return
var $0b1eca56b0789a79$var$returnRulesPlugin = function returnRulesPlugin(context) {
    if (context === -2) {
        var parsedRules = $0b1eca56b0789a79$var$parsingRules;
        $0b1eca56b0789a79$var$parsingRules = [];
        return parsedRules;
    }
};
var $0b1eca56b0789a79$var$parseRulesPlugin = (0, (/*@__PURE__*/$parcel$interopDefault($7fc04fdd1bed7963$exports)))(function(rule) {
    $0b1eca56b0789a79$var$parsingRules.push(rule);
});
$0b1eca56b0789a79$var$stylis.use([
    $0b1eca56b0789a79$var$parseRulesPlugin,
    $0b1eca56b0789a79$var$returnRulesPlugin
]);
$0b1eca56b0789a79$var$stylisSplitter.use([
    $0b1eca56b0789a79$var$parseRulesPlugin,
    $0b1eca56b0789a79$var$returnRulesPlugin
]);
var $0b1eca56b0789a79$var$stringifyRules = function stringifyRules(rules, selector, prefix) {
    var flatCSS = rules.join('').replace($0b1eca56b0789a79$var$COMMENT_REGEX, ''); // replace JS comments
    var cssStr = selector && prefix ? prefix + ' ' + selector + ' { ' + flatCSS + ' }' : flatCSS;
    return $0b1eca56b0789a79$var$stylis(prefix || !selector ? '' : selector, cssStr);
};
var $0b1eca56b0789a79$var$splitByRules = function splitByRules(css) {
    return $0b1eca56b0789a79$var$stylisSplitter('', css);
};
// 
function $0b1eca56b0789a79$export$7ba318d8d2f06c76(target) /* : %checks */ {
    return(// $FlowFixMe TODO: flow for styledComponentId
    typeof target === 'function' && typeof target.styledComponentId === 'string');
}
// 
/* This function is DEPRECATED and will be removed on the next major version release.
 * It was needed to rehydrate all style blocks prepended to chunks before React
 * tries to rehydrate its HTML stream. Since the master StyleSheet will now detect
 * the use of streamed style tags and will perform the rehydration earlier when needed
 * this function will not be needed anymore */ function $0b1eca56b0789a79$export$953e7e0c06f2f28b() {}
// 
/* eslint-disable no-bitwise */ /* This is the "capacity" of our alphabet i.e. 2x26 for all letters plus their capitalised
 * counterparts */ var $0b1eca56b0789a79$var$charsLength = 52;
/* start at 75 for 'a' until 'z' (25) and then start at 65 for capitalised letters */ var $0b1eca56b0789a79$var$getAlphabeticChar = function getAlphabeticChar(code) {
    return String.fromCharCode(code + (code > 25 ? 39 : 97));
};
/* input a number, usually a hash and convert it to base-52 */ var $0b1eca56b0789a79$var$generateAlphabeticName = function generateAlphabeticName(code) {
    var name = '';
    var x = void 0;
    /* get a char and divide by alphabet-length */ for(x = code; x > $0b1eca56b0789a79$var$charsLength; x = Math.floor(x / $0b1eca56b0789a79$var$charsLength))name = $0b1eca56b0789a79$var$getAlphabeticChar(x % $0b1eca56b0789a79$var$charsLength) + name;
    return $0b1eca56b0789a79$var$getAlphabeticChar(x % $0b1eca56b0789a79$var$charsLength) + name;
};
// 
var $0b1eca56b0789a79$var$interleave = function(strings, interpolations) {
    var result = [
        strings[0]
    ];
    for(var i = 0, len = interpolations.length; i < len; i += 1)result.push(interpolations[i], strings[i + 1]);
    return result;
};
// 
var $0b1eca56b0789a79$var$EMPTY_ARRAY = Object.freeze([]);
var $0b1eca56b0789a79$var$EMPTY_OBJECT = Object.freeze({});
// 
var $0b1eca56b0789a79$export$dbf350e5966cf602 = function(styles) {
    for(var _len = arguments.length, interpolations = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)interpolations[_key - 1] = arguments[_key];
    if (typeof styles === 'function' || $0b1eca56b0789a79$var$isPlainObject(styles)) // $FlowFixMe
    return $0b1eca56b0789a79$var$flatten($0b1eca56b0789a79$var$interleave($0b1eca56b0789a79$var$EMPTY_ARRAY, [
        styles
    ].concat(interpolations)));
    // $FlowFixMe
    return $0b1eca56b0789a79$var$flatten($0b1eca56b0789a79$var$interleave(styles, interpolations));
};
// 
var $0b1eca56b0789a79$var$SC_ATTR = (typeof $3ZMUU !== 'undefined' && undefined, 'data-styled-components');
var $0b1eca56b0789a79$var$SC_STREAM_ATTR = 'data-styled-streamed';
var $0b1eca56b0789a79$var$CONTEXT_KEY = '__styled-components-stylesheet__';
var $0b1eca56b0789a79$var$IS_BROWSER = typeof window !== 'undefined' && 'HTMLElement' in window;
var $0b1eca56b0789a79$var$DISABLE_SPEEDY = false;
// 
var $0b1eca56b0789a79$var$SC_COMPONENT_ID = /^[^\S\n]*?\/\* sc-component-id:\s*(\S+)\s+\*\//gm;
var $0b1eca56b0789a79$var$extractComps = function(maybeCSS) {
    var css = '' + (maybeCSS || ''); // Definitely a string, and a clone
    var existingComponents = [];
    css.replace($0b1eca56b0789a79$var$SC_COMPONENT_ID, function(match, componentId, matchIndex) {
        existingComponents.push({
            componentId: componentId,
            matchIndex: matchIndex
        });
        return match;
    });
    return existingComponents.map(function(_ref, i) {
        var componentId = _ref.componentId, matchIndex = _ref.matchIndex;
        var nextComp = existingComponents[i + 1];
        var cssFromDOM = nextComp ? css.slice(matchIndex, nextComp.matchIndex) : css.slice(matchIndex);
        return {
            componentId: componentId,
            cssFromDOM: cssFromDOM
        };
    });
};
// 
/* eslint-disable camelcase, no-undef */ var $0b1eca56b0789a79$var$getNonce = function() {
    return typeof __webpack_nonce__ !== 'undefined' ? __webpack_nonce__ : null;
};
// 
// Helper to call a given function, only once
var $0b1eca56b0789a79$var$once = function(cb) {
    var called = false;
    return function() {
        if (!called) {
            called = true;
            cb();
        }
    };
};
// 
/* These are helpers for the StyleTags to keep track of the injected
 * rule names for each (component) ID that they're keeping track of.
 * They're crucial for detecting whether a name has already been
 * injected.
 * (This excludes rehydrated names) */ /* adds a new ID:name pairing to a names dictionary */ var $0b1eca56b0789a79$var$addNameForId = function addNameForId(names, id, name) {
    if (name) {
        // eslint-disable-next-line no-param-reassign
        var namesForId = names[id] || (names[id] = Object.create(null));
        namesForId[name] = true;
    }
};
/* resets an ID entirely by overwriting it in the dictionary */ var $0b1eca56b0789a79$var$resetIdNames = function resetIdNames(names, id) {
    // eslint-disable-next-line no-param-reassign
    names[id] = Object.create(null);
};
/* factory for a names dictionary checking the existance of an ID:name pairing */ var $0b1eca56b0789a79$var$hasNameForId = function hasNameForId(names) {
    return function(id, name) {
        return names[id] !== undefined && names[id][name];
    };
};
/* stringifies names for the html/element output */ var $0b1eca56b0789a79$var$stringifyNames = function stringifyNames(names) {
    var str = '';
    // eslint-disable-next-line guard-for-in
    for(var id in names)str += Object.keys(names[id]).join(' ') + ' ';
    return str.trim();
};
/* clones the nested names dictionary */ var $0b1eca56b0789a79$var$cloneNames = function cloneNames(names) {
    var clone = Object.create(null);
    // eslint-disable-next-line guard-for-in
    for(var id in names)clone[id] = $0b1eca56b0789a79$var$_extends({}, names[id]);
    return clone;
};
// 
/* These are helpers that deal with the insertRule (aka speedy) API
 * They are used in the StyleTags and specifically the speedy tag
 */ /* retrieve a sheet for a given style tag */ var $0b1eca56b0789a79$var$sheetForTag = function sheetForTag(tag) {
    // $FlowFixMe
    if (tag.sheet) return tag.sheet;
    /* Firefox quirk requires us to step through all stylesheets to find one owned by the given tag */ var size = document.styleSheets.length;
    for(var i = 0; i < size; i += 1){
        var sheet = document.styleSheets[i];
        // $FlowFixMe
        if (sheet.ownerNode === tag) return sheet;
    }
    /* we should always be able to find a tag */ throw new $0b1eca56b0789a79$var$StyledComponentsError(10);
};
/* insert a rule safely and return whether it was actually injected */ var $0b1eca56b0789a79$var$safeInsertRule = function safeInsertRule(sheet, cssRule, index) {
    /* abort early if cssRule string is falsy */ if (!cssRule) return false;
    var maxIndex = sheet.cssRules.length;
    try {
        /* use insertRule and cap passed index with maxIndex (no of cssRules) */ sheet.insertRule(cssRule, index <= maxIndex ? index : maxIndex);
    } catch (err) {
        /* any error indicates an invalid rule */ return false;
    }
    return true;
};
/* deletes `size` rules starting from `removalIndex` */ var $0b1eca56b0789a79$var$deleteRules = function deleteRules(sheet, removalIndex, size) {
    var lowerBound = removalIndex - size;
    for(var i = removalIndex; i > lowerBound; i -= 1)sheet.deleteRule(i);
};
// 
/* this marker separates component styles and is important for rehydration */ var $0b1eca56b0789a79$var$makeTextMarker = function makeTextMarker(id) {
    return '\n/* sc-component-id: ' + id + ' */\n';
};
/* add up all numbers in array up until and including the index */ var $0b1eca56b0789a79$var$addUpUntilIndex = function addUpUntilIndex(sizes, index) {
    var totalUpToIndex = 0;
    for(var i = 0; i <= index; i += 1)totalUpToIndex += sizes[i];
    return totalUpToIndex;
};
/* create a new style tag after lastEl */ var $0b1eca56b0789a79$var$makeStyleTag = function makeStyleTag(target, tagEl, insertBefore) {
    var el = document.createElement('style');
    el.setAttribute($0b1eca56b0789a79$var$SC_ATTR, '');
    var nonce = $0b1eca56b0789a79$var$getNonce();
    if (nonce) el.setAttribute('nonce', nonce);
    /* Work around insertRule quirk in EdgeHTML */ el.appendChild(document.createTextNode(''));
    if (target && !tagEl) /* Append to target when no previous element was passed */ target.appendChild(el);
    else {
        if (!tagEl || !target || !tagEl.parentNode) throw new $0b1eca56b0789a79$var$StyledComponentsError(6);
        /* Insert new style tag after the previous one */ tagEl.parentNode.insertBefore(el, insertBefore ? tagEl : tagEl.nextSibling);
    }
    return el;
};
/* takes a css factory function and outputs an html styled tag factory */ var $0b1eca56b0789a79$var$wrapAsHtmlTag = function wrapAsHtmlTag(css, names) {
    return function(additionalAttrs) {
        var nonce = $0b1eca56b0789a79$var$getNonce();
        var attrs = [
            nonce && 'nonce="' + nonce + '"',
            $0b1eca56b0789a79$var$SC_ATTR + '="' + $0b1eca56b0789a79$var$stringifyNames(names) + '"',
            additionalAttrs
        ];
        var htmlAttr = attrs.filter(Boolean).join(' ');
        return '<style ' + htmlAttr + '>' + css() + '</style>';
    };
};
/* takes a css factory function and outputs an element factory */ var $0b1eca56b0789a79$var$wrapAsElement = function wrapAsElement(css, names) {
    return function() {
        var _props;
        var props = (_props = {}, _props[$0b1eca56b0789a79$var$SC_ATTR] = $0b1eca56b0789a79$var$stringifyNames(names), _props);
        var nonce = $0b1eca56b0789a79$var$getNonce();
        if (nonce) // $FlowFixMe
        props.nonce = nonce;
        // eslint-disable-next-line react/no-danger
        return (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement('style', $0b1eca56b0789a79$var$_extends({}, props, {
            dangerouslySetInnerHTML: {
                __html: css()
            }
        }));
    };
};
var $0b1eca56b0789a79$var$getIdsFromMarkersFactory = function getIdsFromMarkersFactory(markers) {
    return function() {
        return Object.keys(markers);
    };
};
/* speedy tags utilise insertRule */ var $0b1eca56b0789a79$var$makeSpeedyTag = function makeSpeedyTag(el, getImportRuleTag) {
    var names = Object.create(null);
    var markers = Object.create(null);
    var sizes = [];
    var extractImport = getImportRuleTag !== undefined;
    /* indicates whther getImportRuleTag was called */ var usedImportRuleTag = false;
    var insertMarker = function insertMarker(id) {
        var prev = markers[id];
        if (prev !== undefined) return prev;
        markers[id] = sizes.length;
        sizes.push(0);
        $0b1eca56b0789a79$var$resetIdNames(names, id);
        return markers[id];
    };
    var insertRules = function insertRules(id, cssRules, name) {
        var marker = insertMarker(id);
        var sheet = $0b1eca56b0789a79$var$sheetForTag(el);
        var insertIndex = $0b1eca56b0789a79$var$addUpUntilIndex(sizes, marker);
        var injectedRules = 0;
        var importRules = [];
        var cssRulesSize = cssRules.length;
        for(var i = 0; i < cssRulesSize; i += 1){
            var cssRule = cssRules[i];
            var mayHaveImport = extractImport; /* @import rules are reordered to appear first */ 
            if (mayHaveImport && cssRule.indexOf('@import') !== -1) importRules.push(cssRule);
            else if ($0b1eca56b0789a79$var$safeInsertRule(sheet, cssRule, insertIndex + injectedRules)) {
                mayHaveImport = false;
                injectedRules += 1;
            }
        }
        if (extractImport && importRules.length > 0) {
            usedImportRuleTag = true;
            // $FlowFixMe
            getImportRuleTag().insertRules(id + '-import', importRules);
        }
        sizes[marker] += injectedRules; /* add up no of injected rules */ 
        $0b1eca56b0789a79$var$addNameForId(names, id, name);
    };
    var removeRules = function removeRules(id) {
        var marker = markers[id];
        if (marker === undefined) return;
        var size = sizes[marker];
        var sheet = $0b1eca56b0789a79$var$sheetForTag(el);
        var removalIndex = $0b1eca56b0789a79$var$addUpUntilIndex(sizes, marker);
        $0b1eca56b0789a79$var$deleteRules(sheet, removalIndex, size);
        sizes[marker] = 0;
        $0b1eca56b0789a79$var$resetIdNames(names, id);
        if (extractImport && usedImportRuleTag) // $FlowFixMe
        getImportRuleTag().removeRules(id + '-import');
    };
    var css = function css() {
        var _sheetForTag = $0b1eca56b0789a79$var$sheetForTag(el), cssRules = _sheetForTag.cssRules;
        var str = '';
        // eslint-disable-next-line guard-for-in
        for(var id in markers){
            str += $0b1eca56b0789a79$var$makeTextMarker(id);
            var marker = markers[id];
            var end = $0b1eca56b0789a79$var$addUpUntilIndex(sizes, marker);
            var size = sizes[marker];
            for(var i = end - size; i < end; i += 1){
                var rule = cssRules[i];
                if (rule !== undefined) str += rule.cssText;
            }
        }
        return str;
    };
    return {
        clone: function clone() {
            throw new $0b1eca56b0789a79$var$StyledComponentsError(5);
        },
        css: css,
        getIds: $0b1eca56b0789a79$var$getIdsFromMarkersFactory(markers),
        hasNameForId: $0b1eca56b0789a79$var$hasNameForId(names),
        insertMarker: insertMarker,
        insertRules: insertRules,
        removeRules: removeRules,
        sealed: false,
        styleTag: el,
        toElement: $0b1eca56b0789a79$var$wrapAsElement(css, names),
        toHTML: $0b1eca56b0789a79$var$wrapAsHtmlTag(css, names)
    };
};
var $0b1eca56b0789a79$var$makeTextNode = function makeTextNode(id) {
    return document.createTextNode($0b1eca56b0789a79$var$makeTextMarker(id));
};
var $0b1eca56b0789a79$var$makeBrowserTag = function makeBrowserTag(el, getImportRuleTag) {
    var names = Object.create(null);
    var markers = Object.create(null);
    var extractImport = getImportRuleTag !== undefined;
    /* indicates whther getImportRuleTag was called */ var usedImportRuleTag = false;
    var insertMarker = function insertMarker(id) {
        var prev = markers[id];
        if (prev !== undefined) return prev;
        markers[id] = $0b1eca56b0789a79$var$makeTextNode(id);
        el.appendChild(markers[id]);
        names[id] = Object.create(null);
        return markers[id];
    };
    var insertRules = function insertRules(id, cssRules, name) {
        var marker = insertMarker(id);
        var importRules = [];
        var cssRulesSize = cssRules.length;
        for(var i = 0; i < cssRulesSize; i += 1){
            var rule = cssRules[i];
            var mayHaveImport = extractImport;
            if (mayHaveImport && rule.indexOf('@import') !== -1) importRules.push(rule);
            else {
                mayHaveImport = false;
                var separator = i === cssRulesSize - 1 ? '' : ' ';
                marker.appendData('' + rule + separator);
            }
        }
        $0b1eca56b0789a79$var$addNameForId(names, id, name);
        if (extractImport && importRules.length > 0) {
            usedImportRuleTag = true;
            // $FlowFixMe
            getImportRuleTag().insertRules(id + '-import', importRules);
        }
    };
    var removeRules = function removeRules(id) {
        var marker = markers[id];
        if (marker === undefined) return;
        /* create new empty text node and replace the current one */ var newMarker = $0b1eca56b0789a79$var$makeTextNode(id);
        el.replaceChild(newMarker, marker);
        markers[id] = newMarker;
        $0b1eca56b0789a79$var$resetIdNames(names, id);
        if (extractImport && usedImportRuleTag) // $FlowFixMe
        getImportRuleTag().removeRules(id + '-import');
    };
    var css = function css() {
        var str = '';
        // eslint-disable-next-line guard-for-in
        for(var id in markers)str += markers[id].data;
        return str;
    };
    return {
        clone: function clone() {
            throw new $0b1eca56b0789a79$var$StyledComponentsError(5);
        },
        css: css,
        getIds: $0b1eca56b0789a79$var$getIdsFromMarkersFactory(markers),
        hasNameForId: $0b1eca56b0789a79$var$hasNameForId(names),
        insertMarker: insertMarker,
        insertRules: insertRules,
        removeRules: removeRules,
        sealed: false,
        styleTag: el,
        toElement: $0b1eca56b0789a79$var$wrapAsElement(css, names),
        toHTML: $0b1eca56b0789a79$var$wrapAsHtmlTag(css, names)
    };
};
var $0b1eca56b0789a79$var$makeServerTagInternal = function makeServerTagInternal(namesArg, markersArg) {
    var names = namesArg === undefined ? Object.create(null) : namesArg;
    var markers = markersArg === undefined ? Object.create(null) : markersArg;
    var insertMarker = function insertMarker(id) {
        var prev = markers[id];
        if (prev !== undefined) return prev;
        return markers[id] = [
            ''
        ];
    };
    var insertRules = function insertRules(id, cssRules, name) {
        var marker = insertMarker(id);
        marker[0] += cssRules.join(' ');
        $0b1eca56b0789a79$var$addNameForId(names, id, name);
    };
    var removeRules = function removeRules(id) {
        var marker = markers[id];
        if (marker === undefined) return;
        marker[0] = '';
        $0b1eca56b0789a79$var$resetIdNames(names, id);
    };
    var css = function css() {
        var str = '';
        // eslint-disable-next-line guard-for-in
        for(var id in markers){
            var cssForId = markers[id][0];
            if (cssForId) str += $0b1eca56b0789a79$var$makeTextMarker(id) + cssForId;
        }
        return str;
    };
    var clone = function clone() {
        var namesClone = $0b1eca56b0789a79$var$cloneNames(names);
        var markersClone = Object.create(null);
        // eslint-disable-next-line guard-for-in
        for(var id in markers)markersClone[id] = [
            markers[id][0]
        ];
        return makeServerTagInternal(namesClone, markersClone);
    };
    var tag = {
        clone: clone,
        css: css,
        getIds: $0b1eca56b0789a79$var$getIdsFromMarkersFactory(markers),
        hasNameForId: $0b1eca56b0789a79$var$hasNameForId(names),
        insertMarker: insertMarker,
        insertRules: insertRules,
        removeRules: removeRules,
        sealed: false,
        styleTag: null,
        toElement: $0b1eca56b0789a79$var$wrapAsElement(css, names),
        toHTML: $0b1eca56b0789a79$var$wrapAsHtmlTag(css, names)
    };
    return tag;
};
var $0b1eca56b0789a79$var$makeServerTag = function makeServerTag() {
    return $0b1eca56b0789a79$var$makeServerTagInternal();
};
var $0b1eca56b0789a79$var$makeTag = function makeTag(target, tagEl, forceServer, insertBefore, getImportRuleTag) {
    if ($0b1eca56b0789a79$var$IS_BROWSER && !forceServer) {
        var el = $0b1eca56b0789a79$var$makeStyleTag(target, tagEl, insertBefore);
        if ($0b1eca56b0789a79$var$DISABLE_SPEEDY) return $0b1eca56b0789a79$var$makeBrowserTag(el, getImportRuleTag);
        else return $0b1eca56b0789a79$var$makeSpeedyTag(el, getImportRuleTag);
    }
    return $0b1eca56b0789a79$var$makeServerTag();
};
/* wraps a given tag so that rehydration is performed once when necessary */ var $0b1eca56b0789a79$var$makeRehydrationTag = function makeRehydrationTag(tag, els, extracted, immediateRehydration) {
    /* rehydration function that adds all rules to the new tag */ var rehydrate = $0b1eca56b0789a79$var$once(function() {
        /* add all extracted components to the new tag */ for(var i = 0, len = extracted.length; i < len; i += 1){
            var _extracted$i = extracted[i], componentId = _extracted$i.componentId, cssFromDOM = _extracted$i.cssFromDOM;
            var cssRules = $0b1eca56b0789a79$var$splitByRules(cssFromDOM);
            tag.insertRules(componentId, cssRules);
        }
        /* remove old HTMLStyleElements, since they have been rehydrated */ for(var _i = 0, _len = els.length; _i < _len; _i += 1){
            var el = els[_i];
            if (el.parentNode) el.parentNode.removeChild(el);
        }
    });
    if (immediateRehydration) rehydrate();
    return $0b1eca56b0789a79$var$_extends({}, tag, {
        /* add rehydration hook to insertion methods */ insertMarker: function insertMarker(id) {
            rehydrate();
            return tag.insertMarker(id);
        },
        insertRules: function insertRules(id, cssRules, name) {
            rehydrate();
            return tag.insertRules(id, cssRules, name);
        }
    });
};
// 
var $0b1eca56b0789a79$var$SPLIT_REGEX = /\s+/;
/* determine the maximum number of components before tags are sharded */ var $0b1eca56b0789a79$var$MAX_SIZE = void 0;
if ($0b1eca56b0789a79$var$IS_BROWSER) /* in speedy mode we can keep a lot more rules in a sheet before a slowdown can be expected */ $0b1eca56b0789a79$var$MAX_SIZE = $0b1eca56b0789a79$var$DISABLE_SPEEDY ? 40 : 1000;
else /* for servers we do not need to shard at all */ $0b1eca56b0789a79$var$MAX_SIZE = -1;
var $0b1eca56b0789a79$var$sheetRunningId = 0;
var $0b1eca56b0789a79$var$master = void 0;
var $0b1eca56b0789a79$var$StyleSheet = function() {
    /* a map from ids to tags */ /* deferred rules for a given id */ /* this is used for not reinjecting rules via hasNameForId() */ /* when rules for an id are removed using remove() we have to ignore rehydratedNames for it */ /* a list of tags belonging to this StyleSheet */ /* a tag for import rules */ /* current capacity until a new tag must be created */ /* children (aka clones) of this StyleSheet inheriting all and future injections */ function StyleSheet() {
        var _this = this;
        var target = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : $0b1eca56b0789a79$var$IS_BROWSER ? document.head : null;
        var forceServer = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        $0b1eca56b0789a79$var$classCallCheck(this, StyleSheet);
        this.getImportRuleTag = function() {
            var importRuleTag = _this.importRuleTag;
            if (importRuleTag !== undefined) return importRuleTag;
            var firstTag = _this.tags[0];
            var insertBefore = true;
            return _this.importRuleTag = $0b1eca56b0789a79$var$makeTag(_this.target, firstTag ? firstTag.styleTag : null, _this.forceServer, insertBefore);
        };
        $0b1eca56b0789a79$var$sheetRunningId += 1;
        this.id = $0b1eca56b0789a79$var$sheetRunningId;
        this.forceServer = forceServer;
        this.target = forceServer ? null : target;
        this.tagMap = {};
        this.deferred = {};
        this.rehydratedNames = {};
        this.ignoreRehydratedNames = {};
        this.tags = [];
        this.capacity = 1;
        this.clones = [];
    }
    /* rehydrate all SSR'd style tags */ StyleSheet.prototype.rehydrate = function rehydrate() {
        if (!$0b1eca56b0789a79$var$IS_BROWSER || this.forceServer) return this;
        var els = [];
        var extracted = [];
        var isStreamed = false;
        /* retrieve all of our SSR style elements from the DOM */ var nodes = document.querySelectorAll('style[' + $0b1eca56b0789a79$var$SC_ATTR + ']');
        var nodesSize = nodes.length;
        /* abort rehydration if no previous style tags were found */ if (nodesSize === 0) return this;
        for(var i = 0; i < nodesSize; i += 1){
            // $FlowFixMe: We can trust that all elements in this query are style elements
            var el = nodes[i];
            /* check if style tag is a streamed tag */ if (!isStreamed) isStreamed = !!el.getAttribute($0b1eca56b0789a79$var$SC_STREAM_ATTR);
            /* retrieve all component names */ var elNames = (el.getAttribute($0b1eca56b0789a79$var$SC_ATTR) || '').trim().split($0b1eca56b0789a79$var$SPLIT_REGEX);
            var elNamesSize = elNames.length;
            for(var j = 0; j < elNamesSize; j += 1){
                var name = elNames[j];
                /* add rehydrated name to sheet to avoid readding styles */ this.rehydratedNames[name] = true;
            }
            /* extract all components and their CSS */ extracted.push.apply(extracted, $0b1eca56b0789a79$var$extractComps(el.textContent));
            /* store original HTMLStyleElement */ els.push(el);
        }
        /* abort rehydration if nothing was extracted */ var extractedSize = extracted.length;
        if (extractedSize === 0) return this;
        /* create a tag to be used for rehydration */ var tag = this.makeTag(null);
        var rehydrationTag = $0b1eca56b0789a79$var$makeRehydrationTag(tag, els, extracted, isStreamed);
        /* reset capacity and adjust MAX_SIZE by the initial size of the rehydration */ this.capacity = Math.max(1, $0b1eca56b0789a79$var$MAX_SIZE - extractedSize);
        this.tags.push(rehydrationTag);
        /* retrieve all component ids */ for(var _j = 0; _j < extractedSize; _j += 1)this.tagMap[extracted[_j].componentId] = rehydrationTag;
        return this;
    };
    /* retrieve a "master" instance of StyleSheet which is typically used when no other is available
   * The master StyleSheet is targeted by injectGlobal, keyframes, and components outside of any
    * StyleSheetManager's context */ /* reset the internal "master" instance */ StyleSheet.reset = function reset() {
        var forceServer = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
        $0b1eca56b0789a79$var$master = new StyleSheet(undefined, forceServer).rehydrate();
    };
    /* adds "children" to the StyleSheet that inherit all of the parents' rules
   * while their own rules do not affect the parent */ StyleSheet.prototype.clone = function clone() {
        var sheet = new StyleSheet(this.target, this.forceServer);
        /* add to clone array */ this.clones.push(sheet);
        /* clone all tags */ sheet.tags = this.tags.map(function(tag) {
            var ids = tag.getIds();
            var newTag = tag.clone();
            /* reconstruct tagMap */ for(var i = 0; i < ids.length; i += 1)sheet.tagMap[ids[i]] = newTag;
            return newTag;
        });
        /* clone other maps */ sheet.rehydratedNames = $0b1eca56b0789a79$var$_extends({}, this.rehydratedNames);
        sheet.deferred = $0b1eca56b0789a79$var$_extends({}, this.deferred);
        return sheet;
    };
    /* force StyleSheet to create a new tag on the next injection */ StyleSheet.prototype.sealAllTags = function sealAllTags() {
        this.capacity = 1;
        this.tags.forEach(function(tag) {
            // eslint-disable-next-line no-param-reassign
            tag.sealed = true;
        });
    };
    StyleSheet.prototype.makeTag = function makeTag$$1(tag) {
        var lastEl = tag ? tag.styleTag : null;
        var insertBefore = false;
        return $0b1eca56b0789a79$var$makeTag(this.target, lastEl, this.forceServer, insertBefore, this.getImportRuleTag);
    };
    /* get a tag for a given componentId, assign the componentId to one, or shard */ StyleSheet.prototype.getTagForId = function getTagForId(id) {
        /* simply return a tag, when the componentId was already assigned one */ var prev = this.tagMap[id];
        if (prev !== undefined && !prev.sealed) return prev;
        var tag = this.tags[this.tags.length - 1];
        /* shard (create a new tag) if the tag is exhausted (See MAX_SIZE) */ this.capacity -= 1;
        if (this.capacity === 0) {
            this.capacity = $0b1eca56b0789a79$var$MAX_SIZE;
            tag = this.makeTag(tag);
            this.tags.push(tag);
        }
        return this.tagMap[id] = tag;
    };
    /* mainly for injectGlobal to check for its id */ StyleSheet.prototype.hasId = function hasId(id) {
        return this.tagMap[id] !== undefined;
    };
    /* caching layer checking id+name to already have a corresponding tag and injected rules */ StyleSheet.prototype.hasNameForId = function hasNameForId(id, name) {
        /* exception for rehydrated names which are checked separately */ if (this.ignoreRehydratedNames[id] === undefined && this.rehydratedNames[name]) return true;
        var tag = this.tagMap[id];
        return tag !== undefined && tag.hasNameForId(id, name);
    };
    /* registers a componentId and registers it on its tag */ StyleSheet.prototype.deferredInject = function deferredInject(id, cssRules) {
        /* don't inject when the id is already registered */ if (this.tagMap[id] !== undefined) return;
        var clones = this.clones;
        for(var i = 0; i < clones.length; i += 1)clones[i].deferredInject(id, cssRules);
        this.getTagForId(id).insertMarker(id);
        this.deferred[id] = cssRules;
    };
    /* injects rules for a given id with a name that will need to be cached */ StyleSheet.prototype.inject = function inject(id, cssRules, name) {
        var clones = this.clones;
        for(var i = 0; i < clones.length; i += 1)clones[i].inject(id, cssRules, name);
        var tag = this.getTagForId(id);
        /* add deferred rules for component */ if (this.deferred[id] !== undefined) {
            // Combine passed cssRules with previously deferred CSS rules
            // NOTE: We cannot mutate the deferred array itself as all clones
            // do the same (see clones[i].inject)
            var rules = this.deferred[id].concat(cssRules);
            tag.insertRules(id, rules, name);
            this.deferred[id] = undefined;
        } else tag.insertRules(id, cssRules, name);
    };
    /* removes all rules for a given id, which doesn't remove its marker but resets it */ StyleSheet.prototype.remove = function remove(id) {
        var tag = this.tagMap[id];
        if (tag === undefined) return;
        var clones = this.clones;
        for(var i = 0; i < clones.length; i += 1)clones[i].remove(id);
        /* remove all rules from the tag */ tag.removeRules(id);
        /* ignore possible rehydrated names */ this.ignoreRehydratedNames[id] = true;
        /* delete possible deferred rules */ this.deferred[id] = undefined;
    };
    StyleSheet.prototype.toHTML = function toHTML() {
        return this.tags.map(function(tag) {
            return tag.toHTML();
        }).join('');
    };
    StyleSheet.prototype.toReactElements = function toReactElements() {
        var id = this.id;
        return this.tags.map(function(tag, i) {
            var key = 'sc-' + id + '-' + i;
            return (0, $5FkrB.cloneElement)(tag.toElement(), {
                key: key
            });
        });
    };
    $0b1eca56b0789a79$var$createClass(StyleSheet, null, [
        {
            key: 'master',
            get: function get$$1() {
                return $0b1eca56b0789a79$var$master || ($0b1eca56b0789a79$var$master = new StyleSheet().rehydrate());
            }
        },
        {
            key: 'instance',
            get: function get$$1() {
                return StyleSheet.master;
            }
        }
    ]);
    return StyleSheet;
}();
var $0b1eca56b0789a79$var$_StyleSheetManager$ch;
var $0b1eca56b0789a79$export$a473771da2f0ff7c = function(_Component) {
    $0b1eca56b0789a79$var$inherits(StyleSheetManager, _Component);
    function StyleSheetManager() {
        $0b1eca56b0789a79$var$classCallCheck(this, StyleSheetManager);
        return $0b1eca56b0789a79$var$possibleConstructorReturn(this, _Component.apply(this, arguments));
    }
    StyleSheetManager.prototype.getChildContext = function getChildContext() {
        var _ref;
        return _ref = {}, _ref[$0b1eca56b0789a79$var$CONTEXT_KEY] = this.sheetInstance, _ref;
    };
    StyleSheetManager.prototype.componentWillMount = function componentWillMount() {
        if (this.props.sheet) this.sheetInstance = this.props.sheet;
        else if (this.props.target) this.sheetInstance = new $0b1eca56b0789a79$var$StyleSheet(this.props.target);
        else throw new $0b1eca56b0789a79$var$StyledComponentsError(4);
    };
    StyleSheetManager.prototype.render = function render() {
        /* eslint-disable react/prop-types */ // Flow v0.43.1 will report an error accessing the `children` property,
        // but v0.47.0 will not. It is necessary to use a type cast instead of
        // a "fixme" comment to satisfy both Flow versions.
        return (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).Children.only(this.props.children);
    };
    return StyleSheetManager;
}((0, $5FkrB.Component));
$0b1eca56b0789a79$export$a473771da2f0ff7c.childContextTypes = ($0b1eca56b0789a79$var$_StyleSheetManager$ch = {}, $0b1eca56b0789a79$var$_StyleSheetManager$ch[$0b1eca56b0789a79$var$CONTEXT_KEY] = (0, (/*@__PURE__*/$parcel$interopDefault($8vJ0V))).oneOfType([
    (0, (/*@__PURE__*/$parcel$interopDefault($8vJ0V))).instanceOf($0b1eca56b0789a79$var$StyleSheet),
    (0, (/*@__PURE__*/$parcel$interopDefault($8vJ0V))).instanceOf($0b1eca56b0789a79$export$ae8c7d15c8b89a20)
]).isRequired, $0b1eca56b0789a79$var$_StyleSheetManager$ch);
// 
var $0b1eca56b0789a79$export$ae8c7d15c8b89a20 = function() {
    function ServerStyleSheet() {
        $0b1eca56b0789a79$var$classCallCheck(this, ServerStyleSheet);
        /* The master sheet might be reset, so keep a reference here */ this.masterSheet = $0b1eca56b0789a79$var$StyleSheet.master;
        this.instance = this.masterSheet.clone();
        this.closed = false;
    }
    ServerStyleSheet.prototype.complete = function complete() {
        if (!this.closed) {
            /* Remove closed StyleSheets from the master sheet */ var index = this.masterSheet.clones.indexOf(this.instance);
            this.masterSheet.clones.splice(index, 1);
            this.closed = true;
        }
    };
    ServerStyleSheet.prototype.collectStyles = function collectStyles(children) {
        if (this.closed) throw new $0b1eca56b0789a79$var$StyledComponentsError(2);
        return (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement($0b1eca56b0789a79$export$a473771da2f0ff7c, {
            sheet: this.instance
        }, children);
    };
    ServerStyleSheet.prototype.getStyleTags = function getStyleTags() {
        this.complete();
        return this.instance.toHTML();
    };
    ServerStyleSheet.prototype.getStyleElement = function getStyleElement() {
        this.complete();
        return this.instance.toReactElements();
    };
    ServerStyleSheet.prototype.interleaveWithNodeStream = function interleaveWithNodeStream(readableStream) {
        var _this = this;
        var instance, instanceTagIndex, streamAttr, transformer;
        throw new $0b1eca56b0789a79$var$StyledComponentsError(3);
    };
    return ServerStyleSheet;
}();
// 
var $0b1eca56b0789a79$var$LIMIT = 200;
var $0b1eca56b0789a79$var$createWarnTooManyClasses = function(displayName) {
    var generatedClasses = {};
    var warningSeen = false;
    return function(className) {
        if (!warningSeen) {
            generatedClasses[className] = true;
            if (Object.keys(generatedClasses).length >= $0b1eca56b0789a79$var$LIMIT) {
                // Unable to find latestRule in test environment.
                /* eslint-disable no-console, prefer-template */ console.warn('Over ' + $0b1eca56b0789a79$var$LIMIT + ' classes were generated for component ' + displayName + '. \n' + 'Consider using the attrs method, together with a style object for frequently changed styles.\n' + 'Example:\n' + '  const Component = styled.div.attrs({\n' + '    style: ({ background }) => ({\n' + '      background,\n' + '    }),\n' + '  })`width: 100%;`\n\n' + '  <Component />');
                warningSeen = true;
                generatedClasses = {};
            }
        }
    };
};
// 
var $0b1eca56b0789a79$var$determineTheme = function(props, fallbackTheme, defaultProps) {
    // Props should take precedence over ThemeProvider, which should take precedence over
    // defaultProps, but React automatically puts defaultProps on props.
    /* eslint-disable react/prop-types */ var isDefaultTheme = defaultProps && props.theme === defaultProps.theme;
    var theme = props.theme && !isDefaultTheme ? props.theme : fallbackTheme;
    /* eslint-enable */ return theme;
};
// 
var $0b1eca56b0789a79$var$escapeRegex = /[[\].#*$><+~=|^:(),"'`-]+/g;
var $0b1eca56b0789a79$var$dashesAtEnds = /(^-|-$)/g;
/**
 * TODO: Explore using CSS.escape when it becomes more available
 * in evergreen browsers.
 */ function $0b1eca56b0789a79$var$escape(str) {
    return str// Replace all possible CSS selectors
    .replace($0b1eca56b0789a79$var$escapeRegex, '-')// Remove extraneous hyphens at the start and end
    .replace($0b1eca56b0789a79$var$dashesAtEnds, '');
}
// 
function $0b1eca56b0789a79$var$getComponentName(target) {
    return target.displayName || target.name || 'Component';
}
// 
function $0b1eca56b0789a79$var$isTag(target) /* : %checks */ {
    return typeof target === 'string';
}
// 
function $0b1eca56b0789a79$var$generateDisplayName(target) {
    return $0b1eca56b0789a79$var$isTag(target) ? 'styled.' + target : 'Styled(' + $0b1eca56b0789a79$var$getComponentName(target) + ')';
}
// 
/* eslint-disable max-len */ /**
 * Trying to avoid the unknown-prop errors on styled components by filtering by
 * React's attribute whitelist.
 *
 * To regenerate this regex:
 *
 * 1. `npm i -g regexgen` (https://github.com/devongovett/regexgen)
 * 2. Run `regexgen` with the list of space-separated words below as input
 * 3. Surround the emitted regex with this: `/^(GENERATED_REGEX)$/` -- this will ensure a full string match
 *    and no false positives from partials
 * */ /*
children dangerouslySetInnerHTML key ref autoFocus defaultValue valueLink defaultChecked checkedLink innerHTML suppressContentEditableWarning onFocusIn onFocusOut className onCopy onCut onPaste onCompositionEnd onCompositionStart onCompositionUpdate onKeyDown onKeyPress onKeyUp onFocus onBlur onChange onInput onInvalid onSubmit onReset onClick onContextMenu onDoubleClick onDrag onDragEnd onDragEnter onDragExit onDragLeave onDragOver onDragStart onDrop onMouseDown onMouseEnter onMouseLeave onMouseMove onMouseOut onMouseOver onMouseUp onSelect onTouchCancel onTouchEnd onTouchMove onTouchStart onScroll onWheel onAbort onCanPlay onCanPlayThrough onDurationChange onEmptied onEncrypted onEnded onError onLoadedData onLoadedMetadata onLoadStart onPause onPlay onPlaying onProgress onRateChange onSeeked onSeeking onStalled onSuspend onTimeUpdate onVolumeChange onWaiting onLoad onAnimationStart onAnimationEnd onAnimationIteration onTransitionEnd onCopyCapture onCutCapture onPasteCapture onCompositionEndCapture onCompositionStartCapture onCompositionUpdateCapture onKeyDownCapture onKeyPressCapture onKeyUpCapture onFocusCapture onBlurCapture onChangeCapture onInputCapture onSubmitCapture onResetCapture onClickCapture onContextMenuCapture onDoubleClickCapture onDragCapture onDragEndCapture onDragEnterCapture onDragExitCapture onDragLeaveCapture onDragOverCapture onDragStartCapture onDropCapture onMouseDownCapture onMouseEnterCapture onMouseLeaveCapture onMouseMoveCapture onMouseOutCapture onMouseOverCapture onMouseUpCapture onSelectCapture onTouchCancelCapture onTouchEndCapture onTouchMoveCapture onTouchStartCapture onScrollCapture onWheelCapture onAbortCapture onCanPlayCapture onCanPlayThroughCapture onDurationChangeCapture onEmptiedCapture onEncryptedCapture onEndedCapture onErrorCapture onLoadedDataCapture onLoadedMetadataCapture onLoadStartCapture onPauseCapture onPlayCapture onPlayingCapture onProgressCapture onRateChangeCapture onSeekedCapture onSeekingCapture onStalledCapture onSuspendCapture onTimeUpdateCapture onVolumeChangeCapture onWaitingCapture onLoadCapture onAnimationStartCapture onAnimationEndCapture onAnimationIterationCapture onTransitionEndCapture accept acceptCharset accessKey action allowFullScreen allowTransparency alt as async autoComplete autoPlay capture cellPadding cellSpacing charSet challenge checked cite classID className cols colSpan content contentEditable contextMenu controlsList controls coords crossOrigin data dateTime default defer dir disabled download draggable encType form formAction formEncType formMethod formNoValidate formTarget frameBorder headers height hidden high href hrefLang htmlFor httpEquiv icon id inputMode integrity is keyParams keyType kind label lang list loop low manifest marginHeight marginWidth max maxLength media mediaGroup method min minLength multiple muted name nonce noValidate open optimum pattern placeholder playsInline poster preload profile radioGroup readOnly referrerPolicy rel required reversed role rows rowSpan sandbox scope scoped scrolling seamless selected shape size sizes span spellCheck src srcDoc srcLang srcSet start step style summary tabIndex target title type useMap value width wmode wrap about datatype inlist prefix property resource typeof vocab autoCapitalize autoCorrect autoSave color itemProp itemScope itemType itemID itemRef results security unselectable accentHeight accumulate additive alignmentBaseline allowReorder alphabetic amplitude arabicForm ascent attributeName attributeType autoReverse azimuth baseFrequency baseProfile baselineShift bbox begin bias by calcMode capHeight clip clipPath clipRule clipPathUnits colorInterpolation colorInterpolationFilters colorProfile colorRendering contentScriptType contentStyleType cursor cx cy d decelerate descent diffuseConstant direction display divisor dominantBaseline dur dx dy edgeMode elevation enableBackground end exponent externalResourcesRequired fill fillOpacity fillRule filter filterRes filterUnits floodColor floodOpacity focusable fontFamily fontSize fontSizeAdjust fontStretch fontStyle fontVariant fontWeight format from fx fy g1 g2 glyphName glyphOrientationHorizontal glyphOrientationVertical glyphRef gradientTransform gradientUnits hanging horizAdvX horizOriginX ideographic imageRendering in in2 intercept k k1 k2 k3 k4 kernelMatrix kernelUnitLength kerning keyPoints keySplines keyTimes lengthAdjust letterSpacing lightingColor limitingConeAngle local markerEnd markerMid markerStart markerHeight markerUnits markerWidth mask maskContentUnits maskUnits mathematical mode numOctaves offset opacity operator order orient orientation origin overflow overlinePosition overlineThickness paintOrder panose1 pathLength patternContentUnits patternTransform patternUnits pointerEvents points pointsAtX pointsAtY pointsAtZ preserveAlpha preserveAspectRatio primitiveUnits r radius refX refY renderingIntent repeatCount repeatDur requiredExtensions requiredFeatures restart result rotate rx ry scale seed shapeRendering slope spacing specularConstant specularExponent speed spreadMethod startOffset stdDeviation stemh stemv stitchTiles stopColor stopOpacity strikethroughPosition strikethroughThickness string stroke strokeDasharray strokeDashoffset strokeLinecap strokeLinejoin strokeMiterlimit strokeOpacity strokeWidth surfaceScale systemLanguage tableValues targetX targetY textAnchor textDecoration textRendering textLength to transform u1 u2 underlinePosition underlineThickness unicode unicodeBidi unicodeRange unitsPerEm vAlphabetic vHanging vIdeographic vMathematical values vectorEffect version vertAdvY vertOriginX vertOriginY viewBox viewTarget visibility widths wordSpacing writingMode x xHeight x1 x2 xChannelSelector xlinkActuate xlinkArcrole xlinkHref xlinkRole xlinkShow xlinkTitle xlinkType xmlBase xmlns xmlnsXlink xmlLang xmlSpace y y1 y2 yChannelSelector z zoomAndPan onPointerDown onPointerMove onPointerUp onPointerCancel onGotPointerCapture onLostPointerCapture onPointerEnter onPointerLeave onPointerOver onPointerOut class for autofocus allow allowUserMedia allowPaymentRequest
*/ /* eslint-enable max-len */ var $0b1eca56b0789a79$var$ATTRIBUTE_REGEX = /^((?:s(?:uppressContentEditableWarn|croll|pac)|(?:shape|image|text)Render|(?:letter|word)Spac|vHang|hang)ing|(?:on(?:AnimationIteration|C(?:o(?:mposition(?:Update|Start|End)|ntextMenu|py)|anPlayThrough|anPlay|hange|lick|ut)|(?:Animation|Touch|Load|Drag)Start|(?:(?:Duration|Volume|Rate)Chang|(?:MouseLea|(?:Touch|Mouse)Mo|DragLea)v|Paus)e|Loaded(?:Metad|D)ata|(?:(?:T(?:ransition|ouch)|Animation)E|Suspe)nd|DoubleClick|(?:TouchCanc|Whe)el|Lo(?:stPointer|ad)|TimeUpdate|(?:Mouse(?:Ent|Ov)e|Drag(?:Ent|Ov)e|Erro)r|GotPointer|MouseDown|(?:E(?:n(?:crypt|d)|mpti)|S(?:tall|eek))ed|KeyPress|(?:MouseOu|DragExi|S(?:elec|ubmi)|Rese|Inpu)t|P(?:rogress|laying)|DragEnd|Key(?:Down|Up)|(?:MouseU|Dro)p|(?:Wait|Seek)ing|Scroll|Focus|Paste|Abort|Drag|Play|Blur)Captur|alignmentBaselin|(?:limitingConeAng|xlink(?:(?:Arcr|R)o|Tit)|s(?:urfaceSca|ty|ca)|unselectab|baseProfi|fontSty|(?:focus|dragg)ab|multip|profi|tit)l|d(?:ominantBaselin|efaultValu)|onPointerLeav|a(?:uto(?:Capitaliz|Revers|Sav)|dditiv)|(?:(?:formNoValid|xlinkActu|noValid|accumul|rot)a|autoComple|decelera)t|(?:(?:attribute|item)T|datat)yp|onPointerMov|(?:attribute|glyph)Nam|playsInlin|(?:writing|input|edge)Mod|(?:formE|e)ncTyp|(?:amplitu|mo)d|(?:xlinkTy|itemSco|keyTy|slo)p|(?:xmlSpa|non)c|fillRul|(?:dateTi|na)m|r(?:esourc|ol)|xmlBas|wmod)e|(?:glyphOrientationHorizont|loc)al|(?:externalResourcesRequir|select|revers|mut)ed|c(?:o(?:lorInterpolationFilter|ord)s|o(?:lor(?:Interpolation)?|nt(?:rols|ent))|(?:ontentS(?:cript|tyle)Typ|o(?:ntentEditab|lorProfi)l|l(?:assNam|ipRul)|a(?:lcMod|ptur)|it)e|olorRendering|l(?:ipPathUnits|assID)|(?:ontrolsLis|apHeigh)t|h(?:eckedLink|a(?:llenge|rSet)|ildren|ecked)|ell(?:Spac|Padd)ing|o(?:ntextMenu|ls)|(?:rossOrigi|olSpa)n|l(?:ip(?:Path)?|ass)|ursor|[xy])|glyphOrientationVertical|d(?:angerouslySetInnerHTML|efaultChecked|ownload|isabled|isplay|[xy])|(?:s(?:trikethroughThickn|eaml)es|(?:und|ov)erlineThicknes|r(?:equiredExtension|adiu)|(?:requiredFeatur|tableValu|stitchTil|numOctav|filterR)e|key(?:(?:Splin|Tim)e|Param)|auto[Ff]ocu|header|bia)s|(?:(?:st(?:rikethroughPosi|dDevia)|(?:und|ov)erlinePosi|(?:textDecor|elev)a|orienta)tio|(?:strokeLinejo|orig)i|on(?:PointerDow|FocusI)|formActio|zoomAndPa|directio|(?:vers|act)io|rowSpa|begi|ico)n|o(?:n(?:AnimationIteration|C(?:o(?:mposition(?:Update|Start|End)|ntextMenu|py)|anPlayThrough|anPlay|hange|lick|ut)|(?:(?:Duration|Volume|Rate)Chang|(?:MouseLea|(?:Touch|Mouse)Mo|DragLea)v|Paus)e|Loaded(?:Metad|D)ata|(?:Animation|Touch|Load|Drag)Start|(?:(?:T(?:ransition|ouch)|Animation)E|Suspe)nd|DoubleClick|(?:TouchCanc|Whe)el|(?:Mouse(?:Ent|Ov)e|Drag(?:Ent|Ov)e|Erro)r|TimeUpdate|(?:E(?:n(?:crypt|d)|mpti)|S(?:tall|eek))ed|MouseDown|P(?:rogress|laying)|(?:MouseOu|DragExi|S(?:elec|ubmi)|Rese|Inpu)t|KeyPress|DragEnd|Key(?:Down|Up)|(?:Wait|Seek)ing|(?:MouseU|Dro)p|Scroll|Paste|Focus|Abort|Drag|Play|Load|Blur)|rient)|p(?:reserveAspectRatio|ointsAt[X-Z]|anose1)|(?:(?:allowPaymentReque|(?:fontSize|length)Adju|manife)s|strokeMiterlimi|(?:(?:specularE|e)xpon|renderingInt|asc)en|(?:specularConsta|repeatCou|fontVaria)n|d(?:iffuseConsta|esce)n|baselineShif|vectorEffec|onPointerOu|(?:(?:mar(?:ker|gin)|x)H|accentH|fontW)eigh|markerStar|a(?:utoCorrec|bou)|onFocusOu|intercep|restar|forma|inlis|heigh|lis)t|(?:patternContent|ma(?:sk(?:Content)?|rker)|primitive|gradient|pattern|filter)Units|(?:(?:allowTranspar|baseFrequ)enc|re(?:ferrerPolic|adOnl)|(?:(?:st(?:roke|op)O|floodO|fillO|o)pac|integr|secur)it|visibilit|fontFamil|accessKe|propert|summar)y|(?:gradientT|patternT|t)ransform|(?:(?:st(?:rokeDasho|artO)|o)ffs|acceptChars|formTarg|viewTarg|srcS)et|(?:[xy]ChannelSelect|lightingCol|textAnch|floodCol|stopCol|operat|htmlF)or|(?:(?:enableBackgrou|markerE)n|s(?:p(?:readMetho|ee)|ee)|formMetho|(?:markerM|onInval)i|preloa|metho|kin)d|k(?:ernel(?:UnitLength|Matrix)|[1-4])|strokeDasharray|(?:onPointerCanc|lab)el|(?:allowFullScre|hidd)en|a(?:l(?:lowUserMedia|phabetic|t)|rabicForm|sync)|systemLanguage|(?:(?:o(?:nPointer(?:Ent|Ov)|rd)|allowReord|placehold|frameBord|paintOrd|post)e|repeatDu|d(?:efe|u))r|(?:pointerEve|keyPoi)nts|preserveAlpha|(?:strokeLineca|onPointerU|itemPro|useMa|wra|loo)p|v(?:Mathematical|ert(?:Origin[XY]|AdvY)|alues|ocab)|unicodeRange|h(?:oriz(?:Origin|Adv)X|ttpEquiv)|(?:vI|i)deographic|mathematical|u(?:nicodeBidi|[12])|(?:fontStretc|hig)h|vAlphabetic|(?:(?:mar(?:ker|gin)W|strokeW)id|azimu)th|(?:xmlnsXl|valueL)ink|mediaGroup|spellCheck|(?:text|m(?:in|ax))Length|(?:unitsPerE|optimu|fro)m|r(?:adioGroup|e(?:sults|f[XY]|l)|ows|[xy])|pathLength|(?:xlinkHr|glyphR)ef|innerHTML|xlinkShow|f(?:o(?:ntSize|rm?)|il(?:ter|l))|(?:tabInde|(?:sand|b)bo|viewBo)x|autoPlay|r(?:e(?:quired|sult|f))?|(?:(?:href|xml|src)La|kerni)ng|o(?:verflow|pen)|i(?:temRef|n2|s)|p(?:attern|oints)|unicode|d(?:efault|ata|ir)?|divisor|t(?:arget[XY]|o)|(?:stri|la)ng|(?:width|size)s|prefix|typeof|srcDoc|s(?:coped|te(?:m[hv]|p)|pan)|s(?:t(?:roke|art)|hape|cope|rc)|a(?:ccept|llow|s)|itemID|t(?:arget|ype)|m(?:edia|a(?:sk|x)|in)|value|width|x(?:mlns)?|size|href|k(?:ey)?|end|low|by|x[12]|y[12]|g[12]|i[dn]|f[xy]|[yz])$/;
/* From DOMProperty */ var $0b1eca56b0789a79$var$ATTRIBUTE_NAME_START_CHAR = ':A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD';
var $0b1eca56b0789a79$var$ATTRIBUTE_NAME_CHAR = $0b1eca56b0789a79$var$ATTRIBUTE_NAME_START_CHAR + '\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040';
var $0b1eca56b0789a79$var$isCustomAttribute = RegExp.prototype.test.bind(new RegExp('^(x|data|aria)-[' + $0b1eca56b0789a79$var$ATTRIBUTE_NAME_CHAR + ']*$'));
var $0b1eca56b0789a79$var$validAttr = function(name) {
    return $0b1eca56b0789a79$var$ATTRIBUTE_REGEX.test(name) || $0b1eca56b0789a79$var$isCustomAttribute(name.toLowerCase());
};
// 
function $0b1eca56b0789a79$var$hasInInheritanceChain(child, parent) {
    var target = child;
    while(target){
        target = Object.getPrototypeOf(target);
        if (target && target === parent) return true;
    }
    return false;
}
// 
/**
 * Creates a broadcast that can be listened to, i.e. simple event emitter
 *
 * @see https://github.com/ReactTraining/react-broadcast
 */ var $0b1eca56b0789a79$var$createBroadcast = function createBroadcast(initialState) {
    var listeners = {};
    var id = 0;
    var state = initialState;
    function publish(nextState) {
        state = nextState;
        // eslint-disable-next-line guard-for-in, no-restricted-syntax
        for(var key in listeners){
            var listener = listeners[key];
            if (listener === undefined) continue;
            listener(state);
        }
    }
    function subscribe(listener) {
        var currentId = id;
        listeners[currentId] = listener;
        id += 1;
        listener(state);
        return currentId;
    }
    function unsubscribe(unsubID) {
        listeners[unsubID] = undefined;
    }
    return {
        publish: publish,
        subscribe: subscribe,
        unsubscribe: unsubscribe
    };
};
var $0b1eca56b0789a79$var$_contextShape, $0b1eca56b0789a79$var$_ThemeProvider$contex;
// NOTE: DO NOT CHANGE, changing this is a semver major change!
var $0b1eca56b0789a79$var$CHANNEL = '__styled-components__';
var $0b1eca56b0789a79$var$CHANNEL_NEXT = $0b1eca56b0789a79$var$CHANNEL + 'next__';
var $0b1eca56b0789a79$var$CONTEXT_CHANNEL_SHAPE = (0, (/*@__PURE__*/$parcel$interopDefault($8vJ0V))).shape({
    getTheme: (0, (/*@__PURE__*/$parcel$interopDefault($8vJ0V))).func,
    subscribe: (0, (/*@__PURE__*/$parcel$interopDefault($8vJ0V))).func,
    unsubscribe: (0, (/*@__PURE__*/$parcel$interopDefault($8vJ0V))).func
});
var $0b1eca56b0789a79$var$contextShape = ($0b1eca56b0789a79$var$_contextShape = {}, $0b1eca56b0789a79$var$_contextShape[$0b1eca56b0789a79$var$CHANNEL] = (0, (/*@__PURE__*/$parcel$interopDefault($8vJ0V))).func, $0b1eca56b0789a79$var$_contextShape[$0b1eca56b0789a79$var$CHANNEL_NEXT] = $0b1eca56b0789a79$var$CONTEXT_CHANNEL_SHAPE, $0b1eca56b0789a79$var$_contextShape);
var $0b1eca56b0789a79$var$warnChannelDeprecated = void 0;
var $0b1eca56b0789a79$var$isFunction = function isFunction(test) {
    return typeof test === 'function';
};
/**
 * Provide a theme to an entire react component tree via context and event listeners (have to do
 * both context and event emitter as pure components block context updates)
 */ var $0b1eca56b0789a79$export$d8964aec282183a3 = function(_Component) {
    $0b1eca56b0789a79$var$inherits(ThemeProvider, _Component);
    function ThemeProvider() {
        $0b1eca56b0789a79$var$classCallCheck(this, ThemeProvider);
        var _this = $0b1eca56b0789a79$var$possibleConstructorReturn(this, _Component.call(this));
        _this.unsubscribeToOuterId = -1;
        _this.getTheme = _this.getTheme.bind(_this);
        return _this;
    }
    ThemeProvider.prototype.componentWillMount = function componentWillMount() {
        var _this2 = this;
        // If there is a ThemeProvider wrapper anywhere around this theme provider, merge this theme
        // with the outer theme
        var outerContext = this.context[$0b1eca56b0789a79$var$CHANNEL_NEXT];
        if (outerContext !== undefined) this.unsubscribeToOuterId = outerContext.subscribe(function(theme) {
            _this2.outerTheme = theme;
            if (_this2.broadcast !== undefined) _this2.publish(_this2.props.theme);
        });
        this.broadcast = $0b1eca56b0789a79$var$createBroadcast(this.getTheme());
    };
    ThemeProvider.prototype.getChildContext = function getChildContext() {
        var _this3 = this, _babelHelpers$extends;
        return $0b1eca56b0789a79$var$_extends({}, this.context, (_babelHelpers$extends = {}, _babelHelpers$extends[$0b1eca56b0789a79$var$CHANNEL_NEXT] = {
            getTheme: this.getTheme,
            subscribe: this.broadcast.subscribe,
            unsubscribe: this.broadcast.unsubscribe
        }, _babelHelpers$extends[$0b1eca56b0789a79$var$CHANNEL] = function(subscriber) {
            // Patch the old `subscribe` provide via `CHANNEL` for older clients.
            var unsubscribeId = _this3.broadcast.subscribe(subscriber);
            return function() {
                return _this3.broadcast.unsubscribe(unsubscribeId);
            };
        }, _babelHelpers$extends));
    };
    ThemeProvider.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
        if (this.props.theme !== nextProps.theme) this.publish(nextProps.theme);
    };
    ThemeProvider.prototype.componentWillUnmount = function componentWillUnmount() {
        if (this.unsubscribeToOuterId !== -1) this.context[$0b1eca56b0789a79$var$CHANNEL_NEXT].unsubscribe(this.unsubscribeToOuterId);
    };
    // Get the theme from the props, supporting both (outerTheme) => {} as well as object notation
    ThemeProvider.prototype.getTheme = function getTheme(passedTheme) {
        var theme = passedTheme || this.props.theme;
        if ($0b1eca56b0789a79$var$isFunction(theme)) {
            var mergedTheme = theme(this.outerTheme);
            return mergedTheme;
        }
        if (theme === null || Array.isArray(theme) || (typeof theme === 'undefined' ? 'undefined' : $0b1eca56b0789a79$var$_typeof(theme)) !== 'object') throw new $0b1eca56b0789a79$var$StyledComponentsError(8);
        return $0b1eca56b0789a79$var$_extends({}, this.outerTheme, theme);
    };
    ThemeProvider.prototype.publish = function publish(theme) {
        this.broadcast.publish(this.getTheme(theme));
    };
    ThemeProvider.prototype.render = function render() {
        if (!this.props.children) return null;
        return (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).Children.only(this.props.children);
    };
    return ThemeProvider;
}((0, $5FkrB.Component));
$0b1eca56b0789a79$export$d8964aec282183a3.childContextTypes = $0b1eca56b0789a79$var$contextShape;
$0b1eca56b0789a79$export$d8964aec282183a3.contextTypes = ($0b1eca56b0789a79$var$_ThemeProvider$contex = {}, $0b1eca56b0789a79$var$_ThemeProvider$contex[$0b1eca56b0789a79$var$CHANNEL_NEXT] = $0b1eca56b0789a79$var$CONTEXT_CHANNEL_SHAPE, $0b1eca56b0789a79$var$_ThemeProvider$contex);
var $0b1eca56b0789a79$var$_babelHelpers$extends;
// HACK for generating all static styles without needing to allocate
// an empty execution context every single time...
var $0b1eca56b0789a79$var$STATIC_EXECUTION_CONTEXT = {};
var $0b1eca56b0789a79$var$modifiedContextShape = $0b1eca56b0789a79$var$_extends({}, $0b1eca56b0789a79$var$contextShape, ($0b1eca56b0789a79$var$_babelHelpers$extends = {}, $0b1eca56b0789a79$var$_babelHelpers$extends[$0b1eca56b0789a79$var$CONTEXT_KEY] = (0, (/*@__PURE__*/$parcel$interopDefault($8vJ0V))).oneOfType([
    (0, (/*@__PURE__*/$parcel$interopDefault($8vJ0V))).instanceOf($0b1eca56b0789a79$var$StyleSheet),
    (0, (/*@__PURE__*/$parcel$interopDefault($8vJ0V))).instanceOf($0b1eca56b0789a79$export$ae8c7d15c8b89a20)
]), $0b1eca56b0789a79$var$_babelHelpers$extends));
var $0b1eca56b0789a79$var$identifiers = {};
/* We depend on components having unique IDs */ var $0b1eca56b0789a79$var$generateId = function generateId(ComponentStyle, _displayName, parentComponentId) {
    var displayName = typeof _displayName !== 'string' ? 'sc' : $0b1eca56b0789a79$var$escape(_displayName);
    /**
   * This ensures uniqueness if two components happen to share
   * the same displayName.
   */ var nr = ($0b1eca56b0789a79$var$identifiers[displayName] || 0) + 1;
    $0b1eca56b0789a79$var$identifiers[displayName] = nr;
    var componentId = displayName + '-' + ComponentStyle.generateName(displayName + nr);
    return parentComponentId !== undefined ? parentComponentId + '-' + componentId : componentId;
};
var $0b1eca56b0789a79$var$warnExtendDeprecated = function warnExtendDeprecated() {};
// $FlowFixMe
var $0b1eca56b0789a79$var$BaseStyledComponent = function(_Component) {
    $0b1eca56b0789a79$var$inherits(BaseStyledComponent, _Component);
    function BaseStyledComponent() {
        var _temp, _this, _ret;
        $0b1eca56b0789a79$var$classCallCheck(this, BaseStyledComponent);
        for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return _ret = (_temp = (_this = $0b1eca56b0789a79$var$possibleConstructorReturn(this, _Component.call.apply(_Component, [
            this
        ].concat(args))), _this), _this.attrs = {}, _this.state = {
            theme: null,
            generatedClassName: ''
        }, _this.unsubscribeId = -1, _temp), $0b1eca56b0789a79$var$possibleConstructorReturn(_this, _ret);
    }
    BaseStyledComponent.prototype.unsubscribeFromContext = function unsubscribeFromContext() {
        if (this.unsubscribeId !== -1) this.context[$0b1eca56b0789a79$var$CHANNEL_NEXT].unsubscribe(this.unsubscribeId);
    };
    BaseStyledComponent.prototype.buildExecutionContext = function buildExecutionContext(theme, props) {
        var attrs = this.constructor.attrs;
        var context = $0b1eca56b0789a79$var$_extends({}, props, {
            theme: theme
        });
        if (attrs === undefined) return context;
        this.attrs = Object.keys(attrs).reduce(function(acc, key) {
            var attr = attrs[key];
            // eslint-disable-next-line no-param-reassign
            acc[key] = typeof attr === 'function' && !$0b1eca56b0789a79$var$hasInInheritanceChain(attr, (0, $5FkrB.Component)) ? attr(context) : attr;
            return acc;
        }, {});
        return $0b1eca56b0789a79$var$_extends({}, context, this.attrs);
    };
    BaseStyledComponent.prototype.generateAndInjectStyles = function generateAndInjectStyles(theme, props) {
        var _constructor = this.constructor, attrs = _constructor.attrs, componentStyle = _constructor.componentStyle, warnTooManyClasses = _constructor.warnTooManyClasses;
        var styleSheet = this.context[$0b1eca56b0789a79$var$CONTEXT_KEY] || $0b1eca56b0789a79$var$StyleSheet.master;
        // statically styled-components don't need to build an execution context object,
        // and shouldn't be increasing the number of class names
        if (componentStyle.isStatic && attrs === undefined) return componentStyle.generateAndInjectStyles($0b1eca56b0789a79$var$STATIC_EXECUTION_CONTEXT, styleSheet);
        else {
            var executionContext = this.buildExecutionContext(theme, props);
            var className = componentStyle.generateAndInjectStyles(executionContext, styleSheet);
            return className;
        }
    };
    BaseStyledComponent.prototype.componentWillMount = function componentWillMount() {
        var _this2 = this;
        var componentStyle = this.constructor.componentStyle;
        var styledContext = this.context[$0b1eca56b0789a79$var$CHANNEL_NEXT];
        // If this is a statically-styled component, we don't need to the theme
        // to generate or build styles.
        if (componentStyle.isStatic) {
            var generatedClassName = this.generateAndInjectStyles($0b1eca56b0789a79$var$STATIC_EXECUTION_CONTEXT, this.props);
            this.setState({
                generatedClassName: generatedClassName
            });
        // If there is a theme in the context, subscribe to the event emitter. This
        // is necessary due to pure components blocking context updates, this circumvents
        // that by updating when an event is emitted
        } else if (styledContext !== undefined) {
            var subscribe = styledContext.subscribe;
            this.unsubscribeId = subscribe(function(nextTheme) {
                // This will be called once immediately
                var theme = $0b1eca56b0789a79$var$determineTheme(_this2.props, nextTheme, _this2.constructor.defaultProps);
                var generatedClassName = _this2.generateAndInjectStyles(theme, _this2.props);
                _this2.setState({
                    theme: theme,
                    generatedClassName: generatedClassName
                });
            });
        } else {
            // eslint-disable-next-line react/prop-types
            var theme = this.props.theme || $0b1eca56b0789a79$var$EMPTY_OBJECT;
            var _generatedClassName = this.generateAndInjectStyles(theme, this.props);
            this.setState({
                theme: theme,
                generatedClassName: _generatedClassName
            });
        }
    };
    BaseStyledComponent.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
        var _this3 = this;
        // If this is a statically-styled component, we don't need to listen to
        // props changes to update styles
        var componentStyle = this.constructor.componentStyle;
        if (componentStyle.isStatic) return;
        this.setState(function(prevState) {
            var theme = $0b1eca56b0789a79$var$determineTheme(nextProps, prevState.theme, _this3.constructor.defaultProps);
            var generatedClassName = _this3.generateAndInjectStyles(theme, nextProps);
            return {
                theme: theme,
                generatedClassName: generatedClassName
            };
        });
    };
    BaseStyledComponent.prototype.componentWillUnmount = function componentWillUnmount() {
        this.unsubscribeFromContext();
    };
    BaseStyledComponent.prototype.render = function render() {
        // eslint-disable-next-line react/prop-types
        var innerRef = this.props.innerRef;
        var generatedClassName = this.state.generatedClassName;
        var _constructor2 = this.constructor, styledComponentId = _constructor2.styledComponentId, target = _constructor2.target;
        var isTargetTag = $0b1eca56b0789a79$var$isTag(target);
        var className = [
            // eslint-disable-next-line react/prop-types
            this.props.className,
            styledComponentId,
            this.attrs.className,
            generatedClassName
        ].filter(Boolean).join(' ');
        var baseProps = $0b1eca56b0789a79$var$_extends({}, this.attrs, {
            className: className
        });
        if ($0b1eca56b0789a79$export$7ba318d8d2f06c76(target)) baseProps.innerRef = innerRef;
        else baseProps.ref = innerRef;
        var propsForElement = baseProps;
        var key = void 0;
        for(key in this.props)// Don't pass through non HTML tags through to HTML elements
        // always omit innerRef
        if (key !== 'innerRef' && key !== 'className' && (!isTargetTag || $0b1eca56b0789a79$var$validAttr(key))) propsForElement[key] = key === 'style' && key in this.attrs ? $0b1eca56b0789a79$var$_extends({}, this.attrs[key], this.props[key]) : this.props[key];
        return (0, $5FkrB.createElement)(target, propsForElement);
    };
    return BaseStyledComponent;
}((0, $5FkrB.Component));
var $0b1eca56b0789a79$var$_StyledComponent = function(ComponentStyle, constructWithOptions) {
    var createStyledComponent = function createStyledComponent(target, options, rules) {
        var _options$isClass = options.isClass, isClass = _options$isClass === undefined ? !$0b1eca56b0789a79$var$isTag(target) : _options$isClass, _options$displayName = options.displayName, displayName = _options$displayName === undefined ? $0b1eca56b0789a79$var$generateDisplayName(target) : _options$displayName, _options$componentId = options.componentId, componentId = _options$componentId === undefined ? $0b1eca56b0789a79$var$generateId(ComponentStyle, options.displayName, options.parentComponentId) : _options$componentId, _options$ParentCompon = options.ParentComponent, ParentComponent = _options$ParentCompon === undefined ? $0b1eca56b0789a79$var$BaseStyledComponent : _options$ParentCompon, extendingRules = options.rules, attrs = options.attrs;
        var styledComponentId = options.displayName && options.componentId ? $0b1eca56b0789a79$var$escape(options.displayName) + '-' + options.componentId : options.componentId || componentId;
        var componentStyle = new ComponentStyle(extendingRules === undefined ? rules : extendingRules.concat(rules), attrs, styledComponentId);
        var StyledComponent = function(_ParentComponent) {
            $0b1eca56b0789a79$var$inherits(StyledComponent, _ParentComponent);
            function StyledComponent() {
                $0b1eca56b0789a79$var$classCallCheck(this, StyledComponent);
                return $0b1eca56b0789a79$var$possibleConstructorReturn(this, _ParentComponent.apply(this, arguments));
            }
            StyledComponent.withComponent = function withComponent(tag) {
                var previousComponentId = options.componentId, optionsToCopy = $0b1eca56b0789a79$var$objectWithoutProperties(options, [
                    'componentId'
                ]);
                var newComponentId = previousComponentId && previousComponentId + '-' + ($0b1eca56b0789a79$var$isTag(tag) ? tag : $0b1eca56b0789a79$var$escape($0b1eca56b0789a79$var$getComponentName(tag)));
                var newOptions = $0b1eca56b0789a79$var$_extends({}, optionsToCopy, {
                    componentId: newComponentId,
                    ParentComponent: StyledComponent
                });
                return createStyledComponent(tag, newOptions, rules);
            };
            $0b1eca56b0789a79$var$createClass(StyledComponent, null, [
                {
                    key: 'extend',
                    get: function get$$1() {
                        var rulesFromOptions = options.rules, parentComponentId = options.componentId, optionsToCopy = $0b1eca56b0789a79$var$objectWithoutProperties(options, [
                            'rules',
                            'componentId'
                        ]);
                        var newRules = rulesFromOptions === undefined ? rules : rulesFromOptions.concat(rules);
                        var newOptions = $0b1eca56b0789a79$var$_extends({}, optionsToCopy, {
                            rules: newRules,
                            parentComponentId: parentComponentId,
                            ParentComponent: StyledComponent
                        });
                        $0b1eca56b0789a79$var$warnExtendDeprecated();
                        return constructWithOptions(createStyledComponent, target, newOptions);
                    }
                }
            ]);
            return StyledComponent;
        }(ParentComponent);
        StyledComponent.attrs = attrs;
        StyledComponent.componentStyle = componentStyle;
        StyledComponent.contextTypes = $0b1eca56b0789a79$var$modifiedContextShape;
        StyledComponent.displayName = displayName;
        StyledComponent.styledComponentId = styledComponentId;
        StyledComponent.target = target;
        if (isClass) (0, (/*@__PURE__*/$parcel$interopDefault($7587df36c2dc3210$exports)))(StyledComponent, target, {
            // all SC-specific things should not be hoisted
            attrs: true,
            componentStyle: true,
            displayName: true,
            extend: true,
            styledComponentId: true,
            target: true,
            warnTooManyClasses: true,
            withComponent: true
        });
        return StyledComponent;
    };
    return createStyledComponent;
};
// Source: https://github.com/garycourt/murmurhash-js/blob/master/murmurhash2_gc.js
function $0b1eca56b0789a79$var$murmurhash(str) {
    var l = str.length | 0, h = l | 0, i = 0, k;
    while(l >= 4){
        k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
        k = (k & 0xffff) * 0x5bd1e995 + (((k >>> 16) * 0x5bd1e995 & 0xffff) << 16);
        k ^= k >>> 24;
        k = (k & 0xffff) * 0x5bd1e995 + (((k >>> 16) * 0x5bd1e995 & 0xffff) << 16);
        h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16) ^ k;
        l -= 4;
        ++i;
    }
    switch(l){
        case 3:
            h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
        case 2:
            h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
        case 1:
            h ^= str.charCodeAt(i) & 0xff;
            h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16);
    }
    h ^= h >>> 13;
    h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16);
    h ^= h >>> 15;
    return h >>> 0;
}
// 
var $0b1eca56b0789a79$var$areStylesCacheable = $0b1eca56b0789a79$var$IS_BROWSER;
var $0b1eca56b0789a79$var$isStaticRules = function isStaticRules(rules, attrs) {
    for(var i = 0, len = rules.length; i < len; i += 1){
        var rule = rules[i];
        // recursive case
        if (Array.isArray(rule) && !isStaticRules(rule)) return false;
        else if (typeof rule === 'function' && !$0b1eca56b0789a79$export$7ba318d8d2f06c76(rule)) // functions are allowed to be static if they're just being
        // used to get the classname of a nested styled component
        return false;
    }
    if (attrs !== undefined) // eslint-disable-next-line guard-for-in, no-restricted-syntax
    for(var key in attrs){
        if (typeof attrs[key] === 'function') return false;
    }
    return true;
};
var $0b1eca56b0789a79$var$isHMREnabled = (0, null) && false;
/*
 ComponentStyle is all the CSS-specific stuff, not
 the React-specific stuff.
 */ var $0b1eca56b0789a79$var$_ComponentStyle = function(nameGenerator, flatten, stringifyRules) {
    /* combines hashStr (murmurhash) and nameGenerator for convenience */ var generateRuleHash = function generateRuleHash(str) {
        return nameGenerator($0b1eca56b0789a79$var$murmurhash(str));
    };
    var ComponentStyle = function() {
        function ComponentStyle(rules, attrs, componentId) {
            $0b1eca56b0789a79$var$classCallCheck(this, ComponentStyle);
            this.rules = rules;
            this.isStatic = !$0b1eca56b0789a79$var$isHMREnabled && $0b1eca56b0789a79$var$isStaticRules(rules, attrs);
            this.componentId = componentId;
            if (!$0b1eca56b0789a79$var$StyleSheet.master.hasId(componentId)) {
                var placeholder = [];
                $0b1eca56b0789a79$var$StyleSheet.master.deferredInject(componentId, placeholder);
            }
        }
        /*
     * Flattens a rule set into valid CSS
     * Hashes it, wraps the whole chunk in a .hash1234 {}
     * Returns the hash to be injected on render()
     * */ ComponentStyle.prototype.generateAndInjectStyles = function generateAndInjectStyles(executionContext, styleSheet) {
            var isStatic = this.isStatic, componentId = this.componentId, lastClassName = this.lastClassName;
            if ($0b1eca56b0789a79$var$areStylesCacheable && isStatic && lastClassName !== undefined && styleSheet.hasNameForId(componentId, lastClassName)) return lastClassName;
            var flatCSS = flatten(this.rules, executionContext);
            var name = generateRuleHash(this.componentId + flatCSS.join(''));
            if (!styleSheet.hasNameForId(componentId, name)) styleSheet.inject(this.componentId, stringifyRules(flatCSS, '.' + name), name);
            this.lastClassName = name;
            return name;
        };
        ComponentStyle.generateName = function generateName(str) {
            return generateRuleHash(str);
        };
        return ComponentStyle;
    }();
    return ComponentStyle;
};
// 
// Thanks to ReactDOMFactories for this handy list!
var $0b1eca56b0789a79$var$domElements = [
    'a',
    'abbr',
    'address',
    'area',
    'article',
    'aside',
    'audio',
    'b',
    'base',
    'bdi',
    'bdo',
    'big',
    'blockquote',
    'body',
    'br',
    'button',
    'canvas',
    'caption',
    'cite',
    'code',
    'col',
    'colgroup',
    'data',
    'datalist',
    'dd',
    'del',
    'details',
    'dfn',
    'dialog',
    'div',
    'dl',
    'dt',
    'em',
    'embed',
    'fieldset',
    'figcaption',
    'figure',
    'footer',
    'form',
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'h6',
    'head',
    'header',
    'hgroup',
    'hr',
    'html',
    'i',
    'iframe',
    'img',
    'input',
    'ins',
    'kbd',
    'keygen',
    'label',
    'legend',
    'li',
    'link',
    'main',
    'map',
    'mark',
    'marquee',
    'menu',
    'menuitem',
    'meta',
    'meter',
    'nav',
    'noscript',
    'object',
    'ol',
    'optgroup',
    'option',
    'output',
    'p',
    'param',
    'picture',
    'pre',
    'progress',
    'q',
    'rp',
    'rt',
    'ruby',
    's',
    'samp',
    'script',
    'section',
    'select',
    'small',
    'source',
    'span',
    'strong',
    'style',
    'sub',
    'summary',
    'sup',
    'table',
    'tbody',
    'td',
    'textarea',
    'tfoot',
    'th',
    'thead',
    'time',
    'title',
    'tr',
    'track',
    'u',
    'ul',
    'var',
    'video',
    'wbr',
    // SVG
    'circle',
    'clipPath',
    'defs',
    'ellipse',
    'foreignObject',
    'g',
    'image',
    'line',
    'linearGradient',
    'mask',
    'path',
    'pattern',
    'polygon',
    'polyline',
    'radialGradient',
    'rect',
    'stop',
    'svg',
    'text',
    'tspan'
];
// 
var $0b1eca56b0789a79$var$_styled = function(styledComponent, constructWithOptions) {
    var styled = function styled(tag) {
        return constructWithOptions(styledComponent, tag);
    };
    // Shorthands for all valid HTML Elements
    $0b1eca56b0789a79$var$domElements.forEach(function(domElement) {
        styled[domElement] = styled(domElement);
    });
    return styled;
};
// 
var $0b1eca56b0789a79$var$replaceWhitespace = function replaceWhitespace(str) {
    return str.replace(/\s|\\n/g, '');
};
var $0b1eca56b0789a79$var$_keyframes = function(nameGenerator, stringifyRules, css) {
    return function() {
        var styleSheet = $0b1eca56b0789a79$var$StyleSheet.master;
        var rules = css.apply(undefined, arguments);
        var name = nameGenerator($0b1eca56b0789a79$var$murmurhash($0b1eca56b0789a79$var$replaceWhitespace(JSON.stringify(rules))));
        var id = 'sc-keyframes-' + name;
        if (!styleSheet.hasNameForId(id, name)) styleSheet.inject(id, stringifyRules(rules, name, '@keyframes'), name);
        return name;
    };
};
// 
var $0b1eca56b0789a79$var$_injectGlobal = function(stringifyRules, css) {
    var injectGlobal = function injectGlobal() {
        var styleSheet = $0b1eca56b0789a79$var$StyleSheet.master;
        var rules = css.apply(undefined, arguments);
        var hash = $0b1eca56b0789a79$var$murmurhash(JSON.stringify(rules));
        var id = 'sc-global-' + hash;
        if (!styleSheet.hasId(id)) styleSheet.inject(id, stringifyRules(rules));
    };
    return injectGlobal;
};
// 
var $0b1eca56b0789a79$var$_constructWithOptions = function(css) {
    var constructWithOptions = function constructWithOptions(componentConstructor, tag) {
        var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : $0b1eca56b0789a79$var$EMPTY_OBJECT;
        if (!(0, $lwfCu.isValidElementType)(tag)) throw new $0b1eca56b0789a79$var$StyledComponentsError(1, String(tag));
        /* This is callable directly as a template function */ // $FlowFixMe: Not typed to avoid destructuring arguments
        var templateFunction = function templateFunction() {
            return componentConstructor(tag, options, css.apply(undefined, arguments));
        };
        /* If config methods are called, wrap up a new template function and merge options */ templateFunction.withConfig = function(config) {
            return constructWithOptions(componentConstructor, tag, $0b1eca56b0789a79$var$_extends({}, options, config));
        };
        templateFunction.attrs = function(attrs) {
            return constructWithOptions(componentConstructor, tag, $0b1eca56b0789a79$var$_extends({}, options, {
                attrs: $0b1eca56b0789a79$var$_extends({}, options.attrs || $0b1eca56b0789a79$var$EMPTY_OBJECT, attrs)
            }));
        };
        return templateFunction;
    };
    return constructWithOptions;
};
// 
var $0b1eca56b0789a79$export$e8748c6a27b910dc = function(Component$$1) {
    var isStatelessFunctionalComponent = typeof Component$$1 === 'function' && // $FlowFixMe TODO: flow for prototype
    !(Component$$1.prototype && 'isReactComponent' in Component$$1.prototype);
    // NOTE: We can't pass a ref to a stateless functional component
    var shouldSetInnerRef = $0b1eca56b0789a79$export$7ba318d8d2f06c76(Component$$1) || isStatelessFunctionalComponent;
    var WithTheme = function(_React$Component) {
        $0b1eca56b0789a79$var$inherits(WithTheme, _React$Component);
        function WithTheme() {
            var _temp, _this, _ret;
            $0b1eca56b0789a79$var$classCallCheck(this, WithTheme);
            for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            return _ret = (_temp = (_this = $0b1eca56b0789a79$var$possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [
                this
            ].concat(args))), _this), _this.state = $0b1eca56b0789a79$var$EMPTY_OBJECT, _this.unsubscribeId = -1, _temp), $0b1eca56b0789a79$var$possibleConstructorReturn(_this, _ret);
        }
        // NOTE: This is so that isStyledComponent passes for the innerRef unwrapping
        WithTheme.prototype.componentWillMount = function componentWillMount() {
            var _this2 = this;
            var defaultProps = this.constructor.defaultProps;
            var styledContext = this.context[$0b1eca56b0789a79$var$CHANNEL_NEXT];
            var themeProp = $0b1eca56b0789a79$var$determineTheme(this.props, undefined, defaultProps);
            if (styledContext === undefined && themeProp !== undefined) this.setState({
                theme: themeProp
            });
            else {
                var subscribe = styledContext.subscribe;
                this.unsubscribeId = subscribe(function(nextTheme) {
                    var theme = $0b1eca56b0789a79$var$determineTheme(_this2.props, nextTheme, defaultProps);
                    _this2.setState({
                        theme: theme
                    });
                });
            }
        };
        WithTheme.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
            var defaultProps = this.constructor.defaultProps;
            this.setState(function(oldState) {
                var theme = $0b1eca56b0789a79$var$determineTheme(nextProps, oldState.theme, defaultProps);
                return {
                    theme: theme
                };
            });
        };
        WithTheme.prototype.componentWillUnmount = function componentWillUnmount() {
            if (this.unsubscribeId !== -1) this.context[$0b1eca56b0789a79$var$CHANNEL_NEXT].unsubscribe(this.unsubscribeId);
        };
        WithTheme.prototype.render = function render() {
            var props = $0b1eca56b0789a79$var$_extends({
                theme: this.state.theme
            }, this.props);
            if (!shouldSetInnerRef) {
                props.ref = props.innerRef;
                delete props.innerRef;
            }
            return (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(Component$$1, props);
        };
        return WithTheme;
    }((0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).Component);
    WithTheme.contextTypes = $0b1eca56b0789a79$var$contextShape;
    WithTheme.displayName = 'WithTheme(' + $0b1eca56b0789a79$var$getComponentName(Component$$1) + ')';
    WithTheme.styledComponentId = 'withTheme';
    return (0, (/*@__PURE__*/$parcel$interopDefault($7587df36c2dc3210$exports)))(WithTheme, Component$$1);
};
// 
/* eslint-disable */ var $0b1eca56b0789a79$export$84079c323bb0915e = {
    StyleSheet: $0b1eca56b0789a79$var$StyleSheet
};
/* Instantiate singletons */ var $0b1eca56b0789a79$var$ComponentStyle = $0b1eca56b0789a79$var$_ComponentStyle($0b1eca56b0789a79$var$generateAlphabeticName, $0b1eca56b0789a79$var$flatten, $0b1eca56b0789a79$var$stringifyRules);
var $0b1eca56b0789a79$var$constructWithOptions = $0b1eca56b0789a79$var$_constructWithOptions($0b1eca56b0789a79$export$dbf350e5966cf602);
var $0b1eca56b0789a79$var$StyledComponent = $0b1eca56b0789a79$var$_StyledComponent($0b1eca56b0789a79$var$ComponentStyle, $0b1eca56b0789a79$var$constructWithOptions);
/* Instantiate exported singletons */ var $0b1eca56b0789a79$export$d25ddfdf17c3ad3e = $0b1eca56b0789a79$var$_keyframes($0b1eca56b0789a79$var$generateAlphabeticName, $0b1eca56b0789a79$var$stringifyRules, $0b1eca56b0789a79$export$dbf350e5966cf602);
var $0b1eca56b0789a79$export$efb9f5caaa2ca0c7 = $0b1eca56b0789a79$var$_injectGlobal($0b1eca56b0789a79$var$stringifyRules, $0b1eca56b0789a79$export$dbf350e5966cf602);
var $0b1eca56b0789a79$var$styled = $0b1eca56b0789a79$var$_styled($0b1eca56b0789a79$var$StyledComponent, $0b1eca56b0789a79$var$constructWithOptions);
var $0b1eca56b0789a79$export$2e2bcd8739ae039 = $0b1eca56b0789a79$var$styled;



var $d1af5435ad8463ff$export$30c615a45297e297 = (0, $0b1eca56b0789a79$export$2e2bcd8739ae039).div({
    marginRight: "var(--ds-space-025, 2px)",
    textAlign: 'center',
    width: '32px'
});
var $d1af5435ad8463ff$export$d675f139b342d51a = (0, $0b1eca56b0789a79$export$2e2bcd8739ae039).div(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
function(props) {
    return {
        alignItems: 'center',
        display: 'flex',
        flexDirection: 'column',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        height: "".concat(props.height || 128, "px"),
        justifyContent: 'center'
    };
}, // eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
function(_ref) {
    var iconSize = _ref.iconSize;
    return iconSize ? "svg {\n          width: ".concat(iconSize, "px;\n          height: ").concat(iconSize, "px;\n        }") : '';
});
var $d1af5435ad8463ff$export$31ea92f3997410dd = (0, $0b1eca56b0789a79$export$2e2bcd8739ae039).div({
    font: "var(--ds-font-heading-xsmall, normal 653 14px/20px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    marginTop: "var(--ds-space-100, 8px)"
});
var $d1af5435ad8463ff$export$5c7b7f0e517b89f8 = (0, $0b1eca56b0789a79$export$2e2bcd8739ae039).div({
    boxShadow: "var(--ds-shadow-overlay, ".concat("0 2px 0 ".concat((0, $84873b2431594582$export$920c0d5c49070351)), ")"),
    display: 'flex',
    padding: "var(--ds-space-050, 4px)"
});
var $d1af5435ad8463ff$export$94756becb802e330 = (0, $0b1eca56b0789a79$export$2e2bcd8739ae039).div({
    cursor: 'pointer',
    color: "var(--ds-text-subtlest, ".concat((0, $84873b2431594582$export$8754fc7e6d8b3000), ")"),
    '&:hover, &:focus': {
        color: "var(--ds-text-subtle, ".concat((0, $84873b2431594582$export$5f71e19f3a7ad9de), ")")
    }
});
var $d1af5435ad8463ff$export$6833d6d22987ee7f = (0, $0b1eca56b0789a79$export$2e2bcd8739ae039).div(function(props) {
    return {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        display: props.displayFlag ? 'block' : 'none'
    };
});
var $d1af5435ad8463ff$export$e786733cafde97b9 = (0, $0b1eca56b0789a79$export$2e2bcd8739ae039).div({
    backgroundColor: "var(--ds-background-danger, ".concat((0, $84873b2431594582$export$4b84fd0e2c617bd), ")"),
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    paddingRight: "var(--ds-space-100, 8px)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& > *': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
        backgroundColor: 'inherit !important'
    }
});



var $aRMzY = parcelRequire("aRMzY");
var $e914b2b75c55fd1f$export$2e2bcd8739ae039 = (0, $aRMzY.defineMessages)({
    errorMessage: {
        id: 'paginated-picker.async-select.menu-list.error-message.error-message',
        defaultMessage: "Couldn't retrieve data",
        description: 'The text for when an error occurs when loading options'
    },
    retryMessage: {
        id: 'paginated-picker.async-select.menu-list.error-message.retry-message',
        defaultMessage: 'Click to retry',
        description: 'The text for button to reload options'
    }
});


var $783daec48309fc93$var$ErrorMessage = function ErrorMessage(_ref) {
    var onRetry = _ref.onRetry;
    // const { createAnalyticsEvent } = useAnalyticsEvents();
    var onClick = (0, $5FkrB.useCallback)(function() {
        onRetry === null || onRetry === void 0 || onRetry();
    // fireOperationalAnalytics(
    //   createAnalyticsEvent({}),
    //   'refinementBarSelectRetry clicked',
    // );
    }, [
        onRetry
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $d1af5435ad8463ff$export$d675f139b342d51a), {
        height: 144
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $d1af5435ad8463ff$export$d675f139b342d51a), {
        height: 72,
        iconSize: 72
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($656c973b7454adeb$exports))), {
        spacing: "spacious",
        color: "var(--ds-icon-subtle, ".concat((0, $84873b2431594582$export$c39c0fe0f26207ae), ")"),
        label: ""
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $d1af5435ad8463ff$export$31ea92f3997410dd), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $iBNQo.default), (0, $e914b2b75c55fd1f$export$2e2bcd8739ae039).errorMessage)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $e42f2717f86c66ea$export$2e2bcd8739ae039), {
        onClick: onClick,
        appearance: "link"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $iBNQo.default), (0, $e914b2b75c55fd1f$export$2e2bcd8739ae039).retryMessage)));
};
var $783daec48309fc93$export$2e2bcd8739ae039 = $783daec48309fc93$var$ErrorMessage;



var $5FkrB = parcelRequire("5FkrB");

var $iBNQo = parcelRequire("iBNQo");

var $9ztDu = parcelRequire("9ztDu");


var $aRMzY = parcelRequire("aRMzY");
var $88b4c4bbea6453aa$export$2e2bcd8739ae039 = (0, $aRMzY.defineMessages)({
    loadingMessage: {
        id: 'paginated-picker.async-select.menu-list.loading-message.loading-message',
        defaultMessage: 'Loading...',
        description: 'The text for when options are being loaded in dropdown'
    }
});


var $910d9813d724b35d$export$e928a71d039d3102 = function LoadingMessage() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $d1af5435ad8463ff$export$d675f139b342d51a), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $d1af5435ad8463ff$export$d675f139b342d51a), {
        height: 72
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $9ztDu.default), {
        size: "large"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $d1af5435ad8463ff$export$31ea92f3997410dd), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $iBNQo.default), (0, $88b4c4bbea6453aa$export$2e2bcd8739ae039).loadingMessage)));
};



var $5FkrB = parcelRequire("5FkrB");

var $iBNQo = parcelRequire("iBNQo");


var $aRMzY = parcelRequire("aRMzY");
var $1d7c362dc25ad29d$export$2e2bcd8739ae039 = (0, $aRMzY.defineMessages)({
    showMoreButtonText: {
        id: 'paginated-picker.async-select.menu-list.show-more-button.show-more-button-text',
        defaultMessage: 'Show more',
        description: 'Clicking this button will load more items into the dropdown'
    }
});


var $e1b229358b3775ac$var$ShowMoreButton = function ShowMoreButton(_ref) {
    var onShowMore = _ref.onShowMore;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $e42f2717f86c66ea$export$2e2bcd8739ae039), {
        onClick: onShowMore,
        appearance: "link",
        testId: "paginated-picker.ui.async-select.menu-list.show-more-button"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $iBNQo.default), (0, $1d7c362dc25ad29d$export$2e2bcd8739ae039).showMoreButtonText));
};
var $e1b229358b3775ac$export$2e2bcd8739ae039 = $e1b229358b3775ac$var$ShowMoreButton;


// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $71e5f0b5e13069a4$export$43a792a870d28db2 = (0, $0b1eca56b0789a79$export$2e2bcd8739ae039).div({
    display: 'flex',
    justifyContent: 'center',
    margin: "var(--ds-space-050, 4px)".concat(" 0")
});


var $b01729a03f54ba38$export$d4c4e98c5044dc8 = function MenuList(props) {
    // const { createAnalyticsEvent } = useAnalyticsEvents();
    var _useState = (0, $5FkrB.useState)(1), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), clickCount = _useState2[0], setClickCount = _useState2[1];
    var _props$selectProps$me = props.selectProps.menuListProps, _props$selectProps$me2 = _props$selectProps$me.error, isError = _props$selectProps$me2.isError, onRetry = _props$selectProps$me2.onRetry, handleShowMore = _props$selectProps$me.handleShowMore, isLoading = _props$selectProps$me.isLoading, isPaginationLoading = _props$selectProps$me.isPaginationLoading, showShowMoreButton = _props$selectProps$me.showShowMoreButton;
    var handleOnShowMore = (0, $5FkrB.useCallback)(function() {
        setClickCount(clickCount + 1);
        // sendAnalytics({
        //   actionSubjectId: 'filterSearchShowMore',
        //   createAnalyticsEvent,
        //   type,
        //   clickCount,
        // });
        handleShowMore();
    }, [
        clickCount,
        handleShowMore
    ]);
    if (isLoading && clickCount > 1) setClickCount(1);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $eef74442e0ac473a$export$9b5ac10f59f76296).MenuList, props, isLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $910d9813d724b35d$export$e928a71d039d3102), null) : isError ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $783daec48309fc93$export$2e2bcd8739ae039), {
        onRetry: onRetry
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).Fragment, null, props.children, isPaginationLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $71e5f0b5e13069a4$export$43a792a870d28db2), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $9ztDu.default), null)) : showShowMoreButton && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $e1b229358b3775ac$export$2e2bcd8739ae039), {
        onShowMore: handleOnShowMore
    })));
};
var $b01729a03f54ba38$export$2e2bcd8739ae039 = $b01729a03f54ba38$export$d4c4e98c5044dc8;



var $kqp0i = parcelRequire("kqp0i");

var $5FkrB = parcelRequire("5FkrB");

var $iBNQo = parcelRequire("iBNQo");

var $aRMzY = parcelRequire("aRMzY");
var $0f21ecdeb0881f0b$export$2e2bcd8739ae039 = (0, $aRMzY.defineMessages)({
    ofTotalCount: {
        id: 'paginated-picker.async-select.pagination-details.of-total-count',
        defaultMessage: '{itemsCount} of {totalCount}',
        description: 'Total count of items.'
    }
});


// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $c5a07ce9db20b9b8$export$fff9218028c24180 = (0, $0b1eca56b0789a79$export$2e2bcd8739ae039).div({
    flex: 1,
    textAlign: 'right',
    margin: "var(--ds-space-100, 8px)".concat(" ", "var(--ds-space-200, 16px)"),
    font: "var(--ds-font-body, normal 400 14px/20px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    color: "var(--ds-text-subtlest, #979797)"
});


var $16651c44c2d9e46d$export$33eb0288c0936a84 = function PaginationDetails(_ref) {
    var itemsCount = _ref.itemsCount, totalCount = _ref.totalCount;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $c5a07ce9db20b9b8$export$fff9218028c24180), {
        "data-testid": "paginated-picker.ui.async-select.pagination-details"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $iBNQo.default), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, (0, $0f21ecdeb0881f0b$export$2e2bcd8739ae039).ofTotalCount, {
        values: {
            itemsCount: itemsCount,
            totalCount: totalCount
        }
    })));
};
var $16651c44c2d9e46d$export$2e2bcd8739ae039 = $16651c44c2d9e46d$export$33eb0288c0936a84;



var $kqp0i = parcelRequire("kqp0i");

var $iYJcE = parcelRequire("iYJcE");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");

var $iBNQo = parcelRequire("iBNQo");
var $6Wx3K = parcelRequire("6Wx3K");
/* eslint-disable @repo/internal/react/require-jsdoc */ var $ebd584ed0b5bd36b$export$2e2bcd8739ae039 = function(channel) {
    return function(payload) {
        return function(createAnalyticsEvent) {
            var consumerEvent = createAnalyticsEvent(payload);
            var clonedEvent = consumerEvent.clone();
            if (clonedEvent) clonedEvent.fire(channel);
            return consumerEvent;
        };
    };
};


var $kqp0i = parcelRequire("kqp0i");

var $25nEq = parcelRequire("25nEq");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");

var $5FkrB = parcelRequire("5FkrB");

var $9Zzpd = parcelRequire("9Zzpd");

var $3ZMUU = parcelRequire("3ZMUU");
var $c3b4c642fac19cc5$var$_process$env;
var /// <reference types="node" />
$c3b4c642fac19cc5$export$2e2bcd8739ae039 = typeof $3ZMUU !== 'undefined' && $3ZMUU !== null && (($c3b4c642fac19cc5$var$_process$env = {}, $c3b4c642fac19cc5$var$_process$env === void 0) ? void 0 : $c3b4c642fac19cc5$var$_process$env['ANALYTICS_NEXT_MODERN_CONTEXT']);



var $fC8ib = parcelRequire("fC8ib");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $kIXpt = parcelRequire("kIXpt");

var $cYPzS = parcelRequire("cYPzS");

var $eyuDe = parcelRequire("eyuDe");

var $25nEq = parcelRequire("25nEq");

var $5FkrB = parcelRequire("5FkrB");

var $8vJ0V = parcelRequire("8vJ0V");

var $iyyOp = parcelRequire("iyyOp");
function $ac72d5175d476699$var$_callSuper(t, o, e) {
    return o = (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(o), (0, (/*@__PURE__*/$parcel$interopDefault($kIXpt)))(t, $ac72d5175d476699$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(t).constructor) : o.apply(t, e));
}
function $ac72d5175d476699$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($ac72d5175d476699$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $ac72d5175d476699$var$ContextTypes = {
    getAtlaskitAnalyticsContext: (0, (/*@__PURE__*/$parcel$interopDefault($8vJ0V))).func,
    getAtlaskitAnalyticsEventHandlers: (0, (/*@__PURE__*/$parcel$interopDefault($8vJ0V))).func
};
var $ac72d5175d476699$var$noop = function noop() {
    return [];
};
// eslint-disable-next-line @repo/internal/react/no-class-components
var $ac72d5175d476699$var$AnalyticsContext = /*#__PURE__*/ function(_Component) {
    function AnalyticsContext(props) {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, AnalyticsContext);
        _this = $ac72d5175d476699$var$_callSuper(this, AnalyticsContext, [
            props
        ]);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "getChildContext", function() {
            return {
                getAtlaskitAnalyticsContext: _this.getAnalyticsContext
            };
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "getAnalyticsContext", function() {
            var data = _this.props.data;
            var _this$context$getAtla = _this.context.getAtlaskitAnalyticsContext, getAtlaskitAnalyticsContext = _this$context$getAtla === void 0 ? $ac72d5175d476699$var$noop : _this$context$getAtla;
            return [].concat((0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(getAtlaskitAnalyticsContext()), [
                data
            ]);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "getAnalyticsEventHandlers", function() {
            var _this$context$getAtla2 = _this.context.getAtlaskitAnalyticsEventHandlers, getAtlaskitAnalyticsEventHandlers = _this$context$getAtla2 === void 0 ? $ac72d5175d476699$var$noop : _this$context$getAtla2;
            return getAtlaskitAnalyticsEventHandlers();
        });
        _this.contextValue = {
            getAtlaskitAnalyticsContext: _this.getAnalyticsContext,
            getAtlaskitAnalyticsEventHandlers: _this.getAnalyticsEventHandlers
        };
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($eyuDe)))(AnalyticsContext, _Component);
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(AnalyticsContext, [
        {
            key: "render",
            value: function render() {
                var children = this.props.children;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $iyyOp.default).Provider, {
                    value: this.contextValue
                }, children);
            }
        }
    ]);
}((0, $5FkrB.Component));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($ac72d5175d476699$var$AnalyticsContext, "contextTypes", $ac72d5175d476699$var$ContextTypes);
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($ac72d5175d476699$var$AnalyticsContext, "childContextTypes", $ac72d5175d476699$var$ContextTypes);
var $ac72d5175d476699$export$2e2bcd8739ae039 = $ac72d5175d476699$var$AnalyticsContext;



var $fC8ib = parcelRequire("fC8ib");

var $5FkrB = parcelRequire("5FkrB");

var $iyyOp = parcelRequire("iyyOp");


var $89d2dd33044bd8d7$var$AnalyticsContext = function AnalyticsContext(_ref) {
    var data = _ref.data, children = _ref.children;
    var dataRef = (0, $14e8c2f4d76a321c$export$1d27a74659855e44)(data);
    var _useAnalyticsContext = (0, $e9ae543f50fe0e07$export$d1f587f82ad51c4)(), getAtlaskitAnalyticsEventHandlers = _useAnalyticsContext.getAtlaskitAnalyticsEventHandlers, getOriginalAnalyticsContext = _useAnalyticsContext.getAtlaskitAnalyticsContext;
    var getAtlaskitAnalyticsContext = (0, $5FkrB.useCallback)(function() {
        return [].concat((0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(getOriginalAnalyticsContext()), [
            dataRef.current
        ]);
    }, [
        getOriginalAnalyticsContext,
        dataRef
    ]);
    var value = (0, $5FkrB.useMemo)(function() {
        return {
            getAtlaskitAnalyticsContext: getAtlaskitAnalyticsContext,
            getAtlaskitAnalyticsEventHandlers: getAtlaskitAnalyticsEventHandlers
        };
    }, [
        getAtlaskitAnalyticsContext,
        getAtlaskitAnalyticsEventHandlers
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $iyyOp.default).Provider, {
        value: value
    }, children);
};
var $89d2dd33044bd8d7$export$2e2bcd8739ae039 = $89d2dd33044bd8d7$var$AnalyticsContext;


var $b4aed74578fd4524$var$AnalyticsContext = function AnalyticsContext(props) {
    var isModernContext = (0, $c3b4c642fac19cc5$export$2e2bcd8739ae039) || (0, $9Zzpd.fg)('analytics-next-use-legacy-context') === false;
    return isModernContext ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $89d2dd33044bd8d7$export$2e2bcd8739ae039), props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $ac72d5175d476699$export$2e2bcd8739ae039), props);
};
var $b4aed74578fd4524$export$2e2bcd8739ae039 = $b4aed74578fd4524$var$AnalyticsContext;


var $9df5a4d0a7ff3a08$var$_excluded = [
    "analyticsContext"
];
function $9df5a4d0a7ff3a08$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $9df5a4d0a7ff3a08$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $9df5a4d0a7ff3a08$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $9df5a4d0a7ff3a08$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $9df5a4d0a7ff3a08$var$withAnalyticsContext = function withAnalyticsContext(defaultData) {
    return function(WrappedComponent) {
        var WithAnalyticsContext = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function(_ref, ref) {
            var analyticsContext = _ref.analyticsContext, rest = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $9df5a4d0a7ff3a08$var$_excluded);
            var analyticsData = (0, $5FkrB.useMemo)(function() {
                return $9df5a4d0a7ff3a08$var$_objectSpread($9df5a4d0a7ff3a08$var$_objectSpread({}, defaultData), analyticsContext);
            }, [
                analyticsContext
            ]);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $b4aed74578fd4524$export$2e2bcd8739ae039), {
                data: analyticsData
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(WrappedComponent, (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, rest, {
                ref: ref
            })));
        });
        WithAnalyticsContext.displayName = "WithAnalyticsContext(".concat(WrappedComponent.displayName || WrappedComponent.name, ")");
        return WithAnalyticsContext;
    };
};
var $9df5a4d0a7ff3a08$export$2e2bcd8739ae039 = $9df5a4d0a7ff3a08$var$withAnalyticsContext;


var $kqp0i = parcelRequire("kqp0i");

var $5FkrB = parcelRequire("5FkrB");


var $25nEq = parcelRequire("25nEq");

var $ekGgq = parcelRequire("ekGgq");

var $5FkrB = parcelRequire("5FkrB");

function $099a30c8ad497226$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $099a30c8ad497226$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $099a30c8ad497226$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $099a30c8ad497226$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $099a30c8ad497226$export$9ebb5a84d17e5d18() {
    var createEventMap = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var wrappedComponentProps = arguments.length > 1 ? arguments[1] : undefined;
    var _useAnalyticsEvents = (0, $46fdcdf47a9cc549$export$5bf35293e545f20c)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
    var handlerCache = (0, $5FkrB.useRef)({});
    var patchedProps = (0, $5FkrB.useMemo)(function() {
        var cache = handlerCache.current;
        // Clean up no longer used handlers in cache
        Object.keys(cache).filter(function(key) {
            return !(key in createEventMap);
        }).forEach(function(key) {
            return delete cache[key];
        });
        return Object.keys(createEventMap).reduce(function(p, k) {
            var eventCreator = createEventMap[k];
            if (![
                'object',
                'function'
            ].includes((0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(eventCreator))) return p;
            var propValue = wrappedComponentProps[k];
            if (k in cache && cache[k].eventCreator === eventCreator && cache[k].propValue === propValue) return $099a30c8ad497226$var$_objectSpread($099a30c8ad497226$var$_objectSpread({}, p), {}, (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, k, cache[k].wrappedCallback));
            var wrappedCallback = function wrappedCallback() {
                var analyticsEvent = typeof eventCreator === 'function' ? eventCreator(createAnalyticsEvent, wrappedComponentProps) : createAnalyticsEvent(eventCreator);
                if (propValue && typeof propValue === 'function') {
                    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                    propValue.apply(void 0, args.concat([
                        analyticsEvent
                    ]));
                }
            };
            cache[k] = {
                eventCreator: eventCreator,
                wrappedCallback: wrappedCallback,
                propValue: propValue
            };
            return $099a30c8ad497226$var$_objectSpread($099a30c8ad497226$var$_objectSpread({}, p), {}, (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, k, wrappedCallback));
        }, {});
    }, [
        createEventMap,
        wrappedComponentProps,
        createAnalyticsEvent,
        handlerCache
    ]);
    return {
        patchedEventProps: patchedProps
    };
}


var $919b7891de8eb393$var$withAnalyticsEvents = function withAnalyticsEvents() {
    var createEventMap = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return function(WrappedComponent) {
        var WithAnalyticsEvents = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function(props, ref) {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore: to unblock React 18.2.0 -> 18.3.1 version bump in Jira
            var _usePatchedProps = (0, $099a30c8ad497226$export$9ebb5a84d17e5d18)(createEventMap, props), patchedEventProps = _usePatchedProps.patchedEventProps;
            var _useAnalyticsEvents = (0, $46fdcdf47a9cc549$export$5bf35293e545f20c)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(WrappedComponent, (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, props, patchedEventProps, {
                createAnalyticsEvent: createAnalyticsEvent,
                ref: ref
            }));
        });
        WithAnalyticsEvents.displayName = "WithAnalyticsEvents(".concat(WrappedComponent.displayName || WrappedComponent.name, ")");
        return WithAnalyticsEvents;
    };
};
var $919b7891de8eb393$export$2e2bcd8739ae039 = $919b7891de8eb393$var$withAnalyticsEvents;




var $kqp0i = parcelRequire("kqp0i");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");
var $3270bd9241f905cc$var$_excluded = [
    "ariaLiveMessages",
    "isInvalid",
    "onClickPreventDefault",
    "tabSelectsValue",
    "validationState"
];
function $3270bd9241f905cc$export$2e2bcd8739ae039(WrappedComponent) {
    var AtlaskitSelect = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function AtlaskitSelect(props, forwardedRef) {
        var ariaLiveMessages = props.ariaLiveMessages, isInvalid = props.isInvalid, _props$onClickPrevent = props.onClickPreventDefault, onClickPreventDefault = _props$onClickPrevent === void 0 ? true : _props$onClickPrevent, _props$tabSelectsValu = props.tabSelectsValue, tabSelectsValue = _props$tabSelectsValu === void 0 ? false : _props$tabSelectsValu, _props$validationStat = props.validationState, validationState = _props$validationStat === void 0 ? 'default' : _props$validationStat, restProps = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(props, $3270bd9241f905cc$var$_excluded);
        var internalSelectRef = (0, $5FkrB.useRef)(null);
        /**
     * The following `useImperativeHandle` hook exists for the sake of backwards compatibility.
     * This component used to be a class component which set the value of the `ref` prop to object with the properties and value as below.
     * This has lead to slightly odd usage of refs with this component, e.g. `myRef.current.select.select.controlRef` instead of just `myRef.current.select.controlRef`
     * In the next major release, this should removed and the ref should be passed directly to the wrapped component (given users have updated usage)
     * More info https://stash.atlassian.com/projects/ATLASSIAN/repos/atlassian-frontend-monorepo/pull-requests/88021/overview
     */ (0, $5FkrB.useImperativeHandle)(forwardedRef, function() {
            return {
                select: internalSelectRef.current,
                focus: function focus() {
                    var _internalSelectRef$cu;
                    return (_internalSelectRef$cu = internalSelectRef.current) === null || _internalSelectRef$cu === void 0 ? void 0 : _internalSelectRef$cu.focus();
                },
                blur: function blur() {
                    var _internalSelectRef$cu2;
                    return (_internalSelectRef$cu2 = internalSelectRef.current) === null || _internalSelectRef$cu2 === void 0 ? void 0 : _internalSelectRef$cu2.blur();
                }
            };
        }, []);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(WrappedComponent, (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
            ref: internalSelectRef,
            ariaLiveMessages: ariaLiveMessages,
            tabSelectsValue: tabSelectsValue,
            onClickPreventDefault: onClickPreventDefault,
            isInvalid: isInvalid || validationState === 'error'
        }, restProps, {
            // indicates react-select to be async by default using the base Select component
            // so that makers can pass all async props on the base select to async load options.
            isAsync: true
        }));
    });
    AtlaskitSelect.displayName = 'AtlaskitSelect';
    return AtlaskitSelect;
}


var $5657ad900fe2702d$var$packageName = "@atlaskit/select";
var $5657ad900fe2702d$var$packageVersion = "0.0.0-development";
var $5657ad900fe2702d$export$d1de3b251ccaa8a3 = (0, $3270bd9241f905cc$export$2e2bcd8739ae039)((0, $dc5cf7a1de30265f$export$2e2bcd8739ae039));
var $5657ad900fe2702d$var$createAndFireEventOnAtlaskit = (0, $ebd584ed0b5bd36b$export$2e2bcd8739ae039)('atlaskit');
var $5657ad900fe2702d$var$Select = (0, $9df5a4d0a7ff3a08$export$2e2bcd8739ae039)({
    componentName: 'select',
    packageName: $5657ad900fe2702d$var$packageName,
    packageVersion: $5657ad900fe2702d$var$packageVersion
})((0, $919b7891de8eb393$export$2e2bcd8739ae039)({
    onChange: $5657ad900fe2702d$var$createAndFireEventOnAtlaskit({
        action: 'changed',
        actionSubject: 'option',
        attributes: {
            componentName: 'select',
            packageName: $5657ad900fe2702d$var$packageName,
            packageVersion: $5657ad900fe2702d$var$packageVersion
        }
    })
})($5657ad900fe2702d$export$d1de3b251ccaa8a3));
var $5657ad900fe2702d$export$2e2bcd8739ae039 = $5657ad900fe2702d$var$Select;


var $2c2c8763cec88c4d$export$50531cf3046c5956 = {
    setValue: 'set-value',
    inputChange: 'input-change',
    inputBlur: 'input-blur',
    menuClose: 'menu-close',
    selectOption: 'select-option',
    deselectOption: 'deselect-option',
    removeValue: 'remove-value',
    popValue: 'pop-value',
    clear: 'clear',
    createOption: 'create-option',
    clearOptions: 'clear-options',
    add: 'add',
    remove: 'remove',
    update: 'update'
};



var $kqp0i = parcelRequire("kqp0i");

var $5FkrB = parcelRequire("5FkrB");

var $af441003ba3d255b$export$7a7fa4424cb20976 = function Control(_ref) {
    var children = _ref.children, innerProps = _ref.innerProps, innerRef = _ref.innerRef;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $d1af5435ad8463ff$export$5c7b7f0e517b89f8), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, innerProps, {
        ref: innerRef
    }), children);
};



var $5FkrB = parcelRequire("5FkrB");

var $6468dab4f8c28426$exports = {};
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::0ed30ba2fe598b1c691c4159780db191>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty($6468dab4f8c28426$exports, "__esModule", {
    value: true
});
$6468dab4f8c28426$exports.default = void 0;

var $6468dab4f8c28426$var$_react = $6468dab4f8c28426$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $6468dab4f8c28426$var$_baseNew = $6468dab4f8c28426$var$_interopRequireDefault((parcelRequire("eRJCC")));
function $6468dab4f8c28426$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Search".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for searching objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $6468dab4f8c28426$var$SearchIcon = (props)=>/*#__PURE__*/ $6468dab4f8c28426$var$_react.default.createElement($6468dab4f8c28426$var$_baseNew.default, Object.assign({
        name: "SearchIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M7 2.5a4.5 4.5 0 1 0 0 9 4.5 4.5 0 0 0 0-9M1 7a6 6 0 1 1 10.74 3.68l3.29 3.29-1.06 1.06-3.29-3.29A6 6 0 0 1 1 7" clip-rule="evenodd"/>`
    }, props));
$6468dab4f8c28426$var$SearchIcon.displayName = 'SearchIcon';
var $6468dab4f8c28426$var$_default = $6468dab4f8c28426$exports.default = $6468dab4f8c28426$var$SearchIcon;




var $e5cc808bf44932c8$export$ec98719d3db7f2e4 = function DropdownIndicator(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $eef74442e0ac473a$export$9b5ac10f59f76296).DropdownIndicator, props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $d1af5435ad8463ff$export$30c615a45297e297), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $d1af5435ad8463ff$export$6833d6d22987ee7f), {
        displayFlag: !!props.selectProps.inputValue
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $d1af5435ad8463ff$export$94756becb802e330), {
        onClick: function onClick(event) {
            var _props$selectProps$on, _props$selectProps;
            event.preventDefault();
            (_props$selectProps$on = (_props$selectProps = props.selectProps).onInputChange) === null || _props$selectProps$on === void 0 || _props$selectProps$on.call(_props$selectProps, '', {
                action: 'input-change',
                prevInputValue: props.selectProps.inputValue
            });
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($b8fbe79318730926$exports))), {
        color: "currentColor",
        label: "",
        size: "small"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $d1af5435ad8463ff$export$6833d6d22987ee7f), {
        displayFlag: !props.selectProps.inputValue
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6468dab4f8c28426$exports))), {
        color: "currentColor",
        label: ""
    }))));
};



var $kqp0i = parcelRequire("kqp0i");

var $5FkrB = parcelRequire("5FkrB");
var $f31a052dc39d13b3$export$d9b273488cd8ce6f = function Menu(_ref) {
    var innerRef = _ref.innerRef, innerProps = _ref.innerProps, children = _ref.children;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        "data-testid": "refinement-bar.common.ui.select.menu",
        ref: innerRef
    }, innerProps), children);
};



var $aRMzY = parcelRequire("aRMzY");
var $af63372860334df1$export$2e2bcd8739ae039 = (0, $aRMzY.defineMessages)({
    noOptionsMessage: {
        id: 'paginated-picker.async-select.select.no-options-message.no-options-message',
        defaultMessage: 'No matches found',
        description: 'The text for when no matches are found in dropdown'
    },
    searchPlaceholder: {
        id: 'paginated-picker.async-select.select.search-placeholder',
        defaultMessage: 'Search',
        description: 'Placeholder text in search input indicating that the user can search'
    }
});



var $5FkrB = parcelRequire("5FkrB");

/* input-options.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $kqp0i = parcelRequire("kqp0i");

var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");
var $aad61cb0e4d82ad4$var$optionStyles = {
    default: "_1e0c1txw _4cvr1h6o _1bsb1osq _uiztglyw _18ql1j7p _vchhusvi _85i51b66 _1q511b66 _bozgpxbi _y4tiutpp _bfhk1j28 _16qs1kw7 _syaz1kw7 _1di6fcek",
    focused: "_bfhk1dpa _16qsgkog _112e5u6v",
    disabled: "_syaz15gi"
};
// state of the parent option
// the primary color represents the outer or background element
var $aad61cb0e4d82ad4$var$getPrimaryColor = function getPrimaryColor(_ref) {
    var isActive = _ref.isActive, isDisabled = _ref.isDisabled, isFocused = _ref.isFocused, isSelected = _ref.isSelected;
    if (isDisabled) return "var(--ds-background-disabled, #17171708)";
    else if (isSelected && isActive) return "var(--ds-background-selected-bold-pressed, #123263)";
    else if (isActive) return "var(--ds-background-selected-pressed, #8FB8F6)";
    else if (isFocused && isSelected) return "var(--ds-background-selected-bold-hovered, #1558BC)";
    else if (isFocused) return "var(--ds-surface, #FFFFFF)";
    else if (isSelected) return "var(--ds-background-selected-bold, #1868DB)";
    return "var(--ds-background-neutral, #0515240F)";
};
// the secondary color represents the radio dot or checkmark
var $aad61cb0e4d82ad4$var$getSecondaryColor = function getSecondaryColor(_ref2) {
    var isDisabled = _ref2.isDisabled, isSelected = _ref2.isSelected;
    if (isDisabled && isSelected) return "var(--ds-text-disabled, #080F214A)";
    else if (!isSelected) return 'transparent';
    return "var(--ds-surface, #FFFFFF)";
};
var $aad61cb0e4d82ad4$var$iconStyles = {
    inherit: "_1u9j1r31 _1gqp1r31",
    default: "_1u9jrsbi _1gqprsbi"
};
var $aad61cb0e4d82ad4$var$baseIconStyles = null;
var $aad61cb0e4d82ad4$var$baseOptionStyles = null;
var $aad61cb0e4d82ad4$var$ControlOption = function ControlOption(props) {
    var _useState = (0, $5FkrB.useState)(false), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), isActive = _useState2[0], setIsActive = _useState2[1];
    var onMouseDown = (0, $5FkrB.useCallback)(function() {
        return setIsActive(true);
    }, []);
    var onMouseUp = (0, $5FkrB.useCallback)(function() {
        return setIsActive(false);
    }, []);
    var Icon = props.Icon, children = props.children, innerProps = props.innerProps, innerRef = props.innerRef, cx = props.cx, className = props.className, isDisabled = props.isDisabled, isSelected = props.isSelected, isFocused = props.isFocused;
    var classNames = (0, $5FkrB.useMemo)(function() {
        return cx({
            option: true,
            'option--is-disabled': isDisabled,
            'option--is-focused': isFocused,
            'option--is-selected': isSelected
        }, className);
    }, [
        cx,
        isDisabled,
        isFocused,
        isSelected,
        className
    ]);
    return /*#__PURE__*/ $5FkrB.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $970q7.default)([
            $aad61cb0e4d82ad4$var$optionStyles.default,
            isFocused && $aad61cb0e4d82ad4$var$optionStyles.focused,
            isDisabled && $aad61cb0e4d82ad4$var$optionStyles.disabled,
            classNames
        ]),
        ref: innerRef,
        onMouseDown: onMouseDown,
        onMouseUp: onMouseUp,
        onMouseLeave: onMouseUp
    }, innerProps), /*#__PURE__*/ $5FkrB.createElement("div", {
        className: (0, $970q7.default)([
            "_1e0c1txw _4cvr1h6o _1o9zidpf _y4ti1b66 _16cu892t _1xci892t _59qxe4h9 _8y3xe4h9",
            isSelected || isActive || isDisabled ? $aad61cb0e4d82ad4$var$iconStyles.inherit : $aad61cb0e4d82ad4$var$iconStyles.default
        ])
    }, !!Icon ? /*#__PURE__*/ $5FkrB.createElement(Icon, {
        label: "",
        primaryColor: $aad61cb0e4d82ad4$var$getPrimaryColor({
            isDisabled: isDisabled,
            isSelected: isSelected,
            isFocused: isFocused,
            isActive: isActive
        }),
        secondaryColor: $aad61cb0e4d82ad4$var$getSecondaryColor({
            isDisabled: isDisabled,
            isSelected: isSelected
        }),
        isFacadeDisabled: true
    }) : null), /*#__PURE__*/ $5FkrB.createElement("div", {
        className: (0, $970q7.default)([
            "_16jlkb7n _1reo15vq _1bto1l2s _o5721q9c"
        ])
    }, children));
};
var $aad61cb0e4d82ad4$var$svgStyles = null;
var $aad61cb0e4d82ad4$var$CheckboxIcon = function CheckboxIcon(props) {
    var primaryColor = props.primaryColor, secondaryColor = props.secondaryColor, label = props.label;
    return /*#__PURE__*/ $5FkrB.createElement("svg", {
        viewBox: "0 0 24 24",
        style: {
            color: primaryColor,
            fill: secondaryColor
        },
        "aria-label": label ? label : undefined,
        role: label ? 'img' : 'presentation',
        className: (0, $970q7.default)([
            "_1reo15vq _18m915vq _1bsb1tcg _4t3i1tcg _lswuvuon _lcxvglyw"
        ])
    }, /*#__PURE__*/ $5FkrB.createElement("g", {
        fillRule: "evenodd"
    }, /*#__PURE__*/ $5FkrB.createElement("rect", {
        x: "5.5",
        y: "5.5",
        width: "13",
        height: "13",
        rx: "1.5",
        fill: "currentColor"
    }), /*#__PURE__*/ $5FkrB.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M16.3262 9.48011L15.1738 8.51984L10.75 13.8284L8.82616 11.5198L7.67383 12.4801L10.1738 15.4801C10.3163 15.6511 10.5274 15.75 10.75 15.75C10.9726 15.75 11.1837 15.6511 11.3262 15.4801L16.3262 9.48011Z",
        fill: "inherit"
    })));
};
var $aad61cb0e4d82ad4$var$RadioIcon = function RadioIcon(props) {
    var primaryColor = props.primaryColor, secondaryColor = props.secondaryColor, label = props.label;
    return /*#__PURE__*/ $5FkrB.createElement("svg", {
        viewBox: "0 0 24 24",
        style: {
            color: primaryColor,
            fill: secondaryColor
        },
        "aria-label": label ? label : undefined,
        role: label ? 'img' : 'presentation',
        className: (0, $970q7.default)([
            "_1reo15vq _18m915vq _1bsb1tcg _4t3i1tcg _lswuvuon _lcxvglyw"
        ])
    }, /*#__PURE__*/ $5FkrB.createElement("g", {
        fillRule: "evenodd"
    }, /*#__PURE__*/ $5FkrB.createElement("circle", {
        cx: "12",
        cy: "12",
        r: "6.75",
        fill: "currentColor",
        strokeWidth: "1.5"
    }), /*#__PURE__*/ $5FkrB.createElement("circle", {
        cx: "12",
        cy: "12",
        r: "3",
        fill: "inherit"
    })));
};
var $aad61cb0e4d82ad4$export$d40cc97ecda916f9 = function CheckboxOption(props) {
    return /*#__PURE__*/ $5FkrB.createElement($aad61cb0e4d82ad4$var$ControlOption, (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        Icon: $aad61cb0e4d82ad4$var$CheckboxIcon
    }, props));
};
var $aad61cb0e4d82ad4$export$82ab7168879267a7 = function RadioOption(props) {
    return(/*#__PURE__*/ // TODO https://product-fabric.atlassian.net/browse/DSP-20769
    $5FkrB.createElement($aad61cb0e4d82ad4$var$ControlOption, (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        Icon: $aad61cb0e4d82ad4$var$RadioIcon
    }, props)));
};




var $kqp0i = parcelRequire("kqp0i");

var $iYJcE = parcelRequire("iYJcE");

var $25nEq = parcelRequire("25nEq");

var $5FkrB = parcelRequire("5FkrB");

var $7QpUe = parcelRequire("7QpUe");

var $25nEq = parcelRequire("25nEq");

var $5FkrB = parcelRequire("5FkrB");


function $5f91d7c230669509$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $5f91d7c230669509$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $5f91d7c230669509$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $5f91d7c230669509$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $5f91d7c230669509$export$1a04351537078b55(_ref) {
    var fn = _ref.fn, action = _ref.action, componentName = _ref.componentName, packageName = _ref.packageName, packageVersion = _ref.packageVersion, analyticsData = _ref.analyticsData;
    var _useAnalyticsEvents = (0, $46fdcdf47a9cc549$export$5bf35293e545f20c)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
    // We put analyticsData and fn in a ref so that we don't need to break
    // memoization.
    // Generally these could be defined by consumers inline
    // and so we do this to avoid breaking memoization of useCallback
    var dataRef = (0, $14e8c2f4d76a321c$export$1d27a74659855e44)(analyticsData);
    var fnRef = (0, $14e8c2f4d76a321c$export$1d27a74659855e44)(fn);
    var handler = (0, $5FkrB.useCallback)(function() {
        var analyticsEvent = createAnalyticsEvent({
            action: action,
            actionSubject: componentName,
            attributes: {
                componentName: componentName,
                packageName: packageName,
                packageVersion: packageVersion
            }
        });
        // To avoid wrapping this component in AnalyticsContext we manually
        // push the parent context's meta data into the context.
        // Note: this new 'context'
        var context = $5f91d7c230669509$var$_objectSpread({
            componentName: componentName,
            packageName: packageName,
            packageVersion: packageVersion
        }, dataRef.current);
        analyticsEvent.context.push(context);
        // fire an event on the atlaskit channel
        var clone = analyticsEvent.clone();
        if (clone) clone.fire('atlaskit');
        fnRef.current(analyticsEvent);
    }, [
        // These are strings and won't change
        action,
        componentName,
        packageName,
        packageVersion,
        // This function is memoized in the context
        createAnalyticsEvent,
        // these are a stable ref because of the useTrackedRef hook
        dataRef,
        fnRef
    ]);
    return handler;
}



var $eVb4V = parcelRequire("eVb4V");

var $hy47X = parcelRequire("hy47X");

var $3UUXy = parcelRequire("3UUXy");

var $iUCre = parcelRequire("iUCre");

var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");
/**
 * Internally we will be playing with an element that will always have a key defined.
 */ /**
 * Internal data passed to child motions.
 */ // We define empty context here so the object doesn't change.
var $04841b3f070c4001$var$emptyContext = {
    // Motions will always appear if not inside a exiting persistence component.
    appear: true,
    isExiting: false
};
/**
 * __Exiting context__
 *
 * An exiting context.
 */ var $04841b3f070c4001$var$ExitingContext = /*#__PURE__*/ (0, $5FkrB.createContext)($04841b3f070c4001$var$emptyContext);
/**
 * This method will wrap any React element with a context provider. We're using context (instead of
 * cloneElement) so we can communicate between multiple elements without the need of prop drilling
 * (results in a better API for consumers).
 */ var $04841b3f070c4001$var$wrapChildWithContextProvider = function wrapChildWithContextProvider(child) {
    var value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $04841b3f070c4001$var$emptyContext;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement($04841b3f070c4001$var$ExitingContext.Provider, {
        key: "".concat(child.key, "-provider"),
        value: value
    }, child);
};
/**
 * This function will convert all children types to an array while also filtering out non-valid React elements.
 */ var $04841b3f070c4001$var$childrenToArray = function childrenToArray(children) {
    var childrenAsArray = [];
    // We convert children to an array using this helper method as it will add keys to children that do not
    // have them, such as when we have hardcoded children that are conditionally rendered.
    (0, $5FkrB.Children).toArray(children).forEach(function(child) {
        // We ignore any boolean children to make our code a little more simple later on,
        // and also filter out any falsies (empty strings, nulls, and undefined).
        if (typeof child !== 'boolean' && Boolean(child)) // Children WILL have a key after being forced into an array using the React.Children helper.
        childrenAsArray.push(child);
    });
    return childrenAsArray;
};
var $04841b3f070c4001$var$spliceNewElementsIntoPrevious = function spliceNewElementsIntoPrevious(current, previous) {
    var splicedChildren = previous.concat([]);
    var previousMap = $04841b3f070c4001$var$childrenToObj(previous);
    for(var i = 0; i < current.length; i++){
        var child = current[i];
        var childIsNew = !previousMap[child.key];
        if (childIsNew) // This will insert the new element after the previous element.
        splicedChildren.splice(i + 1, 0, child);
    }
    return splicedChildren;
};
var $04841b3f070c4001$var$childrenToObj = function childrenToObj(children) {
    return children.reduce(function(acc, child) {
        acc[child.key] = child;
        return acc;
    }, {});
};
var $04841b3f070c4001$var$getMissingKeys = function getMissingKeys(current, previous) {
    var currentMapKeys = new Set(current.map(function(child) {
        return child.key;
    }));
    var missing = new Set();
    for(var i = 0; i < previous.length; i++){
        var element = previous[i];
        var _key = element.key;
        if (!currentMapKeys.has(_key)) missing.add(_key);
    }
    return missing;
};
/**
 * How does this component work?
 *
 * It looks at changes in its children to see what is removed.
 *
 * If a child is removed it clones it and wraps it with context providing an `onFinish` callback.
 *
 * The cloned child will call the `onFinish` when it finishes its exit animation,
 * which lets `ExitingPersistence` know to stop rendering it.
 */ /**
 * __ExitingPersistence__
 *
 * Useful for enabling elements to persist and animate away when they are removed from the DOM.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/motion/docs/entering-motions)
 */ var $04841b3f070c4001$var$ExitingPersistence = /*#__PURE__*/ (0, $5FkrB.memo)(function(_ref) {
    var _ref$appear = _ref.appear, appear = _ref$appear === void 0 ? false : _ref$appear, children = _ref.children, exitThenEnter = _ref.exitThenEnter;
    var _useState = (0, $5FkrB.useState)([
        null,
        children
    ]), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), stateChildren = _useState2[0], setChildren = _useState2[1];
    var _useState3 = (0, $5FkrB.useState)([]), _useState4 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState3, 2), exitingChildren = _useState4[0], setExitingChildren = _useState4[1];
    var _useState5 = (0, $5FkrB.useState)(function() {
        return {
            appear: appear,
            isExiting: false
        };
    }), _useState6 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState5, 2), defaultContext = _useState6[0], setDefaultContext = _useState6[1];
    (0, $5FkrB.useEffect)(function() {
        if (!defaultContext.appear) setDefaultContext({
            appear: true,
            isExiting: false
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    /**
   * NOTE: This is a workaround for the test case written in Jira where the stateChildren is a boolean value because
   * useState is mocked to return a boolean value.
   */ if (typeof stateChildren === 'boolean') return children;
    var _stateChildren = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(stateChildren, 2), previousChildren = _stateChildren[0], currentChildren = _stateChildren[1];
    var previous = $04841b3f070c4001$var$childrenToArray(previousChildren);
    var current = $04841b3f070c4001$var$childrenToArray(currentChildren);
    if (currentChildren !== children) setChildren([
        currentChildren,
        children
    ]);
    var missingKeys = $04841b3f070c4001$var$getMissingKeys(current, previous);
    var isSomeChildRemoved = !!missingKeys.size;
    var visibleChildren = current;
    if (isSomeChildRemoved) visibleChildren = $04841b3f070c4001$var$spliceNewElementsIntoPrevious(current, previous);
    if (exitThenEnter) {
        if (exitingChildren.length) visibleChildren = exitingChildren;
        else {
            var nextExitingChildren = visibleChildren.filter(function(child) {
                return missingKeys.has(child.key);
            });
            if (nextExitingChildren.length) setExitingChildren(nextExitingChildren);
        }
    }
    if (missingKeys.size) visibleChildren = visibleChildren.map(function(child) {
        var isExiting = missingKeys.has(child.key);
        return $04841b3f070c4001$var$wrapChildWithContextProvider(child, {
            appear: true,
            isExiting: isExiting,
            onFinish: isExiting ? function() {
                missingKeys.delete(child.key);
                if (missingKeys.size === 0) {
                    setChildren([
                        null,
                        children
                    ]);
                    setExitingChildren([]);
                }
            } : undefined
        });
    });
    else visibleChildren = visibleChildren.map(function(child) {
        return $04841b3f070c4001$var$wrapChildWithContextProvider(child, defaultContext);
    });
    return visibleChildren;
});
var $04841b3f070c4001$export$3b6f38abbdcbd000 = function useExitingPersistence() {
    return (0, $5FkrB.useContext)($04841b3f070c4001$var$ExitingContext);
};
$04841b3f070c4001$var$ExitingPersistence.displayName = 'ExitingPersistence';
var $04841b3f070c4001$export$2e2bcd8739ae039 = $04841b3f070c4001$var$ExitingPersistence;


var $5FkrB = parcelRequire("5FkrB");
/* keyframes-motion.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");

var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");

var $7QpUe = parcelRequire("7QpUe");
var $43632c3c54f6ff13$var$isMatchMediaAvailable = function isMatchMediaAvailable() {
    return typeof window !== 'undefined' && 'matchMedia' in window;
};
var $43632c3c54f6ff13$export$b7baf7667a68d87c = function isReducedMotion() {
    if (!$43632c3c54f6ff13$var$isMatchMediaAvailable()) return false;
    var _window$matchMedia = window.matchMedia('(prefers-reduced-motion: reduce)'), matches = _window$matchMedia.matches;
    return matches;
};
var $43632c3c54f6ff13$export$c537e63161742ce3 = function useIsReducedMotion() {
    var _useState = (0, $5FkrB.useState)($43632c3c54f6ff13$export$b7baf7667a68d87c), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), prefersReducedMotion = _useState2[0], setPrefersReducedMotion = _useState2[1];
    (0, $5FkrB.useEffect)(function() {
        if (!$43632c3c54f6ff13$var$isMatchMediaAvailable()) return;
        var mediaQueryList = window.matchMedia('(prefers-reduced-motion: reduce)');
        var onChange = function onChange(event) {
            return setPrefersReducedMotion(event.matches);
        };
        return (0, $7QpUe.bind)(mediaQueryList, {
            type: 'change',
            listener: onChange
        });
    }, []);
    return prefersReducedMotion;
};
var $43632c3c54f6ff13$export$f0f789643ba5a83c = {
    '@media (prefers-reduced-motion: reduce)': {
        animation: 'none',
        transition: 'none'
    }
};
var $43632c3c54f6ff13$export$ff7706047246b98b = function prefersReducedMotion() {
    return $43632c3c54f6ff13$export$f0f789643ba5a83c;
};


/**
 * Think of this as the motion equivalent of the @atlaskit/theme `grid()`.
 */ var $20efdc8e6f2bb874$export$368bacef0dacbe05 = 25;
var $20efdc8e6f2bb874$export$38b928a7167ce124 = {
    none: 0,
    small: 100,
    medium: 350,
    large: 700
};
/**
 * Used to multiply the initial duration for exiting motions.
 */ var $20efdc8e6f2bb874$var$EXITING_MOTION_MULTIPLIER = 0.5;
var $20efdc8e6f2bb874$export$30fa1a2e62ae150c = {
    none: $20efdc8e6f2bb874$export$38b928a7167ce124.none,
    small: $20efdc8e6f2bb874$export$38b928a7167ce124.small * $20efdc8e6f2bb874$var$EXITING_MOTION_MULTIPLIER,
    medium: $20efdc8e6f2bb874$export$38b928a7167ce124.medium * $20efdc8e6f2bb874$var$EXITING_MOTION_MULTIPLIER,
    large: $20efdc8e6f2bb874$export$38b928a7167ce124.large * $20efdc8e6f2bb874$var$EXITING_MOTION_MULTIPLIER
};



var $5FkrB = parcelRequire("5FkrB");
// Handle both browser and Node.js environments
var $f7c7295e9947ded9$var$getHookDeps = function getHookDeps(opts) {
    switch(opts.cleanup){
        case 'next-effect':
            return undefined;
        case 'unmount':
        default:
            return [];
    }
};
var $f7c7295e9947ded9$export$1775f27e7c8051ca = function useRequestAnimationFrame() {
    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        cleanup: 'unmount'
    };
    var frames = (0, $5FkrB.useRef)([]);
    (0, $5FkrB.useEffect)(function() {
        return function() {
            if (frames.current.length) {
                frames.current.forEach(function(id) {
                    return cancelAnimationFrame(id);
                });
                frames.current = [];
            }
        };
    // We dynamically set this so we either clean up on the next effect - or on unmount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, $f7c7295e9947ded9$var$getHookDeps(opts));
    return (0, $5FkrB.useCallback)(function(handler) {
        var id = requestAnimationFrame(function(time) {
            frames.current = frames.current.filter(function(frameId) {
                return frameId !== id;
            });
            handler(time);
        });
        frames.current.push(id);
    }, []);
};
var $f7c7295e9947ded9$export$4f34107a2b00f39c = function useSetTimeout() {
    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        cleanup: 'unmount'
    };
    var timeouts = (0, $5FkrB.useRef)([]);
    (0, $5FkrB.useEffect)(function() {
        return function() {
            if (timeouts.current.length) {
                timeouts.current.forEach(function(id) {
                    return clearTimeout(id);
                });
                timeouts.current = [];
            }
        };
    // We dynamically set this so we either clean up on the next effect - or on unmount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, $f7c7295e9947ded9$var$getHookDeps(opts));
    return (0, $5FkrB.useCallback)(function(handler, timeout) {
        for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)args[_key - 2] = arguments[_key];
        var id = setTimeout.apply(void 0, [
            function() {
                timeouts.current = timeouts.current.filter(function(timeoutId) {
                    return timeoutId !== id;
                });
                handler();
            },
            timeout
        ].concat(args));
        timeouts.current.push(id);
    }, []);
};




var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");

var $eVb4V = parcelRequire("eVb4V");

var $5FkrB = parcelRequire("5FkrB");
var $77a2352ea7b1de65$export$e5c5a5f917a5871c = typeof window === 'undefined' ? (0, $5FkrB.useEffect) : (0, $5FkrB.useLayoutEffect);


/* eslint-disable @repo/internal/react/disallow-unstable-values */ 
var $5FkrB = parcelRequire("5FkrB");
function $d39b7fe7b41a3372$export$c485849f2e393253() {
    var identifier = (0, $5FkrB.useRef)('');
    if (!identifier.current) identifier.current = '_' + (Number(String(Math.random()).slice(2)) + Date.now() + Math.round(performance.now())).toString(36);
    return identifier.current;
}


var $6665b89da3e139fe$var$StaggeredEntranceContext = /*#__PURE__*/ (0, $5FkrB.createContext)(function() {
    return {
        isReady: true,
        delay: 0,
        ref: (0, $eVb4V.default)
    };
});
var $6665b89da3e139fe$export$25c7213fc07ec080 = function useStaggeredEntrance() {
    var indentifier = (0, $d39b7fe7b41a3372$export$c485849f2e393253)();
    var context = (0, $5FkrB.useContext)($6665b89da3e139fe$var$StaggeredEntranceContext);
    return context(indentifier);
};
/**
 * For a list of elements that need to animate in,
 * this should be used in conjunction with entering components.
 * This does not need Javascript to execute so it will run immediately for any SSR rendered React apps before the JS has executed.
 *
 * Will dynamically add delay to each child entering component.
 * Unfortunately all entering components _NEED_ to be a direct descendant.
 */ var $6665b89da3e139fe$var$StaggeredEntrance = function StaggeredEntrance(_ref) {
    var children = _ref.children, column = _ref.column, _ref$columns = _ref.columns, columns = _ref$columns === void 0 ? 'responsive' : _ref$columns, _ref$delayStep = _ref.delayStep, delayStep = _ref$delayStep === void 0 ? 50 : _ref$delayStep;
    var elementRefs = (0, $5FkrB.useRef)([]);
    var indexes = [];
    var _useState = (0, $5FkrB.useState)(function() {
        if (typeof columns === 'number') // A hardcoded columns is set so bail out and set it to that!
        return columns;
        if (typeof column === 'number') // A hardcoded column is set so we will set actualColumns to be 1.
        return 1;
        // We are in "responsive" mode.
        // So we will be calculating when the Javascript executes on the client how many columns there will be.
        return 0;
    }), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), actualColumns = _useState2[0], setActualColumns = _useState2[1];
    (0, $77a2352ea7b1de65$export$e5c5a5f917a5871c)(function() {
        // We want to only run this code when we are in "responsive" mode.
        // It is assumed we are in responsive mode if `columns` is "responsive",
        // we have children element refs ready to be read (i.e. if there are no children this won't run as well)
        // and finally that `actualColumns` is `0` - this is because for the first render cycle `actualColumns` will be `0` (set above)
        // and then after this layout effect runs the value for `actualColumns` will then be calculated and set.
        if (columns === 'responsive' && elementRefs.current.length && actualColumns === 0) {
            var currentTop = 0;
            var numberColumns = 0;
            if (elementRefs.current.length <= 1) {
                setActualColumns(1);
                return;
            }
            // We set the current top to the first elements.
            // We will be comparing this and incrementing the column count
            // until we hit an element that has a different offset top (or we run out of elements).
            currentTop = elementRefs.current[0] ? elementRefs.current[0].offsetTop : 0;
            for(var i = 0; i < elementRefs.current.length; i++){
                var child = elementRefs.current[i];
                if (!child) break;
                if (currentTop === child.offsetTop) {
                    numberColumns += 1;
                    if (elementRefs.current.length - 1 === i) setActualColumns(numberColumns);
                    continue;
                }
                setActualColumns(numberColumns);
                break;
            }
        }
    // We only want this effect to run once - on initial mount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement($6665b89da3e139fe$var$StaggeredEntranceContext.Provider, {
        value: function value(id) {
            if (!indexes.includes(id)) indexes.push(id);
            var isReady = actualColumns > 0;
            var index = indexes.indexOf(id);
            var currentColumn = column || index % actualColumns;
            var currentRow = Math.floor(index / actualColumns);
            var distanceFromTopLeftElement = currentRow + currentColumn;
            // We don't want loads of elements to have the same staggered delay as it ends up looking slow for users.
            // To get around that we calculate the logarithm using `distanceFromTopLeftElement` which ends making
            // elements appear faster the further away from the top left element.
            var delay = Math.ceil(Math.log(distanceFromTopLeftElement + 1) * delayStep * 1.5) || 0;
            return {
                delay: delay,
                isReady: isReady,
                ref: function ref(element) {
                    return elementRefs.current[index] = element;
                }
            };
        }
    }, children);
};
var $6665b89da3e139fe$export$2e2bcd8739ae039 = $6665b89da3e139fe$var$StaggeredEntrance;


var $6f2e0d15efe4b8cb$var$zoomIn = null;
var $6f2e0d15efe4b8cb$var$zoomOut = null;
var $6f2e0d15efe4b8cb$var$fadeIn = null;
var $6f2e0d15efe4b8cb$var$fadeOut = null;
var $6f2e0d15efe4b8cb$var$fadeInFromTop = null;
var $6f2e0d15efe4b8cb$var$fadeOutFromTop = null;
var $6f2e0d15efe4b8cb$var$fadeInFromLeft = null;
var $6f2e0d15efe4b8cb$var$fadeOutFromLeft = null;
var $6f2e0d15efe4b8cb$var$fadeInFromBottom = null;
var $6f2e0d15efe4b8cb$var$fadeOutFromBottom = null;
var $6f2e0d15efe4b8cb$var$fadeInFromRight = null;
var $6f2e0d15efe4b8cb$var$fadeOutFromRight = null;
var $6f2e0d15efe4b8cb$var$fadeInFromTopConstant = null;
var $6f2e0d15efe4b8cb$var$fadeOutFromTopConstant = null;
var $6f2e0d15efe4b8cb$var$fadeInFromLeftConstant = null;
var $6f2e0d15efe4b8cb$var$fadeOutFromLeftConstant = null;
var $6f2e0d15efe4b8cb$var$fadeInFromBottomConstant = null;
var $6f2e0d15efe4b8cb$var$fadeOutFromBottomConstant = null;
var $6f2e0d15efe4b8cb$var$fadeInFromRightConstant = null;
var $6f2e0d15efe4b8cb$var$fadeOutFromRightConstant = null;
var $6f2e0d15efe4b8cb$var$slideInFromTop = null;
var $6f2e0d15efe4b8cb$var$slideOutFromTop = null;
var $6f2e0d15efe4b8cb$var$slideInFromRight = null;
var $6f2e0d15efe4b8cb$var$slideOutFromRight = null;
var $6f2e0d15efe4b8cb$var$slideInFromBottom = null;
var $6f2e0d15efe4b8cb$var$slideOutFromBottom = null;
var $6f2e0d15efe4b8cb$var$slideInFromLeft = null;
var $6f2e0d15efe4b8cb$var$slideOutFromLeft = null;
/**
 * These are props that motions should use as their external props for consumers.
 * See [FadeIn](packages/helpers/motion/src/entering/fade-in.tsx) for an example usage.
 */ /**
 * This is the base INTERNAL component used for all other entering motions.
 * This does not need Javascript to execute on the client so it will run immediately
 * for any SSR rendered React apps before the JS has executed.
 */ var $6f2e0d15efe4b8cb$var$EnteringMotion = function EnteringMotion(_ref) {
    var children = _ref.children, animationTimingFunction = _ref.animationTimingFunction, _ref$animationTimingF = _ref.animationTimingFunctionExiting, animationTimingFunctionExiting = _ref$animationTimingF === void 0 ? animationTimingFunction : _ref$animationTimingF, enteringAnimation = _ref.enteringAnimation, _ref$exitingAnimation = _ref.exitingAnimation, exitingAnimation = _ref$exitingAnimation === void 0 ? enteringAnimation : _ref$exitingAnimation, isPaused = _ref.isPaused, onFinishMotion = _ref.onFinish, _ref$duration = _ref.duration, duration = _ref$duration === void 0 ? 'large' : _ref$duration;
    var staggered = (0, $6665b89da3e139fe$export$25c7213fc07ec080)();
    var _useExitingPersistenc = (0, $04841b3f070c4001$export$3b6f38abbdcbd000)(), isExiting = _useExitingPersistenc.isExiting, onExitFinished = _useExitingPersistenc.onFinish, appear = _useExitingPersistenc.appear;
    var setTimeout = (0, $f7c7295e9947ded9$export$4f34107a2b00f39c)();
    var paused = isPaused || !staggered.isReady;
    var delay = isExiting ? 0 : staggered.delay;
    var state = isExiting ? 'exiting' : 'entering';
    var _useState = (0, $5FkrB.useState)(appear), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), hasAnimationStyles = _useState2[0], setHasAnimationStyles = _useState2[1];
    (0, $5FkrB.useEffect)(function() {
        // Tracking this to prevent changing state on an unmounted component
        var isCancelled = false;
        if (paused) return;
        // On initial mount if elements aren't set to animate on appear, we return early and callback
        if (!appear) {
            onFinishMotion && onFinishMotion(state);
            return;
        }
        /**
     * Updates relevant state.
     * Called when the animation is finished, or immediately with reduced motion.
     */ var onAnimationEnd = function onAnimationEnd() {
            if (state === 'exiting') // Updates the `ExitingPersistence` to remove this child
            onExitFinished === null || onExitFinished === void 0 || onExitFinished();
            if (!isCancelled) setHasAnimationStyles(false);
            onFinishMotion === null || onFinishMotion === void 0 || onFinishMotion(state);
        };
        if ((0, $43632c3c54f6ff13$export$b7baf7667a68d87c)()) {
            // If there is reduced motion there is no exit animation, so call this immediately
            onAnimationEnd();
            return;
        }
        // Elements may need animation styles back after initial mount (they could animate out)
        setHasAnimationStyles(true);
        // Queue `onAnimationEnd` for after the animation has finished
        setTimeout(onAnimationEnd, isExiting ? (0, $20efdc8e6f2bb874$export$30fa1a2e62ae150c)[duration] : (0, $20efdc8e6f2bb874$export$38b928a7167ce124)[duration] + delay);
        return function() {
            isCancelled = true;
        };
    // We ignore this for onFinishMotion as consumers could potentially inline the function
    // which would then trigger this effect every re-render.
    // We want to make it easier for consumers so we go down this path unfortunately.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        onExitFinished,
        state,
        isExiting,
        duration,
        delay,
        paused,
        setTimeout
    ]);
    return children({
        ref: staggered.ref,
        // @ts-expect-error: `ax` is not typed correctly
        className: hasAnimationStyles ? (0, $970q7.default)([
            (0, $970q7.default)([
                "_1o51eoah _1y0co91m _1bumglyw _sedtglyw"
            ]),
            paused && (0, $970q7.default)([
                "_1y0ctrqk"
            ]),
            duration === 'small' && (0, $970q7.default)([
                "_5sag1yx9"
            ]),
            duration === 'medium' && (0, $970q7.default)([
                "_5sag1ttt"
            ]),
            duration === 'large' && (0, $970q7.default)([
                "_5sagpwmj"
            ]),
            isExiting && duration === 'small' && (0, $970q7.default)([
                "_5sag14ed"
            ]),
            isExiting && duration === 'medium' && (0, $970q7.default)([
                "_5sagluct"
            ]),
            isExiting && duration === 'large' && (0, $970q7.default)([
                "_5sag1ttt"
            ]),
            isExiting && (0, $970q7.default)([
                "_ju255cps _1o51q7pw"
            ]),
            !isExiting && animationTimingFunction === 'linear' && (0, $970q7.default)([
                "_1pglp3kn"
            ]),
            !isExiting && animationTimingFunction === 'ease-out' && (0, $970q7.default)([
                "_1pgldkwg"
            ]),
            !isExiting && animationTimingFunction === 'ease-in' && (0, $970q7.default)([
                "_1pgl1nzg"
            ]),
            !isExiting && animationTimingFunction === 'ease-in-40-out' && (0, $970q7.default)([
                "_1pgl5y64"
            ]),
            !isExiting && animationTimingFunction === 'ease-in-60-out' && (0, $970q7.default)([
                "_1pgl1ddy"
            ]),
            !isExiting && animationTimingFunction === 'ease-in-80-out' && (0, $970q7.default)([
                "_1pglannl"
            ]),
            !isExiting && animationTimingFunction === 'ease-in-out' && (0, $970q7.default)([
                "_1pgl1fu8"
            ]),
            isExiting && animationTimingFunction === 'linear' && (0, $970q7.default)([
                "_1pglp3kn"
            ]),
            isExiting && animationTimingFunctionExiting === 'ease-out' && (0, $970q7.default)([
                "_1pgldkwg"
            ]),
            isExiting && animationTimingFunctionExiting === 'ease-in' && (0, $970q7.default)([
                "_1pgl1nzg"
            ]),
            isExiting && animationTimingFunctionExiting === 'ease-in-40-out' && (0, $970q7.default)([
                "_1pgl5y64"
            ]),
            isExiting && animationTimingFunctionExiting === 'ease-in-60-out' && (0, $970q7.default)([
                "_1pgl1ddy"
            ]),
            isExiting && animationTimingFunctionExiting === 'ease-in-80-out' && (0, $970q7.default)([
                "_1pglannl"
            ]),
            isExiting && animationTimingFunctionExiting === 'ease-in-out' && (0, $970q7.default)([
                "_1pgl1fu8"
            ]),
            (!isExiting && enteringAnimation === 'fade-in' || isExiting && exitingAnimation === 'fade-in') && (0, $970q7.default)([
                "_j7hq1cgr"
            ]),
            (!isExiting && enteringAnimation === 'fade-out' || isExiting && exitingAnimation === 'fade-out') && (0, $970q7.default)([
                "_j7hq1lln"
            ]),
            (!isExiting && enteringAnimation === 'zoom-in' || isExiting && exitingAnimation === 'zoom-in') && (0, $970q7.default)([
                "_j7hqe8p0"
            ]),
            (!isExiting && enteringAnimation === 'zoom-out' || isExiting && exitingAnimation === 'zoom-out') && (0, $970q7.default)([
                "_j7hqy6ql"
            ]),
            (!isExiting && enteringAnimation === 'slide-in-from-top' || isExiting && exitingAnimation === 'slide-in-from-top') && (0, $970q7.default)([
                "_j7hqqshu"
            ]),
            (!isExiting && enteringAnimation === 'slide-out-from-top' || isExiting && exitingAnimation === 'slide-out-from-top') && (0, $970q7.default)([
                "_j7hq7ri4"
            ]),
            (!isExiting && enteringAnimation === 'slide-in-from-right' || isExiting && exitingAnimation === 'slide-in-from-right') && (0, $970q7.default)([
                "_j7hqdfjr"
            ]),
            (!isExiting && enteringAnimation === 'slide-out-from-right' || isExiting && exitingAnimation === 'slide-out-from-right') && (0, $970q7.default)([
                "_j7hqonfj"
            ]),
            (!isExiting && enteringAnimation === 'slide-in-from-bottom' || isExiting && exitingAnimation === 'slide-in-from-bottom') && (0, $970q7.default)([
                "_j7hq1liq"
            ]),
            (!isExiting && enteringAnimation === 'slide-out-from-bottom' || isExiting && exitingAnimation === 'slide-out-from-bottom') && (0, $970q7.default)([
                "_j7hqhnf1"
            ]),
            (!isExiting && enteringAnimation === 'slide-in-from-left' || isExiting && exitingAnimation === 'slide-in-from-left') && (0, $970q7.default)([
                "_j7hq1bh1"
            ]),
            (!isExiting && enteringAnimation === 'slide-out-from-left' || isExiting && exitingAnimation === 'slide-out-from-left') && (0, $970q7.default)([
                "_j7hqj08w"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-top' || isExiting && exitingAnimation === 'fade-in-from-top') && (0, $970q7.default)([
                "_j7hq2iua"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-top' || isExiting && exitingAnimation === 'fade-out-from-top') && (0, $970q7.default)([
                "_j7hq39va"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-left' || isExiting && exitingAnimation === 'fade-in-from-left') && (0, $970q7.default)([
                "_j7hq15m2"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-left' || isExiting && exitingAnimation === 'fade-out-from-left') && (0, $970q7.default)([
                "_j7hq1yiv"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-bottom' || isExiting && exitingAnimation === 'fade-in-from-bottom') && (0, $970q7.default)([
                "_j7hq1w00"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-bottom' || isExiting && exitingAnimation === 'fade-out-from-bottom') && (0, $970q7.default)([
                "_j7hqzy3z"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-right' || isExiting && exitingAnimation === 'fade-in-from-right') && (0, $970q7.default)([
                "_j7hqpqak"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-right' || isExiting && exitingAnimation === 'fade-out-from-right') && (0, $970q7.default)([
                "_j7hq1ebg"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-top-constant' || isExiting && exitingAnimation === 'fade-in-from-top-constant') && (0, $970q7.default)([
                "_j7hqm2e2"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-top-constant' || isExiting && exitingAnimation === 'fade-out-from-top-constant') && (0, $970q7.default)([
                "_j7hq97jn"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-left-constant' || isExiting && exitingAnimation === 'fade-in-from-left-constant') && (0, $970q7.default)([
                "_j7hqovgq"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-left-constant' || isExiting && exitingAnimation === 'fade-out-from-left-constant') && (0, $970q7.default)([
                "_j7hq15do"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-bottom-constant' || isExiting && exitingAnimation === 'fade-in-from-bottom-constant') && (0, $970q7.default)([
                "_j7hq797a"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-bottom-constant' || isExiting && exitingAnimation === 'fade-out-from-bottom-constant') && (0, $970q7.default)([
                "_j7hqwo7r"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-right-constant' || isExiting && exitingAnimation === 'fade-in-from-right-constant') && (0, $970q7.default)([
                "_j7hqt8u5"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-right-constant' || isExiting && exitingAnimation === 'fade-out-from-right-constant') && (0, $970q7.default)([
                "_j7hq1pgp"
            ])
        ]) : '',
        style: {
            animationDelay: "".concat(delay, "ms")
        }
    }, state);
};
var $6f2e0d15efe4b8cb$export$2e2bcd8739ae039 = $6f2e0d15efe4b8cb$var$EnteringMotion;


var $be9b575550d045b7$var$invertedDirection = {
    top: 'bottom',
    bottom: 'top',
    left: 'right',
    right: 'left'
};
/**
 * Props for controlling the behavior of the FadeIn animation
 */ /**
 * __FadeIn__
 *
 * Useful for fading in one or more elements.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/motion/docs/entering-motions)
 */ var $be9b575550d045b7$var$FadeIn = function FadeIn(_ref) {
    var children = _ref.children, _ref$duration = _ref.duration, duration = _ref$duration === void 0 ? 'large' : _ref$duration, entranceDirection = _ref.entranceDirection, exitDirection = _ref.exitDirection, _ref$distance = _ref.distance, distance = _ref$distance === void 0 ? 'proportional' : _ref$distance, onFinish = _ref.onFinish, isPaused = _ref.isPaused;
    var invertedEntranceDirection = entranceDirection !== undefined ? $be9b575550d045b7$var$invertedDirection[entranceDirection] : undefined;
    var isExitDirect = Boolean(exitDirection || invertedEntranceDirection) ? "fade-out-from-".concat(exitDirection || invertedEntranceDirection).concat(distance === 'proportional' ? '' : '-constant') : 'fade-out';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $6f2e0d15efe4b8cb$export$2e2bcd8739ae039), {
        duration: duration,
        enteringAnimation: entranceDirection ? "fade-in-from-".concat(entranceDirection).concat(distance === 'proportional' ? '' : '-constant') : 'fade-in',
        exitingAnimation: isExitDirect,
        animationTimingFunction: "ease-in-out",
        onFinish: onFinish,
        isPaused: isPaused
    }, children);
};
var $be9b575550d045b7$export$2e2bcd8739ae039 = $be9b575550d045b7$var$FadeIn;



var $9Zzpd = parcelRequire("9Zzpd");

var $5K5L9 = parcelRequire("5K5L9");


/* eslint-disable @atlaskit/design-system/no-direct-use-of-web-platform-drag-and-drop */ /**
 * We are listening directly to drag events instead of using a monitor from
 * `@atlaskit/pragmatic-drag-and-drop` to avoid the bundle size cost, as it
 * would affect almost every view in every app.
 *
 * We can reconsider this choice in the future.
 */ 
var $7QpUe = parcelRequire("7QpUe");
var $1d6a7ce7a38e7cbc$var$registrations = new Set();
var $1d6a7ce7a38e7cbc$var$cleanupEndEventListeners = null;
function $1d6a7ce7a38e7cbc$var$onDragStart() {
    if ($1d6a7ce7a38e7cbc$var$cleanupEndEventListeners) // If the cleanup function exists then we've already run this
    return;
    $1d6a7ce7a38e7cbc$var$cleanupEndEventListeners = (0, $7QpUe.bindAll)(window, [
        {
            type: 'dragend',
            listener: $1d6a7ce7a38e7cbc$var$onDragEnd
        },
        {
            type: 'pointerdown',
            listener: $1d6a7ce7a38e7cbc$var$onDragEnd
        },
        {
            type: 'pointermove',
            listener: function() {
                var callCount = 0;
                return function listener() {
                    // Using 20 as it is far bigger than the most observed (3)
                    if (callCount < 20) {
                        callCount++;
                        return;
                    }
                    $1d6a7ce7a38e7cbc$var$onDragEnd();
                };
            }()
        }
    ]);
    var clone = Array.from($1d6a7ce7a38e7cbc$var$registrations);
    clone.forEach(function(subscriber) {
        subscriber.onDragStart();
    });
}
function $1d6a7ce7a38e7cbc$var$onDragEnd() {
    var _cleanupEndEventListe;
    (_cleanupEndEventListe = $1d6a7ce7a38e7cbc$var$cleanupEndEventListeners) === null || _cleanupEndEventListe === void 0 || _cleanupEndEventListe();
    $1d6a7ce7a38e7cbc$var$cleanupEndEventListeners = null;
    var clone = Array.from($1d6a7ce7a38e7cbc$var$registrations);
    clone.forEach(function(subscriber) {
        subscriber.onDragEnd();
    });
}
function $1d6a7ce7a38e7cbc$var$bindStartEvents() {
    return (0, $7QpUe.bindAll)(window, [
        {
            type: 'dragstart',
            listener: $1d6a7ce7a38e7cbc$var$onDragStart
        },
        {
            type: 'dragenter',
            listener: $1d6a7ce7a38e7cbc$var$onDragStart
        }
    ]);
}
var $1d6a7ce7a38e7cbc$var$cleanupStartEventListeners = null;
function $1d6a7ce7a38e7cbc$export$6503ec6e8aabbaf(registration) {
    // if first registration, bind event listeners
    if (!$1d6a7ce7a38e7cbc$var$cleanupStartEventListeners) // note: currently never unbinding these event listeners
    $1d6a7ce7a38e7cbc$var$cleanupStartEventListeners = $1d6a7ce7a38e7cbc$var$bindStartEvents();
    $1d6a7ce7a38e7cbc$var$registrations.add(registration);
    /**
   * The reasoning for this behavior is so that if a tooltip mounts during
   * a drag it can still be suppressed.
   *
   * We use a separate callback instead of onDragStart to avoid infinite loops.
   */ registration.onRegister({
        isDragging: $1d6a7ce7a38e7cbc$var$cleanupEndEventListeners !== null
    });
    return function unregister() {
        $1d6a7ce7a38e7cbc$var$registrations.delete(registration);
        if ($1d6a7ce7a38e7cbc$var$registrations.size === 0) {
            var _cleanupStartEventLis;
            (_cleanupStartEventLis = $1d6a7ce7a38e7cbc$var$cleanupStartEventListeners) === null || _cleanupStartEventLis === void 0 || _cleanupStartEventLis();
            $1d6a7ce7a38e7cbc$var$cleanupStartEventListeners = null;
        }
    };
}



var $9Zzpd = parcelRequire("9Zzpd");
var $7bc7e8b514eb417f$var$delayId = null;
function $7bc7e8b514eb417f$export$eaf678f6f93f5250() {
    if ($7bc7e8b514eb417f$var$delayId != null) {
        window.clearTimeout($7bc7e8b514eb417f$var$delayId);
        $7bc7e8b514eb417f$var$delayId = null;
    }
}
function $7bc7e8b514eb417f$export$5f4d6617421d489b(fn, delay) {
    $7bc7e8b514eb417f$export$eaf678f6f93f5250();
    $7bc7e8b514eb417f$var$delayId = window.setTimeout(function() {
        $7bc7e8b514eb417f$var$delayId = null;
        fn();
    }, delay);
}


// This file is a singleton for managing tooltips
var $1a275fdcec761a59$var$active = null;
function $1a275fdcec761a59$export$57bf213be019eeb0(entry) {
    var phase = 'waiting-to-show';
    function isActive() {
        return Boolean($1a275fdcec761a59$var$active && $1a275fdcec761a59$var$active.entry === entry);
    }
    function cleanup() {
        if (isActive()) {
            (0, $7bc7e8b514eb417f$export$eaf678f6f93f5250)();
            $1a275fdcec761a59$var$active = null;
        }
    }
    function done() {
        if (isActive()) entry.done();
        phase = 'done';
        cleanup();
    }
    function immediatelyHideAndDone() {
        if (isActive()) entry.hide({
            isImmediate: true
        });
        done();
    }
    function keep() {
        if (!isActive()) return;
        // aborting a wait to hide
        if (phase === 'waiting-to-hide') {
            phase = 'shown';
            (0, $7bc7e8b514eb417f$export$eaf678f6f93f5250)();
            return;
        }
        // aborting hide animation
        if (phase === 'hide-animating') {
            phase = 'shown';
            (0, $7bc7e8b514eb417f$export$eaf678f6f93f5250)();
            entry.show({
                isImmediate: false
            });
            return;
        }
    }
    function requestHide(_ref) {
        var isImmediate = _ref.isImmediate;
        if (!isActive()) return;
        // If we were not showing yet anyway; finish straight away
        if (phase === 'waiting-to-show') {
            immediatelyHideAndDone();
            return;
        }
        // already waiting to hide
        if (phase === 'waiting-to-hide') return;
        if (isImmediate) {
            immediatelyHideAndDone();
            return;
        }
        phase = 'waiting-to-hide';
        (0, $7bc7e8b514eb417f$export$5f4d6617421d489b)(function() {
            phase = 'hide-animating';
            entry.hide({
                isImmediate: false
            });
        }, entry.delay);
    }
    function finishHideAnimation() {
        if (isActive() && phase === 'hide-animating') done();
    }
    function isVisible() {
        return phase === 'shown' || phase === 'waiting-to-hide' || phase === 'hide-animating';
    }
    function getInitialMouse() {
        if (entry.source.type === 'mouse') return entry.source.mouse;
        return null;
    }
    function start() {
        var shouldAlwaysFadeIn = (0, $9Zzpd.fg)('platform_dst_nav4_side_nav_resize_tooltip_feedback') ? entry.shouldAlwaysFadeIn : false;
        var showImmediately = Boolean($1a275fdcec761a59$var$active && $1a275fdcec761a59$var$active.isVisible()) && !shouldAlwaysFadeIn;
        // If there was an active tooltip; we tell it to remove itself at once!
        if ($1a275fdcec761a59$var$active) {
            (0, $7bc7e8b514eb417f$export$eaf678f6f93f5250)();
            $1a275fdcec761a59$var$active.entry.hide({
                isImmediate: true
            });
            $1a275fdcec761a59$var$active.entry.done();
            $1a275fdcec761a59$var$active = null;
        }
        // this tooltip is now the active tooltip
        $1a275fdcec761a59$var$active = {
            entry: entry,
            isVisible: isVisible
        };
        function show() {
            phase = 'shown';
            entry.show({
                isImmediate: showImmediately
            });
        }
        if (showImmediately) {
            show();
            return;
        }
        phase = 'waiting-to-show';
        (0, $7bc7e8b514eb417f$export$5f4d6617421d489b)(show, entry.delay);
    }
    // let's get started!
    start();
    var result = {
        keep: keep,
        abort: cleanup,
        isActive: isActive,
        requestHide: requestHide,
        finishHideAnimation: finishHideAnimation,
        // Removing old `mousePosition` behind gate because it stored a function.
        // With the gate we just store the coords which are easier to work with.
        mousePosition: (0, $9Zzpd.fg)('platform_dst_nav4_side_nav_resize_tooltip_feedback') ? undefined : getInitialMouse(),
        mousePos: entry.source.type === 'mouse' && (0, $9Zzpd.fg)('platform_dst_nav4_side_nav_resize_tooltip_feedback') ? {
            clientX: entry.source.clientX,
            clientY: entry.source.clientY
        } : null
    };
    return result;
}



var $h8qvJ = parcelRequire("h8qvJ");
function $30ef58c9030f2e88$export$2e2bcd8739ae039(prefix, shouldRenderId) {
    var seed = (0, $h8qvJ.useIdSeed)();
    return shouldRenderId ? "".concat(seed(prefix)) : undefined;
}


/* tooltip-container.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");
/* tooltip-primitive.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");
/* tooltip-shortcut.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");
var $05e614b60448741f$var$styles = {
    shortcutSegmentsContainer: "_zulpv77o _1e0c1txw _1q511b66 _85i5v77o",
    shortcutSegment: "_11c8wadc _2rkolb4i _1dqonqa1 _189ee4h9 _1h6d1ihb _1e0c1txw _4cvr1h6o _4t3i1k92 _vchhusvi _1q51v77o _85i5v77o _bozg12x7 _y4ti12x7 _16qsn7od _1254n7od _cgnln7od _syazn7od _ahbqn7od _12l2n7od _1pfhn7od _6rthn7od _1ul9n7od _w19jn7od _bfhk261p"
};
var $05e614b60448741f$export$5bcbc43c84236222 = function TooltipShortcut(_ref) {
    var shortcut = _ref.shortcut;
    return /*#__PURE__*/ $5FkrB.createElement("div", {
        className: (0, $970q7.default)([
            $05e614b60448741f$var$styles.shortcutSegmentsContainer
        ])
    }, shortcut.map(function(segment, index) {
        return /*#__PURE__*/ $5FkrB.createElement("kbd", {
            key: "".concat(segment, "-").concat(index),
            className: (0, $970q7.default)([
                $05e614b60448741f$var$styles.shortcutSegment
            ])
        }, segment);
    }));
};


var $99473e26304d0aec$var$primitiveStyles = null;
/**
 * The lower level component for rendering a tooltip.
 */ var $99473e26304d0aec$var$TooltipPrimitive = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function TooltipPrimitive(_ref, ref) {
    var style = _ref.style, className = _ref.className, children = _ref.children, placement = _ref.placement, testId = _ref.testId, onMouseOut = _ref.onMouseOut, onMouseOver = _ref.onMouseOver, id = _ref.id, shortcut = _ref.shortcut;
    return /*#__PURE__*/ $5FkrB.createElement("div", {
        ref: ref,
        style: style,
        "data-testid": testId ? "".concat(testId, "--wrapper") : undefined
    }, /*#__PURE__*/ $5FkrB.createElement("div", {
        role: "tooltip",
        className: (0, $970q7.default)([
            "_80om73ad",
            className
        ]),
        onMouseOut: onMouseOut,
        onMouseOver: onMouseOver,
        "data-placement": placement,
        "data-testid": testId,
        id: id
    }, children, shortcut && /*#__PURE__*/ $5FkrB.createElement((0, $05e614b60448741f$export$5bcbc43c84236222), {
        shortcut: shortcut
    })));
});
$99473e26304d0aec$var$TooltipPrimitive.displayName = 'TooltipPrimitive';
var $99473e26304d0aec$export$2e2bcd8739ae039 = $99473e26304d0aec$var$TooltipPrimitive;


var $e613f77ead8e1e79$var$styles = {
    base: "_2rkofajl _11c8wadc _vchhusvi _p12fp3fh _bfhkgkf6 _syaz15cr _152tze3t _1e02ze3t _1i4q1hna _1q511b66 _85i51b66 _y4ti12x7 _bozg12x7 _slp31hna",
    truncate: "_1reo15vq _18m915vq _p12f1pna _1bto1l2s _o5721q9c"
};
/**
 * Used as the default tooltip container component for the exported `Tooltip` component.
 * Adds some styles to the tooltip primitive.
 */ var $e613f77ead8e1e79$var$TooltipContainer = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function TooltipContainer(_ref, ref) {
    var style = _ref.style, className = _ref.className, children = _ref.children, truncate = _ref.truncate, placement = _ref.placement, testId = _ref.testId, onMouseOut = _ref.onMouseOut, onMouseOver = _ref.onMouseOver, id = _ref.id, shortcut = _ref.shortcut;
    return /*#__PURE__*/ $5FkrB.createElement((0, $99473e26304d0aec$export$2e2bcd8739ae039), {
        ref: ref,
        style: style,
        className: (0, $970q7.default)([
            $e613f77ead8e1e79$var$styles.base,
            truncate && $e613f77ead8e1e79$var$styles.truncate,
            className
        ]),
        placement: placement,
        testId: testId,
        id: id,
        onMouseOut: onMouseOut,
        onMouseOver: onMouseOver,
        shortcut: shortcut
    }, children);
});
$e613f77ead8e1e79$var$TooltipContainer.displayName = 'TooltipContainer';
var $e613f77ead8e1e79$export$2e2bcd8739ae039 = $e613f77ead8e1e79$var$TooltipContainer;


function $7f5e86671d538d18$export$642213d516a9b928(mouseCoordinates) {
    var safeMouse = mouseCoordinates || {
        top: 0,
        left: 0
    };
    var getBoundingClientRect = function getBoundingClientRect() {
        return {
            top: safeMouse.top,
            left: safeMouse.left,
            bottom: safeMouse.top,
            right: safeMouse.left,
            width: 0,
            height: 0
        };
    };
    return {
        getBoundingClientRect: getBoundingClientRect,
        clientWidth: 0,
        clientHeight: 0
    };
}
function $7f5e86671d538d18$export$2e68479e0a5d8746(mousePos, _ref) {
    var targetElement = _ref.targetElement, tooltipPosition = _ref.tooltipPosition;
    if (tooltipPosition === 'mouse') return {
        getBoundingClientRect: function getBoundingClientRect() {
            return DOMRect.fromRect({
                x: mousePos.clientX,
                y: mousePos.clientY,
                width: 0,
                height: 0
            });
        }
    };
    var targetRect = targetElement.getBoundingClientRect();
    if (tooltipPosition === 'mouse-x') return {
        getBoundingClientRect: function getBoundingClientRect() {
            return DOMRect.fromRect({
                x: mousePos.clientX,
                y: targetRect.top,
                width: 0,
                height: targetRect.height
            });
        }
    };
    if (tooltipPosition === 'mouse-y') return {
        getBoundingClientRect: function getBoundingClientRect() {
            return DOMRect.fromRect({
                x: targetRect.left,
                y: mousePos.clientY,
                width: targetRect.width,
                height: 0
            });
        }
    };
    throw new Error("Invalid tooltip position for virtual element: ".concat(tooltipPosition));
}


function $8e895bced65fd72c$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $8e895bced65fd72c$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $8e895bced65fd72c$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $8e895bced65fd72c$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $8e895bced65fd72c$var$tooltipZIndex = (0, $0a8491a5f0c98b2c$export$7be255094ccdc533).tooltip();
var $8e895bced65fd72c$var$analyticsAttributes = {
    componentName: 'tooltip',
    packageName: "@atlaskit/tooltip",
    packageVersion: "20.14.1"
};
// Inverts motion direction
var $8e895bced65fd72c$var$invertedDirection = {
    top: 'bottom',
    bottom: 'top',
    left: 'right',
    right: 'left'
};
/**
 * Converts a Popper placement to it's general direction.
 *
 * @param placement - Popper Placement value, e.g. 'top-start'
 * @returns Popper Direction, e.g. 'top'
 */ var $8e895bced65fd72c$var$getDirectionFromPlacement = function getDirectionFromPlacement(placement) {
    return placement.split('-')[0];
};
/**
 * __Tooltip__
 *
 * A tooltip is a floating, non-actionable label used to explain a user interface element or feature.
 */ function $8e895bced65fd72c$var$Tooltip(_ref) {
    var children = _ref.children, _ref$position = _ref.position, position = _ref$position === void 0 ? 'bottom' : _ref$position, _ref$mousePosition = _ref.mousePosition, mousePosition = _ref$mousePosition === void 0 ? 'bottom' : _ref$mousePosition, content = _ref.content, _ref$truncate = _ref.truncate, truncate = _ref$truncate === void 0 ? false : _ref$truncate, _ref$component = _ref.component, Container = _ref$component === void 0 ? (0, $e613f77ead8e1e79$export$2e2bcd8739ae039) : _ref$component, _ref$tag = _ref.tag, TargetContainer = _ref$tag === void 0 ? 'div' : _ref$tag, testId = _ref.testId, _ref$delay = _ref.delay, delay = _ref$delay === void 0 ? 300 : _ref$delay, _ref$onShow = _ref.onShow, onShow = _ref$onShow === void 0 ? (0, $eVb4V.default) : _ref$onShow, _ref$onHide = _ref.onHide, onHide = _ref$onHide === void 0 ? (0, $eVb4V.default) : _ref$onHide, canAppear = _ref.canAppear, _ref$hideTooltipOnCli = _ref.hideTooltipOnClick, hideTooltipOnClick = _ref$hideTooltipOnCli === void 0 ? false : _ref$hideTooltipOnCli, _ref$hideTooltipOnMou = _ref.hideTooltipOnMouseDown, hideTooltipOnMouseDown = _ref$hideTooltipOnMou === void 0 ? false : _ref$hideTooltipOnMou, analyticsContext = _ref.analyticsContext, _ref$strategy = _ref.strategy, strategy = _ref$strategy === void 0 ? 'fixed' : _ref$strategy, _ref$ignoreTooltipPoi = _ref.ignoreTooltipPointerEvents, ignoreTooltipPointerEvents = _ref$ignoreTooltipPoi === void 0 ? false : _ref$ignoreTooltipPoi, _ref$isScreenReaderAn = _ref.isScreenReaderAnnouncementDisabled, isScreenReaderAnnouncementDisabled = _ref$isScreenReaderAn === void 0 ? false : _ref$isScreenReaderAn, shortcut = _ref.shortcut, _ref$UNSAFE_shouldAlw = _ref.UNSAFE_shouldAlwaysFadeIn, shouldAlwaysFadeIn = _ref$UNSAFE_shouldAlw === void 0 ? false : _ref$UNSAFE_shouldAlw, _ref$UNSAFE_shouldRen = _ref.UNSAFE_shouldRenderToParent, UNSAFE_shouldRenderToParent = _ref$UNSAFE_shouldRen === void 0 ? false : _ref$UNSAFE_shouldRen;
    // Not using a gate for this check. When the gate is disabled `mouse-y` and `mouse-x` are treated as `mouse`.
    var isMousePosition = position === 'mouse' || position === 'mouse-y' || position === 'mouse-x';
    var tooltipPosition = isMousePosition ? mousePosition : position;
    var onShowHandler = (0, $5f91d7c230669509$export$1a04351537078b55)($8e895bced65fd72c$var$_objectSpread({
        fn: onShow,
        action: 'displayed',
        analyticsData: analyticsContext
    }, $8e895bced65fd72c$var$analyticsAttributes));
    var onHideHandler = (0, $5f91d7c230669509$export$1a04351537078b55)($8e895bced65fd72c$var$_objectSpread({
        fn: onHide,
        action: 'hidden',
        analyticsData: analyticsContext
    }, $8e895bced65fd72c$var$analyticsAttributes));
    var apiRef = (0, $5FkrB.useRef)(null);
    var _useState = (0, $5FkrB.useState)('hide'), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), state = _useState2[0], setState = _useState2[1];
    var targetRef = (0, $5FkrB.useRef)(null);
    var containerRef = (0, $5FkrB.useRef)(null);
    // This function is deliberately _not_ memoized as it needs to re-run every render
    // to pick up any child ref changes. If you use render props you don't have this issue.
    var setImplicitRefFromChildren = function setImplicitRefFromChildren(node) {
        containerRef.current = node;
        targetRef.current = node ? node.firstElementChild : null;
    };
    // This is memoized and passed into the render props callback.
    var setDirectRef = (0, $5FkrB.useCallback)(function(node) {
        targetRef.current = node;
    }, []);
    // Putting a few things into refs so that we don't have to break memoization
    var stableState = (0, $3UUXy.default)(state);
    // These props are placed in separate refs instead of a single object to reduce memory usage.
    // Placing them in the same object previously caused an increase in the number of JavaScript event listeners
    // before garbage collection.
    var onShowHandlerStable = (0, $3UUXy.default)(onShowHandler);
    var onHideHandlerStable = (0, $3UUXy.default)(onHideHandler);
    var delayStable = (0, $3UUXy.default)(delay);
    var canAppearStable = (0, $3UUXy.default)(canAppear);
    var hasCalledShowHandler = (0, $5FkrB.useRef)(false);
    var shouldAlwaysFadeInStable = (0, $3UUXy.default)(shouldAlwaysFadeIn);
    var start = (0, $5FkrB.useCallback)(function(api) {
        // @ts-ignore
        apiRef.current = api;
        hasCalledShowHandler.current = false;
    }, []);
    var done = (0, $5FkrB.useCallback)(function() {
        if (!apiRef.current) return;
        // Only call onHideHandler if we have called onShowHandler
        if (hasCalledShowHandler.current) onHideHandlerStable.current();
        // @ts-ignore
        apiRef.current = null;
        // @ts-ignore
        hasCalledShowHandler.current = false;
        // just in case
        setState('hide');
    }, [
        onHideHandlerStable
    ]);
    var abort = (0, $5FkrB.useCallback)(function() {
        if (!apiRef.current) return;
        apiRef.current.abort();
        // Only call onHideHandler if we have called onShowHandler
        if (hasCalledShowHandler.current) onHideHandlerStable.current();
        // @ts-ignore
        apiRef.current = null;
    }, [
        onHideHandlerStable
    ]);
    (0, $5FkrB.useEffect)(function mount() {
        return function unmount() {
            if (apiRef.current) abort();
        };
    }, [
        abort
    ]);
    var isDraggingRef = (0, $5FkrB.useRef)(false);
    (0, $5FkrB.useEffect)(function() {
        return (0, $1d6a7ce7a38e7cbc$export$6503ec6e8aabbaf)({
            onRegister: function onRegister(_ref2) {
                var isDragging = _ref2.isDragging;
                isDraggingRef.current = isDragging;
            },
            onDragStart: function onDragStart() {
                var _apiRef$current;
                /**
         * Hiding any visible tooltips when a drag starts because otherwise it
         * looks janky (disappears and reappears), and is not required.
         */ (_apiRef$current = apiRef.current) === null || _apiRef$current === void 0 || _apiRef$current.requestHide({
                    isImmediate: true
                });
                isDraggingRef.current = true;
            },
            onDragEnd: function onDragEnd() {
                isDraggingRef.current = false;
            }
        });
    }, []);
    var tryShowTooltip = (0, $5FkrB.useCallback)(function(source) {
        var _canAppearStable$curr;
        /**
     * Prevent tooltips from being shown during a drag. This can occur with
     * the native drag and drop API, where some pointer events can fire
     * when they should not and lead to jank with tooltips.
     */ if (isDraggingRef.current) return;
        // Another tooltip is has been active but we still have the old `api`
        // around. We need to finish up the last usage.
        // Note: just being safe - this should not happen
        if (apiRef.current && !apiRef.current.isActive()) abort();
        // This tooltip is already active, we can exit
        if (apiRef.current && apiRef.current.isActive()) {
            apiRef.current.keep();
            return;
        }
        /**
     * Check if tooltip is allowed to show.
     *
     * Once a tooltip has started, or has scheduled to start
     * we won't be checking `canAppear` again.
     *
     * - We don't want tooltips to disappear once they are shown
     * - For consistency, we start after a single positive `canAppear`.
     *   Otherwise the amount of times we ask consumers would depend on
     *   how many times we get a "mousemove", which _could_ lead to situations
     *   where moving the mouse could result in a different outcome to if
     *   the mouse was not moved.
     */ if (canAppearStable.current && !((_canAppearStable$curr = canAppearStable.current) !== null && _canAppearStable$curr !== void 0 && _canAppearStable$curr.call(canAppearStable))) return;
        var entry = {
            source: source,
            delay: delayStable.current,
            show: function show(_ref3) {
                var isImmediate = _ref3.isImmediate;
                // Call the onShow handler if it hasn't been called yet
                if (!hasCalledShowHandler.current) {
                    hasCalledShowHandler.current = true;
                    onShowHandlerStable.current();
                }
                setState(!isImmediate ? 'fade-in' : 'show-immediate');
            },
            hide: function hide(_ref4) {
                var isImmediate = _ref4.isImmediate;
                if (isImmediate) setState('hide');
                else setState('before-fade-out');
            },
            done: done,
            shouldAlwaysFadeIn: (0, $9Zzpd.fg)('platform_dst_nav4_side_nav_resize_tooltip_feedback') ? shouldAlwaysFadeInStable.current : false
        };
        var api = (0, $1a275fdcec761a59$export$57bf213be019eeb0)(entry);
        start(api);
    }, [
        canAppearStable,
        delayStable,
        done,
        start,
        abort,
        onShowHandlerStable,
        shouldAlwaysFadeInStable
    ]);
    var hideTooltipOnEsc = (0, $5FkrB.useCallback)(function() {
        var _apiRef$current2;
        (_apiRef$current2 = apiRef.current) === null || _apiRef$current2 === void 0 || _apiRef$current2.requestHide({
            isImmediate: true
        });
    }, [
        apiRef
    ]);
    (0, $hy47X.default)({
        onClose: hideTooltipOnEsc,
        isDisabled: state === 'hide' || state === 'fade-out'
    });
    (0, $5FkrB.useEffect)(function() {
        if (state === 'hide') return 0, $eVb4V.default;
        if (state === 'before-fade-out') setState('fade-out');
        var unbind = (0, $7QpUe.bind)(window, {
            type: 'scroll',
            listener: function listener() {
                if (apiRef.current) apiRef.current.requestHide({
                    isImmediate: true
                });
            },
            options: {
                capture: true,
                passive: true,
                once: true
            }
        });
        return unbind;
    }, [
        state
    ]);
    var onMouseDown = (0, $5FkrB.useCallback)(function() {
        if (hideTooltipOnMouseDown && apiRef.current) apiRef.current.requestHide({
            isImmediate: true
        });
    }, [
        hideTooltipOnMouseDown
    ]);
    var onClick = (0, $5FkrB.useCallback)(function() {
        if (hideTooltipOnClick && apiRef.current) apiRef.current.requestHide({
            isImmediate: true
        });
    }, [
        hideTooltipOnClick
    ]);
    // Ideally we would be using onMouseEnter here, but
    // because we are binding the event to the target parent
    // we need to listen for the mouseover of all sub elements
    // This means when moving along a tooltip we are quickly toggling
    // between api.requestHide and api.keep. This it not ideal
    var onMouseOver = (0, $5FkrB.useCallback)(function(event) {
        // Ignoring events from the container ref
        if (containerRef.current && event.target === containerRef.current) return;
        // Using prevent default as a signal that parent tooltips
        if (event.defaultPrevented) return;
        event.preventDefault();
        var source = isMousePosition ? {
            type: 'mouse',
            // TODO: ideally not recalculating this object each time
            // Removing old `mouse` behind gate because it stored a function.
            // With the gate we just store the coords which are easier to work with.
            mouse: (0, $9Zzpd.fg)('platform_dst_nav4_side_nav_resize_tooltip_feedback') ? undefined : (0, $7f5e86671d538d18$export$642213d516a9b928)({
                left: event.clientX,
                top: event.clientY
            }),
            clientX: event.clientX,
            clientY: event.clientY
        } : {
            type: 'keyboard'
        };
        tryShowTooltip(source);
    }, [
        isMousePosition,
        tryShowTooltip
    ]);
    // Ideally we would be using onMouseEnter here, but
    // because we are binding the event to the target parent
    // we need to listen for the mouseout of all sub elements
    // This means when moving along a tooltip we are quickly toggling
    // between api.requestHide and api.keep. This it not ideal
    var onMouseOut = (0, $5FkrB.useCallback)(function(event) {
        // Ignoring events from the container ref
        if (containerRef.current && event.target === containerRef.current) return;
        // Using prevent default as a signal that parent tooltips
        if (event.defaultPrevented) return;
        event.preventDefault();
        if (apiRef.current) apiRef.current.requestHide({
            isImmediate: false
        });
    }, []);
    var onMouseMove = isMousePosition ? function(event) {
        var _apiRef$current3;
        if ((_apiRef$current3 = apiRef.current) !== null && _apiRef$current3 !== void 0 && _apiRef$current3.isActive()) {
            if (!(0, $9Zzpd.fg)('platform_dst_nav4_side_nav_resize_tooltip_feedback')) apiRef.current.mousePosition = (0, $7f5e86671d538d18$export$642213d516a9b928)({
                left: event.clientX,
                top: event.clientY
            });
            apiRef.current.mousePos = {
                clientX: event.clientX,
                clientY: event.clientY
            };
        }
    } : undefined;
    var onMouseOverTooltip = (0, $5FkrB.useCallback)(function() {
        if (apiRef.current && apiRef.current.isActive()) {
            apiRef.current.keep();
            return;
        }
    }, []);
    var onFocus = (0, $5FkrB.useCallback)(function(e) {
        // Check if focus-visible
        // Prevents tooltips from showing when focus is not visible,
        // i.e., when focus is moved onto tooltip trigger inside a popup on open
        try {
            if (!e.target.matches(':focus-visible')) return;
        } catch (_unused) {
        // Ignore errors from environments that don't support :focus-visible
        }
        // TODO: this does not play well with `hideTooltipOnMouseDown`
        // as "focus" will occur after the "mousedown".
        tryShowTooltip({
            type: 'keyboard'
        });
    }, [
        tryShowTooltip
    ]);
    var onBlur = (0, $5FkrB.useCallback)(function() {
        if (apiRef.current) apiRef.current.requestHide({
            isImmediate: false
        });
    }, []);
    var onAnimationFinished = (0, $5FkrB.useCallback)(function(transition) {
        // Using lastState here because motion is not picking up the latest value
        if (transition === 'exiting' && stableState.current === 'fade-out' && apiRef.current) // @ts-ignore: refs are writeable
        apiRef.current.finishHideAnimation();
    }, [
        stableState
    ]);
    // Doing a cast because typescript is struggling to narrow the type
    var CastTargetContainer = TargetContainer;
    var shouldRenderTooltipPopup = state !== 'hide' && Boolean(content);
    var shouldRenderHiddenContent = !isScreenReaderAnnouncementDisabled && shouldRenderTooltipPopup;
    var shouldRenderTooltipChildren = state !== 'hide' && state !== 'fade-out';
    var handleOpenLayerObserverCloseSignal = (0, $5FkrB.useCallback)(function() {
        var _apiRef$current4;
        (_apiRef$current4 = apiRef.current) === null || _apiRef$current4 === void 0 || _apiRef$current4.requestHide({
            isImmediate: true
        });
    }, []);
    (0, $iUCre.useNotifyOpenLayerObserver)({
        // Layer is only visually open if both the tooltip popup (container) and children are rendered.
        isOpen: shouldRenderTooltipPopup && shouldRenderTooltipChildren,
        /**
     * We don't strictly need to provide an onClose callback at this time, as there is
     * already code that handles hiding the tooltip when a drag is started (and the only
     * usage right now is closing all layers when the user resizes the side nav).
     *
     * However, for future-proofing and semantic reasons, it makes sense to close the tooltip
     * whenever the open layer observer requests a close.
     */ onClose: handleOpenLayerObserverCloseSignal
    });
    var getReferenceElement = function getReferenceElement() {
        var _apiRef$current5, _apiRef$current6;
        if (isMousePosition && (_apiRef$current5 = apiRef.current) !== null && _apiRef$current5 !== void 0 && _apiRef$current5.mousePos && targetRef.current && (0, $9Zzpd.fg)('platform_dst_nav4_side_nav_resize_tooltip_feedback')) return (0, $7f5e86671d538d18$export$2e68479e0a5d8746)(apiRef.current.mousePos, {
            targetElement: targetRef.current,
            tooltipPosition: position
        });
        if (isMousePosition && (_apiRef$current6 = apiRef.current) !== null && _apiRef$current6 !== void 0 && _apiRef$current6.mousePosition && !(0, $9Zzpd.fg)('platform_dst_nav4_side_nav_resize_tooltip_feedback')) {
            var _apiRef$current7;
            return (_apiRef$current7 = apiRef.current) === null || _apiRef$current7 === void 0 ? void 0 : _apiRef$current7.mousePosition;
        }
        return targetRef.current || undefined;
    };
    var tooltipIdForHiddenContent = (0, $30ef58c9030f2e88$export$2e2bcd8739ae039)('tooltip', shouldRenderHiddenContent);
    var tooltipTriggerProps = {
        onMouseOver: onMouseOver,
        onMouseOut: onMouseOut,
        onMouseMove: onMouseMove,
        onMouseDown: onMouseDown,
        onClick: onClick,
        onFocus: onFocus,
        onBlur: onBlur
    };
    // Don't set `data-testid` unless it's defined, as it's not in the interface.
    if (testId) // Adding `data-testid` to the TriggerProps interface breaks Buttons, so we use type assertion
    tooltipTriggerProps['data-testid'] = "".concat(testId, "--container");
    // This useEffect is purely for managing the aria attribute when using the
    // wrapped children approach.
    var isChildrenAFunction = typeof children === 'function';
    (0, $5FkrB.useEffect)(function() {
        if (isChildrenAFunction) return;
        // If `children` is _not_ a function, we are stepping outside of the public
        // API to add a `aria-describedby` attribute.
        var target = targetRef.current;
        if (!target || !tooltipIdForHiddenContent) return;
        target.setAttribute('aria-describedby', tooltipIdForHiddenContent);
        return function() {
            return target.removeAttribute('aria-describedby');
        };
    }, [
        isChildrenAFunction,
        tooltipIdForHiddenContent
    ]);
    var hiddenContent = shouldRenderHiddenContent ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("span", {
        "data-testid": testId ? "".concat(testId, "-hidden") : undefined,
        hidden: true,
        id: tooltipIdForHiddenContent
    }, typeof content === 'function' ? content({}) : content) : null;
    var PopperWrapper = UNSAFE_shouldRenderToParent && (0, $9Zzpd.fg)('platform_dst_nav4_side_nav_resize_tooltip_feedback') ? (0, $5FkrB.Fragment) : $8e895bced65fd72c$var$TooltipPortal;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).Fragment, null, typeof children === 'function' ? /*#__PURE__*/ // once we deprecate the wrapped approach, we can put the aria
    // attribute back into the tooltipTriggerProps and make it required
    // instead of optional in `types`
    (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).Fragment, null, children($8e895bced65fd72c$var$_objectSpread($8e895bced65fd72c$var$_objectSpread({}, tooltipTriggerProps), {}, {
        'aria-describedby': tooltipIdForHiddenContent,
        ref: setDirectRef
    })), hiddenContent) : /*#__PURE__*/ // @ts-ignore
    (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(CastTargetContainer, (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, tooltipTriggerProps, {
        ref: setImplicitRefFromChildren,
        role: "presentation"
    }), children, hiddenContent), shouldRenderTooltipPopup ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(PopperWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $5K5L9.Popper), {
        placement: tooltipPosition,
        referenceElement: getReferenceElement(),
        strategy: strategy
    }, function(_ref5) {
        var ref = _ref5.ref, style = _ref5.style, update = _ref5.update, placement = _ref5.placement;
        // Invert the entrance and exit directions.
        // E.g. a tooltip's position is on the 'right', it should enter from and exit to the 'left'
        // This gives the effect the tooltip is appearing from the target
        var direction = isMousePosition ? undefined : $8e895bced65fd72c$var$invertedDirection[$8e895bced65fd72c$var$getDirectionFromPlacement(placement)];
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $04841b3f070c4001$export$2e2bcd8739ae039), {
            appear: true
        }, shouldRenderTooltipChildren && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $be9b575550d045b7$export$2e2bcd8739ae039), {
            distance: "constant",
            entranceDirection: direction,
            exitDirection: direction,
            onFinish: onAnimationFinished,
            duration: state !== 'show-immediate' ? 'medium' : 'none'
        }, function(_ref6) {
            var className = _ref6.className;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(Container, {
                ref: ref,
                className: "Tooltip ".concat(className),
                style: $8e895bced65fd72c$var$_objectSpread($8e895bced65fd72c$var$_objectSpread({}, style), ignoreTooltipPointerEvents && {
                    pointerEvents: 'none'
                }),
                truncate: truncate,
                placement: tooltipPosition,
                testId: getReferenceElement() ? testId : testId && "".concat(testId, "--unresolved"),
                onMouseOut: onMouseOut,
                onMouseOver: onMouseOverTooltip,
                shortcut: shortcut
            }, typeof content === 'function' ? content({
                update: update
            }) : content);
        }));
    })) : null);
}
var $8e895bced65fd72c$export$2e2bcd8739ae039 = $8e895bced65fd72c$var$Tooltip;
var $8e895bced65fd72c$var$TooltipPortal = function TooltipPortal(_ref7) {
    var children = _ref7.children;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $e1c760c467d2ecc0$export$2e2bcd8739ae039), {
        zIndex: $8e895bced65fd72c$var$tooltipZIndex
    }, children);
};



var $9ccbbf3f156f1205$export$36d18380658d5d20 = function Option(props) {
    var _props$data;
    if ((_props$data = props.data) !== null && _props$data !== void 0 && _props$data.invalid) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $d1af5435ad8463ff$export$e786733cafde97b9), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $aad61cb0e4d82ad4$export$d40cc97ecda916f9), props), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $8e895bced65fd72c$export$2e2bcd8739ae039), {
        content: props.selectProps.fieldInvalidLabel
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($656c973b7454adeb$exports))), {
        label: "Test",
        color: "var(--ds-icon-danger, ".concat((0, $84873b2431594582$export$2010d0fb4295b346), ")")
    })));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $aad61cb0e4d82ad4$export$d40cc97ecda916f9), props);
};


var $d0ececfceac96691$var$_excluded = [
    "onFilterOption",
    "placeholder"
];
var $d0ececfceac96691$export$c34d65c0f5a1c617 = {
    Control: (0, $af441003ba3d255b$export$7a7fa4424cb20976),
    DropdownIndicator: (0, $e5cc808bf44932c8$export$ec98719d3db7f2e4),
    LoadingIndicator: null,
    Menu: (0, $f31a052dc39d13b3$export$d9b273488cd8ce6f),
    Option: (0, $9ccbbf3f156f1205$export$36d18380658d5d20)
};
var $d0ececfceac96691$var$onIsOptionDisabled = function onIsOptionDisabled(option) {
    return 'error' in option ? !!option.error : false;
};
var $d0ececfceac96691$export$51cc13ac81e51592 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).forwardRef(function(_ref, ref) {
    var onFilterOption = _ref.onFilterOption, placeholder = _ref.placeholder, restProps = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $d0ececfceac96691$var$_excluded);
    var intl = (0, $6Wx3K.default)();
    var ariaLabelProp = restProps.ariaLabel, onInputChangeProp = restProps.onInputChange, inputValueProp = restProps.inputValue;
    var _useState = (0, $5FkrB.useState)(inputValueProp || ''), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), inputValue = _useState2[0], setInputValue = _useState2[1];
    var onInputChange = (0, $5FkrB.useCallback)(function(newValue, actionMeta) {
        /**
     * Do not clear the filter input value when an input is selected or blurred.
     * NOTE: We are also returning when 'menu-close' event are triggered,
     * which happens when the input is clicked for some reason, but not when we click outside of the dropdown
     * */ if ([
            (0, $2c2c8763cec88c4d$export$50531cf3046c5956).setValue,
            (0, $2c2c8763cec88c4d$export$50531cf3046c5956).inputBlur,
            (0, $2c2c8763cec88c4d$export$50531cf3046c5956).menuClose
        ].includes(actionMeta.action) && !newValue.length) return;
        onInputChangeProp === null || onInputChangeProp === void 0 || onInputChangeProp(newValue, actionMeta);
        setInputValue(newValue);
    }, [
        onInputChangeProp
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $5657ad900fe2702d$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, restProps, {
        // Typescript fix: SelectOption is not compatible with SingleOption from Select
        ref: ref,
        label: ariaLabelProp || intl.formatMessage((0, $af63372860334df1$export$2e2bcd8739ae039).searchPlaceholder),
        autoFocus: true,
        backspaceRemovesValue: false,
        blurInputOnSelect: false,
        closeMenuOnSelect: false,
        controlShouldRenderValue: false,
        hideSelectedOptions: false,
        isClearable: false,
        isMulti: true,
        inputValue: inputValue,
        menuIsOpen: true,
        menuShouldScrollIntoView: false,
        tabSelectsValue: false,
        noOptionsMessage: function noOptionsMessage() {
            return intl.formatMessage((0, $af63372860334df1$export$2e2bcd8739ae039).noOptionsMessage);
        },
        onInputChange: onInputChange,
        isOptionDisabled: $d0ececfceac96691$var$onIsOptionDisabled // Typescript fix: SelectOption is not compatible with SingleOption from Select
        ,
        filterOption: onFilterOption,
        placeholder: placeholder !== null && placeholder !== void 0 ? placeholder : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $iBNQo.default), (0, $af63372860334df1$export$2e2bcd8739ae039).searchPlaceholder)
    }));
});
$d0ececfceac96691$export$51cc13ac81e51592.displayName = 'LocalBaseSelect';



var $5FkrB = parcelRequire("5FkrB");

var $iBNQo = parcelRequire("iBNQo");


var $aRMzY = parcelRequire("aRMzY");
var $f6543b73af90bb40$export$2e2bcd8739ae039 = (0, $aRMzY.defineMessages)({
    showFullListButtonText: {
        id: 'paginated-picker.async-select.show-full-list-button.show-full-list-button-text',
        defaultMessage: 'Show full list',
        description: 'Initially we show the first few items on the list. Clicking this button will show the full list.'
    }
});


var $73d0b4daf3ac8f9d$export$bf0956d66cd7566b = function ShowFullListButton(_ref) {
    var onShowFullList = _ref.onShowFullList;
    // const { createAnalyticsEvent } = useAnalyticsEvents();
    var handleShowFullList = (0, $5FkrB.useCallback)(function() {
        // const analyticsEvent = createAnalyticsEvent({
        //   eventType: 'UI',
        //   action: 'expanded',
        //   actionSubject: 'filterSearch',
        //   actionSubjectId: 'refinementBarFilterSearch',
        // });
        //
        // const attributes: Attributes = {
        //   fieldType: type,
        // };
        //
        // fireUIAnalytics(analyticsEvent, 'refinementBarFilterSearch', attributes);
        onShowFullList();
    }, [
        onShowFullList
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $e42f2717f86c66ea$export$2e2bcd8739ae039), {
        onClick: handleShowFullList,
        appearance: "subtle-link",
        testId: "paginated-picker.ui.async-select.show-full-list-button.show-full-list-button"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $iBNQo.default), (0, $f6543b73af90bb40$export$2e2bcd8739ae039).showFullListButtonText));
};
var $73d0b4daf3ac8f9d$export$2e2bcd8739ae039 = $73d0b4daf3ac8f9d$export$bf0956d66cd7566b;


// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $090a691c3453407a$export$a06f1c675e846f6f = (0, $0b1eca56b0789a79$export$2e2bcd8739ae039).div({
    borderTop: "var(--ds-border, #ebedf0)".concat(" solid 2px"),
    paddingTop: "var(--ds-space-050, 4px)",
    paddingBottom: "var(--ds-space-050, 4px)",
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center'
});


var $e20b38a672704dfe$var$_excluded = [
    "selectOptions"
], $e20b38a672704dfe$var$_excluded2 = [
    "ariaLabel",
    "field",
    "value",
    "onChange",
    "onClear",
    "initiallyAddSelectedFirst",
    "showFooter"
];
function $e20b38a672704dfe$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $e20b38a672704dfe$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $e20b38a672704dfe$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $e20b38a672704dfe$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $e20b38a672704dfe$var$MAX_TOTAL_COUNT = 1000; // To be cleaned up in EM-3568
var $e20b38a672704dfe$var$paginatedComponents = $e20b38a672704dfe$var$_objectSpread($e20b38a672704dfe$var$_objectSpread({}, (0, $d0ececfceac96691$export$c34d65c0f5a1c617)), {}, {
    MenuList: (0, $b01729a03f54ba38$export$d4c4e98c5044dc8)
});
var $e20b38a672704dfe$var$ProxyBaseSelect = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).forwardRef(function(_ref, ref) {
    var selectOptions = _ref.selectOptions, props = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $e20b38a672704dfe$var$_excluded);
    return selectOptions ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $d0ececfceac96691$export$51cc13ac81e51592), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, props, {
        options: selectOptions,
        ref: ref
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $d0ececfceac96691$export$51cc13ac81e51592), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, props, {
        ref: ref
    }));
});
$e20b38a672704dfe$var$ProxyBaseSelect.displayName = 'ProxyBaseSelect';
var $e20b38a672704dfe$var$AsyncSelect = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).forwardRef(function(props, ref) {
    var baseSelectProps = (0, $4188c2226d921c1d$export$2e2bcd8739ae039)(props);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement($e20b38a672704dfe$var$ProxyBaseSelect, (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, props, baseSelectProps, {
        ref: ref
    }));
});
$e20b38a672704dfe$var$AsyncSelect.displayName = 'AsyncSelect';
/**
 * Adds option to the list of options if its value isn't currently in the Set of keys
 */ var $e20b38a672704dfe$var$_addUniqueOptions = function addUniqueOptions(keys, options, option) {
    if (option.optionType === 'group') {
        var groupOptions = [];
        option.options.forEach(function(groupOption) {
            $e20b38a672704dfe$var$_addUniqueOptions(keys, groupOptions, groupOption);
        });
        options.push($e20b38a672704dfe$var$_objectSpread($e20b38a672704dfe$var$_objectSpread({}, option), {}, {
            options: groupOptions
        }));
        return;
    }
    // Add single options:
    if (!keys.has(option.value)) {
        keys.add(option.value);
        options.push(option);
    }
};
var $e20b38a672704dfe$var$generateOptions = function generateOptions(selectedValues, newOptions, addSelectedFirst, previousOptions) {
    var optionKeys = new Set();
    var options = [];
    if (addSelectedFirst) selectedValues.forEach(function(option) {
        $e20b38a672704dfe$var$_addUniqueOptions(optionKeys, options, option);
    });
    previousOptions === null || previousOptions === void 0 || previousOptions.forEach(function(option) {
        $e20b38a672704dfe$var$_addUniqueOptions(optionKeys, options, option);
    });
    newOptions.forEach(function(option) {
        $e20b38a672704dfe$var$_addUniqueOptions(optionKeys, options, option);
    });
    return options;
};
var $e20b38a672704dfe$var$getLastCursorOption = function getLastCursorOption(options) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($3a70dcab3a7aadc2$exports)))(options, function(option) {
        return 'cursor' in option && !!option.cursor;
    });
};
// Needed to disable filtering from react-select
var $e20b38a672704dfe$var$noFilterOptions = function noFilterOptions() {
    return true;
};
var $e20b38a672704dfe$var$noLoadOptions = function noLoadOptions() {
    return Promise.resolve();
};
var $e20b38a672704dfe$export$54319cf8344f1691 = function countSingleOptions(options) {
    return options.map(function(option) {
        return option.optionType === 'group' ? option.options.length : 1;
    }).reduce(function(sumSoFar, count) {
        return sumSoFar + count;
    }, 0);
};
var $e20b38a672704dfe$export$fccf54b4cac6e0b3 = function PaginatedAsyncSelectView(_ref2) {
    var _field$pagination$ena, _field$pagination;
    var ariaLabel = _ref2.ariaLabel, field = _ref2.field, value = _ref2.value, onChange = _ref2.onChange, onClear = _ref2.onClear, initiallyAddSelectedFirst = _ref2.initiallyAddSelectedFirst, showFooter = _ref2.showFooter, restProps = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref2, $e20b38a672704dfe$var$_excluded2);
    var selectRef = (0, $5FkrB.useRef)(null);
    var _useState = (0, $5FkrB.useState)(0), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), page = _useState2[0], setPage = _useState2[1];
    var _useState3 = (0, $5FkrB.useState)(true), _useState4 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState3, 2), isLoading = _useState4[0], setIsLoading = _useState4[1];
    var _useState5 = (0, $5FkrB.useState)(false), _useState6 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState5, 2), isPaginationLoading = _useState6[0], setIsPaginationLoading = _useState6[1];
    var _useState7 = (0, $5FkrB.useState)(''), _useState8 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState7, 2), inputValue = _useState8[0], setInputValue = _useState8[1];
    var _useState9 = (0, $5FkrB.useState)([]), _useState0 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState9, 2), loadedOptions = _useState0[0], setLoadedOptions = _useState0[1];
    var _useState1 = (0, $5FkrB.useState)((_field$pagination$ena = (_field$pagination = field.pagination) === null || _field$pagination === void 0 ? void 0 : _field$pagination.enableFullList) !== null && _field$pagination$ena !== void 0 ? _field$pagination$ena : false), _useState10 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState1, 2), enableFullList = _useState10[0], setEnableFullList = _useState10[1];
    var _useState11 = (0, $5FkrB.useState)(null), _useState12 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState11, 2), totalCount = _useState12[0], setTotalCount = _useState12[1];
    var _useState13 = (0, $5FkrB.useState)({
        isError: false,
        error: null,
        onRetry: null
    }), _useState14 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState13, 2), error = _useState14[0], setError = _useState14[1];
    var getTotalCountWithFunctions = (0, $5FkrB.useCallback)(function(newTotalCount) {
        var _field$pagination2;
        if (newTotalCount === null || !((_field$pagination2 = field.pagination) !== null && _field$pagination2 !== void 0 && (_field$pagination2 = _field$pagination2.keywordValues) !== null && _field$pagination2 !== void 0 && _field$pagination2.length)) return newTotalCount;
        var keywordValues = field.pagination.keywordValues;
        var newTotalCountWithKeywords = newTotalCount + value.filter(function(option) {
            return keywordValues.includes(option.value);
        }).length;
        return newTotalCountWithKeywords < $e20b38a672704dfe$var$MAX_TOTAL_COUNT ? newTotalCountWithKeywords : $e20b38a672704dfe$var$MAX_TOTAL_COUNT;
    }, [
        field,
        value
    ]);
    var checkIfError = (0, $5FkrB.useCallback)(function(_search, options, onRetry) {
        if (options.some(function(option) {
            return option.optionType === 'error';
        })) {
            setError({
                isError: true,
                error: null,
                onRetry: onRetry
            });
            setIsLoading(false);
            return true;
        }
        setError({
            isError: false,
            error: null,
            onRetry: null
        });
        return false;
    }, []);
    var handleLoadOptions = (0, $5FkrB.useCallback)(function(search) {
        var loadOptions = field.loadOptions;
        if (!loadOptions) return;
        setIsLoading(true);
        loadOptions(search, enableFullList, false, false, undefined, function(_ref3) {
            var options = _ref3.options, newTotalCount = _ref3.totalCount;
            if (checkIfError(search, options, function() {
                return handleLoadOptions(search);
            })) return;
            setLoadedOptions($e20b38a672704dfe$var$generateOptions(value, options, initiallyAddSelectedFirst));
            setTotalCount(search ? newTotalCount : getTotalCountWithFunctions(newTotalCount));
            setIsLoading(false);
        });
    }, [
        field,
        enableFullList,
        checkIfError,
        value,
        initiallyAddSelectedFirst,
        getTotalCountWithFunctions
    ]);
    var handleShowMore = (0, $5FkrB.useCallback)(function() {
        var showFullList = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
        var isRetry = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        var loadOptions = field.loadOptions;
        if (!loadOptions) return;
        var originalLoadedOptions;
        if (showFullList) {
            originalLoadedOptions = [];
            setIsLoading(true);
        } else {
            originalLoadedOptions = loadedOptions;
            if (isRetry) setIsLoading(true);
            else setIsPaginationLoading(true);
        }
        loadOptions(inputValue, false, showFullList, true, $e20b38a672704dfe$var$getLastCursorOption(loadedOptions), function(_ref4) {
            var options = _ref4.options, newTotalCount = _ref4.totalCount;
            if (checkIfError(inputValue, options, function() {
                handleShowMore(showFullList, true);
            })) return;
            setPage(page + 1);
            setEnableFullList(false);
            setLoadedOptions($e20b38a672704dfe$var$generateOptions(value, options, showFullList, originalLoadedOptions));
            setTotalCount(inputValue ? newTotalCount : getTotalCountWithFunctions(newTotalCount));
            setIsPaginationLoading(false);
            setIsLoading(false);
        });
    }, [
        field,
        loadedOptions,
        inputValue,
        checkIfError,
        value,
        page,
        getTotalCountWithFunctions
    ]);
    var handleShowFullList = (0, $5FkrB.useCallback)(function() {
        handleShowMore(true, false);
    }, [
        handleShowMore
    ]);
    var handleInputChange = (0, $5FkrB.useCallback)(function(newInputValue) {
        var onInputChange = field.onInputChange;
        setEnableFullList(false);
        setPage(0);
        setInputValue(newInputValue);
        setTotalCount(null);
        setLoadedOptions([]);
        handleLoadOptions(newInputValue);
        onInputChange && onInputChange();
    }, [
        field,
        handleLoadOptions
    ]);
    var handleOnChange = (0, $5FkrB.useCallback)(function(options, action) {
        var selectData;
        if ('option' in action) {
            var actionOption = action.option;
            if (actionOption && 'value' in actionOption) selectData = {
                selectedIndex: (0, (/*@__PURE__*/$parcel$interopDefault($1099937d2cc3db76$exports)))(loadedOptions, function(option) {
                    return 'value' in option && option.value === actionOption.value;
                })
            };
        }
        onChange === null || onChange === void 0 || onChange(options, action, selectData);
    }, [
        onChange,
        loadedOptions
    ]);
    var handleClear = (0, $5FkrB.useCallback)(function() {
        onClear === null || onClear === void 0 || onClear();
        // Focus the search input after clearing
        setTimeout(function() {
            var _selectRef$current;
            (_selectRef$current = selectRef.current) === null || _selectRef$current === void 0 || _selectRef$current.focus();
        }, 0);
    }, [
        onClear
    ]);
    // We only want to call this on init, so it's ok to disable react-hooks/exhaustive-deps
    (0, $5FkrB.useEffect)(function() {
        handleLoadOptions('');
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    var loadedOptionsCount = totalCount === null ? 0 : $e20b38a672704dfe$export$54319cf8344f1691(loadedOptions);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement($e20b38a672704dfe$var$AsyncSelect, (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        ref: selectRef,
        ariaLabel: ariaLabel,
        cacheOptions: field.cacheOptions,
        components: $e20b38a672704dfe$var$paginatedComponents,
        defaultOptions: field.defaultOptions,
        defaultOptionsLabel: field.defaultOptionsLabel,
        inputValue: inputValue,
        loadOptions: $e20b38a672704dfe$var$noLoadOptions,
        onInputChange: handleInputChange,
        onMenuScrollToBottom: field.onMenuScrollToBottom,
        onMenuScrollToTop: field.onMenuScrollToTop,
        placeholder: field.placeholder,
        fieldKey: field.key,
        fieldLabel: field.label,
        fieldInvalidLabel: field.invalidLabel,
        selectOptions: loadedOptions,
        onFilterOption: $e20b38a672704dfe$var$noFilterOptions,
        menuListProps: {
            error: error,
            type: field.key,
            handleShowMore: handleShowMore,
            isLoading: isLoading,
            isPaginationLoading: isPaginationLoading,
            showShowMoreButton: totalCount !== null && loadedOptionsCount < totalCount
        },
        onChange: handleOnChange,
        value: value
    }, restProps)), (showFooter || !showFooter && !!value.length) && field.pagination && !isLoading && !!(loadedOptions !== null && loadedOptions !== void 0 && loadedOptions.length) && !error.isError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $090a691c3453407a$export$a06f1c675e846f6f), null, !value.length && enableFullList && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $73d0b4daf3ac8f9d$export$bf0956d66cd7566b), {
        type: field.key,
        onShowFullList: handleShowFullList
    }), !!value.length && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $2ae93fbe0749172b$export$1d4b7cda9e589b53), {
        onClear: handleClear,
        type: field.key
    }), showFooter && !enableFullList && totalCount !== null && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $16651c44c2d9e46d$export$33eb0288c0936a84), {
        itemsCount: loadedOptionsCount,
        totalCount: totalCount
    })));
};
var $e20b38a672704dfe$export$2e2bcd8739ae039 = $e20b38a672704dfe$export$fccf54b4cac6e0b3;



var $5FkrB = parcelRequire("5FkrB");

var $5FkrB = parcelRequire("5FkrB");
/* avatar.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $25nEq = parcelRequire("25nEq");

var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");


var $h8qvJ = parcelRequire("h8qvJ");
/* avatar-content.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $kqp0i = parcelRequire("kqp0i");

var $25nEq = parcelRequire("25nEq");

var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");

var $9Zzpd = parcelRequire("9Zzpd");

var $5FkrB = parcelRequire("5FkrB");
var $da05ad68e9bed708$export$a20dad690e1279e2 = /*#__PURE__*/ (0, $5FkrB.createContext)(undefined);
var $da05ad68e9bed708$export$b50b87a1c4086b23 = function useAvatarContext() {
    return (0, $5FkrB.useContext)($da05ad68e9bed708$export$a20dad690e1279e2);
};
var $da05ad68e9bed708$var$defaultAvatarContentProps = {
    as: 'span',
    appearance: 'circle',
    avatarImage: null,
    ref: null,
    size: 'medium'
};
var $da05ad68e9bed708$export$b983474ddd0b6d28 = /*#__PURE__*/ (0, $5FkrB.createContext)($da05ad68e9bed708$var$defaultAvatarContentProps);
var $da05ad68e9bed708$export$79d078b69b7e4842 = function useAvatarContent() {
    return (0, $5FkrB.useContext)($da05ad68e9bed708$export$b983474ddd0b6d28);
};
var $da05ad68e9bed708$export$6b4cbd90d24955ad = /*#__PURE__*/ (0, $5FkrB.createContext)(false);
var $da05ad68e9bed708$export$7db5c57474082dd9 = function useEnsureIsInsideAvatar() {
    var context = (0, $5FkrB.useContext)($da05ad68e9bed708$export$6b4cbd90d24955ad);
    if (!context) throw new Error('Avatar sub-components must be used within a Avatar component.');
};


var $70ec0cdcbb8b5cff$var$boxShadowCssVar = '--avatar-box-shadow';
var $70ec0cdcbb8b5cff$var$bgColorCssVar = '--avatar-bg-color';
var $70ec0cdcbb8b5cff$var$styles = {
    root: "_19itglyw _12ji1r31 _1qu2glyw _12y31o36 _1reo15vq _18m915vq _v564ieh6 _1e0c1txw _kqswpfqs _4cvr1fhb _1bah1h6o _2lx21bp4 _80om1kw7 _6rthv77o _1pfhv77o _12l2v77o _ahbqv77o _85i5ze3t _1q51ze3t _y4tize3t _bozgze3t _t9ec1aqe _9v7aze3t _qc5o1p41 _z0ai1osq _18postnw _1hfk1j28 _aetrf705 _1peqidpf _11fnglyw _1ejjglyw _mizu194a _1ah3v77o _ra3xnqa1 _128mdkaa _4dave4h9",
    circle: "_2rko1qll _14mj1qll",
    square: "_2rkol0p1",
    positionRelative: "_kqswh2mm",
    disabled: "_80om13gf _1hfkvuon _1peqs237"
};
var $70ec0cdcbb8b5cff$var$unboundStyles = {
    root: "_vchh1ntv _bfhkcxp3 _16qs1nhn",
    hexagonFocusContainer: "_1rjc1wgn _18zr1dm9 _1mou5h37 _bfhk1j28 _mkrz1k6g _1o9o1v1w",
    hexagonBorderContainer: "_1rjcf6hp _18zruxly _bfhkcxp3 _mkrz1kw7 _1o9ovuon",
    hexagon: "_2rkoidpf _mkrz1kw7 _16qsn7od _14mjidpf _1ejjn7od _128midpf _4davidpf",
    interactive: "_80omtlke _4tpu1g4v _ez1ykb7n _gcm1182g _eeh8kb7n _jlxit94y"
};
var $70ec0cdcbb8b5cff$var$widthHeightMap = {
    xsmall: "_1bsb7vkz _4t3i7vkz",
    small: "_1bsb1tcg _4t3i1tcg",
    medium: "_1bsbzwfg _4t3izwfg",
    large: "_1bsb1ylp _4t3i1ylp",
    xlarge: "_1bsb16xz _4t3i16xz",
    xxlarge: "_1bsb1qr7 _4t3i1qr7"
};
var $70ec0cdcbb8b5cff$var$marginAdjustmentMap = {
    xsmall: "_195gcwjc",
    small: "_195gcwjc",
    medium: "_195gs7t4",
    large: "_195gs7t4",
    xlarge: "_195g8ocb",
    xxlarge: "_195g1ukp"
};
var $70ec0cdcbb8b5cff$var$borderRadiusMap = {
    xsmall: "_2rkolb4i _14mjlb4i",
    small: "_2rkolb4i _14mjlb4i",
    medium: "_2rko12b0 _14mj12b0",
    large: "_2rko12b0 _14mj12b0",
    xlarge: "_2rko1qi0 _14mj1qi0",
    xxlarge: "_2rkopb1k _14mjpb1k"
};
var $70ec0cdcbb8b5cff$export$47fbc0b44cae5559 = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function(_ref, ref) {
    var children = _ref.children;
    (0, $da05ad68e9bed708$export$7db5c57474082dd9)();
    var _useAvatarContent = (0, $da05ad68e9bed708$export$79d078b69b7e4842)(), Container = _useAvatarContent.as, appearance = _useAvatarContent.appearance, avatarImage = _useAvatarContent.avatarImage, _useAvatarContent$bor = _useAvatarContent.borderColor, borderColor = _useAvatarContent$bor === void 0 ? "var(--ds-surface, #FFFFFF)" : _useAvatarContent$bor, href = _useAvatarContent.href, isDisabled = _useAvatarContent.isDisabled, label = _useAvatarContent.label, onClick = _useAvatarContent.onClick, contextRef = _useAvatarContent.ref, tabIndex = _useAvatarContent.tabIndex, target = _useAvatarContent.target, testId = _useAvatarContent.testId, size = _useAvatarContent.size, stackIndex = _useAvatarContent.stackIndex;
    var isInteractive = Boolean(onClick || href || isDisabled);
    var renderedContent = /*#__PURE__*/ $5FkrB.createElement(Container, (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        style: (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, $70ec0cdcbb8b5cff$var$bgColorCssVar, borderColor), $70ec0cdcbb8b5cff$var$boxShadowCssVar, "0 0 0 2px ".concat(borderColor)),
        ref: ref || contextRef,
        "aria-label": isInteractive ? label : undefined,
        onClick: onClick,
        tabIndex: tabIndex,
        "data-testid": testId,
        disabled: isDisabled,
        type: Container === 'button' ? 'button' : undefined
    }, href && {
        href: href,
        target: target,
        rel: target === '_blank' ? 'noopener noreferrer' : undefined
    }, {
        className: (0, $970q7.default)([
            $70ec0cdcbb8b5cff$var$unboundStyles.root,
            $70ec0cdcbb8b5cff$var$styles.root,
            !(0, $9Zzpd.fg)('platform_dst_avatar_tile') && !(0, $9Zzpd.fg)('platform_dst_avatar_tile_stage2') && $70ec0cdcbb8b5cff$var$borderRadiusMap[size],
            appearance === 'square' && ((0, $9Zzpd.fg)('platform_dst_avatar_tile') || (0, $9Zzpd.fg)('platform_dst_avatar_tile_stage2')) && $70ec0cdcbb8b5cff$var$styles.square,
            appearance === 'circle' && $70ec0cdcbb8b5cff$var$styles.circle,
            appearance === 'hexagon' && $70ec0cdcbb8b5cff$var$unboundStyles.hexagon,
            $70ec0cdcbb8b5cff$var$widthHeightMap[size],
            stackIndex !== undefined && $70ec0cdcbb8b5cff$var$styles.positionRelative,
            isInteractive && !isDisabled && $70ec0cdcbb8b5cff$var$unboundStyles.interactive,
            isDisabled && $70ec0cdcbb8b5cff$var$styles.disabled
        ])
    }), children || avatarImage);
    if (appearance !== 'hexagon') return renderedContent;
    // For a Hexagon Avatar in order to have hexagonal "border" and "outline", we have to
    // layer multiple elements and use their background colors to create the different layers.
    return /*#__PURE__*/ $5FkrB.createElement("div", {
        style: (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, $70ec0cdcbb8b5cff$var$bgColorCssVar, borderColor), $70ec0cdcbb8b5cff$var$boxShadowCssVar, "0 0 0 2px ".concat(borderColor)),
        "data-testid": testId ? "".concat(testId, "-hexagon-focus-container") : 'hexagon-focus-container',
        className: (0, $970q7.default)([
            $70ec0cdcbb8b5cff$var$unboundStyles.hexagonFocusContainer,
            $70ec0cdcbb8b5cff$var$marginAdjustmentMap[size]
        ])
    }, /*#__PURE__*/ $5FkrB.createElement("div", {
        "data-testid": testId ? "".concat(testId, "-hexagon-border-container") : 'hexagon-border-container',
        className: (0, $970q7.default)([
            $70ec0cdcbb8b5cff$var$unboundStyles.hexagonBorderContainer
        ])
    }, renderedContent));
});



/* avatar-image.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");
var $b2c5d688abfa1436$exports = {};
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e079be55658218810235742dfafa5bd4>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty($b2c5d688abfa1436$exports, "__esModule", {
    value: true
});
$b2c5d688abfa1436$exports.default = void 0;

var $b2c5d688abfa1436$var$_react = $b2c5d688abfa1436$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $b2c5d688abfa1436$var$_baseNew = $b2c5d688abfa1436$var$_interopRequireDefault((parcelRequire("eRJCC")));
function $b2c5d688abfa1436$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "AiAgent".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for Rovo Agent.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $b2c5d688abfa1436$var$AiAgentIcon = (props)=>/*#__PURE__*/ $b2c5d688abfa1436$var$_react.default.createElement($b2c5d688abfa1436$var$_baseNew.default, Object.assign({
        name: "AiAgentIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6.971.493a2 2 0 0 1 2.058 0l5 3A2 2 0 0 1 15 5.208v5.584a2 2 0 0 1-.971 1.715l-5 3a2 2 0 0 1-2.058 0l-5-3A2 2 0 0 1 1 10.792V5.208a2 2 0 0 1 .971-1.715zm1.286 1.286a.5.5 0 0 0-.514 0l-5 3a.5.5 0 0 0-.243.429v5.584a.5.5 0 0 0 .243.429l1.098.66a4.25 4.25 0 1 1 8.318 0l1.098-.66a.5.5 0 0 0 .243-.429V5.208a.5.5 0 0 0-.243-.429zM8 8.25a2.75 2.75 0 1 0 0 5.5 2.75 2.75 0 0 0 0-5.5" clip-rule="evenodd"/>`
    }, props));
$b2c5d688abfa1436$var$AiAgentIcon.displayName = 'AiAgentIcon';
var $b2c5d688abfa1436$var$_default = $b2c5d688abfa1436$exports.default = $b2c5d688abfa1436$var$AiAgentIcon;


var $b43819700d91cdd4$exports = {};
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::fc4353a18034f564a0b3573d4163ea60>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty($b43819700d91cdd4$exports, "__esModule", {
    value: true
});
$b43819700d91cdd4$exports.default = void 0;

var $b43819700d91cdd4$var$_react = $b43819700d91cdd4$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $b43819700d91cdd4$var$_baseNew = $b43819700d91cdd4$var$_interopRequireDefault((parcelRequire("eRJCC")));
function $b43819700d91cdd4$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Person".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Known uses: representing a person or user, owner, contributor.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $b43819700d91cdd4$var$PersonIcon = (props)=>/*#__PURE__*/ $b43819700d91cdd4$var$_react.default.createElement($b43819700d91cdd4$var$_baseNew.default, Object.assign({
        name: "PersonIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 1.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5M4 4a4 4 0 1 1 8 0 4 4 0 0 1-8 0m-2 9a3.75 3.75 0 0 1 3.75-3.75h4.5A3.75 3.75 0 0 1 14 13v2h-1.5v-2a2.25 2.25 0 0 0-2.25-2.25h-4.5A2.25 2.25 0 0 0 3.5 13v2H2z" clip-rule="evenodd"/>`
    }, props));
$b43819700d91cdd4$var$PersonIcon.displayName = 'PersonIcon';
var $b43819700d91cdd4$var$_default = $b43819700d91cdd4$exports.default = $b43819700d91cdd4$var$PersonIcon;


var $e9f7b72a76b28c94$exports = {};
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b5b008ccfed50bccf7a8bb78b89f8a48>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty($e9f7b72a76b28c94$exports, "__esModule", {
    value: true
});
$e9f7b72a76b28c94$exports.default = void 0;

var $e9f7b72a76b28c94$var$_react = $e9f7b72a76b28c94$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $e9f7b72a76b28c94$var$_baseNew = $e9f7b72a76b28c94$var$_interopRequireDefault((parcelRequire("eRJCC")));
function $e9f7b72a76b28c94$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Release".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for releases in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $e9f7b72a76b28c94$var$ReleaseIcon = (props)=>/*#__PURE__*/ $e9f7b72a76b28c94$var$_react.default.createElement($e9f7b72a76b28c94$var$_baseNew.default, Object.assign({
        name: "ReleaseIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M4 2h3v2h2a.75.75 0 0 1 .648.372L11.18 7h4.069a.75.75 0 0 1 .646 1.132l-2.887 4.886a2 2 0 0 1-1.722.982H2a2 2 0 0 1-2-2V7.75A.75.75 0 0 1 .75 7H2V4.75A.75.75 0 0 1 2.75 4H4zm-.5 5h5.944L8.57 5.5H3.5zm-2 1.5V12a.5.5 0 0 0 .5.5h9.287a.5.5 0 0 0 .43-.246L13.936 8.5z" clip-rule="evenodd"/>`
    }, props));
$e9f7b72a76b28c94$var$ReleaseIcon.displayName = 'ReleaseIcon';
var $e9f7b72a76b28c94$var$_default = $e9f7b72a76b28c94$exports.default = $e9f7b72a76b28c94$var$ReleaseIcon;


var $1786182c2881e173$var$styles = {
    image: "_16jlkb7n _1o9zkb7n _i0dl1osq _1e0c1txw _1bsb1osq _4t3i1osq",
    icon: "_1e0c1txw _1bsb1osq _4t3i1osq _bfhk7qp0",
    circle: "_2rko1rr0",
    hexagon: "_mkrz1k6g"
};
var $1786182c2881e173$var$borderRadiusMap = {
    xsmall: "_2rkolb4i",
    small: "_2rkolb4i",
    medium: "_2rko12b0",
    large: "_2rko12b0",
    xlarge: "_2rko1qi0",
    xxlarge: "_2rkopb1k"
};
var $1786182c2881e173$var$nestedSvgStylesMap = {
    xsmall: "_w8l57vkz _17527vkz",
    small: "_w8l51tcg _17521tcg",
    medium: "_w8l5zwfg _1752zwfg",
    large: "_w8l51ylp _17521ylp",
    xlarge: "_w8l516xz _175216xz",
    xxlarge: "_w8l51qr7 _17521qr7"
};
/**
 * __Avatar image__
 *
 * An avatar image is an internal component used to control the rendering phases of an image.
 */ var $1786182c2881e173$var$AvatarImage = function AvatarImage(_ref) {
    var _ref$alt = _ref.alt, alt = _ref$alt === void 0 ? '' : _ref$alt, src = _ref.src, appearance = _ref.appearance, size = _ref.size, testId = _ref.testId, imgLoading = _ref.imgLoading;
    var _useState = (0, $5FkrB.useState)(false), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), hasImageErrored = _useState2[0], setHasImageErrored = _useState2[1];
    // If src changes, reset state
    (0, $5FkrB.useEffect)(function() {
        setHasImageErrored(false);
    }, [
        src
    ]);
    if (!src || hasImageErrored) {
        var renderedIcon;
        switch(appearance){
            case 'circle':
                renderedIcon = /*#__PURE__*/ $5FkrB.createElement((0, (/*@__PURE__*/$parcel$interopDefault($b43819700d91cdd4$exports))), {
                    label: alt,
                    color: "var(--ds-icon-subtle, #505258)",
                    testId: testId && "".concat(testId, "--person"),
                    spacing: "spacious"
                });
                break;
            case 'hexagon':
                renderedIcon = /*#__PURE__*/ $5FkrB.createElement((0, (/*@__PURE__*/$parcel$interopDefault($b2c5d688abfa1436$exports))), {
                    label: alt,
                    color: "var(--ds-icon-subtle, #505258)",
                    testId: testId && "".concat(testId, "--agent"),
                    spacing: "spacious"
                });
                break;
            default:
            case 'square':
                renderedIcon = /*#__PURE__*/ $5FkrB.createElement((0, (/*@__PURE__*/$parcel$interopDefault($e9f7b72a76b28c94$exports))), {
                    label: alt,
                    color: "var(--ds-icon-subtle, #505258)",
                    testId: testId && "".concat(testId, "--ship"),
                    spacing: "spacious"
                });
                break;
        }
        return /*#__PURE__*/ $5FkrB.createElement("span", {
            className: (0, $970q7.default)([
                $1786182c2881e173$var$styles.icon,
                $1786182c2881e173$var$nestedSvgStylesMap[size]
            ])
        }, renderedIcon);
    }
    return /*#__PURE__*/ $5FkrB.createElement("img", {
        loading: imgLoading,
        src: src,
        alt: alt,
        "data-testid": testId && "".concat(testId, "--image"),
        onError: function onError() {
            return setHasImageErrored(true);
        },
        "aria-hidden": !alt ? true : undefined,
        "data-vc": testId ? "".concat(testId, "--image") : 'avatar-image',
        "data-ssr-placeholder-ignored": true,
        className: (0, $970q7.default)([
            $1786182c2881e173$var$styles.image,
            $1786182c2881e173$var$borderRadiusMap[size],
            appearance === 'circle' && $1786182c2881e173$var$styles.circle,
            appearance === 'hexagon' && $1786182c2881e173$var$styles.hexagon
        ])
    });
};
var $1786182c2881e173$export$2e2bcd8739ae039 = $1786182c2881e173$var$AvatarImage;


/* presence.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");

/* icon-wrapper.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");
var $a80cdb3d191b6b22$var$styles = {
    root: "_2rko1qll _1reo15vq _18m915vq _189e1dm9 _1dqonqa1 _1e0c1txw _vchhusvi _1bsb1osq _4t3i1osq _4cvr1h6o _ae4v1h6o _bfhk1bhr"
};
var $a80cdb3d191b6b22$var$unboundStyles = {
    root: "_1h6d1bhr"
};
/**
 * __Icon wrapper__
 *
 * An icon wrapper is used internally only.
 */ var $a80cdb3d191b6b22$var$IconWrapper = function IconWrapper(_ref) {
    var bgColor = _ref.bgColor, children = _ref.children;
    return /*#__PURE__*/ $5FkrB.createElement("span", {
        role: "presentation",
        style: {
            borderColor: bgColor,
            backgroundColor: bgColor
        },
        className: (0, $970q7.default)([
            $a80cdb3d191b6b22$var$styles.root,
            $a80cdb3d191b6b22$var$unboundStyles.root
        ])
    }, children);
};
var $a80cdb3d191b6b22$export$2e2bcd8739ae039 = $a80cdb3d191b6b22$var$IconWrapper;


var $37285f37c4138e85$var$BusyIndicator = /*#__PURE__*/ $5FkrB.createElement((0, $5FkrB.Fragment), null, /*#__PURE__*/ $5FkrB.createElement("circle", {
    fill: "var(--ds-icon-danger, ".concat((0, $84873b2431594582$export$4a7404f376229999), ")"),
    cx: "4",
    cy: "4",
    r: "4"
}), /*#__PURE__*/ $5FkrB.createElement("path", {
    fill: "var(--ds-surface-overlay, ".concat((0, $84873b2431594582$export$29a4f05edc054374), ")"),
    d: "M3.3,1.9l2.8,2.8c0.2,0.2,0.2,0.5,0,0.7L5.4,6.1c-0.2,0.2-0.5,0.2-0.7,0L1.9,3.3c-0.2-0.2-0.2-0.5,0-0.7l0.7-0.7C2.8,1.7,3.1,1.7,3.3,1.9z"
}));
var $37285f37c4138e85$var$FocusIndicator = /*#__PURE__*/ $5FkrB.createElement((0, $5FkrB.Fragment), null, /*#__PURE__*/ $5FkrB.createElement("path", {
    fill: "var(--ds-icon-discovery, ".concat((0, $84873b2431594582$export$b48405b95304b5a1), ")"),
    d: "M4,8 C1.790861,8 0,6.209139 0,4 C0,1.790861 1.790861,0 4,0 C6.209139,0 8,1.790861 8,4 C8,6.209139 6.209139,8 4,8 Z M4,6.66666667 C5.47275933,6.66666667 6.66666667,5.47275933 6.66666667,4 C6.66666667,2.52724067 5.47275933,1.33333333 4,1.33333333 C2.52724067,1.33333333 1.33333333,2.52724067 1.33333333,4 C1.33333333,5.47275933 2.52724067,6.66666667 4,6.66666667 Z M4,5.33333333 C3.26362033,5.33333333 2.66666667,4.73637967 2.66666667,4 C2.66666667,3.26362033 3.26362033,2.66666667 4,2.66666667 C4.73637967,2.66666667 5.33333333,3.26362033 5.33333333,4 C5.33333333,4.73637967 4.73637967,5.33333333 4,5.33333333 Z"
}));
var $37285f37c4138e85$var$OfflineIndicator = /*#__PURE__*/ $5FkrB.createElement((0, $5FkrB.Fragment), null, /*#__PURE__*/ $5FkrB.createElement("path", {
    fill: "var(--ds-text-subtlest, ".concat((0, $84873b2431594582$export$f563ee71e9ee74cd), ")"),
    d: "M4,8 C6.209139,8 8,6.209139 8,4 C8,1.790861 6.209139,0 4,0 C1.790861,0 0,1.790861 0,4 C0,6.209139 1.790861,8 4,8 Z M4,6 C5.1045695,6 6,5.1045695 6,4 C6,2.8954305 5.1045695,2 4,2 C2.8954305,2 2,2.8954305 2,4 C2,5.1045695 2.8954305,6 4,6 Z"
}), /*#__PURE__*/ $5FkrB.createElement("path", {
    fill: "var(--ds-surface-overlay, ".concat((0, $84873b2431594582$export$1ce2d1575d444ceb), ")"),
    d: "M4,6 C5.1045695,6 6,5.1045695 6,4 C6,2.8954305 5.1045695,2 4,2 C2.8954305,2 2,2.8954305 2,4 C2,5.1045695 2.8954305,6 4,6 Z"
}));
var $37285f37c4138e85$var$OnlineIndicator = /*#__PURE__*/ $5FkrB.createElement("circle", {
    fill: "var(--ds-icon-success, ".concat((0, $84873b2431594582$export$940e1f69e873f202), ")"),
    cx: "4",
    cy: "4",
    r: "4"
});
function $37285f37c4138e85$var$getPresence(presence) {
    switch(presence){
        case 'busy':
            return $37285f37c4138e85$var$BusyIndicator;
        case 'focus':
            return $37285f37c4138e85$var$FocusIndicator;
        case 'offline':
            return $37285f37c4138e85$var$OfflineIndicator;
        case 'online':
            return $37285f37c4138e85$var$OnlineIndicator;
    }
}
/**
 * __Avatar presence__
 *
 * A presence shows an avatar’s availability.
 *
 * - [Examples](https://atlassian.design/components/avatar/avatar-presence/examples)
 * - [Code](https://atlassian.design/components/avatar/avatar-presence/code)
 * - [Usage](https://atlassian.design/components/avatar/avatar-presence/usage)
 */ var $37285f37c4138e85$var$AvatarPresence = function AvatarPresence(_ref) {
    var borderColor = _ref.borderColor, children = _ref.children, presence = _ref.presence;
    return /*#__PURE__*/ $5FkrB.createElement((0, $a80cdb3d191b6b22$export$2e2bcd8739ae039), {
        bgColor: borderColor
    }, presence ? /*#__PURE__*/ $5FkrB.createElement("svg", {
        height: "100%",
        version: "1.1",
        viewBox: "0 0 8 8",
        width: "100%",
        xmlns: "http://www.w3.org/2000/svg"
    }, $37285f37c4138e85$var$getPresence(presence)) : children);
};
var $37285f37c4138e85$export$2e2bcd8739ae039 = $37285f37c4138e85$var$AvatarPresence;
var $37285f37c4138e85$var$styles = {
    root: "_kqswstnw _lcxvglyw"
};
var $37285f37c4138e85$var$iconSizeMap = {
    small: "_4t3i1crf _1bsb1crf",
    medium: "_4t3idlk8 _1bsbdlk8",
    large: "_4t3io7ao _1bsbo7ao",
    xlarge: "_4t3if6fq _1bsbf6fq"
};
var $37285f37c4138e85$var$circleIconOffsetMap = {
    small: "_94n5idpf _1xi2idpf",
    medium: "_94n5idpf _1xi2idpf",
    large: "_94n5t94y _1xi2t94y",
    xlarge: "_94n51v6z _1xi21v6z"
};
var $37285f37c4138e85$var$squareIconOffsetMap = {
    root: "_94n5myb0 _1xi2myb0"
};
var $37285f37c4138e85$var$hexagonIconOffsetMap = {
    small: "_94n51n1a _1xi21n1a",
    medium: "_94n51n1a _1xi21n1a",
    large: "_94n51y44 _1xi2myb0",
    xlarge: "_94n5l52n _1xi21lpd"
};
var $37285f37c4138e85$export$972c5e90200fa0ef = function PresenceWrapper(_ref2) {
    var size = _ref2.size, appearance = _ref2.appearance, children = _ref2.children, borderColor = _ref2.borderColor, presence = _ref2.presence, testId = _ref2.testId;
    return /*#__PURE__*/ $5FkrB.createElement("span", {
        "aria-hidden": "true",
        "data-testid": testId && "".concat(testId, "--presence"),
        className: (0, $970q7.default)([
            $37285f37c4138e85$var$styles.root,
            $37285f37c4138e85$var$iconSizeMap[size],
            $37285f37c4138e85$var$circleIconOffsetMap[size],
            appearance === 'square' && $37285f37c4138e85$var$squareIconOffsetMap.root,
            appearance === 'hexagon' && $37285f37c4138e85$var$hexagonIconOffsetMap[size]
        ])
    }, /*#__PURE__*/ $5FkrB.createElement($37285f37c4138e85$var$AvatarPresence, {
        borderColor: borderColor,
        presence: !children ? presence : undefined
    }, children));
};


/* status.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");


var $a605c8d56fb38146$var$styles = {
    root: "_kqswstnw"
};
var $a605c8d56fb38146$var$iconSizeMap = {
    small: "_4t3i1crf _1bsb1crf",
    medium: "_4t3idlk8 _1bsbdlk8",
    large: "_4t3io7ao _1bsbo7ao",
    xlarge: "_4t3if6fq _1bsbf6fq"
};
var $a605c8d56fb38146$var$circleIconOffsetMap = {
    small: "_rjxpidpf _152tidpf",
    medium: "_rjxpidpf _152tidpf",
    large: "_rjxpt94y _152tt94y",
    xlarge: "_rjxp1v6z _152t1v6z"
};
var $a605c8d56fb38146$var$squareIconOffsetMap = {
    root: "_rjxpidpf _152tidpf"
};
var $a605c8d56fb38146$var$hexagonIconOffsetMap = {
    small: "_rjxp1n1a _152t1n1a",
    medium: "_rjxp1n1a _152t1n1a",
    large: "_rjxpmyb0 _152t1y44",
    xlarge: "_rjxp1lpd _152tl52n"
};
var $a605c8d56fb38146$var$ApprovedIndicator = /*#__PURE__*/ $5FkrB.createElement((0, $5FkrB.Fragment), null, /*#__PURE__*/ $5FkrB.createElement("circle", {
    fill: "var(--ds-icon-success, ".concat((0, $84873b2431594582$export$a49394138f7b8e85), ")"),
    cx: "4",
    cy: "4",
    r: "4"
}), /*#__PURE__*/ $5FkrB.createElement("path", {
    fill: "var(--ds-surface-overlay, ".concat((0, $84873b2431594582$export$29a4f05edc054374), ")"),
    d: "M2.47140452,3.52859548 C2.21105499,3.26824595 1.78894501,3.26824595 1.52859548,3.52859548 C1.26824595,3.78894501 1.26824595,4.21105499 1.52859548,4.47140452 L2.86192881,5.80473785 C3.12227834,6.06508738 3.54438833,6.06508738 3.80473785,5.80473785 L6.47140452,3.13807119 C6.73175405,2.87772166 6.73175405,2.45561167 6.47140452,2.19526215 C6.21105499,1.93491262 5.78894501,1.93491262 5.52859548,2.19526215 L3.33333333,4.39052429 L2.47140452,3.52859548 Z"
}));
var $a605c8d56fb38146$var$DeclinedIndicator = /*#__PURE__*/ $5FkrB.createElement((0, $5FkrB.Fragment), null, /*#__PURE__*/ $5FkrB.createElement("circle", {
    fill: "var(--ds-icon-danger, ".concat((0, $84873b2431594582$export$2010d0fb4295b346), ")"),
    cx: "4",
    cy: "4",
    r: "4"
}), /*#__PURE__*/ $5FkrB.createElement("path", {
    fill: "var(--ds-surface-overlay, ".concat((0, $84873b2431594582$export$29a4f05edc054374), ")"),
    d: "M4.890661,4.0088336 L5.81806461,3.07802178 C6.06167933,2.83351177 6.06048933,2.43826992 5.81540668,2.19522442 C5.57032402,1.95217891 5.17415651,1.95336612 4.93054179,2.19787613 L4.00765946,3.12415007 L3.06906871,2.18377143 C2.82523777,1.93947602 2.42906937,1.93863765 2.18420182,2.18189887 C1.93933427,2.42516008 1.93849394,2.82040282 2.18232488,3.06469822 L3.12544091,4.00961077 L2.20275024,4.93569234 C1.95913552,5.18020236 1.96032551,5.5754442 2.20540817,5.81848971 C2.45049083,6.06153521 2.84665833,6.060348 3.09027306,5.81583799 L4.00844245,4.89429431 L4.9092123,5.79678001 C5.15304324,6.04107541 5.54921164,6.04191379 5.79407919,5.79865257 C6.03894674,5.55539135 6.03978708,5.16014862 5.79595614,4.91585321 L4.890661,4.0088336 Z"
}));
var $a605c8d56fb38146$var$LockedIndicator = /*#__PURE__*/ $5FkrB.createElement((0, $5FkrB.Fragment), null, /*#__PURE__*/ $5FkrB.createElement("circle", {
    fill: "var(--ds-text-subtlest, ".concat((0, $84873b2431594582$export$1ce2d1575d444ceb), ")"),
    cx: "4",
    cy: "4",
    r: "4"
}), /*#__PURE__*/ $5FkrB.createElement("path", {
    fill: "var(--ds-surface-overlay, ".concat((0, $84873b2431594582$export$c39c0fe0f26207ae), ")"),
    d: "M4.13074827,1.21766493 L4.10368158,1.21766493 C3.36340745,1.21766493 2.76388015,1.80793503 2.76388015,2.5367787 L2.76388015,3.21632216 L3.44054754,3.21632216 L3.44054754,2.54344089 C3.44054754,2.17901906 3.74031119,1.88388401 4.11044825,1.88388401 L4.1239816,1.88388401 C4.49411866,1.88388401 4.79388232,2.17901906 4.79388232,2.54344089 L4.79388232,3.21632216 L5.47054971,3.21632216 L5.47054971,2.5367787 C5.47054971,1.80793503 4.8710224,1.21766493 4.13074827,1.21766493 M2.76388015,3.21632216 L3.44054754,3.21632216 L3.44054754,3.88254123 L2.76388015,3.88254123 L2.76388015,3.21632216 Z M4.79388232,3.21632216 L5.47054971,3.21632216 L5.47054971,3.88254123 L4.79388232,3.88254123 L4.79388232,3.21632216 Z M4.79401765,3.88254123 L3.44068287,3.88254123 L2.76401548,3.88254123 C2.39049508,3.88254123 2.08734809,4.18100738 2.08734809,4.54876031 L2.08734809,5.54808892 C2.08734809,6.10000287 2.53735205,6.54741753 3.09094491,6.54741753 L5.14375561,6.54741753 C5.69802683,6.54741753 6.14735243,6.10385072 6.14735243,5.54808892 L6.14735243,4.54876031 C6.14735243,4.18100738 5.84420544,3.88254123 5.47068504,3.88254123 L4.79401765,3.88254123 Z"
}));
function $a605c8d56fb38146$var$getStatus(status) {
    switch(status){
        case 'approved':
            return $a605c8d56fb38146$var$ApprovedIndicator;
        case 'declined':
            return $a605c8d56fb38146$var$DeclinedIndicator;
        case 'locked':
            return $a605c8d56fb38146$var$LockedIndicator;
    }
}
/**
 * __Avatar status__
 *
 * An avatar status shows contextual information, such as if someone approves or declines something.
 *
 * - [Examples](https://atlassian.design/components/avatar/avatar-status/examples)
 * - [Code](https://atlassian.design/components/avatar/avatar-status/code)
 */ var $a605c8d56fb38146$var$AvatarStatus = function AvatarStatus(_ref) {
    var borderColor = _ref.borderColor, children = _ref.children, status = _ref.status;
    return /*#__PURE__*/ $5FkrB.createElement((0, $a80cdb3d191b6b22$export$2e2bcd8739ae039), {
        bgColor: borderColor
    }, status ? /*#__PURE__*/ $5FkrB.createElement("svg", {
        height: "100%",
        version: "1.1",
        viewBox: "0 0 8 8",
        width: "100%",
        xmlns: "http://www.w3.org/2000/svg"
    }, $a605c8d56fb38146$var$getStatus(status)) : children);
};
var $a605c8d56fb38146$export$2e2bcd8739ae039 = $a605c8d56fb38146$var$AvatarStatus;
var $a605c8d56fb38146$export$8045894f255f9726 = function StatusWrapper(_ref2) {
    var size = _ref2.size, status = _ref2.status, appearance = _ref2.appearance, borderColor = _ref2.borderColor, children = _ref2.children, testId = _ref2.testId;
    return /*#__PURE__*/ $5FkrB.createElement("span", {
        "aria-hidden": "true",
        "data-testid": testId && "".concat(testId, "--status"),
        className: (0, $970q7.default)([
            $a605c8d56fb38146$var$styles.root,
            $a605c8d56fb38146$var$iconSizeMap[size],
            $a605c8d56fb38146$var$circleIconOffsetMap[size],
            appearance === 'square' && $a605c8d56fb38146$var$squareIconOffsetMap.root,
            appearance === 'hexagon' && $a605c8d56fb38146$var$hexagonIconOffsetMap[size]
        ])
    }, /*#__PURE__*/ $5FkrB.createElement($a605c8d56fb38146$var$AvatarStatus, {
        borderColor: borderColor,
        status: !children ? status : undefined
    }, children));
};


var $e19b4ad6a6642f58$export$83ee468102cdf04c = function getCustomElement(isDisabled, href, onClick) {
    if (href && !isDisabled) return 'a';
    if (onClick || isDisabled) return 'button';
    return 'span';
};
function $e19b4ad6a6642f58$export$6b45b5bd2259198a(appType) {
    switch(appType){
        case 'agent':
            return 'hexagon';
        case 'user':
        case 'system':
        default:
            return 'circle';
    }
}


function $bfbca0303486f365$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $bfbca0303486f365$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $bfbca0303486f365$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $bfbca0303486f365$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $bfbca0303486f365$var$packageName = "@atlaskit/avatar";
var $bfbca0303486f365$var$packageVersion = "25.7.1";
var $bfbca0303486f365$var$containerStyles = null;
// eslint-disable-next-line @repo/internal/react/consistent-types-definitions
/**
 * __Avatar__
 *
 * An avatar is a visual representation of a user or entity.
 *
 * - [Examples](https://atlassian.design/components/avatar/examples)
 * - [Code](https://atlassian.design/components/avatar/code)
 * - [Usage](https://atlassian.design/components/avatar/usage)
 */ var $bfbca0303486f365$var$Avatar = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function(_ref, ref) {
    var analyticsContext = _ref.analyticsContext, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'circle' : _ref$appearance, label = _ref.label, borderColor = _ref.borderColor, children = _ref.children, href = _ref.href, isDisabled = _ref.isDisabled, name = _ref.name, onClick = _ref.onClick, presence = _ref.presence, sizeProp = _ref.size, src = _ref.src, stackIndex = _ref.stackIndex, status = _ref.status, target = _ref.target, testId = _ref.testId, _ref$as = _ref.as, AvatarContainer = _ref$as === void 0 ? 'div' : _ref$as, _ref$isDecorative = _ref.isDecorative, isDecorative = _ref$isDecorative === void 0 ? false : _ref$isDecorative, imgLoading = _ref.imgLoading;
    var _useAnalyticsEvents = (0, $46fdcdf47a9cc549$export$5bf35293e545f20c)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
    var context = (0, $da05ad68e9bed708$export$b50b87a1c4086b23)();
    var size = sizeProp || (context === null || context === void 0 ? void 0 : context.size) || 'medium';
    var customPresenceNode = /*#__PURE__*/ (0, $5FkrB.isValidElement)(presence) ? presence : null;
    var customStatusNode = /*#__PURE__*/ (0, $5FkrB.isValidElement)(status) ? status : null;
    var isValidIconSize = size !== 'xxlarge' && size !== 'xsmall';
    var lastAnalytics = (0, $5FkrB.useRef)(analyticsContext);
    var labelId = (0, $h8qvJ.useId)();
    (0, $5FkrB.useEffect)(function() {
        lastAnalytics.current = analyticsContext;
    }, [
        analyticsContext
    ]);
    var onClickHandler = (0, $5FkrB.useCallback)(function(event) {
        if (isDisabled || typeof onClick !== 'function') return;
        var analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'avatar',
            attributes: {
                componentName: 'avatar',
                packageName: $bfbca0303486f365$var$packageName,
                packageVersion: $bfbca0303486f365$var$packageVersion
            }
        });
        /**
     * To avoid wrapping this component in AnalyticsContext we manually
     * push the parent context's meta data into the context.
     */ var context = $bfbca0303486f365$var$_objectSpread({
            componentName: 'avatar',
            packageName: $bfbca0303486f365$var$packageName,
            packageVersion: $bfbca0303486f365$var$packageVersion
        }, lastAnalytics.current);
        analyticsEvent.context.push(context);
        /**
     * Replicating the logic in the `withAnalyticsEvents` HOC.
     */ var clone = analyticsEvent.clone();
        if (clone) clone.fire('atlaskit');
        onClick(event, analyticsEvent);
    }, [
        createAnalyticsEvent,
        isDisabled,
        onClick
    ]);
    var isPresence = isValidIconSize && presence && !status;
    var isStatus = isValidIconSize && status;
    // add presence or status to the label by default if presence and status are passed as a string
    // if status or presence are nodes this is not added to the label by default
    var defaultLabel = [
        name,
        isStatus && !customStatusNode && "(".concat(status, ")"),
        isPresence && !customPresenceNode && "(".concat(presence, ")")
    ].filter(Boolean).join(' ');
    var isInteractive = onClick || href || isDisabled;
    var containerShouldBeImage = Boolean(!isInteractive && defaultLabel);
    return /*#__PURE__*/ $5FkrB.createElement((0, $da05ad68e9bed708$export$6b4cbd90d24955ad).Provider, {
        value: true
    }, /*#__PURE__*/ $5FkrB.createElement(AvatarContainer, {
        "data-testid": testId,
        role: containerShouldBeImage ? 'img' : undefined,
        "aria-labelledby": containerShouldBeImage && !isDecorative ? labelId : undefined,
        style: {
            zIndex: stackIndex
        },
        className: (0, $970q7.default)([
            "_12ji1r31 _1qu2glyw _12y3idpf _1e0c1o8l _kqswh2mm"
        ])
    }, /*#__PURE__*/ $5FkrB.createElement((0, $da05ad68e9bed708$export$b983474ddd0b6d28).Provider, {
        value: {
            as: (0, $e19b4ad6a6642f58$export$83ee468102cdf04c)(isDisabled, href, onClick),
            appearance: appearance,
            borderColor: borderColor,
            href: href,
            isDisabled: isDisabled,
            label: label || defaultLabel,
            onClick: isInteractive ? onClickHandler : undefined,
            ref: ref,
            size: size,
            stackIndex: stackIndex,
            target: target,
            testId: testId ? "".concat(testId, "--inner") : undefined,
            avatarImage: /*#__PURE__*/ $5FkrB.createElement((0, $1786182c2881e173$export$2e2bcd8739ae039), {
                alt: !containerShouldBeImage && src ? name : undefined,
                src: src,
                appearance: appearance,
                size: size,
                testId: testId,
                imgLoading: imgLoading
            })
        }
    }, children || /*#__PURE__*/ $5FkrB.createElement((0, $70ec0cdcbb8b5cff$export$47fbc0b44cae5559), null)), isPresence && /*#__PURE__*/ $5FkrB.createElement((0, $37285f37c4138e85$export$972c5e90200fa0ef), {
        appearance: appearance,
        size: size,
        presence: typeof presence === 'string' ? presence : undefined,
        testId: testId
    }, customPresenceNode), isStatus && /*#__PURE__*/ $5FkrB.createElement((0, $a605c8d56fb38146$export$8045894f255f9726), {
        appearance: appearance,
        size: size,
        borderColor: borderColor,
        status: typeof status === 'string' ? status : undefined,
        testId: testId
    }, customStatusNode), containerShouldBeImage ? /*#__PURE__*/ $5FkrB.createElement("span", {
        "data-testid": testId && "".concat(testId, "--label"),
        id: labelId,
        hidden: true
    }, defaultLabel) : undefined));
});
$bfbca0303486f365$var$Avatar.displayName = 'Avatar';
var $bfbca0303486f365$export$2e2bcd8739ae039 = $bfbca0303486f365$var$Avatar;


// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $aec9472fc55898fa$export$8133811dea85f484 = (0, $0b1eca56b0789a79$export$2e2bcd8739ae039).div({
    margin: "var(--ds-space-050, 4px)",
    minWidth: 0
});
var $aec9472fc55898fa$export$844bee7de236d7ec = (0, $0b1eca56b0789a79$export$2e2bcd8739ae039).div({
    alignItems: 'center',
    display: 'flex'
});
var $aec9472fc55898fa$export$7c16ae7705e422c4 = (0, $0b1eca56b0789a79$export$2e2bcd8739ae039).div({
    display: 'flex'
});
var $aec9472fc55898fa$export$c23e66fb1706d7dd = (0, $0b1eca56b0789a79$export$2e2bcd8739ae039).div({
    marginLeft: "var(--ds-space-100, 8px)"
});
var $aec9472fc55898fa$export$20da797b837461ca = (0, $0b1eca56b0789a79$export$2e2bcd8739ae039).img({
    borderRadius: "var(--ds-radius-full, 9999px)",
    height: '16px',
    width: '16px',
    display: 'flex',
    margin: "var(--ds-space-025, 2px)"
});


var $be56e1dccdd4b04b$export$fe00f602c942368a = function AvatarOptionLabel(_ref) {
    var avatarOption = _ref.avatarOption;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $aec9472fc55898fa$export$844bee7de236d7ec), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $bfbca0303486f365$export$2e2bcd8739ae039), {
        src: typeof avatarOption.avatar !== 'string' ? undefined : avatarOption.avatar,
        size: "xsmall",
        appearance: typeof avatarOption.square === 'boolean' && avatarOption.square ? 'square' : 'circle'
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $aec9472fc55898fa$export$8133811dea85f484), null, avatarOption.label));
};



var $5FkrB = parcelRequire("5FkrB");

var $302763904e393669$export$914fa095fc1e0a45 = function IconOptionLabel(_ref) {
    var option = _ref.option;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $aec9472fc55898fa$export$844bee7de236d7ec), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $aec9472fc55898fa$export$7c16ae7705e422c4), null, option.icon !== undefined && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $aec9472fc55898fa$export$20da797b837461ca), {
        src: option.icon,
        alt: option.label
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $aec9472fc55898fa$export$c23e66fb1706d7dd), null, option.label)));
};



var $5FkrB = parcelRequire("5FkrB");
/* lozenge.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");

var $9Zzpd = parcelRequire("9Zzpd");
/* lozenge.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $5FkrB = parcelRequire("5FkrB");

/* lozenge-base.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $25nEq = parcelRequire("25nEq");

var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");



var $kqp0i = parcelRequire("kqp0i");

var $fC8ib = parcelRequire("fC8ib");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");

var $74Zh5 = parcelRequire("74Zh5");


var $eVb4V = parcelRequire("eVb4V");

var $eqVaP = parcelRequire("eqVaP");

var $25nEq = parcelRequire("25nEq");

var $74Zh5 = parcelRequire("74Zh5");

var $iy6kx = parcelRequire("iy6kx");
function $ff440597d7292b1f$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $ff440597d7292b1f$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $ff440597d7292b1f$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $ff440597d7292b1f$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $ff440597d7292b1f$export$6ccdbebca2ee545f = {
    '100%': '100%',
    'size.100': '1rem',
    'size.200': '1.5rem',
    'size.300': '2rem',
    'size.400': '2.5rem',
    'size.500': '3rem',
    'size.600': '6rem',
    'size.1000': '12rem'
};
var $ff440597d7292b1f$export$958d0ae7f2977ae4 = {
    'space.0': "var(--ds-space-0, 0px)",
    'space.025': "var(--ds-space-025, 2px)",
    'space.050': "var(--ds-space-050, 4px)",
    'space.075': "var(--ds-space-075, 6px)",
    'space.100': "var(--ds-space-100, 8px)",
    'space.150': "var(--ds-space-150, 12px)",
    'space.200': "var(--ds-space-200, 16px)",
    'space.250': "var(--ds-space-250, 20px)",
    'space.300': "var(--ds-space-300, 24px)",
    'space.400': "var(--ds-space-400, 32px)",
    'space.500': "var(--ds-space-500, 40px)",
    'space.600': "var(--ds-space-600, 48px)",
    'space.800': "var(--ds-space-800, 64px)",
    'space.1000': "var(--ds-space-1000, 80px)"
};
var $ff440597d7292b1f$export$d2dc61f58390201c = {
    'space.negative.025': "var(--ds-space-negative-025, -2px)",
    'space.negative.050': "var(--ds-space-negative-050, -4px)",
    'space.negative.075': "var(--ds-space-negative-075, -6px)",
    'space.negative.100': "var(--ds-space-negative-100, -8px)",
    'space.negative.150': "var(--ds-space-negative-150, -12px)",
    'space.negative.200': "var(--ds-space-negative-200, -16px)",
    'space.negative.250': "var(--ds-space-negative-250, -20px)",
    'space.negative.300': "var(--ds-space-negative-300, -24px)",
    'space.negative.400': "var(--ds-space-negative-400, -32px)"
};
var $ff440597d7292b1f$export$632685d741f3dbbf = $ff440597d7292b1f$var$_objectSpread($ff440597d7292b1f$var$_objectSpread({}, $ff440597d7292b1f$export$958d0ae7f2977ae4), $ff440597d7292b1f$export$d2dc61f58390201c);
var $ff440597d7292b1f$export$2185ce37f9bdd963 = {
    'color.background.neutral.bold': 'color.text.inverse',
    'color.background.neutral.bold.hovered': 'color.text.inverse',
    'color.background.neutral.bold.pressed': 'color.text.inverse',
    'color.background.selected.bold': 'color.text.inverse',
    'color.background.selected.bold.hovered': 'color.text.inverse',
    'color.background.selected.bold.pressed': 'color.text.inverse',
    'color.background.brand.bold': 'color.text.inverse',
    'color.background.brand.bold.hovered': 'color.text.inverse',
    'color.background.brand.bold.pressed': 'color.text.inverse',
    'color.background.brand.boldest': 'color.text.inverse',
    'color.background.brand.boldest.hovered': 'color.text.inverse',
    'color.background.brand.boldest.pressed': 'color.text.inverse',
    'color.background.danger.bold': 'color.text.inverse',
    'color.background.danger.bold.hovered': 'color.text.inverse',
    'color.background.danger.bold.pressed': 'color.text.inverse',
    'color.background.warning.bold': 'color.text.warning.inverse',
    'color.background.warning.bold.hovered': 'color.text.warning.inverse',
    'color.background.warning.bold.pressed': 'color.text.warning.inverse',
    'color.background.success.bold': 'color.text.inverse',
    'color.background.success.bold.hovered': 'color.text.inverse',
    'color.background.success.bold.pressed': 'color.text.inverse',
    'color.background.discovery.bold': 'color.text.inverse',
    'color.background.discovery.bold.hovered': 'color.text.inverse',
    'color.background.discovery.bold.pressed': 'color.text.inverse',
    'color.background.information.bold': 'color.text.inverse',
    'color.background.information.bold.hovered': 'color.text.inverse',
    'color.background.information.bold.pressed': 'color.text.inverse'
};
var $ff440597d7292b1f$export$daf94a976c798b4f = {
    'opacity.disabled': "var(--ds-opacity-disabled, 0.4)",
    'opacity.loading': "var(--ds-opacity-loading, 0.2)"
};
var $ff440597d7292b1f$export$7aff6e7ba39bb774 = {
    'elevation.shadow.overflow': "var(--ds-shadow-overflow, 0px 0px 8px #091e423f, 0px 0px 1px #091e424f)",
    'elevation.shadow.overflow.perimeter': "var(--ds-shadow-overflow-perimeter, #091e421f)",
    'elevation.shadow.overflow.spread': "var(--ds-shadow-overflow-spread, #091e4229)",
    'elevation.shadow.overlay': "var(--ds-shadow-overlay, 0px 8px 12px #091e423f, 0px 0px 1px #091e424f)",
    'elevation.shadow.raised': "var(--ds-shadow-raised, 0px 1px 1px #091e423f, 0px 0px 1px #091e4221)"
};
var $ff440597d7292b1f$export$41a358c9c2356760 = {
    'elevation.surface': "var(--ds-surface, #FFFFFF)",
    'elevation.surface.hovered': "var(--ds-surface-hovered, #FAFBFC)",
    'elevation.surface.pressed': "var(--ds-surface-pressed, #F4F5F7)",
    'elevation.surface.overlay': "var(--ds-surface-overlay, #FFFFFF)",
    'elevation.surface.overlay.hovered': "var(--ds-surface-overlay-hovered, #FAFBFC)",
    'elevation.surface.overlay.pressed': "var(--ds-surface-overlay-pressed, #F4F5F7)",
    'elevation.surface.raised': "var(--ds-surface-raised, #FFFFFF)",
    'elevation.surface.raised.hovered': "var(--ds-surface-raised-hovered, #FAFBFC)",
    'elevation.surface.raised.pressed': "var(--ds-surface-raised-pressed, #F4F5F7)",
    'elevation.surface.sunken': "var(--ds-surface-sunken, #F4F5F7)"
};
var $ff440597d7292b1f$export$1531ad5bb3fbedac = {
    'color.border': "var(--ds-border, #091e4221)",
    'color.border.accent.lime': "var(--ds-border-accent-lime, #6A9A23)",
    'color.border.accent.red': "var(--ds-border-accent-red, #FF5630)",
    'color.border.accent.orange': "var(--ds-border-accent-orange, #D94008)",
    'color.border.accent.yellow': "var(--ds-border-accent-yellow, #FFAB00)",
    'color.border.accent.green': "var(--ds-border-accent-green, #36B37E)",
    'color.border.accent.teal': "var(--ds-border-accent-teal, #00B8D9)",
    'color.border.accent.blue': "var(--ds-border-accent-blue, #0065FF)",
    'color.border.accent.purple': "var(--ds-border-accent-purple, #6554C0)",
    'color.border.accent.magenta': "var(--ds-border-accent-magenta, #CD519D)",
    'color.border.accent.gray': "var(--ds-border-accent-gray, #5E6C84)",
    'color.border.disabled': "var(--ds-border-disabled, #FAFBFC)",
    'color.border.focused': "var(--ds-border-focused, #2684FF)",
    'color.border.input': "var(--ds-border-input, #FAFBFC)",
    'color.border.inverse': "var(--ds-border-inverse, #FFFFFF)",
    'color.border.selected': "var(--ds-border-selected, #0052CC)",
    'color.border.brand': "var(--ds-border-brand, #0052CC)",
    'color.border.danger': "var(--ds-border-danger, #FF5630)",
    'color.border.warning': "var(--ds-border-warning, #FFC400)",
    'color.border.success': "var(--ds-border-success, #00875A)",
    'color.border.discovery': "var(--ds-border-discovery, #998DD9)",
    'color.border.information': "var(--ds-border-information, #0065FF)",
    'color.border.bold': "var(--ds-border-bold, #344563)"
};
var $ff440597d7292b1f$export$d1d79bf68ac056bd = {
    'color.background.accent.lime.subtlest': "var(--ds-background-accent-lime-subtlest, #EEFBDA)",
    'color.background.accent.lime.subtlest.hovered': "var(--ds-background-accent-lime-subtlest-hovered, #D3F1A7)",
    'color.background.accent.lime.subtlest.pressed': "var(--ds-background-accent-lime-subtlest-pressed, #B3DF72)",
    'color.background.accent.lime.subtler': "var(--ds-background-accent-lime-subtler, #D3F1A7)",
    'color.background.accent.lime.subtler.hovered': "var(--ds-background-accent-lime-subtler-hovered, #B3DF72)",
    'color.background.accent.lime.subtler.pressed': "var(--ds-background-accent-lime-subtler-pressed, #94C748)",
    'color.background.accent.lime.subtle': "var(--ds-background-accent-lime-subtle, #94C748)",
    'color.background.accent.lime.subtle.hovered': "var(--ds-background-accent-lime-subtle-hovered, #B3DF72)",
    'color.background.accent.lime.subtle.pressed': "var(--ds-background-accent-lime-subtle-pressed, #D3F1A7)",
    'color.background.accent.lime.bolder': "var(--ds-background-accent-lime-bolder, #5B7F24)",
    'color.background.accent.lime.bolder.hovered': "var(--ds-background-accent-lime-bolder-hovered, #37471F)",
    'color.background.accent.lime.bolder.pressed': "var(--ds-background-accent-lime-bolder-pressed, #37471F)",
    'color.background.accent.red.subtlest': "var(--ds-background-accent-red-subtlest, #FF8F73)",
    'color.background.accent.red.subtlest.hovered': "var(--ds-background-accent-red-subtlest-hovered, #FF7452)",
    'color.background.accent.red.subtlest.pressed': "var(--ds-background-accent-red-subtlest-pressed, #FF5630)",
    'color.background.accent.red.subtler': "var(--ds-background-accent-red-subtler, #FF7452)",
    'color.background.accent.red.subtler.hovered': "var(--ds-background-accent-red-subtler-hovered, #FF5630)",
    'color.background.accent.red.subtler.pressed': "var(--ds-background-accent-red-subtler-pressed, #DE350B)",
    'color.background.accent.red.subtle': "var(--ds-background-accent-red-subtle, #DE350B)",
    'color.background.accent.red.subtle.hovered': "var(--ds-background-accent-red-subtle-hovered, #FF5630)",
    'color.background.accent.red.subtle.pressed': "var(--ds-background-accent-red-subtle-pressed, #FF7452)",
    'color.background.accent.red.bolder': "var(--ds-background-accent-red-bolder, #DE350B)",
    'color.background.accent.red.bolder.hovered': "var(--ds-background-accent-red-bolder-hovered, #FF5630)",
    'color.background.accent.red.bolder.pressed': "var(--ds-background-accent-red-bolder-pressed, #FF7452)",
    'color.background.accent.orange.subtlest': "var(--ds-background-accent-orange-subtlest, #F18D13)",
    'color.background.accent.orange.subtlest.hovered': "var(--ds-background-accent-orange-subtlest-hovered, #FEC57B)",
    'color.background.accent.orange.subtlest.pressed': "var(--ds-background-accent-orange-subtlest-pressed, #FFE2BD)",
    'color.background.accent.orange.subtler': "var(--ds-background-accent-orange-subtler, #B65C02)",
    'color.background.accent.orange.subtler.hovered': "var(--ds-background-accent-orange-subtler-hovered, #F18D13)",
    'color.background.accent.orange.subtler.pressed': "var(--ds-background-accent-orange-subtler-pressed, #FEC57B)",
    'color.background.accent.orange.subtle': "var(--ds-background-accent-orange-subtle, #5F3811)",
    'color.background.accent.orange.subtle.hovered': "var(--ds-background-accent-orange-subtle-hovered, #974F0C)",
    'color.background.accent.orange.subtle.pressed': "var(--ds-background-accent-orange-subtle-pressed, #B65C02)",
    'color.background.accent.orange.bolder': "var(--ds-background-accent-orange-bolder, #43290F)",
    'color.background.accent.orange.bolder.hovered': "var(--ds-background-accent-orange-bolder-hovered, #5F3811)",
    'color.background.accent.orange.bolder.pressed': "var(--ds-background-accent-orange-bolder-pressed, #974F0C)",
    'color.background.accent.yellow.subtlest': "var(--ds-background-accent-yellow-subtlest, #FFE380)",
    'color.background.accent.yellow.subtlest.hovered': "var(--ds-background-accent-yellow-subtlest-hovered, #FFC400)",
    'color.background.accent.yellow.subtlest.pressed': "var(--ds-background-accent-yellow-subtlest-pressed, #FFAB00)",
    'color.background.accent.yellow.subtler': "var(--ds-background-accent-yellow-subtler, #FFC400)",
    'color.background.accent.yellow.subtler.hovered': "var(--ds-background-accent-yellow-subtler-hovered, #FFAB00)",
    'color.background.accent.yellow.subtler.pressed': "var(--ds-background-accent-yellow-subtler-pressed, #FF991F)",
    'color.background.accent.yellow.subtle': "var(--ds-background-accent-yellow-subtle, #FF991F)",
    'color.background.accent.yellow.subtle.hovered': "var(--ds-background-accent-yellow-subtle-hovered, #FFAB00)",
    'color.background.accent.yellow.subtle.pressed': "var(--ds-background-accent-yellow-subtle-pressed, #FFC400)",
    'color.background.accent.yellow.bolder': "var(--ds-background-accent-yellow-bolder, #FF991F)",
    'color.background.accent.yellow.bolder.hovered': "var(--ds-background-accent-yellow-bolder-hovered, #FFAB00)",
    'color.background.accent.yellow.bolder.pressed': "var(--ds-background-accent-yellow-bolder-pressed, #FFC400)",
    'color.background.accent.green.subtlest': "var(--ds-background-accent-green-subtlest, #79F2C0)",
    'color.background.accent.green.subtlest.hovered': "var(--ds-background-accent-green-subtlest-hovered, #57D9A3)",
    'color.background.accent.green.subtlest.pressed': "var(--ds-background-accent-green-subtlest-pressed, #36B37E)",
    'color.background.accent.green.subtler': "var(--ds-background-accent-green-subtler, #57D9A3)",
    'color.background.accent.green.subtler.hovered': "var(--ds-background-accent-green-subtler-hovered, #36B37E)",
    'color.background.accent.green.subtler.pressed': "var(--ds-background-accent-green-subtler-pressed, #00875A)",
    'color.background.accent.green.subtle': "var(--ds-background-accent-green-subtle, #00875A)",
    'color.background.accent.green.subtle.hovered': "var(--ds-background-accent-green-subtle-hovered, #36B37E)",
    'color.background.accent.green.subtle.pressed': "var(--ds-background-accent-green-subtle-pressed, #57D9A3)",
    'color.background.accent.green.bolder': "var(--ds-background-accent-green-bolder, #00875A)",
    'color.background.accent.green.bolder.hovered': "var(--ds-background-accent-green-bolder-hovered, #36B37E)",
    'color.background.accent.green.bolder.pressed': "var(--ds-background-accent-green-bolder-pressed, #57D9A3)",
    'color.background.accent.teal.subtlest': "var(--ds-background-accent-teal-subtlest, #79E2F2)",
    'color.background.accent.teal.subtlest.hovered': "var(--ds-background-accent-teal-subtlest-hovered, #00C7E6)",
    'color.background.accent.teal.subtlest.pressed': "var(--ds-background-accent-teal-subtlest-pressed, #00B8D9)",
    'color.background.accent.teal.subtler': "var(--ds-background-accent-teal-subtler, #00C7E6)",
    'color.background.accent.teal.subtler.hovered': "var(--ds-background-accent-teal-subtler-hovered, #00B8D9)",
    'color.background.accent.teal.subtler.pressed': "var(--ds-background-accent-teal-subtler-pressed, #00A3BF)",
    'color.background.accent.teal.subtle': "var(--ds-background-accent-teal-subtle, #00A3BF)",
    'color.background.accent.teal.subtle.hovered': "var(--ds-background-accent-teal-subtle-hovered, #00B8D9)",
    'color.background.accent.teal.subtle.pressed': "var(--ds-background-accent-teal-subtle-pressed, #00C7E6)",
    'color.background.accent.teal.bolder': "var(--ds-background-accent-teal-bolder, #00A3BF)",
    'color.background.accent.teal.bolder.hovered': "var(--ds-background-accent-teal-bolder-hovered, #00B8D9)",
    'color.background.accent.teal.bolder.pressed': "var(--ds-background-accent-teal-bolder-pressed, #00C7E6)",
    'color.background.accent.blue.subtlest': "var(--ds-background-accent-blue-subtlest, #4C9AFF)",
    'color.background.accent.blue.subtlest.hovered': "var(--ds-background-accent-blue-subtlest-hovered, #2684FF)",
    'color.background.accent.blue.subtlest.pressed': "var(--ds-background-accent-blue-subtlest-pressed, #0065FF)",
    'color.background.accent.blue.subtler': "var(--ds-background-accent-blue-subtler, #2684FF)",
    'color.background.accent.blue.subtler.hovered': "var(--ds-background-accent-blue-subtler-hovered, #0065FF)",
    'color.background.accent.blue.subtler.pressed': "var(--ds-background-accent-blue-subtler-pressed, #0052CC)",
    'color.background.accent.blue.subtle': "var(--ds-background-accent-blue-subtle, #0052CC)",
    'color.background.accent.blue.subtle.hovered': "var(--ds-background-accent-blue-subtle-hovered, #0065FF)",
    'color.background.accent.blue.subtle.pressed': "var(--ds-background-accent-blue-subtle-pressed, #2684FF)",
    'color.background.accent.blue.bolder': "var(--ds-background-accent-blue-bolder, #0052CC)",
    'color.background.accent.blue.bolder.hovered': "var(--ds-background-accent-blue-bolder-hovered, #0065FF)",
    'color.background.accent.blue.bolder.pressed': "var(--ds-background-accent-blue-bolder-pressed, #2684FF)",
    'color.background.accent.purple.subtlest': "var(--ds-background-accent-purple-subtlest, #998DD9)",
    'color.background.accent.purple.subtlest.hovered': "var(--ds-background-accent-purple-subtlest-hovered, #8777D9)",
    'color.background.accent.purple.subtlest.pressed': "var(--ds-background-accent-purple-subtlest-pressed, #6554C0)",
    'color.background.accent.purple.subtler': "var(--ds-background-accent-purple-subtler, #8777D9)",
    'color.background.accent.purple.subtler.hovered': "var(--ds-background-accent-purple-subtler-hovered, #6554C0)",
    'color.background.accent.purple.subtler.pressed': "var(--ds-background-accent-purple-subtler-pressed, #5243AA)",
    'color.background.accent.purple.subtle': "var(--ds-background-accent-purple-subtle, #5243AA)",
    'color.background.accent.purple.subtle.hovered': "var(--ds-background-accent-purple-subtle-hovered, #6554C0)",
    'color.background.accent.purple.subtle.pressed': "var(--ds-background-accent-purple-subtle-pressed, #8777D9)",
    'color.background.accent.purple.bolder': "var(--ds-background-accent-purple-bolder, #5243AA)",
    'color.background.accent.purple.bolder.hovered': "var(--ds-background-accent-purple-bolder-hovered, #6554C0)",
    'color.background.accent.purple.bolder.pressed': "var(--ds-background-accent-purple-bolder-pressed, #8777D9)",
    'color.background.accent.magenta.subtlest': "var(--ds-background-accent-magenta-subtlest, #FFECF8)",
    'color.background.accent.magenta.subtlest.hovered': "var(--ds-background-accent-magenta-subtlest-hovered, #FDD0EC)",
    'color.background.accent.magenta.subtlest.pressed': "var(--ds-background-accent-magenta-subtlest-pressed, #F797D2)",
    'color.background.accent.magenta.subtler': "var(--ds-background-accent-magenta-subtler, #FDD0EC)",
    'color.background.accent.magenta.subtler.hovered': "var(--ds-background-accent-magenta-subtler-hovered, #F797D2)",
    'color.background.accent.magenta.subtler.pressed': "var(--ds-background-accent-magenta-subtler-pressed, #E774BB)",
    'color.background.accent.magenta.subtle': "var(--ds-background-accent-magenta-subtle, #E774BB)",
    'color.background.accent.magenta.subtle.hovered': "var(--ds-background-accent-magenta-subtle-hovered, #F797D2)",
    'color.background.accent.magenta.subtle.pressed': "var(--ds-background-accent-magenta-subtle-pressed, #FDD0EC)",
    'color.background.accent.magenta.bolder': "var(--ds-background-accent-magenta-bolder, #AE4787)",
    'color.background.accent.magenta.bolder.hovered': "var(--ds-background-accent-magenta-bolder-hovered, #943D73)",
    'color.background.accent.magenta.bolder.pressed': "var(--ds-background-accent-magenta-bolder-pressed, #50253F)",
    'color.background.accent.gray.subtlest': "var(--ds-background-accent-gray-subtlest, #6B778C)",
    'color.background.accent.gray.subtlest.hovered': "var(--ds-background-accent-gray-subtlest-hovered, #5E6C84)",
    'color.background.accent.gray.subtlest.pressed': "var(--ds-background-accent-gray-subtlest-pressed, #505F79)",
    'color.background.accent.gray.subtler': "var(--ds-background-accent-gray-subtler, #5E6C84)",
    'color.background.accent.gray.subtler.hovered': "var(--ds-background-accent-gray-subtler-hovered, #505F79)",
    'color.background.accent.gray.subtler.pressed': "var(--ds-background-accent-gray-subtler-pressed, #42526E)",
    'color.background.accent.gray.subtle': "var(--ds-background-accent-gray-subtle, #505F79)",
    'color.background.accent.gray.subtle.hovered': "var(--ds-background-accent-gray-subtle-hovered, #5E6C84)",
    'color.background.accent.gray.subtle.pressed': "var(--ds-background-accent-gray-subtle-pressed, #6B778C)",
    'color.background.accent.gray.bolder': "var(--ds-background-accent-gray-bolder, #42526E)",
    'color.background.accent.gray.bolder.hovered': "var(--ds-background-accent-gray-bolder-hovered, #344563)",
    'color.background.accent.gray.bolder.pressed': "var(--ds-background-accent-gray-bolder-pressed, #253858)",
    'color.background.disabled': "var(--ds-background-disabled, #091e4289)",
    'color.background.input': "var(--ds-background-input, #FAFBFC)",
    'color.background.input.hovered': "var(--ds-background-input-hovered, #EBECF0)",
    'color.background.input.pressed': "var(--ds-background-input-pressed, #FFFFFF)",
    'color.background.inverse.subtle': "var(--ds-background-inverse-subtle, #00000029)",
    'color.background.inverse.subtle.hovered': "var(--ds-background-inverse-subtle-hovered, #0000003D)",
    'color.background.inverse.subtle.pressed': "var(--ds-background-inverse-subtle-pressed, #00000052)",
    'color.background.neutral': "var(--ds-background-neutral, #DFE1E6)",
    'color.background.neutral.hovered': "var(--ds-background-neutral-hovered, #091e4214)",
    'color.background.neutral.pressed': "var(--ds-background-neutral-pressed, #B3D4FF)",
    'color.background.neutral.subtle': "var(--ds-background-neutral-subtle, transparent)",
    'color.background.neutral.subtle.hovered': "var(--ds-background-neutral-subtle-hovered, #091e4214)",
    'color.background.neutral.subtle.pressed': "var(--ds-background-neutral-subtle-pressed, #B3D4FF)",
    'color.background.neutral.bold': "var(--ds-background-neutral-bold, #42526E)",
    'color.background.neutral.bold.hovered': "var(--ds-background-neutral-bold-hovered, #505F79)",
    'color.background.neutral.bold.pressed': "var(--ds-background-neutral-bold-pressed, #344563)",
    'color.background.selected': "var(--ds-background-selected, #DEEBFF)",
    'color.background.selected.hovered': "var(--ds-background-selected-hovered, #B3D4FF)",
    'color.background.selected.pressed': "var(--ds-background-selected-pressed, #4C9AFF)",
    'color.background.selected.bold': "var(--ds-background-selected-bold, #0052CC)",
    'color.background.selected.bold.hovered': "var(--ds-background-selected-bold-hovered, #2684FF)",
    'color.background.selected.bold.pressed': "var(--ds-background-selected-bold-pressed, #0052CC)",
    'color.background.brand.subtlest': "var(--ds-background-brand-subtlest, #B3D4FF)",
    'color.background.brand.subtlest.hovered': "var(--ds-background-brand-subtlest-hovered, #DEEBFF)",
    'color.background.brand.subtlest.pressed': "var(--ds-background-brand-subtlest-pressed, #4C9AFF)",
    'color.background.brand.bold': "var(--ds-background-brand-bold, #0052CC)",
    'color.background.brand.bold.hovered': "var(--ds-background-brand-bold-hovered, #0065FF)",
    'color.background.brand.bold.pressed': "var(--ds-background-brand-bold-pressed, #0747A6)",
    'color.background.brand.boldest': "var(--ds-background-brand-boldest, #0747A6)",
    'color.background.brand.boldest.hovered': "var(--ds-background-brand-boldest-hovered, #0052CC)",
    'color.background.brand.boldest.pressed': "var(--ds-background-brand-boldest-pressed, #0747A6)",
    'color.background.danger': "var(--ds-background-danger, #FFEBE6)",
    'color.background.danger.hovered': "var(--ds-background-danger-hovered, #FFBDAD)",
    'color.background.danger.pressed': "var(--ds-background-danger-pressed, #FF8F73)",
    'color.background.danger.subtler': "var(--ds-background-danger-subtler, #FFBDAD)",
    'color.background.danger.subtler.hovered': "var(--ds-background-danger-subtler-hovered, #FF8F73)",
    'color.background.danger.subtler.pressed': "var(--ds-background-danger-subtler-pressed, #FF7452)",
    'color.background.danger.bold': "var(--ds-background-danger-bold, #DE350B)",
    'color.background.danger.bold.hovered': "var(--ds-background-danger-bold-hovered, #FF5630)",
    'color.background.danger.bold.pressed': "var(--ds-background-danger-bold-pressed, #BF2600)",
    'color.background.warning': "var(--ds-background-warning, #FFFAE6)",
    'color.background.warning.hovered': "var(--ds-background-warning-hovered, #FFF0B3)",
    'color.background.warning.pressed': "var(--ds-background-warning-pressed, #FFE380)",
    'color.background.warning.subtler': "var(--ds-background-warning-subtler, #FFF0B3)",
    'color.background.warning.subtler.hovered': "var(--ds-background-warning-subtler-hovered, #FFE380)",
    'color.background.warning.subtler.pressed': "var(--ds-background-warning-subtler-pressed, #FFC400)",
    'color.background.warning.bold': "var(--ds-background-warning-bold, #FFAB00)",
    'color.background.warning.bold.hovered': "var(--ds-background-warning-bold-hovered, #FFC400)",
    'color.background.warning.bold.pressed': "var(--ds-background-warning-bold-pressed, #FF991F)",
    'color.background.success': "var(--ds-background-success, #E3FCEF)",
    'color.background.success.hovered': "var(--ds-background-success-hovered, #ABF5D1)",
    'color.background.success.pressed': "var(--ds-background-success-pressed, #79F2C0)",
    'color.background.success.subtler': "var(--ds-background-success-subtler, #ABF5D1)",
    'color.background.success.subtler.hovered': "var(--ds-background-success-subtler-hovered, #79F2C0)",
    'color.background.success.subtler.pressed': "var(--ds-background-success-subtler-pressed, #57D9A3)",
    'color.background.success.bold': "var(--ds-background-success-bold, #00875A)",
    'color.background.success.bold.hovered': "var(--ds-background-success-bold-hovered, #57D9A3)",
    'color.background.success.bold.pressed': "var(--ds-background-success-bold-pressed, #00875A)",
    'color.background.discovery': "var(--ds-background-discovery, #EAE6FF)",
    'color.background.discovery.hovered': "var(--ds-background-discovery-hovered, #C0B6F2)",
    'color.background.discovery.pressed': "var(--ds-background-discovery-pressed, #998DD9)",
    'color.background.discovery.subtler': "var(--ds-background-discovery-subtler, #C0B6F2)",
    'color.background.discovery.subtler.hovered': "var(--ds-background-discovery-subtler-hovered, #998DD9)",
    'color.background.discovery.subtler.pressed': "var(--ds-background-discovery-subtler-pressed, #8777D9)",
    'color.background.discovery.bold': "var(--ds-background-discovery-bold, #5243AA)",
    'color.background.discovery.bold.hovered': "var(--ds-background-discovery-bold-hovered, #8777D9)",
    'color.background.discovery.bold.pressed': "var(--ds-background-discovery-bold-pressed, #5243AA)",
    'color.background.information': "var(--ds-background-information, #DEEBFF)",
    'color.background.information.hovered': "var(--ds-background-information-hovered, #B3D4FF)",
    'color.background.information.pressed': "var(--ds-background-information-pressed, #4C9AFF)",
    'color.background.information.subtler': "var(--ds-background-information-subtler, #B3D4FF)",
    'color.background.information.subtler.hovered': "var(--ds-background-information-subtler-hovered, #4C9AFF)",
    'color.background.information.subtler.pressed': "var(--ds-background-information-subtler-pressed, #2684FF)",
    'color.background.information.bold': "var(--ds-background-information-bold, #0052CC)",
    'color.background.information.bold.hovered': "var(--ds-background-information-bold-hovered, #2684FF)",
    'color.background.information.bold.pressed': "var(--ds-background-information-bold-pressed, #0052CC)",
    'color.blanket': "var(--ds-blanket, #091e4289)",
    'color.blanket.selected': "var(--ds-blanket-selected, #388BFF14)",
    'color.blanket.danger': "var(--ds-blanket-danger, #EF5C4814)",
    'color.skeleton': "var(--ds-skeleton, #F4F5F7)",
    'color.skeleton.subtle': "var(--ds-skeleton-subtle, #091e420a)",
    'elevation.surface': "var(--ds-surface, #FFFFFF)",
    'elevation.surface.hovered': "var(--ds-surface-hovered, #FAFBFC)",
    'elevation.surface.pressed': "var(--ds-surface-pressed, #F4F5F7)",
    'elevation.surface.overlay': "var(--ds-surface-overlay, #FFFFFF)",
    'elevation.surface.overlay.hovered': "var(--ds-surface-overlay-hovered, #FAFBFC)",
    'elevation.surface.overlay.pressed': "var(--ds-surface-overlay-pressed, #F4F5F7)",
    'elevation.surface.raised': "var(--ds-surface-raised, #FFFFFF)",
    'elevation.surface.raised.hovered': "var(--ds-surface-raised-hovered, #FAFBFC)",
    'elevation.surface.raised.pressed': "var(--ds-surface-raised-pressed, #F4F5F7)",
    'elevation.surface.sunken': "var(--ds-surface-sunken, #F4F5F7)",
    'utility.elevation.surface.current': "var(--ds-elevation-surface-current, #FFFFFF)"
};
var $ff440597d7292b1f$export$8473307aa00d6ea1 = {
    'color.text': "var(--ds-text, #172B4D)",
    'color.text.accent.lime': "var(--ds-text-accent-lime, #4C6B1F)",
    'color.text.accent.lime.bolder': "var(--ds-text-accent-lime-bolder, #37471F)",
    'color.text.accent.red': "var(--ds-text-accent-red, #DE350B)",
    'color.text.accent.red.bolder': "var(--ds-text-accent-red-bolder, #BF2600)",
    'color.text.accent.orange': "var(--ds-text-accent-orange, #F18D13)",
    'color.text.accent.orange.bolder': "var(--ds-text-accent-orange-bolder, #B65C02)",
    'color.text.accent.yellow': "var(--ds-text-accent-yellow, #FF991F)",
    'color.text.accent.yellow.bolder': "var(--ds-text-accent-yellow-bolder, #FF8B00)",
    'color.text.accent.green': "var(--ds-text-accent-green, #00875A)",
    'color.text.accent.green.bolder': "var(--ds-text-accent-green-bolder, #006644)",
    'color.text.accent.teal': "var(--ds-text-accent-teal, #00A3BF)",
    'color.text.accent.teal.bolder': "var(--ds-text-accent-teal-bolder, #008DA6)",
    'color.text.accent.blue': "var(--ds-text-accent-blue, #0052CC)",
    'color.text.accent.blue.bolder': "var(--ds-text-accent-blue-bolder, #0747A6)",
    'color.text.accent.purple': "var(--ds-text-accent-purple, #5243AA)",
    'color.text.accent.purple.bolder': "var(--ds-text-accent-purple-bolder, #403294)",
    'color.text.accent.magenta': "var(--ds-text-accent-magenta, #E774BB)",
    'color.text.accent.magenta.bolder': "var(--ds-text-accent-magenta-bolder, #DA62AC)",
    'color.text.accent.gray': "var(--ds-text-accent-gray, #505F79)",
    'color.text.accent.gray.bolder': "var(--ds-text-accent-gray-bolder, #172B4D)",
    'color.text.disabled': "var(--ds-text-disabled, #A5ADBA)",
    'color.text.inverse': "var(--ds-text-inverse, #FFFFFF)",
    'color.text.selected': "var(--ds-text-selected, #0052CC)",
    'color.text.brand': "var(--ds-text-brand, #0065FF)",
    'color.text.danger': "var(--ds-text-danger, #DE350B)",
    'color.text.danger.bolder': "var(--ds-text-danger-bolder, #BF2600)",
    'color.text.warning': "var(--ds-text-warning, #974F0C)",
    'color.text.warning.inverse': "var(--ds-text-warning-inverse, #172B4D)",
    'color.text.warning.bolder': "var(--ds-text-warning-bolder, #974F0C)",
    'color.text.success': "var(--ds-text-success, #006644)",
    'color.text.success.bolder': "var(--ds-text-success-bolder, #006644)",
    'color.text.discovery': "var(--ds-text-discovery, #403294)",
    'color.text.discovery.bolder': "var(--ds-text-discovery-bolder, #403294)",
    'color.text.information': "var(--ds-text-information, #0052CC)",
    'color.text.information.bolder': "var(--ds-text-information-bolder, #0747A6)",
    'color.text.subtlest': "var(--ds-text-subtlest, #7A869A)",
    'color.text.subtle': "var(--ds-text-subtle, #42526E)",
    'color.link': "var(--ds-link, #0052CC)",
    'color.link.pressed': "var(--ds-link-pressed, #0747A6)",
    'color.link.visited': "var(--ds-link-visited, #403294)",
    'color.link.visited.pressed': "var(--ds-link-visited-pressed, #403294)"
};
var $ff440597d7292b1f$export$498780f74be9af68 = {
    'color.icon': "var(--ds-icon, #505F79)",
    'color.icon.accent.lime': "var(--ds-icon-accent-lime, #6A9A23)",
    'color.icon.accent.red': "var(--ds-icon-accent-red, #FF5630)",
    'color.icon.accent.orange': "var(--ds-icon-accent-orange, #D94008)",
    'color.icon.accent.yellow': "var(--ds-icon-accent-yellow, #FFAB00)",
    'color.icon.accent.green': "var(--ds-icon-accent-green, #36B37E)",
    'color.icon.accent.teal': "var(--ds-icon-accent-teal, #00B8D9)",
    'color.icon.accent.blue': "var(--ds-icon-accent-blue, #0065FF)",
    'color.icon.accent.purple': "var(--ds-icon-accent-purple, #6554C0)",
    'color.icon.accent.magenta': "var(--ds-icon-accent-magenta, #CD519D)",
    'color.icon.accent.gray': "var(--ds-icon-accent-gray, #5E6C84)",
    'color.icon.disabled': "var(--ds-icon-disabled, #8993A4)",
    'color.icon.inverse': "var(--ds-icon-inverse, #FFFFFF)",
    'color.icon.selected': "var(--ds-icon-selected, #0052CC)",
    'color.icon.brand': "var(--ds-icon-brand, #0065FF)",
    'color.icon.danger': "var(--ds-icon-danger, #DE350B)",
    'color.icon.warning': "var(--ds-icon-warning, #FFC400)",
    'color.icon.warning.inverse': "var(--ds-icon-warning-inverse, #253858)",
    'color.icon.success': "var(--ds-icon-success, #00875A)",
    'color.icon.discovery': "var(--ds-icon-discovery, #8777D9)",
    'color.icon.information': "var(--ds-icon-information, #0747A6)",
    'color.icon.subtlest': "var(--ds-icon-subtlest, #6B778C)",
    'color.icon.subtle': "var(--ds-icon-subtle, #6B778C)"
};
var $ff440597d7292b1f$export$b5f31a7e431d2eab = {
    '1': 1,
    card: 100,
    navigation: 200,
    dialog: 300,
    layer: 400,
    blanket: 500,
    modal: 510,
    flag: 600,
    spotlight: 700,
    tooltip: 800
};
var $ff440597d7292b1f$export$e1b83c5210c471b8 = {
    'border.width': "var(--ds-border-width, 1px)",
    'border.width.selected': "var(--ds-border-width-selected, 2px)",
    'border.width.focused': "var(--ds-border-width-focused, 2px)"
};
var $ff440597d7292b1f$export$3c0a6c3e64bb180d = {
    'radius.xsmall': "var(--ds-radius-xsmall, 2px)",
    'radius.small': "var(--ds-radius-small, 3px)",
    'radius.medium': "var(--ds-radius-medium, 6px)",
    'radius.large': "var(--ds-radius-large, 8px)",
    'radius.xlarge': "var(--ds-radius-xlarge, 12px)",
    'radius.xxlarge': "var(--ds-radius-xxlarge, 16px)",
    'radius.full': "var(--ds-radius-full, 9999px)",
    'radius.tile': "var(--ds-radius-tile, 25%)"
};
var $ff440597d7292b1f$export$6ffa317d5e70375 = {
    'font.body': "var(--ds-font-body, normal 400 14px/20px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.body.UNSAFE_small': "var(--ds-font-body-UNSAFE_small, normal 400 12px/16px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.body.large': "var(--ds-font-body-large, normal 400 16px/24px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.body.small': "var(--ds-font-body-small, normal 400 12px/16px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.code': "var(--ds-font-code, normal 400 0.875em/1 \"Atlassian Mono\", ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)",
    'font.heading.large': "var(--ds-font-heading-large, normal 653 24px/28px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.heading.medium': "var(--ds-font-heading-medium, normal 653 20px/24px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.heading.small': "var(--ds-font-heading-small, normal 653 16px/20px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.heading.xlarge': "var(--ds-font-heading-xlarge, normal 653 28px/32px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.heading.xsmall': "var(--ds-font-heading-xsmall, normal 653 14px/20px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.heading.xxlarge': "var(--ds-font-heading-xxlarge, normal 653 32px/36px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.heading.xxsmall': "var(--ds-font-heading-xxsmall, normal 653 12px/16px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.metric.large': "var(--ds-font-metric-large, normal 653 28px/32px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.metric.medium': "var(--ds-font-metric-medium, normal 653 24px/28px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.metric.small': "var(--ds-font-metric-small, normal 653 16px/20px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
};
var $ff440597d7292b1f$export$303e322c6b1ed114 = {
    'font.weight.bold': "var(--ds-font-weight-bold, 653)",
    'font.weight.medium': "var(--ds-font-weight-medium, 500)",
    'font.weight.regular': "var(--ds-font-weight-regular, 400)",
    'font.weight.semibold': "var(--ds-font-weight-semibold, 600)"
};
var $ff440597d7292b1f$export$3c7e9587132614b4 = {
    'font.family.body': "var(--ds-font-family-body, \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.family.brand.body': "var(--ds-font-family-brand-body, \"Charlie Text\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.family.brand.heading': "var(--ds-font-family-brand-heading, \"Charlie Display\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.family.code': "var(--ds-font-family-code, \"Atlassian Mono\", ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)",
    'font.family.heading': "var(--ds-font-family-heading, \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
};
var $ff440597d7292b1f$export$236bfe3a33ef1292 = {
    medium: "var(--ds-font-body, normal 400 14px/20px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    UNSAFE_small: "var(--ds-font-body-UNSAFE_small, normal 400 12px/16px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    large: "var(--ds-font-body-large, normal 400 16px/24px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    small: "var(--ds-font-body-small, normal 400 12px/16px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
};
var $ff440597d7292b1f$export$855cfd311192d666 = {
    bold: "var(--ds-font-weight-bold, 653)",
    medium: "var(--ds-font-weight-medium, 500)",
    regular: "var(--ds-font-weight-regular, 400)",
    semibold: "var(--ds-font-weight-semibold, 600)"
};
var $ff440597d7292b1f$export$b805719bc8cb376 = {
    large: "var(--ds-font-metric-large, normal 653 28px/32px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    medium: "var(--ds-font-metric-medium, normal 653 24px/28px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    small: "var(--ds-font-metric-small, normal 653 16px/20px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
};
/**
 * @codegenEnd
 */ // Margin needs some bespoke types: https://atlassian.slack.com/archives/CKRHB23K8/p1712623192772909
/**
 * Token functions are currently allowed for borderRadius in xcss to ease migration.
 * Because 'radius.small' defaults to 3px, we need a mechanism to allow for 4px values to be provided:
 * This is done by calling the token function - token('radius.small')
 *
 * TODO: Remove once shape them is rolled out and fg platform-dst-shape-theme-default removed
 */ // Generate maps for Box props. backgroundColor, padding, etc
var $ff440597d7292b1f$var$spacingProperties = [
    // Used by Box
    'padding',
    'paddingBlock',
    'paddingBlockStart',
    'paddingBlockEnd',
    'paddingInline',
    'paddingInlineStart',
    'paddingInlineEnd',
    // Used by Inline and Stack
    'gap',
    'rowGap',
    'columnGap'
];
var $ff440597d7292b1f$export$ca0f9c2de39ffed7 = function getSerializedStylesMap(cssProperty, tokenMap) {
    return Object.keys(tokenMap).reduce(function(emotionSpacingMap, token) {
        // eslint-disable-next-line @repo/internal/styles/no-exported-styles
        emotionSpacingMap[token] = (0, $74Zh5.css)((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, cssProperty, tokenMap[token]));
        return emotionSpacingMap;
    }, {});
};
var $ff440597d7292b1f$export$e615f061ca585a6c = $ff440597d7292b1f$var$spacingProperties.reduce(function(styleMap, spacingProperty) {
    styleMap[spacingProperty] = $ff440597d7292b1f$export$ca0f9c2de39ffed7(spacingProperty, $ff440597d7292b1f$export$958d0ae7f2977ae4);
    return styleMap;
}, {});
var $ff440597d7292b1f$export$bf46c3f9eeafc71f = $ff440597d7292b1f$var$spacingProperties.reduce(function(styleMap, spacingProperty) {
    styleMap[spacingProperty] = $ff440597d7292b1f$export$ca0f9c2de39ffed7(spacingProperty, $ff440597d7292b1f$export$958d0ae7f2977ae4);
    return styleMap;
}, {});
var $ff440597d7292b1f$export$e7af83bafe7f9e63 = $ff440597d7292b1f$export$ca0f9c2de39ffed7('backgroundColor', $ff440597d7292b1f$export$d1d79bf68ac056bd);
var $ff440597d7292b1f$export$3a1bcba60b23d7f0 = $ff440597d7292b1f$export$ca0f9c2de39ffed7('color', $ff440597d7292b1f$export$8473307aa00d6ea1);
var $ff440597d7292b1f$export$45f3f4fe16f9f7d5 = $ff440597d7292b1f$export$ca0f9c2de39ffed7('fontWeight', $ff440597d7292b1f$export$303e322c6b1ed114);
var $ff440597d7292b1f$export$68cc305da27dbaa4 = $ff440597d7292b1f$export$ca0f9c2de39ffed7('fontFamily', $ff440597d7292b1f$export$3c7e9587132614b4);
var $ff440597d7292b1f$export$128f10c238242f83 = $ff440597d7292b1f$export$ca0f9c2de39ffed7('font', $ff440597d7292b1f$export$6ffa317d5e70375);
var $ff440597d7292b1f$export$219d364c0da35ae4 = $ff440597d7292b1f$export$ca0f9c2de39ffed7('font', $ff440597d7292b1f$export$236bfe3a33ef1292);
var $ff440597d7292b1f$export$38845ca010b93505 = $ff440597d7292b1f$export$ca0f9c2de39ffed7('fontWeight', $ff440597d7292b1f$export$855cfd311192d666);
var $ff440597d7292b1f$export$ff257d957d48c421 = $ff440597d7292b1f$export$ca0f9c2de39ffed7((0, $iy6kx.CURRENT_SURFACE_CSS_VAR), $ff440597d7292b1f$export$41a358c9c2356760);
var $ff440597d7292b1f$export$5e65a44e5b6ecadb = function isSurfaceColorToken(color) {
    return $ff440597d7292b1f$export$41a358c9c2356760[color] !== undefined;
};
var $ff440597d7292b1f$export$7001ce64d9ff7c7f = $ff440597d7292b1f$export$ca0f9c2de39ffed7('font', $ff440597d7292b1f$export$b805719bc8cb376);



var $fC8ib = parcelRequire("fC8ib");

var $25nEq = parcelRequire("25nEq");

var $iYJcE = parcelRequire("iYJcE");

var $ekGgq = parcelRequire("ekGgq");

var $74Zh5 = parcelRequire("74Zh5");


var $3ZMUU = parcelRequire("3ZMUU");
function $2dab09527a25ccd1$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $2dab09527a25ccd1$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $2dab09527a25ccd1$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $2dab09527a25ccd1$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $2dab09527a25ccd1$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $2dab09527a25ccd1$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
var $2dab09527a25ccd1$export$9a199fbafee0014e = {
    backgroundColor: (0, $ff440597d7292b1f$export$d1d79bf68ac056bd),
    blockSize: (0, $ff440597d7292b1f$export$6ccdbebca2ee545f),
    borderBlockColor: (0, $ff440597d7292b1f$export$1531ad5bb3fbedac),
    borderBlockEndColor: (0, $ff440597d7292b1f$export$1531ad5bb3fbedac),
    borderBlockEndWidth: (0, $ff440597d7292b1f$export$e1b83c5210c471b8),
    borderBlockStartColor: (0, $ff440597d7292b1f$export$1531ad5bb3fbedac),
    borderBlockStartWidth: (0, $ff440597d7292b1f$export$e1b83c5210c471b8),
    borderBlockWidth: (0, $ff440597d7292b1f$export$e1b83c5210c471b8),
    borderBottomColor: (0, $ff440597d7292b1f$export$1531ad5bb3fbedac),
    borderBottomLeftRadius: (0, $ff440597d7292b1f$export$3c0a6c3e64bb180d),
    borderBottomRightRadius: (0, $ff440597d7292b1f$export$3c0a6c3e64bb180d),
    borderBottomWidth: (0, $ff440597d7292b1f$export$e1b83c5210c471b8),
    borderColor: (0, $ff440597d7292b1f$export$1531ad5bb3fbedac),
    borderEndEndRadius: (0, $ff440597d7292b1f$export$3c0a6c3e64bb180d),
    borderEndStartRadius: (0, $ff440597d7292b1f$export$3c0a6c3e64bb180d),
    borderInlineColor: (0, $ff440597d7292b1f$export$1531ad5bb3fbedac),
    borderInlineEndColor: (0, $ff440597d7292b1f$export$1531ad5bb3fbedac),
    borderInlineEndWidth: (0, $ff440597d7292b1f$export$e1b83c5210c471b8),
    borderInlineStartColor: (0, $ff440597d7292b1f$export$1531ad5bb3fbedac),
    borderInlineStartWidth: (0, $ff440597d7292b1f$export$e1b83c5210c471b8),
    borderInlineWidth: (0, $ff440597d7292b1f$export$e1b83c5210c471b8),
    borderLeftColor: (0, $ff440597d7292b1f$export$1531ad5bb3fbedac),
    borderLeftWidth: (0, $ff440597d7292b1f$export$e1b83c5210c471b8),
    borderRadius: (0, $ff440597d7292b1f$export$3c0a6c3e64bb180d),
    borderRightColor: (0, $ff440597d7292b1f$export$1531ad5bb3fbedac),
    borderRightWidth: (0, $ff440597d7292b1f$export$e1b83c5210c471b8),
    borderStartEndRadius: (0, $ff440597d7292b1f$export$3c0a6c3e64bb180d),
    borderStartStartRadius: (0, $ff440597d7292b1f$export$3c0a6c3e64bb180d),
    borderTopColor: (0, $ff440597d7292b1f$export$1531ad5bb3fbedac),
    borderTopLeftRadius: (0, $ff440597d7292b1f$export$3c0a6c3e64bb180d),
    borderTopRightRadius: (0, $ff440597d7292b1f$export$3c0a6c3e64bb180d),
    borderTopWidth: (0, $ff440597d7292b1f$export$e1b83c5210c471b8),
    borderWidth: (0, $ff440597d7292b1f$export$e1b83c5210c471b8),
    bottom: (0, $ff440597d7292b1f$export$632685d741f3dbbf),
    boxShadow: (0, $ff440597d7292b1f$export$7aff6e7ba39bb774),
    color: (0, $ff440597d7292b1f$export$8473307aa00d6ea1),
    columnGap: (0, $ff440597d7292b1f$export$958d0ae7f2977ae4),
    font: (0, $ff440597d7292b1f$export$6ffa317d5e70375),
    fontFamily: (0, $ff440597d7292b1f$export$3c7e9587132614b4),
    fontWeight: (0, $ff440597d7292b1f$export$303e322c6b1ed114),
    gap: (0, $ff440597d7292b1f$export$958d0ae7f2977ae4),
    height: (0, $ff440597d7292b1f$export$6ccdbebca2ee545f),
    inlineSize: (0, $ff440597d7292b1f$export$6ccdbebca2ee545f),
    inset: (0, $ff440597d7292b1f$export$632685d741f3dbbf),
    insetBlock: (0, $ff440597d7292b1f$export$632685d741f3dbbf),
    insetBlockEnd: (0, $ff440597d7292b1f$export$632685d741f3dbbf),
    insetBlockStart: (0, $ff440597d7292b1f$export$632685d741f3dbbf),
    insetInline: (0, $ff440597d7292b1f$export$632685d741f3dbbf),
    insetInlineEnd: (0, $ff440597d7292b1f$export$632685d741f3dbbf),
    insetInlineStart: (0, $ff440597d7292b1f$export$632685d741f3dbbf),
    left: (0, $ff440597d7292b1f$export$632685d741f3dbbf),
    margin: (0, $ff440597d7292b1f$export$632685d741f3dbbf),
    marginBlock: (0, $ff440597d7292b1f$export$632685d741f3dbbf),
    marginBlockEnd: (0, $ff440597d7292b1f$export$632685d741f3dbbf),
    marginBlockStart: (0, $ff440597d7292b1f$export$632685d741f3dbbf),
    marginBottom: (0, $ff440597d7292b1f$export$632685d741f3dbbf),
    marginInline: (0, $ff440597d7292b1f$export$632685d741f3dbbf),
    marginInlineEnd: (0, $ff440597d7292b1f$export$632685d741f3dbbf),
    marginInlineStart: (0, $ff440597d7292b1f$export$632685d741f3dbbf),
    marginLeft: (0, $ff440597d7292b1f$export$632685d741f3dbbf),
    marginRight: (0, $ff440597d7292b1f$export$632685d741f3dbbf),
    marginTop: (0, $ff440597d7292b1f$export$632685d741f3dbbf),
    maxBlockSize: (0, $ff440597d7292b1f$export$6ccdbebca2ee545f),
    maxHeight: (0, $ff440597d7292b1f$export$6ccdbebca2ee545f),
    maxInlineSize: (0, $ff440597d7292b1f$export$6ccdbebca2ee545f),
    maxWidth: (0, $ff440597d7292b1f$export$6ccdbebca2ee545f),
    minBlockSize: (0, $ff440597d7292b1f$export$6ccdbebca2ee545f),
    minHeight: (0, $ff440597d7292b1f$export$6ccdbebca2ee545f),
    minInlineSize: (0, $ff440597d7292b1f$export$6ccdbebca2ee545f),
    minWidth: (0, $ff440597d7292b1f$export$6ccdbebca2ee545f),
    opacity: (0, $ff440597d7292b1f$export$daf94a976c798b4f),
    outlineColor: (0, $ff440597d7292b1f$export$1531ad5bb3fbedac),
    outlineOffset: (0, $ff440597d7292b1f$export$632685d741f3dbbf),
    outlineWidth: (0, $ff440597d7292b1f$export$e1b83c5210c471b8),
    padding: (0, $ff440597d7292b1f$export$958d0ae7f2977ae4),
    paddingBlock: (0, $ff440597d7292b1f$export$958d0ae7f2977ae4),
    paddingBlockEnd: (0, $ff440597d7292b1f$export$958d0ae7f2977ae4),
    paddingBlockStart: (0, $ff440597d7292b1f$export$958d0ae7f2977ae4),
    paddingBottom: (0, $ff440597d7292b1f$export$958d0ae7f2977ae4),
    paddingInline: (0, $ff440597d7292b1f$export$958d0ae7f2977ae4),
    paddingInlineEnd: (0, $ff440597d7292b1f$export$958d0ae7f2977ae4),
    paddingInlineStart: (0, $ff440597d7292b1f$export$958d0ae7f2977ae4),
    paddingLeft: (0, $ff440597d7292b1f$export$958d0ae7f2977ae4),
    paddingRight: (0, $ff440597d7292b1f$export$958d0ae7f2977ae4),
    paddingTop: (0, $ff440597d7292b1f$export$958d0ae7f2977ae4),
    right: (0, $ff440597d7292b1f$export$632685d741f3dbbf),
    rowGap: (0, $ff440597d7292b1f$export$958d0ae7f2977ae4),
    top: (0, $ff440597d7292b1f$export$632685d741f3dbbf),
    width: (0, $ff440597d7292b1f$export$6ccdbebca2ee545f),
    zIndex: (0, $ff440597d7292b1f$export$b5f31a7e431d2eab)
};
var $2dab09527a25ccd1$var$uniqueSymbol = Symbol('UNSAFE_INTERNAL_styles');
var $2dab09527a25ccd1$var$isSafeEnvToThrow = function isSafeEnvToThrow() {
    return (typeof $3ZMUU === "undefined" ? "undefined" : (0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))($3ZMUU)) === 'object' && (0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))($3ZMUU.env) === 'object' && false;
};
var $2dab09527a25ccd1$var$reNestedSelectors = /(\.|\s|&+|\*\>|#|\[.*\])/;
var $2dab09527a25ccd1$var$safeSelectors = /^@media .*$|^::?.*$|^@supports .*$/;
var $2dab09527a25ccd1$var$_transformStyles = function transformStyles(styleObj) {
    if (!styleObj || (0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(styleObj) !== 'object') return styleObj;
    // If styles are defined as a CSSObject[], recursively call on each element until we reach CSSObject
    if (Array.isArray(styleObj)) return styleObj.map($2dab09527a25ccd1$var$_transformStyles);
    // Modifies styleObj in place. Be careful.
    Object.entries(styleObj).forEach(function(_ref) {
        var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_ref, 2), key = _ref2[0], value = _ref2[1];
        // If key is a pseudo class or a pseudo element, then value should be an object.
        // So, call transformStyles on the value
        if ((0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(value) === 'object' && $2dab09527a25ccd1$var$safeSelectors.test(key)) {
            styleObj[key] = $2dab09527a25ccd1$var$_transformStyles(value);
            return;
        }
        if ($2dab09527a25ccd1$var$isSafeEnvToThrow()) {
            // We don't support `.class`, `[data-testid]`, `> *`, `#some-id`
            if ($2dab09527a25ccd1$var$reNestedSelectors.test(key)) throw new Error("Styles not supported for key '".concat(key, "'."));
        }
        // We have now dealt with all the special cases, so,
        // check whether what remains is a style property
        // that can be transformed.
        if (!(key in $2dab09527a25ccd1$export$9a199fbafee0014e)) return;
        var tokenValue = $2dab09527a25ccd1$export$9a199fbafee0014e[key][value];
        styleObj[key] = tokenValue !== null && tokenValue !== void 0 ? tokenValue : value;
    });
    return styleObj;
};
var $2dab09527a25ccd1$var$baseXcss = function baseXcss(style) {
    var transformedStyles = $2dab09527a25ccd1$var$_transformStyles(style);
    return (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, $2dab09527a25ccd1$var$uniqueSymbol, (0, $74Zh5.css)(transformedStyles));
};
/**
 * Picks out runtime XCSS objects and build-time XCSS strings. This is needed
 * to supported both Emotion and Compiled styles until we've fully migrated
 * to Compiled.
 *
 * @private
 * @deprecated
 */ var $2dab09527a25ccd1$export$a9c84988c8f81f2d = function parseXcss(args) {
    if (Array.isArray(args)) {
        var emotion = [];
        var staticArr = [];
        var _iterator = $2dab09527a25ccd1$var$_createForOfIteratorHelper(args), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var arg = _step.value;
                var result = $2dab09527a25ccd1$export$a9c84988c8f81f2d(arg);
                if (result.emotion) emotion.push.apply(emotion, (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(result.emotion));
                if (result.static) staticArr.push(result.static);
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
        return {
            emotion: emotion,
            static: staticArr.join(' ')
        };
    }
    var objArgs = args;
    var _ref4 = objArgs || {}, styles = _ref4[$2dab09527a25ccd1$var$uniqueSymbol];
    if (styles) return {
        emotion: [
            styles
        ]
    };
    if (args) {
        // We use string interpolation here instead of .toString() just
        // in case the resulting object doesn't have the method available.
        var stringifiedArgs = "".concat(args);
        if (stringifiedArgs) return {
            static: stringifiedArgs
        };
    }
    return {};
};
function $2dab09527a25ccd1$export$f6c783d06584602c(style) {
    return $2dab09527a25ccd1$var$baseXcss(style);
}


var $bbb6a82c1990fc1e$var$_excluded = [
    "children",
    "backgroundColor",
    "padding",
    "paddingBlock",
    "paddingBlockStart",
    "paddingBlockEnd",
    "paddingInline",
    "paddingInlineStart",
    "paddingInlineEnd",
    "isDisabled",
    "type",
    "onClick",
    "interactionName",
    "componentName",
    "analyticsContext",
    "style",
    "testId",
    "xcss"
], $bbb6a82c1990fc1e$var$_excluded2 = [
    "className"
];
// This duplicates FocusRing styles from `@atlaskit/focus-ring`.
var $bbb6a82c1990fc1e$var$focusRingStyles = (0, $74Zh5.css)({
    '&:focus, &:focus-visible': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        outlineColor: (0, $ff440597d7292b1f$export$1531ad5bb3fbedac)['color.border.focused'],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        outlineOffset: (0, $ff440597d7292b1f$export$958d0ae7f2977ae4)['space.025'],
        outlineStyle: 'solid',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        outlineWidth: (0, $ff440597d7292b1f$export$e1b83c5210c471b8)['border.width.focused']
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
    '&:focus:not(:focus-visible)': {
        outline: 'none'
    },
    '@media screen and (forced-colors: active), screen and (-ms-high-contrast: active)': {
        '&:focus-visible': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
            outline: "".concat((0, $ff440597d7292b1f$export$e1b83c5210c471b8)['border.width'], " solid")
        }
    }
});
var $bbb6a82c1990fc1e$var$baseStyles = (0, $74Zh5.css)({
    boxSizing: 'border-box',
    appearance: 'none',
    border: 'none'
});
var $bbb6a82c1990fc1e$var$enabledStyles = (0, $74Zh5.css)({
    cursor: 'pointer'
});
var $bbb6a82c1990fc1e$var$disabledStyles = (0, $74Zh5.css)({
    cursor: 'not-allowed'
});
/**
 * __Pressable__
 *
 * A primitive for building custom buttons.
 *
 * - [Examples](https://atlassian.design/components/primitives/pressable/examples)
 * - [Code](https://atlassian.design/components/primitives/pressable/code)
 * - [Usage](https://atlassian.design/components/primitives/pressable/usage)
 */ var $bbb6a82c1990fc1e$var$Pressable = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function(_ref, ref) {
    var children = _ref.children, backgroundColor = _ref.backgroundColor, padding = _ref.padding, paddingBlock = _ref.paddingBlock, paddingBlockStart = _ref.paddingBlockStart, paddingBlockEnd = _ref.paddingBlockEnd, paddingInline = _ref.paddingInline, paddingInlineStart = _ref.paddingInlineStart, paddingInlineEnd = _ref.paddingInlineEnd, isDisabled = _ref.isDisabled, _ref$type = _ref.type, type = _ref$type === void 0 ? 'button' : _ref$type, _ref$onClick = _ref.onClick, providedOnClick = _ref$onClick === void 0 ? (0, $eVb4V.default) : _ref$onClick, interactionName = _ref.interactionName, componentName = _ref.componentName, analyticsContext = _ref.analyticsContext, style = _ref.style, testId = _ref.testId, xcss = _ref.xcss, htmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $bbb6a82c1990fc1e$var$_excluded);
    var interactionContext = (0, $5FkrB.useContext)((0, $eqVaP.default));
    var handleClick = (0, $5FkrB.useCallback)(function(e, analyticsEvent) {
        interactionContext && interactionContext.tracePress(interactionName, e.timeStamp);
        providedOnClick(e, analyticsEvent);
    }, [
        providedOnClick,
        interactionContext,
        interactionName
    ]);
    var onClick = (0, $a4990a43141cc076$export$a4687b0234b40e28)({
        fn: handleClick,
        action: 'clicked',
        componentName: componentName || 'Pressable',
        packageName: "@atlaskit/primitives",
        packageVersion: "17.1.0",
        analyticsData: analyticsContext,
        actionSubject: 'button'
    });
    // This is to remove className from safeHtmlAttributes
    // @ts-expect-error className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(htmlAttributes, $bbb6a82c1990fc1e$var$_excluded2);
    var resolvedStyles = (0, $2dab09527a25ccd1$export$a9c84988c8f81f2d)(xcss);
    return (0, $74Zh5.jsx)("button", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: style,
        ref: ref,
        className: resolvedStyles.static
    }, safeHtmlAttributes, {
        // eslint-disable-next-line react/button-has-type
        type: type,
        onClick: onClick,
        disabled: isDisabled,
        css: [
            $bbb6a82c1990fc1e$var$baseStyles,
            $bbb6a82c1990fc1e$var$focusRingStyles,
            isDisabled ? $bbb6a82c1990fc1e$var$disabledStyles : $bbb6a82c1990fc1e$var$enabledStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            backgroundColor && (0, $ff440597d7292b1f$export$e7af83bafe7f9e63)[backgroundColor],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            padding && (0, $ff440597d7292b1f$export$e615f061ca585a6c).padding[padding],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlock && (0, $ff440597d7292b1f$export$e615f061ca585a6c).paddingBlock[paddingBlock],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlockStart && (0, $ff440597d7292b1f$export$e615f061ca585a6c).paddingBlockStart[paddingBlockStart],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlockEnd && (0, $ff440597d7292b1f$export$e615f061ca585a6c).paddingBlockEnd[paddingBlockEnd],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInline && (0, $ff440597d7292b1f$export$e615f061ca585a6c).paddingInline[paddingInline],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInlineStart && (0, $ff440597d7292b1f$export$e615f061ca585a6c).paddingInlineStart[paddingInlineStart],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInlineEnd && (0, $ff440597d7292b1f$export$e615f061ca585a6c).paddingInlineEnd[paddingInlineEnd]
        ].concat((0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(resolvedStyles.emotion || [])),
        "data-testid": testId
    }), children);
});
var $bbb6a82c1990fc1e$export$2e2bcd8739ae039 = $bbb6a82c1990fc1e$var$Pressable;



var $5FkrB = parcelRequire("5FkrB");
// Map lozenge colors to appropriate icon colors
var $952fa62864493a7d$var$getIconColor = function getIconColor(color, isSelected) {
    // When lozenge is selected and interactive, use selected text color for consistency
    if (isSelected) return "var(--ds-icon-selected, #1868DB)";
    // For semantic colors, use corresponding semantic text colors
    switch(color){
        case 'success':
            return "var(--ds-icon-success, #6A9A23)";
        case 'warning':
            return "var(--ds-icon-warning, #E06C00)";
        case 'danger':
            return "var(--ds-icon-danger, #C9372C)";
        case 'information':
            return "var(--ds-icon-information, #357DE8)";
        case 'neutral':
            return "var(--ds-icon-subtlest, #6B6E76)";
        case 'discovery':
            return "var(--ds-icon-discovery, #AF59E1)";
        // For accent colors, use corresponding accent icon colors
        case 'accent-red':
            return "var(--ds-icon-accent-red, #C9372C)";
        case 'accent-orange':
            return "var(--ds-icon-accent-orange, #E06C00)";
        case 'accent-yellow':
            return "var(--ds-icon-accent-yellow, #B38600)";
        case 'accent-lime':
            return "var(--ds-icon-accent-lime, #6A9A23)";
        case 'accent-green':
            return "var(--ds-icon-accent-green, #22A06B)";
        case 'accent-teal':
            return "var(--ds-icon-accent-teal, #2898BD)";
        case 'accent-blue':
            return "var(--ds-icon-accent-blue, #357DE8)";
        case 'accent-purple':
            return "var(--ds-icon-accent-purple, #AF59E1)";
        case 'accent-magenta':
            return "var(--ds-icon-accent-magenta, #CD519D)";
        case 'accent-gray':
            return "var(--ds-icon-accent-gray, #7D818A)";
        default:
            return "var(--ds-icon-subtlest, #6B6E76)";
    }
};
var $952fa62864493a7d$export$32ff197eed95e568 = function IconRenderer(_ref) {
    var Icon = _ref.icon, color = _ref.color, isSelected = _ref.isSelected, testId = _ref.testId;
    var iconColor = $952fa62864493a7d$var$getIconColor(color, isSelected);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(Icon, {
        color: iconColor,
        label: "",
        size: "small",
        testId: testId
    });
};
var $952fa62864493a7d$export$2e2bcd8739ae039 = $952fa62864493a7d$export$32ff197eed95e568;


// Map legacy appearance to new color values
var $544d314b594cc2bf$var$legacyAppearanceMap = {
    default: 'neutral',
    removed: 'danger',
    inprogress: 'information',
    new: 'discovery',
    moved: 'warning'
};
var $544d314b594cc2bf$export$acf5d2b7dc999bda = function resolveLozengeColor() {
    var _legacyAppearanceMap$;
    var appearance = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'neutral';
    if (appearance.startsWith('accent-')) return appearance;
    return (_legacyAppearanceMap$ = $544d314b594cc2bf$var$legacyAppearanceMap[appearance]) !== null && _legacyAppearanceMap$ !== void 0 ? _legacyAppearanceMap$ : appearance;
};
var $544d314b594cc2bf$export$a3fc04b8551e006a = function getThemeStyles(resolvedColor) {
    var isAccent = resolvedColor.startsWith('accent-');
    var category = isAccent ? 'accent' : 'semantic';
    var key = isAccent ? resolvedColor.replace('accent-', '') : resolvedColor;
    return {
        category: category,
        key: key
    };
};


function $119f1c5fde147707$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $119f1c5fde147707$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $119f1c5fde147707$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $119f1c5fde147707$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $119f1c5fde147707$var$styles = {
    container: "_2rko12b0 _1reo15vq _18m915vq _zulp1b66 _1rjcv77o _18zr1b66 _189ee4h9 _1dqonqa1 _1h6d1j28 _1e0c116y _4cvr1h6o _vchhusvi _4t3igktf",
    containerInteractive: "_80omtlke _mizu1v1w _1ah3v77o _ra3xnqa1 _128mdkaa",
    containerSelected: "_bfhk15s3 _syaz6x5g _irr3ufnl _1di6nozp",
    text: "_11c8wadc _1reo15vq _18m915vq _1bto1l2s _o5721q9c",
    textSelected: "_syaz6x5g",
    'semantic.success': "_1b3i4pcx _3wu01mps _bfhk14j0 _syaz1p1e",
    'semantic.warning': "_1b3iervl _3wu01xiv _bfhk10f4 _syazmgs1",
    'semantic.danger': "_1b3is4qr _3wu01bqt _bfhk18wg _syaz1blx",
    'semantic.information': "_1b3iyhbg _3wu0vbh5 _bfhk8lbg _syaz1qd9",
    'semantic.neutral': "_1b3i1cv2 _3wu01ihb _bfhki8nm _syazi7uo",
    'semantic.discovery': "_1b3iqm1h _3wu0v30g _bfhke670 _syaz1g72",
    'accent.red': "_1b3inbxb _3wu016y8 _bfhk1rtt _syazhwvp",
    'accent.orange': "_1b3i1j6y _3wu01b2s _bfhk165s _syaz7i1p",
    'accent.yellow': "_1b3i1oqg _3wu0feiv _bfhk1773 _syazekll",
    'accent.lime': "_1b3i8645 _3wu0nf89 _bfhkz2ec _syaz1ik3",
    'accent.green': "_1b3i17hp _3wu01crs _bfhk1wnw _syaz1y78",
    'accent.teal': "_1b3i8uof _3wu01h3o _bfhk1a17 _syaz12v7",
    'accent.blue': "_1b3i6txe _3wu01w55 _bfhk1dy8 _syaz1kyx",
    'accent.purple': "_1b3iuq3u _3wu01hqq _bfhk1nm4 _syaz1mn1",
    'accent.magenta': "_1b3iv8hk _3wu0uwd0 _bfhkv9ra _syaz1qur",
    'accent.gray': "_1b3i1diz _3wu08yml _bfhkysee _syaz1tmo",
    'interactive.semantic.success': "_irr31r82 _1di6d6jc",
    'interactive.semantic.warning': "_irr31yx4 _1di6bkku",
    'interactive.semantic.danger': "_irr370oi _1di6jkmi",
    'interactive.semantic.information': "_irr315aw _1di6ar1y",
    'interactive.semantic.neutral': "_irr3plhp _1di61gdz",
    'interactive.semantic.discovery': "_irr3rumk _1di65usi",
    'interactive.accent.red': "_irr3affd _1di61j5a",
    'interactive.accent.orange': "_irr31ei0 _1di6dpo3",
    'interactive.accent.yellow': "_irr31uw7 _1di61r9w",
    'interactive.accent.lime': "_irr31gf0 _1di62kxc",
    'interactive.accent.green': "_irr31e2h _1di6ybhx",
    'interactive.accent.teal': "_irr3kwwr _1di61jb0",
    'interactive.accent.blue': "_irr3815t _1di6rwxf",
    'interactive.accent.purple': "_irr3attl _1di63nfk",
    'interactive.accent.magenta': "_irr31axx _1di642ri",
    'interactive.accent.gray': "_irr3wejn _1di618ut",
    selectedInteractive: "_irr3ufnl _1di6nozp",
    iconBorderFilter: "_1h6dzs9d _4uq11yqs _1k671038 _m71tr3uz _13muu67f _168qx19p _oe6mmko7 _189qkb7n _u8p61h4e _1t75u67f _hg5mr3uz _1f28f1ug _1xe213rw _1easxmrh _1r9r1ss3",
    iconBorderInteractiveFilter: "_1iel6xdd _111i1h4e _18dicjiy _hyog26zw _fdt01r5k _46v5hwvj _ylgq1r5k _bg3q9by0 _196p1btq _18mn783i _l0666xdd _pclnn8xv _ockq1r5k _aewt1n8h _4cvx7ddx _1cp21w66 _q4zt1csi _1gqs1mvc _75gv2l9f _1lh71sfd _ui3h1ct7 _11o31cha"
};
/**
 * __New Lozenge__
 *
 * A lozenge is a visual indicator used to highlight an item's status for quick recognition.
 * This is the updated version with the new North Star visual language.
 */ var $119f1c5fde147707$var$LozengeBase = /*#__PURE__*/ (0, $5FkrB.memo)(/*#__PURE__*/ (0, $5FkrB.forwardRef)(function(_ref, ref) {
    var children = _ref.children, testId = _ref.testId, appearance = _ref.appearance, iconBefore = _ref.iconBefore, _ref$maxWidth = _ref.maxWidth, maxWidth = _ref$maxWidth === void 0 ? 200 : _ref$maxWidth, isSelected = _ref.isSelected, onClick = _ref.onClick, style = _ref.style, analyticsContext = _ref.analyticsContext, interactionName = _ref.interactionName;
    var isInteractive = typeof onClick === 'function';
    // Determine the effective color, with fallback logic for legacy appearances
    var resolvedColor = (0, $544d314b594cc2bf$export$acf5d2b7dc999bda)(appearance) || 'neutral';
    var _getThemeStyles = (0, $544d314b594cc2bf$export$a3fc04b8551e006a)(resolvedColor), category = _getThemeStyles.category, key = _getThemeStyles.key;
    var colorStyleKey = "".concat(category, ".").concat(key);
    var interactiveStyleKey = "interactive.".concat(category, ".").concat(key);
    var maxWidthValue = typeof maxWidth === 'string' ? maxWidth : "".concat(maxWidth, "px");
    var maxWidthIsPc = typeof maxWidth === 'string' && /%$/.test(maxWidth);
    var commonStyleOverrides = {
        backgroundColor: style === null || style === void 0 ? void 0 : style.backgroundColor,
        maxWidth: maxWidthIsPc ? maxWidth : '100%'
    };
    var innerContent = /*#__PURE__*/ $5FkrB.createElement((0, $5FkrB.Fragment), null, iconBefore && /*#__PURE__*/ $5FkrB.createElement((0, $952fa62864493a7d$export$2e2bcd8739ae039), {
        icon: iconBefore,
        color: resolvedColor,
        isSelected: isInteractive ? isSelected : undefined,
        testId: testId && "".concat(testId, "--icon")
    }), /*#__PURE__*/ $5FkrB.createElement("span", {
        style: {
            maxWidth: maxWidthIsPc ? '100%' : "calc(".concat(maxWidthValue, " - ", "var(--ds-space-100, 8px)", ")"),
            color: style === null || style === void 0 ? void 0 : style.color
        },
        "data-testid": testId && "".concat(testId, "--text"),
        className: (0, $970q7.default)([
            $119f1c5fde147707$var$styles.text
        ])
    }, children), isInteractive && /*#__PURE__*/ $5FkrB.createElement((0, (/*@__PURE__*/$parcel$interopDefault($8b2dd9bf72c54e50$exports))), {
        label: "",
        size: "small",
        color: isSelected ? "var(--ds-icon-selected, #1868DB)" : 'currentColor',
        testId: testId && "".concat(testId, "--chevron")
    }));
    if (isInteractive) return /*#__PURE__*/ $5FkrB.createElement((0, $bbb6a82c1990fc1e$export$2e2bcd8739ae039), {
        ref: ref,
        xcss: (0, $947a6ea09ef50dc7$export$a274e22fb40f762e)($119f1c5fde147707$var$styles.container, !isSelected && $119f1c5fde147707$var$styles.iconBorderFilter, !isSelected && $119f1c5fde147707$var$styles.iconBorderInteractiveFilter, $119f1c5fde147707$var$styles[colorStyleKey], $119f1c5fde147707$var$styles[interactiveStyleKey], isSelected && $119f1c5fde147707$var$styles.containerSelected),
        onClick: onClick,
        style: $119f1c5fde147707$var$_objectSpread($119f1c5fde147707$var$_objectSpread({}, commonStyleOverrides), {}, {
            // Specified because Pressable has a default border:none which overrides the border specified on the container
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            border: "solid ".concat("var(--ds-border-width, 1px)", " ", isSelected ? "var(--ds-border-selected, #1868DB)" : 'transparent')
        }),
        testId: testId,
        analyticsContext: analyticsContext,
        interactionName: interactionName,
        componentName: "LozengeDropdownTrigger"
    }, innerContent);
    return /*#__PURE__*/ $5FkrB.createElement("span", {
        ref: ref,
        style: commonStyleOverrides,
        "data-testid": testId,
        className: (0, $970q7.default)([
            $119f1c5fde147707$var$styles.container,
            $119f1c5fde147707$var$styles[colorStyleKey],
            $119f1c5fde147707$var$styles.iconBorderFilter
        ])
    }, innerContent);
}));
var $119f1c5fde147707$export$2e2bcd8739ae039 = $119f1c5fde147707$var$LozengeBase;


/**
 * __Lozenge__
 *
 * A lozenge is a visual indicator used to highlight an item's status for quick recognition.
 *
 * - [Examples](https://atlassian.design/components/lozenge/examples)
 * - [Code](https://atlassian.design/components/lozenge/code)
 * - [Usage](https://atlassian.design/components/lozenge/usage)
 */ var $7014fda20d125c7a$var$Lozenge = function Lozenge(_ref) {
    var _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'neutral' : _ref$appearance, _ref$maxWidth = _ref.maxWidth, maxWidth = _ref$maxWidth === void 0 ? 200 : _ref$maxWidth, style = _ref.style, testId = _ref.testId, children = _ref.children, iconBefore = _ref.iconBefore;
    return /*#__PURE__*/ $5FkrB.createElement((0, $119f1c5fde147707$export$2e2bcd8739ae039), {
        appearance: appearance,
        iconBefore: iconBefore,
        maxWidth: maxWidth,
        style: style,
        testId: testId
    }, children);
};
$7014fda20d125c7a$var$Lozenge.displayName = 'Lozenge';
var $7014fda20d125c7a$export$2e2bcd8739ae039 = $7014fda20d125c7a$var$Lozenge;


/**
 * TODO: We should be using our bounded `cssMap` here, but most of
 * these styles from the visual refresh are not in the Design System.
 */ var $7eec63d374a0c632$var$styles = {
    container: "_2rkofajl _1reo15vq _18m915vq _1e0c116y _vchhusvi _kqswpfqs _1kz6184x _bozg1b66 _y4ti1b66",
    containerSubtle: "_1cwg1n1a",
    text: "_1reo15vq _18m915vq _ect4ttxp _1wyb1skh _zg8l4jg8 _k48pwu06 _vwz47vkz _1bto1l2s _1p1dangw _o5721q9c",
    customLetterspacing: "_1dyz9vsi",
    'bg.bold.default': "_bfhk1fkg",
    'bg.bold.inprogress': "_bfhk1ymo",
    'bg.bold.moved': "_bfhkxmjf",
    'bg.bold.new': "_bfhkshej",
    'bg.bold.removed': "_bfhk1366",
    'bg.bold.success': "_bfhk3uhp",
    'bg.subtle.default': "_bfhksm61",
    'bg.subtle.inprogress': "_bfhksm61",
    'bg.subtle.moved': "_bfhksm61",
    'bg.subtle.new': "_bfhksm61",
    'bg.subtle.removed': "_bfhksm61",
    'bg.subtle.success': "_bfhksm61",
    'outline.subtle.default': "_12ji14je _1qu2nqa1 _12y3t94y",
    'outline.subtle.inprogress': "_12jiuisw _1qu2nqa1 _12y3t94y",
    'outline.subtle.moved': "_12jih727 _1qu2nqa1 _12y3t94y",
    'outline.subtle.new': "_12ji157s _1qu2nqa1 _12y3t94y",
    'outline.subtle.removed': "_12jia2c0 _1qu2nqa1 _12y3t94y",
    'outline.subtle.success': "_12jin0nx _1qu2nqa1 _12y3t94y",
    'text.subtle': "_syazi7uo",
    'text.bold': "_syazwwip"
};
var $7eec63d374a0c632$var$appearanceTypes = [
    'default',
    'inprogress',
    'moved',
    'new',
    'removed'
];
var $7eec63d374a0c632$var$newSemanticColors = [
    'success',
    'discovery',
    'warning',
    'danger',
    'information',
    'neutral'
];
var $7eec63d374a0c632$var$appearanceMapping = {
    neutral: 'default',
    default: 'default',
    information: 'inprogress',
    inprogress: 'inprogress',
    warning: 'moved',
    moved: 'moved',
    removed: 'removed',
    danger: 'removed',
    success: 'success',
    discovery: 'new',
    new: 'new'
};
/**
 * __Lozenge__
 *
 * A lozenge is a visual indicator used to highlight an item's status for quick recognition.
 *
 * - [Examples](https://atlassian.design/components/lozenge/examples)
 * - [Code](https://atlassian.design/components/lozenge/code)
 * - [Usage](https://atlassian.design/components/lozenge/usage)
 */ var $7eec63d374a0c632$var$LegacyLozenge = /*#__PURE__*/ (0, $5FkrB.memo)(function(_ref) {
    var children = _ref.children, testId = _ref.testId, _ref$isBold = _ref.isBold, isBold = _ref$isBold === void 0 ? false : _ref$isBold, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'default' : _ref$appearance, _ref$maxWidth = _ref.maxWidth, maxWidth = _ref$maxWidth === void 0 ? 200 : _ref$maxWidth, style = _ref.style;
    var appearanceStyle = isBold ? 'bold' : 'subtle';
    var appearanceType = (0, $5FkrB.useMemo)(function() {
        return $7eec63d374a0c632$var$appearanceTypes.includes(appearance) || $7eec63d374a0c632$var$newSemanticColors.includes(appearance) ? $7eec63d374a0c632$var$appearanceMapping[appearance] : 'default';
    }, [
        appearance
    ]);
    var maxWidthValue = typeof maxWidth === 'string' ? maxWidth : "".concat(maxWidth, "px");
    var maxWidthIsPc = typeof maxWidth === 'string' && /%$/.test(maxWidth);
    return /*#__PURE__*/ $5FkrB.createElement("span", {
        style: {
            backgroundColor: style === null || style === void 0 ? void 0 : style.backgroundColor,
            maxWidth: maxWidthIsPc ? maxWidth : '100%'
        },
        "data-testid": testId,
        className: (0, $970q7.default)([
            $7eec63d374a0c632$var$styles.container,
            $7eec63d374a0c632$var$styles["bg.".concat(appearanceStyle, ".").concat(appearanceType)],
            appearanceStyle === 'subtle' && $7eec63d374a0c632$var$styles["outline.subtle.".concat(appearanceType)],
            appearanceStyle === 'subtle' && $7eec63d374a0c632$var$styles.containerSubtle
        ])
    }, /*#__PURE__*/ $5FkrB.createElement("span", {
        style: {
            color: style === null || style === void 0 ? void 0 : style.color,
            // to negate paddingInline specified on Box above
            maxWidth: maxWidthIsPc ? '100%' : "calc(".concat(maxWidthValue, " - ", "var(--ds-space-100, 8px)", ")")
        },
        "data-testid": testId && "".concat(testId, "--text"),
        className: (0, $970q7.default)([
            $7eec63d374a0c632$var$styles.text,
            (0, $9Zzpd.fg)('platform-lozenge-custom-letterspacing') && $7eec63d374a0c632$var$styles.customLetterspacing,
            $7eec63d374a0c632$var$styles["text.".concat(appearanceStyle)]
        ])
    }, children));
});
$7eec63d374a0c632$var$LegacyLozenge.displayName = 'Lozenge';
/**
 * Wrapper component that switches between old and new Lozenge based on feature flag
 */ var $7eec63d374a0c632$var$LozengeWrapper = /*#__PURE__*/ (0, $5FkrB.memo)(function(props) {
    if ((0, $9Zzpd.fg)('platform-dst-lozenge-tag-badge-visual-uplifts')) return /*#__PURE__*/ $5FkrB.createElement((0, $7014fda20d125c7a$export$2e2bcd8739ae039), props);
    return /*#__PURE__*/ $5FkrB.createElement($7eec63d374a0c632$var$LegacyLozenge, props);
});
$7eec63d374a0c632$var$LozengeWrapper.displayName = 'Lozenge';
var $7eec63d374a0c632$export$2e2bcd8739ae039 = $7eec63d374a0c632$var$LozengeWrapper;



var $8ffabcfbf2ef3dad$export$5f70fe304106fcb1 = function LozengeOptionLabel(_ref) {
    var lozengeOption = _ref.lozengeOption;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $aec9472fc55898fa$export$844bee7de236d7ec), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $aec9472fc55898fa$export$8133811dea85f484), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $aec9472fc55898fa$export$7c16ae7705e422c4), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $7eec63d374a0c632$export$2e2bcd8739ae039), {
        appearance: lozengeOption.appearance,
        isBold: lozengeOption.isBold,
        maxWidth: lozengeOption.maxWidth
    }, lozengeOption.label))));
};


var $5a90e7b9fdef9647$var$formatOptionLabel = function formatOptionLabel(option) {
    if (option.optionType === 'option') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $302763904e393669$export$914fa095fc1e0a45), {
        option: option
    });
    if (option.optionType === 'avatar') return option.hideAvatar === true ? option.label : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $be56e1dccdd4b04b$export$fe00f602c942368a), {
        avatarOption: option
    });
    if (option.optionType === 'lozenge') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $8ffabcfbf2ef3dad$export$5f70fe304106fcb1), {
        lozengeOption: option
    });
    // eslint-disable-next-line no-console
    console.error('`formatOptionLabel` was passed an unsupported `SelectOption`:', option);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).Fragment, null);
};
var $5a90e7b9fdef9647$export$2e2bcd8739ae039 = $5a90e7b9fdef9647$var$formatOptionLabel;


// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $e9bd2f69f949e8ed$export$999ca5bf223f627 = (0, $0b1eca56b0789a79$export$2e2bcd8739ae039).div({
    minWidth: '220px'
});


var $28a44b62f5812c94$export$ba25329847403e11 = function Picker(_ref) {
    var ariaLabel = _ref.ariaLabel, isOpen = _ref.isOpen, value = _ref.value, onClose = _ref.onClose, onClearValues = _ref.onClearValues, fieldId = _ref.fieldId, fieldLabel = _ref.fieldLabel, fieldInvalidLabel = _ref.fieldInvalidLabel, onChange = _ref.onChange, _ref$formatOptionLabe = _ref.formatOptionLabel, formatOptionLabel = _ref$formatOptionLabe === void 0 ? (0, $5a90e7b9fdef9647$export$2e2bcd8739ae039) : _ref$formatOptionLabe, onLoadOptions = _ref.onLoadOptions, pagination = _ref.pagination, PopupComponent = _ref.PopupComponent, onTrigger = _ref.onTrigger, _ref$initiallyAddSele = _ref.initiallyAddSelectedFirst, initiallyAddSelectedFirst = _ref$initiallyAddSele === void 0 ? true : _ref$initiallyAddSele, _ref$showFooter = _ref.showFooter, showFooter = _ref$showFooter === void 0 ? true : _ref$showFooter, popupProps = _ref.popupProps;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $de01b096d7a510fa$export$b61655080b0a1f32), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $37263ce7a04262dd$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        key: fieldId,
        placement: "bottom-start",
        isOpen: isOpen,
        onClose: onClose,
        popupComponent: PopupComponent,
        shouldRenderToParent: true,
        trigger: onTrigger,
        autoFocus: false,
        content: function content() {
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $e9bd2f69f949e8ed$export$999ca5bf223f627), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $e20b38a672704dfe$export$2e2bcd8739ae039), {
                field: {
                    isRemovable: false,
                    label: fieldLabel || '',
                    invalidLabel: fieldInvalidLabel,
                    type: 'Filter',
                    key: fieldId,
                    defaultOptionsLabel: 'defaultOptionsLabel',
                    defaultOptions: true,
                    cacheOptions: false,
                    inputValue: 'string',
                    enableShowMore: true,
                    pagination: pagination,
                    loadOptions: onLoadOptions
                },
                onChange: onChange,
                value: value,
                formatOptionLabel: formatOptionLabel,
                onClear: onClearValues,
                initiallyAddSelectedFirst: initiallyAddSelectedFirst,
                showFooter: showFooter,
                ariaLabel: ariaLabel
            }));
        }
    }, popupProps)));
};



var $5FkrB = parcelRequire("5FkrB");
/* badge.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");

var $9Zzpd = parcelRequire("9Zzpd");
/* text.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");

var $afMOk = parcelRequire("afMOk");

var $5FkrB = parcelRequire("5FkrB");
var $4fc2dd7cdebee651$var$HasTextAncestorContext = /*#__PURE__*/ (0, $5FkrB.createContext)(false);
var $4fc2dd7cdebee651$export$9322276ec105d055 = function useHasTextAncestor() {
    return (0, $5FkrB.useContext)($4fc2dd7cdebee651$var$HasTextAncestorContext);
};
var $4fc2dd7cdebee651$export$ae933c6cbe5643ad = $4fc2dd7cdebee651$var$HasTextAncestorContext.Provider;



var $5FkrB = parcelRequire("5FkrB");
var $3b9750c1f93dbbfb$export$1ca2a26fecb070ae = /*#__PURE__*/ (0, $5FkrB.createContext)('elevation.surface');
var $3b9750c1f93dbbfb$export$1aeb4f6b93c4540d = function useSurface() {
    return (0, $5FkrB.useContext)($3b9750c1f93dbbfb$export$1ca2a26fecb070ae);
};
$3b9750c1f93dbbfb$export$1ca2a26fecb070ae.displayName = 'SurfaceProvider';


var $03748c549e9ae27a$var$asAllowlist = [
    'span',
    'p',
    'strong',
    'em'
];
/**
 * Custom hook designed to abstract the parsing of the color props and make it clearer in the future how color is reconciled between themes and tokens.
 */ var $03748c549e9ae27a$var$useColor = function useColor(colorProp, hasTextAncestor) {
    var surface = (0, $3b9750c1f93dbbfb$export$1aeb4f6b93c4540d)();
    if (colorProp === 'inherit') return undefined;
    if (colorProp) return colorProp;
    if (hasTextAncestor) return undefined;
    if ($03748c549e9ae27a$export$2185ce37f9bdd963.hasOwnProperty(surface)) return $03748c549e9ae27a$export$2185ce37f9bdd963[surface];
    return 'color.text';
};
var $03748c549e9ae27a$var$styles = {
    root: "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _1i4qfg65",
    'as.strong': "_k48pwu06",
    'as.em': "_zg8l1m30",
    'textAlign.center': "_y3gn1h6o",
    'textAlign.end': "_y3gnh9n0",
    'textAlign.start': "_y3gnv2br",
    truncation: "_1reo15vq _18m915vq _1e0ccj1k _sudp1e54",
    breakAll: "_1nmz9jpi"
};
var $03748c549e9ae27a$var$fontSizeMap = {
    medium: "_11c8fhey",
    UNSAFE_small: "_11c8rymc",
    large: "_11c81d4k",
    small: "_11c8wadc"
};
var $03748c549e9ae27a$var$fontWeightMap = {
    bold: "_k48pwu06",
    medium: "_k48p1wq8",
    regular: "_k48pi7a9",
    semibold: "_k48p1pd9"
};
var $03748c549e9ae27a$var$textColorMap = {
    'color.text': "_syazi7uo",
    'color.text.accent.lime': "_syaz1tco",
    'color.text.accent.lime.bolder': "_syaz1ik3",
    'color.text.accent.red': "_syaz9lu1",
    'color.text.accent.red.bolder': "_syazhwvp",
    'color.text.accent.orange': "_syazp1lv",
    'color.text.accent.orange.bolder': "_syaz7i1p",
    'color.text.accent.yellow': "_syazfb2s",
    'color.text.accent.yellow.bolder': "_syazekll",
    'color.text.accent.green': "_syazh55r",
    'color.text.accent.green.bolder': "_syaz1y78",
    'color.text.accent.teal': "_syaz17qg",
    'color.text.accent.teal.bolder': "_syaz12v7",
    'color.text.accent.blue': "_syaz16jw",
    'color.text.accent.blue.bolder': "_syaz1kyx",
    'color.text.accent.purple': "_syazqmo9",
    'color.text.accent.purple.bolder': "_syaz1mn1",
    'color.text.accent.magenta': "_syaz1s8m",
    'color.text.accent.magenta.bolder': "_syaz1qur",
    'color.text.accent.gray': "_syaz1sqi",
    'color.text.accent.gray.bolder': "_syaz1tmo",
    'color.text.disabled': "_syaz1gmx",
    'color.text.inverse': "_syaz15cr",
    'color.text.selected': "_syaz6x5g",
    'color.text.brand': "_syaz1oa5",
    'color.text.danger': "_syaz1tmw",
    'color.text.warning': "_syaz1xn9",
    'color.text.warning.inverse': "_syaz1yd3",
    'color.text.success': "_syazgsak",
    'color.text.discovery': "_syazdv2p",
    'color.text.information': "_syazu3tg",
    'color.text.subtlest': "_syaz1rpy",
    'color.text.subtle': "_syazazsu",
    'color.link': "_syaz13af",
    'color.link.pressed': "_syaz12zz",
    'color.link.visited': "_syaz1ra0",
    'color.link.visited.pressed': "_syaz17z1"
};
var $03748c549e9ae27a$export$2185ce37f9bdd963 = {
    'color.background.neutral.bold': 'color.text.inverse',
    'color.background.neutral.bold.hovered': 'color.text.inverse',
    'color.background.neutral.bold.pressed': 'color.text.inverse',
    'color.background.selected.bold': 'color.text.inverse',
    'color.background.selected.bold.hovered': 'color.text.inverse',
    'color.background.selected.bold.pressed': 'color.text.inverse',
    'color.background.brand.bold': 'color.text.inverse',
    'color.background.brand.bold.hovered': 'color.text.inverse',
    'color.background.brand.bold.pressed': 'color.text.inverse',
    'color.background.brand.boldest': 'color.text.inverse',
    'color.background.brand.boldest.hovered': 'color.text.inverse',
    'color.background.brand.boldest.pressed': 'color.text.inverse',
    'color.background.danger.bold': 'color.text.inverse',
    'color.background.danger.bold.hovered': 'color.text.inverse',
    'color.background.danger.bold.pressed': 'color.text.inverse',
    'color.background.warning.bold': 'color.text.warning.inverse',
    'color.background.warning.bold.hovered': 'color.text.warning.inverse',
    'color.background.warning.bold.pressed': 'color.text.warning.inverse',
    'color.background.success.bold': 'color.text.inverse',
    'color.background.success.bold.hovered': 'color.text.inverse',
    'color.background.success.bold.pressed': 'color.text.inverse',
    'color.background.discovery.bold': 'color.text.inverse',
    'color.background.discovery.bold.hovered': 'color.text.inverse',
    'color.background.discovery.bold.pressed': 'color.text.inverse',
    'color.background.information.bold': 'color.text.inverse',
    'color.background.information.bold.hovered': 'color.text.inverse',
    'color.background.information.bold.pressed': 'color.text.inverse'
};
/**
 * __Text__
 *
 * Text is a primitive component that has the Atlassian Design System's design guidelines baked in.
 * This includes considerations for text attributes such as color, font size, font weight, and line height.
 * It renders a `span` by default.
 *
 * @internal
 */ var $03748c549e9ae27a$var$Text = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? 'span' : _ref$as, colorProp = _ref.color, align = _ref.align, testId = _ref.testId, id = _ref.id, size = _ref.size, weight = _ref.weight, maxLines = _ref.maxLines, xcss = _ref.xcss, children = _ref.children;
    (0, $afMOk.default)($03748c549e9ae27a$var$asAllowlist.includes(Component), "@atlaskit/primitives: Text received an invalid \"as\" value of \"".concat(Component, "\""));
    var hasTextAncestor = (0, $4fc2dd7cdebee651$export$9322276ec105d055)();
    var color = $03748c549e9ae27a$var$useColor(colorProp, hasTextAncestor);
    if (!size && !hasTextAncestor) size = 'medium';
    var component = /*#__PURE__*/ $5FkrB.createElement(Component, {
        id: id,
        className: (0, $970q7.default)([
            $03748c549e9ae27a$var$styles.root,
            size && $03748c549e9ae27a$var$fontSizeMap[size],
            color && $03748c549e9ae27a$var$textColorMap[color],
            maxLines && $03748c549e9ae27a$var$styles.truncation,
            maxLines === 1 && $03748c549e9ae27a$var$styles.breakAll,
            align && $03748c549e9ae27a$var$styles["textAlign.".concat(align)],
            weight && $03748c549e9ae27a$var$fontWeightMap[weight],
            Component === 'em' && $03748c549e9ae27a$var$styles['as.em'],
            Component === 'strong' && $03748c549e9ae27a$var$styles['as.strong'],
            xcss
        ]),
        style: {
            WebkitLineClamp: maxLines
        },
        "data-testid": testId,
        ref: ref
    }, children);
    if (hasTextAncestor) // no need to re-apply context if the text is already wrapped
    return component;
    return /*#__PURE__*/ $5FkrB.createElement((0, $4fc2dd7cdebee651$export$ae933c6cbe5643ad), {
        value: true
    }, component);
});
var $03748c549e9ae27a$export$2e2bcd8739ae039 = $03748c549e9ae27a$var$Text;


/* badge-new.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");

function $ccf3980778319ef1$var$getSafeValueWithNegativeSupport() {
    var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    var numericValue = +value;
    // NOTE: Changing below code as this causes custom fields -ve number to show up as zero in activity timeline.
    // This will ensure it renders correctly if it is a number otherwise renders 0
    // If the value is NaN, return it as is (assuming it's a non-numeric string)
    if (isNaN(numericValue)) return value;
    // Return the numeric value, allowing negative numbers
    return numericValue;
}
function $ccf3980778319ef1$export$4b844743568d5983(value, max) {
    var safeValue = $ccf3980778319ef1$var$getSafeValueWithNegativeSupport(value);
    var safeMax = $ccf3980778319ef1$var$getSafeValueWithNegativeSupport(max);
    var hasSafeMaxValue = false;
    if (max !== undefined) hasSafeMaxValue = true;
    if (safeMax === Infinity && safeValue === Infinity) return "\u221E";
    if (hasSafeMaxValue && safeMax < safeValue) return "".concat(safeMax, "+");
    if (safeValue === Infinity) return "\u221E";
    return safeValue.toString();
}
function $ccf3980778319ef1$var$getSafeValue() {
    var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    var numericValue = +value;
    if (numericValue < 0) return 0;
    return value;
}
function $ccf3980778319ef1$export$7c4d25c0c3217d8c(value, max) {
    var safeValue = $ccf3980778319ef1$var$getSafeValue(value);
    var safeMax = $ccf3980778319ef1$var$getSafeValue(max);
    if (safeMax && safeMax < safeValue) return "".concat(safeMax, "+");
    if (safeValue === Infinity) return "\u221E";
    return safeValue.toString();
}


var $0a587fe88de97939$export$d21bba0569254935 = {
    added: 'success',
    removed: 'danger',
    default: 'neutral',
    primary: 'information',
    primaryInverted: 'inverse',
    important: 'danger',
    warning: 'warning',
    discovery: 'discovery',
    danger: 'danger',
    success: 'success',
    information: 'information',
    inverse: 'inverse',
    neutral: 'neutral'
};
var $0a587fe88de97939$export$16f8cc7ac3541e83 = {
    added: 'added',
    removed: 'removed',
    default: 'default',
    primary: 'primary',
    primaryInverted: 'primaryInverted',
    important: 'important',
    danger: 'removed',
    success: 'added',
    information: 'primary',
    inverse: 'primaryInverted',
    neutral: 'default',
    warning: 'default',
    discovery: 'default'
};
/* eslint-disable @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors */ // Nested selectors with data attributes are required for theme switching
var $0a587fe88de97939$var$stylesNew = {
    root: "_2rkolb4i _18zr1b66 _1rjcidpf _1e0c116y _vchhusvi _1ul91ejb _1bah1h6o _1o9zidpf _1kz6184x",
    success: "_syaz1p1e _bfhk1s9h _1ut5iv2r _1cn41hpu",
    danger: "_syaz1blx _bfhkrkii _1ut5zp7h _1cn484f9",
    warning: "_bfhk1kmu _syazmgs1 _15ua14ug _1cn4do2b",
    information: "_syaz1qd9 _bfhk1dq8 _1ut5e5eq _1cn4xr8b",
    discovery: "_syaz1g72 _bfhkiizu _1ut51bbx _1cn417oz",
    neutral: "_syazi7uo _bfhk7i23 _1ut5z5kg _1cn41g0e",
    inverse: "_bfhkvuon _syazi7uo"
};
/* eslint-enable @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors */ var $0a587fe88de97939$var$badgeValueWithNegativeNumberSupported = function badgeValueWithNegativeNumberSupported(children, max) {
    return typeof children === 'number' && max ? (0, $ccf3980778319ef1$export$7c4d25c0c3217d8c)(children, max) : children;
};
/**
 * __BadgeNew__
 *
 * New visual refresh implementation of Badge component for the labelling system.
 * This component is used when the 'platform-dst-lozenge-tag-badge-visual-uplifts' feature flag is enabled.
 *
 * Uses new appearance naming convention:
 * - success (green)
 * - danger (red)
 * - neutral (gray)
 * - information (blue)
 * - inverse (inverted colors)
 * - warning (orange/yellow)
 * - discovery (purple)
 */ var $0a587fe88de97939$var$BadgeNew = /*#__PURE__*/ (0, $5FkrB.memo)(function BadgeNew(_ref) {
    var _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'neutral' : _ref$appearance, _ref$children = _ref.children, children = _ref$children === void 0 ? 0 : _ref$children, _ref$max = _ref.max, max = _ref$max === void 0 ? 99 : _ref$max, style = _ref.style, testId = _ref.testId;
    return /*#__PURE__*/ $5FkrB.createElement("span", {
        "data-testid": testId,
        style: {
            background: style === null || style === void 0 ? void 0 : style.backgroundColor,
            color: style === null || style === void 0 ? void 0 : style.color
        },
        className: (0, $970q7.default)([
            $0a587fe88de97939$var$stylesNew.root,
            $0a587fe88de97939$var$stylesNew[appearance]
        ])
    }, /*#__PURE__*/ $5FkrB.createElement((0, $03748c549e9ae27a$export$2e2bcd8739ae039), {
        size: "small",
        align: "center",
        color: "inherit"
    }, $0a587fe88de97939$var$badgeValueWithNegativeNumberSupported(children, max)));
});
var $0a587fe88de97939$export$2e2bcd8739ae039 = $0a587fe88de97939$var$BadgeNew;



/**
 * Visual refresh colors.
 * Hardcoded hex colors are used as the they will be updated in the labelling system work and we want to avoid frequent UI changes.\
 *
 * Using separate variables as opposed to an object, to comply with UI styling standard
 * https://atlassian.design/components/eslint-plugin-ui-styling-standard/no-unsafe-values/usage#object-access
 */ var $3a450d13d3d4e243$var$neutral300 = '#DDDEE1';
var $3a450d13d3d4e243$var$red300 = '#FD9891';
var $3a450d13d3d4e243$var$blue300 = '#8FB8F6';
var $3a450d13d3d4e243$var$neutral1000 = '#292A2E';
var $3a450d13d3d4e243$var$styles = {
    root: "_2rkolb4i _18zr1b66 _1e0c116y _vchhusvi _1ul91ejb _1bah1h6o _1o9zidpf _1kz6184x",
    added: "_bfhk1y9u _syazi7uo",
    default: "_bfhk1fkg _syazwwip",
    important: "_bfhk1366 _syazwwip",
    primary: "_bfhk1ymo _syazwwip",
    primaryInverted: "_bfhkvuon _syaz1oa5",
    removed: "_bfhk1gly _syazi7uo"
};
var $3a450d13d3d4e243$var$badgeValueWithNegativeNumberSupported = function badgeValueWithNegativeNumberSupported(children, max) {
    return typeof children === 'number' && typeof max === 'number' ? (0, $ccf3980778319ef1$export$4b844743568d5983)(children, max) : children;
};
/**
 * __Badge__
 *
 * This component gives you the full badge functionality and automatically formats the number you provide in \`children\`.
 *
 * - [Examples](https://atlassian.design/components/badge/examples)
 * - [Code](https://atlassian.design/components/badge/code)
 * - [Usage](https://atlassian.design/components/badge/usage)
 */ var $3a450d13d3d4e243$var$Badge = /*#__PURE__*/ (0, $5FkrB.memo)(function Badge(_ref) {
    var _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'default' : _ref$appearance, _ref$children = _ref.children, children = _ref$children === void 0 ? 0 : _ref$children, _ref$max = _ref.max, max = _ref$max === void 0 ? 99 : _ref$max, style = _ref.style, testId = _ref.testId;
    if ((0, $9Zzpd.fg)('platform-dst-lozenge-tag-badge-visual-uplifts')) {
        // Map old appearance names to new ones
        var newAppearance = (0, $0a587fe88de97939$export$d21bba0569254935)[appearance];
        return(/*#__PURE__*/ // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        $5FkrB.createElement((0, $0a587fe88de97939$export$2e2bcd8739ae039), {
            appearance: newAppearance,
            max: max,
            style: style,
            testId: testId
        }, children));
    }
    var oldAppearance = (0, $0a587fe88de97939$export$16f8cc7ac3541e83)[appearance];
    return /*#__PURE__*/ $5FkrB.createElement("span", {
        "data-testid": testId,
        style: {
            background: style === null || style === void 0 ? void 0 : style.backgroundColor,
            color: style === null || style === void 0 ? void 0 : style.color
        },
        className: (0, $970q7.default)([
            $3a450d13d3d4e243$var$styles.root,
            $3a450d13d3d4e243$var$styles[oldAppearance]
        ])
    }, /*#__PURE__*/ $5FkrB.createElement((0, $03748c549e9ae27a$export$2e2bcd8739ae039), {
        size: "small",
        align: "center",
        color: "inherit"
    }, $3a450d13d3d4e243$var$badgeValueWithNegativeNumberSupported(children, max)));
});
var $3a450d13d3d4e243$export$2e2bcd8739ae039 = $3a450d13d3d4e243$var$Badge;


/* text.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");

var $afMOk = parcelRequire("afMOk");

var $5FkrB = parcelRequire("5FkrB");
var $02c0cd4d331f430d$var$HasTextAncestorContext = /*#__PURE__*/ (0, $5FkrB.createContext)(false);
var $02c0cd4d331f430d$export$9322276ec105d055 = function useHasTextAncestor() {
    return (0, $5FkrB.useContext)($02c0cd4d331f430d$var$HasTextAncestorContext);
};
var $02c0cd4d331f430d$export$ae933c6cbe5643ad = $02c0cd4d331f430d$var$HasTextAncestorContext.Provider;



var $5FkrB = parcelRequire("5FkrB");
var $e2c317a5a849c806$export$1ca2a26fecb070ae = /*#__PURE__*/ (0, $5FkrB.createContext)('elevation.surface');
var $e2c317a5a849c806$export$1aeb4f6b93c4540d = function useSurface() {
    return (0, $5FkrB.useContext)($e2c317a5a849c806$export$1ca2a26fecb070ae);
};
$e2c317a5a849c806$export$1ca2a26fecb070ae.displayName = 'SurfaceProvider';


var $8511be747fc2d3e4$var$asAllowlist = [
    'span',
    'p',
    'strong',
    'em'
];
/**
 * Custom hook designed to abstract the parsing of the color props and make it clearer in the future how color is reconciled between themes and tokens.
 */ var $8511be747fc2d3e4$var$useColor = function useColor(colorProp, hasTextAncestor) {
    var surface = (0, $e2c317a5a849c806$export$1aeb4f6b93c4540d)();
    if (colorProp === 'inherit') return undefined;
    if (colorProp) return colorProp;
    if (hasTextAncestor) return undefined;
    if ($8511be747fc2d3e4$export$2185ce37f9bdd963.hasOwnProperty(surface)) return $8511be747fc2d3e4$export$2185ce37f9bdd963[surface];
    return 'color.text';
};
var $8511be747fc2d3e4$var$styles = {
    root: "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _1i4qfg65",
    'as.strong': "_k48pwu06",
    'as.em': "_zg8l1m30",
    'textAlign.center': "_y3gn1h6o",
    'textAlign.end': "_y3gnh9n0",
    'textAlign.start': "_y3gnv2br",
    truncation: "_1reo15vq _18m915vq _1e0ccj1k _sudp1e54",
    breakAll: "_1nmz9jpi"
};
var $8511be747fc2d3e4$var$fontSizeMap = {
    medium: "_11c8fhey",
    UNSAFE_small: "_11c8rymc",
    large: "_11c81d4k",
    small: "_11c8wadc"
};
var $8511be747fc2d3e4$var$fontWeightMap = {
    bold: "_k48pwu06",
    medium: "_k48p1wq8",
    regular: "_k48pi7a9",
    semibold: "_k48p1pd9"
};
var $8511be747fc2d3e4$var$textColorMap = {
    'color.text': "_syazi7uo",
    'color.text.accent.lime': "_syaz1tco",
    'color.text.accent.lime.bolder': "_syaz1ik3",
    'color.text.accent.red': "_syaz9lu1",
    'color.text.accent.red.bolder': "_syazhwvp",
    'color.text.accent.orange': "_syazp1lv",
    'color.text.accent.orange.bolder': "_syaz7i1p",
    'color.text.accent.yellow': "_syazfb2s",
    'color.text.accent.yellow.bolder': "_syazekll",
    'color.text.accent.green': "_syazh55r",
    'color.text.accent.green.bolder': "_syaz1y78",
    'color.text.accent.teal': "_syaz17qg",
    'color.text.accent.teal.bolder': "_syaz12v7",
    'color.text.accent.blue': "_syaz16jw",
    'color.text.accent.blue.bolder': "_syaz1kyx",
    'color.text.accent.purple': "_syazqmo9",
    'color.text.accent.purple.bolder': "_syaz1mn1",
    'color.text.accent.magenta': "_syaz1s8m",
    'color.text.accent.magenta.bolder': "_syaz1qur",
    'color.text.accent.gray': "_syaz1sqi",
    'color.text.accent.gray.bolder': "_syaz1tmo",
    'color.text.disabled': "_syaz1gmx",
    'color.text.inverse': "_syaz15cr",
    'color.text.selected': "_syaz6x5g",
    'color.text.brand': "_syaz1oa5",
    'color.text.danger': "_syaz1tmw",
    'color.text.warning': "_syaz1xn9",
    'color.text.warning.inverse': "_syaz1yd3",
    'color.text.success': "_syazgsak",
    'color.text.discovery': "_syazdv2p",
    'color.text.information': "_syazu3tg",
    'color.text.subtlest': "_syaz1rpy",
    'color.text.subtle': "_syazazsu",
    'color.link': "_syaz13af",
    'color.link.pressed': "_syaz12zz",
    'color.link.visited': "_syaz1ra0",
    'color.link.visited.pressed': "_syaz17z1"
};
var $8511be747fc2d3e4$export$2185ce37f9bdd963 = {
    'color.background.neutral.bold': 'color.text.inverse',
    'color.background.neutral.bold.hovered': 'color.text.inverse',
    'color.background.neutral.bold.pressed': 'color.text.inverse',
    'color.background.selected.bold': 'color.text.inverse',
    'color.background.selected.bold.hovered': 'color.text.inverse',
    'color.background.selected.bold.pressed': 'color.text.inverse',
    'color.background.brand.bold': 'color.text.inverse',
    'color.background.brand.bold.hovered': 'color.text.inverse',
    'color.background.brand.bold.pressed': 'color.text.inverse',
    'color.background.brand.boldest': 'color.text.inverse',
    'color.background.brand.boldest.hovered': 'color.text.inverse',
    'color.background.brand.boldest.pressed': 'color.text.inverse',
    'color.background.danger.bold': 'color.text.inverse',
    'color.background.danger.bold.hovered': 'color.text.inverse',
    'color.background.danger.bold.pressed': 'color.text.inverse',
    'color.background.warning.bold': 'color.text.warning.inverse',
    'color.background.warning.bold.hovered': 'color.text.warning.inverse',
    'color.background.warning.bold.pressed': 'color.text.warning.inverse',
    'color.background.success.bold': 'color.text.inverse',
    'color.background.success.bold.hovered': 'color.text.inverse',
    'color.background.success.bold.pressed': 'color.text.inverse',
    'color.background.discovery.bold': 'color.text.inverse',
    'color.background.discovery.bold.hovered': 'color.text.inverse',
    'color.background.discovery.bold.pressed': 'color.text.inverse',
    'color.background.information.bold': 'color.text.inverse',
    'color.background.information.bold.hovered': 'color.text.inverse',
    'color.background.information.bold.pressed': 'color.text.inverse'
};
/**
 * __Text__
 *
 * Text is a primitive component that has the Atlassian Design System's design guidelines baked in.
 * This includes considerations for text attributes such as color, font size, font weight, and line height.
 * It renders a `span` by default.
 *
 * @internal
 */ var $8511be747fc2d3e4$var$Text = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? 'span' : _ref$as, colorProp = _ref.color, align = _ref.align, testId = _ref.testId, id = _ref.id, size = _ref.size, weight = _ref.weight, maxLines = _ref.maxLines, xcss = _ref.xcss, children = _ref.children;
    (0, $afMOk.default)($8511be747fc2d3e4$var$asAllowlist.includes(Component), "@atlaskit/primitives: Text received an invalid \"as\" value of \"".concat(Component, "\""));
    var hasTextAncestor = (0, $02c0cd4d331f430d$export$9322276ec105d055)();
    var color = $8511be747fc2d3e4$var$useColor(colorProp, hasTextAncestor);
    if (!size && !hasTextAncestor) size = 'medium';
    var component = /*#__PURE__*/ $5FkrB.createElement(Component, {
        id: id,
        className: (0, $970q7.default)([
            $8511be747fc2d3e4$var$styles.root,
            size && $8511be747fc2d3e4$var$fontSizeMap[size],
            color && $8511be747fc2d3e4$var$textColorMap[color],
            maxLines && $8511be747fc2d3e4$var$styles.truncation,
            maxLines === 1 && $8511be747fc2d3e4$var$styles.breakAll,
            align && $8511be747fc2d3e4$var$styles["textAlign.".concat(align)],
            weight && $8511be747fc2d3e4$var$fontWeightMap[weight],
            Component === 'em' && $8511be747fc2d3e4$var$styles['as.em'],
            Component === 'strong' && $8511be747fc2d3e4$var$styles['as.strong'],
            xcss
        ]),
        style: {
            WebkitLineClamp: maxLines
        },
        "data-testid": testId,
        ref: ref
    }, children);
    if (hasTextAncestor) // no need to re-apply context if the text is already wrapped
    return component;
    return /*#__PURE__*/ $5FkrB.createElement((0, $02c0cd4d331f430d$export$ae933c6cbe5643ad), {
        value: true
    }, component);
});
var $8511be747fc2d3e4$export$2e2bcd8739ae039 = $8511be747fc2d3e4$var$Text;


// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $d213f500b61a1914$export$1a37a8b7ddf809ac = (0, $0b1eca56b0789a79$export$2e2bcd8739ae039).div({
    display: 'inline-flex',
    marginLeft: "var(--ds-space-050, 4px)",
    opacity: 0.5
});
var $d213f500b61a1914$export$42a852a2b6b56249 = (0, $0b1eca56b0789a79$export$2e2bcd8739ae039).div({
    display: 'inline-flex',
    alignItems: 'center'
});
var $d213f500b61a1914$export$8f3477ca2c4ba51a = (0, $0b1eca56b0789a79$export$2e2bcd8739ae039).div({
    marginLeft: "var(--ds-space-050, 4px)",
    display: 'inline-flex',
    alignItems: 'center'
});


var $1f37b131da0ba31f$export$96bdbc84526f3739 = function hasValue(value) {
    return Array.isArray(value) ? value.length > 0 : !!value;
};
var $1f37b131da0ba31f$export$957d7daebd899f12 = function formatLabel() {
    var label = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    var value = arguments.length > 1 ? arguments[1] : undefined;
    if (!value || !$1f37b131da0ba31f$export$96bdbc84526f3739(value)) return label;
    var _value$map = value.map(function(v) {
        var _v$label;
        return (_v$label = v.label) !== null && _v$label !== void 0 ? _v$label : '';
    }), _value$map2 = (0, (/*@__PURE__*/$parcel$interopDefault($1e638cafe0c7118a$exports)))(_value$map), firstValue = _value$map2[0], otherValues = _value$map2.slice(1);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $d213f500b61a1914$export$42a852a2b6b56249), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $8511be747fc2d3e4$export$2e2bcd8739ae039), {
        as: "strong",
        color: "inherit"
    }, label, ":"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $d213f500b61a1914$export$8f3477ca2c4ba51a), null, firstValue, otherValues.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $d213f500b61a1914$export$1a37a8b7ddf809ac), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $3a450d13d3d4e243$export$2e2bcd8739ae039), null, "+".concat(otherValues.length)))));
};

/* main.tsx generated by @compiled/babel-plugin v0.38.1 */ 

var $5FkrB = parcelRequire("5FkrB");

var $kqp0i = parcelRequire("kqp0i");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");
/* button-base.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $kqp0i = parcelRequire("kqp0i");

var $1Vcia = parcelRequire("1Vcia");

var $970q7 = parcelRequire("970q7");

var $5FkrB = parcelRequire("5FkrB");


var $iO8GM = parcelRequire("iO8GM");

var $gpUQB = parcelRequire("gpUQB");

var $h8qvJ = parcelRequire("h8qvJ");

var $9Zzpd = parcelRequire("9Zzpd");
/* pressable.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $kqp0i = parcelRequire("kqp0i");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");


var $hUFig = parcelRequire("hUFig");


var $dJ32z = parcelRequire("dJ32z");

var $eVb4V = parcelRequire("eVb4V");

var $eqVaP = parcelRequire("eqVaP");
/* focusable.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $kqp0i = parcelRequire("kqp0i");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");
var $90e51fd2638da3dd$var$_excluded = [
    "as",
    "children",
    "isInset",
    "testId",
    "style",
    "xcss"
], $90e51fd2638da3dd$var$_excluded2 = [
    "className"
];
var $90e51fd2638da3dd$var$focusRingStyles = null;
var $90e51fd2638da3dd$var$insetFocusRingStyles = null;
/**
 * __Focus ring__
 *
 * A focus ring visually indicates the currently focused item.
 *
 */ var $90e51fd2638da3dd$var$Focusable = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? 'button' : _ref$as, children = _ref.children, isInset = _ref.isInset, testId = _ref.testId, style = _ref.style, xcss = _ref.xcss, htmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $90e51fd2638da3dd$var$_excluded);
    // This is to remove className from safeHtmlAttributes
    // @ts-ignore -- not using expect since it causes issues with help-center local consumption - className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(htmlAttributes, $90e51fd2638da3dd$var$_excluded2);
    return /*#__PURE__*/ $5FkrB.createElement(Component, (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, safeHtmlAttributes, {
        // @ts-ignore Expression produces a union type that is too complex to represent. We may be able to narrow the type here but unsure.
        ref: ref,
        className: (0, $970q7.default)([
            "_ymio1r31 _ypr0glyw _zcxs1o36 _mizu194a _1ah3dkaa _ra3xnqa1 _128mdkaa _1cvmnqa1 _4davt94y",
            isInset && "_1ah31gjf _2mwq1gjf",
            xcss
        ]),
        style: style,
        "data-testid": testId
    }), children);
});
var $90e51fd2638da3dd$export$2e2bcd8739ae039 = $90e51fd2638da3dd$var$Focusable;


var $a9dda1139145bd84$var$_excluded = [
    "children",
    "isDisabled",
    "type",
    "onClick",
    "interactionName",
    "componentName",
    "analyticsContext",
    "style",
    "testId",
    "xcss",
    "tabIndex"
], $a9dda1139145bd84$var$_excluded2 = [
    "className"
];
var $a9dda1139145bd84$var$styles = {
    root: "_19itglyw _vchhusvi _r06hglyw _80omtlke",
    disabled: "_80om13gf"
};
/**
 * __Pressable__
 *
 * A primitive for building custom buttons.
 *
 * - [Examples](https://atlassian.design/components/primitives/pressable/examples)
 * - [Code](https://atlassian.design/components/primitives/pressable/code)
 * - [Usage](https://atlassian.design/components/primitives/pressable/usage)
 */ var $a9dda1139145bd84$var$Pressable = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function(_ref, ref) {
    var children = _ref.children, isDisabled = _ref.isDisabled, _ref$type = _ref.type, type = _ref$type === void 0 ? 'button' : _ref$type, _ref$onClick = _ref.onClick, providedOnClick = _ref$onClick === void 0 ? (0, $eVb4V.default) : _ref$onClick, interactionName = _ref.interactionName, componentName = _ref.componentName, analyticsContext = _ref.analyticsContext, style = _ref.style, testId = _ref.testId, xcss = _ref.xcss, tabIndex = _ref.tabIndex, htmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $a9dda1139145bd84$var$_excluded);
    var interactionContext = (0, $5FkrB.useContext)((0, $eqVaP.default));
    var handleClick = (0, $5FkrB.useCallback)(function(e, analyticsEvent) {
        interactionContext && interactionContext.tracePress(interactionName, e.timeStamp);
        providedOnClick(e, analyticsEvent);
    }, [
        providedOnClick,
        interactionContext,
        interactionName
    ]);
    var onClick = (0, $a4990a43141cc076$export$a4687b0234b40e28)({
        fn: handleClick,
        action: 'clicked',
        componentName: componentName || 'Pressable',
        packageName: "@atlaskit/primitives",
        packageVersion: "17.1.0",
        analyticsData: analyticsContext,
        actionSubject: 'button'
    });
    // This is to remove className from safeHtmlAttributes
    // @ts-expect-error className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(htmlAttributes, $a9dda1139145bd84$var$_excluded2);
    return /*#__PURE__*/ $5FkrB.createElement((0, $90e51fd2638da3dd$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        as: "button",
        tabIndex: tabIndex !== null && tabIndex !== void 0 ? tabIndex : (0, $dJ32z.isSafari)() && !isDisabled ? 0 : undefined,
        style: style
    }, safeHtmlAttributes, {
        type: type,
        onClick: onClick,
        disabled: isDisabled,
        xcss: (0, $hUFig.cx)($a9dda1139145bd84$var$styles.root, isDisabled && $a9dda1139145bd84$var$styles.disabled, xcss),
        testId: testId,
        ref: ref
    }), children);
});
var $a9dda1139145bd84$export$2e2bcd8739ae039 = $a9dda1139145bd84$var$Pressable;



var $e8kqY = parcelRequire("e8kqY");

var $5FkrB = parcelRequire("5FkrB");
var $07ea6ecf3a7199ff$export$4b86304b2c0d7e71 = /*#__PURE__*/ (0, $5FkrB.createContext)(undefined);
var $07ea6ecf3a7199ff$export$47e2c6fdb142d947 = function useSplitButtonContext() {
    var context = (0, $5FkrB.useContext)($07ea6ecf3a7199ff$export$4b86304b2c0d7e71);
    if (!context) return undefined;
    if (context.appearance === 'navigation') {
        var newContext = {
            spacing: 'default',
            appearance: 'subtle',
            isDisabled: false,
            isActiveOverSelected: false,
            isNavigationSplitButton: true,
            isHighlighted: context.isHighlighted
        };
        return newContext;
    }
    var splitButtonContext = {
        spacing: context.spacing,
        appearance: context.appearance,
        isDisabled: context.isDisabled,
        isActiveOverSelected: true,
        isNavigationSplitButton: false,
        isHighlighted: false
    };
    return splitButtonContext;
};


function $df7230468cbcf0a0$var$abort(event) {
    event.preventDefault();
    event.stopPropagation();
}
var $df7230468cbcf0a0$var$tabKeyCode = 9;
function $df7230468cbcf0a0$var$onKey(event) {
    // Allowing tab so that a user can move focus away
    if (event.keyCode === $df7230468cbcf0a0$var$tabKeyCode) return;
    $df7230468cbcf0a0$var$abort(event);
}
function $df7230468cbcf0a0$export$2e2bcd8739ae039(shouldBlockEvents, events) {
    return shouldBlockEvents ? {
        onMouseDownCapture: $df7230468cbcf0a0$var$abort,
        onMouseUpCapture: $df7230468cbcf0a0$var$abort,
        onKeyDownCapture: $df7230468cbcf0a0$var$onKey,
        onKeyUpCapture: $df7230468cbcf0a0$var$onKey,
        onTouchStartCapture: $df7230468cbcf0a0$var$abort,
        onTouchEndCapture: $df7230468cbcf0a0$var$abort,
        onPointerDownCapture: $df7230468cbcf0a0$var$abort,
        onPointerUpCapture: $df7230468cbcf0a0$var$abort,
        onClickCapture: $df7230468cbcf0a0$var$abort,
        // Just smashing the existing onClick for good measure
        onClick: $df7230468cbcf0a0$var$abort
    } : events;
}



var $5FkrB = parcelRequire("5FkrB");

var $9ztDu = parcelRequire("9ztDu");
function $41ea6fe6090613a4$var$getIconSpacing(spacing) {
    switch(spacing){
        case 'compact':
            return 'small';
        default:
            return 'medium';
    }
}
function $41ea6fe6090613a4$var$getSpinnerAppearance(_ref) {
    var appearance = _ref.appearance, isDisabled = _ref.isDisabled, isSelected = _ref.isSelected;
    if (isDisabled || isSelected) return 'inherit';
    if (appearance === 'primary' || appearance === 'danger' || appearance === 'discovery') return 'invert';
    return 'inherit';
}
function $41ea6fe6090613a4$export$2e2bcd8739ae039(_ref2) {
    var appearance = _ref2.appearance, spacing = _ref2.spacing, isDisabled = _ref2.isDisabled, isSelected = _ref2.isSelected, testId = _ref2.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $9ztDu.default), {
        size: $41ea6fe6090613a4$var$getIconSpacing(spacing),
        appearance: $41ea6fe6090613a4$var$getSpinnerAppearance({
            appearance: appearance,
            isDisabled: isDisabled,
            isSelected: isSelected
        }),
        testId: testId ? "".concat(testId, "--loading-spinner") : undefined
    });
}


var $9fab81a9a2c92794$var$_excluded = [
    "appearance",
    "autoFocus",
    "isDisabled",
    "isLoading",
    "isSelected",
    "isIconButton",
    "isCircle",
    "hasIconBefore",
    "hasIconAfter",
    "shouldFitContainer",
    "spacing",
    "ariaLabel",
    "ariaLabelledBy",
    "children",
    "interactionName",
    "onClick",
    "onMouseDown",
    "onMouseDownCapture",
    "onMouseUp",
    "onMouseUpCapture",
    "onKeyDown",
    "onKeyDownCapture",
    "onKeyUp",
    "onKeyUpCapture",
    "onTouchStart",
    "onTouchStartCapture",
    "onTouchEnd",
    "onTouchEndCapture",
    "onPointerDown",
    "onPointerDownCapture",
    "onPointerUp",
    "onPointerUpCapture",
    "onClickCapture",
    "testId",
    "analyticsContext",
    "componentName",
    "role",
    "onMouseOver",
    "onMouseOut",
    "onFocus",
    "onBlur",
    "onMouseMove",
    "type"
], $9fab81a9a2c92794$var$_excluded2 = [
    "className",
    "css",
    "as",
    "style"
];
var $9fab81a9a2c92794$var$LOADING_LABEL = ', Loading';
var $9fab81a9a2c92794$var$styles = {
    base: "_2rkofajl _11c8fhey _v5649dqc _189eidpf _1rjc12x7 _1e0c116y _vchhusvi _1bsb1wug _p12f1osq _kqswh2mm _4cvr1q9y _1bah1h6o _gy1p1b66 _1o9zidpf _4t3iviql _k48p1wq8 _y4tiutpp _bozgutpp _y3gn1h6o _s7n4nkob _14mj1kw7 _9v7aze3t _1tv3nqa1 _39yqe4h9 _11fnglyw _18postnw",
    baseT26Shape: "_2rko1qi0",
    linkDecorationUnset: "_4bfu1r31 _1hmsglyw _ajmmnqa1 _1a3b1r31 _4fprglyw _5goinqa1 _9oik1r31 _1bnxglyw _jf4cnqa1 _1nrm1r31 _c2waglyw _1iohnqa1",
    disabled: "_80om13gf _syaz1gmx _30l31gmx _9h8h1gmx",
    sharedDisabled: "_bfhk1fvb _irr31fvb _1di61fvb",
    spacingCompact: "_1rjcv77o _gy1p1b66 _4t3i1k8s _y4tiutpp _bozgutpp _s7n4nkob",
    spacingCompactT26Shape: "_2rko12b0",
    circle: "_2rko1rr0",
    fullWidth: "_1bsb1osq",
    loading: "_80om15jw",
    iconButton: "_4t3iviql _1bsbviql _y4tize3t _bozgze3t",
    iconButtonCompact: "_4t3i1k8s _1bsb1k8s",
    buttonIconBefore: "_bozgu2gc",
    buttonIconAfter: "_y4tiu2gc",
    splitButton: "_g0pbb4wl",
    loadingOverlay: "_1reo15vq _18m915vq _1e0c1txw _kqswstnw _4cvr1h6o _1bah1h6o _u7coze3t _152tze3t _rjxpze3t _1e02ze3t",
    navigationSplitButton: "_1bsb1tcg _bfhksm61 _y4ti12x7 _bozg12x7"
};
var $9fab81a9a2c92794$var$defaultStyles = {
    root: "_bfhksm61 _syazazsu _8l3m1l7x _aetrb3bt _1053azsu _f8pjazsu _30l3azsu _9h8hazsu",
    interactive: "_irr31dpa _30l3azsu _1di6fcek _9h8hazsu",
    disabled: "_bfhk1j28 _8l3mbk0g _irr31j28 _1di61j28"
};
var $9fab81a9a2c92794$var$primaryStyles = {
    root: "_bfhkomb0 _syaz15cr _105315cr _f8pj15cr _30l315cr _9h8h15cr",
    interactive: "_30l315cr _irr31wqm _9h8h15cr _1di617hq"
};
var $9fab81a9a2c92794$var$warningStyles = {
    root: "_bfhk1ikc _syazal3n _1053al3n _f8pjal3n _30l3al3n _9h8hal3n",
    interactive: "_30l3al3n _irr31j43 _9h8hal3n _1di6h4op"
};
var $9fab81a9a2c92794$var$dangerStyles = {
    root: "_bfhk1v7l _syaz15cr _105315cr _f8pj15cr _30l315cr _9h8h15cr",
    interactive: "_30l315cr _irr31rwk _9h8h15cr _1di6yycf"
};
var $9fab81a9a2c92794$var$discoveryStyles = {
    root: "_bfhk1vbi _syaz15cr _105315cr _f8pj15cr _30l315cr _9h8h15cr",
    interactive: "_30l315cr _irr37gr8 _9h8h15cr _1di61wu2"
};
var $9fab81a9a2c92794$var$subtleStyles = {
    root: "_bfhkqtfy _syazazsu _1053azsu _f8pjazsu _30l3azsu _9h8hazsu",
    interactive: "_irr34mfv _30l3azsu _1di619qy _9h8hazsu",
    disabled: "_bfhk1j28 _8l3mbk0g _irr31j28 _1di61j28"
};
var $9fab81a9a2c92794$var$selectedStyles = {
    root: "_bfhk15s3 _syaz1ldt _8l3mcoux _aetrb3bt _10531ldt _f8pj1ldt _30l31ldt _9h8h1ldt",
    insideSplitButton: "_1pbycs5v",
    interactive: "_irr3t71w _30l31pke _1di6yssv _9h8h1pke",
    warning: "_bfhkvdtc _syaz16q2 _30l31pke _irr3vdtc _9h8h1pke _1di6vdtc",
    danger: "_bfhkbeib _syaz1pke _30l31pke _irr3beib _9h8h1pke _1di6beib",
    discovery: "_bfhk1g49 _syaz1pke _30l31pke _irr31g49 _9h8h1pke _1di61g49"
};
/**
 * __button base__
 *
 * - Implements auto focus when enabled.
 * - Appends the `onClick` event with UFO analytics tracking.
 *
 * @private
 */ var $9fab81a9a2c92794$var$ButtonBase = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).forwardRef(// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore: to unblock React 18.2.0 -> 18.3.1 version bump in Jira
function(_ref, ref) {
    var propAppearance = _ref.appearance, _ref$autoFocus = _ref.autoFocus, autoFocus = _ref$autoFocus === void 0 ? false : _ref$autoFocus, _ref$isDisabled = _ref.isDisabled, propIsDisabled = _ref$isDisabled === void 0 ? false : _ref$isDisabled, _ref$isLoading = _ref.isLoading, isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading, _ref$isSelected = _ref.isSelected, propIsSelected = _ref$isSelected === void 0 ? false : _ref$isSelected, _ref$isIconButton = _ref.isIconButton, isIconButton = _ref$isIconButton === void 0 ? false : _ref$isIconButton, _ref$isCircle = _ref.isCircle, isCircle = _ref$isCircle === void 0 ? false : _ref$isCircle, _ref$hasIconBefore = _ref.hasIconBefore, hasIconBefore = _ref$hasIconBefore === void 0 ? false : _ref$hasIconBefore, _ref$hasIconAfter = _ref.hasIconAfter, hasIconAfter = _ref$hasIconAfter === void 0 ? false : _ref$hasIconAfter, _ref$shouldFitContain = _ref.shouldFitContainer, shouldFitContainer = _ref$shouldFitContain === void 0 ? false : _ref$shouldFitContain, _ref$spacing = _ref.spacing, propSpacing = _ref$spacing === void 0 ? 'default' : _ref$spacing, ariaLabel = _ref.ariaLabel, ariaLabelledBy = _ref.ariaLabelledBy, children = _ref.children, interactionName = _ref.interactionName, onClick = _ref.onClick, onMouseDown = _ref.onMouseDown, onMouseDownCapture = _ref.onMouseDownCapture, onMouseUp = _ref.onMouseUp, onMouseUpCapture = _ref.onMouseUpCapture, onKeyDown = _ref.onKeyDown, onKeyDownCapture = _ref.onKeyDownCapture, onKeyUp = _ref.onKeyUp, onKeyUpCapture = _ref.onKeyUpCapture, onTouchStart = _ref.onTouchStart, onTouchStartCapture = _ref.onTouchStartCapture, onTouchEnd = _ref.onTouchEnd, onTouchEndCapture = _ref.onTouchEndCapture, onPointerDown = _ref.onPointerDown, onPointerDownCapture = _ref.onPointerDownCapture, onPointerUp = _ref.onPointerUp, onPointerUpCapture = _ref.onPointerUpCapture, onClickCapture = _ref.onClickCapture, testId = _ref.testId, analyticsContext = _ref.analyticsContext, componentName = _ref.componentName, role = _ref.role, onMouseOver = _ref.onMouseOver, onMouseOut = _ref.onMouseOut, onFocus = _ref.onFocus, onBlur = _ref.onBlur, onMouseMove = _ref.onMouseMove, type = _ref.type, unsafeRest = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $9fab81a9a2c92794$var$_excluded);
    var localRef = (0, $5FkrB.useRef)(null);
    var splitButtonContext = (0, $07ea6ecf3a7199ff$export$47e2c6fdb142d947)();
    var loadingLabelId = (0, $h8qvJ.useId)();
    var isSplitButton = Boolean(splitButtonContext);
    var isNavigationSplitButton = (splitButtonContext === null || splitButtonContext === void 0 ? void 0 : splitButtonContext.isNavigationSplitButton) || false;
    var isDefaultAppearanceSplitButton = (splitButtonContext === null || splitButtonContext === void 0 ? void 0 : splitButtonContext.appearance) === 'default';
    var appearance = isDefaultAppearanceSplitButton ? 'subtle' : propAppearance || (splitButtonContext === null || splitButtonContext === void 0 ? void 0 : splitButtonContext.appearance) || 'default';
    var spacing = (splitButtonContext === null || splitButtonContext === void 0 ? void 0 : splitButtonContext.spacing) || propSpacing;
    var isDisabled = (splitButtonContext === null || splitButtonContext === void 0 ? void 0 : splitButtonContext.isDisabled) || propIsDisabled;
    var isInteractive = !isDisabled && !isLoading;
    // Also treat loading buttons as disabled
    var isEffectivelyDisabled = isDisabled || isLoading;
    var isSelected = propIsSelected && !isDisabled;
    (0, $gpUQB.default)(localRef, autoFocus);
    // @ts-expect-error
    var _className = unsafeRest.className, _css = unsafeRest.css, _as = unsafeRest.as, _style = unsafeRest.style, saferRest = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(unsafeRest, $9fab81a9a2c92794$var$_excluded2);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $a9dda1139145bd84$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, saferRest, {
        componentName: componentName || 'button',
        analyticsContext: analyticsContext,
        role: role,
        ref: (0, $iO8GM.default)([
            localRef,
            ref
        ]),
        xcss: (0, $947a6ea09ef50dc7$export$a274e22fb40f762e)($9fab81a9a2c92794$var$styles.base, (0, $9Zzpd.fg)('platform-dst-shape-theme-default') && $9fab81a9a2c92794$var$styles.baseT26Shape, appearance === 'default' && $9fab81a9a2c92794$var$defaultStyles.root, appearance === 'default' && isInteractive && $9fab81a9a2c92794$var$defaultStyles.interactive, appearance === 'primary' && $9fab81a9a2c92794$var$primaryStyles.root, appearance === 'primary' && isInteractive && $9fab81a9a2c92794$var$primaryStyles.interactive, appearance === 'warning' && $9fab81a9a2c92794$var$warningStyles.root, appearance === 'warning' && isInteractive && $9fab81a9a2c92794$var$warningStyles.interactive, appearance === 'danger' && $9fab81a9a2c92794$var$dangerStyles.root, appearance === 'danger' && isInteractive && $9fab81a9a2c92794$var$dangerStyles.interactive, appearance === 'discovery' && $9fab81a9a2c92794$var$discoveryStyles.root, appearance === 'discovery' && isInteractive && $9fab81a9a2c92794$var$discoveryStyles.interactive, appearance === 'subtle' && $9fab81a9a2c92794$var$subtleStyles.root, appearance === 'subtle' && isInteractive && $9fab81a9a2c92794$var$subtleStyles.interactive, $9fab81a9a2c92794$var$styles.linkDecorationUnset, isSelected && $9fab81a9a2c92794$var$selectedStyles.root, isSelected && isSplitButton && $9fab81a9a2c92794$var$selectedStyles.insideSplitButton, isSelected && isInteractive && $9fab81a9a2c92794$var$selectedStyles.interactive, // TODO: remove me once we kill color fallbacks
        isSelected && appearance === 'danger' && $9fab81a9a2c92794$var$selectedStyles.danger, // TODO: remove me once we kill color fallbacks
        isSelected && appearance === 'warning' && $9fab81a9a2c92794$var$selectedStyles.warning, // TODO: remove me once we kill color fallbacks
        isSelected && appearance === 'discovery' && $9fab81a9a2c92794$var$selectedStyles.discovery, isDisabled && $9fab81a9a2c92794$var$styles.disabled, isDisabled && appearance !== 'default' && appearance !== 'subtle' && $9fab81a9a2c92794$var$styles.sharedDisabled, isDisabled && appearance === 'default' && $9fab81a9a2c92794$var$defaultStyles.disabled, isCircle && !isSplitButton && $9fab81a9a2c92794$var$styles.circle, spacing === 'compact' && $9fab81a9a2c92794$var$styles.spacingCompact, spacing === 'compact' && (0, $9Zzpd.fg)('platform-dst-shape-theme-default') && $9fab81a9a2c92794$var$styles.spacingCompactT26Shape, hasIconBefore && $9fab81a9a2c92794$var$styles.buttonIconBefore, shouldFitContainer && $9fab81a9a2c92794$var$styles.fullWidth, hasIconAfter && $9fab81a9a2c92794$var$styles.buttonIconAfter, isIconButton && $9fab81a9a2c92794$var$styles.iconButton, isIconButton && spacing === 'compact' && $9fab81a9a2c92794$var$styles.iconButtonCompact, isLoading && $9fab81a9a2c92794$var$styles.loading, isSplitButton && $9fab81a9a2c92794$var$styles.splitButton, isNavigationSplitButton && $9fab81a9a2c92794$var$styles.navigationSplitButton),
        isDisabled: (0, $9Zzpd.fg)('platform-dst_fix_not_focusable_loading_button') ? isDisabled : isEffectivelyDisabled
    }, (0, $9Zzpd.fg)('platform-dst_fix_not_focusable_loading_button') && {
        'aria-live': 'polite'
    }, isLoading && (0, $9Zzpd.fg)('platform-dst_fix_not_focusable_loading_button') && {
        'aria-disabled': true
    }, {
        "aria-label": isLoading && ariaLabel && !ariaLabelledBy ? "".concat(ariaLabel, " ").concat($9fab81a9a2c92794$var$LOADING_LABEL) : ariaLabel,
        "aria-labelledby": isLoading && ariaLabelledBy ? "".concat(ariaLabelledBy, " ").concat(loadingLabelId) : ariaLabelledBy,
        onClick: onClick
    }, (0, $df7230468cbcf0a0$export$2e2bcd8739ae039)(isEffectivelyDisabled, {
        onMouseDownCapture: onMouseDownCapture,
        onMouseUpCapture: onMouseUpCapture,
        onKeyDownCapture: onKeyDownCapture,
        onKeyUpCapture: onKeyUpCapture,
        onTouchStartCapture: onTouchStartCapture,
        onTouchEndCapture: onTouchEndCapture,
        onPointerDownCapture: onPointerDownCapture,
        onPointerUpCapture: onPointerUpCapture,
        onClickCapture: onClickCapture
    }), {
        testId: testId,
        onMouseOver: onMouseOver,
        onFocus: onFocus,
        onMouseMove: onMouseMove,
        onBlur: onBlur,
        type: type,
        interactionName: interactionName,
        onMouseDown: onMouseDown,
        onMouseUp: onMouseUp,
        onKeyDown: onKeyDown,
        onMouseOut: onMouseOut,
        onKeyUp: onKeyUp,
        onTouchStart: onTouchStart,
        onTouchEnd: onTouchEnd,
        onPointerDown: onPointerDown,
        onPointerUp: onPointerUp
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $07ea6ecf3a7199ff$export$4b86304b2c0d7e71).Provider, {
        value: undefined
    }, children, isLoading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("span", {
        className: (0, $970q7.default)([
            $9fab81a9a2c92794$var$styles.loadingOverlay
        ])
    }, (0, $41ea6fe6090613a4$export$2e2bcd8739ae039)({
        spacing: spacing,
        appearance: appearance,
        isDisabled: isDisabled,
        isSelected: isSelected,
        testId: testId
    })), isLoading && (ariaLabelledBy || !ariaLabel) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $e8kqY.default), {
        id: loadingLabelId
    }, $9fab81a9a2c92794$var$LOADING_LABEL)));
});
var $9fab81a9a2c92794$export$2e2bcd8739ae039 = $9fab81a9a2c92794$var$ButtonBase;


/* content.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $970q7 = parcelRequire("970q7");

var $5FkrB = parcelRequire("5FkrB");
var $d60fcaca5c994756$var$styles = {
    text: "_1reo15vq _18m915vq _16jlkb7n _1o9zkb7n _1bto1l2s _o5721q9c",
    icon: "_1e0c1txw _16jlidpf _1o9zidpf _1wpz1h6o _1wybidpf _vwz4idpf _uiztglyw",
    beforeIcon: "_1he91b66 _w795v77o",
    afterIcon: "_1he9v77o _w7951b66",
    common: "_v564g17y",
    fade: "_tzy4idpf"
};
/**
 * __Content__
 *
 * Used for slots within a Button, including icons and text content.
 */ var $d60fcaca5c994756$var$Content = function Content(_ref) {
    var children = _ref.children, _ref$type = _ref.type, type = _ref$type === void 0 ? 'text' : _ref$type, isLoading = _ref.isLoading, position = _ref.position;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("span", {
        className: (0, $970q7.default)([
            $d60fcaca5c994756$var$styles.common,
            type === 'text' && $d60fcaca5c994756$var$styles.text,
            type === 'icon' && $d60fcaca5c994756$var$styles.icon,
            isLoading && $d60fcaca5c994756$var$styles.fade,
            position === 'before' && $d60fcaca5c994756$var$styles.beforeIcon,
            position === 'after' && $d60fcaca5c994756$var$styles.afterIcon
        ])
    }, children);
};
var $d60fcaca5c994756$export$2e2bcd8739ae039 = $d60fcaca5c994756$var$Content;



var $5FkrB = parcelRequire("5FkrB");

var $9Zzpd = parcelRequire("9Zzpd");
function $ca52aa921587d49b$var$isIconRenderProp(func) {
    return !func.displayName && // most function components and class components have a displayName, negate them
    !func.render && // forwardRef doesn't require a display name, however it does include a render function, negate them
    typeof func === 'function' // at the very least we need to be a function
    ;
}
/**
 * __Icon renderer__
 *
 * Used to support render props with icons.
 *
 */ var $ca52aa921587d49b$var$IconRenderer = function IconRenderer(_ref) {
    var Icon = _ref.icon;
    var isRenderProp = $ca52aa921587d49b$var$isIconRenderProp(Icon);
    var iconProps = {
        label: '',
        color: 'currentColor',
        size: (0, $9Zzpd.fg)('platform_dst_button_chevron_sizing') ? function(iconName) {
            return iconName.startsWith('Chevron') ? 'small' : 'medium';
        } : undefined
    };
    // @ts-ignore - TS2322 TypeScript 5.9.2 upgrade
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).Fragment, null, isRenderProp ? Icon(iconProps) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(Icon, iconProps));
};
var $ca52aa921587d49b$export$2e2bcd8739ae039 = $ca52aa921587d49b$var$IconRenderer;


var $298f70230884e886$var$_excluded = [
    "analyticsContext",
    "appearance",
    "aria-label",
    "aria-labelledby",
    "autoFocus",
    "children",
    "iconAfter",
    "iconBefore",
    "interactionName",
    "isDisabled",
    "isLoading",
    "isSelected",
    "onClick",
    "onClickCapture",
    "onKeyDownCapture",
    "onKeyUpCapture",
    "onMouseDownCapture",
    "onMouseUpCapture",
    "onPointerDownCapture",
    "onPointerUpCapture",
    "onTouchEndCapture",
    "onTouchStartCapture",
    "shouldFitContainer",
    "spacing",
    "testId",
    "type"
], $298f70230884e886$var$_excluded2 = [
    "className",
    "css",
    "as",
    "style"
];
/**
 * __Button__
 *
 * A button triggers an event or action.
 *
 * - [Examples](https://atlassian.design/components/button/examples)
 * - [Code](https://atlassian.design/components/button/code)
 * - [Usage](https://atlassian.design/components/button/usage)
 */ var $298f70230884e886$var$Button = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).forwardRef(function Button(_ref, ref) {
    var analyticsContext = _ref.analyticsContext, appearance = _ref.appearance, ariaLabel = _ref['aria-label'], ariaLabelledBy = _ref['aria-labelledby'], autoFocus = _ref.autoFocus, children = _ref.children, iconAfter = _ref.iconAfter, iconBefore = _ref.iconBefore, interactionName = _ref.interactionName, isDisabled = _ref.isDisabled, _ref$isLoading = _ref.isLoading, isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading, isSelected = _ref.isSelected, onClick = _ref.onClick, onClickCapture = _ref.onClickCapture, onKeyDownCapture = _ref.onKeyDownCapture, onKeyUpCapture = _ref.onKeyUpCapture, onMouseDownCapture = _ref.onMouseDownCapture, onMouseUpCapture = _ref.onMouseUpCapture, onPointerDownCapture = _ref.onPointerDownCapture, onPointerUpCapture = _ref.onPointerUpCapture, onTouchEndCapture = _ref.onTouchEndCapture, onTouchStartCapture = _ref.onTouchStartCapture, shouldFitContainer = _ref.shouldFitContainer, spacing = _ref.spacing, testId = _ref.testId, _ref$type = _ref.type, type = _ref$type === void 0 ? 'button' : _ref$type, unsafeRest = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $298f70230884e886$var$_excluded);
    // @ts-expect-error
    var _className = unsafeRest.className, _css = unsafeRest.css, _as = unsafeRest.as, _style = unsafeRest.style, saferRest = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(unsafeRest, $298f70230884e886$var$_excluded2);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $9fab81a9a2c92794$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        analyticsContext: analyticsContext,
        ref: ref,
        appearance: appearance,
        autoFocus: autoFocus,
        isDisabled: isDisabled,
        isLoading: isLoading,
        isSelected: isSelected,
        hasIconBefore: Boolean(iconBefore),
        hasIconAfter: Boolean(iconAfter),
        shouldFitContainer: shouldFitContainer,
        spacing: spacing,
        ariaLabel: ariaLabel,
        ariaLabelledBy: ariaLabelledBy,
        onClick: onClick,
        onClickCapture: onClickCapture,
        onKeyDownCapture: onKeyDownCapture,
        onKeyUpCapture: onKeyUpCapture,
        onMouseDownCapture: onMouseDownCapture,
        onMouseUpCapture: onMouseUpCapture,
        onPointerDownCapture: onPointerDownCapture,
        onPointerUpCapture: onPointerUpCapture,
        onTouchStartCapture: onTouchStartCapture,
        onTouchEndCapture: onTouchEndCapture,
        testId: testId,
        componentName: "Button",
        type: type,
        interactionName: interactionName
    }, saferRest), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $5FkrB.Fragment), null, iconBefore && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $d60fcaca5c994756$export$2e2bcd8739ae039), {
        type: "icon",
        position: "before",
        isLoading: isLoading
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $ca52aa921587d49b$export$2e2bcd8739ae039), {
        icon: iconBefore
    })), children && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $d60fcaca5c994756$export$2e2bcd8739ae039), {
        isLoading: isLoading
    }, children), iconAfter && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $d60fcaca5c994756$export$2e2bcd8739ae039), {
        type: "icon",
        position: "after",
        isLoading: isLoading
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $ca52aa921587d49b$export$2e2bcd8739ae039), {
        icon: iconAfter
    }))));
}));
$298f70230884e886$var$Button.displayName = 'Button';
var $298f70230884e886$export$2e2bcd8739ae039 = $298f70230884e886$var$Button;




var $9Zzpd = parcelRequire("9Zzpd");
/* box.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $kqp0i = parcelRequire("kqp0i");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");

var $e4b6a0e9d74e117e$var$_excluded = [
    "as",
    "children",
    "backgroundColor",
    "padding",
    "paddingBlock",
    "paddingBlockStart",
    "paddingBlockEnd",
    "paddingInline",
    "paddingInlineStart",
    "paddingInlineEnd",
    "style",
    "testId",
    "xcss"
], $e4b6a0e9d74e117e$var$_excluded2 = [
    "className"
];
// Can either Exclude or Extract - here we're excluding all SVG-related elements, <button> elements (handled by Pressable), and <a> elements (handled by Anchor)
// Basically just ElementType but without ComponentType, it makes sense to keep the "Type" suffix
// eslint-disable-next-line @repo/internal/react/consistent-types-definitions
var $e4b6a0e9d74e117e$var$baseStyles = null;
var $e4b6a0e9d74e117e$var$backgroundColorMap = {
    'color.background.accent.lime.subtlest': "_bfhkm890",
    'color.background.accent.lime.subtlest.hovered': "_bfhkd4y8",
    'color.background.accent.lime.subtlest.pressed': "_bfhkkuup",
    'color.background.accent.lime.subtler': "_bfhkz2ec",
    'color.background.accent.lime.subtler.hovered': "_bfhk1gf0",
    'color.background.accent.lime.subtler.pressed': "_bfhk2kxc",
    'color.background.accent.lime.subtle': "_bfhkbq5w",
    'color.background.accent.lime.subtle.hovered': "_bfhkfoww",
    'color.background.accent.lime.subtle.pressed': "_bfhk1jbd",
    'color.background.accent.lime.bolder': "_bfhktde4",
    'color.background.accent.lime.bolder.hovered': "_bfhknzpa",
    'color.background.accent.lime.bolder.pressed': "_bfhkh0j0",
    'color.background.accent.red.subtlest': "_bfhk1vk5",
    'color.background.accent.red.subtlest.hovered': "_bfhk1i6i",
    'color.background.accent.red.subtlest.pressed': "_bfhknbir",
    'color.background.accent.red.subtler': "_bfhk1rtt",
    'color.background.accent.red.subtler.hovered': "_bfhkaffd",
    'color.background.accent.red.subtler.pressed': "_bfhk1j5a",
    'color.background.accent.red.subtle': "_bfhkkrt9",
    'color.background.accent.red.subtle.hovered': "_bfhk1sou",
    'color.background.accent.red.subtle.pressed': "_bfhk1fnn",
    'color.background.accent.red.bolder': "_bfhkuibq",
    'color.background.accent.red.bolder.hovered': "_bfhk100f",
    'color.background.accent.red.bolder.pressed': "_bfhk1cl6",
    'color.background.accent.orange.subtlest': "_bfhkf5uh",
    'color.background.accent.orange.subtlest.hovered': "_bfhk19yr",
    'color.background.accent.orange.subtlest.pressed': "_bfhkf90x",
    'color.background.accent.orange.subtler': "_bfhk165s",
    'color.background.accent.orange.subtler.hovered': "_bfhk1ei0",
    'color.background.accent.orange.subtler.pressed': "_bfhkdpo3",
    'color.background.accent.orange.subtle': "_bfhk1kkj",
    'color.background.accent.orange.subtle.hovered': "_bfhk9mfs",
    'color.background.accent.orange.subtle.pressed': "_bfhkaxpp",
    'color.background.accent.orange.bolder': "_bfhk1qg1",
    'color.background.accent.orange.bolder.hovered': "_bfhk12qo",
    'color.background.accent.orange.bolder.pressed': "_bfhk1fyq",
    'color.background.accent.yellow.subtlest': "_bfhkibhp",
    'color.background.accent.yellow.subtlest.hovered': "_bfhkaetg",
    'color.background.accent.yellow.subtlest.pressed': "_bfhk1o1l",
    'color.background.accent.yellow.subtler': "_bfhk1773",
    'color.background.accent.yellow.subtler.hovered': "_bfhk1uw7",
    'color.background.accent.yellow.subtler.pressed': "_bfhk1r9w",
    'color.background.accent.yellow.subtle': "_bfhk8y3s",
    'color.background.accent.yellow.subtle.hovered': "_bfhk819w",
    'color.background.accent.yellow.subtle.pressed': "_bfhk1jx0",
    'color.background.accent.yellow.bolder': "_bfhk1vop",
    'color.background.accent.yellow.bolder.hovered': "_bfhkkjqf",
    'color.background.accent.yellow.bolder.pressed': "_bfhk1okt",
    'color.background.accent.green.subtlest': "_bfhkn729",
    'color.background.accent.green.subtlest.hovered': "_bfhk3utz",
    'color.background.accent.green.subtlest.pressed': "_bfhkyfny",
    'color.background.accent.green.subtler': "_bfhk1wnw",
    'color.background.accent.green.subtler.hovered': "_bfhk1e2h",
    'color.background.accent.green.subtler.pressed': "_bfhkybhx",
    'color.background.accent.green.subtle': "_bfhk1rsu",
    'color.background.accent.green.subtle.hovered': "_bfhk12e3",
    'color.background.accent.green.subtle.pressed': "_bfhk1g86",
    'color.background.accent.green.bolder': "_bfhk1e5c",
    'color.background.accent.green.bolder.hovered': "_bfhka5yi",
    'color.background.accent.green.bolder.pressed': "_bfhk1j68",
    'color.background.accent.teal.subtlest': "_bfhk7xuz",
    'color.background.accent.teal.subtlest.hovered': "_bfhk108c",
    'color.background.accent.teal.subtlest.pressed': "_bfhk1cxp",
    'color.background.accent.teal.subtler': "_bfhk1a17",
    'color.background.accent.teal.subtler.hovered': "_bfhkkwwr",
    'color.background.accent.teal.subtler.pressed': "_bfhk1jb0",
    'color.background.accent.teal.subtle': "_bfhktdv8",
    'color.background.accent.teal.subtle.hovered': "_bfhkzh8h",
    'color.background.accent.teal.subtle.pressed': "_bfhk16zl",
    'color.background.accent.teal.bolder': "_bfhk2c8p",
    'color.background.accent.teal.bolder.hovered': "_bfhkl3ve",
    'color.background.accent.teal.bolder.pressed': "_bfhktor0",
    'color.background.accent.blue.subtlest': "_bfhk1s93",
    'color.background.accent.blue.subtlest.hovered': "_bfhkdaj9",
    'color.background.accent.blue.subtlest.pressed': "_bfhkxm0g",
    'color.background.accent.blue.subtler': "_bfhk1dy8",
    'color.background.accent.blue.subtler.hovered': "_bfhk815t",
    'color.background.accent.blue.subtler.pressed': "_bfhkrwxf",
    'color.background.accent.blue.subtle': "_bfhk115i",
    'color.background.accent.blue.subtle.hovered': "_bfhk9pr4",
    'color.background.accent.blue.subtle.pressed': "_bfhknpx7",
    'color.background.accent.blue.bolder': "_bfhk16e3",
    'color.background.accent.blue.bolder.hovered': "_bfhk1vbm",
    'color.background.accent.blue.bolder.pressed': "_bfhk1xwi",
    'color.background.accent.purple.subtlest': "_bfhkp2ly",
    'color.background.accent.purple.subtlest.hovered': "_bfhkkca2",
    'color.background.accent.purple.subtlest.pressed': "_bfhk1jbm",
    'color.background.accent.purple.subtler': "_bfhk1nm4",
    'color.background.accent.purple.subtler.hovered': "_bfhkattl",
    'color.background.accent.purple.subtler.pressed': "_bfhk3nfk",
    'color.background.accent.purple.subtle': "_bfhk18ah",
    'color.background.accent.purple.subtle.hovered': "_bfhk8bp1",
    'color.background.accent.purple.subtle.pressed': "_bfhk1cd2",
    'color.background.accent.purple.bolder': "_bfhkya33",
    'color.background.accent.purple.bolder.hovered': "_bfhk1af5",
    'color.background.accent.purple.bolder.pressed': "_bfhk6cze",
    'color.background.accent.magenta.subtlest': "_bfhk8tvm",
    'color.background.accent.magenta.subtlest.hovered': "_bfhkr3zd",
    'color.background.accent.magenta.subtlest.pressed': "_bfhk1ckf",
    'color.background.accent.magenta.subtler': "_bfhkv9ra",
    'color.background.accent.magenta.subtler.hovered': "_bfhk1axx",
    'color.background.accent.magenta.subtler.pressed': "_bfhk42ri",
    'color.background.accent.magenta.subtle': "_bfhk1mi6",
    'color.background.accent.magenta.subtle.hovered': "_bfhkrwyz",
    'color.background.accent.magenta.subtle.pressed': "_bfhk6c15",
    'color.background.accent.magenta.bolder': "_bfhkc3uk",
    'color.background.accent.magenta.bolder.hovered': "_bfhk1ok8",
    'color.background.accent.magenta.bolder.pressed': "_bfhkeawv",
    'color.background.accent.gray.subtlest': "_bfhkysee",
    'color.background.accent.gray.subtlest.hovered': "_bfhkwejn",
    'color.background.accent.gray.subtlest.pressed': "_bfhk18ut",
    'color.background.accent.gray.subtler': "_bfhk7qp0",
    'color.background.accent.gray.subtler.hovered': "_bfhk10ef",
    'color.background.accent.gray.subtler.pressed': "_bfhk1rk9",
    'color.background.accent.gray.subtle': "_bfhk18j9",
    'color.background.accent.gray.subtle.hovered': "_bfhk1nv3",
    'color.background.accent.gray.subtle.pressed': "_bfhkq9tj",
    'color.background.accent.gray.bolder': "_bfhk1i45",
    'color.background.accent.gray.bolder.hovered': "_bfhkbyip",
    'color.background.accent.gray.bolder.pressed': "_bfhk1van",
    'color.background.disabled': "_bfhkby5v",
    'color.background.input': "_bfhk1j9a",
    'color.background.input.hovered': "_bfhkl4ek",
    'color.background.input.pressed': "_bfhkr01l",
    'color.background.inverse.subtle': "_bfhk1vck",
    'color.background.inverse.subtle.hovered': "_bfhkmpja",
    'color.background.inverse.subtle.pressed': "_bfhk1gii",
    'color.background.neutral': "_bfhki8nm",
    'color.background.neutral.hovered': "_bfhkplhp",
    'color.background.neutral.pressed': "_bfhk1gdz",
    'color.background.neutral.subtle': "_bfhksm61",
    'color.background.neutral.subtle.hovered': "_bfhk1dpa",
    'color.background.neutral.subtle.pressed': "_bfhkfcek",
    'color.background.neutral.bold': "_bfhk1aqn",
    'color.background.neutral.bold.hovered': "_bfhk1ibz",
    'color.background.neutral.bold.pressed': "_bfhkof27",
    'color.background.selected': "_bfhk15s3",
    'color.background.selected.hovered': "_bfhkufnl",
    'color.background.selected.pressed': "_bfhknozp",
    'color.background.selected.bold': "_bfhkjmqp",
    'color.background.selected.bold.hovered': "_bfhk1q28",
    'color.background.selected.bold.pressed': "_bfhk12kk",
    'color.background.brand.subtlest': "_bfhk1gmr",
    'color.background.brand.subtlest.hovered': "_bfhk3v15",
    'color.background.brand.subtlest.pressed': "_bfhku02c",
    'color.background.brand.bold': "_bfhk1856",
    'color.background.brand.bold.hovered': "_bfhkhf2y",
    'color.background.brand.bold.pressed': "_bfhkg6ey",
    'color.background.brand.boldest': "_bfhk1o4i",
    'color.background.brand.boldest.hovered': "_bfhklefx",
    'color.background.brand.boldest.pressed': "_bfhk16k6",
    'color.background.danger': "_bfhk1gly",
    'color.background.danger.hovered': "_bfhk1yvi",
    'color.background.danger.pressed': "_bfhk1r4b",
    'color.background.danger.bold': "_bfhkybec",
    'color.background.danger.bold.hovered': "_bfhks9hg",
    'color.background.danger.bold.pressed': "_bfhk13a9",
    'color.background.warning': "_bfhk1917",
    'color.background.warning.hovered': "_bfhk19zu",
    'color.background.warning.pressed': "_bfhkzr32",
    'color.background.warning.bold': "_bfhk1kmu",
    'color.background.warning.bold.hovered': "_bfhk1spp",
    'color.background.warning.bold.pressed': "_bfhk4m4m",
    'color.background.success': "_bfhk1y9u",
    'color.background.success.hovered': "_bfhk1vfx",
    'color.background.success.pressed': "_bfhk1wl5",
    'color.background.success.bold': "_bfhkkcmj",
    'color.background.success.bold.hovered': "_bfhky7x8",
    'color.background.success.bold.pressed': "_bfhkwcbh",
    'color.background.discovery': "_bfhk6vm6",
    'color.background.discovery.hovered': "_bfhk12eq",
    'color.background.discovery.pressed': "_bfhk18vq",
    'color.background.discovery.bold': "_bfhku5tj",
    'color.background.discovery.bold.hovered': "_bfhkfqeg",
    'color.background.discovery.bold.pressed': "_bfhk1f1m",
    'color.background.information': "_bfhk19ip",
    'color.background.information.hovered': "_bfhk86z5",
    'color.background.information.pressed': "_bfhk1c1j",
    'color.background.information.bold': "_bfhkx4w0",
    'color.background.information.bold.hovered': "_bfhkq2ii",
    'color.background.information.bold.pressed': "_bfhkf89v",
    'color.blanket': "_bfhk1i5c",
    'color.blanket.selected': "_bfhk7wq0",
    'color.blanket.danger': "_bfhkrprw",
    'color.skeleton': "_bfhkizff",
    'color.skeleton.subtle': "_bfhkvkf5",
    'elevation.surface': "_bfhkvuon",
    'elevation.surface.hovered': "_bfhk19i6",
    'elevation.surface.pressed': "_bfhk13ro",
    'elevation.surface.overlay': "_bfhk1bhr",
    'elevation.surface.overlay.hovered': "_bfhk6o2t",
    'elevation.surface.overlay.pressed': "_bfhkm8nx",
    'elevation.surface.raised': "_bfhkhp5a",
    'elevation.surface.raised.hovered': "_bfhk116u",
    'elevation.surface.raised.pressed': "_bfhk14aj",
    'elevation.surface.sunken': "_bfhkhfxm",
    'utility.elevation.surface.current': "_bfhkchd4"
};
var $e4b6a0e9d74e117e$var$CURRENT_SURFACE_CSS_VAR = "--ds-elevation-surface-current";
var $e4b6a0e9d74e117e$var$setSurfaceTokenMap = {
    'elevation.surface': "_1q1lvuon",
    'elevation.surface.hovered': "_1q1l19i6",
    'elevation.surface.pressed': "_1q1l13ro",
    'elevation.surface.overlay': "_1q1l1bhr",
    'elevation.surface.overlay.hovered': "_1q1l6o2t",
    'elevation.surface.overlay.pressed': "_1q1lm8nx",
    'elevation.surface.raised': "_1q1lhp5a",
    'elevation.surface.raised.hovered': "_1q1l116u",
    'elevation.surface.raised.pressed': "_1q1l14aj",
    'elevation.surface.sunken': "_1q1lhfxm"
};
var $e4b6a0e9d74e117e$var$paddingBlockStartMap = {
    'space.0': "_1q51ze3t",
    'space.025': "_1q51v77o",
    'space.050': "_1q511b66",
    'space.075': "_1q5112x7",
    'space.100': "_1q51u2gc",
    'space.150': "_1q51utpp",
    'space.200': "_1q51pxbi",
    'space.250': "_1q51v47k",
    'space.300': "_1q511ejb",
    'space.400': "_1q51xy5q",
    'space.500': "_1q511jfw",
    'space.600': "_1q51oahv",
    'space.800': "_1q51xncg",
    'space.1000': "_1q511epz"
};
var $e4b6a0e9d74e117e$var$paddingBlockEndMap = {
    'space.0': "_85i5ze3t",
    'space.025': "_85i5v77o",
    'space.050': "_85i51b66",
    'space.075': "_85i512x7",
    'space.100': "_85i5u2gc",
    'space.150': "_85i5utpp",
    'space.200': "_85i5pxbi",
    'space.250': "_85i5v47k",
    'space.300': "_85i51ejb",
    'space.400': "_85i5xy5q",
    'space.500': "_85i51jfw",
    'space.600': "_85i5oahv",
    'space.800': "_85i5xncg",
    'space.1000': "_85i51epz"
};
var $e4b6a0e9d74e117e$var$paddingInlineStartMap = {
    'space.0': "_bozgze3t",
    'space.025': "_bozgv77o",
    'space.050': "_bozg1b66",
    'space.075': "_bozg12x7",
    'space.100': "_bozgu2gc",
    'space.150': "_bozgutpp",
    'space.200': "_bozgpxbi",
    'space.250': "_bozgv47k",
    'space.300': "_bozg1ejb",
    'space.400': "_bozgxy5q",
    'space.500': "_bozg1jfw",
    'space.600': "_bozgoahv",
    'space.800': "_bozgxncg",
    'space.1000': "_bozg1epz"
};
var $e4b6a0e9d74e117e$var$paddingInlineEndMap = {
    'space.0': "_y4tize3t",
    'space.025': "_y4tiv77o",
    'space.050': "_y4ti1b66",
    'space.075': "_y4ti12x7",
    'space.100': "_y4tiu2gc",
    'space.150': "_y4tiutpp",
    'space.200': "_y4tipxbi",
    'space.250': "_y4tiv47k",
    'space.300': "_y4ti1ejb",
    'space.400': "_y4tixy5q",
    'space.500': "_y4ti1jfw",
    'space.600': "_y4tioahv",
    'space.800': "_y4tixncg",
    'space.1000': "_y4ti1epz"
};
/**
 * __Box__
 *
 * A Box is a primitive component that has the design decisions of the Atlassian Design System baked in.
 * Renders a `div` by default.
 *
 * - [Examples](https://atlassian.design/components/primitives/box/examples)
 * - [Code](https://atlassian.design/components/primitives/box/code)
 * - [Usage](https://atlassian.design/components/primitives/box/usage)
 */ var $e4b6a0e9d74e117e$var$Box = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? 'div' : _ref$as, children = _ref.children, backgroundColor = _ref.backgroundColor, padding = _ref.padding, _ref$paddingBlock = _ref.paddingBlock, paddingBlock = _ref$paddingBlock === void 0 ? padding : _ref$paddingBlock, _ref$paddingBlockStar = _ref.paddingBlockStart, paddingBlockStart = _ref$paddingBlockStar === void 0 ? paddingBlock : _ref$paddingBlockStar, _ref$paddingBlockEnd = _ref.paddingBlockEnd, paddingBlockEnd = _ref$paddingBlockEnd === void 0 ? paddingBlock : _ref$paddingBlockEnd, _ref$paddingInline = _ref.paddingInline, paddingInline = _ref$paddingInline === void 0 ? padding : _ref$paddingInline, _ref$paddingInlineSta = _ref.paddingInlineStart, paddingInlineStart = _ref$paddingInlineSta === void 0 ? paddingInline : _ref$paddingInlineSta, _ref$paddingInlineEnd = _ref.paddingInlineEnd, paddingInlineEnd = _ref$paddingInlineEnd === void 0 ? paddingInline : _ref$paddingInlineEnd, style = _ref.style, testId = _ref.testId, xcss = _ref.xcss, htmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $e4b6a0e9d74e117e$var$_excluded);
    // This is to remove className from safeHtmlAttributes
    // @ts-ignore -- not using expect since it causes issues with help-center local consumption - className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(htmlAttributes, $e4b6a0e9d74e117e$var$_excluded2);
    var node = /*#__PURE__*/ $5FkrB.createElement(Component, (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        style: style,
        ref: ref,
        className: (0, $970q7.default)([
            "_19itglyw _vchhusvi _r06hglyw",
            backgroundColor && $e4b6a0e9d74e117e$var$backgroundColorMap[backgroundColor],
            backgroundColor && $e4b6a0e9d74e117e$var$isSurfaceToken(backgroundColor) && $e4b6a0e9d74e117e$var$setSurfaceTokenMap[backgroundColor],
            paddingBlockStart && $e4b6a0e9d74e117e$var$paddingBlockStartMap[paddingBlockStart],
            paddingBlockEnd && $e4b6a0e9d74e117e$var$paddingBlockEndMap[paddingBlockEnd],
            paddingInlineStart && $e4b6a0e9d74e117e$var$paddingInlineStartMap[paddingInlineStart],
            paddingInlineEnd && $e4b6a0e9d74e117e$var$paddingInlineEndMap[paddingInlineEnd],
            xcss
        ])
    }, safeHtmlAttributes, {
        "data-testid": testId
    }), children);
    if (backgroundColor) return /*#__PURE__*/ $5FkrB.createElement((0, $e2c317a5a849c806$export$1ca2a26fecb070ae).Provider, {
        value: backgroundColor
    }, node);
    return node;
});
var $e4b6a0e9d74e117e$export$2e2bcd8739ae039 = $e4b6a0e9d74e117e$var$Box;
function $e4b6a0e9d74e117e$var$isSurfaceToken(backgroundColor) {
    return backgroundColor in $e4b6a0e9d74e117e$var$setSurfaceTokenMap;
}




var $kqp0i = parcelRequire("kqp0i");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");

// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766


var $fcc10412a5b9968c$export$969a0501aa28855a = (0, $0b1eca56b0789a79$export$2e2bcd8739ae039).div({
    background: 0,
    border: 0,
    borderRadius: "var(--ds-radius-xsmall, 2px)",
    color: "var(--ds-text-subtlest, ".concat((0, $84873b2431594582$export$8754fc7e6d8b3000), ")"),
    cursor: 'pointer',
    height: "var(--ds-space-300, 24px)",
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: 1,
    outline: 0,
    padding: 0,
    display: 'flex',
    alignItems: 'center',
    marginLeft: "var(--ds-space-025, 2px)",
    transition: 'background-color 200ms opacity 200ms',
    width: "var(--ds-space-300, 24px)",
    '&:hover, &:focus': {
        color: "var(--ds-text-subtle, ".concat((0, $84873b2431594582$export$5f71e19f3a7ad9de), ")")
    }
});


var $6eab9bc9e9038f6f$var$_excluded = [
    "label"
];
var $6eab9bc9e9038f6f$export$13ec83e50bf04290 = function ClearButton(_ref) {
    var label = _ref.label, props = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $6eab9bc9e9038f6f$var$_excluded);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $fcc10412a5b9968c$export$969a0501aa28855a), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, props, {
        "data-testid": "paginated-picker.ui.clear-button"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($af87215eeccde75b$exports))), {
        color: "currentColor",
        label: label,
        size: "small"
    }));
};
$6eab9bc9e9038f6f$export$13ec83e50bf04290.defaultProps = {
    isSelected: false,
    type: 'button'
};
var $6eab9bc9e9038f6f$export$2e2bcd8739ae039 = $6eab9bc9e9038f6f$export$13ec83e50bf04290;


// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $73a1fa5e1b4f1190$export$c7a90a9f6120efb7 = (0, $0b1eca56b0789a79$export$2e2bcd8739ae039).div({
    position: 'relative',
    animation: 'flickerAnimation 2s infinite',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '@keyframes flickerAnimation': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '0%': {
            opacity: 1
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '50%': {
            opacity: 0.5
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '100%': {
            opacity: 1
        }
    }
});


// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $1953a2583c183d28$export$d53c836cccbb0d90 = (0, $0b1eca56b0789a79$export$2e2bcd8739ae039).div({
    position: 'relative'
});
var $1953a2583c183d28$export$cd8104a6ec6bb897 = (0, $0b1eca56b0789a79$export$2e2bcd8739ae039).div({
    background: 0,
    border: 0,
    height: "var(--ds-space-300, 24px)",
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: 1,
    outline: 0,
    padding: 0,
    position: 'absolute',
    right: "var(--ds-space-negative-050, -4px)",
    top: '50%',
    marginTop: "var(--ds-space-negative-150, -12px)",
    width: "var(--ds-space-300, 24px)"
});


var $9029130cf9d754df$var$textPadding = {
    root: "_u5f3utpp"
};
var $9029130cf9d754df$export$d7b370c39c0de454 = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function(_ref, ref) {
    var children = _ref.children, isInvalid = _ref.isInvalid, isSelected = _ref.isSelected, hideSelectedIndicator = _ref.hideSelectedIndicator, triggerIcon = _ref.triggerIcon, isLoading = _ref.isLoading, hasValues = _ref.hasValues, onClick = _ref.onClick, onClear = _ref.onClear, testId = _ref.testId, isDisabled = _ref.isDisabled, ariaLabel = _ref.ariaLabel;
    if (isLoading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $de01b096d7a510fa$export$b61655080b0a1f32), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $73a1fa5e1b4f1190$export$c7a90a9f6120efb7), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $298f70230884e886$export$2e2bcd8739ae039), {
        isSelected: !hideSelectedIndicator && isSelected,
        iconBefore: triggerIcon,
        testId: testId
    }, children, ":")));
    var afterTriggerIcon = onClear ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $1953a2583c183d28$export$cd8104a6ec6bb897), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $6eab9bc9e9038f6f$export$13ec83e50bf04290), {
        onClick: function onClick(e) {
            e.stopPropagation();
            onClear === null || onClear === void 0 || onClear();
        },
        label: "Remove criteria"
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8b2dd9bf72c54e50$exports))), {
        color: "currentColor",
        label: "",
        size: "small"
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $de01b096d7a510fa$export$b61655080b0a1f32), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $1953a2583c183d28$export$d53c836cccbb0d90), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $298f70230884e886$export$2e2bcd8739ae039), {
        appearance: isInvalid ? 'danger' : 'default',
        isSelected: !hideSelectedIndicator && (isSelected || hasValues),
        iconBefore: triggerIcon,
        iconAfter: function iconAfter() {
            return afterTriggerIcon;
        },
        onClick: onClick,
        ref: ref,
        testId: testId,
        "aria-expanded": isSelected,
        isDisabled: isDisabled,
        "aria-label": ariaLabel && (0, $9Zzpd.fg)('jsm-accessibility-fixes') ? ariaLabel : undefined
    }, onClear ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $e4b6a0e9d74e117e$export$2e2bcd8739ae039), {
        xcss: $9029130cf9d754df$var$textPadding.root
    }, children) : children)));
});
var $9029130cf9d754df$export$2e2bcd8739ae039 = $9029130cf9d754df$export$d7b370c39c0de454;


// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled

var $6Qk7v = parcelRequire("6Qk7v");
var $8b7554b4758d7ba6$export$e74528b7a1d409c0 = (0, $6Qk7v.default).div({
    display: 'flex'
});


var $57e93f82e6ef5a0a$var$PaginatedFilter = function PaginatedFilter(props) {
    var _props$initiallyOpene = props.initiallyOpened, initiallyOpened = _props$initiallyOpene === void 0 ? false : _props$initiallyOpene, onOpen = props.onOpen, onClose = props.onClose, fieldId = props.fieldId, fieldLabel = props.fieldLabel, fieldLabelIcon = props.fieldLabelIcon, fieldInvalidLabel = props.fieldInvalidLabel, formatOptionLabel = props.formatOptionLabel, initiallyAddSelectedFirst = props.initiallyAddSelectedFirst, inModal = props.inModal, onChange = props.onChange, onLoadOptions = props.onLoadOptions, onClearValues = props.onClearValues, onPickerTriggerClick = props.onPickerTriggerClick, onPickerTriggerClear = props.onPickerTriggerClear, PopupComponent = props.PopupComponent, testId = props.testId, value = props.value, showFooter = props.showFooter, hideSelectedIndicator = props.hideSelectedIndicator, ariaLabel = props.ariaLabel, isLoading = props.isLoading, isDisabled = props.isDisabled;
    var _React$useState = (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).useState(initiallyOpened), _React$useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_React$useState, 2), isFilterOpen = _React$useState2[0], setIsFilterOpen = _React$useState2[1];
    var wrapperRef = (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).useRef(null);
    var handlePickerTriggerClick = function handlePickerTriggerClick() {
        var newIsFilterOpen = !isFilterOpen;
        setIsFilterOpen(newIsFilterOpen);
        if (onPickerTriggerClick) onPickerTriggerClick();
        if (newIsFilterOpen && onOpen) onOpen();
        if (!newIsFilterOpen && onClose) onClose();
    };
    var handleClose = function handleClose() {
        var isEscapeKey = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
        setIsFilterOpen(false);
        if (onClose) onClose();
        if (isEscapeKey) {
            if (wrapperRef.current) {
                var button = wrapperRef.current.querySelector('button');
                if (button) button.focus();
            }
        }
    };
    var handleChange = function handleChange(options, option, selectData) {
        if (onChange) onChange(options, option, selectData);
    };
    var handleClearValues = function handleClearValues() {
        if (onClearValues) onClearValues();
    };
    var handleCloseWrapper = function handleCloseWrapper(e) {
        var isEscapeKey = (e === null || e === void 0 ? void 0 : e.key) === 'Escape';
        handleClose(isEscapeKey);
    };
    var handleTrigger = function handleTrigger(_ref) {
        var ref = _ref.ref;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $3d0c4bddb991ba57$export$2e2bcd8739ae039), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $9029130cf9d754df$export$2e2bcd8739ae039), {
            hasValues: value.length > 0,
            onClick: handlePickerTriggerClick,
            isSelected: isFilterOpen,
            hideSelectedIndicator: hideSelectedIndicator,
            triggerIcon: fieldLabelIcon,
            isInvalid: value.some(function(val) {
                return val.invalid;
            }),
            ref: ref,
            testId: testId,
            onClear: onPickerTriggerClear !== null && onPickerTriggerClear !== void 0 ? onPickerTriggerClear : undefined,
            isLoading: isLoading,
            isDisabled: isDisabled
        }, (0, $1f37b131da0ba31f$export$957d7daebd899f12)(fieldLabel, value)));
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $8b7554b4758d7ba6$export$e74528b7a1d409c0), {
        ref: wrapperRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $28a44b62f5812c94$export$ba25329847403e11), {
        isOpen: isFilterOpen,
        onOpen: (0, (/*@__PURE__*/$parcel$interopDefault($7WAD0)) //this doesn't do anything in paginated-picker
        ),
        onClose: handleCloseWrapper,
        value: value,
        pagination: {
            enableFullList: false
        },
        fieldId: fieldId,
        fieldLabel: fieldLabel,
        fieldInvalidLabel: fieldInvalidLabel,
        formatOptionLabel: formatOptionLabel,
        initiallyAddSelectedFirst: initiallyAddSelectedFirst,
        onChange: handleChange,
        onLoadOptions: onLoadOptions,
        onTrigger: handleTrigger,
        onClearValues: handleClearValues,
        PopupComponent: PopupComponent,
        showFooter: showFooter,
        popupProps: inModal ? {
            zIndex: (0, $0a8491a5f0c98b2c$export$7be255094ccdc533).modal()
        } : undefined,
        ariaLabel: ariaLabel
    }));
};
var $57e93f82e6ef5a0a$export$2e2bcd8739ae039 = $57e93f82e6ef5a0a$var$PaginatedFilter;




// THIS FILE IS AUTO-GENERATED FROM dataportal.yml
// DO NOT EDIT MANUALLY - Run 'yarn analytics:generate' to regenerate
/* eslint-disable no-unused-vars */ // Import Atlassian analytics types for reference and potential future use
// These provide the strict typing for the actual analytics client
// Note: These imports are kept for reference and potential future use in type definitions
var $d3be6fee8a258747$export$e19cd5f9376f8cee = /*#__PURE__*/ function(Action) {
    Action["Cancelled"] = "cancelled";
    Action["Clicked"] = "clicked";
    Action["Submitted"] = "submitted";
    Action["Closed"] = "closed";
    Action["Typed"] = "typed";
    Action["Searched"] = "searched";
    Action["Created"] = "created";
    Action["Updated"] = "updated";
    Action["Deleted"] = "deleted";
    Action["Invited"] = "invited";
    Action["Selected"] = "selected";
    Action["Focused"] = "focused";
    Action["Blurred"] = "blurred";
    Action["Viewed"] = "viewed";
    Action["Shown"] = "shown";
    Action["Displayed"] = "displayed";
    Action["Hovered"] = "hovered";
    Action["Entered"] = "entered";
    Action["Switched"] = "switched";
    Action["Dwelled"] = "dwelled";
    Action["Toggled"] = "toggled";
    Action["Pressed"] = "pressed";
    Action["Pasted"] = "pasted";
    Action["Copy"] = "copy";
    Action["Changed"] = "changed";
    Action["Fetch"] = "fetch";
    Action["Cleared"] = "cleared";
    return Action;
}({});
var $d3be6fee8a258747$export$7f97440769de1377 = /*#__PURE__*/ function(ActionSubject) {
    ActionSubject["Table"] = "table";
    ActionSubject["Button"] = "button";
    ActionSubject["Form"] = "form";
    ActionSubject["Link"] = "link";
    ActionSubject["AppSwitcherDropdown"] = "appSwitcherDropdown";
    ActionSubject["AppSwitcherItem"] = "appSwitcherItem";
    ActionSubject["Organization"] = "organization";
    ActionSubject["OrganizationSelectorItem"] = "organizationSelectorItem";
    ActionSubject["BillingSelectorItem"] = "billingSelectorItem";
    ActionSubject["HelpSelectorItem"] = "helpSelectorItem";
    ActionSubject["Dialog"] = "dialog";
    ActionSubject["Datepicker"] = "datepicker";
    ActionSubject["Field"] = "field";
    ActionSubject["NavigationItem"] = "navigationItem";
    ActionSubject["Toggle"] = "toggle";
    ActionSubject["Checkbox"] = "checkbox";
    ActionSubject["DropListItem"] = "dropListItem";
    ActionSubject["DropListTrigger"] = "dropListTrigger";
    ActionSubject["RadioButton"] = "radioButton";
    ActionSubject["Radio"] = "radio";
    ActionSubject["TextField"] = "textField";
    ActionSubject["Text"] = "text";
    ActionSubject["Badge"] = "badge";
    ActionSubject["Dropdown"] = "dropdown";
    ActionSubject["DropdownItem"] = "dropdownItem";
    ActionSubject["SelectItem"] = "selectItem";
    ActionSubject["Error"] = "error";
    ActionSubject["Chart"] = "chart";
    ActionSubject["Page"] = "page";
    ActionSubject["Card"] = "card";
    ActionSubject["Tooltip"] = "tooltip";
    ActionSubject["Icon"] = "icon";
    ActionSubject["NotificationModal"] = "notificationModal";
    ActionSubject["Notification"] = "notification";
    ActionSubject["MenuItem"] = "menuItem";
    ActionSubject["UserPicker"] = "userPicker";
    ActionSubject["Accordion"] = "accordion";
    ActionSubject["Tab"] = "tab";
    ActionSubject["Modal"] = "modal";
    ActionSubject["Flag"] = "flag";
    ActionSubject["IphSideBar"] = "iphSideBar";
    ActionSubject["Input"] = "input";
    ActionSubject["SearchResult"] = "searchResult";
    ActionSubject["CallToAction"] = "callToAction";
    ActionSubject["ResendInvite"] = "resendInvite";
    ActionSubject["DisimssButton"] = "dismissButton";
    ActionSubject["EmptyTable"] = "emptyTable";
    ActionSubject["Row"] = "row";
    ActionSubject["Option"] = "option";
    ActionSubject["FilterController"] = "filterController";
    ActionSubject["Banner"] = "banner";
    ActionSubject["Spotlight"] = "spotlight";
    return ActionSubject;
}({});


const $3e8e9266fe04abe4$export$7a7a8c2474f854cd = {
    appUpdatesListScreen: 'appUpdatesListScreen',
    appUpdatesDetailsScreen: 'appUpdatesDetailsScreen'
};
const $3e8e9266fe04abe4$export$73f866ce8175509a = {
    screen: {
        /**
     * App Updates List Screen View
     */ appUpdatesListScreen: {
            data: {
                name: $3e8e9266fe04abe4$export$7a7a8c2474f854cd.appUpdatesListScreen
            }
        },
        /**
     * App Updates Details Screen View
     */ appUpdatesDetailsScreen: (changelogId, updatesAppTypes)=>({
                data: {
                    name: $3e8e9266fe04abe4$export$7a7a8c2474f854cd.appUpdatesDetailsScreen,
                    attributes: {
                        changelogId: changelogId,
                        ...updatesAppTypes && {
                            updatesAppTypes: updatesAppTypes
                        }
                    }
                }
            })
    },
    ui: {
        /**
     * User clicked the app filter on the app updates list screen
     */ appUpdatesAppFilterClicked: (data, updatesAppTypes)=>({
                data: {
                    action: (0, $d3be6fee8a258747$export$e19cd5f9376f8cee).Clicked,
                    actionSubject: (0, $d3be6fee8a258747$export$7f97440769de1377).Button,
                    actionSubjectId: 'appUpdatesAppFilter',
                    ...data,
                    attributes: {
                        ...updatesAppTypes && {
                            updatesAppTypes: updatesAppTypes
                        }
                    }
                }
            }),
        /**
     * User clicked the status filter on the app updates list screen
     */ appUpdatesStatusFilterClicked: (data, updatesStatusTypes)=>({
                data: {
                    action: (0, $d3be6fee8a258747$export$e19cd5f9376f8cee).Clicked,
                    actionSubject: (0, $d3be6fee8a258747$export$7f97440769de1377).Button,
                    actionSubjectId: 'appUpdatesStatusFilter',
                    ...data,
                    attributes: {
                        ...updatesStatusTypes && {
                            updatesStatusTypes: updatesStatusTypes
                        }
                    }
                }
            }),
        /**
     * User clicked the type filter on the app updates list screen
     */ appUpdatesTypeFilterClicked: (data, updatesChangeTypes)=>({
                data: {
                    action: (0, $d3be6fee8a258747$export$e19cd5f9376f8cee).Clicked,
                    actionSubject: (0, $d3be6fee8a258747$export$7f97440769de1377).Button,
                    actionSubjectId: 'appUpdatesTypeFilter',
                    ...data,
                    attributes: {
                        ...updatesChangeTypes && {
                            updatesChangeTypes: updatesChangeTypes
                        }
                    }
                }
            }),
        /**
     * User clicked the impact rating filter on the app updates list screen
     */ appUpdatesImpactRatingFilterClicked: (data, updatesImpactTypes)=>({
                data: {
                    action: (0, $d3be6fee8a258747$export$e19cd5f9376f8cee).Clicked,
                    actionSubject: (0, $d3be6fee8a258747$export$7f97440769de1377).Button,
                    actionSubjectId: 'appUpdatesImpactRatingFilter',
                    ...data,
                    attributes: {
                        ...updatesImpactTypes && {
                            updatesImpactTypes: updatesImpactTypes
                        }
                    }
                }
            }),
        /**
     * User clicked the contextual tag filter on the app updates list screen
     */ appUpdatesTagFilterClicked: (data, updatesTagTypes)=>({
                data: {
                    action: (0, $d3be6fee8a258747$export$e19cd5f9376f8cee).Clicked,
                    actionSubject: (0, $d3be6fee8a258747$export$7f97440769de1377).Button,
                    actionSubjectId: 'appUpdatesTagFilter',
                    ...data,
                    attributes: {
                        ...updatesTagTypes && {
                            updatesTagTypes: updatesTagTypes
                        }
                    }
                }
            }),
        /**
     * User clicked the apply button on the app updates list screen
     */ appUpdatesApplyClicked: (data, updatesAppTypes, updatesStatusTypes, updatesChangeTypes, updatesSearchContent)=>({
                data: {
                    action: (0, $d3be6fee8a258747$export$e19cd5f9376f8cee).Clicked,
                    actionSubject: (0, $d3be6fee8a258747$export$7f97440769de1377).Button,
                    actionSubjectId: 'appUpdatesApply',
                    ...data,
                    attributes: {
                        ...updatesAppTypes && {
                            updatesAppTypes: updatesAppTypes
                        },
                        ...updatesStatusTypes && {
                            updatesStatusTypes: updatesStatusTypes
                        },
                        ...updatesChangeTypes && {
                            updatesChangeTypes: updatesChangeTypes
                        },
                        ...updatesSearchContent && {
                            updatesSearchContent: updatesSearchContent
                        }
                    }
                }
            })
    },
    track: {},
    operational: {}
};


var $5FkrB = parcelRequire("5FkrB");

var $25nEq = parcelRequire("25nEq");
// These types have been converted from frozen objects to enums.
// We cannot change their name, or even capitalise them without breaking API.
let $9c4c150c990b1f10$export$56ac8ebc9870b1b9 = /*#__PURE__*/ function(envType) {
    envType["LOCAL"] = "local";
    envType["DEV"] = "dev";
    envType["STAGING"] = "staging";
    envType["PROD"] = "prod";
    return envType;
}({});
let $9c4c150c990b1f10$export$4c045e605d532c98 = /*#__PURE__*/ function(eventType) {
    eventType["TRACK"] = "track";
    eventType["UI"] = "ui";
    eventType["OPERATIONAL"] = "operational";
    eventType["SCREEN"] = "screen";
    eventType["IDENTIFY"] = "identify";
    return eventType;
}({});
let $9c4c150c990b1f10$export$6b4f396210e539f3 = /*#__PURE__*/ function(platformType) {
    platformType["MAC"] = "mac";
    platformType["LINUX"] = "linux";
    platformType["WINDOWS"] = "windows";
    /**
   *  @deprecated desktop is here for retrocompatibility, please select one of the above OS instead.
   */ platformType["DESKTOP"] = "desktop";
    platformType["WEB"] = "web";
    platformType["MOBILE_WEB"] = "mobileWeb";
    return platformType;
}({});
let $9c4c150c990b1f10$export$f73e9fcd368bb695 = /*#__PURE__*/ function(originType) {
    originType["DESKTOP"] = "desktop";
    originType["WEB"] = "web";
    return originType;
}({});
let $9c4c150c990b1f10$export$496f06ac2a964da2 = /*#__PURE__*/ function(tenantType) {
    tenantType["CLOUD_ID"] = "cloudId";
    tenantType["ORG_ID"] = "orgId";
    tenantType["OPSGENIE_CUSTOMER_ID"] = "opsgenieCustomerId";
    tenantType["HALP_TEAM_ID"] = "halpTeamId";
    tenantType["LOOM_ORG_ID"] = "loomOrgId";
    tenantType["TRANSACTION_ACCOUNT_ID"] = "transactionAccountId";
    tenantType["TRELLO_WORKSPACE_ID"] = "trelloWorkspaceId";
    tenantType["JA_WORKSPACE_ID"] = "jiraAlignWorkspaceId";
    tenantType["STUDIO_WORKSPACE_ID"] = "studioWorkspaceId";
    tenantType["NONE"] = "none";
    return tenantType;
}({});
let $9c4c150c990b1f10$export$f49776dca27a2e7c = /*#__PURE__*/ function(productEmbedType) {
    productEmbedType["FIRST_PARTY"] = "FIRST_PARTY";
    productEmbedType["THIRD_PARTY"] = "THIRD_PARTY";
    return productEmbedType;
}({});
let $9c4c150c990b1f10$export$1827adfd178b4870 = /*#__PURE__*/ function(userType) {
    userType["ATLASSIAN_ACCOUNT"] = "atlassianAccount";
    userType["HASHED_EMAIL"] = "hashedEmail";
    userType["LOOM"] = "loom";
    userType["TRELLO"] = "trello";
    userType["OPSGENIE"] = "opsgenie";
    userType["JA_USER_ID"] = "jiraAlign";
    userType["HALP"] = "halp";
    return userType;
}({});
let $9c4c150c990b1f10$export$99b37380a464d794 = /*#__PURE__*/ function(apdexType) {
    apdexType["TRANSITION"] = "transition";
    apdexType["INITIAL_LOAD"] = "initialLoad";
    return apdexType;
}({});
const $9c4c150c990b1f10$export$809831be6c4c6227 = Object.freeze([
    $9c4c150c990b1f10$export$6b4f396210e539f3.DESKTOP,
    $9c4c150c990b1f10$export$6b4f396210e539f3.MAC,
    $9c4c150c990b1f10$export$6b4f396210e539f3.LINUX,
    $9c4c150c990b1f10$export$6b4f396210e539f3.WINDOWS
]);
const $9c4c150c990b1f10$export$19c579398ad213e7 = Object.freeze([
    $9c4c150c990b1f10$export$6b4f396210e539f3.WEB,
    $9c4c150c990b1f10$export$6b4f396210e539f3.MOBILE_WEB
]);
let $9c4c150c990b1f10$export$62a500c02dc63ee = /*#__PURE__*/ function(originTracingType) {
    originTracingType["ATL_ORIGIN"] = "atlOrigin";
    return originTracingType;
}({});
function $9c4c150c990b1f10$export$ad1854f4a08c15f8(object) {
    return Object.values(object);
}
function $9c4c150c990b1f10$export$26b9f946b448f23e(type, value) {
    return Object.values(type).indexOf(value) > -1;
}
let $9c4c150c990b1f10$export$bdd41749d2096e4b = /*#__PURE__*/ function(perimeterType) {
    perimeterType["C5"] = "c5";
    perimeterType["COMMERCIAL"] = "commercial";
    perimeterType["FEDRAMP_MODERATE"] = "fedramp-moderate";
    perimeterType["FEDRAMP_HIGH"] = "fedramp-high";
    return perimeterType;
}({});
let $9c4c150c990b1f10$export$a8c99e46b781d936 = /*#__PURE__*/ function(aliasType) {
    return aliasType;
}({});
let $9c4c150c990b1f10$export$e73680b18d9b7c6e = /*#__PURE__*/ function(groupType) {
    groupType["TRANSACTION_ACCOUNT_ID"] = "transactionAccountId";
    return groupType;
}({});
let $9c4c150c990b1f10$export$12b75c708da5a04b = /*#__PURE__*/ function(envOverrides) {
    return envOverrides;
}({});



var $25nEq = parcelRequire("25nEq");


var $25nEq = parcelRequire("25nEq");
class $5a0c8cae642f3b67$export$2e2bcd8739ae039 {
    constructor(){
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "_bindEventListeners", ()=>{
            document.addEventListener(this._visibilityChange, this._handleVisibilityChange, false);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "_handleVisibilityChange", ()=>{
            const isHidden = document[this._hidden];
            this._isHidden = isHidden;
            this._callbacks.forEach((callbackFn)=>callbackFn(isHidden));
        });
        this._isHidden = false;
        this._callbacks = new Map();
        this._hidden = undefined;
        this._visibilityChange = undefined;
        if (typeof document !== 'undefined') {
            if (typeof document.hidden !== 'undefined') {
                // Opera 12.10 and Firefox 18 and later support
                this._isHidden = document.hidden;
                this._hidden = 'hidden';
                this._visibilityChange = 'visibilitychange';
            } else if (typeof document.msHidden !== 'undefined') {
                this._isHidden = document.msHidden;
                this._hidden = 'msHidden';
                this._visibilityChange = 'msvisibilitychange';
            } else if (typeof document.webkitHidden !== 'undefined') {
                this._isHidden = document.webkitHidden;
                this._hidden = 'webkitHidden';
                this._visibilityChange = 'webkitvisibilitychange';
            }
            if (typeof document.addEventListener !== 'undefined' && this._hidden !== undefined) this._bindEventListeners();
        }
    }
    addCallback(name, fn) {
        if (typeof name !== 'string') throw new Error('Invalid name, must be string');
        if (typeof fn !== 'function') throw new Error('Invalid callback, must be function');
        this._callbacks.set(name, fn);
    }
    removeCallback(name) {
        if (this._callbacks.has(name)) this._callbacks.delete(name);
    }
    getIsHidden() {
        return this._isHidden;
    }
}


class $5567e94e2046948c$export$2e2bcd8739ae039 {
    constructor(){
        this._performance = window.performance;
    }
    clearMarks(...args) {
        if (!this._performance || !this._performance.clearMarks) return;
        this._performance.clearMarks(...args);
    }
    mark(...args) {
        if (!this._performance || !this._performance.mark) return;
        this._performance.mark(...args);
    }
    getEntriesByName(...args) {
        if (!this._performance || !this._performance.getEntriesByName) return [];
        return this._performance.getEntriesByName(...args);
    }
    getTimeOrigin() {
        if (!this._performance || !this._performance.timeOrigin && !this._performance.timing) return 0;
        return this._performance.timeOrigin || this._performance.timing.navigationStart;
    }
    now() {
        if (!this._performance || !this._performance.now) return Date.now ? Date.now() : +new Date();
        return this._performance.now();
    }
    isAvailable() {
        return !!this._performance && !!this._performance.clearMarks && !!this._performance.mark && !!this._performance.getEntriesByName && !!this._performance.timing;
    }
}


function $046c48c9d0dd9a40$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $046c48c9d0dd9a40$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $046c48c9d0dd9a40$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $046c48c9d0dd9a40$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
class $046c48c9d0dd9a40$export$2e2bcd8739ae039 {
    constructor(onEvent, pageVisibility){
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "_getEventKey", ({ task: task, taskId: taskId })=>taskId ? `${task}.${taskId}` : task);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "_getEventTimingByName", (name)=>{
            const eventTimings = this._performance.getEntriesByName(name);
            const eventTiming = eventTimings[eventTimings.length - 1];
            return eventTiming;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "_getApdexFields", (event)=>{
            const apdexTimings = this._getApdexTimings(event);
            const apdexScore = this._calculateApdex({
                duration: apdexTimings.duration,
                threshold: event.threshold
            });
            return $046c48c9d0dd9a40$var$_objectSpread($046c48c9d0dd9a40$var$_objectSpread({}, apdexTimings), {}, {
                apdex: apdexScore
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "_getApdexTimings", (event)=>{
            const eventKey = this._getEventKey(event);
            const eventStartName = `${eventKey}-start`;
            const startTime = event.startTime || this._getStartTime(event, eventStartName);
            const stopTime = event.stopTime || this._getStopTime();
            // We do some clean up of the marks and started events
            this._cleanApdexState(eventKey);
            return {
                startTime: startTime,
                stopTime: stopTime,
                duration: stopTime - startTime
            };
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "_getStartTime", (event, eventName)=>{
            let startTime;
            const timeOrigin = this._performance.getTimeOrigin();
            if (event.type === (0, $9c4c150c990b1f10$export$99b37380a464d794).INITIAL_LOAD) startTime = timeOrigin;
            else {
                const eventTiming = this._getEventTimingByName(eventName);
                startTime = timeOrigin + eventTiming.startTime;
            }
            return startTime;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "_getStopTime", ()=>this._performance.getTimeOrigin() + this._performance.now());
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "_cleanApdexState", (eventKey)=>{
            this._performance.clearMarks(`${eventKey}-start`);
            this._performance.clearMarks(`${eventKey}-stop`);
            this._startedEvents.delete(eventKey);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "_getVisibilityFields", (event)=>{
            let isActiveTab;
            /**
       * For initialLoad type:
       * 1. if tab was not ever hidden (!_wasPreviouslyHidden)
       *
       * For transition type:
       * 1. active status is tracked in active events map (_isActiveEvents)
       *
       * For any type, if startTime or stopTime is specified:
       * 1. If currently active (!_isHidden)
       */ if (event.type === (0, $9c4c150c990b1f10$export$99b37380a464d794).INITIAL_LOAD) isActiveTab = !this._wasPreviouslyHidden;
            else if (event.type === (0, $9c4c150c990b1f10$export$99b37380a464d794).TRANSITION) {
                const eventKey = this._getEventKey(event);
                isActiveTab = this._isActiveEvents.get(eventKey);
            }
            if (event.startTime || event.stopTime) isActiveTab = !this._pageVisibility.getIsHidden();
            return {
                isActiveTab: isActiveTab
            };
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "_calculateApdex", ({ duration: duration, threshold: threshold = this._threshold })=>{
            let apdex;
            const satisfiedThreshold = threshold;
            const tolerableThreshold = threshold * 4;
            if (duration <= satisfiedThreshold) apdex = 1;
            else if (duration <= tolerableThreshold) apdex = 0.5;
            else apdex = 0;
            return apdex;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "_validateStartEvent", (event)=>{
            if (!event) throw new Error('Missing "event" in Apdex start event');
            if (!event.task) throw new Error('Missing "task" in Apdex start event');
            if (typeof event.task !== 'string') throw new Error('Invalid "task" in Apdex start event');
            if (event.taskId && typeof event.taskId !== 'string') throw new Error('Invalid "taskId" in Apdex start event');
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "_validateStopEvent", (event)=>{
            if (!event) throw new Error('Missing "event" in Apdex stop event');
            if (!event.task) throw new Error('Missing "task" in Apdex stop event');
            if (typeof event.task !== 'string') throw new Error('Invalid "task" in Apdex stop event');
            if (event.taskId && typeof event.taskId !== 'string') throw new Error('Invalid "taskId" in Apdex stop event');
            if (!event.type) throw new Error('Missing "type" in Apdex stop event');
            if (event.type && !(0, $9c4c150c990b1f10$export$26b9f946b448f23e)((0, $9c4c150c990b1f10$export$99b37380a464d794), event.type)) throw new Error('Invalid "type" in Apdex stop event');
            if (event.threshold && typeof event.threshold !== 'number') throw new Error('Invalid "threshold" in Apdex stop event');
            /*
       * For a transition, if the startTime was not specified,
       * the start event should have been present.
       */ if (!event.startTime && event.type === (0, $9c4c150c990b1f10$export$99b37380a464d794).TRANSITION) {
                const eventKey = this._getEventKey(event);
                if (!this._startedEvents.has(eventKey)) throw new Error(`Apdex event transition "${eventKey}" was not started`);
            }
            if (event.startTime && !(typeof event.startTime === 'number' && event.startTime >= 0)) throw new Error('Invalid "startTime" in Apdex stop event');
            if (event.stopTime && typeof event.stopTime !== 'number') throw new Error('Invalid "stopTime" in Apdex stop event');
            if (event.stopTime <= event.startTime) throw new Error('"stopTime" should be greater than "startTime" in Apdex stop event');
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "_shouldSendEvent", (event)=>{
            if (!event) return false;
            if (typeof event.apdex !== 'number') return false;
            return true;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "_sendEvent", (event, callback)=>{
            if (this._shouldSendEvent(event)) this._onEvent({
                source: 'ui',
                action: 'readyForUser',
                actionSubject: 'ui',
                attributes: $046c48c9d0dd9a40$var$_objectSpread($046c48c9d0dd9a40$var$_objectSpread({}, event.additionalAttributes), {}, {
                    task: event.task,
                    taskId: event.taskId,
                    type: event.type,
                    threshold: event.threshold || this._threshold,
                    apdex: event.apdex,
                    startTime: event.startTime,
                    stopTime: event.stopTime,
                    duration: event.duration,
                    isActiveTab: event.isActiveTab
                })
            }, callback);
        });
        if (!onEvent) throw new Error('Missing onEvent callback');
        if (typeof onEvent !== 'function') throw new Error('Invalid onEvent, must be function');
        if (!(pageVisibility instanceof (0, $5a0c8cae642f3b67$export$2e2bcd8739ae039))) throw new Error('Invalid pageVisibility, must be PageVisibility class');
        this._startedEvents = new Map();
        this._performance = new (0, $5567e94e2046948c$export$2e2bcd8739ae039)();
        this._onEvent = onEvent;
        this._threshold = 1000;
        this._wasPreviouslyHidden = pageVisibility.getIsHidden();
        this._isActiveEvents = new Map();
        this._pageVisibility = pageVisibility;
        this._pageVisibility.addCallback('apdexEvent', (isHidden)=>{
            this.onVisibilityChange(!isHidden);
        });
    }
    start(event) {
        this._validateStartEvent(event);
        if (!this._performance.isAvailable()) return;
        const eventKey = this._getEventKey(event);
        const eventStartName = `${eventKey}-start`;
        this._startedEvents.set(eventKey, true);
        this._isActiveEvents.set(eventKey, !this._pageVisibility.getIsHidden());
        this._performance.clearMarks(eventStartName);
        this._performance.mark(eventStartName);
    }
    getStart(event) {
        this._validateStartEvent(event);
        if (!this._performance.isAvailable()) return undefined;
        const eventKey = this._getEventKey(event);
        const eventStartName = `${eventKey}-start`;
        return this._getEventTimingByName(eventStartName);
    }
    stop(event, callback) {
        this._validateStopEvent(event);
        if (!this._performance.isAvailable()) return;
        const apdexFields = this._getApdexFields(event);
        const visibilityFields = this._getVisibilityFields(event);
        this._sendEvent($046c48c9d0dd9a40$var$_objectSpread($046c48c9d0dd9a40$var$_objectSpread($046c48c9d0dd9a40$var$_objectSpread({}, event), apdexFields), visibilityFields), callback);
    }
    onVisibilityChange(isActive) {
        if (!isActive) {
            this._wasPreviouslyHidden = true;
            Array.from(this._isActiveEvents.keys()).forEach((key)=>this._isActiveEvents.set(key, false));
        }
    }
}


/**
 * Wraps {possibleFn} into a error-safe function and handles cases where {possibleFn}
 * is a function or object
 *
 * @param possibleFn - function that returns and object or the object itself
 * @param errorMessage - error message to log if {possibleFn} is a function and
 *                        throws an error when called
 * @returns {Function}
 */ const $7fd7c8f1cf1381dd$var$isFunction = (possibleFn)=>typeof possibleFn === 'function';
var $7fd7c8f1cf1381dd$export$2e2bcd8739ae039 = (possibleFn, errorMessage)=>{
    return ()=>{
        if ($7fd7c8f1cf1381dd$var$isFunction(possibleFn)) try {
            return possibleFn();
        } catch (e) {
            // eslint-disable-next-line no-console
            console.error(`${errorMessage} - ${e instanceof Error ? e.message : String(e)}`);
            return undefined;
        }
        return possibleFn;
    };
};



var $25nEq = parcelRequire("25nEq");

var $arMYe = parcelRequire("arMYe");

var $9P61R = parcelRequire("9P61R");

var $25nEq = parcelRequire("25nEq");

var $KItDh = parcelRequire("KItDh");

var $9Zzpd = parcelRequire("9Zzpd");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $25nEq = parcelRequire("25nEq");

var $arMYe = parcelRequire("arMYe");

var $9P61R = parcelRequire("9P61R");

var $kIXpt = parcelRequire("kIXpt");

var $cYPzS = parcelRequire("cYPzS");

var $eyuDe = parcelRequire("eyuDe");

var $arMYe = parcelRequire("arMYe");

var $9P61R = parcelRequire("9P61R");

var $25nEq = parcelRequire("25nEq");
var $0ecc2545dba4bca4$export$90e3e001bcac59c7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(function InMemoryStore() {
    var _this = this;
    (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, InMemoryStore);
    (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "data", {});
    (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "length", 0);
    (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "setItem", function(key, value) {
        _this.data[key] = value;
        _this.length = Object.keys(_this.data).length;
        return value;
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "getItem", function(key) {
        if (key in _this.data) return _this.data[key];
        return null;
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "removeItem", function(key) {
        if (key in _this.data) delete _this.data[key];
        _this.length = Object.keys(_this.data).length;
        return null;
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "clear", function() {
        _this.data = {};
        _this.length = 0;
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "key", function(index) {
        return Object.keys(_this.data)[index];
    });
});
// eslint-disable-next-line import/no-anonymous-default-export
var $0ecc2545dba4bca4$var$inmemorystorage = new $0ecc2545dba4bca4$export$90e3e001bcac59c7();
var $0ecc2545dba4bca4$export$2e2bcd8739ae039 = $0ecc2545dba4bca4$var$inmemorystorage;



var $arMYe = parcelRequire("arMYe");

var $9P61R = parcelRequire("9P61R");

var $25nEq = parcelRequire("25nEq");

var $2bbb1abbaa4b4747$export$41c06fdd37b7e9a5 = 'awc';
var $2bbb1abbaa4b4747$export$770aa8bc07b3de03 = 'awcInMemoryStorageFallback';
var $2bbb1abbaa4b4747$export$56ac8ebc9870b1b9 = /*#__PURE__*/ function(envType) {
    envType["DEV"] = "dev";
    envType["LOCAL"] = "local";
    envType["PROD"] = "prod";
    envType["STAGING"] = "staging";
    return envType;
}({});
function $2bbb1abbaa4b4747$export$48c17662a6902497(store) {
    var TEST_VALUE = 'test_value';
    if (!store) return false;
    try {
        var key = 'awc.storage.support';
        store.setItem(key, TEST_VALUE);
        var value = store.getItem(key);
        store.removeItem(key);
        // handle localStorage silently failing
        return value === TEST_VALUE;
    } catch (e) {
        // Can throw if localStorage is disabled
        return false;
    }
}
var $2bbb1abbaa4b4747$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(function SafeStorage(storageToUse) {
    var _this = this;
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, SafeStorage);
    (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "getStore", function() {
        return _this.store;
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "getItem", function(key) {
        return _this.store.getItem(_this.createKey(key));
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "removeItem", function(key) {
        return _this.store.removeItem(_this.createKey(key));
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "setItem", function(key, value) {
        try {
            _this.store.setItem(_this.createKey(key), value);
        } catch (err) {
            // Theoretically should only be QuotaExceededError, but keeping 'err' generic
            // https://developer.mozilla.org/en-US/docs/Web/API/Storage/setItem
            _this.swapToInMemory();
            _this.store.setItem(_this.createKey(key), value);
        }
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "swapToInMemory", function() {
        if (_this.store === (0, $0ecc2545dba4bca4$export$2e2bcd8739ae039) || typeof window === 'undefined') return;
        var keys = Object.keys(_this.store || {});
        var inMemoryStorage;
        if ($2bbb1abbaa4b4747$export$48c17662a6902497(window[$2bbb1abbaa4b4747$export$770aa8bc07b3de03])) inMemoryStorage = window[$2bbb1abbaa4b4747$export$770aa8bc07b3de03];
        else {
            inMemoryStorage = (0, $0ecc2545dba4bca4$export$2e2bcd8739ae039);
            if (!window[$2bbb1abbaa4b4747$export$770aa8bc07b3de03]) // If not already attached to window then attach our instance of InMemoryStorage
            // We need to do this because if there are multiple instances of Analytics Client in multiple scopes,
            // there is no way to guarantee the throttling behaviour of the UI viewed event across those instances without a global singleton
            window[$2bbb1abbaa4b4747$export$770aa8bc07b3de03] = (0, $0ecc2545dba4bca4$export$2e2bcd8739ae039);
        }
        keys.forEach(function(key) {
            if (key.indexOf(_this.getPrefix()) === 0) {
                var value = _this.store.getItem(key);
                if (value) inMemoryStorage.setItem(key, value);
            }
        });
        _this.store = inMemoryStorage;
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "clear", function() {
        return _this.store.clear();
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "key", function(index) {
        return _this.store.key(index);
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "getPrefix", function() {
        return _this.prefix;
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "createKey", function(key) {
        if (_this.prefix) return "".concat(_this.getPrefix(), ".").concat(key);
        return key;
    });
    this.options = options;
    var prefixes = [];
    if (options.useStoragePrefix === undefined || options.useStoragePrefix) prefixes.push($2bbb1abbaa4b4747$export$41c06fdd37b7e9a5);
    if (options.envPrefix && options.envPrefix !== $2bbb1abbaa4b4747$export$56ac8ebc9870b1b9.PROD) prefixes.push(options.envPrefix);
    this.prefix = prefixes.join('-');
    if ($2bbb1abbaa4b4747$export$48c17662a6902497(storageToUse)) this.store = storageToUse;
    else this.swapToInMemory();
});


function $d75b148bb05fa448$var$_callSuper(t, o, e) {
    return o = (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(o), (0, (/*@__PURE__*/$parcel$interopDefault($kIXpt)))(t, $d75b148bb05fa448$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(t).constructor) : o.apply(t, e));
}
function $d75b148bb05fa448$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($d75b148bb05fa448$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
// eslint-disable-next-line import/no-anonymous-default-export
var $d75b148bb05fa448$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_SafeStorage) {
    function _default(options) {
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, _default);
        var storageToUse;
        try {
            storageToUse = window.sessionStorage || (0, $0ecc2545dba4bca4$export$2e2bcd8739ae039);
        } catch (err) {
            storageToUse = (0, $0ecc2545dba4bca4$export$2e2bcd8739ae039);
        }
        return $d75b148bb05fa448$var$_callSuper(this, _default, [
            storageToUse,
            options
        ]);
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($eyuDe)))(_default, _SafeStorage);
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(_default);
}((0, $2bbb1abbaa4b4747$export$2e2bcd8739ae039));


// WARNING: The value of INTERACTION_SESSION_ID_STORAGE_KEY will be used by Analytics Web Client to attach the session ID to events.
// If you change this, you will need to update the Analytics Web Client code as well.
var $dad991887cadc559$var$INTERACTION_SESSION_ID_STORAGE_KEY = 'interactionSession.id';
var $dad991887cadc559$var$INTERACTION_SESSION_ID_PREV_STORAGE_KEY = 'interactionSession.id.prev';
var $dad991887cadc559$var$INTERACTION_SESSION_EXPIRY_STORAGE_KEY = 'interactionSession.expiry';
var $dad991887cadc559$export$285f6bddd927a06d = 1800000; // 30 minutes
var $dad991887cadc559$export$d050a4cab1b9f734 = 86400000; // 24 hours
var $dad991887cadc559$export$a92e915d70316eb2 = 5000; // 5 seconds
var $dad991887cadc559$export$de43760b2dc10c19 = 0.9; // 90% of expiry
var $dad991887cadc559$var$INTEGER_REGEX = /^\d+$/;
var $dad991887cadc559$export$5d4c4eab0863aae3 = 'interactionSessionIdUpdated';
/**
 * This class is essentially a wrapper around SessionStorage that introduces some failsafes (such as switching to InMemoryStorage if SessionStorage is not available)
 * and providing resilient methods for accessing and updating the interaction session ID.
 * This class can be initialised anywhere within a document, and `getCurrentInteractionSessionId` will always return the latest interaction session ID.
 *
 * The `setAnalyticsCallback` method must be called with a valid analytics event callback function provided by an Analytics Web Client before any other methods are used.
 * This is to ensure that any generated or renewed session IDs can be reported via an analytics event.
 *
 * The `setInteractionSessionId` method will write the SessionStorage with the persisted session ID, and is only intended to be used by the Analytics Web Client
 */ var $dad991887cadc559$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    // This callback function will be called whenever a new session ID is generated
    // It expects a function that sends an operational analytics event, with
    // the first parameter being set to the action ('started' or 'renewed'), and the second parameter being
    // an InteractionSession object containing the new session ID and previous session ID.
    function InteractionSessionTracking() {
        var _this = this;
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, InteractionSessionTracking);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "analyticsReady", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "generateNewSessionId", function() {
            if (!_this.analyticsReady) return null;
            var currentSessionId = _this.safeSessionStorage.getItem($dad991887cadc559$var$INTERACTION_SESSION_ID_STORAGE_KEY);
            var newSessionId = Date.now().toString();
            _this.safeSessionStorage.setItem($dad991887cadc559$var$INTERACTION_SESSION_ID_STORAGE_KEY, newSessionId);
            var _this$getCurrentSessi = _this.getCurrentSessionParams(), isValidSession = _this$getCurrentSessi.isValidSession;
            if (!isValidSession) // If session is not valid at this point, something has gone wrong with Session Storage access
            // Calling sendInteractionSessionEvent now would result in an infinite loop, so we terminate
            return null;
            if (currentSessionId) {
                // Store a copy of the current session ID so we can link sessions if needed
                _this.safeSessionStorage.setItem($dad991887cadc559$var$INTERACTION_SESSION_ID_PREV_STORAGE_KEY, currentSessionId);
                _this.sendInteractionSessionEvent('renewed');
            } else _this.sendInteractionSessionEvent('started');
            // Event listener is in useCrossProductUrl.tsx to update URL query params
            document.dispatchEvent(new Event($dad991887cadc559$export$5d4c4eab0863aae3));
            return newSessionId;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "updateSessionExpiry", function() {
            var expiry = Date.now() + _this.sessionExpiryTime;
            _this.safeSessionStorage.setItem($dad991887cadc559$var$INTERACTION_SESSION_EXPIRY_STORAGE_KEY, expiry.toString());
            return expiry;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "debouncedUpdateSessionExpiry", function(currentExpiry) {
            var updateSessionExpiry = _this.updateSessionExpiry;
            // If the current expiry is out of date by more than 10% of the expiry, update immediately
            if (currentExpiry < Date.now() + _this.sessionExpiryDebounceThresholdPercentage * _this.sessionExpiryTime) updateSessionExpiry();
            else {
                if (_this.sessionExpiryDebounceTimer) clearTimeout(_this.sessionExpiryDebounceTimer);
                // @ts-ignore Something wrong with our types... this is legit
                _this.sessionExpiryDebounceTimer = setTimeout(function() {
                    updateSessionExpiry();
                }, _this.sessionExpiryDebounce);
            }
        });
        this.sessionExpiryTime = $dad991887cadc559$export$285f6bddd927a06d;
        this.sessionExpiryDebounce = $dad991887cadc559$export$a92e915d70316eb2;
        this.sessionExpiryDebounceThresholdPercentage = $dad991887cadc559$export$de43760b2dc10c19;
        this.safeSessionStorage = new (0, $d75b148bb05fa448$export$2e2bcd8739ae039)();
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(InteractionSessionTracking, [
        {
            key: "getCurrentInteractionSessionId",
            value: function getCurrentInteractionSessionId() {
                try {
                    var _this$getCurrentSessi2 = this.getCurrentSessionParams(), isValidSession = _this$getCurrentSessi2.isValidSession, sessionExpiry = _this$getCurrentSessi2.sessionExpiry, sessionId = _this$getCurrentSessi2.sessionId;
                    // If we have an existing valid session we can return the sessionId straight away
                    if (isValidSession) {
                        this.debouncedUpdateSessionExpiry(sessionExpiry);
                        return sessionId;
                    }
                    // To generate a new session ID we must ensure analytics is ready
                    if (this.analyticsReady) {
                        // Session expiry update must occur before generateNewSessionId. Otherwise we were running
                        // into issues of calls attempting to read the session ID before a valid expiry had been set
                        this.debouncedUpdateSessionExpiry(sessionExpiry);
                        return this.generateNewSessionId();
                    }
                } catch (err) {
                    // eslint-disable-next-line no-console
                    console.error("Error retrieving interaction session ID - ".concat(err instanceof Error ? err.message : String(err)));
                }
                return null;
            }
        },
        {
            key: "getPreviousInteractionSessionId",
            value: function getPreviousInteractionSessionId() {
                return this.safeSessionStorage.getItem($dad991887cadc559$var$INTERACTION_SESSION_ID_PREV_STORAGE_KEY);
            }
        },
        {
            key: "setInteractionSessionId",
            value: function setInteractionSessionId(persistedSessionId) {
                if (this.validateSessionId(persistedSessionId)) {
                    var currentSessionId = this.safeSessionStorage.getItem($dad991887cadc559$var$INTERACTION_SESSION_ID_STORAGE_KEY);
                    // If we are already on the required session ID, just return true and make no changes
                    // This can happen if the persisted session ID in options is the same as the current session ID
                    // We noticed this happening in some cases where Confluence's own URL redirect logic was causing
                    // race conditions with our URL stripping, resulting in the same query parameter being processed multiple times
                    if (currentSessionId === persistedSessionId) return false;
                    // Session expiry update must occur before we fire off the dispatchEvent. Otherwise we were running
                    // into issues of the event consumer attempting to read the session ID before a valid expiry had been set
                    this.debouncedUpdateSessionExpiry(0);
                    this.safeSessionStorage.setItem($dad991887cadc559$var$INTERACTION_SESSION_ID_STORAGE_KEY, persistedSessionId);
                    this.safeSessionStorage.removeItem($dad991887cadc559$var$INTERACTION_SESSION_ID_PREV_STORAGE_KEY);
                    document.dispatchEvent(new Event($dad991887cadc559$export$5d4c4eab0863aae3));
                    return true;
                }
                return false;
            }
        },
        {
            key: "setAnalyticsCallback",
            value: function setAnalyticsCallback(sendEventCallback) {
                if (this.analyticsReady) // If we already have a valid callback, don't over-write it
                return;
                if (sendEventCallback && typeof sendEventCallback === 'function') {
                    this.sendEventCallback = sendEventCallback;
                    this.analyticsReady = true;
                } else this.analyticsReady = false;
            }
        },
        {
            key: "validateSessionId",
            value: function validateSessionId(sessionId) {
                // Check if persisted session ID can parse as valid Unix timestamp
                if (sessionId && $dad991887cadc559$var$INTEGER_REGEX.test(sessionId)) {
                    var sessionAge = Date.now() - parseInt(sessionId, 10);
                    // Validate that timestamp is not a future time, and is also within the TTL
                    if (sessionAge >= 0 && sessionAge <= $dad991887cadc559$export$d050a4cab1b9f734) return true;
                }
                return false;
            }
        },
        {
            key: "getCurrentSessionParams",
            value: function getCurrentSessionParams() {
                var sessionId = this.safeSessionStorage.getItem($dad991887cadc559$var$INTERACTION_SESSION_ID_STORAGE_KEY);
                var sessionExpiry = parseInt(this.safeSessionStorage.getItem($dad991887cadc559$var$INTERACTION_SESSION_EXPIRY_STORAGE_KEY) || '0', 10) || 0;
                if (sessionId && !Number.isNaN(sessionExpiry) && sessionExpiry > Date.now()) return {
                    isValidSession: true,
                    sessionExpiry: sessionExpiry,
                    sessionId: sessionId
                };
                return {
                    isValidSession: false,
                    sessionExpiry: sessionExpiry,
                    sessionId: sessionId
                };
            }
        },
        {
            key: "sendInteractionSessionEvent",
            value: function sendInteractionSessionEvent(action) {
                this.sendEventCallback && this.sendEventCallback({
                    action: action,
                    actionSubject: 'interactionSession',
                    source: 'interactionComponent',
                    tags: [
                        'navigationExperiences'
                    ] // InteractionSession events will be registered under this platform product
                });
            }
        }
    ]);
}();


var $c08a71d1bea39f71$export$7bc189309d2ad463 = 'analyticsInteractionSesssionTrackingClient';
var $c08a71d1bea39f71$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function GlobalInteractionSessionTracking() {
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, GlobalInteractionSessionTracking);
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(GlobalInteractionSessionTracking, null, [
        {
            key: "getInstance",
            value: function getInstance() {
                var interactionSessionTracking;
                try {
                    // Check if InteractionSessionTracking in global window object
                    if ($c08a71d1bea39f71$export$7bc189309d2ad463 in window) interactionSessionTracking = window[$c08a71d1bea39f71$export$7bc189309d2ad463];
                    else {
                        // Initialise InteractionSessionTracking on global window object
                        window[$c08a71d1bea39f71$export$7bc189309d2ad463] = new (0, $dad991887cadc559$export$2e2bcd8739ae039)();
                        interactionSessionTracking = window[$c08a71d1bea39f71$export$7bc189309d2ad463];
                    }
                } catch (error) {
                    // eslint-disable-next-line no-console
                    console.error("Error initialising InteractionSessionTracking - ".concat(error instanceof Error ? error.message : String(error)));
                }
                return interactionSessionTracking;
            }
        }
    ]);
}();



var $3f41ed13c410b797$export$b9dd752fb13352ce = 'interactionSession.source';
var $3f41ed13c410b797$export$e04e3c50573f9af7 = 'interactionSession.bridge';
/**
 * AnalyticsCrossProductInteractionClient is a wrapper for the InteractionSessionTracking class.
 * It is designed to be used internally within the Atlassian Analytics Pipeline as well as useCrossProductUrlWrapper hook.
 * It is not intended to be used directly by end-users.
 *
 * This will create an instance of the interaction session tracker on the window object, which can be shared across different parts of a document.
 * If the internal client already exists, it will use the existing instance. Creating the client in a singleton manner like this enables us
 * to debounce updates to Session Storage, which is important when a large number of links using our hook are rendered on a page.
 *
 * The other interaction session parameters are written directly to session storage as they are predominantly read-only,
 * with the only update being the initialisation of the client
 */ var $3f41ed13c410b797$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(// TODO: Make these fields non-nullable once feature flag removed
function AnalyticsCrossProductInteractionClient(interactionSessionOptions, bridge, interactionSource) {
    var _this = this;
    (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, AnalyticsCrossProductInteractionClient);
    (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "getCurrentInteractionSessionId", function() {
        return _this.isEnabled && _this.interactionSessionTracking ? _this.interactionSessionTracking.getCurrentInteractionSessionId() : null;
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "getPreviousInteractionSessionId", function() {
        return _this.isEnabled && _this.interactionSessionTracking ? _this.interactionSessionTracking.getPreviousInteractionSessionId() : null;
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "getBridge", function() {
        return _this.isEnabled && _this.safeSessionStorage ? _this.safeSessionStorage.getItem($3f41ed13c410b797$export$e04e3c50573f9af7) : null;
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "getInteractionSource", function() {
        return _this.isEnabled && _this.safeSessionStorage ? _this.safeSessionStorage.getItem($3f41ed13c410b797$export$b9dd752fb13352ce) : null;
    });
    this.isEnabled = (0, $9Zzpd.fg)('analytics_cross_product_interaction_tracking') && !(0, $KItDh.isFedrampModerate)();
    if (this.isEnabled) {
        // Get singleton interaction session tracking instance
        this.interactionSessionTracking = (0, $c08a71d1bea39f71$export$2e2bcd8739ae039).getInstance();
        var isValidPersistedId = false;
        if (this.interactionSessionTracking) {
            if (interactionSessionOptions) {
                this.interactionSessionTracking.setAnalyticsCallback(interactionSessionOptions.analyticsEventCallback);
                isValidPersistedId = this.interactionSessionTracking.setInteractionSessionId(interactionSessionOptions.persistedSessionId);
            }
        }
        this.safeSessionStorage = new (0, $d75b148bb05fa448$export$2e2bcd8739ae039)();
        // Store other interaction session parameters directly in session storage if ID has been validated
        if (isValidPersistedId) {
            bridge && this.safeSessionStorage.setItem($3f41ed13c410b797$export$e04e3c50573f9af7, bridge);
            interactionSource && this.safeSessionStorage.setItem($3f41ed13c410b797$export$b9dd752fb13352ce, interactionSource);
        }
    }
});

var $c980ca96fe3c1be9$export$81d16f1428ce0486 = 'xpis';
var $c980ca96fe3c1be9$export$2e3999ec51334ffe = function generateUrlWithParams(url, bridge, interactionSessionId, product, subProduct) {
    var interactionSource = subProduct ? "".concat(product, "-").concat(subProduct) : product;
    var interactionSession = {
        bridge: bridge,
        id: interactionSessionId,
        source: interactionSource
    };
    var paramValueEncoded = btoa(JSON.stringify(interactionSession));
    var urlObj = new URL(url);
    urlObj.searchParams.set($c980ca96fe3c1be9$export$81d16f1428ce0486, paramValueEncoded);
    return urlObj.toString();
};

// Add products that will participate in cross-product interaction tracking here
// TODO: Down the line this should ideally be synced with ECS product list but that
// will take significant engineering effort
var $7f872ef078f1fd45$export$b1e8b4360a046e61 = [
    'jira',
    'confluence',
    'townsquare',
    'loom'
];



var $9Zzpd = parcelRequire("9Zzpd");

var $26356a878988d07a$export$f9380c9a627682d3;
var $26356a878988d07a$export$98e6a39c04603d36;
var $26356a878988d07a$export$fac44ee5b035f737;
var $26356a878988d07a$export$7a5253c0f62e0150;
var $26356a878988d07a$export$a8c1621ea79325d3;
var $26356a878988d07a$export$357523c63a2253b9;
var $26356a878988d07a$export$44c361b8ec72ef7f;
'use strict';

var $6XEYK = parcelRequire("6XEYK");

var $9YPP7 = parcelRequire("9YPP7");

var $l4Qn0 = parcelRequire("l4Qn0");

var $9PyLY = parcelRequire("9PyLY");
const $26356a878988d07a$var$isNullOrUndefined = (value)=>value === null || value === undefined;
const $26356a878988d07a$var$encodeFragmentIdentifier = Symbol('encodeFragmentIdentifier');
function $26356a878988d07a$var$encoderForArrayFormat(options) {
    switch(options.arrayFormat){
        case 'index':
            return (key)=>(result, value)=>{
                    const index = result.length;
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === '') return result;
                    if (value === null) return [
                        ...result,
                        [
                            $26356a878988d07a$var$encode(key, options),
                            '[',
                            index,
                            ']'
                        ].join('')
                    ];
                    return [
                        ...result,
                        [
                            $26356a878988d07a$var$encode(key, options),
                            '[',
                            $26356a878988d07a$var$encode(index, options),
                            ']=',
                            $26356a878988d07a$var$encode(value, options)
                        ].join('')
                    ];
                };
        case 'bracket':
            return (key)=>(result, value)=>{
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === '') return result;
                    if (value === null) return [
                        ...result,
                        [
                            $26356a878988d07a$var$encode(key, options),
                            '[]'
                        ].join('')
                    ];
                    return [
                        ...result,
                        [
                            $26356a878988d07a$var$encode(key, options),
                            '[]=',
                            $26356a878988d07a$var$encode(value, options)
                        ].join('')
                    ];
                };
        case 'colon-list-separator':
            return (key)=>(result, value)=>{
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === '') return result;
                    if (value === null) return [
                        ...result,
                        [
                            $26356a878988d07a$var$encode(key, options),
                            ':list='
                        ].join('')
                    ];
                    return [
                        ...result,
                        [
                            $26356a878988d07a$var$encode(key, options),
                            ':list=',
                            $26356a878988d07a$var$encode(value, options)
                        ].join('')
                    ];
                };
        case 'comma':
        case 'separator':
        case 'bracket-separator':
            {
                const keyValueSep = options.arrayFormat === 'bracket-separator' ? '[]=' : '=';
                return (key)=>(result, value)=>{
                        if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === '') return result;
                        // Translate null to an empty string so that it doesn't serialize as 'null'
                        value = value === null ? '' : value;
                        if (result.length === 0) return [
                            [
                                $26356a878988d07a$var$encode(key, options),
                                keyValueSep,
                                $26356a878988d07a$var$encode(value, options)
                            ].join('')
                        ];
                        return [
                            [
                                result,
                                $26356a878988d07a$var$encode(value, options)
                            ].join(options.arrayFormatSeparator)
                        ];
                    };
            }
        default:
            return (key)=>(result, value)=>{
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === '') return result;
                    if (value === null) return [
                        ...result,
                        $26356a878988d07a$var$encode(key, options)
                    ];
                    return [
                        ...result,
                        [
                            $26356a878988d07a$var$encode(key, options),
                            '=',
                            $26356a878988d07a$var$encode(value, options)
                        ].join('')
                    ];
                };
    }
}
function $26356a878988d07a$var$parserForArrayFormat(options) {
    let result;
    switch(options.arrayFormat){
        case 'index':
            return (key, value, accumulator)=>{
                result = /\[(\d*)\]$/.exec(key);
                key = key.replace(/\[\d*\]$/, '');
                if (!result) {
                    accumulator[key] = value;
                    return;
                }
                if (accumulator[key] === undefined) accumulator[key] = {};
                accumulator[key][result[1]] = value;
            };
        case 'bracket':
            return (key, value, accumulator)=>{
                result = /(\[\])$/.exec(key);
                key = key.replace(/\[\]$/, '');
                if (!result) {
                    accumulator[key] = value;
                    return;
                }
                if (accumulator[key] === undefined) {
                    accumulator[key] = [
                        value
                    ];
                    return;
                }
                accumulator[key] = [].concat(accumulator[key], value);
            };
        case 'colon-list-separator':
            return (key, value, accumulator)=>{
                result = /(:list)$/.exec(key);
                key = key.replace(/:list$/, '');
                if (!result) {
                    accumulator[key] = value;
                    return;
                }
                if (accumulator[key] === undefined) {
                    accumulator[key] = [
                        value
                    ];
                    return;
                }
                accumulator[key] = [].concat(accumulator[key], value);
            };
        case 'comma':
        case 'separator':
            return (key, value, accumulator)=>{
                const isArray = typeof value === 'string' && value.includes(options.arrayFormatSeparator);
                const isEncodedArray = typeof value === 'string' && !isArray && $26356a878988d07a$var$decode(value, options).includes(options.arrayFormatSeparator);
                value = isEncodedArray ? $26356a878988d07a$var$decode(value, options) : value;
                const newValue = isArray || isEncodedArray ? value.split(options.arrayFormatSeparator).map((item)=>$26356a878988d07a$var$decode(item, options)) : value === null ? value : $26356a878988d07a$var$decode(value, options);
                accumulator[key] = newValue;
            };
        case 'bracket-separator':
            return (key, value, accumulator)=>{
                const isArray = /(\[\])$/.test(key);
                key = key.replace(/\[\]$/, '');
                if (!isArray) {
                    accumulator[key] = value ? $26356a878988d07a$var$decode(value, options) : value;
                    return;
                }
                const arrayValue = value === null ? [] : value.split(options.arrayFormatSeparator).map((item)=>$26356a878988d07a$var$decode(item, options));
                if (accumulator[key] === undefined) {
                    accumulator[key] = arrayValue;
                    return;
                }
                accumulator[key] = [].concat(accumulator[key], arrayValue);
            };
        default:
            return (key, value, accumulator)=>{
                if (accumulator[key] === undefined) {
                    accumulator[key] = value;
                    return;
                }
                accumulator[key] = [].concat(accumulator[key], value);
            };
    }
}
function $26356a878988d07a$var$validateArrayFormatSeparator(value) {
    if (typeof value !== 'string' || value.length !== 1) throw new TypeError('arrayFormatSeparator must be single character string');
}
function $26356a878988d07a$var$encode(value, options) {
    if (options.encode) return options.strict ? $6XEYK(value) : encodeURIComponent(value);
    return value;
}
function $26356a878988d07a$var$decode(value, options) {
    if (options.decode) return $9YPP7(value);
    return value;
}
function $26356a878988d07a$var$keysSorter(input) {
    if (Array.isArray(input)) return input.sort();
    if (typeof input === 'object') return $26356a878988d07a$var$keysSorter(Object.keys(input)).sort((a, b)=>Number(a) - Number(b)).map((key)=>input[key]);
    return input;
}
function $26356a878988d07a$var$removeHash(input) {
    const hashStart = input.indexOf('#');
    if (hashStart !== -1) input = input.slice(0, hashStart);
    return input;
}
function $26356a878988d07a$var$getHash(url) {
    let hash = '';
    const hashStart = url.indexOf('#');
    if (hashStart !== -1) hash = url.slice(hashStart);
    return hash;
}
function $26356a878988d07a$var$extract(input) {
    input = $26356a878988d07a$var$removeHash(input);
    const queryStart = input.indexOf('?');
    if (queryStart === -1) return '';
    return input.slice(queryStart + 1);
}
function $26356a878988d07a$var$parseValue(value, options) {
    if (options.parseNumbers && !Number.isNaN(Number(value)) && typeof value === 'string' && value.trim() !== '') value = Number(value);
    else if (options.parseBooleans && value !== null && (value.toLowerCase() === 'true' || value.toLowerCase() === 'false')) value = value.toLowerCase() === 'true';
    return value;
}
function $26356a878988d07a$var$parse(query, options) {
    options = Object.assign({
        decode: true,
        sort: true,
        arrayFormat: 'none',
        arrayFormatSeparator: ',',
        parseNumbers: false,
        parseBooleans: false
    }, options);
    $26356a878988d07a$var$validateArrayFormatSeparator(options.arrayFormatSeparator);
    const formatter = $26356a878988d07a$var$parserForArrayFormat(options);
    // Create an object with no prototype
    const ret = Object.create(null);
    if (typeof query !== 'string') return ret;
    query = query.trim().replace(/^[?#&]/, '');
    if (!query) return ret;
    for (const param of query.split('&')){
        if (param === '') continue;
        let [key, value] = $l4Qn0(options.decode ? param.replace(/\+/g, ' ') : param, '=');
        // Missing `=` should be `null`:
        // http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
        value = value === undefined ? null : [
            'comma',
            'separator',
            'bracket-separator'
        ].includes(options.arrayFormat) ? value : $26356a878988d07a$var$decode(value, options);
        formatter($26356a878988d07a$var$decode(key, options), value, ret);
    }
    for (const key of Object.keys(ret)){
        const value = ret[key];
        if (typeof value === 'object' && value !== null) for (const k of Object.keys(value))value[k] = $26356a878988d07a$var$parseValue(value[k], options);
        else ret[key] = $26356a878988d07a$var$parseValue(value, options);
    }
    if (options.sort === false) return ret;
    return (options.sort === true ? Object.keys(ret).sort() : Object.keys(ret).sort(options.sort)).reduce((result, key)=>{
        const value = ret[key];
        if (Boolean(value) && typeof value === 'object' && !Array.isArray(value)) // Sort object keys, not values
        result[key] = $26356a878988d07a$var$keysSorter(value);
        else result[key] = value;
        return result;
    }, Object.create(null));
}
$26356a878988d07a$export$f9380c9a627682d3 = $26356a878988d07a$var$extract;
$26356a878988d07a$export$98e6a39c04603d36 = $26356a878988d07a$var$parse;
$26356a878988d07a$export$fac44ee5b035f737 = (object, options)=>{
    if (!object) return '';
    options = Object.assign({
        encode: true,
        strict: true,
        arrayFormat: 'none',
        arrayFormatSeparator: ','
    }, options);
    $26356a878988d07a$var$validateArrayFormatSeparator(options.arrayFormatSeparator);
    const shouldFilter = (key)=>options.skipNull && $26356a878988d07a$var$isNullOrUndefined(object[key]) || options.skipEmptyString && object[key] === '';
    const formatter = $26356a878988d07a$var$encoderForArrayFormat(options);
    const objectCopy = {};
    for (const key of Object.keys(object))if (!shouldFilter(key)) objectCopy[key] = object[key];
    const keys = Object.keys(objectCopy);
    if (options.sort !== false) keys.sort(options.sort);
    return keys.map((key)=>{
        const value = object[key];
        if (value === undefined) return '';
        if (value === null) return $26356a878988d07a$var$encode(key, options);
        if (Array.isArray(value)) {
            if (value.length === 0 && options.arrayFormat === 'bracket-separator') return $26356a878988d07a$var$encode(key, options) + '[]';
            return value.reduce(formatter(key), []).join('&');
        }
        return $26356a878988d07a$var$encode(key, options) + '=' + $26356a878988d07a$var$encode(value, options);
    }).filter((x)=>x.length > 0).join('&');
};
$26356a878988d07a$export$7a5253c0f62e0150 = (url, options)=>{
    options = Object.assign({
        decode: true
    }, options);
    const [url_, hash] = $l4Qn0(url, '#');
    return Object.assign({
        url: url_.split('?')[0] || '',
        query: $26356a878988d07a$var$parse($26356a878988d07a$var$extract(url), options)
    }, options && options.parseFragmentIdentifier && hash ? {
        fragmentIdentifier: $26356a878988d07a$var$decode(hash, options)
    } : {});
};
$26356a878988d07a$export$a8c1621ea79325d3 = (object, options)=>{
    options = Object.assign({
        encode: true,
        strict: true,
        [$26356a878988d07a$var$encodeFragmentIdentifier]: true
    }, options);
    const url = $26356a878988d07a$var$removeHash(object.url).split('?')[0] || '';
    const queryFromUrl = $26356a878988d07a$export$f9380c9a627682d3(object.url);
    const parsedQueryFromUrl = $26356a878988d07a$export$98e6a39c04603d36(queryFromUrl, {
        sort: false
    });
    const query = Object.assign(parsedQueryFromUrl, object.query);
    let queryString = $26356a878988d07a$export$fac44ee5b035f737(query, options);
    if (queryString) queryString = `?${queryString}`;
    let hash = $26356a878988d07a$var$getHash(object.url);
    if (object.fragmentIdentifier) hash = `#${options[$26356a878988d07a$var$encodeFragmentIdentifier] ? $26356a878988d07a$var$encode(object.fragmentIdentifier, options) : object.fragmentIdentifier}`;
    return `${url}${queryString}${hash}`;
};
$26356a878988d07a$export$357523c63a2253b9 = (input, filter, options)=>{
    options = Object.assign({
        parseFragmentIdentifier: true,
        [$26356a878988d07a$var$encodeFragmentIdentifier]: false
    }, options);
    const { url: url, query: query, fragmentIdentifier: fragmentIdentifier } = $26356a878988d07a$export$7a5253c0f62e0150(input, options);
    return $26356a878988d07a$export$a8c1621ea79325d3({
        url: url,
        query: $9PyLY(query, filter),
        fragmentIdentifier: fragmentIdentifier
    }, options);
};
$26356a878988d07a$export$44c361b8ec72ef7f = (input, filter, options)=>{
    const exclusionFilter = Array.isArray(filter) ? (key)=>!filter.includes(key) : (key, value)=>!filter(key, value);
    return $26356a878988d07a$export$357523c63a2253b9(input, exclusionFilter, options);
};


/* eslint-disable no-return-assign, no-sequences */ // https://www.30secondsofcode.org/js/s/map-keys
const $68baca26a6bab057$export$781522908e4e76a1 = (obj, fn)=>Object.keys(obj).reduce((acc, k)=>{
        const key = fn(obj[k], k, obj);
        acc[key] = obj[k];
        return acc;
    }, {});
// https://www.30secondsofcode.org/js/s/pick
const $68baca26a6bab057$export$357523c63a2253b9 = (obj, arr)=>arr.reduce((acc, curr)=>(curr in obj && (acc[curr] = obj[curr]), acc), {});
// https://www.30secondsofcode.org/js/s/omit-by
const $68baca26a6bab057$export$d7a617dda645b4e3 = (obj, fn)=>Object.keys(obj).filter((k)=>!fn(obj[k], k)).reduce((acc, key)=>(acc[key] = obj[key], acc), {});
// https://www.30secondsofcode.org/js/s/pick-by
const $68baca26a6bab057$export$b460b275d6c6aa0 = (obj, fn)=>Object.keys(obj).filter((k)=>fn(obj[k], k)).reduce((acc, key)=>(acc[key] = obj[key], acc), {});
// https://www.30secondsofcode.org/js/s/omit
const $68baca26a6bab057$export$30a06c8d3562193f = (obj, arr)=>Object.keys(obj).filter((k)=>arr.indexOf(k) < 0).reduce((acc, key)=>(acc[key] = obj[key], acc), {});
// https://www.30secondsofcode.org/js/s/equals
const $68baca26a6bab057$export$e9bab7fafb253603 = (a, b)=>{
    if (a === b) return true;
    if (a instanceof Date && b instanceof Date) return a.getTime() === b.getTime();
    if (!a || !b || typeof a !== 'object' && typeof b !== 'object') return a === b;
    if (a.prototype !== b.prototype) return false;
    const keys = Object.keys(a);
    if (keys.length !== Object.keys(b).length) return false;
    return keys.every((k)=>$68baca26a6bab057$export$e9bab7fafb253603(a[k], b[k]));
};
// https://www.30secondsofcode.org/js/s/partition
const $68baca26a6bab057$export$b29f828819edca8d = (arr, fn)=>arr.reduce(// eslint-disable-next-line no-shadow
    (acc, val, i, arr)=>{
        acc[fn(val, i, arr) ? 0 : 1].push(val);
        return acc;
    }, [
        [],
        []
    ]);


const $21fc6f103b6afda8$export$600dd5bf1b049f11 = (newUrl)=>window.history.replaceState({}, '', newUrl);
const $21fc6f103b6afda8$var$urlParamExtractor = (isCaptureParam, historyReplaceFn = $21fc6f103b6afda8$export$600dd5bf1b049f11)=>{
    // Extract target parameters and values from URL if present
    const originalUrl = window.location.href;
    const fragmentHash = window.location.hash;
    const removedFragmentURL = fragmentHash !== '' ? originalUrl.replace(fragmentHash, '') : originalUrl;
    const { url: url, query: query } = (0, $26356a878988d07a$export$7a5253c0f62e0150)(removedFragmentURL);
    const captureParams = (0, $68baca26a6bab057$export$b460b275d6c6aa0)(query, isCaptureParam);
    // Do not modify URL if no matches
    if (Object.keys(captureParams).length > 0) {
        const queryWithoutCaptureParams = (0, $68baca26a6bab057$export$d7a617dda645b4e3)(query, isCaptureParam);
        // Replace the URL minus captured parameters
        if (Object.keys(queryWithoutCaptureParams).length > 0) {
            const newUrl = `${url}?${(0, $26356a878988d07a$export$fac44ee5b035f737)(queryWithoutCaptureParams)}${fragmentHash}`;
            historyReplaceFn(newUrl);
        } else historyReplaceFn(`${url}${fragmentHash}`);
    }
    return captureParams;
};
var $21fc6f103b6afda8$export$2e2bcd8739ae039 = $21fc6f103b6afda8$var$urlParamExtractor;


const $293604237edd7ee5$var$isCrossProductInteractionAttribute = (_, paramName)=>{
    return paramName === (0, $c980ca96fe3c1be9$export$81d16f1428ce0486);
};
class $293604237edd7ee5$export$2e2bcd8739ae039 {
    constructor(options){
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "validProduct", false);
        this.isEnabled = (0, $9Zzpd.fg)('analytics_cross_product_interaction_tracking') && options.perimeter !== (0, $9c4c150c990b1f10$export$bdd41749d2096e4b).FEDRAMP_MODERATE;
        this.urlValidation = {
            result: true,
            url: ''
        };
        this.sendEventCallback = options.sendEventCallback;
        if (this.isEnabled) {
            let bridge;
            let interactionSessionId;
            let interactionSource;
            let interactionSessionOptions;
            this.urlValidation.url = window.location.href;
            // Validate product
            //
            // Various UI components in the page might initialize their own AWC instances but some of those
            // instances might be associated with subordinate products that are of no interest to XPC tracking. We
            // want to avoid XPC meta analytics being fired against uninteresting products.
            //
            // Some products (e.g. Confluence) also have custom URL replace functions passed into AWC settings,
            // and we need to use those to ensure our query parameter is correctly processed.
            //
            // TODO - this is currently the best way we can try and guarantee that the most relevant product's AWC
            // is passing in the options. Down the line we ideally want the relevant products themselves to opt-in
            // to initialising cross product tracking via a flag in their AWC init options.
            this.validProduct = (0, $7f872ef078f1fd45$export$b1e8b4360a046e61).includes(options.product);
            if (this.validProduct) {
                // Only parse URL parameters if we are in a valid product
                const crossProductUrlPramater = (0, $21fc6f103b6afda8$export$2e2bcd8739ae039)($293604237edd7ee5$var$isCrossProductInteractionAttribute, options.historyReplaceFn);
                const interactionSessionBlob = (0, $c980ca96fe3c1be9$export$81d16f1428ce0486) in crossProductUrlPramater ? crossProductUrlPramater[0, $c980ca96fe3c1be9$export$81d16f1428ce0486] : null;
                if (interactionSessionBlob) try {
                    const interactionSession = JSON.parse(atob(interactionSessionBlob));
                    if (interactionSession.bridge && interactionSession.id && interactionSession.source) {
                        // All 3 fields must be present from a valid query param
                        bridge = interactionSession.bridge;
                        interactionSessionId = interactionSession.id;
                        interactionSource = interactionSession.source;
                    } else this.urlValidation.result = false;
                } catch (_unused) {
                    // Gracefully fail through if parameter has been corrupted
                    this.urlValidation.result = false;
                }
                interactionSessionOptions = {
                    analyticsEventCallback: this.sendEventCallback,
                    persistedSessionId: interactionSessionId
                };
            }
            // Initialise interaction session client with parsed values if they exist
            this.analyticsCrossProductInteractionClient = new (0, $3f41ed13c410b797$export$2e2bcd8739ae039)(interactionSessionOptions, bridge, interactionSource);
        }
    }
    getInteractionSession() {
        if (this.isEnabled && this.analyticsCrossProductInteractionClient) return {
            bridge: this.analyticsCrossProductInteractionClient.getBridge(),
            id: this.analyticsCrossProductInteractionClient.getCurrentInteractionSessionId(),
            prevId: this.analyticsCrossProductInteractionClient.getPreviousInteractionSessionId(),
            source: this.analyticsCrossProductInteractionClient.getInteractionSource()
        };
        else return {
            bridge: null,
            id: null,
            prevId: null,
            source: null
        };
    }
    /**
   * Validates the cross product interaction session parameters parsed from the URL (if present)
   * If the Base64-encoded URL does not decode into a valid JSON object
   *
   * This method must be called out of the constructor, as the sendEventCallback we expect here
   * depends on crossProductInteractionTracking.getInteractionSession() so the class must be initialised
   */ validateInteractionSession() {
        if (!this.urlValidation.result) this.sendEventCallback({
            action: 'corrupted',
            actionSubject: 'interactionSession',
            attributes: {
                url: this.urlValidation.url
            },
            source: 'interactionComponent',
            tags: [
                'navigationExperiences'
            ] // InteractionSession events will be registered under this platform product
        });
    }
}



const $a92a49061b862547$export$f56713ced121eb91 = (input)=>{
    return input.embeddedType === (0, $9c4c150c990b1f10$export$f49776dca27a2e7c).FIRST_PARTY && input.embeddedFromProduct !== undefined;
};
const $a92a49061b862547$export$ab34f90cc32c8960 = (input)=>{
    return input.embeddedType === (0, $9c4c150c990b1f10$export$f49776dca27a2e7c).THIRD_PARTY && input.embeddedFromTopLevelDomain !== undefined;
};



var $25nEq = parcelRequire("25nEq");

var $9Zzpd = parcelRequire("9Zzpd");

// Modified from https://github.com/jonschlinkert/is-plain-object/blob/master/index.js
function $66a0cce84268e928$var$isObject(val) {
    return val !== null && typeof val === 'object' && Array.isArray(val) === false;
}
function $66a0cce84268e928$var$isObjectObject(o) {
    return $66a0cce84268e928$var$isObject(o) === true && Object.prototype.toString.call(o) === '[object Object]';
}
function $66a0cce84268e928$export$53b83ca8eaab0383(o) {
    if ($66a0cce84268e928$var$isObjectObject(o) === false) return false;
    // If has modified constructor
    const ctor = o.constructor;
    if (typeof ctor !== 'function') return false;
    // If has modified prototype
    const prot = ctor.prototype;
    if ($66a0cce84268e928$var$isObjectObject(prot) === false) return false;
    // If constructor does not have an Object-specific method
    if (!('isPrototypeOf' in prot)) return false;
    // Most likely a plain Object
    return true;
}


function $8f748e4bbc815a77$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $8f748e4bbc815a77$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $8f748e4bbc815a77$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $8f748e4bbc815a77$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
const $8f748e4bbc815a77$var$libraryVersion = "0.0.0-development";
function $8f748e4bbc815a77$var$buildTenantFields(tenantInfo) {
    return {
        tenantIdType: tenantInfo.tenantIdType,
        tenantId: tenantInfo.tenantId
    };
}
function $8f748e4bbc815a77$var$buildUserFields(userInfo) {
    return {
        userIdType: userInfo.userIdType
    };
}
function $8f748e4bbc815a77$var$buildOrgFields(orgInfo) {
    return {
        orgId: orgInfo.orgId
    };
}
function $8f748e4bbc815a77$var$buildWorkspaceFields(workspaceInfo) {
    return {
        workspaceId: workspaceInfo.workspaceId
    };
}
function $8f748e4bbc815a77$var$buildAliases(aliases) {
    if ($8f748e4bbc815a77$var$isNotEmptyObject(aliases)) return {
        aliases: aliases
    };
    return undefined;
}
function $8f748e4bbc815a77$var$buildGroups(groups) {
    if ($8f748e4bbc815a77$var$isNotEmptyObject(groups)) return {
        groups: groups
    };
    return undefined;
}
function $8f748e4bbc815a77$var$buildEventOverrides(event) {
    if (event.anonymousId) return {
        anonymousId: event.anonymousId
    };
    return {};
}
function $8f748e4bbc815a77$var$buildInteractionSession(properties) {
    // TODO: Once feature flag is removed this function can be removed and the property
    // directly added at the top level in the buildActionEvent and buildScreenEvent functions
    if ((0, $9Zzpd.fg)('analytics_cross_product_interaction_tracking')) return {
        interactionSession: properties
    };
    return undefined;
}
function $8f748e4bbc815a77$var$getProductField(field, override) {
    return override === undefined ? field : override;
}
function $8f748e4bbc815a77$var$buildProductFields(productInfo, productOverrides) {
    const overrides = productOverrides || {};
    const env = $8f748e4bbc815a77$var$getProductField(productInfo.env, overrides.env);
    const product = $8f748e4bbc815a77$var$getProductField(productInfo.product, overrides.product);
    const subproduct = $8f748e4bbc815a77$var$getProductField(productInfo.subproduct(), overrides.subproduct);
    const version = $8f748e4bbc815a77$var$getProductField(productInfo.version, overrides.version);
    const origin = $8f748e4bbc815a77$var$getProductField(productInfo.origin, overrides.origin);
    const platform = $8f748e4bbc815a77$var$getProductField(productInfo.platform, overrides.platform);
    const ic = productInfo.ic; // ic should not be overriden once set
    return {
        env: env,
        product: product,
        subproduct: subproduct,
        version: version,
        origin: origin,
        platform: platform,
        ic: ic
    };
}
function $8f748e4bbc815a77$var$isNotEmptyObject(obj) {
    return (0, $66a0cce84268e928$export$53b83ca8eaab0383)(obj) && Object.keys(obj).length > 0;
}
function $8f748e4bbc815a77$var$buildAttributesWithName(name, attrObject) {
    return $8f748e4bbc815a77$var$isNotEmptyObject(attrObject) ? {
        [name]: attrObject
    } : undefined;
}
function $8f748e4bbc815a77$var$buildAttributes(attributes) {
    return $8f748e4bbc815a77$var$buildAttributesWithName('attributes', attributes);
}
function $8f748e4bbc815a77$export$3f5115a568819c1a(containers) {
    const validContainers = {};
    Object.keys(containers).forEach((key)=>{
        const value = containers[key];
        validContainers[key] = {
            id: value.id,
            type: value.type
        };
    });
    return validContainers;
}
function $8f748e4bbc815a77$export$f045f238d77c002a(containers) {
    if ($8f748e4bbc815a77$var$isNotEmptyObject(containers)) {
        const validContainers = $8f748e4bbc815a77$export$3f5115a568819c1a(containers);
        return $8f748e4bbc815a77$var$buildAttributesWithName('containers', validContainers);
    }
    return undefined;
}
function $8f748e4bbc815a77$export$655ecf7241feac42(event, actionEventType) {
    return $8f748e4bbc815a77$var$_objectSpread({
        containerType: event.containerType,
        containerId: event.containerId,
        source: event.source,
        objectType: event.objectType,
        objectId: event.objectId,
        actionSubject: event.actionSubject,
        action: event.action,
        actionSubjectId: event.actionSubjectId,
        attributes: event.attributes,
        nonPrivacySafeAttributes: event.nonPrivacySafeAttributes,
        tags: event.tags,
        highPriority: event.highPriority,
        eventType: actionEventType
    }, $8f748e4bbc815a77$export$f045f238d77c002a(event.containers));
}
function $8f748e4bbc815a77$var$buildNonPrivacySafeAttributes(nonPrivacySafeAttributes) {
    return $8f748e4bbc815a77$var$buildAttributesWithName('nonPrivacySafeAttributes', nonPrivacySafeAttributes);
}
function $8f748e4bbc815a77$export$c7d9a5f56acc4b19(productInfo, tenantInfo, userInfo, attributes, nonPrivacySafeAttributes, tags, tabId, sessionId, taskSessions, interactionSession, orgInfo, pageLoadId, workspaceInfo, event, containers, aliases, groups) {
    const productFields = $8f748e4bbc815a77$var$buildProductFields(productInfo);
    const tenantFields = $8f748e4bbc815a77$var$buildTenantFields(tenantInfo);
    const userFields = $8f748e4bbc815a77$var$buildUserFields(userInfo);
    const orgFields = $8f748e4bbc815a77$var$buildOrgFields(orgInfo);
    const workspaceFields = $8f748e4bbc815a77$var$buildWorkspaceFields(workspaceInfo);
    const overrides = {
        title: '',
        path: '',
        url: '',
        referrer: '',
        search: '',
        eventType: (0, $9c4c150c990b1f10$export$4c045e605d532c98).SCREEN
    };
    return $8f748e4bbc815a77$var$_objectSpread($8f748e4bbc815a77$var$_objectSpread($8f748e4bbc815a77$var$_objectSpread($8f748e4bbc815a77$var$_objectSpread($8f748e4bbc815a77$var$_objectSpread($8f748e4bbc815a77$var$_objectSpread($8f748e4bbc815a77$var$_objectSpread($8f748e4bbc815a77$var$_objectSpread($8f748e4bbc815a77$var$_objectSpread($8f748e4bbc815a77$var$_objectSpread($8f748e4bbc815a77$var$_objectSpread($8f748e4bbc815a77$var$_objectSpread($8f748e4bbc815a77$var$_objectSpread({}, productFields), tenantFields), userFields), orgFields), overrides), $8f748e4bbc815a77$var$buildAttributes(attributes)), $8f748e4bbc815a77$var$buildNonPrivacySafeAttributes(nonPrivacySafeAttributes)), $8f748e4bbc815a77$export$f045f238d77c002a(containers)), $8f748e4bbc815a77$var$buildEventOverrides(event)), {}, {
        tags: tags,
        tabId: tabId,
        sessionId: sessionId,
        taskSessions: taskSessions
    }, $8f748e4bbc815a77$var$buildInteractionSession(interactionSession)), {}, {
        pageLoadId: pageLoadId
    }, workspaceFields), $8f748e4bbc815a77$var$buildAliases(aliases)), $8f748e4bbc815a77$var$buildGroups(groups));
}
function $8f748e4bbc815a77$export$9c5623a792efc9b0(event) {
    return `${event.actionSubject} ${event.action}`;
}
let $8f748e4bbc815a77$export$fbd92247fb4d6159 = /*#__PURE__*/ function(validationMode) {
    validationMode["QUIET"] = "quiet";
    validationMode["STANDARD"] = "standard";
    validationMode["COMPLETE"] = "complete";
    return validationMode;
}({});
function $8f748e4bbc815a77$var$getDefaultValidationMode(productInfo) {
    const environment = productInfo.env;
    if (environment === undefined) return $8f748e4bbc815a77$export$fbd92247fb4d6159.QUIET;
    if (environment.includes('prod')) return $8f748e4bbc815a77$export$fbd92247fb4d6159.QUIET;
    return $8f748e4bbc815a77$export$fbd92247fb4d6159.COMPLETE;
}
function $8f748e4bbc815a77$export$3a7fe28f9bf4f3d9(productInfo) {
    const screen = window.screen || {};
    return {
        context: {
            locale: productInfo.locale,
            screen: {
                width: screen.width,
                height: screen.height,
                density: window.devicePixelRatio
            },
            library: {
                name: 'analytics.js',
                version: $8f748e4bbc815a77$var$libraryVersion
            },
            validationMode: $8f748e4bbc815a77$var$getDefaultValidationMode(productInfo)
        }
    };
}
function $8f748e4bbc815a77$export$e3d99b4bfec06f6e(event) {
    const { env: env, product: product, subproduct: subproduct, version: version, origin: origin, platform: platform } = event;
    return {
        env: env,
        product: product,
        subproduct: subproduct,
        version: version,
        origin: origin,
        platform: platform
    };
}
function $8f748e4bbc815a77$export$7bf451af4a8e3dd9(productInfo, tenantInfo, userInfo, event, actionEventType, tabId, sessionId, taskSessions, interactionSession, orgInfo, pageLoadId, workspaceInfo, aliases, groups) {
    const productFields = $8f748e4bbc815a77$var$buildProductFields(productInfo, $8f748e4bbc815a77$export$e3d99b4bfec06f6e(event));
    const tenantFields = $8f748e4bbc815a77$var$buildTenantFields(tenantInfo);
    const orgFields = $8f748e4bbc815a77$var$buildOrgFields(orgInfo);
    const workspaceFields = $8f748e4bbc815a77$var$buildWorkspaceFields(workspaceInfo);
    const userFields = $8f748e4bbc815a77$var$buildUserFields(userInfo);
    const actionFields = $8f748e4bbc815a77$export$655ecf7241feac42(event, actionEventType);
    return $8f748e4bbc815a77$var$_objectSpread($8f748e4bbc815a77$var$_objectSpread($8f748e4bbc815a77$var$_objectSpread($8f748e4bbc815a77$var$_objectSpread($8f748e4bbc815a77$var$_objectSpread($8f748e4bbc815a77$var$_objectSpread($8f748e4bbc815a77$var$_objectSpread($8f748e4bbc815a77$var$_objectSpread($8f748e4bbc815a77$var$_objectSpread($8f748e4bbc815a77$var$_objectSpread({}, productFields), tenantFields), orgFields), userFields), actionFields), $8f748e4bbc815a77$var$buildEventOverrides(event)), {}, {
        tabId: tabId,
        sessionId: sessionId,
        taskSessions: taskSessions
    }, $8f748e4bbc815a77$var$buildInteractionSession(interactionSession)), {}, {
        pageLoadId: pageLoadId
    }, workspaceFields), $8f748e4bbc815a77$var$buildAliases(aliases)), $8f748e4bbc815a77$var$buildGroups(groups));
}



var $25nEq = parcelRequire("25nEq");
const $59df5babe6000c50$export$cf090d5281b5ae06 = 10000;
const $59df5babe6000c50$export$8575e30be0feb909 = 30000;



var $25nEq = parcelRequire("25nEq");



var $25nEq = parcelRequire("25nEq");



var $25nEq = parcelRequire("25nEq");


const $a18f32a70fa41827$var$actionEventTypes = Object.freeze([
    (0, $9c4c150c990b1f10$export$4c045e605d532c98).OPERATIONAL,
    (0, $9c4c150c990b1f10$export$4c045e605d532c98).TRACK,
    (0, $9c4c150c990b1f10$export$4c045e605d532c98).UI
]);
function $a18f32a70fa41827$export$df8ff30e3c960006(container) {
    if (!(0, $66a0cce84268e928$export$53b83ca8eaab0383)(container)) throw new Error('properties.containers must be an Object');
    if (!('id' in container)) throw new Error("properties.containers is missing field 'id'");
    if (typeof container.id !== 'string') throw new Error('properties.containers.id must be of type String');
    if ('type' in container && typeof container.type !== 'string') throw new Error('properties.containers.type must be of type String');
}
function $a18f32a70fa41827$export$e63ea5d8477971d3(containers) {
    if (!containers) return;
    if (containers && containers.constructor !== Object) throw new Error('properties.containers must be an Object');
    Object.values(containers).forEach((container)=>$a18f32a70fa41827$export$df8ff30e3c960006(container));
}
function $a18f32a70fa41827$export$d19cebda16f7579a(type) {
    switch(type){
        case (0, $9c4c150c990b1f10$export$4c045e605d532c98).OPERATIONAL:
        case (0, $9c4c150c990b1f10$export$4c045e605d532c98).TRACK:
        case (0, $9c4c150c990b1f10$export$4c045e605d532c98).UI:
            return true;
        default:
            return false;
    }
}
function $a18f32a70fa41827$export$4a8d7476662aebcc(type) {
    if (!$a18f32a70fa41827$export$d19cebda16f7579a(type)) throw new Error(`Invalid action event type: ${type}, must be one of: [${$a18f32a70fa41827$var$actionEventTypes}]`);
    return true;
}
function $a18f32a70fa41827$export$e0c121325c66ed4c(event) {
    if (!event) throw new Error('Missing event');
    if (!event.source) throw new Error('Missing event.source');
    if (!event.actionSubject) throw new Error('Missing event.actionSubject');
    if (!event.action) throw new Error('Missing event.action');
    $a18f32a70fa41827$export$e63ea5d8477971d3(event.containers);
}
function $a18f32a70fa41827$export$dc993432a592dc27(name) {
    if (!name) throw new Error('Missing name');
}
function $a18f32a70fa41827$export$8c014fd74b0c8b99(event) {
    $a18f32a70fa41827$export$e0c121325c66ed4c(event);
}
function $a18f32a70fa41827$export$39d6334da9a44984(event) {
    if (!event) throw new Error('Missing event');
    if (!event.source) throw new Error('Missing event.source');
    if (!event.actionSubject) throw new Error('Missing event.actionSubject');
}
function $a18f32a70fa41827$export$e5bac0930c812e90(event) {
    $a18f32a70fa41827$export$e0c121325c66ed4c(event);
}
function $a18f32a70fa41827$export$1e561554275607ef(event) {
    $a18f32a70fa41827$export$e0c121325c66ed4c(event);
}
function $a18f32a70fa41827$export$c16a4e16aa4026c0(userIdType, userId) {
    if (!userIdType) throw new Error('Missing userIdType');
    if (!userId) throw new Error('Missing userId');
    if (!(0, $9c4c150c990b1f10$export$26b9f946b448f23e)((0, $9c4c150c990b1f10$export$1827adfd178b4870), userIdType)) throw new Error(`Invalid userIdType '${userIdType}', ` + `must be an userType: [${(0, $9c4c150c990b1f10$export$ad1854f4a08c15f8)((0, $9c4c150c990b1f10$export$1827adfd178b4870))}]`);
}
function $a18f32a70fa41827$export$801b46c35394d316(productInfo) {
    if (!(0, $9c4c150c990b1f10$export$26b9f946b448f23e)((0, $9c4c150c990b1f10$export$6b4f396210e539f3), productInfo.platform)) throw new Error(`Invalid productInfo.platform '${productInfo.platform}', ` + `must be a platformType: [${(0, $9c4c150c990b1f10$export$ad1854f4a08c15f8)((0, $9c4c150c990b1f10$export$6b4f396210e539f3))}]`);
    if (productInfo.origin === (0, $9c4c150c990b1f10$export$f73e9fcd368bb695).DESKTOP && !(0, $9c4c150c990b1f10$export$26b9f946b448f23e)((0, $9c4c150c990b1f10$export$809831be6c4c6227), productInfo.platform)) throw new Error(`Invalid productInfo.platform '${productInfo.platform}', ` + 'must be one of [mac, linux, windows]');
    if (productInfo.origin === (0, $9c4c150c990b1f10$export$f73e9fcd368bb695).WEB && !(0, $9c4c150c990b1f10$export$26b9f946b448f23e)((0, $9c4c150c990b1f10$export$19c579398ad213e7), productInfo.platform)) throw new Error(`Invalid productInfo.platform '${productInfo.platform}', must be one of [web, mobileWeb]`);
}



class $7c534fef00d87d47$export$89b3253ddfd2e6e8 {
    /**
   * @callback EventPredicate
   * @param {object} event An analytics event
   * @returns {boolean} A flag indicating whether or not the event matches the conditions
   */ /**
   * @callback CompressionFunction
   * @param {Array.<Object>} events A collection of analytics events that match the predicate of this compression rule
   * @returns {Array.<Object>} compressedEvents The compressed analytics events to fire
   */ /**
   * This constructor defines a new rule for compressing analytics events.
   * @param {EventPredicate} predicate
   * @param {CompressionFunction} compressFn
   */ constructor(predicate, compressFn){
        /**
     * This function returns a flag indicating whether or not this instance is capable of compressing the given event.
     * @param event
     * @returns {boolean}
     */ (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "canCompress", (event)=>{
            try {
                return event && (0, $a18f32a70fa41827$export$d19cebda16f7579a)(event.eventType) && this.predicate(event);
            } catch (e) {
                return false;
            }
        });
        /**
     * This function compresses as many events in the given collection as possible.<p>
     * Any events in the given collection that do not match the conditions of {@link canCompress} will be left uncompressed and
     * appended to the end of the resulting array.
     *
     * @param events A collection of analytic events to compress
     * @returns {Array.<Object>} The action fields for the resulting compressed events
     */ (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "compress", (events)=>{
            const [compatibleEvents, incompatibleEvents] = (0, $68baca26a6bab057$export$b29f828819edca8d)(events, (event)=>this.canCompress(event));
            const compressedEvents = this.compressFn(compatibleEvents);
            if (!compressedEvents) throw new Error('No events were returned from the compression function');
            compressedEvents.forEach((event)=>{
                (0, $a18f32a70fa41827$export$4a8d7476662aebcc)(event.eventType);
                (0, $a18f32a70fa41827$export$e0c121325c66ed4c)(event);
            });
            return compressedEvents.concat(incompatibleEvents);
        });
        if (typeof predicate !== 'function') throw new Error('Invalid predicate, must be a function that accepts an event and returns a boolean');
        if (typeof compressFn !== 'function') throw new Error('Invalid compressFn, must be a function that both accepts and returns an array of events');
        this.predicate = predicate;
        this.compressFn = compressFn;
    }
}


function $5c5d265bae4f52f8$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $5c5d265bae4f52f8$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $5c5d265bae4f52f8$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $5c5d265bae4f52f8$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
class $5c5d265bae4f52f8$export$2e2bcd8739ae039 {
    constructor(compressionRules = []){
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "canCompress", (event)=>this.compressionRules.some((compressionRule)=>compressionRule.canCompress(event)));
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "compress", (events)=>{
            const groups = this.createGroups(events);
            return groups.reduce((allCompressedEvents, group)=>{
                const groupCompressedEvents = this.compressGroup(group);
                return allCompressedEvents.concat(groupCompressedEvents);
            }, []);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "createGroups", (events)=>// Group events based on contextual fields. These fields are anything that is added by the client itself,
            // rather than passed in by the caller (eg. product, org. and tenant info)
            events.reduce((groups, event)=>{
                const matchingCompressor = this.compressionRules.find((compressor)=>compressor.canCompress(event));
                let contextFields;
                if (matchingCompressor) {
                    const actionFields = (0, $8f748e4bbc815a77$export$655ecf7241feac42)(event, event.eventType);
                    contextFields = (0, $68baca26a6bab057$export$30a06c8d3562193f)(event, Object.keys(actionFields));
                }
                const matchingGroup = groups.find((group)=>matchingCompressor === group.compressor && (0, $68baca26a6bab057$export$e9bab7fafb253603)(contextFields, group.contextFields));
                if (matchingGroup) matchingGroup.events.push(event);
                else groups.push({
                    contextFields: contextFields,
                    compressor: matchingCompressor,
                    events: [
                        event
                    ]
                });
                return groups;
            }, []));
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "compressGroup", (group)=>{
            // If this group doesn't have any compressor, then the event args are already in their final format
            if (!group.compressor) return group.events;
            try {
                // Run the compressor on the group to generate some new events.
                // The compression function is only expected to return the action fields for each
                // event that it generates, since all other fields are generated by the client.
                const compressedEventActionFields = group.compressor.compress(group.events);
                // Add the context fields to each of the resulting events to inflate them into a full action event
                return compressedEventActionFields.map((actionFields)=>$5c5d265bae4f52f8$var$_objectSpread($5c5d265bae4f52f8$var$_objectSpread({}, actionFields), group.contextFields));
            } catch (e) {
                // If we fail to compress the events, then just fall back the uncompressed events
                // so that no data is lost. This can happen if the compression function throws an error
                // or returns some invalid event payloads.
                // eslint-disable-next-line no-console
                // console.warn(
                // 	'Failed to compress some analytics events. ' +
                // 		`Error: ${(e as Error).message}. Sending ${
                // 			group.events.length
                // 		} uncompressed events instead`,
                // );
                return group.events;
            }
        });
        if (!Array.isArray(compressionRules)) throw new Error('Event compressors must be constructed with an array of CompressionRules');
        if (!compressionRules.every((rule)=>rule instanceof (0, $7c534fef00d87d47$export$89b3253ddfd2e6e8))) throw new Error('Event compressors can only be constructed with instances of CompressionRule');
        this.compressionRules = compressionRules;
    }
}


// We want to throttle the flush rate so that we don't have a huge upfront performance hit from starting the flush,
// and so that the underlying Segment client has some time to process some events in its queue before more are added.
const $6fe8e1689316f53e$var$FLUSH_BATCH_SIZE = 7; // aligns with the default batch size of Segment's BatchableQueue
const $6fe8e1689316f53e$var$FLUSH_BATCH_BACKOFF_PERIOD = 100;
class $6fe8e1689316f53e$export$2e2bcd8739ae039 {
    constructor(processFn, compressionRules){
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "push", (identifier, builtEvent, context, userInfo)=>{
            this.eventArgs.push({
                identifier: identifier,
                builtEvent: builtEvent,
                context: context,
                userInfo: userInfo
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "size", ()=>this.eventArgs.length);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "startFlush", ()=>{
            try {
                this.eventArgs = this.compressEventArgs(this.eventArgs);
            } catch (e) {
                // eslint-disable-next-line no-console
                console.warn('Failed to perform compression on the delayed analytics events. ' + `Error: ${e.message}. Sending ${this.eventArgs.length} uncompressed events instead`);
            }
            this.flushNextBatch();
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "cancelFlush", ()=>{
            if (this.flushBatchTimeout) {
                clearTimeout(this.flushBatchTimeout);
                this.flushBatchTimeout = null;
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "flushNextBatch", ()=>{
            const batch = this.eventArgs.splice(0, $6fe8e1689316f53e$var$FLUSH_BATCH_SIZE);
            batch.forEach((item)=>this.processFn(item.identifier, item.builtEvent, item.context, item.userInfo));
            if (this.eventArgs.length > 0) this.flushBatchTimeout = setTimeout(()=>this.flushNextBatch(), $6fe8e1689316f53e$var$FLUSH_BATCH_BACKOFF_PERIOD);
            else this.flushBatchTimeout = null;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "compressEventArgs", (eventArgs)=>{
            const [compressibleEventArgs, incompressibleEventArgs] = (0, $68baca26a6bab057$export$b29f828819edca8d)(eventArgs, (args)=>this.compressor.canCompress(args.builtEvent));
            // Events can only be compressed together if they share the same context and user info, since these are top-level
            // fields that need to exist on the fired event and can only be set to a single value.
            // We can achieve this by grouping our events by context prior to passing them to the compressor.
            const contextGroups = compressibleEventArgs.reduce((groups, args)=>{
                const matchingGroup = groups.find((group)=>(0, $68baca26a6bab057$export$e9bab7fafb253603)(group.userInfo, args.userInfo) && (0, $68baca26a6bab057$export$e9bab7fafb253603)(group.context, args.context));
                if (matchingGroup) matchingGroup.eventArgs.push(args);
                else groups.push({
                    userInfo: args.userInfo,
                    context: args.context,
                    eventArgs: [
                        args
                    ]
                });
                return groups;
            }, []);
            // Run the compressor on each group
            const allCompressedEventArgs = contextGroups.reduce((acc, group)=>{
                try {
                    const events = group.eventArgs.map((args)=>args.builtEvent);
                    const compressedEvents = this.compressor.compress(events);
                    const compressedEventArgs = compressedEvents.map((compressedEvent)=>({
                            identifier: (0, $8f748e4bbc815a77$export$9c5623a792efc9b0)(compressedEvent),
                            builtEvent: compressedEvent,
                            userInfo: group.userInfo,
                            context: group.context
                        }));
                    return acc.concat(compressedEventArgs);
                } catch (e) {
                    // If anything goes wrong while compressing this group, then just fall back on the
                    // uncompressed events instead. The event compressor already handles errors with invalid
                    // generator functions or results, but this is an extra layer of defense to prevent data
                    // loss in the event of an unexpected error.
                    // eslint-disable-next-line no-console
                    console.warn('Failed to compress some analytics events. ' + `Error: ${e.message}. Sending ${group.eventArgs.length} uncompressed events instead`);
                    return group.eventArgs;
                }
            }, []);
            incompressibleEventArgs.forEach((args)=>allCompressedEventArgs.push(args));
            return allCompressedEventArgs;
        });
        this.processFn = processFn;
        this.flushBatchTimeout = null;
        this.eventArgs = [];
        this.compressor = new (0, $5c5d265bae4f52f8$export$2e2bcd8739ae039)(compressionRules);
    }
}


let $810b9993bdaf216c$export$fa6e3729c21cb8f = /*#__PURE__*/ function(StopLowPriorityEventDelayReason) {
    StopLowPriorityEventDelayReason["TIMEOUT"] = "timeout";
    StopLowPriorityEventDelayReason["MANUAL"] = "manual";
    return StopLowPriorityEventDelayReason;
}({});


class $6c1a0a725e9fc5bf$export$2e2bcd8739ae039 {
    constructor(fireDelayedEvent, compressors){
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "push", (identifier, builtEvent, context, userInfo)=>{
            this.delayQueue.push(identifier, builtEvent, context, userInfo);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "startLowPriorityEventDelay", (timeout = (0, $59df5babe6000c50$export$cf090d5281b5ae06), callback)=>{
            if (Number.isNaN(timeout) || timeout <= 0) throw new Error(`Invalid timeout period: ${timeout}, must be a number greater than 0`);
            if (this.delayTimeout) clearTimeout(this.delayTimeout);
            const delayTimeoutPeriod = timeout ? Math.min(timeout, (0, $59df5babe6000c50$export$8575e30be0feb909)) : (0, $59df5babe6000c50$export$8575e30be0feb909);
            this.delayCallback = callback;
            this.delayTimeout = setTimeout(()=>this.stopLowPriorityEventDelay((0, $810b9993bdaf216c$export$fa6e3729c21cb8f).TIMEOUT), delayTimeoutPeriod);
            // If the queue is still flushing from a previous delay period, then we should cancel that flush
            // to stop it from negatively impacting the performance of the new critical section
            this.delayQueue.cancelFlush();
            this.isDelaying = true;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "stopLowPriorityEventDelay", (reason = (0, $810b9993bdaf216c$export$fa6e3729c21cb8f).MANUAL)=>{
            var _this$delayCallback;
            if (this.delayTimeout) {
                clearTimeout(this.delayTimeout);
                this.delayTimeout = undefined;
            }
            this.delayQueue.startFlush();
            this.isDelaying = false;
            (_this$delayCallback = this.delayCallback) === null || _this$delayCallback === void 0 || _this$delayCallback.call(this, reason);
            this.delayCallback = undefined;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "isDelayingLowPriorityEvents", ()=>this.isDelaying);
        this.isDelaying = false;
        this.delayQueue = new (0, $6fe8e1689316f53e$export$2e2bcd8739ae039)(fireDelayedEvent, compressors);
    }
}




var $25nEq = parcelRequire("25nEq");

var $25nEq = parcelRequire("25nEq");
let $34612426f666b75f$export$ecfa71cbc9b28241 = /*#__PURE__*/ function(LocalStorageKeySuffix) {
    LocalStorageKeySuffix["IN_PROGRESS"] = "inProgress";
    LocalStorageKeySuffix["QUEUE"] = "queue";
    LocalStorageKeySuffix["RECLAIM_START"] = "reclaimStart";
    LocalStorageKeySuffix["RECLAIM_END"] = "reclaimEnd";
    LocalStorageKeySuffix["ACK"] = "ack";
    return LocalStorageKeySuffix;
}({});
let $34612426f666b75f$export$8bb2c1fb2b1765a9 = /*#__PURE__*/ function(Timers) {
    Timers[Timers["RECLAIM_TIMEOUT"] = 10000] = "RECLAIM_TIMEOUT";
    Timers[Timers["RECLAIM_WAIT"] = 500] = "RECLAIM_WAIT";
    Timers[Timers["RECLAIM_WAIT_THRESHOLD"] = 2000] = "RECLAIM_WAIT_THRESHOLD";
    return Timers;
}({});



const $1d0d04b78b826b82$export$8433d54f767cbec5 = (queuePrefix, queueId)=>({
        [(0, $34612426f666b75f$export$ecfa71cbc9b28241).ACK]: `${queuePrefix}.${queueId}.${(0, $34612426f666b75f$export$ecfa71cbc9b28241).ACK}`,
        [(0, $34612426f666b75f$export$ecfa71cbc9b28241).QUEUE]: `${queuePrefix}.${queueId}.${(0, $34612426f666b75f$export$ecfa71cbc9b28241).QUEUE}`,
        [(0, $34612426f666b75f$export$ecfa71cbc9b28241).IN_PROGRESS]: `${queuePrefix}.${queueId}.${(0, $34612426f666b75f$export$ecfa71cbc9b28241).IN_PROGRESS}`,
        [(0, $34612426f666b75f$export$ecfa71cbc9b28241).RECLAIM_START]: `${queuePrefix}.${queueId}.${(0, $34612426f666b75f$export$ecfa71cbc9b28241).RECLAIM_START}`,
        [(0, $34612426f666b75f$export$ecfa71cbc9b28241).RECLAIM_END]: `${queuePrefix}.${queueId}.${(0, $34612426f666b75f$export$ecfa71cbc9b28241).RECLAIM_END}`
    });


// For more details on this funciton, see https://hello.atlassian.net/wiki/spaces/MEASURE/pages/585086028/Investigation+Local+storage+full
// TL;DR
// If a queue looses its `ack` key in localstorage, it will never get claimed.
// There is a small chance that this can happen.
// This function is to run through queues and clean any that have been orphaned.
// Keys stolen from https://github.com/segmentio/localstorage-retry/blob/master/lib/index.js#L55
const $ba738f5e1bb5880f$var$validSuffixs = Object.values((0, $34612426f666b75f$export$ecfa71cbc9b28241));
var $ba738f5e1bb5880f$export$2e2bcd8739ae039 = (prefix)=>{
    if (typeof prefix !== 'string' || prefix.length === 0) // We do not want to start deleting everything in localstorage
    return 0;
    try {
        const queueStates = Object.keys(localStorage).filter((key)=>key && key.startsWith(`${prefix}.`) || false).map((key)=>key.split('.')).filter((splitKeys)=>splitKeys.length === 3 && $ba738f5e1bb5880f$var$validSuffixs.includes(splitKeys[2])).reduce((accumulator, currentKeys)=>{
            const [, id, suffix] = currentKeys;
            if (accumulator[id] === undefined) accumulator[id] = {};
            accumulator[id][suffix] = true;
            return accumulator;
        }, {});
        const queuesToPurge = Object.keys(queueStates).filter((id)=>queueStates[id][(0, $34612426f666b75f$export$ecfa71cbc9b28241).ACK] !== true);
        queuesToPurge.forEach((id)=>{
            const { queue: queue, inProgress: inProgress, reclaimStart: reclaimStart, reclaimEnd: reclaimEnd } = (0, $1d0d04b78b826b82$export$8433d54f767cbec5)(prefix, id);
            localStorage.removeItem(inProgress);
            localStorage.removeItem(queue);
            localStorage.removeItem(reclaimStart);
            localStorage.removeItem(reclaimEnd);
        });
        return queuesToPurge.length;
    } catch (_error) {
    // Ignore errors from localStorage.
    }
    return 0;
};


var $25nEq = parcelRequire("25nEq");
// UUID v4 generator with fallback for non-secure contexts
function $16f8259e8856e670$export$2e2bcd8739ae039() {
    const g = globalThis;
    try {
        if (g.crypto && typeof g.crypto.randomUUID === 'function') return g.crypto.randomUUID();
    } catch (_unused) {
    // ignore and fallback
    }
    // Fallback to Math.random-based v4 UUID
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c)=>{
        const r = Math.floor(Math.random() * 16);
        const v = c === 'x' ? r : r & 0x3 | 0x8; // x => random hex digit; y => set RFC 4122 variant bits (10xx), yielding 8, 9, a, or b
        return v.toString(16);
    });
}




function $021634adde976b1b$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $021634adde976b1b$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $021634adde976b1b$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $021634adde976b1b$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
// Code we need to mimic:
// https://github.com/segmentio/localstorage-retry/blob/master/lib/index.js#L262-L357
// Note we do not want to run this library due to the performance, duplication and memory leak issues.
const $021634adde976b1b$var$promisedSetTimeout = (msToWait)=>new Promise((resolve)=>{
        setTimeout(resolve, msToWait);
    });
const $021634adde976b1b$var$findOtherQueues = (queuePrefix)=>{
    try {
        return Object.keys(localStorage).filter((key)=>key.startsWith(queuePrefix)).map((key)=>key.split('.')).filter((split)=>{
            if (split.length === 3 && split[0] === queuePrefix && split[2] === (0, $34612426f666b75f$export$ecfa71cbc9b28241).ACK) try {
                const ackTimestamp = localStorage.getItem(split.join('.'));
                if (ackTimestamp) {
                    const ackTimestampNumber = parseInt(ackTimestamp);
                    return (0, $34612426f666b75f$export$8bb2c1fb2b1765a9).RECLAIM_TIMEOUT + ackTimestampNumber < Date.now();
                }
            } catch (_unused) {
            // ignore and drop value
            }
            return false;
        }).map((split)=>split[1]);
    } catch (_unused2) {
    // Ignore errors from accessing localStorage.
    }
    return [];
};
const $021634adde976b1b$var$tryReclaim = async (options, callback)=>{
    const { ack: ack, reclaimStart: reclaimStart, reclaimEnd: reclaimEnd } = options.storageKeys;
    const start = Date.now();
    localStorage.setItem(reclaimStart, options.reclaimProcessId);
    localStorage.setItem(ack, start.toString());
    await $021634adde976b1b$var$promisedSetTimeout((0, $34612426f666b75f$export$8bb2c1fb2b1765a9).RECLAIM_WAIT);
    if (// Prevent duplicates when extracting events from localstorage due to CPU / Memory pressure on client
    Date.now() > start + (0, $34612426f666b75f$export$8bb2c1fb2b1765a9).RECLAIM_WAIT_THRESHOLD || // Either the parent has caught up and removed our claim, or someone else started a claim instead
    localStorage.getItem(reclaimStart) !== options.reclaimProcessId) throw new Error('Took to long to callback, reclaim abandonded. After reclaimStart.');
    localStorage.setItem(reclaimEnd, options.reclaimProcessId);
    await $021634adde976b1b$var$promisedSetTimeout((0, $34612426f666b75f$export$8bb2c1fb2b1765a9).RECLAIM_WAIT);
    if (// Prevent duplicates when extracting events from localstorage due to CPU / Memory pressure on client
    Date.now() > start + (0, $34612426f666b75f$export$8bb2c1fb2b1765a9).RECLAIM_WAIT_THRESHOLD || // Either the parent has caught up and removed our claim, or someone else started a claim instead
    localStorage.getItem(reclaimStart) !== options.reclaimProcessId || localStorage.getItem(reclaimEnd) !== options.reclaimProcessId) throw new Error('Took to long to callback, reclaim abandonded. After reclaimEnd.');
    return $021634adde976b1b$var$reclaim(options, callback);
};
const $021634adde976b1b$var$reclaim = async (options, callback)=>{
    const { queue: queue, inProgress: inProgress } = options.storageKeys;
    // Queue is an array of events while inProgress is an object with a uuid for key
    // Either of these queues may legitimately be missing.
    const eventsInQueue = JSON.parse(localStorage.getItem(queue) || '[]');
    const eventsInProgress = JSON.parse(localStorage.getItem(inProgress) || '{}');
    const arrayOfEventsInProgress = Object.entries(eventsInProgress).map(([key, item])=>{
        const itemWithId = $021634adde976b1b$var$_objectSpread($021634adde976b1b$var$_objectSpread({}, item), {}, {
            // LocalStorage-retry would add the attemptCounter after failure, rather than
            // as it was being processed
            attemptNumber: item.attemptNumber + 1,
            id: key
        });
        return itemWithId;
    });
    const eventsToProcess = [
        ...eventsInQueue,
        ...arrayOfEventsInProgress
    ];
    if (eventsToProcess.length > 0) {
        const result = await callback(eventsToProcess);
        if (result.status === 'successful') $021634adde976b1b$var$clearLocalStorageKeys(options.storageKeys);
        else if (result.status === 'partial') {
            // Dont delete all events if we are only able to take some of them.
            const leftover = eventsToProcess.filter((event)=>!result.acceptedItemIds.includes(event.id));
            // This way around, we can almost ensure that we wont hit memory quota exceeded errors.
            // However, there is a very small chance that we may lose events if the process exits between these two commands.
            localStorage.removeItem(inProgress);
            localStorage.setItem(queue, JSON.stringify(leftover));
            return {
                fullReclaim: false
            };
        }
    } else $021634adde976b1b$var$clearLocalStorageKeys(options.storageKeys);
    return {
        fullReclaim: true
    };
};
// Exterminate
const $021634adde976b1b$var$clearLocalStorageKeys = (keys)=>{
    // Always good to do queue and inprogress first to reduce duplications
    // and to free up more space in localstorage
    localStorage.removeItem(keys.queue);
    localStorage.removeItem(keys.inProgress);
    localStorage.removeItem(keys.reclaimEnd);
    localStorage.removeItem(keys.reclaimStart);
    // This has to be last or we risk leaving things in localStorage that have to be purged
    localStorage.removeItem(keys.ack);
};
var $021634adde976b1b$export$2e2bcd8739ae039 = async (queuePrefix, callback)=>{
    if (typeof queuePrefix !== 'string' || queuePrefix.length === 0) // We do not want to start deleting everything in localstorage
    return {
        fullReclaims: 0,
        partialReclaims: 0,
        failedReclaims: 0
    };
    const reclaimProcessId = (0, $16f8259e8856e670$export$2e2bcd8739ae039)();
    const queuesToReclaim = $021634adde976b1b$var$findOtherQueues(queuePrefix);
    const claims = queuesToReclaim.map((id)=>$021634adde976b1b$var$tryReclaim({
            queuePrefix: queuePrefix,
            reclaimProcessId: reclaimProcessId,
            storageKeys: (0, $1d0d04b78b826b82$export$8433d54f767cbec5)(queuePrefix, id)
        }, callback));
    const settledClaims = await Promise.allSettled(claims);
    const failedReclaims = settledClaims.filter((claim)=>claim.status === 'rejected');
    const successfulClaims = settledClaims.filter((settledValue)=>settledValue.status === 'fulfilled').map((result)=>result.value);
    const fullReclaims = successfulClaims.filter((claim)=>claim.fullReclaim);
    const partialReclaims = successfulClaims.filter((claim)=>!claim.fullReclaim);
    return {
        failedReclaims: failedReclaims.length,
        partialReclaims: partialReclaims.length,
        fullReclaims: fullReclaims.length
    };
};


const $f7306cb8422ee85a$export$a409c8de90e11e14 = 'CallbackProcessingError';
class $f7306cb8422ee85a$export$2e2bcd8739ae039 extends Error {
    constructor(error){
        const messageFromError = error && typeof error === 'object' && 'toString' in error && typeof error.toString === 'function' && error.toString();
        const messageFromString = typeof error === 'string' && error;
        const message = messageFromError || messageFromString || 'Argument passed to CallbackProcessingError was not an Error or string.';
        super(`Error thrown while processing events in callback: ${message}`);
        // Must reset the prototypes after calling super of builtin classes
        // https://github.com/Microsoft/TypeScript/wiki/Breaking-Changes#extending-built-ins-like-error-array-and-map-may-no-longer-work
        Object.setPrototypeOf(this, $f7306cb8422ee85a$export$2e2bcd8739ae039.prototype);
        this.name = $f7306cb8422ee85a$export$a409c8de90e11e14;
    }
}

const $33af1b6df02acb6a$export$d21fbb25eb37b5bf = 'namespace-timeAdded';
const $33af1b6df02acb6a$export$8cad224051643259 = 'analytics-web-client';
const $33af1b6df02acb6a$export$3d8420be07b276ab = 'analytics-resilience';
const $33af1b6df02acb6a$export$a512a65455fce2a6 = 'timeToBeProcessedAfter';
const $33af1b6df02acb6a$export$89d9c1ff8ac91862 = 'timeAdded';
const $33af1b6df02acb6a$export$a37d385bcd713809 = 'retryAttempts';
const $33af1b6df02acb6a$export$6d8635fed0e4b14d = 15000;
let $33af1b6df02acb6a$export$39337ab5872e9457 = /*#__PURE__*/ function(StoreType) {
    StoreType["INDEXEDDB"] = "indexeddb";
    StoreType["MEMORY"] = "memory";
    return StoreType;
}({});
let $33af1b6df02acb6a$export$7710d69e6f450f20 = /*#__PURE__*/ function(GuardPolicy) {
    // Adds as many items as possible and IGONRES the rest.
    // Only to be used with BulkAdd
    GuardPolicy["IGNORE"] = "ignore";
    // ABANDON the request if not all items can be added.
    GuardPolicy["ABANDON"] = "abandon";
    // EVICT old items to make room for new items if space is tight.
    GuardPolicy["EVICT"] = "evict";
    return GuardPolicy;
}({});


const $45d6507642197b13$export$fc14cf6dcea0f8ed = 'NoIndexedDbError';
class $45d6507642197b13$export$2e2bcd8739ae039 extends Error {
    constructor(){
        super('window.indexeddb is undefined.');
        // Must reset the prototypes after calling super of builtin classes
        // https://github.com/Microsoft/TypeScript/wiki/Breaking-Changes#extending-built-ins-like-error-array-and-map-may-no-longer-work
        Object.setPrototypeOf(this, $45d6507642197b13$export$2e2bcd8739ae039.prototype);
        this.name = $45d6507642197b13$export$fc14cf6dcea0f8ed;
    }
}

const $d2d6a47f21b9612f$export$ba95206613c96b28 = 'AbandonWriteError';
class $d2d6a47f21b9612f$export$2e2bcd8739ae039 extends Error {
    constructor(source){
        super(`Event Limit reached. Abandoning write to: ${source}`);
        // Must reset the prototypes after calling super of builtin classes
        // https://github.com/Microsoft/TypeScript/wiki/Breaking-Changes#extending-built-ins-like-error-array-and-map-may-no-longer-work
        Object.setPrototypeOf(this, $d2d6a47f21b9612f$export$2e2bcd8739ae039.prototype);
        this.name = $d2d6a47f21b9612f$export$ba95206613c96b28;
    }
}



const $d187f7a92ea73b17$export$7e7aee9a953465ec = 'InvalidPolicyError';
class $d187f7a92ea73b17$export$2e2bcd8739ae039 extends Error {
    constructor(policy, method){
        super(`Method '${method}' cannot be called with policy '${policy}'.`);
        this.name = $d187f7a92ea73b17$export$7e7aee9a953465ec;
    }
}


const $06f8d85073d84c3b$export$74101021e0969375 = (error)=>{
    if (error && typeof error === 'object' && 'name' in error) {
        const errorWithName = error;
        return typeof errorWithName.name === 'string' && (errorWithName.name === (0, $d2d6a47f21b9612f$export$ba95206613c96b28) || errorWithName.name === (0, $f7306cb8422ee85a$export$a409c8de90e11e14) || errorWithName.name === (0, $d187f7a92ea73b17$export$7e7aee9a953465ec));
    }
    return false;
};



var $1Vcia = parcelRequire("1Vcia");

var $25nEq = parcelRequire("25nEq");

const $1c498c884937cf8b$export$b6df3d334cec060f = 7;
const $1c498c884937cf8b$export$14ef152a03a4b6ee = 60000;
const $1c498c884937cf8b$export$da9ab7b2fd5998e8 = 10;
const $1c498c884937cf8b$export$1188664dfff364c8 = 5000;




var $25nEq = parcelRequire("25nEq");




const $f66e1a4ca7c109be$export$aec476f33d77be11 = (item, namespace, { id: id, retryAttempts: retryAttempts, timeToProcessOffset: timeToProcessOffset })=>({
        item: item,
        id: id || (0, $16f8259e8856e670$export$2e2bcd8739ae039)(),
        retryAttempts: retryAttempts || 0,
        timeToBeProcessedAfter: Date.now() + (timeToProcessOffset || 0),
        namespace: namespace,
        timeAdded: Date.now()
    });
const $f66e1a4ca7c109be$export$ddc6718318090f71 = (options)=>({
        logger: options.logger || console,
        useMemory: options.useMemory || false,
        maxAttempts: options.maxAttempts || (0, $1c498c884937cf8b$export$da9ab7b2fd5998e8),
        // This is so that we can customise `maxEventLimit`, primarily for testing.
        maxEventLimit: options.maxEventLimit || (0, $1c498c884937cf8b$export$1188664dfff364c8)
    });
const $f66e1a4ca7c109be$export$85ceed0783e42041 = (request)=>{
    return new Promise((resolve, reject)=>{
        request.onsuccess = (event)=>{
            resolve(event);
        };
        request.onerror = (event)=>{
            reject(event);
        };
    });
};
const $f66e1a4ca7c109be$export$2a5213bce1720b42 = (transaction)=>{
    return new Promise((resolve, reject)=>{
        // We will have to see how much cost there is to waiting for the transaction to complete in the real world.
        // In theory in some cases we could return as soon as the request is complete and
        // just monitor errors on transactions with the logger.
        // This maybe more of an issue in Safari and other older browsers where commit isnt available
        // and we would have to wait for the transaction to complete itself.
        transaction.oncomplete = ()=>{
            resolve();
        };
        transaction.onerror = (event)=>{
            reject(event);
        };
        transaction.onabort = (event)=>{
            reject(event);
        };
    });
};
const $f66e1a4ca7c109be$export$feab8418f018df89 = (transaction, logger)=>{
    try {
        if (typeof transaction.commit === 'function') transaction.commit();
    } catch (error) {
        logger.error('Failed to force commit transaction:', error);
        throw error;
    }
    return $f66e1a4ca7c109be$export$2a5213bce1720b42(transaction);
};
const $f66e1a4ca7c109be$export$342d941b6f724995 = (request, logger)=>{
    request.onerror = (event)=>{
        logger.warn('Error thrown from request:', event);
    };
};


class $09480ff5e266e6b6$export$2e2bcd8739ae039 {
    constructor(eventLimit, namespace, logger, deleteItemHandler){
        /**
     * This query fetches the oldest events currently stored in AWC IndexedDb object store
     * and deletes them sequentially
     */ (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "deleteOldestNEvents", async (objectStore, count)=>{
            var _target;
            const productTimeAddedIndex = objectStore.index((0, $33af1b6df02acb6a$export$d21fbb25eb37b5bf));
            const keyRangeValues = IDBKeyRange.bound([
                this.namespace,
                0
            ], [
                this.namespace,
                Date.now()
            ]);
            const getAllRequest = productTimeAddedIndex.getAllKeys(keyRangeValues, count);
            const event = await (0, $f66e1a4ca7c109be$export$85ceed0783e42041)(getAllRequest);
            const result = event === null || event === void 0 || (_target = event.target) === null || _target === void 0 ? void 0 : _target.result;
            // Adding extra safety
            if (result && Array.isArray(result) && result.length > 0) try {
                const deletePromises = result.map((item)=>this.deleteItemHandler(objectStore, item));
                await Promise.all(deletePromises);
            } catch (error) {
                this.logger.warn('Failed to delete items from indexeddb.', error);
                throw error;
            }
        });
        if (eventLimit > 0) this.eventLimit = eventLimit;
        else throw Error('Event Limit has to be set higher than 1');
        this.namespace = namespace;
        this.logger = logger;
        this.deleteItemHandler = deleteItemHandler;
    }
    /**
   * This function checks the number of events currently in AWC IndexedDB object store and if necessary,
   * will evict the oldest events in favour of the events we want to add.
   *
   * The indexed is treated as effectively: partitioned by product and sorted by timeAdded.
   *
   * This function can be re-used when the bulk add functionality is added in IndexedDbConnector.
   *
   * @param countOfEventsToAdd - The number of events we are proposing to add.
   */ async insertItems(objectStore, items, policy = (0, $33af1b6df02acb6a$export$7710d69e6f450f20).ABANDON) {
        const itemsToAdd = [
            ...items
        ];
        let numberOfEvictedItems = 0;
        switch(policy){
            case (0, $33af1b6df02acb6a$export$7710d69e6f450f20).ABANDON:
                await this.throwIfNotEnoughSpace(objectStore, items.length);
                break;
            case (0, $33af1b6df02acb6a$export$7710d69e6f450f20).EVICT:
                numberOfEvictedItems = await this.evictIfNotEnoughSpace(objectStore, items.length);
                break;
            case (0, $33af1b6df02acb6a$export$7710d69e6f450f20).IGNORE:
                // Removed items from `itemsToAdd` if there is insufficient space
                await this.calculateHowManyEventsWeCanAdd(objectStore, itemsToAdd);
                break;
        }
        const promises = itemsToAdd.map((item)=>(0, $f66e1a4ca7c109be$export$85ceed0783e42041)(objectStore.add(item)));
        await Promise.all(promises);
        await (0, $f66e1a4ca7c109be$export$feab8418f018df89)(objectStore.transaction, this.logger);
        return {
            items: itemsToAdd,
            numberOfEvictedItems: numberOfEvictedItems
        };
    }
    async throwIfNotEnoughSpace(objectStore, requiredSpace) {
        const freeSpace = await this.calculateFreeSpace(objectStore);
        if (freeSpace < requiredSpace) throw new (0, $d2d6a47f21b9612f$export$2e2bcd8739ae039)(`Not enough space in IndexedDb. Needed ${requiredSpace} but only had ${freeSpace}`);
    }
    async evictIfNotEnoughSpace(objectStore, requiredSpace) {
        const freeSpace = await this.calculateFreeSpace(objectStore);
        if (freeSpace < requiredSpace) {
            const extraSpace = requiredSpace - freeSpace;
            await this.deleteOldestNEvents(objectStore, extraSpace);
            return extraSpace;
        }
        return 0;
    }
    async calculateHowManyEventsWeCanAdd(objectStore, items) {
        const freeSpace = await this.calculateFreeSpace(objectStore);
        if (freeSpace < items.length) {
            const numberOfItemsToRemove = items.length - freeSpace;
            const start = items.length - numberOfItemsToRemove;
            items.splice(start, numberOfItemsToRemove);
        }
    }
    async calculateFreeSpace(objectStore) {
        const numberOfEventsInDb = await this.getCountofEventsInObjectStore(objectStore);
        return this.eventLimit - numberOfEventsInDb;
    }
    /**
   * This query returns the count of items held in AWC IndexedDB object store per product.
   */ async getCountofEventsInObjectStore(objectStore) {
        const productTimeAddedIndex = objectStore.index((0, $33af1b6df02acb6a$export$d21fbb25eb37b5bf));
        const keyRangeValues = IDBKeyRange.bound([
            this.namespace,
            0
        ], [
            this.namespace,
            Date.now()
        ]);
        const request = productTimeAddedIndex.count(keyRangeValues);
        const event = await (0, $f66e1a4ca7c109be$export$85ceed0783e42041)(request);
        return event.target.result;
    }
}



const $cc44f0f2693c9e2c$var$_excluded = [
    "item"
], $cc44f0f2693c9e2c$var$_excluded2 = [
    "items"
];
function $cc44f0f2693c9e2c$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $cc44f0f2693c9e2c$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $cc44f0f2693c9e2c$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $cc44f0f2693c9e2c$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
class $cc44f0f2693c9e2c$export$2e2bcd8739ae039 {
    constructor(_namespace, _options = {}){
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "startDB", async ()=>{
            return new Promise(async (resolve, reject)=>{
                if (typeof window !== 'undefined') {
                    const dbTimeout = window.setTimeout(()=>{
                        this.logger.warn('IndexedDB timed out.');
                        reject(new (0, $45d6507642197b13$export$2e2bcd8739ae039)());
                    }, (0, $33af1b6df02acb6a$export$6d8635fed0e4b14d));
                    /*
           * The database version number can never change.
           * An upgrade transaction is limited to only one connection to the database.
           * Once this is done, we cannot open any connections with older versions of the schema.
           * https://www.w3.org/TR/IndexedDB/#upgrade-transaction-construct
           *
           * Due to the nature of how AWC is used (multiple tabs that are very long lived),
           * we will not be able to run version upgrades via indexeddb.
           *
           * This does not mean we cant change what is stored in the tables,
           * this limitation just prevents us from:
           *   - Creating new ObjectStores in this database connection, and
           *   - Creating new indexes on our ObjectStores
           *
           * Any upgrades we wish to run in the future will have to create a new database,
           * and migrate all the data from older databases.
           *
           * This also means any migrations we make will have to be supported until we have evidence
           * that no events are coming from old versions of the database.
           * This may take a long time.
           */ const request = window.indexedDB.open((0, $33af1b6df02acb6a$export$8cad224051643259), 1);
                    request.onupgradeneeded = (event)=>{
                        if (event.oldVersion !== 0) throw new Error('We cannot upgrade the database. Do not do this.');
                        const db = request.result;
                        const store = db.createObjectStore((0, $33af1b6df02acb6a$export$3d8420be07b276ab), {
                            keyPath: 'id'
                        });
                        store.createIndex((0, $33af1b6df02acb6a$export$a512a65455fce2a6), (0, $33af1b6df02acb6a$export$a512a65455fce2a6), {
                            unique: false
                        });
                        store.createIndex((0, $33af1b6df02acb6a$export$a37d385bcd713809), (0, $33af1b6df02acb6a$export$a37d385bcd713809), {
                            unique: false
                        });
                        store.createIndex((0, $33af1b6df02acb6a$export$89d9c1ff8ac91862), (0, $33af1b6df02acb6a$export$89d9c1ff8ac91862), {
                            unique: false
                        });
                        // Compound key index of product - timeAdded.
                        store.createIndex((0, $33af1b6df02acb6a$export$d21fbb25eb37b5bf), [
                            'namespace',
                            'timeAdded'
                        ], {
                            unique: false
                        });
                    };
                    request.onerror = function() {
                        reject(new (0, $45d6507642197b13$export$2e2bcd8739ae039)());
                    };
                    try {
                        await (0, $f66e1a4ca7c109be$export$85ceed0783e42041)(request);
                        return resolve(request.result);
                    } catch (error) {
                        this.logger.warn('IndexedDB failed to initialise.', error);
                        reject(new (0, $45d6507642197b13$export$2e2bcd8739ae039)());
                    } finally{
                        window.clearTimeout(dbTimeout);
                    }
                } else {
                    this.logger.warn("IndexedDB failed to initialise. No 'window' object.");
                    reject(new (0, $45d6507642197b13$export$2e2bcd8739ae039)());
                }
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "addItem", async (item, options = {}, policy = (0, $33af1b6df02acb6a$export$7710d69e6f450f20).ABANDON)=>{
            const { logger: logger, namespace: namespace } = this;
            const value = (0, $f66e1a4ca7c109be$export$aec476f33d77be11)(item, namespace, options);
            const { objectStore: objectStore } = await this.getObjectStoreAndTransaction('readwrite');
            if (policy === (0, $33af1b6df02acb6a$export$7710d69e6f450f20).IGNORE) throw new (0, $d187f7a92ea73b17$export$2e2bcd8739ae039)(policy, 'IndexedDbConnector#addItem');
            try {
                if (!value.namespace || value.namespace.length === 0 || typeof value.namespace !== 'string') throw new Error('Namespace not specified');
                // Making space for 1 event, if required.
                const bulkAddResult = await this.globalEventLimitGuard.insertItems(objectStore, [
                    value
                ], policy);
                if (bulkAddResult.items.length === 1) return {
                    item: bulkAddResult.items[0],
                    numberOfEvictedItems: bulkAddResult.numberOfEvictedItems
                };
                // Should never happen as the Policy and EventCountGuard should cause another pathway
                throw new Error(`Incorrect number of items added. Expected: 1, got: ${bulkAddResult.items.length}`);
            } catch (error) {
                if ((0, $06f8d85073d84c3b$export$74101021e0969375)(error)) throw error;
                logger.log('Failed to add item to table', error);
                throw new Error('Request to add item to table failed');
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "bulkAddItem", async (itemOptions, policy = (0, $33af1b6df02acb6a$export$7710d69e6f450f20).ABANDON)=>{
            const { logger: logger, namespace: namespace } = this;
            const items = itemOptions.map((_ref)=>{
                let { item: item } = _ref, options = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $cc44f0f2693c9e2c$var$_excluded);
                return (0, $f66e1a4ca7c109be$export$aec476f33d77be11)(item, namespace, options);
            });
            const { objectStore: objectStore } = await this.getObjectStoreAndTransaction('readwrite');
            try {
                return await this.globalEventLimitGuard.insertItems(objectStore, items, policy);
            } catch (error) {
                if ((0, $06f8d85073d84c3b$export$74101021e0969375)(error)) throw error;
                logger.log('Failed to add item to table', error);
                throw new Error('Request to add item to table failed');
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "getItems", async (count = (0, $1c498c884937cf8b$export$b6df3d334cec060f))=>{
            const fixedCount = count > 0 ? count : (0, $1c498c884937cf8b$export$b6df3d334cec060f);
            const { logger: logger } = this;
            const maxAttempts = this.options.maxAttempts;
            const { transaction: transaction, objectStore: objectStore } = await this.getObjectStoreAndTransaction('readwrite');
            const timeIndex = objectStore.index((0, $33af1b6df02acb6a$export$a512a65455fce2a6));
            const upperBoundOpenKeyRange = IDBKeyRange.upperBound(Date.now());
            const request = timeIndex.openCursor(upperBoundOpenKeyRange);
            const getResult = await new Promise(async (resolve, reject)=>{
                const items = [];
                let numberOfDeletedItems = 0;
                request.onerror = (error)=>{
                    logger.error('Failed to open cursor:', error);
                    reject('Failed to open cursor');
                };
                // Requests for Cursors call onsuccess multiple times and cannot be converted to promises
                request.onsuccess = (event)=>{
                    const cursor = event.target.result;
                    if (cursor) {
                        // Prevent mutation of the value we are returning
                        const value = $cc44f0f2693c9e2c$var$_objectSpread({}, cursor.value);
                        items.push(value);
                        // Mutations seem to be required for testing indexeddb library
                        const updatedValue = cursor.value;
                        updatedValue.retryAttempts += 1;
                        updatedValue.timeToBeProcessedAfter = Date.now() + (0, $1c498c884937cf8b$export$14ef152a03a4b6ee);
                        if (updatedValue.retryAttempts >= maxAttempts) {
                            ++numberOfDeletedItems;
                            const request = cursor.delete();
                            (0, $f66e1a4ca7c109be$export$342d941b6f724995)(request, logger);
                        } else {
                            const request = cursor.update(updatedValue);
                            (0, $f66e1a4ca7c109be$export$342d941b6f724995)(request, logger);
                        }
                        if (items.length < fixedCount) cursor.continue();
                        else resolve({
                            items: items,
                            numberOfDeletedItems: numberOfDeletedItems
                        });
                    } else resolve({
                        items: items,
                        numberOfDeletedItems: numberOfDeletedItems
                    });
                };
            });
            await (0, $f66e1a4ca7c109be$export$feab8418f018df89)(transaction, this.logger);
            return getResult;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "deleteItems", async (itemIds)=>{
            const { transaction: transaction, objectStore: objectStore } = await this.getObjectStoreAndTransaction('readwrite');
            try {
                const deletePromises = itemIds.map((id)=>this.deleteItem(objectStore, id));
                await (0, $f66e1a4ca7c109be$export$feab8418f018df89)(transaction, this.logger);
                await Promise.all(deletePromises);
            } catch (error) {
                this.logger.warn('Failed to delete items from indexeddb.', error);
                throw error;
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "getItemCount", async ()=>{
            const { transaction: transaction, objectStore: objectStore } = await this.getObjectStoreAndTransaction('readonly');
            const timeIndex = objectStore.index((0, $33af1b6df02acb6a$export$a512a65455fce2a6));
            const upperBoundOpenKeyRange = IDBKeyRange.upperBound(Date.now());
            const request = timeIndex.count(upperBoundOpenKeyRange);
            const event = await (0, $f66e1a4ca7c109be$export$85ceed0783e42041)(request);
            await (0, $f66e1a4ca7c109be$export$feab8418f018df89)(transaction, this.logger);
            return event.target.result;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "processItems", async (processFn, count = (0, $1c498c884937cf8b$export$b6df3d334cec060f))=>{
            const _await$this$getItems = await this.getItems(count), { items: items } = _await$this$getItems, partialResult = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_await$this$getItems, $cc44f0f2693c9e2c$var$_excluded2);
            try {
                const result = await processFn(items, partialResult);
                const itemIds = items.map((item)=>item.id);
                // We should not await this delete as a rejected promise would get caught by the catch statement
                await this.deleteItems(itemIds);
                return result;
            } catch (error) {
                // Eventually we will need a intermediate class to catch all errors but we should ignore this error
                // This allows libraries beneath to distinguish between a success or failure in processing to update schedulers or anything else
                // To provide back off or any other mechanism to allow what ever is cauing the errors to recover
                throw new (0, $f7306cb8422ee85a$export$2e2bcd8739ae039)(error);
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "deleteItem", async (objectStore, id)=>{
            const { logger: logger } = this;
            try {
                await (0, $f66e1a4ca7c109be$export$85ceed0783e42041)(objectStore.delete(id));
            } catch (error) {
                logger.error('Failed to delete item:', id, error);
                throw error;
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "getObjectStoreAndTransaction", async (mode)=>{
            const transaction = (await this.db).transaction((0, $33af1b6df02acb6a$export$3d8420be07b276ab), mode);
            const objectStore = transaction.objectStore((0, $33af1b6df02acb6a$export$3d8420be07b276ab));
            return {
                transaction: transaction,
                objectStore: objectStore
            };
        });
        this.options = (0, $f66e1a4ca7c109be$export$ddc6718318090f71)(_options);
        this.namespace = _namespace;
        this.logger = this.options.logger;
        if (!window.indexedDB) throw new (0, $45d6507642197b13$export$2e2bcd8739ae039)();
        this.db = this.startDB();
        // We just swallow any errors as we know that these are intermittent errors
        // when switching from indexeddb -> localStorage
        this.db.catch(()=>{});
        /**
     *
     * This class will enforce the number of analytics events we can store in our IndexedDB object store
     * if asked before adding items to the object store.
     */ this.globalEventLimitGuard = new (0, $09480ff5e266e6b6$export$2e2bcd8739ae039)(this.options.maxEventLimit, this.namespace, this.logger, this.deleteItem);
    }
    storeType() {
        return (0, $33af1b6df02acb6a$export$39337ab5872e9457).INDEXEDDB;
    }
}



var $25nEq = parcelRequire("25nEq");

var $1Vcia = parcelRequire("1Vcia");




var $25nEq = parcelRequire("25nEq");


class $a473c3a6a30f3441$export$2e2bcd8739ae039 {
    constructor(eventLimit, memoryItemHandlers){
        /**
     * Unlike IndexedDb, we cannot take advantage of any index. So we are,
     * treating the memory store as a sorted set when adding items.
     */ (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "insertItemsToMemoryStore", (itemsToAdd, policy)=>{
            switch(policy){
                case (0, $33af1b6df02acb6a$export$7710d69e6f450f20).ABANDON:
                    return this.handleAbandonIfLimitWillExceedPolicy(itemsToAdd);
                case (0, $33af1b6df02acb6a$export$7710d69e6f450f20).EVICT:
                    return Promise.resolve(this.handleEvictOldestIfLimitExceededPolicy(itemsToAdd));
                case (0, $33af1b6df02acb6a$export$7710d69e6f450f20).IGNORE:
                    return this.handleAddAsManyAsPossible(itemsToAdd);
            }
        });
        if (eventLimit > 0) this.eventLimit = eventLimit;
        else throw Error('Event Limit has to be set higher than 1');
        this.memoryItemHandlers = memoryItemHandlers;
    }
    async handleAbandonIfLimitWillExceedPolicy(itemsToAdd) {
        const itemCount = await this.memoryItemHandlers.getItemCount();
        if (itemCount + itemsToAdd.length > this.eventLimit) throw new (0, $d2d6a47f21b9612f$export$2e2bcd8739ae039)((0, $33af1b6df02acb6a$export$39337ab5872e9457).MEMORY);
        this.memoryItemHandlers.addItems(itemsToAdd);
        return {
            items: itemsToAdd,
            numberOfEvictedItems: 0
        };
    }
    handleEvictOldestIfLimitExceededPolicy(itemsToAdd) {
        this.memoryItemHandlers.addItems(itemsToAdd);
        const numberOfEvictedItems = this.memoryItemHandlers.evictEventsIfNeeded(this.eventLimit);
        return {
            items: itemsToAdd,
            numberOfEvictedItems: numberOfEvictedItems
        };
    }
    async handleAddAsManyAsPossible(itemsToAdd) {
        const freeSpace = this.eventLimit - await this.memoryItemHandlers.getItemCount();
        const partialEventsToAdd = freeSpace > itemsToAdd.length ? itemsToAdd : itemsToAdd.slice(0, freeSpace);
        this.memoryItemHandlers.addItems(partialEventsToAdd);
        return {
            items: partialEventsToAdd,
            numberOfEvictedItems: 0
        };
    }
}



const $1702ecaf3ddce481$var$_excluded = [
    "item"
], $1702ecaf3ddce481$var$_excluded2 = [
    "items"
];
function $1702ecaf3ddce481$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $1702ecaf3ddce481$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $1702ecaf3ddce481$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $1702ecaf3ddce481$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
class $1702ecaf3ddce481$export$2e2bcd8739ae039 {
    constructor(namespace, options = {}){
        this.namespace = namespace;
        this.memoryStore = [];
        this.options = (0, $f66e1a4ca7c109be$export$ddc6718318090f71)(options);
        /**
     * This class will enforce the number of analytics events we can store in our MemoryDb
     */ this.globalEventLimitGuard = new (0, $a473c3a6a30f3441$export$2e2bcd8739ae039)(this.options.maxEventLimit, {
            addItems: this.addItems.bind(this),
            getItemCount: this.getItemCount.bind(this),
            evictEventsIfNeeded: this.evictEventsIfNeeded.bind(this)
        });
    }
    /**
   * This method is used mainly to write new events to MemoryDB and uses the MEMORY_DB_GUARD_POLICY.EVICT_OLDEST_IF_LIMIT_EXECEEDED policy
   * to removes oldest events when limit is reached.
   */ async addItem(item, options = {}, policy = (0, $33af1b6df02acb6a$export$7710d69e6f450f20).ABANDON) {
        if (policy === (0, $33af1b6df02acb6a$export$7710d69e6f450f20).IGNORE) throw new (0, $d187f7a92ea73b17$export$2e2bcd8739ae039)(policy, 'IndexedDbConnector#addItem');
        const storedValue = (0, $f66e1a4ca7c109be$export$aec476f33d77be11)(item, this.namespace, options);
        // Delegated responsiblity to event limit guard to insert to memory stored
        const bulkAddItemsResult = await this.globalEventLimitGuard.insertItemsToMemoryStore([
            storedValue
        ], policy);
        return Promise.resolve({
            item: bulkAddItemsResult.items[0],
            numberOfEvictedItems: bulkAddItemsResult.numberOfEvictedItems
        });
    }
    bulkAddItem(itemOptions, policy = (0, $33af1b6df02acb6a$export$7710d69e6f450f20).ABANDON) {
        const items = itemOptions.map((_ref)=>{
            let { item: item } = _ref, addOptions = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $1702ecaf3ddce481$var$_excluded);
            return (0, $f66e1a4ca7c109be$export$aec476f33d77be11)(item, this.namespace, addOptions);
        });
        return this.bulkAddItemWrapperType(items, policy);
    }
    /**
   * This method is used mainly to write events to MemoryDB when unknown errors are thrown from IndexedDB.
   */ bulkAddItemWrapperType(items, policy = (0, $33af1b6df02acb6a$export$7710d69e6f450f20).ABANDON) {
        return Promise.resolve(this.globalEventLimitGuard.insertItemsToMemoryStore(items, policy));
    }
    getItems(count = (0, $1c498c884937cf8b$export$b6df3d334cec060f)) {
        return Promise.resolve(this.synchronousGetItems(count));
    }
    synchronousGetItems(count = (0, $1c498c884937cf8b$export$b6df3d334cec060f)) {
        const fixedCount = count > 0 ? count : (0, $1c498c884937cf8b$export$b6df3d334cec060f);
        const now = Date.now();
        const wrappedItems = [];
        const itemsToRemove = [];
        for (let wrappedItem of this.memoryStore){
            if (wrappedItem.timeToBeProcessedAfter <= now) {
                wrappedItems.push($1702ecaf3ddce481$var$_objectSpread({}, wrappedItem));
                // Mutates the item in the memoryStore array, but not whats inside of wrappedItems
                wrappedItem.timeToBeProcessedAfter += (0, $1c498c884937cf8b$export$14ef152a03a4b6ee);
                wrappedItem.retryAttempts += 1;
                if (wrappedItem.retryAttempts >= this.options.maxAttempts) itemsToRemove.push(wrappedItem);
            }
            if (wrappedItems.length >= fixedCount) break;
        }
        itemsToRemove.forEach((item)=>{
            const index = this.memoryStore.indexOf(item);
            this.memoryStore.splice(index, 1);
        });
        return {
            items: wrappedItems,
            numberOfDeletedItems: itemsToRemove.length
        };
    }
    deleteItems(itemIds) {
        this.memoryStore = this.memoryStore.filter((item)=>!itemIds.includes(item.id));
        return Promise.resolve(void 0);
    }
    getItemCount() {
        const now = Date.now();
        const count = this.memoryStore.filter((item)=>item.timeToBeProcessedAfter <= now).length;
        return Promise.resolve(count);
    }
    async processItems(processFn, count) {
        const _this$synchronousGetI = this.synchronousGetItems(count), { items: items } = _this$synchronousGetI, partialGetResult = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_this$synchronousGetI, $1702ecaf3ddce481$var$_excluded2);
        const itemIds = items.map((i)=>i.id);
        try {
            const result = await processFn(items, partialGetResult);
            await this.deleteItems(itemIds);
            return result;
        } catch (error) {
            throw new (0, $f7306cb8422ee85a$export$2e2bcd8739ae039)(error);
        }
    }
    storeType() {
        return (0, $33af1b6df02acb6a$export$39337ab5872e9457).MEMORY;
    }
    /**
   * This function is adding items to the tail of the memoryStore and as it adds new items it keeps the
   * memory store sorted by timeAdded property. This makes evictions easier and adding elements to
   * memoryStore much faster.
   *
   * @param itemsToAdd
   */ addItems(itemsToAdd) {
        this.memoryStore.push(...itemsToAdd);
        // Sorting everytime, intentionally.
        this.memoryStore.sort(function(a, b) {
            return a.timeAdded - b.timeAdded;
        });
    }
    /**
   * This function checks the number of events currently in AWC MemoryDb and if necessary,
   * will evict the oldest events in favour of the events we want to add.
   *
   * @param countOfEventsToAdd - The number of events we are proposing to add.
   */ evictEventsIfNeeded(eventLimit) {
        const numberOfEventsInDb = this.memoryStore.length;
        // The number of analytics events currently in MemoryDb and
        // the Z events we are proposing to add will exceed our event count limit.
        if (numberOfEventsInDb > eventLimit) {
            const m = numberOfEventsInDb - eventLimit;
            // Removing oldest M events
            this.memoryStore.splice(0, m);
            return m;
        }
        return 0;
    }
}



class $9d7ccf4aa6931707$export$2e2bcd8739ae039 {
    constructor(namespace, options = {}){
        this.namespace = namespace;
        this.options = (0, $f66e1a4ca7c109be$export$ddc6718318090f71)(options);
        if (!namespace || namespace.length === 0 || typeof namespace !== 'string') throw new Error('Invalid namespace provided');
        this.resilience = this.getResilienceMechanism(namespace, options);
    }
    getResilienceMechanism(namespace, options) {
        if (!options.useMemory) try {
            return new (0, $cc44f0f2693c9e2c$export$2e2bcd8739ae039)(namespace, options);
        } catch (error) {
            if (!(error instanceof (0, $45d6507642197b13$export$2e2bcd8739ae039))) {
                var _options$logger;
                (_options$logger = options.logger) === null || _options$logger === void 0 || _options$logger.warn('Attempted to create IndexedDbResilience but failed. Using memory instead.');
            }
        }
        return new (0, $1702ecaf3ddce481$export$2e2bcd8739ae039)(this.namespace, options);
    }
    addItem(item, options, policy = (0, $33af1b6df02acb6a$export$7710d69e6f450f20).ABANDON) {
        return this.runOrFailOver(()=>this.resilience.addItem(item, options, policy));
    }
    bulkAddItem(itemOptions, policy = (0, $33af1b6df02acb6a$export$7710d69e6f450f20).ABANDON) {
        return this.runOrFailOver(()=>this.resilience.bulkAddItem(itemOptions, policy));
    }
    getItems(count) {
        return this.runOrFailOver(()=>this.resilience.getItems(count));
    }
    deleteItems(itemIds) {
        return this.runOrFailOver(()=>this.resilience.deleteItems(itemIds));
    }
    getItemCount() {
        return this.runOrFailOver(()=>this.resilience.getItemCount());
    }
    processItems(processFn, count) {
        return this.runOrFailOver(()=>this.resilience.processItems(processFn, count));
    }
    storeType() {
        return this.resilience.storeType();
    }
    async runOrFailOver(runnable) {
        try {
            return await runnable();
        } catch (error) {
            if ((0, $06f8d85073d84c3b$export$74101021e0969375)(error)) throw error;
            else if (this.resilience.storeType() === (0, $33af1b6df02acb6a$export$39337ab5872e9457).INDEXEDDB) await this.failOver();
            return runnable();
        }
    }
    async failOver() {
        // Attempt to get any events we can and put them into memory
        const oldResilience = this.resilience;
        const newResilience = new (0, $1702ecaf3ddce481$export$2e2bcd8739ae039)(this.namespace, this.options);
        this.resilience = newResilience;
        try {
            const { items: items } = await oldResilience.getItems(this.options.maxEventLimit);
            if (items.length > 0) {
                const bulkAddItemsResponse = await newResilience.bulkAddItemWrapperType(items, (0, $33af1b6df02acb6a$export$7710d69e6f450f20).IGNORE);
                const addedItemIds = bulkAddItemsResponse.items.map((item)=>item.id);
                await oldResilience.deleteItems(addedItemIds);
            }
        } catch (error) {
            this.options.logger.warn('Unexpected error from ResilienceDb, switching to MemoryDb');
        // Dont need to catch. We are just getting events if we can
        }
    }
}




var $7b751cc60eb1a247$export$2e2bcd8739ae039 = (0, $9d7ccf4aa6931707$export$2e2bcd8739ae039);



var $25nEq = parcelRequire("25nEq");
let $70d72d06700e4121$export$c75161629e3ec34e = /*#__PURE__*/ function(ResilienceMechanism) {
    ResilienceMechanism["INDEXEDDB"] = "indexeddb";
    ResilienceMechanism["MEMORY"] = "memory";
    return ResilienceMechanism;
}({});
let $70d72d06700e4121$export$ee138fa712d11b84 = /*#__PURE__*/ function(NetworkStatusEnum) {
    NetworkStatusEnum[NetworkStatusEnum["ONLINE"] = 0] = "ONLINE";
    NetworkStatusEnum[NetworkStatusEnum["OFFLINE"] = 1] = "OFFLINE";
    return NetworkStatusEnum;
}({});


class $02d51d0ac0f3eacd$export$4b62ee5120ab50a8 {
    constructor(){
        // Number of events discarded due to exceeding retry limits.
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "itemsDiscardedByRetry", 0);
        // Number of events created by the product in current tab.
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "eventCount", 0);
        // Number of events discarded due to reaching queue max size.
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "itemsDiscardedByOverflow", 0);
        // Will be used in the future when we get more resilience mechanisms
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "resilienceMechanism", (0, $70d72d06700e4121$export$c75161629e3ec34e).INDEXEDDB);
        /* --- LocalStorage specific metrics --- */ // Emitted by purgeOrphanedQueues to tell us how many queues we have had to clean up due to
        // https://github.com/segmentio/localstorage-retry/pull/17
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "localstorageNumberOfQueuesPurged", 0);
        // Emitted by reclaimEvents to tell us how many queues were seen in the process of reclaim.
        // We will only emit metrics for queues that are not currently being maintained (i.e. `ack` is not being updated).
        // Queue was found, all events removed and put into resilienceDb.
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "localstorageNumberOfFullReclaims", 0);
        // Queue was found but not all events were able to be put into resilienceDb.
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "localstorageNumberOfPartialReclaims", 0);
        // Reclaim failed for a queue and reclaim was abandonded.
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "localstorageNumberOfFailedReclaims", 0);
    }
    addToItemsDiscardedByRetryCounter(numberOfDeletedEvents = 1) {
        this.itemsDiscardedByRetry += numberOfDeletedEvents;
    }
    addToEventCount() {
        this.eventCount++;
    }
    addToItemsDiscardedByOverflowCounter(numberOfDeletedEvents = 1) {
        this.itemsDiscardedByOverflow += numberOfDeletedEvents;
    }
    setResilienceMechanism(mechanism) {
        this.resilienceMechanism = mechanism;
    }
    /* <Localstorage specific> */ addToReclaimMetrics(reclaimMetrics) {
        this.localstorageNumberOfFullReclaims += reclaimMetrics.fullReclaims;
        this.localstorageNumberOfPartialReclaims += reclaimMetrics.partialReclaims;
        this.localstorageNumberOfFailedReclaims += reclaimMetrics.failedReclaims;
    }
    addToPurgedQueuesMetrics(numberOfQueuesPurged) {
        this.localstorageNumberOfQueuesPurged += numberOfQueuesPurged;
    }
    /* </Localstorage specific> */ subtractFromMetrics(sentMetrics) {
        this.itemsDiscardedByRetry = this.subtractFromCount(this.itemsDiscardedByRetry, sentMetrics.itemsDiscardedByRetry);
        this.eventCount = this.subtractFromCount(this.eventCount, sentMetrics.eventCount);
        this.itemsDiscardedByOverflow = this.subtractFromCount(this.itemsDiscardedByOverflow, sentMetrics.itemsDiscardedByOverflow);
        // Localstorage specific
        this.localstorageNumberOfFullReclaims = this.subtractFromCount(this.localstorageNumberOfFullReclaims, sentMetrics.fullReclaims);
        this.localstorageNumberOfPartialReclaims = this.subtractFromCount(this.localstorageNumberOfPartialReclaims, sentMetrics.partialReclaims);
        this.localstorageNumberOfFailedReclaims = this.subtractFromCount(this.localstorageNumberOfFailedReclaims, sentMetrics.failedReclaims);
        this.localstorageNumberOfQueuesPurged = this.subtractFromCount(this.localstorageNumberOfQueuesPurged, sentMetrics.localstorageQueuesPurged);
    }
    subtractFromCount(count, subtract) {
        return Math.max(count - (subtract || 0), 0);
    }
    getMetricsPayload() {
        return {
            itemsDiscardedByRetry: this.itemsDiscardedByRetry,
            eventCount: this.eventCount,
            itemsDiscardedByOverflow: this.itemsDiscardedByOverflow,
            resilienceMechanism: this.resilienceMechanism,
            // Localstorage specific
            localstorageQueuesPurged: this.localstorageNumberOfQueuesPurged,
            fullReclaims: this.localstorageNumberOfFullReclaims,
            partialReclaims: this.localstorageNumberOfPartialReclaims,
            failedReclaims: this.localstorageNumberOfFailedReclaims
        };
    }
}
let $02d51d0ac0f3eacd$var$cachedMetricsClient = null;
var $02d51d0ac0f3eacd$export$2e2bcd8739ae039 = ()=>{
    if (!$02d51d0ac0f3eacd$var$cachedMetricsClient) $02d51d0ac0f3eacd$var$cachedMetricsClient = new $02d51d0ac0f3eacd$export$4b62ee5120ab50a8();
    return $02d51d0ac0f3eacd$var$cachedMetricsClient;
};



class $217f46601d89c1b6$export$2e2bcd8739ae039 {
    constructor(networkChangeCallback){
        this._networkChangeCallback = networkChangeCallback;
        if (typeof window !== 'undefined') {
            window.addEventListener('offline', ()=>this._networkChangeCallback((0, $70d72d06700e4121$export$ee138fa712d11b84).OFFLINE));
            window.addEventListener('online', ()=>this._networkChangeCallback((0, $70d72d06700e4121$export$ee138fa712d11b84).ONLINE));
        }
    }
    removeListeners() {
        if (typeof window !== 'undefined') {
            window.addEventListener('offline', ()=>this._networkChangeCallback((0, $70d72d06700e4121$export$ee138fa712d11b84).OFFLINE));
            window.addEventListener('online', ()=>this._networkChangeCallback((0, $70d72d06700e4121$export$ee138fa712d11b84).ONLINE));
        }
    }
    getNetworkStatus() {
        if (window.navigator.onLine) return (0, $70d72d06700e4121$export$ee138fa712d11b84).ONLINE;
        return (0, $70d72d06700e4121$export$ee138fa712d11b84).OFFLINE;
    }
}



var $25nEq = parcelRequire("25nEq");

var $25nEq = parcelRequire("25nEq");
let $6529ab323cc35eef$export$ef3353088fca369c = /*#__PURE__*/ function(CallbackStatus) {
    CallbackStatus["IDLE"] = "idle";
    CallbackStatus["RUNNING"] = "running";
    CallbackStatus["COMPLETED"] = "completed";
    CallbackStatus["TIMED_OUT"] = "timedOut";
    return CallbackStatus;
}({});
let $6529ab323cc35eef$export$def7d978353eaa0 = /*#__PURE__*/ function(CallbackEvent) {
    CallbackEvent["EXECUTE"] = "execute";
    CallbackEvent["COMPLETE"] = "complete";
    CallbackEvent["TIMEOUT"] = "timeout";
    return CallbackEvent;
}({});
class $6529ab323cc35eef$export$590a718599f8f8b3 {
    constructor(timeoutPeriod){
        // Milliseconds to wait
        // Tracks the settimeout; so that we can clear the timeout
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "timeoutHandle", undefined);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "callbackStatus", $6529ab323cc35eef$export$ef3353088fca369c.IDLE);
        if (timeoutPeriod > 0) {
            this.timeoutPeriod = timeoutPeriod;
            return;
        }
        throw new Error('CallbackWithTimeout requires timeout period higher than 0');
    }
    // This is a state machine to control the flow of execution.
    // IDLE -> RUNNING -> COMPLETED
    // IDLE -> RUNNING -> TIMEDOUT
    transitionCallbackStatus(currentStatus, event) {
        switch(currentStatus){
            case $6529ab323cc35eef$export$ef3353088fca369c.IDLE:
            case $6529ab323cc35eef$export$ef3353088fca369c.TIMED_OUT:
            case $6529ab323cc35eef$export$ef3353088fca369c.COMPLETED:
                if (event === $6529ab323cc35eef$export$def7d978353eaa0.EXECUTE) this.callbackStatus = $6529ab323cc35eef$export$ef3353088fca369c.RUNNING;
                break;
            case $6529ab323cc35eef$export$ef3353088fca369c.RUNNING:
                switch(event){
                    case $6529ab323cc35eef$export$def7d978353eaa0.COMPLETE:
                        this.callbackStatus = $6529ab323cc35eef$export$ef3353088fca369c.COMPLETED;
                        break;
                    case $6529ab323cc35eef$export$def7d978353eaa0.TIMEOUT:
                        this.callbackStatus = $6529ab323cc35eef$export$ef3353088fca369c.TIMED_OUT;
                        break;
                }
                break;
            default:
                this.callbackStatus = currentStatus;
        }
    }
    // Start a timeout. If this.callback(this._done) does not finish
    // by this.options.callbackTimeoutPeriod time period,
    // we will call done with a true value.
    executeCallbackWithTimeout(callback, onDone, onTimeout) {
        if (typeof window === 'undefined') return;
        this.transitionCallbackStatus(this.callbackStatus, $6529ab323cc35eef$export$def7d978353eaa0.EXECUTE);
        // Setting timeout
        this.timeoutHandle = window.setTimeout(()=>{
            this.transitionCallbackStatus(this.callbackStatus, $6529ab323cc35eef$export$def7d978353eaa0.TIMEOUT);
            onTimeout();
        }, this.timeoutPeriod);
        // Executing callback
        callback((state)=>{
            this.cancelTimeout();
            if (this.getCallbackStatus() !== $6529ab323cc35eef$export$ef3353088fca369c.TIMED_OUT) {
                this.transitionCallbackStatus(this.callbackStatus, $6529ab323cc35eef$export$def7d978353eaa0.COMPLETE);
                onDone(state);
            }
        });
    }
    getCallbackStatus() {
        return this.callbackStatus;
    }
    // This allows us to cancel the timeout function, for example, if the callback finishes before the timeout period
    // or, if the user wants to manually cancel the timeout
    cancelTimeout() {
        if (typeof window !== 'undefined' && this.timeoutPeriod > 0 && this.timeoutHandle) {
            window.clearTimeout(this.timeoutHandle);
            this.timeoutHandle = undefined;
        }
    }
}


// Clients can optionally provide the callbackTimeoutPeriod parameter
let $259e7a33bf7a29f3$export$f93c40fda808dd0c = /*#__PURE__*/ function(DoneState) {
    DoneState[DoneState["NOOP"] = 0] = "NOOP";
    DoneState[DoneState["SUCCESS"] = 1] = "SUCCESS";
    DoneState[DoneState["ERROR"] = 2] = "ERROR";
    return DoneState;
}({});


const $91fcc5723998e290$var$SCHEDULER_OPTIONS_DEFAULT = {
    minRetryDelay: 1000,
    maxRetryDelay: 30000,
    backoffFactor: 2,
    backoffJitterPercentage: 0,
    waitInterval: 500,
    callbackTimeoutPeriod: 5000
};
let $91fcc5723998e290$export$8bb92baee001fc60 = /*#__PURE__*/ function(QueuedScheduleTypes) {
    QueuedScheduleTypes[QueuedScheduleTypes["NONE"] = 0] = "NONE";
    QueuedScheduleTypes[QueuedScheduleTypes["IMMEDIATE"] = 1] = "IMMEDIATE";
    QueuedScheduleTypes[QueuedScheduleTypes["WAIT"] = 2] = "WAIT";
    return QueuedScheduleTypes;
}({});
class $91fcc5723998e290$export$2e2bcd8739ae039 {
    constructor(retryOptions, callback){
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "schedule", ({ immediate: immediate } = {})=>{
            if (typeof window === 'undefined') return;
            if (this.operationInFlight) {
                if (immediate) this.queuedSchedule = $91fcc5723998e290$export$8bb92baee001fc60.IMMEDIATE;
                else if (this.queuedSchedule !== $91fcc5723998e290$export$8bb92baee001fc60.IMMEDIATE) this.queuedSchedule = $91fcc5723998e290$export$8bb92baee001fc60.WAIT;
            // Only run immediately if we have no failures
            } else if ((immediate || this.options.waitInterval <= 0) && this.failureCount === 0) {
                this.clearTimeout();
                this.run();
            // Calculate backoff for normal or failure scenario
            } else if (this.scheduledTimeout === null) this.scheduledTimeout = window.setTimeout(this.run, this.calculateBackoff());
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "stop", ()=>{
            this.clearTimeout();
            this.queuedSchedule = $91fcc5723998e290$export$8bb92baee001fc60.NONE;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "getFailureCount", ()=>this.failureCount);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "getCallbackStatus", ()=>{
            return this.callbackTimer.getCallbackStatus();
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "clearTimeout", ()=>{
            if (typeof window !== 'undefined' && this.scheduledTimeout !== null) {
                window.clearTimeout(this.scheduledTimeout);
                this.scheduledTimeout = null;
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "run", ()=>{
            this.operationInFlight = true;
            this.clearTimeout();
            try {
                this.callbackTimer.executeCallbackWithTimeout(// callback to execute
                this.callback, // when callback completes, call this function
                this.done, // on timeout, do this instead
                ()=>this.done((0, $259e7a33bf7a29f3$export$f93c40fda808dd0c).ERROR));
            } catch (err) {
                this.done(err);
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "done", (state)=>{
            this.operationInFlight = false;
            if (state === (0, $259e7a33bf7a29f3$export$f93c40fda808dd0c).ERROR || this.callbackTimer.getCallbackStatus() === (0, $6529ab323cc35eef$export$ef3353088fca369c).TIMED_OUT) {
                this.failureCount++;
                this.clearTimeout();
            } else if (state === (0, $259e7a33bf7a29f3$export$f93c40fda808dd0c).SUCCESS) this.failureCount = 0;
            this.processQueuedSchedule();
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "processQueuedSchedule", ()=>{
            if (this.queuedSchedule !== $91fcc5723998e290$export$8bb92baee001fc60.NONE) {
                const immediate = this.queuedSchedule === $91fcc5723998e290$export$8bb92baee001fc60.IMMEDIATE;
                this.queuedSchedule = $91fcc5723998e290$export$8bb92baee001fc60.NONE;
                this.schedule({
                    immediate: immediate
                });
            } else if (this.failureCount > 0) // This will schedule tasks when this._done was called with a truthy value
            // For example, when this.callback(this._done) was not called within
            // this.callbackTimeoutPeriod
            this.schedule();
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "calculateBackoff", ()=>{
            const { minRetryDelay: minRetryDelay, maxRetryDelay: maxRetryDelay, backoffFactor: backoffFactor, backoffJitterPercentage: backoffJitterPercentage, waitInterval: waitInterval } = this.options;
            // Helper for deviation based on a single random sample
            const jitter = (base, symmetric)=>{
                if (!backoffJitterPercentage || base <= 0) return 0;
                const r = (Math.random() - 0.5) * 2;
                const frac = symmetric ? r : Math.abs(r);
                return Math.floor(frac * backoffJitterPercentage * base);
            };
            // No failures: wait interval with positive-only jitter
            if (this.failureCount === 0) return waitInterval + jitter(waitInterval, false);
            // Failures: exponential backoff with symmetric jitter
            const base = Math.min(minRetryDelay * backoffFactor ** this.failureCount, maxRetryDelay);
            const withJitter = base + jitter(base, true);
            return Math.max(minRetryDelay, Math.min(withJitter, maxRetryDelay));
        });
        this.options = {
            minRetryDelay: retryOptions.minRetryDelay || $91fcc5723998e290$var$SCHEDULER_OPTIONS_DEFAULT.minRetryDelay,
            maxRetryDelay: retryOptions.maxRetryDelay || $91fcc5723998e290$var$SCHEDULER_OPTIONS_DEFAULT.maxRetryDelay,
            backoffFactor: retryOptions.backoffFactor || $91fcc5723998e290$var$SCHEDULER_OPTIONS_DEFAULT.backoffFactor,
            backoffJitterPercentage: retryOptions.backoffJitterPercentage || $91fcc5723998e290$var$SCHEDULER_OPTIONS_DEFAULT.backoffJitterPercentage,
            waitInterval: retryOptions.waitInterval !== undefined ? retryOptions.waitInterval : $91fcc5723998e290$var$SCHEDULER_OPTIONS_DEFAULT.waitInterval,
            callbackTimeoutPeriod: retryOptions.callbackTimeoutPeriod || $91fcc5723998e290$var$SCHEDULER_OPTIONS_DEFAULT.callbackTimeoutPeriod
        };
        this.scheduledTimeout = null;
        this.failureCount = 0;
        this.callback = callback;
        this.operationInFlight = false;
        this.queuedSchedule = $91fcc5723998e290$export$8bb92baee001fc60.NONE;
        this.callbackTimer = new (0, $6529ab323cc35eef$export$590a718599f8f8b3)(this.options.callbackTimeoutPeriod);
    }
}



function $29ad82233d2d80ba$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $29ad82233d2d80ba$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $29ad82233d2d80ba$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $29ad82233d2d80ba$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
const $29ad82233d2d80ba$var$ONE_MINUTE = 60000;
const $29ad82233d2d80ba$var$LONG_POLLING_OPTIONS = {
    backoffFactor: 0,
    backoffJitterPercentage: 0,
    flushWaitMs: $29ad82233d2d80ba$var$ONE_MINUTE,
    minRetryDelay: $29ad82233d2d80ba$var$ONE_MINUTE,
    maxRetryDelay: $29ad82233d2d80ba$var$ONE_MINUTE
};
const $29ad82233d2d80ba$export$d219df4fe04c04a7 = {
    backoffFactor: 2,
    backoffJitterPercentage: 0.2,
    batchFlushSize: 7,
    flushBeforeUnload: false,
    flushWaitMs: 500,
    maxAttempts: 10,
    // TODO figure out this number. For indexeddb we are sharing the queue with all tabs
    maxItems: 1000,
    maxRetryDelay: 30000,
    minRetryDelay: 1000
};
class $29ad82233d2d80ba$export$2e2bcd8739ae039 {
    constructor(queuePrefix, product, options, logger){
        this.queuePrefix = queuePrefix;
        // Avoiding using options in ResilienceDB at this stage as
        // the options are optimised for the PushBatchableQueue
        this.resilience = new (0, $7b751cc60eb1a247$export$2e2bcd8739ae039)(product, {
            logger: logger,
            maxAttempts: options === null || options === void 0 ? void 0 : options.maxAttempts,
            maxEventLimit: options === null || options === void 0 ? void 0 : options.maxItems
        });
        this.options = this.buildOptions(options);
        this.scheduler = new (0, $91fcc5723998e290$export$2e2bcd8739ae039)($29ad82233d2d80ba$var$_objectSpread($29ad82233d2d80ba$var$_objectSpread({}, this.options), {}, {
            waitInterval: options !== null && options !== void 0 && options.flushBeforeUnload ? 0 : this.options.flushWaitMs
        }), this.scheduleCallback.bind(this));
        this.longPollingScheduler = new (0, $91fcc5723998e290$export$2e2bcd8739ae039)($29ad82233d2d80ba$var$_objectSpread($29ad82233d2d80ba$var$_objectSpread({}, $29ad82233d2d80ba$var$LONG_POLLING_OPTIONS), {}, {
            waitInterval: $29ad82233d2d80ba$var$LONG_POLLING_OPTIONS.flushWaitMs
        }), this.scheduleLongCallBack.bind(this));
        this.metricsCollector = (0, $02d51d0ac0f3eacd$export$2e2bcd8739ae039)();
        this.networkStatus = new (0, $217f46601d89c1b6$export$2e2bcd8739ae039)((status)=>{
            if (status === (0, $70d72d06700e4121$export$ee138fa712d11b84).OFFLINE) this.scheduler.stop();
            else this.checkEventCountAndReschedule();
        });
    }
    start(flushCallback) {
        this.batchFlushCallback = flushCallback;
        this.longPollingScheduler.schedule();
    }
    stop() {
        this.scheduler.stop();
        this.longPollingScheduler.stop();
    }
    async addItem(item) {
        // Since Jira and Confluence use `.toJSON` on objects that should be strings
        // And expect us to use `JSON.stringify` on these objects,
        // And indexeddb strips these functions from the objects when adding them to the DB,
        // We must run this silly stringify and parse before passing the event to the resilience meechanism.
        // Planning on removing this in v4
        const jsonStringifiedAndParsedItem = JSON.parse(JSON.stringify(item));
        const { numberOfEvictedItems: numberOfEvictedItems } = await this.resilience.addItem(jsonStringifiedAndParsedItem, {}, (0, $33af1b6df02acb6a$export$7710d69e6f450f20).EVICT);
        this.scheduler.schedule();
        this.metricsCollector.addToEventCount();
        if (numberOfEvictedItems > 0) this.metricsCollector.addToItemsDiscardedByOverflowCounter(numberOfEvictedItems);
    }
    getGlobalRetryCount() {
        return this.scheduler.getFailureCount();
    }
    async scheduleCallback(done) {
        // Even though we stopped the scheduler, it can be restarted with a call to schedule.
        // This could be triggered by a new event or the longPollingScheduler
        if (this.networkStatus.getNetworkStatus() === (0, $70d72d06700e4121$export$ee138fa712d11b84).OFFLINE) {
            done((0, $259e7a33bf7a29f3$export$f93c40fda808dd0c).NOOP);
            return;
        }
        try {
            const result = await this.resilience.processItems(this.flush.bind(this), this.options.batchFlushSize);
            done(result);
        } catch (error) {
            if (error.name === (0, $f7306cb8422ee85a$export$a409c8de90e11e14)) {
                done((0, $259e7a33bf7a29f3$export$f93c40fda808dd0c).ERROR);
                return;
            }
        // TODO we can probably log here but throwing is useless as it will just be shallowed by the Scheduler
        // In theory something else should catch all other errors from indexeddb and this should never happen.
        } finally{
            await this.checkEventCountAndReschedule();
        }
    }
    async checkEventCountAndReschedule() {
        const eventWaitingCount = await this.resilience.getItemCount();
        if (eventWaitingCount > 0) this.scheduler.schedule({
            immediate: eventWaitingCount >= this.options.batchFlushSize
        });
    }
    async scheduleLongCallBack(done) {
        // Eventually we will want to send data about how many queues were purged
        const numberOfQueuesPurged = (0, $ba738f5e1bb5880f$export$2e2bcd8739ae039)(this.queuePrefix);
        this.metricsCollector.addToPurgedQueuesMetrics(numberOfQueuesPurged);
        // Eventually we will want to send data about how attempted reclaims and actual reclaims were made
        const reclaimMetrics = await (0, $021634adde976b1b$export$2e2bcd8739ae039)(this.queuePrefix, async (localStorageItems)=>{
            const itemsToAdd = localStorageItems.map((localStorageItem)=>({
                    item: localStorageItem.item,
                    retryAttempts: localStorageItem.attemptNumber,
                    id: localStorageItem.id
                }));
            const { items: addedEvents } = await this.resilience.bulkAddItem(itemsToAdd, (0, $33af1b6df02acb6a$export$7710d69e6f450f20).IGNORE);
            if (addedEvents.length === itemsToAdd.length) return {
                status: 'successful'
            };
            else return {
                status: 'partial',
                acceptedItemIds: addedEvents.map((event)=>event.id)
            };
        });
        this.metricsCollector.addToReclaimMetrics(reclaimMetrics);
        // We dont want to flush events from here as there maybe issues with analytics-service
        // Scheduler has all the context and can schedule the next batch accordingly
        await this.checkEventCountAndReschedule();
        done((0, $259e7a33bf7a29f3$export$f93c40fda808dd0c).SUCCESS);
        this.longPollingScheduler.schedule();
    }
    flush(wrappedItems, otherMetadata) {
        this.metricsCollector.setResilienceMechanism(this.resilience.storeType());
        const { batchFlushCallback: batchFlushCallback } = this;
        if (!batchFlushCallback) throw new Error('batchFlushCallback has not been set. Call PullBatchableQueue#start first.');
        return new Promise((resolve, reject)=>{
            if (wrappedItems.length <= 0) {
                resolve((0, $259e7a33bf7a29f3$export$f93c40fda808dd0c).NOOP);
                return;
            }
            const items = wrappedItems.map((wrappedItem)=>{
                const item = wrappedItem.item;
                if (wrappedItem.retryAttempts > 0 && item.msg) {
                    if (!item.msg._metadata) item.msg._metadata = {};
                    item.msg._metadata.failedAttempts = wrappedItem.retryAttempts;
                }
                return item;
            });
            batchFlushCallback(items, (error)=>{
                if (error) {
                    if (otherMetadata.numberOfDeletedItems > 0) this.metricsCollector.addToItemsDiscardedByRetryCounter(otherMetadata.numberOfDeletedItems);
                    reject(error);
                } else resolve((0, $259e7a33bf7a29f3$export$f93c40fda808dd0c).SUCCESS);
            });
        });
    }
    buildOptions(options) {
        return {
            backoffFactor: (options === null || options === void 0 ? void 0 : options.backoffFactor) || $29ad82233d2d80ba$export$d219df4fe04c04a7.backoffFactor,
            backoffJitterPercentage: (options === null || options === void 0 ? void 0 : options.backoffJitterPercentage) !== undefined ? options.backoffJitterPercentage : $29ad82233d2d80ba$export$d219df4fe04c04a7.backoffJitterPercentage,
            batchFlushSize: (options === null || options === void 0 ? void 0 : options.batchFlushSize) || $29ad82233d2d80ba$export$d219df4fe04c04a7.batchFlushSize,
            flushBeforeUnload: (options === null || options === void 0 ? void 0 : options.flushBeforeUnload) || $29ad82233d2d80ba$export$d219df4fe04c04a7.flushBeforeUnload,
            flushWaitMs: (options === null || options === void 0 ? void 0 : options.flushWaitMs) || $29ad82233d2d80ba$export$d219df4fe04c04a7.flushWaitMs,
            maxItems: (options === null || options === void 0 ? void 0 : options.maxItems) || $29ad82233d2d80ba$export$d219df4fe04c04a7.maxItems,
            maxAttempts: (options === null || options === void 0 ? void 0 : options.maxAttempts) || $29ad82233d2d80ba$export$d219df4fe04c04a7.maxAttempts,
            maxRetryDelay: (options === null || options === void 0 ? void 0 : options.maxRetryDelay) || $29ad82233d2d80ba$export$d219df4fe04c04a7.maxRetryDelay,
            minRetryDelay: (options === null || options === void 0 ? void 0 : options.minRetryDelay) || $29ad82233d2d80ba$export$d219df4fe04c04a7.minRetryDelay
        };
    }
}



var $9009c8d029fe1a5f$export$2e2bcd8739ae039 = (retryQueuePrefix, product, options, logger)=>{
    return new (0, $29ad82233d2d80ba$export$2e2bcd8739ae039)(retryQueuePrefix, product, options || {}, logger);
};





var $25nEq = parcelRequire("25nEq");
// Segment event types copied from our backend
// https://bitbucket.org/atlassian/analytics-service/src/master/api/src/main/java/com/atlassian/dataservices/analytics/service/api/segment/
class $3efe50d51d84d6fc$export$a63e16b3351b8c36 {
    constructor(reason, error){
        this.reason = reason;
        this.message = error instanceof Error ? error.message : null;
        this.statusCode = error instanceof $3efe50d51d84d6fc$export$26e841bcf1aeb894 ? error.statusCode : null;
    }
}
let $3efe50d51d84d6fc$export$ddf929981dc6feb3 = /*#__PURE__*/ function(SegmentEventTypes) {
    SegmentEventTypes["IDENTIFY"] = "identify";
    SegmentEventTypes["PAGE"] = "page";
    // Dont need Screen as page and screen are the same and we only use page
    SegmentEventTypes["TRACK"] = "track";
    return SegmentEventTypes;
}({});
let $3efe50d51d84d6fc$export$8d8db47b9b0efb63 = /*#__PURE__*/ function(CrossDomainIdentifierType) {
    CrossDomainIdentifierType["XC"] = "xc";
    CrossDomainIdentifierType["UID"] = "uid";
    return CrossDomainIdentifierType;
}({});
let $3efe50d51d84d6fc$export$2140495465f9e528 = /*#__PURE__*/ function(CrossDomainIdentifierState) {
    CrossDomainIdentifierState["NEW"] = "NEW";
    CrossDomainIdentifierState["CHANGED"] = "CHANGED";
    CrossDomainIdentifierState["EXISTING"] = "EXISTING";
    CrossDomainIdentifierState["TIMEOUT"] = "TIMEOUT";
    CrossDomainIdentifierState["ERROR"] = "ERROR";
    CrossDomainIdentifierState["UNAVAILABLE"] = "UNAVAILABLE";
    CrossDomainIdentifierState["MALFORMED"] = "MALFORMED";
    CrossDomainIdentifierState["UNKNOWN"] = "UNKNOWN";
    return CrossDomainIdentifierState;
}({});
class $3efe50d51d84d6fc$export$4b1a5e5486cc0d80 {
    constructor(props, url){
        this.props = props;
        this.url = url;
    }
    static fromJson(json) {
        let isString = (value)=>typeof value === 'string' || value instanceof String;
        const url = isString(json === null || json === void 0 ? void 0 : json.url) ? json.url.trim() : '';
        return new $3efe50d51d84d6fc$export$4b1a5e5486cc0d80((json === null || json === void 0 ? void 0 : json.props) || null, url.startsWith('http') ? url : null);
    }
}
class $3efe50d51d84d6fc$export$26e841bcf1aeb894 extends Error {
    constructor(message, statusCode, statusText){
        super(message);
        this.statusCode = statusCode;
        this.statusText = statusText;
    }
}
const $3efe50d51d84d6fc$export$96f086dcf574a9e2 = [
    'FetchError',
    'AbortError',
    'TypeError'
];


function $7ec5b9481a262e12$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $7ec5b9481a262e12$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $7ec5b9481a262e12$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $7ec5b9481a262e12$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $7ec5b9481a262e12$export$c9c3aaf655d6f275(item, xidCallback) {
    if (!(xidCallback && xidCallback instanceof Function)) return item;
    if (item.msg.type === (0, $3efe50d51d84d6fc$export$ddf929981dc6feb3).PAGE || item.msg.type === (0, $3efe50d51d84d6fc$export$ddf929981dc6feb3).TRACK) {
        const xid = xidCallback();
        if (xid && Array.isArray(xid)) item.msg.properties = $7ec5b9481a262e12$var$_objectSpread($7ec5b9481a262e12$var$_objectSpread({}, item.msg.properties), {}, {
            xid: xid
        });
    } else if (item.msg.traits && item.msg.type === (0, $3efe50d51d84d6fc$export$ddf929981dc6feb3).IDENTIFY) {
        const xid = xidCallback();
        if (xid && Array.isArray(xid)) item.msg.traits = $7ec5b9481a262e12$var$_objectSpread($7ec5b9481a262e12$var$_objectSpread({}, item.msg.traits), {}, {
            xid: xid
        });
    }
    return item;
}
async function $7ec5b9481a262e12$export$c21270cab66ab290(items, xidItemPromiseCallback) {
    try {
        const xidCallback = await xidItemPromiseCallback;
        return items.map((item)=>$7ec5b9481a262e12$export$c9c3aaf655d6f275(item, xidCallback));
    } catch (error) {
        return items;
    }
}


const $88991a89387117c8$export$9175ce0e1c95daf2 = 10000; // 10 seconds
const $88991a89387117c8$export$8fddcd1eff390364 = 60000; // 60 seconds
const $88991a89387117c8$export$92ed669a3d41dad3 = 600000; // 10 minutes
const $88991a89387117c8$export$6649d5c857717efe = 5000; // 5 seconds
const $88991a89387117c8$export$33e7628d3b2c0e2 = 3600000; // 60 minutes
const $88991a89387117c8$export$6f1c008dd0c3b67e = 10; // 10 milliseconds


const $08317673ed014342$export$ba118f9de1e5ac63 = new Map([
    [
        200,
        'OK'
    ],
    [
        400,
        'Bad Request'
    ],
    [
        401,
        'Unauthorized'
    ],
    [
        402,
        'Payment Required'
    ],
    [
        403,
        'Forbidden'
    ],
    [
        404,
        'Not Found'
    ],
    [
        405,
        'Method Not Allowed'
    ],
    [
        406,
        'Not Acceptable'
    ],
    [
        407,
        'Proxy Authentication Required'
    ],
    [
        408,
        'Request Timeout'
    ],
    [
        409,
        'Conflict'
    ],
    [
        410,
        'Gone'
    ],
    [
        411,
        'Length Required'
    ],
    [
        412,
        'Precondition Failed'
    ],
    [
        413,
        'Payload Too Large'
    ],
    [
        414,
        'URI Too Long'
    ],
    [
        415,
        'Unsupported Media Type'
    ],
    [
        416,
        'Requested range not satisfiable'
    ],
    [
        417,
        'Expectation Failed'
    ],
    [
        418,
        "I'm a teapot"
    ],
    [
        422,
        'Unprocessable Entity'
    ],
    [
        423,
        'Locked'
    ],
    [
        424,
        'Failed Dependency'
    ],
    [
        425,
        'Too Early'
    ],
    [
        426,
        'Upgrade Required'
    ],
    [
        428,
        'Precondition Required'
    ],
    [
        429,
        'Too Many Requests'
    ],
    [
        431,
        'Request Header Fields Too Large'
    ],
    [
        451,
        'Unavailable For Legal Reasons'
    ],
    [
        500,
        'Internal Server Error'
    ],
    [
        501,
        'Not Implemented'
    ],
    [
        502,
        'Bad Gateway'
    ],
    [
        503,
        'Service Unavailable'
    ],
    [
        504,
        'Gateway Timeout'
    ],
    [
        505,
        'HTTP Version not supported'
    ],
    [
        506,
        'Variant Also Negotiates'
    ],
    [
        507,
        'Insufficient Storage'
    ],
    [
        508,
        'Loop Detected'
    ],
    [
        509,
        'Bandwidth Limit Exceeded'
    ],
    [
        510,
        'Not Extended'
    ],
    [
        511,
        'Network Authentication Required'
    ],
    [
        -1,
        'Unknown Status'
    ]
]);



var $25nEq = parcelRequire("25nEq");

var $cvlyC = parcelRequire("cvlyC");

function $78a6f802f57c0600$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $78a6f802f57c0600$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $78a6f802f57c0600$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $78a6f802f57c0600$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
const $78a6f802f57c0600$export$8e8f0180c1b41fad = async (options)=>{
    var _createOrGetAbortCont;
    const signal = (_createOrGetAbortCont = $78a6f802f57c0600$var$createOrGetAbortController(options)) === null || _createOrGetAbortCont === void 0 ? void 0 : _createOrGetAbortCont.signal;
    const corsOptions = $78a6f802f57c0600$var$getCorsForUrl(options.url);
    const response = await fetch(options.url, $78a6f802f57c0600$var$_objectSpread({
        method: 'POST',
        // Content-type has to be text/plain in order to prevent unnecessary `OPTIONS` requests.
        headers: {
            'Content-Type': 'text/plain'
        },
        body: JSON.stringify(options.batch),
        signal: signal
    }, corsOptions));
    if (response.status === 429 || response.status >= 500 && response.status < 600) throw new (0, $3efe50d51d84d6fc$export$26e841bcf1aeb894)(`HTTP Error ${response.status} (${response.statusText})`, response.status, response.statusText);
    return response;
};
const $78a6f802f57c0600$var$createOrGetAbortController = (options)=>{
    if (options.abortController) return options.abortController;
    else if (options.timeout) {
        const abortController = new AbortController();
        // After a fetch has completed, calling abort is ignored.
        setTimeout(()=>{
            abortController.abort();
        }, options.timeout);
        return abortController;
    }
    return undefined;
};
// To ensure we always have cookies, we should check if the origins match.
// If they dont, we need to set mode to `cors` and credentials to `include`.
const $78a6f802f57c0600$var$getCorsForUrl = (0, $cvlyC.default)((url)=>{
    const origin = new URL(url).origin;
    if (origin === location.origin) return {};
    else return {
        mode: 'cors',
        credentials: 'include'
    };
});




var $eWmwA = parcelRequire("eWmwA");
let $c8b41e64c5f9315f$export$202d555a5dbfd90c = /*#__PURE__*/ function(AWCCookiesKeys) {
    AWCCookiesKeys["AWC_TLD_TEST"] = "AWC_TLD_TEST";
    AWCCookiesKeys["AWC_ANALYTICS_DEBUG"] = "AWC_ANALYTICS_DEBUG";
    AWCCookiesKeys["AJS_ANONYMOUS_ID"] = "AJS_ANONYMOUS_ID";
    return AWCCookiesKeys;
}({});
class $c8b41e64c5f9315f$var$CookieSchema {
    constructor(key, options){
        this.key = key;
        this.options = options;
    }
    getAttributes() {
        return this.options;
    }
    getKey() {
        return this.key;
    }
}
const $c8b41e64c5f9315f$var$isSecure = ()=>{
    try {
        return globalThis && globalThis.location && globalThis.location.protocol === 'https:';
    } catch (err) {
        return false;
    }
};
const $c8b41e64c5f9315f$export$d4cb17942ea57c95 = {
    [$c8b41e64c5f9315f$export$202d555a5dbfd90c.AWC_TLD_TEST]: new $c8b41e64c5f9315f$var$CookieSchema('__awc_tld_test__', {
        expires: 365,
        secure: $c8b41e64c5f9315f$var$isSecure(),
        path: '/'
    }),
    [$c8b41e64c5f9315f$export$202d555a5dbfd90c.AWC_ANALYTICS_DEBUG]: new $c8b41e64c5f9315f$var$CookieSchema('atlassian_analytics_debug', {
        expires: 365,
        secure: $c8b41e64c5f9315f$var$isSecure(),
        path: '/'
    }),
    [$c8b41e64c5f9315f$export$202d555a5dbfd90c.AJS_ANONYMOUS_ID]: new $c8b41e64c5f9315f$var$CookieSchema('ajs_anonymous_id', {
        expires: 365,
        secure: $c8b41e64c5f9315f$var$isSecure(),
        path: '/'
    })
};


var $25nEq = parcelRequire("25nEq");

var $bDLqY = parcelRequire("bDLqY");


var $25nEq = parcelRequire("25nEq");
class $ae517b47e306f68f$export$90e3e001bcac59c7 {
    constructor(){
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "_data", {});
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "length", 0);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "setItem", (key, value)=>{
            this._data[key] = value;
            this.length = Object.keys(this._data).length;
            return value;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "getItem", (key)=>{
            if (key in this._data) return this._data[key];
            return null;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "removeItem", (key)=>{
            if (key in this._data) delete this._data[key];
            this.length = Object.keys(this._data).length;
            return null;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "clear", ()=>{
            this._data = {};
            this.length = 0;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "key", (index)=>Object.keys(this._data)[index]);
    }
}
// eslint-disable-next-line import/no-anonymous-default-export
const $ae517b47e306f68f$var$inmemorystorage = new $ae517b47e306f68f$export$90e3e001bcac59c7();
var $ae517b47e306f68f$export$2e2bcd8739ae039 = $ae517b47e306f68f$var$inmemorystorage;



var $25nEq = parcelRequire("25nEq");


const $3cf59f0615ba9877$export$41c06fdd37b7e9a5 = 'awc';
const $3cf59f0615ba9877$export$770aa8bc07b3de03 = 'awcInMemoryStorageFallback';
function $3cf59f0615ba9877$export$48c17662a6902497(store) {
    const TEST_VALUE = 'test_value';
    if (!store) return false;
    try {
        const key = 'awc.storage.support';
        store.setItem(key, TEST_VALUE);
        const value = store.getItem(key);
        store.removeItem(key);
        // handle localStorage silently failing
        return value === TEST_VALUE;
    } catch (e) {
        // Can throw if localStorage is disabled
        return false;
    }
}
class $3cf59f0615ba9877$export$2e2bcd8739ae039 {
    constructor(storageToUse, options = {}){
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "getStore", ()=>this._store);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "getItem", (key)=>this._store.getItem(this.createKey(key)));
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "removeItem", (key)=>this._store.removeItem(this.createKey(key)));
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "setItem", (key, value)=>{
            try {
                this._store.setItem(this.createKey(key), value);
            } catch (err) {
                // Theoretically should only be QuotaExceededError, but keeping 'err' generic
                // https://developer.mozilla.org/en-US/docs/Web/API/Storage/setItem
                this.swapToInMemory();
                this._store.setItem(this.createKey(key), value);
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "swapToInMemory", ()=>{
            if (this._store === (0, $ae517b47e306f68f$export$2e2bcd8739ae039) || typeof globalThis === 'undefined') return;
            const keys = Object.keys(this._store || {});
            let inMemoryStorage;
            if ($3cf59f0615ba9877$export$48c17662a6902497(globalThis[$3cf59f0615ba9877$export$770aa8bc07b3de03])) inMemoryStorage = globalThis[$3cf59f0615ba9877$export$770aa8bc07b3de03];
            else {
                inMemoryStorage = (0, $ae517b47e306f68f$export$2e2bcd8739ae039);
                if (!globalThis[$3cf59f0615ba9877$export$770aa8bc07b3de03]) // If not already attached to globalThis then attach our instance of InMemoryStorage
                // We need to do this because if there are multiple instances of Analytics Client in multiple scopes,
                // there is no way to guarantee the throttling behaviour of the UI viewed event across those instances without a global singleton
                globalThis[$3cf59f0615ba9877$export$770aa8bc07b3de03] = (0, $ae517b47e306f68f$export$2e2bcd8739ae039);
            }
            keys.forEach((key)=>{
                if (key.indexOf(this.getPrefix()) === 0) {
                    const value = this._store.getItem(key);
                    if (value) inMemoryStorage.setItem(key, value);
                }
            });
            this._store = inMemoryStorage;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "clear", ()=>this._store.clear());
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "key", (index)=>this._store.key(index));
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "getPrefix", ()=>this._prefix);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "createKey", (key)=>{
            if (this._prefix) return `${this.getPrefix()}.${key}`;
            return key;
        });
        this.options = options;
        const prefixes = [];
        if (options.useStoragePrefix === undefined || options.useStoragePrefix) prefixes.push($3cf59f0615ba9877$export$41c06fdd37b7e9a5);
        if (options.envPrefix && options.envPrefix !== (0, $9c4c150c990b1f10$export$56ac8ebc9870b1b9).PROD) prefixes.push(options.envPrefix);
        this._prefix = prefixes.join('-');
        if ($3cf59f0615ba9877$export$48c17662a6902497(storageToUse)) this._store = storageToUse;
        else this.swapToInMemory();
    }
}


class $df90e90c3af4c162$export$2e2bcd8739ae039 extends (0, $3cf59f0615ba9877$export$2e2bcd8739ae039) {
    constructor(options){
        let storageToUse;
        try {
            storageToUse = globalThis.localStorage || (0, $ae517b47e306f68f$export$2e2bcd8739ae039);
        } catch (err) {
            storageToUse = (0, $ae517b47e306f68f$export$2e2bcd8739ae039);
        }
        super(storageToUse, options);
    }
}


class $99dff0dfd76e6218$export$2e2bcd8739ae039 {
    constructor(){
        this.safeStorage = new (0, $df90e90c3af4c162$export$2e2bcd8739ae039)({
            useStoragePrefix: false
        });
    }
    set(name, value) {
        this.safeStorage.setItem(name, value);
        return value;
    }
    get(name) {
        const value = this.safeStorage.getItem(name);
        return value || undefined;
    }
    remove(name) {
        this.safeStorage.removeItem(name);
    }
}



var $bDLqY = parcelRequire("bDLqY");

var $cvlyC = parcelRequire("cvlyC");

const $ea3499c14649495b$export$a9330601ee8f4d95 = (disableCookiePersistence = false)=>{
    if (disableCookiePersistence) return false;
    return !(location.protocol === 'file:' || location.protocol === 'chrome-extension:');
};
const $ea3499c14649495b$export$eb80e1beaa8dacf8 = (0, $c8b41e64c5f9315f$export$d4cb17942ea57c95).AWC_TLD_TEST.getKey();
const $ea3499c14649495b$export$19164982d36535d8 = 'tld_test';
const $ea3499c14649495b$export$de6821eed3d5f32d = (0, $cvlyC.default)(()=>{
    if (typeof location === 'undefined') return '';
    const { hostname: hostname } = location;
    const splitHostname = hostname.split('.');
    for(let i = 1; i <= splitHostname.length; i++){
        const domainParts = splitHostname.slice(i * -1);
        const domain = `.${domainParts.join('.')}`;
        (0, (/*@__PURE__*/$parcel$interopDefault($bDLqY))).set($ea3499c14649495b$export$eb80e1beaa8dacf8, $ea3499c14649495b$export$19164982d36535d8, {
            domain: domain
        });
        if ((0, (/*@__PURE__*/$parcel$interopDefault($bDLqY))).get($ea3499c14649495b$export$eb80e1beaa8dacf8) === $ea3499c14649495b$export$19164982d36535d8) {
            (0, (/*@__PURE__*/$parcel$interopDefault($bDLqY))).remove($ea3499c14649495b$export$eb80e1beaa8dacf8, {
                domain: domain
            });
            return domain;
        }
    }
    return hostname;
});


function $f22f007bc4ca3f5c$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $f22f007bc4ca3f5c$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $f22f007bc4ca3f5c$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $f22f007bc4ca3f5c$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
class $f22f007bc4ca3f5c$export$2e2bcd8739ae039 {
    constructor(disableCookiePersistence){
        this.cookieLike = (0, $ea3499c14649495b$export$a9330601ee8f4d95)(disableCookiePersistence) ? (0, (/*@__PURE__*/$parcel$interopDefault($bDLqY))) : new (0, $99dff0dfd76e6218$export$2e2bcd8739ae039)();
    }
    set(name, value, options) {
        // no-op
        if (!(0, $c8b41e64c5f9315f$export$d4cb17942ea57c95)[name]) {
            // eslint-disable-next-line no-console
            console.warn(`Unknown cookie key ${name} provided, not set.`);
            return;
        }
        return this.cookieLike.set((0, $c8b41e64c5f9315f$export$d4cb17942ea57c95)[name].getKey(), value, $f22f007bc4ca3f5c$var$_objectSpread($f22f007bc4ca3f5c$var$_objectSpread({}, (0, $c8b41e64c5f9315f$export$d4cb17942ea57c95)[name].getAttributes()), {}, {
            // Function is memoized so we only calculate this once per page load
            domain: (0, $ea3499c14649495b$export$de6821eed3d5f32d)()
        }, options));
    }
    get(name) {
        if (!(0, $c8b41e64c5f9315f$export$d4cb17942ea57c95)[name]) {
            // eslint-disable-next-line no-console
            console.warn(`Unknown cookie key ${name} provided, not fetched.`);
            return;
        }
        return this.cookieLike.get((0, $c8b41e64c5f9315f$export$d4cb17942ea57c95)[name].getKey());
    }
    remove(name, options) {
        if (!(0, $c8b41e64c5f9315f$export$d4cb17942ea57c95)[name]) {
            // eslint-disable-next-line no-console
            console.warn(`Unknown cookie key ${name} provided, not removed.`);
            return;
        }
        this.cookieLike.remove((0, $c8b41e64c5f9315f$export$d4cb17942ea57c95)[name].getKey(), $f22f007bc4ca3f5c$var$_objectSpread({}, options));
    }
}




// Cookie is stale, if anonymousId was generated 7 days ago.
const $f7e4a1cbd6920661$var$ANONYMOUS_ID_COOKIE_STALE_DAYS = 7;
const $f7e4a1cbd6920661$var$SAFE = 'SAFE';
const $f7e4a1cbd6920661$var$UNSAFE = 'UNSAFE';
const $f7e4a1cbd6920661$var$NOT_FOUND = 'NOT_FOUND';
const $f7e4a1cbd6920661$var$COOKIE = 'COOKIE';
const $f7e4a1cbd6920661$var$LOCAL_STORAGE = 'LOCAL_STORAGE';
class $f7e4a1cbd6920661$export$2e2bcd8739ae039 {
    constructor(disableCookiePersistence){
        this.store = new (0, $df90e90c3af4c162$export$2e2bcd8739ae039)({
            useStoragePrefix: false
        });
        this.cookie = new (0, $f22f007bc4ca3f5c$export$2e2bcd8739ae039)(disableCookiePersistence);
    }
    getUserId() {
        return this.userId || null;
    }
    setUserId(userId) {
        this.userId = userId;
    }
    getAnonymousId(customAnonymousIdGenerator) {
        /**
     * Prefer localStorage as there cant be duplicate keys, and its faster. Also update cookie, if stale.
     * If not set in localStorage, check cookies. Also set localStorage for future attempts.
     * If not in cookies, generate a new one. Set both cookie and localStorage keys.
     */ return this.getAnonymousIdFromLocalStorageAndUpdateCookieIfStale() || this.getAnonymousIdFromCookieAndUpdateLocalStorage() || this.generateNewAnonymousId(customAnonymousIdGenerator);
    }
    setAnonymousId(anonymousId) {
        const stringifyAnonymosId = JSON.stringify(anonymousId);
        this.cookie.set((0, $c8b41e64c5f9315f$export$202d555a5dbfd90c).AJS_ANONYMOUS_ID, stringifyAnonymosId);
        this.lastAnonymousIdCookieUpdate = Date.now();
        return this.store.setItem((0, $c8b41e64c5f9315f$export$d4cb17942ea57c95).AJS_ANONYMOUS_ID.getKey(), stringifyAnonymosId);
    }
    getAnonymousIdFromStorage(source) {
        const rawStorageAnonidValue = source === $f7e4a1cbd6920661$var$LOCAL_STORAGE ? this.store.getItem((0, $c8b41e64c5f9315f$export$d4cb17942ea57c95).AJS_ANONYMOUS_ID.getKey()) : this.cookie.get((0, $c8b41e64c5f9315f$export$202d555a5dbfd90c).AJS_ANONYMOUS_ID);
        if (rawStorageAnonidValue) {
            const unsafeValue = {
                type: $f7e4a1cbd6920661$var$UNSAFE,
                anonymousId: rawStorageAnonidValue
            };
            try {
                const parsedAnonId = JSON.parse(rawStorageAnonidValue);
                if (parsedAnonId && typeof parsedAnonId === 'string') return {
                    type: $f7e4a1cbd6920661$var$SAFE,
                    anonymousId: parsedAnonId
                };
                return unsafeValue;
            } catch (_unused) {
                /*
         * Segments new Analytics-next client will store strings as strings without stringifing.
         * The legacy Segment client and AWC always stringify and parse cookies and values.
         * If the new Segment analytics-client stores a cookie and local storage value first, it will
         * breaking old clients.
         *
         * Additionally, JSON.parse can cause exceptions to be thrown in some browsers; see AAP-324.
         *
         * Intentionally swalling errors here and returning the original value found in storage to avoid ping-pong.
         */ return unsafeValue;
            }
        }
        return {
            type: $f7e4a1cbd6920661$var$NOT_FOUND
        };
    }
    getAnonymousIdFromLocalStorageAndUpdateCookieIfStale() {
        const localStorageValue = this.getAnonymousIdFromStorage($f7e4a1cbd6920661$var$LOCAL_STORAGE);
        let shouldUpdateCookie = false;
        if (!this.lastAnonymousIdCookieUpdate || (0, $eWmwA.default)(new Date(), new Date(this.lastAnonymousIdCookieUpdate)) >= $f7e4a1cbd6920661$var$ANONYMOUS_ID_COOKIE_STALE_DAYS) shouldUpdateCookie = true;
        switch(localStorageValue.type){
            case $f7e4a1cbd6920661$var$SAFE:
                if (shouldUpdateCookie) this.setAnonymousId(localStorageValue.anonymousId);
                return localStorageValue.anonymousId;
            case $f7e4a1cbd6920661$var$UNSAFE:
                return localStorageValue.anonymousId;
            case $f7e4a1cbd6920661$var$NOT_FOUND:
            default:
                return null;
        }
    }
    getAnonymousIdFromCookieAndUpdateLocalStorage() {
        const cookieValue = this.getAnonymousIdFromStorage($f7e4a1cbd6920661$var$COOKIE);
        switch(cookieValue.type){
            case $f7e4a1cbd6920661$var$SAFE:
            case $f7e4a1cbd6920661$var$UNSAFE:
                this.store.setItem((0, $c8b41e64c5f9315f$export$d4cb17942ea57c95).AJS_ANONYMOUS_ID.getKey(), JSON.stringify(cookieValue.anonymousId));
                return cookieValue.anonymousId;
            case $f7e4a1cbd6920661$var$NOT_FOUND:
            default:
                return null;
        }
    }
    generateNewAnonymousId(customAnonymousIdGenerator) {
        const generator = typeof customAnonymousIdGenerator === 'function' ? customAnonymousIdGenerator : ()=>{
            return (0, $16f8259e8856e670$export$2e2bcd8739ae039)();
        };
        const newAnonId = generator();
        this.setAnonymousId(newAnonId);
        return newAnonId;
    }
}



var $25nEq = parcelRequire("25nEq");

var $dMCb6 = parcelRequire("dMCb6");
function $3a338cf2d1e795da$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $3a338cf2d1e795da$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $3a338cf2d1e795da$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $3a338cf2d1e795da$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
const $3a338cf2d1e795da$export$3a7fe28f9bf4f3d9 = (context)=>{
    return $3a338cf2d1e795da$var$_objectSpread($3a338cf2d1e795da$var$_objectSpread({}, context.context), {}, {
        userAgent: navigator.userAgent
    });
};
const $3a338cf2d1e795da$export$44d22e5fb02cc68e = (properties)=>{
    const propertiesWithoutUndefined = $3a338cf2d1e795da$var$nestedRemoveUndefinedValues(properties, '$.properties');
    return (0, (/*@__PURE__*/$parcel$interopDefault($dMCb6)))(propertiesWithoutUndefined);
};
// This function will essentially deepClone as well
const $3a338cf2d1e795da$var$nestedRemoveUndefinedValues = (obj, path)=>{
    const recursionDepthLimit = 512;
    const nestedRemoveUndefinedValuesImpl = (source, processedReferences, path, depth)=>{
        if (source === null || typeof source !== 'object') return source;
        // If the level of nesting is egregiously excessive we'll stop processing any further to
        // avoid crashing due to stack exhaustion, instead we return a note object.
        if (depth > recursionDepthLimit) return {
            _depthLimitExceeded: true,
            message: `Object nesting depth limit exceeded at path '${path}' with depth '${depth}'`
        };
        // If this object has already been seen then processing it would create a circular reference,
        // instead we return a note object.
        if (processedReferences.has(source)) {
            const originalPath = processedReferences.get(source);
            return {
                _circularReference: true,
                message: `Circular reference to object at original path '${originalPath}' detected at path '${path}'`,
                originalPath: originalPath
            };
        }
        processedReferences.set(source, path);
        const clone = {};
        Object.keys(source).forEach((key)=>{
            const value = source[key];
            if (value !== undefined) {
                if (Array.isArray(value)) {
                    const newArray = [];
                    value.forEach((v, i)=>{
                        const newValue = nestedRemoveUndefinedValuesImpl(v, processedReferences, `${path}.${key}[${i}]`, depth + 1);
                        if (newValue !== undefined) newArray.push(newValue);
                    });
                    clone[key] = newArray;
                } else {
                    const newValue = nestedRemoveUndefinedValuesImpl(value, processedReferences, `${path}.${key}`, depth + 1);
                    if (newValue !== undefined) clone[key] = newValue;
                }
            }
        });
        processedReferences.delete(source);
        return clone;
    };
    return nestedRemoveUndefinedValuesImpl(obj, new Map(), path, 0);
};


function $703a7f160fd6ee7a$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $703a7f160fd6ee7a$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $703a7f160fd6ee7a$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $703a7f160fd6ee7a$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
class $703a7f160fd6ee7a$var$AnalyticsAPIResponse {
    constructor(success, validationErrors, message, code, validationReports){
        this.success = success;
        this.validationErrors = validationErrors;
        this.message = message;
        this.code = code;
        this.validationReports = validationReports;
    }
    isSuccess() {
        return this.success;
    }
    getValidationErrors() {
        return this.validationErrors;
    }
    getMessage() {
        return this.message;
    }
    getCode() {
        return this.code;
    }
    getValidationReports() {
        return this.validationReports === undefined ? null : this.validationReports;
    }
}
class $703a7f160fd6ee7a$var$Message {
    constructor(error){
        this.error = error;
    }
}
class $703a7f160fd6ee7a$var$EventValidationReport {
    constructor(messageId, results){
        this.messageId = messageId;
        this.results = results;
    }
    getMessageId() {
        return this.messageId;
    }
    getResults() {
        return this.results;
    }
}
class $703a7f160fd6ee7a$export$133650fcdde1b226 {
    constructor(success, statusCode, message, eventResponseList){
        this.success = success;
        this.statusCode = statusCode;
        this.message = message;
        this.eventResponseList = eventResponseList;
    }
    isSuccess() {
        return this.success;
    }
    getStatusCode() {
        return this.statusCode;
    }
    getMessage() {
        return this.message;
    }
    getEventResponseList() {
        return this.eventResponseList;
    }
}
class $703a7f160fd6ee7a$var$EventResponse {
    constructor(messageId, results, segmentEvent){
        this.messageId = messageId;
        this.results = results;
        this.segmentEvent = segmentEvent;
    }
    getMessageId() {
        return this.messageId;
    }
    getResults() {
        return this.results;
    }
    getSegmentEvent() {
        return this.segmentEvent;
    }
}
class $703a7f160fd6ee7a$var$EventValidationResult {
    constructor(type, severity, propertyPath, message){
        this.type = type;
        this.severity = severity;
        this.propertyPath = propertyPath;
        this.message = message;
    }
    getType() {
        return this.type;
    }
    getSeverity() {
        return this.severity;
    }
    getPropertyPath() {
        return this.propertyPath;
    }
    getMessage() {
        return this.message;
    }
}
class $703a7f160fd6ee7a$export$2e2bcd8739ae039 {
    constructor(options){
        var _this$options;
        // Using anonymous function so it can have the BatchFlushCallback type associated with it
        // And to allow it to not need bind when passing through to ResilieceQueue.
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "sendEvents", async (items, callback)=>{
            var _this$lastSendEventsE, _this$metadataClient;
            if (this.options.enableEventCalls === false) return;
            const httpRetryCount = this.resilienceQueue.getGlobalRetryCount();
            const metricsPayload = this.metrics.getMetricsPayload();
            const eventsWithXID = await this.attachXIDs(items);
            // Calculating sentAt after the XID generation as this may take some time.
            const sentAt = new Date().toISOString();
            const metadataInfo = await this.metadataClient.getMetadataAsync();
            const [eventUrl, isFallbackUrl] = this.getEventUrl(metadataInfo);
            const metadata = $703a7f160fd6ee7a$var$_objectSpread($703a7f160fd6ee7a$var$_objectSpread({}, metricsPayload), {}, {
                httpRetryCount: httpRetryCount,
                lastSendEventsErrorReason: ((_this$lastSendEventsE = this.lastSendEventsError) === null || _this$lastSendEventsE === void 0 ? void 0 : _this$lastSendEventsE.message) || null,
                // Temporary back-compat
                lastSendEventsError: this.lastSendEventsError,
                lastUrlFallbackError: this.lastUrlFallbackError,
                isUsingFallbackUrl: isFallbackUrl,
                props: (metadataInfo === null || metadataInfo === void 0 ? void 0 : metadataInfo.props) || null,
                metadataClientMetrics: ((_this$metadataClient = this.metadataClient) === null || _this$metadataClient === void 0 ? void 0 : _this$metadataClient.metrics) || null
            });
            // Remove default values from metadata to save space
            this.cleanLibraryMetadata(metadata);
            const unpackagedEvents = eventsWithXID.map((item)=>{
                item.msg.sentAt = sentAt;
                return item.msg;
            });
            const batchBody = {
                batch: unpackagedEvents,
                sentAt: sentAt,
                metadata: metadata
            };
            try {
                const response = await (0, $78a6f802f57c0600$export$8e8f0180c1b41fad)({
                    url: eventUrl,
                    batch: batchBody,
                    timeout: this.options.requestTimeout
                });
                this.lastSendEventsError = null;
                this.lastUrlFallbackError = null;
                this.metrics.subtractFromMetrics(metricsPayload);
                callback(null, response);
                await this.invokeLocalResponseCallbackAsync(items, response, null);
            } catch (error) {
                // If there's an error, other than one which indicates a temporary problem with the service,
                // we'll stop using the URL from the metadata and fall back to the default URL. After a time
                // we'll fall forward again in case the problem has been resolved.
                if (error instanceof (0, $3efe50d51d84d6fc$export$26e841bcf1aeb894) && [
                    429,
                    503
                ].includes(error.statusCode)) // Ignore 429 and 503 errors since they're considered to indicate a temporary
                // issue with the service, rather than a network failure due to blocked requests.
                this.lastSendEventsError = new (0, $3efe50d51d84d6fc$export$a63e16b3351b8c36)('ServerBusyError', error);
                else {
                    const errorName = error instanceof Error && (0, $3efe50d51d84d6fc$export$96f086dcf574a9e2).includes(error.name) ? error.name : 'Unknown';
                    this.lastSendEventsError = new (0, $3efe50d51d84d6fc$export$a63e16b3351b8c36)(errorName, error);
                    // Handle falling back to the default URL if we're using the metadata URL.
                    this.useUrlFromMetadata = false;
                    // If we're now using the fallback URL, and the last attempt wasn't,
                    // we'll record this as the error that triggered the fallback.
                    const [_, willUseFallbackUrl] = this.getEventUrl(metadataInfo);
                    if (willUseFallbackUrl && willUseFallbackUrl !== isFallbackUrl) this.lastUrlFallbackError = this.lastSendEventsError;
                }
                callback(error, null);
                await this.invokeLocalResponseCallbackAsync(items, null, error);
            }
        });
        this.options = $703a7f160fd6ee7a$var$_objectSpread($703a7f160fd6ee7a$var$_objectSpread({}, options), {}, {
            requestTimeout: options.requestTimeout || (0, $88991a89387117c8$export$9175ce0e1c95daf2),
            retryQueueOptions: options.retryQueueOptions || {},
            logger: options.logger || console,
            disableCookiePersistence: options.disableCookiePersistence || false,
            env: options.env,
            perimeter: options.perimeter || '',
            enableMetadataCalls: typeof options.enableMetadataCalls === 'boolean' ? options.enableMetadataCalls : true,
            enableEventCalls: typeof options.enableEventCalls === 'boolean' ? options.enableEventCalls : true
        });
        this.user = new (0, $f7e4a1cbd6920661$export$2e2bcd8739ae039)((_this$options = this.options) === null || _this$options === void 0 ? void 0 : _this$options.disableCookiePersistence);
        this.xidPromiseCallback = options.xidPromiseGetter();
        this.gasv3BatchUrl = `${options.apiHostProtocol}://${options.apiHost}/batch`;
        this.metrics = (0, $02d51d0ac0f3eacd$export$2e2bcd8739ae039)();
        this.responseCallback = options.responseCallback;
        this.resilienceQueue = (0, $9009c8d029fe1a5f$export$2e2bcd8739ae039)(options.retryQueuePrefix, options.product, this.options.retryQueueOptions, this.options.logger);
        this.metadataClient = options.metadataClient;
        this.useUrlFromMetadata = true;
        this.lastSendEventsError = null;
        this.lastUrlFallbackError = null;
        setInterval(()=>{
            this.useUrlFromMetadata = true;
        }, 600000);
        this.resilienceQueue.start(this.sendEvents);
    }
    getUser() {
        return this.user;
    }
    async track(eventName, builtEvent, context, callback) {
        const baseEvent = this.buildBaseEvent(context, (0, $3efe50d51d84d6fc$export$ddf929981dc6feb3).TRACK, builtEvent);
        const eventWithoutMessageId = $703a7f160fd6ee7a$var$_objectSpread($703a7f160fd6ee7a$var$_objectSpread({}, baseEvent), {}, {
            type: (0, $3efe50d51d84d6fc$export$ddf929981dc6feb3).TRACK,
            properties: (0, $3a338cf2d1e795da$export$44d22e5fb02cc68e)(builtEvent),
            event: eventName
        });
        const event = $703a7f160fd6ee7a$var$_objectSpread($703a7f160fd6ee7a$var$_objectSpread({}, eventWithoutMessageId), {}, {
            messageId: this.createMessageId()
        });
        const packagedEvent = this.packageEvent(event);
        await this.enqueueEvent(packagedEvent);
        if (callback) callback();
    }
    async page(eventName, builtEvent, context, callback) {
        const baseEvent = this.buildBaseEvent(context, (0, $3efe50d51d84d6fc$export$ddf929981dc6feb3).PAGE, builtEvent);
        const eventWithoutMessageId = $703a7f160fd6ee7a$var$_objectSpread($703a7f160fd6ee7a$var$_objectSpread({}, baseEvent), {}, {
            type: (0, $3efe50d51d84d6fc$export$ddf929981dc6feb3).PAGE,
            properties: (0, $3a338cf2d1e795da$export$44d22e5fb02cc68e)(builtEvent),
            name: eventName
        });
        const event = $703a7f160fd6ee7a$var$_objectSpread($703a7f160fd6ee7a$var$_objectSpread({}, eventWithoutMessageId), {}, {
            messageId: this.createMessageId()
        });
        const packagedEvent = this.packageEvent(event);
        await this.enqueueEvent(packagedEvent);
        if (callback) callback();
    }
    // Segment uses the identifier to update user id which we have already done in the analyticsWebClient.ts
    async identify(_identifier, builtEvent, context, callback) {
        const baseEvent = this.buildBaseEvent(context, (0, $3efe50d51d84d6fc$export$ddf929981dc6feb3).IDENTIFY, builtEvent);
        const eventWithoutMessageId = $703a7f160fd6ee7a$var$_objectSpread($703a7f160fd6ee7a$var$_objectSpread({}, baseEvent), {}, {
            type: (0, $3efe50d51d84d6fc$export$ddf929981dc6feb3).IDENTIFY,
            traits: (0, $3a338cf2d1e795da$export$44d22e5fb02cc68e)(builtEvent)
        });
        const event = $703a7f160fd6ee7a$var$_objectSpread($703a7f160fd6ee7a$var$_objectSpread({}, eventWithoutMessageId), {}, {
            messageId: this.createMessageId()
        });
        const packagedEvent = this.packageEvent(event);
        await this.enqueueEvent(packagedEvent);
        if (callback) callback();
    }
    async enqueueEvent(packagedEvent) {
        if (this.options.enableMetadataCalls) this.metadataClient.start(false); // Start the metadata client if needed
        await this.resilienceQueue.addItem(packagedEvent);
    }
    buildBaseEvent(context, type, overrides) {
        const clonedContext = (0, $3a338cf2d1e795da$export$44d22e5fb02cc68e)(context);
        const segmentContext = (0, $3a338cf2d1e795da$export$3a7fe28f9bf4f3d9)(clonedContext);
        return {
            context: segmentContext,
            timestamp: new Date().toISOString(),
            type: type,
            userId: this.user.getUserId(),
            anonymousId: overrides.anonymousId || this.user.getAnonymousId()
        };
    }
    createMessageId() {
        return `ajs-${(0, $16f8259e8856e670$export$2e2bcd8739ae039)()}`;
    }
    packageEvent(event) {
        const { apiHost: apiHost, apiHostProtocol: apiHostProtocol } = this.options;
        return {
            headers: {
                'Content-Type': 'text/plain'
            },
            msg: event,
            url: `${apiHostProtocol}://${apiHost}/${event.type.charAt(0)}`
        };
    }
    getEventUrl(metadataInfo) {
        const preferredBatchUrl = metadataInfo !== null && metadataInfo !== void 0 && metadataInfo.url ? metadataInfo.url : this.gasv3BatchUrl;
        const finalBatchUrl = this.useUrlFromMetadata ? preferredBatchUrl : this.gasv3BatchUrl;
        const isFallbackUrl = preferredBatchUrl === this.gasv3BatchUrl ? null : finalBatchUrl !== preferredBatchUrl;
        return [
            finalBatchUrl,
            isFallbackUrl
        ];
    }
    cleanLibraryMetadata(obj) {
        // skip if the parameter is not an object
        if (obj === null || typeof obj !== 'object') return;
        for(const key in obj){
            // Skip cleaning up props object and its keys
            // to avoid having to check the existence of the fields in props object
            // and manipulate them to calculate metadata signature in analytics service
            if (key === 'props') continue;
            let value = obj[key];
            // Remove null or undefined values
            if (value === null || value === undefined) delete obj[key];
            else if (typeof value === 'number' && value === 0) delete obj[key];
            else if (Array.isArray(value)) {
                if (value.length === 0) delete obj[key];
                else value.forEach((item)=>{
                    this.cleanLibraryMetadata(item);
                });
            } else if (typeof value === 'object') this.cleanLibraryMetadata(obj[key]);
        }
    }
    async invokeLocalResponseCallbackAsync(items, response, error) {
        const localResponseCallback = this.responseCallback;
        if (localResponseCallback) {
            // If we have a response, we'll parse it and create an AnalyticsAPIResponse from it.
            let analyticsAPIResponse = null;
            if (response) {
                var _responseObject$messa;
                let responseObject;
                try {
                    responseObject = await response.clone().json();
                } catch (_unused) {
                // Ignore errors parsing the response, we can't do anything about them
                }
                // Ensure we've got a valid object to work with, filling in any missing
                // properties as best we can.
                responseObject = responseObject || {};
                responseObject.code = Number.parseInt(responseObject.code) > 0 ? Number.parseInt(responseObject.code) : response.status;
                responseObject.success = responseObject.success || responseObject.code >= 200 && responseObject.code <= 299;
                analyticsAPIResponse = new $703a7f160fd6ee7a$var$AnalyticsAPIResponse(responseObject.success, responseObject.validationErrors || new Map(), new $703a7f160fd6ee7a$var$Message(((_responseObject$messa = responseObject.message) === null || _responseObject$messa === void 0 ? void 0 : _responseObject$messa.error) || ''), responseObject.code, responseObject.validationReports || null);
            }
            // If we have an error, but it's not an instance of Error (e.g. it's a string), we'll convert it to an Error object.
            if (error && !(error instanceof Error)) error = new Error(String(error));
            const analyticsResponse = $703a7f160fd6ee7a$var$BatchInterceptor.toAnalyticsResponse(items || [], error || null, // In case 'error' were to be undefined we'll convert it to null.
            analyticsAPIResponse);
            localResponseCallback(analyticsResponse);
        }
    }
    async attachXIDs(items) {
        if (this.xidPromiseCallback) return (0, $7ec5b9481a262e12$export$c21270cab66ab290)(items, this.xidPromiseCallback);
        return Promise.resolve(items);
    }
    setResponseCallback(responseCallback) {
        this.responseCallback = responseCallback;
    }
    refreshMetadata(userInfo, tenantInfo) {
        this.metadataClient.userInfo = userInfo;
        this.metadataClient.tenantInfo = tenantInfo;
    }
}
class $703a7f160fd6ee7a$var$BatchInterceptor {
    static toAnalyticsResponse(items, error, analyticsAPIResponse) {
        const eventResponseList = [];
        if (analyticsAPIResponse !== null) {
            const [statusCode, success] = [
                analyticsAPIResponse.code,
                analyticsAPIResponse.success
            ];
            if (statusCode >= 200 && statusCode <= 299) {
                var _analyticsAPIResponse;
                (_analyticsAPIResponse = analyticsAPIResponse.validationReports) === null || _analyticsAPIResponse === void 0 || _analyticsAPIResponse.forEach((report)=>{
                    const matchedEvent = items.find((item)=>item.msg.messageId === report.messageId);
                    if (matchedEvent) eventResponseList.push(new $703a7f160fd6ee7a$var$EventResponse(matchedEvent.msg.messageId, report.results, matchedEvent.msg));
                });
                return new $703a7f160fd6ee7a$export$133650fcdde1b226(success, statusCode, (0, $08317673ed014342$export$ba118f9de1e5ac63).get(statusCode), eventResponseList);
            } else if (statusCode >= 400 && statusCode <= 499) {
                var _analyticsAPIResponse2;
                // not exluding "HTTP 429 Too Many Requests error" as it is thrown as an error and handled below
                const errorMessage = ((_analyticsAPIResponse2 = analyticsAPIResponse.message) === null || _analyticsAPIResponse2 === void 0 ? void 0 : _analyticsAPIResponse2.error) !== null ? analyticsAPIResponse.message.error : (0, $08317673ed014342$export$ba118f9de1e5ac63).has(statusCode) ? (0, $08317673ed014342$export$ba118f9de1e5ac63).get(statusCode) : (0, $08317673ed014342$export$ba118f9de1e5ac63).get(-1);
                items.forEach((item)=>{
                    eventResponseList.push(new $703a7f160fd6ee7a$var$EventResponse(item.msg.messageId, [], item.msg));
                });
                return new $703a7f160fd6ee7a$export$133650fcdde1b226(success, statusCode, errorMessage, eventResponseList);
            }
        } else if (error !== null && error !== void 0 && error.message) {
            const match = error.message.match($703a7f160fd6ee7a$var$BatchInterceptor.http_error_regex);
            if (match) {
                items.forEach((item)=>{
                    eventResponseList.push(new $703a7f160fd6ee7a$var$EventResponse(item.msg.messageId, [], item.msg));
                });
                return new $703a7f160fd6ee7a$export$133650fcdde1b226(false, Number(match[1]), match[2], eventResponseList);
            }
        }
        items.forEach((item)=>{
            eventResponseList.push(new $703a7f160fd6ee7a$var$EventResponse(item.msg.messageId, [], item.msg));
        });
        return new $703a7f160fd6ee7a$export$133650fcdde1b226(false, -1, (0, $08317673ed014342$export$ba118f9de1e5ac63).get(-1), eventResponseList);
    }
}
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($703a7f160fd6ee7a$var$BatchInterceptor, "http_error_regex", /HTTP Error\s([0-9]{3})\s\((.+)\)/);



var $25nEq = parcelRequire("25nEq");





const $f9df0b541c3a14c4$var$PROD_HOST = 'as.atlassian.com/api/v1';
const $f9df0b541c3a14c4$var$STARGATE_PROD_HOST = 'api-private.atlassian.com/gasv3/api/v1';
const $f9df0b541c3a14c4$var$STAGING_HOST = 'as.staging.atl-paas.net/api/v1';
const $f9df0b541c3a14c4$var$STARGATE_STAGING_HOST = 'api-private.stg.atlassian.com/gasv3/api/v1';
const $f9df0b541c3a14c4$var$FEDRAMP_STAGING_HOST = 'as.staging.atl-paas-us-gov-mod.net/api/v1';
const $f9df0b541c3a14c4$var$FEDRAMP_PROD_HOST = 'as.atlassian-us-gov-mod.com/api/v1';
const $f9df0b541c3a14c4$var$STARGATE_FEDRAMP_STAGING_HOST = 'api.stg.atlassian-us-gov-mod.com/gasv3/api/v1';
const $f9df0b541c3a14c4$var$STARGATE_FEDRAMP_PROD_HOST = 'api.atlassian-us-gov-mod.com/gasv3/api/v1';
const $f9df0b541c3a14c4$var$STARGATE_PROXY_PATH = '/gateway/api/gasv3/api/v1';
const $f9df0b541c3a14c4$var$handleFedRampModerate = ({ useStargate: useStargate, env: env, useLegacyUrl: useLegacyUrl, envOverride: envOverride })=>{
    if (env === (0, $9c4c150c990b1f10$export$56ac8ebc9870b1b9).LOCAL || env === (0, $9c4c150c990b1f10$export$56ac8ebc9870b1b9).DEV) throw Error('No LOCAL or DEV environments for FedRAMP.');
    if (env === (0, $9c4c150c990b1f10$export$56ac8ebc9870b1b9).PROD && envOverride) throw Error('Cannot override to FedRAMP Sandbox for Prod.');
    if (!useStargate) return env === (0, $9c4c150c990b1f10$export$56ac8ebc9870b1b9).PROD ? $f9df0b541c3a14c4$var$FEDRAMP_PROD_HOST : $f9df0b541c3a14c4$var$FEDRAMP_STAGING_HOST;
    if (useLegacyUrl) return env === (0, $9c4c150c990b1f10$export$56ac8ebc9870b1b9).PROD ? $f9df0b541c3a14c4$var$STARGATE_FEDRAMP_PROD_HOST : $f9df0b541c3a14c4$var$STARGATE_FEDRAMP_STAGING_HOST;
    /**
   * Stargate proxy path now needs to be the default to work around browser restrictions with cookies.
   * For more details, see:
   *  - https://experimentation-platform.atlassian.net/browse/MHD-326, and
   *  - https://hello.atlassian.net/wiki/spaces/I/pages/1217206437/api-private+is+broken+is+your+product+impacted
   */ return window.location.host + $f9df0b541c3a14c4$var$STARGATE_PROXY_PATH;
};
const $f9df0b541c3a14c4$var$handleCommercial = ({ useStargate: useStargate, env: env, useLegacyUrl: useLegacyUrl })=>{
    if (!useStargate) return env === (0, $9c4c150c990b1f10$export$56ac8ebc9870b1b9).PROD ? $f9df0b541c3a14c4$var$PROD_HOST : $f9df0b541c3a14c4$var$STAGING_HOST;
    if (useLegacyUrl) return env === (0, $9c4c150c990b1f10$export$56ac8ebc9870b1b9).PROD ? $f9df0b541c3a14c4$var$STARGATE_PROD_HOST : $f9df0b541c3a14c4$var$STARGATE_STAGING_HOST;
    /**
   * Stargate proxy path now needs to be the default to work around browser restrictions with cookies.
   * For more details, see:
   *  - https://experimentation-platform.atlassian.net/browse/MHD-326, and
   *  - https://hello.atlassian.net/wiki/spaces/I/pages/1217206437/api-private+is+broken+is+your+product+impacted
   */ return window.location.host + $f9df0b541c3a14c4$var$STARGATE_PROXY_PATH;
};
function $f9df0b541c3a14c4$export$18c0b81944902eae({ useStargate: useStargate, env: env, useLegacyUrl: useLegacyUrl, perimeter: perimeter, ic: ic, envOverride: envOverride }) {
    if (ic) {
        if (useLegacyUrl) throw Error('IC is set but useLegacyUrl is true.');
        throw Error('IC is set but no apiHost provided.');
    }
    if (perimeter === (0, $9c4c150c990b1f10$export$bdd41749d2096e4b).FEDRAMP_MODERATE) return $f9df0b541c3a14c4$var$handleFedRampModerate({
        useStargate: useStargate,
        env: env,
        useLegacyUrl: useLegacyUrl,
        envOverride: envOverride
    });
    return $f9df0b541c3a14c4$var$handleCommercial({
        useStargate: useStargate,
        env: env,
        useLegacyUrl: useLegacyUrl
    });
}
function $f9df0b541c3a14c4$export$83a9dd8d74be72c({ apiHost: apiHost }) {
    return apiHost === window.location.host + $f9df0b541c3a14c4$var$STARGATE_PROXY_PATH;
}



var $25nEq = parcelRequire("25nEq");
class $edecb1e04eb94083$export$44b578549c42d779 {
    static isGeminiVREnvironment() {
        try {
            for(const k in globalThis){
                if (k.startsWith('__gemini_') && k.endsWith('__')) return true;
            }
        } catch (e) {
        // ignore
        }
        return false;
    }
    static areMetadataCallsDisabled() {
        return this.areFetchCallsDisabled() || this.getGlobalBooleanProperty($edecb1e04eb94083$export$44b578549c42d779.DISABLE_METADATA_CALLS_PROPERTY);
    }
    static areEventCallsDisabled() {
        return this.areFetchCallsDisabled() || this.getGlobalBooleanProperty($edecb1e04eb94083$export$44b578549c42d779.DISABLE_EVENT_CALLS_PROPERTY);
    }
    static areFetchCallsDisabled() {
        return this.getGlobalBooleanProperty($edecb1e04eb94083$export$44b578549c42d779.DISABLE_FETCH_CALLS_PROPERTY);
    }
    static getSyntheticFlagOverride() {
        return this.getGlobalTriStateProperty($edecb1e04eb94083$export$44b578549c42d779.SYNTHETIC_FLAG_OVERRIDE_PROPERTY);
    }
    static getGlobalBooleanProperty(propertyName) {
        if (globalThis && globalThis.hasOwnProperty(propertyName)) return globalThis[propertyName] === true;
        return false;
    }
    static getGlobalTriStateProperty(propertyName) {
        if (globalThis && globalThis.hasOwnProperty(propertyName)) {
            const value = globalThis[propertyName];
            if (typeof value === 'boolean') return value;
        }
        return undefined;
    }
}
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($edecb1e04eb94083$export$44b578549c42d779, "DISABLE_METADATA_CALLS_PROPERTY", '__awc_disable_metadata_calls__');
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($edecb1e04eb94083$export$44b578549c42d779, "DISABLE_EVENT_CALLS_PROPERTY", '__awc_disable_event_calls__');
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($edecb1e04eb94083$export$44b578549c42d779, "DISABLE_FETCH_CALLS_PROPERTY", '__awc_disable_fetch_calls__');
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($edecb1e04eb94083$export$44b578549c42d779, "SYNTHETIC_FLAG_OVERRIDE_PROPERTY", '__awc_synthetic_flag_override__');




var $25nEq = parcelRequire("25nEq");

var $cvlyC = parcelRequire("cvlyC");

function $2bd4f4c8b23cd51e$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $2bd4f4c8b23cd51e$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $2bd4f4c8b23cd51e$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $2bd4f4c8b23cd51e$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
const $2bd4f4c8b23cd51e$export$55b0d0261469055 = async (url, params, timeout, signal)=>{
    var _params$userInfo, _params$userInfo2, _params$tenantInfo, _params$tenantInfo2;
    const requestAbortController = $2bd4f4c8b23cd51e$var$createRequestAbortController(timeout, signal);
    const corsOptions = $2bd4f4c8b23cd51e$var$getCorsForUrl(url);
    const metadataUrl = url + '?' + new URLSearchParams({
        product: `${params.product}`,
        userId: `${((_params$userInfo = params.userInfo) === null || _params$userInfo === void 0 ? void 0 : _params$userInfo.userId) || ''}`,
        userIdType: `${((_params$userInfo2 = params.userInfo) === null || _params$userInfo2 === void 0 ? void 0 : _params$userInfo2.userIdType) || ''}`,
        tenantId: `${((_params$tenantInfo = params.tenantInfo) === null || _params$tenantInfo === void 0 ? void 0 : _params$tenantInfo.tenantId) || ''}`,
        tenantIdType: `${((_params$tenantInfo2 = params.tenantInfo) === null || _params$tenantInfo2 === void 0 ? void 0 : _params$tenantInfo2.tenantIdType) || ''}`
    }).toString();
    const response = await fetch(metadataUrl, $2bd4f4c8b23cd51e$var$_objectSpread({
        method: 'GET',
        signal: requestAbortController.signal
    }, corsOptions));
    // Response must be a 200 (we expect a JSON response, so 204 is not valid for instance)
    if (response.status !== 200) throw new (0, $3efe50d51d84d6fc$export$26e841bcf1aeb894)(`Metadata: HTTP Error ${response.status} (${response.statusText})`, response.status, response.statusText);
    return response;
};
const $2bd4f4c8b23cd51e$var$createRequestAbortController = (timeout, signal)=>{
    const abortController = new AbortController();
    setTimeout(()=>{
        abortController.abort();
    }, timeout || 30000);
    signal === null || signal === void 0 || signal.addEventListener('abort', ()=>{
        abortController.abort();
    });
    return abortController;
};
// To ensure we always have cookies, we should check if the origins match.
// If they dont, we need to set mode to `cors` and credentials to `include`.
const $2bd4f4c8b23cd51e$var$getCorsForUrl = (0, $cvlyC.default)((url)=>{
    const origin = new URL(url).origin;
    if (origin === location.origin) return {};
    else return {
        mode: 'cors',
        credentials: 'include'
    };
});



var $5f0f1169c182c3a3$var$_MetadataClient;
function $5f0f1169c182c3a3$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $5f0f1169c182c3a3$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $5f0f1169c182c3a3$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $5f0f1169c182c3a3$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
class $5f0f1169c182c3a3$export$1ac223ae496131c9 {
    constructor(apiHostProtocol, apiHost, product){
        this._userInfo = {
            anonymousId: ''
        };
        this._tenantInfo = {};
        this._url = `${apiHostProtocol}://${apiHost}/metadata`;
        this._product = product;
        this._metadataInfo = null;
        this._requestStatus = 'PENDING';
        this._lastFetchRequestCount = 0;
        this._lastErrorReason = null;
        this._fetchAbortController = null;
        this._hasBeenStopped = false;
        this._isEnabled = false;
        this._propertyChangeRefreshTimeout = null;
        const isStargateProxy = (0, $f9df0b541c3a14c4$export$83a9dd8d74be72c)({
            apiHost: apiHost
        });
        this._metadataHost = isStargateProxy ? 'PRODUCT_HOST' : apiHost;
        this._options = this.buildOptions({
            backoffFactor: 2,
            backoffJitterPercentage: 0.8,
            batchFlushSize: 7,
            flushBeforeUnload: false,
            flushWaitMs: 500,
            maxAttempts: 10,
            maxItems: 1000,
            minRetryDelay: (0, $88991a89387117c8$export$6649d5c857717efe),
            maxRetryDelay: (0, $88991a89387117c8$export$33e7628d3b2c0e2)
        });
        this._scheduler = new (0, $91fcc5723998e290$export$2e2bcd8739ae039)($5f0f1169c182c3a3$var$_objectSpread($5f0f1169c182c3a3$var$_objectSpread({}, this._options), {}, {
            waitInterval: (0, $88991a89387117c8$export$92ed669a3d41dad3)
        }), this.scheduleCallback.bind(this));
        this._networkStatus = null;
    }
    /**
   * Starts the metadata client. This will start the scheduler and begin
   * fetching metadata.
   *
   * @param allowRestart - If false, the client will not be restarted if it has already been stopped
   *						 by a call to stop().
   */ start(allowRestart) {
        if (this._isEnabled || this._hasBeenStopped && !allowRestart) return;
        this._isEnabled = true;
        this.startNetworkStatusMonitor();
        setTimeout(()=>{
            this._scheduler.schedule({
                immediate: true
            });
        }, $5f0f1169c182c3a3$export$1ac223ae496131c9.INITIAL_REFRESH_DELAY);
    }
    stop() {
        var _this$_fetchAbortCont;
        if (!this._isEnabled) return;
        this._hasBeenStopped = true;
        this._isEnabled = false;
        this.stopNetworkStatusMonitor();
        this._scheduler.stop();
        (_this$_fetchAbortCont = this._fetchAbortController) === null || _this$_fetchAbortCont === void 0 || _this$_fetchAbortCont.abort();
        this.resetPropertyChangeRefresh();
    }
    startNetworkStatusMonitor() {
        if (this._networkStatus) return;
        this._networkStatus = new (0, $217f46601d89c1b6$export$2e2bcd8739ae039)((status)=>{
            if (status === (0, $70d72d06700e4121$export$ee138fa712d11b84).OFFLINE) this._scheduler.stop();
            else if (this._isEnabled) this._scheduler.schedule({
                immediate: this._metadataInfo === null
            });
        });
    }
    stopNetworkStatusMonitor() {
        if (this._networkStatus) {
            this._networkStatus.removeListeners();
            this._networkStatus = null;
        }
    }
    async refreshMetadataAsync() {
        var _this$_fetchAbortCont2;
        if ((0, $edecb1e04eb94083$export$44b578549c42d779).areFetchCallsDisabled() || !this._isEnabled) return Promise.resolve();
        (_this$_fetchAbortCont2 = this._fetchAbortController) === null || _this$_fetchAbortCont2 === void 0 || _this$_fetchAbortCont2.abort();
        this._fetchAbortController = new AbortController();
        const fetchAbortSignal = this._fetchAbortController.signal;
        this._lastFetchRequestCount = this._scheduler.getFailureCount();
        await (0, $2bd4f4c8b23cd51e$export$55b0d0261469055)(this._url, {
            product: this._product,
            userInfo: this._userInfo,
            tenantInfo: this._tenantInfo
        }, (0, $88991a89387117c8$export$8fddcd1eff390364), fetchAbortSignal).then(async (response)=>{
            const metadata = await response.json();
            this._metadataInfo = (0, $3efe50d51d84d6fc$export$4b1a5e5486cc0d80).fromJson(metadata);
            this._lastFetchRequestCount++;
            this._requestStatus = 'FETCHED';
            this._lastErrorReason = null;
        }).catch((error)=>{
            if (fetchAbortSignal.aborted) // This request was aborted, so we don't need to handle it.
            return;
            this._requestStatus = 'FAILED';
            if (error instanceof (0, $3efe50d51d84d6fc$export$26e841bcf1aeb894) && [
                429,
                503
            ].includes(error.statusCode)) this._lastErrorReason = 'ServerBusyError';
            else this._lastErrorReason = error instanceof Error && (0, $3efe50d51d84d6fc$export$96f086dcf574a9e2).includes(error.name) ? error.name : 'Unknown';
            throw error;
        });
    }
    getMetadataAsync() {
        return Promise.resolve(this._metadataInfo);
    }
    get status() {
        return this._requestStatus;
    }
    get lastErrorReason() {
        return this._lastErrorReason;
    }
    get lastFetchRequestCount() {
        return this._lastFetchRequestCount;
    }
    get userInfo() {
        return this._userInfo;
    }
    set userInfo(userInfo) {
        var _this$_userInfo, _this$_userInfo2;
        if (((_this$_userInfo = this._userInfo) === null || _this$_userInfo === void 0 ? void 0 : _this$_userInfo.userId) === (userInfo === null || userInfo === void 0 ? void 0 : userInfo.userId) && ((_this$_userInfo2 = this._userInfo) === null || _this$_userInfo2 === void 0 ? void 0 : _this$_userInfo2.userIdType) === (userInfo === null || userInfo === void 0 ? void 0 : userInfo.userIdType)) return;
        this._userInfo = userInfo;
        this.schedulePropertyChangeRefresh();
    }
    get tenantInfo() {
        return this._tenantInfo;
    }
    set tenantInfo(tenantInfo) {
        var _this$_tenantInfo, _this$_tenantInfo2;
        if (((_this$_tenantInfo = this._tenantInfo) === null || _this$_tenantInfo === void 0 ? void 0 : _this$_tenantInfo.tenantId) === (tenantInfo === null || tenantInfo === void 0 ? void 0 : tenantInfo.tenantId) && ((_this$_tenantInfo2 = this._tenantInfo) === null || _this$_tenantInfo2 === void 0 ? void 0 : _this$_tenantInfo2.tenantIdType) === (tenantInfo === null || tenantInfo === void 0 ? void 0 : tenantInfo.tenantIdType)) return;
        this._tenantInfo = tenantInfo;
        this.schedulePropertyChangeRefresh();
    }
    get metrics() {
        return {
            host: this._metadataHost,
            status: this.status,
            lastErrorReason: this.lastErrorReason,
            lastRefreshRequestCount: this.lastFetchRequestCount
        };
    }
    async scheduleCallback(done) {
        var _this$_networkStatus;
        if (((_this$_networkStatus = this._networkStatus) === null || _this$_networkStatus === void 0 ? void 0 : _this$_networkStatus.getNetworkStatus()) === (0, $70d72d06700e4121$export$ee138fa712d11b84).OFFLINE) {
            done((0, $259e7a33bf7a29f3$export$f93c40fda808dd0c).NOOP);
            return;
        }
        try {
            await this.refreshMetadataAsync();
            done((0, $259e7a33bf7a29f3$export$f93c40fda808dd0c).SUCCESS);
            this._scheduler.schedule();
        } catch (error) {
            done((0, $259e7a33bf7a29f3$export$f93c40fda808dd0c).ERROR);
        }
    }
    /**
   * Schedules a refresh of the metadata when the user or tenant info changes. There is
   * a short delay to allow for multiple changes to be batched together, such as when the
   * callers sets the user info and tenant info in quick succession.
   */ schedulePropertyChangeRefresh() {
        if (!this._isEnabled) return;
        this.resetPropertyChangeRefresh();
        this._propertyChangeRefreshTimeout = setTimeout(()=>{
            this.resetPropertyChangeRefresh();
            this._scheduler.schedule({
                immediate: true
            });
        }, (0, $88991a89387117c8$export$6f1c008dd0c3b67e));
    }
    resetPropertyChangeRefresh() {
        if (this._propertyChangeRefreshTimeout) {
            clearTimeout(this._propertyChangeRefreshTimeout);
            this._propertyChangeRefreshTimeout = null;
        }
    }
    buildOptions(options) {
        return {
            backoffFactor: (options === null || options === void 0 ? void 0 : options.backoffFactor) || (0, $29ad82233d2d80ba$export$d219df4fe04c04a7).backoffFactor,
            backoffJitterPercentage: (options === null || options === void 0 ? void 0 : options.backoffJitterPercentage) !== undefined ? options.backoffJitterPercentage : (0, $29ad82233d2d80ba$export$d219df4fe04c04a7).backoffJitterPercentage,
            batchFlushSize: (options === null || options === void 0 ? void 0 : options.batchFlushSize) || (0, $29ad82233d2d80ba$export$d219df4fe04c04a7).batchFlushSize,
            flushBeforeUnload: (options === null || options === void 0 ? void 0 : options.flushBeforeUnload) || (0, $29ad82233d2d80ba$export$d219df4fe04c04a7).flushBeforeUnload,
            flushWaitMs: (options === null || options === void 0 ? void 0 : options.flushWaitMs) || (0, $29ad82233d2d80ba$export$d219df4fe04c04a7).flushWaitMs,
            maxItems: (options === null || options === void 0 ? void 0 : options.maxItems) || (0, $29ad82233d2d80ba$export$d219df4fe04c04a7).maxItems,
            maxAttempts: (options === null || options === void 0 ? void 0 : options.maxAttempts) || (0, $29ad82233d2d80ba$export$d219df4fe04c04a7).maxAttempts,
            maxRetryDelay: (options === null || options === void 0 ? void 0 : options.maxRetryDelay) || (0, $29ad82233d2d80ba$export$d219df4fe04c04a7).maxRetryDelay,
            minRetryDelay: (options === null || options === void 0 ? void 0 : options.minRetryDelay) || (0, $29ad82233d2d80ba$export$d219df4fe04c04a7).minRetryDelay
        };
    }
}
$5f0f1169c182c3a3$var$_MetadataClient = $5f0f1169c182c3a3$export$1ac223ae496131c9;
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($5f0f1169c182c3a3$export$1ac223ae496131c9, "INITIAL_REFRESH_DELAY", 1);
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($5f0f1169c182c3a3$export$1ac223ae496131c9, "Factory", (apiHostProtocol, apiHost, product)=>{
    return new $5f0f1169c182c3a3$var$_MetadataClient(apiHostProtocol, apiHost, product);
});



var $25nEq = parcelRequire("25nEq");


class $c71ed008013c1ce7$export$2e2bcd8739ae039 {
    constructor(){
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "handleOriginParameters", (originParamHandlerMapping, historyReplaceFn)=>{
            // Collect all the parameter labels to be handled
            const originParamLabelList = Object.keys(originParamHandlerMapping);
            if (!(originParamLabelList.length > 0)) throw new Error('Empty parameter mapping provided');
            // Check if the parameter labels are valid. If any invalid labels are found throw an exception.
            const invalidParams = originParamLabelList.filter((x)=>Object.values((0, $9c4c150c990b1f10$export$62a500c02dc63ee)).indexOf(x) < 0);
            if (invalidParams.length > 0) throw new Error(`Invalid Origin Tracing Parameter(s) supplied: ${invalidParams.join()}!`);
            const isCaptureParam = (_, key)=>originParamLabelList.indexOf(key) >= 0;
            // Capture and remove params from URL
            const capturedURLParams = (0, $21fc6f103b6afda8$export$2e2bcd8739ae039)(isCaptureParam, historyReplaceFn);
            // Apply provided handler function to extract origin trace ID from each URL parameter
            const applyHandlerFunction = (key)=>{
                const x = originParamHandlerMapping[key](capturedURLParams[key]);
                return {
                    [key]: x
                };
            };
            const extractedOriginID = Object.keys(capturedURLParams).map(applyHandlerFunction).reduce((accumulator, currentValue)=>Object.assign(accumulator, currentValue), {});
            return extractedOriginID;
        });
        this._originStore = {};
    }
}





var $25nEq = parcelRequire("25nEq");

// WARNING: The value of SESSION_ID_STORAGE_KEY is relied upon by other Platform packages
// (eg. search-page, product-search-dialog). If you need to change this key, you MUST
// notify the dependant Platform teams and update all dependent packages accordingly.
const $43d30f76663fb1b4$var$SESSION_ID_STORAGE_KEY = 'session.id';
const $43d30f76663fb1b4$var$SESSION_EXPIRY_STORAGE_KEY = 'session.expiry';
const $43d30f76663fb1b4$var$ONLY_NUMBERS_REGEX = /^\d+$/;
const $43d30f76663fb1b4$export$285f6bddd927a06d = 1800000; // 30 minutes
const $43d30f76663fb1b4$export$a92e915d70316eb2 = 5000; // 5 seconds
const $43d30f76663fb1b4$export$de43760b2dc10c19 = 0.9; // 90% of expiry
const $43d30f76663fb1b4$export$5702a91a6f42969f = ()=>{};
class $43d30f76663fb1b4$export$2e2bcd8739ae039 {
    constructor(options = {}){
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "_generateNewSessionId", ()=>{
            const newSessionId = Date.now().toString();
            this._safeLocalStorage.setItem($43d30f76663fb1b4$var$SESSION_ID_STORAGE_KEY, newSessionId);
            // COMMENTS-123 - When a new session starts, call the callback if it is given
            this._onNewSessionStarted && this._onNewSessionStarted();
            return newSessionId;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "_updateSessionExpiry", ()=>{
            const expiry = Date.now() + this._sessionExpiryTime;
            this._safeLocalStorage.setItem($43d30f76663fb1b4$var$SESSION_EXPIRY_STORAGE_KEY, expiry.toString());
            return expiry;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "_debouncedUpdateSessionExpiry", (currentExpiry)=>{
            const { _updateSessionExpiry: _updateSessionExpiry } = this;
            // If the current expiry is out of date by more than 10% of the expiry, update immediately
            if (currentExpiry < Date.now() + this._sessionExpiryDebounceThresholdPercentage * this._sessionExpiryTime) _updateSessionExpiry();
            else {
                if (this._sessionExpiryDebounceTimer) clearTimeout(this._sessionExpiryDebounceTimer);
                // @ts-ignore Something wrong with our types... this is legit
                this._sessionExpiryDebounceTimer = setTimeout(()=>{
                    _updateSessionExpiry();
                }, this._sessionExpiryDebounce);
            }
        });
        this._sessionExpiryTime = options.sessionExpiryTime || $43d30f76663fb1b4$export$285f6bddd927a06d;
        this._sessionExpiryDebounce = options.sessionExpiryDebounce || $43d30f76663fb1b4$export$a92e915d70316eb2;
        this._sessionExpiryDebounceThresholdPercentage = options.sessionExpiryDebounceThresholdPercentage || $43d30f76663fb1b4$export$de43760b2dc10c19;
        this._onNewSessionStarted = options.onNewSessionStarted ? options.onNewSessionStarted : $43d30f76663fb1b4$export$5702a91a6f42969f;
        this._safeLocalStorage = new (0, $df90e90c3af4c162$export$2e2bcd8739ae039)();
    }
    getCurrentSessionId() {
        const sessionId = this._safeLocalStorage.getItem($43d30f76663fb1b4$var$SESSION_ID_STORAGE_KEY);
        const sessionExpiry = parseInt(this._safeLocalStorage.getItem($43d30f76663fb1b4$var$SESSION_EXPIRY_STORAGE_KEY) || '0', 10) || 0;
        this._debouncedUpdateSessionExpiry(sessionExpiry);
        if (!sessionId || sessionExpiry <= Date.now() || Number.isNaN(sessionExpiry)) return this._generateNewSessionId();
        // Old versions of sessionId were UUIDs which caused issues for Amplitude which only accepts
        // integers for this field. In these scenarios we want to regenerate the sessionId as an integer
        if (!$43d30f76663fb1b4$var$ONLY_NUMBERS_REGEX.test(sessionId)) return this._generateNewSessionId();
        return sessionId;
    }
}




class $94e352d257707d44$export$2e2bcd8739ae039 extends (0, $3cf59f0615ba9877$export$2e2bcd8739ae039) {
    constructor(options){
        let storageToUse;
        try {
            storageToUse = globalThis.sessionStorage || (0, $ae517b47e306f68f$export$2e2bcd8739ae039);
        } catch (err) {
            storageToUse = (0, $ae517b47e306f68f$export$2e2bcd8739ae039);
        }
        super(storageToUse, options);
    }
}



var $25nEq = parcelRequire("25nEq");


const $de631ded0d60c70b$var$STORAGE_KEY = 'tab.id';
class $de631ded0d60c70b$export$2e2bcd8739ae039 {
    constructor(){
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "_generateNewTabId", ()=>{
            const newTabId = (0, $16f8259e8856e670$export$2e2bcd8739ae039)();
            this._safeSessionStorage.setItem($de631ded0d60c70b$var$STORAGE_KEY, newTabId);
            return newTabId;
        });
        this._safeSessionStorage = new (0, $94e352d257707d44$export$2e2bcd8739ae039)();
    }
    getCurrentTabId() {
        let tabId = this._safeSessionStorage.getItem($de631ded0d60c70b$var$STORAGE_KEY);
        if (!tabId) tabId = this._generateNewTabId();
        return tabId;
    }
}



var $25nEq = parcelRequire("25nEq");






function $ef2ff75caf77a3e2$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $ef2ff75caf77a3e2$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $ef2ff75caf77a3e2$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $ef2ff75caf77a3e2$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
const $ef2ff75caf77a3e2$var$STORAGE_KEY = 'taskSessions';
const $ef2ff75caf77a3e2$var$INIT_KEY = 'taskSessionsInit';
const $ef2ff75caf77a3e2$var$AWC_PARAM_PREFIX = 'awc.';
const $ef2ff75caf77a3e2$var$TASK_SESSION_RELOAD_TIME = 3000;
class $ef2ff75caf77a3e2$export$2e2bcd8739ae039 {
    constructor(){
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "_taskSessionsNotRecentlyInitialised", (currentTimestamp)=>this._safeSessionStorage.getItem($ef2ff75caf77a3e2$var$STORAGE_KEY) === null || this._safeSessionStorage.getItem($ef2ff75caf77a3e2$var$INIT_KEY) === null || parseInt(this._safeSessionStorage.getItem($ef2ff75caf77a3e2$var$INIT_KEY) || '0', 10) < currentTimestamp - $ef2ff75caf77a3e2$var$TASK_SESSION_RELOAD_TIME);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "_removeTaskSessionPrefix", (_, taskSessionName)=>taskSessionName.split($ef2ff75caf77a3e2$var$AWC_PARAM_PREFIX)[1]);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "_isTaskSessionQueryParam", (_, taskSessionName)=>taskSessionName.startsWith($ef2ff75caf77a3e2$var$AWC_PARAM_PREFIX));
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "getAllTaskSessions", ()=>{
            try {
                return JSON.parse(this._safeSessionStorage.getItem($ef2ff75caf77a3e2$var$STORAGE_KEY) || '');
            } catch (_unused) {
                return {};
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "_writeToSessionStorage", (taskSessions)=>{
            try {
                this._safeSessionStorage.setItem($ef2ff75caf77a3e2$var$STORAGE_KEY, JSON.stringify(taskSessions));
            // eslint-disable-next-line no-empty
            } catch (_unused2) {}
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "_appendTaskSessions", (newTaskSessions)=>{
            const currentState = this.getAllTaskSessions();
            const newState = currentState === null ? newTaskSessions : Object.assign(currentState, newTaskSessions);
            this._writeToSessionStorage(newState);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "_safelyRemoveKey", (currentState, taskSessionName)=>{
            if (currentState === null) return {};
            delete currentState[taskSessionName];
            return currentState;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "createTaskSession", (taskSessionName)=>{
            const taskSessionId = (0, $16f8259e8856e670$export$2e2bcd8739ae039)();
            const newTaskSessions = {};
            newTaskSessions[taskSessionName] = taskSessionId;
            this._appendTaskSessions(newTaskSessions);
            return taskSessionId;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "createTaskSessionWithProvidedId", (taskSessionName, taskSessionId)=>{
            if (typeof taskSessionId !== 'string') throw new TypeError('invalid taskSessionId, must be string');
            const newTaskSessions = {};
            newTaskSessions[taskSessionName] = taskSessionId;
            this._appendTaskSessions(newTaskSessions);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "completeTaskSession", (taskSessionName)=>{
            const currentState = this.getAllTaskSessions();
            const updatedState = this._safelyRemoveKey(currentState, taskSessionName);
            this._writeToSessionStorage(updatedState);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "formatTaskSessionQueryString", ({ uri: uri, includedTaskSessions: includedTaskSessions })=>{
            const { url: url, query: query } = (0, $26356a878988d07a$export$7a5253c0f62e0150)(uri);
            const currentState = this.getAllTaskSessions();
            // Use specified task sessions, otherwise all tasksessions excluding originTracing sessions
            const filteredTaskSessions = includedTaskSessions ? (0, $68baca26a6bab057$export$357523c63a2253b9)(currentState, includedTaskSessions) : (0, $68baca26a6bab057$export$30a06c8d3562193f)(currentState, Object.values((0, $9c4c150c990b1f10$export$62a500c02dc63ee)));
            if (Object.keys(filteredTaskSessions).length === 0) return uri;
            const queryWithTaskSessions = $ef2ff75caf77a3e2$var$_objectSpread($ef2ff75caf77a3e2$var$_objectSpread({}, (0, $68baca26a6bab057$export$781522908e4e76a1)(filteredTaskSessions, (_, taskSessionName)=>$ef2ff75caf77a3e2$var$AWC_PARAM_PREFIX + taskSessionName)), query);
            return `${url}?${(0, $26356a878988d07a$export$fac44ee5b035f737)(queryWithTaskSessions)}`;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "stripQueryParameters", ()=>{
            const extractedTaskSessions = (0, $68baca26a6bab057$export$781522908e4e76a1)((0, $21fc6f103b6afda8$export$2e2bcd8739ae039)(this._isTaskSessionQueryParam), this._removeTaskSessionPrefix);
            this._appendTaskSessions(extractedTaskSessions);
        });
        const _currentTimestamp = Date.now();
        this._safeSessionStorage = new (0, $94e352d257707d44$export$2e2bcd8739ae039)();
        // Wrapping all sessionStorage calls in try catch to stop any error propogation, taskSessions should gracefully fail.
        try {
            if (this._taskSessionsNotRecentlyInitialised(_currentTimestamp)) {
                this._writeToSessionStorage({});
                this._safeSessionStorage.setItem($ef2ff75caf77a3e2$var$INIT_KEY, _currentTimestamp.toString());
            }
        // eslint-disable-next-line no-empty
        } catch (_unused3) {}
    }
}



var $bDLqY = parcelRequire("bDLqY");


const $60f01de259a84dee$var$MAX_CACHE_SIZE = 100;
const $60f01de259a84dee$var$COOKIE_NAME = (0, $c8b41e64c5f9315f$export$d4cb17942ea57c95).AWC_ANALYTICS_DEBUG.getKey();
const $60f01de259a84dee$var$DEBUG_TAG = 'synthetic';
class $60f01de259a84dee$var$TestingCache {
    constructor(syntheticFlagOverride, enableTestingCache){
        this._syntheticFlagOverride = typeof syntheticFlagOverride === 'boolean' ? syntheticFlagOverride : undefined;
        this._enableTestingCache = typeof enableTestingCache === 'boolean' ? enableTestingCache : undefined;
        this._isDebugCookieEnabled = $60f01de259a84dee$var$TestingCache.getDebugCookie();
        this.bind();
    }
    saveEvent(event) {
        try {
            if (!event) return;
            this.bind();
            this.addSyntheticTag(event);
            this.cache(event);
        } catch (_unused) {
        // Ignore errors from testing cache.
        }
    }
    bind() {
        if (!this.shouldCacheEvent() || typeof window === 'undefined' || window.testAnalytics) return;
        window.testAnalytics = {
            eventCache: [],
            events: ()=>window.testAnalytics.eventCache,
            clear: ()=>{
                window.testAnalytics.eventCache = [];
                try {
                    localStorage.removeItem('awc.ui.viewed.last.sent');
                    localStorage.removeItem('awc-staging.ui.viewed.last.sent');
                    localStorage.removeItem('awc-dev.ui.viewed.last.sent');
                    localStorage.removeItem('awc-local.ui.viewed.last.sent');
                } catch (_unused2) {
                // Ignore errors from localStorage.
                }
            }
        };
    }
    cache(event) {
        if (!this.shouldCacheEvent() || typeof window === 'undefined' || !window.testAnalytics) return;
        if (window.testAnalytics.eventCache.length >= $60f01de259a84dee$var$MAX_CACHE_SIZE) window.testAnalytics.eventCache = window.testAnalytics.eventCache.slice(1, window.testAnalytics.eventCache.length);
        window.testAnalytics.eventCache.push(event);
    }
    addSyntheticTag(event) {
        if (!this.shouldSetSyntheticFlag()) return;
        if (event.tags instanceof Array) {
            if (!event.tags.includes($60f01de259a84dee$var$DEBUG_TAG)) event.tags.push($60f01de259a84dee$var$DEBUG_TAG);
        } else event.tags = [
            $60f01de259a84dee$var$DEBUG_TAG
        ];
    }
    shouldCacheEvent() {
        return this._enableTestingCache ? this._enableTestingCache : this._isDebugCookieEnabled;
    }
    shouldSetSyntheticFlag() {
        if (this._syntheticFlagOverride !== undefined) return this._syntheticFlagOverride;
        const globalSyntheticOverride = (0, $edecb1e04eb94083$export$44b578549c42d779).getSyntheticFlagOverride();
        if (globalSyntheticOverride !== undefined) return globalSyntheticOverride;
        return this.shouldCacheEvent();
    }
    static getDebugCookie() {
        try {
            return JSON.parse((0, (/*@__PURE__*/$parcel$interopDefault($bDLqY))).get($60f01de259a84dee$var$COOKIE_NAME) || 'false') === true;
        } catch (_unused3) {
            (0, (/*@__PURE__*/$parcel$interopDefault($bDLqY))).remove($60f01de259a84dee$var$COOKIE_NAME);
        }
        return false;
    }
}
var $60f01de259a84dee$export$2e2bcd8739ae039 = $60f01de259a84dee$var$TestingCache;



var $1Vcia = parcelRequire("1Vcia");

var $25nEq = parcelRequire("25nEq");

const $997b10b79fa3f8dc$export$f65ca476c09acec0 = ()=>{
    if (typeof document !== 'undefined') return document;
    return null;
};



const $3354a6ae24846e2f$var$_excluded = [
    "embeddedProduct"
];
function $3354a6ae24846e2f$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $3354a6ae24846e2f$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $3354a6ae24846e2f$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $3354a6ae24846e2f$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
const $3354a6ae24846e2f$var$DEFAULT_DELAY = 2000; // 2 seconds
const $3354a6ae24846e2f$var$DEFAULT_THROTTLE = 3600000; // 1 hour
const $3354a6ae24846e2f$var$DEFAULT_STORAGE_KEY = 'ui.viewed.last.sent';
const $3354a6ae24846e2f$var$DEFAULT_MALFORMED_UIVIEWED_EVENT = 'malformed.uiviewed.last.sent';
class $3354a6ae24846e2f$export$2e2bcd8739ae039 {
    constructor(productInfo, getContext, onEvent, settings = {}){
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "start", ()=>{
            this._startInterval();
            this._bindEventListeners();
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "stop", ()=>{
            this._stopInterval();
            this._unbindEventListeners();
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "resetTimers", ()=>{
            if (this._intervalId) {
                this.stop();
                this.start();
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "_bindEventListeners", ()=>{
            if (typeof window !== 'undefined') {
                window.addEventListener('focus', this._focusListener);
                window.addEventListener('blur', this._blurListener);
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "_unbindEventListeners", ()=>{
            if (typeof window !== 'undefined') {
                window.removeEventListener('focus', this._focusListener);
                window.removeEventListener('blur', this._blurListener);
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "_startInterval", ()=>{
            clearInterval(this._intervalId);
            this._intervalId = setInterval(this._handleInterval, this._delay);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "_stopInterval", ()=>{
            if (this._intervalId) {
                clearInterval(this._intervalId);
                this._intervalId = null;
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "_getProductKey", (product, subproduct)=>{
            let productKey = product;
            if (subproduct) productKey += `-${subproduct}`;
            return productKey;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "_getLastSentTimestamp", (productKey, tenantId, userId)=>{
            const json = this._parseLocalStorageData(this._storageKey) || {};
            const u = json[userId] || {};
            const t = u[tenantId] || {};
            const p = t[productKey] || null;
            return p;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "_parseLocalStorageData", (key)=>{
            const data = this._safeLocalStorage.getItem(key);
            try {
                return JSON.parse(data || '');
            } catch (error) {
                this._safeLocalStorage.removeItem(key);
                return null;
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "_getMalformedLastSentTimestamp", (productKey, tenantId, userId)=>{
            const json = this._parseLocalStorageData(this._malformedEventStorageKey) || {};
            const finalUserId = userId || 'NOT_SET';
            const finalTenantId = tenantId || 'NOT_SET';
            const u = json[finalUserId] || {};
            const t = u[finalTenantId] || {};
            const p = t[productKey] || null;
            return p;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "_setLastSentTimestamp", (productKey, tenantId, userId)=>{
            const json = this._parseLocalStorageData(this._storageKey) || {};
            const u = json[userId] || {};
            const t = u[tenantId] || {};
            t[productKey] = Date.now();
            u[tenantId] = t;
            json[userId] = u;
            this._safeLocalStorage.setItem(this._storageKey, JSON.stringify(json));
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "_setMalformedLastSentTimestamp", (productKey, tenantId, userId)=>{
            const json = this._parseLocalStorageData(this._malformedEventStorageKey) || {};
            const finalUserId = userId || 'NOT_SET';
            const finalTenantId = tenantId || 'NOT_SET';
            const u = json[finalUserId] || {};
            const t = u[finalTenantId] || {};
            t[productKey] = Date.now();
            u[finalTenantId] = t;
            json[finalUserId] = u;
            this._safeLocalStorage.setItem(this._malformedEventStorageKey, JSON.stringify(json));
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "_shouldSendEvent", (productKey, tenantIdType, tenantId, userId)=>{
            const document = (0, $997b10b79fa3f8dc$export$f65ca476c09acec0)();
            if (document && !document.hasFocus()) return 'FocusLost';
            // TENANT OR USER ID NOT SET
            if (tenantIdType !== (0, $9c4c150c990b1f10$export$496f06ac2a964da2).NONE && !tenantId || !userId) {
                const sinceLastSent = Date.now() - this._getMalformedLastSentTimestamp(productKey, tenantId, userId);
                if (sinceLastSent === null || sinceLastSent > this._throttle) return 'UserOrTenantIncomplete';
                return 'MalformedUiViewedRateLimited';
            }
            const sinceLastSent = Date.now() - this._getLastSentTimestamp(productKey, tenantId, userId);
            if (sinceLastSent === null || sinceLastSent > this._throttle) return 'EligibleToSend';
            return 'UiViewedRateLimited';
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "_handleInterval", ()=>{
            const _this$_getContext = this._getContext(), { embeddedProduct: embeddedProduct } = _this$_getContext, context = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_this$_getContext, $3354a6ae24846e2f$var$_excluded);
            this._sendEvent(this._product, context);
            if (embeddedProduct) this._sendEvent(embeddedProduct, context, true);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "_sendEvent", (product, context, isEmbeddedProduct = false)=>{
            const { subproduct: subproduct, tenantIdType: tenantIdType, tenantId: tenantId, userId: userId, lastScreenEvent: lastScreenEvent, attributes: attributes } = context;
            const productKey = this._getProductKey(product, subproduct);
            const shouldSendEventTriggerStatus = this._shouldSendEvent(productKey, tenantIdType, tenantId, userId);
            switch(shouldSendEventTriggerStatus){
                case 'EligibleToSend':
                    this._setLastSentTimestamp(productKey, tenantId, userId);
                    this._onEvent(this._createEvent(product, subproduct, isEmbeddedProduct, lastScreenEvent, attributes, 'ui', 'viewed'));
                    break;
                case 'UserOrTenantIncomplete':
                    this._setMalformedLastSentTimestamp(productKey, tenantId, userId);
                    this._onEvent(this._createEvent(product, subproduct, isEmbeddedProduct, lastScreenEvent, attributes, 'malformed', 'uiviewed'));
                    break;
                default:
                    break;
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "_createEvent", (product, subproduct, isEmbeddedProduct, lastScreenEvent, extraAttributes, actionSubject, action)=>{
            const event = {
                product: product,
                source: 'ui',
                action: action,
                actionSubject: actionSubject,
                attributes: extraAttributes
            };
            if (isEmbeddedProduct) {
                // Clear the subproduct and version as they don't relate to the embedded product
                event.subproduct = null;
                event.version = null;
                event.attributes = $3354a6ae24846e2f$var$_objectSpread($3354a6ae24846e2f$var$_objectSpread({}, event.attributes), {}, {
                    embeddedInEnv: this._productInfo.env,
                    embeddedInProduct: this._productInfo.product,
                    embeddedInSubproduct: subproduct,
                    embeddedInVersion: this._productInfo.version,
                    embeddedInOrigin: this._productInfo.origin,
                    embeddedInPlatform: this._productInfo.platform
                });
            }
            if (lastScreenEvent) event.attributes = $3354a6ae24846e2f$var$_objectSpread($3354a6ae24846e2f$var$_objectSpread({}, event.attributes), {}, {
                lastScreenEvent: {
                    name: lastScreenEvent.name,
                    attributes: lastScreenEvent.attributes
                }
            });
            return event;
        });
        if (!productInfo) throw new Error('Missing productInfo');
        if (!productInfo.product) throw new Error('Missing productInfo.product');
        if (!getContext) throw new Error('Missing getContext callback');
        if (typeof getContext !== 'function') throw new Error('Invalid getContext, must be function');
        if (!onEvent) throw new Error('Missing onEvent callback');
        if (typeof onEvent !== 'function') throw new Error('Invalid onEvent, must be function');
        this._productInfo = productInfo;
        this._product = productInfo.product;
        this._getContext = getContext;
        this._onEvent = onEvent;
        this._delay = settings.delay || $3354a6ae24846e2f$var$DEFAULT_DELAY;
        this._throttle = settings.throttle || $3354a6ae24846e2f$var$DEFAULT_THROTTLE;
        this._storageKey = settings.storageKey || $3354a6ae24846e2f$var$DEFAULT_STORAGE_KEY;
        this._malformedEventStorageKey = settings.malformedStorageKey || $3354a6ae24846e2f$var$DEFAULT_MALFORMED_UIVIEWED_EVENT;
        this._safeLocalStorage = new (0, $df90e90c3af4c162$export$2e2bcd8739ae039)({
            envPrefix: this._productInfo.env
        });
        this._focusListener = ()=>{
            this._startInterval();
        };
        this._blurListener = ()=>{
            this._stopInterval();
        };
    }
}





function $5c22578f1038a2ab$export$2e2bcd8739ae039(callback, event) {
    if (!callback || typeof callback !== 'function') return null;
    return ()=>{
        callback(event);
    };
}


let $2c0988cb35351eed$export$92ca0438bcb0d396 = /*#__PURE__*/ function(XIDItemType) {
    XIDItemType["XC"] = "xc";
    XIDItemType["UID"] = "uid";
    return XIDItemType;
}({});
let $2c0988cb35351eed$export$c9079017d1f5aab9 = /*#__PURE__*/ function(XIDState) {
    XIDState["NEW"] = "NEW";
    XIDState["CHANGED"] = "CHANGED";
    XIDState["EXISTING"] = "EXISTING";
    XIDState["TIMEOUT"] = "TIMEOUT";
    XIDState["ERROR"] = "ERROR";
    XIDState["UNAVAILABLE"] = "UNAVAILABLE";
    XIDState["MALFORMED"] = "MALFORMED";
    XIDState["UNKNOWN"] = "UNKNOWN";
    return XIDState;
}({});


const $08e71866145a7f5d$export$545bcbd53afabfa3 = 5000;
const $08e71866145a7f5d$export$af4087e36d63846 = ()=>[
        {
            type: (0, $2c0988cb35351eed$export$92ca0438bcb0d396).XC,
            state: 'TIMEOUT'
        },
        {
            type: (0, $2c0988cb35351eed$export$92ca0438bcb0d396).UID,
            state: 'TIMEOUT'
        }
    ];
const $08e71866145a7f5d$export$fa341d0c750d705b = ()=>[
        {
            type: (0, $2c0988cb35351eed$export$92ca0438bcb0d396).XC,
            state: 'UNKNOWN'
        },
        {
            type: (0, $2c0988cb35351eed$export$92ca0438bcb0d396).UID,
            state: 'UNKNOWN'
        }
    ];


const $cfa945807de0debd$export$fbe53bbbe682bcdd = (xidConsent, xidPromiseFn)=>{
    if (xidConsent && xidPromiseFn && typeof xidPromiseFn === 'function') {
        const timeoutPromise = ()=>{
            return new Promise((resolve)=>{
                setTimeout(()=>resolve(()=>(0, $08e71866145a7f5d$export$af4087e36d63846)()), (0, $08e71866145a7f5d$export$545bcbd53afabfa3));
            });
        };
        const xidPromise = ()=>{
            return xidPromiseFn().catch(()=>()=>(0, $08e71866145a7f5d$export$fa341d0c750d705b)());
        };
        return Promise.race([
            xidPromise(),
            timeoutPromise()
        ]);
    }
    return undefined;
};


function $4667273d53967e9d$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $4667273d53967e9d$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $4667273d53967e9d$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $4667273d53967e9d$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
const $4667273d53967e9d$export$5df9262e102d0c32 = '/gateway/api/gasv3/api/v1';
const $4667273d53967e9d$var$LAST_SCREEN_EVENT_STORAGE_KEY = 'last.screen.event';
class $4667273d53967e9d$export$48361b6ed38f1b0 {
    static getCallback(logger) {
        logger = logger || console;
        return (response)=>{
            $4667273d53967e9d$export$48361b6ed38f1b0.callback(response, logger);
        };
    }
    static callback(response, logger) {
        const statusCode = response.getStatusCode();
        if (statusCode >= 200 && statusCode <= 299) response.getEventResponseList().forEach((eventResponse)=>{
            logger.warn('Validation report for event with message ID %s:\n', eventResponse.getMessageId(), eventResponse);
        });
        else if (statusCode === 400 || statusCode === 404) {
            logger.warn('GASv3 submission failed with HTTP Status Code %d: %s', response.getStatusCode(), response.getMessage());
            response.getEventResponseList().forEach((eventResponse)=>{
                logger.warn('Event with message ID %s:\n', eventResponse.getMessageId(), eventResponse);
            });
        } else {
            logger.log('GASv3 submission failed with HTTP Status Code %d: %s', response.getStatusCode(), response.getMessage());
            response.eventResponseList.forEach((eventResponse)=>{
                logger.debug('Event with message ID %s:\n', eventResponse.getMessageId(), eventResponse);
            });
        }
    }
}
class $4667273d53967e9d$export$2e2bcd8739ae039 {
    constructor(productInfo, settings = {}){
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "_useStargate", (useStargate)=>{
            if (useStargate == null) return true;
            return useStargate;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "_changeInternalUserId", (userId, anonymousId)=>{
            this._eventProcessor.getUser().setUserId(userId);
            if (anonymousId && anonymousId !== this._eventProcessor.getUser().getAnonymousId()) // Setting anonymous id can take a long time. Reading is a lot faster.
            // Only update if it has changed.
            this._eventProcessor.getUser().setAnonymousId(anonymousId);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "_createSubproductGetter", (subproduct)=>(0, $7fd7c8f1cf1381dd$export$2e2bcd8739ae039)(subproduct, 'Cannot get subproduct from the callback. Proceeding without it.'));
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "_createEmbeddedProductGetter", (embeddedProduct)=>(0, $7fd7c8f1cf1381dd$export$2e2bcd8739ae039)(embeddedProduct, 'Cannot get embeddedProduct from the callback. Proceeding without it.'));
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "_getLastScreenEvent", ()=>{
            try {
                return JSON.parse(this._safeSessionStorage.getItem($4667273d53967e9d$var$LAST_SCREEN_EVENT_STORAGE_KEY) || '');
            } catch (_unused) {
                this._safeSessionStorage.removeItem($4667273d53967e9d$var$LAST_SCREEN_EVENT_STORAGE_KEY);
                return null;
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "_setLastScreenEvent", (event)=>{
            this._safeSessionStorage.setItem($4667273d53967e9d$var$LAST_SCREEN_EVENT_STORAGE_KEY, JSON.stringify({
                name: event.name,
                attributes: event.attributes
            }));
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "_shouldEventBeDelayed", (event)=>{
            // TODO: this is a temporary restriction for the purposes of the Track All Changes project
            // The delay mechanism has a chance of event loss, which we can only accept for our own data at this point.
            // Once the delay queue implementation has been improved and measured to confirm that it is reliable enough,
            // then we will be able to open it up for other products to use by removing this check.
            if (!event.tags || event.tags.indexOf('measurement') === -1) return false;
            const isEventHighPriority = event.highPriority !== false; // defaults to true if excluded
            return this._eventDelayQueue.isDelayingLowPriorityEvents() && !isEventHighPriority;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "_fireEvent", (identifier, builtEvent, context, callback)=>{
            switch(builtEvent.eventType){
                case (0, $9c4c150c990b1f10$export$4c045e605d532c98).UI:
                case (0, $9c4c150c990b1f10$export$4c045e605d532c98).OPERATIONAL:
                case (0, $9c4c150c990b1f10$export$4c045e605d532c98).TRACK:
                    return this._eventProcessor.track(identifier, builtEvent, context, callback);
                case (0, $9c4c150c990b1f10$export$4c045e605d532c98).SCREEN:
                    return this._eventProcessor.page(identifier, builtEvent, context, callback);
                case (0, $9c4c150c990b1f10$export$4c045e605d532c98).IDENTIFY:
                    return this._eventProcessor.identify(identifier, builtEvent, context, callback);
                default:
                    throw new Error(`No handler has been defined for events of type ${builtEvent.eventType}`);
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "_fireDelayedEvent", (identifier, builtEvent, context, userInfo)=>{
            try {
                // User information can change while the delay period is active, so we need to restore the values that
                // were active when the event was originally fired.
                this._changeInternalUserId(userInfo.userId, userInfo.anonymousId);
                builtEvent.tags = [
                    ...builtEvent.tags || [],
                    'sentWithDelay'
                ];
                // The callbacks for delayed events are fired immediately, so there is nothing to pass through for this argument.
                this._fireEvent(identifier, builtEvent, context, undefined);
            } finally{
                this._changeInternalUserId(this._userInfo.userId, this._userInfo.anonymousId);
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "_delayEvent", (identifier, builtEvent, context, userInfo, callback)=>{
            this._eventDelayQueue.push(identifier, builtEvent, context, userInfo);
            // Fire the callback immediately, as we can consider the event successfully processed at this point
            if (callback) callback();
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "_processEvent", (identifier, builtEvent, context, callback)=>{
            this._testingCache.saveEvent(builtEvent);
            if (this._shouldEventBeDelayed(builtEvent)) {
                this._delayEvent(identifier, builtEvent, context, this._userInfo, callback);
                return Promise.resolve();
            } else return this._fireEvent(identifier, builtEvent, context, callback);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "setEmbeddedProduct", (embeddedProduct)=>{
            this._internalProductInfo.embeddedProduct = this._createEmbeddedProductGetter(embeddedProduct);
            this.resetUIViewedTimers();
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "clearEmbeddedProduct", ()=>{
            this._internalProductInfo.embeddedProduct = this._createEmbeddedProductGetter(null);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "setSubproduct", (subproduct)=>{
            this._internalProductInfo.subproduct = this._createSubproductGetter(subproduct);
            this.resetUIViewedTimers();
        });
        /**
      * Calling this function in the intialisation of the client in product
      * captures specified 'origin tracing' URL params and fires a single origin landed event
      * <p>
      * This function expects a mapping between the keys for any URL parameters
      *  that should be captured and removed for origin tracing
      * Multiple parameters may be captured simultaneously if multiple key: handler function pairs are provided
      * Each handler function should return an object with two items
      * a) 'originTracingAttributes' - an object that will be added to the 'origin landed' event's attributes under 'originTracing
      * b) 'taskSessionId' (optional) - an Id string that will be added to the tasksessions for any event that fires from the tab, with the key
      *    matching the URL parameter, for the purpose of attributing subsequent analytics event to the origin land.
      * </p>
      * The general use case for this feature is for allowing attributation of user behaviour to a out of product or cross product link,
      * e.g. from a share or email
      *
      * An example calling this function using an external decoding library, with taskSessionId specified to persist
      * analyticsWebClient.setOriginTracingHandlers({
           atlOrigin: encodedOrigin => {
               const { id, product } = OriginTracing.fromEncoded(encodedOrigin);
               return { originTracingAttributes: {'id': id, 'product': product}, taskSessionId: id };
           },
       });
      *
      * @param  {Object} originParamHandlerMapping a dictionary of mappings between origin url param keys and handler functions
      * @this {AnalyticsWebClient}
      */ (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "setOriginTracingHandlers", (originParamHandlerMapping)=>{
            const capturedOriginTraces = this._originTracing.handleOriginParameters(originParamHandlerMapping, this._historyReplaceFn);
            Object.keys(capturedOriginTraces).forEach((x)=>{
                if (typeof capturedOriginTraces[x].taskSessionId !== 'undefined') this._task.createTaskSessionWithProvidedId(x, capturedOriginTraces[x].taskSessionId);
            });
            const originAttributes = {};
            Object.keys(capturedOriginTraces).forEach((x)=>{
                if (capturedOriginTraces[x].originTracingAttributes) originAttributes[x] = capturedOriginTraces[x].originTracingAttributes;
                else // eslint-disable-next-line no-console
                console.warn(`Handling method for origin parameter ${x} has not returned any attributes`);
            });
            if (Object.keys(capturedOriginTraces).length > 0) return this.sendOperationalEvent({
                action: 'landed',
                actionSubject: 'origin',
                source: 'webClient',
                attributes: {
                    originTracesLanded: originAttributes
                }
            }, // eslint-disable-next-line @typescript-eslint/no-empty-function
            ()=>{});
            return Promise.resolve();
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "setTenantInfo", (tenantIdType, tenantId)=>{
            if (!tenantIdType) throw new Error('Missing tenantIdType');
            if (tenantIdType !== (0, $9c4c150c990b1f10$export$496f06ac2a964da2).NONE && !tenantId) throw new Error('Missing tenantId');
            if (!(0, $9c4c150c990b1f10$export$26b9f946b448f23e)((0, $9c4c150c990b1f10$export$496f06ac2a964da2), tenantIdType)) throw new Error(`Invalid tenantIdType '${tenantIdType}', ` + `must be an tenantType: [${(0, $9c4c150c990b1f10$export$ad1854f4a08c15f8)((0, $9c4c150c990b1f10$export$496f06ac2a964da2))}]`);
            this._tenantInfo = {
                tenantIdType: tenantIdType,
                tenantId: tenantId
            };
            this._eventProcessor.refreshMetadata(this._userInfo, this._tenantInfo);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "clearTenantInfo", ()=>{
            this._tenantInfo = {};
            this._eventProcessor.refreshMetadata(this._userInfo, this._tenantInfo);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "setOrgInfo", (orgId)=>{
            if (!orgId) throw new Error('Missing orgId');
            this._orgInfo = {
                orgId: orgId
            };
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "clearOrgInfo", ()=>{
            this._orgInfo = {};
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "setWorkspaceInfo", (workspaceId)=>{
            if (!workspaceId) throw new Error('Missing workspaceId');
            this._workspaceInfo = {
                workspaceId: workspaceId
            };
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "clearWorkspaceInfo", ()=>{
            this._workspaceInfo = {};
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "setUserInfo", (userIdType, userId)=>{
            (0, $a18f32a70fa41827$export$c16a4e16aa4026c0)(userIdType, userId);
            this._changeInternalUserId(userId);
            this._userInfo = {
                userIdType: userIdType,
                userId: userId,
                anonymousId: this._eventProcessor.getUser().getAnonymousId()
            };
            this._eventProcessor.refreshMetadata(this._userInfo, this._tenantInfo);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "clearUserInfo", ()=>{
            this._changeInternalUserId(undefined);
            this._userInfo = {
                anonymousId: this._eventProcessor.getUser().getAnonymousId()
            };
            this._eventProcessor.refreshMetadata(this._userInfo, this._tenantInfo);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "setAlias", (aliasKeyType, alias)=>{
            if (!aliasKeyType) throw new Error('Missing aliasType');
            if (!(0, $9c4c150c990b1f10$export$26b9f946b448f23e)((0, $9c4c150c990b1f10$export$a8c99e46b781d936), aliasKeyType)) throw new Error(`Invalid aliasType '${aliasKeyType}', ` + `must be an aliasType: [${(0, $9c4c150c990b1f10$export$ad1854f4a08c15f8)((0, $9c4c150c990b1f10$export$a8c99e46b781d936))}]`);
            this._aliases[aliasKeyType] = alias;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "clearAlias", ()=>{
            this._aliases = {};
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "setGroup", (groupsKeyType, group)=>{
            if (!groupsKeyType) throw new Error('Missing groupType');
            if (!(0, $9c4c150c990b1f10$export$26b9f946b448f23e)((0, $9c4c150c990b1f10$export$e73680b18d9b7c6e), groupsKeyType)) throw new Error(`Invalid groupType '${groupsKeyType}', ` + `must be an groupType: [${(0, $9c4c150c990b1f10$export$ad1854f4a08c15f8)((0, $9c4c150c990b1f10$export$e73680b18d9b7c6e))}]`);
            this._groups[groupsKeyType] = group;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "clearGroup", ()=>{
            this._groups = {};
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "getAnonymousId", ()=>this._userInfo.anonymousId);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "getCurrentSessionId", ()=>this._sessionTracking.getCurrentSessionId());
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "setUIViewedAttributes", (uiViewedAttributes)=>{
            if (!uiViewedAttributes) throw new Error('Missing uiViewedAttributes');
            if (typeof uiViewedAttributes !== 'object' || Array.isArray(uiViewedAttributes)) throw new Error('Invalid uiViewedAttributes type, should be a non array object');
            this._uiViewedAttributes = $4667273d53967e9d$var$_objectSpread({}, uiViewedAttributes);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "getUIViewedAttributes", ()=>{
            return this._uiViewedAttributes;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "clearUIViewedAttributes", ()=>{
            this._uiViewedAttributes = {};
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "appendUIViewedAttributes", (attributes)=>{
            if (!this._uiViewedAttributes) this._uiViewedAttributes = attributes;
            else this._uiViewedAttributes = $4667273d53967e9d$var$_objectSpread($4667273d53967e9d$var$_objectSpread({}, this._uiViewedAttributes), attributes);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "sendIdentifyEvent", (userIdType, userId, callback)=>{
            this.setUserInfo(userIdType, userId);
            const builtEvent = {
                userIdType: userIdType,
                eventType: (0, $9c4c150c990b1f10$export$4c045e605d532c98).IDENTIFY
            };
            return this._processEvent(userId, builtEvent, this._context, callback);
        });
        /**
     * @deprecated
     * please use {@link sendScreenEvent instead)
     */ (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "sendPageEvent", (name, callback)=>{
            return this.sendScreenEvent(name, callback);
        });
        /**
     * send screen event
     * @param event The event / For retrocompatibility event name is still supported here.
     * @param callback
     * @param attributes. Deprecated, will get ignored if using an event object as first param.
     */ (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "sendScreenEvent", (event, callback, attributes)=>{
            let screenName;
            let screenAttributes;
            let screenContainers;
            let screenTags;
            if (typeof event === 'object') {
                /* This is for retrocompatibility */ screenName = event.name;
                screenAttributes = event.attributes;
                screenContainers = event.containers;
                screenTags = event.tags;
            } else {
                screenName = event;
                screenAttributes = attributes;
            }
            (0, $a18f32a70fa41827$export$dc993432a592dc27)(screenName);
            (0, $a18f32a70fa41827$export$e63ea5d8477971d3)(screenContainers);
            const builtEvent = (0, $8f748e4bbc815a77$export$c7d9a5f56acc4b19)(this._internalProductInfo, this._tenantInfo, this._userInfo, screenAttributes, // TODO: Remove the as any and move into a place where we know event is an object
            event.nonPrivacySafeAttributes, screenTags, this._tabTracking.getCurrentTabId(), this._sessionTracking.getCurrentSessionId(), this._task.getAllTaskSessions(), this._crossProductInteractionTracking.getInteractionSession(), this._orgInfo, this._pageLoadId, this._workspaceInfo, event, screenContainers, this._aliases, this._groups);
            const builtEventWithName = $4667273d53967e9d$var$_objectSpread({
                name: screenName
            }, builtEvent);
            this._setLastScreenEvent(builtEventWithName);
            return this._processEvent(screenName, builtEventWithName, this._context, (0, $5c22578f1038a2ab$export$2e2bcd8739ae039)(callback, builtEventWithName));
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "sendTrackEvent", (event, callback)=>{
            (0, $a18f32a70fa41827$export$8c014fd74b0c8b99)(event);
            const builtEvent = (0, $8f748e4bbc815a77$export$7bf451af4a8e3dd9)(this._internalProductInfo, this._tenantInfo, this._userInfo, event, (0, $9c4c150c990b1f10$export$4c045e605d532c98).TRACK, this._tabTracking.getCurrentTabId(), this._sessionTracking.getCurrentSessionId(), this._task.getAllTaskSessions(), this._crossProductInteractionTracking.getInteractionSession(), this._orgInfo, this._pageLoadId, this._workspaceInfo, this._aliases, this._groups);
            return this._processEvent((0, $8f748e4bbc815a77$export$9c5623a792efc9b0)(event), builtEvent, this._context, (0, $5c22578f1038a2ab$export$2e2bcd8739ae039)(callback, builtEvent));
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "sendUIEvent", (event, callback)=>{
            (0, $a18f32a70fa41827$export$e5bac0930c812e90)(event);
            const builtEvent = (0, $8f748e4bbc815a77$export$7bf451af4a8e3dd9)(this._internalProductInfo, this._tenantInfo, this._userInfo, event, (0, $9c4c150c990b1f10$export$4c045e605d532c98).UI, this._tabTracking.getCurrentTabId(), this._sessionTracking.getCurrentSessionId(), this._task.getAllTaskSessions(), this._crossProductInteractionTracking.getInteractionSession(), this._orgInfo, this._pageLoadId, this._workspaceInfo, this._aliases, this._groups);
            return this._processEvent((0, $8f748e4bbc815a77$export$9c5623a792efc9b0)(event), builtEvent, this._context, (0, $5c22578f1038a2ab$export$2e2bcd8739ae039)(callback, builtEvent));
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "sendOperationalEvent", (event, callback)=>{
            (0, $a18f32a70fa41827$export$1e561554275607ef)(event);
            const builtEvent = (0, $8f748e4bbc815a77$export$7bf451af4a8e3dd9)(this._internalProductInfo, this._tenantInfo, this._userInfo, event, (0, $9c4c150c990b1f10$export$4c045e605d532c98).OPERATIONAL, this._tabTracking.getCurrentTabId(), this._sessionTracking.getCurrentSessionId(), this._task.getAllTaskSessions(), this._crossProductInteractionTracking.getInteractionSession(), this._orgInfo, this._pageLoadId, this._workspaceInfo, this._aliases, this._groups);
            return this._processEvent((0, $8f748e4bbc815a77$export$9c5623a792efc9b0)(event), builtEvent, this._context, (0, $5c22578f1038a2ab$export$2e2bcd8739ae039)(callback, builtEvent));
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "startUIViewedEvent", (callback)=>{
            this.stopUIViewedEvent();
            this._uiViewedEvent = new (0, $3354a6ae24846e2f$export$2e2bcd8739ae039)(this._internalProductInfo, ()=>({
                    embeddedProduct: this._internalProductInfo.embeddedProduct(),
                    subproduct: this._internalProductInfo.subproduct(),
                    tenantIdType: this._tenantInfo.tenantIdType,
                    tenantId: this._tenantInfo.tenantId,
                    userId: this._userInfo.userId,
                    lastScreenEvent: this._getLastScreenEvent(),
                    attributes: this._uiViewedAttributes
                }), (event)=>this.sendUIEvent(event, callback));
            this._uiViewedEvent.start();
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "stopUIViewedEvent", ()=>{
            if (this._uiViewedEvent) {
                this._uiViewedEvent.stop();
                this._uiViewedEvent = null;
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "resetUIViewedTimers", ()=>{
            if (this._uiViewedEvent) this._uiViewedEvent.resetTimers();
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "startApdexEvent", (apdexEvent)=>{
            this._apdexEvent.start(apdexEvent);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "getApdexStart", (apdexEvent)=>this._apdexEvent.getStart(apdexEvent));
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "stopApdexEvent", (apdexEvent, callback)=>{
            this._apdexEvent.stop(apdexEvent, callback);
        });
        // TODO If we ever make another breaking change, merge these two optional args into an `options` object arg.
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "startLowPriorityEventDelay", (timeout, callback)=>{
            this._eventDelayQueue.startLowPriorityEventDelay(timeout, callback);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "stopLowPriorityEventDelay", ()=>{
            this._eventDelayQueue.stopLowPriorityEventDelay();
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "onEvent", (_analyticsId, analyticsData)=>{
            if (!analyticsData) throw new Error('Missing analyticsData');
            if (!analyticsData.eventType) throw new Error('Missing analyticsData.eventType');
            if (analyticsData.eventType === (0, $9c4c150c990b1f10$export$4c045e605d532c98).TRACK) return this.sendTrackEvent(analyticsData);
            else if (analyticsData.eventType === (0, $9c4c150c990b1f10$export$4c045e605d532c98).UI) return this.sendUIEvent(analyticsData);
            else if (analyticsData.eventType === (0, $9c4c150c990b1f10$export$4c045e605d532c98).OPERATIONAL) return this.sendOperationalEvent(analyticsData);
            else if (analyticsData.eventType === (0, $9c4c150c990b1f10$export$4c045e605d532c98).SCREEN) return this.sendScreenEvent(analyticsData.name, null, analyticsData.attributes);
            else if (analyticsData.eventType === (0, $9c4c150c990b1f10$export$4c045e605d532c98).IDENTIFY) return this.sendIdentifyEvent(analyticsData.userIdType, analyticsData.userId);
            throw new Error(`Invalid analyticsData.eventType '${analyticsData.eventType}', ` + `must be an eventType: [${(0, $9c4c150c990b1f10$export$ad1854f4a08c15f8)((0, $9c4c150c990b1f10$export$4c045e605d532c98))}]`);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "setResponseCallback", (responseCallback)=>{
            this._eventProcessor.setResponseCallback(responseCallback);
        });
        if (!productInfo) throw new Error('Missing productInfo');
        if (!productInfo.env) throw new Error('Missing productInfo.env');
        if (!productInfo.product) throw new Error('Missing productInfo.product');
        if (!(0, $9c4c150c990b1f10$export$26b9f946b448f23e)((0, $9c4c150c990b1f10$export$56ac8ebc9870b1b9), productInfo.env)) throw new Error(`Invalid productInfo.env '${productInfo.env}', ` + `must be an envType: [${(0, $9c4c150c990b1f10$export$ad1854f4a08c15f8)((0, $9c4c150c990b1f10$export$56ac8ebc9870b1b9))}]`);
        if (productInfo.perimeter && !(0, $9c4c150c990b1f10$export$26b9f946b448f23e)((0, $9c4c150c990b1f10$export$bdd41749d2096e4b), productInfo.perimeter)) throw new Error(`Invalid productInfo.perimeter '${productInfo.perimeter}', ` + `must be an perimeterType: [${(0, $9c4c150c990b1f10$export$ad1854f4a08c15f8)((0, $9c4c150c990b1f10$export$bdd41749d2096e4b))}]`);
        if (!productInfo.origin) productInfo.origin = (0, $9c4c150c990b1f10$export$f73e9fcd368bb695).WEB;
        else if (!(0, $9c4c150c990b1f10$export$26b9f946b448f23e)((0, $9c4c150c990b1f10$export$f73e9fcd368bb695), productInfo.origin)) throw new Error(`Invalid productInfo.origin '${productInfo.origin}', ` + `must be an originType: [${(0, $9c4c150c990b1f10$export$ad1854f4a08c15f8)((0, $9c4c150c990b1f10$export$f73e9fcd368bb695))}]`);
        if (!productInfo.platform) productInfo.platform = productInfo.origin === (0, $9c4c150c990b1f10$export$f73e9fcd368bb695).WEB ? (0, $9c4c150c990b1f10$export$6b4f396210e539f3).WEB : (0, $9c4c150c990b1f10$export$6b4f396210e539f3).DESKTOP;
        else (0, $a18f32a70fa41827$export$801b46c35394d316)(productInfo);
        this._logger = settings.logger || console;
        this._internalProductInfo = $4667273d53967e9d$var$_objectSpread($4667273d53967e9d$var$_objectSpread({}, productInfo), {}, {
            subproduct: this._createSubproductGetter(productInfo.subproduct),
            embeddedProduct: this._createEmbeddedProductGetter(productInfo.embeddedProduct)
        });
        this._tenantInfo = {};
        this._orgInfo = {};
        this._uiViewedAttributes = {};
        if (productInfo !== null && productInfo !== void 0 && productInfo.embeddedContext) {
            this._embeddedContext = productInfo.embeddedContext;
            if ((0, $a92a49061b862547$export$f56713ced121eb91)(this._embeddedContext)) this.setUIViewedAttributes({
                embeddedType: this._embeddedContext['embeddedType'],
                embeddedFromProduct: this._embeddedContext['embeddedFromProduct'],
                embeddedFromSubproduct: this._embeddedContext['embeddedFromSubproduct'],
                embeddedFromTopLevelDomain: this._embeddedContext['embeddedFromTopLevelDomain']
            });
            if ((0, $a92a49061b862547$export$ab34f90cc32c8960)(this._embeddedContext)) this.setUIViewedAttributes({
                embeddedType: this._embeddedContext['embeddedType'],
                embeddedFromTopLevelDomain: this._embeddedContext['embeddedFromTopLevelDomain']
            });
        }
        this._context = (0, $8f748e4bbc815a77$export$3a7fe28f9bf4f3d9)(this._internalProductInfo);
        this._safeSessionStorage = new (0, $94e352d257707d44$export$2e2bcd8739ae039)();
        const _useStargate = this._useStargate(settings.useStargate);
        const apiHost = settings.apiHost || (0, $f9df0b541c3a14c4$export$18c0b81944902eae)({
            useStargate: _useStargate,
            env: productInfo.env,
            useLegacyUrl: settings.useLegacyUrl,
            perimeter: productInfo.perimeter,
            ic: productInfo.ic,
            envOverride: productInfo.envOverride
        });
        const apiHostProtocol = settings.apiHostProtocol || 'https';
        const minRetryDelay = settings.minRetryDelay || 1000;
        const maxAttempts = settings.maxRetryAttempts !== undefined && Number.isInteger(settings.maxRetryAttempts) && settings.maxRetryAttempts >= 0 ? settings.maxRetryAttempts + 1 : undefined;
        const retryQueueOptions = {
            maxRetryDelay: 60000,
            minRetryDelay: minRetryDelay,
            backoffFactor: 2,
            flushWaitMs: settings.flushWaitInterval,
            flushBeforeUnload: settings.flushBeforeUnload,
            maxAttempts: maxAttempts
        };
        const retryQueuePrefix = `awc-${productInfo.env}`;
        const xidPromiseGetter = ()=>(0, $cfa945807de0debd$export$fbe53bbbe682bcdd)(settings.xidConsent, settings.xidPromiseFn);
        const disableCookiePersistence = settings.disableCookiePersistence || false;
        const metadataClientFactory = settings.metadataClientFactory || (0, $5f0f1169c182c3a3$export$1ac223ae496131c9).Factory;
        const metadataClient = metadataClientFactory(apiHostProtocol, apiHost, productInfo.product);
        this._eventProcessor = new (0, $703a7f160fd6ee7a$export$2e2bcd8739ae039)({
            apiHost: apiHost,
            apiHostProtocol: apiHostProtocol,
            product: productInfo.product,
            retryQueuePrefix: retryQueuePrefix,
            retryQueueOptions: retryQueueOptions,
            xidPromiseGetter: xidPromiseGetter,
            logger: this._logger,
            metadataClient: metadataClient,
            disableCookiePersistence: disableCookiePersistence,
            responseCallback: $4667273d53967e9d$export$48361b6ed38f1b0.getCallback(this._logger),
            env: productInfo.env,
            perimeter: productInfo.perimeter,
            enableMetadataCalls: this.metadataCallsEnabled(settings),
            enableEventCalls: this.eventCallsEnabled(settings)
        });
        this._userInfo = {
            anonymousId: this._eventProcessor.getUser().getAnonymousId(settings === null || settings === void 0 ? void 0 : settings.customAnonymousIdGenerator)
        };
        this._pageVisibility = new (0, $5a0c8cae642f3b67$export$2e2bcd8739ae039)();
        this._tabTracking = new (0, $de631ded0d60c70b$export$2e2bcd8739ae039)();
        this._sessionTracking = new (0, $43d30f76663fb1b4$export$2e2bcd8739ae039)({
            sessionExpiryTime: settings.sessionExpiryTime,
            onNewSessionStarted: settings.onNewSessionStarted
        });
        this._task = new (0, $ef2ff75caf77a3e2$export$2e2bcd8739ae039)();
        this._originTracing = new (0, $c71ed008013c1ce7$export$2e2bcd8739ae039)();
        // Init Apdex
        this._apdexEvent = new (0, $046c48c9d0dd9a40$export$2e2bcd8739ae039)(this.sendOperationalEvent, this._pageVisibility);
        this._historyReplaceFn = typeof settings.historyReplaceFn === 'function' ? settings.historyReplaceFn : (0, $21fc6f103b6afda8$export$600dd5bf1b049f11);
        this._eventDelayQueue = new (0, $6c1a0a725e9fc5bf$export$2e2bcd8739ae039)(this._fireDelayedEvent, settings.delayQueueCompressors || []);
        this._testingCache = new (0, $60f01de259a84dee$export$2e2bcd8739ae039)(settings.isSynthetic, settings.enableTestingCache);
        this._pageLoadId = (0, $16f8259e8856e670$export$2e2bcd8739ae039)();
        this._workspaceInfo = {};
        this._aliases = {};
        this._groups = {};
        this._crossProductInteractionTracking = new (0, $293604237edd7ee5$export$2e2bcd8739ae039)({
            perimeter: productInfo.perimeter,
            product: productInfo.product,
            sendEventCallback: this.sendOperationalEvent,
            historyReplaceFn: this._historyReplaceFn
        });
        this._crossProductInteractionTracking.validateInteractionSession();
    }
    metadataCallsEnabled(settings) {
        if (typeof settings.disableMetadataCalls === 'boolean') return !settings.disableMetadataCalls;
        return !(0, $edecb1e04eb94083$export$44b578549c42d779).isGeminiVREnvironment() && !(0, $edecb1e04eb94083$export$44b578549c42d779).areFetchCallsDisabled();
    }
    eventCallsEnabled(settings) {
        if (typeof settings.disableEventCalls === 'boolean') return !settings.disableEventCalls;
        return !(0, $edecb1e04eb94083$export$44b578549c42d779).isGeminiVREnvironment() && !(0, $edecb1e04eb94083$export$44b578549c42d779).areFetchCallsDisabled();
    }
    setEventValidationMode(eventValidationMode) {
        this._context.context.validationMode = eventValidationMode;
    }
    /**
   * @private
   * @deprecated
   * Please avoid using internal properties. They are not part of the public
   * API and may change without notice.
   *
   * This property has been exposed for backward compatibility with existing
   * tests in external code
   */ get task() {
        return this._task;
    }
    /**
   * @private
   * @deprecated
   * Please avoid using internal properties.
   * They are not part of the public API and may change without notice.
   *
   * This property has been exposed for backward compatibility with existing
   * tests in external code
   */ get _productInfo() {
        return this._internalProductInfo;
    }
}



var $bDLqY = parcelRequire("bDLqY");
const $45964660615f0a60$var$mapEnvironmentToAnalyticsEnvType = ()=>{
    return (0, $9c4c150c990b1f10$export$56ac8ebc9870b1b9).PROD;
};
const $45964660615f0a60$var$init = ()=>{
    const analyticsClient = new (0, $4667273d53967e9d$export$2e2bcd8739ae039)({
        env: $45964660615f0a60$var$mapEnvironmentToAnalyticsEnvType(),
        product: 'appUpdates',
        version: '1.0.0',
        origin: (0, $9c4c150c990b1f10$export$f73e9fcd368bb695).WEB
    }, {
        useLegacyUrl: true
    });
    const aaid = (0, (/*@__PURE__*/$parcel$interopDefault($bDLqY))).get('aaid');
    if (aaid) analyticsClient.setUserInfo((0, $9c4c150c990b1f10$export$1827adfd178b4870).ATLASSIAN_ACCOUNT, aaid);
    return analyticsClient;
};
let $45964660615f0a60$var$analyticsClient = null;
const $45964660615f0a60$export$e9ba7ef9458d1a4a = ()=>{
    if ($45964660615f0a60$var$analyticsClient === null) $45964660615f0a60$var$analyticsClient = $45964660615f0a60$var$init();
    return $45964660615f0a60$var$analyticsClient;
};
const $45964660615f0a60$export$5e53520e517ec9ab = (client, eventType, event)=>{
    switch(eventType){
        case 'screen':
            client.sendScreenEvent(event);
            break;
        case 'track':
            client.sendTrackEvent(event);
            break;
        case 'ui':
            client.sendUIEvent(event);
            break;
        case 'operational':
            client.sendOperationalEvent(event);
            break;
        default:
            throw new Error(`Invalid event type: ${eventType}`);
    }
};




var $5FkrB = parcelRequire("5FkrB");
/**
 * OneTrust consent category ID for "Performance Cookies" (analytics/tracking).
 * OneTrust serializes active groups as a comma-delimited string, e.g. ",1,2,3,".
 * We wrap the ID in commas to avoid false-positive substring matches (e.g. ",12,"
 * accidentally matching a check for "2").
 *
 * If your OneTrust configuration uses a different category ID for analytics,
 * update this constant. Category IDs are found in your OneTrust admin console
 * under: Cookie Compliance > Categorizations.
 */ const $38056d680fac42ff$var$ONETRUST_ANALYTICS_CATEGORY = ',2,';
const $38056d680fac42ff$var$OneTrustContext = /*#__PURE__*/ (0, $5FkrB.createContext)(null);
const $38056d680fac42ff$export$b224af886b957a5e = ()=>{
    const context = (0, $5FkrB.useContext)($38056d680fac42ff$var$OneTrustContext);
    if (context === null) throw new Error('calls to useOneTrustContext must be wrapped in <OneTrustProvider>');
    return context;
};
const $38056d680fac42ff$export$52310512b1bd7aec = ({ children: children })=>{
    const [analyticsOptOut, setAnalyticsOptOut] = (0, $5FkrB.useState)(true);
    const [onetrustActiveGroups, setOnetrustActiveGroups] = (0, $5FkrB.useState)(typeof window !== 'undefined' ? window.OnetrustActiveGroups : undefined);
    // Store the interval ID in a ref so it is always current inside the closure,
    // avoiding the stale-variable bug that occurred when reassigning a `let` that
    // the cleanup function had already captured.
    const intervalRef = (0, $5FkrB.useRef)(undefined);
    (0, $5FkrB.useEffect)(()=>{
        const checkOnetrustActiveGroups = ()=>{
            if (window.OnetrustActiveGroups === undefined) return;
            setOnetrustActiveGroups(window.OnetrustActiveGroups);
            // React batches identical state updates as a no-op, so no need to
            // compare before calling the setter.
            setAnalyticsOptOut(!window.OnetrustActiveGroups.includes($38056d680fac42ff$var$ONETRUST_ANALYTICS_CATEGORY));
            /**
       * Clear the interval once OneTrust has been initialized and only recheck
       * every 1 sec if the opt-out status is still the default (true).
       */ clearInterval(intervalRef.current);
            if (!window.OnetrustActiveGroups.includes($38056d680fac42ff$var$ONETRUST_ANALYTICS_CATEGORY)) intervalRef.current = setInterval(checkOnetrustActiveGroups, 1000);
        };
        // Start the initial 250ms poll. The effect runs once on mount only.
        intervalRef.current = setInterval(checkOnetrustActiveGroups, 250);
        return ()=>{
            clearInterval(intervalRef.current);
        };
    // Empty deps array is intentional: this effect sets up a one-time interval on
    // mount. State setters (setAnalyticsOptOut, setOnetrustActiveGroups) have
    // stable identities guaranteed by React, and intervalRef is a stable ref
    // container — so listing them would cause unnecessary re-subscriptions.
    }, []); // eslint-disable-line react-hooks/exhaustive-deps
    return /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)($38056d680fac42ff$var$OneTrustContext.Provider, {
        value: {
            analyticsOptOut: analyticsOptOut,
            onetrustActiveGroups: onetrustActiveGroups
        },
        children: children
    });
};



parcelRequire("5FkrB");

const $8c48fdd8d5a3abf9$var$ONETRUST_SCRIPT_DOMAIN = "atl-onetrust-wrapper.atlassian.com";
const $8c48fdd8d5a3abf9$var$ONETRUST_GUID = "336ea4c3-54ae-40f0-9331-b4500ffed1ee";
const $8c48fdd8d5a3abf9$var$IS_NON_PROD = false;
const $8c48fdd8d5a3abf9$export$4719288a8f5f7e71 = ({ children: children })=>/*#__PURE__*/ (0, $faf30355a80342e4$exports.jsxs)((0, $448e9b7b3295f6e4$export$4719288a8f5f7e71), {
        children: [
            /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $448e9b7b3295f6e4$export$dcef8f9bb9a41431), {
                children: /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)("script", {
                    src: `https://${$8c48fdd8d5a3abf9$var$ONETRUST_SCRIPT_DOMAIN}/assets/atl-onetrust-wrapper.min.js`,
                    type: "text/javascript",
                    "data-domain": $8c48fdd8d5a3abf9$var$ONETRUST_GUID,
                    "data-test": $8c48fdd8d5a3abf9$var$IS_NON_PROD,
                    "data-geofence": "false",
                    "data-sync": "true"
                })
            }),
            children
        ]
    });




const $a442bdf486731fcc$export$62b6ee20d27ead99 = ()=>{
    const { analyticsOptOut: analyticsOptOut } = (0, $38056d680fac42ff$export$b224af886b957a5e)();
    const sendScreenEvent = (0, $5FkrB.useCallback)((event)=>{
        if (analyticsOptOut) return;
        const client = (0, $45964660615f0a60$export$e9ba7ef9458d1a4a)();
        (0, $45964660615f0a60$export$5e53520e517ec9ab)(client, 'screen', event);
    }, [
        analyticsOptOut
    ]);
    const sendTrackEvent = (0, $5FkrB.useCallback)((event)=>{
        if (analyticsOptOut) return;
        const client = (0, $45964660615f0a60$export$e9ba7ef9458d1a4a)();
        (0, $45964660615f0a60$export$5e53520e517ec9ab)(client, 'track', event);
    }, [
        analyticsOptOut
    ]);
    const sendUIEvent = (0, $5FkrB.useCallback)((event)=>{
        if (analyticsOptOut) return;
        const client = (0, $45964660615f0a60$export$e9ba7ef9458d1a4a)();
        (0, $45964660615f0a60$export$5e53520e517ec9ab)(client, 'ui', event);
    }, [
        analyticsOptOut
    ]);
    const sendOperationalEvent = (0, $5FkrB.useCallback)((event)=>{
        if (analyticsOptOut) return;
        const client = (0, $45964660615f0a60$export$e9ba7ef9458d1a4a)();
        (0, $45964660615f0a60$export$5e53520e517ec9ab)(client, 'operational', event);
    }, [
        analyticsOptOut
    ]);
    return {
        sendScreenEvent: sendScreenEvent,
        sendTrackEvent: sendTrackEvent,
        sendUIEvent: sendUIEvent,
        sendOperationalEvent: sendOperationalEvent
    };
};


const $420420e53272417e$export$defe85febe8b728c = (0, $aRMzY.defineMessages)({
    product: {
        id: 'appUpdates.filters.product.label',
        description: 'Label for the product filter',
        defaultMessage: 'App'
    }
});
const $420420e53272417e$var$productOptionStyles = (0, $c1bec583fa49072f$export$f6c783d06584602c)({
    display: 'flex',
    alignItems: 'center',
    gap: 'space.100',
    minHeight: '24px',
    overflow: 'hidden'
});
// Product.id is UiProductType (e.g. 'JIRA_SOFTWARE') for consistent client-side representation
const $420420e53272417e$var$products = Object.entries((0, $50e94d71524dc43e$export$c6f09e1afd88c25a)()).map(([key, config])=>({
        id: key,
        name: config.displayName,
        icon: config.icon
    }));
const $420420e53272417e$var$productOptions = $420420e53272417e$var$products.map((product)=>({
        label: product.name,
        value: product.id,
        optionType: 'option'
    })).sort((a, b)=>a.label.localeCompare(b.label));
const $420420e53272417e$export$92fd9c7e7e5e91e9 = ()=>{
    const { formatMessage: formatMessage } = (0, $6Wx3K.default)();
    const { state: state, dispatch: dispatch } = (0, $4933e76bd0ca959e$export$7653fec709d1e7bb)();
    const { sendUIEvent: sendUIEvent } = (0, $a442bdf486731fcc$export$62b6ee20d27ead99)();
    const getSelectedProducts = ()=>{
        const selectedProducts = state.updates.draftFilters.selectedProducts;
        if (!selectedProducts || selectedProducts.length === 0) return [];
        return selectedProducts.map((selectedProduct)=>$420420e53272417e$var$productOptions.find((option)=>option.value === selectedProduct.id)).filter((option)=>option !== undefined);
    };
    const onProductFilterChange = (options)=>{
        const selectedProductValues = options.map((option)=>{
            const product = $420420e53272417e$var$products.find((candidate)=>candidate.id === option.value);
            return product;
        });
        dispatch({
            type: 'FILTER_APP_SELECT',
            payload: {
                selectedProducts: selectedProductValues.length > 0 ? selectedProductValues : null
            }
        });
        // Send analytics event
        const updatesAppTypes = selectedProductValues.length > 0 ? selectedProductValues.map((p)=>p.id).join(',') : undefined;
        sendUIEvent((0, $3e8e9266fe04abe4$export$73f866ce8175509a).ui.appUpdatesAppFilterClicked({
            source: 'appUpdatesListScreen'
        }, updatesAppTypes).data);
    };
    // AGENT: do not change next line, it is correct as is
    const formatProduct = (option)=>{
        return /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $383dd904a5a5e5b0$export$2e2bcd8739ae039), {
            testId: `app-filter-option-${option.value}`,
            children: /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsxs)((0, $383dd904a5a5e5b0$export$2e2bcd8739ae039), {
                as: "div",
                xcss: $420420e53272417e$var$productOptionStyles,
                children: [
                    /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $7397f708924e0bda$export$1a199e029d5e93d6), {
                        productType: option.value,
                        size: "xsmall",
                        testId: `app-icon-${option.value}`
                    }),
                    /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $383dd904a5a5e5b0$export$2e2bcd8739ae039), {
                        as: "span",
                        children: option.label
                    })
                ]
            })
        });
    };
    const onLoadOptions = (search, _enableFullList, _showFullList, _showMore, _lastOption, callback)=>{
        let options = $420420e53272417e$var$productOptions.map((option)=>({
                label: option.label,
                value: option.value,
                optionType: 'option'
            }));
        if (search) {
            const searchText = search.toLowerCase();
            options = options.filter((option)=>option.label?.toLowerCase().includes(searchText));
        }
        callback({
            options: options,
            totalCount: options.length
        });
    };
    return {
        testId: 'app-updates-filter-product-app-testid',
        fieldLabel: formatMessage($420420e53272417e$export$defe85febe8b728c.product),
        fieldId: 'app-updates-table-app-filter',
        onLoadOptions: onLoadOptions,
        value: getSelectedProducts(),
        onChange: onProductFilterChange,
        onClearValues: ()=>onProductFilterChange([]),
        formatOptionLabel: formatProduct
    };
};
const $420420e53272417e$export$47ad17e195465d2c = ()=>{
    const filterProps = $420420e53272417e$export$92fd9c7e7e5e91e9();
    return /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $57e93f82e6ef5a0a$export$2e2bcd8739ae039), {
        ...filterProps
    });
};



parcelRequire("5FkrB");

var $aRMzY = parcelRequire("aRMzY");
var $6Wx3K = parcelRequire("6Wx3K");



var $aRMzY = parcelRequire("aRMzY");
const $dafe8aa59b77d934$export$fc553d92d82f7a20 = (0, $aRMzY.defineMessages)({
    comingSoon: {
        id: 'appUpdates.status.comingSoon',
        defaultMessage: 'Coming Soon',
        description: 'Coming Soon status for app updates'
    },
    planned: {
        id: 'appUpdates.status.planned',
        defaultMessage: 'Planned',
        description: 'Planned status for app updates'
    },
    rollingOut: {
        id: 'appUpdates.status.rollingOut',
        defaultMessage: 'Rolling Out',
        description: 'Rolling Out status for app updates'
    },
    generallyAvailable: {
        id: 'appUpdates.status.generallyAvailable',
        defaultMessage: 'Generally Available',
        description: 'Generally Available status for app updates'
    },
    rolledBack: {
        id: 'appUpdates.status.rolledBack',
        defaultMessage: 'Rolled Back',
        description: 'Rolled Back status for app updates'
    }
});
const $dafe8aa59b77d934$export$b42e1e02ec743c13 = {
    COMING_SOON: 'inprogress',
    PLANNED: 'default',
    ROLLING_OUT: 'new',
    GENERALLY_AVAILABLE: 'success',
    ROLLED_BACK: 'removed'
};
const $dafe8aa59b77d934$export$e238a77ea3a8cd66 = (statusId)=>{
    switch(statusId){
        case 'COMING_SOON':
            return $dafe8aa59b77d934$export$fc553d92d82f7a20.comingSoon;
        case 'PLANNED':
            return $dafe8aa59b77d934$export$fc553d92d82f7a20.planned;
        case 'ROLLING_OUT':
            return $dafe8aa59b77d934$export$fc553d92d82f7a20.rollingOut;
        case 'GENERALLY_AVAILABLE':
            return $dafe8aa59b77d934$export$fc553d92d82f7a20.generallyAvailable;
        case 'ROLLED_BACK':
            return $dafe8aa59b77d934$export$fc553d92d82f7a20.rolledBack;
        default:
            return $dafe8aa59b77d934$export$fc553d92d82f7a20.planned; // fallback
    }
};
const $dafe8aa59b77d934$export$548966735f47dde3 = (statusId)=>{
    return $dafe8aa59b77d934$export$b42e1e02ec743c13[statusId];
};




const $d25636532dab27cd$export$defe85febe8b728c = (0, $aRMzY.defineMessages)({
    status: {
        id: 'appUpdates.filters.status.label',
        description: 'Label for the status filter',
        defaultMessage: 'Status'
    }
});
const $d25636532dab27cd$var$useStatusOptions = ()=>{
    const { formatMessage: formatMessage } = (0, $6Wx3K.default)();
    return (0, $51e43113ed6c9475$export$c2352a34eb11a9e9).map((statusId)=>({
            id: statusId,
            name: formatMessage((0, $dafe8aa59b77d934$export$e238a77ea3a8cd66)(statusId))
        }));
};
const $d25636532dab27cd$export$4b6f3c4447f2ab54 = ()=>{
    const { formatMessage: formatMessage } = (0, $6Wx3K.default)();
    const { state: state, dispatch: dispatch } = (0, $4933e76bd0ca959e$export$7653fec709d1e7bb)();
    const { sendUIEvent: sendUIEvent } = (0, $a442bdf486731fcc$export$62b6ee20d27ead99)();
    const statusOptions = $d25636532dab27cd$var$useStatusOptions();
    const statusSelectOptions = statusOptions.map((status)=>({
            label: status.name,
            value: status.id,
            optionType: 'option'
        })).sort((a, b)=>a.label.localeCompare(b.label));
    const getSelectedStatuses = ()=>{
        const selectedStatuses = state.updates.draftFilters.selectedStatuses;
        if (!selectedStatuses || selectedStatuses.length === 0) return [];
        return selectedStatuses.map((selectedStatus)=>statusSelectOptions.find((option)=>option.value === selectedStatus.id)).filter((option)=>option !== undefined);
    };
    const onStatusFilterChange = (options)=>{
        const selectedStatusValues = options.map((option)=>{
            const status = statusOptions.find((candidate)=>candidate.id === option.value);
            return status;
        });
        dispatch({
            type: 'FILTER_STATUS_SELECT',
            payload: {
                selectedStatuses: selectedStatusValues.length > 0 ? selectedStatusValues : null
            }
        });
        // Send analytics event
        const updatesStatusTypes = selectedStatusValues.length > 0 ? selectedStatusValues.map((s)=>s.id).join(',') : undefined;
        sendUIEvent((0, $3e8e9266fe04abe4$export$73f866ce8175509a).ui.appUpdatesStatusFilterClicked({
            source: 'appUpdatesListScreen'
        }, updatesStatusTypes).data);
    };
    const onLoadOptions = (search, _enableFullList, _showFullList, _showMore, _lastOption, callback)=>{
        let options = statusSelectOptions.map((option)=>({
                label: option.label,
                value: option.value,
                optionType: 'option'
            }));
        if (search) {
            const searchText = search.toLowerCase();
            options = options.filter((option)=>option.label?.toLowerCase().includes(searchText));
        }
        callback({
            options: options,
            totalCount: options.length
        });
    };
    return {
        testId: 'app-updates-filter-status-testid',
        fieldLabel: formatMessage($d25636532dab27cd$export$defe85febe8b728c.status),
        fieldId: 'app-updates-table-status-filter',
        onLoadOptions: onLoadOptions,
        value: getSelectedStatuses(),
        onChange: onStatusFilterChange,
        onClearValues: ()=>onStatusFilterChange([])
    };
};
const $d25636532dab27cd$export$20cf945971e823e9 = ()=>{
    const filterProps = $d25636532dab27cd$export$4b6f3c4447f2ab54();
    return /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $57e93f82e6ef5a0a$export$2e2bcd8739ae039), {
        ...filterProps
    });
};




var $5FkrB = parcelRequire("5FkrB");

var $aRMzY = parcelRequire("aRMzY");
var $6Wx3K = parcelRequire("6Wx3K");



var $aRMzY = parcelRequire("aRMzY");
const $5f43c72173f3a108$export$ce41276cb1be92e5 = (0, $aRMzY.defineMessages)({
    improvement: {
        id: 'appUpdates.changeType.improvement',
        defaultMessage: 'Improvement',
        description: "App update is type 'Improvement'"
    },
    fix: {
        id: 'appUpdates.changeType.fix',
        defaultMessage: 'Fix',
        description: "App update is type 'Fix'"
    },
    experiment: {
        id: 'appUpdates.changeType.experiment',
        defaultMessage: 'Experiment',
        description: "App update is type 'Experiment'"
    },
    removed: {
        id: 'appUpdates.changeType.removed',
        defaultMessage: 'Removed',
        description: "App update is type 'Removed'"
    },
    announcement: {
        id: 'appUpdates.changeType.announcement',
        defaultMessage: 'Announcement',
        description: "App update is of type 'Announcement'"
    }
});
const $5f43c72173f3a108$export$58d8d249a6136224 = (changeTypeId)=>{
    switch(changeTypeId){
        case 'IMPROVEMENT':
            return $5f43c72173f3a108$export$ce41276cb1be92e5.improvement;
        case 'FIX':
            return $5f43c72173f3a108$export$ce41276cb1be92e5.fix;
        case 'EXPERIMENT':
            return $5f43c72173f3a108$export$ce41276cb1be92e5.experiment;
        case 'REMOVED':
            return $5f43c72173f3a108$export$ce41276cb1be92e5.removed;
        case 'ANNOUNCEMENT':
            return $5f43c72173f3a108$export$ce41276cb1be92e5.announcement;
        default:
            return $5f43c72173f3a108$export$ce41276cb1be92e5.improvement; // fallback
    }
};




const $4685ebf402bfe2a8$export$defe85febe8b728c = (0, $aRMzY.defineMessages)({
    changeType: {
        id: 'appUpdates.filters.changeType.label',
        description: 'Label for the change type filter',
        defaultMessage: 'Change type'
    }
});
const $4685ebf402bfe2a8$var$useChangeTypeOptions = ()=>{
    const { formatMessage: formatMessage } = (0, $6Wx3K.default)();
    return (0, $51e43113ed6c9475$export$94a5323e67ff7814).map((changeTypeId)=>({
            id: changeTypeId,
            name: formatMessage((0, $5f43c72173f3a108$export$58d8d249a6136224)(changeTypeId))
        }));
};
const $4685ebf402bfe2a8$var$useChangeTypeFilterProps = ()=>{
    const { formatMessage: formatMessage } = (0, $6Wx3K.default)();
    const { state: state, dispatch: dispatch } = (0, $4933e76bd0ca959e$export$7653fec709d1e7bb)();
    const { sendUIEvent: sendUIEvent } = (0, $a442bdf486731fcc$export$62b6ee20d27ead99)();
    const changeTypeOptions = $4685ebf402bfe2a8$var$useChangeTypeOptions();
    const selectedChangeTypes = state.updates.draftFilters.selectedChangeTypes || [];
    const changeTypeSelectOptions = selectedChangeTypes.map((changeType)=>({
            label: changeType.name,
            value: changeType.id,
            optionType: 'option'
        }));
    const onLoadOptions = (search, _enableFullList, _showFullList, _showMore, _lastOption, callback)=>{
        let options = changeTypeOptions.map((option)=>({
                label: option.name,
                value: option.id,
                optionType: 'option'
            }));
        if (search) {
            const searchText = search.toLowerCase();
            options = options.filter((option)=>option.label?.toLowerCase().includes(searchText));
        }
        callback({
            options: options,
            totalCount: options.length
        });
    };
    const handleChange = $5FkrB.useCallback((options)=>{
        const nextSelectedChangeTypes = options.map((option)=>{
            const changeType = changeTypeOptions.find((candidate)=>candidate.id === option.value);
            return changeType;
        });
        dispatch({
            type: 'FILTER_CHANGE_TYPE_SELECT',
            payload: {
                selectedChangeTypes: nextSelectedChangeTypes.length > 0 ? nextSelectedChangeTypes : null
            }
        });
        // Send analytics event
        const nextSelectedChangeTypesString = nextSelectedChangeTypes.length > 0 ? nextSelectedChangeTypes.map((c)=>c.id).join(',') : undefined;
        sendUIEvent((0, $3e8e9266fe04abe4$export$73f866ce8175509a).ui.appUpdatesTypeFilterClicked({
            source: 'appUpdatesListScreen'
        }, nextSelectedChangeTypesString).data);
    }, [
        changeTypeOptions,
        dispatch,
        sendUIEvent
    ]);
    return {
        testId: 'app-updates-filter-change-type-testid',
        fieldLabel: formatMessage($4685ebf402bfe2a8$export$defe85febe8b728c.changeType),
        fieldId: 'app-updates-table-change-type-filter',
        value: changeTypeSelectOptions,
        onLoadOptions: onLoadOptions,
        onChange: handleChange,
        onClearValues: ()=>handleChange([])
    };
};
const $4685ebf402bfe2a8$export$cbae60f067cb26e7 = ()=>{
    const props = $4685ebf402bfe2a8$var$useChangeTypeFilterProps();
    return /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $57e93f82e6ef5a0a$export$2e2bcd8739ae039), {
        ...props
    });
};



parcelRequire("5FkrB");

/**
 * Central registry of feature gate keys used in the application.
 * Add new feature gate keys here as string constants.
 */ const $86626a3c150b02ba$export$5fb62a9fe732a843 = {
    /**
   * PAU_AI_IMPACT_AND_CONTEXT_TAGS
   * @link https://hello.atlassian.net/browse/FD-202623
   * @description Controls visibility of AI-generated Impact rating and
   * Contextual tags columns on the list and details pages.
   * OFF by default — safe to merge at any time.
   * @returns true if the AI Impact and Contextual tags columns should be shown
   */ aiImpactAndContextTags: 'public_app_updates_ai_impact_and_context_tags',
    /**
   * @deprecated A fake gate key used only in unit tests to exercise the fg() utility.
   * Not a real Switcheroo gate — do not use in production code.
   */ testOnly: 'test-gate-for-unit-tests'
};


var $ISKn7 = parcelRequire("ISKn7");


const $c78886f48293f91c$var$developmentFeatureGateOverrides = {
    [(0, $86626a3c150b02ba$export$5fb62a9fe732a843).aiImpactAndContextTags]: true
};
function $c78886f48293f91c$export$b40ec24ac8275656(key) {
    try {
        return (0, $ISKn7.default).checkGate(key);
    } catch (e) {
        (0, $9654b596cdf679bc$export$2e2bcd8739ae039).warn(`[FeatureGates] Failed to check gate "${key}": ${e}`);
        return false;
    }
}






parcelRequire("5FkrB");

var $aRMzY = parcelRequire("aRMzY");
var $6Wx3K = parcelRequire("6Wx3K");




const $1c3ac60f186b4700$export$defe85febe8b728c = (0, $aRMzY.defineMessages)({
    impactRating: {
        id: 'appUpdates.filters.impactRating.label',
        description: 'Label for the impact rating filter',
        defaultMessage: 'Impact rating'
    }
});
// Defined outside component to maintain stable references — same pattern as ProductFilter
const $1c3ac60f186b4700$var$impactRatingOptions = (0, $51e43113ed6c9475$export$aafe24a01710fa9a).map((id)=>({
        id: id,
        name: (0, $51e43113ed6c9475$export$5926fcb263ea10c4)[id]
    }));
const $1c3ac60f186b4700$export$6a5de237ad57564a = ()=>{
    const { formatMessage: formatMessage } = (0, $6Wx3K.default)();
    const { state: state, dispatch: dispatch } = (0, $4933e76bd0ca959e$export$7653fec709d1e7bb)();
    const { sendUIEvent: sendUIEvent } = (0, $a442bdf486731fcc$export$62b6ee20d27ead99)();
    const impactRatingSelectOptions = $1c3ac60f186b4700$var$impactRatingOptions.map((rating)=>({
            label: rating.name,
            value: rating.id,
            optionType: 'option'
        }));
    const getSelectedRatings = ()=>{
        const selectedImpactRatings = state.updates.draftFilters.selectedImpactRatings;
        if (!selectedImpactRatings || selectedImpactRatings.length === 0) return [];
        return selectedImpactRatings.map((selectedRating)=>impactRatingSelectOptions.find((option)=>option.value === selectedRating.id)).filter((option)=>option !== undefined);
    };
    const onImpactRatingFilterChange = (options)=>{
        const selectedRatingValues = options.map((option)=>$1c3ac60f186b4700$var$impactRatingOptions.find((candidate)=>candidate.id === option.value)).filter((rating)=>rating !== undefined);
        dispatch({
            type: 'FILTER_IMPACT_RATING_SELECT',
            payload: {
                selectedImpactRatings: selectedRatingValues.length > 0 ? selectedRatingValues : null
            }
        });
        // Send analytics event
        const updatesImpactTypes = selectedRatingValues.length > 0 ? selectedRatingValues.map((r)=>r.id).join(',') : undefined;
        sendUIEvent((0, $3e8e9266fe04abe4$export$73f866ce8175509a).ui.appUpdatesImpactRatingFilterClicked({
            source: 'appUpdatesListScreen'
        }, updatesImpactTypes).data);
    };
    const onLoadOptions = (search, _enableFullList, _showFullList, _showMore, _lastOption, callback)=>{
        let options = impactRatingSelectOptions.map((option)=>({
                label: option.label,
                value: option.value,
                optionType: 'option'
            }));
        if (search) {
            const searchText = search.toLowerCase();
            options = options.filter((option)=>option.label?.toLowerCase().includes(searchText));
        }
        callback({
            options: options,
            totalCount: options.length
        });
    };
    return {
        testId: 'app-updates-filter-impact-rating-testid',
        fieldLabel: formatMessage($1c3ac60f186b4700$export$defe85febe8b728c.impactRating),
        fieldId: 'app-updates-table-impact-rating-filter',
        onLoadOptions: onLoadOptions,
        value: getSelectedRatings(),
        onChange: onImpactRatingFilterChange,
        onClearValues: ()=>onImpactRatingFilterChange([])
    };
};
const $1c3ac60f186b4700$export$9cf9bdfc86c39f2a = ()=>{
    const filterProps = $1c3ac60f186b4700$export$6a5de237ad57564a();
    return /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $57e93f82e6ef5a0a$export$2e2bcd8739ae039), {
        ...filterProps
    });
};



parcelRequire("5FkrB");

var $aRMzY = parcelRequire("aRMzY");
var $6Wx3K = parcelRequire("6Wx3K");




const $7468c2ae65c82f56$export$defe85febe8b728c = (0, $aRMzY.defineMessages)({
    contextualTags: {
        id: 'appUpdates.filters.tags.label',
        description: 'Label for the AI-generated contextual tags filter',
        defaultMessage: 'Contextual tags'
    }
});
// Defined outside component to maintain stable references
const $7468c2ae65c82f56$var$tagOptions = (0, $51e43113ed6c9475$export$f3e6ae23d6c89755).map((tagId)=>({
        id: tagId,
        name: (0, $51e43113ed6c9475$export$4bbe71e8edfbf0cd)(tagId)
    }));
const $7468c2ae65c82f56$var$tagSelectOptions = $7468c2ae65c82f56$var$tagOptions.map((tag)=>({
        label: tag.name,
        value: tag.id,
        optionType: 'option'
    }));
const $7468c2ae65c82f56$var$useTagFilterProps = ()=>{
    const { formatMessage: formatMessage } = (0, $6Wx3K.default)();
    const { state: state, dispatch: dispatch } = (0, $4933e76bd0ca959e$export$7653fec709d1e7bb)();
    const { sendUIEvent: sendUIEvent } = (0, $a442bdf486731fcc$export$62b6ee20d27ead99)();
    // Derive selected values by looking up from stable options list
    const getSelectedTags = ()=>{
        const selectedTags = state.updates.draftFilters.selectedTags;
        if (!selectedTags || selectedTags.length === 0) return [];
        return selectedTags.map((selected)=>$7468c2ae65c82f56$var$tagSelectOptions.find((option)=>option.value === selected.id)).filter((option)=>option !== undefined);
    };
    const onLoadOptions = (search, _enableFullList, _showFullList, _showMore, _lastOption, callback)=>{
        let options = $7468c2ae65c82f56$var$tagSelectOptions.map((option)=>({
                label: option.label,
                value: option.value,
                optionType: 'option'
            }));
        if (search) {
            const searchText = search.toLowerCase();
            options = options.filter((option)=>option.label?.toLowerCase().includes(searchText));
        }
        callback({
            options: options,
            totalCount: options.length
        });
    };
    const handleChange = (options)=>{
        const nextSelectedTags = options.map((option)=>$7468c2ae65c82f56$var$tagOptions.find((candidate)=>candidate.id === option.value)).filter((tag)=>tag !== undefined);
        dispatch({
            type: 'FILTER_TAG_SELECT',
            payload: {
                selectedTags: nextSelectedTags.length > 0 ? nextSelectedTags : null
            }
        });
        // Send analytics event
        const nextSelectedTagsString = nextSelectedTags.length > 0 ? nextSelectedTags.map((t)=>t.id).join(',') : undefined;
        sendUIEvent((0, $3e8e9266fe04abe4$export$73f866ce8175509a).ui.appUpdatesTagFilterClicked({
            source: 'appUpdatesListScreen'
        }, nextSelectedTagsString).data);
    };
    return {
        testId: 'app-updates-filter-tag-testid',
        fieldLabel: formatMessage($7468c2ae65c82f56$export$defe85febe8b728c.contextualTags),
        fieldId: 'app-updates-table-tag-filter',
        value: getSelectedTags(),
        onLoadOptions: onLoadOptions,
        onChange: handleChange,
        onClearValues: ()=>handleChange([])
    };
};
const $7468c2ae65c82f56$export$becee405f4ba5c0d = ()=>{
    const props = $7468c2ae65c82f56$var$useTagFilterProps();
    return /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $57e93f82e6ef5a0a$export$2e2bcd8739ae039), {
        ...props
    });
};




var $5FkrB = parcelRequire("5FkrB");

var $aRMzY = parcelRequire("aRMzY");
var $6Wx3K = parcelRequire("6Wx3K");

var $d74b25d2aca98929$exports = {};
"use strict";
Object.defineProperty($d74b25d2aca98929$exports, "__esModule", {
    value: true
});
$d74b25d2aca98929$exports.default = void 0;

var $d74b25d2aca98929$var$_react = $d74b25d2aca98929$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $2SuPM = parcelRequire("2SuPM");
function $d74b25d2aca98929$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $d74b25d2aca98929$var$SearchIcon = (props)=>/*#__PURE__*/ $d74b25d2aca98929$var$_react.default.createElement($2SuPM.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m16.436 15.085 3.94 4.01a1 1 0 0 1-1.425 1.402l-3.938-4.006a7.5 7.5 0 1 1 1.423-1.406M10.5 16a5.5 5.5 0 1 0 0-11 5.5 5.5 0 0 0 0 11"/></svg>`
    }, props));
$d74b25d2aca98929$var$SearchIcon.displayName = 'SearchIcon';
var $d74b25d2aca98929$var$_default = $d74b25d2aca98929$exports.default = $d74b25d2aca98929$var$SearchIcon;



var $6fyuV = parcelRequire("6fyuV");


var $5FkrB = parcelRequire("5FkrB");


const $11c628b62cd1de28$export$20b4f4827168badb = ()=>{
    const { state: state } = (0, $4933e76bd0ca959e$export$7653fec709d1e7bb)();
    const syncFiltersToUrl = (0, $5FkrB.useCallback)((overrides)=>{
        // eslint-disable-next-line no-unused-vars
        const { committedFiltersVersion: _committedFiltersVersion, ...filters } = state.updates.committedFilters;
        const currentFilters = {
            ...filters,
            cursor: state.updates.pagination.cursor,
            limit: state.updates.pagination.limit,
            ...overrides
        };
        const urlParams = (0, $ea567f1e5717897c$export$e582c11b604ddc57)(currentFilters);
        const searchString = (0, $ea567f1e5717897c$export$de85dd96eb599379)(urlParams);
        const newUrl = `${window.location.pathname}${searchString}`;
        if (window.history && window.history.replaceState) window.history.replaceState(null, '', newUrl);
    }, [
        state.updates.committedFilters,
        state.updates.pagination
    ]);
    const getFiltersFromUrlCallback = (0, $5FkrB.useCallback)(()=>(0, $ea567f1e5717897c$export$227523e113d14c22)(), []);
    return {
        syncFiltersToUrl: syncFiltersToUrl,
        getFiltersFromUrl: getFiltersFromUrlCallback
    };
};



var $5FkrB = parcelRequire("5FkrB");


const $8081251f610920d9$export$87ec4334ff1f5401 = ()=>{
    const { state: state } = (0, $4933e76bd0ca959e$export$7653fec709d1e7bb)();
    const syncFiltersToUrl = (0, $5FkrB.useCallback)((overrides)=>{
        // eslint-disable-next-line no-unused-vars
        const { committedFiltersVersion: _committedFiltersVersion, ...filters } = state.bundles.committedFilters;
        const currentFilters = {
            ...filters,
            cursor: state.bundles.pagination.cursor,
            limit: state.bundles.pagination.limit,
            ...overrides
        };
        const urlParams = (0, $ea567f1e5717897c$export$e582c11b604ddc57)(currentFilters);
        const searchString = (0, $ea567f1e5717897c$export$de85dd96eb599379)(urlParams);
        const newUrl = `${window.location.pathname}${searchString}`;
        if (window.history && window.history.replaceState) window.history.replaceState(null, '', newUrl);
    }, [
        state.bundles.committedFilters,
        state.bundles.pagination
    ]);
    return {
        syncFiltersToUrl: syncFiltersToUrl
    };
};






const $a4311b03a11a743e$var$BUNDLE_DATES_ENDPOINT = '/gateway/api/public/app-updates/v1/bundle-dates';
const $a4311b03a11a743e$export$60bd082d9d0dd517 = (selectedProducts)=>{
    if (!selectedProducts || selectedProducts.length === 0) return undefined;
    const keys = selectedProducts.map(({ id: id })=>(0, $d3185276e14a4c2b$export$7524c8b3bd6ccb7f)(id)?.productKey).filter((key)=>key !== undefined);
    return keys.join(',') || undefined;
};
const $a4311b03a11a743e$export$9a76656633d800c0 = (selectedProducts)=>{
    const { api: api } = (0, $4933e76bd0ca959e$export$7653fec709d1e7bb)();
    const productsParam = $a4311b03a11a743e$export$60bd082d9d0dd517(selectedProducts);
    const query = (0, $4b398c1589a0f1e2$export$dd0a697e1782aedd)({
        queryKey: [
            $a4311b03a11a743e$var$BUNDLE_DATES_ENDPOINT,
            productsParam ?? ''
        ],
        queryFn: async ()=>{
            try {
                const response = await api.get($a4311b03a11a743e$var$BUNDLE_DATES_ENDPOINT, {
                    params: productsParam ? {
                        products: productsParam
                    } : {}
                });
                return Array.isArray(response.data) ? response.data : [];
            } catch (error) {
                (0, $9654b596cdf679bc$export$2e2bcd8739ae039).error(error, {
                    extra: {
                        action: 'fetch-bundle-dates'
                    }
                });
                return [];
            }
        }
    });
    const allBundleDates = query.data ?? [];
    return {
        latestBundleDate: allBundleDates[0] ?? null,
        allBundleDates: allBundleDates,
        isLoading: query.isLoading,
        error: query.error
    };
};




const $954100d21b12fdcf$export$defe85febe8b728c = (0, $aRMzY.defineMessages)({
    label: {
        id: 'appUpdates.search.label',
        defaultMessage: 'Search release notes',
        description: 'Accessibility label for search input'
    },
    placeholder: {
        id: 'appUpdates.search.placeholder',
        defaultMessage: 'Search release notes',
        description: 'Placeholder text for search input'
    }
});
const $954100d21b12fdcf$var$searchContainerStyles = (0, $c1bec583fa49072f$export$f6c783d06584602c)({
    flexShrink: 1,
    minWidth: '180px',
    width: '360px'
});
const $954100d21b12fdcf$var$searchIconStyles = (0, $c1bec583fa49072f$export$f6c783d06584602c)({
    display: 'flex',
    alignItems: 'center',
    verticalAlign: 'middle',
    paddingLeft: 'space.100'
});
const $954100d21b12fdcf$export$55d7609a8f1eccd2 = ()=>{
    const { formatMessage: formatMessage } = (0, $6Wx3K.default)();
    const { state: state, dispatch: dispatch } = (0, $4933e76bd0ca959e$export$7653fec709d1e7bb)();
    const { syncFiltersToUrl: syncFiltersToUrl } = (0, $11c628b62cd1de28$export$20b4f4827168badb)();
    const [localValue, setLocalValue] = $5FkrB.useState(state.updates.draftFilters.searchQuery || '');
    const handleChange = $5FkrB.useCallback((event)=>{
        const value = event.target.value;
        setLocalValue(value);
        dispatch({
            type: 'FILTER_SEARCH_SELECT',
            payload: {
                searchQuery: value || null
            }
        });
    }, [
        dispatch
    ]);
    const handleKeyDown = $5FkrB.useCallback((event)=>{
        if (event.key === 'Enter') {
            syncFiltersToUrl({
                ...state.updates.draftFilters,
                cursor: undefined
            });
            dispatch({
                type: 'UPDATES_FILTERS_APPLY'
            });
        } else if (event.key === 'Escape') {
            setLocalValue('');
            dispatch({
                type: 'FILTER_SEARCH_SELECT',
                payload: {
                    searchQuery: null
                }
            });
        }
    }, [
        dispatch,
        state.updates.draftFilters,
        syncFiltersToUrl
    ]);
    $5FkrB.useEffect(()=>{
        if (state.updates.draftFilters.searchQuery !== localValue) setLocalValue(state.updates.draftFilters.searchQuery || '');
    }, [
        state.updates.draftFilters.searchQuery,
        localValue
    ]);
    return /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $383dd904a5a5e5b0$export$2e2bcd8739ae039), {
        xcss: $954100d21b12fdcf$var$searchContainerStyles,
        children: /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $6fyuV.default), {
            testId: "app-updates-search-input",
            "aria-label": formatMessage($954100d21b12fdcf$export$defe85febe8b728c.label),
            value: localValue,
            onChange: handleChange,
            onKeyDown: handleKeyDown,
            placeholder: formatMessage($954100d21b12fdcf$export$defe85febe8b728c.placeholder),
            elemBeforeInput: /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $383dd904a5a5e5b0$export$2e2bcd8739ae039), {
                xcss: $954100d21b12fdcf$var$searchIconStyles,
                children: /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($d74b25d2aca98929$exports))), {
                    label: "",
                    size: "small"
                })
            }),
            autoComplete: "off",
            type: "text",
            isCompact: true
        })
    });
};




var $5FkrB = parcelRequire("5FkrB");

var $aRMzY = parcelRequire("aRMzY");
var $6Wx3K = parcelRequire("6Wx3K");

var $dUWEU = parcelRequire("dUWEU");



const $ab87bc3d92f439e3$export$defe85febe8b728c = (0, $aRMzY.defineMessages)({
    label: {
        id: 'appUpdates.filters.apply.label',
        defaultMessage: 'Apply',
        description: 'Label for the apply filters button'
    }
});
const $ab87bc3d92f439e3$export$b8d0691b40a57c25 = ()=>{
    const { formatMessage: formatMessage } = (0, $6Wx3K.default)();
    const { state: state, dispatch: dispatch } = (0, $4933e76bd0ca959e$export$7653fec709d1e7bb)();
    const { syncFiltersToUrl: syncFiltersToUrl } = (0, $11c628b62cd1de28$export$20b4f4827168badb)();
    const { sendUIEvent: sendUIEvent } = (0, $a442bdf486731fcc$export$62b6ee20d27ead99)();
    const handleClick = $5FkrB.useCallback(()=>{
        syncFiltersToUrl({
            ...state.updates.draftFilters,
            cursor: undefined
        });
        dispatch({
            type: 'UPDATES_FILTERS_APPLY'
        });
        // Send analytics event with current filter state
        const updatesAppTypes = state.updates.draftFilters.selectedProducts && state.updates.draftFilters.selectedProducts.length > 0 ? state.updates.draftFilters.selectedProducts.map((p)=>p.id).join(',') : undefined;
        const updatesStatusTypes = state.updates.draftFilters.selectedStatuses && state.updates.draftFilters.selectedStatuses.length > 0 ? state.updates.draftFilters.selectedStatuses.map((s)=>s.id).join(',') : undefined;
        const updatesChangeTypes = state.updates.draftFilters.selectedChangeTypes && state.updates.draftFilters.selectedChangeTypes.length > 0 ? state.updates.draftFilters.selectedChangeTypes.map((c)=>c.id).join(',') : undefined;
        const updatesSearchContent = state.updates.draftFilters.searchQuery || undefined;
        sendUIEvent((0, $3e8e9266fe04abe4$export$73f866ce8175509a).ui.appUpdatesApplyClicked({
            source: 'appUpdatesListScreen'
        }, updatesAppTypes, updatesStatusTypes, updatesChangeTypes, updatesSearchContent).data);
    }, [
        dispatch,
        state.updates.draftFilters,
        syncFiltersToUrl,
        sendUIEvent
    ]);
    return /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $dUWEU.default), {
        testId: "app-updates-apply-filter-button",
        onClick: handleClick,
        appearance: "primary",
        children: formatMessage($ab87bc3d92f439e3$export$defe85febe8b728c.label)
    });
};




var $5FkrB = parcelRequire("5FkrB");

var $aRMzY = parcelRequire("aRMzY");
var $6Wx3K = parcelRequire("6Wx3K");

var $dUWEU = parcelRequire("dUWEU");


const $34eb6162ecf592b3$export$defe85febe8b728c = (0, $aRMzY.defineMessages)({
    label: {
        id: 'appUpdates.filters.reset.label',
        defaultMessage: 'Reset',
        description: 'Label for the reset filters button'
    }
});
/**
 * Helper to check if a filter value has any active selections.
 */ const $34eb6162ecf592b3$var$hasValue = (value)=>value !== undefined && value !== null && value.length > 0;
const $34eb6162ecf592b3$export$2491f201e3dd9acf = ()=>{
    const { formatMessage: formatMessage } = (0, $6Wx3K.default)();
    const { state: state, dispatch: dispatch } = (0, $4933e76bd0ca959e$export$7653fec709d1e7bb)();
    const { syncFiltersToUrl: syncFiltersToUrl } = (0, $11c628b62cd1de28$export$20b4f4827168badb)();
    const { draftFilters: draftFilters, committedFilters: committedFilters } = state.updates;
    const hasDraftFilters = $34eb6162ecf592b3$var$hasValue(draftFilters.selectedProducts) || $34eb6162ecf592b3$var$hasValue(draftFilters.selectedStatuses) || $34eb6162ecf592b3$var$hasValue(draftFilters.selectedChangeTypes) || $34eb6162ecf592b3$var$hasValue(draftFilters.selectedImpactRatings) || $34eb6162ecf592b3$var$hasValue(draftFilters.selectedTags) || $34eb6162ecf592b3$var$hasValue(draftFilters.searchQuery);
    const hasCommittedFilters = $34eb6162ecf592b3$var$hasValue(committedFilters.selectedProducts) || $34eb6162ecf592b3$var$hasValue(committedFilters.selectedStatuses) || $34eb6162ecf592b3$var$hasValue(committedFilters.selectedChangeTypes) || $34eb6162ecf592b3$var$hasValue(committedFilters.selectedImpactRatings) || $34eb6162ecf592b3$var$hasValue(committedFilters.selectedTags) || $34eb6162ecf592b3$var$hasValue(committedFilters.searchQuery);
    const handleClick = $5FkrB.useCallback(()=>{
        if (hasCommittedFilters) {
            // Filters were applied — full reset: clear URL, state, and refetch
            syncFiltersToUrl({
                selectedProducts: null,
                selectedStatuses: null,
                selectedChangeTypes: null,
                selectedImpactRatings: null,
                selectedTags: null,
                searchQuery: null,
                cursor: undefined
            });
            dispatch({
                type: 'UPDATES_FILTERS_RESET'
            });
        } else // Filters only changed in draft — just clear draft selections, no refetch
        dispatch({
            type: 'UPDATES_DRAFT_FILTERS_RESET'
        });
    }, [
        dispatch,
        syncFiltersToUrl,
        hasCommittedFilters
    ]);
    if (!hasDraftFilters && !hasCommittedFilters) return null;
    return /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $dUWEU.default), {
        testId: "app-updates-reset-filter-button",
        onClick: handleClick,
        appearance: "subtle",
        children: formatMessage($34eb6162ecf592b3$export$defe85febe8b728c.label)
    });
};




var $aRMzY = parcelRequire("aRMzY");
var $6Wx3K = parcelRequire("6Wx3K");

var $dUWEU = parcelRequire("dUWEU");

const $0f0f52c97cd3cd26$var$messages = (0, $aRMzY.defineMessages)({
    label: {
        id: 'appUpdates.filters.recentlyPublished.label-nonfinal',
        description: 'Label for the new this week filter chip',
        defaultMessage: 'New this week'
    }
});
const $0f0f52c97cd3cd26$var$getEffectiveFrom = ()=>{
    const date = new Date();
    date.setDate(date.getDate() - 7);
    return date.toISOString();
};
const $0f0f52c97cd3cd26$export$26dc5fbaa253de80 = ()=>{
    const { formatMessage: formatMessage } = (0, $6Wx3K.default)();
    const { state: state, dispatch: dispatch } = (0, $4933e76bd0ca959e$export$7653fec709d1e7bb)();
    const isActive = state.updates.committedFilters.effectiveFrom !== null;
    const handleToggle = ()=>{
        dispatch({
            type: 'FILTER_EFFECTIVE_FROM_TOGGLE',
            payload: {
                effectiveFrom: isActive ? null : $0f0f52c97cd3cd26$var$getEffectiveFrom()
            }
        });
    };
    return /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $dUWEU.default), {
        appearance: "default",
        isSelected: isActive,
        onClick: handleToggle,
        testId: "app-updates-recently-published-filter",
        "aria-label": formatMessage($0f0f52c97cd3cd26$var$messages.label),
        "aria-pressed": isActive,
        children: formatMessage($0f0f52c97cd3cd26$var$messages.label)
    });
};


const $ac017e5cb269e227$var$filterContainerStyles = (0, $c1bec583fa49072f$export$f6c783d06584602c)({
    display: 'flex',
    gap: 'space.100',
    flexWrap: 'wrap',
    alignItems: 'center'
});
const $ac017e5cb269e227$var$filterActionsStyles = (0, $c1bec583fa49072f$export$f6c783d06584602c)({
    display: 'flex',
    gap: 'space.100',
    alignItems: 'center',
    flexShrink: 0
});
const $ac017e5cb269e227$export$29b5614fa0522278 = ()=>{
    return /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsxs)((0, $383dd904a5a5e5b0$export$2e2bcd8739ae039), {
        xcss: $ac017e5cb269e227$var$filterContainerStyles,
        testId: "app-updates-table-filters-testid",
        children: [
            /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $954100d21b12fdcf$export$55d7609a8f1eccd2), {}),
            /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $0f0f52c97cd3cd26$export$26dc5fbaa253de80), {}),
            /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $420420e53272417e$export$47ad17e195465d2c), {}),
            /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $d25636532dab27cd$export$20cf945971e823e9), {}),
            /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $4685ebf402bfe2a8$export$cbae60f067cb26e7), {}),
            (0, $c78886f48293f91c$export$b40ec24ac8275656)((0, $86626a3c150b02ba$export$5fb62a9fe732a843).aiImpactAndContextTags) && /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $1c3ac60f186b4700$export$9cf9bdfc86c39f2a), {}),
            (0, $c78886f48293f91c$export$b40ec24ac8275656)((0, $86626a3c150b02ba$export$5fb62a9fe732a843).aiImpactAndContextTags) && /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $7468c2ae65c82f56$export$becee405f4ba5c0d), {}),
            /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsxs)((0, $383dd904a5a5e5b0$export$2e2bcd8739ae039), {
                xcss: $ac017e5cb269e227$var$filterActionsStyles,
                children: [
                    /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $ab87bc3d92f439e3$export$b8d0691b40a57c25), {}),
                    /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $34eb6162ecf592b3$export$2491f201e3dd9acf), {})
                ]
            })
        ]
    });
};
var $ac017e5cb269e227$export$2e2bcd8739ae039 = $ac017e5cb269e227$export$29b5614fa0522278;




parcelRequire("5FkrB");



var $5FkrB = parcelRequire("5FkrB");

var $aRMzY = parcelRequire("aRMzY");
var $6Wx3K = parcelRequire("6Wx3K");



var $6fyuV = parcelRequire("6fyuV");


const $3b46608cd1ea6a8a$var$messages = (0, $aRMzY.defineMessages)({
    label: {
        id: 'appUpdates.bundles.search.label',
        defaultMessage: 'Search release notes',
        description: 'Accessibility label for bundled changes search input'
    },
    placeholder: {
        id: 'appUpdates.bundles.search.placeholder',
        defaultMessage: 'Search release notes',
        description: 'Placeholder text for bundled changes search input'
    }
});
const $3b46608cd1ea6a8a$var$searchContainerStyles = (0, $c1bec583fa49072f$export$f6c783d06584602c)({
    minWidth: '200px',
    maxWidth: '400px',
    width: '100%'
});
const $3b46608cd1ea6a8a$var$searchIconStyles = (0, $c1bec583fa49072f$export$f6c783d06584602c)({
    display: 'flex',
    alignItems: 'center',
    verticalAlign: 'middle',
    paddingLeft: 'space.100'
});
const $3b46608cd1ea6a8a$export$ad1a3a15064caec9 = ()=>{
    const { formatMessage: formatMessage } = (0, $6Wx3K.default)();
    const { state: state, dispatch: dispatch } = (0, $4933e76bd0ca959e$export$7653fec709d1e7bb)();
    const { syncFiltersToUrl: syncFiltersToUrl } = (0, $8081251f610920d9$export$87ec4334ff1f5401)();
    const [localValue, setLocalValue] = $5FkrB.useState(state.bundles.draftFilters.searchQuery || '');
    const handleChange = $5FkrB.useCallback((event)=>{
        const value = event.target.value;
        setLocalValue(value);
        dispatch({
            type: 'BUNDLE_FILTER_SEARCH_SELECT',
            payload: {
                searchQuery: value || null
            }
        });
    }, [
        dispatch
    ]);
    const handleKeyDown = $5FkrB.useCallback((event)=>{
        if (event.key === 'Enter') {
            syncFiltersToUrl({
                ...state.bundles.draftFilters,
                cursor: undefined
            });
            dispatch({
                type: 'BUNDLES_FILTERS_APPLY'
            });
        } else if (event.key === 'Escape') {
            setLocalValue('');
            dispatch({
                type: 'BUNDLE_FILTER_SEARCH_SELECT',
                payload: {
                    searchQuery: null
                }
            });
        }
    }, [
        dispatch,
        state.bundles.draftFilters,
        syncFiltersToUrl
    ]);
    const prevSearchQueryRef = $5FkrB.useRef(state.bundles.draftFilters.searchQuery);
    $5FkrB.useEffect(()=>{
        const searchQuery = state.bundles.draftFilters.searchQuery;
        if (searchQuery !== prevSearchQueryRef.current) {
            prevSearchQueryRef.current = searchQuery;
            setLocalValue(searchQuery || '');
        }
    }, [
        state.bundles.draftFilters.searchQuery
    ]);
    return /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $383dd904a5a5e5b0$export$2e2bcd8739ae039), {
        xcss: $3b46608cd1ea6a8a$var$searchContainerStyles,
        children: /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $6fyuV.default), {
            testId: "app-updates-bundle-search-input",
            "aria-label": formatMessage($3b46608cd1ea6a8a$var$messages.label),
            value: localValue,
            onChange: handleChange,
            onKeyDown: handleKeyDown,
            placeholder: formatMessage($3b46608cd1ea6a8a$var$messages.placeholder),
            elemBeforeInput: /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $383dd904a5a5e5b0$export$2e2bcd8739ae039), {
                xcss: $3b46608cd1ea6a8a$var$searchIconStyles,
                children: /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($d74b25d2aca98929$exports))), {
                    label: "",
                    size: "small"
                })
            }),
            autoComplete: "off",
            type: "text",
            isCompact: true
        })
    });
};



parcelRequire("5FkrB");

var $aRMzY = parcelRequire("aRMzY");
var $6Wx3K = parcelRequire("6Wx3K");




const $29e2e58ab903288f$var$messages = (0, $aRMzY.defineMessages)({
    product: {
        id: 'appUpdates.bundles.filters.product.label',
        description: 'Label for the bundled changes product filter',
        defaultMessage: 'App'
    }
});
const $29e2e58ab903288f$var$productOptionStyles = (0, $c1bec583fa49072f$export$f6c783d06584602c)({
    display: 'flex',
    alignItems: 'center',
    gap: 'space.100',
    minHeight: '24px',
    overflow: 'hidden'
});
const $29e2e58ab903288f$var$products = Object.entries((0, $50e94d71524dc43e$export$c6f09e1afd88c25a)()).map(([key, config])=>({
        id: key,
        name: config.displayName,
        icon: config.icon
    }));
const $29e2e58ab903288f$var$productOptions = $29e2e58ab903288f$var$products.map((product)=>({
        label: product.name,
        value: product.id,
        optionType: 'option'
    })).sort((a, b)=>a.label.localeCompare(b.label));
const $29e2e58ab903288f$export$e022bc11a909d9bf = ()=>{
    const { formatMessage: formatMessage } = (0, $6Wx3K.default)();
    const { state: state, dispatch: dispatch } = (0, $4933e76bd0ca959e$export$7653fec709d1e7bb)();
    const getSelectedProducts = ()=>{
        const selectedProducts = state.bundles.draftFilters.selectedProducts;
        if (!selectedProducts || selectedProducts.length === 0) return [];
        return selectedProducts.map((selectedProduct)=>$29e2e58ab903288f$var$productOptions.find((option)=>option.value === selectedProduct.id)).filter((option)=>option !== undefined);
    };
    const onProductFilterChange = (options)=>{
        const selectedProductValues = options.map((option)=>$29e2e58ab903288f$var$products.find((candidate)=>candidate.id === option.value)).filter((product)=>product !== undefined);
        dispatch({
            type: 'BUNDLE_FILTER_APP_SELECT',
            payload: {
                selectedProducts: selectedProductValues.length > 0 ? selectedProductValues : null
            }
        });
    // TODO: analytics — fire bundled-changes app filter event (specifics TBD).
    };
    // AGENT: do not change next line, it is correct as is
    const formatProduct = (option)=>{
        return /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $383dd904a5a5e5b0$export$2e2bcd8739ae039), {
            testId: `bundle-app-filter-option-${option.value}`,
            children: /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsxs)((0, $383dd904a5a5e5b0$export$2e2bcd8739ae039), {
                as: "div",
                xcss: $29e2e58ab903288f$var$productOptionStyles,
                children: [
                    /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $7397f708924e0bda$export$1a199e029d5e93d6), {
                        productType: option.value,
                        size: "xsmall",
                        testId: `bundle-app-icon-${option.value}`
                    }),
                    /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $383dd904a5a5e5b0$export$2e2bcd8739ae039), {
                        as: "span",
                        children: option.label
                    })
                ]
            })
        });
    };
    const onLoadOptions = (search, _enableFullList, _showFullList, _showMore, _lastOption, callback)=>{
        let options = $29e2e58ab903288f$var$productOptions.map((option)=>({
                label: option.label,
                value: option.value,
                optionType: 'option'
            }));
        if (search) {
            const searchText = search.toLowerCase();
            options = options.filter((option)=>option.label?.toLowerCase().includes(searchText));
        }
        callback({
            options: options,
            totalCount: options.length
        });
    };
    return {
        testId: 'app-updates-bundle-filter-product-app-testid',
        fieldLabel: formatMessage($29e2e58ab903288f$var$messages.product),
        fieldId: 'app-updates-bundle-app-filter',
        onLoadOptions: onLoadOptions,
        value: getSelectedProducts(),
        onChange: onProductFilterChange,
        onClearValues: ()=>onProductFilterChange([]),
        formatOptionLabel: formatProduct
    };
};
const $29e2e58ab903288f$export$e8e7f13bcb332b1f = ()=>{
    const filterProps = $29e2e58ab903288f$export$e022bc11a909d9bf();
    return /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $57e93f82e6ef5a0a$export$2e2bcd8739ae039), {
        ...filterProps
    });
};



parcelRequire("5FkrB");

var $aRMzY = parcelRequire("aRMzY");
var $6Wx3K = parcelRequire("6Wx3K");


/**
 * Utility functions for time formatting and manipulation using date-fns
 */ 
var $5U7m7 = parcelRequire("5U7m7");
var $hBm5q = parcelRequire("hBm5q");

var $f1PiG = parcelRequire("f1PiG");

var $jFSmD = parcelRequire("jFSmD");

var $k0voR = parcelRequire("k0voR");

var $aCKXn = parcelRequire("aCKXn");
function $8ebfc0f846a89e05$export$2e2bcd8739ae039(dateLeft, dateRight) {
    (0, $aCKXn.default)(2, arguments);
    return (0, $k0voR.default)(dateLeft).getTime() - (0, $k0voR.default)(dateRight).getTime();
}



var $aCKXn = parcelRequire("aCKXn");
var $d70de65e4fd2fb23$var$roundingMap = {
    ceil: Math.ceil,
    round: Math.round,
    floor: Math.floor,
    trunc: function trunc(value) {
        return value < 0 ? Math.ceil(value) : Math.floor(value);
    } // Math.trunc is not supported by IE
};
var $d70de65e4fd2fb23$var$defaultRoundingMethod = 'trunc';
function $d70de65e4fd2fb23$export$b6474a47258c1211(method) {
    return method ? $d70de65e4fd2fb23$var$roundingMap[method] : $d70de65e4fd2fb23$var$roundingMap[$d70de65e4fd2fb23$var$defaultRoundingMethod];
}


function $84ebb6fcf8e1de6a$export$2e2bcd8739ae039(dateLeft, dateRight, options) {
    (0, $aCKXn.default)(2, arguments);
    var diff = (0, $8ebfc0f846a89e05$export$2e2bcd8739ae039)(dateLeft, dateRight) / 1000;
    return (0, $d70de65e4fd2fb23$export$b6474a47258c1211)(options === null || options === void 0 ? void 0 : options.roundingMethod)(diff);
}



var $9G5I4 = parcelRequire("9G5I4");

var $k0voR = parcelRequire("k0voR");
function $8d62d31abbdcaa81$export$2e2bcd8739ae039(target, object) {
    if (target == null) throw new TypeError('assign requires that input parameter not be null or undefined');
    for(var property in object)if (Object.prototype.hasOwnProperty.call(object, property)) target[property] = object[property];
    return target;
}


function $afdc45a2e3319f7c$export$2e2bcd8739ae039(object) {
    return (0, $8d62d31abbdcaa81$export$2e2bcd8739ae039)({}, object);
}




var $9jQRB = parcelRequire("9jQRB");

var $aCKXn = parcelRequire("aCKXn");
var $2c27ea849f0c496b$var$MINUTES_IN_DAY = 1440;
var $2c27ea849f0c496b$var$MINUTES_IN_ALMOST_TWO_DAYS = 2520;
var $2c27ea849f0c496b$var$MINUTES_IN_MONTH = 43200;
var $2c27ea849f0c496b$var$MINUTES_IN_TWO_MONTHS = 86400;
function $2c27ea849f0c496b$export$2e2bcd8739ae039(dirtyDate, dirtyBaseDate, options) {
    var _ref, _options$locale;
    (0, $aCKXn.default)(2, arguments);
    var defaultOptions = (0, $hBm5q.getDefaultOptions)();
    var locale = (_ref = (_options$locale = options === null || options === void 0 ? void 0 : options.locale) !== null && _options$locale !== void 0 ? _options$locale : defaultOptions.locale) !== null && _ref !== void 0 ? _ref : (0, $9G5I4.default);
    if (!locale.formatDistance) throw new RangeError('locale must contain formatDistance property');
    var comparison = (0, $f1PiG.default)(dirtyDate, dirtyBaseDate);
    if (isNaN(comparison)) throw new RangeError('Invalid time value');
    var localizeOptions = (0, $8d62d31abbdcaa81$export$2e2bcd8739ae039)((0, $afdc45a2e3319f7c$export$2e2bcd8739ae039)(options), {
        addSuffix: Boolean(options === null || options === void 0 ? void 0 : options.addSuffix),
        comparison: comparison
    });
    var dateLeft;
    var dateRight;
    if (comparison > 0) {
        dateLeft = (0, $k0voR.default)(dirtyBaseDate);
        dateRight = (0, $k0voR.default)(dirtyDate);
    } else {
        dateLeft = (0, $k0voR.default)(dirtyDate);
        dateRight = (0, $k0voR.default)(dirtyBaseDate);
    }
    var seconds = (0, $84ebb6fcf8e1de6a$export$2e2bcd8739ae039)(dateRight, dateLeft);
    var offsetInSeconds = ((0, $9jQRB.default)(dateRight) - (0, $9jQRB.default)(dateLeft)) / 1000;
    var minutes = Math.round((seconds - offsetInSeconds) / 60);
    var months;
    // 0 up to 2 mins
    if (minutes < 2) {
        if (options !== null && options !== void 0 && options.includeSeconds) {
            if (seconds < 5) return locale.formatDistance('lessThanXSeconds', 5, localizeOptions);
            else if (seconds < 10) return locale.formatDistance('lessThanXSeconds', 10, localizeOptions);
            else if (seconds < 20) return locale.formatDistance('lessThanXSeconds', 20, localizeOptions);
            else if (seconds < 40) return locale.formatDistance('halfAMinute', 0, localizeOptions);
            else if (seconds < 60) return locale.formatDistance('lessThanXMinutes', 1, localizeOptions);
            else return locale.formatDistance('xMinutes', 1, localizeOptions);
        } else {
            if (minutes === 0) return locale.formatDistance('lessThanXMinutes', 1, localizeOptions);
            else return locale.formatDistance('xMinutes', minutes, localizeOptions);
        }
    } else if (minutes < 45) return locale.formatDistance('xMinutes', minutes, localizeOptions);
    else if (minutes < 90) return locale.formatDistance('aboutXHours', 1, localizeOptions);
    else if (minutes < $2c27ea849f0c496b$var$MINUTES_IN_DAY) {
        var hours = Math.round(minutes / 60);
        return locale.formatDistance('aboutXHours', hours, localizeOptions);
    // 1 day up to 1.75 days
    } else if (minutes < $2c27ea849f0c496b$var$MINUTES_IN_ALMOST_TWO_DAYS) return locale.formatDistance('xDays', 1, localizeOptions);
    else if (minutes < $2c27ea849f0c496b$var$MINUTES_IN_MONTH) {
        var days = Math.round(minutes / $2c27ea849f0c496b$var$MINUTES_IN_DAY);
        return locale.formatDistance('xDays', days, localizeOptions);
    // 1 month up to 2 months
    } else if (minutes < $2c27ea849f0c496b$var$MINUTES_IN_TWO_MONTHS) {
        months = Math.round(minutes / $2c27ea849f0c496b$var$MINUTES_IN_MONTH);
        return locale.formatDistance('aboutXMonths', months, localizeOptions);
    }
    months = (0, $jFSmD.default)(dateRight, dateLeft);
    // 2 months up to 12 months
    if (months < 12) {
        var nearestMonth = Math.round(minutes / $2c27ea849f0c496b$var$MINUTES_IN_MONTH);
        return locale.formatDistance('xMonths', nearestMonth, localizeOptions);
    // 1 year up to max Date
    } else {
        var monthsSinceStartOfYear = months % 12;
        var years = Math.floor(months / 12);
        // N years up to 1 years 3 months
        if (monthsSinceStartOfYear < 3) return locale.formatDistance('aboutXYears', years, localizeOptions);
        else if (monthsSinceStartOfYear < 9) return locale.formatDistance('overXYears', years, localizeOptions);
        else return locale.formatDistance('almostXYears', years + 1, localizeOptions);
    }
}



var $aCKXn = parcelRequire("aCKXn");
function $ce267151f0927b75$export$2e2bcd8739ae039(dirtyDate, options) {
    (0, $aCKXn.default)(1, arguments);
    return (0, $2c27ea849f0c496b$export$2e2bcd8739ae039)(dirtyDate, Date.now(), options);
}


/**
 * Collects all available timestamps from a update and its tasks/approvals
 *
 * @param update - update object with createdAt, statusDate, tasks, and approvals
 * @returns Array of ISO timestamp strings
 */ function $dc0b5cf0aeb86d21$var$collectTimestamps(update) {
    const timestamps = [
        update.createdAt,
        update.statusDate
    ];
    // Add task timestamps
    if (update.tasks) update.tasks.forEach((task)=>{
        if (task.completedAt) timestamps.push(task.completedAt);
    });
    // Add approval timestamps
    if (update.approvals) update.approvals.forEach((approval)=>{
        timestamps.push(approval.statusDate);
        if (approval.approvedAt) timestamps.push(approval.approvedAt);
        if (approval.rejectedAt) timestamps.push(approval.rejectedAt);
    });
    return timestamps;
}
function $dc0b5cf0aeb86d21$export$493c11ff22f45a24(dateTimeString) {
    return (0, $ce267151f0927b75$export$2e2bcd8739ae039)(new Date(dateTimeString), {
        addSuffix: true
    });
}
function $dc0b5cf0aeb86d21$export$eecd5dfd0530be5c(dateString) {
    const [year, month, day] = dateString.split('-').map(Number);
    if (!year || !month || !day) return dateString;
    return (0, $5U7m7.default)(new Date(year, month - 1, day), 'MMM d, yyyy');
}
function $dc0b5cf0aeb86d21$export$df6b53120484899a(update) {
    const timestamps = $dc0b5cf0aeb86d21$var$collectTimestamps(update);
    // Find the most recent timestamp
    const mostRecent = timestamps.map((ts)=>new Date(ts).getTime()).reduce((recent, current)=>Math.max(recent, current), -Infinity);
    return new Date(mostRecent).toISOString();
}
function $dc0b5cf0aeb86d21$export$1ea3e7eff6cfbd9f(update) {
    const timestamps = $dc0b5cf0aeb86d21$var$collectTimestamps(update);
    if (timestamps.length === 0) return null;
    const mostRecent = timestamps.map((ts)=>new Date(ts).getTime()).reduce((recent, current)=>Math.max(recent, current), -Infinity);
    // Handle where all dates are invalid
    if (mostRecent === -Infinity) return null;
    return $dc0b5cf0aeb86d21$export$493c11ff22f45a24(new Date(mostRecent).toISOString());
}



const $27e10a2c5a0027cf$var$messages = (0, $aRMzY.defineMessages)({
    bundleDate: {
        id: 'appUpdates.bundles.filters.bundleDate.label',
        description: 'Label for the bundle date filter',
        defaultMessage: 'Preview release date'
    }
});
const $27e10a2c5a0027cf$export$61a826eca4e9dd19 = ()=>{
    const { formatMessage: formatMessage } = (0, $6Wx3K.default)();
    const { state: state, dispatch: dispatch } = (0, $4933e76bd0ca959e$export$7653fec709d1e7bb)();
    const selectedBundleDate = state.bundles.draftFilters.selectedBundleDate;
    const selectedProducts = state.bundles.draftFilters.selectedProducts;
    const { allBundleDates: bundleDates, isLoading: isLoading } = (0, $a4311b03a11a743e$export$9a76656633d800c0)(selectedProducts);
    const getSelectedValue = ()=>selectedBundleDate ? [
            {
                label: (0, $dc0b5cf0aeb86d21$export$eecd5dfd0530be5c)(selectedBundleDate),
                value: selectedBundleDate,
                optionType: 'option'
            }
        ] : [];
    // PaginatedFilter is inherently multi-select; enforce single-select by keeping
    // only the most recently chosen option.
    const onBundleDateChange = (options)=>{
        const latest = options.length > 0 ? options[options.length - 1] : null;
        dispatch({
            type: 'BUNDLE_FILTER_DATE_SELECT',
            payload: {
                selectedBundleDate: latest ? String(latest.value) : null
            }
        });
    };
    const onLoadOptions = (search, _enableFullList, _showFullList, _showMore, _lastOption, callback)=>{
        let options = bundleDates.map((date)=>({
                label: (0, $dc0b5cf0aeb86d21$export$eecd5dfd0530be5c)(date),
                value: date,
                optionType: 'option'
            }));
        if (search) {
            const searchText = search.toLowerCase();
            options = options.filter((option)=>option.label?.toLowerCase().includes(searchText));
        }
        callback({
            options: options,
            totalCount: options.length
        });
    };
    return /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $57e93f82e6ef5a0a$export$2e2bcd8739ae039), {
        testId: "app-updates-bundle-filter-date-testid",
        fieldId: "app-updates-bundle-date-filter",
        fieldLabel: formatMessage($27e10a2c5a0027cf$var$messages.bundleDate),
        onLoadOptions: onLoadOptions,
        value: getSelectedValue(),
        onChange: onBundleDateChange,
        onClearValues: ()=>onBundleDateChange([]),
        isLoading: isLoading
    });
};




var $5FkrB = parcelRequire("5FkrB");

var $aRMzY = parcelRequire("aRMzY");
var $6Wx3K = parcelRequire("6Wx3K");

var $dUWEU = parcelRequire("dUWEU");


const $9f8e055b2b94db46$var$messages = (0, $aRMzY.defineMessages)({
    label: {
        id: 'appUpdates.bundles.filters.apply.label',
        defaultMessage: 'Apply',
        description: 'Label for the bundled changes apply filters button'
    }
});
const $9f8e055b2b94db46$export$a8ce06e607f28325 = ()=>{
    const { formatMessage: formatMessage } = (0, $6Wx3K.default)();
    const { state: state, dispatch: dispatch } = (0, $4933e76bd0ca959e$export$7653fec709d1e7bb)();
    const { syncFiltersToUrl: syncFiltersToUrl } = (0, $8081251f610920d9$export$87ec4334ff1f5401)();
    const handleClick = $5FkrB.useCallback(()=>{
        syncFiltersToUrl({
            ...state.bundles.draftFilters,
            cursor: undefined
        });
        dispatch({
            type: 'BUNDLES_FILTERS_APPLY'
        });
    // TODO: analytics — fire bundled-changes apply event (specifics TBD).
    }, [
        dispatch,
        state.bundles.draftFilters,
        syncFiltersToUrl
    ]);
    return /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $dUWEU.default), {
        testId: "app-updates-bundle-apply-filter-button",
        onClick: handleClick,
        appearance: "primary",
        children: formatMessage($9f8e055b2b94db46$var$messages.label)
    });
};




var $5FkrB = parcelRequire("5FkrB");

var $aRMzY = parcelRequire("aRMzY");
var $6Wx3K = parcelRequire("6Wx3K");

var $dUWEU = parcelRequire("dUWEU");


const $5864bf51e9ceb3f1$var$messages = (0, $aRMzY.defineMessages)({
    label: {
        id: 'appUpdates.bundles.filters.reset.label',
        defaultMessage: 'Reset',
        description: 'Label for the bundled changes reset filters button'
    }
});
const $5864bf51e9ceb3f1$var$hasValue = (value)=>value !== null && value.length > 0;
const $5864bf51e9ceb3f1$export$6dab557f88481070 = ()=>{
    const { formatMessage: formatMessage } = (0, $6Wx3K.default)();
    const { state: state, dispatch: dispatch } = (0, $4933e76bd0ca959e$export$7653fec709d1e7bb)();
    const { syncFiltersToUrl: syncFiltersToUrl } = (0, $8081251f610920d9$export$87ec4334ff1f5401)();
    const { latestBundleDate: latestBundleDate } = (0, $a4311b03a11a743e$export$9a76656633d800c0)(null);
    const { draftFilters: draftFilters, committedFilters: committedFilters } = state.bundles;
    const hasDraftFilters = $5864bf51e9ceb3f1$var$hasValue(draftFilters.selectedProducts) || $5864bf51e9ceb3f1$var$hasValue(draftFilters.selectedBundleDate) || $5864bf51e9ceb3f1$var$hasValue(draftFilters.searchQuery);
    const hasCommittedFilters = $5864bf51e9ceb3f1$var$hasValue(committedFilters.selectedProducts) || $5864bf51e9ceb3f1$var$hasValue(committedFilters.selectedBundleDate) || $5864bf51e9ceb3f1$var$hasValue(committedFilters.searchQuery);
    const handleClick = $5FkrB.useCallback(()=>{
        if (hasCommittedFilters) {
            syncFiltersToUrl({
                selectedProducts: null,
                selectedBundleDate: latestBundleDate,
                searchQuery: null,
                cursor: undefined
            });
            dispatch({
                type: 'BUNDLES_FILTERS_RESET',
                payload: {
                    selectedBundleDate: latestBundleDate
                }
            });
        } else dispatch({
            type: 'BUNDLES_DRAFT_FILTERS_RESET',
            payload: {
                selectedBundleDate: latestBundleDate
            }
        });
    }, [
        dispatch,
        syncFiltersToUrl,
        hasCommittedFilters,
        latestBundleDate
    ]);
    if (!hasDraftFilters && !hasCommittedFilters) return null;
    return /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $dUWEU.default), {
        testId: "app-updates-bundle-reset-filter-button",
        onClick: handleClick,
        appearance: "subtle",
        children: formatMessage($5864bf51e9ceb3f1$var$messages.label)
    });
};


const $fb27fbb16aa94537$var$filterContainerStyles = (0, $c1bec583fa49072f$export$f6c783d06584602c)({
    display: 'flex',
    gap: 'space.100',
    flexWrap: 'wrap',
    alignItems: 'center'
});
const $fb27fbb16aa94537$var$filterActionsStyles = (0, $c1bec583fa49072f$export$f6c783d06584602c)({
    display: 'flex',
    gap: 'space.100',
    alignItems: 'center',
    flexShrink: 0
});
const $fb27fbb16aa94537$export$ac34063c51bd3598 = ()=>{
    return /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsxs)((0, $383dd904a5a5e5b0$export$2e2bcd8739ae039), {
        xcss: $fb27fbb16aa94537$var$filterContainerStyles,
        testId: "app-updates-bundle-filters-testid",
        children: [
            /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $3b46608cd1ea6a8a$export$ad1a3a15064caec9), {}),
            /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $29e2e58ab903288f$export$e8e7f13bcb332b1f), {}),
            /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $27e10a2c5a0027cf$export$61a826eca4e9dd19), {}),
            /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsxs)((0, $383dd904a5a5e5b0$export$2e2bcd8739ae039), {
                xcss: $fb27fbb16aa94537$var$filterActionsStyles,
                children: [
                    /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $9f8e055b2b94db46$export$a8ce06e607f28325), {}),
                    /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $5864bf51e9ceb3f1$export$6dab557f88481070), {})
                ]
            })
        ]
    });
};





const $4981744843bb0981$export$f80c710216eae131 = ()=>{
    const { dispatch: dispatch } = (0, $4933e76bd0ca959e$export$7653fec709d1e7bb)();
    const { syncFiltersToUrl: syncFiltersToUrl } = (0, $11c628b62cd1de28$export$20b4f4827168badb)();
    const setCursor = (0, $5FkrB.useCallback)((cursor)=>{
        dispatch({
            type: 'UPDATES_CURSOR_SET',
            payload: {
                cursor: cursor
            }
        });
        syncFiltersToUrl({
            cursor: cursor
        });
    }, [
        dispatch,
        syncFiltersToUrl
    ]);
    const setLimit = (0, $5FkrB.useCallback)((limit)=>{
        dispatch({
            type: 'UPDATES_LIMIT_SET',
            payload: {
                limit: limit
            }
        });
        syncFiltersToUrl({
            cursor: undefined,
            limit: limit
        });
    }, [
        dispatch,
        syncFiltersToUrl
    ]);
    return {
        setCursor: setCursor,
        setLimit: setLimit
    };
};




var $aRMzY = parcelRequire("aRMzY");
var $iBNQo = parcelRequire("iBNQo");

const $373b864dc2406021$var$messages = (0, $aRMzY.defineMessages)({
    nullReleaseDate: {
        id: 'appUpdates.dateRangeInfo.noTimeframe',
        defaultMessage: 'No timeframe yet',
        description: 'Text shown when no release dates are defined'
    },
    startingIn: {
        id: 'appUpdates.dateRangeInfo.startingIn',
        defaultMessage: 'Starting in {startingDate}',
        description: 'Release window when only a start date is known, no day shown'
    },
    dateRange: {
        id: 'appUpdates.dateRangeInfo.dateRange',
        defaultMessage: '{dateStart} - {dateEnd}',
        description: 'Release window date range, e.g. "Mar - Apr 2024"'
    }
});
const $373b864dc2406021$export$36955e76773cff65 = (start, end)=>{
    const month1 = new Date(start).getMonth();
    const month2 = new Date(end).getMonth();
    const year1 = new Date(start).getFullYear();
    const year2 = new Date(end).getFullYear();
    return month1 === month2 && year1 === year2;
};
const $373b864dc2406021$export$5841f9eb9773f25f = (start, end)=>{
    const year1 = new Date(start).getFullYear();
    const year2 = new Date(end).getFullYear();
    return year1 === year2;
};
const $373b864dc2406021$export$c119e7a38ceabb6b = ({ startDate: startDate, endDate: endDate, status: status })=>{
    // For Generally Available status, show only the end date
    if (status === 'GENERALLY_AVAILABLE' && endDate) return /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $d48daa9a522ca942$export$2e2bcd8739ae039), {
        as: "span",
        children: /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $aRMzY.FormattedDate), {
            value: endDate,
            month: "long",
            year: "numeric"
        })
    });
    if (!startDate) return /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $d48daa9a522ca942$export$2e2bcd8739ae039), {
        as: "span",
        children: /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $iBNQo.default), {
            ...$373b864dc2406021$var$messages.nullReleaseDate
        })
    });
    // Start date only — no end date known yet
    if (!endDate) return /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $d48daa9a522ca942$export$2e2bcd8739ae039), {
        as: "span",
        children: /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $iBNQo.default), {
            ...$373b864dc2406021$var$messages.startingIn,
            values: {
                startingDate: /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $aRMzY.FormattedDate), {
                    value: startDate,
                    month: "long",
                    year: "numeric"
                })
            }
        })
    });
    // Start + end in the same month — show just the month and year
    if ($373b864dc2406021$export$36955e76773cff65(startDate, endDate)) return /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $d48daa9a522ca942$export$2e2bcd8739ae039), {
        as: "span",
        children: /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $aRMzY.FormattedDate), {
            value: startDate,
            month: "long",
            year: "numeric"
        })
    });
    // Different months — show a range; omit year from start if both are in the same year
    return /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $d48daa9a522ca942$export$2e2bcd8739ae039), {
        as: "span",
        children: /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $iBNQo.default), {
            ...$373b864dc2406021$var$messages.dateRange,
            values: {
                dateStart: /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $aRMzY.FormattedDate), {
                    value: startDate,
                    month: "short",
                    year: $373b864dc2406021$export$5841f9eb9773f25f(startDate, endDate) ? undefined : 'numeric'
                }),
                dateEnd: /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $aRMzY.FormattedDate), {
                    value: endDate,
                    month: "short",
                    year: "numeric"
                })
            }
        })
    });
};
var $373b864dc2406021$export$2e2bcd8739ae039 = $373b864dc2406021$export$c119e7a38ceabb6b;




var $5FkrB = parcelRequire("5FkrB");

var $aRMzY = parcelRequire("aRMzY");
var $6Wx3K = parcelRequire("6Wx3K");

var $kqp0i = parcelRequire("kqp0i");

var $fC8ib = parcelRequire("fC8ib");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");

var $74Zh5 = parcelRequire("74Zh5");

var $25nEq = parcelRequire("25nEq");

var $5FkrB = parcelRequire("5FkrB");

var $dLGML = parcelRequire("dLGML");

var $fC8ib = parcelRequire("fC8ib");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $kIXpt = parcelRequire("kIXpt");

var $cYPzS = parcelRequire("cYPzS");

var $lwlXp = parcelRequire("lwlXp");

var $eyuDe = parcelRequire("eyuDe");

var $25nEq = parcelRequire("25nEq");

var $ekGgq = parcelRequire("ekGgq");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $25nEq = parcelRequire("25nEq");
function $091a9b8961dfb365$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $091a9b8961dfb365$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $091a9b8961dfb365$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $091a9b8961dfb365$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $091a9b8961dfb365$export$ad4be5c2ec28cecf = function isAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $091a9b8961dfb365$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === 'AnalyticsEvent';
};
var $091a9b8961dfb365$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function AnalyticsEvent(props) {
        var _this = this;
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, AnalyticsEvent);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "_isAnalyticsEvent", true);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "clone", function() {
            // just a shallow clone, don't change sub refs unless you want to
            // affect the original's too
            var payload = $091a9b8961dfb365$var$_objectSpread({}, _this.payload);
            return new AnalyticsEvent({
                payload: payload
            });
        });
        this.payload = props.payload;
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(AnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (typeof updater === 'function') this.payload = updater(this.payload);
                if ((0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(updater) === 'object') this.payload = $091a9b8961dfb365$var$_objectSpread($091a9b8961dfb365$var$_objectSpread({}, this.payload), updater);
                return this;
            }
        }
    ]);
}();


function $a8306897c4538302$var$_callSuper(t, o, e) {
    return o = (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(o), (0, (/*@__PURE__*/$parcel$interopDefault($kIXpt)))(t, $a8306897c4538302$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(t).constructor) : o.apply(t, e));
}
function $a8306897c4538302$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($a8306897c4538302$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $a8306897c4538302$var$_superPropGet(t, o, e, r) {
    var p = (0, (/*@__PURE__*/$parcel$interopDefault($lwlXp)))((0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(1 & r ? t.prototype : t), o, e);
    return 2 & r && "function" == typeof p ? function(t) {
        return p.apply(e, t);
    } : p;
}
var $a8306897c4538302$export$35f8383928ba8d7 = function isUIAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $a8306897c4538302$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isUIAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === 'UIAnalyticsEvent';
};
var $a8306897c4538302$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_AnalyticsEvent) {
    function UIAnalyticsEvent(props) {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, UIAnalyticsEvent);
        _this = $a8306897c4538302$var$_callSuper(this, UIAnalyticsEvent, [
            props
        ]);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "_isUIAnalyticsEvent", true);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "clone", function() {
            if (_this.hasFired) return null;
            var context = (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(_this.context);
            var handlers = (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(_this.handlers);
            /**
       * A hacky "deep clone" of the object. This is limited in that it wont
       * support functions, regexs, Maps, Sets, etc, but none of those need to
       * be represented in our payload.
       */ var payload = JSON.parse(JSON.stringify(_this.payload));
            return new UIAnalyticsEvent({
                context: context,
                handlers: handlers,
                payload: payload
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "fire", function(channel) {
            if (_this.hasFired) return;
            _this.handlers.forEach(function(handler) {
                return handler(_this, channel);
            });
            _this.hasFired = true;
        });
        _this.context = props.context || [];
        _this.handlers = props.handlers || [];
        _this.hasFired = false;
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($eyuDe)))(UIAnalyticsEvent, _AnalyticsEvent);
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(UIAnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (this.hasFired) return this;
                return $a8306897c4538302$var$_superPropGet(UIAnalyticsEvent, "update", this, 3)([
                    updater
                ]);
            }
        }
    ]);
}((0, $091a9b8961dfb365$export$2e2bcd8739ae039));



var $5FkrB = parcelRequire("5FkrB");

var $iyyOp = parcelRequire("iyyOp");
var $a952c53e4a7dc7d4$export$d1f587f82ad51c4 = function useAnalyticsContext() {
    return (0, $5FkrB.useContext)((0, $iyyOp.default));
};


function $08398ac0fecdee67$export$5bf35293e545f20c() {
    var analyticsContext = (0, $a952c53e4a7dc7d4$export$d1f587f82ad51c4)();
    var createAnalyticsEvent = (0, $dLGML.useCallbackOne)(function(payload) {
        return new (0, $a8306897c4538302$export$2e2bcd8739ae039)({
            context: analyticsContext.getAtlaskitAnalyticsContext(),
            handlers: analyticsContext.getAtlaskitAnalyticsEventHandlers(),
            payload: payload
        });
    }, [
        analyticsContext
    ]);
    return {
        createAnalyticsEvent: createAnalyticsEvent
    };
}



var $5FkrB = parcelRequire("5FkrB");
var $7137edf7f0efddab$export$1d27a74659855e44 = function useTrackedRef(value) {
    var ref = (0, $5FkrB.useRef)(value);
    ref.current = value;
    return ref;
};


function $3f1f449851838b31$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $3f1f449851838b31$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $3f1f449851838b31$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $3f1f449851838b31$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $3f1f449851838b31$export$a4687b0234b40e28(_ref) {
    var fn = _ref.fn, action = _ref.action, componentName = _ref.componentName, actionSubject = _ref.actionSubject, packageName = _ref.packageName, packageVersion = _ref.packageVersion, analyticsData = _ref.analyticsData;
    var _useAnalyticsEvents = (0, $08398ac0fecdee67$export$5bf35293e545f20c)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
    // We put analyticsData and fn in a ref so that we don't need to break
    // memoization.
    // Generally these could be defined by consumers inline
    // and so we do this to avoid breaking memoization of useCallback
    var dataRef = (0, $7137edf7f0efddab$export$1d27a74659855e44)(analyticsData);
    var fnRef = (0, $7137edf7f0efddab$export$1d27a74659855e44)(fn);
    var handler = (0, $5FkrB.useCallback)(function(value) {
        var analyticsEvent = createAnalyticsEvent({
            action: action,
            actionSubject: actionSubject || componentName,
            attributes: {
                componentName: componentName,
                packageName: packageName,
                packageVersion: packageVersion
            }
        });
        // To avoid wrapping this component in AnalyticsContext we manually
        // push the parent context's meta data into the context.
        // Note: this new 'context'
        var context = $3f1f449851838b31$var$_objectSpread({
            componentName: componentName,
            packageName: packageName,
            packageVersion: packageVersion
        }, dataRef.current);
        analyticsEvent.context.push(context);
        // fire an event on the atlaskit channel
        var clone = analyticsEvent.clone();
        if (clone) clone.fire('atlaskit');
        fnRef.current(value, analyticsEvent);
    }, [
        // These are strings and won't change
        action,
        componentName,
        actionSubject,
        packageName,
        packageVersion,
        // This function is memoized in the context
        createAnalyticsEvent,
        // these are a stable ref because of the useTrackedRef hook
        dataRef,
        fnRef
    ]);
    return handler;
}


/**
 * An empty function which does nothing.
 */ function $9eef7cb9f34fbccc$export$2e2bcd8739ae039() {}



var $eqVaP = parcelRequire("eqVaP");


var $d4a7825669dd53f6$var$_excluded = [
    "children",
    "backgroundColor",
    "padding",
    "paddingBlock",
    "paddingBlockStart",
    "paddingBlockEnd",
    "paddingInline",
    "paddingInlineStart",
    "paddingInlineEnd",
    "isDisabled",
    "type",
    "onClick",
    "interactionName",
    "componentName",
    "analyticsContext",
    "style",
    "testId",
    "xcss"
], $d4a7825669dd53f6$var$_excluded2 = [
    "className"
];
// This duplicates FocusRing styles from `@atlaskit/focus-ring`.
var $d4a7825669dd53f6$var$focusRingStyles = (0, $74Zh5.css)({
    '&:focus, &:focus-visible': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        outlineColor: (0, $e955727b9ac9b5b6$export$1531ad5bb3fbedac)['color.border.focused'],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        outlineOffset: (0, $e955727b9ac9b5b6$export$958d0ae7f2977ae4)['space.025'],
        outlineStyle: 'solid',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        outlineWidth: (0, $e955727b9ac9b5b6$export$e1b83c5210c471b8)['border.width.focused']
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
    '&:focus:not(:focus-visible)': {
        outline: 'none'
    },
    '@media screen and (forced-colors: active), screen and (-ms-high-contrast: active)': {
        '&:focus-visible': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
            outline: "".concat((0, $e955727b9ac9b5b6$export$e1b83c5210c471b8)['border.width'], " solid")
        }
    }
});
var $d4a7825669dd53f6$var$baseStyles = (0, $74Zh5.css)({
    boxSizing: 'border-box',
    appearance: 'none',
    border: 'none'
});
var $d4a7825669dd53f6$var$enabledStyles = (0, $74Zh5.css)({
    cursor: 'pointer'
});
var $d4a7825669dd53f6$var$disabledStyles = (0, $74Zh5.css)({
    cursor: 'not-allowed'
});
/**
 * __Pressable__
 *
 * A primitive for building custom buttons.
 *
 * - [Examples](https://atlassian.design/components/primitives/pressable/examples)
 * - [Code](https://atlassian.design/components/primitives/pressable/code)
 * - [Usage](https://atlassian.design/components/primitives/pressable/usage)
 */ var $d4a7825669dd53f6$var$Pressable = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function(_ref, ref) {
    var children = _ref.children, backgroundColor = _ref.backgroundColor, padding = _ref.padding, paddingBlock = _ref.paddingBlock, paddingBlockStart = _ref.paddingBlockStart, paddingBlockEnd = _ref.paddingBlockEnd, paddingInline = _ref.paddingInline, paddingInlineStart = _ref.paddingInlineStart, paddingInlineEnd = _ref.paddingInlineEnd, isDisabled = _ref.isDisabled, _ref$type = _ref.type, type = _ref$type === void 0 ? 'button' : _ref$type, _ref$onClick = _ref.onClick, providedOnClick = _ref$onClick === void 0 ? (0, $9eef7cb9f34fbccc$export$2e2bcd8739ae039) : _ref$onClick, interactionName = _ref.interactionName, componentName = _ref.componentName, analyticsContext = _ref.analyticsContext, style = _ref.style, testId = _ref.testId, xcss = _ref.xcss, htmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $d4a7825669dd53f6$var$_excluded);
    var interactionContext = (0, $5FkrB.useContext)((0, $eqVaP.default));
    var handleClick = (0, $5FkrB.useCallback)(function(e, analyticsEvent) {
        interactionContext && interactionContext.tracePress(interactionName, e.timeStamp);
        providedOnClick(e, analyticsEvent);
    }, [
        providedOnClick,
        interactionContext,
        interactionName
    ]);
    var onClick = (0, $3f1f449851838b31$export$a4687b0234b40e28)({
        fn: handleClick,
        action: 'clicked',
        componentName: componentName || 'Pressable',
        packageName: "@atlaskit/primitives",
        packageVersion: "19.0.0",
        analyticsData: analyticsContext,
        actionSubject: 'button'
    });
    // This is to remove className from safeHtmlAttributes
    // @ts-expect-error className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(htmlAttributes, $d4a7825669dd53f6$var$_excluded2);
    var resolvedStyles = (0, $c1bec583fa49072f$export$a9c84988c8f81f2d)(xcss);
    return (0, $74Zh5.jsx)("button", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        style: style,
        ref: ref,
        className: resolvedStyles.static
    }, safeHtmlAttributes, {
        // eslint-disable-next-line react/button-has-type
        type: type,
        onClick: onClick,
        disabled: isDisabled,
        css: [
            $d4a7825669dd53f6$var$baseStyles,
            $d4a7825669dd53f6$var$focusRingStyles,
            isDisabled ? $d4a7825669dd53f6$var$disabledStyles : $d4a7825669dd53f6$var$enabledStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            backgroundColor && (0, $e955727b9ac9b5b6$export$e7af83bafe7f9e63)[backgroundColor],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            padding && (0, $e955727b9ac9b5b6$export$e615f061ca585a6c).padding[padding],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlock && (0, $e955727b9ac9b5b6$export$e615f061ca585a6c).paddingBlock[paddingBlock],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlockStart && (0, $e955727b9ac9b5b6$export$e615f061ca585a6c).paddingBlockStart[paddingBlockStart],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlockEnd && (0, $e955727b9ac9b5b6$export$e615f061ca585a6c).paddingBlockEnd[paddingBlockEnd],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInline && (0, $e955727b9ac9b5b6$export$e615f061ca585a6c).paddingInline[paddingInline],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInlineStart && (0, $e955727b9ac9b5b6$export$e615f061ca585a6c).paddingInlineStart[paddingInlineStart],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInlineEnd && (0, $e955727b9ac9b5b6$export$e615f061ca585a6c).paddingInlineEnd[paddingInlineEnd]
        ].concat((0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(resolvedStyles.emotion || [])),
        "data-testid": testId
    }), children);
});
var $d4a7825669dd53f6$export$2e2bcd8739ae039 = $d4a7825669dd53f6$var$Pressable;


/* badge.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $5FkrB = parcelRequire("5FkrB");
/**
 * This length includes the underscore,
 * e.g. `"_1s4A"` would be a valid atomic group hash.
 */ const $2497340772c89e9b$var$ATOMIC_GROUP_LENGTH = 5;
function $2497340772c89e9b$export$2e2bcd8739ae039(classNames) {
    // Shortcut: nothing to do
    if (!classNames.length) return;
    // Shortcut: don't need to do anything if we only have a single classname
    if (classNames.length === 1 && classNames[0] && // checking to see if `classNames[0]` is a string that contains other classnames
    !classNames[0].includes(' ')) return classNames[0];
    // Using an object rather than a `Map` as it performed better in our benchmarks.
    // Would be happy to move to `Map` if it proved to be better under real conditions.
    const map = {};
    // Note: using loops to minimize iterations over the collection
    for (const value of classNames){
        // Exclude all falsy values, which leaves us with populated strings
        if (!value) continue;
        // a `value` can contain multiple classnames
        const list = value.split(' ');
        for (const className of list){
            /**
             * For atomic style classnames: the `key` is the `group`
             *
             * - Later atomic classnames with the same `group` will override earlier ones
             *   (which is what we want).
             * - Assumes atomic classnames are the only things that start with `_`
             * - Could use a regex to ensure that atomic classnames are structured how we expect,
             *   but did not add that for now as it did slow things down a bit.
             *
             * For other classnames: the `key` is the whole classname
             * - Okay to remove duplicates as doing so does not impact specificity
             *
             * */ const key = className.startsWith('_') ? className.slice(0, $2497340772c89e9b$var$ATOMIC_GROUP_LENGTH) : className;
            map[key] = className;
        }
    }
    /**
     * We are converting the `map` into a string.
     *
     * The simple way to do this would be `Object.values(map).join(' ')`.
     * However, the approach below performs 10%-20% better in benchmarks.
     *
     * For `ax()` it feels right to squeeze as much runtime performance out as we can.
     */ let result = '';
    for(const key in map)result += map[key] + ' ';
    // If we have an empty string, then our `map` was empty.
    if (!result) return;
    // remove last " " from the result (we added " " at the end of every value)
    return result.trimEnd();
}



var $ISKn7 = parcelRequire("ISKn7");
var $57e3792eefe88ed9$var$_process, $57e3792eefe88ed9$var$_process2;
// We can't rely on NODE_ENV === 'test' if its value is already configured by the consumer to some other value, so better to use JEST_WORKER_ID
// https://jestjs.io/docs/environment-variables#jest_worker_id
var $57e3792eefe88ed9$var$TESTS_MODE = (globalThis === null || globalThis === void 0 || ($57e3792eefe88ed9$var$_process = globalThis.process) === null || $57e3792eefe88ed9$var$_process === void 0 || ($57e3792eefe88ed9$var$_process = $57e3792eefe88ed9$var$_process.env) === null || $57e3792eefe88ed9$var$_process === void 0 ? void 0 : $57e3792eefe88ed9$var$_process.JEST_WORKER_ID) !== undefined;
var $57e3792eefe88ed9$var$DEBUG_MODE = !$57e3792eefe88ed9$var$TESTS_MODE && (globalThis === null || globalThis === void 0 || ($57e3792eefe88ed9$var$_process2 = globalThis.process) === null || $57e3792eefe88ed9$var$_process2 === void 0 || ($57e3792eefe88ed9$var$_process2 = $57e3792eefe88ed9$var$_process2.env) === null || $57e3792eefe88ed9$var$_process2 === void 0 ? void 0 : $57e3792eefe88ed9$var$_process2.NODE_ENV) !== 'production';
var $57e3792eefe88ed9$export$1c9f709888824e05 = function debug() {
    var _console;
    if (!$57e3792eefe88ed9$var$DEBUG_MODE) return;
    // eslint-disable-next-line no-console
    (_console = console).debug.apply(_console, arguments);
};



var $3ZMUU = parcelRequire("3ZMUU");
var $be5c78140b7e3efd$var$pkgName = '@atlaskit/platform-feature-flags';
var $be5c78140b7e3efd$export$7e41b1b2bdee3f98 = '__PLATFORM_FEATURE_FLAGS__';
var $be5c78140b7e3efd$var$hasProcessEnv = typeof $3ZMUU !== 'undefined' && typeof $3ZMUU.env !== 'undefined';
// FF global overrides can be configured by test runners or Storybook
var $be5c78140b7e3efd$var$ENV_ENABLE_PLATFORM_FF = $be5c78140b7e3efd$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
// STORYBOOK_ENABLE_PLATFORM_FF is included as storybook only allows env vars prefixed with STORYBOOK
// https://github.com/storybookjs/storybook/issues/12270
var $be5c78140b7e3efd$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF = $be5c78140b7e3efd$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
var $be5c78140b7e3efd$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE = $be5c78140b7e3efd$var$ENV_ENABLE_PLATFORM_FF || $be5c78140b7e3efd$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF;
var $be5c78140b7e3efd$var$DEFAULT_PFF_GLOBAL = {
    booleanResolver: undefined
};
var $be5c78140b7e3efd$var$globalVar = typeof window !== 'undefined' ? window : globalThis;
$be5c78140b7e3efd$var$globalVar[$be5c78140b7e3efd$export$7e41b1b2bdee3f98] = $be5c78140b7e3efd$var$globalVar[$be5c78140b7e3efd$export$7e41b1b2bdee3f98] || $be5c78140b7e3efd$var$DEFAULT_PFF_GLOBAL;
function $be5c78140b7e3efd$export$f2b591175b3e424c(resolver) {
    $be5c78140b7e3efd$var$globalVar[$be5c78140b7e3efd$export$7e41b1b2bdee3f98].booleanResolver = resolver;
}
function $be5c78140b7e3efd$export$6333b6aff9fc6275(flagKey) {
    if ($be5c78140b7e3efd$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE) {
        (0, $57e3792eefe88ed9$export$1c9f709888824e05)('[%s]: The feature flags were enabled while running tests. The flag "%s" will be always enabled.', $be5c78140b7e3efd$var$pkgName, flagKey);
        return true;
    }
    try {
        var _globalVar$PFF_GLOBAL, _globalVar$PFF_GLOBAL2, _globalVar$PFF_GLOBAL3;
        // booleanResolver will be empty for products like Trello, Elevate, Recruit etc.
        // Currently only Confluence, Jira and Bitbucket has set it.
        if (((_globalVar$PFF_GLOBAL = $be5c78140b7e3efd$var$globalVar[$be5c78140b7e3efd$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL === void 0 ? void 0 : _globalVar$PFF_GLOBAL.booleanResolver) === undefined || ((_globalVar$PFF_GLOBAL2 = $be5c78140b7e3efd$var$globalVar[$be5c78140b7e3efd$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL2 === void 0 ? void 0 : _globalVar$PFF_GLOBAL2.booleanResolver) === null) // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
        return (0, $ISKn7.default).checkGate(flagKey);
        var result = (_globalVar$PFF_GLOBAL3 = $be5c78140b7e3efd$var$globalVar[$be5c78140b7e3efd$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL3 === void 0 ? void 0 : _globalVar$PFF_GLOBAL3.booleanResolver(flagKey);
        if (typeof result !== 'boolean') {
            // eslint-disable-next-line no-console
            console.warn("".concat(flagKey, " resolved to a non-boolean value, returning false for safety"));
            return false;
        }
        return result;
    } catch (e) {
        return false;
    }
}


function $3217752dba69dd42$export$ba05d765b8392e5e(flagResolver) {
    (0, $be5c78140b7e3efd$export$f2b591175b3e424c)(flagResolver);
}
function $3217752dba69dd42$export$470e5c2be1411c89(name) {
    return (0, $be5c78140b7e3efd$export$6333b6aff9fc6275)(name);
}
function $3217752dba69dd42$export$b40ec24ac8275656(name) {
    return (0, $be5c78140b7e3efd$export$6333b6aff9fc6275)(name);
}


/* text.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $5FkrB = parcelRequire("5FkrB");


var $afMOk = parcelRequire("afMOk");

var $5FkrB = parcelRequire("5FkrB");
var $c43273a981f3884e$var$HasTextAncestorContext = /*#__PURE__*/ (0, $5FkrB.createContext)(false);
var $c43273a981f3884e$export$9322276ec105d055 = function useHasTextAncestor() {
    return (0, $5FkrB.useContext)($c43273a981f3884e$var$HasTextAncestorContext);
};
var $c43273a981f3884e$export$ae933c6cbe5643ad = $c43273a981f3884e$var$HasTextAncestorContext.Provider;



var $5FkrB = parcelRequire("5FkrB");

var $5FkrB = parcelRequire("5FkrB");
var $63e667d79c8b3067$export$1ca2a26fecb070ae = /*#__PURE__*/ (0, $5FkrB.createContext)('elevation.surface');


var $d17e68531eaaddd1$export$1aeb4f6b93c4540d = function useSurface() {
    return (0, $5FkrB.useContext)((0, $63e667d79c8b3067$export$1ca2a26fecb070ae));
};
(0, $63e667d79c8b3067$export$1ca2a26fecb070ae).displayName = 'SurfaceProvider';


var $a1a00df3bd122236$var$asAllowlist = [
    'span',
    'p',
    'strong',
    'em'
];
/**
 * Custom hook designed to abstract the parsing of the color props and make it clearer in the future how color is reconciled between themes and tokens.
 */ var $a1a00df3bd122236$var$useColor = function useColor(colorProp, hasTextAncestor) {
    var surface = (0, $d17e68531eaaddd1$export$1aeb4f6b93c4540d)();
    if (colorProp === 'inherit') return undefined;
    if (colorProp) return colorProp;
    if (hasTextAncestor) return undefined;
    if ($a1a00df3bd122236$export$2185ce37f9bdd963.hasOwnProperty(surface)) return $a1a00df3bd122236$export$2185ce37f9bdd963[surface];
    return 'color.text';
};
var $a1a00df3bd122236$var$styles = {
    root: "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _1i4qfg65",
    'as.strong': "_k48pwu06",
    'as.em': "_zg8l1m30",
    'textAlign.center': "_y3gn1h6o",
    'textAlign.end': "_y3gnh9n0",
    'textAlign.start': "_y3gnv2br",
    truncation: "_1reo15vq _18m915vq _1e0ccj1k _sudp1e54",
    breakAll: "_1nmz9jpi"
};
var $a1a00df3bd122236$var$fontSizeMap = {
    medium: "_11c8fhey",
    large: "_11c81d4k",
    small: "_11c8wadc"
};
var $a1a00df3bd122236$var$fontWeightMap = {
    bold: "_k48pwu06",
    medium: "_k48p1wq8",
    regular: "_k48pi7a9",
    semibold: "_k48p1pd9"
};
var $a1a00df3bd122236$var$textColorMap = {
    'color.text': "_syazi7uo",
    'color.text.accent.lime': "_syaz1tco",
    'color.text.accent.lime.bolder': "_syaz1ik3",
    'color.text.accent.red': "_syaz9lu1",
    'color.text.accent.red.bolder': "_syazhwvp",
    'color.text.accent.orange': "_syazp1lv",
    'color.text.accent.orange.bolder': "_syaz7i1p",
    'color.text.accent.yellow': "_syazfb2s",
    'color.text.accent.yellow.bolder': "_syazekll",
    'color.text.accent.green': "_syazh55r",
    'color.text.accent.green.bolder': "_syaz1y78",
    'color.text.accent.teal': "_syaz17qg",
    'color.text.accent.teal.bolder': "_syaz12v7",
    'color.text.accent.blue': "_syaz16jw",
    'color.text.accent.blue.bolder': "_syaz1kyx",
    'color.text.accent.purple': "_syazqmo9",
    'color.text.accent.purple.bolder': "_syaz1mn1",
    'color.text.accent.magenta': "_syaz1s8m",
    'color.text.accent.magenta.bolder': "_syaz1qur",
    'color.text.accent.gray': "_syaz1sqi",
    'color.text.accent.gray.bolder': "_syaz1tmo",
    'color.text.disabled': "_syaz1gmx",
    'color.text.inverse': "_syaz15cr",
    'color.text.selected': "_syaz6x5g",
    'color.text.brand': "_syaz1oa5",
    'color.text.danger': "_syaz1tmw",
    'color.text.warning': "_syaz1xn9",
    'color.text.warning.inverse': "_syaz1yd3",
    'color.text.success': "_syazgsak",
    'color.text.discovery': "_syazdv2p",
    'color.text.information': "_syazu3tg",
    'color.text.subtlest': "_syaz1rpy",
    'color.text.subtle': "_syazazsu",
    'color.link': "_syaz13af",
    'color.link.pressed': "_syaz12zz",
    'color.link.visited': "_syaz1ra0",
    'color.link.visited.pressed': "_syaz17z1"
};
var $a1a00df3bd122236$export$2185ce37f9bdd963 = {
    'color.background.neutral.bold': 'color.text.inverse',
    'color.background.neutral.bold.hovered': 'color.text.inverse',
    'color.background.neutral.bold.pressed': 'color.text.inverse',
    'color.background.selected.bold': 'color.text.inverse',
    'color.background.selected.bold.hovered': 'color.text.inverse',
    'color.background.selected.bold.pressed': 'color.text.inverse',
    'color.background.brand.bold': 'color.text.inverse',
    'color.background.brand.bold.hovered': 'color.text.inverse',
    'color.background.brand.bold.pressed': 'color.text.inverse',
    'color.background.brand.boldest': 'color.text.inverse',
    'color.background.brand.boldest.hovered': 'color.text.inverse',
    'color.background.brand.boldest.pressed': 'color.text.inverse',
    'color.background.danger.bold': 'color.text.inverse',
    'color.background.danger.bold.hovered': 'color.text.inverse',
    'color.background.danger.bold.pressed': 'color.text.inverse',
    'color.background.warning.bold': 'color.text.warning.inverse',
    'color.background.warning.bold.hovered': 'color.text.warning.inverse',
    'color.background.warning.bold.pressed': 'color.text.warning.inverse',
    'color.background.success.bold': 'color.text.inverse',
    'color.background.success.bold.hovered': 'color.text.inverse',
    'color.background.success.bold.pressed': 'color.text.inverse',
    'color.background.discovery.bold': 'color.text.inverse',
    'color.background.discovery.bold.hovered': 'color.text.inverse',
    'color.background.discovery.bold.pressed': 'color.text.inverse',
    'color.background.information.bold': 'color.text.inverse',
    'color.background.information.bold.hovered': 'color.text.inverse',
    'color.background.information.bold.pressed': 'color.text.inverse'
};
/**
 * __Text__
 *
 * Text is a primitive component that has the Atlassian Design System's design guidelines baked in.
 * This includes considerations for text attributes such as color, font size, font weight, and line height.
 * It renders a `span` by default.
 *
 * @internal
 */ var $a1a00df3bd122236$var$Text = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? 'span' : _ref$as, colorProp = _ref.color, align = _ref.align, testId = _ref.testId, id = _ref.id, size = _ref.size, weight = _ref.weight, maxLines = _ref.maxLines, xcss = _ref.xcss, children = _ref.children;
    (0, $afMOk.default)($a1a00df3bd122236$var$asAllowlist.includes(Component), "@atlaskit/primitives: Text received an invalid \"as\" value of \"".concat(Component, "\""));
    var hasTextAncestor = (0, $c43273a981f3884e$export$9322276ec105d055)();
    var color = $a1a00df3bd122236$var$useColor(colorProp, hasTextAncestor);
    if (!size && !hasTextAncestor) size = 'medium';
    var component = /*#__PURE__*/ $5FkrB.createElement(Component, {
        id: id,
        className: (0, $2497340772c89e9b$export$2e2bcd8739ae039)([
            $a1a00df3bd122236$var$styles.root,
            size && $a1a00df3bd122236$var$fontSizeMap[size],
            color && $a1a00df3bd122236$var$textColorMap[color],
            maxLines && $a1a00df3bd122236$var$styles.truncation,
            maxLines === 1 && $a1a00df3bd122236$var$styles.breakAll,
            align && $a1a00df3bd122236$var$styles["textAlign.".concat(align)],
            weight && $a1a00df3bd122236$var$fontWeightMap[weight],
            Component === 'em' && $a1a00df3bd122236$var$styles['as.em'],
            Component === 'strong' && $a1a00df3bd122236$var$styles['as.strong'],
            xcss
        ]),
        style: {
            WebkitLineClamp: maxLines
        },
        "data-testid": testId,
        ref: ref
    }, children);
    if (hasTextAncestor) // no need to re-apply context if the text is already wrapped
    return component;
    return /*#__PURE__*/ $5FkrB.createElement((0, $c43273a981f3884e$export$ae933c6cbe5643ad), {
        value: true
    }, component);
});
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$a1a00df3bd122236$export$2e2bcd8739ae039 = $a1a00df3bd122236$var$Text;


/**
 * @jsxRuntime classic
 * @jsx jsx
 */ var $80644e2bed1866d1$export$d21bba0569254935 = {
    added: 'success',
    removed: 'danger',
    default: 'neutral',
    primary: 'information',
    primaryInverted: 'inverse',
    important: 'danger',
    warning: 'warning',
    discovery: 'discovery',
    danger: 'danger',
    success: 'success',
    information: 'information',
    inverse: 'inverse',
    neutral: 'neutral',
    informationBold: 'informationBold',
    successBold: 'successBold',
    dangerBold: 'dangerBold',
    warningBold: 'warningBold',
    discoveryBold: 'discoveryBold'
};


/**
 * @jsxRuntime classic
 * @jsx jsx
 */ var $784c0047ac8f9b6c$export$16f8cc7ac3541e83 = {
    added: 'added',
    removed: 'removed',
    default: 'default',
    primary: 'primary',
    primaryInverted: 'primaryInverted',
    important: 'important',
    danger: 'removed',
    success: 'added',
    information: 'primary',
    inverse: 'primaryInverted',
    neutral: 'default',
    warning: 'default',
    discovery: 'default',
    informationBold: 'primary',
    successBold: 'added',
    dangerBold: 'important',
    warningBold: 'default',
    discoveryBold: 'default'
};


/* badge-new.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $5FkrB = parcelRequire("5FkrB");



var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");

var $25nEq = parcelRequire("25nEq");
var $cdac5406f56ce43a$export$4ef52930e33717cd = 'data-theme';
var $cdac5406f56ce43a$export$cb374d25ded7f6ab = 'data-subtree-theme';
var $cdac5406f56ce43a$export$a00eac3f8684bcd0 = 'data-color-mode';
var $cdac5406f56ce43a$export$2112803007239c61 = 'data-contrast-mode';
var $cdac5406f56ce43a$export$352e418ed5b6193a = 'data-custom-theme';
var $cdac5406f56ce43a$export$6f0c6fb8c80fcc92 = 'ds';
var $cdac5406f56ce43a$export$4d0c7bbf80185957 = [
    'opacity',
    'font',
    'space',
    'border',
    'radius'
];
var $cdac5406f56ce43a$export$dddac1532e822863 = "--".concat($cdac5406f56ce43a$export$6f0c6fb8c80fcc92, "-token-not-found");
var $cdac5406f56ce43a$export$9d7b58831ae93caa = "--".concat($cdac5406f56ce43a$export$6f0c6fb8c80fcc92, "-elevation-surface-current");


/**
 * Theme modes: The general purpose of a theme.
 * This attr is used to apply the appropriate system-preference option
 * It may also be used as a selector for mode-specific overrides such as light/dark images.
 * The idea is there may exist many color themes, but every theme must either fit into light or dark.
 */ var $b618ae213ded1369$export$83993de8eb66733 = [
    'light',
    'dark',
    'auto'
];



var $iYJcE = parcelRequire("iYJcE");
var $d5bb2abaafb9f311$export$4a14e169b1de4ee7 = function isColorMode(modeId) {
    return [
        'light',
        'dark',
        'auto'
    ].includes(modeId);
};


/**
 * Theme ids: The value that will be mounted to the DOM as a data attr
 * For example: `data-theme="light:light dark:dark spacing:spacing"
 *
 * These ids must be kebab case
 */ var $6aa4e94230a362b0$export$7d43e72a58e3283f = [
    'light-increased-contrast',
    'light',
    'light-future',
    'dark',
    'dark-future',
    'dark-increased-contrast',
    'spacing',
    'shape',
    'typography',
    'motion'
];


var $69e8c9d3b2a47338$export$ea35b8958c39dd07 = function isThemeIds(themeId) {
    return (0, $6aa4e94230a362b0$export$7d43e72a58e3283f).find(function(id) {
        return id === themeId;
    }) !== undefined;
};


var $e6837b7380834933$var$themeKinds = [
    'light',
    'dark',
    'spacing',
    'typography',
    'shape',
    'motion'
];
var $e6837b7380834933$export$958fa026be3a263e = function isThemeKind(themeKind) {
    return $e6837b7380834933$var$themeKinds.find(function(kind) {
        return kind === themeKind;
    }) !== undefined;
};


var $1f3645e5d1eba508$var$customThemeOptions = 'UNSAFE_themeOptions';
var $1f3645e5d1eba508$export$f19b488f7c0547ee = function themeStringToObject(themeState) {
    return themeState.split(' ')// @ts-ignore - TS1501 TypeScript 5.9.2 upgrade
    .map(function(theme) {
        return theme.split(/:([^]*)/);
    }).reduce(function(themeObject, _ref) {
        var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_ref, 2), kind = _ref2[0], id = _ref2[1];
        if (kind === 'colorMode' && (0, $d5bb2abaafb9f311$export$4a14e169b1de4ee7)(id)) themeObject[kind] = id;
        if ((0, $e6837b7380834933$export$958fa026be3a263e)(kind) && (0, $69e8c9d3b2a47338$export$ea35b8958c39dd07)(id)) // @ts-expect-error FIXME - this is a valid ts error
        themeObject[kind] = id;
        if (kind === $1f3645e5d1eba508$var$customThemeOptions) try {
            themeObject[$1f3645e5d1eba508$var$customThemeOptions] = JSON.parse(id);
        } catch (_unused) {
            new Error('Invalid custom theme string');
        }
        return themeObject;
    }, {});
};


function $190213e70a1def0b$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $190213e70a1def0b$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $190213e70a1def0b$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $190213e70a1def0b$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $190213e70a1def0b$var$isThemeColorMode = function isThemeColorMode(colorMode) {
    return (0, $b618ae213ded1369$export$83993de8eb66733).find(function(mode) {
        return mode === colorMode;
    }) !== undefined;
};
var $190213e70a1def0b$var$getGlobalTheme = function getGlobalTheme() {
    if (typeof document === 'undefined') return {};
    var element = document.documentElement;
    var colorMode = element.getAttribute((0, $cdac5406f56ce43a$export$a00eac3f8684bcd0)) || '';
    var theme = element.getAttribute((0, $cdac5406f56ce43a$export$4ef52930e33717cd)) || '';
    return $190213e70a1def0b$var$_objectSpread($190213e70a1def0b$var$_objectSpread({}, (0, $1f3645e5d1eba508$export$f19b488f7c0547ee)(theme)), $190213e70a1def0b$var$isThemeColorMode(colorMode) && {
        colorMode: colorMode
    });
};
var $190213e70a1def0b$export$2e2bcd8739ae039 = $190213e70a1def0b$var$getGlobalTheme;



var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $25nEq = parcelRequire("25nEq");


/**
 * A MutationObserver which watches the `<html>` element for changes to the theme.
 *
 * In React, use the {@link useThemeObserver `useThemeObserver`} hook instead.
 *
 * @param {function} callback - A callback function which fires when the theme changes.
 *
 * @example
 * ```
 * const observer = new ThemeMutationObserver((theme) => {});
 * observer.observe();
 * ```
 */ var $7ee671b3f95a4454$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function ThemeMutationObserver(callback) {
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, ThemeMutationObserver);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "legacyObserver", null);
        this.callback = callback;
        ThemeMutationObserver.callbacks.add(callback);
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(ThemeMutationObserver, [
        {
            key: "observe",
            value: function observe() {
                if (!ThemeMutationObserver.observer) {
                    ThemeMutationObserver.observer = new MutationObserver(function() {
                        var theme = (0, $190213e70a1def0b$export$2e2bcd8739ae039)();
                        ThemeMutationObserver.callbacks.forEach(function(callback) {
                            return callback(theme);
                        });
                    });
                    // Observer only needs to be configured once
                    ThemeMutationObserver.observer.observe(document.documentElement, {
                        attributeFilter: [
                            (0, $cdac5406f56ce43a$export$4ef52930e33717cd),
                            (0, $cdac5406f56ce43a$export$a00eac3f8684bcd0)
                        ]
                    });
                }
            }
        },
        {
            key: "disconnect",
            value: function disconnect() {
                if (this.callback) ThemeMutationObserver.callbacks.delete(this.callback);
                if (ThemeMutationObserver.callbacks.size === 0 && ThemeMutationObserver.observer) {
                    ThemeMutationObserver.observer.disconnect();
                    ThemeMutationObserver.observer = null;
                }
            }
        }
    ]);
}();
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($7ee671b3f95a4454$export$2e2bcd8739ae039, "observer", null);
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($7ee671b3f95a4454$export$2e2bcd8739ae039, "callbacks", new Set());


/**
 * A React hook which returns the current themes and color-mode set on `<html>`.
 *
 * @example
 * ```
 * const { colorMode, dark, light, spacing, typography } = useThemeObserver();
 *
 * // Performing side effects when it changes
 * useEffect(() => {
 *   console.log(`The color mode has changed to ${theme.colorMode}`);
 * }, [theme.colorMode]);
 * ```
 */ var $97f376c96e350a96$var$useThemeObserver = function useThemeObserver() {
    var _useState = (0, $5FkrB.useState)((0, $190213e70a1def0b$export$2e2bcd8739ae039)()), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), theme = _useState2[0], setTheme = _useState2[1];
    (0, $5FkrB.useEffect)(function() {
        var observer = new (0, $7ee671b3f95a4454$export$2e2bcd8739ae039)(function(theme) {
            return setTheme(theme);
        });
        observer.observe();
        return function() {
            return observer.disconnect();
        };
    }, []);
    return theme;
};
var $97f376c96e350a96$export$2e2bcd8739ae039 = $97f376c96e350a96$var$useThemeObserver;


function $7365b71a3b911fbf$var$getSafeValue() {
    var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    var numericValue = +value;
    if (numericValue < 0) return 0;
    return value;
}
function $7365b71a3b911fbf$export$7c4d25c0c3217d8c(value, max) {
    var safeValue = $7365b71a3b911fbf$var$getSafeValue(value);
    var safeMax = $7365b71a3b911fbf$var$getSafeValue(max);
    if (safeMax && safeMax < safeValue) return "".concat(safeMax, "+");
    if (safeValue === Infinity) return "\u221E";
    return safeValue.toString();
}


/* eslint-disable @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors */ // Nested selectors with data attributes are required for theme switching
var $0da488f75a4043f8$var$stylesNew = {
    root: "_2rkolb4i _18zr1b66 _1rjcidpf _1e0c116y _vchhusvi _1ul91ejb _1bah1h6o _1o9zidpf _1kz6184x",
    success: "_syaz1p1e _bfhk14j0",
    danger: "_syaz1blx _bfhk18wg",
    warning: "_syazmgs1 _bfhk10f4",
    information: "_syaz1qd9 _bfhk8lbg",
    discovery: "_syaz1g72 _bfhke670",
    neutral: "_syazi7uo _bfhk7qp0",
    inverse: "_bfhkvuon _syazi7uo",
    informationBold: "_syaz1qd9 _bfhk9pm7",
    successBold: "_syaz1p1e _bfhk16ib",
    dangerBold: "_syaz1blx _bfhkud63",
    warningBold: "_syazmgs1 _bfhk1kmu",
    warningBoldDark: "_syazmgs1 _bfhkgj02",
    discoveryBold: "_syaz1g72 _bfhk5ly7"
};
/* eslint-enable @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors */ var $0da488f75a4043f8$var$badgeValueWithNegativeNumberSupported = function badgeValueWithNegativeNumberSupported(children, max) {
    return typeof children === 'number' && max ? (0, $7365b71a3b911fbf$export$7c4d25c0c3217d8c)(children, max) : children;
};
/**
 * __BadgeNew__
 *
 * New visual refresh implementation of Badge component for the labelling system.
 * This component is used when the 'platform-dst-lozenge-tag-badge-visual-uplifts' feature flag is enabled.
 *
 * Uses new appearance naming convention:
 * - success (green)
 * - danger (red)
 * - neutral (gray)
 * - information (blue)
 * - inverse (inverted colors)
 * - warning (orange/yellow)
 * - discovery (purple)
 * - informationBold (bold blue, color.background.information.subtle)
 * - successBold (bold green, color.background.success.subtle)
 * - dangerBold (bold red, color.background.danger.subtle)
 * - warningBold (bold warning, color.background.warning.bold)
 * - discoveryBold (bold purple, color.background.discovery.subtle)
 */ var $0da488f75a4043f8$var$BadgeNew = /*#__PURE__*/ (0, $5FkrB.memo)(function BadgeNew(_ref) {
    var _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'neutral' : _ref$appearance, _ref$children = _ref.children, children = _ref$children === void 0 ? 0 : _ref$children, _ref$max = _ref.max, max = _ref$max === void 0 ? 99 : _ref$max, style = _ref.style, testId = _ref.testId;
    var _useThemeObserver = (0, $97f376c96e350a96$export$2e2bcd8739ae039)(), colorMode = _useThemeObserver.colorMode;
    // In dark theme, warningBold needs to swap to a lighter background
    // (color.background.warning.subtle / Orange800) for better contrast against
    // the typical dark surface colors.
    var resolvedAppearance = appearance === 'warningBold' && colorMode === 'dark' ? 'warningBoldDark' : appearance;
    return /*#__PURE__*/ $5FkrB.createElement("span", {
        "data-testid": testId,
        style: {
            background: style === null || style === void 0 ? void 0 : style.backgroundColor,
            color: style === null || style === void 0 ? void 0 : style.color
        },
        className: (0, $2497340772c89e9b$export$2e2bcd8739ae039)([
            $0da488f75a4043f8$var$stylesNew.root,
            $0da488f75a4043f8$var$stylesNew[resolvedAppearance]
        ])
    }, /*#__PURE__*/ $5FkrB.createElement((0, $a1a00df3bd122236$export$2e2bcd8739ae039), {
        size: "small",
        align: "center",
        color: "inherit"
    }, $0da488f75a4043f8$var$badgeValueWithNegativeNumberSupported(children, max)));
});
var $0da488f75a4043f8$export$2e2bcd8739ae039 = $0da488f75a4043f8$var$BadgeNew;


function $7cbc607cce3cf77d$var$getSafeValueWithNegativeSupport() {
    var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    var numericValue = +value;
    // NOTE: Changing below code as this causes custom fields -ve number to show up as zero in activity timeline.
    // This will ensure it renders correctly if it is a number otherwise renders 0
    // If the value is NaN, return it as is (assuming it's a non-numeric string)
    if (isNaN(numericValue)) return value;
    // Return the numeric value, allowing negative numbers
    return numericValue;
}
function $7cbc607cce3cf77d$export$4b844743568d5983(value, max) {
    var safeValue = $7cbc607cce3cf77d$var$getSafeValueWithNegativeSupport(value);
    var safeMax = $7cbc607cce3cf77d$var$getSafeValueWithNegativeSupport(max);
    var hasSafeMaxValue = false;
    if (max !== undefined) hasSafeMaxValue = true;
    if (safeMax === Infinity && safeValue === Infinity) return "\u221E";
    if (hasSafeMaxValue && safeMax < safeValue) return "".concat(safeMax, "+");
    if (safeValue === Infinity) return "\u221E";
    return safeValue.toString();
}


/**
 * Visual refresh colors.
 * Hardcoded hex colors are used as the they will be updated in the labelling system work and we want to avoid frequent UI changes.\
 *
 * Using separate variables as opposed to an object, to comply with UI styling standard
 * https://atlassian.design/components/eslint-plugin-ui-styling-standard/no-unsafe-values/usage#object-access
 */ var $e676d41834cd8010$var$neutral300 = '#DDDEE1';
var $e676d41834cd8010$var$red300 = '#FD9891';
var $e676d41834cd8010$var$blue300 = '#8FB8F6';
var $e676d41834cd8010$var$neutral1000 = '#292A2E';
var $e676d41834cd8010$var$styles = {
    root: "_2rkolb4i _18zr1b66 _1e0c116y _vchhusvi _1ul91ejb _1bah1h6o _1o9zidpf _1kz6184x",
    added: "_bfhk1y9u _syazi7uo",
    default: "_bfhk1fkg _syazwwip",
    important: "_bfhk1366 _syazwwip",
    primary: "_bfhk1ymo _syazwwip",
    primaryInverted: "_bfhkvuon _syaz1oa5",
    removed: "_bfhk1gly _syazi7uo"
};
var $e676d41834cd8010$var$badgeValueWithNegativeNumberSupported = function badgeValueWithNegativeNumberSupported(children, max) {
    return typeof children === 'number' && typeof max === 'number' ? (0, $7cbc607cce3cf77d$export$4b844743568d5983)(children, max) : children;
};
/**
 * __Badge__
 *
 * This component gives you the full badge functionality and automatically formats the number you provide in \`children\`.
 *
 * - [Examples](https://atlassian.design/components/badge/examples)
 * - [Code](https://atlassian.design/components/badge/code)
 * - [Usage](https://atlassian.design/components/badge/usage)
 */ var $e676d41834cd8010$var$Badge = /*#__PURE__*/ (0, $5FkrB.memo)(function Badge(_ref) {
    var _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'default' : _ref$appearance, _ref$children = _ref.children, children = _ref$children === void 0 ? 0 : _ref$children, _ref$max = _ref.max, max = _ref$max === void 0 ? 99 : _ref$max, style = _ref.style, testId = _ref.testId;
    if ((0, $3217752dba69dd42$export$b40ec24ac8275656)('platform-dst-lozenge-tag-badge-visual-uplifts')) {
        // Map old appearance names to new ones
        var newAppearance = (0, $80644e2bed1866d1$export$d21bba0569254935)[appearance];
        return /*#__PURE__*/ $5FkrB.createElement((0, $0da488f75a4043f8$export$2e2bcd8739ae039), {
            appearance: newAppearance,
            max: max,
            style: style,
            testId: testId
        }, children);
    }
    var oldAppearance = (0, $784c0047ac8f9b6c$export$16f8cc7ac3541e83)[appearance];
    return /*#__PURE__*/ $5FkrB.createElement("span", {
        "data-testid": testId,
        style: {
            background: style === null || style === void 0 ? void 0 : style.backgroundColor,
            color: style === null || style === void 0 ? void 0 : style.color
        },
        className: (0, $2497340772c89e9b$export$2e2bcd8739ae039)([
            $e676d41834cd8010$var$styles.root,
            $e676d41834cd8010$var$styles[oldAppearance]
        ])
    }, /*#__PURE__*/ $5FkrB.createElement((0, $a1a00df3bd122236$export$2e2bcd8739ae039), {
        size: "small",
        align: "center",
        color: "inherit"
    }, $e676d41834cd8010$var$badgeValueWithNegativeNumberSupported(children, max)));
});
var $e676d41834cd8010$export$2e2bcd8739ae039 = $e676d41834cd8010$var$Badge;



var $jnGKX = parcelRequire("jnGKX");

const $04e2ab9a71aec03a$var$messages = (0, $aRMzY.defineMessages)({
    noProducts: {
        id: 'appUpdates.productList.noProducts',
        defaultMessage: 'No apps',
        description: 'Text displayed when no apps are associated with the update'
    },
    additionalProducts: {
        id: 'appUpdates.productList.additionalProducts',
        defaultMessage: '+{count}',
        description: 'Text for badge showing additional apps count'
    },
    additionalProductsAriaLabel: {
        id: 'appUpdates.productList.additionalProducts.ariaLabel',
        defaultMessage: 'Show {count} more products',
        description: 'Aria label for the additional products badge button'
    },
    additionalProductsTooltip: {
        id: 'appUpdates.productList.additionalProductsTooltip',
        defaultMessage: 'Additional apps',
        description: 'Tooltip title for additional apps'
    }
});
const $04e2ab9a71aec03a$var$styles = {
    container: (0, $c1bec583fa49072f$export$f6c783d06584602c)({
        display: 'flex',
        alignItems: 'center',
        gap: 'space.100'
    }),
    additionalProductsBadge: (0, $c1bec583fa49072f$export$f6c783d06584602c)({
        marginLeft: 'space.075'
    }),
    popupProduct: (0, $c1bec583fa49072f$export$f6c783d06584602c)({
        display: 'flex',
        alignItems: 'center',
        gap: 'space.075',
        padding: 'space.025'
    }),
    popupContainer: (0, $c1bec583fa49072f$export$f6c783d06584602c)({
        display: 'flex',
        flexDirection: 'column',
        gap: 'space.050',
        padding: 'space.100'
    }),
    popupTrigger: (0, $c1bec583fa49072f$export$f6c783d06584602c)({
        backgroundColor: 'color.background.neutral.subtle',
        padding: 'space.0'
    })
};
const $04e2ab9a71aec03a$export$831fdf77aa2a6a18 = ({ productTypes: productTypes })=>{
    const { formatMessage: formatMessage } = (0, $6Wx3K.default)();
    const [isPopupOpen, setIsPopupOpen] = (0, $5FkrB.useState)(false);
    const closeTimeoutRef = (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).useRef(null);
    if (!productTypes || productTypes.length === 0) return /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $d48daa9a522ca942$export$2e2bcd8739ae039), {
        color: "color.text.subtlest",
        size: "small",
        children: formatMessage($04e2ab9a71aec03a$var$messages.noProducts)
    });
    // Sort products by priority so key products (e.g. Jira) are shown first
    const sortedProductTypes = (0, $ace4c485fd808422$export$e3760658a711f2d3)(productTypes);
    if (sortedProductTypes.length === 1) return /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsxs)((0, $1b254ba6a068f2f1$export$2e2bcd8739ae039), {
        xcss: $04e2ab9a71aec03a$var$styles.container,
        testId: "product-list-single",
        children: [
            /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $7397f708924e0bda$export$1a199e029d5e93d6), {
                productType: sortedProductTypes[0],
                size: "small",
                testId: "product-list-icon"
            }),
            /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $d48daa9a522ca942$export$2e2bcd8739ae039), {
                weight: "medium",
                color: "color.text",
                children: (0, $d3185276e14a4c2b$export$44fea6589b7ddc92)(sortedProductTypes[0])
            })
        ]
    });
    // For multiple products, show first product with icon + count badge with popup
    const [firstProductType, ...remainingProductTypes] = sortedProductTypes;
    const openPopup = ()=>{
        if (closeTimeoutRef.current) clearTimeout(closeTimeoutRef.current);
        setIsPopupOpen(true);
    };
    const closePopup = ()=>{
        closeTimeoutRef.current = setTimeout(()=>setIsPopupOpen(false), 150);
    };
    const getPopupContent = ()=>/*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $383dd904a5a5e5b0$export$2e2bcd8739ae039), {
            xcss: $04e2ab9a71aec03a$var$styles.popupContainer,
            testId: "additional-products-popup",
            onMouseEnter: openPopup,
            onMouseLeave: closePopup,
            children: remainingProductTypes.map((productType, index)=>/*#__PURE__*/ (0, $faf30355a80342e4$exports.jsxs)((0, $383dd904a5a5e5b0$export$2e2bcd8739ae039), {
                    xcss: $04e2ab9a71aec03a$var$styles.popupProduct,
                    children: [
                        /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $7397f708924e0bda$export$1a199e029d5e93d6), {
                            productType: productType,
                            size: "small",
                            testId: `popup-product-icon-${index}`
                        }),
                        /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $d48daa9a522ca942$export$2e2bcd8739ae039), {
                            color: "color.text",
                            children: (0, $d3185276e14a4c2b$export$44fea6589b7ddc92)(productType)
                        })
                    ]
                }, `${productType}-${index}`))
        });
    return /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsxs)((0, $1b254ba6a068f2f1$export$2e2bcd8739ae039), {
        xcss: $04e2ab9a71aec03a$var$styles.container,
        testId: "product-list-multiple",
        children: [
            /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $7397f708924e0bda$export$1a199e029d5e93d6), {
                productType: firstProductType,
                size: "small",
                testId: "product-list-primary-icon"
            }),
            /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $d48daa9a522ca942$export$2e2bcd8739ae039), {
                weight: "medium",
                color: "color.text",
                children: (0, $d3185276e14a4c2b$export$44fea6589b7ddc92)(firstProductType)
            }),
            /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $383dd904a5a5e5b0$export$2e2bcd8739ae039), {
                xcss: $04e2ab9a71aec03a$var$styles.additionalProductsBadge,
                children: /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $jnGKX.default), {
                    isOpen: isPopupOpen,
                    onClose: closePopup,
                    placement: "bottom-start",
                    content: getPopupContent,
                    testId: "additional-products-popup-trigger",
                    trigger: (triggerProps)=>/*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $d4a7825669dd53f6$export$2e2bcd8739ae039), {
                            ...triggerProps,
                            onMouseEnter: openPopup,
                            onMouseLeave: closePopup,
                            testId: "additional-products-badge-wrapper",
                            xcss: $04e2ab9a71aec03a$var$styles.popupTrigger,
                            "aria-label": formatMessage($04e2ab9a71aec03a$var$messages.additionalProductsAriaLabel, {
                                count: remainingProductTypes.length
                            }),
                            children: /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $e676d41834cd8010$export$2e2bcd8739ae039), {
                                appearance: "default",
                                testId: "additional-products-badge",
                                children: formatMessage($04e2ab9a71aec03a$var$messages.additionalProducts, {
                                    count: remainingProductTypes.length
                                })
                            })
                        })
                })
            })
        ]
    });
};




var $5FkrB = parcelRequire("5FkrB");

var $iBNQo = parcelRequire("iBNQo");
/* lozenge.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $5FkrB = parcelRequire("5FkrB");

var $jHdWv = parcelRequire("jHdWv");

var $ISKn7 = parcelRequire("ISKn7");
var $7c1f69cf3af6999d$var$_process, $7c1f69cf3af6999d$var$_process2;
// We can't rely on NODE_ENV === 'test' if its value is already configured by the consumer to some other value, so better to use JEST_WORKER_ID
// https://jestjs.io/docs/environment-variables#jest_worker_id
var $7c1f69cf3af6999d$var$TESTS_MODE = (globalThis === null || globalThis === void 0 || ($7c1f69cf3af6999d$var$_process = globalThis.process) === null || $7c1f69cf3af6999d$var$_process === void 0 || ($7c1f69cf3af6999d$var$_process = $7c1f69cf3af6999d$var$_process.env) === null || $7c1f69cf3af6999d$var$_process === void 0 ? void 0 : $7c1f69cf3af6999d$var$_process.JEST_WORKER_ID) !== undefined;
var $7c1f69cf3af6999d$var$DEBUG_MODE = !$7c1f69cf3af6999d$var$TESTS_MODE && (globalThis === null || globalThis === void 0 || ($7c1f69cf3af6999d$var$_process2 = globalThis.process) === null || $7c1f69cf3af6999d$var$_process2 === void 0 || ($7c1f69cf3af6999d$var$_process2 = $7c1f69cf3af6999d$var$_process2.env) === null || $7c1f69cf3af6999d$var$_process2 === void 0 ? void 0 : $7c1f69cf3af6999d$var$_process2.NODE_ENV) !== 'production';
var $7c1f69cf3af6999d$export$1c9f709888824e05 = function debug() {
    var _console;
    if (!$7c1f69cf3af6999d$var$DEBUG_MODE) return;
    // eslint-disable-next-line no-console
    (_console = console).debug.apply(_console, arguments);
};



var $3ZMUU = parcelRequire("3ZMUU");
var $83443e5b8d6ab917$var$pkgName = '@atlaskit/platform-feature-flags';
var $83443e5b8d6ab917$export$7e41b1b2bdee3f98 = '__PLATFORM_FEATURE_FLAGS__';
var $83443e5b8d6ab917$var$hasProcessEnv = typeof $3ZMUU !== 'undefined' && typeof $3ZMUU.env !== 'undefined';
// FF global overrides can be configured by test runners or Storybook
var $83443e5b8d6ab917$var$ENV_ENABLE_PLATFORM_FF = $83443e5b8d6ab917$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
// STORYBOOK_ENABLE_PLATFORM_FF is included as storybook only allows env vars prefixed with STORYBOOK
// https://github.com/storybookjs/storybook/issues/12270
var $83443e5b8d6ab917$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF = $83443e5b8d6ab917$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
var $83443e5b8d6ab917$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE = $83443e5b8d6ab917$var$ENV_ENABLE_PLATFORM_FF || $83443e5b8d6ab917$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF;
var $83443e5b8d6ab917$var$DEFAULT_PFF_GLOBAL = {
    booleanResolver: undefined
};
var $83443e5b8d6ab917$var$globalVar = typeof window !== 'undefined' ? window : globalThis;
$83443e5b8d6ab917$var$globalVar[$83443e5b8d6ab917$export$7e41b1b2bdee3f98] = $83443e5b8d6ab917$var$globalVar[$83443e5b8d6ab917$export$7e41b1b2bdee3f98] || $83443e5b8d6ab917$var$DEFAULT_PFF_GLOBAL;
function $83443e5b8d6ab917$export$f2b591175b3e424c(resolver) {
    $83443e5b8d6ab917$var$globalVar[$83443e5b8d6ab917$export$7e41b1b2bdee3f98].booleanResolver = resolver;
}
function $83443e5b8d6ab917$export$6333b6aff9fc6275(flagKey) {
    if ($83443e5b8d6ab917$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE) {
        (0, $7c1f69cf3af6999d$export$1c9f709888824e05)('[%s]: The feature flags were enabled while running tests. The flag "%s" will be always enabled.', $83443e5b8d6ab917$var$pkgName, flagKey);
        return true;
    }
    try {
        var _globalVar$PFF_GLOBAL, _globalVar$PFF_GLOBAL2, _globalVar$PFF_GLOBAL3;
        // booleanResolver will be empty for products like Trello, Elevate, Recruit etc.
        // Currently only Confluence, Jira and Bitbucket has set it.
        if (((_globalVar$PFF_GLOBAL = $83443e5b8d6ab917$var$globalVar[$83443e5b8d6ab917$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL === void 0 ? void 0 : _globalVar$PFF_GLOBAL.booleanResolver) === undefined || ((_globalVar$PFF_GLOBAL2 = $83443e5b8d6ab917$var$globalVar[$83443e5b8d6ab917$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL2 === void 0 ? void 0 : _globalVar$PFF_GLOBAL2.booleanResolver) === null) // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
        return (0, $ISKn7.default).checkGate(flagKey);
        var result = (_globalVar$PFF_GLOBAL3 = $83443e5b8d6ab917$var$globalVar[$83443e5b8d6ab917$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL3 === void 0 ? void 0 : _globalVar$PFF_GLOBAL3.booleanResolver(flagKey);
        if (typeof result !== 'boolean') {
            // eslint-disable-next-line no-console
            console.warn("".concat(flagKey, " resolved to a non-boolean value, returning false for safety"));
            return false;
        }
        return result;
    } catch (e) {
        return false;
    }
}


function $4b6756957153ffff$export$ba05d765b8392e5e(flagResolver) {
    (0, $83443e5b8d6ab917$export$f2b591175b3e424c)(flagResolver);
}
function $4b6756957153ffff$export$470e5c2be1411c89(name) {
    return (0, $83443e5b8d6ab917$export$6333b6aff9fc6275)(name);
}
function $4b6756957153ffff$export$b40ec24ac8275656(name) {
    return (0, $83443e5b8d6ab917$export$6333b6aff9fc6275)(name);
}


/* lozenge.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $5FkrB = parcelRequire("5FkrB");

/* lozenge-base.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $25nEq = parcelRequire("25nEq");

var $kqp0i = parcelRequire("kqp0i");

var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");

var $jHdWv = parcelRequire("jHdWv");
/* badge-new.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $5FkrB = parcelRequire("5FkrB");

var $jHdWv = parcelRequire("jHdWv");
/* text.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $5FkrB = parcelRequire("5FkrB");

var $jHdWv = parcelRequire("jHdWv");

var $afMOk = parcelRequire("afMOk");

var $5FkrB = parcelRequire("5FkrB");
var $8d1b6202a829cb2d$var$HasTextAncestorContext = /*#__PURE__*/ (0, $5FkrB.createContext)(false);
var $8d1b6202a829cb2d$export$9322276ec105d055 = function useHasTextAncestor() {
    return (0, $5FkrB.useContext)($8d1b6202a829cb2d$var$HasTextAncestorContext);
};
var $8d1b6202a829cb2d$export$ae933c6cbe5643ad = $8d1b6202a829cb2d$var$HasTextAncestorContext.Provider;



var $5FkrB = parcelRequire("5FkrB");

var $5FkrB = parcelRequire("5FkrB");
var $0b4bfd673c69705a$export$1ca2a26fecb070ae = /*#__PURE__*/ (0, $5FkrB.createContext)('elevation.surface');


var $6c5afbca57c79dc8$export$1aeb4f6b93c4540d = function useSurface() {
    return (0, $5FkrB.useContext)((0, $0b4bfd673c69705a$export$1ca2a26fecb070ae));
};
(0, $0b4bfd673c69705a$export$1ca2a26fecb070ae).displayName = 'SurfaceProvider';


var $f4179d4e8cce6704$var$asAllowlist = [
    'span',
    'p',
    'strong',
    'em'
];
/**
 * Custom hook designed to abstract the parsing of the color props and make it clearer in the future how color is reconciled between themes and tokens.
 */ var $f4179d4e8cce6704$var$useColor = function useColor(colorProp, hasTextAncestor) {
    var surface = (0, $6c5afbca57c79dc8$export$1aeb4f6b93c4540d)();
    if (colorProp === 'inherit') return undefined;
    if (colorProp) return colorProp;
    if (hasTextAncestor) return undefined;
    if ($f4179d4e8cce6704$export$2185ce37f9bdd963.hasOwnProperty(surface)) return $f4179d4e8cce6704$export$2185ce37f9bdd963[surface];
    return 'color.text';
};
var $f4179d4e8cce6704$var$styles = {
    root: "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _1i4qfg65",
    'as.strong': "_k48pwu06",
    'as.em': "_zg8l1m30",
    'textAlign.center': "_y3gn1h6o",
    'textAlign.end': "_y3gnh9n0",
    'textAlign.start': "_y3gnv2br",
    truncation: "_1reo15vq _18m915vq _1e0ccj1k _sudp1e54",
    breakAll: "_1nmz9jpi"
};
var $f4179d4e8cce6704$var$fontSizeMap = {
    medium: "_11c8fhey",
    large: "_11c81d4k",
    small: "_11c8wadc"
};
var $f4179d4e8cce6704$var$fontWeightMap = {
    bold: "_k48pwu06",
    medium: "_k48p1wq8",
    regular: "_k48pi7a9",
    semibold: "_k48p1pd9"
};
var $f4179d4e8cce6704$var$textColorMap = {
    'color.text': "_syazi7uo",
    'color.text.accent.lime': "_syaz1tco",
    'color.text.accent.lime.bolder': "_syaz1ik3",
    'color.text.accent.red': "_syaz9lu1",
    'color.text.accent.red.bolder': "_syazhwvp",
    'color.text.accent.orange': "_syazp1lv",
    'color.text.accent.orange.bolder': "_syaz7i1p",
    'color.text.accent.yellow': "_syazfb2s",
    'color.text.accent.yellow.bolder': "_syazekll",
    'color.text.accent.green': "_syazh55r",
    'color.text.accent.green.bolder': "_syaz1y78",
    'color.text.accent.teal': "_syaz17qg",
    'color.text.accent.teal.bolder': "_syaz12v7",
    'color.text.accent.blue': "_syaz16jw",
    'color.text.accent.blue.bolder': "_syaz1kyx",
    'color.text.accent.purple': "_syazqmo9",
    'color.text.accent.purple.bolder': "_syaz1mn1",
    'color.text.accent.magenta': "_syaz1s8m",
    'color.text.accent.magenta.bolder': "_syaz1qur",
    'color.text.accent.gray': "_syaz1sqi",
    'color.text.accent.gray.bolder': "_syaz1tmo",
    'color.text.disabled': "_syaz1gmx",
    'color.text.inverse': "_syaz15cr",
    'color.text.selected': "_syaz6x5g",
    'color.text.brand': "_syaz1oa5",
    'color.text.danger': "_syaz1tmw",
    'color.text.warning': "_syaz1xn9",
    'color.text.warning.inverse': "_syaz1yd3",
    'color.text.success': "_syazgsak",
    'color.text.discovery': "_syazdv2p",
    'color.text.information': "_syazu3tg",
    'color.text.subtlest': "_syaz1rpy",
    'color.text.subtle': "_syazazsu",
    'color.link': "_syaz13af",
    'color.link.pressed': "_syaz12zz",
    'color.link.visited': "_syaz1ra0",
    'color.link.visited.pressed': "_syaz17z1"
};
var $f4179d4e8cce6704$export$2185ce37f9bdd963 = {
    'color.background.neutral.bold': 'color.text.inverse',
    'color.background.neutral.bold.hovered': 'color.text.inverse',
    'color.background.neutral.bold.pressed': 'color.text.inverse',
    'color.background.selected.bold': 'color.text.inverse',
    'color.background.selected.bold.hovered': 'color.text.inverse',
    'color.background.selected.bold.pressed': 'color.text.inverse',
    'color.background.brand.bold': 'color.text.inverse',
    'color.background.brand.bold.hovered': 'color.text.inverse',
    'color.background.brand.bold.pressed': 'color.text.inverse',
    'color.background.brand.boldest': 'color.text.inverse',
    'color.background.brand.boldest.hovered': 'color.text.inverse',
    'color.background.brand.boldest.pressed': 'color.text.inverse',
    'color.background.danger.bold': 'color.text.inverse',
    'color.background.danger.bold.hovered': 'color.text.inverse',
    'color.background.danger.bold.pressed': 'color.text.inverse',
    'color.background.warning.bold': 'color.text.warning.inverse',
    'color.background.warning.bold.hovered': 'color.text.warning.inverse',
    'color.background.warning.bold.pressed': 'color.text.warning.inverse',
    'color.background.success.bold': 'color.text.inverse',
    'color.background.success.bold.hovered': 'color.text.inverse',
    'color.background.success.bold.pressed': 'color.text.inverse',
    'color.background.discovery.bold': 'color.text.inverse',
    'color.background.discovery.bold.hovered': 'color.text.inverse',
    'color.background.discovery.bold.pressed': 'color.text.inverse',
    'color.background.information.bold': 'color.text.inverse',
    'color.background.information.bold.hovered': 'color.text.inverse',
    'color.background.information.bold.pressed': 'color.text.inverse'
};
/**
 * __Text__
 *
 * Text is a primitive component that has the Atlassian Design System's design guidelines baked in.
 * This includes considerations for text attributes such as color, font size, font weight, and line height.
 * It renders a `span` by default.
 *
 * @internal
 */ var $f4179d4e8cce6704$var$Text = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? 'span' : _ref$as, colorProp = _ref.color, align = _ref.align, testId = _ref.testId, id = _ref.id, size = _ref.size, weight = _ref.weight, maxLines = _ref.maxLines, xcss = _ref.xcss, children = _ref.children;
    (0, $afMOk.default)($f4179d4e8cce6704$var$asAllowlist.includes(Component), "@atlaskit/primitives: Text received an invalid \"as\" value of \"".concat(Component, "\""));
    var hasTextAncestor = (0, $8d1b6202a829cb2d$export$9322276ec105d055)();
    var color = $f4179d4e8cce6704$var$useColor(colorProp, hasTextAncestor);
    if (!size && !hasTextAncestor) size = 'medium';
    var component = /*#__PURE__*/ $5FkrB.createElement(Component, {
        id: id,
        className: (0, $jHdWv.default)([
            $f4179d4e8cce6704$var$styles.root,
            size && $f4179d4e8cce6704$var$fontSizeMap[size],
            color && $f4179d4e8cce6704$var$textColorMap[color],
            maxLines && $f4179d4e8cce6704$var$styles.truncation,
            maxLines === 1 && $f4179d4e8cce6704$var$styles.breakAll,
            align && $f4179d4e8cce6704$var$styles["textAlign.".concat(align)],
            weight && $f4179d4e8cce6704$var$fontWeightMap[weight],
            Component === 'em' && $f4179d4e8cce6704$var$styles['as.em'],
            Component === 'strong' && $f4179d4e8cce6704$var$styles['as.strong'],
            xcss
        ]),
        style: {
            WebkitLineClamp: maxLines
        },
        "data-testid": testId,
        ref: ref
    }, children);
    if (hasTextAncestor) // no need to re-apply context if the text is already wrapped
    return component;
    return /*#__PURE__*/ $5FkrB.createElement((0, $8d1b6202a829cb2d$export$ae933c6cbe5643ad), {
        value: true
    }, component);
});
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$f4179d4e8cce6704$export$2e2bcd8739ae039 = $f4179d4e8cce6704$var$Text;



var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");

var $25nEq = parcelRequire("25nEq");
var $4fbdb2750b216b85$export$4ef52930e33717cd = 'data-theme';
var $4fbdb2750b216b85$export$cb374d25ded7f6ab = 'data-subtree-theme';
var $4fbdb2750b216b85$export$a00eac3f8684bcd0 = 'data-color-mode';
var $4fbdb2750b216b85$export$2112803007239c61 = 'data-contrast-mode';
var $4fbdb2750b216b85$export$352e418ed5b6193a = 'data-custom-theme';
var $4fbdb2750b216b85$export$6f0c6fb8c80fcc92 = 'ds';
var $4fbdb2750b216b85$export$4d0c7bbf80185957 = [
    'opacity',
    'font',
    'space',
    'border',
    'radius'
];
var $4fbdb2750b216b85$export$dddac1532e822863 = "--".concat($4fbdb2750b216b85$export$6f0c6fb8c80fcc92, "-token-not-found");
var $4fbdb2750b216b85$export$9d7b58831ae93caa = "--".concat($4fbdb2750b216b85$export$6f0c6fb8c80fcc92, "-elevation-surface-current");


/**
 * Theme modes: The general purpose of a theme.
 * This attr is used to apply the appropriate system-preference option
 * It may also be used as a selector for mode-specific overrides such as light/dark images.
 * The idea is there may exist many color themes, but every theme must either fit into light or dark.
 */ var $936365fac2478b19$export$83993de8eb66733 = [
    'light',
    'dark',
    'auto'
];



var $iYJcE = parcelRequire("iYJcE");
var $08b58224ffd23a38$export$4a14e169b1de4ee7 = function isColorMode(modeId) {
    return [
        'light',
        'dark',
        'auto'
    ].includes(modeId);
};


/**
 * Theme ids: The value that will be mounted to the DOM as a data attr
 * For example: `data-theme="light:light dark:dark spacing:spacing"
 *
 * These ids must be kebab case
 */ var $1cd17b8b7a7b4cfa$export$7d43e72a58e3283f = [
    'light-increased-contrast',
    'light',
    'light-future',
    'dark',
    'dark-future',
    'dark-increased-contrast',
    'spacing',
    'shape',
    'typography',
    'motion'
];


var $7598c8ec37dfe9b3$export$ea35b8958c39dd07 = function isThemeIds(themeId) {
    return (0, $1cd17b8b7a7b4cfa$export$7d43e72a58e3283f).find(function(id) {
        return id === themeId;
    }) !== undefined;
};


var $65101b4024abfbdd$var$themeKinds = [
    'light',
    'dark',
    'spacing',
    'typography',
    'shape',
    'motion'
];
var $65101b4024abfbdd$export$958fa026be3a263e = function isThemeKind(themeKind) {
    return $65101b4024abfbdd$var$themeKinds.find(function(kind) {
        return kind === themeKind;
    }) !== undefined;
};


var $87f583e76f925b9d$var$customThemeOptions = 'UNSAFE_themeOptions';
var $87f583e76f925b9d$export$f19b488f7c0547ee = function themeStringToObject(themeState) {
    return themeState.split(' ')// @ts-ignore - TS1501 TypeScript 5.9.2 upgrade
    .map(function(theme) {
        return theme.split(/:([^]*)/);
    }).reduce(function(themeObject, _ref) {
        var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_ref, 2), kind = _ref2[0], id = _ref2[1];
        if (kind === 'colorMode' && (0, $08b58224ffd23a38$export$4a14e169b1de4ee7)(id)) themeObject[kind] = id;
        if ((0, $65101b4024abfbdd$export$958fa026be3a263e)(kind) && (0, $7598c8ec37dfe9b3$export$ea35b8958c39dd07)(id)) // @ts-expect-error FIXME - this is a valid ts error
        themeObject[kind] = id;
        if (kind === $87f583e76f925b9d$var$customThemeOptions) try {
            themeObject[$87f583e76f925b9d$var$customThemeOptions] = JSON.parse(id);
        } catch (_unused) {
            new Error('Invalid custom theme string');
        }
        return themeObject;
    }, {});
};


function $8314529cf304031f$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $8314529cf304031f$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $8314529cf304031f$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $8314529cf304031f$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $8314529cf304031f$var$isThemeColorMode = function isThemeColorMode(colorMode) {
    return (0, $936365fac2478b19$export$83993de8eb66733).find(function(mode) {
        return mode === colorMode;
    }) !== undefined;
};
var $8314529cf304031f$var$getGlobalTheme = function getGlobalTheme() {
    if (typeof document === 'undefined') return {};
    var element = document.documentElement;
    var colorMode = element.getAttribute((0, $4fbdb2750b216b85$export$a00eac3f8684bcd0)) || '';
    var theme = element.getAttribute((0, $4fbdb2750b216b85$export$4ef52930e33717cd)) || '';
    return $8314529cf304031f$var$_objectSpread($8314529cf304031f$var$_objectSpread({}, (0, $87f583e76f925b9d$export$f19b488f7c0547ee)(theme)), $8314529cf304031f$var$isThemeColorMode(colorMode) && {
        colorMode: colorMode
    });
};
var $8314529cf304031f$export$2e2bcd8739ae039 = $8314529cf304031f$var$getGlobalTheme;



var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $25nEq = parcelRequire("25nEq");


/**
 * A MutationObserver which watches the `<html>` element for changes to the theme.
 *
 * In React, use the {@link useThemeObserver `useThemeObserver`} hook instead.
 *
 * @param {function} callback - A callback function which fires when the theme changes.
 *
 * @example
 * ```
 * const observer = new ThemeMutationObserver((theme) => {});
 * observer.observe();
 * ```
 */ var $c5cf1cbfa4ed7c24$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function ThemeMutationObserver(callback) {
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, ThemeMutationObserver);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "legacyObserver", null);
        this.callback = callback;
        ThemeMutationObserver.callbacks.add(callback);
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(ThemeMutationObserver, [
        {
            key: "observe",
            value: function observe() {
                if (!ThemeMutationObserver.observer) {
                    ThemeMutationObserver.observer = new MutationObserver(function() {
                        var theme = (0, $8314529cf304031f$export$2e2bcd8739ae039)();
                        ThemeMutationObserver.callbacks.forEach(function(callback) {
                            return callback(theme);
                        });
                    });
                    // Observer only needs to be configured once
                    ThemeMutationObserver.observer.observe(document.documentElement, {
                        attributeFilter: [
                            (0, $4fbdb2750b216b85$export$4ef52930e33717cd),
                            (0, $4fbdb2750b216b85$export$a00eac3f8684bcd0)
                        ]
                    });
                }
            }
        },
        {
            key: "disconnect",
            value: function disconnect() {
                if (this.callback) ThemeMutationObserver.callbacks.delete(this.callback);
                if (ThemeMutationObserver.callbacks.size === 0 && ThemeMutationObserver.observer) {
                    ThemeMutationObserver.observer.disconnect();
                    ThemeMutationObserver.observer = null;
                }
            }
        }
    ]);
}();
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($c5cf1cbfa4ed7c24$export$2e2bcd8739ae039, "observer", null);
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($c5cf1cbfa4ed7c24$export$2e2bcd8739ae039, "callbacks", new Set());


/**
 * A React hook which returns the current themes and color-mode set on `<html>`.
 *
 * @example
 * ```
 * const { colorMode, dark, light, spacing, typography } = useThemeObserver();
 *
 * // Performing side effects when it changes
 * useEffect(() => {
 *   console.log(`The color mode has changed to ${theme.colorMode}`);
 * }, [theme.colorMode]);
 * ```
 */ var $9b2b5dc09788ff31$var$useThemeObserver = function useThemeObserver() {
    var _useState = (0, $5FkrB.useState)((0, $8314529cf304031f$export$2e2bcd8739ae039)()), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), theme = _useState2[0], setTheme = _useState2[1];
    (0, $5FkrB.useEffect)(function() {
        var observer = new (0, $c5cf1cbfa4ed7c24$export$2e2bcd8739ae039)(function(theme) {
            return setTheme(theme);
        });
        observer.observe();
        return function() {
            return observer.disconnect();
        };
    }, []);
    return theme;
};
var $9b2b5dc09788ff31$export$2e2bcd8739ae039 = $9b2b5dc09788ff31$var$useThemeObserver;


function $e04e32d61a3610ab$var$getSafeValue() {
    var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    var numericValue = +value;
    if (numericValue < 0) return 0;
    return value;
}
function $e04e32d61a3610ab$export$7c4d25c0c3217d8c(value, max) {
    var safeValue = $e04e32d61a3610ab$var$getSafeValue(value);
    var safeMax = $e04e32d61a3610ab$var$getSafeValue(max);
    if (safeMax && safeMax < safeValue) return "".concat(safeMax, "+");
    if (safeValue === Infinity) return "\u221E";
    return safeValue.toString();
}


/* eslint-disable @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors */ // Nested selectors with data attributes are required for theme switching
var $a2883d8d0008ed61$var$stylesNew = {
    root: "_2rkolb4i _18zr1b66 _1rjcidpf _1e0c116y _vchhusvi _1ul91ejb _1bah1h6o _1o9zidpf _1kz6184x",
    success: "_syaz1p1e _bfhk14j0",
    danger: "_syaz1blx _bfhk18wg",
    warning: "_syazmgs1 _bfhk10f4",
    information: "_syaz1qd9 _bfhk8lbg",
    discovery: "_syaz1g72 _bfhke670",
    neutral: "_syazi7uo _bfhk7qp0",
    inverse: "_bfhkvuon _syazi7uo",
    informationBold: "_syaz1qd9 _bfhk9pm7",
    successBold: "_syaz1p1e _bfhk16ib",
    dangerBold: "_syaz1blx _bfhkud63",
    warningBold: "_syazmgs1 _bfhk1kmu",
    warningBoldDark: "_syazmgs1 _bfhkgj02",
    discoveryBold: "_syaz1g72 _bfhk5ly7"
};
/* eslint-enable @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors */ var $a2883d8d0008ed61$var$badgeValueWithNegativeNumberSupported = function badgeValueWithNegativeNumberSupported(children, max) {
    return typeof children === 'number' && max ? (0, $e04e32d61a3610ab$export$7c4d25c0c3217d8c)(children, max) : children;
};
/**
 * __BadgeNew__
 *
 * New visual refresh implementation of Badge component for the labelling system.
 * This component is used when the 'platform-dst-lozenge-tag-badge-visual-uplifts' feature flag is enabled.
 *
 * Uses new appearance naming convention:
 * - success (green)
 * - danger (red)
 * - neutral (gray)
 * - information (blue)
 * - inverse (inverted colors)
 * - warning (orange/yellow)
 * - discovery (purple)
 * - informationBold (bold blue, color.background.information.subtle)
 * - successBold (bold green, color.background.success.subtle)
 * - dangerBold (bold red, color.background.danger.subtle)
 * - warningBold (bold warning, color.background.warning.bold)
 * - discoveryBold (bold purple, color.background.discovery.subtle)
 */ var $a2883d8d0008ed61$var$BadgeNew = /*#__PURE__*/ (0, $5FkrB.memo)(function BadgeNew(_ref) {
    var _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'neutral' : _ref$appearance, _ref$children = _ref.children, children = _ref$children === void 0 ? 0 : _ref$children, _ref$max = _ref.max, max = _ref$max === void 0 ? 99 : _ref$max, style = _ref.style, testId = _ref.testId;
    var _useThemeObserver = (0, $9b2b5dc09788ff31$export$2e2bcd8739ae039)(), colorMode = _useThemeObserver.colorMode;
    // In dark theme, warningBold needs to swap to a lighter background
    // (color.background.warning.subtle / Orange800) for better contrast against
    // the typical dark surface colors.
    var resolvedAppearance = appearance === 'warningBold' && colorMode === 'dark' ? 'warningBoldDark' : appearance;
    return /*#__PURE__*/ $5FkrB.createElement("span", {
        "data-testid": testId,
        style: {
            background: style === null || style === void 0 ? void 0 : style.backgroundColor,
            color: style === null || style === void 0 ? void 0 : style.color
        },
        className: (0, $jHdWv.default)([
            $a2883d8d0008ed61$var$stylesNew.root,
            $a2883d8d0008ed61$var$stylesNew[resolvedAppearance]
        ])
    }, /*#__PURE__*/ $5FkrB.createElement((0, $f4179d4e8cce6704$export$2e2bcd8739ae039), {
        size: "small",
        align: "center",
        color: "inherit"
    }, $a2883d8d0008ed61$var$badgeValueWithNegativeNumberSupported(children, max)));
});
var $a2883d8d0008ed61$export$2e2bcd8739ae039 = $a2883d8d0008ed61$var$BadgeNew;



var $hRJ5R = parcelRequire("hRJ5R");
var $e40a736c4c08093d$exports = {};
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d56e8662eb8a8d2462ec3a39ff3aa40b>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty($e40a736c4c08093d$exports, "__esModule", {
    value: true
});
$e40a736c4c08093d$exports.default = void 0;

var $e40a736c4c08093d$var$_react = $e40a736c4c08093d$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $e40a736c4c08093d$var$_baseNew = $e40a736c4c08093d$var$_interopRequireDefault((parcelRequire("4kNYI")));
function $e40a736c4c08093d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ChevronDown".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Do not use 16px chevrons within buttons, icon buttons, or dropdowns to maintain visual cohesion with ADS which uses 12px chevrons.
Known uses: Open dropdown menu, expanded tree item, collapse tree item
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $e40a736c4c08093d$var$ChevronDownIcon = (props)=>/*#__PURE__*/ $e40a736c4c08093d$var$_react.default.createElement($e40a736c4c08093d$var$_baseNew.default, Object.assign({
        name: "ChevronDownIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="m14.53 6.03-6 6a.75.75 0 0 1-1.004.052l-.056-.052-6-6 1.06-1.06L8 10.44l5.47-5.47z"/>`
    }, props));
$e40a736c4c08093d$var$ChevronDownIcon.displayName = 'ChevronDownIcon';
var $e40a736c4c08093d$var$_default = $e40a736c4c08093d$exports.default = $e40a736c4c08093d$var$ChevronDownIcon;



var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");
var $a581e2f4a28585ba$export$c5406bd59b374abd = function isMatchMediaAvailable() {
    return typeof window !== 'undefined' && 'matchMedia' in window;
};


var $b0232a2fa99764c0$export$b7baf7667a68d87c = function isReducedMotion() {
    if (!(0, $a581e2f4a28585ba$export$c5406bd59b374abd)()) return false;
    var _window$matchMedia = window.matchMedia('(prefers-reduced-motion: reduce)'), matches = _window$matchMedia.matches;
    return matches;
};



var $5FkrB = parcelRequire("5FkrB");
var $7c0664f362997749$export$ff879f35a69d56b7 = function useElementRef() {
    var elementRef = (0, $5FkrB.useRef)(null);
    var setRef = (0, $5FkrB.useCallback)(function(ref) {
        elementRef.current = ref;
    }, []);
    return [
        elementRef.current,
        setRef
    ];
};



var $5FkrB = parcelRequire("5FkrB");
var $15d1e42bef2ce5ed$export$e5c5a5f917a5871c = typeof window === 'undefined' ? (0, $5FkrB.useEffect) : (0, $5FkrB.useLayoutEffect);



var $5FkrB = parcelRequire("5FkrB");
var $a74f4fce46837c50$var$getHookDeps = function getHookDeps(opts) {
    switch(opts.cleanup){
        case 'next-effect':
            return undefined;
        case 'unmount':
        default:
            return [];
    }
};
var $a74f4fce46837c50$export$1775f27e7c8051ca = function useRequestAnimationFrame() {
    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        cleanup: 'unmount'
    };
    var frames = (0, $5FkrB.useRef)([]);
    (0, $5FkrB.useEffect)(function() {
        return function() {
            if (frames.current.length) {
                frames.current.forEach(function(id) {
                    return cancelAnimationFrame(id);
                });
                frames.current = [];
            }
        };
    // We dynamically set this so we either clean up on the next effect - or on unmount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, $a74f4fce46837c50$var$getHookDeps(opts));
    return (0, $5FkrB.useCallback)(function(handler) {
        var id = requestAnimationFrame(function(time) {
            frames.current = frames.current.filter(function(frameId) {
                return frameId !== id;
            });
            handler(time);
        });
        frames.current.push(id);
    }, []);
};



var $5FkrB = parcelRequire("5FkrB");
// Handle both browser and Node.js environments
var $2ebdb7c7469c8bf6$var$getHookDeps = function getHookDeps(opts) {
    switch(opts.cleanup){
        case 'next-effect':
            return undefined;
        case 'unmount':
        default:
            return [];
    }
};
var $2ebdb7c7469c8bf6$export$4f34107a2b00f39c = function useSetTimeout() {
    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        cleanup: 'unmount'
    };
    var timeouts = (0, $5FkrB.useRef)([]);
    (0, $5FkrB.useEffect)(function() {
        return function() {
            if (timeouts.current.length) {
                timeouts.current.forEach(function(id) {
                    return clearTimeout(id);
                });
                timeouts.current = [];
            }
        };
    // We dynamically set this so we either clean up on the next effect - or on unmount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, $2ebdb7c7469c8bf6$var$getHookDeps(opts));
    return (0, $5FkrB.useCallback)(function(handler, timeout) {
        for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)args[_key - 2] = arguments[_key];
        var id = setTimeout.apply(void 0, [
            function() {
                timeouts.current = timeouts.current.filter(function(timeoutId) {
                    return timeoutId !== id;
                });
                handler();
            },
            timeout
        ].concat(args));
        timeouts.current.push(id);
    }, []);
};



var $5FkrB = parcelRequire("5FkrB");

var $7412c991512a8f43$export$9e95200239cd148b = function useSnapshotBeforeUpdate(cb) {
    var isFirstRender = (0, $5FkrB.useRef)(true);
    if (!isFirstRender.current) cb();
    (0, $15d1e42bef2ce5ed$export$e5c5a5f917a5871c)(function() {
        isFirstRender.current = false;
    }, []);
};


/**
 * Which dimension(s) of the element to animate.
 *
 * - `'width'` animates only width changes.
 * - `'height'` animates only height changes.
 * - `'both'` animates width and height changes simultaneously.
 */ /**
 * Parses a CSS time value (e.g. `"0.2s"` or `"200ms"`) and returns milliseconds.
 * Falls back to 0 if the value cannot be parsed.
 */ function $744d9af81f1a5245$var$parseCSSTimeToMs(value) {
    var parsed = parseFloat(value);
    if (Number.isNaN(parsed)) return 0;
    if (value.endsWith('ms')) return parsed;
    return parsed * 1000;
}
/**
 * Returns `true` if any of the dimension(s) being animated have changed
 * between the previous and next measurements.
 */ function $744d9af81f1a5245$var$hasDimensionChanged(dimension, prev, next) {
    if (dimension === 'width') return prev.width !== next.width;
    if (dimension === 'height') return prev.height !== next.height;
    return prev.width !== next.width || prev.height !== next.height;
}
/**
 * Returns the CSS `transition-property` / `will-change` value for the
 * given dimension(s).
 */ function $744d9af81f1a5245$var$getDimensionPropertyList(dimension) {
    if (dimension === 'both') return 'width, height';
    return dimension;
}
var $744d9af81f1a5245$export$a300664a1a230956 = function useResizing(_ref) {
    var dimension = _ref.dimension, duration = _ref.duration, easing = _ref.easing, onFinishMotion = _ref.onFinishMotion;
    var prevDimensions = (0, $5FkrB.useRef)();
    var _useElementRef = (0, $7c0664f362997749$export$ff879f35a69d56b7)(), _useElementRef2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useElementRef, 2), element = _useElementRef2[0], setElementRef = _useElementRef2[1];
    var setTimeout = (0, $2ebdb7c7469c8bf6$export$4f34107a2b00f39c)({
        cleanup: 'next-effect'
    });
    var requestAnimationFrame = (0, $a74f4fce46837c50$export$1775f27e7c8051ca)();
    (0, $7412c991512a8f43$export$9e95200239cd148b)(function() {
        if ((0, $b0232a2fa99764c0$export$b7baf7667a68d87c)() || !element) return;
        var rect = element.getBoundingClientRect();
        prevDimensions.current = {
            width: rect.width,
            height: rect.height
        };
    });
    (0, $15d1e42bef2ce5ed$export$e5c5a5f917a5871c)(function() {
        if ((0, $b0232a2fa99764c0$export$b7baf7667a68d87c)() || !element || !prevDimensions.current) return;
        // We might already be animating.
        // Because of that we need to expand to the destination dimensions first.
        element.setAttribute('style', '');
        var rect = element.getBoundingClientRect();
        var nextDimensions = {
            width: rect.width,
            height: rect.height
        };
        if (!$744d9af81f1a5245$var$hasDimensionChanged(dimension, prevDimensions.current, nextDimensions)) {
            onFinishMotion === null || onFinishMotion === void 0 || onFinishMotion();
            return;
        }
        var propertyList = $744d9af81f1a5245$var$getDimensionPropertyList(dimension);
        var newStyles = {
            willChange: propertyList,
            transitionProperty: propertyList,
            transitionDuration: duration,
            boxSizing: 'border-box',
            transitionTimingFunction: easing
        };
        if (dimension === 'width' || dimension === 'both') newStyles.width = "".concat(prevDimensions.current.width, "px");
        if (dimension === 'height' || dimension === 'both') newStyles.height = "".concat(prevDimensions.current.height, "px");
        Object.assign(element.style, newStyles);
        var resolvedDuration = $744d9af81f1a5245$var$parseCSSTimeToMs(getComputedStyle(element).transitionDuration);
        // We split this over two animation frames so the DOM has enough time to flush the changes.
        // We are deliberately not skipping this frame if another render happens - if we do the motion doesn't finish properly.
        requestAnimationFrame(function() {
            requestAnimationFrame(function() {
                if (!element) return;
                if (dimension === 'width' || dimension === 'both') element.style.width = "".concat(nextDimensions.width, "px");
                if (dimension === 'height' || dimension === 'both') element.style.height = "".concat(nextDimensions.height, "px");
                setTimeout(function() {
                    if (!element) return;
                    element.setAttribute('style', '');
                    onFinishMotion === null || onFinishMotion === void 0 || onFinishMotion();
                }, resolvedDuration);
            });
        });
    });
    return {
        ref: setElementRef
    };
};




var $kqp0i = parcelRequire("kqp0i");

var $fC8ib = parcelRequire("fC8ib");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");

var $74Zh5 = parcelRequire("74Zh5");

var $25nEq = parcelRequire("25nEq");

var $5FkrB = parcelRequire("5FkrB");

var $dLGML = parcelRequire("dLGML");

var $fC8ib = parcelRequire("fC8ib");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $kIXpt = parcelRequire("kIXpt");

var $cYPzS = parcelRequire("cYPzS");

var $lwlXp = parcelRequire("lwlXp");

var $eyuDe = parcelRequire("eyuDe");

var $25nEq = parcelRequire("25nEq");

var $ekGgq = parcelRequire("ekGgq");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $25nEq = parcelRequire("25nEq");
function $0ca668875499b0f9$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $0ca668875499b0f9$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $0ca668875499b0f9$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $0ca668875499b0f9$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $0ca668875499b0f9$export$ad4be5c2ec28cecf = function isAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $0ca668875499b0f9$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === 'AnalyticsEvent';
};
// eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
var $0ca668875499b0f9$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function AnalyticsEvent(props) {
        var _this = this;
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, AnalyticsEvent);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "_isAnalyticsEvent", true);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "clone", function() {
            // just a shallow clone, don't change sub refs unless you want to
            // affect the original's too
            var payload = $0ca668875499b0f9$var$_objectSpread({}, _this.payload);
            return new AnalyticsEvent({
                payload: payload
            });
        });
        this.payload = props.payload;
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(AnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (typeof updater === 'function') this.payload = updater(this.payload);
                if ((0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(updater) === 'object') this.payload = $0ca668875499b0f9$var$_objectSpread($0ca668875499b0f9$var$_objectSpread({}, this.payload), updater);
                return this;
            }
        }
    ]);
}();


function $a094db762e9be614$var$_callSuper(t, o, e) {
    return o = (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(o), (0, (/*@__PURE__*/$parcel$interopDefault($kIXpt)))(t, $a094db762e9be614$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(t).constructor) : o.apply(t, e));
}
function $a094db762e9be614$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($a094db762e9be614$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $a094db762e9be614$var$_superPropGet(t, o, e, r) {
    var p = (0, (/*@__PURE__*/$parcel$interopDefault($lwlXp)))((0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(1 & r ? t.prototype : t), o, e);
    return 2 & r && "function" == typeof p ? function(t) {
        return p.apply(e, t);
    } : p;
}
var $a094db762e9be614$export$35f8383928ba8d7 = function isUIAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $a094db762e9be614$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isUIAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === 'UIAnalyticsEvent';
};
// eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
var $a094db762e9be614$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_AnalyticsEvent) {
    function UIAnalyticsEvent(props) {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, UIAnalyticsEvent);
        _this = $a094db762e9be614$var$_callSuper(this, UIAnalyticsEvent, [
            props
        ]);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "_isUIAnalyticsEvent", true);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "clone", function() {
            if (_this.hasFired) return null;
            var context = (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(_this.context);
            var handlers = (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(_this.handlers);
            /**
       * A hacky "deep clone" of the object. This is limited in that it wont
       * support functions, regexs, Maps, Sets, etc, but none of those need to
       * be represented in our payload.
       */ var payload = JSON.parse(JSON.stringify(_this.payload));
            return new UIAnalyticsEvent({
                context: context,
                handlers: handlers,
                payload: payload
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "fire", function(channel) {
            if (_this.hasFired) return;
            _this.handlers.forEach(function(handler) {
                try {
                    handler(_this, channel);
                } catch (e) {}
            });
            _this.hasFired = true;
        });
        _this.context = props.context || [];
        _this.handlers = props.handlers || [];
        _this.hasFired = false;
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($eyuDe)))(UIAnalyticsEvent, _AnalyticsEvent);
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(UIAnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (this.hasFired) return this;
                return $a094db762e9be614$var$_superPropGet(UIAnalyticsEvent, "update", this, 3)([
                    updater
                ]);
            }
        }
    ]);
}((0, $0ca668875499b0f9$export$2e2bcd8739ae039));



var $5FkrB = parcelRequire("5FkrB");

var $iyyOp = parcelRequire("iyyOp");
var $f3f99e7266bbdf27$export$d1f587f82ad51c4 = function useAnalyticsContext() {
    return (0, $5FkrB.useContext)((0, $iyyOp.default));
};


function $42cdf0eabed8c15e$export$5bf35293e545f20c() {
    var analyticsContext = (0, $f3f99e7266bbdf27$export$d1f587f82ad51c4)();
    var createAnalyticsEvent = (0, $dLGML.useCallbackOne)(function(payload) {
        return new (0, $a094db762e9be614$export$2e2bcd8739ae039)({
            context: analyticsContext.getAtlaskitAnalyticsContext(),
            handlers: analyticsContext.getAtlaskitAnalyticsEventHandlers(),
            payload: payload
        });
    }, [
        analyticsContext
    ]);
    return {
        createAnalyticsEvent: createAnalyticsEvent
    };
}



var $5FkrB = parcelRequire("5FkrB");
var $f28d55a1b95f4cb6$export$1d27a74659855e44 = function useTrackedRef(value) {
    var ref = (0, $5FkrB.useRef)(value);
    ref.current = value;
    return ref;
};


function $a251a03642d304a8$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $a251a03642d304a8$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $a251a03642d304a8$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $a251a03642d304a8$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $a251a03642d304a8$export$a4687b0234b40e28(_ref) {
    var fn = _ref.fn, action = _ref.action, componentName = _ref.componentName, actionSubject = _ref.actionSubject, packageName = _ref.packageName, packageVersion = _ref.packageVersion, analyticsData = _ref.analyticsData;
    var _useAnalyticsEvents = (0, $42cdf0eabed8c15e$export$5bf35293e545f20c)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
    // We put analyticsData and fn in a ref so that we don't need to break
    // memoization.
    // Generally these could be defined by consumers inline
    // and so we do this to avoid breaking memoization of useCallback
    var dataRef = (0, $f28d55a1b95f4cb6$export$1d27a74659855e44)(analyticsData);
    var fnRef = (0, $f28d55a1b95f4cb6$export$1d27a74659855e44)(fn);
    var handler = (0, $5FkrB.useCallback)(function(value) {
        var analyticsEvent = createAnalyticsEvent({
            action: action,
            actionSubject: actionSubject || componentName,
            attributes: {
                componentName: componentName,
                packageName: packageName,
                packageVersion: packageVersion
            }
        });
        // To avoid wrapping this component in AnalyticsContext we manually
        // push the parent context's meta data into the context.
        // Note: this new 'context'
        var context = $a251a03642d304a8$var$_objectSpread({
            componentName: componentName,
            packageName: packageName,
            packageVersion: packageVersion
        }, dataRef.current);
        analyticsEvent.context.push(context);
        // fire an event on the atlaskit channel
        var clone = analyticsEvent.clone();
        if (clone) clone.fire('atlaskit');
        fnRef.current(value, analyticsEvent);
    }, [
        // These are strings and won't change
        action,
        componentName,
        actionSubject,
        packageName,
        packageVersion,
        // This function is memoized in the context
        createAnalyticsEvent,
        // these are a stable ref because of the useTrackedRef hook
        dataRef,
        fnRef
    ]);
    return handler;
}


/**
 * An empty function which does nothing.
 */ function $9954455cbc1a9a72$export$2e2bcd8739ae039() {}



var $5FkrB = parcelRequire("5FkrB");
var $0a1e917c68969d41$var$interactionContext = /*#__PURE__*/ (0, $5FkrB.createContext)(null);
var $0a1e917c68969d41$export$2e2bcd8739ae039 = $0a1e917c68969d41$var$interactionContext;



var $25nEq = parcelRequire("25nEq");

var $74Zh5 = parcelRequire("74Zh5");

function $1afeb7d9666d3b79$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $1afeb7d9666d3b79$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $1afeb7d9666d3b79$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $1afeb7d9666d3b79$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $1afeb7d9666d3b79$export$6ccdbebca2ee545f = {
    '100%': '100%',
    'size.100': '1rem',
    'size.200': '1.5rem',
    'size.300': '2rem',
    'size.400': '2.5rem',
    'size.500': '3rem',
    'size.600': '6rem',
    'size.1000': '12rem'
};
var $1afeb7d9666d3b79$export$958d0ae7f2977ae4 = {
    'space.0': "var(--ds-space-0, 0px)",
    'space.025': "var(--ds-space-025, 2px)",
    'space.050': "var(--ds-space-050, 4px)",
    'space.075': "var(--ds-space-075, 6px)",
    'space.100': "var(--ds-space-100, 8px)",
    'space.150': "var(--ds-space-150, 12px)",
    'space.200': "var(--ds-space-200, 16px)",
    'space.250': "var(--ds-space-250, 20px)",
    'space.300': "var(--ds-space-300, 24px)",
    'space.400': "var(--ds-space-400, 32px)",
    'space.500': "var(--ds-space-500, 40px)",
    'space.600': "var(--ds-space-600, 48px)",
    'space.800': "var(--ds-space-800, 64px)",
    'space.1000': "var(--ds-space-1000, 80px)"
};
var $1afeb7d9666d3b79$export$d2dc61f58390201c = {
    'space.negative.025': "var(--ds-space-negative-025, -2px)",
    'space.negative.050': "var(--ds-space-negative-050, -4px)",
    'space.negative.075': "var(--ds-space-negative-075, -6px)",
    'space.negative.100': "var(--ds-space-negative-100, -8px)",
    'space.negative.150': "var(--ds-space-negative-150, -12px)",
    'space.negative.200': "var(--ds-space-negative-200, -16px)",
    'space.negative.250': "var(--ds-space-negative-250, -20px)",
    'space.negative.300': "var(--ds-space-negative-300, -24px)",
    'space.negative.400': "var(--ds-space-negative-400, -32px)"
};
var $1afeb7d9666d3b79$export$632685d741f3dbbf = $1afeb7d9666d3b79$var$_objectSpread($1afeb7d9666d3b79$var$_objectSpread({}, $1afeb7d9666d3b79$export$958d0ae7f2977ae4), $1afeb7d9666d3b79$export$d2dc61f58390201c);
var $1afeb7d9666d3b79$export$2185ce37f9bdd963 = {
    'color.background.neutral.bold': 'color.text.inverse',
    'color.background.neutral.bold.hovered': 'color.text.inverse',
    'color.background.neutral.bold.pressed': 'color.text.inverse',
    'color.background.selected.bold': 'color.text.inverse',
    'color.background.selected.bold.hovered': 'color.text.inverse',
    'color.background.selected.bold.pressed': 'color.text.inverse',
    'color.background.brand.bold': 'color.text.inverse',
    'color.background.brand.bold.hovered': 'color.text.inverse',
    'color.background.brand.bold.pressed': 'color.text.inverse',
    'color.background.brand.boldest': 'color.text.inverse',
    'color.background.brand.boldest.hovered': 'color.text.inverse',
    'color.background.brand.boldest.pressed': 'color.text.inverse',
    'color.background.danger.bold': 'color.text.inverse',
    'color.background.danger.bold.hovered': 'color.text.inverse',
    'color.background.danger.bold.pressed': 'color.text.inverse',
    'color.background.warning.bold': 'color.text.warning.inverse',
    'color.background.warning.bold.hovered': 'color.text.warning.inverse',
    'color.background.warning.bold.pressed': 'color.text.warning.inverse',
    'color.background.success.bold': 'color.text.inverse',
    'color.background.success.bold.hovered': 'color.text.inverse',
    'color.background.success.bold.pressed': 'color.text.inverse',
    'color.background.discovery.bold': 'color.text.inverse',
    'color.background.discovery.bold.hovered': 'color.text.inverse',
    'color.background.discovery.bold.pressed': 'color.text.inverse',
    'color.background.information.bold': 'color.text.inverse',
    'color.background.information.bold.hovered': 'color.text.inverse',
    'color.background.information.bold.pressed': 'color.text.inverse',
    'color.rovo.background.brand.bold': 'color.text.inverse',
    'color.rovo.background.brand.bold.hovered': 'color.text.inverse',
    'color.rovo.background.brand.bold.pressed': 'color.text.inverse'
};
var $1afeb7d9666d3b79$export$daf94a976c798b4f = {
    'opacity.disabled': "var(--ds-opacity-disabled, 0.4)",
    'opacity.loading': "var(--ds-opacity-loading, 0.2)"
};
var $1afeb7d9666d3b79$export$7aff6e7ba39bb774 = {
    'elevation.shadow.overflow': "var(--ds-shadow-overflow, 0px 0px 8px #1E1F21, 0px 0px 1px #1E1F21)",
    'elevation.shadow.overflow.perimeter': "var(--ds-shadow-overflow-perimeter, #1E1F211f)",
    'elevation.shadow.overflow.spread': "var(--ds-shadow-overflow-spread, #1E1F2129)",
    'elevation.shadow.overlay': "var(--ds-shadow-overlay, 0px 8px 12px #1E1F21, 0px 0px 1px #1E1F21)",
    'elevation.shadow.raised': "var(--ds-shadow-raised, 0px 1px 1px #1E1F21, 0px 0px 1px #1E1F21)"
};
var $1afeb7d9666d3b79$export$41a358c9c2356760 = {
    'elevation.surface': "var(--ds-surface, #FFFFFF)",
    'elevation.surface.hovered': "var(--ds-surface-hovered, #F0F1F2)",
    'elevation.surface.pressed': "var(--ds-surface-pressed, #DDDEE1)",
    'elevation.surface.container': "var(--ds-surface-container, #F0F1F2)",
    'elevation.surface.overlay': "var(--ds-surface-overlay, #FFFFFF)",
    'elevation.surface.overlay.hovered': "var(--ds-surface-overlay-hovered, #F0F1F2)",
    'elevation.surface.overlay.pressed': "var(--ds-surface-overlay-pressed, #DDDEE1)",
    'elevation.surface.raised': "var(--ds-surface-raised, #FFFFFF)",
    'elevation.surface.raised.hovered': "var(--ds-surface-raised-hovered, #F0F1F2)",
    'elevation.surface.raised.pressed': "var(--ds-surface-raised-pressed, #DDDEE1)",
    'elevation.surface.sunken': "var(--ds-surface-sunken, #F8F8F8)"
};
var $1afeb7d9666d3b79$export$1531ad5bb3fbedac = {
    'color.border': "var(--ds-border, #0B120E24)",
    'color.border.accent.lime': "var(--ds-border-accent-lime, #6A9A23)",
    'color.border.accent.lime.subtle': "var(--ds-border-accent-lime-subtle, #B3DF72)",
    'color.border.accent.red': "var(--ds-border-accent-red, #E2483D)",
    'color.border.accent.red.subtle': "var(--ds-border-accent-red-subtle, #FD9891)",
    'color.border.accent.orange': "var(--ds-border-accent-orange, #E06C00)",
    'color.border.accent.orange.subtle': "var(--ds-border-accent-orange-subtle, #FBC828)",
    'color.border.accent.yellow': "var(--ds-border-accent-yellow, #B38600)",
    'color.border.accent.yellow.subtle': "var(--ds-border-accent-yellow-subtle, #EED12B)",
    'color.border.accent.green': "var(--ds-border-accent-green, #22A06B)",
    'color.border.accent.green.subtle': "var(--ds-border-accent-green-subtle, #7EE2B8)",
    'color.border.accent.teal': "var(--ds-border-accent-teal, #2898BD)",
    'color.border.accent.teal.subtle': "var(--ds-border-accent-teal-subtle, #9DD9EE)",
    'color.border.accent.blue': "var(--ds-border-accent-blue, #357DE8)",
    'color.border.accent.blue.subtle': "var(--ds-border-accent-blue-subtle, #8FB8F6)",
    'color.border.accent.purple': "var(--ds-border-accent-purple, #AF59E1)",
    'color.border.accent.purple.subtle': "var(--ds-border-accent-purple-subtle, #D8A0F7)",
    'color.border.accent.magenta': "var(--ds-border-accent-magenta, #CD519D)",
    'color.border.accent.magenta.subtle': "var(--ds-border-accent-magenta-subtle, #F797D2)",
    'color.border.accent.gray': "var(--ds-border-accent-gray, #7D818A)",
    'color.border.accent.gray.subtle': "var(--ds-border-accent-gray-subtle, #B7B9BE)",
    'color.border.disabled': "var(--ds-border-disabled, #0515240F)",
    'color.border.focused': "var(--ds-border-focused, #4688EC)",
    'color.border.input': "var(--ds-border-input, #8C8F97)",
    'color.border.inverse': "var(--ds-border-inverse, #FFFFFF)",
    'color.border.selected': "var(--ds-border-selected, #1868DB)",
    'color.border.brand': "var(--ds-border-brand, #1868DB)",
    'color.border.danger': "var(--ds-border-danger, #E2483D)",
    'color.border.danger.subtle': "var(--ds-border-danger-subtle, #FD9891)",
    'color.border.warning': "var(--ds-border-warning, #E06C00)",
    'color.border.warning.subtle': "var(--ds-border-warning-subtle, #FBC828)",
    'color.border.success': "var(--ds-border-success, #6A9A23)",
    'color.border.success.subtle': "var(--ds-border-success-subtle, #B3DF72)",
    'color.border.discovery': "var(--ds-border-discovery, #AF59E1)",
    'color.border.discovery.subtle': "var(--ds-border-discovery-subtle, #D8A0F7)",
    'color.border.information': "var(--ds-border-information, #357DE8)",
    'color.border.information.subtle': "var(--ds-border-information-subtle, #8FB8F6)",
    'color.border.bold': "var(--ds-border-bold, #7D818A)"
};
var $1afeb7d9666d3b79$export$d1d79bf68ac056bd = {
    'color.background.accent.lime.subtlest': "var(--ds-background-accent-lime-subtlest, #EFFFD6)",
    'color.background.accent.lime.subtlest.hovered': "var(--ds-background-accent-lime-subtlest-hovered, #D3F1A7)",
    'color.background.accent.lime.subtlest.pressed': "var(--ds-background-accent-lime-subtlest-pressed, #BDE97C)",
    'color.background.accent.lime.subtler': "var(--ds-background-accent-lime-subtler, #D3F1A7)",
    'color.background.accent.lime.subtler.hovered': "var(--ds-background-accent-lime-subtler-hovered, #BDE97C)",
    'color.background.accent.lime.subtler.pressed': "var(--ds-background-accent-lime-subtler-pressed, #B3DF72)",
    'color.background.accent.lime.subtle': "var(--ds-background-accent-lime-subtle, #94C748)",
    'color.background.accent.lime.subtle.hovered': "var(--ds-background-accent-lime-subtle-hovered, #B3DF72)",
    'color.background.accent.lime.subtle.pressed': "var(--ds-background-accent-lime-subtle-pressed, #BDE97C)",
    'color.background.accent.lime.bolder': "var(--ds-background-accent-lime-bolder, #5B7F24)",
    'color.background.accent.lime.bolder.hovered': "var(--ds-background-accent-lime-bolder-hovered, #4C6B1F)",
    'color.background.accent.lime.bolder.pressed': "var(--ds-background-accent-lime-bolder-pressed, #3F5224)",
    'color.background.accent.red.subtlest': "var(--ds-background-accent-red-subtlest, #FFECEB)",
    'color.background.accent.red.subtlest.hovered': "var(--ds-background-accent-red-subtlest-hovered, #FFD5D2)",
    'color.background.accent.red.subtlest.pressed': "var(--ds-background-accent-red-subtlest-pressed, #FFB8B2)",
    'color.background.accent.red.subtler': "var(--ds-background-accent-red-subtler, #FFD5D2)",
    'color.background.accent.red.subtler.hovered': "var(--ds-background-accent-red-subtler-hovered, #FFB8B2)",
    'color.background.accent.red.subtler.pressed': "var(--ds-background-accent-red-subtler-pressed, #FD9891)",
    'color.background.accent.red.subtle': "var(--ds-background-accent-red-subtle, #F87168)",
    'color.background.accent.red.subtle.hovered': "var(--ds-background-accent-red-subtle-hovered, #FD9891)",
    'color.background.accent.red.subtle.pressed': "var(--ds-background-accent-red-subtle-pressed, #FFB8B2)",
    'color.background.accent.red.bolder': "var(--ds-background-accent-red-bolder, #C9372C)",
    'color.background.accent.red.bolder.hovered': "var(--ds-background-accent-red-bolder-hovered, #AE2E24)",
    'color.background.accent.red.bolder.pressed': "var(--ds-background-accent-red-bolder-pressed, #872821)",
    'color.background.accent.orange.subtlest': "var(--ds-background-accent-orange-subtlest, #FFF5DB)",
    'color.background.accent.orange.subtlest.hovered': "var(--ds-background-accent-orange-subtlest-hovered, #FCE4A6)",
    'color.background.accent.orange.subtlest.pressed': "var(--ds-background-accent-orange-subtlest-pressed, #FBD779)",
    'color.background.accent.orange.subtler': "var(--ds-background-accent-orange-subtler, #FCE4A6)",
    'color.background.accent.orange.subtler.hovered': "var(--ds-background-accent-orange-subtler-hovered, #FBD779)",
    'color.background.accent.orange.subtler.pressed': "var(--ds-background-accent-orange-subtler-pressed, #FBC828)",
    'color.background.accent.orange.subtle': "var(--ds-background-accent-orange-subtle, #FCA700)",
    'color.background.accent.orange.subtle.hovered': "var(--ds-background-accent-orange-subtle-hovered, #FBC828)",
    'color.background.accent.orange.subtle.pressed': "var(--ds-background-accent-orange-subtle-pressed, #FBD779)",
    'color.background.accent.orange.bolder': "var(--ds-background-accent-orange-bolder, #BD5B00)",
    'color.background.accent.orange.bolder.hovered': "var(--ds-background-accent-orange-bolder-hovered, #9E4C00)",
    'color.background.accent.orange.bolder.pressed': "var(--ds-background-accent-orange-bolder-pressed, #7A3B00)",
    'color.background.accent.yellow.subtlest': "var(--ds-background-accent-yellow-subtlest, #FEF7C8)",
    'color.background.accent.yellow.subtlest.hovered': "var(--ds-background-accent-yellow-subtlest-hovered, #F5E989)",
    'color.background.accent.yellow.subtlest.pressed': "var(--ds-background-accent-yellow-subtlest-pressed, #EFDD4E)",
    'color.background.accent.yellow.subtler': "var(--ds-background-accent-yellow-subtler, #F5E989)",
    'color.background.accent.yellow.subtler.hovered': "var(--ds-background-accent-yellow-subtler-hovered, #EFDD4E)",
    'color.background.accent.yellow.subtler.pressed': "var(--ds-background-accent-yellow-subtler-pressed, #EED12B)",
    'color.background.accent.yellow.subtle': "var(--ds-background-accent-yellow-subtle, #EED12B)",
    'color.background.accent.yellow.subtle.hovered': "var(--ds-background-accent-yellow-subtle-hovered, #DDB30E)",
    'color.background.accent.yellow.subtle.pressed': "var(--ds-background-accent-yellow-subtle-pressed, #EFDD4E)",
    'color.background.accent.yellow.bolder': "var(--ds-background-accent-yellow-bolder, #946F00)",
    'color.background.accent.yellow.bolder.hovered': "var(--ds-background-accent-yellow-bolder-hovered, #7F5F01)",
    'color.background.accent.yellow.bolder.pressed': "var(--ds-background-accent-yellow-bolder-pressed, #614A05)",
    'color.background.accent.green.subtlest': "var(--ds-background-accent-green-subtlest, #DCFFF1)",
    'color.background.accent.green.subtlest.hovered': "var(--ds-background-accent-green-subtlest-hovered, #BAF3DB)",
    'color.background.accent.green.subtlest.pressed': "var(--ds-background-accent-green-subtlest-pressed, #97EDC9)",
    'color.background.accent.green.subtler': "var(--ds-background-accent-green-subtler, #BAF3DB)",
    'color.background.accent.green.subtler.hovered': "var(--ds-background-accent-green-subtler-hovered, #97EDC9)",
    'color.background.accent.green.subtler.pressed': "var(--ds-background-accent-green-subtler-pressed, #7EE2B8)",
    'color.background.accent.green.subtle': "var(--ds-background-accent-green-subtle, #4BCE97)",
    'color.background.accent.green.subtle.hovered': "var(--ds-background-accent-green-subtle-hovered, #7EE2B8)",
    'color.background.accent.green.subtle.pressed': "var(--ds-background-accent-green-subtle-pressed, #97EDC9)",
    'color.background.accent.green.bolder': "var(--ds-background-accent-green-bolder, #1F845A)",
    'color.background.accent.green.bolder.hovered': "var(--ds-background-accent-green-bolder-hovered, #216E4E)",
    'color.background.accent.green.bolder.pressed': "var(--ds-background-accent-green-bolder-pressed, #19573D)",
    'color.background.accent.teal.subtlest': "var(--ds-background-accent-teal-subtlest, #E7F9FF)",
    'color.background.accent.teal.subtlest.hovered': "var(--ds-background-accent-teal-subtlest-hovered, #C6EDFB)",
    'color.background.accent.teal.subtlest.pressed': "var(--ds-background-accent-teal-subtlest-pressed, #B1E4F7)",
    'color.background.accent.teal.subtler': "var(--ds-background-accent-teal-subtler, #C6EDFB)",
    'color.background.accent.teal.subtler.hovered': "var(--ds-background-accent-teal-subtler-hovered, #B1E4F7)",
    'color.background.accent.teal.subtler.pressed': "var(--ds-background-accent-teal-subtler-pressed, #9DD9EE)",
    'color.background.accent.teal.subtle': "var(--ds-background-accent-teal-subtle, #6CC3E0)",
    'color.background.accent.teal.subtle.hovered': "var(--ds-background-accent-teal-subtle-hovered, #9DD9EE)",
    'color.background.accent.teal.subtle.pressed': "var(--ds-background-accent-teal-subtle-pressed, #B1E4F7)",
    'color.background.accent.teal.bolder': "var(--ds-background-accent-teal-bolder, #227D9B)",
    'color.background.accent.teal.bolder.hovered': "var(--ds-background-accent-teal-bolder-hovered, #206A83)",
    'color.background.accent.teal.bolder.pressed': "var(--ds-background-accent-teal-bolder-pressed, #1A5265)",
    'color.background.accent.blue.subtlest': "var(--ds-background-accent-blue-subtlest, #E9F2FE)",
    'color.background.accent.blue.subtlest.hovered': "var(--ds-background-accent-blue-subtlest-hovered, #CFE1FD)",
    'color.background.accent.blue.subtlest.pressed': "var(--ds-background-accent-blue-subtlest-pressed, #ADCBFB)",
    'color.background.accent.blue.subtler': "var(--ds-background-accent-blue-subtler, #CFE1FD)",
    'color.background.accent.blue.subtler.hovered': "var(--ds-background-accent-blue-subtler-hovered, #ADCBFB)",
    'color.background.accent.blue.subtler.pressed': "var(--ds-background-accent-blue-subtler-pressed, #8FB8F6)",
    'color.background.accent.blue.subtle': "var(--ds-background-accent-blue-subtle, #669DF1)",
    'color.background.accent.blue.subtle.hovered': "var(--ds-background-accent-blue-subtle-hovered, #8FB8F6)",
    'color.background.accent.blue.subtle.pressed': "var(--ds-background-accent-blue-subtle-pressed, #ADCBFB)",
    'color.background.accent.blue.bolder': "var(--ds-background-accent-blue-bolder, #1868DB)",
    'color.background.accent.blue.bolder.hovered': "var(--ds-background-accent-blue-bolder-hovered, #1558BC)",
    'color.background.accent.blue.bolder.pressed': "var(--ds-background-accent-blue-bolder-pressed, #144794)",
    'color.background.accent.purple.subtlest': "var(--ds-background-accent-purple-subtlest, #F8EEFE)",
    'color.background.accent.purple.subtlest.hovered': "var(--ds-background-accent-purple-subtlest-hovered, #EED7FC)",
    'color.background.accent.purple.subtlest.pressed': "var(--ds-background-accent-purple-subtlest-pressed, #E3BDFA)",
    'color.background.accent.purple.subtler': "var(--ds-background-accent-purple-subtler, #EED7FC)",
    'color.background.accent.purple.subtler.hovered': "var(--ds-background-accent-purple-subtler-hovered, #E3BDFA)",
    'color.background.accent.purple.subtler.pressed': "var(--ds-background-accent-purple-subtler-pressed, #D8A0F7)",
    'color.background.accent.purple.subtle': "var(--ds-background-accent-purple-subtle, #C97CF4)",
    'color.background.accent.purple.subtle.hovered': "var(--ds-background-accent-purple-subtle-hovered, #D8A0F7)",
    'color.background.accent.purple.subtle.pressed': "var(--ds-background-accent-purple-subtle-pressed, #E3BDFA)",
    'color.background.accent.purple.bolder': "var(--ds-background-accent-purple-bolder, #964AC0)",
    'color.background.accent.purple.bolder.hovered': "var(--ds-background-accent-purple-bolder-hovered, #803FA5)",
    'color.background.accent.purple.bolder.pressed': "var(--ds-background-accent-purple-bolder-pressed, #673286)",
    'color.background.accent.magenta.subtlest': "var(--ds-background-accent-magenta-subtlest, #FFECF8)",
    'color.background.accent.magenta.subtlest.hovered': "var(--ds-background-accent-magenta-subtlest-hovered, #FDD0EC)",
    'color.background.accent.magenta.subtlest.pressed': "var(--ds-background-accent-magenta-subtlest-pressed, #FCB6E1)",
    'color.background.accent.magenta.subtler': "var(--ds-background-accent-magenta-subtler, #FDD0EC)",
    'color.background.accent.magenta.subtler.hovered': "var(--ds-background-accent-magenta-subtler-hovered, #FCB6E1)",
    'color.background.accent.magenta.subtler.pressed': "var(--ds-background-accent-magenta-subtler-pressed, #F797D2)",
    'color.background.accent.magenta.subtle': "var(--ds-background-accent-magenta-subtle, #E774BB)",
    'color.background.accent.magenta.subtle.hovered': "var(--ds-background-accent-magenta-subtle-hovered, #F797D2)",
    'color.background.accent.magenta.subtle.pressed': "var(--ds-background-accent-magenta-subtle-pressed, #FCB6E1)",
    'color.background.accent.magenta.bolder': "var(--ds-background-accent-magenta-bolder, #AE4787)",
    'color.background.accent.magenta.bolder.hovered': "var(--ds-background-accent-magenta-bolder-hovered, #943D73)",
    'color.background.accent.magenta.bolder.pressed': "var(--ds-background-accent-magenta-bolder-pressed, #77325B)",
    'color.background.accent.gray.subtlest': "var(--ds-background-accent-gray-subtlest, #F0F1F2)",
    'color.background.accent.gray.subtlest.hovered': "var(--ds-background-accent-gray-subtlest-hovered, #DDDEE1)",
    'color.background.accent.gray.subtlest.pressed': "var(--ds-background-accent-gray-subtlest-pressed, #B7B9BE)",
    'color.background.accent.gray.subtler': "var(--ds-background-accent-gray-subtler, #DDDEE1)",
    'color.background.accent.gray.subtler.hovered': "var(--ds-background-accent-gray-subtler-hovered, #B7B9BE)",
    'color.background.accent.gray.subtler.pressed': "var(--ds-background-accent-gray-subtler-pressed, #8C8F97)",
    'color.background.accent.gray.subtle': "var(--ds-background-accent-gray-subtle, #8C8F97)",
    'color.background.accent.gray.subtle.hovered': "var(--ds-background-accent-gray-subtle-hovered, #B7B9BE)",
    'color.background.accent.gray.subtle.pressed': "var(--ds-background-accent-gray-subtle-pressed, #DDDEE1)",
    'color.background.accent.gray.bolder': "var(--ds-background-accent-gray-bolder, #6B6E76)",
    'color.background.accent.gray.bolder.hovered': "var(--ds-background-accent-gray-bolder-hovered, #505258)",
    'color.background.accent.gray.bolder.pressed': "var(--ds-background-accent-gray-bolder-pressed, #3B3D42)",
    'color.background.disabled': "var(--ds-background-disabled, #0515240F)",
    'color.background.input': "var(--ds-background-input, #FFFFFF)",
    'color.background.input.hovered': "var(--ds-background-input-hovered, #F8F8F8)",
    'color.background.input.pressed': "var(--ds-background-input-pressed, #FFFFFF)",
    'color.background.inverse.subtle': "var(--ds-background-inverse-subtle, #00000029)",
    'color.background.inverse.subtle.hovered': "var(--ds-background-inverse-subtle-hovered, #0000003D)",
    'color.background.inverse.subtle.pressed': "var(--ds-background-inverse-subtle-pressed, #00000052)",
    'color.background.neutral': "var(--ds-background-neutral, #0515240F)",
    'color.background.neutral.hovered': "var(--ds-background-neutral-hovered, #0B120E24)",
    'color.background.neutral.pressed': "var(--ds-background-neutral-pressed, #080F214A)",
    'color.background.neutral.subtle': "var(--ds-background-neutral-subtle, #00000000)",
    'color.background.neutral.subtle.hovered': "var(--ds-background-neutral-subtle-hovered, #0515240F)",
    'color.background.neutral.subtle.pressed': "var(--ds-background-neutral-subtle-pressed, #0B120E24)",
    'color.background.neutral.bold': "var(--ds-background-neutral-bold, #292A2E)",
    'color.background.neutral.bold.hovered': "var(--ds-background-neutral-bold-hovered, #3B3D42)",
    'color.background.neutral.bold.pressed': "var(--ds-background-neutral-bold-pressed, #505258)",
    'color.background.selected': "var(--ds-background-selected, #E9F2FE)",
    'color.background.selected.hovered': "var(--ds-background-selected-hovered, #CFE1FD)",
    'color.background.selected.pressed': "var(--ds-background-selected-pressed, #8FB8F6)",
    'color.background.selected.bold': "var(--ds-background-selected-bold, #1868DB)",
    'color.background.selected.bold.hovered': "var(--ds-background-selected-bold-hovered, #1558BC)",
    'color.background.selected.bold.pressed': "var(--ds-background-selected-bold-pressed, #123263)",
    'color.background.brand.subtlest': "var(--ds-background-brand-subtlest, #E9F2FE)",
    'color.background.brand.subtlest.hovered': "var(--ds-background-brand-subtlest-hovered, #CFE1FD)",
    'color.background.brand.subtlest.pressed': "var(--ds-background-brand-subtlest-pressed, #ADCBFB)",
    'color.background.brand.bold': "var(--ds-background-brand-bold, #1868DB)",
    'color.background.brand.bold.hovered': "var(--ds-background-brand-bold-hovered, #1558BC)",
    'color.background.brand.bold.pressed': "var(--ds-background-brand-bold-pressed, #144794)",
    'color.background.brand.boldest': "var(--ds-background-brand-boldest, #1C2B42)",
    'color.background.brand.boldest.hovered': "var(--ds-background-brand-boldest-hovered, #123263)",
    'color.background.brand.boldest.pressed': "var(--ds-background-brand-boldest-pressed, #144794)",
    'color.background.danger': "var(--ds-background-danger, #FFECEB)",
    'color.background.danger.hovered': "var(--ds-background-danger-hovered, #FFD5D2)",
    'color.background.danger.pressed': "var(--ds-background-danger-pressed, #FFB8B2)",
    'color.background.danger.subtler': "var(--ds-background-danger-subtler, #FFD5D2)",
    'color.background.danger.subtler.hovered': "var(--ds-background-danger-subtler-hovered, #FFB8B2)",
    'color.background.danger.subtler.pressed': "var(--ds-background-danger-subtler-pressed, #FD9891)",
    'color.background.danger.subtle': "var(--ds-background-danger-subtle, #FD9891)",
    'color.background.danger.bold': "var(--ds-background-danger-bold, #C9372C)",
    'color.background.danger.bold.hovered': "var(--ds-background-danger-bold-hovered, #AE2E24)",
    'color.background.danger.bold.pressed': "var(--ds-background-danger-bold-pressed, #872821)",
    'color.background.warning': "var(--ds-background-warning, #FFF5DB)",
    'color.background.warning.hovered': "var(--ds-background-warning-hovered, #FCE4A6)",
    'color.background.warning.pressed': "var(--ds-background-warning-pressed, #FBD779)",
    'color.background.warning.subtler': "var(--ds-background-warning-subtler, #FCE4A6)",
    'color.background.warning.subtler.hovered': "var(--ds-background-warning-subtler-hovered, #FBD779)",
    'color.background.warning.subtler.pressed': "var(--ds-background-warning-subtler-pressed, #FBC828)",
    'color.background.warning.subtle': "var(--ds-background-warning-subtle, #FBD779)",
    'color.background.warning.bold': "var(--ds-background-warning-bold, #FBC828)",
    'color.background.warning.bold.hovered': "var(--ds-background-warning-bold-hovered, #FCA700)",
    'color.background.warning.bold.pressed': "var(--ds-background-warning-bold-pressed, #F68909)",
    'color.background.success': "var(--ds-background-success, #EFFFD6)",
    'color.background.success.hovered': "var(--ds-background-success-hovered, #D3F1A7)",
    'color.background.success.pressed': "var(--ds-background-success-pressed, #BDE97C)",
    'color.background.success.subtler': "var(--ds-background-success-subtler, #D3F1A7)",
    'color.background.success.subtler.hovered': "var(--ds-background-success-subtler-hovered, #BDE97C)",
    'color.background.success.subtler.pressed': "var(--ds-background-success-subtler-pressed, #B3DF72)",
    'color.background.success.subtle': "var(--ds-background-success-subtle, #B3DF72)",
    'color.background.success.bold': "var(--ds-background-success-bold, #5B7F24)",
    'color.background.success.bold.hovered': "var(--ds-background-success-bold-hovered, #4C6B1F)",
    'color.background.success.bold.pressed': "var(--ds-background-success-bold-pressed, #3F5224)",
    'color.background.discovery': "var(--ds-background-discovery, #F8EEFE)",
    'color.background.discovery.hovered': "var(--ds-background-discovery-hovered, #EED7FC)",
    'color.background.discovery.pressed': "var(--ds-background-discovery-pressed, #E3BDFA)",
    'color.background.discovery.subtler': "var(--ds-background-discovery-subtler, #EED7FC)",
    'color.background.discovery.subtler.hovered': "var(--ds-background-discovery-subtler-hovered, #E3BDFA)",
    'color.background.discovery.subtler.pressed': "var(--ds-background-discovery-subtler-pressed, #D8A0F7)",
    'color.background.discovery.subtle': "var(--ds-background-discovery-subtle, #D8A0F7)",
    'color.background.discovery.bold': "var(--ds-background-discovery-bold, #964AC0)",
    'color.background.discovery.bold.hovered': "var(--ds-background-discovery-bold-hovered, #803FA5)",
    'color.background.discovery.bold.pressed': "var(--ds-background-discovery-bold-pressed, #673286)",
    'color.background.information': "var(--ds-background-information, #E9F2FE)",
    'color.background.information.hovered': "var(--ds-background-information-hovered, #CFE1FD)",
    'color.background.information.pressed': "var(--ds-background-information-pressed, #ADCBFB)",
    'color.background.information.subtler': "var(--ds-background-information-subtler, #CFE1FD)",
    'color.background.information.subtler.hovered': "var(--ds-background-information-subtler-hovered, #ADCBFB)",
    'color.background.information.subtler.pressed': "var(--ds-background-information-subtler-pressed, #8FB8F6)",
    'color.background.information.subtle': "var(--ds-background-information-subtle, #8FB8F6)",
    'color.background.information.bold': "var(--ds-background-information-bold, #1868DB)",
    'color.background.information.bold.hovered': "var(--ds-background-information-bold-hovered, #1558BC)",
    'color.background.information.bold.pressed': "var(--ds-background-information-bold-pressed, #144794)",
    'color.skeleton': "var(--ds-skeleton, #0515240F)",
    'color.skeleton.subtle': "var(--ds-skeleton-subtle, #17171708)",
    'color.blanket': "var(--ds-blanket, #050C1F75)",
    'color.blanket.selected': "var(--ds-blanket-selected, #388BFF14)",
    'color.blanket.danger': "var(--ds-blanket-danger, #EF5C4814)",
    'color.rovo.background.brand.bold': "var(--ds-rovo-background-brand-bold, #000000)",
    'color.rovo.background.brand.bold.hovered': "var(--ds-rovo-background-brand-bold-hovered, #1E1F21)",
    'color.rovo.background.brand.bold.pressed': "var(--ds-rovo-background-brand-bold-pressed, #292A2E)",
    'elevation.surface': "var(--ds-surface, #FFFFFF)",
    'elevation.surface.hovered': "var(--ds-surface-hovered, #F0F1F2)",
    'elevation.surface.pressed': "var(--ds-surface-pressed, #DDDEE1)",
    'elevation.surface.container': "var(--ds-surface-container, #F0F1F2)",
    'elevation.surface.overlay': "var(--ds-surface-overlay, #FFFFFF)",
    'elevation.surface.overlay.hovered': "var(--ds-surface-overlay-hovered, #F0F1F2)",
    'elevation.surface.overlay.pressed': "var(--ds-surface-overlay-pressed, #DDDEE1)",
    'elevation.surface.raised': "var(--ds-surface-raised, #FFFFFF)",
    'elevation.surface.raised.hovered': "var(--ds-surface-raised-hovered, #F0F1F2)",
    'elevation.surface.raised.pressed': "var(--ds-surface-raised-pressed, #DDDEE1)",
    'elevation.surface.sunken': "var(--ds-surface-sunken, #F8F8F8)",
    'utility.elevation.surface.current': "var(--ds-elevation-surface-current, #FFFFFF)"
};
var $1afeb7d9666d3b79$export$8473307aa00d6ea1 = {
    'color.text': "var(--ds-text, #292A2E)",
    'color.text.accent.lime': "var(--ds-text-accent-lime, #4C6B1F)",
    'color.text.accent.lime.bolder': "var(--ds-text-accent-lime-bolder, #37471F)",
    'color.text.accent.red': "var(--ds-text-accent-red, #AE2E24)",
    'color.text.accent.red.bolder': "var(--ds-text-accent-red-bolder, #5D1F1A)",
    'color.text.accent.orange': "var(--ds-text-accent-orange, #9E4C00)",
    'color.text.accent.orange.bolder': "var(--ds-text-accent-orange-bolder, #693200)",
    'color.text.accent.yellow': "var(--ds-text-accent-yellow, #7F5F01)",
    'color.text.accent.yellow.bolder': "var(--ds-text-accent-yellow-bolder, #533F04)",
    'color.text.accent.green': "var(--ds-text-accent-green, #216E4E)",
    'color.text.accent.green.bolder': "var(--ds-text-accent-green-bolder, #164B35)",
    'color.text.accent.teal': "var(--ds-text-accent-teal, #206A83)",
    'color.text.accent.teal.bolder': "var(--ds-text-accent-teal-bolder, #164555)",
    'color.text.accent.blue': "var(--ds-text-accent-blue, #1558BC)",
    'color.text.accent.blue.bolder': "var(--ds-text-accent-blue-bolder, #123263)",
    'color.text.accent.purple': "var(--ds-text-accent-purple, #803FA5)",
    'color.text.accent.purple.bolder': "var(--ds-text-accent-purple-bolder, #48245D)",
    'color.text.accent.magenta': "var(--ds-text-accent-magenta, #943D73)",
    'color.text.accent.magenta.bolder': "var(--ds-text-accent-magenta-bolder, #50253F)",
    'color.text.accent.gray': "var(--ds-text-accent-gray, #505258)",
    'color.text.accent.gray.bolder': "var(--ds-text-accent-gray-bolder, #1E1F21)",
    'color.text.disabled': "var(--ds-text-disabled, #080F214A)",
    'color.text.inverse': "var(--ds-text-inverse, #FFFFFF)",
    'color.text.selected': "var(--ds-text-selected, #1868DB)",
    'color.text.brand': "var(--ds-text-brand, #1868DB)",
    'color.text.danger': "var(--ds-text-danger, #AE2E24)",
    'color.text.danger.bolder': "var(--ds-text-danger-bolder, #5D1F1A)",
    'color.text.warning': "var(--ds-text-warning, #9E4C00)",
    'color.text.warning.inverse': "var(--ds-text-warning-inverse, #292A2E)",
    'color.text.warning.bolder': "var(--ds-text-warning-bolder, #693200)",
    'color.text.success': "var(--ds-text-success, #4C6B1F)",
    'color.text.success.bolder': "var(--ds-text-success-bolder, #37471F)",
    'color.text.discovery': "var(--ds-text-discovery, #803FA5)",
    'color.text.discovery.bolder': "var(--ds-text-discovery-bolder, #48245D)",
    'color.text.information': "var(--ds-text-information, #1558BC)",
    'color.text.information.bolder': "var(--ds-text-information-bolder, #123263)",
    'color.text.subtlest': "var(--ds-text-subtlest, #6B6E76)",
    'color.text.subtle': "var(--ds-text-subtle, #505258)",
    'color.link': "var(--ds-link, #1868DB)",
    'color.link.pressed': "var(--ds-link-pressed, #1558BC)",
    'color.link.visited': "var(--ds-link-visited, #803FA5)",
    'color.link.visited.pressed': "var(--ds-link-visited-pressed, #48245D)"
};
var $1afeb7d9666d3b79$export$498780f74be9af68 = {
    'color.icon': "var(--ds-icon, #292A2E)",
    'color.icon.accent.lime': "var(--ds-icon-accent-lime, #6A9A23)",
    'color.icon.accent.red': "var(--ds-icon-accent-red, #C9372C)",
    'color.icon.accent.orange': "var(--ds-icon-accent-orange, #E06C00)",
    'color.icon.accent.yellow': "var(--ds-icon-accent-yellow, #B38600)",
    'color.icon.accent.green': "var(--ds-icon-accent-green, #22A06B)",
    'color.icon.accent.teal': "var(--ds-icon-accent-teal, #2898BD)",
    'color.icon.accent.blue': "var(--ds-icon-accent-blue, #357DE8)",
    'color.icon.accent.purple': "var(--ds-icon-accent-purple, #AF59E1)",
    'color.icon.accent.magenta': "var(--ds-icon-accent-magenta, #CD519D)",
    'color.icon.accent.gray': "var(--ds-icon-accent-gray, #7D818A)",
    'color.icon.disabled': "var(--ds-icon-disabled, #080F214A)",
    'color.icon.inverse': "var(--ds-icon-inverse, #FFFFFF)",
    'color.icon.selected': "var(--ds-icon-selected, #1868DB)",
    'color.icon.brand': "var(--ds-icon-brand, #1868DB)",
    'color.icon.danger': "var(--ds-icon-danger, #C9372C)",
    'color.icon.warning': "var(--ds-icon-warning, #E06C00)",
    'color.icon.warning.inverse': "var(--ds-icon-warning-inverse, #292A2E)",
    'color.icon.success': "var(--ds-icon-success, #6A9A23)",
    'color.icon.discovery': "var(--ds-icon-discovery, #AF59E1)",
    'color.icon.information': "var(--ds-icon-information, #357DE8)",
    'color.icon.subtlest': "var(--ds-icon-subtlest, #6B6E76)",
    'color.icon.subtle': "var(--ds-icon-subtle, #505258)"
};
var $1afeb7d9666d3b79$export$b5f31a7e431d2eab = {
    '1': 1,
    card: 100,
    navigation: 200,
    dialog: 300,
    layer: 400,
    blanket: 500,
    modal: 510,
    flag: 600,
    spotlight: 700,
    tooltip: 800
};
var $1afeb7d9666d3b79$export$e1b83c5210c471b8 = {
    'border.width': "var(--ds-border-width, 1px)",
    'border.width.selected': "var(--ds-border-width-selected, 2px)",
    'border.width.focused': "var(--ds-border-width-focused, 2px)"
};
var $1afeb7d9666d3b79$export$3c0a6c3e64bb180d = {
    'radius.xsmall': "var(--ds-radius-xsmall, 2px)",
    'radius.small': "var(--ds-radius-small, 3px)",
    'radius.medium': "var(--ds-radius-medium, 6px)",
    'radius.large': "var(--ds-radius-large, 8px)",
    'radius.xlarge': "var(--ds-radius-xlarge, 12px)",
    'radius.xxlarge': "var(--ds-radius-xxlarge, 16px)",
    'radius.full': "var(--ds-radius-full, 9999px)",
    'radius.tile': "var(--ds-radius-tile, 25%)"
};
var $1afeb7d9666d3b79$export$6ffa317d5e70375 = {
    'font.body': "var(--ds-font-body, normal 400 14px/20px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.body.large': "var(--ds-font-body-large, normal 400 16px/24px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.body.small': "var(--ds-font-body-small, normal 400 12px/16px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.code': "var(--ds-font-code, normal 400 0.875em/1 \"Atlassian Mono\", ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)",
    'font.heading.large': "var(--ds-font-heading-large, normal 653 24px/28px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.heading.medium': "var(--ds-font-heading-medium, normal 653 20px/24px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.heading.small': "var(--ds-font-heading-small, normal 653 16px/20px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.heading.xlarge': "var(--ds-font-heading-xlarge, normal 653 28px/32px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.heading.xsmall': "var(--ds-font-heading-xsmall, normal 653 14px/20px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.heading.xxlarge': "var(--ds-font-heading-xxlarge, normal 653 32px/36px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.heading.xxsmall': "var(--ds-font-heading-xxsmall, normal 653 12px/16px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.metric.large': "var(--ds-font-metric-large, normal 653 28px/32px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.metric.medium': "var(--ds-font-metric-medium, normal 653 24px/28px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.metric.small': "var(--ds-font-metric-small, normal 653 16px/20px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
};
var $1afeb7d9666d3b79$export$303e322c6b1ed114 = {
    'font.weight.bold': "var(--ds-font-weight-bold, 653)",
    'font.weight.medium': "var(--ds-font-weight-medium, 500)",
    'font.weight.regular': "var(--ds-font-weight-regular, 400)",
    'font.weight.semibold': "var(--ds-font-weight-semibold, 600)"
};
var $1afeb7d9666d3b79$export$3c7e9587132614b4 = {
    'font.family.body': "var(--ds-font-family-body, \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.family.brand.body': "var(--ds-font-family-brand-body, \"Charlie Text\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.family.brand.heading': "var(--ds-font-family-brand-heading, \"Charlie Display\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.family.code': "var(--ds-font-family-code, \"Atlassian Mono\", ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)",
    'font.family.heading': "var(--ds-font-family-heading, \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
};
var $1afeb7d9666d3b79$export$236bfe3a33ef1292 = {
    medium: "var(--ds-font-body, normal 400 14px/20px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    large: "var(--ds-font-body-large, normal 400 16px/24px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    small: "var(--ds-font-body-small, normal 400 12px/16px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
};
var $1afeb7d9666d3b79$export$855cfd311192d666 = {
    bold: "var(--ds-font-weight-bold, 653)",
    medium: "var(--ds-font-weight-medium, 500)",
    regular: "var(--ds-font-weight-regular, 400)",
    semibold: "var(--ds-font-weight-semibold, 600)"
};
var $1afeb7d9666d3b79$export$b805719bc8cb376 = {
    large: "var(--ds-font-metric-large, normal 653 28px/32px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    medium: "var(--ds-font-metric-medium, normal 653 24px/28px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    small: "var(--ds-font-metric-small, normal 653 16px/20px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
};
/**
 * @codegenEnd
 */ // Margin needs some bespoke types: https://atlassian.slack.com/archives/CKRHB23K8/p1712623192772909
/**
 * Token functions are currently allowed for borderRadius in xcss to ease migration.
 * Because 'radius.small' defaults to 3px, we need a mechanism to allow for 4px values to be provided:
 * This is done by calling the token function - token('radius.small')
 *
 * TODO: Remove once shape them is rolled out and fg platform-dst-shape-theme-default removed
 */ // Generate maps for Box props. backgroundColor, padding, etc
var $1afeb7d9666d3b79$var$spacingProperties = [
    // Used by Box
    'padding',
    'paddingBlock',
    'paddingBlockStart',
    'paddingBlockEnd',
    'paddingInline',
    'paddingInlineStart',
    'paddingInlineEnd',
    // Used by Inline and Stack
    'gap',
    'rowGap',
    'columnGap'
];
var $1afeb7d9666d3b79$export$ca0f9c2de39ffed7 = function getSerializedStylesMap(cssProperty, tokenMap) {
    return Object.keys(tokenMap).reduce(function(emotionSpacingMap, token) {
        // eslint-disable-next-line @repo/internal/styles/no-exported-styles
        emotionSpacingMap[token] = (0, $74Zh5.css)((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, cssProperty, tokenMap[token]));
        return emotionSpacingMap;
    }, {});
};
var $1afeb7d9666d3b79$export$e615f061ca585a6c = $1afeb7d9666d3b79$var$spacingProperties.reduce(function(styleMap, spacingProperty) {
    styleMap[spacingProperty] = $1afeb7d9666d3b79$export$ca0f9c2de39ffed7(spacingProperty, $1afeb7d9666d3b79$export$958d0ae7f2977ae4);
    return styleMap;
}, {});
var $1afeb7d9666d3b79$export$bf46c3f9eeafc71f = $1afeb7d9666d3b79$var$spacingProperties.reduce(function(styleMap, spacingProperty) {
    styleMap[spacingProperty] = $1afeb7d9666d3b79$export$ca0f9c2de39ffed7(spacingProperty, $1afeb7d9666d3b79$export$958d0ae7f2977ae4);
    return styleMap;
}, {});
var $1afeb7d9666d3b79$export$e7af83bafe7f9e63 = $1afeb7d9666d3b79$export$ca0f9c2de39ffed7('backgroundColor', $1afeb7d9666d3b79$export$d1d79bf68ac056bd);
var $1afeb7d9666d3b79$export$3a1bcba60b23d7f0 = $1afeb7d9666d3b79$export$ca0f9c2de39ffed7('color', $1afeb7d9666d3b79$export$8473307aa00d6ea1);
var $1afeb7d9666d3b79$export$45f3f4fe16f9f7d5 = $1afeb7d9666d3b79$export$ca0f9c2de39ffed7('fontWeight', $1afeb7d9666d3b79$export$303e322c6b1ed114);
var $1afeb7d9666d3b79$export$68cc305da27dbaa4 = $1afeb7d9666d3b79$export$ca0f9c2de39ffed7('fontFamily', $1afeb7d9666d3b79$export$3c7e9587132614b4);
var $1afeb7d9666d3b79$export$128f10c238242f83 = $1afeb7d9666d3b79$export$ca0f9c2de39ffed7('font', $1afeb7d9666d3b79$export$6ffa317d5e70375);
var $1afeb7d9666d3b79$export$219d364c0da35ae4 = $1afeb7d9666d3b79$export$ca0f9c2de39ffed7('font', $1afeb7d9666d3b79$export$236bfe3a33ef1292);
var $1afeb7d9666d3b79$export$38845ca010b93505 = $1afeb7d9666d3b79$export$ca0f9c2de39ffed7('fontWeight', $1afeb7d9666d3b79$export$855cfd311192d666);
var $1afeb7d9666d3b79$export$ff257d957d48c421 = $1afeb7d9666d3b79$export$ca0f9c2de39ffed7((0, $4fbdb2750b216b85$export$9d7b58831ae93caa), $1afeb7d9666d3b79$export$41a358c9c2356760);
var $1afeb7d9666d3b79$export$5e65a44e5b6ecadb = function isSurfaceColorToken(color) {
    return $1afeb7d9666d3b79$export$41a358c9c2356760[color] !== undefined;
};
var $1afeb7d9666d3b79$export$7001ce64d9ff7c7f = $1afeb7d9666d3b79$export$ca0f9c2de39ffed7('font', $1afeb7d9666d3b79$export$b805719bc8cb376);



var $fC8ib = parcelRequire("fC8ib");

var $25nEq = parcelRequire("25nEq");

var $iYJcE = parcelRequire("iYJcE");

var $ekGgq = parcelRequire("ekGgq");

var $74Zh5 = parcelRequire("74Zh5");


var $3ZMUU = parcelRequire("3ZMUU");
function $e6f5269886c36f76$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $e6f5269886c36f76$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $e6f5269886c36f76$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $e6f5269886c36f76$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $e6f5269886c36f76$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $e6f5269886c36f76$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
var $e6f5269886c36f76$export$9a199fbafee0014e = {
    backgroundColor: (0, $1afeb7d9666d3b79$export$d1d79bf68ac056bd),
    blockSize: (0, $1afeb7d9666d3b79$export$6ccdbebca2ee545f),
    borderBlockColor: (0, $1afeb7d9666d3b79$export$1531ad5bb3fbedac),
    borderBlockEndColor: (0, $1afeb7d9666d3b79$export$1531ad5bb3fbedac),
    borderBlockEndWidth: (0, $1afeb7d9666d3b79$export$e1b83c5210c471b8),
    borderBlockStartColor: (0, $1afeb7d9666d3b79$export$1531ad5bb3fbedac),
    borderBlockStartWidth: (0, $1afeb7d9666d3b79$export$e1b83c5210c471b8),
    borderBlockWidth: (0, $1afeb7d9666d3b79$export$e1b83c5210c471b8),
    borderBottomColor: (0, $1afeb7d9666d3b79$export$1531ad5bb3fbedac),
    borderBottomLeftRadius: (0, $1afeb7d9666d3b79$export$3c0a6c3e64bb180d),
    borderBottomRightRadius: (0, $1afeb7d9666d3b79$export$3c0a6c3e64bb180d),
    borderBottomWidth: (0, $1afeb7d9666d3b79$export$e1b83c5210c471b8),
    borderColor: (0, $1afeb7d9666d3b79$export$1531ad5bb3fbedac),
    borderEndEndRadius: (0, $1afeb7d9666d3b79$export$3c0a6c3e64bb180d),
    borderEndStartRadius: (0, $1afeb7d9666d3b79$export$3c0a6c3e64bb180d),
    borderInlineColor: (0, $1afeb7d9666d3b79$export$1531ad5bb3fbedac),
    borderInlineEndColor: (0, $1afeb7d9666d3b79$export$1531ad5bb3fbedac),
    borderInlineEndWidth: (0, $1afeb7d9666d3b79$export$e1b83c5210c471b8),
    borderInlineStartColor: (0, $1afeb7d9666d3b79$export$1531ad5bb3fbedac),
    borderInlineStartWidth: (0, $1afeb7d9666d3b79$export$e1b83c5210c471b8),
    borderInlineWidth: (0, $1afeb7d9666d3b79$export$e1b83c5210c471b8),
    borderLeftColor: (0, $1afeb7d9666d3b79$export$1531ad5bb3fbedac),
    borderLeftWidth: (0, $1afeb7d9666d3b79$export$e1b83c5210c471b8),
    borderRadius: (0, $1afeb7d9666d3b79$export$3c0a6c3e64bb180d),
    borderRightColor: (0, $1afeb7d9666d3b79$export$1531ad5bb3fbedac),
    borderRightWidth: (0, $1afeb7d9666d3b79$export$e1b83c5210c471b8),
    borderStartEndRadius: (0, $1afeb7d9666d3b79$export$3c0a6c3e64bb180d),
    borderStartStartRadius: (0, $1afeb7d9666d3b79$export$3c0a6c3e64bb180d),
    borderTopColor: (0, $1afeb7d9666d3b79$export$1531ad5bb3fbedac),
    borderTopLeftRadius: (0, $1afeb7d9666d3b79$export$3c0a6c3e64bb180d),
    borderTopRightRadius: (0, $1afeb7d9666d3b79$export$3c0a6c3e64bb180d),
    borderTopWidth: (0, $1afeb7d9666d3b79$export$e1b83c5210c471b8),
    borderWidth: (0, $1afeb7d9666d3b79$export$e1b83c5210c471b8),
    bottom: (0, $1afeb7d9666d3b79$export$632685d741f3dbbf),
    boxShadow: (0, $1afeb7d9666d3b79$export$7aff6e7ba39bb774),
    color: (0, $1afeb7d9666d3b79$export$8473307aa00d6ea1),
    columnGap: (0, $1afeb7d9666d3b79$export$958d0ae7f2977ae4),
    font: (0, $1afeb7d9666d3b79$export$6ffa317d5e70375),
    fontFamily: (0, $1afeb7d9666d3b79$export$3c7e9587132614b4),
    fontWeight: (0, $1afeb7d9666d3b79$export$303e322c6b1ed114),
    gap: (0, $1afeb7d9666d3b79$export$958d0ae7f2977ae4),
    height: (0, $1afeb7d9666d3b79$export$6ccdbebca2ee545f),
    inlineSize: (0, $1afeb7d9666d3b79$export$6ccdbebca2ee545f),
    inset: (0, $1afeb7d9666d3b79$export$632685d741f3dbbf),
    insetBlock: (0, $1afeb7d9666d3b79$export$632685d741f3dbbf),
    insetBlockEnd: (0, $1afeb7d9666d3b79$export$632685d741f3dbbf),
    insetBlockStart: (0, $1afeb7d9666d3b79$export$632685d741f3dbbf),
    insetInline: (0, $1afeb7d9666d3b79$export$632685d741f3dbbf),
    insetInlineEnd: (0, $1afeb7d9666d3b79$export$632685d741f3dbbf),
    insetInlineStart: (0, $1afeb7d9666d3b79$export$632685d741f3dbbf),
    left: (0, $1afeb7d9666d3b79$export$632685d741f3dbbf),
    margin: (0, $1afeb7d9666d3b79$export$632685d741f3dbbf),
    marginBlock: (0, $1afeb7d9666d3b79$export$632685d741f3dbbf),
    marginBlockEnd: (0, $1afeb7d9666d3b79$export$632685d741f3dbbf),
    marginBlockStart: (0, $1afeb7d9666d3b79$export$632685d741f3dbbf),
    marginBottom: (0, $1afeb7d9666d3b79$export$632685d741f3dbbf),
    marginInline: (0, $1afeb7d9666d3b79$export$632685d741f3dbbf),
    marginInlineEnd: (0, $1afeb7d9666d3b79$export$632685d741f3dbbf),
    marginInlineStart: (0, $1afeb7d9666d3b79$export$632685d741f3dbbf),
    marginLeft: (0, $1afeb7d9666d3b79$export$632685d741f3dbbf),
    marginRight: (0, $1afeb7d9666d3b79$export$632685d741f3dbbf),
    marginTop: (0, $1afeb7d9666d3b79$export$632685d741f3dbbf),
    maxBlockSize: (0, $1afeb7d9666d3b79$export$6ccdbebca2ee545f),
    maxHeight: (0, $1afeb7d9666d3b79$export$6ccdbebca2ee545f),
    maxInlineSize: (0, $1afeb7d9666d3b79$export$6ccdbebca2ee545f),
    maxWidth: (0, $1afeb7d9666d3b79$export$6ccdbebca2ee545f),
    minBlockSize: (0, $1afeb7d9666d3b79$export$6ccdbebca2ee545f),
    minHeight: (0, $1afeb7d9666d3b79$export$6ccdbebca2ee545f),
    minInlineSize: (0, $1afeb7d9666d3b79$export$6ccdbebca2ee545f),
    minWidth: (0, $1afeb7d9666d3b79$export$6ccdbebca2ee545f),
    opacity: (0, $1afeb7d9666d3b79$export$daf94a976c798b4f),
    outlineColor: (0, $1afeb7d9666d3b79$export$1531ad5bb3fbedac),
    outlineOffset: (0, $1afeb7d9666d3b79$export$632685d741f3dbbf),
    outlineWidth: (0, $1afeb7d9666d3b79$export$e1b83c5210c471b8),
    padding: (0, $1afeb7d9666d3b79$export$958d0ae7f2977ae4),
    paddingBlock: (0, $1afeb7d9666d3b79$export$958d0ae7f2977ae4),
    paddingBlockEnd: (0, $1afeb7d9666d3b79$export$958d0ae7f2977ae4),
    paddingBlockStart: (0, $1afeb7d9666d3b79$export$958d0ae7f2977ae4),
    paddingBottom: (0, $1afeb7d9666d3b79$export$958d0ae7f2977ae4),
    paddingInline: (0, $1afeb7d9666d3b79$export$958d0ae7f2977ae4),
    paddingInlineEnd: (0, $1afeb7d9666d3b79$export$958d0ae7f2977ae4),
    paddingInlineStart: (0, $1afeb7d9666d3b79$export$958d0ae7f2977ae4),
    paddingLeft: (0, $1afeb7d9666d3b79$export$958d0ae7f2977ae4),
    paddingRight: (0, $1afeb7d9666d3b79$export$958d0ae7f2977ae4),
    paddingTop: (0, $1afeb7d9666d3b79$export$958d0ae7f2977ae4),
    right: (0, $1afeb7d9666d3b79$export$632685d741f3dbbf),
    rowGap: (0, $1afeb7d9666d3b79$export$958d0ae7f2977ae4),
    top: (0, $1afeb7d9666d3b79$export$632685d741f3dbbf),
    width: (0, $1afeb7d9666d3b79$export$6ccdbebca2ee545f),
    zIndex: (0, $1afeb7d9666d3b79$export$b5f31a7e431d2eab)
};
var $e6f5269886c36f76$var$uniqueSymbol = Symbol('UNSAFE_INTERNAL_styles');
var $e6f5269886c36f76$var$isSafeEnvToThrow = function isSafeEnvToThrow() {
    return (typeof $3ZMUU === "undefined" ? "undefined" : (0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))($3ZMUU)) === 'object' && (0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))($3ZMUU.env) === 'object' && false;
};
var $e6f5269886c36f76$var$reNestedSelectors = /(\.|\s|&+|\*\>|#|\[.*\])/;
var $e6f5269886c36f76$var$safeSelectors = /^@media .*$|^::?.*$|^@supports .*$/;
var $e6f5269886c36f76$var$_transformStyles = function transformStyles(styleObj) {
    if (!styleObj || (0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(styleObj) !== 'object') return styleObj;
    // If styles are defined as a CSSObject[], recursively call on each element until we reach CSSObject
    if (Array.isArray(styleObj)) return styleObj.map($e6f5269886c36f76$var$_transformStyles);
    // Modifies styleObj in place. Be careful.
    Object.entries(styleObj).forEach(function(_ref) {
        var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_ref, 2), key = _ref2[0], value = _ref2[1];
        // If key is a pseudo class or a pseudo element, then value should be an object.
        // So, call transformStyles on the value
        if ((0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(value) === 'object' && $e6f5269886c36f76$var$safeSelectors.test(key)) {
            styleObj[key] = $e6f5269886c36f76$var$_transformStyles(value);
            return;
        }
        if ($e6f5269886c36f76$var$isSafeEnvToThrow()) {
            // We don't support `.class`, `[data-testid]`, `> *`, `#some-id`
            if ($e6f5269886c36f76$var$reNestedSelectors.test(key)) throw new Error("Styles not supported for key '".concat(key, "'."));
        }
        // We have now dealt with all the special cases, so,
        // check whether what remains is a style property
        // that can be transformed.
        if (!(key in $e6f5269886c36f76$export$9a199fbafee0014e)) return;
        var tokenValue = $e6f5269886c36f76$export$9a199fbafee0014e[key][value];
        styleObj[key] = tokenValue !== null && tokenValue !== void 0 ? tokenValue : value;
    });
    return styleObj;
};
var $e6f5269886c36f76$var$baseXcss = function baseXcss(style) {
    var transformedStyles = $e6f5269886c36f76$var$_transformStyles(style);
    return (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, $e6f5269886c36f76$var$uniqueSymbol, (0, $74Zh5.css)(transformedStyles));
};
/**
 * Picks out runtime XCSS objects and build-time XCSS strings. This is needed
 * to supported both Emotion and Compiled styles until we've fully migrated
 * to Compiled.
 *
 * @private
 * @deprecated
 */ // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
var $e6f5269886c36f76$export$a9c84988c8f81f2d = function parseXcss(args) {
    if (Array.isArray(args)) {
        var emotion = [];
        var staticArr = [];
        var _iterator = $e6f5269886c36f76$var$_createForOfIteratorHelper(args), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var arg = _step.value;
                var result = $e6f5269886c36f76$export$a9c84988c8f81f2d(arg);
                if (result.emotion) emotion.push.apply(emotion, (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(result.emotion));
                if (result.static) staticArr.push(result.static);
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
        return {
            emotion: emotion,
            static: staticArr.join(' ')
        };
    }
    var objArgs = args;
    var _ref4 = objArgs || {}, styles = _ref4[$e6f5269886c36f76$var$uniqueSymbol];
    if (styles) return {
        emotion: [
            styles
        ]
    };
    if (args) {
        // We use string interpolation here instead of .toString() just
        // in case the resulting object doesn't have the method available.
        var stringifiedArgs = "".concat(args);
        if (stringifiedArgs) return {
            static: stringifiedArgs
        };
    }
    return {};
};
function $e6f5269886c36f76$export$f6c783d06584602c(style) {
    return $e6f5269886c36f76$var$baseXcss(style);
}


var $0b31dd7ea89addbb$var$_excluded = [
    "children",
    "backgroundColor",
    "padding",
    "paddingBlock",
    "paddingBlockStart",
    "paddingBlockEnd",
    "paddingInline",
    "paddingInlineStart",
    "paddingInlineEnd",
    "isDisabled",
    "type",
    "onClick",
    "interactionName",
    "componentName",
    "analyticsContext",
    "style",
    "testId",
    "xcss"
], $0b31dd7ea89addbb$var$_excluded2 = [
    "className"
];
// This duplicates FocusRing styles from `@atlaskit/focus-ring`.
var $0b31dd7ea89addbb$var$focusRingStyles = (0, $74Zh5.css)({
    '&:focus, &:focus-visible': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        outlineColor: (0, $1afeb7d9666d3b79$export$1531ad5bb3fbedac)['color.border.focused'],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        outlineOffset: (0, $1afeb7d9666d3b79$export$958d0ae7f2977ae4)['space.025'],
        outlineStyle: 'solid',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        outlineWidth: (0, $1afeb7d9666d3b79$export$e1b83c5210c471b8)['border.width.focused']
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
    '&:focus:not(:focus-visible)': {
        outline: 'none'
    },
    '@media screen and (forced-colors: active), screen and (-ms-high-contrast: active)': {
        '&:focus-visible': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
            outline: "".concat((0, $1afeb7d9666d3b79$export$e1b83c5210c471b8)['border.width'], " solid")
        }
    }
});
var $0b31dd7ea89addbb$var$baseStyles = (0, $74Zh5.css)({
    boxSizing: 'border-box',
    appearance: 'none',
    border: 'none'
});
var $0b31dd7ea89addbb$var$enabledStyles = (0, $74Zh5.css)({
    cursor: 'pointer'
});
var $0b31dd7ea89addbb$var$disabledStyles = (0, $74Zh5.css)({
    cursor: 'not-allowed'
});
/**
 * __Pressable__
 *
 * A primitive for building custom buttons.
 *
 * - [Examples](https://atlassian.design/components/primitives/pressable/examples)
 * - [Code](https://atlassian.design/components/primitives/pressable/code)
 * - [Usage](https://atlassian.design/components/primitives/pressable/usage)
 */ var $0b31dd7ea89addbb$var$Pressable = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function(_ref, ref) {
    var children = _ref.children, backgroundColor = _ref.backgroundColor, padding = _ref.padding, paddingBlock = _ref.paddingBlock, paddingBlockStart = _ref.paddingBlockStart, paddingBlockEnd = _ref.paddingBlockEnd, paddingInline = _ref.paddingInline, paddingInlineStart = _ref.paddingInlineStart, paddingInlineEnd = _ref.paddingInlineEnd, isDisabled = _ref.isDisabled, _ref$type = _ref.type, type = _ref$type === void 0 ? 'button' : _ref$type, _ref$onClick = _ref.onClick, providedOnClick = _ref$onClick === void 0 ? (0, $9954455cbc1a9a72$export$2e2bcd8739ae039) : _ref$onClick, interactionName = _ref.interactionName, componentName = _ref.componentName, analyticsContext = _ref.analyticsContext, style = _ref.style, testId = _ref.testId, xcss = _ref.xcss, htmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $0b31dd7ea89addbb$var$_excluded);
    var interactionContext = (0, $5FkrB.useContext)((0, $0a1e917c68969d41$export$2e2bcd8739ae039));
    var handleClick = (0, $5FkrB.useCallback)(function(e, analyticsEvent) {
        interactionContext && interactionContext.tracePress(interactionName, e.timeStamp);
        providedOnClick(e, analyticsEvent);
    }, [
        providedOnClick,
        interactionContext,
        interactionName
    ]);
    var onClick = (0, $a251a03642d304a8$export$a4687b0234b40e28)({
        fn: handleClick,
        action: 'clicked',
        componentName: componentName || 'Pressable',
        packageName: "@atlaskit/primitives",
        packageVersion: "20.2.0",
        analyticsData: analyticsContext,
        actionSubject: 'button'
    });
    // This is to remove className from safeHtmlAttributes
    // @ts-expect-error className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(htmlAttributes, $0b31dd7ea89addbb$var$_excluded2);
    var resolvedStyles = (0, $e6f5269886c36f76$export$a9c84988c8f81f2d)(xcss);
    return (0, $74Zh5.jsx)("button", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        style: style,
        ref: ref,
        className: resolvedStyles.static
    }, safeHtmlAttributes, {
        // eslint-disable-next-line react/button-has-type
        type: type,
        onClick: onClick,
        disabled: isDisabled,
        css: [
            $0b31dd7ea89addbb$var$baseStyles,
            $0b31dd7ea89addbb$var$focusRingStyles,
            isDisabled ? $0b31dd7ea89addbb$var$disabledStyles : $0b31dd7ea89addbb$var$enabledStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            backgroundColor && (0, $1afeb7d9666d3b79$export$e7af83bafe7f9e63)[backgroundColor],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            padding && (0, $1afeb7d9666d3b79$export$e615f061ca585a6c).padding[padding],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlock && (0, $1afeb7d9666d3b79$export$e615f061ca585a6c).paddingBlock[paddingBlock],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlockStart && (0, $1afeb7d9666d3b79$export$e615f061ca585a6c).paddingBlockStart[paddingBlockStart],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlockEnd && (0, $1afeb7d9666d3b79$export$e615f061ca585a6c).paddingBlockEnd[paddingBlockEnd],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInline && (0, $1afeb7d9666d3b79$export$e615f061ca585a6c).paddingInline[paddingInline],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInlineStart && (0, $1afeb7d9666d3b79$export$e615f061ca585a6c).paddingInlineStart[paddingInlineStart],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInlineEnd && (0, $1afeb7d9666d3b79$export$e615f061ca585a6c).paddingInlineEnd[paddingInlineEnd]
        ].concat((0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(resolvedStyles.emotion || [])),
        "data-testid": testId
    }), children);
});
var $0b31dd7ea89addbb$export$2e2bcd8739ae039 = $0b31dd7ea89addbb$var$Pressable;


/* spinner.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $jHdWv = parcelRequire("jHdWv");

var $5FkrB = parcelRequire("5FkrB");

var $f1b87b9a6b3142e2$export$4e9f1640bbe7a1a8 = {
    xsmall: 12,
    small: 16,
    medium: 24,
    large: 48,
    xlarge: 96
};


/**
 * Returns the appropriate circle stroke color.
 */ function $162f5989c6e6ed5b$var$getStrokeColor(appearance) {
    return appearance === 'inherit' ? "var(--ds-icon-subtle, #505258)" : "var(--ds-icon-inverse, #FFFFFF)";
}
var $162f5989c6e6ed5b$var$rotate = null;
/**
 * There are three parts to the load in animation:
 * 1. Accelerated spin
 * 2. Stretch the spinner line
 */ var $162f5989c6e6ed5b$var$loadIn = null;
var $162f5989c6e6ed5b$var$styles = {
    rotateStyles: "_j7hqsf8s _5sag12kz _tip812c5 _1pgl2qsq _8hrz1h6o",
    loadInStyles: "_j7hq1ky6 _5sag9cwz _1pgl1ytf _1o51q7pw",
    wrapperStyles: "_1e0c116y _s7n4nkob",
    circleStyles: "_lswuglyw _7ljx1dhp _1snbbs82 _jcxd7g3v _1tjm1onz"
};
/**
 * `useLayoutEffect` is being used in SSR safe form. On the server, this work doesn’t need to run.
 * `useEffect` is used in-place, because `useEffect` is not run on the server and it matches types
 * which makes things simpler than doing an `isServer` check or a `null` check.
 *
 * @see https://hello.atlassian.net/wiki/spaces/DST/pages/2081696628/DSTDACI-010+-+Interaction+Tracing+hooks+in+DS+components
 */ var $162f5989c6e6ed5b$var$useLayoutEffect = typeof window === 'undefined' ? (0, $5FkrB.useEffect) : (0, $5FkrB.useLayoutEffect);
/**
 * __Spinner__
 *
 * A spinner is an animated spinning icon that lets users know content is being loaded.
 *
 * - [Examples](https://atlassian.design/components/spinner/examples)
 * - [Code](https://atlassian.design/components/spinner/code)
 * - [Usage](https://atlassian.design/components/spinner/usage)
 */ var $162f5989c6e6ed5b$var$Spinner = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).forwardRef(function Spinner(_ref, ref) {
    var _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'inherit' : _ref$appearance, _ref$delay = _ref.delay, delay = _ref$delay === void 0 ? 0 : _ref$delay, interactionName = _ref.interactionName, label = _ref.label, _ref$size = _ref.size, providedSize = _ref$size === void 0 ? 'medium' : _ref$size, testId = _ref.testId;
    var size = typeof providedSize === 'number' ? providedSize : (0, $f1b87b9a6b3142e2$export$4e9f1640bbe7a1a8)[providedSize];
    var animationDelay = "".concat(delay, "ms");
    var stroke = $162f5989c6e6ed5b$var$getStrokeColor(appearance);
    var context = (0, $5FkrB.useContext)((0, $0a1e917c68969d41$export$2e2bcd8739ae039));
    $162f5989c6e6ed5b$var$useLayoutEffect(function() {
        if (context != null) return context.hold(interactionName);
    }, [
        context,
        interactionName
    ]);
    /**
   * The Spinner animation uses a combination of two
   * css animations on two separate elements.
   */ return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("span", {
        "data-testid": testId ? "".concat(testId, "-wrapper") : 'spinner-wrapper',
        style: {
            animationDelay: animationDelay,
            width: size,
            height: size
        },
        className: (0, $jHdWv.default)([
            $162f5989c6e6ed5b$var$styles.wrapperStyles,
            $162f5989c6e6ed5b$var$styles.rotateStyles
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("svg", {
        height: size,
        width: size,
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg",
        "data-testid": testId,
        ref: ref,
        "aria-label": label || undefined,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            animationDelay: animationDelay
        },
        role: label ? 'img' : 'none',
        className: (0, $jHdWv.default)([
            $162f5989c6e6ed5b$var$styles.loadInStyles
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("circle", {
        cx: "8",
        cy: "8",
        r: "7",
        style: {
            stroke: stroke
        },
        className: (0, $jHdWv.default)([
            $162f5989c6e6ed5b$var$styles.circleStyles
        ])
    })));
}));
var $162f5989c6e6ed5b$export$2e2bcd8739ae039 = $162f5989c6e6ed5b$var$Spinner;


// extract the category and key from the resolved color
var $9c9175041946e684$export$a3fc04b8551e006a = function getThemeStyles(resolvedColor) {
    var isAccent = resolvedColor.startsWith('accent-');
    var category = isAccent ? 'accent' : 'semantic';
    var key = isAccent ? resolvedColor.replace('accent-', '') : resolvedColor;
    return {
        category: category,
        key: key
    };
};


/* icon-renderer.tsx generated by @compiled/babel-plugin v0.39.1 */ 

var $5FkrB = parcelRequire("5FkrB");

/* box.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $kqp0i = parcelRequire("kqp0i");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");

var $jHdWv = parcelRequire("jHdWv");

var $587f3da6c324a0f0$var$_excluded = [
    "as",
    "children",
    "backgroundColor",
    "padding",
    "paddingBlock",
    "paddingBlockStart",
    "paddingBlockEnd",
    "paddingInline",
    "paddingInlineStart",
    "paddingInlineEnd",
    "style",
    "testId",
    "xcss"
], $587f3da6c324a0f0$var$_excluded2 = [
    "className"
];
// Can either Exclude or Extract - here we're excluding all SVG-related elements, <button> elements (handled by Pressable), and <a> elements (handled by Anchor)
// Basically just ElementType but without ComponentType, it makes sense to keep the "Type" suffix
// eslint-disable-next-line @repo/internal/react/consistent-types-definitions
var $587f3da6c324a0f0$var$baseStyles = null;
var $587f3da6c324a0f0$var$backgroundColorMap = {
    'color.background.accent.lime.subtlest': "_bfhkm890",
    'color.background.accent.lime.subtlest.hovered': "_bfhkd4y8",
    'color.background.accent.lime.subtlest.pressed': "_bfhkkuup",
    'color.background.accent.lime.subtler': "_bfhkz2ec",
    'color.background.accent.lime.subtler.hovered': "_bfhk1gf0",
    'color.background.accent.lime.subtler.pressed': "_bfhk2kxc",
    'color.background.accent.lime.subtle': "_bfhkbq5w",
    'color.background.accent.lime.subtle.hovered': "_bfhkfoww",
    'color.background.accent.lime.subtle.pressed': "_bfhk1jbd",
    'color.background.accent.lime.bolder': "_bfhktde4",
    'color.background.accent.lime.bolder.hovered': "_bfhknzpa",
    'color.background.accent.lime.bolder.pressed': "_bfhkh0j0",
    'color.background.accent.red.subtlest': "_bfhk1vk5",
    'color.background.accent.red.subtlest.hovered': "_bfhk1i6i",
    'color.background.accent.red.subtlest.pressed': "_bfhknbir",
    'color.background.accent.red.subtler': "_bfhk1rtt",
    'color.background.accent.red.subtler.hovered': "_bfhkaffd",
    'color.background.accent.red.subtler.pressed': "_bfhk1j5a",
    'color.background.accent.red.subtle': "_bfhkkrt9",
    'color.background.accent.red.subtle.hovered': "_bfhk1sou",
    'color.background.accent.red.subtle.pressed': "_bfhk1fnn",
    'color.background.accent.red.bolder': "_bfhkuibq",
    'color.background.accent.red.bolder.hovered': "_bfhk100f",
    'color.background.accent.red.bolder.pressed': "_bfhk1cl6",
    'color.background.accent.orange.subtlest': "_bfhkf5uh",
    'color.background.accent.orange.subtlest.hovered': "_bfhk19yr",
    'color.background.accent.orange.subtlest.pressed': "_bfhkf90x",
    'color.background.accent.orange.subtler': "_bfhk165s",
    'color.background.accent.orange.subtler.hovered': "_bfhk1ei0",
    'color.background.accent.orange.subtler.pressed': "_bfhkdpo3",
    'color.background.accent.orange.subtle': "_bfhk1kkj",
    'color.background.accent.orange.subtle.hovered': "_bfhk9mfs",
    'color.background.accent.orange.subtle.pressed': "_bfhkaxpp",
    'color.background.accent.orange.bolder': "_bfhk1qg1",
    'color.background.accent.orange.bolder.hovered': "_bfhk12qo",
    'color.background.accent.orange.bolder.pressed': "_bfhk1fyq",
    'color.background.accent.yellow.subtlest': "_bfhkibhp",
    'color.background.accent.yellow.subtlest.hovered': "_bfhkaetg",
    'color.background.accent.yellow.subtlest.pressed': "_bfhk1o1l",
    'color.background.accent.yellow.subtler': "_bfhk1773",
    'color.background.accent.yellow.subtler.hovered': "_bfhk1uw7",
    'color.background.accent.yellow.subtler.pressed': "_bfhk1r9w",
    'color.background.accent.yellow.subtle': "_bfhk8y3s",
    'color.background.accent.yellow.subtle.hovered': "_bfhk819w",
    'color.background.accent.yellow.subtle.pressed': "_bfhk1jx0",
    'color.background.accent.yellow.bolder': "_bfhk1vop",
    'color.background.accent.yellow.bolder.hovered': "_bfhkkjqf",
    'color.background.accent.yellow.bolder.pressed': "_bfhk1okt",
    'color.background.accent.green.subtlest': "_bfhkn729",
    'color.background.accent.green.subtlest.hovered': "_bfhk3utz",
    'color.background.accent.green.subtlest.pressed': "_bfhkyfny",
    'color.background.accent.green.subtler': "_bfhk1wnw",
    'color.background.accent.green.subtler.hovered': "_bfhk1e2h",
    'color.background.accent.green.subtler.pressed': "_bfhkybhx",
    'color.background.accent.green.subtle': "_bfhk1rsu",
    'color.background.accent.green.subtle.hovered': "_bfhk12e3",
    'color.background.accent.green.subtle.pressed': "_bfhk1g86",
    'color.background.accent.green.bolder': "_bfhk1e5c",
    'color.background.accent.green.bolder.hovered': "_bfhka5yi",
    'color.background.accent.green.bolder.pressed': "_bfhk1j68",
    'color.background.accent.teal.subtlest': "_bfhk7xuz",
    'color.background.accent.teal.subtlest.hovered': "_bfhk108c",
    'color.background.accent.teal.subtlest.pressed': "_bfhk1cxp",
    'color.background.accent.teal.subtler': "_bfhk1a17",
    'color.background.accent.teal.subtler.hovered': "_bfhkkwwr",
    'color.background.accent.teal.subtler.pressed': "_bfhk1jb0",
    'color.background.accent.teal.subtle': "_bfhktdv8",
    'color.background.accent.teal.subtle.hovered': "_bfhkzh8h",
    'color.background.accent.teal.subtle.pressed': "_bfhk16zl",
    'color.background.accent.teal.bolder': "_bfhk2c8p",
    'color.background.accent.teal.bolder.hovered': "_bfhkl3ve",
    'color.background.accent.teal.bolder.pressed': "_bfhktor0",
    'color.background.accent.blue.subtlest': "_bfhk1s93",
    'color.background.accent.blue.subtlest.hovered': "_bfhkdaj9",
    'color.background.accent.blue.subtlest.pressed': "_bfhkxm0g",
    'color.background.accent.blue.subtler': "_bfhk1dy8",
    'color.background.accent.blue.subtler.hovered': "_bfhk815t",
    'color.background.accent.blue.subtler.pressed': "_bfhkrwxf",
    'color.background.accent.blue.subtle': "_bfhk115i",
    'color.background.accent.blue.subtle.hovered': "_bfhk9pr4",
    'color.background.accent.blue.subtle.pressed': "_bfhknpx7",
    'color.background.accent.blue.bolder': "_bfhk16e3",
    'color.background.accent.blue.bolder.hovered': "_bfhk1vbm",
    'color.background.accent.blue.bolder.pressed': "_bfhk1xwi",
    'color.background.accent.purple.subtlest': "_bfhkp2ly",
    'color.background.accent.purple.subtlest.hovered': "_bfhkkca2",
    'color.background.accent.purple.subtlest.pressed': "_bfhk1jbm",
    'color.background.accent.purple.subtler': "_bfhk1nm4",
    'color.background.accent.purple.subtler.hovered': "_bfhkattl",
    'color.background.accent.purple.subtler.pressed': "_bfhk3nfk",
    'color.background.accent.purple.subtle': "_bfhk18ah",
    'color.background.accent.purple.subtle.hovered': "_bfhk8bp1",
    'color.background.accent.purple.subtle.pressed': "_bfhk1cd2",
    'color.background.accent.purple.bolder': "_bfhkya33",
    'color.background.accent.purple.bolder.hovered': "_bfhk1af5",
    'color.background.accent.purple.bolder.pressed': "_bfhk6cze",
    'color.background.accent.magenta.subtlest': "_bfhk8tvm",
    'color.background.accent.magenta.subtlest.hovered': "_bfhkr3zd",
    'color.background.accent.magenta.subtlest.pressed': "_bfhk1ckf",
    'color.background.accent.magenta.subtler': "_bfhkv9ra",
    'color.background.accent.magenta.subtler.hovered': "_bfhk1axx",
    'color.background.accent.magenta.subtler.pressed': "_bfhk42ri",
    'color.background.accent.magenta.subtle': "_bfhk1mi6",
    'color.background.accent.magenta.subtle.hovered': "_bfhkrwyz",
    'color.background.accent.magenta.subtle.pressed': "_bfhk6c15",
    'color.background.accent.magenta.bolder': "_bfhkc3uk",
    'color.background.accent.magenta.bolder.hovered': "_bfhk1ok8",
    'color.background.accent.magenta.bolder.pressed': "_bfhkeawv",
    'color.background.accent.gray.subtlest': "_bfhkysee",
    'color.background.accent.gray.subtlest.hovered': "_bfhkwejn",
    'color.background.accent.gray.subtlest.pressed': "_bfhk18ut",
    'color.background.accent.gray.subtler': "_bfhk7qp0",
    'color.background.accent.gray.subtler.hovered': "_bfhk10ef",
    'color.background.accent.gray.subtler.pressed': "_bfhk1rk9",
    'color.background.accent.gray.subtle': "_bfhk18j9",
    'color.background.accent.gray.subtle.hovered': "_bfhk1nv3",
    'color.background.accent.gray.subtle.pressed': "_bfhkq9tj",
    'color.background.accent.gray.bolder': "_bfhk1i45",
    'color.background.accent.gray.bolder.hovered': "_bfhkbyip",
    'color.background.accent.gray.bolder.pressed': "_bfhk1van",
    'color.background.disabled': "_bfhk187o",
    'color.background.input': "_bfhk1j9a",
    'color.background.input.hovered': "_bfhkl4ek",
    'color.background.input.pressed': "_bfhkr01l",
    'color.background.inverse.subtle': "_bfhk1vck",
    'color.background.inverse.subtle.hovered': "_bfhkmpja",
    'color.background.inverse.subtle.pressed': "_bfhk1gii",
    'color.background.neutral': "_bfhki8nm",
    'color.background.neutral.hovered': "_bfhkplhp",
    'color.background.neutral.pressed': "_bfhk1gdz",
    'color.background.neutral.subtle': "_bfhksm61",
    'color.background.neutral.subtle.hovered': "_bfhk1dpa",
    'color.background.neutral.subtle.pressed': "_bfhkfcek",
    'color.background.neutral.bold': "_bfhk1aqn",
    'color.background.neutral.bold.hovered': "_bfhk1ibz",
    'color.background.neutral.bold.pressed': "_bfhkof27",
    'color.background.selected': "_bfhk15s3",
    'color.background.selected.hovered': "_bfhkufnl",
    'color.background.selected.pressed': "_bfhknozp",
    'color.background.selected.bold': "_bfhkjmqp",
    'color.background.selected.bold.hovered': "_bfhk1q28",
    'color.background.selected.bold.pressed': "_bfhk12kk",
    'color.background.brand.subtlest': "_bfhk1gmr",
    'color.background.brand.subtlest.hovered': "_bfhk3v15",
    'color.background.brand.subtlest.pressed': "_bfhku02c",
    'color.background.brand.bold': "_bfhk1856",
    'color.background.brand.bold.hovered': "_bfhkhf2y",
    'color.background.brand.bold.pressed': "_bfhkg6ey",
    'color.background.brand.boldest': "_bfhk1o4i",
    'color.background.brand.boldest.hovered': "_bfhklefx",
    'color.background.brand.boldest.pressed': "_bfhk16k6",
    'color.background.danger': "_bfhk1gly",
    'color.background.danger.hovered': "_bfhk1yvi",
    'color.background.danger.pressed': "_bfhk1r4b",
    'color.background.danger.bold': "_bfhkybec",
    'color.background.danger.bold.hovered': "_bfhks9hg",
    'color.background.danger.bold.pressed': "_bfhk13a9",
    'color.background.warning': "_bfhk1917",
    'color.background.warning.hovered': "_bfhk19zu",
    'color.background.warning.pressed': "_bfhkzr32",
    'color.background.warning.bold': "_bfhk1kmu",
    'color.background.warning.bold.hovered': "_bfhk1spp",
    'color.background.warning.bold.pressed': "_bfhk4m4m",
    'color.background.success': "_bfhk1y9u",
    'color.background.success.hovered': "_bfhk1vfx",
    'color.background.success.pressed': "_bfhk1wl5",
    'color.background.success.bold': "_bfhkkcmj",
    'color.background.success.bold.hovered': "_bfhky7x8",
    'color.background.success.bold.pressed': "_bfhkwcbh",
    'color.background.discovery': "_bfhk6vm6",
    'color.background.discovery.hovered': "_bfhk12eq",
    'color.background.discovery.pressed': "_bfhk18vq",
    'color.background.discovery.bold': "_bfhku5tj",
    'color.background.discovery.bold.hovered': "_bfhkfqeg",
    'color.background.discovery.bold.pressed': "_bfhk1f1m",
    'color.background.information': "_bfhk19ip",
    'color.background.information.hovered': "_bfhk86z5",
    'color.background.information.pressed': "_bfhk1c1j",
    'color.background.information.bold': "_bfhkx4w0",
    'color.background.information.bold.hovered': "_bfhkq2ii",
    'color.background.information.bold.pressed': "_bfhkf89v",
    'color.blanket': "_bfhk1i5c",
    'color.blanket.selected': "_bfhk7wq0",
    'color.blanket.danger': "_bfhkrprw",
    'color.skeleton': "_bfhkizff",
    'color.skeleton.subtle': "_bfhkvkf5",
    'elevation.surface': "_bfhkvuon",
    'elevation.surface.hovered': "_bfhk19i6",
    'elevation.surface.pressed': "_bfhk13ro",
    'elevation.surface.overlay': "_bfhk1bhr",
    'elevation.surface.overlay.hovered': "_bfhk6o2t",
    'elevation.surface.overlay.pressed': "_bfhkm8nx",
    'elevation.surface.raised': "_bfhkhp5a",
    'elevation.surface.raised.hovered': "_bfhk116u",
    'elevation.surface.raised.pressed': "_bfhk14aj",
    'elevation.surface.sunken': "_bfhkhfxm",
    'utility.elevation.surface.current': "_bfhkchd4"
};
var $587f3da6c324a0f0$var$CURRENT_SURFACE_CSS_VAR = "--ds-elevation-surface-current";
var $587f3da6c324a0f0$var$setSurfaceTokenMap = {
    'elevation.surface': "_1q1lvuon",
    'elevation.surface.hovered': "_1q1l19i6",
    'elevation.surface.pressed': "_1q1l13ro",
    'elevation.surface.overlay': "_1q1l1bhr",
    'elevation.surface.overlay.hovered': "_1q1l6o2t",
    'elevation.surface.overlay.pressed': "_1q1lm8nx",
    'elevation.surface.raised': "_1q1lhp5a",
    'elevation.surface.raised.hovered': "_1q1l116u",
    'elevation.surface.raised.pressed': "_1q1l14aj",
    'elevation.surface.sunken': "_1q1lhfxm"
};
var $587f3da6c324a0f0$var$paddingBlockStartMap = {
    'space.0': "_1q51ze3t",
    'space.025': "_1q51v77o",
    'space.050': "_1q511b66",
    'space.075': "_1q5112x7",
    'space.100': "_1q51u2gc",
    'space.150': "_1q51utpp",
    'space.200': "_1q51pxbi",
    'space.250': "_1q51v47k",
    'space.300': "_1q511ejb",
    'space.400': "_1q51xy5q",
    'space.500': "_1q511jfw",
    'space.600': "_1q51oahv",
    'space.800': "_1q51xncg",
    'space.1000': "_1q511epz"
};
var $587f3da6c324a0f0$var$paddingBlockEndMap = {
    'space.0': "_85i5ze3t",
    'space.025': "_85i5v77o",
    'space.050': "_85i51b66",
    'space.075': "_85i512x7",
    'space.100': "_85i5u2gc",
    'space.150': "_85i5utpp",
    'space.200': "_85i5pxbi",
    'space.250': "_85i5v47k",
    'space.300': "_85i51ejb",
    'space.400': "_85i5xy5q",
    'space.500': "_85i51jfw",
    'space.600': "_85i5oahv",
    'space.800': "_85i5xncg",
    'space.1000': "_85i51epz"
};
var $587f3da6c324a0f0$var$paddingInlineStartMap = {
    'space.0': "_bozgze3t",
    'space.025': "_bozgv77o",
    'space.050': "_bozg1b66",
    'space.075': "_bozg12x7",
    'space.100': "_bozgu2gc",
    'space.150': "_bozgutpp",
    'space.200': "_bozgpxbi",
    'space.250': "_bozgv47k",
    'space.300': "_bozg1ejb",
    'space.400': "_bozgxy5q",
    'space.500': "_bozg1jfw",
    'space.600': "_bozgoahv",
    'space.800': "_bozgxncg",
    'space.1000': "_bozg1epz"
};
var $587f3da6c324a0f0$var$paddingInlineEndMap = {
    'space.0': "_y4tize3t",
    'space.025': "_y4tiv77o",
    'space.050': "_y4ti1b66",
    'space.075': "_y4ti12x7",
    'space.100': "_y4tiu2gc",
    'space.150': "_y4tiutpp",
    'space.200': "_y4tipxbi",
    'space.250': "_y4tiv47k",
    'space.300': "_y4ti1ejb",
    'space.400': "_y4tixy5q",
    'space.500': "_y4ti1jfw",
    'space.600': "_y4tioahv",
    'space.800': "_y4tixncg",
    'space.1000': "_y4ti1epz"
};
/**
 * __Box__
 *
 * A Box is a primitive component that has the design decisions of the Atlassian Design System baked in.
 * Renders a `div` by default.
 *
 * - [Examples](https://atlassian.design/components/primitives/box/examples)
 * - [Code](https://atlassian.design/components/primitives/box/code)
 * - [Usage](https://atlassian.design/components/primitives/box/usage)
 */ var $587f3da6c324a0f0$var$Box = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? 'div' : _ref$as, children = _ref.children, backgroundColor = _ref.backgroundColor, padding = _ref.padding, _ref$paddingBlock = _ref.paddingBlock, paddingBlock = _ref$paddingBlock === void 0 ? padding : _ref$paddingBlock, _ref$paddingBlockStar = _ref.paddingBlockStart, paddingBlockStart = _ref$paddingBlockStar === void 0 ? paddingBlock : _ref$paddingBlockStar, _ref$paddingBlockEnd = _ref.paddingBlockEnd, paddingBlockEnd = _ref$paddingBlockEnd === void 0 ? paddingBlock : _ref$paddingBlockEnd, _ref$paddingInline = _ref.paddingInline, paddingInline = _ref$paddingInline === void 0 ? padding : _ref$paddingInline, _ref$paddingInlineSta = _ref.paddingInlineStart, paddingInlineStart = _ref$paddingInlineSta === void 0 ? paddingInline : _ref$paddingInlineSta, _ref$paddingInlineEnd = _ref.paddingInlineEnd, paddingInlineEnd = _ref$paddingInlineEnd === void 0 ? paddingInline : _ref$paddingInlineEnd, style = _ref.style, testId = _ref.testId, xcss = _ref.xcss, htmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $587f3da6c324a0f0$var$_excluded);
    // This is to remove className from safeHtmlAttributes
    // @ts-ignore -- not using expect since it causes issues with help-center local consumption - className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(htmlAttributes, $587f3da6c324a0f0$var$_excluded2);
    var node = /*#__PURE__*/ $5FkrB.createElement(Component, (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        style: style,
        ref: ref,
        className: (0, $jHdWv.default)([
            "_19itglyw _vchhusvi _r06hglyw",
            backgroundColor && $587f3da6c324a0f0$var$backgroundColorMap[backgroundColor],
            backgroundColor && $587f3da6c324a0f0$var$isSurfaceToken(backgroundColor) && $587f3da6c324a0f0$var$setSurfaceTokenMap[backgroundColor],
            paddingBlockStart && $587f3da6c324a0f0$var$paddingBlockStartMap[paddingBlockStart],
            paddingBlockEnd && $587f3da6c324a0f0$var$paddingBlockEndMap[paddingBlockEnd],
            paddingInlineStart && $587f3da6c324a0f0$var$paddingInlineStartMap[paddingInlineStart],
            paddingInlineEnd && $587f3da6c324a0f0$var$paddingInlineEndMap[paddingInlineEnd],
            xcss
        ])
    }, safeHtmlAttributes, {
        "data-testid": testId
    }), children);
    if (backgroundColor) return /*#__PURE__*/ $5FkrB.createElement((0, $0b4bfd673c69705a$export$1ca2a26fecb070ae).Provider, {
        value: backgroundColor
    }, node);
    return node;
});
var $587f3da6c324a0f0$export$2e2bcd8739ae039 = $587f3da6c324a0f0$var$Box;
function $587f3da6c324a0f0$var$isSurfaceToken(backgroundColor) {
    return backgroundColor in $587f3da6c324a0f0$var$setSurfaceTokenMap;
}


// Map lozenge colors to appropriate icon colors.
//
// We intentionally use `color.text.*.bolder` tokens for icons across all
// colored lozenges (semantic + accent). Text tokens use higher-stop palette
// values (Color700+) which pass 3:1 contrast against subtler backgrounds in
// every interactive state — including pressed where icon Color600 fails for
// most hues. Using text tokens uniformly:
//   - avoids global changes to the `color.icon.*` token ramps
//   - keeps icon and text visually aligned in the lozenge
//   - guarantees ≥3:1 contrast across default/hover/pressed states
//
// Neutral lozenges use `color.text.subtle` to match the neutral text styling
// and remain consistent with their alpha-based backgrounds.
var $0db2353ef35514f9$var$getIconColor = function getIconColor(color) {
    switch(color){
        // Semantic
        case 'success':
            return "var(--ds-text-success, #4C6B1F)";
        case 'warning':
            return "var(--ds-text-warning, #9E4C00)";
        case 'danger':
            return "var(--ds-text-danger, #AE2E24)";
        case 'information':
            return "var(--ds-text-information, #1558BC)";
        case 'discovery':
            return "var(--ds-text-discovery, #803FA5)";
        case 'neutral':
            return "var(--ds-text-subtle, #505258)";
        // Accent
        case 'accent-red':
            return "var(--ds-text-accent-red, #AE2E24)";
        case 'accent-orange':
            return "var(--ds-text-accent-orange, #9E4C00)";
        case 'accent-yellow':
            return "var(--ds-text-accent-yellow, #7F5F01)";
        case 'accent-lime':
            return "var(--ds-text-accent-lime, #4C6B1F)";
        case 'accent-green':
            return "var(--ds-text-accent-green, #216E4E)";
        case 'accent-teal':
            return "var(--ds-text-accent-teal, #206A83)";
        case 'accent-blue':
            return "var(--ds-text-accent-blue, #1558BC)";
        case 'accent-purple':
            return "var(--ds-text-accent-purple, #803FA5)";
        case 'accent-magenta':
            return "var(--ds-text-accent-magenta, #943D73)";
        case 'accent-gray':
            return "var(--ds-text-subtle, #505258)";
        default:
            return "var(--ds-text-subtle, #505258)";
    }
};
var $0db2353ef35514f9$var$styles = {
    motion: "_k8m01ylx _1oeci9qs _6fl41d08"
};
/**
 * Icon renderer for lozenge components
 * Handles proper sizing and color theming for icons
 */ var $0db2353ef35514f9$var$IconRenderer = function IconRenderer(_ref) {
    var Icon = _ref.icon, color = _ref.color, testId = _ref.testId, size = _ref.size;
    var iconColor = $0db2353ef35514f9$var$getIconColor(color);
    return (0, $4b6756957153ffff$export$b40ec24ac8275656)('platform-dst-motion-uplift') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $587f3da6c324a0f0$export$2e2bcd8739ae039), {
        xcss: $0db2353ef35514f9$var$styles.motion,
        style: {
            color: iconColor
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(Icon, {
        label: "",
        size: size,
        testId: testId
    })) : /*#__PURE__*/ // Cast required because the lozenge intentionally uses some
    // `color.text.*.bolder` tokens for icons that don't pass 3:1 contrast
    // at their default `color.icon.*` stop. The Icon component types only
    // accept `IconColor`, but text tokens are valid CSS color values and
    // render correctly at runtime.
    (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(Icon, {
        color: iconColor,
        label: "",
        size: size,
        testId: testId
    });
};
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$0db2353ef35514f9$export$2e2bcd8739ae039 = $0db2353ef35514f9$var$IconRenderer;


// Map legacy appearance to new color values

var $e4b3890ca43eeb4f$var$legacyAppearanceMap = {
    default: 'neutral',
    removed: 'danger',
    inprogress: 'information',
    new: 'discovery',
    moved: 'warning'
};
var $e4b3890ca43eeb4f$export$acf5d2b7dc999bda = function resolveLozengeColor() {
    var _legacyAppearanceMap$;
    var appearance = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'neutral';
    if (appearance.startsWith('accent-')) return appearance;
    return (_legacyAppearanceMap$ = $e4b3890ca43eeb4f$var$legacyAppearanceMap[appearance]) !== null && _legacyAppearanceMap$ !== void 0 ? _legacyAppearanceMap$ : appearance;
};


function $8c4045cfee3ec217$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $8c4045cfee3ec217$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $8c4045cfee3ec217$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $8c4045cfee3ec217$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
// Get the pressed background color for the selected lozenge dropdown trigger
var $8c4045cfee3ec217$var$pressedBackgroundMapping = {
    success: "var(--ds-background-success-subtler-pressed, #B3DF72)",
    warning: "var(--ds-background-warning-subtler-pressed, #FBC828)",
    danger: "var(--ds-background-danger-subtler-pressed, #FD9891)",
    information: "var(--ds-background-information-subtler-pressed, #8FB8F6)",
    neutral: "var(--ds-background-neutral-pressed, #080F214A)",
    discovery: "var(--ds-background-discovery-subtler-pressed, #D8A0F7)",
    'accent-red': "var(--ds-background-accent-red-subtler-pressed, #FD9891)",
    'accent-orange': "var(--ds-background-accent-orange-subtler-pressed, #FBC828)",
    'accent-yellow': "var(--ds-background-accent-yellow-subtler-pressed, #EED12B)",
    'accent-lime': "var(--ds-background-accent-lime-subtler-pressed, #B3DF72)",
    'accent-green': "var(--ds-background-accent-green-subtler-pressed, #7EE2B8)",
    'accent-teal': "var(--ds-background-accent-teal-subtler-pressed, #9DD9EE)",
    'accent-blue': "var(--ds-background-accent-blue-subtler-pressed, #8FB8F6)",
    'accent-purple': "var(--ds-background-accent-purple-subtler-pressed, #D8A0F7)",
    'accent-magenta': "var(--ds-background-accent-magenta-subtler-pressed, #F797D2)",
    'accent-gray': "var(--ds-background-accent-gray-subtlest-pressed, #B7B9BE)"
};
var $8c4045cfee3ec217$var$styles = {
    container: "_2rko12b0 _1reo15vq _18m915vq _189ee4h9 _1dqonqa1 _1h6d1j28 _kqswh2mm _1e0c116y _4cvr1h6o _vchhusvi _4t3i1k92 _1q51v77o _85i5v77o _bozg1b66 _y4ti1b66",
    motionContainer: "_k8m01rje _1oeci9qs _6fl41d08",
    containerSpacious: "_2rko1qi0 _1tkeviql _1q511b66 _85i51b66 _bozgutpp _y4tiutpp",
    containerBadgePadding: "_y4ti303w",
    text: "_11c8wadc _1reo15vq _18m915vq _o5721q9c",
    textEllipsis: "_1bto1l2s",
    textClip: "_1btozryt",
    textSpacious: "_11c8fhey _k48p1wq8",
    textSelected: "_syaz6x5g",
    loadingOverlay: "_1reo15vq _18m915vq _1e0c1txw _kqswstnw _4cvr1h6o _1bah1h6o _u7coze3t _152tze3t _rjxpze3t _1e02ze3t _lcxvglyw",
    metricBadgeWrapper: "_1e0c1txw",
    'semantic.success': "_3wu02gvx _bfhk14j0 _syaz1p1e",
    'semantic.warning': "_3wu01wfx _bfhk10f4 _syazmgs1",
    'semantic.danger': "_3wu01mzp _bfhk18wg _syaz1blx",
    'semantic.information': "_3wu0wn4u _bfhk8lbg _syaz1qd9",
    'semantic.neutral': "_3wu01l7x _bfhki8nm _syazi7uo",
    'semantic.discovery': "_3wu019v3 _bfhke670 _syaz1g72",
    'accent.red': "_3wu0n9dc _bfhk1rtt _syazhwvp",
    'accent.orange': "_3wu01ip5 _bfhk165s _syaz7i1p",
    'accent.yellow': "_3wu01s7j _bfhk1773 _syazekll",
    'accent.lime': "_3wu01m7d _bfhkz2ec _syaz1ik3",
    'accent.green': "_3wu05d2u _bfhk1wnw _syaz1y78",
    'accent.teal': "_3wu0131p _bfhk1a17 _syaz12v7",
    'accent.blue': "_3wu018hp _bfhk1dy8 _syaz1kyx",
    'accent.purple': "_3wu0luwt _bfhk1nm4 _syaz1mn1",
    'accent.magenta': "_3wu0132u _bfhkv9ra _syaz1qur",
    'accent.gray': "_3wu01l7x _bfhkysee _syaz1tmo",
    'interactive.semantic.success': "_irr31r82 _1di6d6jc",
    'interactive.semantic.warning': "_irr31yx4 _1di6bkku",
    'interactive.semantic.danger': "_irr370oi _1di6jkmi",
    'interactive.semantic.information': "_irr315aw _1di6ar1y",
    'interactive.semantic.neutral': "_irr3plhp _1di61gdz",
    'interactive.semantic.discovery': "_irr3rumk _1di65usi",
    'interactive.accent.red': "_irr3affd _1di61j5a",
    'interactive.accent.orange': "_irr31ei0 _1di6dpo3",
    'interactive.accent.yellow': "_irr31uw7 _1di61r9w",
    'interactive.accent.lime': "_irr31gf0 _1di62kxc",
    'interactive.accent.green': "_irr31e2h _1di6ybhx",
    'interactive.accent.teal': "_irr3kwwr _1di61jb0",
    'interactive.accent.blue': "_irr3815t _1di6rwxf",
    'interactive.accent.purple': "_irr3attl _1di63nfk",
    'interactive.accent.magenta': "_irr31axx _1di642ri",
    'interactive.accent.gray': "_irr3wejn _1di618ut",
    iconBorderFilter: "_1h6d74of",
    content: "_zulp1b66 _1e0c116y _4cvr1h6o",
    maxWidth: "_p12f1osq",
    contentSpacious: "_zulp12x7",
    loadingContent: "_tzy4idpf",
    containerBadgePressed: "_1axmtoke _17i7toke",
    containerBadgeNeutralAppearance: "_1ftrnkaw _1axmnkaw _17i7nkaw"
};
/**
 * __New Lozenge__
 *
 * A lozenge is a visual indicator used to highlight an item's status for quick recognition.
 * This is the updated version with the new North Star visual language.
 */ var $8c4045cfee3ec217$var$LozengeBase = /*#__PURE__*/ (0, $5FkrB.memo)(/*#__PURE__*/ (0, $5FkrB.forwardRef)(function(_ref, ref) {
    var children = _ref.children, testId = _ref.testId, appearance = _ref.appearance, iconBefore = _ref.iconBefore, trailingMetric = _ref.trailingMetric, trailingMetricAppearance = _ref.trailingMetricAppearance, _ref$maxWidth = _ref.maxWidth, maxWidth = _ref$maxWidth === void 0 ? 200 : _ref$maxWidth, _ref$spacing = _ref.spacing, spacing = _ref$spacing === void 0 ? 'default' : _ref$spacing, isSelected = _ref.isSelected, _ref$isLoading = _ref.isLoading, isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading, onClick = _ref.onClick, style = _ref.style, analyticsContext = _ref.analyticsContext, interactionName = _ref.interactionName, ariaControls = _ref['aria-controls'], ariaExpanded = _ref['aria-expanded'], ariaHaspopup = _ref['aria-haspopup'], ariaLabel = _ref['aria-label'];
    var _useState = (0, $5FkrB.useState)(false), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), resizing = _useState2[0], setResizing = _useState2[1];
    var onFinishMotion = function onFinishMotion() {
        return setResizing(false);
    };
    var resizingWidth = (0, $744d9af81f1a5245$export$a300664a1a230956)({
        dimension: 'width',
        duration: "var(--ds-duration-medium, 200ms)",
        easing: "var(--ds-easing-inout-bold, cubic-bezier(0.4, 0, 0, 1))",
        onFinishMotion: onFinishMotion
    });
    var isInitialRender = (0, $5FkrB.useRef)(true);
    var isInteractive = typeof onClick === 'function';
    // Determine the effective color, with fallback logic for legacy appearances
    var resolvedColor = (0, $e4b3890ca43eeb4f$export$acf5d2b7dc999bda)(appearance) || 'neutral';
    var _getThemeStyles = (0, $9c9175041946e684$export$a3fc04b8551e006a)(resolvedColor), category = _getThemeStyles.category, key = _getThemeStyles.key;
    var colorStyleKey = "".concat(category, ".").concat(key);
    var interactiveStyleKey = "interactive.".concat(category, ".").concat(key);
    var maxWidthValue = typeof maxWidth === 'string' ? maxWidth : "".concat(maxWidth, "px");
    var maxWidthIsPc = typeof maxWidth === 'string' && maxWidth.endsWith('%');
    var resolvedTrailingMetricAppearance = trailingMetricAppearance ? trailingMetricAppearance === 'inverse' ? 'inverse' : (0, $e4b3890ca43eeb4f$export$acf5d2b7dc999bda)(trailingMetricAppearance) : resolvedColor;
    // Map the resolved trailing metric appearance to a Badge appearance.
    // Semantic colors map to their new bold variants (e.g. successBold),
    // which provide sufficient color emphasis on top of the subtler
    // lozenge background. Accent colors and unknown values fall back to
    // the neutral appearance.
    var metricBadgeAppearance = function() {
        if (resolvedTrailingMetricAppearance === 'inverse') return 'inverse';
        if (resolvedTrailingMetricAppearance == null) return 'neutral';
        if (resolvedTrailingMetricAppearance.startsWith('accent-')) return 'neutral';
        switch(resolvedTrailingMetricAppearance){
            case 'success':
                return 'successBold';
            case 'warning':
                return 'warningBold';
            case 'danger':
                return 'dangerBold';
            case 'information':
                return 'informationBold';
            case 'discovery':
                return 'discoveryBold';
            case 'neutral':
            default:
                return 'neutral';
        }
    }();
    var commonStyleOverrides = {
        backgroundColor: style === null || style === void 0 ? void 0 : style.backgroundColor,
        // Constrain the container to the smaller of the explicit maxWidth and 100% of
        // the parent. Using min(...) means the lozenge never overflows its parent,
        // while still honouring the explicit maxWidth prop when the parent is wider.
        maxWidth: maxWidthIsPc ? maxWidth : "min(".concat(maxWidthValue, ", 100%)")
    };
    var hasTrailingMetric = trailingMetric != null && trailingMetric !== '';
    var childrenKey = typeof children === 'string' ? children : undefined;
    (0, $5FkrB.useLayoutEffect)(function() {
        // Ignore initial render
        if (isInitialRender.current) {
            isInitialRender.current = false;
            return;
        }
        setResizing(true);
    }, [
        childrenKey
    ]);
    var enableMotionFG = (0, $4b6756957153ffff$export$b40ec24ac8275656)('platform-dst-motion-uplift');
    var innerContent = /*#__PURE__*/ $5FkrB.createElement("span", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, enableMotionFG ? resizingWidth : undefined, {
        className: (0, $jHdWv.default)([
            $8c4045cfee3ec217$var$styles.content,
            spacing === 'spacious' && $8c4045cfee3ec217$var$styles.contentSpacious,
            isLoading && $8c4045cfee3ec217$var$styles.loadingContent,
            // Constrain the content wrapper to its container so text truncation
            // works correctly within the flex layout, regardless of whether maxWidth
            // is a percentage, fixed value, or the parent container is narrower than
            // the explicit maxWidth.
            $8c4045cfee3ec217$var$styles.maxWidth
        ])
    }), iconBefore && /*#__PURE__*/ $5FkrB.createElement((0, $0db2353ef35514f9$export$2e2bcd8739ae039), {
        size: spacing === 'spacious' ? 'medium' : 'small',
        icon: iconBefore,
        color: resolvedColor,
        testId: testId && "".concat(testId, "--icon")
    }), /*#__PURE__*/ $5FkrB.createElement("span", {
        style: {
            // The text fills 100% of the inner content wrapper. The container's
            // own max-width (set on the container via commonStyleOverrides) handles
            // the actual size constraint, so the text just needs to fill the available
            // space and truncate when it overflows.
            maxWidth: maxWidthIsPc ? '100%' : "calc(".concat(maxWidthValue, " - ", "var(--ds-space-100, 8px)", ")"),
            color: style === null || style === void 0 ? void 0 : style.color
        },
        "data-testid": testId && "".concat(testId, "--text"),
        className: (0, $jHdWv.default)([
            $8c4045cfee3ec217$var$styles.text,
            enableMotionFG && resizing && !maxWidth ? $8c4045cfee3ec217$var$styles.textClip : $8c4045cfee3ec217$var$styles.textEllipsis,
            spacing === 'spacious' && $8c4045cfee3ec217$var$styles.textSpacious
        ])
    }, children), hasTrailingMetric && !resolvedColor.startsWith('accent-') && /*#__PURE__*/ $5FkrB.createElement("span", {
        "data-lozenge-metric-wrapper": true,
        "data-testid": testId && "".concat(testId, "--metric"),
        className: (0, $jHdWv.default)([
            $8c4045cfee3ec217$var$styles.metricBadgeWrapper
        ])
    }, /*#__PURE__*/ $5FkrB.createElement((0, $a2883d8d0008ed61$export$2e2bcd8739ae039), {
        appearance: metricBadgeAppearance
    }, trailingMetric)), isInteractive && /*#__PURE__*/ $5FkrB.createElement((0, (/*@__PURE__*/$parcel$interopDefault($e40a736c4c08093d$exports))), {
        label: "",
        size: "small",
        color: 'currentColor',
        testId: testId && "".concat(testId, "--chevron")
    }));
    if (isInteractive) return /*#__PURE__*/ $5FkrB.createElement((0, $0b31dd7ea89addbb$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        ref: ref,
        xcss: (0, $hRJ5R.cx)($8c4045cfee3ec217$var$styles.container, (0, $4b6756957153ffff$export$b40ec24ac8275656)('platform-dst-motion-uplift') && $8c4045cfee3ec217$var$styles.motionContainer, spacing === 'spacious' && $8c4045cfee3ec217$var$styles.containerSpacious, !isSelected && $8c4045cfee3ec217$var$styles.iconBorderFilter, $8c4045cfee3ec217$var$styles[colorStyleKey], !isLoading && $8c4045cfee3ec217$var$styles[interactiveStyleKey], hasTrailingMetric && $8c4045cfee3ec217$var$styles.containerBadgePressed, hasTrailingMetric && resolvedTrailingMetricAppearance === 'neutral' && $8c4045cfee3ec217$var$styles.containerBadgeNeutralAppearance)
    }, isLoading && {
        'aria-busy': true,
        'aria-disabled': true,
        isDisabled: true
    }, {
        "aria-label": isLoading ? 'Loading' : ariaLabel,
        "aria-controls": ariaControls,
        "aria-expanded": ariaExpanded,
        "aria-haspopup": ariaHaspopup,
        onClick: isLoading ? undefined : onClick,
        style: $8c4045cfee3ec217$var$_objectSpread($8c4045cfee3ec217$var$_objectSpread({}, commonStyleOverrides), {}, {
            // Specified because Pressable has a default border:none which overrides the border specified on the container
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            border: "solid ".concat("var(--ds-border-width, 1px)", " ", isSelected ? 'var(--border-color) !important' : 'transparent'),
            backgroundColor: isSelected ? $8c4045cfee3ec217$var$pressedBackgroundMapping[resolvedColor] : undefined,
            cursor: isLoading ? 'progress' : 'pointer'
        }),
        testId: testId,
        analyticsContext: analyticsContext,
        interactionName: interactionName,
        componentName: "LozengeDropdownTrigger"
    }, isSelected && {
        'data-selected': 'true'
    }), innerContent, isLoading && /*#__PURE__*/ $5FkrB.createElement("span", {
        className: (0, $jHdWv.default)([
            $8c4045cfee3ec217$var$styles.loadingOverlay
        ])
    }, /*#__PURE__*/ $5FkrB.createElement((0, $162f5989c6e6ed5b$export$2e2bcd8739ae039), {
        size: spacing === 'spacious' ? 'small' : 'xsmall',
        label: ", Loading",
        testId: testId ? "".concat(testId, "--loading-spinner") : undefined
    })));
    return /*#__PURE__*/ $5FkrB.createElement("span", {
        ref: ref,
        style: commonStyleOverrides,
        "data-testid": testId,
        className: (0, $jHdWv.default)([
            $8c4045cfee3ec217$var$styles.container,
            spacing === 'spacious' && $8c4045cfee3ec217$var$styles.containerSpacious,
            spacing !== 'spacious' && hasTrailingMetric && $8c4045cfee3ec217$var$styles.containerBadgePadding,
            $8c4045cfee3ec217$var$styles[colorStyleKey],
            $8c4045cfee3ec217$var$styles.iconBorderFilter,
            hasTrailingMetric && resolvedTrailingMetricAppearance === 'neutral' && $8c4045cfee3ec217$var$styles.containerBadgeNeutralAppearance
        ])
    }, innerContent);
}));
var $8c4045cfee3ec217$export$2e2bcd8739ae039 = $8c4045cfee3ec217$var$LozengeBase;


/**
 * __Lozenge__
 *
 * A lozenge is a visual indicator used to highlight an item's status for quick recognition.
 *
 * - [Examples](https://atlassian.design/components/lozenge/examples)
 * - [Code](https://atlassian.design/components/lozenge/code)
 * - [Usage](https://atlassian.design/components/lozenge/usage)
 */ var $2ebefb163f4e3420$var$Lozenge = function Lozenge(_ref) {
    var _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'neutral' : _ref$appearance, _ref$spacing = _ref.spacing, spacing = _ref$spacing === void 0 ? 'default' : _ref$spacing, _ref$maxWidth = _ref.maxWidth, maxWidth = _ref$maxWidth === void 0 ? 200 : _ref$maxWidth, style = _ref.style, testId = _ref.testId, children = _ref.children, iconBefore = _ref.iconBefore, trailingMetric = _ref.trailingMetric, trailingMetricAppearance = _ref.trailingMetricAppearance;
    var baseProps = {
        appearance: appearance,
        spacing: spacing,
        iconBefore: iconBefore,
        trailingMetric: trailingMetric,
        trailingMetricAppearance: trailingMetricAppearance,
        maxWidth: maxWidth,
        style: style,
        testId: testId,
        children: children
    };
    return /*#__PURE__*/ $5FkrB.createElement((0, $8c4045cfee3ec217$export$2e2bcd8739ae039), baseProps, children);
};
$2ebefb163f4e3420$var$Lozenge.displayName = 'Lozenge';
var $2ebefb163f4e3420$export$2e2bcd8739ae039 = $2ebefb163f4e3420$var$Lozenge;


/**
 * TODO: We should be using our bounded `cssMap` here, but most of
 * these styles from the visual refresh are not in the Design System.
 */ var $3f972846489e3122$var$styles = {
    container: "_2rkofajl _1reo15vq _18m915vq _1e0c116y _vchhusvi _kqswpfqs _1kz6184x _bozg1b66 _y4ti1b66",
    containerSubtle: "_1cwg1n1a",
    text: "_1reo15vq _18m915vq _ect4ttxp _1wyb1skh _zg8l4jg8 _k48pwu06 _vwz47vkz _1bto1l2s _1p1dangw _o5721q9c",
    customLetterspacing: "_1dyz9vsi",
    'bg.bold.default': "_bfhk1fkg",
    'bg.bold.inprogress': "_bfhk1ymo",
    'bg.bold.moved': "_bfhkxmjf",
    'bg.bold.new': "_bfhkshej",
    'bg.bold.removed': "_bfhk1366",
    'bg.bold.success': "_bfhk3uhp",
    'bg.subtle.default': "_bfhksm61",
    'bg.subtle.inprogress': "_bfhksm61",
    'bg.subtle.moved': "_bfhksm61",
    'bg.subtle.new': "_bfhksm61",
    'bg.subtle.removed': "_bfhksm61",
    'bg.subtle.success': "_bfhksm61",
    'outline.subtle.default': "_12ji14je _1qu2nqa1 _12y3t94y",
    'outline.subtle.inprogress': "_12jiuisw _1qu2nqa1 _12y3t94y",
    'outline.subtle.moved': "_12jih727 _1qu2nqa1 _12y3t94y",
    'outline.subtle.new': "_12ji157s _1qu2nqa1 _12y3t94y",
    'outline.subtle.removed': "_12jia2c0 _1qu2nqa1 _12y3t94y",
    'outline.subtle.success': "_12jin0nx _1qu2nqa1 _12y3t94y",
    'text.subtle': "_syazi7uo",
    'text.bold': "_syazwwip"
};
var $3f972846489e3122$var$appearanceTypes = [
    'default',
    'inprogress',
    'moved',
    'new',
    'removed'
];
var $3f972846489e3122$var$newSemanticColors = [
    'success',
    'discovery',
    'warning',
    'danger',
    'information',
    'neutral'
];
var $3f972846489e3122$var$appearanceMapping = {
    neutral: 'default',
    default: 'default',
    information: 'inprogress',
    inprogress: 'inprogress',
    warning: 'moved',
    moved: 'moved',
    removed: 'removed',
    danger: 'removed',
    success: 'success',
    discovery: 'new',
    new: 'new'
};
/**
 * __Lozenge__
 *
 * A lozenge is a visual indicator used to highlight an item's status for quick recognition.
 *
 * - [Examples](https://atlassian.design/components/lozenge/examples)
 * - [Code](https://atlassian.design/components/lozenge/code)
 * - [Usage](https://atlassian.design/components/lozenge/usage)
 */ var $3f972846489e3122$var$LegacyLozenge = /*#__PURE__*/ (0, $5FkrB.memo)(function(_ref) {
    var children = _ref.children, testId = _ref.testId, _ref$isBold = _ref.isBold, isBold = _ref$isBold === void 0 ? false : _ref$isBold, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'default' : _ref$appearance, _ref$maxWidth = _ref.maxWidth, maxWidth = _ref$maxWidth === void 0 ? 200 : _ref$maxWidth, style = _ref.style;
    var appearanceStyle = isBold ? 'bold' : 'subtle';
    var appearanceType = (0, $5FkrB.useMemo)(function() {
        return $3f972846489e3122$var$appearanceTypes.includes(appearance) || $3f972846489e3122$var$newSemanticColors.includes(appearance) ? $3f972846489e3122$var$appearanceMapping[appearance] : 'default';
    }, [
        appearance
    ]);
    var maxWidthValue = typeof maxWidth === 'string' ? maxWidth : "".concat(maxWidth, "px");
    var maxWidthIsPc = typeof maxWidth === 'string' && /%$/.test(maxWidth);
    return /*#__PURE__*/ $5FkrB.createElement("span", {
        style: {
            backgroundColor: style === null || style === void 0 ? void 0 : style.backgroundColor,
            maxWidth: maxWidthIsPc ? maxWidth : '100%'
        },
        "data-testid": testId,
        className: (0, $jHdWv.default)([
            $3f972846489e3122$var$styles.container,
            $3f972846489e3122$var$styles["bg.".concat(appearanceStyle, ".").concat(appearanceType)],
            appearanceStyle === 'subtle' && $3f972846489e3122$var$styles["outline.subtle.".concat(appearanceType)],
            appearanceStyle === 'subtle' && $3f972846489e3122$var$styles.containerSubtle
        ])
    }, /*#__PURE__*/ $5FkrB.createElement("span", {
        style: {
            color: style === null || style === void 0 ? void 0 : style.color,
            // to negate paddingInline specified on Box above
            maxWidth: maxWidthIsPc ? '100%' : "calc(".concat(maxWidthValue, " - ", "var(--ds-space-100, 8px)", ")")
        },
        "data-testid": testId && "".concat(testId, "--text"),
        className: (0, $jHdWv.default)([
            $3f972846489e3122$var$styles.text,
            (0, $4b6756957153ffff$export$b40ec24ac8275656)('platform-lozenge-custom-letterspacing') && $3f972846489e3122$var$styles.customLetterspacing,
            $3f972846489e3122$var$styles["text.".concat(appearanceStyle)]
        ])
    }, children));
});
$3f972846489e3122$var$LegacyLozenge.displayName = 'Lozenge';
/**
 * Wrapper component that switches between old and new Lozenge based on feature flag
 */ var $3f972846489e3122$var$LozengeWrapper = /*#__PURE__*/ (0, $5FkrB.memo)(function(props) {
    if ((0, $4b6756957153ffff$export$b40ec24ac8275656)('platform-dst-lozenge-tag-badge-visual-uplifts')) return /*#__PURE__*/ $5FkrB.createElement((0, $2ebefb163f4e3420$export$2e2bcd8739ae039), props);
    return /*#__PURE__*/ $5FkrB.createElement($3f972846489e3122$var$LegacyLozenge, props);
});
$3f972846489e3122$var$LozengeWrapper.displayName = 'Lozenge';
var $3f972846489e3122$export$2e2bcd8739ae039 = $3f972846489e3122$var$LozengeWrapper;



const $fe4fcc4b7b323fa4$var$getStatusDisplay = (status)=>{
    // Check if the status is a known StatusId
    const knownStatuses = [
        'COMING_SOON',
        'PLANNED',
        'ROLLING_OUT',
        'GENERALLY_AVAILABLE',
        'ROLLED_BACK'
    ];
    if (knownStatuses.includes(status)) {
        const statusId = status;
        const messageDescriptor = (0, $dafe8aa59b77d934$export$e238a77ea3a8cd66)(statusId);
        const appearance = (0, $dafe8aa59b77d934$export$548966735f47dde3)(statusId);
        return [
            /*#__PURE__*/ (0, $5FkrB.createElement)((0, $iBNQo.default), {
                ...messageDescriptor,
                key: messageDescriptor.id
            }),
            appearance
        ];
    }
    // Fallback for unknown statuses
    return [
        status,
        'default'
    ];
};
const $fe4fcc4b7b323fa4$export$330c774339d320ad = ({ status: status })=>{
    if (!status) return null;
    const [statusMsg, appearance] = $fe4fcc4b7b323fa4$var$getStatusDisplay(status);
    return /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $3f972846489e3122$export$2e2bcd8739ae039), {
        appearance: appearance,
        children: statusMsg
    });
};



parcelRequire("5FkrB");

var $aRMzY = parcelRequire("aRMzY");
var $6Wx3K = parcelRequire("6Wx3K");


const $d26747ad8d2a0268$var$lozengeWrapperStyles = (0, $c1bec583fa49072f$export$f6c783d06584602c)({
    display: 'inline-flex'
});
const $d26747ad8d2a0268$var$messages = (0, $aRMzY.defineMessages)({
    high: {
        id: 'appUpdatesTable.impactRating.high',
        defaultMessage: 'High',
        description: 'High impact rating label'
    },
    medium: {
        id: 'appUpdatesTable.impactRating.medium',
        defaultMessage: 'Medium',
        description: 'Medium impact rating label'
    },
    low: {
        id: 'appUpdatesTable.impactRating.low',
        defaultMessage: 'Low',
        description: 'Low impact rating label'
    }
});
const $d26747ad8d2a0268$export$2a5158d64a074be2 = ({ impactRating: impactRating })=>{
    const { formatMessage: formatMessage } = (0, $6Wx3K.default)();
    if (!impactRating) return null;
    switch(impactRating){
        case 'HIGH':
            return /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $383dd904a5a5e5b0$export$2e2bcd8739ae039), {
                xcss: $d26747ad8d2a0268$var$lozengeWrapperStyles,
                children: /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $3f972846489e3122$export$2e2bcd8739ae039), {
                    appearance: "removed",
                    isBold: true,
                    children: formatMessage($d26747ad8d2a0268$var$messages.high)
                })
            });
        case 'MEDIUM':
            return /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $383dd904a5a5e5b0$export$2e2bcd8739ae039), {
                xcss: $d26747ad8d2a0268$var$lozengeWrapperStyles,
                children: /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $3f972846489e3122$export$2e2bcd8739ae039), {
                    appearance: "moved",
                    isBold: true,
                    children: formatMessage($d26747ad8d2a0268$var$messages.medium)
                })
            });
        case 'LOW':
            return /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $383dd904a5a5e5b0$export$2e2bcd8739ae039), {
                xcss: $d26747ad8d2a0268$var$lozengeWrapperStyles,
                children: /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $3f972846489e3122$export$2e2bcd8739ae039), {
                    appearance: "success",
                    isBold: true,
                    children: formatMessage($d26747ad8d2a0268$var$messages.low)
                })
            });
        default:
            return null;
    }
};



parcelRequire("5FkrB");

var $fC8ib = parcelRequire("fC8ib");

var $5FkrB = parcelRequire("5FkrB");

var $74Zh5 = parcelRequire("74Zh5");


var $10b0af967ce59e29$var$flexGrowMap = {
    hug: (0, $c1bec583fa49072f$export$f6c783d06584602c)({
        flexGrow: 0
    }),
    fill: (0, $c1bec583fa49072f$export$f6c783d06584602c)({
        width: '100%',
        flexGrow: 1
    })
};
var $10b0af967ce59e29$var$separatorStyles = (0, $74Zh5.css)({
    color: "var(--ds-text-subtle, #42526E)",
    marginBlock: "var(--ds-space-0, 0px)",
    marginInline: "var(--ds-space-negative-025, -2px)",
    pointerEvents: 'none',
    userSelect: 'none'
});
var $10b0af967ce59e29$var$Separator = function Separator(_ref) {
    var children = _ref.children;
    return (0, $74Zh5.jsx)("span", {
        css: $10b0af967ce59e29$var$separatorStyles
    }, children);
};
/**
 * __Inline__
 *
 * Inline is a primitive component based on CSS Flexbox that manages the horizontal layout of direct children.
 *
 * @example
 * ```tsx
 *  <Inline>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *  </Inline>
 * ```
 *
 */ var $10b0af967ce59e29$var$Inline = /*#__PURE__*/ (0, $5FkrB.memo)(/*#__PURE__*/ (0, $5FkrB.forwardRef)(function(_ref2, ref) {
    var as = _ref2.as, alignInline = _ref2.alignInline, _ref2$alignBlock = _ref2.alignBlock, alignItems = _ref2$alignBlock === void 0 ? 'start' : _ref2$alignBlock, _ref2$shouldWrap = _ref2.shouldWrap, shouldWrap = _ref2$shouldWrap === void 0 ? false : _ref2$shouldWrap, spread = _ref2.spread, grow = _ref2.grow, space = _ref2.space, rowSpace = _ref2.rowSpace, separator = _ref2.separator, xcss = _ref2.xcss, testId = _ref2.testId, role = _ref2.role, id = _ref2.id, rawChildren = _ref2.children;
    var separatorComponent = typeof separator === 'string' ? (0, $74Zh5.jsx)($10b0af967ce59e29$var$Separator, null, separator) : separator;
    var children = separatorComponent ? (0, $5FkrB.Children).toArray(rawChildren).filter(Boolean).map(function(child, index) {
        return (0, $74Zh5.jsx)((0, $5FkrB.Fragment), {
            key: index
        }, separator && index > 0 ? separatorComponent : null, child);
    }) : rawChildren;
    var justifyContent = spread || alignInline;
    // We're type coercing this as Compiled styles in an array isn't supported by the types
    // But the runtime accepts it none-the-wiser. We can remove this entire block and replace
    // it with cx(defaultStyles, focusRingStyles, xcssStyles) when we've moved away from Emotion.
    var styles = grow ? [
        $10b0af967ce59e29$var$flexGrowMap[grow]
    ].concat((0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(Array.isArray(xcss) ? xcss : [
        xcss
    ])) : xcss;
    return (0, $74Zh5.jsx)((0, $1b254ba6a068f2f1$export$2e2bcd8739ae039), {
        id: id,
        as: as,
        role: role,
        alignItems: alignItems,
        justifyContent: justifyContent,
        direction: "row",
        gap: space,
        rowGap: rowSpace,
        wrap: shouldWrap ? 'wrap' : undefined,
        xcss: styles,
        testId: testId,
        ref: ref
    }, children);
}));
$10b0af967ce59e29$var$Inline.displayName = 'Inline';
var $10b0af967ce59e29$export$2e2bcd8739ae039 = $10b0af967ce59e29$var$Inline;



var $288ej = parcelRequire("288ej");

const $fbecf69dc9e04116$var$tagsContainerStyles = (0, $c1bec583fa49072f$export$f6c783d06584602c)({
    maxWidth: '160px'
});
const $fbecf69dc9e04116$export$3c86caed05f80ae7 = ({ tags: tags })=>{
    if (!tags || tags.length === 0) return null;
    return /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $383dd904a5a5e5b0$export$2e2bcd8739ae039), {
        xcss: $fbecf69dc9e04116$var$tagsContainerStyles,
        children: /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $10b0af967ce59e29$export$2e2bcd8739ae039), {
            space: "space.050",
            shouldWrap: true,
            children: tags.map((tag)=>/*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $288ej.default), {
                    text: (0, $51e43113ed6c9475$export$4bbe71e8edfbf0cd)(tag),
                    color: "standard",
                    isRemovable: false
                }, tag))
        })
    });
};




var $5FkrB = parcelRequire("5FkrB");

var $iBNQo = parcelRequire("iBNQo");


const $10eaae4bdfb59f21$export$1abc4eff6ef230bd = ({ type: type })=>{
    if (!type) return null;
    // Check if the type is a known ChangeTypeId
    const knownChangeTypes = [
        'IMPROVEMENT',
        'FIX',
        'EXPERIMENT',
        'REMOVED',
        'ANNOUNCEMENT'
    ];
    if (knownChangeTypes.includes(type)) {
        const changeTypeId = type;
        const messageDescriptor = (0, $5f43c72173f3a108$export$58d8d249a6136224)(changeTypeId);
        return /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $d48daa9a522ca942$export$2e2bcd8739ae039), {
            children: /*#__PURE__*/ (0, $5FkrB.createElement)((0, $iBNQo.default), {
                ...messageDescriptor,
                key: messageDescriptor.id
            })
        });
    }
    // Fallback for unknown change types
    return /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $d48daa9a522ca942$export$2e2bcd8739ae039), {
        children: type
    });
};





parcelRequire("5FkrB");

var $5FkrB = parcelRequire("5FkrB");

const $482ba924d5ad5f3a$export$c0feb0112f86aefc = 7;
const $482ba924d5ad5f3a$export$502a1fb2342439ae = 3000; // 3s
const $482ba924d5ad5f3a$export$d89e39edaf3286a8 = 'appUpdatesReadItems';
const $482ba924d5ad5f3a$export$6a9f7378365a81d = 'appUpdatesLastPruned';



const $15b90d5900f709a5$var$getStorage = ()=>{
    if (typeof window === 'undefined') return null;
    try {
        return window.localStorage;
    } catch  {
        return null;
    }
};
const $15b90d5900f709a5$var$readStorageItem = (key)=>{
    try {
        return $15b90d5900f709a5$var$getStorage()?.getItem(key) ?? null;
    } catch  {
        return null;
    }
};
const $15b90d5900f709a5$var$writeStorageItem = (key, value)=>{
    try {
        $15b90d5900f709a5$var$getStorage()?.setItem(key, value);
    } catch  {
    // localStorage may be unavailable or full; read state should never break UI.
    }
};
const $15b90d5900f709a5$export$d7e8c0a596a66888 = (date)=>{
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
};
/**
 * Convert a backend-supplied ISO 8601 timestamp into a canonical YYYY-MM-DD key
 * in the user's local timezone, so the unread window matches the calendar the
 * user actually sees.
 *
 * Returns null if the timestamp is not parseable.
 */ const $15b90d5900f709a5$var$parsePostDateKey = (postDate)=>{
    const date = new Date(postDate);
    if (Number.isNaN(date.getTime())) return null;
    return $15b90d5900f709a5$export$d7e8c0a596a66888(date);
};
const $15b90d5900f709a5$var$getUnreadBoundaryKey = ()=>{
    const today = new Date();
    return $15b90d5900f709a5$export$d7e8c0a596a66888(new Date(today.getFullYear(), today.getMonth(), today.getDate() - (0, $482ba924d5ad5f3a$export$c0feb0112f86aefc)));
};
const $15b90d5900f709a5$export$18302c496e8cdf66 = (firstPublishedAt)=>{
    const firstPublishedAtKey = $15b90d5900f709a5$var$parsePostDateKey(firstPublishedAt);
    if (firstPublishedAtKey === null) return false;
    return firstPublishedAtKey >= $15b90d5900f709a5$var$getUnreadBoundaryKey() && firstPublishedAtKey <= $15b90d5900f709a5$export$d7e8c0a596a66888(new Date());
};
const $15b90d5900f709a5$var$isReadEntry = (value)=>typeof value === 'object' && value !== null && typeof value.id === 'string' && typeof value.firstPublishedAt === 'string';
// Cache the parsed ids so the snapshot returns a stable reference until the raw
// string changes — required by useSyncExternalStore and keeps tearing protection.
let $15b90d5900f709a5$var$cachedRawValue = null;
let $15b90d5900f709a5$var$cachedReadIds = [];
const $15b90d5900f709a5$export$74893074ee6d7252 = ()=>{
    const rawValue = $15b90d5900f709a5$var$readStorageItem((0, $482ba924d5ad5f3a$export$d89e39edaf3286a8));
    if (rawValue !== $15b90d5900f709a5$var$cachedRawValue) {
        $15b90d5900f709a5$var$cachedRawValue = rawValue;
        $15b90d5900f709a5$var$cachedReadIds = $15b90d5900f709a5$export$36103693c78e100c();
    }
    return $15b90d5900f709a5$var$cachedReadIds;
};
const $15b90d5900f709a5$export$a5ef48a7b09fdcbd = ()=>{
    const storedValue = $15b90d5900f709a5$var$readStorageItem((0, $482ba924d5ad5f3a$export$d89e39edaf3286a8));
    if (storedValue === null) return [];
    try {
        const parsedValue = JSON.parse(storedValue);
        if (!Array.isArray(parsedValue)) return [];
        const seenIds = new Set();
        const entries = [];
        parsedValue.forEach((item)=>{
            if (!$15b90d5900f709a5$var$isReadEntry(item) || seenIds.has(item.id)) return;
            seenIds.add(item.id);
            entries.push({
                id: item.id,
                firstPublishedAt: item.firstPublishedAt
            });
        });
        return entries;
    } catch  {
        return [];
    }
};
const $15b90d5900f709a5$export$36103693c78e100c = ()=>$15b90d5900f709a5$export$a5ef48a7b09fdcbd().map((entry)=>entry.id);
const $15b90d5900f709a5$export$dc76bba8c4f0075f = ({ id: id, firstPublishedAt: firstPublishedAt })=>{
    const normalizedId = id.trim();
    // Don't persist invalid entries — a ReadEntry must have a usable date.
    if (normalizedId.length === 0 || $15b90d5900f709a5$var$parsePostDateKey(firstPublishedAt) === null) return;
    const entries = $15b90d5900f709a5$export$a5ef48a7b09fdcbd();
    if (entries.some((entry)=>entry.id === normalizedId)) return;
    $15b90d5900f709a5$var$writeStorageItem((0, $482ba924d5ad5f3a$export$d89e39edaf3286a8), JSON.stringify([
        ...entries,
        {
            id: normalizedId,
            firstPublishedAt: firstPublishedAt
        }
    ]));
    // The browser does not fire the 'storage' event for same-window writes, so
    // dispatch our own custom event to notify same-tab subscribers.
    try {
        window.dispatchEvent(new Event('unread-indicator-changed'));
    } catch  {
    // window may not be available in SSR — safe to skip.
    }
};
const $15b90d5900f709a5$export$504fbc0ef5c94afa = ()=>{
    const todayKey = $15b90d5900f709a5$export$d7e8c0a596a66888(new Date());
    // Short-circuit: already pruned today (cheap YYYY-MM-DD string compare).
    if ($15b90d5900f709a5$var$readStorageItem((0, $482ba924d5ad5f3a$export$6a9f7378365a81d)) === todayKey) return;
    const prunedEntries = $15b90d5900f709a5$export$a5ef48a7b09fdcbd().filter((entry)=>$15b90d5900f709a5$export$18302c496e8cdf66(entry.firstPublishedAt));
    $15b90d5900f709a5$var$writeStorageItem((0, $482ba924d5ad5f3a$export$d89e39edaf3286a8), JSON.stringify(prunedEntries));
    $15b90d5900f709a5$var$writeStorageItem((0, $482ba924d5ad5f3a$export$6a9f7378365a81d), todayKey);
};


// ---------------------------------------------------------------------------
// Subscription — wires useSyncExternalStore to localStorage changes.
//
// Two event sources are needed:
//   - 'storage': fired by the browser on all OTHER tabs when localStorage
//     changes. Gives us cross-tab sync for free. We filter by key so that
//     unrelated cross-tab writes (any other localStorage key) don't trigger
//     re-renders in every component using this hook.
//   - 'unread-indicator-changed': a custom event dispatched by addReadEntry()
//     after it writes. The browser does NOT fire 'storage' for same-window
//     writes, so we emit our own event to keep same-tab components in sync.
// ---------------------------------------------------------------------------
const $9aabdc1903d96d41$var$subscribe = (onStoreChange)=>{
    // Filter the cross-tab 'storage' event to only fire for our key. Note that
    // event.key is null when localStorage.clear() is called — we treat that as
    // a relevant change too, since it wipes our read set.
    const handleStorage = (event)=>{
        if (event.key === null || event.key === (0, $482ba924d5ad5f3a$export$d89e39edaf3286a8)) onStoreChange();
    };
    window.addEventListener('storage', handleStorage);
    window.addEventListener('unread-indicator-changed', onStoreChange);
    return ()=>{
        window.removeEventListener('storage', handleStorage);
        window.removeEventListener('unread-indicator-changed', onStoreChange);
    };
};
const $9aabdc1903d96d41$export$86ce72459a4312fa = ({ id: id, firstPublishedAt: firstPublishedAt })=>{
    const { analyticsOptOut: analyticsOptOut } = (0, $38056d680fac42ff$export$b224af886b957a5e)();
    // Subscribe to the external read-set store.
    const readIds = (0, $5FkrB.useSyncExternalStore)($9aabdc1903d96d41$var$subscribe, (0, $15b90d5900f709a5$export$74893074ee6d7252));
    const isUnread = !analyticsOptOut && (0, $15b90d5900f709a5$export$18302c496e8cdf66)(firstPublishedAt) && !readIds.includes(id);
    const markSeen = (0, $5FkrB.useCallback)(()=>{
        if (analyticsOptOut) return;
        (0, $15b90d5900f709a5$export$dc76bba8c4f0075f)({
            id: id,
            firstPublishedAt: firstPublishedAt
        });
    }, [
        analyticsOptOut,
        id,
        firstPublishedAt
    ]);
    return {
        isUnread: isUnread,
        markSeen: markSeen
    };
};



parcelRequire("5FkrB");

var $aRMzY = parcelRequire("aRMzY");
var $6Wx3K = parcelRequire("6Wx3K");

var $kqp0i = parcelRequire("kqp0i");

var $iYJcE = parcelRequire("iYJcE");

var $25nEq = parcelRequire("25nEq");

var $5FkrB = parcelRequire("5FkrB");

var $7QpUe = parcelRequire("7QpUe");

var $25nEq = parcelRequire("25nEq");

var $5FkrB = parcelRequire("5FkrB");

var $dLGML = parcelRequire("dLGML");

var $fC8ib = parcelRequire("fC8ib");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $kIXpt = parcelRequire("kIXpt");

var $cYPzS = parcelRequire("cYPzS");

var $lwlXp = parcelRequire("lwlXp");

var $eyuDe = parcelRequire("eyuDe");

var $25nEq = parcelRequire("25nEq");

var $ekGgq = parcelRequire("ekGgq");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $25nEq = parcelRequire("25nEq");
function $29629bbb0ad09fa5$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $29629bbb0ad09fa5$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $29629bbb0ad09fa5$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $29629bbb0ad09fa5$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $29629bbb0ad09fa5$export$ad4be5c2ec28cecf = function isAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $29629bbb0ad09fa5$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === 'AnalyticsEvent';
};
var $29629bbb0ad09fa5$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function AnalyticsEvent(props) {
        var _this = this;
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, AnalyticsEvent);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "_isAnalyticsEvent", true);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "clone", function() {
            // just a shallow clone, don't change sub refs unless you want to
            // affect the original's too
            var payload = $29629bbb0ad09fa5$var$_objectSpread({}, _this.payload);
            return new AnalyticsEvent({
                payload: payload
            });
        });
        this.payload = props.payload;
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(AnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (typeof updater === 'function') this.payload = updater(this.payload);
                if ((0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(updater) === 'object') this.payload = $29629bbb0ad09fa5$var$_objectSpread($29629bbb0ad09fa5$var$_objectSpread({}, this.payload), updater);
                return this;
            }
        }
    ]);
}();


function $c74ee1d679864b02$var$_callSuper(t, o, e) {
    return o = (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(o), (0, (/*@__PURE__*/$parcel$interopDefault($kIXpt)))(t, $c74ee1d679864b02$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(t).constructor) : o.apply(t, e));
}
function $c74ee1d679864b02$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($c74ee1d679864b02$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $c74ee1d679864b02$var$_superPropGet(t, o, e, r) {
    var p = (0, (/*@__PURE__*/$parcel$interopDefault($lwlXp)))((0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(1 & r ? t.prototype : t), o, e);
    return 2 & r && "function" == typeof p ? function(t) {
        return p.apply(e, t);
    } : p;
}
var $c74ee1d679864b02$export$35f8383928ba8d7 = function isUIAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $c74ee1d679864b02$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isUIAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === 'UIAnalyticsEvent';
};
var $c74ee1d679864b02$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_AnalyticsEvent) {
    function UIAnalyticsEvent(props) {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, UIAnalyticsEvent);
        _this = $c74ee1d679864b02$var$_callSuper(this, UIAnalyticsEvent, [
            props
        ]);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "_isUIAnalyticsEvent", true);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "clone", function() {
            if (_this.hasFired) return null;
            var context = (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(_this.context);
            var handlers = (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(_this.handlers);
            /**
       * A hacky "deep clone" of the object. This is limited in that it wont
       * support functions, regexs, Maps, Sets, etc, but none of those need to
       * be represented in our payload.
       */ var payload = JSON.parse(JSON.stringify(_this.payload));
            return new UIAnalyticsEvent({
                context: context,
                handlers: handlers,
                payload: payload
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "fire", function(channel) {
            if (_this.hasFired) return;
            _this.handlers.forEach(function(handler) {
                return handler(_this, channel);
            });
            _this.hasFired = true;
        });
        _this.context = props.context || [];
        _this.handlers = props.handlers || [];
        _this.hasFired = false;
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($eyuDe)))(UIAnalyticsEvent, _AnalyticsEvent);
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(UIAnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (this.hasFired) return this;
                return $c74ee1d679864b02$var$_superPropGet(UIAnalyticsEvent, "update", this, 3)([
                    updater
                ]);
            }
        }
    ]);
}((0, $29629bbb0ad09fa5$export$2e2bcd8739ae039));



var $5FkrB = parcelRequire("5FkrB");

var $iyyOp = parcelRequire("iyyOp");
var $d096d4d52abd6b9c$export$d1f587f82ad51c4 = function useAnalyticsContext() {
    return (0, $5FkrB.useContext)((0, $iyyOp.default));
};


function $3bffb4ec411427cf$export$5bf35293e545f20c() {
    var analyticsContext = (0, $d096d4d52abd6b9c$export$d1f587f82ad51c4)();
    var createAnalyticsEvent = (0, $dLGML.useCallbackOne)(function(payload) {
        return new (0, $c74ee1d679864b02$export$2e2bcd8739ae039)({
            context: analyticsContext.getAtlaskitAnalyticsContext(),
            handlers: analyticsContext.getAtlaskitAnalyticsEventHandlers(),
            payload: payload
        });
    }, [
        analyticsContext
    ]);
    return {
        createAnalyticsEvent: createAnalyticsEvent
    };
}



var $5FkrB = parcelRequire("5FkrB");
var $3a3cea8767408000$export$1d27a74659855e44 = function useTrackedRef(value) {
    var ref = (0, $5FkrB.useRef)(value);
    ref.current = value;
    return ref;
};


function $9cd5662c46212572$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $9cd5662c46212572$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $9cd5662c46212572$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $9cd5662c46212572$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $9cd5662c46212572$export$1a04351537078b55(_ref) {
    var fn = _ref.fn, action = _ref.action, componentName = _ref.componentName, packageName = _ref.packageName, packageVersion = _ref.packageVersion, analyticsData = _ref.analyticsData;
    var _useAnalyticsEvents = (0, $3bffb4ec411427cf$export$5bf35293e545f20c)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
    // We put analyticsData and fn in a ref so that we don't need to break
    // memoization.
    // Generally these could be defined by consumers inline
    // and so we do this to avoid breaking memoization of useCallback
    var dataRef = (0, $3a3cea8767408000$export$1d27a74659855e44)(analyticsData);
    var fnRef = (0, $3a3cea8767408000$export$1d27a74659855e44)(fn);
    var handler = (0, $5FkrB.useCallback)(function() {
        var analyticsEvent = createAnalyticsEvent({
            action: action,
            actionSubject: componentName,
            attributes: {
                componentName: componentName,
                packageName: packageName,
                packageVersion: packageVersion
            }
        });
        // To avoid wrapping this component in AnalyticsContext we manually
        // push the parent context's meta data into the context.
        // Note: this new 'context'
        var context = $9cd5662c46212572$var$_objectSpread({
            componentName: componentName,
            packageName: packageName,
            packageVersion: packageVersion
        }, dataRef.current);
        analyticsEvent.context.push(context);
        // fire an event on the atlaskit channel
        var clone = analyticsEvent.clone();
        if (clone) clone.fire('atlaskit');
        fnRef.current(analyticsEvent);
    }, [
        // These are strings and won't change
        action,
        componentName,
        packageName,
        packageVersion,
        // This function is memoized in the context
        createAnalyticsEvent,
        // these are a stable ref because of the useTrackedRef hook
        dataRef,
        fnRef
    ]);
    return handler;
}


/**
 * An empty function which does nothing.
 */ function $e77757f0e07afb88$export$2e2bcd8739ae039() {}



var $5FkrB = parcelRequire("5FkrB");

var $7QpUe = parcelRequire("7QpUe");
/**
 * Character key codes which can be used in keyboard events.
 */ var $20e9f7cf045273c0$export$390330c10ff2b9a1 = 'ArrowUp';
var $20e9f7cf045273c0$export$a80636c6f41931fe = 'ArrowDown';
var $20e9f7cf045273c0$export$fc4577f2a2af0ae3 = 'ArrowLeft';
var $20e9f7cf045273c0$export$c40f9845adc73fb5 = 'ArrowRight';
var $20e9f7cf045273c0$export$4af703091671bc = 'Home';
var $20e9f7cf045273c0$export$e2bc30913faa5db7 = 'End';
var $20e9f7cf045273c0$export$10f6869ed0a7d75b = 'Tab';
var $20e9f7cf045273c0$export$8152f929a25a0ff4 = 'Enter';
var $20e9f7cf045273c0$export$e51a3576c045c8d5 = 'Space';
var $20e9f7cf045273c0$export$2bb790b9008907b4 = 'Escape';


function $16699ead915fb8fe$export$2e2bcd8739ae039(_ref) {
    var onClose = _ref.onClose, isDisabled = _ref.isDisabled;
    var escapePressed = (0, $5FkrB.useRef)(false);
    var onKeyDown = (0, $5FkrB.useCallback)(function(e) {
        if (isDisabled || escapePressed.current || e.key !== (0, $20e9f7cf045273c0$export$2bb790b9008907b4)) // We're either already handling the key down event or it's not escape.
        // Bail early!
        return;
        escapePressed.current = true;
        onClose(e);
    }, [
        onClose,
        isDisabled
    ]);
    var onKeyUp = (0, $5FkrB.useCallback)(function() {
        escapePressed.current = false;
    }, []);
    (0, $5FkrB.useEffect)(function() {
        // Don't attach document event listeners if the hook is disabled
        if (isDisabled) return;
        return (0, $7QpUe.bindAll)(document, [
            {
                type: 'keydown',
                listener: onKeyDown
            },
            {
                type: 'keyup',
                listener: onKeyUp
            }
        ], {
            capture: false
        });
    }, [
        onKeyDown,
        onKeyUp,
        isDisabled
    ]);
}



var $5FkrB = parcelRequire("5FkrB");
function $da62f9bc21c6475f$export$2e2bcd8739ae039(value) {
    var ref = (0, $5FkrB.useRef)(value);
    (0, $5FkrB.useEffect)(function() {
        ref.current = value;
    }, [
        value
    ]);
    return ref;
}



var $5FkrB = parcelRequire("5FkrB");

var $5FkrB = parcelRequire("5FkrB");
var $d6c72d6457d9e607$export$5fbf4d7fae6cdc00 = /*#__PURE__*/ (0, $5FkrB.createContext)(null);



var $5FkrB = parcelRequire("5FkrB");

var $5FkrB = parcelRequire("5FkrB");
var $85124affa8d7009e$export$644a49f3b8c50fcd = /*#__PURE__*/ (0, $5FkrB.createContext)(null);


function $00084e77ebfbc513$export$1d57e79091cc3046() {
    var namespace = (0, $5FkrB.useContext)((0, $85124affa8d7009e$export$644a49f3b8c50fcd));
    return namespace;
}


function $c8ddaa578c48e6d6$export$469bb693f11edc7f(_ref) {
    var isOpen = _ref.isOpen, type = _ref.type, onClose = _ref.onClose;
    var context = (0, $5FkrB.useContext)((0, $d6c72d6457d9e607$export$5fbf4d7fae6cdc00));
    var namespace = (0, $00084e77ebfbc513$export$1d57e79091cc3046)();
    (0, $5FkrB.useEffect)(function() {
        /**
     * Registers the `onClose` callback with the OpenLayerObserver.
     */ if (context === null) return;
        if (!isOpen) /**
       * If the layer is not open, we are not registering the `onClose` callback.
       * This is important to prevent the `onClose` from being called for layers that
       * are not open.
       *
       * Some consumers mistakenly pass "toggle" functions to `onClose` callbacks for
       * layer components, as Popup, e.g. `onClose={() => setIsOpen(!isOpen)}`.
       */ return;
        return context.onClose(onClose, {
            namespace: namespace,
            type: type
        });
    }, [
        context,
        isOpen,
        namespace,
        onClose,
        type
    ]);
}



var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");

var $9Zzpd = parcelRequire("9Zzpd");
/**
 * Internally we will be playing with an element that will always have a key defined.
 */ /**
 * Internal data passed to child motions.
 */ // We define empty context here so the object doesn't change.
var $a4d40a97fb679e4b$var$emptyContext = {
    // Motions will always appear if not inside a exiting persistence component.
    appear: true,
    isExiting: false
};
/**
 * __Exiting context__
 *
 * An exiting context.
 */ var $a4d40a97fb679e4b$var$ExitingContext = /*#__PURE__*/ (0, $5FkrB.createContext)($a4d40a97fb679e4b$var$emptyContext);
/**
 * This method will wrap any React element with a context provider. We're using context (instead of
 * cloneElement) so we can communicate between multiple elements without the need of prop drilling
 * (results in a better API for consumers).
 */ var $a4d40a97fb679e4b$var$wrapChildWithContextProvider = function wrapChildWithContextProvider(child) {
    var value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $a4d40a97fb679e4b$var$emptyContext;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement($a4d40a97fb679e4b$var$ExitingContext.Provider, {
        key: "".concat(child.key, "-provider"),
        value: value
    }, child);
};
/**
 * This function will convert all children types to an array while also filtering out non-valid React elements.
 */ var $a4d40a97fb679e4b$var$childrenToArray = function childrenToArray(children) {
    var childrenAsArray = [];
    // We convert children to an array using this helper method as it will add keys to children that do not
    // have them, such as when we have hardcoded children that are conditionally rendered.
    (0, $5FkrB.Children).toArray(children).forEach(function(child) {
        // We ignore any boolean children to make our code a little more simple later on,
        // and also filter out any falsies (empty strings, nulls, and undefined).
        if (typeof child !== 'boolean' && Boolean(child)) // Children WILL have a key after being forced into an array using the React.Children helper.
        childrenAsArray.push(child);
    });
    return childrenAsArray;
};
var $a4d40a97fb679e4b$var$spliceNewElementsIntoPrevious = function spliceNewElementsIntoPrevious(current, previous) {
    var splicedChildren = previous.concat([]);
    var previousMap = $a4d40a97fb679e4b$var$childrenToObj(previous);
    for(var i = 0; i < current.length; i++){
        var child = current[i];
        var childIsNew = !previousMap[child.key];
        if (childIsNew) // This will insert the new element after the previous element.
        splicedChildren.splice(i + 1, 0, child);
    }
    return splicedChildren;
};
var $a4d40a97fb679e4b$var$childrenToObj = function childrenToObj(children) {
    return children.reduce(function(acc, child) {
        acc[child.key] = child;
        return acc;
    }, {});
};
var $a4d40a97fb679e4b$var$getMissingKeys = function getMissingKeys(current, previous) {
    var currentMapKeys = new Set(current.map(function(child) {
        return child.key;
    }));
    var missing = new Set();
    for(var i = 0; i < previous.length; i++){
        var element = previous[i];
        var _key = element.key;
        if (!currentMapKeys.has(_key)) missing.add(_key);
    }
    return missing;
};
/**
 * How does this component work?
 *
 * It looks at changes in its children to see what is removed.
 *
 * If a child is removed it clones it and wraps it with context providing an `onFinish` callback.
 *
 * The cloned child will call the `onFinish` when it finishes its exit animation,
 * which lets `ExitingPersistence` know to stop rendering it.
 */ /**
 * __ExitingPersistence__
 *
 * Useful for enabling elements to persist and animate away when they are removed from the DOM.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/motion/docs/entering-motion)
 */ var $a4d40a97fb679e4b$var$ExitingPersistence = /*#__PURE__*/ (0, $5FkrB.memo)(function(_ref) {
    var _ref$appear = _ref.appear, appear = _ref$appear === void 0 ? false : _ref$appear, children = _ref.children, exitThenEnter = _ref.exitThenEnter;
    var _useState = (0, $5FkrB.useState)([
        null,
        children
    ]), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), stateChildren = _useState2[0], setChildren = _useState2[1];
    var _useState3 = (0, $5FkrB.useState)([]), _useState4 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState3, 2), exitingChildren = _useState4[0], setExitingChildren = _useState4[1];
    var _useState5 = (0, $5FkrB.useState)(function() {
        return {
            appear: appear,
            isExiting: false
        };
    }), _useState6 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState5, 2), defaultContext = _useState6[0], setDefaultContext = _useState6[1];
    (0, $5FkrB.useEffect)(function() {
        if (!defaultContext.appear) setDefaultContext({
            appear: true,
            isExiting: false
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    /**
   * NOTE: This is a workaround for the test case written in Jira where the stateChildren is a boolean value because
   * useState is mocked to return a boolean value.
   */ if (typeof stateChildren === 'boolean') return children;
    var _stateChildren = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(stateChildren, 2), previousChildren = _stateChildren[0], currentChildren = _stateChildren[1];
    var previous = $a4d40a97fb679e4b$var$childrenToArray(previousChildren);
    var current = $a4d40a97fb679e4b$var$childrenToArray(currentChildren);
    if (currentChildren !== children) setChildren([
        currentChildren,
        children
    ]);
    var nextChildren = currentChildren !== children ? $a4d40a97fb679e4b$var$childrenToArray(children) : current;
    var missingKeys = $a4d40a97fb679e4b$var$getMissingKeys(nextChildren, previous);
    var isSomeChildRemoved = !!missingKeys.size;
    var visibleChildren = !isSomeChildRemoved && currentChildren !== children ? nextChildren : current;
    if (isSomeChildRemoved) visibleChildren = $a4d40a97fb679e4b$var$spliceNewElementsIntoPrevious(current, previous);
    if (exitThenEnter) {
        if (exitingChildren.length) visibleChildren = (0, $9Zzpd.fg)('platform-dst-motion-uplift') ? previous : exitingChildren;
        else {
            var nextExitingChildren = visibleChildren.filter(function(child) {
                return missingKeys.has(child.key);
            });
            if (nextExitingChildren.length) setExitingChildren(nextExitingChildren);
        }
    }
    if (missingKeys.size) visibleChildren = visibleChildren.map(function(child) {
        var isExiting = missingKeys.has(child.key);
        return $a4d40a97fb679e4b$var$wrapChildWithContextProvider(child, {
            appear: true,
            isExiting: isExiting,
            onFinish: isExiting ? function() {
                missingKeys.delete(child.key);
                if (missingKeys.size === 0) {
                    setChildren([
                        null,
                        children
                    ]);
                    setExitingChildren([]);
                }
            } : undefined
        });
    });
    else visibleChildren = visibleChildren.map(function(child) {
        return $a4d40a97fb679e4b$var$wrapChildWithContextProvider(child, defaultContext);
    });
    return visibleChildren;
});
var $a4d40a97fb679e4b$export$3b6f38abbdcbd000 = function useExitingPersistence() {
    return (0, $5FkrB.useContext)($a4d40a97fb679e4b$var$ExitingContext);
};
$a4d40a97fb679e4b$var$ExitingPersistence.displayName = 'ExitingPersistence';
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$a4d40a97fb679e4b$export$2e2bcd8739ae039 = $a4d40a97fb679e4b$var$ExitingPersistence;


var $5FkrB = parcelRequire("5FkrB");
/* keyframes-motion.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");
/**
 * This length includes the underscore,
 * e.g. `"_1s4A"` would be a valid atomic group hash.
 */ const $a78098db76f3c77d$var$ATOMIC_GROUP_LENGTH = 5;
function $a78098db76f3c77d$export$2e2bcd8739ae039(classNames) {
    // Shortcut: nothing to do
    if (!classNames.length) return;
    // Shortcut: don't need to do anything if we only have a single classname
    if (classNames.length === 1 && classNames[0] && // checking to see if `classNames[0]` is a string that contains other classnames
    !classNames[0].includes(' ')) return classNames[0];
    // Using an object rather than a `Map` as it performed better in our benchmarks.
    // Would be happy to move to `Map` if it proved to be better under real conditions.
    const map = {};
    // Note: using loops to minimize iterations over the collection
    for (const value of classNames){
        // Exclude all falsy values, which leaves us with populated strings
        if (!value) continue;
        // a `value` can contain multiple classnames
        const list = value.split(' ');
        for (const className of list){
            /**
             * For atomic style classnames: the `key` is the `group`
             *
             * - Later atomic classnames with the same `group` will override earlier ones
             *   (which is what we want).
             * - Assumes atomic classnames are the only things that start with `_`
             * - Could use a regex to ensure that atomic classnames are structured how we expect,
             *   but did not add that for now as it did slow things down a bit.
             *
             * For other classnames: the `key` is the whole classname
             * - Okay to remove duplicates as doing so does not impact specificity
             *
             * */ const key = className.startsWith('_') ? className.slice(0, $a78098db76f3c77d$var$ATOMIC_GROUP_LENGTH) : className;
            map[key] = className;
        }
    }
    /**
     * We are converting the `map` into a string.
     *
     * The simple way to do this would be `Object.values(map).join(' ')`.
     * However, the approach below performs 10%-20% better in benchmarks.
     *
     * For `ax()` it feels right to squeeze as much runtime performance out as we can.
     */ let result = '';
    for(const key in map)result += map[key] + ' ';
    // If we have an empty string, then our `map` was empty.
    if (!result) return;
    // remove last " " from the result (we added " " at the end of every value)
    return result.trimEnd();
}


/**
 * Think of this as the motion equivalent of the @atlaskit/theme `grid()`.
 */ var $d28cdb29d522de41$export$368bacef0dacbe05 = 25;
var $d28cdb29d522de41$export$38b928a7167ce124 = {
    none: 0,
    small: 100,
    medium: 350,
    large: 700
};



/**
 * Used to multiply the initial duration for exiting motions.
 */ var $cdbbcc1c2e33aec2$var$EXITING_MOTION_MULTIPLIER = 0.5;
var $cdbbcc1c2e33aec2$export$30fa1a2e62ae150c = {
    none: (0, $d28cdb29d522de41$export$38b928a7167ce124).none,
    small: (0, $d28cdb29d522de41$export$38b928a7167ce124).small * $cdbbcc1c2e33aec2$var$EXITING_MOTION_MULTIPLIER,
    medium: (0, $d28cdb29d522de41$export$38b928a7167ce124).medium * $cdbbcc1c2e33aec2$var$EXITING_MOTION_MULTIPLIER,
    large: (0, $d28cdb29d522de41$export$38b928a7167ce124).large * $cdbbcc1c2e33aec2$var$EXITING_MOTION_MULTIPLIER
};


var $844462dae5886456$export$c5406bd59b374abd = function isMatchMediaAvailable() {
    return typeof window !== 'undefined' && 'matchMedia' in window;
};


var $086c9375c67ced11$export$b7baf7667a68d87c = function isReducedMotion() {
    if (!(0, $844462dae5886456$export$c5406bd59b374abd)()) return false;
    var _window$matchMedia = window.matchMedia('(prefers-reduced-motion: reduce)'), matches = _window$matchMedia.matches;
    return matches;
};



var $5FkrB = parcelRequire("5FkrB");
// Handle both browser and Node.js environments
var $a487691292d75b7e$var$getHookDeps = function getHookDeps(opts) {
    switch(opts.cleanup){
        case 'next-effect':
            return undefined;
        case 'unmount':
        default:
            return [];
    }
};
var $a487691292d75b7e$export$4f34107a2b00f39c = function useSetTimeout() {
    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        cleanup: 'unmount'
    };
    var timeouts = (0, $5FkrB.useRef)([]);
    (0, $5FkrB.useEffect)(function() {
        return function() {
            if (timeouts.current.length) {
                timeouts.current.forEach(function(id) {
                    return clearTimeout(id);
                });
                timeouts.current = [];
            }
        };
    // We dynamically set this so we either clean up on the next effect - or on unmount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, $a487691292d75b7e$var$getHookDeps(opts));
    return (0, $5FkrB.useCallback)(function(handler, timeout) {
        for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)args[_key - 2] = arguments[_key];
        var id = setTimeout.apply(void 0, [
            function() {
                timeouts.current = timeouts.current.filter(function(timeoutId) {
                    return timeoutId !== id;
                });
                handler();
            },
            timeout
        ].concat(args));
        timeouts.current.push(id);
    }, []);
};




var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");


var $5FkrB = parcelRequire("5FkrB");
var $2d1e02c02964befa$export$e5c5a5f917a5871c = typeof window === 'undefined' ? (0, $5FkrB.useEffect) : (0, $5FkrB.useLayoutEffect);


/* eslint-disable @repo/internal/react/disallow-unstable-values */ 
var $5FkrB = parcelRequire("5FkrB");
function $5337269aea17b3f5$export$c485849f2e393253() {
    var identifier = (0, $5FkrB.useRef)('');
    if (!identifier.current) identifier.current = '_' + (Number(String(Math.random()).slice(2)) + Date.now() + Math.round(performance.now())).toString(36);
    return identifier.current;
}


var $933d338336ba1945$var$StaggeredEntranceContext = /*#__PURE__*/ (0, $5FkrB.createContext)(function() {
    return {
        isReady: true,
        delay: 0,
        ref: (0, $e77757f0e07afb88$export$2e2bcd8739ae039)
    };
});
var $933d338336ba1945$export$25c7213fc07ec080 = function useStaggeredEntrance() {
    var indentifier = (0, $5337269aea17b3f5$export$c485849f2e393253)();
    var context = (0, $5FkrB.useContext)($933d338336ba1945$var$StaggeredEntranceContext);
    return context(indentifier);
};
/**
 * For a list of elements that need to animate in,
 * this should be used in conjunction with entering components.
 * This does not need Javascript to execute so it will run immediately for any SSR rendered React apps before the JS has executed.
 *
 * Will dynamically add delay to each child entering component.
 * Unfortunately all entering components _NEED_ to be a direct descendant.
 */ var $933d338336ba1945$var$StaggeredEntrance = function StaggeredEntrance(_ref) {
    var children = _ref.children, column = _ref.column, _ref$columns = _ref.columns, columns = _ref$columns === void 0 ? 'responsive' : _ref$columns, _ref$delayStep = _ref.delayStep, delayStep = _ref$delayStep === void 0 ? 50 : _ref$delayStep;
    var elementRefs = (0, $5FkrB.useRef)([]);
    var indexes = [];
    var _useState = (0, $5FkrB.useState)(function() {
        if (typeof columns === 'number') // A hardcoded columns is set so bail out and set it to that!
        return columns;
        if (typeof column === 'number') // A hardcoded column is set so we will set actualColumns to be 1.
        return 1;
        // We are in "responsive" mode.
        // So we will be calculating when the Javascript executes on the client how many columns there will be.
        return 0;
    }), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), actualColumns = _useState2[0], setActualColumns = _useState2[1];
    (0, $2d1e02c02964befa$export$e5c5a5f917a5871c)(function() {
        // We want to only run this code when we are in "responsive" mode.
        // It is assumed we are in responsive mode if `columns` is "responsive",
        // we have children element refs ready to be read (i.e. if there are no children this won't run as well)
        // and finally that `actualColumns` is `0` - this is because for the first render cycle `actualColumns` will be `0` (set above)
        // and then after this layout effect runs the value for `actualColumns` will then be calculated and set.
        if (columns === 'responsive' && elementRefs.current.length && actualColumns === 0) {
            var currentTop = 0;
            var numberColumns = 0;
            if (elementRefs.current.length <= 1) {
                setActualColumns(1);
                return;
            }
            // We set the current top to the first elements.
            // We will be comparing this and incrementing the column count
            // until we hit an element that has a different offset top (or we run out of elements).
            currentTop = elementRefs.current[0] ? elementRefs.current[0].offsetTop : 0;
            for(var i = 0; i < elementRefs.current.length; i++){
                var child = elementRefs.current[i];
                if (!child) break;
                if (currentTop === child.offsetTop) {
                    numberColumns += 1;
                    if (elementRefs.current.length - 1 === i) setActualColumns(numberColumns);
                    continue;
                }
                setActualColumns(numberColumns);
                break;
            }
        }
    // We only want this effect to run once - on initial mount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement($933d338336ba1945$var$StaggeredEntranceContext.Provider, {
        value: function value(id) {
            if (!indexes.includes(id)) indexes.push(id);
            var isReady = actualColumns > 0;
            var index = indexes.indexOf(id);
            var currentColumn = column || index % actualColumns;
            var currentRow = Math.floor(index / actualColumns);
            var distanceFromTopLeftElement = currentRow + currentColumn;
            // We don't want loads of elements to have the same staggered delay as it ends up looking slow for users.
            // To get around that we calculate the logarithm using `distanceFromTopLeftElement` which ends making
            // elements appear faster the further away from the top left element.
            var delay = Math.ceil(Math.log(distanceFromTopLeftElement + 1) * delayStep * 1.5) || 0;
            return {
                delay: delay,
                isReady: isReady,
                ref: function ref(element) {
                    return elementRefs.current[index] = element;
                }
            };
        }
    }, children);
};
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$933d338336ba1945$export$2e2bcd8739ae039 = $933d338336ba1945$var$StaggeredEntrance;


var $cd3cbc249d27df0c$var$zoomIn = null;
var $cd3cbc249d27df0c$var$zoomOut = null;
var $cd3cbc249d27df0c$var$fadeIn = null;
var $cd3cbc249d27df0c$var$fadeOut = null;
var $cd3cbc249d27df0c$var$fadeInFromTop = null;
var $cd3cbc249d27df0c$var$fadeOutFromTop = null;
var $cd3cbc249d27df0c$var$fadeInFromLeft = null;
var $cd3cbc249d27df0c$var$fadeOutFromLeft = null;
var $cd3cbc249d27df0c$var$fadeInFromBottom = null;
var $cd3cbc249d27df0c$var$fadeOutFromBottom = null;
var $cd3cbc249d27df0c$var$fadeInFromRight = null;
var $cd3cbc249d27df0c$var$fadeOutFromRight = null;
var $cd3cbc249d27df0c$var$fadeInFromTopConstant = null;
var $cd3cbc249d27df0c$var$fadeOutFromTopConstant = null;
var $cd3cbc249d27df0c$var$fadeInFromLeftConstant = null;
var $cd3cbc249d27df0c$var$fadeOutFromLeftConstant = null;
var $cd3cbc249d27df0c$var$fadeInFromBottomConstant = null;
var $cd3cbc249d27df0c$var$fadeOutFromBottomConstant = null;
var $cd3cbc249d27df0c$var$fadeInFromRightConstant = null;
var $cd3cbc249d27df0c$var$fadeOutFromRightConstant = null;
var $cd3cbc249d27df0c$var$slideInFromTop = null;
var $cd3cbc249d27df0c$var$slideOutFromTop = null;
var $cd3cbc249d27df0c$var$slideInFromRight = null;
var $cd3cbc249d27df0c$var$slideOutFromRight = null;
var $cd3cbc249d27df0c$var$slideInFromBottom = null;
var $cd3cbc249d27df0c$var$slideOutFromBottom = null;
var $cd3cbc249d27df0c$var$slideInFromLeft = null;
var $cd3cbc249d27df0c$var$slideOutFromLeft = null;
/**
 * These are props that motions should use as their external props for consumers.
 * See [FadeIn](packages/helpers/motion/src/entering/fade-in.tsx) for an example usage.
 */ /**
 * This is the base INTERNAL component used for all other entering motions.
 * This does not need Javascript to execute on the client so it will run immediately
 * for any SSR rendered React apps before the JS has executed.
 */ var $cd3cbc249d27df0c$var$EnteringMotion = function EnteringMotion(_ref) {
    var children = _ref.children, animationTimingFunction = _ref.animationTimingFunction, _ref$animationTimingF = _ref.animationTimingFunctionExiting, animationTimingFunctionExiting = _ref$animationTimingF === void 0 ? animationTimingFunction : _ref$animationTimingF, enteringAnimation = _ref.enteringAnimation, _ref$exitingAnimation = _ref.exitingAnimation, exitingAnimation = _ref$exitingAnimation === void 0 ? enteringAnimation : _ref$exitingAnimation, isPaused = _ref.isPaused, onFinishMotion = _ref.onFinish, _ref$duration = _ref.duration, duration = _ref$duration === void 0 ? 'large' : _ref$duration;
    var staggered = (0, $933d338336ba1945$export$25c7213fc07ec080)();
    var _useExitingPersistenc = (0, $a4d40a97fb679e4b$export$3b6f38abbdcbd000)(), isExiting = _useExitingPersistenc.isExiting, onExitFinished = _useExitingPersistenc.onFinish, appear = _useExitingPersistenc.appear;
    var setTimeout = (0, $a487691292d75b7e$export$4f34107a2b00f39c)();
    var paused = isPaused || !staggered.isReady;
    var delay = isExiting ? 0 : staggered.delay;
    var state = isExiting ? 'exiting' : 'entering';
    var _useState = (0, $5FkrB.useState)(appear), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), hasAnimationStyles = _useState2[0], setHasAnimationStyles = _useState2[1];
    (0, $5FkrB.useEffect)(function() {
        // Tracking this to prevent changing state on an unmounted component
        var isCancelled = false;
        if (paused) return;
        // On initial mount if elements aren't set to animate on appear, we return early and callback
        if (!appear) {
            onFinishMotion && onFinishMotion(state);
            return;
        }
        /**
     * Updates relevant state.
     * Called when the animation is finished, or immediately with reduced motion.
     */ var onAnimationEnd = function onAnimationEnd() {
            if (state === 'exiting') // Updates the `ExitingPersistence` to remove this child
            onExitFinished === null || onExitFinished === void 0 || onExitFinished();
            if (!isCancelled) setHasAnimationStyles(false);
            onFinishMotion === null || onFinishMotion === void 0 || onFinishMotion(state);
        };
        if ((0, $086c9375c67ced11$export$b7baf7667a68d87c)()) {
            // If there is reduced motion there is no exit animation, so call this immediately
            onAnimationEnd();
            return;
        }
        // Elements may need animation styles back after initial mount (they could animate out)
        setHasAnimationStyles(true);
        // Queue `onAnimationEnd` for after the animation has finished
        setTimeout(onAnimationEnd, isExiting ? (0, $cdbbcc1c2e33aec2$export$30fa1a2e62ae150c)[duration] : (0, $d28cdb29d522de41$export$38b928a7167ce124)[duration] + delay);
        return function() {
            isCancelled = true;
        };
    // We ignore this for onFinishMotion as consumers could potentially inline the function
    // which would then trigger this effect every re-render.
    // We want to make it easier for consumers so we go down this path unfortunately.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        onExitFinished,
        state,
        isExiting,
        duration,
        delay,
        paused,
        setTimeout
    ]);
    return children({
        ref: staggered.ref,
        // @ts-expect-error: `ax` is not typed correctly
        className: hasAnimationStyles ? (0, $a78098db76f3c77d$export$2e2bcd8739ae039)([
            (0, $a78098db76f3c77d$export$2e2bcd8739ae039)([
                "_1o51eoah _1y0co91m _1bumglyw _sedtglyw"
            ]),
            paused && (0, $a78098db76f3c77d$export$2e2bcd8739ae039)([
                "_1y0ctrqk"
            ]),
            duration === 'small' && (0, $a78098db76f3c77d$export$2e2bcd8739ae039)([
                "_5sag1yx9"
            ]),
            duration === 'medium' && (0, $a78098db76f3c77d$export$2e2bcd8739ae039)([
                "_5sag1ttt"
            ]),
            duration === 'large' && (0, $a78098db76f3c77d$export$2e2bcd8739ae039)([
                "_5sagpwmj"
            ]),
            isExiting && duration === 'small' && (0, $a78098db76f3c77d$export$2e2bcd8739ae039)([
                "_5sag14ed"
            ]),
            isExiting && duration === 'medium' && (0, $a78098db76f3c77d$export$2e2bcd8739ae039)([
                "_5sagluct"
            ]),
            isExiting && duration === 'large' && (0, $a78098db76f3c77d$export$2e2bcd8739ae039)([
                "_5sag1ttt"
            ]),
            isExiting && (0, $a78098db76f3c77d$export$2e2bcd8739ae039)([
                "_ju255cps _1o51q7pw"
            ]),
            !isExiting && animationTimingFunction === 'linear' && (0, $a78098db76f3c77d$export$2e2bcd8739ae039)([
                "_1pglp3kn"
            ]),
            !isExiting && animationTimingFunction === 'ease-out' && (0, $a78098db76f3c77d$export$2e2bcd8739ae039)([
                "_1pgldkwg"
            ]),
            !isExiting && animationTimingFunction === 'ease-in' && (0, $a78098db76f3c77d$export$2e2bcd8739ae039)([
                "_1pgl1nzg"
            ]),
            !isExiting && animationTimingFunction === 'ease-in-40-out' && (0, $a78098db76f3c77d$export$2e2bcd8739ae039)([
                "_1pgl5y64"
            ]),
            !isExiting && animationTimingFunction === 'ease-in-60-out' && (0, $a78098db76f3c77d$export$2e2bcd8739ae039)([
                "_1pgl1ddy"
            ]),
            !isExiting && animationTimingFunction === 'ease-in-80-out' && (0, $a78098db76f3c77d$export$2e2bcd8739ae039)([
                "_1pglannl"
            ]),
            !isExiting && animationTimingFunction === 'ease-in-out' && (0, $a78098db76f3c77d$export$2e2bcd8739ae039)([
                "_1pgl1fu8"
            ]),
            isExiting && animationTimingFunction === 'linear' && (0, $a78098db76f3c77d$export$2e2bcd8739ae039)([
                "_1pglp3kn"
            ]),
            isExiting && animationTimingFunctionExiting === 'ease-out' && (0, $a78098db76f3c77d$export$2e2bcd8739ae039)([
                "_1pgldkwg"
            ]),
            isExiting && animationTimingFunctionExiting === 'ease-in' && (0, $a78098db76f3c77d$export$2e2bcd8739ae039)([
                "_1pgl1nzg"
            ]),
            isExiting && animationTimingFunctionExiting === 'ease-in-40-out' && (0, $a78098db76f3c77d$export$2e2bcd8739ae039)([
                "_1pgl5y64"
            ]),
            isExiting && animationTimingFunctionExiting === 'ease-in-60-out' && (0, $a78098db76f3c77d$export$2e2bcd8739ae039)([
                "_1pgl1ddy"
            ]),
            isExiting && animationTimingFunctionExiting === 'ease-in-80-out' && (0, $a78098db76f3c77d$export$2e2bcd8739ae039)([
                "_1pglannl"
            ]),
            isExiting && animationTimingFunctionExiting === 'ease-in-out' && (0, $a78098db76f3c77d$export$2e2bcd8739ae039)([
                "_1pgl1fu8"
            ]),
            (!isExiting && enteringAnimation === 'fade-in' || isExiting && exitingAnimation === 'fade-in') && (0, $a78098db76f3c77d$export$2e2bcd8739ae039)([
                "_j7hq1cgr"
            ]),
            (!isExiting && enteringAnimation === 'fade-out' || isExiting && exitingAnimation === 'fade-out') && (0, $a78098db76f3c77d$export$2e2bcd8739ae039)([
                "_j7hq1lln"
            ]),
            (!isExiting && enteringAnimation === 'zoom-in' || isExiting && exitingAnimation === 'zoom-in') && (0, $a78098db76f3c77d$export$2e2bcd8739ae039)([
                "_j7hqe8p0"
            ]),
            (!isExiting && enteringAnimation === 'zoom-out' || isExiting && exitingAnimation === 'zoom-out') && (0, $a78098db76f3c77d$export$2e2bcd8739ae039)([
                "_j7hqy6ql"
            ]),
            (!isExiting && enteringAnimation === 'slide-in-from-top' || isExiting && exitingAnimation === 'slide-in-from-top') && (0, $a78098db76f3c77d$export$2e2bcd8739ae039)([
                "_j7hqqshu"
            ]),
            (!isExiting && enteringAnimation === 'slide-out-from-top' || isExiting && exitingAnimation === 'slide-out-from-top') && (0, $a78098db76f3c77d$export$2e2bcd8739ae039)([
                "_j7hq7ri4"
            ]),
            (!isExiting && enteringAnimation === 'slide-in-from-right' || isExiting && exitingAnimation === 'slide-in-from-right') && (0, $a78098db76f3c77d$export$2e2bcd8739ae039)([
                "_j7hqdfjr"
            ]),
            (!isExiting && enteringAnimation === 'slide-out-from-right' || isExiting && exitingAnimation === 'slide-out-from-right') && (0, $a78098db76f3c77d$export$2e2bcd8739ae039)([
                "_j7hqonfj"
            ]),
            (!isExiting && enteringAnimation === 'slide-in-from-bottom' || isExiting && exitingAnimation === 'slide-in-from-bottom') && (0, $a78098db76f3c77d$export$2e2bcd8739ae039)([
                "_j7hq1liq"
            ]),
            (!isExiting && enteringAnimation === 'slide-out-from-bottom' || isExiting && exitingAnimation === 'slide-out-from-bottom') && (0, $a78098db76f3c77d$export$2e2bcd8739ae039)([
                "_j7hqhnf1"
            ]),
            (!isExiting && enteringAnimation === 'slide-in-from-left' || isExiting && exitingAnimation === 'slide-in-from-left') && (0, $a78098db76f3c77d$export$2e2bcd8739ae039)([
                "_j7hq1bh1"
            ]),
            (!isExiting && enteringAnimation === 'slide-out-from-left' || isExiting && exitingAnimation === 'slide-out-from-left') && (0, $a78098db76f3c77d$export$2e2bcd8739ae039)([
                "_j7hqj08w"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-top' || isExiting && exitingAnimation === 'fade-in-from-top') && (0, $a78098db76f3c77d$export$2e2bcd8739ae039)([
                "_j7hq2iua"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-top' || isExiting && exitingAnimation === 'fade-out-from-top') && (0, $a78098db76f3c77d$export$2e2bcd8739ae039)([
                "_j7hq39va"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-left' || isExiting && exitingAnimation === 'fade-in-from-left') && (0, $a78098db76f3c77d$export$2e2bcd8739ae039)([
                "_j7hq15m2"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-left' || isExiting && exitingAnimation === 'fade-out-from-left') && (0, $a78098db76f3c77d$export$2e2bcd8739ae039)([
                "_j7hq1yiv"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-bottom' || isExiting && exitingAnimation === 'fade-in-from-bottom') && (0, $a78098db76f3c77d$export$2e2bcd8739ae039)([
                "_j7hq1w00"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-bottom' || isExiting && exitingAnimation === 'fade-out-from-bottom') && (0, $a78098db76f3c77d$export$2e2bcd8739ae039)([
                "_j7hqzy3z"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-right' || isExiting && exitingAnimation === 'fade-in-from-right') && (0, $a78098db76f3c77d$export$2e2bcd8739ae039)([
                "_j7hqpqak"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-right' || isExiting && exitingAnimation === 'fade-out-from-right') && (0, $a78098db76f3c77d$export$2e2bcd8739ae039)([
                "_j7hq1ebg"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-top-constant' || isExiting && exitingAnimation === 'fade-in-from-top-constant') && (0, $a78098db76f3c77d$export$2e2bcd8739ae039)([
                "_j7hqm2e2"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-top-constant' || isExiting && exitingAnimation === 'fade-out-from-top-constant') && (0, $a78098db76f3c77d$export$2e2bcd8739ae039)([
                "_j7hq97jn"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-left-constant' || isExiting && exitingAnimation === 'fade-in-from-left-constant') && (0, $a78098db76f3c77d$export$2e2bcd8739ae039)([
                "_j7hqovgq"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-left-constant' || isExiting && exitingAnimation === 'fade-out-from-left-constant') && (0, $a78098db76f3c77d$export$2e2bcd8739ae039)([
                "_j7hq15do"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-bottom-constant' || isExiting && exitingAnimation === 'fade-in-from-bottom-constant') && (0, $a78098db76f3c77d$export$2e2bcd8739ae039)([
                "_j7hq797a"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-bottom-constant' || isExiting && exitingAnimation === 'fade-out-from-bottom-constant') && (0, $a78098db76f3c77d$export$2e2bcd8739ae039)([
                "_j7hqwo7r"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-right-constant' || isExiting && exitingAnimation === 'fade-in-from-right-constant') && (0, $a78098db76f3c77d$export$2e2bcd8739ae039)([
                "_j7hqt8u5"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-right-constant' || isExiting && exitingAnimation === 'fade-out-from-right-constant') && (0, $a78098db76f3c77d$export$2e2bcd8739ae039)([
                "_j7hq1pgp"
            ])
        ]) : '',
        style: {
            animationDelay: "".concat(delay, "ms")
        }
    }, state);
};
var $cd3cbc249d27df0c$export$2e2bcd8739ae039 = $cd3cbc249d27df0c$var$EnteringMotion;


var $5ca2cbc46961ee1d$var$invertedDirection = {
    top: 'bottom',
    bottom: 'top',
    left: 'right',
    right: 'left'
};
/**
 * Props for controlling the behavior of the FadeIn animation
 */ /**
 * __FadeIn__
 *
 * Useful for fading in one or more elements.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/motion/docs/entering-motion)
 */ var $5ca2cbc46961ee1d$var$FadeIn = function FadeIn(_ref) {
    var children = _ref.children, _ref$duration = _ref.duration, duration = _ref$duration === void 0 ? 'large' : _ref$duration, entranceDirection = _ref.entranceDirection, exitDirection = _ref.exitDirection, _ref$distance = _ref.distance, distance = _ref$distance === void 0 ? 'proportional' : _ref$distance, onFinish = _ref.onFinish, isPaused = _ref.isPaused;
    var invertedEntranceDirection = entranceDirection !== undefined ? $5ca2cbc46961ee1d$var$invertedDirection[entranceDirection] : undefined;
    var isExitDirect = Boolean(exitDirection || invertedEntranceDirection) ? "fade-out-from-".concat(exitDirection || invertedEntranceDirection).concat(distance === 'proportional' ? '' : '-constant') : 'fade-out';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $cd3cbc249d27df0c$export$2e2bcd8739ae039), {
        duration: duration,
        enteringAnimation: entranceDirection ? "fade-in-from-".concat(entranceDirection).concat(distance === 'proportional' ? '' : '-constant') : 'fade-in',
        exitingAnimation: isExitDirect,
        animationTimingFunction: "ease-in-out",
        onFinish: onFinish,
        isPaused: isPaused
    }, children);
};
var $5ca2cbc46961ee1d$export$2e2bcd8739ae039 = $5ca2cbc46961ee1d$var$FadeIn;



var $fC8ib = parcelRequire("fC8ib");

var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");

var $lsgol = parcelRequire("lsgol");

var $iYJcE = parcelRequire("iYJcE");
function $35792b80c2523739$export$6d8c2b45c99d6e3f(_ref) {
    var viewportPadding = _ref.viewportPadding;
    return [
        {
            /**
     * Performing DOM measurements in the 'read' phase,
     * which is the convention for popper modifiers
     */ name: 'maxSizeData',
            enabled: true,
            phase: 'read',
            fn: function fn(_ref2) {
                var state = _ref2.state, name = _ref2.name;
                if (!window.visualViewport) return;
                state.modifiersData[name] = {
                    viewport: {
                        width: window.visualViewport.width,
                        height: window.visualViewport.height
                    }
                };
            }
        },
        {
            /**
     * Applying max size CSS
     */ name: 'maxSize',
            enabled: true,
            phase: 'beforeWrite',
            requiresIfExists: [
                'offset',
                'preventOverflow',
                'flip'
            ],
            fn: function fn(_ref3) {
                var _data$viewport, _data$viewport2, _state$modifiersData$2, _state$modifiersData;
                var state = _ref3.state;
                var data = state.modifiersData.maxSizeData;
                if (typeof (data === null || data === void 0 || (_data$viewport = data.viewport) === null || _data$viewport === void 0 ? void 0 : _data$viewport.width) !== 'number' || typeof (data === null || data === void 0 || (_data$viewport2 = data.viewport) === null || _data$viewport2 === void 0 ? void 0 : _data$viewport2.height) !== 'number') // This shouldn't occur in a real browser but might in non-browser test environments
                return;
                var viewport = data.viewport;
                var _state$modifiersData$ = state.modifiersData.popperOffsets, popperOffsets = _state$modifiersData$ === void 0 ? {
                    x: 0,
                    y: 0
                } : _state$modifiersData$;
                var _state$placement$spli = state.placement.split('-'), _state$placement$spli2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_state$placement$spli, 1), basePlacement = _state$placement$spli2[0];
                var placementOffset = (_state$modifiersData$2 = (_state$modifiersData = state.modifiersData) === null || _state$modifiersData === void 0 || (_state$modifiersData = _state$modifiersData.offset) === null || _state$modifiersData === void 0 ? void 0 : _state$modifiersData[state.placement]) !== null && _state$modifiersData$2 !== void 0 ? _state$modifiersData$2 : {
                    x: 0,
                    y: 0
                };
                // By default we set these to the entire viewport (minus padding)
                // Each placement direction will overwrite one of these
                var maxWidth = viewport.width - 2 * viewportPadding;
                var maxHeight = viewport.height - 2 * viewportPadding;
                if (basePlacement === 'top') maxHeight = state.rects.reference.y + // Viewport-relative position of reference element
                placementOffset.y - // Space between popper and reference
                viewportPadding;
                if (basePlacement === 'bottom') maxHeight = viewport.height - popperOffsets.y - // Viewport-relative position of popper
                viewportPadding;
                if (basePlacement === 'left') maxWidth = state.rects.reference.x + // Viewport-relative position of reference element
                placementOffset.x - // Space between popper and reference
                viewportPadding;
                if (basePlacement === 'right') maxWidth = viewport.width - popperOffsets.x - // Viewport-relative position of popper
                viewportPadding;
                state.styles.popper.maxWidth = "".concat(maxWidth, "px");
                state.styles.popper.maxHeight = "".concat(maxHeight, "px");
            }
        }
    ];
}



// Export types from PopperJS / React Popper
var $90dbe317b033cbba$var$viewportPadding = 5;
var $90dbe317b033cbba$var$constantModifiers = [
    {
        name: 'flip',
        options: {
            flipVariations: false,
            padding: $90dbe317b033cbba$var$viewportPadding,
            boundary: 'clippingParents',
            rootBoundary: 'viewport'
        }
    }
];
function $90dbe317b033cbba$var$defaultChildrenFn() {
    return null;
}
var $90dbe317b033cbba$var$defaultOffset = [
    0,
    8
];
function $90dbe317b033cbba$export$badac9ada3a0bdf9(_ref) {
    var _ref$children = _ref.children, children = _ref$children === void 0 ? $90dbe317b033cbba$var$defaultChildrenFn : _ref$children, _ref$offset = _ref.offset, offset = _ref$offset === void 0 ? $90dbe317b033cbba$var$defaultOffset : _ref$offset, _ref$placement = _ref.placement, placement = _ref$placement === void 0 ? 'bottom-start' : _ref$placement, _ref$referenceElement = _ref.referenceElement, referenceElement = _ref$referenceElement === void 0 ? undefined : _ref$referenceElement, modifiers = _ref.modifiers, _ref$strategy = _ref.strategy, strategy = _ref$strategy === void 0 ? 'fixed' : _ref$strategy, _ref$shouldFitViewpor = _ref.shouldFitViewport, shouldFitViewport = _ref$shouldFitViewpor === void 0 ? false : _ref$shouldFitViewpor;
    var _offset = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(offset, 2), offsetX = _offset[0], offsetY = _offset[1];
    var internalModifiers = (0, $5FkrB.useMemo)(function() {
        var preventOverflowModifier = {
            name: 'preventOverflow',
            options: {
                padding: $90dbe317b033cbba$var$viewportPadding,
                rootBoundary: shouldFitViewport ? 'viewport' : 'document'
            }
        };
        var offsetModifier = {
            name: 'offset',
            options: {
                offset: [
                    offsetX,
                    offsetY
                ]
            }
        };
        var maxSizeModifiers = shouldFitViewport ? (0, $35792b80c2523739$export$6d8c2b45c99d6e3f)({
            viewportPadding: $90dbe317b033cbba$var$viewportPadding
        }) : [];
        // @ts-ignore Type errors from incompatible @popperjs/core versions between Jira and AFM Platform... we are using ts-ignore here because ts-expect-error will cause an "Unused '@ts-expect-error' directive." error
        return [].concat($90dbe317b033cbba$var$constantModifiers, [
            preventOverflowModifier,
            offsetModifier
        ], (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(maxSizeModifiers));
    }, [
        offsetX,
        offsetY,
        shouldFitViewport
    ]);
    // Merge custom props and memoize
    var mergedModifiers = (0, $5FkrB.useMemo)(function() {
        if (modifiers == null) return internalModifiers;
        return [].concat((0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(internalModifiers), (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(modifiers));
    }, [
        internalModifiers,
        modifiers
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $lsgol.Popper), {
        modifiers: mergedModifiers,
        placement: placement,
        strategy: strategy,
        referenceElement: referenceElement
    }, children);
}



var $fV8Mu = parcelRequire("fV8Mu");
/* eslint-disable no-console */ var $ba3ec21048f31c55$var$printed = {};
function $ba3ec21048f31c55$export$2e2bcd8739ae039(message) {
    if ($ba3ec21048f31c55$var$printed[message]) return;
    $ba3ec21048f31c55$var$printed[message] = true;
    if (typeof window !== 'undefined') console.warn(message);
}


function $9379f910312450ae$export$2e2bcd8739ae039(packageName, api, additionalMessage) {
    (0, $ba3ec21048f31c55$export$2e2bcd8739ae039)("[".concat(packageName, "]: The ").concat(api, " is deprecated.").concat(additionalMessage && " ".concat(additionalMessage)));
}


var $0847c7880a00bfd3$export$44ffba16bd48dac6 = '__ATLASKIT_THEME__';
var $0847c7880a00bfd3$export$c93026a968943f95 = 'light';
var $0847c7880a00bfd3$export$6ba72c8346b4c57e = [
    'light',
    'dark'
];
var $0847c7880a00bfd3$export$8e24544ddba725ee = function focusRing() {
    var color = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "var(--ds-border-focused, #4688EC)";
    var outlineWidth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
    (0, $9379f910312450ae$export$2e2bcd8739ae039)('@atlaskit/theme', 'focus ring mixin', 'Please use `@atlaskit/focus-ring` instead.');
    return "\n  &:focus {\n    outline: none;\n    box-shadow: 0px 0px 0px ".concat(outlineWidth, "px ").concat(color, ";\n  }\n");
};
var $0847c7880a00bfd3$export$c0dd343266bc3261 = function noFocusRing() {
    return "\n  box-shadow: none;\n";
};
var $0847c7880a00bfd3$export$7be255094ccdc533 = {
    card: function card() {
        return 100;
    },
    navigation: function navigation() {
        return 200;
    },
    dialog: function dialog() {
        return 300;
    },
    layer: function layer() {
        return 400;
    },
    blanket: function blanket() {
        return 500;
    },
    modal: function modal() {
        return 510;
    },
    flag: function flag() {
        return 600;
    },
    spotlight: function spotlight() {
        return 700;
    },
    tooltip: function tooltip() {
        return 9999;
    }
};
var $0847c7880a00bfd3$export$a1b3edb637fb4f35 = function visuallyHidden() {
    (0, $9379f910312450ae$export$2e2bcd8739ae039)('@atlaskit/theme', 'visually hidden mixin', 'Please use `@atlaskit/visually-hidden` instead.');
    return {
        border: '0 !important',
        clip: 'rect(1px, 1px, 1px, 1px) !important',
        height: '1px !important',
        overflow: 'hidden !important',
        padding: '0 !important',
        position: 'absolute !important',
        width: '1px !important',
        whiteSpace: 'nowrap !important'
    };
};
var $0847c7880a00bfd3$export$ba1d834b86d72a09 = $0847c7880a00bfd3$export$a1b3edb637fb4f35;
var $0847c7880a00bfd3$export$e497e856b4f89fcd = function skeletonShimmer() {
    return {
        css: {
            backgroundColor: "var(--ds-skeleton, #0515240F)",
            animationDuration: '1.5s',
            animationIterationCount: 'infinite',
            animationTimingFunction: 'linear',
            animationDirection: 'alternate'
        },
        keyframes: {
            from: {
                backgroundColor: "var(--ds-skeleton, #0515240F)"
            },
            to: {
                backgroundColor: "var(--ds-skeleton-subtle, #17171708)"
            }
        }
    };
};


/* eslint-disable @atlaskit/design-system/no-direct-use-of-web-platform-drag-and-drop */ /**
 * We are listening directly to drag events instead of using a monitor from
 * `@atlaskit/pragmatic-drag-and-drop` to avoid the bundle size cost, as it
 * would affect almost every view in every app.
 *
 * We can reconsider this choice in the future.
 */ 
var $7QpUe = parcelRequire("7QpUe");
var $752ab03f37f22fda$var$registrations = new Set();
var $752ab03f37f22fda$var$cleanupEndEventListeners = null;
function $752ab03f37f22fda$var$onDragStart() {
    if ($752ab03f37f22fda$var$cleanupEndEventListeners) // If the cleanup function exists then we've already run this
    return;
    $752ab03f37f22fda$var$cleanupEndEventListeners = (0, $7QpUe.bindAll)(window, [
        {
            type: 'dragend',
            listener: $752ab03f37f22fda$var$onDragEnd
        },
        {
            type: 'pointerdown',
            listener: $752ab03f37f22fda$var$onDragEnd
        },
        {
            type: 'pointermove',
            listener: function() {
                var callCount = 0;
                return function listener() {
                    // Using 20 as it is far bigger than the most observed (3)
                    if (callCount < 20) {
                        callCount++;
                        return;
                    }
                    $752ab03f37f22fda$var$onDragEnd();
                };
            }()
        }
    ]);
    var clone = Array.from($752ab03f37f22fda$var$registrations);
    clone.forEach(function(subscriber) {
        subscriber.onDragStart();
    });
}
function $752ab03f37f22fda$var$onDragEnd() {
    var _cleanupEndEventListe;
    (_cleanupEndEventListe = $752ab03f37f22fda$var$cleanupEndEventListeners) === null || _cleanupEndEventListe === void 0 || _cleanupEndEventListe();
    $752ab03f37f22fda$var$cleanupEndEventListeners = null;
    var clone = Array.from($752ab03f37f22fda$var$registrations);
    clone.forEach(function(subscriber) {
        subscriber.onDragEnd();
    });
}
function $752ab03f37f22fda$var$bindStartEvents() {
    return (0, $7QpUe.bindAll)(window, [
        {
            type: 'dragstart',
            listener: $752ab03f37f22fda$var$onDragStart
        },
        {
            type: 'dragenter',
            listener: $752ab03f37f22fda$var$onDragStart
        }
    ]);
}
var $752ab03f37f22fda$var$cleanupStartEventListeners = null;
function $752ab03f37f22fda$export$6503ec6e8aabbaf(registration) {
    // if first registration, bind event listeners
    if (!$752ab03f37f22fda$var$cleanupStartEventListeners) // note: currently never unbinding these event listeners
    $752ab03f37f22fda$var$cleanupStartEventListeners = $752ab03f37f22fda$var$bindStartEvents();
    $752ab03f37f22fda$var$registrations.add(registration);
    /**
   * The reasoning for this behavior is so that if a tooltip mounts during
   * a drag it can still be suppressed.
   *
   * We use a separate callback instead of onDragStart to avoid infinite loops.
   */ registration.onRegister({
        isDragging: $752ab03f37f22fda$var$cleanupEndEventListeners !== null
    });
    return function unregister() {
        $752ab03f37f22fda$var$registrations.delete(registration);
        if ($752ab03f37f22fda$var$registrations.size === 0) {
            var _cleanupStartEventLis;
            (_cleanupStartEventLis = $752ab03f37f22fda$var$cleanupStartEventListeners) === null || _cleanupStartEventLis === void 0 || _cleanupStartEventLis();
            $752ab03f37f22fda$var$cleanupStartEventListeners = null;
        }
    };
}


function $e8607a2d873b3355$export$2e68479e0a5d8746(mousePos, _ref) {
    var targetElement = _ref.targetElement, tooltipPosition = _ref.tooltipPosition;
    if (tooltipPosition === 'mouse') return {
        getBoundingClientRect: function getBoundingClientRect() {
            return DOMRect.fromRect({
                x: mousePos.clientX,
                y: mousePos.clientY,
                width: 0,
                height: 0
            });
        }
    };
    var targetRect = targetElement.getBoundingClientRect();
    if (tooltipPosition === 'mouse-x') return {
        getBoundingClientRect: function getBoundingClientRect() {
            return DOMRect.fromRect({
                x: mousePos.clientX,
                y: targetRect.top,
                width: 0,
                height: targetRect.height
            });
        }
    };
    if (tooltipPosition === 'mouse-y') return {
        getBoundingClientRect: function getBoundingClientRect() {
            return DOMRect.fromRect({
                x: targetRect.left,
                y: mousePos.clientY,
                width: targetRect.width,
                height: 0
            });
        }
    };
    throw new Error("Invalid tooltip position for virtual element: ".concat(tooltipPosition));
}


var $20886030c0da208f$var$delayId = null;
function $20886030c0da208f$var$clearScheduled() {
    if ($20886030c0da208f$var$delayId != null) {
        window.clearTimeout($20886030c0da208f$var$delayId);
        $20886030c0da208f$var$delayId = null;
    }
}
function $20886030c0da208f$var$scheduleTimeout(fn, delay) {
    $20886030c0da208f$var$clearScheduled();
    $20886030c0da208f$var$delayId = window.setTimeout(function() {
        $20886030c0da208f$var$delayId = null;
        fn();
    }, delay);
}
// This file is a singleton for managing tooltips
var $20886030c0da208f$var$active = null;
function $20886030c0da208f$export$57bf213be019eeb0(entry) {
    var phase = 'waiting-to-show';
    function isActive() {
        return Boolean($20886030c0da208f$var$active && $20886030c0da208f$var$active.entry === entry);
    }
    function cleanup() {
        if (isActive()) {
            $20886030c0da208f$var$clearScheduled();
            $20886030c0da208f$var$active = null;
        }
    }
    function done() {
        if (isActive()) entry.done();
        phase = 'done';
        cleanup();
    }
    function immediatelyHideAndDone() {
        if (isActive()) entry.hide({
            isImmediate: true
        });
        done();
    }
    function keep() {
        if (!isActive()) return;
        // aborting a wait to hide
        if (phase === 'waiting-to-hide') {
            phase = 'shown';
            $20886030c0da208f$var$clearScheduled();
            return;
        }
        // aborting hide animation
        if (phase === 'hide-animating') {
            phase = 'shown';
            $20886030c0da208f$var$clearScheduled();
            entry.show({
                isImmediate: false
            });
            return;
        }
    }
    function requestHide(_ref) {
        var isImmediate = _ref.isImmediate;
        if (!isActive()) return;
        // If we were not showing yet anyway; finish straight away
        if (phase === 'waiting-to-show') {
            immediatelyHideAndDone();
            return;
        }
        // already waiting to hide
        if (phase === 'waiting-to-hide') return;
        if (isImmediate) {
            immediatelyHideAndDone();
            return;
        }
        phase = 'waiting-to-hide';
        $20886030c0da208f$var$scheduleTimeout(function() {
            phase = 'hide-animating';
            entry.hide({
                isImmediate: false
            });
        }, entry.delay);
    }
    function finishHideAnimation() {
        if (isActive() && phase === 'hide-animating') done();
    }
    function isVisible() {
        return phase === 'shown' || phase === 'waiting-to-hide' || phase === 'hide-animating';
    }
    function start() {
        var shouldAlwaysFadeIn = entry.shouldAlwaysFadeIn;
        var showImmediately = Boolean($20886030c0da208f$var$active && $20886030c0da208f$var$active.isVisible()) && !shouldAlwaysFadeIn;
        // If there was an active tooltip; we tell it to remove itself at once!
        if ($20886030c0da208f$var$active) {
            $20886030c0da208f$var$clearScheduled();
            $20886030c0da208f$var$active.entry.hide({
                isImmediate: true
            });
            $20886030c0da208f$var$active.entry.done();
            $20886030c0da208f$var$active = null;
        }
        // this tooltip is now the active tooltip
        $20886030c0da208f$var$active = {
            entry: entry,
            isVisible: isVisible
        };
        function show() {
            phase = 'shown';
            entry.show({
                isImmediate: showImmediately
            });
        }
        if (showImmediately) {
            show();
            return;
        }
        phase = 'waiting-to-show';
        $20886030c0da208f$var$scheduleTimeout(show, entry.delay);
    }
    // let's get started!
    start();
    var result = {
        keep: keep,
        abort: cleanup,
        isActive: isActive,
        requestHide: requestHide,
        finishHideAnimation: finishHideAnimation,
        mousePos: entry.source.type === 'mouse' ? {
            clientX: entry.source.clientX,
            clientY: entry.source.clientY
        } : null
    };
    return result;
}



var $5FkrB = parcelRequire("5FkrB");
function $24b0504f56d5b7c1$export$f680877a34711e37() {
    // React uses `:` or `«»` in selectors which breaks `document.querySelector(…)`.
    // Replace with `_` to match future React 19 functionality.
    return (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).useId().replace(/[:«»]/g, '_');
}


function $e21a8b537f3d99b4$export$6ee17796e3d70de2() {
    var uid = (0, $24b0504f56d5b7c1$export$f680877a34711e37)();
    return function(id) {
        return "".concat(uid, "-").concat(id.toString());
    };
}


function $e266314cb40581a7$export$2e2bcd8739ae039(prefix, shouldRenderId) {
    var seed = (0, $e21a8b537f3d99b4$export$6ee17796e3d70de2)();
    return shouldRenderId ? "".concat(seed(prefix)) : undefined;
}


/* tooltip-container.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $5FkrB = parcelRequire("5FkrB");

/* tooltip-primitive.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $5FkrB = parcelRequire("5FkrB");

/* tooltip-shortcut.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $5FkrB = parcelRequire("5FkrB");

var $6f4cc550ae8ac983$var$styles = {
    shortcutSegmentsContainer: "_zulpv77o _1e0c1txw _1q511b66 _85i5v77o",
    shortcutSegment: "_11c8wadc _2rkolb4i _1dqonqa1 _189ee4h9 _1h6d1ihb _1e0c1txw _4cvr1h6o _4t3i1k92 _vchhusvi _1q51v77o _85i5v77o _bozg12x7 _y4ti12x7 _16qsn7od _1254n7od _cgnln7od _syazn7od _ahbqn7od _12l2n7od _1pfhn7od _6rthn7od _1ul9n7od _w19jn7od _bfhk261p"
};
var $6f4cc550ae8ac983$export$5bcbc43c84236222 = function TooltipShortcut(_ref) {
    var shortcut = _ref.shortcut;
    return /*#__PURE__*/ $5FkrB.createElement("div", {
        className: (0, $a78098db76f3c77d$export$2e2bcd8739ae039)([
            $6f4cc550ae8ac983$var$styles.shortcutSegmentsContainer
        ])
    }, shortcut.map(function(segment, index) {
        return /*#__PURE__*/ $5FkrB.createElement("kbd", {
            key: "".concat(segment, "-").concat(index),
            className: (0, $a78098db76f3c77d$export$2e2bcd8739ae039)([
                $6f4cc550ae8ac983$var$styles.shortcutSegment
            ])
        }, segment);
    }));
};


var $92a813cf9d41da56$var$primitiveStyles = null;
/**
 * The lower level component for rendering a tooltip.
 */ var $92a813cf9d41da56$var$TooltipPrimitive = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function TooltipPrimitive(_ref, ref) {
    var style = _ref.style, className = _ref.className, children = _ref.children, placement = _ref.placement, testId = _ref.testId, onMouseOut = _ref.onMouseOut, onMouseOver = _ref.onMouseOver, id = _ref.id, shortcut = _ref.shortcut;
    return /*#__PURE__*/ $5FkrB.createElement("div", {
        ref: ref,
        style: style,
        "data-testid": testId ? "".concat(testId, "--wrapper") : undefined
    }, /*#__PURE__*/ $5FkrB.createElement("div", {
        role: "tooltip",
        className: (0, $a78098db76f3c77d$export$2e2bcd8739ae039)([
            "_80om73ad",
            className
        ]),
        onMouseOut: onMouseOut,
        onMouseOver: onMouseOver,
        "data-placement": placement,
        "data-testid": testId,
        id: id
    }, children, shortcut && /*#__PURE__*/ $5FkrB.createElement((0, $6f4cc550ae8ac983$export$5bcbc43c84236222), {
        shortcut: shortcut
    })));
});
$92a813cf9d41da56$var$TooltipPrimitive.displayName = 'TooltipPrimitive';
var $92a813cf9d41da56$export$2e2bcd8739ae039 = $92a813cf9d41da56$var$TooltipPrimitive;


var $08315f6785ccbc22$var$styles = {
    base: "_2rkofajl _11c8wadc _vchhusvi _p12fp3fh _bfhk1aqn _syaz15cr _152tze3t _1e02ze3t _1i4q1hna _1q511b66 _85i51b66 _y4ti12x7 _bozg12x7 _slp31hna",
    truncate: "_1reo15vq _18m915vq _p12f1pna _1bto1l2s _o5721q9c"
};
/**
 * Used as the default tooltip container component for the exported `Tooltip` component.
 * Adds some styles to the tooltip primitive.
 */ var $08315f6785ccbc22$var$TooltipContainer = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function TooltipContainer(_ref, ref) {
    var style = _ref.style, className = _ref.className, children = _ref.children, truncate = _ref.truncate, placement = _ref.placement, testId = _ref.testId, onMouseOut = _ref.onMouseOut, onMouseOver = _ref.onMouseOver, id = _ref.id, shortcut = _ref.shortcut;
    return /*#__PURE__*/ $5FkrB.createElement((0, $92a813cf9d41da56$export$2e2bcd8739ae039), {
        ref: ref,
        style: style,
        className: (0, $a78098db76f3c77d$export$2e2bcd8739ae039)([
            $08315f6785ccbc22$var$styles.base,
            truncate && $08315f6785ccbc22$var$styles.truncate,
            className
        ]),
        placement: placement,
        testId: testId,
        id: id,
        onMouseOut: onMouseOut,
        onMouseOver: onMouseOver,
        shortcut: shortcut
    }, children);
});
$08315f6785ccbc22$var$TooltipContainer.displayName = 'TooltipContainer';
var $08315f6785ccbc22$export$2e2bcd8739ae039 = $08315f6785ccbc22$var$TooltipContainer;


function $32d4a3c4842e3ceb$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $32d4a3c4842e3ceb$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $32d4a3c4842e3ceb$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $32d4a3c4842e3ceb$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $32d4a3c4842e3ceb$var$tooltipZIndex = (0, $0847c7880a00bfd3$export$7be255094ccdc533).tooltip();
var $32d4a3c4842e3ceb$var$analyticsAttributes = {
    componentName: 'tooltip',
    packageName: "@atlaskit/tooltip",
    packageVersion: "21.2.0"
};
// Inverts motion direction
var $32d4a3c4842e3ceb$var$invertedDirection = {
    top: 'bottom',
    bottom: 'top',
    left: 'right',
    right: 'left'
};
/**
 * Converts a Popper placement to it's general direction.
 *
 * @param placement - Popper Placement value, e.g. 'top-start'
 * @returns Popper Direction, e.g. 'top'
 */ var $32d4a3c4842e3ceb$var$getDirectionFromPlacement = function getDirectionFromPlacement(placement) {
    return placement.split('-')[0];
};
/**
 * __Tooltip__
 *
 * A tooltip is a floating, non-actionable label used to explain a user interface element or feature.
 */ function $32d4a3c4842e3ceb$var$Tooltip(_ref) {
    var children = _ref.children, _ref$position = _ref.position, position = _ref$position === void 0 ? 'bottom' : _ref$position, _ref$mousePosition = _ref.mousePosition, mousePosition = _ref$mousePosition === void 0 ? 'bottom' : _ref$mousePosition, content = _ref.content, _ref$truncate = _ref.truncate, truncate = _ref$truncate === void 0 ? false : _ref$truncate, _ref$component = _ref.component, Container = _ref$component === void 0 ? (0, $08315f6785ccbc22$export$2e2bcd8739ae039) : _ref$component, _ref$tag = _ref.tag, TargetContainer = _ref$tag === void 0 ? 'div' : _ref$tag, testId = _ref.testId, _ref$delay = _ref.delay, delay = _ref$delay === void 0 ? 300 : _ref$delay, _ref$onShow = _ref.onShow, onShow = _ref$onShow === void 0 ? (0, $e77757f0e07afb88$export$2e2bcd8739ae039) : _ref$onShow, _ref$onHide = _ref.onHide, onHide = _ref$onHide === void 0 ? (0, $e77757f0e07afb88$export$2e2bcd8739ae039) : _ref$onHide, canAppear = _ref.canAppear, _ref$hideTooltipOnCli = _ref.hideTooltipOnClick, hideTooltipOnClick = _ref$hideTooltipOnCli === void 0 ? false : _ref$hideTooltipOnCli, _ref$hideTooltipOnMou = _ref.hideTooltipOnMouseDown, hideTooltipOnMouseDown = _ref$hideTooltipOnMou === void 0 ? false : _ref$hideTooltipOnMou, analyticsContext = _ref.analyticsContext, _ref$strategy = _ref.strategy, strategy = _ref$strategy === void 0 ? 'fixed' : _ref$strategy, _ref$ignoreTooltipPoi = _ref.ignoreTooltipPointerEvents, ignoreTooltipPointerEvents = _ref$ignoreTooltipPoi === void 0 ? false : _ref$ignoreTooltipPoi, _ref$isScreenReaderAn = _ref.isScreenReaderAnnouncementDisabled, isScreenReaderAnnouncementDisabled = _ref$isScreenReaderAn === void 0 ? false : _ref$isScreenReaderAn, shortcut = _ref.shortcut, _ref$UNSAFE_shouldAlw = _ref.UNSAFE_shouldAlwaysFadeIn, shouldAlwaysFadeIn = _ref$UNSAFE_shouldAlw === void 0 ? false : _ref$UNSAFE_shouldAlw, _ref$UNSAFE_shouldRen = _ref.UNSAFE_shouldRenderToParent, UNSAFE_shouldRenderToParent = _ref$UNSAFE_shouldRen === void 0 ? false : _ref$UNSAFE_shouldRen;
    // Not using a gate for this check. When the gate is disabled `mouse-y` and `mouse-x` are treated as `mouse`.
    var isMousePosition = position === 'mouse' || position === 'mouse-y' || position === 'mouse-x';
    var tooltipPosition = isMousePosition ? mousePosition : position;
    var onShowHandler = (0, $9cd5662c46212572$export$1a04351537078b55)($32d4a3c4842e3ceb$var$_objectSpread({
        fn: onShow,
        action: 'displayed',
        analyticsData: analyticsContext
    }, $32d4a3c4842e3ceb$var$analyticsAttributes));
    var onHideHandler = (0, $9cd5662c46212572$export$1a04351537078b55)($32d4a3c4842e3ceb$var$_objectSpread({
        fn: onHide,
        action: 'hidden',
        analyticsData: analyticsContext
    }, $32d4a3c4842e3ceb$var$analyticsAttributes));
    var apiRef = (0, $5FkrB.useRef)(null);
    var _useState = (0, $5FkrB.useState)('hide'), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), state = _useState2[0], setState = _useState2[1];
    var targetRef = (0, $5FkrB.useRef)(null);
    var containerRef = (0, $5FkrB.useRef)(null);
    // This function is deliberately _not_ memoized as it needs to re-run every render
    // to pick up any child ref changes. If you use render props you don't have this issue.
    var setImplicitRefFromChildren = function setImplicitRefFromChildren(node) {
        containerRef.current = node;
        targetRef.current = node ? node.firstElementChild : null;
    };
    // This is memoized and passed into the render props callback.
    var setDirectRef = (0, $5FkrB.useCallback)(function(node) {
        targetRef.current = node;
    }, []);
    // Putting a few things into refs so that we don't have to break memoization
    var stableState = (0, $da62f9bc21c6475f$export$2e2bcd8739ae039)(state);
    // These props are placed in separate refs instead of a single object to reduce memory usage.
    // Placing them in the same object previously caused an increase in the number of JavaScript event listeners
    // before garbage collection.
    var onShowHandlerStable = (0, $da62f9bc21c6475f$export$2e2bcd8739ae039)(onShowHandler);
    var onHideHandlerStable = (0, $da62f9bc21c6475f$export$2e2bcd8739ae039)(onHideHandler);
    var delayStable = (0, $da62f9bc21c6475f$export$2e2bcd8739ae039)(delay);
    var canAppearStable = (0, $da62f9bc21c6475f$export$2e2bcd8739ae039)(canAppear);
    var hasCalledShowHandler = (0, $5FkrB.useRef)(false);
    var shouldAlwaysFadeInStable = (0, $da62f9bc21c6475f$export$2e2bcd8739ae039)(shouldAlwaysFadeIn);
    var start = (0, $5FkrB.useCallback)(function(api) {
        apiRef.current = api;
        hasCalledShowHandler.current = false;
    }, []);
    var done = (0, $5FkrB.useCallback)(function() {
        if (!apiRef.current) return;
        // Only call onHideHandler if we have called onShowHandler
        if (hasCalledShowHandler.current) onHideHandlerStable.current();
        apiRef.current = null;
        hasCalledShowHandler.current = false;
        // just in case
        setState('hide');
    }, [
        onHideHandlerStable
    ]);
    var abort = (0, $5FkrB.useCallback)(function() {
        if (!apiRef.current) return;
        apiRef.current.abort();
        // Only call onHideHandler if we have called onShowHandler
        if (hasCalledShowHandler.current) onHideHandlerStable.current();
        apiRef.current = null;
    }, [
        onHideHandlerStable
    ]);
    (0, $5FkrB.useEffect)(function mount() {
        return function unmount() {
            if (apiRef.current) abort();
        };
    }, [
        abort
    ]);
    var isDraggingRef = (0, $5FkrB.useRef)(false);
    (0, $5FkrB.useEffect)(function() {
        return (0, $752ab03f37f22fda$export$6503ec6e8aabbaf)({
            onRegister: function onRegister(_ref2) {
                var isDragging = _ref2.isDragging;
                isDraggingRef.current = isDragging;
            },
            onDragStart: function onDragStart() {
                var _apiRef$current;
                /**
         * Hiding any visible tooltips when a drag starts because otherwise it
         * looks janky (disappears and reappears), and is not required.
         */ (_apiRef$current = apiRef.current) === null || _apiRef$current === void 0 || _apiRef$current.requestHide({
                    isImmediate: true
                });
                isDraggingRef.current = true;
            },
            onDragEnd: function onDragEnd() {
                isDraggingRef.current = false;
            }
        });
    }, []);
    var tryShowTooltip = (0, $5FkrB.useCallback)(function(source) {
        var _canAppearStable$curr;
        /**
     * Prevent tooltips from being shown during a drag. This can occur with
     * the native drag and drop API, where some pointer events can fire
     * when they should not and lead to jank with tooltips.
     */ if (isDraggingRef.current) return;
        // Another tooltip is has been active but we still have the old `api`
        // around. We need to finish up the last usage.
        // Note: just being safe - this should not happen
        if (apiRef.current && !apiRef.current.isActive()) abort();
        // This tooltip is already active, we can exit
        if (apiRef.current && apiRef.current.isActive()) {
            apiRef.current.keep();
            return;
        }
        /**
     * Check if tooltip is allowed to show.
     *
     * Once a tooltip has started, or has scheduled to start
     * we won't be checking `canAppear` again.
     *
     * - We don't want tooltips to disappear once they are shown
     * - For consistency, we start after a single positive `canAppear`.
     *   Otherwise the amount of times we ask consumers would depend on
     *   how many times we get a "mousemove", which _could_ lead to situations
     *   where moving the mouse could result in a different outcome to if
     *   the mouse was not moved.
     */ if (canAppearStable.current && !((_canAppearStable$curr = canAppearStable.current) !== null && _canAppearStable$curr !== void 0 && _canAppearStable$curr.call(canAppearStable))) return;
        var entry = {
            source: source,
            delay: delayStable.current,
            show: function show(_ref3) {
                var isImmediate = _ref3.isImmediate;
                // Call the onShow handler if it hasn't been called yet
                if (!hasCalledShowHandler.current) {
                    hasCalledShowHandler.current = true;
                    onShowHandlerStable.current();
                }
                setState(!isImmediate ? 'fade-in' : 'show-immediate');
            },
            hide: function hide(_ref4) {
                var isImmediate = _ref4.isImmediate;
                if (isImmediate) setState('hide');
                else setState('before-fade-out');
            },
            done: done,
            shouldAlwaysFadeIn: shouldAlwaysFadeInStable.current
        };
        var api = (0, $20886030c0da208f$export$57bf213be019eeb0)(entry);
        start(api);
    }, [
        canAppearStable,
        delayStable,
        done,
        start,
        abort,
        onShowHandlerStable,
        shouldAlwaysFadeInStable
    ]);
    var hideTooltipOnEsc = (0, $5FkrB.useCallback)(function() {
        var _apiRef$current2;
        (_apiRef$current2 = apiRef.current) === null || _apiRef$current2 === void 0 || _apiRef$current2.requestHide({
            isImmediate: true
        });
    }, [
        apiRef
    ]);
    (0, $16699ead915fb8fe$export$2e2bcd8739ae039)({
        onClose: hideTooltipOnEsc,
        isDisabled: state === 'hide' || state === 'fade-out'
    });
    (0, $5FkrB.useEffect)(function() {
        if (state === 'hide') return 0, $e77757f0e07afb88$export$2e2bcd8739ae039;
        if (state === 'before-fade-out') setState('fade-out');
        var unbind = (0, $7QpUe.bind)(window, {
            type: 'scroll',
            listener: function listener() {
                if (apiRef.current) apiRef.current.requestHide({
                    isImmediate: true
                });
            },
            options: {
                capture: true,
                passive: true,
                once: true
            }
        });
        return unbind;
    }, [
        state
    ]);
    var onMouseDown = (0, $5FkrB.useCallback)(function() {
        if (hideTooltipOnMouseDown && apiRef.current) apiRef.current.requestHide({
            isImmediate: true
        });
    }, [
        hideTooltipOnMouseDown
    ]);
    var onClick = (0, $5FkrB.useCallback)(function() {
        if (hideTooltipOnClick && apiRef.current) apiRef.current.requestHide({
            isImmediate: true
        });
    }, [
        hideTooltipOnClick
    ]);
    // Ideally we would be using onMouseEnter here, but
    // because we are binding the event to the target parent
    // we need to listen for the mouseover of all sub elements
    // This means when moving along a tooltip we are quickly toggling
    // between api.requestHide and api.keep. This it not ideal
    var onMouseOver = (0, $5FkrB.useCallback)(function(event) {
        // Ignoring events from the container ref
        if (containerRef.current && event.target === containerRef.current) return;
        // Using prevent default as a signal that parent tooltips
        if (event.defaultPrevented) return;
        event.preventDefault();
        var source = isMousePosition ? {
            type: 'mouse',
            clientX: event.clientX,
            clientY: event.clientY
        } : {
            type: 'keyboard'
        };
        tryShowTooltip(source);
    }, [
        isMousePosition,
        tryShowTooltip
    ]);
    // Ideally we would be using onMouseEnter here, but
    // because we are binding the event to the target parent
    // we need to listen for the mouseout of all sub elements
    // This means when moving along a tooltip we are quickly toggling
    // between api.requestHide and api.keep. This it not ideal
    var onMouseOut = (0, $5FkrB.useCallback)(function(event) {
        // Ignoring events from the container ref
        if (containerRef.current && event.target === containerRef.current) return;
        // Using prevent default as a signal that parent tooltips
        if (event.defaultPrevented) return;
        event.preventDefault();
        if (apiRef.current) apiRef.current.requestHide({
            isImmediate: false
        });
    }, []);
    var onMouseMove = isMousePosition ? function(event) {
        var _apiRef$current3;
        if ((_apiRef$current3 = apiRef.current) !== null && _apiRef$current3 !== void 0 && _apiRef$current3.isActive()) apiRef.current.mousePos = {
            clientX: event.clientX,
            clientY: event.clientY
        };
    } : undefined;
    var onMouseOverTooltip = (0, $5FkrB.useCallback)(function() {
        if (apiRef.current && apiRef.current.isActive()) {
            apiRef.current.keep();
            return;
        }
    }, []);
    var onFocus = (0, $5FkrB.useCallback)(function(e) {
        // Check if focus-visible
        // Prevents tooltips from showing when focus is not visible,
        // i.e., when focus is moved onto tooltip trigger inside a popup on open
        try {
            if (!e.target.matches(':focus-visible')) return;
        } catch (_unused) {
        // Ignore errors from environments that don't support :focus-visible
        }
        // TODO: this does not play well with `hideTooltipOnMouseDown`
        // as "focus" will occur after the "mousedown".
        tryShowTooltip({
            type: 'keyboard'
        });
    }, [
        tryShowTooltip
    ]);
    var onBlur = (0, $5FkrB.useCallback)(function() {
        if (apiRef.current) apiRef.current.requestHide({
            isImmediate: false
        });
    }, []);
    var onAnimationFinished = (0, $5FkrB.useCallback)(function(transition) {
        // Using lastState here because motion is not picking up the latest value
        if (transition === 'exiting' && stableState.current === 'fade-out' && apiRef.current) apiRef.current.finishHideAnimation();
    }, [
        stableState
    ]);
    // Doing a cast because typescript is struggling to narrow the type
    var CastTargetContainer = TargetContainer;
    var shouldRenderTooltipPopup = state !== 'hide' && Boolean(content);
    var shouldRenderHiddenContent = !isScreenReaderAnnouncementDisabled && shouldRenderTooltipPopup;
    var shouldRenderTooltipChildren = state !== 'hide' && state !== 'fade-out';
    var handleOpenLayerObserverCloseSignal = (0, $5FkrB.useCallback)(function() {
        var _apiRef$current4;
        (_apiRef$current4 = apiRef.current) === null || _apiRef$current4 === void 0 || _apiRef$current4.requestHide({
            isImmediate: true
        });
    }, []);
    (0, $c8ddaa578c48e6d6$export$469bb693f11edc7f)({
        // Layer is only visually open if both the tooltip popup (container) and children are rendered.
        isOpen: shouldRenderTooltipPopup && shouldRenderTooltipChildren,
        /**
     * We don't strictly need to provide an onClose callback at this time, as there is
     * already code that handles hiding the tooltip when a drag is started (and the only
     * usage right now is closing all layers when the user resizes the side nav).
     *
     * However, for future-proofing and semantic reasons, it makes sense to close the tooltip
     * whenever the open layer observer requests a close.
     */ onClose: handleOpenLayerObserverCloseSignal
    });
    var getReferenceElement = function getReferenceElement() {
        var _apiRef$current5;
        if (isMousePosition && (_apiRef$current5 = apiRef.current) !== null && _apiRef$current5 !== void 0 && _apiRef$current5.mousePos && targetRef.current) return (0, $e8607a2d873b3355$export$2e68479e0a5d8746)(apiRef.current.mousePos, {
            targetElement: targetRef.current,
            tooltipPosition: position
        });
        return targetRef.current || undefined;
    };
    var tooltipIdForHiddenContent = (0, $e266314cb40581a7$export$2e2bcd8739ae039)('tooltip', shouldRenderHiddenContent);
    var tooltipTriggerProps = {
        onMouseOver: onMouseOver,
        onMouseOut: onMouseOut,
        onMouseMove: onMouseMove,
        onMouseDown: onMouseDown,
        onClick: onClick,
        onFocus: onFocus,
        onBlur: onBlur
    };
    // Don't set `data-testid` unless it's defined, as it's not in the interface.
    if (testId) // Adding `data-testid` to the TriggerProps interface breaks Buttons, so we use type assertion
    tooltipTriggerProps['data-testid'] = "".concat(testId, "--container");
    // This useEffect is purely for managing the aria attribute when using the
    // wrapped children approach.
    var isChildrenAFunction = typeof children === 'function';
    (0, $5FkrB.useEffect)(function() {
        if (isChildrenAFunction) return;
        // If `children` is _not_ a function, we are stepping outside of the public
        // API to add a `aria-describedby` attribute.
        var target = targetRef.current;
        if (!target || !tooltipIdForHiddenContent) return;
        target.setAttribute('aria-describedby', tooltipIdForHiddenContent);
        return function() {
            return target.removeAttribute('aria-describedby');
        };
    }, [
        isChildrenAFunction,
        tooltipIdForHiddenContent
    ]);
    var hiddenContent = shouldRenderHiddenContent ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("span", {
        "data-testid": testId ? "".concat(testId, "-hidden") : undefined,
        hidden: true,
        id: tooltipIdForHiddenContent
    }, typeof content === 'function' ? content({}) : content) : null;
    var PopperWrapper = UNSAFE_shouldRenderToParent ? (0, $5FkrB.Fragment) : $32d4a3c4842e3ceb$var$TooltipPortal;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).Fragment, null, typeof children === 'function' ? /*#__PURE__*/ // once we deprecate the wrapped approach, we can put the aria
    // attribute back into the tooltipTriggerProps and make it required
    // instead of optional in `types`
    (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).Fragment, null, children($32d4a3c4842e3ceb$var$_objectSpread($32d4a3c4842e3ceb$var$_objectSpread({}, tooltipTriggerProps), {}, {
        'aria-describedby': tooltipIdForHiddenContent,
        ref: setDirectRef
    })), hiddenContent) : /*#__PURE__*/ // @ts-ignore
    (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(CastTargetContainer, (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, tooltipTriggerProps, {
        ref: setImplicitRefFromChildren,
        role: "presentation"
    }), children, hiddenContent), shouldRenderTooltipPopup ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(PopperWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $90dbe317b033cbba$export$badac9ada3a0bdf9), {
        placement: tooltipPosition,
        referenceElement: getReferenceElement(),
        strategy: strategy
    }, function(_ref5) {
        var ref = _ref5.ref, style = _ref5.style, update = _ref5.update, placement = _ref5.placement;
        // Invert the entrance and exit directions.
        // E.g. a tooltip's position is on the 'right', it should enter from and exit to the 'left'
        // This gives the effect the tooltip is appearing from the target
        var direction = isMousePosition ? undefined : $32d4a3c4842e3ceb$var$invertedDirection[$32d4a3c4842e3ceb$var$getDirectionFromPlacement(placement)];
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $a4d40a97fb679e4b$export$2e2bcd8739ae039), {
            appear: true
        }, shouldRenderTooltipChildren && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $5ca2cbc46961ee1d$export$2e2bcd8739ae039), {
            distance: "constant",
            entranceDirection: direction,
            exitDirection: direction,
            onFinish: onAnimationFinished,
            duration: state !== 'show-immediate' ? 'medium' : 'none'
        }, function(_ref6) {
            var className = _ref6.className;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(Container, {
                ref: ref,
                className: "Tooltip ".concat(className),
                style: $32d4a3c4842e3ceb$var$_objectSpread($32d4a3c4842e3ceb$var$_objectSpread({}, style), ignoreTooltipPointerEvents && {
                    pointerEvents: 'none'
                }),
                truncate: truncate,
                placement: tooltipPosition,
                testId: getReferenceElement() ? testId : testId && "".concat(testId, "--unresolved"),
                onMouseOut: onMouseOut,
                onMouseOver: onMouseOverTooltip,
                shortcut: shortcut
            }, typeof content === 'function' ? content({
                update: update
            }) : content);
        }));
    })) : null);
}
var $32d4a3c4842e3ceb$export$2e2bcd8739ae039 = $32d4a3c4842e3ceb$var$Tooltip;
var $32d4a3c4842e3ceb$var$TooltipPortal = function TooltipPortal(_ref7) {
    var children = _ref7.children;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $fV8Mu.default), {
        zIndex: $32d4a3c4842e3ceb$var$tooltipZIndex
    }, children);
};




var $5yfDB = parcelRequire("5yfDB");


var $bNmp1 = parcelRequire("bNmp1");

var $9AP5g = parcelRequire("9AP5g");

var $3ZMUU = parcelRequire("3ZMUU");
/**
 * Takes a dot-separated token name and an optional fallback, and returns the CSS custom property for the corresponding token.
 * This should be used to implement design decisions throughout your application.
 *
 * Note: With `@atlaskit/babel-plugin-tokens`, this function can be pre-compiled and a fallback value automatically inserted.
 *
 * @param {string} path - A dot-separated token name (example: `'color.background.brand'` or `'spacing.scale.100'`).
 * @param {string} [fallback] - The fallback value that should render when token CSS is not present in your app.
 *
 * @example
 * ```
 * <div
 *   css={{
 *     backgroundColor: token('elevation.surface.raised', N0),
 *     boxShadow: token('elevation.shadow.raised', `0 20px 32px -8px ${N50A}, 0 0 1px ${N60A}`),
 *     padding: token('spacing.scale.100', '8px'),
 *     fontWeight: token('font.weight.regular', '400'),
 *   }}
 * />
 * ```
 *
 */ function $bc0491cc0ab7faea$var$token(path, fallback) {
    var token = (0, $bNmp1.default)[path];
    typeof $3ZMUU;
    // if the token is not found - replacing it with variable name without any value, to avoid it being undefined which would result in invalid css
    if (!token) token = (0, $9AP5g.TOKEN_NOT_FOUND_CSS_VAR);
    var tokenCall = fallback ? "var(".concat(token, ", ").concat(fallback, ")") : "var(".concat(token, ")");
    return tokenCall;
}
var $bc0491cc0ab7faea$export$2e2bcd8739ae039 = $bc0491cc0ab7faea$var$token;


const $55c2d94220e7f4ae$var$messages = (0, $aRMzY.defineMessages)({
    markAsRead: {
        id: 'app-updates-table.unread-dot.mark-as-read',
        defaultMessage: 'Mark as read'
    }
});
const $55c2d94220e7f4ae$var$styles = {
    dot: (0, $c1bec583fa49072f$export$f6c783d06584602c)({
        width: (0, $bc0491cc0ab7faea$export$2e2bcd8739ae039)('space.100'),
        height: (0, $bc0491cc0ab7faea$export$2e2bcd8739ae039)('space.100'),
        borderRadius: 'radius.full',
        backgroundColor: 'color.background.accent.blue.bolder',
        display: 'block'
    })
};
const $55c2d94220e7f4ae$export$45b5aabab39395b1 = ({ onClick: onClick, testId: testId })=>{
    const { formatMessage: formatMessage } = (0, $6Wx3K.default)();
    return /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $32d4a3c4842e3ceb$export$2e2bcd8739ae039), {
        content: formatMessage($55c2d94220e7f4ae$var$messages.markAsRead),
        position: "top",
        children: (tooltipProps)=>/*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $5yfDB.default), {
                ...tooltipProps,
                testId: testId,
                appearance: "subtle",
                icon: (props)=>/*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $383dd904a5a5e5b0$export$2e2bcd8739ae039), {
                        ...props,
                        xcss: $55c2d94220e7f4ae$var$styles.dot
                    }),
                spacing: "compact",
                onClick: onClick,
                label: formatMessage($55c2d94220e7f4ae$var$messages.markAsRead)
            })
    });
};


const $66d7da6dce257b40$export$8c779258b936559c = ({ id: id, firstPublishedAt: firstPublishedAt })=>{
    const { isUnread: isUnread, markSeen: markSeen } = (0, $9aabdc1903d96d41$export$86ce72459a4312fa)({
        id: id,
        firstPublishedAt: firstPublishedAt
    });
    if (!isUnread) return null;
    return /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $55c2d94220e7f4ae$export$45b5aabab39395b1), {
        onClick: markSeen,
        testId: `unread-dot-${id}`
    });
};
var $66d7da6dce257b40$export$2e2bcd8739ae039 = $66d7da6dce257b40$export$8c779258b936559c;




var $5FkrB = parcelRequire("5FkrB");

var $aRMzY = parcelRequire("aRMzY");
var $6Wx3K = parcelRequire("6Wx3K");



var $jnGKX = parcelRequire("jnGKX");

var $hvJbm = parcelRequire("hvJbm");

const $9d0c6ca2818366fa$var$messages = (0, $aRMzY.defineMessages)({
    betaLabel: {
        id: 'appUpdates.aiDisclaimer.beta',
        defaultMessage: 'Beta',
        description: 'Beta label shown next to AI-generated content'
    },
    tooltipText: {
        id: 'appUpdates.aiDisclaimer.tooltipText',
        defaultMessage: 'Uses AI. Verify results.',
        description: 'Disclaimer body text shown in the tooltip next to AI-generated content (Beta lozenge prepended visually)'
    }
});
const $9d0c6ca2818366fa$var$wrapperStyles = (0, $c1bec583fa49072f$export$f6c783d06584602c)({
    display: 'inline-flex',
    alignItems: 'center',
    gap: 'space.050'
});
const $9d0c6ca2818366fa$var$triggerStyles = (0, $c1bec583fa49072f$export$f6c783d06584602c)({
    display: 'inline-flex',
    alignItems: 'center',
    gap: 'space.050',
    cursor: 'default',
    color: 'color.text',
    backgroundColor: 'color.background.neutral.subtle',
    padding: 'space.0',
    borderStyle: 'none'
});
const $9d0c6ca2818366fa$export$e0542ba0c737fe5c = ({ label: label })=>{
    const { formatMessage: formatMessage } = (0, $6Wx3K.default)();
    const betaLabel = formatMessage($9d0c6ca2818366fa$var$messages.betaLabel);
    const tooltipBody = formatMessage($9d0c6ca2818366fa$var$messages.tooltipText);
    const [isOpen, setIsOpen] = (0, $5FkrB.useState)(false);
    const closeTimeoutRef = (0, $5FkrB.useRef)(null);
    const handleMouseEnter = (0, $5FkrB.useCallback)(()=>{
        if (closeTimeoutRef.current) {
            clearTimeout(closeTimeoutRef.current);
            closeTimeoutRef.current = null;
        }
        setIsOpen(true);
    }, []);
    const handleMouseLeave = (0, $5FkrB.useCallback)(()=>{
        closeTimeoutRef.current = setTimeout(()=>setIsOpen(false), 150);
    }, []);
    return /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsxs)((0, $10b0af967ce59e29$export$2e2bcd8739ae039), {
        xcss: $9d0c6ca2818366fa$var$wrapperStyles,
        testId: "ai-disclaimer",
        children: [
            label,
            /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $jnGKX.default), {
                isOpen: isOpen,
                onClose: ()=>setIsOpen(false),
                placement: "top",
                content: ()=>/*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $383dd904a5a5e5b0$export$2e2bcd8739ae039), {
                        padding: "space.100",
                        onMouseEnter: handleMouseEnter,
                        onMouseLeave: handleMouseLeave,
                        children: /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsxs)((0, $10b0af967ce59e29$export$2e2bcd8739ae039), {
                            space: "space.075",
                            alignBlock: "center",
                            children: [
                                /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $3f972846489e3122$export$2e2bcd8739ae039), {
                                    appearance: "default",
                                    isBold: false,
                                    children: betaLabel
                                }),
                                /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $d48daa9a522ca942$export$2e2bcd8739ae039), {
                                    size: "small",
                                    children: tooltipBody
                                })
                            ]
                        })
                    }),
                trigger: (triggerProps)=>/*#__PURE__*/ (0, $faf30355a80342e4$exports.jsxs)((0, $d4a7825669dd53f6$export$2e2bcd8739ae039), {
                        ...triggerProps,
                        testId: "ai-disclaimer-trigger",
                        onMouseEnter: handleMouseEnter,
                        onMouseLeave: handleMouseLeave,
                        onClick: ()=>setIsOpen((prev)=>!prev),
                        xcss: $9d0c6ca2818366fa$var$triggerStyles,
                        children: [
                            /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($hvJbm))), {
                                label: `${betaLabel}. ${tooltipBody}`,
                                color: (0, $bc0491cc0ab7faea$export$2e2bcd8739ae039)('color.icon.subtle'),
                                spacing: "spacious"
                            }),
                            /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $3f972846489e3122$export$2e2bcd8739ae039), {
                                appearance: "default",
                                isBold: false,
                                children: betaLabel
                            })
                        ]
                    })
            })
        ]
    });
};
var $9d0c6ca2818366fa$export$2e2bcd8739ae039 = $9d0c6ca2818366fa$export$e0542ba0c737fe5c;



const $cd51792b00d955d5$var$messages = (0, $aRMzY.defineMessages)({
    emptyStateHeader: {
        id: 'appUpdatesTable.emptyState.header',
        defaultMessage: 'No release notes found',
        description: 'Header text for empty app updates table state'
    },
    emptyStateDescription: {
        id: 'appUpdatesTable.emptyState.description',
        defaultMessage: 'No release notes match your filters. Adjust or clear your filters and try again.',
        description: 'Description text for empty app updates table state'
    },
    errorStateHeader: {
        id: 'appUpdatesTable.errorState.header',
        defaultMessage: 'Unable to load release notes',
        description: 'Header text for error app updates table state'
    },
    errorStateDescription: {
        id: 'appUpdatesTable.errorState.description',
        defaultMessage: "We couldn't load your release notes. Refresh the page to try again.",
        description: 'Description text for error app updates table state'
    },
    productHeader: {
        id: 'appUpdatesTable.column.product',
        defaultMessage: 'App',
        description: 'Column header for product/app name'
    },
    releaseNoteHeader: {
        id: 'appUpdatesTable.column.releaseNote',
        defaultMessage: 'Release note',
        description: 'Column header for release note'
    },
    statusHeader: {
        id: 'appUpdatesTable.column.status',
        defaultMessage: 'Status',
        description: 'Column header for status'
    },
    impactRatingHeader: {
        id: 'appUpdatesTable.column.impactRating',
        defaultMessage: 'Impact',
        description: 'Column header for AI-generated impact rating'
    },
    changeTypeHeader: {
        id: 'appUpdatesTable.column.changeType',
        defaultMessage: 'Change type',
        description: 'Column header for original (non-AI) change type'
    },
    contextualTagsHeader: {
        id: 'appUpdatesTable.column.contextualTags',
        defaultMessage: 'Contextual tags',
        description: 'Column header for AI-generated contextual tags'
    },
    rolloutScheduleHeader: {
        id: 'appUpdatesTable.column.rolloutSchedule',
        defaultMessage: 'Rollout schedule',
        description: 'Column header for rollout schedule date range'
    },
    adminCalloutText: {
        id: 'appUpdatesTable.adminCallout.text',
        defaultMessage: 'For rollout schedules specific to your organization, visit <appUpdatesLink>App updates</appUpdatesLink> in <adminLink>Atlassian Administration</adminLink>. Organization admin access required.',
        description: 'Callout below the table encouraging org admins to visit Atlassian Administration for org-specific rollout schedules. The text inside <appUpdatesLink> and <adminLink> tags are the visible link labels.'
    }
});
const $cd51792b00d955d5$var$rolloutScheduleContentStyles = (0, $c1bec583fa49072f$export$f6c783d06584602c)({
    width: '100%',
    textAlign: 'right',
    paddingInlineEnd: 'space.200'
});
const $cd51792b00d955d5$export$43e60dbd29b5bdea = ()=>{
    const { formatMessage: formatMessage } = (0, $6Wx3K.default)();
    const { state: state } = (0, $4933e76bd0ca959e$export$7653fec709d1e7bb)();
    const { setCursor: setCursor, setLimit: setLimit } = (0, $4981744843bb0981$export$f80c710216eae131)();
    const { analyticsOptOut: analyticsOptOut } = (0, $38056d680fac42ff$export$b224af886b957a5e)();
    const onNextPageClicked = ()=>{
        // pagination component ensures button is disabled if no next page
        // but ts makes us do an extra check here
        if (state.updates.links.next) setCursor(state.updates.links.next);
    };
    const onPreviousPageClicked = ()=>{
        // pagination component ensures button is disabled if no previous page
        // but ts makes us do an extra check here
        if (state.updates.links.prev) setCursor(state.updates.links.prev);
    };
    const onPageSizeChange = (value)=>{
        setLimit(value.value);
    };
    const unreadIndicatorColumn = {
        id: 'unreadDot',
        header: '',
        accessorKey: 'id',
        size: 24,
        enableSorting: false,
        cell: ({ row: row })=>{
            if (analyticsOptOut || !row.original.firstPublishedAt) return null;
            return /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $66d7da6dce257b40$export$8c779258b936559c), {
                id: row.original.id,
                firstPublishedAt: row.original.firstPublishedAt
            });
        }
    };
    const columnDefs = [
        unreadIndicatorColumn,
        {
            id: 'product',
            header: formatMessage($cd51792b00d955d5$var$messages.productHeader),
            accessorKey: 'productTypes',
            size: 150,
            enableSorting: false,
            cell: ({ row: row })=>/*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $04e2ab9a71aec03a$export$831fdf77aa2a6a18), {
                    productTypes: row.original.productTypes
                })
        },
        {
            id: 'title',
            header: formatMessage($cd51792b00d955d5$var$messages.releaseNoteHeader),
            accessorKey: 'title',
            size: 400,
            enableSorting: false,
            cell: ({ row: row })=>/*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $383dd904a5a5e5b0$export$2e2bcd8739ae039), {
                    xcss: (0, $c1bec583fa49072f$export$f6c783d06584602c)({
                        whiteSpace: 'normal'
                    }),
                    children: /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $dba17dfd00ae7d8f$export$2e2bcd8739ae039), {
                        to: (0, $749a6437bd4ec017$export$cd891b82501bb412).RELEASE_NOTE_DETAILS(row.original.id),
                        onClick: ()=>{
                            // TODO: - Temp fix for TC-10499: the GET /changes/id endpoint does not return
                            // firstPublishedAt, so the details page cannot mark the item as read.
                            // We mark it here in the list view where firstPublishedAt is available.
                            if (!analyticsOptOut && row.original.firstPublishedAt) (0, $15b90d5900f709a5$export$dc76bba8c4f0075f)({
                                id: row.original.id,
                                firstPublishedAt: row.original.firstPublishedAt
                            });
                        },
                        children: /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $d48daa9a522ca942$export$2e2bcd8739ae039), {
                            color: "color.link",
                            weight: "regular",
                            children: row.original.title
                        })
                    })
                })
        },
        {
            id: 'status',
            header: formatMessage($cd51792b00d955d5$var$messages.statusHeader),
            accessorKey: 'status',
            size: 150,
            enableSorting: false,
            cell: ({ row: row })=>/*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $fe4fcc4b7b323fa4$export$330c774339d320ad), {
                    status: row.original.status
                })
        },
        {
            id: 'changeType',
            header: formatMessage($cd51792b00d955d5$var$messages.changeTypeHeader),
            accessorKey: 'type',
            size: 130,
            enableSorting: false,
            cell: ({ row: row })=>/*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $10eaae4bdfb59f21$export$1abc4eff6ef230bd), {
                    type: row.original.type
                })
        },
        ...(0, $c78886f48293f91c$export$b40ec24ac8275656)((0, $86626a3c150b02ba$export$5fb62a9fe732a843).aiImpactAndContextTags) ? [
            {
                id: 'impactRating',
                header: ()=>/*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $9d0c6ca2818366fa$export$e0542ba0c737fe5c), {
                        label: formatMessage($cd51792b00d955d5$var$messages.impactRatingHeader)
                    }),
                accessorKey: 'impactRating',
                enableSorting: false,
                cell: ({ row: row })=>/*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $d26747ad8d2a0268$export$2a5158d64a074be2), {
                        impactRating: row.original.impactRating
                    })
            },
            {
                id: 'contextualTags',
                header: ()=>/*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $9d0c6ca2818366fa$export$e0542ba0c737fe5c), {
                        label: formatMessage($cd51792b00d955d5$var$messages.contextualTagsHeader)
                    }),
                accessorKey: 'tags',
                size: 200,
                maxSize: 200,
                enableSorting: false,
                cell: ({ row: row })=>/*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $fbecf69dc9e04116$export$3c86caed05f80ae7), {
                        tags: row.original.tags
                    })
            }
        ] : [],
        {
            id: 'rolloutSchedule',
            header: ()=>/*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $383dd904a5a5e5b0$export$2e2bcd8739ae039), {
                    xcss: $cd51792b00d955d5$var$rolloutScheduleContentStyles,
                    children: formatMessage($cd51792b00d955d5$var$messages.rolloutScheduleHeader)
                }),
            accessorKey: 'releaseStartDate',
            size: 180,
            enableSorting: false,
            minSize: 180,
            cell: ({ row: row })=>/*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $383dd904a5a5e5b0$export$2e2bcd8739ae039), {
                    xcss: $cd51792b00d955d5$var$rolloutScheduleContentStyles,
                    children: /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $373b864dc2406021$export$c119e7a38ceabb6b), {
                        startDate: row.original.releaseStartDate,
                        endDate: row.original.releaseEndDate,
                        status: row.original.status
                    })
                })
        }
    ];
    const tableState = state.updates.error ? (0, $9TAkY.TableState).error : state.updates.isLoading ? (0, $9TAkY.TableState).loading : (0, $9TAkY.TableState).loaded;
    return /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsxs)((0, $c8dbef6c41cfa689$export$2e2bcd8739ae039), {
        space: "space.200",
        children: [
            /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $9TAkY.CharlieTable), {
                data: state.updates.data,
                columnDefs: columnDefs,
                manualSorting: false,
                tableState: tableState,
                emptyTableView: /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $9a28bb334efe6ee5$export$2e2bcd8739ae039), {
                    header: formatMessage($cd51792b00d955d5$var$messages.emptyStateHeader),
                    description: formatMessage($cd51792b00d955d5$var$messages.emptyStateDescription)
                }),
                errorView: /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $9a28bb334efe6ee5$export$2e2bcd8739ae039), {
                    header: formatMessage($cd51792b00d955d5$var$messages.errorStateHeader),
                    description: formatMessage($cd51792b00d955d5$var$messages.errorStateDescription)
                }),
                tableType: "INVENTORY",
                manualPagination: true
            }, !analyticsOptOut ? 'unread-indicator-visible' : 'unread-indicator-hidden'),
            /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $de3e24ee9809fb70$export$2e2bcd8739ae039), {
                hasPreviousPage: !!state.updates?.links?.prev,
                hasNextPage: !!state.updates?.links?.next,
                onNextPageClicked: onNextPageClicked,
                onPreviousPageClicked: onPreviousPageClicked,
                onPageSizeChange: onPageSizeChange
            }),
            /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $1b254ba6a068f2f1$export$2e2bcd8739ae039), {
                justifyContent: "center",
                xcss: (0, $c1bec583fa49072f$export$f6c783d06584602c)({
                    backgroundColor: 'color.background.neutral',
                    borderRadius: 'radius.small',
                    paddingBlock: 'space.150',
                    paddingInline: 'space.150'
                }),
                children: /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $d48daa9a522ca942$export$2e2bcd8739ae039), {
                    size: "small",
                    color: "color.text.subtle",
                    children: formatMessage($cd51792b00d955d5$var$messages.adminCalloutText, {
                        appUpdatesLink: (chunks)=>/*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $64e95b69a05329e9$export$2e2bcd8739ae039), {
                                href: "https://support.atlassian.com/organization-administration/docs/view-all-changes-to-an-atlassian-app/",
                                target: "_blank",
                                rel: "noopener noreferrer",
                                children: chunks
                            }),
                        adminLink: (chunks)=>/*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $64e95b69a05329e9$export$2e2bcd8739ae039), {
                                href: "https://admin.atlassian.com",
                                target: "_blank",
                                rel: "noopener noreferrer",
                                children: chunks
                            })
                    })
                })
            })
        ]
    });
};
var $cd51792b00d955d5$export$2e2bcd8739ae039 = $cd51792b00d955d5$export$43e60dbd29b5bdea;




var $aRMzY = parcelRequire("aRMzY");
var $6Wx3K = parcelRequire("6Wx3K");



var $9TAkY = parcelRequire("9TAkY");










var $5FkrB = parcelRequire("5FkrB");

const $0ae5c4deaafff0f7$export$832f7aa7b8c34acc = ()=>{
    const { dispatch: dispatch } = (0, $4933e76bd0ca959e$export$7653fec709d1e7bb)();
    const setCursor = (0, $5FkrB.useCallback)((cursor)=>{
        dispatch({
            type: 'BUNDLES_CURSOR_SET',
            payload: {
                cursor: cursor
            }
        });
    }, [
        dispatch
    ]);
    const setLimit = (0, $5FkrB.useCallback)((limit)=>{
        dispatch({
            type: 'BUNDLES_LIMIT_SET',
            payload: {
                limit: limit
            }
        });
    }, [
        dispatch
    ]);
    return {
        setCursor: setCursor,
        setLimit: setLimit
    };
};


const $2a8cd52f0324fffc$var$messages = (0, $aRMzY.defineMessages)({
    emptyStateHeader: {
        id: 'bundledChangesTable.emptyState.header',
        defaultMessage: 'No bundled changes found',
        description: 'Header text for empty bundled changes table state'
    },
    emptyStateDescription: {
        id: 'bundledChangesTable.emptyState.description',
        defaultMessage: 'No bundled changes match your filters. Adjust or clear your filters and try again.',
        description: 'Description text for empty bundled changes table state'
    },
    errorStateHeader: {
        id: 'bundledChangesTable.errorState.header',
        defaultMessage: 'Unable to load bundled changes',
        description: 'Header text for error bundled changes table state'
    },
    errorStateDescription: {
        id: 'bundledChangesTable.errorState.description',
        defaultMessage: "We couldn't load bundled changes. Refresh the page to try again.",
        description: 'Description text for error bundled changes table state'
    },
    productHeader: {
        id: 'bundledChangesTable.column.product',
        defaultMessage: 'App',
        description: 'Column header for product/app name'
    },
    releaseNoteHeader: {
        id: 'bundledChangesTable.column.releaseNote',
        defaultMessage: 'Release note',
        description: 'Column header for release note'
    },
    changeTypeHeader: {
        id: 'bundledChangesTable.column.changeType',
        defaultMessage: 'Change type',
        description: 'Column header for change type'
    },
    previewTrackHeader: {
        id: 'bundledChangesTable.column.previewTrack',
        defaultMessage: 'Preview release date',
        description: 'Column header for preview track release date'
    },
    bundledTrackHeader: {
        id: 'bundledChangesTable.column.bundledTrack',
        defaultMessage: 'Bundled release date',
        description: 'Column header for bundled track release date'
    }
});
const $2a8cd52f0324fffc$export$7d9f68d95131377e = ()=>{
    const { formatMessage: formatMessage } = (0, $6Wx3K.default)();
    const { state: state } = (0, $4933e76bd0ca959e$export$7653fec709d1e7bb)();
    const { analyticsOptOut: analyticsOptOut } = (0, $38056d680fac42ff$export$b224af886b957a5e)();
    const { setCursor: setCursor, setLimit: setLimit } = (0, $0ae5c4deaafff0f7$export$832f7aa7b8c34acc)();
    const onNextPageClicked = ()=>{
        if (state.bundles.links.next) setCursor(state.bundles.links.next);
    };
    const onPreviousPageClicked = ()=>{
        if (state.bundles.links.prev) setCursor(state.bundles.links.prev);
    };
    const onPageSizeChange = (value)=>{
        setLimit(value.value);
    };
    const unreadIndicatorColumn = {
        id: 'unreadDot',
        header: '',
        accessorKey: 'id',
        size: 24,
        enableSorting: false,
        cell: ({ row: row })=>{
            if (analyticsOptOut || !row.original.firstPublishedAt) return null;
            return /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $66d7da6dce257b40$export$8c779258b936559c), {
                id: row.original.id,
                firstPublishedAt: row.original.firstPublishedAt
            });
        }
    };
    const columnDefs = [
        unreadIndicatorColumn,
        {
            id: 'product',
            header: formatMessage($2a8cd52f0324fffc$var$messages.productHeader),
            accessorKey: 'productTypes',
            size: 150,
            enableSorting: false,
            cell: ({ row: row })=>/*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $04e2ab9a71aec03a$export$831fdf77aa2a6a18), {
                    productTypes: row.original.productTypes
                })
        },
        {
            id: 'title',
            header: formatMessage($2a8cd52f0324fffc$var$messages.releaseNoteHeader),
            accessorKey: 'title',
            size: 400,
            enableSorting: false,
            cell: ({ row: row })=>/*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $383dd904a5a5e5b0$export$2e2bcd8739ae039), {
                    xcss: (0, $c1bec583fa49072f$export$f6c783d06584602c)({
                        whiteSpace: 'normal'
                    }),
                    children: /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $dba17dfd00ae7d8f$export$2e2bcd8739ae039), {
                        to: (0, $749a6437bd4ec017$export$cd891b82501bb412).RELEASE_NOTE_DETAILS(row.original.id),
                        children: /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $d48daa9a522ca942$export$2e2bcd8739ae039), {
                            color: "color.link",
                            weight: "regular",
                            children: row.original.title
                        })
                    })
                })
        },
        {
            id: 'changeType',
            header: formatMessage($2a8cd52f0324fffc$var$messages.changeTypeHeader),
            accessorKey: 'type',
            size: 130,
            enableSorting: false,
            cell: ({ row: row })=>/*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $10eaae4bdfb59f21$export$1abc4eff6ef230bd), {
                    type: row.original.type
                })
        },
        {
            id: 'previewTrackReleaseDate',
            header: formatMessage($2a8cd52f0324fffc$var$messages.previewTrackHeader),
            accessorKey: 'previewTrackReleaseDate',
            size: 160,
            enableSorting: false,
            cell: ({ row: row })=>/*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $d48daa9a522ca942$export$2e2bcd8739ae039), {
                    children: row.original.previewTrackReleaseDate ? (0, $dc0b5cf0aeb86d21$export$eecd5dfd0530be5c)(row.original.previewTrackReleaseDate) : "\u2014"
                })
        },
        {
            id: 'bundledTrackReleaseDate',
            header: formatMessage($2a8cd52f0324fffc$var$messages.bundledTrackHeader),
            accessorKey: 'bundledTrackReleaseDate',
            size: 160,
            enableSorting: false,
            cell: ({ row: row })=>/*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $d48daa9a522ca942$export$2e2bcd8739ae039), {
                    children: row.original.bundledTrackReleaseDate ? (0, $dc0b5cf0aeb86d21$export$eecd5dfd0530be5c)(row.original.bundledTrackReleaseDate) : "\u2014"
                })
        }
    ];
    const tableState = state.bundles.error ? (0, $9TAkY.TableState).error : state.bundles.isLoading ? (0, $9TAkY.TableState).loading : (0, $9TAkY.TableState).loaded;
    return /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsxs)((0, $c8dbef6c41cfa689$export$2e2bcd8739ae039), {
        space: "space.200",
        children: [
            /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $9TAkY.CharlieTable), {
                data: state.bundles.data,
                columnDefs: columnDefs,
                manualSorting: false,
                tableState: tableState,
                emptyTableView: /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $9a28bb334efe6ee5$export$2e2bcd8739ae039), {
                    header: formatMessage($2a8cd52f0324fffc$var$messages.emptyStateHeader),
                    description: formatMessage($2a8cd52f0324fffc$var$messages.emptyStateDescription)
                }),
                errorView: /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $9a28bb334efe6ee5$export$2e2bcd8739ae039), {
                    header: formatMessage($2a8cd52f0324fffc$var$messages.errorStateHeader),
                    description: formatMessage($2a8cd52f0324fffc$var$messages.errorStateDescription)
                }),
                tableType: "INVENTORY",
                manualPagination: true
            }, !analyticsOptOut ? 'unread-indicator-visible' : 'unread-indicator-hidden'),
            /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $de3e24ee9809fb70$export$2e2bcd8739ae039), {
                hasPreviousPage: !!state.bundles?.links?.prev,
                hasNextPage: !!state.bundles?.links?.next,
                onNextPageClicked: onNextPageClicked,
                onPreviousPageClicked: onPreviousPageClicked,
                onPageSizeChange: onPageSizeChange
            })
        ]
    });
};











/** A special constant with type `never` */ const $d4d51e3b5652b8a4$export$96c94437c95d7862 = Object.freeze({
    status: "aborted"
});
/*@__NO_SIDE_EFFECTS__*/ function $d4d51e3b5652b8a4$export$3122533d606194de(name, initializer, params) {
    function init(inst, def) {
        if (!inst._zod) Object.defineProperty(inst, "_zod", {
            value: {
                def: def,
                constr: _,
                traits: new Set()
            },
            enumerable: false
        });
        if (inst._zod.traits.has(name)) return;
        inst._zod.traits.add(name);
        initializer(inst, def);
        // support prototype modifications
        const proto = _.prototype;
        const keys = Object.keys(proto);
        for(let i = 0; i < keys.length; i++){
            const k = keys[i];
            if (!(k in inst)) inst[k] = proto[k].bind(inst);
        }
    }
    // doesn't work if Parent has a constructor with arguments
    const Parent = params?.Parent ?? Object;
    class Definition extends Parent {
    }
    Object.defineProperty(Definition, "name", {
        value: name
    });
    function _(def) {
        var _a;
        const inst = params?.Parent ? new Definition() : this;
        init(inst, def);
        (_a = inst._zod).deferred ?? (_a.deferred = []);
        for (const fn of inst._zod.deferred)fn();
        return inst;
    }
    Object.defineProperty(_, "init", {
        value: init
    });
    Object.defineProperty(_, Symbol.hasInstance, {
        value: (inst)=>{
            if (params?.Parent && inst instanceof params.Parent) return true;
            return inst?._zod?.traits?.has(name);
        }
    });
    Object.defineProperty(_, "name", {
        value: name
    });
    return _;
}
const $d4d51e3b5652b8a4$export$7d40e40c5b5a6c8f = Symbol("zod_brand");
class $d4d51e3b5652b8a4$export$13016bcec11ba196 extends Error {
    constructor(){
        super(`Encountered Promise during synchronous parse. Use .parseAsync() instead.`);
    }
}
class $d4d51e3b5652b8a4$export$a36d4c29b1151bde extends Error {
    constructor(name){
        super(`Encountered unidirectional transform during encode: ${name}`);
        this.name = "ZodEncodeError";
    }
}
const $d4d51e3b5652b8a4$export$f9cd1e43211d8a4a = {};
function $d4d51e3b5652b8a4$export$e506a1d27d1eaa20(newConfig) {
    if (newConfig) Object.assign($d4d51e3b5652b8a4$export$f9cd1e43211d8a4a, newConfig);
    return $d4d51e3b5652b8a4$export$f9cd1e43211d8a4a;
}




var $8f5391358ccbeba2$exports = {};
$parcel$export($8f5391358ccbeba2$exports, "assertEqual", () => $8f5391358ccbeba2$export$27555cdfb0b84a1a);
$parcel$export($8f5391358ccbeba2$exports, "assertNotEqual", () => $8f5391358ccbeba2$export$49eedac51f614f7d);
$parcel$export($8f5391358ccbeba2$exports, "assertIs", () => $8f5391358ccbeba2$export$6fee1f82edcf4a03);
$parcel$export($8f5391358ccbeba2$exports, "assertNever", () => $8f5391358ccbeba2$export$cbadc5a7223772a8);
$parcel$export($8f5391358ccbeba2$exports, "assert", () => $8f5391358ccbeba2$export$a7a9523472993e97);
$parcel$export($8f5391358ccbeba2$exports, "getEnumValues", () => $8f5391358ccbeba2$export$70a5d58ec00f3c11);
$parcel$export($8f5391358ccbeba2$exports, "joinValues", () => $8f5391358ccbeba2$export$e79b744344f50f50);
$parcel$export($8f5391358ccbeba2$exports, "stringifyPrimitive", () => $8f5391358ccbeba2$export$5859860f650378f4);
$parcel$export($8f5391358ccbeba2$exports, "jsonStringifyReplacer", () => $8f5391358ccbeba2$export$f4defb13cab882b2);
$parcel$export($8f5391358ccbeba2$exports, "cached", () => $8f5391358ccbeba2$export$ade7a147f5129058);
$parcel$export($8f5391358ccbeba2$exports, "nullish", () => $8f5391358ccbeba2$export$69fd1b70ebae5687);
$parcel$export($8f5391358ccbeba2$exports, "cleanRegex", () => $8f5391358ccbeba2$export$78d521805d6c22e4);
$parcel$export($8f5391358ccbeba2$exports, "floatSafeRemainder", () => $8f5391358ccbeba2$export$7807b52a740a7117);
$parcel$export($8f5391358ccbeba2$exports, "defineLazy", () => $8f5391358ccbeba2$export$d43070a5843c1e2);
$parcel$export($8f5391358ccbeba2$exports, "objectClone", () => $8f5391358ccbeba2$export$103832c7353c2f50);
$parcel$export($8f5391358ccbeba2$exports, "assignProp", () => $8f5391358ccbeba2$export$2e23d0571746a3fb);
$parcel$export($8f5391358ccbeba2$exports, "mergeDefs", () => $8f5391358ccbeba2$export$8969f8c824382d73);
$parcel$export($8f5391358ccbeba2$exports, "cloneDef", () => $8f5391358ccbeba2$export$21596dc63856f4c1);
$parcel$export($8f5391358ccbeba2$exports, "getElementAtPath", () => $8f5391358ccbeba2$export$4b74d241e1cc7892);
$parcel$export($8f5391358ccbeba2$exports, "promiseAllObject", () => $8f5391358ccbeba2$export$3db3408dad58da23);
$parcel$export($8f5391358ccbeba2$exports, "randomString", () => $8f5391358ccbeba2$export$7fa8378418b4411e);
$parcel$export($8f5391358ccbeba2$exports, "esc", () => $8f5391358ccbeba2$export$a1a11b095f88289a);
$parcel$export($8f5391358ccbeba2$exports, "slugify", () => $8f5391358ccbeba2$export$c383cdd2a518017a);
$parcel$export($8f5391358ccbeba2$exports, "captureStackTrace", () => $8f5391358ccbeba2$export$756e5cd2d260237b);
$parcel$export($8f5391358ccbeba2$exports, "isObject", () => $8f5391358ccbeba2$export$a6cdc56e425d0d0a);
$parcel$export($8f5391358ccbeba2$exports, "allowsEval", () => $8f5391358ccbeba2$export$1f119cb4d720843b);
$parcel$export($8f5391358ccbeba2$exports, "isPlainObject", () => $8f5391358ccbeba2$export$53b83ca8eaab0383);
$parcel$export($8f5391358ccbeba2$exports, "shallowClone", () => $8f5391358ccbeba2$export$370e8311c3cdebd9);
$parcel$export($8f5391358ccbeba2$exports, "numKeys", () => $8f5391358ccbeba2$export$71667e74ba29447f);
$parcel$export($8f5391358ccbeba2$exports, "getParsedType", () => $8f5391358ccbeba2$export$3e9057828ebd5c7a);
$parcel$export($8f5391358ccbeba2$exports, "propertyKeyTypes", () => $8f5391358ccbeba2$export$b99c149ecf60be48);
$parcel$export($8f5391358ccbeba2$exports, "primitiveTypes", () => $8f5391358ccbeba2$export$c34ffd355f76f0e4);
$parcel$export($8f5391358ccbeba2$exports, "escapeRegex", () => $8f5391358ccbeba2$export$104ed90cc1a13451);
$parcel$export($8f5391358ccbeba2$exports, "clone", () => $8f5391358ccbeba2$export$9cd59f9826255e47);
$parcel$export($8f5391358ccbeba2$exports, "normalizeParams", () => $8f5391358ccbeba2$export$d6b7b25dfacfd300);
$parcel$export($8f5391358ccbeba2$exports, "createTransparentProxy", () => $8f5391358ccbeba2$export$6ebbd8d3cb03909b);
$parcel$export($8f5391358ccbeba2$exports, "optionalKeys", () => $8f5391358ccbeba2$export$240159211e66adb9);
$parcel$export($8f5391358ccbeba2$exports, "NUMBER_FORMAT_RANGES", () => $8f5391358ccbeba2$export$8e78302060ccf26f);
$parcel$export($8f5391358ccbeba2$exports, "BIGINT_FORMAT_RANGES", () => $8f5391358ccbeba2$export$538d1d6d5cfcb3b6);
$parcel$export($8f5391358ccbeba2$exports, "pick", () => $8f5391358ccbeba2$export$357523c63a2253b9);
$parcel$export($8f5391358ccbeba2$exports, "omit", () => $8f5391358ccbeba2$export$30a06c8d3562193f);
$parcel$export($8f5391358ccbeba2$exports, "extend", () => $8f5391358ccbeba2$export$8b58be045bf06082);
$parcel$export($8f5391358ccbeba2$exports, "safeExtend", () => $8f5391358ccbeba2$export$40c90eb222f50efb);
$parcel$export($8f5391358ccbeba2$exports, "merge", () => $8f5391358ccbeba2$export$4950aa0f605343fb);
$parcel$export($8f5391358ccbeba2$exports, "partial", () => $8f5391358ccbeba2$export$e45945969df8035a);
$parcel$export($8f5391358ccbeba2$exports, "required", () => $8f5391358ccbeba2$export$a7a0278c004aac3f);
$parcel$export($8f5391358ccbeba2$exports, "aborted", () => $8f5391358ccbeba2$export$bd75b6d981b9c7f2);
$parcel$export($8f5391358ccbeba2$exports, "prefixIssues", () => $8f5391358ccbeba2$export$7f35a4c434118b9e);
$parcel$export($8f5391358ccbeba2$exports, "unwrapMessage", () => $8f5391358ccbeba2$export$56590e5a47837d61);
$parcel$export($8f5391358ccbeba2$exports, "finalizeIssue", () => $8f5391358ccbeba2$export$c5e667bbfc286a9d);
$parcel$export($8f5391358ccbeba2$exports, "getSizableOrigin", () => $8f5391358ccbeba2$export$67a7c9c676c45d2b);
$parcel$export($8f5391358ccbeba2$exports, "getLengthableOrigin", () => $8f5391358ccbeba2$export$479f5a070abeb487);
$parcel$export($8f5391358ccbeba2$exports, "issue", () => $8f5391358ccbeba2$export$69ad3503f98be476);
$parcel$export($8f5391358ccbeba2$exports, "cleanEnum", () => $8f5391358ccbeba2$export$9b57aa937148f32);
$parcel$export($8f5391358ccbeba2$exports, "base64ToUint8Array", () => $8f5391358ccbeba2$export$f01069a3c307e50e);
$parcel$export($8f5391358ccbeba2$exports, "uint8ArrayToBase64", () => $8f5391358ccbeba2$export$36bac84b1c2da9c7);
$parcel$export($8f5391358ccbeba2$exports, "base64urlToUint8Array", () => $8f5391358ccbeba2$export$b9fa2551f2db41e1);
$parcel$export($8f5391358ccbeba2$exports, "uint8ArrayToBase64url", () => $8f5391358ccbeba2$export$975f78e50159df6f);
$parcel$export($8f5391358ccbeba2$exports, "hexToUint8Array", () => $8f5391358ccbeba2$export$6c74ef56152ffb8d);
$parcel$export($8f5391358ccbeba2$exports, "uint8ArrayToHex", () => $8f5391358ccbeba2$export$c44b02fb03dbac82);
$parcel$export($8f5391358ccbeba2$exports, "Class", () => $8f5391358ccbeba2$export$4c85e640eb41c31b);
// functions
function $8f5391358ccbeba2$export$27555cdfb0b84a1a(val) {
    return val;
}
function $8f5391358ccbeba2$export$49eedac51f614f7d(val) {
    return val;
}
function $8f5391358ccbeba2$export$6fee1f82edcf4a03(_arg) {}
function $8f5391358ccbeba2$export$cbadc5a7223772a8(_x) {
    throw new Error();
}
function $8f5391358ccbeba2$export$a7a9523472993e97(_) {}
function $8f5391358ccbeba2$export$70a5d58ec00f3c11(entries) {
    const numericValues = Object.values(entries).filter((v)=>typeof v === "number");
    const values = Object.entries(entries).filter(([k, _])=>numericValues.indexOf(+k) === -1).map(([_, v])=>v);
    return values;
}
function $8f5391358ccbeba2$export$e79b744344f50f50(array, separator = "|") {
    return array.map((val)=>$8f5391358ccbeba2$export$5859860f650378f4(val)).join(separator);
}
function $8f5391358ccbeba2$export$f4defb13cab882b2(_, value) {
    if (typeof value === "bigint") return value.toString();
    return value;
}
function $8f5391358ccbeba2$export$ade7a147f5129058(getter) {
    const set = false;
    return {
        get value () {
            if (!set) {
                const value = getter();
                Object.defineProperty(this, "value", {
                    value: value
                });
                return value;
            }
            throw new Error("cached value already set");
        }
    };
}
function $8f5391358ccbeba2$export$69fd1b70ebae5687(input) {
    return input === null || input === undefined;
}
function $8f5391358ccbeba2$export$78d521805d6c22e4(source) {
    const start = source.startsWith("^") ? 1 : 0;
    const end = source.endsWith("$") ? source.length - 1 : source.length;
    return source.slice(start, end);
}
function $8f5391358ccbeba2$export$7807b52a740a7117(val, step) {
    const valDecCount = (val.toString().split(".")[1] || "").length;
    const stepString = step.toString();
    let stepDecCount = (stepString.split(".")[1] || "").length;
    if (stepDecCount === 0 && /\d?e-\d?/.test(stepString)) {
        const match = stepString.match(/\d?e-(\d?)/);
        if (match?.[1]) stepDecCount = Number.parseInt(match[1]);
    }
    const decCount = valDecCount > stepDecCount ? valDecCount : stepDecCount;
    const valInt = Number.parseInt(val.toFixed(decCount).replace(".", ""));
    const stepInt = Number.parseInt(step.toFixed(decCount).replace(".", ""));
    return valInt % stepInt / 10 ** decCount;
}
const $8f5391358ccbeba2$var$EVALUATING = Symbol("evaluating");
function $8f5391358ccbeba2$export$d43070a5843c1e2(object, key, getter) {
    let value = undefined;
    Object.defineProperty(object, key, {
        get () {
            if (value === $8f5391358ccbeba2$var$EVALUATING) // Circular reference detected, return undefined to break the cycle
            return undefined;
            if (value === undefined) {
                value = $8f5391358ccbeba2$var$EVALUATING;
                value = getter();
            }
            return value;
        },
        set (v) {
            Object.defineProperty(object, key, {
                value: v
            });
        // object[key] = v;
        },
        configurable: true
    });
}
function $8f5391358ccbeba2$export$103832c7353c2f50(obj) {
    return Object.create(Object.getPrototypeOf(obj), Object.getOwnPropertyDescriptors(obj));
}
function $8f5391358ccbeba2$export$2e23d0571746a3fb(target, prop, value) {
    Object.defineProperty(target, prop, {
        value: value,
        writable: true,
        enumerable: true,
        configurable: true
    });
}
function $8f5391358ccbeba2$export$8969f8c824382d73(...defs) {
    const mergedDescriptors = {};
    for (const def of defs){
        const descriptors = Object.getOwnPropertyDescriptors(def);
        Object.assign(mergedDescriptors, descriptors);
    }
    return Object.defineProperties({}, mergedDescriptors);
}
function $8f5391358ccbeba2$export$21596dc63856f4c1(schema) {
    return $8f5391358ccbeba2$export$8969f8c824382d73(schema._zod.def);
}
function $8f5391358ccbeba2$export$4b74d241e1cc7892(obj, path) {
    if (!path) return obj;
    return path.reduce((acc, key)=>acc?.[key], obj);
}
function $8f5391358ccbeba2$export$3db3408dad58da23(promisesObj) {
    const keys = Object.keys(promisesObj);
    const promises = keys.map((key)=>promisesObj[key]);
    return Promise.all(promises).then((results)=>{
        const resolvedObj = {};
        for(let i = 0; i < keys.length; i++)resolvedObj[keys[i]] = results[i];
        return resolvedObj;
    });
}
function $8f5391358ccbeba2$export$7fa8378418b4411e(length = 10) {
    const chars = "abcdefghijklmnopqrstuvwxyz";
    let str = "";
    for(let i = 0; i < length; i++)str += chars[Math.floor(Math.random() * chars.length)];
    return str;
}
function $8f5391358ccbeba2$export$a1a11b095f88289a(str) {
    return JSON.stringify(str);
}
function $8f5391358ccbeba2$export$c383cdd2a518017a(input) {
    return input.toLowerCase().trim().replace(/[^\w\s-]/g, "").replace(/[\s_-]+/g, "-").replace(/^-+|-+$/g, "");
}
const $8f5391358ccbeba2$export$756e5cd2d260237b = "captureStackTrace" in Error ? Error.captureStackTrace : (..._args)=>{};
function $8f5391358ccbeba2$export$a6cdc56e425d0d0a(data) {
    return typeof data === "object" && data !== null && !Array.isArray(data);
}
const $8f5391358ccbeba2$export$1f119cb4d720843b = $8f5391358ccbeba2$export$ade7a147f5129058(()=>{
    // @ts-ignore
    if (typeof navigator !== "undefined" && navigator?.userAgent?.includes("Cloudflare")) return false;
    try {
        const F = Function;
        new F("");
        return true;
    } catch (_) {
        return false;
    }
});
function $8f5391358ccbeba2$export$53b83ca8eaab0383(o) {
    if ($8f5391358ccbeba2$export$a6cdc56e425d0d0a(o) === false) return false;
    // modified constructor
    const ctor = o.constructor;
    if (ctor === undefined) return true;
    if (typeof ctor !== "function") return true;
    // modified prototype
    const prot = ctor.prototype;
    if ($8f5391358ccbeba2$export$a6cdc56e425d0d0a(prot) === false) return false;
    // ctor doesn't have static `isPrototypeOf`
    if (Object.prototype.hasOwnProperty.call(prot, "isPrototypeOf") === false) return false;
    return true;
}
function $8f5391358ccbeba2$export$370e8311c3cdebd9(o) {
    if ($8f5391358ccbeba2$export$53b83ca8eaab0383(o)) return {
        ...o
    };
    if (Array.isArray(o)) return [
        ...o
    ];
    return o;
}
function $8f5391358ccbeba2$export$71667e74ba29447f(data) {
    let keyCount = 0;
    for(const key in data)if (Object.prototype.hasOwnProperty.call(data, key)) keyCount++;
    return keyCount;
}
const $8f5391358ccbeba2$export$3e9057828ebd5c7a = (data)=>{
    const t = typeof data;
    switch(t){
        case "undefined":
            return "undefined";
        case "string":
            return "string";
        case "number":
            return Number.isNaN(data) ? "nan" : "number";
        case "boolean":
            return "boolean";
        case "function":
            return "function";
        case "bigint":
            return "bigint";
        case "symbol":
            return "symbol";
        case "object":
            if (Array.isArray(data)) return "array";
            if (data === null) return "null";
            if (data.then && typeof data.then === "function" && data.catch && typeof data.catch === "function") return "promise";
            if (typeof Map !== "undefined" && data instanceof Map) return "map";
            if (typeof Set !== "undefined" && data instanceof Set) return "set";
            if (typeof Date !== "undefined" && data instanceof Date) return "date";
            // @ts-ignore
            if (typeof File !== "undefined" && data instanceof File) return "file";
            return "object";
        default:
            throw new Error(`Unknown data type: ${t}`);
    }
};
const $8f5391358ccbeba2$export$b99c149ecf60be48 = new Set([
    "string",
    "number",
    "symbol"
]);
const $8f5391358ccbeba2$export$c34ffd355f76f0e4 = new Set([
    "string",
    "number",
    "bigint",
    "boolean",
    "symbol",
    "undefined"
]);
function $8f5391358ccbeba2$export$104ed90cc1a13451(str) {
    return str.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}
function $8f5391358ccbeba2$export$9cd59f9826255e47(inst, def, params) {
    const cl = new inst._zod.constr(def ?? inst._zod.def);
    if (!def || params?.parent) cl._zod.parent = inst;
    return cl;
}
function $8f5391358ccbeba2$export$d6b7b25dfacfd300(_params) {
    const params = _params;
    if (!params) return {};
    if (typeof params === "string") return {
        error: ()=>params
    };
    if (params?.message !== undefined) {
        if (params?.error !== undefined) throw new Error("Cannot specify both `message` and `error` params");
        params.error = params.message;
    }
    delete params.message;
    if (typeof params.error === "string") return {
        ...params,
        error: ()=>params.error
    };
    return params;
}
function $8f5391358ccbeba2$export$6ebbd8d3cb03909b(getter) {
    let target;
    return new Proxy({}, {
        get (_, prop, receiver) {
            target ?? (target = getter());
            return Reflect.get(target, prop, receiver);
        },
        set (_, prop, value, receiver) {
            target ?? (target = getter());
            return Reflect.set(target, prop, value, receiver);
        },
        has (_, prop) {
            target ?? (target = getter());
            return Reflect.has(target, prop);
        },
        deleteProperty (_, prop) {
            target ?? (target = getter());
            return Reflect.deleteProperty(target, prop);
        },
        ownKeys (_) {
            target ?? (target = getter());
            return Reflect.ownKeys(target);
        },
        getOwnPropertyDescriptor (_, prop) {
            target ?? (target = getter());
            return Reflect.getOwnPropertyDescriptor(target, prop);
        },
        defineProperty (_, prop, descriptor) {
            target ?? (target = getter());
            return Reflect.defineProperty(target, prop, descriptor);
        }
    });
}
function $8f5391358ccbeba2$export$5859860f650378f4(value) {
    if (typeof value === "bigint") return value.toString() + "n";
    if (typeof value === "string") return `"${value}"`;
    return `${value}`;
}
function $8f5391358ccbeba2$export$240159211e66adb9(shape) {
    return Object.keys(shape).filter((k)=>{
        return shape[k]._zod.optin === "optional" && shape[k]._zod.optout === "optional";
    });
}
const $8f5391358ccbeba2$export$8e78302060ccf26f = {
    safeint: [
        Number.MIN_SAFE_INTEGER,
        Number.MAX_SAFE_INTEGER
    ],
    int32: [
        -2147483648,
        2147483647
    ],
    uint32: [
        0,
        4294967295
    ],
    float32: [
        -340282346638528860000000000000000000000,
        3.4028234663852886e38
    ],
    float64: [
        -Number.MAX_VALUE,
        Number.MAX_VALUE
    ]
};
const $8f5391358ccbeba2$export$538d1d6d5cfcb3b6 = {
    int64: [
        /* @__PURE__*/ BigInt("-9223372036854775808"),
        /* @__PURE__*/ BigInt("9223372036854775807")
    ],
    uint64: [
        /* @__PURE__*/ BigInt(0),
        /* @__PURE__*/ BigInt("18446744073709551615")
    ]
};
function $8f5391358ccbeba2$export$357523c63a2253b9(schema, mask) {
    const currDef = schema._zod.def;
    const def = $8f5391358ccbeba2$export$8969f8c824382d73(schema._zod.def, {
        get shape () {
            const newShape = {};
            for(const key in mask){
                if (!(key in currDef.shape)) throw new Error(`Unrecognized key: "${key}"`);
                if (!mask[key]) continue;
                newShape[key] = currDef.shape[key];
            }
            $8f5391358ccbeba2$export$2e23d0571746a3fb(this, "shape", newShape); // self-caching
            return newShape;
        },
        checks: []
    });
    return $8f5391358ccbeba2$export$9cd59f9826255e47(schema, def);
}
function $8f5391358ccbeba2$export$30a06c8d3562193f(schema, mask) {
    const currDef = schema._zod.def;
    const def = $8f5391358ccbeba2$export$8969f8c824382d73(schema._zod.def, {
        get shape () {
            const newShape = {
                ...schema._zod.def.shape
            };
            for(const key in mask){
                if (!(key in currDef.shape)) throw new Error(`Unrecognized key: "${key}"`);
                if (!mask[key]) continue;
                delete newShape[key];
            }
            $8f5391358ccbeba2$export$2e23d0571746a3fb(this, "shape", newShape); // self-caching
            return newShape;
        },
        checks: []
    });
    return $8f5391358ccbeba2$export$9cd59f9826255e47(schema, def);
}
function $8f5391358ccbeba2$export$8b58be045bf06082(schema, shape) {
    if (!$8f5391358ccbeba2$export$53b83ca8eaab0383(shape)) throw new Error("Invalid input to extend: expected a plain object");
    const checks = schema._zod.def.checks;
    const hasChecks = checks && checks.length > 0;
    if (hasChecks) throw new Error("Object schemas containing refinements cannot be extended. Use `.safeExtend()` instead.");
    const def = $8f5391358ccbeba2$export$8969f8c824382d73(schema._zod.def, {
        get shape () {
            const _shape = {
                ...schema._zod.def.shape,
                ...shape
            };
            $8f5391358ccbeba2$export$2e23d0571746a3fb(this, "shape", _shape); // self-caching
            return _shape;
        },
        checks: []
    });
    return $8f5391358ccbeba2$export$9cd59f9826255e47(schema, def);
}
function $8f5391358ccbeba2$export$40c90eb222f50efb(schema, shape) {
    if (!$8f5391358ccbeba2$export$53b83ca8eaab0383(shape)) throw new Error("Invalid input to safeExtend: expected a plain object");
    const def = {
        ...schema._zod.def,
        get shape () {
            const _shape = {
                ...schema._zod.def.shape,
                ...shape
            };
            $8f5391358ccbeba2$export$2e23d0571746a3fb(this, "shape", _shape); // self-caching
            return _shape;
        },
        checks: schema._zod.def.checks
    };
    return $8f5391358ccbeba2$export$9cd59f9826255e47(schema, def);
}
function $8f5391358ccbeba2$export$4950aa0f605343fb(a, b) {
    const def = $8f5391358ccbeba2$export$8969f8c824382d73(a._zod.def, {
        get shape () {
            const _shape = {
                ...a._zod.def.shape,
                ...b._zod.def.shape
            };
            $8f5391358ccbeba2$export$2e23d0571746a3fb(this, "shape", _shape); // self-caching
            return _shape;
        },
        get catchall () {
            return b._zod.def.catchall;
        },
        checks: []
    });
    return $8f5391358ccbeba2$export$9cd59f9826255e47(a, def);
}
function $8f5391358ccbeba2$export$e45945969df8035a(Class, schema, mask) {
    const def = $8f5391358ccbeba2$export$8969f8c824382d73(schema._zod.def, {
        get shape () {
            const oldShape = schema._zod.def.shape;
            const shape = {
                ...oldShape
            };
            if (mask) for(const key in mask){
                if (!(key in oldShape)) throw new Error(`Unrecognized key: "${key}"`);
                if (!mask[key]) continue;
                // if (oldShape[key]!._zod.optin === "optional") continue;
                shape[key] = Class ? new Class({
                    type: "optional",
                    innerType: oldShape[key]
                }) : oldShape[key];
            }
            else for(const key in oldShape)// if (oldShape[key]!._zod.optin === "optional") continue;
            shape[key] = Class ? new Class({
                type: "optional",
                innerType: oldShape[key]
            }) : oldShape[key];
            $8f5391358ccbeba2$export$2e23d0571746a3fb(this, "shape", shape); // self-caching
            return shape;
        },
        checks: []
    });
    return $8f5391358ccbeba2$export$9cd59f9826255e47(schema, def);
}
function $8f5391358ccbeba2$export$a7a0278c004aac3f(Class, schema, mask) {
    const def = $8f5391358ccbeba2$export$8969f8c824382d73(schema._zod.def, {
        get shape () {
            const oldShape = schema._zod.def.shape;
            const shape = {
                ...oldShape
            };
            if (mask) for(const key in mask){
                if (!(key in shape)) throw new Error(`Unrecognized key: "${key}"`);
                if (!mask[key]) continue;
                // overwrite with non-optional
                shape[key] = new Class({
                    type: "nonoptional",
                    innerType: oldShape[key]
                });
            }
            else for(const key in oldShape)// overwrite with non-optional
            shape[key] = new Class({
                type: "nonoptional",
                innerType: oldShape[key]
            });
            $8f5391358ccbeba2$export$2e23d0571746a3fb(this, "shape", shape); // self-caching
            return shape;
        },
        checks: []
    });
    return $8f5391358ccbeba2$export$9cd59f9826255e47(schema, def);
}
function $8f5391358ccbeba2$export$bd75b6d981b9c7f2(x, startIndex = 0) {
    if (x.aborted === true) return true;
    for(let i = startIndex; i < x.issues.length; i++){
        if (x.issues[i]?.continue !== true) return true;
    }
    return false;
}
function $8f5391358ccbeba2$export$7f35a4c434118b9e(path, issues) {
    return issues.map((iss)=>{
        var _a;
        (_a = iss).path ?? (_a.path = []);
        iss.path.unshift(path);
        return iss;
    });
}
function $8f5391358ccbeba2$export$56590e5a47837d61(message) {
    return typeof message === "string" ? message : message?.message;
}
function $8f5391358ccbeba2$export$c5e667bbfc286a9d(iss, ctx, config) {
    const full = {
        ...iss,
        path: iss.path ?? []
    };
    // for backwards compatibility
    if (!iss.message) {
        const message = $8f5391358ccbeba2$export$56590e5a47837d61(iss.inst?._zod.def?.error?.(iss)) ?? $8f5391358ccbeba2$export$56590e5a47837d61(ctx?.error?.(iss)) ?? $8f5391358ccbeba2$export$56590e5a47837d61(config.customError?.(iss)) ?? $8f5391358ccbeba2$export$56590e5a47837d61(config.localeError?.(iss)) ?? "Invalid input";
        full.message = message;
    }
    // delete (full as any).def;
    delete full.inst;
    delete full.continue;
    if (!ctx?.reportInput) delete full.input;
    return full;
}
function $8f5391358ccbeba2$export$67a7c9c676c45d2b(input) {
    if (input instanceof Set) return "set";
    if (input instanceof Map) return "map";
    // @ts-ignore
    if (input instanceof File) return "file";
    return "unknown";
}
function $8f5391358ccbeba2$export$479f5a070abeb487(input) {
    if (Array.isArray(input)) return "array";
    if (typeof input === "string") return "string";
    return "unknown";
}
function $8f5391358ccbeba2$export$69ad3503f98be476(...args) {
    const [iss, input, inst] = args;
    if (typeof iss === "string") return {
        message: iss,
        code: "custom",
        input: input,
        inst: inst
    };
    return {
        ...iss
    };
}
function $8f5391358ccbeba2$export$9b57aa937148f32(obj) {
    return Object.entries(obj).filter(([k, _])=>{
        // return true if NaN, meaning it's not a number, thus a string key
        return Number.isNaN(Number.parseInt(k, 10));
    }).map((el)=>el[1]);
}
function $8f5391358ccbeba2$export$f01069a3c307e50e(base64) {
    const binaryString = atob(base64);
    const bytes = new Uint8Array(binaryString.length);
    for(let i = 0; i < binaryString.length; i++)bytes[i] = binaryString.charCodeAt(i);
    return bytes;
}
function $8f5391358ccbeba2$export$36bac84b1c2da9c7(bytes) {
    let binaryString = "";
    for(let i = 0; i < bytes.length; i++)binaryString += String.fromCharCode(bytes[i]);
    return btoa(binaryString);
}
function $8f5391358ccbeba2$export$b9fa2551f2db41e1(base64url) {
    const base64 = base64url.replace(/-/g, "+").replace(/_/g, "/");
    const padding = "=".repeat((4 - base64.length % 4) % 4);
    return $8f5391358ccbeba2$export$f01069a3c307e50e(base64 + padding);
}
function $8f5391358ccbeba2$export$975f78e50159df6f(bytes) {
    return $8f5391358ccbeba2$export$36bac84b1c2da9c7(bytes).replace(/\+/g, "-").replace(/\//g, "_").replace(/=/g, "");
}
function $8f5391358ccbeba2$export$6c74ef56152ffb8d(hex) {
    const cleanHex = hex.replace(/^0x/, "");
    if (cleanHex.length % 2 !== 0) throw new Error("Invalid hex string length");
    const bytes = new Uint8Array(cleanHex.length / 2);
    for(let i = 0; i < cleanHex.length; i += 2)bytes[i / 2] = Number.parseInt(cleanHex.slice(i, i + 2), 16);
    return bytes;
}
function $8f5391358ccbeba2$export$c44b02fb03dbac82(bytes) {
    return Array.from(bytes).map((b)=>b.toString(16).padStart(2, "0")).join("");
}
class $8f5391358ccbeba2$export$4c85e640eb41c31b {
    constructor(..._args){}
}


const $cfe0667fefc5f30b$var$initializer = (inst, def)=>{
    inst.name = "$ZodError";
    Object.defineProperty(inst, "_zod", {
        value: inst._zod,
        enumerable: false
    });
    Object.defineProperty(inst, "issues", {
        value: def,
        enumerable: false
    });
    inst.message = JSON.stringify(def, $8f5391358ccbeba2$export$f4defb13cab882b2, 2);
    Object.defineProperty(inst, "toString", {
        value: ()=>inst.message,
        enumerable: false
    });
};
const $cfe0667fefc5f30b$export$544878318730b1d8 = (0, $d4d51e3b5652b8a4$export$3122533d606194de)("$ZodError", $cfe0667fefc5f30b$var$initializer);
const $cfe0667fefc5f30b$export$4e07b515db2f7672 = (0, $d4d51e3b5652b8a4$export$3122533d606194de)("$ZodError", $cfe0667fefc5f30b$var$initializer, {
    Parent: Error
});
function $cfe0667fefc5f30b$export$4d7e0dfd5ca8366f(error, mapper = (issue)=>issue.message) {
    const fieldErrors = {};
    const formErrors = [];
    for (const sub of error.issues)if (sub.path.length > 0) {
        fieldErrors[sub.path[0]] = fieldErrors[sub.path[0]] || [];
        fieldErrors[sub.path[0]].push(mapper(sub));
    } else formErrors.push(mapper(sub));
    return {
        formErrors: formErrors,
        fieldErrors: fieldErrors
    };
}
function $cfe0667fefc5f30b$export$7b5b869ee98c16ab(error, mapper = (issue)=>issue.message) {
    const fieldErrors = {
        _errors: []
    };
    const processError = (error)=>{
        for (const issue of error.issues){
            if (issue.code === "invalid_union" && issue.errors.length) issue.errors.map((issues)=>processError({
                    issues: issues
                }));
            else if (issue.code === "invalid_key") processError({
                issues: issue.issues
            });
            else if (issue.code === "invalid_element") processError({
                issues: issue.issues
            });
            else if (issue.path.length === 0) fieldErrors._errors.push(mapper(issue));
            else {
                let curr = fieldErrors;
                let i = 0;
                while(i < issue.path.length){
                    const el = issue.path[i];
                    const terminal = i === issue.path.length - 1;
                    if (!terminal) curr[el] = curr[el] || {
                        _errors: []
                    };
                    else {
                        curr[el] = curr[el] || {
                            _errors: []
                        };
                        curr[el]._errors.push(mapper(issue));
                    }
                    curr = curr[el];
                    i++;
                }
            }
        }
    };
    processError(error);
    return fieldErrors;
}
function $cfe0667fefc5f30b$export$93701dc89257de2f(error, mapper = (issue)=>issue.message) {
    const result = {
        errors: []
    };
    const processError = (error, path = [])=>{
        var _a, _b;
        for (const issue of error.issues){
            if (issue.code === "invalid_union" && issue.errors.length) // regular union error
            issue.errors.map((issues)=>processError({
                    issues: issues
                }, issue.path));
            else if (issue.code === "invalid_key") processError({
                issues: issue.issues
            }, issue.path);
            else if (issue.code === "invalid_element") processError({
                issues: issue.issues
            }, issue.path);
            else {
                const fullpath = [
                    ...path,
                    ...issue.path
                ];
                if (fullpath.length === 0) {
                    result.errors.push(mapper(issue));
                    continue;
                }
                let curr = result;
                let i = 0;
                while(i < fullpath.length){
                    const el = fullpath[i];
                    const terminal = i === fullpath.length - 1;
                    if (typeof el === "string") {
                        curr.properties ?? (curr.properties = {});
                        (_a = curr.properties)[el] ?? (_a[el] = {
                            errors: []
                        });
                        curr = curr.properties[el];
                    } else {
                        curr.items ?? (curr.items = []);
                        (_b = curr.items)[el] ?? (_b[el] = {
                            errors: []
                        });
                        curr = curr.items[el];
                    }
                    if (terminal) curr.errors.push(mapper(issue));
                    i++;
                }
            }
        }
    };
    processError(error);
    return result;
}
function $cfe0667fefc5f30b$export$47768e8997ceb13a(_path) {
    const segs = [];
    const path = _path.map((seg)=>typeof seg === "object" ? seg.key : seg);
    for (const seg of path){
        if (typeof seg === "number") segs.push(`[${seg}]`);
        else if (typeof seg === "symbol") segs.push(`[${JSON.stringify(String(seg))}]`);
        else if (/[^\w$]/.test(seg)) segs.push(`[${JSON.stringify(seg)}]`);
        else {
            if (segs.length) segs.push(".");
            segs.push(seg);
        }
    }
    return segs.join("");
}
function $cfe0667fefc5f30b$export$44eaaa72d914fe8c(error) {
    const lines = [];
    // sort by path length
    const issues = [
        ...error.issues
    ].sort((a, b)=>(a.path ?? []).length - (b.path ?? []).length);
    // Process each issue
    for (const issue of issues){
        lines.push(`\u{2716} ${issue.message}`);
        if (issue.path?.length) lines.push(`  \u{2192} at ${$cfe0667fefc5f30b$export$47768e8997ceb13a(issue.path)}`);
    }
    // Convert Map to formatted string
    return lines.join("\n");
}



const $65d57763ab0754f3$export$dcd1bb9991b57edf = (_Err)=>(schema, value, _ctx, _params)=>{
        const ctx = _ctx ? Object.assign(_ctx, {
            async: false
        }) : {
            async: false
        };
        const result = schema._zod.run({
            value: value,
            issues: []
        }, ctx);
        if (result instanceof Promise) throw new $d4d51e3b5652b8a4$export$13016bcec11ba196();
        if (result.issues.length) {
            const e = new (_params?.Err ?? _Err)(result.issues.map((iss)=>$8f5391358ccbeba2$export$c5e667bbfc286a9d(iss, ctx, $d4d51e3b5652b8a4$export$e506a1d27d1eaa20())));
            $8f5391358ccbeba2$export$756e5cd2d260237b(e, _params?.callee);
            throw e;
        }
        return result.value;
    };
const $65d57763ab0754f3$export$98e6a39c04603d36 = /* @__PURE__*/ $65d57763ab0754f3$export$dcd1bb9991b57edf($cfe0667fefc5f30b$export$4e07b515db2f7672);
const $65d57763ab0754f3$export$1fcca22dc6c780d0 = (_Err)=>async (schema, value, _ctx, params)=>{
        const ctx = _ctx ? Object.assign(_ctx, {
            async: true
        }) : {
            async: true
        };
        let result = schema._zod.run({
            value: value,
            issues: []
        }, ctx);
        if (result instanceof Promise) result = await result;
        if (result.issues.length) {
            const e = new (params?.Err ?? _Err)(result.issues.map((iss)=>$8f5391358ccbeba2$export$c5e667bbfc286a9d(iss, ctx, $d4d51e3b5652b8a4$export$e506a1d27d1eaa20())));
            $8f5391358ccbeba2$export$756e5cd2d260237b(e, params?.callee);
            throw e;
        }
        return result.value;
    };
const $65d57763ab0754f3$export$59b6f938fbf579e3 = /* @__PURE__*/ $65d57763ab0754f3$export$1fcca22dc6c780d0($cfe0667fefc5f30b$export$4e07b515db2f7672);
const $65d57763ab0754f3$export$5ec32605bf51e98e = (_Err)=>(schema, value, _ctx)=>{
        const ctx = _ctx ? {
            ..._ctx,
            async: false
        } : {
            async: false
        };
        const result = schema._zod.run({
            value: value,
            issues: []
        }, ctx);
        if (result instanceof Promise) throw new $d4d51e3b5652b8a4$export$13016bcec11ba196();
        return result.issues.length ? {
            success: false,
            error: new (_Err ?? $cfe0667fefc5f30b$export$544878318730b1d8)(result.issues.map((iss)=>$8f5391358ccbeba2$export$c5e667bbfc286a9d(iss, ctx, $d4d51e3b5652b8a4$export$e506a1d27d1eaa20())))
        } : {
            success: true,
            data: result.value
        };
    };
const $65d57763ab0754f3$export$b48ee232557adc37 = /* @__PURE__*/ $65d57763ab0754f3$export$5ec32605bf51e98e($cfe0667fefc5f30b$export$4e07b515db2f7672);
const $65d57763ab0754f3$export$c08c7322f5625faf = (_Err)=>async (schema, value, _ctx)=>{
        const ctx = _ctx ? Object.assign(_ctx, {
            async: true
        }) : {
            async: true
        };
        let result = schema._zod.run({
            value: value,
            issues: []
        }, ctx);
        if (result instanceof Promise) result = await result;
        return result.issues.length ? {
            success: false,
            error: new _Err(result.issues.map((iss)=>$8f5391358ccbeba2$export$c5e667bbfc286a9d(iss, ctx, $d4d51e3b5652b8a4$export$e506a1d27d1eaa20())))
        } : {
            success: true,
            data: result.value
        };
    };
const $65d57763ab0754f3$export$9b07b0d6e0389261 = /* @__PURE__*/ $65d57763ab0754f3$export$c08c7322f5625faf($cfe0667fefc5f30b$export$4e07b515db2f7672);
const $65d57763ab0754f3$export$50e4445ccc10715b = (_Err)=>(schema, value, _ctx)=>{
        const ctx = _ctx ? Object.assign(_ctx, {
            direction: "backward"
        }) : {
            direction: "backward"
        };
        return $65d57763ab0754f3$export$dcd1bb9991b57edf(_Err)(schema, value, ctx);
    };
const $65d57763ab0754f3$export$c564cdbbe6da493 = /* @__PURE__*/ $65d57763ab0754f3$export$50e4445ccc10715b($cfe0667fefc5f30b$export$4e07b515db2f7672);
const $65d57763ab0754f3$export$bb4a21772f43c982 = (_Err)=>(schema, value, _ctx)=>{
        return $65d57763ab0754f3$export$dcd1bb9991b57edf(_Err)(schema, value, _ctx);
    };
const $65d57763ab0754f3$export$2f872c0f2117be69 = /* @__PURE__*/ $65d57763ab0754f3$export$bb4a21772f43c982($cfe0667fefc5f30b$export$4e07b515db2f7672);
const $65d57763ab0754f3$export$9954740a1a5eaaf1 = (_Err)=>async (schema, value, _ctx)=>{
        const ctx = _ctx ? Object.assign(_ctx, {
            direction: "backward"
        }) : {
            direction: "backward"
        };
        return $65d57763ab0754f3$export$1fcca22dc6c780d0(_Err)(schema, value, ctx);
    };
const $65d57763ab0754f3$export$1a62660bbffb8f11 = /* @__PURE__*/ $65d57763ab0754f3$export$9954740a1a5eaaf1($cfe0667fefc5f30b$export$4e07b515db2f7672);
const $65d57763ab0754f3$export$74b09e12c8956d91 = (_Err)=>async (schema, value, _ctx)=>{
        return $65d57763ab0754f3$export$1fcca22dc6c780d0(_Err)(schema, value, _ctx);
    };
const $65d57763ab0754f3$export$e4c183687a6ff9b = /* @__PURE__*/ $65d57763ab0754f3$export$74b09e12c8956d91($cfe0667fefc5f30b$export$4e07b515db2f7672);
const $65d57763ab0754f3$export$6d688d774257f486 = (_Err)=>(schema, value, _ctx)=>{
        const ctx = _ctx ? Object.assign(_ctx, {
            direction: "backward"
        }) : {
            direction: "backward"
        };
        return $65d57763ab0754f3$export$5ec32605bf51e98e(_Err)(schema, value, ctx);
    };
const $65d57763ab0754f3$export$c094f85f253e4d7d = /* @__PURE__*/ $65d57763ab0754f3$export$6d688d774257f486($cfe0667fefc5f30b$export$4e07b515db2f7672);
const $65d57763ab0754f3$export$b2ef531a734faad5 = (_Err)=>(schema, value, _ctx)=>{
        return $65d57763ab0754f3$export$5ec32605bf51e98e(_Err)(schema, value, _ctx);
    };
const $65d57763ab0754f3$export$7a47376c130cfeac = /* @__PURE__*/ $65d57763ab0754f3$export$b2ef531a734faad5($cfe0667fefc5f30b$export$4e07b515db2f7672);
const $65d57763ab0754f3$export$fa2ac180d22758d6 = (_Err)=>async (schema, value, _ctx)=>{
        const ctx = _ctx ? Object.assign(_ctx, {
            direction: "backward"
        }) : {
            direction: "backward"
        };
        return $65d57763ab0754f3$export$c08c7322f5625faf(_Err)(schema, value, ctx);
    };
const $65d57763ab0754f3$export$ed163a34170fecc5 = /* @__PURE__*/ $65d57763ab0754f3$export$fa2ac180d22758d6($cfe0667fefc5f30b$export$4e07b515db2f7672);
const $65d57763ab0754f3$export$f66d2b402dc6318c = (_Err)=>async (schema, value, _ctx)=>{
        return $65d57763ab0754f3$export$c08c7322f5625faf(_Err)(schema, value, _ctx);
    };
const $65d57763ab0754f3$export$9f879005292a9bc9 = /* @__PURE__*/ $65d57763ab0754f3$export$f66d2b402dc6318c($cfe0667fefc5f30b$export$4e07b515db2f7672);



// import { $ZodType } from "./schemas.js";

var $675a4de49b6b20b4$exports = {};
$parcel$export($675a4de49b6b20b4$exports, "cuid", () => $675a4de49b6b20b4$export$e057ec210c7d3443);
$parcel$export($675a4de49b6b20b4$exports, "cuid2", () => $675a4de49b6b20b4$export$af5866a6cccce9f0);
$parcel$export($675a4de49b6b20b4$exports, "ulid", () => $675a4de49b6b20b4$export$c34778236461ea95);
$parcel$export($675a4de49b6b20b4$exports, "xid", () => $675a4de49b6b20b4$export$5eecaf20006cb6cb);
$parcel$export($675a4de49b6b20b4$exports, "ksuid", () => $675a4de49b6b20b4$export$f49b11deeb9beb0f);
$parcel$export($675a4de49b6b20b4$exports, "nanoid", () => $675a4de49b6b20b4$export$ac4959f4f1338dfc);
$parcel$export($675a4de49b6b20b4$exports, "duration", () => $675a4de49b6b20b4$export$1f34108aa9eb96ab);
$parcel$export($675a4de49b6b20b4$exports, "extendedDuration", () => $675a4de49b6b20b4$export$e30244ba59a8cd84);
$parcel$export($675a4de49b6b20b4$exports, "guid", () => $675a4de49b6b20b4$export$46e8f25c7328f77e);
$parcel$export($675a4de49b6b20b4$exports, "uuid", () => $675a4de49b6b20b4$export$31b40729666a4ae0);
$parcel$export($675a4de49b6b20b4$exports, "uuid4", () => $675a4de49b6b20b4$export$19f53698e68b2496);
$parcel$export($675a4de49b6b20b4$exports, "uuid6", () => $675a4de49b6b20b4$export$1d78c41b29712c01);
$parcel$export($675a4de49b6b20b4$exports, "uuid7", () => $675a4de49b6b20b4$export$b3092b3ac1fa0ace);
$parcel$export($675a4de49b6b20b4$exports, "email", () => $675a4de49b6b20b4$export$d290fa47940df19d);
$parcel$export($675a4de49b6b20b4$exports, "html5Email", () => $675a4de49b6b20b4$export$d2c782992f0a89ee);
$parcel$export($675a4de49b6b20b4$exports, "rfc5322Email", () => $675a4de49b6b20b4$export$54f6bc2d4fd0bb08);
$parcel$export($675a4de49b6b20b4$exports, "unicodeEmail", () => $675a4de49b6b20b4$export$f8855510ae7521df);
$parcel$export($675a4de49b6b20b4$exports, "idnEmail", () => $675a4de49b6b20b4$export$d402ea1c27a77371);
$parcel$export($675a4de49b6b20b4$exports, "browserEmail", () => $675a4de49b6b20b4$export$9d1ec0311c8ce72e);
$parcel$export($675a4de49b6b20b4$exports, "emoji", () => $675a4de49b6b20b4$export$a19185d1233fc4b2);
$parcel$export($675a4de49b6b20b4$exports, "ipv4", () => $675a4de49b6b20b4$export$291a17a16047f284);
$parcel$export($675a4de49b6b20b4$exports, "ipv6", () => $675a4de49b6b20b4$export$4e0c86a59c658526);
$parcel$export($675a4de49b6b20b4$exports, "mac", () => $675a4de49b6b20b4$export$f8d11e097856efcf);
$parcel$export($675a4de49b6b20b4$exports, "cidrv4", () => $675a4de49b6b20b4$export$fc96793d9715e5a1);
$parcel$export($675a4de49b6b20b4$exports, "cidrv6", () => $675a4de49b6b20b4$export$b6e650831cac87fb);
$parcel$export($675a4de49b6b20b4$exports, "base64", () => $675a4de49b6b20b4$export$b3b2de96497acc47);
$parcel$export($675a4de49b6b20b4$exports, "base64url", () => $675a4de49b6b20b4$export$7d21597c7bc64465);
$parcel$export($675a4de49b6b20b4$exports, "hostname", () => $675a4de49b6b20b4$export$640106f6dc7d2706);
$parcel$export($675a4de49b6b20b4$exports, "domain", () => $675a4de49b6b20b4$export$21779e503be4cd98);
$parcel$export($675a4de49b6b20b4$exports, "e164", () => $675a4de49b6b20b4$export$2fa5ed24c9ef198e);
$parcel$export($675a4de49b6b20b4$exports, "date", () => $675a4de49b6b20b4$export$324d90190a8b822a);
$parcel$export($675a4de49b6b20b4$exports, "time", () => $675a4de49b6b20b4$export$2da9be4cfdb689b1);
$parcel$export($675a4de49b6b20b4$exports, "datetime", () => $675a4de49b6b20b4$export$7ba4466dbd0f07e1);
$parcel$export($675a4de49b6b20b4$exports, "string", () => $675a4de49b6b20b4$export$22b082955e083ec3);
$parcel$export($675a4de49b6b20b4$exports, "bigint", () => $675a4de49b6b20b4$export$a0f65b52274bcc00);
$parcel$export($675a4de49b6b20b4$exports, "integer", () => $675a4de49b6b20b4$export$32744b5b3bba4764);
$parcel$export($675a4de49b6b20b4$exports, "number", () => $675a4de49b6b20b4$export$98e628dec113755e);
$parcel$export($675a4de49b6b20b4$exports, "boolean", () => $675a4de49b6b20b4$export$4a21f16c33752377);
$parcel$export($675a4de49b6b20b4$exports, "null", () => $675a4de49b6b20b4$export$7b1b591b262c240);
$parcel$export($675a4de49b6b20b4$exports, "undefined", () => $675a4de49b6b20b4$export$1db45310990710a5);
$parcel$export($675a4de49b6b20b4$exports, "lowercase", () => $675a4de49b6b20b4$export$5b1f80f3c282648c);
$parcel$export($675a4de49b6b20b4$exports, "uppercase", () => $675a4de49b6b20b4$export$6cfe151e6b925e83);
$parcel$export($675a4de49b6b20b4$exports, "hex", () => $675a4de49b6b20b4$export$834dfc94dde4b3d8);
$parcel$export($675a4de49b6b20b4$exports, "md5_hex", () => $675a4de49b6b20b4$export$7d7ef811f6d53a1);
$parcel$export($675a4de49b6b20b4$exports, "md5_base64", () => $675a4de49b6b20b4$export$85425f7cda9f4890);
$parcel$export($675a4de49b6b20b4$exports, "md5_base64url", () => $675a4de49b6b20b4$export$e54699b04083758c);
$parcel$export($675a4de49b6b20b4$exports, "sha1_hex", () => $675a4de49b6b20b4$export$2f163473ef893e12);
$parcel$export($675a4de49b6b20b4$exports, "sha1_base64", () => $675a4de49b6b20b4$export$fc9670fedfd2524a);
$parcel$export($675a4de49b6b20b4$exports, "sha1_base64url", () => $675a4de49b6b20b4$export$5b6729b977839ffd);
$parcel$export($675a4de49b6b20b4$exports, "sha256_hex", () => $675a4de49b6b20b4$export$a923016129fea5fb);
$parcel$export($675a4de49b6b20b4$exports, "sha256_base64", () => $675a4de49b6b20b4$export$ebc25582a9e85396);
$parcel$export($675a4de49b6b20b4$exports, "sha256_base64url", () => $675a4de49b6b20b4$export$9b7979bfebd9716e);
$parcel$export($675a4de49b6b20b4$exports, "sha384_hex", () => $675a4de49b6b20b4$export$61d1fe464d10a5d1);
$parcel$export($675a4de49b6b20b4$exports, "sha384_base64", () => $675a4de49b6b20b4$export$103403cb96133ac3);
$parcel$export($675a4de49b6b20b4$exports, "sha384_base64url", () => $675a4de49b6b20b4$export$eeafcb7aab6a9870);
$parcel$export($675a4de49b6b20b4$exports, "sha512_hex", () => $675a4de49b6b20b4$export$e246a4310a1ad74d);
$parcel$export($675a4de49b6b20b4$exports, "sha512_base64", () => $675a4de49b6b20b4$export$f698997e063dbdae);
$parcel$export($675a4de49b6b20b4$exports, "sha512_base64url", () => $675a4de49b6b20b4$export$a63330069e1b81f6);

const $675a4de49b6b20b4$export$e057ec210c7d3443 = /^[cC][^\s-]{8,}$/;
const $675a4de49b6b20b4$export$af5866a6cccce9f0 = /^[0-9a-z]+$/;
const $675a4de49b6b20b4$export$c34778236461ea95 = /^[0-9A-HJKMNP-TV-Za-hjkmnp-tv-z]{26}$/;
const $675a4de49b6b20b4$export$5eecaf20006cb6cb = /^[0-9a-vA-V]{20}$/;
const $675a4de49b6b20b4$export$f49b11deeb9beb0f = /^[A-Za-z0-9]{27}$/;
const $675a4de49b6b20b4$export$ac4959f4f1338dfc = /^[a-zA-Z0-9_-]{21}$/;
const $675a4de49b6b20b4$export$1f34108aa9eb96ab = /^P(?:(\d+W)|(?!.*W)(?=\d|T\d)(\d+Y)?(\d+M)?(\d+D)?(T(?=\d)(\d+H)?(\d+M)?(\d+([.,]\d+)?S)?)?)$/;
const $675a4de49b6b20b4$export$e30244ba59a8cd84 = /^[-+]?P(?!$)(?:(?:[-+]?\d+Y)|(?:[-+]?\d+[.,]\d+Y$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:(?:[-+]?\d+W)|(?:[-+]?\d+[.,]\d+W$))?(?:(?:[-+]?\d+D)|(?:[-+]?\d+[.,]\d+D$))?(?:T(?=[\d+-])(?:(?:[-+]?\d+H)|(?:[-+]?\d+[.,]\d+H$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:[-+]?\d+(?:[.,]\d+)?S)?)??$/;
const $675a4de49b6b20b4$export$46e8f25c7328f77e = /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12})$/;
const $675a4de49b6b20b4$export$31b40729666a4ae0 = (version)=>{
    if (!version) return /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/;
    return new RegExp(`^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-${version}[0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12})$`);
};
const $675a4de49b6b20b4$export$19f53698e68b2496 = /*@__PURE__*/ $675a4de49b6b20b4$export$31b40729666a4ae0(4);
const $675a4de49b6b20b4$export$1d78c41b29712c01 = /*@__PURE__*/ $675a4de49b6b20b4$export$31b40729666a4ae0(6);
const $675a4de49b6b20b4$export$b3092b3ac1fa0ace = /*@__PURE__*/ $675a4de49b6b20b4$export$31b40729666a4ae0(7);
const $675a4de49b6b20b4$export$d290fa47940df19d = /^(?!\.)(?!.*\.\.)([A-Za-z0-9_'+\-\.]*)[A-Za-z0-9_+-]@([A-Za-z0-9][A-Za-z0-9\-]*\.)+[A-Za-z]{2,}$/;
const $675a4de49b6b20b4$export$d2c782992f0a89ee = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
const $675a4de49b6b20b4$export$54f6bc2d4fd0bb08 = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
const $675a4de49b6b20b4$export$f8855510ae7521df = /^[^\s@"]{1,64}@[^\s@]{1,255}$/u;
const $675a4de49b6b20b4$export$d402ea1c27a77371 = $675a4de49b6b20b4$export$f8855510ae7521df;
const $675a4de49b6b20b4$export$9d1ec0311c8ce72e = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
// from https://thekevinscott.com/emojis-in-javascript/#writing-a-regular-expression
const $675a4de49b6b20b4$var$_emoji = `^(\\p{Extended_Pictographic}|\\p{Emoji_Component})+$`;
function $675a4de49b6b20b4$export$a19185d1233fc4b2() {
    return new RegExp($675a4de49b6b20b4$var$_emoji, "u");
}
const $675a4de49b6b20b4$export$291a17a16047f284 = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])$/;
const $675a4de49b6b20b4$export$4e0c86a59c658526 = /^(([0-9a-fA-F]{1,4}:){7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:))$/;
const $675a4de49b6b20b4$export$f8d11e097856efcf = (delimiter)=>{
    const escapedDelim = $8f5391358ccbeba2$export$104ed90cc1a13451(delimiter ?? ":");
    return new RegExp(`^(?:[0-9A-F]{2}${escapedDelim}){5}[0-9A-F]{2}$|^(?:[0-9a-f]{2}${escapedDelim}){5}[0-9a-f]{2}$`);
};
const $675a4de49b6b20b4$export$fc96793d9715e5a1 = /^((25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\/([0-9]|[1-2][0-9]|3[0-2])$/;
const $675a4de49b6b20b4$export$b6e650831cac87fb = /^(([0-9a-fA-F]{1,4}:){7}[0-9a-fA-F]{1,4}|::|([0-9a-fA-F]{1,4})?::([0-9a-fA-F]{1,4}:?){0,6})\/(12[0-8]|1[01][0-9]|[1-9]?[0-9])$/;
const $675a4de49b6b20b4$export$b3b2de96497acc47 = /^$|^(?:[0-9a-zA-Z+/]{4})*(?:(?:[0-9a-zA-Z+/]{2}==)|(?:[0-9a-zA-Z+/]{3}=))?$/;
const $675a4de49b6b20b4$export$7d21597c7bc64465 = /^[A-Za-z0-9_-]*$/;
const $675a4de49b6b20b4$export$640106f6dc7d2706 = /^(?=.{1,253}\.?$)[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[-0-9a-zA-Z]{0,61}[0-9a-zA-Z])?)*\.?$/;
const $675a4de49b6b20b4$export$21779e503be4cd98 = /^([a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?\.)+[a-zA-Z]{2,}$/;
const $675a4de49b6b20b4$export$2fa5ed24c9ef198e = /^\+(?:[0-9]){6,14}[0-9]$/;
// const dateSource = `((\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-((0[13578]|1[02])-(0[1-9]|[12]\\d|3[01])|(0[469]|11)-(0[1-9]|[12]\\d|30)|(02)-(0[1-9]|1\\d|2[0-8])))`;
const $675a4de49b6b20b4$var$dateSource = `(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))`;
const $675a4de49b6b20b4$export$324d90190a8b822a = /*@__PURE__*/ new RegExp(`^${$675a4de49b6b20b4$var$dateSource}$`);
function $675a4de49b6b20b4$var$timeSource(args) {
    const hhmm = `(?:[01]\\d|2[0-3]):[0-5]\\d`;
    const regex = typeof args.precision === "number" ? args.precision === -1 ? `${hhmm}` : args.precision === 0 ? `${hhmm}:[0-5]\\d` : `${hhmm}:[0-5]\\d\\.\\d{${args.precision}}` : `${hhmm}(?::[0-5]\\d(?:\\.\\d+)?)?`;
    return regex;
}
function $675a4de49b6b20b4$export$2da9be4cfdb689b1(args) {
    return new RegExp(`^${$675a4de49b6b20b4$var$timeSource(args)}$`);
}
function $675a4de49b6b20b4$export$7ba4466dbd0f07e1(args) {
    const time = $675a4de49b6b20b4$var$timeSource({
        precision: args.precision
    });
    const opts = [
        "Z"
    ];
    if (args.local) opts.push("");
    // if (args.offset) opts.push(`([+-]\\d{2}:\\d{2})`);
    if (args.offset) opts.push(`([+-](?:[01]\\d|2[0-3]):[0-5]\\d)`);
    const timeRegex = `${time}(?:${opts.join("|")})`;
    return new RegExp(`^${$675a4de49b6b20b4$var$dateSource}T(?:${timeRegex})$`);
}
const $675a4de49b6b20b4$export$22b082955e083ec3 = (params)=>{
    const regex = params ? `[\\s\\S]{${params?.minimum ?? 0},${params?.maximum ?? ""}}` : `[\\s\\S]*`;
    return new RegExp(`^${regex}$`);
};
const $675a4de49b6b20b4$export$a0f65b52274bcc00 = /^-?\d+n?$/;
const $675a4de49b6b20b4$export$32744b5b3bba4764 = /^-?\d+$/;
const $675a4de49b6b20b4$export$98e628dec113755e = /^-?\d+(?:\.\d+)?/;
const $675a4de49b6b20b4$export$4a21f16c33752377 = /^(?:true|false)$/i;
const $675a4de49b6b20b4$export$7b1b591b262c240 = /^null$/i;
const $675a4de49b6b20b4$export$1db45310990710a5 = /^undefined$/i;
const $675a4de49b6b20b4$export$5b1f80f3c282648c = /^[^A-Z]*$/;
const $675a4de49b6b20b4$export$6cfe151e6b925e83 = /^[^a-z]*$/;
const $675a4de49b6b20b4$export$834dfc94dde4b3d8 = /^[0-9a-fA-F]*$/;
// Hash regexes for different algorithms and encodings
// Helper function to create base64 regex with exact length and padding
function $675a4de49b6b20b4$var$fixedBase64(bodyLength, padding) {
    return new RegExp(`^[A-Za-z0-9+/]{${bodyLength}}${padding}$`);
}
// Helper function to create base64url regex with exact length (no padding)
function $675a4de49b6b20b4$var$fixedBase64url(length) {
    return new RegExp(`^[A-Za-z0-9_-]{${length}}$`);
}
const $675a4de49b6b20b4$export$7d7ef811f6d53a1 = /^[0-9a-fA-F]{32}$/;
const $675a4de49b6b20b4$export$85425f7cda9f4890 = /*@__PURE__*/ $675a4de49b6b20b4$var$fixedBase64(22, "==");
const $675a4de49b6b20b4$export$e54699b04083758c = /*@__PURE__*/ $675a4de49b6b20b4$var$fixedBase64url(22);
const $675a4de49b6b20b4$export$2f163473ef893e12 = /^[0-9a-fA-F]{40}$/;
const $675a4de49b6b20b4$export$fc9670fedfd2524a = /*@__PURE__*/ $675a4de49b6b20b4$var$fixedBase64(27, "=");
const $675a4de49b6b20b4$export$5b6729b977839ffd = /*@__PURE__*/ $675a4de49b6b20b4$var$fixedBase64url(27);
const $675a4de49b6b20b4$export$a923016129fea5fb = /^[0-9a-fA-F]{64}$/;
const $675a4de49b6b20b4$export$ebc25582a9e85396 = /*@__PURE__*/ $675a4de49b6b20b4$var$fixedBase64(43, "=");
const $675a4de49b6b20b4$export$9b7979bfebd9716e = /*@__PURE__*/ $675a4de49b6b20b4$var$fixedBase64url(43);
const $675a4de49b6b20b4$export$61d1fe464d10a5d1 = /^[0-9a-fA-F]{96}$/;
const $675a4de49b6b20b4$export$103403cb96133ac3 = /*@__PURE__*/ $675a4de49b6b20b4$var$fixedBase64(64, "");
const $675a4de49b6b20b4$export$eeafcb7aab6a9870 = /*@__PURE__*/ $675a4de49b6b20b4$var$fixedBase64url(64);
const $675a4de49b6b20b4$export$e246a4310a1ad74d = /^[0-9a-fA-F]{128}$/;
const $675a4de49b6b20b4$export$f698997e063dbdae = /*@__PURE__*/ $675a4de49b6b20b4$var$fixedBase64(86, "==");
const $675a4de49b6b20b4$export$a63330069e1b81f6 = /*@__PURE__*/ $675a4de49b6b20b4$var$fixedBase64url(86);



const $81f0b1f6d5b9fb58$export$c05d9110ef20bb2c = /*@__PURE__*/ $d4d51e3b5652b8a4$export$3122533d606194de("$ZodCheck", (inst, def)=>{
    var _a;
    inst._zod ?? (inst._zod = {});
    inst._zod.def = def;
    (_a = inst._zod).onattach ?? (_a.onattach = []);
});
const $81f0b1f6d5b9fb58$var$numericOriginMap = {
    number: "number",
    bigint: "bigint",
    object: "date"
};
const $81f0b1f6d5b9fb58$export$294415ecbdd02022 = /*@__PURE__*/ $d4d51e3b5652b8a4$export$3122533d606194de("$ZodCheckLessThan", (inst, def)=>{
    $81f0b1f6d5b9fb58$export$c05d9110ef20bb2c.init(inst, def);
    const origin = $81f0b1f6d5b9fb58$var$numericOriginMap[typeof def.value];
    inst._zod.onattach.push((inst)=>{
        const bag = inst._zod.bag;
        const curr = (def.inclusive ? bag.maximum : bag.exclusiveMaximum) ?? Number.POSITIVE_INFINITY;
        if (def.value < curr) {
            if (def.inclusive) bag.maximum = def.value;
            else bag.exclusiveMaximum = def.value;
        }
    });
    inst._zod.check = (payload)=>{
        if (def.inclusive ? payload.value <= def.value : payload.value < def.value) return;
        payload.issues.push({
            origin: origin,
            code: "too_big",
            maximum: def.value,
            input: payload.value,
            inclusive: def.inclusive,
            inst: inst,
            continue: !def.abort
        });
    };
});
const $81f0b1f6d5b9fb58$export$8b670f58decbca18 = /*@__PURE__*/ $d4d51e3b5652b8a4$export$3122533d606194de("$ZodCheckGreaterThan", (inst, def)=>{
    $81f0b1f6d5b9fb58$export$c05d9110ef20bb2c.init(inst, def);
    const origin = $81f0b1f6d5b9fb58$var$numericOriginMap[typeof def.value];
    inst._zod.onattach.push((inst)=>{
        const bag = inst._zod.bag;
        const curr = (def.inclusive ? bag.minimum : bag.exclusiveMinimum) ?? Number.NEGATIVE_INFINITY;
        if (def.value > curr) {
            if (def.inclusive) bag.minimum = def.value;
            else bag.exclusiveMinimum = def.value;
        }
    });
    inst._zod.check = (payload)=>{
        if (def.inclusive ? payload.value >= def.value : payload.value > def.value) return;
        payload.issues.push({
            origin: origin,
            code: "too_small",
            minimum: def.value,
            input: payload.value,
            inclusive: def.inclusive,
            inst: inst,
            continue: !def.abort
        });
    };
});
const $81f0b1f6d5b9fb58$export$ae602e11c1dd0628 = /*@__PURE__*/ $d4d51e3b5652b8a4$export$3122533d606194de("$ZodCheckMultipleOf", (inst, def)=>{
    $81f0b1f6d5b9fb58$export$c05d9110ef20bb2c.init(inst, def);
    inst._zod.onattach.push((inst)=>{
        var _a;
        (_a = inst._zod.bag).multipleOf ?? (_a.multipleOf = def.value);
    });
    inst._zod.check = (payload)=>{
        if (typeof payload.value !== typeof def.value) throw new Error("Cannot mix number and bigint in multiple_of check.");
        const isMultiple = typeof payload.value === "bigint" ? payload.value % def.value === BigInt(0) : $8f5391358ccbeba2$export$7807b52a740a7117(payload.value, def.value) === 0;
        if (isMultiple) return;
        payload.issues.push({
            origin: typeof payload.value,
            code: "not_multiple_of",
            divisor: def.value,
            input: payload.value,
            inst: inst,
            continue: !def.abort
        });
    };
});
const $81f0b1f6d5b9fb58$export$5c26c85ad6aed3e8 = /*@__PURE__*/ $d4d51e3b5652b8a4$export$3122533d606194de("$ZodCheckNumberFormat", (inst, def)=>{
    $81f0b1f6d5b9fb58$export$c05d9110ef20bb2c.init(inst, def); // no format checks
    def.format = def.format || "float64";
    const isInt = def.format?.includes("int");
    const origin = isInt ? "int" : "number";
    const [minimum, maximum] = $8f5391358ccbeba2$export$8e78302060ccf26f[def.format];
    inst._zod.onattach.push((inst)=>{
        const bag = inst._zod.bag;
        bag.format = def.format;
        bag.minimum = minimum;
        bag.maximum = maximum;
        if (isInt) bag.pattern = $675a4de49b6b20b4$export$32744b5b3bba4764;
    });
    inst._zod.check = (payload)=>{
        const input = payload.value;
        if (isInt) {
            if (!Number.isInteger(input)) {
                // invalid_format issue
                // payload.issues.push({
                //   expected: def.format,
                //   format: def.format,
                //   code: "invalid_format",
                //   input,
                //   inst,
                // });
                // invalid_type issue
                payload.issues.push({
                    expected: origin,
                    format: def.format,
                    code: "invalid_type",
                    continue: false,
                    input: input,
                    inst: inst
                });
                return;
            // not_multiple_of issue
            // payload.issues.push({
            //   code: "not_multiple_of",
            //   origin: "number",
            //   input,
            //   inst,
            //   divisor: 1,
            // });
            }
            if (!Number.isSafeInteger(input)) {
                if (input > 0) // too_big
                payload.issues.push({
                    input: input,
                    code: "too_big",
                    maximum: Number.MAX_SAFE_INTEGER,
                    note: "Integers must be within the safe integer range.",
                    inst: inst,
                    origin: origin,
                    continue: !def.abort
                });
                else // too_small
                payload.issues.push({
                    input: input,
                    code: "too_small",
                    minimum: Number.MIN_SAFE_INTEGER,
                    note: "Integers must be within the safe integer range.",
                    inst: inst,
                    origin: origin,
                    continue: !def.abort
                });
                return;
            }
        }
        if (input < minimum) payload.issues.push({
            origin: "number",
            input: input,
            code: "too_small",
            minimum: minimum,
            inclusive: true,
            inst: inst,
            continue: !def.abort
        });
        if (input > maximum) payload.issues.push({
            origin: "number",
            input: input,
            code: "too_big",
            maximum: maximum,
            inst: inst
        });
    };
});
const $81f0b1f6d5b9fb58$export$a0a6d75ce7dc4d36 = /*@__PURE__*/ $d4d51e3b5652b8a4$export$3122533d606194de("$ZodCheckBigIntFormat", (inst, def)=>{
    $81f0b1f6d5b9fb58$export$c05d9110ef20bb2c.init(inst, def); // no format checks
    const [minimum, maximum] = $8f5391358ccbeba2$export$538d1d6d5cfcb3b6[def.format];
    inst._zod.onattach.push((inst)=>{
        const bag = inst._zod.bag;
        bag.format = def.format;
        bag.minimum = minimum;
        bag.maximum = maximum;
    });
    inst._zod.check = (payload)=>{
        const input = payload.value;
        if (input < minimum) payload.issues.push({
            origin: "bigint",
            input: input,
            code: "too_small",
            minimum: minimum,
            inclusive: true,
            inst: inst,
            continue: !def.abort
        });
        if (input > maximum) payload.issues.push({
            origin: "bigint",
            input: input,
            code: "too_big",
            maximum: maximum,
            inst: inst
        });
    };
});
const $81f0b1f6d5b9fb58$export$b3cec505675cf50c = /*@__PURE__*/ $d4d51e3b5652b8a4$export$3122533d606194de("$ZodCheckMaxSize", (inst, def)=>{
    var _a;
    $81f0b1f6d5b9fb58$export$c05d9110ef20bb2c.init(inst, def);
    (_a = inst._zod.def).when ?? (_a.when = (payload)=>{
        const val = payload.value;
        return !$8f5391358ccbeba2$export$69fd1b70ebae5687(val) && val.size !== undefined;
    });
    inst._zod.onattach.push((inst)=>{
        const curr = inst._zod.bag.maximum ?? Number.POSITIVE_INFINITY;
        if (def.maximum < curr) inst._zod.bag.maximum = def.maximum;
    });
    inst._zod.check = (payload)=>{
        const input = payload.value;
        const size = input.size;
        if (size <= def.maximum) return;
        payload.issues.push({
            origin: $8f5391358ccbeba2$export$67a7c9c676c45d2b(input),
            code: "too_big",
            maximum: def.maximum,
            inclusive: true,
            input: input,
            inst: inst,
            continue: !def.abort
        });
    };
});
const $81f0b1f6d5b9fb58$export$59fb0a2e7217c42b = /*@__PURE__*/ $d4d51e3b5652b8a4$export$3122533d606194de("$ZodCheckMinSize", (inst, def)=>{
    var _a;
    $81f0b1f6d5b9fb58$export$c05d9110ef20bb2c.init(inst, def);
    (_a = inst._zod.def).when ?? (_a.when = (payload)=>{
        const val = payload.value;
        return !$8f5391358ccbeba2$export$69fd1b70ebae5687(val) && val.size !== undefined;
    });
    inst._zod.onattach.push((inst)=>{
        const curr = inst._zod.bag.minimum ?? Number.NEGATIVE_INFINITY;
        if (def.minimum > curr) inst._zod.bag.minimum = def.minimum;
    });
    inst._zod.check = (payload)=>{
        const input = payload.value;
        const size = input.size;
        if (size >= def.minimum) return;
        payload.issues.push({
            origin: $8f5391358ccbeba2$export$67a7c9c676c45d2b(input),
            code: "too_small",
            minimum: def.minimum,
            inclusive: true,
            input: input,
            inst: inst,
            continue: !def.abort
        });
    };
});
const $81f0b1f6d5b9fb58$export$af532c490f33cd47 = /*@__PURE__*/ $d4d51e3b5652b8a4$export$3122533d606194de("$ZodCheckSizeEquals", (inst, def)=>{
    var _a;
    $81f0b1f6d5b9fb58$export$c05d9110ef20bb2c.init(inst, def);
    (_a = inst._zod.def).when ?? (_a.when = (payload)=>{
        const val = payload.value;
        return !$8f5391358ccbeba2$export$69fd1b70ebae5687(val) && val.size !== undefined;
    });
    inst._zod.onattach.push((inst)=>{
        const bag = inst._zod.bag;
        bag.minimum = def.size;
        bag.maximum = def.size;
        bag.size = def.size;
    });
    inst._zod.check = (payload)=>{
        const input = payload.value;
        const size = input.size;
        if (size === def.size) return;
        const tooBig = size > def.size;
        payload.issues.push({
            origin: $8f5391358ccbeba2$export$67a7c9c676c45d2b(input),
            ...tooBig ? {
                code: "too_big",
                maximum: def.size
            } : {
                code: "too_small",
                minimum: def.size
            },
            inclusive: true,
            exact: true,
            input: payload.value,
            inst: inst,
            continue: !def.abort
        });
    };
});
const $81f0b1f6d5b9fb58$export$b07b097887f4c15a = /*@__PURE__*/ $d4d51e3b5652b8a4$export$3122533d606194de("$ZodCheckMaxLength", (inst, def)=>{
    var _a;
    $81f0b1f6d5b9fb58$export$c05d9110ef20bb2c.init(inst, def);
    (_a = inst._zod.def).when ?? (_a.when = (payload)=>{
        const val = payload.value;
        return !$8f5391358ccbeba2$export$69fd1b70ebae5687(val) && val.length !== undefined;
    });
    inst._zod.onattach.push((inst)=>{
        const curr = inst._zod.bag.maximum ?? Number.POSITIVE_INFINITY;
        if (def.maximum < curr) inst._zod.bag.maximum = def.maximum;
    });
    inst._zod.check = (payload)=>{
        const input = payload.value;
        const length = input.length;
        if (length <= def.maximum) return;
        const origin = $8f5391358ccbeba2$export$479f5a070abeb487(input);
        payload.issues.push({
            origin: origin,
            code: "too_big",
            maximum: def.maximum,
            inclusive: true,
            input: input,
            inst: inst,
            continue: !def.abort
        });
    };
});
const $81f0b1f6d5b9fb58$export$cd5336aa96b8417c = /*@__PURE__*/ $d4d51e3b5652b8a4$export$3122533d606194de("$ZodCheckMinLength", (inst, def)=>{
    var _a;
    $81f0b1f6d5b9fb58$export$c05d9110ef20bb2c.init(inst, def);
    (_a = inst._zod.def).when ?? (_a.when = (payload)=>{
        const val = payload.value;
        return !$8f5391358ccbeba2$export$69fd1b70ebae5687(val) && val.length !== undefined;
    });
    inst._zod.onattach.push((inst)=>{
        const curr = inst._zod.bag.minimum ?? Number.NEGATIVE_INFINITY;
        if (def.minimum > curr) inst._zod.bag.minimum = def.minimum;
    });
    inst._zod.check = (payload)=>{
        const input = payload.value;
        const length = input.length;
        if (length >= def.minimum) return;
        const origin = $8f5391358ccbeba2$export$479f5a070abeb487(input);
        payload.issues.push({
            origin: origin,
            code: "too_small",
            minimum: def.minimum,
            inclusive: true,
            input: input,
            inst: inst,
            continue: !def.abort
        });
    };
});
const $81f0b1f6d5b9fb58$export$ccdb9b9d477068fb = /*@__PURE__*/ $d4d51e3b5652b8a4$export$3122533d606194de("$ZodCheckLengthEquals", (inst, def)=>{
    var _a;
    $81f0b1f6d5b9fb58$export$c05d9110ef20bb2c.init(inst, def);
    (_a = inst._zod.def).when ?? (_a.when = (payload)=>{
        const val = payload.value;
        return !$8f5391358ccbeba2$export$69fd1b70ebae5687(val) && val.length !== undefined;
    });
    inst._zod.onattach.push((inst)=>{
        const bag = inst._zod.bag;
        bag.minimum = def.length;
        bag.maximum = def.length;
        bag.length = def.length;
    });
    inst._zod.check = (payload)=>{
        const input = payload.value;
        const length = input.length;
        if (length === def.length) return;
        const origin = $8f5391358ccbeba2$export$479f5a070abeb487(input);
        const tooBig = length > def.length;
        payload.issues.push({
            origin: origin,
            ...tooBig ? {
                code: "too_big",
                maximum: def.length
            } : {
                code: "too_small",
                minimum: def.length
            },
            inclusive: true,
            exact: true,
            input: payload.value,
            inst: inst,
            continue: !def.abort
        });
    };
});
const $81f0b1f6d5b9fb58$export$e0c7f6847ab1b629 = /*@__PURE__*/ $d4d51e3b5652b8a4$export$3122533d606194de("$ZodCheckStringFormat", (inst, def)=>{
    var _a, _b;
    $81f0b1f6d5b9fb58$export$c05d9110ef20bb2c.init(inst, def);
    inst._zod.onattach.push((inst)=>{
        const bag = inst._zod.bag;
        bag.format = def.format;
        if (def.pattern) {
            bag.patterns ?? (bag.patterns = new Set());
            bag.patterns.add(def.pattern);
        }
    });
    if (def.pattern) (_a = inst._zod).check ?? (_a.check = (payload)=>{
        def.pattern.lastIndex = 0;
        if (def.pattern.test(payload.value)) return;
        payload.issues.push({
            origin: "string",
            code: "invalid_format",
            format: def.format,
            input: payload.value,
            ...def.pattern ? {
                pattern: def.pattern.toString()
            } : {},
            inst: inst,
            continue: !def.abort
        });
    });
    else (_b = inst._zod).check ?? (_b.check = ()=>{});
});
const $81f0b1f6d5b9fb58$export$6faea86ff718d6df = /*@__PURE__*/ $d4d51e3b5652b8a4$export$3122533d606194de("$ZodCheckRegex", (inst, def)=>{
    $81f0b1f6d5b9fb58$export$e0c7f6847ab1b629.init(inst, def);
    inst._zod.check = (payload)=>{
        def.pattern.lastIndex = 0;
        if (def.pattern.test(payload.value)) return;
        payload.issues.push({
            origin: "string",
            code: "invalid_format",
            format: "regex",
            input: payload.value,
            pattern: def.pattern.toString(),
            inst: inst,
            continue: !def.abort
        });
    };
});
const $81f0b1f6d5b9fb58$export$e18e268bd5c9f27a = /*@__PURE__*/ $d4d51e3b5652b8a4$export$3122533d606194de("$ZodCheckLowerCase", (inst, def)=>{
    def.pattern ?? (def.pattern = $675a4de49b6b20b4$export$5b1f80f3c282648c);
    $81f0b1f6d5b9fb58$export$e0c7f6847ab1b629.init(inst, def);
});
const $81f0b1f6d5b9fb58$export$6d0944a5127e820a = /*@__PURE__*/ $d4d51e3b5652b8a4$export$3122533d606194de("$ZodCheckUpperCase", (inst, def)=>{
    def.pattern ?? (def.pattern = $675a4de49b6b20b4$export$6cfe151e6b925e83);
    $81f0b1f6d5b9fb58$export$e0c7f6847ab1b629.init(inst, def);
});
const $81f0b1f6d5b9fb58$export$600021c28f0498dc = /*@__PURE__*/ $d4d51e3b5652b8a4$export$3122533d606194de("$ZodCheckIncludes", (inst, def)=>{
    $81f0b1f6d5b9fb58$export$c05d9110ef20bb2c.init(inst, def);
    const escapedRegex = $8f5391358ccbeba2$export$104ed90cc1a13451(def.includes);
    const pattern = new RegExp(typeof def.position === "number" ? `^.{${def.position}}${escapedRegex}` : escapedRegex);
    def.pattern = pattern;
    inst._zod.onattach.push((inst)=>{
        const bag = inst._zod.bag;
        bag.patterns ?? (bag.patterns = new Set());
        bag.patterns.add(pattern);
    });
    inst._zod.check = (payload)=>{
        if (payload.value.includes(def.includes, def.position)) return;
        payload.issues.push({
            origin: "string",
            code: "invalid_format",
            format: "includes",
            includes: def.includes,
            input: payload.value,
            inst: inst,
            continue: !def.abort
        });
    };
});
const $81f0b1f6d5b9fb58$export$8e83a74b4b83cc62 = /*@__PURE__*/ $d4d51e3b5652b8a4$export$3122533d606194de("$ZodCheckStartsWith", (inst, def)=>{
    $81f0b1f6d5b9fb58$export$c05d9110ef20bb2c.init(inst, def);
    const pattern = new RegExp(`^${$8f5391358ccbeba2$export$104ed90cc1a13451(def.prefix)}.*`);
    def.pattern ?? (def.pattern = pattern);
    inst._zod.onattach.push((inst)=>{
        const bag = inst._zod.bag;
        bag.patterns ?? (bag.patterns = new Set());
        bag.patterns.add(pattern);
    });
    inst._zod.check = (payload)=>{
        if (payload.value.startsWith(def.prefix)) return;
        payload.issues.push({
            origin: "string",
            code: "invalid_format",
            format: "starts_with",
            prefix: def.prefix,
            input: payload.value,
            inst: inst,
            continue: !def.abort
        });
    };
});
const $81f0b1f6d5b9fb58$export$4a10f85c6af4e92 = /*@__PURE__*/ $d4d51e3b5652b8a4$export$3122533d606194de("$ZodCheckEndsWith", (inst, def)=>{
    $81f0b1f6d5b9fb58$export$c05d9110ef20bb2c.init(inst, def);
    const pattern = new RegExp(`.*${$8f5391358ccbeba2$export$104ed90cc1a13451(def.suffix)}$`);
    def.pattern ?? (def.pattern = pattern);
    inst._zod.onattach.push((inst)=>{
        const bag = inst._zod.bag;
        bag.patterns ?? (bag.patterns = new Set());
        bag.patterns.add(pattern);
    });
    inst._zod.check = (payload)=>{
        if (payload.value.endsWith(def.suffix)) return;
        payload.issues.push({
            origin: "string",
            code: "invalid_format",
            format: "ends_with",
            suffix: def.suffix,
            input: payload.value,
            inst: inst,
            continue: !def.abort
        });
    };
});
///////////////////////////////////
/////    $ZodCheckProperty    /////
///////////////////////////////////
function $81f0b1f6d5b9fb58$var$handleCheckPropertyResult(result, payload, property) {
    if (result.issues.length) payload.issues.push(...$8f5391358ccbeba2$export$7f35a4c434118b9e(property, result.issues));
}
const $81f0b1f6d5b9fb58$export$d36a4eecd766dbc0 = /*@__PURE__*/ $d4d51e3b5652b8a4$export$3122533d606194de("$ZodCheckProperty", (inst, def)=>{
    $81f0b1f6d5b9fb58$export$c05d9110ef20bb2c.init(inst, def);
    inst._zod.check = (payload)=>{
        const result = def.schema._zod.run({
            value: payload.value[def.property],
            issues: []
        }, {});
        if (result instanceof Promise) return result.then((result)=>$81f0b1f6d5b9fb58$var$handleCheckPropertyResult(result, payload, def.property));
        $81f0b1f6d5b9fb58$var$handleCheckPropertyResult(result, payload, def.property);
        return;
    };
});
const $81f0b1f6d5b9fb58$export$5546147f1877f806 = /*@__PURE__*/ $d4d51e3b5652b8a4$export$3122533d606194de("$ZodCheckMimeType", (inst, def)=>{
    $81f0b1f6d5b9fb58$export$c05d9110ef20bb2c.init(inst, def);
    const mimeSet = new Set(def.mime);
    inst._zod.onattach.push((inst)=>{
        inst._zod.bag.mime = def.mime;
    });
    inst._zod.check = (payload)=>{
        if (mimeSet.has(payload.value.type)) return;
        payload.issues.push({
            code: "invalid_value",
            values: def.mime,
            input: payload.value.type,
            inst: inst,
            continue: !def.abort
        });
    };
});
const $81f0b1f6d5b9fb58$export$1bda1934456013d3 = /*@__PURE__*/ $d4d51e3b5652b8a4$export$3122533d606194de("$ZodCheckOverwrite", (inst, def)=>{
    $81f0b1f6d5b9fb58$export$c05d9110ef20bb2c.init(inst, def);
    inst._zod.check = (payload)=>{
        payload.value = def.tx(payload.value);
    };
});



class $0d2576ce26252dd8$export$bceacc74c2212615 {
    constructor(args = []){
        this.content = [];
        this.indent = 0;
        if (this) this.args = args;
    }
    indented(fn) {
        this.indent += 1;
        fn(this);
        this.indent -= 1;
    }
    write(arg) {
        if (typeof arg === "function") {
            arg(this, {
                execution: "sync"
            });
            arg(this, {
                execution: "async"
            });
            return;
        }
        const content = arg;
        const lines = content.split("\n").filter((x)=>x);
        const minIndent = Math.min(...lines.map((x)=>x.length - x.trimStart().length));
        const dedented = lines.map((x)=>x.slice(minIndent)).map((x)=>" ".repeat(this.indent * 2) + x);
        for (const line of dedented)this.content.push(line);
    }
    compile() {
        const F = Function;
        const args = this?.args;
        const content = this?.content ?? [
            ``
        ];
        const lines = [
            ...content.map((x)=>`  ${x}`)
        ];
        // console.log(lines.join("\n"));
        return new F(...args, lines.join("\n"));
    }
}





const $ff6ce508b9832e6e$export$83d89fbfd8236492 = {
    major: 4,
    minor: 1,
    patch: 13
};


const $38bc36f53cb4eb10$export$f43a5c3966de8238 = /*@__PURE__*/ $d4d51e3b5652b8a4$export$3122533d606194de("$ZodType", (inst, def)=>{
    var _a;
    inst ?? (inst = {});
    inst._zod.def = def; // set _def property
    inst._zod.bag = inst._zod.bag || {}; // initialize _bag object
    inst._zod.version = (0, $ff6ce508b9832e6e$export$83d89fbfd8236492);
    const checks = [
        ...inst._zod.def.checks ?? []
    ];
    // if inst is itself a checks.$ZodCheck, run it as a check
    if (inst._zod.traits.has("$ZodCheck")) checks.unshift(inst);
    for (const ch of checks)for (const fn of ch._zod.onattach)fn(inst);
    if (checks.length === 0) {
        // deferred initializer
        // inst._zod.parse is not yet defined
        (_a = inst._zod).deferred ?? (_a.deferred = []);
        inst._zod.deferred?.push(()=>{
            inst._zod.run = inst._zod.parse;
        });
    } else {
        const runChecks = (payload, checks, ctx)=>{
            let isAborted = $8f5391358ccbeba2$export$bd75b6d981b9c7f2(payload);
            let asyncResult;
            for (const ch of checks){
                if (ch._zod.def.when) {
                    const shouldRun = ch._zod.def.when(payload);
                    if (!shouldRun) continue;
                } else if (isAborted) continue;
                const currLen = payload.issues.length;
                const _ = ch._zod.check(payload);
                if (_ instanceof Promise && ctx?.async === false) throw new $d4d51e3b5652b8a4$export$13016bcec11ba196();
                if (asyncResult || _ instanceof Promise) asyncResult = (asyncResult ?? Promise.resolve()).then(async ()=>{
                    await _;
                    const nextLen = payload.issues.length;
                    if (nextLen === currLen) return;
                    if (!isAborted) isAborted = $8f5391358ccbeba2$export$bd75b6d981b9c7f2(payload, currLen);
                });
                else {
                    const nextLen = payload.issues.length;
                    if (nextLen === currLen) continue;
                    if (!isAborted) isAborted = $8f5391358ccbeba2$export$bd75b6d981b9c7f2(payload, currLen);
                }
            }
            if (asyncResult) return asyncResult.then(()=>{
                return payload;
            });
            return payload;
        };
        // const handleChecksResult = (
        //   checkResult: ParsePayload,
        //   originalResult: ParsePayload,
        //   ctx: ParseContextInternal
        // ): util.MaybeAsync<ParsePayload> => {
        //   // if the checks mutated the value && there are no issues, re-parse the result
        //   if (checkResult.value !== originalResult.value && !checkResult.issues.length)
        //     return inst._zod.parse(checkResult, ctx);
        //   return originalResult;
        // };
        const handleCanaryResult = (canary, payload, ctx)=>{
            // abort if the canary is aborted
            if ($8f5391358ccbeba2$export$bd75b6d981b9c7f2(canary)) {
                canary.aborted = true;
                return canary;
            }
            // run checks first, then
            const checkResult = runChecks(payload, checks, ctx);
            if (checkResult instanceof Promise) {
                if (ctx.async === false) throw new $d4d51e3b5652b8a4$export$13016bcec11ba196();
                return checkResult.then((checkResult)=>inst._zod.parse(checkResult, ctx));
            }
            return inst._zod.parse(checkResult, ctx);
        };
        inst._zod.run = (payload, ctx)=>{
            if (ctx.skipChecks) return inst._zod.parse(payload, ctx);
            if (ctx.direction === "backward") {
                // run canary
                // initial pass (no checks)
                const canary = inst._zod.parse({
                    value: payload.value,
                    issues: []
                }, {
                    ...ctx,
                    skipChecks: true
                });
                if (canary instanceof Promise) return canary.then((canary)=>{
                    return handleCanaryResult(canary, payload, ctx);
                });
                return handleCanaryResult(canary, payload, ctx);
            }
            // forward
            const result = inst._zod.parse(payload, ctx);
            if (result instanceof Promise) {
                if (ctx.async === false) throw new $d4d51e3b5652b8a4$export$13016bcec11ba196();
                return result.then((result)=>runChecks(result, checks, ctx));
            }
            return runChecks(result, checks, ctx);
        };
    }
    inst["~standard"] = {
        validate: (value)=>{
            try {
                const r = (0, $65d57763ab0754f3$export$b48ee232557adc37)(inst, value);
                return r.success ? {
                    value: r.data
                } : {
                    issues: r.error?.issues
                };
            } catch (_) {
                return (0, $65d57763ab0754f3$export$9b07b0d6e0389261)(inst, value).then((r)=>r.success ? {
                        value: r.data
                    } : {
                        issues: r.error?.issues
                    });
            }
        },
        vendor: "zod",
        version: 1
    };
});
const $38bc36f53cb4eb10$export$4342b4432d7b1471 = /*@__PURE__*/ $d4d51e3b5652b8a4$export$3122533d606194de("$ZodString", (inst, def)=>{
    $38bc36f53cb4eb10$export$f43a5c3966de8238.init(inst, def);
    inst._zod.pattern = [
        ...inst?._zod.bag?.patterns ?? []
    ].pop() ?? $675a4de49b6b20b4$export$22b082955e083ec3(inst._zod.bag);
    inst._zod.parse = (payload, _)=>{
        if (def.coerce) try {
            payload.value = String(payload.value);
        } catch (_) {}
        if (typeof payload.value === "string") return payload;
        payload.issues.push({
            expected: "string",
            code: "invalid_type",
            input: payload.value,
            inst: inst
        });
        return payload;
    };
});
const $38bc36f53cb4eb10$export$2d69a0d3057a5c7d = /*@__PURE__*/ $d4d51e3b5652b8a4$export$3122533d606194de("$ZodStringFormat", (inst, def)=>{
    // check initialization must come first
    $81f0b1f6d5b9fb58$export$e0c7f6847ab1b629.init(inst, def);
    $38bc36f53cb4eb10$export$4342b4432d7b1471.init(inst, def);
});
const $38bc36f53cb4eb10$export$4ca4397e3147da59 = /*@__PURE__*/ $d4d51e3b5652b8a4$export$3122533d606194de("$ZodGUID", (inst, def)=>{
    def.pattern ?? (def.pattern = $675a4de49b6b20b4$export$46e8f25c7328f77e);
    $38bc36f53cb4eb10$export$2d69a0d3057a5c7d.init(inst, def);
});
const $38bc36f53cb4eb10$export$8794aae384e3c177 = /*@__PURE__*/ $d4d51e3b5652b8a4$export$3122533d606194de("$ZodUUID", (inst, def)=>{
    if (def.version) {
        const versionMap = {
            v1: 1,
            v2: 2,
            v3: 3,
            v4: 4,
            v5: 5,
            v6: 6,
            v7: 7,
            v8: 8
        };
        const v = versionMap[def.version];
        if (v === undefined) throw new Error(`Invalid UUID version: "${def.version}"`);
        def.pattern ?? (def.pattern = $675a4de49b6b20b4$export$31b40729666a4ae0(v));
    } else def.pattern ?? (def.pattern = $675a4de49b6b20b4$export$31b40729666a4ae0());
    $38bc36f53cb4eb10$export$2d69a0d3057a5c7d.init(inst, def);
});
const $38bc36f53cb4eb10$export$a3726aadb6108cdc = /*@__PURE__*/ $d4d51e3b5652b8a4$export$3122533d606194de("$ZodEmail", (inst, def)=>{
    def.pattern ?? (def.pattern = $675a4de49b6b20b4$export$d290fa47940df19d);
    $38bc36f53cb4eb10$export$2d69a0d3057a5c7d.init(inst, def);
});
const $38bc36f53cb4eb10$export$7e12af57cac08b7a = /*@__PURE__*/ $d4d51e3b5652b8a4$export$3122533d606194de("$ZodURL", (inst, def)=>{
    $38bc36f53cb4eb10$export$2d69a0d3057a5c7d.init(inst, def);
    inst._zod.check = (payload)=>{
        try {
            // Trim whitespace from input
            const trimmed = payload.value.trim();
            // @ts-ignore
            const url = new URL(trimmed);
            if (def.hostname) {
                def.hostname.lastIndex = 0;
                if (!def.hostname.test(url.hostname)) payload.issues.push({
                    code: "invalid_format",
                    format: "url",
                    note: "Invalid hostname",
                    pattern: def.hostname.source,
                    input: payload.value,
                    inst: inst,
                    continue: !def.abort
                });
            }
            if (def.protocol) {
                def.protocol.lastIndex = 0;
                if (!def.protocol.test(url.protocol.endsWith(":") ? url.protocol.slice(0, -1) : url.protocol)) payload.issues.push({
                    code: "invalid_format",
                    format: "url",
                    note: "Invalid protocol",
                    pattern: def.protocol.source,
                    input: payload.value,
                    inst: inst,
                    continue: !def.abort
                });
            }
            // Set the output value based on normalize flag
            if (def.normalize) // Use normalized URL
            payload.value = url.href;
            else // Preserve the original input (trimmed)
            payload.value = trimmed;
            return;
        } catch (_) {
            payload.issues.push({
                code: "invalid_format",
                format: "url",
                input: payload.value,
                inst: inst,
                continue: !def.abort
            });
        }
    };
});
const $38bc36f53cb4eb10$export$154cd448b85bb5a3 = /*@__PURE__*/ $d4d51e3b5652b8a4$export$3122533d606194de("$ZodEmoji", (inst, def)=>{
    def.pattern ?? (def.pattern = $675a4de49b6b20b4$export$a19185d1233fc4b2());
    $38bc36f53cb4eb10$export$2d69a0d3057a5c7d.init(inst, def);
});
const $38bc36f53cb4eb10$export$5a160d28c6d62c88 = /*@__PURE__*/ $d4d51e3b5652b8a4$export$3122533d606194de("$ZodNanoID", (inst, def)=>{
    def.pattern ?? (def.pattern = $675a4de49b6b20b4$export$ac4959f4f1338dfc);
    $38bc36f53cb4eb10$export$2d69a0d3057a5c7d.init(inst, def);
});
const $38bc36f53cb4eb10$export$f4f84bd3c6706e60 = /*@__PURE__*/ $d4d51e3b5652b8a4$export$3122533d606194de("$ZodCUID", (inst, def)=>{
    def.pattern ?? (def.pattern = $675a4de49b6b20b4$export$e057ec210c7d3443);
    $38bc36f53cb4eb10$export$2d69a0d3057a5c7d.init(inst, def);
});
const $38bc36f53cb4eb10$export$faf1483c11362df6 = /*@__PURE__*/ $d4d51e3b5652b8a4$export$3122533d606194de("$ZodCUID2", (inst, def)=>{
    def.pattern ?? (def.pattern = $675a4de49b6b20b4$export$af5866a6cccce9f0);
    $38bc36f53cb4eb10$export$2d69a0d3057a5c7d.init(inst, def);
});
const $38bc36f53cb4eb10$export$c5788701f4f55294 = /*@__PURE__*/ $d4d51e3b5652b8a4$export$3122533d606194de("$ZodULID", (inst, def)=>{
    def.pattern ?? (def.pattern = $675a4de49b6b20b4$export$c34778236461ea95);
    $38bc36f53cb4eb10$export$2d69a0d3057a5c7d.init(inst, def);
});
const $38bc36f53cb4eb10$export$e721fd3317199b85 = /*@__PURE__*/ $d4d51e3b5652b8a4$export$3122533d606194de("$ZodXID", (inst, def)=>{
    def.pattern ?? (def.pattern = $675a4de49b6b20b4$export$5eecaf20006cb6cb);
    $38bc36f53cb4eb10$export$2d69a0d3057a5c7d.init(inst, def);
});
const $38bc36f53cb4eb10$export$baa9849ea82bee6e = /*@__PURE__*/ $d4d51e3b5652b8a4$export$3122533d606194de("$ZodKSUID", (inst, def)=>{
    def.pattern ?? (def.pattern = $675a4de49b6b20b4$export$f49b11deeb9beb0f);
    $38bc36f53cb4eb10$export$2d69a0d3057a5c7d.init(inst, def);
});
const $38bc36f53cb4eb10$export$3273e4d2df37774b = /*@__PURE__*/ $d4d51e3b5652b8a4$export$3122533d606194de("$ZodISODateTime", (inst, def)=>{
    def.pattern ?? (def.pattern = $675a4de49b6b20b4$export$7ba4466dbd0f07e1(def));
    $38bc36f53cb4eb10$export$2d69a0d3057a5c7d.init(inst, def);
});
const $38bc36f53cb4eb10$export$75b9bf98f4d806dc = /*@__PURE__*/ $d4d51e3b5652b8a4$export$3122533d606194de("$ZodISODate", (inst, def)=>{
    def.pattern ?? (def.pattern = $675a4de49b6b20b4$export$324d90190a8b822a);
    $38bc36f53cb4eb10$export$2d69a0d3057a5c7d.init(inst, def);
});
const $38bc36f53cb4eb10$export$e9b9c3c2359a3ebc = /*@__PURE__*/ $d4d51e3b5652b8a4$export$3122533d606194de("$ZodISOTime", (inst, def)=>{
    def.pattern ?? (def.pattern = $675a4de49b6b20b4$export$2da9be4cfdb689b1(def));
    $38bc36f53cb4eb10$export$2d69a0d3057a5c7d.init(inst, def);
});
const $38bc36f53cb4eb10$export$d9e850ab18e4b22e = /*@__PURE__*/ $d4d51e3b5652b8a4$export$3122533d606194de("$ZodISODuration", (inst, def)=>{
    def.pattern ?? (def.pattern = $675a4de49b6b20b4$export$1f34108aa9eb96ab);
    $38bc36f53cb4eb10$export$2d69a0d3057a5c7d.init(inst, def);
});
const $38bc36f53cb4eb10$export$93fc833bbf7ceb99 = /*@__PURE__*/ $d4d51e3b5652b8a4$export$3122533d606194de("$ZodIPv4", (inst, def)=>{
    def.pattern ?? (def.pattern = $675a4de49b6b20b4$export$291a17a16047f284);
    $38bc36f53cb4eb10$export$2d69a0d3057a5c7d.init(inst, def);
    inst._zod.bag.format = `ipv4`;
});
const $38bc36f53cb4eb10$export$8c939a460418a1bf = /*@__PURE__*/ $d4d51e3b5652b8a4$export$3122533d606194de("$ZodIPv6", (inst, def)=>{
    def.pattern ?? (def.pattern = $675a4de49b6b20b4$export$4e0c86a59c658526);
    $38bc36f53cb4eb10$export$2d69a0d3057a5c7d.init(inst, def);
    inst._zod.bag.format = `ipv6`;
    inst._zod.check = (payload)=>{
        try {
            // @ts-ignore
            new URL(`http://[${payload.value}]`);
        // return;
        } catch  {
            payload.issues.push({
                code: "invalid_format",
                format: "ipv6",
                input: payload.value,
                inst: inst,
                continue: !def.abort
            });
        }
    };
});
const $38bc36f53cb4eb10$export$747370108f97e6ea = /*@__PURE__*/ $d4d51e3b5652b8a4$export$3122533d606194de("$ZodMAC", (inst, def)=>{
    def.pattern ?? (def.pattern = $675a4de49b6b20b4$export$f8d11e097856efcf(def.delimiter));
    $38bc36f53cb4eb10$export$2d69a0d3057a5c7d.init(inst, def);
    inst._zod.bag.format = `mac`;
});
const $38bc36f53cb4eb10$export$e164feaf5ae5296b = /*@__PURE__*/ $d4d51e3b5652b8a4$export$3122533d606194de("$ZodCIDRv4", (inst, def)=>{
    def.pattern ?? (def.pattern = $675a4de49b6b20b4$export$fc96793d9715e5a1);
    $38bc36f53cb4eb10$export$2d69a0d3057a5c7d.init(inst, def);
});
const $38bc36f53cb4eb10$export$3c3aacb740759234 = /*@__PURE__*/ $d4d51e3b5652b8a4$export$3122533d606194de("$ZodCIDRv6", (inst, def)=>{
    def.pattern ?? (def.pattern = $675a4de49b6b20b4$export$b6e650831cac87fb); // not used for validation
    $38bc36f53cb4eb10$export$2d69a0d3057a5c7d.init(inst, def);
    inst._zod.check = (payload)=>{
        const parts = payload.value.split("/");
        try {
            if (parts.length !== 2) throw new Error();
            const [address, prefix] = parts;
            if (!prefix) throw new Error();
            const prefixNum = Number(prefix);
            if (`${prefixNum}` !== prefix) throw new Error();
            if (prefixNum < 0 || prefixNum > 128) throw new Error();
            // @ts-ignore
            new URL(`http://[${address}]`);
        } catch  {
            payload.issues.push({
                code: "invalid_format",
                format: "cidrv6",
                input: payload.value,
                inst: inst,
                continue: !def.abort
            });
        }
    };
});
function $38bc36f53cb4eb10$export$5f5b3f6a560c676b(data) {
    if (data === "") return true;
    if (data.length % 4 !== 0) return false;
    try {
        // @ts-ignore
        atob(data);
        return true;
    } catch  {
        return false;
    }
}
const $38bc36f53cb4eb10$export$d7d4932079e2113d = /*@__PURE__*/ $d4d51e3b5652b8a4$export$3122533d606194de("$ZodBase64", (inst, def)=>{
    def.pattern ?? (def.pattern = $675a4de49b6b20b4$export$b3b2de96497acc47);
    $38bc36f53cb4eb10$export$2d69a0d3057a5c7d.init(inst, def);
    inst._zod.bag.contentEncoding = "base64";
    inst._zod.check = (payload)=>{
        if ($38bc36f53cb4eb10$export$5f5b3f6a560c676b(payload.value)) return;
        payload.issues.push({
            code: "invalid_format",
            format: "base64",
            input: payload.value,
            inst: inst,
            continue: !def.abort
        });
    };
});
function $38bc36f53cb4eb10$export$eb95420c5686a3be(data) {
    if (!$675a4de49b6b20b4$export$7d21597c7bc64465.test(data)) return false;
    const base64 = data.replace(/[-_]/g, (c)=>c === "-" ? "+" : "/");
    const padded = base64.padEnd(Math.ceil(base64.length / 4) * 4, "=");
    return $38bc36f53cb4eb10$export$5f5b3f6a560c676b(padded);
}
const $38bc36f53cb4eb10$export$f5c3c3bbec012fa6 = /*@__PURE__*/ $d4d51e3b5652b8a4$export$3122533d606194de("$ZodBase64URL", (inst, def)=>{
    def.pattern ?? (def.pattern = $675a4de49b6b20b4$export$7d21597c7bc64465);
    $38bc36f53cb4eb10$export$2d69a0d3057a5c7d.init(inst, def);
    inst._zod.bag.contentEncoding = "base64url";
    inst._zod.check = (payload)=>{
        if ($38bc36f53cb4eb10$export$eb95420c5686a3be(payload.value)) return;
        payload.issues.push({
            code: "invalid_format",
            format: "base64url",
            input: payload.value,
            inst: inst,
            continue: !def.abort
        });
    };
});
const $38bc36f53cb4eb10$export$46d3507e8483217 = /*@__PURE__*/ $d4d51e3b5652b8a4$export$3122533d606194de("$ZodE164", (inst, def)=>{
    def.pattern ?? (def.pattern = $675a4de49b6b20b4$export$2fa5ed24c9ef198e);
    $38bc36f53cb4eb10$export$2d69a0d3057a5c7d.init(inst, def);
});
function $38bc36f53cb4eb10$export$5fc0c2a4042aff0a(token, algorithm = null) {
    try {
        const tokensParts = token.split(".");
        if (tokensParts.length !== 3) return false;
        const [header] = tokensParts;
        if (!header) return false;
        // @ts-ignore
        const parsedHeader = JSON.parse(atob(header));
        if ("typ" in parsedHeader && parsedHeader?.typ !== "JWT") return false;
        if (!parsedHeader.alg) return false;
        if (algorithm && (!("alg" in parsedHeader) || parsedHeader.alg !== algorithm)) return false;
        return true;
    } catch  {
        return false;
    }
}
const $38bc36f53cb4eb10$export$f515616cf0cda103 = /*@__PURE__*/ $d4d51e3b5652b8a4$export$3122533d606194de("$ZodJWT", (inst, def)=>{
    $38bc36f53cb4eb10$export$2d69a0d3057a5c7d.init(inst, def);
    inst._zod.check = (payload)=>{
        if ($38bc36f53cb4eb10$export$5fc0c2a4042aff0a(payload.value, def.alg)) return;
        payload.issues.push({
            code: "invalid_format",
            format: "jwt",
            input: payload.value,
            inst: inst,
            continue: !def.abort
        });
    };
});
const $38bc36f53cb4eb10$export$9dde4397c7b8a192 = /*@__PURE__*/ $d4d51e3b5652b8a4$export$3122533d606194de("$ZodCustomStringFormat", (inst, def)=>{
    $38bc36f53cb4eb10$export$2d69a0d3057a5c7d.init(inst, def);
    inst._zod.check = (payload)=>{
        if (def.fn(payload.value)) return;
        payload.issues.push({
            code: "invalid_format",
            format: def.format,
            input: payload.value,
            inst: inst,
            continue: !def.abort
        });
    };
});
const $38bc36f53cb4eb10$export$b7292ed81eaafd49 = /*@__PURE__*/ $d4d51e3b5652b8a4$export$3122533d606194de("$ZodNumber", (inst, def)=>{
    $38bc36f53cb4eb10$export$f43a5c3966de8238.init(inst, def);
    inst._zod.pattern = inst._zod.bag.pattern ?? $675a4de49b6b20b4$export$98e628dec113755e;
    inst._zod.parse = (payload, _ctx)=>{
        if (def.coerce) try {
            payload.value = Number(payload.value);
        } catch (_) {}
        const input = payload.value;
        if (typeof input === "number" && !Number.isNaN(input) && Number.isFinite(input)) return payload;
        const received = typeof input === "number" ? Number.isNaN(input) ? "NaN" : !Number.isFinite(input) ? "Infinity" : undefined : undefined;
        payload.issues.push({
            expected: "number",
            code: "invalid_type",
            input: input,
            inst: inst,
            ...received ? {
                received: received
            } : {}
        });
        return payload;
    };
});
const $38bc36f53cb4eb10$export$2cfebe79b769ec9 = /*@__PURE__*/ $d4d51e3b5652b8a4$export$3122533d606194de("$ZodNumberFormat", (inst, def)=>{
    $81f0b1f6d5b9fb58$export$5c26c85ad6aed3e8.init(inst, def);
    $38bc36f53cb4eb10$export$b7292ed81eaafd49.init(inst, def); // no format checks
});
const $38bc36f53cb4eb10$export$828bf41e557d7dda = /*@__PURE__*/ $d4d51e3b5652b8a4$export$3122533d606194de("$ZodBoolean", (inst, def)=>{
    $38bc36f53cb4eb10$export$f43a5c3966de8238.init(inst, def);
    inst._zod.pattern = $675a4de49b6b20b4$export$4a21f16c33752377;
    inst._zod.parse = (payload, _ctx)=>{
        if (def.coerce) try {
            payload.value = Boolean(payload.value);
        } catch (_) {}
        const input = payload.value;
        if (typeof input === "boolean") return payload;
        payload.issues.push({
            expected: "boolean",
            code: "invalid_type",
            input: input,
            inst: inst
        });
        return payload;
    };
});
const $38bc36f53cb4eb10$export$7600843f2a3baa73 = /*@__PURE__*/ $d4d51e3b5652b8a4$export$3122533d606194de("$ZodBigInt", (inst, def)=>{
    $38bc36f53cb4eb10$export$f43a5c3966de8238.init(inst, def);
    inst._zod.pattern = $675a4de49b6b20b4$export$a0f65b52274bcc00;
    inst._zod.parse = (payload, _ctx)=>{
        if (def.coerce) try {
            payload.value = BigInt(payload.value);
        } catch (_) {}
        if (typeof payload.value === "bigint") return payload;
        payload.issues.push({
            expected: "bigint",
            code: "invalid_type",
            input: payload.value,
            inst: inst
        });
        return payload;
    };
});
const $38bc36f53cb4eb10$export$487194b75209a5dd = /*@__PURE__*/ $d4d51e3b5652b8a4$export$3122533d606194de("$ZodBigIntFormat", (inst, def)=>{
    $81f0b1f6d5b9fb58$export$a0a6d75ce7dc4d36.init(inst, def);
    $38bc36f53cb4eb10$export$7600843f2a3baa73.init(inst, def); // no format checks
});
const $38bc36f53cb4eb10$export$c9e7e1831bb8dd12 = /*@__PURE__*/ $d4d51e3b5652b8a4$export$3122533d606194de("$ZodSymbol", (inst, def)=>{
    $38bc36f53cb4eb10$export$f43a5c3966de8238.init(inst, def);
    inst._zod.parse = (payload, _ctx)=>{
        const input = payload.value;
        if (typeof input === "symbol") return payload;
        payload.issues.push({
            expected: "symbol",
            code: "invalid_type",
            input: input,
            inst: inst
        });
        return payload;
    };
});
const $38bc36f53cb4eb10$export$379ccf61f9830869 = /*@__PURE__*/ $d4d51e3b5652b8a4$export$3122533d606194de("$ZodUndefined", (inst, def)=>{
    $38bc36f53cb4eb10$export$f43a5c3966de8238.init(inst, def);
    inst._zod.pattern = $675a4de49b6b20b4$export$1db45310990710a5;
    inst._zod.values = new Set([
        undefined
    ]);
    inst._zod.optin = "optional";
    inst._zod.optout = "optional";
    inst._zod.parse = (payload, _ctx)=>{
        const input = payload.value;
        if (typeof input === "undefined") return payload;
        payload.issues.push({
            expected: "undefined",
            code: "invalid_type",
            input: input,
            inst: inst
        });
        return payload;
    };
});
const $38bc36f53cb4eb10$export$d05db4d7bc9da27d = /*@__PURE__*/ $d4d51e3b5652b8a4$export$3122533d606194de("$ZodNull", (inst, def)=>{
    $38bc36f53cb4eb10$export$f43a5c3966de8238.init(inst, def);
    inst._zod.pattern = $675a4de49b6b20b4$export$7b1b591b262c240;
    inst._zod.values = new Set([
        null
    ]);
    inst._zod.parse = (payload, _ctx)=>{
        const input = payload.value;
        if (input === null) return payload;
        payload.issues.push({
            expected: "null",
            code: "invalid_type",
            input: input,
            inst: inst
        });
        return payload;
    };
});
const $38bc36f53cb4eb10$export$de3a83ac65a18f35 = /*@__PURE__*/ $d4d51e3b5652b8a4$export$3122533d606194de("$ZodAny", (inst, def)=>{
    $38bc36f53cb4eb10$export$f43a5c3966de8238.init(inst, def);
    inst._zod.parse = (payload)=>payload;
});
const $38bc36f53cb4eb10$export$37ea092643879ea0 = /*@__PURE__*/ $d4d51e3b5652b8a4$export$3122533d606194de("$ZodUnknown", (inst, def)=>{
    $38bc36f53cb4eb10$export$f43a5c3966de8238.init(inst, def);
    inst._zod.parse = (payload)=>payload;
});
const $38bc36f53cb4eb10$export$4b2a18191b39c3b4 = /*@__PURE__*/ $d4d51e3b5652b8a4$export$3122533d606194de("$ZodNever", (inst, def)=>{
    $38bc36f53cb4eb10$export$f43a5c3966de8238.init(inst, def);
    inst._zod.parse = (payload, _ctx)=>{
        payload.issues.push({
            expected: "never",
            code: "invalid_type",
            input: payload.value,
            inst: inst
        });
        return payload;
    };
});
const $38bc36f53cb4eb10$export$6fd82db70787afbb = /*@__PURE__*/ $d4d51e3b5652b8a4$export$3122533d606194de("$ZodVoid", (inst, def)=>{
    $38bc36f53cb4eb10$export$f43a5c3966de8238.init(inst, def);
    inst._zod.parse = (payload, _ctx)=>{
        const input = payload.value;
        if (typeof input === "undefined") return payload;
        payload.issues.push({
            expected: "void",
            code: "invalid_type",
            input: input,
            inst: inst
        });
        return payload;
    };
});
const $38bc36f53cb4eb10$export$9a0ab9fbd61629f8 = /*@__PURE__*/ $d4d51e3b5652b8a4$export$3122533d606194de("$ZodDate", (inst, def)=>{
    $38bc36f53cb4eb10$export$f43a5c3966de8238.init(inst, def);
    inst._zod.parse = (payload, _ctx)=>{
        if (def.coerce) try {
            payload.value = new Date(payload.value);
        } catch (_err) {}
        const input = payload.value;
        const isDate = input instanceof Date;
        const isValidDate = isDate && !Number.isNaN(input.getTime());
        if (isValidDate) return payload;
        payload.issues.push({
            expected: "date",
            code: "invalid_type",
            input: input,
            ...isDate ? {
                received: "Invalid Date"
            } : {},
            inst: inst
        });
        return payload;
    };
});
function $38bc36f53cb4eb10$var$handleArrayResult(result, final, index) {
    if (result.issues.length) final.issues.push(...$8f5391358ccbeba2$export$7f35a4c434118b9e(index, result.issues));
    final.value[index] = result.value;
}
const $38bc36f53cb4eb10$export$fd77bdade7d2292b = /*@__PURE__*/ $d4d51e3b5652b8a4$export$3122533d606194de("$ZodArray", (inst, def)=>{
    $38bc36f53cb4eb10$export$f43a5c3966de8238.init(inst, def);
    inst._zod.parse = (payload, ctx)=>{
        const input = payload.value;
        if (!Array.isArray(input)) {
            payload.issues.push({
                expected: "array",
                code: "invalid_type",
                input: input,
                inst: inst
            });
            return payload;
        }
        payload.value = Array(input.length);
        const proms = [];
        for(let i = 0; i < input.length; i++){
            const item = input[i];
            const result = def.element._zod.run({
                value: item,
                issues: []
            }, ctx);
            if (result instanceof Promise) proms.push(result.then((result)=>$38bc36f53cb4eb10$var$handleArrayResult(result, payload, i)));
            else $38bc36f53cb4eb10$var$handleArrayResult(result, payload, i);
        }
        if (proms.length) return Promise.all(proms).then(()=>payload);
        return payload; //handleArrayResultsAsync(parseResults, final);
    };
});
function $38bc36f53cb4eb10$var$handlePropertyResult(result, final, key, input) {
    if (result.issues.length) final.issues.push(...$8f5391358ccbeba2$export$7f35a4c434118b9e(key, result.issues));
    if (result.value === undefined) {
        if (key in input) final.value[key] = undefined;
    } else final.value[key] = result.value;
}
function $38bc36f53cb4eb10$var$normalizeDef(def) {
    const keys = Object.keys(def.shape);
    for (const k of keys){
        if (!def.shape?.[k]?._zod?.traits?.has("$ZodType")) throw new Error(`Invalid element at key "${k}": expected a Zod schema`);
    }
    const okeys = $8f5391358ccbeba2$export$240159211e66adb9(def.shape);
    return {
        ...def,
        keys: keys,
        keySet: new Set(keys),
        numKeys: keys.length,
        optionalKeys: new Set(okeys)
    };
}
function $38bc36f53cb4eb10$var$handleCatchall(proms, input, payload, ctx, def, inst) {
    const unrecognized = [];
    // iterate over input keys
    const keySet = def.keySet;
    const _catchall = def.catchall._zod;
    const t = _catchall.def.type;
    for(const key in input){
        if (keySet.has(key)) continue;
        if (t === "never") {
            unrecognized.push(key);
            continue;
        }
        const r = _catchall.run({
            value: input[key],
            issues: []
        }, ctx);
        if (r instanceof Promise) proms.push(r.then((r)=>$38bc36f53cb4eb10$var$handlePropertyResult(r, payload, key, input)));
        else $38bc36f53cb4eb10$var$handlePropertyResult(r, payload, key, input);
    }
    if (unrecognized.length) payload.issues.push({
        code: "unrecognized_keys",
        keys: unrecognized,
        input: input,
        inst: inst
    });
    if (!proms.length) return payload;
    return Promise.all(proms).then(()=>{
        return payload;
    });
}
const $38bc36f53cb4eb10$export$54037a1ef79a4f1a = /*@__PURE__*/ $d4d51e3b5652b8a4$export$3122533d606194de("$ZodObject", (inst, def)=>{
    // requires cast because technically $ZodObject doesn't extend
    $38bc36f53cb4eb10$export$f43a5c3966de8238.init(inst, def);
    // const sh = def.shape;
    const desc = Object.getOwnPropertyDescriptor(def, "shape");
    if (!desc?.get) {
        const sh = def.shape;
        Object.defineProperty(def, "shape", {
            get: ()=>{
                const newSh = {
                    ...sh
                };
                Object.defineProperty(def, "shape", {
                    value: newSh
                });
                return newSh;
            }
        });
    }
    const _normalized = $8f5391358ccbeba2$export$ade7a147f5129058(()=>$38bc36f53cb4eb10$var$normalizeDef(def));
    $8f5391358ccbeba2$export$d43070a5843c1e2(inst._zod, "propValues", ()=>{
        const shape = def.shape;
        const propValues = {};
        for(const key in shape){
            const field = shape[key]._zod;
            if (field.values) {
                propValues[key] ?? (propValues[key] = new Set());
                for (const v of field.values)propValues[key].add(v);
            }
        }
        return propValues;
    });
    const isObject = $8f5391358ccbeba2$export$a6cdc56e425d0d0a;
    const catchall = def.catchall;
    let value;
    inst._zod.parse = (payload, ctx)=>{
        value ?? (value = _normalized.value);
        const input = payload.value;
        if (!isObject(input)) {
            payload.issues.push({
                expected: "object",
                code: "invalid_type",
                input: input,
                inst: inst
            });
            return payload;
        }
        payload.value = {};
        const proms = [];
        const shape = value.shape;
        for (const key of value.keys){
            const el = shape[key];
            const r = el._zod.run({
                value: input[key],
                issues: []
            }, ctx);
            if (r instanceof Promise) proms.push(r.then((r)=>$38bc36f53cb4eb10$var$handlePropertyResult(r, payload, key, input)));
            else $38bc36f53cb4eb10$var$handlePropertyResult(r, payload, key, input);
        }
        if (!catchall) return proms.length ? Promise.all(proms).then(()=>payload) : payload;
        return $38bc36f53cb4eb10$var$handleCatchall(proms, input, payload, ctx, _normalized.value, inst);
    };
});
const $38bc36f53cb4eb10$export$330feb3f8e03c085 = /*@__PURE__*/ $d4d51e3b5652b8a4$export$3122533d606194de("$ZodObjectJIT", (inst, def)=>{
    // requires cast because technically $ZodObject doesn't extend
    $38bc36f53cb4eb10$export$54037a1ef79a4f1a.init(inst, def);
    const superParse = inst._zod.parse;
    const _normalized = $8f5391358ccbeba2$export$ade7a147f5129058(()=>$38bc36f53cb4eb10$var$normalizeDef(def));
    const generateFastpass = (shape)=>{
        const doc = new (0, $0d2576ce26252dd8$export$bceacc74c2212615)([
            "shape",
            "payload",
            "ctx"
        ]);
        const normalized = _normalized.value;
        const parseStr = (key)=>{
            const k = $8f5391358ccbeba2$export$a1a11b095f88289a(key);
            return `shape[${k}]._zod.run({ value: input[${k}], issues: [] }, ctx)`;
        };
        doc.write(`const input = payload.value;`);
        const ids = Object.create(null);
        let counter = 0;
        for (const key of normalized.keys)ids[key] = `key_${counter++}`;
        // A: preserve key order {
        doc.write(`const newResult = {};`);
        for (const key of normalized.keys){
            const id = ids[key];
            const k = $8f5391358ccbeba2$export$a1a11b095f88289a(key);
            doc.write(`const ${id} = ${parseStr(key)};`);
            doc.write(`
        if (${id}.issues.length) {
          payload.issues = payload.issues.concat(${id}.issues.map(iss => ({
            ...iss,
            path: iss.path ? [${k}, ...iss.path] : [${k}]
          })));
        }
        
        
        if (${id}.value === undefined) {
          if (${k} in input) {
            newResult[${k}] = undefined;
          }
        } else {
          newResult[${k}] = ${id}.value;
        }
        
      `);
        }
        doc.write(`payload.value = newResult;`);
        doc.write(`return payload;`);
        const fn = doc.compile();
        return (payload, ctx)=>fn(shape, payload, ctx);
    };
    let fastpass;
    const isObject = $8f5391358ccbeba2$export$a6cdc56e425d0d0a;
    const jit = !$d4d51e3b5652b8a4$export$f9cd1e43211d8a4a.jitless;
    const allowsEval = $8f5391358ccbeba2$export$1f119cb4d720843b;
    const fastEnabled = jit && allowsEval.value; // && !def.catchall;
    const catchall = def.catchall;
    let value;
    inst._zod.parse = (payload, ctx)=>{
        value ?? (value = _normalized.value);
        const input = payload.value;
        if (!isObject(input)) {
            payload.issues.push({
                expected: "object",
                code: "invalid_type",
                input: input,
                inst: inst
            });
            return payload;
        }
        if (jit && fastEnabled && ctx?.async === false && ctx.jitless !== true) {
            // always synchronous
            if (!fastpass) fastpass = generateFastpass(def.shape);
            payload = fastpass(payload, ctx);
            if (!catchall) return payload;
            return $38bc36f53cb4eb10$var$handleCatchall([], input, payload, ctx, value, inst);
        }
        return superParse(payload, ctx);
    };
});
function $38bc36f53cb4eb10$var$handleUnionResults(results, final, inst, ctx) {
    for (const result of results)if (result.issues.length === 0) {
        final.value = result.value;
        return final;
    }
    const nonaborted = results.filter((r)=>!$8f5391358ccbeba2$export$bd75b6d981b9c7f2(r));
    if (nonaborted.length === 1) {
        final.value = nonaborted[0].value;
        return nonaborted[0];
    }
    final.issues.push({
        code: "invalid_union",
        input: final.value,
        inst: inst,
        errors: results.map((result)=>result.issues.map((iss)=>$8f5391358ccbeba2$export$c5e667bbfc286a9d(iss, ctx, $d4d51e3b5652b8a4$export$e506a1d27d1eaa20())))
    });
    return final;
}
const $38bc36f53cb4eb10$export$37a2350ef0bd638c = /*@__PURE__*/ $d4d51e3b5652b8a4$export$3122533d606194de("$ZodUnion", (inst, def)=>{
    $38bc36f53cb4eb10$export$f43a5c3966de8238.init(inst, def);
    $8f5391358ccbeba2$export$d43070a5843c1e2(inst._zod, "optin", ()=>def.options.some((o)=>o._zod.optin === "optional") ? "optional" : undefined);
    $8f5391358ccbeba2$export$d43070a5843c1e2(inst._zod, "optout", ()=>def.options.some((o)=>o._zod.optout === "optional") ? "optional" : undefined);
    $8f5391358ccbeba2$export$d43070a5843c1e2(inst._zod, "values", ()=>{
        if (def.options.every((o)=>o._zod.values)) return new Set(def.options.flatMap((option)=>Array.from(option._zod.values)));
        return undefined;
    });
    $8f5391358ccbeba2$export$d43070a5843c1e2(inst._zod, "pattern", ()=>{
        if (def.options.every((o)=>o._zod.pattern)) {
            const patterns = def.options.map((o)=>o._zod.pattern);
            return new RegExp(`^(${patterns.map((p)=>$8f5391358ccbeba2$export$78d521805d6c22e4(p.source)).join("|")})$`);
        }
        return undefined;
    });
    const single = def.options.length === 1;
    const first = def.options[0]._zod.run;
    inst._zod.parse = (payload, ctx)=>{
        if (single) return first(payload, ctx);
        let async = false;
        const results = [];
        for (const option of def.options){
            const result = option._zod.run({
                value: payload.value,
                issues: []
            }, ctx);
            if (result instanceof Promise) {
                results.push(result);
                async = true;
            } else {
                if (result.issues.length === 0) return result;
                results.push(result);
            }
        }
        if (!async) return $38bc36f53cb4eb10$var$handleUnionResults(results, payload, inst, ctx);
        return Promise.all(results).then((results)=>{
            return $38bc36f53cb4eb10$var$handleUnionResults(results, payload, inst, ctx);
        });
    };
});
const $38bc36f53cb4eb10$export$aad4f17edfb83795 = /*@__PURE__*/ $d4d51e3b5652b8a4$export$3122533d606194de("$ZodDiscriminatedUnion", (inst, def)=>{
    $38bc36f53cb4eb10$export$37a2350ef0bd638c.init(inst, def);
    const _super = inst._zod.parse;
    $8f5391358ccbeba2$export$d43070a5843c1e2(inst._zod, "propValues", ()=>{
        const propValues = {};
        for (const option of def.options){
            const pv = option._zod.propValues;
            if (!pv || Object.keys(pv).length === 0) throw new Error(`Invalid discriminated union option at index "${def.options.indexOf(option)}"`);
            for (const [k, v] of Object.entries(pv)){
                if (!propValues[k]) propValues[k] = new Set();
                for (const val of v)propValues[k].add(val);
            }
        }
        return propValues;
    });
    const disc = $8f5391358ccbeba2$export$ade7a147f5129058(()=>{
        const opts = def.options;
        const map = new Map();
        for (const o of opts){
            const values = o._zod.propValues?.[def.discriminator];
            if (!values || values.size === 0) throw new Error(`Invalid discriminated union option at index "${def.options.indexOf(o)}"`);
            for (const v of values){
                if (map.has(v)) throw new Error(`Duplicate discriminator value "${String(v)}"`);
                map.set(v, o);
            }
        }
        return map;
    });
    inst._zod.parse = (payload, ctx)=>{
        const input = payload.value;
        if (!$8f5391358ccbeba2$export$a6cdc56e425d0d0a(input)) {
            payload.issues.push({
                code: "invalid_type",
                expected: "object",
                input: input,
                inst: inst
            });
            return payload;
        }
        const opt = disc.value.get(input?.[def.discriminator]);
        if (opt) return opt._zod.run(payload, ctx);
        if (def.unionFallback) return _super(payload, ctx);
        // no matching discriminator
        payload.issues.push({
            code: "invalid_union",
            errors: [],
            note: "No matching discriminator",
            discriminator: def.discriminator,
            input: input,
            path: [
                def.discriminator
            ],
            inst: inst
        });
        return payload;
    };
});
const $38bc36f53cb4eb10$export$2299250b426aba4b = /*@__PURE__*/ $d4d51e3b5652b8a4$export$3122533d606194de("$ZodIntersection", (inst, def)=>{
    $38bc36f53cb4eb10$export$f43a5c3966de8238.init(inst, def);
    inst._zod.parse = (payload, ctx)=>{
        const input = payload.value;
        const left = def.left._zod.run({
            value: input,
            issues: []
        }, ctx);
        const right = def.right._zod.run({
            value: input,
            issues: []
        }, ctx);
        const async = left instanceof Promise || right instanceof Promise;
        if (async) return Promise.all([
            left,
            right
        ]).then(([left, right])=>{
            return $38bc36f53cb4eb10$var$handleIntersectionResults(payload, left, right);
        });
        return $38bc36f53cb4eb10$var$handleIntersectionResults(payload, left, right);
    };
});
function $38bc36f53cb4eb10$var$mergeValues(a, b) {
    // const aType = parse.t(a);
    // const bType = parse.t(b);
    if (a === b) return {
        valid: true,
        data: a
    };
    if (a instanceof Date && b instanceof Date && +a === +b) return {
        valid: true,
        data: a
    };
    if ($8f5391358ccbeba2$export$53b83ca8eaab0383(a) && $8f5391358ccbeba2$export$53b83ca8eaab0383(b)) {
        const bKeys = Object.keys(b);
        const sharedKeys = Object.keys(a).filter((key)=>bKeys.indexOf(key) !== -1);
        const newObj = {
            ...a,
            ...b
        };
        for (const key of sharedKeys){
            const sharedValue = $38bc36f53cb4eb10$var$mergeValues(a[key], b[key]);
            if (!sharedValue.valid) return {
                valid: false,
                mergeErrorPath: [
                    key,
                    ...sharedValue.mergeErrorPath
                ]
            };
            newObj[key] = sharedValue.data;
        }
        return {
            valid: true,
            data: newObj
        };
    }
    if (Array.isArray(a) && Array.isArray(b)) {
        if (a.length !== b.length) return {
            valid: false,
            mergeErrorPath: []
        };
        const newArray = [];
        for(let index = 0; index < a.length; index++){
            const itemA = a[index];
            const itemB = b[index];
            const sharedValue = $38bc36f53cb4eb10$var$mergeValues(itemA, itemB);
            if (!sharedValue.valid) return {
                valid: false,
                mergeErrorPath: [
                    index,
                    ...sharedValue.mergeErrorPath
                ]
            };
            newArray.push(sharedValue.data);
        }
        return {
            valid: true,
            data: newArray
        };
    }
    return {
        valid: false,
        mergeErrorPath: []
    };
}
function $38bc36f53cb4eb10$var$handleIntersectionResults(result, left, right) {
    if (left.issues.length) result.issues.push(...left.issues);
    if (right.issues.length) result.issues.push(...right.issues);
    if ($8f5391358ccbeba2$export$bd75b6d981b9c7f2(result)) return result;
    const merged = $38bc36f53cb4eb10$var$mergeValues(left.value, right.value);
    if (!merged.valid) throw new Error(`Unmergable intersection. Error path: ` + `${JSON.stringify(merged.mergeErrorPath)}`);
    result.value = merged.data;
    return result;
}
const $38bc36f53cb4eb10$export$bba1b90a721dbd94 = /*@__PURE__*/ $d4d51e3b5652b8a4$export$3122533d606194de("$ZodTuple", (inst, def)=>{
    $38bc36f53cb4eb10$export$f43a5c3966de8238.init(inst, def);
    const items = def.items;
    inst._zod.parse = (payload, ctx)=>{
        const input = payload.value;
        if (!Array.isArray(input)) {
            payload.issues.push({
                input: input,
                inst: inst,
                expected: "tuple",
                code: "invalid_type"
            });
            return payload;
        }
        payload.value = [];
        const proms = [];
        const reversedIndex = [
            ...items
        ].reverse().findIndex((item)=>item._zod.optin !== "optional");
        const optStart = reversedIndex === -1 ? 0 : items.length - reversedIndex;
        if (!def.rest) {
            const tooBig = input.length > items.length;
            const tooSmall = input.length < optStart - 1;
            if (tooBig || tooSmall) {
                payload.issues.push({
                    ...tooBig ? {
                        code: "too_big",
                        maximum: items.length
                    } : {
                        code: "too_small",
                        minimum: items.length
                    },
                    input: input,
                    inst: inst,
                    origin: "array"
                });
                return payload;
            }
        }
        let i = -1;
        for (const item of items){
            i++;
            if (i >= input.length) {
                if (i >= optStart) continue;
            }
            const result = item._zod.run({
                value: input[i],
                issues: []
            }, ctx);
            if (result instanceof Promise) proms.push(result.then((result)=>$38bc36f53cb4eb10$var$handleTupleResult(result, payload, i)));
            else $38bc36f53cb4eb10$var$handleTupleResult(result, payload, i);
        }
        if (def.rest) {
            const rest = input.slice(items.length);
            for (const el of rest){
                i++;
                const result = def.rest._zod.run({
                    value: el,
                    issues: []
                }, ctx);
                if (result instanceof Promise) proms.push(result.then((result)=>$38bc36f53cb4eb10$var$handleTupleResult(result, payload, i)));
                else $38bc36f53cb4eb10$var$handleTupleResult(result, payload, i);
            }
        }
        if (proms.length) return Promise.all(proms).then(()=>payload);
        return payload;
    };
});
function $38bc36f53cb4eb10$var$handleTupleResult(result, final, index) {
    if (result.issues.length) final.issues.push(...$8f5391358ccbeba2$export$7f35a4c434118b9e(index, result.issues));
    final.value[index] = result.value;
}
const $38bc36f53cb4eb10$export$cc20b90ec1a8c208 = /*@__PURE__*/ $d4d51e3b5652b8a4$export$3122533d606194de("$ZodRecord", (inst, def)=>{
    $38bc36f53cb4eb10$export$f43a5c3966de8238.init(inst, def);
    inst._zod.parse = (payload, ctx)=>{
        const input = payload.value;
        if (!$8f5391358ccbeba2$export$53b83ca8eaab0383(input)) {
            payload.issues.push({
                expected: "record",
                code: "invalid_type",
                input: input,
                inst: inst
            });
            return payload;
        }
        const proms = [];
        const values = def.keyType._zod.values;
        if (values) {
            payload.value = {};
            const recordKeys = new Set();
            for (const key of values)if (typeof key === "string" || typeof key === "number" || typeof key === "symbol") {
                recordKeys.add(typeof key === "number" ? key.toString() : key);
                const result = def.valueType._zod.run({
                    value: input[key],
                    issues: []
                }, ctx);
                if (result instanceof Promise) proms.push(result.then((result)=>{
                    if (result.issues.length) payload.issues.push(...$8f5391358ccbeba2$export$7f35a4c434118b9e(key, result.issues));
                    payload.value[key] = result.value;
                }));
                else {
                    if (result.issues.length) payload.issues.push(...$8f5391358ccbeba2$export$7f35a4c434118b9e(key, result.issues));
                    payload.value[key] = result.value;
                }
            }
            let unrecognized;
            for(const key in input)if (!recordKeys.has(key)) {
                unrecognized = unrecognized ?? [];
                unrecognized.push(key);
            }
            if (unrecognized && unrecognized.length > 0) payload.issues.push({
                code: "unrecognized_keys",
                input: input,
                inst: inst,
                keys: unrecognized
            });
        } else {
            payload.value = {};
            for (const key of Reflect.ownKeys(input)){
                if (key === "__proto__") continue;
                const keyResult = def.keyType._zod.run({
                    value: key,
                    issues: []
                }, ctx);
                if (keyResult instanceof Promise) throw new Error("Async schemas not supported in object keys currently");
                if (keyResult.issues.length) {
                    payload.issues.push({
                        code: "invalid_key",
                        origin: "record",
                        issues: keyResult.issues.map((iss)=>$8f5391358ccbeba2$export$c5e667bbfc286a9d(iss, ctx, $d4d51e3b5652b8a4$export$e506a1d27d1eaa20())),
                        input: key,
                        path: [
                            key
                        ],
                        inst: inst
                    });
                    payload.value[keyResult.value] = keyResult.value;
                    continue;
                }
                const result = def.valueType._zod.run({
                    value: input[key],
                    issues: []
                }, ctx);
                if (result instanceof Promise) proms.push(result.then((result)=>{
                    if (result.issues.length) payload.issues.push(...$8f5391358ccbeba2$export$7f35a4c434118b9e(key, result.issues));
                    payload.value[keyResult.value] = result.value;
                }));
                else {
                    if (result.issues.length) payload.issues.push(...$8f5391358ccbeba2$export$7f35a4c434118b9e(key, result.issues));
                    payload.value[keyResult.value] = result.value;
                }
            }
        }
        if (proms.length) return Promise.all(proms).then(()=>payload);
        return payload;
    };
});
const $38bc36f53cb4eb10$export$5ccfd30a7e358409 = /*@__PURE__*/ $d4d51e3b5652b8a4$export$3122533d606194de("$ZodMap", (inst, def)=>{
    $38bc36f53cb4eb10$export$f43a5c3966de8238.init(inst, def);
    inst._zod.parse = (payload, ctx)=>{
        const input = payload.value;
        if (!(input instanceof Map)) {
            payload.issues.push({
                expected: "map",
                code: "invalid_type",
                input: input,
                inst: inst
            });
            return payload;
        }
        const proms = [];
        payload.value = new Map();
        for (const [key, value] of input){
            const keyResult = def.keyType._zod.run({
                value: key,
                issues: []
            }, ctx);
            const valueResult = def.valueType._zod.run({
                value: value,
                issues: []
            }, ctx);
            if (keyResult instanceof Promise || valueResult instanceof Promise) proms.push(Promise.all([
                keyResult,
                valueResult
            ]).then(([keyResult, valueResult])=>{
                $38bc36f53cb4eb10$var$handleMapResult(keyResult, valueResult, payload, key, input, inst, ctx);
            }));
            else $38bc36f53cb4eb10$var$handleMapResult(keyResult, valueResult, payload, key, input, inst, ctx);
        }
        if (proms.length) return Promise.all(proms).then(()=>payload);
        return payload;
    };
});
function $38bc36f53cb4eb10$var$handleMapResult(keyResult, valueResult, final, key, input, inst, ctx) {
    if (keyResult.issues.length) {
        if ($8f5391358ccbeba2$export$b99c149ecf60be48.has(typeof key)) final.issues.push(...$8f5391358ccbeba2$export$7f35a4c434118b9e(key, keyResult.issues));
        else final.issues.push({
            code: "invalid_key",
            origin: "map",
            input: input,
            inst: inst,
            issues: keyResult.issues.map((iss)=>$8f5391358ccbeba2$export$c5e667bbfc286a9d(iss, ctx, $d4d51e3b5652b8a4$export$e506a1d27d1eaa20()))
        });
    }
    if (valueResult.issues.length) {
        if ($8f5391358ccbeba2$export$b99c149ecf60be48.has(typeof key)) final.issues.push(...$8f5391358ccbeba2$export$7f35a4c434118b9e(key, valueResult.issues));
        else final.issues.push({
            origin: "map",
            code: "invalid_element",
            input: input,
            inst: inst,
            key: key,
            issues: valueResult.issues.map((iss)=>$8f5391358ccbeba2$export$c5e667bbfc286a9d(iss, ctx, $d4d51e3b5652b8a4$export$e506a1d27d1eaa20()))
        });
    }
    final.value.set(keyResult.value, valueResult.value);
}
const $38bc36f53cb4eb10$export$20cf27bc33a30268 = /*@__PURE__*/ $d4d51e3b5652b8a4$export$3122533d606194de("$ZodSet", (inst, def)=>{
    $38bc36f53cb4eb10$export$f43a5c3966de8238.init(inst, def);
    inst._zod.parse = (payload, ctx)=>{
        const input = payload.value;
        if (!(input instanceof Set)) {
            payload.issues.push({
                input: input,
                inst: inst,
                expected: "set",
                code: "invalid_type"
            });
            return payload;
        }
        const proms = [];
        payload.value = new Set();
        for (const item of input){
            const result = def.valueType._zod.run({
                value: item,
                issues: []
            }, ctx);
            if (result instanceof Promise) proms.push(result.then((result)=>$38bc36f53cb4eb10$var$handleSetResult(result, payload)));
            else $38bc36f53cb4eb10$var$handleSetResult(result, payload);
        }
        if (proms.length) return Promise.all(proms).then(()=>payload);
        return payload;
    };
});
function $38bc36f53cb4eb10$var$handleSetResult(result, final) {
    if (result.issues.length) final.issues.push(...result.issues);
    final.value.add(result.value);
}
const $38bc36f53cb4eb10$export$31462b6e6c50b618 = /*@__PURE__*/ $d4d51e3b5652b8a4$export$3122533d606194de("$ZodEnum", (inst, def)=>{
    $38bc36f53cb4eb10$export$f43a5c3966de8238.init(inst, def);
    const values = $8f5391358ccbeba2$export$70a5d58ec00f3c11(def.entries);
    const valuesSet = new Set(values);
    inst._zod.values = valuesSet;
    inst._zod.pattern = new RegExp(`^(${values.filter((k)=>$8f5391358ccbeba2$export$b99c149ecf60be48.has(typeof k)).map((o)=>typeof o === "string" ? $8f5391358ccbeba2$export$104ed90cc1a13451(o) : o.toString()).join("|")})$`);
    inst._zod.parse = (payload, _ctx)=>{
        const input = payload.value;
        if (valuesSet.has(input)) return payload;
        payload.issues.push({
            code: "invalid_value",
            values: values,
            input: input,
            inst: inst
        });
        return payload;
    };
});
const $38bc36f53cb4eb10$export$86699355265fa258 = /*@__PURE__*/ $d4d51e3b5652b8a4$export$3122533d606194de("$ZodLiteral", (inst, def)=>{
    $38bc36f53cb4eb10$export$f43a5c3966de8238.init(inst, def);
    if (def.values.length === 0) throw new Error("Cannot create literal schema with no valid values");
    const values = new Set(def.values);
    inst._zod.values = values;
    inst._zod.pattern = new RegExp(`^(${def.values.map((o)=>typeof o === "string" ? $8f5391358ccbeba2$export$104ed90cc1a13451(o) : o ? $8f5391358ccbeba2$export$104ed90cc1a13451(o.toString()) : String(o)).join("|")})$`);
    inst._zod.parse = (payload, _ctx)=>{
        const input = payload.value;
        if (values.has(input)) return payload;
        payload.issues.push({
            code: "invalid_value",
            values: def.values,
            input: input,
            inst: inst
        });
        return payload;
    };
});
const $38bc36f53cb4eb10$export$1997de0576a81377 = /*@__PURE__*/ $d4d51e3b5652b8a4$export$3122533d606194de("$ZodFile", (inst, def)=>{
    $38bc36f53cb4eb10$export$f43a5c3966de8238.init(inst, def);
    inst._zod.parse = (payload, _ctx)=>{
        const input = payload.value;
        // @ts-ignore
        if (input instanceof File) return payload;
        payload.issues.push({
            expected: "file",
            code: "invalid_type",
            input: input,
            inst: inst
        });
        return payload;
    };
});
const $38bc36f53cb4eb10$export$14b591f873519189 = /*@__PURE__*/ $d4d51e3b5652b8a4$export$3122533d606194de("$ZodTransform", (inst, def)=>{
    $38bc36f53cb4eb10$export$f43a5c3966de8238.init(inst, def);
    inst._zod.parse = (payload, ctx)=>{
        if (ctx.direction === "backward") throw new $d4d51e3b5652b8a4$export$a36d4c29b1151bde(inst.constructor.name);
        const _out = def.transform(payload.value, payload);
        if (ctx.async) {
            const output = _out instanceof Promise ? _out : Promise.resolve(_out);
            return output.then((output)=>{
                payload.value = output;
                return payload;
            });
        }
        if (_out instanceof Promise) throw new $d4d51e3b5652b8a4$export$13016bcec11ba196();
        payload.value = _out;
        return payload;
    };
});
function $38bc36f53cb4eb10$var$handleOptionalResult(result, input) {
    if (result.issues.length && input === undefined) return {
        issues: [],
        value: undefined
    };
    return result;
}
const $38bc36f53cb4eb10$export$980e9af565c4d7aa = /*@__PURE__*/ $d4d51e3b5652b8a4$export$3122533d606194de("$ZodOptional", (inst, def)=>{
    $38bc36f53cb4eb10$export$f43a5c3966de8238.init(inst, def);
    inst._zod.optin = "optional";
    inst._zod.optout = "optional";
    $8f5391358ccbeba2$export$d43070a5843c1e2(inst._zod, "values", ()=>{
        return def.innerType._zod.values ? new Set([
            ...def.innerType._zod.values,
            undefined
        ]) : undefined;
    });
    $8f5391358ccbeba2$export$d43070a5843c1e2(inst._zod, "pattern", ()=>{
        const pattern = def.innerType._zod.pattern;
        return pattern ? new RegExp(`^(${$8f5391358ccbeba2$export$78d521805d6c22e4(pattern.source)})?$`) : undefined;
    });
    inst._zod.parse = (payload, ctx)=>{
        if (def.innerType._zod.optin === "optional") {
            const result = def.innerType._zod.run(payload, ctx);
            if (result instanceof Promise) return result.then((r)=>$38bc36f53cb4eb10$var$handleOptionalResult(r, payload.value));
            return $38bc36f53cb4eb10$var$handleOptionalResult(result, payload.value);
        }
        if (payload.value === undefined) return payload;
        return def.innerType._zod.run(payload, ctx);
    };
});
const $38bc36f53cb4eb10$export$7994573b6604ec66 = /*@__PURE__*/ $d4d51e3b5652b8a4$export$3122533d606194de("$ZodNullable", (inst, def)=>{
    $38bc36f53cb4eb10$export$f43a5c3966de8238.init(inst, def);
    $8f5391358ccbeba2$export$d43070a5843c1e2(inst._zod, "optin", ()=>def.innerType._zod.optin);
    $8f5391358ccbeba2$export$d43070a5843c1e2(inst._zod, "optout", ()=>def.innerType._zod.optout);
    $8f5391358ccbeba2$export$d43070a5843c1e2(inst._zod, "pattern", ()=>{
        const pattern = def.innerType._zod.pattern;
        return pattern ? new RegExp(`^(${$8f5391358ccbeba2$export$78d521805d6c22e4(pattern.source)}|null)$`) : undefined;
    });
    $8f5391358ccbeba2$export$d43070a5843c1e2(inst._zod, "values", ()=>{
        return def.innerType._zod.values ? new Set([
            ...def.innerType._zod.values,
            null
        ]) : undefined;
    });
    inst._zod.parse = (payload, ctx)=>{
        // Forward direction (decode): allow null to pass through
        if (payload.value === null) return payload;
        return def.innerType._zod.run(payload, ctx);
    };
});
const $38bc36f53cb4eb10$export$ae2d21004b7243f7 = /*@__PURE__*/ $d4d51e3b5652b8a4$export$3122533d606194de("$ZodDefault", (inst, def)=>{
    $38bc36f53cb4eb10$export$f43a5c3966de8238.init(inst, def);
    // inst._zod.qin = "true";
    inst._zod.optin = "optional";
    $8f5391358ccbeba2$export$d43070a5843c1e2(inst._zod, "values", ()=>def.innerType._zod.values);
    inst._zod.parse = (payload, ctx)=>{
        if (ctx.direction === "backward") return def.innerType._zod.run(payload, ctx);
        // Forward direction (decode): apply defaults for undefined input
        if (payload.value === undefined) {
            payload.value = def.defaultValue;
            /**
             * $ZodDefault returns the default value immediately in forward direction.
             * It doesn't pass the default value into the validator ("prefault"). There's no reason to pass the default value through validation. The validity of the default is enforced by TypeScript statically. Otherwise, it's the responsibility of the user to ensure the default is valid. In the case of pipes with divergent in/out types, you can specify the default on the `in` schema of your ZodPipe to set a "prefault" for the pipe.   */ return payload;
        }
        // Forward direction: continue with default handling
        const result = def.innerType._zod.run(payload, ctx);
        if (result instanceof Promise) return result.then((result)=>$38bc36f53cb4eb10$var$handleDefaultResult(result, def));
        return $38bc36f53cb4eb10$var$handleDefaultResult(result, def);
    };
});
function $38bc36f53cb4eb10$var$handleDefaultResult(payload, def) {
    if (payload.value === undefined) payload.value = def.defaultValue;
    return payload;
}
const $38bc36f53cb4eb10$export$29a8d757258be679 = /*@__PURE__*/ $d4d51e3b5652b8a4$export$3122533d606194de("$ZodPrefault", (inst, def)=>{
    $38bc36f53cb4eb10$export$f43a5c3966de8238.init(inst, def);
    inst._zod.optin = "optional";
    $8f5391358ccbeba2$export$d43070a5843c1e2(inst._zod, "values", ()=>def.innerType._zod.values);
    inst._zod.parse = (payload, ctx)=>{
        if (ctx.direction === "backward") return def.innerType._zod.run(payload, ctx);
        // Forward direction (decode): apply prefault for undefined input
        if (payload.value === undefined) payload.value = def.defaultValue;
        return def.innerType._zod.run(payload, ctx);
    };
});
const $38bc36f53cb4eb10$export$30ca726c4c50a6d7 = /*@__PURE__*/ $d4d51e3b5652b8a4$export$3122533d606194de("$ZodNonOptional", (inst, def)=>{
    $38bc36f53cb4eb10$export$f43a5c3966de8238.init(inst, def);
    $8f5391358ccbeba2$export$d43070a5843c1e2(inst._zod, "values", ()=>{
        const v = def.innerType._zod.values;
        return v ? new Set([
            ...v
        ].filter((x)=>x !== undefined)) : undefined;
    });
    inst._zod.parse = (payload, ctx)=>{
        const result = def.innerType._zod.run(payload, ctx);
        if (result instanceof Promise) return result.then((result)=>$38bc36f53cb4eb10$var$handleNonOptionalResult(result, inst));
        return $38bc36f53cb4eb10$var$handleNonOptionalResult(result, inst);
    };
});
function $38bc36f53cb4eb10$var$handleNonOptionalResult(payload, inst) {
    if (!payload.issues.length && payload.value === undefined) payload.issues.push({
        code: "invalid_type",
        expected: "nonoptional",
        input: payload.value,
        inst: inst
    });
    return payload;
}
const $38bc36f53cb4eb10$export$3cc4d03e729326ea = /*@__PURE__*/ $d4d51e3b5652b8a4$export$3122533d606194de("$ZodSuccess", (inst, def)=>{
    $38bc36f53cb4eb10$export$f43a5c3966de8238.init(inst, def);
    inst._zod.parse = (payload, ctx)=>{
        if (ctx.direction === "backward") throw new $d4d51e3b5652b8a4$export$a36d4c29b1151bde("ZodSuccess");
        const result = def.innerType._zod.run(payload, ctx);
        if (result instanceof Promise) return result.then((result)=>{
            payload.value = result.issues.length === 0;
            return payload;
        });
        payload.value = result.issues.length === 0;
        return payload;
    };
});
const $38bc36f53cb4eb10$export$d6f8b228374f6d37 = /*@__PURE__*/ $d4d51e3b5652b8a4$export$3122533d606194de("$ZodCatch", (inst, def)=>{
    $38bc36f53cb4eb10$export$f43a5c3966de8238.init(inst, def);
    $8f5391358ccbeba2$export$d43070a5843c1e2(inst._zod, "optin", ()=>def.innerType._zod.optin);
    $8f5391358ccbeba2$export$d43070a5843c1e2(inst._zod, "optout", ()=>def.innerType._zod.optout);
    $8f5391358ccbeba2$export$d43070a5843c1e2(inst._zod, "values", ()=>def.innerType._zod.values);
    inst._zod.parse = (payload, ctx)=>{
        if (ctx.direction === "backward") return def.innerType._zod.run(payload, ctx);
        // Forward direction (decode): apply catch logic
        const result = def.innerType._zod.run(payload, ctx);
        if (result instanceof Promise) return result.then((result)=>{
            payload.value = result.value;
            if (result.issues.length) {
                payload.value = def.catchValue({
                    ...payload,
                    error: {
                        issues: result.issues.map((iss)=>$8f5391358ccbeba2$export$c5e667bbfc286a9d(iss, ctx, $d4d51e3b5652b8a4$export$e506a1d27d1eaa20()))
                    },
                    input: payload.value
                });
                payload.issues = [];
            }
            return payload;
        });
        payload.value = result.value;
        if (result.issues.length) {
            payload.value = def.catchValue({
                ...payload,
                error: {
                    issues: result.issues.map((iss)=>$8f5391358ccbeba2$export$c5e667bbfc286a9d(iss, ctx, $d4d51e3b5652b8a4$export$e506a1d27d1eaa20()))
                },
                input: payload.value
            });
            payload.issues = [];
        }
        return payload;
    };
});
const $38bc36f53cb4eb10$export$528f71701e6a7aee = /*@__PURE__*/ $d4d51e3b5652b8a4$export$3122533d606194de("$ZodNaN", (inst, def)=>{
    $38bc36f53cb4eb10$export$f43a5c3966de8238.init(inst, def);
    inst._zod.parse = (payload, _ctx)=>{
        if (typeof payload.value !== "number" || !Number.isNaN(payload.value)) {
            payload.issues.push({
                input: payload.value,
                inst: inst,
                expected: "nan",
                code: "invalid_type"
            });
            return payload;
        }
        return payload;
    };
});
const $38bc36f53cb4eb10$export$4cb25cfde430326c = /*@__PURE__*/ $d4d51e3b5652b8a4$export$3122533d606194de("$ZodPipe", (inst, def)=>{
    $38bc36f53cb4eb10$export$f43a5c3966de8238.init(inst, def);
    $8f5391358ccbeba2$export$d43070a5843c1e2(inst._zod, "values", ()=>def.in._zod.values);
    $8f5391358ccbeba2$export$d43070a5843c1e2(inst._zod, "optin", ()=>def.in._zod.optin);
    $8f5391358ccbeba2$export$d43070a5843c1e2(inst._zod, "optout", ()=>def.out._zod.optout);
    $8f5391358ccbeba2$export$d43070a5843c1e2(inst._zod, "propValues", ()=>def.in._zod.propValues);
    inst._zod.parse = (payload, ctx)=>{
        if (ctx.direction === "backward") {
            const right = def.out._zod.run(payload, ctx);
            if (right instanceof Promise) return right.then((right)=>$38bc36f53cb4eb10$var$handlePipeResult(right, def.in, ctx));
            return $38bc36f53cb4eb10$var$handlePipeResult(right, def.in, ctx);
        }
        const left = def.in._zod.run(payload, ctx);
        if (left instanceof Promise) return left.then((left)=>$38bc36f53cb4eb10$var$handlePipeResult(left, def.out, ctx));
        return $38bc36f53cb4eb10$var$handlePipeResult(left, def.out, ctx);
    };
});
function $38bc36f53cb4eb10$var$handlePipeResult(left, next, ctx) {
    if (left.issues.length) {
        // prevent further checks
        left.aborted = true;
        return left;
    }
    return next._zod.run({
        value: left.value,
        issues: left.issues
    }, ctx);
}
const $38bc36f53cb4eb10$export$c622e07db8a40b53 = /*@__PURE__*/ $d4d51e3b5652b8a4$export$3122533d606194de("$ZodCodec", (inst, def)=>{
    $38bc36f53cb4eb10$export$f43a5c3966de8238.init(inst, def);
    $8f5391358ccbeba2$export$d43070a5843c1e2(inst._zod, "values", ()=>def.in._zod.values);
    $8f5391358ccbeba2$export$d43070a5843c1e2(inst._zod, "optin", ()=>def.in._zod.optin);
    $8f5391358ccbeba2$export$d43070a5843c1e2(inst._zod, "optout", ()=>def.out._zod.optout);
    $8f5391358ccbeba2$export$d43070a5843c1e2(inst._zod, "propValues", ()=>def.in._zod.propValues);
    inst._zod.parse = (payload, ctx)=>{
        const direction = ctx.direction || "forward";
        if (direction === "forward") {
            const left = def.in._zod.run(payload, ctx);
            if (left instanceof Promise) return left.then((left)=>$38bc36f53cb4eb10$var$handleCodecAResult(left, def, ctx));
            return $38bc36f53cb4eb10$var$handleCodecAResult(left, def, ctx);
        } else {
            const right = def.out._zod.run(payload, ctx);
            if (right instanceof Promise) return right.then((right)=>$38bc36f53cb4eb10$var$handleCodecAResult(right, def, ctx));
            return $38bc36f53cb4eb10$var$handleCodecAResult(right, def, ctx);
        }
    };
});
function $38bc36f53cb4eb10$var$handleCodecAResult(result, def, ctx) {
    if (result.issues.length) {
        // prevent further checks
        result.aborted = true;
        return result;
    }
    const direction = ctx.direction || "forward";
    if (direction === "forward") {
        const transformed = def.transform(result.value, result);
        if (transformed instanceof Promise) return transformed.then((value)=>$38bc36f53cb4eb10$var$handleCodecTxResult(result, value, def.out, ctx));
        return $38bc36f53cb4eb10$var$handleCodecTxResult(result, transformed, def.out, ctx);
    } else {
        const transformed = def.reverseTransform(result.value, result);
        if (transformed instanceof Promise) return transformed.then((value)=>$38bc36f53cb4eb10$var$handleCodecTxResult(result, value, def.in, ctx));
        return $38bc36f53cb4eb10$var$handleCodecTxResult(result, transformed, def.in, ctx);
    }
}
function $38bc36f53cb4eb10$var$handleCodecTxResult(left, value, nextSchema, ctx) {
    // Check if transform added any issues
    if (left.issues.length) {
        left.aborted = true;
        return left;
    }
    return nextSchema._zod.run({
        value: value,
        issues: left.issues
    }, ctx);
}
const $38bc36f53cb4eb10$export$f9f268f3fbb1601b = /*@__PURE__*/ $d4d51e3b5652b8a4$export$3122533d606194de("$ZodReadonly", (inst, def)=>{
    $38bc36f53cb4eb10$export$f43a5c3966de8238.init(inst, def);
    $8f5391358ccbeba2$export$d43070a5843c1e2(inst._zod, "propValues", ()=>def.innerType._zod.propValues);
    $8f5391358ccbeba2$export$d43070a5843c1e2(inst._zod, "values", ()=>def.innerType._zod.values);
    $8f5391358ccbeba2$export$d43070a5843c1e2(inst._zod, "optin", ()=>def.innerType?._zod?.optin);
    $8f5391358ccbeba2$export$d43070a5843c1e2(inst._zod, "optout", ()=>def.innerType?._zod?.optout);
    inst._zod.parse = (payload, ctx)=>{
        if (ctx.direction === "backward") return def.innerType._zod.run(payload, ctx);
        const result = def.innerType._zod.run(payload, ctx);
        if (result instanceof Promise) return result.then($38bc36f53cb4eb10$var$handleReadonlyResult);
        return $38bc36f53cb4eb10$var$handleReadonlyResult(result);
    };
});
function $38bc36f53cb4eb10$var$handleReadonlyResult(payload) {
    payload.value = Object.freeze(payload.value);
    return payload;
}
const $38bc36f53cb4eb10$export$37ea86c57a77af54 = /*@__PURE__*/ $d4d51e3b5652b8a4$export$3122533d606194de("$ZodTemplateLiteral", (inst, def)=>{
    $38bc36f53cb4eb10$export$f43a5c3966de8238.init(inst, def);
    const regexParts = [];
    for (const part of def.parts){
        if (typeof part === "object" && part !== null) {
            // is Zod schema
            if (!part._zod.pattern) // if (!source)
            throw new Error(`Invalid template literal part, no pattern found: ${[
                ...part._zod.traits
            ].shift()}`);
            const source = part._zod.pattern instanceof RegExp ? part._zod.pattern.source : part._zod.pattern;
            if (!source) throw new Error(`Invalid template literal part: ${part._zod.traits}`);
            const start = source.startsWith("^") ? 1 : 0;
            const end = source.endsWith("$") ? source.length - 1 : source.length;
            regexParts.push(source.slice(start, end));
        } else if (part === null || $8f5391358ccbeba2$export$c34ffd355f76f0e4.has(typeof part)) regexParts.push($8f5391358ccbeba2$export$104ed90cc1a13451(`${part}`));
        else throw new Error(`Invalid template literal part: ${part}`);
    }
    inst._zod.pattern = new RegExp(`^${regexParts.join("")}$`);
    inst._zod.parse = (payload, _ctx)=>{
        if (typeof payload.value !== "string") {
            payload.issues.push({
                input: payload.value,
                inst: inst,
                expected: "template_literal",
                code: "invalid_type"
            });
            return payload;
        }
        inst._zod.pattern.lastIndex = 0;
        if (!inst._zod.pattern.test(payload.value)) {
            payload.issues.push({
                input: payload.value,
                inst: inst,
                code: "invalid_format",
                format: def.format ?? "template_literal",
                pattern: inst._zod.pattern.source
            });
            return payload;
        }
        return payload;
    };
});
const $38bc36f53cb4eb10$export$877c6e9c05ede764 = /*@__PURE__*/ $d4d51e3b5652b8a4$export$3122533d606194de("$ZodFunction", (inst, def)=>{
    $38bc36f53cb4eb10$export$f43a5c3966de8238.init(inst, def);
    inst._def = def;
    inst._zod.def = def;
    inst.implement = (func)=>{
        if (typeof func !== "function") throw new Error("implement() must be called with a function");
        return function(...args) {
            const parsedArgs = inst._def.input ? (0, $65d57763ab0754f3$export$98e6a39c04603d36)(inst._def.input, args) : args;
            const result = Reflect.apply(func, this, parsedArgs);
            if (inst._def.output) return (0, $65d57763ab0754f3$export$98e6a39c04603d36)(inst._def.output, result);
            return result;
        };
    };
    inst.implementAsync = (func)=>{
        if (typeof func !== "function") throw new Error("implementAsync() must be called with a function");
        return async function(...args) {
            const parsedArgs = inst._def.input ? await (0, $65d57763ab0754f3$export$59b6f938fbf579e3)(inst._def.input, args) : args;
            const result = await Reflect.apply(func, this, parsedArgs);
            if (inst._def.output) return await (0, $65d57763ab0754f3$export$59b6f938fbf579e3)(inst._def.output, result);
            return result;
        };
    };
    inst._zod.parse = (payload, _ctx)=>{
        if (typeof payload.value !== "function") {
            payload.issues.push({
                code: "invalid_type",
                expected: "function",
                input: payload.value,
                inst: inst
            });
            return payload;
        }
        // Check if output is a promise type to determine if we should use async implementation
        const hasPromiseOutput = inst._def.output && inst._def.output._zod.def.type === "promise";
        if (hasPromiseOutput) payload.value = inst.implementAsync(payload.value);
        else payload.value = inst.implement(payload.value);
        return payload;
    };
    inst.input = (...args)=>{
        const F = inst.constructor;
        if (Array.isArray(args[0])) return new F({
            type: "function",
            input: new $38bc36f53cb4eb10$export$bba1b90a721dbd94({
                type: "tuple",
                items: args[0],
                rest: args[1]
            }),
            output: inst._def.output
        });
        return new F({
            type: "function",
            input: args[0],
            output: inst._def.output
        });
    };
    inst.output = (output)=>{
        const F = inst.constructor;
        return new F({
            type: "function",
            input: inst._def.input,
            output: output
        });
    };
    return inst;
});
const $38bc36f53cb4eb10$export$bdefabff0dd84ca4 = /*@__PURE__*/ $d4d51e3b5652b8a4$export$3122533d606194de("$ZodPromise", (inst, def)=>{
    $38bc36f53cb4eb10$export$f43a5c3966de8238.init(inst, def);
    inst._zod.parse = (payload, ctx)=>{
        return Promise.resolve(payload.value).then((inner)=>def.innerType._zod.run({
                value: inner,
                issues: []
            }, ctx));
    };
});
const $38bc36f53cb4eb10$export$662fecee2efa1a66 = /*@__PURE__*/ $d4d51e3b5652b8a4$export$3122533d606194de("$ZodLazy", (inst, def)=>{
    $38bc36f53cb4eb10$export$f43a5c3966de8238.init(inst, def);
    // let _innerType!: any;
    // util.defineLazy(def, "getter", () => {
    //   if (!_innerType) {
    //     _innerType = def.getter();
    //   }
    //   return () => _innerType;
    // });
    $8f5391358ccbeba2$export$d43070a5843c1e2(inst._zod, "innerType", ()=>def.getter());
    $8f5391358ccbeba2$export$d43070a5843c1e2(inst._zod, "pattern", ()=>inst._zod.innerType?._zod?.pattern);
    $8f5391358ccbeba2$export$d43070a5843c1e2(inst._zod, "propValues", ()=>inst._zod.innerType?._zod?.propValues);
    $8f5391358ccbeba2$export$d43070a5843c1e2(inst._zod, "optin", ()=>inst._zod.innerType?._zod?.optin ?? undefined);
    $8f5391358ccbeba2$export$d43070a5843c1e2(inst._zod, "optout", ()=>inst._zod.innerType?._zod?.optout ?? undefined);
    inst._zod.parse = (payload, ctx)=>{
        const inner = inst._zod.innerType;
        return inner._zod.run(payload, ctx);
    };
});
const $38bc36f53cb4eb10$export$3a5d0e5e098b79ba = /*@__PURE__*/ $d4d51e3b5652b8a4$export$3122533d606194de("$ZodCustom", (inst, def)=>{
    $81f0b1f6d5b9fb58$export$c05d9110ef20bb2c.init(inst, def);
    $38bc36f53cb4eb10$export$f43a5c3966de8238.init(inst, def);
    inst._zod.parse = (payload, _)=>{
        return payload;
    };
    inst._zod.check = (payload)=>{
        const input = payload.value;
        const r = def.fn(input);
        if (r instanceof Promise) return r.then((r)=>$38bc36f53cb4eb10$var$handleRefineResult(r, payload, input, inst));
        $38bc36f53cb4eb10$var$handleRefineResult(r, payload, input, inst);
        return;
    };
});
function $38bc36f53cb4eb10$var$handleRefineResult(result, payload, input, inst) {
    if (!result) {
        const _iss = {
            code: "custom",
            input: input,
            inst: inst,
            path: [
                ...inst._zod.def.path ?? []
            ],
            continue: !inst._zod.def.abort
        };
        if (inst._zod.def.params) _iss.params = inst._zod.def.params;
        payload.issues.push($8f5391358ccbeba2$export$69ad3503f98be476(_iss));
    }
}







const $ea0d52f3fa6013ee$var$error = ()=>{
    const Sizable = {
        string: {
            unit: "\u062D\u0631\u0641",
            verb: "\u0623\u0646 \u064A\u062D\u0648\u064A"
        },
        file: {
            unit: "\u0628\u0627\u064A\u062A",
            verb: "\u0623\u0646 \u064A\u062D\u0648\u064A"
        },
        array: {
            unit: "\u0639\u0646\u0635\u0631",
            verb: "\u0623\u0646 \u064A\u062D\u0648\u064A"
        },
        set: {
            unit: "\u0639\u0646\u0635\u0631",
            verb: "\u0623\u0646 \u064A\u062D\u0648\u064A"
        }
    };
    function getSizing(origin) {
        return Sizable[origin] ?? null;
    }
    const parsedType = (data)=>{
        const t = typeof data;
        switch(t){
            case "number":
                return Number.isNaN(data) ? "NaN" : "number";
            case "object":
                if (Array.isArray(data)) return "array";
                if (data === null) return "null";
                if (Object.getPrototypeOf(data) !== Object.prototype && data.constructor) return data.constructor.name;
        }
        return t;
    };
    const Nouns = {
        regex: "\u0645\u062F\u062E\u0644",
        email: "\u0628\u0631\u064A\u062F \u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A",
        url: "\u0631\u0627\u0628\u0637",
        emoji: "\u0625\u064A\u0645\u0648\u062C\u064A",
        uuid: "UUID",
        uuidv4: "UUIDv4",
        uuidv6: "UUIDv6",
        nanoid: "nanoid",
        guid: "GUID",
        cuid: "cuid",
        cuid2: "cuid2",
        ulid: "ULID",
        xid: "XID",
        ksuid: "KSUID",
        datetime: "\u062A\u0627\u0631\u064A\u062E \u0648\u0648\u0642\u062A \u0628\u0645\u0639\u064A\u0627\u0631 ISO",
        date: "\u062A\u0627\u0631\u064A\u062E \u0628\u0645\u0639\u064A\u0627\u0631 ISO",
        time: "\u0648\u0642\u062A \u0628\u0645\u0639\u064A\u0627\u0631 ISO",
        duration: "\u0645\u062F\u0629 \u0628\u0645\u0639\u064A\u0627\u0631 ISO",
        ipv4: "\u0639\u0646\u0648\u0627\u0646 IPv4",
        ipv6: "\u0639\u0646\u0648\u0627\u0646 IPv6",
        cidrv4: "\u0645\u062F\u0649 \u0639\u0646\u0627\u0648\u064A\u0646 \u0628\u0635\u064A\u063A\u0629 IPv4",
        cidrv6: "\u0645\u062F\u0649 \u0639\u0646\u0627\u0648\u064A\u0646 \u0628\u0635\u064A\u063A\u0629 IPv6",
        base64: "\u0646\u064E\u0635 \u0628\u062A\u0631\u0645\u064A\u0632 base64-encoded",
        base64url: "\u0646\u064E\u0635 \u0628\u062A\u0631\u0645\u064A\u0632 base64url-encoded",
        json_string: "\u0646\u064E\u0635 \u0639\u0644\u0649 \u0647\u064A\u0626\u0629 JSON",
        e164: "\u0631\u0642\u0645 \u0647\u0627\u062A\u0641 \u0628\u0645\u0639\u064A\u0627\u0631 E.164",
        jwt: "JWT",
        template_literal: "\u0645\u062F\u062E\u0644"
    };
    return (issue)=>{
        switch(issue.code){
            case "invalid_type":
                return `\u{645}\u{62F}\u{62E}\u{644}\u{627}\u{62A} \u{63A}\u{64A}\u{631} \u{645}\u{642}\u{628}\u{648}\u{644}\u{629}: \u{64A}\u{641}\u{62A}\u{631}\u{636} \u{625}\u{62F}\u{62E}\u{627}\u{644} ${issue.expected}\u{60C} \u{648}\u{644}\u{643}\u{646} \u{62A}\u{645} \u{625}\u{62F}\u{62E}\u{627}\u{644} ${parsedType(issue.input)}`;
            case "invalid_value":
                if (issue.values.length === 1) return `\u{645}\u{62F}\u{62E}\u{644}\u{627}\u{62A} \u{63A}\u{64A}\u{631} \u{645}\u{642}\u{628}\u{648}\u{644}\u{629}: \u{64A}\u{641}\u{62A}\u{631}\u{636} \u{625}\u{62F}\u{62E}\u{627}\u{644} ${$8f5391358ccbeba2$export$5859860f650378f4(issue.values[0])}`;
                return `\u{627}\u{62E}\u{62A}\u{64A}\u{627}\u{631} \u{63A}\u{64A}\u{631} \u{645}\u{642}\u{628}\u{648}\u{644}: \u{64A}\u{62A}\u{648}\u{642}\u{639} \u{627}\u{646}\u{62A}\u{642}\u{627}\u{621} \u{623}\u{62D}\u{62F} \u{647}\u{630}\u{647} \u{627}\u{644}\u{62E}\u{64A}\u{627}\u{631}\u{627}\u{62A}: ${$8f5391358ccbeba2$export$e79b744344f50f50(issue.values, "|")}`;
            case "too_big":
                {
                    const adj = issue.inclusive ? "<=" : "<";
                    const sizing = getSizing(issue.origin);
                    if (sizing) return ` \u{623}\u{643}\u{628}\u{631} \u{645}\u{646} \u{627}\u{644}\u{644}\u{627}\u{632}\u{645}: \u{64A}\u{641}\u{62A}\u{631}\u{636} \u{623}\u{646} \u{62A}\u{643}\u{648}\u{646} ${issue.origin ?? "\u0627\u0644\u0642\u064A\u0645\u0629"} ${adj} ${issue.maximum.toString()} ${sizing.unit ?? "\u0639\u0646\u0635\u0631"}`;
                    return `\u{623}\u{643}\u{628}\u{631} \u{645}\u{646} \u{627}\u{644}\u{644}\u{627}\u{632}\u{645}: \u{64A}\u{641}\u{62A}\u{631}\u{636} \u{623}\u{646} \u{62A}\u{643}\u{648}\u{646} ${issue.origin ?? "\u0627\u0644\u0642\u064A\u0645\u0629"} ${adj} ${issue.maximum.toString()}`;
                }
            case "too_small":
                {
                    const adj = issue.inclusive ? ">=" : ">";
                    const sizing = getSizing(issue.origin);
                    if (sizing) return `\u{623}\u{635}\u{63A}\u{631} \u{645}\u{646} \u{627}\u{644}\u{644}\u{627}\u{632}\u{645}: \u{64A}\u{641}\u{62A}\u{631}\u{636} \u{644}\u{640} ${issue.origin} \u{623}\u{646} \u{64A}\u{643}\u{648}\u{646} ${adj} ${issue.minimum.toString()} ${sizing.unit}`;
                    return `\u{623}\u{635}\u{63A}\u{631} \u{645}\u{646} \u{627}\u{644}\u{644}\u{627}\u{632}\u{645}: \u{64A}\u{641}\u{62A}\u{631}\u{636} \u{644}\u{640} ${issue.origin} \u{623}\u{646} \u{64A}\u{643}\u{648}\u{646} ${adj} ${issue.minimum.toString()}`;
                }
            case "invalid_format":
                {
                    const _issue = issue;
                    if (_issue.format === "starts_with") return `\u{646}\u{64E}\u{635} \u{63A}\u{64A}\u{631} \u{645}\u{642}\u{628}\u{648}\u{644}: \u{64A}\u{62C}\u{628} \u{623}\u{646} \u{64A}\u{628}\u{62F}\u{623} \u{628}\u{640} "${issue.prefix}"`;
                    if (_issue.format === "ends_with") return `\u{646}\u{64E}\u{635} \u{63A}\u{64A}\u{631} \u{645}\u{642}\u{628}\u{648}\u{644}: \u{64A}\u{62C}\u{628} \u{623}\u{646} \u{64A}\u{646}\u{62A}\u{647}\u{64A} \u{628}\u{640} "${_issue.suffix}"`;
                    if (_issue.format === "includes") return `\u{646}\u{64E}\u{635} \u{63A}\u{64A}\u{631} \u{645}\u{642}\u{628}\u{648}\u{644}: \u{64A}\u{62C}\u{628} \u{623}\u{646} \u{64A}\u{62A}\u{636}\u{645}\u{651}\u{64E}\u{646} "${_issue.includes}"`;
                    if (_issue.format === "regex") return `\u{646}\u{64E}\u{635} \u{63A}\u{64A}\u{631} \u{645}\u{642}\u{628}\u{648}\u{644}: \u{64A}\u{62C}\u{628} \u{623}\u{646} \u{64A}\u{637}\u{627}\u{628}\u{642} \u{627}\u{644}\u{646}\u{645}\u{637} ${_issue.pattern}`;
                    return `${Nouns[_issue.format] ?? issue.format} \u{63A}\u{64A}\u{631} \u{645}\u{642}\u{628}\u{648}\u{644}`;
                }
            case "not_multiple_of":
                return `\u{631}\u{642}\u{645} \u{63A}\u{64A}\u{631} \u{645}\u{642}\u{628}\u{648}\u{644}: \u{64A}\u{62C}\u{628} \u{623}\u{646} \u{64A}\u{643}\u{648}\u{646} \u{645}\u{646} \u{645}\u{636}\u{627}\u{639}\u{641}\u{627}\u{62A} ${issue.divisor}`;
            case "unrecognized_keys":
                return `\u{645}\u{639}\u{631}\u{641}${issue.keys.length > 1 ? "\u0627\u062A" : ""} \u{63A}\u{631}\u{64A}\u{628}${issue.keys.length > 1 ? "\u0629" : ""}: ${$8f5391358ccbeba2$export$e79b744344f50f50(issue.keys, "\u060C ")}`;
            case "invalid_key":
                return `\u{645}\u{639}\u{631}\u{641} \u{63A}\u{64A}\u{631} \u{645}\u{642}\u{628}\u{648}\u{644} \u{641}\u{64A} ${issue.origin}`;
            case "invalid_union":
                return "\u0645\u062F\u062E\u0644 \u063A\u064A\u0631 \u0645\u0642\u0628\u0648\u0644";
            case "invalid_element":
                return `\u{645}\u{62F}\u{62E}\u{644} \u{63A}\u{64A}\u{631} \u{645}\u{642}\u{628}\u{648}\u{644} \u{641}\u{64A} ${issue.origin}`;
            default:
                return "\u0645\u062F\u062E\u0644 \u063A\u064A\u0631 \u0645\u0642\u0628\u0648\u0644";
        }
    };
};
function $ea0d52f3fa6013ee$export$2e2bcd8739ae039() {
    return {
        localeError: $ea0d52f3fa6013ee$var$error()
    };
}



const $4d6d18770395e13d$var$error = ()=>{
    const Sizable = {
        string: {
            unit: "simvol",
            verb: "olmal\u0131d\u0131r"
        },
        file: {
            unit: "bayt",
            verb: "olmal\u0131d\u0131r"
        },
        array: {
            unit: "element",
            verb: "olmal\u0131d\u0131r"
        },
        set: {
            unit: "element",
            verb: "olmal\u0131d\u0131r"
        }
    };
    function getSizing(origin) {
        return Sizable[origin] ?? null;
    }
    const parsedType = (data)=>{
        const t = typeof data;
        switch(t){
            case "number":
                return Number.isNaN(data) ? "NaN" : "number";
            case "object":
                if (Array.isArray(data)) return "array";
                if (data === null) return "null";
                if (Object.getPrototypeOf(data) !== Object.prototype && data.constructor) return data.constructor.name;
        }
        return t;
    };
    const Nouns = {
        regex: "input",
        email: "email address",
        url: "URL",
        emoji: "emoji",
        uuid: "UUID",
        uuidv4: "UUIDv4",
        uuidv6: "UUIDv6",
        nanoid: "nanoid",
        guid: "GUID",
        cuid: "cuid",
        cuid2: "cuid2",
        ulid: "ULID",
        xid: "XID",
        ksuid: "KSUID",
        datetime: "ISO datetime",
        date: "ISO date",
        time: "ISO time",
        duration: "ISO duration",
        ipv4: "IPv4 address",
        ipv6: "IPv6 address",
        cidrv4: "IPv4 range",
        cidrv6: "IPv6 range",
        base64: "base64-encoded string",
        base64url: "base64url-encoded string",
        json_string: "JSON string",
        e164: "E.164 number",
        jwt: "JWT",
        template_literal: "input"
    };
    return (issue)=>{
        switch(issue.code){
            case "invalid_type":
                return `Yanl\u{131}\u{15F} d\u{259}y\u{259}r: g\xf6zl\u{259}nil\u{259}n ${issue.expected}, daxil olan ${parsedType(issue.input)}`;
            case "invalid_value":
                if (issue.values.length === 1) return `Yanl\u{131}\u{15F} d\u{259}y\u{259}r: g\xf6zl\u{259}nil\u{259}n ${$8f5391358ccbeba2$export$5859860f650378f4(issue.values[0])}`;
                return `Yanl\u{131}\u{15F} se\xe7im: a\u{15F}a\u{11F}\u{131}dak\u{131}lardan biri olmal\u{131}d\u{131}r: ${$8f5391358ccbeba2$export$e79b744344f50f50(issue.values, "|")}`;
            case "too_big":
                {
                    const adj = issue.inclusive ? "<=" : "<";
                    const sizing = getSizing(issue.origin);
                    if (sizing) return `\xc7ox b\xf6y\xfck: g\xf6zl\u{259}nil\u{259}n ${issue.origin ?? "d\u0259y\u0259r"} ${adj}${issue.maximum.toString()} ${sizing.unit ?? "element"}`;
                    return `\xc7ox b\xf6y\xfck: g\xf6zl\u{259}nil\u{259}n ${issue.origin ?? "d\u0259y\u0259r"} ${adj}${issue.maximum.toString()}`;
                }
            case "too_small":
                {
                    const adj = issue.inclusive ? ">=" : ">";
                    const sizing = getSizing(issue.origin);
                    if (sizing) return `\xc7ox ki\xe7ik: g\xf6zl\u{259}nil\u{259}n ${issue.origin} ${adj}${issue.minimum.toString()} ${sizing.unit}`;
                    return `\xc7ox ki\xe7ik: g\xf6zl\u{259}nil\u{259}n ${issue.origin} ${adj}${issue.minimum.toString()}`;
                }
            case "invalid_format":
                {
                    const _issue = issue;
                    if (_issue.format === "starts_with") return `Yanl\u{131}\u{15F} m\u{259}tn: "${_issue.prefix}" il\u{259} ba\u{15F}lamal\u{131}d\u{131}r`;
                    if (_issue.format === "ends_with") return `Yanl\u{131}\u{15F} m\u{259}tn: "${_issue.suffix}" il\u{259} bitm\u{259}lidir`;
                    if (_issue.format === "includes") return `Yanl\u{131}\u{15F} m\u{259}tn: "${_issue.includes}" daxil olmal\u{131}d\u{131}r`;
                    if (_issue.format === "regex") return `Yanl\u{131}\u{15F} m\u{259}tn: ${_issue.pattern} \u{15F}ablonuna uy\u{11F}un olmal\u{131}d\u{131}r`;
                    return `Yanl\u{131}\u{15F} ${Nouns[_issue.format] ?? issue.format}`;
                }
            case "not_multiple_of":
                return `Yanl\u{131}\u{15F} \u{259}d\u{259}d: ${issue.divisor} il\u{259} b\xf6l\xfcn\u{259} bil\u{259}n olmal\u{131}d\u{131}r`;
            case "unrecognized_keys":
                return `Tan\u{131}nmayan a\xe7ar${issue.keys.length > 1 ? "lar" : ""}: ${$8f5391358ccbeba2$export$e79b744344f50f50(issue.keys, ", ")}`;
            case "invalid_key":
                return `${issue.origin} daxilind\u{259} yanl\u{131}\u{15F} a\xe7ar`;
            case "invalid_union":
                return "Yanl\u0131\u015F d\u0259y\u0259r";
            case "invalid_element":
                return `${issue.origin} daxilind\u{259} yanl\u{131}\u{15F} d\u{259}y\u{259}r`;
            default:
                return `Yanl\u{131}\u{15F} d\u{259}y\u{259}r`;
        }
    };
};
function $4d6d18770395e13d$export$2e2bcd8739ae039() {
    return {
        localeError: $4d6d18770395e13d$var$error()
    };
}



function $772fd2a92c056b8f$var$getBelarusianPlural(count, one, few, many) {
    const absCount = Math.abs(count);
    const lastDigit = absCount % 10;
    const lastTwoDigits = absCount % 100;
    if (lastTwoDigits >= 11 && lastTwoDigits <= 19) return many;
    if (lastDigit === 1) return one;
    if (lastDigit >= 2 && lastDigit <= 4) return few;
    return many;
}
const $772fd2a92c056b8f$var$error = ()=>{
    const Sizable = {
        string: {
            unit: {
                one: "\u0441\u0456\u043C\u0432\u0430\u043B",
                few: "\u0441\u0456\u043C\u0432\u0430\u043B\u044B",
                many: "\u0441\u0456\u043C\u0432\u0430\u043B\u0430\u045E"
            },
            verb: "\u043C\u0435\u0446\u044C"
        },
        array: {
            unit: {
                one: "\u044D\u043B\u0435\u043C\u0435\u043D\u0442",
                few: "\u044D\u043B\u0435\u043C\u0435\u043D\u0442\u044B",
                many: "\u044D\u043B\u0435\u043C\u0435\u043D\u0442\u0430\u045E"
            },
            verb: "\u043C\u0435\u0446\u044C"
        },
        set: {
            unit: {
                one: "\u044D\u043B\u0435\u043C\u0435\u043D\u0442",
                few: "\u044D\u043B\u0435\u043C\u0435\u043D\u0442\u044B",
                many: "\u044D\u043B\u0435\u043C\u0435\u043D\u0442\u0430\u045E"
            },
            verb: "\u043C\u0435\u0446\u044C"
        },
        file: {
            unit: {
                one: "\u0431\u0430\u0439\u0442",
                few: "\u0431\u0430\u0439\u0442\u044B",
                many: "\u0431\u0430\u0439\u0442\u0430\u045E"
            },
            verb: "\u043C\u0435\u0446\u044C"
        }
    };
    function getSizing(origin) {
        return Sizable[origin] ?? null;
    }
    const parsedType = (data)=>{
        const t = typeof data;
        switch(t){
            case "number":
                return Number.isNaN(data) ? "NaN" : "\u043B\u0456\u043A";
            case "object":
                if (Array.isArray(data)) return "\u043C\u0430\u0441\u0456\u045E";
                if (data === null) return "null";
                if (Object.getPrototypeOf(data) !== Object.prototype && data.constructor) return data.constructor.name;
        }
        return t;
    };
    const Nouns = {
        regex: "\u0443\u0432\u043E\u0434",
        email: "email \u0430\u0434\u0440\u0430\u0441",
        url: "URL",
        emoji: "\u044D\u043C\u043E\u0434\u0437\u0456",
        uuid: "UUID",
        uuidv4: "UUIDv4",
        uuidv6: "UUIDv6",
        nanoid: "nanoid",
        guid: "GUID",
        cuid: "cuid",
        cuid2: "cuid2",
        ulid: "ULID",
        xid: "XID",
        ksuid: "KSUID",
        datetime: "ISO \u0434\u0430\u0442\u0430 \u0456 \u0447\u0430\u0441",
        date: "ISO \u0434\u0430\u0442\u0430",
        time: "ISO \u0447\u0430\u0441",
        duration: "ISO \u043F\u0440\u0430\u0446\u044F\u0433\u043B\u0430\u0441\u0446\u044C",
        ipv4: "IPv4 \u0430\u0434\u0440\u0430\u0441",
        ipv6: "IPv6 \u0430\u0434\u0440\u0430\u0441",
        cidrv4: "IPv4 \u0434\u044B\u044F\u043F\u0430\u0437\u043E\u043D",
        cidrv6: "IPv6 \u0434\u044B\u044F\u043F\u0430\u0437\u043E\u043D",
        base64: "\u0440\u0430\u0434\u043E\u043A \u0443 \u0444\u0430\u0440\u043C\u0430\u0446\u0435 base64",
        base64url: "\u0440\u0430\u0434\u043E\u043A \u0443 \u0444\u0430\u0440\u043C\u0430\u0446\u0435 base64url",
        json_string: "JSON \u0440\u0430\u0434\u043E\u043A",
        e164: "\u043D\u0443\u043C\u0430\u0440 E.164",
        jwt: "JWT",
        template_literal: "\u0443\u0432\u043E\u0434"
    };
    return (issue)=>{
        switch(issue.code){
            case "invalid_type":
                return `\u{41D}\u{44F}\u{43F}\u{440}\u{430}\u{432}\u{456}\u{43B}\u{44C}\u{43D}\u{44B} \u{45E}\u{432}\u{43E}\u{434}: \u{447}\u{430}\u{43A}\u{430}\u{45E}\u{441}\u{44F} ${issue.expected}, \u{430}\u{442}\u{440}\u{44B}\u{43C}\u{430}\u{43D}\u{430} ${parsedType(issue.input)}`;
            case "invalid_value":
                if (issue.values.length === 1) return `\u{41D}\u{44F}\u{43F}\u{440}\u{430}\u{432}\u{456}\u{43B}\u{44C}\u{43D}\u{44B} \u{45E}\u{432}\u{43E}\u{434}: \u{447}\u{430}\u{43A}\u{430}\u{43B}\u{430}\u{441}\u{44F} ${$8f5391358ccbeba2$export$5859860f650378f4(issue.values[0])}`;
                return `\u{41D}\u{44F}\u{43F}\u{440}\u{430}\u{432}\u{456}\u{43B}\u{44C}\u{43D}\u{44B} \u{432}\u{430}\u{440}\u{44B}\u{44F}\u{43D}\u{442}: \u{447}\u{430}\u{43A}\u{430}\u{45E}\u{441}\u{44F} \u{430}\u{434}\u{437}\u{456}\u{43D} \u{437} ${$8f5391358ccbeba2$export$e79b744344f50f50(issue.values, "|")}`;
            case "too_big":
                {
                    const adj = issue.inclusive ? "<=" : "<";
                    const sizing = getSizing(issue.origin);
                    if (sizing) {
                        const maxValue = Number(issue.maximum);
                        const unit = $772fd2a92c056b8f$var$getBelarusianPlural(maxValue, sizing.unit.one, sizing.unit.few, sizing.unit.many);
                        return `\u{417}\u{430}\u{43D}\u{430}\u{434}\u{442}\u{430} \u{432}\u{44F}\u{43B}\u{456}\u{43A}\u{456}: \u{447}\u{430}\u{43A}\u{430}\u{43B}\u{430}\u{441}\u{44F}, \u{448}\u{442}\u{43E} ${issue.origin ?? "\u0437\u043D\u0430\u0447\u044D\u043D\u043D\u0435"} \u{43F}\u{430}\u{432}\u{456}\u{43D}\u{43D}\u{430} ${sizing.verb} ${adj}${issue.maximum.toString()} ${unit}`;
                    }
                    return `\u{417}\u{430}\u{43D}\u{430}\u{434}\u{442}\u{430} \u{432}\u{44F}\u{43B}\u{456}\u{43A}\u{456}: \u{447}\u{430}\u{43A}\u{430}\u{43B}\u{430}\u{441}\u{44F}, \u{448}\u{442}\u{43E} ${issue.origin ?? "\u0437\u043D\u0430\u0447\u044D\u043D\u043D\u0435"} \u{43F}\u{430}\u{432}\u{456}\u{43D}\u{43D}\u{430} \u{431}\u{44B}\u{446}\u{44C} ${adj}${issue.maximum.toString()}`;
                }
            case "too_small":
                {
                    const adj = issue.inclusive ? ">=" : ">";
                    const sizing = getSizing(issue.origin);
                    if (sizing) {
                        const minValue = Number(issue.minimum);
                        const unit = $772fd2a92c056b8f$var$getBelarusianPlural(minValue, sizing.unit.one, sizing.unit.few, sizing.unit.many);
                        return `\u{417}\u{430}\u{43D}\u{430}\u{434}\u{442}\u{430} \u{43C}\u{430}\u{43B}\u{44B}: \u{447}\u{430}\u{43A}\u{430}\u{43B}\u{430}\u{441}\u{44F}, \u{448}\u{442}\u{43E} ${issue.origin} \u{43F}\u{430}\u{432}\u{456}\u{43D}\u{43D}\u{430} ${sizing.verb} ${adj}${issue.minimum.toString()} ${unit}`;
                    }
                    return `\u{417}\u{430}\u{43D}\u{430}\u{434}\u{442}\u{430} \u{43C}\u{430}\u{43B}\u{44B}: \u{447}\u{430}\u{43A}\u{430}\u{43B}\u{430}\u{441}\u{44F}, \u{448}\u{442}\u{43E} ${issue.origin} \u{43F}\u{430}\u{432}\u{456}\u{43D}\u{43D}\u{430} \u{431}\u{44B}\u{446}\u{44C} ${adj}${issue.minimum.toString()}`;
                }
            case "invalid_format":
                {
                    const _issue = issue;
                    if (_issue.format === "starts_with") return `\u{41D}\u{44F}\u{43F}\u{440}\u{430}\u{432}\u{456}\u{43B}\u{44C}\u{43D}\u{44B} \u{440}\u{430}\u{434}\u{43E}\u{43A}: \u{43F}\u{430}\u{432}\u{456}\u{43D}\u{435}\u{43D} \u{43F}\u{430}\u{447}\u{44B}\u{43D}\u{430}\u{446}\u{446}\u{430} \u{437} "${_issue.prefix}"`;
                    if (_issue.format === "ends_with") return `\u{41D}\u{44F}\u{43F}\u{440}\u{430}\u{432}\u{456}\u{43B}\u{44C}\u{43D}\u{44B} \u{440}\u{430}\u{434}\u{43E}\u{43A}: \u{43F}\u{430}\u{432}\u{456}\u{43D}\u{435}\u{43D} \u{437}\u{430}\u{43A}\u{430}\u{43D}\u{447}\u{432}\u{430}\u{446}\u{446}\u{430} \u{43D}\u{430} "${_issue.suffix}"`;
                    if (_issue.format === "includes") return `\u{41D}\u{44F}\u{43F}\u{440}\u{430}\u{432}\u{456}\u{43B}\u{44C}\u{43D}\u{44B} \u{440}\u{430}\u{434}\u{43E}\u{43A}: \u{43F}\u{430}\u{432}\u{456}\u{43D}\u{435}\u{43D} \u{437}\u{43C}\u{44F}\u{448}\u{447}\u{430}\u{446}\u{44C} "${_issue.includes}"`;
                    if (_issue.format === "regex") return `\u{41D}\u{44F}\u{43F}\u{440}\u{430}\u{432}\u{456}\u{43B}\u{44C}\u{43D}\u{44B} \u{440}\u{430}\u{434}\u{43E}\u{43A}: \u{43F}\u{430}\u{432}\u{456}\u{43D}\u{435}\u{43D} \u{430}\u{434}\u{43F}\u{430}\u{432}\u{44F}\u{434}\u{430}\u{446}\u{44C} \u{448}\u{430}\u{431}\u{43B}\u{43E}\u{43D}\u{443} ${_issue.pattern}`;
                    return `\u{41D}\u{44F}\u{43F}\u{440}\u{430}\u{432}\u{456}\u{43B}\u{44C}\u{43D}\u{44B} ${Nouns[_issue.format] ?? issue.format}`;
                }
            case "not_multiple_of":
                return `\u{41D}\u{44F}\u{43F}\u{440}\u{430}\u{432}\u{456}\u{43B}\u{44C}\u{43D}\u{44B} \u{43B}\u{456}\u{43A}: \u{43F}\u{430}\u{432}\u{456}\u{43D}\u{435}\u{43D} \u{431}\u{44B}\u{446}\u{44C} \u{43A}\u{440}\u{430}\u{442}\u{43D}\u{44B}\u{43C} ${issue.divisor}`;
            case "unrecognized_keys":
                return `\u{41D}\u{435}\u{440}\u{430}\u{441}\u{43F}\u{430}\u{437}\u{43D}\u{430}\u{43D}\u{44B} ${issue.keys.length > 1 ? "\u043A\u043B\u044E\u0447\u044B" : "\u043A\u043B\u044E\u0447"}: ${$8f5391358ccbeba2$export$e79b744344f50f50(issue.keys, ", ")}`;
            case "invalid_key":
                return `\u{41D}\u{44F}\u{43F}\u{440}\u{430}\u{432}\u{456}\u{43B}\u{44C}\u{43D}\u{44B} \u{43A}\u{43B}\u{44E}\u{447} \u{443} ${issue.origin}`;
            case "invalid_union":
                return "\u041D\u044F\u043F\u0440\u0430\u0432\u0456\u043B\u044C\u043D\u044B \u045E\u0432\u043E\u0434";
            case "invalid_element":
                return `\u{41D}\u{44F}\u{43F}\u{440}\u{430}\u{432}\u{456}\u{43B}\u{44C}\u{43D}\u{430}\u{435} \u{437}\u{43D}\u{430}\u{447}\u{44D}\u{43D}\u{43D}\u{435} \u{45E} ${issue.origin}`;
            default:
                return `\u{41D}\u{44F}\u{43F}\u{440}\u{430}\u{432}\u{456}\u{43B}\u{44C}\u{43D}\u{44B} \u{45E}\u{432}\u{43E}\u{434}`;
        }
    };
};
function $772fd2a92c056b8f$export$2e2bcd8739ae039() {
    return {
        localeError: $772fd2a92c056b8f$var$error()
    };
}



const $a87838b8685dd93c$export$858d360cf6da2b65 = (data)=>{
    const t = typeof data;
    switch(t){
        case "number":
            return Number.isNaN(data) ? "NaN" : "\u0447\u0438\u0441\u043B\u043E";
        case "object":
            if (Array.isArray(data)) return "\u043C\u0430\u0441\u0438\u0432";
            if (data === null) return "null";
            if (Object.getPrototypeOf(data) !== Object.prototype && data.constructor) return data.constructor.name;
    }
    return t;
};
const $a87838b8685dd93c$var$error = ()=>{
    const Sizable = {
        string: {
            unit: "\u0441\u0438\u043C\u0432\u043E\u043B\u0430",
            verb: "\u0434\u0430 \u0441\u044A\u0434\u044A\u0440\u0436\u0430"
        },
        file: {
            unit: "\u0431\u0430\u0439\u0442\u0430",
            verb: "\u0434\u0430 \u0441\u044A\u0434\u044A\u0440\u0436\u0430"
        },
        array: {
            unit: "\u0435\u043B\u0435\u043C\u0435\u043D\u0442\u0430",
            verb: "\u0434\u0430 \u0441\u044A\u0434\u044A\u0440\u0436\u0430"
        },
        set: {
            unit: "\u0435\u043B\u0435\u043C\u0435\u043D\u0442\u0430",
            verb: "\u0434\u0430 \u0441\u044A\u0434\u044A\u0440\u0436\u0430"
        }
    };
    function getSizing(origin) {
        return Sizable[origin] ?? null;
    }
    const Nouns = {
        regex: "\u0432\u0445\u043E\u0434",
        email: "\u0438\u043C\u0435\u0439\u043B \u0430\u0434\u0440\u0435\u0441",
        url: "URL",
        emoji: "\u0435\u043C\u043E\u0434\u0436\u0438",
        uuid: "UUID",
        uuidv4: "UUIDv4",
        uuidv6: "UUIDv6",
        nanoid: "nanoid",
        guid: "GUID",
        cuid: "cuid",
        cuid2: "cuid2",
        ulid: "ULID",
        xid: "XID",
        ksuid: "KSUID",
        datetime: "ISO \u0432\u0440\u0435\u043C\u0435",
        date: "ISO \u0434\u0430\u0442\u0430",
        time: "ISO \u0432\u0440\u0435\u043C\u0435",
        duration: "ISO \u043F\u0440\u043E\u0434\u044A\u043B\u0436\u0438\u0442\u0435\u043B\u043D\u043E\u0441\u0442",
        ipv4: "IPv4 \u0430\u0434\u0440\u0435\u0441",
        ipv6: "IPv6 \u0430\u0434\u0440\u0435\u0441",
        cidrv4: "IPv4 \u0434\u0438\u0430\u043F\u0430\u0437\u043E\u043D",
        cidrv6: "IPv6 \u0434\u0438\u0430\u043F\u0430\u0437\u043E\u043D",
        base64: "base64-\u043A\u043E\u0434\u0438\u0440\u0430\u043D \u043D\u0438\u0437",
        base64url: "base64url-\u043A\u043E\u0434\u0438\u0440\u0430\u043D \u043D\u0438\u0437",
        json_string: "JSON \u043D\u0438\u0437",
        e164: "E.164 \u043D\u043E\u043C\u0435\u0440",
        jwt: "JWT",
        template_literal: "\u0432\u0445\u043E\u0434"
    };
    return (issue)=>{
        switch(issue.code){
            case "invalid_type":
                return `\u{41D}\u{435}\u{432}\u{430}\u{43B}\u{438}\u{434}\u{435}\u{43D} \u{432}\u{445}\u{43E}\u{434}: \u{43E}\u{447}\u{430}\u{43A}\u{432}\u{430}\u{43D} ${issue.expected}, \u{43F}\u{43E}\u{43B}\u{443}\u{447}\u{435}\u{43D} ${$a87838b8685dd93c$export$858d360cf6da2b65(issue.input)}`;
            case "invalid_value":
                if (issue.values.length === 1) return `\u{41D}\u{435}\u{432}\u{430}\u{43B}\u{438}\u{434}\u{435}\u{43D} \u{432}\u{445}\u{43E}\u{434}: \u{43E}\u{447}\u{430}\u{43A}\u{432}\u{430}\u{43D} ${$8f5391358ccbeba2$export$5859860f650378f4(issue.values[0])}`;
                return `\u{41D}\u{435}\u{432}\u{430}\u{43B}\u{438}\u{434}\u{43D}\u{430} \u{43E}\u{43F}\u{446}\u{438}\u{44F}: \u{43E}\u{447}\u{430}\u{43A}\u{432}\u{430}\u{43D}\u{43E} \u{435}\u{434}\u{43D}\u{43E} \u{43E}\u{442} ${$8f5391358ccbeba2$export$e79b744344f50f50(issue.values, "|")}`;
            case "too_big":
                {
                    const adj = issue.inclusive ? "<=" : "<";
                    const sizing = getSizing(issue.origin);
                    if (sizing) return `\u{422}\u{432}\u{44A}\u{440}\u{434}\u{435} \u{433}\u{43E}\u{43B}\u{44F}\u{43C}\u{43E}: \u{43E}\u{447}\u{430}\u{43A}\u{432}\u{430} \u{441}\u{435} ${issue.origin ?? "\u0441\u0442\u043E\u0439\u043D\u043E\u0441\u0442"} \u{434}\u{430} \u{441}\u{44A}\u{434}\u{44A}\u{440}\u{436}\u{430} ${adj}${issue.maximum.toString()} ${sizing.unit ?? "\u0435\u043B\u0435\u043C\u0435\u043D\u0442\u0430"}`;
                    return `\u{422}\u{432}\u{44A}\u{440}\u{434}\u{435} \u{433}\u{43E}\u{43B}\u{44F}\u{43C}\u{43E}: \u{43E}\u{447}\u{430}\u{43A}\u{432}\u{430} \u{441}\u{435} ${issue.origin ?? "\u0441\u0442\u043E\u0439\u043D\u043E\u0441\u0442"} \u{434}\u{430} \u{431}\u{44A}\u{434}\u{435} ${adj}${issue.maximum.toString()}`;
                }
            case "too_small":
                {
                    const adj = issue.inclusive ? ">=" : ">";
                    const sizing = getSizing(issue.origin);
                    if (sizing) return `\u{422}\u{432}\u{44A}\u{440}\u{434}\u{435} \u{43C}\u{430}\u{43B}\u{43A}\u{43E}: \u{43E}\u{447}\u{430}\u{43A}\u{432}\u{430} \u{441}\u{435} ${issue.origin} \u{434}\u{430} \u{441}\u{44A}\u{434}\u{44A}\u{440}\u{436}\u{430} ${adj}${issue.minimum.toString()} ${sizing.unit}`;
                    return `\u{422}\u{432}\u{44A}\u{440}\u{434}\u{435} \u{43C}\u{430}\u{43B}\u{43A}\u{43E}: \u{43E}\u{447}\u{430}\u{43A}\u{432}\u{430} \u{441}\u{435} ${issue.origin} \u{434}\u{430} \u{431}\u{44A}\u{434}\u{435} ${adj}${issue.minimum.toString()}`;
                }
            case "invalid_format":
                {
                    const _issue = issue;
                    if (_issue.format === "starts_with") return `\u{41D}\u{435}\u{432}\u{430}\u{43B}\u{438}\u{434}\u{435}\u{43D} \u{43D}\u{438}\u{437}: \u{442}\u{440}\u{44F}\u{431}\u{432}\u{430} \u{434}\u{430} \u{437}\u{430}\u{43F}\u{43E}\u{447}\u{432}\u{430} \u{441} "${_issue.prefix}"`;
                    if (_issue.format === "ends_with") return `\u{41D}\u{435}\u{432}\u{430}\u{43B}\u{438}\u{434}\u{435}\u{43D} \u{43D}\u{438}\u{437}: \u{442}\u{440}\u{44F}\u{431}\u{432}\u{430} \u{434}\u{430} \u{437}\u{430}\u{432}\u{44A}\u{440}\u{448}\u{432}\u{430} \u{441} "${_issue.suffix}"`;
                    if (_issue.format === "includes") return `\u{41D}\u{435}\u{432}\u{430}\u{43B}\u{438}\u{434}\u{435}\u{43D} \u{43D}\u{438}\u{437}: \u{442}\u{440}\u{44F}\u{431}\u{432}\u{430} \u{434}\u{430} \u{432}\u{43A}\u{43B}\u{44E}\u{447}\u{432}\u{430} "${_issue.includes}"`;
                    if (_issue.format === "regex") return `\u{41D}\u{435}\u{432}\u{430}\u{43B}\u{438}\u{434}\u{435}\u{43D} \u{43D}\u{438}\u{437}: \u{442}\u{440}\u{44F}\u{431}\u{432}\u{430} \u{434}\u{430} \u{441}\u{44A}\u{432}\u{43F}\u{430}\u{434}\u{430} \u{441} ${_issue.pattern}`;
                    let invalid_adj = "\u041D\u0435\u0432\u0430\u043B\u0438\u0434\u0435\u043D";
                    if (_issue.format === "emoji") invalid_adj = "\u041D\u0435\u0432\u0430\u043B\u0438\u0434\u043D\u043E";
                    if (_issue.format === "datetime") invalid_adj = "\u041D\u0435\u0432\u0430\u043B\u0438\u0434\u043D\u043E";
                    if (_issue.format === "date") invalid_adj = "\u041D\u0435\u0432\u0430\u043B\u0438\u0434\u043D\u0430";
                    if (_issue.format === "time") invalid_adj = "\u041D\u0435\u0432\u0430\u043B\u0438\u0434\u043D\u043E";
                    if (_issue.format === "duration") invalid_adj = "\u041D\u0435\u0432\u0430\u043B\u0438\u0434\u043D\u0430";
                    return `${invalid_adj} ${Nouns[_issue.format] ?? issue.format}`;
                }
            case "not_multiple_of":
                return `\u{41D}\u{435}\u{432}\u{430}\u{43B}\u{438}\u{434}\u{43D}\u{43E} \u{447}\u{438}\u{441}\u{43B}\u{43E}: \u{442}\u{440}\u{44F}\u{431}\u{432}\u{430} \u{434}\u{430} \u{431}\u{44A}\u{434}\u{435} \u{43A}\u{440}\u{430}\u{442}\u{43D}\u{43E} \u{43D}\u{430} ${issue.divisor}`;
            case "unrecognized_keys":
                return `\u{41D}\u{435}\u{440}\u{430}\u{437}\u{43F}\u{43E}\u{437}\u{43D}\u{430}\u{442}${issue.keys.length > 1 ? "\u0438" : ""} \u{43A}\u{43B}\u{44E}\u{447}${issue.keys.length > 1 ? "\u043E\u0432\u0435" : ""}: ${$8f5391358ccbeba2$export$e79b744344f50f50(issue.keys, ", ")}`;
            case "invalid_key":
                return `\u{41D}\u{435}\u{432}\u{430}\u{43B}\u{438}\u{434}\u{435}\u{43D} \u{43A}\u{43B}\u{44E}\u{447} \u{432} ${issue.origin}`;
            case "invalid_union":
                return "\u041D\u0435\u0432\u0430\u043B\u0438\u0434\u0435\u043D \u0432\u0445\u043E\u0434";
            case "invalid_element":
                return `\u{41D}\u{435}\u{432}\u{430}\u{43B}\u{438}\u{434}\u{43D}\u{430} \u{441}\u{442}\u{43E}\u{439}\u{43D}\u{43E}\u{441}\u{442} \u{432} ${issue.origin}`;
            default:
                return `\u{41D}\u{435}\u{432}\u{430}\u{43B}\u{438}\u{434}\u{435}\u{43D} \u{432}\u{445}\u{43E}\u{434}`;
        }
    };
};
function $a87838b8685dd93c$export$2e2bcd8739ae039() {
    return {
        localeError: $a87838b8685dd93c$var$error()
    };
}



const $14f86b1341ff0e92$var$error = ()=>{
    const Sizable = {
        string: {
            unit: "car\xe0cters",
            verb: "contenir"
        },
        file: {
            unit: "bytes",
            verb: "contenir"
        },
        array: {
            unit: "elements",
            verb: "contenir"
        },
        set: {
            unit: "elements",
            verb: "contenir"
        }
    };
    function getSizing(origin) {
        return Sizable[origin] ?? null;
    }
    const parsedType = (data)=>{
        const t = typeof data;
        switch(t){
            case "number":
                return Number.isNaN(data) ? "NaN" : "number";
            case "object":
                if (Array.isArray(data)) return "array";
                if (data === null) return "null";
                if (Object.getPrototypeOf(data) !== Object.prototype && data.constructor) return data.constructor.name;
        }
        return t;
    };
    const Nouns = {
        regex: "entrada",
        email: "adre\xe7a electr\xf2nica",
        url: "URL",
        emoji: "emoji",
        uuid: "UUID",
        uuidv4: "UUIDv4",
        uuidv6: "UUIDv6",
        nanoid: "nanoid",
        guid: "GUID",
        cuid: "cuid",
        cuid2: "cuid2",
        ulid: "ULID",
        xid: "XID",
        ksuid: "KSUID",
        datetime: "data i hora ISO",
        date: "data ISO",
        time: "hora ISO",
        duration: "durada ISO",
        ipv4: "adre\xe7a IPv4",
        ipv6: "adre\xe7a IPv6",
        cidrv4: "rang IPv4",
        cidrv6: "rang IPv6",
        base64: "cadena codificada en base64",
        base64url: "cadena codificada en base64url",
        json_string: "cadena JSON",
        e164: "n\xfamero E.164",
        jwt: "JWT",
        template_literal: "entrada"
    };
    return (issue)=>{
        switch(issue.code){
            case "invalid_type":
                return `Tipus inv\xe0lid: s'esperava ${issue.expected}, s'ha rebut ${parsedType(issue.input)}`;
            // return `Tipus invàlid: s'esperava ${issue.expected}, s'ha rebut ${util.getParsedType(issue.input)}`;
            case "invalid_value":
                if (issue.values.length === 1) return `Valor inv\xe0lid: s'esperava ${$8f5391358ccbeba2$export$5859860f650378f4(issue.values[0])}`;
                return `Opci\xf3 inv\xe0lida: s'esperava una de ${$8f5391358ccbeba2$export$e79b744344f50f50(issue.values, " o ")}`;
            case "too_big":
                {
                    const adj = issue.inclusive ? "com a m\xe0xim" : "menys de";
                    const sizing = getSizing(issue.origin);
                    if (sizing) return `Massa gran: s'esperava que ${issue.origin ?? "el valor"} contingu\xe9s ${adj} ${issue.maximum.toString()} ${sizing.unit ?? "elements"}`;
                    return `Massa gran: s'esperava que ${issue.origin ?? "el valor"} fos ${adj} ${issue.maximum.toString()}`;
                }
            case "too_small":
                {
                    const adj = issue.inclusive ? "com a m\xednim" : "m\xe9s de";
                    const sizing = getSizing(issue.origin);
                    if (sizing) return `Massa petit: s'esperava que ${issue.origin} contingu\xe9s ${adj} ${issue.minimum.toString()} ${sizing.unit}`;
                    return `Massa petit: s'esperava que ${issue.origin} fos ${adj} ${issue.minimum.toString()}`;
                }
            case "invalid_format":
                {
                    const _issue = issue;
                    if (_issue.format === "starts_with") return `Format inv\xe0lid: ha de comen\xe7ar amb "${_issue.prefix}"`;
                    if (_issue.format === "ends_with") return `Format inv\xe0lid: ha d'acabar amb "${_issue.suffix}"`;
                    if (_issue.format === "includes") return `Format inv\xe0lid: ha d'incloure "${_issue.includes}"`;
                    if (_issue.format === "regex") return `Format inv\xe0lid: ha de coincidir amb el patr\xf3 ${_issue.pattern}`;
                    return `Format inv\xe0lid per a ${Nouns[_issue.format] ?? issue.format}`;
                }
            case "not_multiple_of":
                return `N\xfamero inv\xe0lid: ha de ser m\xfaltiple de ${issue.divisor}`;
            case "unrecognized_keys":
                return `Clau${issue.keys.length > 1 ? "s" : ""} no reconeguda${issue.keys.length > 1 ? "s" : ""}: ${$8f5391358ccbeba2$export$e79b744344f50f50(issue.keys, ", ")}`;
            case "invalid_key":
                return `Clau inv\xe0lida a ${issue.origin}`;
            case "invalid_union":
                return "Entrada inv\xe0lida"; // Could also be "Tipus d'unió invàlid" but "Entrada invàlida" is more general
            case "invalid_element":
                return `Element inv\xe0lid a ${issue.origin}`;
            default:
                return `Entrada inv\xe0lida`;
        }
    };
};
function $14f86b1341ff0e92$export$2e2bcd8739ae039() {
    return {
        localeError: $14f86b1341ff0e92$var$error()
    };
}



const $777d05de3f5acbae$var$error = ()=>{
    const Sizable = {
        string: {
            unit: "znak\u016F",
            verb: "m\xedt"
        },
        file: {
            unit: "bajt\u016F",
            verb: "m\xedt"
        },
        array: {
            unit: "prvk\u016F",
            verb: "m\xedt"
        },
        set: {
            unit: "prvk\u016F",
            verb: "m\xedt"
        }
    };
    function getSizing(origin) {
        return Sizable[origin] ?? null;
    }
    const parsedType = (data)=>{
        const t = typeof data;
        switch(t){
            case "number":
                return Number.isNaN(data) ? "NaN" : "\u010D\xedslo";
            case "string":
                return "\u0159et\u011Bzec";
            case "boolean":
                return "boolean";
            case "bigint":
                return "bigint";
            case "function":
                return "funkce";
            case "symbol":
                return "symbol";
            case "undefined":
                return "undefined";
            case "object":
                if (Array.isArray(data)) return "pole";
                if (data === null) return "null";
                if (Object.getPrototypeOf(data) !== Object.prototype && data.constructor) return data.constructor.name;
        }
        return t;
    };
    const Nouns = {
        regex: "regul\xe1rn\xed v\xfdraz",
        email: "e-mailov\xe1 adresa",
        url: "URL",
        emoji: "emoji",
        uuid: "UUID",
        uuidv4: "UUIDv4",
        uuidv6: "UUIDv6",
        nanoid: "nanoid",
        guid: "GUID",
        cuid: "cuid",
        cuid2: "cuid2",
        ulid: "ULID",
        xid: "XID",
        ksuid: "KSUID",
        datetime: "datum a \u010Das ve form\xe1tu ISO",
        date: "datum ve form\xe1tu ISO",
        time: "\u010Das ve form\xe1tu ISO",
        duration: "doba trv\xe1n\xed ISO",
        ipv4: "IPv4 adresa",
        ipv6: "IPv6 adresa",
        cidrv4: "rozsah IPv4",
        cidrv6: "rozsah IPv6",
        base64: "\u0159et\u011Bzec zak\xf3dovan\xfd ve form\xe1tu base64",
        base64url: "\u0159et\u011Bzec zak\xf3dovan\xfd ve form\xe1tu base64url",
        json_string: "\u0159et\u011Bzec ve form\xe1tu JSON",
        e164: "\u010D\xedslo E.164",
        jwt: "JWT",
        template_literal: "vstup"
    };
    return (issue)=>{
        switch(issue.code){
            case "invalid_type":
                return `Neplatn\xfd vstup: o\u{10D}ek\xe1v\xe1no ${issue.expected}, obdr\u{17E}eno ${parsedType(issue.input)}`;
            case "invalid_value":
                if (issue.values.length === 1) return `Neplatn\xfd vstup: o\u{10D}ek\xe1v\xe1no ${$8f5391358ccbeba2$export$5859860f650378f4(issue.values[0])}`;
                return `Neplatn\xe1 mo\u{17E}nost: o\u{10D}ek\xe1v\xe1na jedna z hodnot ${$8f5391358ccbeba2$export$e79b744344f50f50(issue.values, "|")}`;
            case "too_big":
                {
                    const adj = issue.inclusive ? "<=" : "<";
                    const sizing = getSizing(issue.origin);
                    if (sizing) return `Hodnota je p\u{159}\xedli\u{161} velk\xe1: ${issue.origin ?? "hodnota"} mus\xed m\xedt ${adj}${issue.maximum.toString()} ${sizing.unit ?? "prvk\u016F"}`;
                    return `Hodnota je p\u{159}\xedli\u{161} velk\xe1: ${issue.origin ?? "hodnota"} mus\xed b\xfdt ${adj}${issue.maximum.toString()}`;
                }
            case "too_small":
                {
                    const adj = issue.inclusive ? ">=" : ">";
                    const sizing = getSizing(issue.origin);
                    if (sizing) return `Hodnota je p\u{159}\xedli\u{161} mal\xe1: ${issue.origin ?? "hodnota"} mus\xed m\xedt ${adj}${issue.minimum.toString()} ${sizing.unit ?? "prvk\u016F"}`;
                    return `Hodnota je p\u{159}\xedli\u{161} mal\xe1: ${issue.origin ?? "hodnota"} mus\xed b\xfdt ${adj}${issue.minimum.toString()}`;
                }
            case "invalid_format":
                {
                    const _issue = issue;
                    if (_issue.format === "starts_with") return `Neplatn\xfd \u{159}et\u{11B}zec: mus\xed za\u{10D}\xednat na "${_issue.prefix}"`;
                    if (_issue.format === "ends_with") return `Neplatn\xfd \u{159}et\u{11B}zec: mus\xed kon\u{10D}it na "${_issue.suffix}"`;
                    if (_issue.format === "includes") return `Neplatn\xfd \u{159}et\u{11B}zec: mus\xed obsahovat "${_issue.includes}"`;
                    if (_issue.format === "regex") return `Neplatn\xfd \u{159}et\u{11B}zec: mus\xed odpov\xeddat vzoru ${_issue.pattern}`;
                    return `Neplatn\xfd form\xe1t ${Nouns[_issue.format] ?? issue.format}`;
                }
            case "not_multiple_of":
                return `Neplatn\xe9 \u{10D}\xedslo: mus\xed b\xfdt n\xe1sobkem ${issue.divisor}`;
            case "unrecognized_keys":
                return `Nezn\xe1m\xe9 kl\xed\u{10D}e: ${$8f5391358ccbeba2$export$e79b744344f50f50(issue.keys, ", ")}`;
            case "invalid_key":
                return `Neplatn\xfd kl\xed\u{10D} v ${issue.origin}`;
            case "invalid_union":
                return "Neplatn\xfd vstup";
            case "invalid_element":
                return `Neplatn\xe1 hodnota v ${issue.origin}`;
            default:
                return `Neplatn\xfd vstup`;
        }
    };
};
function $777d05de3f5acbae$export$2e2bcd8739ae039() {
    return {
        localeError: $777d05de3f5acbae$var$error()
    };
}



const $fef376cc75450a25$var$error = ()=>{
    const Sizable = {
        string: {
            unit: "tegn",
            verb: "havde"
        },
        file: {
            unit: "bytes",
            verb: "havde"
        },
        array: {
            unit: "elementer",
            verb: "indeholdt"
        },
        set: {
            unit: "elementer",
            verb: "indeholdt"
        }
    };
    const TypeNames = {
        string: "streng",
        number: "tal",
        boolean: "boolean",
        array: "liste",
        object: "objekt",
        set: "s\xe6t",
        file: "fil"
    };
    function getSizing(origin) {
        return Sizable[origin] ?? null;
    }
    function getTypeName(type) {
        return TypeNames[type] ?? type;
    }
    const parsedType = (data)=>{
        const t = typeof data;
        switch(t){
            case "number":
                return Number.isNaN(data) ? "NaN" : "tal";
            case "object":
                if (Array.isArray(data)) return "liste";
                if (data === null) return "null";
                if (Object.getPrototypeOf(data) !== Object.prototype && data.constructor) return data.constructor.name;
                return "objekt";
        }
        return t;
    };
    const Nouns = {
        regex: "input",
        email: "e-mailadresse",
        url: "URL",
        emoji: "emoji",
        uuid: "UUID",
        uuidv4: "UUIDv4",
        uuidv6: "UUIDv6",
        nanoid: "nanoid",
        guid: "GUID",
        cuid: "cuid",
        cuid2: "cuid2",
        ulid: "ULID",
        xid: "XID",
        ksuid: "KSUID",
        datetime: "ISO dato- og klokkesl\xe6t",
        date: "ISO-dato",
        time: "ISO-klokkesl\xe6t",
        duration: "ISO-varighed",
        ipv4: "IPv4-omr\xe5de",
        ipv6: "IPv6-omr\xe5de",
        cidrv4: "IPv4-spektrum",
        cidrv6: "IPv6-spektrum",
        base64: "base64-kodet streng",
        base64url: "base64url-kodet streng",
        json_string: "JSON-streng",
        e164: "E.164-nummer",
        jwt: "JWT",
        template_literal: "input"
    };
    return (issue)=>{
        switch(issue.code){
            case "invalid_type":
                return `Ugyldigt input: forventede ${getTypeName(issue.expected)}, fik ${getTypeName(parsedType(issue.input))}`;
            case "invalid_value":
                if (issue.values.length === 1) return `Ugyldig v\xe6rdi: forventede ${$8f5391358ccbeba2$export$5859860f650378f4(issue.values[0])}`;
                return `Ugyldigt valg: forventede en af f\xf8lgende ${$8f5391358ccbeba2$export$e79b744344f50f50(issue.values, "|")}`;
            case "too_big":
                {
                    const adj = issue.inclusive ? "<=" : "<";
                    const sizing = getSizing(issue.origin);
                    const origin = getTypeName(issue.origin);
                    if (sizing) return `For stor: forventede ${origin ?? "value"} ${sizing.verb} ${adj} ${issue.maximum.toString()} ${sizing.unit ?? "elementer"}`;
                    return `For stor: forventede ${origin ?? "value"} havde ${adj} ${issue.maximum.toString()}`;
                }
            case "too_small":
                {
                    const adj = issue.inclusive ? ">=" : ">";
                    const sizing = getSizing(issue.origin);
                    const origin = getTypeName(issue.origin);
                    if (sizing) return `For lille: forventede ${origin} ${sizing.verb} ${adj} ${issue.minimum.toString()} ${sizing.unit}`;
                    return `For lille: forventede ${origin} havde ${adj} ${issue.minimum.toString()}`;
                }
            case "invalid_format":
                {
                    const _issue = issue;
                    if (_issue.format === "starts_with") return `Ugyldig streng: skal starte med "${_issue.prefix}"`;
                    if (_issue.format === "ends_with") return `Ugyldig streng: skal ende med "${_issue.suffix}"`;
                    if (_issue.format === "includes") return `Ugyldig streng: skal indeholde "${_issue.includes}"`;
                    if (_issue.format === "regex") return `Ugyldig streng: skal matche m\xf8nsteret ${_issue.pattern}`;
                    return `Ugyldig ${Nouns[_issue.format] ?? issue.format}`;
                }
            case "not_multiple_of":
                return `Ugyldigt tal: skal v\xe6re deleligt med ${issue.divisor}`;
            case "unrecognized_keys":
                return `${issue.keys.length > 1 ? "Ukendte n\xf8gler" : "Ukendt n\xf8gle"}: ${$8f5391358ccbeba2$export$e79b744344f50f50(issue.keys, ", ")}`;
            case "invalid_key":
                return `Ugyldig n\xf8gle i ${issue.origin}`;
            case "invalid_union":
                return "Ugyldigt input: matcher ingen af de tilladte typer";
            case "invalid_element":
                return `Ugyldig v\xe6rdi i ${issue.origin}`;
            default:
                return `Ugyldigt input`;
        }
    };
};
function $fef376cc75450a25$export$2e2bcd8739ae039() {
    return {
        localeError: $fef376cc75450a25$var$error()
    };
}



const $c9f7287ecfa25847$var$error = ()=>{
    const Sizable = {
        string: {
            unit: "Zeichen",
            verb: "zu haben"
        },
        file: {
            unit: "Bytes",
            verb: "zu haben"
        },
        array: {
            unit: "Elemente",
            verb: "zu haben"
        },
        set: {
            unit: "Elemente",
            verb: "zu haben"
        }
    };
    function getSizing(origin) {
        return Sizable[origin] ?? null;
    }
    const parsedType = (data)=>{
        const t = typeof data;
        switch(t){
            case "number":
                return Number.isNaN(data) ? "NaN" : "Zahl";
            case "object":
                if (Array.isArray(data)) return "Array";
                if (data === null) return "null";
                if (Object.getPrototypeOf(data) !== Object.prototype && data.constructor) return data.constructor.name;
        }
        return t;
    };
    const Nouns = {
        regex: "Eingabe",
        email: "E-Mail-Adresse",
        url: "URL",
        emoji: "Emoji",
        uuid: "UUID",
        uuidv4: "UUIDv4",
        uuidv6: "UUIDv6",
        nanoid: "nanoid",
        guid: "GUID",
        cuid: "cuid",
        cuid2: "cuid2",
        ulid: "ULID",
        xid: "XID",
        ksuid: "KSUID",
        datetime: "ISO-Datum und -Uhrzeit",
        date: "ISO-Datum",
        time: "ISO-Uhrzeit",
        duration: "ISO-Dauer",
        ipv4: "IPv4-Adresse",
        ipv6: "IPv6-Adresse",
        cidrv4: "IPv4-Bereich",
        cidrv6: "IPv6-Bereich",
        base64: "Base64-codierter String",
        base64url: "Base64-URL-codierter String",
        json_string: "JSON-String",
        e164: "E.164-Nummer",
        jwt: "JWT",
        template_literal: "Eingabe"
    };
    return (issue)=>{
        switch(issue.code){
            case "invalid_type":
                return `Ung\xfcltige Eingabe: erwartet ${issue.expected}, erhalten ${parsedType(issue.input)}`;
            case "invalid_value":
                if (issue.values.length === 1) return `Ung\xfcltige Eingabe: erwartet ${$8f5391358ccbeba2$export$5859860f650378f4(issue.values[0])}`;
                return `Ung\xfcltige Option: erwartet eine von ${$8f5391358ccbeba2$export$e79b744344f50f50(issue.values, "|")}`;
            case "too_big":
                {
                    const adj = issue.inclusive ? "<=" : "<";
                    const sizing = getSizing(issue.origin);
                    if (sizing) return `Zu gro\xdf: erwartet, dass ${issue.origin ?? "Wert"} ${adj}${issue.maximum.toString()} ${sizing.unit ?? "Elemente"} hat`;
                    return `Zu gro\xdf: erwartet, dass ${issue.origin ?? "Wert"} ${adj}${issue.maximum.toString()} ist`;
                }
            case "too_small":
                {
                    const adj = issue.inclusive ? ">=" : ">";
                    const sizing = getSizing(issue.origin);
                    if (sizing) return `Zu klein: erwartet, dass ${issue.origin} ${adj}${issue.minimum.toString()} ${sizing.unit} hat`;
                    return `Zu klein: erwartet, dass ${issue.origin} ${adj}${issue.minimum.toString()} ist`;
                }
            case "invalid_format":
                {
                    const _issue = issue;
                    if (_issue.format === "starts_with") return `Ung\xfcltiger String: muss mit "${_issue.prefix}" beginnen`;
                    if (_issue.format === "ends_with") return `Ung\xfcltiger String: muss mit "${_issue.suffix}" enden`;
                    if (_issue.format === "includes") return `Ung\xfcltiger String: muss "${_issue.includes}" enthalten`;
                    if (_issue.format === "regex") return `Ung\xfcltiger String: muss dem Muster ${_issue.pattern} entsprechen`;
                    return `Ung\xfcltig: ${Nouns[_issue.format] ?? issue.format}`;
                }
            case "not_multiple_of":
                return `Ung\xfcltige Zahl: muss ein Vielfaches von ${issue.divisor} sein`;
            case "unrecognized_keys":
                return `${issue.keys.length > 1 ? "Unbekannte Schl\xfcssel" : "Unbekannter Schl\xfcssel"}: ${$8f5391358ccbeba2$export$e79b744344f50f50(issue.keys, ", ")}`;
            case "invalid_key":
                return `Ung\xfcltiger Schl\xfcssel in ${issue.origin}`;
            case "invalid_union":
                return "Ung\xfcltige Eingabe";
            case "invalid_element":
                return `Ung\xfcltiger Wert in ${issue.origin}`;
            default:
                return `Ung\xfcltige Eingabe`;
        }
    };
};
function $c9f7287ecfa25847$export$2e2bcd8739ae039() {
    return {
        localeError: $c9f7287ecfa25847$var$error()
    };
}



const $2c82302aae7b6758$export$858d360cf6da2b65 = (data)=>{
    const t = typeof data;
    switch(t){
        case "number":
            return Number.isNaN(data) ? "NaN" : "number";
        case "object":
            if (Array.isArray(data)) return "array";
            if (data === null) return "null";
            if (Object.getPrototypeOf(data) !== Object.prototype && data.constructor) return data.constructor.name;
    }
    return t;
};
const $2c82302aae7b6758$var$error = ()=>{
    const Sizable = {
        string: {
            unit: "characters",
            verb: "to have"
        },
        file: {
            unit: "bytes",
            verb: "to have"
        },
        array: {
            unit: "items",
            verb: "to have"
        },
        set: {
            unit: "items",
            verb: "to have"
        }
    };
    function getSizing(origin) {
        return Sizable[origin] ?? null;
    }
    const Nouns = {
        regex: "input",
        email: "email address",
        url: "URL",
        emoji: "emoji",
        uuid: "UUID",
        uuidv4: "UUIDv4",
        uuidv6: "UUIDv6",
        nanoid: "nanoid",
        guid: "GUID",
        cuid: "cuid",
        cuid2: "cuid2",
        ulid: "ULID",
        xid: "XID",
        ksuid: "KSUID",
        datetime: "ISO datetime",
        date: "ISO date",
        time: "ISO time",
        duration: "ISO duration",
        ipv4: "IPv4 address",
        ipv6: "IPv6 address",
        mac: "MAC address",
        cidrv4: "IPv4 range",
        cidrv6: "IPv6 range",
        base64: "base64-encoded string",
        base64url: "base64url-encoded string",
        json_string: "JSON string",
        e164: "E.164 number",
        jwt: "JWT",
        template_literal: "input"
    };
    return (issue)=>{
        switch(issue.code){
            case "invalid_type":
                return `Invalid input: expected ${issue.expected}, received ${$2c82302aae7b6758$export$858d360cf6da2b65(issue.input)}`;
            case "invalid_value":
                if (issue.values.length === 1) return `Invalid input: expected ${$8f5391358ccbeba2$export$5859860f650378f4(issue.values[0])}`;
                return `Invalid option: expected one of ${$8f5391358ccbeba2$export$e79b744344f50f50(issue.values, "|")}`;
            case "too_big":
                {
                    const adj = issue.inclusive ? "<=" : "<";
                    const sizing = getSizing(issue.origin);
                    if (sizing) return `Too big: expected ${issue.origin ?? "value"} to have ${adj}${issue.maximum.toString()} ${sizing.unit ?? "elements"}`;
                    return `Too big: expected ${issue.origin ?? "value"} to be ${adj}${issue.maximum.toString()}`;
                }
            case "too_small":
                {
                    const adj = issue.inclusive ? ">=" : ">";
                    const sizing = getSizing(issue.origin);
                    if (sizing) return `Too small: expected ${issue.origin} to have ${adj}${issue.minimum.toString()} ${sizing.unit}`;
                    return `Too small: expected ${issue.origin} to be ${adj}${issue.minimum.toString()}`;
                }
            case "invalid_format":
                {
                    const _issue = issue;
                    if (_issue.format === "starts_with") return `Invalid string: must start with "${_issue.prefix}"`;
                    if (_issue.format === "ends_with") return `Invalid string: must end with "${_issue.suffix}"`;
                    if (_issue.format === "includes") return `Invalid string: must include "${_issue.includes}"`;
                    if (_issue.format === "regex") return `Invalid string: must match pattern ${_issue.pattern}`;
                    return `Invalid ${Nouns[_issue.format] ?? issue.format}`;
                }
            case "not_multiple_of":
                return `Invalid number: must be a multiple of ${issue.divisor}`;
            case "unrecognized_keys":
                return `Unrecognized key${issue.keys.length > 1 ? "s" : ""}: ${$8f5391358ccbeba2$export$e79b744344f50f50(issue.keys, ", ")}`;
            case "invalid_key":
                return `Invalid key in ${issue.origin}`;
            case "invalid_union":
                return "Invalid input";
            case "invalid_element":
                return `Invalid value in ${issue.origin}`;
            default:
                return `Invalid input`;
        }
    };
};
function $2c82302aae7b6758$export$2e2bcd8739ae039() {
    return {
        localeError: $2c82302aae7b6758$var$error()
    };
}



const $93bc8e99b4e5dc49$export$858d360cf6da2b65 = (data)=>{
    const t = typeof data;
    switch(t){
        case "number":
            return Number.isNaN(data) ? "NaN" : "nombro";
        case "object":
            if (Array.isArray(data)) return "tabelo";
            if (data === null) return "senvalora";
            if (Object.getPrototypeOf(data) !== Object.prototype && data.constructor) return data.constructor.name;
    }
    return t;
};
const $93bc8e99b4e5dc49$var$error = ()=>{
    const Sizable = {
        string: {
            unit: "karaktrojn",
            verb: "havi"
        },
        file: {
            unit: "bajtojn",
            verb: "havi"
        },
        array: {
            unit: "elementojn",
            verb: "havi"
        },
        set: {
            unit: "elementojn",
            verb: "havi"
        }
    };
    function getSizing(origin) {
        return Sizable[origin] ?? null;
    }
    const Nouns = {
        regex: "enigo",
        email: "retadreso",
        url: "URL",
        emoji: "emo\u011Dio",
        uuid: "UUID",
        uuidv4: "UUIDv4",
        uuidv6: "UUIDv6",
        nanoid: "nanoid",
        guid: "GUID",
        cuid: "cuid",
        cuid2: "cuid2",
        ulid: "ULID",
        xid: "XID",
        ksuid: "KSUID",
        datetime: "ISO-datotempo",
        date: "ISO-dato",
        time: "ISO-tempo",
        duration: "ISO-da\u016Dro",
        ipv4: "IPv4-adreso",
        ipv6: "IPv6-adreso",
        cidrv4: "IPv4-rango",
        cidrv6: "IPv6-rango",
        base64: "64-ume kodita karaktraro",
        base64url: "URL-64-ume kodita karaktraro",
        json_string: "JSON-karaktraro",
        e164: "E.164-nombro",
        jwt: "JWT",
        template_literal: "enigo"
    };
    return (issue)=>{
        switch(issue.code){
            case "invalid_type":
                return `Nevalida enigo: atendi\u{11D}is ${issue.expected}, ricevi\u{11D}is ${$93bc8e99b4e5dc49$export$858d360cf6da2b65(issue.input)}`;
            case "invalid_value":
                if (issue.values.length === 1) return `Nevalida enigo: atendi\u{11D}is ${$8f5391358ccbeba2$export$5859860f650378f4(issue.values[0])}`;
                return `Nevalida opcio: atendi\u{11D}is unu el ${$8f5391358ccbeba2$export$e79b744344f50f50(issue.values, "|")}`;
            case "too_big":
                {
                    const adj = issue.inclusive ? "<=" : "<";
                    const sizing = getSizing(issue.origin);
                    if (sizing) return `Tro granda: atendi\u{11D}is ke ${issue.origin ?? "valoro"} havu ${adj}${issue.maximum.toString()} ${sizing.unit ?? "elementojn"}`;
                    return `Tro granda: atendi\u{11D}is ke ${issue.origin ?? "valoro"} havu ${adj}${issue.maximum.toString()}`;
                }
            case "too_small":
                {
                    const adj = issue.inclusive ? ">=" : ">";
                    const sizing = getSizing(issue.origin);
                    if (sizing) return `Tro malgranda: atendi\u{11D}is ke ${issue.origin} havu ${adj}${issue.minimum.toString()} ${sizing.unit}`;
                    return `Tro malgranda: atendi\u{11D}is ke ${issue.origin} estu ${adj}${issue.minimum.toString()}`;
                }
            case "invalid_format":
                {
                    const _issue = issue;
                    if (_issue.format === "starts_with") return `Nevalida karaktraro: devas komenci\u{11D}i per "${_issue.prefix}"`;
                    if (_issue.format === "ends_with") return `Nevalida karaktraro: devas fini\u{11D}i per "${_issue.suffix}"`;
                    if (_issue.format === "includes") return `Nevalida karaktraro: devas inkluzivi "${_issue.includes}"`;
                    if (_issue.format === "regex") return `Nevalida karaktraro: devas kongrui kun la modelo ${_issue.pattern}`;
                    return `Nevalida ${Nouns[_issue.format] ?? issue.format}`;
                }
            case "not_multiple_of":
                return `Nevalida nombro: devas esti oblo de ${issue.divisor}`;
            case "unrecognized_keys":
                return `Nekonata${issue.keys.length > 1 ? "j" : ""} \u{15D}losilo${issue.keys.length > 1 ? "j" : ""}: ${$8f5391358ccbeba2$export$e79b744344f50f50(issue.keys, ", ")}`;
            case "invalid_key":
                return `Nevalida \u{15D}losilo en ${issue.origin}`;
            case "invalid_union":
                return "Nevalida enigo";
            case "invalid_element":
                return `Nevalida valoro en ${issue.origin}`;
            default:
                return `Nevalida enigo`;
        }
    };
};
function $93bc8e99b4e5dc49$export$2e2bcd8739ae039() {
    return {
        localeError: $93bc8e99b4e5dc49$var$error()
    };
}



const $4dcd6381624846ca$var$error = ()=>{
    const Sizable = {
        string: {
            unit: "caracteres",
            verb: "tener"
        },
        file: {
            unit: "bytes",
            verb: "tener"
        },
        array: {
            unit: "elementos",
            verb: "tener"
        },
        set: {
            unit: "elementos",
            verb: "tener"
        }
    };
    const TypeNames = {
        string: "texto",
        number: "n\xfamero",
        boolean: "booleano",
        array: "arreglo",
        object: "objeto",
        set: "conjunto",
        file: "archivo",
        date: "fecha",
        bigint: "n\xfamero grande",
        symbol: "s\xedmbolo",
        undefined: "indefinido",
        null: "nulo",
        function: "funci\xf3n",
        map: "mapa",
        record: "registro",
        tuple: "tupla",
        enum: "enumeraci\xf3n",
        union: "uni\xf3n",
        literal: "literal",
        promise: "promesa",
        void: "vac\xedo",
        never: "nunca",
        unknown: "desconocido",
        any: "cualquiera"
    };
    function getSizing(origin) {
        return Sizable[origin] ?? null;
    }
    function getTypeName(type) {
        return TypeNames[type] ?? type;
    }
    const parsedType = (data)=>{
        const t = typeof data;
        switch(t){
            case "number":
                return Number.isNaN(data) ? "NaN" : "number";
            case "object":
                if (Array.isArray(data)) return "array";
                if (data === null) return "null";
                if (Object.getPrototypeOf(data) !== Object.prototype) return data.constructor.name;
                return "object";
        }
        return t;
    };
    const Nouns = {
        regex: "entrada",
        email: "direcci\xf3n de correo electr\xf3nico",
        url: "URL",
        emoji: "emoji",
        uuid: "UUID",
        uuidv4: "UUIDv4",
        uuidv6: "UUIDv6",
        nanoid: "nanoid",
        guid: "GUID",
        cuid: "cuid",
        cuid2: "cuid2",
        ulid: "ULID",
        xid: "XID",
        ksuid: "KSUID",
        datetime: "fecha y hora ISO",
        date: "fecha ISO",
        time: "hora ISO",
        duration: "duraci\xf3n ISO",
        ipv4: "direcci\xf3n IPv4",
        ipv6: "direcci\xf3n IPv6",
        cidrv4: "rango IPv4",
        cidrv6: "rango IPv6",
        base64: "cadena codificada en base64",
        base64url: "URL codificada en base64",
        json_string: "cadena JSON",
        e164: "n\xfamero E.164",
        jwt: "JWT",
        template_literal: "entrada"
    };
    return (issue)=>{
        switch(issue.code){
            case "invalid_type":
                return `Entrada inv\xe1lida: se esperaba ${getTypeName(issue.expected)}, recibido ${getTypeName(parsedType(issue.input))}`;
            // return `Entrada inválida: se esperaba ${issue.expected}, recibido ${util.getParsedType(issue.input)}`;
            case "invalid_value":
                if (issue.values.length === 1) return `Entrada inv\xe1lida: se esperaba ${$8f5391358ccbeba2$export$5859860f650378f4(issue.values[0])}`;
                return `Opci\xf3n inv\xe1lida: se esperaba una de ${$8f5391358ccbeba2$export$e79b744344f50f50(issue.values, "|")}`;
            case "too_big":
                {
                    const adj = issue.inclusive ? "<=" : "<";
                    const sizing = getSizing(issue.origin);
                    const origin = getTypeName(issue.origin);
                    if (sizing) return `Demasiado grande: se esperaba que ${origin ?? "valor"} tuviera ${adj}${issue.maximum.toString()} ${sizing.unit ?? "elementos"}`;
                    return `Demasiado grande: se esperaba que ${origin ?? "valor"} fuera ${adj}${issue.maximum.toString()}`;
                }
            case "too_small":
                {
                    const adj = issue.inclusive ? ">=" : ">";
                    const sizing = getSizing(issue.origin);
                    const origin = getTypeName(issue.origin);
                    if (sizing) return `Demasiado peque\xf1o: se esperaba que ${origin} tuviera ${adj}${issue.minimum.toString()} ${sizing.unit}`;
                    return `Demasiado peque\xf1o: se esperaba que ${origin} fuera ${adj}${issue.minimum.toString()}`;
                }
            case "invalid_format":
                {
                    const _issue = issue;
                    if (_issue.format === "starts_with") return `Cadena inv\xe1lida: debe comenzar con "${_issue.prefix}"`;
                    if (_issue.format === "ends_with") return `Cadena inv\xe1lida: debe terminar en "${_issue.suffix}"`;
                    if (_issue.format === "includes") return `Cadena inv\xe1lida: debe incluir "${_issue.includes}"`;
                    if (_issue.format === "regex") return `Cadena inv\xe1lida: debe coincidir con el patr\xf3n ${_issue.pattern}`;
                    return `Inv\xe1lido ${Nouns[_issue.format] ?? issue.format}`;
                }
            case "not_multiple_of":
                return `N\xfamero inv\xe1lido: debe ser m\xfaltiplo de ${issue.divisor}`;
            case "unrecognized_keys":
                return `Llave${issue.keys.length > 1 ? "s" : ""} desconocida${issue.keys.length > 1 ? "s" : ""}: ${$8f5391358ccbeba2$export$e79b744344f50f50(issue.keys, ", ")}`;
            case "invalid_key":
                return `Llave inv\xe1lida en ${getTypeName(issue.origin)}`;
            case "invalid_union":
                return "Entrada inv\xe1lida";
            case "invalid_element":
                return `Valor inv\xe1lido en ${getTypeName(issue.origin)}`;
            default:
                return `Entrada inv\xe1lida`;
        }
    };
};
function $4dcd6381624846ca$export$2e2bcd8739ae039() {
    return {
        localeError: $4dcd6381624846ca$var$error()
    };
}



const $ad8fc89fd154971a$var$error = ()=>{
    const Sizable = {
        string: {
            unit: "\u06A9\u0627\u0631\u0627\u06A9\u062A\u0631",
            verb: "\u062F\u0627\u0634\u062A\u0647 \u0628\u0627\u0634\u062F"
        },
        file: {
            unit: "\u0628\u0627\u06CC\u062A",
            verb: "\u062F\u0627\u0634\u062A\u0647 \u0628\u0627\u0634\u062F"
        },
        array: {
            unit: "\u0622\u06CC\u062A\u0645",
            verb: "\u062F\u0627\u0634\u062A\u0647 \u0628\u0627\u0634\u062F"
        },
        set: {
            unit: "\u0622\u06CC\u062A\u0645",
            verb: "\u062F\u0627\u0634\u062A\u0647 \u0628\u0627\u0634\u062F"
        }
    };
    function getSizing(origin) {
        return Sizable[origin] ?? null;
    }
    const parsedType = (data)=>{
        const t = typeof data;
        switch(t){
            case "number":
                return Number.isNaN(data) ? "NaN" : "\u0639\u062F\u062F";
            case "object":
                if (Array.isArray(data)) return "\u0622\u0631\u0627\u06CC\u0647";
                if (data === null) return "null";
                if (Object.getPrototypeOf(data) !== Object.prototype && data.constructor) return data.constructor.name;
        }
        return t;
    };
    const Nouns = {
        regex: "\u0648\u0631\u0648\u062F\u06CC",
        email: "\u0622\u062F\u0631\u0633 \u0627\u06CC\u0645\u06CC\u0644",
        url: "URL",
        emoji: "\u0627\u06CC\u0645\u0648\u062C\u06CC",
        uuid: "UUID",
        uuidv4: "UUIDv4",
        uuidv6: "UUIDv6",
        nanoid: "nanoid",
        guid: "GUID",
        cuid: "cuid",
        cuid2: "cuid2",
        ulid: "ULID",
        xid: "XID",
        ksuid: "KSUID",
        datetime: "\u062A\u0627\u0631\u06CC\u062E \u0648 \u0632\u0645\u0627\u0646 \u0627\u06CC\u0632\u0648",
        date: "\u062A\u0627\u0631\u06CC\u062E \u0627\u06CC\u0632\u0648",
        time: "\u0632\u0645\u0627\u0646 \u0627\u06CC\u0632\u0648",
        duration: "\u0645\u062F\u062A \u0632\u0645\u0627\u0646 \u0627\u06CC\u0632\u0648",
        ipv4: "IPv4 \u0622\u062F\u0631\u0633",
        ipv6: "IPv6 \u0622\u062F\u0631\u0633",
        cidrv4: "IPv4 \u062F\u0627\u0645\u0646\u0647",
        cidrv6: "IPv6 \u062F\u0627\u0645\u0646\u0647",
        base64: "base64-encoded \u0631\u0634\u062A\u0647",
        base64url: "base64url-encoded \u0631\u0634\u062A\u0647",
        json_string: "JSON \u0631\u0634\u062A\u0647",
        e164: "E.164 \u0639\u062F\u062F",
        jwt: "JWT",
        template_literal: "\u0648\u0631\u0648\u062F\u06CC"
    };
    return (issue)=>{
        switch(issue.code){
            case "invalid_type":
                return `\u{648}\u{631}\u{648}\u{62F}\u{6CC} \u{646}\u{627}\u{645}\u{639}\u{62A}\u{628}\u{631}: \u{645}\u{6CC}\u{200C}\u{628}\u{627}\u{6CC}\u{633}\u{62A} ${issue.expected} \u{645}\u{6CC}\u{200C}\u{628}\u{648}\u{62F}\u{60C} ${parsedType(issue.input)} \u{62F}\u{631}\u{6CC}\u{627}\u{641}\u{62A} \u{634}\u{62F}`;
            case "invalid_value":
                if (issue.values.length === 1) return `\u{648}\u{631}\u{648}\u{62F}\u{6CC} \u{646}\u{627}\u{645}\u{639}\u{62A}\u{628}\u{631}: \u{645}\u{6CC}\u{200C}\u{628}\u{627}\u{6CC}\u{633}\u{62A} ${$8f5391358ccbeba2$export$5859860f650378f4(issue.values[0])} \u{645}\u{6CC}\u{200C}\u{628}\u{648}\u{62F}`;
                return `\u{6AF}\u{632}\u{6CC}\u{646}\u{647} \u{646}\u{627}\u{645}\u{639}\u{62A}\u{628}\u{631}: \u{645}\u{6CC}\u{200C}\u{628}\u{627}\u{6CC}\u{633}\u{62A} \u{6CC}\u{6A9}\u{6CC} \u{627}\u{632} ${$8f5391358ccbeba2$export$e79b744344f50f50(issue.values, "|")} \u{645}\u{6CC}\u{200C}\u{628}\u{648}\u{62F}`;
            case "too_big":
                {
                    const adj = issue.inclusive ? "<=" : "<";
                    const sizing = getSizing(issue.origin);
                    if (sizing) return `\u{62E}\u{6CC}\u{644}\u{6CC} \u{628}\u{632}\u{631}\u{6AF}: ${issue.origin ?? "\u0645\u0642\u062F\u0627\u0631"} \u{628}\u{627}\u{6CC}\u{62F} ${adj}${issue.maximum.toString()} ${sizing.unit ?? "\u0639\u0646\u0635\u0631"} \u{628}\u{627}\u{634}\u{62F}`;
                    return `\u{62E}\u{6CC}\u{644}\u{6CC} \u{628}\u{632}\u{631}\u{6AF}: ${issue.origin ?? "\u0645\u0642\u062F\u0627\u0631"} \u{628}\u{627}\u{6CC}\u{62F} ${adj}${issue.maximum.toString()} \u{628}\u{627}\u{634}\u{62F}`;
                }
            case "too_small":
                {
                    const adj = issue.inclusive ? ">=" : ">";
                    const sizing = getSizing(issue.origin);
                    if (sizing) return `\u{62E}\u{6CC}\u{644}\u{6CC} \u{6A9}\u{648}\u{686}\u{6A9}: ${issue.origin} \u{628}\u{627}\u{6CC}\u{62F} ${adj}${issue.minimum.toString()} ${sizing.unit} \u{628}\u{627}\u{634}\u{62F}`;
                    return `\u{62E}\u{6CC}\u{644}\u{6CC} \u{6A9}\u{648}\u{686}\u{6A9}: ${issue.origin} \u{628}\u{627}\u{6CC}\u{62F} ${adj}${issue.minimum.toString()} \u{628}\u{627}\u{634}\u{62F}`;
                }
            case "invalid_format":
                {
                    const _issue = issue;
                    if (_issue.format === "starts_with") return `\u{631}\u{634}\u{62A}\u{647} \u{646}\u{627}\u{645}\u{639}\u{62A}\u{628}\u{631}: \u{628}\u{627}\u{6CC}\u{62F} \u{628}\u{627} "${_issue.prefix}" \u{634}\u{631}\u{648}\u{639} \u{634}\u{648}\u{62F}`;
                    if (_issue.format === "ends_with") return `\u{631}\u{634}\u{62A}\u{647} \u{646}\u{627}\u{645}\u{639}\u{62A}\u{628}\u{631}: \u{628}\u{627}\u{6CC}\u{62F} \u{628}\u{627} "${_issue.suffix}" \u{62A}\u{645}\u{627}\u{645} \u{634}\u{648}\u{62F}`;
                    if (_issue.format === "includes") return `\u{631}\u{634}\u{62A}\u{647} \u{646}\u{627}\u{645}\u{639}\u{62A}\u{628}\u{631}: \u{628}\u{627}\u{6CC}\u{62F} \u{634}\u{627}\u{645}\u{644} "${_issue.includes}" \u{628}\u{627}\u{634}\u{62F}`;
                    if (_issue.format === "regex") return `\u{631}\u{634}\u{62A}\u{647} \u{646}\u{627}\u{645}\u{639}\u{62A}\u{628}\u{631}: \u{628}\u{627}\u{6CC}\u{62F} \u{628}\u{627} \u{627}\u{644}\u{6AF}\u{648}\u{6CC} ${_issue.pattern} \u{645}\u{637}\u{627}\u{628}\u{642}\u{62A} \u{62F}\u{627}\u{634}\u{62A}\u{647} \u{628}\u{627}\u{634}\u{62F}`;
                    return `${Nouns[_issue.format] ?? issue.format} \u{646}\u{627}\u{645}\u{639}\u{62A}\u{628}\u{631}`;
                }
            case "not_multiple_of":
                return `\u{639}\u{62F}\u{62F} \u{646}\u{627}\u{645}\u{639}\u{62A}\u{628}\u{631}: \u{628}\u{627}\u{6CC}\u{62F} \u{645}\u{636}\u{631}\u{628} ${issue.divisor} \u{628}\u{627}\u{634}\u{62F}`;
            case "unrecognized_keys":
                return `\u{6A9}\u{644}\u{6CC}\u{62F}${issue.keys.length > 1 ? "\u0647\u0627\u06CC" : ""} \u{646}\u{627}\u{634}\u{646}\u{627}\u{633}: ${$8f5391358ccbeba2$export$e79b744344f50f50(issue.keys, ", ")}`;
            case "invalid_key":
                return `\u{6A9}\u{644}\u{6CC}\u{62F} \u{646}\u{627}\u{634}\u{646}\u{627}\u{633} \u{62F}\u{631} ${issue.origin}`;
            case "invalid_union":
                return `\u{648}\u{631}\u{648}\u{62F}\u{6CC} \u{646}\u{627}\u{645}\u{639}\u{62A}\u{628}\u{631}`;
            case "invalid_element":
                return `\u{645}\u{642}\u{62F}\u{627}\u{631} \u{646}\u{627}\u{645}\u{639}\u{62A}\u{628}\u{631} \u{62F}\u{631} ${issue.origin}`;
            default:
                return `\u{648}\u{631}\u{648}\u{62F}\u{6CC} \u{646}\u{627}\u{645}\u{639}\u{62A}\u{628}\u{631}`;
        }
    };
};
function $ad8fc89fd154971a$export$2e2bcd8739ae039() {
    return {
        localeError: $ad8fc89fd154971a$var$error()
    };
}



const $d3713a3d830790ab$var$error = ()=>{
    const Sizable = {
        string: {
            unit: "merkki\xe4",
            subject: "merkkijonon"
        },
        file: {
            unit: "tavua",
            subject: "tiedoston"
        },
        array: {
            unit: "alkiota",
            subject: "listan"
        },
        set: {
            unit: "alkiota",
            subject: "joukon"
        },
        number: {
            unit: "",
            subject: "luvun"
        },
        bigint: {
            unit: "",
            subject: "suuren kokonaisluvun"
        },
        int: {
            unit: "",
            subject: "kokonaisluvun"
        },
        date: {
            unit: "",
            subject: "p\xe4iv\xe4m\xe4\xe4r\xe4n"
        }
    };
    function getSizing(origin) {
        return Sizable[origin] ?? null;
    }
    const parsedType = (data)=>{
        const t = typeof data;
        switch(t){
            case "number":
                return Number.isNaN(data) ? "NaN" : "number";
            case "object":
                if (Array.isArray(data)) return "array";
                if (data === null) return "null";
                if (Object.getPrototypeOf(data) !== Object.prototype && data.constructor) return data.constructor.name;
        }
        return t;
    };
    const Nouns = {
        regex: "s\xe4\xe4nn\xf6llinen lauseke",
        email: "s\xe4hk\xf6postiosoite",
        url: "URL-osoite",
        emoji: "emoji",
        uuid: "UUID",
        uuidv4: "UUIDv4",
        uuidv6: "UUIDv6",
        nanoid: "nanoid",
        guid: "GUID",
        cuid: "cuid",
        cuid2: "cuid2",
        ulid: "ULID",
        xid: "XID",
        ksuid: "KSUID",
        datetime: "ISO-aikaleima",
        date: "ISO-p\xe4iv\xe4m\xe4\xe4r\xe4",
        time: "ISO-aika",
        duration: "ISO-kesto",
        ipv4: "IPv4-osoite",
        ipv6: "IPv6-osoite",
        cidrv4: "IPv4-alue",
        cidrv6: "IPv6-alue",
        base64: "base64-koodattu merkkijono",
        base64url: "base64url-koodattu merkkijono",
        json_string: "JSON-merkkijono",
        e164: "E.164-luku",
        jwt: "JWT",
        template_literal: "templaattimerkkijono"
    };
    return (issue)=>{
        switch(issue.code){
            case "invalid_type":
                return `Virheellinen tyyppi: odotettiin ${issue.expected}, oli ${parsedType(issue.input)}`;
            case "invalid_value":
                if (issue.values.length === 1) return `Virheellinen sy\xf6te: t\xe4ytyy olla ${$8f5391358ccbeba2$export$5859860f650378f4(issue.values[0])}`;
                return `Virheellinen valinta: t\xe4ytyy olla yksi seuraavista: ${$8f5391358ccbeba2$export$e79b744344f50f50(issue.values, "|")}`;
            case "too_big":
                {
                    const adj = issue.inclusive ? "<=" : "<";
                    const sizing = getSizing(issue.origin);
                    if (sizing) return `Liian suuri: ${sizing.subject} t\xe4ytyy olla ${adj}${issue.maximum.toString()} ${sizing.unit}`.trim();
                    return `Liian suuri: arvon t\xe4ytyy olla ${adj}${issue.maximum.toString()}`;
                }
            case "too_small":
                {
                    const adj = issue.inclusive ? ">=" : ">";
                    const sizing = getSizing(issue.origin);
                    if (sizing) return `Liian pieni: ${sizing.subject} t\xe4ytyy olla ${adj}${issue.minimum.toString()} ${sizing.unit}`.trim();
                    return `Liian pieni: arvon t\xe4ytyy olla ${adj}${issue.minimum.toString()}`;
                }
            case "invalid_format":
                {
                    const _issue = issue;
                    if (_issue.format === "starts_with") return `Virheellinen sy\xf6te: t\xe4ytyy alkaa "${_issue.prefix}"`;
                    if (_issue.format === "ends_with") return `Virheellinen sy\xf6te: t\xe4ytyy loppua "${_issue.suffix}"`;
                    if (_issue.format === "includes") return `Virheellinen sy\xf6te: t\xe4ytyy sis\xe4lt\xe4\xe4 "${_issue.includes}"`;
                    if (_issue.format === "regex") return `Virheellinen sy\xf6te: t\xe4ytyy vastata s\xe4\xe4nn\xf6llist\xe4 lauseketta ${_issue.pattern}`;
                    return `Virheellinen ${Nouns[_issue.format] ?? issue.format}`;
                }
            case "not_multiple_of":
                return `Virheellinen luku: t\xe4ytyy olla luvun ${issue.divisor} monikerta`;
            case "unrecognized_keys":
                return `${issue.keys.length > 1 ? "Tuntemattomat avaimet" : "Tuntematon avain"}: ${$8f5391358ccbeba2$export$e79b744344f50f50(issue.keys, ", ")}`;
            case "invalid_key":
                return "Virheellinen avain tietueessa";
            case "invalid_union":
                return "Virheellinen unioni";
            case "invalid_element":
                return "Virheellinen arvo joukossa";
            default:
                return `Virheellinen sy\xf6te`;
        }
    };
};
function $d3713a3d830790ab$export$2e2bcd8739ae039() {
    return {
        localeError: $d3713a3d830790ab$var$error()
    };
}



const $f00219da79bb8603$var$error = ()=>{
    const Sizable = {
        string: {
            unit: "caract\xe8res",
            verb: "avoir"
        },
        file: {
            unit: "octets",
            verb: "avoir"
        },
        array: {
            unit: "\xe9l\xe9ments",
            verb: "avoir"
        },
        set: {
            unit: "\xe9l\xe9ments",
            verb: "avoir"
        }
    };
    function getSizing(origin) {
        return Sizable[origin] ?? null;
    }
    const parsedType = (data)=>{
        const t = typeof data;
        switch(t){
            case "number":
                return Number.isNaN(data) ? "NaN" : "nombre";
            case "object":
                if (Array.isArray(data)) return "tableau";
                if (data === null) return "null";
                if (Object.getPrototypeOf(data) !== Object.prototype && data.constructor) return data.constructor.name;
        }
        return t;
    };
    const Nouns = {
        regex: "entr\xe9e",
        email: "adresse e-mail",
        url: "URL",
        emoji: "emoji",
        uuid: "UUID",
        uuidv4: "UUIDv4",
        uuidv6: "UUIDv6",
        nanoid: "nanoid",
        guid: "GUID",
        cuid: "cuid",
        cuid2: "cuid2",
        ulid: "ULID",
        xid: "XID",
        ksuid: "KSUID",
        datetime: "date et heure ISO",
        date: "date ISO",
        time: "heure ISO",
        duration: "dur\xe9e ISO",
        ipv4: "adresse IPv4",
        ipv6: "adresse IPv6",
        cidrv4: "plage IPv4",
        cidrv6: "plage IPv6",
        base64: "cha\xeene encod\xe9e en base64",
        base64url: "cha\xeene encod\xe9e en base64url",
        json_string: "cha\xeene JSON",
        e164: "num\xe9ro E.164",
        jwt: "JWT",
        template_literal: "entr\xe9e"
    };
    return (issue)=>{
        switch(issue.code){
            case "invalid_type":
                return `Entr\xe9e invalide : ${issue.expected} attendu, ${parsedType(issue.input)} re\xe7u`;
            case "invalid_value":
                if (issue.values.length === 1) return `Entr\xe9e invalide : ${$8f5391358ccbeba2$export$5859860f650378f4(issue.values[0])} attendu`;
                return `Option invalide : une valeur parmi ${$8f5391358ccbeba2$export$e79b744344f50f50(issue.values, "|")} attendue`;
            case "too_big":
                {
                    const adj = issue.inclusive ? "<=" : "<";
                    const sizing = getSizing(issue.origin);
                    if (sizing) return `Trop grand : ${issue.origin ?? "valeur"} doit ${sizing.verb} ${adj}${issue.maximum.toString()} ${sizing.unit ?? "\xe9l\xe9ment(s)"}`;
                    return `Trop grand : ${issue.origin ?? "valeur"} doit \xeatre ${adj}${issue.maximum.toString()}`;
                }
            case "too_small":
                {
                    const adj = issue.inclusive ? ">=" : ">";
                    const sizing = getSizing(issue.origin);
                    if (sizing) return `Trop petit : ${issue.origin} doit ${sizing.verb} ${adj}${issue.minimum.toString()} ${sizing.unit}`;
                    return `Trop petit : ${issue.origin} doit \xeatre ${adj}${issue.minimum.toString()}`;
                }
            case "invalid_format":
                {
                    const _issue = issue;
                    if (_issue.format === "starts_with") return `Cha\xeene invalide : doit commencer par "${_issue.prefix}"`;
                    if (_issue.format === "ends_with") return `Cha\xeene invalide : doit se terminer par "${_issue.suffix}"`;
                    if (_issue.format === "includes") return `Cha\xeene invalide : doit inclure "${_issue.includes}"`;
                    if (_issue.format === "regex") return `Cha\xeene invalide : doit correspondre au mod\xe8le ${_issue.pattern}`;
                    return `${Nouns[_issue.format] ?? issue.format} invalide`;
                }
            case "not_multiple_of":
                return `Nombre invalide : doit \xeatre un multiple de ${issue.divisor}`;
            case "unrecognized_keys":
                return `Cl\xe9${issue.keys.length > 1 ? "s" : ""} non reconnue${issue.keys.length > 1 ? "s" : ""} : ${$8f5391358ccbeba2$export$e79b744344f50f50(issue.keys, ", ")}`;
            case "invalid_key":
                return `Cl\xe9 invalide dans ${issue.origin}`;
            case "invalid_union":
                return "Entr\xe9e invalide";
            case "invalid_element":
                return `Valeur invalide dans ${issue.origin}`;
            default:
                return `Entr\xe9e invalide`;
        }
    };
};
function $f00219da79bb8603$export$2e2bcd8739ae039() {
    return {
        localeError: $f00219da79bb8603$var$error()
    };
}



const $1b3657730e2181ac$var$error = ()=>{
    const Sizable = {
        string: {
            unit: "caract\xe8res",
            verb: "avoir"
        },
        file: {
            unit: "octets",
            verb: "avoir"
        },
        array: {
            unit: "\xe9l\xe9ments",
            verb: "avoir"
        },
        set: {
            unit: "\xe9l\xe9ments",
            verb: "avoir"
        }
    };
    function getSizing(origin) {
        return Sizable[origin] ?? null;
    }
    const parsedType = (data)=>{
        const t = typeof data;
        switch(t){
            case "number":
                return Number.isNaN(data) ? "NaN" : "number";
            case "object":
                if (Array.isArray(data)) return "array";
                if (data === null) return "null";
                if (Object.getPrototypeOf(data) !== Object.prototype && data.constructor) return data.constructor.name;
        }
        return t;
    };
    const Nouns = {
        regex: "entr\xe9e",
        email: "adresse courriel",
        url: "URL",
        emoji: "emoji",
        uuid: "UUID",
        uuidv4: "UUIDv4",
        uuidv6: "UUIDv6",
        nanoid: "nanoid",
        guid: "GUID",
        cuid: "cuid",
        cuid2: "cuid2",
        ulid: "ULID",
        xid: "XID",
        ksuid: "KSUID",
        datetime: "date-heure ISO",
        date: "date ISO",
        time: "heure ISO",
        duration: "dur\xe9e ISO",
        ipv4: "adresse IPv4",
        ipv6: "adresse IPv6",
        cidrv4: "plage IPv4",
        cidrv6: "plage IPv6",
        base64: "cha\xeene encod\xe9e en base64",
        base64url: "cha\xeene encod\xe9e en base64url",
        json_string: "cha\xeene JSON",
        e164: "num\xe9ro E.164",
        jwt: "JWT",
        template_literal: "entr\xe9e"
    };
    return (issue)=>{
        switch(issue.code){
            case "invalid_type":
                return `Entr\xe9e invalide : attendu ${issue.expected}, re\xe7u ${parsedType(issue.input)}`;
            case "invalid_value":
                if (issue.values.length === 1) return `Entr\xe9e invalide : attendu ${$8f5391358ccbeba2$export$5859860f650378f4(issue.values[0])}`;
                return `Option invalide : attendu l'une des valeurs suivantes ${$8f5391358ccbeba2$export$e79b744344f50f50(issue.values, "|")}`;
            case "too_big":
                {
                    const adj = issue.inclusive ? "\u2264" : "<";
                    const sizing = getSizing(issue.origin);
                    if (sizing) return `Trop grand : attendu que ${issue.origin ?? "la valeur"} ait ${adj}${issue.maximum.toString()} ${sizing.unit}`;
                    return `Trop grand : attendu que ${issue.origin ?? "la valeur"} soit ${adj}${issue.maximum.toString()}`;
                }
            case "too_small":
                {
                    const adj = issue.inclusive ? "\u2265" : ">";
                    const sizing = getSizing(issue.origin);
                    if (sizing) return `Trop petit : attendu que ${issue.origin} ait ${adj}${issue.minimum.toString()} ${sizing.unit}`;
                    return `Trop petit : attendu que ${issue.origin} soit ${adj}${issue.minimum.toString()}`;
                }
            case "invalid_format":
                {
                    const _issue = issue;
                    if (_issue.format === "starts_with") return `Cha\xeene invalide : doit commencer par "${_issue.prefix}"`;
                    if (_issue.format === "ends_with") return `Cha\xeene invalide : doit se terminer par "${_issue.suffix}"`;
                    if (_issue.format === "includes") return `Cha\xeene invalide : doit inclure "${_issue.includes}"`;
                    if (_issue.format === "regex") return `Cha\xeene invalide : doit correspondre au motif ${_issue.pattern}`;
                    return `${Nouns[_issue.format] ?? issue.format} invalide`;
                }
            case "not_multiple_of":
                return `Nombre invalide : doit \xeatre un multiple de ${issue.divisor}`;
            case "unrecognized_keys":
                return `Cl\xe9${issue.keys.length > 1 ? "s" : ""} non reconnue${issue.keys.length > 1 ? "s" : ""} : ${$8f5391358ccbeba2$export$e79b744344f50f50(issue.keys, ", ")}`;
            case "invalid_key":
                return `Cl\xe9 invalide dans ${issue.origin}`;
            case "invalid_union":
                return "Entr\xe9e invalide";
            case "invalid_element":
                return `Valeur invalide dans ${issue.origin}`;
            default:
                return `Entr\xe9e invalide`;
        }
    };
};
function $1b3657730e2181ac$export$2e2bcd8739ae039() {
    return {
        localeError: $1b3657730e2181ac$var$error()
    };
}



const $a38651de7530fcf8$var$error = ()=>{
    // Hebrew labels + grammatical gender
    const TypeNames = {
        string: {
            label: "\u05DE\u05D7\u05E8\u05D5\u05D6\u05EA",
            gender: "f"
        },
        number: {
            label: "\u05DE\u05E1\u05E4\u05E8",
            gender: "m"
        },
        boolean: {
            label: "\u05E2\u05E8\u05DA \u05D1\u05D5\u05DC\u05D9\u05D0\u05E0\u05D9",
            gender: "m"
        },
        bigint: {
            label: "BigInt",
            gender: "m"
        },
        date: {
            label: "\u05EA\u05D0\u05E8\u05D9\u05DA",
            gender: "m"
        },
        array: {
            label: "\u05DE\u05E2\u05E8\u05DA",
            gender: "m"
        },
        object: {
            label: "\u05D0\u05D5\u05D1\u05D9\u05D9\u05E7\u05D8",
            gender: "m"
        },
        null: {
            label: "\u05E2\u05E8\u05DA \u05E8\u05D9\u05E7 (null)",
            gender: "m"
        },
        undefined: {
            label: "\u05E2\u05E8\u05DA \u05DC\u05D0 \u05DE\u05D5\u05D2\u05D3\u05E8 (undefined)",
            gender: "m"
        },
        symbol: {
            label: "\u05E1\u05D9\u05DE\u05D1\u05D5\u05DC (Symbol)",
            gender: "m"
        },
        function: {
            label: "\u05E4\u05D5\u05E0\u05E7\u05E6\u05D9\u05D4",
            gender: "f"
        },
        map: {
            label: "\u05DE\u05E4\u05D4 (Map)",
            gender: "f"
        },
        set: {
            label: "\u05E7\u05D1\u05D5\u05E6\u05D4 (Set)",
            gender: "f"
        },
        file: {
            label: "\u05E7\u05D5\u05D1\u05E5",
            gender: "m"
        },
        promise: {
            label: "Promise",
            gender: "m"
        },
        NaN: {
            label: "NaN",
            gender: "m"
        },
        unknown: {
            label: "\u05E2\u05E8\u05DA \u05DC\u05D0 \u05D9\u05D3\u05D5\u05E2",
            gender: "m"
        },
        value: {
            label: "\u05E2\u05E8\u05DA",
            gender: "m"
        }
    };
    // Sizing units for size-related messages + localized origin labels
    const Sizable = {
        string: {
            unit: "\u05EA\u05D5\u05D5\u05D9\u05DD",
            shortLabel: "\u05E7\u05E6\u05E8",
            longLabel: "\u05D0\u05E8\u05D5\u05DA"
        },
        file: {
            unit: "\u05D1\u05D9\u05D9\u05D8\u05D9\u05DD",
            shortLabel: "\u05E7\u05D8\u05DF",
            longLabel: "\u05D2\u05D3\u05D5\u05DC"
        },
        array: {
            unit: "\u05E4\u05E8\u05D9\u05D8\u05D9\u05DD",
            shortLabel: "\u05E7\u05D8\u05DF",
            longLabel: "\u05D2\u05D3\u05D5\u05DC"
        },
        set: {
            unit: "\u05E4\u05E8\u05D9\u05D8\u05D9\u05DD",
            shortLabel: "\u05E7\u05D8\u05DF",
            longLabel: "\u05D2\u05D3\u05D5\u05DC"
        },
        number: {
            unit: "",
            shortLabel: "\u05E7\u05D8\u05DF",
            longLabel: "\u05D2\u05D3\u05D5\u05DC"
        }
    };
    // Helpers — labels, articles, and verbs
    const typeEntry = (t)=>t ? TypeNames[t] : undefined;
    const typeLabel = (t)=>{
        const e = typeEntry(t);
        if (e) return e.label;
        // fallback: show raw string if unknown
        return t ?? TypeNames.unknown.label;
    };
    const withDefinite = (t)=>`\u{5D4}${typeLabel(t)}`;
    const verbFor = (t)=>{
        const e = typeEntry(t);
        const gender = e?.gender ?? "m";
        return gender === "f" ? "\u05E6\u05E8\u05D9\u05DB\u05D4 \u05DC\u05D4\u05D9\u05D5\u05EA" : "\u05E6\u05E8\u05D9\u05DA \u05DC\u05D4\u05D9\u05D5\u05EA";
    };
    const getSizing = (origin)=>{
        if (!origin) return null;
        return Sizable[origin] ?? null;
    };
    // Robust type parser for "received" — returns a key we understand or a constructor name
    const parsedType = (data)=>{
        const t = typeof data;
        switch(t){
            case "number":
                return Number.isNaN(data) ? "NaN" : "number";
            case "object":
                if (Array.isArray(data)) return "array";
                if (data === null) return "null";
                if (Object.getPrototypeOf(data) !== Object.prototype && data.constructor) return data.constructor.name; // keep as-is (e.g., "Date")
                return "object";
            default:
                return t;
        }
    };
    const Nouns = {
        regex: {
            label: "\u05E7\u05DC\u05D8",
            gender: "m"
        },
        email: {
            label: "\u05DB\u05EA\u05D5\u05D1\u05EA \u05D0\u05D9\u05DE\u05D9\u05D9\u05DC",
            gender: "f"
        },
        url: {
            label: "\u05DB\u05EA\u05D5\u05D1\u05EA \u05E8\u05E9\u05EA",
            gender: "f"
        },
        emoji: {
            label: "\u05D0\u05D9\u05DE\u05D5\u05D2'\u05D9",
            gender: "m"
        },
        uuid: {
            label: "UUID",
            gender: "m"
        },
        nanoid: {
            label: "nanoid",
            gender: "m"
        },
        guid: {
            label: "GUID",
            gender: "m"
        },
        cuid: {
            label: "cuid",
            gender: "m"
        },
        cuid2: {
            label: "cuid2",
            gender: "m"
        },
        ulid: {
            label: "ULID",
            gender: "m"
        },
        xid: {
            label: "XID",
            gender: "m"
        },
        ksuid: {
            label: "KSUID",
            gender: "m"
        },
        datetime: {
            label: "\u05EA\u05D0\u05E8\u05D9\u05DA \u05D5\u05D6\u05DE\u05DF ISO",
            gender: "m"
        },
        date: {
            label: "\u05EA\u05D0\u05E8\u05D9\u05DA ISO",
            gender: "m"
        },
        time: {
            label: "\u05D6\u05DE\u05DF ISO",
            gender: "m"
        },
        duration: {
            label: "\u05DE\u05E9\u05DA \u05D6\u05DE\u05DF ISO",
            gender: "m"
        },
        ipv4: {
            label: "\u05DB\u05EA\u05D5\u05D1\u05EA IPv4",
            gender: "f"
        },
        ipv6: {
            label: "\u05DB\u05EA\u05D5\u05D1\u05EA IPv6",
            gender: "f"
        },
        cidrv4: {
            label: "\u05D8\u05D5\u05D5\u05D7 IPv4",
            gender: "m"
        },
        cidrv6: {
            label: "\u05D8\u05D5\u05D5\u05D7 IPv6",
            gender: "m"
        },
        base64: {
            label: "\u05DE\u05D7\u05E8\u05D5\u05D6\u05EA \u05D1\u05D1\u05E1\u05D9\u05E1 64",
            gender: "f"
        },
        base64url: {
            label: "\u05DE\u05D7\u05E8\u05D5\u05D6\u05EA \u05D1\u05D1\u05E1\u05D9\u05E1 64 \u05DC\u05DB\u05EA\u05D5\u05D1\u05D5\u05EA \u05E8\u05E9\u05EA",
            gender: "f"
        },
        json_string: {
            label: "\u05DE\u05D7\u05E8\u05D5\u05D6\u05EA JSON",
            gender: "f"
        },
        e164: {
            label: "\u05DE\u05E1\u05E4\u05E8 E.164",
            gender: "m"
        },
        jwt: {
            label: "JWT",
            gender: "m"
        },
        ends_with: {
            label: "\u05E7\u05DC\u05D8",
            gender: "m"
        },
        includes: {
            label: "\u05E7\u05DC\u05D8",
            gender: "m"
        },
        lowercase: {
            label: "\u05E7\u05DC\u05D8",
            gender: "m"
        },
        starts_with: {
            label: "\u05E7\u05DC\u05D8",
            gender: "m"
        },
        uppercase: {
            label: "\u05E7\u05DC\u05D8",
            gender: "m"
        }
    };
    return (issue)=>{
        switch(issue.code){
            case "invalid_type":
                {
                    // Expected type: show without definite article for clearer Hebrew
                    const expectedKey = issue.expected;
                    const expected = typeLabel(expectedKey);
                    // Received: show localized label if known, otherwise constructor/raw
                    const receivedKey = parsedType(issue.input);
                    const received = TypeNames[receivedKey]?.label ?? receivedKey;
                    return `\u{5E7}\u{5DC}\u{5D8} \u{5DC}\u{5D0} \u{5EA}\u{5E7}\u{5D9}\u{5DF}: \u{5E6}\u{5E8}\u{5D9}\u{5DA} \u{5DC}\u{5D4}\u{5D9}\u{5D5}\u{5EA} ${expected}, \u{5D4}\u{5EA}\u{5E7}\u{5D1}\u{5DC} ${received}`;
                }
            case "invalid_value":
                {
                    if (issue.values.length === 1) return `\u{5E2}\u{5E8}\u{5DA} \u{5DC}\u{5D0} \u{5EA}\u{5E7}\u{5D9}\u{5DF}: \u{5D4}\u{5E2}\u{5E8}\u{5DA} \u{5D7}\u{5D9}\u{5D9}\u{5D1} \u{5DC}\u{5D4}\u{5D9}\u{5D5}\u{5EA} ${$8f5391358ccbeba2$export$5859860f650378f4(issue.values[0])}`;
                    // Join values with proper Hebrew formatting
                    const stringified = issue.values.map((v)=>$8f5391358ccbeba2$export$5859860f650378f4(v));
                    if (issue.values.length === 2) return `\u{5E2}\u{5E8}\u{5DA} \u{5DC}\u{5D0} \u{5EA}\u{5E7}\u{5D9}\u{5DF}: \u{5D4}\u{5D0}\u{5E4}\u{5E9}\u{5E8}\u{5D5}\u{5D9}\u{5D5}\u{5EA} \u{5D4}\u{5DE}\u{5EA}\u{5D0}\u{5D9}\u{5DE}\u{5D5}\u{5EA} \u{5D4}\u{5DF} ${stringified[0]} \u{5D0}\u{5D5} ${stringified[1]}`;
                    // For 3+ values: "a", "b" או "c"
                    const lastValue = stringified[stringified.length - 1];
                    const restValues = stringified.slice(0, -1).join(", ");
                    return `\u{5E2}\u{5E8}\u{5DA} \u{5DC}\u{5D0} \u{5EA}\u{5E7}\u{5D9}\u{5DF}: \u{5D4}\u{5D0}\u{5E4}\u{5E9}\u{5E8}\u{5D5}\u{5D9}\u{5D5}\u{5EA} \u{5D4}\u{5DE}\u{5EA}\u{5D0}\u{5D9}\u{5DE}\u{5D5}\u{5EA} \u{5D4}\u{5DF} ${restValues} \u{5D0}\u{5D5} ${lastValue}`;
                }
            case "too_big":
                {
                    const sizing = getSizing(issue.origin);
                    const subject = withDefinite(issue.origin ?? "value");
                    if (issue.origin === "string") // Special handling for strings - more natural Hebrew
                    return `${sizing?.longLabel ?? "\u05D0\u05E8\u05D5\u05DA"} \u{5DE}\u{5D3}\u{5D9}: ${subject} \u{5E6}\u{5E8}\u{5D9}\u{5DB}\u{5D4} \u{5DC}\u{5D4}\u{5DB}\u{5D9}\u{5DC} ${issue.maximum.toString()} ${sizing?.unit ?? ""} ${issue.inclusive ? "\u05D0\u05D5 \u05E4\u05D7\u05D5\u05EA" : "\u05DC\u05DB\u05DC \u05D4\u05D9\u05D5\u05EA\u05E8"}`.trim();
                    if (issue.origin === "number") {
                        // Natural Hebrew for numbers
                        const comparison = issue.inclusive ? `\u{5E7}\u{5D8}\u{5DF} \u{5D0}\u{5D5} \u{5E9}\u{5D5}\u{5D5}\u{5D4} \u{5DC}-${issue.maximum}` : `\u{5E7}\u{5D8}\u{5DF} \u{5DE}-${issue.maximum}`;
                        return `\u{5D2}\u{5D3}\u{5D5}\u{5DC} \u{5DE}\u{5D3}\u{5D9}: ${subject} \u{5E6}\u{5E8}\u{5D9}\u{5DA} \u{5DC}\u{5D4}\u{5D9}\u{5D5}\u{5EA} ${comparison}`;
                    }
                    if (issue.origin === "array" || issue.origin === "set") {
                        // Natural Hebrew for arrays and sets
                        const verb = issue.origin === "set" ? "\u05E6\u05E8\u05D9\u05DB\u05D4" : "\u05E6\u05E8\u05D9\u05DA";
                        const comparison = issue.inclusive ? `${issue.maximum} ${sizing?.unit ?? ""} \u{5D0}\u{5D5} \u{5E4}\u{5D7}\u{5D5}\u{5EA}` : `\u{5E4}\u{5D7}\u{5D5}\u{5EA} \u{5DE}-${issue.maximum} ${sizing?.unit ?? ""}`;
                        return `\u{5D2}\u{5D3}\u{5D5}\u{5DC} \u{5DE}\u{5D3}\u{5D9}: ${subject} ${verb} \u{5DC}\u{5D4}\u{5DB}\u{5D9}\u{5DC} ${comparison}`.trim();
                    }
                    const adj = issue.inclusive ? "<=" : "<";
                    const be = verbFor(issue.origin ?? "value");
                    if (sizing?.unit) return `${sizing.longLabel} \u{5DE}\u{5D3}\u{5D9}: ${subject} ${be} ${adj}${issue.maximum.toString()} ${sizing.unit}`;
                    return `${sizing?.longLabel ?? "\u05D2\u05D3\u05D5\u05DC"} \u{5DE}\u{5D3}\u{5D9}: ${subject} ${be} ${adj}${issue.maximum.toString()}`;
                }
            case "too_small":
                {
                    const sizing = getSizing(issue.origin);
                    const subject = withDefinite(issue.origin ?? "value");
                    if (issue.origin === "string") // Special handling for strings - more natural Hebrew
                    return `${sizing?.shortLabel ?? "\u05E7\u05E6\u05E8"} \u{5DE}\u{5D3}\u{5D9}: ${subject} \u{5E6}\u{5E8}\u{5D9}\u{5DB}\u{5D4} \u{5DC}\u{5D4}\u{5DB}\u{5D9}\u{5DC} ${issue.minimum.toString()} ${sizing?.unit ?? ""} ${issue.inclusive ? "\u05D0\u05D5 \u05D9\u05D5\u05EA\u05E8" : "\u05DC\u05E4\u05D7\u05D5\u05EA"}`.trim();
                    if (issue.origin === "number") {
                        // Natural Hebrew for numbers
                        const comparison = issue.inclusive ? `\u{5D2}\u{5D3}\u{5D5}\u{5DC} \u{5D0}\u{5D5} \u{5E9}\u{5D5}\u{5D5}\u{5D4} \u{5DC}-${issue.minimum}` : `\u{5D2}\u{5D3}\u{5D5}\u{5DC} \u{5DE}-${issue.minimum}`;
                        return `\u{5E7}\u{5D8}\u{5DF} \u{5DE}\u{5D3}\u{5D9}: ${subject} \u{5E6}\u{5E8}\u{5D9}\u{5DA} \u{5DC}\u{5D4}\u{5D9}\u{5D5}\u{5EA} ${comparison}`;
                    }
                    if (issue.origin === "array" || issue.origin === "set") {
                        // Natural Hebrew for arrays and sets
                        const verb = issue.origin === "set" ? "\u05E6\u05E8\u05D9\u05DB\u05D4" : "\u05E6\u05E8\u05D9\u05DA";
                        // Special case for singular (minimum === 1)
                        if (issue.minimum === 1 && issue.inclusive) {
                            const singularPhrase = issue.origin === "set" ? "\u05DC\u05E4\u05D7\u05D5\u05EA \u05E4\u05E8\u05D9\u05D8 \u05D0\u05D7\u05D3" : "\u05DC\u05E4\u05D7\u05D5\u05EA \u05E4\u05E8\u05D9\u05D8 \u05D0\u05D7\u05D3";
                            return `\u{5E7}\u{5D8}\u{5DF} \u{5DE}\u{5D3}\u{5D9}: ${subject} ${verb} \u{5DC}\u{5D4}\u{5DB}\u{5D9}\u{5DC} ${singularPhrase}`;
                        }
                        const comparison = issue.inclusive ? `${issue.minimum} ${sizing?.unit ?? ""} \u{5D0}\u{5D5} \u{5D9}\u{5D5}\u{5EA}\u{5E8}` : `\u{5D9}\u{5D5}\u{5EA}\u{5E8} \u{5DE}-${issue.minimum} ${sizing?.unit ?? ""}`;
                        return `\u{5E7}\u{5D8}\u{5DF} \u{5DE}\u{5D3}\u{5D9}: ${subject} ${verb} \u{5DC}\u{5D4}\u{5DB}\u{5D9}\u{5DC} ${comparison}`.trim();
                    }
                    const adj = issue.inclusive ? ">=" : ">";
                    const be = verbFor(issue.origin ?? "value");
                    if (sizing?.unit) return `${sizing.shortLabel} \u{5DE}\u{5D3}\u{5D9}: ${subject} ${be} ${adj}${issue.minimum.toString()} ${sizing.unit}`;
                    return `${sizing?.shortLabel ?? "\u05E7\u05D8\u05DF"} \u{5DE}\u{5D3}\u{5D9}: ${subject} ${be} ${adj}${issue.minimum.toString()}`;
                }
            case "invalid_format":
                {
                    const _issue = issue;
                    // These apply to strings — use feminine grammar + ה׳ הידיעה
                    if (_issue.format === "starts_with") return `\u{5D4}\u{5DE}\u{5D7}\u{5E8}\u{5D5}\u{5D6}\u{5EA} \u{5D7}\u{5D9}\u{5D9}\u{5D1}\u{5EA} \u{5DC}\u{5D4}\u{5EA}\u{5D7}\u{5D9}\u{5DC} \u{5D1} "${_issue.prefix}"`;
                    if (_issue.format === "ends_with") return `\u{5D4}\u{5DE}\u{5D7}\u{5E8}\u{5D5}\u{5D6}\u{5EA} \u{5D7}\u{5D9}\u{5D9}\u{5D1}\u{5EA} \u{5DC}\u{5D4}\u{5E1}\u{5EA}\u{5D9}\u{5D9}\u{5DD} \u{5D1} "${_issue.suffix}"`;
                    if (_issue.format === "includes") return `\u{5D4}\u{5DE}\u{5D7}\u{5E8}\u{5D5}\u{5D6}\u{5EA} \u{5D7}\u{5D9}\u{5D9}\u{5D1}\u{5EA} \u{5DC}\u{5DB}\u{5DC}\u{5D5}\u{5DC} "${_issue.includes}"`;
                    if (_issue.format === "regex") return `\u{5D4}\u{5DE}\u{5D7}\u{5E8}\u{5D5}\u{5D6}\u{5EA} \u{5D7}\u{5D9}\u{5D9}\u{5D1}\u{5EA} \u{5DC}\u{5D4}\u{5EA}\u{5D0}\u{5D9}\u{5DD} \u{5DC}\u{5EA}\u{5D1}\u{5E0}\u{5D9}\u{5EA} ${_issue.pattern}`;
                    // Handle gender agreement for formats
                    const nounEntry = Nouns[_issue.format];
                    const noun = nounEntry?.label ?? _issue.format;
                    const gender = nounEntry?.gender ?? "m";
                    const adjective = gender === "f" ? "\u05EA\u05E7\u05D9\u05E0\u05D4" : "\u05EA\u05E7\u05D9\u05DF";
                    return `${noun} \u{5DC}\u{5D0} ${adjective}`;
                }
            case "not_multiple_of":
                return `\u{5DE}\u{5E1}\u{5E4}\u{5E8} \u{5DC}\u{5D0} \u{5EA}\u{5E7}\u{5D9}\u{5DF}: \u{5D7}\u{5D9}\u{5D9}\u{5D1} \u{5DC}\u{5D4}\u{5D9}\u{5D5}\u{5EA} \u{5DE}\u{5DB}\u{5E4}\u{5DC}\u{5D4} \u{5E9}\u{5DC} ${issue.divisor}`;
            case "unrecognized_keys":
                return `\u{5DE}\u{5E4}\u{5EA}\u{5D7}${issue.keys.length > 1 ? "\u05D5\u05EA" : ""} \u{5DC}\u{5D0} \u{5DE}\u{5D6}\u{5D5}\u{5D4}${issue.keys.length > 1 ? "\u05D9\u05DD" : "\u05D4"}: ${$8f5391358ccbeba2$export$e79b744344f50f50(issue.keys, ", ")}`;
            case "invalid_key":
                return `\u{5E9}\u{5D3}\u{5D4} \u{5DC}\u{5D0} \u{5EA}\u{5E7}\u{5D9}\u{5DF} \u{5D1}\u{5D0}\u{5D5}\u{5D1}\u{5D9}\u{5D9}\u{5E7}\u{5D8}`;
            case "invalid_union":
                return "\u05E7\u05DC\u05D8 \u05DC\u05D0 \u05EA\u05E7\u05D9\u05DF";
            case "invalid_element":
                {
                    const place = withDefinite(issue.origin ?? "array");
                    return `\u{5E2}\u{5E8}\u{5DA} \u{5DC}\u{5D0} \u{5EA}\u{5E7}\u{5D9}\u{5DF} \u{5D1}${place}`;
                }
            default:
                return `\u{5E7}\u{5DC}\u{5D8} \u{5DC}\u{5D0} \u{5EA}\u{5E7}\u{5D9}\u{5DF}`;
        }
    };
};
function $a38651de7530fcf8$export$2e2bcd8739ae039() {
    return {
        localeError: $a38651de7530fcf8$var$error()
    };
}



const $5c72c4f5edc3f4d9$var$error = ()=>{
    const Sizable = {
        string: {
            unit: "karakter",
            verb: "legyen"
        },
        file: {
            unit: "byte",
            verb: "legyen"
        },
        array: {
            unit: "elem",
            verb: "legyen"
        },
        set: {
            unit: "elem",
            verb: "legyen"
        }
    };
    function getSizing(origin) {
        return Sizable[origin] ?? null;
    }
    const parsedType = (data)=>{
        const t = typeof data;
        switch(t){
            case "number":
                return Number.isNaN(data) ? "NaN" : "sz\xe1m";
            case "object":
                if (Array.isArray(data)) return "t\xf6mb";
                if (data === null) return "null";
                if (Object.getPrototypeOf(data) !== Object.prototype && data.constructor) return data.constructor.name;
        }
        return t;
    };
    const Nouns = {
        regex: "bemenet",
        email: "email c\xedm",
        url: "URL",
        emoji: "emoji",
        uuid: "UUID",
        uuidv4: "UUIDv4",
        uuidv6: "UUIDv6",
        nanoid: "nanoid",
        guid: "GUID",
        cuid: "cuid",
        cuid2: "cuid2",
        ulid: "ULID",
        xid: "XID",
        ksuid: "KSUID",
        datetime: "ISO id\u0151b\xe9lyeg",
        date: "ISO d\xe1tum",
        time: "ISO id\u0151",
        duration: "ISO id\u0151intervallum",
        ipv4: "IPv4 c\xedm",
        ipv6: "IPv6 c\xedm",
        cidrv4: "IPv4 tartom\xe1ny",
        cidrv6: "IPv6 tartom\xe1ny",
        base64: "base64-k\xf3dolt string",
        base64url: "base64url-k\xf3dolt string",
        json_string: "JSON string",
        e164: "E.164 sz\xe1m",
        jwt: "JWT",
        template_literal: "bemenet"
    };
    return (issue)=>{
        switch(issue.code){
            case "invalid_type":
                return `\xc9rv\xe9nytelen bemenet: a v\xe1rt \xe9rt\xe9k ${issue.expected}, a kapott \xe9rt\xe9k ${parsedType(issue.input)}`;
            // return `Invalid input: expected ${issue.expected}, received ${util.getParsedType(issue.input)}`;
            case "invalid_value":
                if (issue.values.length === 1) return `\xc9rv\xe9nytelen bemenet: a v\xe1rt \xe9rt\xe9k ${$8f5391358ccbeba2$export$5859860f650378f4(issue.values[0])}`;
                return `\xc9rv\xe9nytelen opci\xf3: valamelyik \xe9rt\xe9k v\xe1rt ${$8f5391358ccbeba2$export$e79b744344f50f50(issue.values, "|")}`;
            case "too_big":
                {
                    const adj = issue.inclusive ? "<=" : "<";
                    const sizing = getSizing(issue.origin);
                    if (sizing) return `T\xfal nagy: ${issue.origin ?? "\xe9rt\xe9k"} m\xe9rete t\xfal nagy ${adj}${issue.maximum.toString()} ${sizing.unit ?? "elem"}`;
                    return `T\xfal nagy: a bemeneti \xe9rt\xe9k ${issue.origin ?? "\xe9rt\xe9k"} t\xfal nagy: ${adj}${issue.maximum.toString()}`;
                }
            case "too_small":
                {
                    const adj = issue.inclusive ? ">=" : ">";
                    const sizing = getSizing(issue.origin);
                    if (sizing) return `T\xfal kicsi: a bemeneti \xe9rt\xe9k ${issue.origin} m\xe9rete t\xfal kicsi ${adj}${issue.minimum.toString()} ${sizing.unit}`;
                    return `T\xfal kicsi: a bemeneti \xe9rt\xe9k ${issue.origin} t\xfal kicsi ${adj}${issue.minimum.toString()}`;
                }
            case "invalid_format":
                {
                    const _issue = issue;
                    if (_issue.format === "starts_with") return `\xc9rv\xe9nytelen string: "${_issue.prefix}" \xe9rt\xe9kkel kell kezd\u{151}dnie`;
                    if (_issue.format === "ends_with") return `\xc9rv\xe9nytelen string: "${_issue.suffix}" \xe9rt\xe9kkel kell v\xe9gz\u{151}dnie`;
                    if (_issue.format === "includes") return `\xc9rv\xe9nytelen string: "${_issue.includes}" \xe9rt\xe9ket kell tartalmaznia`;
                    if (_issue.format === "regex") return `\xc9rv\xe9nytelen string: ${_issue.pattern} mint\xe1nak kell megfelelnie`;
                    return `\xc9rv\xe9nytelen ${Nouns[_issue.format] ?? issue.format}`;
                }
            case "not_multiple_of":
                return `\xc9rv\xe9nytelen sz\xe1m: ${issue.divisor} t\xf6bbsz\xf6r\xf6s\xe9nek kell lennie`;
            case "unrecognized_keys":
                return `Ismeretlen kulcs${issue.keys.length > 1 ? "s" : ""}: ${$8f5391358ccbeba2$export$e79b744344f50f50(issue.keys, ", ")}`;
            case "invalid_key":
                return `\xc9rv\xe9nytelen kulcs ${issue.origin}`;
            case "invalid_union":
                return "\xc9rv\xe9nytelen bemenet";
            case "invalid_element":
                return `\xc9rv\xe9nytelen \xe9rt\xe9k: ${issue.origin}`;
            default:
                return `\xc9rv\xe9nytelen bemenet`;
        }
    };
};
function $5c72c4f5edc3f4d9$export$2e2bcd8739ae039() {
    return {
        localeError: $5c72c4f5edc3f4d9$var$error()
    };
}



const $a887a039c4a39cb6$var$error = ()=>{
    const Sizable = {
        string: {
            unit: "karakter",
            verb: "memiliki"
        },
        file: {
            unit: "byte",
            verb: "memiliki"
        },
        array: {
            unit: "item",
            verb: "memiliki"
        },
        set: {
            unit: "item",
            verb: "memiliki"
        }
    };
    function getSizing(origin) {
        return Sizable[origin] ?? null;
    }
    const parsedType = (data)=>{
        const t = typeof data;
        switch(t){
            case "number":
                return Number.isNaN(data) ? "NaN" : "number";
            case "object":
                if (Array.isArray(data)) return "array";
                if (data === null) return "null";
                if (Object.getPrototypeOf(data) !== Object.prototype && data.constructor) return data.constructor.name;
        }
        return t;
    };
    const Nouns = {
        regex: "input",
        email: "alamat email",
        url: "URL",
        emoji: "emoji",
        uuid: "UUID",
        uuidv4: "UUIDv4",
        uuidv6: "UUIDv6",
        nanoid: "nanoid",
        guid: "GUID",
        cuid: "cuid",
        cuid2: "cuid2",
        ulid: "ULID",
        xid: "XID",
        ksuid: "KSUID",
        datetime: "tanggal dan waktu format ISO",
        date: "tanggal format ISO",
        time: "jam format ISO",
        duration: "durasi format ISO",
        ipv4: "alamat IPv4",
        ipv6: "alamat IPv6",
        cidrv4: "rentang alamat IPv4",
        cidrv6: "rentang alamat IPv6",
        base64: "string dengan enkode base64",
        base64url: "string dengan enkode base64url",
        json_string: "string JSON",
        e164: "angka E.164",
        jwt: "JWT",
        template_literal: "input"
    };
    return (issue)=>{
        switch(issue.code){
            case "invalid_type":
                return `Input tidak valid: diharapkan ${issue.expected}, diterima ${parsedType(issue.input)}`;
            case "invalid_value":
                if (issue.values.length === 1) return `Input tidak valid: diharapkan ${$8f5391358ccbeba2$export$5859860f650378f4(issue.values[0])}`;
                return `Pilihan tidak valid: diharapkan salah satu dari ${$8f5391358ccbeba2$export$e79b744344f50f50(issue.values, "|")}`;
            case "too_big":
                {
                    const adj = issue.inclusive ? "<=" : "<";
                    const sizing = getSizing(issue.origin);
                    if (sizing) return `Terlalu besar: diharapkan ${issue.origin ?? "value"} memiliki ${adj}${issue.maximum.toString()} ${sizing.unit ?? "elemen"}`;
                    return `Terlalu besar: diharapkan ${issue.origin ?? "value"} menjadi ${adj}${issue.maximum.toString()}`;
                }
            case "too_small":
                {
                    const adj = issue.inclusive ? ">=" : ">";
                    const sizing = getSizing(issue.origin);
                    if (sizing) return `Terlalu kecil: diharapkan ${issue.origin} memiliki ${adj}${issue.minimum.toString()} ${sizing.unit}`;
                    return `Terlalu kecil: diharapkan ${issue.origin} menjadi ${adj}${issue.minimum.toString()}`;
                }
            case "invalid_format":
                {
                    const _issue = issue;
                    if (_issue.format === "starts_with") return `String tidak valid: harus dimulai dengan "${_issue.prefix}"`;
                    if (_issue.format === "ends_with") return `String tidak valid: harus berakhir dengan "${_issue.suffix}"`;
                    if (_issue.format === "includes") return `String tidak valid: harus menyertakan "${_issue.includes}"`;
                    if (_issue.format === "regex") return `String tidak valid: harus sesuai pola ${_issue.pattern}`;
                    return `${Nouns[_issue.format] ?? issue.format} tidak valid`;
                }
            case "not_multiple_of":
                return `Angka tidak valid: harus kelipatan dari ${issue.divisor}`;
            case "unrecognized_keys":
                return `Kunci tidak dikenali ${issue.keys.length > 1 ? "s" : ""}: ${$8f5391358ccbeba2$export$e79b744344f50f50(issue.keys, ", ")}`;
            case "invalid_key":
                return `Kunci tidak valid di ${issue.origin}`;
            case "invalid_union":
                return "Input tidak valid";
            case "invalid_element":
                return `Nilai tidak valid di ${issue.origin}`;
            default:
                return `Input tidak valid`;
        }
    };
};
function $a887a039c4a39cb6$export$2e2bcd8739ae039() {
    return {
        localeError: $a887a039c4a39cb6$var$error()
    };
}



const $69487fa97cb6168b$export$858d360cf6da2b65 = (data)=>{
    const t = typeof data;
    switch(t){
        case "number":
            return Number.isNaN(data) ? "NaN" : "n\xfamer";
        case "object":
            if (Array.isArray(data)) return "fylki";
            if (data === null) return "null";
            if (Object.getPrototypeOf(data) !== Object.prototype && data.constructor) return data.constructor.name;
    }
    return t;
};
const $69487fa97cb6168b$var$error = ()=>{
    const Sizable = {
        string: {
            unit: "stafi",
            verb: "a\xf0 hafa"
        },
        file: {
            unit: "b\xe6ti",
            verb: "a\xf0 hafa"
        },
        array: {
            unit: "hluti",
            verb: "a\xf0 hafa"
        },
        set: {
            unit: "hluti",
            verb: "a\xf0 hafa"
        }
    };
    function getSizing(origin) {
        return Sizable[origin] ?? null;
    }
    const Nouns = {
        regex: "gildi",
        email: "netfang",
        url: "vefsl\xf3\xf0",
        emoji: "emoji",
        uuid: "UUID",
        uuidv4: "UUIDv4",
        uuidv6: "UUIDv6",
        nanoid: "nanoid",
        guid: "GUID",
        cuid: "cuid",
        cuid2: "cuid2",
        ulid: "ULID",
        xid: "XID",
        ksuid: "KSUID",
        datetime: "ISO dagsetning og t\xedmi",
        date: "ISO dagsetning",
        time: "ISO t\xedmi",
        duration: "ISO t\xedmalengd",
        ipv4: "IPv4 address",
        ipv6: "IPv6 address",
        cidrv4: "IPv4 range",
        cidrv6: "IPv6 range",
        base64: "base64-encoded strengur",
        base64url: "base64url-encoded strengur",
        json_string: "JSON strengur",
        e164: "E.164 t\xf6lugildi",
        jwt: "JWT",
        template_literal: "gildi"
    };
    return (issue)=>{
        switch(issue.code){
            case "invalid_type":
                return `Rangt gildi: \xde\xfa sl\xf3st inn ${$69487fa97cb6168b$export$858d360cf6da2b65(issue.input)} \xfear sem \xe1 a\xf0 vera ${issue.expected}`;
            case "invalid_value":
                if (issue.values.length === 1) return `Rangt gildi: gert r\xe1\xf0 fyrir ${$8f5391358ccbeba2$export$5859860f650378f4(issue.values[0])}`;
                return `\xd3gilt val: m\xe1 vera eitt af eftirfarandi ${$8f5391358ccbeba2$export$e79b744344f50f50(issue.values, "|")}`;
            case "too_big":
                {
                    const adj = issue.inclusive ? "<=" : "<";
                    const sizing = getSizing(issue.origin);
                    if (sizing) return `Of st\xf3rt: gert er r\xe1\xf0 fyrir a\xf0 ${issue.origin ?? "gildi"} hafi ${adj}${issue.maximum.toString()} ${sizing.unit ?? "hluti"}`;
                    return `Of st\xf3rt: gert er r\xe1\xf0 fyrir a\xf0 ${issue.origin ?? "gildi"} s\xe9 ${adj}${issue.maximum.toString()}`;
                }
            case "too_small":
                {
                    const adj = issue.inclusive ? ">=" : ">";
                    const sizing = getSizing(issue.origin);
                    if (sizing) return `Of l\xedti\xf0: gert er r\xe1\xf0 fyrir a\xf0 ${issue.origin} hafi ${adj}${issue.minimum.toString()} ${sizing.unit}`;
                    return `Of l\xedti\xf0: gert er r\xe1\xf0 fyrir a\xf0 ${issue.origin} s\xe9 ${adj}${issue.minimum.toString()}`;
                }
            case "invalid_format":
                {
                    const _issue = issue;
                    if (_issue.format === "starts_with") return `\xd3gildur strengur: ver\xf0ur a\xf0 byrja \xe1 "${_issue.prefix}"`;
                    if (_issue.format === "ends_with") return `\xd3gildur strengur: ver\xf0ur a\xf0 enda \xe1 "${_issue.suffix}"`;
                    if (_issue.format === "includes") return `\xd3gildur strengur: ver\xf0ur a\xf0 innihalda "${_issue.includes}"`;
                    if (_issue.format === "regex") return `\xd3gildur strengur: ver\xf0ur a\xf0 fylgja mynstri ${_issue.pattern}`;
                    return `Rangt ${Nouns[_issue.format] ?? issue.format}`;
                }
            case "not_multiple_of":
                return `R\xf6ng tala: ver\xf0ur a\xf0 vera margfeldi af ${issue.divisor}`;
            case "unrecognized_keys":
                return `\xd3\xfeekkt ${issue.keys.length > 1 ? "ir lyklar" : "ur lykill"}: ${$8f5391358ccbeba2$export$e79b744344f50f50(issue.keys, ", ")}`;
            case "invalid_key":
                return `Rangur lykill \xed ${issue.origin}`;
            case "invalid_union":
                return "Rangt gildi";
            case "invalid_element":
                return `Rangt gildi \xed ${issue.origin}`;
            default:
                return `Rangt gildi`;
        }
    };
};
function $69487fa97cb6168b$export$2e2bcd8739ae039() {
    return {
        localeError: $69487fa97cb6168b$var$error()
    };
}



const $cc67eeb50e653bdb$var$error = ()=>{
    const Sizable = {
        string: {
            unit: "caratteri",
            verb: "avere"
        },
        file: {
            unit: "byte",
            verb: "avere"
        },
        array: {
            unit: "elementi",
            verb: "avere"
        },
        set: {
            unit: "elementi",
            verb: "avere"
        }
    };
    function getSizing(origin) {
        return Sizable[origin] ?? null;
    }
    const parsedType = (data)=>{
        const t = typeof data;
        switch(t){
            case "number":
                return Number.isNaN(data) ? "NaN" : "numero";
            case "object":
                if (Array.isArray(data)) return "vettore";
                if (data === null) return "null";
                if (Object.getPrototypeOf(data) !== Object.prototype && data.constructor) return data.constructor.name;
        }
        return t;
    };
    const Nouns = {
        regex: "input",
        email: "indirizzo email",
        url: "URL",
        emoji: "emoji",
        uuid: "UUID",
        uuidv4: "UUIDv4",
        uuidv6: "UUIDv6",
        nanoid: "nanoid",
        guid: "GUID",
        cuid: "cuid",
        cuid2: "cuid2",
        ulid: "ULID",
        xid: "XID",
        ksuid: "KSUID",
        datetime: "data e ora ISO",
        date: "data ISO",
        time: "ora ISO",
        duration: "durata ISO",
        ipv4: "indirizzo IPv4",
        ipv6: "indirizzo IPv6",
        cidrv4: "intervallo IPv4",
        cidrv6: "intervallo IPv6",
        base64: "stringa codificata in base64",
        base64url: "URL codificata in base64",
        json_string: "stringa JSON",
        e164: "numero E.164",
        jwt: "JWT",
        template_literal: "input"
    };
    return (issue)=>{
        switch(issue.code){
            case "invalid_type":
                return `Input non valido: atteso ${issue.expected}, ricevuto ${parsedType(issue.input)}`;
            // return `Input non valido: atteso ${issue.expected}, ricevuto ${util.getParsedType(issue.input)}`;
            case "invalid_value":
                if (issue.values.length === 1) return `Input non valido: atteso ${$8f5391358ccbeba2$export$5859860f650378f4(issue.values[0])}`;
                return `Opzione non valida: atteso uno tra ${$8f5391358ccbeba2$export$e79b744344f50f50(issue.values, "|")}`;
            case "too_big":
                {
                    const adj = issue.inclusive ? "<=" : "<";
                    const sizing = getSizing(issue.origin);
                    if (sizing) return `Troppo grande: ${issue.origin ?? "valore"} deve avere ${adj}${issue.maximum.toString()} ${sizing.unit ?? "elementi"}`;
                    return `Troppo grande: ${issue.origin ?? "valore"} deve essere ${adj}${issue.maximum.toString()}`;
                }
            case "too_small":
                {
                    const adj = issue.inclusive ? ">=" : ">";
                    const sizing = getSizing(issue.origin);
                    if (sizing) return `Troppo piccolo: ${issue.origin} deve avere ${adj}${issue.minimum.toString()} ${sizing.unit}`;
                    return `Troppo piccolo: ${issue.origin} deve essere ${adj}${issue.minimum.toString()}`;
                }
            case "invalid_format":
                {
                    const _issue = issue;
                    if (_issue.format === "starts_with") return `Stringa non valida: deve iniziare con "${_issue.prefix}"`;
                    if (_issue.format === "ends_with") return `Stringa non valida: deve terminare con "${_issue.suffix}"`;
                    if (_issue.format === "includes") return `Stringa non valida: deve includere "${_issue.includes}"`;
                    if (_issue.format === "regex") return `Stringa non valida: deve corrispondere al pattern ${_issue.pattern}`;
                    return `Invalid ${Nouns[_issue.format] ?? issue.format}`;
                }
            case "not_multiple_of":
                return `Numero non valido: deve essere un multiplo di ${issue.divisor}`;
            case "unrecognized_keys":
                return `Chiav${issue.keys.length > 1 ? "i" : "e"} non riconosciut${issue.keys.length > 1 ? "e" : "a"}: ${$8f5391358ccbeba2$export$e79b744344f50f50(issue.keys, ", ")}`;
            case "invalid_key":
                return `Chiave non valida in ${issue.origin}`;
            case "invalid_union":
                return "Input non valido";
            case "invalid_element":
                return `Valore non valido in ${issue.origin}`;
            default:
                return `Input non valido`;
        }
    };
};
function $cc67eeb50e653bdb$export$2e2bcd8739ae039() {
    return {
        localeError: $cc67eeb50e653bdb$var$error()
    };
}



const $57b8dee7734d7ce1$var$error = ()=>{
    const Sizable = {
        string: {
            unit: "\u6587\u5B57",
            verb: "\u3067\u3042\u308B"
        },
        file: {
            unit: "\u30D0\u30A4\u30C8",
            verb: "\u3067\u3042\u308B"
        },
        array: {
            unit: "\u8981\u7D20",
            verb: "\u3067\u3042\u308B"
        },
        set: {
            unit: "\u8981\u7D20",
            verb: "\u3067\u3042\u308B"
        }
    };
    function getSizing(origin) {
        return Sizable[origin] ?? null;
    }
    const parsedType = (data)=>{
        const t = typeof data;
        switch(t){
            case "number":
                return Number.isNaN(data) ? "NaN" : "\u6570\u5024";
            case "object":
                if (Array.isArray(data)) return "\u914D\u5217";
                if (data === null) return "null";
                if (Object.getPrototypeOf(data) !== Object.prototype && data.constructor) return data.constructor.name;
        }
        return t;
    };
    const Nouns = {
        regex: "\u5165\u529B\u5024",
        email: "\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9",
        url: "URL",
        emoji: "\u7D75\u6587\u5B57",
        uuid: "UUID",
        uuidv4: "UUIDv4",
        uuidv6: "UUIDv6",
        nanoid: "nanoid",
        guid: "GUID",
        cuid: "cuid",
        cuid2: "cuid2",
        ulid: "ULID",
        xid: "XID",
        ksuid: "KSUID",
        datetime: "ISO\u65E5\u6642",
        date: "ISO\u65E5\u4ED8",
        time: "ISO\u6642\u523B",
        duration: "ISO\u671F\u9593",
        ipv4: "IPv4\u30A2\u30C9\u30EC\u30B9",
        ipv6: "IPv6\u30A2\u30C9\u30EC\u30B9",
        cidrv4: "IPv4\u7BC4\u56F2",
        cidrv6: "IPv6\u7BC4\u56F2",
        base64: "base64\u30A8\u30F3\u30B3\u30FC\u30C9\u6587\u5B57\u5217",
        base64url: "base64url\u30A8\u30F3\u30B3\u30FC\u30C9\u6587\u5B57\u5217",
        json_string: "JSON\u6587\u5B57\u5217",
        e164: "E.164\u756A\u53F7",
        jwt: "JWT",
        template_literal: "\u5165\u529B\u5024"
    };
    return (issue)=>{
        switch(issue.code){
            case "invalid_type":
                return `\u{7121}\u{52B9}\u{306A}\u{5165}\u{529B}: ${issue.expected}\u{304C}\u{671F}\u{5F85}\u{3055}\u{308C}\u{307E}\u{3057}\u{305F}\u{304C}\u{3001}${parsedType(issue.input)}\u{304C}\u{5165}\u{529B}\u{3055}\u{308C}\u{307E}\u{3057}\u{305F}`;
            case "invalid_value":
                if (issue.values.length === 1) return `\u{7121}\u{52B9}\u{306A}\u{5165}\u{529B}: ${$8f5391358ccbeba2$export$5859860f650378f4(issue.values[0])}\u{304C}\u{671F}\u{5F85}\u{3055}\u{308C}\u{307E}\u{3057}\u{305F}`;
                return `\u{7121}\u{52B9}\u{306A}\u{9078}\u{629E}: ${$8f5391358ccbeba2$export$e79b744344f50f50(issue.values, "\u3001")}\u{306E}\u{3044}\u{305A}\u{308C}\u{304B}\u{3067}\u{3042}\u{308B}\u{5FC5}\u{8981}\u{304C}\u{3042}\u{308A}\u{307E}\u{3059}`;
            case "too_big":
                {
                    const adj = issue.inclusive ? "\u4EE5\u4E0B\u3067\u3042\u308B" : "\u3088\u308A\u5C0F\u3055\u3044";
                    const sizing = getSizing(issue.origin);
                    if (sizing) return `\u{5927}\u{304D}\u{3059}\u{304E}\u{308B}\u{5024}: ${issue.origin ?? "\u5024"}\u{306F}${issue.maximum.toString()}${sizing.unit ?? "\u8981\u7D20"}${adj}\u{5FC5}\u{8981}\u{304C}\u{3042}\u{308A}\u{307E}\u{3059}`;
                    return `\u{5927}\u{304D}\u{3059}\u{304E}\u{308B}\u{5024}: ${issue.origin ?? "\u5024"}\u{306F}${issue.maximum.toString()}${adj}\u{5FC5}\u{8981}\u{304C}\u{3042}\u{308A}\u{307E}\u{3059}`;
                }
            case "too_small":
                {
                    const adj = issue.inclusive ? "\u4EE5\u4E0A\u3067\u3042\u308B" : "\u3088\u308A\u5927\u304D\u3044";
                    const sizing = getSizing(issue.origin);
                    if (sizing) return `\u{5C0F}\u{3055}\u{3059}\u{304E}\u{308B}\u{5024}: ${issue.origin}\u{306F}${issue.minimum.toString()}${sizing.unit}${adj}\u{5FC5}\u{8981}\u{304C}\u{3042}\u{308A}\u{307E}\u{3059}`;
                    return `\u{5C0F}\u{3055}\u{3059}\u{304E}\u{308B}\u{5024}: ${issue.origin}\u{306F}${issue.minimum.toString()}${adj}\u{5FC5}\u{8981}\u{304C}\u{3042}\u{308A}\u{307E}\u{3059}`;
                }
            case "invalid_format":
                {
                    const _issue = issue;
                    if (_issue.format === "starts_with") return `\u{7121}\u{52B9}\u{306A}\u{6587}\u{5B57}\u{5217}: "${_issue.prefix}"\u{3067}\u{59CB}\u{307E}\u{308B}\u{5FC5}\u{8981}\u{304C}\u{3042}\u{308A}\u{307E}\u{3059}`;
                    if (_issue.format === "ends_with") return `\u{7121}\u{52B9}\u{306A}\u{6587}\u{5B57}\u{5217}: "${_issue.suffix}"\u{3067}\u{7D42}\u{308F}\u{308B}\u{5FC5}\u{8981}\u{304C}\u{3042}\u{308A}\u{307E}\u{3059}`;
                    if (_issue.format === "includes") return `\u{7121}\u{52B9}\u{306A}\u{6587}\u{5B57}\u{5217}: "${_issue.includes}"\u{3092}\u{542B}\u{3080}\u{5FC5}\u{8981}\u{304C}\u{3042}\u{308A}\u{307E}\u{3059}`;
                    if (_issue.format === "regex") return `\u{7121}\u{52B9}\u{306A}\u{6587}\u{5B57}\u{5217}: \u{30D1}\u{30BF}\u{30FC}\u{30F3}${_issue.pattern}\u{306B}\u{4E00}\u{81F4}\u{3059}\u{308B}\u{5FC5}\u{8981}\u{304C}\u{3042}\u{308A}\u{307E}\u{3059}`;
                    return `\u{7121}\u{52B9}\u{306A}${Nouns[_issue.format] ?? issue.format}`;
                }
            case "not_multiple_of":
                return `\u{7121}\u{52B9}\u{306A}\u{6570}\u{5024}: ${issue.divisor}\u{306E}\u{500D}\u{6570}\u{3067}\u{3042}\u{308B}\u{5FC5}\u{8981}\u{304C}\u{3042}\u{308A}\u{307E}\u{3059}`;
            case "unrecognized_keys":
                return `\u{8A8D}\u{8B58}\u{3055}\u{308C}\u{3066}\u{3044}\u{306A}\u{3044}\u{30AD}\u{30FC}${issue.keys.length > 1 ? "\u7FA4" : ""}: ${$8f5391358ccbeba2$export$e79b744344f50f50(issue.keys, "\u3001")}`;
            case "invalid_key":
                return `${issue.origin}\u{5185}\u{306E}\u{7121}\u{52B9}\u{306A}\u{30AD}\u{30FC}`;
            case "invalid_union":
                return "\u7121\u52B9\u306A\u5165\u529B";
            case "invalid_element":
                return `${issue.origin}\u{5185}\u{306E}\u{7121}\u{52B9}\u{306A}\u{5024}`;
            default:
                return `\u{7121}\u{52B9}\u{306A}\u{5165}\u{529B}`;
        }
    };
};
function $57b8dee7734d7ce1$export$2e2bcd8739ae039() {
    return {
        localeError: $57b8dee7734d7ce1$var$error()
    };
}



const $46225d5c8e68f369$export$858d360cf6da2b65 = (data)=>{
    const t = typeof data;
    switch(t){
        case "number":
            return Number.isNaN(data) ? "NaN" : "\u10E0\u10D8\u10EA\u10EE\u10D5\u10D8";
        case "object":
            if (Array.isArray(data)) return "\u10DB\u10D0\u10E1\u10D8\u10D5\u10D8";
            if (data === null) return "null";
            if (Object.getPrototypeOf(data) !== Object.prototype && data.constructor) return data.constructor.name;
    }
    const typeMap = {
        string: "\u10E1\u10E2\u10E0\u10D8\u10DC\u10D2\u10D8",
        boolean: "\u10D1\u10E3\u10DA\u10D4\u10D0\u10DC\u10D8",
        undefined: "undefined",
        bigint: "bigint",
        symbol: "symbol",
        function: "\u10E4\u10E3\u10DC\u10E5\u10EA\u10D8\u10D0"
    };
    return typeMap[t] ?? t;
};
const $46225d5c8e68f369$var$error = ()=>{
    const Sizable = {
        string: {
            unit: "\u10E1\u10D8\u10DB\u10D1\u10DD\u10DA\u10DD",
            verb: "\u10E3\u10DC\u10D3\u10D0 \u10E8\u10D4\u10D8\u10EA\u10D0\u10D5\u10D3\u10D4\u10E1"
        },
        file: {
            unit: "\u10D1\u10D0\u10D8\u10E2\u10D8",
            verb: "\u10E3\u10DC\u10D3\u10D0 \u10E8\u10D4\u10D8\u10EA\u10D0\u10D5\u10D3\u10D4\u10E1"
        },
        array: {
            unit: "\u10D4\u10DA\u10D4\u10DB\u10D4\u10DC\u10E2\u10D8",
            verb: "\u10E3\u10DC\u10D3\u10D0 \u10E8\u10D4\u10D8\u10EA\u10D0\u10D5\u10D3\u10D4\u10E1"
        },
        set: {
            unit: "\u10D4\u10DA\u10D4\u10DB\u10D4\u10DC\u10E2\u10D8",
            verb: "\u10E3\u10DC\u10D3\u10D0 \u10E8\u10D4\u10D8\u10EA\u10D0\u10D5\u10D3\u10D4\u10E1"
        }
    };
    function getSizing(origin) {
        return Sizable[origin] ?? null;
    }
    const Nouns = {
        regex: "\u10E8\u10D4\u10E7\u10D5\u10D0\u10DC\u10D0",
        email: "\u10D4\u10DA-\u10E4\u10DD\u10E1\u10E2\u10D8\u10E1 \u10DB\u10D8\u10E1\u10D0\u10DB\u10D0\u10E0\u10D7\u10D8",
        url: "URL",
        emoji: "\u10D4\u10DB\u10DD\u10EF\u10D8",
        uuid: "UUID",
        uuidv4: "UUIDv4",
        uuidv6: "UUIDv6",
        nanoid: "nanoid",
        guid: "GUID",
        cuid: "cuid",
        cuid2: "cuid2",
        ulid: "ULID",
        xid: "XID",
        ksuid: "KSUID",
        datetime: "\u10D7\u10D0\u10E0\u10D8\u10E6\u10D8-\u10D3\u10E0\u10DD",
        date: "\u10D7\u10D0\u10E0\u10D8\u10E6\u10D8",
        time: "\u10D3\u10E0\u10DD",
        duration: "\u10EE\u10D0\u10DC\u10D2\u10E0\u10EB\u10DA\u10D8\u10D5\u10DD\u10D1\u10D0",
        ipv4: "IPv4 \u10DB\u10D8\u10E1\u10D0\u10DB\u10D0\u10E0\u10D7\u10D8",
        ipv6: "IPv6 \u10DB\u10D8\u10E1\u10D0\u10DB\u10D0\u10E0\u10D7\u10D8",
        cidrv4: "IPv4 \u10D3\u10D8\u10D0\u10DE\u10D0\u10D6\u10DD\u10DC\u10D8",
        cidrv6: "IPv6 \u10D3\u10D8\u10D0\u10DE\u10D0\u10D6\u10DD\u10DC\u10D8",
        base64: "base64-\u10D9\u10DD\u10D3\u10D8\u10E0\u10D4\u10D1\u10E3\u10DA\u10D8 \u10E1\u10E2\u10E0\u10D8\u10DC\u10D2\u10D8",
        base64url: "base64url-\u10D9\u10DD\u10D3\u10D8\u10E0\u10D4\u10D1\u10E3\u10DA\u10D8 \u10E1\u10E2\u10E0\u10D8\u10DC\u10D2\u10D8",
        json_string: "JSON \u10E1\u10E2\u10E0\u10D8\u10DC\u10D2\u10D8",
        e164: "E.164 \u10DC\u10DD\u10DB\u10D4\u10E0\u10D8",
        jwt: "JWT",
        template_literal: "\u10E8\u10D4\u10E7\u10D5\u10D0\u10DC\u10D0"
    };
    return (issue)=>{
        switch(issue.code){
            case "invalid_type":
                return `\u{10D0}\u{10E0}\u{10D0}\u{10E1}\u{10EC}\u{10DD}\u{10E0}\u{10D8} \u{10E8}\u{10D4}\u{10E7}\u{10D5}\u{10D0}\u{10DC}\u{10D0}: \u{10DB}\u{10DD}\u{10E1}\u{10D0}\u{10DA}\u{10DD}\u{10D3}\u{10DC}\u{10D4}\u{10DA}\u{10D8} ${issue.expected}, \u{10DB}\u{10D8}\u{10E6}\u{10D4}\u{10D1}\u{10E3}\u{10DA}\u{10D8} ${$46225d5c8e68f369$export$858d360cf6da2b65(issue.input)}`;
            case "invalid_value":
                if (issue.values.length === 1) return `\u{10D0}\u{10E0}\u{10D0}\u{10E1}\u{10EC}\u{10DD}\u{10E0}\u{10D8} \u{10E8}\u{10D4}\u{10E7}\u{10D5}\u{10D0}\u{10DC}\u{10D0}: \u{10DB}\u{10DD}\u{10E1}\u{10D0}\u{10DA}\u{10DD}\u{10D3}\u{10DC}\u{10D4}\u{10DA}\u{10D8} ${$8f5391358ccbeba2$export$5859860f650378f4(issue.values[0])}`;
                return `\u{10D0}\u{10E0}\u{10D0}\u{10E1}\u{10EC}\u{10DD}\u{10E0}\u{10D8} \u{10D5}\u{10D0}\u{10E0}\u{10D8}\u{10D0}\u{10DC}\u{10E2}\u{10D8}: \u{10DB}\u{10DD}\u{10E1}\u{10D0}\u{10DA}\u{10DD}\u{10D3}\u{10DC}\u{10D4}\u{10DA}\u{10D8}\u{10D0} \u{10D4}\u{10E0}\u{10D7}-\u{10D4}\u{10E0}\u{10D7}\u{10D8} ${$8f5391358ccbeba2$export$e79b744344f50f50(issue.values, "|")}-\u{10D3}\u{10D0}\u{10DC}`;
            case "too_big":
                {
                    const adj = issue.inclusive ? "<=" : "<";
                    const sizing = getSizing(issue.origin);
                    if (sizing) return `\u{10D6}\u{10D4}\u{10D3}\u{10DB}\u{10D4}\u{10E2}\u{10D0}\u{10D3} \u{10D3}\u{10D8}\u{10D3}\u{10D8}: \u{10DB}\u{10DD}\u{10E1}\u{10D0}\u{10DA}\u{10DD}\u{10D3}\u{10DC}\u{10D4}\u{10DA}\u{10D8} ${issue.origin ?? "\u10DB\u10DC\u10D8\u10E8\u10D5\u10DC\u10D4\u10DA\u10DD\u10D1\u10D0"} ${sizing.verb} ${adj}${issue.maximum.toString()} ${sizing.unit}`;
                    return `\u{10D6}\u{10D4}\u{10D3}\u{10DB}\u{10D4}\u{10E2}\u{10D0}\u{10D3} \u{10D3}\u{10D8}\u{10D3}\u{10D8}: \u{10DB}\u{10DD}\u{10E1}\u{10D0}\u{10DA}\u{10DD}\u{10D3}\u{10DC}\u{10D4}\u{10DA}\u{10D8} ${issue.origin ?? "\u10DB\u10DC\u10D8\u10E8\u10D5\u10DC\u10D4\u10DA\u10DD\u10D1\u10D0"} \u{10D8}\u{10E7}\u{10DD}\u{10E1} ${adj}${issue.maximum.toString()}`;
                }
            case "too_small":
                {
                    const adj = issue.inclusive ? ">=" : ">";
                    const sizing = getSizing(issue.origin);
                    if (sizing) return `\u{10D6}\u{10D4}\u{10D3}\u{10DB}\u{10D4}\u{10E2}\u{10D0}\u{10D3} \u{10DE}\u{10D0}\u{10E2}\u{10D0}\u{10E0}\u{10D0}: \u{10DB}\u{10DD}\u{10E1}\u{10D0}\u{10DA}\u{10DD}\u{10D3}\u{10DC}\u{10D4}\u{10DA}\u{10D8} ${issue.origin} ${sizing.verb} ${adj}${issue.minimum.toString()} ${sizing.unit}`;
                    return `\u{10D6}\u{10D4}\u{10D3}\u{10DB}\u{10D4}\u{10E2}\u{10D0}\u{10D3} \u{10DE}\u{10D0}\u{10E2}\u{10D0}\u{10E0}\u{10D0}: \u{10DB}\u{10DD}\u{10E1}\u{10D0}\u{10DA}\u{10DD}\u{10D3}\u{10DC}\u{10D4}\u{10DA}\u{10D8} ${issue.origin} \u{10D8}\u{10E7}\u{10DD}\u{10E1} ${adj}${issue.minimum.toString()}`;
                }
            case "invalid_format":
                {
                    const _issue = issue;
                    if (_issue.format === "starts_with") return `\u{10D0}\u{10E0}\u{10D0}\u{10E1}\u{10EC}\u{10DD}\u{10E0}\u{10D8} \u{10E1}\u{10E2}\u{10E0}\u{10D8}\u{10DC}\u{10D2}\u{10D8}: \u{10E3}\u{10DC}\u{10D3}\u{10D0} \u{10D8}\u{10EC}\u{10E7}\u{10D4}\u{10D1}\u{10DD}\u{10D3}\u{10D4}\u{10E1} "${_issue.prefix}"-\u{10D8}\u{10D7}`;
                    if (_issue.format === "ends_with") return `\u{10D0}\u{10E0}\u{10D0}\u{10E1}\u{10EC}\u{10DD}\u{10E0}\u{10D8} \u{10E1}\u{10E2}\u{10E0}\u{10D8}\u{10DC}\u{10D2}\u{10D8}: \u{10E3}\u{10DC}\u{10D3}\u{10D0} \u{10DB}\u{10D7}\u{10D0}\u{10D5}\u{10E0}\u{10D3}\u{10D4}\u{10D1}\u{10DD}\u{10D3}\u{10D4}\u{10E1} "${_issue.suffix}"-\u{10D8}\u{10D7}`;
                    if (_issue.format === "includes") return `\u{10D0}\u{10E0}\u{10D0}\u{10E1}\u{10EC}\u{10DD}\u{10E0}\u{10D8} \u{10E1}\u{10E2}\u{10E0}\u{10D8}\u{10DC}\u{10D2}\u{10D8}: \u{10E3}\u{10DC}\u{10D3}\u{10D0} \u{10E8}\u{10D4}\u{10D8}\u{10EA}\u{10D0}\u{10D5}\u{10D3}\u{10D4}\u{10E1} "${_issue.includes}"-\u{10E1}`;
                    if (_issue.format === "regex") return `\u{10D0}\u{10E0}\u{10D0}\u{10E1}\u{10EC}\u{10DD}\u{10E0}\u{10D8} \u{10E1}\u{10E2}\u{10E0}\u{10D8}\u{10DC}\u{10D2}\u{10D8}: \u{10E3}\u{10DC}\u{10D3}\u{10D0} \u{10E8}\u{10D4}\u{10D4}\u{10E1}\u{10D0}\u{10D1}\u{10D0}\u{10DB}\u{10D4}\u{10D1}\u{10DD}\u{10D3}\u{10D4}\u{10E1} \u{10E8}\u{10D0}\u{10D1}\u{10DA}\u{10DD}\u{10DC}\u{10E1} ${_issue.pattern}`;
                    return `\u{10D0}\u{10E0}\u{10D0}\u{10E1}\u{10EC}\u{10DD}\u{10E0}\u{10D8} ${Nouns[_issue.format] ?? issue.format}`;
                }
            case "not_multiple_of":
                return `\u{10D0}\u{10E0}\u{10D0}\u{10E1}\u{10EC}\u{10DD}\u{10E0}\u{10D8} \u{10E0}\u{10D8}\u{10EA}\u{10EE}\u{10D5}\u{10D8}: \u{10E3}\u{10DC}\u{10D3}\u{10D0} \u{10D8}\u{10E7}\u{10DD}\u{10E1} ${issue.divisor}-\u{10D8}\u{10E1} \u{10EF}\u{10D4}\u{10E0}\u{10D0}\u{10D3}\u{10D8}`;
            case "unrecognized_keys":
                return `\u{10E3}\u{10EA}\u{10DC}\u{10DD}\u{10D1}\u{10D8} \u{10D2}\u{10D0}\u{10E1}\u{10D0}\u{10E6}\u{10D4}\u{10D1}${issue.keys.length > 1 ? "\u10D4\u10D1\u10D8" : "\u10D8"}: ${$8f5391358ccbeba2$export$e79b744344f50f50(issue.keys, ", ")}`;
            case "invalid_key":
                return `\u{10D0}\u{10E0}\u{10D0}\u{10E1}\u{10EC}\u{10DD}\u{10E0}\u{10D8} \u{10D2}\u{10D0}\u{10E1}\u{10D0}\u{10E6}\u{10D4}\u{10D1}\u{10D8} ${issue.origin}-\u{10E8}\u{10D8}`;
            case "invalid_union":
                return "\u10D0\u10E0\u10D0\u10E1\u10EC\u10DD\u10E0\u10D8 \u10E8\u10D4\u10E7\u10D5\u10D0\u10DC\u10D0";
            case "invalid_element":
                return `\u{10D0}\u{10E0}\u{10D0}\u{10E1}\u{10EC}\u{10DD}\u{10E0}\u{10D8} \u{10DB}\u{10DC}\u{10D8}\u{10E8}\u{10D5}\u{10DC}\u{10D4}\u{10DA}\u{10DD}\u{10D1}\u{10D0} ${issue.origin}-\u{10E8}\u{10D8}`;
            default:
                return `\u{10D0}\u{10E0}\u{10D0}\u{10E1}\u{10EC}\u{10DD}\u{10E0}\u{10D8} \u{10E8}\u{10D4}\u{10E7}\u{10D5}\u{10D0}\u{10DC}\u{10D0}`;
        }
    };
};
function $46225d5c8e68f369$export$2e2bcd8739ae039() {
    return {
        localeError: $46225d5c8e68f369$var$error()
    };
}



const $ba2155e6709af442$var$error = ()=>{
    const Sizable = {
        string: {
            unit: "\u178F\u17BD\u17A2\u1780\u17D2\u179F\u179A",
            verb: "\u1782\u17BD\u179A\u1798\u17B6\u1793"
        },
        file: {
            unit: "\u1794\u17C3",
            verb: "\u1782\u17BD\u179A\u1798\u17B6\u1793"
        },
        array: {
            unit: "\u1792\u17B6\u178F\u17BB",
            verb: "\u1782\u17BD\u179A\u1798\u17B6\u1793"
        },
        set: {
            unit: "\u1792\u17B6\u178F\u17BB",
            verb: "\u1782\u17BD\u179A\u1798\u17B6\u1793"
        }
    };
    function getSizing(origin) {
        return Sizable[origin] ?? null;
    }
    const parsedType = (data)=>{
        const t = typeof data;
        switch(t){
            case "number":
                return Number.isNaN(data) ? "\u1798\u17B7\u1793\u1798\u17C2\u1793\u1787\u17B6\u179B\u17C1\u1781 (NaN)" : "\u179B\u17C1\u1781";
            case "object":
                if (Array.isArray(data)) return "\u17A2\u17B6\u179A\u17C1 (Array)";
                if (data === null) return "\u1782\u17D2\u1798\u17B6\u1793\u178F\u1798\u17D2\u179B\u17C3 (null)";
                if (Object.getPrototypeOf(data) !== Object.prototype && data.constructor) return data.constructor.name;
        }
        return t;
    };
    const Nouns = {
        regex: "\u1791\u17B7\u1793\u17D2\u1793\u1793\u17D0\u1799\u1794\u1789\u17D2\u1785\u17BC\u179B",
        email: "\u17A2\u17B6\u179F\u1799\u178A\u17D2\u178B\u17B6\u1793\u17A2\u17CA\u17B8\u1798\u17C2\u179B",
        url: "URL",
        emoji: "\u179F\u1789\u17D2\u1789\u17B6\u17A2\u17B6\u179A\u1798\u17D2\u1798\u178E\u17CD",
        uuid: "UUID",
        uuidv4: "UUIDv4",
        uuidv6: "UUIDv6",
        nanoid: "nanoid",
        guid: "GUID",
        cuid: "cuid",
        cuid2: "cuid2",
        ulid: "ULID",
        xid: "XID",
        ksuid: "KSUID",
        datetime: "\u1780\u17B6\u179B\u1794\u179A\u17B7\u1785\u17D2\u1786\u17C1\u1791 \u1793\u17B7\u1784\u1798\u17C9\u17C4\u1784 ISO",
        date: "\u1780\u17B6\u179B\u1794\u179A\u17B7\u1785\u17D2\u1786\u17C1\u1791 ISO",
        time: "\u1798\u17C9\u17C4\u1784 ISO",
        duration: "\u179A\u1799\u17C8\u1796\u17C1\u179B ISO",
        ipv4: "\u17A2\u17B6\u179F\u1799\u178A\u17D2\u178B\u17B6\u1793 IPv4",
        ipv6: "\u17A2\u17B6\u179F\u1799\u178A\u17D2\u178B\u17B6\u1793 IPv6",
        cidrv4: "\u178A\u17C2\u1793\u17A2\u17B6\u179F\u1799\u178A\u17D2\u178B\u17B6\u1793 IPv4",
        cidrv6: "\u178A\u17C2\u1793\u17A2\u17B6\u179F\u1799\u178A\u17D2\u178B\u17B6\u1793 IPv6",
        base64: "\u1781\u17D2\u179F\u17C2\u17A2\u1780\u17D2\u179F\u179A\u17A2\u17CA\u17B7\u1780\u17BC\u178A base64",
        base64url: "\u1781\u17D2\u179F\u17C2\u17A2\u1780\u17D2\u179F\u179A\u17A2\u17CA\u17B7\u1780\u17BC\u178A base64url",
        json_string: "\u1781\u17D2\u179F\u17C2\u17A2\u1780\u17D2\u179F\u179A JSON",
        e164: "\u179B\u17C1\u1781 E.164",
        jwt: "JWT",
        template_literal: "\u1791\u17B7\u1793\u17D2\u1793\u1793\u17D0\u1799\u1794\u1789\u17D2\u1785\u17BC\u179B"
    };
    return (issue)=>{
        switch(issue.code){
            case "invalid_type":
                return `\u{1791}\u{17B7}\u{1793}\u{17D2}\u{1793}\u{1793}\u{17D0}\u{1799}\u{1794}\u{1789}\u{17D2}\u{1785}\u{17BC}\u{179B}\u{1798}\u{17B7}\u{1793}\u{178F}\u{17D2}\u{179A}\u{17B9}\u{1798}\u{178F}\u{17D2}\u{179A}\u{17BC}\u{179C}\u{17D6} \u{178F}\u{17D2}\u{179A}\u{17BC}\u{179C}\u{1780}\u{17B6}\u{179A} ${issue.expected} \u{1794}\u{17C9}\u{17BB}\u{1793}\u{17D2}\u{178F}\u{17C2}\u{1791}\u{1791}\u{17BD}\u{179B}\u{1794}\u{17B6}\u{1793} ${parsedType(issue.input)}`;
            case "invalid_value":
                if (issue.values.length === 1) return `\u{1791}\u{17B7}\u{1793}\u{17D2}\u{1793}\u{1793}\u{17D0}\u{1799}\u{1794}\u{1789}\u{17D2}\u{1785}\u{17BC}\u{179B}\u{1798}\u{17B7}\u{1793}\u{178F}\u{17D2}\u{179A}\u{17B9}\u{1798}\u{178F}\u{17D2}\u{179A}\u{17BC}\u{179C}\u{17D6} \u{178F}\u{17D2}\u{179A}\u{17BC}\u{179C}\u{1780}\u{17B6}\u{179A} ${$8f5391358ccbeba2$export$5859860f650378f4(issue.values[0])}`;
                return `\u{1787}\u{1798}\u{17D2}\u{179A}\u{17BE}\u{179F}\u{1798}\u{17B7}\u{1793}\u{178F}\u{17D2}\u{179A}\u{17B9}\u{1798}\u{178F}\u{17D2}\u{179A}\u{17BC}\u{179C}\u{17D6} \u{178F}\u{17D2}\u{179A}\u{17BC}\u{179C}\u{1787}\u{17B6}\u{1798}\u{17BD}\u{1799}\u{1780}\u{17D2}\u{1793}\u{17BB}\u{1784}\u{1785}\u{17C6}\u{178E}\u{17C4}\u{1798} ${$8f5391358ccbeba2$export$e79b744344f50f50(issue.values, "|")}`;
            case "too_big":
                {
                    const adj = issue.inclusive ? "<=" : "<";
                    const sizing = getSizing(issue.origin);
                    if (sizing) return `\u{1792}\u{17C6}\u{1796}\u{17C1}\u{1780}\u{17D6} \u{178F}\u{17D2}\u{179A}\u{17BC}\u{179C}\u{1780}\u{17B6}\u{179A} ${issue.origin ?? "\u178F\u1798\u17D2\u179B\u17C3"} ${adj} ${issue.maximum.toString()} ${sizing.unit ?? "\u1792\u17B6\u178F\u17BB"}`;
                    return `\u{1792}\u{17C6}\u{1796}\u{17C1}\u{1780}\u{17D6} \u{178F}\u{17D2}\u{179A}\u{17BC}\u{179C}\u{1780}\u{17B6}\u{179A} ${issue.origin ?? "\u178F\u1798\u17D2\u179B\u17C3"} ${adj} ${issue.maximum.toString()}`;
                }
            case "too_small":
                {
                    const adj = issue.inclusive ? ">=" : ">";
                    const sizing = getSizing(issue.origin);
                    if (sizing) return `\u{178F}\u{17BC}\u{1785}\u{1796}\u{17C1}\u{1780}\u{17D6} \u{178F}\u{17D2}\u{179A}\u{17BC}\u{179C}\u{1780}\u{17B6}\u{179A} ${issue.origin} ${adj} ${issue.minimum.toString()} ${sizing.unit}`;
                    return `\u{178F}\u{17BC}\u{1785}\u{1796}\u{17C1}\u{1780}\u{17D6} \u{178F}\u{17D2}\u{179A}\u{17BC}\u{179C}\u{1780}\u{17B6}\u{179A} ${issue.origin} ${adj} ${issue.minimum.toString()}`;
                }
            case "invalid_format":
                {
                    const _issue = issue;
                    if (_issue.format === "starts_with") return `\u{1781}\u{17D2}\u{179F}\u{17C2}\u{17A2}\u{1780}\u{17D2}\u{179F}\u{179A}\u{1798}\u{17B7}\u{1793}\u{178F}\u{17D2}\u{179A}\u{17B9}\u{1798}\u{178F}\u{17D2}\u{179A}\u{17BC}\u{179C}\u{17D6} \u{178F}\u{17D2}\u{179A}\u{17BC}\u{179C}\u{1785}\u{17B6}\u{1794}\u{17CB}\u{1795}\u{17D2}\u{178F}\u{17BE}\u{1798}\u{178A}\u{17C4}\u{1799} "${_issue.prefix}"`;
                    if (_issue.format === "ends_with") return `\u{1781}\u{17D2}\u{179F}\u{17C2}\u{17A2}\u{1780}\u{17D2}\u{179F}\u{179A}\u{1798}\u{17B7}\u{1793}\u{178F}\u{17D2}\u{179A}\u{17B9}\u{1798}\u{178F}\u{17D2}\u{179A}\u{17BC}\u{179C}\u{17D6} \u{178F}\u{17D2}\u{179A}\u{17BC}\u{179C}\u{1794}\u{1789}\u{17D2}\u{1785}\u{1794}\u{17CB}\u{178A}\u{17C4}\u{1799} "${_issue.suffix}"`;
                    if (_issue.format === "includes") return `\u{1781}\u{17D2}\u{179F}\u{17C2}\u{17A2}\u{1780}\u{17D2}\u{179F}\u{179A}\u{1798}\u{17B7}\u{1793}\u{178F}\u{17D2}\u{179A}\u{17B9}\u{1798}\u{178F}\u{17D2}\u{179A}\u{17BC}\u{179C}\u{17D6} \u{178F}\u{17D2}\u{179A}\u{17BC}\u{179C}\u{1798}\u{17B6}\u{1793} "${_issue.includes}"`;
                    if (_issue.format === "regex") return `\u{1781}\u{17D2}\u{179F}\u{17C2}\u{17A2}\u{1780}\u{17D2}\u{179F}\u{179A}\u{1798}\u{17B7}\u{1793}\u{178F}\u{17D2}\u{179A}\u{17B9}\u{1798}\u{178F}\u{17D2}\u{179A}\u{17BC}\u{179C}\u{17D6} \u{178F}\u{17D2}\u{179A}\u{17BC}\u{179C}\u{178F}\u{17C2}\u{1795}\u{17D2}\u{1782}\u{17BC}\u{1795}\u{17D2}\u{1782}\u{1784}\u{1793}\u{17B9}\u{1784}\u{1791}\u{1798}\u{17D2}\u{179A}\u{1784}\u{17CB}\u{178A}\u{17C2}\u{179B}\u{1794}\u{17B6}\u{1793}\u{1780}\u{17C6}\u{178E}\u{178F}\u{17CB} ${_issue.pattern}`;
                    return `\u{1798}\u{17B7}\u{1793}\u{178F}\u{17D2}\u{179A}\u{17B9}\u{1798}\u{178F}\u{17D2}\u{179A}\u{17BC}\u{179C}\u{17D6} ${Nouns[_issue.format] ?? issue.format}`;
                }
            case "not_multiple_of":
                return `\u{179B}\u{17C1}\u{1781}\u{1798}\u{17B7}\u{1793}\u{178F}\u{17D2}\u{179A}\u{17B9}\u{1798}\u{178F}\u{17D2}\u{179A}\u{17BC}\u{179C}\u{17D6} \u{178F}\u{17D2}\u{179A}\u{17BC}\u{179C}\u{178F}\u{17C2}\u{1787}\u{17B6}\u{1796}\u{17A0}\u{17BB}\u{1782}\u{17BB}\u{178E}\u{1793}\u{17C3} ${issue.divisor}`;
            case "unrecognized_keys":
                return `\u{179A}\u{1780}\u{1783}\u{17BE}\u{1789}\u{179F}\u{17C4}\u{1798}\u{17B7}\u{1793}\u{179F}\u{17D2}\u{1782}\u{17B6}\u{179B}\u{17CB}\u{17D6} ${$8f5391358ccbeba2$export$e79b744344f50f50(issue.keys, ", ")}`;
            case "invalid_key":
                return `\u{179F}\u{17C4}\u{1798}\u{17B7}\u{1793}\u{178F}\u{17D2}\u{179A}\u{17B9}\u{1798}\u{178F}\u{17D2}\u{179A}\u{17BC}\u{179C}\u{1793}\u{17C5}\u{1780}\u{17D2}\u{1793}\u{17BB}\u{1784} ${issue.origin}`;
            case "invalid_union":
                return `\u{1791}\u{17B7}\u{1793}\u{17D2}\u{1793}\u{1793}\u{17D0}\u{1799}\u{1798}\u{17B7}\u{1793}\u{178F}\u{17D2}\u{179A}\u{17B9}\u{1798}\u{178F}\u{17D2}\u{179A}\u{17BC}\u{179C}`;
            case "invalid_element":
                return `\u{1791}\u{17B7}\u{1793}\u{17D2}\u{1793}\u{1793}\u{17D0}\u{1799}\u{1798}\u{17B7}\u{1793}\u{178F}\u{17D2}\u{179A}\u{17B9}\u{1798}\u{178F}\u{17D2}\u{179A}\u{17BC}\u{179C}\u{1793}\u{17C5}\u{1780}\u{17D2}\u{1793}\u{17BB}\u{1784} ${issue.origin}`;
            default:
                return `\u{1791}\u{17B7}\u{1793}\u{17D2}\u{1793}\u{1793}\u{17D0}\u{1799}\u{1798}\u{17B7}\u{1793}\u{178F}\u{17D2}\u{179A}\u{17B9}\u{1798}\u{178F}\u{17D2}\u{179A}\u{17BC}\u{179C}`;
        }
    };
};
function $ba2155e6709af442$export$2e2bcd8739ae039() {
    return {
        localeError: $ba2155e6709af442$var$error()
    };
}


function $6bd99c45933e5e8b$export$2e2bcd8739ae039() {
    return (0, $ba2155e6709af442$export$2e2bcd8739ae039)();
}




const $1568a95bd241b9de$var$error = ()=>{
    const Sizable = {
        string: {
            unit: "\uBB38\uC790",
            verb: "to have"
        },
        file: {
            unit: "\uBC14\uC774\uD2B8",
            verb: "to have"
        },
        array: {
            unit: "\uAC1C",
            verb: "to have"
        },
        set: {
            unit: "\uAC1C",
            verb: "to have"
        }
    };
    function getSizing(origin) {
        return Sizable[origin] ?? null;
    }
    const parsedType = (data)=>{
        const t = typeof data;
        switch(t){
            case "number":
                return Number.isNaN(data) ? "NaN" : "number";
            case "object":
                if (Array.isArray(data)) return "array";
                if (data === null) return "null";
                if (Object.getPrototypeOf(data) !== Object.prototype && data.constructor) return data.constructor.name;
        }
        return t;
    };
    const Nouns = {
        regex: "\uC785\uB825",
        email: "\uC774\uBA54\uC77C \uC8FC\uC18C",
        url: "URL",
        emoji: "\uC774\uBAA8\uC9C0",
        uuid: "UUID",
        uuidv4: "UUIDv4",
        uuidv6: "UUIDv6",
        nanoid: "nanoid",
        guid: "GUID",
        cuid: "cuid",
        cuid2: "cuid2",
        ulid: "ULID",
        xid: "XID",
        ksuid: "KSUID",
        datetime: "ISO \uB0A0\uC9DC\uC2DC\uAC04",
        date: "ISO \uB0A0\uC9DC",
        time: "ISO \uC2DC\uAC04",
        duration: "ISO \uAE30\uAC04",
        ipv4: "IPv4 \uC8FC\uC18C",
        ipv6: "IPv6 \uC8FC\uC18C",
        cidrv4: "IPv4 \uBC94\uC704",
        cidrv6: "IPv6 \uBC94\uC704",
        base64: "base64 \uC778\uCF54\uB529 \uBB38\uC790\uC5F4",
        base64url: "base64url \uC778\uCF54\uB529 \uBB38\uC790\uC5F4",
        json_string: "JSON \uBB38\uC790\uC5F4",
        e164: "E.164 \uBC88\uD638",
        jwt: "JWT",
        template_literal: "\uC785\uB825"
    };
    return (issue)=>{
        switch(issue.code){
            case "invalid_type":
                return `\u{C798}\u{BABB}\u{B41C} \u{C785}\u{B825}: \u{C608}\u{C0C1} \u{D0C0}\u{C785}\u{C740} ${issue.expected}, \u{BC1B}\u{C740} \u{D0C0}\u{C785}\u{C740} ${parsedType(issue.input)}\u{C785}\u{B2C8}\u{B2E4}`;
            case "invalid_value":
                if (issue.values.length === 1) return `\u{C798}\u{BABB}\u{B41C} \u{C785}\u{B825}: \u{AC12}\u{C740} ${$8f5391358ccbeba2$export$5859860f650378f4(issue.values[0])} \u{C774}\u{C5B4}\u{C57C} \u{D569}\u{B2C8}\u{B2E4}`;
                return `\u{C798}\u{BABB}\u{B41C} \u{C635}\u{C158}: ${$8f5391358ccbeba2$export$e79b744344f50f50(issue.values, "\uB610\uB294 ")} \u{C911} \u{D558}\u{B098}\u{C5EC}\u{C57C} \u{D569}\u{B2C8}\u{B2E4}`;
            case "too_big":
                {
                    const adj = issue.inclusive ? "\uC774\uD558" : "\uBBF8\uB9CC";
                    const suffix = adj === "\uBBF8\uB9CC" ? "\uC774\uC5B4\uC57C \uD569\uB2C8\uB2E4" : "\uC5EC\uC57C \uD569\uB2C8\uB2E4";
                    const sizing = getSizing(issue.origin);
                    const unit = sizing?.unit ?? "\uC694\uC18C";
                    if (sizing) return `${issue.origin ?? "\uAC12"}\u{C774} \u{B108}\u{BB34} \u{D07D}\u{B2C8}\u{B2E4}: ${issue.maximum.toString()}${unit} ${adj}${suffix}`;
                    return `${issue.origin ?? "\uAC12"}\u{C774} \u{B108}\u{BB34} \u{D07D}\u{B2C8}\u{B2E4}: ${issue.maximum.toString()} ${adj}${suffix}`;
                }
            case "too_small":
                {
                    const adj = issue.inclusive ? "\uC774\uC0C1" : "\uCD08\uACFC";
                    const suffix = adj === "\uC774\uC0C1" ? "\uC774\uC5B4\uC57C \uD569\uB2C8\uB2E4" : "\uC5EC\uC57C \uD569\uB2C8\uB2E4";
                    const sizing = getSizing(issue.origin);
                    const unit = sizing?.unit ?? "\uC694\uC18C";
                    if (sizing) return `${issue.origin ?? "\uAC12"}\u{C774} \u{B108}\u{BB34} \u{C791}\u{C2B5}\u{B2C8}\u{B2E4}: ${issue.minimum.toString()}${unit} ${adj}${suffix}`;
                    return `${issue.origin ?? "\uAC12"}\u{C774} \u{B108}\u{BB34} \u{C791}\u{C2B5}\u{B2C8}\u{B2E4}: ${issue.minimum.toString()} ${adj}${suffix}`;
                }
            case "invalid_format":
                {
                    const _issue = issue;
                    if (_issue.format === "starts_with") return `\u{C798}\u{BABB}\u{B41C} \u{BB38}\u{C790}\u{C5F4}: "${_issue.prefix}"(\u{C73C})\u{B85C} \u{C2DC}\u{C791}\u{D574}\u{C57C} \u{D569}\u{B2C8}\u{B2E4}`;
                    if (_issue.format === "ends_with") return `\u{C798}\u{BABB}\u{B41C} \u{BB38}\u{C790}\u{C5F4}: "${_issue.suffix}"(\u{C73C})\u{B85C} \u{B05D}\u{B098}\u{C57C} \u{D569}\u{B2C8}\u{B2E4}`;
                    if (_issue.format === "includes") return `\u{C798}\u{BABB}\u{B41C} \u{BB38}\u{C790}\u{C5F4}: "${_issue.includes}"\u{C744}(\u{B97C}) \u{D3EC}\u{D568}\u{D574}\u{C57C} \u{D569}\u{B2C8}\u{B2E4}`;
                    if (_issue.format === "regex") return `\u{C798}\u{BABB}\u{B41C} \u{BB38}\u{C790}\u{C5F4}: \u{C815}\u{ADDC}\u{C2DD} ${_issue.pattern} \u{D328}\u{D134}\u{ACFC} \u{C77C}\u{CE58}\u{D574}\u{C57C} \u{D569}\u{B2C8}\u{B2E4}`;
                    return `\u{C798}\u{BABB}\u{B41C} ${Nouns[_issue.format] ?? issue.format}`;
                }
            case "not_multiple_of":
                return `\u{C798}\u{BABB}\u{B41C} \u{C22B}\u{C790}: ${issue.divisor}\u{C758} \u{BC30}\u{C218}\u{C5EC}\u{C57C} \u{D569}\u{B2C8}\u{B2E4}`;
            case "unrecognized_keys":
                return `\u{C778}\u{C2DD}\u{D560} \u{C218} \u{C5C6}\u{B294} \u{D0A4}: ${$8f5391358ccbeba2$export$e79b744344f50f50(issue.keys, ", ")}`;
            case "invalid_key":
                return `\u{C798}\u{BABB}\u{B41C} \u{D0A4}: ${issue.origin}`;
            case "invalid_union":
                return `\u{C798}\u{BABB}\u{B41C} \u{C785}\u{B825}`;
            case "invalid_element":
                return `\u{C798}\u{BABB}\u{B41C} \u{AC12}: ${issue.origin}`;
            default:
                return `\u{C798}\u{BABB}\u{B41C} \u{C785}\u{B825}`;
        }
    };
};
function $1568a95bd241b9de$export$2e2bcd8739ae039() {
    return {
        localeError: $1568a95bd241b9de$var$error()
    };
}



const $983ed49554be1f62$export$858d360cf6da2b65 = (data)=>{
    const t = typeof data;
    return $983ed49554be1f62$var$parsedTypeFromType(t, data);
};
const $983ed49554be1f62$var$parsedTypeFromType = (t, data)=>{
    switch(t){
        case "number":
            return Number.isNaN(data) ? "NaN" : "skai\u010Dius";
        case "bigint":
            return "sveikasis skai\u010Dius";
        case "string":
            return "eilut\u0117";
        case "boolean":
            return "login\u0117 reik\u0161m\u0117";
        case "undefined":
        case "void":
            return "neapibr\u0117\u017Eta reik\u0161m\u0117";
        case "function":
            return "funkcija";
        case "symbol":
            return "simbolis";
        case "object":
            if (data === undefined) return "ne\u017Einomas objektas";
            if (data === null) return "nulin\u0117 reik\u0161m\u0117";
            if (Array.isArray(data)) return "masyvas";
            if (Object.getPrototypeOf(data) !== Object.prototype && data.constructor) return data.constructor.name;
            return "objektas";
        //Zod types below
        case "null":
            return "nulin\u0117 reik\u0161m\u0117";
    }
    return t;
};
const $983ed49554be1f62$var$capitalizeFirstCharacter = (text)=>{
    return text.charAt(0).toUpperCase() + text.slice(1);
};
function $983ed49554be1f62$var$getUnitTypeFromNumber(number) {
    const abs = Math.abs(number);
    const last = abs % 10;
    const last2 = abs % 100;
    if (last2 >= 11 && last2 <= 19 || last === 0) return "many";
    if (last === 1) return "one";
    return "few";
}
const $983ed49554be1f62$var$error = ()=>{
    const Sizable = {
        string: {
            unit: {
                one: "simbolis",
                few: "simboliai",
                many: "simboli\u0173"
            },
            verb: {
                smaller: {
                    inclusive: "turi b\u016Bti ne ilgesn\u0117 kaip",
                    notInclusive: "turi b\u016Bti trumpesn\u0117 kaip"
                },
                bigger: {
                    inclusive: "turi b\u016Bti ne trumpesn\u0117 kaip",
                    notInclusive: "turi b\u016Bti ilgesn\u0117 kaip"
                }
            }
        },
        file: {
            unit: {
                one: "baitas",
                few: "baitai",
                many: "bait\u0173"
            },
            verb: {
                smaller: {
                    inclusive: "turi b\u016Bti ne didesnis kaip",
                    notInclusive: "turi b\u016Bti ma\u017Eesnis kaip"
                },
                bigger: {
                    inclusive: "turi b\u016Bti ne ma\u017Eesnis kaip",
                    notInclusive: "turi b\u016Bti didesnis kaip"
                }
            }
        },
        array: {
            unit: {
                one: "element\u0105",
                few: "elementus",
                many: "element\u0173"
            },
            verb: {
                smaller: {
                    inclusive: "turi tur\u0117ti ne daugiau kaip",
                    notInclusive: "turi tur\u0117ti ma\u017Eiau kaip"
                },
                bigger: {
                    inclusive: "turi tur\u0117ti ne ma\u017Eiau kaip",
                    notInclusive: "turi tur\u0117ti daugiau kaip"
                }
            }
        },
        set: {
            unit: {
                one: "element\u0105",
                few: "elementus",
                many: "element\u0173"
            },
            verb: {
                smaller: {
                    inclusive: "turi tur\u0117ti ne daugiau kaip",
                    notInclusive: "turi tur\u0117ti ma\u017Eiau kaip"
                },
                bigger: {
                    inclusive: "turi tur\u0117ti ne ma\u017Eiau kaip",
                    notInclusive: "turi tur\u0117ti daugiau kaip"
                }
            }
        }
    };
    function getSizing(origin, unitType, inclusive, targetShouldBe) {
        const result = Sizable[origin] ?? null;
        if (result === null) return result;
        return {
            unit: result.unit[unitType],
            verb: result.verb[targetShouldBe][inclusive ? "inclusive" : "notInclusive"]
        };
    }
    const Nouns = {
        regex: "\u012Fvestis",
        email: "el. pa\u0161to adresas",
        url: "URL",
        emoji: "jaustukas",
        uuid: "UUID",
        uuidv4: "UUIDv4",
        uuidv6: "UUIDv6",
        nanoid: "nanoid",
        guid: "GUID",
        cuid: "cuid",
        cuid2: "cuid2",
        ulid: "ULID",
        xid: "XID",
        ksuid: "KSUID",
        datetime: "ISO data ir laikas",
        date: "ISO data",
        time: "ISO laikas",
        duration: "ISO trukm\u0117",
        ipv4: "IPv4 adresas",
        ipv6: "IPv6 adresas",
        cidrv4: "IPv4 tinklo prefiksas (CIDR)",
        cidrv6: "IPv6 tinklo prefiksas (CIDR)",
        base64: "base64 u\u017Ekoduota eilut\u0117",
        base64url: "base64url u\u017Ekoduota eilut\u0117",
        json_string: "JSON eilut\u0117",
        e164: "E.164 numeris",
        jwt: "JWT",
        template_literal: "\u012Fvestis"
    };
    return (issue)=>{
        switch(issue.code){
            case "invalid_type":
                return `Gautas tipas ${$983ed49554be1f62$export$858d360cf6da2b65(issue.input)}, o tik\u{117}tasi - ${$983ed49554be1f62$var$parsedTypeFromType(issue.expected)}`;
            case "invalid_value":
                if (issue.values.length === 1) return `Privalo b\u{16B}ti ${$8f5391358ccbeba2$export$5859860f650378f4(issue.values[0])}`;
                return `Privalo b\u{16B}ti vienas i\u{161} ${$8f5391358ccbeba2$export$e79b744344f50f50(issue.values, "|")} pasirinkim\u{173}`;
            case "too_big":
                {
                    const origin = $983ed49554be1f62$var$parsedTypeFromType(issue.origin);
                    const sizing = getSizing(issue.origin, $983ed49554be1f62$var$getUnitTypeFromNumber(Number(issue.maximum)), issue.inclusive ?? false, "smaller");
                    if (sizing?.verb) return `${$983ed49554be1f62$var$capitalizeFirstCharacter(origin ?? issue.origin ?? "reik\u0161m\u0117")} ${sizing.verb} ${issue.maximum.toString()} ${sizing.unit ?? "element\u0173"}`;
                    const adj = issue.inclusive ? "ne didesnis kaip" : "ma\u017Eesnis kaip";
                    return `${$983ed49554be1f62$var$capitalizeFirstCharacter(origin ?? issue.origin ?? "reik\u0161m\u0117")} turi b\u{16B}ti ${adj} ${issue.maximum.toString()} ${sizing?.unit}`;
                }
            case "too_small":
                {
                    const origin = $983ed49554be1f62$var$parsedTypeFromType(issue.origin);
                    const sizing = getSizing(issue.origin, $983ed49554be1f62$var$getUnitTypeFromNumber(Number(issue.minimum)), issue.inclusive ?? false, "bigger");
                    if (sizing?.verb) return `${$983ed49554be1f62$var$capitalizeFirstCharacter(origin ?? issue.origin ?? "reik\u0161m\u0117")} ${sizing.verb} ${issue.minimum.toString()} ${sizing.unit ?? "element\u0173"}`;
                    const adj = issue.inclusive ? "ne ma\u017Eesnis kaip" : "didesnis kaip";
                    return `${$983ed49554be1f62$var$capitalizeFirstCharacter(origin ?? issue.origin ?? "reik\u0161m\u0117")} turi b\u{16B}ti ${adj} ${issue.minimum.toString()} ${sizing?.unit}`;
                }
            case "invalid_format":
                {
                    const _issue = issue;
                    if (_issue.format === "starts_with") return `Eilut\u{117} privalo prasid\u{117}ti "${_issue.prefix}"`;
                    if (_issue.format === "ends_with") return `Eilut\u{117} privalo pasibaigti "${_issue.suffix}"`;
                    if (_issue.format === "includes") return `Eilut\u{117} privalo \u{12F}traukti "${_issue.includes}"`;
                    if (_issue.format === "regex") return `Eilut\u{117} privalo atitikti ${_issue.pattern}`;
                    return `Neteisingas ${Nouns[_issue.format] ?? issue.format}`;
                }
            case "not_multiple_of":
                return `Skai\u{10D}ius privalo b\u{16B}ti ${issue.divisor} kartotinis.`;
            case "unrecognized_keys":
                return `Neatpa\u{17E}int${issue.keys.length > 1 ? "i" : "as"} rakt${issue.keys.length > 1 ? "ai" : "as"}: ${$8f5391358ccbeba2$export$e79b744344f50f50(issue.keys, ", ")}`;
            case "invalid_key":
                return "Rastas klaidingas raktas";
            case "invalid_union":
                return "Klaidinga \u012Fvestis";
            case "invalid_element":
                {
                    const origin = $983ed49554be1f62$var$parsedTypeFromType(issue.origin);
                    return `${$983ed49554be1f62$var$capitalizeFirstCharacter(origin ?? issue.origin ?? "reik\u0161m\u0117")} turi klaiding\u{105} \u{12F}vest\u{12F}`;
                }
            default:
                return "Klaidinga \u012Fvestis";
        }
    };
};
function $983ed49554be1f62$export$2e2bcd8739ae039() {
    return {
        localeError: $983ed49554be1f62$var$error()
    };
}



const $76ea32247cbd302f$var$error = ()=>{
    const Sizable = {
        string: {
            unit: "\u0437\u043D\u0430\u0446\u0438",
            verb: "\u0434\u0430 \u0438\u043C\u0430\u0430\u0442"
        },
        file: {
            unit: "\u0431\u0430\u0458\u0442\u0438",
            verb: "\u0434\u0430 \u0438\u043C\u0430\u0430\u0442"
        },
        array: {
            unit: "\u0441\u0442\u0430\u0432\u043A\u0438",
            verb: "\u0434\u0430 \u0438\u043C\u0430\u0430\u0442"
        },
        set: {
            unit: "\u0441\u0442\u0430\u0432\u043A\u0438",
            verb: "\u0434\u0430 \u0438\u043C\u0430\u0430\u0442"
        }
    };
    function getSizing(origin) {
        return Sizable[origin] ?? null;
    }
    const parsedType = (data)=>{
        const t = typeof data;
        switch(t){
            case "number":
                return Number.isNaN(data) ? "NaN" : "\u0431\u0440\u043E\u0458";
            case "object":
                if (Array.isArray(data)) return "\u043D\u0438\u0437\u0430";
                if (data === null) return "null";
                if (Object.getPrototypeOf(data) !== Object.prototype && data.constructor) return data.constructor.name;
        }
        return t;
    };
    const Nouns = {
        regex: "\u0432\u043D\u0435\u0441",
        email: "\u0430\u0434\u0440\u0435\u0441\u0430 \u043D\u0430 \u0435-\u043F\u043E\u0448\u0442\u0430",
        url: "URL",
        emoji: "\u0435\u043C\u043E\u045F\u0438",
        uuid: "UUID",
        uuidv4: "UUIDv4",
        uuidv6: "UUIDv6",
        nanoid: "nanoid",
        guid: "GUID",
        cuid: "cuid",
        cuid2: "cuid2",
        ulid: "ULID",
        xid: "XID",
        ksuid: "KSUID",
        datetime: "ISO \u0434\u0430\u0442\u0443\u043C \u0438 \u0432\u0440\u0435\u043C\u0435",
        date: "ISO \u0434\u0430\u0442\u0443\u043C",
        time: "ISO \u0432\u0440\u0435\u043C\u0435",
        duration: "ISO \u0432\u0440\u0435\u043C\u0435\u0442\u0440\u0430\u0435\u045A\u0435",
        ipv4: "IPv4 \u0430\u0434\u0440\u0435\u0441\u0430",
        ipv6: "IPv6 \u0430\u0434\u0440\u0435\u0441\u0430",
        cidrv4: "IPv4 \u043E\u043F\u0441\u0435\u0433",
        cidrv6: "IPv6 \u043E\u043F\u0441\u0435\u0433",
        base64: "base64-\u0435\u043D\u043A\u043E\u0434\u0438\u0440\u0430\u043D\u0430 \u043D\u0438\u0437\u0430",
        base64url: "base64url-\u0435\u043D\u043A\u043E\u0434\u0438\u0440\u0430\u043D\u0430 \u043D\u0438\u0437\u0430",
        json_string: "JSON \u043D\u0438\u0437\u0430",
        e164: "E.164 \u0431\u0440\u043E\u0458",
        jwt: "JWT",
        template_literal: "\u0432\u043D\u0435\u0441"
    };
    return (issue)=>{
        switch(issue.code){
            case "invalid_type":
                return `\u{413}\u{440}\u{435}\u{448}\u{435}\u{43D} \u{432}\u{43D}\u{435}\u{441}: \u{441}\u{435} \u{43E}\u{447}\u{435}\u{43A}\u{443}\u{432}\u{430} ${issue.expected}, \u{43F}\u{440}\u{438}\u{43C}\u{435}\u{43D}\u{43E} ${parsedType(issue.input)}`;
            // return `Invalid input: expected ${issue.expected}, received ${util.getParsedType(issue.input)}`;
            case "invalid_value":
                if (issue.values.length === 1) return `Invalid input: expected ${$8f5391358ccbeba2$export$5859860f650378f4(issue.values[0])}`;
                return `\u{413}\u{440}\u{435}\u{448}\u{430}\u{43D}\u{430} \u{43E}\u{43F}\u{446}\u{438}\u{458}\u{430}: \u{441}\u{435} \u{43E}\u{447}\u{435}\u{43A}\u{443}\u{432}\u{430} \u{435}\u{434}\u{43D}\u{430} ${$8f5391358ccbeba2$export$e79b744344f50f50(issue.values, "|")}`;
            case "too_big":
                {
                    const adj = issue.inclusive ? "<=" : "<";
                    const sizing = getSizing(issue.origin);
                    if (sizing) return `\u{41F}\u{440}\u{435}\u{43C}\u{43D}\u{43E}\u{433}\u{443} \u{433}\u{43E}\u{43B}\u{435}\u{43C}: \u{441}\u{435} \u{43E}\u{447}\u{435}\u{43A}\u{443}\u{432}\u{430} ${issue.origin ?? "\u0432\u0440\u0435\u0434\u043D\u043E\u0441\u0442\u0430"} \u{434}\u{430} \u{438}\u{43C}\u{430} ${adj}${issue.maximum.toString()} ${sizing.unit ?? "\u0435\u043B\u0435\u043C\u0435\u043D\u0442\u0438"}`;
                    return `\u{41F}\u{440}\u{435}\u{43C}\u{43D}\u{43E}\u{433}\u{443} \u{433}\u{43E}\u{43B}\u{435}\u{43C}: \u{441}\u{435} \u{43E}\u{447}\u{435}\u{43A}\u{443}\u{432}\u{430} ${issue.origin ?? "\u0432\u0440\u0435\u0434\u043D\u043E\u0441\u0442\u0430"} \u{434}\u{430} \u{431}\u{438}\u{434}\u{435} ${adj}${issue.maximum.toString()}`;
                }
            case "too_small":
                {
                    const adj = issue.inclusive ? ">=" : ">";
                    const sizing = getSizing(issue.origin);
                    if (sizing) return `\u{41F}\u{440}\u{435}\u{43C}\u{43D}\u{43E}\u{433}\u{443} \u{43C}\u{430}\u{43B}: \u{441}\u{435} \u{43E}\u{447}\u{435}\u{43A}\u{443}\u{432}\u{430} ${issue.origin} \u{434}\u{430} \u{438}\u{43C}\u{430} ${adj}${issue.minimum.toString()} ${sizing.unit}`;
                    return `\u{41F}\u{440}\u{435}\u{43C}\u{43D}\u{43E}\u{433}\u{443} \u{43C}\u{430}\u{43B}: \u{441}\u{435} \u{43E}\u{447}\u{435}\u{43A}\u{443}\u{432}\u{430} ${issue.origin} \u{434}\u{430} \u{431}\u{438}\u{434}\u{435} ${adj}${issue.minimum.toString()}`;
                }
            case "invalid_format":
                {
                    const _issue = issue;
                    if (_issue.format === "starts_with") return `\u{41D}\u{435}\u{432}\u{430}\u{436}\u{435}\u{447}\u{43A}\u{430} \u{43D}\u{438}\u{437}\u{430}: \u{43C}\u{43E}\u{440}\u{430} \u{434}\u{430} \u{437}\u{430}\u{43F}\u{43E}\u{447}\u{43D}\u{443}\u{432}\u{430} \u{441}\u{43E} "${_issue.prefix}"`;
                    if (_issue.format === "ends_with") return `\u{41D}\u{435}\u{432}\u{430}\u{436}\u{435}\u{447}\u{43A}\u{430} \u{43D}\u{438}\u{437}\u{430}: \u{43C}\u{43E}\u{440}\u{430} \u{434}\u{430} \u{437}\u{430}\u{432}\u{440}\u{448}\u{443}\u{432}\u{430} \u{441}\u{43E} "${_issue.suffix}"`;
                    if (_issue.format === "includes") return `\u{41D}\u{435}\u{432}\u{430}\u{436}\u{435}\u{447}\u{43A}\u{430} \u{43D}\u{438}\u{437}\u{430}: \u{43C}\u{43E}\u{440}\u{430} \u{434}\u{430} \u{432}\u{43A}\u{43B}\u{443}\u{447}\u{443}\u{432}\u{430} "${_issue.includes}"`;
                    if (_issue.format === "regex") return `\u{41D}\u{435}\u{432}\u{430}\u{436}\u{435}\u{447}\u{43A}\u{430} \u{43D}\u{438}\u{437}\u{430}: \u{43C}\u{43E}\u{440}\u{430} \u{434}\u{430} \u{43E}\u{434}\u{433}\u{43E}\u{430}\u{440}\u{430} \u{43D}\u{430} \u{43F}\u{430}\u{442}\u{435}\u{440}\u{43D}\u{43E}\u{442} ${_issue.pattern}`;
                    return `Invalid ${Nouns[_issue.format] ?? issue.format}`;
                }
            case "not_multiple_of":
                return `\u{413}\u{440}\u{435}\u{448}\u{435}\u{43D} \u{431}\u{440}\u{43E}\u{458}: \u{43C}\u{43E}\u{440}\u{430} \u{434}\u{430} \u{431}\u{438}\u{434}\u{435} \u{434}\u{435}\u{43B}\u{438}\u{432} \u{441}\u{43E} ${issue.divisor}`;
            case "unrecognized_keys":
                return `${issue.keys.length > 1 ? "\u041D\u0435\u043F\u0440\u0435\u043F\u043E\u0437\u043D\u0430\u0435\u043D\u0438 \u043A\u043B\u0443\u0447\u0435\u0432\u0438" : "\u041D\u0435\u043F\u0440\u0435\u043F\u043E\u0437\u043D\u0430\u0435\u043D \u043A\u043B\u0443\u0447"}: ${$8f5391358ccbeba2$export$e79b744344f50f50(issue.keys, ", ")}`;
            case "invalid_key":
                return `\u{413}\u{440}\u{435}\u{448}\u{435}\u{43D} \u{43A}\u{43B}\u{443}\u{447} \u{432}\u{43E} ${issue.origin}`;
            case "invalid_union":
                return "\u0413\u0440\u0435\u0448\u0435\u043D \u0432\u043D\u0435\u0441";
            case "invalid_element":
                return `\u{413}\u{440}\u{435}\u{448}\u{43D}\u{430} \u{432}\u{440}\u{435}\u{434}\u{43D}\u{43E}\u{441}\u{442} \u{432}\u{43E} ${issue.origin}`;
            default:
                return `\u{413}\u{440}\u{435}\u{448}\u{435}\u{43D} \u{432}\u{43D}\u{435}\u{441}`;
        }
    };
};
function $76ea32247cbd302f$export$2e2bcd8739ae039() {
    return {
        localeError: $76ea32247cbd302f$var$error()
    };
}



const $dca99c3f54b8966d$var$error = ()=>{
    const Sizable = {
        string: {
            unit: "aksara",
            verb: "mempunyai"
        },
        file: {
            unit: "bait",
            verb: "mempunyai"
        },
        array: {
            unit: "elemen",
            verb: "mempunyai"
        },
        set: {
            unit: "elemen",
            verb: "mempunyai"
        }
    };
    function getSizing(origin) {
        return Sizable[origin] ?? null;
    }
    const parsedType = (data)=>{
        const t = typeof data;
        switch(t){
            case "number":
                return Number.isNaN(data) ? "NaN" : "nombor";
            case "object":
                if (Array.isArray(data)) return "array";
                if (data === null) return "null";
                if (Object.getPrototypeOf(data) !== Object.prototype && data.constructor) return data.constructor.name;
        }
        return t;
    };
    const Nouns = {
        regex: "input",
        email: "alamat e-mel",
        url: "URL",
        emoji: "emoji",
        uuid: "UUID",
        uuidv4: "UUIDv4",
        uuidv6: "UUIDv6",
        nanoid: "nanoid",
        guid: "GUID",
        cuid: "cuid",
        cuid2: "cuid2",
        ulid: "ULID",
        xid: "XID",
        ksuid: "KSUID",
        datetime: "tarikh masa ISO",
        date: "tarikh ISO",
        time: "masa ISO",
        duration: "tempoh ISO",
        ipv4: "alamat IPv4",
        ipv6: "alamat IPv6",
        cidrv4: "julat IPv4",
        cidrv6: "julat IPv6",
        base64: "string dikodkan base64",
        base64url: "string dikodkan base64url",
        json_string: "string JSON",
        e164: "nombor E.164",
        jwt: "JWT",
        template_literal: "input"
    };
    return (issue)=>{
        switch(issue.code){
            case "invalid_type":
                return `Input tidak sah: dijangka ${issue.expected}, diterima ${parsedType(issue.input)}`;
            case "invalid_value":
                if (issue.values.length === 1) return `Input tidak sah: dijangka ${$8f5391358ccbeba2$export$5859860f650378f4(issue.values[0])}`;
                return `Pilihan tidak sah: dijangka salah satu daripada ${$8f5391358ccbeba2$export$e79b744344f50f50(issue.values, "|")}`;
            case "too_big":
                {
                    const adj = issue.inclusive ? "<=" : "<";
                    const sizing = getSizing(issue.origin);
                    if (sizing) return `Terlalu besar: dijangka ${issue.origin ?? "nilai"} ${sizing.verb} ${adj}${issue.maximum.toString()} ${sizing.unit ?? "elemen"}`;
                    return `Terlalu besar: dijangka ${issue.origin ?? "nilai"} adalah ${adj}${issue.maximum.toString()}`;
                }
            case "too_small":
                {
                    const adj = issue.inclusive ? ">=" : ">";
                    const sizing = getSizing(issue.origin);
                    if (sizing) return `Terlalu kecil: dijangka ${issue.origin} ${sizing.verb} ${adj}${issue.minimum.toString()} ${sizing.unit}`;
                    return `Terlalu kecil: dijangka ${issue.origin} adalah ${adj}${issue.minimum.toString()}`;
                }
            case "invalid_format":
                {
                    const _issue = issue;
                    if (_issue.format === "starts_with") return `String tidak sah: mesti bermula dengan "${_issue.prefix}"`;
                    if (_issue.format === "ends_with") return `String tidak sah: mesti berakhir dengan "${_issue.suffix}"`;
                    if (_issue.format === "includes") return `String tidak sah: mesti mengandungi "${_issue.includes}"`;
                    if (_issue.format === "regex") return `String tidak sah: mesti sepadan dengan corak ${_issue.pattern}`;
                    return `${Nouns[_issue.format] ?? issue.format} tidak sah`;
                }
            case "not_multiple_of":
                return `Nombor tidak sah: perlu gandaan ${issue.divisor}`;
            case "unrecognized_keys":
                return `Kunci tidak dikenali: ${$8f5391358ccbeba2$export$e79b744344f50f50(issue.keys, ", ")}`;
            case "invalid_key":
                return `Kunci tidak sah dalam ${issue.origin}`;
            case "invalid_union":
                return "Input tidak sah";
            case "invalid_element":
                return `Nilai tidak sah dalam ${issue.origin}`;
            default:
                return `Input tidak sah`;
        }
    };
};
function $dca99c3f54b8966d$export$2e2bcd8739ae039() {
    return {
        localeError: $dca99c3f54b8966d$var$error()
    };
}



const $bc9846a511522a33$var$error = ()=>{
    const Sizable = {
        string: {
            unit: "tekens",
            verb: "te hebben"
        },
        file: {
            unit: "bytes",
            verb: "te hebben"
        },
        array: {
            unit: "elementen",
            verb: "te hebben"
        },
        set: {
            unit: "elementen",
            verb: "te hebben"
        }
    };
    function getSizing(origin) {
        return Sizable[origin] ?? null;
    }
    const parsedType = (data)=>{
        const t = typeof data;
        switch(t){
            case "number":
                return Number.isNaN(data) ? "NaN" : "getal";
            case "object":
                if (Array.isArray(data)) return "array";
                if (data === null) return "null";
                if (Object.getPrototypeOf(data) !== Object.prototype && data.constructor) return data.constructor.name;
        }
        return t;
    };
    const Nouns = {
        regex: "invoer",
        email: "emailadres",
        url: "URL",
        emoji: "emoji",
        uuid: "UUID",
        uuidv4: "UUIDv4",
        uuidv6: "UUIDv6",
        nanoid: "nanoid",
        guid: "GUID",
        cuid: "cuid",
        cuid2: "cuid2",
        ulid: "ULID",
        xid: "XID",
        ksuid: "KSUID",
        datetime: "ISO datum en tijd",
        date: "ISO datum",
        time: "ISO tijd",
        duration: "ISO duur",
        ipv4: "IPv4-adres",
        ipv6: "IPv6-adres",
        cidrv4: "IPv4-bereik",
        cidrv6: "IPv6-bereik",
        base64: "base64-gecodeerde tekst",
        base64url: "base64 URL-gecodeerde tekst",
        json_string: "JSON string",
        e164: "E.164-nummer",
        jwt: "JWT",
        template_literal: "invoer"
    };
    return (issue)=>{
        switch(issue.code){
            case "invalid_type":
                return `Ongeldige invoer: verwacht ${issue.expected}, ontving ${parsedType(issue.input)}`;
            case "invalid_value":
                if (issue.values.length === 1) return `Ongeldige invoer: verwacht ${$8f5391358ccbeba2$export$5859860f650378f4(issue.values[0])}`;
                return `Ongeldige optie: verwacht \xe9\xe9n van ${$8f5391358ccbeba2$export$e79b744344f50f50(issue.values, "|")}`;
            case "too_big":
                {
                    const adj = issue.inclusive ? "<=" : "<";
                    const sizing = getSizing(issue.origin);
                    if (sizing) return `Te groot: verwacht dat ${issue.origin ?? "waarde"} ${sizing.verb} ${adj}${issue.maximum.toString()} ${sizing.unit ?? "elementen"}`;
                    return `Te groot: verwacht dat ${issue.origin ?? "waarde"} ${adj}${issue.maximum.toString()} is`;
                }
            case "too_small":
                {
                    const adj = issue.inclusive ? ">=" : ">";
                    const sizing = getSizing(issue.origin);
                    if (sizing) return `Te klein: verwacht dat ${issue.origin} ${sizing.verb} ${adj}${issue.minimum.toString()} ${sizing.unit}`;
                    return `Te klein: verwacht dat ${issue.origin} ${adj}${issue.minimum.toString()} is`;
                }
            case "invalid_format":
                {
                    const _issue = issue;
                    if (_issue.format === "starts_with") return `Ongeldige tekst: moet met "${_issue.prefix}" beginnen`;
                    if (_issue.format === "ends_with") return `Ongeldige tekst: moet op "${_issue.suffix}" eindigen`;
                    if (_issue.format === "includes") return `Ongeldige tekst: moet "${_issue.includes}" bevatten`;
                    if (_issue.format === "regex") return `Ongeldige tekst: moet overeenkomen met patroon ${_issue.pattern}`;
                    return `Ongeldig: ${Nouns[_issue.format] ?? issue.format}`;
                }
            case "not_multiple_of":
                return `Ongeldig getal: moet een veelvoud van ${issue.divisor} zijn`;
            case "unrecognized_keys":
                return `Onbekende key${issue.keys.length > 1 ? "s" : ""}: ${$8f5391358ccbeba2$export$e79b744344f50f50(issue.keys, ", ")}`;
            case "invalid_key":
                return `Ongeldige key in ${issue.origin}`;
            case "invalid_union":
                return "Ongeldige invoer";
            case "invalid_element":
                return `Ongeldige waarde in ${issue.origin}`;
            default:
                return `Ongeldige invoer`;
        }
    };
};
function $bc9846a511522a33$export$2e2bcd8739ae039() {
    return {
        localeError: $bc9846a511522a33$var$error()
    };
}



const $019ee903b682c813$var$error = ()=>{
    const Sizable = {
        string: {
            unit: "tegn",
            verb: "\xe5 ha"
        },
        file: {
            unit: "bytes",
            verb: "\xe5 ha"
        },
        array: {
            unit: "elementer",
            verb: "\xe5 inneholde"
        },
        set: {
            unit: "elementer",
            verb: "\xe5 inneholde"
        }
    };
    function getSizing(origin) {
        return Sizable[origin] ?? null;
    }
    const parsedType = (data)=>{
        const t = typeof data;
        switch(t){
            case "number":
                return Number.isNaN(data) ? "NaN" : "tall";
            case "object":
                if (Array.isArray(data)) return "liste";
                if (data === null) return "null";
                if (Object.getPrototypeOf(data) !== Object.prototype && data.constructor) return data.constructor.name;
        }
        return t;
    };
    const Nouns = {
        regex: "input",
        email: "e-postadresse",
        url: "URL",
        emoji: "emoji",
        uuid: "UUID",
        uuidv4: "UUIDv4",
        uuidv6: "UUIDv6",
        nanoid: "nanoid",
        guid: "GUID",
        cuid: "cuid",
        cuid2: "cuid2",
        ulid: "ULID",
        xid: "XID",
        ksuid: "KSUID",
        datetime: "ISO dato- og klokkeslett",
        date: "ISO-dato",
        time: "ISO-klokkeslett",
        duration: "ISO-varighet",
        ipv4: "IPv4-omr\xe5de",
        ipv6: "IPv6-omr\xe5de",
        cidrv4: "IPv4-spekter",
        cidrv6: "IPv6-spekter",
        base64: "base64-enkodet streng",
        base64url: "base64url-enkodet streng",
        json_string: "JSON-streng",
        e164: "E.164-nummer",
        jwt: "JWT",
        template_literal: "input"
    };
    return (issue)=>{
        switch(issue.code){
            case "invalid_type":
                return `Ugyldig input: forventet ${issue.expected}, fikk ${parsedType(issue.input)}`;
            case "invalid_value":
                if (issue.values.length === 1) return `Ugyldig verdi: forventet ${$8f5391358ccbeba2$export$5859860f650378f4(issue.values[0])}`;
                return `Ugyldig valg: forventet en av ${$8f5391358ccbeba2$export$e79b744344f50f50(issue.values, "|")}`;
            case "too_big":
                {
                    const adj = issue.inclusive ? "<=" : "<";
                    const sizing = getSizing(issue.origin);
                    if (sizing) return `For stor(t): forventet ${issue.origin ?? "value"} til \xe5 ha ${adj}${issue.maximum.toString()} ${sizing.unit ?? "elementer"}`;
                    return `For stor(t): forventet ${issue.origin ?? "value"} til \xe5 ha ${adj}${issue.maximum.toString()}`;
                }
            case "too_small":
                {
                    const adj = issue.inclusive ? ">=" : ">";
                    const sizing = getSizing(issue.origin);
                    if (sizing) return `For lite(n): forventet ${issue.origin} til \xe5 ha ${adj}${issue.minimum.toString()} ${sizing.unit}`;
                    return `For lite(n): forventet ${issue.origin} til \xe5 ha ${adj}${issue.minimum.toString()}`;
                }
            case "invalid_format":
                {
                    const _issue = issue;
                    if (_issue.format === "starts_with") return `Ugyldig streng: m\xe5 starte med "${_issue.prefix}"`;
                    if (_issue.format === "ends_with") return `Ugyldig streng: m\xe5 ende med "${_issue.suffix}"`;
                    if (_issue.format === "includes") return `Ugyldig streng: m\xe5 inneholde "${_issue.includes}"`;
                    if (_issue.format === "regex") return `Ugyldig streng: m\xe5 matche m\xf8nsteret ${_issue.pattern}`;
                    return `Ugyldig ${Nouns[_issue.format] ?? issue.format}`;
                }
            case "not_multiple_of":
                return `Ugyldig tall: m\xe5 v\xe6re et multiplum av ${issue.divisor}`;
            case "unrecognized_keys":
                return `${issue.keys.length > 1 ? "Ukjente n\xf8kler" : "Ukjent n\xf8kkel"}: ${$8f5391358ccbeba2$export$e79b744344f50f50(issue.keys, ", ")}`;
            case "invalid_key":
                return `Ugyldig n\xf8kkel i ${issue.origin}`;
            case "invalid_union":
                return "Ugyldig input";
            case "invalid_element":
                return `Ugyldig verdi i ${issue.origin}`;
            default:
                return `Ugyldig input`;
        }
    };
};
function $019ee903b682c813$export$2e2bcd8739ae039() {
    return {
        localeError: $019ee903b682c813$var$error()
    };
}



const $75f8185903b08836$var$error = ()=>{
    const Sizable = {
        string: {
            unit: "harf",
            verb: "olmal\u0131d\u0131r"
        },
        file: {
            unit: "bayt",
            verb: "olmal\u0131d\u0131r"
        },
        array: {
            unit: "unsur",
            verb: "olmal\u0131d\u0131r"
        },
        set: {
            unit: "unsur",
            verb: "olmal\u0131d\u0131r"
        }
    };
    function getSizing(origin) {
        return Sizable[origin] ?? null;
    }
    const parsedType = (data)=>{
        const t = typeof data;
        switch(t){
            case "number":
                return Number.isNaN(data) ? "NaN" : "numara";
            case "object":
                if (Array.isArray(data)) return "saf";
                if (data === null) return "gayb";
                if (Object.getPrototypeOf(data) !== Object.prototype && data.constructor) return data.constructor.name;
        }
        return t;
    };
    const Nouns = {
        regex: "giren",
        email: "epostag\xe2h",
        url: "URL",
        emoji: "emoji",
        uuid: "UUID",
        uuidv4: "UUIDv4",
        uuidv6: "UUIDv6",
        nanoid: "nanoid",
        guid: "GUID",
        cuid: "cuid",
        cuid2: "cuid2",
        ulid: "ULID",
        xid: "XID",
        ksuid: "KSUID",
        datetime: "ISO heng\xe2m\u0131",
        date: "ISO tarihi",
        time: "ISO zaman\u0131",
        duration: "ISO m\xfcddeti",
        ipv4: "IPv4 ni\u015F\xe2n\u0131",
        ipv6: "IPv6 ni\u015F\xe2n\u0131",
        cidrv4: "IPv4 menzili",
        cidrv6: "IPv6 menzili",
        base64: "base64-\u015Fifreli metin",
        base64url: "base64url-\u015Fifreli metin",
        json_string: "JSON metin",
        e164: "E.164 say\u0131s\u0131",
        jwt: "JWT",
        template_literal: "giren"
    };
    return (issue)=>{
        switch(issue.code){
            case "invalid_type":
                return `F\xe2sit giren: umulan ${issue.expected}, al\u{131}nan ${parsedType(issue.input)}`;
            // return `Fâsit giren: umulan ${issue.expected}, alınan ${util.getParsedType(issue.input)}`;
            case "invalid_value":
                if (issue.values.length === 1) return `F\xe2sit giren: umulan ${$8f5391358ccbeba2$export$5859860f650378f4(issue.values[0])}`;
                return `F\xe2sit tercih: m\xfbteberler ${$8f5391358ccbeba2$export$e79b744344f50f50(issue.values, "|")}`;
            case "too_big":
                {
                    const adj = issue.inclusive ? "<=" : "<";
                    const sizing = getSizing(issue.origin);
                    if (sizing) return `Fazla b\xfcy\xfck: ${issue.origin ?? "value"}, ${adj}${issue.maximum.toString()} ${sizing.unit ?? "elements"} sahip olmal\u{131}yd\u{131}.`;
                    return `Fazla b\xfcy\xfck: ${issue.origin ?? "value"}, ${adj}${issue.maximum.toString()} olmal\u{131}yd\u{131}.`;
                }
            case "too_small":
                {
                    const adj = issue.inclusive ? ">=" : ">";
                    const sizing = getSizing(issue.origin);
                    if (sizing) return `Fazla k\xfc\xe7\xfck: ${issue.origin}, ${adj}${issue.minimum.toString()} ${sizing.unit} sahip olmal\u{131}yd\u{131}.`;
                    return `Fazla k\xfc\xe7\xfck: ${issue.origin}, ${adj}${issue.minimum.toString()} olmal\u{131}yd\u{131}.`;
                }
            case "invalid_format":
                {
                    const _issue = issue;
                    if (_issue.format === "starts_with") return `F\xe2sit metin: "${_issue.prefix}" ile ba\u{15F}lamal\u{131}.`;
                    if (_issue.format === "ends_with") return `F\xe2sit metin: "${_issue.suffix}" ile bitmeli.`;
                    if (_issue.format === "includes") return `F\xe2sit metin: "${_issue.includes}" ihtiv\xe2 etmeli.`;
                    if (_issue.format === "regex") return `F\xe2sit metin: ${_issue.pattern} nak\u{15F}\u{131}na uymal\u{131}.`;
                    return `F\xe2sit ${Nouns[_issue.format] ?? issue.format}`;
                }
            case "not_multiple_of":
                return `F\xe2sit say\u{131}: ${issue.divisor} kat\u{131} olmal\u{131}yd\u{131}.`;
            case "unrecognized_keys":
                return `Tan\u{131}nmayan anahtar ${issue.keys.length > 1 ? "s" : ""}: ${$8f5391358ccbeba2$export$e79b744344f50f50(issue.keys, ", ")}`;
            case "invalid_key":
                return `${issue.origin} i\xe7in tan\u{131}nmayan anahtar var.`;
            case "invalid_union":
                return "Giren tan\u0131namad\u0131.";
            case "invalid_element":
                return `${issue.origin} i\xe7in tan\u{131}nmayan k\u{131}ymet var.`;
            default:
                return `K\u{131}ymet tan\u{131}namad\u{131}.`;
        }
    };
};
function $75f8185903b08836$export$2e2bcd8739ae039() {
    return {
        localeError: $75f8185903b08836$var$error()
    };
}



const $8cc314d8b5dc27a1$var$error = ()=>{
    const Sizable = {
        string: {
            unit: "\u062A\u0648\u06A9\u064A",
            verb: "\u0648\u0644\u0631\u064A"
        },
        file: {
            unit: "\u0628\u0627\u06CC\u067C\u0633",
            verb: "\u0648\u0644\u0631\u064A"
        },
        array: {
            unit: "\u062A\u0648\u06A9\u064A",
            verb: "\u0648\u0644\u0631\u064A"
        },
        set: {
            unit: "\u062A\u0648\u06A9\u064A",
            verb: "\u0648\u0644\u0631\u064A"
        }
    };
    function getSizing(origin) {
        return Sizable[origin] ?? null;
    }
    const parsedType = (data)=>{
        const t = typeof data;
        switch(t){
            case "number":
                return Number.isNaN(data) ? "NaN" : "\u0639\u062F\u062F";
            case "object":
                if (Array.isArray(data)) return "\u0627\u0631\u06D0";
                if (data === null) return "null";
                if (Object.getPrototypeOf(data) !== Object.prototype && data.constructor) return data.constructor.name;
        }
        return t;
    };
    const Nouns = {
        regex: "\u0648\u0631\u0648\u062F\u064A",
        email: "\u0628\u0631\u06CC\u069A\u0646\u0627\u0644\u06CC\u06A9",
        url: "\u06CC\u0648 \u0622\u0631 \u0627\u0644",
        emoji: "\u0627\u06CC\u0645\u0648\u062C\u064A",
        uuid: "UUID",
        uuidv4: "UUIDv4",
        uuidv6: "UUIDv6",
        nanoid: "nanoid",
        guid: "GUID",
        cuid: "cuid",
        cuid2: "cuid2",
        ulid: "ULID",
        xid: "XID",
        ksuid: "KSUID",
        datetime: "\u0646\u06CC\u067C\u0647 \u0627\u0648 \u0648\u062E\u062A",
        date: "\u0646\u06D0\u067C\u0647",
        time: "\u0648\u062E\u062A",
        duration: "\u0645\u0648\u062F\u0647",
        ipv4: "\u062F IPv4 \u067E\u062A\u0647",
        ipv6: "\u062F IPv6 \u067E\u062A\u0647",
        cidrv4: "\u062F IPv4 \u0633\u0627\u062D\u0647",
        cidrv6: "\u062F IPv6 \u0633\u0627\u062D\u0647",
        base64: "base64-encoded \u0645\u062A\u0646",
        base64url: "base64url-encoded \u0645\u062A\u0646",
        json_string: "JSON \u0645\u062A\u0646",
        e164: "\u062F E.164 \u0634\u0645\u06D0\u0631\u0647",
        jwt: "JWT",
        template_literal: "\u0648\u0631\u0648\u062F\u064A"
    };
    return (issue)=>{
        switch(issue.code){
            case "invalid_type":
                return `\u{646}\u{627}\u{633}\u{645} \u{648}\u{631}\u{648}\u{62F}\u{64A}: \u{628}\u{627}\u{6CC}\u{62F} ${issue.expected} \u{648}\u{627}\u{6CC}, \u{645}\u{6AB}\u{631} ${parsedType(issue.input)} \u{62A}\u{631}\u{644}\u{627}\u{633}\u{647} \u{634}\u{648}`;
            case "invalid_value":
                if (issue.values.length === 1) return `\u{646}\u{627}\u{633}\u{645} \u{648}\u{631}\u{648}\u{62F}\u{64A}: \u{628}\u{627}\u{6CC}\u{62F} ${$8f5391358ccbeba2$export$5859860f650378f4(issue.values[0])} \u{648}\u{627}\u{6CC}`;
                return `\u{646}\u{627}\u{633}\u{645} \u{627}\u{646}\u{62A}\u{62E}\u{627}\u{628}: \u{628}\u{627}\u{6CC}\u{62F} \u{6CC}\u{648} \u{644}\u{647} ${$8f5391358ccbeba2$export$e79b744344f50f50(issue.values, "|")} \u{685}\u{62E}\u{647} \u{648}\u{627}\u{6CC}`;
            case "too_big":
                {
                    const adj = issue.inclusive ? "<=" : "<";
                    const sizing = getSizing(issue.origin);
                    if (sizing) return `\u{689}\u{6CC}\u{631} \u{644}\u{648}\u{6CC}: ${issue.origin ?? "\u0627\u0631\u0632\u069A\u062A"} \u{628}\u{627}\u{6CC}\u{62F} ${adj}${issue.maximum.toString()} ${sizing.unit ?? "\u0639\u0646\u0635\u0631\u0648\u0646\u0647"} \u{648}\u{644}\u{631}\u{64A}`;
                    return `\u{689}\u{6CC}\u{631} \u{644}\u{648}\u{6CC}: ${issue.origin ?? "\u0627\u0631\u0632\u069A\u062A"} \u{628}\u{627}\u{6CC}\u{62F} ${adj}${issue.maximum.toString()} \u{648}\u{64A}`;
                }
            case "too_small":
                {
                    const adj = issue.inclusive ? ">=" : ">";
                    const sizing = getSizing(issue.origin);
                    if (sizing) return `\u{689}\u{6CC}\u{631} \u{6A9}\u{648}\u{686}\u{646}\u{6CC}: ${issue.origin} \u{628}\u{627}\u{6CC}\u{62F} ${adj}${issue.minimum.toString()} ${sizing.unit} \u{648}\u{644}\u{631}\u{64A}`;
                    return `\u{689}\u{6CC}\u{631} \u{6A9}\u{648}\u{686}\u{646}\u{6CC}: ${issue.origin} \u{628}\u{627}\u{6CC}\u{62F} ${adj}${issue.minimum.toString()} \u{648}\u{64A}`;
                }
            case "invalid_format":
                {
                    const _issue = issue;
                    if (_issue.format === "starts_with") return `\u{646}\u{627}\u{633}\u{645} \u{645}\u{62A}\u{646}: \u{628}\u{627}\u{6CC}\u{62F} \u{62F} "${_issue.prefix}" \u{633}\u{631}\u{647} \u{67E}\u{6CC}\u{644} \u{634}\u{64A}`;
                    if (_issue.format === "ends_with") return `\u{646}\u{627}\u{633}\u{645} \u{645}\u{62A}\u{646}: \u{628}\u{627}\u{6CC}\u{62F} \u{62F} "${_issue.suffix}" \u{633}\u{631}\u{647} \u{67E}\u{627}\u{6CC} \u{62A}\u{647} \u{648}\u{631}\u{633}\u{64A}\u{696}\u{64A}`;
                    if (_issue.format === "includes") return `\u{646}\u{627}\u{633}\u{645} \u{645}\u{62A}\u{646}: \u{628}\u{627}\u{6CC}\u{62F} "${_issue.includes}" \u{648}\u{644}\u{631}\u{64A}`;
                    if (_issue.format === "regex") return `\u{646}\u{627}\u{633}\u{645} \u{645}\u{62A}\u{646}: \u{628}\u{627}\u{6CC}\u{62F} \u{62F} ${_issue.pattern} \u{633}\u{631}\u{647} \u{645}\u{637}\u{627}\u{628}\u{642}\u{62A} \u{648}\u{644}\u{631}\u{64A}`;
                    return `${Nouns[_issue.format] ?? issue.format} \u{646}\u{627}\u{633}\u{645} \u{62F}\u{6CC}`;
                }
            case "not_multiple_of":
                return `\u{646}\u{627}\u{633}\u{645} \u{639}\u{62F}\u{62F}: \u{628}\u{627}\u{6CC}\u{62F} \u{62F} ${issue.divisor} \u{645}\u{636}\u{631}\u{628} \u{648}\u{64A}`;
            case "unrecognized_keys":
                return `\u{646}\u{627}\u{633}\u{645} ${issue.keys.length > 1 ? "\u06A9\u0644\u06CC\u0689\u0648\u0646\u0647" : "\u06A9\u0644\u06CC\u0689"}: ${$8f5391358ccbeba2$export$e79b744344f50f50(issue.keys, ", ")}`;
            case "invalid_key":
                return `\u{646}\u{627}\u{633}\u{645} \u{6A9}\u{644}\u{6CC}\u{689} \u{67E}\u{647} ${issue.origin} \u{6A9}\u{6D0}`;
            case "invalid_union":
                return `\u{646}\u{627}\u{633}\u{645}\u{647} \u{648}\u{631}\u{648}\u{62F}\u{64A}`;
            case "invalid_element":
                return `\u{646}\u{627}\u{633}\u{645} \u{639}\u{646}\u{635}\u{631} \u{67E}\u{647} ${issue.origin} \u{6A9}\u{6D0}`;
            default:
                return `\u{646}\u{627}\u{633}\u{645}\u{647} \u{648}\u{631}\u{648}\u{62F}\u{64A}`;
        }
    };
};
function $8cc314d8b5dc27a1$export$2e2bcd8739ae039() {
    return {
        localeError: $8cc314d8b5dc27a1$var$error()
    };
}



const $de7f4eb294d43e1b$var$error = ()=>{
    const Sizable = {
        string: {
            unit: "znak\xf3w",
            verb: "mie\u0107"
        },
        file: {
            unit: "bajt\xf3w",
            verb: "mie\u0107"
        },
        array: {
            unit: "element\xf3w",
            verb: "mie\u0107"
        },
        set: {
            unit: "element\xf3w",
            verb: "mie\u0107"
        }
    };
    function getSizing(origin) {
        return Sizable[origin] ?? null;
    }
    const parsedType = (data)=>{
        const t = typeof data;
        switch(t){
            case "number":
                return Number.isNaN(data) ? "NaN" : "liczba";
            case "object":
                if (Array.isArray(data)) return "tablica";
                if (data === null) return "null";
                if (Object.getPrototypeOf(data) !== Object.prototype && data.constructor) return data.constructor.name;
        }
        return t;
    };
    const Nouns = {
        regex: "wyra\u017Cenie",
        email: "adres email",
        url: "URL",
        emoji: "emoji",
        uuid: "UUID",
        uuidv4: "UUIDv4",
        uuidv6: "UUIDv6",
        nanoid: "nanoid",
        guid: "GUID",
        cuid: "cuid",
        cuid2: "cuid2",
        ulid: "ULID",
        xid: "XID",
        ksuid: "KSUID",
        datetime: "data i godzina w formacie ISO",
        date: "data w formacie ISO",
        time: "godzina w formacie ISO",
        duration: "czas trwania ISO",
        ipv4: "adres IPv4",
        ipv6: "adres IPv6",
        cidrv4: "zakres IPv4",
        cidrv6: "zakres IPv6",
        base64: "ci\u0105g znak\xf3w zakodowany w formacie base64",
        base64url: "ci\u0105g znak\xf3w zakodowany w formacie base64url",
        json_string: "ci\u0105g znak\xf3w w formacie JSON",
        e164: "liczba E.164",
        jwt: "JWT",
        template_literal: "wej\u015Bcie"
    };
    return (issue)=>{
        switch(issue.code){
            case "invalid_type":
                return `Nieprawid\u{142}owe dane wej\u{15B}ciowe: oczekiwano ${issue.expected}, otrzymano ${parsedType(issue.input)}`;
            case "invalid_value":
                if (issue.values.length === 1) return `Nieprawid\u{142}owe dane wej\u{15B}ciowe: oczekiwano ${$8f5391358ccbeba2$export$5859860f650378f4(issue.values[0])}`;
                return `Nieprawid\u{142}owa opcja: oczekiwano jednej z warto\u{15B}ci ${$8f5391358ccbeba2$export$e79b744344f50f50(issue.values, "|")}`;
            case "too_big":
                {
                    const adj = issue.inclusive ? "<=" : "<";
                    const sizing = getSizing(issue.origin);
                    if (sizing) return `Za du\u{17C}a warto\u{15B}\u{107}: oczekiwano, \u{17C}e ${issue.origin ?? "warto\u015B\u0107"} b\u{119}dzie mie\u{107} ${adj}${issue.maximum.toString()} ${sizing.unit ?? "element\xf3w"}`;
                    return `Zbyt du\u{17C}(y/a/e): oczekiwano, \u{17C}e ${issue.origin ?? "warto\u015B\u0107"} b\u{119}dzie wynosi\u{107} ${adj}${issue.maximum.toString()}`;
                }
            case "too_small":
                {
                    const adj = issue.inclusive ? ">=" : ">";
                    const sizing = getSizing(issue.origin);
                    if (sizing) return `Za ma\u{142}a warto\u{15B}\u{107}: oczekiwano, \u{17C}e ${issue.origin ?? "warto\u015B\u0107"} b\u{119}dzie mie\u{107} ${adj}${issue.minimum.toString()} ${sizing.unit ?? "element\xf3w"}`;
                    return `Zbyt ma\u{142}(y/a/e): oczekiwano, \u{17C}e ${issue.origin ?? "warto\u015B\u0107"} b\u{119}dzie wynosi\u{107} ${adj}${issue.minimum.toString()}`;
                }
            case "invalid_format":
                {
                    const _issue = issue;
                    if (_issue.format === "starts_with") return `Nieprawid\u{142}owy ci\u{105}g znak\xf3w: musi zaczyna\u{107} si\u{119} od "${_issue.prefix}"`;
                    if (_issue.format === "ends_with") return `Nieprawid\u{142}owy ci\u{105}g znak\xf3w: musi ko\u{144}czy\u{107} si\u{119} na "${_issue.suffix}"`;
                    if (_issue.format === "includes") return `Nieprawid\u{142}owy ci\u{105}g znak\xf3w: musi zawiera\u{107} "${_issue.includes}"`;
                    if (_issue.format === "regex") return `Nieprawid\u{142}owy ci\u{105}g znak\xf3w: musi odpowiada\u{107} wzorcowi ${_issue.pattern}`;
                    return `Nieprawid\u{142}ow(y/a/e) ${Nouns[_issue.format] ?? issue.format}`;
                }
            case "not_multiple_of":
                return `Nieprawid\u{142}owa liczba: musi by\u{107} wielokrotno\u{15B}ci\u{105} ${issue.divisor}`;
            case "unrecognized_keys":
                return `Nierozpoznane klucze${issue.keys.length > 1 ? "s" : ""}: ${$8f5391358ccbeba2$export$e79b744344f50f50(issue.keys, ", ")}`;
            case "invalid_key":
                return `Nieprawid\u{142}owy klucz w ${issue.origin}`;
            case "invalid_union":
                return "Nieprawid\u0142owe dane wej\u015Bciowe";
            case "invalid_element":
                return `Nieprawid\u{142}owa warto\u{15B}\u{107} w ${issue.origin}`;
            default:
                return `Nieprawid\u{142}owe dane wej\u{15B}ciowe`;
        }
    };
};
function $de7f4eb294d43e1b$export$2e2bcd8739ae039() {
    return {
        localeError: $de7f4eb294d43e1b$var$error()
    };
}



const $c7351cd809dfb0e1$var$error = ()=>{
    const Sizable = {
        string: {
            unit: "caracteres",
            verb: "ter"
        },
        file: {
            unit: "bytes",
            verb: "ter"
        },
        array: {
            unit: "itens",
            verb: "ter"
        },
        set: {
            unit: "itens",
            verb: "ter"
        }
    };
    function getSizing(origin) {
        return Sizable[origin] ?? null;
    }
    const parsedType = (data)=>{
        const t = typeof data;
        switch(t){
            case "number":
                return Number.isNaN(data) ? "NaN" : "n\xfamero";
            case "object":
                if (Array.isArray(data)) return "array";
                if (data === null) return "nulo";
                if (Object.getPrototypeOf(data) !== Object.prototype && data.constructor) return data.constructor.name;
        }
        return t;
    };
    const Nouns = {
        regex: "padr\xe3o",
        email: "endere\xe7o de e-mail",
        url: "URL",
        emoji: "emoji",
        uuid: "UUID",
        uuidv4: "UUIDv4",
        uuidv6: "UUIDv6",
        nanoid: "nanoid",
        guid: "GUID",
        cuid: "cuid",
        cuid2: "cuid2",
        ulid: "ULID",
        xid: "XID",
        ksuid: "KSUID",
        datetime: "data e hora ISO",
        date: "data ISO",
        time: "hora ISO",
        duration: "dura\xe7\xe3o ISO",
        ipv4: "endere\xe7o IPv4",
        ipv6: "endere\xe7o IPv6",
        cidrv4: "faixa de IPv4",
        cidrv6: "faixa de IPv6",
        base64: "texto codificado em base64",
        base64url: "URL codificada em base64",
        json_string: "texto JSON",
        e164: "n\xfamero E.164",
        jwt: "JWT",
        template_literal: "entrada"
    };
    return (issue)=>{
        switch(issue.code){
            case "invalid_type":
                return `Tipo inv\xe1lido: esperado ${issue.expected}, recebido ${parsedType(issue.input)}`;
            case "invalid_value":
                if (issue.values.length === 1) return `Entrada inv\xe1lida: esperado ${$8f5391358ccbeba2$export$5859860f650378f4(issue.values[0])}`;
                return `Op\xe7\xe3o inv\xe1lida: esperada uma das ${$8f5391358ccbeba2$export$e79b744344f50f50(issue.values, "|")}`;
            case "too_big":
                {
                    const adj = issue.inclusive ? "<=" : "<";
                    const sizing = getSizing(issue.origin);
                    if (sizing) return `Muito grande: esperado que ${issue.origin ?? "valor"} tivesse ${adj}${issue.maximum.toString()} ${sizing.unit ?? "elementos"}`;
                    return `Muito grande: esperado que ${issue.origin ?? "valor"} fosse ${adj}${issue.maximum.toString()}`;
                }
            case "too_small":
                {
                    const adj = issue.inclusive ? ">=" : ">";
                    const sizing = getSizing(issue.origin);
                    if (sizing) return `Muito pequeno: esperado que ${issue.origin} tivesse ${adj}${issue.minimum.toString()} ${sizing.unit}`;
                    return `Muito pequeno: esperado que ${issue.origin} fosse ${adj}${issue.minimum.toString()}`;
                }
            case "invalid_format":
                {
                    const _issue = issue;
                    if (_issue.format === "starts_with") return `Texto inv\xe1lido: deve come\xe7ar com "${_issue.prefix}"`;
                    if (_issue.format === "ends_with") return `Texto inv\xe1lido: deve terminar com "${_issue.suffix}"`;
                    if (_issue.format === "includes") return `Texto inv\xe1lido: deve incluir "${_issue.includes}"`;
                    if (_issue.format === "regex") return `Texto inv\xe1lido: deve corresponder ao padr\xe3o ${_issue.pattern}`;
                    return `${Nouns[_issue.format] ?? issue.format} inv\xe1lido`;
                }
            case "not_multiple_of":
                return `N\xfamero inv\xe1lido: deve ser m\xfaltiplo de ${issue.divisor}`;
            case "unrecognized_keys":
                return `Chave${issue.keys.length > 1 ? "s" : ""} desconhecida${issue.keys.length > 1 ? "s" : ""}: ${$8f5391358ccbeba2$export$e79b744344f50f50(issue.keys, ", ")}`;
            case "invalid_key":
                return `Chave inv\xe1lida em ${issue.origin}`;
            case "invalid_union":
                return "Entrada inv\xe1lida";
            case "invalid_element":
                return `Valor inv\xe1lido em ${issue.origin}`;
            default:
                return `Campo inv\xe1lido`;
        }
    };
};
function $c7351cd809dfb0e1$export$2e2bcd8739ae039() {
    return {
        localeError: $c7351cd809dfb0e1$var$error()
    };
}



function $2c3ab961f3efbcf5$var$getRussianPlural(count, one, few, many) {
    const absCount = Math.abs(count);
    const lastDigit = absCount % 10;
    const lastTwoDigits = absCount % 100;
    if (lastTwoDigits >= 11 && lastTwoDigits <= 19) return many;
    if (lastDigit === 1) return one;
    if (lastDigit >= 2 && lastDigit <= 4) return few;
    return many;
}
const $2c3ab961f3efbcf5$var$error = ()=>{
    const Sizable = {
        string: {
            unit: {
                one: "\u0441\u0438\u043C\u0432\u043E\u043B",
                few: "\u0441\u0438\u043C\u0432\u043E\u043B\u0430",
                many: "\u0441\u0438\u043C\u0432\u043E\u043B\u043E\u0432"
            },
            verb: "\u0438\u043C\u0435\u0442\u044C"
        },
        file: {
            unit: {
                one: "\u0431\u0430\u0439\u0442",
                few: "\u0431\u0430\u0439\u0442\u0430",
                many: "\u0431\u0430\u0439\u0442"
            },
            verb: "\u0438\u043C\u0435\u0442\u044C"
        },
        array: {
            unit: {
                one: "\u044D\u043B\u0435\u043C\u0435\u043D\u0442",
                few: "\u044D\u043B\u0435\u043C\u0435\u043D\u0442\u0430",
                many: "\u044D\u043B\u0435\u043C\u0435\u043D\u0442\u043E\u0432"
            },
            verb: "\u0438\u043C\u0435\u0442\u044C"
        },
        set: {
            unit: {
                one: "\u044D\u043B\u0435\u043C\u0435\u043D\u0442",
                few: "\u044D\u043B\u0435\u043C\u0435\u043D\u0442\u0430",
                many: "\u044D\u043B\u0435\u043C\u0435\u043D\u0442\u043E\u0432"
            },
            verb: "\u0438\u043C\u0435\u0442\u044C"
        }
    };
    function getSizing(origin) {
        return Sizable[origin] ?? null;
    }
    const parsedType = (data)=>{
        const t = typeof data;
        switch(t){
            case "number":
                return Number.isNaN(data) ? "NaN" : "\u0447\u0438\u0441\u043B\u043E";
            case "object":
                if (Array.isArray(data)) return "\u043C\u0430\u0441\u0441\u0438\u0432";
                if (data === null) return "null";
                if (Object.getPrototypeOf(data) !== Object.prototype && data.constructor) return data.constructor.name;
        }
        return t;
    };
    const Nouns = {
        regex: "\u0432\u0432\u043E\u0434",
        email: "email \u0430\u0434\u0440\u0435\u0441",
        url: "URL",
        emoji: "\u044D\u043C\u043E\u0434\u0437\u0438",
        uuid: "UUID",
        uuidv4: "UUIDv4",
        uuidv6: "UUIDv6",
        nanoid: "nanoid",
        guid: "GUID",
        cuid: "cuid",
        cuid2: "cuid2",
        ulid: "ULID",
        xid: "XID",
        ksuid: "KSUID",
        datetime: "ISO \u0434\u0430\u0442\u0430 \u0438 \u0432\u0440\u0435\u043C\u044F",
        date: "ISO \u0434\u0430\u0442\u0430",
        time: "ISO \u0432\u0440\u0435\u043C\u044F",
        duration: "ISO \u0434\u043B\u0438\u0442\u0435\u043B\u044C\u043D\u043E\u0441\u0442\u044C",
        ipv4: "IPv4 \u0430\u0434\u0440\u0435\u0441",
        ipv6: "IPv6 \u0430\u0434\u0440\u0435\u0441",
        cidrv4: "IPv4 \u0434\u0438\u0430\u043F\u0430\u0437\u043E\u043D",
        cidrv6: "IPv6 \u0434\u0438\u0430\u043F\u0430\u0437\u043E\u043D",
        base64: "\u0441\u0442\u0440\u043E\u043A\u0430 \u0432 \u0444\u043E\u0440\u043C\u0430\u0442\u0435 base64",
        base64url: "\u0441\u0442\u0440\u043E\u043A\u0430 \u0432 \u0444\u043E\u0440\u043C\u0430\u0442\u0435 base64url",
        json_string: "JSON \u0441\u0442\u0440\u043E\u043A\u0430",
        e164: "\u043D\u043E\u043C\u0435\u0440 E.164",
        jwt: "JWT",
        template_literal: "\u0432\u0432\u043E\u0434"
    };
    return (issue)=>{
        switch(issue.code){
            case "invalid_type":
                return `\u{41D}\u{435}\u{432}\u{435}\u{440}\u{43D}\u{44B}\u{439} \u{432}\u{432}\u{43E}\u{434}: \u{43E}\u{436}\u{438}\u{434}\u{430}\u{43B}\u{43E}\u{441}\u{44C} ${issue.expected}, \u{43F}\u{43E}\u{43B}\u{443}\u{447}\u{435}\u{43D}\u{43E} ${parsedType(issue.input)}`;
            case "invalid_value":
                if (issue.values.length === 1) return `\u{41D}\u{435}\u{432}\u{435}\u{440}\u{43D}\u{44B}\u{439} \u{432}\u{432}\u{43E}\u{434}: \u{43E}\u{436}\u{438}\u{434}\u{430}\u{43B}\u{43E}\u{441}\u{44C} ${$8f5391358ccbeba2$export$5859860f650378f4(issue.values[0])}`;
                return `\u{41D}\u{435}\u{432}\u{435}\u{440}\u{43D}\u{44B}\u{439} \u{432}\u{430}\u{440}\u{438}\u{430}\u{43D}\u{442}: \u{43E}\u{436}\u{438}\u{434}\u{430}\u{43B}\u{43E}\u{441}\u{44C} \u{43E}\u{434}\u{43D}\u{43E} \u{438}\u{437} ${$8f5391358ccbeba2$export$e79b744344f50f50(issue.values, "|")}`;
            case "too_big":
                {
                    const adj = issue.inclusive ? "<=" : "<";
                    const sizing = getSizing(issue.origin);
                    if (sizing) {
                        const maxValue = Number(issue.maximum);
                        const unit = $2c3ab961f3efbcf5$var$getRussianPlural(maxValue, sizing.unit.one, sizing.unit.few, sizing.unit.many);
                        return `\u{421}\u{43B}\u{438}\u{448}\u{43A}\u{43E}\u{43C} \u{431}\u{43E}\u{43B}\u{44C}\u{448}\u{43E}\u{435} \u{437}\u{43D}\u{430}\u{447}\u{435}\u{43D}\u{438}\u{435}: \u{43E}\u{436}\u{438}\u{434}\u{430}\u{43B}\u{43E}\u{441}\u{44C}, \u{447}\u{442}\u{43E} ${issue.origin ?? "\u0437\u043D\u0430\u0447\u0435\u043D\u0438\u0435"} \u{431}\u{443}\u{434}\u{435}\u{442} \u{438}\u{43C}\u{435}\u{442}\u{44C} ${adj}${issue.maximum.toString()} ${unit}`;
                    }
                    return `\u{421}\u{43B}\u{438}\u{448}\u{43A}\u{43E}\u{43C} \u{431}\u{43E}\u{43B}\u{44C}\u{448}\u{43E}\u{435} \u{437}\u{43D}\u{430}\u{447}\u{435}\u{43D}\u{438}\u{435}: \u{43E}\u{436}\u{438}\u{434}\u{430}\u{43B}\u{43E}\u{441}\u{44C}, \u{447}\u{442}\u{43E} ${issue.origin ?? "\u0437\u043D\u0430\u0447\u0435\u043D\u0438\u0435"} \u{431}\u{443}\u{434}\u{435}\u{442} ${adj}${issue.maximum.toString()}`;
                }
            case "too_small":
                {
                    const adj = issue.inclusive ? ">=" : ">";
                    const sizing = getSizing(issue.origin);
                    if (sizing) {
                        const minValue = Number(issue.minimum);
                        const unit = $2c3ab961f3efbcf5$var$getRussianPlural(minValue, sizing.unit.one, sizing.unit.few, sizing.unit.many);
                        return `\u{421}\u{43B}\u{438}\u{448}\u{43A}\u{43E}\u{43C} \u{43C}\u{430}\u{43B}\u{435}\u{43D}\u{44C}\u{43A}\u{43E}\u{435} \u{437}\u{43D}\u{430}\u{447}\u{435}\u{43D}\u{438}\u{435}: \u{43E}\u{436}\u{438}\u{434}\u{430}\u{43B}\u{43E}\u{441}\u{44C}, \u{447}\u{442}\u{43E} ${issue.origin} \u{431}\u{443}\u{434}\u{435}\u{442} \u{438}\u{43C}\u{435}\u{442}\u{44C} ${adj}${issue.minimum.toString()} ${unit}`;
                    }
                    return `\u{421}\u{43B}\u{438}\u{448}\u{43A}\u{43E}\u{43C} \u{43C}\u{430}\u{43B}\u{435}\u{43D}\u{44C}\u{43A}\u{43E}\u{435} \u{437}\u{43D}\u{430}\u{447}\u{435}\u{43D}\u{438}\u{435}: \u{43E}\u{436}\u{438}\u{434}\u{430}\u{43B}\u{43E}\u{441}\u{44C}, \u{447}\u{442}\u{43E} ${issue.origin} \u{431}\u{443}\u{434}\u{435}\u{442} ${adj}${issue.minimum.toString()}`;
                }
            case "invalid_format":
                {
                    const _issue = issue;
                    if (_issue.format === "starts_with") return `\u{41D}\u{435}\u{432}\u{435}\u{440}\u{43D}\u{430}\u{44F} \u{441}\u{442}\u{440}\u{43E}\u{43A}\u{430}: \u{434}\u{43E}\u{43B}\u{436}\u{43D}\u{430} \u{43D}\u{430}\u{447}\u{438}\u{43D}\u{430}\u{442}\u{44C}\u{441}\u{44F} \u{441} "${_issue.prefix}"`;
                    if (_issue.format === "ends_with") return `\u{41D}\u{435}\u{432}\u{435}\u{440}\u{43D}\u{430}\u{44F} \u{441}\u{442}\u{440}\u{43E}\u{43A}\u{430}: \u{434}\u{43E}\u{43B}\u{436}\u{43D}\u{430} \u{437}\u{430}\u{43A}\u{430}\u{43D}\u{447}\u{438}\u{432}\u{430}\u{442}\u{44C}\u{441}\u{44F} \u{43D}\u{430} "${_issue.suffix}"`;
                    if (_issue.format === "includes") return `\u{41D}\u{435}\u{432}\u{435}\u{440}\u{43D}\u{430}\u{44F} \u{441}\u{442}\u{440}\u{43E}\u{43A}\u{430}: \u{434}\u{43E}\u{43B}\u{436}\u{43D}\u{430} \u{441}\u{43E}\u{434}\u{435}\u{440}\u{436}\u{430}\u{442}\u{44C} "${_issue.includes}"`;
                    if (_issue.format === "regex") return `\u{41D}\u{435}\u{432}\u{435}\u{440}\u{43D}\u{430}\u{44F} \u{441}\u{442}\u{440}\u{43E}\u{43A}\u{430}: \u{434}\u{43E}\u{43B}\u{436}\u{43D}\u{430} \u{441}\u{43E}\u{43E}\u{442}\u{432}\u{435}\u{442}\u{441}\u{442}\u{432}\u{43E}\u{432}\u{430}\u{442}\u{44C} \u{448}\u{430}\u{431}\u{43B}\u{43E}\u{43D}\u{443} ${_issue.pattern}`;
                    return `\u{41D}\u{435}\u{432}\u{435}\u{440}\u{43D}\u{44B}\u{439} ${Nouns[_issue.format] ?? issue.format}`;
                }
            case "not_multiple_of":
                return `\u{41D}\u{435}\u{432}\u{435}\u{440}\u{43D}\u{43E}\u{435} \u{447}\u{438}\u{441}\u{43B}\u{43E}: \u{434}\u{43E}\u{43B}\u{436}\u{43D}\u{43E} \u{431}\u{44B}\u{442}\u{44C} \u{43A}\u{440}\u{430}\u{442}\u{43D}\u{44B}\u{43C} ${issue.divisor}`;
            case "unrecognized_keys":
                return `\u{41D}\u{435}\u{440}\u{430}\u{441}\u{43F}\u{43E}\u{437}\u{43D}\u{430}\u{43D}\u{43D}${issue.keys.length > 1 ? "\u044B\u0435" : "\u044B\u0439"} \u{43A}\u{43B}\u{44E}\u{447}${issue.keys.length > 1 ? "\u0438" : ""}: ${$8f5391358ccbeba2$export$e79b744344f50f50(issue.keys, ", ")}`;
            case "invalid_key":
                return `\u{41D}\u{435}\u{432}\u{435}\u{440}\u{43D}\u{44B}\u{439} \u{43A}\u{43B}\u{44E}\u{447} \u{432} ${issue.origin}`;
            case "invalid_union":
                return "\u041D\u0435\u0432\u0435\u0440\u043D\u044B\u0435 \u0432\u0445\u043E\u0434\u043D\u044B\u0435 \u0434\u0430\u043D\u043D\u044B\u0435";
            case "invalid_element":
                return `\u{41D}\u{435}\u{432}\u{435}\u{440}\u{43D}\u{43E}\u{435} \u{437}\u{43D}\u{430}\u{447}\u{435}\u{43D}\u{438}\u{435} \u{432} ${issue.origin}`;
            default:
                return `\u{41D}\u{435}\u{432}\u{435}\u{440}\u{43D}\u{44B}\u{435} \u{432}\u{445}\u{43E}\u{434}\u{43D}\u{44B}\u{435} \u{434}\u{430}\u{43D}\u{43D}\u{44B}\u{435}`;
        }
    };
};
function $2c3ab961f3efbcf5$export$2e2bcd8739ae039() {
    return {
        localeError: $2c3ab961f3efbcf5$var$error()
    };
}



const $e138688906cc9516$var$error = ()=>{
    const Sizable = {
        string: {
            unit: "znakov",
            verb: "imeti"
        },
        file: {
            unit: "bajtov",
            verb: "imeti"
        },
        array: {
            unit: "elementov",
            verb: "imeti"
        },
        set: {
            unit: "elementov",
            verb: "imeti"
        }
    };
    function getSizing(origin) {
        return Sizable[origin] ?? null;
    }
    const parsedType = (data)=>{
        const t = typeof data;
        switch(t){
            case "number":
                return Number.isNaN(data) ? "NaN" : "\u0161tevilo";
            case "object":
                if (Array.isArray(data)) return "tabela";
                if (data === null) return "null";
                if (Object.getPrototypeOf(data) !== Object.prototype && data.constructor) return data.constructor.name;
        }
        return t;
    };
    const Nouns = {
        regex: "vnos",
        email: "e-po\u0161tni naslov",
        url: "URL",
        emoji: "emoji",
        uuid: "UUID",
        uuidv4: "UUIDv4",
        uuidv6: "UUIDv6",
        nanoid: "nanoid",
        guid: "GUID",
        cuid: "cuid",
        cuid2: "cuid2",
        ulid: "ULID",
        xid: "XID",
        ksuid: "KSUID",
        datetime: "ISO datum in \u010Das",
        date: "ISO datum",
        time: "ISO \u010Das",
        duration: "ISO trajanje",
        ipv4: "IPv4 naslov",
        ipv6: "IPv6 naslov",
        cidrv4: "obseg IPv4",
        cidrv6: "obseg IPv6",
        base64: "base64 kodiran niz",
        base64url: "base64url kodiran niz",
        json_string: "JSON niz",
        e164: "E.164 \u0161tevilka",
        jwt: "JWT",
        template_literal: "vnos"
    };
    return (issue)=>{
        switch(issue.code){
            case "invalid_type":
                return `Neveljaven vnos: pri\u{10D}akovano ${issue.expected}, prejeto ${parsedType(issue.input)}`;
            case "invalid_value":
                if (issue.values.length === 1) return `Neveljaven vnos: pri\u{10D}akovano ${$8f5391358ccbeba2$export$5859860f650378f4(issue.values[0])}`;
                return `Neveljavna mo\u{17E}nost: pri\u{10D}akovano eno izmed ${$8f5391358ccbeba2$export$e79b744344f50f50(issue.values, "|")}`;
            case "too_big":
                {
                    const adj = issue.inclusive ? "<=" : "<";
                    const sizing = getSizing(issue.origin);
                    if (sizing) return `Preveliko: pri\u{10D}akovano, da bo ${issue.origin ?? "vrednost"} imelo ${adj}${issue.maximum.toString()} ${sizing.unit ?? "elementov"}`;
                    return `Preveliko: pri\u{10D}akovano, da bo ${issue.origin ?? "vrednost"} ${adj}${issue.maximum.toString()}`;
                }
            case "too_small":
                {
                    const adj = issue.inclusive ? ">=" : ">";
                    const sizing = getSizing(issue.origin);
                    if (sizing) return `Premajhno: pri\u{10D}akovano, da bo ${issue.origin} imelo ${adj}${issue.minimum.toString()} ${sizing.unit}`;
                    return `Premajhno: pri\u{10D}akovano, da bo ${issue.origin} ${adj}${issue.minimum.toString()}`;
                }
            case "invalid_format":
                {
                    const _issue = issue;
                    if (_issue.format === "starts_with") return `Neveljaven niz: mora se za\u{10D}eti z "${_issue.prefix}"`;
                    if (_issue.format === "ends_with") return `Neveljaven niz: mora se kon\u{10D}ati z "${_issue.suffix}"`;
                    if (_issue.format === "includes") return `Neveljaven niz: mora vsebovati "${_issue.includes}"`;
                    if (_issue.format === "regex") return `Neveljaven niz: mora ustrezati vzorcu ${_issue.pattern}`;
                    return `Neveljaven ${Nouns[_issue.format] ?? issue.format}`;
                }
            case "not_multiple_of":
                return `Neveljavno \u{161}tevilo: mora biti ve\u{10D}kratnik ${issue.divisor}`;
            case "unrecognized_keys":
                return `Neprepoznan${issue.keys.length > 1 ? "i klju\u010Di" : " klju\u010D"}: ${$8f5391358ccbeba2$export$e79b744344f50f50(issue.keys, ", ")}`;
            case "invalid_key":
                return `Neveljaven klju\u{10D} v ${issue.origin}`;
            case "invalid_union":
                return "Neveljaven vnos";
            case "invalid_element":
                return `Neveljavna vrednost v ${issue.origin}`;
            default:
                return "Neveljaven vnos";
        }
    };
};
function $e138688906cc9516$export$2e2bcd8739ae039() {
    return {
        localeError: $e138688906cc9516$var$error()
    };
}



const $029658e9e97709f5$var$error = ()=>{
    const Sizable = {
        string: {
            unit: "tecken",
            verb: "att ha"
        },
        file: {
            unit: "bytes",
            verb: "att ha"
        },
        array: {
            unit: "objekt",
            verb: "att inneh\xe5lla"
        },
        set: {
            unit: "objekt",
            verb: "att inneh\xe5lla"
        }
    };
    function getSizing(origin) {
        return Sizable[origin] ?? null;
    }
    const parsedType = (data)=>{
        const t = typeof data;
        switch(t){
            case "number":
                return Number.isNaN(data) ? "NaN" : "antal";
            case "object":
                if (Array.isArray(data)) return "lista";
                if (data === null) return "null";
                if (Object.getPrototypeOf(data) !== Object.prototype && data.constructor) return data.constructor.name;
        }
        return t;
    };
    const Nouns = {
        regex: "regulj\xe4rt uttryck",
        email: "e-postadress",
        url: "URL",
        emoji: "emoji",
        uuid: "UUID",
        uuidv4: "UUIDv4",
        uuidv6: "UUIDv6",
        nanoid: "nanoid",
        guid: "GUID",
        cuid: "cuid",
        cuid2: "cuid2",
        ulid: "ULID",
        xid: "XID",
        ksuid: "KSUID",
        datetime: "ISO-datum och tid",
        date: "ISO-datum",
        time: "ISO-tid",
        duration: "ISO-varaktighet",
        ipv4: "IPv4-intervall",
        ipv6: "IPv6-intervall",
        cidrv4: "IPv4-spektrum",
        cidrv6: "IPv6-spektrum",
        base64: "base64-kodad str\xe4ng",
        base64url: "base64url-kodad str\xe4ng",
        json_string: "JSON-str\xe4ng",
        e164: "E.164-nummer",
        jwt: "JWT",
        template_literal: "mall-literal"
    };
    return (issue)=>{
        switch(issue.code){
            case "invalid_type":
                return `Ogiltig inmatning: f\xf6rv\xe4ntat ${issue.expected}, fick ${parsedType(issue.input)}`;
            case "invalid_value":
                if (issue.values.length === 1) return `Ogiltig inmatning: f\xf6rv\xe4ntat ${$8f5391358ccbeba2$export$5859860f650378f4(issue.values[0])}`;
                return `Ogiltigt val: f\xf6rv\xe4ntade en av ${$8f5391358ccbeba2$export$e79b744344f50f50(issue.values, "|")}`;
            case "too_big":
                {
                    const adj = issue.inclusive ? "<=" : "<";
                    const sizing = getSizing(issue.origin);
                    if (sizing) return `F\xf6r stor(t): f\xf6rv\xe4ntade ${issue.origin ?? "v\xe4rdet"} att ha ${adj}${issue.maximum.toString()} ${sizing.unit ?? "element"}`;
                    return `F\xf6r stor(t): f\xf6rv\xe4ntat ${issue.origin ?? "v\xe4rdet"} att ha ${adj}${issue.maximum.toString()}`;
                }
            case "too_small":
                {
                    const adj = issue.inclusive ? ">=" : ">";
                    const sizing = getSizing(issue.origin);
                    if (sizing) return `F\xf6r lite(t): f\xf6rv\xe4ntade ${issue.origin ?? "v\xe4rdet"} att ha ${adj}${issue.minimum.toString()} ${sizing.unit}`;
                    return `F\xf6r lite(t): f\xf6rv\xe4ntade ${issue.origin ?? "v\xe4rdet"} att ha ${adj}${issue.minimum.toString()}`;
                }
            case "invalid_format":
                {
                    const _issue = issue;
                    if (_issue.format === "starts_with") return `Ogiltig str\xe4ng: m\xe5ste b\xf6rja med "${_issue.prefix}"`;
                    if (_issue.format === "ends_with") return `Ogiltig str\xe4ng: m\xe5ste sluta med "${_issue.suffix}"`;
                    if (_issue.format === "includes") return `Ogiltig str\xe4ng: m\xe5ste inneh\xe5lla "${_issue.includes}"`;
                    if (_issue.format === "regex") return `Ogiltig str\xe4ng: m\xe5ste matcha m\xf6nstret "${_issue.pattern}"`;
                    return `Ogiltig(t) ${Nouns[_issue.format] ?? issue.format}`;
                }
            case "not_multiple_of":
                return `Ogiltigt tal: m\xe5ste vara en multipel av ${issue.divisor}`;
            case "unrecognized_keys":
                return `${issue.keys.length > 1 ? "Ok\xe4nda nycklar" : "Ok\xe4nd nyckel"}: ${$8f5391358ccbeba2$export$e79b744344f50f50(issue.keys, ", ")}`;
            case "invalid_key":
                return `Ogiltig nyckel i ${issue.origin ?? "v\xe4rdet"}`;
            case "invalid_union":
                return "Ogiltig input";
            case "invalid_element":
                return `Ogiltigt v\xe4rde i ${issue.origin ?? "v\xe4rdet"}`;
            default:
                return `Ogiltig input`;
        }
    };
};
function $029658e9e97709f5$export$2e2bcd8739ae039() {
    return {
        localeError: $029658e9e97709f5$var$error()
    };
}



const $f36a75a3a95cfbd5$var$error = ()=>{
    const Sizable = {
        string: {
            unit: "\u0B8E\u0BB4\u0BC1\u0BA4\u0BCD\u0BA4\u0BC1\u0B95\u0BCD\u0B95\u0BB3\u0BCD",
            verb: "\u0B95\u0BCA\u0BA3\u0BCD\u0B9F\u0BBF\u0BB0\u0BC1\u0B95\u0BCD\u0B95 \u0BB5\u0BC7\u0BA3\u0BCD\u0B9F\u0BC1\u0BAE\u0BCD"
        },
        file: {
            unit: "\u0BAA\u0BC8\u0B9F\u0BCD\u0B9F\u0BC1\u0B95\u0BB3\u0BCD",
            verb: "\u0B95\u0BCA\u0BA3\u0BCD\u0B9F\u0BBF\u0BB0\u0BC1\u0B95\u0BCD\u0B95 \u0BB5\u0BC7\u0BA3\u0BCD\u0B9F\u0BC1\u0BAE\u0BCD"
        },
        array: {
            unit: "\u0B89\u0BB1\u0BC1\u0BAA\u0BCD\u0BAA\u0BC1\u0B95\u0BB3\u0BCD",
            verb: "\u0B95\u0BCA\u0BA3\u0BCD\u0B9F\u0BBF\u0BB0\u0BC1\u0B95\u0BCD\u0B95 \u0BB5\u0BC7\u0BA3\u0BCD\u0B9F\u0BC1\u0BAE\u0BCD"
        },
        set: {
            unit: "\u0B89\u0BB1\u0BC1\u0BAA\u0BCD\u0BAA\u0BC1\u0B95\u0BB3\u0BCD",
            verb: "\u0B95\u0BCA\u0BA3\u0BCD\u0B9F\u0BBF\u0BB0\u0BC1\u0B95\u0BCD\u0B95 \u0BB5\u0BC7\u0BA3\u0BCD\u0B9F\u0BC1\u0BAE\u0BCD"
        }
    };
    function getSizing(origin) {
        return Sizable[origin] ?? null;
    }
    const parsedType = (data)=>{
        const t = typeof data;
        switch(t){
            case "number":
                return Number.isNaN(data) ? "\u0B8E\u0BA3\u0BCD \u0B85\u0BB2\u0BCD\u0BB2\u0BBE\u0BA4\u0BA4\u0BC1" : "\u0B8E\u0BA3\u0BCD";
            case "object":
                if (Array.isArray(data)) return "\u0B85\u0BA3\u0BBF";
                if (data === null) return "\u0BB5\u0BC6\u0BB1\u0BC1\u0BAE\u0BC8";
                if (Object.getPrototypeOf(data) !== Object.prototype && data.constructor) return data.constructor.name;
        }
        return t;
    };
    const Nouns = {
        regex: "\u0B89\u0BB3\u0BCD\u0BB3\u0BC0\u0B9F\u0BC1",
        email: "\u0BAE\u0BBF\u0BA9\u0BCD\u0BA9\u0B9E\u0BCD\u0B9A\u0BB2\u0BCD \u0BAE\u0BC1\u0B95\u0BB5\u0BB0\u0BBF",
        url: "URL",
        emoji: "emoji",
        uuid: "UUID",
        uuidv4: "UUIDv4",
        uuidv6: "UUIDv6",
        nanoid: "nanoid",
        guid: "GUID",
        cuid: "cuid",
        cuid2: "cuid2",
        ulid: "ULID",
        xid: "XID",
        ksuid: "KSUID",
        datetime: "ISO \u0BA4\u0BC7\u0BA4\u0BBF \u0BA8\u0BC7\u0BB0\u0BAE\u0BCD",
        date: "ISO \u0BA4\u0BC7\u0BA4\u0BBF",
        time: "ISO \u0BA8\u0BC7\u0BB0\u0BAE\u0BCD",
        duration: "ISO \u0B95\u0BBE\u0BB2 \u0B85\u0BB3\u0BB5\u0BC1",
        ipv4: "IPv4 \u0BAE\u0BC1\u0B95\u0BB5\u0BB0\u0BBF",
        ipv6: "IPv6 \u0BAE\u0BC1\u0B95\u0BB5\u0BB0\u0BBF",
        cidrv4: "IPv4 \u0BB5\u0BB0\u0BAE\u0BCD\u0BAA\u0BC1",
        cidrv6: "IPv6 \u0BB5\u0BB0\u0BAE\u0BCD\u0BAA\u0BC1",
        base64: "base64-encoded \u0B9A\u0BB0\u0BAE\u0BCD",
        base64url: "base64url-encoded \u0B9A\u0BB0\u0BAE\u0BCD",
        json_string: "JSON \u0B9A\u0BB0\u0BAE\u0BCD",
        e164: "E.164 \u0B8E\u0BA3\u0BCD",
        jwt: "JWT",
        template_literal: "input"
    };
    return (issue)=>{
        switch(issue.code){
            case "invalid_type":
                return `\u{BA4}\u{BB5}\u{BB1}\u{BBE}\u{BA9} \u{B89}\u{BB3}\u{BCD}\u{BB3}\u{BC0}\u{B9F}\u{BC1}: \u{B8E}\u{BA4}\u{BBF}\u{BB0}\u{BCD}\u{BAA}\u{BBE}\u{BB0}\u{BCD}\u{B95}\u{BCD}\u{B95}\u{BAA}\u{BCD}\u{BAA}\u{B9F}\u{BCD}\u{B9F}\u{BA4}\u{BC1} ${issue.expected}, \u{BAA}\u{BC6}\u{BB1}\u{BAA}\u{BCD}\u{BAA}\u{B9F}\u{BCD}\u{B9F}\u{BA4}\u{BC1} ${parsedType(issue.input)}`;
            case "invalid_value":
                if (issue.values.length === 1) return `\u{BA4}\u{BB5}\u{BB1}\u{BBE}\u{BA9} \u{B89}\u{BB3}\u{BCD}\u{BB3}\u{BC0}\u{B9F}\u{BC1}: \u{B8E}\u{BA4}\u{BBF}\u{BB0}\u{BCD}\u{BAA}\u{BBE}\u{BB0}\u{BCD}\u{B95}\u{BCD}\u{B95}\u{BAA}\u{BCD}\u{BAA}\u{B9F}\u{BCD}\u{B9F}\u{BA4}\u{BC1} ${$8f5391358ccbeba2$export$5859860f650378f4(issue.values[0])}`;
                return `\u{BA4}\u{BB5}\u{BB1}\u{BBE}\u{BA9} \u{BB5}\u{BBF}\u{BB0}\u{BC1}\u{BAA}\u{BCD}\u{BAA}\u{BAE}\u{BCD}: \u{B8E}\u{BA4}\u{BBF}\u{BB0}\u{BCD}\u{BAA}\u{BBE}\u{BB0}\u{BCD}\u{B95}\u{BCD}\u{B95}\u{BAA}\u{BCD}\u{BAA}\u{B9F}\u{BCD}\u{B9F}\u{BA4}\u{BC1} ${$8f5391358ccbeba2$export$e79b744344f50f50(issue.values, "|")} \u{B87}\u{BB2}\u{BCD} \u{B92}\u{BA9}\u{BCD}\u{BB1}\u{BC1}`;
            case "too_big":
                {
                    const adj = issue.inclusive ? "<=" : "<";
                    const sizing = getSizing(issue.origin);
                    if (sizing) return `\u{BAE}\u{BBF}\u{B95} \u{BAA}\u{BC6}\u{BB0}\u{BBF}\u{BAF}\u{BA4}\u{BC1}: \u{B8E}\u{BA4}\u{BBF}\u{BB0}\u{BCD}\u{BAA}\u{BBE}\u{BB0}\u{BCD}\u{B95}\u{BCD}\u{B95}\u{BAA}\u{BCD}\u{BAA}\u{B9F}\u{BCD}\u{B9F}\u{BA4}\u{BC1} ${issue.origin ?? "\u0BAE\u0BA4\u0BBF\u0BAA\u0BCD\u0BAA\u0BC1"} ${adj}${issue.maximum.toString()} ${sizing.unit ?? "\u0B89\u0BB1\u0BC1\u0BAA\u0BCD\u0BAA\u0BC1\u0B95\u0BB3\u0BCD"} \u{B86}\u{B95} \u{B87}\u{BB0}\u{BC1}\u{B95}\u{BCD}\u{B95} \u{BB5}\u{BC7}\u{BA3}\u{BCD}\u{B9F}\u{BC1}\u{BAE}\u{BCD}`;
                    return `\u{BAE}\u{BBF}\u{B95} \u{BAA}\u{BC6}\u{BB0}\u{BBF}\u{BAF}\u{BA4}\u{BC1}: \u{B8E}\u{BA4}\u{BBF}\u{BB0}\u{BCD}\u{BAA}\u{BBE}\u{BB0}\u{BCD}\u{B95}\u{BCD}\u{B95}\u{BAA}\u{BCD}\u{BAA}\u{B9F}\u{BCD}\u{B9F}\u{BA4}\u{BC1} ${issue.origin ?? "\u0BAE\u0BA4\u0BBF\u0BAA\u0BCD\u0BAA\u0BC1"} ${adj}${issue.maximum.toString()} \u{B86}\u{B95} \u{B87}\u{BB0}\u{BC1}\u{B95}\u{BCD}\u{B95} \u{BB5}\u{BC7}\u{BA3}\u{BCD}\u{B9F}\u{BC1}\u{BAE}\u{BCD}`;
                }
            case "too_small":
                {
                    const adj = issue.inclusive ? ">=" : ">";
                    const sizing = getSizing(issue.origin);
                    if (sizing) return `\u{BAE}\u{BBF}\u{B95}\u{B9A}\u{BCD} \u{B9A}\u{BBF}\u{BB1}\u{BBF}\u{BAF}\u{BA4}\u{BC1}: \u{B8E}\u{BA4}\u{BBF}\u{BB0}\u{BCD}\u{BAA}\u{BBE}\u{BB0}\u{BCD}\u{B95}\u{BCD}\u{B95}\u{BAA}\u{BCD}\u{BAA}\u{B9F}\u{BCD}\u{B9F}\u{BA4}\u{BC1} ${issue.origin} ${adj}${issue.minimum.toString()} ${sizing.unit} \u{B86}\u{B95} \u{B87}\u{BB0}\u{BC1}\u{B95}\u{BCD}\u{B95} \u{BB5}\u{BC7}\u{BA3}\u{BCD}\u{B9F}\u{BC1}\u{BAE}\u{BCD}`; //
                    return `\u{BAE}\u{BBF}\u{B95}\u{B9A}\u{BCD} \u{B9A}\u{BBF}\u{BB1}\u{BBF}\u{BAF}\u{BA4}\u{BC1}: \u{B8E}\u{BA4}\u{BBF}\u{BB0}\u{BCD}\u{BAA}\u{BBE}\u{BB0}\u{BCD}\u{B95}\u{BCD}\u{B95}\u{BAA}\u{BCD}\u{BAA}\u{B9F}\u{BCD}\u{B9F}\u{BA4}\u{BC1} ${issue.origin} ${adj}${issue.minimum.toString()} \u{B86}\u{B95} \u{B87}\u{BB0}\u{BC1}\u{B95}\u{BCD}\u{B95} \u{BB5}\u{BC7}\u{BA3}\u{BCD}\u{B9F}\u{BC1}\u{BAE}\u{BCD}`;
                }
            case "invalid_format":
                {
                    const _issue = issue;
                    if (_issue.format === "starts_with") return `\u{BA4}\u{BB5}\u{BB1}\u{BBE}\u{BA9} \u{B9A}\u{BB0}\u{BAE}\u{BCD}: "${_issue.prefix}" \u{B87}\u{BB2}\u{BCD} \u{BA4}\u{BCA}\u{B9F}\u{B99}\u{BCD}\u{B95} \u{BB5}\u{BC7}\u{BA3}\u{BCD}\u{B9F}\u{BC1}\u{BAE}\u{BCD}`;
                    if (_issue.format === "ends_with") return `\u{BA4}\u{BB5}\u{BB1}\u{BBE}\u{BA9} \u{B9A}\u{BB0}\u{BAE}\u{BCD}: "${_issue.suffix}" \u{B87}\u{BB2}\u{BCD} \u{BAE}\u{BC1}\u{B9F}\u{BBF}\u{BB5}\u{B9F}\u{BC8}\u{BAF} \u{BB5}\u{BC7}\u{BA3}\u{BCD}\u{B9F}\u{BC1}\u{BAE}\u{BCD}`;
                    if (_issue.format === "includes") return `\u{BA4}\u{BB5}\u{BB1}\u{BBE}\u{BA9} \u{B9A}\u{BB0}\u{BAE}\u{BCD}: "${_issue.includes}" \u{B90} \u{B89}\u{BB3}\u{BCD}\u{BB3}\u{B9F}\u{B95}\u{BCD}\u{B95} \u{BB5}\u{BC7}\u{BA3}\u{BCD}\u{B9F}\u{BC1}\u{BAE}\u{BCD}`;
                    if (_issue.format === "regex") return `\u{BA4}\u{BB5}\u{BB1}\u{BBE}\u{BA9} \u{B9A}\u{BB0}\u{BAE}\u{BCD}: ${_issue.pattern} \u{BAE}\u{BC1}\u{BB1}\u{BC8}\u{BAA}\u{BBE}\u{B9F}\u{BCD}\u{B9F}\u{BC1}\u{B9F}\u{BA9}\u{BCD} \u{BAA}\u{BCA}\u{BB0}\u{BC1}\u{BA8}\u{BCD}\u{BA4} \u{BB5}\u{BC7}\u{BA3}\u{BCD}\u{B9F}\u{BC1}\u{BAE}\u{BCD}`;
                    return `\u{BA4}\u{BB5}\u{BB1}\u{BBE}\u{BA9} ${Nouns[_issue.format] ?? issue.format}`;
                }
            case "not_multiple_of":
                return `\u{BA4}\u{BB5}\u{BB1}\u{BBE}\u{BA9} \u{B8E}\u{BA3}\u{BCD}: ${issue.divisor} \u{B87}\u{BA9}\u{BCD} \u{BAA}\u{BB2}\u{BAE}\u{BBE}\u{B95} \u{B87}\u{BB0}\u{BC1}\u{B95}\u{BCD}\u{B95} \u{BB5}\u{BC7}\u{BA3}\u{BCD}\u{B9F}\u{BC1}\u{BAE}\u{BCD}`;
            case "unrecognized_keys":
                return `\u{B85}\u{B9F}\u{BC8}\u{BAF}\u{BBE}\u{BB3}\u{BAE}\u{BCD} \u{BA4}\u{BC6}\u{BB0}\u{BBF}\u{BAF}\u{BBE}\u{BA4} \u{BB5}\u{BBF}\u{B9A}\u{BC8}${issue.keys.length > 1 ? "\u0B95\u0BB3\u0BCD" : ""}: ${$8f5391358ccbeba2$export$e79b744344f50f50(issue.keys, ", ")}`;
            case "invalid_key":
                return `${issue.origin} \u{B87}\u{BB2}\u{BCD} \u{BA4}\u{BB5}\u{BB1}\u{BBE}\u{BA9} \u{BB5}\u{BBF}\u{B9A}\u{BC8}`;
            case "invalid_union":
                return "\u0BA4\u0BB5\u0BB1\u0BBE\u0BA9 \u0B89\u0BB3\u0BCD\u0BB3\u0BC0\u0B9F\u0BC1";
            case "invalid_element":
                return `${issue.origin} \u{B87}\u{BB2}\u{BCD} \u{BA4}\u{BB5}\u{BB1}\u{BBE}\u{BA9} \u{BAE}\u{BA4}\u{BBF}\u{BAA}\u{BCD}\u{BAA}\u{BC1}`;
            default:
                return `\u{BA4}\u{BB5}\u{BB1}\u{BBE}\u{BA9} \u{B89}\u{BB3}\u{BCD}\u{BB3}\u{BC0}\u{B9F}\u{BC1}`;
        }
    };
};
function $f36a75a3a95cfbd5$export$2e2bcd8739ae039() {
    return {
        localeError: $f36a75a3a95cfbd5$var$error()
    };
}



const $d3e718b0ef101b2b$var$error = ()=>{
    const Sizable = {
        string: {
            unit: "\u0E15\u0E31\u0E27\u0E2D\u0E31\u0E01\u0E29\u0E23",
            verb: "\u0E04\u0E27\u0E23\u0E21\u0E35"
        },
        file: {
            unit: "\u0E44\u0E1A\u0E15\u0E4C",
            verb: "\u0E04\u0E27\u0E23\u0E21\u0E35"
        },
        array: {
            unit: "\u0E23\u0E32\u0E22\u0E01\u0E32\u0E23",
            verb: "\u0E04\u0E27\u0E23\u0E21\u0E35"
        },
        set: {
            unit: "\u0E23\u0E32\u0E22\u0E01\u0E32\u0E23",
            verb: "\u0E04\u0E27\u0E23\u0E21\u0E35"
        }
    };
    function getSizing(origin) {
        return Sizable[origin] ?? null;
    }
    const parsedType = (data)=>{
        const t = typeof data;
        switch(t){
            case "number":
                return Number.isNaN(data) ? "\u0E44\u0E21\u0E48\u0E43\u0E0A\u0E48\u0E15\u0E31\u0E27\u0E40\u0E25\u0E02 (NaN)" : "\u0E15\u0E31\u0E27\u0E40\u0E25\u0E02";
            case "object":
                if (Array.isArray(data)) return "\u0E2D\u0E32\u0E23\u0E4C\u0E40\u0E23\u0E22\u0E4C (Array)";
                if (data === null) return "\u0E44\u0E21\u0E48\u0E21\u0E35\u0E04\u0E48\u0E32 (null)";
                if (Object.getPrototypeOf(data) !== Object.prototype && data.constructor) return data.constructor.name;
        }
        return t;
    };
    const Nouns = {
        regex: "\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E17\u0E35\u0E48\u0E1B\u0E49\u0E2D\u0E19",
        email: "\u0E17\u0E35\u0E48\u0E2D\u0E22\u0E39\u0E48\u0E2D\u0E35\u0E40\u0E21\u0E25",
        url: "URL",
        emoji: "\u0E2D\u0E34\u0E42\u0E21\u0E08\u0E34",
        uuid: "UUID",
        uuidv4: "UUIDv4",
        uuidv6: "UUIDv6",
        nanoid: "nanoid",
        guid: "GUID",
        cuid: "cuid",
        cuid2: "cuid2",
        ulid: "ULID",
        xid: "XID",
        ksuid: "KSUID",
        datetime: "\u0E27\u0E31\u0E19\u0E17\u0E35\u0E48\u0E40\u0E27\u0E25\u0E32\u0E41\u0E1A\u0E1A ISO",
        date: "\u0E27\u0E31\u0E19\u0E17\u0E35\u0E48\u0E41\u0E1A\u0E1A ISO",
        time: "\u0E40\u0E27\u0E25\u0E32\u0E41\u0E1A\u0E1A ISO",
        duration: "\u0E0A\u0E48\u0E27\u0E07\u0E40\u0E27\u0E25\u0E32\u0E41\u0E1A\u0E1A ISO",
        ipv4: "\u0E17\u0E35\u0E48\u0E2D\u0E22\u0E39\u0E48 IPv4",
        ipv6: "\u0E17\u0E35\u0E48\u0E2D\u0E22\u0E39\u0E48 IPv6",
        cidrv4: "\u0E0A\u0E48\u0E27\u0E07 IP \u0E41\u0E1A\u0E1A IPv4",
        cidrv6: "\u0E0A\u0E48\u0E27\u0E07 IP \u0E41\u0E1A\u0E1A IPv6",
        base64: "\u0E02\u0E49\u0E2D\u0E04\u0E27\u0E32\u0E21\u0E41\u0E1A\u0E1A Base64",
        base64url: "\u0E02\u0E49\u0E2D\u0E04\u0E27\u0E32\u0E21\u0E41\u0E1A\u0E1A Base64 \u0E2A\u0E33\u0E2B\u0E23\u0E31\u0E1A URL",
        json_string: "\u0E02\u0E49\u0E2D\u0E04\u0E27\u0E32\u0E21\u0E41\u0E1A\u0E1A JSON",
        e164: "\u0E40\u0E1A\u0E2D\u0E23\u0E4C\u0E42\u0E17\u0E23\u0E28\u0E31\u0E1E\u0E17\u0E4C\u0E23\u0E30\u0E2B\u0E27\u0E48\u0E32\u0E07\u0E1B\u0E23\u0E30\u0E40\u0E17\u0E28 (E.164)",
        jwt: "\u0E42\u0E17\u0E40\u0E04\u0E19 JWT",
        template_literal: "\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E17\u0E35\u0E48\u0E1B\u0E49\u0E2D\u0E19"
    };
    return (issue)=>{
        switch(issue.code){
            case "invalid_type":
                return `\u{E1B}\u{E23}\u{E30}\u{E40}\u{E20}\u{E17}\u{E02}\u{E49}\u{E2D}\u{E21}\u{E39}\u{E25}\u{E44}\u{E21}\u{E48}\u{E16}\u{E39}\u{E01}\u{E15}\u{E49}\u{E2D}\u{E07}: \u{E04}\u{E27}\u{E23}\u{E40}\u{E1B}\u{E47}\u{E19} ${issue.expected} \u{E41}\u{E15}\u{E48}\u{E44}\u{E14}\u{E49}\u{E23}\u{E31}\u{E1A} ${parsedType(issue.input)}`;
            case "invalid_value":
                if (issue.values.length === 1) return `\u{E04}\u{E48}\u{E32}\u{E44}\u{E21}\u{E48}\u{E16}\u{E39}\u{E01}\u{E15}\u{E49}\u{E2D}\u{E07}: \u{E04}\u{E27}\u{E23}\u{E40}\u{E1B}\u{E47}\u{E19} ${$8f5391358ccbeba2$export$5859860f650378f4(issue.values[0])}`;
                return `\u{E15}\u{E31}\u{E27}\u{E40}\u{E25}\u{E37}\u{E2D}\u{E01}\u{E44}\u{E21}\u{E48}\u{E16}\u{E39}\u{E01}\u{E15}\u{E49}\u{E2D}\u{E07}: \u{E04}\u{E27}\u{E23}\u{E40}\u{E1B}\u{E47}\u{E19}\u{E2B}\u{E19}\u{E36}\u{E48}\u{E07}\u{E43}\u{E19} ${$8f5391358ccbeba2$export$e79b744344f50f50(issue.values, "|")}`;
            case "too_big":
                {
                    const adj = issue.inclusive ? "\u0E44\u0E21\u0E48\u0E40\u0E01\u0E34\u0E19" : "\u0E19\u0E49\u0E2D\u0E22\u0E01\u0E27\u0E48\u0E32";
                    const sizing = getSizing(issue.origin);
                    if (sizing) return `\u{E40}\u{E01}\u{E34}\u{E19}\u{E01}\u{E33}\u{E2B}\u{E19}\u{E14}: ${issue.origin ?? "\u0E04\u0E48\u0E32"} \u{E04}\u{E27}\u{E23}\u{E21}\u{E35}${adj} ${issue.maximum.toString()} ${sizing.unit ?? "\u0E23\u0E32\u0E22\u0E01\u0E32\u0E23"}`;
                    return `\u{E40}\u{E01}\u{E34}\u{E19}\u{E01}\u{E33}\u{E2B}\u{E19}\u{E14}: ${issue.origin ?? "\u0E04\u0E48\u0E32"} \u{E04}\u{E27}\u{E23}\u{E21}\u{E35}${adj} ${issue.maximum.toString()}`;
                }
            case "too_small":
                {
                    const adj = issue.inclusive ? "\u0E2D\u0E22\u0E48\u0E32\u0E07\u0E19\u0E49\u0E2D\u0E22" : "\u0E21\u0E32\u0E01\u0E01\u0E27\u0E48\u0E32";
                    const sizing = getSizing(issue.origin);
                    if (sizing) return `\u{E19}\u{E49}\u{E2D}\u{E22}\u{E01}\u{E27}\u{E48}\u{E32}\u{E01}\u{E33}\u{E2B}\u{E19}\u{E14}: ${issue.origin} \u{E04}\u{E27}\u{E23}\u{E21}\u{E35}${adj} ${issue.minimum.toString()} ${sizing.unit}`;
                    return `\u{E19}\u{E49}\u{E2D}\u{E22}\u{E01}\u{E27}\u{E48}\u{E32}\u{E01}\u{E33}\u{E2B}\u{E19}\u{E14}: ${issue.origin} \u{E04}\u{E27}\u{E23}\u{E21}\u{E35}${adj} ${issue.minimum.toString()}`;
                }
            case "invalid_format":
                {
                    const _issue = issue;
                    if (_issue.format === "starts_with") return `\u{E23}\u{E39}\u{E1B}\u{E41}\u{E1A}\u{E1A}\u{E44}\u{E21}\u{E48}\u{E16}\u{E39}\u{E01}\u{E15}\u{E49}\u{E2D}\u{E07}: \u{E02}\u{E49}\u{E2D}\u{E04}\u{E27}\u{E32}\u{E21}\u{E15}\u{E49}\u{E2D}\u{E07}\u{E02}\u{E36}\u{E49}\u{E19}\u{E15}\u{E49}\u{E19}\u{E14}\u{E49}\u{E27}\u{E22} "${_issue.prefix}"`;
                    if (_issue.format === "ends_with") return `\u{E23}\u{E39}\u{E1B}\u{E41}\u{E1A}\u{E1A}\u{E44}\u{E21}\u{E48}\u{E16}\u{E39}\u{E01}\u{E15}\u{E49}\u{E2D}\u{E07}: \u{E02}\u{E49}\u{E2D}\u{E04}\u{E27}\u{E32}\u{E21}\u{E15}\u{E49}\u{E2D}\u{E07}\u{E25}\u{E07}\u{E17}\u{E49}\u{E32}\u{E22}\u{E14}\u{E49}\u{E27}\u{E22} "${_issue.suffix}"`;
                    if (_issue.format === "includes") return `\u{E23}\u{E39}\u{E1B}\u{E41}\u{E1A}\u{E1A}\u{E44}\u{E21}\u{E48}\u{E16}\u{E39}\u{E01}\u{E15}\u{E49}\u{E2D}\u{E07}: \u{E02}\u{E49}\u{E2D}\u{E04}\u{E27}\u{E32}\u{E21}\u{E15}\u{E49}\u{E2D}\u{E07}\u{E21}\u{E35} "${_issue.includes}" \u{E2D}\u{E22}\u{E39}\u{E48}\u{E43}\u{E19}\u{E02}\u{E49}\u{E2D}\u{E04}\u{E27}\u{E32}\u{E21}`;
                    if (_issue.format === "regex") return `\u{E23}\u{E39}\u{E1B}\u{E41}\u{E1A}\u{E1A}\u{E44}\u{E21}\u{E48}\u{E16}\u{E39}\u{E01}\u{E15}\u{E49}\u{E2D}\u{E07}: \u{E15}\u{E49}\u{E2D}\u{E07}\u{E15}\u{E23}\u{E07}\u{E01}\u{E31}\u{E1A}\u{E23}\u{E39}\u{E1B}\u{E41}\u{E1A}\u{E1A}\u{E17}\u{E35}\u{E48}\u{E01}\u{E33}\u{E2B}\u{E19}\u{E14} ${_issue.pattern}`;
                    return `\u{E23}\u{E39}\u{E1B}\u{E41}\u{E1A}\u{E1A}\u{E44}\u{E21}\u{E48}\u{E16}\u{E39}\u{E01}\u{E15}\u{E49}\u{E2D}\u{E07}: ${Nouns[_issue.format] ?? issue.format}`;
                }
            case "not_multiple_of":
                return `\u{E15}\u{E31}\u{E27}\u{E40}\u{E25}\u{E02}\u{E44}\u{E21}\u{E48}\u{E16}\u{E39}\u{E01}\u{E15}\u{E49}\u{E2D}\u{E07}: \u{E15}\u{E49}\u{E2D}\u{E07}\u{E40}\u{E1B}\u{E47}\u{E19}\u{E08}\u{E33}\u{E19}\u{E27}\u{E19}\u{E17}\u{E35}\u{E48}\u{E2B}\u{E32}\u{E23}\u{E14}\u{E49}\u{E27}\u{E22} ${issue.divisor} \u{E44}\u{E14}\u{E49}\u{E25}\u{E07}\u{E15}\u{E31}\u{E27}`;
            case "unrecognized_keys":
                return `\u{E1E}\u{E1A}\u{E04}\u{E35}\u{E22}\u{E4C}\u{E17}\u{E35}\u{E48}\u{E44}\u{E21}\u{E48}\u{E23}\u{E39}\u{E49}\u{E08}\u{E31}\u{E01}: ${$8f5391358ccbeba2$export$e79b744344f50f50(issue.keys, ", ")}`;
            case "invalid_key":
                return `\u{E04}\u{E35}\u{E22}\u{E4C}\u{E44}\u{E21}\u{E48}\u{E16}\u{E39}\u{E01}\u{E15}\u{E49}\u{E2D}\u{E07}\u{E43}\u{E19} ${issue.origin}`;
            case "invalid_union":
                return "\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E44\u0E21\u0E48\u0E16\u0E39\u0E01\u0E15\u0E49\u0E2D\u0E07: \u0E44\u0E21\u0E48\u0E15\u0E23\u0E07\u0E01\u0E31\u0E1A\u0E23\u0E39\u0E1B\u0E41\u0E1A\u0E1A\u0E22\u0E39\u0E40\u0E19\u0E35\u0E22\u0E19\u0E17\u0E35\u0E48\u0E01\u0E33\u0E2B\u0E19\u0E14\u0E44\u0E27\u0E49";
            case "invalid_element":
                return `\u{E02}\u{E49}\u{E2D}\u{E21}\u{E39}\u{E25}\u{E44}\u{E21}\u{E48}\u{E16}\u{E39}\u{E01}\u{E15}\u{E49}\u{E2D}\u{E07}\u{E43}\u{E19} ${issue.origin}`;
            default:
                return `\u{E02}\u{E49}\u{E2D}\u{E21}\u{E39}\u{E25}\u{E44}\u{E21}\u{E48}\u{E16}\u{E39}\u{E01}\u{E15}\u{E49}\u{E2D}\u{E07}`;
        }
    };
};
function $d3e718b0ef101b2b$export$2e2bcd8739ae039() {
    return {
        localeError: $d3e718b0ef101b2b$var$error()
    };
}



const $0acde46f117b7988$export$858d360cf6da2b65 = (data)=>{
    const t = typeof data;
    switch(t){
        case "number":
            return Number.isNaN(data) ? "NaN" : "number";
        case "object":
            if (Array.isArray(data)) return "array";
            if (data === null) return "null";
            if (Object.getPrototypeOf(data) !== Object.prototype && data.constructor) return data.constructor.name;
    }
    return t;
};
const $0acde46f117b7988$var$error = ()=>{
    const Sizable = {
        string: {
            unit: "karakter",
            verb: "olmal\u0131"
        },
        file: {
            unit: "bayt",
            verb: "olmal\u0131"
        },
        array: {
            unit: "\xf6\u011Fe",
            verb: "olmal\u0131"
        },
        set: {
            unit: "\xf6\u011Fe",
            verb: "olmal\u0131"
        }
    };
    function getSizing(origin) {
        return Sizable[origin] ?? null;
    }
    const Nouns = {
        regex: "girdi",
        email: "e-posta adresi",
        url: "URL",
        emoji: "emoji",
        uuid: "UUID",
        uuidv4: "UUIDv4",
        uuidv6: "UUIDv6",
        nanoid: "nanoid",
        guid: "GUID",
        cuid: "cuid",
        cuid2: "cuid2",
        ulid: "ULID",
        xid: "XID",
        ksuid: "KSUID",
        datetime: "ISO tarih ve saat",
        date: "ISO tarih",
        time: "ISO saat",
        duration: "ISO s\xfcre",
        ipv4: "IPv4 adresi",
        ipv6: "IPv6 adresi",
        cidrv4: "IPv4 aral\u0131\u011F\u0131",
        cidrv6: "IPv6 aral\u0131\u011F\u0131",
        base64: "base64 ile \u015Fifrelenmi\u015F metin",
        base64url: "base64url ile \u015Fifrelenmi\u015F metin",
        json_string: "JSON dizesi",
        e164: "E.164 say\u0131s\u0131",
        jwt: "JWT",
        template_literal: "\u015Eablon dizesi"
    };
    return (issue)=>{
        switch(issue.code){
            case "invalid_type":
                return `Ge\xe7ersiz de\u{11F}er: beklenen ${issue.expected}, al\u{131}nan ${$0acde46f117b7988$export$858d360cf6da2b65(issue.input)}`;
            case "invalid_value":
                if (issue.values.length === 1) return `Ge\xe7ersiz de\u{11F}er: beklenen ${$8f5391358ccbeba2$export$5859860f650378f4(issue.values[0])}`;
                return `Ge\xe7ersiz se\xe7enek: a\u{15F}a\u{11F}\u{131}dakilerden biri olmal\u{131}: ${$8f5391358ccbeba2$export$e79b744344f50f50(issue.values, "|")}`;
            case "too_big":
                {
                    const adj = issue.inclusive ? "<=" : "<";
                    const sizing = getSizing(issue.origin);
                    if (sizing) return `\xc7ok b\xfcy\xfck: beklenen ${issue.origin ?? "de\u011Fer"} ${adj}${issue.maximum.toString()} ${sizing.unit ?? "\xf6\u011Fe"}`;
                    return `\xc7ok b\xfcy\xfck: beklenen ${issue.origin ?? "de\u011Fer"} ${adj}${issue.maximum.toString()}`;
                }
            case "too_small":
                {
                    const adj = issue.inclusive ? ">=" : ">";
                    const sizing = getSizing(issue.origin);
                    if (sizing) return `\xc7ok k\xfc\xe7\xfck: beklenen ${issue.origin} ${adj}${issue.minimum.toString()} ${sizing.unit}`;
                    return `\xc7ok k\xfc\xe7\xfck: beklenen ${issue.origin} ${adj}${issue.minimum.toString()}`;
                }
            case "invalid_format":
                {
                    const _issue = issue;
                    if (_issue.format === "starts_with") return `Ge\xe7ersiz metin: "${_issue.prefix}" ile ba\u{15F}lamal\u{131}`;
                    if (_issue.format === "ends_with") return `Ge\xe7ersiz metin: "${_issue.suffix}" ile bitmeli`;
                    if (_issue.format === "includes") return `Ge\xe7ersiz metin: "${_issue.includes}" i\xe7ermeli`;
                    if (_issue.format === "regex") return `Ge\xe7ersiz metin: ${_issue.pattern} desenine uymal\u{131}`;
                    return `Ge\xe7ersiz ${Nouns[_issue.format] ?? issue.format}`;
                }
            case "not_multiple_of":
                return `Ge\xe7ersiz say\u{131}: ${issue.divisor} ile tam b\xf6l\xfcnebilmeli`;
            case "unrecognized_keys":
                return `Tan\u{131}nmayan anahtar${issue.keys.length > 1 ? "lar" : ""}: ${$8f5391358ccbeba2$export$e79b744344f50f50(issue.keys, ", ")}`;
            case "invalid_key":
                return `${issue.origin} i\xe7inde ge\xe7ersiz anahtar`;
            case "invalid_union":
                return "Ge\xe7ersiz de\u011Fer";
            case "invalid_element":
                return `${issue.origin} i\xe7inde ge\xe7ersiz de\u{11F}er`;
            default:
                return `Ge\xe7ersiz de\u{11F}er`;
        }
    };
};
function $0acde46f117b7988$export$2e2bcd8739ae039() {
    return {
        localeError: $0acde46f117b7988$var$error()
    };
}



const $f5d9ce840d3a3b61$var$error = ()=>{
    const Sizable = {
        string: {
            unit: "\u0441\u0438\u043C\u0432\u043E\u043B\u0456\u0432",
            verb: "\u043C\u0430\u0442\u0438\u043C\u0435"
        },
        file: {
            unit: "\u0431\u0430\u0439\u0442\u0456\u0432",
            verb: "\u043C\u0430\u0442\u0438\u043C\u0435"
        },
        array: {
            unit: "\u0435\u043B\u0435\u043C\u0435\u043D\u0442\u0456\u0432",
            verb: "\u043C\u0430\u0442\u0438\u043C\u0435"
        },
        set: {
            unit: "\u0435\u043B\u0435\u043C\u0435\u043D\u0442\u0456\u0432",
            verb: "\u043C\u0430\u0442\u0438\u043C\u0435"
        }
    };
    function getSizing(origin) {
        return Sizable[origin] ?? null;
    }
    const parsedType = (data)=>{
        const t = typeof data;
        switch(t){
            case "number":
                return Number.isNaN(data) ? "NaN" : "\u0447\u0438\u0441\u043B\u043E";
            case "object":
                if (Array.isArray(data)) return "\u043C\u0430\u0441\u0438\u0432";
                if (data === null) return "null";
                if (Object.getPrototypeOf(data) !== Object.prototype && data.constructor) return data.constructor.name;
        }
        return t;
    };
    const Nouns = {
        regex: "\u0432\u0445\u0456\u0434\u043D\u0456 \u0434\u0430\u043D\u0456",
        email: "\u0430\u0434\u0440\u0435\u0441\u0430 \u0435\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u043E\u0457 \u043F\u043E\u0448\u0442\u0438",
        url: "URL",
        emoji: "\u0435\u043C\u043E\u0434\u0437\u0456",
        uuid: "UUID",
        uuidv4: "UUIDv4",
        uuidv6: "UUIDv6",
        nanoid: "nanoid",
        guid: "GUID",
        cuid: "cuid",
        cuid2: "cuid2",
        ulid: "ULID",
        xid: "XID",
        ksuid: "KSUID",
        datetime: "\u0434\u0430\u0442\u0430 \u0442\u0430 \u0447\u0430\u0441 ISO",
        date: "\u0434\u0430\u0442\u0430 ISO",
        time: "\u0447\u0430\u0441 ISO",
        duration: "\u0442\u0440\u0438\u0432\u0430\u043B\u0456\u0441\u0442\u044C ISO",
        ipv4: "\u0430\u0434\u0440\u0435\u0441\u0430 IPv4",
        ipv6: "\u0430\u0434\u0440\u0435\u0441\u0430 IPv6",
        cidrv4: "\u0434\u0456\u0430\u043F\u0430\u0437\u043E\u043D IPv4",
        cidrv6: "\u0434\u0456\u0430\u043F\u0430\u0437\u043E\u043D IPv6",
        base64: "\u0440\u044F\u0434\u043E\u043A \u0443 \u043A\u043E\u0434\u0443\u0432\u0430\u043D\u043D\u0456 base64",
        base64url: "\u0440\u044F\u0434\u043E\u043A \u0443 \u043A\u043E\u0434\u0443\u0432\u0430\u043D\u043D\u0456 base64url",
        json_string: "\u0440\u044F\u0434\u043E\u043A JSON",
        e164: "\u043D\u043E\u043C\u0435\u0440 E.164",
        jwt: "JWT",
        template_literal: "\u0432\u0445\u0456\u0434\u043D\u0456 \u0434\u0430\u043D\u0456"
    };
    return (issue)=>{
        switch(issue.code){
            case "invalid_type":
                return `\u{41D}\u{435}\u{43F}\u{440}\u{430}\u{432}\u{438}\u{43B}\u{44C}\u{43D}\u{456} \u{432}\u{445}\u{456}\u{434}\u{43D}\u{456} \u{434}\u{430}\u{43D}\u{456}: \u{43E}\u{447}\u{456}\u{43A}\u{443}\u{454}\u{442}\u{44C}\u{441}\u{44F} ${issue.expected}, \u{43E}\u{442}\u{440}\u{438}\u{43C}\u{430}\u{43D}\u{43E} ${parsedType(issue.input)}`;
            // return `Неправильні вхідні дані: очікується ${issue.expected}, отримано ${util.getParsedType(issue.input)}`;
            case "invalid_value":
                if (issue.values.length === 1) return `\u{41D}\u{435}\u{43F}\u{440}\u{430}\u{432}\u{438}\u{43B}\u{44C}\u{43D}\u{456} \u{432}\u{445}\u{456}\u{434}\u{43D}\u{456} \u{434}\u{430}\u{43D}\u{456}: \u{43E}\u{447}\u{456}\u{43A}\u{443}\u{454}\u{442}\u{44C}\u{441}\u{44F} ${$8f5391358ccbeba2$export$5859860f650378f4(issue.values[0])}`;
                return `\u{41D}\u{435}\u{43F}\u{440}\u{430}\u{432}\u{438}\u{43B}\u{44C}\u{43D}\u{430} \u{43E}\u{43F}\u{446}\u{456}\u{44F}: \u{43E}\u{447}\u{456}\u{43A}\u{443}\u{454}\u{442}\u{44C}\u{441}\u{44F} \u{43E}\u{434}\u{43D}\u{435} \u{437} ${$8f5391358ccbeba2$export$e79b744344f50f50(issue.values, "|")}`;
            case "too_big":
                {
                    const adj = issue.inclusive ? "<=" : "<";
                    const sizing = getSizing(issue.origin);
                    if (sizing) return `\u{417}\u{430}\u{43D}\u{430}\u{434}\u{442}\u{43E} \u{432}\u{435}\u{43B}\u{438}\u{43A}\u{435}: \u{43E}\u{447}\u{456}\u{43A}\u{443}\u{454}\u{442}\u{44C}\u{441}\u{44F}, \u{449}\u{43E} ${issue.origin ?? "\u0437\u043D\u0430\u0447\u0435\u043D\u043D\u044F"} ${sizing.verb} ${adj}${issue.maximum.toString()} ${sizing.unit ?? "\u0435\u043B\u0435\u043C\u0435\u043D\u0442\u0456\u0432"}`;
                    return `\u{417}\u{430}\u{43D}\u{430}\u{434}\u{442}\u{43E} \u{432}\u{435}\u{43B}\u{438}\u{43A}\u{435}: \u{43E}\u{447}\u{456}\u{43A}\u{443}\u{454}\u{442}\u{44C}\u{441}\u{44F}, \u{449}\u{43E} ${issue.origin ?? "\u0437\u043D\u0430\u0447\u0435\u043D\u043D\u044F"} \u{431}\u{443}\u{434}\u{435} ${adj}${issue.maximum.toString()}`;
                }
            case "too_small":
                {
                    const adj = issue.inclusive ? ">=" : ">";
                    const sizing = getSizing(issue.origin);
                    if (sizing) return `\u{417}\u{430}\u{43D}\u{430}\u{434}\u{442}\u{43E} \u{43C}\u{430}\u{43B}\u{435}: \u{43E}\u{447}\u{456}\u{43A}\u{443}\u{454}\u{442}\u{44C}\u{441}\u{44F}, \u{449}\u{43E} ${issue.origin} ${sizing.verb} ${adj}${issue.minimum.toString()} ${sizing.unit}`;
                    return `\u{417}\u{430}\u{43D}\u{430}\u{434}\u{442}\u{43E} \u{43C}\u{430}\u{43B}\u{435}: \u{43E}\u{447}\u{456}\u{43A}\u{443}\u{454}\u{442}\u{44C}\u{441}\u{44F}, \u{449}\u{43E} ${issue.origin} \u{431}\u{443}\u{434}\u{435} ${adj}${issue.minimum.toString()}`;
                }
            case "invalid_format":
                {
                    const _issue = issue;
                    if (_issue.format === "starts_with") return `\u{41D}\u{435}\u{43F}\u{440}\u{430}\u{432}\u{438}\u{43B}\u{44C}\u{43D}\u{438}\u{439} \u{440}\u{44F}\u{434}\u{43E}\u{43A}: \u{43F}\u{43E}\u{432}\u{438}\u{43D}\u{435}\u{43D} \u{43F}\u{43E}\u{447}\u{438}\u{43D}\u{430}\u{442}\u{438}\u{441}\u{44F} \u{437} "${_issue.prefix}"`;
                    if (_issue.format === "ends_with") return `\u{41D}\u{435}\u{43F}\u{440}\u{430}\u{432}\u{438}\u{43B}\u{44C}\u{43D}\u{438}\u{439} \u{440}\u{44F}\u{434}\u{43E}\u{43A}: \u{43F}\u{43E}\u{432}\u{438}\u{43D}\u{435}\u{43D} \u{437}\u{430}\u{43A}\u{456}\u{43D}\u{447}\u{443}\u{432}\u{430}\u{442}\u{438}\u{441}\u{44F} \u{43D}\u{430} "${_issue.suffix}"`;
                    if (_issue.format === "includes") return `\u{41D}\u{435}\u{43F}\u{440}\u{430}\u{432}\u{438}\u{43B}\u{44C}\u{43D}\u{438}\u{439} \u{440}\u{44F}\u{434}\u{43E}\u{43A}: \u{43F}\u{43E}\u{432}\u{438}\u{43D}\u{435}\u{43D} \u{43C}\u{456}\u{441}\u{442}\u{438}\u{442}\u{438} "${_issue.includes}"`;
                    if (_issue.format === "regex") return `\u{41D}\u{435}\u{43F}\u{440}\u{430}\u{432}\u{438}\u{43B}\u{44C}\u{43D}\u{438}\u{439} \u{440}\u{44F}\u{434}\u{43E}\u{43A}: \u{43F}\u{43E}\u{432}\u{438}\u{43D}\u{435}\u{43D} \u{432}\u{456}\u{434}\u{43F}\u{43E}\u{432}\u{456}\u{434}\u{430}\u{442}\u{438} \u{448}\u{430}\u{431}\u{43B}\u{43E}\u{43D}\u{443} ${_issue.pattern}`;
                    return `\u{41D}\u{435}\u{43F}\u{440}\u{430}\u{432}\u{438}\u{43B}\u{44C}\u{43D}\u{438}\u{439} ${Nouns[_issue.format] ?? issue.format}`;
                }
            case "not_multiple_of":
                return `\u{41D}\u{435}\u{43F}\u{440}\u{430}\u{432}\u{438}\u{43B}\u{44C}\u{43D}\u{435} \u{447}\u{438}\u{441}\u{43B}\u{43E}: \u{43F}\u{43E}\u{432}\u{438}\u{43D}\u{43D}\u{43E} \u{431}\u{443}\u{442}\u{438} \u{43A}\u{440}\u{430}\u{442}\u{43D}\u{438}\u{43C} ${issue.divisor}`;
            case "unrecognized_keys":
                return `\u{41D}\u{435}\u{440}\u{43E}\u{437}\u{43F}\u{456}\u{437}\u{43D}\u{430}\u{43D}\u{438}\u{439} \u{43A}\u{43B}\u{44E}\u{447}${issue.keys.length > 1 ? "\u0456" : ""}: ${$8f5391358ccbeba2$export$e79b744344f50f50(issue.keys, ", ")}`;
            case "invalid_key":
                return `\u{41D}\u{435}\u{43F}\u{440}\u{430}\u{432}\u{438}\u{43B}\u{44C}\u{43D}\u{438}\u{439} \u{43A}\u{43B}\u{44E}\u{447} \u{443} ${issue.origin}`;
            case "invalid_union":
                return "\u041D\u0435\u043F\u0440\u0430\u0432\u0438\u043B\u044C\u043D\u0456 \u0432\u0445\u0456\u0434\u043D\u0456 \u0434\u0430\u043D\u0456";
            case "invalid_element":
                return `\u{41D}\u{435}\u{43F}\u{440}\u{430}\u{432}\u{438}\u{43B}\u{44C}\u{43D}\u{435} \u{437}\u{43D}\u{430}\u{447}\u{435}\u{43D}\u{43D}\u{44F} \u{443} ${issue.origin}`;
            default:
                return `\u{41D}\u{435}\u{43F}\u{440}\u{430}\u{432}\u{438}\u{43B}\u{44C}\u{43D}\u{456} \u{432}\u{445}\u{456}\u{434}\u{43D}\u{456} \u{434}\u{430}\u{43D}\u{456}`;
        }
    };
};
function $f5d9ce840d3a3b61$export$2e2bcd8739ae039() {
    return {
        localeError: $f5d9ce840d3a3b61$var$error()
    };
}


function $b44862c4873e864e$export$2e2bcd8739ae039() {
    return (0, $f5d9ce840d3a3b61$export$2e2bcd8739ae039)();
}




const $d1cd6a523e86dd46$var$error = ()=>{
    const Sizable = {
        string: {
            unit: "\u062D\u0631\u0648\u0641",
            verb: "\u06C1\u0648\u0646\u0627"
        },
        file: {
            unit: "\u0628\u0627\u0626\u0679\u0633",
            verb: "\u06C1\u0648\u0646\u0627"
        },
        array: {
            unit: "\u0622\u0626\u0679\u0645\u0632",
            verb: "\u06C1\u0648\u0646\u0627"
        },
        set: {
            unit: "\u0622\u0626\u0679\u0645\u0632",
            verb: "\u06C1\u0648\u0646\u0627"
        }
    };
    function getSizing(origin) {
        return Sizable[origin] ?? null;
    }
    const parsedType = (data)=>{
        const t = typeof data;
        switch(t){
            case "number":
                return Number.isNaN(data) ? "NaN" : "\u0646\u0645\u0628\u0631";
            case "object":
                if (Array.isArray(data)) return "\u0622\u0631\u06D2";
                if (data === null) return "\u0646\u0644";
                if (Object.getPrototypeOf(data) !== Object.prototype && data.constructor) return data.constructor.name;
        }
        return t;
    };
    const Nouns = {
        regex: "\u0627\u0646 \u067E\u0679",
        email: "\u0627\u06CC \u0645\u06CC\u0644 \u0627\u06CC\u0688\u0631\u06CC\u0633",
        url: "\u06CC\u0648 \u0622\u0631 \u0627\u06CC\u0644",
        emoji: "\u0627\u06CC\u0645\u0648\u062C\u06CC",
        uuid: "\u06CC\u0648 \u06CC\u0648 \u0622\u0626\u06CC \u0688\u06CC",
        uuidv4: "\u06CC\u0648 \u06CC\u0648 \u0622\u0626\u06CC \u0688\u06CC \u0648\u06CC 4",
        uuidv6: "\u06CC\u0648 \u06CC\u0648 \u0622\u0626\u06CC \u0688\u06CC \u0648\u06CC 6",
        nanoid: "\u0646\u06CC\u0646\u0648 \u0622\u0626\u06CC \u0688\u06CC",
        guid: "\u062C\u06CC \u06CC\u0648 \u0622\u0626\u06CC \u0688\u06CC",
        cuid: "\u0633\u06CC \u06CC\u0648 \u0622\u0626\u06CC \u0688\u06CC",
        cuid2: "\u0633\u06CC \u06CC\u0648 \u0622\u0626\u06CC \u0688\u06CC 2",
        ulid: "\u06CC\u0648 \u0627\u06CC\u0644 \u0622\u0626\u06CC \u0688\u06CC",
        xid: "\u0627\u06CC\u06A9\u0633 \u0622\u0626\u06CC \u0688\u06CC",
        ksuid: "\u06A9\u06D2 \u0627\u06CC\u0633 \u06CC\u0648 \u0622\u0626\u06CC \u0688\u06CC",
        datetime: "\u0622\u0626\u06CC \u0627\u06CC\u0633 \u0627\u0648 \u0688\u06CC\u0679 \u0679\u0627\u0626\u0645",
        date: "\u0622\u0626\u06CC \u0627\u06CC\u0633 \u0627\u0648 \u062A\u0627\u0631\u06CC\u062E",
        time: "\u0622\u0626\u06CC \u0627\u06CC\u0633 \u0627\u0648 \u0648\u0642\u062A",
        duration: "\u0622\u0626\u06CC \u0627\u06CC\u0633 \u0627\u0648 \u0645\u062F\u062A",
        ipv4: "\u0622\u0626\u06CC \u067E\u06CC \u0648\u06CC 4 \u0627\u06CC\u0688\u0631\u06CC\u0633",
        ipv6: "\u0622\u0626\u06CC \u067E\u06CC \u0648\u06CC 6 \u0627\u06CC\u0688\u0631\u06CC\u0633",
        cidrv4: "\u0622\u0626\u06CC \u067E\u06CC \u0648\u06CC 4 \u0631\u06CC\u0646\u062C",
        cidrv6: "\u0622\u0626\u06CC \u067E\u06CC \u0648\u06CC 6 \u0631\u06CC\u0646\u062C",
        base64: "\u0628\u06CC\u0633 64 \u0627\u0646 \u06A9\u0648\u0688\u0688 \u0633\u0679\u0631\u0646\u06AF",
        base64url: "\u0628\u06CC\u0633 64 \u06CC\u0648 \u0622\u0631 \u0627\u06CC\u0644 \u0627\u0646 \u06A9\u0648\u0688\u0688 \u0633\u0679\u0631\u0646\u06AF",
        json_string: "\u062C\u06D2 \u0627\u06CC\u0633 \u0627\u0648 \u0627\u06CC\u0646 \u0633\u0679\u0631\u0646\u06AF",
        e164: "\u0627\u06CC 164 \u0646\u0645\u0628\u0631",
        jwt: "\u062C\u06D2 \u0688\u0628\u0644\u06CC\u0648 \u0679\u06CC",
        template_literal: "\u0627\u0646 \u067E\u0679"
    };
    return (issue)=>{
        switch(issue.code){
            case "invalid_type":
                return `\u{63A}\u{644}\u{637} \u{627}\u{646} \u{67E}\u{679}: ${issue.expected} \u{645}\u{62A}\u{648}\u{642}\u{639} \u{62A}\u{6BE}\u{627}\u{60C} ${parsedType(issue.input)} \u{645}\u{648}\u{635}\u{648}\u{644} \u{6C1}\u{648}\u{627}`;
            case "invalid_value":
                if (issue.values.length === 1) return `\u{63A}\u{644}\u{637} \u{627}\u{646} \u{67E}\u{679}: ${$8f5391358ccbeba2$export$5859860f650378f4(issue.values[0])} \u{645}\u{62A}\u{648}\u{642}\u{639} \u{62A}\u{6BE}\u{627}`;
                return `\u{63A}\u{644}\u{637} \u{622}\u{67E}\u{634}\u{646}: ${$8f5391358ccbeba2$export$e79b744344f50f50(issue.values, "|")} \u{645}\u{6CC}\u{6BA} \u{633}\u{6D2} \u{627}\u{6CC}\u{6A9} \u{645}\u{62A}\u{648}\u{642}\u{639} \u{62A}\u{6BE}\u{627}`;
            case "too_big":
                {
                    const adj = issue.inclusive ? "<=" : "<";
                    const sizing = getSizing(issue.origin);
                    if (sizing) return `\u{628}\u{6C1}\u{62A} \u{628}\u{691}\u{627}: ${issue.origin ?? "\u0648\u06CC\u0644\u06CC\u0648"} \u{6A9}\u{6D2} ${adj}${issue.maximum.toString()} ${sizing.unit ?? "\u0639\u0646\u0627\u0635\u0631"} \u{6C1}\u{648}\u{646}\u{6D2} \u{645}\u{62A}\u{648}\u{642}\u{639} \u{62A}\u{6BE}\u{6D2}`;
                    return `\u{628}\u{6C1}\u{62A} \u{628}\u{691}\u{627}: ${issue.origin ?? "\u0648\u06CC\u0644\u06CC\u0648"} \u{6A9}\u{627} ${adj}${issue.maximum.toString()} \u{6C1}\u{648}\u{646}\u{627} \u{645}\u{62A}\u{648}\u{642}\u{639} \u{62A}\u{6BE}\u{627}`;
                }
            case "too_small":
                {
                    const adj = issue.inclusive ? ">=" : ">";
                    const sizing = getSizing(issue.origin);
                    if (sizing) return `\u{628}\u{6C1}\u{62A} \u{686}\u{6BE}\u{648}\u{679}\u{627}: ${issue.origin} \u{6A9}\u{6D2} ${adj}${issue.minimum.toString()} ${sizing.unit} \u{6C1}\u{648}\u{646}\u{6D2} \u{645}\u{62A}\u{648}\u{642}\u{639} \u{62A}\u{6BE}\u{6D2}`;
                    return `\u{628}\u{6C1}\u{62A} \u{686}\u{6BE}\u{648}\u{679}\u{627}: ${issue.origin} \u{6A9}\u{627} ${adj}${issue.minimum.toString()} \u{6C1}\u{648}\u{646}\u{627} \u{645}\u{62A}\u{648}\u{642}\u{639} \u{62A}\u{6BE}\u{627}`;
                }
            case "invalid_format":
                {
                    const _issue = issue;
                    if (_issue.format === "starts_with") return `\u{63A}\u{644}\u{637} \u{633}\u{679}\u{631}\u{646}\u{6AF}: "${_issue.prefix}" \u{633}\u{6D2} \u{634}\u{631}\u{648}\u{639} \u{6C1}\u{648}\u{646}\u{627} \u{686}\u{627}\u{6C1}\u{6CC}\u{6D2}`;
                    if (_issue.format === "ends_with") return `\u{63A}\u{644}\u{637} \u{633}\u{679}\u{631}\u{646}\u{6AF}: "${_issue.suffix}" \u{67E}\u{631} \u{62E}\u{62A}\u{645} \u{6C1}\u{648}\u{646}\u{627} \u{686}\u{627}\u{6C1}\u{6CC}\u{6D2}`;
                    if (_issue.format === "includes") return `\u{63A}\u{644}\u{637} \u{633}\u{679}\u{631}\u{646}\u{6AF}: "${_issue.includes}" \u{634}\u{627}\u{645}\u{644} \u{6C1}\u{648}\u{646}\u{627} \u{686}\u{627}\u{6C1}\u{6CC}\u{6D2}`;
                    if (_issue.format === "regex") return `\u{63A}\u{644}\u{637} \u{633}\u{679}\u{631}\u{646}\u{6AF}: \u{67E}\u{6CC}\u{679}\u{631}\u{646} ${_issue.pattern} \u{633}\u{6D2} \u{645}\u{6CC}\u{686} \u{6C1}\u{648}\u{646}\u{627} \u{686}\u{627}\u{6C1}\u{6CC}\u{6D2}`;
                    return `\u{63A}\u{644}\u{637} ${Nouns[_issue.format] ?? issue.format}`;
                }
            case "not_multiple_of":
                return `\u{63A}\u{644}\u{637} \u{646}\u{645}\u{628}\u{631}: ${issue.divisor} \u{6A9}\u{627} \u{645}\u{636}\u{627}\u{639}\u{641} \u{6C1}\u{648}\u{646}\u{627} \u{686}\u{627}\u{6C1}\u{6CC}\u{6D2}`;
            case "unrecognized_keys":
                return `\u{63A}\u{6CC}\u{631} \u{62A}\u{633}\u{644}\u{6CC}\u{645} \u{634}\u{62F}\u{6C1} \u{6A9}\u{6CC}${issue.keys.length > 1 ? "\u0632" : ""}: ${$8f5391358ccbeba2$export$e79b744344f50f50(issue.keys, "\u060C ")}`;
            case "invalid_key":
                return `${issue.origin} \u{645}\u{6CC}\u{6BA} \u{63A}\u{644}\u{637} \u{6A9}\u{6CC}`;
            case "invalid_union":
                return "\u063A\u0644\u0637 \u0627\u0646 \u067E\u0679";
            case "invalid_element":
                return `${issue.origin} \u{645}\u{6CC}\u{6BA} \u{63A}\u{644}\u{637} \u{648}\u{6CC}\u{644}\u{6CC}\u{648}`;
            default:
                return `\u{63A}\u{644}\u{637} \u{627}\u{646} \u{67E}\u{679}`;
        }
    };
};
function $d1cd6a523e86dd46$export$2e2bcd8739ae039() {
    return {
        localeError: $d1cd6a523e86dd46$var$error()
    };
}



const $5613bdf39979ed24$var$error = ()=>{
    const Sizable = {
        string: {
            unit: "k\xfd t\u1EF1",
            verb: "c\xf3"
        },
        file: {
            unit: "byte",
            verb: "c\xf3"
        },
        array: {
            unit: "ph\u1EA7n t\u1EED",
            verb: "c\xf3"
        },
        set: {
            unit: "ph\u1EA7n t\u1EED",
            verb: "c\xf3"
        }
    };
    function getSizing(origin) {
        return Sizable[origin] ?? null;
    }
    const parsedType = (data)=>{
        const t = typeof data;
        switch(t){
            case "number":
                return Number.isNaN(data) ? "NaN" : "s\u1ED1";
            case "object":
                if (Array.isArray(data)) return "m\u1EA3ng";
                if (data === null) return "null";
                if (Object.getPrototypeOf(data) !== Object.prototype && data.constructor) return data.constructor.name;
        }
        return t;
    };
    const Nouns = {
        regex: "\u0111\u1EA7u v\xe0o",
        email: "\u0111\u1ECBa ch\u1EC9 email",
        url: "URL",
        emoji: "emoji",
        uuid: "UUID",
        uuidv4: "UUIDv4",
        uuidv6: "UUIDv6",
        nanoid: "nanoid",
        guid: "GUID",
        cuid: "cuid",
        cuid2: "cuid2",
        ulid: "ULID",
        xid: "XID",
        ksuid: "KSUID",
        datetime: "ng\xe0y gi\u1EDD ISO",
        date: "ng\xe0y ISO",
        time: "gi\u1EDD ISO",
        duration: "kho\u1EA3ng th\u1EDDi gian ISO",
        ipv4: "\u0111\u1ECBa ch\u1EC9 IPv4",
        ipv6: "\u0111\u1ECBa ch\u1EC9 IPv6",
        cidrv4: "d\u1EA3i IPv4",
        cidrv6: "d\u1EA3i IPv6",
        base64: "chu\u1ED7i m\xe3 h\xf3a base64",
        base64url: "chu\u1ED7i m\xe3 h\xf3a base64url",
        json_string: "chu\u1ED7i JSON",
        e164: "s\u1ED1 E.164",
        jwt: "JWT",
        template_literal: "\u0111\u1EA7u v\xe0o"
    };
    return (issue)=>{
        switch(issue.code){
            case "invalid_type":
                return `\u{110}\u{1EA7}u v\xe0o kh\xf4ng h\u{1EE3}p l\u{1EC7}: mong \u{111}\u{1EE3}i ${issue.expected}, nh\u{1EAD}n \u{111}\u{1B0}\u{1EE3}c ${parsedType(issue.input)}`;
            case "invalid_value":
                if (issue.values.length === 1) return `\u{110}\u{1EA7}u v\xe0o kh\xf4ng h\u{1EE3}p l\u{1EC7}: mong \u{111}\u{1EE3}i ${$8f5391358ccbeba2$export$5859860f650378f4(issue.values[0])}`;
                return `T\xf9y ch\u{1ECD}n kh\xf4ng h\u{1EE3}p l\u{1EC7}: mong \u{111}\u{1EE3}i m\u{1ED9}t trong c\xe1c gi\xe1 tr\u{1ECB} ${$8f5391358ccbeba2$export$e79b744344f50f50(issue.values, "|")}`;
            case "too_big":
                {
                    const adj = issue.inclusive ? "<=" : "<";
                    const sizing = getSizing(issue.origin);
                    if (sizing) return `Qu\xe1 l\u{1EDB}n: mong \u{111}\u{1EE3}i ${issue.origin ?? "gi\xe1 tr\u1ECB"} ${sizing.verb} ${adj}${issue.maximum.toString()} ${sizing.unit ?? "ph\u1EA7n t\u1EED"}`;
                    return `Qu\xe1 l\u{1EDB}n: mong \u{111}\u{1EE3}i ${issue.origin ?? "gi\xe1 tr\u1ECB"} ${adj}${issue.maximum.toString()}`;
                }
            case "too_small":
                {
                    const adj = issue.inclusive ? ">=" : ">";
                    const sizing = getSizing(issue.origin);
                    if (sizing) return `Qu\xe1 nh\u{1ECF}: mong \u{111}\u{1EE3}i ${issue.origin} ${sizing.verb} ${adj}${issue.minimum.toString()} ${sizing.unit}`;
                    return `Qu\xe1 nh\u{1ECF}: mong \u{111}\u{1EE3}i ${issue.origin} ${adj}${issue.minimum.toString()}`;
                }
            case "invalid_format":
                {
                    const _issue = issue;
                    if (_issue.format === "starts_with") return `Chu\u{1ED7}i kh\xf4ng h\u{1EE3}p l\u{1EC7}: ph\u{1EA3}i b\u{1EAF}t \u{111}\u{1EA7}u b\u{1EB1}ng "${_issue.prefix}"`;
                    if (_issue.format === "ends_with") return `Chu\u{1ED7}i kh\xf4ng h\u{1EE3}p l\u{1EC7}: ph\u{1EA3}i k\u{1EBF}t th\xfac b\u{1EB1}ng "${_issue.suffix}"`;
                    if (_issue.format === "includes") return `Chu\u{1ED7}i kh\xf4ng h\u{1EE3}p l\u{1EC7}: ph\u{1EA3}i bao g\u{1ED3}m "${_issue.includes}"`;
                    if (_issue.format === "regex") return `Chu\u{1ED7}i kh\xf4ng h\u{1EE3}p l\u{1EC7}: ph\u{1EA3}i kh\u{1EDB}p v\u{1EDB}i m\u{1EAB}u ${_issue.pattern}`;
                    return `${Nouns[_issue.format] ?? issue.format} kh\xf4ng h\u{1EE3}p l\u{1EC7}`;
                }
            case "not_multiple_of":
                return `S\u{1ED1} kh\xf4ng h\u{1EE3}p l\u{1EC7}: ph\u{1EA3}i l\xe0 b\u{1ED9}i s\u{1ED1} c\u{1EE7}a ${issue.divisor}`;
            case "unrecognized_keys":
                return `Kh\xf3a kh\xf4ng \u{111}\u{1B0}\u{1EE3}c nh\u{1EAD}n d\u{1EA1}ng: ${$8f5391358ccbeba2$export$e79b744344f50f50(issue.keys, ", ")}`;
            case "invalid_key":
                return `Kh\xf3a kh\xf4ng h\u{1EE3}p l\u{1EC7} trong ${issue.origin}`;
            case "invalid_union":
                return "\u0110\u1EA7u v\xe0o kh\xf4ng h\u1EE3p l\u1EC7";
            case "invalid_element":
                return `Gi\xe1 tr\u{1ECB} kh\xf4ng h\u{1EE3}p l\u{1EC7} trong ${issue.origin}`;
            default:
                return `\u{110}\u{1EA7}u v\xe0o kh\xf4ng h\u{1EE3}p l\u{1EC7}`;
        }
    };
};
function $5613bdf39979ed24$export$2e2bcd8739ae039() {
    return {
        localeError: $5613bdf39979ed24$var$error()
    };
}



const $56a1b5486632de00$var$error = ()=>{
    const Sizable = {
        string: {
            unit: "\u5B57\u7B26",
            verb: "\u5305\u542B"
        },
        file: {
            unit: "\u5B57\u8282",
            verb: "\u5305\u542B"
        },
        array: {
            unit: "\u9879",
            verb: "\u5305\u542B"
        },
        set: {
            unit: "\u9879",
            verb: "\u5305\u542B"
        }
    };
    function getSizing(origin) {
        return Sizable[origin] ?? null;
    }
    const parsedType = (data)=>{
        const t = typeof data;
        switch(t){
            case "number":
                return Number.isNaN(data) ? "\u975E\u6570\u5B57(NaN)" : "\u6570\u5B57";
            case "object":
                if (Array.isArray(data)) return "\u6570\u7EC4";
                if (data === null) return "\u7A7A\u503C(null)";
                if (Object.getPrototypeOf(data) !== Object.prototype && data.constructor) return data.constructor.name;
        }
        return t;
    };
    const Nouns = {
        regex: "\u8F93\u5165",
        email: "\u7535\u5B50\u90AE\u4EF6",
        url: "URL",
        emoji: "\u8868\u60C5\u7B26\u53F7",
        uuid: "UUID",
        uuidv4: "UUIDv4",
        uuidv6: "UUIDv6",
        nanoid: "nanoid",
        guid: "GUID",
        cuid: "cuid",
        cuid2: "cuid2",
        ulid: "ULID",
        xid: "XID",
        ksuid: "KSUID",
        datetime: "ISO\u65E5\u671F\u65F6\u95F4",
        date: "ISO\u65E5\u671F",
        time: "ISO\u65F6\u95F4",
        duration: "ISO\u65F6\u957F",
        ipv4: "IPv4\u5730\u5740",
        ipv6: "IPv6\u5730\u5740",
        cidrv4: "IPv4\u7F51\u6BB5",
        cidrv6: "IPv6\u7F51\u6BB5",
        base64: "base64\u7F16\u7801\u5B57\u7B26\u4E32",
        base64url: "base64url\u7F16\u7801\u5B57\u7B26\u4E32",
        json_string: "JSON\u5B57\u7B26\u4E32",
        e164: "E.164\u53F7\u7801",
        jwt: "JWT",
        template_literal: "\u8F93\u5165"
    };
    return (issue)=>{
        switch(issue.code){
            case "invalid_type":
                return `\u{65E0}\u{6548}\u{8F93}\u{5165}\u{FF1A}\u{671F}\u{671B} ${issue.expected}\u{FF0C}\u{5B9E}\u{9645}\u{63A5}\u{6536} ${parsedType(issue.input)}`;
            case "invalid_value":
                if (issue.values.length === 1) return `\u{65E0}\u{6548}\u{8F93}\u{5165}\u{FF1A}\u{671F}\u{671B} ${$8f5391358ccbeba2$export$5859860f650378f4(issue.values[0])}`;
                return `\u{65E0}\u{6548}\u{9009}\u{9879}\u{FF1A}\u{671F}\u{671B}\u{4EE5}\u{4E0B}\u{4E4B}\u{4E00} ${$8f5391358ccbeba2$export$e79b744344f50f50(issue.values, "|")}`;
            case "too_big":
                {
                    const adj = issue.inclusive ? "<=" : "<";
                    const sizing = getSizing(issue.origin);
                    if (sizing) return `\u{6570}\u{503C}\u{8FC7}\u{5927}\u{FF1A}\u{671F}\u{671B} ${issue.origin ?? "\u503C"} ${adj}${issue.maximum.toString()} ${sizing.unit ?? "\u4E2A\u5143\u7D20"}`;
                    return `\u{6570}\u{503C}\u{8FC7}\u{5927}\u{FF1A}\u{671F}\u{671B} ${issue.origin ?? "\u503C"} ${adj}${issue.maximum.toString()}`;
                }
            case "too_small":
                {
                    const adj = issue.inclusive ? ">=" : ">";
                    const sizing = getSizing(issue.origin);
                    if (sizing) return `\u{6570}\u{503C}\u{8FC7}\u{5C0F}\u{FF1A}\u{671F}\u{671B} ${issue.origin} ${adj}${issue.minimum.toString()} ${sizing.unit}`;
                    return `\u{6570}\u{503C}\u{8FC7}\u{5C0F}\u{FF1A}\u{671F}\u{671B} ${issue.origin} ${adj}${issue.minimum.toString()}`;
                }
            case "invalid_format":
                {
                    const _issue = issue;
                    if (_issue.format === "starts_with") return `\u{65E0}\u{6548}\u{5B57}\u{7B26}\u{4E32}\u{FF1A}\u{5FC5}\u{987B}\u{4EE5} "${_issue.prefix}" \u{5F00}\u{5934}`;
                    if (_issue.format === "ends_with") return `\u{65E0}\u{6548}\u{5B57}\u{7B26}\u{4E32}\u{FF1A}\u{5FC5}\u{987B}\u{4EE5} "${_issue.suffix}" \u{7ED3}\u{5C3E}`;
                    if (_issue.format === "includes") return `\u{65E0}\u{6548}\u{5B57}\u{7B26}\u{4E32}\u{FF1A}\u{5FC5}\u{987B}\u{5305}\u{542B} "${_issue.includes}"`;
                    if (_issue.format === "regex") return `\u{65E0}\u{6548}\u{5B57}\u{7B26}\u{4E32}\u{FF1A}\u{5FC5}\u{987B}\u{6EE1}\u{8DB3}\u{6B63}\u{5219}\u{8868}\u{8FBE}\u{5F0F} ${_issue.pattern}`;
                    return `\u{65E0}\u{6548}${Nouns[_issue.format] ?? issue.format}`;
                }
            case "not_multiple_of":
                return `\u{65E0}\u{6548}\u{6570}\u{5B57}\u{FF1A}\u{5FC5}\u{987B}\u{662F} ${issue.divisor} \u{7684}\u{500D}\u{6570}`;
            case "unrecognized_keys":
                return `\u{51FA}\u{73B0}\u{672A}\u{77E5}\u{7684}\u{952E}(key): ${$8f5391358ccbeba2$export$e79b744344f50f50(issue.keys, ", ")}`;
            case "invalid_key":
                return `${issue.origin} \u{4E2D}\u{7684}\u{952E}(key)\u{65E0}\u{6548}`;
            case "invalid_union":
                return "\u65E0\u6548\u8F93\u5165";
            case "invalid_element":
                return `${issue.origin} \u{4E2D}\u{5305}\u{542B}\u{65E0}\u{6548}\u{503C}(value)`;
            default:
                return `\u{65E0}\u{6548}\u{8F93}\u{5165}`;
        }
    };
};
function $56a1b5486632de00$export$2e2bcd8739ae039() {
    return {
        localeError: $56a1b5486632de00$var$error()
    };
}



const $205dd299c3aa23b7$var$error = ()=>{
    const Sizable = {
        string: {
            unit: "\u5B57\u5143",
            verb: "\u64C1\u6709"
        },
        file: {
            unit: "\u4F4D\u5143\u7D44",
            verb: "\u64C1\u6709"
        },
        array: {
            unit: "\u9805\u76EE",
            verb: "\u64C1\u6709"
        },
        set: {
            unit: "\u9805\u76EE",
            verb: "\u64C1\u6709"
        }
    };
    function getSizing(origin) {
        return Sizable[origin] ?? null;
    }
    const parsedType = (data)=>{
        const t = typeof data;
        switch(t){
            case "number":
                return Number.isNaN(data) ? "NaN" : "number";
            case "object":
                if (Array.isArray(data)) return "array";
                if (data === null) return "null";
                if (Object.getPrototypeOf(data) !== Object.prototype && data.constructor) return data.constructor.name;
        }
        return t;
    };
    const Nouns = {
        regex: "\u8F38\u5165",
        email: "\u90F5\u4EF6\u5730\u5740",
        url: "URL",
        emoji: "emoji",
        uuid: "UUID",
        uuidv4: "UUIDv4",
        uuidv6: "UUIDv6",
        nanoid: "nanoid",
        guid: "GUID",
        cuid: "cuid",
        cuid2: "cuid2",
        ulid: "ULID",
        xid: "XID",
        ksuid: "KSUID",
        datetime: "ISO \u65E5\u671F\u6642\u9593",
        date: "ISO \u65E5\u671F",
        time: "ISO \u6642\u9593",
        duration: "ISO \u671F\u9593",
        ipv4: "IPv4 \u4F4D\u5740",
        ipv6: "IPv6 \u4F4D\u5740",
        cidrv4: "IPv4 \u7BC4\u570D",
        cidrv6: "IPv6 \u7BC4\u570D",
        base64: "base64 \u7DE8\u78BC\u5B57\u4E32",
        base64url: "base64url \u7DE8\u78BC\u5B57\u4E32",
        json_string: "JSON \u5B57\u4E32",
        e164: "E.164 \u6578\u503C",
        jwt: "JWT",
        template_literal: "\u8F38\u5165"
    };
    return (issue)=>{
        switch(issue.code){
            case "invalid_type":
                return `\u{7121}\u{6548}\u{7684}\u{8F38}\u{5165}\u{503C}\u{FF1A}\u{9810}\u{671F}\u{70BA} ${issue.expected}\u{FF0C}\u{4F46}\u{6536}\u{5230} ${parsedType(issue.input)}`;
            case "invalid_value":
                if (issue.values.length === 1) return `\u{7121}\u{6548}\u{7684}\u{8F38}\u{5165}\u{503C}\u{FF1A}\u{9810}\u{671F}\u{70BA} ${$8f5391358ccbeba2$export$5859860f650378f4(issue.values[0])}`;
                return `\u{7121}\u{6548}\u{7684}\u{9078}\u{9805}\u{FF1A}\u{9810}\u{671F}\u{70BA}\u{4EE5}\u{4E0B}\u{5176}\u{4E2D}\u{4E4B}\u{4E00} ${$8f5391358ccbeba2$export$e79b744344f50f50(issue.values, "|")}`;
            case "too_big":
                {
                    const adj = issue.inclusive ? "<=" : "<";
                    const sizing = getSizing(issue.origin);
                    if (sizing) return `\u{6578}\u{503C}\u{904E}\u{5927}\u{FF1A}\u{9810}\u{671F} ${issue.origin ?? "\u503C"} \u{61C9}\u{70BA} ${adj}${issue.maximum.toString()} ${sizing.unit ?? "\u500B\u5143\u7D20"}`;
                    return `\u{6578}\u{503C}\u{904E}\u{5927}\u{FF1A}\u{9810}\u{671F} ${issue.origin ?? "\u503C"} \u{61C9}\u{70BA} ${adj}${issue.maximum.toString()}`;
                }
            case "too_small":
                {
                    const adj = issue.inclusive ? ">=" : ">";
                    const sizing = getSizing(issue.origin);
                    if (sizing) return `\u{6578}\u{503C}\u{904E}\u{5C0F}\u{FF1A}\u{9810}\u{671F} ${issue.origin} \u{61C9}\u{70BA} ${adj}${issue.minimum.toString()} ${sizing.unit}`;
                    return `\u{6578}\u{503C}\u{904E}\u{5C0F}\u{FF1A}\u{9810}\u{671F} ${issue.origin} \u{61C9}\u{70BA} ${adj}${issue.minimum.toString()}`;
                }
            case "invalid_format":
                {
                    const _issue = issue;
                    if (_issue.format === "starts_with") return `\u{7121}\u{6548}\u{7684}\u{5B57}\u{4E32}\u{FF1A}\u{5FC5}\u{9808}\u{4EE5} "${_issue.prefix}" \u{958B}\u{982D}`;
                    if (_issue.format === "ends_with") return `\u{7121}\u{6548}\u{7684}\u{5B57}\u{4E32}\u{FF1A}\u{5FC5}\u{9808}\u{4EE5} "${_issue.suffix}" \u{7D50}\u{5C3E}`;
                    if (_issue.format === "includes") return `\u{7121}\u{6548}\u{7684}\u{5B57}\u{4E32}\u{FF1A}\u{5FC5}\u{9808}\u{5305}\u{542B} "${_issue.includes}"`;
                    if (_issue.format === "regex") return `\u{7121}\u{6548}\u{7684}\u{5B57}\u{4E32}\u{FF1A}\u{5FC5}\u{9808}\u{7B26}\u{5408}\u{683C}\u{5F0F} ${_issue.pattern}`;
                    return `\u{7121}\u{6548}\u{7684} ${Nouns[_issue.format] ?? issue.format}`;
                }
            case "not_multiple_of":
                return `\u{7121}\u{6548}\u{7684}\u{6578}\u{5B57}\u{FF1A}\u{5FC5}\u{9808}\u{70BA} ${issue.divisor} \u{7684}\u{500D}\u{6578}`;
            case "unrecognized_keys":
                return `\u{7121}\u{6CD5}\u{8B58}\u{5225}\u{7684}\u{9375}\u{503C}${issue.keys.length > 1 ? "\u5011" : ""}\u{FF1A}${$8f5391358ccbeba2$export$e79b744344f50f50(issue.keys, "\u3001")}`;
            case "invalid_key":
                return `${issue.origin} \u{4E2D}\u{6709}\u{7121}\u{6548}\u{7684}\u{9375}\u{503C}`;
            case "invalid_union":
                return "\u7121\u6548\u7684\u8F38\u5165\u503C";
            case "invalid_element":
                return `${issue.origin} \u{4E2D}\u{6709}\u{7121}\u{6548}\u{7684}\u{503C}`;
            default:
                return `\u{7121}\u{6548}\u{7684}\u{8F38}\u{5165}\u{503C}`;
        }
    };
};
function $205dd299c3aa23b7$export$2e2bcd8739ae039() {
    return {
        localeError: $205dd299c3aa23b7$var$error()
    };
}



const $93ae3b7bb8bd6324$var$error = ()=>{
    const Sizable = {
        string: {
            unit: "\xe0mi",
            verb: "n\xed"
        },
        file: {
            unit: "bytes",
            verb: "n\xed"
        },
        array: {
            unit: "nkan",
            verb: "n\xed"
        },
        set: {
            unit: "nkan",
            verb: "n\xed"
        }
    };
    function getSizing(origin) {
        return Sizable[origin] ?? null;
    }
    const parsedType = (data)=>{
        const t = typeof data;
        switch(t){
            case "number":
                return Number.isNaN(data) ? "NaN" : "n\u1ECD\u0301mb\xe0";
            case "object":
                if (Array.isArray(data)) return "akop\u1ECD";
                if (data === null) return "null";
                if (Object.getPrototypeOf(data) !== Object.prototype && data.constructor) return data.constructor.name;
        }
        return t;
    };
    const Nouns = {
        regex: "\u1EB9\u0300r\u1ECD \xecb\xe1w\u1ECDl\xe9",
        email: "\xe0d\xedr\u1EB9\u0301s\xec \xecm\u1EB9\u0301l\xec",
        url: "URL",
        emoji: "emoji",
        uuid: "UUID",
        uuidv4: "UUIDv4",
        uuidv6: "UUIDv6",
        nanoid: "nanoid",
        guid: "GUID",
        cuid: "cuid",
        cuid2: "cuid2",
        ulid: "ULID",
        xid: "XID",
        ksuid: "KSUID",
        datetime: "\xe0k\xf3k\xf2 ISO",
        date: "\u1ECDj\u1ECD\u0301 ISO",
        time: "\xe0k\xf3k\xf2 ISO",
        duration: "\xe0k\xf3k\xf2 t\xf3 p\xe9 ISO",
        ipv4: "\xe0d\xedr\u1EB9\u0301s\xec IPv4",
        ipv6: "\xe0d\xedr\u1EB9\u0301s\xec IPv6",
        cidrv4: "\xe0gb\xe8gb\xe8 IPv4",
        cidrv6: "\xe0gb\xe8gb\xe8 IPv6",
        base64: "\u1ECD\u0300r\u1ECD\u0300 t\xed a k\u1ECD\u0301 n\xed base64",
        base64url: "\u1ECD\u0300r\u1ECD\u0300 base64url",
        json_string: "\u1ECD\u0300r\u1ECD\u0300 JSON",
        e164: "n\u1ECD\u0301mb\xe0 E.164",
        jwt: "JWT",
        template_literal: "\u1EB9\u0300r\u1ECD \xecb\xe1w\u1ECDl\xe9"
    };
    return (issue)=>{
        switch(issue.code){
            case "invalid_type":
                return `\xccb\xe1w\u{1ECD}l\xe9 a\u{1E63}\xec\u{1E63}e: a n\xed l\xe1ti fi ${issue.expected}, \xe0m\u{1ECD}\u{300} a r\xed ${parsedType(issue.input)}`;
            case "invalid_value":
                if (issue.values.length === 1) return `\xccb\xe1w\u{1ECD}l\xe9 a\u{1E63}\xec\u{1E63}e: a n\xed l\xe1ti fi ${$8f5391358ccbeba2$export$5859860f650378f4(issue.values[0])}`;
                return `\xc0\u{1E63}\xe0y\xe0n a\u{1E63}\xec\u{1E63}e: yan \u{1ECD}\u{300}kan l\xe1ra ${$8f5391358ccbeba2$export$e79b744344f50f50(issue.values, "|")}`;
            case "too_big":
                {
                    const adj = issue.inclusive ? "<=" : "<";
                    const sizing = getSizing(issue.origin);
                    if (sizing) return `T\xf3 p\u{1ECD}\u{300} j\xf9: a n\xed l\xe1ti j\u{1EB9}\u{301} p\xe9 ${issue.origin ?? "iye"} ${sizing.verb} ${adj}${issue.maximum} ${sizing.unit}`;
                    return `T\xf3 p\u{1ECD}\u{300} j\xf9: a n\xed l\xe1ti j\u{1EB9}\u{301} ${adj}${issue.maximum}`;
                }
            case "too_small":
                {
                    const adj = issue.inclusive ? ">=" : ">";
                    const sizing = getSizing(issue.origin);
                    if (sizing) return `K\xe9r\xe9 ju: a n\xed l\xe1ti j\u{1EB9}\u{301} p\xe9 ${issue.origin} ${sizing.verb} ${adj}${issue.minimum} ${sizing.unit}`;
                    return `K\xe9r\xe9 ju: a n\xed l\xe1ti j\u{1EB9}\u{301} ${adj}${issue.minimum}`;
                }
            case "invalid_format":
                {
                    const _issue = issue;
                    if (_issue.format === "starts_with") return `\u{1ECC}\u{300}r\u{1ECD}\u{300} a\u{1E63}\xec\u{1E63}e: gb\u{1ECD}\u{301}d\u{1ECD}\u{300} b\u{1EB9}\u{300}r\u{1EB9}\u{300} p\u{1EB9}\u{300}l\xfa "${_issue.prefix}"`;
                    if (_issue.format === "ends_with") return `\u{1ECC}\u{300}r\u{1ECD}\u{300} a\u{1E63}\xec\u{1E63}e: gb\u{1ECD}\u{301}d\u{1ECD}\u{300} par\xed p\u{1EB9}\u{300}l\xfa "${_issue.suffix}"`;
                    if (_issue.format === "includes") return `\u{1ECC}\u{300}r\u{1ECD}\u{300} a\u{1E63}\xec\u{1E63}e: gb\u{1ECD}\u{301}d\u{1ECD}\u{300} n\xed "${_issue.includes}"`;
                    if (_issue.format === "regex") return `\u{1ECC}\u{300}r\u{1ECD}\u{300} a\u{1E63}\xec\u{1E63}e: gb\u{1ECD}\u{301}d\u{1ECD}\u{300} b\xe1 \xe0p\u{1EB9}\u{1EB9}r\u{1EB9} mu ${_issue.pattern}`;
                    return `A\u{1E63}\xec\u{1E63}e: ${Nouns[_issue.format] ?? issue.format}`;
                }
            case "not_multiple_of":
                return `N\u{1ECD}\u{301}mb\xe0 a\u{1E63}\xec\u{1E63}e: gb\u{1ECD}\u{301}d\u{1ECD}\u{300} j\u{1EB9}\u{301} \xe8y\xe0 p\xedp\xedn ti ${issue.divisor}`;
            case "unrecognized_keys":
                return `B\u{1ECD}t\xecn\xec \xe0\xecm\u{1ECD}\u{300}: ${$8f5391358ccbeba2$export$e79b744344f50f50(issue.keys, ", ")}`;
            case "invalid_key":
                return `B\u{1ECD}t\xecn\xec a\u{1E63}\xec\u{1E63}e n\xedn\xfa ${issue.origin}`;
            case "invalid_union":
                return "\xccb\xe1w\u1ECDl\xe9 a\u1E63\xec\u1E63e";
            case "invalid_element":
                return `Iye a\u{1E63}\xec\u{1E63}e n\xedn\xfa ${issue.origin}`;
            default:
                return "\xccb\xe1w\u1ECDl\xe9 a\u1E63\xec\u1E63e";
        }
    };
};
function $93ae3b7bb8bd6324$export$2e2bcd8739ae039() {
    return {
        localeError: $93ae3b7bb8bd6324$var$error()
    };
}




var $3cec3829b03c3a57$var$_a;
const $3cec3829b03c3a57$export$26c272954616d4a2 = Symbol("ZodOutput");
const $3cec3829b03c3a57$export$4159eb10f43487af = Symbol("ZodInput");
class $3cec3829b03c3a57$export$dc03955eec152cc5 {
    constructor(){
        this._map = new WeakMap();
        this._idmap = new Map();
    }
    add(schema, ..._meta) {
        const meta = _meta[0];
        this._map.set(schema, meta);
        if (meta && typeof meta === "object" && "id" in meta) {
            if (this._idmap.has(meta.id)) throw new Error(`ID ${meta.id} already exists in the registry`);
            this._idmap.set(meta.id, schema);
        }
        return this;
    }
    clear() {
        this._map = new WeakMap();
        this._idmap = new Map();
        return this;
    }
    remove(schema) {
        const meta = this._map.get(schema);
        if (meta && typeof meta === "object" && "id" in meta) this._idmap.delete(meta.id);
        this._map.delete(schema);
        return this;
    }
    get(schema) {
        // return this._map.get(schema) as any;
        // inherit metadata
        const p = schema._zod.parent;
        if (p) {
            const pm = {
                ...this.get(p) ?? {}
            };
            delete pm.id; // do not inherit id
            const f = {
                ...pm,
                ...this._map.get(schema)
            };
            return Object.keys(f).length ? f : undefined;
        }
        return this._map.get(schema);
    }
    has(schema) {
        return this._map.has(schema);
    }
}
function $3cec3829b03c3a57$export$4bb7493d241fd8a5() {
    return new $3cec3829b03c3a57$export$dc03955eec152cc5();
}
($3cec3829b03c3a57$var$_a = globalThis).__zod_globalRegistry ?? ($3cec3829b03c3a57$var$_a.__zod_globalRegistry = $3cec3829b03c3a57$export$4bb7493d241fd8a5());
const $3cec3829b03c3a57$export$bc58ce2776ecdb6f = globalThis.__zod_globalRegistry;







function $d7427071dbf0b4e9$export$25986a84359f8f7f(Class, params) {
    return new Class({
        type: "string",
        ...$8f5391358ccbeba2$export$d6b7b25dfacfd300(params)
    });
}
function $d7427071dbf0b4e9$export$614049477c642ce0(Class, params) {
    return new Class({
        type: "string",
        coerce: true,
        ...$8f5391358ccbeba2$export$d6b7b25dfacfd300(params)
    });
}
function $d7427071dbf0b4e9$export$471b39521bec3299(Class, params) {
    return new Class({
        type: "string",
        format: "email",
        check: "string_format",
        abort: false,
        ...$8f5391358ccbeba2$export$d6b7b25dfacfd300(params)
    });
}
function $d7427071dbf0b4e9$export$129b5399d64cccb0(Class, params) {
    return new Class({
        type: "string",
        format: "guid",
        check: "string_format",
        abort: false,
        ...$8f5391358ccbeba2$export$d6b7b25dfacfd300(params)
    });
}
function $d7427071dbf0b4e9$export$f2f3139038bea52c(Class, params) {
    return new Class({
        type: "string",
        format: "uuid",
        check: "string_format",
        abort: false,
        ...$8f5391358ccbeba2$export$d6b7b25dfacfd300(params)
    });
}
function $d7427071dbf0b4e9$export$a5559d7da37a112f(Class, params) {
    return new Class({
        type: "string",
        format: "uuid",
        check: "string_format",
        abort: false,
        version: "v4",
        ...$8f5391358ccbeba2$export$d6b7b25dfacfd300(params)
    });
}
function $d7427071dbf0b4e9$export$53b427a8173231a(Class, params) {
    return new Class({
        type: "string",
        format: "uuid",
        check: "string_format",
        abort: false,
        version: "v6",
        ...$8f5391358ccbeba2$export$d6b7b25dfacfd300(params)
    });
}
function $d7427071dbf0b4e9$export$588d23d6e9ec2ed5(Class, params) {
    return new Class({
        type: "string",
        format: "uuid",
        check: "string_format",
        abort: false,
        version: "v7",
        ...$8f5391358ccbeba2$export$d6b7b25dfacfd300(params)
    });
}
function $d7427071dbf0b4e9$export$e3f203373341d39(Class, params) {
    return new Class({
        type: "string",
        format: "url",
        check: "string_format",
        abort: false,
        ...$8f5391358ccbeba2$export$d6b7b25dfacfd300(params)
    });
}
function $d7427071dbf0b4e9$export$936e26d261396f46(Class, params) {
    return new Class({
        type: "string",
        format: "emoji",
        check: "string_format",
        abort: false,
        ...$8f5391358ccbeba2$export$d6b7b25dfacfd300(params)
    });
}
function $d7427071dbf0b4e9$export$a030949b19390ea0(Class, params) {
    return new Class({
        type: "string",
        format: "nanoid",
        check: "string_format",
        abort: false,
        ...$8f5391358ccbeba2$export$d6b7b25dfacfd300(params)
    });
}
function $d7427071dbf0b4e9$export$639125837b796148(Class, params) {
    return new Class({
        type: "string",
        format: "cuid",
        check: "string_format",
        abort: false,
        ...$8f5391358ccbeba2$export$d6b7b25dfacfd300(params)
    });
}
function $d7427071dbf0b4e9$export$36b63ef9af7972c2(Class, params) {
    return new Class({
        type: "string",
        format: "cuid2",
        check: "string_format",
        abort: false,
        ...$8f5391358ccbeba2$export$d6b7b25dfacfd300(params)
    });
}
function $d7427071dbf0b4e9$export$95acf3b3fa11bdc9(Class, params) {
    return new Class({
        type: "string",
        format: "ulid",
        check: "string_format",
        abort: false,
        ...$8f5391358ccbeba2$export$d6b7b25dfacfd300(params)
    });
}
function $d7427071dbf0b4e9$export$bbb0a2cfb079fa90(Class, params) {
    return new Class({
        type: "string",
        format: "xid",
        check: "string_format",
        abort: false,
        ...$8f5391358ccbeba2$export$d6b7b25dfacfd300(params)
    });
}
function $d7427071dbf0b4e9$export$1306ede2f9ea153f(Class, params) {
    return new Class({
        type: "string",
        format: "ksuid",
        check: "string_format",
        abort: false,
        ...$8f5391358ccbeba2$export$d6b7b25dfacfd300(params)
    });
}
function $d7427071dbf0b4e9$export$c77a1c80cebc2aad(Class, params) {
    return new Class({
        type: "string",
        format: "ipv4",
        check: "string_format",
        abort: false,
        ...$8f5391358ccbeba2$export$d6b7b25dfacfd300(params)
    });
}
function $d7427071dbf0b4e9$export$964dfe0e2e4e8895(Class, params) {
    return new Class({
        type: "string",
        format: "ipv6",
        check: "string_format",
        abort: false,
        ...$8f5391358ccbeba2$export$d6b7b25dfacfd300(params)
    });
}
function $d7427071dbf0b4e9$export$84f8b3e041d8e7d9(Class, params) {
    return new Class({
        type: "string",
        format: "mac",
        check: "string_format",
        abort: false,
        ...$8f5391358ccbeba2$export$d6b7b25dfacfd300(params)
    });
}
function $d7427071dbf0b4e9$export$feaac4e27a421ddc(Class, params) {
    return new Class({
        type: "string",
        format: "cidrv4",
        check: "string_format",
        abort: false,
        ...$8f5391358ccbeba2$export$d6b7b25dfacfd300(params)
    });
}
function $d7427071dbf0b4e9$export$a0518ffc5273ec92(Class, params) {
    return new Class({
        type: "string",
        format: "cidrv6",
        check: "string_format",
        abort: false,
        ...$8f5391358ccbeba2$export$d6b7b25dfacfd300(params)
    });
}
function $d7427071dbf0b4e9$export$9fdb09384fbc4988(Class, params) {
    return new Class({
        type: "string",
        format: "base64",
        check: "string_format",
        abort: false,
        ...$8f5391358ccbeba2$export$d6b7b25dfacfd300(params)
    });
}
function $d7427071dbf0b4e9$export$178c70fb89c949fa(Class, params) {
    return new Class({
        type: "string",
        format: "base64url",
        check: "string_format",
        abort: false,
        ...$8f5391358ccbeba2$export$d6b7b25dfacfd300(params)
    });
}
function $d7427071dbf0b4e9$export$b8bf0b70d4bc7855(Class, params) {
    return new Class({
        type: "string",
        format: "e164",
        check: "string_format",
        abort: false,
        ...$8f5391358ccbeba2$export$d6b7b25dfacfd300(params)
    });
}
function $d7427071dbf0b4e9$export$4a9318e6b46f1aa1(Class, params) {
    return new Class({
        type: "string",
        format: "jwt",
        check: "string_format",
        abort: false,
        ...$8f5391358ccbeba2$export$d6b7b25dfacfd300(params)
    });
}
const $d7427071dbf0b4e9$export$3a3ade082c590099 = {
    Any: null,
    Minute: -1,
    Second: 0,
    Millisecond: 3,
    Microsecond: 6
};
function $d7427071dbf0b4e9$export$a62adeb27809351b(Class, params) {
    return new Class({
        type: "string",
        format: "datetime",
        check: "string_format",
        offset: false,
        local: false,
        precision: null,
        ...$8f5391358ccbeba2$export$d6b7b25dfacfd300(params)
    });
}
function $d7427071dbf0b4e9$export$e4f19dd0a54e7a59(Class, params) {
    return new Class({
        type: "string",
        format: "date",
        check: "string_format",
        ...$8f5391358ccbeba2$export$d6b7b25dfacfd300(params)
    });
}
function $d7427071dbf0b4e9$export$36f9f051d5e817c(Class, params) {
    return new Class({
        type: "string",
        format: "time",
        check: "string_format",
        precision: null,
        ...$8f5391358ccbeba2$export$d6b7b25dfacfd300(params)
    });
}
function $d7427071dbf0b4e9$export$7d70539c76fbff4(Class, params) {
    return new Class({
        type: "string",
        format: "duration",
        check: "string_format",
        ...$8f5391358ccbeba2$export$d6b7b25dfacfd300(params)
    });
}
function $d7427071dbf0b4e9$export$9249bb0b45639623(Class, params) {
    return new Class({
        type: "number",
        checks: [],
        ...$8f5391358ccbeba2$export$d6b7b25dfacfd300(params)
    });
}
function $d7427071dbf0b4e9$export$272511620e4661dd(Class, params) {
    return new Class({
        type: "number",
        coerce: true,
        checks: [],
        ...$8f5391358ccbeba2$export$d6b7b25dfacfd300(params)
    });
}
function $d7427071dbf0b4e9$export$3d5b343b1f51efdd(Class, params) {
    return new Class({
        type: "number",
        check: "number_format",
        abort: false,
        format: "safeint",
        ...$8f5391358ccbeba2$export$d6b7b25dfacfd300(params)
    });
}
function $d7427071dbf0b4e9$export$656ad65d6cf64174(Class, params) {
    return new Class({
        type: "number",
        check: "number_format",
        abort: false,
        format: "float32",
        ...$8f5391358ccbeba2$export$d6b7b25dfacfd300(params)
    });
}
function $d7427071dbf0b4e9$export$9ddff8176107cc11(Class, params) {
    return new Class({
        type: "number",
        check: "number_format",
        abort: false,
        format: "float64",
        ...$8f5391358ccbeba2$export$d6b7b25dfacfd300(params)
    });
}
function $d7427071dbf0b4e9$export$5ec965fd114a2f9f(Class, params) {
    return new Class({
        type: "number",
        check: "number_format",
        abort: false,
        format: "int32",
        ...$8f5391358ccbeba2$export$d6b7b25dfacfd300(params)
    });
}
function $d7427071dbf0b4e9$export$a43c28c6e86e066e(Class, params) {
    return new Class({
        type: "number",
        check: "number_format",
        abort: false,
        format: "uint32",
        ...$8f5391358ccbeba2$export$d6b7b25dfacfd300(params)
    });
}
function $d7427071dbf0b4e9$export$e23c41ce5ce2db39(Class, params) {
    return new Class({
        type: "boolean",
        ...$8f5391358ccbeba2$export$d6b7b25dfacfd300(params)
    });
}
function $d7427071dbf0b4e9$export$c3eb0e1c7c887e5c(Class, params) {
    return new Class({
        type: "boolean",
        coerce: true,
        ...$8f5391358ccbeba2$export$d6b7b25dfacfd300(params)
    });
}
function $d7427071dbf0b4e9$export$c96ff33878177e4c(Class, params) {
    return new Class({
        type: "bigint",
        ...$8f5391358ccbeba2$export$d6b7b25dfacfd300(params)
    });
}
function $d7427071dbf0b4e9$export$8ff745acc355d077(Class, params) {
    return new Class({
        type: "bigint",
        coerce: true,
        ...$8f5391358ccbeba2$export$d6b7b25dfacfd300(params)
    });
}
function $d7427071dbf0b4e9$export$cb7d3ec922804f3f(Class, params) {
    return new Class({
        type: "bigint",
        check: "bigint_format",
        abort: false,
        format: "int64",
        ...$8f5391358ccbeba2$export$d6b7b25dfacfd300(params)
    });
}
function $d7427071dbf0b4e9$export$c51606f0dfa0f5a1(Class, params) {
    return new Class({
        type: "bigint",
        check: "bigint_format",
        abort: false,
        format: "uint64",
        ...$8f5391358ccbeba2$export$d6b7b25dfacfd300(params)
    });
}
function $d7427071dbf0b4e9$export$a8f93f5b7c030e84(Class, params) {
    return new Class({
        type: "symbol",
        ...$8f5391358ccbeba2$export$d6b7b25dfacfd300(params)
    });
}
function $d7427071dbf0b4e9$export$60e4c9fe67803d40(Class, params) {
    return new Class({
        type: "undefined",
        ...$8f5391358ccbeba2$export$d6b7b25dfacfd300(params)
    });
}
function $d7427071dbf0b4e9$export$a2cbb38cda512d16(Class, params) {
    return new Class({
        type: "null",
        ...$8f5391358ccbeba2$export$d6b7b25dfacfd300(params)
    });
}
function $d7427071dbf0b4e9$export$4678886173313220(Class) {
    return new Class({
        type: "any"
    });
}
function $d7427071dbf0b4e9$export$e0ed508a47e00801(Class) {
    return new Class({
        type: "unknown"
    });
}
function $d7427071dbf0b4e9$export$887f43204ffc2a69(Class, params) {
    return new Class({
        type: "never",
        ...$8f5391358ccbeba2$export$d6b7b25dfacfd300(params)
    });
}
function $d7427071dbf0b4e9$export$9480825d3c8e9ad6(Class, params) {
    return new Class({
        type: "void",
        ...$8f5391358ccbeba2$export$d6b7b25dfacfd300(params)
    });
}
function $d7427071dbf0b4e9$export$da799735c76175a(Class, params) {
    return new Class({
        type: "date",
        ...$8f5391358ccbeba2$export$d6b7b25dfacfd300(params)
    });
}
function $d7427071dbf0b4e9$export$2efeac445ea43f33(Class, params) {
    return new Class({
        type: "date",
        coerce: true,
        ...$8f5391358ccbeba2$export$d6b7b25dfacfd300(params)
    });
}
function $d7427071dbf0b4e9$export$a5e7e1f8491a5e50(Class, params) {
    return new Class({
        type: "nan",
        ...$8f5391358ccbeba2$export$d6b7b25dfacfd300(params)
    });
}
function $d7427071dbf0b4e9$export$2a42c74e76a068a(value, params) {
    return new $81f0b1f6d5b9fb58$export$294415ecbdd02022({
        check: "less_than",
        ...$8f5391358ccbeba2$export$d6b7b25dfacfd300(params),
        value: value,
        inclusive: false
    });
}
function $d7427071dbf0b4e9$export$7a060cf3d60b84a6(value, params) {
    return new $81f0b1f6d5b9fb58$export$294415ecbdd02022({
        check: "less_than",
        ...$8f5391358ccbeba2$export$d6b7b25dfacfd300(params),
        value: value,
        inclusive: true
    });
}
function $d7427071dbf0b4e9$export$7582466e3ab4d25b(value, params) {
    return new $81f0b1f6d5b9fb58$export$8b670f58decbca18({
        check: "greater_than",
        ...$8f5391358ccbeba2$export$d6b7b25dfacfd300(params),
        value: value,
        inclusive: false
    });
}
function $d7427071dbf0b4e9$export$a1c6d8834a3b19c9(value, params) {
    return new $81f0b1f6d5b9fb58$export$8b670f58decbca18({
        check: "greater_than",
        ...$8f5391358ccbeba2$export$d6b7b25dfacfd300(params),
        value: value,
        inclusive: true
    });
}
function $d7427071dbf0b4e9$export$ddfc6f0a2e49a568(params) {
    return $d7427071dbf0b4e9$export$7582466e3ab4d25b(0, params);
}
function $d7427071dbf0b4e9$export$d30568dda7134ca5(params) {
    return $d7427071dbf0b4e9$export$2a42c74e76a068a(0, params);
}
function $d7427071dbf0b4e9$export$c3e51eea33419c94(params) {
    return $d7427071dbf0b4e9$export$7a060cf3d60b84a6(0, params);
}
function $d7427071dbf0b4e9$export$93ec5f75848b1928(params) {
    return $d7427071dbf0b4e9$export$a1c6d8834a3b19c9(0, params);
}
function $d7427071dbf0b4e9$export$c41e40f80e978ab1(value, params) {
    return new $81f0b1f6d5b9fb58$export$ae602e11c1dd0628({
        check: "multiple_of",
        ...$8f5391358ccbeba2$export$d6b7b25dfacfd300(params),
        value: value
    });
}
function $d7427071dbf0b4e9$export$3eed6ccb98bc18db(maximum, params) {
    return new $81f0b1f6d5b9fb58$export$b3cec505675cf50c({
        check: "max_size",
        ...$8f5391358ccbeba2$export$d6b7b25dfacfd300(params),
        maximum: maximum
    });
}
function $d7427071dbf0b4e9$export$e379713268c2c18a(minimum, params) {
    return new $81f0b1f6d5b9fb58$export$59fb0a2e7217c42b({
        check: "min_size",
        ...$8f5391358ccbeba2$export$d6b7b25dfacfd300(params),
        minimum: minimum
    });
}
function $d7427071dbf0b4e9$export$2621565b966a8d23(size, params) {
    return new $81f0b1f6d5b9fb58$export$af532c490f33cd47({
        check: "size_equals",
        ...$8f5391358ccbeba2$export$d6b7b25dfacfd300(params),
        size: size
    });
}
function $d7427071dbf0b4e9$export$ec76627108655a22(maximum, params) {
    const ch = new $81f0b1f6d5b9fb58$export$b07b097887f4c15a({
        check: "max_length",
        ...$8f5391358ccbeba2$export$d6b7b25dfacfd300(params),
        maximum: maximum
    });
    return ch;
}
function $d7427071dbf0b4e9$export$21f6711a906c1450(minimum, params) {
    return new $81f0b1f6d5b9fb58$export$cd5336aa96b8417c({
        check: "min_length",
        ...$8f5391358ccbeba2$export$d6b7b25dfacfd300(params),
        minimum: minimum
    });
}
function $d7427071dbf0b4e9$export$620b9f7ab17ff8a9(length, params) {
    return new $81f0b1f6d5b9fb58$export$ccdb9b9d477068fb({
        check: "length_equals",
        ...$8f5391358ccbeba2$export$d6b7b25dfacfd300(params),
        length: length
    });
}
function $d7427071dbf0b4e9$export$c4768a1bd8f8393(pattern, params) {
    return new $81f0b1f6d5b9fb58$export$6faea86ff718d6df({
        check: "string_format",
        format: "regex",
        ...$8f5391358ccbeba2$export$d6b7b25dfacfd300(params),
        pattern: pattern
    });
}
function $d7427071dbf0b4e9$export$ea67c3edeec85c63(params) {
    return new $81f0b1f6d5b9fb58$export$e18e268bd5c9f27a({
        check: "string_format",
        format: "lowercase",
        ...$8f5391358ccbeba2$export$d6b7b25dfacfd300(params)
    });
}
function $d7427071dbf0b4e9$export$2998381b41c6902a(params) {
    return new $81f0b1f6d5b9fb58$export$6d0944a5127e820a({
        check: "string_format",
        format: "uppercase",
        ...$8f5391358ccbeba2$export$d6b7b25dfacfd300(params)
    });
}
function $d7427071dbf0b4e9$export$fccf016a6caa651d(includes, params) {
    return new $81f0b1f6d5b9fb58$export$600021c28f0498dc({
        check: "string_format",
        format: "includes",
        ...$8f5391358ccbeba2$export$d6b7b25dfacfd300(params),
        includes: includes
    });
}
function $d7427071dbf0b4e9$export$2f37aaf99060de76(prefix, params) {
    return new $81f0b1f6d5b9fb58$export$8e83a74b4b83cc62({
        check: "string_format",
        format: "starts_with",
        ...$8f5391358ccbeba2$export$d6b7b25dfacfd300(params),
        prefix: prefix
    });
}
function $d7427071dbf0b4e9$export$eaeaa2fcd833167e(suffix, params) {
    return new $81f0b1f6d5b9fb58$export$4a10f85c6af4e92({
        check: "string_format",
        format: "ends_with",
        ...$8f5391358ccbeba2$export$d6b7b25dfacfd300(params),
        suffix: suffix
    });
}
function $d7427071dbf0b4e9$export$537db06738ee7f1b(property, schema, params) {
    return new $81f0b1f6d5b9fb58$export$d36a4eecd766dbc0({
        check: "property",
        property: property,
        schema: schema,
        ...$8f5391358ccbeba2$export$d6b7b25dfacfd300(params)
    });
}
function $d7427071dbf0b4e9$export$267177285a1a8b37(types, params) {
    return new $81f0b1f6d5b9fb58$export$5546147f1877f806({
        check: "mime_type",
        mime: types,
        ...$8f5391358ccbeba2$export$d6b7b25dfacfd300(params)
    });
}
function $d7427071dbf0b4e9$export$aeea8f004f34f8c2(tx) {
    return new $81f0b1f6d5b9fb58$export$1bda1934456013d3({
        check: "overwrite",
        tx: tx
    });
}
function $d7427071dbf0b4e9$export$2b99bb23a814f78e(form) {
    return $d7427071dbf0b4e9$export$aeea8f004f34f8c2((input)=>input.normalize(form));
}
function $d7427071dbf0b4e9$export$8be2de0b60774d1e() {
    return $d7427071dbf0b4e9$export$aeea8f004f34f8c2((input)=>input.trim());
}
function $d7427071dbf0b4e9$export$d9cfe939403a2525() {
    return $d7427071dbf0b4e9$export$aeea8f004f34f8c2((input)=>input.toLowerCase());
}
function $d7427071dbf0b4e9$export$cf76ef1ae9e9944e() {
    return $d7427071dbf0b4e9$export$aeea8f004f34f8c2((input)=>input.toUpperCase());
}
function $d7427071dbf0b4e9$export$2801993b93f3c232() {
    return $d7427071dbf0b4e9$export$aeea8f004f34f8c2((input)=>$8f5391358ccbeba2$export$c383cdd2a518017a(input));
}
function $d7427071dbf0b4e9$export$4ea446333e3db634(Class, element, params) {
    return new Class({
        type: "array",
        element: element,
        // get element() {
        //   return element;
        // },
        ...$8f5391358ccbeba2$export$d6b7b25dfacfd300(params)
    });
}
function $d7427071dbf0b4e9$export$48eec03fd15d025b(Class, options, params) {
    return new Class({
        type: "union",
        options: options,
        ...$8f5391358ccbeba2$export$d6b7b25dfacfd300(params)
    });
}
function $d7427071dbf0b4e9$export$ffbf51421b0acee1(Class, discriminator, options, params) {
    return new Class({
        type: "union",
        options: options,
        discriminator: discriminator,
        ...$8f5391358ccbeba2$export$d6b7b25dfacfd300(params)
    });
}
function $d7427071dbf0b4e9$export$3d0d84e16c5ea809(Class, left, right) {
    return new Class({
        type: "intersection",
        left: left,
        right: right
    });
}
function $d7427071dbf0b4e9$export$a13693bfb304605a(Class, items, _paramsOrRest, _params) {
    const hasRest = _paramsOrRest instanceof $38bc36f53cb4eb10$export$f43a5c3966de8238;
    const params = hasRest ? _params : _paramsOrRest;
    const rest = hasRest ? _paramsOrRest : null;
    return new Class({
        type: "tuple",
        items: items,
        rest: rest,
        ...$8f5391358ccbeba2$export$d6b7b25dfacfd300(params)
    });
}
function $d7427071dbf0b4e9$export$64440e3f2e29d7bc(Class, keyType, valueType, params) {
    return new Class({
        type: "record",
        keyType: keyType,
        valueType: valueType,
        ...$8f5391358ccbeba2$export$d6b7b25dfacfd300(params)
    });
}
function $d7427071dbf0b4e9$export$a0135aecf4a782ab(Class, keyType, valueType, params) {
    return new Class({
        type: "map",
        keyType: keyType,
        valueType: valueType,
        ...$8f5391358ccbeba2$export$d6b7b25dfacfd300(params)
    });
}
function $d7427071dbf0b4e9$export$c37fd9e9b598996d(Class, valueType, params) {
    return new Class({
        type: "set",
        valueType: valueType,
        ...$8f5391358ccbeba2$export$d6b7b25dfacfd300(params)
    });
}
function $d7427071dbf0b4e9$export$3290a9b46bcfecc1(Class, values, params) {
    const entries = Array.isArray(values) ? Object.fromEntries(values.map((v)=>[
            v,
            v
        ])) : values;
    // if (Array.isArray(values)) {
    //   for (const value of values) {
    //     entries[value] = value;
    //   }
    // } else {
    //   Object.assign(entries, values);
    // }
    // const entries: util.EnumLike = {};
    // for (const val of values) {
    //   entries[val] = val;
    // }
    return new Class({
        type: "enum",
        entries: entries,
        ...$8f5391358ccbeba2$export$d6b7b25dfacfd300(params)
    });
}
function $d7427071dbf0b4e9$export$6b94bba2375b9e3d(Class, entries, params) {
    return new Class({
        type: "enum",
        entries: entries,
        ...$8f5391358ccbeba2$export$d6b7b25dfacfd300(params)
    });
}
function $d7427071dbf0b4e9$export$a03e276eec27de8b(Class, value, params) {
    return new Class({
        type: "literal",
        values: Array.isArray(value) ? value : [
            value
        ],
        ...$8f5391358ccbeba2$export$d6b7b25dfacfd300(params)
    });
}
function $d7427071dbf0b4e9$export$e335cd0b9f8bab1e(Class, params) {
    return new Class({
        type: "file",
        ...$8f5391358ccbeba2$export$d6b7b25dfacfd300(params)
    });
}
function $d7427071dbf0b4e9$export$fa4a3df4db7f3166(Class, fn) {
    return new Class({
        type: "transform",
        transform: fn
    });
}
function $d7427071dbf0b4e9$export$6d07c57dda792495(Class, innerType) {
    return new Class({
        type: "optional",
        innerType: innerType
    });
}
function $d7427071dbf0b4e9$export$4e46ee4534ff341d(Class, innerType) {
    return new Class({
        type: "nullable",
        innerType: innerType
    });
}
function $d7427071dbf0b4e9$export$d4b0f68d0d916971(Class, innerType, defaultValue) {
    return new Class({
        type: "default",
        innerType: innerType,
        get defaultValue () {
            return typeof defaultValue === "function" ? defaultValue() : $8f5391358ccbeba2$export$370e8311c3cdebd9(defaultValue);
        }
    });
}
function $d7427071dbf0b4e9$export$24cb0533b28b009b(Class, innerType, params) {
    return new Class({
        type: "nonoptional",
        innerType: innerType,
        ...$8f5391358ccbeba2$export$d6b7b25dfacfd300(params)
    });
}
function $d7427071dbf0b4e9$export$6f570707f72cba02(Class, innerType) {
    return new Class({
        type: "success",
        innerType: innerType
    });
}
function $d7427071dbf0b4e9$export$7f43fa37c3d8a0b3(Class, innerType, catchValue) {
    return new Class({
        type: "catch",
        innerType: innerType,
        catchValue: typeof catchValue === "function" ? catchValue : ()=>catchValue
    });
}
function $d7427071dbf0b4e9$export$fc24e256ce7b145(Class, in_, out) {
    return new Class({
        type: "pipe",
        in: in_,
        out: out
    });
}
function $d7427071dbf0b4e9$export$4fe7ff2cfb7a6dd7(Class, innerType) {
    return new Class({
        type: "readonly",
        innerType: innerType
    });
}
function $d7427071dbf0b4e9$export$f30d99994777b6d(Class, parts, params) {
    return new Class({
        type: "template_literal",
        parts: parts,
        ...$8f5391358ccbeba2$export$d6b7b25dfacfd300(params)
    });
}
function $d7427071dbf0b4e9$export$137d76f65e4bcae1(Class, getter) {
    return new Class({
        type: "lazy",
        getter: getter
    });
}
function $d7427071dbf0b4e9$export$d91bbb815217feb6(Class, innerType) {
    return new Class({
        type: "promise",
        innerType: innerType
    });
}
function $d7427071dbf0b4e9$export$8bfc2ce1398e3071(Class, fn, _params) {
    const norm = $8f5391358ccbeba2$export$d6b7b25dfacfd300(_params);
    norm.abort ?? (norm.abort = true); // default to abort:false
    const schema = new Class({
        type: "custom",
        check: "custom",
        fn: fn,
        ...norm
    });
    return schema;
}
function $d7427071dbf0b4e9$export$ac822e05051812e1(Class, fn, _params) {
    const schema = new Class({
        type: "custom",
        check: "custom",
        fn: fn,
        ...$8f5391358ccbeba2$export$d6b7b25dfacfd300(_params)
    });
    return schema;
}
function $d7427071dbf0b4e9$export$f2b01ecb843d7ab9(fn) {
    const ch = $d7427071dbf0b4e9$export$d37145829e4ff88e((payload)=>{
        payload.addIssue = (issue)=>{
            if (typeof issue === "string") payload.issues.push($8f5391358ccbeba2$export$69ad3503f98be476(issue, payload.value, ch._zod.def));
            else {
                // for Zod 3 backwards compatibility
                const _issue = issue;
                if (_issue.fatal) _issue.continue = false;
                _issue.code ?? (_issue.code = "custom");
                _issue.input ?? (_issue.input = payload.value);
                _issue.inst ?? (_issue.inst = ch);
                _issue.continue ?? (_issue.continue = !ch._zod.def.abort); // abort is always undefined, so this is always true...
                payload.issues.push($8f5391358ccbeba2$export$69ad3503f98be476(_issue));
            }
        };
        return fn(payload.value, payload);
    });
    return ch;
}
function $d7427071dbf0b4e9$export$d37145829e4ff88e(fn, params) {
    const ch = new $81f0b1f6d5b9fb58$export$c05d9110ef20bb2c({
        check: "custom",
        ...$8f5391358ccbeba2$export$d6b7b25dfacfd300(params)
    });
    ch._zod.check = fn;
    return ch;
}
function $d7427071dbf0b4e9$export$cd5450f3a47e3789(description) {
    const ch = new $81f0b1f6d5b9fb58$export$c05d9110ef20bb2c({
        check: "describe"
    });
    ch._zod.onattach = [
        (inst)=>{
            const existing = $3cec3829b03c3a57$export$bc58ce2776ecdb6f.get(inst) ?? {};
            $3cec3829b03c3a57$export$bc58ce2776ecdb6f.add(inst, {
                ...existing,
                description: description
            });
        }
    ];
    ch._zod.check = ()=>{}; // no-op check
    return ch;
}
function $d7427071dbf0b4e9$export$6990040ee07315(metadata) {
    const ch = new $81f0b1f6d5b9fb58$export$c05d9110ef20bb2c({
        check: "meta"
    });
    ch._zod.onattach = [
        (inst)=>{
            const existing = $3cec3829b03c3a57$export$bc58ce2776ecdb6f.get(inst) ?? {};
            $3cec3829b03c3a57$export$bc58ce2776ecdb6f.add(inst, {
                ...existing,
                ...metadata
            });
        }
    ];
    ch._zod.check = ()=>{}; // no-op check
    return ch;
}
function $d7427071dbf0b4e9$export$a75528509e3a7006(Classes, _params) {
    const params = $8f5391358ccbeba2$export$d6b7b25dfacfd300(_params);
    let truthyArray = params.truthy ?? [
        "true",
        "1",
        "yes",
        "on",
        "y",
        "enabled"
    ];
    let falsyArray = params.falsy ?? [
        "false",
        "0",
        "no",
        "off",
        "n",
        "disabled"
    ];
    if (params.case !== "sensitive") {
        truthyArray = truthyArray.map((v)=>typeof v === "string" ? v.toLowerCase() : v);
        falsyArray = falsyArray.map((v)=>typeof v === "string" ? v.toLowerCase() : v);
    }
    const truthySet = new Set(truthyArray);
    const falsySet = new Set(falsyArray);
    const _Codec = Classes.Codec ?? $38bc36f53cb4eb10$export$c622e07db8a40b53;
    const _Boolean = Classes.Boolean ?? $38bc36f53cb4eb10$export$828bf41e557d7dda;
    const _String = Classes.String ?? $38bc36f53cb4eb10$export$4342b4432d7b1471;
    const stringSchema = new _String({
        type: "string",
        error: params.error
    });
    const booleanSchema = new _Boolean({
        type: "boolean",
        error: params.error
    });
    const codec = new _Codec({
        type: "pipe",
        in: stringSchema,
        out: booleanSchema,
        transform: (input, payload)=>{
            let data = input;
            if (params.case !== "sensitive") data = data.toLowerCase();
            if (truthySet.has(data)) return true;
            else if (falsySet.has(data)) return false;
            else {
                payload.issues.push({
                    code: "invalid_value",
                    expected: "stringbool",
                    values: [
                        ...truthySet,
                        ...falsySet
                    ],
                    input: payload.value,
                    inst: codec,
                    continue: false
                });
                return {};
            }
        },
        reverseTransform: (input, _payload)=>{
            if (input === true) return truthyArray[0] || "true";
            else return falsyArray[0] || "false";
        },
        error: params.error
    });
    return codec;
}
function $d7427071dbf0b4e9$export$e25dde89ba546b88(Class, format, fnOrRegex, _params = {}) {
    const params = $8f5391358ccbeba2$export$d6b7b25dfacfd300(_params);
    const def = {
        ...$8f5391358ccbeba2$export$d6b7b25dfacfd300(_params),
        check: "string_format",
        type: "string",
        format: format,
        fn: typeof fnOrRegex === "function" ? fnOrRegex : (val)=>fnOrRegex.test(val),
        ...params
    };
    if (fnOrRegex instanceof RegExp) def.pattern = fnOrRegex;
    const inst = new Class(def);
    return inst;
}




class $16e71a39bb8f69ca$export$1b2196b107de679 {
    constructor(params){
        this.counter = 0;
        this.metadataRegistry = params?.metadata ?? (0, $3cec3829b03c3a57$export$bc58ce2776ecdb6f);
        this.target = params?.target ?? "draft-2020-12";
        this.unrepresentable = params?.unrepresentable ?? "throw";
        this.override = params?.override ?? (()=>{});
        this.io = params?.io ?? "output";
        this.seen = new Map();
    }
    process(schema, _params = {
        path: [],
        schemaPath: []
    }) {
        var _a;
        const def = schema._zod.def;
        const formatMap = {
            guid: "uuid",
            url: "uri",
            datetime: "date-time",
            json_string: "json-string",
            regex: ""
        };
        // check for schema in seens
        const seen = this.seen.get(schema);
        if (seen) {
            seen.count++;
            // check if cycle
            const isCycle = _params.schemaPath.includes(schema);
            if (isCycle) seen.cycle = _params.path;
            return seen.schema;
        }
        // initialize
        const result = {
            schema: {},
            count: 1,
            cycle: undefined,
            path: _params.path
        };
        this.seen.set(schema, result);
        // custom method overrides default behavior
        const overrideSchema = schema._zod.toJSONSchema?.();
        if (overrideSchema) result.schema = overrideSchema;
        else {
            const params = {
                ..._params,
                schemaPath: [
                    ..._params.schemaPath,
                    schema
                ],
                path: _params.path
            };
            const parent = schema._zod.parent;
            if (parent) {
                // schema was cloned from another schema
                result.ref = parent;
                this.process(parent, params);
                this.seen.get(parent).isParent = true;
            } else {
                const _json = result.schema;
                switch(def.type){
                    case "string":
                        {
                            const json = _json;
                            json.type = "string";
                            const { minimum: minimum, maximum: maximum, format: format, patterns: patterns, contentEncoding: contentEncoding } = schema._zod.bag;
                            if (typeof minimum === "number") json.minLength = minimum;
                            if (typeof maximum === "number") json.maxLength = maximum;
                            // custom pattern overrides format
                            if (format) {
                                json.format = formatMap[format] ?? format;
                                if (json.format === "") delete json.format; // empty format is not valid
                            }
                            if (contentEncoding) json.contentEncoding = contentEncoding;
                            if (patterns && patterns.size > 0) {
                                const regexes = [
                                    ...patterns
                                ];
                                if (regexes.length === 1) json.pattern = regexes[0].source;
                                else if (regexes.length > 1) result.schema.allOf = [
                                    ...regexes.map((regex)=>({
                                            ...this.target === "draft-7" || this.target === "draft-4" || this.target === "openapi-3.0" ? {
                                                type: "string"
                                            } : {},
                                            pattern: regex.source
                                        }))
                                ];
                            }
                            break;
                        }
                    case "number":
                        {
                            const json = _json;
                            const { minimum: minimum, maximum: maximum, format: format, multipleOf: multipleOf, exclusiveMaximum: exclusiveMaximum, exclusiveMinimum: exclusiveMinimum } = schema._zod.bag;
                            if (typeof format === "string" && format.includes("int")) json.type = "integer";
                            else json.type = "number";
                            if (typeof exclusiveMinimum === "number") {
                                if (this.target === "draft-4" || this.target === "openapi-3.0") {
                                    json.minimum = exclusiveMinimum;
                                    json.exclusiveMinimum = true;
                                } else json.exclusiveMinimum = exclusiveMinimum;
                            }
                            if (typeof minimum === "number") {
                                json.minimum = minimum;
                                if (typeof exclusiveMinimum === "number" && this.target !== "draft-4") {
                                    if (exclusiveMinimum >= minimum) delete json.minimum;
                                    else delete json.exclusiveMinimum;
                                }
                            }
                            if (typeof exclusiveMaximum === "number") {
                                if (this.target === "draft-4" || this.target === "openapi-3.0") {
                                    json.maximum = exclusiveMaximum;
                                    json.exclusiveMaximum = true;
                                } else json.exclusiveMaximum = exclusiveMaximum;
                            }
                            if (typeof maximum === "number") {
                                json.maximum = maximum;
                                if (typeof exclusiveMaximum === "number" && this.target !== "draft-4") {
                                    if (exclusiveMaximum <= maximum) delete json.maximum;
                                    else delete json.exclusiveMaximum;
                                }
                            }
                            if (typeof multipleOf === "number") json.multipleOf = multipleOf;
                            break;
                        }
                    case "boolean":
                        {
                            const json = _json;
                            json.type = "boolean";
                            break;
                        }
                    case "bigint":
                        if (this.unrepresentable === "throw") throw new Error("BigInt cannot be represented in JSON Schema");
                        break;
                    case "symbol":
                        if (this.unrepresentable === "throw") throw new Error("Symbols cannot be represented in JSON Schema");
                        break;
                    case "null":
                        if (this.target === "openapi-3.0") {
                            _json.type = "string";
                            _json.nullable = true;
                            _json.enum = [
                                null
                            ];
                        } else _json.type = "null";
                        break;
                    case "any":
                        break;
                    case "unknown":
                        break;
                    case "undefined":
                        if (this.unrepresentable === "throw") throw new Error("Undefined cannot be represented in JSON Schema");
                        break;
                    case "void":
                        if (this.unrepresentable === "throw") throw new Error("Void cannot be represented in JSON Schema");
                        break;
                    case "never":
                        _json.not = {};
                        break;
                    case "date":
                        if (this.unrepresentable === "throw") throw new Error("Date cannot be represented in JSON Schema");
                        break;
                    case "array":
                        {
                            const json = _json;
                            const { minimum: minimum, maximum: maximum } = schema._zod.bag;
                            if (typeof minimum === "number") json.minItems = minimum;
                            if (typeof maximum === "number") json.maxItems = maximum;
                            json.type = "array";
                            json.items = this.process(def.element, {
                                ...params,
                                path: [
                                    ...params.path,
                                    "items"
                                ]
                            });
                            break;
                        }
                    case "object":
                        {
                            const json = _json;
                            json.type = "object";
                            json.properties = {};
                            const shape = def.shape; // params.shapeCache.get(schema)!;
                            for(const key in shape)json.properties[key] = this.process(shape[key], {
                                ...params,
                                path: [
                                    ...params.path,
                                    "properties",
                                    key
                                ]
                            });
                            // required keys
                            const allKeys = new Set(Object.keys(shape));
                            // const optionalKeys = new Set(def.optional);
                            const requiredKeys = new Set([
                                ...allKeys
                            ].filter((key)=>{
                                const v = def.shape[key]._zod;
                                if (this.io === "input") return v.optin === undefined;
                                else return v.optout === undefined;
                            }));
                            if (requiredKeys.size > 0) json.required = Array.from(requiredKeys);
                            // catchall
                            if (def.catchall?._zod.def.type === "never") // strict
                            json.additionalProperties = false;
                            else if (!def.catchall) // regular
                            {
                                if (this.io === "output") json.additionalProperties = false;
                            } else if (def.catchall) json.additionalProperties = this.process(def.catchall, {
                                ...params,
                                path: [
                                    ...params.path,
                                    "additionalProperties"
                                ]
                            });
                            break;
                        }
                    case "union":
                        {
                            const json = _json;
                            // Discriminated unions use oneOf (exactly one match) instead of anyOf (one or more matches)
                            // because the discriminator field ensures mutual exclusivity between options in JSON Schema
                            const isDiscriminated = def.discriminator !== undefined;
                            const options = def.options.map((x, i)=>this.process(x, {
                                    ...params,
                                    path: [
                                        ...params.path,
                                        isDiscriminated ? "oneOf" : "anyOf",
                                        i
                                    ]
                                }));
                            if (isDiscriminated) json.oneOf = options;
                            else json.anyOf = options;
                            break;
                        }
                    case "intersection":
                        {
                            const json = _json;
                            const a = this.process(def.left, {
                                ...params,
                                path: [
                                    ...params.path,
                                    "allOf",
                                    0
                                ]
                            });
                            const b = this.process(def.right, {
                                ...params,
                                path: [
                                    ...params.path,
                                    "allOf",
                                    1
                                ]
                            });
                            const isSimpleIntersection = (val)=>"allOf" in val && Object.keys(val).length === 1;
                            const allOf = [
                                ...isSimpleIntersection(a) ? a.allOf : [
                                    a
                                ],
                                ...isSimpleIntersection(b) ? b.allOf : [
                                    b
                                ]
                            ];
                            json.allOf = allOf;
                            break;
                        }
                    case "tuple":
                        {
                            const json = _json;
                            json.type = "array";
                            const prefixPath = this.target === "draft-2020-12" ? "prefixItems" : "items";
                            const restPath = this.target === "draft-2020-12" ? "items" : this.target === "openapi-3.0" ? "items" : "additionalItems";
                            const prefixItems = def.items.map((x, i)=>this.process(x, {
                                    ...params,
                                    path: [
                                        ...params.path,
                                        prefixPath,
                                        i
                                    ]
                                }));
                            const rest = def.rest ? this.process(def.rest, {
                                ...params,
                                path: [
                                    ...params.path,
                                    restPath,
                                    ...this.target === "openapi-3.0" ? [
                                        def.items.length
                                    ] : []
                                ]
                            }) : null;
                            if (this.target === "draft-2020-12") {
                                json.prefixItems = prefixItems;
                                if (rest) json.items = rest;
                            } else if (this.target === "openapi-3.0") {
                                json.items = {
                                    anyOf: prefixItems
                                };
                                if (rest) json.items.anyOf.push(rest);
                                json.minItems = prefixItems.length;
                                if (!rest) json.maxItems = prefixItems.length;
                            } else {
                                json.items = prefixItems;
                                if (rest) json.additionalItems = rest;
                            }
                            // length
                            const { minimum: minimum, maximum: maximum } = schema._zod.bag;
                            if (typeof minimum === "number") json.minItems = minimum;
                            if (typeof maximum === "number") json.maxItems = maximum;
                            break;
                        }
                    case "record":
                        {
                            const json = _json;
                            json.type = "object";
                            if (this.target === "draft-7" || this.target === "draft-2020-12") json.propertyNames = this.process(def.keyType, {
                                ...params,
                                path: [
                                    ...params.path,
                                    "propertyNames"
                                ]
                            });
                            json.additionalProperties = this.process(def.valueType, {
                                ...params,
                                path: [
                                    ...params.path,
                                    "additionalProperties"
                                ]
                            });
                            break;
                        }
                    case "map":
                        if (this.unrepresentable === "throw") throw new Error("Map cannot be represented in JSON Schema");
                        break;
                    case "set":
                        if (this.unrepresentable === "throw") throw new Error("Set cannot be represented in JSON Schema");
                        break;
                    case "enum":
                        {
                            const json = _json;
                            const values = (0, $8f5391358ccbeba2$export$70a5d58ec00f3c11)(def.entries);
                            // Number enums can have both string and number values
                            if (values.every((v)=>typeof v === "number")) json.type = "number";
                            if (values.every((v)=>typeof v === "string")) json.type = "string";
                            json.enum = values;
                            break;
                        }
                    case "literal":
                        {
                            const json = _json;
                            const vals = [];
                            for (const val of def.values){
                                if (val === undefined) {
                                    if (this.unrepresentable === "throw") throw new Error("Literal `undefined` cannot be represented in JSON Schema");
                                } else if (typeof val === "bigint") {
                                    if (this.unrepresentable === "throw") throw new Error("BigInt literals cannot be represented in JSON Schema");
                                    else vals.push(Number(val));
                                } else vals.push(val);
                            }
                            if (vals.length === 0) ;
                            else if (vals.length === 1) {
                                const val = vals[0];
                                json.type = val === null ? "null" : typeof val;
                                if (this.target === "draft-4" || this.target === "openapi-3.0") json.enum = [
                                    val
                                ];
                                else json.const = val;
                            } else {
                                if (vals.every((v)=>typeof v === "number")) json.type = "number";
                                if (vals.every((v)=>typeof v === "string")) json.type = "string";
                                if (vals.every((v)=>typeof v === "boolean")) json.type = "string";
                                if (vals.every((v)=>v === null)) json.type = "null";
                                json.enum = vals;
                            }
                            break;
                        }
                    case "file":
                        {
                            const json = _json;
                            const file = {
                                type: "string",
                                format: "binary",
                                contentEncoding: "binary"
                            };
                            const { minimum: minimum, maximum: maximum, mime: mime } = schema._zod.bag;
                            if (minimum !== undefined) file.minLength = minimum;
                            if (maximum !== undefined) file.maxLength = maximum;
                            if (mime) {
                                if (mime.length === 1) {
                                    file.contentMediaType = mime[0];
                                    Object.assign(json, file);
                                } else json.anyOf = mime.map((m)=>{
                                    const mFile = {
                                        ...file,
                                        contentMediaType: m
                                    };
                                    return mFile;
                                });
                            } else Object.assign(json, file);
                            break;
                        }
                    case "transform":
                        if (this.unrepresentable === "throw") throw new Error("Transforms cannot be represented in JSON Schema");
                        break;
                    case "nullable":
                        {
                            const inner = this.process(def.innerType, params);
                            if (this.target === "openapi-3.0") {
                                result.ref = def.innerType;
                                _json.nullable = true;
                            } else _json.anyOf = [
                                inner,
                                {
                                    type: "null"
                                }
                            ];
                            break;
                        }
                    case "nonoptional":
                        this.process(def.innerType, params);
                        result.ref = def.innerType;
                        break;
                    case "success":
                        {
                            const json = _json;
                            json.type = "boolean";
                            break;
                        }
                    case "default":
                        this.process(def.innerType, params);
                        result.ref = def.innerType;
                        _json.default = JSON.parse(JSON.stringify(def.defaultValue));
                        break;
                    case "prefault":
                        this.process(def.innerType, params);
                        result.ref = def.innerType;
                        if (this.io === "input") _json._prefault = JSON.parse(JSON.stringify(def.defaultValue));
                        break;
                    case "catch":
                        {
                            // use conditionals
                            this.process(def.innerType, params);
                            result.ref = def.innerType;
                            let catchValue;
                            try {
                                catchValue = def.catchValue(undefined);
                            } catch  {
                                throw new Error("Dynamic catch values are not supported in JSON Schema");
                            }
                            _json.default = catchValue;
                            break;
                        }
                    case "nan":
                        if (this.unrepresentable === "throw") throw new Error("NaN cannot be represented in JSON Schema");
                        break;
                    case "template_literal":
                        {
                            const json = _json;
                            const pattern = schema._zod.pattern;
                            if (!pattern) throw new Error("Pattern not found in template literal");
                            json.type = "string";
                            json.pattern = pattern.source;
                            break;
                        }
                    case "pipe":
                        {
                            const innerType = this.io === "input" ? def.in._zod.def.type === "transform" ? def.out : def.in : def.out;
                            this.process(innerType, params);
                            result.ref = innerType;
                            break;
                        }
                    case "readonly":
                        this.process(def.innerType, params);
                        result.ref = def.innerType;
                        _json.readOnly = true;
                        break;
                    // passthrough types
                    case "promise":
                        this.process(def.innerType, params);
                        result.ref = def.innerType;
                        break;
                    case "optional":
                        this.process(def.innerType, params);
                        result.ref = def.innerType;
                        break;
                    case "lazy":
                        {
                            const innerType = schema._zod.innerType;
                            this.process(innerType, params);
                            result.ref = innerType;
                            break;
                        }
                    case "custom":
                        if (this.unrepresentable === "throw") throw new Error("Custom types cannot be represented in JSON Schema");
                        break;
                    case "function":
                        if (this.unrepresentable === "throw") throw new Error("Function types cannot be represented in JSON Schema");
                        break;
                    default:
                        def;
                }
            }
        }
        // metadata
        const meta = this.metadataRegistry.get(schema);
        if (meta) Object.assign(result.schema, meta);
        if (this.io === "input" && $16e71a39bb8f69ca$var$isTransforming(schema)) {
            // examples/defaults only apply to output type of pipe
            delete result.schema.examples;
            delete result.schema.default;
        }
        // set prefault as default
        if (this.io === "input" && result.schema._prefault) (_a = result.schema).default ?? (_a.default = result.schema._prefault);
        delete result.schema._prefault;
        // pulling fresh from this.seen in case it was overwritten
        const _result = this.seen.get(schema);
        return _result.schema;
    }
    emit(schema, _params) {
        const params = {
            cycles: _params?.cycles ?? "ref",
            reused: _params?.reused ?? "inline",
            // unrepresentable: _params?.unrepresentable ?? "throw",
            // uri: _params?.uri ?? ((id) => `${id}`),
            external: _params?.external ?? undefined
        };
        // iterate over seen map;
        const root = this.seen.get(schema);
        if (!root) throw new Error("Unprocessed schema. This is a bug in Zod.");
        // initialize result with root schema fields
        // Object.assign(result, seen.cached);
        // returns a ref to the schema
        // defId will be empty if the ref points to an external schema (or #)
        const makeURI = (entry)=>{
            // comparing the seen objects because sometimes
            // multiple schemas map to the same seen object.
            // e.g. lazy
            // external is configured
            const defsSegment = this.target === "draft-2020-12" ? "$defs" : "definitions";
            if (params.external) {
                const externalId = params.external.registry.get(entry[0])?.id; // ?? "__shared";// `__schema${this.counter++}`;
                // check if schema is in the external registry
                const uriGenerator = params.external.uri ?? ((id)=>id);
                if (externalId) return {
                    ref: uriGenerator(externalId)
                };
                // otherwise, add to __shared
                const id = entry[1].defId ?? entry[1].schema.id ?? `schema${this.counter++}`;
                entry[1].defId = id; // set defId so it will be reused if needed
                return {
                    defId: id,
                    ref: `${uriGenerator("__shared")}#/${defsSegment}/${id}`
                };
            }
            if (entry[1] === root) return {
                ref: "#"
            };
            // self-contained schema
            const uriPrefix = `#`;
            const defUriPrefix = `${uriPrefix}/${defsSegment}/`;
            const defId = entry[1].schema.id ?? `__schema${this.counter++}`;
            return {
                defId: defId,
                ref: defUriPrefix + defId
            };
        };
        // stored cached version in `def` property
        // remove all properties, set $ref
        const extractToDef = (entry)=>{
            // if the schema is already a reference, do not extract it
            if (entry[1].schema.$ref) return;
            const seen = entry[1];
            const { ref: ref, defId: defId } = makeURI(entry);
            seen.def = {
                ...seen.schema
            };
            // defId won't be set if the schema is a reference to an external schema
            if (defId) seen.defId = defId;
            // wipe away all properties except $ref
            const schema = seen.schema;
            for(const key in schema)delete schema[key];
            schema.$ref = ref;
        };
        // throw on cycles
        // break cycles
        if (params.cycles === "throw") for (const entry of this.seen.entries()){
            const seen = entry[1];
            if (seen.cycle) throw new Error("Cycle detected: " + `#/${seen.cycle?.join("/")}/<root>` + '\n\nSet the `cycles` parameter to `"ref"` to resolve cyclical schemas with defs.');
        }
        // extract schemas into $defs
        for (const entry of this.seen.entries()){
            const seen = entry[1];
            // convert root schema to # $ref
            if (schema === entry[0]) {
                extractToDef(entry); // this has special handling for the root schema
                continue;
            }
            // extract schemas that are in the external registry
            if (params.external) {
                const ext = params.external.registry.get(entry[0])?.id;
                if (schema !== entry[0] && ext) {
                    extractToDef(entry);
                    continue;
                }
            }
            // extract schemas with `id` meta
            const id = this.metadataRegistry.get(entry[0])?.id;
            if (id) {
                extractToDef(entry);
                continue;
            }
            // break cycles
            if (seen.cycle) {
                // any
                extractToDef(entry);
                continue;
            }
            // extract reused schemas
            if (seen.count > 1) {
                if (params.reused === "ref") {
                    extractToDef(entry);
                    continue;
                }
            }
        }
        // flatten _refs
        const flattenRef = (zodSchema, params)=>{
            const seen = this.seen.get(zodSchema);
            const schema = seen.def ?? seen.schema;
            const _cached = {
                ...schema
            };
            // already seen
            if (seen.ref === null) return;
            // flatten ref if defined
            const ref = seen.ref;
            seen.ref = null; // prevent recursion
            if (ref) {
                flattenRef(ref, params);
                // merge referenced schema into current
                const refSchema = this.seen.get(ref).schema;
                if (refSchema.$ref && (params.target === "draft-7" || params.target === "draft-4" || params.target === "openapi-3.0")) {
                    schema.allOf = schema.allOf ?? [];
                    schema.allOf.push(refSchema);
                } else {
                    Object.assign(schema, refSchema);
                    Object.assign(schema, _cached); // prevent overwriting any fields in the original schema
                }
            }
            // execute overrides
            if (!seen.isParent) this.override({
                zodSchema: zodSchema,
                jsonSchema: schema,
                path: seen.path ?? []
            });
        };
        for (const entry of [
            ...this.seen.entries()
        ].reverse())flattenRef(entry[0], {
            target: this.target
        });
        const result = {};
        if (this.target === "draft-2020-12") result.$schema = "https://json-schema.org/draft/2020-12/schema";
        else if (this.target === "draft-7") result.$schema = "http://json-schema.org/draft-07/schema#";
        else if (this.target === "draft-4") result.$schema = "http://json-schema.org/draft-04/schema#";
        else if (this.target === "openapi-3.0") ;
        else // @ts-ignore
        console.warn(`Invalid target: ${this.target}`);
        if (params.external?.uri) {
            const id = params.external.registry.get(schema)?.id;
            if (!id) throw new Error("Schema is missing an `id` property");
            result.$id = params.external.uri(id);
        }
        Object.assign(result, root.def);
        // build defs object
        const defs = params.external?.defs ?? {};
        for (const entry of this.seen.entries()){
            const seen = entry[1];
            if (seen.def && seen.defId) defs[seen.defId] = seen.def;
        }
        // set definitions in result
        if (params.external) ;
        else if (Object.keys(defs).length > 0) {
            if (this.target === "draft-2020-12") result.$defs = defs;
            else result.definitions = defs;
        }
        try {
            // this "finalizes" this schema and ensures all cycles are removed
            // each call to .emit() is functionally independent
            // though the seen map is shared
            return JSON.parse(JSON.stringify(result));
        } catch (_err) {
            throw new Error("Error converting schema to JSON.");
        }
    }
}
function $16e71a39bb8f69ca$export$395d8e19463d4f49(input, _params) {
    if (input instanceof (0, $3cec3829b03c3a57$export$dc03955eec152cc5)) {
        const gen = new $16e71a39bb8f69ca$export$1b2196b107de679(_params);
        const defs = {};
        for (const entry of input._idmap.entries()){
            const [_, schema] = entry;
            gen.process(schema);
        }
        const schemas = {};
        const external = {
            registry: input,
            uri: _params?.uri,
            defs: defs
        };
        for (const entry of input._idmap.entries()){
            const [key, schema] = entry;
            schemas[key] = gen.emit(schema, {
                ..._params,
                external: external
            });
        }
        if (Object.keys(defs).length > 0) {
            const defsSegment = gen.target === "draft-2020-12" ? "$defs" : "definitions";
            schemas.__shared = {
                [defsSegment]: defs
            };
        }
        return {
            schemas: schemas
        };
    }
    const gen = new $16e71a39bb8f69ca$export$1b2196b107de679(_params);
    gen.process(input);
    return gen.emit(input, _params);
}
function $16e71a39bb8f69ca$var$isTransforming(_schema, _ctx) {
    const ctx = _ctx ?? {
        seen: new Set()
    };
    if (ctx.seen.has(_schema)) return false;
    ctx.seen.add(_schema);
    const def = _schema._zod.def;
    if (def.type === "transform") return true;
    if (def.type === "array") return $16e71a39bb8f69ca$var$isTransforming(def.element, ctx);
    if (def.type === "set") return $16e71a39bb8f69ca$var$isTransforming(def.valueType, ctx);
    if (def.type === "lazy") return $16e71a39bb8f69ca$var$isTransforming(def.getter(), ctx);
    if (def.type === "promise" || def.type === "optional" || def.type === "nonoptional" || def.type === "nullable" || def.type === "readonly" || def.type === "default" || def.type === "prefault") return $16e71a39bb8f69ca$var$isTransforming(def.innerType, ctx);
    if (def.type === "intersection") return $16e71a39bb8f69ca$var$isTransforming(def.left, ctx) || $16e71a39bb8f69ca$var$isTransforming(def.right, ctx);
    if (def.type === "record" || def.type === "map") return $16e71a39bb8f69ca$var$isTransforming(def.keyType, ctx) || $16e71a39bb8f69ca$var$isTransforming(def.valueType, ctx);
    if (def.type === "pipe") return $16e71a39bb8f69ca$var$isTransforming(def.in, ctx) || $16e71a39bb8f69ca$var$isTransforming(def.out, ctx);
    if (def.type === "object") {
        for(const key in def.shape){
            if ($16e71a39bb8f69ca$var$isTransforming(def.shape[key], ctx)) return true;
        }
        return false;
    }
    if (def.type === "union") {
        for (const option of def.options){
            if ($16e71a39bb8f69ca$var$isTransforming(option, ctx)) return true;
        }
        return false;
    }
    if (def.type === "tuple") {
        for (const item of def.items){
            if ($16e71a39bb8f69ca$var$isTransforming(item, ctx)) return true;
        }
        if (def.rest && $16e71a39bb8f69ca$var$isTransforming(def.rest, ctx)) return true;
        return false;
    }
    return false;
}












const $db2fa429698c3f4b$export$8ceba53cbe6a272e = /*@__PURE__*/ $d4d51e3b5652b8a4$export$3122533d606194de("ZodISODateTime", (inst, def)=>{
    $38bc36f53cb4eb10$export$3273e4d2df37774b.init(inst, def);
    $ec141028f9f6a3fe$export$6f00fc81f4be18e5.init(inst, def);
});
function $db2fa429698c3f4b$export$7ba4466dbd0f07e1(params) {
    return $d7427071dbf0b4e9$export$a62adeb27809351b($db2fa429698c3f4b$export$8ceba53cbe6a272e, params);
}
const $db2fa429698c3f4b$export$e7f25b469dafa5ec = /*@__PURE__*/ $d4d51e3b5652b8a4$export$3122533d606194de("ZodISODate", (inst, def)=>{
    $38bc36f53cb4eb10$export$75b9bf98f4d806dc.init(inst, def);
    $ec141028f9f6a3fe$export$6f00fc81f4be18e5.init(inst, def);
});
function $db2fa429698c3f4b$export$324d90190a8b822a(params) {
    return $d7427071dbf0b4e9$export$e4f19dd0a54e7a59($db2fa429698c3f4b$export$e7f25b469dafa5ec, params);
}
const $db2fa429698c3f4b$export$ee190fc7c4074018 = /*@__PURE__*/ $d4d51e3b5652b8a4$export$3122533d606194de("ZodISOTime", (inst, def)=>{
    $38bc36f53cb4eb10$export$e9b9c3c2359a3ebc.init(inst, def);
    $ec141028f9f6a3fe$export$6f00fc81f4be18e5.init(inst, def);
});
function $db2fa429698c3f4b$export$2da9be4cfdb689b1(params) {
    return $d7427071dbf0b4e9$export$36f9f051d5e817c($db2fa429698c3f4b$export$ee190fc7c4074018, params);
}
const $db2fa429698c3f4b$export$164bac5916a0e7e9 = /*@__PURE__*/ $d4d51e3b5652b8a4$export$3122533d606194de("ZodISODuration", (inst, def)=>{
    $38bc36f53cb4eb10$export$d9e850ab18e4b22e.init(inst, def);
    $ec141028f9f6a3fe$export$6f00fc81f4be18e5.init(inst, def);
});
function $db2fa429698c3f4b$export$1f34108aa9eb96ab(params) {
    return $d7427071dbf0b4e9$export$7d70539c76fbff4($db2fa429698c3f4b$export$164bac5916a0e7e9, params);
}





const $8e1152a3310e250e$var$initializer = (inst, issues)=>{
    (0, $cfe0667fefc5f30b$export$544878318730b1d8).init(inst, issues);
    inst.name = "ZodError";
    Object.defineProperties(inst, {
        format: {
            value: (mapper)=>$cfe0667fefc5f30b$export$7b5b869ee98c16ab(inst, mapper)
        },
        flatten: {
            value: (mapper)=>$cfe0667fefc5f30b$export$4d7e0dfd5ca8366f(inst, mapper)
        },
        addIssue: {
            value: (issue)=>{
                inst.issues.push(issue);
                inst.message = JSON.stringify(inst.issues, $8f5391358ccbeba2$export$f4defb13cab882b2, 2);
            }
        },
        addIssues: {
            value: (issues)=>{
                inst.issues.push(...issues);
                inst.message = JSON.stringify(inst.issues, $8f5391358ccbeba2$export$f4defb13cab882b2, 2);
            }
        },
        isEmpty: {
            get () {
                return inst.issues.length === 0;
            }
        }
    });
// Object.defineProperty(inst, "isEmpty", {
//   get() {
//     return inst.issues.length === 0;
//   },
// });
};
const $8e1152a3310e250e$export$f98dac4b251ab333 = $d4d51e3b5652b8a4$export$3122533d606194de("ZodError", $8e1152a3310e250e$var$initializer);
const $8e1152a3310e250e$export$42f76a3b4eb5449a = $d4d51e3b5652b8a4$export$3122533d606194de("ZodError", $8e1152a3310e250e$var$initializer, {
    Parent: Error
}); // /** @deprecated Use `z.core.$ZodErrorMapCtx` instead. */
 // export type ErrorMapCtx = core.$ZodErrorMapCtx;


const $f3a43778cf11e5e5$export$98e6a39c04603d36 = /* @__PURE__ */ $65d57763ab0754f3$export$dcd1bb9991b57edf((0, $8e1152a3310e250e$export$42f76a3b4eb5449a));
const $f3a43778cf11e5e5$export$59b6f938fbf579e3 = /* @__PURE__ */ $65d57763ab0754f3$export$1fcca22dc6c780d0((0, $8e1152a3310e250e$export$42f76a3b4eb5449a));
const $f3a43778cf11e5e5$export$b48ee232557adc37 = /* @__PURE__ */ $65d57763ab0754f3$export$5ec32605bf51e98e((0, $8e1152a3310e250e$export$42f76a3b4eb5449a));
const $f3a43778cf11e5e5$export$9b07b0d6e0389261 = /* @__PURE__ */ $65d57763ab0754f3$export$c08c7322f5625faf((0, $8e1152a3310e250e$export$42f76a3b4eb5449a));
const $f3a43778cf11e5e5$export$c564cdbbe6da493 = /* @__PURE__ */ $65d57763ab0754f3$export$50e4445ccc10715b((0, $8e1152a3310e250e$export$42f76a3b4eb5449a));
const $f3a43778cf11e5e5$export$2f872c0f2117be69 = /* @__PURE__ */ $65d57763ab0754f3$export$bb4a21772f43c982((0, $8e1152a3310e250e$export$42f76a3b4eb5449a));
const $f3a43778cf11e5e5$export$1a62660bbffb8f11 = /* @__PURE__ */ $65d57763ab0754f3$export$9954740a1a5eaaf1((0, $8e1152a3310e250e$export$42f76a3b4eb5449a));
const $f3a43778cf11e5e5$export$e4c183687a6ff9b = /* @__PURE__ */ $65d57763ab0754f3$export$74b09e12c8956d91((0, $8e1152a3310e250e$export$42f76a3b4eb5449a));
const $f3a43778cf11e5e5$export$c094f85f253e4d7d = /* @__PURE__ */ $65d57763ab0754f3$export$6d688d774257f486((0, $8e1152a3310e250e$export$42f76a3b4eb5449a));
const $f3a43778cf11e5e5$export$7a47376c130cfeac = /* @__PURE__ */ $65d57763ab0754f3$export$b2ef531a734faad5((0, $8e1152a3310e250e$export$42f76a3b4eb5449a));
const $f3a43778cf11e5e5$export$ed163a34170fecc5 = /* @__PURE__ */ $65d57763ab0754f3$export$fa2ac180d22758d6((0, $8e1152a3310e250e$export$42f76a3b4eb5449a));
const $f3a43778cf11e5e5$export$9f879005292a9bc9 = /* @__PURE__ */ $65d57763ab0754f3$export$f66d2b402dc6318c((0, $8e1152a3310e250e$export$42f76a3b4eb5449a));


const $ec141028f9f6a3fe$export$2afb8ab49d4b92c0 = /*@__PURE__*/ $d4d51e3b5652b8a4$export$3122533d606194de("ZodType", (inst, def)=>{
    $38bc36f53cb4eb10$export$f43a5c3966de8238.init(inst, def);
    inst.def = def;
    inst.type = def.type;
    Object.defineProperty(inst, "_def", {
        value: def
    });
    // base methods
    inst.check = (...checks)=>{
        return inst.clone((0, $8f5391358ccbeba2$exports).mergeDefs(def, {
            checks: [
                ...def.checks ?? [],
                ...checks.map((ch)=>typeof ch === "function" ? {
                        _zod: {
                            check: ch,
                            def: {
                                check: "custom"
                            },
                            onattach: []
                        }
                    } : ch)
            ]
        }));
    };
    inst.clone = (def, params)=>$8f5391358ccbeba2$export$9cd59f9826255e47(inst, def, params);
    inst.brand = ()=>inst;
    inst.register = (reg, meta)=>{
        reg.add(inst, meta);
        return inst;
    };
    // parsing
    inst.parse = (data, params)=>$f3a43778cf11e5e5$export$98e6a39c04603d36(inst, data, params, {
            callee: inst.parse
        });
    inst.safeParse = (data, params)=>$f3a43778cf11e5e5$export$b48ee232557adc37(inst, data, params);
    inst.parseAsync = async (data, params)=>$f3a43778cf11e5e5$export$59b6f938fbf579e3(inst, data, params, {
            callee: inst.parseAsync
        });
    inst.safeParseAsync = async (data, params)=>$f3a43778cf11e5e5$export$9b07b0d6e0389261(inst, data, params);
    inst.spa = inst.safeParseAsync;
    // encoding/decoding
    inst.encode = (data, params)=>$f3a43778cf11e5e5$export$c564cdbbe6da493(inst, data, params);
    inst.decode = (data, params)=>$f3a43778cf11e5e5$export$2f872c0f2117be69(inst, data, params);
    inst.encodeAsync = async (data, params)=>$f3a43778cf11e5e5$export$1a62660bbffb8f11(inst, data, params);
    inst.decodeAsync = async (data, params)=>$f3a43778cf11e5e5$export$e4c183687a6ff9b(inst, data, params);
    inst.safeEncode = (data, params)=>$f3a43778cf11e5e5$export$c094f85f253e4d7d(inst, data, params);
    inst.safeDecode = (data, params)=>$f3a43778cf11e5e5$export$7a47376c130cfeac(inst, data, params);
    inst.safeEncodeAsync = async (data, params)=>$f3a43778cf11e5e5$export$ed163a34170fecc5(inst, data, params);
    inst.safeDecodeAsync = async (data, params)=>$f3a43778cf11e5e5$export$9f879005292a9bc9(inst, data, params);
    // refinements
    inst.refine = (check, params)=>inst.check($ec141028f9f6a3fe$export$edc9d475108b3212(check, params));
    inst.superRefine = (refinement)=>inst.check($ec141028f9f6a3fe$export$e0f31df04c32a6bf(refinement));
    inst.overwrite = (fn)=>inst.check($d7427071dbf0b4e9$export$aeea8f004f34f8c2(fn));
    // wrappers
    inst.optional = ()=>$ec141028f9f6a3fe$export$516e28dec6a4b6d4(inst);
    inst.nullable = ()=>$ec141028f9f6a3fe$export$133fc36489ac9add(inst);
    inst.nullish = ()=>$ec141028f9f6a3fe$export$516e28dec6a4b6d4($ec141028f9f6a3fe$export$133fc36489ac9add(inst));
    inst.nonoptional = (params)=>$ec141028f9f6a3fe$export$e6aa51fdda6cd70d(inst, params);
    inst.array = ()=>$ec141028f9f6a3fe$export$2f23118c22fb2630(inst);
    inst.or = (arg)=>$ec141028f9f6a3fe$export$971dd5b0dfd021b6([
            inst,
            arg
        ]);
    inst.and = (arg)=>$ec141028f9f6a3fe$export$bc86dfbf7795668c(inst, arg);
    inst.transform = (tx)=>$ec141028f9f6a3fe$export$a4627e546088548d(inst, $ec141028f9f6a3fe$export$51186ad6e864892a(tx));
    inst.default = (def)=>$ec141028f9f6a3fe$export$d4b0f68d0d916971(inst, def);
    inst.prefault = (def)=>$ec141028f9f6a3fe$export$569da376ae266d0a(inst, def);
    // inst.coalesce = (def, params) => coalesce(inst, def, params);
    inst.catch = (params)=>$ec141028f9f6a3fe$export$e1d4808a6ac94c4c(inst, params);
    inst.pipe = (target)=>$ec141028f9f6a3fe$export$a4627e546088548d(inst, target);
    inst.readonly = ()=>$ec141028f9f6a3fe$export$6ec456bd5b7b3c51(inst);
    // meta
    inst.describe = (description)=>{
        const cl = inst.clone();
        $3cec3829b03c3a57$export$bc58ce2776ecdb6f.add(cl, {
            description: description
        });
        return cl;
    };
    Object.defineProperty(inst, "description", {
        get () {
            return $3cec3829b03c3a57$export$bc58ce2776ecdb6f.get(inst)?.description;
        },
        configurable: true
    });
    inst.meta = (...args)=>{
        if (args.length === 0) return $3cec3829b03c3a57$export$bc58ce2776ecdb6f.get(inst);
        const cl = inst.clone();
        $3cec3829b03c3a57$export$bc58ce2776ecdb6f.add(cl, args[0]);
        return cl;
    };
    // helpers
    inst.isOptional = ()=>inst.safeParse(undefined).success;
    inst.isNullable = ()=>inst.safeParse(null).success;
    return inst;
});
const $ec141028f9f6a3fe$export$f6d83ce3dacef2be = /*@__PURE__*/ $d4d51e3b5652b8a4$export$3122533d606194de("_ZodString", (inst, def)=>{
    $38bc36f53cb4eb10$export$4342b4432d7b1471.init(inst, def);
    $ec141028f9f6a3fe$export$2afb8ab49d4b92c0.init(inst, def);
    const bag = inst._zod.bag;
    inst.format = bag.format ?? null;
    inst.minLength = bag.minimum ?? null;
    inst.maxLength = bag.maximum ?? null;
    // validations
    inst.regex = (...args)=>inst.check($d7427071dbf0b4e9$export$c4768a1bd8f8393(...args));
    inst.includes = (...args)=>inst.check($d7427071dbf0b4e9$export$fccf016a6caa651d(...args));
    inst.startsWith = (...args)=>inst.check($d7427071dbf0b4e9$export$2f37aaf99060de76(...args));
    inst.endsWith = (...args)=>inst.check($d7427071dbf0b4e9$export$eaeaa2fcd833167e(...args));
    inst.min = (...args)=>inst.check($d7427071dbf0b4e9$export$21f6711a906c1450(...args));
    inst.max = (...args)=>inst.check($d7427071dbf0b4e9$export$ec76627108655a22(...args));
    inst.length = (...args)=>inst.check($d7427071dbf0b4e9$export$620b9f7ab17ff8a9(...args));
    inst.nonempty = (...args)=>inst.check($d7427071dbf0b4e9$export$21f6711a906c1450(1, ...args));
    inst.lowercase = (params)=>inst.check($d7427071dbf0b4e9$export$ea67c3edeec85c63(params));
    inst.uppercase = (params)=>inst.check($d7427071dbf0b4e9$export$2998381b41c6902a(params));
    // transforms
    inst.trim = ()=>inst.check($d7427071dbf0b4e9$export$8be2de0b60774d1e());
    inst.normalize = (...args)=>inst.check($d7427071dbf0b4e9$export$2b99bb23a814f78e(...args));
    inst.toLowerCase = ()=>inst.check($d7427071dbf0b4e9$export$d9cfe939403a2525());
    inst.toUpperCase = ()=>inst.check($d7427071dbf0b4e9$export$cf76ef1ae9e9944e());
    inst.slugify = ()=>inst.check($d7427071dbf0b4e9$export$2801993b93f3c232());
});
const $ec141028f9f6a3fe$export$1230eb29b8d3b502 = /*@__PURE__*/ $d4d51e3b5652b8a4$export$3122533d606194de("ZodString", (inst, def)=>{
    $38bc36f53cb4eb10$export$4342b4432d7b1471.init(inst, def);
    $ec141028f9f6a3fe$export$f6d83ce3dacef2be.init(inst, def);
    inst.email = (params)=>inst.check($d7427071dbf0b4e9$export$471b39521bec3299($ec141028f9f6a3fe$export$770096fb2a685237, params));
    inst.url = (params)=>inst.check($d7427071dbf0b4e9$export$e3f203373341d39($ec141028f9f6a3fe$export$82127fa72e650526, params));
    inst.jwt = (params)=>inst.check($d7427071dbf0b4e9$export$4a9318e6b46f1aa1($ec141028f9f6a3fe$export$5c0d807bd77507f, params));
    inst.emoji = (params)=>inst.check($d7427071dbf0b4e9$export$936e26d261396f46($ec141028f9f6a3fe$export$f072c1a26a31d55b, params));
    inst.guid = (params)=>inst.check($d7427071dbf0b4e9$export$129b5399d64cccb0($ec141028f9f6a3fe$export$2827a6bad660427b, params));
    inst.uuid = (params)=>inst.check($d7427071dbf0b4e9$export$f2f3139038bea52c($ec141028f9f6a3fe$export$7ee22ce365e4d3b5, params));
    inst.uuidv4 = (params)=>inst.check($d7427071dbf0b4e9$export$a5559d7da37a112f($ec141028f9f6a3fe$export$7ee22ce365e4d3b5, params));
    inst.uuidv6 = (params)=>inst.check($d7427071dbf0b4e9$export$53b427a8173231a($ec141028f9f6a3fe$export$7ee22ce365e4d3b5, params));
    inst.uuidv7 = (params)=>inst.check($d7427071dbf0b4e9$export$588d23d6e9ec2ed5($ec141028f9f6a3fe$export$7ee22ce365e4d3b5, params));
    inst.nanoid = (params)=>inst.check($d7427071dbf0b4e9$export$a030949b19390ea0($ec141028f9f6a3fe$export$9e180e3f910c7773, params));
    inst.guid = (params)=>inst.check($d7427071dbf0b4e9$export$129b5399d64cccb0($ec141028f9f6a3fe$export$2827a6bad660427b, params));
    inst.cuid = (params)=>inst.check($d7427071dbf0b4e9$export$639125837b796148($ec141028f9f6a3fe$export$c6b7c3c30ab9362e, params));
    inst.cuid2 = (params)=>inst.check($d7427071dbf0b4e9$export$36b63ef9af7972c2($ec141028f9f6a3fe$export$536dc9ce9eec8565, params));
    inst.ulid = (params)=>inst.check($d7427071dbf0b4e9$export$95acf3b3fa11bdc9($ec141028f9f6a3fe$export$a060914fca5da3d4, params));
    inst.base64 = (params)=>inst.check($d7427071dbf0b4e9$export$9fdb09384fbc4988($ec141028f9f6a3fe$export$237b9f5cee85a1c1, params));
    inst.base64url = (params)=>inst.check($d7427071dbf0b4e9$export$178c70fb89c949fa($ec141028f9f6a3fe$export$62a2e9135a9e2356, params));
    inst.xid = (params)=>inst.check($d7427071dbf0b4e9$export$bbb0a2cfb079fa90($ec141028f9f6a3fe$export$d53bc3b8251fa017, params));
    inst.ksuid = (params)=>inst.check($d7427071dbf0b4e9$export$1306ede2f9ea153f($ec141028f9f6a3fe$export$1bbac5f87dca43e4, params));
    inst.ipv4 = (params)=>inst.check($d7427071dbf0b4e9$export$c77a1c80cebc2aad($ec141028f9f6a3fe$export$567930edb18e0c3a, params));
    inst.ipv6 = (params)=>inst.check($d7427071dbf0b4e9$export$964dfe0e2e4e8895($ec141028f9f6a3fe$export$75c5c5fd479ecddf, params));
    inst.cidrv4 = (params)=>inst.check($d7427071dbf0b4e9$export$feaac4e27a421ddc($ec141028f9f6a3fe$export$ac524bc9ec5fac50, params));
    inst.cidrv6 = (params)=>inst.check($d7427071dbf0b4e9$export$a0518ffc5273ec92($ec141028f9f6a3fe$export$b8cae7a616378f16, params));
    inst.e164 = (params)=>inst.check($d7427071dbf0b4e9$export$b8bf0b70d4bc7855($ec141028f9f6a3fe$export$fac79817565ec0f7, params));
    // iso
    inst.datetime = (params)=>inst.check($db2fa429698c3f4b$export$7ba4466dbd0f07e1(params));
    inst.date = (params)=>inst.check($db2fa429698c3f4b$export$324d90190a8b822a(params));
    inst.time = (params)=>inst.check($db2fa429698c3f4b$export$2da9be4cfdb689b1(params));
    inst.duration = (params)=>inst.check($db2fa429698c3f4b$export$1f34108aa9eb96ab(params));
});
function $ec141028f9f6a3fe$export$22b082955e083ec3(params) {
    return $d7427071dbf0b4e9$export$25986a84359f8f7f($ec141028f9f6a3fe$export$1230eb29b8d3b502, params);
}
const $ec141028f9f6a3fe$export$6f00fc81f4be18e5 = /*@__PURE__*/ $d4d51e3b5652b8a4$export$3122533d606194de("ZodStringFormat", (inst, def)=>{
    $38bc36f53cb4eb10$export$2d69a0d3057a5c7d.init(inst, def);
    $ec141028f9f6a3fe$export$f6d83ce3dacef2be.init(inst, def);
});
const $ec141028f9f6a3fe$export$770096fb2a685237 = /*@__PURE__*/ $d4d51e3b5652b8a4$export$3122533d606194de("ZodEmail", (inst, def)=>{
    // ZodStringFormat.init(inst, def);
    $38bc36f53cb4eb10$export$a3726aadb6108cdc.init(inst, def);
    $ec141028f9f6a3fe$export$6f00fc81f4be18e5.init(inst, def);
});
function $ec141028f9f6a3fe$export$d290fa47940df19d(params) {
    return $d7427071dbf0b4e9$export$471b39521bec3299($ec141028f9f6a3fe$export$770096fb2a685237, params);
}
const $ec141028f9f6a3fe$export$2827a6bad660427b = /*@__PURE__*/ $d4d51e3b5652b8a4$export$3122533d606194de("ZodGUID", (inst, def)=>{
    // ZodStringFormat.init(inst, def);
    $38bc36f53cb4eb10$export$4ca4397e3147da59.init(inst, def);
    $ec141028f9f6a3fe$export$6f00fc81f4be18e5.init(inst, def);
});
function $ec141028f9f6a3fe$export$46e8f25c7328f77e(params) {
    return $d7427071dbf0b4e9$export$129b5399d64cccb0($ec141028f9f6a3fe$export$2827a6bad660427b, params);
}
const $ec141028f9f6a3fe$export$7ee22ce365e4d3b5 = /*@__PURE__*/ $d4d51e3b5652b8a4$export$3122533d606194de("ZodUUID", (inst, def)=>{
    // ZodStringFormat.init(inst, def);
    $38bc36f53cb4eb10$export$8794aae384e3c177.init(inst, def);
    $ec141028f9f6a3fe$export$6f00fc81f4be18e5.init(inst, def);
});
function $ec141028f9f6a3fe$export$31b40729666a4ae0(params) {
    return $d7427071dbf0b4e9$export$f2f3139038bea52c($ec141028f9f6a3fe$export$7ee22ce365e4d3b5, params);
}
function $ec141028f9f6a3fe$export$abe4376e1bf796d6(params) {
    return $d7427071dbf0b4e9$export$a5559d7da37a112f($ec141028f9f6a3fe$export$7ee22ce365e4d3b5, params);
}
function $ec141028f9f6a3fe$export$b1fe4fcff87f98e5(params) {
    return $d7427071dbf0b4e9$export$53b427a8173231a($ec141028f9f6a3fe$export$7ee22ce365e4d3b5, params);
}
function $ec141028f9f6a3fe$export$a7b512db306b38d7(params) {
    return $d7427071dbf0b4e9$export$588d23d6e9ec2ed5($ec141028f9f6a3fe$export$7ee22ce365e4d3b5, params);
}
const $ec141028f9f6a3fe$export$82127fa72e650526 = /*@__PURE__*/ $d4d51e3b5652b8a4$export$3122533d606194de("ZodURL", (inst, def)=>{
    // ZodStringFormat.init(inst, def);
    $38bc36f53cb4eb10$export$7e12af57cac08b7a.init(inst, def);
    $ec141028f9f6a3fe$export$6f00fc81f4be18e5.init(inst, def);
});
function $ec141028f9f6a3fe$export$128fa18b7194ef(params) {
    return $d7427071dbf0b4e9$export$e3f203373341d39($ec141028f9f6a3fe$export$82127fa72e650526, params);
}
function $ec141028f9f6a3fe$export$cddedb4cb7866be8(params) {
    return $d7427071dbf0b4e9$export$e3f203373341d39($ec141028f9f6a3fe$export$82127fa72e650526, {
        protocol: /^https?$/,
        hostname: $675a4de49b6b20b4$exports.domain,
        ...(0, $8f5391358ccbeba2$exports).normalizeParams(params)
    });
}
const $ec141028f9f6a3fe$export$f072c1a26a31d55b = /*@__PURE__*/ $d4d51e3b5652b8a4$export$3122533d606194de("ZodEmoji", (inst, def)=>{
    // ZodStringFormat.init(inst, def);
    $38bc36f53cb4eb10$export$154cd448b85bb5a3.init(inst, def);
    $ec141028f9f6a3fe$export$6f00fc81f4be18e5.init(inst, def);
});
function $ec141028f9f6a3fe$export$a19185d1233fc4b2(params) {
    return $d7427071dbf0b4e9$export$936e26d261396f46($ec141028f9f6a3fe$export$f072c1a26a31d55b, params);
}
const $ec141028f9f6a3fe$export$9e180e3f910c7773 = /*@__PURE__*/ $d4d51e3b5652b8a4$export$3122533d606194de("ZodNanoID", (inst, def)=>{
    // ZodStringFormat.init(inst, def);
    $38bc36f53cb4eb10$export$5a160d28c6d62c88.init(inst, def);
    $ec141028f9f6a3fe$export$6f00fc81f4be18e5.init(inst, def);
});
function $ec141028f9f6a3fe$export$ac4959f4f1338dfc(params) {
    return $d7427071dbf0b4e9$export$a030949b19390ea0($ec141028f9f6a3fe$export$9e180e3f910c7773, params);
}
const $ec141028f9f6a3fe$export$c6b7c3c30ab9362e = /*@__PURE__*/ $d4d51e3b5652b8a4$export$3122533d606194de("ZodCUID", (inst, def)=>{
    // ZodStringFormat.init(inst, def);
    $38bc36f53cb4eb10$export$f4f84bd3c6706e60.init(inst, def);
    $ec141028f9f6a3fe$export$6f00fc81f4be18e5.init(inst, def);
});
function $ec141028f9f6a3fe$export$e057ec210c7d3443(params) {
    return $d7427071dbf0b4e9$export$639125837b796148($ec141028f9f6a3fe$export$c6b7c3c30ab9362e, params);
}
const $ec141028f9f6a3fe$export$536dc9ce9eec8565 = /*@__PURE__*/ $d4d51e3b5652b8a4$export$3122533d606194de("ZodCUID2", (inst, def)=>{
    // ZodStringFormat.init(inst, def);
    $38bc36f53cb4eb10$export$faf1483c11362df6.init(inst, def);
    $ec141028f9f6a3fe$export$6f00fc81f4be18e5.init(inst, def);
});
function $ec141028f9f6a3fe$export$af5866a6cccce9f0(params) {
    return $d7427071dbf0b4e9$export$36b63ef9af7972c2($ec141028f9f6a3fe$export$536dc9ce9eec8565, params);
}
const $ec141028f9f6a3fe$export$a060914fca5da3d4 = /*@__PURE__*/ $d4d51e3b5652b8a4$export$3122533d606194de("ZodULID", (inst, def)=>{
    // ZodStringFormat.init(inst, def);
    $38bc36f53cb4eb10$export$c5788701f4f55294.init(inst, def);
    $ec141028f9f6a3fe$export$6f00fc81f4be18e5.init(inst, def);
});
function $ec141028f9f6a3fe$export$c34778236461ea95(params) {
    return $d7427071dbf0b4e9$export$95acf3b3fa11bdc9($ec141028f9f6a3fe$export$a060914fca5da3d4, params);
}
const $ec141028f9f6a3fe$export$d53bc3b8251fa017 = /*@__PURE__*/ $d4d51e3b5652b8a4$export$3122533d606194de("ZodXID", (inst, def)=>{
    // ZodStringFormat.init(inst, def);
    $38bc36f53cb4eb10$export$e721fd3317199b85.init(inst, def);
    $ec141028f9f6a3fe$export$6f00fc81f4be18e5.init(inst, def);
});
function $ec141028f9f6a3fe$export$5eecaf20006cb6cb(params) {
    return $d7427071dbf0b4e9$export$bbb0a2cfb079fa90($ec141028f9f6a3fe$export$d53bc3b8251fa017, params);
}
const $ec141028f9f6a3fe$export$1bbac5f87dca43e4 = /*@__PURE__*/ $d4d51e3b5652b8a4$export$3122533d606194de("ZodKSUID", (inst, def)=>{
    // ZodStringFormat.init(inst, def);
    $38bc36f53cb4eb10$export$baa9849ea82bee6e.init(inst, def);
    $ec141028f9f6a3fe$export$6f00fc81f4be18e5.init(inst, def);
});
function $ec141028f9f6a3fe$export$f49b11deeb9beb0f(params) {
    return $d7427071dbf0b4e9$export$1306ede2f9ea153f($ec141028f9f6a3fe$export$1bbac5f87dca43e4, params);
}
const $ec141028f9f6a3fe$export$567930edb18e0c3a = /*@__PURE__*/ $d4d51e3b5652b8a4$export$3122533d606194de("ZodIPv4", (inst, def)=>{
    // ZodStringFormat.init(inst, def);
    $38bc36f53cb4eb10$export$93fc833bbf7ceb99.init(inst, def);
    $ec141028f9f6a3fe$export$6f00fc81f4be18e5.init(inst, def);
});
function $ec141028f9f6a3fe$export$291a17a16047f284(params) {
    return $d7427071dbf0b4e9$export$c77a1c80cebc2aad($ec141028f9f6a3fe$export$567930edb18e0c3a, params);
}
const $ec141028f9f6a3fe$export$cb4c1bda006648e3 = /*@__PURE__*/ $d4d51e3b5652b8a4$export$3122533d606194de("ZodMAC", (inst, def)=>{
    // ZodStringFormat.init(inst, def);
    $38bc36f53cb4eb10$export$747370108f97e6ea.init(inst, def);
    $ec141028f9f6a3fe$export$6f00fc81f4be18e5.init(inst, def);
});
function $ec141028f9f6a3fe$export$f8d11e097856efcf(params) {
    return $d7427071dbf0b4e9$export$84f8b3e041d8e7d9($ec141028f9f6a3fe$export$cb4c1bda006648e3, params);
}
const $ec141028f9f6a3fe$export$75c5c5fd479ecddf = /*@__PURE__*/ $d4d51e3b5652b8a4$export$3122533d606194de("ZodIPv6", (inst, def)=>{
    // ZodStringFormat.init(inst, def);
    $38bc36f53cb4eb10$export$8c939a460418a1bf.init(inst, def);
    $ec141028f9f6a3fe$export$6f00fc81f4be18e5.init(inst, def);
});
function $ec141028f9f6a3fe$export$4e0c86a59c658526(params) {
    return $d7427071dbf0b4e9$export$964dfe0e2e4e8895($ec141028f9f6a3fe$export$75c5c5fd479ecddf, params);
}
const $ec141028f9f6a3fe$export$ac524bc9ec5fac50 = /*@__PURE__*/ $d4d51e3b5652b8a4$export$3122533d606194de("ZodCIDRv4", (inst, def)=>{
    $38bc36f53cb4eb10$export$e164feaf5ae5296b.init(inst, def);
    $ec141028f9f6a3fe$export$6f00fc81f4be18e5.init(inst, def);
});
function $ec141028f9f6a3fe$export$fc96793d9715e5a1(params) {
    return $d7427071dbf0b4e9$export$feaac4e27a421ddc($ec141028f9f6a3fe$export$ac524bc9ec5fac50, params);
}
const $ec141028f9f6a3fe$export$b8cae7a616378f16 = /*@__PURE__*/ $d4d51e3b5652b8a4$export$3122533d606194de("ZodCIDRv6", (inst, def)=>{
    $38bc36f53cb4eb10$export$3c3aacb740759234.init(inst, def);
    $ec141028f9f6a3fe$export$6f00fc81f4be18e5.init(inst, def);
});
function $ec141028f9f6a3fe$export$b6e650831cac87fb(params) {
    return $d7427071dbf0b4e9$export$a0518ffc5273ec92($ec141028f9f6a3fe$export$b8cae7a616378f16, params);
}
const $ec141028f9f6a3fe$export$237b9f5cee85a1c1 = /*@__PURE__*/ $d4d51e3b5652b8a4$export$3122533d606194de("ZodBase64", (inst, def)=>{
    // ZodStringFormat.init(inst, def);
    $38bc36f53cb4eb10$export$d7d4932079e2113d.init(inst, def);
    $ec141028f9f6a3fe$export$6f00fc81f4be18e5.init(inst, def);
});
function $ec141028f9f6a3fe$export$b3b2de96497acc47(params) {
    return $d7427071dbf0b4e9$export$9fdb09384fbc4988($ec141028f9f6a3fe$export$237b9f5cee85a1c1, params);
}
const $ec141028f9f6a3fe$export$62a2e9135a9e2356 = /*@__PURE__*/ $d4d51e3b5652b8a4$export$3122533d606194de("ZodBase64URL", (inst, def)=>{
    // ZodStringFormat.init(inst, def);
    $38bc36f53cb4eb10$export$f5c3c3bbec012fa6.init(inst, def);
    $ec141028f9f6a3fe$export$6f00fc81f4be18e5.init(inst, def);
});
function $ec141028f9f6a3fe$export$7d21597c7bc64465(params) {
    return $d7427071dbf0b4e9$export$178c70fb89c949fa($ec141028f9f6a3fe$export$62a2e9135a9e2356, params);
}
const $ec141028f9f6a3fe$export$fac79817565ec0f7 = /*@__PURE__*/ $d4d51e3b5652b8a4$export$3122533d606194de("ZodE164", (inst, def)=>{
    // ZodStringFormat.init(inst, def);
    $38bc36f53cb4eb10$export$46d3507e8483217.init(inst, def);
    $ec141028f9f6a3fe$export$6f00fc81f4be18e5.init(inst, def);
});
function $ec141028f9f6a3fe$export$2fa5ed24c9ef198e(params) {
    return $d7427071dbf0b4e9$export$b8bf0b70d4bc7855($ec141028f9f6a3fe$export$fac79817565ec0f7, params);
}
const $ec141028f9f6a3fe$export$5c0d807bd77507f = /*@__PURE__*/ $d4d51e3b5652b8a4$export$3122533d606194de("ZodJWT", (inst, def)=>{
    // ZodStringFormat.init(inst, def);
    $38bc36f53cb4eb10$export$f515616cf0cda103.init(inst, def);
    $ec141028f9f6a3fe$export$6f00fc81f4be18e5.init(inst, def);
});
function $ec141028f9f6a3fe$export$6b49f0d0c2777fe9(params) {
    return $d7427071dbf0b4e9$export$4a9318e6b46f1aa1($ec141028f9f6a3fe$export$5c0d807bd77507f, params);
}
const $ec141028f9f6a3fe$export$a75d00728843496d = /*@__PURE__*/ $d4d51e3b5652b8a4$export$3122533d606194de("ZodCustomStringFormat", (inst, def)=>{
    // ZodStringFormat.init(inst, def);
    $38bc36f53cb4eb10$export$9dde4397c7b8a192.init(inst, def);
    $ec141028f9f6a3fe$export$6f00fc81f4be18e5.init(inst, def);
});
function $ec141028f9f6a3fe$export$80ce5102b3890b72(format, fnOrRegex, _params = {}) {
    return $d7427071dbf0b4e9$export$e25dde89ba546b88($ec141028f9f6a3fe$export$a75d00728843496d, format, fnOrRegex, _params);
}
function $ec141028f9f6a3fe$export$640106f6dc7d2706(_params) {
    return $d7427071dbf0b4e9$export$e25dde89ba546b88($ec141028f9f6a3fe$export$a75d00728843496d, "hostname", $675a4de49b6b20b4$exports.hostname, _params);
}
function $ec141028f9f6a3fe$export$834dfc94dde4b3d8(_params) {
    return $d7427071dbf0b4e9$export$e25dde89ba546b88($ec141028f9f6a3fe$export$a75d00728843496d, "hex", $675a4de49b6b20b4$exports.hex, _params);
}
function $ec141028f9f6a3fe$export$d6af199866bfb566(alg, params) {
    const enc = params?.enc ?? "hex";
    const format = `${alg}_${enc}`;
    const regex = $675a4de49b6b20b4$exports[format];
    if (!regex) throw new Error(`Unrecognized hash format: ${format}`);
    return $d7427071dbf0b4e9$export$e25dde89ba546b88($ec141028f9f6a3fe$export$a75d00728843496d, format, regex, params);
}
const $ec141028f9f6a3fe$export$5b070a55c0c43e09 = /*@__PURE__*/ $d4d51e3b5652b8a4$export$3122533d606194de("ZodNumber", (inst, def)=>{
    $38bc36f53cb4eb10$export$b7292ed81eaafd49.init(inst, def);
    $ec141028f9f6a3fe$export$2afb8ab49d4b92c0.init(inst, def);
    inst.gt = (value, params)=>inst.check($d7427071dbf0b4e9$export$7582466e3ab4d25b(value, params));
    inst.gte = (value, params)=>inst.check($d7427071dbf0b4e9$export$a1c6d8834a3b19c9(value, params));
    inst.min = (value, params)=>inst.check($d7427071dbf0b4e9$export$a1c6d8834a3b19c9(value, params));
    inst.lt = (value, params)=>inst.check($d7427071dbf0b4e9$export$2a42c74e76a068a(value, params));
    inst.lte = (value, params)=>inst.check($d7427071dbf0b4e9$export$7a060cf3d60b84a6(value, params));
    inst.max = (value, params)=>inst.check($d7427071dbf0b4e9$export$7a060cf3d60b84a6(value, params));
    inst.int = (params)=>inst.check($ec141028f9f6a3fe$export$7d260a2a5f8bc19e(params));
    inst.safe = (params)=>inst.check($ec141028f9f6a3fe$export$7d260a2a5f8bc19e(params));
    inst.positive = (params)=>inst.check($d7427071dbf0b4e9$export$7582466e3ab4d25b(0, params));
    inst.nonnegative = (params)=>inst.check($d7427071dbf0b4e9$export$a1c6d8834a3b19c9(0, params));
    inst.negative = (params)=>inst.check($d7427071dbf0b4e9$export$2a42c74e76a068a(0, params));
    inst.nonpositive = (params)=>inst.check($d7427071dbf0b4e9$export$7a060cf3d60b84a6(0, params));
    inst.multipleOf = (value, params)=>inst.check($d7427071dbf0b4e9$export$c41e40f80e978ab1(value, params));
    inst.step = (value, params)=>inst.check($d7427071dbf0b4e9$export$c41e40f80e978ab1(value, params));
    // inst.finite = (params) => inst.check(core.finite(params));
    inst.finite = ()=>inst;
    const bag = inst._zod.bag;
    inst.minValue = Math.max(bag.minimum ?? Number.NEGATIVE_INFINITY, bag.exclusiveMinimum ?? Number.NEGATIVE_INFINITY) ?? null;
    inst.maxValue = Math.min(bag.maximum ?? Number.POSITIVE_INFINITY, bag.exclusiveMaximum ?? Number.POSITIVE_INFINITY) ?? null;
    inst.isInt = (bag.format ?? "").includes("int") || Number.isSafeInteger(bag.multipleOf ?? 0.5);
    inst.isFinite = true;
    inst.format = bag.format ?? null;
});
function $ec141028f9f6a3fe$export$98e628dec113755e(params) {
    return $d7427071dbf0b4e9$export$9249bb0b45639623($ec141028f9f6a3fe$export$5b070a55c0c43e09, params);
}
const $ec141028f9f6a3fe$export$1d835e7a0f492f73 = /*@__PURE__*/ $d4d51e3b5652b8a4$export$3122533d606194de("ZodNumberFormat", (inst, def)=>{
    $38bc36f53cb4eb10$export$2cfebe79b769ec9.init(inst, def);
    $ec141028f9f6a3fe$export$5b070a55c0c43e09.init(inst, def);
});
function $ec141028f9f6a3fe$export$7d260a2a5f8bc19e(params) {
    return $d7427071dbf0b4e9$export$3d5b343b1f51efdd($ec141028f9f6a3fe$export$1d835e7a0f492f73, params);
}
function $ec141028f9f6a3fe$export$1a4bac2aea11f30e(params) {
    return $d7427071dbf0b4e9$export$656ad65d6cf64174($ec141028f9f6a3fe$export$1d835e7a0f492f73, params);
}
function $ec141028f9f6a3fe$export$76f82835c9736f87(params) {
    return $d7427071dbf0b4e9$export$9ddff8176107cc11($ec141028f9f6a3fe$export$1d835e7a0f492f73, params);
}
function $ec141028f9f6a3fe$export$1d95835383bb05a(params) {
    return $d7427071dbf0b4e9$export$5ec965fd114a2f9f($ec141028f9f6a3fe$export$1d835e7a0f492f73, params);
}
function $ec141028f9f6a3fe$export$de9ffb9418dd7d0d(params) {
    return $d7427071dbf0b4e9$export$a43c28c6e86e066e($ec141028f9f6a3fe$export$1d835e7a0f492f73, params);
}
const $ec141028f9f6a3fe$export$723d146f80596191 = /*@__PURE__*/ $d4d51e3b5652b8a4$export$3122533d606194de("ZodBoolean", (inst, def)=>{
    $38bc36f53cb4eb10$export$828bf41e557d7dda.init(inst, def);
    $ec141028f9f6a3fe$export$2afb8ab49d4b92c0.init(inst, def);
});
function $ec141028f9f6a3fe$export$4a21f16c33752377(params) {
    return $d7427071dbf0b4e9$export$e23c41ce5ce2db39($ec141028f9f6a3fe$export$723d146f80596191, params);
}
const $ec141028f9f6a3fe$export$67d741fd70ff98f4 = /*@__PURE__*/ $d4d51e3b5652b8a4$export$3122533d606194de("ZodBigInt", (inst, def)=>{
    $38bc36f53cb4eb10$export$7600843f2a3baa73.init(inst, def);
    $ec141028f9f6a3fe$export$2afb8ab49d4b92c0.init(inst, def);
    inst.gte = (value, params)=>inst.check($d7427071dbf0b4e9$export$a1c6d8834a3b19c9(value, params));
    inst.min = (value, params)=>inst.check($d7427071dbf0b4e9$export$a1c6d8834a3b19c9(value, params));
    inst.gt = (value, params)=>inst.check($d7427071dbf0b4e9$export$7582466e3ab4d25b(value, params));
    inst.gte = (value, params)=>inst.check($d7427071dbf0b4e9$export$a1c6d8834a3b19c9(value, params));
    inst.min = (value, params)=>inst.check($d7427071dbf0b4e9$export$a1c6d8834a3b19c9(value, params));
    inst.lt = (value, params)=>inst.check($d7427071dbf0b4e9$export$2a42c74e76a068a(value, params));
    inst.lte = (value, params)=>inst.check($d7427071dbf0b4e9$export$7a060cf3d60b84a6(value, params));
    inst.max = (value, params)=>inst.check($d7427071dbf0b4e9$export$7a060cf3d60b84a6(value, params));
    inst.positive = (params)=>inst.check($d7427071dbf0b4e9$export$7582466e3ab4d25b(BigInt(0), params));
    inst.negative = (params)=>inst.check($d7427071dbf0b4e9$export$2a42c74e76a068a(BigInt(0), params));
    inst.nonpositive = (params)=>inst.check($d7427071dbf0b4e9$export$7a060cf3d60b84a6(BigInt(0), params));
    inst.nonnegative = (params)=>inst.check($d7427071dbf0b4e9$export$a1c6d8834a3b19c9(BigInt(0), params));
    inst.multipleOf = (value, params)=>inst.check($d7427071dbf0b4e9$export$c41e40f80e978ab1(value, params));
    const bag = inst._zod.bag;
    inst.minValue = bag.minimum ?? null;
    inst.maxValue = bag.maximum ?? null;
    inst.format = bag.format ?? null;
});
function $ec141028f9f6a3fe$export$a0f65b52274bcc00(params) {
    return $d7427071dbf0b4e9$export$c96ff33878177e4c($ec141028f9f6a3fe$export$67d741fd70ff98f4, params);
}
const $ec141028f9f6a3fe$export$7483f4dc330f3456 = /*@__PURE__*/ $d4d51e3b5652b8a4$export$3122533d606194de("ZodBigIntFormat", (inst, def)=>{
    $38bc36f53cb4eb10$export$487194b75209a5dd.init(inst, def);
    $ec141028f9f6a3fe$export$67d741fd70ff98f4.init(inst, def);
});
function $ec141028f9f6a3fe$export$af207e6076994812(params) {
    return $d7427071dbf0b4e9$export$cb7d3ec922804f3f($ec141028f9f6a3fe$export$7483f4dc330f3456, params);
}
function $ec141028f9f6a3fe$export$870002f71f6ee2de(params) {
    return $d7427071dbf0b4e9$export$c51606f0dfa0f5a1($ec141028f9f6a3fe$export$7483f4dc330f3456, params);
}
const $ec141028f9f6a3fe$export$bcc3b40f6b638044 = /*@__PURE__*/ $d4d51e3b5652b8a4$export$3122533d606194de("ZodSymbol", (inst, def)=>{
    $38bc36f53cb4eb10$export$c9e7e1831bb8dd12.init(inst, def);
    $ec141028f9f6a3fe$export$2afb8ab49d4b92c0.init(inst, def);
});
function $ec141028f9f6a3fe$export$8f701197936bc2a6(params) {
    return $d7427071dbf0b4e9$export$a8f93f5b7c030e84($ec141028f9f6a3fe$export$bcc3b40f6b638044, params);
}
const $ec141028f9f6a3fe$export$4e780e961c30340d = /*@__PURE__*/ $d4d51e3b5652b8a4$export$3122533d606194de("ZodUndefined", (inst, def)=>{
    $38bc36f53cb4eb10$export$379ccf61f9830869.init(inst, def);
    $ec141028f9f6a3fe$export$2afb8ab49d4b92c0.init(inst, def);
});
function $ec141028f9f6a3fe$export$1db45310990710a5(params) {
    return $d7427071dbf0b4e9$export$60e4c9fe67803d40($ec141028f9f6a3fe$export$4e780e961c30340d, params);
}
const $ec141028f9f6a3fe$export$a96281f914484f2d = /*@__PURE__*/ $d4d51e3b5652b8a4$export$3122533d606194de("ZodNull", (inst, def)=>{
    $38bc36f53cb4eb10$export$d05db4d7bc9da27d.init(inst, def);
    $ec141028f9f6a3fe$export$2afb8ab49d4b92c0.init(inst, def);
});
function $ec141028f9f6a3fe$export$7b1b591b262c240(params) {
    return $d7427071dbf0b4e9$export$a2cbb38cda512d16($ec141028f9f6a3fe$export$a96281f914484f2d, params);
}
const $ec141028f9f6a3fe$export$b9d1edb536b4e4eb = /*@__PURE__*/ $d4d51e3b5652b8a4$export$3122533d606194de("ZodAny", (inst, def)=>{
    $38bc36f53cb4eb10$export$de3a83ac65a18f35.init(inst, def);
    $ec141028f9f6a3fe$export$2afb8ab49d4b92c0.init(inst, def);
});
function $ec141028f9f6a3fe$export$4154a199d7d90455() {
    return $d7427071dbf0b4e9$export$4678886173313220($ec141028f9f6a3fe$export$b9d1edb536b4e4eb);
}
const $ec141028f9f6a3fe$export$ef3b1bb1630977ae = /*@__PURE__*/ $d4d51e3b5652b8a4$export$3122533d606194de("ZodUnknown", (inst, def)=>{
    $38bc36f53cb4eb10$export$37ea092643879ea0.init(inst, def);
    $ec141028f9f6a3fe$export$2afb8ab49d4b92c0.init(inst, def);
});
function $ec141028f9f6a3fe$export$19282c40b967aec6() {
    return $d7427071dbf0b4e9$export$e0ed508a47e00801($ec141028f9f6a3fe$export$ef3b1bb1630977ae);
}
const $ec141028f9f6a3fe$export$1e576a20c3ce9fb5 = /*@__PURE__*/ $d4d51e3b5652b8a4$export$3122533d606194de("ZodNever", (inst, def)=>{
    $38bc36f53cb4eb10$export$4b2a18191b39c3b4.init(inst, def);
    $ec141028f9f6a3fe$export$2afb8ab49d4b92c0.init(inst, def);
});
function $ec141028f9f6a3fe$export$b3e22bcfd64c1022(params) {
    return $d7427071dbf0b4e9$export$887f43204ffc2a69($ec141028f9f6a3fe$export$1e576a20c3ce9fb5, params);
}
const $ec141028f9f6a3fe$export$7d39f5df85f21031 = /*@__PURE__*/ $d4d51e3b5652b8a4$export$3122533d606194de("ZodVoid", (inst, def)=>{
    $38bc36f53cb4eb10$export$6fd82db70787afbb.init(inst, def);
    $ec141028f9f6a3fe$export$2afb8ab49d4b92c0.init(inst, def);
});
function $ec141028f9f6a3fe$export$490e536ee7389aeb(params) {
    return $d7427071dbf0b4e9$export$9480825d3c8e9ad6($ec141028f9f6a3fe$export$7d39f5df85f21031, params);
}
const $ec141028f9f6a3fe$export$e974be33bdc55521 = /*@__PURE__*/ $d4d51e3b5652b8a4$export$3122533d606194de("ZodDate", (inst, def)=>{
    $38bc36f53cb4eb10$export$9a0ab9fbd61629f8.init(inst, def);
    $ec141028f9f6a3fe$export$2afb8ab49d4b92c0.init(inst, def);
    inst.min = (value, params)=>inst.check($d7427071dbf0b4e9$export$a1c6d8834a3b19c9(value, params));
    inst.max = (value, params)=>inst.check($d7427071dbf0b4e9$export$7a060cf3d60b84a6(value, params));
    const c = inst._zod.bag;
    inst.minDate = c.minimum ? new Date(c.minimum) : null;
    inst.maxDate = c.maximum ? new Date(c.maximum) : null;
});
function $ec141028f9f6a3fe$export$324d90190a8b822a(params) {
    return $d7427071dbf0b4e9$export$da799735c76175a($ec141028f9f6a3fe$export$e974be33bdc55521, params);
}
const $ec141028f9f6a3fe$export$7acfc3e64785411 = /*@__PURE__*/ $d4d51e3b5652b8a4$export$3122533d606194de("ZodArray", (inst, def)=>{
    $38bc36f53cb4eb10$export$fd77bdade7d2292b.init(inst, def);
    $ec141028f9f6a3fe$export$2afb8ab49d4b92c0.init(inst, def);
    inst.element = def.element;
    inst.min = (minLength, params)=>inst.check($d7427071dbf0b4e9$export$21f6711a906c1450(minLength, params));
    inst.nonempty = (params)=>inst.check($d7427071dbf0b4e9$export$21f6711a906c1450(1, params));
    inst.max = (maxLength, params)=>inst.check($d7427071dbf0b4e9$export$ec76627108655a22(maxLength, params));
    inst.length = (len, params)=>inst.check($d7427071dbf0b4e9$export$620b9f7ab17ff8a9(len, params));
    inst.unwrap = ()=>inst.element;
});
function $ec141028f9f6a3fe$export$2f23118c22fb2630(element, params) {
    return $d7427071dbf0b4e9$export$4ea446333e3db634($ec141028f9f6a3fe$export$7acfc3e64785411, element, params);
}
function $ec141028f9f6a3fe$export$7e1278799275f68e(schema) {
    const shape = schema._zod.def.shape;
    return $ec141028f9f6a3fe$export$78a99c8d44d72635(Object.keys(shape));
}
const $ec141028f9f6a3fe$export$736315c5b55efbad = /*@__PURE__*/ $d4d51e3b5652b8a4$export$3122533d606194de("ZodObject", (inst, def)=>{
    $38bc36f53cb4eb10$export$330feb3f8e03c085.init(inst, def);
    $ec141028f9f6a3fe$export$2afb8ab49d4b92c0.init(inst, def);
    (0, $8f5391358ccbeba2$exports).defineLazy(inst, "shape", ()=>{
        return def.shape;
    });
    inst.keyof = ()=>$ec141028f9f6a3fe$export$78a99c8d44d72635(Object.keys(inst._zod.def.shape));
    inst.catchall = (catchall)=>inst.clone({
            ...inst._zod.def,
            catchall: catchall
        });
    inst.passthrough = ()=>inst.clone({
            ...inst._zod.def,
            catchall: $ec141028f9f6a3fe$export$19282c40b967aec6()
        });
    inst.loose = ()=>inst.clone({
            ...inst._zod.def,
            catchall: $ec141028f9f6a3fe$export$19282c40b967aec6()
        });
    inst.strict = ()=>inst.clone({
            ...inst._zod.def,
            catchall: $ec141028f9f6a3fe$export$b3e22bcfd64c1022()
        });
    inst.strip = ()=>inst.clone({
            ...inst._zod.def,
            catchall: undefined
        });
    inst.extend = (incoming)=>{
        return (0, $8f5391358ccbeba2$exports).extend(inst, incoming);
    };
    inst.safeExtend = (incoming)=>{
        return (0, $8f5391358ccbeba2$exports).safeExtend(inst, incoming);
    };
    inst.merge = (other)=>(0, $8f5391358ccbeba2$exports).merge(inst, other);
    inst.pick = (mask)=>(0, $8f5391358ccbeba2$exports).pick(inst, mask);
    inst.omit = (mask)=>(0, $8f5391358ccbeba2$exports).omit(inst, mask);
    inst.partial = (...args)=>(0, $8f5391358ccbeba2$exports).partial($ec141028f9f6a3fe$export$aa56fec1e9d629b8, inst, args[0]);
    inst.required = (...args)=>(0, $8f5391358ccbeba2$exports).required($ec141028f9f6a3fe$export$eb04319818b4702e, inst, args[0]);
});
function $ec141028f9f6a3fe$export$be5493f9613cbbe(shape, params) {
    const def = {
        type: "object",
        shape: shape ?? {},
        ...(0, $8f5391358ccbeba2$exports).normalizeParams(params)
    };
    return new $ec141028f9f6a3fe$export$736315c5b55efbad(def);
}
function $ec141028f9f6a3fe$export$8fb0df5f40d0b477(shape, params) {
    return new $ec141028f9f6a3fe$export$736315c5b55efbad({
        type: "object",
        shape: shape,
        catchall: $ec141028f9f6a3fe$export$b3e22bcfd64c1022(),
        ...(0, $8f5391358ccbeba2$exports).normalizeParams(params)
    });
}
function $ec141028f9f6a3fe$export$bc233bd5e67eecd(shape, params) {
    return new $ec141028f9f6a3fe$export$736315c5b55efbad({
        type: "object",
        shape: shape,
        catchall: $ec141028f9f6a3fe$export$19282c40b967aec6(),
        ...(0, $8f5391358ccbeba2$exports).normalizeParams(params)
    });
}
const $ec141028f9f6a3fe$export$a8b236cb5070a311 = /*@__PURE__*/ $d4d51e3b5652b8a4$export$3122533d606194de("ZodUnion", (inst, def)=>{
    $38bc36f53cb4eb10$export$37a2350ef0bd638c.init(inst, def);
    $ec141028f9f6a3fe$export$2afb8ab49d4b92c0.init(inst, def);
    inst.options = def.options;
});
function $ec141028f9f6a3fe$export$971dd5b0dfd021b6(options, params) {
    return new $ec141028f9f6a3fe$export$a8b236cb5070a311({
        type: "union",
        options: options,
        ...(0, $8f5391358ccbeba2$exports).normalizeParams(params)
    });
}
const $ec141028f9f6a3fe$export$5ef2424805ac76a3 = /*@__PURE__*/ $d4d51e3b5652b8a4$export$3122533d606194de("ZodDiscriminatedUnion", (inst, def)=>{
    $ec141028f9f6a3fe$export$a8b236cb5070a311.init(inst, def);
    $38bc36f53cb4eb10$export$aad4f17edfb83795.init(inst, def);
});
function $ec141028f9f6a3fe$export$4b888e40c4ee26dd(discriminator, options, params) {
    // const [options, params] = args;
    return new $ec141028f9f6a3fe$export$5ef2424805ac76a3({
        type: "union",
        options: options,
        discriminator: discriminator,
        ...(0, $8f5391358ccbeba2$exports).normalizeParams(params)
    });
}
const $ec141028f9f6a3fe$export$c02deaf0bb5203d4 = /*@__PURE__*/ $d4d51e3b5652b8a4$export$3122533d606194de("ZodIntersection", (inst, def)=>{
    $38bc36f53cb4eb10$export$2299250b426aba4b.init(inst, def);
    $ec141028f9f6a3fe$export$2afb8ab49d4b92c0.init(inst, def);
});
function $ec141028f9f6a3fe$export$bc86dfbf7795668c(left, right) {
    return new $ec141028f9f6a3fe$export$c02deaf0bb5203d4({
        type: "intersection",
        left: left,
        right: right
    });
}
const $ec141028f9f6a3fe$export$e2a18bb771d8e6a3 = /*@__PURE__*/ $d4d51e3b5652b8a4$export$3122533d606194de("ZodTuple", (inst, def)=>{
    $38bc36f53cb4eb10$export$bba1b90a721dbd94.init(inst, def);
    $ec141028f9f6a3fe$export$2afb8ab49d4b92c0.init(inst, def);
    inst.rest = (rest)=>inst.clone({
            ...inst._zod.def,
            rest: rest
        });
});
function $ec141028f9f6a3fe$export$65e3907585753458(items, _paramsOrRest, _params) {
    const hasRest = _paramsOrRest instanceof $38bc36f53cb4eb10$export$f43a5c3966de8238;
    const params = hasRest ? _params : _paramsOrRest;
    const rest = hasRest ? _paramsOrRest : null;
    return new $ec141028f9f6a3fe$export$e2a18bb771d8e6a3({
        type: "tuple",
        items: items,
        rest: rest,
        ...(0, $8f5391358ccbeba2$exports).normalizeParams(params)
    });
}
const $ec141028f9f6a3fe$export$a2acc09968cb4b7f = /*@__PURE__*/ $d4d51e3b5652b8a4$export$3122533d606194de("ZodRecord", (inst, def)=>{
    $38bc36f53cb4eb10$export$cc20b90ec1a8c208.init(inst, def);
    $ec141028f9f6a3fe$export$2afb8ab49d4b92c0.init(inst, def);
    inst.keyType = def.keyType;
    inst.valueType = def.valueType;
});
function $ec141028f9f6a3fe$export$e5185e241753e543(keyType, valueType, params) {
    return new $ec141028f9f6a3fe$export$a2acc09968cb4b7f({
        type: "record",
        keyType: keyType,
        valueType: valueType,
        ...(0, $8f5391358ccbeba2$exports).normalizeParams(params)
    });
}
function $ec141028f9f6a3fe$export$669401d1edf671b3(keyType, valueType, params) {
    const k = $8f5391358ccbeba2$export$9cd59f9826255e47(keyType);
    k._zod.values = undefined;
    return new $ec141028f9f6a3fe$export$a2acc09968cb4b7f({
        type: "record",
        keyType: k,
        valueType: valueType,
        ...(0, $8f5391358ccbeba2$exports).normalizeParams(params)
    });
}
const $ec141028f9f6a3fe$export$163b6a2b712d9542 = /*@__PURE__*/ $d4d51e3b5652b8a4$export$3122533d606194de("ZodMap", (inst, def)=>{
    $38bc36f53cb4eb10$export$5ccfd30a7e358409.init(inst, def);
    $ec141028f9f6a3fe$export$2afb8ab49d4b92c0.init(inst, def);
    inst.keyType = def.keyType;
    inst.valueType = def.valueType;
});
function $ec141028f9f6a3fe$export$871de8747c9eaa88(keyType, valueType, params) {
    return new $ec141028f9f6a3fe$export$163b6a2b712d9542({
        type: "map",
        keyType: keyType,
        valueType: valueType,
        ...(0, $8f5391358ccbeba2$exports).normalizeParams(params)
    });
}
const $ec141028f9f6a3fe$export$977057706f816712 = /*@__PURE__*/ $d4d51e3b5652b8a4$export$3122533d606194de("ZodSet", (inst, def)=>{
    $38bc36f53cb4eb10$export$20cf27bc33a30268.init(inst, def);
    $ec141028f9f6a3fe$export$2afb8ab49d4b92c0.init(inst, def);
    inst.min = (...args)=>inst.check($d7427071dbf0b4e9$export$e379713268c2c18a(...args));
    inst.nonempty = (params)=>inst.check($d7427071dbf0b4e9$export$e379713268c2c18a(1, params));
    inst.max = (...args)=>inst.check($d7427071dbf0b4e9$export$3eed6ccb98bc18db(...args));
    inst.size = (...args)=>inst.check($d7427071dbf0b4e9$export$2621565b966a8d23(...args));
});
function $ec141028f9f6a3fe$export$adaa4cf7ef1b65be(valueType, params) {
    return new $ec141028f9f6a3fe$export$977057706f816712({
        type: "set",
        valueType: valueType,
        ...(0, $8f5391358ccbeba2$exports).normalizeParams(params)
    });
}
const $ec141028f9f6a3fe$export$d325d1f0e1c20179 = /*@__PURE__*/ $d4d51e3b5652b8a4$export$3122533d606194de("ZodEnum", (inst, def)=>{
    $38bc36f53cb4eb10$export$31462b6e6c50b618.init(inst, def);
    $ec141028f9f6a3fe$export$2afb8ab49d4b92c0.init(inst, def);
    inst.enum = def.entries;
    inst.options = Object.values(def.entries);
    const keys = new Set(Object.keys(def.entries));
    inst.extract = (values, params)=>{
        const newEntries = {};
        for (const value of values){
            if (keys.has(value)) newEntries[value] = def.entries[value];
            else throw new Error(`Key ${value} not found in enum`);
        }
        return new $ec141028f9f6a3fe$export$d325d1f0e1c20179({
            ...def,
            checks: [],
            ...(0, $8f5391358ccbeba2$exports).normalizeParams(params),
            entries: newEntries
        });
    };
    inst.exclude = (values, params)=>{
        const newEntries = {
            ...def.entries
        };
        for (const value of values){
            if (keys.has(value)) delete newEntries[value];
            else throw new Error(`Key ${value} not found in enum`);
        }
        return new $ec141028f9f6a3fe$export$d325d1f0e1c20179({
            ...def,
            checks: [],
            ...(0, $8f5391358ccbeba2$exports).normalizeParams(params),
            entries: newEntries
        });
    };
});
function $ec141028f9f6a3fe$export$78a99c8d44d72635(values, params) {
    const entries = Array.isArray(values) ? Object.fromEntries(values.map((v)=>[
            v,
            v
        ])) : values;
    return new $ec141028f9f6a3fe$export$d325d1f0e1c20179({
        type: "enum",
        entries: entries,
        ...(0, $8f5391358ccbeba2$exports).normalizeParams(params)
    });
}
function $ec141028f9f6a3fe$export$6fe7eca19ebe5199(entries, params) {
    return new $ec141028f9f6a3fe$export$d325d1f0e1c20179({
        type: "enum",
        entries: entries,
        ...(0, $8f5391358ccbeba2$exports).normalizeParams(params)
    });
}
const $ec141028f9f6a3fe$export$7e44096782a165d3 = /*@__PURE__*/ $d4d51e3b5652b8a4$export$3122533d606194de("ZodLiteral", (inst, def)=>{
    $38bc36f53cb4eb10$export$86699355265fa258.init(inst, def);
    $ec141028f9f6a3fe$export$2afb8ab49d4b92c0.init(inst, def);
    inst.values = new Set(def.values);
    Object.defineProperty(inst, "value", {
        get () {
            if (def.values.length > 1) throw new Error("This schema contains multiple valid literal values. Use `.values` instead.");
            return def.values[0];
        }
    });
});
function $ec141028f9f6a3fe$export$c8ec6e1ec9fefcb0(value, params) {
    return new $ec141028f9f6a3fe$export$7e44096782a165d3({
        type: "literal",
        values: Array.isArray(value) ? value : [
            value
        ],
        ...(0, $8f5391358ccbeba2$exports).normalizeParams(params)
    });
}
const $ec141028f9f6a3fe$export$1aa10ff06069e07d = /*@__PURE__*/ $d4d51e3b5652b8a4$export$3122533d606194de("ZodFile", (inst, def)=>{
    $38bc36f53cb4eb10$export$1997de0576a81377.init(inst, def);
    $ec141028f9f6a3fe$export$2afb8ab49d4b92c0.init(inst, def);
    inst.min = (size, params)=>inst.check($d7427071dbf0b4e9$export$e379713268c2c18a(size, params));
    inst.max = (size, params)=>inst.check($d7427071dbf0b4e9$export$3eed6ccb98bc18db(size, params));
    inst.mime = (types, params)=>inst.check($d7427071dbf0b4e9$export$267177285a1a8b37(Array.isArray(types) ? types : [
            types
        ], params));
});
function $ec141028f9f6a3fe$export$c2a28f090bb0afd6(params) {
    return $d7427071dbf0b4e9$export$e335cd0b9f8bab1e($ec141028f9f6a3fe$export$1aa10ff06069e07d, params);
}
const $ec141028f9f6a3fe$export$cf1499e83869147b = /*@__PURE__*/ $d4d51e3b5652b8a4$export$3122533d606194de("ZodTransform", (inst, def)=>{
    $38bc36f53cb4eb10$export$14b591f873519189.init(inst, def);
    $ec141028f9f6a3fe$export$2afb8ab49d4b92c0.init(inst, def);
    inst._zod.parse = (payload, _ctx)=>{
        if (_ctx.direction === "backward") throw new $d4d51e3b5652b8a4$export$a36d4c29b1151bde(inst.constructor.name);
        payload.addIssue = (issue)=>{
            if (typeof issue === "string") payload.issues.push((0, $8f5391358ccbeba2$exports).issue(issue, payload.value, def));
            else {
                // for Zod 3 backwards compatibility
                const _issue = issue;
                if (_issue.fatal) _issue.continue = false;
                _issue.code ?? (_issue.code = "custom");
                _issue.input ?? (_issue.input = payload.value);
                _issue.inst ?? (_issue.inst = inst);
                // _issue.continue ??= true;
                payload.issues.push((0, $8f5391358ccbeba2$exports).issue(_issue));
            }
        };
        const output = def.transform(payload.value, payload);
        if (output instanceof Promise) return output.then((output)=>{
            payload.value = output;
            return payload;
        });
        payload.value = output;
        return payload;
    };
});
function $ec141028f9f6a3fe$export$51186ad6e864892a(fn) {
    return new $ec141028f9f6a3fe$export$cf1499e83869147b({
        type: "transform",
        transform: fn
    });
}
const $ec141028f9f6a3fe$export$aa56fec1e9d629b8 = /*@__PURE__*/ $d4d51e3b5652b8a4$export$3122533d606194de("ZodOptional", (inst, def)=>{
    $38bc36f53cb4eb10$export$980e9af565c4d7aa.init(inst, def);
    $ec141028f9f6a3fe$export$2afb8ab49d4b92c0.init(inst, def);
    inst.unwrap = ()=>inst._zod.def.innerType;
});
function $ec141028f9f6a3fe$export$516e28dec6a4b6d4(innerType) {
    return new $ec141028f9f6a3fe$export$aa56fec1e9d629b8({
        type: "optional",
        innerType: innerType
    });
}
const $ec141028f9f6a3fe$export$aaac0b8b429cef5 = /*@__PURE__*/ $d4d51e3b5652b8a4$export$3122533d606194de("ZodNullable", (inst, def)=>{
    $38bc36f53cb4eb10$export$7994573b6604ec66.init(inst, def);
    $ec141028f9f6a3fe$export$2afb8ab49d4b92c0.init(inst, def);
    inst.unwrap = ()=>inst._zod.def.innerType;
});
function $ec141028f9f6a3fe$export$133fc36489ac9add(innerType) {
    return new $ec141028f9f6a3fe$export$aaac0b8b429cef5({
        type: "nullable",
        innerType: innerType
    });
}
function $ec141028f9f6a3fe$export$69fd1b70ebae5687(innerType) {
    return $ec141028f9f6a3fe$export$516e28dec6a4b6d4($ec141028f9f6a3fe$export$133fc36489ac9add(innerType));
}
const $ec141028f9f6a3fe$export$bb19b37874861e7e = /*@__PURE__*/ $d4d51e3b5652b8a4$export$3122533d606194de("ZodDefault", (inst, def)=>{
    $38bc36f53cb4eb10$export$ae2d21004b7243f7.init(inst, def);
    $ec141028f9f6a3fe$export$2afb8ab49d4b92c0.init(inst, def);
    inst.unwrap = ()=>inst._zod.def.innerType;
    inst.removeDefault = inst.unwrap;
});
function $ec141028f9f6a3fe$export$d4b0f68d0d916971(innerType, defaultValue) {
    return new $ec141028f9f6a3fe$export$bb19b37874861e7e({
        type: "default",
        innerType: innerType,
        get defaultValue () {
            return typeof defaultValue === "function" ? defaultValue() : (0, $8f5391358ccbeba2$exports).shallowClone(defaultValue);
        }
    });
}
const $ec141028f9f6a3fe$export$b619aec225e4abe9 = /*@__PURE__*/ $d4d51e3b5652b8a4$export$3122533d606194de("ZodPrefault", (inst, def)=>{
    $38bc36f53cb4eb10$export$29a8d757258be679.init(inst, def);
    $ec141028f9f6a3fe$export$2afb8ab49d4b92c0.init(inst, def);
    inst.unwrap = ()=>inst._zod.def.innerType;
});
function $ec141028f9f6a3fe$export$569da376ae266d0a(innerType, defaultValue) {
    return new $ec141028f9f6a3fe$export$b619aec225e4abe9({
        type: "prefault",
        innerType: innerType,
        get defaultValue () {
            return typeof defaultValue === "function" ? defaultValue() : (0, $8f5391358ccbeba2$exports).shallowClone(defaultValue);
        }
    });
}
const $ec141028f9f6a3fe$export$eb04319818b4702e = /*@__PURE__*/ $d4d51e3b5652b8a4$export$3122533d606194de("ZodNonOptional", (inst, def)=>{
    $38bc36f53cb4eb10$export$30ca726c4c50a6d7.init(inst, def);
    $ec141028f9f6a3fe$export$2afb8ab49d4b92c0.init(inst, def);
    inst.unwrap = ()=>inst._zod.def.innerType;
});
function $ec141028f9f6a3fe$export$e6aa51fdda6cd70d(innerType, params) {
    return new $ec141028f9f6a3fe$export$eb04319818b4702e({
        type: "nonoptional",
        innerType: innerType,
        ...(0, $8f5391358ccbeba2$exports).normalizeParams(params)
    });
}
const $ec141028f9f6a3fe$export$89dfce00a343f317 = /*@__PURE__*/ $d4d51e3b5652b8a4$export$3122533d606194de("ZodSuccess", (inst, def)=>{
    $38bc36f53cb4eb10$export$3cc4d03e729326ea.init(inst, def);
    $ec141028f9f6a3fe$export$2afb8ab49d4b92c0.init(inst, def);
    inst.unwrap = ()=>inst._zod.def.innerType;
});
function $ec141028f9f6a3fe$export$fe7c49d056ea1d88(innerType) {
    return new $ec141028f9f6a3fe$export$89dfce00a343f317({
        type: "success",
        innerType: innerType
    });
}
const $ec141028f9f6a3fe$export$75a44ec6249ac76b = /*@__PURE__*/ $d4d51e3b5652b8a4$export$3122533d606194de("ZodCatch", (inst, def)=>{
    $38bc36f53cb4eb10$export$d6f8b228374f6d37.init(inst, def);
    $ec141028f9f6a3fe$export$2afb8ab49d4b92c0.init(inst, def);
    inst.unwrap = ()=>inst._zod.def.innerType;
    inst.removeCatch = inst.unwrap;
});
function $ec141028f9f6a3fe$export$e1d4808a6ac94c4c(innerType, catchValue) {
    return new $ec141028f9f6a3fe$export$75a44ec6249ac76b({
        type: "catch",
        innerType: innerType,
        catchValue: typeof catchValue === "function" ? catchValue : ()=>catchValue
    });
}
const $ec141028f9f6a3fe$export$26ccfa0145e8511f = /*@__PURE__*/ $d4d51e3b5652b8a4$export$3122533d606194de("ZodNaN", (inst, def)=>{
    $38bc36f53cb4eb10$export$528f71701e6a7aee.init(inst, def);
    $ec141028f9f6a3fe$export$2afb8ab49d4b92c0.init(inst, def);
});
function $ec141028f9f6a3fe$export$9e06de0973666692(params) {
    return $d7427071dbf0b4e9$export$a5e7e1f8491a5e50($ec141028f9f6a3fe$export$26ccfa0145e8511f, params);
}
const $ec141028f9f6a3fe$export$8c4c5c16b952637a = /*@__PURE__*/ $d4d51e3b5652b8a4$export$3122533d606194de("ZodPipe", (inst, def)=>{
    $38bc36f53cb4eb10$export$4cb25cfde430326c.init(inst, def);
    $ec141028f9f6a3fe$export$2afb8ab49d4b92c0.init(inst, def);
    inst.in = def.in;
    inst.out = def.out;
});
function $ec141028f9f6a3fe$export$a4627e546088548d(in_, out) {
    return new $ec141028f9f6a3fe$export$8c4c5c16b952637a({
        type: "pipe",
        in: in_,
        out: out
    });
}
const $ec141028f9f6a3fe$export$d2591c20339f7464 = /*@__PURE__*/ $d4d51e3b5652b8a4$export$3122533d606194de("ZodCodec", (inst, def)=>{
    $ec141028f9f6a3fe$export$8c4c5c16b952637a.init(inst, def);
    $38bc36f53cb4eb10$export$c622e07db8a40b53.init(inst, def);
});
function $ec141028f9f6a3fe$export$1c37c01eba8ed446(in_, out, params) {
    return new $ec141028f9f6a3fe$export$d2591c20339f7464({
        type: "pipe",
        in: in_,
        out: out,
        transform: params.decode,
        reverseTransform: params.encode
    });
}
const $ec141028f9f6a3fe$export$5d1f7ef05c4e493a = /*@__PURE__*/ $d4d51e3b5652b8a4$export$3122533d606194de("ZodReadonly", (inst, def)=>{
    $38bc36f53cb4eb10$export$f9f268f3fbb1601b.init(inst, def);
    $ec141028f9f6a3fe$export$2afb8ab49d4b92c0.init(inst, def);
    inst.unwrap = ()=>inst._zod.def.innerType;
});
function $ec141028f9f6a3fe$export$6ec456bd5b7b3c51(innerType) {
    return new $ec141028f9f6a3fe$export$5d1f7ef05c4e493a({
        type: "readonly",
        innerType: innerType
    });
}
const $ec141028f9f6a3fe$export$e6e9ee3f9fd7fdd9 = /*@__PURE__*/ $d4d51e3b5652b8a4$export$3122533d606194de("ZodTemplateLiteral", (inst, def)=>{
    $38bc36f53cb4eb10$export$37ea86c57a77af54.init(inst, def);
    $ec141028f9f6a3fe$export$2afb8ab49d4b92c0.init(inst, def);
});
function $ec141028f9f6a3fe$export$859cd210a8f40722(parts, params) {
    return new $ec141028f9f6a3fe$export$e6e9ee3f9fd7fdd9({
        type: "template_literal",
        parts: parts,
        ...(0, $8f5391358ccbeba2$exports).normalizeParams(params)
    });
}
const $ec141028f9f6a3fe$export$378d0cfce37406e6 = /*@__PURE__*/ $d4d51e3b5652b8a4$export$3122533d606194de("ZodLazy", (inst, def)=>{
    $38bc36f53cb4eb10$export$662fecee2efa1a66.init(inst, def);
    $ec141028f9f6a3fe$export$2afb8ab49d4b92c0.init(inst, def);
    inst.unwrap = ()=>inst._zod.def.getter();
});
function $ec141028f9f6a3fe$export$488013bae63b21da(getter) {
    return new $ec141028f9f6a3fe$export$378d0cfce37406e6({
        type: "lazy",
        getter: getter
    });
}
const $ec141028f9f6a3fe$export$3f196b0127d6e50a = /*@__PURE__*/ $d4d51e3b5652b8a4$export$3122533d606194de("ZodPromise", (inst, def)=>{
    $38bc36f53cb4eb10$export$bdefabff0dd84ca4.init(inst, def);
    $ec141028f9f6a3fe$export$2afb8ab49d4b92c0.init(inst, def);
    inst.unwrap = ()=>inst._zod.def.innerType;
});
function $ec141028f9f6a3fe$export$c957ef27a0ebfd4(innerType) {
    return new $ec141028f9f6a3fe$export$3f196b0127d6e50a({
        type: "promise",
        innerType: innerType
    });
}
const $ec141028f9f6a3fe$export$d4602ba55673f53c = /*@__PURE__*/ $d4d51e3b5652b8a4$export$3122533d606194de("ZodFunction", (inst, def)=>{
    $38bc36f53cb4eb10$export$877c6e9c05ede764.init(inst, def);
    $ec141028f9f6a3fe$export$2afb8ab49d4b92c0.init(inst, def);
});
function $ec141028f9f6a3fe$export$6e2aba165ec1f1d9(params) {
    return new $ec141028f9f6a3fe$export$d4602ba55673f53c({
        type: "function",
        input: Array.isArray(params?.input) ? $ec141028f9f6a3fe$export$65e3907585753458(params?.input) : params?.input ?? $ec141028f9f6a3fe$export$2f23118c22fb2630($ec141028f9f6a3fe$export$19282c40b967aec6()),
        output: params?.output ?? $ec141028f9f6a3fe$export$19282c40b967aec6()
    });
}
const $ec141028f9f6a3fe$export$76cf7569fb33e487 = /*@__PURE__*/ $d4d51e3b5652b8a4$export$3122533d606194de("ZodCustom", (inst, def)=>{
    $38bc36f53cb4eb10$export$3a5d0e5e098b79ba.init(inst, def);
    $ec141028f9f6a3fe$export$2afb8ab49d4b92c0.init(inst, def);
});
function $ec141028f9f6a3fe$export$35dc45686fc2dbd7(fn) {
    const ch = new $81f0b1f6d5b9fb58$export$c05d9110ef20bb2c({
        check: "custom"
    });
    ch._zod.check = fn;
    return ch;
}
function $ec141028f9f6a3fe$export$4c00f665f0d4b443(fn, _params) {
    return $d7427071dbf0b4e9$export$8bfc2ce1398e3071($ec141028f9f6a3fe$export$76cf7569fb33e487, fn ?? (()=>true), _params);
}
function $ec141028f9f6a3fe$export$edc9d475108b3212(fn, _params = {}) {
    return $d7427071dbf0b4e9$export$ac822e05051812e1($ec141028f9f6a3fe$export$76cf7569fb33e487, fn, _params);
}
function $ec141028f9f6a3fe$export$e0f31df04c32a6bf(fn) {
    return $d7427071dbf0b4e9$export$f2b01ecb843d7ab9(fn);
}
const $ec141028f9f6a3fe$export$cd5450f3a47e3789 = $d7427071dbf0b4e9$export$cd5450f3a47e3789;
const $ec141028f9f6a3fe$export$6990040ee07315 = $d7427071dbf0b4e9$export$6990040ee07315;
function $ec141028f9f6a3fe$export$3d916e7c22dbd8b5(cls, params = {
    error: `Input not instance of ${cls.name}`
}) {
    const inst = new $ec141028f9f6a3fe$export$76cf7569fb33e487({
        type: "custom",
        check: "custom",
        fn: (data)=>data instanceof cls,
        abort: true,
        ...(0, $8f5391358ccbeba2$exports).normalizeParams(params)
    });
    inst._zod.bag.Class = cls;
    return inst;
}
const $ec141028f9f6a3fe$export$c1250768cb298588 = (...args)=>$d7427071dbf0b4e9$export$a75528509e3a7006({
        Codec: $ec141028f9f6a3fe$export$d2591c20339f7464,
        Boolean: $ec141028f9f6a3fe$export$723d146f80596191,
        String: $ec141028f9f6a3fe$export$1230eb29b8d3b502
    }, ...args);
function $ec141028f9f6a3fe$export$7b419323e6ed4f31(params) {
    const jsonSchema = $ec141028f9f6a3fe$export$488013bae63b21da(()=>{
        return $ec141028f9f6a3fe$export$971dd5b0dfd021b6([
            $ec141028f9f6a3fe$export$22b082955e083ec3(params),
            $ec141028f9f6a3fe$export$98e628dec113755e(),
            $ec141028f9f6a3fe$export$4a21f16c33752377(),
            $ec141028f9f6a3fe$export$7b1b591b262c240(),
            $ec141028f9f6a3fe$export$2f23118c22fb2630(jsonSchema),
            $ec141028f9f6a3fe$export$e5185e241753e543($ec141028f9f6a3fe$export$22b082955e083ec3(), jsonSchema)
        ]);
    });
    return jsonSchema;
}
function $ec141028f9f6a3fe$export$fc37fe19dfda43ee(fn, schema) {
    return $ec141028f9f6a3fe$export$a4627e546088548d($ec141028f9f6a3fe$export$51186ad6e864892a(fn), schema);
}





// Zod 3 compat layer

const $f673c803bc893cb8$export$5ba560653e4a1035 = {
    invalid_type: "invalid_type",
    too_big: "too_big",
    too_small: "too_small",
    invalid_format: "invalid_format",
    not_multiple_of: "not_multiple_of",
    unrecognized_keys: "unrecognized_keys",
    invalid_union: "invalid_union",
    invalid_key: "invalid_key",
    invalid_element: "invalid_element",
    invalid_value: "invalid_value",
    custom: "custom"
};
function $f673c803bc893cb8$export$1097a8289cfd22d7(map) {
    $d4d51e3b5652b8a4$export$e506a1d27d1eaa20({
        customError: map
    });
}
function $f673c803bc893cb8$export$32f27c719778d4c4() {
    return $d4d51e3b5652b8a4$export$e506a1d27d1eaa20().customError;
}
var $f673c803bc893cb8$export$558106ce543bd011;
$f673c803bc893cb8$export$558106ce543bd011 || ($f673c803bc893cb8$export$558106ce543bd011 = {});







function $bd4375750321e06e$export$22b082955e083ec3(params) {
    return $d7427071dbf0b4e9$export$614049477c642ce0($ec141028f9f6a3fe$export$1230eb29b8d3b502, params);
}
function $bd4375750321e06e$export$98e628dec113755e(params) {
    return $d7427071dbf0b4e9$export$272511620e4661dd($ec141028f9f6a3fe$export$5b070a55c0c43e09, params);
}
function $bd4375750321e06e$export$4a21f16c33752377(params) {
    return $d7427071dbf0b4e9$export$c3eb0e1c7c887e5c($ec141028f9f6a3fe$export$723d146f80596191, params);
}
function $bd4375750321e06e$export$a0f65b52274bcc00(params) {
    return $d7427071dbf0b4e9$export$8ff745acc355d077($ec141028f9f6a3fe$export$67d741fd70ff98f4, params);
}
function $bd4375750321e06e$export$324d90190a8b822a(params) {
    return $d7427071dbf0b4e9$export$2efeac445ea43f33($ec141028f9f6a3fe$export$e974be33bdc55521, params);
}


(0, $d4d51e3b5652b8a4$export$e506a1d27d1eaa20)((0, $2c82302aae7b6758$export$2e2bcd8739ae039)());


const $5980852fab81bf32$export$50459aae8e896057 = $ec141028f9f6a3fe$export$be5493f9613cbbe({
    aaid: $ec141028f9f6a3fe$export$22b082955e083ec3(),
    staffId: $ec141028f9f6a3fe$export$22b082955e083ec3(),
    name: $ec141028f9f6a3fe$export$22b082955e083ec3()
});
const $5980852fab81bf32$export$26933d974c970670 = $ec141028f9f6a3fe$export$78a99c8d44d72635([
    'READY',
    'DONE',
    'COMPLETE',
    'IN_PROGRESS',
    'BLOCKED'
]);
const $5980852fab81bf32$export$cd2da33297e70f42 = $ec141028f9f6a3fe$export$78a99c8d44d72635([
    'access',
    'assets',
    'cmdb',
    'atlassian-together',
    'avocado',
    'avp',
    'beacon',
    'bitbucket',
    'canvas',
    'cloud-admin',
    'compass',
    'confluence',
    'devai',
    'feedback',
    'goal',
    'guard',
    'hipchat.cloud',
    'jira-admin',
    'jira-align',
    'jira-core',
    'jira-customer-service',
    'jira-family',
    'jira-incident-manager',
    'jira-product-discovery',
    'jira-servicedesk',
    'jira-servicedesk.ondemand',
    'jira-software',
    'jira-work-management',
    'loom',
    'loom-attribution',
    'mercury',
    'opsgenie',
    'passionfruit',
    'project',
    'radar',
    'refapp',
    'rovo',
    'statuspage',
    'studio',
    'teams',
    'townsquare',
    'trello',
    'unknown-atlassian'
]);
const $5980852fab81bf32$export$fc2f2bb38e071f9f = $ec141028f9f6a3fe$export$be5493f9613cbbe({
    url: $ec141028f9f6a3fe$export$22b082955e083ec3(),
    altTag: $ec141028f9f6a3fe$export$22b082955e083ec3(),
    title: $ec141028f9f6a3fe$export$22b082955e083ec3(),
    width: $ec141028f9f6a3fe$export$98e628dec113755e(),
    height: $ec141028f9f6a3fe$export$98e628dec113755e()
});
const $5980852fab81bf32$export$8f438f2e2f3b5ab6 = $ec141028f9f6a3fe$export$be5493f9613cbbe({
    id: $ec141028f9f6a3fe$export$22b082955e083ec3(),
    title: $ec141028f9f6a3fe$export$22b082955e083ec3(),
    products: $ec141028f9f6a3fe$export$2f23118c22fb2630($5980852fab81bf32$export$cd2da33297e70f42).optional().nullable(),
    status: $ec141028f9f6a3fe$export$78a99c8d44d72635([
        'COMING_SOON',
        'PLANNED',
        'ROLLING_OUT',
        'GENERALLY_AVAILABLE',
        'ROLLED_BACK'
    ]).optional().nullable(),
    type: $ec141028f9f6a3fe$export$78a99c8d44d72635([
        'IMPROVEMENT',
        'FIX',
        'EXPERIMENT',
        'REMOVED',
        'ANNOUNCEMENT'
    ]).optional().nullable(),
    // AI-generated impact rating for the update
    impactRating: $ec141028f9f6a3fe$export$78a99c8d44d72635([
        'HIGH',
        'MEDIUM',
        'LOW'
    ]).optional().nullable(),
    // AI-generated contextual tags replacing change type
    tags: $ec141028f9f6a3fe$export$2f23118c22fb2630($ec141028f9f6a3fe$export$22b082955e083ec3()).optional().nullable(),
    // List and details page fields
    summary: $ec141028f9f6a3fe$export$22b082955e083ec3().optional().nullable(),
    releaseStartDate: $ec141028f9f6a3fe$export$22b082955e083ec3().optional().nullable(),
    releaseEndDate: $ec141028f9f6a3fe$export$22b082955e083ec3().optional().nullable(),
    firstPublishedAt: $ec141028f9f6a3fe$export$22b082955e083ec3().optional().nullable(),
    // Details page fields
    getStarted: $ec141028f9f6a3fe$export$22b082955e083ec3().optional().nullable(),
    keyChanges: $ec141028f9f6a3fe$export$22b082955e083ec3().optional().nullable(),
    benefitsList: $ec141028f9f6a3fe$export$22b082955e083ec3().optional().nullable(),
    reasonForChange: $ec141028f9f6a3fe$export$22b082955e083ec3().optional().nullable(),
    prepareForChange: $ec141028f9f6a3fe$export$22b082955e083ec3().optional().nullable(),
    featuredImage: $5980852fab81bf32$export$fc2f2bb38e071f9f.optional().nullable()
});
const $5980852fab81bf32$export$c87d4a255d390b42 = $ec141028f9f6a3fe$export$be5493f9613cbbe({
    prev: $ec141028f9f6a3fe$export$22b082955e083ec3().nullable(),
    self: $ec141028f9f6a3fe$export$22b082955e083ec3(),
    next: $ec141028f9f6a3fe$export$22b082955e083ec3().nullable()
});
const $5980852fab81bf32$export$858ba830f18930de = $ec141028f9f6a3fe$export$2f23118c22fb2630($5980852fab81bf32$export$8f438f2e2f3b5ab6);
const $5980852fab81bf32$export$cc5d40c0c68901df = $ec141028f9f6a3fe$export$be5493f9613cbbe({
    data: $5980852fab81bf32$export$858ba830f18930de,
    links: $5980852fab81bf32$export$c87d4a255d390b42,
    meta: $ec141028f9f6a3fe$export$be5493f9613cbbe({
        total: $ec141028f9f6a3fe$export$98e628dec113755e()
    }).optional().nullable()
});
const $5980852fab81bf32$export$c857e1b94e9f9b3e = $5980852fab81bf32$export$8f438f2e2f3b5ab6.extend({
    previewTrackReleaseDate: $ec141028f9f6a3fe$export$22b082955e083ec3().optional().nullable(),
    bundledTrackReleaseDate: $ec141028f9f6a3fe$export$22b082955e083ec3().optional().nullable()
});
const $5980852fab81bf32$export$70d05b2dcce6090f = $ec141028f9f6a3fe$export$2f23118c22fb2630($5980852fab81bf32$export$c857e1b94e9f9b3e);
const $5980852fab81bf32$export$d03cdea9c9f8dd87 = $ec141028f9f6a3fe$export$be5493f9613cbbe({
    data: $5980852fab81bf32$export$70d05b2dcce6090f,
    links: $5980852fab81bf32$export$c87d4a255d390b42,
    meta: $ec141028f9f6a3fe$export$be5493f9613cbbe({
        total: $ec141028f9f6a3fe$export$98e628dec113755e()
    }).optional().nullable()
});
const $5980852fab81bf32$export$98d9a00f2a6d4f51 = $ec141028f9f6a3fe$export$be5493f9613cbbe({
    currentValue: $ec141028f9f6a3fe$export$98e628dec113755e().nullable(),
    percentageChange: $ec141028f9f6a3fe$export$98e628dec113755e().nullable()
});
const $5980852fab81bf32$export$d56e026ea8343f5d = $ec141028f9f6a3fe$export$be5493f9613cbbe({
    totalActiveUpdates: $5980852fab81bf32$export$98d9a00f2a6d4f51,
    awaitingApproval: $5980852fab81bf32$export$98d9a00f2a6d4f51,
    approvedForUpdate: $5980852fab81bf32$export$98d9a00f2a6d4f51,
    averageApprovalTimeHours: $5980852fab81bf32$export$98d9a00f2a6d4f51
});



var $k7fIB = parcelRequire("k7fIB");

var $Un5hy = parcelRequire("Un5hy");
const $962eaad69e29ec03$export$b0b91c85f99f8402 = ()=>{
    const { api: api, dispatch: dispatch, state: state } = (0, $4933e76bd0ca959e$export$7653fec709d1e7bb)();
    const { sendScreenEvent: sendScreenEvent } = (0, $a442bdf486731fcc$export$62b6ee20d27ead99)();
    (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).useEffect(()=>{
        sendScreenEvent((0, $3e8e9266fe04abe4$export$73f866ce8175509a).screen.appUpdatesListScreen.data);
    }, [
        sendScreenEvent
    ]);
    const { committedFilters: committedFilters, pagination: pagination } = state.updates;
    const { selectedProducts: committedProducts, selectedStatuses: committedStatuses, selectedChangeTypes: committedChangeTypes, selectedImpactRatings: committedImpactRatings, selectedTags: committedTags, searchQuery: committedSearchQuery, effectiveFrom: committedEffectiveFrom, committedFiltersVersion: committedFiltersVersion } = committedFilters;
    // Convert UiProductType ids (e.g. 'JIRA_SOFTWARE') to ProductKey (e.g. 'jira-software')
    // for the backend API, which expects kebab-case ProductKey format.
    const selectedProducts = committedProducts?.map(({ id: id })=>(0, $d3185276e14a4c2b$export$7524c8b3bd6ccb7f)(id)?.productKey).filter((key)=>key !== undefined).join(',') || undefined;
    const selectedStatuses = committedStatuses?.map(({ id: id })=>id).join(',') || undefined;
    const selectedChangeTypes = committedChangeTypes?.map(({ id: id })=>id).join(',') || undefined;
    const selectedImpactRatings = committedImpactRatings?.map(({ id: id })=>id).join(',') || undefined;
    const selectedTags = committedTags?.map(({ id: id })=>id).join(',') || undefined;
    const searchQuery = committedSearchQuery || undefined;
    const updatesQuery = (0, $4b398c1589a0f1e2$export$dd0a697e1782aedd)({
        queryKey: [
            '/gateway/api/public/app-updates/v1/changes',
            pagination.cursor ?? null,
            pagination.limit,
            searchQuery ?? null,
            selectedProducts ?? null,
            selectedStatuses ?? null,
            selectedChangeTypes ?? null,
            selectedImpactRatings ?? null,
            selectedTags ?? null,
            committedEffectiveFrom ?? null,
            // This fixes scenario where user clicks on Apply but do not change filters,
            // in which case the query would not refetch because queryKey did not change.
            // With this, even if filters did not change, the query will refetch because
            // committedFiltersVersion increments on every Apply click.
            committedFiltersVersion
        ],
        // Shows old data while fetching new data, to prevent showing empty state with spinner
        // on every filter change.
        placeholderData: (previousData)=>previousData,
        queryFn: async ()=>{
            try {
                if (typeof window !== 'undefined' && typeof window.scrollTo === 'function') window.scrollTo({
                    top: 0,
                    left: 0
                });
                const params = pagination.cursor ? {
                    cursor: pagination.cursor
                } : {
                    limit: pagination.limit,
                    search: searchQuery,
                    products: selectedProducts,
                    statuses: selectedStatuses,
                    types: selectedChangeTypes,
                    impactRatings: selectedImpactRatings,
                    tags: selectedTags,
                    effectiveFrom: committedEffectiveFrom ?? undefined
                };
                const response = await api.get('/gateway/api/public/app-updates/v1/changes', {
                    params: params
                });
                const parsedResponse = (0, $5980852fab81bf32$export$cc5d40c0c68901df).parse(response.data);
                return {
                    updates: [
                        ...parsedResponse?.data.map((update)=>({
                                ...update,
                                productTypes: update.products?.map((product)=>(0, $d3185276e14a4c2b$export$27e53caf66bae1d)(product)).filter((product)=>product != null) || []
                            })) || []
                    ],
                    links: parsedResponse?.links
                };
            } catch (error) {
                // Distinguish Zod schema parse failures (malformed API response) from
                // network/HTTP errors so Sentry gives clearer diagnostics.
                const isParseError = error instanceof Error && error.name === 'ZodError';
                (0, $9654b596cdf679bc$export$2e2bcd8739ae039).error(error, {
                    extra: {
                        action: isParseError ? 'parse-updates-list-response' : 'fetch-updates-list'
                    }
                });
                throw error;
            }
        }
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).useEffect(()=>{
        dispatch({
            type: 'UPDATES_LOADING_SET',
            payload: {
                isLoading: updatesQuery.isFetching
            }
        });
    }, [
        dispatch,
        updatesQuery.isFetching
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).useEffect(()=>{
        dispatch({
            type: 'UPDATES_ERROR_SET',
            payload: {
                error: updatesQuery.error?.message || null
            }
        });
    }, [
        dispatch,
        updatesQuery.error
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).useEffect(()=>{
        dispatch({
            type: 'UPDATES_DATA_LINKS_SET',
            payload: {
                updates: updatesQuery.data?.updates || [],
                links: updatesQuery.data?.links ? updatesQuery.data.links : {
                    self: '',
                    next: null,
                    prev: null
                }
            }
        });
    }, [
        dispatch,
        updatesQuery.data,
        updatesQuery.isLoading
    ]);
    // UFOSegment provides the interaction context required by UFOLoadHold.
    // UFOLoadHold holds the page-load interaction open while data is fetching;
    // when isFetching becomes false, react-ufo automatically completes and
    // sends the operational event to the analytics pipeline.
    return /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsxs)((0, $Un5hy.default), {
        name: "app-updates",
        children: [
            /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $k7fIB.default), {
                name: "updates-data",
                hold: updatesQuery.isFetching
            }),
            /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsxs)((0, $c8dbef6c41cfa689$export$2e2bcd8739ae039), {
                space: "space.400",
                children: [
                    /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $ac017e5cb269e227$export$29b5614fa0522278), {}),
                    /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $cd51792b00d955d5$export$43e60dbd29b5bdea), {})
                ]
            })
        ]
    });
};




var $5FkrB = parcelRequire("5FkrB");



var $9ztDu = parcelRequire("9ztDu");








var $aRMzY = parcelRequire("aRMzY");
var $6Wx3K = parcelRequire("6Wx3K");


const $eb4ca328ce2b1810$var$messages = (0, $aRMzY.defineMessages)({
    adminCalloutText: {
        id: 'appUpdates.rolloutScheduleCallout.text',
        defaultMessage: 'For rollout schedules specific to your organization, visit <appUpdatesLink>App updates</appUpdatesLink> in <adminLink>Atlassian Administration</adminLink>. Organization admin access required.',
        description: 'Callout encouraging org admins to visit Atlassian Administration for org-specific rollout schedules. The text inside <appUpdatesLink> and <adminLink> tags are the visible link labels.'
    }
});
const $eb4ca328ce2b1810$var$calloutStyles = (0, $c1bec583fa49072f$export$f6c783d06584602c)({
    backgroundColor: 'color.background.neutral',
    borderRadius: 'radius.small',
    paddingBlock: 'space.150',
    paddingInline: 'space.150'
});
const $eb4ca328ce2b1810$export$986e8be29c8a24b3 = ()=>{
    const { formatMessage: formatMessage } = (0, $6Wx3K.default)();
    return /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $1b254ba6a068f2f1$export$2e2bcd8739ae039), {
        justifyContent: "center",
        xcss: $eb4ca328ce2b1810$var$calloutStyles,
        children: /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $d48daa9a522ca942$export$2e2bcd8739ae039), {
            size: "small",
            color: "color.text.subtle",
            children: formatMessage($eb4ca328ce2b1810$var$messages.adminCalloutText, {
                appUpdatesLink: (chunks)=>/*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $64e95b69a05329e9$export$2e2bcd8739ae039), {
                        href: "https://support.atlassian.com/organization-administration/docs/view-all-changes-to-an-atlassian-app/",
                        target: "_blank",
                        rel: "noopener noreferrer",
                        children: chunks
                    }),
                adminLink: (chunks)=>/*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $64e95b69a05329e9$export$2e2bcd8739ae039), {
                        href: "https://admin.atlassian.com",
                        target: "_blank",
                        rel: "noopener noreferrer",
                        children: chunks
                    })
            })
        })
    });
};



var $k7fIB = parcelRequire("k7fIB");

var $Un5hy = parcelRequire("Un5hy");
const $0ee532bd9ceb4b0a$export$d080aaafe13b8512 = ()=>{
    const { api: api, dispatch: dispatch, state: state } = (0, $4933e76bd0ca959e$export$7653fec709d1e7bb)();
    const { committedFilters: committedFilters, pagination: pagination } = state.bundles;
    const { selectedProducts: committedProducts, selectedBundleDate: committedBundleDate, searchQuery: committedSearchQuery, committedFiltersVersion: committedFiltersVersion } = committedFilters;
    const selectedProducts = committedProducts?.map(({ id: id })=>(0, $d3185276e14a4c2b$export$7524c8b3bd6ccb7f)(id)?.productKey).filter((key)=>key !== undefined).join(',') || undefined;
    // Prefetch available bundle dates for the currently selected app(s) so the
    // most recent date can be auto-applied before we render the table.
    const datesQuery = (0, $4b398c1589a0f1e2$export$dd0a697e1782aedd)({
        queryKey: [
            '/gateway/api/public/app-updates/v1/bundle-dates',
            selectedProducts ?? null
        ],
        queryFn: async ()=>{
            const response = await api.get('/gateway/api/public/app-updates/v1/bundle-dates', {
                params: {
                    products: selectedProducts
                }
            });
            return response.data ?? [];
        }
    });
    const hasInitialisedDefaultDateRef = (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).useRef(false);
    const hasUserSelectedDate = committedBundleDate !== null;
    const isReadyToRender = hasInitialisedDefaultDateRef.current || hasUserSelectedDate;
    (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).useEffect(()=>{
        if (hasInitialisedDefaultDateRef.current || hasUserSelectedDate) return;
        if (datesQuery.isSuccess) {
            const mostRecentDate = datesQuery.data[0] ?? null;
            hasInitialisedDefaultDateRef.current = true;
            if (mostRecentDate) {
                dispatch({
                    type: 'BUNDLE_FILTER_DATE_SELECT',
                    payload: {
                        selectedBundleDate: mostRecentDate
                    }
                });
                dispatch({
                    type: 'BUNDLES_FILTERS_APPLY'
                });
            }
        }
    }, [
        datesQuery.isSuccess,
        datesQuery.data,
        hasUserSelectedDate,
        dispatch
    ]);
    const searchQuery = committedSearchQuery || undefined;
    const inputDate = committedBundleDate || undefined;
    const bundlesQuery = (0, $4b398c1589a0f1e2$export$dd0a697e1782aedd)({
        enabled: isReadyToRender,
        queryKey: [
            '/gateway/api/public/app-updates/v1/bundle-changes',
            pagination.cursor ?? null,
            pagination.limit,
            searchQuery ?? null,
            selectedProducts ?? null,
            inputDate ?? null,
            committedFiltersVersion
        ],
        placeholderData: (previousData)=>previousData,
        queryFn: async ()=>{
            try {
                const params = pagination.cursor ? {
                    cursor: pagination.cursor
                } : {
                    limit: pagination.limit,
                    search: searchQuery,
                    products: selectedProducts,
                    inputDate: inputDate
                };
                const response = await api.get('/gateway/api/public/app-updates/v1/bundle-changes', {
                    params: params
                });
                const parsedResponse = (0, $5980852fab81bf32$export$d03cdea9c9f8dd87).parse(response.data);
                return {
                    bundles: [
                        ...parsedResponse?.data.map((bundle)=>({
                                ...bundle,
                                productTypes: bundle.products?.map((product)=>(0, $d3185276e14a4c2b$export$27e53caf66bae1d)(product)).filter((product)=>product != null) || []
                            })) || []
                    ],
                    links: parsedResponse?.links
                };
            } catch (error) {
                const isParseError = error instanceof Error && error.name === 'ZodError';
                (0, $9654b596cdf679bc$export$2e2bcd8739ae039).error(error, {
                    extra: {
                        action: isParseError ? 'parse-bundle-changes-response' : 'fetch-bundle-changes'
                    }
                });
                throw error;
            }
        }
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).useEffect(()=>{
        dispatch({
            type: 'BUNDLES_LOADING_SET',
            payload: {
                isLoading: bundlesQuery.isFetching
            }
        });
    }, [
        dispatch,
        bundlesQuery.isFetching
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).useEffect(()=>{
        dispatch({
            type: 'BUNDLES_ERROR_SET',
            payload: {
                error: bundlesQuery.error?.message || null
            }
        });
    }, [
        dispatch,
        bundlesQuery.error
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).useEffect(()=>{
        dispatch({
            type: 'BUNDLES_DATA_LINKS_SET',
            payload: {
                data: bundlesQuery.data?.bundles || [],
                links: bundlesQuery.data?.links ? bundlesQuery.data.links : {
                    self: '',
                    next: null,
                    prev: null
                }
            }
        });
    }, [
        dispatch,
        bundlesQuery.data
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).useEffect(()=>{
        if (typeof window === 'undefined' || typeof window.scrollTo !== 'function') return;
        window.scrollTo({
            top: 0,
            left: 0
        });
    }, [
        pagination.cursor
    ]);
    return /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsxs)((0, $Un5hy.default), {
        name: "bundled-changes",
        children: [
            /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $k7fIB.default), {
                name: "bundles-data",
                hold: !isReadyToRender || bundlesQuery.isFetching
            }),
            isReadyToRender ? /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsxs)((0, $c8dbef6c41cfa689$export$2e2bcd8739ae039), {
                space: "space.400",
                children: [
                    /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $fb27fbb16aa94537$export$ac34063c51bd3598), {}),
                    /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $2a8cd52f0324fffc$export$7d9f68d95131377e), {}),
                    /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $eb4ca328ce2b1810$export$986e8be29c8a24b3), {})
                ]
            }) : /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $1b254ba6a068f2f1$export$2e2bcd8739ae039), {
                justifyContent: "center",
                alignItems: "center",
                children: /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $383dd904a5a5e5b0$export$2e2bcd8739ae039), {
                    padding: "space.400",
                    children: /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $9ztDu.default), {
                        size: "large"
                    })
                })
            })
        ]
    });
};


const $5be66ddef5c7b610$var$ALL_CHANGES_TAB_INDEX = 0;
const $5be66ddef5c7b610$var$BUNDLED_CHANGES_TAB_INDEX = 1;
const $5be66ddef5c7b610$var$tabPanelContentStyles = (0, $c1bec583fa49072f$export$f6c783d06584602c)({
    width: '100%'
});
const $5be66ddef5c7b610$var$messages = (0, $aRMzY.defineMessages)({
    listPageTitle: {
        id: 'app.updates.title',
        defaultMessage: "What's new across Atlassian",
        description: 'Title for the app updates list page'
    },
    listPageSubtitle: {
        id: 'app.updates.subtitle',
        defaultMessage: "Discover new cloud features designed to unleash your team's potential and see how our latest updates can power your work today.",
        description: 'Subtitle describing the app updates list page content'
    },
    browserTabTitle: {
        id: 'app.updates.browserTabTitle',
        defaultMessage: 'Release Notes | Atlassian Community',
        description: 'Browser tab title for the release notes list page'
    },
    allChangesTab: {
        id: 'app.updates.tabs.allChanges',
        defaultMessage: 'All changes',
        description: 'Label for the "All changes" tab on the app updates list page'
    },
    bundledChangesTab: {
        id: 'app.updates.tabs.bundledChanges',
        defaultMessage: 'Release tracks changes',
        description: 'Label for the "Bundled changes" tab on the app updates list page'
    }
});
const $5be66ddef5c7b610$export$617fd60bbdea4ae5 = ()=>{
    const { formatMessage: formatMessage } = (0, $6Wx3K.default)();
    const [routerState, routerActions] = (0, $b421c015f5018cd0$export$9a302a45f65d0572)();
    const isOnBundledChangesPath = routerState.location.pathname === (0, $749a6437bd4ec017$export$cd891b82501bb412).RELEASE_TRACKS_CHANGES;
    const getActiveTabIndex = ()=>{
        if (isOnBundledChangesPath) return $5be66ddef5c7b610$var$BUNDLED_CHANGES_TAB_INDEX;
        return $5be66ddef5c7b610$var$ALL_CHANGES_TAB_INDEX;
    };
    const handleTabChange = (index)=>{
        // TODO: analytics — fire a tab-switch UI event here (specifics TBD).
        const nextPath = index === $5be66ddef5c7b610$var$BUNDLED_CHANGES_TAB_INDEX ? (0, $749a6437bd4ec017$export$cd891b82501bb412).RELEASE_TRACKS_CHANGES : (0, $749a6437bd4ec017$export$cd891b82501bb412).RELEASE_NOTES;
        if (nextPath !== routerState.location.pathname) routerActions.push(nextPath);
    };
    return /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsxs)((0, $383dd904a5a5e5b0$export$2e2bcd8739ae039), {
        as: "main",
        paddingBlockStart: "space.300",
        children: [
            /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $448e9b7b3295f6e4$export$dcef8f9bb9a41431), {
                children: /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)("title", {
                    children: formatMessage($5be66ddef5c7b610$var$messages.browserTabTitle)
                })
            }),
            /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsxs)((0, $c8dbef6c41cfa689$export$2e2bcd8739ae039), {
                space: "space.400",
                children: [
                    /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsxs)((0, $c8dbef6c41cfa689$export$2e2bcd8739ae039), {
                        space: "space.100",
                        children: [
                            /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $bb0Oq.default), {
                                size: "xxlarge",
                                children: formatMessage($5be66ddef5c7b610$var$messages.listPageTitle)
                            }),
                            /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $d48daa9a522ca942$export$2e2bcd8739ae039), {
                                color: "color.text.subtlest",
                                children: formatMessage($5be66ddef5c7b610$var$messages.listPageSubtitle)
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $010bee42faeab737$export$92843d20b8ec0118), {}),
                    /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsxs)((0, $f4929bb9d46c4aaa$export$2e2bcd8739ae039), {
                        id: "app-updates-tabs",
                        selected: getActiveTabIndex(),
                        onChange: handleTabChange,
                        children: [
                            /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsxs)((0, $62b7beffa12a0bc3$export$2e2bcd8739ae039), {
                                children: [
                                    /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $e23e17c0c75104db$export$2e2bcd8739ae039), {
                                        children: formatMessage($5be66ddef5c7b610$var$messages.allChangesTab)
                                    }),
                                    /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $e23e17c0c75104db$export$2e2bcd8739ae039), {
                                        children: formatMessage($5be66ddef5c7b610$var$messages.bundledChangesTab)
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $9620d31b6d3b6773$export$2e2bcd8739ae039), {
                                testId: "all-changes-panel",
                                children: /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $383dd904a5a5e5b0$export$2e2bcd8739ae039), {
                                    paddingBlockStart: "space.400",
                                    xcss: $5be66ddef5c7b610$var$tabPanelContentStyles,
                                    children: /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $962eaad69e29ec03$export$b0b91c85f99f8402), {})
                                })
                            }),
                            /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $9620d31b6d3b6773$export$2e2bcd8739ae039), {
                                testId: "bundled-changes-panel",
                                children: /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $383dd904a5a5e5b0$export$2e2bcd8739ae039), {
                                    paddingBlockStart: "space.400",
                                    xcss: $5be66ddef5c7b610$var$tabPanelContentStyles,
                                    children: /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $0ee532bd9ceb4b0a$export$d080aaafe13b8512), {})
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};





var $aRMzY = parcelRequire("aRMzY");
var $6Wx3K = parcelRequire("6Wx3K");




var $bb0Oq = parcelRequire("bb0Oq");

var $dUWEU = parcelRequire("dUWEU");

var $fiGqm = parcelRequire("fiGqm");

var $9ztDu = parcelRequire("9ztDu");

var $5FkrB = parcelRequire("5FkrB");
/* eslint-disable no-unused-vars */ 




const $aae63e431edf6a1c$export$d1b34fec48b30a4f = (updateId)=>{
    const { api: api } = (0, $4933e76bd0ca959e$export$7653fec709d1e7bb)();
    // Helper function to handle updateId in query functions
    const createQueryFn = (fn)=>{
        return updateId ? ()=>fn(updateId) : undefined;
    };
    // Update data query
    const updateQuery = (0, $4b398c1589a0f1e2$export$dd0a697e1782aedd)({
        queryKey: [
            `/gateway/api/public/app-updates/v1/change-details/${updateId}`
        ],
        queryFn: createQueryFn(async (id)=>{
            try {
                const response = await api.get(`/gateway/api/public/app-updates/v1/change-details/${id}`);
                const updateDetails = (0, $5980852fab81bf32$export$8f438f2e2f3b5ab6).parse(response.data);
                return {
                    ...updateDetails,
                    // Map product key to display name for easier UI rendering
                    productTypes: updateDetails.products?.map((product)=>(0, $d3185276e14a4c2b$export$27e53caf66bae1d)(product)).filter((product)=>product != null)
                };
            } catch (error) {
                // Distinguish Zod schema parse failures (malformed API response) from
                // network/HTTP errors so Sentry gives clearer diagnostics.
                const isParseError = error instanceof Error && error.name === 'ZodError';
                (0, $9654b596cdf679bc$export$2e2bcd8739ae039).error(error, {
                    extra: {
                        updateId: id,
                        action: isParseError ? 'parse-update-details-response' : 'fetch-update-details'
                    }
                });
                throw error;
            }
        }),
        enabled: !!updateId
    });
    return {
        // Data
        update: updateQuery.data,
        isUpdateLoading: updateQuery.isLoading,
        // Error states
        updateError: updateQuery.error,
        hasErrors: !!updateQuery.error
    };
};








var $bb0Oq = parcelRequire("bb0Oq");

var $kqp0i = parcelRequire("kqp0i");

var $1Vcia = parcelRequire("1Vcia");

var $25nEq = parcelRequire("25nEq");

var $5FkrB = parcelRequire("5FkrB");

var $kYLlQ = parcelRequire("kYLlQ");

var $fBC68 = parcelRequire("fBC68");
var $d0n7Z = parcelRequire("d0n7Z");

var $kMHA5 = parcelRequire("kMHA5");
var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $kIXpt = parcelRequire("kIXpt");

var $cYPzS = parcelRequire("cYPzS");

var $eyuDe = parcelRequire("eyuDe");

var $25nEq = parcelRequire("25nEq");

var $5FkrB = parcelRequire("5FkrB");

var $2DGGf = parcelRequire("2DGGf");
function $de1783a2fb838cfd$var$_callSuper(t, o, e) {
    return o = (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(o), (0, (/*@__PURE__*/$parcel$interopDefault($kIXpt)))(t, $de1783a2fb838cfd$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(t).constructor) : o.apply(t, e));
}
function $de1783a2fb838cfd$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($de1783a2fb838cfd$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $de1783a2fb838cfd$export$c7ef921528e1d279 = '<IntlProvider> needs to exist in the component ancestry';
var $de1783a2fb838cfd$var$isMissingIntlProviderInAncestryError = function isMissingIntlProviderInAncestryError(err) {
    var _err$toString;
    return err === null || err === void 0 || (_err$toString = err.toString()) === null || _err$toString === void 0 ? void 0 : _err$toString.includes('<IntlProvider> needs to exist in the component ancestry');
};
var $de1783a2fb838cfd$export$7df0749115d18d19 = /*#__PURE__*/ function(_React$Component) {
    function IntlErrorBoundary() {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, IntlErrorBoundary);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = $de1783a2fb838cfd$var$_callSuper(this, IntlErrorBoundary, [].concat(args));
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "state", {
            missingIntlProviderInAncestry: false
        });
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($eyuDe)))(IntlErrorBoundary, _React$Component);
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(IntlErrorBoundary, [
        {
            key: "componentDidCatch",
            value: function componentDidCatch(error, _errorInfo) {
                // if missing IntlProvider in ancestry, we setup a fallback IntlProvider ourselves
                if ($de1783a2fb838cfd$var$isMissingIntlProviderInAncestryError(error)) this.setState({
                    missingIntlProviderInAncestry: true
                });
                else // else we re-propagate the non-react-intl-next error
                throw error;
            }
        },
        {
            key: "render",
            value: function render() {
                if (this.state.missingIntlProviderInAncestry) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $2DGGf.default), {
                    locale: "en"
                }, this.props.children);
                return this.props.children;
            }
        }
    ]);
}((0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).Component);


var $5dFQJ = parcelRequire("5dFQJ");
var $01HkO = parcelRequire("01HkO");parcelRequire("dujqE");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $kIXpt = parcelRequire("kIXpt");

var $cYPzS = parcelRequire("cYPzS");

var $eyuDe = parcelRequire("eyuDe");

var $5FkrB = parcelRequire("5FkrB");

var $e2N4h = parcelRequire("e2N4h");
function $8d472cee2b63d31a$var$_callSuper(t, o, e) {
    return o = (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(o), (0, (/*@__PURE__*/$parcel$interopDefault($kIXpt)))(t, $8d472cee2b63d31a$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(t).constructor) : o.apply(t, e));
}
function $8d472cee2b63d31a$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($8d472cee2b63d31a$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $8d472cee2b63d31a$export$9ac3d19711324187 = (0, $e2N4h.default)()(/*#__PURE__*/ function(_React$Component) {
    function WithCreateAnalyticsEvent() {
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, WithCreateAnalyticsEvent);
        return $8d472cee2b63d31a$var$_callSuper(this, WithCreateAnalyticsEvent, arguments);
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($eyuDe)))(WithCreateAnalyticsEvent, _React$Component);
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(WithCreateAnalyticsEvent, [
        {
            key: "render",
            value: function render() {
                var _this$props = this.props, render = _this$props.render, createAnalyticsEvent = _this$props.createAnalyticsEvent;
                return render(createAnalyticsEvent);
            }
        }
    ]);
}((0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).Component));



var $fAhSf = parcelRequire("fAhSf");

var $74Zh5 = parcelRequire("74Zh5");

var $4vXmi = parcelRequire("4vXmi");
var $3be21b4824eb4ce4$var$hasRequiredPerformanceAPIs;
function $3be21b4824eb4ce4$export$b5717a625dd4a3eb() {
    if ($3be21b4824eb4ce4$var$hasRequiredPerformanceAPIs === undefined) $3be21b4824eb4ce4$var$hasRequiredPerformanceAPIs = typeof window !== 'undefined' && 'performance' in window && [
        'measure',
        'clearMeasures',
        'clearMarks',
        'getEntriesByName',
        'getEntriesByType',
        'now'
    ].every(function(api) {
        return !!performance[api];
    });
    return $3be21b4824eb4ce4$var$hasRequiredPerformanceAPIs;
}
function $3be21b4824eb4ce4$export$48995af1e77d8643() {
    return !!(typeof window !== 'undefined' && 'PerformanceObserver' in window);
}
function $3be21b4824eb4ce4$export$4370ec0f52022f66() {
    return $3be21b4824eb4ce4$export$48995af1e77d8643() && PerformanceObserver.supportedEntryTypes && PerformanceObserver.supportedEntryTypes.includes('longtask');
}


var $f3813def174ce227$var$measureMap = new Map();
function $f3813def174ce227$export$b62aa2130c86b59b(measureName) {
    if (!(0, $3be21b4824eb4ce4$export$b5717a625dd4a3eb)()) return;
    performance.mark("".concat(measureName, "::start"));
    $f3813def174ce227$var$measureMap.set(measureName, performance.now());
}
function $f3813def174ce227$export$37c25be427bec097(measureName, onMeasureComplete) {
    if (!(0, $3be21b4824eb4ce4$export$b5717a625dd4a3eb)()) return;
    performance.mark("".concat(measureName, "::end"));
    var start = onMeasureComplete ? $f3813def174ce227$var$measureMap.get(measureName) : undefined;
    try {
        performance.measure(measureName, "".concat(measureName, "::start"), "".concat(measureName, "::end"));
    } catch (error) {} finally{
        if (onMeasureComplete) {
            var entry = performance.getEntriesByName(measureName).pop();
            if (entry) onMeasureComplete(entry.duration, entry.startTime);
            else if (start) onMeasureComplete(performance.now() - start, start);
        }
        $f3813def174ce227$export$6f766653554dac02(measureName);
    }
}
function $f3813def174ce227$export$6f766653554dac02(measureName) {
    if (!(0, $3be21b4824eb4ce4$export$b5717a625dd4a3eb)()) return;
    $f3813def174ce227$var$measureMap.delete(measureName);
    performance.clearMarks("".concat(measureName, "::start"));
    performance.clearMarks("".concat(measureName, "::end"));
    performance.clearMeasures(measureName);
}
function $f3813def174ce227$export$b0a51f9f0047ea32(measureName) {
    if (!(0, $3be21b4824eb4ce4$export$b5717a625dd4a3eb)()) return false;
    return $f3813def174ce227$var$measureMap.get(measureName) !== undefined;
}



var $6f06f484c7500059$export$70f7d127254a90c = function getDistortedDurationMonitor() {
    if (typeof document === 'undefined') return {
        distortedDuration: false,
        cleanup: function cleanup() {}
    };
    // If an editor is rendered when the document is not visible -- the callback passed to
    // requestAnimationFrame will not fire until the document becomes visible again.
    //
    // For the purposes of using performance measurement -- this behaviour means the events
    // which have been fired in the background are not useful -- and lead to other events
    // being hard to draw conclusions from.
    //
    // To mitigate this -- we detect this state -- and fire a separate callback when the
    // measurement has occurred when the render was in the background
    var distortedDuration = document.visibilityState !== 'visible';
    function handleVisibilityChange() {
        if (document.visibilityState !== 'visible') distortedDuration = true;
    }
    // Ignored via go/ees005
    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
    document.addEventListener('visibilitychange', handleVisibilityChange);
    return {
        distortedDuration: distortedDuration,
        /**
     * Cleans up the document visibility event listener
     */ cleanup: function cleanup() {
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.removeEventListener('visibilitychange', handleVisibilityChange);
        }
    };
};
function $6f06f484c7500059$export$267ed650a5d21ae6(/**
 * Unique name for the measurement
 *
 * Important: if multiple measureRender events are fired at the same time
 * with the same measure name -- the result will not be correct.
 */ measureName, /**
 * Call back fired when the measurement completes.
 *
 * Note: when this function is called when the Document.visibilityState is not
 * visible -- the duration is likely to be misleading/inaccurate. This is due
 * to the measurements use of the `requestAnimationFrame` api which only fires
 * when the Document.visibilityState is visible.
 */ onMeasureComplete) {
    if (!(0, $3be21b4824eb4ce4$export$b5717a625dd4a3eb)()) return;
    var startMark = "[START]: ".concat(measureName);
    var endMark = "[END]: ".concat(measureName);
    var startTime = performance.now();
    performance.mark(startMark);
    var distortedDurationMonitor = $6f06f484c7500059$export$70f7d127254a90c();
    requestAnimationFrame(function() {
        requestAnimationFrame(function() {
            performance.mark(endMark);
            distortedDurationMonitor.cleanup();
            var duration = performance.now() - startTime;
            try {
                performance.measure(measureName, startMark, endMark);
                var entry = performance.getEntriesByName(measureName).pop();
                if (!entry) onMeasureComplete({
                    duration: duration,
                    startTime: startTime,
                    distortedDuration: distortedDurationMonitor.distortedDuration
                });
                else onMeasureComplete({
                    duration: entry.duration,
                    startTime: entry.startTime,
                    distortedDuration: distortedDurationMonitor.distortedDuration
                });
            } catch (e) {
                onMeasureComplete({
                    duration: duration,
                    startTime: startTime,
                    distortedDuration: distortedDurationMonitor.distortedDuration
                });
            }
            performance.clearMeasures(measureName);
            performance.clearMarks(startMark);
            performance.clearMarks(endMark);
        });
    });
}



function $1cacfa6421e59bfa$export$92d097a1155bbe27() {
    if (!(0, $3be21b4824eb4ce4$export$b5717a625dd4a3eb)()) return;
    var nav = performance.getEntriesByType('navigation')[0];
    if (nav) return nav.responseEnd;
    return;
}
function $1cacfa6421e59bfa$export$c982229f6c12dcf() {
    if (!(0, $3be21b4824eb4ce4$export$b5717a625dd4a3eb)()) return;
    var nav = performance.getEntriesByType('navigation')[0];
    if (nav) return nav.responseEnd - nav.requestStart;
    return;
}



var $kHFeb = parcelRequire("kHFeb");

var $cc08P = parcelRequire("cc08P");

var $4inI8 = parcelRequire("4inI8");

var $25nEq = parcelRequire("25nEq");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $kIXpt = parcelRequire("kIXpt");

var $cYPzS = parcelRequire("cYPzS");

var $eyuDe = parcelRequire("eyuDe");

var $2gI99 = parcelRequire("2gI99");

var $l8uaJ = parcelRequire("l8uaJ");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $l8uaJ = parcelRequire("l8uaJ");
function $0aa60fed10b264a8$export$217a88ad224d1b11(state) {
    var $head = state.selection.$head;
    for(var d = $head.depth; d > 0; d--){
        if ($head.node(d).type.spec.tableRole === 'row') return true;
    }
    return false;
}
function $0aa60fed10b264a8$export$debd62b44eb7e281($a, $b) {
    return $a.depth === $b.depth && $a.pos >= $b.start(-1) && $a.pos <= $b.end(-1);
}


var $d5be41131738196c$export$ca751a6394ad160e = /*#__PURE__*/ function() {
    function CellBookmark(anchor, head) {
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, CellBookmark);
        this.anchor = anchor;
        this.head = head;
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(CellBookmark, [
        {
            key: "map",
            value: function map(mapping) {
                return new CellBookmark(mapping.map(this.anchor), mapping.map(this.head));
            }
        },
        {
            key: "resolve",
            value: function resolve(doc) {
                var $anchorCell = doc.resolve(this.anchor);
                var $headCell = doc.resolve(this.head);
                if ($anchorCell.parent.type.spec.tableRole === 'row' && $headCell.parent.type.spec.tableRole === 'row' && $anchorCell.index() < $anchorCell.parent.childCount && $headCell.index() < $headCell.parent.childCount && (0, $0aa60fed10b264a8$export$debd62b44eb7e281)($anchorCell, $headCell)) {
                    var data = {
                        type: 'cell',
                        anchor: $anchorCell.pos,
                        head: $headCell.pos
                    };
                    return (0, $l8uaJ.Selection).fromJSON(doc, data);
                }
                return (0, $l8uaJ.Selection).near($headCell, 1);
            }
        }
    ]);
}();



var $25nEq = parcelRequire("25nEq");

var $arMYe = parcelRequire("arMYe");

var $9P61R = parcelRequire("9P61R");
/* eslint-disable @atlaskit/editor/no-re-export */ // Entry file in package.json
// Because working with row and column-spanning cells is not quite
// trivial, this code builds up a descriptive structure for a given
// table node. The structures are cached with the (persistent) table
// nodes as key, so that they only have to be recomputed when the
// content of the table changes.
//
// This does mean that they have to store table-relative, not
// document-relative positions. So code that uses them will typically
// compute the start position of the table and offset positions passed
// to or gotten from this structure by that amount.
var $be3f6291b33bf3ca$var$readFromCache, $be3f6291b33bf3ca$var$addToCache;
// Prefer using a weak map to cache table maps. Fall back on a
// fixed-size cache if that's not supported.
if (typeof WeakMap !== 'undefined') {
    var $be3f6291b33bf3ca$var$cache = new WeakMap();
    $be3f6291b33bf3ca$var$readFromCache = function readFromCache(key) {
        return $be3f6291b33bf3ca$var$cache.get(key);
    };
    $be3f6291b33bf3ca$var$addToCache = function addToCache(key, value) {
        $be3f6291b33bf3ca$var$cache.set(key, value);
        return value;
    };
} else {
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var $be3f6291b33bf3ca$var$_cache = [];
    var $be3f6291b33bf3ca$var$cacheSize = 10;
    var $be3f6291b33bf3ca$var$cachePos = 0;
    $be3f6291b33bf3ca$var$readFromCache = function readFromCache(key) {
        for(var i = 0; i < $be3f6291b33bf3ca$var$_cache.length; i += 2){
            if ($be3f6291b33bf3ca$var$_cache[i] === key) return $be3f6291b33bf3ca$var$_cache[i + 1];
        }
    };
    $be3f6291b33bf3ca$var$addToCache = function addToCache(key, value) {
        if ($be3f6291b33bf3ca$var$cachePos === $be3f6291b33bf3ca$var$cacheSize) $be3f6291b33bf3ca$var$cachePos = 0;
        $be3f6291b33bf3ca$var$_cache[$be3f6291b33bf3ca$var$cachePos++] = key;
        return $be3f6291b33bf3ca$var$_cache[$be3f6291b33bf3ca$var$cachePos++] = value;
    };
}
var $be3f6291b33bf3ca$export$c79fc6492f3af13d = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(function Rect(left, top, right, bottom) {
    (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, Rect);
    this.left = left;
    this.top = top;
    this.right = right;
    this.bottom = bottom;
});
var $be3f6291b33bf3ca$export$d8cd393a71edca79 = /*#__PURE__*/ function(TableProblemTypes) {
    TableProblemTypes["COLLISION"] = "collision";
    TableProblemTypes["OVERLONG_ROWSPAN"] = "overlong_rowspan";
    TableProblemTypes["MISSING"] = "missing";
    TableProblemTypes["COLWIDTH_MISMATCH"] = "colwidth mismatch";
    return TableProblemTypes;
}({});
var $be3f6291b33bf3ca$export$c60fae4049791eae = 140;
var $be3f6291b33bf3ca$export$493da463fed0a57a = /*#__PURE__*/ function() {
    function TableMap(width, height, map, problems, mapByColumn, mapByRow) {
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, TableMap);
        // The width of the table
        // The table's height
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "mapByColumn", []);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "mapByRow", []);
        this.width = width;
        this.height = height;
        this.mapByColumn = mapByColumn || [];
        this.mapByRow = mapByRow || [];
        // :: [number] A width * height array with the start position of
        // the cell covering that part of the table in each slot
        this.map = map;
        // An optional array of problems (cell overlap or non-rectangular
        // shape) for the table, used by the table normalizer.
        this.problems = problems;
    }
    // :: (number) → Rect
    // Find the dimensions of the cell at the given position.
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(TableMap, [
        {
            key: "findCell",
            value: function findCell(pos) {
                for(var i = 0; i < this.map.length; i++){
                    var curPos = this.map[i];
                    if (curPos !== pos) continue;
                    var left = i % this.width;
                    var top = i / this.width | 0;
                    var right = left + 1;
                    var bottom = top + 1;
                    for(var j = 1; right < this.width && this.map[i + j] === curPos; j++)right++;
                    for(var _j = 1; bottom < this.height && this.map[i + this.width * _j] === curPos; _j++)bottom++;
                    return new $be3f6291b33bf3ca$export$c79fc6492f3af13d(left, top, right, bottom);
                }
                throw new RangeError('No cell with offset ' + pos + ' found');
            }
        },
        {
            key: "colCount",
            value: function colCount(pos) {
                for(var i = 0; i < this.map.length; i++){
                    if (this.map[i] === pos) return i % this.width;
                }
                throw new RangeError('No cell with offset ' + pos + ' found');
            }
        },
        {
            key: "rowCount",
            value: function rowCount(pos) {
                if (this.width <= 0) throw new RangeError('Wrong table width found');
                for(var i = 0; i < this.map.length; i++){
                    if (this.map[i] === pos) return Math.floor(i / this.width);
                }
                throw new RangeError('No cell with offset ' + pos + ' found');
            }
        },
        {
            key: "isPosMerged",
            value: function isPosMerged(pos) {
                return this.map.includes(pos, this.map.indexOf(pos) + 1);
            }
        },
        {
            key: "isCellMerged",
            value: function isCellMerged(row, col) {
                return this.isCellMergedTopLeft(row, col) || this.isCellMergedBottomRight(row, col);
            }
        },
        {
            key: "isCellMergedTopLeft",
            value: function isCellMergedTopLeft(row, col) {
                var pos = this.map[row * this.width + col];
                return(// top
                row > 0 && pos === this.map[(row - 1) * this.width + col] || // left
                col > 0 && pos === this.map[row * this.width + (col - 1)]);
            }
        },
        {
            key: "isCellMergedBottomRight",
            value: function isCellMergedBottomRight(row, col) {
                var pos = this.map[row * this.width + col];
                return(// bottom
                row < this.height - 1 && pos === this.map[(row + 1) * this.width + col] || // right
                col < this.width - 1 && pos === this.map[row * this.width + (col + 1)]);
            }
        },
        {
            key: "nextCell",
            value: function nextCell(pos, axis, dir) {
                var _this$findCell = this.findCell(pos), left = _this$findCell.left, right = _this$findCell.right, top = _this$findCell.top, bottom = _this$findCell.bottom;
                if (axis === 'horiz') {
                    if (dir < 0 ? left === 0 : right === this.width) return null;
                    return this.map[top * this.width + (dir < 0 ? left - 1 : right)];
                } else {
                    if (dir < 0 ? top === 0 : bottom === this.height) return null;
                    return this.map[left + this.width * (dir < 0 ? top - 1 : bottom)];
                }
            }
        },
        {
            key: "rectBetween",
            value: function rectBetween(a, b) {
                var _this$findCell2 = this.findCell(a), leftA = _this$findCell2.left, rightA = _this$findCell2.right, topA = _this$findCell2.top, bottomA = _this$findCell2.bottom;
                var _this$findCell3 = this.findCell(b), leftB = _this$findCell3.left, rightB = _this$findCell3.right, topB = _this$findCell3.top, bottomB = _this$findCell3.bottom;
                return new $be3f6291b33bf3ca$export$c79fc6492f3af13d(Math.min(leftA, leftB), Math.min(topA, topB), Math.max(rightA, rightB), Math.max(bottomA, bottomB));
            }
        },
        {
            key: "cellsInRect",
            value: function cellsInRect(rect) {
                var result = [];
                var seen = {};
                for(var row = rect.top; row < rect.bottom; row++)for(var col = rect.left; col < rect.right; col++){
                    var index = row * this.width + col;
                    var pos = this.map[index];
                    if (seen[pos]) continue;
                    seen[pos] = true;
                    if ((col !== rect.left || !col || this.map[index - 1] !== pos) && (row !== rect.top || !row || this.map[index - this.width] !== pos)) result.push(pos);
                }
                return result;
            }
        },
        {
            key: "positionAt",
            value: function positionAt(row, col, table) {
                for(var i = 0, rowStart = 0;; i++){
                    var rowEnd = rowStart + table.child(i).nodeSize;
                    if (i === row) {
                        var index = col + row * this.width;
                        var rowEndIndex = (row + 1) * this.width;
                        // Skip past cells from previous rows (via rowspan)
                        while(index < rowEndIndex && this.map[index] < rowStart)index++;
                        return index === rowEndIndex ? rowEnd - 1 : this.map[index];
                    }
                    rowStart = rowEnd;
                }
            }
        },
        {
            key: "getMaxColInRow",
            value: function getMaxColInRow(pos) {
                var parentRowNode = pos.parent;
                if (parentRowNode.type.name === 'tableRow') return parentRowNode.childCount;
            }
        },
        {
            key: "hasMergedCells",
            value: function hasMergedCells() {
                var uniquePositions = new Set(this.map);
                return uniquePositions.size !== this.map.length;
            }
        }
    ], [
        {
            key: "get",
            value: function get(table) {
                return $be3f6291b33bf3ca$var$readFromCache(table) || $be3f6291b33bf3ca$var$addToCache(table, $be3f6291b33bf3ca$var$computeMap(table));
            }
        }
    ]);
}();
// Compute a table map.
function $be3f6291b33bf3ca$var$computeMap(table) {
    if (table.type.spec.tableRole !== 'table') throw new RangeError('Not a table node: ' + table.type.name);
    var width = $be3f6291b33bf3ca$var$findWidth(table);
    var height = table.childCount;
    var map = [];
    var colWidths = [];
    var mapPos = 0, problems = null;
    for(var i = 0, e = width * height; i < e; i++)map[i] = 0;
    for(var row = 0, pos = 0; row < height; row++){
        var rowNode = table.child(row);
        pos++;
        for(var _i = 0;; _i++){
            while(mapPos < map.length && map[mapPos] !== 0)mapPos++;
            if (_i === rowNode.childCount) break;
            var cellNode = rowNode.child(_i), _cellNode$attrs = cellNode.attrs, colspan = _cellNode$attrs.colspan, rowspan = _cellNode$attrs.rowspan, colwidth = _cellNode$attrs.colwidth;
            for(var h = 0; h < rowspan; h++){
                if (h + row >= height) {
                    (problems || (problems = [])).push({
                        type: $be3f6291b33bf3ca$export$d8cd393a71edca79.OVERLONG_ROWSPAN,
                        pos: pos,
                        n: rowspan - h
                    });
                    break;
                }
                var start = mapPos + h * width;
                for(var w = 0; w < colspan; w++){
                    if (map[start + w] === 0) map[start + w] = pos;
                    else (problems || (problems = [])).push({
                        type: $be3f6291b33bf3ca$export$d8cd393a71edca79.COLLISION,
                        row: row,
                        pos: pos,
                        n: colspan - w
                    });
                    var colW = colwidth && colwidth[w];
                    if (colW) {
                        var widthIndex = (start + w) % width * 2, prev = colWidths[widthIndex];
                        if (prev == null || prev !== colW && colWidths[widthIndex + 1] === 1) {
                            colWidths[widthIndex] = colW;
                            colWidths[widthIndex + 1] = 1;
                        } else if (prev === colW) colWidths[widthIndex + 1]++;
                    }
                }
            }
            mapPos += colspan;
            pos += cellNode.nodeSize;
        }
        var expectedPos = (row + 1) * width;
        var missing = 0;
        while(mapPos < expectedPos)if (map[mapPos++] === 0) missing++;
        if (missing) (problems || (problems = [])).push({
            type: $be3f6291b33bf3ca$export$d8cd393a71edca79.MISSING,
            row: row,
            n: missing
        });
        pos++;
    }
    var mapByRow = Array(height);
    var mapByColumn = Array(width);
    for(var _i2 = 0; _i2 < map.length; _i2++){
        var _mapByColumn$columnIn, _mapByRow$rowIndex;
        var columnIndex = _i2 % width;
        mapByColumn[columnIndex] = (_mapByColumn$columnIn = mapByColumn[columnIndex]) !== null && _mapByColumn$columnIn !== void 0 ? _mapByColumn$columnIn : [];
        mapByColumn[columnIndex].push(map[_i2]);
        var rowIndex = Math.trunc(_i2 / width);
        mapByRow[rowIndex] = (_mapByRow$rowIndex = mapByRow[rowIndex]) !== null && _mapByRow$rowIndex !== void 0 ? _mapByRow$rowIndex : [];
        mapByRow[rowIndex].push(map[_i2]);
    }
    var tableMap = new $be3f6291b33bf3ca$export$493da463fed0a57a(width, height, map, problems, mapByColumn, mapByRow);
    var badWidths = false;
    // For columns that have defined widths, but whose widths disagree
    // between rows, fix up the cells whose width doesn't match the
    // computed one.
    for(var _i3 = 0; !badWidths && _i3 < colWidths.length; _i3 += 2)if (colWidths[_i3] != null && colWidths[_i3 + 1] < height) badWidths = true;
    // colWidths is an array of numbers, it can look like this
    // const colWidths = [255, 3, 125, 3, 150, 2, 130, 1];
    // 255 is a colWidth and 3 is a number of cells with this colwidth.
    // This check exists to make sure that the table has been resized,
    // which means there will be elements in the colWidths array.
    if (colWidths.length > 0 && colWidths.length !== width * 2) {
        for(var _i4 = 0; _i4 < width * 2 - colWidths.length; _i4++)colWidths.push($be3f6291b33bf3ca$export$c60fae4049791eae, 0);
        badWidths = true;
    }
    if (badWidths) $be3f6291b33bf3ca$var$findBadColWidths(tableMap, colWidths, table);
    return tableMap;
}
function $be3f6291b33bf3ca$var$findWidth(table) {
    var width = -1;
    var hasRowSpan = false;
    for(var row = 0; row < table.childCount; row++){
        var rowNode = table.child(row);
        var rowWidth = 0;
        if (hasRowSpan) for(var j = 0; j < row; j++){
            var prevRow = table.child(j);
            for(var i = 0; i < prevRow.childCount; i++){
                var cell = prevRow.child(i);
                if (j + cell.attrs.rowspan > row) rowWidth += cell.attrs.colspan;
            }
        }
        for(var _i5 = 0; _i5 < rowNode.childCount; _i5++){
            var _cell = rowNode.child(_i5);
            rowWidth += _cell.attrs.colspan;
            if (_cell.attrs.rowspan > 1) hasRowSpan = true;
        }
        if (width === -1) width = rowWidth;
        else if (width !== rowWidth) width = Math.max(width, rowWidth);
    }
    return width;
}
function $be3f6291b33bf3ca$var$findBadColWidths(map, colWidths, table) {
    if (!map.problems) map.problems = [];
    var seen = {};
    for(var i = 0; i < map.map.length; i++){
        var pos = map.map[i];
        if (seen[pos]) continue;
        seen[pos] = true;
        var node = table.nodeAt(pos);
        var updated = null;
        for(var j = 0; j < node.attrs.colspan; j++){
            var col = (i + j) % map.width, colWidth = colWidths[col * 2];
            if (colWidth != null && (!node.attrs.colwidth || node.attrs.colwidth[j] !== colWidth)) (updated || (updated = $be3f6291b33bf3ca$var$freshColWidth(node.attrs)))[j] = colWidth;
        }
        if (updated) map.problems.unshift({
            type: $be3f6291b33bf3ca$export$d8cd393a71edca79.COLWIDTH_MISMATCH,
            pos: pos,
            colwidth: updated
        });
    }
}
// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $be3f6291b33bf3ca$var$freshColWidth(attrs) {
    if (attrs.colwidth) return attrs.colwidth.slice();
    var result = [];
    for(var i = 0; i < attrs.colspan; i++)result.push(0);
    return result;
}



function $f2ed471e3ef4fd00$export$3c89e45c7dff9619($pos) {
    return $pos.parent.type.spec.tableRole === 'row' && $pos.nodeAfter;
}
function $f2ed471e3ef4fd00$export$7a283ef453dbae9e($pos) {
    for(var after = $pos.nodeAfter, pos = $pos.pos; after; after = after.firstChild, pos++){
        var role = after.type.spec.tableRole;
        if (role === 'cell' || role === 'header_cell') return $pos.doc.resolve(pos);
    }
    for(var before = $pos.nodeBefore, _pos = $pos.pos; before; before = before.lastChild, _pos--){
        var _role = before.type.spec.tableRole;
        if (_role === 'cell' || _role === 'header_cell') return $pos.doc.resolve(_pos - before.nodeSize);
    }
    return null;
}
function $f2ed471e3ef4fd00$export$1f482d92c57578ce($pos) {
    for(var d = $pos.depth - 1; d > 0; d--){
        if ($pos.node(d).type.spec.tableRole === 'row') return $pos.node(0).resolve($pos.before(d + 1));
    }
    return null;
}
function $f2ed471e3ef4fd00$export$172699367bb25225($pos, axis, dir) {
    var start = $pos.start(-1);
    var map = (0, $be3f6291b33bf3ca$export$493da463fed0a57a).get($pos.node(-1));
    var moved = map.nextCell($pos.pos - start, axis, dir);
    return moved == null ? null : $pos.node(0).resolve(start + moved);
}



var $25nEq = parcelRequire("25nEq");
function $109c09578ebe8447$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $109c09578ebe8447$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $109c09578ebe8447$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $109c09578ebe8447$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $109c09578ebe8447$export$b24d9c3cc95412e0(attrs, pos) {
    var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
    if (!attrs.colspan) throw new Error('removeColSpan(): attrs.colspan not defined');
    var result = $109c09578ebe8447$var$_objectSpread($109c09578ebe8447$var$_objectSpread({}, attrs), {}, {
        colspan: attrs.colspan - n
    });
    if (result.colwidth) {
        result.colwidth = result.colwidth.slice();
        result.colwidth.splice(pos, n);
        if (!result.colwidth.some(function(w) {
            return w > 0;
        })) result.colwidth = undefined;
    }
    return result;
}
function $109c09578ebe8447$export$6fccdf7cee1b5201(attrs) {
    if (typeof attrs.colspan === 'undefined') throw new Error('addColSpan: attrs.colspan is not defined');
    if (typeof attrs.colspan !== 'number' || Number.isNaN(attrs.colspan) || attrs.colspan < 1) throw new Error("addColSpan: attrs.colspan must be number >= 1, received: ".concat(attrs.colspan));
}
function $109c09578ebe8447$export$147ee78a1321ac36(attrs, pos) {
    var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
    $109c09578ebe8447$export$6fccdf7cee1b5201(attrs);
    var result = $109c09578ebe8447$var$_objectSpread($109c09578ebe8447$var$_objectSpread({}, attrs), {}, {
        colspan: attrs.colspan + n
    });
    if (result.colwidth) {
        result.colwidth = result.colwidth.slice();
        for(var i = 0; i < n; i++)result.colwidth.splice(pos, 0, 0);
    }
    return result;
}



var $l8uaJ = parcelRequire("l8uaJ");

function $c34a21f50a4a8dbc$export$a60a444208fd5099($anchorCell, $headCell) {
    var table = $anchorCell.node(-1);
    var map = (0, $be3f6291b33bf3ca$export$493da463fed0a57a).get(table);
    var start = $anchorCell.start(-1);
    var rect = map.rectBetween($anchorCell.pos - start, $headCell.pos - start);
    var doc = $anchorCell.node(0);
    var cells = map.cellsInRect(rect).filter(function(p) {
        return p !== $headCell.pos - start;
    });
    // Make the head cell the first range, so that it counts as the
    // primary part of the selection
    cells.unshift($headCell.pos - start);
    return cells.map(function(pos) {
        var cell = table.nodeAt(pos);
        if (cell === null) throw new Error("No cell at position ".concat(pos));
        var from = pos + start + 1;
        return new (0, $l8uaJ.SelectionRange)(doc.resolve(from), doc.resolve(from + cell.content.size));
    });
}



function $b4d25baa1ccdc40b$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $b4d25baa1ccdc40b$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $b4d25baa1ccdc40b$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $b4d25baa1ccdc40b$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $b4d25baa1ccdc40b$var$_callSuper(t, o, e) {
    return o = (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(o), (0, (/*@__PURE__*/$parcel$interopDefault($kIXpt)))(t, $b4d25baa1ccdc40b$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(t).constructor) : o.apply(t, e));
}
function $b4d25baa1ccdc40b$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($b4d25baa1ccdc40b$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $b4d25baa1ccdc40b$export$831cc7e2a83afa94 = /*#__PURE__*/ function(_Selection) {
    // :: (ResolvedPos, ?ResolvedPos)
    // A table selection is identified by its anchor and head cells. The
    // positions given to this constructor should point _before_ two
    // cells in the same table. They may be the same, to select a single
    // cell.
    function CellSelection($anchorCell) {
        var _this;
        var $headCell = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $anchorCell;
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, CellSelection);
        var ranges = (0, $c34a21f50a4a8dbc$export$a60a444208fd5099)($anchorCell, $headCell);
        _this = $b4d25baa1ccdc40b$var$_callSuper(this, CellSelection, [
            ranges[0].$from,
            ranges[0].$to,
            ranges
        ]);
        // :: ResolvedPos
        // A resolved position pointing _in front of_ the anchor cell (the one
        // that doesn't move when extending the selection).
        _this.$anchorCell = $anchorCell;
        // :: ResolvedPos
        // A resolved position pointing in front of the head cell (the one
        // moves when extending the selection).
        _this.$headCell = $headCell;
        _this.visible = false;
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($eyuDe)))(CellSelection, _Selection);
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(CellSelection, [
        {
            key: "map",
            value: function map(doc, mapping) {
                var $anchorCell = doc.resolve(mapping.map(this.$anchorCell.pos));
                var $headCell = doc.resolve(mapping.map(this.$headCell.pos));
                if ((0, $f2ed471e3ef4fd00$export$3c89e45c7dff9619)($anchorCell) && (0, $f2ed471e3ef4fd00$export$3c89e45c7dff9619)($headCell) && (0, $0aa60fed10b264a8$export$debd62b44eb7e281)($anchorCell, $headCell)) {
                    var tableChanged = this.$anchorCell.node(-1) !== $anchorCell.node(-1);
                    if (tableChanged && this.isRowSelection()) return CellSelection.rowSelection($anchorCell, $headCell);
                    if (tableChanged && this.isColSelection()) return CellSelection.colSelection($anchorCell, $headCell);
                    return new CellSelection($anchorCell, $headCell);
                }
                return (0, $l8uaJ.TextSelection).between($anchorCell, $headCell);
            }
        },
        {
            key: "content",
            value: function content() {
                var table = this.$anchorCell.node(-1);
                var map = (0, $be3f6291b33bf3ca$export$493da463fed0a57a).get(table);
                var start = this.$anchorCell.start(-1);
                var rect = map.rectBetween(this.$anchorCell.pos - start, this.$headCell.pos - start);
                var seen = {};
                var rows = [];
                for(var row = rect.top; row < rect.bottom; row++){
                    var rowContent = [];
                    for(var index = row * map.width + rect.left, col = rect.left; col < rect.right; col++, index++){
                        var pos = map.map[index];
                        if (!seen[pos]) {
                            seen[pos] = true;
                            var cellRect = map.findCell(pos);
                            var cell = table.nodeAt(pos);
                            if (cell === null || cell === undefined) throw new Error("No cell at position ".concat(pos));
                            var extraLeft = rect.left - cellRect.left;
                            var extraRight = cellRect.right - rect.right;
                            if (extraLeft > 0 || extraRight > 0) {
                                var _cell = cell, attrs = _cell.attrs;
                                if (!attrs) throw new Error("No cell at position ".concat(pos));
                                if (extraLeft > 0) attrs = (0, $109c09578ebe8447$export$b24d9c3cc95412e0)(attrs, 0, extraLeft);
                                if (extraRight > 0) // Ignored via go/ees005
                                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                                attrs = (0, $109c09578ebe8447$export$b24d9c3cc95412e0)(attrs, attrs.colspan - extraRight, extraRight);
                                if (cellRect.left < rect.left) cell = cell.type.createAndFill(attrs);
                                else cell = cell.type.create(attrs, cell.content);
                            }
                            if (cell === null || cell === undefined) throw new Error("No cell at position after create/createAndFill");
                            if (cellRect.top < rect.top || cellRect.bottom > rect.bottom) {
                                var _attrs = $b4d25baa1ccdc40b$var$_objectSpread($b4d25baa1ccdc40b$var$_objectSpread({}, cell.attrs), {}, {
                                    rowspan: Math.min(cellRect.bottom, rect.bottom) - Math.max(cellRect.top, rect.top)
                                });
                                if (cellRect.top < rect.top) cell = cell.type.createAndFill(_attrs);
                                else cell = cell.type.create(_attrs, cell.content);
                            }
                            if (cell === null || cell === undefined) throw new Error("No cell at position before rowContent.push");
                            rowContent.push(cell);
                        }
                    }
                    var rowNode = table.child(row).copy((0, $2gI99.Fragment).from(rowContent));
                    rows.push(rowNode);
                }
                var fragment = this.isColSelection() && this.isRowSelection() ? table : rows;
                return new (0, $2gI99.Slice)((0, $2gI99.Fragment).from(fragment), 1, 1);
            }
        },
        {
            key: "replace",
            value: function replace(tr) {
                var content = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (0, $2gI99.Slice).empty;
                var mapFrom = tr.steps.length;
                var ranges = this.ranges;
                for(var i = 0; i < ranges.length; i++){
                    var _ranges$i = ranges[i], $from = _ranges$i.$from, $to = _ranges$i.$to;
                    var mapping = tr.mapping.slice(mapFrom);
                    tr.replace(mapping.map($from.pos), mapping.map($to.pos), i ? (0, $2gI99.Slice).empty : content);
                }
                var sel = (0, $l8uaJ.Selection).findFrom(tr.doc.resolve(tr.mapping.slice(mapFrom).map(this.to)), -1);
                if (sel) tr.setSelection(sel);
            }
        },
        {
            key: "replaceWith",
            value: function replaceWith(tr, node) {
                this.replace(tr, new (0, $2gI99.Slice)((0, $2gI99.Fragment).from(node), 0, 0));
            }
        },
        {
            key: "forEachCell",
            value: function forEachCell(f) {
                var table = this.$anchorCell.node(-1);
                var map = (0, $be3f6291b33bf3ca$export$493da463fed0a57a).get(table);
                var start = this.$anchorCell.start(-1);
                var cells = map.cellsInRect(map.rectBetween(this.$anchorCell.pos - start, this.$headCell.pos - start));
                for(var i = 0; i < cells.length; i++){
                    var cell = table.nodeAt(cells[i]);
                    if (cell === null || cell === undefined) throw new Error("undefined cell at pos ".concat(cells[i]));
                    f(cell, start + cells[i]);
                }
            }
        },
        {
            key: "isColSelection",
            value: function isColSelection() {
                if (!this.$anchorCell || !this.$headCell) throw new Error('invalid $anchorCell or $headCell');
                var anchorTop = this.$anchorCell.index(-1);
                var headTop = this.$headCell.index(-1);
                if (Math.min(anchorTop, headTop) > 0) return false;
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                var anchorBot = anchorTop + this.$anchorCell.nodeAfter.attrs.rowspan;
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                var headBot = headTop + this.$headCell.nodeAfter.attrs.rowspan;
                return Math.max(anchorBot, headBot) === this.$headCell.node(-1).childCount;
            }
        },
        {
            key: "isRowSelection",
            value: // :: () → bool
            // True if this selection goes all the way from the left to the
            // right of the table.
            function isRowSelection() {
                if (!this.$anchorCell || !this.$headCell) return false;
                var start = this.$anchorCell.start(-1);
                var map = (0, $be3f6291b33bf3ca$export$493da463fed0a57a).get(this.$anchorCell.node(-1));
                var rowAtAnchorCell = map.rowCount(this.$anchorCell.pos - start);
                var rowAtHeadCell = map.rowCount(this.$headCell.pos - start);
                var isSelectionSameRow = rowAtAnchorCell === rowAtHeadCell;
                // if anchor and head in the same line, counting how many cells
                // should be in the row except merged cell
                var maxColumnInSelectedRow = map.getMaxColInRow(this.$anchorCell);
                // if selected cells less than table max column amount, and
                // the anchor/head not in a merged cell
                // it should be select maxColumnInSelectedRow to be TRUE
                if (isSelectionSameRow && this.ranges.length <= map.width && !map.isPosMerged(this.$anchorCell.pos - start) && !map.isPosMerged(this.$headCell.pos - start)) return this.ranges.length === maxColumnInSelectedRow;
                // If anchor and head in different row, it should be always in first and
                // last column to select the whole row.
                var anchorLeft = map.colCount(this.$anchorCell.pos - start);
                var headLeft = map.colCount(this.$headCell.pos - start);
                if (Math.min(anchorLeft, headLeft) > 0) return false;
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                var anchorRight = anchorLeft + this.$anchorCell.nodeAfter.attrs.colspan;
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                var headRight = headLeft + this.$headCell.nodeAfter.attrs.colspan;
                return Math.max(anchorRight, headRight) === map.width;
            }
        },
        {
            key: "eq",
            value: function eq(other) {
                return other instanceof CellSelection && other.$anchorCell.pos === this.$anchorCell.pos && other.$headCell.pos === this.$headCell.pos;
            }
        },
        {
            key: "toJSON",
            value: function toJSON() {
                return {
                    type: 'cell',
                    anchor: this.$anchorCell.pos,
                    head: this.$headCell.pos
                };
            }
        },
        {
            key: "getBookmark",
            value: function getBookmark() {
                return new (0, $d5be41131738196c$export$ca751a6394ad160e)(this.$anchorCell.pos, this.$headCell.pos);
            }
        }
    ], [
        {
            key: "colSelection",
            value: function colSelection($anchorCell) {
                var $headCell = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $anchorCell;
                var $calculatedAnchorCell = $anchorCell;
                var $calculatedHeadCell = $headCell;
                var map = (0, $be3f6291b33bf3ca$export$493da463fed0a57a).get($calculatedAnchorCell.node(-1));
                var start = $calculatedAnchorCell.start(-1);
                var anchorRect = map.findCell($calculatedAnchorCell.pos - start);
                var headRect = map.findCell($calculatedHeadCell.pos - start);
                var doc = $calculatedAnchorCell.node(0);
                if (anchorRect.top <= headRect.top) {
                    if (anchorRect.top > 0) $calculatedAnchorCell = doc.resolve(start + map.map[anchorRect.left]);
                    if (headRect.bottom < map.height) $calculatedHeadCell = doc.resolve(start + map.map[map.width * (map.height - 1) + headRect.right - 1]);
                } else {
                    if (headRect.top > 0) $calculatedHeadCell = doc.resolve(start + map.map[headRect.left]);
                    if (anchorRect.bottom < map.height) $calculatedAnchorCell = doc.resolve(start + map.map[map.width * (map.height - 1) + anchorRect.right - 1]);
                }
                return new CellSelection($calculatedAnchorCell, $calculatedHeadCell);
            }
        },
        {
            key: "rowSelection",
            value: function rowSelection($anchorCell) {
                var $headCell = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $anchorCell;
                var reverse = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
                var $calculatedAnchorCell = $anchorCell;
                var $calculatedHeadCell = $headCell;
                var map = (0, $be3f6291b33bf3ca$export$493da463fed0a57a).get($calculatedAnchorCell.node(-1));
                var start = $calculatedAnchorCell.start(-1);
                var anchorRect = map.findCell($calculatedAnchorCell.pos - start);
                var headRect = map.findCell($calculatedHeadCell.pos - start);
                var doc = $calculatedAnchorCell.node(0);
                if (anchorRect.left <= headRect.left) {
                    if (anchorRect.left > 0) $calculatedAnchorCell = doc.resolve(start + map.map[anchorRect.top * map.width]);
                    if (headRect.right < map.width) $calculatedHeadCell = doc.resolve(start + map.map[map.width * (headRect.top + 1) - 1]);
                } else {
                    if (headRect.left > 0) $calculatedHeadCell = doc.resolve(start + map.map[headRect.top * map.width]);
                    if (anchorRect.right < map.width) $calculatedAnchorCell = doc.resolve(start + map.map[map.width * (anchorRect.top + 1) - 1]);
                }
                return reverse ? new CellSelection($calculatedHeadCell, $calculatedAnchorCell) : new CellSelection($calculatedAnchorCell, $calculatedHeadCell);
            }
        },
        {
            key: "fromJSON",
            value: function fromJSON(doc, json) {
                return new CellSelection(doc.resolve(json.anchor), doc.resolve(json.head));
            }
        },
        {
            key: "create",
            value: function create(doc, anchorCell) {
                var headCell = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : anchorCell;
                return new CellSelection(doc.resolve(anchorCell), doc.resolve(headCell));
            }
        }
    ]);
}((0, $l8uaJ.Selection));
(0, $l8uaJ.Selection).jsonID('cell', $b4d25baa1ccdc40b$export$831cc7e2a83afa94);


var $577d48613d9afb24$export$be87849653b93e6b = function getAnalyticsAppearance(appearance) {
    switch(appearance){
        case 'full-page':
            return (0, $kHFeb.EDITOR_APPEARANCE_CONTEXT).FIXED_WIDTH;
        case 'full-width':
            return (0, $kHFeb.EDITOR_APPEARANCE_CONTEXT).FULL_WIDTH;
        case 'comment':
            return (0, $kHFeb.EDITOR_APPEARANCE_CONTEXT).COMMENT;
        case 'chromeless':
            return (0, $kHFeb.EDITOR_APPEARANCE_CONTEXT).CHROMELESS;
        case 'mobile':
            return (0, $kHFeb.EDITOR_APPEARANCE_CONTEXT).MOBILE;
        case 'max':
            return (0, $kHFeb.EDITOR_APPEARANCE_CONTEXT).MAX;
    }
};
var $577d48613d9afb24$export$31ae53e002edded0 = function getAnalyticsEditorAppearance(editorAppearance) {
    return editorAppearance ? "editor_".concat($577d48613d9afb24$export$be87849653b93e6b(editorAppearance)) : '_unknown';
};
var $577d48613d9afb24$export$f8edd689e8b20f3a = function getAnalyticsEventSeverity(duration, normalThreshold, degradedThreshold) {
    if (duration > normalThreshold && duration <= degradedThreshold) return $577d48613d9afb24$export$6a6bef12562cd865.DEGRADED;
    if (duration > degradedThreshold) return $577d48613d9afb24$export$6a6bef12562cd865.BLOCKING;
    return $577d48613d9afb24$export$6a6bef12562cd865.NORMAL;
};
function $577d48613d9afb24$export$d770b562ead089d8(selection) {
    var _selection$$from$doc$ = selection.$from.doc.type, schema = _selection$$from$doc$.schema, name = _selection$$from$doc$.name;
    if (selection instanceof (0, $cc08P.NodeSelection)) return selection.node.type.name;
    if (selection instanceof (0, $b4d25baa1ccdc40b$export$831cc7e2a83afa94)) return schema.nodes.table.name;
    // Text selection
    var parentNodeInfo = (0, $4inI8.findParentNode)(function(node) {
        return node.type !== schema.nodes.paragraph;
    })(selection);
    return parentNodeInfo ? parentNodeInfo.node.type.name : name;
}
var $577d48613d9afb24$export$6a6bef12562cd865 = /*#__PURE__*/ function(SEVERITY) {
    SEVERITY["NORMAL"] = "normal";
    SEVERITY["DEGRADED"] = "degraded";
    SEVERITY["BLOCKING"] = "blocking";
    return SEVERITY;
}({});
var $577d48613d9afb24$export$288273ee3e3b6132 = 'EDITOR_ANALYTICS_EVENT';
var $577d48613d9afb24$var$EDITOR_BREAKPOINT_WIDTH = {
    S: 760,
    M: 1600,
    L: Infinity
};
var $577d48613d9afb24$var$TABLE_BREAKPOINT_KEYS = Object.keys($577d48613d9afb24$var$EDITOR_BREAKPOINT_WIDTH);
var $577d48613d9afb24$export$afdcbbd112676ca8 = function getBreakpointKey(width) {
    return $577d48613d9afb24$var$TABLE_BREAKPOINT_KEYS.find(function(key) {
        return width <= $577d48613d9afb24$var$EDITOR_BREAKPOINT_WIDTH[key];
    }) || 'L';
};

// START: temporary code https://product-fabric.atlassian.net/browse/ED-10260
var $52c73f50bcd8b255$export$5b59d3e9e22dbdc6 = function shouldForceTracking() {
    try {
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        var _ref = window.__buildInfo || {}, _ref$FRONTEND_VERSION = _ref.FRONTEND_VERSION, FRONTEND_VERSION = _ref$FRONTEND_VERSION === void 0 ? '' : _ref$FRONTEND_VERSION;
        return window.location.hostname === 'product-fabric.atlassian.net' && FRONTEND_VERSION.includes('branch-deploy');
    } catch (err) {
        // eslint-disable-next-line no-console
        console.warn(err);
        return false;
    }
}; // END:  temporary code  https://product-fabric.atlassian.net/browse/ED-10260



var $9Zzpd = parcelRequire("9Zzpd");

var $2H1dZ = parcelRequire("2H1dZ");
parcelRequire("2WYRt");
var $kHFeb = parcelRequire("kHFeb");

var $jJH6F = parcelRequire("jJH6F");

var $iYJcE = parcelRequire("iYJcE");

var $ekGgq = parcelRequire("ekGgq");
var $e07a6647be522254$exports = {};
var $31ae822182fad2a0$exports = {};

var $duo48 = parcelRequire("duo48");
var $c7f6974ab15fcc4d$exports = {};
var $9362cde0037d9446$exports = {};

var $5rVTQ = parcelRequire("5rVTQ");

var $3gUX4 = parcelRequire("3gUX4");

var $aqMZB = parcelRequire("aqMZB");

var $duo48 = parcelRequire("duo48");
/**
 * Creates a function like `_.lowerFirst`.
 *
 * @private
 * @param {string} methodName The name of the `String` case method to use.
 * @returns {Function} Returns the new case function.
 */ function $9362cde0037d9446$var$createCaseFirst(methodName) {
    return function(string) {
        string = $duo48(string);
        var strSymbols = $3gUX4(string) ? $aqMZB(string) : undefined;
        var chr = strSymbols ? strSymbols[0] : string.charAt(0);
        var trailing = strSymbols ? $5rVTQ(strSymbols, 1).join('') : string.slice(1);
        return chr[methodName]() + trailing;
    };
}
$9362cde0037d9446$exports = $9362cde0037d9446$var$createCaseFirst;


/**
 * Converts the first character of `string` to upper case.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.upperFirst('fred');
 * // => 'Fred'
 *
 * _.upperFirst('FRED');
 * // => 'FRED'
 */ var $c7f6974ab15fcc4d$var$upperFirst = $9362cde0037d9446$exports('toUpperCase');
$c7f6974ab15fcc4d$exports = $c7f6974ab15fcc4d$var$upperFirst;


/**
 * Converts the first character of `string` to upper case and the remaining
 * to lower case.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to capitalize.
 * @returns {string} Returns the capitalized string.
 * @example
 *
 * _.capitalize('FRED');
 * // => 'Fred'
 */ function $31ae822182fad2a0$var$capitalize(string) {
    return $c7f6974ab15fcc4d$exports($duo48(string).toLowerCase());
}
$31ae822182fad2a0$exports = $31ae822182fad2a0$var$capitalize;


var $ae50d2e87a5da0cc$exports = {};
var $62a63c1eb65a1440$exports = {};
/**
 * A specialized version of `_.reduce` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @param {boolean} [initAccum] Specify using the first element of `array` as
 *  the initial value.
 * @returns {*} Returns the accumulated value.
 */ function $62a63c1eb65a1440$var$arrayReduce(array, iteratee, accumulator, initAccum) {
    var index = -1, length = array == null ? 0 : array.length;
    if (initAccum && length) accumulator = array[++index];
    while(++index < length)accumulator = iteratee(accumulator, array[index], index, array);
    return accumulator;
}
$62a63c1eb65a1440$exports = $62a63c1eb65a1440$var$arrayReduce;



var $l75Tm = parcelRequire("l75Tm");
var $e7dc26b72a5cbbb7$exports = {};
var $14f580510cd13668$exports = {};
/** Used to match words composed of alphanumeric characters. */ var $14f580510cd13668$var$reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
/**
 * Splits an ASCII `string` into an array of its words.
 *
 * @private
 * @param {string} The string to inspect.
 * @returns {Array} Returns the words of `string`.
 */ function $14f580510cd13668$var$asciiWords(string) {
    return string.match($14f580510cd13668$var$reAsciiWord) || [];
}
$14f580510cd13668$exports = $14f580510cd13668$var$asciiWords;


var $9f5ddde4b9906afb$exports = {};
/** Used to detect strings that need a more robust regexp to match words. */ var $9f5ddde4b9906afb$var$reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
/**
 * Checks if `string` contains a word composed of Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a word is found, else `false`.
 */ function $9f5ddde4b9906afb$var$hasUnicodeWord(string) {
    return $9f5ddde4b9906afb$var$reHasUnicodeWord.test(string);
}
$9f5ddde4b9906afb$exports = $9f5ddde4b9906afb$var$hasUnicodeWord;



var $duo48 = parcelRequire("duo48");
var $aa870181a19f30d4$exports = {};
/** Used to compose unicode character classes. */ var $aa870181a19f30d4$var$rsAstralRange = '\\ud800-\\udfff', $aa870181a19f30d4$var$rsComboMarksRange = '\\u0300-\\u036f', $aa870181a19f30d4$var$reComboHalfMarksRange = '\\ufe20-\\ufe2f', $aa870181a19f30d4$var$rsComboSymbolsRange = '\\u20d0-\\u20ff', $aa870181a19f30d4$var$rsComboRange = $aa870181a19f30d4$var$rsComboMarksRange + $aa870181a19f30d4$var$reComboHalfMarksRange + $aa870181a19f30d4$var$rsComboSymbolsRange, $aa870181a19f30d4$var$rsDingbatRange = '\\u2700-\\u27bf', $aa870181a19f30d4$var$rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff', $aa870181a19f30d4$var$rsMathOpRange = '\\xac\\xb1\\xd7\\xf7', $aa870181a19f30d4$var$rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf', $aa870181a19f30d4$var$rsPunctuationRange = '\\u2000-\\u206f', $aa870181a19f30d4$var$rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000', $aa870181a19f30d4$var$rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde', $aa870181a19f30d4$var$rsVarRange = '\\ufe0e\\ufe0f', $aa870181a19f30d4$var$rsBreakRange = $aa870181a19f30d4$var$rsMathOpRange + $aa870181a19f30d4$var$rsNonCharRange + $aa870181a19f30d4$var$rsPunctuationRange + $aa870181a19f30d4$var$rsSpaceRange;
/** Used to compose unicode capture groups. */ var $aa870181a19f30d4$var$rsApos = "['\u2019]", $aa870181a19f30d4$var$rsBreak = '[' + $aa870181a19f30d4$var$rsBreakRange + ']', $aa870181a19f30d4$var$rsCombo = '[' + $aa870181a19f30d4$var$rsComboRange + ']', $aa870181a19f30d4$var$rsDigits = '\\d+', $aa870181a19f30d4$var$rsDingbat = '[' + $aa870181a19f30d4$var$rsDingbatRange + ']', $aa870181a19f30d4$var$rsLower = '[' + $aa870181a19f30d4$var$rsLowerRange + ']', $aa870181a19f30d4$var$rsMisc = '[^' + $aa870181a19f30d4$var$rsAstralRange + $aa870181a19f30d4$var$rsBreakRange + $aa870181a19f30d4$var$rsDigits + $aa870181a19f30d4$var$rsDingbatRange + $aa870181a19f30d4$var$rsLowerRange + $aa870181a19f30d4$var$rsUpperRange + ']', $aa870181a19f30d4$var$rsFitz = '\\ud83c[\\udffb-\\udfff]', $aa870181a19f30d4$var$rsModifier = '(?:' + $aa870181a19f30d4$var$rsCombo + '|' + $aa870181a19f30d4$var$rsFitz + ')', $aa870181a19f30d4$var$rsNonAstral = '[^' + $aa870181a19f30d4$var$rsAstralRange + ']', $aa870181a19f30d4$var$rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}', $aa870181a19f30d4$var$rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]', $aa870181a19f30d4$var$rsUpper = '[' + $aa870181a19f30d4$var$rsUpperRange + ']', $aa870181a19f30d4$var$rsZWJ = '\\u200d';
/** Used to compose unicode regexes. */ var $aa870181a19f30d4$var$rsMiscLower = '(?:' + $aa870181a19f30d4$var$rsLower + '|' + $aa870181a19f30d4$var$rsMisc + ')', $aa870181a19f30d4$var$rsMiscUpper = '(?:' + $aa870181a19f30d4$var$rsUpper + '|' + $aa870181a19f30d4$var$rsMisc + ')', $aa870181a19f30d4$var$rsOptContrLower = '(?:' + $aa870181a19f30d4$var$rsApos + '(?:d|ll|m|re|s|t|ve))?', $aa870181a19f30d4$var$rsOptContrUpper = '(?:' + $aa870181a19f30d4$var$rsApos + '(?:D|LL|M|RE|S|T|VE))?', $aa870181a19f30d4$var$reOptMod = $aa870181a19f30d4$var$rsModifier + '?', $aa870181a19f30d4$var$rsOptVar = '[' + $aa870181a19f30d4$var$rsVarRange + ']?', $aa870181a19f30d4$var$rsOptJoin = '(?:' + $aa870181a19f30d4$var$rsZWJ + '(?:' + [
    $aa870181a19f30d4$var$rsNonAstral,
    $aa870181a19f30d4$var$rsRegional,
    $aa870181a19f30d4$var$rsSurrPair
].join('|') + ')' + $aa870181a19f30d4$var$rsOptVar + $aa870181a19f30d4$var$reOptMod + ')*', $aa870181a19f30d4$var$rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])', $aa870181a19f30d4$var$rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])', $aa870181a19f30d4$var$rsSeq = $aa870181a19f30d4$var$rsOptVar + $aa870181a19f30d4$var$reOptMod + $aa870181a19f30d4$var$rsOptJoin, $aa870181a19f30d4$var$rsEmoji = '(?:' + [
    $aa870181a19f30d4$var$rsDingbat,
    $aa870181a19f30d4$var$rsRegional,
    $aa870181a19f30d4$var$rsSurrPair
].join('|') + ')' + $aa870181a19f30d4$var$rsSeq;
/** Used to match complex or compound words. */ var $aa870181a19f30d4$var$reUnicodeWord = RegExp([
    $aa870181a19f30d4$var$rsUpper + '?' + $aa870181a19f30d4$var$rsLower + '+' + $aa870181a19f30d4$var$rsOptContrLower + '(?=' + [
        $aa870181a19f30d4$var$rsBreak,
        $aa870181a19f30d4$var$rsUpper,
        '$'
    ].join('|') + ')',
    $aa870181a19f30d4$var$rsMiscUpper + '+' + $aa870181a19f30d4$var$rsOptContrUpper + '(?=' + [
        $aa870181a19f30d4$var$rsBreak,
        $aa870181a19f30d4$var$rsUpper + $aa870181a19f30d4$var$rsMiscLower,
        '$'
    ].join('|') + ')',
    $aa870181a19f30d4$var$rsUpper + '?' + $aa870181a19f30d4$var$rsMiscLower + '+' + $aa870181a19f30d4$var$rsOptContrLower,
    $aa870181a19f30d4$var$rsUpper + '+' + $aa870181a19f30d4$var$rsOptContrUpper,
    $aa870181a19f30d4$var$rsOrdUpper,
    $aa870181a19f30d4$var$rsOrdLower,
    $aa870181a19f30d4$var$rsDigits,
    $aa870181a19f30d4$var$rsEmoji
].join('|'), 'g');
/**
 * Splits a Unicode `string` into an array of its words.
 *
 * @private
 * @param {string} The string to inspect.
 * @returns {Array} Returns the words of `string`.
 */ function $aa870181a19f30d4$var$unicodeWords(string) {
    return string.match($aa870181a19f30d4$var$reUnicodeWord) || [];
}
$aa870181a19f30d4$exports = $aa870181a19f30d4$var$unicodeWords;


/**
 * Splits `string` into an array of its words.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to inspect.
 * @param {RegExp|string} [pattern] The pattern to match words.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Array} Returns the words of `string`.
 * @example
 *
 * _.words('fred, barney, & pebbles');
 * // => ['fred', 'barney', 'pebbles']
 *
 * _.words('fred, barney, & pebbles', /[^, ]+/g);
 * // => ['fred', 'barney', '&', 'pebbles']
 */ function $e7dc26b72a5cbbb7$var$words(string, pattern, guard) {
    string = $duo48(string);
    pattern = guard ? undefined : pattern;
    if (pattern === undefined) return $9f5ddde4b9906afb$exports(string) ? $aa870181a19f30d4$exports(string) : $14f580510cd13668$exports(string);
    return string.match(pattern) || [];
}
$e7dc26b72a5cbbb7$exports = $e7dc26b72a5cbbb7$var$words;


/** Used to compose unicode capture groups. */ var $ae50d2e87a5da0cc$var$rsApos = "['\u2019]";
/** Used to match apostrophes. */ var $ae50d2e87a5da0cc$var$reApos = RegExp($ae50d2e87a5da0cc$var$rsApos, 'g');
/**
 * Creates a function like `_.camelCase`.
 *
 * @private
 * @param {Function} callback The function to combine each word.
 * @returns {Function} Returns the new compounder function.
 */ function $ae50d2e87a5da0cc$var$createCompounder(callback) {
    return function(string) {
        return $62a63c1eb65a1440$exports($e7dc26b72a5cbbb7$exports($l75Tm(string).replace($ae50d2e87a5da0cc$var$reApos, '')), callback, '');
    };
}
$ae50d2e87a5da0cc$exports = $ae50d2e87a5da0cc$var$createCompounder;


/**
 * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the camel cased string.
 * @example
 *
 * _.camelCase('Foo Bar');
 * // => 'fooBar'
 *
 * _.camelCase('--foo-bar--');
 * // => 'fooBar'
 *
 * _.camelCase('__FOO_BAR__');
 * // => 'fooBar'
 */ var $e07a6647be522254$var$camelCase = $ae50d2e87a5da0cc$exports(function(result, word, index) {
    word = word.toLowerCase();
    return result + (index ? $31ae822182fad2a0$exports(word) : word);
});
$e07a6647be522254$exports = $e07a6647be522254$var$camelCase;


var $6e1a6a485b4d6431$exports = {};

/**
 * Converts `string` to
 * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the kebab cased string.
 * @example
 *
 * _.kebabCase('Foo Bar');
 * // => 'foo-bar'
 *
 * _.kebabCase('fooBar');
 * // => 'foo-bar'
 *
 * _.kebabCase('__FOO_BAR__');
 * // => 'foo-bar'
 */ var $6e1a6a485b4d6431$var$kebabCase = $ae50d2e87a5da0cc$exports(function(result, word, index) {
    return result + (index ? '-' : '') + word.toLowerCase();
});
$6e1a6a485b4d6431$exports = $6e1a6a485b4d6431$var$kebabCase;


var $e3d31a87077225d6$var$EMPTY = {};
function $e3d31a87077225d6$var$isObjectFlagKey(key, // Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
value, objectFlagKeys) {
    return Boolean(typeof value === 'string' && (objectFlagKeys === null || objectFlagKeys === void 0 ? void 0 : objectFlagKeys.includes(key)));
}
function $e3d31a87077225d6$var$isValidJSONObject(value) {
    try {
        var result = JSON.parse(value);
        if ((0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(result) === 'object' && result !== null) return true;
        return false;
    } catch (err) {
        return false;
    }
}
function $e3d31a87077225d6$export$f1485fc4974593c0(rawFeatureFlags, options) {
    if (!rawFeatureFlags) return $e3d31a87077225d6$var$EMPTY;
    return Object.entries(rawFeatureFlags).filter(function(e) {
        if (typeof e[1] === 'boolean') return true;
        if ($e3d31a87077225d6$var$isObjectFlagKey((0, (/*@__PURE__*/$parcel$interopDefault($e07a6647be522254$exports)))(e[0]), e[1], options === null || options === void 0 ? void 0 : options.objectFlagKeys) && $e3d31a87077225d6$var$isValidJSONObject(e[1])) return true;
        return false;
    }).filter(function(_ref) {
        var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_ref, 1), key = _ref2[0];
        return (0, (/*@__PURE__*/$parcel$interopDefault($6e1a6a485b4d6431$exports)))(key) === key;
    }).map(function(_ref3) {
        var _ref4 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_ref3, 2), key = _ref4[0], value = _ref4[1];
        return [
            (0, (/*@__PURE__*/$parcel$interopDefault($e07a6647be522254$exports)))(key),
            value
        ];
    }).reduce(function(flags, _ref5) {
        var _ref6 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_ref5, 2), key = _ref6[0], value = _ref6[1];
        if ($e3d31a87077225d6$var$isObjectFlagKey(key, value, options === null || options === void 0 ? void 0 : options.objectFlagKeys)) flags[key] = JSON.parse(value);
        if (typeof value === 'boolean') flags[key] = value;
        return flags;
    }, {});
}
function $e3d31a87077225d6$export$6d018dd0f6cbebcb(featureFlags) {
    return Object.keys(featureFlags).filter(function(key) {
        return featureFlags[key] === true;
    });
}



var $6JfQX = parcelRequire("6JfQX");

var $kqp0i = parcelRequire("kqp0i");

var $1Vcia = parcelRequire("1Vcia");

var $fC8ib = parcelRequire("fC8ib");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $25nEq = parcelRequire("25nEq");

var $5FkrB = parcelRequire("5FkrB");

var $2gI99 = parcelRequire("2gI99");

var $drUcN = parcelRequire("drUcN");

var $fAhSf = parcelRequire("fAhSf");
parcelRequire("9M0Oh");
var $ac0Rs = parcelRequire("ac0Rs");
var $9M0Oh = parcelRequire("9M0Oh");

var $5FkrB = parcelRequire("5FkrB");

var $kqp0i = parcelRequire("kqp0i");

var $5FkrB = parcelRequire("5FkrB");

var $74Zh5 = parcelRequire("74Zh5");
var $e6e266389a291656$export$c1bd4813440b4505 = /*#__PURE__*/ function(InsertDraftPosition) {
    InsertDraftPosition["AROUND_TEXT"] = "AROUND_TEXT";
    InsertDraftPosition["START"] = "START";
    InsertDraftPosition["END"] = "END";
    InsertDraftPosition["INSIDE"] = "INSIDE";
    return InsertDraftPosition;
}({});



var $5FkrB = parcelRequire("5FkrB");
function $b44ac14cc36cbe03$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $b44ac14cc36cbe03$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $b44ac14cc36cbe03$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $b44ac14cc36cbe03$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $b44ac14cc36cbe03$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $b44ac14cc36cbe03$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
var $b44ac14cc36cbe03$export$a9795c84b22a1f06 = function findTextString(reactNode) {
    var result = null;
    var children = (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).Children.toArray(reactNode);
    var _iterator = $b44ac14cc36cbe03$var$_createForOfIteratorHelper(children), _step;
    try {
        for(_iterator.s(); !(_step = _iterator.n()).done;){
            var childNode = _step.value;
            if (result) break;
            else if (typeof childNode === 'string') result = childNode;
            else if ($b44ac14cc36cbe03$var$isReactElement(childNode) && childNode.props.children) result = $b44ac14cc36cbe03$export$a9795c84b22a1f06(childNode.props.children);
        }
    } catch (err) {
        _iterator.e(err);
    } finally{
        _iterator.f();
    }
    return result;
};
function $b44ac14cc36cbe03$var$isReactElement(child) {
    return !!child.type;
}
var $b44ac14cc36cbe03$export$2878cc467c8be8fe = function splitText(text, _ref) {
    var startOffset = _ref.startOffset, endOffset = _ref.endOffset;
    if (endOffset > text.length || endOffset - startOffset <= 0) return null;
    return [
        text.slice(0, startOffset),
        text.slice(startOffset, endOffset),
        text.slice(endOffset)
    ].filter(Boolean);
};
var $b44ac14cc36cbe03$export$1059bfc467f4f55d = function calcTextSplitOffset(position, textPosition, text) {
    var start = textPosition.start, end = textPosition.end;
    var startOffset = Math.max(position.from - start, 0);
    var endOffset = Math.min(Math.abs(end - position.to - text.length), text.length);
    return {
        startOffset: startOffset,
        endOffset: endOffset
    };
};



var $3aff10c8472757a3$export$b1baddbd5f289877 = function calcInsertDraftPositionOnText(_ref, position) {
    var startTextPosition = _ref.start, endTextPosition = _ref.end;
    var isRangePositionAroundText = position.from <= startTextPosition && position.to >= endTextPosition;
    if (isRangePositionAroundText) return (0, $e6e266389a291656$export$c1bd4813440b4505).AROUND_TEXT;
    var isRangePositionInsideText = position.from > startTextPosition && position.from < endTextPosition && position.to < endTextPosition && position.to > startTextPosition;
    if (isRangePositionInsideText) return (0, $e6e266389a291656$export$c1bd4813440b4505).INSIDE;
    var isRangePositionStartingAtText = position.from >= startTextPosition && position.from <= endTextPosition && position.to >= endTextPosition;
    if (isRangePositionStartingAtText) return (0, $e6e266389a291656$export$c1bd4813440b4505).END;
    var isRangePositionEndingAtText = position.from <= startTextPosition && position.to >= startTextPosition && position.to <= endTextPosition;
    if (isRangePositionEndingAtText) return (0, $e6e266389a291656$export$c1bd4813440b4505).START;
    return false;
};



var $eyRpM = parcelRequire("eyRpM");
function $da823e371d629bd7$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $da823e371d629bd7$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $da823e371d629bd7$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $da823e371d629bd7$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $da823e371d629bd7$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $da823e371d629bd7$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $da823e371d629bd7$export$93301b6f1ff0b0c3(text, highlighter) {
    if (!highlighter || !text) return [
        {
            type: 'plain',
            text: text !== null && text !== void 0 ? text : ''
        }
    ];
    var segments = [];
    var pos = 0;
    try {
        var markTextSegmentMatches = text.matchAll(highlighter.pattern);
        var _iterator = $da823e371d629bd7$var$_createForOfIteratorHelper(markTextSegmentMatches), _step;
        try {
            var _loop = function _loop() {
                var markTextMatch = _step.value;
                if (markTextMatch.index !== 0) segments.push({
                    type: 'plain',
                    text: text.substring(pos, markTextMatch.index)
                });
                segments.push({
                    type: 'match',
                    text: markTextMatch[0],
                    groups: markTextMatch.groups && // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    Object.keys(markTextMatch.groups).filter(function(key) {
                        return markTextMatch.groups[key];
                    })
                });
                pos = markTextMatch.index + markTextMatch[0].length;
            };
            for(_iterator.s(); !(_step = _iterator.n()).done;)_loop();
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
        if (pos < text.length) segments.push({
            type: 'plain',
            text: text.substring(pos)
        });
        return segments;
    } catch (_e) {}
    return [
        {
            type: 'plain',
            text: text
        }
    ];
}



var $5FkrB = parcelRequire("5FkrB");
function $00533252bf4c5c68$export$8a20fd0614851c5f(segments, textHighlighter, marksList, startPos) {
    var Component = textHighlighter === null || textHighlighter === void 0 ? void 0 : textHighlighter.component;
    var marks = new Set(marksList.map(function(m) {
        return m.type.name;
    }));
    function renderSegment(segment) {
        var idx = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
        if (segment.type === 'plain' || !Component) return segment.text;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("span", {
            "data-highlighted": true,
            "data-vc": "highlighted-text"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(Component, {
            match: segment.text,
            groups: segment.groups,
            marks: marks,
            key: "".concat(segment.text, "_").concat(startPos, "_").concat(idx),
            startPos: startPos + idx
        }, segment.text));
    }
    if (segments.length === 1) return renderSegment(segments[0]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).Fragment, {
        key: "text-wrapper_".concat(startPos)
    }, segments.map(renderSegment));
}



var $fDwDe = parcelRequire("fDwDe");

var $38vNc = parcelRequire("38vNc");
// Localized AnnotationSharedCSSByState().common and AnnotationSharedCSSByState().focus
var $cd97ba6fc7bf5abf$var$markStyles = (0, $74Zh5.css)({
    color: 'inherit',
    backgroundColor: 'unset',
    WebkitTapHighlightColor: 'transparent',
    borderBottom: "var(--ds-border-width-selected, 2px)".concat(" solid transparent"),
    cursor: 'pointer',
    padding: '1px 0 2px',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
    '&:has(.card), &:has([data-inline-card])': {
        padding: '5px 0 3px 0'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
    '&:has(.date-lozenger-container)': {
        paddingTop: "var(--ds-space-025, 2px)"
    },
    background: "var(--ds-background-accent-yellow-subtlest-pressed, #EFDD4E)",
    borderBottomColor: "var(--ds-border-accent-yellow, #B38600)",
    boxShadow: "var(--ds-shadow-overlay, 0px 8px 12px #1E1F2126, 0px 0px 1px #1E1F214f)"
});
var $cd97ba6fc7bf5abf$export$8062d68eccdfa39c = function AnnotationDraft(_ref) {
    var draftPosition = _ref.draftPosition, children = _ref.children;
    var _useAnnotationManager = (0, $fDwDe.useAnnotationManagerDispatch)(), dispatch = _useAnnotationManager.dispatch;
    var markRef = (0, $5FkrB.useCallback)(function(node) {
        dispatch({
            type: 'setDraftMarkRef',
            data: {
                draftMarkRef: node !== null && node !== void 0 ? node : undefined
            }
        });
    }, [
        dispatch
    ]);
    return (0, $74Zh5.jsx)("mark", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        "data-renderer-mark": true
    }, (0, $eyRpM.dataAttributes)(draftPosition), {
        css: $cd97ba6fc7bf5abf$var$markStyles,
        ref: markRef
    }), children);
};
var $cd97ba6fc7bf5abf$export$846ef6158669db08 = function getAnnotationIndex(annotationPosition, fragmentCount) {
    if (annotationPosition === (0, $e6e266389a291656$export$c1bd4813440b4505).START) return 0;
    if (annotationPosition === (0, $e6e266389a291656$export$c1bd4813440b4505).END) return fragmentCount - 1;
    if (annotationPosition === (0, $e6e266389a291656$export$c1bd4813440b4505).INSIDE && fragmentCount === 3) return 1;
    return -1;
};
var $cd97ba6fc7bf5abf$export$b756d37afc321d72 = function applyAnnotationOnText(_ref2) {
    var texts = _ref2.texts, shouldApplyAnnotationAt = _ref2.shouldApplyAnnotationAt, draftPosition = _ref2.draftPosition, textHighlighter = _ref2.textHighlighter, marks = _ref2.marks;
    var annotateIndex = $cd97ba6fc7bf5abf$export$846ef6158669db08(shouldApplyAnnotationAt, texts.length);
    return texts.map(function(value, index) {
        var segments = (0, $da823e371d629bd7$export$93301b6f1ff0b0c3)(value, textHighlighter);
        if (annotateIndex === index) return(// Ignored via go/ees005
        // eslint-disable-next-line react/no-array-index-key
        (0, $74Zh5.jsx)($cd97ba6fc7bf5abf$export$8062d68eccdfa39c, {
            key: index,
            draftPosition: draftPosition
        }, (0, $00533252bf4c5c68$export$8a20fd0614851c5f)(segments, textHighlighter, marks || [], draftPosition.from)));
        return(// Ignored via go/ees005
        // eslint-disable-next-line react/no-array-index-key
        (0, $74Zh5.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).Fragment, {
            key: index
        }, (0, $00533252bf4c5c68$export$8a20fd0614851c5f)(segments, textHighlighter, marks || [], draftPosition.from)));
    });
};
var $cd97ba6fc7bf5abf$export$69a4e0ac39aaf9b7 = function TextWithAnnotationDraft(_ref3) {
    var startPos = _ref3.startPos, endPos = _ref3.endPos, children = _ref3.children, textHighlighter = _ref3.textHighlighter, marks = _ref3.marks;
    var textPosition = (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).useMemo(function() {
        return {
            start: startPos,
            end: endPos
        };
    }, [
        endPos,
        startPos
    ]);
    var _useAnnotationRangeSt = (0, $38vNc.useAnnotationRangeState)(), nextDraftPosition = _useAnnotationRangeSt.selectionDraftDocumentPosition;
    var shouldApplyAnnotationAt = (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).useMemo(function() {
        if (!nextDraftPosition) return false;
        return (0, $3aff10c8472757a3$export$b1baddbd5f289877)(textPosition, nextDraftPosition);
    }, [
        nextDraftPosition,
        textPosition
    ]);
    var textString = (0, $b44ac14cc36cbe03$export$a9795c84b22a1f06)(children);
    if (!textString) return (0, $74Zh5.jsx)((0, $5FkrB.Fragment), null, children);
    if (shouldApplyAnnotationAt === false || !nextDraftPosition) {
        var segments = (0, $da823e371d629bd7$export$93301b6f1ff0b0c3)(textString, textHighlighter);
        return (0, $74Zh5.jsx)((0, $5FkrB.Fragment), null, (0, $00533252bf4c5c68$export$8a20fd0614851c5f)(segments, textHighlighter, marks || [], startPos));
    }
    if (shouldApplyAnnotationAt === (0, $e6e266389a291656$export$c1bd4813440b4505).AROUND_TEXT) {
        var _segments = (0, $da823e371d629bd7$export$93301b6f1ff0b0c3)(textString, textHighlighter);
        return (0, $74Zh5.jsx)($cd97ba6fc7bf5abf$export$8062d68eccdfa39c, {
            key: 0,
            draftPosition: nextDraftPosition
        }, (0, $00533252bf4c5c68$export$8a20fd0614851c5f)(_segments, textHighlighter, marks || [], startPos));
    }
    var offsets = (0, $b44ac14cc36cbe03$export$1059bfc467f4f55d)(nextDraftPosition, textPosition, textString);
    var texts = (0, $b44ac14cc36cbe03$export$2878cc467c8be8fe)(textString, offsets);
    if (!texts) {
        var _segments2 = (0, $da823e371d629bd7$export$93301b6f1ff0b0c3)(textString, textHighlighter);
        return (0, $74Zh5.jsx)((0, $5FkrB.Fragment), null, (0, $00533252bf4c5c68$export$8a20fd0614851c5f)(_segments2, textHighlighter, marks || [], startPos));
    }
    var components = $cd97ba6fc7bf5abf$export$b756d37afc321d72({
        texts: texts,
        shouldApplyAnnotationAt: shouldApplyAnnotationAt,
        draftPosition: nextDraftPosition,
        textHighlighter: textHighlighter,
        marks: marks
    });
    return (0, $74Zh5.jsx)((0, $5FkrB.Fragment), null, components);
};


var $0add6e4a2440403c$var$TextWrapper = function TextWrapper(props) {
    var startPos = props.startPos, endPos = props.endPos;
    var children = props.children;
    if (!children) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $cd97ba6fc7bf5abf$export$69a4e0ac39aaf9b7), {
        startPos: startPos,
        endPos: endPos,
        textHighlighter: props.textHighlighter,
        marks: props.marks
    }, children);
};
var $0add6e4a2440403c$export$2e2bcd8739ae039 = $0add6e4a2440403c$var$TextWrapper;


function $e382f311073cdba5$export$7aa7587d1ce9583c(allowHeadingAnchorLinks) {
    // If it's a boolean or undefined, then we don't support nesting.
    if (!allowHeadingAnchorLinks || typeof allowHeadingAnchorLinks === 'boolean') return false;
    var allowNestedHeaderLinks = allowHeadingAnchorLinks.allowNestedHeaderLinks;
    // Explicit cast to a boolean to cover scenario where it's undefined.
    return !!allowNestedHeaderLinks;
}
function $e382f311073cdba5$export$acb253d79d72af92(allowHeadingAnchorLinks) {
    if (!$e382f311073cdba5$export$7aa7587d1ce9583c(allowHeadingAnchorLinks)) return undefined;
    return allowHeadingAnchorLinks.activeHeadingId;
}



var $il4RY = parcelRequire("il4RY");

var $25nEq = parcelRequire("25nEq");

var $fC8ib = parcelRequire("fC8ib");

var $l56lt = parcelRequire("l56lt");// eslint-disable-next-line import/no-namespace
var $97d292d308609fa6$exports = {};
$parcel$export($97d292d308609fa6$exports, "expandWithNestedExpand", () => $9cd5a5cff2a9157b$export$7b80cba28d10b2c1);
$parcel$export($97d292d308609fa6$exports, "expandWithNestedExpandLocalId", () => $9cd5a5cff2a9157b$export$2ae5e7565ff9ffa6);
$parcel$export($97d292d308609fa6$exports, "expandToJSON", () => $9cd5a5cff2a9157b$export$54fd2c36b5cc6731);
$parcel$export($97d292d308609fa6$exports, "confluenceJiraIssue", () => $e9fb2e043a62b7b0$export$daf889beb5092f95);
$parcel$export($97d292d308609fa6$exports, "confluenceUnsupportedBlock", () => $25b61cd4e4df05e7$export$e6e4878f43c27cab);
$parcel$export($97d292d308609fa6$exports, "confluenceUnsupportedInline", () => $34f612c5109d80d1$export$3e6d667072febc87);
$parcel$export($97d292d308609fa6$exports, "doc", () => $3189a38ae2d8190d$export$2a111da947c407d2);
$parcel$export($97d292d308609fa6$exports, "blockquote", () => $de125a506c44dde8$export$67dc04e652a298ca);
$parcel$export($97d292d308609fa6$exports, "extendedBlockquote", () => $de125a506c44dde8$export$70a64939da3e8455);
$parcel$export($97d292d308609fa6$exports, "extendedBlockquoteWithLocalId", () => $de125a506c44dde8$export$950ebf43f3364a0f);
$parcel$export($97d292d308609fa6$exports, "bulletList", () => $68aa38673a09f75f$export$a140c94e5ea26bee);
$parcel$export($97d292d308609fa6$exports, "bulletListSelector", () => $68aa38673a09f75f$export$5f25a39efab3b58b);
$parcel$export($97d292d308609fa6$exports, "bulletListWithLocalId", () => $68aa38673a09f75f$export$dfd406053b2bab40);
$parcel$export($97d292d308609fa6$exports, "codeBlock", () => $f03078759126255d$export$7bb0d5c671655cc4);
$parcel$export($97d292d308609fa6$exports, "codeBlockWithLocalId", () => $f03078759126255d$export$3f75de798a0b5356);
$parcel$export($97d292d308609fa6$exports, "codeBlockToJSON", () => $f03078759126255d$export$54fd2c36b5cc6731);
$parcel$export($97d292d308609fa6$exports, "hardBreak", () => $0914d755479e1221$export$371da9dd35aba193);
$parcel$export($97d292d308609fa6$exports, "heading", () => $2c737b0f1b7d6028$export$46e4a324ac90507f);
$parcel$export($97d292d308609fa6$exports, "rule", () => $d9ae5ab08c734466$export$fbeb3a3956e8a3c7);
$parcel$export($97d292d308609fa6$exports, "ruleWithLocalId", () => $d9ae5ab08c734466$export$bf3ef6fb6ad90e7);
$parcel$export($97d292d308609fa6$exports, "orderedList", () => $b9468ae6afc572a5$export$a5dc81035676e7a);
$parcel$export($97d292d308609fa6$exports, "orderedListSelector", () => $b9468ae6afc572a5$export$4e7125c7ff595be5);
$parcel$export($97d292d308609fa6$exports, "orderedListWithLocalId", () => $b9468ae6afc572a5$export$8157adc5747ec436);
$parcel$export($97d292d308609fa6$exports, "orderedListWithOrder", () => $b9468ae6afc572a5$export$b9ab759e8298198f);
$parcel$export($97d292d308609fa6$exports, "orderedListWithOrderAndLocalId", () => $b9468ae6afc572a5$export$2ea3505d41d7525d);
$parcel$export($97d292d308609fa6$exports, "paragraph", () => $c86326eb6bb37777$export$9c206ddddb32a9b);
$parcel$export($97d292d308609fa6$exports, "emoji", () => $3b9771668d47d1fd$export$a19185d1233fc4b2);
$parcel$export($97d292d308609fa6$exports, "emojiWithLocalId", () => $3b9771668d47d1fd$export$ebb3b3c7a0ac9936);
$parcel$export($97d292d308609fa6$exports, "image", () => $a57c320c6d513196$export$5c452ff88e35e47d);
$parcel$export($97d292d308609fa6$exports, "mention", () => $bcfbfcab2297a3f6$export$db83999c14438df4);
$parcel$export($97d292d308609fa6$exports, "mentionToJSON", () => $bcfbfcab2297a3f6$export$54fd2c36b5cc6731);
$parcel$export($97d292d308609fa6$exports, "listItem", () => $cd973dd5f5481b0f$export$76c7e83ecc9cdf05);
$parcel$export($97d292d308609fa6$exports, "listItemWithFlexibleFirstChildStage0", () => $cd973dd5f5481b0f$export$fcbecfed570fc881);
$parcel$export($97d292d308609fa6$exports, "listItemWithLocalId", () => $cd973dd5f5481b0f$export$483d52f09158e61c);
$parcel$export($97d292d308609fa6$exports, "extendedPanel", () => (parcelRequire("jRLnM")).extendedPanel);
$parcel$export($97d292d308609fa6$exports, "extendedPanelWithLocalId", () => (parcelRequire("jRLnM")).extendedPanelWithLocalId);
$parcel$export($97d292d308609fa6$exports, "PanelType", () => (parcelRequire("jRLnM")).PanelType);
$parcel$export($97d292d308609fa6$exports, "text", () => $0843b8206c94d9c8$export$6f093cfa640b7166);
$parcel$export($97d292d308609fa6$exports, "unknownBlock", () => $e7d33089ad270e58$export$2e2bcd8739ae039);
$parcel$export($97d292d308609fa6$exports, "caption", () => $06b7e02ee990af9a$export$8e3c2dfdc4f0453d);
$parcel$export($97d292d308609fa6$exports, "captionWithLocalId", () => $06b7e02ee990af9a$export$b5d01ee303c467aa);
$parcel$export($97d292d308609fa6$exports, "media", () => $aacb6205dbe8d16e$export$987d49ffe1b0900f);
$parcel$export($97d292d308609fa6$exports, "copyPrivateMediaAttributes", () => $aacb6205dbe8d16e$export$111130fa8968d741);
$parcel$export($97d292d308609fa6$exports, "mediaToJSON", () => $aacb6205dbe8d16e$export$54fd2c36b5cc6731);
$parcel$export($97d292d308609fa6$exports, "mediaGroup", () => $cc684338e25ee07f$export$2855e964765eac9);
$parcel$export($97d292d308609fa6$exports, "mediaInline", () => $e66d54db0e5b1698$export$38bab695e3f720f1);
$parcel$export($97d292d308609fa6$exports, "mediaSingle", () => $ea198752dd60970b$export$969fe3781ca15058);
$parcel$export($97d292d308609fa6$exports, "mediaSingleSpec", () => $ea198752dd60970b$export$5a1e124099b60c6b);
$parcel$export($97d292d308609fa6$exports, "mediaSingleWithCaption", () => $ea198752dd60970b$export$d35e6c006d4abdfb);
$parcel$export($97d292d308609fa6$exports, "mediaSingleWithWidthType", () => $ea198752dd60970b$export$9c58e19811ce4cf5);
$parcel$export($97d292d308609fa6$exports, "mediaSingleFull", () => $ea198752dd60970b$export$7e767666f2ce108a);
$parcel$export($97d292d308609fa6$exports, "mediaSingleFullWithLocalId", () => $ea198752dd60970b$export$75376a385837c942);
$parcel$export($97d292d308609fa6$exports, "mediaSingleToJSON", () => $ea198752dd60970b$export$54fd2c36b5cc6731);
$parcel$export($97d292d308609fa6$exports, "table", () => (parcelRequire("4iuZ2")).table);
$parcel$export($97d292d308609fa6$exports, "tableWithNestedTable", () => (parcelRequire("4iuZ2")).tableWithNestedTable);
$parcel$export($97d292d308609fa6$exports, "tableRowWithNestedTable", () => (parcelRequire("4iuZ2")).tableRowWithNestedTable);
$parcel$export($97d292d308609fa6$exports, "tableCellWithNestedTable", () => (parcelRequire("4iuZ2")).tableCellWithNestedTable);
$parcel$export($97d292d308609fa6$exports, "tableHeaderWithNestedTable", () => (parcelRequire("4iuZ2")).tableHeaderWithNestedTable);
$parcel$export($97d292d308609fa6$exports, "tableRowWithLocalId", () => (parcelRequire("4iuZ2")).tableRowWithLocalId);
$parcel$export($97d292d308609fa6$exports, "tableCellWithLocalId", () => (parcelRequire("4iuZ2")).tableCellWithLocalId);
$parcel$export($97d292d308609fa6$exports, "tableHeaderWithLocalId", () => (parcelRequire("4iuZ2")).tableHeaderWithLocalId);
$parcel$export($97d292d308609fa6$exports, "tableRowWithNestedTableWithLocalId", () => (parcelRequire("4iuZ2")).tableRowWithNestedTableWithLocalId);
$parcel$export($97d292d308609fa6$exports, "tableCellWithNestedTableWithLocalId", () => (parcelRequire("4iuZ2")).tableCellWithNestedTableWithLocalId);
$parcel$export($97d292d308609fa6$exports, "tableHeaderWithNestedTableWithLocalId", () => (parcelRequire("4iuZ2")).tableHeaderWithNestedTableWithLocalId);
$parcel$export($97d292d308609fa6$exports, "tableStage0", () => (parcelRequire("4iuZ2")).tableStage0);
$parcel$export($97d292d308609fa6$exports, "tableWithCustomWidth", () => (parcelRequire("4iuZ2")).tableWithCustomWidth);
$parcel$export($97d292d308609fa6$exports, "tableToJSON", () => (parcelRequire("4iuZ2")).tableToJSON);
$parcel$export($97d292d308609fa6$exports, "tableCell", () => (parcelRequire("4iuZ2")).tableCell);
$parcel$export($97d292d308609fa6$exports, "toJSONTableCell", () => (parcelRequire("4iuZ2")).toJSONTableCell);
$parcel$export($97d292d308609fa6$exports, "tableHeader", () => (parcelRequire("4iuZ2")).tableHeader);
$parcel$export($97d292d308609fa6$exports, "toJSONTableHeader", () => (parcelRequire("4iuZ2")).toJSONTableHeader);
$parcel$export($97d292d308609fa6$exports, "tableRow", () => (parcelRequire("4iuZ2")).tableRow);
$parcel$export($97d292d308609fa6$exports, "tableBackgroundColorPalette", () => (parcelRequire("4iuZ2")).tableBackgroundColorPalette);
$parcel$export($97d292d308609fa6$exports, "tableBackgroundBorderColor", () => (parcelRequire("4iuZ2")).tableBackgroundBorderColor);
$parcel$export($97d292d308609fa6$exports, "tableBackgroundColorNames", () => (parcelRequire("4iuZ2")).tableBackgroundColorNames);
$parcel$export($97d292d308609fa6$exports, "getCellAttrs", () => (parcelRequire("4iuZ2")).getCellAttrs);
$parcel$export($97d292d308609fa6$exports, "getCellDomAttrs", () => (parcelRequire("4iuZ2")).getCellDomAttrs);
$parcel$export($97d292d308609fa6$exports, "tablePrefixSelector", () => (parcelRequire("4iuZ2")).tablePrefixSelector);
$parcel$export($97d292d308609fa6$exports, "tableCellSelector", () => (parcelRequire("4iuZ2")).tableCellSelector);
$parcel$export($97d292d308609fa6$exports, "tableHeaderSelector", () => (parcelRequire("4iuZ2")).tableHeaderSelector);
$parcel$export($97d292d308609fa6$exports, "tableCellContentWrapperSelector", () => (parcelRequire("4iuZ2")).tableCellContentWrapperSelector);
$parcel$export($97d292d308609fa6$exports, "tableCellContentDomSelector", () => (parcelRequire("4iuZ2")).tableCellContentDomSelector);
$parcel$export($97d292d308609fa6$exports, "decisionList", () => $964797ab5bfd59fb$export$62d45a65fb43d95e);
$parcel$export($97d292d308609fa6$exports, "decisionListSelector", () => $964797ab5bfd59fb$export$a5393ce68c2ff601);
$parcel$export($97d292d308609fa6$exports, "decisionItem", () => $6f5a7a342445f237$export$6959e16eeff859b4);
$parcel$export($97d292d308609fa6$exports, "taskList", () => $b2e5441fe7d9a137$export$375b6afcc5f4d291);
$parcel$export($97d292d308609fa6$exports, "taskListSelector", () => $b2e5441fe7d9a137$export$c0ec71adb7a18fb2);
$parcel$export($97d292d308609fa6$exports, "taskListWithFlexibleFirstChildStage0", () => $b2e5441fe7d9a137$export$3c86306d85ad1f18);
$parcel$export($97d292d308609fa6$exports, "taskItem", () => $cbf37c1c4b8d5d30$export$6d8b0ef52e2e6390);
$parcel$export($97d292d308609fa6$exports, "blockTaskItem", () => $cbf37c1c4b8d5d30$export$16018c61064a18df);
$parcel$export($97d292d308609fa6$exports, "date", () => $1d8f0dac087417d1$export$324d90190a8b822a);
$parcel$export($97d292d308609fa6$exports, "dateWithLocalId", () => $1d8f0dac087417d1$export$a6a035390e3921b2);
$parcel$export($97d292d308609fa6$exports, "placeholder", () => $22fba87185ef0411$export$c7187bbd1a7a9244);
$parcel$export($97d292d308609fa6$exports, "placeholderWithLocalId", () => $22fba87185ef0411$export$6205248609a8f7a0);
$parcel$export($97d292d308609fa6$exports, "layoutSection", () => $1f387ae27d37c85e$export$b3b6a70a7fa4a5be);
$parcel$export($97d292d308609fa6$exports, "layoutSectionWithLocalId", () => $1f387ae27d37c85e$export$d9d3c69a64270b13);
$parcel$export($97d292d308609fa6$exports, "layoutSectionWithSingleColumn", () => $1f387ae27d37c85e$export$4f9d8f623ff17117);
$parcel$export($97d292d308609fa6$exports, "layoutSectionWithSingleColumnLocalId", () => $1f387ae27d37c85e$export$64facded20dfd85c);
$parcel$export($97d292d308609fa6$exports, "layoutColumn", () => $4926a20aff33a51e$export$ab76e7c03cd6f650);
$parcel$export($97d292d308609fa6$exports, "layoutColumnWithLocalId", () => $4926a20aff33a51e$export$b2e27d292505bac2);
$parcel$export($97d292d308609fa6$exports, "inlineCard", () => $3a1f01737c54306b$export$cbf8224b64e0d942);
$parcel$export($97d292d308609fa6$exports, "inlineCardWithLocalId", () => $3a1f01737c54306b$export$7ed775fc743eadd1);
$parcel$export($97d292d308609fa6$exports, "blockCard", () => $1523cff2135842ff$export$c4c2f833baaebdb8);
$parcel$export($97d292d308609fa6$exports, "blockCardWithLocalId", () => $1523cff2135842ff$export$9894f24949f094e5);
$parcel$export($97d292d308609fa6$exports, "unsupportedBlock", () => $6f6274e72602d062$export$44b79b0979d0f0f7);
$parcel$export($97d292d308609fa6$exports, "unsupportedInline", () => $7baec23ccb628f19$export$310ebe0d80122e9b);
$parcel$export($97d292d308609fa6$exports, "status", () => $6972390ebb9bd4b0$export$471f7ae5c4103ae1);
$parcel$export($97d292d308609fa6$exports, "nestedExpand", () => $e1accce4e805401f$export$63cadbf5f4296627);
$parcel$export($97d292d308609fa6$exports, "nestedExpandWithLocalId", () => $e1accce4e805401f$export$b854197485aa1fa0);
$parcel$export($97d292d308609fa6$exports, "embedCard", () => $bc4f37863f21d42d$export$be4283d9a1cb1ff6);
$parcel$export($97d292d308609fa6$exports, "embedCardWithLocalId", () => $bc4f37863f21d42d$export$36734475a7f6fd3e);
$parcel$export($97d292d308609fa6$exports, "extension", () => $559b2b6e22802307$export$1b45514b112dd749);
$parcel$export($97d292d308609fa6$exports, "inlineExtension", () => $bb20a9c871fceff5$export$16b353b2649bd8d9);
$parcel$export($97d292d308609fa6$exports, "bodiedExtension", () => $8650cd3ae99343ef$export$27903d543b563e39);
$parcel$export($97d292d308609fa6$exports, "extensionFrame", () => $78a12cccd6b79e5f$export$4fdcae991fd743e7);
$parcel$export($97d292d308609fa6$exports, "multiBodiedExtension", () => $78a12cccd6b79e5f$export$c3c04d555a8b9013);
$parcel$export($97d292d308609fa6$exports, "syncBlock", () => $3614b7dcde529e3d$export$faab0ca9701d7048);
$parcel$export($97d292d308609fa6$exports, "bodiedSyncBlock", () => $1c7b3187728193dc$export$e92c7e4302dd4371);
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $25nEq = parcelRequire("25nEq");

var $hibjE = parcelRequire("hibjE");

var $l56lt = parcelRequire("l56lt");
function $9cd5a5cff2a9157b$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $9cd5a5cff2a9157b$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $9cd5a5cff2a9157b$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $9cd5a5cff2a9157b$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
/**
 * @name expand_node
 */ /**
 * @name expand_with_no_mark_node
 */ /**
 * @name expand_root_only_node
 */ function $9cd5a5cff2a9157b$var$getExpandAttrs(domNode) {
    // eslint-disable-next-line @atlaskit/editor/no-as-casting
    var dom = domNode;
    return {
        title: dom.getAttribute('data-title'),
        __expanded: true
    };
}
var $9cd5a5cff2a9157b$var$nodeSpecOptions = {
    parseDOM: [
        {
            context: 'table//',
            tag: 'div[data-node-type="expand"]',
            getAttrs: $9cd5a5cff2a9157b$var$getExpandAttrs
        },
        {
            context: 'expand//',
            tag: '[data-node-type="expand"]',
            getAttrs: $9cd5a5cff2a9157b$var$getExpandAttrs
        },
        {
            context: 'nestedExpand//',
            tag: '[data-node-type="expand"]',
            getAttrs: $9cd5a5cff2a9157b$var$getExpandAttrs
        },
        {
            tag: '[data-node-type="nestedExpand"] button',
            ignore: true
        },
        {
            tag: '[data-node-type="expand"] button',
            ignore: true
        },
        {
            tag: 'div[data-node-type="expand"]',
            getAttrs: $9cd5a5cff2a9157b$var$getExpandAttrs
        }
    ],
    toDOM: function toDOM(node) {
        var attrs = {
            'data-node-type': 'expand',
            'data-title': node.attrs.title,
            'data-expanded': node.attrs.__expanded
        };
        return [
            'div',
            attrs,
            0
        ];
    }
};
var $9cd5a5cff2a9157b$export$7b80cba28d10b2c1 = (0, $hibjE.expand)($9cd5a5cff2a9157b$var$nodeSpecOptions);
var $9cd5a5cff2a9157b$export$2ae5e7565ff9ffa6 = (0, $hibjE.expand)({
    parseDOM: [
        {
            context: 'table//',
            tag: 'div[data-node-type="expand"]',
            getAttrs: function getAttrs(dom) {
                var attrs = $9cd5a5cff2a9157b$var$getExpandAttrs(dom);
                return $9cd5a5cff2a9157b$var$_objectSpread($9cd5a5cff2a9157b$var$_objectSpread({}, attrs), {}, {
                    localId: (0, $l56lt.uuid).generate()
                });
            }
        },
        {
            context: 'expand//',
            tag: '[data-node-type="expand"]',
            getAttrs: function getAttrs(dom) {
                var attrs = $9cd5a5cff2a9157b$var$getExpandAttrs(dom);
                return $9cd5a5cff2a9157b$var$_objectSpread($9cd5a5cff2a9157b$var$_objectSpread({}, attrs), {}, {
                    localId: (0, $l56lt.uuid).generate()
                });
            }
        },
        {
            context: 'nestedExpand//',
            tag: '[data-node-type="expand"]',
            getAttrs: function getAttrs(dom) {
                var attrs = $9cd5a5cff2a9157b$var$getExpandAttrs(dom);
                return $9cd5a5cff2a9157b$var$_objectSpread($9cd5a5cff2a9157b$var$_objectSpread({}, attrs), {}, {
                    localId: (0, $l56lt.uuid).generate()
                });
            }
        },
        {
            tag: '[data-node-type="nestedExpand"] button',
            ignore: true
        },
        {
            tag: '[data-node-type="expand"] button',
            ignore: true
        },
        {
            tag: 'div[data-node-type="expand"]',
            getAttrs: function getAttrs(dom) {
                var attrs = $9cd5a5cff2a9157b$var$getExpandAttrs(dom);
                return $9cd5a5cff2a9157b$var$_objectSpread($9cd5a5cff2a9157b$var$_objectSpread({}, attrs), {}, {
                    localId: (0, $l56lt.uuid).generate()
                });
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node$attrs;
        var attrs = {
            'data-node-type': 'expand',
            'data-title': node.attrs.title,
            'data-expanded': node.attrs.__expanded,
            'data-local-id': (node === null || node === void 0 ? void 0 : (_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.localId) || undefined
        };
        return [
            'div',
            attrs,
            0
        ];
    }
});
var $9cd5a5cff2a9157b$export$54fd2c36b5cc6731 = function toJSON(node) {
    return {
        attrs: Object.keys(node.attrs).filter(function(key) {
            return !key.startsWith('__');
        }).reduce(function(obj, key) {
            return $9cd5a5cff2a9157b$var$_objectSpread($9cd5a5cff2a9157b$var$_objectSpread({}, obj), {}, (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, key, node.attrs[key]));
        }, {})
    };
};



var $hibjE = parcelRequire("hibjE");
var $e9fb2e043a62b7b0$var$name = 'confluenceJiraIssue';
var $e9fb2e043a62b7b0$export$daf889beb5092f95 = (0, $hibjE.confluenceJiraIssue)({
    parseDOM: [
        {
            tag: "span[data-node-type=\"".concat($e9fb2e043a62b7b0$var$name, "\"]"),
            getAttrs: function getAttrs(domNode) {
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                var dom = domNode;
                return {
                    issueKey: dom.textContent,
                    macroId: dom.dataset && dom.dataset.macroId,
                    schemaVersion: dom.dataset && dom.dataset.schemaVersion,
                    server: dom.dataset && dom.dataset.server,
                    serverId: dom.dataset && dom.dataset.serverId
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var attrs = {
            'data-node-type': $e9fb2e043a62b7b0$var$name,
            'data-macro-id': node.attrs.macroId,
            'data-schema-version': node.attrs.schemaVersion,
            'data-server': node.attrs.server,
            'data-server-id': node.attrs.serverId,
            'data-jira-issue': node.attrs.issueKey
        };
        return [
            'span',
            attrs,
            node.attrs.issueKey
        ];
    }
});



var $hibjE = parcelRequire("hibjE");
var $25b61cd4e4df05e7$var$name = 'confluenceUnsupportedBlock';
var $25b61cd4e4df05e7$export$e6e4878f43c27cab = (0, $hibjE.confluenceUnsupportedBlock)({
    toDOM: function toDOM(node) {
        // NOTE: This node cannot be "contenteditable: false". If it's the only node in a document, PM throws an error because there's nowhere to put the cursor.
        var attrs = {
            'data-node-type': $25b61cd4e4df05e7$var$name,
            'data-confluence-unsupported': 'block',
            'data-confluence-unsupported-block-cxhtml': node.attrs['cxhtml']
        };
        return [
            'div',
            attrs,
            'Unsupported content'
        ];
    },
    parseDOM: [
        {
            tag: "div[data-node-type=\"".concat($25b61cd4e4df05e7$var$name, "\"]"),
            getAttrs: function getAttrs(dom) {
                return {
                    // eslint-disable-next-line @atlaskit/editor/no-as-casting, @typescript-eslint/no-non-null-assertion
                    cxhtml: dom.getAttribute('data-confluence-unsupported-block-cxhtml')
                };
            }
        }
    ]
});



var $hibjE = parcelRequire("hibjE");
var $34f612c5109d80d1$var$name = 'confluenceUnsupportedInline';
var $34f612c5109d80d1$export$3e6d667072febc87 = (0, $hibjE.confluenceUnsupportedInline)({
    toDOM: function toDOM(node) {
        var attrs = {
            'data-node-type': $34f612c5109d80d1$var$name,
            'data-confluence-unsupported': 'inline',
            'data-confluence-unsupported-inline-cxhtml': node.attrs['cxhtml']
        };
        return [
            'div',
            attrs,
            'Unsupported content'
        ];
    },
    parseDOM: [
        {
            tag: "div[data-node-type=\"".concat($34f612c5109d80d1$var$name, "\"]"),
            getAttrs: function getAttrs(dom) {
                return {
                    // eslint-disable-next-line @atlaskit/editor/no-as-casting, @typescript-eslint/no-non-null-assertion
                    cxhtml: dom.getAttribute('data-confluence-unsupported-inline-cxhtml')
                };
            }
        }
    ]
});



var $hibjE = parcelRequire("hibjE");
var $3189a38ae2d8190d$export$2a111da947c407d2 = (0, $hibjE.doc)({});



var $hibjE = parcelRequire("hibjE");

var $l56lt = parcelRequire("l56lt");
/**
 * @name blockquote_node
 */ var $de125a506c44dde8$var$nodeSpecOptions = {
    parseDOM: [
        {
            tag: 'blockquote'
        }
    ],
    toDOM: function toDOM() {
        return [
            'blockquote',
            0
        ];
    }
};
var $de125a506c44dde8$export$67dc04e652a298ca = (0, $hibjE.blockquoteLegacy)($de125a506c44dde8$var$nodeSpecOptions);
var $de125a506c44dde8$export$70a64939da3e8455 = (0, $hibjE.blockquote)($de125a506c44dde8$var$nodeSpecOptions);
var $de125a506c44dde8$var$nodeSpecOptionsWithLocalId = {
    parseDOM: [
        {
            tag: 'blockquote',
            getAttrs: function getAttrs() {
                return {
                    localId: (0, $l56lt.uuid).generate()
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node$attrs;
        return [
            'blockquote',
            {
                'data-local-id': (node === null || node === void 0 ? void 0 : (_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.localId) || undefined
            },
            0
        ];
    }
};
var $de125a506c44dde8$export$950ebf43f3364a0f = (0, $hibjE.blockquote)($de125a506c44dde8$var$nodeSpecOptionsWithLocalId);



var $l56lt = parcelRequire("l56lt");

var $hibjE = parcelRequire("hibjE");
var $68aa38673a09f75f$export$5f25a39efab3b58b = '.ak-ul';
var $68aa38673a09f75f$export$a140c94e5ea26bee = (0, $hibjE.bulletList)({
    parseDOM: [
        {
            tag: 'ul'
        }
    ],
    toDOM: function toDOM() {
        var attrs = {
            class: $68aa38673a09f75f$export$5f25a39efab3b58b.substr(1)
        };
        return [
            'ul',
            attrs,
            0
        ];
    }
});
var $68aa38673a09f75f$export$dfd406053b2bab40 = (0, $hibjE.bulletList)({
    parseDOM: [
        {
            tag: 'ul',
            getAttrs: function getAttrs() {
                return {
                    localId: (0, $l56lt.uuid).generate()
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node$attrs;
        var attrs = {
            class: $68aa38673a09f75f$export$5f25a39efab3b58b.substr(1),
            'data-local-id': (node === null || node === void 0 ? void 0 : (_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.localId) || undefined
        };
        return [
            'ul',
            attrs,
            0
        ];
    }
});



var $9Jwkl = parcelRequire("9Jwkl");

var $hibjE = parcelRequire("hibjE");

var $l56lt = parcelRequire("l56lt");
/**
 * @name codeBlock_with_no_marks_node
 */ /**
 * @name codeBlock_node
 */ var $f03078759126255d$var$getLanguageFromEditorStyle = function getLanguageFromEditorStyle(dom) {
    return dom.getAttribute('data-language') || undefined;
};
// example of BB style:
// <div class="codehilite language-javascript"><pre><span>hello world</span><span>\n</span></pre></div>
var $f03078759126255d$var$getLanguageFromBitbucketStyle = function getLanguageFromBitbucketStyle(dom) {
    if (dom && dom.classList.contains('codehilite')) // code block html from Bitbucket always contains an extra new line
    return $f03078759126255d$var$extractLanguageFromClass(dom.className);
    return;
};
// If there is a child code element, check that for data-language
var $f03078759126255d$var$getLanguageFromCode = function getLanguageFromCode(dom) {
    var firstChild = dom.firstElementChild;
    if (firstChild && firstChild.nodeName === 'CODE') return firstChild.getAttribute('data-language') || undefined;
};
var $f03078759126255d$var$extractLanguageFromClass = function extractLanguageFromClass(className) {
    // @ts-ignore TS1501: This regular expression flag is only available when targeting 'es6' or later.
    var languageRegex = /(?:^|[\t-\r \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF])language-((?:[\0-\x08\x0E-\x1F!-\x9F\xA1-\u167F\u1681-\u1FFF\u200B-\u2027\u202A-\u202E\u2030-\u205E\u2060-\u2FFF\u3001-\uD7FF\uE000-\uFEFE\uFF00-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])+)/;
    var result = languageRegex.exec(className);
    if (result && result[1]) return result[1];
    return;
};
var $f03078759126255d$var$removeLastNewLine = function removeLastNewLine(dom) {
    var parent = dom && dom.parentElement;
    if (parent && parent.classList.contains('codehilite')) // @ts-ignore TS1501: This regular expression flag is only available when targeting 'es6' or later.
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    dom.textContent = dom.textContent.replace(/\n$/, '');
    return dom;
};
function $f03078759126255d$var$parseCodeFromHtml(node) {
    var code = '';
    node.childNodes.forEach(function(child) {
        if (child.nodeType === Node.TEXT_NODE) // append text
        code += child.nodeValue;
        else if (child.nodeType === Node.ELEMENT_NODE && child instanceof Element) {
            var tagName = child.tagName.toLowerCase();
            if (tagName === 'div' || tagName === 'p') // add a newline before its content, unless it's the first child to avoid leading newlines
            {
                if (child.previousElementSibling !== null) code += '\n';
            }
            if (tagName === 'br') code += '\n';
            else code += $f03078759126255d$var$parseCodeFromHtml(child);
        }
    });
    return code;
}
var $f03078759126255d$export$7bb0d5c671655cc4 = (0, $hibjE.codeBlock)({
    parseDOM: [
        {
            tag: 'pre',
            preserveWhitespace: 'full',
            getAttrs: function getAttrs(domNode) {
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                var dom = domNode;
                var language = // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                $f03078759126255d$var$getLanguageFromBitbucketStyle(dom.parentElement) || // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                $f03078759126255d$var$getLanguageFromEditorStyle(dom.parentElement) || $f03078759126255d$var$getLanguageFromCode(dom) || // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                dom.getAttribute('data-language');
                dom = $f03078759126255d$var$removeLastNewLine(dom);
                return {
                    language: language
                };
            }
        },
        // Handle VSCode, Android Studio paste
        // Checking `white-space: pre-wrap` is too aggressive @see ED-2627
        {
            tag: 'div[style]',
            preserveWhitespace: 'full',
            getAttrs: function getAttrs(domNode) {
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                var dom = domNode;
                if (dom.style.whiteSpace === 'pre' || dom.style.fontFamily && dom.style.fontFamily.toLowerCase().indexOf('monospace') > -1) return {};
                return false;
            },
            getContent: function getContent(domNode, schema) {
                var code = $f03078759126255d$var$parseCodeFromHtml(domNode);
                return code ? (0, $9Jwkl.Fragment).from(schema.text(code)) : (0, $9Jwkl.Fragment).empty;
            }
        },
        // Handle GitHub/Gist paste
        {
            tag: 'table[style]',
            preserveWhitespace: 'full',
            getAttrs: function getAttrs(dom) {
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                if (dom.querySelector('td[class*="blob-code"]')) return {};
                return false;
            }
        },
        {
            tag: 'div.code-block',
            preserveWhitespace: 'full',
            getAttrs: function getAttrs(domNode) {
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                var dom = domNode;
                // TODO: ED-5604 - Fix it inside `react-syntax-highlighter`
                // Remove line numbers
                var lineNumber = dom.querySelectorAll('.react-syntax-highlighter-line-number');
                if (lineNumber.length > 0) // It's possible to copy without the line numbers too hence this
                // `react-syntax-highlighter-line-number` check, so that we don't remove real code
                lineNumber.forEach(function(line) {
                    return line.remove();
                });
                return {};
            }
        }
    ],
    toDOM: function toDOM(node) {
        return [
            'pre',
            [
                'code',
                {
                    'data-language': node.attrs.language
                },
                0
            ]
        ];
    }
});
var $f03078759126255d$export$54fd2c36b5cc6731 = function toJSON(node) {
    return {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        attrs: Object.keys(node.attrs).reduce(function(memo, key) {
            if (key === 'uniqueId') return memo;
            if (key === 'language' && node.attrs.language === null) return memo;
            memo[key] = node.attrs[key];
            return memo;
        }, {})
    };
};
var $f03078759126255d$export$3f75de798a0b5356 = (0, $hibjE.codeBlock)({
    parseDOM: [
        {
            tag: 'pre',
            preserveWhitespace: 'full',
            getAttrs: function getAttrs(domNode) {
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                var dom = domNode;
                var language = // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                $f03078759126255d$var$getLanguageFromBitbucketStyle(dom.parentElement) || // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                $f03078759126255d$var$getLanguageFromEditorStyle(dom.parentElement) || $f03078759126255d$var$getLanguageFromCode(dom) || // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                dom.getAttribute('data-language');
                dom = $f03078759126255d$var$removeLastNewLine(dom);
                return {
                    language: language,
                    localId: (0, $l56lt.uuid).generate()
                };
            }
        },
        // Handle VSCode, Android Studio paste
        // Checking `white-space: pre-wrap` is too aggressive @see ED-2627
        {
            tag: 'div[style]',
            preserveWhitespace: 'full',
            getAttrs: function getAttrs(domNode) {
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                var dom = domNode;
                if (dom.style.whiteSpace === 'pre' || dom.style.fontFamily && dom.style.fontFamily.toLowerCase().indexOf('monospace') > -1) return {};
                return false;
            },
            getContent: function getContent(domNode, schema) {
                var code = $f03078759126255d$var$parseCodeFromHtml(domNode);
                return code ? (0, $9Jwkl.Fragment).from(schema.text(code)) : (0, $9Jwkl.Fragment).empty;
            }
        },
        // Handle GitHub/Gist paste
        {
            tag: 'table[style]',
            preserveWhitespace: 'full',
            getAttrs: function getAttrs(dom) {
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                if (dom.querySelector('td[class*="blob-code"]')) return {};
                return false;
            }
        },
        {
            tag: 'div.code-block',
            preserveWhitespace: 'full',
            getAttrs: function getAttrs(domNode) {
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                var dom = domNode;
                // TODO: ED-5604 - Fix it inside `react-syntax-highlighter`
                // Remove line numbers
                var lineNumber = dom.querySelectorAll('.react-syntax-highlighter-line-number');
                if (lineNumber.length > 0) // It's possible to copy without the line numbers too hence this
                // `react-syntax-highlighter-line-number` check, so that we don't remove real code
                lineNumber.forEach(function(line) {
                    return line.remove();
                });
                return {};
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node$attrs;
        var attrs = {};
        if ((node === null || node === void 0 ? void 0 : (_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.localId) !== undefined) attrs['data-local-id'] = node.attrs.localId;
        return [
            'pre',
            attrs,
            [
                'code',
                {
                    'data-language': node.attrs.language
                },
                0
            ]
        ];
    }
});



var $hibjE = parcelRequire("hibjE");
var $0914d755479e1221$export$371da9dd35aba193 = (0, $hibjE.hardBreak)({
    parseDOM: [
        {
            tag: 'br'
        }
    ],
    toDOM: function toDOM() {
        return [
            'br'
        ];
    }
});



var $hibjE = parcelRequire("hibjE");
/**
 * @name heading_node
 */ /**
 * @name heading_with_no_marks_node
 */ // Check `paragraph` node for why we are doing things like this
/**
 * @name heading_with_alignment_node
 */ /**
 * @name heading_with_indentation_node
 */ var $2c737b0f1b7d6028$var$getAttrs = function getAttrs(level) {
    return function(domNode) {
        return {
            level: level,
            localId: // eslint-disable-next-line @atlaskit/editor/no-as-casting
            domNode.getAttribute('data-local-id') || null
        };
    };
};
var $2c737b0f1b7d6028$export$46e4a324ac90507f = (0, $hibjE.heading)({
    parseDOM: [
        {
            tag: 'h1',
            getAttrs: $2c737b0f1b7d6028$var$getAttrs(1)
        },
        {
            tag: 'h2',
            getAttrs: $2c737b0f1b7d6028$var$getAttrs(2)
        },
        {
            tag: 'h3',
            getAttrs: $2c737b0f1b7d6028$var$getAttrs(3)
        },
        {
            tag: 'h4',
            getAttrs: $2c737b0f1b7d6028$var$getAttrs(4)
        },
        {
            tag: 'h5',
            getAttrs: $2c737b0f1b7d6028$var$getAttrs(5)
        },
        {
            tag: 'h6',
            getAttrs: $2c737b0f1b7d6028$var$getAttrs(6)
        }
    ],
    toDOM: function toDOM(node) {
        var _node$attrs = node.attrs, level = _node$attrs.level, localId = _node$attrs.localId;
        var name = 'h' + level;
        var attrs = localId !== undefined && localId !== null ? [
            {
                'data-local-id': localId
            }
        ] : [];
        return [
            name
        ].concat(attrs, [
            0
        ]);
    }
});



var $hibjE = parcelRequire("hibjE");

var $l56lt = parcelRequire("l56lt");
/**
 * @name rule_node
 */ var $d9ae5ab08c734466$var$hrDOM = [
    'hr'
];
var $d9ae5ab08c734466$export$fbeb3a3956e8a3c7 = (0, $hibjE.rule)({
    parseDOM: [
        {
            tag: 'hr'
        }
    ],
    toDOM: function toDOM() {
        return $d9ae5ab08c734466$var$hrDOM;
    }
});
var $d9ae5ab08c734466$export$bf3ef6fb6ad90e7 = (0, $hibjE.rule)({
    parseDOM: [
        {
            tag: 'hr',
            getAttrs: function getAttrs() {
                return {
                    localId: (0, $l56lt.uuid).generate()
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node$attrs;
        return [
            'hr',
            {
                'data-local-id': (node === null || node === void 0 ? void 0 : (_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.localId) || undefined
            }
        ];
    }
});



var $l56lt = parcelRequire("l56lt");

var $hibjE = parcelRequire("hibjE");
var $b9468ae6afc572a5$export$4e7125c7ff595be5 = '.ak-ol';
var $b9468ae6afc572a5$export$a5dc81035676e7a = (0, $hibjE.orderedList)({
    parseDOM: [
        {
            tag: 'ol'
        }
    ],
    toDOM: function toDOM() {
        var attrs = {
            class: $b9468ae6afc572a5$export$4e7125c7ff595be5.substr(1)
        };
        return [
            'ol',
            attrs,
            0
        ];
    }
});
var $b9468ae6afc572a5$export$8157adc5747ec436 = (0, $hibjE.orderedList)({
    parseDOM: [
        {
            tag: 'ol',
            getAttrs: function getAttrs() {
                return {
                    localId: (0, $l56lt.uuid).generate()
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node$attrs;
        var attrs = {
            class: $b9468ae6afc572a5$export$4e7125c7ff595be5.substr(1),
            'data-local-id': (node === null || node === void 0 ? void 0 : (_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.localId) || undefined
        };
        return [
            'ol',
            attrs,
            0
        ];
    }
});
// resolve "start" to a safe, 0+ integer, otherwise return undefined
// Note: Any changes to this function should also be made to "resolveOrder"
// in packages/editor/editor-common/src/utils/list.ts
// eslint-disable-next-line @typescript-eslint/no-explicit-any
var $b9468ae6afc572a5$var$resolveStart = function resolveStart(start) {
    var num = Number(start);
    if (Number.isNaN(num)) return;
    if (num < 0) return;
    return Math.floor(Math.max(num, 0));
};
var $b9468ae6afc572a5$export$b9ab759e8298198f = (0, $hibjE.orderedList)({
    parseDOM: [
        {
            tag: 'ol',
            getAttrs: function getAttrs(domNode) {
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                var dom = domNode;
                var startDOMAttr = dom.getAttribute('start');
                if (startDOMAttr) {
                    var start = $b9468ae6afc572a5$var$resolveStart(startDOMAttr);
                    if (typeof start === 'number') return {
                        order: start
                    };
                }
                return null;
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node$attrs2;
        var start = $b9468ae6afc572a5$var$resolveStart(node === null || node === void 0 ? void 0 : (_node$attrs2 = node.attrs) === null || _node$attrs2 === void 0 ? void 0 : _node$attrs2.order);
        var attrs = {
            start: typeof start === 'number' ? String(start) : undefined,
            class: $b9468ae6afc572a5$export$4e7125c7ff595be5.substr(1)
        };
        return [
            'ol',
            attrs,
            0
        ];
    }
});
var $b9468ae6afc572a5$export$2ea3505d41d7525d = (0, $hibjE.orderedList)({
    parseDOM: [
        {
            tag: 'ol',
            getAttrs: function getAttrs(domNode) {
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                var dom = domNode;
                var startDOMAttr = dom.getAttribute('start');
                var localId = (0, $l56lt.uuid).generate();
                if (startDOMAttr) {
                    var start = $b9468ae6afc572a5$var$resolveStart(startDOMAttr);
                    if (typeof start === 'number') return {
                        order: start,
                        localId: localId
                    };
                }
                return {
                    localId: localId
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node$attrs3, _node$attrs4;
        var start = $b9468ae6afc572a5$var$resolveStart(node === null || node === void 0 ? void 0 : (_node$attrs3 = node.attrs) === null || _node$attrs3 === void 0 ? void 0 : _node$attrs3.order);
        var attrs = {
            start: typeof start === 'number' ? String(start) : undefined,
            class: $b9468ae6afc572a5$export$4e7125c7ff595be5.substr(1),
            'data-local-id': (node === null || node === void 0 ? void 0 : (_node$attrs4 = node.attrs) === null || _node$attrs4 === void 0 ? void 0 : _node$attrs4.localId) || undefined
        };
        return [
            'ol',
            attrs,
            0
        ];
    }
});



var $hibjE = parcelRequire("hibjE");
var $c86326eb6bb37777$export$9c206ddddb32a9b = (0, $hibjE.paragraph)({
    parseDOM: [
        {
            tag: 'p',
            getAttrs: function getAttrs(domNode) {
                var _paragraph$attrs, _paragraph$attrs$loca;
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                var dom = domNode;
                var attrs = {
                    localId: dom.getAttribute('data-local-id') || ((_paragraph$attrs = $c86326eb6bb37777$export$9c206ddddb32a9b.attrs) === null || _paragraph$attrs === void 0 ? void 0 : (_paragraph$attrs$loca = _paragraph$attrs.localId) === null || _paragraph$attrs$loca === void 0 ? void 0 : _paragraph$attrs$loca.default)
                };
                return attrs;
            }
        }
    ],
    toDOM: function toDOM(node) {
        var localId = node.attrs.localId;
        var name = 'p';
        var attrs = localId !== undefined && localId !== null ? [
            {
                'data-local-id': localId
            }
        ] : [];
        return [
            name
        ].concat(attrs, [
            0
        ]);
    }
});



var $25nEq = parcelRequire("25nEq");
// Default emoji id for Confluence glyphs that has no match to Fabric Emoji
var $22cae55e03a9340a$var$DEFAULT_EMOJI_ID = '2b50';
// Default ac:name for emoticons as a fallback is `blue-star`
var $22cae55e03a9340a$var$DEFAULT_EMOJI_ACNAME = 'blue-star';
// ac:hipchat-emoticon prefix when converting to Emoji ID
var $22cae55e03a9340a$var$HC_EMOTICON_PREFIX = 'atlassian-';
/**
 * Confluence glyphs ac:name of <ac:emoticon /> map to new emojis
 * {
 *   [ac:name] : ['emoji-id', 'emoji-shortName', 'emoji-fallback']
 *   ...
 * }
 * Glyphs that do not map to Fabric Emoji
 * will be mapped to Emoji Id '2b50' (:star:) with preserving ac:name as shortName attribute;
 */ var $22cae55e03a9340a$var$acNameToEmojiMap = {
    smile: [
        '1f642',
        ':slight_smile:',
        "\uD83D\uDE42"
    ],
    sad: [
        '1f641',
        ':slight_frown:',
        "\uD83D\uDE41"
    ],
    cheeky: [
        '1f61b',
        ':stuck_out_tongue:',
        "\uD83D\uDE1B"
    ],
    laugh: [
        '1f600',
        ':grinning:',
        "\uD83D\uDE00"
    ],
    wink: [
        '1f609',
        ':wink:',
        "\uD83D\uDE09"
    ],
    information: [
        '2139',
        ':information_source:',
        "\u2139"
    ],
    tick: [
        '2705',
        ':white_check_mark:',
        "\u2705"
    ],
    cross: [
        '274c',
        ':x:',
        "\u274C"
    ],
    warning: [
        '26a0',
        ':warning:',
        "\u26A0"
    ],
    plus: [
        '2795',
        ':heavy_plus_sign:',
        "\u2795"
    ],
    minus: [
        '2796',
        ':heavy_minus_sign:',
        "\u2796"
    ],
    question: [
        '2753',
        ':question:',
        "?"
    ],
    'thumbs-up': [
        '1f44d',
        ':thumbsup:',
        "\uD83D\uDC4D"
    ],
    'thumbs-down': [
        '1f44e',
        ':thumbsdown:',
        "\uD83D\uDC4E"
    ],
    'light-on': [
        '1f4a1',
        ':bulb:',
        "\uD83D\uDCA1"
    ],
    'yellow-star': [
        '2b50',
        ':star:',
        "\uD83D\uDC9B"
    ],
    'light-off': [
        '1f6ab',
        ':no_entry_sign:',
        "\uD83D\uDEAB"
    ],
    'red-star': [
        '2764',
        ':heart:',
        "\u2764\uFE0F"
    ],
    'green-star': [
        '1f49a',
        ':green_heart:',
        "\uD83D\uDC9A"
    ],
    'blue-star': [
        '1f499',
        ':blue_heart:',
        "\uD83D\uDC99"
    ],
    heart: [
        '2764',
        ':heart:',
        "\u2764\uFE0F"
    ],
    'broken-heart': [
        '1f494',
        ':broken_heart:',
        "\uD83D\uDC94"
    ]
};
function $22cae55e03a9340a$export$f61e93bda2a8b420(acName) {
    var emojiData = $22cae55e03a9340a$var$acNameToEmojiMap[acName];
    return emojiData ? {
        id: emojiData[0],
        shortName: emojiData[1],
        text: emojiData[2]
    } : {
        id: $22cae55e03a9340a$var$DEFAULT_EMOJI_ID,
        shortName: ":".concat(acName, ":"),
        text: ''
    };
}
function $22cae55e03a9340a$export$bc94e44ec0e7bd82(emojiId) {
    var filterEmojis = function filterEmojis(acName) {
        return $22cae55e03a9340a$var$acNameToEmojiMap[acName] ? $22cae55e03a9340a$var$acNameToEmojiMap[acName][0] === emojiId : false;
    };
    return Object.keys($22cae55e03a9340a$var$acNameToEmojiMap).filter(filterEmojis)[0];
}
function $22cae55e03a9340a$export$441f8b58f5790a68(hipchatEmoticonShortName) {
    return {
        id: "".concat($22cae55e03a9340a$var$HC_EMOTICON_PREFIX).concat(hipchatEmoticonShortName),
        shortName: ":".concat(hipchatEmoticonShortName, ":"),
        text: ''
    };
}
function $22cae55e03a9340a$var$getAcNameFromShortName(shortName) {
    return shortName.slice(shortName[0] === ':' ? 1 : 0, shortName[shortName.length - 1] === ':' ? -1 : shortName.length);
}
function $22cae55e03a9340a$export$880a2465992fbbe(_ref) {
    var id = _ref.id, shortName = _ref.shortName;
    if ($22cae55e03a9340a$var$DEFAULT_EMOJI_ID === id) {
        var possibleName = $22cae55e03a9340a$var$getAcNameFromShortName(shortName);
        if (possibleName in $22cae55e03a9340a$var$acNameToEmojiMap) return possibleName;
    }
    return $22cae55e03a9340a$export$bc94e44ec0e7bd82(id) || $22cae55e03a9340a$var$DEFAULT_EMOJI_ACNAME;
}



var $hibjE = parcelRequire("hibjE");

var $l56lt = parcelRequire("l56lt");
function $3b9771668d47d1fd$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $3b9771668d47d1fd$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $3b9771668d47d1fd$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $3b9771668d47d1fd$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $3b9771668d47d1fd$export$a19185d1233fc4b2 = (0, $hibjE.emoji)({
    parseDOM: [
        // Handle copy/paste beautiful panel from renderer />
        {
            tag: 'div.ak-editor-panel__icon span',
            ignore: true
        },
        {
            tag: 'span[data-emoji-short-name]',
            getAttrs: function getAttrs(domNode) {
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                var dom = domNode;
                return {
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    shortName: dom.getAttribute('data-emoji-short-name') || // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    $3b9771668d47d1fd$export$a19185d1233fc4b2.attrs.shortName.default,
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    id: dom.getAttribute('data-emoji-id') || $3b9771668d47d1fd$export$a19185d1233fc4b2.attrs.id.default,
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    text: // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    dom.getAttribute('data-emoji-text') || $3b9771668d47d1fd$export$a19185d1233fc4b2.attrs.text.default
                };
            }
        },
        // Handle copy/paste from old <ac:emoticon />
        {
            tag: 'img[data-emoticon-name]',
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            getAttrs: function getAttrs(dom) {
                return (0, $22cae55e03a9340a$export$f61e93bda2a8b420)(// eslint-disable-next-line @typescript-eslint/no-explicit-any
                dom.getAttribute('data-emoticon-name'));
            }
        },
        // Handle copy/paste from old <ac:hipchat-emoticons />
        {
            tag: 'img[data-hipchat-emoticon]',
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            getAttrs: function getAttrs(dom) {
                return (0, $22cae55e03a9340a$export$441f8b58f5790a68)(// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                dom.getAttribute('data-hipchat-emoticon'));
            }
        },
        // Handle copy/paste from bitbucket's <img class="emoji" />
        {
            tag: 'img.emoji[data-emoji-short-name]',
            getAttrs: function getAttrs(domNode) {
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                var dom = domNode;
                return {
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    shortName: dom.getAttribute('data-emoji-short-name') || // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    $3b9771668d47d1fd$export$a19185d1233fc4b2.attrs.shortName.default,
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    id: dom.getAttribute('data-emoji-id') || $3b9771668d47d1fd$export$a19185d1233fc4b2.attrs.id.default,
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    text: // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    dom.getAttribute('data-emoji-text') || $3b9771668d47d1fd$export$a19185d1233fc4b2.attrs.text.default
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node$attrs = node.attrs, shortName = _node$attrs.shortName, id = _node$attrs.id, text = _node$attrs.text;
        var attrs = {
            'data-emoji-short-name': shortName,
            'data-emoji-id': id,
            'data-emoji-text': text,
            contenteditable: 'false'
        };
        return [
            'span',
            attrs,
            text
        ];
    }
});
var $3b9771668d47d1fd$export$ebb3b3c7a0ac9936 = (0, $hibjE.emoji)({
    parseDOM: [
        // Handle copy/paste beautiful panel from renderer />
        {
            tag: 'div.ak-editor-panel__icon span',
            ignore: true
        },
        {
            tag: 'span[data-emoji-short-name]',
            getAttrs: function getAttrs(domNode) {
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                var dom = domNode;
                return {
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    shortName: dom.getAttribute('data-emoji-short-name') || // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    $3b9771668d47d1fd$export$a19185d1233fc4b2.attrs.shortName.default,
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    id: dom.getAttribute('data-emoji-id') || $3b9771668d47d1fd$export$a19185d1233fc4b2.attrs.id.default,
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    text: // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    dom.getAttribute('data-emoji-text') || $3b9771668d47d1fd$export$a19185d1233fc4b2.attrs.text.default,
                    localId: (0, $l56lt.uuid).generate()
                };
            }
        },
        // Handle copy/paste from old <ac:emoticon />
        {
            tag: 'img[data-emoticon-name]',
            getAttrs: function getAttrs(dom) {
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                var attrs = (0, $22cae55e03a9340a$export$f61e93bda2a8b420)(// eslint-disable-next-line @typescript-eslint/no-explicit-any
                dom.getAttribute('data-emoticon-name'));
                return $3b9771668d47d1fd$var$_objectSpread($3b9771668d47d1fd$var$_objectSpread({}, attrs), {}, {
                    localId: (0, $l56lt.uuid).generate()
                });
            }
        },
        // Handle copy/paste from old <ac:hipchat-emoticons />
        {
            tag: 'img[data-hipchat-emoticon]',
            getAttrs: function getAttrs(dom) {
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                var attrs = (0, $22cae55e03a9340a$export$441f8b58f5790a68)(// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                dom.getAttribute('data-hipchat-emoticon'));
                return $3b9771668d47d1fd$var$_objectSpread($3b9771668d47d1fd$var$_objectSpread({}, attrs), {}, {
                    localId: (0, $l56lt.uuid).generate()
                });
            }
        },
        // Handle copy/paste from bitbucket's <img class="emoji" />
        {
            tag: 'img.emoji[data-emoji-short-name]',
            getAttrs: function getAttrs(domNode) {
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                var dom = domNode;
                return {
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    shortName: dom.getAttribute('data-emoji-short-name') || // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    $3b9771668d47d1fd$export$a19185d1233fc4b2.attrs.shortName.default,
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    id: dom.getAttribute('data-emoji-id') || $3b9771668d47d1fd$export$a19185d1233fc4b2.attrs.id.default,
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    text: // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    dom.getAttribute('data-emoji-text') || $3b9771668d47d1fd$export$a19185d1233fc4b2.attrs.text.default,
                    localId: (0, $l56lt.uuid).generate()
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node$attrs3;
        var _node$attrs2 = node.attrs, shortName = _node$attrs2.shortName, id = _node$attrs2.id, text = _node$attrs2.text;
        var attrs = {
            'data-emoji-short-name': shortName,
            'data-emoji-id': id,
            'data-emoji-text': text,
            contenteditable: 'false',
            'data-local-id': (node === null || node === void 0 ? void 0 : (_node$attrs3 = node.attrs) === null || _node$attrs3 === void 0 ? void 0 : _node$attrs3.localId) || undefined
        };
        return [
            'span',
            attrs,
            text
        ];
    }
});



var $hibjE = parcelRequire("hibjE");
var $a57c320c6d513196$export$5c452ff88e35e47d = (0, $hibjE.image)({
    parseDOM: [
        {
            tag: 'img[src^="data:image/"]',
            ignore: true
        },
        {
            tag: 'img[src]',
            getAttrs: function getAttrs(domNode) {
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                var dom = domNode;
                return {
                    src: dom.getAttribute('src'),
                    alt: dom.getAttribute('alt'),
                    title: dom.getAttribute('title')
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        return [
            'img',
            node.attrs
        ];
    }
});



var $25nEq = parcelRequire("25nEq");

var $l56lt = parcelRequire("l56lt");

var $hibjE = parcelRequire("hibjE");
function $bcfbfcab2297a3f6$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $bcfbfcab2297a3f6$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $bcfbfcab2297a3f6$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $bcfbfcab2297a3f6$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $bcfbfcab2297a3f6$export$abebb208988c258 = /*#__PURE__*/ function(USER_TYPES) {
    USER_TYPES["DEFAULT"] = "DEFAULT";
    USER_TYPES["SPECIAL"] = "SPECIAL";
    USER_TYPES["APP"] = "APP";
    return USER_TYPES;
}({});
var $bcfbfcab2297a3f6$export$db83999c14438df4 = (0, $hibjE.mention)({
    parseDOM: [
        {
            tag: 'span[data-mention-id]',
            getAttrs: function getAttrs(domNode) {
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                var dom = domNode;
                var attrs = {
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    id: dom.getAttribute('data-mention-id') || $bcfbfcab2297a3f6$export$db83999c14438df4.attrs.id.default,
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    text: dom.textContent || $bcfbfcab2297a3f6$export$db83999c14438df4.attrs.text.default,
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    accessLevel: dom.getAttribute('data-access-level') || // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    $bcfbfcab2297a3f6$export$db83999c14438df4.attrs.accessLevel.default,
                    localId: (0, $l56lt.uuid).generate()
                };
                var userType = dom.getAttribute('data-user-type');
                if ($bcfbfcab2297a3f6$export$abebb208988c258[userType]) attrs.userType = userType;
                return attrs;
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node$attrs = node.attrs, id = _node$attrs.id, accessLevel = _node$attrs.accessLevel, text = _node$attrs.text, userType = _node$attrs.userType, localId = _node$attrs.localId;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        var attrs = {
            'data-mention-id': id,
            'data-access-level': accessLevel,
            contenteditable: 'false'
        };
        if (localId) attrs['data-local-id'] = localId;
        if (userType) attrs['data-user-type'] = userType;
        return [
            'span',
            attrs,
            text
        ];
    }
});
var $bcfbfcab2297a3f6$var$isOptional = function isOptional(key) {
    return [
        'userType',
        'localId'
    ].indexOf(key) > -1;
};
var $bcfbfcab2297a3f6$export$54fd2c36b5cc6731 = function toJSON(node) {
    return {
        attrs: Object.keys(node.attrs).reduce(function(obj, key) {
            if ($bcfbfcab2297a3f6$var$isOptional(key) && !node.attrs[key]) return obj;
            return $bcfbfcab2297a3f6$var$_objectSpread($bcfbfcab2297a3f6$var$_objectSpread({}, obj), {}, (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, key, node.attrs[key]));
        }, {})
    };
};



var $hibjE = parcelRequire("hibjE");

var $l56lt = parcelRequire("l56lt");
var $cd973dd5f5481b0f$export$76c7e83ecc9cdf05 = (0, $hibjE.listItem)({
    parseDOM: [
        {
            tag: 'li'
        }
    ],
    toDOM: function toDOM() {
        return [
            'li',
            0
        ];
    }
});
var $cd973dd5f5481b0f$export$483d52f09158e61c = (0, $hibjE.listItem)({
    parseDOM: [
        {
            tag: 'li',
            getAttrs: function getAttrs() {
                return {
                    localId: (0, $l56lt.uuid).generate()
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node$attrs;
        return [
            'li',
            {
                'data-local-id': (node === null || node === void 0 ? void 0 : (_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.localId) || undefined
            },
            0
        ];
    }
});
var $cd973dd5f5481b0f$export$fcbecfed570fc881 = (0, $hibjE.listItemWithFlexibleFirstChildStage0)({
    parseDOM: [
        {
            tag: 'li',
            getAttrs: function getAttrs() {
                return {
                    localId: (0, $l56lt.uuid).generate()
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node$attrs2;
        return [
            'li',
            {
                'data-local-id': (node === null || node === void 0 ? void 0 : (_node$attrs2 = node.attrs) === null || _node$attrs2 === void 0 ? void 0 : _node$attrs2.localId) || undefined
            },
            0
        ];
    }
});



var $jRLnM = parcelRequire("jRLnM");

var $hibjE = parcelRequire("hibjE");
var $0843b8206c94d9c8$export$6f093cfa640b7166 = (0, $hibjE.text)({
    toDebugString: function() {
        return 'text_node';
    }
});


var $e7d33089ad270e58$var$name = 'unknownBlock';
var $e7d33089ad270e58$export$2e2bcd8739ae039 = {
    group: 'block',
    content: 'inline+',
    marks: '_',
    toDOM: function toDOM() {
        return [
            'div',
            {
                'data-node-type': $e7d33089ad270e58$var$name
            },
            0
        ];
    },
    parseDOM: [
        {
            tag: "div[data-node-type=\"".concat($e7d33089ad270e58$var$name, "\"]")
        }
    ]
};



var $hibjE = parcelRequire("hibjE");

var $l56lt = parcelRequire("l56lt");
var $06b7e02ee990af9a$export$8e3c2dfdc4f0453d = (0, $hibjE.caption)({
    parseDOM: [
        {
            tag: 'figcaption[data-caption]'
        }
    ],
    toDOM: function toDOM() {
        var attrs = {
            'data-caption': 'true'
        };
        return [
            'figcaption',
            attrs,
            0
        ];
    }
});
var $06b7e02ee990af9a$export$b5d01ee303c467aa = (0, $hibjE.caption)({
    parseDOM: [
        {
            tag: 'figcaption[data-caption]',
            getAttrs: function getAttrs() {
                return {
                    localId: (0, $l56lt.uuid).generate()
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node$attrs;
        var attrs = {
            'data-caption': 'true'
        };
        if ((node === null || node === void 0 ? void 0 : (_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.localId) !== undefined) attrs['data-local-id'] = node.attrs.localId;
        return [
            'figcaption',
            attrs,
            0
        ];
    }
});



var $25nEq = parcelRequire("25nEq");

var $8HAlz = parcelRequire("8HAlz");

var $hibjE = parcelRequire("hibjE");

var $l56lt = parcelRequire("l56lt");
function $aacb6205dbe8d16e$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $aacb6205dbe8d16e$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $aacb6205dbe8d16e$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $aacb6205dbe8d16e$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $aacb6205dbe8d16e$export$bb3fe706be61f640 = (0, $hibjE.media)({}).attrs;
var $aacb6205dbe8d16e$export$f84fdfb973c05bd8 = function camelCaseToKebabCase(str) {
    return(// @ts-ignore TS1501: This regular expression flag is only available when targeting 'es6' or later.
    str.replace(/((?:[\0-@\[-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])+)([A-Z])/g, function(_, x, y) {
        return "".concat(x, "-").concat(y.toLowerCase());
    }));
};
var $aacb6205dbe8d16e$export$111130fa8968d741 = function copyPrivateAttributes(from, to, attributes, map) {
    var attrs = attributes || {};
    Object.keys(attrs).forEach(function(key) {
        if (key[0] === '_' && key[1] === '_' && from[key]) to[map ? map(key) : key] = from[key];
    });
};
var $aacb6205dbe8d16e$export$35bdbf5bc8caa677 = function createMediaSpec(attributes) {
    var inline = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var generateLocalId = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    var domNodeType = inline ? 'span' : 'div';
    var nodeName = inline ? 'mediaInline' : 'media';
    var parseDOM = [
        {
            tag: "".concat(domNodeType, "[data-node-type=\"").concat(nodeName, "\"]"),
            getAttrs: function getAttrs(dom) {
                var attrs = {};
                if (attributes) Object.keys(attributes).forEach(function(k) {
                    // @ts-ignore TS1501: This regular expression flag is only available when targeting 'es6' or later.
                    // eslint-disable-next-line @atlassian/perf-linting/no-expensive-split-replace -- Ignored via go/ees017 (to be fixed)
                    var key = $aacb6205dbe8d16e$export$f84fdfb973c05bd8(k).replace(/^__/, '');
                    // eslint-disable-next-line @atlaskit/editor/no-as-casting
                    var value = dom.getAttribute("data-".concat(key)) || '';
                    if (value) attrs[k] = value;
                });
                // Need to do validation & type conversion manually
                if (attrs.__fileSize) attrs.__fileSize = +attrs.__fileSize;
                var width = Number(attrs.width);
                if (typeof width !== 'undefined' && !isNaN(width)) attrs.width = width;
                var height = Number(attrs.height);
                if (typeof height !== 'undefined' && !isNaN(height)) attrs.height = height;
                if (generateLocalId) attrs.localId = (0, $l56lt.uuid).generate();
                return attrs;
            }
        },
        // Don't match data URI
        {
            tag: 'img[src^="data:image"]',
            ignore: true
        }
    ];
    var toDOM = function toDOM(node) {
        var attrs = {
            'data-id': node.attrs.id,
            'data-node-type': "".concat(nodeName),
            'data-type': node.attrs.type,
            'data-collection': node.attrs.collection,
            'data-occurrence-key': node.attrs.occurrenceKey,
            'data-width': node.attrs.width,
            'data-height': node.attrs.height,
            'data-url': node.attrs.url,
            'data-alt': node.attrs.alt,
            'data-local-id': node.attrs.localId || undefined,
            // toDOM is used for static rendering as well as editor rendering. This comes into play for
            // emails, copy/paste, etc, so the title and styling here *is* useful (despite a React-based
            // node view being used for editing).
            title: 'Attachment',
            // Manually kept in sync with the style of media cards. The goal is to render a plain gray
            // rectangle that provides an affordance for media.
            style: "display: inline-block; border-radius: 3px; background: ".concat((0, $8HAlz.N30), "; box-shadow: 0 1px 1px rgba(9, 30, 66, 0.2), 0 0 1px 0 rgba(9, 30, 66, 0.24);")
        };
        $aacb6205dbe8d16e$export$111130fa8968d741(node.attrs, attrs, attributes, function(key) {
            return "data-".concat($aacb6205dbe8d16e$export$f84fdfb973c05bd8(key.slice(2)));
        });
        return [
            "".concat(domNodeType),
            attrs
        ];
    };
    if (inline) return (0, $hibjE.mediaInline)({
        parseDOM: parseDOM,
        toDOM: toDOM
    });
    return (0, $hibjE.media)({
        parseDOM: [].concat(parseDOM, [
            {
                // media-inline.ts uses this same function to generate the nodespec
                // this ensures that we don't make a media inline out of a copied image
                // https://product-fabric.atlassian.net/browse/EDM-2996
                tag: 'img:not(.smart-link-icon)',
                getAttrs: function getAttrs(dom) {
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    var attrs = {
                        type: 'external',
                        // eslint-disable-next-line @atlaskit/editor/no-as-casting
                        url: dom.getAttribute('src') || '',
                        // eslint-disable-next-line @atlaskit/editor/no-as-casting
                        alt: dom.getAttribute('alt') || ''
                    };
                    if (generateLocalId) attrs.localId = (0, $l56lt.uuid).generate();
                    return attrs;
                }
            }
        ]),
        toDOM: toDOM
    });
};
var $aacb6205dbe8d16e$export$987d49ffe1b0900f = $aacb6205dbe8d16e$export$35bdbf5bc8caa677($aacb6205dbe8d16e$export$bb3fe706be61f640, false, false);
var $aacb6205dbe8d16e$export$8446e47a4c7fd000 = $aacb6205dbe8d16e$export$35bdbf5bc8caa677($aacb6205dbe8d16e$var$_objectSpread($aacb6205dbe8d16e$var$_objectSpread({}, $aacb6205dbe8d16e$export$bb3fe706be61f640), {}, {
    localId: {
        default: (0, $l56lt.uuid).generate()
    }
}), false, true);
/**
 * There's no concept of optional property in ProseMirror. It sets value as `null`
 * when there's no use of any property. We are filtering out all private & optional attrs here.
 */ var $aacb6205dbe8d16e$var$optionalAttributes = [
    'occurrenceKey',
    'width',
    'height',
    'url',
    'alt',
    'localId'
];
var $aacb6205dbe8d16e$var$externalOnlyAttributes = [
    'type',
    'url',
    'width',
    'height',
    'alt',
    'localId'
];
var $aacb6205dbe8d16e$export$54fd2c36b5cc6731 = function toJSON(node) {
    return {
        attrs: Object.keys(node.attrs)// Strip private attributes e.g. __fileName, __fileSize, __fileMimeType, etc.
        .filter(function(key) {
            return !(key[0] === '_' && key[1] === '_');
        })// eslint-disable-next-line @typescript-eslint/no-explicit-any
        .reduce(function(obj, key) {
            if (node.attrs.type === 'external' && $aacb6205dbe8d16e$var$externalOnlyAttributes.indexOf(key) === -1) return obj;
            if ($aacb6205dbe8d16e$var$optionalAttributes.indexOf(key) > -1 && (node.attrs[key] === null || node.attrs[key] === '')) return obj;
            if ([
                'width',
                'height'
            ].indexOf(key) !== -1) {
                obj[key] = Number(node.attrs[key]);
                return obj;
            }
            obj[key] = node.attrs[key];
            return obj;
        }, {})
    };
};



var $hibjE = parcelRequire("hibjE");
var $cc684338e25ee07f$export$2855e964765eac9 = (0, $hibjE.mediaGroup)({
    parseDOM: [
        {
            tag: 'div[data-node-type="mediaGroup"]'
        },
        {
            tag: 'div[class="MediaGroup"]'
        }
    ],
    toDOM: function toDOM() {
        return [
            'div',
            {
                'data-node-type': 'mediaGroup'
            },
            0
        ];
    }
});



var $25nEq = parcelRequire("25nEq");


var $l56lt = parcelRequire("l56lt");

var $hibjE = parcelRequire("hibjE");
function $e66d54db0e5b1698$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $e66d54db0e5b1698$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $e66d54db0e5b1698$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $e66d54db0e5b1698$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $e66d54db0e5b1698$export$38bab695e3f720f1 = (0, $aacb6205dbe8d16e$export$35bdbf5bc8caa677)((0, $hibjE.mediaInline)({}).attrs, true);
var $e66d54db0e5b1698$export$aea8e9c496505c61 = (0, $aacb6205dbe8d16e$export$35bdbf5bc8caa677)($e66d54db0e5b1698$var$_objectSpread($e66d54db0e5b1698$var$_objectSpread({}, (0, $hibjE.mediaInline)({}).attrs), {}, {
    localId: {
        default: (0, $l56lt.uuid).generate()
    }
}), true, true);



var $25nEq = parcelRequire("25nEq");
/**
 * @description The widthType attribute is used to support fixed with media single
 */ var $abf4fcbf0aa98110$export$4d41558722ac7eed = /*#__PURE__*/ function(WidthType) {
    WidthType["PIXEL"] = "pixel";
    WidthType["PERCENTAGE"] = "percentage";
    return WidthType;
}({});


var $a499da7ad88c6850$export$c296e2d4365c37a5 = function isDOMElement(maybeNode) {
    return maybeNode instanceof Node && maybeNode.nodeType === Node.ELEMENT_NODE;
};



var $hibjE = parcelRequire("hibjE");

var $l56lt = parcelRequire("l56lt");
function $ea198752dd60970b$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $ea198752dd60970b$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $ea198752dd60970b$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $ea198752dd60970b$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $ea198752dd60970b$export$bb3fe706be61f640 = {
    width: {
        default: null
    },
    // null makes small images to have original size by default
    layout: {
        default: 'center'
    }
};
var $ea198752dd60970b$export$5a1e124099b60c6b = function mediaSingleSpec(_ref) {
    var _ref$withCaption = _ref.withCaption, withCaption = _ref$withCaption === void 0 ? false : _ref$withCaption, _ref$withExtendedWidt = _ref.withExtendedWidthTypes, withExtendedWidthTypes = _ref$withExtendedWidt === void 0 ? false : _ref$withExtendedWidt, _ref$generateLocalId = _ref.generateLocalId, generateLocalId = _ref$generateLocalId === void 0 ? false : _ref$generateLocalId;
    var getAttrs = function getAttrs(dom) {
        if (!(0, $a499da7ad88c6850$export$c296e2d4365c37a5)(dom)) // this should never happen
        return {
            layout: 'center'
        };
        var layout = dom.getAttribute('data-layout') || 'center';
        var width = Number(dom.getAttribute('data-width')) || null;
        var widthType = dom.getAttribute('data-width-type');
        if (generateLocalId) return {
            layout: layout,
            width: width,
            widthType: widthType,
            localId: (0, $l56lt.uuid).generate()
        };
        if (withExtendedWidthTypes) return {
            layout: layout,
            width: width,
            widthType: widthType
        };
        else if (widthType === (0, $abf4fcbf0aa98110$export$4d41558722ac7eed).PIXEL) // if editor does not support widthType attribute.
        // We ignore width and widthType together.
        return {
            layout: layout
        };
        else return {
            layout: layout,
            width: width
        };
    };
    var getAttrsFromNode = function getAttrsFromNode(node) {
        var _node$attrs = node.attrs, layout = _node$attrs.layout, width = _node$attrs.width;
        var attrs = {
            'data-node-type': 'mediaSingle',
            'data-layout': layout,
            'data-width': ''
        };
        if (generateLocalId) {
            var _node$attrs2;
            attrs['data-local-id'] = (node === null || node === void 0 ? void 0 : (_node$attrs2 = node.attrs) === null || _node$attrs2 === void 0 ? void 0 : _node$attrs2.localId) || undefined;
        }
        if (width) attrs['data-width'] = isFinite(width) && Math.floor(width) === width ? width : width.toFixed(2);
        if (withExtendedWidthTypes && node.attrs.widthType) {
            var widthType = node.attrs.widthType;
            return $ea198752dd60970b$var$_objectSpread($ea198752dd60970b$var$_objectSpread({}, attrs), {}, {
                'data-width-type': widthType || (0, $abf4fcbf0aa98110$export$4d41558722ac7eed).PERCENTAGE
            });
        }
        return attrs;
    };
    if (withExtendedWidthTypes && withCaption) return (0, $hibjE.mediaSingleFull)({
        parseDOM: [
            {
                tag: 'div[data-node-type="mediaSingle"]',
                getAttrs: getAttrs
            }
        ],
        toDOM: function toDOM(node) {
            return [
                'div',
                getAttrsFromNode(node),
                0
            ];
        }
    });
    if (withExtendedWidthTypes && !withCaption) return (0, $hibjE.mediaSingleWidthType)({
        parseDOM: [
            {
                tag: 'div[data-node-type="mediaSingle"]',
                getAttrs: getAttrs
            }
        ],
        toDOM: function toDOM(node) {
            return [
                'div',
                getAttrsFromNode(node),
                0
            ];
        }
    });
    if (!withExtendedWidthTypes && withCaption) return (0, $hibjE.mediaSingleCaption)({
        parseDOM: [
            {
                tag: 'div[data-node-type="mediaSingle"]',
                getAttrs: getAttrs
            }
        ],
        toDOM: function toDOM(node) {
            return [
                'div',
                getAttrsFromNode(node),
                0
            ];
        }
    });
    return (0, $hibjE.mediaSingle)({
        parseDOM: [
            {
                tag: 'div[data-node-type="mediaSingle"]',
                getAttrs: getAttrs
            }
        ],
        toDOM: function toDOM(node) {
            return [
                'div',
                getAttrsFromNode(node),
                0
            ];
        }
    });
};
var $ea198752dd60970b$export$969fe3781ca15058 = $ea198752dd60970b$export$5a1e124099b60c6b({
    withCaption: false,
    withExtendedWidthTypes: false
});
var $ea198752dd60970b$export$d35e6c006d4abdfb = $ea198752dd60970b$export$5a1e124099b60c6b({
    withCaption: true,
    withExtendedWidthTypes: false
});
var $ea198752dd60970b$export$9c58e19811ce4cf5 = $ea198752dd60970b$export$5a1e124099b60c6b({
    withCaption: false,
    withExtendedWidthTypes: true
});
var $ea198752dd60970b$export$7e767666f2ce108a = $ea198752dd60970b$export$5a1e124099b60c6b({
    withCaption: true,
    withExtendedWidthTypes: true
});
var $ea198752dd60970b$export$75376a385837c942 = $ea198752dd60970b$export$5a1e124099b60c6b({
    withCaption: true,
    withExtendedWidthTypes: true,
    generateLocalId: true
});
var $ea198752dd60970b$export$54fd2c36b5cc6731 = function toJSON(node) {
    return {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        attrs: Object.keys(node.attrs).reduce(function(obj, key) {
            if (node.attrs[key] !== null) obj[key] = node.attrs[key];
            return obj;
        }, {})
    };
};



var $4iuZ2 = parcelRequire("4iuZ2");

var $l56lt = parcelRequire("l56lt");

var $hibjE = parcelRequire("hibjE");
/**
 * @name decisionList_node
 */ var $964797ab5bfd59fb$var$name = 'decisionList';
var $964797ab5bfd59fb$export$a5393ce68c2ff601 = "[data-node-type=\"".concat($964797ab5bfd59fb$var$name, "\"]");
var $964797ab5bfd59fb$export$62d45a65fb43d95e = (0, $hibjE.decisionList)({
    parseDOM: [
        {
            tag: "ol".concat($964797ab5bfd59fb$export$a5393ce68c2ff601),
            // Default priority is 50. We normally don't change this but since this node type is
            // also used by ordered-list we need to make sure that we run this parser first.
            priority: 100,
            getAttrs: function getAttrs() {
                return {
                    localId: (0, $l56lt.uuid).generate()
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var localId = node.attrs.localId;
        var attrs = {
            'data-node-type': $964797ab5bfd59fb$var$name,
            'data-decision-list-local-id': localId || 'local-decision-list',
            style: 'list-style: none; padding-left: 0'
        };
        return [
            'ol',
            attrs,
            0
        ];
    }
});



var $l56lt = parcelRequire("l56lt");

var $hibjE = parcelRequire("hibjE");
var $6f5a7a342445f237$export$6959e16eeff859b4 = (0, $hibjE.decisionItem)({
    parseDOM: [
        {
            tag: 'li[data-decision-local-id]',
            // Default priority is 50. We normally don't change this but since this node type is
            // also used by list-item we need to make sure that we run this parser first.
            priority: 100,
            getAttrs: function getAttrs(dom) {
                return {
                    localId: (0, $l56lt.uuid).generate(),
                    // eslint-disable-next-line @atlaskit/editor/no-as-casting, @typescript-eslint/no-non-null-assertion
                    state: dom.getAttribute('data-decision-state')
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node$attrs = node.attrs, localId = _node$attrs.localId, state = _node$attrs.state;
        var attrs = {
            'data-decision-local-id': localId || 'local-decision',
            'data-decision-state': state
        };
        return [
            'li',
            attrs,
            0
        ];
    }
});



var $25nEq = parcelRequire("25nEq");

var $hibjE = parcelRequire("hibjE");

var $l56lt = parcelRequire("l56lt");
function $b2e5441fe7d9a137$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $b2e5441fe7d9a137$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $b2e5441fe7d9a137$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $b2e5441fe7d9a137$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
/**
 * @name taskList_node
 */ var $b2e5441fe7d9a137$var$name = 'actionList';
var $b2e5441fe7d9a137$export$c0ec71adb7a18fb2 = "[data-node-type=\"".concat($b2e5441fe7d9a137$var$name, "\"]");
var $b2e5441fe7d9a137$var$taskListParseDOMAndToDOM = {
    parseDOM: [
        {
            tag: "div".concat($b2e5441fe7d9a137$export$c0ec71adb7a18fb2),
            // Default priority is 50. We normally don't change this but since this node type is
            // also used by ordered-list we need to make sure that we run this parser first.
            priority: 100,
            getAttrs: function getAttrs() {
                return {
                    localId: (0, $l56lt.uuid).generate()
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var localId = node.attrs.localId;
        var attrs = {
            'data-node-type': $b2e5441fe7d9a137$var$name,
            'data-task-list-local-id': localId || 'local-task-list',
            style: 'list-style: none; padding-left: 0'
        };
        return [
            'div',
            attrs,
            0
        ];
    }
};
var $b2e5441fe7d9a137$export$375b6afcc5f4d291 = (0, $hibjE.taskList)($b2e5441fe7d9a137$var$taskListParseDOMAndToDOM);
var $b2e5441fe7d9a137$var$taskListWithFlexibleFirstChild = (0, $hibjE.taskListWithFlexibleFirstChildStage0)($b2e5441fe7d9a137$var$taskListParseDOMAndToDOM);
var $b2e5441fe7d9a137$export$3c86306d85ad1f18 = $b2e5441fe7d9a137$var$_objectSpread($b2e5441fe7d9a137$var$_objectSpread({}, $b2e5441fe7d9a137$var$taskListWithFlexibleFirstChild), {}, {
    // Generated spec omits PM group; keep taskList in block content for doc validation.
    group: 'block'
});



var $l56lt = parcelRequire("l56lt");

var $hibjE = parcelRequire("hibjE");
var $cbf37c1c4b8d5d30$export$6d8b0ef52e2e6390 = (0, $hibjE.taskItem)({
    parseDOM: [
        {
            tag: 'div[data-task-local-id]',
            // Default priority is 50. We normally don't change this but since this node type is
            // also used by list-item we need to make sure that we run this parser first.
            priority: 100,
            getAttrs: function getAttrs(dom) {
                return {
                    localId: (0, $l56lt.uuid).generate(),
                    // eslint-disable-next-line @atlaskit/editor/no-as-casting
                    state: dom.getAttribute('data-task-state') || 'TODO'
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node$attrs = node.attrs, localId = _node$attrs.localId, state = _node$attrs.state;
        var attrs = {
            'data-task-local-id': localId || 'local-task',
            'data-task-state': state || 'TODO'
        };
        return [
            'div',
            attrs,
            0
        ];
    }
});
var $cbf37c1c4b8d5d30$export$16018c61064a18df = (0, $hibjE.blockTaskItem)({
    parseDOM: [
        {
            tag: 'div[data-task-is-block]',
            // Default priority is 50. We normally don't change this but since this node type is
            // also used by list-item we need to make sure that we run this parser first.
            priority: 100,
            getAttrs: function getAttrs(dom) {
                return {
                    localId: (0, $l56lt.uuid).generate(),
                    // eslint-disable-next-line @atlaskit/editor/no-as-casting
                    state: dom.getAttribute('data-task-state') || 'TODO'
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node$attrs2 = node.attrs, localId = _node$attrs2.localId, state = _node$attrs2.state;
        var attrs = {
            'data-task-local-id': localId || 'local-task',
            'data-task-state': state || 'TODO',
            'data-task-is-block': 'true'
        };
        return [
            'div',
            attrs,
            0
        ];
    }
});



var $hibjE = parcelRequire("hibjE");

var $l56lt = parcelRequire("l56lt");
var $1d8f0dac087417d1$export$324d90190a8b822a = (0, $hibjE.date)({
    parseDOM: [
        {
            tag: 'span[data-node-type="date"]',
            getAttrs: function getAttrs(dom) {
                return {
                    // eslint-disable-next-line @atlaskit/editor/no-as-casting
                    timestamp: dom.getAttribute('data-timestamp')
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var attrs = {
            'data-node-type': 'date',
            'data-timestamp': node.attrs.timestamp
        };
        return [
            'span',
            attrs
        ];
    }
});
var $1d8f0dac087417d1$export$a6a035390e3921b2 = (0, $hibjE.date)({
    parseDOM: [
        {
            tag: 'span[data-node-type="date"]',
            getAttrs: function getAttrs(dom) {
                return {
                    // eslint-disable-next-line @atlaskit/editor/no-as-casting
                    timestamp: dom.getAttribute('data-timestamp'),
                    localId: (0, $l56lt.uuid).generate()
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node$attrs;
        var attrs = {
            'data-node-type': 'date',
            'data-timestamp': node.attrs.timestamp,
            'data-local-id': (node === null || node === void 0 ? void 0 : (_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.localId) || undefined
        };
        return [
            'span',
            attrs
        ];
    }
});



var $hibjE = parcelRequire("hibjE");

var $l56lt = parcelRequire("l56lt");
var $22fba87185ef0411$export$c7187bbd1a7a9244 = (0, $hibjE.placeholder)({
    parseDOM: [
        {
            tag: 'span[data-placeholder]',
            getAttrs: function getAttrs(dom) {
                return {
                    text: // eslint-disable-next-line @atlaskit/editor/no-as-casting, @typescript-eslint/no-non-null-assertion
                    dom.getAttribute('data-placeholder') || // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    $22fba87185ef0411$export$c7187bbd1a7a9244.attrs.text.default
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var text = node.attrs.text;
        var attrs = {
            'data-placeholder': text,
            // Needs to be edtiable for mobile to not close keyboard
            contenteditable: 'true'
        };
        return [
            'span',
            attrs,
            text
        ];
    }
});
var $22fba87185ef0411$export$6205248609a8f7a0 = (0, $hibjE.placeholder)({
    parseDOM: [
        {
            tag: 'span[data-placeholder]',
            getAttrs: function getAttrs(dom) {
                return {
                    text: // eslint-disable-next-line @atlaskit/editor/no-as-casting, @typescript-eslint/no-non-null-assertion
                    dom.getAttribute('data-placeholder') || // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    $22fba87185ef0411$export$c7187bbd1a7a9244.attrs.text.default,
                    localId: (0, $l56lt.uuid).generate()
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node$attrs;
        var text = node.attrs.text;
        var attrs = {
            'data-placeholder': text,
            // Needs to be edtiable for mobile to not close keyboard
            contenteditable: 'true',
            'data-local-id': (node === null || node === void 0 ? void 0 : (_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.localId) || undefined
        };
        return [
            'span',
            attrs,
            text
        ];
    }
});



var $hibjE = parcelRequire("hibjE");

var $l56lt = parcelRequire("l56lt");
var $1f387ae27d37c85e$export$b3b6a70a7fa4a5be = (0, $hibjE.layoutSection)({
    parseDOM: [
        {
            context: 'layoutSection//|layoutColumn//',
            tag: 'div[data-layout-section]',
            skip: true
        },
        {
            tag: 'div[data-layout-section]'
        }
    ],
    toDOM: function toDOM() {
        var attrs = {
            'data-layout-section': 'true'
        };
        return [
            'div',
            attrs,
            0
        ];
    }
});
var $1f387ae27d37c85e$export$cdae19acb0a520fd = (0, $hibjE.layoutSectionFull)({
    parseDOM: [
        {
            context: 'layoutSection//|layoutColumn//',
            tag: 'div[data-layout-section]',
            skip: true
        },
        {
            tag: 'div[data-layout-section]'
        }
    ],
    toDOM: function toDOM() {
        var attrs = {
            'data-layout-section': 'true'
        };
        return [
            'div',
            attrs,
            0
        ];
    }
});
var $1f387ae27d37c85e$export$4f9d8f623ff17117 = (0, $hibjE.layoutSectionWithSingleColumnStage0)({
    parseDOM: [
        {
            context: 'layoutSection//|layoutColumn//',
            tag: 'div[data-layout-section]',
            skip: true
        },
        {
            tag: 'div[data-layout-section]',
            getAttrs: function getAttrs(dom) {
                var columnRuleStyle = dom.getAttribute('data-column-rule-style');
                return columnRuleStyle ? {
                    columnRuleStyle: columnRuleStyle
                } : {};
            }
        }
    ],
    toDOM: function toDOM(node) {
        var columnRuleStyle = node.attrs.columnRuleStyle;
        var attrs = {
            'data-layout-section': 'true',
            'data-column-rule-style': columnRuleStyle || undefined
        };
        return [
            'div',
            attrs,
            0
        ];
    }
});
var $1f387ae27d37c85e$export$d9d3c69a64270b13 = (0, $hibjE.layoutSection)({
    parseDOM: [
        {
            context: 'layoutSection//|layoutColumn//',
            tag: 'div[data-layout-section]',
            skip: true
        },
        {
            tag: 'div[data-layout-section]',
            getAttrs: function getAttrs() {
                var localId = (0, $l56lt.uuid).generate();
                return {
                    localId: localId
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var localId = node.attrs.localId;
        var attrs = {
            'data-layout-section': 'true',
            'data-local-id': localId
        };
        return [
            'div',
            attrs,
            0
        ];
    }
});
var $1f387ae27d37c85e$export$64facded20dfd85c = (0, $hibjE.layoutSectionWithSingleColumnStage0)({
    parseDOM: [
        {
            context: 'layoutSection//|layoutColumn//',
            tag: 'div[data-layout-section]',
            skip: true
        },
        {
            tag: 'div[data-layout-section]',
            getAttrs: function getAttrs(dom) {
                var columnRuleStyle = dom.getAttribute('data-column-rule-style');
                var localId = (0, $l56lt.uuid).generate();
                return columnRuleStyle ? {
                    columnRuleStyle: columnRuleStyle,
                    localId: localId
                } : {
                    localId: localId
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node$attrs;
        var columnRuleStyle = node.attrs.columnRuleStyle;
        var attrs = {
            'data-layout-section': 'true',
            'data-column-rule-style': columnRuleStyle || undefined,
            'data-local-id': (node === null || node === void 0 ? void 0 : (_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.localId) || undefined
        };
        return [
            'div',
            attrs,
            0
        ];
    }
});



var $hibjE = parcelRequire("hibjE");

var $l56lt = parcelRequire("l56lt");

var $iVSxl = parcelRequire("iVSxl");
var $4926a20aff33a51e$export$ab76e7c03cd6f650 = (0, $hibjE.layoutColumn)({
    parseDOM: [
        {
            context: 'layoutColumn//',
            tag: 'div[data-layout-column]',
            skip: true
        },
        {
            tag: 'div[data-layout-column]',
            getAttrs: function getAttrs(domNode) {
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                var dom = domNode;
                return {
                    width: Number(dom.getAttribute('data-column-width')) || undefined
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var attrs = {
            'data-layout-column': 'true'
        };
        var width = node.attrs.width;
        if (width) {
            var baseStyle = "flex-basis: ".concat(width, "%");
            var columnWidthVar = (0, $iVSxl.editorExperiment)('platform_editor_layout_column_resize_handle', true) ? "; --column-width: ".concat(width, "%") : '';
            attrs['style'] = baseStyle + columnWidthVar;
            attrs['data-column-width'] = "".concat(width);
        }
        // We need to apply a attribute to the inner most child to help
        // ProseMirror identify its boundaries better.
        var contentAttrs = {
            'data-layout-content': 'true'
        };
        return [
            'div',
            attrs,
            [
                'div',
                contentAttrs,
                0
            ]
        ];
    }
});
var $4926a20aff33a51e$export$b2e27d292505bac2 = (0, $hibjE.layoutColumn)({
    parseDOM: [
        {
            context: 'layoutColumn//',
            tag: 'div[data-layout-column]',
            skip: true
        },
        {
            tag: 'div[data-layout-column]',
            getAttrs: function getAttrs(domNode) {
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                var dom = domNode;
                return {
                    width: Number(dom.getAttribute('data-column-width')) || undefined,
                    localId: (0, $l56lt.uuid).generate()
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node$attrs;
        var attrs = {
            'data-layout-column': 'true'
        };
        if ((node === null || node === void 0 ? void 0 : (_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.localId) !== undefined) attrs['data-local-id'] = node.attrs.localId;
        var width = node.attrs.width;
        if (width) {
            var baseStyle = "flex-basis: ".concat(width, "%");
            var columnWidthVar = (0, $iVSxl.editorExperiment)('platform_editor_layout_column_resize_handle', true) ? "; --column-width: ".concat(width, "%") : '';
            attrs['style'] = baseStyle + columnWidthVar;
            attrs['data-column-width'] = "".concat(width);
        }
        // We need to apply a attribute to the inner most child to help
        // ProseMirror identify its boundaries better.
        var contentAttrs = {
            'data-layout-content': 'true'
        };
        return [
            'div',
            attrs,
            [
                'div',
                contentAttrs,
                0
            ]
        ];
    }
});



var $hibjE = parcelRequire("hibjE");

var $l56lt = parcelRequire("l56lt");
var $3a1f01737c54306b$export$cbf8224b64e0d942 = (0, $hibjE.inlineCard)({
    parseDOM: [
        {
            tag: 'a[data-inline-card], span[data-inline-card]',
            // bump priority higher than hyperlink
            priority: 100,
            getAttrs: function getAttrs(dom) {
                var anchor = dom;
                var data = anchor.getAttribute('data-card-data');
                /* Support attrs from Editor and Renderer */ return {
                    url: anchor.getAttribute('href') || anchor.getAttribute('data-card-url') || null,
                    data: data ? JSON.parse(data) : null
                };
            }
        },
        // for renderer
        {
            tag: 'div[data-inline-card]',
            getAttrs: function getAttrs(dom) {
                var anchor = dom;
                var data = anchor.getAttribute('data-card-data');
                return {
                    url: anchor.getAttribute('data-card-url'),
                    data: data ? JSON.parse(data) : null
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var attrs = {
            'data-inline-card': '',
            href: node.attrs.url || '',
            'data-card-data': node.attrs.data ? JSON.stringify(node.attrs.data) : ''
        };
        if (node.attrs.url) return [
            'a',
            attrs,
            node.attrs.url
        ];
        else return [
            'a',
            attrs
        ];
    }
});
var $3a1f01737c54306b$export$7ed775fc743eadd1 = (0, $hibjE.inlineCard)({
    parseDOM: [
        {
            tag: 'a[data-inline-card], span[data-inline-card]',
            // bump priority higher than hyperlink
            priority: 100,
            getAttrs: function getAttrs(dom) {
                var anchor = dom;
                var data = anchor.getAttribute('data-card-data');
                /* Support attrs from Editor and Renderer */ return {
                    url: anchor.getAttribute('href') || anchor.getAttribute('data-card-url') || null,
                    data: data ? JSON.parse(data) : null,
                    localId: (0, $l56lt.uuid).generate()
                };
            }
        },
        // for renderer
        {
            tag: 'div[data-inline-card]',
            getAttrs: function getAttrs(dom) {
                var anchor = dom;
                var data = anchor.getAttribute('data-card-data');
                return {
                    url: anchor.getAttribute('data-card-url'),
                    data: data ? JSON.parse(data) : null,
                    localId: (0, $l56lt.uuid).generate()
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node$attrs;
        var attrs = {
            'data-inline-card': '',
            href: node.attrs.url || '',
            'data-card-data': node.attrs.data ? JSON.stringify(node.attrs.data) : '',
            'data-local-id': (node === null || node === void 0 ? void 0 : (_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.localId) || undefined
        };
        if (node.attrs.url) return [
            'a',
            attrs,
            node.attrs.url
        ];
        else return [
            'a',
            attrs
        ];
    }
});



var $25nEq = parcelRequire("25nEq");

var $hibjE = parcelRequire("hibjE");

var $l56lt = parcelRequire("l56lt");
function $1523cff2135842ff$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $1523cff2135842ff$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $1523cff2135842ff$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $1523cff2135842ff$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
/**
 * @name blockCard_node
 */ var $1523cff2135842ff$var$getCommonAttributesFromDom = function getCommonAttributesFromDom(dom) {
    var anchor = dom;
    var data = anchor.getAttribute('data-card-data');
    var datasource = anchor.getAttribute('data-datasource');
    return {
        data: data ? JSON.parse(data) : undefined,
        layout: datasource ? // eslint-disable-next-line @atlaskit/editor/no-as-casting
        dom.getAttribute('data-layout') || undefined : undefined,
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        width: Number(dom.getAttribute('data-width')) || undefined,
        datasource: datasource ? JSON.parse(datasource) : undefined
    };
};
var $1523cff2135842ff$export$c4c2f833baaebdb8 = (0, $hibjE.blockCard)({
    parseDOM: [
        {
            tag: 'a[data-block-card]',
            // bump priority higher than hyperlink
            priority: 100,
            getAttrs: function getAttrs(dom) {
                var anchor = dom;
                return $1523cff2135842ff$var$_objectSpread({
                    url: anchor.getAttribute('href') || undefined
                }, $1523cff2135842ff$var$getCommonAttributesFromDom(dom));
            }
        },
        {
            tag: 'div[data-block-card]',
            getAttrs: function getAttrs(dom) {
                var anchor = dom;
                return $1523cff2135842ff$var$_objectSpread({
                    url: anchor.getAttribute('data-card-url') || undefined
                }, $1523cff2135842ff$var$getCommonAttributesFromDom(dom));
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node$attrs;
        var _ref = node.attrs, url = _ref.url;
        var _ref2 = node.attrs, data = _ref2.data;
        var _ref3 = node.attrs, layout = _ref3.layout, width = _ref3.width, datasource = _ref3.datasource;
        var attrs = {
            'data-block-card': '',
            href: url || '',
            'data-card-data': data ? JSON.stringify(data) : '',
            'data-datasource': datasource ? JSON.stringify(datasource) : '',
            'data-layout': layout,
            'data-width': "".concat(width)
        };
        return [
            'a',
            attrs,
            (node === null || node === void 0 ? void 0 : (_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.url) || ' '
        ];
    }
});
var $1523cff2135842ff$export$9894f24949f094e5 = (0, $hibjE.blockCard)({
    parseDOM: [
        {
            tag: 'a[data-block-card]',
            // bump priority higher than hyperlink
            priority: 100,
            getAttrs: function getAttrs(dom) {
                var anchor = dom;
                return $1523cff2135842ff$var$_objectSpread($1523cff2135842ff$var$_objectSpread({
                    url: anchor.getAttribute('href') || undefined
                }, $1523cff2135842ff$var$getCommonAttributesFromDom(dom)), {}, {
                    localId: (0, $l56lt.uuid).generate()
                });
            }
        },
        {
            tag: 'div[data-block-card]',
            getAttrs: function getAttrs(dom) {
                var anchor = dom;
                return $1523cff2135842ff$var$_objectSpread($1523cff2135842ff$var$_objectSpread({
                    url: anchor.getAttribute('data-card-url') || undefined
                }, $1523cff2135842ff$var$getCommonAttributesFromDom(dom)), {}, {
                    localId: (0, $l56lt.uuid).generate()
                });
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node$attrs2, _node$attrs3;
        var _ref4 = node.attrs, url = _ref4.url;
        var _ref5 = node.attrs, data = _ref5.data;
        var _ref6 = node.attrs, layout = _ref6.layout, width = _ref6.width, datasource = _ref6.datasource;
        var attrs = {
            'data-block-card': '',
            href: url || '',
            'data-card-data': data ? JSON.stringify(data) : '',
            'data-datasource': datasource ? JSON.stringify(datasource) : '',
            'data-layout': layout,
            'data-width': "".concat(width),
            'data-local-id': (node === null || node === void 0 ? void 0 : (_node$attrs2 = node.attrs) === null || _node$attrs2 === void 0 ? void 0 : _node$attrs2.localId) || undefined
        };
        return [
            'a',
            attrs,
            (node === null || node === void 0 ? void 0 : (_node$attrs3 = node.attrs) === null || _node$attrs3 === void 0 ? void 0 : _node$attrs3.url) || ' '
        ];
    }
});



var $hibjE = parcelRequire("hibjE");
var $6f6274e72602d062$export$44b79b0979d0f0f7 = (0, $hibjE.unsupportedBlock)({
    parseDOM: [
        {
            tag: '[data-node-type="unsupportedBlock"]',
            getAttrs: function getAttrs(dom) {
                return {
                    originalValue: JSON.parse(// eslint-disable-next-line @atlaskit/editor/no-as-casting
                    dom.getAttribute('data-original-value') || '{}')
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var attrs = {
            'data-node-type': 'unsupportedBlock',
            'data-original-value': JSON.stringify(node.attrs.originalValue)
        };
        return [
            'div',
            attrs,
            'Unsupported content'
        ];
    }
});



var $hibjE = parcelRequire("hibjE");
var $7baec23ccb628f19$export$310ebe0d80122e9b = (0, $hibjE.unsupportedInline)({
    parseDOM: [
        {
            tag: '[data-node-type="unsupportedInline"]',
            getAttrs: function getAttrs(dom) {
                return {
                    originalValue: JSON.parse(// eslint-disable-next-line @atlaskit/editor/no-as-casting
                    dom.getAttribute('data-original-value') || '{}')
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var attrs = {
            'data-node-type': 'unsupportedInline',
            'data-original-value': JSON.stringify(node.attrs.originalValue)
        };
        return [
            'span',
            attrs,
            'Unsupported content'
        ];
    }
});



var $l56lt = parcelRequire("l56lt");

var $hibjE = parcelRequire("hibjE");

var $3tz1M = parcelRequire("3tz1M");
var $6972390ebb9bd4b0$export$471f7ae5c4103ae1 = (0, $hibjE.status)({
    parseDOM: [
        {
            tag: 'span[data-node-type="status"]',
            getAttrs: function getAttrs(domNode) {
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                var dom = domNode;
                // @ts-ignore TS1501: This regular expression flag is only available when targeting 'es6' or later.
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                var textContent = dom.textContent.replace(/\n/, '').trim();
                // Prefer data-text attribute over textContent
                // When NodeView DOM is copied, inner text content may not be preserved
                var text = (0, $3tz1M.expValEquals)('platform_editor_copy_paste_issue_fix', 'isEnabled', true) ? dom.getAttribute('data-text') || textContent : textContent;
                return {
                    text: text,
                    color: dom.getAttribute('data-color'),
                    localId: (0, $l56lt.uuid).generate(),
                    style: dom.getAttribute('data-style')
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node$attrs = node.attrs, text = _node$attrs.text, color = _node$attrs.color, localId = _node$attrs.localId, style = _node$attrs.style;
        var attrs = {
            'data-node-type': 'status',
            'data-color': color,
            'data-local-id': localId,
            'data-style': style,
            contenteditable: 'false'
        };
        return [
            'span',
            attrs,
            text
        ];
    }
});



var $fC8ib = parcelRequire("fC8ib");

var $25nEq = parcelRequire("25nEq");

var $hibjE = parcelRequire("hibjE");

var $l56lt = parcelRequire("l56lt");
function $e1accce4e805401f$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $e1accce4e805401f$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $e1accce4e805401f$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $e1accce4e805401f$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
/**
 * @name nestedExpand_content
 // eslint-disable-next-line eslint-plugin-jsdoc/check-tag-names
 * @minItems 1
 // eslint-disable-next-line eslint-plugin-jsdoc/check-tag-names
 * @allowUnsupportedBlock true
 */ /**
 * @name nestedExpand_node
 */ /**
 * @name nestedExpand_with_no_marks_node
 */ function $e1accce4e805401f$var$getExpandAttrs(domNode, generateLocalId) {
    // eslint-disable-next-line @atlaskit/editor/no-as-casting
    var dom = domNode;
    return {
        title: dom.getAttribute('data-title'),
        __expanded: true,
        localId: generateLocalId ? (0, $l56lt.uuid).generate() : undefined
    };
}
var $e1accce4e805401f$var$nestedExpandFactoryOptions = {
    parseDOM: [
        {
            context: 'nestedExpand//',
            tag: '[data-node-type="nestedExpand"]',
            getAttrs: function getAttrs(domNode) {
                return $e1accce4e805401f$var$getExpandAttrs(domNode, false);
            }
        },
        {
            tag: '[data-node-type="nestedExpand"] button',
            ignore: true
        },
        {
            tag: '[data-node-type="expand"] button',
            ignore: true
        },
        {
            tag: 'div[data-node-type="nestedExpand"]',
            getAttrs: function getAttrs(domNode) {
                return $e1accce4e805401f$var$getExpandAttrs(domNode, false);
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node$attrs;
        var attrs = {
            'data-node-type': 'nestedExpand',
            'data-title': node.attrs.title,
            'data-expanded': node.attrs.__expanded,
            'data-local-id': (node === null || node === void 0 ? void 0 : (_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.localId) || undefined
        };
        return [
            'div',
            attrs,
            0
        ];
    }
};
var $e1accce4e805401f$export$63cadbf5f4296627 = (0, $hibjE.nestedExpand)($e1accce4e805401f$var$nestedExpandFactoryOptions);
var $e1accce4e805401f$export$b854197485aa1fa0 = (0, $hibjE.nestedExpand)($e1accce4e805401f$var$_objectSpread($e1accce4e805401f$var$_objectSpread({}, $e1accce4e805401f$var$nestedExpandFactoryOptions), {}, {
    parseDOM: [].concat((0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))($e1accce4e805401f$var$nestedExpandFactoryOptions.parseDOM || []), [
        {
            context: 'nestedExpand//',
            tag: '[data-node-type="nestedExpand"]',
            getAttrs: function getAttrs(domNode) {
                return $e1accce4e805401f$var$getExpandAttrs(domNode, true);
            }
        },
        {
            tag: '[data-node-type="nestedExpand"]',
            getAttrs: function getAttrs(domNode) {
                return $e1accce4e805401f$var$getExpandAttrs(domNode, true);
            }
        }
    ])
}));



var $hibjE = parcelRequire("hibjE");

var $l56lt = parcelRequire("l56lt");
var $bc4f37863f21d42d$export$be4283d9a1cb1ff6 = (0, $hibjE.embedCard)({
    parseDOM: [
        {
            tag: 'div[data-embed-card]',
            getAttrs: function getAttrs(dom) {
                return {
                    // eslint-disable-next-line @atlaskit/editor/no-as-casting
                    url: dom.getAttribute('data-card-url'),
                    // eslint-disable-next-line @atlaskit/editor/no-as-casting
                    layout: dom.getAttribute('data-layout') || 'center',
                    // eslint-disable-next-line @atlaskit/editor/no-as-casting
                    width: Number(dom.getAttribute('data-width')) || null,
                    originalWidth: Number(// eslint-disable-next-line @atlaskit/editor/no-as-casting
                    dom.getAttribute('data-card-original-width')) || null,
                    originalHeight: Number(// eslint-disable-next-line @atlaskit/editor/no-as-casting
                    dom.getAttribute('data-card-original-height')) || null
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node$attrs = node.attrs, url = _node$attrs.url, layout = _node$attrs.layout, width = _node$attrs.width, originalWidth = _node$attrs.originalWidth, originalHeight = _node$attrs.originalHeight;
        var attrs = {
            'data-embed-card': '',
            'data-card-url': url,
            'data-layout': layout,
            'data-width': width,
            'data-original-width': originalWidth,
            'data-original-height': originalHeight
        };
        return [
            'div',
            attrs
        ];
    }
});
var $bc4f37863f21d42d$export$36734475a7f6fd3e = (0, $hibjE.embedCard)({
    parseDOM: [
        {
            tag: 'div[data-embed-card]',
            getAttrs: function getAttrs(dom) {
                return {
                    // eslint-disable-next-line @atlaskit/editor/no-as-casting
                    url: dom.getAttribute('data-card-url'),
                    // eslint-disable-next-line @atlaskit/editor/no-as-casting
                    layout: dom.getAttribute('data-layout') || 'center',
                    // eslint-disable-next-line @atlaskit/editor/no-as-casting
                    width: Number(dom.getAttribute('data-width')) || null,
                    originalWidth: Number(// eslint-disable-next-line @atlaskit/editor/no-as-casting
                    dom.getAttribute('data-card-original-width')) || null,
                    originalHeight: Number(// eslint-disable-next-line @atlaskit/editor/no-as-casting
                    dom.getAttribute('data-card-original-height')) || null,
                    localId: (0, $l56lt.uuid).generate()
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node$attrs3;
        var _node$attrs2 = node.attrs, url = _node$attrs2.url, layout = _node$attrs2.layout, width = _node$attrs2.width, originalWidth = _node$attrs2.originalWidth, originalHeight = _node$attrs2.originalHeight;
        var attrs = {
            'data-embed-card': '',
            'data-card-url': url,
            'data-layout': layout,
            'data-width': width,
            'data-original-width': originalWidth,
            'data-original-height': originalHeight,
            'data-local-id': (node === null || node === void 0 ? void 0 : (_node$attrs3 = node.attrs) === null || _node$attrs3 === void 0 ? void 0 : _node$attrs3.localId) || undefined
        };
        return [
            'div',
            attrs
        ];
    }
});


var $abfb26d4dfb5fb5a$export$d5f21755dc782a4a = function isValidLayout(name) {
    return !!name && [
        'default',
        'wide',
        'full-width'
    ].includes(name);
};
var $abfb26d4dfb5fb5a$export$1765e2758fc47004 = function getExtensionAttrs(dom) {
    var isInline = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var extensionType = dom.getAttribute('data-extension-type');
    var extensionKey = dom.getAttribute('data-extension-key');
    if (!extensionType || !extensionKey) return false;
    var attrs = {
        extensionType: extensionType,
        extensionKey: extensionKey,
        text: dom.getAttribute('data-text') || undefined,
        parameters: JSON.parse(dom.getAttribute('data-parameters') || '{}'),
        localId: dom.getAttribute('data-local-id') || undefined
    };
    if (!isInline) {
        var rawLayout = dom.getAttribute('data-layout');
        attrs.layout = $abfb26d4dfb5fb5a$export$d5f21755dc782a4a(rawLayout) ? rawLayout : 'default';
    }
    return attrs;
};



var $hibjE = parcelRequire("hibjE");
var $559b2b6e22802307$export$1b45514b112dd749 = (0, $hibjE.extension)({
    parseDOM: [
        {
            tag: '[data-node-type="extension"]',
            // eslint-disable-next-line @atlaskit/editor/no-as-casting
            getAttrs: function getAttrs(domNode) {
                return (0, $abfb26d4dfb5fb5a$export$1765e2758fc47004)(domNode);
            }
        }
    ],
    toDOM: function toDOM(node) {
        var attrs = {
            'data-node-type': 'extension',
            'data-extension-type': node.attrs.extensionType,
            'data-extension-key': node.attrs.extensionKey,
            'data-text': node.attrs.text,
            'data-parameters': JSON.stringify(node.attrs.parameters),
            'data-layout': node.attrs.layout,
            'data-local-id:': node.attrs.localId
        };
        return [
            'div',
            attrs
        ];
    }
});




var $hibjE = parcelRequire("hibjE");
var $bb20a9c871fceff5$export$16b353b2649bd8d9 = (0, $hibjE.inlineExtensionWithMarks)({
    parseDOM: [
        {
            tag: 'span[data-extension-type]',
            // eslint-disable-next-line @atlaskit/editor/no-as-casting
            getAttrs: function getAttrs(domNode) {
                return (0, $abfb26d4dfb5fb5a$export$1765e2758fc47004)(domNode, true);
            }
        }
    ],
    toDOM: function toDOM(node) {
        var attrs = {
            'data-extension-type': node.attrs.extensionType,
            'data-extension-key': node.attrs.extensionKey,
            'data-text': node.attrs.text,
            'data-parameters': JSON.stringify(node.attrs.parameters),
            'data-local-id:': node.attrs.localId,
            contenteditable: 'false'
        };
        return [
            'span',
            attrs
        ];
    }
});




var $hibjE = parcelRequire("hibjE");
var $8650cd3ae99343ef$export$27903d543b563e39 = (0, $hibjE.bodiedExtension)({
    parseDOM: [
        {
            context: 'bodiedExtension//',
            tag: '[data-node-type="bodied-extension"]',
            skip: true
        },
        {
            tag: '[data-node-type="bodied-extension"]',
            // eslint-disable-next-line @atlaskit/editor/no-as-casting
            getAttrs: function getAttrs(domNode) {
                return (0, $abfb26d4dfb5fb5a$export$1765e2758fc47004)(domNode);
            }
        }
    ],
    toDOM: function toDOM(node) {
        var attrs = {
            'data-node-type': 'bodied-extension',
            'data-extension-type': node.attrs.extensionType,
            'data-extension-key': node.attrs.extensionKey,
            'data-text': node.attrs.text,
            'data-parameters': JSON.stringify(node.attrs.parameters),
            'data-layout': node.attrs.layout,
            'data-local-id:': node.attrs.localId
        };
        return [
            'div',
            attrs,
            0
        ];
    }
});




var $hibjE = parcelRequire("hibjE");
var $78a12cccd6b79e5f$export$4fdcae991fd743e7 = (0, $hibjE.extensionFrameStage0)({
    parseDOM: [
        {
            context: 'extensionFrame//',
            tag: 'div[data-extension-frame]',
            skip: true
        },
        {
            tag: 'div[data-extension-frame]'
        }
    ],
    toDOM: function toDOM() {
        var attrs = {
            'data-extension-frame': 'true'
        };
        return [
            'div',
            attrs,
            0
        ];
    }
});
var $78a12cccd6b79e5f$export$c3c04d555a8b9013 = (0, $hibjE.multiBodiedExtensionStage0)({
    parseDOM: [
        {
            context: 'multiBodiedExtension//',
            tag: '[data-node-type="multi-bodied-extension"]',
            skip: true
        },
        {
            tag: '[data-node-type="multi-bodied-extension"]',
            getAttrs: function getAttrs(domNode) {
                return (0, $abfb26d4dfb5fb5a$export$1765e2758fc47004)(domNode);
            }
        }
    ],
    toDOM: function toDOM(node) {
        var attrs = {
            'data-node-type': 'multi-bodied-extension',
            'data-extension-type': node.attrs.extensionType,
            'data-extension-key': node.attrs.extensionKey,
            'data-text': node.attrs.text,
            'data-parameters': JSON.stringify(node.attrs.parameters),
            'data-layout': node.attrs.layout,
            'data-local-id:': node.attrs.localId
        };
        return [
            'div',
            attrs,
            0
        ];
    }
});



var $hibjE = parcelRequire("hibjE");

var $l56lt = parcelRequire("l56lt");
var $3614b7dcde529e3d$export$faab0ca9701d7048 = (0, $hibjE.syncBlock)({
    parseDOM: [
        {
            tag: 'div[data-sync-block]',
            getAttrs: function getAttrs(domNode) {
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                var dom = domNode;
                var attrs = {
                    localId: dom.getAttribute('data-local-id') || (0, $l56lt.uuid).generate(),
                    resourceId: dom.getAttribute('data-resource-id') || ''
                };
                return attrs;
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node$attrs = node.attrs, localId = _node$attrs.localId, resourceId = _node$attrs.resourceId;
        var name = 'div';
        var attrs = {
            'data-sync-block': '',
            'data-local-id': localId,
            'data-resource-id': resourceId
        };
        return [
            name,
            attrs
        ];
    }
});



var $hibjE = parcelRequire("hibjE");

var $l56lt = parcelRequire("l56lt");
var $1c7b3187728193dc$export$e92c7e4302dd4371 = (0, $hibjE.bodiedSyncBlock)({
    parseDOM: [
        {
            tag: 'div[data-bodied-sync-block]',
            getAttrs: function getAttrs(domNode) {
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                var dom = domNode;
                var attrs = {
                    localId: dom.getAttribute('data-local-id') || (0, $l56lt.uuid).generate(),
                    resourceId: dom.getAttribute('data-resource-id') || ''
                };
                return attrs;
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node$attrs = node.attrs, localId = _node$attrs.localId, resourceId = _node$attrs.resourceId;
        var name = 'div';
        var attrs = {
            'data-bodied-sync-block': '',
            'data-local-id': localId,
            'data-resource-id': resourceId
        };
        return [
            name,
            attrs,
            0
        ];
    }
});




// eslint-disable-next-line @typescript-eslint/no-explicit-any
var $24bf16fa17640746$var$typedNodes = $97d292d308609fa6$exports;
var $24bf16fa17640746$export$b1f729c6af6f2a6e = new Set(Object.keys($24bf16fa17640746$var$typedNodes).filter(function(key) {
    return $24bf16fa17640746$var$typedNodes[key] && $24bf16fa17640746$var$typedNodes[key].group === 'inline';
}));

/**
 * This file has been partially duplicated in packages/linking-platform/linking-common/src/url.ts
 * Any changes made here should be mirrored there.
 * Ticket for dedeplication: https://product-fabric.atlassian.net/browse/EDM-7138
 * Ticket for fixing linkification of filename-like urls: https://product-fabric.atlassian.net/browse/EDM-7190
 */ 
var $840z9 = parcelRequire("840z9");
var $108e5e5f673311da$var$whitelistedURLPatterns = [
    /^http[s\u017F]?:\/\//im,
    /^ftp[s\u017F]?:\/\//im,
    /^gopher:\/\//im,
    /^integrity:\/\//im,
    /^file:\/\//im,
    /^[s\u017F]mb:\/\//im,
    /^dynamic[s\u017F]nav:\/\//im,
    /^jamf[s\u017F]elf[s\u017F]ervice:\/\//im,
    /^\//im,
    /^mailto:/im,
    /^[s\u017F][k\u212A]ype:/im,
    /^callto:/im,
    /^facetime:/im,
    /^git:/im,
    /^irc6?:/im,
    /^new[s\u017F]:/im,
    /^nntp:/im,
    /^feed:/im,
    /^cv[s\u017F]:/im,
    /^[s\u017F]vn:/im,
    /^mvn:/im,
    /^[s\u017F][s\u017F]h:/im,
    /^[s\u017F]cp:\/\//im,
    /^[s\u017F]ftp:\/\//im,
    /^itm[s\u017F]:/im,
    // This is not a valid notes link, but we support this pattern for backwards compatibility
    /^note[s\u017F]:/im,
    /^note[s\u017F]:\/\//im,
    /^hipchat:\/\//im,
    // This is not a valid sourcetree link, but we support this pattern for backwards compatibility
    /^[s\u017F]ourcetree:/im,
    /^[s\u017F]ourcetree:\/\//im,
    /^urn:/im,
    /^tel:/im,
    /^xmpp:/im,
    /^telnet:/im,
    /^vnc:/im,
    /^rdp:/im,
    /^what[s\u017F]app:/im,
    /^[s\u017F]lac[k\u212A]:/im,
    /^[s\u017F]ip[s\u017F]?:/im,
    /^magnet:/im,
    /^#/im
];
var $108e5e5f673311da$export$c9f92f5469372e0f = function isSafeUrl(url) {
    var urlTrimmed = url === null || url === void 0 ? void 0 : url.trim();
    if (urlTrimmed === undefined) return true;
    if (urlTrimmed.length === 0) return true;
    return $108e5e5f673311da$var$whitelistedURLPatterns.some(function(p) {
        return p.test(urlTrimmed);
    });
};
var $108e5e5f673311da$export$8ccbde94d5c7f8e7 = (0, $840z9.default)();
$108e5e5f673311da$export$8ccbde94d5c7f8e7.add('sourcetree:', 'http:');
$108e5e5f673311da$export$8ccbde94d5c7f8e7.add('jamfselfservice:', 'http:');
var $108e5e5f673311da$var$urlWithoutSpacesValidator = {
    validate: /(?:[\0-\x08\x0E-\x1F!-\x9F\xA1-\u167F\u1681-\u1FFF\u200B-\u2027\u202A-\u202E\u2030-\u205E\u2060-\u2FFF\u3001-\uD7FF\uE000-\uFEFE\uFF00-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])+/
};
// `tel:` URI spec is https://datatracker.ietf.org/doc/html/rfc3966
// We're not validating the phone number or separators - but if there's a space it definitely isn't a valid `tel:` URI
$108e5e5f673311da$export$8ccbde94d5c7f8e7.add('tel:', $108e5e5f673311da$var$urlWithoutSpacesValidator);
// https://datatracker.ietf.org/doc/html/rfc8089
$108e5e5f673311da$export$8ccbde94d5c7f8e7.add('file:', $108e5e5f673311da$var$urlWithoutSpacesValidator);
$108e5e5f673311da$export$8ccbde94d5c7f8e7.add('notes:', 'http:');
var $108e5e5f673311da$var$tlds = "biz|com|edu|gov|net|org|pro|web|xxx|aero|asia|coop|info|museum|name|shop|\u0440\u0444".split('|');
var $108e5e5f673311da$var$tlds2Char = 'a[cdefgilmnoqrtuwxz]|b[abdefghijmnorstvwyz]|c[acdfghiklmnoruvwxyz]|d[ejkmoz]|e[cegrstu]|f[ijkmor]|g[abdefghilmnpqrstuwy]|h[kmnrtu]|i[delmnoqrst]|j[emop]|k[eghimnprwyz]|l[abcikrstuvy]|m[acdeghklmnopqrtuvwxyz]|n[acefgilopruz]|om|p[aefghkmnrtw]|qa|r[eosuw]|s[abcdegijklmnrtuvxyz]|t[cdfghjklmnortvwz]|u[agksyz]|v[aceginu]|w[fs]|y[et]|z[amw]';
$108e5e5f673311da$var$tlds.push($108e5e5f673311da$var$tlds2Char);
$108e5e5f673311da$export$8ccbde94d5c7f8e7.tlds($108e5e5f673311da$var$tlds, false);
var $108e5e5f673311da$export$746d02eae03c72e1 = /(https?|ftp|jamfselfservice|gopher|dynamicsnav|integrity|file|smb):\/\/(?:[\0-\x08\x0E-\x1F!-\x9F\xA1-\u167F\u1681-\u1FFF\u200B-\u2027\u202A-\u202E\u2030-\u205E\u2060-\u2FFF\u3001-\uD7FF\uE000-\uFEFE\uFF00-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])+/;
var $108e5e5f673311da$export$6f7d7761b97f967 = function linkifyMatch(text) {
    if (!$108e5e5f673311da$export$746d02eae03c72e1.test(text)) return [];
    var matches = [];
    var startpos = 0;
    var substr;
    substr = text.substr(startpos);
    while(substr){
        var link = (substr.match($108e5e5f673311da$export$746d02eae03c72e1) || [
            ''
        ])[0];
        if (link) {
            var index = substr.search($108e5e5f673311da$export$746d02eae03c72e1);
            var start = index >= 0 ? index + startpos : index;
            var end = start + link.length;
            matches.push({
                index: start,
                lastIndex: end,
                raw: link,
                url: link,
                text: link,
                schema: ''
            });
            startpos += end;
            substr = text.substr(startpos);
        } else break;
    }
    return matches;
};
function $108e5e5f673311da$export$ce9ae45aed3e4ec(str) {
    if (!str) return null;
    // linkify-it mishandles closing braces on long urls, so we preference using our own regex first:
    // https://product-fabric.atlassian.net/browse/ED-13669
    var match = $108e5e5f673311da$export$6f7d7761b97f967(str);
    if (!match.length) match = $108e5e5f673311da$export$8ccbde94d5c7f8e7.match(str);
    return match && match[0];
}
function $108e5e5f673311da$export$6535eb414fa2c8b6(url) {
    var match = $108e5e5f673311da$export$ce9ae45aed3e4ec(url);
    return match && match.url || '';
}
function $108e5e5f673311da$export$23579274a7a24f7b(url) {
    // Support `#top` and `#` special references as per:
    // https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#linking_to_an_element_on_the_same_page
    return url.startsWith('/') || url === '#top' || url === '#';
}


var $jRLnM = parcelRequire("jRLnM");

var $cvlyC = parcelRequire("cvlyC");

var $4iuZ2 = parcelRequire("4iuZ2");

var $9Jwkl = parcelRequire("9Jwkl");
// # What do marks exist?
//
// Marks are categorised into different groups. One motivation for this was to allow the `code` mark
// to exclude other marks, without needing to explicitly name them. Explicit naming requires the
// named mark to exist in the schema. This is undesirable because we want to construct different
// schemas that have different sets of nodes/marks.
//
// Groups provide a level of indirection, and solve this problem. For the immediate use-case, one
// group called "not_code" would have sufficed, but this an ultra-specialised to code.
// Mark group for font styling (e.g. bold, italic, underline, superscript).
var $e4b22187f59641f2$export$4498a6080fed604c = 'fontStyle';
var $e4b22187f59641f2$export$f8e8a5f34f6ea725 = 'searchQuery';
var $e4b22187f59641f2$export$b395009ca7f092c7 = 'link';
var $e4b22187f59641f2$export$9b982809044276a6 = 'color';
var $e4b22187f59641f2$export$470d0905851e47a1 = 'alignment';
var $e4b22187f59641f2$export$bacb7f4b06a06b22 = 'indentation';



var $25nEq = parcelRequire("25nEq");
function $5d37263b6ee57b2c$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $5d37263b6ee57b2c$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $5d37263b6ee57b2c$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $5d37263b6ee57b2c$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $5d37263b6ee57b2c$export$daf54fed04c8fb77(nodes, supportedMarks) {
    var nodeNames = Object.keys(nodes);
    nodeNames.forEach(function(nodeKey) {
        var nodeSpec = $5d37263b6ee57b2c$var$_objectSpread({}, nodes[nodeKey]);
        if (nodeSpec.marks && nodeSpec.marks !== '_') // eslint-disable-next-line @atlassian/perf-linting/no-expensive-split-replace -- Ignored via go/ees017 (to be fixed)
        nodeSpec.marks = nodeSpec.marks.split(' ').filter(function(mark) {
            return !!supportedMarks[mark];
        }).join(' ');
        if (nodeSpec.content) nodeSpec.content = $5d37263b6ee57b2c$var$sanitizeNodeSpecContent(nodes, nodeSpec.content);
        nodes[nodeKey] = nodeSpec;
    });
    return nodes;
}
function $5d37263b6ee57b2c$var$sanitizeNodeSpecContent(nodes, rawContent) {
    // @ts-ignore TS1501: This regular expression flag is only available when targeting 'es6' or later.
    var content = rawContent.replace(/(?:[\0-\/:-@\[-\^`\{-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])/g, ' ');
    var contentKeys = content.split(' ');
    var unsupportedContentKeys = contentKeys.filter(function(contentKey) {
        return !$5d37263b6ee57b2c$var$isContentSupported(nodes, contentKey);
    });
    return unsupportedContentKeys.reduce(function(newContent, nodeName) {
        return $5d37263b6ee57b2c$var$sanitizedContent(newContent, nodeName);
    }, rawContent);
}
function $5d37263b6ee57b2c$var$sanitizedContent(content, invalidContent) {
    if (!invalidContent.length) return content || '';
    // @ts-ignore TS1501: This regular expression flag is only available when targeting 'es6' or later.
    if (!content || !content.match(/[0-9A-Z_a-z]/)) return '';
    var pattern = "(".concat(invalidContent, "((\\s)*\\|)+)|((\\|(\\s)*)+").concat(invalidContent, "(\\+|\\*)?)|(").concat(invalidContent, "$)|(").concat(invalidContent, "(\\+|\\*))");
    return content.replace(new RegExp(pattern, 'gu'), '').replace('  ', ' ').trim();
}
function $5d37263b6ee57b2c$var$isContentSupported(nodes, contentKey) {
    var nodeKeys = Object.keys(nodes);
    // content is with valid node
    if (nodeKeys.indexOf(contentKey) > -1) return true;
    // content is with valid group
    for(var supportedKey in nodes)if (nodes.hasOwnProperty(supportedKey)) {
        var nodeSpec = nodes[supportedKey];
        if (nodeSpec && nodeSpec.group === contentKey) return true;
    }
    return false;
}



var $idfOp = parcelRequire("idfOp");
var $1bd16a105180511f$export$be9cf49015769bbd = {
    end: 'right',
    right: 'end',
    center: 'center'
};
var $1bd16a105180511f$export$8e53000a4ec837 = (0, $idfOp.alignment)({
    parseDOM: [
        {
            tag: 'div.fabric-editor-block-mark',
            getAttrs: function getAttrs(dom) {
                var align = dom.getAttribute('data-align');
                return align ? {
                    align: align
                } : false;
            }
        }
    ],
    toDOM: function toDOM(mark) {
        return [
            'div',
            {
                class: "fabric-editor-block-mark fabric-editor-alignment fabric-editor-align-".concat(mark.attrs.align),
                'data-align': mark.attrs.align
            },
            0
        ];
    }
});


var $jJtX0 = parcelRequire("jJtX0");
var $25nEq = parcelRequire("25nEq");

var $iYJcE = parcelRequire("iYJcE");

var $idfOp = parcelRequire("idfOp");

var $4KSDi = parcelRequire("4KSDi");

var $8HAlz = parcelRequire("8HAlz");

var $25nEq = parcelRequire("25nEq");

var $iYJcE = parcelRequire("iYJcE");

var $idfOp = parcelRequire("idfOp");

var $4KSDi = parcelRequire("4KSDi");

var $8HAlz = parcelRequire("8HAlz");

var $dGnui = parcelRequire("dGnui");
/**
 * @name textColor_mark
 */ // used for extended palette in text color picker
var $a025fc2c63d700a1$var$colorArrayPalette = [
    // default row - first color is added programatically
    // [N800, 'Squid ink'], // default dark gray
    [
        (0, $8HAlz.B500),
        'Dark blue'
    ],
    // Chore coat
    [
        (0, $8HAlz.T500),
        'Dark teal'
    ],
    // Shabby chic
    [
        (0, $8HAlz.G500),
        'Dark green'
    ],
    // Keen green
    [
        (0, $8HAlz.Y400),
        'Orange'
    ],
    // Cheezy blasters
    [
        (0, $8HAlz.R500),
        'Dark red'
    ],
    // Dragon's blood
    [
        (0, $8HAlz.P500),
        'Dark purple'
    ],
    // Prince
    // row 2
    [
        (0, $8HAlz.N80),
        'Light gray'
    ],
    // Spooky ghost
    [
        (0, $8HAlz.B100),
        'Blue'
    ],
    // Arvo breeze
    [
        (0, $8HAlz.T300),
        'Teal'
    ],
    // Tamarama
    [
        (0, $8HAlz.G300),
        'Green'
    ],
    // Fine pine
    [
        (0, $8HAlz.Y200),
        'Yellow'
    ],
    // Pub mix
    [
        (0, $8HAlz.R300),
        'Red'
    ],
    // Poppy surprise
    [
        (0, $8HAlz.P300),
        'Purple'
    ],
    // Da' juice
    // row 3
    [
        (0, $8HAlz.N0),
        'White'
    ],
    [
        (0, $8HAlz.B75),
        'Light blue'
    ],
    // Schwag
    [
        (0, $8HAlz.T75),
        'Light teal'
    ],
    // Arctic chill
    [
        (0, $8HAlz.G75),
        'Light green'
    ],
    // Mintie
    [
        (0, $8HAlz.Y75),
        'Light yellow'
    ],
    // Dandelion whisper
    [
        (0, $8HAlz.R75),
        'Light red'
    ],
    // Bondi sunburn
    [
        (0, $8HAlz.P50),
        'Light purple'
    ] // Lavender secret
];
var $a025fc2c63d700a1$export$569885e57444f84a = new Map();
var $a025fc2c63d700a1$export$81e5ed9e84fe2e28 = $a025fc2c63d700a1$export$569885e57444f84a;
$a025fc2c63d700a1$var$colorArrayPalette.forEach(function(_ref) {
    var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_ref, 2), color = _ref2[0], label = _ref2[1];
    return $a025fc2c63d700a1$export$569885e57444f84a.set(color.toLowerCase(), label);
});
// these are for test only
var $a025fc2c63d700a1$var$testGlobalTheme;
var $a025fc2c63d700a1$export$fd7e0dd2b74807f7 = function setGlobalTheme(theme) {
    $a025fc2c63d700a1$var$testGlobalTheme = theme;
};
var $a025fc2c63d700a1$export$813ecdf77207a053 = function getGlobalTheme() {
    // This should only be hit during tests.
    //
    // At time of writing Jest mocks are not working in this repository.
    if ($a025fc2c63d700a1$var$testGlobalTheme) return {
        colorMode: $a025fc2c63d700a1$var$testGlobalTheme
    };
    var element = document.documentElement;
    var colorMode = element.getAttribute('data-color-mode') || '';
    return {
        colorMode: colorMode
    };
};
var $a025fc2c63d700a1$export$32f78bffcd82ff28 = (0, $idfOp.textColor)({
    parseDOM: [
        {
            style: 'color',
            getAttrs: function getAttrs(maybeValue) {
                var value = maybeValue;
                var hexColor;
                // @ts-ignore TS1501: This regular expression flag is only available when targeting 'es6' or later.
                if (value.match(/^rgb/i)) hexColor = (0, $8HAlz.rgbToHex)(value);
                else if (value[0] === '#') hexColor = value.toLowerCase();
                // else handle other colour formats
                return hexColor && $a025fc2c63d700a1$export$569885e57444f84a.has(hexColor) ? {
                    color: hexColor
                } : false;
            }
        },
        // This rule ensures when loading from a renderer or editor where the
        // presented text color does not match the stored hex color -- that the
        // text color is preserved.
        //
        // This was initially introduced to ensure text-color marks were not lost
        // when text-color was used inside a link, and is now also used to support
        // where the hex color stored in ADF is used as an ID for a design system
        // token (and based on theme mode -- the presented color will change).
        {
            tag: '.fabric-text-color-mark',
            getAttrs: function getAttrs(maybeElement) {
                if (!(maybeElement instanceof HTMLElement)) return false;
                var hexColor = maybeElement.dataset.textCustomColor;
                return hexColor && $a025fc2c63d700a1$export$569885e57444f84a.has(hexColor) ? {
                    color: hexColor
                } : false;
            }
        }
    ],
    toDOM: function toDOM(mark) {
        var paletteColorValue;
        // Note -- while there is no way to create custom colors using default tooling
        // the editor does supported ad hoc color values -- and there may be content
        // which has been migrated or created via apis which use such values.
        /**
     * The Editor persists custom text colors when content has been migrated from the old editor, or created via
     * apis.
     *
     * This behaviour predates the introduction of dark mode.
     *
     * Without the inversion logic below, text with custom colors, can be hard to read when the user loads the page in dark mode.
     *
     * This introduces inversion of the presentation of the custom text colors when the user is in dark mode.
     *
     * This can be done without additional changes to account for users copying and pasting content inside the Editor, because of
     * how we detect text colors copied from external editor sources. Where we load the background color from a
     * seperate attribute (data-text-custom-color), instead of the inline style.
     *
     * See the following document for more details on this behaviour
     * https://hello.atlassian.net/wiki/spaces/CCECO/pages/2908658046/Unsupported+custom+text+colors+in+dark+theme+Editor+Job+Story
     */ var tokenColor = (0, $4KSDi.hexToEditorTextPaletteColor)(mark.attrs.color);
        if (tokenColor) paletteColorValue = tokenColor;
        else if ($a025fc2c63d700a1$export$813ecdf77207a053().colorMode === 'dark') // if we have a custom color, we need to check if we are in dark mode
        paletteColorValue = (0, $dGnui.getDarkModeLCHColor)(mark.attrs.color);
        else // if we are in light mode, we can just set the color
        paletteColorValue = mark.attrs.color;
        return [
            'span',
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({
                class: 'fabric-text-color-mark',
                // Editor common has a common style which uses this css variable as the value for
                // the color property using the `fabric-text-color-mark` selector applied above.
                style: "--custom-palette-color: ".concat(paletteColorValue)
            }, 'data-text-custom-color', mark.attrs.color)
        ];
    }
});



var $dGnui = parcelRequire("dGnui");
/**
 * @name backgroundColor_mark
 */ var $43c334654e9cdb0e$var$colorArrayPalette = [
    [
        (0, $8HAlz.Neutral300),
        'Gray'
    ],
    // token: color.background.accent.gray.subtler
    [
        (0, $8HAlz.P200),
        'Purple'
    ],
    // token: color.background.accent.purple.subtler
    [
        (0, $8HAlz.M200),
        'Magenta'
    ],
    // token: color.background.accent.magenta.subtler
    [
        (0, $8HAlz.O200),
        'Orange'
    ],
    // token: color.background.accent.orange.subtler
    [
        (0, $8HAlz.Yellow200),
        'Yellow'
    ],
    // token: color.background.accent.yellow.subtler
    [
        (0, $8HAlz.L200),
        'Lime'
    ],
    // token: color.background.accent.lime.subtler
    [
        (0, $8HAlz.T200),
        'Teal'
    ] // token: color.background.accent.teal.subtler
];
var $43c334654e9cdb0e$export$14ec3f21a268e497 = new Map();
$43c334654e9cdb0e$var$colorArrayPalette.forEach(function(_ref) {
    var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_ref, 2), color = _ref2[0], label = _ref2[1];
    return $43c334654e9cdb0e$export$14ec3f21a268e497.set(color.toLowerCase(), label);
});
var $43c334654e9cdb0e$export$8c5a050822fd698c = (0, $idfOp.backgroundColor)({
    parseDOM: [
        {
            style: 'background-color',
            getAttrs: function getAttrs(maybeValue) {
                var value = maybeValue;
                var hexColor;
                // @ts-ignore TS1501: This regular expression flag is only available when targeting 'es6' or later.
                if (value.match(/^rgb/i)) hexColor = (0, $8HAlz.rgbToHex)(value);
                else if (value[0] === '#') hexColor = value.toLowerCase();
                // else handle other colour formats
                return hexColor && $43c334654e9cdb0e$export$14ec3f21a268e497.has(hexColor) ? {
                    color: hexColor
                } : false;
            }
        },
        // This rule ensures when loading from a renderer or editor where the
        // presented text color does not match the stored hex color -- that the
        // text color is preserved.
        //
        // This is used to support the work-around that converts the hex color to
        // a design system token to enable light / dark mode (through a CSS variable --custom-palette-color)
        {
            tag: '.fabric-background-color-mark',
            getAttrs: function getAttrs(maybeElement) {
                if (!(maybeElement instanceof HTMLElement)) return false;
                var hexColor = maybeElement.dataset.backgroundCustomColor;
                return hexColor && $43c334654e9cdb0e$export$14ec3f21a268e497.has(hexColor) ? {
                    color: hexColor
                } : false;
            }
        }
    ],
    toDOM: function toDOM(mark) {
        var paletteColorValue;
        /**
     * Documents can contain custom colors when content has been migrated from the old editor, or created via APIs.
     *
     * This behaviour predates the introduction of dark mode.
     *
     * Without the inversion logic below, text with custom colors, can be hard to read when the user loads the page in dark mode.
     *
     * This introduces inversion of the presentation of the custom text colors when the user is in dark mode.
     *
     * This can be done without additional changes to account for users copying and pasting content inside the Editor, because of
     * how we detect text colors copied from external editor sources. Where we load the background color from a
     * separate attribute (data-text-custom-color), instead of the inline style.
     *
     * See the following document for more details on this behaviour
     * https://hello.atlassian.net/wiki/spaces/CCECO/pages/2908658046/Unsupported+custom+text+colors+in+dark+theme+Editor+Job+Story
     */ var tokenColor = (0, $4KSDi.hexToEditorTextBackgroundPaletteColor)(mark.attrs.color);
        if (tokenColor) paletteColorValue = tokenColor;
        else if ((0, $a025fc2c63d700a1$export$813ecdf77207a053)().colorMode === 'dark') // if we have a custom color, we need to check if we are in dark mode
        paletteColorValue = (0, $dGnui.getDarkModeLCHColor)(mark.attrs.color);
        else // if we are in light mode, we can just set the color
        paletteColorValue = mark.attrs.color;
        return [
            'span',
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({
                class: 'fabric-background-color-mark',
                // Editor common has a common style which uses this css variable as the value for
                // the color property using the `fabric-text-background-color-mark` selector applied above.
                style: "--custom-palette-color: ".concat(paletteColorValue)
            }, 'data-background-custom-color', mark.attrs.color)
        ];
    }
});


var $iYJcE = parcelRequire("iYJcE");

var $idfOp = parcelRequire("idfOp");

var $4KSDi = parcelRequire("4KSDi");

var $8HAlz = parcelRequire("8HAlz");
/**
 * @name border_mark
 * @description This mark adds decoration to an element, and any element decorated with it will also have a border style.
 */ var $9d86e5f2b5e1390e$var$borderColorArrayPalette = [
    [
        (0, $8HAlz.N300A),
        'Subtle gray'
    ],
    [
        (0, $8HAlz.N600),
        'Gray'
    ],
    [
        (0, $8HAlz.N1000),
        'Bold gray'
    ]
];
var $9d86e5f2b5e1390e$export$e4e044c989c86ca7 = new Map();
$9d86e5f2b5e1390e$var$borderColorArrayPalette.forEach(function(_ref) {
    var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_ref, 2), color = _ref2[0], label = _ref2[1];
    return $9d86e5f2b5e1390e$export$e4e044c989c86ca7.set(color.toLowerCase(), label);
});
var $9d86e5f2b5e1390e$export$1edee58a52776cd9 = (0, $idfOp.border)({
    parseDOM: [
        {
            tag: '[data-mark-type="border"]',
            getAttrs: function getAttrs(domNode) {
                var _dom$getAttribute, _dom$getAttribute2;
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                var dom = domNode;
                var color = ((_dom$getAttribute = dom.getAttribute('data-color')) !== null && _dom$getAttribute !== void 0 ? _dom$getAttribute : '').toLowerCase();
                var size = +((_dom$getAttribute2 = dom.getAttribute('data-size')) !== null && _dom$getAttribute2 !== void 0 ? _dom$getAttribute2 : '0');
                return {
                    size: size > 3 ? 3 : size < 1 ? false : size,
                    color: $9d86e5f2b5e1390e$export$e4e044c989c86ca7.has(color) ? color : false
                };
            }
        }
    ],
    toDOM: function toDOM(mark, isInline) {
        var wrapperStyle = isInline ? 'span' : 'div';
        // Note -- while there is no way to create custom colors using default tooling
        // the editor does supported ad hoc color values -- and there may be content
        // which has been migrated or created via apis which use such values.
        var paletteColorValue = (0, $4KSDi.hexToEditorBorderPaletteColor)(mark.attrs.color) || mark.attrs.color;
        return [
            wrapperStyle,
            {
                'data-mark-type': 'border',
                'data-color': mark.attrs.color,
                'data-size': mark.attrs.size,
                style: "--custom-palette-color: ".concat(paletteColorValue)
            }
        ];
    }
});


var $idfOp = parcelRequire("idfOp");
var $19b94a11cb845c30$var$allowedTypes = [
    'wide',
    'full-width'
];
var $19b94a11cb845c30$export$89015c65f1c75e3f = (0, $idfOp.breakout)({
    parseDOM: [
        {
            tag: 'div.fabric-editor-breakout-mark',
            getAttrs: function getAttrs(dom) {
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                var mode = dom.getAttribute('data-mode');
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                var width = dom.getAttribute('data-width');
                return {
                    mode: $19b94a11cb845c30$var$allowedTypes.indexOf(mode || '') === -1 ? 'wide' : mode,
                    width: width ? parseInt(width) : null
                };
            }
        }
    ],
    toDOM: function toDOM(mark) {
        var _mark$attrs;
        return [
            'div',
            {
                class: 'fabric-editor-breakout-mark',
                'data-mode': mark.attrs.mode,
                'data-width': (_mark$attrs = mark.attrs) === null || _mark$attrs === void 0 ? void 0 : _mark$attrs.width
            },
            0
        ];
    }
});


var $idfOp = parcelRequire("idfOp");
var $f6d55d3017234528$export$6565f9f03506010b = (0, $idfOp.code)({
    parseDOM: [
        {
            tag: 'span.code',
            preserveWhitespace: true
        },
        {
            tag: 'code',
            preserveWhitespace: true
        },
        {
            tag: 'tt',
            preserveWhitespace: true
        },
        {
            tag: 'span',
            preserveWhitespace: true,
            getAttrs: function getAttrs(domNode) {
                var dom = domNode;
                if (dom.style.whiteSpace === 'pre') return {};
                if (dom.style.fontFamily && dom.style.fontFamily.toLowerCase().indexOf('monospace') >= 0) return {};
                return false;
            }
        }
    ],
    toDOM: function toDOM() {
        return [
            'span',
            {
                class: 'code',
                spellcheck: 'false'
            }
        ];
    }
});


var $idfOp = parcelRequire("idfOp");
var $9d1d133406e69391$export$f3b72f8fc4684ecd = (0, $idfOp.confluenceInlineComment)({
    parseDOM: [
        {
            tag: 'span[data-mark-type="confluenceInlineComment"]'
        }
    ],
    toDOM: function toDOM(node) {
        return [
            'span',
            {
                'data-mark-type': 'confluenceInlineComment',
                'data-reference': node.attrs.reference
            }
        ];
    }
});


var $25nEq = parcelRequire("25nEq");

var $idfOp = parcelRequire("idfOp");

function $373acd484bebe214$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $373acd484bebe214$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $373acd484bebe214$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $373acd484bebe214$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
/**
 * This annotation is purely for reference, & does _nothing_ given annotating
 * `minLength` on an array of strings is not supported with our schema+spec
 * generator.
 *
 * We're keeping it to signal that data consumer `sources` shouldn't be empty
 * strings
 *
 // eslint-disable-next-line eslint-plugin-jsdoc/check-tag-names
 * // @minLength 1
 */ /**
 * @name dataConsumer_mark
 * @description This mark is used for metadata surrounding a node consuming data
 * from a given source node
 */ var $373acd484bebe214$var$parseDataConsumer = function parseDataConsumer(maybeValue) {
    var sources = (0, $a499da7ad88c6850$export$c296e2d4365c37a5)(maybeValue) && maybeValue.getAttribute('data-sources');
    try {
        return sources ? {
            sources: JSON.parse(sources)
        } : false;
    } catch (_unused) {
        return false;
    }
};
var $373acd484bebe214$export$3024f02c495408d6 = (0, $idfOp.dataConsumer)({
    parseDOM: [
        {
            tag: '[data-mark-type="dataConsumer"]',
            getAttrs: function getAttrs(maybeValue) {
                return $373acd484bebe214$var$parseDataConsumer(maybeValue);
            }
        }
    ],
    toDOM: function toDOM(mark, inline) {
        var wrapperStyle = inline ? 'span' : 'div';
        return [
            wrapperStyle,
            {
                'data-mark-type': 'dataConsumer',
                'data-sources': JSON.stringify(mark.attrs.sources)
            }
        ];
    }
});
var $373acd484bebe214$export$54fd2c36b5cc6731 = function toJSON(mark) {
    // // Remove intemediary state if we don't have any sources on data consumer
    // if (mark.attrs?.sources?.length < 1) {
    //   return null;
    // }
    return {
        type: mark.type.name,
        attrs: Object.keys(mark.attrs).filter(function(key) {
            return key === 'sources' && mark.attrs[key].length > 0 && mark.attrs[key] !== null;
        }).reduce(function(acc, key) {
            return $373acd484bebe214$var$_objectSpread($373acd484bebe214$var$_objectSpread({}, acc), {}, (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, key, mark.attrs[key]));
        }, {})
    };
};


var $idfOp = parcelRequire("idfOp");
/**
 * @name em_mark
 */ var $40036effaaf803e9$var$emDOM = [
    'em'
];
var $40036effaaf803e9$export$c63c6f932822f543 = (0, $idfOp.em)({
    parseDOM: [
        {
            tag: 'i'
        },
        {
            tag: 'em'
        },
        {
            style: 'font-style=italic'
        }
    ],
    toDOM: function toDOM() {
        return $40036effaaf803e9$var$emDOM;
    }
});


var $idfOp = parcelRequire("idfOp");
var $75d0c35cdf3c5641$var$allowedSizes = [
    'small'
];
var $75d0c35cdf3c5641$export$85e3c3ca0c6fb93 = (0, $idfOp.fontSize)({
    parseDOM: [
        {
            tag: 'div.fabric-editor-font-size',
            getAttrs: function getAttrs(dom) {
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                var fontSize = dom.getAttribute('data-font-size');
                return {
                    fontSize: $75d0c35cdf3c5641$var$allowedSizes.indexOf(fontSize || '') === -1 ? 'small' : fontSize
                };
            }
        }
    ],
    toDOM: function toDOM(mark) {
        return [
            'div',
            {
                class: 'fabric-editor-block-mark fabric-editor-font-size',
                'data-font-size': mark.attrs.fontSize
            },
            0
        ];
    }
});


var $25nEq = parcelRequire("25nEq");

var $idfOp = parcelRequire("idfOp");

function $8695fda815504e46$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $8695fda815504e46$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $8695fda815504e46$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $8695fda815504e46$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
/**
 * @name fragment_mark
 * @description Indicates that the elements decorated with this mark belong to a "fragment" entity, which represents a collection of ADF nodes.
 * This entity can be referred to later by its `localId` attribute.
 */ var $8695fda815504e46$var$parseFragment = function parseFragment(maybeValue) {
    var _maybeValue$getAttrib;
    if (!(0, $a499da7ad88c6850$export$c296e2d4365c37a5)(maybeValue)) return false;
    var name = (_maybeValue$getAttrib = maybeValue.getAttribute('data-name')) !== null && _maybeValue$getAttrib !== void 0 ? _maybeValue$getAttrib : undefined;
    var localId = maybeValue.getAttribute('data-localId');
    if (!localId) return false;
    return {
        localId: localId,
        name: name
    };
};
var $8695fda815504e46$export$f00aeb236b6f05af = (0, $idfOp.fragment)({
    parseDOM: [
        {
            tag: '[data-mark-type="fragment"]',
            getAttrs: function getAttrs(maybeValue) {
                return $8695fda815504e46$var$parseFragment(maybeValue);
            }
        }
    ],
    toDOM: function toDOM(mark, inline) {
        var wrapperStyle = inline ? 'span' : 'div';
        return [
            wrapperStyle,
            {
                'data-mark-type': 'fragment',
                'data-name': mark.attrs.name,
                'data-localId': mark.attrs.localId
            }
        ];
    }
});
var $8695fda815504e46$export$54fd2c36b5cc6731 = function toJSON(mark) {
    return {
        type: mark.type.name,
        attrs: $8695fda815504e46$var$_objectSpread({
            localId: mark.attrs.localId
        }, mark.attrs.name ? {
            name: mark.attrs.name
        } : {})
    };
};


var $idfOp = parcelRequire("idfOp");
var $381b106cee5226c2$export$480c699bd4ec0d86 = (0, $idfOp.indentation)({
    parseDOM: [
        {
            tag: 'div.fabric-editor-indentation-mark',
            getAttrs: function getAttrs(dom) {
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                var level = +(dom.getAttribute('data-level') || '0');
                return {
                    level: level > 6 ? 6 : level < 1 ? false : level
                };
            }
        }
    ],
    toDOM: function toDOM(mark) {
        return [
            'div',
            {
                class: 'fabric-editor-block-mark fabric-editor-indentation-mark',
                'data-level': mark.attrs.level
            },
            0
        ];
    }
});


var $25nEq = parcelRequire("25nEq");

var $idfOp = parcelRequire("idfOp");

function $6b42229a267c3c21$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $6b42229a267c3c21$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $6b42229a267c3c21$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $6b42229a267c3c21$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $6b42229a267c3c21$export$b5f67017585d1431 = function getLinkAttrs(attribute) {
    return function(domNode) {
        var dom = domNode;
        var href = dom.getAttribute(attribute) || '';
        var attrs = {
            __confluenceMetadata: dom.hasAttribute('__confluenceMetadata') ? JSON.parse(dom.getAttribute('__confluenceMetadata') || '') : undefined
        };
        if (!(0, $108e5e5f673311da$export$c9f92f5469372e0f)(href)) return false;
        if ((0, $108e5e5f673311da$export$23579274a7a24f7b)(href)) {
            attrs.href = href;
            return attrs;
        }
        attrs.href = (0, $108e5e5f673311da$export$6535eb414fa2c8b6)(href);
        return attrs;
    };
};
var $6b42229a267c3c21$export$9c30223ca0a664fb = (0, $idfOp.link)({
    parseDOM: [
        {
            tag: '[data-block-link]',
            getAttrs: $6b42229a267c3c21$export$b5f67017585d1431('data-block-link'),
            contentElement: function contentElement(node) {
                var clone = node.cloneNode(true);
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                clone.removeAttribute('data-block-link');
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                clone.setAttribute('data-skip-paste', 'true');
                var wrapper = document.createElement('div');
                wrapper.appendChild(clone);
                return wrapper;
            }
        },
        {
            tag: 'a[href]',
            getAttrs: $6b42229a267c3c21$export$b5f67017585d1431('href')
        }
    ],
    toDOM: function toDOM(node, isInline) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        var attrs = Object.keys(node.attrs).reduce(function(attrs, key) {
            if (key === '__confluenceMetadata') {
                if (node.attrs[key] !== null) attrs[key] = JSON.stringify(node.attrs[key]);
            } else if (key === 'href') attrs[key] = (0, $108e5e5f673311da$export$c9f92f5469372e0f)(node.attrs[key]) ? node.attrs[key] : undefined;
            else // @ts-ignore
            attrs[key] = node.attrs[key];
            return attrs;
        }, {});
        if (isInline) return [
            'a',
            attrs
        ];
        return [
            'a',
            $6b42229a267c3c21$var$_objectSpread($6b42229a267c3c21$var$_objectSpread({}, attrs), {}, (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, 'data-block-link', 'true'), "class", 'blockLink')),
            0
        ];
    }
});
var $6b42229a267c3c21$var$OPTIONAL_ATTRS = [
    'title',
    'id',
    'collection',
    'occurrenceKey',
    '__confluenceMetadata'
];
var $6b42229a267c3c21$export$54fd2c36b5cc6731 = function toJSON(mark) {
    return {
        type: mark.type.name,
        attrs: Object.keys(mark.attrs).reduce(function(attrs, key) {
            if ($6b42229a267c3c21$var$OPTIONAL_ATTRS.indexOf(key) === -1 || mark.attrs[key] !== null) attrs[key] = mark.attrs[key];
            return attrs;
        }, {})
    };
};


var $idfOp = parcelRequire("idfOp");
var $1dbd45bd36e32cdf$export$4899a95d70ec5056 = (0, $idfOp.strike)({
    parseDOM: [
        {
            tag: 'strike'
        },
        {
            tag: 's'
        },
        {
            tag: 'del'
        },
        {
            style: 'text-decoration',
            getAttrs: function getAttrs(value) {
                return value === 'line-through' && null;
            }
        }
    ],
    toDOM: function toDOM() {
        return [
            's'
        ];
    }
});


var $idfOp = parcelRequire("idfOp");
/**
 * @name strong_mark
 */ var $8e6e032454bb22a0$var$strongDOM = [
    'strong'
];
var $8e6e032454bb22a0$export$59ae2c325a998f89 = (0, $idfOp.strong)({
    parseDOM: [
        {
            tag: 'strong'
        },
        // This works around a Google Docs misbehavior where
        // pasted content will be inexplicably wrapped in `<b>`
        // tags with a font-weight normal.
        {
            tag: 'b',
            getAttrs: function getAttrs(node) {
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                var element = node;
                return element.style.fontWeight !== 'normal' && null;
            }
        },
        {
            tag: 'span',
            getAttrs: function getAttrs(node) {
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                var element = node;
                var fontWeight = element.style.fontWeight;
                return typeof fontWeight === 'string' && (fontWeight === 'bold' || fontWeight === 'bolder' || // @ts-ignore TS1501: This regular expression flag is only available when targeting 'es6' or later.
                /^(bold(er)?|[5-9][0-9]{2,})$/.test(fontWeight)) && null;
            }
        }
    ],
    toDOM: function toDOM() {
        return $8e6e032454bb22a0$var$strongDOM;
    }
});


var $idfOp = parcelRequire("idfOp");
/**
 * @name subsup_mark
 */ function $8ebab425d760f0ae$var$getAttrFromVerticalAlign(node) {
    if (node === 'sub') return {
        type: 'sub'
    };
    if (node === 'super') return {
        type: 'sup'
    };
    return false;
}
var $8ebab425d760f0ae$export$b3401ee80eb31041 = (0, $idfOp.subsup)({
    parseDOM: [
        {
            tag: 'sub',
            attrs: {
                type: 'sub'
            }
        },
        {
            tag: 'sup',
            attrs: {
                type: 'sup'
            }
        },
        {
            // Special case for pasting from Google Docs
            // Google Docs uses vertical align to denote subscript and super script
            style: 'vertical-align=super',
            getAttrs: function getAttrs(node) {
                return $8ebab425d760f0ae$var$getAttrFromVerticalAlign(node);
            }
        },
        {
            style: 'vertical-align=sub',
            getAttrs: function getAttrs(node) {
                return $8ebab425d760f0ae$var$getAttrFromVerticalAlign(node);
            }
        }
    ],
    toDOM: function toDOM(mark) {
        return [
            mark.attrs.type
        ];
    }
});


var $idfOp = parcelRequire("idfOp");

var $8HAlz = parcelRequire("8HAlz");
var $fcb95875713c0e12$export$20af3dabbb5538df = (0, $idfOp.typeAheadQuery)({
    parseDOM: [
        {
            tag: 'span[data-type-ahead-query]'
        }
    ],
    toDOM: function toDOM(node) {
        return [
            'span',
            {
                'data-type-ahead-query': 'true',
                'data-trigger': node.attrs.trigger,
                style: "color: ".concat((0, $8HAlz.B400))
            }
        ];
    }
});


var $idfOp = parcelRequire("idfOp");
var $898cfee0199366cd$export$425327af25286e5e = (0, $idfOp.underline)({
    parseDOM: [
        {
            tag: 'u'
        },
        {
            style: 'text-decoration',
            getAttrs: function getAttrs(value) {
                return value === 'underline' && null;
            }
        }
    ],
    toDOM: function toDOM() {
        return [
            'u'
        ];
    }
});


var $idfOp = parcelRequire("idfOp");
var $001713b564db32e2$export$30d78d5eb6719bb8 = (0, $idfOp.unsupportedMark)({
    toDOM: function toDOM() {
        return [
            'span'
        ];
    }
});


var $idfOp = parcelRequire("idfOp");
var $ac117d25f445ca23$export$a316dc07ff5182a2 = (0, $idfOp.unsupportedNodeAttribute)({
    toDOM: function toDOM() {
        return [
            'span'
        ];
    }
});



var $jRLnM = parcelRequire("jRLnM");
var $4iuZ2 = parcelRequire("4iuZ2");
function $ec3ce640b08fa443$var$addItems(builtInItems, config) {
    var customSpecs = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    if (!config) return {};
    /**
   * Add built-in Node / Mark specs
   */ var items = builtInItems.reduce(function(items, _ref) {
        var name = _ref.name, spec = _ref.spec;
        if (config.indexOf(name) !== -1) items[name] = customSpecs[name] || spec;
        return items;
    }, {});
    /**
   * Add Custom Node / Mark specs
   */ return Object.keys(customSpecs).reduce(function(items, name) {
        if (items[name]) return items;
        items[name] = customSpecs[name];
        return items;
    }, items);
}
// We use groups to allow schemas to be constructed in different shapes without changing node/mark
// specs, but this means nodes/marks are defined with groups that might never be used in the schema.
// In this scenario ProseMirror will complain and prevent the schema from being constructed.
//
// To avoid the problem, we include items that serve to "declare" the groups in the schema. This
// approach unfortunately leaves unused items in the schema, but has the benefit of avoiding the
// need to manipulate `exclude` or content expression values for potentially every schema item.
function $ec3ce640b08fa443$var$groupDeclaration(name) {
    return {
        name: "__".concat(name, "GroupDeclaration"),
        spec: {
            group: name
        }
    };
}
var $ec3ce640b08fa443$var$markGroupDeclarations = [
    $ec3ce640b08fa443$var$groupDeclaration((0, $e4b22187f59641f2$export$9b982809044276a6)),
    $ec3ce640b08fa443$var$groupDeclaration((0, $e4b22187f59641f2$export$4498a6080fed604c)),
    $ec3ce640b08fa443$var$groupDeclaration((0, $e4b22187f59641f2$export$f8e8a5f34f6ea725)),
    $ec3ce640b08fa443$var$groupDeclaration((0, $e4b22187f59641f2$export$b395009ca7f092c7))
];
var $ec3ce640b08fa443$var$markGroupDeclarationsNames = $ec3ce640b08fa443$var$markGroupDeclarations.map(function(groupMark) {
    return groupMark.name;
});
var $ec3ce640b08fa443$var$nodesInOrder = [
    {
        name: 'doc',
        spec: (0, $3189a38ae2d8190d$export$2a111da947c407d2)
    },
    {
        name: 'paragraph',
        spec: (0, $c86326eb6bb37777$export$9c206ddddb32a9b)
    },
    {
        name: 'text',
        spec: (0, $0843b8206c94d9c8$export$6f093cfa640b7166)
    },
    {
        name: 'bulletList',
        spec: (0, $68aa38673a09f75f$export$a140c94e5ea26bee)
    },
    {
        name: 'orderedList',
        spec: (0, $b9468ae6afc572a5$export$b9ab759e8298198f)
    },
    {
        name: 'listItem',
        spec: (0, $cd973dd5f5481b0f$export$76c7e83ecc9cdf05)
    },
    {
        name: 'heading',
        spec: (0, $2c737b0f1b7d6028$export$46e4a324ac90507f)
    },
    {
        name: 'blockquote',
        spec: (0, $de125a506c44dde8$export$70a64939da3e8455)
    },
    {
        name: 'codeBlock',
        spec: (0, $f03078759126255d$export$7bb0d5c671655cc4)
    },
    {
        name: 'panel',
        spec: (0, $jRLnM.extendedPanel)(true)
    },
    {
        name: 'rule',
        spec: (0, $d9ae5ab08c734466$export$fbeb3a3956e8a3c7)
    },
    {
        name: 'image',
        spec: (0, $a57c320c6d513196$export$5c452ff88e35e47d)
    },
    {
        name: 'mention',
        spec: (0, $bcfbfcab2297a3f6$export$db83999c14438df4)
    },
    {
        name: 'caption',
        spec: (0, $06b7e02ee990af9a$export$8e3c2dfdc4f0453d)
    },
    {
        name: 'media',
        spec: (0, $aacb6205dbe8d16e$export$987d49ffe1b0900f)
    },
    {
        name: 'mediaGroup',
        spec: (0, $cc684338e25ee07f$export$2855e964765eac9)
    },
    {
        name: 'mediaSingle',
        spec: (0, $ea198752dd60970b$export$7e767666f2ce108a)
    },
    {
        name: 'mediaInline',
        spec: (0, $e66d54db0e5b1698$export$38bab695e3f720f1)
    },
    {
        name: 'placeholder',
        spec: (0, $22fba87185ef0411$export$c7187bbd1a7a9244)
    },
    {
        name: 'layoutSection',
        spec: (0, $1f387ae27d37c85e$export$b3b6a70a7fa4a5be)
    },
    {
        name: 'layoutColumn',
        spec: (0, $4926a20aff33a51e$export$ab76e7c03cd6f650)
    },
    {
        name: 'hardBreak',
        spec: (0, $0914d755479e1221$export$371da9dd35aba193)
    },
    {
        name: 'emoji',
        spec: (0, $3b9771668d47d1fd$export$a19185d1233fc4b2)
    },
    {
        name: 'table',
        spec: (0, $4iuZ2.table)
    },
    {
        name: 'tableCell',
        spec: (0, $4iuZ2.tableCell)
    },
    {
        name: 'tableRow',
        spec: (0, $4iuZ2.tableRow)
    },
    {
        name: 'tableHeader',
        spec: (0, $4iuZ2.tableHeader)
    },
    {
        name: 'confluenceJiraIssue',
        spec: (0, $e9fb2e043a62b7b0$export$daf889beb5092f95)
    },
    {
        name: 'confluenceUnsupportedInline',
        spec: (0, $34f612c5109d80d1$export$3e6d667072febc87)
    },
    {
        name: 'confluenceUnsupportedBlock',
        spec: (0, $25b61cd4e4df05e7$export$e6e4878f43c27cab)
    },
    {
        name: 'decisionList',
        spec: (0, $964797ab5bfd59fb$export$62d45a65fb43d95e)
    },
    {
        name: 'decisionItem',
        spec: (0, $6f5a7a342445f237$export$6959e16eeff859b4)
    },
    {
        name: 'taskList',
        spec: (0, $b2e5441fe7d9a137$export$375b6afcc5f4d291)
    },
    {
        name: 'taskItem',
        spec: (0, $cbf37c1c4b8d5d30$export$6d8b0ef52e2e6390)
    },
    {
        name: 'blockTaskItem',
        spec: (0, $cbf37c1c4b8d5d30$export$16018c61064a18df)
    },
    {
        name: 'date',
        spec: (0, $1d8f0dac087417d1$export$324d90190a8b822a)
    },
    {
        name: 'status',
        spec: (0, $6972390ebb9bd4b0$export$471f7ae5c4103ae1)
    },
    {
        name: 'expand',
        spec: (0, $9cd5a5cff2a9157b$export$7b80cba28d10b2c1)
    },
    {
        name: 'nestedExpand',
        spec: (0, $e1accce4e805401f$export$63cadbf5f4296627)
    },
    {
        name: 'extension',
        spec: (0, $559b2b6e22802307$export$1b45514b112dd749)
    },
    {
        name: 'inlineExtension',
        spec: (0, $bb20a9c871fceff5$export$16b353b2649bd8d9)
    },
    {
        name: 'bodiedExtension',
        spec: (0, $8650cd3ae99343ef$export$27903d543b563e39)
    },
    {
        name: 'multiBodiedExtension',
        spec: (0, $78a12cccd6b79e5f$export$c3c04d555a8b9013)
    },
    {
        name: 'extensionFrame',
        spec: (0, $78a12cccd6b79e5f$export$4fdcae991fd743e7)
    },
    {
        name: 'inlineCard',
        spec: (0, $3a1f01737c54306b$export$cbf8224b64e0d942)
    },
    {
        name: 'blockCard',
        spec: (0, $1523cff2135842ff$export$c4c2f833baaebdb8)
    },
    {
        name: 'embedCard',
        spec: (0, $bc4f37863f21d42d$export$be4283d9a1cb1ff6)
    },
    {
        name: 'syncBlock',
        spec: (0, $3614b7dcde529e3d$export$faab0ca9701d7048)
    },
    {
        name: 'bodiedSyncBlock',
        spec: (0, $1c7b3187728193dc$export$e92c7e4302dd4371)
    },
    {
        name: 'unknownBlock',
        spec: (0, $e7d33089ad270e58$export$2e2bcd8739ae039)
    },
    {
        name: 'unsupportedBlock',
        spec: (0, $6f6274e72602d062$export$44b79b0979d0f0f7)
    },
    {
        name: 'unsupportedInline',
        spec: (0, $7baec23ccb628f19$export$310ebe0d80122e9b)
    }
];
var $ec3ce640b08fa443$var$marksInOrder = [
    {
        name: 'link',
        spec: (0, $6b42229a267c3c21$export$9c30223ca0a664fb)
    },
    {
        name: 'em',
        spec: (0, $40036effaaf803e9$export$c63c6f932822f543)
    },
    {
        name: 'strong',
        spec: (0, $8e6e032454bb22a0$export$59ae2c325a998f89)
    },
    {
        name: 'textColor',
        spec: (0, $a025fc2c63d700a1$export$32f78bffcd82ff28)
    },
    {
        name: 'backgroundColor',
        spec: (0, $43c334654e9cdb0e$export$8c5a050822fd698c)
    },
    {
        name: 'strike',
        spec: (0, $1dbd45bd36e32cdf$export$4899a95d70ec5056)
    },
    {
        name: 'subsup',
        spec: (0, $8ebab425d760f0ae$export$b3401ee80eb31041)
    },
    {
        name: 'underline',
        spec: (0, $898cfee0199366cd$export$425327af25286e5e)
    },
    {
        name: 'code',
        spec: (0, $f6d55d3017234528$export$6565f9f03506010b)
    },
    {
        name: 'typeAheadQuery',
        spec: (0, $fcb95875713c0e12$export$20af3dabbb5538df)
    },
    {
        name: 'alignment',
        spec: (0, $1bd16a105180511f$export$8e53000a4ec837)
    },
    {
        name: 'annotation',
        spec: (0, $jJtX0.annotation)
    },
    {
        name: 'confluenceInlineComment',
        spec: (0, $9d1d133406e69391$export$f3b72f8fc4684ecd)
    }
].concat($ec3ce640b08fa443$var$markGroupDeclarations, [
    {
        name: 'fontSize',
        spec: (0, $75d0c35cdf3c5641$export$85e3c3ca0c6fb93)
    },
    {
        name: 'breakout',
        spec: (0, $19b94a11cb845c30$export$89015c65f1c75e3f)
    },
    {
        name: 'dataConsumer',
        spec: (0, $373acd484bebe214$export$3024f02c495408d6)
    },
    {
        name: 'fragment',
        spec: (0, $8695fda815504e46$export$f00aeb236b6f05af)
    },
    {
        name: 'indentation',
        spec: (0, $381b106cee5226c2$export$480c699bd4ec0d86)
    },
    {
        name: 'border',
        spec: (0, $9d86e5f2b5e1390e$export$1edee58a52776cd9)
    },
    {
        name: 'unsupportedMark',
        spec: (0, $001713b564db32e2$export$30d78d5eb6719bb8)
    },
    {
        name: 'unsupportedNodeAttribute',
        spec: (0, $ac117d25f445ca23$export$a316dc07ff5182a2)
    }
]);
function $ec3ce640b08fa443$export$2d0c32a809131488() {
    var nodes = $ec3ce640b08fa443$var$nodesInOrder.reduce(function(acc, _ref2) {
        var name = _ref2.name, spec = _ref2.spec;
        acc[name] = spec;
        return acc;
    }, {});
    var marks = $ec3ce640b08fa443$var$marksInOrder.reduce(function(acc, _ref3) {
        var name = _ref3.name, spec = _ref3.spec;
        acc[name] = spec;
        return acc;
    }, {});
    return {
        nodes: nodes,
        marks: marks
    };
}
function $ec3ce640b08fa443$export$5f4ce795563f4211(config) {
    var customNodeSpecs = config.customNodeSpecs, customMarkSpecs = config.customMarkSpecs;
    var nodesConfig = Object.keys(customNodeSpecs || {}).concat(config.nodes);
    var marksConfig = Object.keys(customMarkSpecs || {}).concat(config.marks || []).concat($ec3ce640b08fa443$var$markGroupDeclarationsNames);
    var nodes = $ec3ce640b08fa443$var$addItems($ec3ce640b08fa443$var$nodesInOrder, nodesConfig, customNodeSpecs);
    var marks = $ec3ce640b08fa443$var$addItems($ec3ce640b08fa443$var$marksInOrder, marksConfig, customMarkSpecs);
    nodes = (0, $5d37263b6ee57b2c$export$daf54fed04c8fb77)(nodes, marks);
    return new (0, $9Jwkl.Schema)({
        nodes: nodes,
        marks: marks
    });
}
var $ec3ce640b08fa443$export$c77b6d30da5276a1 = true;



var $2b350d2d3b0fda69$var$getDefaultSchemaConfig = function getDefaultSchemaConfig() {
    var defaultSchemaConfig = {
        nodes: [
            'doc',
            'paragraph',
            'text',
            'bulletList',
            'orderedList',
            'listItem',
            'heading',
            'blockquote',
            'codeBlock',
            'panel',
            'rule',
            'image',
            'caption',
            'mention',
            'media',
            'mediaGroup',
            'mediaSingle',
            'mediaInline',
            'confluenceUnsupportedBlock',
            'confluenceUnsupportedInline',
            'confluenceJiraIssue',
            'expand',
            'nestedExpand',
            'extension',
            'inlineExtension',
            'bodiedExtension',
            'hardBreak',
            'emoji',
            'table',
            'tableCell',
            'tableHeader',
            'tableRow',
            'decisionList',
            'decisionItem',
            'taskList',
            'taskItem',
            'blockTaskItem',
            'unknownBlock',
            'date',
            'status',
            'placeholder',
            'layoutSection',
            'layoutColumn',
            'inlineCard',
            'blockCard',
            'embedCard',
            'syncBlock',
            'bodiedSyncBlock',
            'unsupportedBlock',
            'unsupportedInline'
        ],
        marks: [
            'link',
            'em',
            'strong',
            'strike',
            'subsup',
            'underline',
            'code',
            'textColor',
            'backgroundColor',
            'confluenceInlineComment',
            'breakout',
            'alignment',
            'indentation',
            'annotation',
            'dataConsumer',
            'border',
            'unsupportedMark',
            'unsupportedNodeAttribute',
            'typeAheadQuery',
            // https://product-fabric.atlassian.net/browse/ED-10214,
            'fragment'
        ]
    };
    return defaultSchemaConfig;
};
var $2b350d2d3b0fda69$export$e4e3ac1fa64862db = $2b350d2d3b0fda69$var$getDefaultSchemaConfig();
var $2b350d2d3b0fda69$export$fd147e7d448dea03 = (0, $cvlyC.default)(// eslint-disable-next-line @typescript-eslint/no-explicit-any
function() {
    var stage = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'final';
    var defaultSchemaConfig = $2b350d2d3b0fda69$var$getDefaultSchemaConfig();
    if (stage === 'stage0') {
        defaultSchemaConfig.customNodeSpecs = {
            layoutSection: (0, $1f387ae27d37c85e$export$4f9d8f623ff17117),
            multiBodiedExtension: (0, $78a12cccd6b79e5f$export$c3c04d555a8b9013),
            extensionFrame: (0, $78a12cccd6b79e5f$export$4fdcae991fd743e7),
            expand: (0, $9cd5a5cff2a9157b$export$7b80cba28d10b2c1),
            listItem: (0, $cd973dd5f5481b0f$export$fcbecfed570fc881),
            taskList: (0, $b2e5441fe7d9a137$export$3c86306d85ad1f18),
            table: (0, $4iuZ2.tableWithNestedTable),
            tableRow: (0, $4iuZ2.tableRowWithNestedTable),
            tableCell: (0, $4iuZ2.tableCellWithNestedTable),
            tableHeader: (0, $4iuZ2.tableHeaderWithNestedTable)
        };
        defaultSchemaConfig.customMarkSpecs = {
            fontSize: (0, $75d0c35cdf3c5641$export$85e3c3ca0c6fb93)
        };
    }
    return (0, $ec3ce640b08fa443$export$5f4ce795563f4211)(defaultSchemaConfig);
});
var $2b350d2d3b0fda69$export$1db618b7b2275ea1 = $2b350d2d3b0fda69$export$fd147e7d448dea03();



var $9Zzpd = parcelRequire("9Zzpd");

var $iVSxl = parcelRequire("iVSxl");
function $5558251c256ad6af$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $5558251c256ad6af$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $5558251c256ad6af$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $5558251c256ad6af$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $5558251c256ad6af$export$3b94ef2190b2d585 = {
    FINAL: 'final',
    STAGE_0: 'stage0'
};
var $5558251c256ad6af$export$62d5811a2955c1d8 = [
    'fragment',
    'link',
    'em',
    'strong',
    'textColor',
    'backgroundColor',
    'strike',
    'subsup',
    'underline',
    'code',
    'confluenceInlineComment',
    'annotation',
    'dataConsumer'
];
var $5558251c256ad6af$export$30f8aa4cc1f8c1cb = function isSubSupType(type) {
    return type === 'sub' || type === 'sup';
};
var $5558251c256ad6af$export$99a33ed044c278ae = function getMarksByOrder(marks) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(marks).sort(function(a, b) {
        return $5558251c256ad6af$export$62d5811a2955c1d8.indexOf(a.type.name) - $5558251c256ad6af$export$62d5811a2955c1d8.indexOf(b.type.name);
    });
};
var $5558251c256ad6af$export$b1304404bdc42b7a = function isSameMark(mark, otherMark) {
    if (!mark || !otherMark) return false;
    return mark.eq(otherMark);
};
var $5558251c256ad6af$export$fb80336a7e408cb3 = function getValidDocument(doc) {
    var schema = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (0, $2b350d2d3b0fda69$export$1db618b7b2275ea1);
    var adfStage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'final';
    var node = $5558251c256ad6af$export$81b20b6c83a56bd(doc, schema, adfStage);
    if (node.type === 'doc') {
        node.content = $5558251c256ad6af$var$wrapInlineNodes(node.content);
        return node;
    }
    return null;
};
var $5558251c256ad6af$var$wrapInlineNodes = function wrapInlineNodes() {
    var nodes = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    return nodes.map(function(node) {
        return (0, $24bf16fa17640746$export$b1f729c6af6f2a6e).has(node.type) ? {
            type: 'paragraph',
            content: [
                node
            ]
        } : node;
    });
};
var $5558251c256ad6af$export$fafd4f799ee68da0 = function getValidContent(content) {
    var schema = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (0, $2b350d2d3b0fda69$export$1db618b7b2275ea1);
    var adfStage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'final';
    return content.map(function(node) {
        return $5558251c256ad6af$export$81b20b6c83a56bd(node, schema, adfStage);
    });
};
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
var $5558251c256ad6af$var$TEXT_COLOR_PATTERN = /^#[0-9a-fA-F]{6}$/;
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
var $5558251c256ad6af$var$RELATIVE_LINK = /^\//;
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
var $5558251c256ad6af$var$ANCHOR_LINK = /^#/;
var $5558251c256ad6af$var$_flattenUnknownBlockTree = function flattenUnknownBlockTree(node) {
    var schema = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (0, $2b350d2d3b0fda69$export$1db618b7b2275ea1);
    var adfStage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'final';
    var output = [];
    var isPrevLeafNode = false;
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    for(var i = 0; i < node.content.length; i++){
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        var childNode = node.content[i];
        var isLeafNode = !(childNode.content && childNode.content.length);
        if (i > 0) {
            if (isPrevLeafNode) output.push({
                type: 'text',
                text: ' '
            });
            else output.push({
                type: 'hardBreak'
            });
        }
        if (isLeafNode) output.push($5558251c256ad6af$export$81b20b6c83a56bd(childNode, schema, adfStage));
        else output.push.apply(output, (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))($5558251c256ad6af$var$_flattenUnknownBlockTree(childNode, schema, adfStage)));
        isPrevLeafNode = isLeafNode;
    }
    return output;
};
var $5558251c256ad6af$export$b9908ef75cad1e0e = function getValidUnknownNode(node) {
    var _node$attrs = node.attrs, attrs = _node$attrs === void 0 ? {} : _node$attrs, content = node.content, text = node.text, type = node.type;
    if (!content || !content.length) {
        var unknownInlineNode = {
            type: 'text',
            text: text || attrs.text || "[".concat(type, "]")
        };
        var textUrl = attrs.textUrl;
        if (textUrl && (0, $108e5e5f673311da$export$c9f92f5469372e0f)(textUrl)) unknownInlineNode.marks = [
            {
                type: 'link',
                attrs: {
                    href: textUrl
                }
            }
        ];
        return unknownInlineNode;
    }
    /*
   * Find leaf nodes and join them. If leaf nodes' parent node is the same node
   * join with a blank space, otherwise they are children of different branches, i.e.
   * we need to join them with a hardBreak node
   */ return {
        type: 'unknownBlock',
        content: $5558251c256ad6af$var$_flattenUnknownBlockTree(node)
    };
};
var $5558251c256ad6af$var$getValidMarks = function getValidMarks(marks) {
    var adfStage = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'final';
    if (marks && marks.length > 0) return marks.reduce(function(acc, mark) {
        var validMark = $5558251c256ad6af$export$87c6d4a6ebb7d9e9(mark, adfStage);
        if (validMark) acc.push(validMark);
        return acc;
    }, []);
    return marks;
};
var $5558251c256ad6af$export$81b20b6c83a56bd = function getValidNode(originalNode) {
    var schema = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (0, $2b350d2d3b0fda69$export$1db618b7b2275ea1);
    var adfStage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'final';
    var attrs = originalNode.attrs, marks = originalNode.marks, text = originalNode.text, type = originalNode.type;
    var content = originalNode.content;
    var node = {
        attrs: attrs,
        marks: marks,
        text: text,
        type: type
    };
    if (content) node.content = content = $5558251c256ad6af$export$fafd4f799ee68da0(content, schema, adfStage);
    // If node type doesn't exist in schema, make it an unknown node
    if (!schema.nodes[type]) return $5558251c256ad6af$export$b9908ef75cad1e0e(node);
    if (type) switch(type){
        case 'doc':
            var _ref = originalNode, version = _ref.version;
            if (version && content && content.length) return {
                type: type,
                content: content
            };
            break;
        case 'codeBlock':
            if (content) content = content.reduce(function(acc, val) {
                if (val.type === 'text') acc.push({
                    type: val.type,
                    text: val.text
                });
                return acc;
            }, []);
            if (attrs && attrs.language) return {
                type: type,
                attrs: attrs,
                content: content,
                marks: marks
            };
            return {
                type: type,
                content: content,
                marks: marks
            };
        case 'date':
            if (attrs && attrs.timestamp) return $5558251c256ad6af$var$_objectSpread({
                type: type,
                attrs: attrs
            }, (0, $9Zzpd.fg)('editor_inline_comments_on_inline_nodes') ? {
                marks: marks
            } : {});
            break;
        case 'status':
            if (attrs && attrs.text && attrs.color) return $5558251c256ad6af$var$_objectSpread({
                type: type,
                attrs: attrs
            }, (0, $9Zzpd.fg)('editor_inline_comments_on_inline_nodes') ? {
                marks: marks
            } : {});
            break;
        case 'emoji':
            if (attrs && attrs.shortName) return $5558251c256ad6af$var$_objectSpread({
                type: type,
                attrs: attrs
            }, (0, $9Zzpd.fg)('editor_inline_comments_on_inline_nodes') ? {
                marks: marks
            } : {});
            break;
        case 'inlineExtension':
        case 'extension':
            if (attrs && attrs.extensionType && attrs.extensionKey) return {
                type: type,
                attrs: attrs
            };
            break;
        case 'inlineCard':
            if (attrs && (attrs.datasource && !attrs.url || attrs.url && (0, $108e5e5f673311da$export$c9f92f5469372e0f)(attrs.url) || attrs.data && attrs.data.url && (0, $108e5e5f673311da$export$c9f92f5469372e0f)(attrs.data.url))) return $5558251c256ad6af$var$_objectSpread({
                type: type,
                attrs: attrs
            }, (0, $9Zzpd.fg)('editor_inline_comments_on_inline_nodes') ? {
                marks: marks
            } : {});
            break;
        case 'blockCard':
            if (attrs && (attrs.datasource && !attrs.url || attrs.url && (0, $108e5e5f673311da$export$c9f92f5469372e0f)(attrs.url) || attrs.data && attrs.data.url && (0, $108e5e5f673311da$export$c9f92f5469372e0f)(attrs.data.url))) return {
                type: type,
                attrs: attrs
            };
            break;
        case 'embedCard':
            if (attrs && (attrs.url && (0, $108e5e5f673311da$export$c9f92f5469372e0f)(attrs.url) || attrs.data && attrs.data.url && (0, $108e5e5f673311da$export$c9f92f5469372e0f)(attrs.data.url)) && attrs.layout) return {
                type: type,
                attrs: attrs
            };
            break;
        case 'bodiedExtension':
            if (attrs && attrs.extensionType && attrs.extensionKey && content) return {
                type: type,
                attrs: attrs,
                content: content
            };
            break;
        case 'multiBodiedExtension':
            if (attrs && attrs.extensionType && attrs.extensionKey && content) return {
                type: type,
                attrs: attrs,
                content: content
            };
            break;
        case 'extensionFrame':
            if (content) return {
                type: type,
                attrs: attrs,
                content: content
            };
            break;
        case 'hardBreak':
            return {
                type: type
            };
        case 'caption':
            if (content) return {
                type: type,
                content: content
            };
            break;
        case 'mediaInline':
            var mediaId = '';
            var mediaCollection = [];
            if (attrs) {
                var id = attrs.id, collection = attrs.collection;
                mediaId = id;
                mediaCollection = collection;
            }
            if (mediaId && mediaCollection) return {
                type: type,
                attrs: attrs,
                marks: marks
            };
            break;
        case 'media':
            var _mediaId = '';
            var mediaType = '';
            var _mediaCollection = [];
            var mediaUrl = '';
            if (attrs) {
                var _id = attrs.id, _collection = attrs.collection, _type = attrs.type, url = attrs.url;
                _mediaId = _id;
                mediaType = _type;
                _mediaCollection = _collection;
                mediaUrl = url;
            }
            if (mediaType === 'external' && !!mediaUrl) {
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                var mediaAttrs = {
                    type: mediaType,
                    url: mediaUrl,
                    width: attrs.width,
                    height: attrs.height
                };
                if (attrs.alt) mediaAttrs.alt = attrs.alt;
                var getMarks = $5558251c256ad6af$var$getValidMarks(marks, adfStage);
                return getMarks ? {
                    type: type,
                    attrs: mediaAttrs,
                    marks: getMarks
                } : {
                    type: type,
                    attrs: mediaAttrs
                };
            } else if (_mediaId && mediaType) {
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                var _mediaAttrs = {
                    type: mediaType,
                    id: _mediaId,
                    collection: _mediaCollection
                };
                if (attrs.width) _mediaAttrs.width = attrs.width;
                if (attrs.height) _mediaAttrs.height = attrs.height;
                if (attrs.alt) _mediaAttrs.alt = attrs.alt;
                var _getMarks = $5558251c256ad6af$var$getValidMarks(marks, adfStage);
                return _getMarks ? {
                    type: type,
                    attrs: _mediaAttrs,
                    marks: _getMarks
                } : {
                    type: type,
                    attrs: _mediaAttrs
                };
            }
            break;
        case 'mediaGroup':
            if (Array.isArray(content) && !content.some(function(e) {
                return e.type !== 'media';
            })) return {
                type: type,
                content: content
            };
            break;
        case 'mediaSingle':
            var containsJustMedia = Array.isArray(content) && content.length === 1 && content[0].type === 'media';
            var containsMediaAndCaption = Array.isArray(content) && content.length === 2 && content[0].type === 'media' && content[1].type === 'caption';
            if (containsJustMedia || containsMediaAndCaption) return {
                type: type,
                attrs: attrs,
                content: content,
                marks: $5558251c256ad6af$var$getValidMarks(marks, adfStage)
            };
            break;
        case 'mention':
            var mentionText = '';
            var mentionId;
            var mentionAccess;
            if (attrs) {
                var _text = attrs.text, displayName = attrs.displayName, _id2 = attrs.id, accessLevel = attrs.accessLevel;
                mentionText = _text || displayName;
                mentionId = _id2;
                mentionAccess = accessLevel;
            }
            if (!mentionText) mentionText = text || '@unknown';
            if (mentionText && mentionId) {
                var mentionNode = $5558251c256ad6af$var$_objectSpread({
                    type: type,
                    attrs: {
                        id: mentionId,
                        text: mentionText,
                        accessLevel: ''
                    }
                }, (0, $9Zzpd.fg)('editor_inline_comments_on_inline_nodes') ? {
                    marks: marks
                } : {});
                if (mentionAccess) mentionNode.attrs.accessLevel = mentionAccess;
                return mentionNode;
            }
            break;
        case 'paragraph':
            if (adfStage === 'stage0') {
                var paragraphNode = {
                    type: type,
                    content: content || []
                };
                if (attrs && attrs.localId) paragraphNode.attrs = {
                    localId: attrs.localId
                };
                if (marks) paragraphNode.marks = (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(marks);
                return paragraphNode;
            }
            return marks ? {
                type: type,
                content: content || [],
                marks: marks
            } : {
                type: type,
                content: content || []
            };
        case 'rule':
            return {
                type: type
            };
        case 'text':
            var _marks = node.marks;
            if (text) return _marks ? {
                type: type,
                text: text,
                marks: $5558251c256ad6af$var$getValidMarks(_marks, adfStage)
            } : {
                type: type,
                text: text
            };
            break;
        case 'heading':
            if (attrs) {
                var level = attrs.level;
                var between = function between(x, a, b) {
                    return x >= a && x <= b;
                };
                if (level && between(level, 1, 6)) {
                    if (adfStage === 'stage0') {
                        var headingNode = {
                            type: type,
                            content: content,
                            attrs: {
                                level: level
                            }
                        };
                        if (attrs.localId) headingNode.attrs.localId = attrs.localId;
                        if (marks) headingNode.marks = (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(marks);
                        return headingNode;
                    }
                    return marks ? {
                        type: type,
                        content: content,
                        marks: marks,
                        attrs: {
                            level: level
                        }
                    } : {
                        type: type,
                        content: content,
                        attrs: {
                            level: level
                        }
                    };
                }
            }
            break;
        case 'bulletList':
            if (content) return {
                type: type,
                content: content
            };
            break;
        case 'orderedList':
            if (content) return {
                type: type,
                content: content,
                attrs: {
                    order: attrs && attrs.order
                }
            };
            break;
        case 'listItem':
            if (content) return {
                type: type,
                content: $5558251c256ad6af$var$wrapInlineNodes(content)
            };
            break;
        case 'blockquote':
            if (content) return {
                type: type,
                content: content
            };
            break;
        case 'panel':
            if (attrs && content) {
                var panelType = attrs.panelType;
                if (Object.values((0, $jRLnM.PanelType)).includes(panelType)) return {
                    type: type,
                    attrs: attrs,
                    content: content
                };
            }
            break;
        case 'layoutSection':
            if (content) return {
                type: type,
                marks: marks,
                content: content
            };
            break;
        case 'layoutColumn':
            if (attrs && content) {
                if (attrs.width > 0 && attrs.width <= 100) return {
                    type: type,
                    content: content,
                    attrs: attrs
                };
            }
            break;
        case 'decisionList':
            return {
                type: type,
                content: content,
                attrs: {
                    localId: attrs && attrs.localId || (0, $l56lt.generateUuid)()
                }
            };
        case 'decisionItem':
            return {
                type: type,
                content: content,
                attrs: {
                    localId: attrs && attrs.localId || (0, $l56lt.generateUuid)(),
                    state: attrs && attrs.state || 'DECIDED'
                }
            };
        case 'taskList':
            return {
                type: type,
                content: content,
                attrs: {
                    localId: attrs && attrs.localId || (0, $l56lt.generateUuid)()
                }
            };
        case 'taskItem':
            return {
                type: type,
                content: content,
                attrs: {
                    localId: attrs && attrs.localId || (0, $l56lt.generateUuid)(),
                    state: attrs && attrs.state || 'TODO'
                }
            };
        case 'blockTaskItem':
            return {
                type: type,
                content: content,
                attrs: {
                    localId: attrs && attrs.localId || (0, $l56lt.generateUuid)(),
                    state: attrs && attrs.state || 'TODO'
                }
            };
        case 'table':
            if (Array.isArray(content) && content.length > 0 && !content.some(function(e) {
                return e.type !== 'tableRow';
            })) {
                if (adfStage === 'stage0') return {
                    type: type,
                    content: content,
                    attrs: $5558251c256ad6af$var$_objectSpread($5558251c256ad6af$var$_objectSpread({}, attrs), {}, {
                        localId: (attrs === null || attrs === void 0 ? void 0 : attrs.localId) || (0, $l56lt.generateUuid)(),
                        width: (attrs === null || attrs === void 0 ? void 0 : attrs.width) || null
                    })
                };
                return {
                    type: type,
                    content: content,
                    attrs: attrs
                };
            }
            break;
        case 'tableRow':
            if (Array.isArray(content) && content.length > 0 && !content.some(function(e) {
                return e.type !== 'tableCell' && e.type !== 'tableHeader';
            })) return {
                type: type,
                content: content
            };
            break;
        case 'tableCell':
        case 'tableHeader':
            if (content) {
                var cellAttrs = {};
                if (attrs) {
                    if (attrs.colspan && attrs.colspan > 1) cellAttrs.colspan = attrs.colspan;
                    if (attrs.rowspan && attrs.rowspan > 1) cellAttrs.rowspan = attrs.rowspan;
                    if (attrs.background) cellAttrs.background = attrs.background;
                    if (attrs.colwidth && Array.isArray(attrs.colwidth)) cellAttrs.colwidth = attrs.colwidth;
                }
                return {
                    type: type,
                    content: $5558251c256ad6af$var$wrapInlineNodes(content),
                    attrs: attrs ? cellAttrs : undefined
                };
            }
            break;
        case 'image':
            if (attrs && attrs.src) return {
                type: type,
                attrs: attrs
            };
            break;
        case 'placeholder':
            if (attrs && typeof attrs.text !== 'undefined') return {
                type: type,
                attrs: attrs
            };
            break;
        case 'expand':
        case 'nestedExpand':
            return {
                type: type,
                attrs: attrs,
                content: content,
                marks: marks
            };
        case 'syncBlock':
            if (attrs && attrs.resourceId && (0, $iVSxl.editorExperiment)('platform_synced_block', true)) return {
                type: type,
                attrs: {
                    resourceId: attrs.resourceId,
                    localId: attrs.localId || (0, $l56lt.generateUuid)()
                },
                marks: marks
            };
            else return $5558251c256ad6af$export$b9908ef75cad1e0e(node);
        case 'bodiedSyncBlock':
            if (attrs && attrs.resourceId && Array.isArray(content) && content.length > 0 && (0, $iVSxl.editorExperiment)('platform_synced_block', true)) return {
                type: type,
                attrs: {
                    resourceId: attrs.resourceId,
                    localId: attrs.localId || (0, $l56lt.generateUuid)()
                },
                marks: marks,
                content: content
            };
            else return $5558251c256ad6af$export$b9908ef75cad1e0e(node);
    }
    return $5558251c256ad6af$export$b9908ef75cad1e0e(node);
};
var $5558251c256ad6af$export$87c6d4a6ebb7d9e9 = function getValidMark(mark) {
    var adfStage = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'final';
    var attrs = mark.attrs, type = mark.type;
    if (type) switch(type){
        case 'code':
            return {
                type: type
            };
        case 'em':
            return {
                type: type
            };
        case 'link':
            if (attrs) {
                var href = attrs.href, url = attrs.url, __confluenceMetadata = attrs.__confluenceMetadata;
                var linkHref = href || url;
                if (linkHref && linkHref.indexOf(':') === -1 && !$5558251c256ad6af$var$RELATIVE_LINK.test(linkHref) && !$5558251c256ad6af$var$ANCHOR_LINK.test(linkHref)) linkHref = "http://".concat(linkHref);
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                var linkAttrs = {
                    href: linkHref
                };
                if (__confluenceMetadata) linkAttrs.__confluenceMetadata = __confluenceMetadata;
                if (linkHref && (0, $108e5e5f673311da$export$c9f92f5469372e0f)(linkHref)) return {
                    type: type,
                    attrs: linkAttrs
                };
            }
            break;
        case 'strike':
            return {
                type: type
            };
        case 'strong':
            return {
                type: type
            };
        case 'subsup':
            if (attrs && attrs['type']) {
                var subSupType = attrs['type'];
                if ($5558251c256ad6af$export$30f8aa4cc1f8c1cb(subSupType)) return {
                    type: type,
                    attrs: {
                        type: subSupType
                    }
                };
            }
            break;
        case 'textColor':
            if (attrs && $5558251c256ad6af$var$TEXT_COLOR_PATTERN.test(attrs.color)) return {
                type: type,
                attrs: attrs
            };
            break;
        case 'underline':
            return {
                type: type
            };
        case 'annotation':
            return {
                type: type,
                attrs: attrs
            };
        case 'border':
            return {
                type: type,
                attrs: attrs
            };
        case 'backgroundColor':
            if (attrs && $5558251c256ad6af$var$TEXT_COLOR_PATTERN.test(attrs.color)) return {
                type: type,
                attrs: attrs
            };
            break;
    }
    if (adfStage === 'stage0') switch(type){
        case 'confluenceInlineComment':
            return {
                type: type,
                attrs: attrs
            };
        case 'dataConsumer':
            return {
                type: type,
                attrs: attrs
            };
        case 'fragment':
            return {
                type: type,
                attrs: attrs
            };
        case 'border':
            return {
                type: type,
                attrs: attrs
            };
    }
    return null;
};


// src/selection.ts

var $l8uaJ = parcelRequire("l8uaJ");

var $2gI99 = parcelRequire("2gI99");
var $a94aebd51bef5436$export$5dd18664fe8bcbde = (nodeType)=>(tr)=>{
        const parent = $a94aebd51bef5436$export$1a3a74094b9968e(nodeType)(tr.selection);
        if (parent) return $a94aebd51bef5436$var$removeNodeAtPos(parent.pos)(tr);
        return tr;
    };
var $a94aebd51bef5436$export$b72cc612b642c071 = (nodeType, content)=>(tr)=>{
        if (!Array.isArray(nodeType)) nodeType = [
            nodeType
        ];
        for(let i = 0, count = nodeType.length; i < count; i++){
            const parent = $a94aebd51bef5436$export$1a3a74094b9968e(nodeType[i])(tr.selection);
            if (parent) {
                const newTr = $a94aebd51bef5436$var$replaceNodeAtPos(parent.pos, content)(tr);
                if (newTr !== tr) return newTr;
            }
        }
        return tr;
    };
var $a94aebd51bef5436$export$7d6e4e6663186878 = (tr)=>{
    if ($a94aebd51bef5436$export$a8c1d2c13abf8822(tr.selection)) {
        const from = tr.selection.$from.pos;
        const to = tr.selection.$to.pos;
        return $a94aebd51bef5436$var$cloneTr(tr.delete(from, to));
    }
    return tr;
};
var $a94aebd51bef5436$export$39874bca494f9ba3 = (content)=>(tr)=>{
        if ($a94aebd51bef5436$export$a8c1d2c13abf8822(tr.selection)) {
            const { $from: $from, $to: $to } = tr.selection;
            if (content instanceof (0, $2gI99.Fragment) && $from.parent.canReplace($from.index(), $from.indexAfter(), content) || content instanceof (0, $2gI99.Node) && $from.parent.canReplaceWith($from.index(), $from.indexAfter(), content.type)) return $a94aebd51bef5436$var$cloneTr(tr.replaceWith($from.pos, $to.pos, content).setSelection(new (0, $l8uaJ.NodeSelection)(tr.doc.resolve($from.pos))));
        }
        return tr;
    };
var $a94aebd51bef5436$export$1df6d14df6b0b758 = (position, dir = 1)=>(tr)=>{
        const nextSelection = (0, $l8uaJ.Selection).findFrom(tr.doc.resolve(position), dir, true);
        if (nextSelection) return tr.setSelection(nextSelection);
        return tr;
    };
var $a94aebd51bef5436$var$isSelectableNode = (node)=>Boolean(node instanceof (0, $2gI99.Node) && node.type && node.type.spec.selectable);
var $a94aebd51bef5436$var$shouldSelectNode = (node)=>$a94aebd51bef5436$var$isSelectableNode(node) && node.type.isLeaf;
var $a94aebd51bef5436$var$setSelection = (node, pos, tr)=>{
    if ($a94aebd51bef5436$var$shouldSelectNode(node)) return tr.setSelection(new (0, $l8uaJ.NodeSelection)(tr.doc.resolve(pos)));
    return $a94aebd51bef5436$export$1df6d14df6b0b758(pos)(tr);
};
var $a94aebd51bef5436$export$5fe92db78385e37c = (content, position, tryToReplace)=>(tr)=>{
        const hasPosition = typeof position === "number";
        const { $from: $from } = tr.selection;
        const $insertPos = hasPosition ? tr.doc.resolve(position) : $a94aebd51bef5436$export$a8c1d2c13abf8822(tr.selection) ? tr.doc.resolve($from.pos + 1) : $from;
        const { parent: parent } = $insertPos;
        if ($a94aebd51bef5436$export$a8c1d2c13abf8822(tr.selection) && tryToReplace) {
            const oldTr = tr;
            tr = $a94aebd51bef5436$export$39874bca494f9ba3(content)(tr);
            if (oldTr !== tr) return tr;
        }
        if ($a94aebd51bef5436$var$isEmptyParagraph(parent)) {
            const oldTr = tr;
            tr = $a94aebd51bef5436$export$b72cc612b642c071(parent.type, content)(tr);
            if (oldTr !== tr) {
                const pos = $a94aebd51bef5436$var$isSelectableNode(content) ? // for selectable node, selection position would be the position of the replaced parent
                $insertPos.before($insertPos.depth) : $insertPos.pos;
                return $a94aebd51bef5436$var$setSelection(content, pos, tr);
            }
        }
        if ($a94aebd51bef5436$export$b4d1262a40ad21d4($insertPos, content)) {
            tr.insert($insertPos.pos, content);
            const pos = hasPosition ? $insertPos.pos : $a94aebd51bef5436$var$isSelectableNode(content) ? // for atom nodes selection position after insertion is the previous pos
            tr.selection.$anchor.pos - 1 : tr.selection.$anchor.pos;
            return $a94aebd51bef5436$var$cloneTr($a94aebd51bef5436$var$setSelection(content, pos, tr));
        }
        for(let i = $insertPos.depth; i > 0; i--){
            const pos = $insertPos.after(i);
            const $pos = tr.doc.resolve(pos);
            if ($a94aebd51bef5436$export$b4d1262a40ad21d4($pos, content)) {
                tr.insert(pos, content);
                return $a94aebd51bef5436$var$cloneTr($a94aebd51bef5436$var$setSelection(content, pos, tr));
            }
        }
        return tr;
    };
var $a94aebd51bef5436$export$36491a9ea218d882 = (nodeType, type, attrs, marks)=>(tr)=>{
        const parent = $a94aebd51bef5436$export$1a3a74094b9968e(nodeType)(tr.selection);
        if (parent) return $a94aebd51bef5436$var$cloneTr(tr.setNodeMarkup(parent.pos, type, Object.assign({}, parent.node.attrs, attrs), marks));
        return tr;
    };
var $a94aebd51bef5436$export$7f11cc48adfe3aed = (nodeType)=>(tr)=>{
        if (!$a94aebd51bef5436$export$a8c1d2c13abf8822(tr.selection)) {
            const parent = $a94aebd51bef5436$export$1a3a74094b9968e(nodeType)(tr.selection);
            if (parent) return $a94aebd51bef5436$var$cloneTr(tr.setSelection((0, $l8uaJ.NodeSelection).create(tr.doc, parent.pos)));
        }
        return tr;
    };
var $a94aebd51bef5436$export$ffb1550ab6c3d03c = (tr)=>{
    const position = $a94aebd51bef5436$export$f8088819b1e2c2dc(tr.selection);
    if (typeof position === "number") return $a94aebd51bef5436$var$removeNodeAtPos(position)(tr);
    return tr;
};
// src/helpers.ts
var $a94aebd51bef5436$export$a8c1d2c13abf8822 = (selection)=>{
    return selection instanceof (0, $l8uaJ.NodeSelection);
};
var $a94aebd51bef5436$var$equalNodeType = (nodeType, node)=>{
    return Array.isArray(nodeType) && nodeType.indexOf(node.type) > -1 || node.type === nodeType;
};
var $a94aebd51bef5436$var$cloneTr = (tr)=>{
    return Object.assign(Object.create(tr), tr).setTime(Date.now());
};
var $a94aebd51bef5436$var$replaceNodeAtPos = (position, content)=>(tr)=>{
        const node = tr.doc.nodeAt(position);
        const $pos = tr.doc.resolve(position);
        if (!node) return tr;
        if ($a94aebd51bef5436$var$canReplace($pos, content)) {
            tr = tr.replaceWith(position, position + node.nodeSize, content);
            const start = tr.selection.$from.pos - 1;
            tr = $a94aebd51bef5436$export$1df6d14df6b0b758(Math.max(start, 0), -1)(tr);
            tr = $a94aebd51bef5436$export$1df6d14df6b0b758(tr.selection.$from.start())(tr);
            return $a94aebd51bef5436$var$cloneTr(tr);
        }
        return tr;
    };
var $a94aebd51bef5436$var$canReplace = ($pos, content)=>{
    const node = $pos.node($pos.depth);
    return node && node.type.validContent(content instanceof (0, $2gI99.Fragment) ? content : (0, $2gI99.Fragment).from(content));
};
var $a94aebd51bef5436$var$removeNodeAtPos = (position)=>(tr)=>{
        const node = tr.doc.nodeAt(position);
        if (!node) return tr;
        return $a94aebd51bef5436$var$cloneTr(tr.delete(position, position + node.nodeSize));
    };
var $a94aebd51bef5436$export$b4d1262a40ad21d4 = ($pos, content)=>{
    const index = $pos.index();
    if (content instanceof (0, $2gI99.Fragment)) return $pos.parent.canReplace(index, index, content);
    else if (content instanceof (0, $2gI99.Node)) return $pos.parent.canReplaceWith(index, index, content.type);
    return false;
};
var $a94aebd51bef5436$var$isEmptyParagraph = (node)=>{
    return !node || node.type.name === "paragraph" && node.nodeSize === 2;
};
// src/selection.ts
var $a94aebd51bef5436$export$dc159056ffdb4c76 = (predicate)=>({ $from: $from, $to: $to }, validateSameParent = false)=>{
        if (validateSameParent && !$from.sameParent($to)) {
            let depth = Math.min($from.depth, $to.depth);
            while(depth >= 0){
                const fromNode = $from.node(depth);
                const toNode = $to.node(depth);
                if (toNode === fromNode) {
                    if (predicate(fromNode)) return {
                        // Return the resolved pos
                        pos: depth > 0 ? $from.before(depth) : 0,
                        start: $from.start(depth),
                        depth: depth,
                        node: fromNode
                    };
                }
                depth = depth - 1;
            }
            return;
        }
        return $a94aebd51bef5436$export$fe09644e3bc6166b($from, predicate);
    };
var $a94aebd51bef5436$export$fe09644e3bc6166b = ($pos, predicate)=>{
    for(let i = $pos.depth; i > 0; i--){
        const node = $pos.node(i);
        if (predicate(node)) return {
            pos: i > 0 ? $pos.before(i) : 0,
            start: $pos.start(i),
            depth: i,
            node: node
        };
    }
};
var $a94aebd51bef5436$export$8556d79fa8189214 = (predicate, domAtPos)=>(selection)=>{
        const parent = $a94aebd51bef5436$export$dc159056ffdb4c76(predicate)(selection);
        if (parent) return $a94aebd51bef5436$export$666ce65defe9ad6e(parent.pos, domAtPos);
    };
var $a94aebd51bef5436$export$178ecaf80f45fdb6 = (predicate)=>(selection)=>{
        return !!$a94aebd51bef5436$export$dc159056ffdb4c76(predicate)(selection);
    };
var $a94aebd51bef5436$export$1a3a74094b9968e = (nodeType)=>(selection)=>{
        return $a94aebd51bef5436$export$dc159056ffdb4c76((node)=>$a94aebd51bef5436$var$equalNodeType(nodeType, node))(selection);
    };
var $a94aebd51bef5436$export$8bf0d019bde85d18 = ($pos, nodeType)=>{
    return $a94aebd51bef5436$export$fe09644e3bc6166b($pos, (node)=>$a94aebd51bef5436$var$equalNodeType(nodeType, node));
};
var $a94aebd51bef5436$export$14f438bb7227ce63 = (nodeType)=>(selection)=>{
        return $a94aebd51bef5436$export$178ecaf80f45fdb6((node)=>$a94aebd51bef5436$var$equalNodeType(nodeType, node))(selection);
    };
var $a94aebd51bef5436$export$faeafc1151740116 = (nodeType, domAtPos)=>(selection)=>{
        return $a94aebd51bef5436$export$8556d79fa8189214((node)=>$a94aebd51bef5436$var$equalNodeType(nodeType, node), domAtPos)(selection);
    };
var $a94aebd51bef5436$export$924aa2dd4d9a67fa = (nodeType)=>(selection)=>{
        if ($a94aebd51bef5436$export$a8c1d2c13abf8822(selection)) {
            const { node: node, $from: $from } = selection;
            if ($a94aebd51bef5436$var$equalNodeType(nodeType, node)) return {
                node: node,
                start: $from.start(),
                pos: $from.pos,
                depth: $from.depth
            };
        }
    };
var $a94aebd51bef5436$export$f8088819b1e2c2dc = (selection)=>{
    const { nodeBefore: nodeBefore } = selection.$from;
    const maybeSelection = (0, $l8uaJ.Selection).findFrom(selection.$from, -1);
    if (maybeSelection && nodeBefore) {
        const parent = $a94aebd51bef5436$export$1a3a74094b9968e(nodeBefore.type)(maybeSelection);
        if (parent) return parent.pos;
        return maybeSelection.$from.pos;
    }
};
var $a94aebd51bef5436$export$666ce65defe9ad6e = (position, domAtPos)=>{
    const dom = domAtPos(position);
    const node = dom.node.childNodes[dom.offset];
    if (dom.node.nodeType === Node.TEXT_NODE && dom.node.parentNode) return dom.node.parentNode;
    if (!node || node.nodeType === Node.TEXT_NODE) return dom.node;
    return node;
};
// src/node.ts
var $a94aebd51bef5436$export$bffa455ba8c619a6 = (node, descend = true)=>{
    if (!node) throw new Error('Invalid "node" parameter');
    const result = [];
    node.descendants((child, pos)=>{
        result.push({
            node: child,
            pos: pos
        });
        if (!descend) return false;
    });
    return result;
};
var $a94aebd51bef5436$export$f94ca194e830789c = (node, predicate, descend = true)=>{
    if (!node) throw new Error('Invalid "node" parameter');
    else if (!predicate) throw new Error('Invalid "predicate" parameter');
    return $a94aebd51bef5436$export$bffa455ba8c619a6(node, descend).filter((child)=>predicate(child.node));
};
var $a94aebd51bef5436$export$53418710fbc2d8cc = (node, descend = true)=>{
    return $a94aebd51bef5436$export$f94ca194e830789c(node, (child)=>child.isText, descend);
};
var $a94aebd51bef5436$export$ddc1620722e25671 = (node, descend = true)=>{
    return $a94aebd51bef5436$export$f94ca194e830789c(node, (child)=>child.isInline, descend);
};
var $a94aebd51bef5436$export$cae8d7f259e5bbe9 = (node, descend = true)=>{
    return $a94aebd51bef5436$export$f94ca194e830789c(node, (child)=>child.isBlock, descend);
};
var $a94aebd51bef5436$export$a836476a7f9de5b4 = (node, predicate, descend = true)=>{
    return $a94aebd51bef5436$export$f94ca194e830789c(node, (child)=>!!predicate(child.attrs), descend);
};
var $a94aebd51bef5436$export$96bb9476c7c69f39 = (node, nodeType, descend = true)=>{
    return $a94aebd51bef5436$export$f94ca194e830789c(node, (child)=>child.type === nodeType, descend);
};
var $a94aebd51bef5436$export$c01a9e7ec615e821 = (node, markType, descend = true)=>{
    return $a94aebd51bef5436$export$f94ca194e830789c(node, (child)=>Boolean(markType.isInSet(child.marks)), descend);
};
var $a94aebd51bef5436$export$2344b14b097df817 = (node, nodeType)=>{
    return !!$a94aebd51bef5436$export$96bb9476c7c69f39(node, nodeType).length;
};



var $9Zzpd = parcelRequire("9Zzpd");

var $9F9pG = parcelRequire("9F9pG");

var $w2fDc = parcelRequire("w2fDc");/* eslint-disable @atlaskit/editor/no-re-export */ // Mapping file

var $kqp0i = parcelRequire("kqp0i");

var $5FkrB = parcelRequire("5FkrB");

var $3IjMA = parcelRequire("3IjMA");
/* code.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $kqp0i = parcelRequire("kqp0i");

var $1Vcia = parcelRequire("1Vcia");

var $970q7 = parcelRequire("970q7");

var $5FkrB = parcelRequire("5FkrB");

var $l23cj = parcelRequire("l23cj");

var $deLXP = parcelRequire("deLXP");
var $234d968de5335696$var$_excluded = [
    "testId"
], $234d968de5335696$var$_excluded2 = [
    "children",
    "codeBidiWarnings",
    "hasBidiWarnings",
    "codeBidiWarningLabel",
    "codeBidiWarningTooltipEnabled",
    "isBidiWarningTooltipEnabled"
];
var $234d968de5335696$var$styles = {
    base: "_ca0qyh40 _u5f3m5ip _n3tdyh40 _19bvm5ip _2rkofajl _11c81u0j _1reo1wug _18m91wug _1dqoglyw _1e0c1nu9 _bfhktkvp _16d9qvcn _syaz1fxt _vwz41kw7 _1i4q1hna _o5721jtm"
};
/**
 * __Code__
 *
 * Code highlights short strings of code snippets inline with body text.
 *
 * - [Examples](https://atlassian.design/components/code/examples)
 * - [Code](https://atlassian.design/components/code/code)
 * - [Usage](https://atlassian.design/components/code/usage)
 */ var $234d968de5335696$var$Code = /*#__PURE__*/ (0, $5FkrB.memo)(/*#__PURE__*/ (0, $5FkrB.forwardRef)(function Code(_ref, ref) {
    var testId = _ref.testId, props = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $234d968de5335696$var$_excluded);
    var children = props.children, _props$codeBidiWarnin = props.codeBidiWarnings, codeBidiWarnings = _props$codeBidiWarnin === void 0 ? true : _props$codeBidiWarnin, hasBidiWarnings = props.hasBidiWarnings, codeBidiWarningLabel = props.codeBidiWarningLabel, _props$codeBidiWarnin2 = props.codeBidiWarningTooltipEnabled, codeBidiWarningTooltipEnabled = _props$codeBidiWarnin2 === void 0 ? true : _props$codeBidiWarnin2, isBidiWarningTooltipEnabled = props.isBidiWarningTooltipEnabled, otherProps = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(props, $234d968de5335696$var$_excluded2);
    // Use new props if provided, otherwise fall back to deprecated props
    var shouldShowBidiWarnings = hasBidiWarnings !== undefined ? hasBidiWarnings : codeBidiWarnings;
    var shouldEnableTooltip = isBidiWarningTooltipEnabled !== undefined ? isBidiWarningTooltipEnabled : codeBidiWarningTooltipEnabled;
    var decoratedChildren = shouldShowBidiWarnings ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement($234d968de5335696$var$RenderCodeChildrenWithBidiWarnings, {
        codeBidiWarningLabel: codeBidiWarningLabel,
        codeBidiWarningTooltipEnabled: shouldEnableTooltip
    }, children) : children;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("code", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        ref: ref,
        "data-testid": testId
    }, otherProps, {
        className: (0, $970q7.default)([
            $234d968de5335696$var$styles.base
        ])
    }), decoratedChildren);
}));
function $234d968de5335696$var$RenderCodeChildrenWithBidiWarnings(_ref2) {
    var children = _ref2.children, codeBidiWarningLabel = _ref2.codeBidiWarningLabel, codeBidiWarningTooltipEnabled = _ref2.codeBidiWarningTooltipEnabled;
    var replacedChildren = (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).Children.map(children, function(childNode) {
        if (typeof childNode === 'string') {
            var decorated = (0, $deLXP.default)(childNode, function(_ref3) {
                var bidiCharacter = _ref3.bidiCharacter, index = _ref3.index;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $l23cj.default), {
                    bidiCharacter: bidiCharacter,
                    key: index,
                    label: codeBidiWarningLabel,
                    tooltipEnabled: codeBidiWarningTooltipEnabled
                });
            });
            return decorated;
        }
        if ($234d968de5335696$var$isReactElement(childNode) && childNode.props.children) {
            // eslint-disable-next-line @repo/internal/react/no-clone-element
            var newChildNode = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).cloneElement(childNode, {
                children: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement($234d968de5335696$var$RenderCodeChildrenWithBidiWarnings, {
                    codeBidiWarningLabel: codeBidiWarningLabel,
                    codeBidiWarningTooltipEnabled: codeBidiWarningTooltipEnabled
                }, childNode.props.children)
            });
            return newChildNode;
        }
        return childNode;
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).Fragment, null, replacedChildren);
}
function $234d968de5335696$var$isReactElement(child) {
    return !!child.type;
}
$234d968de5335696$var$Code.displayName = 'Code';
var $234d968de5335696$export$2e2bcd8739ae039 = $234d968de5335696$var$Code;



var $6qzXE = parcelRequire("6qzXE");
var $7b2d933bcff57ef4$export$86390c02c110ec2f = function isCodeMark(mark) {
    return mark && mark.type && mark.type.name === 'code';
};
function $7b2d933bcff57ef4$export$7cea6ffa7022e85f(props) {
    var codeBidiWarningLabel = props.intl.formatMessage((0, $6qzXE.codeBidiWarningMessages).label);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $234d968de5335696$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        className: "code",
        codeBidiWarningLabel: codeBidiWarningLabel,
        codeBidiWarningTooltipEnabled: props.codeBidiWarningTooltipEnabled
    }, props.dataAttributes), props.children);
}
var $7b2d933bcff57ef4$export$2e2bcd8739ae039 = (0, $3IjMA.default)($7b2d933bcff57ef4$export$7cea6ffa7022e85f);



var $5FkrB = parcelRequire("5FkrB");
function $8ba2e00755bbf395$export$2e2bcd8739ae039(props) {
    // ignore the eslint warning Text primitive does not support dataAttributes
    // eslint-disable-next-line @atlaskit/design-system/use-primitives-text
    // Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading, @atlaskit/design-system/use-primitives-text
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("em", props.dataAttributes, props.children);
}



var $kqp0i = parcelRequire("kqp0i");

var $5FkrB = parcelRequire("5FkrB");

var $74Zh5 = parcelRequire("74Zh5");

var $d4dXm = parcelRequire("d4dXm");

var $9Zzpd = parcelRequire("9Zzpd");

var $9F9pG = parcelRequire("9F9pG");

var $aP6HU = parcelRequire("aP6HU");

var $jJH6F = parcelRequire("jJH6F");

var $kqp0i = parcelRequire("kqp0i");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");


var $48wjX = parcelRequire("48wjX");

var $8dj3L = parcelRequire("8dj3L");

var $iDztP = parcelRequire("iDztP");

var $5bCL3 = parcelRequire("5bCL3");

var $5FkrB = parcelRequire("5FkrB");

var $lrGSQ = parcelRequire("lrGSQ");
var $4cd49b1669da37f1$export$9458cdec663b9ff1 = function LinkAnalyticsContext(_ref) {
    var display = _ref.display, id = _ref.id, children = _ref.children, source = _ref.source;
    var displayCategory = display === 'url' ? 'link' : undefined;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $lrGSQ.default), {
        data: {
            source: source,
            attributes: {
                displayCategory: displayCategory,
                display: display,
                id: id
            }
        }
    }, children);
};



var $kqp0i = parcelRequire("kqp0i");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");

var $iDztP = parcelRequire("iDztP");

var $5bCL3 = parcelRequire("5bCL3");
var $f0b26b3a2b312bb4$var$_excluded = [
    "href",
    "children",
    "testId",
    "isLinkComponent"
];
var $f0b26b3a2b312bb4$var$Anchor = (0, $5bCL3.withLinkClickedEvent)('a');
var $f0b26b3a2b312bb4$export$8c0773eab230d49e = (0, $5bCL3.withLinkClickedEvent)((0, $iDztP.default));
var $f0b26b3a2b312bb4$var$Hyperlink = function Hyperlink(_ref) {
    var href = _ref.href, children = _ref.children, testId = _ref.testId, _ref$isLinkComponent = _ref.isLinkComponent, isLinkComponent = _ref$isLinkComponent === void 0 ? false : _ref$isLinkComponent, props = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $f0b26b3a2b312bb4$var$_excluded);
    var Link = isLinkComponent ? $f0b26b3a2b312bb4$export$8c0773eab230d49e : $f0b26b3a2b312bb4$var$Anchor;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(Link, (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, isLinkComponent ? {
        testId: testId
    } : {
        'data-testid': testId
    }, {
        href: href || ''
    }, props), children);
};
var $f0b26b3a2b312bb4$export$2e2bcd8739ae039 = $f0b26b3a2b312bb4$var$Hyperlink;



var $kqp0i = parcelRequire("kqp0i");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");

var $3spbj = parcelRequire("3spbj");

var $3IjMA = parcelRequire("3IjMA");

var $8dj3L = parcelRequire("8dj3L");

var $jPneb = parcelRequire("jPneb");

var $9Zzpd = parcelRequire("9Zzpd");

var $bCLMC = parcelRequire("bCLMC");

var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");

var $6JfQX = parcelRequire("6JfQX");

var $96IWe = parcelRequire("96IWe");

var $1Bpy8 = parcelRequire("1Bpy8");

var $g8q8G = parcelRequire("g8q8G");

var $bCLMC = parcelRequire("bCLMC");

var $eDkLs = parcelRequire("eDkLs");
/**
 * This is a scheduled batched register mechanism for resolving blue hyperlinks while the page is idle.
 * i.e. SharePoint tenants with the same hostname will be grouped together before the register is made.
 */ 
var $5FkrB = parcelRequire("5FkrB");
var $f662da5fe91e2f67$var$batchQueue = new Map();
var $f662da5fe91e2f67$var$batchTimeouts = new Map();
var $f662da5fe91e2f67$var$BATCH_DELAY = 250;
var $f662da5fe91e2f67$var$executeBatch = function executeBatch(hostname) {
    var items = $f662da5fe91e2f67$var$batchQueue.get(hostname) || [];
    if (items.length === 0) return;
    $f662da5fe91e2f67$var$batchQueue.delete(hostname);
    $f662da5fe91e2f67$var$batchTimeouts.delete(hostname);
    items.forEach(function(_ref) {
        var register = _ref.register, resolve = _ref.resolve, reject = _ref.reject;
        register().then(resolve).catch(reject);
    });
};
var $f662da5fe91e2f67$var$addToBatch = function addToBatch(hostname, item) {
    if (!$f662da5fe91e2f67$var$batchQueue.has(hostname)) $f662da5fe91e2f67$var$batchQueue.set(hostname, []);
    $f662da5fe91e2f67$var$batchQueue.get(hostname).push(item);
    if ($f662da5fe91e2f67$var$batchTimeouts.has(hostname)) clearTimeout($f662da5fe91e2f67$var$batchTimeouts.get(hostname));
    $f662da5fe91e2f67$var$batchTimeouts.set(hostname, setTimeout(function() {
        $f662da5fe91e2f67$var$executeBatch(hostname);
    }, $f662da5fe91e2f67$var$BATCH_DELAY));
};
var $f662da5fe91e2f67$export$db80d61271e4d5af = function useScheduledRegister(href, register) {
    var isScheduled = (0, $5FkrB.useRef)(false);
    var scheduledRegister = (0, $5FkrB.useCallback)(function() {
        if (!href || !register || isScheduled.current) return Promise.resolve();
        isScheduled.current = true;
        return new Promise(function(_resolve, _reject) {
            var scheduleRegister = function scheduleRegister() {
                try {
                    var hostname = new URL(href).hostname;
                    $f662da5fe91e2f67$var$addToBatch(hostname, {
                        href: href,
                        register: register,
                        resolve: function resolve(value) {
                            isScheduled.current = false;
                            _resolve(value);
                        },
                        reject: function reject(error) {
                            isScheduled.current = false;
                            _reject(error);
                        }
                    });
                } catch (error) {
                    isScheduled.current = false;
                    register().then(_resolve).catch(_reject);
                }
            };
            if (typeof window !== 'undefined') {
                if ('requestIdleCallback' in window) window.requestIdleCallback(scheduleRegister);
                else setTimeout(scheduleRegister, 0);
            } else scheduleRegister();
        });
    }, [
        href,
        register
    ]);
    return scheduledRegister;
};


var $04aeb6032c4349ca$var$useResolveHyperlink = function useResolveHyperlink(_ref) {
    var href = _ref.href;
    // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
    var _useState = (0, $5FkrB.useState)(function() {
        return (0, $6JfQX.default)();
    }), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 1), id = _useState2[0];
    var state = (0, $eDkLs.useSmartCardState)(href);
    var definitionId = (0, $bCLMC.getDefinitionId)(state.details);
    var extensionKey = (0, $bCLMC.getExtensionKey)(state.details);
    var resourceType = (0, $bCLMC.getResourceType)(state.details);
    var actions = (0, $g8q8G.useSmartCardActions)(id, href);
    var scheduledRegister = (0, $f662da5fe91e2f67$export$db80d61271e4d5af)(href, actions.register);
    var _useAnalyticsEvents = (0, $96IWe.useAnalyticsEvents)(), fireEvent = _useAnalyticsEvents.fireEvent;
    (0, $5FkrB.useEffect)(function() {
        scheduledRegister().catch(function(error) {
            throw error;
        });
    }, [
        scheduledRegister
    ]);
    (0, $5FkrB.useEffect)(function() {
        $1Bpy8.mark(id, state.status);
        if (state.status !== 'pending' && state.status !== 'resolving') {
            var _state$error, _state$error2;
            $1Bpy8.create(id, state.status);
            if (state.status === 'resolved') {
                var _measure$getMeasure$d, _measure$getMeasure;
                fireEvent('operational.hyperlink.resolved', {
                    definitionId: definitionId !== null && definitionId !== void 0 ? definitionId : null,
                    extensionKey: extensionKey !== null && extensionKey !== void 0 ? extensionKey : null,
                    resourceType: resourceType !== null && resourceType !== void 0 ? resourceType : null,
                    duration: (_measure$getMeasure$d = (_measure$getMeasure = $1Bpy8.getMeasure(id, state.status)) === null || _measure$getMeasure === void 0 ? void 0 : _measure$getMeasure.duration) !== null && _measure$getMeasure$d !== void 0 ? _measure$getMeasure$d : null
                });
            } else if (((_state$error = state.error) === null || _state$error === void 0 ? void 0 : _state$error.type) !== 'ResolveUnsupportedError' && ((_state$error2 = state.error) === null || _state$error2 === void 0 ? void 0 : _state$error2.type) !== 'UnsupportedError') fireEvent('operational.hyperlink.unresolved', {
                definitionId: definitionId !== null && definitionId !== void 0 ? definitionId : null,
                extensionKey: extensionKey !== null && extensionKey !== void 0 ? extensionKey : null,
                resourceType: resourceType !== null && resourceType !== void 0 ? resourceType : null,
                reason: state.status,
                error: state.error === undefined ? null : {
                    name: state.error.name,
                    kind: state.error.kind,
                    type: state.error.type
                }
            });
        }
    }, [
        id,
        state.status,
        state.error,
        definitionId,
        extensionKey,
        resourceType,
        fireEvent
    ]);
    return {
        state: state,
        actions: actions
    };
};
var $04aeb6032c4349ca$export$2e2bcd8739ae039 = $04aeb6032c4349ca$var$useResolveHyperlink;



var $5FkrB = parcelRequire("5FkrB");

var $9kTNw = parcelRequire("9kTNw");
var $b6c468dabe0284aa$var$allowedHostnames = [
    'sharepoint.com',
    'onedrive.live.com',
    'docs.google.com',
    'drive.google.com'
];
var $b6c468dabe0284aa$export$aa45d36a96427452 = function shouldResolveUrl(href) {
    try {
        var hostname = new URL(href).hostname.toLowerCase();
        return $b6c468dabe0284aa$var$allowedHostnames.some(function(allowedHostname) {
            return hostname.includes(allowedHostname);
        });
    } catch (_unused) {
        return false;
    }
};
var $b6c468dabe0284aa$var$useResolveHyperlinkValidator = function useResolveHyperlinkValidator() {
    var href = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    var hasSmartCardProvider = !!(0, $5FkrB.useContext)((0, $9kTNw.SmartCardContext));
    return hasSmartCardProvider && $b6c468dabe0284aa$export$aa45d36a96427452(href);
};
var $b6c468dabe0284aa$export$2e2bcd8739ae039 = $b6c468dabe0284aa$var$useResolveHyperlinkValidator;



var $LjX2F = parcelRequire("LjX2F");

var $5FkrB = parcelRequire("5FkrB");

var $2DGGf = parcelRequire("2DGGf");
/**
 * HOC to wrap component with IntlProvider if not available
 */ var $4f6b0e09cf2ff659$var$withIntlProvider = function withIntlProvider(Component) {
    return function(props) {
        var content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(Component, props);
        return props !== null && props !== void 0 && props.intl ? content : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $2DGGf.default), {
            locale: "en"
        }, content);
    };
};
var $4f6b0e09cf2ff659$export$2e2bcd8739ae039 = $4f6b0e09cf2ff659$var$withIntlProvider;



var $fFOdD = parcelRequire("fFOdD");


var $kqp0i = parcelRequire("kqp0i");

var $1Vcia = parcelRequire("1Vcia");

var $5FkrB = parcelRequire("5FkrB");

var $iBNQo = parcelRequire("iBNQo");

var $aSVEw = parcelRequire("aSVEw");

var $h4cku = parcelRequire("h4cku");

var $98204b4111d2c937$var$_excluded = [
    "onAuthorize",
    "provider",
    "showConnectBtn"
];
var $98204b4111d2c937$var$HyperlinkUnauthorizedView = function HyperlinkUnauthorizedView(_ref) {
    var onAuthorize = _ref.onAuthorize, provider = _ref.provider, showConnectBtn = _ref.showConnectBtn, props = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $98204b4111d2c937$var$_excluded);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $f0b26b3a2b312bb4$export$2e2bcd8739ae039), props), showConnectBtn && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).Fragment, null, ' ', /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $h4cku.ActionButton), {
        onClick: onAuthorize,
        testId: "button-connect-account"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $iBNQo.default), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, (0, $aSVEw.messages).connect_link_account_card_name, {
        values: {
            context: provider === null || provider === void 0 ? void 0 : provider.text
        }
    })))));
};
var $98204b4111d2c937$export$2e2bcd8739ae039 = $98204b4111d2c937$var$HyperlinkUnauthorizedView;


var $8687f6d5cd20f2ea$var$_excluded = [
    "onClick"
];
var $8687f6d5cd20f2ea$var$HyperlinkFallbackComponent = function HyperlinkFallbackComponent() {
    return null;
};
var $8687f6d5cd20f2ea$var$withValidator = function withValidator(Component, DefaultComponent) {
    return function(props) {
        var shouldResolveHyperlink = (0, $b6c468dabe0284aa$export$2e2bcd8739ae039)(props === null || props === void 0 ? void 0 : props.href);
        return shouldResolveHyperlink && props.href ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $LjX2F.SmartLinkAnalyticsContext), {
            url: props.href,
            display: "url"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(Component, props)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(DefaultComponent, props);
    };
};
var $8687f6d5cd20f2ea$var$HyperlinkWithSmartLinkResolverInner = function HyperlinkWithSmartLinkResolverInner(_ref) {
    var onClickCallback = _ref.onClick, props = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $8687f6d5cd20f2ea$var$_excluded);
    var _useResolveHyperlink = (0, $04aeb6032c4349ca$export$2e2bcd8739ae039)({
        href: props.href || ''
    }), actions = _useResolveHyperlink.actions, state = _useResolveHyperlink.state;
    var services = (0, $bCLMC.getServices)(state === null || state === void 0 ? void 0 : state.details);
    var thirdPartyARI = (0, $bCLMC.getThirdPartyARI)(state === null || state === void 0 ? void 0 : state.details);
    var firstPartyIdentifier = (0, $bCLMC.getFirstPartyIdentifier)();
    var fire3PClickEvent = (0, $9Zzpd.fg)('platform_smartlink_3pclick_analytics') ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $fFOdD.useFire3PWorkflowsClickEvent)(firstPartyIdentifier, thirdPartyARI) : undefined;
    var onClick = (0, $5FkrB.useCallback)(function(e) {
        // Only fire the event if the feature flag is on and other conditions are met
        if ((state === null || state === void 0 ? void 0 : state.status) === 'resolved' && (e === null || e === void 0 ? void 0 : e.button) === 0 && fire3PClickEvent && (0, $9Zzpd.fg)('platform_smartlink_3pclick_analytics')) // 0 taken from button state representation -
        // https://developer.mozilla.org/en-US/docs/Web/API/MouseEvent/button
        fire3PClickEvent();
        onClickCallback === null || onClickCallback === void 0 || onClickCallback(e);
    }, [
        onClickCallback,
        fire3PClickEvent,
        state === null || state === void 0 ? void 0 : state.status
    ]);
    var onAuthorize = (0, $5FkrB.useCallback)(function() {
        return actions.authorize('url');
    }, [
        actions
    ]);
    var shouldRenderConnectBtn = function shouldRenderConnectBtn() {
        if (!props.children || !Array.isArray(props.children) || props.children.length === 0) return false;
        var firstChild = props.children[0];
        try {
            var _firstChild$props;
            // Check if first child has a string matching href
            if (typeof firstChild === 'string') return props.href === firstChild;
            // Check if first child has another child object containing matching href. This aligns with the behavior of the TextWrapper component used by editor to render link nodes
            if (firstChild !== null && firstChild !== void 0 && (_firstChild$props = firstChild.props) !== null && _firstChild$props !== void 0 && _firstChild$props.children && typeof firstChild.props.children === 'string') return props.href === firstChild.props.children;
        } catch (_) {
            return false;
        }
    };
    if ((state === null || state === void 0 ? void 0 : state.status) === 'unauthorized' && shouldRenderConnectBtn() && ((0, $8dj3L.default).getExperimentValue('platform_linking_bluelink_connect_confluence', 'isEnabled', false) || (0, $8dj3L.default).getExperimentValue('platform_linking_bluelink_connect_jira', 'isEnabled', false))) {
        var provider = (0, $jPneb.extractSmartLinkProvider)(state === null || state === void 0 ? void 0 : state.details);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $98204b4111d2c937$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, props, {
            onAuthorize: services !== null && services !== void 0 && services.length ? onAuthorize : undefined,
            onClick: onClick,
            showConnectBtn: (services === null || services === void 0 ? void 0 : services.length) > 0,
            provider: provider
        }));
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $f0b26b3a2b312bb4$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, props, {
        onClick: onClick
    }));
};
var $8687f6d5cd20f2ea$export$1fdb4f77fe528a52 = (0, $3spbj.withErrorBoundary)($8687f6d5cd20f2ea$var$withValidator((0, $3IjMA.default)((0, $4f6b0e09cf2ff659$export$2e2bcd8739ae039)($8687f6d5cd20f2ea$var$HyperlinkWithSmartLinkResolverInner), {
    enforceContext: false
}), (0, $f0b26b3a2b312bb4$export$2e2bcd8739ae039)), {
    FallbackComponent: $8687f6d5cd20f2ea$var$HyperlinkFallbackComponent
});


/* index.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $kqp0i = parcelRequire("kqp0i");

var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");

var $iBNQo = parcelRequire("iBNQo");
var $3IjMA = parcelRequire("3IjMA");
var $2DGGf = parcelRequire("2DGGf");

var $jgNUw = parcelRequire("jgNUw");

var $iDztP = parcelRequire("iDztP");

var $fv8CT = parcelRequire("fv8CT");
var $jh6Of = parcelRequire("jh6Of");
var $3oYKE = parcelRequire("3oYKE");
var $acmdv = parcelRequire("acmdv");
var $ayzaw = parcelRequire("ayzaw");
var $lh9Pt = parcelRequire("lh9Pt");

var $aSVEw = parcelRequire("aSVEw");
var $c81e5166218a95c2$var$breakWordsCss = null;
var $c81e5166218a95c2$var$WarningModal = function WarningModal(props) {
    var isOpen = props.isOpen, unsafeLinkText = props.unsafeLinkText, url = props.url, onClose = props.onClose, onContinue = props.onContinue, intl = props.intl;
    var content = /*#__PURE__*/ $5FkrB.createElement((0, $lh9Pt.default), null, isOpen && /*#__PURE__*/ $5FkrB.createElement((0, $fv8CT.default), {
        onClose: onClose,
        testId: "link-with-safety-warning"
    }, /*#__PURE__*/ $5FkrB.createElement((0, $acmdv.default), {
        hasCloseButton: true
    }, /*#__PURE__*/ $5FkrB.createElement((0, $ayzaw.default), {
        appearance: "warning"
    }, /*#__PURE__*/ $5FkrB.createElement((0, $iBNQo.default), (0, $aSVEw.messages).check_this_link))), /*#__PURE__*/ $5FkrB.createElement((0, $jh6Of.default), null, /*#__PURE__*/ $5FkrB.createElement("div", {
        className: (0, $970q7.default)([
            "_o5726vc6 _1nmz9jpi"
        ])
    }, url && unsafeLinkText && /*#__PURE__*/ $5FkrB.createElement((0, $iBNQo.default), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, (0, $aSVEw.messages).link_safety_warning_message, {
        values: {
            unsafeLinkText: unsafeLinkText,
            a: function a() {
                return /*#__PURE__*/ $5FkrB.createElement((0, $iDztP.default), {
                    href: url,
                    target: "_blank",
                    rel: "noopener noreferrer"
                }, url);
            }
        }
    })))), /*#__PURE__*/ $5FkrB.createElement((0, $3oYKE.default), null, /*#__PURE__*/ $5FkrB.createElement((0, $jgNUw.default), {
        appearance: "subtle",
        onClick: onClose
    }, /*#__PURE__*/ $5FkrB.createElement((0, $iBNQo.default), (0, $aSVEw.messages).go_back)), /*#__PURE__*/ $5FkrB.createElement((0, $jgNUw.default), {
        appearance: "warning",
        onClick: onContinue,
        autoFocus: true
    }, /*#__PURE__*/ $5FkrB.createElement((0, $iBNQo.default), (0, $aSVEw.messages).continue)))));
    return intl ? content : /*#__PURE__*/ $5FkrB.createElement((0, $2DGGf.default), {
        locale: "en"
    }, content);
};
var $c81e5166218a95c2$export$2e2bcd8739ae039 = (0, $3IjMA.default)($c81e5166218a95c2$var$WarningModal, {
    enforceContext: false
});



var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");

var $cOsWw = parcelRequire("cOsWw");

var $eLdEw = parcelRequire("eLdEw");

var $8ckEN = parcelRequire("8ckEN");
var $c72e65a2d8b8655e$var$toUrl = function toUrl(url, base) {
    try {
        return new URL(url, base);
    } catch (_unused) {
        return undefined;
    }
};
var $c72e65a2d8b8655e$export$32b76c003683c2ec = function useLinkWarningModal() {
    var _useState = (0, $5FkrB.useState)(null), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), unsafeLinkText = _useState2[0], setUnsafeLinkText = _useState2[1];
    var _useState3 = (0, $5FkrB.useState)(null), _useState4 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState3, 2), url = _useState4[0], setUrl = _useState4[1];
    var _useState5 = (0, $5FkrB.useState)(false), _useState6 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState5, 2), isOpen = _useState6[0], setIsOpen = _useState6[1];
    var _useAnalyticsEvents = (0, $cOsWw.useAnalyticsEvents)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
    var sendWarningModalViewedEvent = function sendWarningModalViewedEvent() {
        createAnalyticsEvent({
            action: 'viewed',
            actionSubject: 'linkSafetyWarningModal',
            eventType: 'screen',
            name: 'linkSafetyWarningModal'
        }).fire((0, $8ckEN.ANALYTICS_CHANNEL));
    };
    var sendContinueClickedEvent = function sendContinueClickedEvent() {
        createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'linkSafetyWarningModalContinue',
            eventType: 'ui',
            screen: 'linkSafetyWarningModal'
        }).fire((0, $8ckEN.ANALYTICS_CHANNEL));
    };
    /**
   * It checks and warns if a link text is a URL and different from an actual link destination
   */ var isLinkSafe = function isLinkSafe(event, href) {
        if (!href) return true;
        var anchor = event.currentTarget;
        var linkText = anchor.innerText;
        var normalisedUrlFromLinkText = (0, $eLdEw.normalizeUrl)(linkText);
        if (!normalisedUrlFromLinkText) return true;
        var anchorLinkRegex = new RegExp(/^#/im);
        var isLinkTextAnchorLink = anchorLinkRegex.test(linkText);
        var isAnchorLink = anchorLinkRegex.test(href);
        if (isAnchorLink || isLinkTextAnchorLink) return true;
        var relativeLinkRegex = new RegExp(/^\//im);
        var isRelativeHrefLink = relativeLinkRegex.test(href);
        if (isRelativeHrefLink) return true;
        var hrefUrl = $c72e65a2d8b8655e$var$toUrl(href, window.location.origin);
        var linkTextUrl = $c72e65a2d8b8655e$var$toUrl(normalisedUrlFromLinkText, hrefUrl === null || hrefUrl === void 0 ? void 0 : hrefUrl.origin);
        if (!hrefUrl || !linkTextUrl) return true;
        var currentAtlassianProductOrigin = window.location.origin;
        var isSafeToIgnoreNonOriginDifferences = (hrefUrl === null || hrefUrl === void 0 ? void 0 : hrefUrl.origin) === currentAtlassianProductOrigin && (linkTextUrl === null || linkTextUrl === void 0 ? void 0 : linkTextUrl.origin) === currentAtlassianProductOrigin;
        if (isSafeToIgnoreNonOriginDifferences) return true;
        var httpProtocols = [
            'http:',
            'https:'
        ];
        var areProtocolsEquivalent;
        if (httpProtocols.includes(linkTextUrl.protocol) && httpProtocols.includes(hrefUrl.protocol)) {
            var noUserNameAndPassword = !linkTextUrl.username && !linkTextUrl.password && !hrefUrl.username && !hrefUrl.password;
            areProtocolsEquivalent = noUserNameAndPassword;
        } else areProtocolsEquivalent = linkTextUrl.protocol === hrefUrl.protocol;
        var areEquivalentLinks = linkTextUrl.hostname === hrefUrl.hostname && linkTextUrl.pathname === hrefUrl.pathname && linkTextUrl.search === hrefUrl.search && linkTextUrl.username === hrefUrl.username && linkTextUrl.password === hrefUrl.password && areProtocolsEquivalent;
        if (!areEquivalentLinks) return false;
        return true;
    };
    var showSafetyWarningModal = function showSafetyWarningModal(event, href) {
        event.preventDefault();
        var anchor = event.currentTarget;
        var linkText = anchor.innerText;
        setUnsafeLinkText(linkText);
        href && setUrl(href);
        setIsOpen(true);
        sendWarningModalViewedEvent();
    };
    var onClose = function onClose() {
        setIsOpen(false);
        setUnsafeLinkText(null);
        setUrl(null);
    };
    var onContinue = function onContinue() {
        onClose();
        sendContinueClickedEvent();
        url && window.open(url, '_blank', 'noopener noreferrer');
    };
    return {
        isLinkSafe: isLinkSafe,
        isOpen: isOpen,
        onClose: onClose,
        onContinue: onContinue,
        showSafetyWarningModal: showSafetyWarningModal,
        unsafeLinkText: unsafeLinkText,
        url: url
    };
};


var $94aa06c49d1fa9d8$var$_excluded = [
    "href",
    "children",
    "checkSafety",
    "onClick",
    "testId",
    "isLinkComponent",
    "enableResolve"
], $94aa06c49d1fa9d8$var$_excluded2 = [
    "isLinkSafe",
    "showSafetyWarningModal"
];
var $94aa06c49d1fa9d8$var$PACKAGE_DATA = {
    packageName: "@atlaskit/smart-card",
    packageVersion: "43.12.3",
    componentName: 'linkUrl'
};
var $94aa06c49d1fa9d8$var$Anchor = (0, $5bCL3.withLinkClickedEvent)('a');
var $94aa06c49d1fa9d8$export$8c0773eab230d49e = (0, $5bCL3.withLinkClickedEvent)((0, $iDztP.default));
var $94aa06c49d1fa9d8$var$LinkUrl = function LinkUrl(_ref) {
    var href = _ref.href, children = _ref.children, _ref$checkSafety = _ref.checkSafety, checkSafety = _ref$checkSafety === void 0 ? true : _ref$checkSafety, _onClick = _ref.onClick, _ref$testId = _ref.testId, testId = _ref$testId === void 0 ? 'link-with-safety' : _ref$testId, _ref$isLinkComponent = _ref.isLinkComponent, isLinkComponent = _ref$isLinkComponent === void 0 ? false : _ref$isLinkComponent, _ref$enableResolve = _ref.enableResolve, enableResolve = _ref$enableResolve === void 0 ? false : _ref$enableResolve, props = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $94aa06c49d1fa9d8$var$_excluded);
    var _useLinkWarningModal = (0, $c72e65a2d8b8655e$export$32b76c003683c2ec)(), isLinkSafe = _useLinkWarningModal.isLinkSafe, showSafetyWarningModal = _useLinkWarningModal.showSafetyWarningModal, linkWarningModalProps = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_useLinkWarningModal, $94aa06c49d1fa9d8$var$_excluded2);
    var resolveHyperlinkFG = (0, $8dj3L.default).checkGate('platform_editor_resolve_hyperlinks_killswitch');
    if (resolveHyperlinkFG) {
        var _Link = enableResolve ? (0, $8687f6d5cd20f2ea$export$1fdb4f77fe528a52) : (0, $f0b26b3a2b312bb4$export$2e2bcd8739ae039);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $4cd49b1669da37f1$export$9458cdec663b9ff1), {
            url: href,
            display: "url"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(_Link, (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
            href: href,
            isLinkComponent: isLinkComponent,
            onClick: function onClick(e) {
                if (!checkSafety) {
                    _onClick && _onClick(e);
                    return;
                }
                // Only call the onClick if the link is safe
                if (isLinkSafe(e, href)) _onClick && _onClick(e);
                else showSafetyWarningModal(e, href);
            }
        }, props), children)), checkSafety && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $c81e5166218a95c2$export$2e2bcd8739ae039), linkWarningModalProps));
    }
    var Link = isLinkComponent ? $94aa06c49d1fa9d8$export$8c0773eab230d49e : $94aa06c49d1fa9d8$var$Anchor;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $4cd49b1669da37f1$export$9458cdec663b9ff1), {
        url: href,
        display: "url"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(Link, (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, isLinkComponent ? {
        testId: testId
    } : {
        'data-testid': testId
    }, {
        href: href || '',
        onClick: function onClick(e) {
            if (!checkSafety) {
                _onClick && _onClick(e);
                return;
            }
            // Only call the onClick if the link is safe
            if (isLinkSafe(e, href)) _onClick && _onClick(e);
            else showSafetyWarningModal(e, href);
        }
    }, props), children)), checkSafety && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $c81e5166218a95c2$export$2e2bcd8739ae039), linkWarningModalProps));
};
var $94aa06c49d1fa9d8$export$2e2bcd8739ae039 = (0, $48wjX.default)($94aa06c49d1fa9d8$var$PACKAGE_DATA)($94aa06c49d1fa9d8$var$LinkUrl);



var $lrGSQ = parcelRequire("lrGSQ");
var $34deba354526914d$var$anchorStyles = (0, $74Zh5.css)({
    color: "var(--ds-link, ".concat((0, $d4dXm.B400), ")"),
    '&:hover': {
        color: "var(--ds-link, ".concat((0, $d4dXm.B300), ")"),
        textDecoration: 'underline'
    },
    '&:active': {
        color: "var(--ds-link-pressed, ".concat((0, $d4dXm.B500), ")")
    }
});
function $34deba354526914d$export$2e2bcd8739ae039(props) {
    var href = props.href, target = props.target, onSetLinkTarget = props.onSetLinkTarget, eventHandlers = props.eventHandlers, fireAnalyticsEvent = props.fireAnalyticsEvent, isMediaLink = props.isMediaLink, dataAttributes = props.dataAttributes;
    var actualTarget = target;
    if (onSetLinkTarget && href && (0, $9Zzpd.fg)('rovo_chat_deep_linking_enabled')) try {
        var _onSetLinkTarget;
        actualTarget = (_onSetLinkTarget = onSetLinkTarget(href)) !== null && _onSetLinkTarget !== void 0 ? _onSetLinkTarget : actualTarget;
    } catch (error) {
    // If URL parsing fails, use the original target
    }
    var anchorProps = {
        href: href,
        target: actualTarget,
        title: href
    };
    if (actualTarget === '_blank') anchorProps.rel = 'noreferrer noopener';
    var handler = (0, $9F9pG.getEventHandler)(eventHandlers, 'link');
    if (isMediaLink) return (0, $74Zh5.jsx)((0, $5FkrB.Fragment), null, props.children);
    var analyticsData = {
        attributes: {
            location: 'renderer'
        },
        // Below is added for the future implementation of Linking Platform namespaced analytic context
        location: 'renderer'
    };
    return (0, $74Zh5.jsx)((0, $lrGSQ.default), {
        data: analyticsData
    }, (0, $74Zh5.jsx)((0, $94aa06c49d1fa9d8$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        css: $34deba354526914d$var$anchorStyles,
        onClick: function onClick(e) {
            if (fireAnalyticsEvent) fireAnalyticsEvent({
                action: (0, $jJH6F.ACTION).VISITED,
                actionSubject: (0, $jJH6F.ACTION_SUBJECT).LINK,
                eventType: (0, $jJH6F.EVENT_TYPE).TRACK,
                attributes: {
                    platform: (0, $aP6HU.PLATFORM).WEB,
                    mode: (0, $aP6HU.MODE).RENDERER
                }
            });
            if (handler) handler(e, href);
        }
    }, anchorProps, dataAttributes, {
        isLinkComponent: true,
        enableResolve: true
    }), props.children));
}



var $kqp0i = parcelRequire("kqp0i");

var $5FkrB = parcelRequire("5FkrB");
function $4f2072525bb46916$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("span", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, props.dataAttributes, {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            textDecoration: 'line-through'
        }
    }), props.children);
}



var $5FkrB = parcelRequire("5FkrB");
function $bf141d5161e77678$export$2e2bcd8739ae039(props) {
    // ignore the eslint warning Text primitive does not support dataAttributes
    // eslint-disable-next-line @atlaskit/design-system/use-primitives-text
    // Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading, @atlaskit/design-system/use-primitives-text
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("strong", props.dataAttributes, props.children);
}



var $5FkrB = parcelRequire("5FkrB");
var $12c13372ddda400f$var$isSub = function isSub(type) {
    return type === 'sub';
};
function $12c13372ddda400f$export$2e2bcd8739ae039(props) {
    if ($12c13372ddda400f$var$isSub(props.type)) // Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("sub", props.dataAttributes, props.children);
    // Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("sup", props.dataAttributes, props.children);
}



var $kqp0i = parcelRequire("kqp0i");

var $25nEq = parcelRequire("25nEq");

var $5FkrB = parcelRequire("5FkrB");

var $gwjAb = parcelRequire("gwjAb");

var $25nEq = parcelRequire("25nEq");
var $583caa1295a28541$var$_editorTextPalette;
function $583caa1295a28541$export$9c2f408d391feb93(hexColor) {
    // Ts ignore used to allow use of conditional return type
    // (preferencing better type on consumption over safety in implementation)
    // @ts-ignore
    return $583caa1295a28541$export$57fa5089caad992[hexColor.toUpperCase()];
}
var $583caa1295a28541$export$57fa5089caad992 = ($583caa1295a28541$var$_editorTextPalette = {}, (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($583caa1295a28541$var$_editorTextPalette, '#B3D4FF', "var(--ds-background-accent-blue-subtler, #B3D4FF)"), '#4C9AFF', "var(--ds-icon-accent-blue, #4C9AFF)"), '#0747A6', "var(--ds-text-accent-blue, #0747A6)"), '#B3F5FF', "var(--ds-background-accent-teal-subtler, #B3F5FF)"), '#00B8D9', "var(--ds-icon-accent-teal, #00B8D9)"), '#008DA6', "var(--ds-text-accent-teal, #008DA6)"), '#ABF5D1', "var(--ds-background-accent-green-subtler, #ABF5D1)"), '#36B37E', "var(--ds-icon-accent-green, #36B37E)"), '#006644', "var(--ds-text-accent-green, #006644)"), '#FFF0B3', "var(--ds-background-accent-yellow-subtler, #FFF0B3)"), (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($583caa1295a28541$var$_editorTextPalette, '#FFC400', "var(--ds-background-accent-orange-subtle, #FFC400)"), '#FF991F', "var(--ds-icon-accent-orange, #FF991F)"), '#FFBDAD', "var(--ds-background-accent-red-subtler, #FFBDAD)"), '#FF5630', "var(--ds-icon-accent-red, #FF5630)"), '#BF2600', "var(--ds-text-accent-red, #BF2600)"), '#EAE6FF', "var(--ds-background-accent-purple-subtler, #EAE6FF)"), '#6554C0', "var(--ds-icon-accent-purple, #6554C0)"), '#403294', "var(--ds-text-accent-purple, #403294)"), '#FFFFFF', "var(--ds-text-inverse, #FFFFFF)"), '#97A0AF', "var(--ds-icon-accent-gray, #97A0AF)"), (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($583caa1295a28541$var$_editorTextPalette, '#172B4D', "var(--ds-text, #172B4D)"));



var $jLsC1 = parcelRequire("jLsC1");
function $c16c5e74cb7ad188$export$2e2bcd8739ae039(props) {
    var _useThemeObserver = (0, $jLsC1.default)(), colorMode = _useThemeObserver.colorMode;
    // Note -- while there is no way to create custom colors using default tooling
    // the editor does supported ad hoc color values -- and there may be content
    // which has been migrated or created via apis which use such values.
    var paletteColorValue;
    /**
   * The Editor persists custom text colors when content has been migrated from the old editor, or created via
   * apis.
   *
   * This behaviour predates the introduction of dark mode.
   *
   * Without the inversion logic below, text with custom colors, can be hard to read when the user loads the page in dark mode.
   *
   * This introduces inversion of the presentation of the custom text colors when the user is in dark mode.
   *
   * This can be done without additional changes to account for users copying and pasting content inside the Editor, because of
   * how we detect text colors copied from external editor sources. Where we load the background color from a
   * seperate attribute (data-text-custom-color), instead of the inline style.
   *
   * See the following document for more details on this behaviour
   * https://hello.atlassian.net/wiki/spaces/CCECO/pages/2908658046/Unsupported+custom+text+colors+in+dark+theme+Editor+Job+Story
   */ var tokenColor = (0, $583caa1295a28541$export$9c2f408d391feb93)(props.color);
    if (tokenColor) paletteColorValue = (0, $583caa1295a28541$export$9c2f408d391feb93)(props.color) || props.color;
    else if (colorMode === 'dark') // if we have a custom color, we need to check if we are in dark mode
    paletteColorValue = (0, $gwjAb.getDarkModeLCHColor)(props.color);
    else // if we are in light mode, we can just set the color
    paletteColorValue = props.color;
    var style = (0, $5FkrB.useMemo)(function() {
        return (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, '--custom-palette-color', paletteColorValue);
    }, [
        paletteColorValue
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("span", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, props.dataAttributes, {
        "data-text-custom-color": props.color,
        className: "fabric-text-color-mark",
        style: style
    }), props.children);
}



var $kqp0i = parcelRequire("kqp0i");

var $25nEq = parcelRequire("25nEq");

var $5FkrB = parcelRequire("5FkrB");

var $gwjAb = parcelRequire("gwjAb");

var $25nEq = parcelRequire("25nEq");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $25nEq = parcelRequire("25nEq");

var $1Vcia = parcelRequire("1Vcia");

var $iYJcE = parcelRequire("iYJcE");

var $fL8KA = parcelRequire("fL8KA");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $25nEq = parcelRequire("25nEq");

var $6HG4S = parcelRequire("6HG4S");

var $iFR7a = parcelRequire("iFR7a");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $25nEq = parcelRequire("25nEq");

var $hLfKH = parcelRequire("hLfKH");
function $8e14ff35252fa9f0$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $8e14ff35252fa9f0$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $8e14ff35252fa9f0$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $8e14ff35252fa9f0$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $8e14ff35252fa9f0$export$a66cbd9b2289cd78 = '@all-features';
var $8e14ff35252fa9f0$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function Subscriptions() {
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, Subscriptions);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "eventToValue", new Map());
        this.emitter = new (0, (/*@__PURE__*/$parcel$interopDefault($hLfKH)))();
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(Subscriptions, [
        {
            key: "onGateUpdated",
            value: function onGateUpdated(gateName, callback, checkGate, options) {
                var _this = this;
                var value = checkGate(gateName, $8e14ff35252fa9f0$var$_objectSpread($8e14ff35252fa9f0$var$_objectSpread({}, options), {}, {
                    fireGateExposure: false
                }));
                if (this.eventToValue.get(callback) === undefined) this.eventToValue.set(callback, value);
                var wrapCallback = function wrapCallback() {
                    var value = checkGate(gateName, $8e14ff35252fa9f0$var$_objectSpread($8e14ff35252fa9f0$var$_objectSpread({}, options), {}, {
                        fireGateExposure: false
                    }));
                    var existingValue = _this.eventToValue.get(callback);
                    if (existingValue !== value) {
                        _this.eventToValue.set(callback, value);
                        callback(value);
                    }
                };
                this.emitter.on(gateName, wrapCallback);
                return function() {
                    _this.emitter.off(gateName, wrapCallback);
                };
            }
        },
        {
            key: "onExperimentValueUpdated",
            value: function onExperimentValueUpdated(experimentName, parameterName, defaultValue, callback, getExperimentValue, options) {
                var _this2 = this;
                var experimentEventName = "".concat(experimentName, ".").concat(parameterName);
                var value = getExperimentValue(experimentName, parameterName, defaultValue, $8e14ff35252fa9f0$var$_objectSpread($8e14ff35252fa9f0$var$_objectSpread({}, options), {}, {
                    fireExperimentExposure: false
                }));
                if (this.eventToValue.get(callback) === undefined) this.eventToValue.set(callback, value);
                var wrapCallback = function wrapCallback() {
                    var value = getExperimentValue(experimentName, parameterName, defaultValue, $8e14ff35252fa9f0$var$_objectSpread($8e14ff35252fa9f0$var$_objectSpread({}, options), {}, {
                        fireExperimentExposure: false
                    }));
                    var existingValue = _this2.eventToValue.get(callback);
                    if (existingValue !== value) {
                        _this2.eventToValue.set(callback, value);
                        callback(value);
                    }
                };
                this.emitter.on(experimentEventName, wrapCallback);
                return function() {
                    _this2.emitter.off(experimentEventName, wrapCallback);
                };
            }
        },
        {
            key: "onAnyUpdated",
            value: function onAnyUpdated(callback) {
                var _this3 = this;
                this.emitter.on($8e14ff35252fa9f0$export$a66cbd9b2289cd78, callback);
                return function() {
                    _this3.emitter.off($8e14ff35252fa9f0$export$a66cbd9b2289cd78, callback);
                };
            }
        },
        {
            key: "anyUpdated",
            value: function anyUpdated() {
                var _this4 = this;
                this.emitter.emit($8e14ff35252fa9f0$export$a66cbd9b2289cd78);
                this.emitter.eventNames().filter(function(name) {
                    return name !== $8e14ff35252fa9f0$export$a66cbd9b2289cd78;
                }).forEach(function(event) {
                    _this4.emitter.emit(event);
                });
            }
        }
    ]);
}();



var $ekGgq = parcelRequire("ekGgq");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $1Vcia = parcelRequire("1Vcia");

var $iYJcE = parcelRequire("iYJcE");

var $25nEq = parcelRequire("25nEq");

var $ygbGG = parcelRequire("ygbGG");
// Reference: https://github.com/statsig-io/js-lite/blob/main/src/StatsigStore.ts
var $efb69d3109c59e7b$export$c62558b199e46828 = /*#__PURE__*/ function(EvaluationReason) {
    // Order is important since the logic for migrating from a new client reason to an old one
    // returns the first which is a substring of the new client reason
    EvaluationReason["Error"] = "Error";
    EvaluationReason["LocalOverride"] = "LocalOverride";
    EvaluationReason["Unrecognized"] = "Unrecognized";
    EvaluationReason["Uninitialized"] = "Uninitialized";
    EvaluationReason["NetworkNotModified"] = "NetworkNotModified";
    EvaluationReason["Network"] = "Network";
    EvaluationReason["InvalidBootstrap"] = "InvalidBootstrap";
    EvaluationReason["Bootstrap"] = "Bootstrap";
    EvaluationReason["Cache"] = "Cache";
    // For when we could not migrate the reason from the new client
    EvaluationReason["Unknown"] = "Unknown";
    return EvaluationReason;
}({}); // Reference: https://github.com/statsig-io/js-lite/blob/main/src/StatsigSDKOptions.ts


/**
 * The identifiers for the user. Options are restricted to the set that is currently supported.
 */ /**
 * Base client options. Does not include any options specific to providers
 * @interface BaseClientOptions
 * @property {FeatureGateEnvironment} environment - The environment for the client.
 * @property {string} targetApp - The target app for the client.
 * @property {AnalyticsWebClient} analyticsWebClient - The analytics web client.
 * @property {PerimeterType} perimeter - The perimeter for the client.
 */ /**
 * The options for the client.
 * @interface ClientOptions
 * @extends {BaseClientOptions}
 * @property {string} apiKey - The API key for the client.
 * @property {fetchTimeoutMs} fetchTimeoutMs - The timeout for the fetch request in milliseconds. Defaults to 5000.
 * @property {boolean} useGatewayURL - Whether to use the gateway URL. Defaults to false.
 */ /**
 * The custom attributes for the user.
 */ var $9cc743b88fc2afa4$export$479e7351a733299 = /*#__PURE__*/ function(FeatureGateEnvironment) {
    FeatureGateEnvironment["Development"] = "development";
    FeatureGateEnvironment["Staging"] = "staging";
    FeatureGateEnvironment["Production"] = "production";
    return FeatureGateEnvironment;
}({});
var $9cc743b88fc2afa4$export$c42b7bbc5e7ba555 = /*#__PURE__*/ function(PerimeterType) {
    PerimeterType["COMMERCIAL"] = "commercial";
    PerimeterType["FEDRAMP_MODERATE"] = "fedramp-moderate";
    return PerimeterType;
}({});
var $9cc743b88fc2afa4$export$42f4885608027d0c = 'non_boolean'; // Type magic to get the JSDoc comments from the Client class methods to appear on the static
 // methods in FeatureGates where the property name and function type are identical


var $035fce1ed950fa3a$var$_excluded = [
    "api",
    "disableCurrentPageLogging",
    "loggingIntervalMillis",
    "loggingBufferMaxSize",
    "localMode",
    "eventLoggingApi",
    "eventLoggingApiForRetries",
    "disableLocalStorage",
    "ignoreWindowUndefined",
    "disableAllLogging",
    "initTimeoutMs",
    "disableNetworkKeepalive",
    "overrideStableID",
    "disableErrorLogging",
    "disableAutoMetricsLogging"
];
function $035fce1ed950fa3a$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $035fce1ed950fa3a$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $035fce1ed950fa3a$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $035fce1ed950fa3a$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $035fce1ed950fa3a$export$d119b37e5f788b43 = function getOptionsWithDefaults(options) {
    return $035fce1ed950fa3a$var$_objectSpread({
        /**
     * If more federal PerimeterTypes are added in the future, this should be updated so
     * that isFedRamp() === true always returns the strictest perimeter.
     */ perimeter: (0, $ygbGG.isFedRamp)() ? (0, $9cc743b88fc2afa4$export$c42b7bbc5e7ba555).FEDRAMP_MODERATE : (0, $9cc743b88fc2afa4$export$c42b7bbc5e7ba555).COMMERCIAL
    }, options);
};
var $035fce1ed950fa3a$export$fa1c2bbf4100b8bc = function shallowEquals(objectA, objectB) {
    if (!objectA && !objectB) return true;
    if (!objectA || !objectB) return false;
    var aEntries = Object.entries(objectA);
    var bEntries = Object.entries(objectB);
    if (aEntries.length !== bEntries.length) return false;
    var ascendingKeyOrder = function ascendingKeyOrder(_ref, _ref2) {
        var _ref3 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_ref, 1), key1 = _ref3[0];
        var _ref4 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_ref2, 1), key2 = _ref4[0];
        return key1.localeCompare(key2);
    };
    aEntries.sort(ascendingKeyOrder);
    bEntries.sort(ascendingKeyOrder);
    for(var i = 0; i < aEntries.length; i++){
        var _aEntries$i = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(aEntries[i], 2), aValue = _aEntries$i[1];
        var _bEntries$i = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(bEntries[i], 2), bValue = _bEntries$i[1];
        if (aValue !== bValue) return false;
    }
    return true;
};
var $035fce1ed950fa3a$export$3dad1db244472f32 = function toStatsigUser(identifiers, customAttributes) {
    var user = {
        customIDs: identifiers,
        custom: customAttributes
    };
    if (identifiers.atlassianAccountId) user.userID = identifiers.atlassianAccountId;
    return user;
};
var $035fce1ed950fa3a$export$202946b690d26d22 = function migrateInitializationOptions(options) {
    var api = options.api, disableCurrentPageLogging = options.disableCurrentPageLogging, loggingIntervalMillis = options.loggingIntervalMillis, loggingBufferMaxSize = options.loggingBufferMaxSize, localMode = options.localMode, eventLoggingApi = options.eventLoggingApi, eventLoggingApiForRetries = options.eventLoggingApiForRetries, disableLocalStorage = options.disableLocalStorage, ignoreWindowUndefined = options.ignoreWindowUndefined, disableAllLogging = options.disableAllLogging, _initTimeoutMs = options.initTimeoutMs, _disableNetworkKeepalive = options.disableNetworkKeepalive, _overrideStableID = options.overrideStableID, _disableErrorLogging = options.disableErrorLogging, _disableAutoMetricsLogging = options.disableAutoMetricsLogging, rest = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(options, $035fce1ed950fa3a$var$_excluded);
    return $035fce1ed950fa3a$var$_objectSpread($035fce1ed950fa3a$var$_objectSpread({}, rest), {}, {
        networkConfig: {
            api: api,
            logEventUrl: eventLoggingApi ? eventLoggingApi + 'rgstr' : undefined,
            logEventFallbackUrls: eventLoggingApiForRetries ? [
                eventLoggingApiForRetries
            ] : undefined,
            preventAllNetworkTraffic: localMode || !ignoreWindowUndefined && typeof window === 'undefined'
        },
        includeCurrentPageUrlWithEvents: !disableCurrentPageLogging,
        loggingIntervalMs: loggingIntervalMillis,
        loggingBufferMaxSize: loggingBufferMaxSize,
        disableStorage: disableLocalStorage === undefined ? localMode : disableLocalStorage,
        disableLogging: disableAllLogging === undefined ? localMode : disableAllLogging
    });
};
var $035fce1ed950fa3a$var$evaluationReasonMappings = Object.entries((0, $efb69d3109c59e7b$export$c62558b199e46828)).map(function(_ref5) {
    var _ref6 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_ref5, 2), key = _ref6[0], value = _ref6[1];
    return [
        key.toLowerCase(),
        value
    ];
});
var $035fce1ed950fa3a$export$18ad168d3dbac899 = function migrateEvaluationDetails(details) {
    var _evaluationReasonMapp, _evaluationReasonMapp2, _details$receivedAt;
    var reasonLower = details.reason.toLowerCase();
    return {
        reason: (_evaluationReasonMapp = (_evaluationReasonMapp2 = $035fce1ed950fa3a$var$evaluationReasonMappings.find(function(_ref7) {
            var _ref8 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_ref7, 1), key = _ref8[0];
            return reasonLower.includes(key);
        })) === null || _evaluationReasonMapp2 === void 0 ? void 0 : _evaluationReasonMapp2[1]) !== null && _evaluationReasonMapp !== void 0 ? _evaluationReasonMapp : (0, $efb69d3109c59e7b$export$c62558b199e46828).Unknown,
        time: (_details$receivedAt = details.receivedAt) !== null && _details$receivedAt !== void 0 ? _details$receivedAt : Date.now()
    };
};
var $035fce1ed950fa3a$export$55fd683752d01e67 = function migrateSecondaryExposures(secondaryExposures) {
    return secondaryExposures.map(function(exposure) {
        if (typeof exposure === 'string') // This should ideally have gateValue and ruleID fields too, but it's not possible for us
        // to determine the correct values for these.
        return {
            gate: exposure
        };
        return exposure;
    });
};


var $31e4b2b84c540613$export$6dc24881a3d96325 = /*#__PURE__*/ function() {
    function DynamicConfig(configName, configValue, ruleID, evaluationDetails) {
        var secondaryExposures = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : [];
        var allocatedExperimentName = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : '';
        var onDefaultValueFallback = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : null;
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, DynamicConfig);
        this.value = configValue;
        this._name = configName;
        this._ruleID = ruleID;
        this._secondaryExposures = secondaryExposures;
        this._allocatedExperimentName = allocatedExperimentName;
        this._evaluationDetails = evaluationDetails;
        this._onDefaultValueFallback = onDefaultValueFallback;
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(DynamicConfig, [
        {
            key: "get",
            value: function get(key, defaultValue, typeGuard) {
                var _this$_onDefaultValue2;
                var val = this.getValue(key, defaultValue);
                if (val == null) return defaultValue;
                var expectedType = Array.isArray(defaultValue) ? 'array' : (0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(defaultValue);
                var actualType = Array.isArray(val) ? 'array' : (0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(val);
                if (typeGuard) {
                    var _this$_onDefaultValue;
                    if (typeGuard(val)) {
                        this.fireExposure(key);
                        return val;
                    }
                    (_this$_onDefaultValue = this._onDefaultValueFallback) === null || _this$_onDefaultValue === void 0 || _this$_onDefaultValue.call(this, this, key, expectedType, actualType);
                    return defaultValue;
                }
                if (defaultValue == null || expectedType === actualType) {
                    this.fireExposure(key);
                    return val;
                }
                (_this$_onDefaultValue2 = this._onDefaultValueFallback) === null || _this$_onDefaultValue2 === void 0 || _this$_onDefaultValue2.call(this, this, key, expectedType, actualType);
                return defaultValue;
            }
        },
        {
            key: "getValue",
            value: function getValue(key, defaultValue) {
                if (key == null) return this.value;
                if (defaultValue == null) defaultValue = null;
                if (this.value[key] == null) return defaultValue;
                this.fireExposure(key);
                return this.value[key];
            }
        },
        {
            key: "fireExposure",
            value: function fireExposure(key) {
                // Call the wrapped experiment's get method to fire exposure
                if (this.experiment) this.experiment.get(key);
            }
        }
    ], [
        {
            key: "fromExperiment",
            value: function fromExperiment(experiment) {
                var _experiment$__evaluat, _experiment$__evaluat2, _experiment$groupName;
                var config = new DynamicConfig(experiment.name, experiment.value, experiment.ruleID, (0, $035fce1ed950fa3a$export$18ad168d3dbac899)(experiment.details), (0, $035fce1ed950fa3a$export$55fd683752d01e67)((_experiment$__evaluat = (_experiment$__evaluat2 = experiment.__evaluation) === null || _experiment$__evaluat2 === void 0 ? void 0 : _experiment$__evaluat2.secondary_exposures) !== null && _experiment$__evaluat !== void 0 ? _experiment$__evaluat : []), (_experiment$groupName = experiment.groupName) !== null && _experiment$groupName !== void 0 ? _experiment$groupName : undefined);
                config.experiment = experiment;
                return config;
            }
        }
    ]);
}();



var $ekGgq = parcelRequire("ekGgq");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $ba2aa0b6a9aa9cb1$export$936d0764594b6eb3 = /*#__PURE__*/ function() {
    function Layer(name, layerValue, ruleID, evaluationDetails) {
        var logParameterFunction = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
        var secondaryExposures = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : [];
        var undelegatedSecondaryExposures = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : [];
        var allocatedExperimentName = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : '';
        var explicitParameters = arguments.length > 8 && arguments[8] !== undefined ? arguments[8] : [];
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, Layer);
        this._logParameterFunction = logParameterFunction;
        this._name = name;
        this._value = JSON.parse(JSON.stringify(layerValue !== null && layerValue !== void 0 ? layerValue : {}));
        this._ruleID = ruleID !== null && ruleID !== void 0 ? ruleID : '';
        this._evaluationDetails = evaluationDetails;
        this._secondaryExposures = secondaryExposures;
        this._undelegatedSecondaryExposures = undelegatedSecondaryExposures;
        this._allocatedExperimentName = allocatedExperimentName;
        this._explicitParameters = explicitParameters;
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(Layer, [
        {
            key: "get",
            value: function get(key, defaultValue, typeGuard) {
                var _this = this;
                var val = this._value[key];
                if (val == null) return defaultValue;
                var logAndReturn = function logAndReturn() {
                    _this._logLayerParameterExposure(key);
                    return val;
                };
                if (typeGuard) return typeGuard(val) ? logAndReturn() : defaultValue;
                if (defaultValue == null) return logAndReturn();
                if ((0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(val) === (0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(defaultValue) && Array.isArray(defaultValue) === Array.isArray(val)) return logAndReturn();
                return defaultValue;
            }
        },
        {
            key: "getValue",
            value: function getValue(key, defaultValue) {
                // eslint-disable-next-line eqeqeq
                if (defaultValue == undefined) defaultValue = null;
                var val = this._value[key];
                if (val != null) this._logLayerParameterExposure(key);
                return val !== null && val !== void 0 ? val : defaultValue;
            }
        },
        {
            key: "_logLayerParameterExposure",
            value: function _logLayerParameterExposure(parameterName) {
                var _this$_logParameterFu;
                (_this$_logParameterFu = this._logParameterFunction) === null || _this$_logParameterFu === void 0 || _this$_logParameterFu.call(this, this, parameterName);
            }
        }
    ], [
        {
            key: "fromLayer",
            value: function fromLayer(layer) {
                var _layer$__evaluation$s, _layer$__evaluation, _layer$__evaluation$u, _layer$__evaluation2, _layer$__evaluation3, _layer$__evaluation4;
                var value = new Layer(layer.name, layer.__value, layer.ruleID, (0, $035fce1ed950fa3a$export$18ad168d3dbac899)(layer.details), function(_layer, parameterName) {
                    return layer.get(parameterName);
                }, (0, $035fce1ed950fa3a$export$55fd683752d01e67)((_layer$__evaluation$s = (_layer$__evaluation = layer.__evaluation) === null || _layer$__evaluation === void 0 ? void 0 : _layer$__evaluation.secondary_exposures) !== null && _layer$__evaluation$s !== void 0 ? _layer$__evaluation$s : []), (0, $035fce1ed950fa3a$export$55fd683752d01e67)((_layer$__evaluation$u = (_layer$__evaluation2 = layer.__evaluation) === null || _layer$__evaluation2 === void 0 ? void 0 : _layer$__evaluation2.undelegated_secondary_exposures) !== null && _layer$__evaluation$u !== void 0 ? _layer$__evaluation$u : []), (_layer$__evaluation3 = layer.__evaluation) === null || _layer$__evaluation3 === void 0 ? void 0 : _layer$__evaluation3.allocated_experiment_name, (_layer$__evaluation4 = layer.__evaluation) === null || _layer$__evaluation4 === void 0 ? void 0 : _layer$__evaluation4.explicit_parameters);
                return value;
            }
        }
    ]);
}();




var $25nEq = parcelRequire("25nEq");

var $fL8KA = parcelRequire("fL8KA");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $6HG4S = parcelRequire("6HG4S");

/// <reference types="node" />
var $51bb5732914b7a49$export$a59f8d67326bd1cb = "0.0.0-development";



var $arMYe = parcelRequire("arMYe");

var $9P61R = parcelRequire("9P61R");

var $kIXpt = parcelRequire("kIXpt");

var $cYPzS = parcelRequire("cYPzS");

var $eyuDe = parcelRequire("eyuDe");

var $c7s0H = parcelRequire("c7s0H");
function $896922affdb37a42$var$_callSuper(t, o, e) {
    return o = (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(o), (0, (/*@__PURE__*/$parcel$interopDefault($kIXpt)))(t, $896922affdb37a42$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(t).constructor) : o.apply(t, e));
}
function $896922affdb37a42$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($896922affdb37a42$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $896922affdb37a42$export$286baf652d0b1206 = /*#__PURE__*/ function(_Error) {
    function ResponseError(message) {
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, ResponseError);
        return $896922affdb37a42$var$_callSuper(this, ResponseError, [
            message
        ]);
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($eyuDe)))(ResponseError, _Error);
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(ResponseError);
}(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($c7s0H)))(Error));


function $ef06eed36f62c0a5$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $ef06eed36f62c0a5$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $ef06eed36f62c0a5$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $ef06eed36f62c0a5$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $ef06eed36f62c0a5$var$DEFAULT_REQUEST_TIMEOUT_MS = 5000;
var $ef06eed36f62c0a5$export$250a58ecde616daa = 'https://api.atlassian.com/flags';
var $ef06eed36f62c0a5$export$942ba04389b0d5a2 = 'https://api.stg.atlassian.com/flags';
var $ef06eed36f62c0a5$export$f058dbf75c3bc647 = 'https://api.dev.atlassian.com/flags';
var $ef06eed36f62c0a5$export$1a401a0da8da3565 = 'https://api.stg.atlassian-us-gov-mod.com/flags';
var $ef06eed36f62c0a5$export$18c93900db9358a4 = 'https://api.atlassian-us-gov-mod.com/flags';
var $ef06eed36f62c0a5$export$4e8a0415edbfa1f7 = 'https://atlassian-statsig-proxy-archetype.atl-paas.%s.atl-ic.net';
var $ef06eed36f62c0a5$export$cb3cd156f70d7e94 = 'oasis-stg.com/flags';
var $ef06eed36f62c0a5$export$921fbc6cdfd4eee0 = 'atlassian-isolated.net/flags';
var $ef06eed36f62c0a5$export$450bd8fb2a6d7ace = '/gateway/api/flags';
var $ef06eed36f62c0a5$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function Fetcher() {
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, Fetcher);
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(Fetcher, null, [
        {
            key: "fetchClientSdk",
            value: function() {
                var _fetchClientSdk = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee(fetcherOptions) {
                    var targetApp, url;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee$(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                targetApp = fetcherOptions.targetApp;
                                url = "/api/v2/frontend/clientSdkKey/".concat(targetApp);
                                _context.prev = 2;
                                _context.next = 5;
                                return this.fetchRequest(url, 'GET', fetcherOptions);
                            case 5:
                                return _context.abrupt("return", _context.sent);
                            case 8:
                                _context.prev = 8;
                                _context.t0 = _context["catch"](2);
                                if (!(_context.t0 instanceof Error)) {
                                    _context.next = 12;
                                    break;
                                }
                                throw _context.t0;
                            case 12:
                                throw Error('Failed to retrieve client sdk key');
                            case 13:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee, this, [
                        [
                            2,
                            8
                        ]
                    ]);
                }));
                function fetchClientSdk(_x) {
                    return _fetchClientSdk.apply(this, arguments);
                }
                return fetchClientSdk;
            }()
        },
        {
            key: "fetchExperimentValues",
            value: function() {
                var _fetchExperimentValues = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee2(fetcherOptions, identifiers, customAttributes) {
                    var requestBody;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee2$(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                requestBody = {
                                    identifiers: identifiers,
                                    customAttributes: customAttributes,
                                    targetApp: fetcherOptions.targetApp
                                };
                                _context2.prev = 1;
                                _context2.next = 4;
                                return this.fetchRequest('/api/v2/frontend/experimentValues', 'POST', fetcherOptions, requestBody);
                            case 4:
                                return _context2.abrupt("return", _context2.sent);
                            case 7:
                                _context2.prev = 7;
                                _context2.t0 = _context2["catch"](1);
                                if (!(_context2.t0 instanceof Error)) {
                                    _context2.next = 11;
                                    break;
                                }
                                throw _context2.t0;
                            case 11:
                                throw Error('Failed to retrieve experiment values');
                            case 12:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2, this, [
                        [
                            1,
                            7
                        ]
                    ]);
                }));
                function fetchExperimentValues(_x2, _x3, _x4) {
                    return _fetchExperimentValues.apply(this, arguments);
                }
                return fetchExperimentValues;
            }()
        },
        {
            key: "handleResponseError",
            value: function() {
                var _handleResponseError = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee3(response) {
                    var body;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee3$(_context3) {
                        while(true)switch(_context3.prev = _context3.next){
                            case 0:
                                if (response.ok) {
                                    _context3.next = 5;
                                    break;
                                }
                                _context3.next = 3;
                                return response.text();
                            case 3:
                                body = _context3.sent;
                                throw new (0, $896922affdb37a42$export$286baf652d0b1206)("Non 2xx response status received, status: ".concat(response.status, ", body: ").concat(JSON.stringify(body)));
                            case 5:
                                if (!(response.status === 204)) {
                                    _context3.next = 7;
                                    break;
                                }
                                throw new (0, $896922affdb37a42$export$286baf652d0b1206)('Unexpected 204 response');
                            case 7:
                            case "end":
                                return _context3.stop();
                        }
                    }, _callee3);
                }));
                function handleResponseError(_x5) {
                    return _handleResponseError.apply(this, arguments);
                }
                return handleResponseError;
            }()
        },
        {
            key: "extractResponseBody",
            value: function() {
                var _extractResponseBody = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee4(response) {
                    var value;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee4$(_context4) {
                        while(true)switch(_context4.prev = _context4.next){
                            case 0:
                                _context4.next = 2;
                                return response.text();
                            case 2:
                                value = _context4.sent;
                                return _context4.abrupt("return", JSON.parse(value));
                            case 4:
                            case "end":
                                return _context4.stop();
                        }
                    }, _callee4);
                }));
                function extractResponseBody(_x6) {
                    return _extractResponseBody.apply(this, arguments);
                }
                return extractResponseBody;
            }()
        },
        {
            key: "getBaseUrl",
            value: function getBaseUrl(serviceEnv) {
                var useGatewayUrl = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
                var perimeter = arguments.length > 2 ? arguments[2] : undefined;
                var isolationContextId = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
                if (useGatewayUrl) return $ef06eed36f62c0a5$export$450bd8fb2a6d7ace;
                if (perimeter === (0, $9cc743b88fc2afa4$export$c42b7bbc5e7ba555).FEDRAMP_MODERATE) switch(serviceEnv){
                    case (0, $9cc743b88fc2afa4$export$479e7351a733299).Production:
                        return $ef06eed36f62c0a5$export$18c93900db9358a4;
                    case (0, $9cc743b88fc2afa4$export$479e7351a733299).Staging:
                        return $ef06eed36f62c0a5$export$1a401a0da8da3565;
                    default:
                        throw new Error("Invalid environment \"".concat(serviceEnv, "\" for \"").concat(perimeter, "\" perimeter"));
                }
                else if (perimeter === (0, $9cc743b88fc2afa4$export$c42b7bbc5e7ba555).COMMERCIAL) switch(serviceEnv){
                    case (0, $9cc743b88fc2afa4$export$479e7351a733299).Development:
                        return $ef06eed36f62c0a5$export$f058dbf75c3bc647;
                    case (0, $9cc743b88fc2afa4$export$479e7351a733299).Staging:
                        var apiUrl = this.getApiUrl(isolationContextId);
                        if (apiUrl !== null) return apiUrl;
                        return $ef06eed36f62c0a5$export$942ba04389b0d5a2;
                    default:
                        var prodApiUrl = this.getApiUrl(isolationContextId);
                        if (prodApiUrl !== null) return prodApiUrl;
                        return $ef06eed36f62c0a5$export$250a58ecde616daa;
                }
                else throw new Error("Invalid perimeter \"".concat(perimeter, "\""));
            }
        },
        {
            key: "fetchRequest",
            value: function() {
                var _fetchRequest = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee5(path, method, fetcherOptions, body) {
                    var baseUrl, fetchTimeout, abortSignal, abortController, response;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee5$(_context5) {
                        while(true)switch(_context5.prev = _context5.next){
                            case 0:
                                baseUrl = Fetcher.getBaseUrl(fetcherOptions.environment, fetcherOptions.useGatewayURL, fetcherOptions.perimeter, fetcherOptions.isolationContextId);
                                fetchTimeout = fetcherOptions.fetchTimeoutMs || $ef06eed36f62c0a5$var$DEFAULT_REQUEST_TIMEOUT_MS;
                                if (AbortSignal.timeout) abortSignal = AbortSignal.timeout(fetchTimeout);
                                else if (AbortController) {
                                    abortController = new AbortController();
                                    abortSignal = abortController.signal;
                                    setTimeout(function() {
                                        return abortController.abort();
                                    }, fetchTimeout);
                                }
                                _context5.next = 5;
                                return fetch("".concat(baseUrl).concat(path), $ef06eed36f62c0a5$var$_objectSpread({
                                    method: method,
                                    headers: {
                                        'Content-Type': 'application/json',
                                        'X-Client-Name': 'feature-gate-js-client',
                                        'X-Client-Version': (0, $51bb5732914b7a49$export$a59f8d67326bd1cb),
                                        'X-API-KEY': fetcherOptions.apiKey
                                    },
                                    signal: abortSignal
                                }, body && {
                                    body: JSON.stringify(body)
                                }));
                            case 5:
                                response = _context5.sent;
                                _context5.next = 8;
                                return this.handleResponseError(response);
                            case 8:
                                _context5.next = 10;
                                return this.extractResponseBody(response);
                            case 10:
                                return _context5.abrupt("return", _context5.sent);
                            case 11:
                            case "end":
                                return _context5.stop();
                        }
                    }, _callee5, this);
                }));
                function fetchRequest(_x7, _x8, _x9, _x0) {
                    return _fetchRequest.apply(this, arguments);
                }
                return fetchRequest;
            }()
        },
        {
            key: "getApiUrl",
            value: function getApiUrl(isolationContextId) {
                var window1 = this.getWindowLocation();
                if (window1 === undefined) {
                    //this is needed when this SDK is used for SSR or plugin use cases where secret keys not available to use backend SDKs
                    if (!isolationContextId) return null;
                    return $ef06eed36f62c0a5$export$4e8a0415edbfa1f7.replace('%s', isolationContextId);
                }
                var protocol = window1.protocol, hostname = window1.hostname;
                // Match last subdomain fragment before oasis-stg.com
                var oasisMatch = hostname.match(/([^.]+)\.oasis-stg\.com$/);
                if (oasisMatch) return "".concat(protocol, "//api.").concat(oasisMatch[1], ".").concat($ef06eed36f62c0a5$export$cb3cd156f70d7e94);
                // Match last subdomain fragment before atlassian-isolated.net
                var isolatedMatch = hostname.match(/([^.]+)\.atlassian-isolated\.net$/);
                if (isolatedMatch) return "".concat(protocol, "//api.").concat(isolatedMatch[1], ".").concat($ef06eed36f62c0a5$export$921fbc6cdfd4eee0);
                return null;
            }
        },
        {
            key: "getWindowLocation",
            value: function getWindowLocation() {
                if (typeof window !== 'undefined' && window.location) return window.location;
                return undefined;
            }
        }
    ]);
}();



var $fL8KA = parcelRequire("fL8KA");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $kIXpt = parcelRequire("kIXpt");

var $cYPzS = parcelRequire("cYPzS");

var $lwlXp = parcelRequire("lwlXp");

var $eyuDe = parcelRequire("eyuDe");

var $25nEq = parcelRequire("25nEq");

var $6HG4S = parcelRequire("6HG4S");

var $iFR7a = parcelRequire("iFR7a");
function $0c612007e59d374a$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $0c612007e59d374a$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $0c612007e59d374a$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $0c612007e59d374a$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $0c612007e59d374a$var$_callSuper(t, o, e) {
    return o = (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(o), (0, (/*@__PURE__*/$parcel$interopDefault($kIXpt)))(t, $0c612007e59d374a$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(t).constructor) : o.apply(t, e));
}
function $0c612007e59d374a$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($0c612007e59d374a$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $0c612007e59d374a$var$_superPropGet(t, o, e, r) {
    var p = (0, (/*@__PURE__*/$parcel$interopDefault($lwlXp)))((0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(1 & r ? t.prototype : t), o, e);
    return 2 & r && "function" == typeof p ? function(t) {
        return p.apply(e, t);
    } : p;
}
var $0c612007e59d374a$export$55fffef3474104af = /*#__PURE__*/ function(_DataAdapterCore) {
    function NoFetchDataAdapter() {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, NoFetchDataAdapter);
        _this = $0c612007e59d374a$var$_callSuper(this, NoFetchDataAdapter, [
            'NoFetchDataAdapter',
            'nofetch'
        ]);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(_this, "bootstrapResult", null);
        return _this;
    }
    /**
   * Make sure to call this **before** calling `initializeAsync` or `updateUserAsync` but
   * after the Statsig client has been created!
   */ (0, (/*@__PURE__*/$parcel$interopDefault($eyuDe)))(NoFetchDataAdapter, _DataAdapterCore);
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(NoFetchDataAdapter, [
        {
            key: "setBootstrapData",
            value: function setBootstrapData(data) {
                this.bootstrapResult = data ? {
                    source: 'Bootstrap',
                    data: JSON.stringify(data),
                    receivedAt: Date.now(),
                    stableID: (0, $iFR7a.StableID).get(this._getSdkKey()),
                    fullUserHash: null
                } : null;
            }
        },
        {
            key: "prefetchData",
            value: function() {
                var _prefetchData = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee(_user, _options) {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee$(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee);
                }));
                function prefetchData(_x, _x2) {
                    return _prefetchData.apply(this, arguments);
                }
                return prefetchData;
            }()
        },
        {
            key: "getDataAsync",
            value: function() {
                var _getDataAsync = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee2(_current, user, _options) {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee2$(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                return _context2.abrupt("return", this.bootstrapResult && $0c612007e59d374a$var$_objectSpread($0c612007e59d374a$var$_objectSpread({}, this.bootstrapResult), {}, {
                                    fullUserHash: (0, $iFR7a._getFullUserHash)(user)
                                }));
                            case 1:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2, this);
                }));
                function getDataAsync(_x3, _x4, _x5) {
                    return _getDataAsync.apply(this, arguments);
                }
                return getDataAsync;
            }()
        },
        {
            key: "getDataSync",
            value: function getDataSync(user) {
                return this.bootstrapResult && $0c612007e59d374a$var$_objectSpread($0c612007e59d374a$var$_objectSpread({}, this.bootstrapResult), {}, {
                    fullUserHash: (0, $iFR7a._getFullUserHash)(user)
                });
            }
        },
        {
            key: "_fetchFromNetwork",
            value: function() {
                var _fetchFromNetwork2 = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee3(_current, _user, _options) {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee3$(_context3) {
                        while(true)switch(_context3.prev = _context3.next){
                            case 0:
                                return _context3.abrupt("return", null);
                            case 1:
                            case "end":
                                return _context3.stop();
                        }
                    }, _callee3);
                }));
                function _fetchFromNetwork(_x6, _x7, _x8) {
                    return _fetchFromNetwork2.apply(this, arguments);
                }
                return _fetchFromNetwork;
            }()
        },
        {
            key: "_getCacheKey",
            value: function _getCacheKey(user) {
                // Same logic as default data adapter
                // https://github.com/statsig-io/js-client-monorepo/blob/main/packages/js-client/src/StatsigEvaluationsDataAdapter.ts
                var key = (0, $iFR7a._getStorageKey)(this._getSdkKey(), user);
                return "".concat((0, $iFR7a.DataAdapterCachePrefix), ".").concat(this._cacheSuffix, ".").concat(key);
            }
        },
        {
            key: "_isCachedResultValidFor204",
            value: function _isCachedResultValidFor204(_result, _user) {
                return false;
            }
        },
        {
            key: "setDataLegacy",
            value: function setDataLegacy(data, user) {
                $0c612007e59d374a$var$_superPropGet(NoFetchDataAdapter, "setData", this, 3)([
                    data,
                    user
                ]);
            }
        },
        {
            key: "toJSON",
            value: function toJSON() {
                var result = $0c612007e59d374a$var$_objectSpread({}, this);
                delete result._options;
                delete result._inMemoryCache;
                delete result.bootstrapResult;
                return result;
            }
        }
    ]);
}((0, $iFR7a.DataAdapterCore));



var $25nEq = parcelRequire("25nEq");

var $iYJcE = parcelRequire("iYJcE");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $dtn6l = parcelRequire("dtn6l");
function $1aba1b1eabd89cc6$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $1aba1b1eabd89cc6$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $1aba1b1eabd89cc6$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $1aba1b1eabd89cc6$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $1aba1b1eabd89cc6$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $1aba1b1eabd89cc6$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $1aba1b1eabd89cc6$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $1aba1b1eabd89cc6$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $1aba1b1eabd89cc6$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $1aba1b1eabd89cc6$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
var $1aba1b1eabd89cc6$var$LOCAL_OVERRIDE_REASON = 'LocalOverride:Recognized';
var $1aba1b1eabd89cc6$export$d8474cff104280f3 = 'STATSIG_OVERRIDES';
var $1aba1b1eabd89cc6$var$LEGACY_LOCAL_STORAGE_KEY = 'STATSIG_JS_LITE_LOCAL_OVERRIDES';
var $1aba1b1eabd89cc6$var$makeEmptyStore = function makeEmptyStore() {
    return {
        gates: {},
        configs: {},
        layers: {}
    };
};
var $1aba1b1eabd89cc6$var$djb2MapKey = function djb2MapKey(hash, kind) {
    return kind + ':' + hash;
};
var $1aba1b1eabd89cc6$export$bcb28fbac1def494 = /*#__PURE__*/ function() {
    function PersistentOverrideAdapter(localStorageKey) {
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, PersistentOverrideAdapter);
        this._overrides = $1aba1b1eabd89cc6$var$makeEmptyStore();
        this._djb2Map = new Map();
        this._localStorageKey = localStorageKey;
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(PersistentOverrideAdapter, [
        {
            key: "parseStoredOverrides",
            value: function parseStoredOverrides(localStorageKey) {
                try {
                    var json = window.localStorage.getItem(localStorageKey);
                    if (!json) return $1aba1b1eabd89cc6$var$makeEmptyStore();
                    return JSON.parse(json);
                } catch (_unused) {
                    return $1aba1b1eabd89cc6$var$makeEmptyStore();
                }
            }
        },
        {
            key: "mergeOverrides",
            value: function mergeOverrides() {
                var merged = $1aba1b1eabd89cc6$var$makeEmptyStore();
                for(var _len = arguments.length, allOverrides = new Array(_len), _key = 0; _key < _len; _key++)allOverrides[_key] = arguments[_key];
                for(var _i = 0, _allOverrides = allOverrides; _i < _allOverrides.length; _i++){
                    var overrides = _allOverrides[_i];
                    for(var _i2 = 0, _Object$entries = Object.entries((_overrides$gates = overrides.gates) !== null && _overrides$gates !== void 0 ? _overrides$gates : {}); _i2 < _Object$entries.length; _i2++){
                        var _overrides$gates;
                        var _Object$entries$_i = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_Object$entries[_i2], 2), name = _Object$entries$_i[0], value = _Object$entries$_i[1];
                        merged.gates[name] = value;
                    }
                    for(var _i3 = 0, _Object$entries2 = Object.entries((_overrides$configs = overrides.configs) !== null && _overrides$configs !== void 0 ? _overrides$configs : {}); _i3 < _Object$entries2.length; _i3++){
                        var _overrides$configs;
                        var _Object$entries2$_i = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_Object$entries2[_i3], 2), _name = _Object$entries2$_i[0], _value = _Object$entries2$_i[1];
                        merged.configs[_name] = _value;
                    }
                    for(var _i4 = 0, _Object$entries3 = Object.entries((_overrides$layers = overrides.layers) !== null && _overrides$layers !== void 0 ? _overrides$layers : {}); _i4 < _Object$entries3.length; _i4++){
                        var _overrides$layers;
                        var _Object$entries3$_i = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_Object$entries3[_i4], 2), _name2 = _Object$entries3$_i[0], _value2 = _Object$entries3$_i[1];
                        merged.layers[_name2] = _value2;
                    }
                }
                return merged;
            }
        },
        {
            key: "initFromStoredOverrides",
            value: function initFromStoredOverrides() {
                var storedOverrides = this.mergeOverrides(this._overrides, this.parseStoredOverrides($1aba1b1eabd89cc6$var$LEGACY_LOCAL_STORAGE_KEY), this.parseStoredOverrides(this._localStorageKey));
                // Clear data from legacy local storage key now we've read from it.
                // This prevents things being stuck in there that are always read but never written to.
                try {
                    window.localStorage.removeItem($1aba1b1eabd89cc6$var$LEGACY_LOCAL_STORAGE_KEY);
                } catch (_unused2) {
                // ignored - window is not defined in non-browser environments, and we don't save things there
                // (things like SSR, etc)
                }
                // In version 4.24.0 we introduced hashes in this override adapter, but had a bug which would cause
                // multiple hashes to continue being created. This code here removes these hashes since we've moved
                // to using a more reliable and easier to maintain map in `_djb2Map`.
                for(var _i5 = 0, _Object$values = Object.values(storedOverrides); _i5 < _Object$values.length; _i5++){
                    var container = _Object$values[_i5];
                    var allKeys = new Set(Object.keys(container));
                    var _iterator = $1aba1b1eabd89cc6$var$_createForOfIteratorHelper(allKeys), _step;
                    try {
                        for(_iterator.s(); !(_step = _iterator.n()).done;){
                            var name = _step.value;
                            var hash = (0, $dtn6l._DJB2)(name);
                            if (allKeys.has(hash)) delete container[hash];
                        }
                    } catch (err) {
                        _iterator.e(err);
                    } finally{
                        _iterator.f();
                    }
                }
                this.applyOverrides(storedOverrides);
            }
        },
        {
            key: "saveOverrides",
            value: function saveOverrides() {
                try {
                    window.localStorage.setItem(this._localStorageKey, JSON.stringify(this._overrides));
                } catch (_unused3) {
                // ignored - window is not defined in non-browser environments, and we don't save things there
                // (things like SSR, etc)
                }
            }
        },
        {
            key: "getOverrides",
            value: function getOverrides() {
                return this.mergeOverrides(this._overrides);
            }
        },
        {
            key: "applyOverrides",
            value: function applyOverrides(overrides) {
                var newOverrides = $1aba1b1eabd89cc6$var$_objectSpread($1aba1b1eabd89cc6$var$_objectSpread({}, $1aba1b1eabd89cc6$var$makeEmptyStore()), overrides);
                this._djb2Map.clear();
                for(var _i6 = 0, _Object$entries4 = Object.entries(newOverrides); _i6 < _Object$entries4.length; _i6++){
                    var _Object$entries4$_i = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_Object$entries4[_i6], 2), containerName = _Object$entries4$_i[0], container = _Object$entries4$_i[1];
                    for(var _i7 = 0, _Object$entries5 = Object.entries(container); _i7 < _Object$entries5.length; _i7++){
                        var _Object$entries5$_i = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_Object$entries5[_i7], 2), name = _Object$entries5$_i[0], value = _Object$entries5$_i[1];
                        this._djb2Map.set($1aba1b1eabd89cc6$var$djb2MapKey((0, $dtn6l._DJB2)(name), containerName), value);
                    }
                }
                this._overrides = newOverrides;
            }
        },
        {
            key: "setOverrides",
            value: function setOverrides(overrides) {
                this.applyOverrides(overrides);
                this.saveOverrides();
            }
        },
        {
            key: "overrideGate",
            value: function overrideGate(name, value) {
                this._overrides.gates[name] = value;
                this._djb2Map.set($1aba1b1eabd89cc6$var$djb2MapKey((0, $dtn6l._DJB2)(name), 'gates'), value);
                this.saveOverrides();
            }
        },
        {
            key: "removeGateOverride",
            value: function removeGateOverride(name) {
                delete this._overrides.gates[name];
                this._djb2Map.delete($1aba1b1eabd89cc6$var$djb2MapKey((0, $dtn6l._DJB2)(name), 'gates'));
                this.saveOverrides();
            }
        },
        {
            key: "getGateOverride",
            value: function getGateOverride(current, _user) {
                var _this$_overrides$gate;
                var overridden = (_this$_overrides$gate = this._overrides.gates[current.name]) !== null && _this$_overrides$gate !== void 0 ? _this$_overrides$gate : this._djb2Map.get($1aba1b1eabd89cc6$var$djb2MapKey(current.name, 'gates'));
                if (overridden == null) return null;
                return $1aba1b1eabd89cc6$var$_objectSpread($1aba1b1eabd89cc6$var$_objectSpread({}, current), {}, {
                    value: overridden,
                    details: $1aba1b1eabd89cc6$var$_objectSpread($1aba1b1eabd89cc6$var$_objectSpread({}, current.details), {}, {
                        reason: $1aba1b1eabd89cc6$var$LOCAL_OVERRIDE_REASON
                    })
                });
            }
        },
        {
            key: "overrideDynamicConfig",
            value: function overrideDynamicConfig(name, value) {
                this._overrides.configs[name] = value;
                this._djb2Map.set($1aba1b1eabd89cc6$var$djb2MapKey((0, $dtn6l._DJB2)(name), 'configs'), value);
                this.saveOverrides();
            }
        },
        {
            key: "removeDynamicConfigOverride",
            value: function removeDynamicConfigOverride(name) {
                delete this._overrides.configs[name];
                this._djb2Map.delete($1aba1b1eabd89cc6$var$djb2MapKey((0, $dtn6l._DJB2)(name), 'configs'));
                this.saveOverrides();
            }
        },
        {
            key: "getDynamicConfigOverride",
            value: function getDynamicConfigOverride(current, _user) {
                return this._getConfigOverride(current, this._overrides.configs);
            }
        },
        {
            key: "overrideExperiment",
            value: function overrideExperiment(name, value) {
                this._overrides.configs[name] = value;
                this._djb2Map.set($1aba1b1eabd89cc6$var$djb2MapKey((0, $dtn6l._DJB2)(name), 'configs'), value);
                this.saveOverrides();
            }
        },
        {
            key: "removeExperimentOverride",
            value: function removeExperimentOverride(name) {
                delete this._overrides.configs[name];
                this._djb2Map.delete($1aba1b1eabd89cc6$var$djb2MapKey((0, $dtn6l._DJB2)(name), 'configs'));
                this.saveOverrides();
            }
        },
        {
            key: "getExperimentOverride",
            value: function getExperimentOverride(current, _user) {
                return this._getConfigOverride(current, this._overrides.configs);
            }
        },
        {
            key: "overrideLayer",
            value: function overrideLayer(name, value) {
                this._overrides.layers[name] = value;
                this._djb2Map.set($1aba1b1eabd89cc6$var$djb2MapKey((0, $dtn6l._DJB2)(name), 'layers'), value);
                this.saveOverrides();
            }
        },
        {
            key: "removeLayerOverride",
            value: function removeLayerOverride(name) {
                delete this._overrides.layers[name];
                this._djb2Map.delete($1aba1b1eabd89cc6$var$djb2MapKey((0, $dtn6l._DJB2)(name), 'layers'));
                this.saveOverrides();
            }
        },
        {
            key: "removeAllOverrides",
            value: function removeAllOverrides() {
                this._overrides = $1aba1b1eabd89cc6$var$makeEmptyStore();
                try {
                    window.localStorage.removeItem(this._localStorageKey);
                } catch (_unused4) {
                // ignored - window is not defined in non-browser environments, and we don't save things there
                // (things like SSR, etc)
                }
            }
        },
        {
            key: "getLayerOverride",
            value: function getLayerOverride(current, _user) {
                var _this$_overrides$laye;
                var overridden = (_this$_overrides$laye = this._overrides.layers[current.name]) !== null && _this$_overrides$laye !== void 0 ? _this$_overrides$laye : this._djb2Map.get($1aba1b1eabd89cc6$var$djb2MapKey(current.name, 'layers'));
                if (overridden == null) return null;
                return $1aba1b1eabd89cc6$var$_objectSpread($1aba1b1eabd89cc6$var$_objectSpread({}, current), {}, {
                    __value: overridden,
                    get: (0, $dtn6l._makeTypedGet)(current.name, overridden),
                    details: $1aba1b1eabd89cc6$var$_objectSpread($1aba1b1eabd89cc6$var$_objectSpread({}, current.details), {}, {
                        reason: $1aba1b1eabd89cc6$var$LOCAL_OVERRIDE_REASON
                    })
                });
            }
        },
        {
            key: "_getConfigOverride",
            value: function _getConfigOverride(current, lookup) {
                var _lookup$current$name;
                var overridden = (_lookup$current$name = lookup[current.name]) !== null && _lookup$current$name !== void 0 ? _lookup$current$name : this._djb2Map.get($1aba1b1eabd89cc6$var$djb2MapKey(current.name, 'configs'));
                if (overridden == null) return null;
                return $1aba1b1eabd89cc6$var$_objectSpread($1aba1b1eabd89cc6$var$_objectSpread({}, current), {}, {
                    value: overridden,
                    get: (0, $dtn6l._makeTypedGet)(current.name, overridden),
                    details: $1aba1b1eabd89cc6$var$_objectSpread($1aba1b1eabd89cc6$var$_objectSpread({}, current.details), {}, {
                        reason: $1aba1b1eabd89cc6$var$LOCAL_OVERRIDE_REASON
                    })
                });
            }
        }
    ]);
}();





var $cbed893bd7829229$var$_excluded = [
    "sdkKey",
    "environment",
    "updateUserCompletionCallback",
    "perimeter"
];
function $cbed893bd7829229$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $cbed893bd7829229$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $cbed893bd7829229$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $cbed893bd7829229$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $cbed893bd7829229$var$DEFAULT_CLIENT_KEY = 'client-default-key';
// default event logging api is Atlassian proxy rather than Statsig's domain, to avoid ad blockers
var $cbed893bd7829229$var$DEFAULT_EVENT_LOGGING_API = 'https://xp.atlassian.com/v1/rgstr';
var $cbed893bd7829229$export$1f2bb630327ac4b6 = /*#__PURE__*/ function() {
    function Client() {
        var _this = this;
        var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, _ref$localStorageKey = _ref.localStorageKey, localStorageKey = _ref$localStorageKey === void 0 ? (0, $1aba1b1eabd89cc6$export$d8474cff104280f3) : _ref$localStorageKey, overrideAdapter = _ref.overrideAdapter;
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, Client);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "initPromise", null);
        /** True if an initialize method was called and completed successfully. */ (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "initCompleted", false);
        /**
     * True if an initialize method was called and completed, meaning the client is now usable.
     * However if there was an error during initialization it may have initialized with default
     * values. Use {@link initCompleted} to check for this.
     */ (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "initWithDefaults", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "hasCheckGateErrorOccurred", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "hasGetExperimentErrorOccurred", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "hasGetExperimentValueErrorOccurred", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "hasGetLayerErrorOccurred", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "hasGetLayerValueErrorOccurred", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "subscriptions", new (0, $8e14ff35252fa9f0$export$2e2bcd8739ae039)());
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "dataAdapter", new (0, $0c612007e59d374a$export$55fffef3474104af)());
        /**
     * Call this if modifying the values being served by the Statsig library since it has its own
     * memoization cache which will not be updated if the values are changed outside of the library.
     */ (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "statsigValuesUpdated", function() {
            if (_this.user) // Trigger a reset of the memoize cache
            _this.statsigClient.updateUserSync(_this.user, {
                disableBackgroundCacheRefresh: true
            });
            _this.subscriptions.anyUpdated();
        });
        this.overrideAdapter = overrideAdapter || new (0, $1aba1b1eabd89cc6$export$bcb28fbac1def494)(localStorageKey);
    }
    /**
   * @description
   * This method initializes the client using a network call to fetch the bootstrap values.
   * If the client is inialized with an `analyticsWebClient`, it will send an operational event
   * to GASv3 with the following attributes:
   * - targetApp: the target app of the client
   * - clientVersion: the version of the client
   * - success: whether the initialization was successful
   * - startTime: the time when the initialization started
   * - totalTime: the total time it took to initialize the client
   * - apiKey: the api key used to initialize the client
   * @param clientOptions {ClientOptions}
   * @param identifiers {Identifiers}
   * @param customAttributes {CustomAttributes}
   * @returns {Promise<void>}
   */ return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(Client, [
        {
            key: "initialize",
            value: function() {
                var _initialize = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee(clientOptions, identifiers, customAttributes) {
                    var _this2 = this;
                    var clientOptionsWithDefaults, startTime;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee$(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                clientOptionsWithDefaults = (0, $035fce1ed950fa3a$export$d119b37e5f788b43)(clientOptions);
                                if (!this.initPromise) {
                                    _context.next = 4;
                                    break;
                                }
                                if (!(0, $035fce1ed950fa3a$export$fa1c2bbf4100b8bc)(clientOptionsWithDefaults, this.initOptions)) // eslint-disable-next-line no-console
                                console.warn('Feature Gates client already initialized with different options. New options were not applied.');
                                return _context.abrupt("return", this.initPromise);
                            case 4:
                                startTime = performance.now();
                                this.initOptions = clientOptionsWithDefaults;
                                this.initPromise = this.init(clientOptionsWithDefaults, identifiers, customAttributes).then(function() {
                                    _this2.initCompleted = true;
                                    _this2.initWithDefaults = true;
                                }).finally(function() {
                                    var endTime = performance.now();
                                    var totalTime = endTime - startTime;
                                    _this2.fireClientEvent(startTime, totalTime, 'initialize', _this2.initCompleted, clientOptionsWithDefaults.apiKey);
                                });
                                return _context.abrupt("return", this.initPromise);
                            case 8:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee, this);
                }));
                function initialize(_x, _x2, _x3) {
                    return _initialize.apply(this, arguments);
                }
                return initialize;
            }()
        },
        {
            key: "initializeWithProvider",
            value: function() {
                var _initializeWithProvider = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee2(clientOptions, provider, identifiers, customAttributes) {
                    var _this3 = this;
                    var clientOptionsWithDefaults, startTime;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee2$(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                clientOptionsWithDefaults = (0, $035fce1ed950fa3a$export$d119b37e5f788b43)(clientOptions);
                                if (!this.initPromise) {
                                    _context2.next = 4;
                                    break;
                                }
                                if (!(0, $035fce1ed950fa3a$export$fa1c2bbf4100b8bc)(clientOptionsWithDefaults, this.initOptions)) // eslint-disable-next-line no-console
                                console.warn('Feature Gates client already initialized with different options. New options were not applied.');
                                return _context2.abrupt("return", this.initPromise);
                            case 4:
                                startTime = performance.now();
                                this.initOptions = clientOptionsWithDefaults;
                                this.provider = provider;
                                this.provider.setClientVersion((0, $51bb5732914b7a49$export$a59f8d67326bd1cb));
                                if (this.provider.setApplyUpdateCallback) this.provider.setApplyUpdateCallback(this.applyUpdateCallback.bind(this));
                                this.initPromise = this.initWithProvider(clientOptionsWithDefaults, provider, identifiers, customAttributes).then(function() {
                                    _this3.initCompleted = true;
                                    _this3.initWithDefaults = true;
                                }).finally(function() {
                                    var endTime = performance.now();
                                    var totalTime = endTime - startTime;
                                    _this3.fireClientEvent(startTime, totalTime, 'initializeWithProvider', _this3.initCompleted, provider.getApiKey ? provider.getApiKey() : undefined);
                                });
                                return _context2.abrupt("return", this.initPromise);
                            case 11:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2, this);
                }));
                function initializeWithProvider(_x4, _x5, _x6, _x7) {
                    return _initializeWithProvider.apply(this, arguments);
                }
                return initializeWithProvider;
            }()
        },
        {
            key: "applyUpdateCallback",
            value: function applyUpdateCallback(experimentsResult) {
                try {
                    if (this.initCompleted || this.initWithDefaults) {
                        this.assertInitialized(this.statsigClient);
                        this.dataAdapter.setBootstrapData(experimentsResult.experimentValues);
                        this.dataAdapter.setData(JSON.stringify(experimentsResult.experimentValues));
                        this.statsigValuesUpdated();
                    }
                } catch (error) {
                    // eslint-disable-next-line no-console
                    console.warn('Error when attempting to apply update', error);
                }
            }
        },
        {
            key: "fireClientEvent",
            value: function fireClientEvent(startTime, totalTime, action, success) {
                var _analyticsWebClient, _this4 = this;
                var apiKey = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
                (_analyticsWebClient = this.initOptions.analyticsWebClient) === null || _analyticsWebClient === void 0 || _analyticsWebClient.then(function(analyticsWebClient) {
                    var attributes = $cbed893bd7829229$var$_objectSpread({
                        targetApp: _this4.initOptions.targetApp,
                        clientVersion: (0, $51bb5732914b7a49$export$a59f8d67326bd1cb),
                        success: success,
                        startTime: startTime,
                        totalTime: totalTime
                    }, apiKey && {
                        apiKey: apiKey
                    });
                    analyticsWebClient.sendOperationalEvent({
                        action: action,
                        actionSubject: 'featureGatesClient',
                        attributes: attributes,
                        tags: [
                            'measurement'
                        ],
                        source: '@atlaskit/feature-gate-js-client'
                    });
                }).catch(function(err) {
                    if (_this4.initOptions.environment !== (0, $9cc743b88fc2afa4$export$479e7351a733299).Production) // eslint-disable-next-line no-console
                    console.error('Analytics web client promise did not resolve', err);
                });
            }
        },
        {
            key: "initializeFromValues",
            value: function() {
                var _initializeFromValues = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee3(clientOptions, identifiers, customAttributes) {
                    var _this5 = this;
                    var initializeValues, clientOptionsWithDefaults, startTime, _args3 = arguments;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee3$(_context3) {
                        while(true)switch(_context3.prev = _context3.next){
                            case 0:
                                initializeValues = _args3.length > 3 && _args3[3] !== undefined ? _args3[3] : {};
                                clientOptionsWithDefaults = (0, $035fce1ed950fa3a$export$d119b37e5f788b43)(clientOptions);
                                if (!this.initPromise) {
                                    _context3.next = 5;
                                    break;
                                }
                                if (!(0, $035fce1ed950fa3a$export$fa1c2bbf4100b8bc)(clientOptionsWithDefaults, this.initOptions)) // eslint-disable-next-line no-console
                                console.warn('Feature Gates client already initialized with different options. New options were not applied.');
                                return _context3.abrupt("return", this.initPromise);
                            case 5:
                                // This makes sure the new Statsig client behaves like the old when bootstrap data is
                                // passed, and `has_updates` isn't specified (which happens a lot in product integration tests).
                                if (!Object.prototype.hasOwnProperty.call(initializeValues, 'has_updates')) initializeValues['has_updates'] = true;
                                startTime = performance.now();
                                this.initOptions = clientOptionsWithDefaults;
                                this.initPromise = this.initFromValues(clientOptionsWithDefaults, identifiers, customAttributes, initializeValues).then(function() {
                                    _this5.initCompleted = true;
                                    _this5.initWithDefaults = true;
                                }).finally(function() {
                                    var endTime = performance.now();
                                    var totalTime = endTime - startTime;
                                    _this5.fireClientEvent(startTime, totalTime, 'initializeFromValues', _this5.initCompleted);
                                });
                                return _context3.abrupt("return", this.initPromise);
                            case 10:
                            case "end":
                                return _context3.stop();
                        }
                    }, _callee3, this);
                }));
                function initializeFromValues(_x8, _x9, _x0) {
                    return _initializeFromValues.apply(this, arguments);
                }
                return initializeFromValues;
            }()
        },
        {
            key: "assertInitialized",
            value: function assertInitialized(statsigClient) {
                if (!statsigClient) throw new Error('Client must be initialized before using this method');
            }
        },
        {
            key: "updateUser",
            value: function() {
                var _updateUser = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee4(fetchOptions, identifiers, customAttributes) {
                    var fetchOptionsWithDefaults, initializeValuesProducer;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee4$(_context4) {
                        while(true)switch(_context4.prev = _context4.next){
                            case 0:
                                this.assertInitialized(this.statsigClient);
                                fetchOptionsWithDefaults = (0, $035fce1ed950fa3a$export$d119b37e5f788b43)(fetchOptions);
                                initializeValuesProducer = function initializeValuesProducer() {
                                    return (0, $ef06eed36f62c0a5$export$2e2bcd8739ae039).fetchExperimentValues(fetchOptionsWithDefaults, identifiers, customAttributes).then(function(_ref2) {
                                        var experimentValues = _ref2.experimentValues, customAttributes = _ref2.customAttributes;
                                        return {
                                            experimentValues: experimentValues,
                                            customAttributesFromFetch: customAttributes
                                        };
                                    });
                                };
                                _context4.next = 5;
                                return this.updateUserUsingInitializeValuesProducer(initializeValuesProducer, identifiers, customAttributes);
                            case 5:
                            case "end":
                                return _context4.stop();
                        }
                    }, _callee4, this);
                }));
                function updateUser(_x1, _x10, _x11) {
                    return _updateUser.apply(this, arguments);
                }
                return updateUser;
            }()
        },
        {
            key: "updateUserWithProvider",
            value: function() {
                var _updateUserWithProvider = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee5(identifiers, customAttributes) {
                    var _this6 = this;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee5$(_context5) {
                        while(true)switch(_context5.prev = _context5.next){
                            case 0:
                                this.assertInitialized(this.statsigClient);
                                if (this.provider) {
                                    _context5.next = 3;
                                    break;
                                }
                                throw new Error('Cannot update user using provider as the client was not initialised with a provider');
                            case 3:
                                _context5.next = 5;
                                return this.provider.setProfile(this.initOptions, identifiers, customAttributes);
                            case 5:
                                _context5.next = 7;
                                return this.updateUserUsingInitializeValuesProducer(function() {
                                    return _this6.provider.getExperimentValues();
                                }, identifiers, customAttributes);
                            case 7:
                            case "end":
                                return _context5.stop();
                        }
                    }, _callee5, this);
                }));
                function updateUserWithProvider(_x12, _x13) {
                    return _updateUserWithProvider.apply(this, arguments);
                }
                return updateUserWithProvider;
            }()
        },
        {
            key: "updateUserWithValues",
            value: function() {
                var _updateUserWithValues = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee6(identifiers, customAttributes) {
                    var initializeValues, initializeValuesProducer, _args6 = arguments;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee6$(_context6) {
                        while(true)switch(_context6.prev = _context6.next){
                            case 0:
                                initializeValues = _args6.length > 2 && _args6[2] !== undefined ? _args6[2] : {};
                                this.assertInitialized(this.statsigClient);
                                initializeValuesProducer = function initializeValuesProducer() {
                                    return Promise.resolve({
                                        experimentValues: initializeValues,
                                        customAttributesFromFetch: customAttributes
                                    });
                                };
                                _context6.next = 5;
                                return this.updateUserUsingInitializeValuesProducer(initializeValuesProducer, identifiers, customAttributes);
                            case 5:
                            case "end":
                                return _context6.stop();
                        }
                    }, _callee6, this);
                }));
                function updateUserWithValues(_x14, _x15) {
                    return _updateUserWithValues.apply(this, arguments);
                }
                return updateUserWithValues;
            }()
        },
        {
            key: "initializeCalled",
            value: function initializeCalled() {
                return this.initPromise != null;
            }
        },
        {
            key: "initializeCompleted",
            value: function initializeCompleted() {
                return this.initCompleted;
            }
        },
        {
            key: "waitUntilInitializeCompleted",
            value: function() {
                var _waitUntilInitializeCompleted = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee7() {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee7$(_context7) {
                        while(true)switch(_context7.prev = _context7.next){
                            case 0:
                                if (this.initPromise) {
                                    _context7.next = 2;
                                    break;
                                }
                                throw new Error('The client must be initialized before you can wait until initialized.');
                            case 2:
                                if (!this.initCompleted) {
                                    _context7.next = 4;
                                    break;
                                }
                                return _context7.abrupt("return");
                            case 4:
                                _context7.next = 6;
                                return this.initPromise;
                            case 6:
                            case "end":
                                return _context7.stop();
                        }
                    }, _callee7, this);
                }));
                function waitUntilInitializeCompleted() {
                    return _waitUntilInitializeCompleted.apply(this, arguments);
                }
                return waitUntilInitializeCompleted;
            }()
        },
        {
            key: "checkGate",
            value: function checkGate(gateName) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                try {
                    this.assertInitialized(this.statsigClient);
                    var _options$fireGateExpo = options.fireGateExposure, fireGateExposure = _options$fireGateExpo === void 0 ? true : _options$fireGateExpo;
                    return this.statsigClient.checkGate(gateName, {
                        disableExposureLog: !fireGateExposure
                    });
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!this.hasCheckGateErrorOccurred) {
                        // eslint-disable-next-line no-console
                        console.warn({
                            msg: 'An error has occurred checking the feature gate. Only the first occurrence of this error is logged.',
                            gateName: gateName,
                            error: error
                        });
                        this.hasCheckGateErrorOccurred = true;
                    }
                    return false;
                }
            }
        },
        {
            key: "isGateExist",
            value: function isGateExist(gateName) {
                try {
                    this.assertInitialized(this.statsigClient);
                    var gate = this.statsigClient.getFeatureGate(gateName, {
                        disableExposureLog: true
                    });
                    return !gate.details.reason.includes('Unrecognized');
                } catch (error) {
                    // eslint-disable-next-line no-console
                    console.error("Error occurred when trying to check FeatureGate: ".concat(error));
                    // in case of error report true to avoid false positives.
                    return true;
                }
            }
        },
        {
            key: "isExperimentExist",
            value: function isExperimentExist(experimentName) {
                try {
                    this.assertInitialized(this.statsigClient);
                    var config = this.statsigClient.getExperiment(experimentName, {
                        disableExposureLog: true
                    });
                    return !config.details.reason.includes('Unrecognized');
                } catch (error) {
                    // eslint-disable-next-line no-console
                    console.error("Error occurred when trying to check Experiment: ".concat(error));
                    // in case of error report true to avoid false positives.
                    return true;
                }
            }
        },
        {
            key: "manuallyLogGateExposure",
            value: function manuallyLogGateExposure(gateName) {
                this.assertInitialized(this.statsigClient);
                // This is the approach recommended in the docs
                // https://docs.statsig.com/client/javascript-sdk/#manual-exposures-
                this.statsigClient.checkGate(gateName);
            }
        },
        {
            key: "getExperiment",
            value: function getExperiment(experimentName) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                try {
                    this.assertInitialized(this.statsigClient);
                    var _options$fireExperime = options.fireExperimentExposure, fireExperimentExposure = _options$fireExperime === void 0 ? true : _options$fireExperime;
                    return (0, $31e4b2b84c540613$export$6dc24881a3d96325).fromExperiment(this.statsigClient.getExperiment(experimentName, {
                        disableExposureLog: !fireExperimentExposure
                    }));
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!this.hasGetExperimentErrorOccurred) {
                        // eslint-disable-next-line no-console
                        console.warn({
                            msg: 'An error has occurred getting the experiment. Only the first occurrence of this error is logged.',
                            experimentName: experimentName,
                            error: error
                        });
                        this.hasGetExperimentErrorOccurred = true;
                    }
                    // Return a default value
                    return new (0, $31e4b2b84c540613$export$6dc24881a3d96325)(experimentName, {}, '', {
                        time: Date.now(),
                        reason: (0, $efb69d3109c59e7b$export$c62558b199e46828).Error
                    });
                }
            }
        },
        {
            key: "getExperimentValue",
            value: function getExperimentValue(experimentName, parameterName, defaultValue) {
                var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var experiment = this.getExperiment(experimentName, options);
                try {
                    var typeGuard = options.typeGuard;
                    return experiment.get(parameterName, defaultValue, typeGuard);
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!this.hasGetExperimentValueErrorOccurred) {
                        // eslint-disable-next-line no-console
                        console.warn({
                            msg: 'An error has occurred getting the experiment value. Only the first occurrence of this error is logged.',
                            experimentName: experimentName,
                            defaultValue: defaultValue,
                            options: options,
                            error: error
                        });
                        this.hasGetExperimentValueErrorOccurred = true;
                    }
                    return defaultValue;
                }
            }
        },
        {
            key: "manuallyLogExperimentExposure",
            value: function manuallyLogExperimentExposure(experimentName) {
                this.assertInitialized(this.statsigClient);
                // This is the approach recommended in the docs
                // https://docs.statsig.com/client/javascript-sdk/#manual-exposures-
                this.statsigClient.getExperiment(experimentName);
            }
        },
        {
            key: "manuallyLogLayerExposure",
            value: function manuallyLogLayerExposure(layerName, parameterName) {
                var _this$statsigClient$g;
                this.assertInitialized(this.statsigClient);
                // This is the approach recommended in the docs
                // https://docs.statsig.com/client/javascript-sdk/#manual-exposures-
                (_this$statsigClient$g = this.statsigClient.getLayer(layerName)) === null || _this$statsigClient$g === void 0 || _this$statsigClient$g.get(parameterName);
            }
        },
        {
            key: "shutdownStatsig",
            value: function shutdownStatsig() {
                this.assertInitialized(this.statsigClient);
                this.statsigClient.shutdown();
            }
        },
        {
            key: "overrideGate",
            value: function overrideGate(gateName, value) {
                this.overrideAdapter.overrideGate(gateName, value);
                // Trigger a reset of the memoized gate value
                if (this.user) {
                    var _this$statsigClient;
                    (_this$statsigClient = this.statsigClient) === null || _this$statsigClient === void 0 || _this$statsigClient.updateUserSync(this.user, {
                        disableBackgroundCacheRefresh: true
                    });
                }
                this.statsigValuesUpdated();
            }
        },
        {
            key: "clearGateOverride",
            value: function clearGateOverride(gateName) {
                this.overrideAdapter.removeGateOverride(gateName);
                this.statsigValuesUpdated();
            }
        },
        {
            key: "overrideConfig",
            value: function overrideConfig(experimentName, values) {
                this.overrideAdapter.overrideDynamicConfig(experimentName, values);
                this.statsigValuesUpdated();
            }
        },
        {
            key: "clearConfigOverride",
            value: function clearConfigOverride(experimentName) {
                this.overrideAdapter.removeDynamicConfigOverride(experimentName);
                this.statsigValuesUpdated();
            }
        },
        {
            key: "setOverrides",
            value: function setOverrides(overrides) {
                this.overrideAdapter.setOverrides(overrides);
                this.statsigValuesUpdated();
            }
        },
        {
            key: "getOverrides",
            value: function getOverrides() {
                return this.overrideAdapter.getOverrides();
            }
        },
        {
            key: "clearAllOverrides",
            value: function clearAllOverrides() {
                this.overrideAdapter.removeAllOverrides();
                this.statsigValuesUpdated();
            }
        },
        {
            key: "isCurrentUser",
            value: function isCurrentUser(identifiers, customAttributes) {
                return (0, $035fce1ed950fa3a$export$fa1c2bbf4100b8bc)(this.currentIdentifiers, identifiers) && (0, $035fce1ed950fa3a$export$fa1c2bbf4100b8bc)(this.currentAttributes, customAttributes);
            }
        },
        {
            key: "onGateUpdated",
            value: function onGateUpdated(gateName, callback) {
                var _this7 = this;
                var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var wrapCallback = function wrapCallback(value) {
                    var _options$fireGateExpo2 = options.fireGateExposure, fireGateExposure = _options$fireGateExpo2 === void 0 ? true : _options$fireGateExpo2;
                    if (fireGateExposure) _this7.manuallyLogGateExposure(gateName);
                    try {
                        callback(value);
                    } catch (error) {
                        // eslint-disable-next-line no-console
                        console.warn("Error calling callback for gate ".concat(gateName, " with value ").concat(value), error);
                    }
                };
                return this.subscriptions.onGateUpdated(gateName, wrapCallback, this.checkGate.bind(this), options);
            }
        },
        {
            key: "onExperimentValueUpdated",
            value: function onExperimentValueUpdated(experimentName, parameterName, defaultValue, callback) {
                var _this8 = this;
                var options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
                var wrapCallback = function wrapCallback(value) {
                    var _options$fireExperime2 = options.fireExperimentExposure, fireExperimentExposure = _options$fireExperime2 === void 0 ? true : _options$fireExperime2;
                    if (fireExperimentExposure) _this8.manuallyLogExperimentExposure(experimentName);
                    try {
                        callback(value);
                    } catch (error) {
                        // eslint-disable-next-line no-console
                        console.warn("Error calling callback for experiment ".concat(experimentName, " with value ").concat(value), error);
                    }
                };
                return this.subscriptions.onExperimentValueUpdated(experimentName, parameterName, defaultValue, wrapCallback, this.getExperimentValue.bind(this), options);
            }
        },
        {
            key: "onAnyUpdated",
            value: function onAnyUpdated(callback) {
                return this.subscriptions.onAnyUpdated(callback);
            }
        },
        {
            key: "init",
            value: function() {
                var _init = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee8(clientOptions, identifiers, customAttributes) {
                    var fromValuesClientOptions, experimentValues, customAttributesFromResult, clientSdkKeyPromise, experimentValuesPromise, _yield$Promise$all, _yield$Promise$all2, experimentValuesResult;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee8$(_context8) {
                        while(true)switch(_context8.prev = _context8.next){
                            case 0:
                                fromValuesClientOptions = $cbed893bd7829229$var$_objectSpread({}, clientOptions);
                                _context8.prev = 1;
                                // If client sdk key fetch fails, an error would be thrown and handled instead of waiting for
                                // the experiment values request to be settled, and it will fall back to use default values.
                                clientSdkKeyPromise = (0, $ef06eed36f62c0a5$export$2e2bcd8739ae039).fetchClientSdk(clientOptions).then(function(value) {
                                    return fromValuesClientOptions.sdkKey = value.clientSdkKey;
                                });
                                experimentValuesPromise = (0, $ef06eed36f62c0a5$export$2e2bcd8739ae039).fetchExperimentValues(clientOptions, identifiers, customAttributes); // Only wait for the experiment values request to finish and try to initialise the client
                                // with experiment values if both requests are successful. Else an error would be thrown and
                                // handled by the catch
                                _context8.next = 6;
                                return Promise.all([
                                    clientSdkKeyPromise,
                                    experimentValuesPromise
                                ]);
                            case 6:
                                _yield$Promise$all = _context8.sent;
                                _yield$Promise$all2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_yield$Promise$all, 2);
                                experimentValuesResult = _yield$Promise$all2[1];
                                experimentValues = experimentValuesResult.experimentValues;
                                customAttributesFromResult = experimentValuesResult.customAttributes;
                                _context8.next = 20;
                                break;
                            case 13:
                                _context8.prev = 13;
                                _context8.t0 = _context8["catch"](1);
                                if (_context8.t0 instanceof Error) // eslint-disable-next-line no-console
                                console.error("Error occurred when trying to fetch the Feature Gates client values, error: ".concat(_context8.t0 === null || _context8.t0 === void 0 ? void 0 : _context8.t0.message));
                                // eslint-disable-next-line no-console
                                console.warn("Initialising Statsig client without values");
                                _context8.next = 19;
                                return this.initFromValues(fromValuesClientOptions, identifiers, customAttributes);
                            case 19:
                                throw _context8.t0;
                            case 20:
                                return _context8.abrupt("return", this.initFromValues(fromValuesClientOptions, identifiers, customAttributesFromResult, experimentValues));
                            case 21:
                            case "end":
                                return _context8.stop();
                        }
                    }, _callee8, this, [
                        [
                            1,
                            13
                        ]
                    ]);
                }));
                function init(_x16, _x17, _x18) {
                    return _init.apply(this, arguments);
                }
                return init;
            }()
        },
        {
            key: "initWithProvider",
            value: function() {
                var _initWithProvider = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee9(baseClientOptions, provider, identifiers, customAttributes) {
                    var fromValuesClientOptions, experimentValues, customAttributesFromResult, clientSdkKeyPromise, experimentValuesPromise, _yield$Promise$all3, _yield$Promise$all4, experimentValuesResult;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee9$(_context9) {
                        while(true)switch(_context9.prev = _context9.next){
                            case 0:
                                fromValuesClientOptions = $cbed893bd7829229$var$_objectSpread($cbed893bd7829229$var$_objectSpread({}, baseClientOptions), {}, {
                                    disableCurrentPageLogging: true
                                });
                                _context9.prev = 1;
                                _context9.next = 4;
                                return provider.setProfile(baseClientOptions, identifiers, customAttributes);
                            case 4:
                                // If client sdk key fetch fails, an error would be thrown and handled instead of waiting for
                                // the experiment values request to be settled, and it will fall back to use default values.
                                clientSdkKeyPromise = provider.getClientSdkKey().then(function(value) {
                                    return fromValuesClientOptions.sdkKey = value;
                                });
                                experimentValuesPromise = provider.getExperimentValues(); // Only wait for the experiment values request to finish and try to initialise the client
                                // with experiment values if both requests are successful. Else an error would be thrown and
                                // handled by the catch
                                _context9.next = 8;
                                return Promise.all([
                                    clientSdkKeyPromise,
                                    experimentValuesPromise
                                ]);
                            case 8:
                                _yield$Promise$all3 = _context9.sent;
                                _yield$Promise$all4 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_yield$Promise$all3, 2);
                                experimentValuesResult = _yield$Promise$all4[1];
                                experimentValues = experimentValuesResult.experimentValues;
                                customAttributesFromResult = experimentValuesResult.customAttributesFromFetch;
                                _context9.next = 22;
                                break;
                            case 15:
                                _context9.prev = 15;
                                _context9.t0 = _context9["catch"](1);
                                if (_context9.t0 instanceof Error) // eslint-disable-next-line no-console
                                console.error("Error occurred when trying to fetch the Feature Gates client values, error: ".concat(_context9.t0 === null || _context9.t0 === void 0 ? void 0 : _context9.t0.message));
                                // eslint-disable-next-line no-console
                                console.warn("Initialising Statsig client without values");
                                _context9.next = 21;
                                return this.initFromValues(fromValuesClientOptions, identifiers, customAttributes);
                            case 21:
                                throw _context9.t0;
                            case 22:
                                return _context9.abrupt("return", this.initFromValues(fromValuesClientOptions, identifiers, customAttributesFromResult, experimentValues));
                            case 23:
                            case "end":
                                return _context9.stop();
                        }
                    }, _callee9, this, [
                        [
                            1,
                            15
                        ]
                    ]);
                }));
                function initWithProvider(_x19, _x20, _x21, _x22) {
                    return _initWithProvider.apply(this, arguments);
                }
                return initWithProvider;
            }()
        },
        {
            key: "initFromValues",
            value: function() {
                var _initFromValues = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee0(clientOptions, identifiers, customAttributes) {
                    var _newClientOptions$net;
                    var initializeValues, newClientOptions, sdkKey, environment, _updateUserCompletionCallback, _perimeter, restClientOptions, statsigOptions, _args0 = arguments;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee0$(_context0) {
                        while(true)switch(_context0.prev = _context0.next){
                            case 0:
                                initializeValues = _args0.length > 3 && _args0[3] !== undefined ? _args0[3] : {};
                                this.overrideAdapter.initFromStoredOverrides();
                                this.currentIdentifiers = identifiers;
                                this.currentAttributes = customAttributes;
                                newClientOptions = (0, $035fce1ed950fa3a$export$202946b690d26d22)(clientOptions);
                                if (!newClientOptions.sdkKey) newClientOptions.sdkKey = $cbed893bd7829229$var$DEFAULT_CLIENT_KEY;
                                if (!((_newClientOptions$net = newClientOptions.networkConfig) !== null && _newClientOptions$net !== void 0 && _newClientOptions$net.logEventUrl)) newClientOptions.networkConfig = $cbed893bd7829229$var$_objectSpread($cbed893bd7829229$var$_objectSpread({}, newClientOptions.networkConfig), {}, {
                                    logEventUrl: $cbed893bd7829229$var$DEFAULT_EVENT_LOGGING_API
                                });
                                if (newClientOptions.perimeter === (0, $9cc743b88fc2afa4$export$c42b7bbc5e7ba555).FEDRAMP_MODERATE) // disable all logging in FedRAMP to prevent egress of sensitive data
                                newClientOptions.disableLogging = true;
                                sdkKey = newClientOptions.sdkKey, environment = newClientOptions.environment, _updateUserCompletionCallback = newClientOptions.updateUserCompletionCallback, _perimeter = newClientOptions.perimeter, restClientOptions = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(newClientOptions, $cbed893bd7829229$var$_excluded);
                                this.user = (0, $035fce1ed950fa3a$export$3dad1db244472f32)(identifiers, customAttributes);
                                statsigOptions = $cbed893bd7829229$var$_objectSpread($cbed893bd7829229$var$_objectSpread({}, restClientOptions), {}, {
                                    environment: {
                                        tier: environment
                                    },
                                    includeCurrentPageUrlWithEvents: false,
                                    dataAdapter: this.dataAdapter,
                                    overrideAdapter: this.overrideAdapter,
                                    logEventCompressionMode: (0, $iFR7a.LogEventCompressionMode).Forced
                                }); // Statsig validates the provided stableId against their own cookie, so we either need
                                // to update the cookie to match, or disable the validation completely.
                                if (identifiers.stableId) (0, $iFR7a.StableID).setOverride(identifiers.stableId, sdkKey);
                                else statsigOptions.disableStableID = true;
                                _context0.prev = 12;
                                this.statsigClient = new (0, $iFR7a.StatsigClient)(sdkKey, this.user, statsigOptions);
                                this.dataAdapter.setBootstrapData(initializeValues);
                                _context0.next = 17;
                                return this.statsigClient.initializeAsync();
                            case 17:
                                _context0.next = 29;
                                break;
                            case 19:
                                _context0.prev = 19;
                                _context0.t0 = _context0["catch"](12);
                                if (_context0.t0 instanceof Error) // eslint-disable-next-line no-console
                                console.error("Error occurred when trying to initialise the Statsig client, error: ".concat(_context0.t0 === null || _context0.t0 === void 0 ? void 0 : _context0.t0.message));
                                // eslint-disable-next-line no-console
                                console.warn("Initialising Statsig client with default sdk key and without values");
                                this.statsigClient = new (0, $iFR7a.StatsigClient)($cbed893bd7829229$var$DEFAULT_CLIENT_KEY, this.user, statsigOptions);
                                this.dataAdapter.setBootstrapData();
                                _context0.next = 27;
                                return this.statsigClient.initializeAsync();
                            case 27:
                                this.initWithDefaults = true;
                                throw _context0.t0;
                            case 29:
                            case "end":
                                return _context0.stop();
                        }
                    }, _callee0, this, [
                        [
                            12,
                            19
                        ]
                    ]);
                }));
                function initFromValues(_x23, _x24, _x25) {
                    return _initFromValues.apply(this, arguments);
                }
                return initFromValues;
            }()
        },
        {
            key: "updateUserUsingInitializeValuesProducer",
            value: function() {
                var _updateUserUsingInitializeValuesProducer = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee10(getInitializeValues, identifiers, customAttributes) {
                    var _this9 = this;
                    var originalInitPromise, initializeValuesPromise, updateUserPromise;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee10$(_context10) {
                        while(true)switch(_context10.prev = _context10.next){
                            case 0:
                                this.assertInitialized(this.statsigClient);
                                if (this.initPromise) {
                                    _context10.next = 3;
                                    break;
                                }
                                throw new Error('The client must be initialized before you can update the user.');
                            case 3:
                                if (!this.isCurrentUser(identifiers, customAttributes)) {
                                    _context10.next = 5;
                                    break;
                                }
                                return _context10.abrupt("return", this.initPromise);
                            case 5:
                                // Wait for the current initialize/update to finish
                                originalInitPromise = this.initPromise;
                                _context10.prev = 6;
                                _context10.next = 9;
                                return this.initPromise;
                            case 9:
                                _context10.next = 13;
                                break;
                            case 11:
                                _context10.prev = 11;
                                _context10.t0 = _context10["catch"](6);
                            case 13:
                                initializeValuesPromise = getInitializeValues();
                                updateUserPromise = this.updateStatsigClientUser(initializeValuesPromise, identifiers, customAttributes); // We replace the init promise here since we are essentially re-initializing the client at this
                                // point. Any subsequent calls to await client.initialize() or client.updateUser()
                                // will now also await this user update.
                                this.initPromise = updateUserPromise.catch(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee1() {
                                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee1$(_context1) {
                                        while(true)switch(_context1.prev = _context1.next){
                                            case 0:
                                                // If the update failed then it changed nothing, so revert back to the original promise.
                                                _this9.initPromise = originalInitPromise;
                                                // Set the user profile again to revert back to the current user
                                                if (!_this9.provider) {
                                                    _context1.next = 4;
                                                    break;
                                                }
                                                _context1.next = 4;
                                                return _this9.provider.setProfile(_this9.initOptions, _this9.currentIdentifiers, _this9.currentAttributes);
                                            case 4:
                                            case "end":
                                                return _context1.stop();
                                        }
                                    }, _callee1);
                                })));
                                return _context10.abrupt("return", updateUserPromise);
                            case 17:
                            case "end":
                                return _context10.stop();
                        }
                    }, _callee10, this, [
                        [
                            6,
                            11
                        ]
                    ]);
                }));
                function updateUserUsingInitializeValuesProducer(_x26, _x27, _x28) {
                    return _updateUserUsingInitializeValuesProducer.apply(this, arguments);
                }
                return updateUserUsingInitializeValuesProducer;
            }()
        },
        {
            key: "updateStatsigClientUser",
            value: function() {
                var _updateStatsigClientUser = (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee11(initializeValuesPromise, identifiers, customAttributes) {
                    var _this$initOptions, _this$initOptions$upd;
                    var initializeValues, user, _updateUserCompletion, _ref4, errMsg, success, errorMessage;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee11$(_context11) {
                        while(true)switch(_context11.prev = _context11.next){
                            case 0:
                                this.assertInitialized(this.statsigClient);
                                _context11.prev = 1;
                                _context11.next = 4;
                                return initializeValuesPromise;
                            case 4:
                                initializeValues = _context11.sent;
                                user = (0, $035fce1ed950fa3a$export$3dad1db244472f32)(identifiers, initializeValues.customAttributesFromFetch);
                                _context11.next = 13;
                                break;
                            case 8:
                                _context11.prev = 8;
                                _context11.t0 = _context11["catch"](1);
                                // Make sure the updateUserCompletionCallback is called for any errors in our custom code.
                                // This is not necessary for the updateUserWithValues call, because the Statsig client will
                                // already invoke the callback itself.
                                errMsg = _context11.t0 instanceof Error ? _context11.t0.message : JSON.stringify(_context11.t0);
                                (_updateUserCompletion = (_ref4 = this.initOptions).updateUserCompletionCallback) === null || _updateUserCompletion === void 0 || _updateUserCompletion.call(_ref4, false, errMsg);
                                throw _context11.t0;
                            case 13:
                                success = true;
                                errorMessage = null;
                                _context11.prev = 15;
                                this.dataAdapter.setBootstrapData(initializeValues.experimentValues);
                                this.user = user;
                                if (!this.user) {
                                    _context11.next = 21;
                                    break;
                                }
                                _context11.next = 21;
                                return this.statsigClient.updateUserAsync(this.user);
                            case 21:
                                _context11.next = 27;
                                break;
                            case 23:
                                _context11.prev = 23;
                                _context11.t1 = _context11["catch"](15);
                                success = false;
                                errorMessage = String(_context11.t1);
                            case 27:
                                (_this$initOptions = this.initOptions) === null || _this$initOptions === void 0 || (_this$initOptions$upd = _this$initOptions.updateUserCompletionCallback) === null || _this$initOptions$upd === void 0 || _this$initOptions$upd.call(_this$initOptions, success, errorMessage);
                                if (!success) {
                                    _context11.next = 34;
                                    break;
                                }
                                this.currentIdentifiers = identifiers;
                                this.currentAttributes = customAttributes;
                                this.subscriptions.anyUpdated();
                                _context11.next = 35;
                                break;
                            case 34:
                                throw new Error('Failed to update user. An unexpected error occured.');
                            case 35:
                            case "end":
                                return _context11.stop();
                        }
                    }, _callee11, this, [
                        [
                            1,
                            8
                        ],
                        [
                            15,
                            23
                        ]
                    ]);
                }));
                function updateStatsigClientUser(_x29, _x30, _x31) {
                    return _updateStatsigClientUser.apply(this, arguments);
                }
                return updateStatsigClientUser;
            }()
        },
        {
            key: "getPackageVersion",
            value: /**
     * @returns string version of the current package in semver style.
     */ function getPackageVersion() {
                return 0, $51bb5732914b7a49$export$a59f8d67326bd1cb;
            }
        },
        {
            key: "getLayer",
            value: function getLayer(/** The name of the layer */ layerName) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                try {
                    this.assertInitialized(this.statsigClient);
                    var _options$fireLayerExp = options.fireLayerExposure, fireLayerExposure = _options$fireLayerExp === void 0 ? true : _options$fireLayerExp;
                    return (0, $ba2aa0b6a9aa9cb1$export$936d0764594b6eb3).fromLayer(this.statsigClient.getLayer(layerName, {
                        disableExposureLog: !fireLayerExposure
                    }));
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!this.hasGetLayerErrorOccurred) {
                        // eslint-disable-next-line no-console
                        console.warn({
                            msg: 'An error has occurred getting the layer. Only the first occurrence of this error is logged.',
                            layerName: layerName,
                            error: error
                        });
                        this.hasGetLayerErrorOccurred = true;
                    }
                    // Return a default value
                    return (0, $ba2aa0b6a9aa9cb1$export$936d0764594b6eb3).fromLayer((0, $iFR7a._makeLayer)(layerName, {
                        reason: 'Error'
                    }, null));
                }
            }
        },
        {
            key: "getLayerValue",
            value: function getLayerValue(layerName, parameterName, defaultValue) {
                var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var layer = this.getLayer(layerName, options);
                try {
                    var typeGuard = options.typeGuard;
                    return layer.get(parameterName, defaultValue, typeGuard);
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!this.hasGetLayerValueErrorOccurred) {
                        // eslint-disable-next-line no-console
                        console.warn({
                            msg: 'An error has occurred getting the layer value. Only the first occurrence of this error is logged.',
                            layerName: layerName,
                            defaultValue: defaultValue,
                            options: options,
                            error: error
                        });
                        this.hasGetLayerValueErrorOccurred = true;
                    }
                    return defaultValue;
                }
            }
        }
    ]);
}();






var $7f069327a0ab9221$var$_FeatureGates;
/**
 * Access the FeatureGates object via the default export.
 * ```ts
 * import FeatureGates from '@atlaskit/feature-gate-js-client';
 * ```
 */ var $7f069327a0ab9221$var$FeatureGates = /*#__PURE__*/ function() {
    function FeatureGates() {
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, FeatureGates);
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(FeatureGates, null, [
        {
            key: "isGateExists",
            value: function isGateExists(gateName) {
                return this.client.isGateExist(gateName);
            }
        },
        {
            key: "isExperimentExists",
            value: function isExperimentExists(experimentName) {
                return this.client.isExperimentExist(experimentName);
            }
        }
    ]);
}();
$7f069327a0ab9221$var$_FeatureGates = $7f069327a0ab9221$var$FeatureGates;
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($7f069327a0ab9221$var$FeatureGates, "client", new (0, $cbed893bd7829229$export$1f2bb630327ac4b6)());
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($7f069327a0ab9221$var$FeatureGates, "hasCheckGateErrorOccurred", false);
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($7f069327a0ab9221$var$FeatureGates, "hasGetExperimentValueErrorOccurred", false);
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($7f069327a0ab9221$var$FeatureGates, "checkGate", function(gateName, options) {
    try {
        // Check if the CRITERION override mechanism is available
        if (typeof window !== 'undefined' && window.__CRITERION__ && typeof window.__CRITERION__.getFeatureFlagOverride === 'function') {
            // Attempt to retrieve an override value for the feature gate
            var overrideValue = window.__CRITERION__.getFeatureFlagOverride(gateName);
            // If an override value is found, return it immediately
            if (overrideValue !== undefined) return overrideValue;
        }
    } catch (error) {
        // Log the first occurrence of the error
        if (!$7f069327a0ab9221$var$_FeatureGates.hasCheckGateErrorOccurred) {
            // eslint-disable-next-line no-console
            console.warn({
                msg: 'An error has occurred checking the feature gate from criterion override. Only the first occurrence of this error is logged.',
                gateName: gateName,
                error: error
            });
            $7f069327a0ab9221$var$_FeatureGates.hasCheckGateErrorOccurred = true;
        }
    }
    // Proceed with the main logic if no override is found
    return $7f069327a0ab9221$var$_FeatureGates.client.checkGate(gateName, options);
});
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($7f069327a0ab9221$var$FeatureGates, "getExperimentValue", function(experimentName, parameterName, defaultValue, options) {
    try {
        // Check if the CRITERION override mechanism is available
        if (typeof window !== 'undefined' && window.__CRITERION__ && typeof window.__CRITERION__.getExperimentValueOverride === 'function') {
            var overrideValue = window.__CRITERION__.getExperimentValueOverride(experimentName, parameterName);
            if (overrideValue !== undefined && overrideValue !== null) return overrideValue;
        }
    } catch (error) {
        // Log the first occurrence of the error
        if (!$7f069327a0ab9221$var$_FeatureGates.hasGetExperimentValueErrorOccurred) {
            // eslint-disable-next-line no-console
            console.warn({
                msg: 'An error has occurred getting the experiment value from criterion override. Only the first occurrence of this error is logged.',
                experimentName: experimentName,
                defaultValue: defaultValue,
                options: options,
                error: error
            });
            $7f069327a0ab9221$var$_FeatureGates.hasGetExperimentValueErrorOccurred = true;
        }
        return defaultValue;
    }
    // Proceed with the main logic if no override is found
    return $7f069327a0ab9221$var$_FeatureGates.client.getExperimentValue(experimentName, parameterName, defaultValue, options);
});
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($7f069327a0ab9221$var$FeatureGates, "initializeCalled", $7f069327a0ab9221$var$_FeatureGates.client.initializeCalled.bind($7f069327a0ab9221$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($7f069327a0ab9221$var$FeatureGates, "initializeCompleted", $7f069327a0ab9221$var$_FeatureGates.client.initializeCompleted.bind($7f069327a0ab9221$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($7f069327a0ab9221$var$FeatureGates, "waitUntilInitializeCompleted", $7f069327a0ab9221$var$_FeatureGates.client.waitUntilInitializeCompleted.bind($7f069327a0ab9221$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($7f069327a0ab9221$var$FeatureGates, "initialize", $7f069327a0ab9221$var$_FeatureGates.client.initialize.bind($7f069327a0ab9221$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($7f069327a0ab9221$var$FeatureGates, "initializeWithProvider", $7f069327a0ab9221$var$_FeatureGates.client.initializeWithProvider.bind($7f069327a0ab9221$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($7f069327a0ab9221$var$FeatureGates, "initializeFromValues", $7f069327a0ab9221$var$_FeatureGates.client.initializeFromValues.bind($7f069327a0ab9221$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($7f069327a0ab9221$var$FeatureGates, "manuallyLogGateExposure", $7f069327a0ab9221$var$_FeatureGates.client.manuallyLogGateExposure.bind($7f069327a0ab9221$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($7f069327a0ab9221$var$FeatureGates, "getExperiment", $7f069327a0ab9221$var$_FeatureGates.client.getExperiment.bind($7f069327a0ab9221$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($7f069327a0ab9221$var$FeatureGates, "manuallyLogExperimentExposure", $7f069327a0ab9221$var$_FeatureGates.client.manuallyLogExperimentExposure.bind($7f069327a0ab9221$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($7f069327a0ab9221$var$FeatureGates, "manuallyLogLayerExposure", $7f069327a0ab9221$var$_FeatureGates.client.manuallyLogLayerExposure.bind($7f069327a0ab9221$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($7f069327a0ab9221$var$FeatureGates, "shutdownStatsig", $7f069327a0ab9221$var$_FeatureGates.client.shutdownStatsig.bind($7f069327a0ab9221$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($7f069327a0ab9221$var$FeatureGates, "overrideGate", $7f069327a0ab9221$var$_FeatureGates.client.overrideGate.bind($7f069327a0ab9221$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($7f069327a0ab9221$var$FeatureGates, "clearGateOverride", $7f069327a0ab9221$var$_FeatureGates.client.clearGateOverride.bind($7f069327a0ab9221$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($7f069327a0ab9221$var$FeatureGates, "overrideConfig", $7f069327a0ab9221$var$_FeatureGates.client.overrideConfig.bind($7f069327a0ab9221$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($7f069327a0ab9221$var$FeatureGates, "clearConfigOverride", $7f069327a0ab9221$var$_FeatureGates.client.clearConfigOverride.bind($7f069327a0ab9221$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($7f069327a0ab9221$var$FeatureGates, "setOverrides", $7f069327a0ab9221$var$_FeatureGates.client.setOverrides.bind($7f069327a0ab9221$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($7f069327a0ab9221$var$FeatureGates, "getOverrides", $7f069327a0ab9221$var$_FeatureGates.client.getOverrides.bind($7f069327a0ab9221$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($7f069327a0ab9221$var$FeatureGates, "clearAllOverrides", $7f069327a0ab9221$var$_FeatureGates.client.clearAllOverrides.bind($7f069327a0ab9221$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($7f069327a0ab9221$var$FeatureGates, "isCurrentUser", $7f069327a0ab9221$var$_FeatureGates.client.isCurrentUser.bind($7f069327a0ab9221$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($7f069327a0ab9221$var$FeatureGates, "onGateUpdated", $7f069327a0ab9221$var$_FeatureGates.client.onGateUpdated.bind($7f069327a0ab9221$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($7f069327a0ab9221$var$FeatureGates, "onExperimentValueUpdated", $7f069327a0ab9221$var$_FeatureGates.client.onExperimentValueUpdated.bind($7f069327a0ab9221$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($7f069327a0ab9221$var$FeatureGates, "onAnyUpdated", $7f069327a0ab9221$var$_FeatureGates.client.onAnyUpdated.bind($7f069327a0ab9221$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($7f069327a0ab9221$var$FeatureGates, "updateUser", $7f069327a0ab9221$var$_FeatureGates.client.updateUser.bind($7f069327a0ab9221$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($7f069327a0ab9221$var$FeatureGates, "updateUserWithProvider", $7f069327a0ab9221$var$_FeatureGates.client.updateUserWithProvider.bind($7f069327a0ab9221$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($7f069327a0ab9221$var$FeatureGates, "updateUserWithValues", $7f069327a0ab9221$var$_FeatureGates.client.updateUserWithValues.bind($7f069327a0ab9221$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($7f069327a0ab9221$var$FeatureGates, "getPackageVersion", $7f069327a0ab9221$var$_FeatureGates.client.getPackageVersion.bind($7f069327a0ab9221$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($7f069327a0ab9221$var$FeatureGates, "getLayer", $7f069327a0ab9221$var$_FeatureGates.client.getLayer.bind($7f069327a0ab9221$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($7f069327a0ab9221$var$FeatureGates, "getLayerValue", $7f069327a0ab9221$var$_FeatureGates.client.getLayerValue.bind($7f069327a0ab9221$var$_FeatureGates.client));
var $7f069327a0ab9221$var$boundFGJS = $7f069327a0ab9221$var$FeatureGates;
// This makes it possible to get a reference to the FeatureGates client at runtime.
// This is important for overriding values in Cypress tests, as there needs to be a
// way to get the exact instance for a window in order to mock some of its methods.
if (typeof window !== 'undefined') {
    if (window.__FEATUREGATES_JS__ === undefined) window.__FEATUREGATES_JS__ = $7f069327a0ab9221$var$FeatureGates;
    else {
        var $7f069327a0ab9221$var$_boundFGJS, $7f069327a0ab9221$var$_boundFGJS$getPackage;
        $7f069327a0ab9221$var$boundFGJS = window.__FEATUREGATES_JS__;
        var $7f069327a0ab9221$var$boundVersion = (($7f069327a0ab9221$var$_boundFGJS = $7f069327a0ab9221$var$boundFGJS) === null || $7f069327a0ab9221$var$_boundFGJS === void 0 || ($7f069327a0ab9221$var$_boundFGJS$getPackage = $7f069327a0ab9221$var$_boundFGJS.getPackageVersion) === null || $7f069327a0ab9221$var$_boundFGJS$getPackage === void 0 ? void 0 : $7f069327a0ab9221$var$_boundFGJS$getPackage.call($7f069327a0ab9221$var$_boundFGJS)) || '4.10.0 or earlier';
        if ($7f069327a0ab9221$var$boundVersion !== (0, $51bb5732914b7a49$export$a59f8d67326bd1cb)) {
            var $7f069327a0ab9221$var$message = "Multiple versions of FeatureGateClients found on the current page.\n      The currently bound version is ".concat($7f069327a0ab9221$var$boundVersion, " when module version ").concat((0, $51bb5732914b7a49$export$a59f8d67326bd1cb), " was loading.");
            // eslint-disable-next-line no-console
            console.warn($7f069327a0ab9221$var$message);
        }
    }
}
var /**
 * @property {FeatureGates} FeatureGate default export
 */ $7f069327a0ab9221$export$2e2bcd8739ae039 = $7f069327a0ab9221$var$boundFGJS;



var $8qy01 = parcelRequire("8qy01");

var $25nEq = parcelRequire("25nEq");

var $iYJcE = parcelRequire("iYJcE");
/* eslint-disable perfectionist/sort-object-types */ /* eslint-disable @atlaskit/editor/no-re-export */ // Entry file in package.json

var $fC8ib = parcelRequire("fC8ib");

var $25nEq = parcelRequire("25nEq");

var $ekGgq = parcelRequire("ekGgq");

var $3ZMUU = parcelRequire("3ZMUU");
var $e312a98e6349636b$var$_process, $e312a98e6349636b$var$_process2;
function $e312a98e6349636b$export$f9ce7b637dfbe238(value) {
    return typeof value === 'boolean';
}
function $e312a98e6349636b$export$a9a18ae5ba42aeab(values) {
    function typeGuard(value) {
        return values.includes(value);
    }
    /**
   * This is used by test utils to get the variants when running describe.each
   */ if ($e312a98e6349636b$var$IS_TESTING_ENV) typeGuard.values = values;
    return typeGuard;
}
// @ts-ignore
var $e312a98e6349636b$var$IS_TESTING_ENV = (typeof $3ZMUU === "undefined" ? "undefined" : (0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))($3ZMUU)) !== undefined && ((($e312a98e6349636b$var$_process = $3ZMUU) === null || $e312a98e6349636b$var$_process === void 0 || ($e312a98e6349636b$var$_process = $e312a98e6349636b$var$_process.env) === null || $e312a98e6349636b$var$_process === void 0 ? void 0 : $e312a98e6349636b$var$_process.NODE_ENV) === 'test' || (($e312a98e6349636b$var$_process2 = $3ZMUU) === null || $e312a98e6349636b$var$_process2 === void 0 || ($e312a98e6349636b$var$_process2 = $e312a98e6349636b$var$_process2.env) === null || $e312a98e6349636b$var$_process2 === void 0 ? void 0 : $e312a98e6349636b$var$_process2.JEST_WORKER_ID) !== undefined);


function $6c00e80e64677e79$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $6c00e80e64677e79$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $6c00e80e64677e79$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $6c00e80e64677e79$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $6c00e80e64677e79$export$456f1587c9c92021(config) {
    return $6c00e80e64677e79$var$_objectSpread($6c00e80e64677e79$var$_objectSpread({}, config), {}, {
        typeGuard: (0, $e312a98e6349636b$export$f9ce7b637dfbe238),
        defaultValue: config.defaultValue
    });
}
function $6c00e80e64677e79$export$fb89e8a786694d1(config) {
    var values = config.values;
    return $6c00e80e64677e79$var$_objectSpread($6c00e80e64677e79$var$_objectSpread({}, config), {}, {
        values: (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(values),
        // Maintains the tuple
        typeGuard: (0, $e312a98e6349636b$export$a9a18ae5ba42aeab)(config.values),
        defaultValue: config.defaultValue
    });
}


var $1ac22aed74317d57$export$6cbb856f286b07ef = {
    // new format to avoid collisions with other users when updating the file
    // Editor Platform experiments
    // lwoollard experiments
    // Added 02-12-2025
    cc_fix_hydration_ttvc: (0, $6c00e80e64677e79$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'cc_fix_hydration_ttvc'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 03-09-2025
    cc_editor_limited_mode_include_lcm: (0, $6c00e80e64677e79$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'cc_editor_limited_mode_include_lcm'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 03-09-2025
    cc_editor_interactivity_monitoring: (0, $6c00e80e64677e79$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'cc_editor_interactivity_monitoring'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-11-03
    editor_tinymce_full_width_mode: (0, $6c00e80e64677e79$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'editor_tinymce_full_width_mode'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    cc_editor_insm_doc_size_stats: (0, $6c00e80e64677e79$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'cc_editor_insm_doc_size_stats'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-09-30
    cc_editor_insm_outlier_events: (0, $6c00e80e64677e79$export$fb89e8a786694d1)({
        productKeys: {
            confluence: 'cc_editor_insm_outlier_events'
        },
        param: 'cohort',
        values: [
            'control',
            'test'
        ],
        defaultValue: 'control'
    }),
    // Added 2025-11-17
    platform_editor_renderer_extension_width_fix: (0, $6c00e80e64677e79$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_renderer_extension_width_fix'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-09-30
    // variant 1: remove table overflow shadows completely, no table border shown when scrolling.
    // variant 2: remove table overflow shadows, show table border when scrolling.
    // variant 3: replace table overflow shadows with CSS-only solution.
    platform_editor_disable_table_overflow_shadows: (0, $6c00e80e64677e79$export$fb89e8a786694d1)({
        productKeys: {
            confluence: 'platform_editor_disable_table_overflow_shadows'
        },
        param: 'cohort',
        values: [
            'control',
            'variant1',
            'variant2',
            'variant3'
        ],
        defaultValue: 'control'
    }),
    // Added 2025-11-26
    platform_editor_resizer_styles_cleanup: (0, $6c00e80e64677e79$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_resizer_styles_cleanup'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-11-12
    platform_editor_media_vc_fixes: (0, $6c00e80e64677e79$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_media_vc_fixes'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-11-20
    platform_editor_annotations_sync_on_docchange: (0, $6c00e80e64677e79$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_annotations_sync_on_docchange'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-05-27
    platform_editor_reduce_noisy_steps_ncs: (0, $6c00e80e64677e79$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_reduce_noisy_steps_ncs'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-07-24
    editor_prevent_numbered_column_too_big_jira_1: (0, $6c00e80e64677e79$export$456f1587c9c92021)({
        productKeys: {
            jira: 'editor_prevent_numbered_column_too_big_jira_1'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-06-02
    platform_editor_block_control_optimise_render: (0, $6c00e80e64677e79$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_block_control_optimise_render'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2024-08-08
    'example-boolean': (0, $6c00e80e64677e79$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'confluence_editor_experiment_test_new_package_boolean'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2024-08-08
    'example-multivariate': (0, $6c00e80e64677e79$export$fb89e8a786694d1)({
        productKeys: {
            confluence: 'confluence_editor_experiment_test_new_package_multivariate'
        },
        param: 'variant',
        values: [
            'one',
            'two',
            'three'
        ],
        defaultValue: 'one'
    }),
    // Added 2024-08-08
    'test-new-experiments-package': (0, $6c00e80e64677e79$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'confluence_editor_experiment_test_new_package',
            jira: 'jira_editor_experiment_test_new_package'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    platform_editor_table_drag_handle_hover: (0, $6c00e80e64677e79$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_table_drag_handle_hover',
            jira: 'platform_editor_table_drag_handle_hover'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2024-09-05
    support_table_in_comment: (0, $6c00e80e64677e79$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_support_table_in_comment_exp'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2024-09-07
    platform_editor_exp_lazy_node_views: (0, $6c00e80e64677e79$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_exp_lazy_node_views'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2024-09-18
    platform_renderer_table_sticky_scrollbar: (0, $6c00e80e64677e79$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_renderer_table_sticky_scrollbar'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-11-20
    'company-hub-config-panel-keyboard-nav': (0, $6c00e80e64677e79$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'company-hub-config-panel-keyboard-nav'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-10-10
    platform_editor_experience_tracking: (0, $6c00e80e64677e79$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_experience_tracking'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-05-26
    platform_editor_prevent_toolbar_layout_shifts: (0, $6c00e80e64677e79$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_prevent_toolbar_layout_shifts'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2024-10-01
    comment_on_bodied_extensions: (0, $6c00e80e64677e79$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_comment_on_bodied_extensions'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2024-10-14
    // https://console.statsig.com/LqivKg6ADZZaGczRfBKfX/experiments/platform_editor_advanced_layouts/setup
    advanced_layouts: (0, $6c00e80e64677e79$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_advanced_layouts'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-3-15
    // https://console.statsig.com/LqivKg6ADZZaGczRfBKfX/experiments/platform_editor_single_column_layout/setup
    single_column_layouts: (0, $6c00e80e64677e79$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_single_column_layout'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2024-10-08
    support_table_in_comment_jira: (0, $6c00e80e64677e79$export$456f1587c9c92021)({
        productKeys: {
            jira: 'platform_editor_support_table_in_comment_jira'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    'platform_editor_ai-prompts-placeholder': (0, $6c00e80e64677e79$export$fb89e8a786694d1)({
        productKeys: {
            confluence: 'platform_editor_ai-prompts-placeholder'
        },
        param: 'cohort',
        values: [
            'control',
            'test'
        ],
        defaultValue: 'control'
    }),
    // added 2024-11-06
    // https://console.statsig.com/LqivKg6ADZZaGczRfBKfX/experiments/platform_editor_nested_tables/setup
    'nested-tables-in-tables': (0, $6c00e80e64677e79$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_nested_tables'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2024-11-26
    platform_editor_ai_unsplash_page_header: (0, $6c00e80e64677e79$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_ai_unsplash_page_header'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2024-12-05
    platform_editor_blockquote_in_text_formatting_menu: (0, $6c00e80e64677e79$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_blockquote_in_text_formatting_menu'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-01-13
    platform_editor_element_drag_and_drop_multiselect: (0, $6c00e80e64677e79$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_element_drag_and_drop_multiselect'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-01-19
    platform_editor_ai_edit_response_in_preview: (0, $6c00e80e64677e79$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_ai_edit_response_in_preview'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-02-10
    platform_editor_controls: (0, $6c00e80e64677e79$export$fb89e8a786694d1)({
        productKeys: {
            confluence: 'platform_editor_controls'
        },
        param: 'cohort',
        values: [
            'control',
            'variant1'
        ],
        defaultValue: 'control'
    }),
    // Added 2025-08-01
    platform_editor_controls_block_controls_state_fix: (0, $6c00e80e64677e79$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_controls_block_controls_state_fix'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-09-03
    platform_editor_hydratable_ui: (0, $6c00e80e64677e79$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_hydratable_ui'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-03-28
    platform_editor_ai_proactive_ai_nudge_parameters: (0, $6c00e80e64677e79$export$fb89e8a786694d1)({
        productKeys: {
            confluence: 'platform_editor_ai_proactive_ai_nudge_parameters'
        },
        param: 'cohort',
        values: [
            'control',
            'variant1'
        ],
        defaultValue: 'control'
    }),
    // Added 2025-04-14
    // https://switcheroo.atlassian.com/ui/gates/b159b45a-86d9-4f4b-b482-f9aca5b615d6/key/platform_editor_offline_editing_web
    platform_editor_offline_editing_web: (0, $6c00e80e64677e79$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_offline_editing_web'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-10-15
    platform_editor_no_ssr: (0, $6c00e80e64677e79$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_no_ssr'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-10-31
    platform_editor_lovability_suppress_toolbar_event: (0, $6c00e80e64677e79$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_lovability_suppress_toolbar_event',
            jira: 'platform_editor_lovability_suppress_toolbar_event'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-04-17
    platform_editor_tables_drag_and_drop: (0, $6c00e80e64677e79$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_tables_drag_and_drop'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-04-17
    platform_editor_tables_table_selector: (0, $6c00e80e64677e79$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_tables_table_selector'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-04-23
    platform_editor_usesharedpluginstateselector: (0, $6c00e80e64677e79$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_usesharedpluginstateselector'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-04-23
    platform_renderer_fix_analytics_memo_callback: (0, $6c00e80e64677e79$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_renderer_fix_analytics_memo_callback'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-05-26
    platform_editor_stop_width_reflows: (0, $6c00e80e64677e79$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_stop_width_reflows'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-12-01
    platform_editor_no_state_plugin_injection_api: (0, $6c00e80e64677e79$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_no_state_plugin_injection_api'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-06-10
    platform_editor_no_cursor_on_edit_page_init: (0, $6c00e80e64677e79$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_no_cursor_on_edit_page_init'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-07-14
    platform_editor_debounce_portal_provider: (0, $6c00e80e64677e79$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_debounce_portal_provider'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-08-14
    platform_editor_jira_advanced_code_blocks: (0, $6c00e80e64677e79$export$456f1587c9c92021)({
        productKeys: {
            jira: 'platform_editor_jira_advanced_code_blocks'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-07-08 - Jira work sync description comment summary
    'jira-work-sync-desc-comment-summary': (0, $6c00e80e64677e79$export$456f1587c9c92021)({
        productKeys: {
            jira: 'jira-work-sync-desc-comment-summary'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-05-15
    platform_editor_breakout_resizing: (0, $6c00e80e64677e79$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_breakout_resizing'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-05-07
    platform_editor_ai_quickstart_command: (0, $6c00e80e64677e79$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_ai_quickstart_command'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-06-05
    platform_editor_block_controls_perf_optimization: (0, $6c00e80e64677e79$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_block_controls_perf_optimization'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-06-16
    platform_editor_enable_single_player_step_merging: (0, $6c00e80e64677e79$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_enable_single_player_step_merging'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-07-02
    platform_editor_code_block_fold_gutter: (0, $6c00e80e64677e79$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_code_block_fold_gutter'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-06-18
    platform_editor_ai_iw_adf_streaming: (0, $6c00e80e64677e79$export$fb89e8a786694d1)({
        productKeys: {
            confluence: 'platform_editor_ai_iw_adf_streaming'
        },
        param: 'cohort',
        values: [
            'control',
            'adf_gemini25flash',
            'adf_gpt41mini'
        ],
        defaultValue: 'control'
    }),
    // Added 2025-08-20
    platform_editor_ai_non_iw_adf_streaming: (0, $6c00e80e64677e79$export$fb89e8a786694d1)({
        productKeys: {
            confluence: 'platform_editor_ai_non_iw_adf_streaming'
        },
        param: 'cohort',
        values: [
            'control',
            'adf_gemini25flash',
            'adf_gpt41mini'
        ],
        defaultValue: 'control'
    }),
    //Added 2025-07-25
    platform_editor_extension_styles: (0, $6c00e80e64677e79$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_extension_styles'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-06-20
    confluence_whiteboards_quick_insert_aa: (0, $6c00e80e64677e79$export$fb89e8a786694d1)({
        productKeys: {
            confluence: 'confluence_whiteboards_quick_insert_aa'
        },
        param: 'cohort',
        values: [
            'control',
            'test_blank',
            'test_diagram'
        ],
        defaultValue: 'control'
    }),
    // Added 2025-06-24
    platform_editor_find_and_replace_improvements: (0, $6c00e80e64677e79$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_find_and_replace_improvements'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-06-24
    confluence_whiteboards_quick_insert: (0, $6c00e80e64677e79$export$fb89e8a786694d1)({
        productKeys: {
            confluence: 'confluence_whiteboards_quick_insert'
        },
        param: 'cohort',
        values: [
            'control',
            'test_blank',
            'test_diagram'
        ],
        defaultValue: 'control'
    }),
    // Added 2025-06-26
    platform_editor_feedback_mandatory_rating: (0, $6c00e80e64677e79$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_feedback_mandatory_rating'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-07-30
    platform_editor_drag_handle_aria_label: (0, $6c00e80e64677e79$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_drag_handle_aria_label'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-07-07
    platform_editor_toggle_expand_on_match_found: (0, $6c00e80e64677e79$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_toggle_expand_on_match_found'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    platform_editor_smart_card_otp: (0, $6c00e80e64677e79$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_smart_card_otp'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-07-15
    platform_editor_preview_panel_responsiveness: (0, $6c00e80e64677e79$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'confluence_preview_panels_exp'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-08-18
    platform_editor_preview_panel_linking_exp: (0, $6c00e80e64677e79$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_preview_panel_linking_exp_conf',
            jira: 'platform_editor_preview_panel_linking_exp_jira'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-10-10
    platform_editor_hoverlink_ui_fixes_exp: (0, $6c00e80e64677e79$export$fb89e8a786694d1)({
        productKeys: {
            confluence: 'platform_editor_hoverlink_ui_fixes_exp'
        },
        param: 'cohort',
        values: [
            'control',
            'css_changes_only',
            'css_js_changes'
        ],
        defaultValue: 'control'
    }),
    // Added 2025-08-17
    platform_hover_card_preview_panel: (0, $6c00e80e64677e79$export$fb89e8a786694d1)({
        productKeys: {
            confluence: 'platform_hover_card_preview_panel',
            jira: 'platform_hover_card_preview_panel'
        },
        param: 'cohort',
        values: [
            'control',
            'test'
        ],
        defaultValue: 'control'
    }),
    // Added 2025-09-17
    platform_hover_card_preview_panel_modal: (0, $6c00e80e64677e79$export$fb89e8a786694d1)({
        productKeys: {
            confluence: 'platform_hover_card_preview_panel_modal',
            jira: 'platform_hover_card_preview_panel_modal'
        },
        param: 'cohort',
        values: [
            'control',
            'test'
        ],
        defaultValue: 'control'
    }),
    // Added 2025-11-25
    smart_link_confluence_short_link_analytics: (0, $6c00e80e64677e79$export$fb89e8a786694d1)({
        productKeys: {
            confluence: 'smart-link-confluence-short-link-analytics',
            jira: 'smart-link-confluence-short-link-analytics'
        },
        param: 'cohort',
        values: [
            'control',
            'test'
        ],
        defaultValue: 'control'
    }),
    // Added 2025--8-05
    platform_editor_block_menu: (0, $6c00e80e64677e79$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_block_menu'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-09-16
    platform_editor_emoji_otp: (0, $6c00e80e64677e79$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_emoji_otp'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-07-23
    platform_editor_renderer_breakout_fix: (0, $6c00e80e64677e79$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_renderer_breakout_fix'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-07-24
    editor_enghealth_hyperlink_toolbar_aria_values: (0, $6c00e80e64677e79$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'editor_enghealth_hyperlink_toolbar_aria_values'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-07-14
    platform_editor_add_orange_highlight_color: (0, $6c00e80e64677e79$export$fb89e8a786694d1)({
        productKeys: {
            confluence: 'platform_editor_add_orange_highlight_color'
        },
        param: 'cohort',
        values: [
            'control',
            'test'
        ],
        defaultValue: 'control'
    }),
    //Added 2025-07-16
    platform_editor_toolbar_aifc: (0, $6c00e80e64677e79$export$456f1587c9c92021)({
        productKeys: {
            jira: 'platform_editor_toolbar_aifc_jira',
            confluence: 'platform_editor_toolbar_aifc_confluence'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-09-04
    editor_refactor_backspace_task_and_decisions: (0, $6c00e80e64677e79$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'editor_refactor_backspace_task_and_decisions'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    //Added 2025-07-16
    platform_editor_toolbar_aifc_patch_3: (0, $6c00e80e64677e79$export$456f1587c9c92021)({
        productKeys: {
            jira: 'platform_editor_toolbar_aifc_patch_3',
            confluence: 'platform_editor_toolbar_aifc_patch_3'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    //Added 2025-09-09
    platform_editor_toolbar_aifc_patch_4: (0, $6c00e80e64677e79$export$456f1587c9c92021)({
        productKeys: {
            jira: 'platform_editor_toolbar_aifc_patch_4',
            confluence: 'platform_editor_toolbar_aifc_patch_4'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-09-29
    platform_editor_toolbar_aifc_selection_extension: (0, $6c00e80e64677e79$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_toolbar_aifc_selection_extension',
            jira: 'platform_editor_toolbar_aifc_selection_extension'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-08-04
    platform_editor_floating_toolbar_button_aria_label: (0, $6c00e80e64677e79$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_floating_toolbar_button_aria_label'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-07-24
    platform_editor_enghealth_table_plugin_lable_rule: (0, $6c00e80e64677e79$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_enghealth_table_plugin_lable_rule'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-07-31
    platform_editor_breakout_interaction_rerender: (0, $6c00e80e64677e79$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_breakout_interaction_rerender'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-08-27
    platform_editor_toolbar_aifc_responsive: (0, $6c00e80e64677e79$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_toolbar_aifc_responsive',
            jira: 'platform_editor_toolbar_aifc_responsive'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-07-30
    platform_editor_pasting_nested_table_fix: (0, $6c00e80e64677e79$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_pasting_nested_table_fix'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 20205-07-28
    platform_editor_fix_quick_insert_consistency_exp: (0, $6c00e80e64677e79$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_fix_quick_insert_consistency_exp'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    //Added 2025-11-19
    platform_editor_pasting_text_in_panel: (0, $6c00e80e64677e79$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_pasting_text_in_panel'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-07-31
    platform_editor_fix_a11y_aria_posinset_0: (0, $6c00e80e64677e79$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_fix_a11y_aria_posinset_0'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-07-30
    platform_editor_blocktaskitem_node_tenantid: (0, $6c00e80e64677e79$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_blocktaskitem_node_tenantid'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-09-08
    platform_editor_blocktaskitem_patch_1: (0, $6c00e80e64677e79$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_blocktaskitem_patch_1'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-08-06
    cc_editor_limited_mode: (0, $6c00e80e64677e79$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'cc_editor_limited_mode'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-08-05
    platform_editor_native_anchor_with_dnd: (0, $6c00e80e64677e79$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_native_anchor_with_dnd'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    platform_editor_native_expand_button: (0, $6c00e80e64677e79$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_native_expand_button'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-08-28
    editor_enable_image_alignment_in_expand: (0, $6c00e80e64677e79$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'editor_enable_image_alignment_in_expand'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-08-05
    platform_editor_august_a11y: (0, $6c00e80e64677e79$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_august_a11y'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-08-10
    platform_synced_block: (0, $6c00e80e64677e79$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_synced_block',
            jira: 'platform_synced_block_jira'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-09-16
    cc_improve_writing_on_paste_v2: (0, $6c00e80e64677e79$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'cc_improve_writing_on_paste_v2'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-08-18
    platform_editor_locale_datepicker: (0, $6c00e80e64677e79$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_locale_datepicker'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-08-19
    platform_editor_breakout_resizing_vc90_fix: (0, $6c00e80e64677e79$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_breakout_resizing_vc90_fix'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-08-27
    platform_editor_toolbar_support_custom_components: (0, $6c00e80e64677e79$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_toolbar_support_custom_components'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-08-25
    platform_editor_toolbar_aifc_template_editor: (0, $6c00e80e64677e79$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_toolbar_aifc_template_editor'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-08-26
    platform_editor_toolbar_migrate_loom: (0, $6c00e80e64677e79$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_toolbar_migrate_loom',
            jira: 'platform_editor_toolbar_migrate_loom'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-09-16
    platform_editor_prevent_taskitem_remount: (0, $6c00e80e64677e79$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_prevent_taskitem_remount'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-09-01
    cc_editor_ai_content_mode: (0, $6c00e80e64677e79$export$fb89e8a786694d1)({
        productKeys: {
            confluence: 'cc_editor_ai_content_mode'
        },
        param: 'variant',
        values: [
            'control',
            'test'
        ],
        defaultValue: 'control'
    }),
    // Added 2025-09-08
    platform_editor_editor_width_analytics: (0, $6c00e80e64677e79$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_editor_width_analytics',
            jira: 'platform_editor_editor_width_analytics'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-09-10
    platform_editor_fix_button_name_violation_in_table: (0, $6c00e80e64677e79$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_fix_button_name_violation_in_table'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-09-11
    platform_editor_quick_insert_image_wrap_right_fix: (0, $6c00e80e64677e79$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_quick_insert_image_wrap_right_fix'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-09-11
    platform_editor_add_aria_checked_to_inline_img_btn: (0, $6c00e80e64677e79$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_add_aria_checked_to_inline_image_btn'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-09-16
    platform_editor_nested_table_refresh_width_fix: (0, $6c00e80e64677e79$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_nested_table_refresh_width_fix'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-09-15
    platform_editor_toolbar_aifc_patch_5: (0, $6c00e80e64677e79$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_toolbar_aifc_patch_5'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-10-10
    platform_use_llm_space_recommendations: (0, $6c00e80e64677e79$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_use_llm_space_recommendations'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-09-15
    platform_editor_text_highlight_padding: (0, $6c00e80e64677e79$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_text_highlight_padding'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-10-24
    platform_editor_lovability_user_intent: (0, $6c00e80e64677e79$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_lovability_user_intent'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-09-17
    cc_complexit_fe_emoji_stability: (0, $6c00e80e64677e79$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'cc_complexit_fe_emoji_stability'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-09-23
    cc_editor_ttvc_release_bundle_one: (0, $6c00e80e64677e79$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'cc_editor_ttvc_release_bundle_one'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-10-07
    platform_editor_plain_text_support: (0, $6c00e80e64677e79$export$456f1587c9c92021)({
        productKeys: {
            jira: 'platform_editor_plain_text_support',
            confluence: 'platform_editor_plain_text_support'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-09-26
    platform_editor_toolbar_aifc_patch_6: (0, $6c00e80e64677e79$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_toolbar_aifc_patch_6'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-10-17
    confluence_content_mode_replace_dense_with_compact: (0, $6c00e80e64677e79$export$fb89e8a786694d1)({
        productKeys: {
            confluence: 'confluence_content_mode_replace_dense_with_compact'
        },
        param: 'cohort',
        values: [
            'control',
            'test'
        ],
        defaultValue: 'control'
    }),
    // Added 2025-10-01
    platform_inline_smartcard_connect_button_exp: (0, $6c00e80e64677e79$export$fb89e8a786694d1)({
        productKeys: {
            confluence: 'platform_inline_smartcard_connect_button_exp',
            jira: 'platform_inline_smartcard_connect_button_exp'
        },
        param: 'cohort',
        values: [
            'control',
            'test1',
            'test2'
        ],
        defaultValue: 'control'
    }),
    // Added 2025-10-10
    platform_editor_new_list_decorations_logic: (0, $6c00e80e64677e79$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_new_list_decorations_logic'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-10-13
    platform_editor_media_error_analytics: (0, $6c00e80e64677e79$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_media_error_analytics'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-10-15
    platform_editor_new_mentions_detection_logic: (0, $6c00e80e64677e79$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_new_mentions_detection_logic'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-10-20
    confluence_whiteboards_quick_insert_localised: (0, $6c00e80e64677e79$export$fb89e8a786694d1)({
        productKeys: {
            confluence: 'confluence_whiteboards_quick_insert_localised'
        },
        param: 'cohort',
        values: [
            'control',
            'test_blank',
            'test_diagram'
        ],
        defaultValue: 'control'
    }),
    // Added 2025-10-28
    confluence_whiteboards_quick_insert_localised_aa: (0, $6c00e80e64677e79$export$fb89e8a786694d1)({
        productKeys: {
            confluence: 'confluence_whiteboards_quick_insert_localised_aa'
        },
        param: 'cohort',
        values: [
            'control',
            'test_diagram'
        ],
        defaultValue: 'control'
    }),
    // Added 2025-10-22
    platform_editor_remove_bidi_char_warning: (0, $6c00e80e64677e79$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_remove_bidi_char_warning'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-11-05
    platform_editor_nested_table_detection: (0, $6c00e80e64677e79$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_nested_table_detection'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-10-24
    platform_editor_fix_clone_nesting_exp: (0, $6c00e80e64677e79$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_fix_clone_nesting_exp'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-10-27
    platform_editor_table_sticky_header_improvements: (0, $6c00e80e64677e79$export$fb89e8a786694d1)({
        productKeys: {
            confluence: 'platform_editor_table_sticky_header_improvements'
        },
        param: 'cohort',
        values: [
            'control',
            'test_with_overflow',
            'test_without_overflow'
        ],
        defaultValue: 'control'
    }),
    // Added 2025-11-04
    platform_editor_disable_lazy_load_media: (0, $6c00e80e64677e79$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_disable_lazy_load_media'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-10-29
    platform_editor_lovability_inline_code: (0, $6c00e80e64677e79$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_lovability_inline_code'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-11-05
    platform_editor_lovability_emoji_scaling: (0, $6c00e80e64677e79$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_lovability_emoji_scaling'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-11-07
    cc_editor_limited_mode_table_align_bttn: (0, $6c00e80e64677e79$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'cc_editor_limited_mode_table_align_bttn'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-11-19
    platform_editor_lovability_navigation_fixes: (0, $6c00e80e64677e79$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_lovability_navigation_fixes'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-11-27
    platform_sl_3p_unauth_paste_as_block_card: (0, $6c00e80e64677e79$export$fb89e8a786694d1)({
        productKeys: {
            confluence: 'platform_sl_3p_unauth_paste_as_block_card',
            jira: 'platform_sl_3p_unauth_paste_as_block_card'
        },
        values: [
            'control',
            'card_by_default_only',
            'card_by_default_and_new_design'
        ],
        param: 'cohort',
        defaultValue: 'control'
    }),
    // Added 2025-11-25
    platform_editor_remove_ncsStepMetrics_plugin: (0, $6c00e80e64677e79$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_remove_ncsStepMetrics_plugin'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-11-18
    platform_editor_wait_for_space_after_ascii_emoji: (0, $6c00e80e64677e79$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_wait_for_space_after_ascii_emoji'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-12-03
    platform_editor_nested_media_selection_fix: (0, $6c00e80e64677e79$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_nested_media_selection_fix'
        },
        param: 'isEnabled',
        defaultValue: false
    })
};


var $4308dc3dd5bb19c3$export$7e849a84a00ffd1c = {
    'example-multivariate': 'one',
    'platform_editor_ai-prompts-placeholder': 'control',
    platform_editor_ai_proactive_ai_nudge_parameters: 'control',
    platform_editor_controls: 'control',
    confluence_whiteboards_quick_insert_aa: 'control',
    confluence_whiteboards_quick_insert: 'control',
    confluence_whiteboards_quick_insert_localised: 'control',
    confluence_whiteboards_quick_insert_localised_aa: 'control',
    cc_editor_ai_content_mode: 'control',
    platform_editor_add_orange_highlight_color: 'control',
    platform_editor_ai_iw_adf_streaming: 'control',
    platform_editor_ai_non_iw_adf_streaming: 'control',
    platform_hover_card_preview_panel: 'control',
    platform_hover_card_preview_panel_modal: 'control',
    smart_link_confluence_short_link_analytics: 'control',
    platform_inline_smartcard_connect_button_exp: 'control',
    confluence_content_mode_replace_dense_with_compact: 'control',
    cc_editor_insm_outlier_events: 'test',
    platform_editor_disable_table_overflow_shadows: 'control',
    platform_editor_hoverlink_ui_fixes_exp: 'control',
    platform_editor_table_sticky_header_improvements: 'control',
    platform_sl_3p_unauth_paste_as_block_card: 'control'
};
var $4308dc3dd5bb19c3$export$54960937bb713f97 = {
    platform_editor_feedback_mandatory_rating: false,
    platform_editor_preview_panel_responsiveness: false,
    platform_editor_renderer_breakout_fix: false,
    platform_editor_toolbar_aifc: false,
    platform_editor_block_control_optimise_render: false,
    'test-new-experiments-package': false,
    support_table_in_comment: false,
    platform_editor_exp_lazy_node_views: false,
    platform_renderer_table_sticky_scrollbar: false,
    platform_editor_prevent_toolbar_layout_shifts: false,
    comment_on_bodied_extensions: false,
    advanced_layouts: false,
    single_column_layouts: false,
    support_table_in_comment_jira: false,
    'nested-tables-in-tables': false,
    platform_editor_ai_unsplash_page_header: false,
    platform_editor_blockquote_in_text_formatting_menu: false,
    platform_editor_element_drag_and_drop_multiselect: false,
    platform_editor_ai_edit_response_in_preview: false,
    platform_editor_offline_editing_web: false,
    platform_editor_tables_drag_and_drop: false,
    platform_editor_tables_table_selector: false,
    platform_renderer_fix_analytics_memo_callback: false,
    platform_editor_stop_width_reflows: false,
    platform_editor_no_cursor_on_edit_page_init: false,
    'jira-work-sync-desc-comment-summary': false,
    platform_editor_breakout_resizing: false,
    platform_editor_ai_quickstart_command: false,
    platform_editor_block_controls_perf_optimization: false,
    platform_editor_enable_single_player_step_merging: false,
    platform_editor_find_and_replace_improvements: false,
    platform_editor_toggle_expand_on_match_found: false,
    platform_editor_reduce_noisy_steps_ncs: false,
    cc_improve_writing_on_paste_v2: false,
    platform_editor_text_highlight_padding: false
};


function $9ee46fa0dbaa7578$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $9ee46fa0dbaa7578$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $9ee46fa0dbaa7578$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $9ee46fa0dbaa7578$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $9ee46fa0dbaa7578$export$e5d73bf4f8e2ae96 = {};
var $9ee46fa0dbaa7578$export$4e849416bb5c5b52 = {};
var $9ee46fa0dbaa7578$export$cf7305fc65acbf0d;
function $9ee46fa0dbaa7578$export$1c2b6dbf79eb3560(product, /**
 * Overrides are used to set the group of an experiment for testing purposes.
 * This is useful when you want to test a specific experiment group.
 */ groupOverrides, /**
 * Param overrides are used to set the experiment parameters for testing purposes.
 * This is useful when you want to tweak the experiment parameters for testing.
 */ paramOverrides, options) {
    if (groupOverrides) {
        // When setting up overrides, we want to ensure that experiments don't end up with invalid
        // values.
        // For production usage -- this is done via the feature flag client which takes the type
        // and performs equivalent logic.
        // @ts-ignore
        groupOverrides = Object.entries(groupOverrides).reduce(function(acc, _ref) {
            var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_ref, 2), key = _ref2[0], value = _ref2[1];
            var config = (0, $1ac22aed74317d57$export$6cbb856f286b07ef)[key];
            if (config) acc = $9ee46fa0dbaa7578$var$_objectSpread($9ee46fa0dbaa7578$var$_objectSpread({}, acc), {}, (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, key, config.typeGuard(value) ? value : config.defaultValue));
            return acc;
        }, {});
        $9ee46fa0dbaa7578$export$e5d73bf4f8e2ae96 = groupOverrides;
    }
    if (product === 'test' && !(options !== null && options !== void 0 && options.disableTestOverrides)) {
        // Enforce expectation - file overrides, then global overrides, then default to true for boolean
        // experiments, then last result use the default value
        var testOverrides = Object.fromEntries(Object.entries((0, $1ac22aed74317d57$export$6cbb856f286b07ef)).map(function(_ref3) {
            var _ref5, _ref6, _groupOverrides, _groupOverrides2;
            var _ref4 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_ref3, 2), key = _ref4[0], value = _ref4[1];
            var defaultValue = typeof value.defaultValue === 'boolean' ? true : value.defaultValue;
            return [
                key,
                (_ref5 = (_ref6 = (_groupOverrides = (_groupOverrides2 = groupOverrides) === null || _groupOverrides2 === void 0 ? void 0 : _groupOverrides2[key]) !== null && _groupOverrides !== void 0 ? _groupOverrides : (0, $4308dc3dd5bb19c3$export$7e849a84a00ffd1c)[key]) !== null && _ref6 !== void 0 ? _ref6 : (0, $4308dc3dd5bb19c3$export$54960937bb713f97)[key]) !== null && _ref5 !== void 0 ? _ref5 : defaultValue
            ];
        }));
        $9ee46fa0dbaa7578$export$e5d73bf4f8e2ae96 = testOverrides;
    }
    $9ee46fa0dbaa7578$export$cf7305fc65acbf0d = product;
    $9ee46fa0dbaa7578$export$4e849416bb5c5b52 = paramOverrides || {};
}


function $d1e7bb1fad29e0f0$export$58e581060588c6bb(experimentName, experimentParam, experimentExpectedValue, experimentDefaultValue, experimentExposure) {
    // @ts-ignore need to loosen the type here to allow for any experiment name
    if ((0, $9ee46fa0dbaa7578$export$e5d73bf4f8e2ae96)[experimentName] !== undefined) // This will be hit in the case of a test setting an override
    // @ts-ignore need to loosen the type here to allow for any experiment name
    return (0, $9ee46fa0dbaa7578$export$e5d73bf4f8e2ae96)[experimentName] === experimentExpectedValue;
    // If client is not initialized, we compare with the default value
    if (!(0, $7f069327a0ab9221$export$2e2bcd8739ae039).initializeCompleted()) return experimentDefaultValue === experimentExpectedValue;
    // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
    var experimentValue = (0, $7f069327a0ab9221$export$2e2bcd8739ae039).getExperimentValue(experimentName, experimentParam, experimentDefaultValue, {
        fireExperimentExposure: experimentExposure
    });
    if (// eslint-disable-next-line @atlaskit/platform/use-recommended-utils
    (0, $7f069327a0ab9221$export$2e2bcd8739ae039).getExperimentValue('cc_editor_experiments_ufo_gate_reporting', 'isEnabled', false)) // Duplicated from /confluence/next/packages/feature-experiments/src/index.ts
    (0, $8qy01.addFeatureFlagAccessed)("".concat(experimentName, ":").concat(experimentParam), experimentValue);
    return experimentValue === experimentExpectedValue;
}


function $60698074f978cdf8$export$45abdb3f977b5b14(experimentName, experimentParam, experimentExpectedValue) {
    var experimentDefaultValue = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
    return (0, $d1e7bb1fad29e0f0$export$58e581060588c6bb)(experimentName, experimentParam, experimentExpectedValue, experimentDefaultValue, true);
}


var $691a01f0c2a721b6$export$12a518ff137dd389 = (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, '#DCDFE4', "var(--ds-background-accent-gray-subtler, #DCDFE4)"), '#C6EDFB', "var(--ds-background-accent-teal-subtler, #C6EDFB)"), '#D3F1A7', "var(--ds-background-accent-lime-subtler, #D3F1A7)"), '#F8E6A0', "var(--ds-background-accent-yellow-subtler, #F8E6A0)"), '#FEDEC8', "var(--ds-background-accent-orange-subtler, #FEDEC8)"), '#FDD0EC', "var(--ds-background-accent-magenta-subtler, #FDD0EC)"), '#DFD8FD', "var(--ds-background-accent-purple-subtler, #DFD8FD)");
function $691a01f0c2a721b6$export$8b58ff1b36bb75e0(hexColor) {
    if (!(0, $60698074f978cdf8$export$45abdb3f977b5b14)('platform_editor_add_orange_highlight_color', 'cohort', 'test')) // @ts-expect-error Expect type error. Will modify production type
    // if experiment proceeds post-results.
    $691a01f0c2a721b6$export$12a518ff137dd389['#FEDEC8'] = "var(--ds-background-accent-yellow-subtler, #F8E6A0)";
    // Ts ignore was used to allow use of conditional return type
    // (preferring better type on consumption over safety in implementation)
    // @ts-ignore
    return $691a01f0c2a721b6$export$12a518ff137dd389[hexColor.toUpperCase()];
}



var $jLsC1 = parcelRequire("jLsC1");

var $drUcN = parcelRequire("drUcN");
function $7eff8bb2e3b8a318$export$2e2bcd8739ae039(props) {
    var _useThemeObserver = (0, $jLsC1.default)(), colorMode = _useThemeObserver.colorMode;
    var paletteColorValue;
    /**
   * Documents can contain custom colors when content has been migrated from the old editor, or created via APIs.
   *
   * This behaviour predates the introduction of dark mode.
   *
   * Without the inversion logic below, text with custom colors, can be hard to read when the user loads the page in dark mode.
   *
   * This introduces inversion of the presentation of the custom text background colors when the user is in dark mode.
   *
   * This can be done without additional changes to account for users copying and pasting content inside the Editor, because of
   * how we detect text background colors copied from external editor sources. Where we load the background color from a
   * separate attribute (data-background-custom-color), instead of the inline style.
   *
   * See the following document for more details on this behaviour
   * https://hello.atlassian.net/wiki/spaces/CCECO/pages/2908658046/Unsupported+custom+text+colors+in+dark+theme+Editor+Job+Story
   */ var tokenColor = (0, $691a01f0c2a721b6$export$8b58ff1b36bb75e0)(props.color);
    if (tokenColor) paletteColorValue = tokenColor;
    else if (colorMode === 'dark') // if we have a custom color, we need to check if we are in dark mode
    paletteColorValue = (0, $gwjAb.getDarkModeLCHColor)(props.color);
    else // if we are in light mode, we can just set the color
    paletteColorValue = props.color;
    var style = (0, $5FkrB.useMemo)(function() {
        return (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, '--custom-palette-color', paletteColorValue);
    }, [
        paletteColorValue
    ]);
    if (props.isStandalone && (0, $drUcN.expValEquals)('platform_editor_text_highlight_padding', 'isEnabled', true)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("span", {
        "data-block-mark": props.dataAttributes['data-block-mark'],
        "data-renderer-mark": props.dataAttributes['data-renderer-mark'],
        "data-background-custom-color": props.color,
        className: "fabric-background-color-mark",
        style: style
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("span", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "background-color-padding-left background-color-padding-right"
    }, props.children));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("span", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, props.dataAttributes, {
        "data-background-custom-color": props.color,
        className: "fabric-background-color-mark",
        style: style
    }), props.children);
}



var $5FkrB = parcelRequire("5FkrB");
function $a43077aec2438448$export$2e2bcd8739ae039(props) {
    // Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("u", props.dataAttributes, props.children);
}



var $kqp0i = parcelRequire("kqp0i");

var $74Zh5 = parcelRequire("74Zh5");

var $1LBcl = parcelRequire("1LBcl");

var $fAhSf = parcelRequire("fAhSf");

var $drUcN = parcelRequire("drUcN");
var $c0e50d9529b2a755$var$wrapperStyles = (0, $74Zh5.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    margin: "".concat((0, $1LBcl.blockNodesVerticalMargin), " 0"),
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
    marginLeft: '50%',
    transform: 'translateX(-50%)'
});
var $c0e50d9529b2a755$var$getWidth = function getWidth(width, mode) {
    if ((0, $fAhSf.editorExperiment)('advanced_layouts', true) && width) return "min(".concat(width, "px, var(--ak-editor--breakout-container-without-gutter-width))");
    else {
        if ((0, $drUcN.expValEquals)('editor_tinymce_full_width_mode', 'isEnabled', true)) {
            if (mode === 'max' || typeof width === 'number' && width >= (0, $1LBcl.akEditorFullWidthLayoutWidth)) return "min(".concat((0, $1LBcl.akEditorMaxLayoutWidth), "px, var(--ak-editor--breakout-container-without-gutter-width))");
        }
        if (mode === 'full-width') {
            if ((0, $drUcN.expValEquals)('platform_editor_renderer_breakout_fix', 'isEnabled', true)) return "min(".concat((0, $1LBcl.akEditorFullWidthLayoutWidth), "px, var(--ak-editor--breakout-container-without-gutter-width))");
            return "max(".concat((0, $1LBcl.akEditorDefaultLayoutWidth), "px, min(").concat((0, $1LBcl.akEditorFullWidthLayoutWidth), "px, var(--ak-editor--breakout-container-without-gutter-width)))");
        }
        if (mode === 'wide') return "min(var(--ak-editor--breakout-wide-layout-width), var(--ak-editor--breakout-container-without-gutter-width))";
    }
};
function $c0e50d9529b2a755$export$2e2bcd8739ae039(props) {
    return (0, $74Zh5.jsx)("div", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        css: $c0e50d9529b2a755$var$wrapperStyles,
        "data-mode": props.mode
    }, (0, $fAhSf.editorExperiment)('advanced_layouts', true) && {
        'data-has-width': !!props.width,
        'data-width': props.width
    }, {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            width: $c0e50d9529b2a755$var$getWidth('width' in props ? props.width : null, props.mode)
        },
        className: "fabric-editor-breakout-mark fabric-editor-block-mark"
    }), props.children);
}



var $kqp0i = parcelRequire("kqp0i");
parcelRequire("5FkrB");

var $74Zh5 = parcelRequire("74Zh5");

var $5fbqs = parcelRequire("5fbqs");
var $cc7b02ff90190344$var$MarkWrapper = function MarkWrapper(props) {
    var dataAlign = props['data-align'] ? (0, $5fbqs.alignmentPositionMap)[props['data-align']] : undefined;
    return (0, $74Zh5.jsx)("div", (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        style: {
            textAlign: dataAlign
        }
    }, props), props.children);
};
function $cc7b02ff90190344$export$2e2bcd8739ae039(props) {
    return (0, $74Zh5.jsx)($cc7b02ff90190344$var$MarkWrapper, {
        className: "fabric-editor-block-mark fabric-editor-alignment",
        "data-align": props.align
    }, props.children);
}



var $5FkrB = parcelRequire("5FkrB");
function $e980729e1759a63a$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "fabric-editor-block-mark fabric-editor-indentation-mark",
        "data-level": props.level
    }, props.children);
}



var $5FkrB = parcelRequire("5FkrB");
function $c58e089383781168$export$2e2bcd8739ae039(props) {
    // Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("span", props.dataAttributes, props.children);
}



var $5FkrB = parcelRequire("5FkrB");
function $0d40a60c16b721e3$export$2e2bcd8739ae039(props) {
    // Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("span", props.dataAttributes, props.children);
}



var $kqp0i = parcelRequire("kqp0i");

var $5FkrB = parcelRequire("5FkrB");
function $f3bfc2c67e24dc3e$export$2e2bcd8739ae039(props) {
    var WrapperElement = props.isInline ? 'span' : 'div';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(WrapperElement, (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        "data-source": props.sources ? JSON.stringify(props.sources) : undefined,
        "data-mark-type": "dataConsumer"
    }, props.dataAttributes), props.children);
}



var $kqp0i = parcelRequire("kqp0i");

var $5FkrB = parcelRequire("5FkrB");
function $298953afb828ae9b$export$2e2bcd8739ae039(props) {
    var WrapperElement = props.isInline ? 'span' : 'div';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(WrapperElement, (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        "data-localId": props.localId,
        "data-name": props.name,
        "data-mark-type": "fragment"
    }, props.dataAttributes), props.children);
}



var $w2fDc = parcelRequire("w2fDc");
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $74Zh5 = parcelRequire("74Zh5");
function $b6e959fc4dd558ff$export$2e2bcd8739ae039(props) {
    var _props$color, _props$size;
    var borderColor = (_props$color = props.color) !== null && _props$color !== void 0 ? _props$color : '';
    var borderSize = (_props$size = props.size) !== null && _props$size !== void 0 ? _props$size : 0;
    return (0, $74Zh5.jsx)("span", {
        "data-color": borderColor,
        "data-size": borderSize,
        "data-mark-type": "border"
    }, props.children);
}



var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $kIXpt = parcelRequire("kIXpt");

var $cYPzS = parcelRequire("cYPzS");

var $eyuDe = parcelRequire("eyuDe");

var $5FkrB = parcelRequire("5FkrB");
function $e558e5bbc09a7442$var$_callSuper(t, o, e) {
    return o = (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(o), (0, (/*@__PURE__*/$parcel$interopDefault($kIXpt)))(t, $e558e5bbc09a7442$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(t).constructor) : o.apply(t, e));
}
function $e558e5bbc09a7442$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($e558e5bbc09a7442$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
// Ignored via go/ees005
// eslint-disable-next-line @repo/internal/react/no-class-components, react/prefer-stateless-function
var $e558e5bbc09a7442$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_Component) {
    function ConfluenceInlineComment() {
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, ConfluenceInlineComment);
        return $e558e5bbc09a7442$var$_callSuper(this, ConfluenceInlineComment, arguments);
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($eyuDe)))(ConfluenceInlineComment, _Component);
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(ConfluenceInlineComment, [
        {
            key: "render",
            value: function render() {
                var _this$props = this.props, reference = _this$props.reference, children = _this$props.children;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("span", {
                    "data-mark-type": "confluenceInlineComment",
                    "data-reference": reference
                }, children);
            }
        }
    ]);
}((0, $5FkrB.Component));


var $6ea97fdfef30088f$export$c00d967a0f56fdb7 = {
    code: (0, $7b2d933bcff57ef4$export$2e2bcd8739ae039),
    em: (0, $8ba2e00755bbf395$export$2e2bcd8739ae039),
    link: (0, $34deba354526914d$export$2e2bcd8739ae039),
    strike: (0, $4f2072525bb46916$export$2e2bcd8739ae039),
    strong: (0, $bf141d5161e77678$export$2e2bcd8739ae039),
    subsup: (0, $12c13372ddda400f$export$2e2bcd8739ae039),
    textColor: (0, $c16c5e74cb7ad188$export$2e2bcd8739ae039),
    backgroundColor: (0, $7eff8bb2e3b8a318$export$2e2bcd8739ae039),
    underline: (0, $a43077aec2438448$export$2e2bcd8739ae039),
    annotation: (0, $w2fDc.default),
    border: (0, $b6e959fc4dd558ff$export$2e2bcd8739ae039),
    // Stage0
    confluenceInlineComment: (0, $e558e5bbc09a7442$export$2e2bcd8739ae039),
    breakout: (0, $c0e50d9529b2a755$export$2e2bcd8739ae039),
    alignment: (0, $cc7b02ff90190344$export$2e2bcd8739ae039),
    indentation: (0, $e980729e1759a63a$export$2e2bcd8739ae039),
    unsupportedMark: (0, $c58e089383781168$export$2e2bcd8739ae039),
    unsupportedNodeAttribute: (0, $0d40a60c16b721e3$export$2e2bcd8739ae039),
    dataConsumer: (0, $f3bfc2c67e24dc3e$export$2e2bcd8739ae039),
    fragment: (0, $298953afb828ae9b$export$2e2bcd8739ae039)
};
var $6ea97fdfef30088f$export$d4334b129116aad7 = function toReact(mark) {
    return $6ea97fdfef30088f$export$c00d967a0f56fdb7[mark.type.name];
};



var $0b366d21bf0dee21$var$isLayoutNode = function isLayoutNode(node) {
    return node.type.name === 'layoutSection';
};
var $0b366d21bf0dee21$var$hasBreakOutMark = function hasBreakOutMark(node) {
    return node.marks.some(function(m) {
        return m.type.name === 'breakout';
    });
};
var $0b366d21bf0dee21$export$d7bc71cca336a3b = function insideBreakoutLayout(path) {
    return path.some(function(item) {
        return $0b366d21bf0dee21$var$isLayoutNode(item) && $0b366d21bf0dee21$var$hasBreakOutMark(item);
    });
};
var $0b366d21bf0dee21$export$42ddc573eb5a7b43 = function insideBlockNode(path, schema) {
    var _schema$nodes = schema.nodes, expand = _schema$nodes.expand, nestedExpand = _schema$nodes.nestedExpand, layoutColumn = _schema$nodes.layoutColumn;
    var blockNodeNames = [
        expand,
        nestedExpand,
        layoutColumn
    ].filter(function(node) {
        return Boolean(node);
    }).map(function(node) {
        return node.name;
    });
    return path && path.some(function(n) {
        return n.type && blockNodeNames.indexOf(n.type.name) > -1;
    });
};
var $0b366d21bf0dee21$export$9f1e9347b0411934 = function insideMultiBodiedExtension(path, schema) {
    var multiBodiedExtension = schema.nodes.multiBodiedExtension;
    return path.some(function(n) {
        return n.type === multiBodiedExtension;
    });
};
var $0b366d21bf0dee21$export$244bf4b32387ef62 = function insideTable(path, schema) {
    var table = schema.nodes.table;
    return path.some(function(n) {
        return n.type === table;
    });
};





var $6af2eee65b21fc1b$export$eeb66772b38d7581 = function getStandaloneBackgroundColorMarks(content) {
    var standaloneMarks = [];
    // keep track of the previous node's state
    var prev = {
        selfSpaceOnTheRight: true // initial value to handle leading BackgroundColor
    };
    var prevNode = null;
    // Iterates through each node in the content array.
    // Tracks if the previous node had a backgroundColor mark and if it ended with a space.
    // If a backgroundColor mark is followed by a text node that starts with a space,
    // and the previous node ended with a space, the previous backgroundColor mark is considered standalone.
    // At the end, flushes any remaining node that meets the standalone criteria.
    for(var i = 0; i < content.length; i++){
        var node = content[i];
        var nodeMarks = (0, $412c6966035531bf$export$2e2bcd8739ae039).getMarks(node);
        var isBackgroundColor = nodeMarks.some(function(m) {
            return m.type.name === 'backgroundColor';
        });
        var selfSpaceOnTheLeft = false;
        var selfSpaceOnTheRight = false;
        if (node.text) {
            selfSpaceOnTheLeft = node.text.startsWith(' ');
            selfSpaceOnTheRight = node.text.endsWith(' ');
        }
        if (isBackgroundColor) {
            prevNode = node;
            prev = {
                selfSpaceOnTheRight: false,
                hasBackgroundColor: true,
                spaceToTheLeft: prev !== null && prev.selfSpaceOnTheRight
            };
        } else {
            // If prev exists, check for standalone logic
            if (prev && prev.hasBackgroundColor && prevNode) // If prev had space on the left and current is a TextNode and has space on the left
            {
                if (prev.spaceToTheLeft && selfSpaceOnTheLeft) {
                    var mark = (0, $412c6966035531bf$export$2e2bcd8739ae039).getMarks(prevNode).find(function(m) {
                        return m.type.name === 'backgroundColor';
                    });
                    if (mark) standaloneMarks.push(mark);
                }
            }
            prevNode = null;
            prev = {
                selfSpaceOnTheRight: selfSpaceOnTheRight,
                hasBackgroundColor: false
            };
        }
    }
    if (prevNode) {
        if (prev && prev.hasBackgroundColor && prev.spaceToTheLeft) {
            var _mark = (0, $412c6966035531bf$export$2e2bcd8739ae039).getMarks(prevNode).find(function(m) {
                return m.type.name === 'backgroundColor';
            });
            if (_mark) standaloneMarks.push(_mark);
        }
    }
    return standaloneMarks;
};


var $412c6966035531bf$var$_excluded = [
    "key"
];
function $412c6966035531bf$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $412c6966035531bf$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $412c6966035531bf$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $412c6966035531bf$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $412c6966035531bf$var$mergeMarks(marksAndNodes) {
    return marksAndNodes.reduce(function(acc, markOrNode) {
        var prev = acc.length && acc[acc.length - 1] || null;
        if (markOrNode.type instanceof (0, $2gI99.MarkType) && prev && prev.type instanceof (0, $2gI99.MarkType) && Array.isArray(prev.content) && (0, $5558251c256ad6af$export$b1304404bdc42b7a)(prev, markOrNode)) prev.content = $412c6966035531bf$var$mergeMarks(prev.content.concat(markOrNode.content));
        else acc.push(markOrNode);
        return acc;
    }, []);
}
var $412c6966035531bf$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function ReactSerializer(init) {
        var _this = this;
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, ReactSerializer);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "headingIds", []);
        /**
     * The reason we have this extra array here is because we need to generate the same unique
     * heading id for 2 different nodes: headers and expands (check the implementation of
     * `getUniqueHeadingId` for more info).
     *
     * We will eventually need to refactor the current approach to generate unique ids
     * for headers under this ticket -> https://product-fabric.atlassian.net/browse/ED-9668
     */ (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "expandHeadingIds", []);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "allowCopyToClipboard", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "allowWrapCodeBlock", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "allowPlaceholderText", true);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "allowCustomPanels", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "surroundTextNodesWithTextWrapper", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "allowAnnotations", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "standaloneBackgroundColorMarks", []);
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "serializeFragmentChild", function(node, _ref) {
            var index = _ref.index, parentInfo = _ref.parentInfo;
            var pos = _this.startPos;
            var currentPath = parentInfo && parentInfo.path || [];
            var parentIsIncompleteTask = (node.type.name === 'taskItem' || node.type.name === 'blockTaskItem' && (0, $drUcN.expValEquals)('platform_editor_blocktaskitem_node_tenantid', 'isEnabled', true)) && node.attrs.state !== 'DONE' || // If blockTaskItem is in the schema, check if the parent of the current node
            // is an incomplete task item, because blockTaskItems can have nested nodes
            node.type.schema.nodes.blockTaskItem && (parentInfo === null || parentInfo === void 0 ? void 0 : parentInfo.parentIsIncompleteTask) === true && (0, $drUcN.expValEquals)('platform_editor_blocktaskitem_node_tenantid', 'isEnabled', true);
            var nodeKey = "".concat(node.type.name, "__").concat(_this.startPos);
            var serializedContent = _this.serializeFragment(node.content, _this.getNodeProps(node, parentInfo), (0, $9M0Oh.toReact)(node, {
                allowSelectAllTrap: _this.allowSelectAllTrap,
                allowWindowedCodeBlock: _this.allowWindowedCodeBlock
            }, _this.nodeComponents), nodeKey, {
                parentIsIncompleteTask: parentIsIncompleteTask,
                path: [].concat((0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(currentPath), [
                    node
                ]),
                pos: _this.startPos
            });
            _this.startPos = pos + node.nodeSize;
            var marks = node.marks ? (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(node.marks) : [];
            var isMedia = node.type.name === 'media';
            var shouldSkipBorderMark = function shouldSkipBorderMark(mark) {
                return currentPath.some(function(n) {
                    var _n$type;
                    return ((_n$type = n.type) === null || _n$type === void 0 ? void 0 : _n$type.name) !== 'mediaSingle';
                }) && isMedia && mark.type.name === 'border';
            };
            var shouldSkipLinkMark = function shouldSkipLinkMark(mark) {
                return _this.allowMediaLinking !== true && isMedia && mark.type.name === 'link';
            };
            return marks.reduceRight(function(content, mark) {
                if (shouldSkipLinkMark(mark) || shouldSkipBorderMark(mark)) return content;
                return _this.renderMark((0, $6ea97fdfef30088f$export$d4334b129116aad7)(mark), _this.withMediaMarkProps(node, mark, _this.getMarkProps(mark, [], node)), "".concat(mark.type.name, "-").concat(index), content);
            }, serializedContent);
        });
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "withMediaMarkProps", function(node, mark, defaultProps) {
            if (mark.type.name === 'link' && node.type.name === 'media') return $412c6966035531bf$var$_objectSpread($412c6966035531bf$var$_objectSpread({}, defaultProps), {}, {
                isMediaLink: true
            });
            if (node.type.name === 'mediaInline' && mark.type.name === 'annotation') return $412c6966035531bf$var$_objectSpread($412c6966035531bf$var$_objectSpread({}, defaultProps), {}, {
                isMediaInline: true
            });
            return defaultProps;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "getUnsupportedContentProps", function(node) {
            return {
                node: node,
                dispatchAnalyticsEvent: _this.fireAnalyticsEvent
            };
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "getAnnotationMarkProps", function(mark, marksParentPath) {
            var annotationParentIds = (marksParentPath || []).reduce(function(acc, parent) {
                if ((0, $w2fDc.isAnnotationMark)(parent)) return [].concat((0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(acc), [
                    parent.attrs.id
                ]);
                return acc;
            }, []);
            return {
                id: mark.attrs.id,
                annotationType: mark.attrs.annotationType,
                annotationParentIds: annotationParentIds,
                allowAnnotations: _this.allowAnnotations,
                dataAttributes: {
                    'data-renderer-mark': true
                }
            };
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(this, "getMarkProps", function(mark, marksParentPath, node) {
            if ((0, $w2fDc.isAnnotationMark)(mark)) return _this.getAnnotationMarkProps(mark, marksParentPath);
            var _mark$attrs = mark.attrs, key = _mark$attrs.key, otherAttrs = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_mark$attrs, $412c6966035531bf$var$_excluded);
            var extraProps = {
                isInline: node === null || node === void 0 ? void 0 : node.isInline
            };
            // currently the only mark which has custom props is the code mark
            var markSpecificProps = (0, $7b2d933bcff57ef4$export$86390c02c110ec2f)(mark) ? {
                // The appearance being mobile indicates we are in an renderer being
                // rendered by mobile bridge in a web view.
                // The tooltip is likely to have unexpected behaviour there, with being cut
                // off, so we disable it. This is also to keep the behaviour consistent with
                // the rendering in the mobile Native Renderer.
                codeBidiWarningTooltipEnabled: false
            } : {};
            // Add deepLinkTarget for link marks
            var linkSpecificProps = mark.type.name === 'link' ? {
                onSetLinkTarget: _this.onSetLinkTarget
            } : {};
            var props = $412c6966035531bf$var$_objectSpread($412c6966035531bf$var$_objectSpread($412c6966035531bf$var$_objectSpread($412c6966035531bf$var$_objectSpread($412c6966035531bf$var$_objectSpread({
                eventHandlers: _this.eventHandlers,
                fireAnalyticsEvent: _this.fireAnalyticsEvent,
                markKey: key
            }, otherAttrs), extraProps), markSpecificProps), linkSpecificProps), {}, {
                dataAttributes: {
                    'data-renderer-mark': true
                }
            });
            return props;
        });
        if ((0, $fAhSf.editorExperiment)('comment_on_bodied_extensions', true)) {
            this.initStartPos = init.startPos || 1;
            this.startPos = init.startPos || 1;
        } else {
            this.initStartPos = 1;
            this.startPos = 1;
        }
        this.providers = init.providers;
        this.eventHandlers = init.eventHandlers;
        this.extensionHandlers = init.extensionHandlers;
        this.portal = init.portal;
        this.rendererContext = init.objectContext;
        this.appearance = init.appearance;
        this.contentMode = init.contentMode;
        this.disableHeadingIDs = init.disableHeadingIDs;
        this.disableActions = init.disableActions;
        this.allowHeadingAnchorLinks = init.allowHeadingAnchorLinks;
        this.allowCopyToClipboard = init.allowCopyToClipboard;
        this.allowWrapCodeBlock = init.allowWrapCodeBlock;
        this.allowPlaceholderText = init.allowPlaceholderText;
        this.allowCustomPanels = init.allowCustomPanels;
        this.allowColumnSorting = init.allowColumnSorting;
        this.fireAnalyticsEvent = init.fireAnalyticsEvent;
        this.shouldOpenMediaViewer = init.shouldOpenMediaViewer;
        this.allowAltTextOnImages = init.allowAltTextOnImages;
        this.stickyHeaders = init.stickyHeaders;
        this.allowMediaLinking = init.allowMediaLinking;
        this.allowAnnotations = Boolean(init.allowAnnotations);
        this.surroundTextNodesWithTextWrapper = Boolean(init.surroundTextNodesWithTextWrapper);
        this.media = init.media;
        this.emojiResourceConfig = init.emojiResourceConfig;
        this.smartLinks = init.smartLinks;
        this.extensionViewportSizes = init.extensionViewportSizes;
        this.getExtensionHeight = init.getExtensionHeight;
        this.allowSelectAllTrap = init.allowSelectAllTrap;
        this.nodeComponents = init.nodeComponents;
        this.allowWindowedCodeBlock = init.allowWindowedCodeBlock;
        this.isInsideOfInlineExtension = init.isInsideOfInlineExtension;
        this.textHighlighter = init.textHighlighter;
        this.allowTableAlignment = init.allowTableAlignment;
        this.allowTableResizing = init.allowTableResizing;
        this.isPresentational = init.isPresentational;
        this.disableTableOverflowShadow = init.disableTableOverflowShadow;
        this.onSetLinkTarget = init.onSetLinkTarget;
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(ReactSerializer, [
        {
            key: "resetState",
            value: function resetState() {
                this.headingIds = [];
                this.expandHeadingIds = [];
                this.startPos = this.initStartPos;
            }
        },
        {
            key: "getNodeProps",
            value: function getNodeProps(node, parentInfo) {
                var path = parentInfo ? parentInfo.path : undefined;
                switch(node.type.name){
                    case 'date':
                        return this.getDateProps(node, parentInfo, path);
                    case 'hardBreak':
                        return this.getHardBreakProps(node, path);
                    case 'heading':
                        return this.getHeadingProps(node, path);
                    case 'media':
                        return this.getMediaProps(node, path);
                    case 'emoji':
                        return this.getEmojiProps(node, path);
                    case 'extension':
                    case 'bodiedExtension':
                        return this.getExtensionProps(node, path);
                    case 'mediaGroup':
                        return this.getMediaGroupProps(node);
                    case 'mediaInline':
                        return this.getMediaInlineProps(node);
                    case 'mediaSingle':
                        return this.getMediaSingleProps(node, path);
                    case 'table':
                        return this.getTableProps(node, path);
                    case 'tableHeader':
                    case 'tableRow':
                        return this.getTableChildrenProps(node);
                    case 'taskItem':
                        return this.getTaskItemProps(node, path);
                    case 'embedCard':
                        return this.getEmbedCardProps(node, path);
                    case 'blockCard':
                        return this.getBlockCardProps(node, path);
                    case 'expand':
                        return this.getExpandProps(node, path);
                    case 'unsupportedBlock':
                    case 'unsupportedInline':
                        return this.getUnsupportedContentProps(node);
                    case 'codeBlock':
                        return this.getCodeBlockProps(node);
                    case 'panel':
                        return this.getPanelProps(node);
                    default:
                        return this.getProps(node, path);
                }
            }
        },
        {
            key: "serializeFragment",
            value: function serializeFragment(fragment) {
                var _this2 = this;
                var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var target = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : this.allowSelectAllTrap ? (0, $ac0Rs.DocWithSelectAllTrap) : (0, $ac0Rs.default);
                var key = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'root-0';
                var parentInfo = arguments.length > 4 ? arguments[4] : undefined;
                // This makes sure that we reset internal state on re-render.
                if (key === 'root-0') this.resetState();
                return this.renderNode(target, props, key, ReactSerializer.getChildNodes(fragment).map(function(node, index) {
                    if ((0, $9M0Oh.isTextWrapper)(node)) return _this2.serializeTextWrapper(node.content, {
                        index: index,
                        parentInfo: parentInfo
                    });
                    return _this2.serializeFragmentChild(node, {
                        index: index,
                        parentInfo: parentInfo
                    });
                }));
            }
        },
        {
            key: "serializeTextWrapper",
            value: function serializeTextWrapper(content, _ref2) {
                var _this3 = this;
                var parentInfo = _ref2.parentInfo;
                var currentPath = parentInfo && parentInfo.path || [];
                var nodePosition = parentInfo && parentInfo.pos || 1;
                if ((0, $drUcN.expValEquals)('platform_editor_text_highlight_padding', 'isEnabled', true)) {
                    var _this$standaloneBackg;
                    (_this$standaloneBackg = this.standaloneBackgroundColorMarks).push.apply(_this$standaloneBackg, (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))((0, $6af2eee65b21fc1b$export$eeb66772b38d7581)(content)));
                }
                return ReactSerializer.buildMarkStructure(content).map(function(mark, _index) {
                    return _this3.serializeMark({
                        mark: mark,
                        parentNode: {
                            path: currentPath,
                            pos: nodePosition
                        },
                        parentMark: {
                            path: [
                                mark
                            ]
                        }
                    });
                });
            }
        },
        {
            key: "serializeMark",
            value: function serializeMark(_ref3) {
                var _this4 = this;
                var mark = _ref3.mark, parentNode = _ref3.parentNode, parentMark = _ref3.parentMark;
                if (!(0, $9M0Oh.isTextNode)(mark)) {
                    var serializeContent = function serializeContent(childMark, _index) {
                        return _this4.serializeMark({
                            mark: childMark,
                            parentNode: parentNode,
                            parentMark: {
                                path: [].concat((0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(parentMark.path), [
                                    childMark
                                ])
                            }
                        });
                    };
                    // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    var content = (mark.content || []).map(serializeContent);
                    var markKey = "".concat(mark.type.name, "-component__").concat(this.startPos, "__").concat(parentMark.path.length);
                    var isStandalone = (0, $drUcN.expValEquals)('platform_editor_text_highlight_padding', 'isEnabled', true) && this.standaloneBackgroundColorMarks.some(function(m) {
                        return mark.eq(m);
                    });
                    return this.renderMark((0, $6ea97fdfef30088f$export$d4334b129116aad7)(mark), $412c6966035531bf$var$_objectSpread($412c6966035531bf$var$_objectSpread({}, this.getMarkProps(mark, parentMark.path)), {}, {
                        isStandalone: isStandalone
                    }), markKey, content);
                }
                var startPos = this.startPos;
                var endPos = startPos + mark.nodeSize;
                this.startPos = endPos;
                var textKey = "text-wrapper_".concat(this.startPos);
                if (this.surroundTextNodesWithTextWrapper) {
                    var parentDepth = Math.max(parentNode.path.length - 1, 0);
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $0add6e4a2440403c$export$2e2bcd8739ae039), {
                        key: textKey,
                        startPos: startPos + parentDepth,
                        endPos: endPos + parentDepth,
                        textHighlighter: this.textHighlighter,
                        marks: mark.marks
                    }, mark.text);
                }
                var segments = (0, $da823e371d629bd7$export$93301b6f1ff0b0c3)(mark.text, this.textHighlighter);
                return (0, $00533252bf4c5c68$export$8a20fd0614851c5f)(segments, this.textHighlighter, mark.marks, startPos);
            }
        },
        {
            key: "renderNode",
            value: function renderNode(// Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            NodeComponent, // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            props, key, // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            content) {
                return(/*#__PURE__*/ // Ignored via go/ees005
                // eslint-disable-next-line react/jsx-props-no-spreading
                (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(NodeComponent, (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
                    key: key
                }, props), content));
            }
        },
        {
            key: "renderMark",
            value: function renderMark(// Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            MarkComponent, props, key, // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            content) {
                return(/*#__PURE__*/ // Ignored via go/ees005
                // eslint-disable-next-line react/jsx-props-no-spreading
                (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(MarkComponent, (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
                    key: key
                }, props), content));
            }
        },
        {
            key: "getTableChildrenProps",
            value: function getTableChildrenProps(node) {
                return $412c6966035531bf$var$_objectSpread($412c6966035531bf$var$_objectSpread({}, this.getProps(node)), {}, {
                    allowColumnSorting: this.allowColumnSorting
                });
            }
        },
        {
            key: "getTableProps",
            value: function getTableProps(node) {
                var path = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
                var isInsideOfBlockNode = (0, $0b366d21bf0dee21$export$42ddc573eb5a7b43)(path, node.type.schema);
                var isInsideMultiBodiedExtension = (0, $0b366d21bf0dee21$export$9f1e9347b0411934)(path, node.type.schema);
                var isInsideOfTable = (0, $0b366d21bf0dee21$export$244bf4b32387ef62)(path, node.type.schema);
                // TODO: CEMS-1048 - Support sticky headers inside breakout + layout
                var stickyHeaders = !isInsideOfTable && !(0, $0b366d21bf0dee21$export$d7bc71cca336a3b)(path) ? this.stickyHeaders : undefined;
                return $412c6966035531bf$var$_objectSpread($412c6966035531bf$var$_objectSpread({}, this.getProps(node)), {}, {
                    allowColumnSorting: this.allowColumnSorting,
                    columnWidths: (0, $il4RY.getColumnWidths)(node),
                    tableNode: node,
                    stickyHeaders: stickyHeaders,
                    isInsideOfBlockNode: isInsideOfBlockNode,
                    isInsideOfTable: isInsideOfTable,
                    isInsideMultiBodiedExtension: isInsideMultiBodiedExtension,
                    allowTableAlignment: this.allowTableAlignment,
                    allowTableResizing: this.allowTableResizing,
                    isPresentational: (0, $9Zzpd.fg)('platform_renderer_isPresentational') ? this.isPresentational : false,
                    disableTableOverflowShadow: this.disableTableOverflowShadow
                });
            }
        },
        {
            key: "getDateProps",
            value: function getDateProps(node, parentInfo) {
                var path = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
                return {
                    timestamp: node.attrs && node.attrs.timestamp,
                    parentIsIncompleteTask: parentInfo && parentInfo.parentIsIncompleteTask,
                    dataAttributes: {
                        // We need to account for depth (path.length gives up depth) here
                        // but depth doesnt increment the pos, only accounted for.
                        'data-renderer-start-pos': this.startPos + path.length
                    }
                };
            }
        },
        {
            key: "getMediaSingleProps",
            value: function getMediaSingleProps(node) {
                var _this5 = this;
                var path = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
                var link = node.type.schema.marks.link;
                var isInsideOfBlockNode = (0, $0b366d21bf0dee21$export$42ddc573eb5a7b43)(path, node.type.schema);
                var isLinkMark = function isLinkMark(mark) {
                    return mark.type === link;
                };
                var childHasLink = node.firstChild && node.firstChild.marks.filter(function(m) {
                    return isLinkMark(m) || _this5.allowMediaLinking === true;
                }).length;
                return $412c6966035531bf$var$_objectSpread($412c6966035531bf$var$_objectSpread({}, this.getProps(node, path)), {}, {
                    isInsideOfBlockNode: isInsideOfBlockNode,
                    childHasLink: childHasLink,
                    allowCaptions: this.media && this.media.allowCaptions,
                    featureFlags: this.media && this.media.featureFlags
                });
            }
        },
        {
            key: "getMediaProps",
            value: function getMediaProps(node) {
                var _this6 = this, _this$media, _this$media2;
                var path = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
                var _node$type$schema$mar = node.type.schema.marks, annotation = _node$type$schema$mar.annotation, link = _node$type$schema$mar.link, border = _node$type$schema$mar.border;
                var isChildOfMediaSingle = path.some(function(n) {
                    var _n$type2;
                    return ((_n$type2 = n.type) === null || _n$type2 === void 0 ? void 0 : _n$type2.name) === 'mediaSingle';
                });
                var isAnnotationMark = function isAnnotationMark(mark) {
                    return mark.type === annotation;
                };
                var isLinkMark = function isLinkMark(mark) {
                    return mark.type === link;
                };
                var isBorderMark = function isBorderMark(mark) {
                    return isChildOfMediaSingle && mark.type === border;
                };
                return $412c6966035531bf$var$_objectSpread($412c6966035531bf$var$_objectSpread({}, this.getProps(node, path)), {}, {
                    marks: node.marks.filter(function(m) {
                        return !isLinkMark(m) || _this6.allowMediaLinking === true;
                    }),
                    isLinkMark: isLinkMark,
                    isBorderMark: isBorderMark,
                    isAnnotationMark: isAnnotationMark,
                    allowAltTextOnImages: this.allowAltTextOnImages,
                    featureFlags: this.media && this.media.featureFlags,
                    shouldOpenMediaViewer: this.shouldOpenMediaViewer,
                    ssr: (_this$media = this.media) === null || _this$media === void 0 ? void 0 : _this$media.ssr,
                    // surroundTextNodesWithTextWrapper checks inlineComment.allowDraftMode
                    allowAnnotationsDraftMode: this.surroundTextNodesWithTextWrapper,
                    enableSyncMediaCard: (_this$media2 = this.media) === null || _this$media2 === void 0 ? void 0 : _this$media2.enableSyncMediaCard
                });
            }
        },
        {
            key: "getExtensionProps",
            value: function getExtensionProps(node) {
                var _this$getExtensionHei;
                var path = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
                return $412c6966035531bf$var$_objectSpread($412c6966035531bf$var$_objectSpread({}, this.getProps(node, path)), {}, {
                    extensionViewportSizes: this.extensionViewportSizes,
                    nodeHeight: (_this$getExtensionHei = this.getExtensionHeight) === null || _this$getExtensionHei === void 0 ? void 0 : _this$getExtensionHei.call(this, node)
                });
            }
        },
        {
            key: "getEmojiProps",
            value: function getEmojiProps(node) {
                var path = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
                return $412c6966035531bf$var$_objectSpread($412c6966035531bf$var$_objectSpread({}, this.getProps(node, path)), {}, {
                    resourceConfig: this.emojiResourceConfig
                });
            }
        },
        {
            key: "getEmbedCardProps",
            value: function getEmbedCardProps(node) {
                var path = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
                var isInsideOfBlockNode = (0, $0b366d21bf0dee21$export$42ddc573eb5a7b43)(path, node.type.schema);
                return $412c6966035531bf$var$_objectSpread($412c6966035531bf$var$_objectSpread({}, this.getProps(node)), {}, {
                    isInsideOfBlockNode: isInsideOfBlockNode
                });
            }
        },
        {
            key: "getBlockCardProps",
            value: function getBlockCardProps(node) {
                var path = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
                return $412c6966035531bf$var$_objectSpread($412c6966035531bf$var$_objectSpread({}, this.getProps(node)), {}, {
                    isNodeNested: path.length > 0
                });
            }
        },
        {
            key: "getMediaGroupProps",
            value: function getMediaGroupProps(node) {
                var _this$media3, _this$media4;
                return $412c6966035531bf$var$_objectSpread($412c6966035531bf$var$_objectSpread({}, this.getProps(node)), {}, {
                    shouldOpenMediaViewer: this.shouldOpenMediaViewer,
                    allowAltTextOnImages: this.allowAltTextOnImages,
                    featureFlags: this.media && this.media.featureFlags,
                    enableDownloadButton: (_this$media3 = this.media) === null || _this$media3 === void 0 ? void 0 : _this$media3.enableDownloadButton,
                    ssr: (_this$media4 = this.media) === null || _this$media4 === void 0 ? void 0 : _this$media4.ssr
                });
            }
        },
        {
            key: "getMediaInlineProps",
            value: function getMediaInlineProps(node) {
                var _this$media5;
                return $412c6966035531bf$var$_objectSpread($412c6966035531bf$var$_objectSpread({}, this.getProps(node)), {}, {
                    ssr: (_this$media5 = this.media) === null || _this$media5 === void 0 ? void 0 : _this$media5.ssr
                });
            }
        },
        {
            key: "getTaskItemProps",
            value: function getTaskItemProps(node) {
                var path = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
                return $412c6966035531bf$var$_objectSpread($412c6966035531bf$var$_objectSpread({}, this.getProps(node, path)), {}, {
                    disabled: this.disableActions
                });
            }
        },
        {
            key: "getHardBreakProps",
            value: function getHardBreakProps(node) {
                var path = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
                var forceNewLine = false;
                var parentNode = path.length > 0 ? path[path.length - 1] : null;
                if (parentNode && parentNode.lastChild === node) forceNewLine = true;
                return $412c6966035531bf$var$_objectSpread($412c6966035531bf$var$_objectSpread({}, this.getProps(node)), {}, {
                    forceNewLine: forceNewLine
                });
            }
        },
        {
            key: "getCodeBlockProps",
            value: function getCodeBlockProps(node) {
                // The appearance being mobile indicates we are in an renderer being
                // rendered by mobile bridge in a web view.
                // The tooltip is likely to have unexpected behaviour there, with being cut
                // off, so we disable it. This is also to keep the behaviour consistent with
                // the rendering in the mobile Native Renderer.
                var codeBidiWarningTooltipEnabled = false;
                return $412c6966035531bf$var$_objectSpread($412c6966035531bf$var$_objectSpread({}, this.getProps(node)), {}, {
                    text: node.textContent,
                    codeBidiWarningTooltipEnabled: codeBidiWarningTooltipEnabled
                });
            }
        },
        {
            key: "getPanelProps",
            value: function getPanelProps(node) {
                return $412c6966035531bf$var$_objectSpread($412c6966035531bf$var$_objectSpread({}, this.getProps(node)), {}, {
                    allowCustomPanels: this.allowCustomPanels
                });
            }
        },
        {
            key: "getProps",
            value: function getProps(node) {
                var path = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
                var startPos = this.startPos + path.length;
                return $412c6966035531bf$var$_objectSpread({
                    text: node.text,
                    providers: this.providers,
                    eventHandlers: this.eventHandlers,
                    extensionHandlers: this.extensionHandlers,
                    portal: this.portal,
                    rendererContext: this.rendererContext,
                    serializer: this,
                    content: node.content ? node.content.toJSON() : undefined,
                    allowHeadingAnchorLinks: this.allowHeadingAnchorLinks,
                    allowCopyToClipboard: this.allowCopyToClipboard,
                    allowWrapCodeBlock: this.allowWrapCodeBlock,
                    allowPlaceholderText: this.allowPlaceholderText,
                    rendererAppearance: this.appearance,
                    rendererContentMode: this.contentMode,
                    fireAnalyticsEvent: this.fireAnalyticsEvent,
                    nodeType: node.type.name,
                    marks: node.marks,
                    smartLinks: this.smartLinks,
                    isInsideOfInlineExtension: this.isInsideOfInlineExtension,
                    dataAttributes: {
                        // We need to account for depth (path.length gives up depth) here
                        // but depth doesnt increment the pos, only accounted for.
                        'data-renderer-start-pos': startPos
                    },
                    startPos: startPos,
                    path: path
                }, node.attrs);
            }
        },
        {
            key: "headingAnchorSupported",
            value: function headingAnchorSupported() {
                var path = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
                var isImmediateParent = function isImmediateParent(path, nodeName) {
                    return path.length > 0 && path[path.length - 1].type.name === nodeName;
                };
                return (0, $e382f311073cdba5$export$7aa7587d1ce9583c)(this.allowHeadingAnchorLinks) || path.length === 0 || isImmediateParent(path, 'layoutColumn');
            }
        },
        {
            key: "getHeadingProps",
            value: function getHeadingProps(node) {
                var path = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
                return $412c6966035531bf$var$_objectSpread($412c6966035531bf$var$_objectSpread({}, this.getProps(node, path)), {}, {
                    content: node.content ? node.content.toJSON() : undefined,
                    headingId: this.getHeadingId(node, this.headingIds),
                    showAnchorLink: this.appearance !== 'comment' && this.allowHeadingAnchorLinks && !this.disableHeadingIDs && this.headingAnchorSupported(path)
                });
            }
        },
        {
            key: "getExpandProps",
            value: function getExpandProps(node) {
                var _this7 = this;
                var _path = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
                if (!(0, $e382f311073cdba5$export$7aa7587d1ce9583c)(this.allowHeadingAnchorLinks)) return this.getProps(node);
                var nestedHeaderIds = (0, $a94aebd51bef5436$export$96bb9476c7c69f39)(node, node.type.schema.nodes.heading).map(function(_ref4) {
                    var node = _ref4.node;
                    return _this7.getHeadingId(node, _this7.expandHeadingIds);
                });
                return $412c6966035531bf$var$_objectSpread($412c6966035531bf$var$_objectSpread({}, this.getProps(node)), {}, {
                    nestedHeaderIds: nestedHeaderIds
                });
            }
        },
        {
            key: "getHeadingId",
            value: function getHeadingId(node, headingIds) {
                if (this.disableHeadingIDs || !node.content.size) return;
                // We are not use node.textContent here, because we would like to handle cases where
                // headings only contain inline blocks like emoji, status and date.
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                var nodeContent = node.content.toJSON()// Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                .reduce(function(acc, node) {
                    return acc.concat((0, $9F9pG.getText)(node) || '');
                }, '').trim()// Ignored via go/ees005
                // eslint-disable-next-line require-unicode-regexp
                .replace(/\s/g, '-');
                if (!nodeContent) return;
                return this.getUniqueHeadingId(nodeContent, headingIds);
            }
        },
        {
            key: "getUniqueHeadingId",
            value: function getUniqueHeadingId(baseId, headingIds) {
                var counter = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
                if (counter === 0 && headingIds.indexOf(baseId) === -1) {
                    headingIds.push(baseId);
                    return baseId;
                } else if (counter !== 0) {
                    var headingId = "".concat(baseId, ".").concat(counter);
                    if (headingIds.indexOf(headingId) === -1) {
                        headingIds.push(headingId);
                        return headingId;
                    }
                }
                return this.getUniqueHeadingId(baseId, headingIds, ++counter);
            }
        }
    ], [
        {
            key: "getChildNodes",
            value: function getChildNodes(fragment) {
                var children = [];
                fragment.forEach(function(node) {
                    children.push(node);
                });
                return (0, $9M0Oh.mergeTextNodes)(children);
            }
        },
        {
            key: "getMarks",
            value: function getMarks(node) {
                if (!node.marks || node.marks.length === 0) return [];
                return (0, $5558251c256ad6af$export$99a33ed044c278ae)(node.marks);
            }
        },
        {
            key: "buildMarkStructure",
            value: function buildMarkStructure(content) {
                var _this8 = this;
                return $412c6966035531bf$var$mergeMarks(content.map(function(node) {
                    var nodeMarks = _this8.getMarks(node);
                    if (nodeMarks.length === 0) return node;
                    return nodeMarks.reverse().reduce(function(acc, mark) {
                        var eq = mark.eq;
                        return $412c6966035531bf$var$_objectSpread($412c6966035531bf$var$_objectSpread({}, mark), {}, {
                            eq: eq,
                            content: [
                                acc
                            ]
                        });
                    // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    }, node);
                }));
            }
        },
        {
            key: "fromSchema",
            value: function fromSchema(_, init) {
                return new ReactSerializer(init);
            }
        }
    ]);
}();


var $iYJcE = parcelRequire("iYJcE");

var $kYLlQ = parcelRequire("kYLlQ");

var $30Iuw = parcelRequire("30Iuw");
var $793534cea0118fed$export$6528700f3fa2fe2a = function transformMediaLinkMarks(adf) {
    var isTransformed = false;
    var transformedAdf = (0, $30Iuw.traverse)(adf, {
        mediaSingle: function mediaSingle(node) {
            var _node$content$;
            if (!node.marks || !node.content || ((_node$content$ = node.content[0]) === null || _node$content$ === void 0 ? void 0 : _node$content$.type) !== 'media') return node;
            var linkMark = null;
            node.marks.forEach(function(mark, i) {
                if (mark.type === 'link') {
                    var _node$marks;
                    linkMark = mark;
                    (_node$marks = node.marks) === null || _node$marks === void 0 || _node$marks.splice(i, 1);
                    isTransformed = true;
                }
            });
            if (node.marks.length === 0) delete node.marks;
            if (linkMark) {
                var _mediaNode$marks;
                var mediaNode = node.content[0];
                // only add link mark if media node doesnt already have one
                if ((_mediaNode$marks = mediaNode.marks) !== null && _mediaNode$marks !== void 0 && _mediaNode$marks.every(function(mark) {
                    return mark.type !== 'link';
                })) mediaNode.marks.push(linkMark);
                else if (!mediaNode.marks) mediaNode.marks = [
                    linkMark
                ];
            }
            return node;
        }
    });
    return {
        transformedAdf: transformedAdf,
        isTransformed: isTransformed
    };
};


var $25nEq = parcelRequire("25nEq");

var $30Iuw = parcelRequire("30Iuw");
var $d73f6d774103b804$export$1b45514b112dd749 = function extension(attrs) {
    return {
        type: 'extension',
        attrs: attrs
    };
};



var $arMYe = parcelRequire("arMYe");

var $9P61R = parcelRequire("9P61R");

var $kIXpt = parcelRequire("kIXpt");

var $cYPzS = parcelRequire("cYPzS");

var $eyuDe = parcelRequire("eyuDe");

var $c7s0H = parcelRequire("c7s0H");
function $777fc947739da8ed$var$_callSuper(t, o, e) {
    return o = (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(o), (0, (/*@__PURE__*/$parcel$interopDefault($kIXpt)))(t, $777fc947739da8ed$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(t).constructor) : o.apply(t, e));
}
function $777fc947739da8ed$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($777fc947739da8ed$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $777fc947739da8ed$export$3d8e8d2182f13924 = /*#__PURE__*/ function(_Error) {
    /**
   * @param message - Error message - Do not use any UGC in this message
   */ function NodeNestingTransformError(message) {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, NodeNestingTransformError);
        _this = $777fc947739da8ed$var$_callSuper(this, NodeNestingTransformError, [
            message
        ]);
        _this.name = 'NodeNestingTransformError';
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($eyuDe)))(NodeNestingTransformError, _Error);
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(NodeNestingTransformError);
}(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($c7s0H)))(Error));


function $471646a78c6cd88f$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $471646a78c6cd88f$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $471646a78c6cd88f$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $471646a78c6cd88f$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $471646a78c6cd88f$var$NESTED_TABLE_EXTENSION_TYPE = 'com.atlassian.confluence.migration', $471646a78c6cd88f$var$NESTED_TABLE_EXTENSION_KEY = 'nested-table';
var $471646a78c6cd88f$export$f45e7335ec874bfe = function isNestedTableExtension(extensionNode) {
    var _extensionNode$attrs, _extensionNode$attrs2;
    return ((_extensionNode$attrs = extensionNode.attrs) === null || _extensionNode$attrs === void 0 ? void 0 : _extensionNode$attrs.extensionType) === $471646a78c6cd88f$var$NESTED_TABLE_EXTENSION_TYPE && ((_extensionNode$attrs2 = extensionNode.attrs) === null || _extensionNode$attrs2 === void 0 ? void 0 : _extensionNode$attrs2.extensionKey) === $471646a78c6cd88f$var$NESTED_TABLE_EXTENSION_KEY;
};
var $471646a78c6cd88f$var$transformNestedTableExtension = function transformNestedTableExtension(nestedTableExtension) {
    var _nestedTableExtension;
    // No content - drop the extension node
    if (!((_nestedTableExtension = nestedTableExtension.attrs) !== null && _nestedTableExtension !== void 0 && (_nestedTableExtension = _nestedTableExtension.parameters) !== null && _nestedTableExtension !== void 0 && _nestedTableExtension.adf)) return false;
    try {
        var _nestedTableExtension2;
        var adf = JSON.parse((_nestedTableExtension2 = nestedTableExtension.attrs) === null || _nestedTableExtension2 === void 0 || (_nestedTableExtension2 = _nestedTableExtension2.parameters) === null || _nestedTableExtension2 === void 0 ? void 0 : _nestedTableExtension2.adf);
        if (!adf.content || adf.content.length === 0) return false;
        return adf.content[0];
    } catch (e) {
        throw new (0, $777fc947739da8ed$export$3d8e8d2182f13924)('Failed to parse nested table content');
    }
};
var $471646a78c6cd88f$export$18544d0b5f43e4a1 = function transformNestedTablesIncomingDocument(adf) {
    var isTransformed = false;
    var transformedAdf = (0, $30Iuw.traverse)(adf, {
        extension: function extension(node) {
            if ($471646a78c6cd88f$export$f45e7335ec874bfe(node)) {
                isTransformed = true;
                return $471646a78c6cd88f$var$transformNestedTableExtension(node);
            }
            return;
        }
    });
    return {
        transformedAdf: transformedAdf,
        isTransformed: isTransformed
    };
};
var $471646a78c6cd88f$export$8a334a7d9fe120ec = function transformNestedTableNodeOutgoingDocument(tableCellNode) {
    try {
        var _tableCellNode$conten;
        return $471646a78c6cd88f$var$_objectSpread($471646a78c6cd88f$var$_objectSpread({}, tableCellNode), {}, {
            content: (_tableCellNode$conten = tableCellNode.content) === null || _tableCellNode$conten === void 0 ? void 0 : _tableCellNode$conten.map(function(childNode) {
                // wrap nested table in an extension node
                if ((childNode === null || childNode === void 0 ? void 0 : childNode.type) === 'table') return (0, $d73f6d774103b804$export$1b45514b112dd749)({
                    extensionType: $471646a78c6cd88f$var$NESTED_TABLE_EXTENSION_TYPE,
                    extensionKey: $471646a78c6cd88f$var$NESTED_TABLE_EXTENSION_KEY,
                    parameters: {
                        adf: JSON.stringify({
                            type: 'doc',
                            version: 1,
                            content: [
                                childNode
                            ]
                        })
                    }
                });
                return childNode;
            })
        });
    } catch (e) {
        throw new (0, $777fc947739da8ed$export$3d8e8d2182f13924)('Failed to encode nested table node');
    }
};



var $jJH6F = parcelRequire("jJH6F");

var $fpooh = parcelRequire("fpooh");
var $25nEq = parcelRequire("25nEq");

var $iYJcE = parcelRequire("iYJcE");

var $ekGgq = parcelRequire("ekGgq");

var $25nEq = parcelRequire("25nEq");

var $1Vcia = parcelRequire("1Vcia");

var $6TmbT = parcelRequire("6TmbT");
var $db4a68befdfe02b0$exports = {};
$parcel$export($db4a68befdfe02b0$exports, "alignment", () => $d8c4c1fb31a84879$export$8e53000a4ec837);
$parcel$export($db4a68befdfe02b0$exports, "annotation", () => $d8c4c1fb31a84879$export$8512c9afa7b24c3b);
$parcel$export($db4a68befdfe02b0$exports, "backgroundColor", () => $d8c4c1fb31a84879$export$8c5a050822fd698c);
$parcel$export($db4a68befdfe02b0$exports, "blockCard", () => $d8c4c1fb31a84879$export$c4c2f833baaebdb8);
$parcel$export($db4a68befdfe02b0$exports, "block_content", () => $d8c4c1fb31a84879$export$a31afb40076fa18b);
$parcel$export($db4a68befdfe02b0$exports, "blockRootOnly", () => $d8c4c1fb31a84879$export$ebb5393736e9ba23);
$parcel$export($db4a68befdfe02b0$exports, "blockquote", () => $d8c4c1fb31a84879$export$67dc04e652a298ca);
$parcel$export($db4a68befdfe02b0$exports, "blockTaskItem", () => $d8c4c1fb31a84879$export$16018c61064a18df);
$parcel$export($db4a68befdfe02b0$exports, "bodiedExtension", () => $d8c4c1fb31a84879$export$27903d543b563e39);
$parcel$export($db4a68befdfe02b0$exports, "bodiedExtension_with_marks", () => $d8c4c1fb31a84879$export$ee052cc5b2356e83);
$parcel$export($db4a68befdfe02b0$exports, "border", () => $d8c4c1fb31a84879$export$1edee58a52776cd9);
$parcel$export($db4a68befdfe02b0$exports, "breakout", () => $d8c4c1fb31a84879$export$89015c65f1c75e3f);
$parcel$export($db4a68befdfe02b0$exports, "bulletList", () => $d8c4c1fb31a84879$export$a140c94e5ea26bee);
$parcel$export($db4a68befdfe02b0$exports, "caption", () => $d8c4c1fb31a84879$export$8e3c2dfdc4f0453d);
$parcel$export($db4a68befdfe02b0$exports, "code", () => $d8c4c1fb31a84879$export$6565f9f03506010b);
$parcel$export($db4a68befdfe02b0$exports, "codeBlock", () => $d8c4c1fb31a84879$export$7bb0d5c671655cc4);
$parcel$export($db4a68befdfe02b0$exports, "codeBlock_root_only", () => $d8c4c1fb31a84879$export$38d90d1aac6883a3);
$parcel$export($db4a68befdfe02b0$exports, "text_with_no_marks", () => $d8c4c1fb31a84879$export$437a3d96346717e0);
$parcel$export($db4a68befdfe02b0$exports, "confluenceInlineComment", () => $d8c4c1fb31a84879$export$f3b72f8fc4684ecd);
$parcel$export($db4a68befdfe02b0$exports, "dataConsumer", () => $d8c4c1fb31a84879$export$3024f02c495408d6);
$parcel$export($db4a68befdfe02b0$exports, "date", () => $d8c4c1fb31a84879$export$324d90190a8b822a);
$parcel$export($db4a68befdfe02b0$exports, "decisionItem", () => $d8c4c1fb31a84879$export$6959e16eeff859b4);
$parcel$export($db4a68befdfe02b0$exports, "decisionList", () => $d8c4c1fb31a84879$export$62d45a65fb43d95e);
$parcel$export($db4a68befdfe02b0$exports, "doc", () => $d8c4c1fb31a84879$export$2a111da947c407d2);
$parcel$export($db4a68befdfe02b0$exports, "em", () => $d8c4c1fb31a84879$export$c63c6f932822f543);
$parcel$export($db4a68befdfe02b0$exports, "embedCard", () => $d8c4c1fb31a84879$export$be4283d9a1cb1ff6);
$parcel$export($db4a68befdfe02b0$exports, "emoji", () => $d8c4c1fb31a84879$export$a19185d1233fc4b2);
$parcel$export($db4a68befdfe02b0$exports, "expand", () => $d8c4c1fb31a84879$export$9f77e0932fb78f72);
$parcel$export($db4a68befdfe02b0$exports, "expand_root_only", () => $d8c4c1fb31a84879$export$b2817c6954dd6d2c);
$parcel$export($db4a68befdfe02b0$exports, "extension", () => $d8c4c1fb31a84879$export$1b45514b112dd749);
$parcel$export($db4a68befdfe02b0$exports, "extensionFrame", () => $d8c4c1fb31a84879$export$4fdcae991fd743e7);
$parcel$export($db4a68befdfe02b0$exports, "extension_with_marks", () => $d8c4c1fb31a84879$export$15be7c145cec614a);
$parcel$export($db4a68befdfe02b0$exports, "fontSize", () => $d8c4c1fb31a84879$export$85e3c3ca0c6fb93);
$parcel$export($db4a68befdfe02b0$exports, "fragment", () => $d8c4c1fb31a84879$export$f00aeb236b6f05af);
$parcel$export($db4a68befdfe02b0$exports, "hardBreak", () => $d8c4c1fb31a84879$export$371da9dd35aba193);
$parcel$export($db4a68befdfe02b0$exports, "heading", () => $d8c4c1fb31a84879$export$46e4a324ac90507f);
$parcel$export($db4a68befdfe02b0$exports, "heading_with_alignment", () => $d8c4c1fb31a84879$export$c17edf9af655deaf);
$parcel$export($db4a68befdfe02b0$exports, "heading_with_indentation", () => $d8c4c1fb31a84879$export$1902f9737466a0dc);
$parcel$export($db4a68befdfe02b0$exports, "heading_with_no_marks", () => $d8c4c1fb31a84879$export$7b491e75f1be9278);
$parcel$export($db4a68befdfe02b0$exports, "indentation", () => $d8c4c1fb31a84879$export$480c699bd4ec0d86);
$parcel$export($db4a68befdfe02b0$exports, "inlineCard", () => $d8c4c1fb31a84879$export$cbf8224b64e0d942);
$parcel$export($db4a68befdfe02b0$exports, "inlineExtension", () => $d8c4c1fb31a84879$export$16b353b2649bd8d9);
$parcel$export($db4a68befdfe02b0$exports, "inlineExtension_with_marks", () => $d8c4c1fb31a84879$export$e37f10815f36843d);
$parcel$export($db4a68befdfe02b0$exports, "inline_content", () => $d8c4c1fb31a84879$export$e23e6162adaa368d);
$parcel$export($db4a68befdfe02b0$exports, "layoutColumn", () => $d8c4c1fb31a84879$export$ab76e7c03cd6f650);
$parcel$export($db4a68befdfe02b0$exports, "layoutSection", () => $d8c4c1fb31a84879$export$b3b6a70a7fa4a5be);
$parcel$export($db4a68befdfe02b0$exports, "layoutSection_full", () => $d8c4c1fb31a84879$export$941b63fbd931e449);
$parcel$export($db4a68befdfe02b0$exports, "layoutSection_with_single_column", () => $d8c4c1fb31a84879$export$e0e9834198e8601d);
$parcel$export($db4a68befdfe02b0$exports, "link", () => $d8c4c1fb31a84879$export$9c30223ca0a664fb);
$parcel$export($db4a68befdfe02b0$exports, "listItem", () => $d8c4c1fb31a84879$export$76c7e83ecc9cdf05);
$parcel$export($db4a68befdfe02b0$exports, "listItem_with_flexible_first_child", () => $d8c4c1fb31a84879$export$d80b696b842918ee);
$parcel$export($db4a68befdfe02b0$exports, "media", () => $d8c4c1fb31a84879$export$987d49ffe1b0900f);
$parcel$export($db4a68befdfe02b0$exports, "mediaGroup", () => $d8c4c1fb31a84879$export$2855e964765eac9);
$parcel$export($db4a68befdfe02b0$exports, "mediaInline", () => $d8c4c1fb31a84879$export$38bab695e3f720f1);
$parcel$export($db4a68befdfe02b0$exports, "mediaSingle", () => $d8c4c1fb31a84879$export$969fe3781ca15058);
$parcel$export($db4a68befdfe02b0$exports, "mediaSingle_caption", () => $d8c4c1fb31a84879$export$68b0ead306f9670f);
$parcel$export($db4a68befdfe02b0$exports, "mediaSingle_full", () => $d8c4c1fb31a84879$export$f7fd577406abd5f8);
$parcel$export($db4a68befdfe02b0$exports, "mention", () => $d8c4c1fb31a84879$export$db83999c14438df4);
$parcel$export($db4a68befdfe02b0$exports, "multiBodiedExtension", () => $d8c4c1fb31a84879$export$c3c04d555a8b9013);
$parcel$export($db4a68befdfe02b0$exports, "nestedExpand", () => $d8c4c1fb31a84879$export$63cadbf5f4296627);
$parcel$export($db4a68befdfe02b0$exports, "nestedExpand_content", () => $d8c4c1fb31a84879$export$9584f52f3ebd5d7e);
$parcel$export($db4a68befdfe02b0$exports, "nestedExpand_with_no_marks", () => $d8c4c1fb31a84879$export$b756fc994eb0bc4f);
$parcel$export($db4a68befdfe02b0$exports, "non_nestable_block_content", () => $d8c4c1fb31a84879$export$ed866000601e7fa5);
$parcel$export($db4a68befdfe02b0$exports, "orderedList", () => $d8c4c1fb31a84879$export$a5dc81035676e7a);
$parcel$export($db4a68befdfe02b0$exports, "panel", () => $d8c4c1fb31a84879$export$21f42ab9b6679f44);
$parcel$export($db4a68befdfe02b0$exports, "paragraph", () => $d8c4c1fb31a84879$export$9c206ddddb32a9b);
$parcel$export($db4a68befdfe02b0$exports, "paragraph_with_alignment", () => $d8c4c1fb31a84879$export$9ca11c06877e5c64);
$parcel$export($db4a68befdfe02b0$exports, "paragraph_with_font_size", () => $d8c4c1fb31a84879$export$f745a1f9fa5e1ca8);
$parcel$export($db4a68befdfe02b0$exports, "paragraph_with_font_size_and_alignment", () => $d8c4c1fb31a84879$export$20cf96f162e24b93);
$parcel$export($db4a68befdfe02b0$exports, "paragraph_with_font_size_and_indentation", () => $d8c4c1fb31a84879$export$8f4b0a3fbc7cdc91);
$parcel$export($db4a68befdfe02b0$exports, "paragraph_with_indentation", () => $d8c4c1fb31a84879$export$a3bd66932996fb7d);
$parcel$export($db4a68befdfe02b0$exports, "paragraph_with_no_marks", () => $d8c4c1fb31a84879$export$f06f75eb1e56b0c5);
$parcel$export($db4a68befdfe02b0$exports, "placeholder", () => $d8c4c1fb31a84879$export$c7187bbd1a7a9244);
$parcel$export($db4a68befdfe02b0$exports, "rule", () => $d8c4c1fb31a84879$export$fbeb3a3956e8a3c7);
$parcel$export($db4a68befdfe02b0$exports, "status", () => $d8c4c1fb31a84879$export$471f7ae5c4103ae1);
$parcel$export($db4a68befdfe02b0$exports, "strike", () => $d8c4c1fb31a84879$export$4899a95d70ec5056);
$parcel$export($db4a68befdfe02b0$exports, "strong", () => $d8c4c1fb31a84879$export$59ae2c325a998f89);
$parcel$export($db4a68befdfe02b0$exports, "subsup", () => $d8c4c1fb31a84879$export$b3401ee80eb31041);
$parcel$export($db4a68befdfe02b0$exports, "table", () => $d8c4c1fb31a84879$export$9852986a3ec5f6a0);
$parcel$export($db4a68befdfe02b0$exports, "tableCell", () => $d8c4c1fb31a84879$export$e1e720e5f4603e6a);
$parcel$export($db4a68befdfe02b0$exports, "tableHeader", () => $d8c4c1fb31a84879$export$48884d2a5190dc73);
$parcel$export($db4a68befdfe02b0$exports, "tableRow", () => $d8c4c1fb31a84879$export$ce666bf02318c957);
$parcel$export($db4a68befdfe02b0$exports, "taskItem", () => $d8c4c1fb31a84879$export$6d8b0ef52e2e6390);
$parcel$export($db4a68befdfe02b0$exports, "taskList", () => $d8c4c1fb31a84879$export$375b6afcc5f4d291);
$parcel$export($db4a68befdfe02b0$exports, "taskList_with_flexible_first_child", () => $d8c4c1fb31a84879$export$32c25bbc91b30817);
$parcel$export($db4a68befdfe02b0$exports, "text", () => $d8c4c1fb31a84879$export$6f093cfa640b7166);
$parcel$export($db4a68befdfe02b0$exports, "textColor", () => $d8c4c1fb31a84879$export$32f78bffcd82ff28);
$parcel$export($db4a68befdfe02b0$exports, "text_code_inline", () => $d8c4c1fb31a84879$export$5008c13f04d544f6);
$parcel$export($db4a68befdfe02b0$exports, "text_formatted", () => $d8c4c1fb31a84879$export$d24a7becb4e0da7c);
$parcel$export($db4a68befdfe02b0$exports, "text_link_inline", () => $d8c4c1fb31a84879$export$2a9d18d5b3064e6c);
$parcel$export($db4a68befdfe02b0$exports, "underline", () => $d8c4c1fb31a84879$export$425327af25286e5e);
$parcel$export($db4a68befdfe02b0$exports, "syncBlock", () => $d8c4c1fb31a84879$export$faab0ca9701d7048);
$parcel$export($db4a68befdfe02b0$exports, "bodiedSyncBlock", () => $d8c4c1fb31a84879$export$e92c7e4302dd4371);
/* eslint-disable @atlaskit/editor/no-re-export */ var $d8c4c1fb31a84879$export$8e53000a4ec837 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'alignment'
            ]
        },
        attrs: {
            props: {
                align: {
                    type: 'enum',
                    values: [
                        'center',
                        'end'
                    ]
                }
            }
        }
    }
};
var $d8c4c1fb31a84879$export$8512c9afa7b24c3b = {
    props: {
        type: {
            type: 'enum',
            values: [
                'annotation'
            ]
        },
        attrs: {
            props: {
                id: {
                    type: 'string'
                },
                annotationType: {
                    type: 'enum',
                    values: [
                        'inlineComment'
                    ]
                }
            }
        }
    }
};
var $d8c4c1fb31a84879$export$8c5a050822fd698c = {
    props: {
        type: {
            type: 'enum',
            values: [
                'backgroundColor'
            ]
        },
        attrs: {
            props: {
                color: {
                    pattern: '^#[0-9a-fA-F]{6}$',
                    type: 'string'
                }
            }
        }
    }
};
var $d8c4c1fb31a84879$export$a31afb40076fa18b = [
    'blockCard',
    'paragraph_with_no_marks',
    'paragraph_with_alignment',
    'paragraph_with_indentation',
    'paragraph_with_font_size_and_alignment',
    'paragraph_with_font_size_and_indentation',
    'mediaSingle_caption',
    'mediaSingle_full',
    'codeBlock',
    'taskList',
    'bulletList',
    'orderedList',
    'heading_with_no_marks',
    'heading_with_alignment',
    'heading_with_indentation',
    'mediaGroup',
    'decisionList',
    'rule',
    'panel',
    'blockquote',
    'extension_with_marks',
    'embedCard',
    'table',
    'expand',
    'bodiedExtension_with_marks'
];
var $d8c4c1fb31a84879$export$c4c2f833baaebdb8 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'blockCard'
            ]
        },
        attrs: [
            {
                props: {
                    localId: {
                        type: 'string',
                        optional: true
                    },
                    url: {
                        type: 'string',
                        optional: true,
                        validatorFn: 'safeUrl'
                    },
                    datasource: {
                        props: {
                            id: {
                                type: 'string'
                            },
                            parameters: {
                                type: 'object'
                            },
                            views: {
                                items: [
                                    {
                                        props: {
                                            properties: {
                                                optional: true,
                                                type: 'object'
                                            },
                                            type: {
                                                type: 'string'
                                            }
                                        }
                                    }
                                ],
                                minItems: 1,
                                type: 'array'
                            }
                        }
                    },
                    width: {
                        type: 'number',
                        optional: true
                    },
                    layout: {
                        type: 'enum',
                        values: [
                            'wide',
                            'full-width',
                            'center',
                            'wrap-right',
                            'wrap-left',
                            'align-end',
                            'align-start'
                        ],
                        optional: true
                    }
                }
            },
            {
                props: {
                    url: {
                        type: 'string',
                        validatorFn: 'safeUrl'
                    },
                    localId: {
                        type: 'string',
                        optional: true
                    }
                }
            },
            {
                props: {
                    data: {
                        type: 'object'
                    },
                    localId: {
                        type: 'string',
                        optional: true
                    }
                }
            }
        ]
    },
    required: [
        'attrs'
    ]
};
var $d8c4c1fb31a84879$export$67dc04e652a298ca = {
    props: {
        type: {
            type: 'enum',
            values: [
                'blockquote'
            ]
        },
        attrs: {
            props: {
                localId: {
                    type: 'string',
                    optional: true
                }
            },
            optional: true
        },
        content: {
            type: 'array',
            items: [
                [
                    'paragraph_with_no_marks',
                    'orderedList',
                    'bulletList',
                    'codeBlock',
                    'mediaSingle_caption',
                    'mediaSingle_full',
                    'mediaGroup',
                    'extension_with_marks'
                ]
            ],
            minItems: 1,
            allowUnsupportedBlock: true
        }
    }
};
var $d8c4c1fb31a84879$export$ebb5393736e9ba23 = [
    'multiBodiedExtension'
];
var $d8c4c1fb31a84879$export$16018c61064a18df = {
    props: {
        type: {
            type: 'enum',
            values: [
                'blockTaskItem'
            ]
        },
        attrs: {
            props: {
                localId: {
                    type: 'string'
                },
                state: {
                    type: 'enum',
                    values: [
                        'TODO',
                        'DONE'
                    ]
                }
            }
        },
        content: {
            type: 'array',
            isTupleLike: true,
            items: [
                [
                    'paragraph_with_no_marks',
                    'paragraph_with_font_size',
                    'extension_with_marks'
                ],
                [
                    'paragraph_with_no_marks',
                    'paragraph_with_font_size',
                    'extension_with_marks'
                ]
            ],
            minItems: 1
        }
    }
};
var $d8c4c1fb31a84879$export$27903d543b563e39 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'bodiedExtension'
            ]
        },
        attrs: {
            props: {
                extensionKey: {
                    minLength: 1,
                    type: 'string'
                },
                extensionType: {
                    minLength: 1,
                    type: 'string'
                },
                parameters: {
                    type: 'object',
                    optional: true
                },
                text: {
                    type: 'string',
                    optional: true
                },
                layout: {
                    type: 'enum',
                    values: [
                        'wide',
                        'full-width',
                        'default'
                    ],
                    optional: true
                },
                localId: {
                    minLength: 1,
                    type: 'string',
                    optional: true
                }
            }
        },
        content: {
            type: 'array',
            items: [
                'non_nestable_block_content'
            ],
            minItems: 1,
            allowUnsupportedBlock: true
        },
        marks: {
            type: 'array',
            items: [],
            optional: true
        }
    }
};
var $d8c4c1fb31a84879$export$ee052cc5b2356e83 = [
    'bodiedExtension',
    {
        props: {
            marks: {
                type: 'array',
                optional: true,
                items: [
                    [
                        'dataConsumer',
                        'fragment'
                    ]
                ]
            }
        }
    }
];
var $d8c4c1fb31a84879$export$e92c7e4302dd4371 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'bodiedSyncBlock'
            ]
        },
        attrs: {
            props: {
                resourceId: {
                    type: 'string'
                },
                localId: {
                    type: 'string'
                }
            }
        },
        content: {
            type: 'array',
            items: [
                [
                    'paragraph',
                    'paragraph_with_alignment',
                    'paragraph_with_indentation',
                    'paragraph_with_font_size_and_alignment',
                    'paragraph_with_font_size_and_indentation',
                    'paragraph_with_no_marks',
                    'blockCard',
                    'blockquote',
                    'bulletList',
                    'codeBlock',
                    'decisionList',
                    'embedCard',
                    'expand',
                    'heading',
                    'heading_with_alignment',
                    'heading_with_indentation',
                    'heading_with_no_marks',
                    'layoutSection',
                    'layoutSection_with_single_column',
                    'layoutSection_full',
                    'mediaGroup',
                    'mediaSingle',
                    'mediaSingle_caption',
                    'mediaSingle_full',
                    'mediaSingle_width_type',
                    'orderedList',
                    'panel',
                    'rule',
                    'table',
                    'taskList'
                ]
            ],
            minItems: 1,
            allowUnsupportedBlock: true
        },
        marks: {
            type: 'array',
            optional: true,
            items: [
                'breakout'
            ]
        }
    }
};
var $d8c4c1fb31a84879$export$1edee58a52776cd9 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'border'
            ]
        },
        attrs: {
            props: {
                size: {
                    type: 'number',
                    minimum: 1,
                    maximum: 3
                },
                color: {
                    pattern: '^#[0-9a-fA-F]{8}$|^#[0-9a-fA-F]{6}$',
                    type: 'string'
                }
            }
        }
    }
};
var $d8c4c1fb31a84879$export$89015c65f1c75e3f = {
    props: {
        type: {
            type: 'enum',
            values: [
                'breakout'
            ]
        },
        attrs: {
            props: {
                mode: {
                    type: 'enum',
                    values: [
                        'wide',
                        'full-width'
                    ]
                },
                width: {
                    type: 'number',
                    optional: true
                }
            }
        }
    }
};
var $d8c4c1fb31a84879$export$a140c94e5ea26bee = {
    props: {
        type: {
            type: 'enum',
            values: [
                'bulletList'
            ]
        },
        attrs: {
            props: {
                localId: {
                    type: 'string',
                    optional: true
                }
            },
            optional: true
        },
        content: {
            type: 'array',
            items: [
                [
                    'listItem',
                    'listItem_with_flexible_first_child'
                ]
            ],
            minItems: 1
        }
    }
};
var $d8c4c1fb31a84879$export$8e3c2dfdc4f0453d = {
    props: {
        type: {
            type: 'enum',
            values: [
                'caption'
            ]
        },
        attrs: {
            props: {
                localId: {
                    type: 'string',
                    optional: true
                }
            },
            optional: true
        },
        content: {
            type: 'array',
            items: [
                [
                    'hardBreak',
                    'mention',
                    'emoji',
                    'date',
                    'placeholder',
                    'inlineCard',
                    'status',
                    'text_formatted',
                    'text_code_inline'
                ]
            ],
            optional: true,
            allowUnsupportedInline: true
        }
    }
};
var $d8c4c1fb31a84879$export$6565f9f03506010b = {
    props: {
        type: {
            type: 'enum',
            values: [
                'code'
            ]
        }
    }
};
var $d8c4c1fb31a84879$export$7bb0d5c671655cc4 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'codeBlock'
            ]
        },
        attrs: {
            props: {
                language: {
                    type: 'string',
                    optional: true
                },
                uniqueId: {
                    type: 'string',
                    optional: true
                },
                localId: {
                    type: 'string',
                    optional: true
                }
            },
            optional: true
        },
        content: {
            type: 'array',
            items: [
                'text_with_no_marks'
            ],
            optional: true,
            allowUnsupportedInline: true
        }
    }
};
var $d8c4c1fb31a84879$export$38d90d1aac6883a3 = [
    'codeBlock',
    {
        props: {
            marks: {
                type: 'array',
                optional: true,
                items: [
                    'breakout'
                ]
            }
        }
    }
];
var $d8c4c1fb31a84879$export$f3b72f8fc4684ecd = {
    props: {
        type: {
            type: 'enum',
            values: [
                'confluenceInlineComment'
            ]
        },
        attrs: {
            props: {
                reference: {
                    type: 'string'
                }
            }
        }
    }
};
var $d8c4c1fb31a84879$export$3024f02c495408d6 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'dataConsumer'
            ]
        },
        attrs: {
            props: {
                sources: {
                    type: 'array',
                    items: [
                        {
                            type: 'string'
                        }
                    ],
                    minItems: 1
                }
            }
        }
    }
};
var $d8c4c1fb31a84879$export$324d90190a8b822a = {
    props: {
        type: {
            type: 'enum',
            values: [
                'date'
            ]
        },
        attrs: {
            props: {
                timestamp: {
                    minLength: 1,
                    type: 'string'
                },
                localId: {
                    type: 'string',
                    optional: true
                }
            }
        },
        marks: {
            type: 'array',
            optional: true,
            items: [
                'annotation'
            ]
        }
    }
};
var $d8c4c1fb31a84879$export$6959e16eeff859b4 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'decisionItem'
            ]
        },
        attrs: {
            props: {
                localId: {
                    type: 'string'
                },
                state: {
                    type: 'string'
                }
            }
        },
        content: {
            type: 'array',
            items: [
                'inline_content'
            ],
            optional: true,
            allowUnsupportedInline: true
        }
    }
};
var $d8c4c1fb31a84879$export$62d45a65fb43d95e = {
    props: {
        type: {
            type: 'enum',
            values: [
                'decisionList'
            ]
        },
        attrs: {
            props: {
                localId: {
                    type: 'string'
                }
            }
        },
        content: {
            type: 'array',
            items: [
                'decisionItem'
            ],
            minItems: 1,
            allowUnsupportedBlock: true
        }
    }
};
var $d8c4c1fb31a84879$export$2a111da947c407d2 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'doc'
            ]
        },
        version: {
            type: 'enum',
            values: [
                1
            ]
        },
        content: {
            type: 'array',
            items: [
                [
                    'blockCard',
                    'paragraph_with_no_marks',
                    'paragraph_with_alignment',
                    'paragraph_with_indentation',
                    'paragraph_with_font_size_and_alignment',
                    'paragraph_with_font_size_and_indentation',
                    'mediaSingle_caption',
                    'mediaSingle_full',
                    'codeBlock',
                    'taskList',
                    'bulletList',
                    'orderedList',
                    'heading_with_no_marks',
                    'heading_with_alignment',
                    'heading_with_indentation',
                    'mediaGroup',
                    'decisionList',
                    'rule',
                    'panel',
                    'blockquote',
                    'extension_with_marks',
                    'embedCard',
                    'table',
                    'expand',
                    'bodiedExtension_with_marks',
                    'codeBlock_root_only',
                    'layoutSection_with_single_column',
                    'layoutSection_full',
                    'multiBodiedExtension',
                    'expand_root_only',
                    'syncBlock',
                    'bodiedSyncBlock'
                ]
            ],
            allowUnsupportedBlock: true
        }
    }
};
var $d8c4c1fb31a84879$export$c63c6f932822f543 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'em'
            ]
        }
    }
};
var $d8c4c1fb31a84879$export$be4283d9a1cb1ff6 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'embedCard'
            ]
        },
        attrs: {
            props: {
                url: {
                    type: 'string',
                    validatorFn: 'safeUrl'
                },
                layout: {
                    type: 'enum',
                    values: [
                        'wide',
                        'full-width',
                        'center',
                        'wrap-right',
                        'wrap-left',
                        'align-end',
                        'align-start'
                    ]
                },
                width: {
                    type: 'number',
                    maximum: 100,
                    minimum: 0,
                    optional: true
                },
                originalHeight: {
                    type: 'number',
                    optional: true
                },
                originalWidth: {
                    type: 'number',
                    optional: true
                },
                localId: {
                    type: 'string',
                    optional: true
                }
            }
        }
    }
};
var $d8c4c1fb31a84879$export$a19185d1233fc4b2 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'emoji'
            ]
        },
        attrs: {
            props: {
                shortName: {
                    type: 'string'
                },
                id: {
                    type: 'string',
                    optional: true
                },
                text: {
                    type: 'string',
                    optional: true
                },
                localId: {
                    type: 'string',
                    optional: true
                }
            }
        },
        marks: {
            type: 'array',
            optional: true,
            items: [
                'annotation'
            ]
        }
    }
};
var $d8c4c1fb31a84879$export$9f77e0932fb78f72 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'expand'
            ]
        },
        attrs: {
            props: {
                title: {
                    type: 'string',
                    optional: true
                },
                localId: {
                    type: 'string',
                    optional: true
                }
            },
            optional: true
        },
        content: {
            type: 'array',
            items: [
                [
                    'paragraph_with_no_marks',
                    'paragraph_with_font_size',
                    'panel',
                    'blockquote',
                    'orderedList',
                    'bulletList',
                    'rule',
                    'heading_with_no_marks',
                    'codeBlock',
                    'mediaGroup',
                    'mediaSingle_caption',
                    'mediaSingle_full',
                    'decisionList',
                    'taskList',
                    'table',
                    'blockCard',
                    'embedCard',
                    'extension_with_marks',
                    'nestedExpand_with_no_marks'
                ]
            ],
            minItems: 1,
            allowUnsupportedBlock: true
        }
    }
};
var $d8c4c1fb31a84879$export$b2817c6954dd6d2c = [
    'expand',
    {
        props: {
            marks: {
                type: 'array',
                optional: true,
                items: [
                    'breakout'
                ]
            }
        }
    }
];
var $d8c4c1fb31a84879$export$1b45514b112dd749 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'extension'
            ]
        },
        attrs: {
            props: {
                extensionKey: {
                    minLength: 1,
                    type: 'string'
                },
                extensionType: {
                    minLength: 1,
                    type: 'string'
                },
                parameters: {
                    type: 'object',
                    optional: true
                },
                text: {
                    type: 'string',
                    optional: true
                },
                layout: {
                    type: 'enum',
                    values: [
                        'wide',
                        'full-width',
                        'default'
                    ],
                    optional: true
                },
                localId: {
                    minLength: 1,
                    type: 'string',
                    optional: true
                }
            }
        },
        marks: {
            type: 'array',
            items: [],
            optional: true
        }
    }
};
var $d8c4c1fb31a84879$export$15be7c145cec614a = [
    'extension',
    {
        props: {
            marks: {
                type: 'array',
                optional: true,
                items: [
                    [
                        'dataConsumer',
                        'fragment'
                    ]
                ]
            }
        }
    }
];
var $d8c4c1fb31a84879$export$4fdcae991fd743e7 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'extensionFrame'
            ]
        },
        content: {
            type: 'array',
            items: [
                [
                    'paragraph_with_no_marks',
                    'paragraph_with_font_size',
                    'panel',
                    'blockquote',
                    'orderedList',
                    'bulletList',
                    'rule',
                    'heading_with_no_marks',
                    'codeBlock',
                    'mediaGroup',
                    'mediaSingle_full',
                    'mediaSingle_caption',
                    'decisionList',
                    'taskList',
                    'table',
                    'extension_with_marks',
                    'bodiedExtension_with_marks',
                    'blockCard',
                    'embedCard'
                ]
            ],
            minItems: 1
        },
        marks: {
            type: 'array',
            optional: true,
            items: [
                [
                    'dataConsumer',
                    'fragment'
                ]
            ]
        }
    }
};
var $d8c4c1fb31a84879$export$85e3c3ca0c6fb93 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'fontSize'
            ]
        },
        attrs: {
            props: {
                fontSize: {
                    type: 'enum',
                    values: [
                        'small'
                    ]
                }
            }
        }
    }
};
var $d8c4c1fb31a84879$export$f00aeb236b6f05af = {
    props: {
        type: {
            type: 'enum',
            values: [
                'fragment'
            ]
        },
        attrs: {
            props: {
                localId: {
                    minLength: 1,
                    type: 'string'
                },
                name: {
                    type: 'string',
                    optional: true
                }
            }
        }
    }
};
var $d8c4c1fb31a84879$export$371da9dd35aba193 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'hardBreak'
            ]
        },
        attrs: {
            props: {
                text: {
                    type: 'enum',
                    values: [
                        '\n'
                    ],
                    optional: true
                },
                localId: {
                    type: 'string',
                    optional: true
                }
            },
            optional: true
        }
    }
};
var $d8c4c1fb31a84879$export$46e4a324ac90507f = {
    props: {
        type: {
            type: 'enum',
            values: [
                'heading'
            ]
        },
        attrs: {
            props: {
                level: {
                    type: 'number',
                    minimum: 1,
                    maximum: 6
                },
                localId: {
                    type: 'string',
                    optional: true
                }
            }
        },
        content: {
            type: 'array',
            items: [
                'inline_content'
            ],
            optional: true,
            allowUnsupportedInline: true
        },
        marks: {
            type: 'array',
            items: [],
            optional: true
        }
    }
};
var $d8c4c1fb31a84879$export$c17edf9af655deaf = [
    'heading',
    {
        props: {
            marks: {
                type: 'array',
                optional: true,
                items: [
                    'alignment'
                ]
            }
        }
    }
];
var $d8c4c1fb31a84879$export$1902f9737466a0dc = [
    'heading',
    {
        props: {
            marks: {
                type: 'array',
                optional: true,
                items: [
                    'indentation'
                ]
            }
        }
    }
];
var $d8c4c1fb31a84879$export$7b491e75f1be9278 = [
    'heading',
    {
        props: {
            marks: {
                type: 'array',
                maxItems: 0,
                items: [],
                optional: true
            }
        }
    }
];
var $d8c4c1fb31a84879$export$480c699bd4ec0d86 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'indentation'
            ]
        },
        attrs: {
            props: {
                level: {
                    type: 'number',
                    minimum: 1,
                    maximum: 6
                }
            }
        }
    }
};
var $d8c4c1fb31a84879$export$e23e6162adaa368d = [
    'text_formatted',
    'text_code_inline',
    'date',
    'emoji',
    'hardBreak',
    'inlineCard',
    'mention',
    'placeholder',
    'status',
    'inlineExtension_with_marks',
    'mediaInline'
];
var $d8c4c1fb31a84879$export$cbf8224b64e0d942 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'inlineCard'
            ]
        },
        attrs: [
            {
                props: {
                    url: {
                        type: 'string',
                        validatorFn: 'safeUrl'
                    },
                    localId: {
                        type: 'string',
                        optional: true
                    }
                }
            },
            {
                props: {
                    data: {
                        type: 'object'
                    },
                    localId: {
                        type: 'string',
                        optional: true
                    }
                }
            }
        ],
        marks: {
            type: 'array',
            optional: true,
            items: [
                'annotation'
            ]
        }
    },
    required: [
        'attrs'
    ]
};
var $d8c4c1fb31a84879$export$16b353b2649bd8d9 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'inlineExtension'
            ]
        },
        attrs: {
            props: {
                extensionKey: {
                    minLength: 1,
                    type: 'string'
                },
                extensionType: {
                    minLength: 1,
                    type: 'string'
                },
                parameters: {
                    type: 'object',
                    optional: true
                },
                text: {
                    type: 'string',
                    optional: true
                },
                localId: {
                    minLength: 1,
                    type: 'string',
                    optional: true
                }
            }
        },
        marks: {
            type: 'array',
            items: [],
            optional: true
        }
    }
};
var $d8c4c1fb31a84879$export$e37f10815f36843d = [
    'inlineExtension',
    {
        props: {
            marks: {
                type: 'array',
                optional: true,
                items: [
                    [
                        'dataConsumer',
                        'fragment'
                    ]
                ]
            }
        }
    }
];
var $d8c4c1fb31a84879$export$ab76e7c03cd6f650 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'layoutColumn'
            ]
        },
        attrs: {
            props: {
                width: {
                    type: 'number',
                    minimum: 0,
                    maximum: 100
                },
                localId: {
                    type: 'string',
                    optional: true
                }
            }
        },
        content: {
            type: 'array',
            items: [
                'block_content'
            ],
            minItems: 1,
            allowUnsupportedBlock: true
        }
    }
};
var $d8c4c1fb31a84879$export$b3b6a70a7fa4a5be = {
    props: {
        type: {
            type: 'enum',
            values: [
                'layoutSection'
            ]
        },
        attrs: {
            props: {
                localId: {
                    type: 'string',
                    optional: true
                }
            },
            optional: true
        },
        content: {
            type: 'array',
            items: [
                'layoutColumn'
            ],
            minItems: 1,
            maxItems: 3,
            allowUnsupportedBlock: true
        },
        marks: {
            type: 'array',
            optional: true,
            items: [
                'breakout'
            ]
        }
    }
};
var $d8c4c1fb31a84879$export$941b63fbd931e449 = [
    'layoutSection',
    {
        props: {
            content: {
                type: 'array',
                items: [
                    'layoutColumn'
                ],
                minItems: 2,
                maxItems: 3,
                allowUnsupportedBlock: true
            },
            marks: {
                type: 'array',
                optional: true,
                items: [
                    'breakout'
                ]
            }
        }
    }
];
var $d8c4c1fb31a84879$export$e0e9834198e8601d = [
    'layoutSection',
    {
        props: {
            attrs: {
                props: {
                    columnRuleStyle: {
                        type: 'enum',
                        values: [
                            'solid'
                        ],
                        optional: true
                    },
                    localId: {
                        type: 'string',
                        optional: true
                    }
                },
                optional: true
            },
            content: {
                type: 'array',
                items: [
                    'layoutColumn'
                ],
                minItems: 1,
                maxItems: 5,
                allowUnsupportedBlock: true
            },
            marks: {
                type: 'array',
                optional: true,
                items: [
                    'breakout'
                ]
            }
        }
    }
];
var $d8c4c1fb31a84879$export$9c30223ca0a664fb = {
    props: {
        type: {
            type: 'enum',
            values: [
                'link'
            ]
        },
        attrs: {
            props: {
                href: {
                    type: 'string',
                    validatorFn: 'safeUrl'
                },
                title: {
                    type: 'string',
                    optional: true
                },
                id: {
                    type: 'string',
                    optional: true
                },
                collection: {
                    type: 'string',
                    optional: true
                },
                occurrenceKey: {
                    type: 'string',
                    optional: true
                }
            }
        }
    }
};
var $d8c4c1fb31a84879$export$76c7e83ecc9cdf05 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'listItem'
            ]
        },
        attrs: {
            props: {
                localId: {
                    type: 'string',
                    optional: true
                }
            },
            optional: true
        },
        content: {
            type: 'array',
            isTupleLike: true,
            items: [
                [
                    'paragraph_with_font_size',
                    'paragraph_with_no_marks',
                    'mediaSingle_caption',
                    'mediaSingle_full',
                    'codeBlock',
                    'extension_with_marks'
                ],
                [
                    'paragraph_with_font_size',
                    'paragraph_with_no_marks',
                    'bulletList',
                    'orderedList',
                    'taskList',
                    'mediaSingle_caption',
                    'mediaSingle_full',
                    'codeBlock',
                    'extension_with_marks'
                ]
            ],
            minItems: 1,
            allowUnsupportedBlock: true
        }
    }
};
var $d8c4c1fb31a84879$export$d80b696b842918ee = [
    'listItem',
    {
        props: {
            content: {
                type: 'array',
                items: [
                    [
                        'paragraph_with_font_size',
                        'paragraph_with_no_marks',
                        'bulletList',
                        'orderedList',
                        'taskList',
                        'taskList_with_flexible_first_child',
                        'mediaSingle_caption',
                        'mediaSingle_full',
                        'codeBlock',
                        'extension_with_marks'
                    ]
                ],
                minItems: 1,
                allowUnsupportedBlock: true
            }
        }
    }
];
var $d8c4c1fb31a84879$export$987d49ffe1b0900f = {
    props: {
        type: {
            type: 'enum',
            values: [
                'media'
            ]
        },
        attrs: [
            {
                props: {
                    type: {
                        type: 'enum',
                        values: [
                            'link',
                            'file'
                        ]
                    },
                    localId: {
                        type: 'string',
                        optional: true
                    },
                    id: {
                        minLength: 1,
                        type: 'string'
                    },
                    alt: {
                        type: 'string',
                        optional: true
                    },
                    collection: {
                        type: 'string'
                    },
                    height: {
                        type: 'number',
                        optional: true
                    },
                    occurrenceKey: {
                        minLength: 1,
                        type: 'string',
                        optional: true
                    },
                    width: {
                        type: 'number',
                        optional: true
                    }
                }
            },
            {
                props: {
                    type: {
                        type: 'enum',
                        values: [
                            'external'
                        ]
                    },
                    localId: {
                        type: 'string',
                        optional: true
                    },
                    alt: {
                        type: 'string',
                        optional: true
                    },
                    height: {
                        type: 'number',
                        optional: true
                    },
                    width: {
                        type: 'number',
                        optional: true
                    },
                    url: {
                        type: 'string'
                    }
                }
            }
        ],
        marks: {
            type: 'array',
            optional: true,
            items: [
                [
                    'dataConsumer',
                    'link',
                    'annotation',
                    'border'
                ]
            ]
        }
    },
    required: [
        'attrs'
    ]
};
var $d8c4c1fb31a84879$export$2855e964765eac9 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'mediaGroup'
            ]
        },
        content: {
            type: 'array',
            items: [
                'media'
            ],
            minItems: 1,
            allowUnsupportedBlock: true
        }
    }
};
var $d8c4c1fb31a84879$export$38bab695e3f720f1 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'mediaInline'
            ]
        },
        attrs: {
            props: {
                type: {
                    type: 'enum',
                    values: [
                        'link',
                        'file',
                        'image'
                    ],
                    optional: true
                },
                localId: {
                    type: 'string',
                    optional: true
                },
                url: {
                    type: 'string',
                    optional: true
                },
                id: {
                    minLength: 1,
                    type: 'string'
                },
                alt: {
                    type: 'string',
                    optional: true
                },
                collection: {
                    type: 'string'
                },
                occurrenceKey: {
                    minLength: 1,
                    type: 'string',
                    optional: true
                },
                width: {
                    type: 'number',
                    optional: true
                },
                height: {
                    type: 'number',
                    optional: true
                },
                data: {
                    type: 'object',
                    optional: true
                }
            }
        },
        marks: {
            type: 'array',
            optional: true,
            items: [
                [
                    'dataConsumer',
                    'link',
                    'annotation',
                    'border'
                ]
            ]
        }
    }
};
var $d8c4c1fb31a84879$export$969fe3781ca15058 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'mediaSingle'
            ]
        },
        attrs: [
            {
                props: {
                    localId: {
                        type: 'string',
                        optional: true
                    },
                    width: {
                        type: 'number',
                        minimum: 0,
                        maximum: 100,
                        optional: true
                    },
                    layout: {
                        type: 'enum',
                        values: [
                            'wide',
                            'full-width',
                            'center',
                            'wrap-right',
                            'wrap-left',
                            'align-end',
                            'align-start'
                        ]
                    },
                    widthType: {
                        type: 'enum',
                        values: [
                            'percentage'
                        ],
                        optional: true
                    }
                }
            },
            {
                props: {
                    localId: {
                        type: 'string',
                        optional: true
                    },
                    width: {
                        type: 'number',
                        minimum: 0
                    },
                    widthType: {
                        type: 'enum',
                        values: [
                            'pixel'
                        ]
                    },
                    layout: {
                        type: 'enum',
                        values: [
                            'wide',
                            'full-width',
                            'center',
                            'wrap-right',
                            'wrap-left',
                            'align-end',
                            'align-start'
                        ]
                    }
                }
            }
        ],
        marks: {
            type: 'array',
            optional: true,
            items: [
                'link'
            ]
        }
    }
};
var $d8c4c1fb31a84879$export$68b0ead306f9670f = [
    'mediaSingle',
    {
        props: {
            content: {
                type: 'array',
                isTupleLike: true,
                items: [
                    'media',
                    'caption'
                ],
                minItems: 1,
                maxItems: 2,
                allowUnsupportedBlock: true
            }
        }
    }
];
var $d8c4c1fb31a84879$export$f7fd577406abd5f8 = [
    'mediaSingle',
    {
        props: {
            content: {
                type: 'array',
                items: [
                    'media'
                ],
                minItems: 1,
                maxItems: 1,
                allowUnsupportedBlock: true
            }
        }
    }
];
var $d8c4c1fb31a84879$export$af10954ff7b86f88 = [
    'mediaSingle',
    {
        props: {
            content: {
                type: 'array',
                items: [
                    'media'
                ],
                minItems: 1,
                maxItems: 1,
                allowUnsupportedBlock: true
            }
        }
    }
];
var $d8c4c1fb31a84879$export$db83999c14438df4 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'mention'
            ]
        },
        attrs: {
            props: {
                id: {
                    type: 'string'
                },
                localId: {
                    type: 'string',
                    optional: true
                },
                text: {
                    type: 'string',
                    optional: true
                },
                accessLevel: {
                    type: 'string',
                    optional: true
                },
                userType: {
                    type: 'enum',
                    values: [
                        'DEFAULT',
                        'SPECIAL',
                        'APP'
                    ],
                    optional: true
                }
            }
        },
        marks: {
            type: 'array',
            optional: true,
            items: [
                'annotation'
            ]
        }
    }
};
var $d8c4c1fb31a84879$export$c3c04d555a8b9013 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'multiBodiedExtension'
            ]
        },
        attrs: {
            props: {
                extensionKey: {
                    type: 'string',
                    minLength: 1
                },
                extensionType: {
                    type: 'string',
                    minLength: 1
                },
                parameters: {
                    type: 'object',
                    optional: true
                },
                text: {
                    type: 'string',
                    optional: true
                },
                layout: {
                    type: 'enum',
                    values: [
                        'default',
                        'wide',
                        'full-width'
                    ],
                    optional: true
                },
                localId: {
                    type: 'string',
                    optional: true,
                    minLength: 1
                }
            }
        },
        content: {
            type: 'array',
            items: [
                'extensionFrame'
            ]
        },
        marks: {
            type: 'array',
            items: [],
            optional: true
        }
    }
};
var $d8c4c1fb31a84879$export$63cadbf5f4296627 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'nestedExpand'
            ]
        },
        attrs: {
            props: {
                title: {
                    type: 'string',
                    optional: true
                },
                localId: {
                    type: 'string',
                    optional: true
                }
            }
        },
        content: 'nestedExpand_content'
    },
    required: [
        'content'
    ]
};
var $d8c4c1fb31a84879$export$9584f52f3ebd5d7e = {
    type: 'array',
    items: [
        [
            'paragraph_with_no_marks',
            'paragraph_with_font_size',
            'heading_with_no_marks',
            'mediaSingle_caption',
            'mediaSingle_full',
            'mediaGroup',
            'codeBlock',
            'bulletList',
            'orderedList',
            'taskList',
            'decisionList',
            'rule',
            'panel',
            'blockquote',
            'extension_with_marks'
        ]
    ],
    minItems: 1,
    allowUnsupportedBlock: true
};
var $d8c4c1fb31a84879$export$b756fc994eb0bc4f = [
    'nestedExpand',
    {
        props: {
            marks: {
                type: 'array',
                maxItems: 0,
                items: [],
                optional: true
            }
        }
    }
];
var $d8c4c1fb31a84879$export$ed866000601e7fa5 = [
    'paragraph_with_no_marks',
    'paragraph_with_font_size',
    'panel',
    'blockquote',
    'orderedList',
    'bulletList',
    'rule',
    'heading_with_no_marks',
    'codeBlock',
    'mediaGroup',
    'mediaSingle_caption',
    'mediaSingle_full',
    'decisionList',
    'taskList',
    'table',
    'blockCard',
    'embedCard',
    'extension_with_marks'
];
var $d8c4c1fb31a84879$export$a5dc81035676e7a = {
    props: {
        type: {
            type: 'enum',
            values: [
                'orderedList'
            ]
        },
        attrs: {
            props: {
                order: {
                    type: 'number',
                    minimum: 0,
                    optional: true
                },
                localId: {
                    type: 'string',
                    optional: true
                }
            },
            optional: true
        },
        content: {
            type: 'array',
            items: [
                [
                    'listItem',
                    'listItem_with_flexible_first_child'
                ]
            ],
            minItems: 1
        }
    }
};
var $d8c4c1fb31a84879$export$21f42ab9b6679f44 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'panel'
            ]
        },
        attrs: {
            props: {
                panelType: {
                    type: 'enum',
                    values: [
                        'info',
                        'note',
                        'tip',
                        'warning',
                        'error',
                        'success',
                        'custom'
                    ]
                },
                panelIcon: {
                    type: 'string',
                    optional: true
                },
                panelIconId: {
                    type: 'string',
                    optional: true
                },
                panelIconText: {
                    type: 'string',
                    optional: true
                },
                panelColor: {
                    type: 'string',
                    optional: true
                },
                localId: {
                    type: 'string',
                    optional: true
                }
            }
        },
        content: {
            type: 'array',
            items: [
                [
                    'paragraph_with_no_marks',
                    'paragraph_with_font_size',
                    'heading_with_no_marks',
                    'bulletList',
                    'orderedList',
                    'blockCard',
                    'mediaGroup',
                    'mediaSingle_caption',
                    'mediaSingle_full',
                    'codeBlock',
                    'taskList',
                    'rule',
                    'decisionList',
                    'extension_with_marks'
                ]
            ],
            minItems: 1,
            allowUnsupportedBlock: true
        }
    }
};
var $d8c4c1fb31a84879$export$9c206ddddb32a9b = {
    props: {
        type: {
            type: 'enum',
            values: [
                'paragraph'
            ]
        },
        attrs: {
            props: {
                localId: {
                    type: 'string',
                    optional: true
                }
            },
            optional: true
        },
        content: {
            type: 'array',
            items: [
                'inline_content'
            ],
            optional: true,
            allowUnsupportedInline: true
        },
        marks: {
            type: 'array',
            items: [],
            optional: true
        }
    }
};
var $d8c4c1fb31a84879$export$9ca11c06877e5c64 = [
    'paragraph',
    {
        props: {
            marks: {
                type: 'array',
                optional: true,
                items: [
                    'alignment'
                ]
            }
        }
    }
];
var $d8c4c1fb31a84879$export$f745a1f9fa5e1ca8 = [
    'paragraph',
    {
        props: {
            marks: {
                type: 'array',
                optional: true,
                items: [
                    'fontSize'
                ]
            }
        }
    }
];
var $d8c4c1fb31a84879$export$20cf96f162e24b93 = [
    'paragraph',
    {
        props: {
            marks: {
                type: 'array',
                optional: true,
                items: [
                    [
                        'fontSize',
                        'alignment'
                    ]
                ]
            }
        }
    }
];
var $d8c4c1fb31a84879$export$8f4b0a3fbc7cdc91 = [
    'paragraph',
    {
        props: {
            marks: {
                type: 'array',
                optional: true,
                items: [
                    [
                        'fontSize',
                        'indentation'
                    ]
                ]
            }
        }
    }
];
var $d8c4c1fb31a84879$export$a3bd66932996fb7d = [
    'paragraph',
    {
        props: {
            marks: {
                type: 'array',
                optional: true,
                items: [
                    'indentation'
                ]
            }
        }
    }
];
var $d8c4c1fb31a84879$export$f06f75eb1e56b0c5 = [
    'paragraph',
    {
        props: {
            marks: {
                type: 'array',
                maxItems: 0,
                items: [],
                optional: true
            }
        }
    }
];
var $d8c4c1fb31a84879$export$c7187bbd1a7a9244 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'placeholder'
            ]
        },
        attrs: {
            props: {
                text: {
                    type: 'string'
                },
                localId: {
                    type: 'string',
                    optional: true
                }
            }
        }
    }
};
var $d8c4c1fb31a84879$export$fbeb3a3956e8a3c7 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'rule'
            ]
        },
        attrs: {
            props: {
                localId: {
                    type: 'string',
                    optional: true
                }
            },
            optional: true
        }
    }
};
var $d8c4c1fb31a84879$export$471f7ae5c4103ae1 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'status'
            ]
        },
        attrs: {
            props: {
                text: {
                    minLength: 1,
                    type: 'string'
                },
                color: {
                    type: 'enum',
                    values: [
                        'neutral',
                        'purple',
                        'blue',
                        'red',
                        'yellow',
                        'green'
                    ]
                },
                localId: {
                    type: 'string',
                    optional: true
                },
                style: {
                    type: 'string',
                    optional: true
                }
            }
        },
        marks: {
            type: 'array',
            optional: true,
            items: [
                'annotation'
            ]
        }
    }
};
var $d8c4c1fb31a84879$export$4899a95d70ec5056 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'strike'
            ]
        }
    }
};
var $d8c4c1fb31a84879$export$59ae2c325a998f89 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'strong'
            ]
        }
    }
};
var $d8c4c1fb31a84879$export$b3401ee80eb31041 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'subsup'
            ]
        },
        attrs: {
            props: {
                type: {
                    type: 'enum',
                    values: [
                        'sub',
                        'sup'
                    ]
                }
            }
        }
    }
};
var $d8c4c1fb31a84879$export$faab0ca9701d7048 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'syncBlock'
            ]
        },
        attrs: {
            props: {
                resourceId: {
                    type: 'string'
                },
                localId: {
                    type: 'string'
                }
            }
        },
        marks: {
            type: 'array',
            optional: true,
            items: [
                'breakout'
            ]
        }
    }
};
var $d8c4c1fb31a84879$export$9852986a3ec5f6a0 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'table'
            ]
        },
        attrs: {
            props: {
                displayMode: {
                    type: 'enum',
                    values: [
                        'default',
                        'fixed'
                    ],
                    optional: true
                },
                isNumberColumnEnabled: {
                    type: 'boolean',
                    optional: true
                },
                layout: {
                    type: 'enum',
                    values: [
                        'wide',
                        'full-width',
                        'center',
                        'align-end',
                        'align-start',
                        'default'
                    ],
                    optional: true
                },
                localId: {
                    type: 'string',
                    minLength: 1,
                    optional: true
                },
                width: {
                    type: 'number',
                    optional: true
                }
            },
            optional: true
        },
        content: {
            type: 'array',
            items: [
                'tableRow'
            ],
            minItems: 1
        },
        marks: {
            type: 'array',
            optional: true,
            items: [
                'fragment'
            ]
        }
    }
};
var $d8c4c1fb31a84879$export$e1e720e5f4603e6a = {
    props: {
        type: {
            type: 'enum',
            values: [
                'tableCell'
            ]
        },
        attrs: {
            props: {
                colspan: {
                    type: 'number',
                    optional: true
                },
                rowspan: {
                    type: 'number',
                    optional: true
                },
                colwidth: {
                    type: 'array',
                    items: [
                        {
                            type: 'number'
                        }
                    ],
                    optional: true
                },
                background: {
                    type: 'string',
                    optional: true
                },
                localId: {
                    type: 'string',
                    optional: true
                }
            },
            optional: true
        },
        content: {
            type: 'array',
            items: [
                [
                    'paragraph_with_no_marks',
                    'paragraph_with_alignment',
                    'paragraph_with_font_size_and_alignment',
                    'panel',
                    'blockquote',
                    'orderedList',
                    'bulletList',
                    'rule',
                    'heading_with_no_marks',
                    'heading_with_alignment',
                    'heading_with_indentation',
                    'codeBlock',
                    'mediaSingle_caption',
                    'mediaSingle_full',
                    'mediaGroup',
                    'decisionList',
                    'taskList',
                    'blockCard',
                    'embedCard',
                    'extension_with_marks',
                    'nestedExpand_with_no_marks'
                ]
            ],
            minItems: 1,
            allowUnsupportedBlock: true
        }
    },
    required: [
        'content'
    ]
};
var $d8c4c1fb31a84879$export$48884d2a5190dc73 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'tableHeader'
            ]
        },
        attrs: {
            props: {
                colspan: {
                    type: 'number',
                    optional: true
                },
                rowspan: {
                    type: 'number',
                    optional: true
                },
                colwidth: {
                    type: 'array',
                    items: [
                        {
                            type: 'number'
                        }
                    ],
                    optional: true
                },
                background: {
                    type: 'string',
                    optional: true
                },
                localId: {
                    type: 'string',
                    optional: true
                }
            },
            optional: true
        },
        content: {
            type: 'array',
            items: [
                [
                    'paragraph_with_no_marks',
                    'paragraph_with_alignment',
                    'paragraph_with_font_size_and_alignment',
                    'panel',
                    'blockquote',
                    'orderedList',
                    'bulletList',
                    'rule',
                    'heading_with_no_marks',
                    'heading_with_alignment',
                    'heading_with_indentation',
                    'codeBlock',
                    'mediaSingle_caption',
                    'mediaSingle_full',
                    'mediaGroup',
                    'decisionList',
                    'taskList',
                    'blockCard',
                    'embedCard',
                    'extension_with_marks',
                    'nestedExpand_with_no_marks',
                    'nestedExpand'
                ]
            ],
            minItems: 1
        }
    },
    required: [
        'content'
    ]
};
var $d8c4c1fb31a84879$export$ce666bf02318c957 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'tableRow'
            ]
        },
        attrs: {
            props: {
                localId: {
                    type: 'string',
                    optional: true
                }
            },
            optional: true
        },
        content: {
            type: 'array',
            items: [
                [
                    'tableCell',
                    'tableHeader'
                ]
            ]
        }
    }
};
var $d8c4c1fb31a84879$export$6d8b0ef52e2e6390 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'taskItem'
            ]
        },
        attrs: {
            props: {
                localId: {
                    type: 'string'
                },
                state: {
                    type: 'enum',
                    values: [
                        'TODO',
                        'DONE'
                    ]
                }
            }
        },
        content: {
            type: 'array',
            items: [
                'inline_content'
            ],
            optional: true,
            allowUnsupportedInline: true
        }
    }
};
var $d8c4c1fb31a84879$export$375b6afcc5f4d291 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'taskList'
            ]
        },
        attrs: {
            props: {
                localId: {
                    type: 'string'
                }
            }
        },
        content: {
            type: 'array',
            isTupleLike: true,
            items: [
                [
                    'taskItem',
                    'blockTaskItem'
                ],
                [
                    'taskItem',
                    'taskList',
                    'blockTaskItem'
                ]
            ],
            minItems: 1,
            allowUnsupportedBlock: true
        }
    }
};
var $d8c4c1fb31a84879$export$32c25bbc91b30817 = [
    'taskList',
    {
        props: {
            content: {
                type: 'array',
                items: [
                    [
                        'taskItem',
                        'taskList',
                        'blockTaskItem'
                    ]
                ],
                minItems: 1,
                allowUnsupportedBlock: true
            }
        }
    }
];
var $d8c4c1fb31a84879$export$6f093cfa640b7166 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'text'
            ]
        },
        text: {
            type: 'string',
            minLength: 1
        },
        marks: {
            type: 'array',
            items: [],
            optional: true
        }
    }
};
var $d8c4c1fb31a84879$export$5008c13f04d544f6 = [
    'text',
    {
        props: {
            marks: {
                type: 'array',
                optional: true,
                items: [
                    [
                        'code',
                        'link',
                        'annotation'
                    ]
                ]
            }
        }
    }
];
var $d8c4c1fb31a84879$export$d24a7becb4e0da7c = [
    'text',
    {
        props: {
            marks: {
                type: 'array',
                optional: true,
                items: [
                    [
                        'link',
                        'em',
                        'strong',
                        'strike',
                        'subsup',
                        'underline',
                        'textColor',
                        'annotation',
                        'backgroundColor',
                        null
                    ]
                ]
            }
        }
    }
];
var $d8c4c1fb31a84879$export$2a9d18d5b3064e6c = [
    'text',
    {
        props: {
            marks: {
                type: 'array',
                optional: true,
                items: [
                    'link'
                ]
            }
        }
    }
];
var $d8c4c1fb31a84879$export$437a3d96346717e0 = [
    'text',
    {
        props: {
            marks: {
                type: 'array',
                maxItems: 0,
                items: [],
                optional: true
            }
        }
    }
];
var $d8c4c1fb31a84879$export$32f78bffcd82ff28 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'textColor'
            ]
        },
        attrs: {
            props: {
                color: {
                    type: 'string',
                    pattern: '^#[0-9a-fA-F]{6}$'
                }
            }
        }
    }
};
var $d8c4c1fb31a84879$export$425327af25286e5e = {
    props: {
        type: {
            type: 'enum',
            values: [
                'underline'
            ]
        }
    }
};





var $ekGgq = parcelRequire("ekGgq");
var $9c556fef0f50844f$export$4e62c701997796c1 = function isDefined(x) {
    return x != null;
};
var $9c556fef0f50844f$export$7e4aa119212bc614 = function isNumber(x) {
    return typeof x === 'number' && !isNaN(x) && isFinite(x);
};
var $9c556fef0f50844f$export$a287f47fed4544b8 = function isInteger(x) {
    return typeof x === 'number' && isFinite(x) && Math.floor(x) === x;
};
var $9c556fef0f50844f$export$f9ce7b637dfbe238 = function isBoolean(x) {
    return x === true || x === false || toString.call(x) === '[object Boolean]';
};
var $9c556fef0f50844f$export$844ec244b1367d54 = function isString(s) {
    return typeof s === 'string' || s instanceof String;
};
var $9c556fef0f50844f$export$53b83ca8eaab0383 = function isPlainObject(x) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(x) === 'object' && x !== null && !Array.isArray(x);
};
var $9c556fef0f50844f$export$784d13d8ee351f07 = function copy(source, dest, key) {
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    dest[key] = source[key];
    return dest;
};
var $9c556fef0f50844f$export$7b85fd78dd236198 = function makeArray(maybeArray) {
    return Array.isArray(maybeArray) ? maybeArray : [
        maybeArray
    ];
};



var $ekGgq = parcelRequire("ekGgq");

var $iYJcE = parcelRequire("iYJcE");
function $a265986427be6a21$export$7d2123bc001cdbf8(validatorSpecs, entity) {
    // Filter out content type + irrelevant nodes
    var potentialAllowedContent = Object.entries(validatorSpecs).filter(function(item) {
        var _item = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(item, 2), node = _item[0], value = _item[1];
        if ($a265986427be6a21$var$isValidatorSpec(value)) return node === entity.type;
        var _ref = [
            value[0],
            value[1]
        ], nodeName = _ref[0], spec = _ref[1];
        if (typeof spec === 'string' || (0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(spec) !== 'object') return false;
        return nodeName === entity.type;
    });
    // Keep types such as `mediaSingle_full` which contain additional spec information
    var contentArray = potentialAllowedContent.map(function(allowedContent) {
        if ($a265986427be6a21$var$isValidatorSpec(allowedContent)) return undefined;
        var value = allowedContent[1];
        return !$a265986427be6a21$var$isValidatorSpec(value) ? [
            [
                value[0],
                value[1]
            ]
        ] : undefined;
    });
    return contentArray.filter(function(x) {
        return !!x;
    });
}
function $a265986427be6a21$var$isValidatorSpec(spec) {
    return spec.props !== undefined || spec.required !== undefined || spec.maxItems !== undefined || spec.minItems !== undefined;
}


/**
 * This file has been partially duplicated in packages/linking-platform/linking-common/src/url.ts
 * Any changes made here should be mirrored there.
 * Ticket for dedeplication: https://product-fabric.atlassian.net/browse/EDM-7138
 * Ticket for fixing linkification of filename-like urls: https://product-fabric.atlassian.net/browse/EDM-7190
 */ 
var $840z9 = parcelRequire("840z9");
var $a302c0502bb198f5$var$whitelistedURLPatterns = [
    /^http[s\u017F]?:\/\//im,
    /^ftp[s\u017F]?:\/\//im,
    /^gopher:\/\//im,
    /^integrity:\/\//im,
    /^file:\/\//im,
    /^[s\u017F]mb:\/\//im,
    /^dynamic[s\u017F]nav:\/\//im,
    /^jamf[s\u017F]elf[s\u017F]ervice:\/\//im,
    /^\//im,
    /^mailto:/im,
    /^[s\u017F][k\u212A]ype:/im,
    /^callto:/im,
    /^facetime:/im,
    /^git:/im,
    /^irc6?:/im,
    /^new[s\u017F]:/im,
    /^nntp:/im,
    /^feed:/im,
    /^cv[s\u017F]:/im,
    /^[s\u017F]vn:/im,
    /^mvn:/im,
    /^[s\u017F][s\u017F]h:/im,
    /^[s\u017F]cp:\/\//im,
    /^[s\u017F]ftp:\/\//im,
    /^itm[s\u017F]:/im,
    // This is not a valid notes link, but we support this pattern for backwards compatibility
    /^note[s\u017F]:/im,
    /^note[s\u017F]:\/\//im,
    /^hipchat:\/\//im,
    // This is not a valid sourcetree link, but we support this pattern for backwards compatibility
    /^[s\u017F]ourcetree:/im,
    /^[s\u017F]ourcetree:\/\//im,
    /^urn:/im,
    /^tel:/im,
    /^xmpp:/im,
    /^telnet:/im,
    /^vnc:/im,
    /^rdp:/im,
    /^what[s\u017F]app:/im,
    /^[s\u017F]lac[k\u212A]:/im,
    /^[s\u017F]ip[s\u017F]?:/im,
    /^magnet:/im,
    /^#/im
];
var $a302c0502bb198f5$export$c9f92f5469372e0f = function isSafeUrl(url) {
    var urlTrimmed = url === null || url === void 0 ? void 0 : url.trim();
    if (urlTrimmed === undefined) return true;
    if (urlTrimmed.length === 0) return true;
    return $a302c0502bb198f5$var$whitelistedURLPatterns.some(function(p) {
        return p.test(urlTrimmed);
    });
};
var $a302c0502bb198f5$export$8ccbde94d5c7f8e7 = (0, $840z9.default)();
$a302c0502bb198f5$export$8ccbde94d5c7f8e7.add('sourcetree:', 'http:');
$a302c0502bb198f5$export$8ccbde94d5c7f8e7.add('jamfselfservice:', 'http:');
var $a302c0502bb198f5$var$urlWithoutSpacesValidator = {
    validate: /(?:[\0-\x08\x0E-\x1F!-\x9F\xA1-\u167F\u1681-\u1FFF\u200B-\u2027\u202A-\u202E\u2030-\u205E\u2060-\u2FFF\u3001-\uD7FF\uE000-\uFEFE\uFF00-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])+/
};
// `tel:` URI spec is https://datatracker.ietf.org/doc/html/rfc3966
// We're not validating the phone number or separators - but if there's a space it definitely isn't a valid `tel:` URI
$a302c0502bb198f5$export$8ccbde94d5c7f8e7.add('tel:', $a302c0502bb198f5$var$urlWithoutSpacesValidator);
// https://datatracker.ietf.org/doc/html/rfc8089
$a302c0502bb198f5$export$8ccbde94d5c7f8e7.add('file:', $a302c0502bb198f5$var$urlWithoutSpacesValidator);
$a302c0502bb198f5$export$8ccbde94d5c7f8e7.add('notes:', 'http:');
var $a302c0502bb198f5$var$tlds = "biz|com|edu|gov|net|org|pro|web|xxx|aero|asia|coop|info|museum|name|shop|\u0440\u0444".split('|');
var $a302c0502bb198f5$var$tlds2Char = 'a[cdefgilmnoqrtuwxz]|b[abdefghijmnorstvwyz]|c[acdfghiklmnoruvwxyz]|d[ejkmoz]|e[cegrstu]|f[ijkmor]|g[abdefghilmnpqrstuwy]|h[kmnrtu]|i[delmnoqrst]|j[emop]|k[eghimnprwyz]|l[abcikrstuvy]|m[acdeghklmnopqrtuvwxyz]|n[acefgilopruz]|om|p[aefghkmnrtw]|qa|r[eosuw]|s[abcdegijklmnrtuvxyz]|t[cdfghjklmnortvwz]|u[agksyz]|v[aceginu]|w[fs]|y[et]|z[amw]';
$a302c0502bb198f5$var$tlds.push($a302c0502bb198f5$var$tlds2Char);
$a302c0502bb198f5$export$8ccbde94d5c7f8e7.tlds($a302c0502bb198f5$var$tlds, false);
var $a302c0502bb198f5$export$746d02eae03c72e1 = /(https?|ftp|jamfselfservice|gopher|dynamicsnav|integrity|file|smb):\/\/(?:[\0-\x08\x0E-\x1F!-\x9F\xA1-\u167F\u1681-\u1FFF\u200B-\u2027\u202A-\u202E\u2030-\u205E\u2060-\u2FFF\u3001-\uD7FF\uE000-\uFEFE\uFF00-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])+/;
var $a302c0502bb198f5$export$6f7d7761b97f967 = function linkifyMatch(text) {
    if (!$a302c0502bb198f5$export$746d02eae03c72e1.test(text)) return [];
    var matches = [];
    var startpos = 0;
    var substr;
    substr = text.substr(startpos);
    while(substr){
        var link = (substr.match($a302c0502bb198f5$export$746d02eae03c72e1) || [
            ''
        ])[0];
        if (link) {
            var index = substr.search($a302c0502bb198f5$export$746d02eae03c72e1);
            var start = index >= 0 ? index + startpos : index;
            var end = start + link.length;
            matches.push({
                index: start,
                lastIndex: end,
                raw: link,
                url: link,
                text: link,
                schema: ''
            });
            startpos += end;
            substr = text.substr(startpos);
        } else break;
    }
    return matches;
};
function $a302c0502bb198f5$export$ce9ae45aed3e4ec(str) {
    if (!str) return null;
    // linkify-it mishandles closing braces on long urls, so we preference using our own regex first:
    // https://product-fabric.atlassian.net/browse/ED-13669
    var match = $a302c0502bb198f5$export$6f7d7761b97f967(str);
    if (!match.length) match = $a302c0502bb198f5$export$8ccbde94d5c7f8e7.match(str);
    return match && match[0];
}
function $a302c0502bb198f5$export$6535eb414fa2c8b6(url) {
    var match = $a302c0502bb198f5$export$ce9ae45aed3e4ec(url);
    return match && match.url || '';
}
function $a302c0502bb198f5$export$23579274a7a24f7b(url) {
    // Support `#top` and `#` special references as per:
    // https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#linking_to_an_element_on_the_same_page
    return url.startsWith('/') || url === '#top' || url === '#';
}


var $f0f3f0f3bbc98098$export$d1b377ca77ac267d = {
    // eslint-disable-next-line @atlaskit/editor/no-re-export
    safeUrl: (0, $a302c0502bb198f5$export$c9f92f5469372e0f)
};


var $7dc088a1efcddf18$var$_excluded = [
    "items"
];
function $7dc088a1efcddf18$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $7dc088a1efcddf18$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $7dc088a1efcddf18$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $7dc088a1efcddf18$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $7dc088a1efcddf18$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $7dc088a1efcddf18$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $7dc088a1efcddf18$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $7dc088a1efcddf18$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $7dc088a1efcddf18$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $7dc088a1efcddf18$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $7dc088a1efcddf18$var$mapMarksItems(spec) {
    var fn = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function(x) {
        return x;
    };
    if (spec.props && spec.props.marks) {
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        var _ref = spec.props.marks, items = _ref.items, rest = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(_ref, $7dc088a1efcddf18$var$_excluded);
        return $7dc088a1efcddf18$var$_objectSpread($7dc088a1efcddf18$var$_objectSpread({}, spec), {}, {
            props: $7dc088a1efcddf18$var$_objectSpread($7dc088a1efcddf18$var$_objectSpread({}, spec.props), {}, {
                marks: $7dc088a1efcddf18$var$_objectSpread($7dc088a1efcddf18$var$_objectSpread({}, rest), {}, {
                    /**
           * `Text & MarksObject<Mark-1>` produces `items: ['mark-1']`
           * `Text & MarksObject<Mark-1 | Mark-2>` produces `items: [['mark-1', 'mark-2']]`
           */ items: items.length ? Array.isArray(items[0]) ? items.map(fn) : [
                        fn(items)
                    ] : [
                        []
                    ]
                })
            })
        });
    } else return spec;
}
// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
var $7dc088a1efcddf18$var$partitionObject = function partitionObject(obj, predicate) {
    return Object.keys(obj).reduce(function(acc, key) {
        var result = predicate(key, obj[key], obj);
        acc[result ? 0 : 1].push(key);
        return acc;
    }, [
        [],
        []
    ]);
};
/**
 * Checks if a spec is a variant spec.
 * A variant spec is an array where the first element is a string (base spec name)
 * and the second element is a ValidatorSpec object { props: { ... } }
 *
 * @param spec - The spec to check
 * @returns true if the spec is a variant spec, false otherwise
 */ var $7dc088a1efcddf18$var$isVariant = function isVariant(spec) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(spec) === 'object' && !!spec && 0 in spec && 1 in spec && typeof spec[0] === 'string' && (0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(spec[1]) === 'object';
};
function $7dc088a1efcddf18$export$a49afc9edc88765c(nodes, marks) {
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return Object.keys($db4a68befdfe02b0$exports).reduce(function(newSpecs, k) {
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        var spec = $7dc088a1efcddf18$var$_objectSpread({}, $db4a68befdfe02b0$exports[k]);
        if ((0, $6TmbT.expValEqualsNoExposure)('platform_editor_flexible_list_schema', 'isEnabled', true) && $7dc088a1efcddf18$var$isVariant(spec) && // Only apply to variants which are explicitly marked for override in `variantSpecOverrides`
        Object.values($7dc088a1efcddf18$var$variantSpecOverrides).includes(k)) // This allows the variant spec to also have the content normalization applied to it
        // When the spec is a variant it will be in the form of ['base_spec_name', { props: { ... } }]
        // So the actual validator spec of the variant will be the second item in the array
        // We also need to shallow clone this to ensure we don't mutate the original spec
        spec = $7dc088a1efcddf18$var$_objectSpread({}, spec[1]);
        if (spec.props) {
            spec.props = $7dc088a1efcddf18$var$_objectSpread({}, spec.props);
            if (spec.props.content) {
                // 'tableCell_content' => { type: 'array', items: [ ... ] }
                if ((0, $9c556fef0f50844f$export$844ec244b1367d54)(spec.props.content)) // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                spec.props.content = $db4a68befdfe02b0$exports[spec.props.content];
                // ['inline', 'emoji']
                if (Array.isArray(spec.props.content)) /**
           * Flatten
           *
           * Input:
           * [ { type: 'array', items: [ 'tableHeader' ] }, { type: 'array', items: [ 'tableCell' ] } ]
           *
           * Output:
           * { type: 'array', items: [ [ 'tableHeader' ], [ 'tableCell' ] ] }
           */ spec.props.content = {
                    type: 'array',
                    items: (spec.props.content || []).map(function(arr) {
                        return arr.items;
                    })
                };
                else spec.props.content = $7dc088a1efcddf18$var$_objectSpread({}, spec.props.content);
                spec.props.content.items = spec.props.content.items// ['inline'] => [['emoji', 'hr', ...]]
                // ['media'] => [['media']]
                .map(function(item) {
                    return (0, $9c556fef0f50844f$export$844ec244b1367d54)(item) ? // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    Array.isArray($db4a68befdfe02b0$exports[item]) ? // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    $db4a68befdfe02b0$exports[item] : [
                        item
                    ] : item;
                })// [['emoji', 'hr', 'inline_code']] => [['emoji', 'hr', ['text', { marks: {} }]]]
                .map(function(item) {
                    return item.map(function(subItem) {
                        return(// Ignored via go/ees005
                        // eslint-disable-next-line @typescript-eslint/no-explicit-any
                        Array.isArray($db4a68befdfe02b0$exports[subItem]) ? // Ignored via go/ees005
                        // eslint-disable-next-line @typescript-eslint/no-explicit-any
                        $db4a68befdfe02b0$exports[subItem] : (0, $9c556fef0f50844f$export$844ec244b1367d54)(subItem) ? subItem : // Now `NoMark` produces `items: []`, should be fixed in generator
                        [
                            'text',
                            subItem
                        ]);
                    })// Remove unsupported nodes & marks
                    // Filter nodes
                    .filter(function(subItem) {
                        if (nodes) {
                            // Node with overrides
                            // ['mediaSingle', { props: { content: { items: [ 'media', 'caption' ] } }}]
                            if (Array.isArray(subItem)) {
                                var _subItem$;
                                var isMainNodeSupported = nodes.indexOf(subItem[0]) > -1;
                                if (isMainNodeSupported && (_subItem$ = subItem[1]) !== null && _subItem$ !== void 0 && (_subItem$ = _subItem$.props) !== null && _subItem$ !== void 0 && (_subItem$ = _subItem$.content) !== null && _subItem$ !== void 0 && _subItem$.items) return subItem[1].props.content.items.every(function(item) {
                                    return nodes.indexOf(item) > -1;
                                });
                                return isMainNodeSupported;
                            }
                            return nodes.indexOf(subItem) > -1;
                        }
                        return true;
                    })// Filter marks
                    .map(function(subItem) {
                        return Array.isArray(subItem) && marks ? /**
            * TODO: Probably try something like immer, but it's 3.3kb gzipped.
            * Not worth it just for this.
            */ [
                            subItem[0],
                            $7dc088a1efcddf18$var$mapMarksItems(subItem[1])
                        ] : subItem;
                    });
                });
            }
        }
        newSpecs[k] = spec;
        return newSpecs;
    }, {});
}
// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $7dc088a1efcddf18$var$getOptionsForType(type, list) {
    if (!list) return {};
    for(var i = 0, len = list.length; i < len; i++){
        var spec = list[i];
        var name = spec;
        var options = {};
        if (Array.isArray(spec)) {
            var _spec = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(spec, 2);
            name = _spec[0];
            options = _spec[1];
        }
        if (name === type) return options;
    }
    return false;
}
var $7dc088a1efcddf18$var$isValidatorSpecAttrs = function isValidatorSpecAttrs(spec) {
    return !!spec.props;
};
function $7dc088a1efcddf18$export$66c739158ef99a42(spec, value) {
    if (!(0, $9c556fef0f50844f$export$4e62c701997796c1)(value)) return !!spec.optional;
    if ($7dc088a1efcddf18$var$isValidatorSpecAttrs(spec)) {
        // If spec has ".props" it is ValidatorSpecAttrs and need to pipe back in recursively
        var _partitionObject = $7dc088a1efcddf18$var$partitionObject(spec.props, function(key, subSpec) {
            return(// Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            $7dc088a1efcddf18$export$66c739158ef99a42(subSpec, value[key]));
        }), _partitionObject2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_partitionObject, 2), _ = _partitionObject2[0], invalidKeys = _partitionObject2[1];
        return invalidKeys.length === 0;
    }
    // extension_node parameters has no type
    if (!(0, $9c556fef0f50844f$export$4e62c701997796c1)(spec.type)) return !!spec.optional;
    switch(spec.type){
        case 'boolean':
            return (0, $9c556fef0f50844f$export$f9ce7b637dfbe238)(value);
        case 'number':
            return (0, $9c556fef0f50844f$export$7e4aa119212bc614)(value) && ((0, $9c556fef0f50844f$export$4e62c701997796c1)(spec.minimum) ? spec.minimum <= value : true) && ((0, $9c556fef0f50844f$export$4e62c701997796c1)(spec.maximum) ? spec.maximum >= value : true);
        case 'integer':
            return (0, $9c556fef0f50844f$export$a287f47fed4544b8)(value) && ((0, $9c556fef0f50844f$export$4e62c701997796c1)(spec.minimum) ? spec.minimum <= value : true) && ((0, $9c556fef0f50844f$export$4e62c701997796c1)(spec.maximum) ? spec.maximum >= value : true);
        case 'string':
            var validatorFnPassed = function validatorFnPassed(rule) {
                return typeof value === 'string' && (0, $9c556fef0f50844f$export$4e62c701997796c1)((0, $f0f3f0f3bbc98098$export$d1b377ca77ac267d)[rule]) && (0, $f0f3f0f3bbc98098$export$d1b377ca77ac267d)[rule](value);
            };
            return (0, $9c556fef0f50844f$export$844ec244b1367d54)(value) && // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            ((0, $9c556fef0f50844f$export$4e62c701997796c1)(spec.minLength) ? spec.minLength <= value.length : true) && ((0, $9c556fef0f50844f$export$4e62c701997796c1)(spec.validatorFn) ? validatorFnPassed(spec.validatorFn) : true) && // Ignored via go/ees005
            // eslint-disable-next-line require-unicode-regexp
            (spec.pattern ? new RegExp(spec.pattern).test(value) : true);
        case 'object':
            return (0, $9c556fef0f50844f$export$53b83ca8eaab0383)(value);
        case 'array':
            if (Array.isArray(value)) {
                var isTuple = !!spec.isTupleLike;
                var minItems = spec.minItems, maxItems = spec.maxItems;
                if (minItems !== undefined && value.length < minItems || maxItems !== undefined && value.length > maxItems) return false;
                if (isTuple) {
                    // If value has fewer items than tuple has specs - we are fine with that.
                    var numberOfItemsToCheck = Math.min(spec.items.length, value.length);
                    return Array(numberOfItemsToCheck).fill(null).every(function(_, i) {
                        return $7dc088a1efcddf18$export$66c739158ef99a42(spec.items[i], value[i]);
                    });
                } else return value.every(function(valueItem) {
                    return(// We check that at least one of the specs in the list (spec.items) matches each value from
                    spec.items.some(function(itemSpec) {
                        return $7dc088a1efcddf18$export$66c739158ef99a42(itemSpec, valueItem);
                    }));
                });
            }
            return false;
        case 'enum':
            return (0, $9c556fef0f50844f$export$844ec244b1367d54)(value) && spec.values.indexOf(value) > -1;
    }
}
var $7dc088a1efcddf18$var$errorMessageFor = function errorMessageFor(type, message) {
    return "".concat(type, ": ").concat(message, ".");
};
var $7dc088a1efcddf18$var$getUnsupportedOptions = function getUnsupportedOptions(spec) {
    if (spec && spec.props && spec.props.content) {
        var _spec$props$content = spec.props.content, allowUnsupportedBlock = _spec$props$content.allowUnsupportedBlock, allowUnsupportedInline = _spec$props$content.allowUnsupportedInline;
        return {
            allowUnsupportedBlock: allowUnsupportedBlock,
            allowUnsupportedInline: allowUnsupportedInline
        };
    }
    return {};
};
var $7dc088a1efcddf18$var$invalidChildContent = function invalidChildContent(child, errorCallback, parentSpec) {
    var message = $7dc088a1efcddf18$var$errorMessageFor(child.type, 'invalid content');
    if (!errorCallback) throw new Error(message);
    else {
        var _parentSpec$props;
        return errorCallback($7dc088a1efcddf18$var$_objectSpread({}, child), {
            code: 'INVALID_CONTENT',
            message: message,
            meta: {
                parentType: parentSpec === null || parentSpec === void 0 || (_parentSpec$props = parentSpec.props) === null || _parentSpec$props === void 0 || (_parentSpec$props = _parentSpec$props.type) === null || _parentSpec$props === void 0 ? void 0 : _parentSpec$props.values[0]
            }
        }, $7dc088a1efcddf18$var$getUnsupportedOptions(parentSpec));
    }
};
var $7dc088a1efcddf18$var$unsupportedMarkContent = function unsupportedMarkContent(errorCode, mark, errorCallback, errorMessage) {
    var message = errorMessage || $7dc088a1efcddf18$var$errorMessageFor(mark.type, 'unsupported mark');
    if (!errorCallback) throw new Error(message);
    else return errorCallback($7dc088a1efcddf18$var$_objectSpread({}, mark), {
        code: errorCode,
        message: message,
        meta: mark
    }, {
        allowUnsupportedBlock: false,
        allowUnsupportedInline: false,
        isMark: true
    });
};
var $7dc088a1efcddf18$var$unsupportedNodeAttributesContent = function unsupportedNodeAttributesContent(entity, errorCode, invalidAttributes, message, errorCallback) {
    if (!errorCallback) throw new Error(message);
    else return errorCallback({
        type: entity.type
    }, {
        code: errorCode,
        message: message,
        meta: invalidAttributes
    }, {
        allowUnsupportedBlock: false,
        allowUnsupportedInline: false,
        isMark: false,
        isNodeAttribute: true
    });
};
/**
 * Map of base spec names to a preferred variant spec that should be used in their place during validation.
 *
 * WARNING: The variant spec must be a strict superset of the base spec, i.e. any content valid
 * under the base spec must also be valid under the variant
 */ var $7dc088a1efcddf18$var$variantSpecOverrides = {
    listItem: 'listItem_with_flexible_first_child',
    taskList: 'taskList_with_flexible_first_child'
};
/**
 * Replaces base validator specs with their designated variant overrides
 */ var $7dc088a1efcddf18$var$applyVariantSpecOverrides = function applyVariantSpecOverrides(validatorSpecs) {
    Object.entries($7dc088a1efcddf18$var$variantSpecOverrides).forEach(function(_ref2) {
        var _ref3 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_ref2, 2), base = _ref3[0], variant = _ref3[1];
        var baseSpec = validatorSpecs[base];
        var variantOverride = validatorSpecs[variant];
        if (baseSpec !== null && baseSpec !== void 0 && baseSpec.props && variantOverride !== null && variantOverride !== void 0 && variantOverride.props && (0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(baseSpec.props) === 'object' && (0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(variantOverride.props) === 'object') // Merge variant overrides INTO the base spec
        baseSpec.props = $7dc088a1efcddf18$var$_objectSpread($7dc088a1efcddf18$var$_objectSpread({}, baseSpec.props), variantOverride.props);
    });
};
function $7dc088a1efcddf18$export$956325f45c5d174a(nodes, marks, options) {
    var validatorSpecs = $7dc088a1efcddf18$export$a49afc9edc88765c(nodes, marks);
    if ((0, $6TmbT.expValEqualsNoExposure)('platform_editor_flexible_list_schema', 'isEnabled', true)) $7dc088a1efcddf18$var$applyVariantSpecOverrides(validatorSpecs);
    var _ref4 = options || {}, _ref4$mode = _ref4.mode, mode = _ref4$mode === void 0 ? 'strict' : _ref4$mode, _ref4$allowPrivateAtt = _ref4.allowPrivateAttributes, allowPrivateAttributes = _ref4$allowPrivateAtt === void 0 ? false : _ref4$allowPrivateAtt;
    var validate = function validate(entity, errorCallback, allowed, parentSpec) {
        if (!allowed) {
            var _iterator = $7dc088a1efcddf18$var$_createForOfIteratorHelper((0, $a265986427be6a21$export$7d2123bc001cdbf8)(validatorSpecs, entity)), _step;
            try {
                for(_iterator.s(); !(_step = _iterator.n()).done;){
                    var _allowed = _step.value;
                    var _validationResult = validateNode(entity, errorCallback, _allowed, parentSpec);
                    if (_validationResult.valid) return {
                        entity: _validationResult.entity,
                        valid: _validationResult.valid
                    };
                }
            } catch (err) {
                _iterator.e(err);
            } finally{
                _iterator.f();
            }
        }
        // If `allowed` was provided or we haven't passed yet, return the initial result
        var validationResult = validateNode(entity, errorCallback, allowed, parentSpec);
        return {
            entity: validationResult.entity,
            valid: validationResult.valid
        };
    };
    var validateNode = function validateNode(entity, errorCallback, allowed, parentSpec) {
        var isMark = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
        var type = entity.type;
        var newEntity = $7dc088a1efcddf18$var$_objectSpread({}, entity);
        var err = function err(code, msg, meta) {
            var message = $7dc088a1efcddf18$var$errorMessageFor(type, msg);
            if (errorCallback) return {
                valid: false,
                entity: errorCallback(newEntity, {
                    code: code,
                    message: message,
                    meta: meta
                }, $7dc088a1efcddf18$var$getUnsupportedOptions(parentSpec))
            };
            else throw new Error(message);
        };
        if (type) {
            var typeOptions = $7dc088a1efcddf18$var$getOptionsForType(type, allowed);
            if (typeOptions === false) return isMark ? {
                valid: false
            } : err('INVALID_TYPE', 'type not allowed here');
            var spec = validatorSpecs[type];
            if (!spec) return err('INVALID_TYPE', "".concat(type, ": No validation spec found for type!"));
            var specBasedValidationResult = specBasedValidationFor(spec, typeOptions, entity, err, newEntity, type, errorCallback, isMark);
            if (specBasedValidationResult.hasValidated && specBasedValidationResult.result) return specBasedValidationResult.result;
        } else return err('INVALID_TYPE', 'ProseMirror Node/Mark should contain a `type`');
        return {
            valid: true,
            entity: newEntity
        };
    };
    return validate;
    function marksValidationFor(validator, entity, errorCallback, newEntity, err) {
        var validationResult;
        if (validator.props && validator.props.marks) {
            var marksSet = allowedMarksFor(validator);
            var marksValidationResult = marksAfterValidation(entity, errorCallback, marksSet, validator);
            validationResult = {
                valid: true,
                entity: newEntity,
                marksValidationOutput: marksValidationResult
            };
        } else validationResult = marksForEntitySpecNotSupportingMarks(entity, newEntity, errorCallback, err);
        return validationResult;
    }
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    function validatorFor(spec, typeOptions) {
        return $7dc088a1efcddf18$var$_objectSpread($7dc088a1efcddf18$var$_objectSpread($7dc088a1efcddf18$var$_objectSpread({}, spec), typeOptions), spec.props ? {
            props: $7dc088a1efcddf18$var$_objectSpread($7dc088a1efcddf18$var$_objectSpread({}, spec.props), typeOptions['props'] || {})
        } : {});
    }
    function marksAfterValidation(entity, errorCallback, marksSet, validator) {
        return entity.marks ? entity.marks.map(function(mark) {
            var isAKnownMark = marks ? marks.indexOf(mark.type) > -1 : true;
            if (mode === 'strict' && isAKnownMark) {
                var finalResult = validateNode(mark, errorCallback, marksSet, validator, true);
                var finalMark = finalResult.entity;
                if (finalMark) return {
                    valid: true,
                    originalMark: mark,
                    newMark: finalMark
                };
                else if (finalResult.marksValidationOutput && finalResult.marksValidationOutput.length) return {
                    valid: false,
                    originalMark: mark,
                    errorCode: finalResult.marksValidationOutput[0].errorCode,
                    message: finalResult.marksValidationOutput[0].message
                };
                else return {
                    valid: false,
                    originalMark: mark,
                    errorCode: 'INVALID_TYPE'
                };
            } else return {
                valid: false,
                originalMark: mark,
                errorCode: 'INVALID_CONTENT'
            };
        }) : [];
    }
    function allowedMarksFor(validator) {
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        var _ref5 = validator.props.marks, items = _ref5.items;
        var marksSet = items.length ? Array.isArray(items[0]) ? items[0] : items : [];
        return marksSet;
    }
    function marksForEntitySpecNotSupportingMarks(prevEntity, newEntity, errorCallback, err) {
        var errorCode = 'REDUNDANT_MARKS';
        var currentMarks = prevEntity.marks || [];
        var newMarks = currentMarks.map(function(mark) {
            var isUnsupportedNodeAttributeMark = mark.type === 'unsupportedNodeAttribute';
            if (isUnsupportedNodeAttributeMark) return mark;
            return $7dc088a1efcddf18$var$unsupportedMarkContent(errorCode, mark, errorCallback);
        });
        if (newMarks.length) {
            newEntity.marks = newMarks;
            return {
                valid: true,
                entity: newEntity
            };
        } else return err('REDUNDANT_MARKS', 'redundant marks', {
            marks: Object.keys(currentMarks)
        });
    }
    function requiredPropertyValidationFor(validatorSpec, prevEntity, err) {
        var result = {
            valid: true,
            entity: prevEntity
        };
        if (validatorSpec.required) {
            if (!validatorSpec.required.every(function(prop) {
                return (0, $9c556fef0f50844f$export$4e62c701997796c1)(prevEntity[prop]);
            })) result = err('MISSING_PROPERTIES', 'required prop missing');
        }
        return result;
    }
    function textPropertyValidationFor(validatorSpec, prevEntity, err) {
        var result = {
            valid: true,
            entity: prevEntity
        };
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        if (validatorSpec.props.text) {
            if ((0, $9c556fef0f50844f$export$4e62c701997796c1)(prevEntity.text) && // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            !$7dc088a1efcddf18$export$66c739158ef99a42(validatorSpec.props.text, prevEntity.text)) result = err('INVALID_TEXT', "'text' validation failed");
        }
        return result;
    }
    function contentLengthValidationFor(validatorSpec, prevEntity, err) {
        var result = {
            valid: true,
            entity: prevEntity
        };
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        if (validatorSpec.props.content && prevEntity.content) {
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            var _content = validatorSpec.props.content, minItems = _content.minItems, maxItems = _content.maxItems;
            var length = prevEntity.content.length;
            if ((0, $9c556fef0f50844f$export$4e62c701997796c1)(minItems) && minItems > length) result = err('INVALID_CONTENT_LENGTH', "'content' should have more than ".concat(minItems, " child"), {
                length: length,
                requiredLength: minItems,
                type: 'minimum'
            });
            else if ((0, $9c556fef0f50844f$export$4e62c701997796c1)(maxItems) && maxItems < length) result = err('INVALID_CONTENT_LENGTH', "'content' should have less than ".concat(maxItems, " child"), {
                length: length,
                requiredLength: maxItems,
                type: 'maximum'
            });
        }
        return result;
    }
    function invalidAttributesFor(validatorSpec, prevEntity) {
        var invalidAttrs = [];
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        var validatorAttrs = {};
        if (validatorSpec.props && validatorSpec.props.attrs) {
            var attrOptions = (0, $9c556fef0f50844f$export$7b85fd78dd236198)(validatorSpec.props.attrs);
            /**
       * Attrs can be union type so try each path
       * attrs: [{ props: { url: { type: 'string' } } }, { props: { data: {} } }],
       * Gotcha: It will always report the last failure.
       */ for(var i = 0, length = attrOptions.length; i < length; ++i){
                var attrOption = attrOptions[i];
                if (attrOption && attrOption.props) {
                    var _partitionObject3 = $7dc088a1efcddf18$var$partitionObject(attrOption.props, function(key, spec) {
                        // Ignored via go/ees005
                        // eslint-disable-next-line @typescript-eslint/no-explicit-any
                        var valueToValidate = prevEntity.attrs[key];
                        return $7dc088a1efcddf18$export$66c739158ef99a42(spec, valueToValidate);
                    });
                    var _partitionObject4 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_partitionObject3, 2);
                    invalidAttrs = _partitionObject4[1];
                }
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                validatorAttrs = attrOption;
                if (!invalidAttrs.length) break;
            }
        }
        return {
            invalidAttrs: invalidAttrs,
            validatorAttrs: validatorAttrs
        };
    }
    function attributesValidationFor(validatorSpec, prevEntity, newEntity, isMark, errorCallback) {
        var validatorSpecAllowsAttributes = validatorSpec.props && validatorSpec.props.attrs;
        if (prevEntity.attrs) {
            if (!validatorSpecAllowsAttributes) {
                if (isMark) return handleNoAttibutesAllowedInSpecForMark(prevEntity, prevEntity.attrs);
                var attrs = Object.keys(prevEntity.attrs);
                return handleUnsupportedNodeAttributes(prevEntity, newEntity, [], attrs, errorCallback);
            }
            var _validateAttributes = validateAttributes(validatorSpec, prevEntity, prevEntity.attrs), hasUnsupportedAttrs = _validateAttributes.hasUnsupportedAttrs, redundantAttrs = _validateAttributes.redundantAttrs, invalidAttrs = _validateAttributes.invalidAttrs;
            if (hasUnsupportedAttrs) {
                if (isMark) return handleUnsupportedMarkAttributes(prevEntity, invalidAttrs, redundantAttrs);
                return handleUnsupportedNodeAttributes(prevEntity, newEntity, invalidAttrs, redundantAttrs, errorCallback);
            }
        }
        return {
            valid: true,
            entity: prevEntity
        };
    }
    function validateAttributes(validatorSpec, prevEntity, // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    attributes) {
        var invalidAttributesResult = invalidAttributesFor(validatorSpec, prevEntity);
        var invalidAttrs = invalidAttributesResult.invalidAttrs;
        var validatorAttrs = invalidAttributesResult.validatorAttrs;
        var attrs = Object.keys(attributes).filter(function(k) {
            return !(allowPrivateAttributes && k.startsWith('__'));
        });
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        var redundantAttrs = attrs.filter(function(a) {
            return !validatorAttrs.props[a];
        });
        var hasRedundantAttrs = redundantAttrs.length > 0;
        var hasUnsupportedAttrs = invalidAttrs.length || hasRedundantAttrs;
        return {
            hasUnsupportedAttrs: hasUnsupportedAttrs,
            invalidAttrs: invalidAttrs,
            redundantAttrs: redundantAttrs
        };
    }
    function handleUnsupportedNodeAttributes(prevEntity, newEntity, invalidAttrs, redundantAttrs, errorCallback) {
        var attr = invalidAttrs.concat(redundantAttrs);
        var result = {
            valid: true,
            entity: prevEntity
        };
        var message = $7dc088a1efcddf18$var$errorMessageFor(prevEntity.type, "'attrs' validation failed");
        var errorCode = 'UNSUPPORTED_ATTRIBUTES';
        newEntity.marks = wrapUnSupportedNodeAttributes(prevEntity, newEntity, attr, errorCode, message, errorCallback);
        result = {
            valid: true,
            entity: newEntity
        };
        return result;
    }
    function handleUnsupportedMarkAttributes(prevEntity, invalidAttrs, redundantAttrs) {
        var errorCode = 'INVALID_ATTRIBUTES';
        var message = $7dc088a1efcddf18$var$errorMessageFor(prevEntity.type, "'attrs' validation failed");
        var hasRedundantAttrs = redundantAttrs.length;
        var hasBothInvalidAndRedundantAttrs = hasRedundantAttrs && invalidAttrs.length;
        if (!hasBothInvalidAndRedundantAttrs && hasRedundantAttrs) {
            errorCode = 'REDUNDANT_ATTRIBUTES';
            message = $7dc088a1efcddf18$var$errorMessageFor('redundant attributes found', redundantAttrs.join(', '));
        }
        var markValidationResult = {
            valid: true,
            originalMark: prevEntity,
            errorCode: errorCode,
            message: message
        };
        return {
            valid: false,
            marksValidationOutput: [
                markValidationResult
            ]
        };
    }
    function handleNoAttibutesAllowedInSpecForMark(prevEntity, // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    attributes) {
        var message = $7dc088a1efcddf18$var$errorMessageFor('redundant attributes found', Object.keys(attributes).join(', '));
        var errorCode = 'REDUNDANT_ATTRIBUTES';
        var markValidationResult = {
            valid: true,
            originalMark: prevEntity,
            errorCode: errorCode,
            message: message
        };
        return {
            valid: false,
            marksValidationOutput: [
                markValidationResult
            ]
        };
    }
    function wrapUnSupportedNodeAttributes(prevEntity, newEntity, invalidAttrs, errorCode, message, errorCallback) {
        var invalidValues = {};
        // eslint-disable-next-line guard-for-in
        for(var invalidAttr in invalidAttrs){
            invalidValues[invalidAttrs[invalidAttr]] = prevEntity.attrs && prevEntity.attrs[invalidAttrs[invalidAttr]];
            if (newEntity.attrs) delete newEntity.attrs[invalidAttrs[invalidAttr]];
        }
        var unsupportedNodeAttributeValues = $7dc088a1efcddf18$var$unsupportedNodeAttributesContent(prevEntity, errorCode, invalidValues, message, errorCallback);
        var finalEntity = $7dc088a1efcddf18$var$_objectSpread({}, newEntity);
        if (finalEntity.marks) {
            if (!unsupportedNodeAttributeValues) return finalEntity.marks;
            // If there is an existing unsupported node attribute mark, overwrite it to avoid duplicate marks
            var existingMark = finalEntity.marks.find(function(mark) {
                return mark.type === unsupportedNodeAttributeValues.type;
            });
            if (existingMark) existingMark.attrs = unsupportedNodeAttributeValues.attrs;
            else finalEntity.marks.push(unsupportedNodeAttributeValues);
            return finalEntity.marks;
        } else return [
            unsupportedNodeAttributeValues
        ];
    }
    function extraPropsValidationFor(validatorSpec, prevEntity, err, newEntity, type) {
        var result = {
            valid: true,
            entity: prevEntity
        };
        var _partitionObject5 = $7dc088a1efcddf18$var$partitionObject(prevEntity, function(k) {
            return(// Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            (0, $9c556fef0f50844f$export$4e62c701997796c1)(validatorSpec.props[k]));
        }), _partitionObject6 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_partitionObject5, 2), requiredProps = _partitionObject6[0], redundantProps = _partitionObject6[1];
        if (redundantProps.length) {
            if (mode === 'loose') {
                newEntity = {
                    type: type
                };
                requiredProps.reduce(function(acc, p) {
                    return (0, $9c556fef0f50844f$export$784d13d8ee351f07)(prevEntity, acc, p);
                }, newEntity);
            } else {
                if (!((redundantProps.indexOf('marks') > -1 || redundantProps.indexOf('attrs') > -1) && redundantProps.length === 1)) return err('REDUNDANT_PROPERTIES', "redundant props found: ".concat(redundantProps.join(', ')), {
                    props: redundantProps
                });
            }
        }
        return result;
    }
    function specBasedValidationFor(spec, // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    typeOptions, prevEntity, err, newEntity, type, errorCallback, isMark) {
        var specBasedValidationResult = {
            hasValidated: false
        };
        var validatorSpec = validatorFor(spec, typeOptions);
        if (!validatorSpec) return specBasedValidationResult;
        // Required Props
        // For array format where `required` is an array
        var requiredPropertyValidatonResult = requiredPropertyValidationFor(validatorSpec, prevEntity, err);
        if (!requiredPropertyValidatonResult.valid) return {
            hasValidated: true,
            result: requiredPropertyValidatonResult
        };
        if (!validatorSpec.props) {
            var props = Object.keys(prevEntity);
            // If there's no validator.props then there shouldn't be any key except `type`
            if (props.length > 1) return {
                hasValidated: true,
                result: err('REDUNDANT_PROPERTIES', "redundant props found: ".concat(Object.keys(prevEntity).join(', ')), {
                    props: props
                })
            };
            return specBasedValidationResult;
        }
        // Check text
        var textPropertyValidationResult = textPropertyValidationFor(validatorSpec, prevEntity, err);
        if (!textPropertyValidationResult.valid) return {
            hasValidated: true,
            result: textPropertyValidationResult
        };
        // Content Length
        var contentLengthValidationResult = contentLengthValidationFor(validatorSpec, prevEntity, err);
        if (!contentLengthValidationResult.valid) return {
            hasValidated: true,
            result: contentLengthValidationResult
        };
        // Required Props
        // For object format based on `optional` property
        var _partitionObject7 = $7dc088a1efcddf18$var$partitionObject(validatorSpec.props, function(k, v) {
            var _validatorSpec$requir;
            // if the validator is an array, then check
            // if the `required` field contains the key.
            var isOptional = Array.isArray(v) ? !((_validatorSpec$requir = validatorSpec.required) !== null && _validatorSpec$requir !== void 0 && _validatorSpec$requir.includes(k)) : (0, (/*@__PURE__*/$parcel$interopDefault($ekGgq)))(v) === 'object' && v !== null && 'optional' in v ? v.optional : false;
            return isOptional || (0, $9c556fef0f50844f$export$4e62c701997796c1)(prevEntity[k]);
        }), _partitionObject8 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_partitionObject7, 2), missingProps = _partitionObject8[1];
        if (missingProps.length) return {
            hasValidated: true,
            result: err('MISSING_PROPERTIES', 'required prop missing', {
                props: missingProps
            })
        };
        var attributesValidationResult = attributesValidationFor(validatorSpec, prevEntity, newEntity, isMark, errorCallback);
        if (!attributesValidationResult.valid) return {
            hasValidated: true,
            result: attributesValidationResult
        };
        if (isMark && attributesValidationResult.valid) return {
            hasValidated: true,
            result: attributesValidationResult
        };
        var extraPropsValidationResult = extraPropsValidationFor(validatorSpec, prevEntity, err, newEntity, type);
        if (!extraPropsValidationResult.valid) return {
            hasValidated: true,
            result: extraPropsValidationResult
        };
        // Children
        if (validatorSpec.props.content) {
            var contentValidatorSpec = validatorSpec.props.content;
            if (prevEntity.content) {
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                var validateChildNode = function validateChildNode(child, index) {
                    if (child === undefined) return child;
                    var validateChildMarks = function validateChildMarks(childEntity, marksValidationOutput, errorCallback, isLastValidationSpec) {
                        var isParentTupleLike = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
                        var marksAreValid = true;
                        if (childEntity && childEntity.marks && marksValidationOutput) {
                            var validMarks = marksValidationOutput.filter(function(mark) {
                                return mark.valid;
                            });
                            // Ignored via go/ees005
                            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                            var finalMarks = marksValidationOutput.map(function(mr) {
                                if (mr.valid) return mr.newMark;
                                else {
                                    if (validMarks.length || isLastValidationSpec || isParentTupleLike || mr.errorCode === 'INVALID_TYPE' || mr.errorCode === 'INVALID_CONTENT' || mr.errorCode === 'REDUNDANT_ATTRIBUTES' || mr.errorCode === 'INVALID_ATTRIBUTES') return $7dc088a1efcddf18$var$unsupportedMarkContent(// Ignored via go/ees005
                                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                                    mr.errorCode, mr.originalMark, errorCallback, mr.message);
                                    return;
                                }
                            }).filter(Boolean);
                            if (finalMarks.length) childEntity.marks = finalMarks;
                            else {
                                delete childEntity.marks;
                                marksAreValid = false;
                            }
                        }
                        return {
                            valid: marksAreValid,
                            entity: childEntity
                        };
                    };
                    var hasMultipleCombinationOfContentAllowed = !!contentValidatorSpec.isTupleLike;
                    if (hasMultipleCombinationOfContentAllowed) {
                        var _validateNode = validateNode(child, errorCallback, (0, $9c556fef0f50844f$export$7b85fd78dd236198)(contentValidatorSpec.items[index] || contentValidatorSpec.items[contentValidatorSpec.items.length - 1]), validatorSpec), newChildEntity = _validateNode.entity, marksValidationOutput = _validateNode.marksValidationOutput;
                        var _validateChildMarks = validateChildMarks(newChildEntity, marksValidationOutput, errorCallback, false, true), entity = _validateChildMarks.entity;
                        return entity;
                    }
                    // Only go inside valid branch
                    var allowedSpecsForEntity = contentValidatorSpec.items.filter(function(item) {
                        return Array.isArray(item) ? item.some(// [p, hr, ...] or [p, [text, {}], ...]
                        function(spec) {
                            return (Array.isArray(spec) ? spec[0] : spec) === child.type;
                        }) : true;
                    });
                    if (allowedSpecsForEntity.length) {
                        if (allowedSpecsForEntity.length > 1) throw new Error('Consider using Tuple instead!');
                        var maybeArray = (0, $9c556fef0f50844f$export$7b85fd78dd236198)(allowedSpecsForEntity[0]);
                        var allowedSpecsForChild = maybeArray.filter(function(item) {
                            return (Array.isArray(item) ? item[0] : item) === child.type;
                        });
                        if (allowedSpecsForChild.length === 0) return $7dc088a1efcddf18$var$invalidChildContent(child, errorCallback, validatorSpec);
                        /**
             * When there's multiple possible branches try all of them.
             * If all of them fails, throw the first one.
             * e.g.- [['text', { marks: ['a'] }], ['text', { marks: ['b'] }]]
             */ var firstError;
                        var firstChild;
                        for(var i = 0, len = allowedSpecsForChild.length; i < len; i++)try {
                            var allowedValueForCurrentSpec = [
                                allowedSpecsForChild[i]
                            ];
                            var _validateNode2 = validateNode(child, errorCallback, allowedValueForCurrentSpec, validatorSpec), valid = _validateNode2.valid, _newChildEntity = _validateNode2.entity, _marksValidationOutput = _validateNode2.marksValidationOutput;
                            if (valid) {
                                var isLastValidationSpec = i === allowedSpecsForChild.length - 1;
                                var _validateChildMarks2 = validateChildMarks(_newChildEntity, _marksValidationOutput, errorCallback, isLastValidationSpec), marksAreValid = _validateChildMarks2.valid, _entity = _validateChildMarks2.entity;
                                var unsupportedMarks = _entity && _entity.marks && _entity.marks.filter(function(mark) {
                                    return mark.type === 'unsupportedMark';
                                }) || [];
                                if (marksAreValid && !unsupportedMarks.length) return _entity;
                                else firstChild = firstChild || _newChildEntity;
                            } else firstChild = firstChild || _newChildEntity;
                        } catch (error) {
                            firstError = firstError || error;
                        }
                        if (!errorCallback) throw firstError;
                        else return firstChild;
                    } else return $7dc088a1efcddf18$var$invalidChildContent(child, errorCallback, validatorSpec);
                };
                newEntity.content = prevEntity.content.map(validateChildNode).filter(Boolean);
            } else if (!contentValidatorSpec.optional) return {
                hasValidated: true,
                result: err('MISSING_PROPERTIES', 'missing `content` prop')
            };
        }
        // Marks
        if (prevEntity.marks) return {
            hasValidated: true,
            result: marksValidationFor(validatorSpec, prevEntity, errorCallback, newEntity, err)
        };
        return specBasedValidationResult;
    }
}



var $jJH6F = parcelRequire("jJH6F");

var $fpooh = parcelRequire("fpooh");
function $0f386b4740d7d561$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $0f386b4740d7d561$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $0f386b4740d7d561$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $0f386b4740d7d561$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $0f386b4740d7d561$export$8e7fd962b4d3895d = 'unsupportedNodeAttribute';
var $0f386b4740d7d561$var$errorCallbackFor = function errorCallbackFor(marks, validate, dispatchAnalyticsEvent, validationOverrides) {
    return function(entity, error, options) {
        return $0f386b4740d7d561$export$468b008419c9a974(entity, error, $0f386b4740d7d561$var$_objectSpread($0f386b4740d7d561$var$_objectSpread({}, options), {}, {
            allowNestedTables: validationOverrides === null || validationOverrides === void 0 ? void 0 : validationOverrides.allowNestedTables
        }), marks, validate, dispatchAnalyticsEvent);
    };
};
var $0f386b4740d7d561$export$468b008419c9a974 = function validationErrorHandler(entity, error, options, marks, validate, dispatchAnalyticsEvent) {
    if (entity && entity.type === $0f386b4740d7d561$export$8e7fd962b4d3895d) return entity;
    if (options.isMark) return $0f386b4740d7d561$export$87b732fa69cdf16e(error.meta, 'mark');
    if (options.isNodeAttribute) {
        var entityType = entity && entity.type ? entity.type : undefined;
        return {
            type: $0f386b4740d7d561$export$8e7fd962b4d3895d,
            attrs: {
                type: {
                    nodeType: entityType
                },
                unsupported: error.meta
            }
        };
    }
    if (entity && marks.indexOf(entity.type) > -1) return;
    /**
   * There's a inconsistency between ProseMirror and ADF.
   * `content` is actually optional in ProseMirror.
   * And, also empty `text` node is not valid.
   */ if (error.code === 'MISSING_PROPERTIES' && entity.type === 'paragraph') return {
        type: 'paragraph',
        content: []
    };
    // Ignored via go/ees007
    // eslint-disable-next-line @atlaskit/editor/enforce-todo-comment-format
    // TODO: We can repair missing content like `panel` without a `paragraph`.
    if (error.code === 'INVALID_CONTENT_LENGTH') {
        if (error.meta && options.allowUnsupportedBlock && entity.content) return $0f386b4740d7d561$var$getEntityForInvalidContentLength(error, entity, validate, marks, dispatchAnalyticsEvent);
        else // Can't fix it by wrapping
        if (dispatchAnalyticsEvent) $0f386b4740d7d561$var$trackValidationError(dispatchAnalyticsEvent, error, entity);
    }
    // Nested tables don't actually exist in ADF. In ADF they are stored as an `extension` node with the nested table content serialized in a property of that extension.
    // Usually when we validate ADF we are validating this `extension` and then later transforming it into nested tables for usage by ProseMirror.
    // Under certain circumstances however, ADF validation is performed on this already transformed extension and since nested tables aren't allowed by ADF this
    // produces an error. For example, nested renderers in Confluence `bodiedExtension`'s. The nested renderer receives the already transformed nested tables that originated from the
    // `extension` node and validates it. This is invalid ADF so an error is thrown.
    // This override allows an exception to be made for nested tables in the validator in this circumstance.
    if (options.allowNestedTables) {
        var meta = error.meta;
        if (options.allowNestedTables && meta !== null && meta !== void 0 && meta.parentType && [
            'tableCell',
            'tableHeader'
        ].includes(meta === null || meta === void 0 ? void 0 : meta.parentType) && error.code === 'INVALID_CONTENT' && entity.type === 'table') return entity;
    }
    if (options.allowUnsupportedBlock) return $0f386b4740d7d561$export$87b732fa69cdf16e(entity);
    if (options.allowUnsupportedInline) return $0f386b4740d7d561$export$87b732fa69cdf16e(entity, 'inline');
    if (dispatchAnalyticsEvent) $0f386b4740d7d561$var$trackValidationError(dispatchAnalyticsEvent, error, entity);
    return entity;
};
function $0f386b4740d7d561$var$getEntityForInvalidContentLength(error, entity, validate, marks, dispatchAnalyticsEvent) {
    var meta = error.meta;
    if (meta.type === 'maximum') // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    entity.content = entity.content.filter(function(x) {
        return !!x;
    }).map(function(child, index) {
        return index >= meta.requiredLength && child.type !== 'unsupportedBlock' ? $0f386b4740d7d561$export$87b732fa69cdf16e(child) : validate(child, $0f386b4740d7d561$var$errorCallbackFor(marks, validate, dispatchAnalyticsEvent)).entity;
    });
    if (meta.type === 'minimum') {
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        if (entity.content.length === 0) return $0f386b4740d7d561$export$87b732fa69cdf16e(entity);
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        entity.content = entity.content.filter(function(x) {
            return !!x;
        }).map(function(child) {
            return child.type !== 'unsupportedBlock' ? $0f386b4740d7d561$export$87b732fa69cdf16e(child) : child;
        });
    }
    return entity;
}
function $0f386b4740d7d561$var$trackValidationError(dispatchAnalyticsEvent, error, entity) {
    if (!dispatchAnalyticsEvent) return;
    (0, $fpooh.fireUnsupportedEvent)(dispatchAnalyticsEvent, (0, $jJH6F.ACTION_SUBJECT_ID).UNSUPPORTED_ERROR, {
        type: entity.type || '',
        ancestry: entity.ancestorHierarchy || '',
        parentType: entity.parentType || '',
        marks: entity.marks || [],
        attrs: entity.attrs || {}
    }, error.code);
}
var $0f386b4740d7d561$export$884cfad20dece33e = function validateADFEntity(schema, node, dispatchAnalyticsEvent, validationOverrides) {
    var nodes = Object.keys(schema.nodes);
    var marks = Object.keys(schema.marks);
    var validate = (0, $7dc088a1efcddf18$export$956325f45c5d174a)(nodes, marks, {
        allowPrivateAttributes: true
    });
    var emptyDoc = {
        type: 'doc',
        content: []
    };
    var _validate = validate(node, $0f386b4740d7d561$var$errorCallbackFor(marks, validate, dispatchAnalyticsEvent, validationOverrides)), _validate$entity = _validate.entity, entity = _validate$entity === void 0 ? emptyDoc : _validate$entity;
    return entity;
};
function $0f386b4740d7d561$export$87b732fa69cdf16e(originalValue) {
    var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'block';
    var unsupportedNodeType;
    switch(type){
        case 'inline':
            unsupportedNodeType = 'unsupportedInline';
            break;
        case 'mark':
            unsupportedNodeType = 'unsupportedMark';
            break;
        default:
            unsupportedNodeType = 'unsupportedBlock';
    }
    return {
        type: unsupportedNodeType,
        attrs: {
            originalValue: originalValue
        }
    };
}




var $9Zzpd = parcelRequire("9Zzpd");

var $cvlyC = parcelRequire("cvlyC");

var $aP6HU = parcelRequire("aP6HU");

var $25nEq = parcelRequire("25nEq");
function $eb171955d7e73573$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $eb171955d7e73573$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $eb171955d7e73573$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $eb171955d7e73573$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $eb171955d7e73573$export$735cfea22ce30f58(_visitors) {
    return true;
}
function $eb171955d7e73573$export$df3f009e3d155b20(adf, visitors) {
    if (!$eb171955d7e73573$export$735cfea22ce30f58(visitors)) throw new Error("Visitors are not valid: \"".concat(Object.keys(visitors).join(', '), "\""));
    return $eb171955d7e73573$var$traverseNode(adf, {
        node: undefined
    }, visitors, 0, 0);
}
function $eb171955d7e73573$var$traverseNode(adfNode, parent, visitors, index, depth) {
    var visitor = visitors[adfNode.type] || visitors['any'];
    var newNode = $eb171955d7e73573$var$_objectSpread({}, adfNode);
    if (visitor) {
        var processedNode = visitor($eb171955d7e73573$var$_objectSpread({}, newNode), parent, index, depth);
        if (processedNode === false) return false;
        newNode = processedNode || adfNode;
    }
    if (newNode.content) newNode.content = newNode.content.reduce(function(acc, node, idx) {
        if (!node) return acc;
        var processedNode = $eb171955d7e73573$var$traverseNode(node, {
            node: newNode,
            parent: parent
        }, visitors, idx, depth + 1);
        if (processedNode !== false) acc.push(processedNode);
        return acc;
    }, []);
    return newNode;
}


var $89d8778c7b3d3918$export$6632e71a22d31bf1 = /*#__PURE__*/ function(UNSUPPORTED_CONTENT_LEVEL_SEVERITY) {
    UNSUPPORTED_CONTENT_LEVEL_SEVERITY["NORMAL"] = "normal";
    UNSUPPORTED_CONTENT_LEVEL_SEVERITY["DEGRADED"] = "degraded";
    UNSUPPORTED_CONTENT_LEVEL_SEVERITY["BLOCKING"] = "blocking";
    return UNSUPPORTED_CONTENT_LEVEL_SEVERITY;
}({});
var $89d8778c7b3d3918$export$f9f8a29778652c3e = {
    DEGRADED: 10,
    BLOCKING: 25
};
var $89d8778c7b3d3918$var$buildUnsupportedContentLevelThresholds = function buildUnsupportedContentLevelThresholds(customThresholds) {
    return {
        degraded: (customThresholds === null || customThresholds === void 0 ? void 0 : customThresholds.degraded) || $89d8778c7b3d3918$export$f9f8a29778652c3e.DEGRADED,
        blocking: (customThresholds === null || customThresholds === void 0 ? void 0 : customThresholds.blocking) || $89d8778c7b3d3918$export$f9f8a29778652c3e.BLOCKING
    };
};
var $89d8778c7b3d3918$var$countSupportedUnsupportedNodes = function countSupportedUnsupportedNodes(validDocument) {
    var unsupportedNodes = 0;
    var supportedNodes = 0;
    var unsupportedNodeTypeCount = {};
    var unsupportedNodeTypes = [
        'unsupportedInline',
        'unsupportedBlock',
        'confluenceUnsupportedInline',
        'confluenceUnsupportedBlock'
    ];
    (0, $eb171955d7e73573$export$df3f009e3d155b20)(validDocument, {
        any: function any(node) {
            if (unsupportedNodeTypes.includes(node.type)) {
                var _node$attrs;
                var originalNode = (_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.originalValue;
                if (originalNode) // start an independent traversal for the purpose of counting
                // unsupported content nodes (with nested children contributing towards
                // that count)
                (0, $eb171955d7e73573$export$df3f009e3d155b20)(originalNode, {
                    any: function any(unsupportedNode, parent) {
                        var _parent$parent$node$t, _parent$parent, _unsupportedNode$type, _unsupportedNodeTypeC;
                        unsupportedNodes++;
                        // Count the types of unsupported nodes
                        var parentType = (_parent$parent$node$t = (_parent$parent = parent.parent) === null || _parent$parent === void 0 || (_parent$parent = _parent$parent.node) === null || _parent$parent === void 0 ? void 0 : _parent$parent.type) !== null && _parent$parent$node$t !== void 0 ? _parent$parent$node$t : 'unknown';
                        var type = "".concat(parentType, "/").concat((_unsupportedNode$type = unsupportedNode === null || unsupportedNode === void 0 ? void 0 : unsupportedNode.type) !== null && _unsupportedNode$type !== void 0 ? _unsupportedNode$type : 'unknown');
                        unsupportedNodeTypeCount[type] = ((_unsupportedNodeTypeC = unsupportedNodeTypeCount === null || unsupportedNodeTypeCount === void 0 ? void 0 : unsupportedNodeTypeCount[type]) !== null && _unsupportedNodeTypeC !== void 0 ? _unsupportedNodeTypeC : 0) + 1;
                    }
                });
                // force the parent traversal (which is counting supported content nodes)
                // to skip traversal/counting of nested children of the unsupported nodes
                return false;
            } else supportedNodes++;
        }
    });
    return {
        unsupportedNodes: unsupportedNodes,
        supportedNodes: supportedNodes,
        unsupportedNodeTypeCount: unsupportedNodeTypeCount
    };
};
var $89d8778c7b3d3918$var$mapUnsupportedContentLevelToSeverity = function mapUnsupportedContentLevelToSeverity(unsupportedContentLevelPercent, thresholds) {
    if (thresholds.degraded <= unsupportedContentLevelPercent && unsupportedContentLevelPercent < thresholds.blocking) return $89d8778c7b3d3918$export$6632e71a22d31bf1.DEGRADED;
    if (thresholds.blocking <= unsupportedContentLevelPercent) return $89d8778c7b3d3918$export$6632e71a22d31bf1.BLOCKING;
    return $89d8778c7b3d3918$export$6632e71a22d31bf1.NORMAL;
};
var $89d8778c7b3d3918$export$484b83e0462998d = function getUnsupportedContentLevelData(validDocument, customThresholds) {
    var _countSupportedUnsupp = $89d8778c7b3d3918$var$countSupportedUnsupportedNodes(validDocument), unsupportedNodes = _countSupportedUnsupp.unsupportedNodes, supportedNodes = _countSupportedUnsupp.supportedNodes, unsupportedNodeTypeCount = _countSupportedUnsupp.unsupportedNodeTypeCount;
    var thresholds = $89d8778c7b3d3918$var$buildUnsupportedContentLevelThresholds(customThresholds);
    var percentage = Math.round(unsupportedNodes / (unsupportedNodes + supportedNodes) * 100);
    var severity = $89d8778c7b3d3918$var$mapUnsupportedContentLevelToSeverity(percentage, thresholds);
    return {
        severity: severity,
        percentage: percentage,
        counts: {
            supportedNodes: supportedNodes,
            unsupportedNodes: unsupportedNodes,
            unsupportedNodeTypeCount: unsupportedNodeTypeCount
        }
    };
};



var $jJH6F = parcelRequire("jJH6F");

var $aP6HU = parcelRequire("aP6HU");
// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
var $588355632ca7aaa5$var$rendersMap = {};
var $588355632ca7aaa5$var$processLevelsAndTrack = function processLevelsAndTrack(item, thresholds, dispatchAnalyticsEvent) {
    try {
        var _getUnsupportedConten = (0, $89d8778c7b3d3918$export$484b83e0462998d)(item.doc, thresholds), severity = _getUnsupportedConten.severity, percentage = _getUnsupportedConten.percentage, _getUnsupportedConten2 = _getUnsupportedConten.counts, supportedNodes = _getUnsupportedConten2.supportedNodes, unsupportedNodes = _getUnsupportedConten2.unsupportedNodes, unsupportedNodeTypeCount = _getUnsupportedConten2.unsupportedNodeTypeCount;
        dispatchAnalyticsEvent({
            action: (0, $jJH6F.ACTION).UNSUPPORTED_CONTENT_LEVELS_TRACKING_SUCCEEDED,
            actionSubject: (0, $jJH6F.ACTION_SUBJECT).RENDERER,
            attributes: {
                appearance: (0, $577d48613d9afb24$export$be87849653b93e6b)(item.appearance),
                platform: (0, $aP6HU.PLATFORM).WEB,
                unsupportedContentLevelSeverity: severity,
                unsupportedContentLevelPercentage: percentage,
                unsupportedNodesCount: unsupportedNodes,
                supportedNodesCount: supportedNodes,
                unsupportedNodeTypeCount: unsupportedNodeTypeCount
            },
            eventType: (0, $jJH6F.EVENT_TYPE).OPERATIONAL
        });
    } catch (err) {
        dispatchAnalyticsEvent({
            action: (0, $jJH6F.ACTION).UNSUPPORTED_CONTENT_LEVELS_TRACKING_ERRORED,
            actionSubject: (0, $jJH6F.ACTION_SUBJECT).RENDERER,
            attributes: {
                platform: (0, $aP6HU.PLATFORM).WEB,
                error: err instanceof Error ? err.message : String(err)
            },
            eventType: (0, $jJH6F.EVENT_TYPE).OPERATIONAL
        });
    }
};
var $588355632ca7aaa5$var$schedule = function schedule(fn) {
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    if (typeof window.requestIdleCallback === 'function') // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    window.requestIdleCallback(fn);
    else setTimeout(fn, 0);
};
var $588355632ca7aaa5$var$DEFAULT_SAMPLING_RATE = 100;
var $588355632ca7aaa5$export$a43de96edd8d0a0 = function trackUnsupportedContentLevels(item, trackingOptions, dispatchAnalyticsEvent) {
    var _item$appearance;
    var thresholds = trackingOptions.thresholds, samplingRates = trackingOptions.samplingRates;
    var appearance = (_item$appearance = item.appearance) !== null && _item$appearance !== void 0 ? _item$appearance : 'unknown';
    if (!$588355632ca7aaa5$var$rendersMap[appearance]) $588355632ca7aaa5$var$rendersMap[appearance] = new Set();
    // bail out if already processed a render from a given renderer instance
    var didProcessRenderer = $588355632ca7aaa5$var$rendersMap[appearance].has(item.rendererId);
    if (didProcessRenderer) return;
    // otherwise track the render
    $588355632ca7aaa5$var$rendersMap[appearance].add(item.rendererId);
    var sampleRate = samplingRates && samplingRates[appearance] || $588355632ca7aaa5$var$DEFAULT_SAMPLING_RATE;
    // sample from the first available tracked render
    if ($588355632ca7aaa5$var$rendersMap[appearance].size === 1) $588355632ca7aaa5$var$schedule(function() {
        return $588355632ca7aaa5$var$processLevelsAndTrack(item, thresholds, dispatchAnalyticsEvent);
    });
    // cleanup/refresh tracked renders at the sampling rate
    if ($588355632ca7aaa5$var$rendersMap[appearance].size % sampleRate === 0) $588355632ca7aaa5$var$rendersMap[appearance] = new Set();
};



var $30Iuw = parcelRequire("30Iuw");
function $a0b5eb012d6bf593$export$533b26079ad0b4b(adf, callback, initial) {
    var result = initial;
    (0, $30Iuw.traverse)(adf, {
        any: function any(node) {
            result = callback(result, node);
        }
    });
    return result;
}


function $85fdf1d409f20456$export$1daf15cbaf649dad(adfDocument) {
    return (0, $a0b5eb012d6bf593$export$533b26079ad0b4b)(adfDocument, function(acc, node) {
        acc[node.type] = (acc[node.type] || 0) + 1;
        return acc;
    }, {});
}


var $2071b3d80d22d00f$var$SUPPORTS_HIRES_TIMER_API = !!(typeof window !== 'undefined' && window.performance && performance.now);
var $2071b3d80d22d00f$var$withStopwatch = function withStopwatch(cb) {
    var startTime = $2071b3d80d22d00f$var$SUPPORTS_HIRES_TIMER_API ? performance.now() : Date.now();
    var output = cb();
    var endTime = $2071b3d80d22d00f$var$SUPPORTS_HIRES_TIMER_API ? performance.now() : Date.now();
    var time = endTime - startTime;
    return {
        output: output,
        time: time
    };
};
var $2071b3d80d22d00f$var$_validation = function _validation(doc, schema, adfStage, useSpecBasedValidator, dispatchAnalyticsEvent, skipValidation, validationOverrides) {
    var result;
    if (useSpecBasedValidator) {
        // link mark on mediaSingle is deprecated, need to move link mark to child media node
        // https://product-fabric.atlassian.net/browse/ED-14043
        var _transformMediaLinkMa = (0, $793534cea0118fed$export$6528700f3fa2fe2a)(doc), transformedAdf = _transformMediaLinkMa.transformedAdf, isTransformed = _transformMediaLinkMa.isTransformed;
        if (isTransformed && dispatchAnalyticsEvent) dispatchAnalyticsEvent({
            action: (0, $jJH6F.ACTION).MEDIA_LINK_TRANSFORMED,
            actionSubject: (0, $jJH6F.ACTION_SUBJECT).RENDERER,
            eventType: (0, $jJH6F.EVENT_TYPE).OPERATIONAL
        });
        result = skipValidation ? transformedAdf || doc : (0, $0f386b4740d7d561$export$884cfad20dece33e)(schema, transformedAdf || doc, dispatchAnalyticsEvent, validationOverrides);
    } else result = (0, $5558251c256ad6af$export$fb80336a7e408cb3)(doc, schema, adfStage);
    if (!result) return result;
    // ProseMirror always require a child under doc
    if (result.type === 'doc' && useSpecBasedValidator) {
        if (Array.isArray(result.content) && result.content.length === 0) result.content.push({
            type: 'paragraph',
            content: []
        });
        // Just making sure doc is always valid
        if (!result.version) result.version = 1;
    }
    // Convert nested-table extensions into nested tables
    try {
        var _transformNestedTable = (0, $471646a78c6cd88f$export$18544d0b5f43e4a1)(result), _transformedAdf = _transformNestedTable.transformedAdf, _isTransformed = _transformNestedTable.isTransformed;
        if (_isTransformed) {
            dispatchAnalyticsEvent === null || dispatchAnalyticsEvent === void 0 || dispatchAnalyticsEvent({
                action: (0, $jJH6F.ACTION).NESTED_TABLE_TRANSFORMED,
                actionSubject: (0, $jJH6F.ACTION_SUBJECT).RENDERER,
                eventType: (0, $jJH6F.EVENT_TYPE).OPERATIONAL
            });
            result = _transformedAdf;
        }
    } catch (e) {
        dispatchAnalyticsEvent === null || dispatchAnalyticsEvent === void 0 || dispatchAnalyticsEvent({
            action: (0, $jJH6F.ACTION).INVALID_PROSEMIRROR_DOCUMENT,
            actionSubject: (0, $jJH6F.ACTION_SUBJECT).RENDERER,
            eventType: (0, $jJH6F.EVENT_TYPE).OPERATIONAL,
            attributes: {
                platform: (0, $aP6HU.PLATFORM).WEB,
                errorStack: "".concat(e instanceof Error && e.name === 'NodeNestingTransformError' ? 'NodeNestingTransformError - Failed to encode one or more nested tables' : undefined)
            }
        });
    }
    return result;
};
var $2071b3d80d22d00f$var$memoValidation = (0, $cvlyC.default)($2071b3d80d22d00f$var$_validation, function(newArgs, lastArgs) {
    var _newArgs = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(newArgs, 7), newDoc = _newArgs[0], newSchema = _newArgs[1], newADFStage = _newArgs[2], newUseSpecValidator = _newArgs[3], /* ignoring dispatchAnalyticsEvent */ newSkipValidation = _newArgs[5], newValidationOverrides = _newArgs[6];
    var _lastArgs = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(lastArgs, 7), oldDoc = _lastArgs[0], oldSchema = _lastArgs[1], oldADFStage = _lastArgs[2], oldUseSpecValidator = _lastArgs[3], /* ignoring dispatchAnalyticsEvent */ oldSkipValidation = _lastArgs[5], oldValidationOverrides = _lastArgs[6];
    return $2071b3d80d22d00f$var$areDocsEqual(newDoc, oldDoc) && newSchema === oldSchema && newADFStage === oldADFStage && newUseSpecValidator === oldUseSpecValidator && newSkipValidation === oldSkipValidation && newValidationOverrides === oldValidationOverrides;
});
// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
var $2071b3d80d22d00f$var$areDocsEqual = function areDocsEqual(docA, docB) {
    if (docA === docB) return true;
    if (typeof docA === 'string' && typeof docB === 'string') return docA === docB;
    // PMNode
    if (docA.type && docA.toJSON && docB.type && docB.toJSON) return JSON.stringify(docA.toJSON()) === JSON.stringify(docB.toJSON());
    // Object
    return JSON.stringify(docA) === JSON.stringify(docB);
};
var $2071b3d80d22d00f$var$_serializeFragment = function _serializeFragment(serializer, doc) {
    return serializer.serializeFragment(doc.content);
};
var $2071b3d80d22d00f$var$memoSerializeFragment = (0, $cvlyC.default)($2071b3d80d22d00f$var$_serializeFragment, function(newArgs, lastArgs) {
    var _newArgs2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(newArgs, 2), newSerializer = _newArgs2[0], newDoc = _newArgs2[1];
    var _lastArgs2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(lastArgs, 2), oldSerializer = _lastArgs2[0], oldDoc = _lastArgs2[1];
    return newSerializer === oldSerializer && $2071b3d80d22d00f$var$areDocsEqual(newDoc, oldDoc);
});
var $2071b3d80d22d00f$var$_createNodeAndCheck = function _createNodeAndCheck(schema, doc, dispatchAnalyticsEvent) {
    var pmNode = schema.nodeFromJSON(doc);
    try {
        pmNode.check();
    } catch (err) {
        if (dispatchAnalyticsEvent) dispatchAnalyticsEvent({
            action: (0, $jJH6F.ACTION).INVALID_PROSEMIRROR_DOCUMENT,
            actionSubject: (0, $jJH6F.ACTION_SUBJECT).RENDERER,
            attributes: {
                platform: (0, $aP6HU.PLATFORM).WEB,
                errorStack: err instanceof Error ? err.message : String(err)
            },
            eventType: (0, $jJH6F.EVENT_TYPE).OPERATIONAL
        });
    }
    return pmNode;
};
var $2071b3d80d22d00f$var$memoCreateNodeAndCheck = (0, $cvlyC.default)($2071b3d80d22d00f$var$_createNodeAndCheck, function(newArgs, lastArgs) {
    // ignore dispatchAnalyticsEvent
    var _newArgs3 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(newArgs, 2), newSchema = _newArgs3[0], newDoc = _newArgs3[1];
    var _lastArgs3 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(lastArgs, 2), oldSchema = _lastArgs3[0], oldDoc = _lastArgs3[1];
    return newSchema === oldSchema && $2071b3d80d22d00f$var$areDocsEqual(newDoc, oldDoc);
});
var $2071b3d80d22d00f$export$59a54f98b9753d5c = function renderDocument(doc, serializer) {
    var schema = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : (0, $kYLlQ.defaultSchema);
    var adfStage = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'final';
    var useSpecBasedValidator = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
    var rendererId = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 'noid';
    var dispatchAnalyticsEvent = arguments.length > 6 ? arguments[6] : undefined;
    var unsupportedContentLevelsTracking = arguments.length > 7 ? arguments[7] : undefined;
    var appearance = arguments.length > 8 ? arguments[8] : undefined;
    var includeNodesCountInStats = arguments.length > 9 ? arguments[9] : undefined;
    var skipValidation = arguments.length > 10 ? arguments[10] : undefined;
    var validationOverrides = arguments.length > 11 ? arguments[11] : undefined;
    var stat = {
        sanitizeTime: 0
    };
    if ((0, $9Zzpd.fg)('platform_editor_renderer_rm_usespecbasedvalidator')) useSpecBasedValidator = true;
    var _withStopwatch = $2071b3d80d22d00f$var$withStopwatch(function() {
        return $2071b3d80d22d00f$var$memoValidation(doc, schema, adfStage, useSpecBasedValidator, dispatchAnalyticsEvent, skipValidation, validationOverrides);
    }), validDoc = _withStopwatch.output, sanitizeTime = _withStopwatch.time;
    // save sanitize time to stats
    stat.sanitizeTime = sanitizeTime;
    if (!validDoc) return {
        stat: stat,
        result: null
    };
    var _withStopwatch2 = $2071b3d80d22d00f$var$withStopwatch(function() {
        return $2071b3d80d22d00f$var$memoCreateNodeAndCheck(schema, validDoc, dispatchAnalyticsEvent);
    }), node = _withStopwatch2.output, buildTreeTime = _withStopwatch2.time;
    // save build tree time to stats
    stat.buildTreeTime = buildTreeTime;
    var _withStopwatch3 = $2071b3d80d22d00f$var$withStopwatch(function() {
        return $2071b3d80d22d00f$var$memoSerializeFragment(serializer, node);
    }), result = _withStopwatch3.output, serializeTime = _withStopwatch3.time;
    // save serialize tree time to stats
    stat.serializeTime = serializeTime;
    if (dispatchAnalyticsEvent && useSpecBasedValidator) {
        (0, $fpooh.findAndTrackUnsupportedContentNodes)(node, schema, dispatchAnalyticsEvent);
        if (unsupportedContentLevelsTracking !== null && unsupportedContentLevelsTracking !== void 0 && unsupportedContentLevelsTracking.enabled) {
            var documentData = {
                doc: validDoc,
                appearance: appearance,
                rendererId: rendererId
            };
            (0, $588355632ca7aaa5$export$a43de96edd8d0a0)(documentData, unsupportedContentLevelsTracking, dispatchAnalyticsEvent);
        }
    }
    if (includeNodesCountInStats) stat.nodesCount = (0, $85fdf1d409f20456$export$1daf15cbaf649dad)(doc);
    return {
        result: result,
        stat: stat,
        pmDoc: node
    };
};



var $gPdZj = parcelRequire("gPdZj");

var $aP6HU = parcelRequire("aP6HU");

var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");

var $lknPo = parcelRequire("lknPo");
var $3cF57 = parcelRequire("3cF57");

var $d0n7Z = parcelRequire("d0n7Z");
var $cffc3bdc16b16678$export$77218b6ff680865f = function EditorMediaClientProvider(_ref) {
    var children = _ref.children, ssr = _ref.ssr;
    var _useState = (0, $5FkrB.useState)(), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_useState, 2), mediaClientConfig = _useState2[0], setMediaClientConfig = _useState2[1];
    var mediaProvider = (0, $d0n7Z.useProviderLayout)('mediaProvider');
    /**
   * If a mediaClientConfig is provided then we will force
   * skip the mediaClient from context
   */ var shouldSkipContext = Boolean((ssr === null || ssr === void 0 ? void 0 : ssr.config) || mediaProvider);
    var contextMediaClient = (0, $5FkrB.useContext)((0, $3cF57.MediaClientContext));
    // MediaClientProvider currently requires a mediaClientConfig
    // And inserting the MediaClientProvider will cause a re-render
    // We should use MediaClientProvider once it no longer requires a config
    var mediaClient = (0, $5FkrB.useMemo)(function() {
        return mediaClientConfig ? (0, $lknPo.getMediaClient)(mediaClientConfig) : undefined;
    }, [
        mediaClientConfig
    ]);
    // Consumers can override the mediaClient for renderer,
    // by not providing both SSR config and mediaProvider,
    // and provide a top level mediaClient context
    // This is useful for testing and creating examples.
    (0, $5FkrB.useLayoutEffect)(function() {
        if (ssr !== null && ssr !== void 0 && ssr.config) setMediaClientConfig(ssr.config);
        else if (mediaProvider) mediaProvider.then(function(provider) {
            setMediaClientConfig(provider.viewMediaClientConfig);
        });
    }, [
        mediaProvider,
        ssr
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $3cF57.MediaClientContext).Provider, {
        value: shouldSkipContext ? mediaClient : contextMediaClient
    }, children);
};




var $ky5Ao = parcelRequire("ky5Ao");

var $9F9pG = parcelRequire("9F9pG");

var $lMzAH = parcelRequire("lMzAH");

var $4qXRD = parcelRequire("4qXRD");

var $lVo0h = parcelRequire("lVo0h");

var $nOuq8 = parcelRequire("nOuq8");

var $enqEB = parcelRequire("enqEB");

var $5FkrB = parcelRequire("5FkrB");

var $2XMn4 = parcelRequire("2XMn4");

var $9Zzpd = parcelRequire("9Zzpd");

var $13ECD = parcelRequire("13ECD");

var $drUcN = parcelRequire("drUcN");
function $e2e772a0c175af19$export$cfc1361be0de4203(_ref) {
    var noOpSSRInlineScript = _ref.noOpSSRInlineScript;
    /**
   * Should only inline this script while SSR,
   * not needed on the client side.
   */ // For hydrateRoot there is a mismatch on client for this script.
    // So we want to add the script on client side but guard it with check to
    // not execute logic
    if (typeof window !== 'undefined' && !window.navigator.userAgent.includes('jsdom')) {
        if (!noOpSSRInlineScript) return null;
        else window.__RENDERER_BYPASS_BREAKOUT_SSR__ = true;
    }
    var id = Math.floor(Math.random() * 9999990001) + 9999;
    var shouldSkipScript = {
        table: (0, $9Zzpd.fg)('platform-ssr-table-resize')
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("script", {
        "data-breakout-script-id": id,
        dangerouslySetInnerHTML: {
            __html: $e2e772a0c175af19$export$92859d13f30c883e(id, shouldSkipScript)
        },
        "data-testid": "breakout-ssr-inline-script"
    });
}
function $e2e772a0c175af19$export$92859d13f30c883e(id, shouldSkipScript) {
    var flags = {
        platform_editor_fix_media_in_renderer: (0, $9Zzpd.fg)('platform_editor_fix_media_in_renderer'),
        platform_editor_fix_wide_media_in_renderer: (0, $9Zzpd.fg)('platform_editor_fix_wide_media_in_renderer'),
        platform_editor_renderer_extension_width_fix: (0, $drUcN.expValEquals)('platform_editor_renderer_extension_width_fix', 'isEnabled', true)
    };
    return "(function(window){\nif(typeof window !== 'undefined' && window.__RENDERER_BYPASS_BREAKOUT_SSR__) { return; }\n".concat($e2e772a0c175af19$export$47813c4121c8b4b3, ";\n(").concat($e2e772a0c175af19$var$applyBreakoutAfterSSR.toString(), ")(\"").concat(id, "\", breakoutConsts, ").concat(JSON.stringify(shouldSkipScript), ", ").concat(JSON.stringify(flags), ");\n})(window);\n");
}
var $e2e772a0c175af19$export$47813c4121c8b4b3 = "\n  var breakoutConsts = ".concat(JSON.stringify((0, $2XMn4.breakoutConsts)), ";\n  breakoutConsts.mapBreakpointToLayoutMaxWidth = ").concat((0, $2XMn4.breakoutConsts).mapBreakpointToLayoutMaxWidth.toString(), ";\n  breakoutConsts.getBreakpoint = ").concat((0, $2XMn4.breakoutConsts).getBreakpoint.toString(), ";\n  breakoutConsts.calcBreakoutWidth = ").concat((0, $2XMn4.breakoutConsts).calcBreakoutWidth.toString(), ";\n  breakoutConsts.calcLineLength = ").concat((0, $2XMn4.breakoutConsts).calcLineLength.toString(), ";\n  breakoutConsts.calcWideWidth = ").concat((0, $2XMn4.breakoutConsts).calcWideWidth.toString(), ";\n  breakoutConsts.FullPagePadding = ").concat((0, $13ECD.FullPagePadding).toString(), ";\n");
/**
 * WARNING: NO EXTERNAL FUNCTION CALL IN THIS FUNCTION
 * This function will be put to DOM as an inline script.
 * It can not have any external function dependency.
 * All required data must be passed in as serializable parameters.
 */ // Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $e2e772a0c175af19$var$applyBreakoutAfterSSR(id, breakoutConsts, shouldSkipBreakoutScript, flags) {
    var MEDIA_NODE_TYPE = 'mediaSingle';
    var WIDE_LAYOUT_MODES = [
        'full-width',
        'wide',
        'custom'
    ];
    function findUp(element, condition) {
        if (!element) return;
        while(element.parentElement){
            if (condition(element)) return element.parentElement;
            element = element.parentElement;
        }
    }
    var renderer = findUp(document.querySelector("[data-breakout-script-id=\"".concat(id, "\"]")), function(elem) {
        var _elem$parentElement;
        return !!((_elem$parentElement = elem.parentElement) !== null && _elem$parentElement !== void 0 && _elem$parentElement.classList.contains('ak-renderer-wrapper'));
    });
    if (!renderer) return;
    var observer = new MutationObserver(function(mutationsList) {
        mutationsList.forEach(function(item) {
            if (item.target.nodeType !== Node.ELEMENT_NODE) return;
            // Remove with feature gate 'platform-ssr-table-resize'
            // Ignored via go/ees005
            // eslint-disable-next-line @atlaskit/editor/no-as-casting
            if (item.target.classList.contains('ak-renderer-document')) item.addedNodes.forEach(function(maybeNode) {
                // maybeNode may contain comments which doesn't have a dataset property
                if (maybeNode.nodeType !== Node.ELEMENT_NODE) return;
                var width;
                // Ignored via go/ees005
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                var node = maybeNode;
                var mode = node.dataset.mode || node.dataset.layout || '';
                var nodeType = node.dataset.nodeType;
                var widthType = node.dataset.widthType;
                var isMediaSingleWithPixelWidth = nodeType === 'mediaSingle' && widthType === 'pixel';
                var isExtension = nodeType === 'extension' || nodeType === 'bodiedExtension';
                if (!mode || !WIDE_LAYOUT_MODES.includes(mode) || // skip apply width styling to mediaSingle node with pixel width to avoid image size changing
                isMediaSingleWithPixelWidth && flags['platform_editor_fix_media_in_renderer'] || isExtension && flags['platform_editor_renderer_extension_width_fix']) return;
                // When flag is on we are using CSS to calculate the table width thus don't need logic below to set the width and left.
                if (shouldSkipBreakoutScript.table && node.classList.contains('pm-table-container')) return;
                if (node.classList.contains('fabric-editor-breakout-mark')) return;
                // use breakout script for all other types of nodes
                if (node.classList.contains('pm-table-container') && mode === 'custom') {
                    // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    var rendererWidth = renderer.offsetWidth;
                    var effectiveWidth = rendererWidth - breakoutConsts.padding;
                    width = "".concat(Math.min(parseInt(node.style.width), effectiveWidth), "px");
                } else // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                width = breakoutConsts.calcBreakoutWidth(breakoutConsts)(mode, renderer.offsetWidth);
                if (node.style.width === width) return;
                node.style.width = width;
                // Tables require some special logic, as they are not using common css transform approach,
                // because it breaks with sticky headers. This logic is copied from a table node:
                // https://bitbucket.org/atlassian/atlassian-frontend/src/77938aee0c140d02ff99b98a03849be1236865b4/packages/editor/renderer/src/react/nodes/table.tsx#table.tsx-235:245
                if (node.classList.contains('pm-table-container') && // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                !renderer.classList.contains('is-full-width')) {
                    var lineLength = breakoutConsts.calcLineLength(breakoutConsts)();
                    var left = lineLength / 2 - parseInt(width) / 2;
                    if (left < 0 && parseInt(width) > lineLength) node.style.left = left + 'px';
                    else node.style.left = '';
                }
            });
            else if (/**
       * The mutation observer is only called once per added node.
       * The above condition only deals with direct children of <div class="ak-renderer-document" />
       * When it is initially called on the direct children, not all the sub children have loaded.
       * So nested media elements which are not immediately loaded as sub children are not available in the above conditional.
       * Thus adding this conditional to deal with all media elements directly.
       */ // Ignored via go/ees005
            // eslint-disable-next-line @atlaskit/editor/no-as-casting
            item.target.dataset.nodeType === MEDIA_NODE_TYPE) // Ignored via go/ees005
            // eslint-disable-next-line @atlaskit/editor/no-as-casting
            applyMediaBreakout(item.target, flags);
        });
    });
    var applyMediaBreakout = function applyMediaBreakout(card, flags) {
        // width was already set by another breakout script
        if (card.style.width) return;
        var tableParent = findUp(card, function(elem) {
            return elem instanceof HTMLTableCellElement;
        });
        // only apply the breakout to media elements not nested inside table
        // table sizing is not based on percentage width
        if (tableParent) return;
        var mode = card.dataset.mode || card.dataset.layout || '';
        var width = card.dataset.width;
        var isPixelBasedResizing = card.dataset.widthType === 'pixel';
        // Pixel based resizing has width set in pixels based on its width attribute
        // Thus, no need to override width
        if (flags['platform_editor_fix_wide_media_in_renderer'] && isPixelBasedResizing) return;
        if (WIDE_LAYOUT_MODES.includes(mode)) card.style.width = '100%';
        else if (width && (!isPixelBasedResizing || flags['platform_editor_fix_wide_media_in_renderer'])) card.style.width = "".concat(width, "%");
    };
    observer.observe(renderer, {
        childList: true,
        subtree: true
    });
    /**
   * Using window load event to unsubscribe from mutation observer, as at this stage document is fully rendered.
   * Experiment with DOMContentLoaded showed that some of the blocks were not processed at all.
   * That's why window load is necessary.
   *
   * More info:
   * – https://html.spec.whatwg.org/multipage/parsing.html#the-end
   * – https://developer.mozilla.org/en-US/docs/Web/API/Window/load_event
   * – https://developer.mozilla.org/en-US/docs/Web/API/Document/DOMContentLoaded_event
   */ var _disconnect = function disconnect() {
        observer.disconnect();
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        window.removeEventListener('load', _disconnect);
    };
    // Ignored via go/ees005
    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
    window.addEventListener('load', _disconnect);
}
var $e2e772a0c175af19$export$2a0b3eeee3f2ea40 = (0, $2XMn4.breakoutConsts).calcLineLength((0, $2XMn4.breakoutConsts));



var $a4VNM = parcelRequire("a4VNM");

var $eTqtO = parcelRequire("eTqtO");
function $06b5438107d56029$export$3dee5e4542c672d9(element) {
    if ('href' in element && element.href != null) return true;
    if (element.classList.contains((0, $eTqtO.mediaViewerPopupClass))) return true;
    if (element.classList.contains((0, $a4VNM.fileCardImageViewSelector))) return true;
    return false;
}




var $13ECD = parcelRequire("13ECD");

var $9P61R = parcelRequire("9P61R");

var $arMYe = parcelRequire("arMYe");

var $kIXpt = parcelRequire("kIXpt");

var $cYPzS = parcelRequire("cYPzS");

var $eyuDe = parcelRequire("eyuDe");

var $74Zh5 = parcelRequire("74Zh5");

var $5FkrB = parcelRequire("5FkrB");
function $68ff72c25ae09c72$var$_callSuper(t, o, e) {
    return o = (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(o), (0, (/*@__PURE__*/$parcel$interopDefault($kIXpt)))(t, $68ff72c25ae09c72$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, (/*@__PURE__*/$parcel$interopDefault($cYPzS)))(t).constructor) : o.apply(t, e));
}
function $68ff72c25ae09c72$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($68ff72c25ae09c72$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $68ff72c25ae09c72$var$fadeOutStyles = function fadeOutStyles(maxHeight, top, backgroundColor) {
    return (0, $74Zh5.css)({
        position: 'relative',
        overflowY: 'hidden',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        maxHeight: "".concat(maxHeight, "px"),
        '&::after': {
            content: "''",
            position: 'absolute',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            top: "".concat(top, "px"),
            bottom: 0,
            left: 0,
            right: 0,
            backgroundImage: "linear-gradient( ".concat("var(--ds-background-neutral-subtle, rgba(255, 255, 255, 0))", ", ", backgroundColor, " )")
        }
    });
};
var $68ff72c25ae09c72$var$FadeOut = function FadeOut(props) {
    var children = props.children, backgroundColor = props.backgroundColor, fadeHeight = props.fadeHeight, height = props.height;
    var top = height - fadeHeight;
    var styles = $68ff72c25ae09c72$var$fadeOutStyles(height, top, backgroundColor);
    // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
    return (0, $74Zh5.jsx)("div", {
        css: styles
    }, children);
};
var $68ff72c25ae09c72$export$79ad592494094f07 = /*#__PURE__*/ function(_Component) {
    function TruncatedWrapper(props) {
        (0, (/*@__PURE__*/$parcel$interopDefault($9P61R)))(this, TruncatedWrapper);
        return $68ff72c25ae09c72$var$_callSuper(this, TruncatedWrapper, [
            props
        ]);
    }
    // TODO: DSP-4123 - Quality ticket as elevation.surface will be issue when sits top of modal.
    (0, (/*@__PURE__*/$parcel$interopDefault($eyuDe)))(TruncatedWrapper, _Component);
    return (0, (/*@__PURE__*/$parcel$interopDefault($arMYe)))(TruncatedWrapper, [
        {
            key: "render",
            value: function render() {
                var _this$props = this.props, _this$props$height = _this$props.height, height = _this$props$height === void 0 ? 95 : _this$props$height, _this$props$fadeHeigh = _this$props.fadeHeight, fadeHeight = _this$props$fadeHeigh === void 0 ? 24 : _this$props$fadeHeigh, _this$props$backgroun = _this$props.backgroundColor, backgroundColor = _this$props$backgroun === void 0 ? "var(--ds-surface, white)" : _this$props$backgroun, children = _this$props.children;
                return (0, $74Zh5.jsx)($68ff72c25ae09c72$var$FadeOut, {
                    height: height,
                    fadeHeight: fadeHeight,
                    backgroundColor: backgroundColor
                }, children);
            }
        }
    ]);
}((0, $5FkrB.Component));



var $caYHb = parcelRequire("caYHb");

var $25nEq = parcelRequire("25nEq");

var $74Zh5 = parcelRequire("74Zh5");

var $5FkrB = parcelRequire("5FkrB");

var $hBCYb = parcelRequire("hBCYb");
var $509fb8fcbca1dd31$export$18a71eb9fe4307bc = 'block-';
var $509fb8fcbca1dd31$export$d7e471f6502a69e2 = function isBlockLinkHash(hash) {
    var prefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $509fb8fcbca1dd31$export$18a71eb9fe4307bc;
    if (!hash || !prefix) return false;
    // Match either UUID format (8-4-4-4-12) or short hex ID format (exactly 12 hex chars without dashes).
    var uuidRegex = new RegExp("^#?".concat(prefix, "[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$"), 'iu');
    var shortIdRegex = new RegExp("^#?".concat(prefix, "[0-9a-f]{12}$"), 'iu');
    return uuidRegex.test(hash) || shortIdRegex.test(hash);
};
var $509fb8fcbca1dd31$export$c95c8d5e0fd74b32 = function extractBlockIdFromLinkHash(hash) {
    var prefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $509fb8fcbca1dd31$export$18a71eb9fe4307bc;
    if (!$509fb8fcbca1dd31$export$d7e471f6502a69e2(hash, prefix)) return null;
    // Remove leading # if present, then remove the prefix.
    var normalized = hash.startsWith('#') ? hash.slice(1) : hash;
    return normalized.slice(prefix.length);
};
var $509fb8fcbca1dd31$export$7d28ccc9eddf2197 = function createBlockLinkHashValue(blockId) {
    var prefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $509fb8fcbca1dd31$export$18a71eb9fe4307bc;
    return "".concat(prefix).concat(blockId);
};


// Find editor node dom with localId - similar to confluence useScrollOnUrlChange.ts
var $ab9660a843f61d8b$var$getLocalIdSelector = function getLocalIdSelector(localId, container) {
    // Check if the element with data-local-id exists
    var element = container.querySelector("[data-local-id=\"".concat(localId, "\"]"));
    if (element) return element;
    // Special case for decision lists and task lists which already have localId
    element = container.querySelector("[data-decision-list-local-id=\"".concat(localId, "\"]"));
    if (element) return element;
    element = container.querySelector("[data-task-list-local-id=\"".concat(localId, "\"]"));
    if (element) return element;
    // Special case for tables which use data-table-local-id
    element = container.querySelector("[data-table-local-id=\"".concat(localId, "\"]"));
    if (element) return element;
    // Special case for extension, smart cards and media which use lowercase localid
    element = container.querySelector("[localid=\"".concat(localId, "\"]"));
    if (element) return element;
    return null;
};
var $ab9660a843f61d8b$export$b61745354f522fe = function useScrollToLocalId(containerRef, shouldScrollToLocalId) {
    (0, $5FkrB.useEffect)(function() {
        var _getDocument;
        // Only run in browser environment
        if (typeof window === 'undefined' || !(containerRef !== null && containerRef !== void 0 && containerRef.current) || !shouldScrollToLocalId) return;
        // Parse hash fragment for block ID (format: #block-{localId})
        var hash = window.location.hash;
        var defaultPrefixWithHash = "#".concat((0, $509fb8fcbca1dd31$export$18a71eb9fe4307bc));
        var blockId = hash.startsWith(defaultPrefixWithHash) ? hash.slice(defaultPrefixWithHash.length) : null;
        if (!blockId) return;
        var retryCount = 0;
        // 5 second timeout based on dashboard showing ~4.96s TTI load time
        var maxRetries = 20; // Maximum 20 retries (5 seconds at 250ms intervals)
        var retryInterval = 250; // Check every 250ms
        var intervalId = null;
        var scrollToElement = function scrollToElement() {
            if (containerRef !== null && containerRef !== void 0 && containerRef.current) {
                var element = $ab9660a843f61d8b$var$getLocalIdSelector(blockId, containerRef.current);
                if (element) {
                    element.scrollIntoView({
                        behavior: 'smooth'
                    });
                    return true;
                }
            }
            return false;
        };
        var attemptScroll = function attemptScroll() {
            retryCount++;
            // Try to scroll to element
            if (scrollToElement()) {
                if (intervalId) {
                    clearInterval(intervalId);
                    intervalId = null;
                }
                return true;
            }
            // Stop retrying if we've exceeded max retries
            if (retryCount >= maxRetries) {
                if (intervalId) {
                    clearInterval(intervalId);
                    intervalId = null;
                }
                return false;
            }
            return false;
        };
        // Try to scroll immediately
        if (attemptScroll()) return;
        if (((_getDocument = (0, $hBCYb.getDocument)()) === null || _getDocument === void 0 ? void 0 : _getDocument.readyState) === 'complete') // Document is already ready, try a few more times with delays
        // This handles cases where elements are added after document ready
        intervalId = setInterval(function() {
            attemptScroll();
        }, retryInterval);
        else // Document not ready yet, wait for it and then retry
        intervalId = setInterval(function() {
            var _getDocument2;
            if (((_getDocument2 = (0, $hBCYb.getDocument)()) === null || _getDocument2 === void 0 ? void 0 : _getDocument2.readyState) === 'complete') attemptScroll();
            else if (retryCount >= maxRetries) // Stop retrying even if document isn't ready
            {
                if (intervalId) {
                    clearInterval(intervalId);
                    intervalId = null;
                }
            } else retryCount++;
        }, retryInterval);
        // Cleanup function
        return function() {
            if (intervalId) {
                clearInterval(intervalId);
                intervalId = null;
            }
        };
    }, [
        containerRef,
        shouldScrollToLocalId
    ]);
};



var $d4dXm = parcelRequire("d4dXm");

var $13ECD = parcelRequire("13ECD");

var $9Zzpd = parcelRequire("9Zzpd");

var $eqmEx = parcelRequire("eqmEx");

var $53SBn = parcelRequire("53SBn");

var $1LBcl = parcelRequire("1LBcl");

var $5qFVM = parcelRequire("5qFVM");

var $fq8Dd = parcelRequire("fq8Dd");

var $knSf2 = parcelRequire("knSf2");
var $hyfkz = parcelRequire("hyfkz");
var $14WDN = parcelRequire("14WDN");
var $25nEq = parcelRequire("25nEq");

var $74Zh5 = parcelRequire("74Zh5");

var $1LBcl = parcelRequire("1LBcl");
var $7269fd760c5a40ab$export$cfe6da7d522d87bb = 'rich-media-item';
var $7269fd760c5a40ab$var$wrappedMediaBreakoutPoint = 410;
var $7269fd760c5a40ab$export$d031611b96ba4cf0 = (0, $74Zh5.css)((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, "li .".concat($7269fd760c5a40ab$export$cfe6da7d522d87bb), {
    margin: 0
}), '&.ua-chrome li > .mediaSingleView-content-wrap::before', {
    content: "''",
    display: 'block',
    height: 0
}), '&.ua-firefox', {
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.mediaSingleView-content-wrap': {
        userSelect: 'none'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.captionView-content-wrap': {
        userSelect: 'text'
    }
}), ".mediaSingleView-content-wrap[layout='center']", {
    clear: 'both'
}), "table .".concat($7269fd760c5a40ab$export$cfe6da7d522d87bb), {
    marginTop: "var(--ds-space-150, 12px)",
    marginBottom: "var(--ds-space-150, 12px)",
    clear: 'both',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.image-wrap-left[data-layout], &.image-wrap-right[data-layout]': {
        clear: 'none',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '&:first-child': {
            marginTop: "var(--ds-space-150, 12px)"
        }
    }
}), ".".concat($7269fd760c5a40ab$export$cfe6da7d522d87bb, ".image-wrap-right + .").concat($7269fd760c5a40ab$export$cfe6da7d522d87bb, ".image-wrap-left"), {
    clear: 'both'
}), ".".concat($7269fd760c5a40ab$export$cfe6da7d522d87bb, ".image-wrap-left + .").concat($7269fd760c5a40ab$export$cfe6da7d522d87bb, ".image-wrap-right, .").concat($7269fd760c5a40ab$export$cfe6da7d522d87bb, ".image-wrap-right + .").concat($7269fd760c5a40ab$export$cfe6da7d522d87bb, ".image-wrap-left, .").concat($7269fd760c5a40ab$export$cfe6da7d522d87bb, ".image-wrap-left + .").concat($7269fd760c5a40ab$export$cfe6da7d522d87bb, ".image-wrap-left, .").concat($7269fd760c5a40ab$export$cfe6da7d522d87bb, ".image-wrap-right + .").concat($7269fd760c5a40ab$export$cfe6da7d522d87bb, ".image-wrap-right"), {
    marginRight: 0,
    marginLeft: 0
}), "@media all and (max-width: ".concat($7269fd760c5a40ab$var$wrappedMediaBreakoutPoint, "px)"), {
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    "div.mediaSingleView-content-wrap[layout='wrap-left'], div.mediaSingleView-content-wrap[data-layout='wrap-left'], div.mediaSingleView-content-wrap[layout='wrap-right'], div.mediaSingleView-content-wrap[data-layout='wrap-right']": {
        float: 'none',
        overflow: 'auto',
        margin: "var(--ds-space-150, 12px)".concat(" 0")
    }
}));
var $7269fd760c5a40ab$export$b51dea84d928a378 = (0, $74Zh5.css)((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, "li .".concat($7269fd760c5a40ab$export$cfe6da7d522d87bb), {
    margin: 0
}), '&.ua-chrome li > .mediaSingleView-content-wrap::before', {
    content: "''",
    display: 'block',
    height: 0
}), '&.ua-firefox', {
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.mediaSingleView-content-wrap': {
        userSelect: 'none'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.captionView-content-wrap': {
        userSelect: 'text'
    }
}), ".mediaSingleView-content-wrap[layout^='wrap-']", {
    position: 'relative',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
    zIndex: (0, $1LBcl.akEditorWrappedNodeZIndex)
}), ".mediaSingleView-content-wrap[layout='center']", {
    clear: 'both'
}), "table .".concat($7269fd760c5a40ab$export$cfe6da7d522d87bb), {
    marginTop: "var(--ds-space-150, 12px)",
    marginBottom: "var(--ds-space-150, 12px)",
    clear: 'both',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.image-wrap-left[data-layout], &.image-wrap-right[data-layout]': {
        clear: 'none',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '&:first-child': {
            marginTop: "var(--ds-space-150, 12px)"
        }
    }
}), ".".concat($7269fd760c5a40ab$export$cfe6da7d522d87bb, ".image-wrap-right + .").concat($7269fd760c5a40ab$export$cfe6da7d522d87bb, ".image-wrap-left"), {
    clear: 'both'
}), ".".concat($7269fd760c5a40ab$export$cfe6da7d522d87bb, ".image-wrap-left + .").concat($7269fd760c5a40ab$export$cfe6da7d522d87bb, ".image-wrap-right, .").concat($7269fd760c5a40ab$export$cfe6da7d522d87bb, ".image-wrap-right + .").concat($7269fd760c5a40ab$export$cfe6da7d522d87bb, ".image-wrap-left, .").concat($7269fd760c5a40ab$export$cfe6da7d522d87bb, ".image-wrap-left + .").concat($7269fd760c5a40ab$export$cfe6da7d522d87bb, ".image-wrap-left, .").concat($7269fd760c5a40ab$export$cfe6da7d522d87bb, ".image-wrap-right + .").concat($7269fd760c5a40ab$export$cfe6da7d522d87bb, ".image-wrap-right"), {
    marginRight: 0,
    marginLeft: 0
}), "@media all and (max-width: ".concat($7269fd760c5a40ab$var$wrappedMediaBreakoutPoint, "px)"), {
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    "div.mediaSingleView-content-wrap[layout='wrap-left'], div.mediaSingleView-content-wrap[data-layout='wrap-left'], div.mediaSingleView-content-wrap[layout='wrap-right'], div.mediaSingleView-content-wrap[data-layout='wrap-right']": {
        float: 'none',
        overflow: 'auto',
        margin: "var(--ds-space-150, 12px)".concat(" 0")
    }
}));

var $23e6e5ff8dd7ee19$export$4ccd31bf665a88f6 = {
    INLINE_CARD_CONTAINER: 'inlineCardView-content-wrap',
    BLOCK_CARD_CONTAINER: 'blockCardView-content-wrap',
    EMBED_CARD_CONTAINER: 'embedCardView-content-wrap',
    DATASOURCE_CONTAINER: 'datasourceView-content-wrap',
    LOADER_WRAPPER: 'loader-wrapper'
};


var $fMtrl = parcelRequire("fMtrl");var $ff7834a81ceb151c$export$a7172b75d403a0e4 = {
    DECISION_CONTAINER: 'decisionItemView-content-wrap',
    TASK_CONTAINER: 'taskItemView-content-wrap',
    //NOTE: value is a selector (data attribute), not a class name
    TASK_LIST_CONTAINER: '[data-node-type="actionList]',
    TASK_ITEM: 'task-item',
    TASK_CHECKBOX_CONTAINER: 'task-item-checkbox-wrap'
};



var $gBea6 = parcelRequire("gBea6");
var $5MY3X = parcelRequire("5MY3X");

var $c6bEO = parcelRequire("c6bEO");
var $3ytat = parcelRequire("3ytat");

var $4vXmi = parcelRequire("4vXmi");

var $fAhSf = parcelRequire("fAhSf");

var $8tCqL = parcelRequire("8tCqL");

var $4VBpm = parcelRequire("4VBpm");

var $7J4nJ = parcelRequire("7J4nJ");

var $9Zzpd = parcelRequire("9Zzpd");
var $789a6b614b844e25$export$4a3637dc6e2ae29e = {
    'editor.font.heading.h1': 'normal 500 1.71429em/1.16667 ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
    'editor.font.heading.h2': 'normal 500 1.42857em/1.2 ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
    'editor.font.heading.h3': 'normal 600 1.14286em/1.25 ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
    'editor.font.heading.h4': 'normal 600 1em/1.14286 ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
    'editor.font.heading.h5': 'normal 600 0.857143em/1.33333 ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
    'editor.font.heading.h6': 'normal 700 0.785714em/1.45455 ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
    'editor.font.body': 'normal 400 1em/1.714 ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
    'editor.font.weight.heading.h1.bold': '700',
    'editor.font.weight.heading.h2.bold': '700',
    'editor.font.weight.heading.h3.bold': '700',
    'editor.font.weight.heading.h4.bold': '700',
    'editor.font.weight.heading.h5.bold': '700',
    'editor.font.weight.heading.h6.bold': '700'
};
var $789a6b614b844e25$export$95588e746468319e = {
    'editor.font.heading.h1': 'normal 600 1.71429em/1.16667 ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
    'editor.font.heading.h2': 'normal 600 1.42857em/1.2 ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
    'editor.font.heading.h3': 'normal 600 1.14286em/1.25 ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
    'editor.font.heading.h4': 'normal 600  1em/1.14286 ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
    'editor.font.heading.h5': 'normal 600  0.857143em/1.33333 ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
    'editor.font.heading.h6': 'normal 600 0.785714em/1.45455 ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
    'editor.font.body': 'normal 400 1em/1.714 ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
    'editor.font.weight.heading.h1.bold': '700',
    'editor.font.weight.heading.h2.bold': '700',
    'editor.font.weight.heading.h3.bold': '700',
    'editor.font.weight.heading.h4.bold': '700',
    'editor.font.weight.heading.h5.bold': '700',
    'editor.font.weight.heading.h6.bold': '700'
};
var $789a6b614b844e25$export$63adc0ebe3278d31 = {
    'editor.font.heading.h1': 'normal 600 1.71429em/1.16667 "Atlassian Sans", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
    'editor.font.heading.h2': 'normal 600 1.42857em/1.2 "Atlassian Sans", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
    'editor.font.heading.h3': 'normal 600 1.14286em/1.25 "Atlassian Sans", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
    'editor.font.heading.h4': 'normal 600 1em/1.14286 "Atlassian Sans", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
    'editor.font.heading.h5': 'normal 600 0.857143em/1.33333 "Atlassian Sans", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
    'editor.font.heading.h6': 'normal 600 0.785714em/1.45455 "Atlassian Sans", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
    'editor.font.body': 'normal 400 1em/1.714 "Atlassian Sans", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
    'editor.font.body.small': 'normal 400 0.875em/1.714 "Atlassian Sans", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
    'editor.font.weight.heading.h1.bold': '700',
    'editor.font.weight.heading.h2.bold': '700',
    'editor.font.weight.heading.h3.bold': '700',
    'editor.font.weight.heading.h4.bold': '700',
    'editor.font.weight.heading.h5.bold': '700',
    'editor.font.weight.heading.h6.bold': '700'
};


function $381325189b6a639e$var$editorUGCToken(path) {
    var tokens;
    if ((0, $9Zzpd.fg)('platform_editor_typography_ugc')) tokens = (0, $789a6b614b844e25$export$63adc0ebe3278d31);
    else tokens = (0, $789a6b614b844e25$export$4a3637dc6e2ae29e);
    return tokens[path];
}
var $381325189b6a639e$export$2e2bcd8739ae039 = $381325189b6a639e$var$editorUGCToken;



var $1LBcl = parcelRequire("1LBcl");

var $drUcN = parcelRequire("drUcN");
var $cc8a699f38d2ae23$export$8e2864079bc476bd = function getBaseFontSize(appearance, contentMode) {
    if ((0, $drUcN.expValEquals)('cc_editor_ai_content_mode', 'variant', 'test')) {
        if (contentMode === ((0, $drUcN.expValEquals)('confluence_content_mode_replace_dense_with_compact', 'cohort', 'test') ? 'compact' : 'dense')) return 0, $1LBcl.akEditorFullPageDenseFontSize;
    }
    return appearance && appearance !== 'comment' ? (0, $1LBcl.akEditorFullPageDefaultFontSize) : 14;
};



var $9DPK6 = parcelRequire("9DPK6");
var $8Upo7 = parcelRequire("8Upo7");
var $ab7eec81c4bc28d0$export$ee47248f9a998789 = {
    EMOJI_CONTAINER: 'emojiView-content-wrap',
    // eslint-disable-next-line @atlaskit/editor/no-re-export
    EMOJI_NODE: (0, $8Upo7.emojiNodeStyles),
    // eslint-disable-next-line @atlaskit/editor/no-re-export
    EMOJI_SPRITE: (0, $8Upo7.emojiSprite),
    // eslint-disable-next-line @atlaskit/editor/no-re-export
    EMOJI_IMAGE: (0, $8Upo7.emojiImage),
    // eslint-disable-next-line @atlaskit/editor/no-re-export
    EMOJI_PLACEHOLDER: (0, $8Upo7.placeholder)
};



var $drUcN = parcelRequire("drUcN");
var $df014fe6e70c2dc0$var$_css, $df014fe6e70c2dc0$var$_css8;
var $df014fe6e70c2dc0$var$wrappedMediaBreakoutPoint = 410;
var $df014fe6e70c2dc0$var$TELEPOINTER_ID = 'ai-streaming-telepointer';
var $df014fe6e70c2dc0$var$tableShadowWidth = 32;
var $df014fe6e70c2dc0$var$LAYOUT_BREAKPOINT_RENDERER = 629;
// originally defined from packages/editor/editor-plugin-table/src/ui/common-styles.ts
// Temporarily ignoring the below the owning team can add the ticket number for the TODO.  Context: https://atlassian.slack.com/archives/CPUEVD9MY/p1741565387326829
// eslint-disable-next-line @atlaskit/editor/enforce-todo-comment-format
// TODO: tableRowHeight can be moved into `@atlaskit/editor-common/table`
var $df014fe6e70c2dc0$var$tableRowHeight = 44;
var $df014fe6e70c2dc0$var$isBackgroundClipBrowserFixNeeded = function isBackgroundClipBrowserFixNeeded() {
    var browser = (0, $drUcN.expValEquals)('platform_editor_hydratable_ui', 'isEnabled', true) ? (0, $4vXmi.getBrowserInfo)() : (0, $4vXmi.browser);
    return browser.isGecko || browser.isIE || browser.isMac && browser.isChrome;
};
// styles are copied from ./style.tsx
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles, @atlaskit/design-system/no-css-tagged-template-expression, @atlaskit/design-system/consistent-css-prop-usage
var $df014fe6e70c2dc0$var$baseStyles = (0, $74Zh5.css)(($df014fe6e70c2dc0$var$_css = {
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    fontSize: 'var(--ak-renderer-base-font-size)',
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: '1.5rem',
    color: "var(--ds-text, ".concat((0, $d4dXm.N800), ")"),
    '--ak-editor--full-width-layout-width': "".concat((0, $1LBcl.akEditorFullWidthLayoutWidth), "px")
}, (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($df014fe6e70c2dc0$var$_css, ".".concat((0, $53SBn.RendererCssClassName).DOCUMENT, "::after"), {
    // we add a clearfix after ak-renderer-document in order to
    // contain internal floats (such as media images that are "wrap-left")
    // to just the renderer (and not spill outside of it)
    content: '""',
    visibility: 'hidden',
    display: 'block',
    height: 0,
    clear: 'both'
}), ".".concat((0, $53SBn.RendererCssClassName).DOCUMENT), (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, ".".concat((0, $5qFVM.INLINE_IMAGE_WRAPPER_CLASS_NAME)), {
    height: '22px',
    transform: "translateY(-2px)"
}), "h1", (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, "> .mediaInlineView-content-wrap > .".concat((0, $5qFVM.INLINE_IMAGE_WRAPPER_CLASS_NAME), ",\n  > :is(a, span[data-mark-type='border']) .mediaInlineView-content-wrap > .").concat((0, $5qFVM.INLINE_IMAGE_WRAPPER_CLASS_NAME), ",\n  > .").concat((0, $5qFVM.INLINE_IMAGE_WRAPPER_CLASS_NAME), ",\n  > :is(a, span[data-mark-type='border']) .").concat((0, $5qFVM.INLINE_IMAGE_WRAPPER_CLASS_NAME)), {
    height: '36px',
    transform: "translateY(-3px)"
})), "h2", (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, "> .mediaInlineView-content-wrap > .".concat((0, $5qFVM.INLINE_IMAGE_WRAPPER_CLASS_NAME), ",\n  > :is(a, span[data-mark-type='border']) .mediaInlineView-content-wrap > .").concat((0, $5qFVM.INLINE_IMAGE_WRAPPER_CLASS_NAME), ",\n  > .").concat((0, $5qFVM.INLINE_IMAGE_WRAPPER_CLASS_NAME), ",\n  > :is(a, span[data-mark-type='border']) .").concat((0, $5qFVM.INLINE_IMAGE_WRAPPER_CLASS_NAME)), {
    height: '31px',
    transform: "translateY(-3px)"
})), "h3", (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, "> .mediaInlineView-content-wrap > .".concat((0, $5qFVM.INLINE_IMAGE_WRAPPER_CLASS_NAME), ",\n  > :is(a, span[data-mark-type='border']) .mediaInlineView-content-wrap > .").concat((0, $5qFVM.INLINE_IMAGE_WRAPPER_CLASS_NAME), ",\n  > .").concat((0, $5qFVM.INLINE_IMAGE_WRAPPER_CLASS_NAME), ",\n  > :is(a, span[data-mark-type='border']) .").concat((0, $5qFVM.INLINE_IMAGE_WRAPPER_CLASS_NAME)), {
    height: '25px',
    transform: "translateY(-2px)"
})), "h4", (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, "> .mediaInlineView-content-wrap > .".concat((0, $5qFVM.INLINE_IMAGE_WRAPPER_CLASS_NAME), ",\n  > :is(a, span[data-mark-type='border']) .mediaInlineView-content-wrap > .").concat((0, $5qFVM.INLINE_IMAGE_WRAPPER_CLASS_NAME), ",\n  > .").concat((0, $5qFVM.INLINE_IMAGE_WRAPPER_CLASS_NAME), ",\n  > :is(a, span[data-mark-type='border']) .").concat((0, $5qFVM.INLINE_IMAGE_WRAPPER_CLASS_NAME)), {
    height: '23px',
    transform: "translateY(-2px)"
})), "h5", (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, "> .mediaInlineView-content-wrap > .".concat((0, $5qFVM.INLINE_IMAGE_WRAPPER_CLASS_NAME), ",\n  > :is(a, span[data-mark-type='border']) .mediaInlineView-content-wrap > .").concat((0, $5qFVM.INLINE_IMAGE_WRAPPER_CLASS_NAME), ",\n  > .").concat((0, $5qFVM.INLINE_IMAGE_WRAPPER_CLASS_NAME), ",\n  > :is(a, span[data-mark-type='border']) .").concat((0, $5qFVM.INLINE_IMAGE_WRAPPER_CLASS_NAME)), {
    height: '20px',
    transform: "translateY(-2px)"
})), "h6", (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, "> .mediaInlineView-content-wrap > .".concat((0, $5qFVM.INLINE_IMAGE_WRAPPER_CLASS_NAME), ",\n  > :is(a, span[data-mark-type='border']) .mediaInlineView-content-wrap > .").concat((0, $5qFVM.INLINE_IMAGE_WRAPPER_CLASS_NAME), ",\n  > .").concat((0, $5qFVM.INLINE_IMAGE_WRAPPER_CLASS_NAME), ",\n  > :is(a, span[data-mark-type='border']) .").concat((0, $5qFVM.INLINE_IMAGE_WRAPPER_CLASS_NAME)), {
    height: '18px',
    transform: "translateY(-2px)"
}))), '& h1, & h2, & h3, & h4, & h5, & h6', (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, ".".concat((0, $fq8Dd.HeadingAnchorWrapperClassName)), {
    position: 'absolute',
    marginLeft: "var(--ds-space-075, 6px)",
    button: {
        paddingLeft: 0,
        paddingRight: 0
    },
    /**
   * Adds the visibility of the button when in focus through keyboard navigation.
   */ 'button:focus': {
        opacity: 1,
        transform: 'none !important'
    }
}), "@media (hover: hover) and (pointer: fine)", (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, ".".concat((0, $fq8Dd.HeadingAnchorWrapperClassName)), {
    '> button': {
        opacity: 0,
        transform: "translate(-8px, 0px)",
        transition: "opacity 0.2s ease 0s, transform 0.2s ease 0s"
    }
}), '&:hover', (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, ".".concat((0, $fq8Dd.HeadingAnchorWrapperClassName), " > button"), {
    opacity: 1,
    transform: 'none !important'
})))), '& h1', (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, ".".concat((0, $fq8Dd.HeadingAnchorWrapperClassName)), {
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: "".concat(28 / 24, "em")
})), '& h2', (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, ".".concat((0, $fq8Dd.HeadingAnchorWrapperClassName)), {
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: "".concat(1.2, "em")
})), '& h3', (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, ".".concat((0, $fq8Dd.HeadingAnchorWrapperClassName)), {
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: "".concat(1.25, "em")
})), '& h4', (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, ".".concat((0, $fq8Dd.HeadingAnchorWrapperClassName)), {
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: "".concat(16 / 14, "em")
})), '& h5', (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, ".".concat((0, $fq8Dd.HeadingAnchorWrapperClassName)), {
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: "".concat(16 / 12, "em")
})), '& h6', (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, ".".concat((0, $fq8Dd.HeadingAnchorWrapperClassName)), {
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: "".concat(16 / 11, "em")
})), "& span.akActionMark", {
    color: "var(--ds-link, ".concat((0, $d4dXm.B400), ")"),
    textDecoration: 'none',
    cursor: 'pointer',
    '&:hover': {
        color: "var(--ds-link, ".concat((0, $d4dXm.B300), ")"),
        textDecoration: 'underline'
    },
    '&:active': {
        color: "var(--ds-link-pressed, ".concat((0, $d4dXm.B500), ")")
    }
}), (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($df014fe6e70c2dc0$var$_css, '& span[data-placeholder]', {
    color: "var(--ds-text-subtlest, ".concat((0, $d4dXm.N200), ")")
})));
var $df014fe6e70c2dc0$var$akEditorBreakpointForSmallDevice = '1266px';
var $df014fe6e70c2dc0$var$responsiveBreakoutWidth = (0, $74Zh5.css)((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({
    '--ak-editor--breakout-container-without-gutter-width': "calc(100cqw - ".concat((0, $1LBcl.akEditorGutterPadding), "px * 2)"),
    // Corresponds to the legacyContentStyles from `@atlaskit/editor-core` meant to introduce responsive breakout width.
    '--ak-editor--breakout-wide-layout-width': "".concat((0, $1LBcl.akEditorCalculatedWideLayoutWidthSmallViewport), "px")
}, "@media (min-width: ".concat($df014fe6e70c2dc0$var$akEditorBreakpointForSmallDevice, ")"), {
    '--ak-editor--breakout-wide-layout-width': "".concat((0, $1LBcl.akEditorCalculatedWideLayoutWidth), "px")
}));
var $df014fe6e70c2dc0$var$responsiveBreakoutWidthFullWidth = (0, $74Zh5.css)((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({
    '--ak-editor--breakout-container-without-gutter-width': '100cqw',
    // Corresponds to the legacyContentStyles from `@atlaskit/editor-core` meant to introduce responsive breakout width.
    '--ak-editor--breakout-wide-layout-width': "".concat((0, $1LBcl.akEditorCalculatedWideLayoutWidthSmallViewport), "px")
}, "@media (min-width: ".concat($df014fe6e70c2dc0$var$akEditorBreakpointForSmallDevice, ")"), {
    '--ak-editor--breakout-wide-layout-width': "".concat((0, $1LBcl.akEditorCalculatedWideLayoutWidth), "px")
}));
var $df014fe6e70c2dc0$var$responsiveBreakoutWidthWithReducedPadding = (0, $74Zh5.css)((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({
    '--ak-editor--breakout-container-without-gutter-width': "calc(100cqw - var(--ak-renderer--full-page-gutter) * 2)",
    // Corresponds to the legacyContentStyles from `@atlaskit/editor-core` meant to introduce responsive breakout width.
    '--ak-editor--breakout-wide-layout-width': "".concat((0, $1LBcl.akEditorCalculatedWideLayoutWidthSmallViewport), "px")
}, "@media (min-width: ".concat($df014fe6e70c2dc0$var$akEditorBreakpointForSmallDevice, ")"), {
    '--ak-editor--breakout-wide-layout-width': "".concat((0, $1LBcl.akEditorCalculatedWideLayoutWidth), "px")
}), "@media (max-width: ".concat((0, $1LBcl.akEditorFullPageNarrowBreakout), "px)"), {
    '--ak-editor--breakout-container-without-gutter-width': "calc(100cqw - var(--ak-renderer--full-page-gutter) * 2)"
}));
var $df014fe6e70c2dc0$var$hideHeadingCopyLinkWrapperStyles = (0, $74Zh5.css)({
    '& h1, & h2, & h3, & h4, & h5, & h6': (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, ".".concat((0, $fq8Dd.HeadingAnchorWrapperClassName)), {
        '&:focus-within': {
            opacity: 1
        }
    }), "@media (hover: hover) and (pointer: fine)", (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, ".".concat((0, $fq8Dd.HeadingAnchorWrapperClassName)), {
        opacity: 0,
        transition: "opacity 0.2s ease 0s"
    }), '&:hover', (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, ".".concat((0, $fq8Dd.HeadingAnchorWrapperClassName)), {
        opacity: 1
    })))
});
var $df014fe6e70c2dc0$var$rendererFullPageStyles = (0, $74Zh5.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    maxWidth: "".concat((0, $1LBcl.akEditorDefaultLayoutWidth), "px"),
    margin: '0 auto',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    padding: "0 ".concat((0, $13ECD.FullPagePadding), "px")
});
var $df014fe6e70c2dc0$var$rendererFullPageStylesWithReducedPadding = (0, $74Zh5.css)((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({
    '--ak-renderer--full-page-gutter': "".concat((0, $13ECD.FullPagePadding), "px"),
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    maxWidth: "".concat((0, $1LBcl.akEditorDefaultLayoutWidth), "px"),
    margin: '0 auto',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    padding: "0 var(--ak-renderer--full-page-gutter)"
}, "@media (max-width: ".concat((0, $1LBcl.akEditorFullPageNarrowBreakout), "px)"), {
    '--ak-renderer--full-page-gutter': "".concat((0, $1LBcl.akEditorGutterPaddingReduced), "px")
}));
var $df014fe6e70c2dc0$var$rendererFullWidthStyles = (0, $74Zh5.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    maxWidth: "".concat((0, $1LBcl.akEditorFullWidthLayoutWidth), "px"),
    margin: "0 auto",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
    '.fabric-editor-breakout-mark:not([data-has-width="true"]), .ak-renderer-extension': {
        width: '100% !important'
    }
});
var $df014fe6e70c2dc0$var$rendererMaxWidthStyles = (0, $74Zh5.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    maxWidth: "".concat((0, $1LBcl.akEditorMaxWidthLayoutWidth), "px"),
    margin: "0 auto",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
    '.fabric-editor-breakout-mark:not([data-has-width="true"]), .ak-renderer-extension': {
        width: '100% !important'
    }
});
var $df014fe6e70c2dc0$var$rendererFullWidthStylesForTableResizing = (0, $74Zh5.css)({
    '.pm-table-container': {
        width: '100% !important'
    }
});
// eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression
var $df014fe6e70c2dc0$var$telepointerStyles = (0, $74Zh5.css)((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, "#".concat($df014fe6e70c2dc0$var$TELEPOINTER_ID), {
    display: 'inline-block',
    position: 'relative',
    width: '1.5px',
    height: '25px',
    backgroundColor: "var(--ds-background-brand-bold, #1868DB)",
    marginLeft: "var(--ds-space-025, 2px)",
    '&::after': {
        content: '"AI"',
        position: 'absolute',
        display: 'block',
        top: 0,
        left: 0,
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        fontSize: '10px',
        fontWeight: "var(--ds-font-weight-bold, 700)",
        width: '12.5px',
        height: '13px',
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
        paddingTop: '1px',
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
        paddingLeft: '1.5px',
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        lineHeight: 'initial',
        borderRadius: "0px ".concat("var(--ds-radius-xsmall, 2px)", " ", "var(--ds-radius-xsmall, 2px)", " 0px"),
        color: "var(--ds-text-inverse, white)",
        backgroundColor: "var(--ds-background-brand-bold, #1868DB)"
    }
}));
var $df014fe6e70c2dc0$var$rovoTelepointerStyles = (0, $74Zh5.css)((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, "#".concat($df014fe6e70c2dc0$var$TELEPOINTER_ID), {
    display: 'inline-block',
    position: 'relative',
    width: '1.5px',
    height: '24px',
    backgroundColor: "var(--ds-background-brand-bold, #1868DB)",
    marginLeft: "var(--ds-space-025, 2px)",
    '&::after': {
        content: '""',
        position: 'absolute',
        display: 'block',
        top: 0,
        left: 0,
        width: '31.5px',
        height: '15.5px',
        borderRadius: "0px ".concat("var(--ds-space-050, 4px)", " ", "var(--ds-space-050, 4px)", " 0px"),
        background: // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography, @atlaskit/design-system/ensure-design-token-usage
        'linear-gradient(to right, #1868db 0px, #1868db 1.5px, transparent 1.5px) 0 0 / 100% 100% no-repeat, conic-gradient(from 270deg at 50% 50%, #1868db 0deg, #1868db 115deg, #fca700 115deg, #fca700 180deg, #bf63f3 180deg, #bf63f3 310deg, #82b536 310deg, #82b536 359.96deg, #1868db 360deg)'
    },
    '&::before': {
        content: '"Rovo"',
        position: 'absolute',
        fontFamily: "var(--ds-font-family-body, ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
        fontWeight: "var(--ds-font-weight-semibold, 600)",
        color: "var(--ds-text-inverse, white)",
        background: "var(--ds-text, #292A2E)",
        top: 1,
        left: 1,
        borderRadius: "0px ".concat("var(--ds-space-050, 4px)", " ", "var(--ds-space-050, 4px)", " 0px"),
        zIndex: 1,
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        fontSize: '10px',
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
        padding: '0.5px 2.5px',
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        lineHeight: 'initial'
    }
}));
var $df014fe6e70c2dc0$var$whitespaceSharedStyles = (0, $74Zh5.css)({
    wordWrap: 'break-word',
    whiteSpace: 'pre-wrap'
});
var $df014fe6e70c2dc0$var$blockquoteSharedStyles = (0, $74Zh5.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& blockquote': {
        boxSizing: 'border-box',
        color: 'inherit',
        width: '100%',
        display: 'inline-block',
        paddingLeft: "var(--ds-space-200, 16px)",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        borderLeft: "var(--ds-border-width-selected, 2px)".concat(" solid ", "var(--ds-border, ".concat((0, $1LBcl.akEditorBlockquoteBorderColor), ")")),
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        margin: "".concat((0, $1LBcl.blockNodesVerticalMargin), " 0 0 0"),
        marginRight: 0,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        "[dir='rtl'] &": {
            paddingLeft: 0,
            paddingRight: "var(--ds-space-200, 16px)"
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '&:first-child': {
            marginTop: 0
        },
        '&::before': {
            content: "''"
        },
        '&::after': {
            content: 'none'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '& p': {
            display: 'block'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '& table, & table:last-child': {
            display: 'inline-table'
        },
        // Workaround for overriding the inline-block display on last child of a blockquote set in CSS reset.
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
        '> .code-block:last-child, >.mediaSingleView-content-wrap:last-child, >.mediaGroupView-content-wrap:last-child': {
            display: 'block'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '> .extensionView-content-wrap:last-child': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            display: 'block'
        }
    }
});
var $df014fe6e70c2dc0$var$headingsSharedStyles = (0, $74Zh5.css)({
    '& h1': {
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        fontSize: "".concat(24 / 14, "em"),
        fontStyle: 'inherit',
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        lineHeight: 28 / 24,
        color: "var(--ds-text, #292A2E)",
        fontWeight: "var(--ds-font-weight-medium, 500)",
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        letterSpacing: "-0.01em",
        marginBottom: 0,
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
        marginTop: '1.667em'
    },
    '& h2': {
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        fontSize: "".concat(20 / 14, "em"),
        fontStyle: 'inherit',
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        lineHeight: 1.2,
        color: "var(--ds-text, #292A2E)",
        fontWeight: "var(--ds-font-weight-medium, 500)",
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        letterSpacing: "-0.008em",
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
        marginTop: '1.8em',
        marginBottom: 0
    },
    '& h3': {
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        fontSize: "".concat(16 / 14, "em"),
        fontStyle: 'inherit',
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        lineHeight: 1.25,
        color: "var(--ds-text, #292A2E)",
        fontWeight: "var(--ds-font-weight-semibold, 600)",
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        letterSpacing: "-0.006em",
        marginTop: "var(--ds-space-400, 2em)",
        marginBottom: 0
    },
    '& h4': {
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        fontSize: "".concat(1, "em"),
        fontStyle: 'inherit',
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        lineHeight: 16 / 14,
        color: "var(--ds-text, #292A2E)",
        fontWeight: "var(--ds-font-weight-semibold, 600)",
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        letterSpacing: "-0.003em",
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
        marginTop: '1.357em'
    },
    '& h5': {
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        fontSize: "".concat(12 / 14, "em"),
        fontStyle: 'inherit',
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        lineHeight: 16 / 12,
        color: "var(--ds-text, #292A2E)",
        fontWeight: "var(--ds-font-weight-semibold, 600)",
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
        marginTop: '1.667em',
        textTransform: 'none'
    },
    '& h6': {
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        fontSize: "".concat(11 / 14, "em"),
        fontStyle: 'inherit',
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        lineHeight: 16 / 11,
        color: "var(--ds-text-subtlest, #6B6E76)",
        fontWeight: "var(--ds-font-weight-bold, 700)",
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
        marginTop: '1.455em',
        textTransform: 'none'
    }
});
var $df014fe6e70c2dc0$var$headingsSharedStylesWithEditorUGC = (0, $74Zh5.css)({
    '& h1': {
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        font: "var(--ak-renderer-editor-font-heading-h1)",
        marginBottom: 0,
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
        marginTop: '1.45833em',
        '& strong': {
            // set all heading bold style to token font.weight.bold, as not matter what typography is used, the editorUGCToken will return the font weight 700
            fontWeight: "var(--ds-font-weight-bold, 700)"
        },
        '&::before': {}
    },
    '& h2': {
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        font: "var(--ak-renderer-editor-font-heading-h2)",
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
        marginTop: '1.4em',
        marginBottom: 0,
        '& strong': {
            // set all heading bold style to token font.weight.bold, as not matter what typography is used, the editorUGCToken will return the font weight 700
            fontWeight: "var(--ds-font-weight-bold, 700)"
        }
    },
    '& h3': {
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        font: "var(--ak-renderer-editor-font-heading-h3)",
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
        marginTop: '1.31249em',
        marginBottom: 0,
        '& strong': {
            // set all heading bold style to token font.weight.bold, as not matter what typography is used, the editorUGCToken will return the font weight 700
            fontWeight: "var(--ds-font-weight-bold, 700)"
        }
    },
    '& h4': {
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        font: "var(--ak-renderer-editor-font-heading-h4)",
        marginTop: "var(--ds-space-250, 1.25em)",
        '& strong': {
            // set all heading bold style to token font.weight.bold, as not matter what typography is used, the editorUGCToken will return the font weight 700
            fontWeight: "var(--ds-font-weight-bold, 700)"
        }
    },
    '& h5': {
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        font: "var(--ak-renderer-editor-font-heading-h5)",
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
        marginTop: '1.45833em',
        textTransform: 'none',
        '& strong': {
            // set all heading bold style to token font.weight.bold, as not matter what typography is used, the editorUGCToken will return the font weight 700
            fontWeight: "var(--ds-font-weight-bold, 700)"
        }
    },
    '& h6': {
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        font: "var(--ak-renderer-editor-font-heading-h6)",
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
        marginTop: '1.59091em',
        textTransform: 'none',
        '& strong': {
            // set all heading bold style to token font.weight.bold, as not matter what typography is used, the editorUGCToken will return the font weight 700
            fontWeight: "var(--ds-font-weight-bold, 700)"
        }
    }
});
var $df014fe6e70c2dc0$var$headingWithAlignmentStyles = (0, $74Zh5.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
    '.fabric-editor-block-mark.fabric-editor-alignment:not(:first-child)': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
        '> h1:first-child': {
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
            marginTop: '1.667em'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
        ' > h2:first-child': {
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
            marginTop: '1.8em'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
        '> h3:first-child': {
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
            marginTop: '2em'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
        '> h4:first-child': {
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
            marginTop: '1.357em'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
        '> h5:first-child': {
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
            marginTop: '1.667em'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
        '> h6:first-child': {
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
            marginTop: '1.455em'
        }
    },
    // Set marginTop: 0 if alignment block is next to a gap cursor or widget that is first child
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
    '.ProseMirror-gapcursor:first-child + .fabric-editor-block-mark.fabric-editor-alignment, .ProseMirror-widget:first-child + .fabric-editor-block-mark.fabric-editor-alignment, .ProseMirror-widget:first-child + .ProseMirror-widget:nth-child(2) + .fabric-editor-block-mark.fabric-editor-alignment': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
        '> :is(h1, h2, h3, h4, h5, h6):first-child': {
            marginTop: '0'
        }
    }
});
var $df014fe6e70c2dc0$var$ruleSharedStyles = (0, $74Zh5.css)({
    '& hr': {
        border: 'none',
        backgroundColor: "var(--ds-border, #0B120E24)",
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        margin: "".concat((0, $1LBcl.akEditorLineHeight), "em 0"),
        height: '2px',
        borderRadius: "var(--ds-radius-full, 9999px)"
    }
});
// When cleaning up `platform_editor_content_mode_button_mvp` simplify the name/ use the other paragraph style name
var $df014fe6e70c2dc0$var$paragraphSharedStylesWithEditorUGC = (0, $74Zh5.css)({
    '& p': {
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        font: "var(--ak-renderer-editor-font-normal-text)",
        marginTop: (0, $1LBcl.blockNodesVerticalMargin),
        marginBottom: 0
    }
});
var $df014fe6e70c2dc0$var$paragraphStylesUGCScaledMargin = (0, $74Zh5.css)({
    '& p': {
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        font: "var(--ak-renderer-editor-font-normal-text)",
        marginTop: (0, $1LBcl.scaledBlockNodesVerticalMargin),
        marginBottom: 0
    }
});
var $df014fe6e70c2dc0$var$paragraphSharedStyles = (0, $74Zh5.css)({
    '& p': {
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        fontSize: '1em',
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        lineHeight: (0, $1LBcl.akEditorLineHeight),
        fontWeight: "var(--ds-font-weight-regular, 400)",
        marginTop: (0, $1LBcl.blockNodesVerticalMargin),
        marginBottom: 0,
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        letterSpacing: '-0.005em'
    }
});
// When cleaning up `platform_editor_content_mode_button_mvp` simplify the name/ use the other paragraph style name
var $df014fe6e70c2dc0$var$paragraphSharedStyleScaledMargin = (0, $74Zh5.css)({
    '& p': {
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        fontSize: '1em',
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        lineHeight: (0, $1LBcl.akEditorLineHeight),
        fontWeight: "var(--ds-font-weight-regular, 400)",
        marginTop: (0, $1LBcl.scaledBlockNodesVerticalMargin),
        marginBottom: 0,
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        letterSpacing: '-0.005em'
    }
});
var $df014fe6e70c2dc0$var$listsSharedStyles = (0, $74Zh5.css)(($df014fe6e70c2dc0$var$_css8 = {
    /* =============== INDENTATION SPACING ========= */ 'ul, ol': {
        boxSizing: 'border-box',
        paddingLeft: "var(--ed--list--item-counter--padding, ".concat((0, $14WDN.listItemCounterPadding), "px)")
    }
}, (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($df014fe6e70c2dc0$var$_css8, "".concat((0, $5MY3X.orderedListSelector), ", ").concat((0, $gBea6.bulletListSelector)), {
    /*
   Ensures list item content adheres to the list's margin instead
   of filling the entire block row. This is important to allow
   clicking interactive elements which are floated next to a list.
    For some history and context on this block, see PRs related to tickets.:
   @see ED-6551 - original issue.
   @see ED-7015 - follow up issue.
   @see ED-7447 - flow-root change.
    used to have display: 'table' in tag template style but not supported in object styles
   removed display: 'table' as 'flow-root' is supported in latest browsers
    @see https://css-tricks.com/display-flow-root/
  */ display: 'flow-root'
}), 'ul, ul ul ul ul', {
    listStyleType: 'disc'
}), 'ul ul, ul ul ul ul ul', {
    listStyleType: 'circle'
}), 'ul ul ul, ul ul ul ul ul ul', {
    listStyleType: 'square'
}), 'ol, ol ol ol ol', {
    listStyleType: 'decimal'
}), 'ol ol, ol ol ol ol ol', {
    listStyleType: 'lower-alpha'
}), 'ol ol ol, ol ol ol ol ol ol', {
    listStyleType: 'lower-roman'
}), 'ol[data-indent-level="1"], ol[data-indent-level="4"]', {
    listStyleType: 'decimal'
}), 'ol[data-indent-level="2"], ol[data-indent-level="5"]', {
    listStyleType: 'lower-alpha'
}), 'ol[data-indent-level="3"], ol[data-indent-level="6"]', {
    listStyleType: 'lower-roman'
}), (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))($df014fe6e70c2dc0$var$_css8, 'ul[data-indent-level="1"], ul[data-indent-level="4"]', {
    listStyleType: 'disc'
}), 'ul[data-indent-level="2"], ul[data-indent-level="5"]', {
    listStyleType: 'circle'
}), 'ul[data-indent-level="3"], ul[data-indent-level="6"]', {
    listStyleType: 'square'
})));
/*
	Firefox does not handle empty block element inside li tag.
	If there is not block element inside li tag,
	then firefox sets inherited height to li
	However, if there is any block element and if it's empty
	(or has empty inline element) then
	firefox sets li tag height to zero.
	More details at
	https://product-fabric.atlassian.net/wiki/spaces/~455502413/pages/3149365890/ED-14110+Investigation
*/ var $df014fe6e70c2dc0$var$listsSharedStylesForGekko = (0, $74Zh5.css)({
    'ul, ol': {
        'li p:empty, li p > span:empty': {
            display: 'inline-block'
        }
    }
});
var $df014fe6e70c2dc0$var$indentationSharedStyles = (0, $74Zh5.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.fabric-editor-indentation-mark': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        "&[data-level='1']": {
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
            marginLeft: '30px'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        "&[data-level='2']": {
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
            marginLeft: '60px'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        "&[data-level='3']": {
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
            marginLeft: '90px'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        "&[data-level='4']": {
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
            marginLeft: '120px'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        "&[data-level='5']": {
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
            marginLeft: '150px'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        "&[data-level='6']": {
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
            marginLeft: '180px'
        }
    }
});
var $df014fe6e70c2dc0$var$indentationSharedStylesWithMarginFix = (0, $74Zh5.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.fabric-editor-indentation-mark': {
        // Prevent marginTop of p:first-child overrode by batch.css
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
        'p:first-child': {
            marginTop: (0, $1LBcl.blockNodesVerticalMargin)
        }
    }
});
var $df014fe6e70c2dc0$var$blockMarksSharedStyles = (0, $74Zh5.css)((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, "*:not(.fabric-editor-block-mark) >,\n  \t*:not(.fabric-editor-block-mark) >\n    div.fabric-editor-block-mark:first-of-type\n\t:not(.fabric-editor-indentation-mark)\n\t:not(.fabric-editor-alignment),\n  \t.fabric-editor-alignment:first-of-type:first-child,\n  \t.ProseMirror .fabric-editor-indentation-mark:first-of-type:first-child", {
    'p, h1, h2, h3, h4, h5, h6, .heading-wrapper': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
        ':first-child:not(style), style:first-child + *': {
            marginTop: 0
        }
    }
}));
var $df014fe6e70c2dc0$var$codeMarkSharedStyles = (0, $74Zh5.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.code': {
        '--ds--code--bg-color': "var(--ds-background-neutral, #0515240F)",
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        fontSize: '0.875em',
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        fontFamily: "var(--ds-font-family-code, ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)",
        fontWeight: "var(--ds-font-weight-regular, 400)",
        backgroundColor: "var(--ds--code--bg-color,".concat("var(--ds-background-neutral, ".concat((0, $d4dXm.N20), ")"), ")"),
        color: "var(--ds-text, ".concat((0, $d4dXm.N800), ")"),
        borderStyle: 'none',
        borderRadius: "var(--ds-radius-small, 3px)",
        display: 'inline',
        padding: '2px 0.5ch',
        boxDecorationBreak: 'clone',
        overflow: 'auto',
        overflowWrap: 'break-word',
        whiteSpace: 'pre-wrap'
    }
});
var $df014fe6e70c2dc0$var$extensionStyle = (0, $74Zh5.css)({
    // Sets fontSize of extensions to match base font size which scales with the renderer contentMode prop
    // exceptions:
    // - nested renderers - bodied extensions have nested renderers adopt the contentMode prop themselves so should not be touched
    // - legacy status lozenge - some extensions use the .aui-lozenge class for a legacy status lozenge and is not designed to scale
    // - .ak-renderer-extension .ak-renderer-document .ak-renderer-extension:not(:has(.ak-renderer-document)) :not(.aui-lozenge, .status-lozenge-span *)
    //	 extensions inside extension documents (like ones with their own renderer) will need the font size to be applied again (e.g. TOC inside Excerpt, or TOC inside Page Properties inside LCM inside table)
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
    '.ak-renderer-extension :not(.ak-renderer-extension .ak-renderer-document *, .aui-lozenge, .status-lozenge-span *), .ak-renderer-extension .ak-renderer-document .ak-renderer-extension:not(:has(.ak-renderer-document)) :not(.aui-lozenge, .status-lozenge-span *)': {
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        fontSize: 'var(--ak-renderer-base-font-size)'
    }
});
var $df014fe6e70c2dc0$var$shadowSharedStyle = (0, $74Zh5.css)((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, "& .".concat((0, $c6bEO.shadowClassNames).RIGHT_SHADOW, "::before, .").concat((0, $c6bEO.shadowClassNames).RIGHT_SHADOW, "::after, .").concat((0, $c6bEO.shadowClassNames).LEFT_SHADOW, "::before, .").concat((0, $c6bEO.shadowClassNames).LEFT_SHADOW, "::after"), {
    display: 'none',
    position: 'absolute',
    pointerEvents: 'none',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    zIndex: (0, $1LBcl.akEditorShadowZIndex),
    width: '8px',
    content: "''",
    height: 'calc(100%)'
}), "& .".concat((0, $c6bEO.shadowClassNames).RIGHT_SHADOW, ", .").concat((0, $c6bEO.shadowClassNames).LEFT_SHADOW), {
    position: 'relative'
}), "& .".concat((0, $c6bEO.shadowClassNames).LEFT_SHADOW, "::before"), {
    background: "linear-gradient( to left, transparent 0, ".concat("var(--ds-shadow-overflow-spread, #1E1F2129)", " 140% ), linear-gradient( to right, ", "var(--ds-shadow-overflow-perimeter, transparent)", " 0px, transparent 1px )"),
    top: '0px',
    left: 0,
    display: 'block'
}), "& .".concat((0, $c6bEO.shadowClassNames).RIGHT_SHADOW, "::after"), {
    background: "linear-gradient( to right, transparent 0, ".concat("var(--ds-shadow-overflow-spread, #1E1F2129)", " 140% ), linear-gradient( to left, ", "var(--ds-shadow-overflow-perimeter, transparent)", " 0px, transparent 1px )"),
    right: '0px',
    top: '0px',
    display: 'block'
}), "& .".concat((0, $3ytat.shadowObserverClassNames).SENTINEL_LEFT), {
    height: '100%',
    width: '0px',
    minWidth: '0px'
}), "& .".concat((0, $3ytat.shadowObserverClassNames).SENTINEL_RIGHT), {
    height: '100%',
    width: '0px',
    minWidth: '0px'
}));
var $df014fe6e70c2dc0$var$dateSharedStyle = (0, $74Zh5.css)((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, ".".concat((0, $hyfkz.DateSharedCssClassName).DATE_WRAPPER, " span"), {
    whiteSpace: 'unset'
}));
var $df014fe6e70c2dc0$var$textColorStyles = (0, $74Zh5.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.fabric-text-color-mark': {
        color: 'var(--custom-palette-color, inherit)'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    'a .fabric-text-color-mark': {
        color: 'unset'
    }
});
var $df014fe6e70c2dc0$var$backgroundColorStyles = (0, $74Zh5.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.fabric-background-color-mark': {
        backgroundColor: 'var(--custom-palette-color, inherit)',
        borderRadius: "var(--ds-radius-xsmall, 2px)",
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
        paddingTop: '1px',
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
        paddingBottom: '2px',
        boxDecorationBreak: 'clone'
    },
    // Don't show text highlight styling when there is a hyperlink
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    'a .fabric-background-color-mark': {
        backgroundColor: 'unset'
    },
    // Don't show text highlight styling when there is an inline comment
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.fabric-background-color-mark .ak-editor-annotation': {
        backgroundColor: 'unset'
    }
});
var $df014fe6e70c2dc0$export$a365082c2a191514 = (0, $74Zh5.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '.fabric-background-color-mark:has(.background-color-padding-left)': {
        paddingLeft: "var(--ds-space-025, 2px)",
        marginLeft: "var(--ds-space-negative-025, -2px)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '.fabric-background-color-mark:has(.background-color-padding-right)': {
        paddingRight: "var(--ds-space-025, 2px)",
        marginRight: "var(--ds-space-negative-025, -2px)"
    }
});
var $df014fe6e70c2dc0$var$tasksAndDecisionsStyles = (0, $74Zh5.css)({
    '.ProseMirror': (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, ".taskItemView-content-wrap,\n\t\t.".concat((0, $ff7834a81ceb151c$export$a7172b75d403a0e4).DECISION_CONTAINER), {
        position: 'relative',
        minWidth: "".concat((0, $1LBcl.akEditorTableCellMinWidth), "px")
    }), ".".concat((0, $ff7834a81ceb151c$export$a7172b75d403a0e4).DECISION_CONTAINER), {
        marginTop: 0
    }), ".".concat((0, $ff7834a81ceb151c$export$a7172b75d403a0e4).TASK_CONTAINER), {
        'span[contenteditable="false"]': {
            height: "".concat((0, $1LBcl.akEditorLineHeight), "em")
        }
    }), ".".concat((0, $ff7834a81ceb151c$export$a7172b75d403a0e4).TASK_ITEM), {
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        lineHeight: (0, $1LBcl.akEditorLineHeight)
    }),
    'div[data-task-local-id]': {
        'span[contenteditable="false"]': {
            height: "".concat((0, $1LBcl.akEditorLineHeight), "em")
        },
        'span[contenteditable="false"] + div': {
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            lineHeight: "".concat((0, $1LBcl.akEditorLineHeight), "em")
        }
    },
    'div[data-task-list-local-id]': {
        margin: "var(--ds-space-150, 12px)".concat(" 0 0 0"),
        // If task item is not first in the list then set margin top to 4px.
        'div + div': {
            marginTop: "var(--ds-space-050, 4px)"
        }
    },
    // If task list is not first in the document then set margin top to 4px.
    'div[data-task-list-local-id] div[data-task-list-local-id]': {
        marginTop: "var(--ds-space-050, 4px)",
        marginLeft: "var(--ds-space-300, 24px)"
    },
    /* When action list is inside panel */ '.ak-editor-panel__content': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
        '> div[data-task-list-local-id]:first-child': {
            margin: '0 0 0 0 !important'
        }
    }
});
var $df014fe6e70c2dc0$var$smartCardStyles = (0, $74Zh5.css)((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, ".".concat((0, $23e6e5ff8dd7ee19$export$4ccd31bf665a88f6).BLOCK_CARD_CONTAINER), {
    display: 'block',
    margin: "".concat((0, $1LBcl.blockNodesVerticalMargin), " 0 0"),
    maxWidth: "".concat(760, "px")
}));
var $df014fe6e70c2dc0$var$smartCardStylesAvatarFix = (0, $74Zh5.css)((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, ".".concat((0, $23e6e5ff8dd7ee19$export$4ccd31bf665a88f6).BLOCK_CARD_CONTAINER, ":not(.").concat((0, $23e6e5ff8dd7ee19$export$4ccd31bf665a88f6).DATASOURCE_CONTAINER, ")"), {
    /* EDM-11991: Fix list plugin adding padding to ADS AvatarGroup start */ 'ul, ol': {
        paddingLeft: 'inherit'
    }
}));
var $df014fe6e70c2dc0$var$smartCardStylesAvatarMarginFix = (0, $74Zh5.css)((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, ".".concat((0, $23e6e5ff8dd7ee19$export$4ccd31bf665a88f6).BLOCK_CARD_CONTAINER, ":not(.").concat((0, $23e6e5ff8dd7ee19$export$4ccd31bf665a88f6).DATASOURCE_CONTAINER, ")"), {
    'ul, ol': {
        marginRight: 'inherit'
    }
}));
var $df014fe6e70c2dc0$var$smartCardStylesAvatarListZeroMarginTop = (0, $74Zh5.css)((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, ".".concat((0, $23e6e5ff8dd7ee19$export$4ccd31bf665a88f6).BLOCK_CARD_CONTAINER, ":not(.").concat((0, $23e6e5ff8dd7ee19$export$4ccd31bf665a88f6).DATASOURCE_CONTAINER, ")"), {
    'ul, ol': {
        marginTop: 0
    }
}));
// In Renderer in Jira there is no SmartCardSharedCssClassName.INLINE_CARD_CONTAINER, so using data-inline-cart="true"
var $df014fe6e70c2dc0$var$headerSmartCardStyles = (0, $74Zh5.css)({
    '[data-inline-card="true"]': {
        '[data-inlinecard-button-overlay="icon-wrapper-line-height"] span': {
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            lineHeight: 0
        }
    }
});
var $df014fe6e70c2dc0$var$baseOtherStyles = (0, $74Zh5.css)((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({
    '& .UnknownBlock': {
        fontFamily: "var(--ds-font-family-body, ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        fontSize: "".concat(0.875, "rem"),
        fontWeight: "var(--ds-font-weight-regular, 400)",
        whiteSpace: 'pre-wrap',
        wordWrap: 'break-word'
    },
    '& span.date-node': {
        background: "var(--ds-background-neutral, ".concat((0, $d4dXm.N30A), ")"),
        borderRadius: "var(--ds-radius-small, 3px)",
        color: "var(--ds-text, ".concat((0, $d4dXm.N800), ")"),
        padding: "var(--ds-space-025, 2px)".concat(" ", "var(--ds-space-050, 4px)"),
        margin: "0 1px",
        transition: "background 0.3s"
    },
    '& span.date-node-highlighted': {
        background: "var(--ds-background-danger, ".concat((0, $d4dXm.R50), ")"),
        color: "var(--ds-text-danger, ".concat((0, $d4dXm.R500), ")")
    },
    '& .renderer-image': {
        maxWidth: '100%',
        display: 'block',
        margin: "var(--ds-space-300, 24px)".concat(" 0")
    }
}, ".".concat((0, $7269fd760c5a40ab$export$cfe6da7d522d87bb), ".rich-media-wrapped + .").concat((0, $7269fd760c5a40ab$export$cfe6da7d522d87bb), ":not(.rich-media-wrapped)"), {
    clear: 'both'
}), "& .code-block,\n\t& blockquote,\n\t& hr,\n\t& > div > div:not(.rich-media-wrapped),\n\t.".concat((0, $7269fd760c5a40ab$export$cfe6da7d522d87bb), ".rich-media-wrapped + .rich-media-wrapped + *:not(.rich-media-wrapped),\n\t.").concat((0, $7269fd760c5a40ab$export$cfe6da7d522d87bb), ".rich-media-wrapped + div:not(.rich-media-wrapped),\n\t.").concat((0, $7269fd760c5a40ab$export$cfe6da7d522d87bb), ".image-align-start,\n\t\t.").concat((0, $7269fd760c5a40ab$export$cfe6da7d522d87bb), ".image-center,\n\t\t.").concat((0, $7269fd760c5a40ab$export$cfe6da7d522d87bb), ".image-align-end"), {
    clear: 'both'
}), '& .rich-media-wrapped', {
    '& + h1, & + h2, & + h3, & + h4, & + h5, & + h6': {
        marginTop: "var(--ds-space-100, 8px)"
    }
}), 'div[class^="image-wrap-"] + div[class^="image-wrap-"]', {
    marginLeft: 0,
    marginRight: 0
}), ".".concat((0, $53SBn.RendererCssClassName).DOCUMENT, " >"), (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, "*:not([data-mark-type='fragment']) .".concat((0, $fMtrl.TableSharedCssClassName).TABLE_CONTAINER), {
    // Temporarily ignoring the below the owning team can add the ticket number for the TODO.  Context: https://atlassian.slack.com/archives/CPUEVD9MY/p1741565387326829
    // eslint-disable-next-line @atlaskit/editor/enforce-todo-comment-format
    // TODO - improve inline style logic on table container so important styles aren't required here
    width: '100% !important',
    left: '0 !important'
}), "[data-mark-type='fragment'] * .".concat((0, $fMtrl.TableSharedCssClassName).TABLE_CONTAINER), {
    // Temporarily ignoring the below the owning team can add the ticket number for the TODO.  Context: https://atlassian.slack.com/archives/CPUEVD9MY/p1741565387326829
    // eslint-disable-next-line @atlaskit/editor/enforce-todo-comment-format
    // TODO - improve inline style logic on table container so important styles aren't required here
    width: '100% !important',
    left: '0 !important'
}), "* .".concat((0, $53SBn.RendererCssClassName).EXTENSION_OVERFLOW_CONTAINER), {
    overflowX: 'auto'
}), "& .".concat((0, $53SBn.RendererCssClassName).EXTENSION, ":first-child"), {
    marginTop: 0
})), ".".concat((0, $53SBn.RendererCssClassName).DOCUMENT), (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, ".".concat((0, $53SBn.RendererCssClassName).EXTENSION), {
    marginTop: "".concat((0, $1LBcl.blockNodesVerticalMargin))
}), ".".concat((0, $53SBn.RendererCssClassName).EXTENSION_CENTER_ALIGN), {
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
    marginLeft: '50%',
    transform: 'translateX(-50%)'
}), ".".concat((0, $fMtrl.TableSharedCssClassName).TABLE_NODE_WRAPPER), {
    overflowX: 'auto'
}), ".".concat((0, $3ytat.shadowObserverClassNames).SHADOW_CONTAINER, " .").concat((0, $fMtrl.TableSharedCssClassName).TABLE_NODE_WRAPPER), {
    display: 'flex'
})));
var $df014fe6e70c2dc0$var$alignedHeadingAnchorStyle = (0, $74Zh5.css)({
    // Temporarily ignoring the below the owning team can add the ticket number for the TODO.  Context: https://atlassian.slack.com/archives/CPUEVD9MY/p1741565387326829
    // eslint-disable-next-line @atlaskit/editor/enforce-todo-comment-format
    // TODO Delete this comment after verifying space token -> previous value `margin: 6px`
    '.fabric-editor-block-mark[data-align] >': {
        'h1, h2, h3, h4, h5, h6': {
            position: 'relative'
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
    '.fabric-editor-block-mark:not([data-align="center"])[data-align]': (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, ".".concat((0, $fq8Dd.HeadingAnchorWrapperClassName)), {
        margin: "0 ".concat("var(--ds-space-075, 6px)", " 0 0"),
        // If the anchor is right aligned then the left side of the heading
        // is aligned with the left side of the anchor.
        // In order to align as expected we transform it the width of the element (plus our expected 6px)
        // to the left
        transform: "translateX(calc(-100% - ".concat("var(--ds-space-075, 6px)", "))")
    }), '@media (hover: hover) and (pointer: fine)', (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, ".".concat((0, $fq8Dd.HeadingAnchorWrapperClassName), " > button"), {
        transform: "translate(8px, 0px)"
    }))
});
var $df014fe6e70c2dc0$var$firstWrappedMediaStyles = (0, $74Zh5.css)((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, ".".concat((0, $7269fd760c5a40ab$export$cfe6da7d522d87bb), "[class*=\"image-wrap-\"]:has(+ .").concat((0, $7269fd760c5a40ab$export$cfe6da7d522d87bb), "[class*=\"image-wrap-\"])"), {
    marginRight: 0,
    marginLeft: 0
}));
// Temporarily ignoring the below the owning team can add the ticket number for the TODO.  Context: https://atlassian.slack.com/archives/CPUEVD9MY/p1741565387326829
// eslint-disable-next-line @atlaskit/editor/enforce-todo-comment-format
// TODO: emotion refactor - there's a mediaSingleSharedNewStyle, but not originally used in the renderer.
var $df014fe6e70c2dc0$var$mediaSingleSharedStyle = (0, $74Zh5.css)((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, "li .".concat((0, $7269fd760c5a40ab$export$cfe6da7d522d87bb)), {
    margin: 0
}), '&.ua-chrome li > .mediaSingleView-content-wrap::before', {
    content: "''",
    display: 'block',
    height: 0
}), '&.ua-firefox', {
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.mediaSingleView-content-wrap': {
        userSelect: 'none'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.captionView-content-wrap': {
        userSelect: 'text'
    }
}), ".mediaSingleView-content-wrap[layout='center']", {
    clear: 'both'
}), "table .".concat((0, $7269fd760c5a40ab$export$cfe6da7d522d87bb)), {
    marginTop: "var(--ds-space-150, 12px)",
    marginBottom: "var(--ds-space-150, 12px)",
    clear: 'both',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.image-wrap-left[data-layout], &.image-wrap-right[data-layout]': {
        clear: 'none',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '&:first-child': {
            marginTop: "var(--ds-space-150, 12px)"
        }
    }
}), ".".concat((0, $7269fd760c5a40ab$export$cfe6da7d522d87bb), ".image-wrap-right + .").concat((0, $7269fd760c5a40ab$export$cfe6da7d522d87bb), ".image-wrap-left"), {
    clear: 'both'
}), ".".concat((0, $7269fd760c5a40ab$export$cfe6da7d522d87bb), ".image-wrap-left + .").concat((0, $7269fd760c5a40ab$export$cfe6da7d522d87bb), ".image-wrap-right, .").concat((0, $7269fd760c5a40ab$export$cfe6da7d522d87bb), ".image-wrap-right + .").concat((0, $7269fd760c5a40ab$export$cfe6da7d522d87bb), ".image-wrap-left, .").concat((0, $7269fd760c5a40ab$export$cfe6da7d522d87bb), ".image-wrap-left + .").concat((0, $7269fd760c5a40ab$export$cfe6da7d522d87bb), ".image-wrap-left, .").concat((0, $7269fd760c5a40ab$export$cfe6da7d522d87bb), ".image-wrap-right + .").concat((0, $7269fd760c5a40ab$export$cfe6da7d522d87bb), ".image-wrap-right"), {
    marginRight: 0,
    marginLeft: 0
}), "@media all and (max-width: ".concat($df014fe6e70c2dc0$var$wrappedMediaBreakoutPoint, "px)"), {
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    "div.mediaSingleView-content-wrap[layout='wrap-left'], div.mediaSingleView-content-wrap[data-layout='wrap-left'], div.mediaSingleView-content-wrap[layout='wrap-right'], div.mediaSingleView-content-wrap[data-layout='wrap-right']": {
        float: 'none',
        overflow: 'auto',
        margin: "var(--ds-space-150, 12px)".concat(" 0")
    }
}));
// was shared between editor-core and renderer
var $df014fe6e70c2dc0$var$tableSharedStyle = (0, $74Zh5.css)((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({
    // originally from packages/editor/editor-common/src/styles/shared/tableCell.ts
    // Hardcoding the background color for the table cells to avoid the use of inline styles
    'td[colorname="white" i], th[colorname="white" i]': {
        backgroundColor: "var(--ds-surface, #FFFFFF)".concat(" !important")
    },
    'td[colorname="light blue" i], th[colorname="light blue" i]': {
        backgroundColor: "var(--ds-background-accent-blue-subtlest, #DEEBFF)".concat(" !important")
    },
    'td[colorname="light teal" i], th[colorname="light teal" i]': {
        backgroundColor: "var(--ds-background-accent-teal-subtlest, #E6FCFF)".concat(" !important")
    },
    'td[colorname="light green" i], th[colorname="light green" i]': {
        backgroundColor: "var(--ds-background-accent-green-subtlest, #E3FCEF)".concat(" !important")
    },
    'td[colorname="light yellow" i], th[colorname="light yellow" i]': {
        backgroundColor: "var(--ds-background-accent-yellow-subtlest, #FFFAE6)".concat(" !important")
    },
    'td[colorname="light red" i], th[colorname="light red" i]': {
        backgroundColor: "var(--ds-background-accent-red-subtlest, #FFEBE6)".concat(" !important")
    },
    'td[colorname="light purple" i], th[colorname="light purple" i]': {
        backgroundColor: "var(--ds-background-accent-purple-subtlest, #EAE6FF)".concat(" !important")
    },
    'td[colorname="light gray" i], th[colorname="light gray" i]': {
        backgroundColor: "var(--ds-background-accent-gray-subtlest, #F4F5F7)".concat(" !important")
    },
    'td[colorname="blue" i], th[colorname="blue" i]': {
        backgroundColor: "var(--ds-background-accent-blue-subtler, #B3D4FF)".concat(" !important")
    },
    'td[colorname="teal" i], th[colorname="teal" i]': {
        backgroundColor: "var(--ds-background-accent-teal-subtler, #B3F5FF)".concat(" !important")
    },
    'td[colorname="green" i], th[colorname="green" i]': {
        backgroundColor: "var(--ds-background-accent-green-subtler, #ABF5D1)".concat(" !important")
    },
    'td[colorname="yellow" i], th[colorname="yellow" i]': {
        backgroundColor: "var(--ds-background-accent-yellow-subtler, #FFF0B3)".concat(" !important")
    },
    'td[colorname="red" i], th[colorname="red" i]': {
        backgroundColor: "var(--ds-background-accent-red-subtler, #FFBDAD)".concat(" !important")
    },
    'td[colorname="purple" i], th[colorname="purple" i]': {
        backgroundColor: "var(--ds-background-accent-purple-subtler, #C0B6F2)".concat(" !important")
    },
    'td[colorname="gray" i], th[colorname="gray" i]': {
        backgroundColor: "var(--ds-background-accent-gray-subtle, #B3BAC5)".concat(" !important")
    },
    'td[colorname="dark blue" i], th[colorname="dark blue" i]': {
        backgroundColor: "var(--ds-background-accent-blue-subtle, #4C9AFF)".concat(" !important")
    },
    'td[colorname="dark teal" i], th[colorname="dark teal" i]': {
        backgroundColor: "var(--ds-background-accent-teal-subtle, #79E2F2)".concat(" !important")
    },
    'td[colorname="dark green" i], th[colorname="dark green" i]': {
        backgroundColor: "var(--ds-background-accent-green-subtle, #57D9A3)".concat(" !important")
    },
    'td[colorname="dark yellow" i], th[colorname="dark yellow" i]': {
        backgroundColor: "var(--ds-background-accent-orange-subtle, #FFC400)".concat(" !important")
    },
    'td[colorname="dark red" i], th[colorname="dark red" i]': {
        backgroundColor: "var(--ds-background-accent-red-subtle, #FF8F73)".concat(" !important")
    },
    'td[colorname="dark purple" i], th[colorname="dark purple" i]': {
        backgroundColor: "var(--ds-background-accent-purple-subtle, #998DD9)".concat(" !important")
    }
}, ".".concat((0, $fMtrl.TableSharedCssClassName).TABLE_CONTAINER), {
    position: 'relative',
    margin: "0 auto ".concat("var(--ds-space-200, 16px)"),
    boxSizing: 'border-box',
    /**
   * Fix block top alignment inside table cells.
   */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
    '.decisionItemView-content-wrap:first-of-type > div': {
        marginTop: 0
    }
}), ".".concat((0, $fMtrl.TableSharedCssClassName).TABLE_CONTAINER, "[data-number-column='true']"), {
    paddingLeft: "".concat((0, $1LBcl.akEditorTableNumberColumnWidth) - 1, "px"),
    clear: 'both'
}), ".".concat((0, $fMtrl.TableSharedCssClassName).TABLE_RESIZER_CONTAINER), {
    willChange: 'width, margin-left'
}), ".".concat((0, $fMtrl.TableSharedCssClassName).TABLE_RESIZER_CONTAINER, " table"), {
    willChange: 'width'
}), ".".concat((0, $fMtrl.TableSharedCssClassName).TABLE_NODE_WRAPPER, " > table"), {
    margin: "var(--ds-space-300, 24px)".concat(" 0 0 0")
}), ".".concat((0, $fMtrl.TableSharedCssClassName).TABLE_CONTAINER, " > table,\n\t.").concat((0, $fMtrl.TableSharedCssClassName).TABLE_STICKY_WRAPPER, " > table"), {
    margin: "var(--ds-space-300, 24px)".concat(" ", "var(--ds-space-100, 8px)", " 0 0")
}), ".".concat((0, $fMtrl.TableSharedCssClassName).TABLE_CONTAINER, " > table,\n\t.").concat((0, $fMtrl.TableSharedCssClassName).TABLE_NODE_WRAPPER, " > table,\n\t.").concat((0, $fMtrl.TableSharedCssClassName).TABLE_STICKY_WRAPPER, " > table"), {
    borderCollapse: 'collapse',
    border: "".concat((0, $fMtrl.tableCellBorderWidth), "px solid ", "var(--ds-background-accent-gray-subtler, ".concat((0, $1LBcl.akEditorTableBorder), ")")),
    tableLayout: 'fixed',
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    fontSize: '1em',
    width: '100%',
    '&[data-autosize="true"]': {
        tableLayout: 'auto'
    },
    '*': {
        boxSizing: 'border-box'
    },
    hr: {
        boxSizing: 'content-box'
    },
    tbody: {
        borderBottom: 'none'
    },
    'th td': {
        backgroundColor: "var(--ds-background-neutral-subtle, white)"
    },
    '> tbody > tr > td': {
        backgroundColor: "var(--ds-surface, #FFFFFF)"
    },
    th: {
        backgroundColor: "var(--ds-background-accent-gray-subtlest, ".concat((0, $1LBcl.akEditorTableToolbar), ")"),
        textAlign: 'left',
        /* only apply this styling to codeblocks in default background headercells */ /* TODO this needs to be overhauled as it relies on unsafe selectors */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
        '&:not([style]):not(.danger)': (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, ".".concat((0, $knSf2.CodeBlockSharedCssClassName).CODEBLOCK_CONTAINER, ":not(.danger)"), (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({
            backgroundColor: "var(--ds-surface-raised, rgb(235, 237, 240))"
        }, "&:not(.".concat((0, $1LBcl.akEditorSelectedNodeClassName), ")"), {
            boxShadow: "0px 0px 0px 1px ".concat("var(--ds-border, transparent)")
        }), ".".concat((0, $knSf2.CodeBlockSharedCssClassName).CODEBLOCK_CONTENT_WRAPPER), {
            // originally copied from packages/editor/editor-shared-styles/src/overflow-shadow/overflow-shadow.ts
            backgroundImage: "linear-gradient(\n\t\t\t\t\t\t\tto right,\n\t\t\t\t\t\t\t".concat("var(--ds-background-neutral, #0515240F)", " ", "var(--ds-space-300, 24px)", ",\n\t\t\t\t\t\t\ttransparent ", "var(--ds-space-300, 24px)", "\n\t\t\t\t\t\t  ),linear-gradient(\n\t\t\t\t\t\t\tto right,\n\t\t\t\t\t\t\t", "var(--ds-surface-raised, #FFFFFF)", " ", "var(--ds-space-300, 24px)", ",\n\t\t\t\t\t\t\ttransparent ", "var(--ds-space-300, 24px)", "\n\t\t\t\t\t\t  ),linear-gradient(\n\t\t\t\t\t\t\tto left,\n\t\t\t\t\t\t\t", "var(--ds-background-neutral, #0515240F)", " ", "var(--ds-space-100, 8px)", ",\n\t\t\t\t\t\t\ttransparent ", "var(--ds-space-100, 8px)", "\n\t\t\t\t\t\t  ),linear-gradient(\n\t\t\t\t\t\t\tto left,\n\t\t\t\t\t\t\t", "var(--ds-surface-raised, #FFFFFF)", " ", "var(--ds-space-100, 8px)", ",\n\t\t\t\t\t\t\ttransparent ", "var(--ds-space-100, 8px)", "\n\t\t\t\t\t\t  ),linear-gradient(\n\t\t\t\t\t\t\tto left,\n\t\t\t\t\t\t\t", "var(--ds-shadow-overflow-spread, #1E1F2129)", " 0,\n\t\t\t\t\t\t\t", "var(--ds-UNSAFE-transparent, transparent)", "  ", "var(--ds-space-100, 8px)", "\n\t\t\t\t\t\t  ),linear-gradient(\n\t\t\t\t\t\t\tto left,\n\t\t\t\t\t\t\t", "var(--ds-shadow-overflow-perimeter, #1E1F211f)", " 0,\n\t\t\t\t\t\t\t", "var(--ds-UNSAFE-transparent, transparent)", "  ", "var(--ds-space-100, 8px)", "\n\t\t\t\t\t\t  ),linear-gradient(\n\t\t\t\t\t\t\tto right,\n\t\t\t\t\t\t\t", "var(--ds-shadow-overflow-spread, #1E1F2129)", " 0,\n\t\t\t\t\t\t\t", "var(--ds-UNSAFE-transparent, transparent)", "  ", "var(--ds-space-100, 8px)", "\n\t\t\t\t\t\t  ),linear-gradient(\n\t\t\t\t\t\t\tto right,\n\t\t\t\t\t\t\t", "var(--ds-shadow-overflow-perimeter, #1E1F211f)", " 0,\n\t\t\t\t\t\t\t", "var(--ds-UNSAFE-transparent, transparent)", "  ", "var(--ds-space-100, 8px)", "\n\t\t\t\t\t\t  )"),
            backgroundColor: "var(--ds-background-neutral, rgb(235, 237, 240))"
        }), ".".concat((0, $knSf2.CodeBlockSharedCssClassName).CODEBLOCK_LINE_NUMBER_GUTTER), {
            backgroundColor: "var(--ds-background-neutral, rgb(226, 229, 233))"
        }), '> [data-ds--code--code-block]', {
            // originally copied from packages/editor/editor-shared-styles/src/overflow-shadow/overflow-shadow.ts
            backgroundImage: "linear-gradient(\n\t\t\t\t\t\t\tto right,\n\t\t\t\t\t\t\t".concat("var(--ds-background-neutral, #0515240F)", " ", "var(--ds-space-300, 24px)", ",\n\t\t\t\t\t\t\ttransparent ", "var(--ds-space-300, 24px)", "\n\t\t\t\t\t\t  ),linear-gradient(\n\t\t\t\t\t\t\tto right,\n\t\t\t\t\t\t\t", "var(--ds-surface-raised, #FFFFFF)", " ", "var(--ds-space-300, 24px)", ",\n\t\t\t\t\t\t\ttransparent ", "var(--ds-space-300, 24px)", "\n\t\t\t\t\t\t  ),linear-gradient(\n\t\t\t\t\t\t\tto left,\n\t\t\t\t\t\t\t", "var(--ds-background-neutral, #0515240F)", " ", "var(--ds-space-100, 8px)", ",\n\t\t\t\t\t\t\ttransparent ", "var(--ds-space-100, 8px)", "\n\t\t\t\t\t\t  ),linear-gradient(\n\t\t\t\t\t\t\tto left,\n\t\t\t\t\t\t\t", "var(--ds-surface-raised, #FFFFFF)", " ", "var(--ds-space-100, 8px)", ",\n\t\t\t\t\t\t\ttransparent ", "var(--ds-space-100, 8px)", "\n\t\t\t\t\t\t  ),linear-gradient(\n\t\t\t\t\t\t\tto left,\n\t\t\t\t\t\t\t", "var(--ds-shadow-overflow-spread, #1E1F2129)", " 0,\n\t\t\t\t\t\t\t", "var(--ds-UNSAFE-transparent, transparent)", "  ", "var(--ds-space-100, 8px)", "\n\t\t\t\t\t\t  ),linear-gradient(\n\t\t\t\t\t\t\tto left,\n\t\t\t\t\t\t\t", "var(--ds-shadow-overflow-perimeter, #1E1F211f)", " 0,\n\t\t\t\t\t\t\t", "var(--ds-UNSAFE-transparent, transparent)", "  ", "var(--ds-space-100, 8px)", "\n\t\t\t\t\t\t  ),linear-gradient(\n\t\t\t\t\t\t\tto right,\n\t\t\t\t\t\t\t", "var(--ds-shadow-overflow-spread, #1E1F2129)", " 0,\n\t\t\t\t\t\t\t", "var(--ds-UNSAFE-transparent, transparent)", "  ", "var(--ds-space-100, 8px)", "\n\t\t\t\t\t\t  ),linear-gradient(\n\t\t\t\t\t\t\tto right,\n\t\t\t\t\t\t\t", "var(--ds-shadow-overflow-perimeter, #1E1F211f)", " 0,\n\t\t\t\t\t\t\t", "var(--ds-UNSAFE-transparent, transparent)", "  ", "var(--ds-space-100, 8px)", "\n\t\t\t\t\t\t  )"),
            backgroundColor: "var(--ds-background-neutral, rgb(235, 237, 240))".concat("!important"),
            // selector lives inside @atlaskit/code
            '--ds--code--line-number-bg-color': "var(--ds-background-neutral, rgb(226, 229, 233))"
        }))
    }
}));
var $df014fe6e70c2dc0$var$tableRendererHeaderStylesForTableCellOnly = (0, $74Zh5.css)((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, ".".concat((0, $fMtrl.TableSharedCssClassName).TABLE_CONTAINER, " > table,\n\t\t.").concat((0, $fMtrl.TableSharedCssClassName).TABLE_NODE_WRAPPER, " > table,\n\t\t.").concat((0, $fMtrl.TableSharedCssClassName).TABLE_STICKY_WRAPPER, " > table"), {
    '> tbody > tr > th, > tbody > tr > td': {
        minWidth: "".concat((0, $fMtrl.tableCellMinWidth), "px"),
        fontWeight: "var(--ds-font-weight-regular, 400)",
        verticalAlign: 'top',
        border: "var(--ds-border-width, 1px)".concat(" solid ", "var(--ds-background-accent-gray-subtler, ".concat((0, $1LBcl.akEditorTableBorder), ")")),
        borderRightWidth: 0,
        borderBottomWidth: 0,
        padding: "var(--ds-space-100, 8px)",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
        'th p:not(:first-of-type), td p:not(:first-of-type)': {
            marginTop: "var(--ds-space-150, 12px)"
        }
    }
}));
var $df014fe6e70c2dc0$var$tableRendererNestedPanelStyles = (0, $74Zh5.css)((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, ".".concat((0, $fMtrl.TableSharedCssClassName).TABLE_CONTAINER, " .ak-editor-panel"), {
    border: "var(--ds-border-width, 1px)".concat(" solid ", "var(--ds-border, #d9dbea)")
}));
var $df014fe6e70c2dc0$var$tableStylesBackGroundClipForGeckoForTableCellOnly = (0, $74Zh5.css)((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, ".".concat((0, $fMtrl.TableSharedCssClassName).TABLE_CONTAINER, " > table,\n\t\t.").concat((0, $fMtrl.TableSharedCssClassName).TABLE_NODE_WRAPPER, " > table,\n\t\t.").concat((0, $fMtrl.TableSharedCssClassName).TABLE_STICKY_WRAPPER, " > table"), {
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
    '> tbody > tr > th, > tbody > tr > td': {
        backgroundClip: 'padding-box'
    }
}));
var $df014fe6e70c2dc0$var$firstNodeWithNotMarginTopWithNestedDnD = (0, $74Zh5.css)((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, ".".concat((0, $fMtrl.TableSharedCssClassName).TABLE_CONTAINER, " > table,\n\t\t.").concat((0, $fMtrl.TableSharedCssClassName).TABLE_NODE_WRAPPER, " > table,\n\t\t.").concat((0, $fMtrl.TableSharedCssClassName).TABLE_STICKY_WRAPPER, " > table"), {
    '> tbody > tr > th, > tbody > tr > td': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
        '> :nth-child(1 of :not(style, .ProseMirror-gapcursor, .ProseMirror-widget, span))': {
            marginTop: 0
        }
    }
}));
var $df014fe6e70c2dc0$var$firstNodeWithNotMarginTop = (0, $74Zh5.css)((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, ".".concat((0, $fMtrl.TableSharedCssClassName).TABLE_CONTAINER, " > table,\n\t\t.").concat((0, $fMtrl.TableSharedCssClassName).TABLE_NODE_WRAPPER, " > table,\n\t\t.").concat((0, $fMtrl.TableSharedCssClassName).TABLE_STICKY_WRAPPER, " > table"), {
    '> tbody > tr > th, > tbody > tr > td': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
        '> :first-child:not(style), > style:first-child + *': {
            marginTop: 0
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
        '> .ProseMirror-gapcursor:first-child + *, > style:first-child + .ProseMirror-gapcursor + *': {
            marginTop: 0
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
        '> .ProseMirror-gapcursor:first-child + span + *, > style:first-child + .ProseMirror-gapcursor + span + *': {
            marginTop: 0
        }
    }
}));
var $df014fe6e70c2dc0$var$rendererTableStyles = (0, $74Zh5.css)((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, ".".concat((0, $53SBn.RendererCssClassName).DOCUMENT, " .").concat((0, $fMtrl.TableSharedCssClassName).TABLE_CONTAINER), (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({
    zIndex: 0,
    transition: "all 0.1s linear",
    display: 'flex' /* needed to avoid position: fixed jumpiness in Chrome */ 
}, "&.".concat((0, $c6bEO.shadowClassNames).RIGHT_SHADOW, "::after, &.").concat((0, $c6bEO.shadowClassNames).LEFT_SHADOW, "::before"), {
    top: "".concat((0, $fMtrl.tableMarginTop) - 1, "px"),
    height: "calc(100% - ".concat((0, $fMtrl.tableMarginTop), "px)"),
    zIndex: "".concat((0, $1LBcl.akEditorStickyHeaderZIndex)),
    width: "".concat($df014fe6e70c2dc0$var$tableShadowWidth, "px"),
    background: "linear-gradient(\n\t\t\t\t\tto left,\n\t\t\t\t\ttransparent 0,\n\t\t\t\t\t".concat("var(--ds-shadow-overflow-spread, ".concat((0, $d4dXm.N40A), ")"), " 140%\n\t\t\t\t),\n\t\t\t\tlinear-gradient(\n\t\t\t\t\tto right,\n\t\t\t\t\t", "var(--ds-shadow-overflow-perimeter, transparent)", " 0px,\n\t\t\t\t\ttransparent 1px\n\t\t\t\t)")
}), "&.".concat((0, $c6bEO.shadowClassNames).RIGHT_SHADOW, "::after"), {
    background: "linear-gradient(\n\t\t\t\t\tto right,\n\t\t\t\t\ttransparent 0,\n\t\t\t\t\t".concat("var(--ds-shadow-overflow-spread, ".concat((0, $d4dXm.N40A), ")"), " 140%\n\t\t\t\t),\n\t\t\t\tlinear-gradient(\n\t\t\t\t\tto left,\n\t\t\t\t\t", "var(--ds-shadow-overflow-perimeter, transparent)", " 0px,\n\t\t\t\t\ttransparent 1px\n\t\t\t\t)"),
    right: "0px"
}), "&\n          .".concat((0, $3ytat.shadowObserverClassNames).SENTINEL_LEFT, ",\n          &\n          .").concat((0, $3ytat.shadowObserverClassNames).SENTINEL_RIGHT), {
    height: "calc(100% - ".concat((0, $fMtrl.tableMarginTop), "px)")
})));
var $df014fe6e70c2dc0$var$stickyScrollbarStyles = (0, $74Zh5.css)((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, ".".concat((0, $53SBn.RendererCssClassName).DOCUMENT, " .").concat((0, $fMtrl.TableSharedCssClassName).TABLE_CONTAINER), (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({
    position: 'relative',
    flexDirection: 'column'
}, "> .".concat((0, $fMtrl.TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_CONTAINER), {
    width: '100%',
    display: 'block',
    visibility: 'hidden',
    overflowX: 'auto',
    position: 'sticky',
    bottom: "var(--ds-space-0, 0px)",
    zIndex: 1
}), "> .".concat((0, $fMtrl.TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_SENTINEL_BOTTOM, ",\n\t\t> .").concat((0, $fMtrl.TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_SENTINEL_TOP), {
    position: 'absolute',
    width: '100%',
    height: '1px',
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
    marginTop: '-1px',
    // need this to avoid sentinel being focused via keyboard
    // this still allows it to be detected by intersection observer
    visibility: 'hidden'
}), "> .".concat((0, $fMtrl.TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_SENTINEL_TOP), {
    top: "".concat($df014fe6e70c2dc0$var$tableRowHeight * 3, "px")
}), "> .".concat((0, $fMtrl.TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_SENTINEL_BOTTOM), {
    bottom: "var(--ds-space-250, 20px)" // MAX_BROWSER_SCROLLBAR_HEIGHT = 20;
})));
var $df014fe6e70c2dc0$var$rendererTableHeaderEqualHeightStylesForTableCellOnly = (0, $74Zh5.css)((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, ".".concat((0, $53SBn.RendererCssClassName).DOCUMENT, " .").concat((0, $fMtrl.TableSharedCssClassName).TABLE_CONTAINER), (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, ".".concat((0, $fMtrl.TableSharedCssClassName).TABLE_NODE_WRAPPER, " > table, .").concat((0, $fMtrl.TableSharedCssClassName).TABLE_STICKY_WRAPPER, " > table"), {
    height: '1px' /* will be ignored */ ,
    marginLeft: 0,
    marginRight: 0
})), ".".concat((0, $fMtrl.TableSharedCssClassName).TABLE_NODE_WRAPPER, " > table > tbody > tr:first-of-type, .").concat((0, $fMtrl.TableSharedCssClassName).TABLE_STICKY_WRAPPER, " > table > tbody > tr:first-of-type"), {
    height: '100%',
    'td, th': {
        position: 'relative'
    }
}));
var $df014fe6e70c2dc0$var$rendererTableSortableColumnStyles = (0, $74Zh5.css)((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, ".".concat((0, $53SBn.RendererCssClassName).DOCUMENT, " .").concat((0, $fMtrl.TableSharedCssClassName).TABLE_CONTAINER), (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, ".".concat((0, $fMtrl.TableSharedCssClassName).TABLE_NODE_WRAPPER, " > table, .").concat((0, $fMtrl.TableSharedCssClassName).TABLE_STICKY_WRAPPER, " > table"), (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, ".".concat((0, $53SBn.RendererCssClassName).SORTABLE_COLUMN_WRAPPER), (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({
    padding: 0
}, ".".concat((0, $53SBn.RendererCssClassName).SORTABLE_COLUMN), {
    width: '100%',
    height: '100%',
    padding: "".concat((0, $fMtrl.tableCellPadding), "px"),
    borderWidth: '1.5px',
    borderStyle: 'solid',
    borderColor: "transparent",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
    '> *:first-child': {
        marginTop: 0
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
    '> .ProseMirror-gapcursor:first-child + *, > style:first-child + .ProseMirror-gapcursor + *': {
        marginTop: 0
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
    '> .ProseMirror-gapcursor:first-child + span + *, > style:first-child + .ProseMirror-gapcursor + span + *': {
        marginTop: 0
    },
    '@supports selector(:focus-visible)': {
        '&:focus': {
            outline: 'unset'
        },
        '&:focus-visible': {
            borderColor: "".concat("var(--ds-border-focused, ".concat((0, $d4dXm.B300), ")"))
        }
    }
}), "> .".concat((0, $53SBn.RendererCssClassName).SORTABLE_COLUMN, " > .").concat((0, $53SBn.RendererCssClassName).SORTABLE_COLUMN_ICON_WRAPPER), (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({
    margin: 0
}, ".".concat((0, $4VBpm.SORTABLE_COLUMN_ICON_CLASSNAME)), {
    opacity: 1,
    transition: "opacity 0.2s ease-in-out"
})), "> .".concat((0, $53SBn.RendererCssClassName).SORTABLE_COLUMN, "\n\t\t\t\t\t\t> .").concat((0, $53SBn.RendererCssClassName).SORTABLE_COLUMN_NO_ORDER), (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, ".".concat((0, $4VBpm.SORTABLE_COLUMN_ICON_CLASSNAME)), {
    opacity: 0,
    '&:focus': {
        opacity: 1
    }
})), "&:hover:not(\n\t\t\t\t\t\t\t:has(\n\t\t\t\t\t\t\t\t\t.".concat((0, $53SBn.RendererCssClassName).SORTABLE_COLUMN_WRAPPER, "\n\t\t\t\t\t\t\t\t\t\t.").concat((0, $53SBn.RendererCssClassName).SORTABLE_COLUMN, ":hover\n\t\t\t\t\t\t\t\t)\n\t\t\t\t\t\t)\n\t\t\t\t\t\t> .").concat((0, $53SBn.RendererCssClassName).SORTABLE_COLUMN, "\n\t\t\t\t\t\t> .").concat((0, $53SBn.RendererCssClassName).SORTABLE_COLUMN_NO_ORDER), (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, ".".concat((0, $4VBpm.SORTABLE_COLUMN_ICON_CLASSNAME)), {
    opacity: 1
}))))));
var $df014fe6e70c2dc0$var$rendererTableColumnStyles = (0, $74Zh5.css)((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, ".".concat((0, $53SBn.RendererCssClassName).DOCUMENT, " .").concat((0, $fMtrl.TableSharedCssClassName).TABLE_CONTAINER), {
    'table[data-number-column="true"]': (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, ".".concat((0, $53SBn.RendererCssClassName).NUMBER_COLUMN), {
        backgroundColor: "var(--ds-background-accent-gray-subtlest, #F0F1F2)",
        borderRight: "var(--ds-border-width, 1px)".concat(" solid\n\t\t\t\t\t\t\t\t", "var(--ds-background-accent-gray-subtler, ".concat((0, $1LBcl.akEditorTableBorder), ")")),
        width: "".concat((0, $1LBcl.akEditorTableNumberColumnWidth), "px"),
        textAlign: 'center',
        color: "".concat("var(--ds-text-subtlest, ".concat((0, $d4dXm.N200), ")")),
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        fontSize: "".concat(0.875, " rem")
    }), ".fixed .".concat((0, $53SBn.RendererCssClassName).NUMBER_COLUMN), {
        borderRight: "0px none"
    })
}));
var $df014fe6e70c2dc0$var$rendererTableHeaderEqualHeightStylesAllowNestedHeaderLinks = (0, $74Zh5.css)((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, ".".concat((0, $53SBn.RendererCssClassName).DOCUMENT, " .").concat((0, $fMtrl.TableSharedCssClassName).TABLE_CONTAINER), (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, ".".concat((0, $fMtrl.TableSharedCssClassName).TABLE_NODE_WRAPPER, " > table, .").concat((0, $fMtrl.TableSharedCssClassName).TABLE_STICKY_WRAPPER, " > table"), (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, ".".concat((0, $53SBn.RendererCssClassName).SORTABLE_COLUMN_WRAPPER), (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, ".".concat((0, $53SBn.RendererCssClassName).SORTABLE_COLUMN), (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, ".".concat((0, $fq8Dd.HeadingAnchorWrapperClassName)), {
    position: 'unset'
}), '>', {
    'h1, h2, h3, h4, h5, h6': {
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
        marginRight: '30px'
    }
}))))));
// @ts-expect-error - throw TS error when use !import in position.
var $df014fe6e70c2dc0$var$stickyHeaderStyles = (0, $74Zh5.css)({
    'tr[data-header-row].fixed': {
        position: 'fixed !important',
        display: 'flex',
        overflow: 'hidden',
        zIndex: "".concat((0, $1LBcl.akEditorStickyHeaderZIndex)),
        borderRight: "var(--ds-border-width, 1px)".concat(" solid ", "var(--ds-background-accent-gray-subtler, ".concat((0, $1LBcl.akEditorTableBorder), ")")),
        borderBottom: "var(--ds-border-width, 1px)".concat(" solid ", "var(--ds-background-accent-gray-subtler, ".concat((0, $1LBcl.akEditorTableBorder), ")")),
        /* this is to compensate for the table border */ transform: 'translateX(-1px)'
    },
    '.sticky > th': {
        zIndex: "".concat((0, $1LBcl.akEditorStickyHeaderZIndex)),
        position: 'fixed !important',
        top: 0
    },
    /* Make the number column header sticky */ '.sticky > td': {
        position: 'fixed !important',
        top: 0
    },
    /* add border for position: sticky
  and work around background-clip: padding-box
  bug for FF causing box-shadow bug in Chrome */ '.sticky th, .sticky td': {
        boxShadow: "0px 1px ".concat("var(--ds-background-accent-gray-subtler, ".concat((0, $1LBcl.akEditorTableBorder), ")"), ",\n\t\t\t0px -0.5px ", "var(--ds-background-accent-gray-subtler, ".concat((0, $1LBcl.akEditorTableBorder), ")"), ",\n\t\t\tinset -1px 0px ", "var(--ds-background-accent-gray-subtler, ".concat((0, $1LBcl.akEditorTableToolbar), ")"), ",\n\t\t\t0px -1px ", "var(--ds-background-accent-gray-subtler, ".concat((0, $1LBcl.akEditorTableToolbar), ")"))
    },
    /* this will remove jumpiness caused in Chrome for sticky headers */ '.fixed + tr': {
        minHeight: '0px'
    }
});
var $df014fe6e70c2dc0$var$codeBlockAndLayoutStyles = (0, $74Zh5.css)((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({
    /*
   * We wrap CodeBlock in a grid to prevent it from overflowing the container of the renderer.
   * See ED-4159.
   */ '& .code-block': {
        maxWidth: '100%',
        display: 'block',
        position: 'relative',
        borderRadius: "var(--ds-radius-small, 3px)",
        /*
     * The overall renderer has word-wrap: break; which causes issues with
     * code block line numbers in Safari / iOS.
     */ wordWrap: 'normal'
    },
    '& .MediaGroup, & .code-block': {
        marginTop: "".concat((0, $1LBcl.blockNodesVerticalMargin)),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
        '&:first-child': {
            marginTop: 0
        }
    }
}, ".".concat((0, $53SBn.RendererCssClassName).DOCUMENT, "\n\t\t> .").concat((0, $7J4nJ.LightWeightCodeBlockCssClassName).CONTAINER, "\n\t\t.").concat((0, $knSf2.CodeBlockSharedCssClassName).CODEBLOCK_CONTAINER), {
    marginTop: (0, $1LBcl.blockNodesVerticalMargin)
}), '& [data-layout-section]', (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({
    marginTop: "var(--ds-space-250, 20px)",
    '& > div + div': {
        marginLeft: "var(--ds-space-400, 32px)"
    }
}, "@media screen and (max-width: ".concat((0, $1LBcl.gridMediumMaxWidth), "px)"), {
    '& > div + div': {
        marginLeft: 0
    }
}), '& .MediaGroup, & .code-block', {
    marginTop: (0, $1LBcl.blockNodesVerticalMargin),
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
    '&:first-child': {
        marginTop: 0
    }
})), '& li', {
    '> .code-block': {
        margin: "".concat((0, $1LBcl.blockNodesVerticalMargin), " 0 0 0")
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
    '> .code-block:first-child': {
        marginTop: 0
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
    '> div:last-of-type.code-block': {
        marginBottom: (0, $1LBcl.blockNodesVerticalMargin)
    }
}));
var $df014fe6e70c2dc0$var$layoutSectionForAdvancedLayoutsStyles = (0, $74Zh5.css)({
    '& [data-layout-section]': {
        '& > div + div': {
            marginLeft: 0
        }
    }
});
var $df014fe6e70c2dc0$var$gridRenderForCodeBlockStyles = (0, $74Zh5.css)({
    '& .code-block': {
        // removed old -ms- prefix, as grid is well supported for MS Edge
        display: 'grid',
        gridTemplateColumns: 'minmax(0, 1fr)',
        '& > span': {
            gridColumn: 1
        }
    }
});
// This prevents https://product-fabric.atlassian.net/browse/ED-20924
var $df014fe6e70c2dc0$var$codeBlockInListSafariFixStyles = (0, $74Zh5.css)((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, "&:not([data-node-type='decisionList']) > li,\n\t\t&:not(.".concat((0, $23e6e5ff8dd7ee19$export$4ccd31bf665a88f6).BLOCK_CARD_CONTAINER, ") > li"), (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({
    '&::before': {
        content: '" "',
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        lineHeight: (0, $1LBcl.akEditorLineHeight)
    }
}, "> p:first-child,\n\t\t\t> .code-block:first-child,\n\t\t\t> .ProseMirror-gapcursor:first-child + .code-block", {
    marginTop: "-".concat((0, $1LBcl.akEditorLineHeight), "em !important")
})));
var $df014fe6e70c2dc0$var$columnLayoutSharedStyle = (0, $74Zh5.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '[data-layout-section]': (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({
        position: 'relative',
        display: 'flex',
        flexDirection: 'row',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '& > *': {
            flex: 1,
            minWidth: 0
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '& > .unsupportedBlockView-content-wrap': {
            minWidth: 'initial'
        }
    }, "@media screen and (max-width: ".concat((0, $1LBcl.gridMediumMaxWidth), "px)"), {
        flexDirection: 'column'
    })
});
var $df014fe6e70c2dc0$var$columnLayoutResponsiveSharedStyle = (0, $74Zh5.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-layout-section]': {
        display: 'flex',
        flexDirection: 'row',
        gap: "var(--ds-space-100, 8px)",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '& > *': {
            flex: 1,
            minWidth: 0
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '& > .unsupportedBlockView-content-wrap': {
            minWidth: 'initial'
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.layout-section-container': {
        containerType: 'inline-size',
        containerName: 'layout-area'
    }
});
var $df014fe6e70c2dc0$var$columnLayoutResponsiveRendererStyles = (0, $74Zh5.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.layout-section-container [data-layout-section]': (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({
        gap: "var(--ds-space-600, 48px)"
    }, "@container layout-area (max-width: ".concat($df014fe6e70c2dc0$var$LAYOUT_BREAKPOINT_RENDERER, "px)"), {
        flexDirection: 'column',
        gap: "var(--ds-space-400, 32px)"
    })
});
var $df014fe6e70c2dc0$var$rendererAnnotationStyles = (0, $74Zh5.css)({
    "& [data-mark-type='annotation'][data-mark-annotation-state='active'] [data-annotation-mark], & [data-annotation-draft-mark][data-annotation-inline-node]": {
        background: "var(--ds-background-accent-yellow-subtler, ".concat((0, $d4dXm.Y75), ")"),
        borderBottom: "var(--ds-border-width-selected, 2px)".concat(" solid ", "var(--ds-border-accent-yellow, ".concat((0, $d4dXm.Y300), ")")),
        boxShadow: "var(--ds-shadow-overlay, ".concat("1px 2px 3px ".concat((0, $d4dXm.N60A), ", -1px 2px 3px ").concat((0, $d4dXm.N60A)), ")"),
        cursor: 'pointer',
        padding: "var(--ds-space-050, 4px)".concat(" ", "var(--ds-space-025, 2px)")
    }
});
var $df014fe6e70c2dc0$var$rendererAnnotationStylesCommentHeightFix = (0, $74Zh5.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '& [data-annotation-draft-mark][data-annotation-inline-node]': {
        borderBottom: "var(--ds-border-width-selected, 2px)".concat(" solid transparent"),
        cursor: 'pointer',
        padding: "1px 0 ".concat("var(--ds-space-025, 2px)"),
        background: "var(--ds-background-accent-yellow-subtler, ".concat((0, $d4dXm.Y75), ")"),
        borderBottomColor: "var(--ds-border-accent-yellow, ".concat((0, $d4dXm.Y300), ")"),
        boxShadow: "var(--ds-shadow-overlay, ".concat("1px 2px 3px ".concat((0, $d4dXm.N60A), ", -1px 2px 3px ").concat((0, $d4dXm.N60A)), ")")
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '& [data-annotation-draft-mark][data-annotation-inline-node][data-inline-card]': {
        padding: '5px 0 3px 0'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '& [data-annotation-draft-mark][data-annotation-inline-node].date-lozenger-container': {
        paddingTop: "var(--ds-space-025, 2px)"
    }
});
var $df014fe6e70c2dc0$var$RENDERER_LIST_DENSE_GAP = "max(0px,calc((var(--ak-renderer-base-font-size) - ".concat((0, $1LBcl.akEditorFullPageDenseFontSize), "px)* (4/3)))");
var $df014fe6e70c2dc0$var$TASKLIST_CONTAINER_DENSE_MARGIN = "max(calc(10px + (var(--ak-renderer-base-font-size) - ".concat((0, $1LBcl.akEditorFullPageDenseFontSize), "px) *( 2 / 3)))");
var $df014fe6e70c2dc0$var$scaledDenseEmojiStyles = (0, $74Zh5.css)((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, ".".concat((0, $ab7eec81c4bc28d0$export$ee47248f9a998789).EMOJI_IMAGE), {
    height: "".concat((0, $9DPK6.defaultDenseEmojiHeight), "px"),
    minHeight: "".concat((0, $9DPK6.defaultDenseEmojiHeight), "px"),
    minWidth: "".concat((0, $9DPK6.defaultDenseEmojiHeight), "px"),
    maxHeight: "".concat((0, $9DPK6.denseEmojiHeightH1), "px"),
    maxWidth: "".concat((0, $9DPK6.denseEmojiHeightH1), "px"),
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    img: {
        width: '100%',
        height: '100%',
        objectFit: 'contain'
    }
}), "h1 :is(.".concat((0, $ab7eec81c4bc28d0$export$ee47248f9a998789).EMOJI_IMAGE, ", .").concat((0, $ab7eec81c4bc28d0$export$ee47248f9a998789).EMOJI_SPRITE, ", .").concat((0, $ab7eec81c4bc28d0$export$ee47248f9a998789).EMOJI_PLACEHOLDER, ")"), {
    height: "".concat((0, $9DPK6.denseEmojiHeightH1), "px"),
    width: "".concat((0, $9DPK6.denseEmojiHeightH1), "px")
}), "h2 :is(.".concat((0, $ab7eec81c4bc28d0$export$ee47248f9a998789).EMOJI_IMAGE, ", .").concat((0, $ab7eec81c4bc28d0$export$ee47248f9a998789).EMOJI_SPRITE, ", .").concat((0, $ab7eec81c4bc28d0$export$ee47248f9a998789).EMOJI_PLACEHOLDER, ")"), {
    height: "".concat((0, $9DPK6.denseEmojiHeightH2), "px"),
    width: "".concat((0, $9DPK6.denseEmojiHeightH2), "px")
}), "h3 :is(.".concat((0, $ab7eec81c4bc28d0$export$ee47248f9a998789).EMOJI_IMAGE, ", .").concat((0, $ab7eec81c4bc28d0$export$ee47248f9a998789).EMOJI_SPRITE, ", .").concat((0, $ab7eec81c4bc28d0$export$ee47248f9a998789).EMOJI_PLACEHOLDER, ")"), {
    height: "".concat((0, $9DPK6.denseEmojiHeightH3), "px"),
    width: "".concat((0, $9DPK6.denseEmojiHeightH3), "px")
}), "h4 :is(.".concat((0, $ab7eec81c4bc28d0$export$ee47248f9a998789).EMOJI_IMAGE, ", .").concat((0, $ab7eec81c4bc28d0$export$ee47248f9a998789).EMOJI_SPRITE, ", .").concat((0, $ab7eec81c4bc28d0$export$ee47248f9a998789).EMOJI_PLACEHOLDER, ")"), {
    height: "".concat((0, $9DPK6.denseEmojiHeightH4), "px"),
    width: "".concat((0, $9DPK6.denseEmojiHeightH4), "px")
}), ":is(h5, h6, p) :is(.".concat((0, $ab7eec81c4bc28d0$export$ee47248f9a998789).EMOJI_IMAGE, ", .").concat((0, $ab7eec81c4bc28d0$export$ee47248f9a998789).EMOJI_SPRITE, ", .").concat((0, $ab7eec81c4bc28d0$export$ee47248f9a998789).EMOJI_PLACEHOLDER, ")"), {
    height: "".concat((0, $9DPK6.defaultDenseEmojiHeight), "px"),
    width: "".concat((0, $9DPK6.defaultDenseEmojiHeight), "px")
}));
var $df014fe6e70c2dc0$var$scaledEmojiStyles = (0, $74Zh5.css)((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, ".".concat((0, $ab7eec81c4bc28d0$export$ee47248f9a998789).EMOJI_IMAGE), {
    height: "".concat((0, $9DPK6.defaultEmojiHeight), "px"),
    minHeight: "".concat((0, $9DPK6.defaultEmojiHeight), "px"),
    minWidth: "".concat((0, $9DPK6.defaultEmojiHeight), "px"),
    maxHeight: "".concat((0, $9DPK6.scaledEmojiHeightH1), "px"),
    maxWidth: "".concat((0, $9DPK6.scaledEmojiHeightH1), "px"),
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    img: {
        width: '100%',
        height: '100%',
        objectFit: 'contain'
    }
}), "h1 :is(.".concat((0, $ab7eec81c4bc28d0$export$ee47248f9a998789).EMOJI_IMAGE, ", .").concat((0, $ab7eec81c4bc28d0$export$ee47248f9a998789).EMOJI_SPRITE, ", .").concat((0, $ab7eec81c4bc28d0$export$ee47248f9a998789).EMOJI_PLACEHOLDER, ")"), {
    height: "".concat((0, $9DPK6.scaledEmojiHeightH1), "px"),
    width: "".concat((0, $9DPK6.scaledEmojiHeightH1), "px")
}), "h2 :is(.".concat((0, $ab7eec81c4bc28d0$export$ee47248f9a998789).EMOJI_IMAGE, ", .").concat((0, $ab7eec81c4bc28d0$export$ee47248f9a998789).EMOJI_SPRITE, ", .").concat((0, $ab7eec81c4bc28d0$export$ee47248f9a998789).EMOJI_PLACEHOLDER, ")"), {
    height: "".concat((0, $9DPK6.scaledEmojiHeightH2), "px"),
    width: "".concat((0, $9DPK6.scaledEmojiHeightH2), "px")
}), "h3 :is(.".concat((0, $ab7eec81c4bc28d0$export$ee47248f9a998789).EMOJI_IMAGE, ", .").concat((0, $ab7eec81c4bc28d0$export$ee47248f9a998789).EMOJI_SPRITE, ", .").concat((0, $ab7eec81c4bc28d0$export$ee47248f9a998789).EMOJI_PLACEHOLDER, ")"), {
    height: "".concat((0, $9DPK6.scaledEmojiHeightH3), "px"),
    width: "".concat((0, $9DPK6.scaledEmojiHeightH3), "px")
}), "h4 :is(.".concat((0, $ab7eec81c4bc28d0$export$ee47248f9a998789).EMOJI_IMAGE, ", .").concat((0, $ab7eec81c4bc28d0$export$ee47248f9a998789).EMOJI_SPRITE, ", .").concat((0, $ab7eec81c4bc28d0$export$ee47248f9a998789).EMOJI_PLACEHOLDER, ")"), {
    height: "".concat((0, $9DPK6.scaledEmojiHeightH4), "px"),
    width: "".concat((0, $9DPK6.scaledEmojiHeightH4), "px")
}), ":is(h5, h6, p) :is(.".concat((0, $ab7eec81c4bc28d0$export$ee47248f9a998789).EMOJI_IMAGE, ", .").concat((0, $ab7eec81c4bc28d0$export$ee47248f9a998789).EMOJI_SPRITE, ", .").concat((0, $ab7eec81c4bc28d0$export$ee47248f9a998789).EMOJI_PLACEHOLDER, ")"), {
    height: "".concat((0, $9DPK6.defaultEmojiHeight), "px"),
    width: "".concat((0, $9DPK6.defaultEmojiHeight), "px")
}));
var $df014fe6e70c2dc0$var$denseStyles = (0, $74Zh5.css)((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))((0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))({}, ".".concat((0, $ab7eec81c4bc28d0$export$ee47248f9a998789).EMOJI_IMAGE), {
    height: "calc(".concat((0, $9DPK6.defaultEmojiHeight), " * var(--ak-renderer-base-font-size) / ").concat((0, $1LBcl.akEditorFullPageDefaultFontSize), ")"),
    width: "calc(".concat((0, $9DPK6.defaultEmojiHeight), " * var(--ak-renderer-base-font-size) / ").concat((0, $1LBcl.akEditorFullPageDefaultFontSize), ")"),
    maxHeight: "calc(".concat((0, $9DPK6.defaultEmojiHeight), " * var(--ak-renderer-base-font-size) / ").concat((0, $1LBcl.akEditorFullPageDefaultFontSize), ")"),
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    img: {
        width: '100%',
        height: '100%',
        objectFit: 'contain'
    }
}), ".".concat((0, $53SBn.RendererCssClassName).DOCUMENT, " .ak-editor-panel .ak-editor-panel__icon"), {
    height: "var(--ds-space-250, 20px)",
    width: "var(--ds-space-250, 20px)"
}), ".".concat((0, $53SBn.RendererCssClassName).DOCUMENT), {
    // Adjacent list items
    'li + li': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
        marginTop: $df014fe6e70c2dc0$var$RENDERER_LIST_DENSE_GAP
    },
    // Nested lists directly under an li (unordered and ordered)
    'li > ul, li > ol, .ak-ul li > ul, .ak-ul li > ol, .ak-ol li > ul, .ak-ol li > ol': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
        marginTop: $df014fe6e70c2dc0$var$RENDERER_LIST_DENSE_GAP
    },
    // Task lists
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-task-list-local-id]': {
        // Task lists: container top margin
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
        marginTop: $df014fe6e70c2dc0$var$TASKLIST_CONTAINER_DENSE_MARGIN
    },
    // Task lists: sibling items and nested lists
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-task-list-local-id] > * + *': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
        marginTop: $df014fe6e70c2dc0$var$RENDERER_LIST_DENSE_GAP
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-task-list-local-id] [data-task-list-local-id], [data-task-local-id] [data-task-local-id]': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
        marginTop: $df014fe6e70c2dc0$var$RENDERER_LIST_DENSE_GAP
    }
}));
var $df014fe6e70c2dc0$export$8f0929e72efe521f = function RendererStyleContainer(props) {
    var onClick = props.onClick, onMouseDown = props.onMouseDown, appearance = props.appearance, contentMode = props.contentMode, allowNestedHeaderLinks = props.allowNestedHeaderLinks, allowColumnSorting = props.allowColumnSorting, useBlockRenderForCodeBlock = props.useBlockRenderForCodeBlock, children = props.children, innerRef = props.innerRef, testId = props.testId;
    // Scroll to localId functionality
    (0, $ab9660a843f61d8b$export$b61745354f522fe)(innerRef, (0, $eqmEx.expValEqualsNoExposure)('platform_editor_block_menu', 'isEnabled', true));
    var isAdvancedLayoutsOn = (0, $fAhSf.editorExperiment)('advanced_layouts', true);
    var isPreviewPanelResponsivenessOn = (0, $fAhSf.editorExperiment)('platform_editor_preview_panel_responsiveness', true, {
        exposure: true
    });
    var isCompactModeSupported = (0, $drUcN.expValEquals)('cc_editor_ai_content_mode', 'variant', 'test') && (0, $9Zzpd.fg)('platform_editor_content_mode_button_mvp');
    var isCompactModeEnabled = contentMode === 'compact' && isCompactModeSupported;
    var baseFontSize = (0, $cc8a699f38d2ae23$export$8e2864079bc476bd)(appearance, contentMode);
    var browser = (0, $drUcN.expValEquals)('platform_editor_hydratable_ui', 'isEnabled', true) ? (0, $4vXmi.getBrowserInfo)() : (0, $4vXmi.browser);
    return(// eslint-disable-next-line @atlassian/a11y/click-events-have-key-events, @atlassian/a11y/interactive-element-not-keyboard-focusable, @atlassian/a11y/no-static-element-interactions
    (0, $74Zh5.jsx)("div", {
        ref: innerRef,
        onClick: onClick,
        onMouseDown: onMouseDown,
        style: {
            '--ak-renderer-base-font-size': "".concat(baseFontSize, "px"),
            '--ak-renderer-editor-font-heading-h1': "".concat((0, $381325189b6a639e$export$2e2bcd8739ae039)('editor.font.heading.h1')),
            '--ak-renderer-editor-font-heading-h2': "".concat((0, $381325189b6a639e$export$2e2bcd8739ae039)('editor.font.heading.h2')),
            '--ak-renderer-editor-font-heading-h3': "".concat((0, $381325189b6a639e$export$2e2bcd8739ae039)('editor.font.heading.h3')),
            '--ak-renderer-editor-font-heading-h4': "".concat((0, $381325189b6a639e$export$2e2bcd8739ae039)('editor.font.heading.h4')),
            '--ak-renderer-editor-font-heading-h5': "".concat((0, $381325189b6a639e$export$2e2bcd8739ae039)('editor.font.heading.h5')),
            '--ak-renderer-editor-font-heading-h6': "".concat((0, $381325189b6a639e$export$2e2bcd8739ae039)('editor.font.heading.h6')),
            '--ak-renderer-editor-font-normal-text': "".concat((0, $381325189b6a639e$export$2e2bcd8739ae039)('editor.font.body'))
        },
        css: [
            $df014fe6e70c2dc0$var$baseStyles,
            $df014fe6e70c2dc0$var$hideHeadingCopyLinkWrapperStyles,
            appearance === 'full-page' && isPreviewPanelResponsivenessOn && $df014fe6e70c2dc0$var$rendererFullPageStylesWithReducedPadding,
            appearance === 'full-page' && !isPreviewPanelResponsivenessOn && $df014fe6e70c2dc0$var$rendererFullPageStyles,
            appearance === 'full-width' && $df014fe6e70c2dc0$var$rendererFullWidthStyles,
            (appearance === 'full-width' || appearance === 'max' && (0, $drUcN.expValEquals)('editor_tinymce_full_width_mode', 'isEnabled', true)) && !(0, $8tCqL.isTableResizingEnabled)(appearance) && $df014fe6e70c2dc0$var$rendererFullWidthStylesForTableResizing,
            appearance === 'max' && (0, $drUcN.expValEquals)('editor_tinymce_full_width_mode', 'isEnabled', true) && $df014fe6e70c2dc0$var$rendererMaxWidthStyles,
            !(0, $9Zzpd.fg)('platform_editor_ai_generic_prep_for_aifc_2') && $df014fe6e70c2dc0$var$telepointerStyles,
            (0, $9Zzpd.fg)('platform_editor_ai_generic_prep_for_aifc_2') && $df014fe6e70c2dc0$var$rovoTelepointerStyles,
            $df014fe6e70c2dc0$var$whitespaceSharedStyles,
            $df014fe6e70c2dc0$var$blockquoteSharedStyles,
            (0, $9Zzpd.fg)('platform_editor_typography_ugc') ? $df014fe6e70c2dc0$var$headingsSharedStylesWithEditorUGC : $df014fe6e70c2dc0$var$headingsSharedStyles,
            $df014fe6e70c2dc0$var$headingWithAlignmentStyles,
            $df014fe6e70c2dc0$var$ruleSharedStyles,
            (contentMode === 'compact' || contentMode === 'dense') && isCompactModeSupported && $df014fe6e70c2dc0$var$extensionStyle,
            (0, $9Zzpd.fg)('platform_editor_typography_ugc') ? isCompactModeSupported ? $df014fe6e70c2dc0$var$paragraphStylesUGCScaledMargin : $df014fe6e70c2dc0$var$paragraphSharedStylesWithEditorUGC : isCompactModeSupported ? $df014fe6e70c2dc0$var$paragraphSharedStyleScaledMargin : $df014fe6e70c2dc0$var$paragraphSharedStyles,
            $df014fe6e70c2dc0$var$listsSharedStyles,
            browser.gecko && $df014fe6e70c2dc0$var$listsSharedStylesForGekko,
            $df014fe6e70c2dc0$var$indentationSharedStyles,
            (0, $9Zzpd.fg)('platform_editor__renderer_indentation_text_margin') && $df014fe6e70c2dc0$var$indentationSharedStylesWithMarginFix,
            $df014fe6e70c2dc0$var$blockMarksSharedStyles,
            $df014fe6e70c2dc0$var$codeMarkSharedStyles,
            $df014fe6e70c2dc0$var$shadowSharedStyle,
            $df014fe6e70c2dc0$var$dateSharedStyle,
            $df014fe6e70c2dc0$var$textColorStyles,
            $df014fe6e70c2dc0$var$backgroundColorStyles,
            (0, $drUcN.expValEquals)('platform_editor_text_highlight_padding', 'isEnabled', true) && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            $df014fe6e70c2dc0$export$a365082c2a191514,
            $df014fe6e70c2dc0$var$tasksAndDecisionsStyles,
            $df014fe6e70c2dc0$var$smartCardStyles,
            $df014fe6e70c2dc0$var$smartCardStylesAvatarFix,
            (0, $fAhSf.editorExperiment)('platform_editor_preview_panel_linking_exp', true) && $df014fe6e70c2dc0$var$headerSmartCardStyles,
            $df014fe6e70c2dc0$var$smartCardStylesAvatarMarginFix,
            $df014fe6e70c2dc0$var$smartCardStylesAvatarListZeroMarginTop,
            (0, $9Zzpd.fg)('editor_inline_comments_on_inline_nodes') && $df014fe6e70c2dc0$var$rendererAnnotationStyles,
            // eslint-disable-next-line @atlaskit/platform/no-preconditioning
            (0, $9Zzpd.fg)('editor_inline_comments_on_inline_nodes') && (0, $9Zzpd.fg)('annotations_align_editor_and_renderer_styles') && $df014fe6e70c2dc0$var$rendererAnnotationStylesCommentHeightFix,
            $df014fe6e70c2dc0$var$baseOtherStyles,
            allowNestedHeaderLinks && $df014fe6e70c2dc0$var$alignedHeadingAnchorStyle,
            $df014fe6e70c2dc0$var$mediaSingleSharedStyle,
            // merge firstWrappedMediaStyles with mediaSingleSharedStyle when clean up platform_editor_fix_media_in_renderer
            (0, $9Zzpd.fg)('platform_editor_fix_media_in_renderer') && $df014fe6e70c2dc0$var$firstWrappedMediaStyles,
            $df014fe6e70c2dc0$var$tableSharedStyle,
            $df014fe6e70c2dc0$var$tableRendererHeaderStylesForTableCellOnly,
            (0, $9Zzpd.fg)('platform_editor_bordered_panel_nested_in_table') && $df014fe6e70c2dc0$var$tableRendererNestedPanelStyles,
            $df014fe6e70c2dc0$var$isBackgroundClipBrowserFixNeeded() && $df014fe6e70c2dc0$var$tableStylesBackGroundClipForGeckoForTableCellOnly,
            (0, $9Zzpd.fg)('platform_editor_nested_dnd_styles_changes') ? $df014fe6e70c2dc0$var$firstNodeWithNotMarginTopWithNestedDnD : $df014fe6e70c2dc0$var$firstNodeWithNotMarginTop,
            $df014fe6e70c2dc0$var$rendererTableStyles,
            (0, $8tCqL.isStickyScrollbarEnabled)(appearance) && $df014fe6e70c2dc0$var$stickyScrollbarStyles,
            $df014fe6e70c2dc0$var$rendererTableHeaderEqualHeightStylesForTableCellOnly,
            allowColumnSorting && $df014fe6e70c2dc0$var$rendererTableSortableColumnStyles,
            allowColumnSorting && allowNestedHeaderLinks && $df014fe6e70c2dc0$var$rendererTableHeaderEqualHeightStylesAllowNestedHeaderLinks,
            $df014fe6e70c2dc0$var$rendererTableColumnStyles,
            $df014fe6e70c2dc0$var$stickyHeaderStyles,
            $df014fe6e70c2dc0$var$codeBlockAndLayoutStyles,
            $df014fe6e70c2dc0$var$columnLayoutSharedStyle,
            isAdvancedLayoutsOn && $df014fe6e70c2dc0$var$columnLayoutResponsiveSharedStyle,
            isAdvancedLayoutsOn && $df014fe6e70c2dc0$var$columnLayoutResponsiveRendererStyles,
            isAdvancedLayoutsOn && $df014fe6e70c2dc0$var$layoutSectionForAdvancedLayoutsStyles,
            !useBlockRenderForCodeBlock && $df014fe6e70c2dc0$var$gridRenderForCodeBlockStyles,
            browser.safari && $df014fe6e70c2dc0$var$codeBlockInListSafariFixStyles,
            appearance === 'full-page' && !isPreviewPanelResponsivenessOn && $df014fe6e70c2dc0$var$responsiveBreakoutWidth,
            appearance === 'full-page' && isPreviewPanelResponsivenessOn && $df014fe6e70c2dc0$var$responsiveBreakoutWidthWithReducedPadding,
            (appearance === 'full-width' || appearance === 'max' && (0, $drUcN.expValEquals)('editor_tinymce_full_width_mode', 'isEnabled', true)) && $df014fe6e70c2dc0$var$responsiveBreakoutWidthFullWidth,
            (0, $drUcN.expValEquals)('platform_editor_lovability_emoji_scaling', 'isEnabled', true) ? isCompactModeEnabled ? $df014fe6e70c2dc0$var$scaledDenseEmojiStyles : $df014fe6e70c2dc0$var$scaledEmojiStyles : isCompactModeEnabled ? $df014fe6e70c2dc0$var$denseStyles : undefined
        ],
        "data-testid": testId
    }, children));
};




var $25nEq = parcelRequire("25nEq");
function $2cbb530e7605fa73$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $2cbb530e7605fa73$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $2cbb530e7605fa73$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $2cbb530e7605fa73$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $2cbb530e7605fa73$export$c94cfc0c675062a1 = function removeEmptySpaceAroundContent(document) {
    // Check if the document is valid
    if (!document || !document.content || !Array.isArray(document.content)) return document;
    // Check if the node is a meaningful content node meaning it is not an empty paragraph or a paragraph with only whitespace
    var isMeaningfulContentNode = function isMeaningfulContentNode(node) {
        // Check if the node is a non-empty paragraph or a non-paragraph node
        if (node.type !== 'paragraph') return true;
        // If the paragraph is empty, return false
        if (!node.content || node.content.length === 0) return false;
        // Check if paragraph has any content other than `hardBreak` or whitespace text nodes
        return node.content.some(function(child) {
            return !((child === null || child === void 0 ? void 0 : child.type) === 'hardBreak' || (child === null || child === void 0 ? void 0 : child.type) === 'text' && typeof child.text === 'string' && child.text.trim() === '');
        });
    };
    var content = document.content;
    var firstContentIndex = -1;
    var lastContentIndex = -1;
    // Find the first and last paragraphs with content and check if they are meaningful
    for(var i = 0; i < content.length; i++)if (isMeaningfulContentNode(content[i])) {
        if (firstContentIndex === -1) firstContentIndex = i;
        lastContentIndex = i;
    }
    // If no content was found, return an empty document
    if (firstContentIndex === -1) return $2cbb530e7605fa73$var$_objectSpread($2cbb530e7605fa73$var$_objectSpread({}, document), {}, {
        content: []
    });
    // Slice the content array to include only paragraphs between the first and last content
    var trimmedContent = content.slice(firstContentIndex, lastContentIndex + 1);
    // Return a new document with the trimmed content
    return $2cbb530e7605fa73$var$_objectSpread($2cbb530e7605fa73$var$_objectSpread({}, document), {}, {
        content: trimmedContent
    });
};



var $iYJcE = parcelRequire("iYJcE");

var $5FkrB = parcelRequire("5FkrB");
function $7c9845e1179c85a2$export$80ffe7e3c6bf25c3(factory, propsDerivator, props) {
    // cache the last set of props
    var prev = (0, $5FkrB.useRef)(props);
    var prevFactory = (0, $5FkrB.useRef)(null);
    return (0, $5FkrB.useMemo)(function() {
        // check if the serializer is already created
        var shouldCreate = !prevFactory.current;
        // check each prop to see if value has changed and also check if the number of props has changed
        if (prev.current !== props) {
            var propsEntries = Object.entries(props);
            shouldCreate = propsEntries.length !== Object.keys(prev.current).length || propsEntries.some(function(_ref) {
                var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_ref, 2), key = _ref2[0], prop = _ref2[1];
                return prev.current[key] !== prop;
            });
        }
        prev.current = props;
        // If first time or any prop value has changed, create a new serializer
        if (shouldCreate) prevFactory.current = factory(propsDerivator(props));
        return prevFactory.current;
    }, // To keep deps consistent, here disable the exhaustive-deps rule to drop factory from the deps array
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        propsDerivator,
        props
    ]);
}



var $aOpeL = parcelRequire("aOpeL");

var $eqmEx = parcelRequire("eqmEx");

var $drUcN = parcelRequire("drUcN");

var $fC8ib = parcelRequire("fC8ib");

var $jJH6F = parcelRequire("jJH6F");var $cde71ec685ce28c3$export$a8d23193462f2b63 = /*#__PURE__*/ function(PLATFORMS) {
    PLATFORMS["NATIVE"] = "mobileNative";
    PLATFORMS["HYBRID"] = "mobileHybrid";
    PLATFORMS["WEB"] = "web";
    return PLATFORMS;
}({});
var $cde71ec685ce28c3$export$e48589d9e4824227 = /*#__PURE__*/ function(MODE) {
    MODE["RENDERER"] = "renderer";
    MODE["EDITOR"] = "editor";
    return MODE;
}({});
var $cde71ec685ce28c3$export$57453495b81e2dde = /*#__PURE__*/ function(FULL_WIDTH_MODE) {
    FULL_WIDTH_MODE["FIXED_WIDTH"] = "fixedWidth";
    FULL_WIDTH_MODE["FULL_WIDTH"] = "fullWidth";
    return FULL_WIDTH_MODE;
}({});
var $cde71ec685ce28c3$export$60a219cfaef9722 = /*#__PURE__*/ function(BROWSER_FREEZE_INTERACTION_TYPE) {
    BROWSER_FREEZE_INTERACTION_TYPE["LOADING"] = "loading";
    BROWSER_FREEZE_INTERACTION_TYPE["TYPING"] = "typing";
    BROWSER_FREEZE_INTERACTION_TYPE["CLICKING"] = "clicking";
    BROWSER_FREEZE_INTERACTION_TYPE["PASTING"] = "pasting";
    return BROWSER_FREEZE_INTERACTION_TYPE;
}({});

var $f850a3c9ea50a5db$export$1627223e090990cf = /*#__PURE__*/ function(TABLE_ACTION) {
    TABLE_ACTION["DELETED"] = "deleted";
    TABLE_ACTION["CLEARED"] = "cleared";
    TABLE_ACTION["COLLAPSED"] = "collapsed";
    TABLE_ACTION["MERGED"] = "merged";
    TABLE_ACTION["SPLIT"] = "split";
    TABLE_ACTION["COLORED"] = "colored";
    TABLE_ACTION["TOGGLED_HEADER_COLUMN"] = "toggledHeaderColumn";
    TABLE_ACTION["TOGGLED_HEADER_ROW"] = "toggledHeaderRow";
    TABLE_ACTION["TOGGLED_NUMBER_COLUMN"] = "toggledNumberColumn";
    TABLE_ACTION["CHANGED_BREAKOUT_MODE"] = "changedBreakoutMode";
    TABLE_ACTION["CUT"] = "cut";
    TABLE_ACTION["COPIED"] = "copied";
    TABLE_ACTION["ADDED_ROW"] = "addedRow";
    TABLE_ACTION["ADDED_COLUMN"] = "addedColumn";
    TABLE_ACTION["DELETED_ROW"] = "deletedRow";
    TABLE_ACTION["DELETED_COLUMN"] = "deletedColumn";
    TABLE_ACTION["SORTED_COLUMN"] = "sortedColumn";
    TABLE_ACTION["REPLACED"] = "replaced";
    TABLE_ACTION["ATTEMPTED_TABLE_WIDTH_CHANGE"] = "attemptedTableWidthChange";
    TABLE_ACTION["DISTRIBUTED_COLUMNS_WIDTHS"] = "distributedColumnsWidths";
    TABLE_ACTION["FIXED"] = "fixed";
    TABLE_ACTION["RESIZED"] = "resized";
    TABLE_ACTION["RESIZE_PERF_SAMPLING"] = "resizePerfSampling";
    TABLE_ACTION["COLUMN_RESIZED"] = "columnResized";
    TABLE_ACTION["OVERFLOW_CHANGED"] = "overflowChanged";
    TABLE_ACTION["INITIAL_OVERFLOW_CAPTURED"] = "initialOverflowCaptured";
    TABLE_ACTION["MOVED_ROW"] = "movedRow";
    TABLE_ACTION["MOVED_COLUMN"] = "movedColumn";
    TABLE_ACTION["CLONED_ROW"] = "clonedRow";
    TABLE_ACTION["CLONED_COLUMN"] = "clonedColumn";
    TABLE_ACTION["DRAG_MENU_OPENED"] = "dragMenuOpened";
    /**
   * This is a unique action that's used to track legacy table move behaviour flow of insert+copy+paste. Please use
   * the MOVED_ROW | MOVED_COLUMN actions if you want to track events which move row/cols in a single step.
   */ TABLE_ACTION["ROW_OR_COLUMN_MOVED"] = "rowOrColumnMoved";
    TABLE_ACTION["CHANGED_DISPLAY_MODE"] = "changedDisplayMode";
    TABLE_ACTION["CHANGED_ALIGNMENT"] = "changedAlignment";
    // Temporary to track usage of CONFCLOUD-78239 bug
    TABLE_ACTION["TABLE_CELL_BACKGROUND_FIXED"] = "tableCellBackgroundFixed";
    TABLE_ACTION["TABLE_WIDTH_INFO"] = "tableWidthInformation";
    TABLE_ACTION["TABLE_EDITOR_HEIGHT_INFO"] = "tableEditorHeightInformation";
    TABLE_ACTION["TABLE_RENDERER_HEIGHT_INFO"] = "tableRendererHeightInformation";
    TABLE_ACTION["STICKY_HEADER_METHOD_TOGGLED"] = "stickyHeaderMethodToggled";
    return TABLE_ACTION;
}({});
var $f850a3c9ea50a5db$export$6b0804bad09b61c6 = /*#__PURE__*/ function(TABLE_BREAKOUT) {
    TABLE_BREAKOUT["WIDE"] = "wide";
    TABLE_BREAKOUT["FULL_WIDTH"] = "fullWidth";
    TABLE_BREAKOUT["NORMAL"] = "normal";
    return TABLE_BREAKOUT;
}({});
var $f850a3c9ea50a5db$export$e0b2ad636c1c8ab4 = /*#__PURE__*/ function(TABLE_OVERFLOW_CHANGE_TRIGGER) {
    TABLE_OVERFLOW_CHANGE_TRIGGER["EXTERNAL"] = "external";
    TABLE_OVERFLOW_CHANGE_TRIGGER["ADDED_COLUMN"] = "addedColumn";
    TABLE_OVERFLOW_CHANGE_TRIGGER["DELETED_COLUMN"] = "deletedColumn";
    TABLE_OVERFLOW_CHANGE_TRIGGER["RESIZED_COLUMN"] = "resizedColumn";
    TABLE_OVERFLOW_CHANGE_TRIGGER["ENABLED_NUMBERED_COLUMN"] = "enabledNumberedColumn";
    TABLE_OVERFLOW_CHANGE_TRIGGER["DISABLED_NUMBERED_COLUMN"] = "disabledNumberedColumn";
    TABLE_OVERFLOW_CHANGE_TRIGGER["DISTRIBUTED_COLUMNS"] = "distributedColumnsWidths";
    TABLE_OVERFLOW_CHANGE_TRIGGER["RESIZED"] = "resizedTable";
    return TABLE_OVERFLOW_CHANGE_TRIGGER;
}({});
var $f850a3c9ea50a5db$export$90dde066fa32cf2f = /*#__PURE__*/ function(TABLE_STATUS) {
    TABLE_STATUS["SUCCESS"] = "success";
    TABLE_STATUS["CANCELLED"] = "cancelled";
    TABLE_STATUS["INVALID"] = "invalid";
    return TABLE_STATUS;
}({});
var $f850a3c9ea50a5db$export$a62a68f32aa71693 = /*#__PURE__*/ function(TABLE_DISPLAY_MODE) {
    TABLE_DISPLAY_MODE["FIXED"] = "fixed";
    TABLE_DISPLAY_MODE["DEFAULT"] = "default";
    TABLE_DISPLAY_MODE["INITIAL"] = "initial";
    return TABLE_DISPLAY_MODE;
}({});
var $f850a3c9ea50a5db$export$ba2dfc055a59d951 = /*#__PURE__*/ function(CHANGE_ALIGNMENT_REASON) {
    CHANGE_ALIGNMENT_REASON["TABLE_RESIZING"] = "tableResizing";
    CHANGE_ALIGNMENT_REASON["TABLE_COLUMN_RESIZED"] = "tableColumnResized";
    CHANGE_ALIGNMENT_REASON["EDITOR_APPEARANCE_CHANGED"] = "editorAppearanceChanged";
    CHANGE_ALIGNMENT_REASON["TOOLBAR_OPTION_CHANGED"] = "toolbarOptionChanged";
    return CHANGE_ALIGNMENT_REASON;
}({});



var $6daa18ee83e5c8bd$export$208d2421b73f3f86 = function getWidthInfoPayload(renderer) {
    var tablesInfo = [];
    var tableWrappers = renderer.querySelectorAll('.pm-table-wrapper');
    // only send the event if there are tables on the page
    if (tableWrappers.length === 0) return undefined;
    tableWrappers.forEach(function(tableWrapper) {
        var table = tableWrapper.querySelector(':scope > table');
        if (table) {
            var isNestedTable = Boolean(table.closest('td, th'));
            tablesInfo.push({
                tableWidth: table.scrollWidth,
                hasScrollbar: tableWrapper.clientWidth < table.scrollWidth,
                isNestedTable: isNestedTable
            });
        }
    });
    var maxTableWidth = Math.max.apply(Math, (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(tablesInfo.map(function(table) {
        return table.tableWidth;
    })));
    var editorWidth = renderer.scrollWidth;
    return {
        action: (0, $f850a3c9ea50a5db$export$1627223e090990cf).TABLE_WIDTH_INFO,
        actionSubject: (0, $jJH6F.ACTION_SUBJECT).TABLE,
        attributes: {
            editorWidth: editorWidth,
            editorWidthBreakpoint: (0, $577d48613d9afb24$export$afdcbbd112676ca8)(editorWidth),
            tableWidthInfo: tablesInfo,
            maxTableWidthBreakpoint: (0, $577d48613d9afb24$export$afdcbbd112676ca8)(maxTableWidth),
            hasTableWiderThanEditor: maxTableWidth > editorWidth,
            hasTableWithScrollbar: tablesInfo.some(function(table) {
                return table.hasScrollbar;
            }),
            mode: (0, $cde71ec685ce28c3$export$e48589d9e4824227).RENDERER
        },
        eventType: (0, $jJH6F.EVENT_TYPE).OPERATIONAL
    };
};
var $6daa18ee83e5c8bd$export$34e5b28c67455a81 = function getHeightInfoPayload(renderer) {
    var tablesInfo = [];
    var tableWrappers = renderer.querySelectorAll('.pm-table-wrapper');
    // only send the event if there are tables on the page
    if (tableWrappers.length === 0) return undefined;
    tableWrappers.forEach(function(tableWrapper) {
        var table = tableWrapper.querySelector(':scope > table');
        if (table) {
            var isNestedTable = Boolean(table.closest('td, th'));
            tablesInfo.push({
                tableHeight: table.scrollHeight,
                isNestedTable: isNestedTable
            });
        }
    });
    var maxTableHeight = Math.max.apply(Math, (0, (/*@__PURE__*/$parcel$interopDefault($fC8ib)))(tablesInfo.map(function(table) {
        return table.tableHeight;
    })));
    /** NOTE: Renderer is not scrollable, so this height represents the height of the content */ var rendererClientHeight = renderer.clientHeight;
    var viewportHeight = window.innerHeight;
    if (!viewportHeight) return undefined;
    return {
        action: (0, $f850a3c9ea50a5db$export$1627223e090990cf).TABLE_RENDERER_HEIGHT_INFO,
        actionSubject: (0, $jJH6F.ACTION_SUBJECT).TABLE,
        attributes: {
            viewportHeight: viewportHeight,
            rendererHeight: rendererClientHeight,
            maxTableHeight: maxTableHeight,
            maxTableToViewportHeightRatio: maxTableHeight / viewportHeight,
            tableHeightInfo: tablesInfo
        },
        eventType: (0, $jJH6F.EVENT_TYPE).OPERATIONAL
    };
};


var $303ba37d2d9486ca$var$_excluded = [
    "portal"
];
function $303ba37d2d9486ca$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $303ba37d2d9486ca$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $303ba37d2d9486ca$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $303ba37d2d9486ca$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $303ba37d2d9486ca$export$47b2879ca9bbf67a = 2000;
var $303ba37d2d9486ca$export$1b622068be977101 = 3000;
// we want to calculate all the table widths (which causes reflows) after the renderer has finished loading to mitigate performance impact
var $303ba37d2d9486ca$var$TABLE_INFO_TIMEOUT = 10000;
var $303ba37d2d9486ca$var$packageName = "@atlaskit/renderer";
var $303ba37d2d9486ca$var$packageVersion = "0.0.0-development";
var $303ba37d2d9486ca$var$setAsQueryContainerStyles = (0, $74Zh5.css)({
    containerName: 'ak-renderer-wrapper',
    containerType: 'inline-size'
});
var $303ba37d2d9486ca$var$handleMouseTripleClickInTables = function handleMouseTripleClickInTables(event) {
    var _parentElement, _parentElement2;
    var browser = (0, $drUcN.expValEquals)('platform_editor_hydratable_ui', 'isEnabled', true) ? (0, $4vXmi.getBrowserInfo)() : (0, $4vXmi.browser);
    if (browser.ios || browser.android) return;
    var badBrowser = browser.chrome || browser.safari;
    var tripleClick = event.detail >= 3;
    if (!(badBrowser && tripleClick)) return;
    var selection = window.getSelection();
    if (!selection) return;
    var type = selection.type, anchorNode = selection.anchorNode, focusNode = selection.focusNode;
    var rangeSelection = Boolean(type === 'Range' && anchorNode && focusNode);
    if (!rangeSelection) return;
    // Ignored via go/ees005
    // eslint-disable-next-line @atlaskit/editor/no-as-casting
    var target = event.target;
    var tableCell = target.closest('td,th');
    var clickedInCell = Boolean(tableCell);
    if (!clickedInCell) return;
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    var anchorInCell = tableCell.contains(anchorNode);
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    var focusInCell = tableCell.contains(focusNode);
    var selectionStartsOrEndsOutsideClickedCell = !(anchorInCell && focusInCell);
    if (!selectionStartsOrEndsOutsideClickedCell) return;
    // Ensure that selecting text in the renderer doesn't trigger onUnhandledClick
    // This logic originated in jira-frontend:
    // src/packages/issue/issue-view/src/views/field/rich-text/rich-text-inline-edit-view.js
    // The selection is required to be checked in `onMouseDown` and here. If not here, a new
    // selection isn't reported; if not in `onMouseDown`, a click outside the selection will
    // return an empty selection, which will erroneously fire onUnhandledClick.
    var elementToSelect = anchorInCell ? // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (_parentElement = anchorNode.parentElement) === null || _parentElement === void 0 ? void 0 : _parentElement.closest('div,p') : focusInCell ? // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (_parentElement2 = focusNode.parentElement) === null || _parentElement2 === void 0 ? void 0 : _parentElement2.closest('div,p') : tableCell;
    if (elementToSelect) selection.selectAllChildren(elementToSelect);
};
/**
 * Handle clicks inside renderer. If the click isn't on media, in the media picker, or on a
 * link, call the onUnhandledClick eventHandler (which in Jira for example, may switch the
 * renderer out for the editor).
 * @param event Click event anywhere inside renderer
 * @param props
 * @param mouseDownSelection
 * @example
 */ var $303ba37d2d9486ca$var$handleWrapperOnClick = function handleWrapperOnClick(event, props, mouseDownSelection) {
    var _props$eventHandlers;
    // Ignored via go/ees005
    // eslint-disable-next-line @atlaskit/editor/no-as-casting
    var targetElement = event.target;
    $303ba37d2d9486ca$var$handleMouseTripleClickInTables(event);
    // ED-14862: When a user triple clicks to select a line of content inside a
    // a table cell, but the browser incorrectly moves the selection start or end into
    // a different table cell, we manually set the selection back to within the original
    // table cell the user intended to target
    if (!((_props$eventHandlers = props.eventHandlers) !== null && _props$eventHandlers !== void 0 && _props$eventHandlers.onUnhandledClick)) return;
    if (!(targetElement instanceof window.Element)) return;
    // Ignored via go/ees005
    // eslint-disable-next-line @atlaskit/editor/no-as-casting
    var rendererWrapper = event.currentTarget;
    var isInteractiveElementInTree = (0, $9F9pG.findInTree)(targetElement, rendererWrapper, (0, $06b5438107d56029$export$3dee5e4542c672d9));
    if (isInteractiveElementInTree) return;
    // Ensure that selecting text in the renderer doesn't trigger onUnhandledClick
    // This logic originated in jira-frontend:
    // src/packages/issue/issue-view/src/views/field/rich-text/rich-text-inline-edit-view.js
    // The selection is required to be checked in `onMouseDown` and here. If not here, a new
    // selection isn't reported; if not in `onMouseDown`, a click outside the selection will
    // return an empty selection, which will erroneously fire onUnhandledClick.
    var windowSelection = window.getSelection();
    var selection = windowSelection !== null ? windowSelection.toString() : undefined;
    var hasSelection = selection && selection.length !== 0;
    var hasSelectionMouseDown = mouseDownSelection.current && mouseDownSelection.current.length !== 0;
    var allowEditBasedOnSelection = !hasSelection && !hasSelectionMouseDown;
    if (allowEditBasedOnSelection) props.eventHandlers.onUnhandledClick(event);
};
var $303ba37d2d9486ca$export$c49fe2316038f3c2 = function RendererFunctionalComponent(props) {
    var createAnalyticsEvent = props.createAnalyticsEvent;
    var mouseDownSelection = (0, $5FkrB.useRef)(undefined);
    var providerFactory = (0, $5FkrB.useMemo)(function() {
        return props.dataProviders || new (0, $fBC68.default)();
    }, [
        props.dataProviders
    ]);
    var _useRendererContext = (0, $ky5Ao.useRendererContext)(), parentContextContentMode = _useRendererContext.contentMode;
    var createRendererContext = (0, $5FkrB.useMemo)(function() {
        return function(featureFlags, isTopLevelRenderer, contentMode) {
            var normalizedFeatureFlags = (0, $e3d31a87077225d6$export$f1485fc4974593c0)(featureFlags);
            return $303ba37d2d9486ca$var$_objectSpread({
                featureFlags: normalizedFeatureFlags,
                isTopLevelRenderer: isTopLevelRenderer === undefined
            }, (0, $9Zzpd.fg)('platform_editor_content_mode_render_context') && {
                contentMode: contentMode || parentContextContentMode
            });
        };
    }, [
        parentContextContentMode
    ]);
    var fireAnalyticsEventOld = (0, $5FkrB.useCallback)(function(event) {
        var createAnalyticsEvent = props.createAnalyticsEvent;
        if (createAnalyticsEvent) {
            var channel = (0, $2H1dZ.FabricChannel).editor;
            createAnalyticsEvent(event).fire(channel);
        }
    }, [
        props
    ]);
    var fireAnalyticsEventNew = (0, $5FkrB.useCallback)(function(event) {
        if (createAnalyticsEvent) {
            var channel = (0, $2H1dZ.FabricChannel).editor;
            createAnalyticsEvent(event).fire(channel);
        }
    }, [
        createAnalyticsEvent
    ]);
    var _fireAnalyticsEvent = (0, $fAhSf.editorExperiment)('platform_renderer_fix_analytics_memo_callback', true, {
        exposure: true
    }) ? fireAnalyticsEventNew : fireAnalyticsEventOld;
    var deriveSerializerProps = (0, $5FkrB.useCallback)(function(props) {
        var _props$startPos;
        var stickyHeaders = props.stickyHeaders ? props.stickyHeaders === true ? {} : props.stickyHeaders : undefined;
        var annotationProvider = props.annotationProvider;
        var allowAnnotationsDraftMode = Boolean(annotationProvider && annotationProvider.inlineComment && annotationProvider.inlineComment.allowDraftMode);
        var _createRendererContex = createRendererContext(props.featureFlags, props.isTopLevelRenderer, props.contentMode), featureFlags = _createRendererContex.featureFlags;
        return {
            startPos: (_props$startPos = props.startPos) !== null && _props$startPos !== void 0 ? _props$startPos : 0,
            providers: providerFactory,
            eventHandlers: props.eventHandlers,
            extensionHandlers: props.extensionHandlers,
            portal: props.portal,
            objectContext: $303ba37d2d9486ca$var$_objectSpread({
                adDoc: props.shouldRemoveEmptySpaceAroundContent ? (0, $2cbb530e7605fa73$export$c94cfc0c675062a1)(props.document) : props.document,
                schema: props.schema
            }, props.rendererContext),
            appearance: props.appearance,
            contentMode: props.contentMode,
            onSetLinkTarget: props.onSetLinkTarget,
            disableHeadingIDs: props.disableHeadingIDs,
            disableActions: props.disableActions,
            allowHeadingAnchorLinks: props.allowHeadingAnchorLinks,
            allowColumnSorting: props.allowColumnSorting,
            fireAnalyticsEvent: _fireAnalyticsEvent,
            shouldOpenMediaViewer: props.shouldOpenMediaViewer,
            allowAltTextOnImages: props.allowAltTextOnImages,
            stickyHeaders: stickyHeaders,
            allowMediaLinking: props.media && props.media.allowLinking,
            surroundTextNodesWithTextWrapper: allowAnnotationsDraftMode,
            media: props.media,
            emojiResourceConfig: props.emojiResourceConfig,
            smartLinks: props.smartLinks,
            extensionViewportSizes: props.extensionViewportSizes,
            getExtensionHeight: props.getExtensionHeight,
            allowCopyToClipboard: props.allowCopyToClipboard,
            allowWrapCodeBlock: props.allowWrapCodeBlock,
            allowCustomPanels: props.allowCustomPanels,
            allowAnnotations: props.allowAnnotations,
            allowSelectAllTrap: props.allowSelectAllTrap,
            allowPlaceholderText: props.allowPlaceholderText,
            nodeComponents: props.nodeComponents,
            allowWindowedCodeBlock: featureFlags === null || featureFlags === void 0 ? void 0 : featureFlags.allowWindowedCodeBlock,
            isInsideOfInlineExtension: props.isInsideOfInlineExtension,
            isPresentational: props.UNSTABLE_isPresentational,
            textHighlighter: props.textHighlighter || props.UNSTABLE_textHighlighter,
            allowTableAlignment: props.UNSTABLE_allowTableAlignment,
            allowTableResizing: props.UNSTABLE_allowTableResizing,
            disableTableOverflowShadow: props.disableTableOverflowShadow
        };
    }, [
        createRendererContext,
        providerFactory,
        _fireAnalyticsEvent
    ]);
    var serializer = (0, $7c9845e1179c85a2$export$80ffe7e3c6bf25c3)(function(serializerProps) {
        var _props$createSerializ, _props$createSerializ2;
        return (_props$createSerializ = (_props$createSerializ2 = props.createSerializer) === null || _props$createSerializ2 === void 0 ? void 0 : _props$createSerializ2.call(props, serializerProps)) !== null && _props$createSerializ !== void 0 ? _props$createSerializ : new (0, $412c6966035531bf$export$2e2bcd8739ae039)(serializerProps);
    }, deriveSerializerProps, props);
    var localRef = (0, $5FkrB.useRef)(null);
    var editorRef = props.innerRef || localRef;
    // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
    var id = (0, $5FkrB.useMemo)(function() {
        return (0, $6JfQX.default)();
    }, []);
    var renderedMeasurementDistortedDurationMonitor = (0, $5FkrB.useMemo)(function() {
        return (0, $6f06f484c7500059$export$70f7d127254a90c)();
    }, []);
    // we are doing this to ensure it runs as
    // early as possible in the React lifecycle
    // to avoid any other side effects
    var measureStarted = (0, $5FkrB.useRef)(false);
    var startAnalyticsMeasure = function startAnalyticsMeasure() {
        (0, $f3813def174ce227$export$b62aa2130c86b59b)("Renderer Render Time: ".concat(id));
    };
    if (!measureStarted.current) {
        startAnalyticsMeasure();
        measureStarted.current = true;
    }
    var anchorLinkAnalytics = (0, $5FkrB.useCallback)(function() {
        var hash = window.location.hash && decodeURIComponent(window.location.hash.slice(1));
        var disableHeadingIDs = props.disableHeadingIDs;
        if (!disableHeadingIDs && hash && editorRef && editorRef.current instanceof HTMLElement) {
            var anchorLinkElement = document.getElementById(hash);
            if (anchorLinkElement && editorRef.current.contains(anchorLinkElement)) _fireAnalyticsEvent({
                action: (0, $jJH6F.ACTION).VIEWED,
                actionSubject: (0, $jJH6F.ACTION_SUBJECT).ANCHOR_LINK,
                attributes: {
                    platform: (0, $aP6HU.PLATFORM).WEB,
                    mode: (0, $aP6HU.MODE).RENDERER
                },
                eventType: (0, $jJH6F.EVENT_TYPE).UI
            });
        }
    }, [
        props.disableHeadingIDs,
        editorRef,
        _fireAnalyticsEvent
    ]);
    var getSchema = (0, $5FkrB.useMemo)(function() {
        return function(schema, adfStage) {
            if (schema) return schema;
            return (0, $kYLlQ.getSchemaBasedOnStage)(adfStage);
        };
    }, []);
    var onMouseDownEditView = function onMouseDownEditView() {
        var windowSelection = window.getSelection();
        mouseDownSelection.current = windowSelection !== null ? windowSelection.toString() : undefined;
    };
    var dataProviders = props.dataProviders, analyticsEventSeverityTracking = props.analyticsEventSeverityTracking;
    (0, $5FkrB.useEffect)(function() {
        var rafID;
        var heightWidthAnalyticsSetTimeoutID;
        var heightWidthAnalyticsRicID;
        var heightWidthAnalyticsRafID;
        var handleAnalytics = function handleAnalytics() {
            _fireAnalyticsEvent({
                action: (0, $jJH6F.ACTION).STARTED,
                actionSubject: (0, $jJH6F.ACTION_SUBJECT).RENDERER,
                attributes: {
                    platform: (0, $aP6HU.PLATFORM).WEB
                },
                eventType: (0, $jJH6F.EVENT_TYPE).UI
            });
            rafID = requestAnimationFrame(function() {
                (0, $f3813def174ce227$export$37c25be427bec097)("Renderer Render Time: ".concat(id), function(duration) {
                    var _analyticsEventSeveri, _analyticsEventSeveri2;
                    var forceSeverityTracking = typeof analyticsEventSeverityTracking === 'undefined' && (0, $52c73f50bcd8b255$export$5b59d3e9e22dbdc6)();
                    var severity = !!forceSeverityTracking || analyticsEventSeverityTracking !== null && analyticsEventSeverityTracking !== void 0 && analyticsEventSeverityTracking.enabled ? (0, $577d48613d9afb24$export$f8edd689e8b20f3a)(duration, (_analyticsEventSeveri = analyticsEventSeverityTracking === null || analyticsEventSeverityTracking === void 0 ? void 0 : analyticsEventSeverityTracking.severityNormalThreshold) !== null && _analyticsEventSeveri !== void 0 ? _analyticsEventSeveri : $303ba37d2d9486ca$export$47b2879ca9bbf67a, (_analyticsEventSeveri2 = analyticsEventSeverityTracking === null || analyticsEventSeverityTracking === void 0 ? void 0 : analyticsEventSeverityTracking.severityDegradedThreshold) !== null && _analyticsEventSeveri2 !== void 0 ? _analyticsEventSeveri2 : $303ba37d2d9486ca$export$1b622068be977101) : undefined;
                    var isTTRTrackingExplicitlyDisabled = (analyticsEventSeverityTracking === null || analyticsEventSeverityTracking === void 0 ? void 0 : analyticsEventSeverityTracking.enabled) === false;
                    if (!isTTRTrackingExplicitlyDisabled) _fireAnalyticsEvent({
                        action: (0, $jJH6F.ACTION).RENDERED,
                        actionSubject: (0, $jJH6F.ACTION_SUBJECT).RENDERER,
                        attributes: {
                            platform: (0, $aP6HU.PLATFORM).WEB,
                            duration: duration,
                            // Ignored via go/ees005
                            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                            distortedDuration: renderedMeasurementDistortedDurationMonitor.distortedDuration,
                            ttfb: (0, $1cacfa6421e59bfa$export$92d097a1155bbe27)(),
                            nodes: (0, $85fdf1d409f20456$export$1daf15cbaf649dad)(props.document),
                            severity: severity
                        },
                        eventType: (0, $jJH6F.EVENT_TYPE).OPERATIONAL
                    });
                    // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    renderedMeasurementDistortedDurationMonitor.cleanup();
                });
                anchorLinkAnalytics();
            });
            if ((0, $drUcN.expValEquals)('platform_editor_editor_width_analytics', 'isEnabled', true)) // send statistics about the heights/widths of the tables on the page for alerting
            heightWidthAnalyticsSetTimeoutID = setTimeout(function() {
                var requestIdleCallbackFn = function requestIdleCallbackFn() {
                    var _props$innerRef;
                    var renderer = (_props$innerRef = props.innerRef) === null || _props$innerRef === void 0 || (_props$innerRef = _props$innerRef.current) === null || _props$innerRef === void 0 ? void 0 : _props$innerRef.querySelector('.ak-renderer-document');
                    if (renderer) {
                        var payload = (0, $6daa18ee83e5c8bd$export$208d2421b73f3f86)(renderer);
                        if (payload) _fireAnalyticsEvent(payload);
                        if ((0, $9Zzpd.fg)('platform_editor_table_height_analytics_event')) {
                            var payloadHeight = (0, $6daa18ee83e5c8bd$export$34e5b28c67455a81)(renderer);
                            if (payloadHeight) _fireAnalyticsEvent(payloadHeight);
                        }
                    }
                };
                if (window && typeof window.requestIdleCallback === 'function') heightWidthAnalyticsRicID = window.requestIdleCallback(requestIdleCallbackFn);
                else if (window && typeof window.requestAnimationFrame === 'function') // requestIdleCallback is not supported in safari, fallback to requestAnimationFrame
                heightWidthAnalyticsRafID = window.requestAnimationFrame(requestIdleCallbackFn);
            }, $303ba37d2d9486ca$var$TABLE_INFO_TIMEOUT);
        };
        handleAnalytics();
        return function() {
            if (rafID) window.cancelAnimationFrame(rafID);
            if (heightWidthAnalyticsSetTimeoutID) window.clearTimeout(heightWidthAnalyticsSetTimeoutID);
            if (heightWidthAnalyticsRafID) window.cancelAnimationFrame(heightWidthAnalyticsRafID);
            if (heightWidthAnalyticsRicID) window.cancelIdleCallback(heightWidthAnalyticsRicID);
            // if this is the ProviderFactory which was created in constructor
            // it's safe to destroy it on Renderer unmount
            // updated to match existing class component
            if (!dataProviders) providerFactory.destroy();
        };
    // we are going to ignore this because I'm doing this on purpose
    // having a dependency array means we run stopMeasure twice per render
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    var rendererContext = (0, $5FkrB.useMemo)(function() {
        return createRendererContext(props.featureFlags, props.isTopLevelRenderer, props.contentMode);
    }, [
        props.featureFlags,
        props.isTopLevelRenderer,
        createRendererContext,
        props.contentMode
    ]);
    try {
        var _rendererContext$feat, _props$media;
        var schema = getSchema(props.schema, props.adfStage);
        var _renderDocument = (0, $2071b3d80d22d00f$export$59a54f98b9753d5c)(props.shouldRemoveEmptySpaceAroundContent ? (0, $2cbb530e7605fa73$export$c94cfc0c675062a1)(props.document) : props.document, serializer, schema, props.adfStage, props.useSpecBasedValidator, id, _fireAnalyticsEvent, props.unsupportedContentLevelsTracking, props.appearance, props.includeNodesCountInStats, props.skipValidation, props.validationOverrides), result = _renderDocument.result, stat = _renderDocument.stat, pmDoc = _renderDocument.pmDoc;
        if (props.onComplete) props.onComplete(stat);
        var rendererOutput = (0, $74Zh5.jsx)((0, $ky5Ao.RendererContextProvider), {
            value: rendererContext
        }, (0, $74Zh5.jsx)((0, $lVo0h.ActiveHeaderIdProvider), {
            value: (0, $e382f311073cdba5$export$acb253d79d72af92)(props.allowHeadingAnchorLinks)
        }, (0, $74Zh5.jsx)((0, $gPdZj.default).Provider, {
            value: {
                fireAnalyticsEvent: function fireAnalyticsEvent(event) {
                    return _fireAnalyticsEvent(event);
                }
            }
        }, (0, $74Zh5.jsx)((0, $4qXRD.Provider), null, (0, $74Zh5.jsx)((0, $d0n7Z.ProviderFactoryProvider), {
            value: providerFactory
        }, (0, $74Zh5.jsx)($303ba37d2d9486ca$var$RendererWrapper, {
            allowAnnotations: props.allowAnnotations,
            appearance: props.appearance,
            contentMode: (0, $9Zzpd.fg)('platform_editor_content_mode_render_context') ? props.contentMode || rendererContext.contentMode || 'standard' : props.contentMode || 'standard',
            allowNestedHeaderLinks: (0, $e382f311073cdba5$export$7aa7587d1ce9583c)(props.allowHeadingAnchorLinks),
            allowColumnSorting: props.allowColumnSorting,
            allowCopyToClipboard: props.allowCopyToClipboard,
            allowWrapCodeBlock: props.allowWrapCodeBlock,
            allowCustomPanels: props.allowCustomPanels,
            allowPlaceholderText: props.allowPlaceholderText,
            useBlockRenderForCodeBlock: (_rendererContext$feat = rendererContext.featureFlags.useBlockRenderForCodeBlock) !== null && _rendererContext$feat !== void 0 ? _rendererContext$feat : true,
            addTelepointer: props.addTelepointer,
            innerRef: editorRef,
            onClick: function onClick(event) {
                return $303ba37d2d9486ca$var$handleWrapperOnClick(event, props, mouseDownSelection);
            },
            onMouseDown: onMouseDownEditView,
            ssr: (_props$media = props.media) === null || _props$media === void 0 ? void 0 : _props$media.ssr,
            isInsideOfInlineExtension: props.isInsideOfInlineExtension,
            isTopLevelRenderer: rendererContext.isTopLevelRenderer,
            shouldRemoveEmptySpaceAroundContent: props.shouldRemoveEmptySpaceAroundContent,
            allowRendererContainerStyles: props.allowRendererContainerStyles
        }, props.enableSsrInlineScripts || props.noOpSSRInlineScript ? (0, $74Zh5.jsx)((0, $e2e772a0c175af19$export$cfc1361be0de4203), {
            noOpSSRInlineScript: Boolean(props.noOpSSRInlineScript)
        }) : null, (0, $74Zh5.jsx)($303ba37d2d9486ca$var$RendererActionsInternalUpdater, {
            doc: pmDoc,
            schema: schema,
            onAnalyticsEvent: _fireAnalyticsEvent
        }, result)))))));
        var rendererResult = props.truncated ? (0, $74Zh5.jsx)((0, $68ff72c25ae09c72$export$79ad592494094f07), {
            height: props.maxHeight,
            fadeHeight: props.fadeOutHeight
        }, rendererOutput) : rendererOutput;
        return (0, $74Zh5.jsx)((0, $5FkrB.Fragment), null, rendererResult);
    } catch (e) {
        var _rendererContext$feat2;
        if (props.onError) props.onError(e);
        return (0, $74Zh5.jsx)($303ba37d2d9486ca$var$RendererWrapper, {
            allowAnnotations: props.allowAnnotations,
            appearance: props.appearance,
            contentMode: (0, $9Zzpd.fg)('platform_editor_content_mode_render_context') ? props.contentMode || rendererContext.contentMode || 'standard' : props.contentMode || 'standard',
            allowCopyToClipboard: props.allowCopyToClipboard,
            allowWrapCodeBlock: props.allowWrapCodeBlock,
            allowPlaceholderText: props.allowPlaceholderText,
            allowColumnSorting: props.allowColumnSorting,
            allowNestedHeaderLinks: (0, $e382f311073cdba5$export$7aa7587d1ce9583c)(props.allowHeadingAnchorLinks),
            useBlockRenderForCodeBlock: (_rendererContext$feat2 = rendererContext.featureFlags.useBlockRenderForCodeBlock) !== null && _rendererContext$feat2 !== void 0 ? _rendererContext$feat2 : true,
            addTelepointer: props.addTelepointer,
            onClick: function onClick(event) {
                return $303ba37d2d9486ca$var$handleWrapperOnClick(event, props, mouseDownSelection);
            },
            isTopLevelRenderer: rendererContext.isTopLevelRenderer,
            allowRendererContainerStyles: props.allowRendererContainerStyles
        }, (0, $74Zh5.jsx)((0, $5dFQJ.default), null));
    }
};
var $303ba37d2d9486ca$var$RendererFunctionalComponentMemoized = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).memo($303ba37d2d9486ca$export$c49fe2316038f3c2);
var $303ba37d2d9486ca$var$RendererFunctionalComponentWithPortalContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).memo(function(props) {
    // If nodeComponents are provided, we don't remove portal from props and use context instead,
    // because we can't guarantee compatibility with existing Atlaskit Renderer consumers.
    if (props.nodeComponents) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement($303ba37d2d9486ca$var$RendererFunctionalComponentMemoized, props);
    var portal = props.portal, propsWithoutPortal = (0, (/*@__PURE__*/$parcel$interopDefault($1Vcia)))(props, $303ba37d2d9486ca$var$_excluded);
    return (0, $74Zh5.jsx)((0, $aOpeL.PortalContext).Provider, {
        value: portal
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement($303ba37d2d9486ca$export$c49fe2316038f3c2, propsWithoutPortal));
});
function $303ba37d2d9486ca$export$88530751e3977073(props) {
    var _props$isTopLevelRend;
    var _React$useContext = (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).useContext((0, $nOuq8.AnnotationsPositionContext)), startPos = _React$useContext.startPos;
    var _useRendererContext2 = (0, $ky5Ao.useRendererContext)(), isTopLevelRenderer = _useRendererContext2.isTopLevelRenderer;
    var _ref = (0, $5FkrB.useContext)((0, $caYHb.ValidationContext)) || {}, skipValidation = _ref.skipValidation, allowNestedTables = _ref.allowNestedTables;
    var validationOverrides = (0, $5FkrB.useMemo)(function() {
        return {
            allowNestedTables: allowNestedTables
        };
    }, [
        allowNestedTables
    ]);
    return (0, $74Zh5.jsx)($303ba37d2d9486ca$var$RendererFunctionalComponentWithPortalContext, (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, props, {
        startPos: startPos,
        isTopLevelRenderer: (_props$isTopLevelRend = props.isTopLevelRenderer) !== null && _props$isTopLevelRend !== void 0 ? _props$isTopLevelRend : isTopLevelRenderer,
        skipValidation: skipValidation,
        validationOverrides: validationOverrides
    }));
}
var $303ba37d2d9486ca$export$af81ffb59b6ef0dd = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).memo(function(props) {
    return (0, $74Zh5.jsx)((0, $kHFeb.FabricEditorAnalyticsContext), {
        data: {
            appearance: (0, $577d48613d9afb24$export$be87849653b93e6b)(props.appearance),
            packageName: $303ba37d2d9486ca$var$packageName,
            packageVersion: $303ba37d2d9486ca$var$packageVersion,
            componentName: 'renderer',
            // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
            editorSessionId: (0, $6JfQX.default)()
        }
    }, (0, $74Zh5.jsx)((0, $8d472cee2b63d31a$export$9ac3d19711324187), {
        render: function render(createAnalyticsEvent) {
            // `IntlErrorBoundary` only captures Internationalisation errors, leaving others for `ErrorBoundary`.
            return (0, $74Zh5.jsx)((0, $enqEB.ErrorBoundary), {
                component: (0, $jJH6F.ACTION_SUBJECT).RENDERER,
                rethrowError: true,
                fallbackComponent: null,
                createAnalyticsEvent: createAnalyticsEvent
            }, (0, $74Zh5.jsx)((0, $de1783a2fb838cfd$export$7df0749115d18d19), null, (0, $74Zh5.jsx)($303ba37d2d9486ca$export$88530751e3977073, (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({}, props, {
                createAnalyticsEvent: createAnalyticsEvent
            }))));
        }
    }));
});
var $303ba37d2d9486ca$var$RendererWrapper = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).memo(function(props) {
    var allowColumnSorting = props.allowColumnSorting, allowNestedHeaderLinks = props.allowNestedHeaderLinks, innerRef = props.innerRef, appearance = props.appearance, contentMode = props.contentMode, children = props.children, onClick = props.onClick, onMouseDown = props.onMouseDown, useBlockRenderForCodeBlock = props.useBlockRenderForCodeBlock, addTelepointer = props.addTelepointer, ssr = props.ssr, isInsideOfInlineExtension = props.isInsideOfInlineExtension, allowTableResizing = props.allowTableResizing, isTopLevelRenderer = props.isTopLevelRenderer, allowRendererContainerStyles = props.allowRendererContainerStyles;
    var createTelepointer = function createTelepointer() {
        var telepointer = document.createElement('span');
        telepointer.textContent = "\u200B";
        telepointer.id = (0, $13ECD.TELEPOINTER_ID);
        return telepointer;
    };
    var initialUpdate = (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).useRef(true);
    (0, $5FkrB.useEffect)(function() {
        // We must check if window is defined, if it isn't we are in a SSR environment
        // and we don't want to add the telepointer
        if (typeof window !== 'undefined' && addTelepointer && innerRef !== null && innerRef !== void 0 && innerRef.current) {
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            var _renderer = innerRef.current.querySelector('.ak-renderer-document');
            if (initialUpdate.current) {
                var lastChild = _renderer.lastChild;
                lastChild && lastChild.appendChild(createTelepointer());
            }
            var mutateTelepointer = function mutateTelepointer(mutations) {
                mutations.forEach(function(mutation, _index) {
                    var _mutation$addedNodes$, _mutation$removedNode;
                    if (initialUpdate.current) {
                        var oldTelepointer = _renderer.querySelector("#".concat((0, $13ECD.TELEPOINTER_ID)));
                        if (oldTelepointer) oldTelepointer.remove();
                        var _lastChild = _renderer.lastChild;
                        _lastChild && _lastChild.appendChild(createTelepointer());
                        initialUpdate.current = false;
                    }
                    if (mutation.type === 'characterData') {
                        var parentNode = mutation.target.parentElement;
                        if (parentNode) {
                            var _oldTelepointer = _renderer.querySelector("#".concat((0, $13ECD.TELEPOINTER_ID)));
                            if (_oldTelepointer) _oldTelepointer.remove();
                            // Ignored via go/ees005
                            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                            parentNode.appendChild(createTelepointer());
                        }
                    }
                    /**
           * When streaming ADF content, we may receive mutations where nodes get
           * replaced, rather than have characterData updated.
           *
           * Telepointer changes will also cause a childList mutation, so we manually ignore it.
           * Telepointer changes are always a singular node-adds or node-removes.
           */ var isAdfStreamingEnabled = (0, $9Zzpd.fg)('platform_editor_ai_adf_prompts_in_all_products') || (0, $eqmEx.expValEqualsNoExposure)('platform_editor_ai_iw_adf_streaming', 'cohort', 'adf_gpt41mini') || (0, $eqmEx.expValEqualsNoExposure)('platform_editor_ai_iw_adf_streaming', 'cohort', 'adf_gemini25flash') || (0, $eqmEx.expValEqualsNoExposure)('platform_editor_ai_non_iw_adf_streaming', 'cohort', 'adf_gpt41mini') || (0, $eqmEx.expValEqualsNoExposure)('platform_editor_ai_non_iw_adf_streaming', 'cohort', 'adf_gemini25flash');
                    if (isAdfStreamingEnabled && mutation.type === 'childList' && !(mutation.addedNodes.length === 1 && ((_mutation$addedNodes$ = mutation.addedNodes[0]) === null || _mutation$addedNodes$ === void 0 ? void 0 : _mutation$addedNodes$.id) === (0, $13ECD.TELEPOINTER_ID) || mutation.removedNodes.length === 1 && ((_mutation$removedNode = mutation.removedNodes[0]) === null || _mutation$removedNode === void 0 ? void 0 : _mutation$removedNode.id) === (0, $13ECD.TELEPOINTER_ID))) {
                        var _lastChild2 = _renderer.lastChild;
                        if (_lastChild2) {
                            /**
               * We want to place telepointer inside content (which has data-renderer-start-pos) and
               * inside lines in codeblocks (which have data-ds--code--row).
               */ var contentElements = _lastChild2.querySelectorAll('[data-renderer-start-pos],[data-ds--code--row]');
                            var lastElement = contentElements[contentElements.length - 1];
                            var _oldTelepointer2 = _renderer.querySelector("#".concat((0, $13ECD.TELEPOINTER_ID)));
                            if (lastElement) {
                                _oldTelepointer2 === null || _oldTelepointer2 === void 0 || _oldTelepointer2.remove();
                                lastElement === null || lastElement === void 0 || lastElement.appendChild(createTelepointer());
                            } else {
                                _oldTelepointer2 === null || _oldTelepointer2 === void 0 || _oldTelepointer2.remove();
                                _lastChild2 === null || _lastChild2 === void 0 || _lastChild2.appendChild(createTelepointer());
                            }
                        }
                    }
                });
            };
            var observer = new MutationObserver(mutateTelepointer);
            observer.observe(innerRef.current, {
                characterData: true,
                attributes: false,
                childList: true,
                subtree: true
            });
            return function() {
                return observer.disconnect();
            };
        }
    }, [
        innerRef,
        addTelepointer
    ]);
    var renderer = (0, $74Zh5.jsx)((0, $01HkO.WidthProvider), {
        className: "ak-renderer-wrapper is-".concat(appearance),
        "data-appearance": appearance,
        shouldCheckExistingValue: isInsideOfInlineExtension
    }, (0, $74Zh5.jsx)((0, $kMHA5.BaseTheme), {
        baseFontSize: (0, $cc8a699f38d2ae23$export$8e2864079bc476bd)(appearance, contentMode)
    }, (0, $74Zh5.jsx)((0, $cffc3bdc16b16678$export$77218b6ff680865f), {
        ssr: ssr
    }, (0, $74Zh5.jsx)((0, $df014fe6e70c2dc0$export$8f0929e72efe521f), {
        innerRef: innerRef,
        onClick: onClick,
        onMouseDown: onMouseDown,
        appearance: appearance,
        contentMode: contentMode,
        allowNestedHeaderLinks: allowNestedHeaderLinks,
        allowColumnSorting: !!allowColumnSorting,
        useBlockRenderForCodeBlock: useBlockRenderForCodeBlock,
        allowAnnotations: props.allowAnnotations,
        allowTableResizing: allowTableResizing,
        allowRendererContainerStyles: allowRendererContainerStyles
    }, children))));
    // We can only make the wrapper div query container when we have a known width.
    // This is also required for SSR to work correctly. As WidthProvider/WithConsumer will not have the correct width during SSR.
    //
    // allowRendererContainerStyles is not needed for comment container styling as container should always be set for comments
    if (appearance === 'comment' && isTopLevelRenderer && (0, $9Zzpd.fg)('platform-ssr-table-resize')) return (0, $74Zh5.jsx)("div", {
        css: $303ba37d2d9486ca$var$setAsQueryContainerStyles
    }, renderer);
    // We are setting this wrapper div as query container conditionally.
    // Only apply container-type = inline-size when having a known width in full-page/full-width/comment mode.
    // Otherwise when appearance is unspecified the renderer size is decided by the content.
    // In this case we can't set the container-type = inline-size as it will collapse width to 0.
    return (appearance === 'full-page' || appearance === 'full-width' || (0, $eqmEx.expValEqualsNoExposure)('editor_tinymce_full_width_mode', 'isEnabled', true) && appearance === 'max') && // In case of having excerpt-include on page there are multiple renderers nested.
    // Make sure only the root renderer is set to be query container.
    isTopLevelRenderer && allowRendererContainerStyles && (0, $9Zzpd.fg)('platform-ssr-table-resize') ? (0, $74Zh5.jsx)("div", {
        css: $303ba37d2d9486ca$var$setAsQueryContainerStyles
    }, renderer) : renderer;
});
var $303ba37d2d9486ca$var$RootRendererContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createContext(null);
function $303ba37d2d9486ca$var$RendererActionsInternalUpdater(_ref2) {
    var children = _ref2.children, doc = _ref2.doc, schema = _ref2.schema, onAnalyticsEvent = _ref2.onAnalyticsEvent;
    var rootRendererContextValue = (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).useContext($303ba37d2d9486ca$var$RootRendererContext);
    var actions = (0, $5FkrB.useContext)((0, $lMzAH.RendererContext));
    var rendererRef = (0, $5FkrB.useRef)(null);
    // This doc is used by the renderer actions when applying comments to the document.
    // (via hand crafted steps based on non prosemirror based position calculations)
    // It is set to the root renderer's doc as otherwise the resulting document will
    // be incorrect (nested renderers use a fake document which represents a subset
    // of the actual document).
    var _doc;
    if ((0, $fAhSf.editorExperiment)('comment_on_bodied_extensions', true) && rootRendererContextValue) // If rootRendererContextValue is set -- we are inside a nested renderer
    // and should always use the doc from the root renderer
    _doc = rootRendererContextValue.doc;
    else // If rootRendererContextValue is not set -- we are in the root renderer
    // and set the doc to the current doc.
    _doc = doc;
    (0, $5FkrB.useLayoutEffect)(function() {
        if (_doc) actions._privateRegisterRenderer(rendererRef, _doc, schema, onAnalyticsEvent);
        else actions._privateUnregisterRenderer();
        return function() {
            return actions._privateUnregisterRenderer();
        };
    }, [
        actions,
        schema,
        _doc,
        onAnalyticsEvent
    ]);
    if ((0, $fAhSf.editorExperiment)('comment_on_bodied_extensions', true)) return (0, $74Zh5.jsx)($303ba37d2d9486ca$var$RootRendererContext.Provider, {
        value: {
            doc: _doc
        }
    }, children);
    return children;
}
// Usage notes:
// Used by Confluence for nested renderers
// For the View page renderer - see RendererWithAnalytics
var $303ba37d2d9486ca$var$RendererWithAnnotationSelection = function RendererWithAnnotationSelection(props) {
    var allowAnnotations = props.allowAnnotations, adfDocument = props.document;
    var localRef = (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).useRef(null);
    var innerRef = props.innerRef || localRef;
    // @see https://hello.jira.atlassian.cloud/browse/EDITOR-3389
    if (props.appearance === 'max' && !(0, $drUcN.expValEquals)('editor_tinymce_full_width_mode', 'isEnabled', true)) props.appearance = 'full-width';
    if (!allowAnnotations) // Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    return (0, $74Zh5.jsx)($303ba37d2d9486ca$export$af81ffb59b6ef0dd, (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        innerRef: innerRef
    }, props));
    return (0, $74Zh5.jsx)((0, $lMzAH.RendererActionsContext), null, (0, $74Zh5.jsx)((0, $nOuq8.AnnotationsWrapper), {
        rendererRef: innerRef,
        adfDocument: adfDocument,
        annotationProvider: props.annotationProvider,
        isNestedRender: true
    }, (0, $74Zh5.jsx)($303ba37d2d9486ca$export$af81ffb59b6ef0dd, (0, (/*@__PURE__*/$parcel$interopDefault($kqp0i)))({
        innerRef: innerRef
    }, props, {
        featureFlags: props.featureFlags
    }))));
};
var // eslint-disable-next-line @repo/internal/deprecations/deprecation-ticket-required -- Ignored via go/ED-25883
/* @deprecated using this version of the renderer causes the RendererActions to inaccessible from any consumers */ $303ba37d2d9486ca$export$2e2bcd8739ae039 = $303ba37d2d9486ca$var$RendererWithAnnotationSelection;



var $eMiEC = parcelRequire("eMiEC");

var $6Wx3K = parcelRequire("6Wx3K");
const $b1e0b601f9d37334$var$messages = {
    contentDisplayErrorTItle: {
        id: 'adfContentSection.contentDisplayError',
        defaultMessage: 'Content Display Error',
        description: 'Title for error message when ADF content cannot be displayed'
    },
    contentDisplayErrorDescription: {
        id: 'adfContentSection.contentDisplayErrorDescription',
        defaultMessage: 'The content for this section could not be displayed due to a formatting issue.',
        description: 'Description for error message when ADF content cannot be displayed'
    }
};
const $b1e0b601f9d37334$export$56108d98a201729 = ({ content: content, title: title })=>{
    const { formatMessage: formatMessage } = (0, $6Wx3K.default)();
    if (!content) return null;
    let parsedDocument;
    try {
        parsedDocument = JSON.parse(content);
    } catch (error) {
        // Log the error for debugging purposes
        console.error('Failed to parse ADF content:', error);
        return /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsxs)((0, $383dd904a5a5e5b0$export$2e2bcd8739ae039), {
            paddingBlockEnd: "space.400",
            children: [
                title && /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $383dd904a5a5e5b0$export$2e2bcd8739ae039), {
                    paddingBlockEnd: "space.100",
                    children: /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $bb0Oq.default), {
                        as: "h2",
                        size: "small",
                        children: title
                    })
                }),
                /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $eMiEC.default), {
                    appearance: "warning",
                    title: formatMessage($b1e0b601f9d37334$var$messages.contentDisplayErrorTItle),
                    children: /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $d48daa9a522ca942$export$2e2bcd8739ae039), {
                        children: formatMessage($b1e0b601f9d37334$var$messages.contentDisplayErrorDescription)
                    })
                })
            ]
        });
    }
    return /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsxs)((0, $383dd904a5a5e5b0$export$2e2bcd8739ae039), {
        paddingBlockEnd: "space.400",
        children: [
            title && /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $383dd904a5a5e5b0$export$2e2bcd8739ae039), {
                paddingBlockEnd: "space.100",
                children: /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $bb0Oq.default), {
                    as: "h2",
                    size: "small",
                    children: title
                })
            }),
            /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $303ba37d2d9486ca$export$2e2bcd8739ae039), {
                document: parsedDocument
            })
        ]
    });
};
var $b1e0b601f9d37334$export$2e2bcd8739ae039 = $b1e0b601f9d37334$export$56108d98a201729;



var $aRMzY = parcelRequire("aRMzY");
var $6Wx3K = parcelRequire("6Wx3K");


var $bb0Oq = parcelRequire("bb0Oq");




const $f521c9d158c3d71f$var$messages = (0, $aRMzY.defineMessages)({
    appsImpactedTitle: {
        id: 'appUpdatesDetails.sidebar.appsImpactedTitle',
        defaultMessage: 'Apps impacted',
        description: 'Title for the section displaying apps impacted by the update'
    },
    impactRatingTitle: {
        id: 'appUpdatesDetails.sidebar.impactRatingTitle',
        defaultMessage: 'Change impact',
        description: 'Title for the impact rating section in the sidebar'
    },
    changeTypeTitle: {
        id: 'appUpdatesDetails.sidebar.changeTypeTitle',
        defaultMessage: 'Contextual tags',
        description: 'Title for the change type (tags) section in the sidebar'
    }
});
const $f521c9d158c3d71f$var$titleStyles = (0, $c1bec583fa49072f$export$f6c783d06584602c)({
    marginBlockEnd: 'space.100'
});
const $f521c9d158c3d71f$var$contentStyles = (0, $c1bec583fa49072f$export$f6c783d06584602c)({
    fontWeight: 'font.weight.regular',
    color: 'color.text.subtlest',
    marginBlockStart: 'space.150',
    gap: 'space.100'
});
const $f521c9d158c3d71f$var$productItemStyles = (0, $c1bec583fa49072f$export$f6c783d06584602c)({
    display: 'flex',
    alignItems: 'center',
    gap: 'space.100'
});
const $f521c9d158c3d71f$export$da96d30cc2e733ab = ({ products: products, impactRating: impactRating, tags: tags })=>{
    const { formatMessage: formatMessage } = (0, $6Wx3K.default)();
    const hasProducts = products && products.length > 0;
    const hasTags = tags && tags.length > 0;
    // Don't render if nothing to show
    if (!hasProducts && !impactRating && !hasTags) return null;
    return /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsxs)((0, $c8dbef6c41cfa689$export$2e2bcd8739ae039), {
        space: "space.300",
        children: [
            (0, $c78886f48293f91c$export$b40ec24ac8275656)((0, $86626a3c150b02ba$export$5fb62a9fe732a843).aiImpactAndContextTags) && impactRating && /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsxs)("section", {
                "data-testid": "app-impacted-sidebar-impact-rating",
                children: [
                    /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $383dd904a5a5e5b0$export$2e2bcd8739ae039), {
                        xcss: $f521c9d158c3d71f$var$titleStyles,
                        children: /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $bb0Oq.default), {
                            as: "div",
                            size: "small",
                            children: formatMessage($f521c9d158c3d71f$var$messages.impactRatingTitle)
                        })
                    }),
                    /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $383dd904a5a5e5b0$export$2e2bcd8739ae039), {
                        xcss: $f521c9d158c3d71f$var$contentStyles,
                        children: /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $d26747ad8d2a0268$export$2a5158d64a074be2), {
                            impactRating: impactRating
                        })
                    })
                ]
            }),
            (0, $c78886f48293f91c$export$b40ec24ac8275656)((0, $86626a3c150b02ba$export$5fb62a9fe732a843).aiImpactAndContextTags) && hasTags && /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsxs)("section", {
                "data-testid": "app-impacted-sidebar-tags",
                children: [
                    /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $383dd904a5a5e5b0$export$2e2bcd8739ae039), {
                        xcss: $f521c9d158c3d71f$var$titleStyles,
                        children: /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $bb0Oq.default), {
                            as: "div",
                            size: "small",
                            children: formatMessage($f521c9d158c3d71f$var$messages.changeTypeTitle)
                        })
                    }),
                    /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $383dd904a5a5e5b0$export$2e2bcd8739ae039), {
                        xcss: $f521c9d158c3d71f$var$contentStyles,
                        children: /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $fbecf69dc9e04116$export$3c86caed05f80ae7), {
                            tags: tags
                        })
                    })
                ]
            }),
            hasProducts && /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsxs)("section", {
                "data-testid": "app-impacted-sidebar-products",
                children: [
                    /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $383dd904a5a5e5b0$export$2e2bcd8739ae039), {
                        xcss: $f521c9d158c3d71f$var$titleStyles,
                        children: /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $bb0Oq.default), {
                            as: "div",
                            size: "small",
                            children: formatMessage($f521c9d158c3d71f$var$messages.appsImpactedTitle)
                        })
                    }),
                    /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $c8dbef6c41cfa689$export$2e2bcd8739ae039), {
                        xcss: $f521c9d158c3d71f$var$contentStyles,
                        children: (0, $ace4c485fd808422$export$e3760658a711f2d3)(products).map((productType)=>/*#__PURE__*/ (0, $faf30355a80342e4$exports.jsxs)((0, $383dd904a5a5e5b0$export$2e2bcd8739ae039), {
                                xcss: $f521c9d158c3d71f$var$productItemStyles,
                                testId: `app-display-${productType}`,
                                children: [
                                    /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $7397f708924e0bda$export$1a199e029d5e93d6), {
                                        productType: productType,
                                        size: "small",
                                        testId: "product-list-primary-icon"
                                    }),
                                    /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $d48daa9a522ca942$export$2e2bcd8739ae039), {
                                        children: (0, $d3185276e14a4c2b$export$44fea6589b7ddc92)(productType)
                                    })
                                ]
                            }, productType))
                    })
                ]
            })
        ]
    });
};
var $f521c9d158c3d71f$export$2e2bcd8739ae039 = $f521c9d158c3d71f$export$da96d30cc2e733ab;



var $aRMzY = parcelRequire("aRMzY");
var $6Wx3K = parcelRequire("6Wx3K");








const $bb106d656d239203$var$summaryItemStyles = (0, $c1bec583fa49072f$export$f6c783d06584602c)({
    minWidth: '0',
    alignItems: 'flex-start'
});
// Ensures all header labels align on the same baseline,
// even when some headers include the AIDisclaimer (icon + lozenge).
const $bb106d656d239203$var$headerStyles = (0, $c1bec583fa49072f$export$f6c783d06584602c)({
    minHeight: '24px',
    display: 'flex',
    alignItems: 'center'
});
const $bb106d656d239203$var$messages = (0, $aRMzY.defineMessages)({
    rolloutSchedule: {
        id: 'appUpdatesDetails.changelog.rolloutSchedule',
        defaultMessage: 'Rollout schedule',
        description: 'Label for rollout schedule information'
    },
    status: {
        id: 'appUpdatesDetails.changelog.status',
        defaultMessage: 'Status',
        description: 'Label for update status information'
    },
    changeType: {
        id: 'appUpdatesDetails.changelog.changeType',
        defaultMessage: 'Change type',
        description: 'Label for original (non-AI) change type'
    },
    changeImpact: {
        id: 'appUpdatesDetails.changelog.changeImpact',
        defaultMessage: 'Change impact',
        description: 'Label for AI-generated impact rating'
    },
    contextualTags: {
        id: 'appUpdatesDetails.changelog.contextualTags',
        defaultMessage: 'Contextual tags',
        description: 'Label for AI-generated contextual tags'
    }
});
const $bb106d656d239203$export$ab8b745e030c7e6f = ({ status: status, type: type, releaseStartDate: releaseStartDate, releaseEndDate: releaseEndDate, impactRating: impactRating, tags: tags })=>{
    const { formatMessage: formatMessage } = (0, $6Wx3K.default)();
    const isAiImpactAndContextTagsEnabled = (0, $c78886f48293f91c$export$b40ec24ac8275656)((0, $86626a3c150b02ba$export$5fb62a9fe732a843).aiImpactAndContextTags);
    const hasBaseMetadata = Boolean(status || type || releaseStartDate || releaseEndDate);
    const hasImpactRating = Boolean(impactRating);
    const hasContextualTags = Boolean(tags?.length);
    const shouldRenderAiMetadata = isAiImpactAndContextTagsEnabled && (hasBaseMetadata || hasImpactRating || hasContextualTags);
    // Don't render if no visible metadata is available.
    if (!hasBaseMetadata && !(isAiImpactAndContextTagsEnabled && (hasImpactRating || hasContextualTags))) return null;
    return /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsxs)((0, $10b0af967ce59e29$export$2e2bcd8739ae039), {
        space: "space.400",
        alignBlock: "start",
        shouldWrap: true,
        children: [
            status && /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsxs)((0, $c8dbef6c41cfa689$export$2e2bcd8739ae039), {
                space: "space.100",
                xcss: $bb106d656d239203$var$summaryItemStyles,
                children: [
                    /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $383dd904a5a5e5b0$export$2e2bcd8739ae039), {
                        xcss: $bb106d656d239203$var$headerStyles,
                        children: /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $d48daa9a522ca942$export$2e2bcd8739ae039), {
                            size: "small",
                            weight: "bold",
                            children: formatMessage($bb106d656d239203$var$messages.status)
                        })
                    }),
                    /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $fe4fcc4b7b323fa4$export$330c774339d320ad), {
                        status: status
                    })
                ]
            }),
            type && /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsxs)((0, $c8dbef6c41cfa689$export$2e2bcd8739ae039), {
                space: "space.100",
                xcss: $bb106d656d239203$var$summaryItemStyles,
                children: [
                    /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $383dd904a5a5e5b0$export$2e2bcd8739ae039), {
                        xcss: $bb106d656d239203$var$headerStyles,
                        children: /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $d48daa9a522ca942$export$2e2bcd8739ae039), {
                            size: "small",
                            weight: "bold",
                            children: formatMessage($bb106d656d239203$var$messages.changeType)
                        })
                    }),
                    /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $10eaae4bdfb59f21$export$1abc4eff6ef230bd), {
                        type: type
                    })
                ]
            }),
            (releaseStartDate || releaseEndDate) && /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsxs)((0, $c8dbef6c41cfa689$export$2e2bcd8739ae039), {
                space: "space.100",
                xcss: $bb106d656d239203$var$summaryItemStyles,
                children: [
                    /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $383dd904a5a5e5b0$export$2e2bcd8739ae039), {
                        xcss: $bb106d656d239203$var$headerStyles,
                        children: /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $d48daa9a522ca942$export$2e2bcd8739ae039), {
                            size: "small",
                            weight: "bold",
                            children: formatMessage($bb106d656d239203$var$messages.rolloutSchedule)
                        })
                    }),
                    /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $373b864dc2406021$export$c119e7a38ceabb6b), {
                        startDate: releaseStartDate,
                        endDate: releaseEndDate,
                        status: status
                    })
                ]
            }),
            shouldRenderAiMetadata && /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsxs)((0, $c8dbef6c41cfa689$export$2e2bcd8739ae039), {
                space: "space.100",
                xcss: $bb106d656d239203$var$summaryItemStyles,
                alignInline: "start",
                children: [
                    /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $383dd904a5a5e5b0$export$2e2bcd8739ae039), {
                        xcss: $bb106d656d239203$var$headerStyles,
                        children: /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $9d0c6ca2818366fa$export$e0542ba0c737fe5c), {
                            label: /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $d48daa9a522ca942$export$2e2bcd8739ae039), {
                                size: "small",
                                weight: "bold",
                                children: formatMessage($bb106d656d239203$var$messages.changeImpact)
                            })
                        })
                    }),
                    impactRating && /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $d26747ad8d2a0268$export$2a5158d64a074be2), {
                        impactRating: impactRating
                    })
                ]
            }),
            shouldRenderAiMetadata && /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsxs)((0, $c8dbef6c41cfa689$export$2e2bcd8739ae039), {
                space: "space.0",
                xcss: $bb106d656d239203$var$summaryItemStyles,
                children: [
                    /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $383dd904a5a5e5b0$export$2e2bcd8739ae039), {
                        xcss: $bb106d656d239203$var$headerStyles,
                        children: /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $9d0c6ca2818366fa$export$e0542ba0c737fe5c), {
                            label: /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $d48daa9a522ca942$export$2e2bcd8739ae039), {
                                size: "small",
                                weight: "bold",
                                children: formatMessage($bb106d656d239203$var$messages.contextualTags)
                            })
                        })
                    }),
                    tags && tags.length > 0 && /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $383dd904a5a5e5b0$export$2e2bcd8739ae039), {
                        xcss: (0, $c1bec583fa49072f$export$f6c783d06584602c)({
                            marginInlineStart: 'space.negative.050'
                        }),
                        children: /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $fbecf69dc9e04116$export$3c86caed05f80ae7), {
                            tags: tags
                        })
                    })
                ]
            })
        ]
    });
};
var $bb106d656d239203$export$2e2bcd8739ae039 = $bb106d656d239203$export$ab8b745e030c7e6f;



var $5FkrB = parcelRequire("5FkrB");


var $9ztDu = parcelRequire("9ztDu");
const $43a52dbdb7ebc3db$var$wrapperStyles = (0, $c1bec583fa49072f$export$f6c783d06584602c)({
    width: '100%',
    overflow: 'hidden',
    lineHeight: '0'
});
const $43a52dbdb7ebc3db$var$spinnerContainerStyles = (0, $c1bec583fa49072f$export$f6c783d06584602c)({
    width: '100%',
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'absolute'
});
const $43a52dbdb7ebc3db$var$imageContainerStyles = (0, $c1bec583fa49072f$export$f6c783d06584602c)({
    position: 'relative',
    width: '100%'
});
/**
 * Validates that the URL is safe to load (not a javascript: URL)
 */ const $43a52dbdb7ebc3db$var$isValidImageUrl = (url)=>{
    try {
        // Check for javascript: protocol
        if (url.toLowerCase().startsWith('javascript:')) return false;
        // Check for data: URLs that might contain script
        if (url.toLowerCase().startsWith('data:')) return false;
        return true;
    } catch  {
        return false;
    }
};
const $43a52dbdb7ebc3db$export$4935cefa9e8adac4 = ({ src: src, altTag: altTag, title: title, width: width, height: height, testId: testId, onLoadError: onLoadError, aspectRatio: aspectRatio })=>{
    const [isLoading, setIsLoading] = (0, $5FkrB.useState)(true);
    const [hasError, setHasError] = (0, $5FkrB.useState)(false);
    // Validate URL on mount/src change
    const isValidUrl = $43a52dbdb7ebc3db$var$isValidImageUrl(src);
    const handleImageLoad = (0, $5FkrB.useCallback)(()=>{
        setIsLoading(false);
    }, []);
    const handleImageError = (0, $5FkrB.useCallback)(()=>{
        setHasError(true);
        setIsLoading(false);
        onLoadError?.();
    }, [
        onLoadError
    ]);
    // Return null if URL is invalid
    if (!isValidUrl) return null;
    // Return null if image failed to load
    if (hasError) return null;
    const imgStyles = {
        width: width ? typeof width === 'number' ? `${width}px` : width : '100%',
        height: height ? typeof height === 'number' ? `${height}px` : height : 'auto',
        objectFit: 'cover',
        objectPosition: 'center',
        transition: 'opacity 200ms ease-in-out',
        opacity: isLoading ? 0 : 1,
        display: 'block',
        aspectRatio: aspectRatio
    };
    return /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $383dd904a5a5e5b0$export$2e2bcd8739ae039), {
        xcss: $43a52dbdb7ebc3db$var$wrapperStyles,
        testId: testId,
        children: /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsxs)((0, $383dd904a5a5e5b0$export$2e2bcd8739ae039), {
            xcss: $43a52dbdb7ebc3db$var$imageContainerStyles,
            children: [
                isLoading && /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $383dd904a5a5e5b0$export$2e2bcd8739ae039), {
                    xcss: $43a52dbdb7ebc3db$var$spinnerContainerStyles,
                    children: /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $9ztDu.default), {
                        interactionName: "content-image-loading"
                    })
                }),
                /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)("img", {
                    src: src,
                    alt: altTag,
                    title: title,
                    onLoad: handleImageLoad,
                    onError: handleImageError,
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
                    style: imgStyles
                })
            ]
        })
    });
};
var $43a52dbdb7ebc3db$export$2e2bcd8739ae039 = $43a52dbdb7ebc3db$export$4935cefa9e8adac4;


/* divider.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $5FkrB = parcelRequire("5FkrB");

var $970q7 = parcelRequire("970q7");
var $408399d1ce27a4df$var$styles = null;
var $408399d1ce27a4df$export$2e0a83ec2e27ecbb = function Divider() {
    return /*#__PURE__*/ $5FkrB.createElement("hr", {
        /**
     * The existing usage of these dividers is presentational,
     * so we are removing the separator semantics by default.
     *
     * In the future we may consider allowing opt-in separator semantics,
     * but it probably isn't necessary.
     */ role: "none",
        className: (0, $970q7.default)([
            "_h7alglyw _179rglyw _mqm2ia51 _1bsb1osq"
        ])
    });
};



var $k7fIB = parcelRequire("k7fIB");

var $Un5hy = parcelRequire("Un5hy");
const $835ddb2f29e7ae63$var$messages = (0, $aRMzY.defineMessages)({
    backAction: {
        id: 'appUpdatesDetails.backAction',
        defaultMessage: 'Back to release notes',
        description: 'Button text to navigate back to the updates list'
    },
    notFound: {
        id: 'appUpdatesDetails.notFound',
        defaultMessage: 'This release note could not be found. Use the back button to return to release notes.',
        description: 'Error message displayed when an update cannot be found'
    },
    error: {
        id: 'appUpdatesDetails.error',
        defaultMessage: 'Unable to load this release note. Use the back button to return and try again.',
        description: 'Error message displayed when update fails to load'
    },
    loading: {
        id: 'appUpdatesDetails.loading',
        defaultMessage: 'Loading release note\u2026',
        description: 'Loading message while fetching update details'
    },
    keyChanges: {
        id: 'appUpdatesDetails.keyChanges',
        defaultMessage: 'Key changes',
        description: 'Section title for key changes'
    },
    benefits: {
        id: 'appUpdatesDetails.benefits',
        defaultMessage: 'Benefits',
        description: 'Section title for benefits'
    },
    reasonForChange: {
        id: 'appUpdatesDetails.reasonForChange',
        defaultMessage: 'Reason for the change',
        description: 'Section title for reason for change'
    },
    prepareForChange: {
        id: 'appUpdatesDetails.prepareForChange',
        defaultMessage: 'How to prepare for the change',
        description: 'Section title for prepare for change'
    },
    getStarted: {
        id: 'appUpdatesDetails.getStarted',
        defaultMessage: 'Getting started',
        description: 'Section title for getting started'
    },
    browserTabTitleSuffix: {
        id: 'appUpdatesDetails.browserTabTitleSuffix',
        defaultMessage: 'Release Notes | Atlassian Community',
        description: 'Browser tab title for the release note details page'
    }
});
const $835ddb2f29e7ae63$var$titleContainerStyles = (0, $c1bec583fa49072f$export$f6c783d06584602c)({
    marginBlockStart: 'space.300'
});
const $835ddb2f29e7ae63$var$mainSectionStyles = (0, $c1bec583fa49072f$export$f6c783d06584602c)({
    flex: 2
});
const $835ddb2f29e7ae63$var$sideSectionStyles = (0, $c1bec583fa49072f$export$f6c783d06584602c)({
    flex: 1,
    marginBlockStart: 'space.500'
});
const $835ddb2f29e7ae63$var$imageContainerStyles = (0, $c1bec583fa49072f$export$f6c783d06584602c)({
    marginBlockEnd: 'space.400',
    overflow: 'hidden',
    lineHeight: 'space.0',
    maxWidth: '800px'
});
const $835ddb2f29e7ae63$var$contentSectionStyles = (0, $c1bec583fa49072f$export$f6c783d06584602c)({
    marginBlockStart: 'space.300'
});
const $835ddb2f29e7ae63$var$renderImage = (update)=>{
    if (!update?.featuredImage) return null;
    const { url: url, altTag: altTag, title: title, width: width, height: height } = update.featuredImage;
    const isHorizontal = width >= height;
    return /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $383dd904a5a5e5b0$export$2e2bcd8739ae039), {
        xcss: $835ddb2f29e7ae63$var$imageContainerStyles,
        children: /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $43a52dbdb7ebc3db$export$4935cefa9e8adac4), {
            src: url,
            altTag: altTag,
            title: title,
            width: isHorizontal ? '100%' : width,
            height: isHorizontal ? 'auto' : height,
            aspectRatio: isHorizontal ? 'unset' : '4 / 3'
        })
    });
};
const $835ddb2f29e7ae63$export$b1cf0b871d8be4ff = ()=>{
    const { formatMessage: formatMessage } = (0, $6Wx3K.default)();
    const [routerState] = (0, $b421c015f5018cd0$export$9a302a45f65d0572)();
    const { sendScreenEvent: sendScreenEvent } = (0, $a442bdf486731fcc$export$62b6ee20d27ead99)();
    const { analyticsOptOut: analyticsOptOut } = (0, $38056d680fac42ff$export$b224af886b957a5e)();
    // TODO: - Fix bug: If the details page was opened in a new tab this doesn't do anything.
    // If it says "go back to release notes page" and you click it, user expects it to work.
    const handleBackClick = ()=>window.history.back();
    const updateId = routerState.match.params.id || null;
    const { update: update, isUpdateLoading: isUpdateLoading, hasErrors: hasErrors } = (0, $aae63e431edf6a1c$export$d1b34fec48b30a4f)(updateId);
    // Mark the update as read after the user has spent READ_TIME_THRESHOLD_MS on the page.
    // Only runs when: user has not opted out of analytics, and data has loaded.
    (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).useEffect(()=>{
        if (analyticsOptOut || !update || !updateId || !update.firstPublishedAt) return;
        const timerId = setTimeout(()=>{
            (0, $15b90d5900f709a5$export$dc76bba8c4f0075f)({
                id: updateId,
                firstPublishedAt: update.firstPublishedAt
            });
        }, (0, $482ba924d5ad5f3a$export$502a1fb2342439ae));
        return ()=>clearTimeout(timerId);
    }, [
        analyticsOptOut,
        update,
        updateId
    ]);
    // Fire screen event after data loads so we can include changelogId and updatesAppTypes attributes
    (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).useEffect(()=>{
        if (update && updateId) {
            const appTypes = update.productTypes?.join(',');
            sendScreenEvent((0, $3e8e9266fe04abe4$export$73f866ce8175509a).screen.appUpdatesDetailsScreen(updateId, appTypes).data);
        }
    }, [
        sendScreenEvent,
        update,
        updateId
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).useEffect(()=>{
        if (typeof window.scrollTo === 'function') window.scrollTo({
            top: 0,
            left: 0
        });
    }, [
        updateId
    ]);
    // UFOSegment provides interaction context for UFOLoadHold.
    // UFOLoadHold holds the page-load interaction open while data is loading;
    // react-ufo auto-completes and sends the event when isUpdateLoading becomes false.
    // It is rendered in all states (loading, error, success) so the hold is always released.
    return /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsxs)((0, $Un5hy.default), {
        name: "app-updates-details",
        children: [
            /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $k7fIB.default), {
                name: "update-data",
                hold: isUpdateLoading
            }),
            isUpdateLoading && /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $383dd904a5a5e5b0$export$2e2bcd8739ae039), {
                padding: "space.300",
                children: /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsxs)((0, $c8dbef6c41cfa689$export$2e2bcd8739ae039), {
                    space: "space.300",
                    alignInline: "center",
                    children: [
                        /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $9ztDu.default), {
                            label: formatMessage($835ddb2f29e7ae63$var$messages.loading)
                        }),
                        /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $d48daa9a522ca942$export$2e2bcd8739ae039), {
                            children: formatMessage($835ddb2f29e7ae63$var$messages.loading)
                        })
                    ]
                })
            }),
            !isUpdateLoading && (!update || hasErrors) && /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $383dd904a5a5e5b0$export$2e2bcd8739ae039), {
                as: "main",
                padding: "space.300",
                children: /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsxs)((0, $c8dbef6c41cfa689$export$2e2bcd8739ae039), {
                    space: "space.300",
                    children: [
                        /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $dUWEU.default), {
                            appearance: "primary",
                            iconBefore: (0, (/*@__PURE__*/$parcel$interopDefault($fiGqm))),
                            onClick: handleBackClick,
                            children: formatMessage($835ddb2f29e7ae63$var$messages.backAction)
                        }),
                        /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $d48daa9a522ca942$export$2e2bcd8739ae039), {
                            color: "color.text.danger",
                            children: formatMessage(hasErrors ? $835ddb2f29e7ae63$var$messages.error : $835ddb2f29e7ae63$var$messages.notFound)
                        })
                    ]
                })
            }),
            !isUpdateLoading && update && !hasErrors && /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsxs)((0, $383dd904a5a5e5b0$export$2e2bcd8739ae039), {
                as: "main",
                paddingBlockStart: "space.300",
                children: [
                    /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $448e9b7b3295f6e4$export$dcef8f9bb9a41431), {
                        children: /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)("title", {
                            children: formatMessage($835ddb2f29e7ae63$var$messages.browserTabTitleSuffix)
                        })
                    }),
                    /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $383dd904a5a5e5b0$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $dUWEU.default), {
                            appearance: "subtle",
                            iconBefore: (0, (/*@__PURE__*/$parcel$interopDefault($fiGqm))),
                            onClick: handleBackClick,
                            children: formatMessage($835ddb2f29e7ae63$var$messages.backAction)
                        })
                    }),
                    /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsxs)((0, $1b254ba6a068f2f1$export$2e2bcd8739ae039), {
                        gap: "space.150",
                        children: [
                            /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsxs)((0, $c8dbef6c41cfa689$export$2e2bcd8739ae039), {
                                xcss: $835ddb2f29e7ae63$var$mainSectionStyles,
                                space: "space.400",
                                children: [
                                    /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $383dd904a5a5e5b0$export$2e2bcd8739ae039), {
                                        xcss: $835ddb2f29e7ae63$var$titleContainerStyles,
                                        children: /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $bb0Oq.default), {
                                            as: "h1",
                                            size: "xxlarge",
                                            children: update.title
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $bb106d656d239203$export$ab8b745e030c7e6f), {
                                        status: update.status,
                                        type: update.type,
                                        releaseStartDate: update.releaseStartDate,
                                        releaseEndDate: update.releaseEndDate,
                                        impactRating: update.impactRating,
                                        tags: update.tags
                                    }),
                                    /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $408399d1ce27a4df$export$2e0a83ec2e27ecbb), {}),
                                    /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsxs)((0, $383dd904a5a5e5b0$export$2e2bcd8739ae039), {
                                        xcss: $835ddb2f29e7ae63$var$contentSectionStyles,
                                        children: [
                                            update.summary && /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $b1e0b601f9d37334$export$56108d98a201729), {
                                                content: update.summary
                                            }),
                                            $835ddb2f29e7ae63$var$renderImage(update),
                                            update.keyChanges && /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $b1e0b601f9d37334$export$56108d98a201729), {
                                                content: update.keyChanges,
                                                title: formatMessage($835ddb2f29e7ae63$var$messages.keyChanges)
                                            }),
                                            update.benefitsList && /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $b1e0b601f9d37334$export$56108d98a201729), {
                                                content: update.benefitsList,
                                                title: formatMessage($835ddb2f29e7ae63$var$messages.benefits)
                                            }),
                                            update.reasonForChange && /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $b1e0b601f9d37334$export$56108d98a201729), {
                                                content: update.reasonForChange,
                                                title: formatMessage($835ddb2f29e7ae63$var$messages.reasonForChange)
                                            }),
                                            update.prepareForChange && /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $b1e0b601f9d37334$export$56108d98a201729), {
                                                content: update.prepareForChange,
                                                title: formatMessage($835ddb2f29e7ae63$var$messages.prepareForChange)
                                            }),
                                            update.getStarted && /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $b1e0b601f9d37334$export$56108d98a201729), {
                                                content: update.getStarted,
                                                title: formatMessage($835ddb2f29e7ae63$var$messages.getStarted)
                                            })
                                        ]
                                    })
                                ]
                            }),
                            update.products && update.products.length > 0 && /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $383dd904a5a5e5b0$export$2e2bcd8739ae039), {
                                xcss: $835ddb2f29e7ae63$var$sideSectionStyles,
                                children: /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $f521c9d158c3d71f$export$da96d30cc2e733ab), {
                                    products: update.productTypes
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var $835ddb2f29e7ae63$export$2e2bcd8739ae039 = $835ddb2f29e7ae63$export$b1cf0b871d8be4ff;


const $822a62c8758b6be8$export$352552ab999c9092 = {
    name: 'app-updates',
    path: '/release-notes',
    exact: true,
    component: (0, $5be66ddef5c7b610$export$617fd60bbdea4ae5),
    resources: []
};
const $822a62c8758b6be8$export$77c38a6734b02710 = {
    name: 'app-updates-bundled-changes',
    path: (0, $749a6437bd4ec017$export$cd891b82501bb412).RELEASE_TRACKS_CHANGES,
    exact: true,
    component: (0, $5be66ddef5c7b610$export$617fd60bbdea4ae5),
    resources: []
};
const $822a62c8758b6be8$export$3ad0ba51c296adcf = {
    name: 'app-updates-legacy-bundled-changes',
    path: (0, $749a6437bd4ec017$export$cd891b82501bb412).LEGACY_BUNDLED_CHANGES,
    exact: true,
    component: ()=>(0, $5FkrB.createElement)((0, $d60bad8df7964b6c$export$2d8d895a0a0f636e), {
            to: (0, $749a6437bd4ec017$export$cd891b82501bb412).RELEASE_TRACKS_CHANGES
        }),
    resources: []
};
const $822a62c8758b6be8$export$527547b9491d1b85 = {
    name: 'app-updates-details',
    path: '/release-notes/:id',
    exact: true,
    component: (0, $835ddb2f29e7ae63$export$b1cf0b871d8be4ff),
    resources: []
};



'use strict';
function $9bb29d85db6f995e$export$2e2bcd8739ae039(fn, thisArg) {
    return function wrap() {
        return fn.apply(thisArg, arguments);
    };
}



var $3ZMUU = parcelRequire("3ZMUU");
'use strict';
// utils is a library of generic helper functions non-specific to axios
const { toString: $cb898722622e1bbe$var$toString } = Object.prototype;
const { getPrototypeOf: $cb898722622e1bbe$var$getPrototypeOf } = Object;
const { iterator: $cb898722622e1bbe$var$iterator, toStringTag: $cb898722622e1bbe$var$toStringTag } = Symbol;
const $cb898722622e1bbe$var$kindOf = ((cache)=>(thing)=>{
        const str = $cb898722622e1bbe$var$toString.call(thing);
        return cache[str] || (cache[str] = str.slice(8, -1).toLowerCase());
    })(Object.create(null));
const $cb898722622e1bbe$var$kindOfTest = (type)=>{
    type = type.toLowerCase();
    return (thing)=>$cb898722622e1bbe$var$kindOf(thing) === type;
};
const $cb898722622e1bbe$var$typeOfTest = (type)=>(thing)=>typeof thing === type;
/**
 * Determine if a value is a non-null object
 *
 * @param {Object} val The value to test
 *
 * @returns {boolean} True if value is an Array, otherwise false
 */ const { isArray: $cb898722622e1bbe$var$isArray } = Array;
/**
 * Determine if a value is undefined
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if the value is undefined, otherwise false
 */ const $cb898722622e1bbe$var$isUndefined = $cb898722622e1bbe$var$typeOfTest('undefined');
/**
 * Determine if a value is a Buffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Buffer, otherwise false
 */ function $cb898722622e1bbe$var$isBuffer(val) {
    return val !== null && !$cb898722622e1bbe$var$isUndefined(val) && val.constructor !== null && !$cb898722622e1bbe$var$isUndefined(val.constructor) && $cb898722622e1bbe$var$isFunction(val.constructor.isBuffer) && val.constructor.isBuffer(val);
}
/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */ const $cb898722622e1bbe$var$isArrayBuffer = $cb898722622e1bbe$var$kindOfTest('ArrayBuffer');
/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */ function $cb898722622e1bbe$var$isArrayBufferView(val) {
    let result;
    if (typeof ArrayBuffer !== 'undefined' && ArrayBuffer.isView) result = ArrayBuffer.isView(val);
    else result = val && val.buffer && $cb898722622e1bbe$var$isArrayBuffer(val.buffer);
    return result;
}
/**
 * Determine if a value is a String
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a String, otherwise false
 */ const $cb898722622e1bbe$var$isString = $cb898722622e1bbe$var$typeOfTest('string');
/**
 * Determine if a value is a Function
 *
 * @param {*} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */ const $cb898722622e1bbe$var$isFunction = $cb898722622e1bbe$var$typeOfTest('function');
/**
 * Determine if a value is a Number
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Number, otherwise false
 */ const $cb898722622e1bbe$var$isNumber = $cb898722622e1bbe$var$typeOfTest('number');
/**
 * Determine if a value is an Object
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an Object, otherwise false
 */ const $cb898722622e1bbe$var$isObject = (thing)=>thing !== null && typeof thing === 'object';
/**
 * Determine if a value is a Boolean
 *
 * @param {*} thing The value to test
 * @returns {boolean} True if value is a Boolean, otherwise false
 */ const $cb898722622e1bbe$var$isBoolean = (thing)=>thing === true || thing === false;
/**
 * Determine if a value is a plain Object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a plain Object, otherwise false
 */ const $cb898722622e1bbe$var$isPlainObject = (val)=>{
    if ($cb898722622e1bbe$var$kindOf(val) !== 'object') return false;
    const prototype = $cb898722622e1bbe$var$getPrototypeOf(val);
    return (prototype === null || prototype === Object.prototype || Object.getPrototypeOf(prototype) === null) && !($cb898722622e1bbe$var$toStringTag in val) && !($cb898722622e1bbe$var$iterator in val);
};
/**
 * Determine if a value is an empty object (safely handles Buffers)
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is an empty object, otherwise false
 */ const $cb898722622e1bbe$var$isEmptyObject = (val)=>{
    // Early return for non-objects or Buffers to prevent RangeError
    if (!$cb898722622e1bbe$var$isObject(val) || $cb898722622e1bbe$var$isBuffer(val)) return false;
    try {
        return Object.keys(val).length === 0 && Object.getPrototypeOf(val) === Object.prototype;
    } catch (e) {
        // Fallback for any other objects that might cause RangeError with Object.keys()
        return false;
    }
};
/**
 * Determine if a value is a Date
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Date, otherwise false
 */ const $cb898722622e1bbe$var$isDate = $cb898722622e1bbe$var$kindOfTest('Date');
/**
 * Determine if a value is a File
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */ const $cb898722622e1bbe$var$isFile = $cb898722622e1bbe$var$kindOfTest('File');
/**
 * Determine if a value is a React Native Blob
 * React Native "blob": an object with a `uri` attribute. Optionally, it can
 * also have a `name` and `type` attribute to specify filename and content type
 *
 * @see https://github.com/facebook/react-native/blob/26684cf3adf4094eb6c405d345a75bf8c7c0bf88/Libraries/Network/FormData.js#L68-L71
 *
 * @param {*} value The value to test
 *
 * @returns {boolean} True if value is a React Native Blob, otherwise false
 */ const $cb898722622e1bbe$var$isReactNativeBlob = (value)=>{
    return !!(value && typeof value.uri !== 'undefined');
};
/**
 * Determine if environment is React Native
 * ReactNative `FormData` has a non-standard `getParts()` method
 *
 * @param {*} formData The formData to test
 *
 * @returns {boolean} True if environment is React Native, otherwise false
 */ const $cb898722622e1bbe$var$isReactNative = (formData)=>formData && typeof formData.getParts !== 'undefined';
/**
 * Determine if a value is a Blob
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Blob, otherwise false
 */ const $cb898722622e1bbe$var$isBlob = $cb898722622e1bbe$var$kindOfTest('Blob');
/**
 * Determine if a value is a FileList
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a FileList, otherwise false
 */ const $cb898722622e1bbe$var$isFileList = $cb898722622e1bbe$var$kindOfTest('FileList');
/**
 * Determine if a value is a Stream
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Stream, otherwise false
 */ const $cb898722622e1bbe$var$isStream = (val)=>$cb898722622e1bbe$var$isObject(val) && $cb898722622e1bbe$var$isFunction(val.pipe);
/**
 * Determine if a value is a FormData
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an FormData, otherwise false
 */ function $cb898722622e1bbe$var$getGlobal() {
    if (typeof globalThis !== 'undefined') return globalThis;
    if (typeof self !== 'undefined') return self;
    if (typeof window !== 'undefined') return window;
    if (typeof $parcel$global !== 'undefined') return $parcel$global;
    return {};
}
const $cb898722622e1bbe$var$G = $cb898722622e1bbe$var$getGlobal();
const $cb898722622e1bbe$var$FormDataCtor = typeof $cb898722622e1bbe$var$G.FormData !== 'undefined' ? $cb898722622e1bbe$var$G.FormData : undefined;
const $cb898722622e1bbe$var$isFormData = (thing)=>{
    if (!thing) return false;
    if ($cb898722622e1bbe$var$FormDataCtor && thing instanceof $cb898722622e1bbe$var$FormDataCtor) return true;
    // Reject plain objects inheriting directly from Object.prototype so prototype-pollution gadgets can't spoof FormData.
    const proto = $cb898722622e1bbe$var$getPrototypeOf(thing);
    if (!proto || proto === Object.prototype) return false;
    if (!$cb898722622e1bbe$var$isFunction(thing.append)) return false;
    const kind = $cb898722622e1bbe$var$kindOf(thing);
    return kind === 'formdata' || // detect form-data instance
    kind === 'object' && $cb898722622e1bbe$var$isFunction(thing.toString) && thing.toString() === '[object FormData]';
};
/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */ const $cb898722622e1bbe$var$isURLSearchParams = $cb898722622e1bbe$var$kindOfTest('URLSearchParams');
const [$cb898722622e1bbe$var$isReadableStream, $cb898722622e1bbe$var$isRequest, $cb898722622e1bbe$var$isResponse, $cb898722622e1bbe$var$isHeaders] = [
    'ReadableStream',
    'Request',
    'Response',
    'Headers'
].map($cb898722622e1bbe$var$kindOfTest);
/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 *
 * @returns {String} The String freed of excess whitespace
 */ const $cb898722622e1bbe$var$trim = (str)=>{
    return str.trim ? str.trim() : str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '');
};
/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array<unknown>} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 *
 * @param {Object} [options]
 * @param {Boolean} [options.allOwnKeys = false]
 * @returns {any}
 */ function $cb898722622e1bbe$var$forEach(obj, fn, { allOwnKeys: allOwnKeys = false } = {}) {
    // Don't bother if no value provided
    if (obj === null || typeof obj === 'undefined') return;
    let i;
    let l;
    // Force an array if not already something iterable
    if (typeof obj !== 'object') /*eslint no-param-reassign:0*/ obj = [
        obj
    ];
    if ($cb898722622e1bbe$var$isArray(obj)) // Iterate over array values
    for(i = 0, l = obj.length; i < l; i++)fn.call(null, obj[i], i, obj);
    else {
        // Buffer check
        if ($cb898722622e1bbe$var$isBuffer(obj)) return;
        // Iterate over object keys
        const keys = allOwnKeys ? Object.getOwnPropertyNames(obj) : Object.keys(obj);
        const len = keys.length;
        let key;
        for(i = 0; i < len; i++){
            key = keys[i];
            fn.call(null, obj[key], key, obj);
        }
    }
}
/**
 * Finds a key in an object, case-insensitive, returning the actual key name.
 * Returns null if the object is a Buffer or if no match is found.
 *
 * @param {Object} obj - The object to search.
 * @param {string} key - The key to find (case-insensitive).
 * @returns {?string} The actual key name if found, otherwise null.
 */ function $cb898722622e1bbe$var$findKey(obj, key) {
    if ($cb898722622e1bbe$var$isBuffer(obj)) return null;
    key = key.toLowerCase();
    const keys = Object.keys(obj);
    let i = keys.length;
    let _key;
    while(i-- > 0){
        _key = keys[i];
        if (key === _key.toLowerCase()) return _key;
    }
    return null;
}
const $cb898722622e1bbe$var$_global = (()=>{
    /*eslint no-undef:0*/ if (typeof globalThis !== 'undefined') return globalThis;
    return typeof self !== 'undefined' ? self : typeof window !== 'undefined' ? window : $parcel$global;
})();
const $cb898722622e1bbe$var$isContextDefined = (context)=>!$cb898722622e1bbe$var$isUndefined(context) && context !== $cb898722622e1bbe$var$_global;
/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * const result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 *
 * @returns {Object} Result of all merge properties
 */ function $cb898722622e1bbe$var$merge(...objs) {
    const { caseless: caseless, skipUndefined: skipUndefined } = $cb898722622e1bbe$var$isContextDefined(this) && this || {};
    const result = {};
    const assignValue = (val, key)=>{
        // Skip dangerous property names to prevent prototype pollution
        if (key === '__proto__' || key === 'constructor' || key === 'prototype') return;
        // findKey lowercases the key, so caseless lookup only applies to strings —
        // symbol keys are identity-matched.
        const targetKey = caseless && typeof key === 'string' && $cb898722622e1bbe$var$findKey(result, key) || key;
        // Read via own-prop only — a bare `result[targetKey]` walks the prototype
        // chain, so a polluted Object.prototype value could surface here and get
        // copied into the merged result.
        const existing = $cb898722622e1bbe$var$hasOwnProperty(result, targetKey) ? result[targetKey] : undefined;
        if ($cb898722622e1bbe$var$isPlainObject(existing) && $cb898722622e1bbe$var$isPlainObject(val)) result[targetKey] = $cb898722622e1bbe$var$merge(existing, val);
        else if ($cb898722622e1bbe$var$isPlainObject(val)) result[targetKey] = $cb898722622e1bbe$var$merge({}, val);
        else if ($cb898722622e1bbe$var$isArray(val)) result[targetKey] = val.slice();
        else if (!skipUndefined || !$cb898722622e1bbe$var$isUndefined(val)) result[targetKey] = val;
    };
    for(let i = 0, l = objs.length; i < l; i++){
        const source = objs[i];
        if (!source || $cb898722622e1bbe$var$isBuffer(source)) continue;
        $cb898722622e1bbe$var$forEach(source, assignValue);
        if (typeof source !== 'object' || $cb898722622e1bbe$var$isArray(source)) continue;
        const symbols = Object.getOwnPropertySymbols(source);
        for(let j = 0; j < symbols.length; j++){
            const symbol = symbols[j];
            if ($cb898722622e1bbe$var$propertyIsEnumerable.call(source, symbol)) assignValue(source[symbol], symbol);
        }
    }
    return result;
}
/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 *
 * @param {Object} [options]
 * @param {Boolean} [options.allOwnKeys]
 * @returns {Object} The resulting value of object a
 */ const $cb898722622e1bbe$var$extend = (a, b, thisArg, { allOwnKeys: allOwnKeys } = {})=>{
    $cb898722622e1bbe$var$forEach(b, (val, key)=>{
        if (thisArg && $cb898722622e1bbe$var$isFunction(val)) Object.defineProperty(a, key, {
            // Null-proto descriptor so a polluted Object.prototype.get cannot
            // hijack defineProperty's accessor-vs-data resolution.
            __proto__: null,
            value: (0, $9bb29d85db6f995e$export$2e2bcd8739ae039)(val, thisArg),
            writable: true,
            enumerable: true,
            configurable: true
        });
        else Object.defineProperty(a, key, {
            __proto__: null,
            value: val,
            writable: true,
            enumerable: true,
            configurable: true
        });
    }, {
        allOwnKeys: allOwnKeys
    });
    return a;
};
/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 *
 * @returns {string} content value without BOM
 */ const $cb898722622e1bbe$var$stripBOM = (content)=>{
    if (content.charCodeAt(0) === 0xfeff) content = content.slice(1);
    return content;
};
/**
 * Inherit the prototype methods from one constructor into another
 * @param {function} constructor
 * @param {function} superConstructor
 * @param {object} [props]
 * @param {object} [descriptors]
 *
 * @returns {void}
 */ const $cb898722622e1bbe$var$inherits = (constructor, superConstructor, props, descriptors)=>{
    constructor.prototype = Object.create(superConstructor.prototype, descriptors);
    Object.defineProperty(constructor.prototype, 'constructor', {
        __proto__: null,
        value: constructor,
        writable: true,
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(constructor, 'super', {
        __proto__: null,
        value: superConstructor.prototype
    });
    props && Object.assign(constructor.prototype, props);
};
/**
 * Resolve object with deep prototype chain to a flat object
 * @param {Object} sourceObj source object
 * @param {Object} [destObj]
 * @param {Function|Boolean} [filter]
 * @param {Function} [propFilter]
 *
 * @returns {Object}
 */ const $cb898722622e1bbe$var$toFlatObject = (sourceObj, destObj, filter, propFilter)=>{
    let props;
    let i;
    let prop;
    const merged = {};
    destObj = destObj || {};
    // eslint-disable-next-line no-eq-null,eqeqeq
    if (sourceObj == null) return destObj;
    do {
        props = Object.getOwnPropertyNames(sourceObj);
        i = props.length;
        while(i-- > 0){
            prop = props[i];
            if ((!propFilter || propFilter(prop, sourceObj, destObj)) && !merged[prop]) {
                destObj[prop] = sourceObj[prop];
                merged[prop] = true;
            }
        }
        sourceObj = filter !== false && $cb898722622e1bbe$var$getPrototypeOf(sourceObj);
    }while (sourceObj && (!filter || filter(sourceObj, destObj)) && sourceObj !== Object.prototype);
    return destObj;
};
/**
 * Determines whether a string ends with the characters of a specified string
 *
 * @param {String} str
 * @param {String} searchString
 * @param {Number} [position= 0]
 *
 * @returns {boolean}
 */ const $cb898722622e1bbe$var$endsWith = (str, searchString, position)=>{
    str = String(str);
    if (position === undefined || position > str.length) position = str.length;
    position -= searchString.length;
    const lastIndex = str.indexOf(searchString, position);
    return lastIndex !== -1 && lastIndex === position;
};
/**
 * Returns new array from array like object or null if failed
 *
 * @param {*} [thing]
 *
 * @returns {?Array}
 */ const $cb898722622e1bbe$var$toArray = (thing)=>{
    if (!thing) return null;
    if ($cb898722622e1bbe$var$isArray(thing)) return thing;
    let i = thing.length;
    if (!$cb898722622e1bbe$var$isNumber(i)) return null;
    const arr = new Array(i);
    while(i-- > 0)arr[i] = thing[i];
    return arr;
};
/**
 * Checking if the Uint8Array exists and if it does, it returns a function that checks if the
 * thing passed in is an instance of Uint8Array
 *
 * @param {TypedArray}
 *
 * @returns {Array}
 */ // eslint-disable-next-line func-names
const $cb898722622e1bbe$var$isTypedArray = ((TypedArray)=>{
    // eslint-disable-next-line func-names
    return (thing)=>{
        return TypedArray && thing instanceof TypedArray;
    };
})(typeof Uint8Array !== 'undefined' && $cb898722622e1bbe$var$getPrototypeOf(Uint8Array));
/**
 * For each entry in the object, call the function with the key and value.
 *
 * @param {Object<any, any>} obj - The object to iterate over.
 * @param {Function} fn - The function to call for each entry.
 *
 * @returns {void}
 */ const $cb898722622e1bbe$var$forEachEntry = (obj, fn)=>{
    const generator = obj && obj[$cb898722622e1bbe$var$iterator];
    const _iterator = generator.call(obj);
    let result;
    while((result = _iterator.next()) && !result.done){
        const pair = result.value;
        fn.call(obj, pair[0], pair[1]);
    }
};
/**
 * It takes a regular expression and a string, and returns an array of all the matches
 *
 * @param {string} regExp - The regular expression to match against.
 * @param {string} str - The string to search.
 *
 * @returns {Array<boolean>}
 */ const $cb898722622e1bbe$var$matchAll = (regExp, str)=>{
    let matches;
    const arr = [];
    while((matches = regExp.exec(str)) !== null)arr.push(matches);
    return arr;
};
/* Checking if the kindOfTest function returns true when passed an HTMLFormElement. */ const $cb898722622e1bbe$var$isHTMLForm = $cb898722622e1bbe$var$kindOfTest('HTMLFormElement');
const $cb898722622e1bbe$var$toCamelCase = (str)=>{
    return str.toLowerCase().replace(/[-_\s]([a-z\d])(\w*)/g, function replacer(m, p1, p2) {
        return p1.toUpperCase() + p2;
    });
};
/* Creating a function that will check if an object has a property. */ const $cb898722622e1bbe$var$hasOwnProperty = (({ hasOwnProperty: hasOwnProperty })=>(obj, prop)=>hasOwnProperty.call(obj, prop))(Object.prototype);
const { propertyIsEnumerable: $cb898722622e1bbe$var$propertyIsEnumerable } = Object.prototype;
/**
 * Determine if a value is a RegExp object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a RegExp object, otherwise false
 */ const $cb898722622e1bbe$var$isRegExp = $cb898722622e1bbe$var$kindOfTest('RegExp');
const $cb898722622e1bbe$var$reduceDescriptors = (obj, reducer)=>{
    const descriptors = Object.getOwnPropertyDescriptors(obj);
    const reducedDescriptors = {};
    $cb898722622e1bbe$var$forEach(descriptors, (descriptor, name)=>{
        let ret;
        if ((ret = reducer(descriptor, name, obj)) !== false) reducedDescriptors[name] = ret || descriptor;
    });
    Object.defineProperties(obj, reducedDescriptors);
};
/**
 * Makes all methods read-only
 * @param {Object} obj
 */ const $cb898722622e1bbe$var$freezeMethods = (obj)=>{
    $cb898722622e1bbe$var$reduceDescriptors(obj, (descriptor, name)=>{
        // skip restricted props in strict mode
        if ($cb898722622e1bbe$var$isFunction(obj) && [
            'arguments',
            'caller',
            'callee'
        ].includes(name)) return false;
        const value = obj[name];
        if (!$cb898722622e1bbe$var$isFunction(value)) return;
        descriptor.enumerable = false;
        if ('writable' in descriptor) {
            descriptor.writable = false;
            return;
        }
        if (!descriptor.set) descriptor.set = ()=>{
            throw Error("Can not rewrite read-only method '" + name + "'");
        };
    });
};
/**
 * Converts an array or a delimited string into an object set with values as keys and true as values.
 * Useful for fast membership checks.
 *
 * @param {Array|string} arrayOrString - The array or string to convert.
 * @param {string} delimiter - The delimiter to use if input is a string.
 * @returns {Object} An object with keys from the array or string, values set to true.
 */ const $cb898722622e1bbe$var$toObjectSet = (arrayOrString, delimiter)=>{
    const obj = {};
    const define = (arr)=>{
        arr.forEach((value)=>{
            obj[value] = true;
        });
    };
    $cb898722622e1bbe$var$isArray(arrayOrString) ? define(arrayOrString) : define(String(arrayOrString).split(delimiter));
    return obj;
};
const $cb898722622e1bbe$var$noop = ()=>{};
const $cb898722622e1bbe$var$toFiniteNumber = (value, defaultValue)=>{
    return value != null && Number.isFinite(value = +value) ? value : defaultValue;
};
/**
 * If the thing is a FormData object, return true, otherwise return false.
 *
 * @param {unknown} thing - The thing to check.
 *
 * @returns {boolean}
 */ function $cb898722622e1bbe$var$isSpecCompliantForm(thing) {
    return !!(thing && $cb898722622e1bbe$var$isFunction(thing.append) && thing[$cb898722622e1bbe$var$toStringTag] === 'FormData' && thing[$cb898722622e1bbe$var$iterator]);
}
/**
 * Recursively converts an object to a JSON-compatible object, handling circular references and Buffers.
 *
 * @param {Object} obj - The object to convert.
 * @returns {Object} The JSON-compatible object.
 */ const $cb898722622e1bbe$var$toJSONObject = (obj)=>{
    const visited = new WeakSet();
    const visit = (source)=>{
        if ($cb898722622e1bbe$var$isObject(source)) {
            if (visited.has(source)) return;
            //Buffer check
            if ($cb898722622e1bbe$var$isBuffer(source)) return source;
            if (!('toJSON' in source)) {
                // add-on descent / delete-on-ascent: preserves path semantics, so DAG nodes serialise at every occurrence (see #7230).
                visited.add(source);
                const target = $cb898722622e1bbe$var$isArray(source) ? [] : {};
                $cb898722622e1bbe$var$forEach(source, (value, key)=>{
                    const reducedValue = visit(value);
                    !$cb898722622e1bbe$var$isUndefined(reducedValue) && (target[key] = reducedValue);
                });
                visited.delete(source);
                return target;
            }
        }
        return source;
    };
    return visit(obj);
};
/**
 * Determines if a value is an async function.
 *
 * @param {*} thing - The value to test.
 * @returns {boolean} True if value is an async function, otherwise false.
 */ const $cb898722622e1bbe$var$isAsyncFn = $cb898722622e1bbe$var$kindOfTest('AsyncFunction');
/**
 * Determines if a value is thenable (has then and catch methods).
 *
 * @param {*} thing - The value to test.
 * @returns {boolean} True if value is thenable, otherwise false.
 */ const $cb898722622e1bbe$var$isThenable = (thing)=>thing && ($cb898722622e1bbe$var$isObject(thing) || $cb898722622e1bbe$var$isFunction(thing)) && $cb898722622e1bbe$var$isFunction(thing.then) && $cb898722622e1bbe$var$isFunction(thing.catch);
// original code
// https://github.com/DigitalBrainJS/AxiosPromise/blob/16deab13710ec09779922131f3fa5954320f83ab/lib/utils.js#L11-L34
/**
 * Provides a cross-platform setImmediate implementation.
 * Uses native setImmediate if available, otherwise falls back to postMessage or setTimeout.
 *
 * @param {boolean} setImmediateSupported - Whether setImmediate is supported.
 * @param {boolean} postMessageSupported - Whether postMessage is supported.
 * @returns {Function} A function to schedule a callback asynchronously.
 */ const $cb898722622e1bbe$var$_setImmediate = ((setImmediateSupported, postMessageSupported)=>{
    if (setImmediateSupported) return setImmediate;
    return postMessageSupported ? ((token, callbacks)=>{
        $cb898722622e1bbe$var$_global.addEventListener('message', ({ source: source, data: data })=>{
            if (source === $cb898722622e1bbe$var$_global && data === token) callbacks.length && callbacks.shift()();
        }, false);
        return (cb)=>{
            callbacks.push(cb);
            $cb898722622e1bbe$var$_global.postMessage(token, '*');
        };
    })(`axios@${Math.random()}`, []) : (cb)=>setTimeout(cb);
})(typeof setImmediate === 'function', $cb898722622e1bbe$var$isFunction($cb898722622e1bbe$var$_global.postMessage));
/**
 * Schedules a microtask or asynchronous callback as soon as possible.
 * Uses queueMicrotask if available, otherwise falls back to process.nextTick or _setImmediate.
 *
 * @type {Function}
 */ const $cb898722622e1bbe$var$asap = typeof queueMicrotask !== 'undefined' ? queueMicrotask.bind($cb898722622e1bbe$var$_global) : typeof $3ZMUU !== 'undefined' && $3ZMUU.nextTick || $cb898722622e1bbe$var$_setImmediate;
// *********************
const $cb898722622e1bbe$var$isIterable = (thing)=>thing != null && $cb898722622e1bbe$var$isFunction(thing[$cb898722622e1bbe$var$iterator]);
var $cb898722622e1bbe$export$2e2bcd8739ae039 = {
    isArray: $cb898722622e1bbe$var$isArray,
    isArrayBuffer: $cb898722622e1bbe$var$isArrayBuffer,
    isBuffer: $cb898722622e1bbe$var$isBuffer,
    isFormData: $cb898722622e1bbe$var$isFormData,
    isArrayBufferView: $cb898722622e1bbe$var$isArrayBufferView,
    isString: $cb898722622e1bbe$var$isString,
    isNumber: $cb898722622e1bbe$var$isNumber,
    isBoolean: $cb898722622e1bbe$var$isBoolean,
    isObject: $cb898722622e1bbe$var$isObject,
    isPlainObject: $cb898722622e1bbe$var$isPlainObject,
    isEmptyObject: $cb898722622e1bbe$var$isEmptyObject,
    isReadableStream: $cb898722622e1bbe$var$isReadableStream,
    isRequest: $cb898722622e1bbe$var$isRequest,
    isResponse: $cb898722622e1bbe$var$isResponse,
    isHeaders: $cb898722622e1bbe$var$isHeaders,
    isUndefined: $cb898722622e1bbe$var$isUndefined,
    isDate: $cb898722622e1bbe$var$isDate,
    isFile: $cb898722622e1bbe$var$isFile,
    isReactNativeBlob: $cb898722622e1bbe$var$isReactNativeBlob,
    isReactNative: $cb898722622e1bbe$var$isReactNative,
    isBlob: $cb898722622e1bbe$var$isBlob,
    isRegExp: $cb898722622e1bbe$var$isRegExp,
    isFunction: $cb898722622e1bbe$var$isFunction,
    isStream: $cb898722622e1bbe$var$isStream,
    isURLSearchParams: $cb898722622e1bbe$var$isURLSearchParams,
    isTypedArray: $cb898722622e1bbe$var$isTypedArray,
    isFileList: $cb898722622e1bbe$var$isFileList,
    forEach: $cb898722622e1bbe$var$forEach,
    merge: $cb898722622e1bbe$var$merge,
    extend: $cb898722622e1bbe$var$extend,
    trim: $cb898722622e1bbe$var$trim,
    stripBOM: $cb898722622e1bbe$var$stripBOM,
    inherits: $cb898722622e1bbe$var$inherits,
    toFlatObject: $cb898722622e1bbe$var$toFlatObject,
    kindOf: $cb898722622e1bbe$var$kindOf,
    kindOfTest: $cb898722622e1bbe$var$kindOfTest,
    endsWith: $cb898722622e1bbe$var$endsWith,
    toArray: $cb898722622e1bbe$var$toArray,
    forEachEntry: $cb898722622e1bbe$var$forEachEntry,
    matchAll: $cb898722622e1bbe$var$matchAll,
    isHTMLForm: $cb898722622e1bbe$var$isHTMLForm,
    hasOwnProperty: $cb898722622e1bbe$var$hasOwnProperty,
    hasOwnProp: $cb898722622e1bbe$var$hasOwnProperty,
    reduceDescriptors: $cb898722622e1bbe$var$reduceDescriptors,
    freezeMethods: $cb898722622e1bbe$var$freezeMethods,
    toObjectSet: $cb898722622e1bbe$var$toObjectSet,
    toCamelCase: $cb898722622e1bbe$var$toCamelCase,
    noop: $cb898722622e1bbe$var$noop,
    toFiniteNumber: $cb898722622e1bbe$var$toFiniteNumber,
    findKey: $cb898722622e1bbe$var$findKey,
    global: $cb898722622e1bbe$var$_global,
    isContextDefined: $cb898722622e1bbe$var$isContextDefined,
    isSpecCompliantForm: $cb898722622e1bbe$var$isSpecCompliantForm,
    toJSONObject: $cb898722622e1bbe$var$toJSONObject,
    isAsyncFn: $cb898722622e1bbe$var$isAsyncFn,
    isThenable: $cb898722622e1bbe$var$isThenable,
    setImmediate: $cb898722622e1bbe$var$_setImmediate,
    asap: $cb898722622e1bbe$var$asap,
    isIterable: $cb898722622e1bbe$var$isIterable
};









'use strict';
// RawAxiosHeaders whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
const $6e51a7800d926fe5$var$ignoreDuplicateOf = (0, $cb898722622e1bbe$export$2e2bcd8739ae039).toObjectSet([
    'age',
    'authorization',
    'content-length',
    'content-type',
    'etag',
    'expires',
    'from',
    'host',
    'if-modified-since',
    'if-unmodified-since',
    'last-modified',
    'location',
    'max-forwards',
    'proxy-authorization',
    'referer',
    'retry-after',
    'user-agent'
]);
var /**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} rawHeaders Headers needing to be parsed
 *
 * @returns {Object} Headers parsed into an object
 */ $6e51a7800d926fe5$export$2e2bcd8739ae039 = (rawHeaders)=>{
    const parsed = {};
    let key;
    let val;
    let i;
    rawHeaders && rawHeaders.split('\n').forEach(function parser(line) {
        i = line.indexOf(':');
        key = line.substring(0, i).trim().toLowerCase();
        val = line.substring(i + 1).trim();
        if (!key || parsed[key] && $6e51a7800d926fe5$var$ignoreDuplicateOf[key]) return;
        if (key === 'set-cookie') {
            if (parsed[key]) parsed[key].push(val);
            else parsed[key] = [
                val
            ];
        } else parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
    });
    return parsed;
};



'use strict';
function $b4b7fdb921feec02$var$trimSPorHTAB(str) {
    let start = 0;
    let end = str.length;
    while(start < end){
        const code = str.charCodeAt(start);
        if (code !== 0x09 && code !== 0x20) break;
        start += 1;
    }
    while(end > start){
        const code = str.charCodeAt(end - 1);
        if (code !== 0x09 && code !== 0x20) break;
        end -= 1;
    }
    return start === 0 && end === str.length ? str : str.slice(start, end);
}
// The control-code ranges are intentional: header sanitization strips C0/DEL bytes.
// eslint-disable-next-line no-control-regex
const $b4b7fdb921feec02$var$INVALID_UNICODE_HEADER_VALUE_CHARS = new RegExp('[\\u0000-\\u0008\\u000a-\\u001f\\u007f]+', 'g');
// eslint-disable-next-line no-control-regex
const $b4b7fdb921feec02$var$INVALID_BYTE_STRING_HEADER_VALUE_CHARS = new RegExp('[^\\u0009\\u0020-\\u007e\\u0080-\\u00ff]+', 'g');
function $b4b7fdb921feec02$var$sanitizeValue(value, invalidChars) {
    if ((0, $cb898722622e1bbe$export$2e2bcd8739ae039).isArray(value)) return value.map((item)=>$b4b7fdb921feec02$var$sanitizeValue(item, invalidChars));
    return $b4b7fdb921feec02$var$trimSPorHTAB(String(value).replace(invalidChars, ''));
}
const $b4b7fdb921feec02$export$9e344cffce061a22 = (value)=>$b4b7fdb921feec02$var$sanitizeValue(value, $b4b7fdb921feec02$var$INVALID_UNICODE_HEADER_VALUE_CHARS);
const $b4b7fdb921feec02$export$59dd66c2a12d8f62 = (value)=>$b4b7fdb921feec02$var$sanitizeValue(value, $b4b7fdb921feec02$var$INVALID_BYTE_STRING_HEADER_VALUE_CHARS);
function $b4b7fdb921feec02$export$c30c72bb7e677d54(headers) {
    const byteStringHeaders = Object.create(null);
    (0, $cb898722622e1bbe$export$2e2bcd8739ae039).forEach(headers.toJSON(), (value, header)=>{
        byteStringHeaders[header] = $b4b7fdb921feec02$export$59dd66c2a12d8f62(value);
    });
    return byteStringHeaders;
}


'use strict';
const $a107ecb812e3a6a9$var$$internals = Symbol('internals');
function $a107ecb812e3a6a9$var$normalizeHeader(header) {
    return header && String(header).trim().toLowerCase();
}
function $a107ecb812e3a6a9$var$normalizeValue(value) {
    if (value === false || value == null) return value;
    return (0, $cb898722622e1bbe$export$2e2bcd8739ae039).isArray(value) ? value.map($a107ecb812e3a6a9$var$normalizeValue) : (0, $b4b7fdb921feec02$export$9e344cffce061a22)(String(value));
}
function $a107ecb812e3a6a9$var$parseTokens(str) {
    const tokens = Object.create(null);
    const tokensRE = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
    let match;
    while(match = tokensRE.exec(str))tokens[match[1]] = match[2];
    return tokens;
}
const $a107ecb812e3a6a9$var$isValidHeaderName = (str)=>/^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(str.trim());
function $a107ecb812e3a6a9$var$matchHeaderValue(context, value, header, filter, isHeaderNameFilter) {
    if ((0, $cb898722622e1bbe$export$2e2bcd8739ae039).isFunction(filter)) return filter.call(this, value, header);
    if (isHeaderNameFilter) value = header;
    if (!(0, $cb898722622e1bbe$export$2e2bcd8739ae039).isString(value)) return;
    if ((0, $cb898722622e1bbe$export$2e2bcd8739ae039).isString(filter)) return value.indexOf(filter) !== -1;
    if ((0, $cb898722622e1bbe$export$2e2bcd8739ae039).isRegExp(filter)) return filter.test(value);
}
function $a107ecb812e3a6a9$var$formatHeader(header) {
    return header.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (w, char, str)=>{
        return char.toUpperCase() + str;
    });
}
function $a107ecb812e3a6a9$var$buildAccessors(obj, header) {
    const accessorName = (0, $cb898722622e1bbe$export$2e2bcd8739ae039).toCamelCase(' ' + header);
    [
        'get',
        'set',
        'has'
    ].forEach((methodName)=>{
        Object.defineProperty(obj, methodName + accessorName, {
            // Null-proto descriptor so a polluted Object.prototype.get cannot turn
            // this data descriptor into an accessor descriptor on the way in.
            __proto__: null,
            value: function(arg1, arg2, arg3) {
                return this[methodName].call(this, header, arg1, arg2, arg3);
            },
            configurable: true
        });
    });
}
class $a107ecb812e3a6a9$var$AxiosHeaders {
    constructor(headers){
        headers && this.set(headers);
    }
    set(header, valueOrRewrite, rewrite) {
        const self = this;
        function setHeader(_value, _header, _rewrite) {
            const lHeader = $a107ecb812e3a6a9$var$normalizeHeader(_header);
            if (!lHeader) return;
            const key = (0, $cb898722622e1bbe$export$2e2bcd8739ae039).findKey(self, lHeader);
            if (!key || self[key] === undefined || _rewrite === true || _rewrite === undefined && self[key] !== false) self[key || _header] = $a107ecb812e3a6a9$var$normalizeValue(_value);
        }
        const setHeaders = (headers, _rewrite)=>(0, $cb898722622e1bbe$export$2e2bcd8739ae039).forEach(headers, (_value, _header)=>setHeader(_value, _header, _rewrite));
        if ((0, $cb898722622e1bbe$export$2e2bcd8739ae039).isPlainObject(header) || header instanceof this.constructor) setHeaders(header, valueOrRewrite);
        else if ((0, $cb898722622e1bbe$export$2e2bcd8739ae039).isString(header) && (header = header.trim()) && !$a107ecb812e3a6a9$var$isValidHeaderName(header)) setHeaders((0, $6e51a7800d926fe5$export$2e2bcd8739ae039)(header), valueOrRewrite);
        else if ((0, $cb898722622e1bbe$export$2e2bcd8739ae039).isObject(header) && (0, $cb898722622e1bbe$export$2e2bcd8739ae039).isIterable(header)) {
            let obj = {}, dest, key;
            for (const entry of header){
                if (!(0, $cb898722622e1bbe$export$2e2bcd8739ae039).isArray(entry)) throw new TypeError('Object iterator must return a key-value pair');
                obj[key = entry[0]] = (dest = obj[key]) ? (0, $cb898722622e1bbe$export$2e2bcd8739ae039).isArray(dest) ? [
                    ...dest,
                    entry[1]
                ] : [
                    dest,
                    entry[1]
                ] : entry[1];
            }
            setHeaders(obj, valueOrRewrite);
        } else header != null && setHeader(valueOrRewrite, header, rewrite);
        return this;
    }
    get(header, parser) {
        header = $a107ecb812e3a6a9$var$normalizeHeader(header);
        if (header) {
            const key = (0, $cb898722622e1bbe$export$2e2bcd8739ae039).findKey(this, header);
            if (key) {
                const value = this[key];
                if (!parser) return value;
                if (parser === true) return $a107ecb812e3a6a9$var$parseTokens(value);
                if ((0, $cb898722622e1bbe$export$2e2bcd8739ae039).isFunction(parser)) return parser.call(this, value, key);
                if ((0, $cb898722622e1bbe$export$2e2bcd8739ae039).isRegExp(parser)) return parser.exec(value);
                throw new TypeError('parser must be boolean|regexp|function');
            }
        }
    }
    has(header, matcher) {
        header = $a107ecb812e3a6a9$var$normalizeHeader(header);
        if (header) {
            const key = (0, $cb898722622e1bbe$export$2e2bcd8739ae039).findKey(this, header);
            return !!(key && this[key] !== undefined && (!matcher || $a107ecb812e3a6a9$var$matchHeaderValue(this, this[key], key, matcher)));
        }
        return false;
    }
    delete(header, matcher) {
        const self = this;
        let deleted = false;
        function deleteHeader(_header) {
            _header = $a107ecb812e3a6a9$var$normalizeHeader(_header);
            if (_header) {
                const key = (0, $cb898722622e1bbe$export$2e2bcd8739ae039).findKey(self, _header);
                if (key && (!matcher || $a107ecb812e3a6a9$var$matchHeaderValue(self, self[key], key, matcher))) {
                    delete self[key];
                    deleted = true;
                }
            }
        }
        if ((0, $cb898722622e1bbe$export$2e2bcd8739ae039).isArray(header)) header.forEach(deleteHeader);
        else deleteHeader(header);
        return deleted;
    }
    clear(matcher) {
        const keys = Object.keys(this);
        let i = keys.length;
        let deleted = false;
        while(i--){
            const key = keys[i];
            if (!matcher || $a107ecb812e3a6a9$var$matchHeaderValue(this, this[key], key, matcher, true)) {
                delete this[key];
                deleted = true;
            }
        }
        return deleted;
    }
    normalize(format) {
        const self = this;
        const headers = {};
        (0, $cb898722622e1bbe$export$2e2bcd8739ae039).forEach(this, (value, header)=>{
            const key = (0, $cb898722622e1bbe$export$2e2bcd8739ae039).findKey(headers, header);
            if (key) {
                self[key] = $a107ecb812e3a6a9$var$normalizeValue(value);
                delete self[header];
                return;
            }
            const normalized = format ? $a107ecb812e3a6a9$var$formatHeader(header) : String(header).trim();
            if (normalized !== header) delete self[header];
            self[normalized] = $a107ecb812e3a6a9$var$normalizeValue(value);
            headers[normalized] = true;
        });
        return this;
    }
    concat(...targets) {
        return this.constructor.concat(this, ...targets);
    }
    toJSON(asStrings) {
        const obj = Object.create(null);
        (0, $cb898722622e1bbe$export$2e2bcd8739ae039).forEach(this, (value, header)=>{
            value != null && value !== false && (obj[header] = asStrings && (0, $cb898722622e1bbe$export$2e2bcd8739ae039).isArray(value) ? value.join(', ') : value);
        });
        return obj;
    }
    [Symbol.iterator]() {
        return Object.entries(this.toJSON())[Symbol.iterator]();
    }
    toString() {
        return Object.entries(this.toJSON()).map(([header, value])=>header + ': ' + value).join('\n');
    }
    getSetCookie() {
        return this.get('set-cookie') || [];
    }
    get [Symbol.toStringTag]() {
        return 'AxiosHeaders';
    }
    static from(thing) {
        return thing instanceof this ? thing : new this(thing);
    }
    static concat(first, ...targets) {
        const computed = new this(first);
        targets.forEach((target)=>computed.set(target));
        return computed;
    }
    static accessor(header) {
        const internals = this[$a107ecb812e3a6a9$var$$internals] = this[$a107ecb812e3a6a9$var$$internals] = {
            accessors: {}
        };
        const accessors = internals.accessors;
        const prototype = this.prototype;
        function defineAccessor(_header) {
            const lHeader = $a107ecb812e3a6a9$var$normalizeHeader(_header);
            if (!accessors[lHeader]) {
                $a107ecb812e3a6a9$var$buildAccessors(prototype, _header);
                accessors[lHeader] = true;
            }
        }
        (0, $cb898722622e1bbe$export$2e2bcd8739ae039).isArray(header) ? header.forEach(defineAccessor) : defineAccessor(header);
        return this;
    }
}
$a107ecb812e3a6a9$var$AxiosHeaders.accessor([
    'Content-Type',
    'Content-Length',
    'Accept',
    'Accept-Encoding',
    'User-Agent',
    'Authorization'
]);
// reserved names hotfix
(0, $cb898722622e1bbe$export$2e2bcd8739ae039).reduceDescriptors($a107ecb812e3a6a9$var$AxiosHeaders.prototype, ({ value: value }, key)=>{
    let mapped = key[0].toUpperCase() + key.slice(1); // map `set` => `Set`
    return {
        get: ()=>value,
        set (headerValue) {
            this[mapped] = headerValue;
        }
    };
});
(0, $cb898722622e1bbe$export$2e2bcd8739ae039).freezeMethods($a107ecb812e3a6a9$var$AxiosHeaders);
var $a107ecb812e3a6a9$export$2e2bcd8739ae039 = $a107ecb812e3a6a9$var$AxiosHeaders;


'use strict';
const $f9b1affb0498ba1f$var$REDACTED = '[REDACTED ****]';
function $f9b1affb0498ba1f$var$hasOwnOrPrototypeToJSON(source) {
    if ((0, $cb898722622e1bbe$export$2e2bcd8739ae039).hasOwnProp(source, 'toJSON')) return true;
    let prototype = Object.getPrototypeOf(source);
    while(prototype && prototype !== Object.prototype){
        if ((0, $cb898722622e1bbe$export$2e2bcd8739ae039).hasOwnProp(prototype, 'toJSON')) return true;
        prototype = Object.getPrototypeOf(prototype);
    }
    return false;
}
// Build a plain-object snapshot of `config` and replace the value of any key
// (case-insensitive) listed in `redactKeys` with REDACTED. Walks through arrays
// and AxiosHeaders, and short-circuits on circular references.
function $f9b1affb0498ba1f$var$redactConfig(config, redactKeys) {
    const lowerKeys = new Set(redactKeys.map((k)=>String(k).toLowerCase()));
    const seen = [];
    const visit = (source)=>{
        if (source === null || typeof source !== 'object') return source;
        if ((0, $cb898722622e1bbe$export$2e2bcd8739ae039).isBuffer(source)) return source;
        if (seen.indexOf(source) !== -1) return undefined;
        if (source instanceof (0, $a107ecb812e3a6a9$export$2e2bcd8739ae039)) source = source.toJSON();
        seen.push(source);
        let result;
        if ((0, $cb898722622e1bbe$export$2e2bcd8739ae039).isArray(source)) {
            result = [];
            source.forEach((v, i)=>{
                const reducedValue = visit(v);
                if (!(0, $cb898722622e1bbe$export$2e2bcd8739ae039).isUndefined(reducedValue)) result[i] = reducedValue;
            });
        } else {
            if (!(0, $cb898722622e1bbe$export$2e2bcd8739ae039).isPlainObject(source) && $f9b1affb0498ba1f$var$hasOwnOrPrototypeToJSON(source)) {
                seen.pop();
                return source;
            }
            result = Object.create(null);
            for (const [key, value] of Object.entries(source)){
                const reducedValue = lowerKeys.has(key.toLowerCase()) ? $f9b1affb0498ba1f$var$REDACTED : visit(value);
                if (!(0, $cb898722622e1bbe$export$2e2bcd8739ae039).isUndefined(reducedValue)) result[key] = reducedValue;
            }
        }
        seen.pop();
        return result;
    };
    return visit(config);
}
class $f9b1affb0498ba1f$var$AxiosError extends Error {
    static from(error, code, config, request, response, customProps) {
        const axiosError = new $f9b1affb0498ba1f$var$AxiosError(error.message, code || error.code, config, request, response);
        axiosError.cause = error;
        axiosError.name = error.name;
        // Preserve status from the original error if not already set from response
        if (error.status != null && axiosError.status == null) axiosError.status = error.status;
        customProps && Object.assign(axiosError, customProps);
        return axiosError;
    }
    /**
   * Create an Error with the specified message, config, error code, request and response.
   *
   * @param {string} message The error message.
   * @param {string} [code] The error code (for example, 'ECONNABORTED').
   * @param {Object} [config] The config.
   * @param {Object} [request] The request.
   * @param {Object} [response] The response.
   *
   * @returns {Error} The created error.
   */ constructor(message, code, config, request, response){
        super(message);
        // Make message enumerable to maintain backward compatibility
        // The native Error constructor sets message as non-enumerable,
        // but axios < v1.13.3 had it as enumerable
        Object.defineProperty(this, 'message', {
            // Null-proto descriptor so a polluted Object.prototype.get cannot turn
            // this data descriptor into an accessor descriptor on the way in.
            __proto__: null,
            value: message,
            enumerable: true,
            writable: true,
            configurable: true
        });
        this.name = 'AxiosError';
        this.isAxiosError = true;
        code && (this.code = code);
        config && (this.config = config);
        request && (this.request = request);
        if (response) {
            this.response = response;
            this.status = response.status;
        }
    }
    toJSON() {
        // Opt-in redaction: when the request config carries a `redact` array, the
        // value of any matching key (case-insensitive, at any depth) is replaced
        // with REDACTED in the serialized snapshot. Undefined or empty leaves the
        // existing serialization behavior unchanged.
        const config = this.config;
        const redactKeys = config && (0, $cb898722622e1bbe$export$2e2bcd8739ae039).hasOwnProp(config, 'redact') ? config.redact : undefined;
        const serializedConfig = (0, $cb898722622e1bbe$export$2e2bcd8739ae039).isArray(redactKeys) && redactKeys.length > 0 ? $f9b1affb0498ba1f$var$redactConfig(config, redactKeys) : (0, $cb898722622e1bbe$export$2e2bcd8739ae039).toJSONObject(config);
        return {
            // Standard
            message: this.message,
            name: this.name,
            // Microsoft
            description: this.description,
            number: this.number,
            // Mozilla
            fileName: this.fileName,
            lineNumber: this.lineNumber,
            columnNumber: this.columnNumber,
            stack: this.stack,
            // Axios
            config: serializedConfig,
            code: this.code,
            status: this.status
        };
    }
}
// This can be changed to static properties as soon as the parser options in .eslint.cjs are updated.
$f9b1affb0498ba1f$var$AxiosError.ERR_BAD_OPTION_VALUE = 'ERR_BAD_OPTION_VALUE';
$f9b1affb0498ba1f$var$AxiosError.ERR_BAD_OPTION = 'ERR_BAD_OPTION';
$f9b1affb0498ba1f$var$AxiosError.ECONNABORTED = 'ECONNABORTED';
$f9b1affb0498ba1f$var$AxiosError.ETIMEDOUT = 'ETIMEDOUT';
$f9b1affb0498ba1f$var$AxiosError.ECONNREFUSED = 'ECONNREFUSED';
$f9b1affb0498ba1f$var$AxiosError.ERR_NETWORK = 'ERR_NETWORK';
$f9b1affb0498ba1f$var$AxiosError.ERR_FR_TOO_MANY_REDIRECTS = 'ERR_FR_TOO_MANY_REDIRECTS';
$f9b1affb0498ba1f$var$AxiosError.ERR_DEPRECATED = 'ERR_DEPRECATED';
$f9b1affb0498ba1f$var$AxiosError.ERR_BAD_RESPONSE = 'ERR_BAD_RESPONSE';
$f9b1affb0498ba1f$var$AxiosError.ERR_BAD_REQUEST = 'ERR_BAD_REQUEST';
$f9b1affb0498ba1f$var$AxiosError.ERR_CANCELED = 'ERR_CANCELED';
$f9b1affb0498ba1f$var$AxiosError.ERR_NOT_SUPPORT = 'ERR_NOT_SUPPORT';
$f9b1affb0498ba1f$var$AxiosError.ERR_INVALID_URL = 'ERR_INVALID_URL';
$f9b1affb0498ba1f$var$AxiosError.ERR_FORM_DATA_DEPTH_EXCEEDED = 'ERR_FORM_DATA_DEPTH_EXCEEDED';
var $f9b1affb0498ba1f$export$2e2bcd8739ae039 = $f9b1affb0498ba1f$var$AxiosError;


// eslint-disable-next-line strict
var $243db4f4ede3c5cf$export$2e2bcd8739ae039 = null;



var $7KfP5 = parcelRequire("7KfP5");
var $ec2d6980f48e9528$require$Buffer = $7KfP5.Buffer;
'use strict';
/**
 * Determines if the given thing is a array or js object.
 *
 * @param {string} thing - The object or array to be visited.
 *
 * @returns {boolean}
 */ function $ec2d6980f48e9528$var$isVisitable(thing) {
    return (0, $cb898722622e1bbe$export$2e2bcd8739ae039).isPlainObject(thing) || (0, $cb898722622e1bbe$export$2e2bcd8739ae039).isArray(thing);
}
/**
 * It removes the brackets from the end of a string
 *
 * @param {string} key - The key of the parameter.
 *
 * @returns {string} the key without the brackets.
 */ function $ec2d6980f48e9528$var$removeBrackets(key) {
    return (0, $cb898722622e1bbe$export$2e2bcd8739ae039).endsWith(key, '[]') ? key.slice(0, -2) : key;
}
/**
 * It takes a path, a key, and a boolean, and returns a string
 *
 * @param {string} path - The path to the current key.
 * @param {string} key - The key of the current object being iterated over.
 * @param {string} dots - If true, the key will be rendered with dots instead of brackets.
 *
 * @returns {string} The path to the current key.
 */ function $ec2d6980f48e9528$var$renderKey(path, key, dots) {
    if (!path) return key;
    return path.concat(key).map(function each(token, i) {
        // eslint-disable-next-line no-param-reassign
        token = $ec2d6980f48e9528$var$removeBrackets(token);
        return !dots && i ? '[' + token + ']' : token;
    }).join(dots ? '.' : '');
}
/**
 * If the array is an array and none of its elements are visitable, then it's a flat array.
 *
 * @param {Array<any>} arr - The array to check
 *
 * @returns {boolean}
 */ function $ec2d6980f48e9528$var$isFlatArray(arr) {
    return (0, $cb898722622e1bbe$export$2e2bcd8739ae039).isArray(arr) && !arr.some($ec2d6980f48e9528$var$isVisitable);
}
const $ec2d6980f48e9528$var$predicates = (0, $cb898722622e1bbe$export$2e2bcd8739ae039).toFlatObject((0, $cb898722622e1bbe$export$2e2bcd8739ae039), {}, null, function filter(prop) {
    return /^is[A-Z]/.test(prop);
});
/**
 * Convert a data object to FormData
 *
 * @param {Object} obj
 * @param {?Object} [formData]
 * @param {?Object} [options]
 * @param {Function} [options.visitor]
 * @param {Boolean} [options.metaTokens = true]
 * @param {Boolean} [options.dots = false]
 * @param {?Boolean} [options.indexes = false]
 *
 * @returns {Object}
 **/ /**
 * It converts an object into a FormData object
 *
 * @param {Object<any, any>} obj - The object to convert to form data.
 * @param {string} formData - The FormData object to append to.
 * @param {Object<string, any>} options
 *
 * @returns
 */ function $ec2d6980f48e9528$var$toFormData(obj, formData, options) {
    if (!(0, $cb898722622e1bbe$export$2e2bcd8739ae039).isObject(obj)) throw new TypeError('target must be an object');
    // eslint-disable-next-line no-param-reassign
    formData = formData || new ((0, $243db4f4ede3c5cf$export$2e2bcd8739ae039) || FormData)();
    // eslint-disable-next-line no-param-reassign
    options = (0, $cb898722622e1bbe$export$2e2bcd8739ae039).toFlatObject(options, {
        metaTokens: true,
        dots: false,
        indexes: false
    }, false, function defined(option, source) {
        // eslint-disable-next-line no-eq-null,eqeqeq
        return !(0, $cb898722622e1bbe$export$2e2bcd8739ae039).isUndefined(source[option]);
    });
    const metaTokens = options.metaTokens;
    // eslint-disable-next-line no-use-before-define
    const visitor = options.visitor || defaultVisitor;
    const dots = options.dots;
    const indexes = options.indexes;
    const _Blob = options.Blob || typeof Blob !== 'undefined' && Blob;
    const maxDepth = options.maxDepth === undefined ? 100 : options.maxDepth;
    const useBlob = _Blob && (0, $cb898722622e1bbe$export$2e2bcd8739ae039).isSpecCompliantForm(formData);
    if (!(0, $cb898722622e1bbe$export$2e2bcd8739ae039).isFunction(visitor)) throw new TypeError('visitor must be a function');
    function convertValue(value) {
        if (value === null) return '';
        if ((0, $cb898722622e1bbe$export$2e2bcd8739ae039).isDate(value)) return value.toISOString();
        if ((0, $cb898722622e1bbe$export$2e2bcd8739ae039).isBoolean(value)) return value.toString();
        if (!useBlob && (0, $cb898722622e1bbe$export$2e2bcd8739ae039).isBlob(value)) throw new (0, $f9b1affb0498ba1f$export$2e2bcd8739ae039)('Blob is not supported. Use a Buffer instead.');
        if ((0, $cb898722622e1bbe$export$2e2bcd8739ae039).isArrayBuffer(value) || (0, $cb898722622e1bbe$export$2e2bcd8739ae039).isTypedArray(value)) return useBlob && typeof Blob === 'function' ? new Blob([
            value
        ]) : $ec2d6980f48e9528$require$Buffer.from(value);
        return value;
    }
    /**
   * Default visitor.
   *
   * @param {*} value
   * @param {String|Number} key
   * @param {Array<String|Number>} path
   * @this {FormData}
   *
   * @returns {boolean} return true to visit the each prop of the value recursively
   */ function defaultVisitor(value, key, path) {
        let arr = value;
        if ((0, $cb898722622e1bbe$export$2e2bcd8739ae039).isReactNative(formData) && (0, $cb898722622e1bbe$export$2e2bcd8739ae039).isReactNativeBlob(value)) {
            formData.append($ec2d6980f48e9528$var$renderKey(path, key, dots), convertValue(value));
            return false;
        }
        if (value && !path && typeof value === 'object') {
            if ((0, $cb898722622e1bbe$export$2e2bcd8739ae039).endsWith(key, '{}')) {
                // eslint-disable-next-line no-param-reassign
                key = metaTokens ? key : key.slice(0, -2);
                // eslint-disable-next-line no-param-reassign
                value = JSON.stringify(value);
            } else if ((0, $cb898722622e1bbe$export$2e2bcd8739ae039).isArray(value) && $ec2d6980f48e9528$var$isFlatArray(value) || ((0, $cb898722622e1bbe$export$2e2bcd8739ae039).isFileList(value) || (0, $cb898722622e1bbe$export$2e2bcd8739ae039).endsWith(key, '[]')) && (arr = (0, $cb898722622e1bbe$export$2e2bcd8739ae039).toArray(value))) {
                // eslint-disable-next-line no-param-reassign
                key = $ec2d6980f48e9528$var$removeBrackets(key);
                arr.forEach(function each(el, index) {
                    !((0, $cb898722622e1bbe$export$2e2bcd8739ae039).isUndefined(el) || el === null) && formData.append(// eslint-disable-next-line no-nested-ternary
                    indexes === true ? $ec2d6980f48e9528$var$renderKey([
                        key
                    ], index, dots) : indexes === null ? key : key + '[]', convertValue(el));
                });
                return false;
            }
        }
        if ($ec2d6980f48e9528$var$isVisitable(value)) return true;
        formData.append($ec2d6980f48e9528$var$renderKey(path, key, dots), convertValue(value));
        return false;
    }
    const stack = [];
    const exposedHelpers = Object.assign($ec2d6980f48e9528$var$predicates, {
        defaultVisitor: defaultVisitor,
        convertValue: convertValue,
        isVisitable: $ec2d6980f48e9528$var$isVisitable
    });
    function build(value, path, depth = 0) {
        if ((0, $cb898722622e1bbe$export$2e2bcd8739ae039).isUndefined(value)) return;
        if (depth > maxDepth) throw new (0, $f9b1affb0498ba1f$export$2e2bcd8739ae039)('Object is too deeply nested (' + depth + ' levels). Max depth: ' + maxDepth, (0, $f9b1affb0498ba1f$export$2e2bcd8739ae039).ERR_FORM_DATA_DEPTH_EXCEEDED);
        if (stack.indexOf(value) !== -1) throw new Error('Circular reference detected in ' + path.join('.'));
        stack.push(value);
        (0, $cb898722622e1bbe$export$2e2bcd8739ae039).forEach(value, function each(el, key) {
            const result = !((0, $cb898722622e1bbe$export$2e2bcd8739ae039).isUndefined(el) || el === null) && visitor.call(formData, el, (0, $cb898722622e1bbe$export$2e2bcd8739ae039).isString(key) ? key.trim() : key, path, exposedHelpers);
            if (result === true) build(el, path ? path.concat(key) : [
                key
            ], depth + 1);
        });
        stack.pop();
    }
    if (!(0, $cb898722622e1bbe$export$2e2bcd8739ae039).isObject(obj)) throw new TypeError('data must be an object');
    build(obj);
    return formData;
}
var $ec2d6980f48e9528$export$2e2bcd8739ae039 = $ec2d6980f48e9528$var$toFormData;


'use strict';
/**
 * It encodes a string by replacing all characters that are not in the unreserved set with
 * their percent-encoded equivalents
 *
 * @param {string} str - The string to encode.
 *
 * @returns {string} The encoded string.
 */ function $394be5798fbcf19f$var$encode(str) {
    const charMap = {
        '!': '%21',
        "'": '%27',
        '(': '%28',
        ')': '%29',
        '~': '%7E',
        '%20': '+'
    };
    return encodeURIComponent(str).replace(/[!'()~]|%20/g, function replacer(match) {
        return charMap[match];
    });
}
/**
 * It takes a params object and converts it to a FormData object
 *
 * @param {Object<string, any>} params - The parameters to be converted to a FormData object.
 * @param {Object<string, any>} options - The options object passed to the Axios constructor.
 *
 * @returns {void}
 */ function $394be5798fbcf19f$var$AxiosURLSearchParams(params, options) {
    this._pairs = [];
    params && (0, $ec2d6980f48e9528$export$2e2bcd8739ae039)(params, this, options);
}
const $394be5798fbcf19f$var$prototype = $394be5798fbcf19f$var$AxiosURLSearchParams.prototype;
$394be5798fbcf19f$var$prototype.append = function append(name, value) {
    this._pairs.push([
        name,
        value
    ]);
};
$394be5798fbcf19f$var$prototype.toString = function toString(encoder) {
    const _encode = encoder ? function(value) {
        return encoder.call(this, value, $394be5798fbcf19f$var$encode);
    } : $394be5798fbcf19f$var$encode;
    return this._pairs.map(function each(pair) {
        return _encode(pair[0]) + '=' + _encode(pair[1]);
    }, '').join('&');
};
var $394be5798fbcf19f$export$2e2bcd8739ae039 = $394be5798fbcf19f$var$AxiosURLSearchParams;


'use strict';
function $09cc5760c042eaec$export$c564cdbbe6da493(val) {
    return encodeURIComponent(val).replace(/%3A/gi, ':').replace(/%24/g, '$').replace(/%2C/gi, ',').replace(/%20/g, '+');
}
function $09cc5760c042eaec$export$2e2bcd8739ae039(url, params, options) {
    if (!params) return url;
    const _encode = options && options.encode || $09cc5760c042eaec$export$c564cdbbe6da493;
    const _options = (0, $cb898722622e1bbe$export$2e2bcd8739ae039).isFunction(options) ? {
        serialize: options
    } : options;
    const serializeFn = _options && _options.serialize;
    let serializedParams;
    if (serializeFn) serializedParams = serializeFn(params, _options);
    else serializedParams = (0, $cb898722622e1bbe$export$2e2bcd8739ae039).isURLSearchParams(params) ? params.toString() : new (0, $394be5798fbcf19f$export$2e2bcd8739ae039)(params, _options).toString(_encode);
    if (serializedParams) {
        const hashmarkIndex = url.indexOf('#');
        if (hashmarkIndex !== -1) url = url.slice(0, hashmarkIndex);
        url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
    }
    return url;
}



'use strict';
class $95dc0c3cfa5e38d6$var$InterceptorManager {
    constructor(){
        this.handlers = [];
    }
    /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   * @param {Object} options The options for the interceptor, synchronous and runWhen
   *
   * @return {Number} An ID used to remove interceptor later
   */ use(fulfilled, rejected, options) {
        this.handlers.push({
            fulfilled: fulfilled,
            rejected: rejected,
            synchronous: options ? options.synchronous : false,
            runWhen: options ? options.runWhen : null
        });
        return this.handlers.length - 1;
    }
    /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {void}
   */ eject(id) {
        if (this.handlers[id]) this.handlers[id] = null;
    }
    /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */ clear() {
        if (this.handlers) this.handlers = [];
    }
    /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */ forEach(fn) {
        (0, $cb898722622e1bbe$export$2e2bcd8739ae039).forEach(this.handlers, function forEachHandler(h) {
            if (h !== null) fn(h);
        });
    }
}
var $95dc0c3cfa5e38d6$export$2e2bcd8739ae039 = $95dc0c3cfa5e38d6$var$InterceptorManager;





'use strict';
var $f10e0d1daedbcc26$export$2e2bcd8739ae039 = {
    silentJSONParsing: true,
    forcedJSONParsing: true,
    clarifyTimeoutError: false,
    legacyInterceptorReqResOrdering: true,
    advertiseZstdAcceptEncoding: false
};






'use strict';
var $85d256adaf990c55$export$2e2bcd8739ae039 = typeof URLSearchParams !== 'undefined' ? URLSearchParams : (0, $394be5798fbcf19f$export$2e2bcd8739ae039);


'use strict';
var $397fc345476ebefa$export$2e2bcd8739ae039 = typeof FormData !== 'undefined' ? FormData : null;


'use strict';
var $1ba8abde1bdba5ab$export$2e2bcd8739ae039 = typeof Blob !== 'undefined' ? Blob : null;


var $fd7572cf8dc78389$export$2e2bcd8739ae039 = {
    isBrowser: true,
    classes: {
        URLSearchParams: $85d256adaf990c55$export$2e2bcd8739ae039,
        FormData: $397fc345476ebefa$export$2e2bcd8739ae039,
        Blob: $1ba8abde1bdba5ab$export$2e2bcd8739ae039
    },
    protocols: [
        'http',
        'https',
        'file',
        'blob',
        'url',
        'data'
    ]
};


var $23b70ea44eade3d0$exports = {};
$parcel$export($23b70ea44eade3d0$exports, "hasBrowserEnv", () => $23b70ea44eade3d0$export$c4996c4b7b93b0bf);
$parcel$export($23b70ea44eade3d0$exports, "navigator", () => $23b70ea44eade3d0$export$ec7c8efa7f5790ae);
$parcel$export($23b70ea44eade3d0$exports, "hasStandardBrowserEnv", () => $23b70ea44eade3d0$export$c0bcc9250309d66);
$parcel$export($23b70ea44eade3d0$exports, "hasStandardBrowserWebWorkerEnv", () => $23b70ea44eade3d0$export$c81692cf5af97dac);
$parcel$export($23b70ea44eade3d0$exports, "origin", () => $23b70ea44eade3d0$export$f710a83a91838a36);
const $23b70ea44eade3d0$export$c4996c4b7b93b0bf = typeof window !== 'undefined' && typeof document !== 'undefined';
const $23b70ea44eade3d0$export$ec7c8efa7f5790ae = typeof navigator === 'object' && navigator || undefined;
/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 *
 * @returns {boolean}
 */ const $23b70ea44eade3d0$export$c0bcc9250309d66 = $23b70ea44eade3d0$export$c4996c4b7b93b0bf && (!$23b70ea44eade3d0$export$ec7c8efa7f5790ae || [
    'ReactNative',
    'NativeScript',
    'NS'
].indexOf($23b70ea44eade3d0$export$ec7c8efa7f5790ae.product) < 0);
/**
 * Determine if we're running in a standard browser webWorker environment
 *
 * Although the `isStandardBrowserEnv` method indicates that
 * `allows axios to run in a web worker`, the WebWorker will still be
 * filtered out due to its judgment standard
 * `typeof window !== 'undefined' && typeof document !== 'undefined'`.
 * This leads to a problem when axios post `FormData` in webWorker
 */ const $23b70ea44eade3d0$export$c81692cf5af97dac = (()=>{
    return typeof WorkerGlobalScope !== 'undefined' && // eslint-disable-next-line no-undef
    self instanceof WorkerGlobalScope && typeof self.importScripts === 'function';
})();
const $23b70ea44eade3d0$export$f710a83a91838a36 = $23b70ea44eade3d0$export$c4996c4b7b93b0bf && window.location.href || 'http://localhost';


var $dd4365a6b7ba12cc$export$2e2bcd8739ae039 = {
    ...$23b70ea44eade3d0$exports,
    ...(0, $fd7572cf8dc78389$export$2e2bcd8739ae039)
};


'use strict';
function $46a1c96d89d8a991$export$2e2bcd8739ae039(data, options) {
    return (0, $ec2d6980f48e9528$export$2e2bcd8739ae039)(data, new (0, $dd4365a6b7ba12cc$export$2e2bcd8739ae039).classes.URLSearchParams(), {
        visitor: function(value, key, path, helpers) {
            if ((0, $dd4365a6b7ba12cc$export$2e2bcd8739ae039).isNode && (0, $cb898722622e1bbe$export$2e2bcd8739ae039).isBuffer(value)) {
                this.append(key, value.toString('base64'));
                return false;
            }
            return helpers.defaultVisitor.apply(this, arguments);
        },
        ...options
    });
}




'use strict';
/**
 * It takes a string like `foo[x][y][z]` and returns an array like `['foo', 'x', 'y', 'z']
 *
 * @param {string} name - The name of the property to get.
 *
 * @returns An array of strings.
 */ function $372f04b133c1df53$var$parsePropPath(name) {
    // foo[x][y][z]
    // foo.x.y.z
    // foo-x-y-z
    // foo x y z
    return (0, $cb898722622e1bbe$export$2e2bcd8739ae039).matchAll(/\w+|\[(\w*)]/g, name).map((match)=>{
        return match[0] === '[]' ? '' : match[1] || match[0];
    });
}
/**
 * Convert an array to an object.
 *
 * @param {Array<any>} arr - The array to convert to an object.
 *
 * @returns An object with the same keys and values as the array.
 */ function $372f04b133c1df53$var$arrayToObject(arr) {
    const obj = {};
    const keys = Object.keys(arr);
    let i;
    const len = keys.length;
    let key;
    for(i = 0; i < len; i++){
        key = keys[i];
        obj[key] = arr[key];
    }
    return obj;
}
/**
 * It takes a FormData object and returns a JavaScript object
 *
 * @param {string} formData The FormData object to convert to JSON.
 *
 * @returns {Object<string, any> | null} The converted object.
 */ function $372f04b133c1df53$var$formDataToJSON(formData) {
    function buildPath(path, value, target, index) {
        let name = path[index++];
        if (name === '__proto__') return true;
        const isNumericKey = Number.isFinite(+name);
        const isLast = index >= path.length;
        name = !name && (0, $cb898722622e1bbe$export$2e2bcd8739ae039).isArray(target) ? target.length : name;
        if (isLast) {
            if ((0, $cb898722622e1bbe$export$2e2bcd8739ae039).hasOwnProp(target, name)) target[name] = (0, $cb898722622e1bbe$export$2e2bcd8739ae039).isArray(target[name]) ? target[name].concat(value) : [
                target[name],
                value
            ];
            else target[name] = value;
            return !isNumericKey;
        }
        if (!(0, $cb898722622e1bbe$export$2e2bcd8739ae039).hasOwnProp(target, name) || !(0, $cb898722622e1bbe$export$2e2bcd8739ae039).isObject(target[name])) target[name] = [];
        const result = buildPath(path, value, target[name], index);
        if (result && (0, $cb898722622e1bbe$export$2e2bcd8739ae039).isArray(target[name])) target[name] = $372f04b133c1df53$var$arrayToObject(target[name]);
        return !isNumericKey;
    }
    if ((0, $cb898722622e1bbe$export$2e2bcd8739ae039).isFormData(formData) && (0, $cb898722622e1bbe$export$2e2bcd8739ae039).isFunction(formData.entries)) {
        const obj = {};
        (0, $cb898722622e1bbe$export$2e2bcd8739ae039).forEachEntry(formData, (name, value)=>{
            buildPath($372f04b133c1df53$var$parsePropPath(name), value, obj, 0);
        });
        return obj;
    }
    return null;
}
var $372f04b133c1df53$export$2e2bcd8739ae039 = $372f04b133c1df53$var$formDataToJSON;


'use strict';
const $e1c9a57ef3ebea92$var$own = (obj, key)=>obj != null && (0, $cb898722622e1bbe$export$2e2bcd8739ae039).hasOwnProp(obj, key) ? obj[key] : undefined;
/**
 * It takes a string, tries to parse it, and if it fails, it returns the stringified version
 * of the input
 *
 * @param {any} rawValue - The value to be stringified.
 * @param {Function} parser - A function that parses a string into a JavaScript object.
 * @param {Function} encoder - A function that takes a value and returns a string.
 *
 * @returns {string} A stringified version of the rawValue.
 */ function $e1c9a57ef3ebea92$var$stringifySafely(rawValue, parser, encoder) {
    if ((0, $cb898722622e1bbe$export$2e2bcd8739ae039).isString(rawValue)) try {
        (parser || JSON.parse)(rawValue);
        return (0, $cb898722622e1bbe$export$2e2bcd8739ae039).trim(rawValue);
    } catch (e) {
        if (e.name !== 'SyntaxError') throw e;
    }
    return (encoder || JSON.stringify)(rawValue);
}
const $e1c9a57ef3ebea92$var$defaults = {
    transitional: (0, $f10e0d1daedbcc26$export$2e2bcd8739ae039),
    adapter: [
        'xhr',
        'http',
        'fetch'
    ],
    transformRequest: [
        function transformRequest(data, headers) {
            const contentType = headers.getContentType() || '';
            const hasJSONContentType = contentType.indexOf('application/json') > -1;
            const isObjectPayload = (0, $cb898722622e1bbe$export$2e2bcd8739ae039).isObject(data);
            if (isObjectPayload && (0, $cb898722622e1bbe$export$2e2bcd8739ae039).isHTMLForm(data)) data = new FormData(data);
            const isFormData = (0, $cb898722622e1bbe$export$2e2bcd8739ae039).isFormData(data);
            if (isFormData) return hasJSONContentType ? JSON.stringify((0, $372f04b133c1df53$export$2e2bcd8739ae039)(data)) : data;
            if ((0, $cb898722622e1bbe$export$2e2bcd8739ae039).isArrayBuffer(data) || (0, $cb898722622e1bbe$export$2e2bcd8739ae039).isBuffer(data) || (0, $cb898722622e1bbe$export$2e2bcd8739ae039).isStream(data) || (0, $cb898722622e1bbe$export$2e2bcd8739ae039).isFile(data) || (0, $cb898722622e1bbe$export$2e2bcd8739ae039).isBlob(data) || (0, $cb898722622e1bbe$export$2e2bcd8739ae039).isReadableStream(data)) return data;
            if ((0, $cb898722622e1bbe$export$2e2bcd8739ae039).isArrayBufferView(data)) return data.buffer;
            if ((0, $cb898722622e1bbe$export$2e2bcd8739ae039).isURLSearchParams(data)) {
                headers.setContentType('application/x-www-form-urlencoded;charset=utf-8', false);
                return data.toString();
            }
            let isFileList;
            if (isObjectPayload) {
                const formSerializer = $e1c9a57ef3ebea92$var$own(this, 'formSerializer');
                if (contentType.indexOf('application/x-www-form-urlencoded') > -1) return (0, $46a1c96d89d8a991$export$2e2bcd8739ae039)(data, formSerializer).toString();
                if ((isFileList = (0, $cb898722622e1bbe$export$2e2bcd8739ae039).isFileList(data)) || contentType.indexOf('multipart/form-data') > -1) {
                    const env = $e1c9a57ef3ebea92$var$own(this, 'env');
                    const _FormData = env && env.FormData;
                    return (0, $ec2d6980f48e9528$export$2e2bcd8739ae039)(isFileList ? {
                        'files[]': data
                    } : data, _FormData && new _FormData(), formSerializer);
                }
            }
            if (isObjectPayload || hasJSONContentType) {
                headers.setContentType('application/json', false);
                return $e1c9a57ef3ebea92$var$stringifySafely(data);
            }
            return data;
        }
    ],
    transformResponse: [
        function transformResponse(data) {
            const transitional = $e1c9a57ef3ebea92$var$own(this, 'transitional') || $e1c9a57ef3ebea92$var$defaults.transitional;
            const forcedJSONParsing = transitional && transitional.forcedJSONParsing;
            const responseType = $e1c9a57ef3ebea92$var$own(this, 'responseType');
            const JSONRequested = responseType === 'json';
            if ((0, $cb898722622e1bbe$export$2e2bcd8739ae039).isResponse(data) || (0, $cb898722622e1bbe$export$2e2bcd8739ae039).isReadableStream(data)) return data;
            if (data && (0, $cb898722622e1bbe$export$2e2bcd8739ae039).isString(data) && (forcedJSONParsing && !responseType || JSONRequested)) {
                const silentJSONParsing = transitional && transitional.silentJSONParsing;
                const strictJSONParsing = !silentJSONParsing && JSONRequested;
                try {
                    return JSON.parse(data, $e1c9a57ef3ebea92$var$own(this, 'parseReviver'));
                } catch (e) {
                    if (strictJSONParsing) {
                        if (e.name === 'SyntaxError') throw (0, $f9b1affb0498ba1f$export$2e2bcd8739ae039).from(e, (0, $f9b1affb0498ba1f$export$2e2bcd8739ae039).ERR_BAD_RESPONSE, this, null, $e1c9a57ef3ebea92$var$own(this, 'response'));
                        throw e;
                    }
                }
            }
            return data;
        }
    ],
    /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */ timeout: 0,
    xsrfCookieName: 'XSRF-TOKEN',
    xsrfHeaderName: 'X-XSRF-TOKEN',
    maxContentLength: -1,
    maxBodyLength: -1,
    env: {
        FormData: (0, $dd4365a6b7ba12cc$export$2e2bcd8739ae039).classes.FormData,
        Blob: (0, $dd4365a6b7ba12cc$export$2e2bcd8739ae039).classes.Blob
    },
    validateStatus: function validateStatus(status) {
        return status >= 200 && status < 300;
    },
    headers: {
        common: {
            Accept: 'application/json, text/plain, */*',
            'Content-Type': undefined
        }
    }
};
(0, $cb898722622e1bbe$export$2e2bcd8739ae039).forEach([
    'delete',
    'get',
    'head',
    'post',
    'put',
    'patch',
    'query'
], (method)=>{
    $e1c9a57ef3ebea92$var$defaults.headers[method] = {};
});
var $e1c9a57ef3ebea92$export$2e2bcd8739ae039 = $e1c9a57ef3ebea92$var$defaults;



'use strict';
function $cbed29dc306d3656$export$2e2bcd8739ae039(fns, response) {
    const config = this || (0, $e1c9a57ef3ebea92$export$2e2bcd8739ae039);
    const context = response || config;
    const headers = (0, $a107ecb812e3a6a9$export$2e2bcd8739ae039).from(context.headers);
    let data = context.data;
    (0, $cb898722622e1bbe$export$2e2bcd8739ae039).forEach(fns, function transform(fn) {
        data = fn.call(config, data, headers.normalize(), response ? response.status : undefined);
    });
    headers.normalize();
    return data;
}


'use strict';
function $7ccf50e37e313489$export$2e2bcd8739ae039(value) {
    return !!(value && value.__CANCEL__);
}




'use strict';
class $d2353333ffc17c53$var$CanceledError extends (0, $f9b1affb0498ba1f$export$2e2bcd8739ae039) {
    /**
   * A `CanceledError` is an object that is thrown when an operation is canceled.
   *
   * @param {string=} message The message.
   * @param {Object=} config The config.
   * @param {Object=} request The request.
   *
   * @returns {CanceledError} The created error.
   */ constructor(message, config, request){
        super(message == null ? 'canceled' : message, (0, $f9b1affb0498ba1f$export$2e2bcd8739ae039).ERR_CANCELED, config, request);
        this.name = 'CanceledError';
        this.__CANCEL__ = true;
    }
}
var $d2353333ffc17c53$export$2e2bcd8739ae039 = $d2353333ffc17c53$var$CanceledError;







'use strict';
function $65b761545c1367d7$export$2e2bcd8739ae039(resolve, reject, response) {
    const validateStatus = response.config.validateStatus;
    if (!response.status || !validateStatus || validateStatus(response.status)) resolve(response);
    else reject(new (0, $f9b1affb0498ba1f$export$2e2bcd8739ae039)('Request failed with status code ' + response.status, response.status >= 400 && response.status < 500 ? (0, $f9b1affb0498ba1f$export$2e2bcd8739ae039).ERR_BAD_REQUEST : (0, $f9b1affb0498ba1f$export$2e2bcd8739ae039).ERR_BAD_RESPONSE, response.config, response.request, response));
}





'use strict';
function $74d7823de4940a99$export$2e2bcd8739ae039(url) {
    const match = /^([-+\w]{1,25}):(?:\/\/)?/.exec(url);
    return match && match[1] || '';
}




'use strict';
/**
 * Calculate data maxRate
 * @param {Number} [samplesCount= 10]
 * @param {Number} [min= 1000]
 * @returns {Function}
 */ function $e8ab64df6f629ac9$var$speedometer(samplesCount, min) {
    samplesCount = samplesCount || 10;
    const bytes = new Array(samplesCount);
    const timestamps = new Array(samplesCount);
    let head = 0;
    let tail = 0;
    let firstSampleTS;
    min = min !== undefined ? min : 1000;
    return function push(chunkLength) {
        const now = Date.now();
        const startedAt = timestamps[tail];
        if (!firstSampleTS) firstSampleTS = now;
        bytes[head] = chunkLength;
        timestamps[head] = now;
        let i = tail;
        let bytesCount = 0;
        while(i !== head){
            bytesCount += bytes[i++];
            i = i % samplesCount;
        }
        head = (head + 1) % samplesCount;
        if (head === tail) tail = (tail + 1) % samplesCount;
        if (now - firstSampleTS < min) return;
        const passed = startedAt && now - startedAt;
        return passed ? Math.round(bytesCount * 1000 / passed) : undefined;
    };
}
var $e8ab64df6f629ac9$export$2e2bcd8739ae039 = $e8ab64df6f629ac9$var$speedometer;


/**
 * Throttle decorator
 * @param {Function} fn
 * @param {Number} freq
 * @return {Function}
 */ function $a21ca0c8397b2970$var$throttle(fn, freq) {
    let timestamp = 0;
    let threshold = 1000 / freq;
    let lastArgs;
    let timer;
    const invoke = (args, now = Date.now())=>{
        timestamp = now;
        lastArgs = null;
        if (timer) {
            clearTimeout(timer);
            timer = null;
        }
        fn(...args);
    };
    const throttled = (...args)=>{
        const now = Date.now();
        const passed = now - timestamp;
        if (passed >= threshold) invoke(args, now);
        else {
            lastArgs = args;
            if (!timer) timer = setTimeout(()=>{
                timer = null;
                invoke(lastArgs);
            }, threshold - passed);
        }
    };
    const flush = ()=>lastArgs && invoke(lastArgs);
    return [
        throttled,
        flush
    ];
}
var $a21ca0c8397b2970$export$2e2bcd8739ae039 = $a21ca0c8397b2970$var$throttle;



const $347f6d773d0c9353$export$c1b28109d46c3592 = (listener, isDownloadStream, freq = 3)=>{
    let bytesNotified = 0;
    const _speedometer = (0, $e8ab64df6f629ac9$export$2e2bcd8739ae039)(50, 250);
    return (0, $a21ca0c8397b2970$export$2e2bcd8739ae039)((e)=>{
        if (!e || typeof e.loaded !== 'number') return;
        const rawLoaded = e.loaded;
        const total = e.lengthComputable ? e.total : undefined;
        const loaded = total != null ? Math.min(rawLoaded, total) : rawLoaded;
        const progressBytes = Math.max(0, loaded - bytesNotified);
        const rate = _speedometer(progressBytes);
        bytesNotified = Math.max(bytesNotified, loaded);
        const data = {
            loaded: loaded,
            total: total,
            progress: total ? loaded / total : undefined,
            bytes: progressBytes,
            rate: rate ? rate : undefined,
            estimated: rate && total ? (total - loaded) / rate : undefined,
            event: e,
            lengthComputable: total != null,
            [isDownloadStream ? 'download' : 'upload']: true
        };
        listener(data);
    }, freq);
};
const $347f6d773d0c9353$export$d9fadd12586c18d6 = (total, throttled)=>{
    const lengthComputable = total != null;
    return [
        (loaded)=>throttled[0]({
                lengthComputable: lengthComputable,
                total: total,
                loaded: loaded
            }),
        throttled[1]
    ];
};
const $347f6d773d0c9353$export$5d35863c355a22a9 = (fn)=>(...args)=>(0, $cb898722622e1bbe$export$2e2bcd8739ae039).asap(()=>fn(...args));





var $d81aa7444d42d05f$export$2e2bcd8739ae039 = (0, $dd4365a6b7ba12cc$export$2e2bcd8739ae039).hasStandardBrowserEnv ? ((origin, isMSIE)=>(url)=>{
        url = new URL(url, (0, $dd4365a6b7ba12cc$export$2e2bcd8739ae039).origin);
        return origin.protocol === url.protocol && origin.host === url.host && (isMSIE || origin.port === url.port);
    })(new URL((0, $dd4365a6b7ba12cc$export$2e2bcd8739ae039).origin), (0, $dd4365a6b7ba12cc$export$2e2bcd8739ae039).navigator && /(msie|trident)/i.test((0, $dd4365a6b7ba12cc$export$2e2bcd8739ae039).navigator.userAgent)) : ()=>true;




var $c1785cd19fee110a$export$2e2bcd8739ae039 = (0, $dd4365a6b7ba12cc$export$2e2bcd8739ae039).hasStandardBrowserEnv ? {
    write (name, value, expires, path, domain, secure, sameSite) {
        if (typeof document === 'undefined') return;
        const cookie = [
            `${name}=${encodeURIComponent(value)}`
        ];
        if ((0, $cb898722622e1bbe$export$2e2bcd8739ae039).isNumber(expires)) cookie.push(`expires=${new Date(expires).toUTCString()}`);
        if ((0, $cb898722622e1bbe$export$2e2bcd8739ae039).isString(path)) cookie.push(`path=${path}`);
        if ((0, $cb898722622e1bbe$export$2e2bcd8739ae039).isString(domain)) cookie.push(`domain=${domain}`);
        if (secure === true) cookie.push('secure');
        if ((0, $cb898722622e1bbe$export$2e2bcd8739ae039).isString(sameSite)) cookie.push(`SameSite=${sameSite}`);
        document.cookie = cookie.join('; ');
    },
    read (name) {
        if (typeof document === 'undefined') return null;
        // Match name=value by splitting on the semicolon separator instead of building a
        // RegExp from `name` — interpolating an unescaped string into a RegExp would let
        // metacharacters (e.g. `.+?` in an attacker-influenced cookie name) cause ReDoS or
        // match the wrong cookie. Browsers may serialize cookie pairs as either ";" or
        // "; ", so ignore optional whitespace before each cookie name.
        const cookies = document.cookie.split(';');
        for(let i = 0; i < cookies.length; i++){
            const cookie = cookies[i].replace(/^\s+/, '');
            const eq = cookie.indexOf('=');
            if (eq !== -1 && cookie.slice(0, eq) === name) return decodeURIComponent(cookie.slice(eq + 1));
        }
        return null;
    },
    remove (name) {
        this.write(name, '', Date.now() - 86400000, '/');
    }
} : {
    write () {},
    read () {
        return null;
    },
    remove () {}
};


'use strict';
function $88d29e2784134738$export$2e2bcd8739ae039(url) {
    // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
    // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
    // by any combination of letters, digits, plus, period, or hyphen.
    if (typeof url !== 'string') return false;
    return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(url);
}


'use strict';
function $1553d45bd639ed27$export$2e2bcd8739ae039(baseURL, relativeURL) {
    return relativeURL ? baseURL.replace(/\/?\/$/, '') + '/' + relativeURL.replace(/^\/+/, '') : baseURL;
}


'use strict';
function $fc4436884ed94f0b$export$2e2bcd8739ae039(baseURL, requestedURL, allowAbsoluteUrls) {
    let isRelativeUrl = !(0, $88d29e2784134738$export$2e2bcd8739ae039)(requestedURL);
    if (baseURL && (isRelativeUrl || allowAbsoluteUrls === false)) return (0, $1553d45bd639ed27$export$2e2bcd8739ae039)(baseURL, requestedURL);
    return requestedURL;
}




'use strict';
const $df9d9d057b970962$var$headersToObject = (thing)=>thing instanceof (0, $a107ecb812e3a6a9$export$2e2bcd8739ae039) ? {
        ...thing
    } : thing;
function $df9d9d057b970962$export$2e2bcd8739ae039(config1, config2) {
    // eslint-disable-next-line no-param-reassign
    config2 = config2 || {};
    // Use a null-prototype object so that downstream reads such as `config.auth`
    // or `config.baseURL` cannot inherit polluted values from Object.prototype.
    // `hasOwnProperty` is restored as a non-enumerable own slot to preserve
    // ergonomics for user code that relies on it.
    const config = Object.create(null);
    Object.defineProperty(config, 'hasOwnProperty', {
        // Null-proto descriptor so a polluted Object.prototype.get cannot turn
        // this data descriptor into an accessor descriptor on the way in.
        __proto__: null,
        value: Object.prototype.hasOwnProperty,
        enumerable: false,
        writable: true,
        configurable: true
    });
    function getMergedValue(target, source, prop, caseless) {
        if ((0, $cb898722622e1bbe$export$2e2bcd8739ae039).isPlainObject(target) && (0, $cb898722622e1bbe$export$2e2bcd8739ae039).isPlainObject(source)) return (0, $cb898722622e1bbe$export$2e2bcd8739ae039).merge.call({
            caseless: caseless
        }, target, source);
        else if ((0, $cb898722622e1bbe$export$2e2bcd8739ae039).isPlainObject(source)) return (0, $cb898722622e1bbe$export$2e2bcd8739ae039).merge({}, source);
        else if ((0, $cb898722622e1bbe$export$2e2bcd8739ae039).isArray(source)) return source.slice();
        return source;
    }
    function mergeDeepProperties(a, b, prop, caseless) {
        if (!(0, $cb898722622e1bbe$export$2e2bcd8739ae039).isUndefined(b)) return getMergedValue(a, b, prop, caseless);
        else if (!(0, $cb898722622e1bbe$export$2e2bcd8739ae039).isUndefined(a)) return getMergedValue(undefined, a, prop, caseless);
    }
    // eslint-disable-next-line consistent-return
    function valueFromConfig2(a, b) {
        if (!(0, $cb898722622e1bbe$export$2e2bcd8739ae039).isUndefined(b)) return getMergedValue(undefined, b);
    }
    // eslint-disable-next-line consistent-return
    function defaultToConfig2(a, b) {
        if (!(0, $cb898722622e1bbe$export$2e2bcd8739ae039).isUndefined(b)) return getMergedValue(undefined, b);
        else if (!(0, $cb898722622e1bbe$export$2e2bcd8739ae039).isUndefined(a)) return getMergedValue(undefined, a);
    }
    // eslint-disable-next-line consistent-return
    function mergeDirectKeys(a, b, prop) {
        if ((0, $cb898722622e1bbe$export$2e2bcd8739ae039).hasOwnProp(config2, prop)) return getMergedValue(a, b);
        else if ((0, $cb898722622e1bbe$export$2e2bcd8739ae039).hasOwnProp(config1, prop)) return getMergedValue(undefined, a);
    }
    const mergeMap = {
        url: valueFromConfig2,
        method: valueFromConfig2,
        data: valueFromConfig2,
        baseURL: defaultToConfig2,
        transformRequest: defaultToConfig2,
        transformResponse: defaultToConfig2,
        paramsSerializer: defaultToConfig2,
        timeout: defaultToConfig2,
        timeoutMessage: defaultToConfig2,
        withCredentials: defaultToConfig2,
        withXSRFToken: defaultToConfig2,
        adapter: defaultToConfig2,
        responseType: defaultToConfig2,
        xsrfCookieName: defaultToConfig2,
        xsrfHeaderName: defaultToConfig2,
        onUploadProgress: defaultToConfig2,
        onDownloadProgress: defaultToConfig2,
        decompress: defaultToConfig2,
        maxContentLength: defaultToConfig2,
        maxBodyLength: defaultToConfig2,
        beforeRedirect: defaultToConfig2,
        transport: defaultToConfig2,
        httpAgent: defaultToConfig2,
        httpsAgent: defaultToConfig2,
        cancelToken: defaultToConfig2,
        socketPath: defaultToConfig2,
        allowedSocketPaths: defaultToConfig2,
        responseEncoding: defaultToConfig2,
        validateStatus: mergeDirectKeys,
        headers: (a, b, prop)=>mergeDeepProperties($df9d9d057b970962$var$headersToObject(a), $df9d9d057b970962$var$headersToObject(b), prop, true)
    };
    (0, $cb898722622e1bbe$export$2e2bcd8739ae039).forEach(Object.keys({
        ...config1,
        ...config2
    }), function computeConfigValue(prop) {
        if (prop === '__proto__' || prop === 'constructor' || prop === 'prototype') return;
        const merge = (0, $cb898722622e1bbe$export$2e2bcd8739ae039).hasOwnProp(mergeMap, prop) ? mergeMap[prop] : mergeDeepProperties;
        const a = (0, $cb898722622e1bbe$export$2e2bcd8739ae039).hasOwnProp(config1, prop) ? config1[prop] : undefined;
        const b = (0, $cb898722622e1bbe$export$2e2bcd8739ae039).hasOwnProp(config2, prop) ? config2[prop] : undefined;
        const configValue = merge(a, b, prop);
        (0, $cb898722622e1bbe$export$2e2bcd8739ae039).isUndefined(configValue) && merge !== mergeDirectKeys || (config[prop] = configValue);
    });
    return config;
}




const $bcfc1ef472e4bbd0$var$FORM_DATA_CONTENT_HEADERS = [
    'content-type',
    'content-length'
];
function $bcfc1ef472e4bbd0$var$setFormDataHeaders(headers, formHeaders, policy) {
    if (policy !== 'content-only') {
        headers.set(formHeaders);
        return;
    }
    Object.entries(formHeaders).forEach(([key, val])=>{
        if ($bcfc1ef472e4bbd0$var$FORM_DATA_CONTENT_HEADERS.includes(key.toLowerCase())) headers.set(key, val);
    });
}
/**
 * Encode a UTF-8 string to a Latin-1 byte string for use with btoa().
 * This is a modern replacement for the deprecated unescape(encodeURIComponent(str)) pattern.
 *
 * @param {string} str The string to encode
 *
 * @returns {string} UTF-8 bytes as a Latin-1 string
 */ const $bcfc1ef472e4bbd0$var$encodeUTF8 = (str)=>encodeURIComponent(str).replace(/%([0-9A-F]{2})/gi, (_, hex)=>String.fromCharCode(parseInt(hex, 16)));
function $bcfc1ef472e4bbd0$var$resolveConfig(config) {
    const newConfig = (0, $df9d9d057b970962$export$2e2bcd8739ae039)({}, config);
    // Read only own properties to prevent prototype pollution gadgets
    // (e.g. Object.prototype.baseURL = 'https://evil.com').
    const own = (key)=>(0, $cb898722622e1bbe$export$2e2bcd8739ae039).hasOwnProp(newConfig, key) ? newConfig[key] : undefined;
    const data = own('data');
    let withXSRFToken = own('withXSRFToken');
    const xsrfHeaderName = own('xsrfHeaderName');
    const xsrfCookieName = own('xsrfCookieName');
    let headers = own('headers');
    const auth = own('auth');
    const baseURL = own('baseURL');
    const allowAbsoluteUrls = own('allowAbsoluteUrls');
    const url = own('url');
    newConfig.headers = headers = (0, $a107ecb812e3a6a9$export$2e2bcd8739ae039).from(headers);
    newConfig.url = (0, $09cc5760c042eaec$export$2e2bcd8739ae039)((0, $fc4436884ed94f0b$export$2e2bcd8739ae039)(baseURL, url, allowAbsoluteUrls), own('params'), own('paramsSerializer'));
    // HTTP basic authentication
    if (auth) headers.set('Authorization', 'Basic ' + btoa((auth.username || '') + ':' + (auth.password ? $bcfc1ef472e4bbd0$var$encodeUTF8(auth.password) : '')));
    if ((0, $cb898722622e1bbe$export$2e2bcd8739ae039).isFormData(data)) {
        if ((0, $dd4365a6b7ba12cc$export$2e2bcd8739ae039).hasStandardBrowserEnv || (0, $dd4365a6b7ba12cc$export$2e2bcd8739ae039).hasStandardBrowserWebWorkerEnv || (0, $cb898722622e1bbe$export$2e2bcd8739ae039).isReactNative(data)) headers.setContentType(undefined); // browser/web worker/RN handles it
        else if ((0, $cb898722622e1bbe$export$2e2bcd8739ae039).isFunction(data.getHeaders)) // Node.js FormData (like form-data package)
        $bcfc1ef472e4bbd0$var$setFormDataHeaders(headers, data.getHeaders(), own('formDataHeaderPolicy'));
    }
    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if ((0, $dd4365a6b7ba12cc$export$2e2bcd8739ae039).hasStandardBrowserEnv) {
        if ((0, $cb898722622e1bbe$export$2e2bcd8739ae039).isFunction(withXSRFToken)) withXSRFToken = withXSRFToken(newConfig);
        // Strict boolean check — prevents proto-pollution gadgets (e.g. Object.prototype.withXSRFToken = 1)
        // and misconfigurations (e.g. "false") from short-circuiting the same-origin check and leaking
        // the XSRF token cross-origin.
        const shouldSendXSRF = withXSRFToken === true || withXSRFToken == null && (0, $d81aa7444d42d05f$export$2e2bcd8739ae039)(newConfig.url);
        if (shouldSendXSRF) {
            const xsrfValue = xsrfHeaderName && xsrfCookieName && (0, $c1785cd19fee110a$export$2e2bcd8739ae039).read(xsrfCookieName);
            if (xsrfValue) headers.set(xsrfHeaderName, xsrfValue);
        }
    }
    return newConfig;
}
var $bcfc1ef472e4bbd0$export$2e2bcd8739ae039 = $bcfc1ef472e4bbd0$var$resolveConfig;



const $a896e51633600c95$var$isXHRAdapterSupported = typeof XMLHttpRequest !== 'undefined';
var $a896e51633600c95$export$2e2bcd8739ae039 = $a896e51633600c95$var$isXHRAdapterSupported && function(config) {
    return new Promise(function dispatchXhrRequest(resolve, reject) {
        const _config = (0, $bcfc1ef472e4bbd0$export$2e2bcd8739ae039)(config);
        let requestData = _config.data;
        const requestHeaders = (0, $a107ecb812e3a6a9$export$2e2bcd8739ae039).from(_config.headers).normalize();
        let { responseType: responseType, onUploadProgress: onUploadProgress, onDownloadProgress: onDownloadProgress } = _config;
        let onCanceled;
        let uploadThrottled, downloadThrottled;
        let flushUpload, flushDownload;
        function done() {
            flushUpload && flushUpload(); // flush events
            flushDownload && flushDownload(); // flush events
            _config.cancelToken && _config.cancelToken.unsubscribe(onCanceled);
            _config.signal && _config.signal.removeEventListener('abort', onCanceled);
        }
        let request = new XMLHttpRequest();
        request.open(_config.method.toUpperCase(), _config.url, true);
        // Set the request timeout in MS
        request.timeout = _config.timeout;
        function onloadend() {
            if (!request) return;
            // Prepare the response
            const responseHeaders = (0, $a107ecb812e3a6a9$export$2e2bcd8739ae039).from('getAllResponseHeaders' in request && request.getAllResponseHeaders());
            const responseData = !responseType || responseType === 'text' || responseType === 'json' ? request.responseText : request.response;
            const response = {
                data: responseData,
                status: request.status,
                statusText: request.statusText,
                headers: responseHeaders,
                config: config,
                request: request
            };
            (0, $65b761545c1367d7$export$2e2bcd8739ae039)(function _resolve(value) {
                resolve(value);
                done();
            }, function _reject(err) {
                reject(err);
                done();
            }, response);
            // Clean up request
            request = null;
        }
        if ('onloadend' in request) // Use onloadend if available
        request.onloadend = onloadend;
        else // Listen for ready state to emulate onloadend
        request.onreadystatechange = function handleLoad() {
            if (!request || request.readyState !== 4) return;
            // The request errored out and we didn't get a response, this will be
            // handled by onerror instead
            // With one exception: request that using file: protocol, most browsers
            // will return status as 0 even though it's a successful request
            if (request.status === 0 && !(request.responseURL && request.responseURL.startsWith('file:'))) return;
            // readystate handler is calling before onerror or ontimeout handlers,
            // so we should call onloadend on the next 'tick'
            setTimeout(onloadend);
        };
        // Handle browser request cancellation (as opposed to a manual cancellation)
        request.onabort = function handleAbort() {
            if (!request) return;
            reject(new (0, $f9b1affb0498ba1f$export$2e2bcd8739ae039)('Request aborted', (0, $f9b1affb0498ba1f$export$2e2bcd8739ae039).ECONNABORTED, config, request));
            done();
            // Clean up request
            request = null;
        };
        // Handle low level network errors
        request.onerror = function handleError(event) {
            // Browsers deliver a ProgressEvent in XHR onerror
            // (message may be empty; when present, surface it)
            // See https://developer.mozilla.org/docs/Web/API/XMLHttpRequest/error_event
            const msg = event && event.message ? event.message : 'Network Error';
            const err = new (0, $f9b1affb0498ba1f$export$2e2bcd8739ae039)(msg, (0, $f9b1affb0498ba1f$export$2e2bcd8739ae039).ERR_NETWORK, config, request);
            // attach the underlying event for consumers who want details
            err.event = event || null;
            reject(err);
            done();
            request = null;
        };
        // Handle timeout
        request.ontimeout = function handleTimeout() {
            let timeoutErrorMessage = _config.timeout ? 'timeout of ' + _config.timeout + 'ms exceeded' : 'timeout exceeded';
            const transitional = _config.transitional || (0, $f10e0d1daedbcc26$export$2e2bcd8739ae039);
            if (_config.timeoutErrorMessage) timeoutErrorMessage = _config.timeoutErrorMessage;
            reject(new (0, $f9b1affb0498ba1f$export$2e2bcd8739ae039)(timeoutErrorMessage, transitional.clarifyTimeoutError ? (0, $f9b1affb0498ba1f$export$2e2bcd8739ae039).ETIMEDOUT : (0, $f9b1affb0498ba1f$export$2e2bcd8739ae039).ECONNABORTED, config, request));
            done();
            // Clean up request
            request = null;
        };
        // Remove Content-Type if data is undefined
        requestData === undefined && requestHeaders.setContentType(null);
        // Add headers to the request
        if ('setRequestHeader' in request) (0, $cb898722622e1bbe$export$2e2bcd8739ae039).forEach((0, $b4b7fdb921feec02$export$c30c72bb7e677d54)(requestHeaders), function setRequestHeader(val, key) {
            request.setRequestHeader(key, val);
        });
        // Add withCredentials to request if needed
        if (!(0, $cb898722622e1bbe$export$2e2bcd8739ae039).isUndefined(_config.withCredentials)) request.withCredentials = !!_config.withCredentials;
        // Add responseType to request if needed
        if (responseType && responseType !== 'json') request.responseType = _config.responseType;
        // Handle progress if needed
        if (onDownloadProgress) {
            [downloadThrottled, flushDownload] = (0, $347f6d773d0c9353$export$c1b28109d46c3592)(onDownloadProgress, true);
            request.addEventListener('progress', downloadThrottled);
        }
        // Not all browsers support upload events
        if (onUploadProgress && request.upload) {
            [uploadThrottled, flushUpload] = (0, $347f6d773d0c9353$export$c1b28109d46c3592)(onUploadProgress);
            request.upload.addEventListener('progress', uploadThrottled);
            request.upload.addEventListener('loadend', flushUpload);
        }
        if (_config.cancelToken || _config.signal) {
            // Handle cancellation
            // eslint-disable-next-line func-names
            onCanceled = (cancel)=>{
                if (!request) return;
                reject(!cancel || cancel.type ? new (0, $d2353333ffc17c53$export$2e2bcd8739ae039)(null, config, request) : cancel);
                request.abort();
                done();
                request = null;
            };
            _config.cancelToken && _config.cancelToken.subscribe(onCanceled);
            if (_config.signal) _config.signal.aborted ? onCanceled() : _config.signal.addEventListener('abort', onCanceled);
        }
        const protocol = (0, $74d7823de4940a99$export$2e2bcd8739ae039)(_config.url);
        if (protocol && !(0, $dd4365a6b7ba12cc$export$2e2bcd8739ae039).protocols.includes(protocol)) {
            reject(new (0, $f9b1affb0498ba1f$export$2e2bcd8739ae039)('Unsupported protocol ' + protocol + ':', (0, $f9b1affb0498ba1f$export$2e2bcd8739ae039).ERR_BAD_REQUEST, config));
            return;
        }
        // Send the request
        request.send(requestData || null);
    });
};








const $44f58441f577bc02$var$composeSignals = (signals, timeout)=>{
    signals = signals ? signals.filter(Boolean) : [];
    if (!timeout && !signals.length) return;
    const controller = new AbortController();
    let aborted = false;
    const onabort = function(reason) {
        if (!aborted) {
            aborted = true;
            unsubscribe();
            const err = reason instanceof Error ? reason : this.reason;
            controller.abort(err instanceof (0, $f9b1affb0498ba1f$export$2e2bcd8739ae039) ? err : new (0, $d2353333ffc17c53$export$2e2bcd8739ae039)(err instanceof Error ? err.message : err));
        }
    };
    let timer = timeout && setTimeout(()=>{
        timer = null;
        onabort(new (0, $f9b1affb0498ba1f$export$2e2bcd8739ae039)(`timeout of ${timeout}ms exceeded`, (0, $f9b1affb0498ba1f$export$2e2bcd8739ae039).ETIMEDOUT));
    }, timeout);
    const unsubscribe = ()=>{
        if (!signals) return;
        timer && clearTimeout(timer);
        timer = null;
        signals.forEach((signal)=>{
            signal.unsubscribe ? signal.unsubscribe(onabort) : signal.removeEventListener('abort', onabort);
        });
        signals = null;
    };
    signals.forEach((signal)=>signal.addEventListener('abort', onabort));
    const { signal: signal } = controller;
    signal.unsubscribe = ()=>(0, $cb898722622e1bbe$export$2e2bcd8739ae039).asap(unsubscribe);
    return signal;
};
var $44f58441f577bc02$export$2e2bcd8739ae039 = $44f58441f577bc02$var$composeSignals;


const $b97d47e9dccdea70$export$71b051935044bd5d = function*(chunk, chunkSize) {
    let len = chunk.byteLength;
    if (!chunkSize || len < chunkSize) {
        yield chunk;
        return;
    }
    let pos = 0;
    let end;
    while(pos < len){
        end = pos + chunkSize;
        yield chunk.slice(pos, end);
        pos = end;
    }
};
const $b97d47e9dccdea70$export$f9f241124ee3198e = async function*(iterable, chunkSize) {
    for await (const chunk of $b97d47e9dccdea70$var$readStream(iterable))yield* $b97d47e9dccdea70$export$71b051935044bd5d(chunk, chunkSize);
};
const $b97d47e9dccdea70$var$readStream = async function*(stream) {
    if (stream[Symbol.asyncIterator]) {
        yield* stream;
        return;
    }
    const reader = stream.getReader();
    try {
        for(;;){
            const { done: done, value: value } = await reader.read();
            if (done) break;
            yield value;
        }
    } finally{
        await reader.cancel();
    }
};
const $b97d47e9dccdea70$export$b0119225647bd83 = (stream, chunkSize, onProgress, onFinish)=>{
    const iterator = $b97d47e9dccdea70$export$f9f241124ee3198e(stream, chunkSize);
    let bytes = 0;
    let done;
    let _onFinish = (e)=>{
        if (!done) {
            done = true;
            onFinish && onFinish(e);
        }
    };
    return new ReadableStream({
        async pull (controller) {
            try {
                const { done: done, value: value } = await iterator.next();
                if (done) {
                    _onFinish();
                    controller.close();
                    return;
                }
                let len = value.byteLength;
                if (onProgress) {
                    let loadedBytes = bytes += len;
                    onProgress(loadedBytes);
                }
                controller.enqueue(new Uint8Array(value));
            } catch (err) {
                _onFinish(err);
                throw err;
            }
        },
        cancel (reason) {
            _onFinish(reason);
            return iterator.return();
        }
    }, {
        highWaterMark: 2
    });
};






/**
 * Estimate decoded byte length of a data:// URL *without* allocating large buffers.
 * - For base64: compute exact decoded size using length and padding;
 *               handle %XX at the character-count level (no string allocation).
 * - For non-base64: use UTF-8 byteLength of the encoded body as a safe upper bound.
 *
 * @param {string} url
 * @returns {number}
 */ 
var $7KfP5 = parcelRequire("7KfP5");
var $d594c5c87e2cd645$require$Buffer = $7KfP5.Buffer;
function $d594c5c87e2cd645$export$2e2bcd8739ae039(url) {
    if (!url || typeof url !== 'string') return 0;
    if (!url.startsWith('data:')) return 0;
    const comma = url.indexOf(',');
    if (comma < 0) return 0;
    const meta = url.slice(5, comma);
    const body = url.slice(comma + 1);
    const isBase64 = /;base64/i.test(meta);
    if (isBase64) {
        let effectiveLen = body.length;
        const len = body.length; // cache length
        for(let i = 0; i < len; i++)if (body.charCodeAt(i) === 37 /* '%' */  && i + 2 < len) {
            const a = body.charCodeAt(i + 1);
            const b = body.charCodeAt(i + 2);
            const isHex = (a >= 48 && a <= 57 || a >= 65 && a <= 70 || a >= 97 && a <= 102) && (b >= 48 && b <= 57 || b >= 65 && b <= 70 || b >= 97 && b <= 102);
            if (isHex) {
                effectiveLen -= 2;
                i += 2;
            }
        }
        let pad = 0;
        let idx = len - 1;
        const tailIsPct3D = (j)=>j >= 2 && body.charCodeAt(j - 2) === 37 && // '%'
            body.charCodeAt(j - 1) === 51 && // '3'
            (body.charCodeAt(j) === 68 || body.charCodeAt(j) === 100); // 'D' or 'd'
        if (idx >= 0) {
            if (body.charCodeAt(idx) === 61 /* '=' */ ) {
                pad++;
                idx--;
            } else if (tailIsPct3D(idx)) {
                pad++;
                idx -= 3;
            }
        }
        if (pad === 1 && idx >= 0) {
            if (body.charCodeAt(idx) === 61 /* '=' */ ) pad++;
            else if (tailIsPct3D(idx)) pad++;
        }
        const groups = Math.floor(effectiveLen / 4);
        const bytes = groups * 3 - (pad || 0);
        return bytes > 0 ? bytes : 0;
    }
    if (typeof $d594c5c87e2cd645$require$Buffer !== 'undefined' && typeof $d594c5c87e2cd645$require$Buffer.byteLength === 'function') return $d594c5c87e2cd645$require$Buffer.byteLength(body, 'utf8');
    // Compute UTF-8 byte length directly from UTF-16 code units without allocating
    // a byte buffer (TextEncoder.encode would defeat the DoS guard on large bodies).
    // Using body.length here would undercount non-ASCII (e.g. '€' is 1 code unit
    // but 3 UTF-8 bytes).
    let bytes = 0;
    for(let i = 0, len = body.length; i < len; i++){
        const c = body.charCodeAt(i);
        if (c < 0x80) bytes += 1;
        else if (c < 0x800) bytes += 2;
        else if (c >= 0xd800 && c <= 0xdbff && i + 1 < len) {
            const next = body.charCodeAt(i + 1);
            if (next >= 0xdc00 && next <= 0xdfff) {
                bytes += 4;
                i++;
            } else bytes += 3;
        } else bytes += 3;
    }
    return bytes;
}


const $50ed237574169459$export$a4ad2735b021c132 = "1.17.0";



const $08bbc66245da04da$var$DEFAULT_CHUNK_SIZE = 65536;
const { isFunction: $08bbc66245da04da$var$isFunction } = (0, $cb898722622e1bbe$export$2e2bcd8739ae039);
/**
 * Encode a UTF-8 string to a Latin-1 byte string for use with btoa().
 * This is a modern replacement for the deprecated unescape(encodeURIComponent(str)) pattern.
 *
 * @param {string} str The string to encode
 *
 * @returns {string} UTF-8 bytes as a Latin-1 string
 */ const $08bbc66245da04da$var$encodeUTF8 = (str)=>encodeURIComponent(str).replace(/%([0-9A-F]{2})/gi, (_, hex)=>String.fromCharCode(parseInt(hex, 16)));
// Node's WHATWG URL parser returns `username` and `password` percent-encoded.
// Decode before composing the `auth` option so credentials such as
// `my%40email.com:pass` are sent as `my@email.com:pass`. Falls back to the
// original value for malformed input so a bad encoding never throws.
const $08bbc66245da04da$var$decodeURIComponentSafe = (value)=>{
    if (!(0, $cb898722622e1bbe$export$2e2bcd8739ae039).isString(value)) return value;
    try {
        return decodeURIComponent(value);
    } catch (error) {
        return value;
    }
};
const $08bbc66245da04da$var$test = (fn, ...args)=>{
    try {
        return !!fn(...args);
    } catch (e) {
        return false;
    }
};
const $08bbc66245da04da$var$maybeWithAuthCredentials = (url)=>{
    const protocolIndex = url.indexOf('://');
    let urlToCheck = url;
    if (protocolIndex !== -1) urlToCheck = urlToCheck.slice(protocolIndex + 3);
    return urlToCheck.includes('@') || urlToCheck.includes(':');
};
const $08bbc66245da04da$var$factory = (env)=>{
    const globalObject = (0, $cb898722622e1bbe$export$2e2bcd8739ae039).global !== undefined && (0, $cb898722622e1bbe$export$2e2bcd8739ae039).global !== null ? (0, $cb898722622e1bbe$export$2e2bcd8739ae039).global : globalThis;
    const { ReadableStream: ReadableStream, TextEncoder: TextEncoder } = globalObject;
    env = (0, $cb898722622e1bbe$export$2e2bcd8739ae039).merge.call({
        skipUndefined: true
    }, {
        Request: globalObject.Request,
        Response: globalObject.Response
    }, env);
    const { fetch: envFetch, Request: Request, Response: Response } = env;
    const isFetchSupported = envFetch ? $08bbc66245da04da$var$isFunction(envFetch) : typeof fetch === 'function';
    const isRequestSupported = $08bbc66245da04da$var$isFunction(Request);
    const isResponseSupported = $08bbc66245da04da$var$isFunction(Response);
    if (!isFetchSupported) return false;
    const isReadableStreamSupported = isFetchSupported && $08bbc66245da04da$var$isFunction(ReadableStream);
    const encodeText = isFetchSupported && (typeof TextEncoder === 'function' ? ((encoder)=>(str)=>encoder.encode(str))(new TextEncoder()) : async (str)=>new Uint8Array(await new Request(str).arrayBuffer()));
    const supportsRequestStream = isRequestSupported && isReadableStreamSupported && $08bbc66245da04da$var$test(()=>{
        let duplexAccessed = false;
        const request = new Request((0, $dd4365a6b7ba12cc$export$2e2bcd8739ae039).origin, {
            body: new ReadableStream(),
            method: 'POST',
            get duplex () {
                duplexAccessed = true;
                return 'half';
            }
        });
        const hasContentType = request.headers.has('Content-Type');
        if (request.body != null) request.body.cancel();
        return duplexAccessed && !hasContentType;
    });
    const supportsResponseStream = isResponseSupported && isReadableStreamSupported && $08bbc66245da04da$var$test(()=>(0, $cb898722622e1bbe$export$2e2bcd8739ae039).isReadableStream(new Response('').body));
    const resolvers = {
        stream: supportsResponseStream && ((res)=>res.body)
    };
    isFetchSupported && (()=>{
        [
            'text',
            'arrayBuffer',
            'blob',
            'formData',
            'stream'
        ].forEach((type)=>{
            !resolvers[type] && (resolvers[type] = (res, config)=>{
                let method = res && res[type];
                if (method) return method.call(res);
                throw new (0, $f9b1affb0498ba1f$export$2e2bcd8739ae039)(`Response type '${type}' is not supported`, (0, $f9b1affb0498ba1f$export$2e2bcd8739ae039).ERR_NOT_SUPPORT, config);
            });
        });
    })();
    const getBodyLength = async (body)=>{
        if (body == null) return 0;
        if ((0, $cb898722622e1bbe$export$2e2bcd8739ae039).isBlob(body)) return body.size;
        if ((0, $cb898722622e1bbe$export$2e2bcd8739ae039).isSpecCompliantForm(body)) {
            const _request = new Request((0, $dd4365a6b7ba12cc$export$2e2bcd8739ae039).origin, {
                method: 'POST',
                body: body
            });
            return (await _request.arrayBuffer()).byteLength;
        }
        if ((0, $cb898722622e1bbe$export$2e2bcd8739ae039).isArrayBufferView(body) || (0, $cb898722622e1bbe$export$2e2bcd8739ae039).isArrayBuffer(body)) return body.byteLength;
        if ((0, $cb898722622e1bbe$export$2e2bcd8739ae039).isURLSearchParams(body)) body = body + '';
        if ((0, $cb898722622e1bbe$export$2e2bcd8739ae039).isString(body)) return (await encodeText(body)).byteLength;
    };
    const resolveBodyLength = async (headers, body)=>{
        const length = (0, $cb898722622e1bbe$export$2e2bcd8739ae039).toFiniteNumber(headers.getContentLength());
        return length == null ? getBodyLength(body) : length;
    };
    return async (config)=>{
        let { url: url, method: method, data: data, signal: signal, cancelToken: cancelToken, timeout: timeout, onDownloadProgress: onDownloadProgress, onUploadProgress: onUploadProgress, responseType: responseType, headers: headers, withCredentials: withCredentials = 'same-origin', fetchOptions: fetchOptions, maxContentLength: maxContentLength, maxBodyLength: maxBodyLength } = (0, $bcfc1ef472e4bbd0$export$2e2bcd8739ae039)(config);
        const hasMaxContentLength = (0, $cb898722622e1bbe$export$2e2bcd8739ae039).isNumber(maxContentLength) && maxContentLength > -1;
        const hasMaxBodyLength = (0, $cb898722622e1bbe$export$2e2bcd8739ae039).isNumber(maxBodyLength) && maxBodyLength > -1;
        const own = (key)=>(0, $cb898722622e1bbe$export$2e2bcd8739ae039).hasOwnProp(config, key) ? config[key] : undefined;
        let _fetch = envFetch || fetch;
        responseType = responseType ? (responseType + '').toLowerCase() : 'text';
        let composedSignal = (0, $44f58441f577bc02$export$2e2bcd8739ae039)([
            signal,
            cancelToken && cancelToken.toAbortSignal()
        ], timeout);
        let request = null;
        const unsubscribe = composedSignal && composedSignal.unsubscribe && (()=>{
            composedSignal.unsubscribe();
        });
        let requestContentLength;
        try {
            // HTTP basic authentication
            let auth = undefined;
            const configAuth = own('auth');
            if (configAuth) {
                const username = configAuth.username || '';
                const password = configAuth.password || '';
                auth = {
                    username: username,
                    password: password
                };
            }
            if ($08bbc66245da04da$var$maybeWithAuthCredentials(url)) {
                const parsedURL = new URL(url, (0, $dd4365a6b7ba12cc$export$2e2bcd8739ae039).origin);
                if (!auth && (parsedURL.username || parsedURL.password)) {
                    const urlUsername = $08bbc66245da04da$var$decodeURIComponentSafe(parsedURL.username);
                    const urlPassword = $08bbc66245da04da$var$decodeURIComponentSafe(parsedURL.password);
                    auth = {
                        username: urlUsername,
                        password: urlPassword
                    };
                }
                if (parsedURL.username || parsedURL.password) {
                    parsedURL.username = '';
                    parsedURL.password = '';
                    url = parsedURL.href;
                }
            }
            if (auth) {
                headers.delete('authorization');
                headers.set('Authorization', 'Basic ' + btoa($08bbc66245da04da$var$encodeUTF8((auth.username || '') + ':' + (auth.password || ''))));
            }
            // Enforce maxContentLength for data: URLs up-front so we never materialize
            // an oversized payload. The HTTP adapter applies the same check (see http.js
            // "if (protocol === 'data:')" branch).
            if (hasMaxContentLength && typeof url === 'string' && url.startsWith('data:')) {
                const estimated = (0, $d594c5c87e2cd645$export$2e2bcd8739ae039)(url);
                if (estimated > maxContentLength) throw new (0, $f9b1affb0498ba1f$export$2e2bcd8739ae039)('maxContentLength size of ' + maxContentLength + ' exceeded', (0, $f9b1affb0498ba1f$export$2e2bcd8739ae039).ERR_BAD_RESPONSE, config, request);
            }
            // Enforce maxBodyLength against the outbound request body before dispatch.
            // Mirrors http.js behavior (ERR_BAD_REQUEST / 'Request body larger than
            // maxBodyLength limit'). Skip when the body length cannot be determined
            // (e.g. a live ReadableStream supplied by the caller).
            if (hasMaxBodyLength && method !== 'get' && method !== 'head') {
                const outboundLength = await resolveBodyLength(headers, data);
                if (typeof outboundLength === 'number' && isFinite(outboundLength) && outboundLength > maxBodyLength) throw new (0, $f9b1affb0498ba1f$export$2e2bcd8739ae039)('Request body larger than maxBodyLength limit', (0, $f9b1affb0498ba1f$export$2e2bcd8739ae039).ERR_BAD_REQUEST, config, request);
            }
            if (onUploadProgress && supportsRequestStream && method !== 'get' && method !== 'head' && (requestContentLength = await resolveBodyLength(headers, data)) !== 0) {
                let _request = new Request(url, {
                    method: 'POST',
                    body: data,
                    duplex: 'half'
                });
                let contentTypeHeader;
                if ((0, $cb898722622e1bbe$export$2e2bcd8739ae039).isFormData(data) && (contentTypeHeader = _request.headers.get('content-type'))) headers.setContentType(contentTypeHeader);
                if (_request.body) {
                    const [onProgress, flush] = (0, $347f6d773d0c9353$export$d9fadd12586c18d6)(requestContentLength, (0, $347f6d773d0c9353$export$c1b28109d46c3592)((0, $347f6d773d0c9353$export$5d35863c355a22a9)(onUploadProgress)));
                    data = (0, $b97d47e9dccdea70$export$b0119225647bd83)(_request.body, $08bbc66245da04da$var$DEFAULT_CHUNK_SIZE, onProgress, flush);
                }
            }
            if (!(0, $cb898722622e1bbe$export$2e2bcd8739ae039).isString(withCredentials)) withCredentials = withCredentials ? 'include' : 'omit';
            // Cloudflare Workers throws when credentials are defined
            // see https://github.com/cloudflare/workerd/issues/902
            const isCredentialsSupported = isRequestSupported && 'credentials' in Request.prototype;
            // If data is FormData and Content-Type is multipart/form-data without boundary,
            // delete it so fetch can set it correctly with the boundary
            if ((0, $cb898722622e1bbe$export$2e2bcd8739ae039).isFormData(data)) {
                const contentType = headers.getContentType();
                if (contentType && /^multipart\/form-data/i.test(contentType) && !/boundary=/i.test(contentType)) headers.delete('content-type');
            }
            // Set User-Agent header if not already set (fetch defaults to 'node' in Node.js)
            headers.set('User-Agent', 'axios/' + (0, $50ed237574169459$export$a4ad2735b021c132), false);
            const resolvedOptions = {
                ...fetchOptions,
                signal: composedSignal,
                method: method.toUpperCase(),
                headers: (0, $b4b7fdb921feec02$export$c30c72bb7e677d54)(headers.normalize()),
                body: data,
                duplex: 'half',
                credentials: isCredentialsSupported ? withCredentials : undefined
            };
            request = isRequestSupported && new Request(url, resolvedOptions);
            let response = await (isRequestSupported ? _fetch(request, fetchOptions) : _fetch(url, resolvedOptions));
            // Cheap pre-check: if the server honestly declares a content-length that
            // already exceeds the cap, reject before we start streaming.
            if (hasMaxContentLength) {
                const declaredLength = (0, $cb898722622e1bbe$export$2e2bcd8739ae039).toFiniteNumber(response.headers.get('content-length'));
                if (declaredLength != null && declaredLength > maxContentLength) throw new (0, $f9b1affb0498ba1f$export$2e2bcd8739ae039)('maxContentLength size of ' + maxContentLength + ' exceeded', (0, $f9b1affb0498ba1f$export$2e2bcd8739ae039).ERR_BAD_RESPONSE, config, request);
            }
            const isStreamResponse = supportsResponseStream && (responseType === 'stream' || responseType === 'response');
            if (supportsResponseStream && response.body && (onDownloadProgress || hasMaxContentLength || isStreamResponse && unsubscribe)) {
                const options = {};
                [
                    'status',
                    'statusText',
                    'headers'
                ].forEach((prop)=>{
                    options[prop] = response[prop];
                });
                const responseContentLength = (0, $cb898722622e1bbe$export$2e2bcd8739ae039).toFiniteNumber(response.headers.get('content-length'));
                const [onProgress, flush] = onDownloadProgress && (0, $347f6d773d0c9353$export$d9fadd12586c18d6)(responseContentLength, (0, $347f6d773d0c9353$export$c1b28109d46c3592)((0, $347f6d773d0c9353$export$5d35863c355a22a9)(onDownloadProgress), true)) || [];
                let bytesRead = 0;
                const onChunkProgress = (loadedBytes)=>{
                    if (hasMaxContentLength) {
                        bytesRead = loadedBytes;
                        if (bytesRead > maxContentLength) throw new (0, $f9b1affb0498ba1f$export$2e2bcd8739ae039)('maxContentLength size of ' + maxContentLength + ' exceeded', (0, $f9b1affb0498ba1f$export$2e2bcd8739ae039).ERR_BAD_RESPONSE, config, request);
                    }
                    onProgress && onProgress(loadedBytes);
                };
                response = new Response((0, $b97d47e9dccdea70$export$b0119225647bd83)(response.body, $08bbc66245da04da$var$DEFAULT_CHUNK_SIZE, onChunkProgress, ()=>{
                    flush && flush();
                    unsubscribe && unsubscribe();
                }), options);
            }
            responseType = responseType || 'text';
            let responseData = await resolvers[(0, $cb898722622e1bbe$export$2e2bcd8739ae039).findKey(resolvers, responseType) || 'text'](response, config);
            // Fallback enforcement for environments without ReadableStream support
            // (legacy runtimes). Detect materialized size from typed output; skip
            // streams/Response passthrough since the user will read those themselves.
            if (hasMaxContentLength && !supportsResponseStream && !isStreamResponse) {
                let materializedSize;
                if (responseData != null) {
                    if (typeof responseData.byteLength === 'number') materializedSize = responseData.byteLength;
                    else if (typeof responseData.size === 'number') materializedSize = responseData.size;
                    else if (typeof responseData === 'string') materializedSize = typeof TextEncoder === 'function' ? new TextEncoder().encode(responseData).byteLength : responseData.length;
                }
                if (typeof materializedSize === 'number' && materializedSize > maxContentLength) throw new (0, $f9b1affb0498ba1f$export$2e2bcd8739ae039)('maxContentLength size of ' + maxContentLength + ' exceeded', (0, $f9b1affb0498ba1f$export$2e2bcd8739ae039).ERR_BAD_RESPONSE, config, request);
            }
            !isStreamResponse && unsubscribe && unsubscribe();
            return await new Promise((resolve, reject)=>{
                (0, $65b761545c1367d7$export$2e2bcd8739ae039)(resolve, reject, {
                    data: responseData,
                    headers: (0, $a107ecb812e3a6a9$export$2e2bcd8739ae039).from(response.headers),
                    status: response.status,
                    statusText: response.statusText,
                    config: config,
                    request: request
                });
            });
        } catch (err) {
            unsubscribe && unsubscribe();
            // Safari can surface fetch aborts as a DOMException-like object whose
            // branded getters throw. Prefer our composed signal reason before reading
            // the caught error, preserving timeout vs cancellation semantics.
            if (composedSignal && composedSignal.aborted && composedSignal.reason instanceof (0, $f9b1affb0498ba1f$export$2e2bcd8739ae039)) {
                const canceledError = composedSignal.reason;
                canceledError.config = config;
                request && (canceledError.request = request);
                err !== canceledError && (canceledError.cause = err);
                throw canceledError;
            }
            if (err && err.name === 'TypeError' && /Load failed|fetch/i.test(err.message)) throw Object.assign(new (0, $f9b1affb0498ba1f$export$2e2bcd8739ae039)('Network Error', (0, $f9b1affb0498ba1f$export$2e2bcd8739ae039).ERR_NETWORK, config, request, err && err.response), {
                cause: err.cause || err
            });
            throw (0, $f9b1affb0498ba1f$export$2e2bcd8739ae039).from(err, err && err.code, config, request, err && err.response);
        }
    };
};
const $08bbc66245da04da$var$seedCache = new Map();
const $08bbc66245da04da$export$3105c6651375d4fa = (config)=>{
    let env = config && config.env || {};
    const { fetch: fetch1, Request: Request, Response: Response } = env;
    const seeds = [
        Request,
        Response,
        fetch1
    ];
    let len = seeds.length, i = len, seed, target, map = $08bbc66245da04da$var$seedCache;
    while(i--){
        seed = seeds[i];
        target = map.get(seed);
        target === undefined && map.set(seed, target = i ? new Map() : $08bbc66245da04da$var$factory(env));
        map = target;
    }
    return target;
};
const $08bbc66245da04da$var$adapter = $08bbc66245da04da$export$3105c6651375d4fa();
var $08bbc66245da04da$export$2e2bcd8739ae039 = $08bbc66245da04da$var$adapter;



/**
 * Known adapters mapping.
 * Provides environment-specific adapters for Axios:
 * - `http` for Node.js
 * - `xhr` for browsers
 * - `fetch` for fetch API-based requests
 *
 * @type {Object<string, Function|Object>}
 */ const $7e2e3476ae4147c4$var$knownAdapters = {
    http: (0, $243db4f4ede3c5cf$export$2e2bcd8739ae039),
    xhr: (0, $a896e51633600c95$export$2e2bcd8739ae039),
    fetch: {
        get: $08bbc66245da04da$export$3105c6651375d4fa
    }
};
// Assign adapter names for easier debugging and identification
(0, $cb898722622e1bbe$export$2e2bcd8739ae039).forEach($7e2e3476ae4147c4$var$knownAdapters, (fn, value)=>{
    if (fn) {
        try {
            // Null-proto descriptors so a polluted Object.prototype.get cannot turn
            // these data descriptors into accessor descriptors on the way in.
            Object.defineProperty(fn, 'name', {
                __proto__: null,
                value: value
            });
        } catch (e) {
        // eslint-disable-next-line no-empty
        }
        Object.defineProperty(fn, 'adapterName', {
            __proto__: null,
            value: value
        });
    }
});
/**
 * Render a rejection reason string for unknown or unsupported adapters
 *
 * @param {string} reason
 * @returns {string}
 */ const $7e2e3476ae4147c4$var$renderReason = (reason)=>`- ${reason}`;
/**
 * Check if the adapter is resolved (function, null, or false)
 *
 * @param {Function|null|false} adapter
 * @returns {boolean}
 */ const $7e2e3476ae4147c4$var$isResolvedHandle = (adapter)=>(0, $cb898722622e1bbe$export$2e2bcd8739ae039).isFunction(adapter) || adapter === null || adapter === false;
/**
 * Get the first suitable adapter from the provided list.
 * Tries each adapter in order until a supported one is found.
 * Throws an AxiosError if no adapter is suitable.
 *
 * @param {Array<string|Function>|string|Function} adapters - Adapter(s) by name or function.
 * @param {Object} config - Axios request configuration
 * @throws {AxiosError} If no suitable adapter is available
 * @returns {Function} The resolved adapter function
 */ function $7e2e3476ae4147c4$var$getAdapter(adapters, config) {
    adapters = (0, $cb898722622e1bbe$export$2e2bcd8739ae039).isArray(adapters) ? adapters : [
        adapters
    ];
    const { length: length } = adapters;
    let nameOrAdapter;
    let adapter;
    const rejectedReasons = {};
    for(let i = 0; i < length; i++){
        nameOrAdapter = adapters[i];
        let id;
        adapter = nameOrAdapter;
        if (!$7e2e3476ae4147c4$var$isResolvedHandle(nameOrAdapter)) {
            adapter = $7e2e3476ae4147c4$var$knownAdapters[(id = String(nameOrAdapter)).toLowerCase()];
            if (adapter === undefined) throw new (0, $f9b1affb0498ba1f$export$2e2bcd8739ae039)(`Unknown adapter '${id}'`);
        }
        if (adapter && ((0, $cb898722622e1bbe$export$2e2bcd8739ae039).isFunction(adapter) || (adapter = adapter.get(config)))) break;
        rejectedReasons[id || '#' + i] = adapter;
    }
    if (!adapter) {
        const reasons = Object.entries(rejectedReasons).map(([id, state])=>`adapter ${id} ` + (state === false ? 'is not supported by the environment' : 'is not available in the build'));
        let s = length ? reasons.length > 1 ? 'since :\n' + reasons.map($7e2e3476ae4147c4$var$renderReason).join('\n') : ' ' + $7e2e3476ae4147c4$var$renderReason(reasons[0]) : 'as no adapter specified';
        throw new (0, $f9b1affb0498ba1f$export$2e2bcd8739ae039)(`There is no suitable adapter to dispatch the request ` + s, 'ERR_NOT_SUPPORT');
    }
    return adapter;
}
var /**
 * Exports Axios adapters and utility to resolve an adapter
 */ $7e2e3476ae4147c4$export$2e2bcd8739ae039 = {
    getAdapter: /**
   * Resolve an adapter from a list of adapter names or functions.
   * @type {Function}
   */ $7e2e3476ae4147c4$var$getAdapter,
    /**
   * Exposes all known adapters
   * @type {Object<string, Function|Object>}
   */ adapters: $7e2e3476ae4147c4$var$knownAdapters
};


'use strict';
/**
 * Throws a `CanceledError` if cancellation has been requested.
 *
 * @param {Object} config The config that is to be used for the request
 *
 * @returns {void}
 */ function $ad4477c883aa8b31$var$throwIfCancellationRequested(config) {
    if (config.cancelToken) config.cancelToken.throwIfRequested();
    if (config.signal && config.signal.aborted) throw new (0, $d2353333ffc17c53$export$2e2bcd8739ae039)(null, config);
}
function $ad4477c883aa8b31$export$2e2bcd8739ae039(config) {
    $ad4477c883aa8b31$var$throwIfCancellationRequested(config);
    config.headers = (0, $a107ecb812e3a6a9$export$2e2bcd8739ae039).from(config.headers);
    // Transform request data
    config.data = (0, $cbed29dc306d3656$export$2e2bcd8739ae039).call(config, config.transformRequest);
    if ([
        'post',
        'put',
        'patch'
    ].indexOf(config.method) !== -1) config.headers.setContentType('application/x-www-form-urlencoded', false);
    const adapter = (0, $7e2e3476ae4147c4$export$2e2bcd8739ae039).getAdapter(config.adapter || (0, $e1c9a57ef3ebea92$export$2e2bcd8739ae039).adapter, config);
    return adapter(config).then(function onAdapterResolution(response) {
        $ad4477c883aa8b31$var$throwIfCancellationRequested(config);
        // Expose the current response on config so that transformResponse can
        // attach it to any AxiosError it throws (e.g. on JSON parse failure).
        // We clean it up afterwards to avoid polluting the config object.
        config.response = response;
        try {
            response.data = (0, $cbed29dc306d3656$export$2e2bcd8739ae039).call(config, config.transformResponse, response);
        } finally{
            delete config.response;
        }
        response.headers = (0, $a107ecb812e3a6a9$export$2e2bcd8739ae039).from(response.headers);
        return response;
    }, function onAdapterRejection(reason) {
        if (!(0, $7ccf50e37e313489$export$2e2bcd8739ae039)(reason)) {
            $ad4477c883aa8b31$var$throwIfCancellationRequested(config);
            // Transform response data
            if (reason && reason.response) {
                config.response = reason.response;
                try {
                    reason.response.data = (0, $cbed29dc306d3656$export$2e2bcd8739ae039).call(config, config.transformResponse, reason.response);
                } finally{
                    delete config.response;
                }
                reason.response.headers = (0, $a107ecb812e3a6a9$export$2e2bcd8739ae039).from(reason.response.headers);
            }
        }
        return Promise.reject(reason);
    });
}






'use strict';
const $130adcb876facb14$var$validators = {};
// eslint-disable-next-line func-names
[
    'object',
    'boolean',
    'number',
    'function',
    'string',
    'symbol'
].forEach((type, i)=>{
    $130adcb876facb14$var$validators[type] = function validator(thing) {
        return typeof thing === type || 'a' + (i < 1 ? 'n ' : ' ') + type;
    };
});
const $130adcb876facb14$var$deprecatedWarnings = {};
/**
 * Transitional option validator
 *
 * @param {function|boolean?} validator - set to false if the transitional option has been removed
 * @param {string?} version - deprecated version / removed since version
 * @param {string?} message - some message with additional info
 *
 * @returns {function}
 */ $130adcb876facb14$var$validators.transitional = function transitional(validator, version, message) {
    function formatMessage(opt, desc) {
        return '[Axios v' + (0, $50ed237574169459$export$a4ad2735b021c132) + "] Transitional option '" + opt + "'" + desc + (message ? '. ' + message : '');
    }
    // eslint-disable-next-line func-names
    return (value, opt, opts)=>{
        if (validator === false) throw new (0, $f9b1affb0498ba1f$export$2e2bcd8739ae039)(formatMessage(opt, ' has been removed' + (version ? ' in ' + version : '')), (0, $f9b1affb0498ba1f$export$2e2bcd8739ae039).ERR_DEPRECATED);
        if (version && !$130adcb876facb14$var$deprecatedWarnings[opt]) {
            $130adcb876facb14$var$deprecatedWarnings[opt] = true;
            // eslint-disable-next-line no-console
            console.warn(formatMessage(opt, ' has been deprecated since v' + version + ' and will be removed in the near future'));
        }
        return validator ? validator(value, opt, opts) : true;
    };
};
$130adcb876facb14$var$validators.spelling = function spelling(correctSpelling) {
    return (value, opt)=>{
        // eslint-disable-next-line no-console
        console.warn(`${opt} is likely a misspelling of ${correctSpelling}`);
        return true;
    };
};
/**
 * Assert object's properties type
 *
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 *
 * @returns {object}
 */ function $130adcb876facb14$var$assertOptions(options, schema, allowUnknown) {
    if (typeof options !== 'object') throw new (0, $f9b1affb0498ba1f$export$2e2bcd8739ae039)('options must be an object', (0, $f9b1affb0498ba1f$export$2e2bcd8739ae039).ERR_BAD_OPTION_VALUE);
    const keys = Object.keys(options);
    let i = keys.length;
    while(i-- > 0){
        const opt = keys[i];
        // Use hasOwnProperty so a polluted Object.prototype.<opt> cannot supply
        // a non-function validator and cause a TypeError.
        const validator = Object.prototype.hasOwnProperty.call(schema, opt) ? schema[opt] : undefined;
        if (validator) {
            const value = options[opt];
            const result = value === undefined || validator(value, opt, options);
            if (result !== true) throw new (0, $f9b1affb0498ba1f$export$2e2bcd8739ae039)('option ' + opt + ' must be ' + result, (0, $f9b1affb0498ba1f$export$2e2bcd8739ae039).ERR_BAD_OPTION_VALUE);
            continue;
        }
        if (allowUnknown !== true) throw new (0, $f9b1affb0498ba1f$export$2e2bcd8739ae039)('Unknown option ' + opt, (0, $f9b1affb0498ba1f$export$2e2bcd8739ae039).ERR_BAD_OPTION);
    }
}
var $130adcb876facb14$export$2e2bcd8739ae039 = {
    assertOptions: $130adcb876facb14$var$assertOptions,
    validators: $130adcb876facb14$var$validators
};




'use strict';
const $1e2450381b7b932c$var$validators = (0, $130adcb876facb14$export$2e2bcd8739ae039).validators;
/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 *
 * @return {Axios} A new instance of Axios
 */ class $1e2450381b7b932c$var$Axios {
    constructor(instanceConfig){
        this.defaults = instanceConfig || {};
        this.interceptors = {
            request: new (0, $95dc0c3cfa5e38d6$export$2e2bcd8739ae039)(),
            response: new (0, $95dc0c3cfa5e38d6$export$2e2bcd8739ae039)()
        };
    }
    /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */ async request(configOrUrl, config) {
        try {
            return await this._request(configOrUrl, config);
        } catch (err) {
            if (err instanceof Error) {
                let dummy = {};
                Error.captureStackTrace ? Error.captureStackTrace(dummy) : dummy = new Error();
                // slice off the Error: ... line
                const stack = (()=>{
                    if (!dummy.stack) return '';
                    const firstNewlineIndex = dummy.stack.indexOf('\n');
                    return firstNewlineIndex === -1 ? '' : dummy.stack.slice(firstNewlineIndex + 1);
                })();
                try {
                    if (!err.stack) err.stack = stack;
                    else if (stack) {
                        const firstNewlineIndex = stack.indexOf('\n');
                        const secondNewlineIndex = firstNewlineIndex === -1 ? -1 : stack.indexOf('\n', firstNewlineIndex + 1);
                        const stackWithoutTwoTopLines = secondNewlineIndex === -1 ? '' : stack.slice(secondNewlineIndex + 1);
                        if (!String(err.stack).endsWith(stackWithoutTwoTopLines)) err.stack += '\n' + stack;
                    }
                } catch (e) {
                // ignore the case where "stack" is an un-writable property
                }
            }
            throw err;
        }
    }
    _request(configOrUrl, config) {
        /*eslint no-param-reassign:0*/ // Allow for axios('example/url'[, config]) a la fetch API
        if (typeof configOrUrl === 'string') {
            config = config || {};
            config.url = configOrUrl;
        } else config = configOrUrl || {};
        config = (0, $df9d9d057b970962$export$2e2bcd8739ae039)(this.defaults, config);
        const { transitional: transitional, paramsSerializer: paramsSerializer, headers: headers } = config;
        if (transitional !== undefined) (0, $130adcb876facb14$export$2e2bcd8739ae039).assertOptions(transitional, {
            silentJSONParsing: $1e2450381b7b932c$var$validators.transitional($1e2450381b7b932c$var$validators.boolean),
            forcedJSONParsing: $1e2450381b7b932c$var$validators.transitional($1e2450381b7b932c$var$validators.boolean),
            clarifyTimeoutError: $1e2450381b7b932c$var$validators.transitional($1e2450381b7b932c$var$validators.boolean),
            legacyInterceptorReqResOrdering: $1e2450381b7b932c$var$validators.transitional($1e2450381b7b932c$var$validators.boolean),
            advertiseZstdAcceptEncoding: $1e2450381b7b932c$var$validators.transitional($1e2450381b7b932c$var$validators.boolean)
        }, false);
        if (paramsSerializer != null) {
            if ((0, $cb898722622e1bbe$export$2e2bcd8739ae039).isFunction(paramsSerializer)) config.paramsSerializer = {
                serialize: paramsSerializer
            };
            else (0, $130adcb876facb14$export$2e2bcd8739ae039).assertOptions(paramsSerializer, {
                encode: $1e2450381b7b932c$var$validators.function,
                serialize: $1e2450381b7b932c$var$validators.function
            }, true);
        }
        // Set config.allowAbsoluteUrls
        if (config.allowAbsoluteUrls !== undefined) ;
        else if (this.defaults.allowAbsoluteUrls !== undefined) config.allowAbsoluteUrls = this.defaults.allowAbsoluteUrls;
        else config.allowAbsoluteUrls = true;
        (0, $130adcb876facb14$export$2e2bcd8739ae039).assertOptions(config, {
            baseUrl: $1e2450381b7b932c$var$validators.spelling('baseURL'),
            withXsrfToken: $1e2450381b7b932c$var$validators.spelling('withXSRFToken')
        }, true);
        // Set config.method
        config.method = (config.method || this.defaults.method || 'get').toLowerCase();
        // Flatten headers
        let contextHeaders = headers && (0, $cb898722622e1bbe$export$2e2bcd8739ae039).merge(headers.common, headers[config.method]);
        headers && (0, $cb898722622e1bbe$export$2e2bcd8739ae039).forEach([
            'delete',
            'get',
            'head',
            'post',
            'put',
            'patch',
            'query',
            'common'
        ], (method)=>{
            delete headers[method];
        });
        config.headers = (0, $a107ecb812e3a6a9$export$2e2bcd8739ae039).concat(contextHeaders, headers);
        // filter out skipped interceptors
        const requestInterceptorChain = [];
        let synchronousRequestInterceptors = true;
        this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
            if (typeof interceptor.runWhen === 'function' && interceptor.runWhen(config) === false) return;
            synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;
            const transitional = config.transitional || (0, $f10e0d1daedbcc26$export$2e2bcd8739ae039);
            const legacyInterceptorReqResOrdering = transitional && transitional.legacyInterceptorReqResOrdering;
            if (legacyInterceptorReqResOrdering) requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
            else requestInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
        });
        const responseInterceptorChain = [];
        this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
            responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
        });
        let promise;
        let i = 0;
        let len;
        if (!synchronousRequestInterceptors) {
            const chain = [
                (0, $ad4477c883aa8b31$export$2e2bcd8739ae039).bind(this),
                undefined
            ];
            chain.unshift(...requestInterceptorChain);
            chain.push(...responseInterceptorChain);
            len = chain.length;
            promise = Promise.resolve(config);
            while(i < len)promise = promise.then(chain[i++], chain[i++]);
            return promise;
        }
        len = requestInterceptorChain.length;
        let newConfig = config;
        while(i < len){
            const onFulfilled = requestInterceptorChain[i++];
            const onRejected = requestInterceptorChain[i++];
            try {
                newConfig = onFulfilled(newConfig);
            } catch (error) {
                onRejected.call(this, error);
                break;
            }
        }
        try {
            promise = (0, $ad4477c883aa8b31$export$2e2bcd8739ae039).call(this, newConfig);
        } catch (error) {
            return Promise.reject(error);
        }
        i = 0;
        len = responseInterceptorChain.length;
        while(i < len)promise = promise.then(responseInterceptorChain[i++], responseInterceptorChain[i++]);
        return promise;
    }
    getUri(config) {
        config = (0, $df9d9d057b970962$export$2e2bcd8739ae039)(this.defaults, config);
        const fullPath = (0, $fc4436884ed94f0b$export$2e2bcd8739ae039)(config.baseURL, config.url, config.allowAbsoluteUrls);
        return (0, $09cc5760c042eaec$export$2e2bcd8739ae039)(fullPath, config.params, config.paramsSerializer);
    }
}
// Provide aliases for supported request methods
(0, $cb898722622e1bbe$export$2e2bcd8739ae039).forEach([
    'delete',
    'get',
    'head',
    'options'
], function forEachMethodNoData(method) {
    /*eslint func-names:0*/ $1e2450381b7b932c$var$Axios.prototype[method] = function(url, config) {
        return this.request((0, $df9d9d057b970962$export$2e2bcd8739ae039)(config || {}, {
            method: method,
            url: url,
            data: (config || {}).data
        }));
    };
});
(0, $cb898722622e1bbe$export$2e2bcd8739ae039).forEach([
    'post',
    'put',
    'patch',
    'query'
], function forEachMethodWithData(method) {
    function generateHTTPMethod(isForm) {
        return function httpMethod(url, data, config) {
            return this.request((0, $df9d9d057b970962$export$2e2bcd8739ae039)(config || {}, {
                method: method,
                headers: isForm ? {
                    'Content-Type': 'multipart/form-data'
                } : {},
                url: url,
                data: data
            }));
        };
    }
    $1e2450381b7b932c$var$Axios.prototype[method] = generateHTTPMethod();
    // QUERY is a safe/idempotent read method; multipart form bodies don't fit
    // its semantics, so no queryForm shorthand is generated.
    if (method !== 'query') $1e2450381b7b932c$var$Axios.prototype[method + 'Form'] = generateHTTPMethod(true);
});
var $1e2450381b7b932c$export$2e2bcd8739ae039 = $1e2450381b7b932c$var$Axios;







'use strict';
/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @param {Function} executor The executor function.
 *
 * @returns {CancelToken}
 */ class $6b31aeb513694a91$var$CancelToken {
    constructor(executor){
        if (typeof executor !== 'function') throw new TypeError('executor must be a function.');
        let resolvePromise;
        this.promise = new Promise(function promiseExecutor(resolve) {
            resolvePromise = resolve;
        });
        const token = this;
        // eslint-disable-next-line func-names
        this.promise.then((cancel)=>{
            if (!token._listeners) return;
            let i = token._listeners.length;
            while(i-- > 0)token._listeners[i](cancel);
            token._listeners = null;
        });
        // eslint-disable-next-line func-names
        this.promise.then = (onfulfilled)=>{
            let _resolve;
            // eslint-disable-next-line func-names
            const promise = new Promise((resolve)=>{
                token.subscribe(resolve);
                _resolve = resolve;
            }).then(onfulfilled);
            promise.cancel = function reject() {
                token.unsubscribe(_resolve);
            };
            return promise;
        };
        executor(function cancel(message, config, request) {
            if (token.reason) // Cancellation has already been requested
            return;
            token.reason = new (0, $d2353333ffc17c53$export$2e2bcd8739ae039)(message, config, request);
            resolvePromise(token.reason);
        });
    }
    /**
   * Throws a `CanceledError` if cancellation has been requested.
   */ throwIfRequested() {
        if (this.reason) throw this.reason;
    }
    /**
   * Subscribe to the cancel signal
   */ subscribe(listener) {
        if (this.reason) {
            listener(this.reason);
            return;
        }
        if (this._listeners) this._listeners.push(listener);
        else this._listeners = [
            listener
        ];
    }
    /**
   * Unsubscribe from the cancel signal
   */ unsubscribe(listener) {
        if (!this._listeners) return;
        const index = this._listeners.indexOf(listener);
        if (index !== -1) this._listeners.splice(index, 1);
    }
    toAbortSignal() {
        const controller = new AbortController();
        const abort = (err)=>{
            controller.abort(err);
        };
        this.subscribe(abort);
        controller.signal.unsubscribe = ()=>this.unsubscribe(abort);
        return controller.signal;
    }
    /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */ static source() {
        let cancel;
        const token = new $6b31aeb513694a91$var$CancelToken(function executor(c) {
            cancel = c;
        });
        return {
            token: token,
            cancel: cancel
        };
    }
}
var $6b31aeb513694a91$export$2e2bcd8739ae039 = $6b31aeb513694a91$var$CancelToken;






'use strict';
function $3c9d2466bb005877$export$2e2bcd8739ae039(callback) {
    return function wrap(arr) {
        return callback.apply(null, arr);
    };
}



'use strict';
function $0747345d83b28a29$export$2e2bcd8739ae039(payload) {
    return (0, $cb898722622e1bbe$export$2e2bcd8739ae039).isObject(payload) && payload.isAxiosError === true;
}




const $7cfa68ccb196e159$var$HttpStatusCode = {
    Continue: 100,
    SwitchingProtocols: 101,
    Processing: 102,
    EarlyHints: 103,
    Ok: 200,
    Created: 201,
    Accepted: 202,
    NonAuthoritativeInformation: 203,
    NoContent: 204,
    ResetContent: 205,
    PartialContent: 206,
    MultiStatus: 207,
    AlreadyReported: 208,
    ImUsed: 226,
    MultipleChoices: 300,
    MovedPermanently: 301,
    Found: 302,
    SeeOther: 303,
    NotModified: 304,
    UseProxy: 305,
    Unused: 306,
    TemporaryRedirect: 307,
    PermanentRedirect: 308,
    BadRequest: 400,
    Unauthorized: 401,
    PaymentRequired: 402,
    Forbidden: 403,
    NotFound: 404,
    MethodNotAllowed: 405,
    NotAcceptable: 406,
    ProxyAuthenticationRequired: 407,
    RequestTimeout: 408,
    Conflict: 409,
    Gone: 410,
    LengthRequired: 411,
    PreconditionFailed: 412,
    PayloadTooLarge: 413,
    UriTooLong: 414,
    UnsupportedMediaType: 415,
    RangeNotSatisfiable: 416,
    ExpectationFailed: 417,
    ImATeapot: 418,
    MisdirectedRequest: 421,
    UnprocessableEntity: 422,
    Locked: 423,
    FailedDependency: 424,
    TooEarly: 425,
    UpgradeRequired: 426,
    PreconditionRequired: 428,
    TooManyRequests: 429,
    RequestHeaderFieldsTooLarge: 431,
    UnavailableForLegalReasons: 451,
    InternalServerError: 500,
    NotImplemented: 501,
    BadGateway: 502,
    ServiceUnavailable: 503,
    GatewayTimeout: 504,
    HttpVersionNotSupported: 505,
    VariantAlsoNegotiates: 506,
    InsufficientStorage: 507,
    LoopDetected: 508,
    NotExtended: 510,
    NetworkAuthenticationRequired: 511,
    WebServerIsDown: 521,
    ConnectionTimedOut: 522,
    OriginIsUnreachable: 523,
    TimeoutOccurred: 524,
    SslHandshakeFailed: 525,
    InvalidSslCertificate: 526
};
Object.entries($7cfa68ccb196e159$var$HttpStatusCode).forEach(([key, value])=>{
    $7cfa68ccb196e159$var$HttpStatusCode[value] = key;
});
var $7cfa68ccb196e159$export$2e2bcd8739ae039 = $7cfa68ccb196e159$var$HttpStatusCode;


'use strict';
/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 *
 * @returns {Axios} A new instance of Axios
 */ function $782a7beaab0195f3$var$createInstance(defaultConfig) {
    const context = new (0, $1e2450381b7b932c$export$2e2bcd8739ae039)(defaultConfig);
    const instance = (0, $9bb29d85db6f995e$export$2e2bcd8739ae039)((0, $1e2450381b7b932c$export$2e2bcd8739ae039).prototype.request, context);
    // Copy axios.prototype to instance
    (0, $cb898722622e1bbe$export$2e2bcd8739ae039).extend(instance, (0, $1e2450381b7b932c$export$2e2bcd8739ae039).prototype, context, {
        allOwnKeys: true
    });
    // Copy context to instance
    (0, $cb898722622e1bbe$export$2e2bcd8739ae039).extend(instance, context, null, {
        allOwnKeys: true
    });
    // Factory for creating new instances
    instance.create = function create(instanceConfig) {
        return $782a7beaab0195f3$var$createInstance((0, $df9d9d057b970962$export$2e2bcd8739ae039)(defaultConfig, instanceConfig));
    };
    return instance;
}
// Create the default instance to be exported
const $782a7beaab0195f3$var$axios = $782a7beaab0195f3$var$createInstance((0, $e1c9a57ef3ebea92$export$2e2bcd8739ae039));
// Expose Axios class to allow class inheritance
$782a7beaab0195f3$var$axios.Axios = (0, $1e2450381b7b932c$export$2e2bcd8739ae039);
// Expose Cancel & CancelToken
$782a7beaab0195f3$var$axios.CanceledError = (0, $d2353333ffc17c53$export$2e2bcd8739ae039);
$782a7beaab0195f3$var$axios.CancelToken = (0, $6b31aeb513694a91$export$2e2bcd8739ae039);
$782a7beaab0195f3$var$axios.isCancel = (0, $7ccf50e37e313489$export$2e2bcd8739ae039);
$782a7beaab0195f3$var$axios.VERSION = (0, $50ed237574169459$export$a4ad2735b021c132);
$782a7beaab0195f3$var$axios.toFormData = (0, $ec2d6980f48e9528$export$2e2bcd8739ae039);
// Expose AxiosError class
$782a7beaab0195f3$var$axios.AxiosError = (0, $f9b1affb0498ba1f$export$2e2bcd8739ae039);
// alias for CanceledError for backward compatibility
$782a7beaab0195f3$var$axios.Cancel = $782a7beaab0195f3$var$axios.CanceledError;
// Expose all/spread
$782a7beaab0195f3$var$axios.all = function all(promises) {
    return Promise.all(promises);
};
$782a7beaab0195f3$var$axios.spread = (0, $3c9d2466bb005877$export$2e2bcd8739ae039);
// Expose isAxiosError
$782a7beaab0195f3$var$axios.isAxiosError = (0, $0747345d83b28a29$export$2e2bcd8739ae039);
// Expose mergeConfig
$782a7beaab0195f3$var$axios.mergeConfig = (0, $df9d9d057b970962$export$2e2bcd8739ae039);
$782a7beaab0195f3$var$axios.AxiosHeaders = (0, $a107ecb812e3a6a9$export$2e2bcd8739ae039);
$782a7beaab0195f3$var$axios.formToJSON = (thing)=>(0, $372f04b133c1df53$export$2e2bcd8739ae039)((0, $cb898722622e1bbe$export$2e2bcd8739ae039).isHTMLForm(thing) ? new FormData(thing) : thing);
$782a7beaab0195f3$var$axios.getAdapter = (0, $7e2e3476ae4147c4$export$2e2bcd8739ae039).getAdapter;
$782a7beaab0195f3$var$axios.HttpStatusCode = (0, $7cfa68ccb196e159$export$2e2bcd8739ae039);
$782a7beaab0195f3$var$axios.default = $782a7beaab0195f3$var$axios;
var // this module should only have a default export
$782a7beaab0195f3$export$2e2bcd8739ae039 = $782a7beaab0195f3$var$axios;


// This module is intended to unwrap Axios default export as named.
// Keep top-level export same with static properties
// so that it can keep same with es module or cjs
const { Axios: $f6169e2f48b1aaca$export$1c00760e9e5a4e95, AxiosError: $f6169e2f48b1aaca$export$c1fbed17c2f6a328, CanceledError: $f6169e2f48b1aaca$export$1ab0c6b20d94fa14, isCancel: $f6169e2f48b1aaca$export$3b22524397b493c6, CancelToken: $f6169e2f48b1aaca$export$fd08e3cb425f0d61, VERSION: $f6169e2f48b1aaca$export$a4ad2735b021c132, all: $f6169e2f48b1aaca$export$84bf76cd7afc7469, Cancel: $f6169e2f48b1aaca$export$848c9b7ead0df967, isAxiosError: $f6169e2f48b1aaca$export$fbafdbe06a5b5a9a, spread: $f6169e2f48b1aaca$export$3ae0fd4797ed47c8, toFormData: $f6169e2f48b1aaca$export$10ae0d317ea97f8b, AxiosHeaders: $f6169e2f48b1aaca$export$4e7d6ff0f3e6520, HttpStatusCode: $f6169e2f48b1aaca$export$a972f69c851492b3, formToJSON: $f6169e2f48b1aaca$export$86d7c59254d6a2c9, getAdapter: $f6169e2f48b1aaca$export$17ddc20a97d669e2, mergeConfig: $f6169e2f48b1aaca$export$7ec1ebcfa9d8bd6a, create: $f6169e2f48b1aaca$export$185802fd694ee1f5 } = (0, $782a7beaab0195f3$export$2e2bcd8739ae039);







var $7658ab69ad25d4be$var$_queries;
var $7658ab69ad25d4be$export$5dde0cd941da8468 = class extends (0, $78d76f0c1d823036$export$d26086b469ecdbcc) {
    constructor(config = {}){
        super();
        this.config = config;
        (0, $a0cb2f29b373067e$export$addf369becd23283)(this, $7658ab69ad25d4be$var$_queries);
        (0, $a0cb2f29b373067e$export$42432efe6614d3b4)(this, $7658ab69ad25d4be$var$_queries, /* @__PURE__ */ new Map());
    }
    build(client, options, state) {
        const queryKey = options.queryKey;
        const queryHash = options.queryHash ?? (0, $e9d6dc959f196f70$export$cc90ca97bc0d73fd)(queryKey, options);
        let query = this.get(queryHash);
        if (!query) {
            query = new (0, $d3cc80c94d2af732$export$62297b13309008b2)({
                client: client,
                queryKey: queryKey,
                queryHash: queryHash,
                options: client.defaultQueryOptions(options),
                state: state,
                defaultOptions: client.getQueryDefaults(queryKey)
            });
            this.add(query);
        }
        return query;
    }
    add(query) {
        if (!(0, $a0cb2f29b373067e$export$18a094aefa070634)(this, $7658ab69ad25d4be$var$_queries).has(query.queryHash)) {
            (0, $a0cb2f29b373067e$export$18a094aefa070634)(this, $7658ab69ad25d4be$var$_queries).set(query.queryHash, query);
            this.notify({
                type: "added",
                query: query
            });
        }
    }
    remove(query) {
        const queryInMap = (0, $a0cb2f29b373067e$export$18a094aefa070634)(this, $7658ab69ad25d4be$var$_queries).get(query.queryHash);
        if (queryInMap) {
            query.destroy();
            if (queryInMap === query) (0, $a0cb2f29b373067e$export$18a094aefa070634)(this, $7658ab69ad25d4be$var$_queries).delete(query.queryHash);
            this.notify({
                type: "removed",
                query: query
            });
        }
    }
    clear() {
        (0, $a37b31dc4086690f$export$520687f44db6e1ab).batch(()=>{
            this.getAll().forEach((query)=>{
                this.remove(query);
            });
        });
    }
    get(queryHash) {
        return (0, $a0cb2f29b373067e$export$18a094aefa070634)(this, $7658ab69ad25d4be$var$_queries).get(queryHash);
    }
    getAll() {
        return [
            ...(0, $a0cb2f29b373067e$export$18a094aefa070634)(this, $7658ab69ad25d4be$var$_queries).values()
        ];
    }
    find(filters) {
        const defaultedFilters = {
            exact: true,
            ...filters
        };
        return this.getAll().find((query)=>(0, $e9d6dc959f196f70$export$c5d1efe363797780)(defaultedFilters, query));
    }
    findAll(filters = {}) {
        const queries = this.getAll();
        return Object.keys(filters).length > 0 ? queries.filter((query)=>(0, $e9d6dc959f196f70$export$c5d1efe363797780)(filters, query)) : queries;
    }
    notify(event) {
        (0, $a37b31dc4086690f$export$520687f44db6e1ab).batch(()=>{
            this.listeners.forEach((listener)=>{
                listener(event);
            });
        });
    }
    onFocus() {
        (0, $a37b31dc4086690f$export$520687f44db6e1ab).batch(()=>{
            this.getAll().forEach((query)=>{
                query.onFocus();
            });
        });
    }
    onOnline() {
        (0, $a37b31dc4086690f$export$520687f44db6e1ab).batch(()=>{
            this.getAll().forEach((query)=>{
                query.onOnline();
            });
        });
    }
};
$7658ab69ad25d4be$var$_queries = new WeakMap();










var $969142c0f0e104ca$var$_client, $969142c0f0e104ca$var$_observers, $969142c0f0e104ca$var$_mutationCache, $969142c0f0e104ca$var$_retryer, $969142c0f0e104ca$var$_Mutation_instances, $969142c0f0e104ca$var$dispatch_fn;
var $969142c0f0e104ca$export$17b8b19c814bcf56 = class extends (0, $b5f33a596cb9c395$export$e09608847fcc8c59) {
    constructor(config){
        super();
        (0, $a0cb2f29b373067e$export$addf369becd23283)(this, $969142c0f0e104ca$var$_Mutation_instances);
        (0, $a0cb2f29b373067e$export$addf369becd23283)(this, $969142c0f0e104ca$var$_client);
        (0, $a0cb2f29b373067e$export$addf369becd23283)(this, $969142c0f0e104ca$var$_observers);
        (0, $a0cb2f29b373067e$export$addf369becd23283)(this, $969142c0f0e104ca$var$_mutationCache);
        (0, $a0cb2f29b373067e$export$addf369becd23283)(this, $969142c0f0e104ca$var$_retryer);
        (0, $a0cb2f29b373067e$export$42432efe6614d3b4)(this, $969142c0f0e104ca$var$_client, config.client);
        this.mutationId = config.mutationId;
        (0, $a0cb2f29b373067e$export$42432efe6614d3b4)(this, $969142c0f0e104ca$var$_mutationCache, config.mutationCache);
        (0, $a0cb2f29b373067e$export$42432efe6614d3b4)(this, $969142c0f0e104ca$var$_observers, []);
        this.state = config.state || $969142c0f0e104ca$export$a1659b54bac3252a();
        this.setOptions(config.options);
        this.scheduleGc();
    }
    setOptions(options) {
        this.options = options;
        this.updateGcTime(this.options.gcTime);
    }
    get meta() {
        return this.options.meta;
    }
    addObserver(observer) {
        if (!(0, $a0cb2f29b373067e$export$18a094aefa070634)(this, $969142c0f0e104ca$var$_observers).includes(observer)) {
            (0, $a0cb2f29b373067e$export$18a094aefa070634)(this, $969142c0f0e104ca$var$_observers).push(observer);
            this.clearGcTimeout();
            (0, $a0cb2f29b373067e$export$18a094aefa070634)(this, $969142c0f0e104ca$var$_mutationCache).notify({
                type: "observerAdded",
                mutation: this,
                observer: observer
            });
        }
    }
    removeObserver(observer) {
        (0, $a0cb2f29b373067e$export$42432efe6614d3b4)(this, $969142c0f0e104ca$var$_observers, (0, $a0cb2f29b373067e$export$18a094aefa070634)(this, $969142c0f0e104ca$var$_observers).filter((x)=>x !== observer));
        this.scheduleGc();
        (0, $a0cb2f29b373067e$export$18a094aefa070634)(this, $969142c0f0e104ca$var$_mutationCache).notify({
            type: "observerRemoved",
            mutation: this,
            observer: observer
        });
    }
    optionalRemove() {
        if (!(0, $a0cb2f29b373067e$export$18a094aefa070634)(this, $969142c0f0e104ca$var$_observers).length) {
            if (this.state.status === "pending") this.scheduleGc();
            else (0, $a0cb2f29b373067e$export$18a094aefa070634)(this, $969142c0f0e104ca$var$_mutationCache).remove(this);
        }
    }
    continue() {
        var _a;
        return ((_a = (0, $a0cb2f29b373067e$export$18a094aefa070634)(this, $969142c0f0e104ca$var$_retryer)) == null ? void 0 : _a.continue()) ?? // continuing a mutation assumes that variables are set, mutation must have been dehydrated before
        this.execute(this.state.variables);
    }
    async execute(variables) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l, _m, _n, _o, _p, _q, _r, _s, _t;
        const onContinue = ()=>{
            (0, $a0cb2f29b373067e$export$fa92d15b718fce20)(this, $969142c0f0e104ca$var$_Mutation_instances, $969142c0f0e104ca$var$dispatch_fn).call(this, {
                type: "continue"
            });
        };
        const mutationFnContext = {
            client: (0, $a0cb2f29b373067e$export$18a094aefa070634)(this, $969142c0f0e104ca$var$_client),
            meta: this.options.meta,
            mutationKey: this.options.mutationKey
        };
        (0, $a0cb2f29b373067e$export$42432efe6614d3b4)(this, $969142c0f0e104ca$var$_retryer, (0, $c0d8ccc060892ed3$export$2cbd00fe8a2c8d85)({
            fn: ()=>{
                if (!this.options.mutationFn) return Promise.reject(new Error("No mutationFn found"));
                return this.options.mutationFn(variables, mutationFnContext);
            },
            onFail: (failureCount, error)=>{
                (0, $a0cb2f29b373067e$export$fa92d15b718fce20)(this, $969142c0f0e104ca$var$_Mutation_instances, $969142c0f0e104ca$var$dispatch_fn).call(this, {
                    type: "failed",
                    failureCount: failureCount,
                    error: error
                });
            },
            onPause: ()=>{
                (0, $a0cb2f29b373067e$export$fa92d15b718fce20)(this, $969142c0f0e104ca$var$_Mutation_instances, $969142c0f0e104ca$var$dispatch_fn).call(this, {
                    type: "pause"
                });
            },
            onContinue: onContinue,
            retry: this.options.retry ?? 0,
            retryDelay: this.options.retryDelay,
            networkMode: this.options.networkMode,
            canRun: ()=>(0, $a0cb2f29b373067e$export$18a094aefa070634)(this, $969142c0f0e104ca$var$_mutationCache).canRun(this)
        }));
        const restored = this.state.status === "pending";
        const isPaused = !(0, $a0cb2f29b373067e$export$18a094aefa070634)(this, $969142c0f0e104ca$var$_retryer).canStart();
        try {
            if (restored) onContinue();
            else {
                (0, $a0cb2f29b373067e$export$fa92d15b718fce20)(this, $969142c0f0e104ca$var$_Mutation_instances, $969142c0f0e104ca$var$dispatch_fn).call(this, {
                    type: "pending",
                    variables: variables,
                    isPaused: isPaused
                });
                await ((_b = (_a = (0, $a0cb2f29b373067e$export$18a094aefa070634)(this, $969142c0f0e104ca$var$_mutationCache).config).onMutate) == null ? void 0 : _b.call(_a, variables, this, mutationFnContext));
                const context = await ((_d = (_c = this.options).onMutate) == null ? void 0 : _d.call(_c, variables, mutationFnContext));
                if (context !== this.state.context) (0, $a0cb2f29b373067e$export$fa92d15b718fce20)(this, $969142c0f0e104ca$var$_Mutation_instances, $969142c0f0e104ca$var$dispatch_fn).call(this, {
                    type: "pending",
                    context: context,
                    variables: variables,
                    isPaused: isPaused
                });
            }
            const data = await (0, $a0cb2f29b373067e$export$18a094aefa070634)(this, $969142c0f0e104ca$var$_retryer).start();
            await ((_f = (_e = (0, $a0cb2f29b373067e$export$18a094aefa070634)(this, $969142c0f0e104ca$var$_mutationCache).config).onSuccess) == null ? void 0 : _f.call(_e, data, variables, this.state.context, this, mutationFnContext));
            await ((_h = (_g = this.options).onSuccess) == null ? void 0 : _h.call(_g, data, variables, this.state.context, mutationFnContext));
            await ((_j = (_i = (0, $a0cb2f29b373067e$export$18a094aefa070634)(this, $969142c0f0e104ca$var$_mutationCache).config).onSettled) == null ? void 0 : _j.call(_i, data, null, this.state.variables, this.state.context, this, mutationFnContext));
            await ((_l = (_k = this.options).onSettled) == null ? void 0 : _l.call(_k, data, null, variables, this.state.context, mutationFnContext));
            (0, $a0cb2f29b373067e$export$fa92d15b718fce20)(this, $969142c0f0e104ca$var$_Mutation_instances, $969142c0f0e104ca$var$dispatch_fn).call(this, {
                type: "success",
                data: data
            });
            return data;
        } catch (error) {
            try {
                await ((_n = (_m = (0, $a0cb2f29b373067e$export$18a094aefa070634)(this, $969142c0f0e104ca$var$_mutationCache).config).onError) == null ? void 0 : _n.call(_m, error, variables, this.state.context, this, mutationFnContext));
                await ((_p = (_o = this.options).onError) == null ? void 0 : _p.call(_o, error, variables, this.state.context, mutationFnContext));
                await ((_r = (_q = (0, $a0cb2f29b373067e$export$18a094aefa070634)(this, $969142c0f0e104ca$var$_mutationCache).config).onSettled) == null ? void 0 : _r.call(_q, void 0, error, this.state.variables, this.state.context, this, mutationFnContext));
                await ((_t = (_s = this.options).onSettled) == null ? void 0 : _t.call(_s, void 0, error, variables, this.state.context, mutationFnContext));
                throw error;
            } finally{
                (0, $a0cb2f29b373067e$export$fa92d15b718fce20)(this, $969142c0f0e104ca$var$_Mutation_instances, $969142c0f0e104ca$var$dispatch_fn).call(this, {
                    type: "error",
                    error: error
                });
            }
        } finally{
            (0, $a0cb2f29b373067e$export$18a094aefa070634)(this, $969142c0f0e104ca$var$_mutationCache).runNext(this);
        }
    }
};
$969142c0f0e104ca$var$_client = new WeakMap();
$969142c0f0e104ca$var$_observers = new WeakMap();
$969142c0f0e104ca$var$_mutationCache = new WeakMap();
$969142c0f0e104ca$var$_retryer = new WeakMap();
$969142c0f0e104ca$var$_Mutation_instances = new WeakSet();
$969142c0f0e104ca$var$dispatch_fn = function(action) {
    const reducer = (state)=>{
        switch(action.type){
            case "failed":
                return {
                    ...state,
                    failureCount: action.failureCount,
                    failureReason: action.error
                };
            case "pause":
                return {
                    ...state,
                    isPaused: true
                };
            case "continue":
                return {
                    ...state,
                    isPaused: false
                };
            case "pending":
                return {
                    ...state,
                    context: action.context,
                    data: void 0,
                    failureCount: 0,
                    failureReason: null,
                    error: null,
                    isPaused: action.isPaused,
                    status: "pending",
                    variables: action.variables,
                    submittedAt: Date.now()
                };
            case "success":
                return {
                    ...state,
                    data: action.data,
                    failureCount: 0,
                    failureReason: null,
                    error: null,
                    status: "success",
                    isPaused: false
                };
            case "error":
                return {
                    ...state,
                    data: void 0,
                    error: action.error,
                    failureCount: state.failureCount + 1,
                    failureReason: action.error,
                    isPaused: false,
                    status: "error"
                };
        }
    };
    this.state = reducer(this.state);
    (0, $a37b31dc4086690f$export$520687f44db6e1ab).batch(()=>{
        (0, $a0cb2f29b373067e$export$18a094aefa070634)(this, $969142c0f0e104ca$var$_observers).forEach((observer)=>{
            observer.onMutationUpdate(action);
        });
        (0, $a0cb2f29b373067e$export$18a094aefa070634)(this, $969142c0f0e104ca$var$_mutationCache).notify({
            mutation: this,
            type: "updated",
            action: action
        });
    });
};
function $969142c0f0e104ca$export$a1659b54bac3252a() {
    return {
        context: void 0,
        data: void 0,
        error: null,
        failureCount: 0,
        failureReason: null,
        isPaused: false,
        status: "idle",
        variables: void 0,
        submittedAt: 0
    };
}




var $6b281d51985145ae$var$_mutations, $6b281d51985145ae$var$_scopes, $6b281d51985145ae$var$_mutationId;
var $6b281d51985145ae$export$1fcfd9a244434844 = class extends (0, $78d76f0c1d823036$export$d26086b469ecdbcc) {
    constructor(config = {}){
        super();
        this.config = config;
        (0, $a0cb2f29b373067e$export$addf369becd23283)(this, $6b281d51985145ae$var$_mutations);
        (0, $a0cb2f29b373067e$export$addf369becd23283)(this, $6b281d51985145ae$var$_scopes);
        (0, $a0cb2f29b373067e$export$addf369becd23283)(this, $6b281d51985145ae$var$_mutationId);
        (0, $a0cb2f29b373067e$export$42432efe6614d3b4)(this, $6b281d51985145ae$var$_mutations, /* @__PURE__ */ new Set());
        (0, $a0cb2f29b373067e$export$42432efe6614d3b4)(this, $6b281d51985145ae$var$_scopes, /* @__PURE__ */ new Map());
        (0, $a0cb2f29b373067e$export$42432efe6614d3b4)(this, $6b281d51985145ae$var$_mutationId, 0);
    }
    build(client, options, state) {
        const mutation = new (0, $969142c0f0e104ca$export$17b8b19c814bcf56)({
            client: client,
            mutationCache: this,
            mutationId: ++(0, $a0cb2f29b373067e$export$b1fe7cbb4502036b)(this, $6b281d51985145ae$var$_mutationId)._,
            options: client.defaultMutationOptions(options),
            state: state
        });
        this.add(mutation);
        return mutation;
    }
    add(mutation) {
        (0, $a0cb2f29b373067e$export$18a094aefa070634)(this, $6b281d51985145ae$var$_mutations).add(mutation);
        const scope = $6b281d51985145ae$var$scopeFor(mutation);
        if (typeof scope === "string") {
            const scopedMutations = (0, $a0cb2f29b373067e$export$18a094aefa070634)(this, $6b281d51985145ae$var$_scopes).get(scope);
            if (scopedMutations) scopedMutations.push(mutation);
            else (0, $a0cb2f29b373067e$export$18a094aefa070634)(this, $6b281d51985145ae$var$_scopes).set(scope, [
                mutation
            ]);
        }
        this.notify({
            type: "added",
            mutation: mutation
        });
    }
    remove(mutation) {
        if ((0, $a0cb2f29b373067e$export$18a094aefa070634)(this, $6b281d51985145ae$var$_mutations).delete(mutation)) {
            const scope = $6b281d51985145ae$var$scopeFor(mutation);
            if (typeof scope === "string") {
                const scopedMutations = (0, $a0cb2f29b373067e$export$18a094aefa070634)(this, $6b281d51985145ae$var$_scopes).get(scope);
                if (scopedMutations) {
                    if (scopedMutations.length > 1) {
                        const index = scopedMutations.indexOf(mutation);
                        if (index !== -1) scopedMutations.splice(index, 1);
                    } else if (scopedMutations[0] === mutation) (0, $a0cb2f29b373067e$export$18a094aefa070634)(this, $6b281d51985145ae$var$_scopes).delete(scope);
                }
            }
        }
        this.notify({
            type: "removed",
            mutation: mutation
        });
    }
    canRun(mutation) {
        const scope = $6b281d51985145ae$var$scopeFor(mutation);
        if (typeof scope === "string") {
            const mutationsWithSameScope = (0, $a0cb2f29b373067e$export$18a094aefa070634)(this, $6b281d51985145ae$var$_scopes).get(scope);
            const firstPendingMutation = mutationsWithSameScope == null ? void 0 : mutationsWithSameScope.find((m)=>m.state.status === "pending");
            return !firstPendingMutation || firstPendingMutation === mutation;
        } else return true;
    }
    runNext(mutation) {
        var _a;
        const scope = $6b281d51985145ae$var$scopeFor(mutation);
        if (typeof scope === "string") {
            const foundMutation = (_a = (0, $a0cb2f29b373067e$export$18a094aefa070634)(this, $6b281d51985145ae$var$_scopes).get(scope)) == null ? void 0 : _a.find((m)=>m !== mutation && m.state.isPaused);
            return (foundMutation == null ? void 0 : foundMutation.continue()) ?? Promise.resolve();
        } else return Promise.resolve();
    }
    clear() {
        (0, $a37b31dc4086690f$export$520687f44db6e1ab).batch(()=>{
            (0, $a0cb2f29b373067e$export$18a094aefa070634)(this, $6b281d51985145ae$var$_mutations).forEach((mutation)=>{
                this.notify({
                    type: "removed",
                    mutation: mutation
                });
            });
            (0, $a0cb2f29b373067e$export$18a094aefa070634)(this, $6b281d51985145ae$var$_mutations).clear();
            (0, $a0cb2f29b373067e$export$18a094aefa070634)(this, $6b281d51985145ae$var$_scopes).clear();
        });
    }
    getAll() {
        return Array.from((0, $a0cb2f29b373067e$export$18a094aefa070634)(this, $6b281d51985145ae$var$_mutations));
    }
    find(filters) {
        const defaultedFilters = {
            exact: true,
            ...filters
        };
        return this.getAll().find((mutation)=>(0, $e9d6dc959f196f70$export$a1ea5fb559f63ae3)(defaultedFilters, mutation));
    }
    findAll(filters = {}) {
        return this.getAll().filter((mutation)=>(0, $e9d6dc959f196f70$export$a1ea5fb559f63ae3)(filters, mutation));
    }
    notify(event) {
        (0, $a37b31dc4086690f$export$520687f44db6e1ab).batch(()=>{
            this.listeners.forEach((listener)=>{
                listener(event);
            });
        });
    }
    resumePausedMutations() {
        const pausedMutations = this.getAll().filter((x)=>x.state.isPaused);
        return (0, $a37b31dc4086690f$export$520687f44db6e1ab).batch(()=>Promise.all(pausedMutations.map((mutation)=>mutation.continue().catch((0, $e9d6dc959f196f70$export$8793edee2d425525)))));
    }
};
$6b281d51985145ae$var$_mutations = new WeakMap();
$6b281d51985145ae$var$_scopes = new WeakMap();
$6b281d51985145ae$var$_mutationId = new WeakMap();
function $6b281d51985145ae$var$scopeFor(mutation) {
    var _a;
    return (_a = mutation.options.scope) == null ? void 0 : _a.id;
}







function $0297628cdc6ea7c0$export$84470d1367601e8d(pages) {
    return {
        onFetch: (context, query)=>{
            var _a, _b, _c, _d, _e;
            const options = context.options;
            const direction = (_c = (_b = (_a = context.fetchOptions) == null ? void 0 : _a.meta) == null ? void 0 : _b.fetchMore) == null ? void 0 : _c.direction;
            const oldPages = ((_d = context.state.data) == null ? void 0 : _d.pages) || [];
            const oldPageParams = ((_e = context.state.data) == null ? void 0 : _e.pageParams) || [];
            let result = {
                pages: [],
                pageParams: []
            };
            let currentPage = 0;
            const fetchFn = async ()=>{
                let cancelled = false;
                const addSignalProperty = (object)=>{
                    Object.defineProperty(object, "signal", {
                        enumerable: true,
                        get: ()=>{
                            if (context.signal.aborted) cancelled = true;
                            else context.signal.addEventListener("abort", ()=>{
                                cancelled = true;
                            });
                            return context.signal;
                        }
                    });
                };
                const queryFn = (0, $e9d6dc959f196f70$export$c71c44209368a3bc)(context.options, context.fetchOptions);
                const fetchPage = async (data, param, previous)=>{
                    if (cancelled) return Promise.reject();
                    if (param == null && data.pages.length) return Promise.resolve(data);
                    const createQueryFnContext = ()=>{
                        const queryFnContext2 = {
                            client: context.client,
                            queryKey: context.queryKey,
                            pageParam: param,
                            direction: previous ? "backward" : "forward",
                            meta: context.options.meta
                        };
                        addSignalProperty(queryFnContext2);
                        return queryFnContext2;
                    };
                    const queryFnContext = createQueryFnContext();
                    const page = await queryFn(queryFnContext);
                    const { maxPages: maxPages } = context.options;
                    const addTo = previous ? (0, $e9d6dc959f196f70$export$8c6246b73dd61f4a) : (0, $e9d6dc959f196f70$export$ccce65a22a26f2bc);
                    return {
                        pages: addTo(data.pages, page, maxPages),
                        pageParams: addTo(data.pageParams, param, maxPages)
                    };
                };
                if (direction && oldPages.length) {
                    const previous = direction === "backward";
                    const pageParamFn = previous ? $0297628cdc6ea7c0$var$getPreviousPageParam : $0297628cdc6ea7c0$var$getNextPageParam;
                    const oldData = {
                        pages: oldPages,
                        pageParams: oldPageParams
                    };
                    const param = pageParamFn(options, oldData);
                    result = await fetchPage(oldData, param, previous);
                } else {
                    const remainingPages = pages ?? oldPages.length;
                    do {
                        const param = currentPage === 0 ? oldPageParams[0] ?? options.initialPageParam : $0297628cdc6ea7c0$var$getNextPageParam(options, result);
                        if (currentPage > 0 && param == null) break;
                        result = await fetchPage(result, param);
                        currentPage++;
                    }while (currentPage < remainingPages);
                }
                return result;
            };
            if (context.options.persister) context.fetchFn = ()=>{
                var _a2, _b2;
                return (_b2 = (_a2 = context.options).persister) == null ? void 0 : _b2.call(_a2, fetchFn, {
                    client: context.client,
                    queryKey: context.queryKey,
                    meta: context.options.meta,
                    signal: context.signal
                }, query);
            };
            else context.fetchFn = fetchFn;
        }
    };
}
function $0297628cdc6ea7c0$var$getNextPageParam(options, { pages: pages, pageParams: pageParams }) {
    const lastIndex = pages.length - 1;
    return pages.length > 0 ? options.getNextPageParam(pages[lastIndex], pages, pageParams[lastIndex], pageParams) : void 0;
}
function $0297628cdc6ea7c0$var$getPreviousPageParam(options, { pages: pages, pageParams: pageParams }) {
    var _a;
    return pages.length > 0 ? (_a = options.getPreviousPageParam) == null ? void 0 : _a.call(options, pages[0], pages, pageParams[0], pageParams) : void 0;
}
function $0297628cdc6ea7c0$export$b9c88add8b8b5e6a(options, data) {
    if (!data) return false;
    return $0297628cdc6ea7c0$var$getNextPageParam(options, data) != null;
}
function $0297628cdc6ea7c0$export$db1663b730a8e6e4(options, data) {
    if (!data || !options.getPreviousPageParam) return false;
    return $0297628cdc6ea7c0$var$getPreviousPageParam(options, data) != null;
}


var $c0446aa2125f8e36$var$_queryCache, $c0446aa2125f8e36$var$_mutationCache, $c0446aa2125f8e36$var$_defaultOptions, $c0446aa2125f8e36$var$_queryDefaults, $c0446aa2125f8e36$var$_mutationDefaults, $c0446aa2125f8e36$var$_mountCount, $c0446aa2125f8e36$var$_unsubscribeFocus, $c0446aa2125f8e36$var$_unsubscribeOnline;
var $c0446aa2125f8e36$export$405d0624ed55a03f = class {
    constructor(config = {}){
        (0, $a0cb2f29b373067e$export$addf369becd23283)(this, $c0446aa2125f8e36$var$_queryCache);
        (0, $a0cb2f29b373067e$export$addf369becd23283)(this, $c0446aa2125f8e36$var$_mutationCache);
        (0, $a0cb2f29b373067e$export$addf369becd23283)(this, $c0446aa2125f8e36$var$_defaultOptions);
        (0, $a0cb2f29b373067e$export$addf369becd23283)(this, $c0446aa2125f8e36$var$_queryDefaults);
        (0, $a0cb2f29b373067e$export$addf369becd23283)(this, $c0446aa2125f8e36$var$_mutationDefaults);
        (0, $a0cb2f29b373067e$export$addf369becd23283)(this, $c0446aa2125f8e36$var$_mountCount);
        (0, $a0cb2f29b373067e$export$addf369becd23283)(this, $c0446aa2125f8e36$var$_unsubscribeFocus);
        (0, $a0cb2f29b373067e$export$addf369becd23283)(this, $c0446aa2125f8e36$var$_unsubscribeOnline);
        (0, $a0cb2f29b373067e$export$42432efe6614d3b4)(this, $c0446aa2125f8e36$var$_queryCache, config.queryCache || new (0, $7658ab69ad25d4be$export$5dde0cd941da8468)());
        (0, $a0cb2f29b373067e$export$42432efe6614d3b4)(this, $c0446aa2125f8e36$var$_mutationCache, config.mutationCache || new (0, $6b281d51985145ae$export$1fcfd9a244434844)());
        (0, $a0cb2f29b373067e$export$42432efe6614d3b4)(this, $c0446aa2125f8e36$var$_defaultOptions, config.defaultOptions || {});
        (0, $a0cb2f29b373067e$export$42432efe6614d3b4)(this, $c0446aa2125f8e36$var$_queryDefaults, /* @__PURE__ */ new Map());
        (0, $a0cb2f29b373067e$export$42432efe6614d3b4)(this, $c0446aa2125f8e36$var$_mutationDefaults, /* @__PURE__ */ new Map());
        (0, $a0cb2f29b373067e$export$42432efe6614d3b4)(this, $c0446aa2125f8e36$var$_mountCount, 0);
    }
    mount() {
        (0, $a0cb2f29b373067e$export$b1fe7cbb4502036b)(this, $c0446aa2125f8e36$var$_mountCount)._++;
        if ((0, $a0cb2f29b373067e$export$18a094aefa070634)(this, $c0446aa2125f8e36$var$_mountCount) !== 1) return;
        (0, $a0cb2f29b373067e$export$42432efe6614d3b4)(this, $c0446aa2125f8e36$var$_unsubscribeFocus, (0, $780e8903dcf2df97$export$6bf54661be5b02cf).subscribe(async (focused)=>{
            if (focused) {
                await this.resumePausedMutations();
                (0, $a0cb2f29b373067e$export$18a094aefa070634)(this, $c0446aa2125f8e36$var$_queryCache).onFocus();
            }
        }));
        (0, $a0cb2f29b373067e$export$42432efe6614d3b4)(this, $c0446aa2125f8e36$var$_unsubscribeOnline, (0, $3b7c5eeebfe845db$export$b113e788b2dd3fdc).subscribe(async (online)=>{
            if (online) {
                await this.resumePausedMutations();
                (0, $a0cb2f29b373067e$export$18a094aefa070634)(this, $c0446aa2125f8e36$var$_queryCache).onOnline();
            }
        }));
    }
    unmount() {
        var _a, _b;
        (0, $a0cb2f29b373067e$export$b1fe7cbb4502036b)(this, $c0446aa2125f8e36$var$_mountCount)._--;
        if ((0, $a0cb2f29b373067e$export$18a094aefa070634)(this, $c0446aa2125f8e36$var$_mountCount) !== 0) return;
        (_a = (0, $a0cb2f29b373067e$export$18a094aefa070634)(this, $c0446aa2125f8e36$var$_unsubscribeFocus)) == null || _a.call(this);
        (0, $a0cb2f29b373067e$export$42432efe6614d3b4)(this, $c0446aa2125f8e36$var$_unsubscribeFocus, void 0);
        (_b = (0, $a0cb2f29b373067e$export$18a094aefa070634)(this, $c0446aa2125f8e36$var$_unsubscribeOnline)) == null || _b.call(this);
        (0, $a0cb2f29b373067e$export$42432efe6614d3b4)(this, $c0446aa2125f8e36$var$_unsubscribeOnline, void 0);
    }
    isFetching(filters) {
        return (0, $a0cb2f29b373067e$export$18a094aefa070634)(this, $c0446aa2125f8e36$var$_queryCache).findAll({
            ...filters,
            fetchStatus: "fetching"
        }).length;
    }
    isMutating(filters) {
        return (0, $a0cb2f29b373067e$export$18a094aefa070634)(this, $c0446aa2125f8e36$var$_mutationCache).findAll({
            ...filters,
            status: "pending"
        }).length;
    }
    /**
   * Imperative (non-reactive) way to retrieve data for a QueryKey.
   * Should only be used in callbacks or functions where reading the latest data is necessary, e.g. for optimistic updates.
   *
   * Hint: Do not use this function inside a component, because it won't receive updates.
   * Use `useQuery` to create a `QueryObserver` that subscribes to changes.
   */ getQueryData(queryKey) {
        var _a;
        const options = this.defaultQueryOptions({
            queryKey: queryKey
        });
        return (_a = (0, $a0cb2f29b373067e$export$18a094aefa070634)(this, $c0446aa2125f8e36$var$_queryCache).get(options.queryHash)) == null ? void 0 : _a.state.data;
    }
    ensureQueryData(options) {
        const defaultedOptions = this.defaultQueryOptions(options);
        const query = (0, $a0cb2f29b373067e$export$18a094aefa070634)(this, $c0446aa2125f8e36$var$_queryCache).build(this, defaultedOptions);
        const cachedData = query.state.data;
        if (cachedData === void 0) return this.fetchQuery(options);
        if (options.revalidateIfStale && query.isStaleByTime((0, $e9d6dc959f196f70$export$cb3145f011bda3ac)(defaultedOptions.staleTime, query))) this.prefetchQuery(defaultedOptions);
        return Promise.resolve(cachedData);
    }
    getQueriesData(filters) {
        return (0, $a0cb2f29b373067e$export$18a094aefa070634)(this, $c0446aa2125f8e36$var$_queryCache).findAll(filters).map(({ queryKey: queryKey, state: state })=>{
            const data = state.data;
            return [
                queryKey,
                data
            ];
        });
    }
    setQueryData(queryKey, updater, options) {
        const defaultedOptions = this.defaultQueryOptions({
            queryKey: queryKey
        });
        const query = (0, $a0cb2f29b373067e$export$18a094aefa070634)(this, $c0446aa2125f8e36$var$_queryCache).get(defaultedOptions.queryHash);
        const prevData = query == null ? void 0 : query.state.data;
        const data = (0, $e9d6dc959f196f70$export$7f095f455ad5af3f)(updater, prevData);
        if (data === void 0) return void 0;
        return (0, $a0cb2f29b373067e$export$18a094aefa070634)(this, $c0446aa2125f8e36$var$_queryCache).build(this, defaultedOptions).setData(data, {
            ...options,
            manual: true
        });
    }
    setQueriesData(filters, updater, options) {
        return (0, $a37b31dc4086690f$export$520687f44db6e1ab).batch(()=>(0, $a0cb2f29b373067e$export$18a094aefa070634)(this, $c0446aa2125f8e36$var$_queryCache).findAll(filters).map(({ queryKey: queryKey })=>[
                    queryKey,
                    this.setQueryData(queryKey, updater, options)
                ]));
    }
    getQueryState(queryKey) {
        var _a;
        const options = this.defaultQueryOptions({
            queryKey: queryKey
        });
        return (_a = (0, $a0cb2f29b373067e$export$18a094aefa070634)(this, $c0446aa2125f8e36$var$_queryCache).get(options.queryHash)) == null ? void 0 : _a.state;
    }
    removeQueries(filters) {
        const queryCache = (0, $a0cb2f29b373067e$export$18a094aefa070634)(this, $c0446aa2125f8e36$var$_queryCache);
        (0, $a37b31dc4086690f$export$520687f44db6e1ab).batch(()=>{
            queryCache.findAll(filters).forEach((query)=>{
                queryCache.remove(query);
            });
        });
    }
    resetQueries(filters, options) {
        const queryCache = (0, $a0cb2f29b373067e$export$18a094aefa070634)(this, $c0446aa2125f8e36$var$_queryCache);
        return (0, $a37b31dc4086690f$export$520687f44db6e1ab).batch(()=>{
            queryCache.findAll(filters).forEach((query)=>{
                query.reset();
            });
            return this.refetchQueries({
                type: "active",
                ...filters
            }, options);
        });
    }
    cancelQueries(filters, cancelOptions = {}) {
        const defaultedCancelOptions = {
            revert: true,
            ...cancelOptions
        };
        const promises = (0, $a37b31dc4086690f$export$520687f44db6e1ab).batch(()=>(0, $a0cb2f29b373067e$export$18a094aefa070634)(this, $c0446aa2125f8e36$var$_queryCache).findAll(filters).map((query)=>query.cancel(defaultedCancelOptions)));
        return Promise.all(promises).then((0, $e9d6dc959f196f70$export$8793edee2d425525)).catch((0, $e9d6dc959f196f70$export$8793edee2d425525));
    }
    invalidateQueries(filters, options = {}) {
        return (0, $a37b31dc4086690f$export$520687f44db6e1ab).batch(()=>{
            (0, $a0cb2f29b373067e$export$18a094aefa070634)(this, $c0446aa2125f8e36$var$_queryCache).findAll(filters).forEach((query)=>{
                query.invalidate();
            });
            if ((filters == null ? void 0 : filters.refetchType) === "none") return Promise.resolve();
            return this.refetchQueries({
                ...filters,
                type: (filters == null ? void 0 : filters.refetchType) ?? (filters == null ? void 0 : filters.type) ?? "active"
            }, options);
        });
    }
    refetchQueries(filters, options = {}) {
        const fetchOptions = {
            ...options,
            cancelRefetch: options.cancelRefetch ?? true
        };
        const promises = (0, $a37b31dc4086690f$export$520687f44db6e1ab).batch(()=>(0, $a0cb2f29b373067e$export$18a094aefa070634)(this, $c0446aa2125f8e36$var$_queryCache).findAll(filters).filter((query)=>!query.isDisabled() && !query.isStatic()).map((query)=>{
                let promise = query.fetch(void 0, fetchOptions);
                if (!fetchOptions.throwOnError) promise = promise.catch((0, $e9d6dc959f196f70$export$8793edee2d425525));
                return query.state.fetchStatus === "paused" ? Promise.resolve() : promise;
            }));
        return Promise.all(promises).then((0, $e9d6dc959f196f70$export$8793edee2d425525));
    }
    fetchQuery(options) {
        const defaultedOptions = this.defaultQueryOptions(options);
        if (defaultedOptions.retry === void 0) defaultedOptions.retry = false;
        const query = (0, $a0cb2f29b373067e$export$18a094aefa070634)(this, $c0446aa2125f8e36$var$_queryCache).build(this, defaultedOptions);
        return query.isStaleByTime((0, $e9d6dc959f196f70$export$cb3145f011bda3ac)(defaultedOptions.staleTime, query)) ? query.fetch(defaultedOptions) : Promise.resolve(query.state.data);
    }
    prefetchQuery(options) {
        return this.fetchQuery(options).then((0, $e9d6dc959f196f70$export$8793edee2d425525)).catch((0, $e9d6dc959f196f70$export$8793edee2d425525));
    }
    fetchInfiniteQuery(options) {
        options.behavior = (0, $0297628cdc6ea7c0$export$84470d1367601e8d)(options.pages);
        return this.fetchQuery(options);
    }
    prefetchInfiniteQuery(options) {
        return this.fetchInfiniteQuery(options).then((0, $e9d6dc959f196f70$export$8793edee2d425525)).catch((0, $e9d6dc959f196f70$export$8793edee2d425525));
    }
    ensureInfiniteQueryData(options) {
        options.behavior = (0, $0297628cdc6ea7c0$export$84470d1367601e8d)(options.pages);
        return this.ensureQueryData(options);
    }
    resumePausedMutations() {
        if ((0, $3b7c5eeebfe845db$export$b113e788b2dd3fdc).isOnline()) return (0, $a0cb2f29b373067e$export$18a094aefa070634)(this, $c0446aa2125f8e36$var$_mutationCache).resumePausedMutations();
        return Promise.resolve();
    }
    getQueryCache() {
        return (0, $a0cb2f29b373067e$export$18a094aefa070634)(this, $c0446aa2125f8e36$var$_queryCache);
    }
    getMutationCache() {
        return (0, $a0cb2f29b373067e$export$18a094aefa070634)(this, $c0446aa2125f8e36$var$_mutationCache);
    }
    getDefaultOptions() {
        return (0, $a0cb2f29b373067e$export$18a094aefa070634)(this, $c0446aa2125f8e36$var$_defaultOptions);
    }
    setDefaultOptions(options) {
        (0, $a0cb2f29b373067e$export$42432efe6614d3b4)(this, $c0446aa2125f8e36$var$_defaultOptions, options);
    }
    setQueryDefaults(queryKey, options) {
        (0, $a0cb2f29b373067e$export$18a094aefa070634)(this, $c0446aa2125f8e36$var$_queryDefaults).set((0, $e9d6dc959f196f70$export$1e87d19d4aab5805)(queryKey), {
            queryKey: queryKey,
            defaultOptions: options
        });
    }
    getQueryDefaults(queryKey) {
        const defaults = [
            ...(0, $a0cb2f29b373067e$export$18a094aefa070634)(this, $c0446aa2125f8e36$var$_queryDefaults).values()
        ];
        const result = {};
        defaults.forEach((queryDefault)=>{
            if ((0, $e9d6dc959f196f70$export$2f07189bb9fa26a7)(queryKey, queryDefault.queryKey)) Object.assign(result, queryDefault.defaultOptions);
        });
        return result;
    }
    setMutationDefaults(mutationKey, options) {
        (0, $a0cb2f29b373067e$export$18a094aefa070634)(this, $c0446aa2125f8e36$var$_mutationDefaults).set((0, $e9d6dc959f196f70$export$1e87d19d4aab5805)(mutationKey), {
            mutationKey: mutationKey,
            defaultOptions: options
        });
    }
    getMutationDefaults(mutationKey) {
        const defaults = [
            ...(0, $a0cb2f29b373067e$export$18a094aefa070634)(this, $c0446aa2125f8e36$var$_mutationDefaults).values()
        ];
        const result = {};
        defaults.forEach((queryDefault)=>{
            if ((0, $e9d6dc959f196f70$export$2f07189bb9fa26a7)(mutationKey, queryDefault.mutationKey)) Object.assign(result, queryDefault.defaultOptions);
        });
        return result;
    }
    defaultQueryOptions(options) {
        if (options._defaulted) return options;
        const defaultedOptions = {
            ...(0, $a0cb2f29b373067e$export$18a094aefa070634)(this, $c0446aa2125f8e36$var$_defaultOptions).queries,
            ...this.getQueryDefaults(options.queryKey),
            ...options,
            _defaulted: true
        };
        if (!defaultedOptions.queryHash) defaultedOptions.queryHash = (0, $e9d6dc959f196f70$export$cc90ca97bc0d73fd)(defaultedOptions.queryKey, defaultedOptions);
        if (defaultedOptions.refetchOnReconnect === void 0) defaultedOptions.refetchOnReconnect = defaultedOptions.networkMode !== "always";
        if (defaultedOptions.throwOnError === void 0) defaultedOptions.throwOnError = !!defaultedOptions.suspense;
        if (!defaultedOptions.networkMode && defaultedOptions.persister) defaultedOptions.networkMode = "offlineFirst";
        if (defaultedOptions.queryFn === (0, $e9d6dc959f196f70$export$1aa5a89531b7670d)) defaultedOptions.enabled = false;
        return defaultedOptions;
    }
    defaultMutationOptions(options) {
        if (options == null ? void 0 : options._defaulted) return options;
        return {
            ...(0, $a0cb2f29b373067e$export$18a094aefa070634)(this, $c0446aa2125f8e36$var$_defaultOptions).mutations,
            ...(options == null ? void 0 : options.mutationKey) && this.getMutationDefaults(options.mutationKey),
            ...options,
            _defaulted: true
        };
    }
    clear() {
        (0, $a0cb2f29b373067e$export$18a094aefa070634)(this, $c0446aa2125f8e36$var$_queryCache).clear();
        (0, $a0cb2f29b373067e$export$18a094aefa070634)(this, $c0446aa2125f8e36$var$_mutationCache).clear();
    }
};
$c0446aa2125f8e36$var$_queryCache = new WeakMap();
$c0446aa2125f8e36$var$_mutationCache = new WeakMap();
$c0446aa2125f8e36$var$_defaultOptions = new WeakMap();
$c0446aa2125f8e36$var$_queryDefaults = new WeakMap();
$c0446aa2125f8e36$var$_mutationDefaults = new WeakMap();
$c0446aa2125f8e36$var$_mountCount = new WeakMap();
$c0446aa2125f8e36$var$_unsubscribeFocus = new WeakMap();
$c0446aa2125f8e36$var$_unsubscribeOnline = new WeakMap();


/**
 * Backend API Configuration
 *
 * Manages different backend environments for local development.
 * Use environment variable REACT_APP_BACKEND_ENV to switch between:
 * - 'mock': Uses .proxyrc.cjs with mock responses (default)
 * - 'local-docker': Proxies to local Docker container
 * - 'staging': Points to staging environment (future)
 */ const $ffafe62ab6b0f968$var$backendConfigs = {
    mock: {
        baseURL: '',
        timeout: 10000
    },
    'local-docker': {
        baseURL: '',
        timeout: 10000,
        withCredentials: false
    },
    staging: {
        baseURL: '',
        timeout: 10000,
        withCredentials: true
    }
};
function $ffafe62ab6b0f968$export$6cf71c61ed0e83bb() {
    const backendEnv = undefined;
    if (backendEnv && backendEnv in $ffafe62ab6b0f968$var$backendConfigs) return backendEnv;
    // Default to mock for local development
    return 'mock';
}
function $ffafe62ab6b0f968$export$2f4db9c29007a800() {
    const env = $ffafe62ab6b0f968$export$6cf71c61ed0e83bb();
    const config = $ffafe62ab6b0f968$var$backendConfigs[env];
    if (typeof window !== 'undefined') {
        console.log(`\u{1F527} Backend Environment: ${env}`);
        console.log(`\u{1F527} Backend URL: ${config.baseURL || 'Using local proxy'}`);
    }
    return config;
}



const $20b06ac8b5e61eaa$export$8a94cb4f54be52a3 = ()=>new (0, $c0446aa2125f8e36$export$405d0624ed55a03f)({
        defaultOptions: {
            queries: {
                refetchOnWindowFocus: false,
                refetchIntervalInBackground: false,
                retry: false,
                refetchOnMount: false,
                refetchOnReconnect: false
            }
        },
        queryCache: new (0, $7658ab69ad25d4be$export$5dde0cd941da8468)({
            onError: (error, query)=>{
                (0, $9654b596cdf679bc$export$2e2bcd8739ae039).error('Error when executing query', query.queryKey, error);
            }
        })
    });
const $20b06ac8b5e61eaa$export$7c07b633a151f9c5 = $20b06ac8b5e61eaa$export$8a94cb4f54be52a3();
const $20b06ac8b5e61eaa$export$644d8ea042df96a6 = (0, $782a7beaab0195f3$export$2e2bcd8739ae039).create((0, $ffafe62ab6b0f968$export$2f4db9c29007a800)());



var $5FkrB = parcelRequire("5FkrB");



var $5FkrB = parcelRequire("5FkrB");
const $f5e234f6c33e6e6b$var$UNAUTHENTICATED_STATUS_CODES = [
    401,
    402
];
const $f5e234f6c33e6e6b$export$d3dd4b610d39290a = async (api)=>{
    try {
        const response = await api.get('/gateway/api/me');
        return response.data;
    } catch (error) {
        const status = error?.response?.status;
        // Silently ignore 401/402 — user is simply not authenticated
        if (status !== undefined && $f5e234f6c33e6e6b$var$UNAUTHENTICATED_STATUS_CODES.includes(status)) return null;
        // Re-throw all other errors so callers can handle/log them
        throw error;
    }
};



const $f6c3dce408db50e2$var$UserContext = /*#__PURE__*/ (0, $5FkrB.createContext)(null);
const $f6c3dce408db50e2$export$88f24fd8fcfab6ca = ({ api: api, children: children })=>{
    const [user, setUser] = (0, $5FkrB.useState)(null);
    const [isSettled, setIsSettled] = (0, $5FkrB.useState)(false);
    (0, $5FkrB.useEffect)(()=>{
        (0, $f5e234f6c33e6e6b$export$d3dd4b610d39290a)(api).then((fetchedUser)=>{
            setUser(fetchedUser);
        }).catch((error)=>{
            // Non-401/402 errors are unexpected — log them to Sentry for visibility
            (0, $9654b596cdf679bc$export$2e2bcd8739ae039).error(error);
        }).finally(()=>{
            setIsSettled(true);
        });
    // Run once on mount — we only need to fetch the user once when the app loads.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const value = (0, $5FkrB.useMemo)(()=>({
            user: user,
            isSettled: isSettled
        }), [
        user,
        isSettled
    ]);
    return /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)($f6c3dce408db50e2$var$UserContext.Provider, {
        value: value,
        children: children
    });
};
const $f6c3dce408db50e2$export$87c54b525b914dab = ()=>{
    const ctx = (0, $5FkrB.useContext)($f6c3dce408db50e2$var$UserContext);
    if (!ctx) throw new Error('useUserContext must be used within <UserProvider>');
    return ctx;
};


const $ffae71f140f0c685$export$1d39dc5b47e56ff0 = ()=>{
    const { state: state, dispatch: dispatch } = (0, $4933e76bd0ca959e$export$7653fec709d1e7bb)();
    const { user: user } = (0, $f6c3dce408db50e2$export$87c54b525b914dab)();
    (0, $5FkrB.useEffect)(()=>{
        // User is pre-seeded into AppUpdatesContext via initialState in App.tsx,
        // but dispatch here as a safety net in case it wasn't available at init time.
        if (state.user || !user) return;
        dispatch({
            type: 'AUTHENTICATE',
            payload: {
                user: user
            }
        });
    }, [
        user,
        state.user,
        dispatch
    ]);
};




var $5FkrB = parcelRequire("5FkrB");

var $hiARP = parcelRequire("hiARP");
var $1a5e9ce6b94f06da$exports = {};
"use strict";
var $1a5e9ce6b94f06da$var$__createBinding = $1a5e9ce6b94f06da$exports && $1a5e9ce6b94f06da$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $1a5e9ce6b94f06da$var$__exportStar = $1a5e9ce6b94f06da$exports && $1a5e9ce6b94f06da$exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $1a5e9ce6b94f06da$var$__createBinding(exports1, m, p);
};
Object.defineProperty($1a5e9ce6b94f06da$exports, "__esModule", {
    value: true
});

$1a5e9ce6b94f06da$var$__exportStar((parcelRequire("c4Up0")), $1a5e9ce6b94f06da$exports);

$1a5e9ce6b94f06da$var$__exportStar((parcelRequire("fb6VX")), $1a5e9ce6b94f06da$exports);

$1a5e9ce6b94f06da$var$__exportStar((parcelRequire("jlxKU")), $1a5e9ce6b94f06da$exports);

$1a5e9ce6b94f06da$var$__exportStar((parcelRequire("glblS")), $1a5e9ce6b94f06da$exports);

$1a5e9ce6b94f06da$var$__exportStar((parcelRequire("hn1YZ")), $1a5e9ce6b94f06da$exports);



var $bDLqY = parcelRequire("bDLqY");



const $8efc6877f826f30c$var$FeatureGatesReadyContext = /*#__PURE__*/ (0, $5FkrB.createContext)(false);
function $8efc6877f826f30c$export$565f843eab5aeb55() {
    return (0, $5FkrB.useContext)($8efc6877f826f30c$var$FeatureGatesReadyContext);
}
const $8efc6877f826f30c$var$FEATURE_GATE_TARGET_APP = 'community-core_web';
function $8efc6877f826f30c$export$51d679bd9933520f() {
    const env = (0, $09e3b90497c94454$export$57570b1603cf6adb)();
    switch(env){
        case 'production':
            return (0, $hiARP.FeatureGateEnvironment).Production;
        case 'staging':
            return (0, $hiARP.FeatureGateEnvironment).Staging;
        case 'development':
        default:
            return (0, $hiARP.FeatureGateEnvironment).Development;
    }
}
function $8efc6877f826f30c$export$d9e6d91f1f7e3282({ children: children }) {
    const [isReady, setIsReady] = (0, $5FkrB.useState)(false);
    const { user: user, isSettled: isSettled } = (0, $f6c3dce408db50e2$export$87c54b525b914dab)();
    const identifiers = (0, $5FkrB.useMemo)(()=>({
            analyticsAnonymousId: (0, (/*@__PURE__*/$parcel$interopDefault($bDLqY))).get('ajs_anonymous_id'),
            atlassianAccountId: user?.account_id
        }), [
        user
    ]);
    // Don't mount FeatureGatesInitialization until the user fetch has settled.
    // Mounting it before the user is known causes a double-init that throws
    // "Client must be initialized before using this method" and makes checkGate()
    // return false, incorrectly triggering a redirect.
    if (!isSettled) return null;
    function handleReady(err) {
        if (err) (0, $9654b596cdf679bc$export$2e2bcd8739ae039).error(err, {
            extra: {
                message: '[FeatureGates] Initialization failed'
            }
        });
        // Mark gates as ready even on error so the app can proceed
        // (fg() returns false on error, which is the safe default)
        setIsReady(true);
    }
    return /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)($8efc6877f826f30c$var$FeatureGatesReadyContext.Provider, {
        value: isReady,
        children: /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $1a5e9ce6b94f06da$exports.FeatureGatesInitialization), {
            identifiers: identifiers,
            options: {
                apiKey: "41b0854a-40e8-4d53-944c-093616393a0f" ?? '',
                environment: $8efc6877f826f30c$export$51d679bd9933520f(),
                targetApp: $8efc6877f826f30c$var$FEATURE_GATE_TARGET_APP
            },
            onReady: handleReady,
            children: children
        })
    });
}


/**
 * React UFO (Unified Frontend Observability) performance monitoring setup.
 *
 * UFO tracks page load times and reports them as operational events via
 * the analytics web client. Interactions are tracked using @atlaskit/react-ufo:
 *   - traceUFOPageLoad() / traceUFOTransition() are called via useReactUFOWatcher (central, in App.tsx)
 *   - <UFOSegment> provides interaction context to child components
 *   - <UFOLoadHold> holds the interaction open while data is loading; removing
 *     the hold (hold={false}) automatically completes and sends the event.
 *
 * See: https://developer.atlassian.com/platform/ufo/
 */ 
var $iYJcE = parcelRequire("iYJcE");

var $fL8KA = parcelRequire("fL8KA");

var $6HG4S = parcelRequire("6HG4S");

var $9Zzpd = parcelRequire("9Zzpd");

var $6ohtU = parcelRequire("6ohtU");

var $DtLwq = parcelRequire("DtLwq");

var $eEwI0 = parcelRequire("eEwI0");

var $az8pZ = parcelRequire("az8pZ");

var $h9fNq = parcelRequire("h9fNq");

var $iGolp = parcelRequire("iGolp");

var $25nEq = parcelRequire("25nEq");

var $iGolp = parcelRequire("iGolp");
var $46766faed9eb6bde$var$nameCache = new WeakMap();
function $46766faed9eb6bde$var$getAttributeSelector(element, attributeName) {
    var attrValue = element.getAttribute(attributeName);
    if (!attrValue) return '';
    return "[".concat(attributeName, "=\"").concat(attrValue, "\"]");
}
function $46766faed9eb6bde$var$isValidSelector(selector) {
    try {
        document.querySelector(selector);
        return true;
    } catch (err) {
        return false;
    }
}
function $46766faed9eb6bde$var$isSelectorUnique(selector) {
    return document.querySelectorAll(selector).length === 1;
}
function $46766faed9eb6bde$var$getUniqueSelector(selectorConfig, element) {
    var currentElement = element;
    var parts = [];
    var MAX_DEPTH = 3;
    var currentDepth = 0;
    while(currentElement && currentElement.localName !== 'body' && currentDepth <= MAX_DEPTH){
        var tagName = currentElement.localName;
        var selectorPart = tagName;
        if (selectorConfig.id && currentElement.id && $46766faed9eb6bde$var$isValidSelector("#".concat(currentElement.id))) selectorPart += "#".concat(currentElement.id);
        else if (selectorConfig.dataVC) selectorPart += $46766faed9eb6bde$var$getAttributeSelector(currentElement, 'data-vc');
        else if (selectorConfig.testId) selectorPart += $46766faed9eb6bde$var$getAttributeSelector(currentElement, 'data-testid') || $46766faed9eb6bde$var$getAttributeSelector(currentElement, 'data-test-id');
        else if (selectorConfig.role) selectorPart += $46766faed9eb6bde$var$getAttributeSelector(currentElement, 'role');
        else if (selectorConfig.className && currentElement.className) {
            var classNames = Array.from(currentElement.classList).join('.');
            if (classNames) {
                if ($46766faed9eb6bde$var$isValidSelector(".".concat(classNames))) selectorPart += ".".concat(classNames);
            }
        }
        parts.unshift(selectorPart);
        var _potentialSelector = parts.join(' > ').trim();
        if (_potentialSelector && $46766faed9eb6bde$var$isSelectorUnique(_potentialSelector)) return _potentialSelector;
        currentElement = currentElement.parentElement;
        currentDepth++;
    }
    var potentialSelector = parts.join(' > ').trim();
    if (!potentialSelector) return 'unknown';
    else if (!$46766faed9eb6bde$var$isSelectorUnique(potentialSelector)) {
        var parentElement = element.parentElement;
        if (parentElement) return "".concat(potentialSelector, ":nth-child"); // NOTE: invalid DOM selector, but enough information for VC
    }
    return potentialSelector;
}
function $46766faed9eb6bde$var$getElementName(selectorConfig, element) {
    if (!(element instanceof HTMLElement)) return 'error';
    var cachedName = $46766faed9eb6bde$var$nameCache.get(element);
    if (cachedName) return cachedName;
    var uniqueSelector = $46766faed9eb6bde$var$getUniqueSelector(selectorConfig, element);
    $46766faed9eb6bde$var$nameCache.set(element, uniqueSelector);
    return uniqueSelector;
}
var $46766faed9eb6bde$export$2e2bcd8739ae039 = $46766faed9eb6bde$var$getElementName;


function $e5fa92dd0c98cbb4$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $e5fa92dd0c98cbb4$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $e5fa92dd0c98cbb4$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25nEq)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $e5fa92dd0c98cbb4$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $e5fa92dd0c98cbb4$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $e5fa92dd0c98cbb4$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $e5fa92dd0c98cbb4$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $e5fa92dd0c98cbb4$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $e5fa92dd0c98cbb4$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $e5fa92dd0c98cbb4$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
var $e5fa92dd0c98cbb4$var$performanceEventObserver;
var $e5fa92dd0c98cbb4$var$selectorConfig = {
    id: true,
    testId: true,
    role: true,
    className: true
};
function $e5fa92dd0c98cbb4$var$getTestIdName(memoizedProps) {
    if (memoizedProps['data-testid']) return "[data-testid=".concat(memoizedProps['data-testid'], "]");
    else if (memoizedProps['data-test-id']) return "[data-test-id=".concat(memoizedProps['data-testid'], "]");
    else if (memoizedProps['data-vc']) return "[data-vc=".concat(memoizedProps['data-vc'], "]");
    return null;
}
function $e5fa92dd0c98cbb4$var$getUFOSegmentName(componentName, memoizedProps) {
    if (memoizedProps && memoizedProps['name']) return "UFOSegment[name=".concat(memoizedProps['name'], "]");
    return componentName;
}
function $e5fa92dd0c98cbb4$var$getReactComponentHierarchy(element) {
    var componentHierarchy = [];
    // Function to traverse up the fiber tree
    function traverseFiber(fiber) {
        var currentFiber = fiber;
        while(currentFiber){
            if (currentFiber.type) {
                // Check if there's a display name or a function name
                var componentName = currentFiber.type.displayName || currentFiber.type.name;
                // checking when component name is bigger than the minimized name produced by react
                if (componentName && componentName.length > 2 && !componentName.includes('Listener') && !componentName.includes('Provider')) {
                    if (componentName === 'UFOSegment') {
                        componentHierarchy.push($e5fa92dd0c98cbb4$var$getUFOSegmentName(componentName, currentFiber.memoizedProps));
                        break;
                    }
                    componentHierarchy.push(componentName);
                }
            }
            if (currentFiber.memoizedProps) {
                var dataIdInfo = $e5fa92dd0c98cbb4$var$getTestIdName(currentFiber.memoizedProps);
                if (dataIdInfo) {
                    componentHierarchy.push(dataIdInfo);
                    currentFiber = null;
                    continue;
                }
            }
            currentFiber = currentFiber.return;
        }
    }
    // Access the reactFiber node from the HTML element
    var reactFiberKey = Object.keys(element).find(function(key) {
        return key.startsWith('__reactFiber$');
    });
    if (reactFiberKey) {
        var fiber = element[reactFiberKey];
        traverseFiber(fiber);
    }
    return componentHierarchy.reverse().join(' > ');
}
var $e5fa92dd0c98cbb4$export$17afbba0f16b4b19 = function getPerformanceObserver() {
    $e5fa92dd0c98cbb4$var$performanceEventObserver = $e5fa92dd0c98cbb4$var$performanceEventObserver || new PerformanceObserver(function(entries) {
        var list = entries.getEntries();
        var _iterator = $e5fa92dd0c98cbb4$var$_createForOfIteratorHelper(list), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var entry = _step.value;
                if (entry.name === 'click') $e5fa92dd0c98cbb4$export$e6be05b411ce21a6(entry);
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
    });
    return $e5fa92dd0c98cbb4$var$performanceEventObserver;
};
var $e5fa92dd0c98cbb4$export$e6be05b411ce21a6 = function setInteractionPerformanceEvent(entry) {
    var interaction = (0, $iGolp.getActiveInteraction)();
    if ((interaction === null || interaction === void 0 ? void 0 : interaction.type) === 'press') {
        var _interaction$responsi;
        if (!((_interaction$responsi = interaction.responsiveness) !== null && _interaction$responsi !== void 0 && _interaction$responsi.experimentalInputToNextPaint)) {
            var _interaction$responsi2, _interaction$responsi3;
            interaction.responsiveness = $e5fa92dd0c98cbb4$var$_objectSpread($e5fa92dd0c98cbb4$var$_objectSpread({}, interaction.responsiveness), {}, {
                experimentalInputToNextPaint: ((_interaction$responsi2 = interaction.responsiveness) === null || _interaction$responsi2 === void 0 ? void 0 : _interaction$responsi2.experimentalInputToNextPaint) || entry.duration,
                inputDelay: ((_interaction$responsi3 = interaction.responsiveness) === null || _interaction$responsi3 === void 0 ? void 0 : _interaction$responsi3.inputDelay) || entry.processingStart - entry.startTime
            });
            if (interaction.ufoName === 'unknown') {
                if (entry.target) {
                    var componentHierarchy = $e5fa92dd0c98cbb4$var$getReactComponentHierarchy(entry.target);
                    interaction.unknownElementHierarchy = componentHierarchy;
                }
                interaction.unknownElementName = (0, $46766faed9eb6bde$export$2e2bcd8739ae039)($e5fa92dd0c98cbb4$var$selectorConfig, entry.target);
            }
        }
    }
};



var $1gQdg = parcelRequire("1gQdg");

var $3hvsM = parcelRequire("3hvsM");

var $9Zzpd = parcelRequire("9Zzpd");
function $20510629fa7f7e26$var$scheduleIdleCallback(work) {
    if (typeof window !== 'undefined' && typeof window.requestIdleCallback === 'function' && (0, $9Zzpd.fg)('ufo_payload_use_idle_callback')) window.requestIdleCallback(work);
    else (0, $3hvsM.unstable_scheduleCallback)((0, $3hvsM.unstable_IdlePriority), work);
}
var $20510629fa7f7e26$export$2e2bcd8739ae039 = $20510629fa7f7e26$var$scheduleIdleCallback;


var $b5d959f5f0c4d4a3$var$initialized = false;
function $b5d959f5f0c4d4a3$var$sinkInteraction(instance, payloadPackage) {
    function sinkFn(interactionId, interaction) {
        function onIdle() {
            payloadPackage.createPayloads(interactionId, interaction).then(function(payloads) {
                // NOTE: This API is used by the UFO DevTool Chrome Extension and Criterion
                var devToolObserver = globalThis.__ufo_devtool_onUfoPayload;
                payloads === null || payloads === void 0 || payloads.forEach(function(payload) {
                    if (typeof devToolObserver === 'function') devToolObserver === null || devToolObserver === void 0 || devToolObserver(payload);
                    instance.sendOperationalEvent(payload);
                });
            }).catch(function(error) {
                throw error;
            });
        }
        (0, $20510629fa7f7e26$export$2e2bcd8739ae039)(onIdle);
    }
    (0, $iGolp.sinkInteractionHandler)(sinkFn);
}
function $b5d959f5f0c4d4a3$var$sinkExperimentalInteractionMetrics(instance, payloadPackage) {
    function experimentalMetricsSinkFn(interactionId, interaction) {
        function experimentalMetricsOnIdle() {
            var payloadPromise = payloadPackage.createExperimentalMetricsPayload(interactionId, interaction);
            payloadPromise.then(function(payload) {
                if (payload) {
                    if ((0, $9Zzpd.fg)('enable_ufo_devtools_api_for_extra_events')) {
                        // NOTE: This API is used by the UFO DevTool Chrome Extension and Criterion
                        var devToolObserver = globalThis.__ufo_devtool_onUfoPayload;
                        if (typeof devToolObserver === 'function') devToolObserver === null || devToolObserver === void 0 || devToolObserver(payload);
                    }
                    instance.sendOperationalEvent(payload);
                }
            });
        }
        (0, $20510629fa7f7e26$export$2e2bcd8739ae039)(experimentalMetricsOnIdle);
    }
    (0, $eEwI0.sinkExperimentalHandler)(experimentalMetricsSinkFn);
}
function $b5d959f5f0c4d4a3$var$sinkPostInteractionLog(instance, createPostInteractionLogPayload) {
    (0, $iGolp.sinkPostInteractionLogHandler)(function(logOutput) {
        (0, $20510629fa7f7e26$export$2e2bcd8739ae039)(function() {
            var payload = createPostInteractionLogPayload(logOutput);
            if (payload) {
                // NOTE: This API is used by the UFO DevTool Chrome Extension and also by Criterion
                if ((0, $9Zzpd.fg)('enable_ufo_devtools_api_for_extra_events')) {
                    var devToolObserver = globalThis.__ufo_devtool_onUfoPayload;
                    if (typeof devToolObserver === 'function') devToolObserver === null || devToolObserver === void 0 || devToolObserver(payload);
                }
                instance.sendOperationalEvent(payload);
            }
        });
    });
}
function $b5d959f5f0c4d4a3$var$sinkInteractionExtraMetrics(instance, createInteractionExtraLogPayload) {
    (0, $iGolp.interactionExtraMetrics).sinkHandler(function(interactionId, interaction, lastInteractionFinish, lastInteractionFinishVCResult) {
        (0, $20510629fa7f7e26$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fL8KA)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).mark(function _callee() {
            var payload, devToolObserver;
            return (0, (/*@__PURE__*/$parcel$interopDefault($6HG4S))).wrap(function _callee$(_context) {
                while(true)switch(_context.prev = _context.next){
                    case 0:
                        _context.next = 2;
                        return createInteractionExtraLogPayload(interactionId, interaction, lastInteractionFinish, lastInteractionFinishVCResult);
                    case 2:
                        payload = _context.sent;
                        if (payload) {
                            // NOTE: This API is used by the UFO DevTool Chrome Extension and also by Criterion
                            if ((0, $9Zzpd.fg)('enable_ufo_devtools_api_for_extra_events')) {
                                devToolObserver = globalThis.__ufo_devtool_onUfoPayload;
                                if (typeof devToolObserver === 'function') devToolObserver === null || devToolObserver === void 0 || devToolObserver(payload);
                            }
                            instance.sendOperationalEvent(payload);
                        }
                    case 4:
                    case "end":
                        return _context.stop();
                }
            }, _callee);
        })));
    });
}
function $b5d959f5f0c4d4a3$var$sinkExtraSearchPageInteraction(instance, payloadPackage) {
    function sinkFn(interactionId, interaction) {
        function onIdle() {
            payloadPackage.createExtraSearchPageInteractionPayload(interactionId, interaction).then(function(payloads) {
                // NOTE: This API is used by the UFO DevTool Chrome Extension and Criterion
                var devToolObserver = globalThis.__ufo_devtool_onUfoPayload;
                payloads === null || payloads === void 0 || payloads.forEach(function(payload) {
                    if (typeof devToolObserver === 'function') devToolObserver === null || devToolObserver === void 0 || devToolObserver(payload);
                    instance.sendOperationalEvent(payload);
                });
            }).catch(function(error) {
                throw error;
            });
        }
        (0, $20510629fa7f7e26$export$2e2bcd8739ae039)(onIdle);
    }
    (0, $az8pZ.sinkExtraSearchPageInteractionHandler)(sinkFn);
}



function $b5d959f5f0c4d4a3$export$2cd8252107eb640b(analyticsWebClientAsync, config) {
    var _config$vc;
    if ($b5d959f5f0c4d4a3$var$initialized) return;
    // Initialize pressure observer for CPU usage monitoring
    (0, $1gQdg.initialisePressureObserver)();
    (0, $1gQdg.initialiseMemoryObserver)();
    (0, $DtLwq.setUFOConfig)(config);
    if ((_config$vc = config.vc) !== null && _config$vc !== void 0 && _config$vc.enabled) {
        var _config$experimentalI, _config$extraInteract;
        var vcOptions = {
            heatmapSize: config.vc.heatmapSize,
            oldDomUpdates: config.vc.oldDomUpdates,
            devToolsEnabled: config.vc.devToolsEnabled,
            selectorConfig: config.vc.selectorConfig,
            ssrEnablePageLayoutPlaceholder: config.vc.ssrEnablePageLayoutPlaceholder
        };
        (0, $iGolp.postInteractionLog).initializeVCObserver(vcOptions);
        if (config !== null && config !== void 0 && (_config$experimentalI = config.experimentalInteractionMetrics) !== null && _config$experimentalI !== void 0 && _config$experimentalI.enabled) (0, $eEwI0.experimentalVC).initialize(vcOptions).start({
            startTime: 0
        });
        if (config !== null && config !== void 0 && (_config$extraInteract = config.extraInteractionMetrics) !== null && _config$extraInteract !== void 0 && _config$extraInteract.enabled) (0, $iGolp.interactionExtraMetrics).initializeVCObserver(vcOptions);
    }
    (0, $h9fNq.setupHiddenTimingCapture)();
    (0, $6ohtU.startLighthouseObserver)();
    $b5d959f5f0c4d4a3$var$initialized = true;
    if (typeof PerformanceObserver !== 'undefined') {
        var observer = (0, $e5fa92dd0c98cbb4$export$17afbba0f16b4b19)();
        observer.observe({
            type: 'event',
            buffered: true,
            durationThreshold: 16
        });
    }
    Promise.all([
        analyticsWebClientAsync,
        (parcelRequire("LUkQI")),
        (parcelRequire("gyFaN")),
        (parcelRequire("7nmeJ"))
    ]).then(function(_ref2) {
        var _ref3 = (0, (/*@__PURE__*/$parcel$interopDefault($iYJcE)))(_ref2, 4), awc = _ref3[0], payloadPackage = _ref3[1], createPostInteractionLogPayloadPackage = _ref3[2], createInteractionExtraMetricsPayloadPackage = _ref3[3];
        if (awc.getAnalyticsWebClientPromise) awc.getAnalyticsWebClientPromise().then(function(client) {
            var _config$experimentalI2, _config$postInteracti, _config$extraInteract2, _config$extraSearchPa;
            var instance = client.getInstance();
            $b5d959f5f0c4d4a3$var$sinkInteraction(instance, payloadPackage);
            if (config !== null && config !== void 0 && (_config$experimentalI2 = config.experimentalInteractionMetrics) !== null && _config$experimentalI2 !== void 0 && _config$experimentalI2.enabled) $b5d959f5f0c4d4a3$var$sinkExperimentalInteractionMetrics(instance, payloadPackage);
            if ((_config$postInteracti = config.postInteractionLog) !== null && _config$postInteracti !== void 0 && _config$postInteracti.enabled) $b5d959f5f0c4d4a3$var$sinkPostInteractionLog(instance, createPostInteractionLogPayloadPackage.default);
            if (config !== null && config !== void 0 && (_config$extraInteract2 = config.extraInteractionMetrics) !== null && _config$extraInteract2 !== void 0 && _config$extraInteract2.enabled && (0, $9Zzpd.fg)('platform_ufo_enable_ttai_with_3p')) $b5d959f5f0c4d4a3$var$sinkInteractionExtraMetrics(instance, createInteractionExtraMetricsPayloadPackage.default);
            if (config !== null && config !== void 0 && (_config$extraSearchPa = config.extraSearchPageInteraction) !== null && _config$extraSearchPa !== void 0 && _config$extraSearchPa.enabled) $b5d959f5f0c4d4a3$var$sinkExtraSearchPageInteraction(instance, payloadPackage);
        });
        else if (awc.sendOperationalEvent) {
            var _config$experimentalI3, _config$postInteracti2, _config$extraInteract3, _config$extraSearchPa2;
            $b5d959f5f0c4d4a3$var$sinkInteraction(awc, payloadPackage);
            if (config !== null && config !== void 0 && (_config$experimentalI3 = config.experimentalInteractionMetrics) !== null && _config$experimentalI3 !== void 0 && _config$experimentalI3.enabled) $b5d959f5f0c4d4a3$var$sinkExperimentalInteractionMetrics(awc, payloadPackage);
            if ((_config$postInteracti2 = config.postInteractionLog) !== null && _config$postInteracti2 !== void 0 && _config$postInteracti2.enabled) $b5d959f5f0c4d4a3$var$sinkPostInteractionLog(awc, createPostInteractionLogPayloadPackage.default);
            if (config !== null && config !== void 0 && (_config$extraInteract3 = config.extraInteractionMetrics) !== null && _config$extraInteract3 !== void 0 && _config$extraInteract3.enabled && (0, $9Zzpd.fg)('platform_ufo_enable_ttai_with_3p')) $b5d959f5f0c4d4a3$var$sinkInteractionExtraMetrics(awc, createInteractionExtraMetricsPayloadPackage.default);
            if (config !== null && config !== void 0 && (_config$extraSearchPa2 = config.extraSearchPageInteraction) !== null && _config$extraSearchPa2 !== void 0 && _config$extraSearchPa2.enabled) $b5d959f5f0c4d4a3$var$sinkExtraSearchPageInteraction(awc, payloadPackage);
        }
    });
}



const $41268bd829e2a570$export$af995ee1d7017fea = ()=>{
    const analyticsClientPromise = Promise.resolve({
        getAnalyticsWebClientPromise: ()=>Promise.resolve({
                getInstance: ()=>(0, $45964660615f0a60$export$e9ba7ef9458d1a4a)()
            })
    });
    (0, $b5d959f5f0c4d4a3$export$2cd8252107eb640b)(analyticsClientPromise, {
        // 'learning' is the registered UFO product name for the community platform
        // that hosts App Updates. Glance experience IDs will be:
        //   learning.fe.page-load.ufo-app-updates
        //   learning.fe.page-load.ufo-app-updates-details
        product: 'learning',
        // region is the geographic deployment region (not environment).
        // Defaults to 'us-east-1' — the primary Atlassian region.
        region: undefined ?? 'us-east-1',
        vc: {
            enabled: true,
            heatmapSize: 200,
            oldDomUpdates: false,
            devToolsEnabled: true,
            enabledVCRevisions: {
                all: [
                    'fy25.02',
                    'fy25.03'
                ]
            },
            // Account for possible UGC/PII in DOM attributes:
            // id: false — element IDs may contain user-generated content (e.g. update IDs)
            selectorConfig: {
                id: false,
                role: true,
                className: true,
                testId: true
            }
        },
        // Prefix aligns experience keys with the platform naming convention
        // used by Performance Portal (e.g. 'ufo-app-updates').
        namePrefix: 'ufo-',
        // Only track page_load, transition and press interactions.
        kind: {
            page_load: 1,
            transition: 1,
            hover: 0,
            legacy: 0,
            typing: 0,
            press: 1
        }
    });
};


var $5FkrB = parcelRequire("5FkrB");
// eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead

var $6JfQX = parcelRequire("6JfQX");

var $4iVTn = parcelRequire("4iVTn");

var $DtLwq = parcelRequire("DtLwq");

var $6K0Mp = parcelRequire("6K0Mp");

var $gITbN = parcelRequire("gITbN");

var $iGolp = parcelRequire("iGolp");

var $6SIfU = parcelRequire("6SIfU");
var $f66e8cd8df206c10$var$AWAITING_PAGELOAD_NAME = 'awaiting_pageload_name';
function $f66e8cd8df206c10$var$traceUFOPageLoad(ufoName) {
    var routeName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ufoName;
    var activeInteraction = (0, $iGolp.getActiveInteraction)();
    if (activeInteraction && !ufoName) return;
    (0, $6SIfU.default).current = routeName || null;
    var rate = ufoName ? (0, $DtLwq.getInteractionRate)(ufoName, 'page_load') : 1;
    var enabledBySamplingRate = (0, $4iVTn.default)(rate);
    if (enabledBySamplingRate && !activeInteraction) {
        // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
        var newId = (0, $6JfQX.default)();
        (0, $gITbN.DefaultInteractionID).current = newId;
        (0, $iGolp.addNewInteraction)(newId, ufoName || '', 'page_load', 0, rate, null, routeName, (0, $6K0Mp.getActiveTrace)());
        if (!ufoName) // if no name is provided we add a hold to the interaction, it is removed if the name is provided while the interaction is holding
        (0, $iGolp.addHoldByID)(newId, [], $f66e8cd8df206c10$var$AWAITING_PAGELOAD_NAME, $f66e8cd8df206c10$var$AWAITING_PAGELOAD_NAME, true);
    } else if (!enabledBySamplingRate && activeInteraction && activeInteraction.type === 'page_load') // if there is an active interaction it will be aborted without initialising a new one because the coinflip returned false
    (0, $iGolp.abort)(activeInteraction.id, 'excluded_by_sampling');
    else if (ufoName && activeInteraction && !activeInteraction.ufoName && activeInteraction.type === 'page_load') {
        (0, $iGolp.updatePageLoadInteractionName)(ufoName, routeName);
        (0, $iGolp.removeHoldByID)(activeInteraction.id, $f66e8cd8df206c10$var$AWAITING_PAGELOAD_NAME);
    }
}
var $f66e8cd8df206c10$export$2e2bcd8739ae039 = $f66e8cd8df206c10$var$traceUFOPageLoad;
function $f66e8cd8df206c10$export$d0f99433cd4f4028(ufoName) {
    var routeName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ufoName;
    var interaction = (0, $iGolp.getActiveInteraction)();
    if (!interaction || interaction.type !== 'page_load' && interaction.type !== 'transition') return;
    if (ufoName) {
        var rate = (0, $DtLwq.getInteractionRate)(ufoName, 'page_load');
        (0, $iGolp.updatePageLoadInteractionName)(ufoName, routeName);
        if ((0, $4iVTn.default)(rate)) (0, $6SIfU.default).current = ufoName;
        else (0, $iGolp.abort)(interaction.id, 'excluded_by_sampling');
    }
    (0, $iGolp.removeHoldByID)(interaction.id, $f66e8cd8df206c10$var$AWAITING_PAGELOAD_NAME);
}



var $5FkrB = parcelRequire("5FkrB");

var $6JfQX = parcelRequire("6JfQX");

var $4iVTn = parcelRequire("4iVTn");

var $DtLwq = parcelRequire("DtLwq");

var $6K0Mp = parcelRequire("6K0Mp");

var $gITbN = parcelRequire("gITbN");

var $iGolp = parcelRequire("iGolp");

var $6SIfU = parcelRequire("6SIfU");

var $6K0Mp = parcelRequire("6K0Mp");
function $19b4a06296635e75$export$295213bc4d0c54ad() {
    return Array.from(new Array(16), function() {
        return Math.floor(Math.random() * 16).toString(16);
    }).join('');
}


function $35cd9ec52fa2080b$export$f2e521e495a88544(newId) {
    (0, $6K0Mp.setActiveTrace)(newId.replace(/-/g, ''), (0, $19b4a06296635e75$export$295213bc4d0c54ad)(), 'transition');
}


function $ac2d8686bb191ca9$var$traceUFOTransition(ufoName) {
    var routeName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ufoName;
    var pressInteractionsList = (0, $DtLwq.getDoNotAbortActivePressInteractionOnTransition)();
    var interaction = (0, $iGolp.getActiveInteraction)();
    if (pressInteractionsList && interaction) {
        if (pressInteractionsList.includes(interaction.ufoName)) return;
    }
    (0, $iGolp.abortAll)('transition', ufoName !== null && ufoName !== void 0 ? ufoName : undefined);
    if (ufoName) {
        (0, $6SIfU.default).current = ufoName;
        var rate = (0, $DtLwq.getInteractionRate)(ufoName, 'transition');
        if ((0, $4iVTn.default)(rate)) {
            // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
            var newId = (0, $6JfQX.default)();
            (0, $35cd9ec52fa2080b$export$f2e521e495a88544)(newId);
            (0, $gITbN.DefaultInteractionID).current = newId;
            (0, $iGolp.addNewInteraction)(newId, ufoName, 'transition', performance.now(), rate, null, routeName, (0, $6K0Mp.getActiveTrace)());
        }
    }
}
function $ac2d8686bb191ca9$export$369f0ded13ce6c50() {
    var interactionId = (0, $5FkrB.useContext)((0, $gITbN.default));
    var capturedInteractionId = interactionId.current;
    (0, $5FkrB.useEffect)(function() {
        // If we have a current interaction set...
        if (capturedInteractionId != null) {
            var cancel = requestAnimationFrame(function() {
                cancel = requestAnimationFrame(function() {
                    if (capturedInteractionId === interactionId.current) (0, $iGolp.tryComplete)(capturedInteractionId);
                });
            });
            (0, $iGolp.addOnCancelCallback)(capturedInteractionId, function() {
                cancelAnimationFrame(cancel);
            });
        }
    }, [
        capturedInteractionId,
        interactionId
    ]);
}
var $ac2d8686bb191ca9$export$2e2bcd8739ae039 = $ac2d8686bb191ca9$var$traceUFOTransition;



var $iGolp = parcelRequire("iGolp");


const $53db48ba8bac8e3a$export$c1a838a491a42b2 = (routeContext)=>{
    const { analyticsOptOut: analyticsOptOut } = (0, $38056d680fac42ff$export$b224af886b957a5e)();
    (0, $5FkrB.useEffect)(()=>{
        if (analyticsOptOut || !routeContext.route) return;
        const experienceName = routeContext.route.name.toLowerCase();
        // Decide from UFO's live state, not routeContext.action.
        const activeInteraction = (0, $iGolp.getActiveInteraction)();
        let decision;
        if (!activeInteraction) {
            decision = 'page_load';
            (0, $f66e8cd8df206c10$export$2e2bcd8739ae039)(experienceName);
        } else {
            decision = 'transition';
            (0, $ac2d8686bb191ca9$export$2e2bcd8739ae039)(experienceName);
        }
        // TEMPORARY DEBUG: breadcrumb what we reported vs. the actual navigation
        // target so we can confirm behaviour in prod. Remove once verified.
        // eslint-disable-next-line no-restricted-syntax
        (0, $033860fe7bfd25af$exports).addBreadcrumb({
            category: 'ufo-watcher',
            level: 'info',
            message: `ufo-watcher: ${decision} -> ${experienceName}`,
            data: {
                experienceName: experienceName,
                decision: decision,
                locationPathname: routeContext.location?.pathname ?? null,
                matchedRoutePath: routeContext.route?.path ?? null,
                routeName: routeContext.route?.name ?? null,
                routerAction: routeContext.action,
                activeInteractionType: activeInteraction?.type ?? null,
                activeInteractionName: activeInteraction?.ufoName ?? null
            }
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        routeContext.route,
        routeContext.action,
        analyticsOptOut
    ]);
};



var $5FkrB = parcelRequire("5FkrB");


const $93ef5b82f3a99b71$export$f1f8325c2f4f8721 = ()=>{
    const { analyticsOptOut: analyticsOptOut } = (0, $38056d680fac42ff$export$b224af886b957a5e)();
    (0, $5FkrB.useEffect)(()=>{
        if (analyticsOptOut) return;
        (0, $15b90d5900f709a5$export$504fbc0ef5c94afa)();
    }, [
        analyticsOptOut
    ]);
};


// Initialize Sentry for error tracking
(0, $9654b596cdf679bc$export$f5ae3c4820871661)();
// Initialize UFO performance monitoring
(0, $41268bd829e2a570$export$af995ee1d7017fea)();
// Release tracks routes must precede the dynamic ':id' route so they aren't
// matched as release note ids.
const $6c337d21896291b4$var$appRoutes = [
    (0, $822a62c8758b6be8$export$352552ab999c9092),
    (0, $822a62c8758b6be8$export$3ad0ba51c296adcf),
    (0, $822a62c8758b6be8$export$77c38a6734b02710),
    (0, $822a62c8758b6be8$export$527547b9491d1b85)
];
// TODO: keeping for now, will remove once OneTrust is done
// console.log(process.env.REACT_APP_ONETRUST_SCRIPT_DOMAIN);
const $6c337d21896291b4$var$fullHeightStyles = (0, $c1bec583fa49072f$export$f6c783d06584602c)({
    height: '100vh'
});
const $6c337d21896291b4$var$mainStyles = (0, $c1bec583fa49072f$export$f6c783d06584602c)({
    display: 'flex',
    flexDirection: 'column',
    // @ts-ignore - need to fix styles
    gap: '112px',
    margin: '0 auto',
    width: '1232px',
    '@media (max-width: 1279px)': {
        gap: '72px',
        width: '100%',
        paddingInline: 'space.300'
    },
    '@media (max-width: 767px)': {
        gap: '64px',
        width: '100%',
        paddingInline: 'space.200'
    }
});
const $6c337d21896291b4$var$AppContents = ()=>{
    (0, $ffae71f140f0c685$export$1d39dc5b47e56ff0)();
    const { state: state } = (0, $4933e76bd0ca959e$export$7653fec709d1e7bb)();
    const [routerState] = (0, $b421c015f5018cd0$export$9a302a45f65d0572)();
    // Trigger a one-time, self-throttled prune of the unread read set on app load.
    (0, $93ef5b82f3a99b71$export$f1f8325c2f4f8721)();
    // Central UFO watcher — tracks page-load on initial load and transitions on
    // subsequent route changes. Called here (inside <Router>) so useRouter() works.
    // Individual pages should use <UFOSegment> and <UFOLoadHold> only.
    (0, $53db48ba8bac8e3a$export$c1a838a491a42b2)(routerState);
    const { isLoggedIn: isLoggedIn, loggedInUser: loggedInUser } = state;
    return /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsxs)((0, $faf30355a80342e4$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $12fc361ebcaf5b04$export$3151da8f6716d1a2), {
                isLoggedIn: isLoggedIn,
                loggedInUser: loggedInUser
            }),
            /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)("div", {
                id: "core-root",
                children: /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $0b354a69a2959049$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $383dd904a5a5e5b0$export$2e2bcd8739ae039), {
                        xcss: $6c337d21896291b4$var$mainStyles,
                        children: /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $56c1ff970910c658$export$7903e4b73fc7d6c3), {})
                    })
                })
            }),
            /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)("footer", {
                children: /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $6cf738ba21080f36$export$a06f1c675e846f6f), {
                    isLoggedIn: isLoggedIn,
                    loggedInUser: loggedInUser
                })
            })
        ]
    });
};
const $6c337d21896291b4$export$86fbec116b87613f = ()=>{
    const history = (0, $5FkrB.useMemo)(()=>(0, $c29d101a2cf08ade$export$719fc203c4e16dee)(), []);
    const isFeatureGatesReady = (0, $8efc6877f826f30c$export$565f843eab5aeb55)();
    const { user: user } = (0, $f6c3dce408db50e2$export$87c54b525b914dab)();
    // Wait for Statsig to finish initializing before evaluating gates.
    // Without this guard, checkGate() returns false during async init,
    // which would incorrectly redirect users away from /release-notes.
    if (!isFeatureGatesReady) return /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $1b254ba6a068f2f1$export$2e2bcd8739ae039), {
        justifyContent: "center",
        alignItems: "center",
        xcss: $6c337d21896291b4$var$fullHeightStyles,
        children: /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $9ztDu.default), {
            size: "large",
            interactionName: "feature-gates-initializing"
        })
    });
    return /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $2DGGf.default), {
        locale: (0, $9bc4aff2ff299440$export$d7f512c98c859244),
        messages: (0, (/*@__PURE__*/$parcel$interopDefault($eeccb061c66729e2$exports))),
        children: /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $4933e76bd0ca959e$export$5d107a7783183624), {
            api: (0, $20b06ac8b5e61eaa$export$644d8ea042df96a6),
            initialState: {
                user: user
            },
            children: /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $a0fe68b284b4365c$export$45604f0cc8ae667b), {
                client: (0, $20b06ac8b5e61eaa$export$7c07b633a151f9c5),
                children: /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $ddc1dbf2b1f7581e$export$55185c17a0fcbe46), {
                    routes: $6c337d21896291b4$var$appRoutes,
                    history: history,
                    children: /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)($6c337d21896291b4$var$AppContents, {})
                })
            })
        })
    });
};









const $c4c47b0e78c26f17$var$THEME_CONFIG = {
    colorMode: 'light',
    light: 'light',
    dark: 'dark',
    spacing: 'spacing'
};
// Load and inject theme styles
(0, $9e4e6a70439714f4$export$2e2bcd8739ae039)($c4c47b0e78c26f17$var$THEME_CONFIG).then((themeStyles)=>{
    themeStyles.forEach(({ css: css, attrs: attrs })=>{
        const style = document.createElement('style');
        style.textContent = css;
        Object.entries(attrs).forEach(([key, value])=>{
            style.setAttribute(key, value);
        });
        document.head.appendChild(style);
    });
});
// Initialize global theme for runtime theme switching
(0, $f17f0f6b501ed4b1$export$2e2bcd8739ae039)($c4c47b0e78c26f17$var$THEME_CONFIG);
const $c4c47b0e78c26f17$var$container = document.getElementById('root');
if ($c4c47b0e78c26f17$var$container) {
    const root = (0, $94347cf79186e453$export$882461b6382ed46c)($c4c47b0e78c26f17$var$container);
    root.render(/*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $38056d680fac42ff$export$52310512b1bd7aec), {
        children: /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $8c48fdd8d5a3abf9$export$4719288a8f5f7e71), {
            children: /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $f6c3dce408db50e2$export$88f24fd8fcfab6ca), {
                api: (0, $20b06ac8b5e61eaa$export$644d8ea042df96a6),
                children: /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $8efc6877f826f30c$export$d9e6d91f1f7e3282), {
                    children: /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $6c337d21896291b4$export$86fbec116b87613f), {})
                })
            })
        })
    }));
}


//# sourceMappingURL=index.c58c2579.js.map
